/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 585);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(622);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(634)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutProperties;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__ = __webpack_require__(112);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = Object(__WEBPACK_IMPORTED_MODULE_0__objectWithoutPropertiesLoose__["a" /* default */])(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toVal(mix) {
	var k, y, str='';
	if (mix) {
		if (typeof mix === 'object') {
			if (!!mix.push) {
				for (k=0; k < mix.length; k++) {
					if (mix[k] && (y = toVal(mix[k]))) {
						str && (str += ' ');
						str += y;
					}
				}
			} else {
				for (k in mix) {
					if (mix[k] && (y = toVal(k))) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else if (typeof mix !== 'boolean' && !mix.call) {
			str && (str += ' ');
			str += mix;
		}
	}
	return str;
}

/* harmony default export */ __webpack_exports__["a"] = (function () {
	var i=0, x, str='';
	while (i < arguments.length) {
		if (x = toVal(arguments[i++])) {
			str && (str += ' ');
			str += x
		}
	}
	return str;
});


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(135);




function withStyles(stylesOrCreator, options) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["h" /* withStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __webpack_require__(457);
exports.assert = assert_1.assert;
exports.assertionError = assert_1.assertionError;
var crypt_1 = __webpack_require__(458);
exports.base64 = crypt_1.base64;
exports.base64Decode = crypt_1.base64Decode;
exports.base64Encode = crypt_1.base64Encode;
var constants_1 = __webpack_require__(267);
exports.CONSTANTS = constants_1.CONSTANTS;
var deepCopy_1 = __webpack_require__(1182);
exports.deepCopy = deepCopy_1.deepCopy;
exports.deepExtend = deepCopy_1.deepExtend;
exports.patchProperty = deepCopy_1.patchProperty;
var deferred_1 = __webpack_require__(1183);
exports.Deferred = deferred_1.Deferred;
var environment_1 = __webpack_require__(1184);
exports.getUA = environment_1.getUA;
exports.isMobileCordova = environment_1.isMobileCordova;
exports.isNodeSdk = environment_1.isNodeSdk;
exports.isReactNative = environment_1.isReactNative;
var errors_1 = __webpack_require__(1185);
exports.ErrorFactory = errors_1.ErrorFactory;
exports.FirebaseError = errors_1.FirebaseError;
exports.patchCapture = errors_1.patchCapture;
var json_1 = __webpack_require__(459);
exports.jsonEval = json_1.jsonEval;
exports.stringify = json_1.stringify;
var jwt_1 = __webpack_require__(1186);
exports.decode = jwt_1.decode;
exports.isAdmin = jwt_1.isAdmin;
exports.issuedAtTime = jwt_1.issuedAtTime;
exports.isValidFormat = jwt_1.isValidFormat;
exports.isValidTimestamp = jwt_1.isValidTimestamp;
var obj_1 = __webpack_require__(460);
exports.clone = obj_1.clone;
exports.contains = obj_1.contains;
exports.every = obj_1.every;
exports.extend = obj_1.extend;
exports.findKey = obj_1.findKey;
exports.findValue = obj_1.findValue;
exports.forEach = obj_1.forEach;
exports.getAnyKey = obj_1.getAnyKey;
exports.getCount = obj_1.getCount;
exports.getValues = obj_1.getValues;
exports.isEmpty = obj_1.isEmpty;
exports.isNonNullObject = obj_1.isNonNullObject;
exports.map = obj_1.map;
exports.safeGet = obj_1.safeGet;
var query_1 = __webpack_require__(1187);
exports.querystring = query_1.querystring;
exports.querystringDecode = query_1.querystringDecode;
var sha1_1 = __webpack_require__(1188);
exports.Sha1 = sha1_1.Sha1;
var subscribe_1 = __webpack_require__(1190);
exports.async = subscribe_1.async;
exports.createSubscribe = subscribe_1.createSubscribe;
var validation_1 = __webpack_require__(1191);
exports.errorPrefix = validation_1.errorPrefix;
exports.validateArgCount = validation_1.validateArgCount;
exports.validateCallback = validation_1.validateCallback;
exports.validateContextObject = validation_1.validateContextObject;
exports.validateNamespace = validation_1.validateNamespace;
var utf8_1 = __webpack_require__(1192);
exports.stringLength = utf8_1.stringLength;
exports.stringToByteArray = utf8_1.stringToByteArray;

//# sourceMappingURL=index.js.map


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_create__);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = __WEBPACK_IMPORTED_MODULE_0__core_js_object_create___default()(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_assign__);

function _extends() {
  _extends = __WEBPACK_IMPORTED_MODULE_0__core_js_object_assign___default.a || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_keys__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__core_js_object_keys__);

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};

  var sourceKeys = __WEBPACK_IMPORTED_MODULE_0__core_js_object_keys___default()(source);

  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = prefix;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bsClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bsStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return bsSizes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = getClassSet;
/* harmony export (immutable) */ __webpack_exports__["f"] = splitBsProps;
/* harmony export (immutable) */ __webpack_exports__["g"] = splitBsPropsAndOmit;
/* unused harmony export addStyle */
/* unused harmony export _curry */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StyleConfig__ = __webpack_require__(37);


// TODO: The publicly exposed parts of this should be in lib/BootstrapUtils.




function curry(fn) {
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var last = args[args.length - 1];

    if (typeof last === 'function') {
      return fn.apply(void 0, args);
    }

    return function (Component) {
      return fn.apply(void 0, args.concat([Component]));
    };
  };
}

function prefix(props, variant) {
  var bsClass = (props.bsClass || '').trim();
  !(bsClass != null) ?  false ? invariant(false, 'A `bsClass` prop is required for this component') : __WEBPACK_IMPORTED_MODULE_2_invariant___default()(false) : void 0;
  return bsClass + (variant ? "-" + variant : '');
}
var bsClass = curry(function (defaultClass, Component) {
  var propTypes = Component.propTypes || (Component.propTypes = {});
  var defaultProps = Component.defaultProps || (Component.defaultProps = {});
  propTypes.bsClass = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string;
  defaultProps.bsClass = defaultClass;
  return Component;
});
var bsStyles = curry(function (styles, defaultStyle, Component) {
  if (typeof defaultStyle !== 'string') {
    Component = defaultStyle;
    defaultStyle = undefined;
  }

  var existing = Component.STYLES || [];
  var propTypes = Component.propTypes || {};
  styles.forEach(function (style) {
    if (existing.indexOf(style) === -1) {
      existing.push(style);
    }
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(existing); // expose the values on the propType function for documentation

  Component.STYLES = existing;
  propType._values = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsStyle: propType
  });

  if (defaultStyle !== undefined) {
    var defaultProps = Component.defaultProps || (Component.defaultProps = {});
    defaultProps.bsStyle = defaultStyle;
  }

  return Component;
});
var bsSizes = curry(function (sizes, defaultSize, Component) {
  if (typeof defaultSize !== 'string') {
    Component = defaultSize;
    defaultSize = undefined;
  }

  var existing = Component.SIZES || [];
  var propTypes = Component.propTypes || {};
  sizes.forEach(function (size) {
    if (existing.indexOf(size) === -1) {
      existing.push(size);
    }
  });
  var values = [];
  existing.forEach(function (size) {
    var mappedSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][size];

    if (mappedSize && mappedSize !== size) {
      values.push(mappedSize);
    }

    values.push(size);
  });
  var propType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(values);
  propType._values = values; // expose the values on the propType function for documentation

  Component.SIZES = existing;
  Component.propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, propTypes, {
    bsSize: propType
  });

  if (defaultSize !== undefined) {
    if (!Component.defaultProps) {
      Component.defaultProps = {};
    }

    Component.defaultProps.bsSize = defaultSize;
  }

  return Component;
});
function getClassSet(props) {
  var _classes;

  var classes = (_classes = {}, _classes[prefix(props)] = true, _classes);

  if (props.bsSize) {
    var bsSize = __WEBPACK_IMPORTED_MODULE_4__StyleConfig__["b" /* SIZE_MAP */][props.bsSize] || props.bsSize;
    classes[prefix(props, bsSize)] = true;
  }

  if (props.bsStyle) {
    classes[prefix(props, props.bsStyle)] = true;
  }

  return classes;
}

function getBsProps(props) {
  return {
    bsClass: props.bsClass,
    bsSize: props.bsSize,
    bsStyle: props.bsStyle,
    bsRole: props.bsRole
  };
}

function isBsProp(propName) {
  return propName === 'bsClass' || propName === 'bsSize' || propName === 'bsStyle' || propName === 'bsRole';
}

function splitBsProps(props) {
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (!isBsProp(propName)) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
function splitBsPropsAndOmit(props, omittedPropNames) {
  var isOmittedProp = {};
  omittedPropNames.forEach(function (propName) {
    isOmittedProp[propName] = true;
  });
  var elementProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref2) {
    var propName = _ref2[0],
        propValue = _ref2[1];

    if (!isBsProp(propName) && !isOmittedProp[propName]) {
      elementProps[propName] = propValue;
    }
  });

  return [getBsProps(props), elementProps];
}
/**
 * Add a style variant to a Component. Mutates the propTypes of the component
 * in order to validate the new variant.
 */

function addStyle(Component) {
  for (var _len2 = arguments.length, styleVariant = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    styleVariant[_key2 - 1] = arguments[_key2];
  }

  bsStyles(styleVariant, Component);
}
var _curry = curry;

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(244);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(860);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__deepmerge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(861);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(862);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(863);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDisplayName__ = __webpack_require__(864);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ponyfillGlobal__ = __webpack_require__(865);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refType__ = __webpack_require__(866);
/* unused harmony reexport refType */
/** @license Material-UI v4.5.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */









/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorManipulator__ = __webpack_require__(36);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__colorManipulator__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__ = __webpack_require__(377);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__createMuiTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(873);
/* unused harmony reexport createStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__makeStyles__ = __webpack_require__(395);
/* unused harmony reexport makeStyles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__responsiveFontSizes__ = __webpack_require__(906);
/* unused harmony reexport responsiveFontSizes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styled__ = __webpack_require__(396);
/* unused harmony reexport styled */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transitions__ = __webpack_require__(64);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__transitions__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__useTheme__ = __webpack_require__(32);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__useTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__withStyles__ = __webpack_require__(5);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_8__withStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withTheme__ = __webpack_require__(909);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_9__withTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_styles__ = __webpack_require__(59);
/* unused harmony reexport createGenerateClassName */
/* unused harmony reexport jssPreset */
/* unused harmony reexport ServerStyleSheets */
/* unused harmony reexport StylesProvider */
/* unused harmony reexport MuiThemeProvider */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__material_ui_styles__["a"]; });












/***/ }),
/* 14 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createSvgIcon;

var _extends2 = _interopRequireDefault(__webpack_require__(1152));

var _react = _interopRequireDefault(__webpack_require__(0));

var _SvgIcon = _interopRequireDefault(__webpack_require__(116));

function createSvgIcon(path, displayName) {
  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
      ref: ref
    }, props), path);
  }));

  if (false) {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = _SvgIcon.default.muiName;
  return Component;
}

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word a the sentence.
// We only handle the first word.
function capitalize(string) {
  if (false) {
    if (typeof string !== 'string') {
      throw new Error('Material-UI: capitalize(string) expects a string argument.');
    }
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(623);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(658);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(663);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__splice__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getIn__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setIn__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__deepEqual__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deleteIn__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keys__ = __webpack_require__(752);








var structure = {
  allowsArrayErrors: true,
  empty: {},
  emptyList: [],
  getIn: __WEBPACK_IMPORTED_MODULE_1__getIn__["a" /* default */],
  setIn: __WEBPACK_IMPORTED_MODULE_2__setIn__["a" /* default */],
  deepEqual: __WEBPACK_IMPORTED_MODULE_3__deepEqual__["a" /* default */],
  deleteIn: __WEBPACK_IMPORTED_MODULE_4__deleteIn__["a" /* default */],
  forEach: function forEach(items, callback) {
    return items.forEach(callback);
  },
  fromJS: function fromJS(value) {
    return value;
  },
  keys: __WEBPACK_IMPORTED_MODULE_5__keys__["a" /* default */],
  size: function size(array) {
    return array ? array.length : 0;
  },
  some: function some(items, callback) {
    return items.some(callback);
  },
  splice: __WEBPACK_IMPORTED_MODULE_0__splice__["a" /* default */],
  toJS: function toJS(value) {
    return value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (structure);

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colors__ = __webpack_require__(911);
/* unused harmony reexport colors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles__ = __webpack_require__(13);
/* unused harmony reexport createGenerateClassName */
/* unused harmony reexport createMuiTheme */
/* unused harmony reexport createStyles */
/* unused harmony reexport jssPreset */
/* unused harmony reexport makeStyles */
/* unused harmony reexport MuiThemeProvider */
/* unused harmony reexport responsiveFontSizes */
/* unused harmony reexport ServerStyleSheets */
/* unused harmony reexport styled */
/* unused harmony reexport StylesProvider */
/* unused harmony reexport ThemeProvider */
/* unused harmony reexport useTheme */
/* unused harmony reexport withStyles */
/* unused harmony reexport withTheme */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppBar__ = __webpack_require__(927);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__AppBar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Avatar__ = __webpack_require__(930);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__Avatar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Backdrop__ = __webpack_require__(251);
/* unused harmony reexport Backdrop */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Badge__ = __webpack_require__(941);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_5__Badge__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__BottomNavigation__ = __webpack_require__(943);
/* unused harmony reexport BottomNavigation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__BottomNavigationAction__ = __webpack_require__(945);
/* unused harmony reexport BottomNavigationAction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Box__ = __webpack_require__(951);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__Box__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Breadcrumbs__ = __webpack_require__(960);
/* unused harmony reexport Breadcrumbs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Button__ = __webpack_require__(410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonBase__ = __webpack_require__(41);
/* unused harmony reexport ButtonBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ButtonGroup__ = __webpack_require__(968);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Card__ = __webpack_require__(970);
/* unused harmony reexport Card */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__CardActionArea__ = __webpack_require__(972);
/* unused harmony reexport CardActionArea */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__CardActions__ = __webpack_require__(974);
/* unused harmony reexport CardActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__CardContent__ = __webpack_require__(976);
/* unused harmony reexport CardContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__CardHeader__ = __webpack_require__(978);
/* unused harmony reexport CardHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__CardMedia__ = __webpack_require__(980);
/* unused harmony reexport CardMedia */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Checkbox__ = __webpack_require__(411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_19__Checkbox__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__Chip__ = __webpack_require__(412);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_20__Chip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__CircularProgress__ = __webpack_require__(989);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_21__CircularProgress__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__ClickAwayListener__ = __webpack_require__(413);
/* unused harmony reexport ClickAwayListener */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Collapse__ = __webpack_require__(178);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_23__Collapse__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__Container__ = __webpack_require__(993);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_24__Container__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__CssBaseline__ = __webpack_require__(995);
/* unused harmony reexport CssBaseline */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__Dialog__ = __webpack_require__(997);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_26__Dialog__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__DialogActions__ = __webpack_require__(1003);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_27__DialogActions__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__DialogContent__ = __webpack_require__(1005);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_28__DialogContent__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__DialogContentText__ = __webpack_require__(1007);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_29__DialogContentText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__DialogTitle__ = __webpack_require__(1009);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_30__DialogTitle__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Divider__ = __webpack_require__(1011);
/* unused harmony reexport Divider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__Drawer__ = __webpack_require__(1013);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_32__Drawer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__ExpansionPanel__ = __webpack_require__(1015);
/* unused harmony reexport ExpansionPanel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ExpansionPanelActions__ = __webpack_require__(1018);
/* unused harmony reexport ExpansionPanelActions */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ExpansionPanelDetails__ = __webpack_require__(1020);
/* unused harmony reexport ExpansionPanelDetails */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ExpansionPanelSummary__ = __webpack_require__(1022);
/* unused harmony reexport ExpansionPanelSummary */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__Fab__ = __webpack_require__(260);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_37__Fab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__Fade__ = __webpack_require__(252);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__FilledInput__ = __webpack_require__(261);
/* unused harmony reexport FilledInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__FormControl__ = __webpack_require__(263);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return __WEBPACK_IMPORTED_MODULE_40__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__FormControlLabel__ = __webpack_require__(1029);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return __WEBPACK_IMPORTED_MODULE_41__FormControlLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__FormGroup__ = __webpack_require__(419);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__FormHelperText__ = __webpack_require__(420);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return __WEBPACK_IMPORTED_MODULE_43__FormHelperText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__FormLabel__ = __webpack_require__(421);
/* unused harmony reexport FormLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__Grid__ = __webpack_require__(1034);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return __WEBPACK_IMPORTED_MODULE_45__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__GridList__ = __webpack_require__(1036);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return __WEBPACK_IMPORTED_MODULE_46__GridList__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__GridListTile__ = __webpack_require__(1038);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return __WEBPACK_IMPORTED_MODULE_47__GridListTile__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__GridListTileBar__ = __webpack_require__(1040);
/* unused harmony reexport GridListTileBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Grow__ = __webpack_require__(180);
/* unused harmony reexport Grow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Hidden__ = __webpack_require__(1043);
/* unused harmony reexport Hidden */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__Icon__ = __webpack_require__(1049);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return __WEBPACK_IMPORTED_MODULE_51__Icon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__IconButton__ = __webpack_require__(137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return __WEBPACK_IMPORTED_MODULE_52__IconButton__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__Input__ = __webpack_require__(181);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return __WEBPACK_IMPORTED_MODULE_53__Input__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__InputAdornment__ = __webpack_require__(1052);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return __WEBPACK_IMPORTED_MODULE_54__InputAdornment__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__InputBase__ = __webpack_require__(140);
/* unused harmony reexport InputBase */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__InputLabel__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return __WEBPACK_IMPORTED_MODULE_56__InputLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__LinearProgress__ = __webpack_require__(426);
/* unused harmony reexport LinearProgress */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__Link__ = __webpack_require__(1056);
/* unused harmony reexport Link */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__List__ = __webpack_require__(427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return __WEBPACK_IMPORTED_MODULE_59__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__ListItem__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return __WEBPACK_IMPORTED_MODULE_60__ListItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__ListItemAvatar__ = __webpack_require__(1060);
/* unused harmony reexport ListItemAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__ListItemIcon__ = __webpack_require__(1062);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return __WEBPACK_IMPORTED_MODULE_62__ListItemIcon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__ListItemSecondaryAction__ = __webpack_require__(1064);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return __WEBPACK_IMPORTED_MODULE_63__ListItemSecondaryAction__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__ListItemText__ = __webpack_require__(1066);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return __WEBPACK_IMPORTED_MODULE_64__ListItemText__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__ListSubheader__ = __webpack_require__(429);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return __WEBPACK_IMPORTED_MODULE_65__ListSubheader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__Menu__ = __webpack_require__(1069);
/* unused harmony reexport Menu */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__MenuItem__ = __webpack_require__(433);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return __WEBPACK_IMPORTED_MODULE_67__MenuItem__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__MenuList__ = __webpack_require__(432);
/* unused harmony reexport MenuList */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__MobileStepper__ = __webpack_require__(1073);
/* unused harmony reexport MobileStepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__Modal__ = __webpack_require__(179);
/* unused harmony reexport Modal */
/* unused harmony reexport ModalManager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__NativeSelect__ = __webpack_require__(1075);
/* unused harmony reexport NativeSelect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__NoSsr__ = __webpack_require__(255);
/* unused harmony reexport NoSsr */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__OutlinedInput__ = __webpack_require__(265);
/* unused harmony reexport OutlinedInput */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__Paper__ = __webpack_require__(60);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return __WEBPACK_IMPORTED_MODULE_74__Paper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__Popover__ = __webpack_require__(431);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return __WEBPACK_IMPORTED_MODULE_75__Popover__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__Popper__ = __webpack_require__(266);
/* unused harmony reexport Popper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__Portal__ = __webpack_require__(258);
/* unused harmony reexport Portal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__Radio__ = __webpack_require__(1080);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__RadioGroup__ = __webpack_require__(438);
/* unused harmony reexport RadioGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__RootRef__ = __webpack_require__(1086);
/* unused harmony reexport RootRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__Select__ = __webpack_require__(92);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return __WEBPACK_IMPORTED_MODULE_81__Select__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__Slide__ = __webpack_require__(416);
/* unused harmony reexport Slide */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__Slider__ = __webpack_require__(1094);
/* unused harmony reexport Slider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__Snackbar__ = __webpack_require__(1097);
/* unused harmony reexport Snackbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__SnackbarContent__ = __webpack_require__(439);
/* unused harmony reexport SnackbarContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__Step__ = __webpack_require__(1100);
/* unused harmony reexport Step */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__StepButton__ = __webpack_require__(1102);
/* unused harmony reexport StepButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__StepConnector__ = __webpack_require__(442);
/* unused harmony reexport StepConnector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__StepContent__ = __webpack_require__(1109);
/* unused harmony reexport StepContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__StepIcon__ = __webpack_require__(441);
/* unused harmony reexport StepIcon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__StepLabel__ = __webpack_require__(440);
/* unused harmony reexport StepLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__Stepper__ = __webpack_require__(1111);
/* unused harmony reexport Stepper */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__SvgIcon__ = __webpack_require__(116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return __WEBPACK_IMPORTED_MODULE_93__SvgIcon__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__SwipeableDrawer__ = __webpack_require__(1113);
/* unused harmony reexport SwipeableDrawer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__Switch__ = __webpack_require__(443);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__Tab__ = __webpack_require__(1117);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return __WEBPACK_IMPORTED_MODULE_96__Tab__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__Table__ = __webpack_require__(1119);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return __WEBPACK_IMPORTED_MODULE_97__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__TableBody__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return __WEBPACK_IMPORTED_MODULE_98__TableBody__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__TableCell__ = __webpack_require__(445);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return __WEBPACK_IMPORTED_MODULE_99__TableCell__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__TableFooter__ = __webpack_require__(1124);
/* unused harmony reexport TableFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__TableHead__ = __webpack_require__(1126);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return __WEBPACK_IMPORTED_MODULE_101__TableHead__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__TablePagination__ = __webpack_require__(1128);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return __WEBPACK_IMPORTED_MODULE_102__TablePagination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__TableRow__ = __webpack_require__(1132);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return __WEBPACK_IMPORTED_MODULE_103__TableRow__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__TableSortLabel__ = __webpack_require__(1134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "U", function() { return __WEBPACK_IMPORTED_MODULE_104__TableSortLabel__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__Tabs__ = __webpack_require__(1137);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "V", function() { return __WEBPACK_IMPORTED_MODULE_105__Tabs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__TextField__ = __webpack_require__(449);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "W", function() { return __WEBPACK_IMPORTED_MODULE_106__TextField__["default"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__TextareaAutosize__ = __webpack_require__(418);
/* unused harmony reexport TextareaAutosize */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__Toolbar__ = __webpack_require__(446);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "X", function() { return __WEBPACK_IMPORTED_MODULE_108__Toolbar__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__Tooltip__ = __webpack_require__(450);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Y", function() { return __WEBPACK_IMPORTED_MODULE_109__Tooltip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__Typography__ = __webpack_require__(46);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Z", function() { return __WEBPACK_IMPORTED_MODULE_110__Typography__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__useMediaQuery__ = __webpack_require__(424);
/* unused harmony reexport useMediaQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__useScrollTrigger__ = __webpack_require__(1146);
/* unused harmony reexport useScrollTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__withMobileDialog__ = __webpack_require__(1148);
/* unused harmony reexport withMobileDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__withWidth__ = __webpack_require__(264);
/* unused harmony reexport withWidth */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__Zoom__ = __webpack_require__(451);
/* unused harmony reexport Zoom */
/** @license Material-UI v4.6.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */






















































































































/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var util_3 = __webpack_require__(6);
var util_4 = __webpack_require__(6);
var util_5 = __webpack_require__(6);
var util_6 = __webpack_require__(6);
var storage_1 = __webpack_require__(182);
var util_7 = __webpack_require__(6);
/**
 * Returns a locally-unique ID (generated by just incrementing up from 0 each time its called).
 * @type {function(): number} Generated ID.
 */
exports.LUIDGenerator = (function () {
    var id = 1;
    return function () {
        return id++;
    };
})();
/**
 * Sha1 hash of the input string
 * @param {!string} str The string to hash
 * @return {!string} The resulting hash
 */
exports.sha1 = function (str) {
    var utf8Bytes = util_5.stringToByteArray(str);
    var sha1 = new util_4.Sha1();
    sha1.update(utf8Bytes);
    var sha1Bytes = sha1.digest();
    return util_3.base64.encodeByteArray(sha1Bytes);
};
/**
 * @param {...*} var_args
 * @return {string}
 * @private
 */
var buildLogMessage_ = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = '';
    for (var i = 0; i < var_args.length; i++) {
        if (Array.isArray(var_args[i]) ||
            (var_args[i] &&
                typeof var_args[i] === 'object' &&
                typeof var_args[i].length === 'number')) {
            message += buildLogMessage_.apply(null, var_args[i]);
        }
        else if (typeof var_args[i] === 'object') {
            message += util_6.stringify(var_args[i]);
        }
        else {
            message += var_args[i];
        }
        message += ' ';
    }
    return message;
};
/**
 * Use this for all debug messages in Firebase.
 * @type {?function(string)}
 */
exports.logger = null;
/**
 * Flag to check for log availability on first log message
 * @type {boolean}
 * @private
 */
var firstLog_ = true;
/**
 * The implementation of Firebase.enableLogging (defined here to break dependencies)
 * @param {boolean|?function(string)} logger_ A flag to turn on logging, or a custom logger
 * @param {boolean=} persistent Whether or not to persist logging settings across refreshes
 */
exports.enableLogging = function (logger_, persistent) {
    util_1.assert(!persistent || (logger_ === true || logger_ === false), "Can't turn on custom loggers persistently.");
    if (logger_ === true) {
        if (typeof console !== 'undefined') {
            if (typeof console.log === 'function') {
                exports.logger = console.log.bind(console);
            }
            else if (typeof console.log === 'object') {
                // IE does this.
                exports.logger = function (message) {
                    console.log(message);
                };
            }
        }
        if (persistent)
            storage_1.SessionStorage.set('logging_enabled', true);
    }
    else if (typeof logger_ === 'function') {
        exports.logger = logger_;
    }
    else {
        exports.logger = null;
        storage_1.SessionStorage.remove('logging_enabled');
    }
};
/**
 *
 * @param {...(string|Arguments)} var_args
 */
exports.log = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (firstLog_ === true) {
        firstLog_ = false;
        if (exports.logger === null && storage_1.SessionStorage.get('logging_enabled') === true)
            exports.enableLogging(true);
    }
    if (exports.logger) {
        var message = buildLogMessage_.apply(null, var_args);
        exports.logger(message);
    }
};
/**
 * @param {!string} prefix
 * @return {function(...[*])}
 */
exports.logWrapper = function (prefix) {
    return function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        exports.log.apply(void 0, [prefix].concat(var_args));
    };
};
/**
 * @param {...string} var_args
 */
exports.error = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        var message = 'FIREBASE INTERNAL ERROR: ' + buildLogMessage_.apply(void 0, var_args);
        if (typeof console.error !== 'undefined') {
            console.error(message);
        }
        else {
            console.log(message);
        }
    }
};
/**
 * @param {...string} var_args
 */
exports.fatal = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var message = buildLogMessage_.apply(void 0, var_args);
    throw new Error('FIREBASE FATAL ERROR: ' + message);
};
/**
 * @param {...*} var_args
 */
exports.warn = function () {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    if (typeof console !== 'undefined') {
        var message = 'FIREBASE WARNING: ' + buildLogMessage_.apply(void 0, var_args);
        if (typeof console.warn !== 'undefined') {
            console.warn(message);
        }
        else {
            console.log(message);
        }
    }
};
/**
 * Logs a warning if the containing page uses https. Called when a call to new Firebase
 * does not use https.
 */
exports.warnIfPageIsSecure = function () {
    // Be very careful accessing browser globals. Who knows what may or may not exist.
    if (typeof window !== 'undefined' &&
        window.location &&
        window.location.protocol &&
        window.location.protocol.indexOf('https:') !== -1) {
        exports.warn('Insecure Firebase access from a secure page. ' +
            'Please use https in calls to new Firebase().');
    }
};
/**
 * @param {!String} methodName
 */
exports.warnAboutUnsupportedMethod = function (methodName) {
    exports.warn(methodName +
        ' is unsupported and will likely change soon.  ' +
        'Please do not use.');
};
/**
 * Returns true if data is NaN, or +/- Infinity.
 * @param {*} data
 * @return {boolean}
 */
exports.isInvalidJSONNumber = function (data) {
    return (typeof data === 'number' &&
        (data != data || // NaN
            data == Number.POSITIVE_INFINITY ||
            data == Number.NEGATIVE_INFINITY));
};
/**
 * @param {function()} fn
 */
exports.executeWhenDOMReady = function (fn) {
    if (util_7.isNodeSdk() || document.readyState === 'complete') {
        fn();
    }
    else {
        // Modeled after jQuery. Try DOMContentLoaded and onreadystatechange (which
        // fire before onload), but fall back to onload.
        var called_1 = false;
        var wrappedFn_1 = function () {
            if (!document.body) {
                setTimeout(wrappedFn_1, Math.floor(10));
                return;
            }
            if (!called_1) {
                called_1 = true;
                fn();
            }
        };
        if (document.addEventListener) {
            document.addEventListener('DOMContentLoaded', wrappedFn_1, false);
            // fallback to onload.
            window.addEventListener('load', wrappedFn_1, false);
        }
        else if (document.attachEvent) {
            // IE.
            document.attachEvent('onreadystatechange', function () {
                if (document.readyState === 'complete')
                    wrappedFn_1();
            });
            // fallback to onload.
            window.attachEvent('onload', wrappedFn_1);
            // jQuery has an extra hack for IE that we could employ (based on
            // http://javascript.nwbox.com/IEContentLoaded/) But it looks really old.
            // I'm hoping we don't need it.
        }
    }
};
/**
 * Minimum key name. Invalid for actual data, used as a marker to sort before any valid names
 * @type {!string}
 */
exports.MIN_NAME = '[MIN_NAME]';
/**
 * Maximum key name. Invalid for actual data, used as a marker to sort above any valid names
 * @type {!string}
 */
exports.MAX_NAME = '[MAX_NAME]';
/**
 * Compares valid Firebase key names, plus min and max name
 * @param {!string} a
 * @param {!string} b
 * @return {!number}
 */
exports.nameCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a === exports.MIN_NAME || b === exports.MAX_NAME) {
        return -1;
    }
    else if (b === exports.MIN_NAME || a === exports.MAX_NAME) {
        return 1;
    }
    else {
        var aAsInt = exports.tryParseInt(a), bAsInt = exports.tryParseInt(b);
        if (aAsInt !== null) {
            if (bAsInt !== null) {
                return aAsInt - bAsInt == 0 ? a.length - b.length : aAsInt - bAsInt;
            }
            else {
                return -1;
            }
        }
        else if (bAsInt !== null) {
            return 1;
        }
        else {
            return a < b ? -1 : 1;
        }
    }
};
/**
 * @param {!string} a
 * @param {!string} b
 * @return {!number} comparison result.
 */
exports.stringCompare = function (a, b) {
    if (a === b) {
        return 0;
    }
    else if (a < b) {
        return -1;
    }
    else {
        return 1;
    }
};
/**
 * @param {string} key
 * @param {Object} obj
 * @return {*}
 */
exports.requireKey = function (key, obj) {
    if (obj && key in obj) {
        return obj[key];
    }
    else {
        throw new Error('Missing required key (' + key + ') in object: ' + util_6.stringify(obj));
    }
};
/**
 * @param {*} obj
 * @return {string}
 */
exports.ObjectToUniqueKey = function (obj) {
    if (typeof obj !== 'object' || obj === null)
        return util_6.stringify(obj);
    var keys = [];
    for (var k in obj) {
        keys.push(k);
    }
    // Export as json, but with the keys sorted.
    keys.sort();
    var key = '{';
    for (var i = 0; i < keys.length; i++) {
        if (i !== 0)
            key += ',';
        key += util_6.stringify(keys[i]);
        key += ':';
        key += exports.ObjectToUniqueKey(obj[keys[i]]);
    }
    key += '}';
    return key;
};
/**
 * Splits a string into a number of smaller segments of maximum size
 * @param {!string} str The string
 * @param {!number} segsize The maximum number of chars in the string.
 * @return {Array.<string>} The string, split into appropriately-sized chunks
 */
exports.splitStringBySize = function (str, segsize) {
    var len = str.length;
    if (len <= segsize) {
        return [str];
    }
    var dataSegs = [];
    for (var c = 0; c < len; c += segsize) {
        if (c + segsize > len) {
            dataSegs.push(str.substring(c, len));
        }
        else {
            dataSegs.push(str.substring(c, c + segsize));
        }
    }
    return dataSegs;
};
/**
 * Apply a function to each (key, value) pair in an object or
 * apply a function to each (index, value) pair in an array
 * @param {!(Object|Array)} obj The object or array to iterate over
 * @param {function(?, ?)} fn The function to apply
 */
exports.each = function (obj, fn) {
    if (Array.isArray(obj)) {
        for (var i = 0; i < obj.length; ++i) {
            fn(i, obj[i]);
        }
    }
    else {
        /**
         * in the conversion of code we removed the goog.object.forEach
         * function which did a value,key callback. We standardized on
         * a single impl that does a key, value callback. So we invert
         * to not have to touch the `each` code points
         */
        util_2.forEach(obj, function (key, val) { return fn(val, key); });
    }
};
/**
 * Like goog.bind, but doesn't bother to create a closure if opt_context is null/undefined.
 * @param {function(*)} callback Callback function.
 * @param {?Object=} context Optional context to bind to.
 * @return {function(*)}
 */
exports.bindCallback = function (callback, context) {
    return context ? callback.bind(context) : callback;
};
/**
 * Borrowed from http://hg.secondlife.com/llsd/src/tip/js/typedarray.js (MIT License)
 * I made one modification at the end and removed the NaN / Infinity
 * handling (since it seemed broken [caused an overflow] and we don't need it).  See MJL comments.
 * @param {!number} v A double
 * @return {string}
 */
exports.doubleToIEEE754String = function (v) {
    util_1.assert(!exports.isInvalidJSONNumber(v), 'Invalid JSON number'); // MJL
    var ebits = 11, fbits = 52;
    var bias = (1 << (ebits - 1)) - 1, s, e, f, ln, i, bits, str;
    // Compute sign, exponent, fraction
    // Skip NaN / Infinity handling --MJL.
    if (v === 0) {
        e = 0;
        f = 0;
        s = 1 / v === -Infinity ? 1 : 0;
    }
    else {
        s = v < 0;
        v = Math.abs(v);
        if (v >= Math.pow(2, 1 - bias)) {
            // Normalized
            ln = Math.min(Math.floor(Math.log(v) / Math.LN2), bias);
            e = ln + bias;
            f = Math.round(v * Math.pow(2, fbits - ln) - Math.pow(2, fbits));
        }
        else {
            // Denormalized
            e = 0;
            f = Math.round(v / Math.pow(2, 1 - bias - fbits));
        }
    }
    // Pack sign, exponent, fraction
    bits = [];
    for (i = fbits; i; i -= 1) {
        bits.push(f % 2 ? 1 : 0);
        f = Math.floor(f / 2);
    }
    for (i = ebits; i; i -= 1) {
        bits.push(e % 2 ? 1 : 0);
        e = Math.floor(e / 2);
    }
    bits.push(s ? 1 : 0);
    bits.reverse();
    str = bits.join('');
    // Return the data as a hex string. --MJL
    var hexByteString = '';
    for (i = 0; i < 64; i += 8) {
        var hexByte = parseInt(str.substr(i, 8), 2).toString(16);
        if (hexByte.length === 1)
            hexByte = '0' + hexByte;
        hexByteString = hexByteString + hexByte;
    }
    return hexByteString.toLowerCase();
};
/**
 * Used to detect if we're in a Chrome content script (which executes in an
 * isolated environment where long-polling doesn't work).
 * @return {boolean}
 */
exports.isChromeExtensionContentScript = function () {
    return !!(typeof window === 'object' &&
        window['chrome'] &&
        window['chrome']['extension'] &&
        !/^chrome/.test(window.location.href));
};
/**
 * Used to detect if we're in a Windows 8 Store app.
 * @return {boolean}
 */
exports.isWindowsStoreApp = function () {
    // Check for the presence of a couple WinRT globals
    return typeof Windows === 'object' && typeof Windows.UI === 'object';
};
/**
 * Converts a server error code to a Javascript Error
 * @param {!string} code
 * @param {!Query} query
 * @return {Error}
 */
exports.errorForServerCode = function (code, query) {
    var reason = 'Unknown Error';
    if (code === 'too_big') {
        reason =
            'The data requested exceeds the maximum size ' +
                'that can be accessed with a single request.';
    }
    else if (code == 'permission_denied') {
        reason = "Client doesn't have permission to access the desired data.";
    }
    else if (code == 'unavailable') {
        reason = 'The service is unavailable';
    }
    var error = new Error(code + ' at ' + query.path.toString() + ': ' + reason);
    error.code = code.toUpperCase();
    return error;
};
/**
 * Used to test for integer-looking strings
 * @type {RegExp}
 * @private
 */
exports.INTEGER_REGEXP_ = new RegExp('^-?\\d{1,10}$');
/**
 * If the string contains a 32-bit integer, return it.  Else return null.
 * @param {!string} str
 * @return {?number}
 */
exports.tryParseInt = function (str) {
    if (exports.INTEGER_REGEXP_.test(str)) {
        var intVal = Number(str);
        if (intVal >= -2147483648 && intVal <= 2147483647) {
            return intVal;
        }
    }
    return null;
};
/**
 * Helper to run some code but catch any exceptions and re-throw them later.
 * Useful for preventing user callbacks from breaking internal code.
 *
 * Re-throwing the exception from a setTimeout is a little evil, but it's very
 * convenient (we don't have to try to figure out when is a safe point to
 * re-throw it), and the behavior seems reasonable:
 *
 * * If you aren't pausing on exceptions, you get an error in the console with
 *   the correct stack trace.
 * * If you're pausing on all exceptions, the debugger will pause on your
 *   exception and then again when we rethrow it.
 * * If you're only pausing on uncaught exceptions, the debugger will only pause
 *   on us re-throwing it.
 *
 * @param {!function()} fn The code to guard.
 */
exports.exceptionGuard = function (fn) {
    try {
        fn();
    }
    catch (e) {
        // Re-throw exception when it's safe.
        setTimeout(function () {
            // It used to be that "throw e" would result in a good console error with
            // relevant context, but as of Chrome 39, you just get the firebase.js
            // file/line number where we re-throw it, which is useless. So we log
            // e.stack explicitly.
            var stack = e.stack || '';
            exports.warn('Exception was thrown by user callback.', stack);
            throw e;
        }, Math.floor(0));
    }
};
/**
 * Helper function to safely call opt_callback with the specified arguments.  It:
 * 1. Turns into a no-op if opt_callback is null or undefined.
 * 2. Wraps the call inside exceptionGuard to prevent exceptions from breaking our state.
 *
 * @param {?Function=} callback Optional onComplete callback.
 * @param {...*} var_args Arbitrary args to be passed to opt_onComplete
 */
exports.callUserCallback = function (callback) {
    var var_args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        var_args[_i - 1] = arguments[_i];
    }
    if (typeof callback === 'function') {
        exports.exceptionGuard(function () {
            callback.apply(void 0, var_args);
        });
    }
};
/**
 * @return {boolean} true if we think we're currently being crawled.
 */
exports.beingCrawled = function () {
    var userAgent = (typeof window === 'object' &&
        window['navigator'] &&
        window['navigator']['userAgent']) ||
        '';
    // For now we whitelist the most popular crawlers.  We should refine this to be the set of crawlers we
    // believe to support JavaScript/AJAX rendering.
    // NOTE: Google Webmaster Tools doesn't really belong, but their "This is how a visitor to your website
    // would have seen the page" is flaky if we don't treat it as a crawler.
    return (userAgent.search(/googlebot|google webmaster tools|bingbot|yahoo! slurp|baiduspider|yandexbot|duckduckbot/i) >= 0);
};
/**
 * Export a property of an object using a getter function.
 *
 * @param {!Object} object
 * @param {string} name
 * @param {!function(): *} fnGet
 */
exports.exportPropGetter = function (object, name, fnGet) {
    Object.defineProperty(object, name, { get: fnGet });
};
/**
 * Same as setTimeout() except on Node.JS it will /not/ prevent the process from exiting.
 *
 * It is removed with clearTimeout() as normal.
 *
 * @param {Function} fn Function to run.
 * @param {number} time Milliseconds to wait before running.
 * @return {number|Object} The setTimeout() return value.
 */
exports.setTimeoutNonBlocking = function (fn, time) {
    var timeout = setTimeout(fn, time);
    if (typeof timeout === 'object' && timeout['unref']) {
        timeout['unref']();
    }
    return timeout;
};

//# sourceMappingURL=util.js.map


/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__combineReducers__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__ = __webpack_require__(671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__compose__ = __webpack_require__(341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_warning__ = __webpack_require__(340);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_0__createStore__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__combineReducers__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__bindActionCreators__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__applyMiddleware__["a"]; });
/* unused harmony reexport compose */







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(633);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(646);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(332);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(648);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(649);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(650);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(651);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(652);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_7__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(653);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(654);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(655);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_10__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__matchPath__ = __webpack_require__(656);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withRouter__ = __webpack_require__(657);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_12__withRouter__["a"]; });



























/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return INDEX_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return LOGIN_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return EVENTS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EVENTS_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EVENTS_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EVENTS_COPY_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return EVENTS_STATISTICS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return EVENTS_STATISTICS_DIRECT_RRPP_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return EVENTS_STATISTICS_PRODUCER_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return TICKETS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return TICKET_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return TICKET_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return TICKET_TYPES_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return TICKET_TYPE_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return TICKET_TYPE_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return USERS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return ROLES_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return ROLES_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return ROLES_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return PLACES_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return PLACES_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return PLACES_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NEWS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return NEWS_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return NEWS_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return NOTIFICATIONS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return NOTIFICATIONS_ADD_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return NOTIFICATIONS_EDIT_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return STATISTICS_ROUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return UNAUTHORIZED_ROUTE; });
var INDEX_ROUTE='/';var LOGIN_ROUTE='/login';var EVENTS_ROUTE='/events';var EVENTS_ADD_ROUTE='/events/create';var EVENTS_EDIT_ROUTE='/events/edit';var EVENTS_COPY_ROUTE='/events/copy';var EVENTS_STATISTICS_ROUTE='/events/statistics';var EVENTS_STATISTICS_DIRECT_RRPP_ROUTE='/events/statistics/direct-rrpp';var EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE='/events/statistics/referenced-rrpp';var EVENTS_STATISTICS_PRODUCER_ROUTE='/events/statistics/producer';// export const STATISTICS_RRPP_ROUTE = '/events/statistics/rrpp'
var TICKETS_ROUTE='/events/tickets';var TICKET_ADD_ROUTE='/events/tickets/create';var TICKET_EDIT_ROUTE='/events/tickets/edit';var TICKET_TYPES_ROUTE='/events/ticketTypes';var TICKET_TYPE_ADD_ROUTE='/events/ticketTypes/create';var TICKET_TYPE_EDIT_ROUTE='/events/ticketTypes/edit';var USERS_ROUTE='/users';var ROLES_ROUTE='/roles';var ROLES_ADD_ROUTE='/roles/add';var ROLES_EDIT_ROUTE='/roles/edit';var PLACES_ROUTE='/places';var PLACES_ADD_ROUTE='/places/create';var PLACES_EDIT_ROUTE='/places/edit';var NEWS_ROUTE='/news';var NEWS_ADD_ROUTE='/news/create';var NEWS_EDIT_ROUTE='/news/edit';var NOTIFICATIONS_ROUTE='/notifications';var NOTIFICATIONS_ADD_ROUTE='/notifications/create';var NOTIFICATIONS_EDIT_ROUTE='/notifications/edit';var STATISTICS_ROUTE='/stats';var UNAUTHORIZED_ROUTE='/unauthorized';// export const PASSWORD_RECOVERY = '/passwordrecovery';

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIs = __webpack_require__(72);

var _createChainableTypeChecker = __webpack_require__(197);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`,expected an element type (a string ') + ', component class, or function component).');
  }

  if (!(0, _reactIs.isValidElementType)(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + ', component class, or function component).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);
module.exports = exports['default'];

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SUCCESS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return WARNING; });
/* unused harmony export ALERT */
/* unused harmony export INFO */
/* unused harmony export BUTTON */
/* unused harmony export COMPLEX */
/* harmony export (immutable) */ __webpack_exports__["e"] = handleSubmitFail;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_noty__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_noty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_noty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_dom__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// Para mas info consultar en https://ned.im/noty/#/
var SUCCESS="SUCCESS";var ERROR="ERROR";var WARNING="WARNING";var ALERT="ALERT";var INFO="INFO";var BUTTON="BUTTON";var COMPLEX="COMPLEX";var Util=function(){function Util(){_classCallCheck(this,Util);}_createClass(Util,null,[{key:"notyComplex",/* Parametros:
			msg_little: String con el mensaje de tamaño menor.
			type: String, puede ser: success, info, alert, error).
			categ: String, puede ser: Informacion, Mensaje, etc.
			msg_big: String, mensaje de tamaño mayor.
			image: imagen que se mostrata como icono.
	*/value:function notyComplex(msg_little,type,categ,msg_big,image){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({text:msg_little,type:type,category:categ,category_link:"/messages",date:Date.now(),from:msg_big,avatar:image,progressBar:true,callbacks:{onTemplate:function onTemplate(){if(this.options.type===type){this.barDom.innerHTML='<div class="my-custom-template noty_body">';this.barDom.innerHTML+="<div class='noty_custom_container'>"+"<div>"+'<div class="noty-header"><a href="'+this.options.category_link+'">'+this.options.from+'</a> <span class="noty-bull">&bull;</span> <span class="noty-date">'+__WEBPACK_IMPORTED_MODULE_1_moment___default()(this.options.date).fromNow()+"</span></div>"+"<div>"+'<p class="noty-reply">'+this.options.text+"</p>"+"</div>"+"</div>"+"<div class='noty_custom_icon'>"+'<img src="'+this.options.avatar+'">'+"</div>";this.barDom.innerHTML+="<div>";}}}}).show();}},{key:"notySuccess",value:function notySuccess(msg){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({theme:"relax",type:"success",layout:"topRight",text:msg,timeout:2000,progressBar:true,closeWith:["button"],animation:{open:"noty_effects_open",close:"noty_effects_close"},id:false,force:false,killer:false,queue:"global",container:false,buttons:[],sounds:{sources:[],volume:1,conditions:[]},titleCount:{conditions:[]},modal:false}).show();}},{key:"notyError",value:function notyError(msg){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({theme:"relax",type:"error",layout:"topRight",text:msg,progressBar:false,closeWith:["button"],animation:{open:"noty_effects_open",close:"noty_effects_close"},id:false,force:false,killer:false,queue:"global",container:false,buttons:[],sounds:{sources:[],volume:1,conditions:[]},titleCount:{conditions:[]},modal:false}).show();}},{key:"notyWarning",value:function notyWarning(msg){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({theme:"relax",type:"warning",layout:"bottomRight",text:msg,timeout:2000,progressBar:true,closeWith:["button"],animation:{open:"noty_effects_open",close:"noty_effects_close"},id:false,force:false,killer:false,queue:"global",container:false,buttons:[],sounds:{sources:[],volume:1,conditions:[]},titleCount:{conditions:[]},modal:false}).show();}},{key:"notyAlert",value:function notyAlert(msg){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({theme:"relax",type:"alert",layout:"centerLeft",text:msg,progressBar:false,closeWith:["button"],animation:{open:"noty_effects_open",close:"noty_effects_close"},id:false,force:false,killer:false,queue:"global",container:false,buttons:[],sounds:{sources:[],volume:1,conditions:[]},titleCount:{conditions:[]},modal:false}).show();}},{key:"notyInfo",value:function notyInfo(msg){new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({theme:"relax",type:"info",layout:"bottomLeft",text:msg,progressBar:false,closeWith:["button"],animation:{open:"noty_effects_open",close:"noty_effects_close"},id:false,force:false,killer:false,queue:"global",container:false,buttons:[],sounds:{sources:[],volume:1,conditions:[]},titleCount:{conditions:[]},modal:false}).show();}},{key:"notyButton",value:function notyButton(msg){var n=new __WEBPACK_IMPORTED_MODULE_0_noty___default.a({text:msg,layout:"center",buttons:[__WEBPACK_IMPORTED_MODULE_0_noty___default.a.button("YES","btn btn-success",function(){console.log("button 1 clicked");},{id:"button1","data-status":"ok"}),__WEBPACK_IMPORTED_MODULE_0_noty___default.a.button("NO","btn btn-error",function(){console.log("button 2 clicked");n.close();})]}).show();}},{key:"showNoty",value:function showNoty(result,message_little,is_type,category,message_big,ima){if(result===ERROR){this.notyError(message_little);}else if(result===WARNING){this.notyWarning(message_little);}else if(result===SUCCESS){this.notySuccess(message_little);}else if(result===ALERT){this.notyAlert(message_little);}else if(result===INFO){this.notyInfo(message_little);}else if(result===BUTTON){this.notyButton(message_little);}else if(result===COMPLEX){this.notyComplex(message_little,is_type,category,message_big,ima);}}},{key:"sortAtoZ",value:function sortAtoZ(a,b){if(a<b)return-1;if(a>b)return 1;return 0;}},{key:"formatDateTimeToISODate",value:function formatDateTimeToISODate(date,time){var returnValue=__WEBPACK_IMPORTED_MODULE_1_moment___default()(date);var _time=__WEBPACK_IMPORTED_MODULE_1_moment___default()(time);returnValue.set({hour:_time.get("hour"),minute:_time.get("minute")});return __WEBPACK_IMPORTED_MODULE_1_moment___default()(returnValue).format("YYYY-MM-DDTHH:mm");}},{key:"timestampToMoment",value:function timestampToMoment(t){return t&&t._seconds&&__WEBPACK_IMPORTED_MODULE_1_moment___default()(0,0,0,0,0).add(t._seconds,'second')||t;}},{key:"formatDateToShow",value:function formatDateToShow(date){return date?__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format("DD/MM/YYYY HH:mm"):null;}},{key:"formatDate",value:function formatDate(date){return date?__WEBPACK_IMPORTED_MODULE_1_moment___default()(date).format("DD/MM/YYYY"):null;}},{key:"isoDateToJavascriptDate",value:function isoDateToJavascriptDate(date){return date?__WEBPACK_IMPORTED_MODULE_1_moment___default()(date,"YYYY-MM-DDTHH:mm").toDate():null;}},{key:"joinDataAndTime",value:function joinDataAndTime(date,time){var _date=__WEBPACK_IMPORTED_MODULE_1_moment___default()(date);var _time=__WEBPACK_IMPORTED_MODULE_1_moment___default()(time);_date.set({hour:_time.get("hour"),minute:_time.get("minute")});return _date;}},{key:"formatNumber",value:function formatNumber(value,name){if(!value){return"";}var aux=value.toString();if(aux.endsWith(".")){aux=aux.substring(0,aux.length-1)+',';}aux=aux.split('.');var integ=aux[0].toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');var decim=aux[1]?","+aux[1].substring(0,2):"";return integ+decim;}},{key:"formatNumberWith0",value:function formatNumberWith0(value,name){if(!value&&value!=0){return"";}var aux=value.toString();if(aux.endsWith(".")){aux=aux.substring(0,aux.length-1)+',';}aux=aux.split('.');var integ=aux[0].toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');var decim=aux[1]?","+aux[1].substring(0,2):"";return integ+decim;}},{key:"formatCurrency",value:function formatCurrency(value,name){if(!value){return"$0,00";}var aux=value.toString();if(aux.endsWith(".")){aux=aux.substring(0,aux.length-1)+',';}aux=aux.split('.');var integ=aux[0].toString().replace('.',',').replace(/(\d)(?=(\d{3})+(?!\d))/g,'$1.');var decim=aux[1]?","+aux[1].substring(0,2):",00";decim=decim.length==3?decim:decim+"0";return"$"+integ+decim;}},{key:"toNumber",value:function toNumber(value,name){// console.log("TO NUMBER", value, name)
if(!value){return value;}var num=value.replace(/\./g,'').replace(/,/g,'.');if(value.endsWith('.')){return num+',';}num=parseFloat(num);return isNaN(num)?0:num;}}]);return Util;}();/* harmony default export */ __webpack_exports__["d"] = (Util);function handleSubmitFail(errors){if(!this.refs||!errors){return;}var refsKeys=Object.keys(this.refs);var keys=Object.keys(errors);var key=null;var matchfound=false;refsKeys.filter(function(item){if(keys.indexOf(item)>-1&&!matchfound){key=item;matchfound=true;return false;}else{return true;}});this.targetNode=this.refs[key];if(this.targetNode){var node=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this.targetNode);if(node.getElementsByTagName("input")[0]){node.getElementsByTagName("input")[0].focus();return;}else if(node.getElementsByTagName("div")[0].getElementsByTagName("textarea")[0]){node.getElementsByTagName("div")[0].getElementsByTagName("textarea")[1].focus();return;}var parentNode=__WEBPACK_IMPORTED_MODULE_2_react_dom___default.a.findDOMNode(this);var xy=node.getBoundingClientRect();this.x=xy.right+window.scrollX;this.y=xy.top+window.scrollY-60;parentNode&&parentNode.scrollTo&&parentNode.scrollTo(this.x,this.y)||parentNode&&parentNode.scrollTop&&(parentNode.scrollTop=this.y)||window&&window.scrollTo(this.x,this.y);}}

/***/ }),
/* 27 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useForkRef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setRef__ = __webpack_require__(82);


function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior
   */
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    if (refA == null && refB == null) {
      return null;
    }

    return function (refValue) {
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refA, refValue);
      Object(__WEBPACK_IMPORTED_MODULE_1__setRef__["a" /* default */])(refB, refValue);
    };
  }, [refA, refB]);
}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
var util_2 = __webpack_require__(6);
/**
 * An immutable object representing a parsed path.  It's immutable so that you
 * can pass them around to other functions without worrying about them changing
 * it.
 */
var Path = /** @class */ (function () {
    /**
     * @param {string|Array.<string>} pathOrString Path string to parse,
     *      or another path, or the raw tokens array
     * @param {number=} pieceNum
     */
    function Path(pathOrString, pieceNum) {
        if (pieceNum === void 0) {
            this.pieces_ = pathOrString.split('/');
            // Remove empty pieces.
            var copyTo = 0;
            for (var i = 0; i < this.pieces_.length; i++) {
                if (this.pieces_[i].length > 0) {
                    this.pieces_[copyTo] = this.pieces_[i];
                    copyTo++;
                }
            }
            this.pieces_.length = copyTo;
            this.pieceNum_ = 0;
        }
        else {
            this.pieces_ = pathOrString;
            this.pieceNum_ = pieceNum;
        }
    }
    Object.defineProperty(Path, "Empty", {
        /**
         * Singleton to represent an empty path
         *
         * @const
         */
        get: function () {
            return new Path('');
        },
        enumerable: true,
        configurable: true
    });
    Path.prototype.getFront = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        return this.pieces_[this.pieceNum_];
    };
    /**
     * @return {number} The number of segments in this path
     */
    Path.prototype.getLength = function () {
        return this.pieces_.length - this.pieceNum_;
    };
    /**
     * @return {!Path}
     */
    Path.prototype.popFront = function () {
        var pieceNum = this.pieceNum_;
        if (pieceNum < this.pieces_.length) {
            pieceNum++;
        }
        return new Path(this.pieces_, pieceNum);
    };
    /**
     * @return {?string}
     */
    Path.prototype.getBack = function () {
        if (this.pieceNum_ < this.pieces_.length)
            return this.pieces_[this.pieces_.length - 1];
        return null;
    };
    Path.prototype.toString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + this.pieces_[i];
        }
        return pathString || '/';
    };
    Path.prototype.toUrlEncodedString = function () {
        var pathString = '';
        for (var i = this.pieceNum_; i < this.pieces_.length; i++) {
            if (this.pieces_[i] !== '')
                pathString += '/' + encodeURIComponent(String(this.pieces_[i]));
        }
        return pathString || '/';
    };
    /**
     * Shallow copy of the parts of the path.
     *
     * @param {number=} begin
     * @return {!Array<string>}
     */
    Path.prototype.slice = function (begin) {
        if (begin === void 0) { begin = 0; }
        return this.pieces_.slice(this.pieceNum_ + begin);
    };
    /**
     * @return {?Path}
     */
    Path.prototype.parent = function () {
        if (this.pieceNum_ >= this.pieces_.length)
            return null;
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length - 1; i++)
            pieces.push(this.pieces_[i]);
        return new Path(pieces, 0);
    };
    /**
     * @param {string|!Path} childPathObj
     * @return {!Path}
     */
    Path.prototype.child = function (childPathObj) {
        var pieces = [];
        for (var i = this.pieceNum_; i < this.pieces_.length; i++)
            pieces.push(this.pieces_[i]);
        if (childPathObj instanceof Path) {
            for (var i = childPathObj.pieceNum_; i < childPathObj.pieces_.length; i++) {
                pieces.push(childPathObj.pieces_[i]);
            }
        }
        else {
            var childPieces = childPathObj.split('/');
            for (var i = 0; i < childPieces.length; i++) {
                if (childPieces[i].length > 0)
                    pieces.push(childPieces[i]);
            }
        }
        return new Path(pieces, 0);
    };
    /**
     * @return {boolean} True if there are no segments in this path
     */
    Path.prototype.isEmpty = function () {
        return this.pieceNum_ >= this.pieces_.length;
    };
    /**
     * @param {!Path} outerPath
     * @param {!Path} innerPath
     * @return {!Path} The path from outerPath to innerPath
     */
    Path.relativePath = function (outerPath, innerPath) {
        var outer = outerPath.getFront(), inner = innerPath.getFront();
        if (outer === null) {
            return innerPath;
        }
        else if (outer === inner) {
            return Path.relativePath(outerPath.popFront(), innerPath.popFront());
        }
        else {
            throw new Error('INTERNAL ERROR: innerPath (' +
                innerPath +
                ') is not within ' +
                'outerPath (' +
                outerPath +
                ')');
        }
    };
    /**
     * @param {!Path} left
     * @param {!Path} right
     * @return {number} -1, 0, 1 if left is less, equal, or greater than the right.
     */
    Path.comparePaths = function (left, right) {
        var leftKeys = left.slice();
        var rightKeys = right.slice();
        for (var i = 0; i < leftKeys.length && i < rightKeys.length; i++) {
            var cmp = util_1.nameCompare(leftKeys[i], rightKeys[i]);
            if (cmp !== 0)
                return cmp;
        }
        if (leftKeys.length === rightKeys.length)
            return 0;
        return leftKeys.length < rightKeys.length ? -1 : 1;
    };
    /**
     *
     * @param {Path} other
     * @return {boolean} true if paths are the same.
     */
    Path.prototype.equals = function (other) {
        if (this.getLength() !== other.getLength()) {
            return false;
        }
        for (var i = this.pieceNum_, j = other.pieceNum_; i <= this.pieces_.length; i++, j++) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
        }
        return true;
    };
    /**
     *
     * @param {!Path} other
     * @return {boolean} True if this path is a parent (or the same as) other
     */
    Path.prototype.contains = function (other) {
        var i = this.pieceNum_;
        var j = other.pieceNum_;
        if (this.getLength() > other.getLength()) {
            return false;
        }
        while (i < this.pieces_.length) {
            if (this.pieces_[i] !== other.pieces_[j]) {
                return false;
            }
            ++i;
            ++j;
        }
        return true;
    };
    return Path;
}()); // end Path
exports.Path = Path;
/**
 * Dynamic (mutable) path used to count path lengths.
 *
 * This class is used to efficiently check paths for valid
 * length (in UTF8 bytes) and depth (used in path validation).
 *
 * Throws Error exception if path is ever invalid.
 *
 * The definition of a path always begins with '/'.
 */
var ValidationPath = /** @class */ (function () {
    /**
     * @param {!Path} path Initial Path.
     * @param {string} errorPrefix_ Prefix for any error messages.
     */
    function ValidationPath(path, errorPrefix_) {
        this.errorPrefix_ = errorPrefix_;
        /** @type {!Array<string>} */
        this.parts_ = path.slice();
        /** @type {number} Initialize to number of '/' chars needed in path. */
        this.byteLength_ = Math.max(1, this.parts_.length);
        for (var i = 0; i < this.parts_.length; i++) {
            this.byteLength_ += util_2.stringLength(this.parts_[i]);
        }
        this.checkValid_();
    }
    Object.defineProperty(ValidationPath, "MAX_PATH_DEPTH", {
        /** @const {number} Maximum key depth. */
        get: function () {
            return 32;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ValidationPath, "MAX_PATH_LENGTH_BYTES", {
        /** @const {number} Maximum number of (UTF8) bytes in a Firebase path. */
        get: function () {
            return 768;
        },
        enumerable: true,
        configurable: true
    });
    /** @param {string} child */
    ValidationPath.prototype.push = function (child) {
        // Count the needed '/'
        if (this.parts_.length > 0) {
            this.byteLength_ += 1;
        }
        this.parts_.push(child);
        this.byteLength_ += util_2.stringLength(child);
        this.checkValid_();
    };
    ValidationPath.prototype.pop = function () {
        var last = this.parts_.pop();
        this.byteLength_ -= util_2.stringLength(last);
        // Un-count the previous '/'
        if (this.parts_.length > 0) {
            this.byteLength_ -= 1;
        }
    };
    ValidationPath.prototype.checkValid_ = function () {
        if (this.byteLength_ > ValidationPath.MAX_PATH_LENGTH_BYTES) {
            throw new Error(this.errorPrefix_ +
                'has a key path longer than ' +
                ValidationPath.MAX_PATH_LENGTH_BYTES +
                ' bytes (' +
                this.byteLength_ +
                ').');
        }
        if (this.parts_.length > ValidationPath.MAX_PATH_DEPTH) {
            throw new Error(this.errorPrefix_ +
                'path specified exceeds the maximum depth that can be written (' +
                ValidationPath.MAX_PATH_DEPTH +
                ') or object contains a cycle ' +
                this.toErrorString());
        }
    };
    /**
     * String for use in error messages - uses '.' notation for path.
     *
     * @return {string}
     */
    ValidationPath.prototype.toErrorString = function () {
        if (this.parts_.length == 0) {
            return '';
        }
        return "in property '" + this.parts_.join('.') + "'";
    };
    return ValidationPath;
}());
exports.ValidationPath = ValidationPath;

//# sourceMappingURL=Path.js.map


/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ACT_AUTH_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ACT_APP_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return ACT_EVT_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return ACT_PLC_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return ACT_USR_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return ACT_TAG_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return ACT_ROL_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return ACT_NTF_CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return ACT_NVT_CHANGE; });
/* unused harmony export ACT_ABM_CHANGE */
/* unused harmony export MODE_CRU_UPDATE */
/* unused harmony export MODE_CRU_ADDELEMENT */
/* unused harmony export MODE_CRU_SHOW */
/* unused harmony export MODE_CRU_CREATE */
/* unused harmony export MODE_CRU_COPY */
/* unused harmony export CHPROPS_LOGIN_RECOVERY_PASSWORD */
/* unused harmony export CHPROPS_AUTH_USER */
/* unused harmony export ACT_PERMISO_CHANGE */
/* unused harmony export CHPROPS_LOGIN_REGISTER */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return ACT_STATS_CHANGE; });
/*
Nomenclatura para la definicion de constantes:
	ACT_ + NOMBRE DEL MODULO (Action File) + Acción propiamente dicha

Ejemplos de nomenclatura:
	ACT_LOGIN_REGISTER
	ACT_EMPLEADOS_ADD
	ACT_EMPLEADOS_DELETE

Para acciones que solo cambian props (ejemplo).
	CHPROPS_LOGIN
	CHPROPS_EMPLEADOS
*/var ACT_AUTH_CHANGE="ACT_AUTH_CHANGE";var ACT_APP_CHANGE="ACT_APP_CHANGE";var ACT_EVT_CHANGE="ACT_EVT_CHANGE";var ACT_PLC_CHANGE="ACT_PLC_CHANGE";var ACT_USR_CHANGE="ACT_USR_CHANGE";var ACT_TAG_CHANGE="ACT_TAG_CHANGE";var ACT_ROL_CHANGE="ACT_ROL_CHANGE";var ACT_NTF_CHANGE="ACT_NTF_CHANGE";var ACT_NVT_CHANGE="ACT_NVT_CHANGE";var ACT_ABM_CHANGE="ACT_ABM_CHANGE";var MODE_CRU_UPDATE="UPDATE";var MODE_CRU_ADDELEMENT="ADDELEMENT";var MODE_CRU_SHOW="SHOW";var MODE_CRU_CREATE="CREATE";var MODE_CRU_COPY="COPY";var CHPROPS_LOGIN_RECOVERY_PASSWORD="CHPROPS_LOGIN_RECOVERY_PASSWORD";//CHANGE_PROPS_RECOVERY_PASSWORD
var CHPROPS_AUTH_USER="CHPROPS_AUTH_USER";//LOGIN_USER
var ACT_PERMISO_CHANGE="ACT_PERMISO_CHANGE";//CHANGE_PERMISO_PROPS
var CHPROPS_LOGIN_REGISTER="CHPROPS_LOGIN_REGISTER";//ACTION_SET_COMPLETE_REGISTRATION
var ACT_STATS_CHANGE="ACT_STATS_CHANGE";

/***/ }),
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTheme__ = __webpack_require__(135);


function useTheme() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["g" /* useTheme */])() || __WEBPACK_IMPORTED_MODULE_1__defaultTheme__["a" /* default */];
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var _sendAuthHeader=true;var _env="PROD";//Example constans for firebase
var API_KEY="AIzaSyAVWIoiYTaZhU_rPiz9Eonze1TE9xStLmY";var AUTH_DOMAIN="hangover-prod.firebaseapp.com";var DATABASE_URL="https://hangover-prod.firebaseio.com";var STORAGE_BUCKET="hangover-prod.appspot.com";var MESSAGING_SENDER_ID="993782657168";var PRODUCT_ID=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_APP_DISPLAY_NAME":"Hangover","REACT_APP_ENVIRONMENT":"PROD","REACT_APP_API_BASE":"https://us-central1-hangover-prod.cloudfunctions.net/api","REACT_APP_API_BASE_V2":"https://us-central1-hangover-prod.cloudfunctions.net/api_v2","REACT_APP_API_KEY":"AIzaSyAVWIoiYTaZhU_rPiz9Eonze1TE9xStLmY","REACT_APP_AUTH_DOMAIN":"hangover-prod.firebaseapp.com","REACT_APP_DATABASE_URL":"https://hangover-prod.firebaseio.com","REACT_APP_STORAGE_BUCKET":"hangover-prod.appspot.com","REACT_APP_MESSAGING_SENDER_ID":"993782657168","REACT_APP_PRODUCT_ID":"hangover","REACT_APP_USER_VERIFIED":"on","REACT_APP_HAS_BIRTHDATE_MIGRATED":"true","REACT_APP_HAS_LOYALY_ACTIVE":"inactive","REACT_APP_EXCEL_TEMPLATE":"https://firebasestorage.googleapis.com/v0/b/leparc-prod.appspot.com/o/template%2FTemplateCargaMasiva.xlsx?alt=media&token=4a5394db-a9a0-4901-811e-2d41a5212169"}).PRODUCT_ID;var EXCEL_TEMPLATE="https://firebasestorage.googleapis.com/v0/b/leparc-prod.appspot.com/o/template%2FTemplateCargaMasiva.xlsx?alt=media&token=4a5394db-a9a0-4901-811e-2d41a5212169";var HAS_LOYALY_ACTIVE="inactive";var USER_VERIFIED="on";//Variable para saber si deben agregarse o no la posibilidad de verificar usuario y hacer ventas solo a usuarios verificados
//Example variable
var URL_PRODUCTS="products";var DUMMY="dummy";var Settings=function(){function Settings(){_classCallCheck(this,Settings);}_createClass(Settings,null,[{key:"env",get:function get(){return _env;},set:function set(value){_env=value;}},{key:"SERVICE_DOMAIN",get:function get(){return "https://us-central1-hangover-prod.cloudfunctions.net/api";}},{key:"SERVICE_DOMAIN_V2",get:function get(){return "https://us-central1-hangover-prod.cloudfunctions.net/api_v2";}},{key:"API_KEY",get:function get(){return API_KEY;}},{key:"AUTH_DOMAIN",get:function get(){return AUTH_DOMAIN;}},{key:"DATABASE_URL",get:function get(){return DATABASE_URL;}},{key:"STORAGE_BUCKET",get:function get(){return STORAGE_BUCKET;}},{key:"MESSAGING_SENDER_ID",get:function get(){return MESSAGING_SENDER_ID;}},{key:"PRODUCT_ID",get:function get(){return PRODUCT_ID;}},{key:"EXCEL_TEMPLATE",get:function get(){return EXCEL_TEMPLATE;}},{key:"sendAuthHeader",get:function get(){return _sendAuthHeader;},set:function set(value){_sendAuthHeader=value;}//Example getter
},{key:"productsEndpoint",get:function get(){return URL_PRODUCTS;}//Variable para saber si deben agregarse o no la posibilidad de verificar usuario y hacer ventas solo a usuarios verificados
},{key:"IS_USER_VERIFIED",get:function get(){return USER_VERIFIED=="on";}},{key:"hasLoyaly",get:function get(){return HAS_LOYALY_ACTIVE;}}]);return Settings;}();module.exports=Settings;

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.filter(function (f) {
    return f != null;
  }).reduce(function (acc, f) {
    if (typeof f !== 'function') {
      throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
    }

    if (acc === null) {
      return f;
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      f.apply(this, args);
    };
  }, null);
}

/* harmony default export */ __webpack_exports__["a"] = (createChainedFunction);

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hexToRgb */
/* unused harmony export rgbToHex */
/* unused harmony export hslToRgb */
/* unused harmony export decomposeColor */
/* unused harmony export recomposeColor */
/* harmony export (immutable) */ __webpack_exports__["d"] = getContrastRatio;
/* unused harmony export getLuminance */
/* harmony export (immutable) */ __webpack_exports__["b"] = emphasize;
/* harmony export (immutable) */ __webpack_exports__["c"] = fade;
/* harmony export (immutable) */ __webpack_exports__["a"] = darken;
/* harmony export (immutable) */ __webpack_exports__["e"] = lighten;
/* eslint-disable no-use-before-define */

/**
 * Returns a number whose value is limited to the given range.
 *
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value) {
  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (false) {
    if (value < min || value > max) {
      console.error("Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
    }
  }

  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 *
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
  var colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(function (n) {
      return n + n;
    });
  }

  return colors ? "rgb(".concat(colors.map(function (n) {
    return parseInt(n, 16);
  }).join(', '), ")") : '';
}

function intToHex(int) {
  var hex = int.toString(16);
  return hex.length === 1 ? "0".concat(hex) : hex;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 *
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  var _decomposeColor = decomposeColor(color),
      values = _decomposeColor.values;

  return "#".concat(values.map(function (n) {
    return intToHex(n);
  }).join(''));
}
/**
 * Converts a color from hsl format to rgb format.
 *
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  var _color = color,
      values = _color.values;
  var h = values[0];
  var s = values[1] / 100;
  var l = values[2] / 100;
  var a = s * Math.min(l, 1 - l);

  var f = function f(n) {
    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
  };

  var type = 'rgb';
  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type: type,
    values: rgb
  });
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */

function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  var marker = color.indexOf('(');
  var type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
  }

  var values = color.substring(marker + 1, color.length - 1).split(',');
  values = values.map(function (value) {
    return parseFloat(value);
  });
  return {
    type: type,
    values: values
  };
}
/**
 * Converts a color object with type and values to a string.
 *
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  var type = color.type;
  var values = color.values;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map(function (n, i) {
      return i < 3 ? parseInt(n, 10) : n;
    });
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = "".concat(values[1], "%");
    values[2] = "".concat(values[2], "%");
  }

  return "".concat(type, "(").concat(values.join(', '), ")");
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  var lumA = getLuminance(foreground);
  var lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(function (val) {
    val /= 255; // normalized

    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function emphasize(color) {
  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
}
/**
 * Set the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} value - value to set the alpha channel to in the range 0 -1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function fade(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  color.values[3] = value;
  return recomposeColor(color);
}
/**
 * Darkens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 *
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (var i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Size; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEVICE_SIZES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return State; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Style; });
var Size = {
  LARGE: 'large',
  SMALL: 'small',
  XSMALL: 'xsmall'
};
var SIZE_MAP = {
  large: 'lg',
  medium: 'md',
  small: 'sm',
  xsmall: 'xs',
  lg: 'lg',
  md: 'md',
  sm: 'sm',
  xs: 'xs'
};
var DEVICE_SIZES = ['lg', 'md', 'sm', 'xs'];
var State = {
  SUCCESS: 'success',
  WARNING: 'warning',
  DANGER: 'danger',
  INFO: 'info'
};
var Style = {
  DEFAULT: 'default',
  PRIMARY: 'primary',
  LINK: 'link',
  INVERSE: 'inverse'
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
}), 'Search');

exports.default = _default;

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 11H7.83l4.88-4.88c.39-.39.39-1.03 0-1.42a.9959.9959 0 00-1.41 0l-6.59 6.59c-.39.39-.39 1.02 0 1.41l6.59 6.59c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L7.83 13H19c.55 0 1-.45 1-1s-.45-1-1-1z"
}), 'ArrowBackRounded');

exports.default = _default;

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toConsumableArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__ = __webpack_require__(888);



function _toConsumableArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithoutHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableSpread__["a" /* default */])();
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonBase__ = __webpack_require__(947);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ButtonBase__["a"]; });


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var Index_1 = __webpack_require__(184);
var util_1 = __webpack_require__(21);
var Node_1 = __webpack_require__(53);
var LeafNode_1 = __webpack_require__(185);
var nodeFromJSON;
var MAX_NODE;
function setNodeFromJSON(val) {
    nodeFromJSON = val;
}
exports.setNodeFromJSON = setNodeFromJSON;
function setMaxNode(val) {
    MAX_NODE = val;
}
exports.setMaxNode = setMaxNode;
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var PriorityIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PriorityIndex, _super);
    function PriorityIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.compare = function (a, b) {
        var aPriority = a.node.getPriority();
        var bPriority = b.node.getPriority();
        var indexCmp = aPriority.compareTo(bPriority);
        if (indexCmp === 0) {
            return util_1.nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.isDefinedOn = function (node) {
        return !node.getPriority().isEmpty();
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.getPriority().equals(newNode.getPriority());
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.minPost = function () {
        return Node_1.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    PriorityIndex.prototype.maxPost = function () {
        return new Node_1.NamedNode(util_1.MAX_NAME, new LeafNode_1.LeafNode('[PRIORITY-POST]', MAX_NODE));
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    PriorityIndex.prototype.makePost = function (indexValue, name) {
        var priorityNode = nodeFromJSON(indexValue);
        return new Node_1.NamedNode(name, new LeafNode_1.LeafNode('[PRIORITY-POST]', priorityNode));
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    PriorityIndex.prototype.toString = function () {
        return '.priority';
    };
    return PriorityIndex;
}(Index_1.Index));
exports.PriorityIndex = PriorityIndex;
exports.PRIORITY_INDEX = new PriorityIndex();

//# sourceMappingURL=PriorityIndex.js.map


/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
// TODO: This module should be ElementChildren, and should use named exports.

/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid components".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @return {object} Object containing the ordered map of results.
 */

function map(children, func, context) {
  var index = 0;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return child;
    }

    return func.call(context, child, index++);
  });
}
/**
 * Iterates through children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for context.
 */


function forEach(children, func, context) {
  var index = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    func.call(context, child, index++);
  });
}
/**
 * Count the number of "valid components" in the Children container.
 *
 * @param {?*} children Children tree container.
 * @returns {number}
 */


function count(children) {
  var result = 0;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    ++result;
  });
  return result;
}
/**
 * Finds children that are typically specified as `props.children`,
 * but only iterates over children that are "valid components".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func.
 * @param {*} context Context for func.
 * @returns {array} of children that meet the func return statement
 */


function filter(children, func, context) {
  var index = 0;
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result.push(child);
    }
  });
  return result;
}

function find(children, func, context) {
  var index = 0;
  var result;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = child;
    }
  });
  return result;
}

function every(children, func, context) {
  var index = 0;
  var result = true;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (!func.call(context, child, index++)) {
      result = false;
    }
  });
  return result;
}

function some(children, func, context) {
  var index = 0;
  var result = false;
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (result) {
      return;
    }

    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    if (func.call(context, child, index++)) {
      result = true;
    }
  });
  return result;
}

function toArray(children) {
  var result = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(child)) {
      return;
    }

    result.push(child);
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  map: map,
  forEach: forEach,
  count: count,
  find: find,
  filter: filter,
  every: every,
  some: some,
  toArray: toArray
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = function() {};

if (false) {
  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
        '`warning(condition, format, ...args)` requires a warning ' +
        'message argument'
      );
    }

    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
      throw new Error(
        'The warning format should be able to uniquely identify this ' +
        'warning. Please, use a more descriptive format than: ' + format
      );
    }

    if (!condition) {
      var argIndex = 0;
      var message = 'Warning: ' +
        format.replace(/%s/g, function() {
          return args[argIndex++];
        });
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch(x) {}
    }
  };
}

module.exports = warning;


/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Typography__ = __webpack_require__(962);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Typography__["a"]; });


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SvgIcon__ = __webpack_require__(116);



function createSvgIcon(path, displayName) {
  var Component = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__SvgIcon__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref
    }), path);
  }));

  if (false) {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__SvgIcon__["default"].muiName;
  return Component;
}

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks () {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback (callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return (Object.getOwnPropertyNames(obj).length === 0);
        } else {
            var k;
            for (k in obj) {
                if (obj.hasOwnProperty(k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }

    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }

    function map(arr, fn) {
        var res = [], i;
        for (i = 0; i < arr.length; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty           : false,
            unusedTokens    : [],
            unusedInput     : [],
            overflow        : -2,
            charsLeftOver   : 0,
            nullInput       : false,
            invalidMonth    : null,
            invalidFormat   : false,
            userInvalidated : false,
            iso             : false,
            parsedDateParts : [],
            meridiem        : null,
            rfc2822         : false,
            weekdayMismatch : false
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this);
            var len = t.length >>> 0;

            for (var i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m);
            var parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            var isNowValid = !isNaN(m._d.getTime()) &&
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid = isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            }
            else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid (flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        }
        else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [];

    function copyConfig(to, from) {
        var i, prop, val;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentProperties.length > 0) {
            for (i = 0; i < momentProperties.length; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    var updateInProgress = false;

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment (obj) {
        return obj instanceof Moment || (obj != null && obj._isAMomentObject != null);
    }

    function absFloor (number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if ((dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false &&
                (typeof console !==  'undefined') && console.warn) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [];
                var arg;
                for (var i = 0; i < arguments.length; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (var key in arguments[0]) {
                            arg += key + ': ' + arguments[0][key] + ', ';
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + (new Error()).stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }

    function set (config) {
        var prop, i;
        for (i in config) {
            prop = config[i];
            if (isFunction(prop)) {
                this[i] = prop;
            } else {
                this['_' + i] = prop;
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' + (/\d{1,2}/).source);
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (hasOwnProp(parentConfig, prop) &&
                    !hasOwnProp(childConfig, prop) &&
                    isObject(parentConfig[prop])) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i, res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay : '[Today at] LT',
        nextDay : '[Tomorrow at] LT',
        nextWeek : 'dddd [at] LT',
        lastDay : '[Yesterday at] LT',
        lastWeek : '[Last] dddd [at] LT',
        sameElse : 'L'
    };

    function calendar (key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    var defaultLongDateFormat = {
        LTS  : 'h:mm:ss A',
        LT   : 'h:mm A',
        L    : 'MM/DD/YYYY',
        LL   : 'MMMM D, YYYY',
        LLL  : 'MMMM D, YYYY h:mm A',
        LLLL : 'dddd, MMMM D, YYYY h:mm A'
    };

    function longDateFormat (key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper.replace(/MMMM|MM|DD|dddd/g, function (val) {
            return val.slice(1);
        });

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate () {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d';
    var defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal (number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future : 'in %s',
        past   : '%s ago',
        s  : 'a few seconds',
        ss : '%d seconds',
        m  : 'a minute',
        mm : '%d minutes',
        h  : 'an hour',
        hh : '%d hours',
        d  : 'a day',
        dd : '%d days',
        M  : 'a month',
        MM : '%d months',
        y  : 'a year',
        yy : '%d years'
    };

    function relativeTime (number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return (isFunction(output)) ?
            output(number, withoutSuffix, string, isFuture) :
            output.replace(/%d/i, number);
    }

    function pastFuture (diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias (unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [];
        for (var u in unitsObj) {
            units.push({unit: u, priority: priorities[u]});
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }

    var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|YYYYYY|YYYYY|YYYY|YY|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g;

    var localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g;

    var formatFunctions = {};

    var formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken (token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '', i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var match1         = /\d/;            //       0 - 9
    var match2         = /\d\d/;          //      00 - 99
    var match3         = /\d{3}/;         //     000 - 999
    var match4         = /\d{4}/;         //    0000 - 9999
    var match6         = /[+-]?\d{6}/;    // -999999 - 999999
    var match1to2      = /\d\d?/;         //       0 - 99
    var match3to4      = /\d\d\d\d?/;     //     999 - 9999
    var match5to6      = /\d\d\d\d\d\d?/; //   99999 - 999999
    var match1to3      = /\d{1,3}/;       //       0 - 999
    var match1to4      = /\d{1,4}/;       //       0 - 9999
    var match1to6      = /[+-]?\d{1,6}/;  // -999999 - 999999

    var matchUnsigned  = /\d+/;           //       0 - inf
    var matchSigned    = /[+-]?\d+/;      //    -inf - inf

    var matchOffset    = /Z|[+-]\d\d:?\d\d/gi; // +00:00 -00:00 +0000 -0000 or Z
    var matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi; // +00 -00 +00:00 -00:00 +0000 -0000 or Z

    var matchTimestamp = /[+-]?\d+(\.\d{1,3})?/; // 123456789 123456789.123

    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    var matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i;

    var regexes = {};

    function addRegexToken (token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
            return (isStrict && strictRegex) ? strictRegex : regex;
        };
    }

    function getParseRegexForToken (token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken (token, callback) {
        var i, func = callback;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        for (i = 0; i < token.length; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken (token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0;
    var MONTH = 1;
    var DATE = 2;
    var HOUR = 3;
    var MINUTE = 4;
    var SECOND = 5;
    var MILLISECOND = 6;
    var WEEK = 7;
    var WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? '' + y : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY',   4],       0, 'year');
    addFormatToken(0, ['YYYYY',  5],       0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y',      matchSigned);
    addRegexToken('YY',     match1to2, match2);
    addRegexToken('YYYY',   match1to4, match4);
    addRegexToken('YYYYY',  match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear () {
        return isLeapYear(this.year());
    }

    function makeGetSet (unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get (mom, unit) {
        return mom.isValid() ?
            mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]() : NaN;
    }

    function set$1 (mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (unit === 'FullYear' && isLeapYear(mom.year()) && mom.month() === 1 && mom.date() === 29) {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value, mom.month(), daysInMonth(value, mom.month()));
            }
            else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet (units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }


    function stringSet (units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units);
            for (var i = 0; i < prioritized.length; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? (isLeapYear(year) ? 29 : 28) : (31 - modMonth % 7 % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M',    match1to2);
    addRegexToken('MM',   match1to2, match2);
    addRegexToken('MMM',  function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/;
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_');
    function localeMonths (m, format) {
        if (!m) {
            return isArray(this._months) ? this._months :
                this._months['standalone'];
        }
        return isArray(this._months) ? this._months[m.month()] :
            this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }

    var defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_');
    function localeMonthsShort (m, format) {
        if (!m) {
            return isArray(this._monthsShort) ? this._monthsShort :
                this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] :
            this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse (monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
                return i;
            } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth (mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth (value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth () {
        return daysInMonth(this.year(), this.month());
    }

    var defaultMonthsShortRegex = matchWord;
    function monthsShortRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict ?
                this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }

    var defaultMonthsRegex = matchWord;
    function monthsRegex (isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict ?
                this._monthsStrictRegex : this._monthsRegex;
        }
    }

    function computeMonthsParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }

    function createDate (y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate (y) {
        var date;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            var args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear, resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek, resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w',  match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W',  match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });

    // HELPERS

    // LOCALES

    function localeWeek (mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow : 0, // Sunday is the first day of the week.
        doy : 6  // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek () {
        return this._week.dow;
    }

    function localeFirstDayOfYear () {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek (input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek (input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d',    match1to2);
    addRegexToken('e',    match1to2);
    addRegexToken('E',    match1to2);
    addRegexToken('dd',   function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd',   function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd',   function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays (ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_');
    function localeWeekdays (m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays :
            this._weekdays[(m && m !== true && this._weekdays.isFormat.test(format)) ? 'format' : 'standalone'];
        return (m === true) ? shiftWeekdays(weekdays, this._week.dow)
            : (m) ? weekdays[m.day()] : weekdays;
    }

    var defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_');
    function localeWeekdaysShort (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : (m) ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }

    var defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_');
    function localeWeekdaysMin (m) {
        return (m === true) ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : (m) ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse (weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek (input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    var defaultWeekdaysRegex = matchWord;
    function weekdaysRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict ?
                this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }

    var defaultWeekdaysShortRegex = matchWord;
    function weekdaysShortRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict ?
                this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }

    var defaultWeekdaysMinRegex = matchWord;
    function weekdaysMinRegex (isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict ?
                this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }


    function computeWeekdaysParse () {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [],
            i, mom, minp, shortp, longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = this.weekdaysMin(mom, '');
            shortp = this.weekdaysShort(mom, '');
            longp = this.weekdays(mom, '');
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 7; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2);
    });

    function meridiem (token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem (isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a',  matchMeridiem);
    addRegexToken('A',  matchMeridiem);
    addRegexToken('H',  match1to2);
    addRegexToken('h',  match1to2);
    addRegexToken('k',  match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4;
        var pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM (input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return ((input + '').toLowerCase().charAt(0) === 'p');
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i;
    function localeMeridiem (hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }


    // MOMENTS

    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    var getSetHour = makeGetSet('Hours', true);

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse
    };

    // internal storage for locale config files
    var locales = {};
    var localeFamilies = {};
    var globalLocale;

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (next && next.length >= j && compareArrays(split, next, true) >= j - 1) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function loadLocale(name) {
        var oldLocale = null;
        // TODO: Find a better way to register and load all the locales in Node
        if (!locales[name] && (typeof module !== 'undefined') &&
                module && module.exports) {
            try {
                oldLocale = globalLocale._abbr;
                var aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {}
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale (key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            }
            else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            }
            else {
                if ((typeof console !==  'undefined') && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn('Locale ' + key +  ' not found. Did you forget to load it?');
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale (name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride',
                        'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);


            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale, tmpLocale, parentConfig = baseConfig;
            // MERGE
            tmpLocale = loadLocale(name);
            if (tmpLocale != null) {
                parentConfig = tmpLocale._config;
            }
            config = mergeConfigs(parentConfig, config);
            locale = new Locale(config);
            locale.parentLocale = locales[name];
            locales[name] = locale;

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale (key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow (m) {
        var overflow;
        var a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH]       < 0 || a[MONTH]       > 11  ? MONTH :
                a[DATE]        < 1 || a[DATE]        > daysInMonth(a[YEAR], a[MONTH]) ? DATE :
                a[HOUR]        < 0 || a[HOUR]        > 24 || (a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0)) ? HOUR :
                a[MINUTE]      < 0 || a[MINUTE]      > 59  ? MINUTE :
                a[SECOND]      < 0 || a[SECOND]      > 59  ? SECOND :
                a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND :
                -1;

            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray (config) {
        var i, date, input = [], currentDate, expectedWeekday, yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] = (config._a[i] == null) ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 &&
                config._a[MINUTE] === 0 &&
                config._a[SECOND] === 0 &&
                config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            var curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;
    var basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([\+\-]\d\d(?::?\d\d)?|\s*Z)?)?$/;

    var tzRegex = /Z|[+-]\d\d(?::?\d\d)?/;

    var isoDates = [
        ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
        ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
        ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
        ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
        ['YYYY-DDD', /\d{4}-\d{3}/],
        ['YYYY-MM', /\d{4}-\d\d/, false],
        ['YYYYYYMMDD', /[+-]\d{10}/],
        ['YYYYMMDD', /\d{8}/],
        // YYYYMM is NOT allowed by the standard
        ['GGGG[W]WWE', /\d{4}W\d{3}/],
        ['GGGG[W]WW', /\d{4}W\d{2}/, false],
        ['YYYYDDD', /\d{7}/]
    ];

    // iso time formats and regexes
    var isoTimes = [
        ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
        ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
        ['HH:mm:ss', /\d\d:\d\d:\d\d/],
        ['HH:mm', /\d\d:\d\d/],
        ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
        ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
        ['HHmmss', /\d\d\d\d\d\d/],
        ['HHmm', /\d\d\d\d/],
        ['HH', /\d\d/]
    ];

    var aspNetJsonRegex = /^\/?Date\((\-?\d+)/i;

    // date from iso format
    function configFromISO(config) {
        var i, l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime, dateFormat, timeFormat, tzFormat;

        if (match) {
            getParsingFlags(config).iso = true;

            for (i = 0, l = isoDates.length; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimes.length; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    var rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/;

    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^)]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an indepentent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    var obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -4 * 60,
        EST: -5 * 60,
        CDT: -5 * 60,
        CST: -6 * 60,
        MDT: -6 * 60,
        MST: -7 * 60,
        PDT: -7 * 60,
        PST: -8 * 60
    };

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10);
            var m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i));
        if (match) {
            var parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from iso format or fallback
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);

        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
        'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
        'discouraged and will be removed in an upcoming major release. Please refer to ' +
        'http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i, parsedInput, tokens, token, skipped,
            stringLength = string.length,
            totalParsedInputLength = 0;

        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];

        for (i = 0; i < tokens.length; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            // console.log('token', token, 'parsedInput', parsedInput,
            //         'regex', getParseRegexForToken(token, config));
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                }
                else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            }
            else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

        configFromArray(config);
        checkOverflow(config);
    }


    function meridiemFixWrap (locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,

            scoreToBeat,
            i,
            currentScore;

        if (config._f.length === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < config._f.length; i++) {
            currentScore = 0;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (!isValid(tempConfig)) {
                continue;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (scoreToBeat == null || currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i);
        config._a = map([i.year, i.month, i.day || i.date, i.hour, i.minute, i.second, i.millisecond], function (obj) {
            return obj && parseInt(obj, 10);
        });

        configFromArray(config);
    }

    function createFromConfig (config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig (config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({nullInput: true});
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        }  else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC (input, format, locale, strict, isUTC) {
        var c = {};

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if ((isObject(input) && isObjectEmpty(input)) ||
                (isArray(input) && input.length === 0)) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal (input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
        'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other < this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    var prototypeMax = deprecate(
        'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
        function () {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) {
                return other > this ? this : other;
            } else {
                return createInvalid();
            }
        }
    );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max () {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +(new Date());
    };

    var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];

    function isDurationValid(m) {
        for (var key in m) {
            if (!(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
                return false;
            }
        }

        var unitHasDecimal = false;
        for (var i = 0; i < ordering.length; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration (duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds = +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days +
            weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months +
            quarters * 3 +
            years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration (obj) {
        return obj instanceof Duration;
    }

    function absRound (number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // FORMATTING

    function offset (token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset();
            var sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~(offset) % 60, 2);
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z',  matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher);

        if (matches === null) {
            return null;
        }

        var chunk   = matches[matches.length - 1] || [];
        var parts   = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        var minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ?
          0 :
          parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset (m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset() / 15) * 15;
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset (input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone (input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC (keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal (keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset () {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            }
            else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset (input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime () {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted () {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {};

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            var other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() &&
                compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal () {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset () {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc () {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(\-|\+)?(?:(\d*)[. ])?(\d+)\:(\d+)(?:\:(\d+)(\.\d*)?)?$/;

    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    var isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration (input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms : input._milliseconds,
                d  : input._days,
                M  : input._months
            };
        } else if (isNumber(input)) {
            duration = {};
            if (key) {
                duration[key] = input;
            } else {
                duration.milliseconds = input;
            }
        } else if (!!(match = aspNetRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y  : 0,
                d  : toInt(match[DATE])                         * sign,
                h  : toInt(match[HOUR])                         * sign,
                m  : toInt(match[MINUTE])                       * sign,
                s  : toInt(match[SECOND])                       * sign,
                ms : toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
            };
        } else if (!!(match = isoRegex.exec(input))) {
            sign = (match[1] === '-') ? -1 : 1;
            duration = {
                y : parseIso(match[2], sign),
                M : parseIso(match[3], sign),
                w : parseIso(match[4], sign),
                d : parseIso(match[5], sign),
                h : parseIso(match[6], sign),
                m : parseIso(match[7], sign),
                s : parseIso(match[8], sign)
            };
        } else if (duration == null) {// checks for null or undefined
            duration = {};
        } else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso (inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months = other.month() - base.month() +
            (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +(base.clone().add(res.months, 'M'));

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return {milliseconds: 0, months: 0};
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name  + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' +
                'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val; val = period; period = tmp;
            }

            val = typeof val === 'string' ? +val : val;
            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract (mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add      = createAdder(1, 'add');
    var subtract = createAdder(-1, 'subtract');

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' :
                diff < -1 ? 'lastWeek' :
                diff < 0 ? 'lastDay' :
                diff < 1 ? 'sameDay' :
                diff < 2 ? 'nextDay' :
                diff < 7 ? 'nextWeek' : 'sameElse';
    }

    function calendar$1 (time, formats) {
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse';

        var output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);

        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }

    function clone () {
        return new Moment(this);
    }

    function isAfter (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween (from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }

    function isSame (input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }

    function isSameOrAfter (input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore (input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff (input, units, asFloat) {
        var that,
            zoneDelta,
            output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year': output = monthDiff(this, that) / 12; break;
            case 'month': output = monthDiff(this, that); break;
            case 'quarter': output = monthDiff(this, that) / 3; break;
            case 'second': output = (this - that) / 1e3; break; // 1000
            case 'minute': output = (this - that) / 6e4; break; // 1000 * 60
            case 'hour': output = (this - that) / 36e5; break; // 1000 * 60 * 60
            case 'day': output = (this - that - zoneDelta) / 864e5; break; // 1000 * 60 * 60 * 24, negate dst
            case 'week': output = (this - that - zoneDelta) / 6048e5; break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default: output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff (a, b) {
        // difference in months
        var wholeMonthDiff = ((b.year() - a.year()) * 12) + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2, adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString () {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true;
        var m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect () {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment';
        var zone = '';
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        var prefix = '[' + func + '("]';
        var year = (0 <= this.year() && this.year() <= 9999) ? 'YYYY' : 'YYYYYY';
        var datetime = '-MM-DD[T]HH:mm:ss.SSS';
        var suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format (inputString) {
        if (!inputString) {
            inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({to: this, from: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow (withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to (time, withoutSuffix) {
        if (this.isValid() &&
                ((isMoment(time) && time.isValid()) ||
                 createLocal(time).isValid())) {
            return createDuration({from: this, to: time}).locale(this.locale()).humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow (withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale (key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData () {
        return this._locale;
    }

    var MS_PER_SECOND = 1000;
    var MS_PER_MINUTE = 60 * MS_PER_SECOND;
    var MS_PER_HOUR = 60 * MS_PER_MINUTE;
    var MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf (units) {
        var time;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        var startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf () {
        return this._d.valueOf() - ((this._offset || 0) * 60000);
    }

    function unix () {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate () {
        return new Date(this.valueOf());
    }

    function toArray () {
        var m = this;
        return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
    }

    function toObject () {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }

    function toJSON () {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2 () {
        return isValid(this);
    }

    function parsingFlags () {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt () {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken (token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg',     'weekYear');
    addWeekYearFormatToken('ggggg',    'weekYear');
    addWeekYearFormatToken('GGGG',  'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);


    // PARSING

    addRegexToken('G',      matchSigned);
    addRegexToken('g',      matchSigned);
    addRegexToken('GG',     match1to2, match2);
    addRegexToken('gg',     match1to2, match2);
    addRegexToken('GGGG',   match1to4, match4);
    addRegexToken('gggg',   match1to4, match4);
    addRegexToken('GGGGG',  match1to6, match6);
    addRegexToken('ggggg',  match1to6, match6);

    addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input,
                this.week(),
                this.weekday(),
                this.localeData()._week.dow,
                this.localeData()._week.doy);
    }

    function getSetISOWeekYear (input) {
        return getSetWeekYearHelper.call(this,
                input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }

    function getISOWeeksInYear () {
        return weeksInYear(this.year(), 1, 4);
    }

    function getWeeksInYear () {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter (input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D',  match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ?
          (locale._dayOfMonthOrdinalParse || locale._ordinalParse) :
          locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD',  match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear (input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add((input - dayOfYear), 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m',  match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s',  match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });


    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S',    match1to3, match1);
    addRegexToken('SS',   match1to3, match2);
    addRegexToken('SSS',  match1to3, match3);

    var token;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }
    // MOMENTS

    var getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z',  0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr () {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName () {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add               = add;
    proto.calendar          = calendar$1;
    proto.clone             = clone;
    proto.diff              = diff;
    proto.endOf             = endOf;
    proto.format            = format;
    proto.from              = from;
    proto.fromNow           = fromNow;
    proto.to                = to;
    proto.toNow             = toNow;
    proto.get               = stringGet;
    proto.invalidAt         = invalidAt;
    proto.isAfter           = isAfter;
    proto.isBefore          = isBefore;
    proto.isBetween         = isBetween;
    proto.isSame            = isSame;
    proto.isSameOrAfter     = isSameOrAfter;
    proto.isSameOrBefore    = isSameOrBefore;
    proto.isValid           = isValid$2;
    proto.lang              = lang;
    proto.locale            = locale;
    proto.localeData        = localeData;
    proto.max               = prototypeMax;
    proto.min               = prototypeMin;
    proto.parsingFlags      = parsingFlags;
    proto.set               = stringSet;
    proto.startOf           = startOf;
    proto.subtract          = subtract;
    proto.toArray           = toArray;
    proto.toObject          = toObject;
    proto.toDate            = toDate;
    proto.toISOString       = toISOString;
    proto.inspect           = inspect;
    proto.toJSON            = toJSON;
    proto.toString          = toString;
    proto.unix              = unix;
    proto.valueOf           = valueOf;
    proto.creationData      = creationData;
    proto.year       = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear    = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month       = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week           = proto.weeks        = getSetWeek;
    proto.isoWeek        = proto.isoWeeks     = getSetISOWeek;
    proto.weeksInYear    = getWeeksInYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.date       = getSetDayOfMonth;
    proto.day        = proto.days             = getSetDayOfWeek;
    proto.weekday    = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear  = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset            = getSetOffset;
    proto.utc                  = setOffsetToUTC;
    proto.local                = setOffsetToLocal;
    proto.parseZone            = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST                = isDaylightSavingTime;
    proto.isLocal              = isLocal;
    proto.isUtcOffset          = isUtcOffset;
    proto.isUtc                = isUtc;
    proto.isUTC                = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates  = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto.years  = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto.zone   = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);

    function createUnix (input) {
        return createLocal(input * 1000);
    }

    function createInZone () {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat (string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar        = calendar;
    proto$1.longDateFormat  = longDateFormat;
    proto$1.invalidDate     = invalidDate;
    proto$1.ordinal         = ordinal;
    proto$1.preparse        = preParsePostFormat;
    proto$1.postformat      = preParsePostFormat;
    proto$1.relativeTime    = relativeTime;
    proto$1.pastFuture      = pastFuture;
    proto$1.set             = set;

    proto$1.months            =        localeMonths;
    proto$1.monthsShort       =        localeMonthsShort;
    proto$1.monthsParse       =        localeMonthsParse;
    proto$1.monthsRegex       = monthsRegex;
    proto$1.monthsShortRegex  = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays       =        localeWeekdays;
    proto$1.weekdaysMin    =        localeWeekdaysMin;
    proto$1.weekdaysShort  =        localeWeekdaysShort;
    proto$1.weekdaysParse  =        localeWeekdaysParse;

    proto$1.weekdaysRegex       =        weekdaysRegex;
    proto$1.weekdaysShortRegex  =        weekdaysShortRegex;
    proto$1.weekdaysMinRegex    =        weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1 (format, index, field, setter) {
        var locale = getLocale();
        var utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl (format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i;
        var out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl (localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0;

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        var i;
        var out = [];
        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths (format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort (format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin (localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal : function (number) {
            var b = number % 10,
                output = (toInt(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
            return number + output;
        }
    });

    // Side effect imports

    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);

    var mathAbs = Math.abs;

    function abs () {
        var data           = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days         = mathAbs(this._days);
        this._months       = mathAbs(this._months);

        data.milliseconds  = mathAbs(data.milliseconds);
        data.seconds       = mathAbs(data.seconds);
        data.minutes       = mathAbs(data.minutes);
        data.hours         = mathAbs(data.hours);
        data.months        = mathAbs(data.months);
        data.years         = mathAbs(data.years);

        return this;
    }

    function addSubtract$1 (duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days         += direction * other._days;
        duration._months       += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1 (input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1 (input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil (number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble () {
        var milliseconds = this._milliseconds;
        var days         = this._days;
        var months       = this._months;
        var data         = this._data;
        var seconds, minutes, hours, years, monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!((milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0))) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds           = absFloor(milliseconds / 1000);
        data.seconds      = seconds % 60;

        minutes           = absFloor(seconds / 60);
        data.minutes      = minutes % 60;

        hours             = absFloor(minutes / 60);
        data.hours        = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days   = days;
        data.months = months;
        data.years  = years;

        return this;
    }

    function daysToMonths (days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }

    function monthsToDays (months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }

    function as (units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days;
        var months;
        var milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':   return months;
                case 'quarter': return months / 3;
                case 'year':    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week'   : return days / 7     + milliseconds / 6048e5;
                case 'day'    : return days         + milliseconds / 864e5;
                case 'hour'   : return days * 24    + milliseconds / 36e5;
                case 'minute' : return days * 1440  + milliseconds / 6e4;
                case 'second' : return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond': return Math.floor(days * 864e5) + milliseconds;
                default: throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1 () {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs (alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms');
    var asSeconds      = makeAs('s');
    var asMinutes      = makeAs('m');
    var asHours        = makeAs('h');
    var asDays         = makeAs('d');
    var asWeeks        = makeAs('w');
    var asMonths       = makeAs('M');
    var asQuarters     = makeAs('Q');
    var asYears        = makeAs('y');

    function clone$1 () {
        return createDuration(this);
    }

    function get$2 (units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds');
    var seconds      = makeGetter('seconds');
    var minutes      = makeGetter('minutes');
    var hours        = makeGetter('hours');
    var days         = makeGetter('days');
    var months       = makeGetter('months');
    var years        = makeGetter('years');

    function weeks () {
        return absFloor(this.days() / 7);
    }

    var round = Math.round;
    var thresholds = {
        ss: 44,         // a few seconds to seconds
        s : 45,         // seconds to minute
        m : 45,         // minutes to hour
        h : 22,         // hours to day
        d : 26,         // days to month
        M : 11          // months to year
    };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1 (posNegDuration, withoutSuffix, locale) {
        var duration = createDuration(posNegDuration).abs();
        var seconds  = round(duration.as('s'));
        var minutes  = round(duration.as('m'));
        var hours    = round(duration.as('h'));
        var days     = round(duration.as('d'));
        var months   = round(duration.as('M'));
        var years    = round(duration.as('y'));

        var a = seconds <= thresholds.ss && ['s', seconds]  ||
                seconds < thresholds.s   && ['ss', seconds] ||
                minutes <= 1             && ['m']           ||
                minutes < thresholds.m   && ['mm', minutes] ||
                hours   <= 1             && ['h']           ||
                hours   < thresholds.h   && ['hh', hours]   ||
                days    <= 1             && ['d']           ||
                days    < thresholds.d   && ['dd', days]    ||
                months  <= 1             && ['M']           ||
                months  < thresholds.M   && ['MM', months]  ||
                years   <= 1             && ['y']           || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding (roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof(roundingFunction) === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold (threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize (withSuffix) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var locale = this.localeData();
        var output = relativeTime$1(this, !withSuffix, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return ((x > 0) - (x < 0)) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000;
        var days         = abs$1(this._days);
        var months       = abs$1(this._months);
        var minutes, hours, years;

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes           = absFloor(seconds / 60);
        hours             = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years  = absFloor(months / 12);
        months %= 12;


        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        var Y = years;
        var M = months;
        var D = days;
        var h = hours;
        var m = minutes;
        var s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        var total = this.asSeconds();

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        var totalSign = total < 0 ? '-' : '';
        var ymSign = sign(this._months) !== sign(total) ? '-' : '';
        var daysSign = sign(this._days) !== sign(total) ? '-' : '';
        var hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return totalSign + 'P' +
            (Y ? ymSign + Y + 'Y' : '') +
            (M ? ymSign + M + 'M' : '') +
            (D ? daysSign + D + 'D' : '') +
            ((h || m || s) ? 'T' : '') +
            (h ? hmsSign + h + 'H' : '') +
            (m ? hmsSign + m + 'M' : '') +
            (s ? hmsSign + s + 'S' : '');
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid        = isValid$1;
    proto$2.abs            = abs;
    proto$2.add            = add$1;
    proto$2.subtract       = subtract$1;
    proto$2.as             = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds      = asSeconds;
    proto$2.asMinutes      = asMinutes;
    proto$2.asHours        = asHours;
    proto$2.asDays         = asDays;
    proto$2.asWeeks        = asWeeks;
    proto$2.asMonths       = asMonths;
    proto$2.asQuarters     = asQuarters;
    proto$2.asYears        = asYears;
    proto$2.valueOf        = valueOf$1;
    proto$2._bubble        = bubble;
    proto$2.clone          = clone$1;
    proto$2.get            = get$2;
    proto$2.milliseconds   = milliseconds;
    proto$2.seconds        = seconds;
    proto$2.minutes        = minutes;
    proto$2.hours          = hours;
    proto$2.days           = days;
    proto$2.weeks          = weeks;
    proto$2.months         = months;
    proto$2.years          = years;
    proto$2.humanize       = humanize;
    proto$2.toISOString    = toISOString$1;
    proto$2.toString       = toISOString$1;
    proto$2.toJSON         = toISOString$1;
    proto$2.locale         = locale;
    proto$2.localeData     = localeData;

    proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
    proto$2.lang = lang;

    // Side effect imports

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input, 10) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    // Side effect imports


    hooks.version = '2.24.0';

    setHookCallback(createLocal);

    hooks.fn                    = proto;
    hooks.min                   = min;
    hooks.max                   = max;
    hooks.now                   = now;
    hooks.utc                   = createUTC;
    hooks.unix                  = createUnix;
    hooks.months                = listMonths;
    hooks.isDate                = isDate;
    hooks.locale                = getSetGlobalLocale;
    hooks.invalid               = createInvalid;
    hooks.duration              = createDuration;
    hooks.isMoment              = isMoment;
    hooks.weekdays              = listWeekdays;
    hooks.parseZone             = createInZone;
    hooks.localeData            = getLocale;
    hooks.isDuration            = isDuration;
    hooks.monthsShort           = listMonthsShort;
    hooks.weekdaysMin           = listWeekdaysMin;
    hooks.defineLocale          = defineLocale;
    hooks.updateLocale          = updateLocale;
    hooks.locales               = listLocales;
    hooks.weekdaysShort         = listWeekdaysShort;
    hooks.normalizeUnits        = normalizeUnits;
    hooks.relativeTimeRounding  = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat        = getCalendarFormat;
    hooks.prototype             = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',             // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',  // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',   // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD',                             // <input type="date" />
        TIME: 'HH:mm',                                  // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss',                       // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS',                        // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW',                             // <input type="week" />
        MONTH: 'YYYY-MM'                                // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(455)(module)))

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var SortedMap_1 = __webpack_require__(186);
var Node_1 = __webpack_require__(53);
var snap_1 = __webpack_require__(466);
var PriorityIndex_1 = __webpack_require__(42);
var KeyIndex_1 = __webpack_require__(145);
var IndexMap_1 = __webpack_require__(468);
var LeafNode_1 = __webpack_require__(185);
var comparators_1 = __webpack_require__(470);
// TODO: For memory savings, don't store priorityNode_ if it's empty.
var EMPTY_NODE;
/**
 * ChildrenNode is a class for storing internal nodes in a DataSnapshot
 * (i.e. nodes with children).  It implements Node and stores the
 * list of children in the children property, sorted by child name.
 *
 * @constructor
 * @implements {Node}
 */
var ChildrenNode = /** @class */ (function () {
    /**
     *
     * @param {!SortedMap.<string, !Node>} children_ List of children
     * of this node..
     * @param {?Node} priorityNode_ The priority of this node (as a snapshot node).
     * @param {!IndexMap} indexMap_
     */
    function ChildrenNode(children_, priorityNode_, indexMap_) {
        this.children_ = children_;
        this.priorityNode_ = priorityNode_;
        this.indexMap_ = indexMap_;
        this.lazyHash_ = null;
        /**
         * Note: The only reason we allow null priority is for EMPTY_NODE, since we can't use
         * EMPTY_NODE as the priority of EMPTY_NODE.  We might want to consider making EMPTY_NODE its own
         * class instead of an empty ChildrenNode.
         */
        if (this.priorityNode_) {
            snap_1.validatePriorityNode(this.priorityNode_);
        }
        if (this.children_.isEmpty()) {
            util_1.assert(!this.priorityNode_ || this.priorityNode_.isEmpty(), 'An empty node cannot have a priority');
        }
    }
    Object.defineProperty(ChildrenNode, "EMPTY_NODE", {
        get: function () {
            return (EMPTY_NODE ||
                (EMPTY_NODE = new ChildrenNode(new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), null, IndexMap_1.IndexMap.Default)));
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    ChildrenNode.prototype.isLeafNode = function () {
        return false;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPriority = function () {
        return this.priorityNode_ || EMPTY_NODE;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updatePriority = function (newPriorityNode) {
        if (this.children_.isEmpty()) {
            // Don't allow priorities on empty nodes
            return this;
        }
        else {
            return new ChildrenNode(this.children_, newPriorityNode, this.indexMap_);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.getPriority();
        }
        else {
            var child = this.children_.get(childName);
            return child === null ? EMPTY_NODE : child;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getChild = function (path) {
        var front = path.getFront();
        if (front === null)
            return this;
        return this.getImmediateChild(front).getChild(path.popFront());
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hasChild = function (childName) {
        return this.children_.get(childName) !== null;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        util_1.assert(newChildNode, 'We should always be passing snapshot nodes');
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else {
            var namedNode = new Node_1.NamedNode(childName, newChildNode);
            var newChildren = void 0, newIndexMap = void 0, newPriority = void 0;
            if (newChildNode.isEmpty()) {
                newChildren = this.children_.remove(childName);
                newIndexMap = this.indexMap_.removeFromIndexes(namedNode, this.children_);
            }
            else {
                newChildren = this.children_.insert(childName, newChildNode);
                newIndexMap = this.indexMap_.addToIndexes(namedNode, this.children_);
            }
            newPriority = newChildren.isEmpty() ? EMPTY_NODE : this.priorityNode_;
            return new ChildrenNode(newChildren, newPriority, newIndexMap);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else {
            util_1.assert(path.getFront() !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            var newImmediateChild = this.getImmediateChild(front).updateChild(path.popFront(), newChildNode);
            return this.updateImmediateChild(front, newImmediateChild);
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.isEmpty = function () {
        return this.children_.isEmpty();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.numChildren = function () {
        return this.children_.count();
    };
    /** @inheritDoc */
    ChildrenNode.prototype.val = function (exportFormat) {
        if (this.isEmpty())
            return null;
        var obj = {};
        var numKeys = 0, maxKey = 0, allIntegerKeys = true;
        this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
            obj[key] = childNode.val(exportFormat);
            numKeys++;
            if (allIntegerKeys && ChildrenNode.INTEGER_REGEXP_.test(key)) {
                maxKey = Math.max(maxKey, Number(key));
            }
            else {
                allIntegerKeys = false;
            }
        });
        if (!exportFormat && allIntegerKeys && maxKey < 2 * numKeys) {
            // convert to array.
            var array = [];
            for (var key in obj)
                array[key] = obj[key];
            return array;
        }
        else {
            if (exportFormat && !this.getPriority().isEmpty()) {
                obj['.priority'] = this.getPriority().val();
            }
            return obj;
        }
    };
    /** @inheritDoc */
    ChildrenNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash_1 = '';
            if (!this.getPriority().isEmpty())
                toHash_1 +=
                    'priority:' +
                        snap_1.priorityHashText(this.getPriority().val()) +
                        ':';
            this.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
                var childHash = childNode.hash();
                if (childHash !== '')
                    toHash_1 += ':' + key + ':' + childHash;
            });
            this.lazyHash_ = toHash_1 === '' ? '' : util_2.sha1(toHash_1);
        }
        return this.lazyHash_;
    };
    /** @inheritDoc */
    ChildrenNode.prototype.getPredecessorChildName = function (childName, childNode, index) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            var predecessor = idx.getPredecessorKey(new Node_1.NamedNode(childName, childNode));
            return predecessor ? predecessor.name : null;
        }
        else {
            return this.children_.getPredecessorKey(childName);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getFirstChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var minKey = idx.minKey();
            return minKey && minKey.name;
        }
        else {
            return this.children_.minKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getFirstChild = function (indexDefinition) {
        var minKey = this.getFirstChildName(indexDefinition);
        if (minKey) {
            return new Node_1.NamedNode(minKey, this.children_.get(minKey));
        }
        else {
            return null;
        }
    };
    /**
     * Given an index, return the key name of the largest value we have, according to that index
     * @param {!Index} indexDefinition
     * @return {?string}
     */
    ChildrenNode.prototype.getLastChildName = function (indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            var maxKey = idx.maxKey();
            return maxKey && maxKey.name;
        }
        else {
            return this.children_.maxKey();
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {?NamedNode}
     */
    ChildrenNode.prototype.getLastChild = function (indexDefinition) {
        var maxKey = this.getLastChildName(indexDefinition);
        if (maxKey) {
            return new Node_1.NamedNode(maxKey, this.children_.get(maxKey));
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.forEachChild = function (index, action) {
        var idx = this.resolveIndex_(index);
        if (idx) {
            return idx.inorderTraversal(function (wrappedNode) {
                return action(wrappedNode.name, wrappedNode.node);
            });
        }
        else {
            return this.children_.inorderTraversal(action);
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {SortedMapIterator}
     */
    ChildrenNode.prototype.getIterator = function (indexDefinition) {
        return this.getIteratorFrom(indexDefinition.minPost(), indexDefinition);
    };
    /**
     *
     * @param {!NamedNode} startPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getIteratorFrom = function (startPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getIteratorFrom(startPost, function (key) { return key; });
        }
        else {
            var iterator = this.children_.getIteratorFrom(startPost.name, Node_1.NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, startPost) < 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIterator = function (indexDefinition) {
        return this.getReverseIteratorFrom(indexDefinition.maxPost(), indexDefinition);
    };
    /**
     * @param {!NamedNode} endPost
     * @param {!Index} indexDefinition
     * @return {!SortedMapIterator}
     */
    ChildrenNode.prototype.getReverseIteratorFrom = function (endPost, indexDefinition) {
        var idx = this.resolveIndex_(indexDefinition);
        if (idx) {
            return idx.getReverseIteratorFrom(endPost, function (key) {
                return key;
            });
        }
        else {
            var iterator = this.children_.getReverseIteratorFrom(endPost.name, Node_1.NamedNode.Wrap);
            var next = iterator.peek();
            while (next != null && indexDefinition.compare(next, endPost) > 0) {
                iterator.getNext();
                next = iterator.peek();
            }
            return iterator;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.compareTo = function (other) {
        if (this.isEmpty()) {
            if (other.isEmpty()) {
                return 0;
            }
            else {
                return -1;
            }
        }
        else if (other.isLeafNode() || other.isEmpty()) {
            return 1;
        }
        else if (other === exports.MAX_NODE) {
            return -1;
        }
        else {
            // Must be another node with children.
            return 0;
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.withIndex = function (indexDefinition) {
        if (indexDefinition === KeyIndex_1.KEY_INDEX ||
            this.indexMap_.hasIndex(indexDefinition)) {
            return this;
        }
        else {
            var newIndexMap = this.indexMap_.addIndex(indexDefinition, this.children_);
            return new ChildrenNode(this.children_, this.priorityNode_, newIndexMap);
        }
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.isIndexed = function (index) {
        return index === KeyIndex_1.KEY_INDEX || this.indexMap_.hasIndex(index);
    };
    /**
     * @inheritDoc
     */
    ChildrenNode.prototype.equals = function (other) {
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            return false;
        }
        else {
            var otherChildrenNode = other;
            if (!this.getPriority().equals(otherChildrenNode.getPriority())) {
                return false;
            }
            else if (this.children_.count() === otherChildrenNode.children_.count()) {
                var thisIter = this.getIterator(PriorityIndex_1.PRIORITY_INDEX);
                var otherIter = otherChildrenNode.getIterator(PriorityIndex_1.PRIORITY_INDEX);
                var thisCurrent = thisIter.getNext();
                var otherCurrent = otherIter.getNext();
                while (thisCurrent && otherCurrent) {
                    if (thisCurrent.name !== otherCurrent.name ||
                        !thisCurrent.node.equals(otherCurrent.node)) {
                        return false;
                    }
                    thisCurrent = thisIter.getNext();
                    otherCurrent = otherIter.getNext();
                }
                return thisCurrent === null && otherCurrent === null;
            }
            else {
                return false;
            }
        }
    };
    /**
     * Returns a SortedMap ordered by index, or null if the default (by-key) ordering can be used
     * instead.
     *
     * @private
     * @param {!Index} indexDefinition
     * @return {?SortedMap.<NamedNode, Node>}
     */
    ChildrenNode.prototype.resolveIndex_ = function (indexDefinition) {
        if (indexDefinition === KeyIndex_1.KEY_INDEX) {
            return null;
        }
        else {
            return this.indexMap_.get(indexDefinition.toString());
        }
    };
    /**
     * @private
     * @type {RegExp}
     */
    ChildrenNode.INTEGER_REGEXP_ = /^(0|[1-9]\d*)$/;
    return ChildrenNode;
}());
exports.ChildrenNode = ChildrenNode;
/**
 * @constructor
 * @extends {ChildrenNode}
 * @private
 */
var MaxNode = /** @class */ (function (_super) {
    tslib_1.__extends(MaxNode, _super);
    function MaxNode() {
        return _super.call(this, new SortedMap_1.SortedMap(comparators_1.NAME_COMPARATOR), ChildrenNode.EMPTY_NODE, IndexMap_1.IndexMap.Default) || this;
    }
    MaxNode.prototype.compareTo = function (other) {
        if (other === this) {
            return 0;
        }
        else {
            return 1;
        }
    };
    MaxNode.prototype.equals = function (other) {
        // Not that we every compare it, but MAX_NODE is only ever equal to itself
        return other === this;
    };
    MaxNode.prototype.getPriority = function () {
        return this;
    };
    MaxNode.prototype.getImmediateChild = function (childName) {
        return ChildrenNode.EMPTY_NODE;
    };
    MaxNode.prototype.isEmpty = function () {
        return false;
    };
    return MaxNode;
}(ChildrenNode));
exports.MaxNode = MaxNode;
/**
 * Marker that will sort higher than any other snapshot.
 * @type {!MAX_NODE}
 * @const
 */
exports.MAX_NODE = new MaxNode();
Object.defineProperties(Node_1.NamedNode, {
    MIN: {
        value: new Node_1.NamedNode(util_2.MIN_NAME, ChildrenNode.EMPTY_NODE)
    },
    MAX: {
        value: new Node_1.NamedNode(util_2.MAX_NAME, exports.MAX_NODE)
    }
});
/**
 * Reference Extensions
 */
KeyIndex_1.KeyIndex.__EMPTY_NODE = ChildrenNode.EMPTY_NODE;
LeafNode_1.LeafNode.__childrenNodeConstructor = ChildrenNode;
snap_1.setMaxNode(exports.MAX_NODE);
PriorityIndex_1.setMaxNode(exports.MAX_NODE);

//# sourceMappingURL=ChildrenNode.js.map


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(638);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(640);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(641);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(330);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__Route__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(225);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_4__Router__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(643);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(644);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__Switch__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(328);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(226);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(645);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1166);


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["__extends"] = __extends;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (immutable) */ __webpack_exports__["__rest"] = __rest;
/* harmony export (immutable) */ __webpack_exports__["__decorate"] = __decorate;
/* harmony export (immutable) */ __webpack_exports__["__param"] = __param;
/* harmony export (immutable) */ __webpack_exports__["__metadata"] = __metadata;
/* harmony export (immutable) */ __webpack_exports__["__awaiter"] = __awaiter;
/* harmony export (immutable) */ __webpack_exports__["__generator"] = __generator;
/* harmony export (immutable) */ __webpack_exports__["__exportStar"] = __exportStar;
/* harmony export (immutable) */ __webpack_exports__["__values"] = __values;
/* harmony export (immutable) */ __webpack_exports__["__read"] = __read;
/* harmony export (immutable) */ __webpack_exports__["__spread"] = __spread;
/* harmony export (immutable) */ __webpack_exports__["__await"] = __await;
/* harmony export (immutable) */ __webpack_exports__["__asyncGenerator"] = __asyncGenerator;
/* harmony export (immutable) */ __webpack_exports__["__asyncDelegator"] = __asyncDelegator;
/* harmony export (immutable) */ __webpack_exports__["__asyncValues"] = __asyncValues;
/* harmony export (immutable) */ __webpack_exports__["__makeTemplateObject"] = __makeTemplateObject;
/* harmony export (immutable) */ __webpack_exports__["__importStar"] = __importStar;
/* harmony export (immutable) */ __webpack_exports__["__importDefault"] = __importDefault;
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = Object.setPrototypeOf ||
    ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
    function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = Object.assign || function __assign(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);  }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { if (o[n]) i[n] = function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; }; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator];
    return m ? m.call(o) : typeof __values === "function" ? __values(o) : o[Symbol.iterator]();
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 *
 * @param {!string} name
 * @param {!Node} node
 * @constructor
 * @struct
 */
var NamedNode = /** @class */ (function () {
    function NamedNode(name, node) {
        this.name = name;
        this.node = node;
    }
    /**
     *
     * @param {!string} name
     * @param {!Node} node
     * @return {NamedNode}
     */
    NamedNode.Wrap = function (name, node) {
        return new NamedNode(name, node);
    };
    return NamedNode;
}());
exports.NamedNode = NamedNode;

//# sourceMappingURL=Node.js.map


/***/ }),
/* 54 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 55 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(215)('wks');
var uid = __webpack_require__(156);
var Symbol = __webpack_require__(71).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export actionTypes */
/* unused harmony export arrayInsert */
/* unused harmony export arrayMove */
/* unused harmony export arrayPop */
/* unused harmony export arrayPush */
/* unused harmony export arrayRemove */
/* unused harmony export arrayRemoveAll */
/* unused harmony export arrayShift */
/* unused harmony export arraySplice */
/* unused harmony export arraySwap */
/* unused harmony export arrayUnshift */
/* unused harmony export autofill */
/* unused harmony export blur */
/* unused harmony export change */
/* unused harmony export clearAsyncError */
/* unused harmony export clearFields */
/* unused harmony export clearSubmitErrors */
/* unused harmony export destroy */
/* unused harmony export focus */
/* unused harmony export initialize */
/* unused harmony export registerField */
/* unused harmony export reset */
/* unused harmony export resetSection */
/* unused harmony export setSubmitFailed */
/* unused harmony export setSubmitSucceeded */
/* unused harmony export startAsyncValidation */
/* unused harmony export startSubmit */
/* unused harmony export stopAsyncValidation */
/* unused harmony export stopSubmit */
/* unused harmony export submit */
/* unused harmony export touch */
/* unused harmony export unregisterField */
/* unused harmony export untouch */
/* unused harmony export updateSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__actionTypes__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultShouldAsyncValidate__ = __webpack_require__(345);
/* unused harmony reexport defaultShouldAsyncValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultShouldValidate__ = __webpack_require__(346);
/* unused harmony reexport defaultShouldValidate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultShouldError__ = __webpack_require__(347);
/* unused harmony reexport defaultShouldError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultShouldWarn__ = __webpack_require__(348);
/* unused harmony reexport defaultShouldWarn */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Form__ = __webpack_require__(681);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormName__ = __webpack_require__(682);
/* unused harmony reexport FormName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormSection__ = __webpack_require__(683);
/* unused harmony reexport FormSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__SubmissionError__ = __webpack_require__(349);
/* unused harmony reexport SubmissionError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__propTypes__ = __webpack_require__(685);
/* unused harmony reexport propTypes */
/* unused harmony reexport fieldInputPropTypes */
/* unused harmony reexport fieldMetaPropTypes */
/* unused harmony reexport fieldPropTypes */
/* unused harmony reexport fieldArrayFieldsPropTypes */
/* unused harmony reexport fieldArrayMetaPropTypes */
/* unused harmony reexport fieldArrayPropTypes */
/* unused harmony reexport formPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Field__ = __webpack_require__(686);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_11__Field__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Fields__ = __webpack_require__(753);
/* unused harmony reexport Fields */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FieldArray__ = __webpack_require__(756);
/* unused harmony reexport FieldArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__formValueSelector__ = __webpack_require__(774);
/* unused harmony reexport formValueSelector */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__formValues__ = __webpack_require__(776);
/* unused harmony reexport formValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__getFormError__ = __webpack_require__(780);
/* unused harmony reexport getFormError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__getFormNames__ = __webpack_require__(782);
/* unused harmony reexport getFormNames */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__getFormValues__ = __webpack_require__(784);
/* unused harmony reexport getFormValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__getFormInitialValues__ = __webpack_require__(786);
/* unused harmony reexport getFormInitialValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__getFormSyncErrors__ = __webpack_require__(788);
/* unused harmony reexport getFormSyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__getFormMeta__ = __webpack_require__(790);
/* unused harmony reexport getFormMeta */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__getFormAsyncErrors__ = __webpack_require__(792);
/* unused harmony reexport getFormAsyncErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__getFormSyncWarnings__ = __webpack_require__(794);
/* unused harmony reexport getFormSyncWarnings */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__getFormSubmitErrors__ = __webpack_require__(796);
/* unused harmony reexport getFormSubmitErrors */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__isAsyncValidating__ = __webpack_require__(798);
/* unused harmony reexport isAsyncValidating */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__isDirty__ = __webpack_require__(800);
/* unused harmony reexport isDirty */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__isInvalid__ = __webpack_require__(802);
/* unused harmony reexport isInvalid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__isPristine__ = __webpack_require__(805);
/* unused harmony reexport isPristine */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__isValid__ = __webpack_require__(806);
/* unused harmony reexport isValid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__isSubmitting__ = __webpack_require__(807);
/* unused harmony reexport isSubmitting */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__hasSubmitSucceeded__ = __webpack_require__(809);
/* unused harmony reexport hasSubmitSucceeded */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__hasSubmitFailed__ = __webpack_require__(811);
/* unused harmony reexport hasSubmitFailed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__reduxForm__ = __webpack_require__(813);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_33__reduxForm__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__reducer__ = __webpack_require__(844);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_34__reducer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__values__ = __webpack_require__(847);
/* unused harmony reexport values */










// alias for propTypes


























var actionTypes = __WEBPACK_IMPORTED_MODULE_1__actionTypes__;
var arrayInsert = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayInsert;
var arrayMove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayMove;
var arrayPop = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPop;
var arrayPush = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayPush;
var arrayRemove = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemove;
var arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayRemoveAll;
var arrayShift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayShift;
var arraySplice = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySplice;
var arraySwap = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arraySwap;
var arrayUnshift = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].arrayUnshift;
var autofill = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].autofill;
var blur = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].blur;
var change = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].change;
var clearAsyncError = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearAsyncError;
var clearFields = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearFields;
var clearSubmitErrors = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].clearSubmitErrors;
var destroy = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].destroy;
var focus = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].focus;
var initialize = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].initialize;
var registerField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].registerField;
var reset = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].reset;
var resetSection = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].resetSection;
var setSubmitFailed = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitFailed;
var setSubmitSucceeded = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].setSubmitSucceeded;
var startAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startAsyncValidation;
var startSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].startSubmit;
var stopAsyncValidation = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopAsyncValidation;
var stopSubmit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].stopSubmit;
var submit = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].submit;
var touch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].touch;
var unregisterField = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].unregisterField;
var untouch = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].untouch;
var updateSyncWarnings = __WEBPACK_IMPORTED_MODULE_0__actions__["a" /* default */].updateSyncWarnings;

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/* harmony default export */ __webpack_exports__["a"] = (isArray);


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createGenerateClassName__ = __webpack_require__(245);
/* unused harmony reexport createGenerateClassName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__createStyles__ = __webpack_require__(875);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__createStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getThemeProps__ = __webpack_require__(386);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__getThemeProps__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jssPreset__ = __webpack_require__(387);
/* unused harmony reexport jssPreset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__makeStyles__ = __webpack_require__(247);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_5__makeStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeClasses__ = __webpack_require__(390);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_6__mergeClasses__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ServerStyleSheets__ = __webpack_require__(897);
/* unused harmony reexport ServerStyleSheets */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styled__ = __webpack_require__(899);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_8__styled__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StylesProvider__ = __webpack_require__(248);
/* unused harmony reexport StylesProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__ = __webpack_require__(901);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_10__ThemeProvider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__useTheme__ = __webpack_require__(134);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_11__useTheme__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__withStyles__ = __webpack_require__(903);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_12__withStyles__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withTheme__ = __webpack_require__(905);
/* unused harmony reexport withTheme */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_13__withTheme__["a"]; });
/** @license Material-UI v4.6.0
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/* Warning if there are several instances of @material-ui/styles */

if (false) {
  ponyfillGlobal['__@material-ui/styles-init__'] = ponyfillGlobal['__@material-ui/styles-init__'] || 0;

  if (ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
  }

  ponyfillGlobal['__@material-ui/styles-init__'] += 1;
}















/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Paper__ = __webpack_require__(929);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Paper__["a"]; });


/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(34);








var propTypes = {
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  onKeyDown: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  tabIndex: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * this is sort of silly but needed for Button
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'a'
};

function isTrivialHref(href) {
  return !href || href.trim() === '#';
}
/**
 * There are situations due to browser quirks or Bootstrap CSS where
 * an anchor tag is needed, when semantically a button tag is the
 * better choice. SafeAnchor ensures that when an anchor is used like a
 * button its accessible. It also emulates input `disabled` behavior for
 * links, which is usually desirable for Buttons, NavItems, MenuItems, etc.
 */


var SafeAnchor =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SafeAnchor, _React$Component);

  function SafeAnchor(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = SafeAnchor.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        href = _this$props.href,
        onClick = _this$props.onClick;

    if (disabled || isTrivialHref(href)) {
      event.preventDefault();
    }

    if (disabled) {
      event.stopPropagation();
      return;
    }

    if (onClick) {
      onClick(event);
    }
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (event.key === ' ') {
      event.preventDefault();
      this.handleClick(event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        disabled = _this$props2.disabled,
        onKeyDown = _this$props2.onKeyDown,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "disabled", "onKeyDown"]);

    if (isTrivialHref(props.href)) {
      props.role = props.role || 'button'; // we want to make sure there is a href attribute on the node
      // otherwise, the cursor incorrectly styled (except with role='button')

      props.href = props.href || '#';
    }

    if (disabled) {
      props.tabIndex = -1;
      props.style = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        pointerEvents: 'none'
      }, props.style);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      onClick: this.handleClick,
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(this.handleKeyDown, onKeyDown)
    }));
  };

  return SafeAnchor;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

SafeAnchor.propTypes = propTypes;
SafeAnchor.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SafeAnchor);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add');

exports.default = _default;

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(337);


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ __webpack_exports__["a"] = (root);


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export easing */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return duration; });
/* unused harmony export formatMs */
/* unused harmony export isString */
/* unused harmony export isNumber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);

// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
var easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

var duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};
var formatMs = function formatMs(milliseconds) {
  return "".concat(Math.round(milliseconds), "ms");
};
var isString = function isString(value) {
  return typeof value === 'string';
};
var isNumber = function isNumber(value) {
  return !isNaN(parseFloat(value));
};
/**
 * @param {string|Array} props
 * @param {object} param
 * @param {string} param.prop
 * @param {number} param.duration
 * @param {string} param.easing
 * @param {number} param.delay
 */

/* harmony default export */ __webpack_exports__["a"] = ({
  easing: easing,
  duration: duration,
  create: function create() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var _options$duration = options.duration,
        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
        _options$easing = options.easing,
        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
        _options$delay = options.delay,
        delay = _options$delay === void 0 ? 0 : _options$delay,
        other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["duration", "easing", "delay"]);

    if (false) {
      if (!isString(props) && !Array.isArray(props)) {
        console.error('Material-UI: argument "props" must be a string or Array.');
      }

      if (!isNumber(durationOption) && !isString(durationOption)) {
        console.error("Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
      }

      if (!isString(easingOption)) {
        console.error('Material-UI: argument "easing" must be a string.');
      }

      if (!isNumber(delay) && !isString(delay)) {
        console.error('Material-UI: argument "delay" must be a number or a string.');
      }

      if (Object.keys(other).length !== 0) {
        console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]"));
      }
    }

    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
    }).join(',');
  },
  getAutoHeightDuration: function getAutoHeightDuration(height) {
    if (!height) {
      return 0;
    }

    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AuthConfig__ = __webpack_require__(1168);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var AuthService=function(){function AuthService(){_classCallCheck(this,AuthService);}_createClass(AuthService,null,[{key:"registerAuthStateListener",value:function registerAuthStateListener(callback){return __WEBPACK_IMPORTED_MODULE_1__AuthConfig__["a" /* default */].FirebaseConnector.onChangeAuth(callback);}},{key:"login",value:function login(user){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var userData,error;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_1__AuthConfig__["a" /* default */].FirebaseConnector.login(user.email,user.password);case 3:userData=_context.sent;resolve(Object.assign({},userData,{app:["Nuevamente"]}));_context.next=13;break;case 7:_context.prev=7;_context.t0=_context["catch"](0);console.log("ERROR LOGIN",_context.t0);error={code:_context.t0.code,message:"No pudimos loguear el usuario ingresado"};if(_context.t0.code=="auth/invalid-password"||_context.t0.code=="auth/wrong-password"||_context.t0.code=="auth/user-not-found"){error.message="Usuario y/o constraseña incorrectos";}reject(error);case 13:case"end":return _context.stop();}}},_callee,_this,[[0,7]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"logout",value:function logout(){return __WEBPACK_IMPORTED_MODULE_1__AuthConfig__["a" /* default */].FirebaseConnector.logout();}},{key:"createAccount",value:function createAccount(user,onSuccess,onFail){__WEBPACK_IMPORTED_MODULE_1__AuthConfig__["a" /* default */].FirebaseConnector.createAccount(user,onSuccess,onFail);}},{key:"getToken",value:function getToken(){return __WEBPACK_IMPORTED_MODULE_1__AuthConfig__["a" /* default */].FirebaseConnector.getToken();}// pega contra firebase (usa FirebaseConnector)
// static forgotPassword(userEmail) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       let resp = AuthConfig.FirebaseConnector.forgotPassword(userEmail);
//       resolve(resp);
//     } catch (error) {
//       reject(error);
//     }
//   });
// }
// static confirmPasswordReset(code, password) {
//   return new Promise(async (resolve, reject) => {
//     try {
//       let resp = AuthConfig.FirebaseConnector.confirmPasswordReset(
//         code,
//         password
//       );
//       resolve(resp);
//     } catch (error) {
//       reject(error);
//     }
//   });
// }
}]);return AuthService;}();/* harmony default export */ __webpack_exports__["a"] = (AuthService);

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_Logger__ = __webpack_require__(1169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * Clase para hacer ajax requests
 * Devuelve una promesa con un json.
 *
 * let api = new APIConnector({timeout: 5000})
 * api.post('/api/user', {name: 'john doe', age:40})
 *    .then(response => {
 *    	if(response.ok()){
 *				console.log(response.body);
 *			} else {
 *				console.log(response.status, response.statusText, response.body)
 *      }
 *    })
 */// real nasty old approaches js function
function Response(status,statusText){var body=arguments.length>2&&arguments[2]!==undefined?arguments[2]:null;if(status===502||status===503||status===504){statusText="Error en la conexion con el servidor";}return{status:status,statusText:statusText,body:body,ok:function ok(){return status===200||status===202||status===204?true:false;},isSessionExpired:function isSessionExpired(){return status===401?true:false;}};}var logger=new __WEBPACK_IMPORTED_MODULE_0__common_Logger__["a" /* default */]("API-Connector");var Methods={HEAD:"HEAD",GET:"GET",POST:"POST",PUT:"PUT",PATCH:"PATCH",DELETE:"DELETE"};// Variable privada
var _defaultHeaders={// "Access-Control-Request-Headers":"Content-Type, Accept, Authorization, App",
// "Access-Control-Request-Method":"GET,POST, DELETE",
"Content-Type":"application/json"//,
// Accept: "application/json"
};var APIConnector=function(){function APIConnector(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,APIConnector);// vars
var _options$timeout=options.timeout,timeout=_options$timeout===undefined?0:_options$timeout,_options$debug=options.debug,debug=_options$debug===undefined?1:_options$debug;if(timeout)this._timeout=timeout;this._debug=debug;}/*
	 * Setter/getter for default headers
	 */_createClass(APIConnector,[{key:"head",/*
	 * All supported methods below
	 */value:function head(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.HEAD}));}},{key:"get",value:function get(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.GET}));}},{key:"post",value:function post(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.POST}));}},{key:"put",value:function put(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.PUT}));}},{key:"patch",value:function patch(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.PATCH}));}},{key:"delete",value:function _delete(uri){var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return this._request(uri,Object.assign({},args,{method:Methods.DELETE}));}/*
	 * Log funtions
	 */},{key:"logRequest",value:function logRequest(uri,options){if(!this._debug||this._debug<=1)return;var logs=[];// method log
logs.push("Request "+options.method+": \""+uri+"\"");// header log
var headers=Object.assign({},options.headers);if(headers.Authorization){headers.Authorization="Bearer [removed]";}logs.push("Headers: "+JSON.stringify(headers));// body log
if(options.body){var logBody="Body: "+JSON.stringify(options.body).substr(0,80);if(options.body.length>80)logBody+="...";logs.push(logBody);}// implode all array elements into a string and log it
logger.info(logs.join(", "));}},{key:"logResponse",value:function logResponse(method,uri,time){if(!this._debug)return;logger.info("Response "+method+": "+uri+" completed, took: "+(+new Date()-time)+"ms");}/*
	 * Read stream as text and parse into json
	 */},{key:"readResponse",value:function readResponse(response){return new Promise(function(resolve,reject){response.text().then(function(text){try{var json={};if(text&&text.length){json=JSON.parse(text);}resolve(Response(response.status,response.statusText,json));}catch(e){reject(Response(response.status,response.statusText,text));}}).catch(function(error){// nasty unknown error here...
logger.error("Unknown error trying to connect to server",error);reject(Response(400,"Error en la aplicación web. No es posible acceder a Internet."));});});}/**
   * Internal method that make (and handle) the request
   *
   * @param string uri
   * @param object args
   * @return Promise
   */},{key:"_request",value:function _request(uri){var _this=this;var args=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};var time=new Date();var method=args.method,_args$headers=args.headers,headers=_args$headers===undefined?{}:_args$headers,body=args.body;// uri validation
if(!uri||uri instanceof String){return logger.error("No valid uri given for method "+method)&&this;}// populate options with default data + user data
var options={};options.method=method;options.headers=Object.assign({},_defaultHeaders,headers);if(body)options.body=body;// create a log for the request
// this.logRequest(uri, options);
return new Promise(function(resolve,reject){var timeoutReached=false;var requestDone=false;// timeout feature...
if(_this._timeout){setTimeout(function(){if(requestDone)return;timeoutReached=true;logger.info("request "+method+": "+uri+" timeout after "+(+new Date()-time)+"ms");reject(Response(500,"Timeout en la conexion"));},_this._timeout);}// manage the request
fetch(uri,options).then(function(response){requestDone=true;if(timeoutReached)return;_this.logResponse(method,uri,time);_this.readResponse(response).then(function(json){if(response.ok){resolve(json);}else{if(json.status==401){//"Unauthorized"
__WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].logout();__WEBPACK_IMPORTED_MODULE_1__common_Util__["d" /* default */].notyError("Su sesión ha caducado.");}// Util.notyError(json.statusText || response.statusText);
console.log("REJECT READ RESPONSE NOT OK");reject(json);}});}).catch(function(error){requestDone=true;if(error.status==401){//"Unauthorized"
__WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].logout();__WEBPACK_IMPORTED_MODULE_1__common_Util__["d" /* default */].notyError("Su sesión ha caducado.");}if(timeoutReached)return;logger.error("request "+method+": "+uri+" raised error: \""+error+"\", took "+(+new Date()-time)+"ms");// let response = Response(502, "", {});
// Util.notyError(response.statusText);
reject(error);});});}}],[{key:"defaultHeaders",set:function set(value){_defaultHeaders=value;},get:function get(){return _defaultHeaders;}/*
	 * getters
	 */},{key:"Methods",get:function get(){return Methods;}},{key:"s4",get:function get(){return Math.floor((1+Math.random())*0x10000).toString(16).substring(1);}},{key:"generateUUID",get:function get(){return APIConnector.s4+APIConnector.s4+"-"+APIConnector.s4+"-"+APIConnector.s4+"-"+APIConnector.s4+"-"+APIConnector.s4+APIConnector.s4+APIConnector.s4;}}]);return APIConnector;}();/* harmony default export */ __webpack_exports__["a"] = (APIConnector);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return required; });
/* unused harmony export textLength */
/* unused harmony export dateIsSameOrAfterToday */
/* unused harmony export fromDatetimeIsBeforeToDatetimeForm */
/* unused harmony export fromDatetimeIsBeforeToDatetime */
/* unused harmony export datetimeIsBetween */
/* unused harmony export username */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return password; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return typeInteger; });
/* unused harmony export typeIntegerOrDecimal */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return typeIntegerOrDecimalOr0; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return typeIntegerOrDecimalMin10; });
/* unused harmony export onlyWords */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return validateEmail; });
/* unused harmony export confirmPassword */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
var required=function required(value){return value===null||value===""||value===undefined?"Campo requerido":undefined;};var textLength=function textLength(value){return value!==undefined?(value.length>45?"El nombre solo puede tener hasta 45 caracteres.":undefined)||(value.length<3?"El nombre debe tener al menos 3 caracteres.":undefined):undefined;};var dateIsSameOrAfterToday=function dateIsSameOrAfterToday(value){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(value).isSameOrAfter(__WEBPACK_IMPORTED_MODULE_0_moment___default()(),"day")===true?undefined:"La fecha es anterior a la actual.";};var fromDatetimeIsBeforeToDatetimeForm=function fromDatetimeIsBeforeToDatetimeForm(value,allValues){var fromDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()(value);var fromTime=__WEBPACK_IMPORTED_MODULE_0_moment___default()(allValues.from_time);fromDate.set({hour:fromTime.get("hour"),minute:fromTime.get("minute")});var toDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()(allValues.to_date);var toTime=__WEBPACK_IMPORTED_MODULE_0_moment___default()(allValues.to_time);toDate.set({hour:toTime.get("hour"),minute:toTime.get("minute")});if(fromDate.isBefore(toDate)===true){return undefined;}else{return"La fecha/hora desde debe ser anterior a la fecha/hora hasta.";}};var fromDatetimeIsBeforeToDatetime=function fromDatetimeIsBeforeToDatetime(fromDate,fromTime,toDate,toTime){var _fromDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()(fromDate);var _fromTime=__WEBPACK_IMPORTED_MODULE_0_moment___default()(fromTime);_fromDate.set({hour:_fromTime.get("hour"),minute:_fromTime.get("minute")});var _toDate=__WEBPACK_IMPORTED_MODULE_0_moment___default()(toDate);var _toTime=__WEBPACK_IMPORTED_MODULE_0_moment___default()(toTime);_toDate.set({hour:_toTime.get("hour"),minute:_toTime.get("minute")});return _fromDate.isBefore(_toDate);};var datetimeIsBetween=function datetimeIsBetween(date,from,to){return __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).isBetween(from,to,"minute","[]");};var username=function username(value){return value!==undefined?(value.length>45?"El Usuario solo puede tener hasta 45 caracteres.":undefined)||(value.length<3?"El Usuario debe tener al menos 3 caracteres.":undefined):undefined;};var password=function password(value){return value!==undefined?(value.length>50?"La contraseña solo puede tener hasta 50 caracteres.":undefined)||(value.length<6?"La contraseña debe tener al menos 6 caracteres.":undefined):undefined;};var typeInteger=function typeInteger(value){var regexInteger=/^[1-9]\d*?$/;if(value){return regexInteger.test(value)?null:"Este campo solo admite números enteros.";}else{return value;}};var typeIntegerOrDecimal=function typeIntegerOrDecimal(value){// console.log("value", value);
var regexIntegerOrDecial=/^[1-9]\d*(\.\d+)?$/;if(value){return regexIntegerOrDecial.test(value)?null:"Este campo solo admite números enteros o decimales.";}else{return value;}};var typeIntegerOrDecimalOr0=function typeIntegerOrDecimalOr0(value){//  console.log("value", value, typeof value, value?"TRUE":"FALSE");
var regexIntegerOrDecimal=/^[0-9]\d*(\.\d+)?$/;if(value||value===0){// console.log("regexIntegerOrDecial", regexIntegerOrDecimal.test(value))
return regexIntegerOrDecimal.test(value)?null:"Este campo solo admite números enteros o decimales.";}else{return value;}};var typeIntegerOrDecimalMin10=function typeIntegerOrDecimalMin10(value){//  console.log("value", value, typeof value, value?"TRUE":"FALSE");
var regexIntegerOrDecimal=/^[0-9]\d*(\.\d+)?$/;if(value||value===0){// console.log("regexIntegerOrDecial", regexIntegerOrDecimal.test(value))
return regexIntegerOrDecimal.test(value)?value>=10?null:"Debe ingresar un valor mayor o igual 10":"Este campo solo admite números enteros o decimales.";}else{return value;}};var onlyWords=function onlyWords(value){var regexWordsAndSpacesBetween=/^[a-zA-Z]+( [a-zA-Z]+)*$/;//^[a-zA-Z ]+$/;
if(value){return regexWordsAndSpacesBetween.test(value)?null:"Este campo solo admite letras.";}else{return value;}};var validateEmail=function validateEmail(value){var emailRegex=/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;if(value){return emailRegex.test(value)?null:"Correo electrónico inválido.";}else{return null;}};var confirmPassword=function confirmPassword(value,password){if(password){if(value){return password===value?null:"Las contraseñas no coinciden.";}else{return null;}}else{return"Debe escribir una contraseña.";}};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(120);
var core = __webpack_require__(54);
var ctx = __webpack_require__(497);
var hide = __webpack_require__(190);
var has = __webpack_require__(193);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["k"] = actionSelectEvent;
/* harmony export (immutable) */ __webpack_exports__["e"] = actionGetEvents;
/* harmony export (immutable) */ __webpack_exports__["h"] = actionSaveEvent;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeleteEvent;
/* harmony export (immutable) */ __webpack_exports__["f"] = actionGetTicketTypes;
/* harmony export (immutable) */ __webpack_exports__["i"] = actionSaveTicketType;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionDeleteTicketType;
/* harmony export (immutable) */ __webpack_exports__["d"] = actionGetCategories;
/* harmony export (immutable) */ __webpack_exports__["g"] = actionGetTickets;
/* harmony export (immutable) */ __webpack_exports__["j"] = actionSaveTickets;
/* harmony export (immutable) */ __webpack_exports__["p"] = actionTransferTicket;
/* harmony export (immutable) */ __webpack_exports__["b"] = actionDeleteTicket;
/* harmony export (immutable) */ __webpack_exports__["l"] = actionStatisticsByEvent;
/* harmony export (immutable) */ __webpack_exports__["m"] = actionStatisticsDirectRRPPByEvent;
/* harmony export (immutable) */ __webpack_exports__["o"] = actionStatisticsReferencedRRPPByEvent;
/* harmony export (immutable) */ __webpack_exports__["n"] = actionStatisticsProductorByEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__ = __webpack_require__(1449);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__ = __webpack_require__(209);
function actionSelectEvent(event){return function(dispatch,getStore){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{event:event}});};}/*** ACTIONS EVENTS ******/function actionGetEvents(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getEvents(getStore().app.app).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{eventList:response||[]}});succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveEvent(eventData,isCopyWithTickets,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);var event=Object.assign({},eventData,{evtName:eventData.evtTitle});event.evtDateTime=new Date(event.evtDateTime).getTime();// console.log("event.evtDateTime", event.evtDateTime)
event.evtInitDate=new Date(event.evtInitDate).getTime();event.evtEndDate=new Date(event.evtEndDate).getTime();if(typeof event.evtImg=="string"){//Si tiene una url y no un archivo seleccionado con el componente
__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].saveEvent(getStore().app.app,event,isCopyWithTickets,getStore().auth.email).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}else{//Si tiene un archivo seleccionado por el componente
__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].uploadFile(eventData.evtImg,"events","image").then(function(res){if(event.evtImgPath&&event.evtImgPath!=res.path){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(event.evtImgPath);}event.evtImg=res.downloadURL;event.evtImgName=res.filename;event.evtImgPath=res.path;__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].saveEvent(getStore().app.app,event,isCopyWithTickets,getStore().auth.email).then(function(response){successCallback();}).catch(errorCallback);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}};}function actionDeleteEvent(event,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].deleteEvent(getStore().app.app,event.id).then(function(response){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(event.evtImgPath);successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/****** FIN ACTION EVENTS +**********//****** ACTION TICKET TYPES **********/function actionGetTicketTypes(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getTicketTypesByEvent(getStore().app.app,getStore().evt.event.id).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{ticketTypeList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveTicketType(ticketTypeData,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);var ticketType=ticketTypeData;ticketType.tktEndDate=new Date(ticketType.tktEndDate).getTime();ticketType.tktInitDate=new Date(ticketType.tktInitDate).getTime();ticketType.tktOutdateDate=new Date(ticketType.tktOutdateDate).getTime();// console.log("SAVE TICKET TYPE", ticketType.tktIconFamily, ticketType.tktIcon)
// if(ticketType.tktIconFamily=="material"){
//   ticketType.tktIcon = ticketType.tktIcon.substring(3, ticketType.tktIcon.length)
// }
__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].saveTicketType(getStore().app.app,getStore().evt.event.id,ticketType,getStore().auth.email).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeleteTicketType(ticketTypeId,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].deleteTicketType(getStore().app.app,getStore().evt.event.id,ticketTypeId).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetCategories(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getCategories(getStore().app.app).then(function(response){// console.log("CATEGORIES", response)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{categoryList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/***** FIN ACTION TICKET TYPES *********//****** ACTION TICKETS **********/function actionGetTickets(filter,order,limit,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getTicketsByEvent(getStore().app.app,filter,order,limit).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{ticketList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveTickets(tickets,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);// let ticket = {
//   // tktBuyDate:new Date().getTime(),
//   tktBuyOperationId: 0,
//   tktBuyerDU: ticketData.tktBuyerDU,
//   tktCategory: ticketData.tktTicketType.tktCategory,
//   tktColor: ticketData.tktTicketType.tktColor,
//   tktDisplayName: ticketData.tktTicketType.tktDisplayName,
//   tktIcon: ticketData.tktTicketType.tktIcon,
//   tktIconFamily: ticketData.tktTicketType.tktIconFamily,
//   tktOrigin:"standard",
//   tktOwnerDU: ticketData.tktOwnerDU,
//   tktOwnerLastName: ticketData.tktOwnerLastName,
//   tktOwnerName: ticketData.tktOwnerName,
//   tktOwnerName2: ticketData.tktOwnerName + " " + ticketData.tktOwnerLastName,
//   tktPrice: ticketData.tktTicketType.tktPrice,
//   tktPriceProducer: ticketData.tktTicketType.tktPriceProducer,
//   tktRrpp: "",
//   tktRrppComision: 0,
//   tktState: "pendingUser",
//   tktType: ticketData.tktTicketType.id
// }
var eventId=getStore().evt.event.id;console.log("STORE",getStore());// const ticketTypeId = ticketType.id
// const profileData = profileData
// const buyOperationId = 0
__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].saveTickets(getStore().app.app,eventId,tickets).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionTransferTicket(requestObj,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].transferTicket(getStore().app.app,requestObj).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeleteTicket(ticketId,du,tktState,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].deleteTicket(getStore().app.app,getStore().evt.event.id,ticketId,du,tktState).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/***** FIN ACTION TICKETS *********//*** ACTIONS STATISTICS ******/function actionStatisticsByEvent(event,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getStatistics(getStore().app.app,event.id).then(function(response){// console.log("STATISTICS", response)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{stats:response,eventStats:event}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}// export function actionStatisticsRRPPByEvent(eventId, succesCallback, errorCallback) {
//   return (dispatch, getStore) => {
//       loading(true)(dispatch, getStore)
//       EventService.getStatisticsRRPP(getStore().app.app, eventId).then((response) => {
//           // console.log("STATISTICS RRPP", response)
//           dispatch({
//               type:ACT_EVT_CHANGE,
//               props: {
//                 statsRRPPList:response.rrppList,
//                 statsProducerList:response.producerList
//               }
//           })
//           succesCallback&&succesCallback()
//       }).catch(errorCallback)
//       .finally(()=>{loading(false)(dispatch, getStore)})
//   };
// }
function actionStatisticsDirectRRPPByEvent(eventId,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getStatisticsDirectRRPP(getStore().app.app,eventId).then(function(response){console.log("STATISTICS RRPP",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{directRrppList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionStatisticsReferencedRRPPByEvent(eventId,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getStatisticsReferencedRRPP(getStore().app.app,eventId).then(function(response){// console.log("STATISTICS RRPP", response)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{referencedRrppList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionStatisticsProductorByEvent(eventId,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_event_EventService__["a" /* default */].getStatisticsProducer(getStore().app.app,eventId).then(function(response){console.log("PRODUCER RESPONSE",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["c" /* ACT_EVT_CHANGE */],props:{producerSellList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/***** FIN ACTION STATISTICS *********/

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
}), 'Delete');

exports.default = _default;

/***/ }),
/* 71 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(661);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(256);




function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce(function (acc, item) {
    return acc && acc[item] ? acc[item] : null;
  }, obj);
}

function style(options) {
  var prop = options.prop,
      _options$cssProperty = options.cssProperty,
      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
      themeKey = options.themeKey,
      transform = options.transform;

  var fn = function fn(props) {
    if (props[prop] == null) {
      return null;
    }

    var propValue = props[prop];
    var theme = props.theme;
    var themeMapping = getPath(theme, themeKey) || {};

    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
      var value;

      if (typeof themeMapping === 'function') {
        value = themeMapping(propValueFinal);
      } else if (Array.isArray(themeMapping)) {
        value = themeMapping[propValueFinal] || propValueFinal;
      } else {
        value = getPath(themeMapping, propValueFinal) || propValueFinal;

        if (transform) {
          value = transform(value);
        }
      }

      if (cssProperty === false) {
        return value;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, value);
    };

    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  };

  fn.propTypes =  false ? _defineProperty({}, prop, responsivePropType) : {};
  fn.filterProps = [prop];
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = loading;
/* unused harmony export actionChangeAppProps */
/* unused harmony export actionLogout */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ActionTypes__ = __webpack_require__(30);
function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}// Creo una instancia de tipo CrudAction para usarla de forma local
//const action = new CrudAction(service, CHANGE_CONFIG_SETTINGS_PROPS);
function loading(value){return function(dispatch,getStore){console.log("LOADING",value);//Lo paso a valores numéricos para que no se superpongan dos llamadas y el false de la primera pise a la segunda que aún se ejecuta.
var newValue=getStore().app.loading;if(value){newValue++;}else{newValue--;}dispatch({type:__WEBPACK_IMPORTED_MODULE_1__ActionTypes__["a" /* ACT_APP_CHANGE */],props:{loading:newValue}});};}function actionChangeAppProps(props){return function(dispatch,getStore){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__ActionTypes__["a" /* ACT_APP_CHANGE */],props:props});};}// Promesa que debe ser implementada con el servicio elegido
function espera(){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:setTimeout(function(){return resolve("Resuelve la promesa");},4000);case 1:case"end":return _context.stop();}}},_callee,_this);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}function actionLogout(values,success){return function(dispatch,getStore){dispatch({type:__WEBPACK_IMPORTED_MODULE_1__ActionTypes__["a" /* ACT_APP_CHANGE */],props:{login:false,username:""}});if(success){success();}};}// export function actionLoading(value) {
// 	return (dispatch, getStore) => {
// 		dispatch({
// 			type: ACT_APP_CHANGE,
// 			props: { loading: value }
// 		});
// 		var timeoutId = setTimeout(console.log("ya paso el tiempo"), 7000);
// 		dispatch({
// 			type: ACT_APP_CHANGE,
// 			props: { loading: false }
// 		});
// 	};
// }
/* Ejemple de uso del servicio CrudAction
export function actionListConfigSetting(params, callback) {
  params = params || {};
  return (dispatch, getStore) => {
    dispatch({
      type: CHANGE_CONFIG_SETTINGS_PROPS,
      props: { gridFetchingData: true }
    });
    // Llamada al servicio list
    action
      .list(params)
      .then(response => {
        if (response.isSessionExpired()) {
          dispatch(actionLogout);
          return;
    }
}

async function asyncGetSponsorsList(name, page, size) {
		 try {
			 let response = await SponsorService.getSponsorsList(name, page, size);
			 return response;
		 } catch (error) {
			 return error;
	 }
}

async function asyncCreateSponsor(values) {
		 try {
			 let response = await SponsorService.createSponsor(values);
			 return response;
		 } catch (error) {
			 return error;
		}
}

export function actionUpdateSponsor(idSponsor, values, callback) {
		 return (dispatch, getStore) => {
			 dispatch({
				 type: ACT_APP_CHANGE,
				 props: {
					 loading: true
				 }
			 });
			 asyncUpdateSponsor(idSponsor, values)
				 .then(response => {
					 if (
						 response.code &&
						 (response.code === 42215104 || response.code === 42215105)
					 ) {
						 callback(WARNING);
					 } else {
						 callback(SUCCESS);
					 }
					 dispatch({
						 type: ACT_APP_CHANGE,
						 props: {
							 loading: false
						 }
					 });
				 })
				 .catch(error => callback(ERROR));
		};
}

async function asyncUpdateSponsor(idSponsor, values) {
		 try {
			 let response = await SponsorService.updateSponsor(idSponsor, values);
			 return response;
		 } catch (error) {
			 return error;
	}
}

export function actionDeleteSponsor(idSponsor, callback) {
		 return (dispatch, getStore) => {
			 dispatch({
			 type: ACT_APP_CHANGE,
				 props: {
					 loading: true
				 }
			 });
			 asyncDeleteSponsor(idSponsor)
				 .then(response => {
				 if (
						 response.code &&
						 UtilProyect.getHttpStatusCode(response.code) === 41215103
					 ) {
						 callback(WARNING);
					 } else {
						 callback(SUCCESS);
					 }
				 })
				 .catch(error => {
					 callback(ERROR);
				 })
				 .then(() => {
					 dispatch({
						 type: ACT_APP_CHANGE,
						 props: {
							 loading: false
						 }
				 });
			 });
	 };
}

async function asyncDeleteSponsor(idSponsor) {
		 let response = await SponsorService.deleteSponsor(idSponsor);
		 return response;
}


export function actionGetSponsorsList(name, page, size) {
 return (dispatch, getStore) => {
	 dispatch({
		 type: ACT_APP_CHANGE,
		 props: {
			 loading: true
		 }
	 });
	 asyncGetSponsorsList(name, page, size).then(response => {
		 dispatch({
			 type: "CHANGE_PROPS_SPONSOR",
			 props: {
				 sponsorsList: response
			 }
		 });
		 dispatch({
			 type: ACT_APP_CHANGE,
			 props: {
				 loading: false
			 }
		 });
	 });
 };
}

export function actionCreateSponsor(values, callback) {
 return (dispatch, getStore) => {
	 dispatch({
		 type: ACT_APP_CHANGE,
		 props: {
			 loading: true
		 }
	 });
	 asyncCreateSponsor(values)
		 .then(response => {
			 if (
				 response.code &&
				 (response.code === 42215104 || response.code === 42215105)
			 ) {
				 callback(WARNING);
			 } else {
				 callback(SUCCESS);
			 }
			 dispatch({
				 type: ACT_APP_CHANGE,
				 props: {
					 loading: false
				 }
			 });
		 })
		 .catch(error => callback(ERROR));
	};
}
*/

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(129);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/* harmony default export */ __webpack_exports__["a"] = (isObject);


/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = setRef;
// TODO: Make it private only in v5
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useEventCallback;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect;
/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 *
 * @param {function} fn
 */

function useEventCallback(fn) {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(fn);
  useEnhancedEffect(function () {
    ref.current = fn;
  });
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    return (0, ref.current).apply(void 0, arguments);
  }, []);
}

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__merge__ = __webpack_require__(176);



function compose() {
  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
    styles[_key] = arguments[_key];
  }

  var fn = function fn(props) {
    return styles.reduce(function (acc, style) {
      var output = style(props);

      if (output) {
        return Object(__WEBPACK_IMPORTED_MODULE_1__merge__["a" /* default */])(acc, output);
      }

      return acc;
    }, {});
  }; // Alternative approach that doesn't yield any performance gain.
  // const handlers = styles.reduce((acc, style) => {
  //   style.filterProps.forEach(prop => {
  //     acc[prop] = style;
  //   });
  //   return acc;
  // }, {});
  // const fn = props => {
  //   return Object.keys(props).reduce((acc, prop) => {
  //     if (handlers[prop]) {
  //       return merge(acc, handlers[prop](props));
  //     }
  //     return acc;
  //   }, {});
  // };


  fn.propTypes =  false ? styles.reduce(function (acc, style) {
    return _extends(acc, style.propTypes);
  }, {}) : {};
  fn.filterProps = styles.reduce(function (acc, style) {
    return acc.concat(style.filterProps);
  }, []);
  return fn;
}

/* harmony default export */ __webpack_exports__["a"] = (compose);

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

/* harmony default export */ __webpack_exports__["a"] = (ownerDocument);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(1160);

Object.defineProperty(exports, 'Checkbox', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkbox).default;
  }
});

var _RadioGroup = __webpack_require__(1162);

Object.defineProperty(exports, 'RadioGroup', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RadioGroup).default;
  }
});

var _Select = __webpack_require__(1163);

Object.defineProperty(exports, 'Select', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Select).default;
  }
});

var _Switch = __webpack_require__(1164);

Object.defineProperty(exports, 'Switch', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Switch).default;
  }
});

var _TextField = __webpack_require__(1165);

Object.defineProperty(exports, 'TextField', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TextField).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(157)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ __webpack_exports__["a"] = (isObjectLike);


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getValue_js__ = __webpack_require__(701);



/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = Object(__WEBPACK_IMPORTED_MODULE_1__getValue_js__["a" /* default */])(object, key);
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsNative_js__["a" /* default */])(value) ? value : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (getNative);


/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return hasCSSTOMSupport; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return create; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getDynamicStyles; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return toCssValue; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createRule; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SheetsRegistry; });
/* unused harmony export SheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return RuleList; });
/* unused harmony export sheets */
/* unused harmony export createGenerateId */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_is_in_browser__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_tiny_warning__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(112);








var plainObjectConstrurctor = {}.constructor;
function cloneStyle(style) {
  if (style == null || typeof style !== 'object') return style;
  if (Array.isArray(style)) return style.map(cloneStyle);
  if (style.constructor !== plainObjectConstrurctor) return style;
  var newStyle = {};

  for (var name in style) {
    newStyle[name] = cloneStyle(style[name]);
  }

  return newStyle;
}

/**
 * Create a rule instance.
 */

function createRule(name, decl, options) {
  if (name === void 0) {
    name = 'unnamed';
  }

  var jss = options.jss;
  var declCopy = cloneStyle(decl);
  var rule = jss.plugins.onCreateRule(name, declCopy, options);
  if (rule) return rule; // It is an at-rule and it has no instance.

  if (name[0] === '@') {
     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
  }

  return null;
}

var join = function join(value, by) {
  var result = '';

  for (var i = 0; i < value.length; i++) {
    // Remove !important from the value, it will be readded later.
    if (value[i] === '!important') break;
    if (result) result += by;
    result += value[i];
  }

  return result;
};
/**
 * Converts array values to string.
 *
 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
 * `border: ['1px', '2px']` > `border: 1px, 2px;`
 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
 * `color: ['red', !important]` > `color: red !important;`
 */


function toCssValue(value, ignoreImportant) {
  if (ignoreImportant === void 0) {
    ignoreImportant = false;
  }

  if (!Array.isArray(value)) return value;
  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.

  if (Array.isArray(value[0])) {
    for (var i = 0; i < value.length; i++) {
      if (value[i] === '!important') break;
      if (cssValue) cssValue += ', ';
      cssValue += join(value[i], ' ');
    }
  } else cssValue = join(value, ', '); // Add !important, because it was ignored.


  if (!ignoreImportant && value[value.length - 1] === '!important') {
    cssValue += ' !important';
  }

  return cssValue;
}

/**
 * Indent a string.
 * http://jsperf.com/array-join-vs-for
 */
function indentStr(str, indent) {
  var result = '';

  for (var index = 0; index < indent; index++) {
    result += '  ';
  }

  return result + str;
}
/**
 * Converts a Rule to CSS string.
 */


function toCss(selector, style, options) {
  if (options === void 0) {
    options = {};
  }

  var result = '';
  if (!style) return result;
  var _options = options,
      _options$indent = _options.indent,
      indent = _options$indent === void 0 ? 0 : _options$indent;
  var fallbacks = style.fallbacks;
  if (selector) indent++; // Apply fallbacks first.

  if (fallbacks) {
    // Array syntax {fallbacks: [{prop: value}]}
    if (Array.isArray(fallbacks)) {
      for (var index = 0; index < fallbacks.length; index++) {
        var fallback = fallbacks[index];

        for (var prop in fallback) {
          var value = fallback[prop];

          if (value != null) {
            if (result) result += '\n';
            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
          }
        }
      }
    } else {
      // Object syntax {fallbacks: {prop: value}}
      for (var _prop in fallbacks) {
        var _value = fallbacks[_prop];

        if (_value != null) {
          if (result) result += '\n';
          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
        }
      }
    }
  }

  for (var _prop2 in style) {
    var _value2 = style[_prop2];

    if (_value2 != null && _prop2 !== 'fallbacks') {
      if (result) result += '\n';
      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
    }
  } // Allow empty style in this case, because properties will be added dynamically.


  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.

  if (!selector) return result;
  indent--;
  if (result) result = "\n" + result + "\n";
  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
}

var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
var escape = (function (str) {
  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
});

var BaseStyleRule =
/*#__PURE__*/
function () {
  function BaseStyleRule(key, style, options) {
    this.type = 'style';
    this.key = void 0;
    this.isProcessed = false;
    this.style = void 0;
    this.renderer = void 0;
    this.renderable = void 0;
    this.options = void 0;
    var sheet = options.sheet,
        Renderer = options.Renderer;
    this.key = key;
    this.options = options;
    this.style = style;
    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
  }
  /**
   * Get or set a style property.
   */


  var _proto = BaseStyleRule.prototype;

  _proto.prop = function prop(name, value, options) {
    // It's a getter.
    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.

    var force = options ? options.force : false;
    if (!force && this.style[name] === value) return this;
    var newValue = value;

    if (!options || options.process !== false) {
      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
    }

    var isEmpty = newValue == null || newValue === false;
    var isDefined = name in this.style; // Value is empty and wasn't defined before.

    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.

    var remove = isEmpty && isDefined;
    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.

    if (this.renderable && this.renderer) {
      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
      return this;
    }

    var sheet = this.options.sheet;

    if (sheet && sheet.attached) {
       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
    }

    return this;
  };

  return BaseStyleRule;
}();
var StyleRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(StyleRule, _BaseStyleRule);

  function StyleRule(key, style, options) {
    var _this;

    _this = _BaseStyleRule.call(this, key, style, options) || this;
    _this.selectorText = void 0;
    _this.id = void 0;
    _this.renderable = void 0;
    var selector = options.selector,
        scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;

    if (selector) {
      _this.selectorText = selector;
    } else if (scoped !== false) {
      _this.id = generateId(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_5__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)), sheet);
      _this.selectorText = "." + escape(_this.id);
    }

    return _this;
  }
  /**
   * Set selector string.
   * Attention: use this with caution. Most browsers didn't implement
   * selectorText setter, so this may result in rerendering of entire Style Sheet.
   */


  var _proto2 = StyleRule.prototype;

  /**
   * Apply rule to an element inline.
   */
  _proto2.applyTo = function applyTo(renderable) {
    var renderer = this.renderer;

    if (renderer) {
      var json = this.toJSON();

      for (var prop in json) {
        renderer.setProperty(renderable, prop, json[prop]);
      }
    }

    return this;
  }
  /**
   * Returns JSON representation of the rule.
   * Fallbacks are not supported.
   * Useful for inline styles.
   */
  ;

  _proto2.toJSON = function toJSON() {
    var json = {};

    for (var prop in this.style) {
      var value = this.style[prop];
      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
    }

    return json;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto2.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.selectorText, this.style, opts);
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(StyleRule, [{
    key: "selector",
    set: function set(selector) {
      if (selector === this.selectorText) return;
      this.selectorText = selector;
      var renderer = this.renderer,
          renderable = this.renderable;
      if (!renderable || !renderer) return;
      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.

      if (!hasChanged) {
        renderer.replaceRule(renderable, this);
      }
    }
    /**
     * Get selector string.
     */
    ,
    get: function get() {
      return this.selectorText;
    }
  }]);

  return StyleRule;
}(BaseStyleRule);
var pluginStyleRule = {
  onCreateRule: function onCreateRule(name, style, options) {
    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
      return null;
    }

    return new StyleRule(name, style, options);
  }
};

var defaultToStringOptions = {
  indent: 1,
  children: true
};
var atRegExp = /@([\w-]+)/;
/**
 * Conditional rule for @media, @supports
 */

var ConditionalRule =
/*#__PURE__*/
function () {
  function ConditionalRule(key, styles, options) {
    this.type = 'conditional';
    this.at = void 0;
    this.key = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    var atMatch = key.match(atRegExp);
    this.at = atMatch ? atMatch[1] : 'unknown';
    this.options = options;
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = ConditionalRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions;
    }

    if (options.indent == null) options.indent = defaultToStringOptions.indent;
    if (options.children == null) options.children = defaultToStringOptions.children;

    if (options.children === false) {
      return this.key + " {}";
    }

    var children = this.rules.toString(options);
    return children ? this.key + " {\n" + children + "\n}" : '';
  };

  return ConditionalRule;
}();
var keyRegExp = /@media|@supports\s+/;
var pluginConditionalRule = {
  onCreateRule: function onCreateRule(key, styles, options) {
    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
  }
};

var defaultToStringOptions$1 = {
  indent: 1,
  children: true
};
var nameRegExp = /@keyframes\s+([\w-]+)/;
/**
 * Rule for @keyframes
 */

var KeyframesRule =
/*#__PURE__*/
function () {
  function KeyframesRule(key, frames, options) {
    this.type = 'keyframes';
    this.at = '@keyframes';
    this.key = void 0;
    this.name = void 0;
    this.id = void 0;
    this.rules = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    var nameMatch = key.match(nameRegExp);

    if (nameMatch && nameMatch[1]) {
      this.name = nameMatch[1];
    } else {
      this.name = 'noname';
       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
    }

    this.key = this.type + "-" + this.name;
    this.options = options;
    var scoped = options.scoped,
        sheet = options.sheet,
        generateId = options.generateId;
    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
    this.rules = new RuleList(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var name in frames) {
      this.rules.add(name, frames[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
        parent: this
      }));
    }

    this.rules.process();
  }
  /**
   * Generates a CSS string.
   */


  var _proto = KeyframesRule.prototype;

  _proto.toString = function toString(options) {
    if (options === void 0) {
      options = defaultToStringOptions$1;
    }

    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
    if (options.children == null) options.children = defaultToStringOptions$1.children;

    if (options.children === false) {
      return this.at + " " + this.id + " {}";
    }

    var children = this.rules.toString(options);
    if (children) children = "\n" + children + "\n";
    return this.at + " " + this.id + " {" + children + "}";
  };

  return KeyframesRule;
}();
var keyRegExp$1 = /@keyframes\s+/;
var refRegExp = /\$([\w-]+)/g;

var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
  if (typeof val === 'string') {
    return val.replace(refRegExp, function (match, name) {
      if (name in keyframes) {
        return keyframes[name];
      }

       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
      return match;
    });
  }

  return val;
};
/**
 * Replace the reference for a animation name.
 */


var replaceRef = function replaceRef(style, prop, keyframes) {
  var value = style[prop];
  var refKeyframe = findReferencedKeyframe(value, keyframes);

  if (refKeyframe !== value) {
    style[prop] = refKeyframe;
  }
};

var plugin = {
  onCreateRule: function onCreateRule(key, frames, options) {
    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
  },
  // Animation name ref replacer.
  onProcessStyle: function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style' || !sheet) return style;
    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
    return style;
  },
  onChangeValue: function onChangeValue(val, prop, rule) {
    var sheet = rule.options.sheet;

    if (!sheet) {
      return val;
    }

    switch (prop) {
      case 'animation':
        return findReferencedKeyframe(val, sheet.keyframes);

      case 'animation-name':
        return findReferencedKeyframe(val, sheet.keyframes);

      default:
        return val;
    }
  }
};

var KeyframeRule =
/*#__PURE__*/
function (_BaseStyleRule) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(KeyframeRule, _BaseStyleRule);

  function KeyframeRule() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
    _this.renderable = void 0;
    return _this;
  }

  var _proto = KeyframeRule.prototype;

  /**
   * Generates a CSS string.
   */
  _proto.toString = function toString(options) {
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;
    var opts = link ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      allowEmpty: true
    }) : options;
    return toCss(this.key, this.style, opts);
  };

  return KeyframeRule;
}(BaseStyleRule);
var pluginKeyframeRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    if (options.parent && options.parent.type === 'keyframes') {
      return new KeyframeRule(key, style, options);
    }

    return null;
  }
};

var FontFaceRule =
/*#__PURE__*/
function () {
  function FontFaceRule(key, style, options) {
    this.type = 'font-face';
    this.at = '@font-face';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = FontFaceRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.style)) {
      var str = '';

      for (var index = 0; index < this.style.length; index++) {
        str += toCss(this.key, this.style[index]);
        if (this.style[index + 1]) str += '\n';
      }

      return str;
    }

    return toCss(this.key, this.style, options);
  };

  return FontFaceRule;
}();
var pluginFontFaceRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@font-face' ? new FontFaceRule(key, style, options) : null;
  }
};

var ViewportRule =
/*#__PURE__*/
function () {
  function ViewportRule(key, style, options) {
    this.type = 'viewport';
    this.at = '@viewport';
    this.key = void 0;
    this.style = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.style = style;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */


  var _proto = ViewportRule.prototype;

  _proto.toString = function toString(options) {
    return toCss(this.key, this.style, options);
  };

  return ViewportRule;
}();
var pluginViewportRule = {
  onCreateRule: function onCreateRule(key, style, options) {
    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
  }
};

var SimpleRule =
/*#__PURE__*/
function () {
  function SimpleRule(key, value, options) {
    this.type = 'simple';
    this.key = void 0;
    this.value = void 0;
    this.options = void 0;
    this.isProcessed = false;
    this.renderable = void 0;
    this.key = key;
    this.value = value;
    this.options = options;
  }
  /**
   * Generates a CSS string.
   */
  // eslint-disable-next-line no-unused-vars


  var _proto = SimpleRule.prototype;

  _proto.toString = function toString(options) {
    if (Array.isArray(this.value)) {
      var str = '';

      for (var index = 0; index < this.value.length; index++) {
        str += this.key + " " + this.value[index] + ";";
        if (this.value[index + 1]) str += '\n';
      }

      return str;
    }

    return this.key + " " + this.value + ";";
  };

  return SimpleRule;
}();
var keysMap = {
  '@charset': true,
  '@import': true,
  '@namespace': true
};
var pluginSimpleRule = {
  onCreateRule: function onCreateRule(key, value, options) {
    return key in keysMap ? new SimpleRule(key, value, options) : null;
  }
};

var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];

var defaultUpdateOptions = {
  process: true
};
var forceUpdateOptions = {
  force: true,
  process: true
  /**
   * Contains rules objects and allows adding/removing etc.
   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
   */

};

var RuleList =
/*#__PURE__*/
function () {
  // Rules registry for access by .get() method.
  // It contains the same rule registered by name and by selector.
  // Original styles object.
  // Used to ensure correct rules order.
  function RuleList(options) {
    this.map = {};
    this.raw = {};
    this.index = [];
    this.options = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.options = options;
    this.classes = options.classes;
    this.keyframes = options.keyframes;
  }
  /**
   * Create and register rule.
   *
   * Will not render after Style Sheet was rendered the first time.
   */


  var _proto = RuleList.prototype;

  _proto.add = function add(key, decl, ruleOptions) {
    var _this$options = this.options,
        parent = _this$options.parent,
        sheet = _this$options.sheet,
        jss = _this$options.jss,
        Renderer = _this$options.Renderer,
        generateId = _this$options.generateId,
        scoped = _this$options.scoped;

    var options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      classes: this.classes,
      parent: parent,
      sheet: sheet,
      jss: jss,
      Renderer: Renderer,
      generateId: generateId,
      scoped: scoped
    }, ruleOptions); // We need to save the original decl before creating the rule
    // because cache plugin needs to use it as a key to return a cached rule.


    this.raw[key] = decl;

    if (key in this.classes) {
      // For e.g. rules inside of @media container
      options.selector = "." + escape(this.classes[key]);
    }

    var rule = createRule(key, decl, options);
    if (!rule) return null;
    this.register(rule);
    var index = options.index === undefined ? this.index.length : options.index;
    this.index.splice(index, 0, rule);
    return rule;
  }
  /**
   * Get a rule.
   */
  ;

  _proto.get = function get(name) {
    return this.map[name];
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.remove = function remove(rule) {
    this.unregister(rule);
    delete this.raw[rule.key];
    this.index.splice(this.indexOf(rule), 1);
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.index.indexOf(rule);
  }
  /**
   * Run `onProcessRule()` plugins on every rule.
   */
  ;

  _proto.process = function process() {
    var plugins$$1 = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
    // we end up with very hard-to-track-down side effects.

    this.index.slice(0).forEach(plugins$$1.onProcessRule, plugins$$1);
  }
  /**
   * Register a rule in `.map` and `.classes` maps.
   */
  ;

  _proto.register = function register(rule) {
    this.map[rule.key] = rule;

    if (rule instanceof StyleRule) {
      this.map[rule.selector] = rule;
      if (rule.id) this.classes[rule.key] = rule.id;
    } else if (rule instanceof KeyframesRule && this.keyframes) {
      this.keyframes[rule.name] = rule.id;
    }
  }
  /**
   * Unregister a rule.
   */
  ;

  _proto.unregister = function unregister(rule) {
    delete this.map[rule.key];

    if (rule instanceof StyleRule) {
      delete this.map[rule.selector];
      delete this.classes[rule.key];
    } else if (rule instanceof KeyframesRule) {
      delete this.keyframes[rule.name];
    }
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var name;
    var data;
    var options;

    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe

      options = arguments.length <= 2 ? undefined : arguments[2];
    } else {
      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe

      options = arguments.length <= 1 ? undefined : arguments[1];
      name = null;
    }

    if (name) {
      this.onUpdate(data, this.get(name), options);
    } else {
      for (var index = 0; index < this.index.length; index++) {
        this.onUpdate(data, this.index[index], options);
      }
    }
  }
  /**
   * Execute plugins, update rule props.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, options) {
    if (options === void 0) {
      options = defaultUpdateOptions;
    }

    var _this$options2 = this.options,
        plugins$$1 = _this$options2.jss.plugins,
        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.

    if (rule.rules instanceof RuleList) {
      rule.rules.update(data, options);
      return;
    }

    var styleRule = rule;
    var style = styleRule.style;
    plugins$$1.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.

    if (options.process && style && style !== styleRule.style) {
      // We need to run the plugins in case new `style` relies on syntax plugins.
      plugins$$1.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.

      for (var prop in styleRule.style) {
        var nextValue = styleRule.style[prop];
        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (nextValue !== prevValue) {
          styleRule.prop(prop, nextValue, forceUpdateOptions);
        }
      } // Remove props.


      for (var _prop in style) {
        var _nextValue = styleRule.style[_prop];
        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.

        if (_nextValue == null && _nextValue !== _prevValue) {
          styleRule.prop(_prop, null, forceUpdateOptions);
        }
      }
    }
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    var str = '';
    var sheet = this.options.sheet;
    var link = sheet ? sheet.options.link : false;

    for (var index = 0; index < this.index.length; index++) {
      var rule = this.index[index];
      var css = rule.toString(options); // No need to render an empty rule.

      if (!css && !link) continue;
      if (str) str += '\n';
      str += css;
    }

    return str;
  };

  return RuleList;
}();

var StyleSheet =
/*#__PURE__*/
function () {
  function StyleSheet(styles, options) {
    this.options = void 0;
    this.deployed = void 0;
    this.attached = void 0;
    this.rules = void 0;
    this.renderer = void 0;
    this.classes = void 0;
    this.keyframes = void 0;
    this.queue = void 0;
    this.attached = false;
    this.deployed = false;
    this.classes = {};
    this.keyframes = {};
    this.options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      sheet: this,
      parent: this,
      classes: this.classes,
      keyframes: this.keyframes
    });

    if (options.Renderer) {
      this.renderer = new options.Renderer(this);
    }

    this.rules = new RuleList(this.options);

    for (var name in styles) {
      this.rules.add(name, styles[name]);
    }

    this.rules.process();
  }
  /**
   * Attach renderable to the render tree.
   */


  var _proto = StyleSheet.prototype;

  _proto.attach = function attach() {
    if (this.attached) return this;
    if (this.renderer) this.renderer.attach();
    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.

    if (!this.deployed) this.deploy();
    return this;
  }
  /**
   * Remove renderable from render tree.
   */
  ;

  _proto.detach = function detach() {
    if (!this.attached) return this;
    if (this.renderer) this.renderer.detach();
    this.attached = false;
    return this;
  }
  /**
   * Add a rule to the current stylesheet.
   * Will insert a rule also after the stylesheet has been rendered first time.
   */
  ;

  _proto.addRule = function addRule(name, decl, options) {
    var queue = this.queue; // Plugins can create rules.
    // In order to preserve the right order, we need to queue all `.addRule` calls,
    // which happen after the first `rules.add()` call.

    if (this.attached && !queue) this.queue = [];
    var rule = this.rules.add(name, decl, options);
    if (!rule) return null;
    this.options.jss.plugins.onProcessRule(rule);

    if (this.attached) {
      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
      // It will be inserted all together when .attach is called.

      if (queue) queue.push(rule);else {
        this.insertRule(rule);

        if (this.queue) {
          this.queue.forEach(this.insertRule, this);
          this.queue = undefined;
        }
      }
      return rule;
    } // We can't add rules to a detached style node.
    // We will redeploy the sheet once user will attach it.


    this.deployed = false;
    return rule;
  }
  /**
   * Insert rule into the StyleSheet
   */
  ;

  _proto.insertRule = function insertRule(rule) {
    if (this.renderer) {
      this.renderer.insertRule(rule);
    }
  }
  /**
   * Create and add rules.
   * Will render also after Style Sheet was rendered the first time.
   */
  ;

  _proto.addRules = function addRules(styles, options) {
    var added = [];

    for (var name in styles) {
      var rule = this.addRule(name, styles[name], options);
      if (rule) added.push(rule);
    }

    return added;
  }
  /**
   * Get a rule by name.
   */
  ;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Delete a rule by name.
   * Returns `true`: if rule has been deleted from the DOM.
   */
  ;

  _proto.deleteRule = function deleteRule(name) {
    var rule = this.rules.get(name);
    if (!rule) return false;
    this.rules.remove(rule);

    if (this.attached && rule.renderable && this.renderer) {
      return this.renderer.deleteRule(rule.renderable);
    }

    return true;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Deploy pure CSS string to a renderable.
   */
  ;

  _proto.deploy = function deploy() {
    if (this.renderer) this.renderer.deploy();
    this.deployed = true;
    return this;
  }
  /**
   * Update the function values with a new data.
   */
  ;

  _proto.update = function update() {
    var _this$rules;

    (_this$rules = this.rules).update.apply(_this$rules, arguments);

    return this;
  }
  /**
   * Convert rules to a CSS string.
   */
  ;

  _proto.toString = function toString(options) {
    return this.rules.toString(options);
  };

  return StyleSheet;
}();

var PluginsRegistry =
/*#__PURE__*/
function () {
  function PluginsRegistry() {
    this.plugins = {
      internal: [],
      external: []
    };
    this.registry = void 0;
  }

  var _proto = PluginsRegistry.prototype;

  /**
   * Call `onCreateRule` hooks and return an object if returned by a hook.
   */
  _proto.onCreateRule = function onCreateRule(name, decl, options) {
    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
      var rule = this.registry.onCreateRule[i](name, decl, options);
      if (rule) return rule;
    }

    return null;
  }
  /**
   * Call `onProcessRule` hooks.
   */
  ;

  _proto.onProcessRule = function onProcessRule(rule) {
    if (rule.isProcessed) return;
    var sheet = rule.options.sheet;

    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
      this.registry.onProcessRule[i](rule, sheet);
    }

    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
    rule.isProcessed = true;
  }
  /**
   * Call `onProcessStyle` hooks.
   */
  ;

  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
      // $FlowFixMe
      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
    }
  }
  /**
   * Call `onProcessSheet` hooks.
   */
  ;

  _proto.onProcessSheet = function onProcessSheet(sheet) {
    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
      this.registry.onProcessSheet[i](sheet);
    }
  }
  /**
   * Call `onUpdate` hooks.
   */
  ;

  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
    for (var i = 0; i < this.registry.onUpdate.length; i++) {
      this.registry.onUpdate[i](data, rule, sheet, options);
    }
  }
  /**
   * Call `onChangeValue` hooks.
   */
  ;

  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
    var processedValue = value;

    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
    }

    return processedValue;
  }
  /**
   * Register a plugin.
   */
  ;

  _proto.use = function use(newPlugin, options) {
    if (options === void 0) {
      options = {
        queue: 'external'
      };
    }

    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.

    if (plugins.indexOf(newPlugin) !== -1) {
      return;
    }

    plugins.push(newPlugin);
    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
      for (var name in plugin) {
        if (name in registry) {
          registry[name].push(plugin[name]);
        } else {
           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
        }
      }

      return registry;
    }, {
      onCreateRule: [],
      onProcessRule: [],
      onProcessStyle: [],
      onProcessSheet: [],
      onChangeValue: [],
      onUpdate: []
    });
  };

  return PluginsRegistry;
}();

/**
 * Sheets registry to access them all at one place.
 */
var SheetsRegistry =
/*#__PURE__*/
function () {
  function SheetsRegistry() {
    this.registry = [];
  }

  var _proto = SheetsRegistry.prototype;

  /**
   * Register a Style Sheet.
   */
  _proto.add = function add(sheet) {
    var registry = this.registry;
    var index = sheet.options.index;
    if (registry.indexOf(sheet) !== -1) return;

    if (registry.length === 0 || index >= this.index) {
      registry.push(sheet);
      return;
    } // Find a position.


    for (var i = 0; i < registry.length; i++) {
      if (registry[i].options.index > index) {
        registry.splice(i, 0, sheet);
        return;
      }
    }
  }
  /**
   * Reset the registry.
   */
  ;

  _proto.reset = function reset() {
    this.registry = [];
  }
  /**
   * Remove a Style Sheet.
   */
  ;

  _proto.remove = function remove(sheet) {
    var index = this.registry.indexOf(sheet);
    this.registry.splice(index, 1);
  }
  /**
   * Convert all attached sheets to a CSS string.
   */
  ;

  _proto.toString = function toString(_temp) {
    var _ref = _temp === void 0 ? {} : _temp,
        attached = _ref.attached,
        options = Object(__WEBPACK_IMPORTED_MODULE_6__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["attached"]);

    var css = '';

    for (var i = 0; i < this.registry.length; i++) {
      var sheet = this.registry[i];

      if (attached != null && sheet.attached !== attached) {
        continue;
      }

      if (css) css += '\n';
      css += sheet.toString(options);
    }

    return css;
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsRegistry, [{
    key: "index",

    /**
     * Current highest index number.
     */
    get: function get() {
      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
    }
  }]);

  return SheetsRegistry;
}();

/**
 * This is a global sheets registry. Only DomRenderer will add sheets to it.
 * On the server one should use an own SheetsRegistry instance and add the
 * sheets to it, because you need to make sure to create a new registry for
 * each request in order to not leak sheets across requests.
 */

var sheets = new SheetsRegistry();

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
// the current version with just one short number and use it for classes generation
// we use a counter. Also it is more accurate, because user can manually reevaluate
// the module.

var moduleId = globalThis[ns]++;

var maxRules = 1e10;

/**
 * Returns a function which generates unique class names based on counters.
 * When new generator function is created, rule counter is reseted.
 * We need to reset the rule counter for SSR for each request.
 */
var createGenerateId = function createGenerateId(options) {
  if (options === void 0) {
    options = {};
  }

  var ruleCounter = 0;
  return function (rule, sheet) {
    ruleCounter += 1;

    if (ruleCounter > maxRules) {
       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
    }

    var jssId = '';
    var prefix = '';

    if (sheet) {
      if (sheet.options.classNamePrefix) {
        prefix = sheet.options.classNamePrefix;
      }

      if (sheet.options.jss.id != null) {
        jssId = String(sheet.options.jss.id);
      }
    }

    if (options.minify) {
      // Using "c" because a number can't be the first char in a class name.
      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
    }

    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
  };
};

/**
 * Cache the value from the first time a function is called.
 */
var memoize = function memoize(fn) {
  var value;
  return function () {
    if (!value) value = fn();
    return value;
  };
};
/**
 * Get a style property value.
 */


function getPropertyValue(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      return cssRule.attributeStyleMap.get(prop);
    }

    return cssRule.style.getPropertyValue(prop);
  } catch (err) {
    // IE may throw if property is unknown.
    return '';
  }
}
/**
 * Set a style property.
 */


function setProperty(cssRule, prop, value) {
  try {
    var cssValue = value;

    if (Array.isArray(value)) {
      cssValue = toCssValue(value, true);

      if (value[value.length - 1] === '!important') {
        cssRule.style.setProperty(prop, cssValue, 'important');
        return true;
      }
    } // Support CSSTOM.


    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.set(prop, cssValue);
    } else {
      cssRule.style.setProperty(prop, cssValue);
    }
  } catch (err) {
    // IE may throw if property is unknown.
    return false;
  }

  return true;
}
/**
 * Remove a style property.
 */


function removeProperty(cssRule, prop) {
  try {
    // Support CSSTOM.
    if (cssRule.attributeStyleMap) {
      cssRule.attributeStyleMap.delete(prop);
    } else {
      cssRule.style.removeProperty(prop);
    }
  } catch (err) {
     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
  }
}
/**
 * Set the selector.
 */


function setSelector(cssRule, selectorText) {
  cssRule.selectorText = selectorText; // Return false if setter was not successful.
  // Currently works in chrome only.

  return cssRule.selectorText === selectorText;
}
/**
 * Gets the `head` element upon the first call and caches it.
 * We assume it can't be null.
 */


var getHead = memoize(function () {
  return document.querySelector('head');
});
/**
 * Find attached sheet with an index higher than the passed one.
 */

function findHigherSheet(registry, options) {
  for (var i = 0; i < registry.length; i++) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find attached sheet with the highest index.
 */


function findHighestSheet(registry, options) {
  for (var i = registry.length - 1; i >= 0; i--) {
    var sheet = registry[i];

    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
      return sheet;
    }
  }

  return null;
}
/**
 * Find a comment with "jss" inside.
 */


function findCommentNode(text) {
  var head = getHead();

  for (var i = 0; i < head.childNodes.length; i++) {
    var node = head.childNodes[i];

    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
      return node;
    }
  }

  return null;
}

/**
 * Find a node before which we can insert the sheet.
 */
function findPrevNode(options) {
  var registry = sheets.registry;

  if (registry.length > 0) {
    // Try to insert before the next higher sheet.
    var sheet = findHigherSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element
      };
    } // Otherwise insert after the last attached.


    sheet = findHighestSheet(registry, options);

    if (sheet && sheet.renderer) {
      return {
        parent: sheet.renderer.element.parentNode,
        node: sheet.renderer.element.nextSibling
      };
    }
  } // Try to find a comment placeholder if registry is empty.


  var insertionPoint = options.insertionPoint;

  if (insertionPoint && typeof insertionPoint === 'string') {
    var comment = findCommentNode(insertionPoint);

    if (comment) {
      return {
        parent: comment.parentNode,
        node: comment.nextSibling
      };
    } // If user specifies an insertion point and it can't be found in the document -
    // bad specificity issues may appear.


     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
  }

  return false;
}
/**
 * Insert style element into the DOM.
 */


function insertStyle(style, options) {
  var insertionPoint = options.insertionPoint;
  var nextNode = findPrevNode(options);

  if (nextNode !== false && nextNode.parent) {
    nextNode.parent.insertBefore(style, nextNode.node);
    return;
  } // Works with iframes and any node types.


  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
    var insertionPointElement = insertionPoint;
    var parentNode = insertionPointElement.parentNode;
    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
    return;
  }

  getHead().appendChild(style);
}
/**
 * Read jss nonce setting from the page if the user has set it.
 */


var getNonce = memoize(function () {
  var node = document.querySelector('meta[property="csp-nonce"]');
  return node ? node.getAttribute('content') : null;
});

var _insertRule = function insertRule(container, rule, index) {
  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong

  if (index === undefined || index > maxIndex) {
    // eslint-disable-next-line no-param-reassign
    index = maxIndex;
  }

  try {
    if ('insertRule' in container) {
      var c = container;
      c.insertRule(rule, index);
    } // Keyframes rule.
    else if ('appendRule' in container) {
        var _c = container;

        _c.appendRule(rule);
      }
  } catch (err) {
     false ? warning(false, "[JSS] " + err.message) : void 0;
    return false;
  }

  return container.cssRules[index];
};

var createStyle = function createStyle() {
  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
  // insert rules after we insert the style tag.
  // It seems to kick-off the source order specificity algorithm.

  el.textContent = '\n';
  return el;
};

var DomRenderer =
/*#__PURE__*/
function () {
  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
  function DomRenderer(sheet) {
    this.getPropertyValue = getPropertyValue;
    this.setProperty = setProperty;
    this.removeProperty = removeProperty;
    this.setSelector = setSelector;
    this.element = void 0;
    this.sheet = void 0;
    this.hasInsertedRules = false;
    // There is no sheet when the renderer is used from a standalone StyleRule.
    if (sheet) sheets.add(sheet);
    this.sheet = sheet;

    var _ref = this.sheet ? this.sheet.options : {},
        media = _ref.media,
        meta = _ref.meta,
        element = _ref.element;

    this.element = element || createStyle();
    this.element.setAttribute('data-jss', '');
    if (media) this.element.setAttribute('media', media);
    if (meta) this.element.setAttribute('data-meta', meta);
    var nonce = getNonce();
    if (nonce) this.element.setAttribute('nonce', nonce);
  }
  /**
   * Insert style element into render tree.
   */


  var _proto = DomRenderer.prototype;

  _proto.attach = function attach() {
    // In the case the element node is external and it is already in the DOM.
    if (this.element.parentNode || !this.sheet) return;
    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
    // most browsers create a new CSSStyleSheet, except of all IEs.

    var deployed = Boolean(this.sheet && this.sheet.deployed);

    if (this.hasInsertedRules && deployed) {
      this.hasInsertedRules = false;
      this.deploy();
    }
  }
  /**
   * Remove style element from render tree.
   */
  ;

  _proto.detach = function detach() {
    var parentNode = this.element.parentNode;
    if (parentNode) parentNode.removeChild(this.element);
  }
  /**
   * Inject CSS string into element.
   */
  ;

  _proto.deploy = function deploy() {
    var sheet = this.sheet;
    if (!sheet) return;

    if (sheet.options.link) {
      this.insertRules(sheet.rules);
      return;
    }

    this.element.textContent = "\n" + sheet.toString() + "\n";
  }
  /**
   * Insert RuleList into an element.
   */
  ;

  _proto.insertRules = function insertRules(rules, nativeParent) {
    for (var i = 0; i < rules.index.length; i++) {
      this.insertRule(rules.index[i], i, nativeParent);
    }
  }
  /**
   * Insert a rule into element.
   */
  ;

  _proto.insertRule = function insertRule(rule, index, nativeParent) {
    if (nativeParent === void 0) {
      nativeParent = this.element.sheet;
    }

    if (rule.rules) {
      var parent = rule;
      var latestNativeParent = nativeParent;

      if (rule.type === 'conditional' || rule.type === 'keyframes') {
        // We need to render the container without children first.
        latestNativeParent = _insertRule(nativeParent, parent.toString({
          children: false
        }), index);

        if (latestNativeParent === false) {
          return false;
        }
      }

      this.insertRules(parent.rules, latestNativeParent);
      return latestNativeParent;
    } // IE keeps the CSSStyleSheet after style node has been reattached,
    // so we need to check if the `renderable` reference the right style sheet and not
    // rerender those rules.


    if (rule.renderable && rule.renderable.parentStyleSheet === this.element.sheet) {
      return rule.renderable;
    }

    var ruleStr = rule.toString();
    if (!ruleStr) return false;

    var nativeRule = _insertRule(nativeParent, ruleStr, index);

    if (nativeRule === false) {
      return false;
    }

    this.hasInsertedRules = true;
    rule.renderable = nativeRule;
    return nativeRule;
  }
  /**
   * Delete a rule.
   */
  ;

  _proto.deleteRule = function deleteRule(cssRule) {
    var sheet = this.element.sheet;
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    sheet.deleteRule(index);
    return true;
  }
  /**
   * Get index of a CSS Rule.
   */
  ;

  _proto.indexOf = function indexOf(cssRule) {
    var cssRules = this.element.sheet.cssRules;

    for (var index = 0; index < cssRules.length; index++) {
      if (cssRule === cssRules[index]) return index;
    }

    return -1;
  }
  /**
   * Generate a new CSS rule and replace the existing one.
   *
   * Only used for some old browsers because they can't set a selector.
   */
  ;

  _proto.replaceRule = function replaceRule(cssRule, rule) {
    var index = this.indexOf(cssRule);
    if (index === -1) return false;
    this.element.sheet.deleteRule(index);
    return this.insertRule(rule, index);
  }
  /**
   * Get all rules elements.
   */
  ;

  _proto.getRules = function getRules() {
    return this.element.sheet.cssRules;
  };

  return DomRenderer;
}();

var instanceCounter = 0;

var Jss =
/*#__PURE__*/
function () {
  function Jss(options) {
    this.id = instanceCounter++;
    this.version = "10.0.0";
    this.plugins = new PluginsRegistry();
    this.options = {
      id: {
        minify: false
      },
      createGenerateId: createGenerateId,
      Renderer: __WEBPACK_IMPORTED_MODULE_1_is_in_browser__["a" /* default */] ? DomRenderer : null,
      plugins: []
    };
    this.generateId = createGenerateId({
      minify: false
    });

    for (var i = 0; i < plugins.length; i++) {
      this.plugins.use(plugins[i], {
        queue: 'internal'
      });
    }

    this.setup(options);
  }
  /**
   * Prepares various options, applies plugins.
   * Should not be used twice on the same instance, because there is no plugins
   * deduplication logic.
   */


  var _proto = Jss.prototype;

  _proto.setup = function setup(options) {
    if (options === void 0) {
      options = {};
    }

    if (options.createGenerateId) {
      this.options.createGenerateId = options.createGenerateId;
    }

    if (options.id) {
      this.options.id = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.options.id, options.id);
    }

    if (options.createGenerateId || options.id) {
      this.generateId = this.options.createGenerateId(this.options.id);
    }

    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;

    if ('Renderer' in options) {
      this.options.Renderer = options.Renderer;
    } // eslint-disable-next-line prefer-spread


    if (options.plugins) this.use.apply(this, options.plugins);
    return this;
  }
  /**
   * Create a Style Sheet.
   */
  ;

  _proto.createStyleSheet = function createStyleSheet(styles, options) {
    if (options === void 0) {
      options = {};
    }

    var _options = options,
        index = _options.index;

    if (typeof index !== 'number') {
      index = sheets.index === 0 ? 0 : sheets.index + 1;
    }

    var sheet = new StyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      generateId: options.generateId || this.generateId,
      insertionPoint: this.options.insertionPoint,
      Renderer: this.options.Renderer,
      index: index
    }));
    this.plugins.onProcessSheet(sheet);
    return sheet;
  }
  /**
   * Detach the Style Sheet and remove it from the registry.
   */
  ;

  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
    sheet.detach();
    sheets.remove(sheet);
    return this;
  }
  /**
   * Create a rule without a Style Sheet.
   */
  ;

  _proto.createRule = function createRule$$1(name, style, options) {
    if (style === void 0) {
      style = {};
    }

    if (options === void 0) {
      options = {};
    }

    // Enable rule without name for inline styles.
    if (typeof name === 'object') {
      return this.createRule(undefined, name, style);
    }

    var ruleOptions = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      jss: this,
      Renderer: this.options.Renderer
    });

    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
    if (!ruleOptions.classes) ruleOptions.classes = {};
    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};

    var rule = createRule(name, style, ruleOptions);

    if (rule) this.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Register plugin. Passed function will be invoked with a rule instance.
   */
  ;

  _proto.use = function use() {
    var _this = this;

    for (var _len = arguments.length, plugins$$1 = new Array(_len), _key = 0; _key < _len; _key++) {
      plugins$$1[_key] = arguments[_key];
    }

    plugins$$1.forEach(function (plugin) {
      _this.plugins.use(plugin);
    });
    return this;
  };

  return Jss;
}();

/**
 * Extracts a styles object with only props that contain function values.
 */
function getDynamicStyles(styles) {
  var to = null;

  for (var key in styles) {
    var value = styles[key];
    var type = typeof value;

    if (type === 'function') {
      if (!to) to = {};
      to[key] = value;
    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
      var extracted = getDynamicStyles(value);

      if (extracted) {
        if (!to) to = {};
        to[key] = extracted;
      }
    }
  }

  return to;
}

/**
 * SheetsManager is like a WeakMap which is designed to count StyleSheet
 * instances and attach/detach automatically.
 */
var SheetsManager =
/*#__PURE__*/
function () {
  function SheetsManager() {
    this.length = 0;
    this.sheets = new WeakMap();
  }

  var _proto = SheetsManager.prototype;

  _proto.get = function get(key) {
    var entry = this.sheets.get(key);
    return entry && entry.sheet;
  };

  _proto.add = function add(key, sheet) {
    if (this.sheets.has(key)) return;
    this.length++;
    this.sheets.set(key, {
      sheet: sheet,
      refs: 0
    });
  };

  _proto.manage = function manage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs === 0) {
        entry.sheet.attach();
      }

      entry.refs++;
      return entry.sheet;
    }

    Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "[JSS] SheetsManager: can't find sheet to manage");
    return undefined;
  };

  _proto.unmanage = function unmanage(key) {
    var entry = this.sheets.get(key);

    if (entry) {
      if (entry.refs > 0) {
        entry.refs--;
        if (entry.refs === 0) entry.sheet.detach();
      }
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_2_tiny_warning__["default"])(false, "SheetsManager: can't find sheet to unmanage");
    }
  };

  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_createClass__["a" /* default */])(SheetsManager, [{
    key: "size",
    get: function get() {
      return this.length;
    }
  }]);

  return SheetsManager;
}();

/**
 * A better abstraction over CSS.
 *
 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
 * @website https://github.com/cssinjs/jss
 * @license MIT
 */

/**
 * Export a constant indicating if this browser has CSSTOM support.
 * https://developers.google.com/web/updates/2018/03/cssom
 */
var hasCSSTOMSupport = typeof CSS !== 'undefined' && CSS && 'number' in CSS;
/**
 * Creates a new instance of Jss.
 */

var create = function create(options) {
  return new Jss(options);
};
/**
 * A global Jss instance.
 */

var index = create();

/* unused harmony default export */ var _unused_webpack_default_export = (index);



/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__FormControlContext__ = __webpack_require__(177);


function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__FormControlContext__["a" /* default */]);
}

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(1092);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Select__["a"]; });


/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firebase", function() { return firebase; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_firebaseApp__ = __webpack_require__(1181);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var firebase = Object(__WEBPACK_IMPORTED_MODULE_0__src_firebaseApp__["a" /* createFirebaseNamespace */])();
/* harmony default export */ __webpack_exports__["default"] = (firebase);


//# sourceMappingURL=index.js.map


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Path_1 = __webpack_require__(29);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var util_3 = __webpack_require__(6);
var util_4 = __webpack_require__(6);
/**
 * True for invalid Firebase keys
 * @type {RegExp}
 * @private
 */
exports.INVALID_KEY_REGEX_ = /[\[\].#$\/\u0000-\u001F\u007F]/;
/**
 * True for invalid Firebase paths.
 * Allows '/' in paths.
 * @type {RegExp}
 * @private
 */
exports.INVALID_PATH_REGEX_ = /[\[\].#$\u0000-\u001F\u007F]/;
/**
 * Maximum number of characters to allow in leaf value
 * @type {number}
 * @private
 */
exports.MAX_LEAF_SIZE_ = 10 * 1024 * 1024;
/**
 * @param {*} key
 * @return {boolean}
 */
exports.isValidKey = function (key) {
    return (typeof key === 'string' && key.length !== 0 && !exports.INVALID_KEY_REGEX_.test(key));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
exports.isValidPathString = function (pathString) {
    return (typeof pathString === 'string' &&
        pathString.length !== 0 &&
        !exports.INVALID_PATH_REGEX_.test(pathString));
};
/**
 * @param {string} pathString
 * @return {boolean}
 */
exports.isValidRootPathString = function (pathString) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    return exports.isValidPathString(pathString);
};
/**
 * @param {*} priority
 * @return {boolean}
 */
exports.isValidPriority = function (priority) {
    return (priority === null ||
        typeof priority === 'string' ||
        (typeof priority === 'number' && !util_2.isInvalidJSONNumber(priority)) ||
        (priority && typeof priority === 'object' && util_1.contains(priority, '.sv')));
};
/**
 * Pre-validate a datum passed as an argument to Firebase function.
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
exports.validateFirebaseDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    exports.validateFirebaseData(util_3.errorPrefix(fnName, argumentNumber, optional), data, path);
};
/**
 * Validate a data object client-side before sending to server.
 *
 * @param {string} errorPrefix
 * @param {*} data
 * @param {!Path|!ValidationPath} path_
 */
exports.validateFirebaseData = function (errorPrefix, data, path_) {
    var path = path_ instanceof Path_1.Path ? new Path_1.ValidationPath(path_, errorPrefix) : path_;
    if (data === undefined) {
        throw new Error(errorPrefix + 'contains undefined ' + path.toErrorString());
    }
    if (typeof data === 'function') {
        throw new Error(errorPrefix +
            'contains a function ' +
            path.toErrorString() +
            ' with contents = ' +
            data.toString());
    }
    if (util_2.isInvalidJSONNumber(data)) {
        throw new Error(errorPrefix + 'contains ' + data.toString() + ' ' + path.toErrorString());
    }
    // Check max leaf size, but try to avoid the utf8 conversion if we can.
    if (typeof data === 'string' &&
        data.length > exports.MAX_LEAF_SIZE_ / 3 &&
        util_4.stringLength(data) > exports.MAX_LEAF_SIZE_) {
        throw new Error(errorPrefix +
            'contains a string greater than ' +
            exports.MAX_LEAF_SIZE_ +
            ' utf8 bytes ' +
            path.toErrorString() +
            " ('" +
            data.substring(0, 50) +
            "...')");
    }
    // TODO = Perf = Consider combining the recursive validation of keys into NodeFromJSON
    // to save extra walking of large objects.
    if (data && typeof data === 'object') {
        var hasDotValue_1 = false, hasActualChild_1 = false;
        util_1.forEach(data, function (key, value) {
            if (key === '.value') {
                hasDotValue_1 = true;
            }
            else if (key !== '.priority' && key !== '.sv') {
                hasActualChild_1 = true;
                if (!exports.isValidKey(key)) {
                    throw new Error(errorPrefix +
                        ' contains an invalid key (' +
                        key +
                        ') ' +
                        path.toErrorString() +
                        '.  Keys must be non-empty strings ' +
                        'and can\'t contain ".", "#", "$", "/", "[", or "]"');
                }
            }
            path.push(key);
            exports.validateFirebaseData(errorPrefix, value, path);
            path.pop();
        });
        if (hasDotValue_1 && hasActualChild_1) {
            throw new Error(errorPrefix +
                ' contains ".value" child ' +
                path.toErrorString() +
                ' in addition to actual children.');
        }
    }
};
/**
 * Pre-validate paths passed in the firebase function.
 *
 * @param {string} errorPrefix
 * @param {Array<!Path>} mergePaths
 */
exports.validateFirebaseMergePaths = function (errorPrefix, mergePaths) {
    var i, curPath;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        var keys = curPath.slice();
        for (var j = 0; j < keys.length; j++) {
            if (keys[j] === '.priority' && j === keys.length - 1) {
                // .priority is OK
            }
            else if (!exports.isValidKey(keys[j])) {
                throw new Error(errorPrefix +
                    'contains an invalid key (' +
                    keys[j] +
                    ') in path ' +
                    curPath.toString() +
                    '. Keys must be non-empty strings ' +
                    'and can\'t contain ".", "#", "$", "/", "[", or "]"');
            }
        }
    }
    // Check that update keys are not descendants of each other.
    // We rely on the property that sorting guarantees that ancestors come
    // right before descendants.
    mergePaths.sort(Path_1.Path.comparePaths);
    var prevPath = null;
    for (i = 0; i < mergePaths.length; i++) {
        curPath = mergePaths[i];
        if (prevPath !== null && prevPath.contains(curPath)) {
            throw new Error(errorPrefix +
                'contains a path ' +
                prevPath.toString() +
                ' that is ancestor of another path ' +
                curPath.toString());
        }
        prevPath = curPath;
    }
};
/**
 * pre-validate an object passed as an argument to firebase function (
 * must be an object - e.g. for firebase.update()).
 *
 * @param {string} fnName
 * @param {number} argumentNumber
 * @param {*} data
 * @param {!Path} path
 * @param {boolean} optional
 */
exports.validateFirebaseMergeDataArg = function (fnName, argumentNumber, data, path, optional) {
    if (optional && data === undefined)
        return;
    var errorPrefix = util_3.errorPrefix(fnName, argumentNumber, optional);
    if (!(data && typeof data === 'object') || Array.isArray(data)) {
        throw new Error(errorPrefix + ' must be an object containing the children to replace.');
    }
    var mergePaths = [];
    util_1.forEach(data, function (key, value) {
        var curPath = new Path_1.Path(key);
        exports.validateFirebaseData(errorPrefix, value, path.child(curPath));
        if (curPath.getBack() === '.priority') {
            if (!exports.isValidPriority(value)) {
                throw new Error(errorPrefix +
                    "contains an invalid value for '" +
                    curPath.toString() +
                    "', which must be a valid " +
                    'Firebase priority (a string, finite number, server value, or null).');
            }
        }
        mergePaths.push(curPath);
    });
    exports.validateFirebaseMergePaths(errorPrefix, mergePaths);
};
exports.validatePriority = function (fnName, argumentNumber, priority, optional) {
    if (optional && priority === undefined)
        return;
    if (util_2.isInvalidJSONNumber(priority))
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'is ' +
            priority.toString() +
            ', but must be a valid Firebase priority (a string, finite number, ' +
            'server value, or null).');
    // Special case to allow importing data with a .sv.
    if (!exports.isValidPriority(priority))
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid Firebase priority ' +
            '(a string, finite number, server value, or null).');
};
exports.validateEventType = function (fnName, argumentNumber, eventType, optional) {
    if (optional && eventType === undefined)
        return;
    switch (eventType) {
        case 'value':
        case 'child_added':
        case 'child_removed':
        case 'child_changed':
        case 'child_moved':
            break;
        default:
            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
                'must be a valid event type = "value", "child_added", "child_removed", ' +
                '"child_changed", or "child_moved".');
    }
};
exports.validateKey = function (fnName, argumentNumber, key, optional) {
    if (optional && key === undefined)
        return;
    if (!exports.isValidKey(key))
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid key = "' +
            key +
            '".  Firebase keys must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "/", "[", or "]").');
};
exports.validatePathString = function (fnName, argumentNumber, pathString, optional) {
    if (optional && pathString === undefined)
        return;
    if (!exports.isValidPathString(pathString))
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'was an invalid path = "' +
            pathString +
            '". Paths must be non-empty strings and ' +
            'can\'t contain ".", "#", "$", "[", or "]"');
};
exports.validateRootPathString = function (fnName, argumentNumber, pathString, optional) {
    if (pathString) {
        // Allow '/.info/' at the beginning.
        pathString = pathString.replace(/^\/*\.info(\/|$)/, '/');
    }
    exports.validatePathString(fnName, argumentNumber, pathString, optional);
};
exports.validateWritablePath = function (fnName, path) {
    if (path.getFront() === '.info') {
        throw new Error(fnName + " failed = Can't modify data under /.info/");
    }
};
exports.validateUrl = function (fnName, argumentNumber, parsedUrl) {
    // TODO = Validate server better.
    var pathString = parsedUrl.path.toString();
    if (!(typeof parsedUrl.repoInfo.host === 'string') ||
        parsedUrl.repoInfo.host.length === 0 ||
        (!exports.isValidKey(parsedUrl.repoInfo.namespace) &&
            parsedUrl.repoInfo.host.split(':')[0] !== 'localhost') ||
        (pathString.length !== 0 && !exports.isValidRootPathString(pathString))) {
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, false) +
            'must be a valid firebase URL and ' +
            'the path can\'t contain ".", "#", "$", "[", or "]".');
    }
};
exports.validateCredential = function (fnName, argumentNumber, cred, optional) {
    if (optional && cred === undefined)
        return;
    if (!(typeof cred === 'string'))
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid credential (a string).');
};
exports.validateBoolean = function (fnName, argumentNumber, bool, optional) {
    if (optional && bool === undefined)
        return;
    if (typeof bool !== 'boolean')
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) + 'must be a boolean.');
};
exports.validateString = function (fnName, argumentNumber, string, optional) {
    if (optional && string === undefined)
        return;
    if (!(typeof string === 'string')) {
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid string.');
    }
};
exports.validateObject = function (fnName, argumentNumber, obj, optional) {
    if (optional && obj === undefined)
        return;
    if (!(obj && typeof obj === 'object') || obj === null) {
        throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid object.');
    }
};
exports.validateObjectContainsKey = function (fnName, argumentNumber, obj, key, optional, opt_type) {
    var objectContainsKey = obj && typeof obj === 'object' && util_1.contains(obj, key);
    if (!objectContainsKey) {
        if (optional) {
            return;
        }
        else {
            throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
                'must contain the key "' +
                key +
                '"');
        }
    }
    if (opt_type) {
        var val = util_1.safeGet(obj, key);
        if ((opt_type === 'number' && !(typeof val === 'number')) ||
            (opt_type === 'string' && !(typeof val === 'string')) ||
            (opt_type === 'boolean' && !(typeof val === 'boolean')) ||
            (opt_type === 'function' && !(typeof val === 'function')) ||
            (opt_type === 'object' && !(typeof val === 'object') && val)) {
            if (optional) {
                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
                    'contains invalid value for key "' +
                    key +
                    '" (must be of type "' +
                    opt_type +
                    '")');
            }
            else {
                throw new Error(util_3.errorPrefix(fnName, argumentNumber, optional) +
                    'must contain the key "' +
                    key +
                    '" with type "' +
                    opt_type +
                    '"');
            }
        }
    }
};

//# sourceMappingURL=validation.js.map


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 *
 * @enum
 */
var OperationType;
(function (OperationType) {
    OperationType[OperationType["OVERWRITE"] = 0] = "OVERWRITE";
    OperationType[OperationType["MERGE"] = 1] = "MERGE";
    OperationType[OperationType["ACK_USER_WRITE"] = 2] = "ACK_USER_WRITE";
    OperationType[OperationType["LISTEN_COMPLETE"] = 3] = "LISTEN_COMPLETE";
})(OperationType = exports.OperationType || (exports.OperationType = {}));
/**
 * @param {boolean} fromUser
 * @param {boolean} fromServer
 * @param {?string} queryId
 * @param {boolean} tagged
 * @constructor
 */
var OperationSource = /** @class */ (function () {
    function OperationSource(fromUser, fromServer, queryId, tagged) {
        this.fromUser = fromUser;
        this.fromServer = fromServer;
        this.queryId = queryId;
        this.tagged = tagged;
        util_1.assert(!tagged || fromServer, 'Tagged queries must be from server.');
    }
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.User = new OperationSource(
    /*fromUser=*/ true, false, null, 
    /*tagged=*/ false);
    /**
     * @const
     * @type {!OperationSource}
     */
    OperationSource.Server = new OperationSource(false, 
    /*fromServer=*/ true, null, 
    /*tagged=*/ false);
    /**
     * @param {string} queryId
     * @return {!OperationSource}
     */
    OperationSource.forServerTaggedQuery = function (queryId) {
        return new OperationSource(false, 
        /*fromServer=*/ true, queryId, 
        /*tagged=*/ true);
    };
    return OperationSource;
}());
exports.OperationSource = OperationSource;

//# sourceMappingURL=Operation.js.map


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = uncontrollable;

var _react = _interopRequireDefault(__webpack_require__(0));

var _invariant = _interopRequireDefault(__webpack_require__(35));

var Utils = _interopRequireWildcard(__webpack_require__(1280));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function uncontrollable(Component, controlledValues, methods) {
  if (methods === void 0) {
    methods = [];
  }

  var displayName = Component.displayName || Component.name || 'Component';
  var isCompositeComponent = Utils.isReactComponent(Component);
  var controlledProps = Object.keys(controlledValues);
  var PROPS_TO_OMIT = controlledProps.map(Utils.defaultKey);
  !(isCompositeComponent || !methods.length) ?  false ? (0, _invariant.default)(false, '[uncontrollable] stateless function components cannot pass through methods ' + 'because they have no associated instances. Check component: ' + displayName + ', ' + 'attempting to pass through methods: ' + methods.join(', ')) : invariant(false) : void 0;

  var UncontrolledComponent =
  /*#__PURE__*/
  function (_React$Component) {
    _inheritsLoose(UncontrolledComponent, _React$Component);

    function UncontrolledComponent() {
      var _this;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
      _this.handlers = Object.create(null);
      controlledProps.forEach(function (propName) {
        var handlerName = controlledValues[propName];

        var handleChange = function handleChange(value) {
          if (_this.props[handlerName]) {
            var _this$props;

            _this._notifying = true;

            for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
              args[_key2 - 1] = arguments[_key2];
            }

            (_this$props = _this.props)[handlerName].apply(_this$props, [value].concat(args));

            _this._notifying = false;
          }

          _this._values[propName] = value;
          if (!_this.unmounted) _this.forceUpdate();
        };

        _this.handlers[handlerName] = handleChange;
      });
      if (isCompositeComponent) _this.attachRef = function (ref) {
        _this.inner = ref;
      };
      return _this;
    }

    var _proto = UncontrolledComponent.prototype;

    _proto.shouldComponentUpdate = function shouldComponentUpdate() {
      //let the forceUpdate trigger the update
      return !this._notifying;
    };

    _proto.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var props = this.props;
      this._values = Object.create(null);
      controlledProps.forEach(function (key) {
        _this2._values[key] = props[Utils.defaultKey(key)];
      });
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      var props = this.props;
      controlledProps.forEach(function (key) {
        /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */
        if (!Utils.isProp(nextProps, key) && Utils.isProp(props, key)) {
          _this3._values[key] = nextProps[Utils.defaultKey(key)];
        }
      });
    };

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.unmounted = true;
    };

    _proto.getControlledInstance = function getControlledInstance() {
      return this.inner;
    };

    _proto.render = function render() {
      var _this4 = this;

      var props = _extends({}, this.props);

      PROPS_TO_OMIT.forEach(function (prop) {
        delete props[prop];
      });
      var newProps = {};
      controlledProps.forEach(function (propName) {
        var propValue = _this4.props[propName];
        newProps[propName] = propValue !== undefined ? propValue : _this4._values[propName];
      });
      return _react.default.createElement(Component, _extends({}, props, newProps, this.handlers, {
        ref: this.attachRef
      }));
    };

    return UncontrolledComponent;
  }(_react.default.Component);

  UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
  UncontrolledComponent.propTypes = Utils.uncontrolledPropTypes(controlledValues, displayName);
  methods.forEach(function (method) {
    UncontrolledComponent.prototype[method] = function $proxiedMethod() {
      var _inner;

      return (_inner = this.inner)[method].apply(_inner, arguments);
    };
  });
  UncontrolledComponent.ControlledComponent = Component;
  /**
   * useful when wrapping a Component and you want to control
   * everything
   */

  UncontrolledComponent.deferControlTo = function (newComponent, additions, nextMethods) {
    if (additions === void 0) {
      additions = {};
    }

    return uncontrollable(newComponent, _extends({}, controlledValues, additions), nextMethods);
  };

  return UncontrolledComponent;
}

module.exports = exports["default"];

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(501)('wks');
var uid = __webpack_require__(503);
var Symbol = __webpack_require__(120).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34a.9959.9959 0 00-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
}), 'Edit');

exports.default = _default;

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__capitalize__ = __webpack_require__(16);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__capitalize__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deprecatedPropType__ = __webpack_require__(1469);
/* unused harmony reexport deprecatedPropType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isMuiElement__ = __webpack_require__(141);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__isMuiElement__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ownerDocument__ = __webpack_require__(85);
/* unused harmony reexport ownerDocument */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ownerWindow__ = __webpack_require__(139);
/* unused harmony reexport ownerWindow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__requirePropFactory__ = __webpack_require__(422);
/* unused harmony reexport requirePropFactory */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__setRef__ = __webpack_require__(82);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_6__setRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__unsupportedProp__ = __webpack_require__(175);
/* unused harmony reexport unsupportedProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useEventCallback__ = __webpack_require__(83);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_8__useEventCallback__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__useForkRef__ = __webpack_require__(28);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_9__useForkRef__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__focusVisible__ = __webpack_require__(136);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_10__focusVisible__["a"]; });












/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = actionGetUsers;
/* harmony export (immutable) */ __webpack_exports__["e"] = actionGetUsersByReg;
/* harmony export (immutable) */ __webpack_exports__["d"] = actionGetUsersByEmailOrDU;
/* harmony export (immutable) */ __webpack_exports__["f"] = actionGetUsersFromExcel;
/* harmony export (immutable) */ __webpack_exports__["g"] = actionSaveUser;
/* harmony export (immutable) */ __webpack_exports__["i"] = actionTransferPoints;
/* harmony export (immutable) */ __webpack_exports__["b"] = actionDeleteUser;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionAddTagsToUsers;
/* harmony export (immutable) */ __webpack_exports__["h"] = actionSendNotification;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/*** ACTIONS USERS ******/function actionGetUsers(filter,order,limit,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].getUsers(getStore().app.app,filter,order,limit).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["j" /* ACT_USR_CHANGE */],props:{userList:response// response con formato {items:[], size:0}
}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetUsersByReg(filter,succesCallback,errorCallback){return function(dispatch,getStore){// loading(true)(dispatch, getStore)
__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].getUsersByReg(getStore().app.app,filter).then(function(response){// dispatch({
//     type:ACT_USR_CHANGE,
//     props: {userList:response}
// })
succesCallback&&succesCallback(response);}).catch(errorCallback);// .finally(()=>{loading(false)(dispatch, getStore)})
};}function actionGetUsersByEmailOrDU(usersDU,usersEmail,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].getUsersByEmailOrDU(getStore().app.app,usersDU,usersEmail).then(function(response){// dispatch({
//   type:ACT_USR_CHANGE,
//   props: {user:response}
// })
succesCallback&&succesCallback(response);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetUsersFromExcel(file,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].uploadFile(file,"temp","excel").then(function(res){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].getUsersFromStorage(res.path,res.filename).then(function(response){console.log("RESPONSE",response);successCallback(response);}).finally(function(){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(res.path);Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveUser(user,successCallback,errorCallback){// if (process.env.REACT_APP_HAS_BIRTHDATE_MIGRATED) {
//   const { proBirthDate } = user;
//   if (proBirthDate) {
//     // console.log("actionSaveUser proBirthDate",proBirthDate, proBirthDate._seconds)
//     // const { _seconds } = proBirthDate;
//     console.log("actionSaveUser proBirthDate _seconds",proBirthDate)
//     user.proBirthDate = moment.unix(proBirthDate).toDate();
//   }
// }
return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].saveUser(getStore().app.app,user).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionTransferPoints(points,dni,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].transferPoints(getStore().app.app,points,dni).then(function(response){succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeleteUser(user,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].deleteUser(getStore().app.app,user.id).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionAddTagsToUsers(tags,allUsersSelected,users,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].addTagsToUsers(getStore().app.app,tags,allUsersSelected,users).then(function(response){succesCallback&&succesCallback(response);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSendNotification(user,notification,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);if(notification.image&&notification.image!={}){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].uploadFile(notification.image,"temp","image").then(function(res){notification.image=res.downloadURL;__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].sendNotification(getStore().app.app,user,notification).then(function(response){successCallback();}).catch(errorCallback).finally(function(){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(res.path);});}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}else{__WEBPACK_IMPORTED_MODULE_1__provider_user_UserService__["a" /* default */].sendNotification(getStore().app.app,user,notification).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}};}/****** FIN ACTION USERS +**********/

/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
}), 'Sync');

exports.default = _default;

/***/ }),
/* 102 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.10' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var hide = __webpack_require__(104);
var has = __webpack_require__(107);
var SRC = __webpack_require__(156)('src');
var $toString = __webpack_require__(593);
var TO_STRING = 'toString';
var TPL = ('' + $toString).split(TO_STRING);

__webpack_require__(102).inspectSource = function (it) {
  return $toString.call(it);
};

(module.exports = function (O, key, val, safe) {
  var isFunction = typeof val == 'function';
  if (isFunction) has(val, 'name') || hide(val, 'name', key);
  if (O[key] === val) return;
  if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
  if (O === global) {
    O[key] = val;
  } else if (!safe) {
    delete O[key];
    hide(O, key, val);
  } else if (O[key]) {
    O[key] = val;
  } else {
    hide(O, key, val);
  }
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, TO_STRING, function toString() {
  return typeof this == 'function' && this[SRC] || $toString.call(this);
});


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(105);
var createDesc = __webpack_require__(216);
module.exports = __webpack_require__(87) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(106);
var IE8_DOM_DEFINE = __webpack_require__(306);
var toPrimitive = __webpack_require__(308);
var dP = Object.defineProperty;

exports.f = __webpack_require__(87) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(78);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getRawTag_js__ = __webpack_require__(666);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__objectToString_js__ = __webpack_require__(667);




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? Object(__WEBPACK_IMPORTED_MODULE_1__getRawTag_js__["a" /* default */])(value)
    : Object(__WEBPACK_IMPORTED_MODULE_2__objectToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetTag);


/***/ }),
/* 110 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CSSTransition__ = __webpack_require__(934);
/* unused harmony reexport CSSTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ReplaceTransition__ = __webpack_require__(938);
/* unused harmony reexport ReplaceTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SwitchTransition__ = __webpack_require__(940);
/* unused harmony reexport SwitchTransition */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__ = __webpack_require__(399);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_3__TransitionGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Transition__ = __webpack_require__(253);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_4__Transition__["d"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(397);
/* unused harmony reexport config */







/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return reflow; });
/* harmony export (immutable) */ __webpack_exports__["a"] = getTransitionProps;
var reflow = function reflow(node) {
  return node.scrollTop;
};
function getTransitionProps(props, options) {
  var timeout = props.timeout,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style;
  return {
    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    delay: style.transitionDelay
  };
}

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SvgIcon__ = __webpack_require__(965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__SvgIcon__["a"]; });


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce(func) {
  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
  var timeout;

  function debounced() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // eslint-disable-next-line consistent-this
    var that = this;

    var later = function later() {
      func.apply(that, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = function () {
    clearTimeout(timeout);
  };

  return debounced;
}

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = formControlState;
function formControlState(_ref) {
  var props = _ref.props,
      states = _ref.states,
      muiFormControl = _ref.muiFormControl;
  return states.reduce(function (acc, state) {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @constructor
 * @struct
 * @param {!string} type The event type
 * @param {!Node} snapshotNode The data
 * @param {string=} childName The name for this child, if it's a child event
 * @param {Node=} oldSnap Used for intermediate processing of child changed events
 * @param {string=} prevName The name for the previous child, if applicable
 */
var Change = /** @class */ (function () {
    function Change(type, snapshotNode, childName, oldSnap, prevName) {
        this.type = type;
        this.snapshotNode = snapshotNode;
        this.childName = childName;
        this.oldSnap = oldSnap;
        this.prevName = prevName;
    }
    /**
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.valueChange = function (snapshot) {
        return new Change(Change.VALUE, snapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childAddedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_ADDED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childRemovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_REMOVED, snapshot, childKey);
    };
    /**
     * @param {string} childKey
     * @param {!Node} newSnapshot
     * @param {!Node} oldSnapshot
     * @return {!Change}
     */
    Change.childChangedChange = function (childKey, newSnapshot, oldSnapshot) {
        return new Change(Change.CHILD_CHANGED, newSnapshot, childKey, oldSnapshot);
    };
    /**
     * @param {string} childKey
     * @param {!Node} snapshot
     * @return {!Change}
     */
    Change.childMovedChange = function (childKey, snapshot) {
        return new Change(Change.CHILD_MOVED, snapshot, childKey);
    };
    //event types
    /** Event type for a child added */
    Change.CHILD_ADDED = 'child_added';
    /** Event type for a child removed */
    Change.CHILD_REMOVED = 'child_removed';
    /** Event type for a child changed */
    Change.CHILD_CHANGED = 'child_changed';
    /** Event type for a child moved */
    Change.CHILD_MOVED = 'child_moved';
    /** Event type for a value change */
    Change.VALUE = 'value';
    return Change;
}());
exports.Change = Change;

//# sourceMappingURL=Change.js.map


/***/ }),
/* 120 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(148)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1284);

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = ownerDocument;

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = exports["default"];

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var _default = function () {
  // HTML DOM and SVG DOM may have different support levels,
  // so we need to check on context instead of a document root element.
  return _inDOM.default ? function (context, node) {
    if (context.contains) {
      return context.contains(node);
    } else if (context.compareDocumentPosition) {
      return context === node || !!(context.compareDocumentPosition(node) & 16);
    } else {
      return fallback(context, node);
    }
  } : fallback;
}();

exports.default = _default;

function fallback(context, node) {
  if (node) do {
    if (node === context) return true;
  } while (node = node.parentNode);
  return false;
}

module.exports = exports["default"];

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (componentOrElement) {
  return (0, _ownerDocument2.default)(_reactDom2.default.findDOMNode(componentOrElement));
};

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _ownerDocument = __webpack_require__(123);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var ReactCurrentOwner = __webpack_require__(548);

var warning = __webpack_require__(80);
var canDefineProperty = __webpack_require__(549);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(550);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetPlaces;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionSavePlace;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeletePlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_place_PlaceService__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
// TODO
/*** ACTIONS PlaceS ******/function actionGetPlaces(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_place_PlaceService__["a" /* default */].getPlaces(getStore().app.app).then(function(response){// console.log("PLACES RESPONSE", response)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["f" /* ACT_PLC_CHANGE */],props:{placeList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSavePlace(place,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_place_PlaceService__["a" /* default */].savePlace(getStore().app.app,place).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeletePlace(place,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_place_PlaceService__["a" /* default */].deletePlace(getStore().app.app,place.id).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/****** FIN ACTION PlaceS +**********/

/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var formatName = function formatName(_ref, name) {
  var sectionPrefix = _ref._reduxForm.sectionPrefix;
  return sectionPrefix ? sectionPrefix + '.' + name : name;
};


/* harmony default export */ __webpack_exports__["a"] = (formatName);

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/* harmony default export */ __webpack_exports__["a"] = (eq);


/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isSymbol_js__ = __webpack_require__(163);


/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__isSymbol_js__["a" /* default */])(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (toKey);


/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(238);



/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLike);


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useTheme__ = __webpack_require__(893);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useTheme__["a"]; });


/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createMuiTheme__ = __webpack_require__(377);

var defaultTheme = Object(__WEBPACK_IMPORTED_MODULE_0__createMuiTheme__["a" /* default */])();
/* harmony default export */ __webpack_exports__["a"] = (defaultTheme);

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export teardown */
/* harmony export (immutable) */ __webpack_exports__["a"] = useIsFocusVisible;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js


var hadKeyboardEvent = true;
var hadFocusVisibleRecently = false;
var hadFocusVisibleRecentlyTimeout = null;
var inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @return {boolean}
 */

function focusTriggersKeyboardModality(node) {
  var type = node.type,
      tagName = node.tagName;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(ownerDocument) {
  ownerDocument.addEventListener('keydown', handleKeyDown, true);
  ownerDocument.addEventListener('mousedown', handlePointerDown, true);
  ownerDocument.addEventListener('pointerdown', handlePointerDown, true);
  ownerDocument.addEventListener('touchstart', handlePointerDown, true);
  ownerDocument.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function teardown(ownerDocument) {
  ownerDocument.removeEventListener('keydown', handleKeyDown, true);
  ownerDocument.removeEventListener('mousedown', handlePointerDown, true);
  ownerDocument.removeEventListener('pointerdown', handlePointerDown, true);
  ownerDocument.removeEventListener('touchstart', handlePointerDown, true);
  ownerDocument.removeEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  var target = event.target;

  try {
    return target.matches(':focus-visible');
  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
  // we use our own heuristic for those browsers
  // rethrow might be better if it's not the expected error but do we really
  // want to crash if focus-visible malfunctioned?
  // no need for validFocusTarget check. the user does that by attaching it to
  // focusable events only


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}
/**
 * Should be called if a blur event is fired on a focus-visible element
 */


function handleBlurVisible() {
  // To detect a tab/window switch, we look for a blur event followed
  // rapidly by a visibility change.
  // If we don't see a visibility change within 100ms, it's probably a
  // regular focus change.
  hadFocusVisibleRecently = true;
  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
    hadFocusVisibleRecently = false;
  }, 100);
}

function useIsFocusVisible() {
  var ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (instance) {
    var node = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(instance);

    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  return {
    isFocusVisible: isFocusVisible,
    onBlurVisible: handleBlurVisible,
    ref: ref
  };
}

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__IconButton__ = __webpack_require__(983);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__IconButton__["a"]; });


/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createChainedFunction;
/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */
function createChainedFunction() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  return funcs.reduce(function (acc, func) {
    if (func == null) {
      return acc;
    }

    if (false) {
      if (typeof func !== 'function') {
        console.error('Material-UI: invalid Argument Type, must only provide functions, undefined, or null.');
      }
    }

    return function chainedFunction() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      acc.apply(this, args);
      func.apply(this, args);
    };
  }, function () {});
}

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ownerDocument__ = __webpack_require__(85);


function ownerWindow(node) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_0__ownerDocument__["a" /* default */])(node);
  return doc.defaultView || window;
}

/* harmony default export */ __webpack_exports__["a"] = (ownerWindow);

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputBase__ = __webpack_require__(1026);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputBase__["a"]; });


/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isMuiElement;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

function isMuiElement(element, muiNames) {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var ListContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({});
/* harmony default export */ __webpack_exports__["a"] = (ListContext);

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var Tablelvl2Context = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["a"] = (Tablelvl2Context);

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = createComponent;

var _react = __webpack_require__(0);

var _utils = __webpack_require__(1161);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Creates a component class that renders the given Material UI component
 *
 * @param MaterialUIComponent The material ui component to render
 * @param mapProps A mapping of props provided by redux-form to the props the Material UI
 * component needs
 */
function createComponent(MaterialUIComponent, mapProps) {
  var InputComponent = function (_Component) {
    _inherits(InputComponent, _Component);

    function InputComponent() {
      _classCallCheck(this, InputComponent);

      return _possibleConstructorReturn(this, (InputComponent.__proto__ || Object.getPrototypeOf(InputComponent)).apply(this, arguments));
    }

    _createClass(InputComponent, [{
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.component;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this2 = this;

        return (0, _react.createElement)(MaterialUIComponent, _extends({}, mapProps(this.props), {
          ref: !(0, _utils.isStateLess)(MaterialUIComponent) ? function (el) {
            return _this2.component = el;
          } : null
        }));
      }
    }]);

    return InputComponent;
  }(_react.Component);

  InputComponent.displayName = 'ReduxFormMaterialUI' + MaterialUIComponent.name;
  return InputComponent;
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var Index_1 = __webpack_require__(184);
var Node_1 = __webpack_require__(53);
var util_1 = __webpack_require__(21);
var util_2 = __webpack_require__(6);
var __EMPTY_NODE;
var KeyIndex = /** @class */ (function (_super) {
    tslib_1.__extends(KeyIndex, _super);
    function KeyIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(KeyIndex, "__EMPTY_NODE", {
        get: function () {
            return __EMPTY_NODE;
        },
        set: function (val) {
            __EMPTY_NODE = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.compare = function (a, b) {
        return util_1.nameCompare(a.name, b.name);
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.isDefinedOn = function (node) {
        // We could probably return true here (since every node has a key), but it's never called
        // so just leaving unimplemented for now.
        throw util_2.assertionError('KeyIndex.isDefinedOn not expected to be called.');
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return false; // The key for a node never changes.
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.minPost = function () {
        return Node_1.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    KeyIndex.prototype.maxPost = function () {
        // TODO: This should really be created once and cached in a static property, but
        // NamedNode isn't defined yet, so I can't use it in a static.  Bleh.
        return new Node_1.NamedNode(util_1.MAX_NAME, __EMPTY_NODE);
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    KeyIndex.prototype.makePost = function (indexValue, name) {
        util_2.assert(typeof indexValue === 'string', 'KeyIndex indexValue must always be a string.');
        // We just use empty node, but it'll never be compared, since our comparator only looks at name.
        return new Node_1.NamedNode(indexValue, __EMPTY_NODE);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    KeyIndex.prototype.toString = function () {
        return '.key';
    };
    return KeyIndex;
}(Index_1.Index));
exports.KeyIndex = KeyIndex;
exports.KEY_INDEX = new KeyIndex();

//# sourceMappingURL=KeyIndex.js.map


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenNode_1 = __webpack_require__(49);
var LeafNode_1 = __webpack_require__(185);
var Node_1 = __webpack_require__(53);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var childSet_1 = __webpack_require__(469);
var comparators_1 = __webpack_require__(470);
var IndexMap_1 = __webpack_require__(468);
var PriorityIndex_1 = __webpack_require__(42);
var USE_HINZE = true;
/**
 * Constructs a snapshot node representing the passed JSON and returns it.
 * @param {*} json JSON to create a node for.
 * @param {?string|?number=} priority Optional priority to use.  This will be ignored if the
 * passed JSON contains a .priority property.
 * @return {!Node}
 */
function nodeFromJSON(json, priority) {
    if (priority === void 0) { priority = null; }
    if (json === null) {
        return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
    }
    if (typeof json === 'object' && '.priority' in json) {
        priority = json['.priority'];
    }
    util_2.assert(priority === null ||
        typeof priority === 'string' ||
        typeof priority === 'number' ||
        (typeof priority === 'object' && '.sv' in priority), 'Invalid priority type found: ' + typeof priority);
    if (typeof json === 'object' && '.value' in json && json['.value'] !== null) {
        json = json['.value'];
    }
    // Valid leaf nodes include non-objects or server-value wrapper objects
    if (typeof json !== 'object' || '.sv' in json) {
        var jsonLeaf = json;
        return new LeafNode_1.LeafNode(jsonLeaf, nodeFromJSON(priority));
    }
    if (!(json instanceof Array) && USE_HINZE) {
        var children_1 = [];
        var childrenHavePriority_1 = false;
        var hinzeJsonObj_1 = json;
        util_1.forEach(hinzeJsonObj_1, function (key, child) {
            if (typeof key !== 'string' || key.substring(0, 1) !== '.') {
                // Ignore metadata nodes
                var childNode = nodeFromJSON(hinzeJsonObj_1[key]);
                if (!childNode.isEmpty()) {
                    childrenHavePriority_1 =
                        childrenHavePriority_1 || !childNode.getPriority().isEmpty();
                    children_1.push(new Node_1.NamedNode(key, childNode));
                }
            }
        });
        if (children_1.length == 0) {
            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        }
        var childSet = childSet_1.buildChildSet(children_1, comparators_1.NAME_ONLY_COMPARATOR, function (namedNode) { return namedNode.name; }, comparators_1.NAME_COMPARATOR);
        if (childrenHavePriority_1) {
            var sortedChildSet = childSet_1.buildChildSet(children_1, PriorityIndex_1.PRIORITY_INDEX.getCompare());
            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), new IndexMap_1.IndexMap({ '.priority': sortedChildSet }, { '.priority': PriorityIndex_1.PRIORITY_INDEX }));
        }
        else {
            return new ChildrenNode_1.ChildrenNode(childSet, nodeFromJSON(priority), IndexMap_1.IndexMap.Default);
        }
    }
    else {
        var node_1 = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        var jsonObj_1 = json;
        util_1.forEach(jsonObj_1, function (key, childData) {
            if (util_1.contains(jsonObj_1, key)) {
                if (key.substring(0, 1) !== '.') {
                    // ignore metadata nodes.
                    var childNode = nodeFromJSON(childData);
                    if (childNode.isLeafNode() || !childNode.isEmpty())
                        node_1 = node_1.updateImmediateChild(key, childNode);
                }
            }
        });
        return node_1.updatePriority(nodeFromJSON(priority));
    }
}
exports.nodeFromJSON = nodeFromJSON;
PriorityIndex_1.setNodeFromJSON(nodeFromJSON);

//# sourceMappingURL=nodeFromJSON.js.map


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.15';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading and trailing whitespace. */
  var reTrim = /^\s+|\s+$/g,
      reTrimStart = /^\s+/,
      reTrimEnd = /\s+$/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      var index = -1;
      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      value = iteratee(value);

      var low = 0,
          high = array == null ? 0 : array.length,
          valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(array);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked && stack.get(other)) {
        return stacked == other;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = value.replace(reTrim, '');
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // with lookup (in case of e.g. prototype pollution), and strip newlines if any.
      // A newline wouldn't be a valid sourceURL anyway, and it'd enable code injection.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/[\r\n]/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      // Like with sourceURL, we take care to not check the option's prototype,
      // as this configuration is a code injection vector.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrim, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimEnd, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(455)(module)))

/***/ }),
/* 148 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(61);











var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Defines HTML button type attribute
   * @defaultValue 'button'
   */
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['button', 'reset', 'submit'])
};
var defaultProps = {
  active: false,
  block: false,
  disabled: false
};

var Button =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Button, _React$Component);

  function Button() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.renderAnchor = function renderAnchor(elementProps, className) {
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, elementProps.disabled && 'disabled')
    }));
  };

  _proto.renderButton = function renderButton(_ref, className) {
    var componentClass = _ref.componentClass,
        elementProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass"]);

    var Component = componentClass || 'button';
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: elementProps.type || 'button',
      className: className
    }));
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        active = _this$props.active,
        block = _this$props.block,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "block", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'block')] = block, _extends2));

    var fullClassName = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes);

    if (elementProps.href) {
      return this.renderAnchor(elementProps, fullClassName);
    }

    return this.renderButton(elementProps, fullClassName);
  };

  return Button;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Button.propTypes = propTypes;
Button.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn', Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["c" /* Size */].XSMALL], Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].PRIMARY, __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].LINK]), __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["e" /* Style */].DEFAULT, Button))));

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = style;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(513));

var _hyphenateStyle = _interopRequireDefault(__webpack_require__(1294));

var _getComputedStyle2 = _interopRequireDefault(__webpack_require__(1296));

var _removeStyle = _interopRequireDefault(__webpack_require__(1297));

var _properties = __webpack_require__(199);

var _isTransform = _interopRequireDefault(__webpack_require__(1298));

function style(node, property, value) {
  var css = '';
  var transforms = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      return node.style[(0, _camelizeStyle.default)(property)] || (0, _getComputedStyle2.default)(node).getPropertyValue((0, _hyphenateStyle.default)(property));
    } else {
      (props = {})[property] = value;
    }
  }

  Object.keys(props).forEach(function (key) {
    var value = props[key];

    if (!value && value !== 0) {
      (0, _removeStyle.default)(node, (0, _hyphenateStyle.default)(key));
    } else if ((0, _isTransform.default)(key)) {
      transforms += key + "(" + value + ") ";
    } else {
      css += (0, _hyphenateStyle.default)(key) + ": " + value + ";";
    }
  });

  if (transforms) {
    css += _properties.transform + ": " + transforms + ";";
  }

  node.style.cssText += ';' + css;
}

module.exports = exports["default"];

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Autocomplete__ = __webpack_require__(1465);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Autocomplete__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Autocomplete__["a"]; });


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

exports.default = _default;

/***/ }),
/* 154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Autocomplete__ = __webpack_require__(152);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Autocomplete__["b"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Rating__ = __webpack_require__(565);
/* unused harmony reexport Rating */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Skeleton__ = __webpack_require__(566);
/* unused harmony reexport Skeleton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SpeedDial__ = __webpack_require__(567);
/* unused harmony reexport SpeedDial */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SpeedDialAction__ = __webpack_require__(568);
/* unused harmony reexport SpeedDialAction */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SpeedDialIcon__ = __webpack_require__(569);
/* unused harmony reexport SpeedDialIcon */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ToggleButton__ = __webpack_require__(570);
/* unused harmony reexport ToggleButton */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ToggleButtonGroup__ = __webpack_require__(571);
/* unused harmony reexport ToggleButtonGroup */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TreeItem__ = __webpack_require__(572);
/* unused harmony reexport TreeItem */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TreeView__ = __webpack_require__(574);
/* unused harmony reexport TreeView */
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__useAutocomplete__ = __webpack_require__(559);
/* unused harmony reexport useAutocomplete */
/** @license Material-UI v4.0.0-alpha.34
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
/* eslint-disable import/export */



















 // createFilterOptions is exported from Autocomplete



/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = actionGetStatsByClient;
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetStatsByClientDetail;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionGetStatsByEvent;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_stats_StatsService__ = __webpack_require__(1527);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
/*** ACTIONS STATS ******/function actionGetStatsByClient(filter,order,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_stats_StatsService__["a" /* default */].getStatsByClient(filter,order,getStore().app.app).then(function(response){console.log("ACTION",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["h" /* ACT_STATS_CHANGE */],props:{statsByClient:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetStatsByClientDetail(filter,order,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_stats_StatsService__["a" /* default */].getStatsByClientDetail(filter,order,getStore().app.app).then(function(response){console.log("ACTION actionGetStatsByClientDetail",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["h" /* ACT_STATS_CHANGE */],props:{statsByClientDetail:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetStatsByEvent(filter,order,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_stats_StatsService__["a" /* default */].getStatsByEvent(filter,order,getStore().app.app).then(function(response){console.log("ACTION",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["h" /* ACT_STATS_CHANGE */],props:{statsByEvent:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}

/***/ }),
/* 156 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 157 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(595);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(599);
var defined = __webpack_require__(218);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* harmony default export */ __webpack_exports__["default"] = (warning);


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(63);


/** Built-in value references. */
var Symbol = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Symbol;

/* harmony default export */ __webpack_exports__["a"] = (Symbol);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayMap_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__copyArray_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stringToPath_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toString_js__ = __webpack_require__(358);








/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__arrayMap_js__["a" /* default */])(value, __WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */]);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_1__copyArray_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toString_js__["a" /* default */])(value)));
}

/* harmony default export */ __webpack_exports__["a"] = (toPath);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(88);



/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == symbolTag);
}

/* harmony default export */ __webpack_exports__["a"] = (isSymbol);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);


/* Built-in method references that are verified to be native. */
var nativeCreate = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'create');

/* harmony default export */ __webpack_exports__["a"] = (nativeCreate);


/***/ }),
/* 165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__ = __webpack_require__(710);






/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__listCacheClear_js__["a" /* default */];
ListCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__listCacheDelete_js__["a" /* default */];
ListCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__listCacheGet_js__["a" /* default */];
ListCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__listCacheHas_js__["a" /* default */];
ListCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__listCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (ListCache);


/***/ }),
/* 166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(131);


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/* harmony default export */ __webpack_exports__["a"] = (assocIndexOf);


/***/ }),
/* 167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isKeyable_js__ = __webpack_require__(712);


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return Object(__WEBPACK_IMPORTED_MODULE_0__isKeyable_js__["a" /* default */])(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/* harmony default export */ __webpack_exports__["a"] = (getMapData);


/***/ }),
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(88);



/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && !Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(other))) {
    return value !== value && other !== other;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqualDeep_js__["a" /* default */])(value, other, bitmask, customizer, baseIsEqual, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqual);


/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(88);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = Object(__WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */])(function() { return arguments; }()) ? __WEBPACK_IMPORTED_MODULE_0__baseIsArguments_js__["a" /* default */] : function(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

/* harmony default export */ __webpack_exports__["a"] = (isArguments);


/***/ }),
/* 170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__ = __webpack_require__(742);



/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || __WEBPACK_IMPORTED_MODULE_1__stubFalse_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110)(module)))

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseUnary_js__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__ = __webpack_require__(745);




/* Node.js helper references. */
var nodeIsTypedArray = __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_2__nodeUtil_js__["a" /* default */].isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? Object(__WEBPACK_IMPORTED_MODULE_1__baseUnary_js__["a" /* default */])(nodeIsTypedArray) : __WEBPACK_IMPORTED_MODULE_0__baseIsTypedArray_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (isTypedArray);


/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/* harmony default export */ __webpack_exports__["a"] = (isPrototype);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(366);


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */]) {
    Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/* harmony default export */ __webpack_exports__["a"] = (baseAssignValue);


/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _createClass;
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

/***/ }),
/* 175 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function unsupportedProp(props, propName, componentName, location, propFullName) {
  if (true) {
    return null;
  }

  var propFullNameSafe = propFullName || propName;

  if (typeof props[propName] !== 'undefined') {
    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (unsupportedProp);

/***/ }),
/* 176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_utils__ = __webpack_require__(12);


function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_utils__["a" /* deepmerge */])(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

/* harmony default export */ __webpack_exports__["a"] = (merge);

/***/ }),
/* 177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = useFormControl;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var FormControlContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
function useFormControl() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(FormControlContext);
}
/* harmony default export */ __webpack_exports__["a"] = (FormControlContext);

/***/ }),
/* 178 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collapse__ = __webpack_require__(992);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collapse__["a"]; });


/***/ }),
/* 179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Modal__ = __webpack_require__(999);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ModalManager__ = __webpack_require__(414);
/* unused harmony reexport ModalManager */



/***/ }),
/* 180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grow__ = __webpack_require__(1042);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grow__["a"]; });


/***/ }),
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Input__ = __webpack_require__(1051);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Input__["a"]; });


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DOMStorageWrapper_1 = __webpack_require__(1197);
var MemoryStorage_1 = __webpack_require__(1198);
/**
 * Helper to create a DOMStorageWrapper or else fall back to MemoryStorage.
 * TODO: Once MemoryStorage and DOMStorageWrapper have a shared interface this method annotation should change
 * to reflect this type
 *
 * @param {string} domStorageName Name of the underlying storage object
 *   (e.g. 'localStorage' or 'sessionStorage').
 * @return {?} Turning off type information until a common interface is defined.
 */
var createStoragefor = function (domStorageName) {
    try {
        // NOTE: just accessing "localStorage" or "window['localStorage']" may throw a security exception,
        // so it must be inside the try/catch.
        if (typeof window !== 'undefined' &&
            typeof window[domStorageName] !== 'undefined') {
            // Need to test cache. Just because it's here doesn't mean it works
            var domStorage = window[domStorageName];
            domStorage.setItem('firebase:sentinel', 'cache');
            domStorage.removeItem('firebase:sentinel');
            return new DOMStorageWrapper_1.DOMStorageWrapper(domStorage);
        }
    }
    catch (e) { }
    // Failed to create wrapper.  Just return in-memory storage.
    // TODO: log?
    return new MemoryStorage_1.MemoryStorage();
};
/** A storage object that lasts across sessions */
exports.PersistentStorage = createStoragefor('localStorage');
/** A storage object that only lasts one session */
exports.SessionStorage = createStoragefor('sessionStorage');

//# sourceMappingURL=storage.js.map


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROTOCOL_VERSION = '5';
exports.VERSION_PARAM = 'v';
exports.TRANSPORT_SESSION_PARAM = 's';
exports.REFERER_PARAM = 'r';
exports.FORGE_REF = 'f';
exports.FORGE_DOMAIN = 'firebaseio.com';
exports.LAST_SESSION_PARAM = 'ls';
exports.WEBSOCKET = 'websocket';
exports.LONG_POLLING = 'long_polling';

//# sourceMappingURL=Constants.js.map


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Node_1 = __webpack_require__(53);
var util_1 = __webpack_require__(21);
/**
 *
 * @constructor
 */
var Index = /** @class */ (function () {
    function Index() {
    }
    /**
     * @return {function(!NamedNode, !NamedNode):number} A standalone comparison function for
     * this index
     */
    Index.prototype.getCompare = function () {
        return this.compare.bind(this);
    };
    /**
     * Given a before and after value for a node, determine if the indexed value has changed. Even if they are different,
     * it's possible that the changes are isolated to parts of the snapshot that are not indexed.
     *
     * @param {!Node} oldNode
     * @param {!Node} newNode
     * @return {boolean} True if the portion of the snapshot being indexed changed between oldNode and newNode
     */
    Index.prototype.indexedValueChanged = function (oldNode, newNode) {
        var oldWrapped = new Node_1.NamedNode(util_1.MIN_NAME, oldNode);
        var newWrapped = new Node_1.NamedNode(util_1.MIN_NAME, newNode);
        return this.compare(oldWrapped, newWrapped) !== 0;
    };
    /**
     * @return {!NamedNode} a node wrapper that will sort equal to or less than
     * any other node wrapper, using this index
     */
    Index.prototype.minPost = function () {
        return Node_1.NamedNode.MIN;
    };
    return Index;
}());
exports.Index = Index;

//# sourceMappingURL=Index.js.map


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var snap_1 = __webpack_require__(466);
var __childrenNodeConstructor;
/**
 * LeafNode is a class for storing leaf nodes in a DataSnapshot.  It
 * implements Node and stores the value of the node (a string,
 * number, or boolean) accessible via getValue().
 */
var LeafNode = /** @class */ (function () {
    /**
     * @implements {Node}
     * @param {!(string|number|boolean|Object)} value_ The value to store in this leaf node.
     *                                         The object type is possible in the event of a deferred value
     * @param {!Node=} priorityNode_ The priority of this node.
     */
    function LeafNode(value_, priorityNode_) {
        if (priorityNode_ === void 0) { priorityNode_ = LeafNode.__childrenNodeConstructor.EMPTY_NODE; }
        this.value_ = value_;
        this.priorityNode_ = priorityNode_;
        this.lazyHash_ = null;
        util_1.assert(this.value_ !== undefined && this.value_ !== null, "LeafNode shouldn't be created with null/undefined value.");
        snap_1.validatePriorityNode(this.priorityNode_);
    }
    Object.defineProperty(LeafNode, "__childrenNodeConstructor", {
        get: function () {
            return __childrenNodeConstructor;
        },
        set: function (val) {
            __childrenNodeConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /** @inheritDoc */
    LeafNode.prototype.isLeafNode = function () {
        return true;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPriority = function () {
        return this.priorityNode_;
    };
    /** @inheritDoc */
    LeafNode.prototype.updatePriority = function (newPriorityNode) {
        return new LeafNode(this.value_, newPriorityNode);
    };
    /** @inheritDoc */
    LeafNode.prototype.getImmediateChild = function (childName) {
        // Hack to treat priority as a regular child
        if (childName === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.getChild = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else if (path.getFront() === '.priority') {
            return this.priorityNode_;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.hasChild = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.getPredecessorChildName = function (childName, childNode) {
        return null;
    };
    /** @inheritDoc */
    LeafNode.prototype.updateImmediateChild = function (childName, newChildNode) {
        if (childName === '.priority') {
            return this.updatePriority(newChildNode);
        }
        else if (newChildNode.isEmpty() && childName !== '.priority') {
            return this;
        }
        else {
            return LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateImmediateChild(childName, newChildNode).updatePriority(this.priorityNode_);
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.updateChild = function (path, newChildNode) {
        var front = path.getFront();
        if (front === null) {
            return newChildNode;
        }
        else if (newChildNode.isEmpty() && front !== '.priority') {
            return this;
        }
        else {
            util_1.assert(front !== '.priority' || path.getLength() === 1, '.priority must be the last token in a path');
            return this.updateImmediateChild(front, LeafNode.__childrenNodeConstructor.EMPTY_NODE.updateChild(path.popFront(), newChildNode));
        }
    };
    /** @inheritDoc */
    LeafNode.prototype.isEmpty = function () {
        return false;
    };
    /** @inheritDoc */
    LeafNode.prototype.numChildren = function () {
        return 0;
    };
    /** @inheritDoc */
    LeafNode.prototype.forEachChild = function (index, action) {
        return false;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.val = function (exportFormat) {
        if (exportFormat && !this.getPriority().isEmpty())
            return {
                '.value': this.getValue(),
                '.priority': this.getPriority().val()
            };
        else
            return this.getValue();
    };
    /** @inheritDoc */
    LeafNode.prototype.hash = function () {
        if (this.lazyHash_ === null) {
            var toHash = '';
            if (!this.priorityNode_.isEmpty())
                toHash +=
                    'priority:' +
                        snap_1.priorityHashText(this.priorityNode_.val()) +
                        ':';
            var type = typeof this.value_;
            toHash += type + ':';
            if (type === 'number') {
                toHash += util_2.doubleToIEEE754String(this.value_);
            }
            else {
                toHash += this.value_;
            }
            this.lazyHash_ = util_2.sha1(toHash);
        }
        return this.lazyHash_;
    };
    /**
     * Returns the value of the leaf node.
     * @return {Object|string|number|boolean} The value of the node.
     */
    LeafNode.prototype.getValue = function () {
        return this.value_;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.compareTo = function (other) {
        if (other === LeafNode.__childrenNodeConstructor.EMPTY_NODE) {
            return 1;
        }
        else if (other instanceof LeafNode.__childrenNodeConstructor) {
            return -1;
        }
        else {
            util_1.assert(other.isLeafNode(), 'Unknown node type');
            return this.compareToLeafNode_(other);
        }
    };
    /**
     * Comparison specifically for two leaf nodes
     * @param {!LeafNode} otherLeaf
     * @return {!number}
     * @private
     */
    LeafNode.prototype.compareToLeafNode_ = function (otherLeaf) {
        var otherLeafType = typeof otherLeaf.value_;
        var thisLeafType = typeof this.value_;
        var otherIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(otherLeafType);
        var thisIndex = LeafNode.VALUE_TYPE_ORDER.indexOf(thisLeafType);
        util_1.assert(otherIndex >= 0, 'Unknown leaf type: ' + otherLeafType);
        util_1.assert(thisIndex >= 0, 'Unknown leaf type: ' + thisLeafType);
        if (otherIndex === thisIndex) {
            // Same type, compare values
            if (thisLeafType === 'object') {
                // Deferred value nodes are all equal, but we should also never get to this point...
                return 0;
            }
            else {
                // Note that this works because true > false, all others are number or string comparisons
                if (this.value_ < otherLeaf.value_) {
                    return -1;
                }
                else if (this.value_ === otherLeaf.value_) {
                    return 0;
                }
                else {
                    return 1;
                }
            }
        }
        else {
            return thisIndex - otherIndex;
        }
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.withIndex = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.isIndexed = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LeafNode.prototype.equals = function (other) {
        /**
         * @inheritDoc
         */
        if (other === this) {
            return true;
        }
        else if (other.isLeafNode()) {
            var otherLeaf = other;
            return (this.value_ === otherLeaf.value_ &&
                this.priorityNode_.equals(otherLeaf.priorityNode_));
        }
        else {
            return false;
        }
    };
    /**
     * The sort order for comparing leaf nodes of different types. If two leaf nodes have
     * the same type, the comparison falls back to their value
     * @type {Array.<!string>}
     * @const
     */
    LeafNode.VALUE_TYPE_ORDER = ['object', 'boolean', 'number', 'string'];
    return LeafNode;
}());
exports.LeafNode = LeafNode;

//# sourceMappingURL=LeafNode.js.map


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * An iterator over an LLRBNode.
 */
var SortedMapIterator = /** @class */ (function () {
    /**
     * @template K, V, T
     * @param {LLRBNode|LLRBEmptyNode} node Node to iterate.
     * @param {?K} startKey
     * @param {function(K, K): number} comparator
     * @param {boolean} isReverse_ Whether or not to iterate in reverse
     * @param {(function(K, V):T)=} resultGenerator_
     */
    function SortedMapIterator(node, startKey, comparator, isReverse_, resultGenerator_) {
        if (resultGenerator_ === void 0) { resultGenerator_ = null; }
        this.isReverse_ = isReverse_;
        this.resultGenerator_ = resultGenerator_;
        /** @private
         * @type {Array.<!LLRBNode>}
         */
        this.nodeStack_ = [];
        var cmp = 1;
        while (!node.isEmpty()) {
            node = node;
            cmp = startKey ? comparator(node.key, startKey) : 1;
            // flip the comparison if we're going in reverse
            if (isReverse_)
                cmp *= -1;
            if (cmp < 0) {
                // This node is less than our start key. ignore it
                if (this.isReverse_) {
                    node = node.left;
                }
                else {
                    node = node.right;
                }
            }
            else if (cmp === 0) {
                // This node is exactly equal to our start key. Push it on the stack, but stop iterating;
                this.nodeStack_.push(node);
                break;
            }
            else {
                // This node is greater than our start key, add it to the stack and move to the next one
                this.nodeStack_.push(node);
                if (this.isReverse_) {
                    node = node.right;
                }
                else {
                    node = node.left;
                }
            }
        }
    }
    SortedMapIterator.prototype.getNext = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_.pop();
        var result;
        if (this.resultGenerator_)
            result = this.resultGenerator_(node.key, node.value);
        else
            result = { key: node.key, value: node.value };
        if (this.isReverse_) {
            node = node.left;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.right;
            }
        }
        else {
            node = node.right;
            while (!node.isEmpty()) {
                this.nodeStack_.push(node);
                node = node.left;
            }
        }
        return result;
    };
    SortedMapIterator.prototype.hasNext = function () {
        return this.nodeStack_.length > 0;
    };
    SortedMapIterator.prototype.peek = function () {
        if (this.nodeStack_.length === 0)
            return null;
        var node = this.nodeStack_[this.nodeStack_.length - 1];
        if (this.resultGenerator_) {
            return this.resultGenerator_(node.key, node.value);
        }
        else {
            return { key: node.key, value: node.value };
        }
    };
    return SortedMapIterator;
}());
exports.SortedMapIterator = SortedMapIterator;
/**
 * Represents a node in a Left-leaning Red-Black tree.
 */
var LLRBNode = /** @class */ (function () {
    /**
     * @template K, V
     * @param {!K} key Key associated with this node.
     * @param {!V} value Value associated with this node.
     * @param {?boolean} color Whether this node is red.
     * @param {?(LLRBNode|LLRBEmptyNode)=} left Left child.
     * @param {?(LLRBNode|LLRBEmptyNode)=} right Right child.
     */
    function LLRBNode(key, value, color, left, right) {
        this.key = key;
        this.value = value;
        this.color = color != null ? color : LLRBNode.RED;
        this.left =
            left != null ? left : SortedMap.EMPTY_NODE;
        this.right =
            right != null ? right : SortedMap.EMPTY_NODE;
    }
    /**
     * Returns a copy of the current node, optionally replacing pieces of it.
     *
     * @param {?K} key New key for the node, or null.
     * @param {?V} value New value for the node, or null.
     * @param {?boolean} color New color for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} left New left child for the node, or null.
     * @param {?LLRBNode|LLRBEmptyNode} right New right child for the node, or null.
     * @return {!LLRBNode} The node copy.
     */
    LLRBNode.prototype.copy = function (key, value, color, left, right) {
        return new LLRBNode(key != null ? key : this.key, value != null ? value : this.value, color != null ? color : this.color, left != null ? left : this.left, right != null ? right : this.right);
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBNode.prototype.count = function () {
        return this.left.count() + 1 + this.right.count();
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBNode.prototype.isEmpty = function () {
        return false;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     *   node.  If it returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    LLRBNode.prototype.inorderTraversal = function (action) {
        return (this.left.inorderTraversal(action) ||
            action(this.key, this.value) ||
            this.right.inorderTraversal(action));
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!Object, !Object)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {*} True if traversal was aborted.
     */
    LLRBNode.prototype.reverseTraversal = function (action) {
        return (this.right.reverseTraversal(action) ||
            action(this.key, this.value) ||
            this.left.reverseTraversal(action));
    };
    /**
     * @return {!Object} The minimum node in the tree.
     * @private
     */
    LLRBNode.prototype.min_ = function () {
        if (this.left.isEmpty()) {
            return this;
        }
        else {
            return this.left.min_();
        }
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.minKey = function () {
        return this.min_().key;
    };
    /**
     * @return {!K} The maximum key in the tree.
     */
    LLRBNode.prototype.maxKey = function () {
        if (this.right.isEmpty()) {
            return this.key;
        }
        else {
            return this.right.maxKey();
        }
    };
    /**
     *
     * @param {!Object} key Key to insert.
     * @param {!Object} value Value to insert.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with the key/value added.
     */
    LLRBNode.prototype.insert = function (key, value, comparator) {
        var cmp, n;
        n = this;
        cmp = comparator(key, n.key);
        if (cmp < 0) {
            n = n.copy(null, null, null, n.left.insert(key, value, comparator), null);
        }
        else if (cmp === 0) {
            n = n.copy(null, value, null, null, null);
        }
        else {
            n = n.copy(null, null, null, null, n.right.insert(key, value, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the minimum key removed.
     */
    LLRBNode.prototype.removeMin_ = function () {
        if (this.left.isEmpty()) {
            return SortedMap.EMPTY_NODE;
        }
        var n = this;
        if (!n.left.isRed_() && !n.left.left.isRed_())
            n = n.moveRedLeft_();
        n = n.copy(null, null, null, n.left.removeMin_(), null);
        return n.fixUp_();
    };
    /**
     * @param {!Object} key The key of the item to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode|LLRBEmptyNode} New tree, with the specified item removed.
     */
    LLRBNode.prototype.remove = function (key, comparator) {
        var n, smallest;
        n = this;
        if (comparator(key, n.key) < 0) {
            if (!n.left.isEmpty() && !n.left.isRed_() && !n.left.left.isRed_()) {
                n = n.moveRedLeft_();
            }
            n = n.copy(null, null, null, n.left.remove(key, comparator), null);
        }
        else {
            if (n.left.isRed_())
                n = n.rotateRight_();
            if (!n.right.isEmpty() && !n.right.isRed_() && !n.right.left.isRed_()) {
                n = n.moveRedRight_();
            }
            if (comparator(key, n.key) === 0) {
                if (n.right.isEmpty()) {
                    return SortedMap.EMPTY_NODE;
                }
                else {
                    smallest = n.right.min_();
                    n = n.copy(smallest.key, smallest.value, null, null, n.right.removeMin_());
                }
            }
            n = n.copy(null, null, null, null, n.right.remove(key, comparator));
        }
        return n.fixUp_();
    };
    /**
     * @private
     * @return {boolean} Whether this is a RED node.
     */
    LLRBNode.prototype.isRed_ = function () {
        return this.color;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree after performing any needed rotations.
     */
    LLRBNode.prototype.fixUp_ = function () {
        var n = this;
        if (n.right.isRed_() && !n.left.isRed_())
            n = n.rotateLeft_();
        if (n.left.isRed_() && n.left.left.isRed_())
            n = n.rotateRight_();
        if (n.left.isRed_() && n.right.isRed_())
            n = n.colorFlip_();
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedLeft.
     */
    LLRBNode.prototype.moveRedLeft_ = function () {
        var n = this.colorFlip_();
        if (n.right.left.isRed_()) {
            n = n.copy(null, null, null, null, n.right.rotateRight_());
            n = n.rotateLeft_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after moveRedRight.
     */
    LLRBNode.prototype.moveRedRight_ = function () {
        var n = this.colorFlip_();
        if (n.left.left.isRed_()) {
            n = n.rotateRight_();
            n = n.colorFlip_();
        }
        return n;
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateLeft.
     */
    LLRBNode.prototype.rotateLeft_ = function () {
        var nl = this.copy(null, null, LLRBNode.RED, null, this.right.left);
        return this.right.copy(null, null, this.color, nl, null);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after rotateRight.
     */
    LLRBNode.prototype.rotateRight_ = function () {
        var nr = this.copy(null, null, LLRBNode.RED, this.left.right, null);
        return this.left.copy(null, null, this.color, null, nr);
    };
    /**
     * @private
     * @return {!LLRBNode} New tree, after colorFlip.
     */
    LLRBNode.prototype.colorFlip_ = function () {
        var left = this.left.copy(null, null, !this.left.color, null, null);
        var right = this.right.copy(null, null, !this.right.color, null, null);
        return this.copy(null, null, !this.color, left, right);
    };
    /**
     * For testing.
     *
     * @private
     * @return {boolean} True if all is well.
     */
    LLRBNode.prototype.checkMaxDepth_ = function () {
        var blackDepth = this.check_();
        return Math.pow(2.0, blackDepth) <= this.count() + 1;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBNode.prototype.check_ = function () {
        var blackDepth;
        if (this.isRed_() && this.left.isRed_()) {
            throw new Error('Red node has red child(' + this.key + ',' + this.value + ')');
        }
        if (this.right.isRed_()) {
            throw new Error('Right child of (' + this.key + ',' + this.value + ') is red');
        }
        blackDepth = this.left.check_();
        if (blackDepth !== this.right.check_()) {
            throw new Error('Black depths differ');
        }
        else {
            return blackDepth + (this.isRed_() ? 0 : 1);
        }
    };
    LLRBNode.RED = true;
    LLRBNode.BLACK = false;
    return LLRBNode;
}());
exports.LLRBNode = LLRBNode;
/**
 * Represents an empty node (a leaf node in the Red-Black Tree).
 */
var LLRBEmptyNode = /** @class */ (function () {
    function LLRBEmptyNode() {
    }
    /**
     * Returns a copy of the current node.
     *
     * @return {!LLRBEmptyNode} The node copy.
     */
    LLRBEmptyNode.prototype.copy = function (key, value, color, left, right) {
        return this;
    };
    /**
     * Returns a copy of the tree, with the specified key/value added.
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBNode} New tree, with item added.
     */
    LLRBEmptyNode.prototype.insert = function (key, value, comparator) {
        return new LLRBNode(key, value, null);
    };
    /**
     * Returns a copy of the tree, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @param {Comparator} comparator Comparator.
     * @return {!LLRBEmptyNode} New tree, with item removed.
     */
    LLRBEmptyNode.prototype.remove = function (key, comparator) {
        return this;
    };
    /**
     * @return {number} The total number of nodes in the tree.
     */
    LLRBEmptyNode.prototype.count = function () {
        return 0;
    };
    /**
     * @return {boolean} True if the tree is empty.
     */
    LLRBEmptyNode.prototype.isEmpty = function () {
        return true;
    };
    /**
     * Traverses the tree in key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V):*} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.inorderTraversal = function (action) {
        return false;
    };
    /**
     * Traverses the tree in reverse key order and calls the specified action function
     * for each node.
     *
     * @param {function(!K, !V)} action Callback function to be called for each
     * node.  If it returns true, traversal is aborted.
     * @return {boolean} True if traversal was aborted.
     */
    LLRBEmptyNode.prototype.reverseTraversal = function (action) {
        return false;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.minKey = function () {
        return null;
    };
    /**
     * @return {null}
     */
    LLRBEmptyNode.prototype.maxKey = function () {
        return null;
    };
    /**
     * @private
     * @return {number} Not sure what this returns exactly. :-).
     */
    LLRBEmptyNode.prototype.check_ = function () {
        return 0;
    };
    /**
     * @private
     * @return {boolean} Whether this node is red.
     */
    LLRBEmptyNode.prototype.isRed_ = function () {
        return false;
    };
    return LLRBEmptyNode;
}());
exports.LLRBEmptyNode = LLRBEmptyNode;
/**
 * An immutable sorted map implementation, based on a Left-leaning Red-Black
 * tree.
 */
var SortedMap = /** @class */ (function () {
    /**
     * @template K, V
     * @param {function(K, K):number} comparator_ Key comparator.
     * @param {LLRBNode=} root_ (Optional) Root node for the map.
     */
    function SortedMap(comparator_, root_) {
        if (root_ === void 0) { root_ = SortedMap.EMPTY_NODE; }
        this.comparator_ = comparator_;
        this.root_ = root_;
    }
    /**
     * Returns a copy of the map, with the specified key/value added or replaced.
     * (TODO: We should perhaps rename this method to 'put')
     *
     * @param {!K} key Key to be added.
     * @param {!V} value Value to be added.
     * @return {!SortedMap.<K, V>} New map, with item added.
     */
    SortedMap.prototype.insert = function (key, value) {
        return new SortedMap(this.comparator_, this.root_
            .insert(key, value, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns a copy of the map, with the specified key removed.
     *
     * @param {!K} key The key to remove.
     * @return {!SortedMap.<K, V>} New map, with item removed.
     */
    SortedMap.prototype.remove = function (key) {
        return new SortedMap(this.comparator_, this.root_
            .remove(key, this.comparator_)
            .copy(null, null, LLRBNode.BLACK, null, null));
    };
    /**
     * Returns the value of the node with the given key, or null.
     *
     * @param {!K} key The key to look up.
     * @return {?V} The value of the node with the given key, or null if the
     * key doesn't exist.
     */
    SortedMap.prototype.get = function (key) {
        var cmp;
        var node = this.root_;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                return node.value;
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                node = node.right;
            }
        }
        return null;
    };
    /**
     * Returns the key of the item *before* the specified key, or null if key is the first item.
     * @param {K} key The key to find the predecessor of
     * @return {?K} The predecessor key.
     */
    SortedMap.prototype.getPredecessorKey = function (key) {
        var cmp, node = this.root_, rightParent = null;
        while (!node.isEmpty()) {
            cmp = this.comparator_(key, node.key);
            if (cmp === 0) {
                if (!node.left.isEmpty()) {
                    node = node.left;
                    while (!node.right.isEmpty())
                        node = node.right;
                    return node.key;
                }
                else if (rightParent) {
                    return rightParent.key;
                }
                else {
                    return null; // first item.
                }
            }
            else if (cmp < 0) {
                node = node.left;
            }
            else if (cmp > 0) {
                rightParent = node;
                node = node.right;
            }
        }
        throw new Error('Attempted to find predecessor key for a nonexistent key.  What gives?');
    };
    /**
     * @return {boolean} True if the map is empty.
     */
    SortedMap.prototype.isEmpty = function () {
        return this.root_.isEmpty();
    };
    /**
     * @return {number} The total number of nodes in the map.
     */
    SortedMap.prototype.count = function () {
        return this.root_.count();
    };
    /**
     * @return {?K} The minimum key in the map.
     */
    SortedMap.prototype.minKey = function () {
        return this.root_.minKey();
    };
    /**
     * @return {?K} The maximum key in the map.
     */
    SortedMap.prototype.maxKey = function () {
        return this.root_.maxKey();
    };
    /**
     * Traverses the map in key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!K, !V):*} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} The first truthy value returned by action, or the last falsey
     *   value returned by action
     */
    SortedMap.prototype.inorderTraversal = function (action) {
        return this.root_.inorderTraversal(action);
    };
    /**
     * Traverses the map in reverse key order and calls the specified action function
     * for each key/value pair.
     *
     * @param {function(!Object, !Object)} action Callback function to be called
     * for each key/value pair.  If action returns true, traversal is aborted.
     * @return {*} True if the traversal was aborted.
     */
    SortedMap.prototype.reverseTraversal = function (action) {
        return this.root_.reverseTraversal(action);
    };
    /**
     * Returns an iterator over the SortedMap.
     * @template T
     * @param {(function(K, V):T)=} resultGenerator
     * @return {SortedMapIterator.<K, V, T>} The iterator.
     */
    SortedMap.prototype.getIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, false, resultGenerator);
    };
    SortedMap.prototype.getReverseIteratorFrom = function (key, resultGenerator) {
        return new SortedMapIterator(this.root_, key, this.comparator_, true, resultGenerator);
    };
    SortedMap.prototype.getReverseIterator = function (resultGenerator) {
        return new SortedMapIterator(this.root_, null, this.comparator_, true, resultGenerator);
    };
    /**
     * Always use the same empty node, to reduce memory.
     * @const
     */
    SortedMap.EMPTY_NODE = new LLRBEmptyNode();
    return SortedMap;
}());
exports.SortedMap = SortedMap;

//# sourceMappingURL=SortedMap.js.map


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ServerValues_1 = __webpack_require__(472);
var nodeFromJSON_1 = __webpack_require__(146);
var Path_1 = __webpack_require__(29);
var SparseSnapshotTree_1 = __webpack_require__(473);
var SyncTree_1 = __webpack_require__(1203);
var SnapshotHolder_1 = __webpack_require__(1214);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var util_3 = __webpack_require__(6);
var AuthTokenProvider_1 = __webpack_require__(1215);
var StatsManager_1 = __webpack_require__(272);
var StatsReporter_1 = __webpack_require__(1217);
var StatsListener_1 = __webpack_require__(478);
var EventQueue_1 = __webpack_require__(1218);
var PersistentConnection_1 = __webpack_require__(479);
var ReadonlyRestClient_1 = __webpack_require__(1223);
var Database_1 = __webpack_require__(461);
var INTERRUPT_REASON = 'repo_interrupt';
/**
 * A connection to a single data repository.
 */
var Repo = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo_
     * @param {boolean} forceRestClient
     * @param {!FirebaseApp} app
     */
    function Repo(repoInfo_, forceRestClient, app) {
        var _this = this;
        this.repoInfo_ = repoInfo_;
        this.app = app;
        this.dataUpdateCount = 0;
        this.statsListener_ = null;
        this.eventQueue_ = new EventQueue_1.EventQueue();
        this.nextWriteId_ = 1;
        this.interceptServerDataCallback_ = null;
        // A list of data pieces and paths to be set when this client disconnects.
        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
        /**
         * TODO: This should be @private but it's used by test_access.js and internal.js
         * @type {?PersistentConnection}
         */
        this.persistentConnection_ = null;
        /** @type {!AuthTokenProvider} */
        var authTokenProvider = new AuthTokenProvider_1.AuthTokenProvider(app);
        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo_);
        if (forceRestClient || util_2.beingCrawled()) {
            this.server_ = new ReadonlyRestClient_1.ReadonlyRestClient(this.repoInfo_, this.onDataUpdate_.bind(this), authTokenProvider);
            // Minor hack: Fire onConnect immediately, since there's no actual connection.
            setTimeout(this.onConnectStatus_.bind(this, true), 0);
        }
        else {
            var authOverride = app.options['databaseAuthVariableOverride'];
            // Validate authOverride
            if (typeof authOverride !== 'undefined' && authOverride !== null) {
                if (typeof authOverride !== 'object') {
                    throw new Error('Only objects are supported for option databaseAuthVariableOverride');
                }
                try {
                    util_1.stringify(authOverride);
                }
                catch (e) {
                    throw new Error('Invalid authOverride provided: ' + e);
                }
            }
            this.persistentConnection_ = new PersistentConnection_1.PersistentConnection(this.repoInfo_, this.onDataUpdate_.bind(this), this.onConnectStatus_.bind(this), this.onServerInfoUpdate_.bind(this), authTokenProvider, authOverride);
            this.server_ = this.persistentConnection_;
        }
        authTokenProvider.addTokenChangeListener(function (token) {
            _this.server_.refreshAuthToken(token);
        });
        // In the case of multiple Repos for the same repoInfo (i.e. there are multiple Firebase.Contexts being used),
        // we only want to create one StatsReporter.  As such, we'll report stats over the first Repo created.
        this.statsReporter_ = StatsManager_1.StatsManager.getOrCreateReporter(repoInfo_, function () { return new StatsReporter_1.StatsReporter(_this.stats_, _this.server_); });
        this.transactions_init_();
        // Used for .info.
        this.infoData_ = new SnapshotHolder_1.SnapshotHolder();
        this.infoSyncTree_ = new SyncTree_1.SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                var infoEvents = [];
                var node = _this.infoData_.getNode(query.path);
                // This is possibly a hack, but we have different semantics for .info endpoints. We don't raise null events
                // on initial data...
                if (!node.isEmpty()) {
                    infoEvents = _this.infoSyncTree_.applyServerOverwrite(query.path, node);
                    setTimeout(function () {
                        onComplete('ok');
                    }, 0);
                }
                return infoEvents;
            },
            stopListening: function () { }
        });
        this.updateInfo_('connected', false);
        this.serverSyncTree_ = new SyncTree_1.SyncTree({
            startListening: function (query, tag, currentHashFn, onComplete) {
                _this.server_.listen(query, currentHashFn, tag, function (status, data) {
                    var events = onComplete(status, data);
                    _this.eventQueue_.raiseEventsForChangedPath(query.path, events);
                });
                // No synchronous events for network-backed sync trees
                return [];
            },
            stopListening: function (query, tag) {
                _this.server_.unlisten(query, tag);
            }
        });
    }
    /**
     * @return {string}  The URL corresponding to the root of this Firebase.
     */
    Repo.prototype.toString = function () {
        return ((this.repoInfo_.secure ? 'https://' : 'http://') + this.repoInfo_.host);
    };
    /**
     * @return {!string} The namespace represented by the repo.
     */
    Repo.prototype.name = function () {
        return this.repoInfo_.namespace;
    };
    /**
     * @return {!number} The time in milliseconds, taking the server offset into account if we have one.
     */
    Repo.prototype.serverTime = function () {
        var offsetNode = this.infoData_.getNode(new Path_1.Path('.info/serverTimeOffset'));
        var offset = offsetNode.val() || 0;
        return new Date().getTime() + offset;
    };
    /**
     * Generate ServerValues using some variables from the repo object.
     * @return {!Object}
     */
    Repo.prototype.generateServerValues = function () {
        return ServerValues_1.generateWithValues({
            timestamp: this.serverTime()
        });
    };
    /**
     * Called by realtime when we get new messages from the server.
     *
     * @private
     * @param {string} pathString
     * @param {*} data
     * @param {boolean} isMerge
     * @param {?number} tag
     */
    Repo.prototype.onDataUpdate_ = function (pathString, data, isMerge, tag) {
        // For testing.
        this.dataUpdateCount++;
        var path = new Path_1.Path(pathString);
        data = this.interceptServerDataCallback_
            ? this.interceptServerDataCallback_(pathString, data)
            : data;
        var events = [];
        if (tag) {
            if (isMerge) {
                var taggedChildren = util_3.map(data, function (raw) {
                    return nodeFromJSON_1.nodeFromJSON(raw);
                });
                events = this.serverSyncTree_.applyTaggedQueryMerge(path, taggedChildren, tag);
            }
            else {
                var taggedSnap = nodeFromJSON_1.nodeFromJSON(data);
                events = this.serverSyncTree_.applyTaggedQueryOverwrite(path, taggedSnap, tag);
            }
        }
        else if (isMerge) {
            var changedChildren = util_3.map(data, function (raw) {
                return nodeFromJSON_1.nodeFromJSON(raw);
            });
            events = this.serverSyncTree_.applyServerMerge(path, changedChildren);
        }
        else {
            var snap = nodeFromJSON_1.nodeFromJSON(data);
            events = this.serverSyncTree_.applyServerOverwrite(path, snap);
        }
        var affectedPath = path;
        if (events.length > 0) {
            // Since we have a listener outstanding for each transaction, receiving any events
            // is a proxy for some change having occurred.
            affectedPath = this.rerunTransactions_(path);
        }
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, events);
    };
    /**
     * TODO: This should be @private but it's used by test_access.js and internal.js
     * @param {?function(!string, *):*} callback
     * @private
     */
    Repo.prototype.interceptServerData_ = function (callback) {
        this.interceptServerDataCallback_ = callback;
    };
    /**
     * @param {!boolean} connectStatus
     * @private
     */
    Repo.prototype.onConnectStatus_ = function (connectStatus) {
        this.updateInfo_('connected', connectStatus);
        if (connectStatus === false) {
            this.runOnDisconnectEvents_();
        }
    };
    /**
     * @param {!Object} updates
     * @private
     */
    Repo.prototype.onServerInfoUpdate_ = function (updates) {
        var _this = this;
        util_2.each(updates, function (value, key) {
            _this.updateInfo_(key, value);
        });
    };
    /**
     *
     * @param {!string} pathString
     * @param {*} value
     * @private
     */
    Repo.prototype.updateInfo_ = function (pathString, value) {
        var path = new Path_1.Path('/.info/' + pathString);
        var newNode = nodeFromJSON_1.nodeFromJSON(value);
        this.infoData_.updateSnapshot(path, newNode);
        var events = this.infoSyncTree_.applyServerOverwrite(path, newNode);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
    };
    /**
     * @return {!number}
     * @private
     */
    Repo.prototype.getNextWriteId_ = function () {
        return this.nextWriteId_++;
    };
    /**
     * @param {!Path} path
     * @param {*} newVal
     * @param {number|string|null} newPriority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.setWithPriority = function (path, newVal, newPriority, onComplete) {
        var _this = this;
        this.log_('set', {
            path: path.toString(),
            value: newVal,
            priority: newPriority
        });
        // TODO: Optimize this behavior to either (a) store flag to skip resolving where possible and / or
        // (b) store unresolved paths on JSON parse
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, newPriority);
        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        var writeId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, writeId, true);
        this.eventQueue_.queueEvents(events);
        this.server_.put(path.toString(), newNodeUnresolved.val(/*export=*/ true), function (status, errorReason) {
            var success = status === 'ok';
            if (!success) {
                util_2.warn('set at ' + path + ' failed: ' + status);
            }
            var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId, !success);
            _this.eventQueue_.raiseEventsForChangedPath(path, clearEvents);
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
        var affectedPath = this.abortTransactions_(path);
        this.rerunTransactions_(affectedPath);
        // We queued the events above, so just flush the queue here
        this.eventQueue_.raiseEventsForChangedPath(affectedPath, []);
    };
    /**
     * @param {!Path} path
     * @param {!Object} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.update = function (path, childrenToMerge, onComplete) {
        var _this = this;
        this.log_('update', { path: path.toString(), value: childrenToMerge });
        // Start with our existing data and merge each child into it.
        var empty = true;
        var serverValues = this.generateServerValues();
        var changedChildren = {};
        util_3.forEach(childrenToMerge, function (changedKey, changedValue) {
            empty = false;
            var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(changedValue);
            changedChildren[changedKey] = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        });
        if (!empty) {
            var writeId_1 = this.getNextWriteId_();
            var events = this.serverSyncTree_.applyUserMerge(path, changedChildren, writeId_1);
            this.eventQueue_.queueEvents(events);
            this.server_.merge(path.toString(), childrenToMerge, function (status, errorReason) {
                var success = status === 'ok';
                if (!success) {
                    util_2.warn('update at ' + path + ' failed: ' + status);
                }
                var clearEvents = _this.serverSyncTree_.ackUserWrite(writeId_1, !success);
                var affectedPath = clearEvents.length > 0 ? _this.rerunTransactions_(path) : path;
                _this.eventQueue_.raiseEventsForChangedPath(affectedPath, clearEvents);
                _this.callOnCompleteCallback(onComplete, status, errorReason);
            });
            util_3.forEach(childrenToMerge, function (changedPath) {
                var affectedPath = _this.abortTransactions_(path.child(changedPath));
                _this.rerunTransactions_(affectedPath);
            });
            // We queued the events above, so just flush the queue here
            this.eventQueue_.raiseEventsForChangedPath(path, []);
        }
        else {
            util_2.log("update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
        }
    };
    /**
     * Applies all of the changes stored up in the onDisconnect_ tree.
     * @private
     */
    Repo.prototype.runOnDisconnectEvents_ = function () {
        var _this = this;
        this.log_('onDisconnectEvents');
        var serverValues = this.generateServerValues();
        var resolvedOnDisconnectTree = ServerValues_1.resolveDeferredValueTree(this.onDisconnect_, serverValues);
        var events = [];
        resolvedOnDisconnectTree.forEachTree(Path_1.Path.Empty, function (path, snap) {
            events = events.concat(_this.serverSyncTree_.applyServerOverwrite(path, snap));
            var affectedPath = _this.abortTransactions_(path);
            _this.rerunTransactions_(affectedPath);
        });
        this.onDisconnect_ = new SparseSnapshotTree_1.SparseSnapshotTree();
        this.eventQueue_.raiseEventsForChangedPath(Path_1.Path.Empty, events);
    };
    /**
     * @param {!Path} path
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectCancel = function (path, onComplete) {
        var _this = this;
        this.server_.onDisconnectCancel(path.toString(), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.forget(path);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSet = function (path, value, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON_1.nodeFromJSON(value);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} value
     * @param {*} priority
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectSetWithPriority = function (path, value, priority, onComplete) {
        var _this = this;
        var newNode = nodeFromJSON_1.nodeFromJSON(value, priority);
        this.server_.onDisconnectPut(path.toString(), newNode.val(/*export=*/ true), function (status, errorReason) {
            if (status === 'ok') {
                _this.onDisconnect_.remember(path, newNode);
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Path} path
     * @param {*} childrenToMerge
     * @param {?function(?Error, *=)} onComplete
     */
    Repo.prototype.onDisconnectUpdate = function (path, childrenToMerge, onComplete) {
        var _this = this;
        if (util_3.isEmpty(childrenToMerge)) {
            util_2.log("onDisconnect().update() called with empty data.  Don't do anything.");
            this.callOnCompleteCallback(onComplete, 'ok');
            return;
        }
        this.server_.onDisconnectMerge(path.toString(), childrenToMerge, function (status, errorReason) {
            if (status === 'ok') {
                util_3.forEach(childrenToMerge, function (childName, childNode) {
                    var newChildNode = nodeFromJSON_1.nodeFromJSON(childNode);
                    _this.onDisconnect_.remember(path.child(childName), newChildNode);
                });
            }
            _this.callOnCompleteCallback(onComplete, status, errorReason);
        });
    };
    /**
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     */
    Repo.prototype.addEventCallbackForQuery = function (query, eventRegistration) {
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.addEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.addEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    /**
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration
     */
    Repo.prototype.removeEventCallbackForQuery = function (query, eventRegistration) {
        // These are guaranteed not to raise events, since we're not passing in a cancelError. However, we can future-proof
        // a little bit by handling the return values anyways.
        var events;
        if (query.path.getFront() === '.info') {
            events = this.infoSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        else {
            events = this.serverSyncTree_.removeEventRegistration(query, eventRegistration);
        }
        this.eventQueue_.raiseEventsAtPath(query.path, events);
    };
    Repo.prototype.interrupt = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.interrupt(INTERRUPT_REASON);
        }
    };
    Repo.prototype.resume = function () {
        if (this.persistentConnection_) {
            this.persistentConnection_.resume(INTERRUPT_REASON);
        }
    };
    Repo.prototype.stats = function (showDelta) {
        if (showDelta === void 0) { showDelta = false; }
        if (typeof console === 'undefined')
            return;
        var stats;
        if (showDelta) {
            if (!this.statsListener_)
                this.statsListener_ = new StatsListener_1.StatsListener(this.stats_);
            stats = this.statsListener_.get();
        }
        else {
            stats = this.stats_.get();
        }
        var longestName = Object.keys(stats).reduce(function (previousValue, currentValue) {
            return Math.max(currentValue.length, previousValue);
        }, 0);
        util_3.forEach(stats, function (stat, value) {
            // pad stat names to be the same length (plus 2 extra spaces).
            for (var i = stat.length; i < longestName + 2; i++)
                stat += ' ';
            console.log(stat + value);
        });
    };
    Repo.prototype.statsIncrementCounter = function (metric) {
        this.stats_.incrementCounter(metric);
        this.statsReporter_.includeStat(metric);
    };
    /**
     * @param {...*} var_args
     * @private
     */
    Repo.prototype.log_ = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        var prefix = '';
        if (this.persistentConnection_) {
            prefix = this.persistentConnection_.id + ':';
        }
        util_2.log.apply(void 0, [prefix].concat(var_args));
    };
    /**
     * @param {?function(?Error, *=)} callback
     * @param {!string} status
     * @param {?string=} errorReason
     */
    Repo.prototype.callOnCompleteCallback = function (callback, status, errorReason) {
        if (callback) {
            util_2.exceptionGuard(function () {
                if (status == 'ok') {
                    callback(null);
                }
                else {
                    var code = (status || 'error').toUpperCase();
                    var message = code;
                    if (errorReason)
                        message += ': ' + errorReason;
                    var error = new Error(message);
                    error.code = code;
                    callback(error);
                }
            });
        }
    };
    Object.defineProperty(Repo.prototype, "database", {
        get: function () {
            return this.__database || (this.__database = new Database_1.Database(this));
        },
        enumerable: true,
        configurable: true
    });
    return Repo;
}());
exports.Repo = Repo;

//# sourceMappingURL=Repo.js.map


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A cache node only stores complete children. Additionally it holds a flag whether the node can be considered fully
 * initialized in the sense that we know at one point in time this represented a valid state of the world, e.g.
 * initialized with data from the server, or a complete overwrite by the client. The filtered flag also tracks
 * whether a node potentially had children removed due to a filter.
 */
var CacheNode = /** @class */ (function () {
    /**
     * @param {!Node} node_
     * @param {boolean} fullyInitialized_
     * @param {boolean} filtered_
     */
    function CacheNode(node_, fullyInitialized_, filtered_) {
        this.node_ = node_;
        this.fullyInitialized_ = fullyInitialized_;
        this.filtered_ = filtered_;
    }
    /**
     * Returns whether this node was fully initialized with either server data or a complete overwrite by the client
     * @return {boolean}
     */
    CacheNode.prototype.isFullyInitialized = function () {
        return this.fullyInitialized_;
    };
    /**
     * Returns whether this node is potentially missing children due to a filter applied to the node
     * @return {boolean}
     */
    CacheNode.prototype.isFiltered = function () {
        return this.filtered_;
    };
    /**
     * @param {!Path} path
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForPath = function (path) {
        if (path.isEmpty()) {
            return this.isFullyInitialized() && !this.filtered_;
        }
        var childKey = path.getFront();
        return this.isCompleteForChild(childKey);
    };
    /**
     * @param {!string} key
     * @return {boolean}
     */
    CacheNode.prototype.isCompleteForChild = function (key) {
        return ((this.isFullyInitialized() && !this.filtered_) || this.node_.hasChild(key));
    };
    /**
     * @return {!Node}
     */
    CacheNode.prototype.getNode = function () {
        return this.node_;
    };
    return CacheNode;
}());
exports.CacheNode = CacheNode;

//# sourceMappingURL=CacheNode.js.map


/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var CODES = {
    AVAILABLE_IN_WINDOW: 'only-available-in-window',
    AVAILABLE_IN_SW: 'only-available-in-sw',
    SHOULD_BE_INHERITED: 'should-be-overriden',
    BAD_SENDER_ID: 'bad-sender-id',
    INCORRECT_GCM_SENDER_ID: 'incorrect-gcm-sender-id',
    PERMISSION_DEFAULT: 'permission-default',
    PERMISSION_BLOCKED: 'permission-blocked',
    UNSUPPORTED_BROWSER: 'unsupported-browser',
    NOTIFICATIONS_BLOCKED: 'notifications-blocked',
    FAILED_DEFAULT_REGISTRATION: 'failed-serviceworker-registration',
    SW_REGISTRATION_EXPECTED: 'sw-registration-expected',
    GET_SUBSCRIPTION_FAILED: 'get-subscription-failed',
    INVALID_SAVED_TOKEN: 'invalid-saved-token',
    SW_REG_REDUNDANT: 'sw-reg-redundant',
    TOKEN_SUBSCRIBE_FAILED: 'token-subscribe-failed',
    TOKEN_SUBSCRIBE_NO_TOKEN: 'token-subscribe-no-token',
    TOKEN_SUBSCRIBE_NO_PUSH_SET: 'token-subscribe-no-push-set',
    USE_SW_BEFORE_GET_TOKEN: 'use-sw-before-get-token',
    INVALID_DELETE_TOKEN: 'invalid-delete-token',
    DELETE_TOKEN_NOT_FOUND: 'delete-token-not-found',
    DELETE_SCOPE_NOT_FOUND: 'delete-scope-not-found',
    BG_HANDLER_FUNCTION_EXPECTED: 'bg-handler-function-expected',
    NO_WINDOW_CLIENT_TO_MSG: 'no-window-client-to-msg',
    UNABLE_TO_RESUBSCRIBE: 'unable-to-resubscribe',
    NO_FCM_TOKEN_FOR_RESUBSCRIBE: 'no-fcm-token-for-resubscribe',
    FAILED_TO_DELETE_TOKEN: 'failed-to-delete-token',
    NO_SW_IN_REG: 'no-sw-in-reg',
    BAD_SCOPE: 'bad-scope',
    BAD_VAPID_KEY: 'bad-vapid-key',
    BAD_SUBSCRIPTION: 'bad-subscription',
    BAD_TOKEN: 'bad-token',
    BAD_PUSH_SET: 'bad-push-set',
    FAILED_DELETE_VAPID_KEY: 'failed-delete-vapid-key'
};
var ERROR_MAP = (_a = {},
    _a[CODES.AVAILABLE_IN_WINDOW] = 'This method is available in a Window context.',
    _a[CODES.AVAILABLE_IN_SW] = 'This method is available in a service worker ' + 'context.',
    _a[CODES.SHOULD_BE_INHERITED] = 'This method should be overriden by ' + 'extended classes.',
    _a[CODES.BAD_SENDER_ID] = "Please ensure that 'messagingSenderId' is set " +
        'correctly in the options passed into firebase.initializeApp().',
    _a[CODES.PERMISSION_DEFAULT] = 'The required permissions were not granted and ' + 'dismissed instead.',
    _a[CODES.PERMISSION_BLOCKED] = 'The required permissions were not granted and ' + 'blocked instead.',
    _a[CODES.UNSUPPORTED_BROWSER] = "This browser doesn't support the API's " +
        'required to use the firebase SDK.',
    _a[CODES.NOTIFICATIONS_BLOCKED] = 'Notifications have been blocked.',
    _a[CODES.FAILED_DEFAULT_REGISTRATION] = 'We are unable to register the ' +
        'default service worker. {$browserErrorMessage}',
    _a[CODES.SW_REGISTRATION_EXPECTED] = 'A service worker registration was the ' + 'expected input.',
    _a[CODES.GET_SUBSCRIPTION_FAILED] = 'There was an error when trying to get ' +
        'any existing Push Subscriptions.',
    _a[CODES.INVALID_SAVED_TOKEN] = 'Unable to access details of the saved token.',
    _a[CODES.SW_REG_REDUNDANT] = 'The service worker being used for push was made ' + 'redundant.',
    _a[CODES.TOKEN_SUBSCRIBE_FAILED] = 'A problem occured while subscribing the ' + 'user to FCM: {$message}',
    _a[CODES.TOKEN_SUBSCRIBE_NO_TOKEN] = 'FCM returned no token when subscribing ' + 'the user to push.',
    _a[CODES.TOKEN_SUBSCRIBE_NO_PUSH_SET] = 'FCM returned an invalid response ' + 'when getting an FCM token.',
    _a[CODES.USE_SW_BEFORE_GET_TOKEN] = 'You must call useServiceWorker() before ' +
        'calling getToken() to ensure your service worker is used.',
    _a[CODES.INVALID_DELETE_TOKEN] = 'You must pass a valid token into ' +
        'deleteToken(), i.e. the token from getToken().',
    _a[CODES.DELETE_TOKEN_NOT_FOUND] = 'The deletion attempt for token could not ' +
        'be performed as the token was not found.',
    _a[CODES.DELETE_SCOPE_NOT_FOUND] = 'The deletion attempt for service worker ' +
        'scope could not be performed as the scope was not found.',
    _a[CODES.BG_HANDLER_FUNCTION_EXPECTED] = 'The input to ' + 'setBackgroundMessageHandler() must be a function.',
    _a[CODES.NO_WINDOW_CLIENT_TO_MSG] = 'An attempt was made to message a ' + 'non-existant window client.',
    _a[CODES.UNABLE_TO_RESUBSCRIBE] = 'There was an error while re-subscribing ' +
        'the FCM token for push messaging. Will have to resubscribe the ' +
        'user on next visit. {$message}',
    _a[CODES.NO_FCM_TOKEN_FOR_RESUBSCRIBE] = 'Could not find an FCM token ' +
        'and as a result, unable to resubscribe. Will have to resubscribe the ' +
        'user on next visit.',
    _a[CODES.FAILED_TO_DELETE_TOKEN] = 'Unable to delete the currently saved token.',
    _a[CODES.NO_SW_IN_REG] = 'Even though the service worker registration was ' +
        'successful, there was a problem accessing the service worker itself.',
    _a[CODES.INCORRECT_GCM_SENDER_ID] = "Please change your web app manifest's " +
        "'gcm_sender_id' value to '103953800507' to use Firebase messaging.",
    _a[CODES.BAD_SCOPE] = 'The service worker scope must be a string with at ' +
        'least one character.',
    _a[CODES.BAD_VAPID_KEY] = 'The public VAPID key must be a string with at ' + 'least one character.',
    _a[CODES.BAD_SUBSCRIPTION] = 'The subscription must be a valid ' + 'PushSubscription.',
    _a[CODES.BAD_TOKEN] = 'The FCM Token used for storage / lookup was not ' +
        'a valid token string.',
    _a[CODES.BAD_PUSH_SET] = 'The FCM push set used for storage / lookup was not ' +
        'not a valid push set string.',
    _a[CODES.FAILED_DELETE_VAPID_KEY] = 'The VAPID key could not be deleted.',
    _a);
/* harmony default export */ __webpack_exports__["a"] = ({
    codes: CODES,
    map: ERROR_MAP
});
var _a;

//# sourceMappingURL=errors.js.map


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(191);
var createDesc = __webpack_require__(277);
module.exports = __webpack_require__(121) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(192);
var IE8_DOM_DEFINE = __webpack_require__(1264);
var toPrimitive = __webpack_require__(1265);
var dP = Object.defineProperty;

exports.f = __webpack_require__(121) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(276);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 193 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(1267);
var enumBugKeys = __webpack_require__(504);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 195 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(195);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}
module.exports = exports['default'];

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = all;

var _createChainableTypeChecker = __webpack_require__(197);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function all() {
  for (var _len = arguments.length, validators = Array(_len), _key = 0; _key < _len; _key++) {
    validators[_key] = arguments[_key];
  }

  function allPropTypes() {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    var error = null;

    validators.forEach(function (validator) {
      if (error != null) {
        return;
      }

      var result = validator.apply(undefined, args);
      if (result != null) {
        error = result;
      }
    });

    return error;
  }

  return (0, _createChainableTypeChecker2.default)(allPropTypes);
}
module.exports = exports['default'];

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__ = __webpack_require__(510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__ = __webpack_require__(43);























var TOGGLE_ROLE = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */].defaultProps.bsRole;
var MENU_ROLE = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */].defaultProps.bsRole;
var propTypes = {
  /**
   * The menu will open above the dropdown button, instead of below it.
   */
  dropup: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * An html id attribute, necessary for assistive technologies, such as screen readers.
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_13_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.number])),
  componentClass: __WEBPACK_IMPORTED_MODULE_12_prop_types_extra_lib_elementType___default.a,

  /**
   * The children of a Dropdown may be a `<Dropdown.Toggle>` or a `<Dropdown.Menu>`.
   * @type {node}
   */
  children: __WEBPACK_IMPORTED_MODULE_11_prop_types_extra_lib_all___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["c" /* requiredRoles */])(TOGGLE_ROLE, MENU_ROLE), Object(__WEBPACK_IMPORTED_MODULE_21__utils_PropTypes__["a" /* exclusiveRoles */])(MENU_ROLE)),

  /**
   * Whether or not component is disabled.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Align the menu to the right side of the Dropdown toggle
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * Whether or not the Dropdown is visible.
   *
   * @controllable onToggle
   */
  open: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,
  defaultOpen: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,

  /**
   * A callback fired when the Dropdown wishes to change visibility. Called with the requested
   * `open` value, the DOM event, and the source that fired it: `'click'`,`'keydown'`,`'rootClose'`, or `'select'`.
   *
   * ```js
   * function(Boolean isOpen, Object event, { String source }) {}
   * ```
   * @controllable open
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * A callback fired when a menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * If `'menuitem'`, causes the dropdown to behave like a menu item rather than
   * a menu button.
   */
  role: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string,

  /**
   * Which event when fired outside the component will cause it to be closed
   *
   * *Note: For custom dropdown components, you will have to pass the
   * `rootCloseEvent` to `<RootCloseWrapper>` in your custom dropdown menu
   * component ([similarly to how it is implemented in `<Dropdown.Menu>`](https://github.com/react-bootstrap/react-bootstrap/blob/v0.31.5/src/DropdownMenu.js#L115-L119)).*
   */
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.oneOf(['click', 'mousedown']),

  /**
   * @private
   */
  onMouseEnter: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseLeave: __WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.func
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_16__ButtonGroup__["a" /* default */]
};

var Dropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Dropdown, _React$Component);

  function Dropdown(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleClose = _this.handleClose.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this._focusInDropdown = false;
    _this.lastOpenEventType = null;
    return _this;
  }

  var _proto = Dropdown.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.focusNextOnOpen();
  };

  _proto.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!nextProps.open && this.props.open) {
      this._focusInDropdown = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_query_contains___default()(__WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.menu), __WEBPACK_IMPORTED_MODULE_5_dom_helpers_activeElement___default()(document));
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var open = this.props.open;
    var prevOpen = prevProps.open;

    if (open && !prevOpen) {
      this.focusNextOnOpen();
    }

    if (!open && prevOpen) {
      // if focus hasn't already moved from the menu let's return it
      // to the toggle
      if (this._focusInDropdown) {
        this._focusInDropdown = false;
        this.focus();
      }
    }
  };

  _proto.focus = function focus() {
    var toggle = __WEBPACK_IMPORTED_MODULE_10_react_dom___default.a.findDOMNode(this.toggle);

    if (toggle && toggle.focus) {
      toggle.focus();
    }
  };

  _proto.focusNextOnOpen = function focusNextOnOpen() {
    var menu = this.menu;

    if (!menu || !menu.focusNext) {
      return;
    }

    if (this.lastOpenEventType === 'keydown' || this.props.role === 'menuitem') {
      menu.focusNext();
    }
  };

  _proto.handleClick = function handleClick(event) {
    if (this.props.disabled) {
      return;
    }

    this.toggleOpen(event, {
      source: 'click'
    });
  };

  _proto.handleClose = function handleClose(event, eventDetails) {
    if (!this.props.open) {
      return;
    }

    this.toggleOpen(event, eventDetails);
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    if (this.props.disabled) {
      return;
    }

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.down:
        if (!this.props.open) {
          this.toggleOpen(event, {
            source: 'keydown'
          });
        } else if (this.menu.focusNext) {
          this.menu.focusNext();
        }

        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_7_keycode___default.a.codes.tab:
        this.handleClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.toggleOpen = function toggleOpen(event, eventDetails) {
    var open = !this.props.open;

    if (open) {
      this.lastOpenEventType = eventDetails.source;
    }

    if (this.props.onToggle) {
      this.props.onToggle(open, event, eventDetails);
    }
  };

  _proto.renderMenu = function renderMenu(child, _ref) {
    var _this2 = this;

    var id = _ref.id,
        onSelect = _ref.onSelect,
        rootCloseEvent = _ref.rootCloseEvent,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["id", "onSelect", "rootCloseEvent"]);

    var ref = function ref(c) {
      _this2.menu = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Menu>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      labelledBy: id,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'menu'),
      onClose: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClose, this.handleClose),
      onSelect: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, function (key, event) {
        return _this2.handleClose(event, {
          source: 'select'
        });
      }),
      rootCloseEvent: rootCloseEvent
    }));
  };

  _proto.renderToggle = function renderToggle(child, props) {
    var _this3 = this;

    var ref = function ref(c) {
      _this3.toggle = c;
    };

    if (typeof child.ref === 'string') {
       false ? warning(false, 'String refs are not supported on `<Dropdown.Toggle>` components. ' + 'To apply a ref to the component use the callback signature:\n\n ' + 'https://facebook.github.io/react/docs/more-about-refs.html#the-ref-callback-attribute') : void 0;
    } else {
      ref = Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.ref, ref);
    }

    return Object(__WEBPACK_IMPORTED_MODULE_8_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      ref: ref,
      bsClass: Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["e" /* prefix */])(props, 'toggle'),
      onClick: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onClick, this.handleClick),
      onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_20__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, this.handleKeyDown)
    }));
  };

  _proto.render = function render() {
    var _classes,
        _this4 = this;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        id = _this$props.id,
        dropup = _this$props.dropup,
        disabled = _this$props.disabled,
        pullRight = _this$props.pullRight,
        open = _this$props.open,
        onSelect = _this$props.onSelect,
        role = _this$props.role,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "id", "dropup", "disabled", "pullRight", "open", "onSelect", "role", "bsClass", "className", "rootCloseEvent", "children"]);

    delete props.onToggle;
    var classes = (_classes = {}, _classes[bsClass] = true, _classes.open = open, _classes.disabled = disabled, _classes);

    if (dropup) {
      classes[bsClass] = false;
      classes.dropup = true;
    } // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.


    return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_22__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      switch (child.props.bsRole) {
        case TOGGLE_ROLE:
          return _this4.renderToggle(child, {
            id: id,
            disabled: disabled,
            open: open,
            role: role,
            bsClass: bsClass
          });

        case MENU_ROLE:
          return _this4.renderMenu(child, {
            id: id,
            open: open,
            pullRight: pullRight,
            bsClass: bsClass,
            onSelect: onSelect,
            rootCloseEvent: rootCloseEvent
          });

        default:
          return child;
      }
    }));
  };

  return Dropdown;
}(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Component);

Dropdown.propTypes = propTypes;
Dropdown.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_19__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', Dropdown);
var UncontrolledDropdown = __WEBPACK_IMPORTED_MODULE_14_uncontrollable___default()(Dropdown, {
  open: 'onToggle'
});
UncontrolledDropdown.Toggle = __WEBPACK_IMPORTED_MODULE_18__DropdownToggle__["a" /* default */];
UncontrolledDropdown.Menu = __WEBPACK_IMPORTED_MODULE_17__DropdownMenu__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (UncontrolledDropdown);

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isRequiredForA11y;
function isRequiredForA11y(validator) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      return new Error('The ' + location + ' `' + propFullNameSafe + '` is required to make ' + ('`' + componentNameSafe + '` accessible for users of assistive ') + 'technologies such as screen readers.');
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}
module.exports = exports['default'];

/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = splitComponentProps;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries__);

function splitComponentProps(props, Component) {
  var componentPropTypes = Component.propTypes;
  var parentProps = {};
  var childProps = {};

  __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_entries___default()(props).forEach(function (_ref) {
    var propName = _ref[0],
        propValue = _ref[1];

    if (componentPropTypes[propName]) {
      parentProps[propName] = propValue;
    } else {
      childProps[propName] = propValue;
    }
  });

  return [parentProps, childProps];
}

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__);




var _fadeStyles;





var propTypes = {
  /**
   * Show the component; triggers the fade in or fade out animation
   */
  in: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is faded out
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Run the fade in animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Duration of the fade animation in milliseconds, to ensure that finishing
   * callbacks are fired even if the original browser transition end events are
   * canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Callback fired before the component fades in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the has component faded in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired before the component fades out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to fade out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the component has faded out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false
};
var fadeStyles = (_fadeStyles = {}, _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERING"]] = 'in', _fadeStyles[__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition__["ENTERED"]] = 'in', _fadeStyles);

var Fade =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Fade, _React$Component);

  function Fade() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Fade.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group_Transition___default.a, props, function (status, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()('fade', className, children.props.className, fadeStyles[status])
      }));
    });
  };

  return Fade;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Fade.propTypes = propTypes;
Fade.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__MediaBody__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MediaHeading__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MediaLeft__ = __webpack_require__(1341);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MediaList__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__MediaListItem__ = __webpack_require__(1343);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__MediaRight__ = __webpack_require__(1344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(11);













var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Media =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Media, _React$Component);

  function Media() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Media.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Media;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Media.propTypes = propTypes;
Media.defaultProps = defaultProps;
Media.Heading = __WEBPACK_IMPORTED_MODULE_7__MediaHeading__["a" /* default */];
Media.Body = __WEBPACK_IMPORTED_MODULE_6__MediaBody__["a" /* default */];
Media.Left = __WEBPACK_IMPORTED_MODULE_8__MediaLeft__["a" /* default */];
Media.Right = __WEBPACK_IMPORTED_MODULE_11__MediaRight__["a" /* default */];
Media.List = __WEBPACK_IMPORTED_MODULE_9__MediaList__["a" /* default */];
Media.ListItem = __WEBPACK_IMPORTED_MODULE_10__MediaListItem__["a" /* default */];
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('media', Media));

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(197);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement. You can usually obtain a ReactComponent or DOMElement ' + 'from a ReactElement by attaching a ref to it.');
  }

  if ((propType !== 'object' || typeof propValue.render !== 'function') && propValue.nodeType !== 1) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected a ReactComponent or a ') + 'DOMElement.');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(validate);
module.exports = exports['default'];

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getWindow;

function getWindow(node) {
  return node === node.window ? node : node.nodeType === 9 ? node.defaultView || node.parentWindow : false;
}

module.exports = exports["default"];

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = getContainer;

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainer(container, defaultContainer) {
  container = typeof container === 'function' ? container() : container;
  return _reactDom2.default.findDOMNode(container) || defaultContainer;
}
module.exports = exports['default'];

/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Iconset_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Icon_js__ = __webpack_require__(1415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__style_js__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Render an iconPicker component
 *
 * <IconPicker iconset={iconset} size={size} onSelect={callback(item)} />
 * iconset  = string (check availableIconsets constant)
 * size     = integer (default 60)
 * label    = string
 * onSelect = callback function that accept one string parameter (the icon name)
 */var IconPicker=function(_Component){_inherits(IconPicker,_Component);function IconPicker(props){_classCallCheck(this,IconPicker);var _this=_possibleConstructorReturn(this,(IconPicker.__proto__||Object.getPrototypeOf(IconPicker)).call(this,props));_initialiseProps.call(_this);_this.iconsPerPage=100;var iconSwitch=_this.switchIconSet(_this.props.icon,_this.props.iconset,true);_this.state={open:false,search:"",iconset:iconSwitch.iconset,tabIndex:0,iconSelected:iconSwitch.icon,countPages:1,page:0};_this.onChangeTab=_this.onChangeTab.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.filterIcons=_this.filterIcons.bind(_this);_this.size=_this.props.size||__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["b" /* _DefaultIconSize */];_this.color=_this.props.color||__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["a" /* _DefaultIconColor */];_this.callback=_this.props.onSelect?_this.props.onSelect:function(icon){console.log("default onSelect",icon);};_this.buttonLabel=_this.props.label||"IconPicker";_this.buttonStyle=_this.props.buttonStyle||{};_this.iconStyle=_this.props.iconStyle||{};// fix ionic size
if(Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["f" /* isIonicons */])(_this.state.iconset)){_this.size=_this.size+"px";}return _this;}_createClass(IconPicker,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.icon!=nextProps.icon||this.props.iconset!=nextProps.iconset){var iconSwitch=this.switchIconSet(nextProps.icon,nextProps.iconset,true);console.log("ICONSET",iconSwitch);this.setState({iconSelected:iconSwitch.icon,iconset:iconSwitch.iconset});}}},{key:"switchIconSet",value:function switchIconSet(icon,iconset,toRender){console.log("ICON",icon);if(icon){if(toRender){switch(iconset){case"MaterialIcons":return{iconset:"material",icon:"ic_"+icon.replace(/-/g,"_")};case"FontAwesome":return{iconset:"fa",icon:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.camelCase(icon)};case"Ionicons":return{iconset:"ionicons3",icon:icon};default:return{iconset:"material",icon:"ic_"+icon.replace(/-/g,"_")};}}else{switch(iconset){case"material":return{iconset:"MaterialIcons",icon:icon.substring(3,icon.length).replace(/_/g,"-")};case"fa":return{iconset:"FontAwesome",icon:__WEBPACK_IMPORTED_MODULE_6_lodash___default.a.kebabCase(icon)};case"ionicons3":return{iconset:"Ionicons",icon:icon};default:return{iconset:"MaterialIcons",icon:icon.substring(3,icon.length).replace(/_/g,"-")};}}}else{return toRender?{iconset:"material",icon:""}:{iconset:"MaterialIcons",icon:""};}}/*
   * Modal Dialog Methods
   *//*
   * Filter Methods
   *//*
   * Render Methods
   */// render an <Paper /> item with logo and logo name
},{key:"onChangeTab",value:function onChangeTab(evt,value){switch(value){case 1:this.setState({iconset:"fa",tabIndex:value,iconSelected:null,page:0});break;case 2:this.setState({iconset:"ionicons3",tabIndex:value,iconSelected:null,page:0});break;default:this.setState({iconset:"material",tabIndex:value,iconSelected:null,page:0});}}},{key:"onChangePage",value:function onChangePage(evt,value){this.setState({page:value});}},{key:"renderPages",value:function renderPages(icons){var tabs=[];var count=icons.count%this.iconsPerPage==0?icons.count/this.iconsPerPage:Math.trunc(icons.count/this.iconsPerPage)+1;for(var i=0;i<count;i++){tabs.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["N" /* Tab */],{label:i+1,selected:this.state.page==i,style:{minWidth:0}}));}return tabs;}// render dialog
},{key:"render",value:function render(){// is it Ionic?
var icons=void 0;// performance hack, only render icons when the popup is open
if(this.state.open){icons=this.renderIcons();}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"columns-row-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MuiInputBase-root MuiInput-root MuiInput-underline column-full",style:{height:32,width:"70%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Button */],{onClick:this.onOpen,style:this.buttonStyle,color:"primary"},this.state.iconSelected?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon_js__["a" /* default */],{iconset:this.state.iconset,icon:this.state.iconSelected,size:24}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,"Seleccionar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["q" /* Fab */],{size:"small",onClick:this.onOpen,color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Search___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["k" /* Dialog */]//modal={false}
,{open:this.state.open,onClose:this.onClose,maxWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* DialogTitle */],null,this.buttonLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["o" /* DialogTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["B" /* InputLabel */],null,"Buscar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["W" /* TextField */],{value:this.state.search,onChange:this.onChangeSearchField,fullWidth:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["V" /* Tabs */],{indicatorColor:"primary",value:this.state.tabIndex,onChange:this.onChangeTab,centered:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["N" /* Tab */],{label:"Material"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["N" /* Tab */],{label:"FontAwesome"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* GridList */],{cols:6,cellHeight:"auto"},icons&&icons.list.map(this.renderItem))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],null,"P\xE1gina:"),icons&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["V" /* Tabs */],{onChange:this.onChangePage,value:this.state.page,centered:true},this.renderPages(icons)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onClose},"Cerrar"))));}}]);return IconPicker;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);var _initialiseProps=function _initialiseProps(){var _this2=this;this.onOpen=function(){_this2.setState({open:true});};this.onClose=function(){_this2.setState({open:false});};this.onClick=function(icon){_this2.setState({search:"",open:false,iconSelected:icon});var iconSwitch=_this2.switchIconSet(icon,_this2.state.iconset,false);console.log("ON CLICK ICON",iconSwitch);_this2.callback({icon:iconSwitch.icon,family:iconSwitch.iconset});};this.onChangeSearchField=function(event){var search=event.target.value,icons=void 0;_this2.setState({search:search});if(_this2.state.iconset==="ionicons3"){icons=_this2.filterIcons(search);}else{}_this2.setState({icons:icons});};this.filterIcons=function(){var search=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"";var data=Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["c" /* getAllIcons */])(_this2.state.iconset);var icons=_this2.state.iconset==="ionicons3"?data:Object.keys(data);if(search){var pattern=new RegExp(search);icons=icons.filter(function(value){return pattern.test(value);});}var from=_this2.state.page*_this2.iconsPerPage;var to=from+_this2.iconsPerPage;var count=icons.length;return{count:count,list:icons.slice(from,to)};};this.renderItem=function(icon){var iconStyle=Object.assign({},__WEBPACK_IMPORTED_MODULE_5__style_js__["a" /* default */].item,_this2.iconStyle,{color:_this2.color});var iconName=_this2.state.iconset=="material"?icon.substring(3,icon.length):icon;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["D" /* ListItem */],{button:true,key:icon,style:iconStyle,onClick:function onClick(){_this2.onClick(icon);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["E" /* ListItemIcon */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Icon_js__["a" /* default */],{iconset:_this2.state.iconset,icon:icon,size:_this2.size,color:_this2.color})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["G" /* ListItemText */],{primary:iconName}));};this.renderIcons=function(){return _this2.filterIcons(_this2.state.search);};};/* harmony default export */ __webpack_exports__["a"] = (IconPicker);

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MediaConfig__ = __webpack_require__(1451);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var MediaService=function(){function MediaService(){_classCallCheck(this,MediaService);}_createClass(MediaService,null,[{key:"uploadFile",value:function uploadFile(file,path,type){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_1__MediaConfig__["a" /* default */].FirebaseConnector.uploadFile(file,path,type,function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(downloadURL,path,filename){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:resolve({downloadURL:downloadURL,path:path,filename:filename});/*INIT_INJECT_API_REST_MEDIA_SERVICE*/case 1:case"end":return _context.stop();}}},_callee,_this);}));return function(_x3,_x4,_x5){return _ref2.apply(this,arguments);};}());case 3:_context2.next=8;break;case 5:_context2.prev=5;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 8:case"end":return _context2.stop();}}},_callee2,_this,[[0,5]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"downloadFile",value:function downloadFile(filePath){var _this2=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_1__MediaConfig__["a" /* default */].FirebaseConnector.downloadFile(filePath);case 3:response=_context3.sent;resolve(response);_context3.next=10;break;case 7:_context3.prev=7;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 10:case"end":return _context3.stop();}}},_callee3,_this2,[[0,7]]);}));return function(_x6,_x7){return _ref3.apply(this,arguments);};}());}},{key:"deleteFile",value:function deleteFile(filePath){var _this3=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:try{//   console.log("FILEPATH", filePath)
__WEBPACK_IMPORTED_MODULE_1__MediaConfig__["a" /* default */].FirebaseConnector.deleteFile(filePath,function(r){resolve(r);});}catch(error){reject(error);}case 1:case"end":return _context4.stop();}}},_callee4,_this3);}));return function(_x8,_x9){return _ref4.apply(this,arguments);};}());}}]);return MediaService;}();/* harmony default export */ __webpack_exports__["a"] = (MediaService);

/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = actionSaveTag;
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetTags;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeleteTagFromUser;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_tag_TagService__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
function actionSaveTag(tag,successCallback,errorCallback){return function(dispatch,getStore){__WEBPACK_IMPORTED_MODULE_1__provider_tag_TagService__["a" /* default */].saveTag(getStore().app.app,tag).then(function(response){successCallback&&successCallback(response);}).catch(errorCallback);};}function actionGetTags(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_tag_TagService__["a" /* default */].getTags(getStore().app.app).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["i" /* ACT_TAG_CHANGE */],props:{tagList:response}});succesCallback&&succesCallback(response);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeleteTagFromUser(tag,user,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);console.log("actionDeleteTagFromUser",tag,user);__WEBPACK_IMPORTED_MODULE_1__provider_tag_TagService__["a" /* default */].deleteTagFromUser(getStore().app.app,tag,user).then(function(response){successCallback&&successCallback(response);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}

/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_CameraAltRounded__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_CameraAltRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_CameraAltRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info__ = __webpack_require__(1460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FileInput__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SelectAll__ = __webpack_require__(1462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SelectAll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_SelectAll__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var styles={gridList:{display:"flex",flexWrap:"nowrap",overflowX:"auto",width:"auto"},input:{cursor:"pointer",position:"absolute",top:0,bottom:0,right:0,left:0,width:"100%",opacity:0}};var ImageSelector=function(_Component){_inherits(ImageSelector,_Component);function ImageSelector(props){_classCallCheck(this,ImageSelector);// console.log("IMAGE ", props.imagePreviewUrl)
var _this=_possibleConstructorReturn(this,(ImageSelector.__proto__||Object.getPrototypeOf(ImageSelector)).call(this,props));_this.adaptFileEventToValue=function(delegate){return function(e){if(e.target.files[0]){// e.preventDefault();
// let reader = new FileReader()
// let img = new Image()
// let dimensions = {}
// reader.onloadend = () => {
// 	img.onload = () => {
// 		dimensions.width = img.width
// 		dimensions.height = img.height
// 		console.log(img.width, img.height)
// 		console.log(this.props.fileDimentions.width)
// 		console.log(this.props.fileDimentions.height)
// 	}
// 	img.src = reader.result
// }
// reader.readAsDataURL(e.target.files[0])
if(e.target.files[0].size<=_this.props.fileSize){// if (e.target.files[0].size <= this.props.fileSize &&
//img.width === this.props.fileDimentions.width &&
//img.height === this.props.fileDimentions.height) {
_this.handleImageChange(e);//añadido para sindicato controlador de estado de la pantalla a la que pertenece
// eslint-disable-next-line
_this.props.onChangeState?_this.props.onChangeState():null;delegate(e.target.files[0]);_this.setState({fileName:e.target.files[0].name});}else _this.setState({sizeErrorText:"La imagen debe ser de \n\t\t\t"+_this.props.fileDimentions.width+"x\n\t\t\t"+_this.props.fileDimentions.height+" y el tama\xF1o no debe superar "+_this.props.fileSize/1000+"kb",fileName:null});}};};_this.deleteFile=function(){var fieldName=_this.props.fieldName;var dispatch=_this.refs.field.context._reduxForm.dispatch;var change=_this.refs.field.context._reduxForm.change;dispatch(change(fieldName,""));_this.refs.field.getRenderedComponent().refs.FileInput.value="";_this.setState({imagePreviewUrl:null,fileName:null});// eslint-disable-next-line
_this.props.onChangeDeleteFlag?_this.props.onChangeDeleteFlag():null;};_this.state={imagePreviewUrl:_this.props.imagePreviewUrl,sizeErrorText:null,fileName:_this.props.fileName};return _this;}_createClass(ImageSelector,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.imagePreviewUrl!==this.props.imagePreviewUrl){// console.log("CHANGE IMAGE ", nextProps.imagePreviewUrl)
this.setState({imagePreviewUrl:nextProps.imagePreviewUrl,fileName:nextProps.fileName});}}},{key:"handleImageChange",value:function handleImageChange(e){var _this2=this;e.preventDefault();var reader=new FileReader();reader.onloadend=function(){return _this2.setState({imagePreviewUrl:reader.result,sizeErrorText:null});};reader.readAsDataURL(e.target.files[0]);if(e.type!=="blur")this.refs.field.getRenderedComponent().refs.FileInput.blur();}},{key:"renderPreviews",value:function renderPreviews(){var previewUrl=this.state.imagePreviewUrl;if(previewUrl)return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.props.styleRenderPreviews},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Vista previa"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["v" /* GridList */],{cols:2,style:styles.gridList,cellHeight:"auto"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["w" /* GridListTile */],{title:" ",style:{width:300,height:180},actionIcon:this.props.disabledUploadPhoto?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["y" /* IconButton */],{onClick:this.deleteFile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete___default.a,{color:"white"}))},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:{height:"100%",width:"100%",objectFit:"contain"},src:previewUrl,alt:""}))));}},{key:"render",value:function render(){// console.log("RENDER IMAGE STATE",this.state.imagePreviewUrl)
var props=this.props;var previewStyle=this.state.imagePreviewUrl?{backgroundImage:"url(\""+this.state.imagePreviewUrl+"\")"}:{};var iconPreviewStyle=this.state.imagePreviewUrl?{opacity:0.5}:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.classNameIS},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["e" /* Button */],{variant:"container"// labelPosition="before"
// containerElement="label"
,style:Object.assign({},props.styleButton,previewStyle),disabled:this.props.disabledUploadPhoto?this.props.disabledUploadPhoto:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_CameraAltRounded___default.a,{color:"primary",style:Object.assign({fontSize:63},iconPreviewStyle)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],_defineProperty({ref:"field",name:props.fieldName,component:__WEBPACK_IMPORTED_MODULE_6__FileInput__["a" /* default */],validate:props.validate,style:styles.input,adaptEvent:this.adaptFileEventToValue,accept:"image/x-png,image/jpeg",withRef:true,disabled:this.props.disabledUploadPhoto?this.props.disabledUploadPhoto:false},"validate",props.validate))),this.state.sizeErrorText?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"display-flex align-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_icons_Info___default.a,{color:"#00529b",style:{width:16}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"margin0 light",style:{fontSize:11,marginLeft:5}},this.state.sizeErrorText)):null,this.props.noPreview?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"display-flex align-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{className:"margin0 light",style:{fontSize:11,marginLeft:5,whiteSpace:"nowrap",overflow:"hidden",textOverflow:"ellipsis"}},this.state.fileName),this.props.showDelete&&this.state.imagePreviewUrl?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["y" /* IconButton */],{onClick:this.deleteFile},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__material_ui_icons_Delete___default.a,{color:"primary"})):null):this.renderPreviews());}}]);return ImageSelector;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ImageSelector);

/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSvgIcon;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_SvgIcon__ = __webpack_require__(116);



function createSvgIcon(path, displayName) {
  var Component = __WEBPACK_IMPORTED_MODULE_1_react___default.a.memo(__WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function (props, ref) {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_SvgIcon__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: ref
    }, props), path);
  }));

  if (false) {
    Component.displayName = "".concat(displayName, "Icon");
  }

  Component.muiName = __WEBPACK_IMPORTED_MODULE_2__material_ui_core_SvgIcon__["default"].muiName;
  return Component;
}

/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ColorField=function(_Component){_inherits(ColorField,_Component);function ColorField(props){_classCallCheck(this,ColorField);var _this=_possibleConstructorReturn(this,(ColorField.__proto__||Object.getPrototypeOf(ColorField)).call(this,props));_this.state={value:"#EE0000"};_this.onChange=_this.onChange.bind(_this);return _this;}_createClass(ColorField,[{key:"onChange",value:function onChange(evt){this.setState({value:evt.target.value});this.props.input.onChange(evt.target.value);// console.log("COLOR", evt.target.value, this.props.meta)
}},{key:"render",value:function render(){// console.log("COLOR FIELD PROPS", this.props)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"MuiInput-Base-root MuiInput-root MuiInput-underline display-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({},this.props.input,{className:"MuiInput-input color-selector",type:"color"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({},this.props.input,{className:"MuiInputBase-input MuiInput-input"})));}}]);return ColorField;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (ColorField);

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
}), 'List');

exports.default = _default;

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(102);
var global = __webpack_require__(71);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(305) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 216 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 217 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 218 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(305);
var $export = __webpack_require__(310);
var redefine = __webpack_require__(103);
var hide = __webpack_require__(104);
var Iterators = __webpack_require__(128);
var $iterCreate = __webpack_require__(596);
var setToStringTag = __webpack_require__(221);
var getPrototypeOf = __webpack_require__(603);
var ITERATOR = __webpack_require__(56)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(215)('keys');
var uid = __webpack_require__(156);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(105).f;
var has = __webpack_require__(107);
var TAG = __webpack_require__(56)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(78);
module.exports = function (it, TYPE) {
  if (!isObject(it) || it._t !== TYPE) throw TypeError('Incompatible receiver, ' + TYPE + ' required!');
  return it;
};


/***/ }),
/* 223 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createBrowserHistory */
/* unused harmony export createHashHistory */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(639);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(327);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["default"])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["default"])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["default"])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(88);




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) != objectTag) {
    return false;
  }
  var proto = Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ __webpack_exports__["a"] = (isPlainObject);


/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prefix", function() { return prefix; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_INSERT", function() { return ARRAY_INSERT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_MOVE", function() { return ARRAY_MOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_POP", function() { return ARRAY_POP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_PUSH", function() { return ARRAY_PUSH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE", function() { return ARRAY_REMOVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_REMOVE_ALL", function() { return ARRAY_REMOVE_ALL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SHIFT", function() { return ARRAY_SHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SPLICE", function() { return ARRAY_SPLICE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_UNSHIFT", function() { return ARRAY_UNSHIFT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ARRAY_SWAP", function() { return ARRAY_SWAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AUTOFILL", function() { return AUTOFILL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BLUR", function() { return BLUR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CHANGE", function() { return CHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_FIELDS", function() { return CLEAR_FIELDS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT", function() { return CLEAR_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_SUBMIT_ERRORS", function() { return CLEAR_SUBMIT_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CLEAR_ASYNC_ERROR", function() { return CLEAR_ASYNC_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DESTROY", function() { return DESTROY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS", function() { return FOCUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "INITIALIZE", function() { return INITIALIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "REGISTER_FIELD", function() { return REGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET", function() { return RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RESET_SECTION", function() { return RESET_SECTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_FAILED", function() { return SET_SUBMIT_FAILED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SET_SUBMIT_SUCCEEDED", function() { return SET_SUBMIT_SUCCEEDED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_ASYNC_VALIDATION", function() { return START_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "START_SUBMIT", function() { return START_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_ASYNC_VALIDATION", function() { return STOP_ASYNC_VALIDATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "STOP_SUBMIT", function() { return STOP_SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SUBMIT", function() { return SUBMIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOUCH", function() { return TOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNREGISTER_FIELD", function() { return UNREGISTER_FIELD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UNTOUCH", function() { return UNTOUCH; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_ERRORS", function() { return UPDATE_SYNC_ERRORS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UPDATE_SYNC_WARNINGS", function() { return UPDATE_SYNC_WARNINGS; });
var prefix = '@@redux-form/';

var ARRAY_INSERT = prefix + 'ARRAY_INSERT';
var ARRAY_MOVE = prefix + 'ARRAY_MOVE';
var ARRAY_POP = prefix + 'ARRAY_POP';
var ARRAY_PUSH = prefix + 'ARRAY_PUSH';
var ARRAY_REMOVE = prefix + 'ARRAY_REMOVE';
var ARRAY_REMOVE_ALL = prefix + 'ARRAY_REMOVE_ALL';
var ARRAY_SHIFT = prefix + 'ARRAY_SHIFT';
var ARRAY_SPLICE = prefix + 'ARRAY_SPLICE';
var ARRAY_UNSHIFT = prefix + 'ARRAY_UNSHIFT';
var ARRAY_SWAP = prefix + 'ARRAY_SWAP';
var AUTOFILL = prefix + 'AUTOFILL';
var BLUR = prefix + 'BLUR';
var CHANGE = prefix + 'CHANGE';
var CLEAR_FIELDS = prefix + 'CLEAR_FIELDS';
var CLEAR_SUBMIT = prefix + 'CLEAR_SUBMIT';
var CLEAR_SUBMIT_ERRORS = prefix + 'CLEAR_SUBMIT_ERRORS';
var CLEAR_ASYNC_ERROR = prefix + 'CLEAR_ASYNC_ERROR';
var DESTROY = prefix + 'DESTROY';
var FOCUS = prefix + 'FOCUS';
var INITIALIZE = prefix + 'INITIALIZE';
var REGISTER_FIELD = prefix + 'REGISTER_FIELD';
var RESET = prefix + 'RESET';
var RESET_SECTION = prefix + 'RESET_SECTION';
var SET_SUBMIT_FAILED = prefix + 'SET_SUBMIT_FAILED';
var SET_SUBMIT_SUCCEEDED = prefix + 'SET_SUBMIT_SUCCEEDED';
var START_ASYNC_VALIDATION = prefix + 'START_ASYNC_VALIDATION';
var START_SUBMIT = prefix + 'START_SUBMIT';
var STOP_ASYNC_VALIDATION = prefix + 'STOP_ASYNC_VALIDATION';
var STOP_SUBMIT = prefix + 'STOP_SUBMIT';
var SUBMIT = prefix + 'SUBMIT';
var TOUCH = prefix + 'TOUCH';
var UNREGISTER_FIELD = prefix + 'UNREGISTER_FIELD';
var UNTOUCH = prefix + 'UNTOUCH';
var UPDATE_SYNC_ERRORS = prefix + 'UPDATE_SYNC_ERRORS';
var UPDATE_SYNC_WARNINGS = prefix + 'UPDATE_SYNC_WARNINGS';

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__ = __webpack_require__(715);






/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__mapCacheClear_js__["a" /* default */];
MapCache.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__mapCacheDelete_js__["a" /* default */];
MapCache.prototype.get = __WEBPACK_IMPORTED_MODULE_2__mapCacheGet_js__["a" /* default */];
MapCache.prototype.has = __WEBPACK_IMPORTED_MODULE_3__mapCacheHas_js__["a" /* default */];
MapCache.prototype.set = __WEBPACK_IMPORTED_MODULE_4__mapCacheSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (MapCache);


/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObject_js__ = __webpack_require__(81);



/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__isObject_js__["a" /* default */])(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

/* harmony default export */ __webpack_exports__["a"] = (isFunction);


/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(63);



/* Built-in method references that are verified to be native. */
var Map = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Map');

/* harmony default export */ __webpack_exports__["a"] = (Map);


/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stackClear_js__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__stackGet_js__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stackHas_js__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__stackSet_js__ = __webpack_require__(724);







/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */](entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = __WEBPACK_IMPORTED_MODULE_1__stackClear_js__["a" /* default */];
Stack.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_2__stackDelete_js__["a" /* default */];
Stack.prototype.get = __WEBPACK_IMPORTED_MODULE_3__stackGet_js__["a" /* default */];
Stack.prototype.has = __WEBPACK_IMPORTED_MODULE_4__stackHas_js__["a" /* default */];
Stack.prototype.set = __WEBPACK_IMPORTED_MODULE_5__stackSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Stack);


/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeys_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(133);




/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeys_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keys);


/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/* harmony default export */ __webpack_exports__["a"] = (isIndex);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/* harmony default export */ __webpack_exports__["a"] = (isLength);


/***/ }),
/* 239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__ = __webpack_require__(761);




/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = Object(__WEBPACK_IMPORTED_MODULE_2__baseIteratee_js__["a" /* default */])(iteratee, 3);

  Object(__WEBPACK_IMPORTED_MODULE_1__baseForOwn_js__["a" /* default */])(object, function(value, key, object) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(result, key, iteratee(value, key, object));
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapValues);


/***/ }),
/* 240 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isSymbol_js__ = __webpack_require__(163);



/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || Object(__WEBPACK_IMPORTED_MODULE_1__isSymbol_js__["a" /* default */])(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

/* harmony default export */ __webpack_exports__["a"] = (isKey);


/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

/* harmony default export */ __webpack_exports__["a"] = (identity);


/***/ }),
/* 242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasError__ = __webpack_require__(804);



var createIsValid = function createIsValid(structure) {
  var getIn = structure.getIn,
      keys = structure.keys;

  var hasError = Object(__WEBPACK_IMPORTED_MODULE_0__hasError__["a" /* default */])(structure);
  return function (form, getFormState) {
    var ignoreSubmitErrors = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      var syncError = getIn(formState, form + '.syncError');
      if (syncError) {
        return false;
      }
      if (!ignoreSubmitErrors) {
        var error = getIn(formState, form + '.error');
        if (error) {
          return false;
        }
      }
      var syncErrors = getIn(formState, form + '.syncErrors');
      var asyncErrors = getIn(formState, form + '.asyncErrors');
      var submitErrors = ignoreSubmitErrors ? undefined : getIn(formState, form + '.submitErrors');
      if (!syncErrors && !asyncErrors && !submitErrors) {
        return true;
      }

      var registeredFields = getIn(formState, form + '.registeredFields');
      if (!registeredFields) {
        return true;
      }

      return !keys(registeredFields).filter(function (name) {
        return getIn(registeredFields, '[\'' + name + '\'].count') > 0;
      }).some(function (name) {
        return hasError(getIn(registeredFields, '[\'' + name + '\']'), syncErrors, asyncErrors, submitErrors);
      });
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsValid);

/***/ }),
/* 243 */
/***/ (function(module, exports) {

module.exports = isPromise;

function isPromise(obj) {
  return !!obj && (typeof obj === 'object' || typeof obj === 'function') && typeof obj.then === 'function';
}


/***/ }),
/* 244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__ = __webpack_require__(874);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createGenerateClassName__["a"]; });


/***/ }),
/* 246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__makeStyles__ = __webpack_require__(890);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__makeStyles__["a"]; });


/***/ }),
/* 248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StylesProvider__ = __webpack_require__(392);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StylesProvider__["a"]; });



/***/ }),
/* 249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _classCallCheck;
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(72);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Backdrop__ = __webpack_require__(932);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Backdrop__["a"]; });


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fade__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fade__["a"]; });


/***/ }),
/* 253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export UNMOUNTED */
/* unused harmony export EXITED */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ENTERING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTERED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return EXITING; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_PropTypes__ = __webpack_require__(398);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__ = __webpack_require__(254);








var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();
      var node = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit || __WEBPACK_IMPORTED_MODULE_5__config__["a" /* default */].disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      // allows for nested Transitions
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, children(status, childProps));
    }

    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.only(children);
    return (// allows for nested Transitions
      __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */].Provider, {
        value: null
      }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, childProps))
    );
  };

  return Transition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Transition.contextType = __WEBPACK_IMPORTED_MODULE_7__TransitionGroupContext__["a" /* default */];
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the
   * `<Transition>` component mounts. If you want to transition on the first
   * mount set `appear` to `true`, and the component will transition in as soon
   * as the `<Transition>` mounts.
   *
   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
   * > only adds an additional enter transition. However, in the
   * > `<CSSTransition>` component that first enter transition does result in
   * > additional `.appear-*` classes, that way you can choose to style it
   * > differently.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;
/* harmony default export */ __webpack_exports__["d"] = (Transition);

/***/ }),
/* 254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null));

/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NoSsr__ = __webpack_require__(948);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__NoSsr__["a"]; });


/***/ }),
/* 256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = handleBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__merge__ = __webpack_require__(176);




 // The breakpoint **start** at this value.
// For instance with the first breakpoint xs: [xs, sm[.

var values = {
  xs: 0,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1920
};
var defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: function up(key) {
    return "@media (min-width:".concat(values[key], "px)");
  }
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  if (false) {
    if (!props.theme) {
      console.error('@material-ui/system: you are calling a style function without a theme value.');
    }
  }

  if (Array.isArray(propValue)) {
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    return propValue.reduce(function (acc, item, index) {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_typeof__["a" /* default */])(propValue) === 'object') {
    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;

    return Object.keys(propValue).reduce(function (acc, breakpoint) {
      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
      return acc;
    }, {});
  }

  var output = styleFromPropValue(propValue);
  return output;
}

function breakpoints(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var base = styleFunction(props);
    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
      if (props[key]) {
        acc = acc || {};
        acc[themeBreakpoints.up(key)] = styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
          theme: props.theme
        }, props[key]));
      }

      return acc;
    }, null);
    return Object(__WEBPACK_IMPORTED_MODULE_4__merge__["a" /* default */])(base, extended);
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    xs: PropTypes.object,
    sm: PropTypes.object,
    md: PropTypes.object,
    lg: PropTypes.object,
    xl: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* unused harmony default export */ var _unused_webpack_default_export = (breakpoints);

/***/ }),
/* 257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__IconButton__ = __webpack_require__(137);









var styles = {
  root: {
    padding: 9
  },
  checked: {},
  disabled: {},
  input: {
    cursor: 'inherit',
    position: 'absolute',
    opacity: 0,
    width: '100%',
    height: '100%',
    top: 0,
    left: 0,
    margin: 0,
    padding: 0,
    zIndex: 1
  }
};
/**
 * @ignore - internal component.
 */

var SwitchBase = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SwitchBase(props, ref) {
  var autoFocus = props.autoFocus,
      checkedProp = props.checked,
      checkedIcon = props.checkedIcon,
      classes = props.classes,
      className = props.className,
      defaultChecked = props.defaultChecked,
      disabledProp = props.disabled,
      icon = props.icon,
      id = props.id,
      inputProps = props.inputProps,
      inputRef = props.inputRef,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      readOnly = props.readOnly,
      required = props.required,
      tabIndex = props.tabIndex,
      type = props.type,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(checkedProp != null),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(Boolean(defaultChecked)),
      checkedState = _React$useState[0],
      setCheckedState = _React$useState[1];

  var checked = isControlled ? checkedProp : checkedState;
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();

  var handleFocus = function handleFocus(event) {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  var handleInputChange = function handleInputChange(event) {
    var newChecked = event.target.checked;

    if (!isControlled) {
      setCheckedState(newChecked);
    }

    if (onChange) {
      onChange(event, newChecked);
    }
  };

  var disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  var hasLabelFor = type === 'checkbox' || type === 'radio';
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, checked && classes.checked, disabled && classes.disabled),
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    autoFocus: autoFocus,
    checked: checkedProp,
    defaultChecked: defaultChecked,
    className: classes.input,
    disabled: disabled,
    id: hasLabelFor && id,
    name: name,
    onChange: handleInputChange,
    readOnly: readOnly,
    ref: inputRef,
    required: required,
    tabIndex: tabIndex,
    type: type,
    value: value
  }, inputProps)), checked ? checkedIcon : icon);
}); // NB: If changed, please update Checkbox, Switch and Radio
// so that the API documentation is updated.

 false ? SwitchBase.propTypes = {
  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node.isRequired,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /*
   * @ignore
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string.isRequired,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwitchBase'
})(SwitchBase));

/***/ }),
/* 258 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Portal__ = __webpack_require__(1000);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Portal__["a"]; });


/***/ }),
/* 259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony export (immutable) */ __webpack_exports__["c"] = isHorizontal;
/* harmony export (immutable) */ __webpack_exports__["b"] = getAnchor;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Modal__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Backdrop__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Slide__ = __webpack_require__(416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_useTheme__ = __webpack_require__(32);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {},

    /* Styles applied to the root element if `variant="permanent or persistent"`. */
    docked: {
      flex: '0 0 auto'
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      overflowY: 'auto',
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      flex: '1 0 auto',
      zIndex: theme.zIndex.drawer,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      // temporary style
      position: 'fixed',
      top: 0,
      // We disable the focus ring for mouse, touch and keyboard users.
      // At some point, it would be better to keep it for keyboard users.
      // :focus-ring CSS pseudo-class will help.
      outline: 0
    },

    /* Styles applied to the `Paper` component if `anchor="left"`. */
    paperAnchorLeft: {
      left: 0,
      right: 'auto'
    },

    /* Styles applied to the `Paper` component if `anchor="right"`. */
    paperAnchorRight: {
      left: 'auto',
      right: 0
    },

    /* Styles applied to the `Paper` component if `anchor="top"`. */
    paperAnchorTop: {
      top: 0,
      left: 0,
      bottom: 'auto',
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
    paperAnchorBottom: {
      top: 'auto',
      left: 0,
      bottom: 0,
      right: 0,
      height: 'auto',
      maxHeight: '100%'
    },

    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
    paperAnchorDockedLeft: {
      borderRight: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
    paperAnchorDockedTop: {
      borderBottom: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
    paperAnchorDockedRight: {
      borderLeft: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
    paperAnchorDockedBottom: {
      borderTop: "1px solid ".concat(theme.palette.divider)
    },

    /* Styles applied to the `Modal` component. */
    modal: {}
  };
};
var oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

var Drawer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Drawer(props, ref) {
  var _props$anchor = props.anchor,
      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
      BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropPropsProp = _props$ModalProps.BackdropProps,
      ModalProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      _props$open = props.open,
      open = _props$open === void 0 ? false : _props$open,
      PaperProps = props.PaperProps,
      SlideProps = props.SlideProps,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_12__styles_useTheme__["a" /* default */])(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  var mounted = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(false);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    mounted.current = true;
  }, []);
  var anchor = getAnchor(theme, anchorProp);
  var drawer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.paper, classes["paperAnchor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))], variant !== 'temporary' && classes["paperAnchorDocked".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(anchor))])
  }, PaperProps), children);

  if (variant === 'permanent') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), drawer);
  }

  var slidingDrawer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Slide__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    direction: oppositeDirection[anchor],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps), drawer);

  if (variant === 'persistent') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.docked, className),
      ref: ref
    }, other), slidingDrawer);
  } // variant === temporary


  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, {}, BackdropPropsProp, {
      transitionDuration: transitionDuration
    }),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_6__Backdrop__["a" /* default */],
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.modal, className),
    open: open,
    onClose: onClose,
    ref: ref
  }, other, ModalProps), slidingDrawer);
});
 false ? Drawer.propTypes = {
  /**
   * Side from which the drawer will appear.
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * The contents of the drawer.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The elevation of the drawer.
   */
  elevation: PropTypes.number,

  /**
   * Props applied to the [`Modal`](/api/modal/) element.
   */
  ModalProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Props applied to the [`Slide`](/api/slide/) element.
   */
  SlideProps: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDrawer',
  flip: false
})(Drawer));

/***/ }),
/* 260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Fab__ = __webpack_require__(1024);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Fab__["a"]; });


/***/ }),
/* 261 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FilledInput__ = __webpack_require__(1025);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FilledInput__["a"]; });


/***/ }),
/* 262 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export hasValue */
/* harmony export (immutable) */ __webpack_exports__["b"] = isFilled;
/* harmony export (immutable) */ __webpack_exports__["a"] = isAdornedStart;
// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj) {
  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

/***/ }),
/* 263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControl__ = __webpack_require__(1028);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormControl__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__useFormControl__ = __webpack_require__(91);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__useFormControl__["a"]; });



/***/ }),
/* 264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withWidth__ = __webpack_require__(423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__withWidth__["c"]; });



/***/ }),
/* 265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__ = __webpack_require__(1076);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__OutlinedInput__["a"]; });


/***/ }),
/* 266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popper__ = __webpack_require__(1078);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popper__["a"]; });


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
exports.CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

//# sourceMappingURL=constants.js.map


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var onDisconnect_1 = __webpack_require__(464);
var TransactionResult_1 = __webpack_require__(1199);
var util_1 = __webpack_require__(21);
var NextPushId_1 = __webpack_require__(1200);
var Query_1 = __webpack_require__(465);
var Repo_1 = __webpack_require__(187);
var Path_1 = __webpack_require__(29);
var QueryParams_1 = __webpack_require__(1224);
var validation_1 = __webpack_require__(94);
var util_2 = __webpack_require__(6);
var util_3 = __webpack_require__(6);
var SyncPoint_1 = __webpack_require__(476);
var Reference = /** @class */ (function (_super) {
    tslib_1.__extends(Reference, _super);
    /**
     * Call options:
     *   new Reference(Repo, Path) or
     *   new Reference(url: string, string|RepoManager)
     *
     * Externally - this is the firebase.database.Reference type.
     *
     * @param {!Repo} repo
     * @param {(!Path)} path
     * @extends {Query}
     */
    function Reference(repo, path) {
        var _this = this;
        if (!(repo instanceof Repo_1.Repo)) {
            throw new Error('new Reference() no longer supported - use app.database().');
        }
        // call Query's constructor, passing in the repo and path.
        _this = _super.call(this, repo, path, QueryParams_1.QueryParams.DEFAULT, false) || this;
        return _this;
    }
    /** @return {?string} */
    Reference.prototype.getKey = function () {
        util_2.validateArgCount('Reference.key', 0, 0, arguments.length);
        if (this.path.isEmpty())
            return null;
        else
            return this.path.getBack();
    };
    /**
     * @param {!(string|Path)} pathString
     * @return {!Reference}
     */
    Reference.prototype.child = function (pathString) {
        util_2.validateArgCount('Reference.child', 1, 1, arguments.length);
        if (typeof pathString === 'number') {
            pathString = String(pathString);
        }
        else if (!(pathString instanceof Path_1.Path)) {
            if (this.path.getFront() === null)
                validation_1.validateRootPathString('Reference.child', 1, pathString, false);
            else
                validation_1.validatePathString('Reference.child', 1, pathString, false);
        }
        return new Reference(this.repo, this.path.child(pathString));
    };
    /** @return {?Reference} */
    Reference.prototype.getParent = function () {
        util_2.validateArgCount('Reference.parent', 0, 0, arguments.length);
        var parentPath = this.path.parent();
        return parentPath === null ? null : new Reference(this.repo, parentPath);
    };
    /** @return {!Reference} */
    Reference.prototype.getRoot = function () {
        util_2.validateArgCount('Reference.root', 0, 0, arguments.length);
        var ref = this;
        while (ref.getParent() !== null) {
            ref = ref.getParent();
        }
        return ref;
    };
    /** @return {!Database} */
    Reference.prototype.databaseProp = function () {
        return this.repo.database;
    };
    /**
     * @param {*} newVal
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.set = function (newVal, onComplete) {
        util_2.validateArgCount('Reference.set', 1, 2, arguments.length);
        validation_1.validateWritablePath('Reference.set', this.path);
        validation_1.validateFirebaseDataArg('Reference.set', 1, newVal, this.path, false);
        util_2.validateCallback('Reference.set', 2, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo.setWithPriority(this.path, newVal, 
        /*priority=*/ null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.update = function (objectToMerge, onComplete) {
        util_2.validateArgCount('Reference.update', 1, 2, arguments.length);
        validation_1.validateWritablePath('Reference.update', this.path);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            util_1.warn('Passing an Array to Firebase.update() is deprecated. ' +
                'Use set() if you want to overwrite the existing data, or ' +
                'an Object with integer keys if you really do want to ' +
                'only update some of the children.');
        }
        validation_1.validateFirebaseMergeDataArg('Reference.update', 1, objectToMerge, this.path, false);
        util_2.validateCallback('Reference.update', 2, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo.update(this.path, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} newVal
     * @param {string|number|null} newPriority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setWithPriority = function (newVal, newPriority, onComplete) {
        util_2.validateArgCount('Reference.setWithPriority', 2, 3, arguments.length);
        validation_1.validateWritablePath('Reference.setWithPriority', this.path);
        validation_1.validateFirebaseDataArg('Reference.setWithPriority', 1, newVal, this.path, false);
        validation_1.validatePriority('Reference.setWithPriority', 2, newPriority, false);
        util_2.validateCallback('Reference.setWithPriority', 3, onComplete, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.setWithPriority failed: ' +
                this.getKey() +
                ' is a read-only object.';
        var deferred = new util_3.Deferred();
        this.repo.setWithPriority(this.path, newVal, newPriority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.remove = function (onComplete) {
        util_2.validateArgCount('Reference.remove', 0, 1, arguments.length);
        validation_1.validateWritablePath('Reference.remove', this.path);
        util_2.validateCallback('Reference.remove', 1, onComplete, true);
        return this.set(null, onComplete);
    };
    /**
     * @param {function(*):*} transactionUpdate
     * @param {(function(?Error, boolean, ?DataSnapshot))=} onComplete
     * @param {boolean=} applyLocally
     * @return {!Promise}
     */
    Reference.prototype.transaction = function (transactionUpdate, onComplete, applyLocally) {
        util_2.validateArgCount('Reference.transaction', 1, 3, arguments.length);
        validation_1.validateWritablePath('Reference.transaction', this.path);
        util_2.validateCallback('Reference.transaction', 1, transactionUpdate, false);
        util_2.validateCallback('Reference.transaction', 2, onComplete, true);
        // NOTE: applyLocally is an internal-only option for now.  We need to decide if we want to keep it and how
        // to expose it.
        validation_1.validateBoolean('Reference.transaction', 3, applyLocally, true);
        if (this.getKey() === '.length' || this.getKey() === '.keys')
            throw 'Reference.transaction failed: ' +
                this.getKey() +
                ' is a read-only object.';
        if (applyLocally === undefined)
            applyLocally = true;
        var deferred = new util_3.Deferred();
        if (typeof onComplete === 'function') {
            deferred.promise.catch(function () { });
        }
        var promiseComplete = function (error, committed, snapshot) {
            if (error) {
                deferred.reject(error);
            }
            else {
                deferred.resolve(new TransactionResult_1.TransactionResult(committed, snapshot));
            }
            if (typeof onComplete === 'function') {
                onComplete(error, committed, snapshot);
            }
        };
        this.repo.startTransaction(this.path, transactionUpdate, promiseComplete, applyLocally);
        return deferred.promise;
    };
    /**
     * @param {string|number|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!Promise}
     */
    Reference.prototype.setPriority = function (priority, onComplete) {
        util_2.validateArgCount('Reference.setPriority', 1, 2, arguments.length);
        validation_1.validateWritablePath('Reference.setPriority', this.path);
        validation_1.validatePriority('Reference.setPriority', 1, priority, false);
        util_2.validateCallback('Reference.setPriority', 2, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo.setWithPriority(this.path.child('.priority'), priority, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*=} value
     * @param {function(?Error)=} onComplete
     * @return {!Reference}
     */
    Reference.prototype.push = function (value, onComplete) {
        util_2.validateArgCount('Reference.push', 0, 2, arguments.length);
        validation_1.validateWritablePath('Reference.push', this.path);
        validation_1.validateFirebaseDataArg('Reference.push', 1, value, this.path, true);
        util_2.validateCallback('Reference.push', 2, onComplete, true);
        var now = this.repo.serverTime();
        var name = NextPushId_1.nextPushId(now);
        // push() returns a ThennableReference whose promise is fulfilled with a regular Reference.
        // We use child() to create handles to two different references. The first is turned into a
        // ThennableReference below by adding then() and catch() methods and is used as the
        // return value of push(). The second remains a regular Reference and is used as the fulfilled
        // value of the first ThennableReference.
        var thennablePushRef = this.child(name);
        var pushRef = this.child(name);
        var promise;
        if (value != null) {
            promise = thennablePushRef.set(value, onComplete).then(function () { return pushRef; });
        }
        else {
            promise = Promise.resolve(pushRef);
        }
        thennablePushRef.then = promise.then.bind(promise);
        thennablePushRef.catch = promise.then.bind(promise, undefined);
        if (typeof onComplete === 'function') {
            promise.catch(function () { });
        }
        return thennablePushRef;
    };
    /**
     * @return {!OnDisconnect}
     */
    Reference.prototype.onDisconnect = function () {
        validation_1.validateWritablePath('Reference.onDisconnect', this.path);
        return new onDisconnect_1.OnDisconnect(this.repo, this.path);
    };
    Object.defineProperty(Reference.prototype, "database", {
        get: function () {
            return this.databaseProp();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "key", {
        get: function () {
            return this.getKey();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "parent", {
        get: function () {
            return this.getParent();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        get: function () {
            return this.getRoot();
        },
        enumerable: true,
        configurable: true
    });
    return Reference;
}(Query_1.Query));
exports.Reference = Reference;
/**
 * Define reference constructor in various modules
 *
 * We are doing this here to avoid several circular
 * dependency issues
 */
Query_1.Query.__referenceConstructor = Reference;
SyncPoint_1.SyncPoint.__referenceConstructor = Reference;

//# sourceMappingURL=Reference.js.map


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var validation_1 = __webpack_require__(94);
var Path_1 = __webpack_require__(29);
var PriorityIndex_1 = __webpack_require__(42);
/**
 * Class representing a firebase data snapshot.  It wraps a SnapshotNode and
 * surfaces the public methods (val, forEach, etc.) we want to expose.
 */
var DataSnapshot = /** @class */ (function () {
    /**
     * @param {!Node} node_ A SnapshotNode to wrap.
     * @param {!Reference} ref_ The ref of the location this snapshot came from.
     * @param {!Index} index_ The iteration order for this snapshot
     */
    function DataSnapshot(node_, ref_, index_) {
        this.node_ = node_;
        this.ref_ = ref_;
        this.index_ = index_;
    }
    /**
     * Retrieves the snapshot contents as JSON.  Returns null if the snapshot is
     * empty.
     *
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.val = function () {
        util_1.validateArgCount('DataSnapshot.val', 0, 0, arguments.length);
        return this.node_.val();
    };
    /**
     * Returns the snapshot contents as JSON, including priorities of node.  Suitable for exporting
     * the entire node contents.
     * @return {*} JSON representation of the DataSnapshot contents, or null if empty.
     */
    DataSnapshot.prototype.exportVal = function () {
        util_1.validateArgCount('DataSnapshot.exportVal', 0, 0, arguments.length);
        return this.node_.val(true);
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    DataSnapshot.prototype.toJSON = function () {
        // Optional spacer argument is unnecessary because we're depending on recursion rather than stringifying the content
        util_1.validateArgCount('DataSnapshot.toJSON', 0, 1, arguments.length);
        return this.exportVal();
    };
    /**
     * Returns whether the snapshot contains a non-null value.
     *
     * @return {boolean} Whether the snapshot contains a non-null value, or is empty.
     */
    DataSnapshot.prototype.exists = function () {
        util_1.validateArgCount('DataSnapshot.exists', 0, 0, arguments.length);
        return !this.node_.isEmpty();
    };
    /**
     * Returns a DataSnapshot of the specified child node's contents.
     *
     * @param {!string} childPathString Path to a child.
     * @return {!DataSnapshot} DataSnapshot for child node.
     */
    DataSnapshot.prototype.child = function (childPathString) {
        util_1.validateArgCount('DataSnapshot.child', 0, 1, arguments.length);
        // Ensure the childPath is a string (can be a number)
        childPathString = String(childPathString);
        validation_1.validatePathString('DataSnapshot.child', 1, childPathString, false);
        var childPath = new Path_1.Path(childPathString);
        var childRef = this.ref_.child(childPath);
        return new DataSnapshot(this.node_.getChild(childPath), childRef, PriorityIndex_1.PRIORITY_INDEX);
    };
    /**
     * Returns whether the snapshot contains a child at the specified path.
     *
     * @param {!string} childPathString Path to a child.
     * @return {boolean} Whether the child exists.
     */
    DataSnapshot.prototype.hasChild = function (childPathString) {
        util_1.validateArgCount('DataSnapshot.hasChild', 1, 1, arguments.length);
        validation_1.validatePathString('DataSnapshot.hasChild', 1, childPathString, false);
        var childPath = new Path_1.Path(childPathString);
        return !this.node_.getChild(childPath).isEmpty();
    };
    /**
     * Returns the priority of the object, or null if no priority was set.
     *
     * @return {string|number|null} The priority.
     */
    DataSnapshot.prototype.getPriority = function () {
        util_1.validateArgCount('DataSnapshot.getPriority', 0, 0, arguments.length);
        // typecast here because we never return deferred values or internal priorities (MAX_PRIORITY)
        return this.node_.getPriority().val();
    };
    /**
     * Iterates through child nodes and calls the specified action for each one.
     *
     * @param {function(!DataSnapshot)} action Callback function to be called
     * for each child.
     * @return {boolean} True if forEach was canceled by action returning true for
     * one of the child nodes.
     */
    DataSnapshot.prototype.forEach = function (action) {
        var _this = this;
        util_1.validateArgCount('DataSnapshot.forEach', 1, 1, arguments.length);
        util_1.validateCallback('DataSnapshot.forEach', 1, action, false);
        if (this.node_.isLeafNode())
            return false;
        var childrenNode = this.node_;
        // Sanitize the return value to a boolean. ChildrenNode.forEachChild has a weird return type...
        return !!childrenNode.forEachChild(this.index_, function (key, node) {
            return action(new DataSnapshot(node, _this.ref_.child(key), PriorityIndex_1.PRIORITY_INDEX));
        });
    };
    /**
     * Returns whether this DataSnapshot has children.
     * @return {boolean} True if the DataSnapshot contains 1 or more child nodes.
     */
    DataSnapshot.prototype.hasChildren = function () {
        util_1.validateArgCount('DataSnapshot.hasChildren', 0, 0, arguments.length);
        if (this.node_.isLeafNode())
            return false;
        else
            return !this.node_.isEmpty();
    };
    Object.defineProperty(DataSnapshot.prototype, "key", {
        get: function () {
            return this.ref_.getKey();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns the number of children for this DataSnapshot.
     * @return {number} The number of children that this DataSnapshot contains.
     */
    DataSnapshot.prototype.numChildren = function () {
        util_1.validateArgCount('DataSnapshot.numChildren', 0, 0, arguments.length);
        return this.node_.numChildren();
    };
    /**
     * @return {Reference} The Firebase reference for the location this snapshot's data came from.
     */
    DataSnapshot.prototype.getRef = function () {
        util_1.validateArgCount('DataSnapshot.ref', 0, 0, arguments.length);
        return this.ref_;
    };
    Object.defineProperty(DataSnapshot.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return DataSnapshot;
}());
exports.DataSnapshot = DataSnapshot;

//# sourceMappingURL=DataSnapshot.js.map


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SortedMap_1 = __webpack_require__(186);
var Path_1 = __webpack_require__(29);
var util_1 = __webpack_require__(21);
var util_2 = __webpack_require__(6);
var emptyChildrenSingleton;
/**
 * Singleton empty children collection.
 *
 * @const
 * @type {!SortedMap.<string, !ImmutableTree.<?>>}
 */
var EmptyChildren = function () {
    if (!emptyChildrenSingleton) {
        emptyChildrenSingleton = new SortedMap_1.SortedMap(util_1.stringCompare);
    }
    return emptyChildrenSingleton;
};
/**
 * A tree with immutable elements.
 */
var ImmutableTree = /** @class */ (function () {
    /**
     * @template T
     * @param {?T} value
     * @param {SortedMap.<string, !ImmutableTree.<T>>=} children
     */
    function ImmutableTree(value, children) {
        if (children === void 0) { children = EmptyChildren(); }
        this.value = value;
        this.children = children;
    }
    /**
     * @template T
     * @param {!Object.<string, !T>} obj
     * @return {!ImmutableTree.<!T>}
     */
    ImmutableTree.fromObject = function (obj) {
        var tree = ImmutableTree.Empty;
        util_2.forEach(obj, function (childPath, childSnap) {
            tree = tree.set(new Path_1.Path(childPath), childSnap);
        });
        return tree;
    };
    /**
     * True if the value is empty and there are no children
     * @return {boolean}
     */
    ImmutableTree.prototype.isEmpty = function () {
        return this.value === null && this.children.isEmpty();
    };
    /**
     * Given a path and predicate, return the first node and the path to that node
     * where the predicate returns true.
     *
     * TODO Do a perf test -- If we're creating a bunch of {path: value:} objects
     * on the way back out, it may be better to pass down a pathSoFar obj.
     *
     * @param {!Path} relativePath The remainder of the path
     * @param {function(T):boolean} predicate The predicate to satisfy to return a
     *   node
     * @return {?{path:!Path, value:!T}}
     */
    ImmutableTree.prototype.findRootMostMatchingPathAndValue = function (relativePath, predicate) {
        if (this.value != null && predicate(this.value)) {
            return { path: Path_1.Path.Empty, value: this.value };
        }
        else {
            if (relativePath.isEmpty()) {
                return null;
            }
            else {
                var front = relativePath.getFront();
                var child = this.children.get(front);
                if (child !== null) {
                    var childExistingPathAndValue = child.findRootMostMatchingPathAndValue(relativePath.popFront(), predicate);
                    if (childExistingPathAndValue != null) {
                        var fullPath = new Path_1.Path(front).child(childExistingPathAndValue.path);
                        return { path: fullPath, value: childExistingPathAndValue.value };
                    }
                    else {
                        return null;
                    }
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     * Find, if it exists, the shortest subpath of the given path that points a defined
     * value in the tree
     * @param {!Path} relativePath
     * @return {?{path: !Path, value: !T}}
     */
    ImmutableTree.prototype.findRootMostValueAndPath = function (relativePath) {
        return this.findRootMostMatchingPathAndValue(relativePath, function () { return true; });
    };
    /**
     * @param {!Path} relativePath
     * @return {!ImmutableTree.<T>} The subtree at the given path
     */
    ImmutableTree.prototype.subtree = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this;
        }
        else {
            var front = relativePath.getFront();
            var childTree = this.children.get(front);
            if (childTree !== null) {
                return childTree.subtree(relativePath.popFront());
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Sets a value at the specified path.
     *
     * @param {!Path} relativePath Path to set value at.
     * @param {?T} toSet Value to set.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.set = function (relativePath, toSet) {
        if (relativePath.isEmpty()) {
            return new ImmutableTree(toSet, this.children);
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.set(relativePath.popFront(), toSet);
            var newChildren = this.children.insert(front, newChild);
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Removes the value at the specified path.
     *
     * @param {!Path} relativePath Path to value to remove.
     * @return {!ImmutableTree.<T>} Resulting tree.
     */
    ImmutableTree.prototype.remove = function (relativePath) {
        if (relativePath.isEmpty()) {
            if (this.children.isEmpty()) {
                return ImmutableTree.Empty;
            }
            else {
                return new ImmutableTree(null, this.children);
            }
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                var newChild = child.remove(relativePath.popFront());
                var newChildren = void 0;
                if (newChild.isEmpty()) {
                    newChildren = this.children.remove(front);
                }
                else {
                    newChildren = this.children.insert(front, newChild);
                }
                if (this.value === null && newChildren.isEmpty()) {
                    return ImmutableTree.Empty;
                }
                else {
                    return new ImmutableTree(this.value, newChildren);
                }
            }
            else {
                return this;
            }
        }
    };
    /**
     * Gets a value from the tree.
     *
     * @param {!Path} relativePath Path to get value for.
     * @return {?T} Value at path, or null.
     */
    ImmutableTree.prototype.get = function (relativePath) {
        if (relativePath.isEmpty()) {
            return this.value;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front);
            if (child) {
                return child.get(relativePath.popFront());
            }
            else {
                return null;
            }
        }
    };
    /**
     * Replace the subtree at the specified path with the given new tree.
     *
     * @param {!Path} relativePath Path to replace subtree for.
     * @param {!ImmutableTree} newTree New tree.
     * @return {!ImmutableTree} Resulting tree.
     */
    ImmutableTree.prototype.setTree = function (relativePath, newTree) {
        if (relativePath.isEmpty()) {
            return newTree;
        }
        else {
            var front = relativePath.getFront();
            var child = this.children.get(front) || ImmutableTree.Empty;
            var newChild = child.setTree(relativePath.popFront(), newTree);
            var newChildren = void 0;
            if (newChild.isEmpty()) {
                newChildren = this.children.remove(front);
            }
            else {
                newChildren = this.children.insert(front, newChild);
            }
            return new ImmutableTree(this.value, newChildren);
        }
    };
    /**
     * Performs a depth first fold on this tree. Transforms a tree into a single
     * value, given a function that operates on the path to a node, an optional
     * current value, and a map of child names to folded subtrees
     * @template V
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     */
    ImmutableTree.prototype.fold = function (fn) {
        return this.fold_(Path_1.Path.Empty, fn);
    };
    /**
     * Recursive helper for public-facing fold() method
     * @template V
     * @param {!Path} pathSoFar
     * @param {function(Path, ?T, Object.<string, V>):V} fn
     * @return {V}
     * @private
     */
    ImmutableTree.prototype.fold_ = function (pathSoFar, fn) {
        var accum = {};
        this.children.inorderTraversal(function (childKey, childTree) {
            accum[childKey] = childTree.fold_(pathSoFar.child(childKey), fn);
        });
        return fn(pathSoFar, this.value, accum);
    };
    /**
     * Find the first matching value on the given path. Return the result of applying f to it.
     * @template V
     * @param {!Path} path
     * @param {!function(!Path, !T):?V} f
     * @return {?V}
     */
    ImmutableTree.prototype.findOnPath = function (path, f) {
        return this.findOnPath_(path, Path_1.Path.Empty, f);
    };
    ImmutableTree.prototype.findOnPath_ = function (pathToFollow, pathSoFar, f) {
        var result = this.value ? f(pathSoFar, this.value) : false;
        if (result) {
            return result;
        }
        else {
            if (pathToFollow.isEmpty()) {
                return null;
            }
            else {
                var front = pathToFollow.getFront();
                var nextChild = this.children.get(front);
                if (nextChild) {
                    return nextChild.findOnPath_(pathToFollow.popFront(), pathSoFar.child(front), f);
                }
                else {
                    return null;
                }
            }
        }
    };
    /**
     *
     * @param {!Path} path
     * @param {!function(!Path, !T)} f
     * @returns {!ImmutableTree.<T>}
     */
    ImmutableTree.prototype.foreachOnPath = function (path, f) {
        return this.foreachOnPath_(path, Path_1.Path.Empty, f);
    };
    ImmutableTree.prototype.foreachOnPath_ = function (pathToFollow, currentRelativePath, f) {
        if (pathToFollow.isEmpty()) {
            return this;
        }
        else {
            if (this.value) {
                f(currentRelativePath, this.value);
            }
            var front = pathToFollow.getFront();
            var nextChild = this.children.get(front);
            if (nextChild) {
                return nextChild.foreachOnPath_(pathToFollow.popFront(), currentRelativePath.child(front), f);
            }
            else {
                return ImmutableTree.Empty;
            }
        }
    };
    /**
     * Calls the given function for each node in the tree that has a value.
     *
     * @param {function(!Path, !T)} f A function to be called with
     *   the path from the root of the tree to a node, and the value at that node.
     *   Called in depth-first order.
     */
    ImmutableTree.prototype.foreach = function (f) {
        this.foreach_(Path_1.Path.Empty, f);
    };
    ImmutableTree.prototype.foreach_ = function (currentRelativePath, f) {
        this.children.inorderTraversal(function (childName, childTree) {
            childTree.foreach_(currentRelativePath.child(childName), f);
        });
        if (this.value) {
            f(currentRelativePath, this.value);
        }
    };
    /**
     *
     * @param {function(string, !T)} f
     */
    ImmutableTree.prototype.foreachChild = function (f) {
        this.children.inorderTraversal(function (childName, childTree) {
            if (childTree.value) {
                f(childName, childTree.value);
            }
        });
    };
    ImmutableTree.Empty = new ImmutableTree(null);
    return ImmutableTree;
}());
exports.ImmutableTree = ImmutableTree;

//# sourceMappingURL=ImmutableTree.js.map


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Change_1 = __webpack_require__(119);
var ChildrenNode_1 = __webpack_require__(49);
var PriorityIndex_1 = __webpack_require__(42);
/**
 * Doesn't really filter nodes but applies an index to the node and keeps track of any changes
 *
 * @constructor
 * @implements {NodeFilter}
 * @param {!Index} index
 */
var IndexedFilter = /** @class */ (function () {
    function IndexedFilter(index_) {
        this.index_ = index_;
    }
    IndexedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        util_1.assert(snap.isIndexed(this.index_), 'A node must be indexed if only a child is updated');
        var oldChild = snap.getImmediateChild(key);
        // Check if anything actually changed.
        if (oldChild.getChild(affectedPath).equals(newChild.getChild(affectedPath))) {
            // There's an edge case where a child can enter or leave the view because affectedPath was set to null.
            // In this case, affectedPath will appear null in both the old and new snapshots.  So we need
            // to avoid treating these cases as "nothing changed."
            if (oldChild.isEmpty() == newChild.isEmpty()) {
                // Nothing changed.
                // This assert should be valid, but it's expensive (can dominate perf testing) so don't actually do it.
                //assert(oldChild.equals(newChild), 'Old and new snapshots should be equal.');
                return snap;
            }
        }
        if (optChangeAccumulator != null) {
            if (newChild.isEmpty()) {
                if (snap.hasChild(key)) {
                    optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, oldChild));
                }
                else {
                    util_1.assert(snap.isLeafNode(), 'A child remove without an old child only makes sense on a leaf node');
                }
            }
            else if (oldChild.isEmpty()) {
                optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, newChild));
            }
            else {
                optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, newChild, oldChild));
            }
        }
        if (snap.isLeafNode() && newChild.isEmpty()) {
            return snap;
        }
        else {
            // Make sure the node is indexed
            return snap.updateImmediateChild(key, newChild).withIndex(this.index_);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (optChangeAccumulator != null) {
            if (!oldSnap.isLeafNode()) {
                oldSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
                    if (!newSnap.hasChild(key)) {
                        optChangeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(key, childNode));
                    }
                });
            }
            if (!newSnap.isLeafNode()) {
                newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
                    if (oldSnap.hasChild(key)) {
                        var oldChild = oldSnap.getImmediateChild(key);
                        if (!oldChild.equals(childNode)) {
                            optChangeAccumulator.trackChildChange(Change_1.Change.childChangedChange(key, childNode, oldChild));
                        }
                    }
                    else {
                        optChangeAccumulator.trackChildChange(Change_1.Change.childAddedChange(key, childNode));
                    }
                });
            }
        }
        return newSnap.withIndex(this.index_);
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        if (oldSnap.isEmpty()) {
            return ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        }
        else {
            return oldSnap.updatePriority(newPriority);
        }
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.filtersNodes = function () {
        return false;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndexedFilter = function () {
        return this;
    };
    /**
     * @inheritDoc
     */
    IndexedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    return IndexedFilter;
}());
exports.IndexedFilter = IndexedFilter;

//# sourceMappingURL=IndexedFilter.js.map


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var StatsCollection_1 = __webpack_require__(1216);
var StatsManager = /** @class */ (function () {
    function StatsManager() {
    }
    StatsManager.getCollection = function (repoInfo) {
        var hashString = repoInfo.toString();
        if (!this.collections_[hashString]) {
            this.collections_[hashString] = new StatsCollection_1.StatsCollection();
        }
        return this.collections_[hashString];
    };
    StatsManager.getOrCreateReporter = function (repoInfo, creatorFunction) {
        var hashString = repoInfo.toString();
        if (!this.reporters_[hashString]) {
            this.reporters_[hashString] = creatorFunction();
        }
        return this.reporters_[hashString];
    };
    StatsManager.collections_ = {};
    StatsManager.reporters_ = {};
    return StatsManager;
}());
exports.StatsManager = StatsManager;

//# sourceMappingURL=StatsManager.js.map


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Repo_1 = __webpack_require__(187);
var util_2 = __webpack_require__(21);
var parser_1 = __webpack_require__(462);
var validation_1 = __webpack_require__(94);
__webpack_require__(1226);
/** @const {string} */
var DATABASE_URL_OPTION = 'databaseURL';
var _staticInstance;
/**
 * Creates and caches Repo instances.
 */
var RepoManager = /** @class */ (function () {
    function RepoManager() {
        /**
         * @private {!Object.<string, Object<string, !fb.core.Repo>>}
         */
        this.repos_ = {};
        /**
         * If true, new Repos will be created to use ReadonlyRestClient (for testing purposes).
         * @private {boolean}
         */
        this.useRestClient_ = false;
    }
    RepoManager.getInstance = function () {
        if (!_staticInstance) {
            _staticInstance = new RepoManager();
        }
        return _staticInstance;
    };
    // TODO(koss): Remove these functions unless used in tests?
    RepoManager.prototype.interrupt = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].interrupt();
            }
        }
    };
    RepoManager.prototype.resume = function () {
        for (var appName in this.repos_) {
            for (var dbUrl in this.repos_[appName]) {
                this.repos_[appName][dbUrl].resume();
            }
        }
    };
    /**
     * This function should only ever be called to CREATE a new database instance.
     *
     * @param {!FirebaseApp} app
     * @return {!Database}
     */
    RepoManager.prototype.databaseFromApp = function (app, url) {
        var dbUrl = url || app.options[DATABASE_URL_OPTION];
        if (dbUrl === undefined) {
            util_2.fatal("Can't determine Firebase Database URL.  Be sure to include " +
                DATABASE_URL_OPTION +
                ' option when calling firebase.initializeApp().');
        }
        var parsedUrl = parser_1.parseRepoInfo(dbUrl);
        var repoInfo = parsedUrl.repoInfo;
        validation_1.validateUrl('Invalid Firebase Database URL', 1, parsedUrl);
        if (!parsedUrl.path.isEmpty()) {
            util_2.fatal('Database URL must point to the root of a Firebase Database ' +
                '(not including a child path).');
        }
        var repo = this.createRepo(repoInfo, app);
        return repo.database;
    };
    /**
     * Remove the repo and make sure it is disconnected.
     *
     * @param {!Repo} repo
     */
    RepoManager.prototype.deleteRepo = function (repo) {
        var appRepos = util_1.safeGet(this.repos_, repo.app.name);
        // This should never happen...
        if (!appRepos || util_1.safeGet(appRepos, repo.repoInfo_.toURLString()) !== repo) {
            util_2.fatal("Database " + repo.app.name + "(" + repo.repoInfo_ + ") has already been deleted.");
        }
        repo.interrupt();
        delete appRepos[repo.repoInfo_.toURLString()];
    };
    /**
     * Ensures a repo doesn't already exist and then creates one using the
     * provided app.
     *
     * @param {!RepoInfo} repoInfo The metadata about the Repo
     * @param {!FirebaseApp} app
     * @return {!Repo} The Repo object for the specified server / repoName.
     */
    RepoManager.prototype.createRepo = function (repoInfo, app) {
        var appRepos = util_1.safeGet(this.repos_, app.name);
        if (!appRepos) {
            appRepos = {};
            this.repos_[app.name] = appRepos;
        }
        var repo = util_1.safeGet(appRepos, repoInfo.toURLString());
        if (repo) {
            util_2.fatal('Database initialized multiple times. Please make sure the format of the database URL matches with each database() call.');
        }
        repo = new Repo_1.Repo(repoInfo, this.useRestClient_, app);
        appRepos[repoInfo.toURLString()] = repo;
        return repo;
    };
    /**
     * Forces us to use ReadonlyRestClient instead of PersistentConnection for new Repos.
     * @param {boolean} forceRestClient
     */
    RepoManager.prototype.forceRestClient = function (forceRestClient) {
        this.useRestClient_ = forceRestClient;
    };
    return RepoManager;
}());
exports.RepoManager = RepoManager;

//# sourceMappingURL=RepoManager.js.map


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __webpack_require__(487);
exports.assert = assert_1.assert;
exports.assertionError = assert_1.assertionError;
var crypt_1 = __webpack_require__(488);
exports.base64 = crypt_1.base64;
exports.base64Decode = crypt_1.base64Decode;
exports.base64Encode = crypt_1.base64Encode;
var constants_1 = __webpack_require__(275);
exports.CONSTANTS = constants_1.CONSTANTS;
var deepCopy_1 = __webpack_require__(1233);
exports.deepCopy = deepCopy_1.deepCopy;
exports.deepExtend = deepCopy_1.deepExtend;
exports.patchProperty = deepCopy_1.patchProperty;
var deferred_1 = __webpack_require__(1234);
exports.Deferred = deferred_1.Deferred;
var environment_1 = __webpack_require__(1235);
exports.getUA = environment_1.getUA;
exports.isMobileCordova = environment_1.isMobileCordova;
exports.isNodeSdk = environment_1.isNodeSdk;
exports.isReactNative = environment_1.isReactNative;
var errors_1 = __webpack_require__(1236);
exports.ErrorFactory = errors_1.ErrorFactory;
exports.FirebaseError = errors_1.FirebaseError;
exports.patchCapture = errors_1.patchCapture;
var json_1 = __webpack_require__(489);
exports.jsonEval = json_1.jsonEval;
exports.stringify = json_1.stringify;
var jwt_1 = __webpack_require__(1237);
exports.decode = jwt_1.decode;
exports.isAdmin = jwt_1.isAdmin;
exports.issuedAtTime = jwt_1.issuedAtTime;
exports.isValidFormat = jwt_1.isValidFormat;
exports.isValidTimestamp = jwt_1.isValidTimestamp;
var obj_1 = __webpack_require__(490);
exports.clone = obj_1.clone;
exports.contains = obj_1.contains;
exports.every = obj_1.every;
exports.extend = obj_1.extend;
exports.findKey = obj_1.findKey;
exports.findValue = obj_1.findValue;
exports.forEach = obj_1.forEach;
exports.getAnyKey = obj_1.getAnyKey;
exports.getCount = obj_1.getCount;
exports.getValues = obj_1.getValues;
exports.isEmpty = obj_1.isEmpty;
exports.isNonNullObject = obj_1.isNonNullObject;
exports.map = obj_1.map;
exports.safeGet = obj_1.safeGet;
var query_1 = __webpack_require__(1238);
exports.querystring = query_1.querystring;
exports.querystringDecode = query_1.querystringDecode;
var sha1_1 = __webpack_require__(1239);
exports.Sha1 = sha1_1.Sha1;
var subscribe_1 = __webpack_require__(1241);
exports.async = subscribe_1.async;
exports.createSubscribe = subscribe_1.createSubscribe;
var validation_1 = __webpack_require__(1242);
exports.errorPrefix = validation_1.errorPrefix;
exports.validateArgCount = validation_1.validateArgCount;
exports.validateCallback = validation_1.validateCallback;
exports.validateContextObject = validation_1.validateContextObject;
exports.validateNamespace = validation_1.validateNamespace;
var utf8_1 = __webpack_require__(1243);
exports.stringLength = utf8_1.stringLength;
exports.stringToByteArray = utf8_1.stringToByteArray;

//# sourceMappingURL=index.js.map


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @fileoverview Firebase constants.  Some of these (@defines) can be overridden at compile-time.
 */
exports.CONSTANTS = {
    /**
     * @define {boolean} Whether this is the client Node.js SDK.
     */
    NODE_CLIENT: false,
    /**
     * @define {boolean} Whether this is the Admin Node.js SDK.
     */
    NODE_ADMIN: false,
    /**
     * Firebase SDK Version
     */
    SDK_VERSION: '${JSCORE_VERSION}'
};

//# sourceMappingURL=constants.js.map


/***/ }),
/* 276 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 277 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(499);
var defined = __webpack_require__(195);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 279 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 280 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(501)('keys');
var uid = __webpack_require__(503);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 282 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);



var propTypes = {
  label: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
var defaultProps = {
  label: 'Close'
};

var CloseButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CloseButton, _React$Component);

  function CloseButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CloseButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        label = _this$props.label,
        onClick = _this$props.onClick;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button", {
      type: "button",
      className: "close",
      onClick: onClick
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      "aria-hidden": "true"
    }, "\xD7"), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: "sr-only"
    }, label));
  };

  return CloseButton;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

CloseButton.propTypes = propTypes;
CloseButton.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CloseButton);

/***/ }),
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Button__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(11);









var propTypes = {
  vertical: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Display block buttons; only useful when used with the "vertical" prop.
   * @type {bool}
   */
  block: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, function (_ref) {
    var block = _ref.block,
        vertical = _ref.vertical;
    return block && !vertical ? new Error('`block` requires `vertical` to be set to have any effect') : null;
  })
};
var defaultProps = {
  block: false,
  justified: false,
  vertical: false
};

var ButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonGroup, _React$Component);

  function ButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonGroup.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        block = _this$props.block,
        justified = _this$props.justified,
        vertical = _this$props.vertical,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["block", "justified", "vertical", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps)] = !vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'vertical')] = vertical, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Button__["a" /* default */].defaultProps, 'block')] = block, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ButtonGroup.propTypes = propTypes;
ButtonGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('btn-group', ButtonGroup));

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  /**
   * An icon name without "glyphicon-" prefix. See e.g. http://getbootstrap.com/components/#glyphicons
   */
  glyph: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string.isRequired
};

var Glyphicon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Glyphicon, _React$Component);

  function Glyphicon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Glyphicon.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        glyph = _this$props.glyph,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["glyph", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, glyph)] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Glyphicon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Glyphicon.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('glyphicon', Glyphicon));

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__ = __webpack_require__(1303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__ = __webpack_require__(516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(34);





var _collapseStyles;








var MARGINS = {
  height: ['marginTop', 'marginBottom'],
  width: ['marginLeft', 'marginRight']
}; // reading a dimension prop will cause the browser to recalculate,
// which will let our animations work

function triggerBrowserReflow(node) {
  node.offsetHeight; // eslint-disable-line no-unused-expressions
}

function getDimensionValue(dimension, elem) {
  var value = elem["offset" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)];
  var margins = MARGINS[dimension];
  return value + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[0]), 10) + __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_core_js_parse_int___default()(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_style___default()(elem, margins[1]), 10);
}

var collapseStyles = (_collapseStyles = {}, _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITED"]] = 'collapse', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["EXITING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERING"]] = 'collapsing', _collapseStyles[__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition__["ENTERED"]] = 'collapse in', _collapseStyles);
var propTypes = {
  /**
   * Show the component; triggers the expand or collapse animation
   */
  in: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Wait until the first "enter" transition to mount the component (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Unmount the component (remove it from the DOM) when it is collapsed
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Run the expand animation when the component mounts, if it is initially
   * shown
   */
  appear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * Duration of the collapse animation in milliseconds, to ensure that
   * finishing callbacks are fired even if the original browser transition end
   * events are canceled
   */
  timeout: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * The dimension used when collapsing, or a function that returns the
   * dimension
   *
   * _Note: Bootstrap only partially supports 'width'!
   * You will need to supply your own CSS animation for the `.width` CSS class._
   */
  dimension: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['height', 'width']), __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func]),

  /**
   * Function that returns the height or width of the animating DOM node
   *
   * Allows for providing some custom logic for how much the Collapse component
   * should animate in its specified dimension. Called with the current
   * dimension prop value and the DOM node.
   */
  getDimensionValue: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * ARIA role of collapsible element
   */
  role: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string
};
var defaultProps = {
  in: false,
  timeout: 300,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  dimension: 'height',
  getDimensionValue: getDimensionValue
};

var Collapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Collapse, _React$Component);

  function Collapse() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleEnter = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    _this.handleEntering = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this._getScrollDimensionValue(elem, dimension);
    };

    _this.handleEntered = function (elem) {
      elem.style[_this.getDimension()] = null;
    };

    _this.handleExit = function (elem) {
      var dimension = _this.getDimension();

      elem.style[dimension] = _this.props.getDimensionValue(dimension, elem) + "px";
      triggerBrowserReflow(elem);
    };

    _this.handleExiting = function (elem) {
      elem.style[_this.getDimension()] = '0';
    };

    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.getDimension = function getDimension() {
    return typeof this.props.dimension === 'function' ? this.props.dimension() : this.props.dimension;
  }; // for testing


  _proto._getScrollDimensionValue = function _getScrollDimensionValue(elem, dimension) {
    return elem["scroll" + Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(dimension)] + "px";
  };
  /* -- Expanding -- */


  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onEnter", "onEntering", "onEntered", "onExit", "onExiting", "className", "children"]);

    delete props.dimension;
    delete props.getDimensionValue;
    var handleEnter = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter);
    var handleEntering = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntering, onEntering);
    var handleEntered = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEntered, onEntered);
    var handleExit = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExit, onExit);
    var handleExiting = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExiting, onExiting);
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_transition_group_Transition___default.a, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "aria-expanded": props.role ? props.in : null,
      onEnter: handleEnter,
      onEntering: handleEntering,
      onEntered: handleEntered,
      onExit: handleExit,
      onExiting: handleExiting
    }), function (state, innerProps) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, innerProps, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, children.props.className, collapseStyles[state], _this2.getDimension() === 'width' && 'width')
      }));
    });
  };

  return Collapse;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Collapse);

/***/ }),
/* 286 */
/***/ (function(module, exports) {

// Source: http://jsfiddle.net/vWx8V/
// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes

/**
 * Conenience method returns corresponding value for given keyName or keyCode.
 *
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Mixed}
 * @api public
 */

function keyCode(searchInput) {
  // Keyboard Events
  if (searchInput && 'object' === typeof searchInput) {
    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
    if (hasKeyCode) searchInput = hasKeyCode
  }

  // Numbers
  if ('number' === typeof searchInput) return names[searchInput]

  // Everything else (cast to string)
  var search = String(searchInput)

  // check codes
  var foundNamedKey = codes[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // check aliases
  var foundNamedKey = aliases[search.toLowerCase()]
  if (foundNamedKey) return foundNamedKey

  // weird character?
  if (search.length === 1) return search.charCodeAt(0)

  return undefined
}

/**
 * Compares a keyboard event with a given keyCode or keyName.
 *
 * @param {Event} event Keyboard event that should be tested
 * @param {Mixed} keyCode {Number} or keyName {String}
 * @return {Boolean}
 * @api public
 */
keyCode.isEventKey = function isEventKey(event, nameOrCode) {
  if (event && 'object' === typeof event) {
    var keyCode = event.which || event.keyCode || event.charCode
    if (keyCode === null || keyCode === undefined) { return false; }
    if (typeof nameOrCode === 'string') {
      // check codes
      var foundNamedKey = codes[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    
      // check aliases
      var foundNamedKey = aliases[nameOrCode.toLowerCase()]
      if (foundNamedKey) { return foundNamedKey === keyCode; }
    } else if (typeof nameOrCode === 'number') {
      return nameOrCode === keyCode;
    }
    return false;
  }
}

exports = module.exports = keyCode;

/**
 * Get by name
 *
 *   exports.code['enter'] // => 13
 */

var codes = exports.code = exports.codes = {
  'backspace': 8,
  'tab': 9,
  'enter': 13,
  'shift': 16,
  'ctrl': 17,
  'alt': 18,
  'pause/break': 19,
  'caps lock': 20,
  'esc': 27,
  'space': 32,
  'page up': 33,
  'page down': 34,
  'end': 35,
  'home': 36,
  'left': 37,
  'up': 38,
  'right': 39,
  'down': 40,
  'insert': 45,
  'delete': 46,
  'command': 91,
  'left command': 91,
  'right command': 93,
  'numpad *': 106,
  'numpad +': 107,
  'numpad -': 109,
  'numpad .': 110,
  'numpad /': 111,
  'num lock': 144,
  'scroll lock': 145,
  'my computer': 182,
  'my calculator': 183,
  ';': 186,
  '=': 187,
  ',': 188,
  '-': 189,
  '.': 190,
  '/': 191,
  '`': 192,
  '[': 219,
  '\\': 220,
  ']': 221,
  "'": 222
}

// Helper aliases

var aliases = exports.aliases = {
  'windows': 91,
  '⇧': 16,
  '⌥': 18,
  '⌃': 17,
  '⌘': 91,
  'ctl': 17,
  'control': 17,
  'option': 18,
  'pause': 19,
  'break': 19,
  'caps': 20,
  'return': 13,
  'escape': 27,
  'spc': 32,
  'spacebar': 32,
  'pgup': 33,
  'pgdn': 34,
  'ins': 45,
  'del': 46,
  'cmd': 91
}

/*!
 * Programatically add the following
 */

// lower case chars
for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32

// numbers
for (var i = 48; i < 58; i++) codes[i - 48] = i

// function keys
for (i = 1; i < 13; i++) codes['f'+i] = i + 111

// numpad keys
for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96

/**
 * Get by code
 *
 *   exports.name[13] // => 'Enter'
 */

var names = exports.names = exports.title = {} // title for backward compat

// Create reverse mapping
for (i in codes) names[codes[i]] = i

// Add aliases
for (var alias in aliases) {
  codes[alias] = aliases[alias]
}


/***/ }),
/* 287 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createChainableTypeChecker = __webpack_require__(1385);

var _createChainableTypeChecker2 = _interopRequireDefault(_createChainableTypeChecker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function elementType(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var propType = typeof propValue === 'undefined' ? 'undefined' : _typeof(propValue);

  if (_react2.default.isValidElement(propValue)) {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of type ReactElement ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  if (propType !== 'function' && propType !== 'string') {
    return new Error('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected an element type (a string ') + 'or a ReactClass).');
  }

  return null;
}

exports.default = (0, _createChainableTypeChecker2.default)(elementType);

/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_uncontrollable__);





var TAB = 'tab';
var PANE = 'pane';
var idPropType = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.number]);
var propTypes = {
  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: function id(props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error('In order to properly initialize Tabs in a way that is accessible ' + 'to assistive technologies (such as screen readers) an `id` or a ' + '`generateChildId` prop to TabContainer is required');
      }
    }

    return error;
  },

  /**
   * A function that takes an `eventKey` and `type` and returns a unique id for
   * child tab `<NavItem>`s and `<TabPane>`s. The function _must_ be a pure
   * function, meaning it should always return the _same_ id for the same set
   * of inputs. The default value requires that an `id` to be set for the
   * `<TabContainer>`.
   *
   * The `type` argument will either be `"tab"` or `"pane"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * A callback fired when a tab is selected.
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The `eventKey` of the currently active tab.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};
var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func.isRequired
  })
};

var TabContainer =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContainer, _React$Component);

  function TabContainer() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = TabContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        onSelect = _this$props.onSelect,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;

    var getId = generateChildId || function (key, type) {
      return id ? id + "-" + type + "-" + key : null;
    };

    return {
      $bs_tabContainer: {
        activeKey: activeKey,
        onSelect: onSelect,
        getTabId: function getTabId(key) {
          return getId(key, TAB);
        },
        getPaneId: function getPaneId(key) {
          return getId(key, PANE);
        }
      }
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children"]);

    delete props.generateChildId;
    delete props.onSelect;
    delete props.activeKey;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children), props);
  };

  return TabContainer;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

TabContainer.propTypes = propTypes;
TabContainer.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_4_uncontrollable___default()(TabContainer, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(11);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * Sets a default animation strategy for all children `<TabPane>`s. Use
   * `false` to disable, `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when they are no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
  })
};
var childContextTypes = {
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};

var TabContent =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabContent, _React$Component);

  function TabContent(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handlePaneEnter = _this.handlePaneEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePaneExited = _this.handlePaneExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this))); // Active entries in state will be `null` unless `animation` is set. Need
    // to track active child in case keys swap and the active child changes
    // but the active key does not.

    _this.state = {
      activeKey: null,
      activeChild: null
    };
    return _this;
  }

  var _proto = TabContent.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit;
    var stateActiveKey = this.state.activeKey;
    var containerActiveKey = this.getContainerActiveKey();
    var activeKey = stateActiveKey != null ? stateActiveKey : containerActiveKey;
    var exiting = stateActiveKey != null && stateActiveKey !== containerActiveKey;
    return {
      $bs_tabContent: {
        bsClass: bsClass,
        animation: animation,
        activeKey: activeKey,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        onPaneEnter: this.handlePaneEnter,
        onPaneExited: this.handlePaneExited,
        exiting: exiting
      }
    };
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (!nextProps.animation && this.state.activeChild) {
      this.setState({
        activeKey: null,
        activeChild: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.getContainerActiveKey = function getContainerActiveKey() {
    var tabContainer = this.context.$bs_tabContainer;
    return tabContainer && tabContainer.activeKey;
  };

  _proto.handlePaneEnter = function handlePaneEnter(child, childKey) {
    if (!this.props.animation) {
      return false;
    } // It's possible that this child should be transitioning out.


    if (childKey !== this.getContainerActiveKey()) {
      return false;
    }

    this.setState({
      activeKey: childKey,
      activeChild: child
    });
    return true;
  };

  _proto.handlePaneExited = function handlePaneExited(child) {
    // This might happen as everything is unmounting.
    if (this.isUnmounted) {
      return;
    }

    this.setState(function (_ref) {
      var activeChild = _ref.activeChild;

      if (activeChild !== child) {
        return null;
      }

      return {
        activeKey: null,
        activeChild: null
      };
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        Component = _this$props2.componentClass,
        className = _this$props2.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["componentClass", "className"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation', 'mountOnEnter', 'unmountOnExit']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'))
    }));
  };

  return TabContent;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabContent.propTypes = propTypes;
TabContent.defaultProps = defaultProps;
TabContent.contextTypes = contextTypes;
TabContent.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('tab', TabContent));

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(151);

var ReactNoopUpdateQueue = __webpack_require__(294);

var canDefineProperty = __webpack_require__(549);
var emptyObject = __webpack_require__(295);
var invariant = __webpack_require__(79);
var warning = __webpack_require__(80);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          process.env.NODE_ENV !== 'production' ? warning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]) : void 0;
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

module.exports = ReactComponent;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var warning = __webpack_require__(80);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {

  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__react_google_maps_api__ = __webpack_require__(1456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__provider_base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GoogleMapLocation=function(_React$PureComponent){_inherits(GoogleMapLocation,_React$PureComponent);function GoogleMapLocation(props){_classCallCheck(this,GoogleMapLocation);var _this=_possibleConstructorReturn(this,(GoogleMapLocation.__proto__||Object.getPrototypeOf(GoogleMapLocation)).call(this,props));_this.state={markerPosition:props.initialPosition,center:props.initialPosition};_this.searchBox;_this.onPlacesChanged=_this.onPlacesChanged.bind(_this);_this.onClickMap=_this.onClickMap.bind(_this);_this.libraries=["places"];return _this;}_createClass(GoogleMapLocation,[{key:'onPlacesChanged',value:function onPlacesChanged(){// console.log("onPlacesChanged")
//this.props.onChangeLocation(this.searchBox.getPlaces())
var place=this.searchBox.getPlaces()[0];var latLng=place.geometry.location;var coords={lat:latLng.lat(),lng:latLng.lng()// console.log("PLACE",place)
};this.setState({center:coords,markerPosition:coords});this.props.onChangeAddress(place.formatted_address);}},{key:'onClickMap',value:function onClickMap(_ref){var latLng=_ref.latLng;this.setState({markerPosition:{lat:latLng.lat(),lng:latLng.lng()}});}//Ver los eventos del mapa para mandar las coordenadas y dirección fuera del componente
},{key:'render',value:function render(){var _this2=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__react_google_maps_api__["b" /* LoadScript */],{id:'script-loader',googleMapsApiKey:__WEBPACK_IMPORTED_MODULE_2__provider_base_Settings___default.a.API_KEY,libraries:this.libraries// {...other props}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__react_google_maps_api__["a" /* GoogleMap */],{id:'example-map',mapContainerStyle:{height:"400px",width:"100%"},zoom:this.props.zoom,center:this.state.center,onClick:this.onClickMap// {...other props }
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__react_google_maps_api__["c" /* Marker */],{onLoad:function onLoad(ref){_this2.marker=ref;},position:this.state.markerPosition,draggable:true,onPositionChanged:function onPositionChanged(){_this2.marker&&_this2.props.onChangeLocation(_this2.marker.position);}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__react_google_maps_api__["d" /* StandaloneSearchBox */],{onLoad:function onLoad(ref){_this2.searchBox=ref;},onPlacesChanged:this.onPlacesChanged},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',{ref:'refInput',type:'text',placeholder:'Buscar ...'// eslint-disable-next-line react-perf/jsx-no-new-object-as-prop
,style:{boxSizing:'border-box',border:'1px solid transparent',width:'240px',height:'32px',padding:'0 12px',borderRadius:'3px',boxShadow:'0 2px 6px rgba(0, 0, 0, 0.3)',fontSize:'14px',outline:'none',textOverflow:'ellipses',position:'absolute',top:'10px',right:'80px'}}))));}}]);return GoogleMapLocation;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);GoogleMapLocation.defaultProps={onChangeLocation:function onChangeLocation(evt){console.log("ON CHANGE LOCATION",evt);},onChangeAddress:function onChangeAddress(address){console.log("ON CHANGE ADDRESS",address);},zoom:10,initialPosition:{lat:-31.4179457,lng:-64.1813292}};/* harmony default export */ __webpack_exports__["a"] = (GoogleMapLocation);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
}), 'Visibility');

exports.default = _default;

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetRoles;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionGetRolesRedimidores;
/* harmony export (immutable) */ __webpack_exports__["d"] = actionSaveRol;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeleteRol;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_rol_RolService__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
/*** ACTIONS ROLES ******/function actionGetRoles(succesCallback,errorCallback){return function(dispatch,getStore){// loading(true)(dispatch)
__WEBPACK_IMPORTED_MODULE_1__provider_rol_RolService__["a" /* default */].getRoles(getStore().app.app).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["g" /* ACT_ROL_CHANGE */],props:{rolList:response}});succesCallback&&succesCallback();}).catch(errorCallback);// .finally(()=>{loading(false)(dispatch)})
};}function actionGetRolesRedimidores(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_rol_RolService__["a" /* default */].getRolesRedimidores(getStore().app.app).then(function(response){console.log("actionGetRolesRedimidores",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["g" /* ACT_ROL_CHANGE */],props:{rolesRedimidoresList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveRol(rol,successCallback,errorCallback){return function(dispatch,getStore){console.log("actionSaveRol ROL",rol);Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_rol_RolService__["a" /* default */].saveRol(getStore().app.app,rol).then(function(){successCallback&&successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionDeleteRol(rol,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_rol_RolService__["a" /* default */].deleteRol(getStore().app.app,rol).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/****** FIN ACTION ROLES +**********/

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = chainPropTypes;
function chainPropTypes(propType1, propType2) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

/***/ }),
/* 300 */
/***/ (function(module, exports) {

var roles={PRODUCTOR:"Productor",RRPP:"Rrpp",REDIMIDOR:"Redimidor",DEFAULT:"Default",ADMIN:"Admin",SUPERADMIN:"SuperAdmin"};module.exports=roles;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(588);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.3.6 Object.prototype.toString()
var classof = __webpack_require__(303);
var test = {};
test[__webpack_require__(56)('toStringTag')] = 'z';
if (test + '' != '[object z]') {
  __webpack_require__(103)(Object.prototype, 'toString', function toString() {
    return '[object ' + classof(this) + ']';
  }, true);
}


/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(304);
var TAG = __webpack_require__(56)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 304 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 305 */
/***/ (function(module, exports) {

module.exports = false;


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(87) && !__webpack_require__(157)(function () {
  return Object.defineProperty(__webpack_require__(307)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(78);
var document = __webpack_require__(71).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(78);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(594)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(219)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(71);
var core = __webpack_require__(102);
var hide = __webpack_require__(104);
var redefine = __webpack_require__(103);
var ctx = __webpack_require__(158);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE];
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {});
  var key, own, out, exp;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    // export native or passed
    out = (own ? target : source)[key];
    // bind timers to global for call from export context
    exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // extend global
    if (target) redefine(target, key, out, type & $export.U);
    // export
    if (exports[key] != out) hide(exports, key, exp);
    if (IS_PROTO && expProto[key] != out) expProto[key] = out;
  }
};
global.core = core;
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(106);
var dPs = __webpack_require__(597);
var enumBugKeys = __webpack_require__(314);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(307)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(602).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(598);
var enumBugKeys = __webpack_require__(314);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(217);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 314 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

var $iterators = __webpack_require__(605);
var getKeys = __webpack_require__(312);
var redefine = __webpack_require__(103);
var global = __webpack_require__(71);
var hide = __webpack_require__(104);
var Iterators = __webpack_require__(128);
var wks = __webpack_require__(56);
var ITERATOR = wks('iterator');
var TO_STRING_TAG = wks('toStringTag');
var ArrayValues = Iterators.Array;

var DOMIterables = {
  CSSRuleList: true, // TODO: Not spec compliant, should be false.
  CSSStyleDeclaration: false,
  CSSValueList: false,
  ClientRectList: false,
  DOMRectList: false,
  DOMStringList: false,
  DOMTokenList: true,
  DataTransferItemList: false,
  FileList: false,
  HTMLAllCollection: false,
  HTMLCollection: false,
  HTMLFormElement: false,
  HTMLSelectElement: false,
  MediaList: true, // TODO: Not spec compliant, should be false.
  MimeTypeArray: false,
  NamedNodeMap: false,
  NodeList: true,
  PaintRequestList: false,
  Plugin: false,
  PluginArray: false,
  SVGLengthList: false,
  SVGNumberList: false,
  SVGPathSegList: false,
  SVGPointList: false,
  SVGStringList: false,
  SVGTransformList: false,
  SourceBufferList: false,
  StyleSheetList: true, // TODO: Not spec compliant, should be false.
  TextTrackCueList: false,
  TextTrackList: false,
  TouchList: false
};

for (var collections = getKeys(DOMIterables), i = 0; i < collections.length; i++) {
  var NAME = collections[i];
  var explicit = DOMIterables[NAME];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  var key;
  if (proto) {
    if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
    if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
    Iterators[NAME] = ArrayValues;
    if (explicit) for (key in $iterators) if (!proto[key]) redefine(proto, key, $iterators[key], true);
  }
}


/***/ }),
/* 316 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var dP = __webpack_require__(105).f;
var create = __webpack_require__(311);
var redefineAll = __webpack_require__(318);
var ctx = __webpack_require__(158);
var anInstance = __webpack_require__(319);
var forOf = __webpack_require__(320);
var $iterDefine = __webpack_require__(219);
var step = __webpack_require__(316);
var setSpecies = __webpack_require__(611);
var DESCRIPTORS = __webpack_require__(87);
var fastKey = __webpack_require__(321).fastKey;
var validate = __webpack_require__(222);
var SIZE = DESCRIPTORS ? '_s' : 'size';

var getEntry = function (that, key) {
  // fast case
  var index = fastKey(key);
  var entry;
  if (index !== 'F') return that._i[index];
  // frozen object case
  for (entry = that._f; entry; entry = entry.n) {
    if (entry.k == key) return entry;
  }
};

module.exports = {
  getConstructor: function (wrapper, NAME, IS_MAP, ADDER) {
    var C = wrapper(function (that, iterable) {
      anInstance(that, C, NAME, '_i');
      that._t = NAME;         // collection type
      that._i = create(null); // index
      that._f = undefined;    // first entry
      that._l = undefined;    // last entry
      that[SIZE] = 0;         // size
      if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
    });
    redefineAll(C.prototype, {
      // 23.1.3.1 Map.prototype.clear()
      // 23.2.3.2 Set.prototype.clear()
      clear: function clear() {
        for (var that = validate(this, NAME), data = that._i, entry = that._f; entry; entry = entry.n) {
          entry.r = true;
          if (entry.p) entry.p = entry.p.n = undefined;
          delete data[entry.i];
        }
        that._f = that._l = undefined;
        that[SIZE] = 0;
      },
      // 23.1.3.3 Map.prototype.delete(key)
      // 23.2.3.4 Set.prototype.delete(value)
      'delete': function (key) {
        var that = validate(this, NAME);
        var entry = getEntry(that, key);
        if (entry) {
          var next = entry.n;
          var prev = entry.p;
          delete that._i[entry.i];
          entry.r = true;
          if (prev) prev.n = next;
          if (next) next.p = prev;
          if (that._f == entry) that._f = next;
          if (that._l == entry) that._l = prev;
          that[SIZE]--;
        } return !!entry;
      },
      // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
      // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
      forEach: function forEach(callbackfn /* , that = undefined */) {
        validate(this, NAME);
        var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3);
        var entry;
        while (entry = entry ? entry.n : this._f) {
          f(entry.v, entry.k, this);
          // revert to the last existing entry
          while (entry && entry.r) entry = entry.p;
        }
      },
      // 23.1.3.7 Map.prototype.has(key)
      // 23.2.3.7 Set.prototype.has(value)
      has: function has(key) {
        return !!getEntry(validate(this, NAME), key);
      }
    });
    if (DESCRIPTORS) dP(C.prototype, 'size', {
      get: function () {
        return validate(this, NAME)[SIZE];
      }
    });
    return C;
  },
  def: function (that, key, value) {
    var entry = getEntry(that, key);
    var prev, index;
    // change existing entry
    if (entry) {
      entry.v = value;
    // create new entry
    } else {
      that._l = entry = {
        i: index = fastKey(key, true), // <- index
        k: key,                        // <- key
        v: value,                      // <- value
        p: prev = that._l,             // <- previous entry
        n: undefined,                  // <- next entry
        r: false                       // <- removed
      };
      if (!that._f) that._f = entry;
      if (prev) prev.n = entry;
      that[SIZE]++;
      // add to index
      if (index !== 'F') that._i[index] = entry;
    } return that;
  },
  getEntry: getEntry,
  setStrong: function (C, NAME, IS_MAP) {
    // add .keys, .values, .entries, [@@iterator]
    // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
    $iterDefine(C, NAME, function (iterated, kind) {
      this._t = validate(iterated, NAME); // target
      this._k = kind;                     // kind
      this._l = undefined;                // previous
    }, function () {
      var that = this;
      var kind = that._k;
      var entry = that._l;
      // revert to the last existing entry
      while (entry && entry.r) entry = entry.p;
      // get next entry
      if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
        // or finish the iteration
        that._t = undefined;
        return step(1);
      }
      // return step by kind
      if (kind == 'keys') return step(0, entry.k);
      if (kind == 'values') return step(0, entry.v);
      return step(0, [entry.k, entry.v]);
    }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);

    // add [@@species], 23.1.2.2, 23.2.2.2
    setSpecies(NAME);
  }
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

var redefine = __webpack_require__(103);
module.exports = function (target, src, safe) {
  for (var key in src) redefine(target, key, src[key], safe);
  return target;
};


/***/ }),
/* 319 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(158);
var call = __webpack_require__(608);
var isArrayIter = __webpack_require__(609);
var anObject = __webpack_require__(106);
var toLength = __webpack_require__(313);
var getIterFn = __webpack_require__(610);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(156)('meta');
var isObject = __webpack_require__(78);
var has = __webpack_require__(107);
var setDesc = __webpack_require__(105).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(157)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(71);
var $export = __webpack_require__(310);
var redefine = __webpack_require__(103);
var redefineAll = __webpack_require__(318);
var meta = __webpack_require__(321);
var forOf = __webpack_require__(320);
var anInstance = __webpack_require__(319);
var isObject = __webpack_require__(78);
var fails = __webpack_require__(157);
var $iterDetect = __webpack_require__(612);
var setToStringTag = __webpack_require__(221);
var inheritIfRequired = __webpack_require__(613);

module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
  var Base = global[NAME];
  var C = Base;
  var ADDER = IS_MAP ? 'set' : 'add';
  var proto = C && C.prototype;
  var O = {};
  var fixMethod = function (KEY) {
    var fn = proto[KEY];
    redefine(proto, KEY,
      KEY == 'delete' ? function (a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'has' ? function has(a) {
        return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'get' ? function get(a) {
        return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
      } : KEY == 'add' ? function add(a) { fn.call(this, a === 0 ? 0 : a); return this; }
        : function set(a, b) { fn.call(this, a === 0 ? 0 : a, b); return this; }
    );
  };
  if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
    new C().entries().next();
  }))) {
    // create collection constructor
    C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
    redefineAll(C.prototype, methods);
    meta.NEED = true;
  } else {
    var instance = new C();
    // early implementations not supports chaining
    var HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance;
    // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
    var THROWS_ON_PRIMITIVES = fails(function () { instance.has(1); });
    // most early implementations doesn't supports iterables, most modern - not close it correctly
    var ACCEPT_ITERABLES = $iterDetect(function (iter) { new C(iter); }); // eslint-disable-line no-new
    // for early implementations -0 and +0 not the same
    var BUGGY_ZERO = !IS_WEAK && fails(function () {
      // V8 ~ Chromium 42- fails only with 5+ elements
      var $instance = new C();
      var index = 5;
      while (index--) $instance[ADDER](index, index);
      return !$instance.has(-0);
    });
    if (!ACCEPT_ITERABLES) {
      C = wrapper(function (target, iterable) {
        anInstance(target, C, NAME);
        var that = inheritIfRequired(new Base(), target, C);
        if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
        return that;
      });
      C.prototype = proto;
      proto.constructor = C;
    }
    if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
      fixMethod('delete');
      fixMethod('has');
      IS_MAP && fixMethod('get');
    }
    if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
    // weak collections should not contains .clear method
    if (IS_WEAK && proto.clear) delete proto.clear;
  }

  setToStringTag(C, NAME);

  O[NAME] = C;
  $export($export.G + $export.W + $export.F * (C != Base), O);

  if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);

  return C;
};


/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var printWarning = function() {};

if (false) {
  printWarning = function(format, subs) {
    var index = 0;
    var message =
      'Warning: ' +
      (subs.length > 0
        ? format.replace(/%s/g, function() {
            return subs[index++];
          })
        : format);

    if (typeof console !== 'undefined') {
      console.error(message);
    }

    try {
      // --- Welcome to debugging history ---
      // This error was thrown as a convenience so that you can use the
      // stack trace to find the callsite that triggered this warning.
      throw new Error(message);
    } catch (e) {}
  };
}

module.exports = function(member) {
  printWarning(
    'Please use `require("history").%s` instead of `require("history/%s")`. ' +
      'Support for the latter will be removed in the next major release.',
    [member, member]
  );
};


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(637);
} else {
  module.exports = require('./cjs/history.js');
}


/***/ }),
/* 325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["default"] = (resolvePathname);


/***/ }),
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["default"] = (valueEqual);


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
  if (condition) {
    return;
  }

  if (isProduction) {
    throw new Error(prefix);
  } else {
    throw new Error(prefix + ": " + (message || ''));
  }
}

/* harmony default export */ __webpack_exports__["default"] = (invariant);


/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(642)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(226);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }




var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore right clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        props = _objectWithoutProperties(_props, ['replace', 'to']); // eslint-disable-line no-unused-vars

    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(659);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(660);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(334);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ActionTypes; });
/* harmony export (immutable) */ __webpack_exports__["b"] = createStore;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_symbol_observable__ = __webpack_require__(668);



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isPlainObject__["a" /* default */])(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[__WEBPACK_IMPORTED_MODULE_1_symbol_observable__["a" /* default */]] = observable, _ref2;
}

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(339);


/** Built-in value references. */
var getPrototype = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.getPrototypeOf, Object);

/* harmony default export */ __webpack_exports__["a"] = (getPrototype);


/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overArg);


/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = compose;
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(343);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(673);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(227);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(231);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };




var arrayInsert = function arrayInsert(form, field, index, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"],
    meta: { form: form, field: field, index: index },
    payload: value
  };
};

var arrayMove = function arrayMove(form, field, from, to) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"],
    meta: { form: form, field: field, from: from, to: to }
  };
};

var arrayPop = function arrayPop(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"],
    meta: { form: form, field: field }
  };
};

var arrayPush = function arrayPush(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"],
    meta: { form: form, field: field },
    payload: value
  };
};

var arrayRemove = function arrayRemove(form, field, index) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"],
    meta: { form: form, field: field, index: index }
  };
};

var arrayRemoveAll = function arrayRemoveAll(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"],
    meta: { form: form, field: field }
  };
};

var arrayShift = function arrayShift(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"],
    meta: { form: form, field: field }
  };
};

var arraySplice = function arraySplice(form, field, index, removeNum, value) {
  var action = {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"],
    meta: { form: form, field: field, index: index, removeNum: removeNum }
  };
  if (value !== undefined) {
    action.payload = value;
  }
  return action;
};

var arraySwap = function arraySwap(form, field, indexA, indexB) {
  if (indexA === indexB) {
    throw new Error('Swap indices cannot be equal');
  }
  if (indexA < 0 || indexB < 0) {
    throw new Error('Swap indices cannot be negative');
  }
  return { type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], meta: { form: form, field: field, indexA: indexA, indexB: indexB } };
};

var arrayUnshift = function arrayUnshift(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"],
    meta: { form: form, field: field },
    payload: value
  };
};

var autofill = function autofill(form, field, value) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"],
    meta: { form: form, field: field },
    payload: value
  };
};

var blur = function blur(form, field, value, touch) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"],
    meta: { form: form, field: field, touch: touch },
    payload: value
  };
};

var change = function change(form, field, value, touch, persistentSubmitErrors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"],
    meta: { form: form, field: field, touch: touch, persistentSubmitErrors: persistentSubmitErrors },
    payload: value
  };
};

var clearSubmit = function clearSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"],
    meta: { form: form }
  };
};

var clearSubmitErrors = function clearSubmitErrors(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"],
    meta: { form: form }
  };
};

var clearAsyncError = function clearAsyncError(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"],
    meta: { form: form, field: field }
  };
};

var clearFields = function clearFields(form, keepTouched, persistentSubmitErrors) {
  for (var _len = arguments.length, fields = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    fields[_key - 3] = arguments[_key];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"],
    meta: { form: form, keepTouched: keepTouched, persistentSubmitErrors: persistentSubmitErrors, fields: fields }
  };
};

var destroy = function destroy() {
  for (var _len2 = arguments.length, form = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    form[_key2] = arguments[_key2];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"],
    meta: { form: form }
  };
};

var focus = function focus(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"],
    meta: { form: form, field: field }
  };
};

var initialize = function initialize(form, values, keepDirty) {
  var otherMeta = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  if (keepDirty instanceof Object) {
    otherMeta = keepDirty;
    keepDirty = false;
  }
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"],
    meta: _extends({ form: form, keepDirty: keepDirty }, otherMeta),
    payload: values
  };
};

var registerField = function registerField(form, name, type) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, type: type }
  };
};

var reset = function reset(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"],
    meta: { form: form }
  };
};

var resetSection = function resetSection(form) {
  for (var _len3 = arguments.length, sections = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    sections[_key3 - 1] = arguments[_key3];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"],
    meta: { form: form, sections: sections }
  };
};

var startAsyncValidation = function startAsyncValidation(form, field) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"],
    meta: { form: form, field: field }
  };
};

var startSubmit = function startSubmit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"],
    meta: { form: form }
  };
};

var stopAsyncValidation = function stopAsyncValidation(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var stopSubmit = function stopSubmit(form, errors) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"],
    meta: { form: form },
    payload: errors,
    error: !!(errors && Object.keys(errors).length)
  };
};

var submit = function submit(form) {
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"],
    meta: { form: form }
  };
};

var setSubmitFailed = function setSubmitFailed(form) {
  for (var _len4 = arguments.length, fields = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    fields[_key4 - 1] = arguments[_key4];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"],
    meta: { form: form, fields: fields },
    error: true
  };
};

var setSubmitSucceeded = function setSubmitSucceeded(form) {
  for (var _len5 = arguments.length, fields = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    fields[_key5 - 1] = arguments[_key5];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"],
    meta: { form: form, fields: fields },
    error: false
  };
};

var touch = function touch(form) {
  for (var _len6 = arguments.length, fields = Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
    fields[_key6 - 1] = arguments[_key6];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"],
    meta: { form: form, fields: fields }
  };
};

var unregisterField = function unregisterField(form, name) {
  var destroyOnUnmount = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"],
    meta: { form: form },
    payload: { name: name, destroyOnUnmount: destroyOnUnmount }
  };
};

var untouch = function untouch(form) {
  for (var _len7 = arguments.length, fields = Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
    fields[_key7 - 1] = arguments[_key7];
  }

  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"],
    meta: { form: form, fields: fields }
  };
};

var updateSyncErrors = function updateSyncErrors(form) {
  var syncErrors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var error = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"],
    meta: { form: form },
    payload: { syncErrors: syncErrors, error: error }
  };
};

var updateSyncWarnings = function updateSyncWarnings(form) {
  var syncWarnings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var warning = arguments[2];
  return {
    type: __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"],
    meta: { form: form },
    payload: { syncWarnings: syncWarnings, warning: warning }
  };
};

var actions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift,
  autofill: autofill,
  blur: blur,
  change: change,
  clearFields: clearFields,
  clearSubmit: clearSubmit,
  clearSubmitErrors: clearSubmitErrors,
  clearAsyncError: clearAsyncError,
  destroy: destroy,
  focus: focus,
  initialize: initialize,
  registerField: registerField,
  reset: reset,
  resetSection: resetSection,
  startAsyncValidation: startAsyncValidation,
  startSubmit: startSubmit,
  stopAsyncValidation: stopAsyncValidation,
  stopSubmit: stopSubmit,
  submit: submit,
  setSubmitFailed: setSubmitFailed,
  setSubmitSucceeded: setSubmitSucceeded,
  touch: touch,
  unregisterField: unregisterField,
  untouch: untouch,
  updateSyncErrors: updateSyncErrors,
  updateSyncWarnings: updateSyncWarnings
};

/* harmony default export */ __webpack_exports__["a"] = (actions);

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldAsyncValidate = function defaultShouldAsyncValidate(_ref) {
  var initialized = _ref.initialized,
      trigger = _ref.trigger,
      pristine = _ref.pristine,
      syncValidationPasses = _ref.syncValidationPasses;

  if (!syncValidationPasses) {
    return false;
  }
  switch (trigger) {
    case 'blur':
    case 'change':
      // blurring
      return true;
    case 'submit':
      // submitting, so only async validate if form is dirty or was never initialized
      // conversely, DON'T async validate if the form is pristine just as it was initialized
      return !pristine || !initialized;
    default:
      return false;
  }
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldAsyncValidate);

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldValidate = function defaultShouldValidate(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldValidate);

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldError = function defaultShouldError(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldError);

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var defaultShouldWarn = function defaultShouldWarn(_ref) {
  var values = _ref.values,
      nextProps = _ref.nextProps,
      initialRender = _ref.initialRender,
      lastFieldValidatorKeys = _ref.lastFieldValidatorKeys,
      fieldValidatorKeys = _ref.fieldValidatorKeys,
      structure = _ref.structure;

  if (initialRender) {
    return true;
  }
  return !structure.deepEqual(values, nextProps && nextProps.values) || !structure.deepEqual(lastFieldValidatorKeys, fieldValidatorKeys);
};


/* harmony default export */ __webpack_exports__["a"] = (defaultShouldWarn);

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_error__ = __webpack_require__(684);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



var SubmissionError = function (_ExtendableError) {
  _inherits(SubmissionError, _ExtendableError);

  function SubmissionError(errors) {
    _classCallCheck(this, SubmissionError);

    var _this = _possibleConstructorReturn(this, (SubmissionError.__proto__ || Object.getPrototypeOf(SubmissionError)).call(this, 'Submit Validation Failed'));

    _this.errors = errors;
    return _this;
  }

  return SubmissionError;
}(__WEBPACK_IMPORTED_MODULE_0_es6_error__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SubmissionError);

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var processProps = function processProps(type, props, _value, deepEqual) {
  var value = props.value;

  if (type === 'checkbox') {
    return _extends({}, props, {
      checked: !!value
    });
  }
  if (type === 'radio') {
    return _extends({}, props, {
      checked: deepEqual(value, _value),
      value: _value
    });
  }
  if (type === 'select-multiple') {
    return _extends({}, props, {
      value: value || []
    });
  }
  if (type === 'file') {
    return _extends({}, props, {
      value: value || undefined
    });
  }
  return props;
};

var createFieldProps = function createFieldProps(_ref2, name, _ref) {
  var getIn = _ref2.getIn,
      toJS = _ref2.toJS,
      deepEqual = _ref2.deepEqual;

  var asyncError = _ref.asyncError,
      asyncValidating = _ref.asyncValidating,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onDrop = _ref.onDrop,
      onDragStart = _ref.onDragStart,
      dirty = _ref.dirty,
      dispatch = _ref.dispatch,
      onFocus = _ref.onFocus,
      form = _ref.form,
      format = _ref.format,
      initial = _ref.initial,
      parse = _ref.parse,
      pristine = _ref.pristine,
      props = _ref.props,
      state = _ref.state,
      submitError = _ref.submitError,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      validate = _ref.validate,
      value = _ref.value,
      _value = _ref._value,
      warn = _ref.warn,
      custom = _objectWithoutProperties(_ref, ['asyncError', 'asyncValidating', 'onBlur', 'onChange', 'onDrop', 'onDragStart', 'dirty', 'dispatch', 'onFocus', 'form', 'format', 'initial', 'parse', 'pristine', 'props', 'state', 'submitError', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'validate', 'value', '_value', 'warn']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;

  var formatFieldValue = function formatFieldValue(value, format) {
    if (format === null) {
      return value;
    }
    var defaultFormattedValue = value == null ? '' : value;
    return format ? format(value, name) : defaultFormattedValue;
  };

  var formattedFieldValue = formatFieldValue(value, format);

  return {
    input: processProps(custom.type, {
      name: name,
      onBlur: onBlur,
      onChange: onChange,
      onDragStart: onDragStart,
      onDrop: onDrop,
      onFocus: onFocus,
      value: formattedFieldValue
    }, _value, deepEqual),
    meta: _extends({}, toJS(state), {
      active: !!(state && getIn(state, 'active')),
      asyncValidating: asyncValidating,
      autofilled: !!(state && getIn(state, 'autofilled')),
      dirty: dirty,
      dispatch: dispatch,
      error: error,
      form: form,
      initial: initial,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: !!submitting,
      submitFailed: !!submitFailed,
      touched: !!(state && getIn(state, 'touched')),
      valid: !error,
      visited: !!(state && getIn(state, 'visited'))
    }),
    custom: _extends({}, custom, props)
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldProps);

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getValue__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isReactNative__ = __webpack_require__(353);




var onChangeValue = function onChangeValue(event, _ref) {
  var name = _ref.name,
      parse = _ref.parse,
      normalize = _ref.normalize;

  // read value from input
  var value = Object(__WEBPACK_IMPORTED_MODULE_0__getValue__["a" /* default */])(event, __WEBPACK_IMPORTED_MODULE_1__isReactNative__["a" /* default */]);

  // parse value if we have a parser
  if (parse) {
    value = parse(value, name);
  }

  // normalize value
  if (normalize) {
    value = normalize(name, value);
  }

  return value;
};

/* harmony default export */ __webpack_exports__["a"] = (onChangeValue);

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isEvent = function isEvent(candidate) {
  return !!(candidate && candidate.stopPropagation && candidate.preventDefault);
};

/* harmony default export */ __webpack_exports__["a"] = (isEvent);

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

/* harmony default export */ __webpack_exports__["a"] = (isReactNative);

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayMap);


/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (copyArray);


/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__ = __webpack_require__(693);


/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = Object(__WEBPACK_IMPORTED_MODULE_0__memoizeCapped_js__["a" /* default */])(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

/* harmony default export */ __webpack_exports__["a"] = (stringToPath);


/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/* harmony default export */ __webpack_exports__["a"] = (toSource);


/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseToString_js__ = __webpack_require__(716);


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : Object(__WEBPACK_IMPORTED_MODULE_0__baseToString_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (toString);


/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(168);


/**
 * This method is like `_.isEqual` except that it accepts `customizer` which
 * is invoked to compare values. If `customizer` returns `undefined`, comparisons
 * are handled by the method instead. The `customizer` is invoked with up to
 * six arguments: (objValue, othValue [, index|key, object, other, stack]).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * function isGreeting(value) {
 *   return /^h(?:i|ello)$/.test(value);
 * }
 *
 * function customizer(objValue, othValue) {
 *   if (isGreeting(objValue) && isGreeting(othValue)) {
 *     return true;
 *   }
 * }
 *
 * var array = ['hello', 'goodbye'];
 * var other = ['hi', 'goodbye'];
 *
 * _.isEqualWith(array, other, customizer);
 * // => true
 */
function isEqualWith(value, other, customizer) {
  customizer = typeof customizer == 'function' ? customizer : undefined;
  var result = customizer ? customizer(value, other) : undefined;
  return result === undefined ? Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other, undefined, customizer) : !!result;
}

/* harmony default export */ __webpack_exports__["a"] = (isEqualWith);


/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SetCache_js__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arraySome_js__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cacheHas_js__ = __webpack_require__(729);




/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(array);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new __WEBPACK_IMPORTED_MODULE_0__SetCache_js__["a" /* default */] : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__arraySome_js__["a" /* default */])(other, function(othValue, othIndex) {
            if (!Object(__WEBPACK_IMPORTED_MODULE_2__cacheHas_js__["a" /* default */])(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalArrays);


/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(63);


/** Built-in value references. */
var Uint8Array = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Uint8Array;

/* harmony default export */ __webpack_exports__["a"] = (Uint8Array);


/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseTimes_js__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isBuffer_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isIndex_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__ = __webpack_require__(171);







/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value),
      isArg = !isArr && Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(value),
      isBuff = !isArr && !isArg && Object(__WEBPACK_IMPORTED_MODULE_3__isBuffer_js__["a" /* default */])(value),
      isType = !isArr && !isArg && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_5__isTypedArray_js__["a" /* default */])(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? Object(__WEBPACK_IMPORTED_MODULE_0__baseTimes_js__["a" /* default */])(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           Object(__WEBPACK_IMPORTED_MODULE_4__isIndex_js__["a" /* default */])(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayLikeKeys);


/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPrototype_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__ = __webpack_require__(746);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPrototype_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_1__nativeKeys_js__["a" /* default */])(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeys);


/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DataView_js__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Promise_js__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Set_js__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toSource_js__ = __webpack_require__(357);








/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */]),
    mapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]),
    promiseCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */]),
    setCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]),
    weakMapCtorString = Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = __WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */];

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((__WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_0__DataView_js__["a" /* default */](new ArrayBuffer(1))) != dataViewTag) ||
    (__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */]) != mapTag) ||
    (__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */] && getTag(__WEBPACK_IMPORTED_MODULE_2__Promise_js__["a" /* default */].resolve()) != promiseTag) ||
    (__WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_3__Set_js__["a" /* default */]) != setTag) ||
    (__WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */] && getTag(new __WEBPACK_IMPORTED_MODULE_4__WeakMap_js__["a" /* default */]) != weakMapTag)) {
  getTag = function(value) {
    var result = Object(__WEBPACK_IMPORTED_MODULE_5__baseGetTag_js__["a" /* default */])(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? Object(__WEBPACK_IMPORTED_MODULE_6__toSource_js__["a" /* default */])(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getTag);


/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(359);



var customizer = function customizer(objectValue, otherValue, indexOrkey, object, other, stack) {
  // https://lodash.com/docs/4.17.4#isEqualWith
  if (stack) {
    // Shallow compares
    // For 1st level, stack === undefined.
    //   -> Do nothing (and implicitly return undefined so that it goes to compare 2nd level)
    // For 2nd level and up, stack !== undefined.
    //   -> Compare by === operator
    return objectValue === otherValue;
  }
};

var shallowCompare = function shallowCompare(instance, nextProps, nextState) {
  var propsEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.props, nextProps, customizer);
  var stateEqual = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(instance.state, nextState, customizer);

  return !propsEqual || !stateEqual;
};

/* harmony default export */ __webpack_exports__["a"] = (shallowCompare);

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);


var defineProperty = (function() {
  try {
    var func = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (defineProperty);


/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__ = __webpack_require__(760);


/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = Object(__WEBPACK_IMPORTED_MODULE_0__createBaseFor_js__["a" /* default */])();

/* harmony default export */ __webpack_exports__["a"] = (baseFor);


/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(81);


/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isStrictComparable);


/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

/* harmony default export */ __webpack_exports__["a"] = (matchesStrictComparable);


/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toKey_js__ = __webpack_require__(132);



/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[Object(__WEBPACK_IMPORTED_MODULE_1__toKey_js__["a" /* default */])(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (baseGet);


/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isKey_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__stringToPath_js__ = __webpack_require__(356);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toString_js__ = __webpack_require__(358);





/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isArray_js__["a" /* default */])(value)) {
    return value;
  }
  return Object(__WEBPACK_IMPORTED_MODULE_1__isKey_js__["a" /* default */])(value, object) ? [value] : Object(__WEBPACK_IMPORTED_MODULE_2__stringToPath_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toString_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (castPath);


/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsPristine = function createIsPristine(_ref) {
  var deepEqual = _ref.deepEqual,
      empty = _ref.empty,
      getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      var formState = nonNullGetFormState(state);
      if (fields && fields.length) {
        return fields.every(function (field) {
          var fieldInitial = getIn(formState, form + '.initial.' + field);
          var fieldValue = getIn(formState, form + '.values.' + field);
          return deepEqual(fieldInitial, fieldValue);
        });
      }
      var initial = getIn(formState, form + '.initial') || empty;
      var values = getIn(formState, form + '.values') || initial;
      return deepEqual(initial, values);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsPristine);

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(131);



/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(object[key], value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignMergeValue);


/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (safeGet);


/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__ = __webpack_require__(362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__ = __webpack_require__(133);




/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isArrayLike_js__["a" /* default */])(object) ? Object(__WEBPACK_IMPORTED_MODULE_0__arrayLikeKeys_js__["a" /* default */])(object, true) : Object(__WEBPACK_IMPORTED_MODULE_1__baseKeysIn_js__["a" /* default */])(object);
}

/* harmony default export */ __webpack_exports__["a"] = (keysIn);


/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(352);


var silenceEvent = function silenceEvent(event) {
  var is = Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event);
  if (is) {
    event.preventDefault();
  }
  return is;
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvent);

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__createBreakpoints__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createMixins__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createPalette__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__createTypography__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shadows__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shape__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__createSpacing__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__zIndex__ = __webpack_require__(384);














function createMuiTheme() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$breakpoints = options.breakpoints,
      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
      _options$mixins = options.mixins,
      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
      _options$palette = options.palette,
      paletteInput = _options$palette === void 0 ? {} : _options$palette,
      shadowsInput = options.shadows,
      spacingInput = options.spacing,
      _options$typography = options.typography,
      typographyInput = _options$typography === void 0 ? {} : _options$typography,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["breakpoints", "mixins", "palette", "shadows", "spacing", "typography"]);

  var palette = Object(__WEBPACK_IMPORTED_MODULE_6__createPalette__["a" /* default */])(paletteInput);
  var breakpoints = Object(__WEBPACK_IMPORTED_MODULE_4__createBreakpoints__["a" /* default */])(breakpointsInput);
  var spacing = Object(__WEBPACK_IMPORTED_MODULE_10__createSpacing__["a" /* default */])(spacingInput);

  var muiTheme = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    breakpoints: breakpoints,
    direction: 'ltr',
    mixins: Object(__WEBPACK_IMPORTED_MODULE_5__createMixins__["a" /* default */])(breakpoints, spacing, mixinsInput),
    overrides: {},
    // Inject custom styles
    palette: palette,
    props: {},
    // Inject custom props
    shadows: shadowsInput || __WEBPACK_IMPORTED_MODULE_8__shadows__["a" /* default */],
    typography: Object(__WEBPACK_IMPORTED_MODULE_7__createTypography__["a" /* default */])(palette, typographyInput),
    spacing: spacing
  }, Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_utils__["a" /* deepmerge */])({
    shape: __WEBPACK_IMPORTED_MODULE_9__shape__["a" /* default */],
    transitions: __WEBPACK_IMPORTED_MODULE_11__transitions__["a" /* default */],
    zIndex: __WEBPACK_IMPORTED_MODULE_12__zIndex__["a" /* default */]
  }, other));

  if (false) {
    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];

    var traverse = function traverse(node, parentKey) {
      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax

      for (key in node) {
        var child = node[key];

        if (depth === 1) {
          if (key.indexOf('Mui') === 0 && child) {
            traverse(child, key, depth + 1);
          }
        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
          if (process.env.NODE_ENV !== 'production') {
            console.error(["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
              root: _defineProperty({}, "&$".concat(key), child)
            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
          } // Remove the style to prevent global conflicts.


          node[key] = {};
        }
      }
    };

    traverse(muiTheme.overrides);
  }

  return muiTheme;
}

/* harmony default export */ __webpack_exports__["a"] = (createMuiTheme);

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return keys; });
/* harmony export (immutable) */ __webpack_exports__["a"] = createBreakpoints;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);


// Sorted ASC by size. That's important.
// It can't be configured as it's used statically for propTypes.
var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.

function createBreakpoints(breakpoints) {
  var _breakpoints$values = breakpoints.values,
      values = _breakpoints$values === void 0 ? {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1920
  } : _breakpoints$values,
      _breakpoints$unit = breakpoints.unit,
      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
      _breakpoints$step = breakpoints.step,
      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(breakpoints, ["values", "unit", "step"]);

  function up(key) {
    var value = typeof values[key] === 'number' ? values[key] : key;
    return "@media (min-width:".concat(value).concat(unit, ")");
  }

  function down(key) {
    var endIndex = keys.indexOf(key) + 1;
    var upperbound = values[keys[endIndex]];

    if (endIndex === keys.length) {
      // xl down applies to all sizes
      return up('xs');
    }

    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
  }

  function between(start, end) {
    var endIndex = keys.indexOf(end) + 1;

    if (endIndex === keys.length) {
      return up(start);
    }

    return "@media (min-width:".concat(values[start]).concat(unit, ") and ") + "(max-width:".concat(values[keys[endIndex]] - step / 100).concat(unit, ")");
  }

  function only(key) {
    return between(key, key);
  }

  function width(key) {
    return values[key];
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    keys: keys,
    values: values,
    up: up,
    down: down,
    between: between,
    only: only,
    width: width
  }, other);
}

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var common = {
  black: '#000',
  white: '#fff'
};
/* harmony default export */ __webpack_exports__["a"] = (common);

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#d5d5d5',
  A200: '#aaaaaa',
  A400: '#303030',
  A700: '#616161'
};
/* harmony default export */ __webpack_exports__["a"] = (grey);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var indigo = {
  50: '#e8eaf6',
  100: '#c5cae9',
  200: '#9fa8da',
  300: '#7986cb',
  400: '#5c6bc0',
  500: '#3f51b5',
  600: '#3949ab',
  700: '#303f9f',
  800: '#283593',
  900: '#1a237e',
  A100: '#8c9eff',
  A200: '#536dfe',
  A400: '#3d5afe',
  A700: '#304ffe'
};
/* harmony default export */ __webpack_exports__["a"] = (indigo);

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var pink = {
  50: '#fce4ec',
  100: '#f8bbd0',
  200: '#f48fb1',
  300: '#f06292',
  400: '#ec407a',
  500: '#e91e63',
  600: '#d81b60',
  700: '#c2185b',
  800: '#ad1457',
  900: '#880e4f',
  A100: '#ff80ab',
  A200: '#ff4081',
  A400: '#f50057',
  A700: '#c51162'
};
/* harmony default export */ __webpack_exports__["a"] = (pink);

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
/* harmony default export */ __webpack_exports__["a"] = (red);

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We need to centralize the zIndex definitions as they work
// like global values in the browser.
var zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
/* harmony default export */ __webpack_exports__["a"] = (zIndex);

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
/* harmony default export */ __webpack_exports__["a"] = (hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__');

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getThemeProps__ = __webpack_require__(877);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getThemeProps__["a"]; });


/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jssPreset__ = __webpack_require__(878);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__jssPreset__["a"]; });


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBrowser */
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;

/* harmony default export */ __webpack_exports__["a"] = (isBrowser);


/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArray;
function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mergeClasses__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__mergeClasses__["a"]; });


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

var ThemeContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext(null);
/* harmony default export */ __webpack_exports__["a"] = (ThemeContext);

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export sheetsManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return StylesContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jssPreset__ = __webpack_require__(387);







 // Default JSS instance.

var jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])(Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])()); // Use a singleton or the provided one by the context.
//
// The counter-based approach doesn't tolerate any mistake.
// It's much safer to use the same counter everywhere.

var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_5__createGenerateClassName__["a" /* default */])(); // Exported for test purposes

var sheetsManager = new Map();
var defaultOptions = {
  disableGeneration: false,
  generateClassName: generateClassName,
  jss: jss,
  sheetsCache: null,
  sheetsManager: sheetsManager,
  sheetsRegistry: null
};
var StylesContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createContext(defaultOptions);
var injectFirstNode;

function StylesProvider(props) {
  var children = props.children,
      _props$injectFirst = props.injectFirst,
      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
      _props$disableGenerat = props.disableGeneration,
      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
      localOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "injectFirst", "disableGeneration"]);

  var outerOptions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(StylesContext);

  var context = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerOptions, {
    disableGeneration: disableGeneration
  }, localOptions);

  if (false) {
    if (typeof window === 'undefined' && !context.sheetsManager) {
      console.error('Material-UI: you need to use the ServerStyleSheets API when rendering on the server.');
    }
  }

  if (false) {
    if (context.jss.options.insertionPoint && injectFirst) {
      console.error('Material-UI: you cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
    }
  }

  if (false) {
    if (injectFirst && localOptions.jss) {
      console.error('Material-UI: you cannot use the jss and injectFirst props at the same time.');
    }
  }

  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
    if (!injectFirstNode) {
      var head = document.head;
      injectFirstNode = document.createComment('mui-inject-first');
      head.insertBefore(injectFirstNode, head.firstChild);
    }

    context.jss = Object(__WEBPACK_IMPORTED_MODULE_6_jss__["c" /* create */])({
      plugins: Object(__WEBPACK_IMPORTED_MODULE_7__jssPreset__["a" /* default */])().plugins,
      insertionPoint: injectFirstNode
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StylesContext.Provider, {
    value: context
  }, children);
}

 false ? StylesProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * You can disable the generation of the styles with this option.
   * It can be useful when traversing the React tree outside of the HTML
   * rendering step on the server.
   * Let's say you are using react-apollo to extract all
   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
   */
  disableGeneration: PropTypes.bool,

  /**
   * JSS's class name generator.
   */
  generateClassName: PropTypes.func,

  /**
   * By default, the styles are injected last in the <head> element of the page.
   * As a result, they gain more specificity than any other style sheet.
   * If you want to override Material-UI's styles, set this prop.
   */
  injectFirst: PropTypes.bool,

  /**
   * JSS's instance.
   */
  jss: PropTypes.object,

  /**
   * @ignore
   */
  serverGenerateClassName: PropTypes.func,

  /**
   * @ignore
   *
   * Beta feature.
   *
   * Cache for the sheets.
   */
  sheetsCache: PropTypes.object,

  /**
   * @ignore
   *
   * The sheetsManager is used to deduplicate style sheet injection in the page.
   * It's deduplicating using the (theme, styles) couple.
   * On the server, you should provide a new instance for each request.
   */
  sheetsManager: PropTypes.object,

  /**
   * @ignore
   *
   * Collect the sheets.
   */
  sheetsRegistry: PropTypes.object
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = exactProp(StylesProvider.propTypes) : void 0;
}

/* harmony default export */ __webpack_exports__["b"] = (StylesProvider);

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// We use the same empty object to ref count the styles that don't need a theme object.
var noopTheme = {};
/* harmony default export */ __webpack_exports__["a"] = (noopTheme);

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = withThemeCreator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(134);







function withThemeCreator() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultTheme = options.defaultTheme;

  var withTheme = function withTheme(Component) {
    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var WithTheme = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithTheme(props, ref) {
      var innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["innerRef"]);

      var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: theme,
        ref: innerRef || ref
      }, other));
    });
     false ? WithTheme.propTypes = {
      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return new Error('Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
      })
    } : void 0;

    if (false) {
      WithTheme.displayName = "WithTheme(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component);

    if (false) {
      // Exposed for test purposes.
      WithTheme.Naked = Component;
    }

    return WithTheme;
  };

  return withTheme;
} // Provide the theme object as a prop to the input component.
// It's an alternative API to useTheme().
// We encourage the usage of useTheme() where possible.

var withTheme = withThemeCreator();
/* unused harmony default export */ var _unused_webpack_default_export = (withTheme);

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(135);




function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["d" /* makeStyles */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
  }, options));
}

/* harmony default export */ __webpack_exports__["a"] = (makeStyles);

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultTheme__ = __webpack_require__(135);




var styled = function styled(Component) {
  var componentCreator = Object(__WEBPACK_IMPORTED_MODULE_1__material_ui_styles__["f" /* styled */])(Component);
  return function (style, options) {
    return componentCreator(style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: __WEBPACK_IMPORTED_MODULE_2__defaultTheme__["a" /* default */]
    }, options));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (styled);

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  disabled: false
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export timeoutsShape */
/* unused harmony export classNamesShape */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var timeoutsShape =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
  enter: PropTypes.number,
  exit: PropTypes.number,
  appear: PropTypes.number
}).isRequired]) : null;
var classNamesShape =  false ? PropTypes.oneOfType([PropTypes.string, PropTypes.shape({
  enter: PropTypes.string,
  exit: PropTypes.string,
  active: PropTypes.string
}), PropTypes.shape({
  enter: PropTypes.string,
  enterDone: PropTypes.string,
  enterActive: PropTypes.string,
  exit: PropTypes.string,
  exitDone: PropTypes.string,
  exitActive: PropTypes.string
})]) : null;

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__ = __webpack_require__(254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__ = __webpack_require__(939);









var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
  /**
   * The `<TransitionGroup>` component manages a set of transition components
   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
   * components, `<TransitionGroup>` is a state machine for managing the mounting
   * and unmounting of components over time.
   *
   * Consider the example below. As items are removed or added to the TodoList the
   * `in` prop is toggled automatically by the `<TransitionGroup>`.
   *
   * Note that `<TransitionGroup>`  does not define any animation behavior!
   * Exactly _how_ a list item animates is up to the individual transition
   * component. This means you can mix and match animations across different list
   * items.
   */

};

var TransitionGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this))); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["b" /* getInitialChildMapping */])(nextProps, handleExited) : Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["c" /* getNextChildMapping */])(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  };

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = Object(__WEBPACK_IMPORTED_MODULE_7__utils_ChildMapping__["a" /* getChildMapping */])(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
        value: contextValue
      }, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TransitionGroupContext__["a" /* default */].Provider, {
      value: contextValue
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, props, children));
  };

  return TransitionGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TransitionGroup.propTypes =  false ? {
  /**
   * `<TransitionGroup>` renders a `<div>` by default. You can change this
   * behavior by providing a `component` prop.
   * If you use React v16+ and would like to avoid a wrapping `<div>` element
   * you can pass in `component={null}`. This is useful if the wrapping div
   * borks your css styles.
   */
  component: PropTypes.any,

  /**
   * A set of `<Transition>` components, that are toggled `in` and out as they
   * leave. the `<TransitionGroup>` will inject specific transition props, so
   * remember to spread them through if you are wrapping the `<Transition>` as
   * with our `<Fade>` example.
   *
   * While this component is meant for multiple `Transition` or `CSSTransition`
   * children, sometimes you may want to have a single transition child with
   * content that you want to be transitioned out and in when you change it
   * (e.g. routes, images etc.) In that case you can change the `key` prop of
   * the transition child as you change its content, this will cause
   * `TransitionGroup` to transition the child out and back in.
   */
  children: PropTypes.node,

  /**
   * A convenience prop that enables or disables appear animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  appear: PropTypes.bool,

  /**
   * A convenience prop that enables or disables enter animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  enter: PropTypes.bool,

  /**
   * A convenience prop that enables or disables exit animations
   * for all children. Note that specifying this will override any defaults set
   * on individual children Transitions.
   */
  exit: PropTypes.bool,

  /**
   * You may need to apply reactive updates to a child as it is exiting.
   * This is generally done by using `cloneElement` however in the case of an exiting
   * child the element has already been removed and not accessible to the consumer.
   *
   * If you do need to update a child as it leaves you can provide a `childFactory`
   * to wrap every child, even the ones that are leaving.
   *
   * @type Function(child: ReactElement) -> ReactElement
   */
  childFactory: PropTypes.func
} : {};
TransitionGroup.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (TransitionGroup);

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export border */
/* unused harmony export borderTop */
/* unused harmony export borderRight */
/* unused harmony export borderBottom */
/* unused harmony export borderLeft */
/* unused harmony export borderColor */
/* unused harmony export borderRadius */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);



function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return "".concat(value, "px solid");
}

var border = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
var borderTop = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
var borderRight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
var borderBottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
var borderLeft = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
var borderColor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderColor',
  themeKey: 'palette'
});
var borderRadius = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'borderRadius',
  themeKey: 'shape'
});
var borders = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
/* harmony default export */ __webpack_exports__["a"] = (borders);

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var responsivePropType =  false ? PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.object, PropTypes.array]) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (responsivePropType);

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export flexBasis */
/* unused harmony export flexDirection */
/* unused harmony export flexWrap */
/* unused harmony export justifyContent */
/* unused harmony export alignItems */
/* unused harmony export alignContent */
/* unused harmony export order */
/* unused harmony export flex */
/* unused harmony export flexGrow */
/* unused harmony export flexShrink */
/* unused harmony export alignSelf */
/* unused harmony export justifyItems */
/* unused harmony export justifySelf */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);


var flexBasis = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexBasis'
});
var flexDirection = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexDirection'
});
var flexWrap = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexWrap'
});
var justifyContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyContent'
});
var alignItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignItems'
});
var alignContent = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignContent'
});
var order = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'order'
});
var flex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flex'
});
var flexGrow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexGrow'
});
var flexShrink = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'flexShrink'
});
var alignSelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'alignSelf'
});
var justifyItems = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifyItems'
});
var justifySelf = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'justifySelf'
});
var flexbox = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
/* harmony default export */ __webpack_exports__["a"] = (flexbox);

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export color */
/* unused harmony export bgcolor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);


var color = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'color',
  themeKey: 'palette'
});
var bgcolor = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
var palette = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(color, bgcolor);
/* harmony default export */ __webpack_exports__["a"] = (palette);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export position */
/* unused harmony export zIndex */
/* unused harmony export top */
/* unused harmony export right */
/* unused harmony export bottom */
/* unused harmony export left */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);


var position = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'position'
});
var zIndex = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
var top = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'top'
});
var right = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'right'
});
var bottom = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'bottom'
});
var left = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'left'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(position, zIndex, top, right, bottom, left));

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export width */
/* unused harmony export maxWidth */
/* unused harmony export minWidth */
/* unused harmony export height */
/* unused harmony export maxHeight */
/* unused harmony export minHeight */
/* unused harmony export sizeWidth */
/* unused harmony export sizeHeight */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);



function transform(value) {
  return value <= 1 ? "".concat(value * 100, "%") : value;
}

var width = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'width',
  transform: transform
});
var maxWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxWidth',
  transform: transform
});
var minWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minWidth',
  transform: transform
});
var height = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'height',
  transform: transform
});
var maxHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'maxHeight',
  transform: transform
});
var minHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'minHeight',
  transform: transform
});
var sizeWidth = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'width',
  transform: transform
});
var sizeHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'size',
  cssProperty: 'height',
  transform: transform
});
var sizing = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(width, maxWidth, minWidth, height, maxHeight, minHeight);
/* harmony default export */ __webpack_exports__["a"] = (sizing);

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _slicedToArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(408);



function _slicedToArray(arr, i) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArrayLimit__["a" /* default */])(arr, i) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithHoles;
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableRest;
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fontFamily */
/* unused harmony export fontSize */
/* unused harmony export fontStyle */
/* unused harmony export fontWeight */
/* unused harmony export letterSpacing */
/* unused harmony export lineHeight */
/* unused harmony export textAlign */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);


var fontFamily = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontFamily',
  themeKey: 'typography'
});
var fontSize = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontSize',
  themeKey: 'typography'
});
var fontStyle = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontStyle',
  themeKey: 'typography'
});
var fontWeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'fontWeight',
  themeKey: 'typography'
});
var letterSpacing = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'letterSpacing'
});
var lineHeight = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'lineHeight'
});
var textAlign = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textAlign'
});
var typography = Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
/* harmony default export */ __webpack_exports__["a"] = (typography);

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Button__ = __webpack_require__(967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Button__["a"]; });


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Checkbox__ = __webpack_require__(982);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Checkbox__["a"]; });


/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Chip__ = __webpack_require__(987);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Chip__["a"]; });


/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__ = __webpack_require__(991);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ClickAwayListener__["a"]; });


/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ariaHidden;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ModalManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__ = __webpack_require__(139);





 // Is a vertical scrollbar displayed?

function isOverflowing(container) {
  var doc = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container);

  if (doc.body === container) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerWindow__["a" /* default */])(doc).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(node, show) {
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(node) {
  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
}

function ariaHiddenSiblings(container, mountNode, currentNode) {
  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
  var show = arguments.length > 4 ? arguments[4] : undefined;
  var blacklist = [mountNode, currentNode].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(nodesToExclude));
  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, function (node) {
    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
      ariaHidden(node, show);
    }
  });
}

function findIndexOf(containerInfo, callback) {
  var idx = -1;
  containerInfo.some(function (item, index) {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  var restoreStyle = [];
  var restorePaddings = [];
  var container = containerInfo.container;
  var fixedNodes;

  if (!props.disableScrollLock) {
    var overflowing = isOverflowing(container); // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/

    var parent = container.parentElement;
    var scrollContainer = parent.nodeName === 'HTML' ? parent : container;
    restoreStyle.push({
      value: scrollContainer.style.overflow,
      key: 'overflow',
      el: scrollContainer
    }); // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    scrollContainer.style.overflow = 'hidden';

    if (overflowing) {
      var scrollbarSize = Object(__WEBPACK_IMPORTED_MODULE_3__utils_getScrollbarSize__["a" /* default */])();
      restoreStyle.push({
        value: container.style.paddingRight,
        key: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.

      fixedNodes = Object(__WEBPACK_IMPORTED_MODULE_4__utils_ownerDocument__["a" /* default */])(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedNodes, function (node) {
        restorePaddings.push(node.style.paddingRight);
        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
      });
    }
  }

  var restore = function restore() {
    if (fixedNodes) {
      [].forEach.call(fixedNodes, function (node, i) {
        if (restorePaddings[i]) {
          node.style.paddingRight = restorePaddings[i];
        } else {
          node.style.removeProperty('padding-right');
        }
      });
    }

    restoreStyle.forEach(function (_ref) {
      var value = _ref.value,
          el = _ref.el,
          key = _ref.key;

      if (value) {
        el.style.setProperty(key, value);
      } else {
        el.style.removeProperty(key);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  var hiddenSiblings = [];
  [].forEach.call(container.children, function (node) {
    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(node);
    }
  });
  return hiddenSiblings;
}
/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */


var ModalManager =
/*#__PURE__*/
function () {
  function ModalManager() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ModalManager);

    // this.modals[modalIndex] = modal
    this.modals = []; // this.containers[containerIndex] = {
    //   modals: [],
    //   container,
    //   restore: null,
    // }

    this.containers = [];
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(ModalManager, [{
    key: "add",
    value: function add(modal, container) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex !== -1) {
        return modalIndex;
      }

      modalIndex = this.modals.length;
      this.modals.push(modal); // If the modal we are adding is already in the DOM.

      if (modal.modalRef) {
        ariaHidden(modal.modalRef, false);
      }

      var hiddenSiblingNodes = getHiddenSiblings(container);
      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.container === container;
      });

      if (containerIndex !== -1) {
        this.containers[containerIndex].modals.push(modal);
        return modalIndex;
      }

      this.containers.push({
        modals: [modal],
        container: container,
        restore: null,
        hiddenSiblingNodes: hiddenSiblingNodes
      });
      return modalIndex;
    }
  }, {
    key: "mount",
    value: function mount(modal, props) {
      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];

      if (!containerInfo.restore) {
        containerInfo.restore = handleContainer(containerInfo, props);
      }
    }
  }, {
    key: "remove",
    value: function remove(modal) {
      var modalIndex = this.modals.indexOf(modal);

      if (modalIndex === -1) {
        return modalIndex;
      }

      var containerIndex = findIndexOf(this.containers, function (item) {
        return item.modals.indexOf(modal) !== -1;
      });
      var containerInfo = this.containers[containerIndex];
      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

      if (containerInfo.modals.length === 0) {
        // The modal might be closed before it had the chance to be mounted in the DOM.
        if (containerInfo.restore) {
          containerInfo.restore();
        }

        if (modal.modalRef) {
          // In case the modal wasn't in the DOM yet.
          ariaHidden(modal.modalRef, true);
        }

        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
        this.containers.splice(containerIndex, 1);
      } else {
        // Otherwise make sure the next top modal is visible to a screen reader.
        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
        // aria-hidden because the dom element doesn't exist either
        // when modal was unmounted before modalRef gets null

        if (nextTop.modalRef) {
          ariaHidden(nextTop.modalRef, false);
        }
      }

      return modalIndex;
    }
  }, {
    key: "isTopModal",
    value: function isTopModal(modal) {
      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
    }
  }]);

  return ModalManager;
}();



/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
function getScrollbarSize() {
  var scrollDiv = document.createElement('div');
  scrollDiv.style.width = '99px';
  scrollDiv.style.height = '99px';
  scrollDiv.style.position = 'absolute';
  scrollDiv.style.top = '-9999px';
  scrollDiv.style.overflow = 'scroll';
  document.body.appendChild(scrollDiv);
  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
  document.body.removeChild(scrollDiv);
  return scrollbarSize;
}

/* harmony default export */ __webpack_exports__["a"] = (getScrollbarSize);

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slide__ = __webpack_require__(1014);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Slide__["a"]; });


/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
 */

var ExpansionPanelContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({});
/* harmony default export */ __webpack_exports__["a"] = (ExpansionPanelContext);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__ = __webpack_require__(1027);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TextareaAutosize__["a"]; });


/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormGroup__ = __webpack_require__(1031);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormGroup__["a"]; });


/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormHelperText__ = __webpack_require__(1032);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormHelperText__["a"]; });


/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormLabel__ = __webpack_require__(1033);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormLabel__["a"]; });


/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function requirePropFactory(componentNameInError) {
  if (true) {
    return function () {
      return null;
    };
  }

  var requireProp = function requireProp(requiredProp) {
    return function (props, propName, componentName, location, propFullName) {
      var propFullNameSafe = propFullName || propName;

      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
      }

      return null;
    };
  };

  return requireProp;
}

/* unused harmony default export */ var _unused_webpack_default_export = (requirePropFactory);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isWidthUp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isWidthDown; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__useMediaQuery__ = __webpack_require__(424);










 // By default, returns true if screen width is the same or greater than the given breakpoint.

var isWidthUp = function isWidthUp(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) <= __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(width);
  }

  return __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint) < __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(width);
}; // By default, returns true if screen width is the same or less than the given breakpoint.

var isWidthDown = function isWidthDown(breakpoint, width) {
  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  if (inclusive) {
    return __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(width) <= __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
  }

  return __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(width) < __WEBPACK_IMPORTED_MODULE_9__styles_createBreakpoints__["b" /* keys */].indexOf(breakpoint);
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect : __WEBPACK_IMPORTED_MODULE_3_react___default.a.useLayoutEffect;

var withWidth = function withWidth() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$withTheme = options.withTheme,
        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
        _options$noSSR = options.noSSR,
        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
        initialWidthOption = options.initialWidth;

    function WithWidth(props) {
      var contextTheme = Object(__WEBPACK_IMPORTED_MODULE_8__styles_useTheme__["a" /* default */])();
      var theme = props.theme || contextTheme;

      var _getThemeProps = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_styles__["c" /* getThemeProps */])({
        theme: theme,
        name: 'MuiWithWidth',
        props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props)
      }),
          initialWidth = _getThemeProps.initialWidth,
          width = _getThemeProps.width,
          other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_getThemeProps, ["initialWidth", "width"]);

      var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(false),
          mountedState = _React$useState[0],
          setMountedState = _React$useState[1];

      useEnhancedEffect(function () {
        setMountedState(true);
      }, []);
      /**
       * innerWidth |xs      sm      md      lg      xl
       *            |-------|-------|-------|-------|------>
       * width      |  xs   |  sm   |  md   |  lg   |  xl
       */

      var keys = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(theme.breakpoints.keys).reverse();

      var widthComputed = keys.reduce(function (output, key) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        var matches = Object(__WEBPACK_IMPORTED_MODULE_10__useMediaQuery__["a" /* default */])(theme.breakpoints.up(key));
        return !output && matches ? key : output;
      }, null);

      var more = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
      }, withThemeOption ? {
        theme: theme
      } : {}, {}, other); // When rendering the component on the server,
      // we have no idea about the client browser screen width.
      // In order to prevent blinks and help the reconciliation of the React tree
      // we are not rendering the child component.
      //
      // An alternative is to use the `initialWidth` property.


      if (more.width === undefined) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, more);
    }

     false ? WithWidth.propTypes = {
      /**
       * As `window.innerWidth` is unavailable on the server,
       * we default to rendering an empty component during the first mount.
       * You might want to use an heuristic to approximate
       * the screen width of the client browser screen width.
       *
       * For instance, you could be using the user-agent or the client-hints.
       * https://caniuse.com/#search=client%20hint
       */
      initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

      /**
       * @ignore
       */
      theme: PropTypes.object,

      /**
       * Bypass the width calculation logic.
       */
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
    } : void 0;

    if (false) {
      WithWidth.displayName = "WithWidth(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_7_hoist_non_react_statics___default()(WithWidth, Component);
    return WithWidth;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withWidth);

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__ = __webpack_require__(1047);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useMediaQuery__["a"]; });


/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputLabel__ = __webpack_require__(1054);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputLabel__["a"]; });


/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__LinearProgress__ = __webpack_require__(1055);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__LinearProgress__["a"]; });


/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(1058);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });


/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItem__ = __webpack_require__(1059);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItem__["a"]; });


/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListSubheader__ = __webpack_require__(1068);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListSubheader__["a"]; });


/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Popover__ = __webpack_require__(431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__MenuList__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_useTheme__ = __webpack_require__(32);











var RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
var LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};
var styles = {
  /* Styles applied to the `Paper` component. */
  paper: {
    // specZ: The maximum height of a simple menu should be one or more rows less than the view
    // height. This ensures a tapable area outside of the simple menu with which to dismiss
    // the menu.
    maxHeight: 'calc(100% - 96px)',
    // Add iOS momentum scrolling.
    WebkitOverflowScrolling: 'touch'
  },

  /* Styles applied to the `List` component via `MenuList`. */
  list: {
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Menu = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Menu(props, ref) {
  var _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      _props$disableAutoFoc = props.disableAutoFocusItem,
      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$MenuListProps = props.MenuListProps,
      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
      onClose = props.onClose,
      onEntering = props.onEntering,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      PopoverClasses = props.PopoverClasses,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_10__styles_useTheme__["a" /* default */])();
  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  var menuListActionsRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var contentAnchorRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var getContentAnchorEl = function getContentAnchorEl() {
    return contentAnchorRef.current;
  };

  var handleEntering = function handleEntering(element, isAppearing) {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  var handleListKeyDown = function handleListKeyDown(event) {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant !== "menu" && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
        ref: function ref(instance) {
          // #StrictMode ready
          contentAnchorRef.current = __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.findDOMNode(instance);
          Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(child.ref, instance);
        }
      });
    }

    return child;
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Popover__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    getContentAnchorEl: getContentAnchorEl,
    classes: PopoverClasses,
    onClose: onClose,
    onEntering: handleEntering,
    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    open: open,
    ref: ref,
    transitionDuration: transitionDuration
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__MenuList__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onKeyDown: handleListKeyDown,
    actions: menuListActionsRef,
    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
    autoFocusItem: autoFocusItem,
    variant: variant
  }, MenuListProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.list, MenuListProps.className)
  }), items));
});
 false ? Menu.propTypes = {
  /**
   * The DOM element used to set the position of the menu.
   */
  anchorEl: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
   * children are not focusable. If you set this prop to `false` focus will be placed
   * on the parent modal container. This has severe accessibility implications
   * and should only be considered if you manage focus otherwise.
   */
  autoFocus: PropTypes.bool,

  /**
   * Menu contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * When opening the menu will not focus the active item but the `[role="menu"]`
   * unless `autoFocus` is also set to `false`. Not using the default means not
   * following WAI-ARIA authoring practices. Please be considerate about possible
   * accessibility implications.
   */
  disableAutoFocusItem: PropTypes.bool,

  /**
   * Props applied to the [`MenuList`](/api/menu-list/) element.
   */
  MenuListProps: PropTypes.object,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the Menu enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the Menu has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the Menu is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the Menu exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the Menu has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the Menu is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the menu is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.object,

  /**
   * `classes` prop applied to the [`Popover`](/api/popover/) element.
   */
  PopoverClasses: PropTypes.object,

  /**
   * The length of the transition in `ms`, or 'auto'
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  }), PropTypes.oneOf(['auto'])]),

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenu'
})(Menu));

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Popover__ = __webpack_require__(1070);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Popover__["a"]; });


/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuList__ = __webpack_require__(1071);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuList__["a"]; });


/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MenuItem__ = __webpack_require__(1072);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MenuItem__["a"]; });


/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return styles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Input__ = __webpack_require__(181);










var styles = function styles(theme) {
  return {
    /* Styles applied to the select component `root` class. */
    root: {},

    /* Styles applied to the select component `select` class. */
    select: {
      '-moz-appearance': 'none',
      // Reset
      '-webkit-appearance': 'none',
      // Reset
      // When interacting quickly, the text can end up selected.
      // Native select can't be selected either.
      userSelect: 'none',
      borderRadius: 0,
      // Reset
      minWidth: 16,
      // So it doesn't collapse.
      cursor: 'pointer',
      '&:focus': {
        // Show that it's not an text input
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
        borderRadius: 0 // Reset Chrome style

      },
      // Remove IE 11 arrow
      '&::-ms-expand': {
        display: 'none'
      },
      '&$disabled': {
        cursor: 'default'
      },
      '&[multiple]': {
        height: 'auto'
      },
      '&:not([multiple]) option, &:not([multiple]) optgroup': {
        backgroundColor: theme.palette.background.paper
      }
    },

    /* Styles applied to the select component if `variant="filled"`. */
    filled: {},

    /* Styles applied to the select component if `variant="outlined"`. */
    outlined: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the select component `selectMenu` class. */
    selectMenu: {
      height: 'auto',
      // Reset
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden'
    },

    /* Pseudo-class applied to the select component `disabled` class. */
    disabled: {},

    /* Styles applied to the icon component. */
    icon: {
      // We use a position absolute over a flexbox in order to forward the pointer events
      // to the input.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 12px)',
      // Center vertically
      color: theme.palette.action.active,
      pointerEvents: 'none' // Don't block pointer events on the select under the icon.

    },

    /* Styles applied to the icon component if the popup is open. */
    iconOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the icon component if `variant="filled"`. */
    iconFilled: {
      right: 7
    },

    /* Styles applied to the icon component if `variant="outlined"`. */
    iconOutlined: {
      right: 7
    }
  };
};
var defaultInput = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Input__["a" /* default */], null);
/**
 * An alternative to `<Select native />` with a much smaller bundle size footprint.
 */

var NativeSelect = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function NativeSelect(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      _props$input = props.input,
      input = _props$input === void 0 ? defaultInput : _props$input,
      inputProps = props.inputProps,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(input, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `NativeSelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: __WEBPACK_IMPORTED_MODULE_4__NativeSelectInput__["a" /* default */],
    select: true,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      classes: classes,
      IconComponent: IconComponent,
      variant: fcs.variant,
      type: undefined
    }, inputProps, {}, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? NativeSelect.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * Attributes applied to the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value. The DOM API casts this to a string.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
NativeSelect.muiName = 'Select';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiNativeSelect'
})(NativeSelect));

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







/**
 * @ignore - internal component.
 */

var NativeSelectInput = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function NativeSelectInput(props, ref) {
  var classes = props.classes,
      className = props.className,
      disabled = props.disabled,
      IconComponent = props.IconComponent,
      inputRef = props.inputRef,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("select", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes[variant], className, disabled && classes.disabled),
    disabled: disabled,
    ref: inputRef || ref
  }, other)), props.multiple ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(variant))])
  }));
});
 false ? NativeSelectInput.propTypes = {
  /**
   * The option elements to populate the select with.
   * Can be some `<option>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * Use that prop to pass a ref to the native select element.
   * @deprecated
   */
  inputRef: refType,

  /**
   * @ignore
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (NativeSelectInput);

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var RadioGroupContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["a"] = (RadioGroupContext);

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RadioGroup__ = __webpack_require__(1085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__RadioGroup__["a"]; });


/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__ = __webpack_require__(1099);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__SnackbarContent__["a"]; });


/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepLabel__ = __webpack_require__(1104);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepLabel__["a"]; });


/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepIcon__ = __webpack_require__(1105);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepIcon__["a"]; });


/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepConnector__ = __webpack_require__(1108);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__StepConnector__["a"]; });


/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Switch__ = __webpack_require__(1116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__Switch__["a"]; });


/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TableContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext();
/* harmony default export */ __webpack_exports__["a"] = (TableContext);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableCell__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableCell__["a"]; });


/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Toolbar__ = __webpack_require__(1130);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Toolbar__["a"]; });


/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
}), 'KeyboardArrowLeft'));

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
}), 'KeyboardArrowRight'));

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TextField__ = __webpack_require__(1144);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__TextField__["a"]; });


/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tooltip__ = __webpack_require__(1145);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tooltip__["a"]; });


/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Zoom__ = __webpack_require__(1150);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Zoom__["a"]; });


/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_AuthActions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_SvgIcon__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_VpnKey__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_VpnKey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_VpnKey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__LoginImageSelector__ = __webpack_require__(1255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_react_bootstrap__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_IconPicker_IconPicker__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { actionLoading } from "../../actions/AppActions";
// import {
//   actionSetCompleteRegistration,
//   actionLoginGoogle,
//   actionLoginFacebook
// } from "../../actions/LoginActions";
// import logo from "../../common/assets/logoCreek.png";
// import logo from "../../common/assets/logoHangover.png";
var _handleSubmitFail=void 0;var FacebookIcon=function FacebookIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_SvgIcon__["default"],props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1376 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-188v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-532q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z"}));};var GoogleIcon=function GoogleIcon(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_SvgIcon__["default"],props,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{d:"M1045 905q0-26-6-64h-362v132h217q-3 24-16.5 50t-37.5 53-66.5 44.5-96.5 17.5q-99 0-169-71t-70-171 70-171 169-71q92 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zm345 46h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zm274-535v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"}));};var styles={link:{color:"#1958b7"}};var loginMain=function(_Component){_inherits(loginMain,_Component);function loginMain(props){_classCallCheck(this,loginMain);var _this=_possibleConstructorReturn(this,(loginMain.__proto__||Object.getPrototypeOf(loginMain)).call(this,props));_this.state={state:"estado",error:""};_handleSubmitFail=__WEBPACK_IMPORTED_MODULE_17__common_Util__["e" /* handleSubmitFail */].bind(_this);_this.loginCallback=_this.loginCallback.bind(_this);// this.facebookPopup = this.facebookPopup.bind(this);
// this.googlePopup = this.googlePopup.bind(this);
//this.onPressRegisterUser = this.onPressRegisterUser.bind(this);
return _this;}_createClass(loginMain,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_14__config_RoutesConstants__["i" /* INDEX_ROUTE */]);}}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(nextProps.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_14__config_RoutesConstants__["i" /* INDEX_ROUTE */]);}}},{key:"onSubmit",value:function onSubmit(formValues){var _this2=this;var values=JSON.parse(JSON.stringify(formValues));this.props.actionLogin(values,function(){_this2.props.history.push(__WEBPACK_IMPORTED_MODULE_14__config_RoutesConstants__["i" /* INDEX_ROUTE */]);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_17__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_17__common_Util__["a" /* ERROR */],e.message);});}},{key:"loginCallback",value:function loginCallback(value){this.setState({loading:false});if(value){this.props.reset();this.setState({error:value});}else{this.props.history.push(__WEBPACK_IMPORTED_MODULE_14__config_RoutesConstants__["i" /* INDEX_ROUTE */]);}}// onRecoveryPassword = e => {
//   e.preventDefault();
//   this.props.history.push(PASSWORD_RECOVERY);
// };
// onPressRegisterUser() {
//   this.props.history.push(ADD_USER_ROUTE);
// }
// googlePopup() {
//   //this.props.actionLoading(true);
//   //this.props.actionSetCompleteRegistration(false);
//   this.props.actionLoginGoogle();
// }
// facebookPopup() {
//   //this.props.actionLoading(true);
//   //this.props.actionSetCompleteRegistration(false);
//   this.props.actionLoginFacebook();
// }
},{key:"render",value:function render(){var _props=this.props,handleSubmit=_props.handleSubmit,theme=_props.theme;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"screen-login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap__["a" /* Col */],{style:{flex:1,backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_12__LoginImageSelector__["a" /* default */]+")"},className:"bg-login columns-column-between imagen-fondo-login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15_react_bootstrap__["a" /* Col */],{xs:12,sm:12,md:8,mdOffset:2,className:"container-login top100"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["J" /* Paper */],{className:"paper-login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Iniciar Sesi\xF3n ","Hangover"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fields-login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Person___default.a,{style:{marginRight:10,color:"#ccc"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],className:"textField",name:"email",type:"text",fullWidth:true,hintText:"someone@example.com",label:"E-mail",floatingLabelFixed:true,validate:[__WEBPACK_IMPORTED_MODULE_11__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_11__common_Validations__["f" /* validateEmail */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"fields-login"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_VpnKey___default.a,{style:{marginRight:10,color:"#ccc"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_5_redux_form_material_ui__["TextField"],className:"textField",name:"password",type:"password",fullWidth:true,label:"Contrase\xF1a",floatingLabelFixed:true,validate:[__WEBPACK_IMPORTED_MODULE_11__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_11__common_Validations__["a" /* password */]]})),this.state.error!==""?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"text-center top20",style:{color:"red"}},this.state.error):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:handleSubmit(this.onSubmit.bind(this)),fullWidth:true,className:"top30",style:{height:40,marginTop:10}},"Ingresar"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)))));}}]);return loginMain;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(store){return{login:store.auth.login,rol:store.app.rol,username:store.app.username,active:store.app.activeFilters,loading:store.app.loading};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionLogin:__WEBPACK_IMPORTED_MODULE_6__actions_AuthActions__["b" /* actionLogin */]// actionLoading
},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_redux_form__["c" /* reduxForm */])({form:"loginMain",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(loginMain)))));

/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var mapError = function mapError(_ref) {
  var _ref$hasHelperText = _ref.hasHelperText,
      hasHelperText = _ref$hasHelperText === undefined ? true : _ref$hasHelperText,
      _ref$meta = _ref.meta;
  _ref$meta = _ref$meta === undefined ? {} : _ref$meta;

  var touched = _ref$meta.touched,
      error = _ref$meta.error,
      warning = _ref$meta.warning,
      input = _ref.input,
      props = _objectWithoutProperties(_ref, ["hasHelperText", "meta", "input"]);

  var errorProps = touched && (error || warning) ? _extends({}, props, input, {
    error: Boolean(error || warning)
  }) : _extends({}, input, props);

  if (touched && hasHelperText && (error || warning)) {
    errorProps.helperText = error || warning;
  }

  return errorProps;
};

exports.default = mapError;

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = actionVerifyLogin;
/* harmony export (immutable) */ __webpack_exports__["b"] = actionLogin;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionLogOut;
/* unused harmony export createAccount */
/* unused harmony export forgotPassword */
/* unused harmony export confirmPasswordReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__provider_user_UserService__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppActions__ = __webpack_require__(75);
function actionVerifyLogin(logOutCallback){return function(dispatch,getStore){__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].registerAuthStateListener(function(user){if(user){__WEBPACK_IMPORTED_MODULE_2__provider_user_UserService__["a" /* default */].getUsersByEmailOrDU(getStore().app.app,null,user.email).then(function(response){console.log("USERS",response);dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["b" /* ACT_AUTH_CHANGE */],props:{login:true,username:user.displayName,email:user.email,photo:user.photoURL,app:user.app&&user.app.length==1&&user.app[0]||"Nuevamente",//Agregar app al usuario
profile:response.users[0]}});});}else{dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["b" /* ACT_AUTH_CHANGE */],props:{login:false,username:null,email:null,photo:null,userId:null,app:null,profile:null}});logOutCallback();}});};}function actionLogin(user,successCalback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].login(user).then(function(res){// dispatch({
// 	type: ACT_APP_CHANGE,
// 	props: {
// 		login: true,
// 		username: res.name,
// 		email: res.displayName,
// 		photo: res.photoURL,
// 		app: res.app&&res.app.length==1&&res.app[0]||"Nuevamente" //Agregar app al usuario
// 	}
// });
successCalback(res.app);//Modificar callback para que permita seleccionar la app si hay mas de una
}).catch(errorCallback).finally(function(){return Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionLogOut(){return function(dispatch){__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].logout();};}function createAccount(user,successCalback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(dispatch,true);__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].createAccount(user).then(function(res){console.log("RESPONSE",res);dispatch({type:"CREATE_USER",props:res});successCalback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(dispatch,false);});};}function forgotPassword(email,callback){return function(dispatch,getStore){__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].forgotPassword(email).then(function(resp){callback(true);}).catch(function(error){callback(false);});};}function confirmPasswordReset(code,password,callback){return function(dispatch,getStore){__WEBPACK_IMPORTED_MODULE_1__provider_auth_AuthService__["a" /* default */].confirmPasswordReset(code,password).then(function(resp){callback(true,resp);}).catch(function(error){callback(false,error);});};}/* Ejemple de uso del servicio CrudAction
export function actionListConfigSetting(params, callback) {
  params = params || {};
  return (dispatch, getStore) => {
    dispatch({
      type: CHANGE_CONFIG_SETTINGS_PROPS,
      props: { gridFetchingData: true }
    });
    // Llamada al servicio list
    action
      .list(params)
      .then(response => {
        if (response.isSessionExpired()) {
          dispatch(actionLogout);
          return;
        }
    }
*/

/***/ }),
/* 455 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_Firebase__ = __webpack_require__(1171);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var Methods={HEAD:"HEAD",GET:"GET",POST:"POST",PUT:"PUT",PATCH:"PATCH",DELETE:"DELETE"};var FirebaseConnector=function(){function FirebaseConnector(){var options=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};_classCallCheck(this,FirebaseConnector);var _options$apikey=options.apikey,apikey=_options$apikey===undefined?"":_options$apikey,_options$timeout=options.timeout,timeout=_options$timeout===undefined?0:_options$timeout,_options$trackingId=options.trackingId,trackingId=_options$trackingId===undefined?"":_options$trackingId;this._defaultHeaders={};if(apikey)this._defaultHeaders["X-ApiKey"]=apikey;if(trackingId)this._defaultHeaders["X-TrackingId"]=trackingId;if(timeout)this._timeout=timeout;this.token;// this.onChangeToken()
}_createClass(FirebaseConnector,[{key:"onChangeAuth",value:function onChangeAuth(callback){return __WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth().onAuthStateChanged(callback);}// onChangeToken(){
//   firebaseApp.auth().onIdTokenChanged(async (user)=>{
//     console.log("ON CHANGE TOKEN", user)
//     if(user){
//       const token = await user.getIdToken(true)
//       this.token=token
//     }else{
//       this.token = null
//     }
//   })
// }
},{key:"login",value:function login(user,pass){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var auth,resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:try{auth=__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth();resp=auth.signInWithEmailAndPassword(user,pass);resolve(resp);}catch(error){reject(error);}case 1:case"end":return _context.stop();}}},_callee,_this);}));return function(_x2,_x3){return _ref.apply(this,arguments);};}());}},{key:"logout",value:function logout(){return __WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth().signOut();}},{key:"getToken",value:function getToken(){return __WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth().currentUser.getIdToken(true);// return new Promise(async (resolve, reject) => {
//   try {
//     if(!this.token){
//       console.log("BUSCO EN EL CURRENT USER EL TOKEN")
//       if(firebaseApp.auth().currentUser){
//         this.token = await firebaseApp.auth().currentUser.getIdToken(true);  
//       }
//     }
//     console.log("GET TOKEN", this.token)
//     resolve(this.token)
//   } catch (error) {
//     console.log("ERROR GET TOKEN", error)
//     reject(error);
//   }
// });
}// init(config) {
//   firebaseApp.initializeApp(config);
// }
// get(uri, id, callback) {
//   return new Promise((resolve, reject) => {
//     if (id) {
//       uri = uri + "/" + id;
//     }
//     db.ref(uri).once("value", snapshot => {
//       let snap = snapshot.val();
//       resolve(snap);
//       if (callback) {
//         callback(snap);
//       }
//     });
//   });
// }
// del(uri, id) {
//   db.ref(uri + "/" + id).remove();
// }
// save(uri, obj, id) {
//   let newKey = id ? id : new Date();
//   db.ref(uri + "/" + newKey.valueOf()).set(obj);
// }
// update(uri, obj) {
//   db.ref(uri + "/" + obj.ref).update(obj);
// }
// listener(uri, callback) {
//   db.ref(uri).on("value", snapshot => {
//     let snap = snapshot.val();
//     if (callback) {
//       callback(snap);
//     }
//   });
// }
},{key:"uploadFile",value:function uploadFile(file,path,type,callback){var storageRef=__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].storage().ref();var filename=new Date().getTime();//Ver si usamos este tiempo para no pisar archivos o vamos a permitir que se pisen archivos con el mismo nombre
filename+="_"+file.name;var metadata={contentType:file.type};var uploadTask="";switch(type){case"image":uploadTask=storageRef.child(path+"/"+filename).put(file,metadata);break;case"excel":uploadTask=storageRef.child(path+"/"+filename).put(file);break;default:break;}// Register three observers:
// 1. 'state_changed' observer, called any time the state changes
// 2. Error observer, called on failure
// 3. Completion observer, called on successful completion
uploadTask.on("state_changed",function(snapshot){// Observe state change events such as progress, pause, and resume
// Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
var progreso=snapshot.bytesTransferred/snapshot.totalBytes*100;console.log("PROGRESO",progreso," %",snapshot.state);switch(snapshot.state){case'paused':console.log("Upload is paused");break;case'running':console.log("Upload is running");break;}},function(error){// Handle unsuccessful uploads
console.log("Has been occurred an error.");},function(){// Handle successful uploads on complete
// For instance, get the download URL: https://firebasestorage.googleapis.com/...
var downloadURL=uploadTask.snapshot.downloadURL;callback(downloadURL,path+"/"+filename,file.name);//return downloadURL;
});}},{key:"deleteFile",value:function deleteFile(path,callback){var storageRef=__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].storage().ref();var deleteRef=storageRef.child(path);// Delete the file
deleteRef.delete().then(function(){// File deleted successfully
callback(true);}).catch(function(error){// Uh-oh, an error occurred!
callback(false);});}},{key:"createUserWithEmailAndPass",value:function createUserWithEmailAndPass(user,onSuccess,onError){__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth().createUserWithEmailAndPassword(user.userName,user.password).then(function(user){if(onSuccess)onSuccess(user);}).catch(function(error){if(onError)onError(error);});}},{key:"forgotPassword",value:function forgotPassword(email){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var auth,resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:try{auth=__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth();resp=auth.sendPasswordResetEmail(email,null);resolve(resp);}catch(error){reject(error);}case 1:case"end":return _context2.stop();}}},_callee2,_this2);}));return function(_x4,_x5){return _ref2.apply(this,arguments);};}());}},{key:"confirmPasswordReset",value:function confirmPasswordReset(code,password){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var auth,resp;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:try{auth=__WEBPACK_IMPORTED_MODULE_1__config_Firebase__["a" /* firebaseApp */].auth();resp=auth.confirmPasswordReset(code,password);resolve(resp);}catch(error){reject(error);}case 1:case"end":return _context3.stop();}}},_callee3,_this3);}));return function(_x6,_x7){return _ref3.apply(this,arguments);};}());}}]);return FirebaseConnector;}();/* harmony default export */ __webpack_exports__["a"] = (FirebaseConnector);

/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(267);
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
exports.assert = function (assertion, message) {
    if (!assertion) {
        throw exports.assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
exports.assertionError = function (message) {
    return new Error('Firebase Database (' +
        constants_1.CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

//# sourceMappingURL=assert.js.map


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
exports.base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
exports.base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return exports.base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
exports.base64Decode = function (str) {
    try {
        return exports.base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

//# sourceMappingURL=crypt.js.map


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
exports.jsonEval = jsonEval;
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}
exports.stringify = stringify;

//# sourceMappingURL=json.js.map


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
exports.contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
exports.safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
exports.extend = function (objTo, objFrom) {
    exports.forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
exports.clone = function (obj) {
    return exports.extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
exports.isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
exports.isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
exports.getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
exports.map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
exports.findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
exports.findValue = function (obj, fn, opt_this) {
    var key = exports.findKey(obj, fn, opt_this);
    return key && obj[key];
};
exports.getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
exports.getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

//# sourceMappingURL=obj.js.map


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var util_1 = __webpack_require__(21);
var parser_1 = __webpack_require__(462);
var Path_1 = __webpack_require__(29);
var Reference_1 = __webpack_require__(268);
var Repo_1 = __webpack_require__(187);
var RepoManager_1 = __webpack_require__(273);
var util_2 = __webpack_require__(6);
var validation_1 = __webpack_require__(94);
/**
 * Class representing a firebase database.
 * @implements {FirebaseService}
 */
var Database = /** @class */ (function () {
    /**
     * The constructor should not be called by users of our public API.
     * @param {!Repo} repo_
     */
    function Database(repo_) {
        this.repo_ = repo_;
        if (!(repo_ instanceof Repo_1.Repo)) {
            util_1.fatal("Don't call new Database() directly - please use firebase.database().");
        }
        /** @type {Reference} */
        this.root_ = new Reference_1.Reference(repo_, Path_1.Path.Empty);
        this.INTERNAL = new DatabaseInternals(this);
    }
    Object.defineProperty(Database.prototype, "app", {
        get: function () {
            return this.repo_.app;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Returns a reference to the root or the path specified in opt_pathString.
     * @param {string=} pathString
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.ref = function (pathString) {
        this.checkDeleted_('ref');
        util_2.validateArgCount('database.ref', 0, 1, arguments.length);
        return pathString !== undefined ? this.root_.child(pathString) : this.root_;
    };
    /**
     * Returns a reference to the root or the path specified in url.
     * We throw a exception if the url is not in the same domain as the
     * current repo.
     * @param {string} url
     * @return {!Reference} Firebase reference.
     */
    Database.prototype.refFromURL = function (url) {
        /** @const {string} */
        var apiName = 'database.refFromURL';
        this.checkDeleted_(apiName);
        util_2.validateArgCount(apiName, 1, 1, arguments.length);
        var parsedURL = parser_1.parseRepoInfo(url);
        validation_1.validateUrl(apiName, 1, parsedURL);
        var repoInfo = parsedURL.repoInfo;
        if (repoInfo.host !== this.repo_.repoInfo_.host) {
            util_1.fatal(apiName +
                ': Host name does not match the current database: ' +
                '(found ' +
                repoInfo.host +
                ' but expected ' +
                this.repo_.repoInfo_.host +
                ')');
        }
        return this.ref(parsedURL.path.toString());
    };
    /**
     * @param {string} apiName
     */
    Database.prototype.checkDeleted_ = function (apiName) {
        if (this.repo_ === null) {
            util_1.fatal('Cannot call ' + apiName + ' on a deleted database.');
        }
    };
    // Make individual repo go offline.
    Database.prototype.goOffline = function () {
        util_2.validateArgCount('database.goOffline', 0, 0, arguments.length);
        this.checkDeleted_('goOffline');
        this.repo_.interrupt();
    };
    Database.prototype.goOnline = function () {
        util_2.validateArgCount('database.goOnline', 0, 0, arguments.length);
        this.checkDeleted_('goOnline');
        this.repo_.resume();
    };
    Database.ServerValue = {
        TIMESTAMP: {
            '.sv': 'timestamp'
        }
    };
    return Database;
}());
exports.Database = Database;
var DatabaseInternals = /** @class */ (function () {
    /** @param {!Database} database */
    function DatabaseInternals(database) {
        this.database = database;
    }
    /** @return {Promise<void>} */
    DatabaseInternals.prototype.delete = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                this.database.checkDeleted_('delete');
                RepoManager_1.RepoManager.getInstance().deleteRepo(this.database.repo_);
                this.database.repo_ = null;
                this.database.root_ = null;
                this.database.INTERNAL = null;
                this.database = null;
                return [2 /*return*/];
            });
        });
    };
    return DatabaseInternals;
}());
exports.DatabaseInternals = DatabaseInternals;

//# sourceMappingURL=Database.js.map


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Path_1 = __webpack_require__(29);
var RepoInfo_1 = __webpack_require__(463);
var util_1 = __webpack_require__(21);
/**
 * @param {!string} pathString
 * @return {string}
 */
function decodePath(pathString) {
    var pathStringDecoded = '';
    var pieces = pathString.split('/');
    for (var i = 0; i < pieces.length; i++) {
        if (pieces[i].length > 0) {
            var piece = pieces[i];
            try {
                piece = decodeURIComponent(piece.replace(/\+/g, ' '));
            }
            catch (e) { }
            pathStringDecoded += '/' + piece;
        }
    }
    return pathStringDecoded;
}
/**
 * @param {!string} queryString
 * @return {!{[key:string]:string}} key value hash
 */
function decodeQuery(queryString) {
    var results = {};
    if (queryString.startsWith('?')) {
        queryString = queryString.substring(1);
    }
    for (var _i = 0, _a = queryString.split('&'); _i < _a.length; _i++) {
        var segment = _a[_i];
        if (segment.length === 0) {
            continue;
        }
        var kv = segment.split('=');
        if (kv.length === 2) {
            results[decodeURIComponent(kv[0])] = decodeURIComponent(kv[1]);
        }
        else {
            util_1.warn("Invalid query segment '" + segment + "' in query '" + queryString + "'");
        }
    }
    return results;
}
/**
 *
 * @param {!string} dataURL
 * @return {{repoInfo: !RepoInfo, path: !Path}}
 */
exports.parseRepoInfo = function (dataURL) {
    var parsedUrl = exports.parseURL(dataURL), namespace = parsedUrl.subdomain;
    if (parsedUrl.domain === 'firebase') {
        util_1.fatal(parsedUrl.host +
            ' is no longer supported. ' +
            'Please use <YOUR FIREBASE>.firebaseio.com instead');
    }
    // Catch common error of uninitialized namespace value.
    if ((!namespace || namespace == 'undefined') &&
        parsedUrl.domain !== 'localhost') {
        util_1.fatal('Cannot parse Firebase url. Please use https://<YOUR FIREBASE>.firebaseio.com');
    }
    if (!parsedUrl.secure) {
        util_1.warnIfPageIsSecure();
    }
    var webSocketOnly = parsedUrl.scheme === 'ws' || parsedUrl.scheme === 'wss';
    return {
        repoInfo: new RepoInfo_1.RepoInfo(parsedUrl.host, parsedUrl.secure, namespace, webSocketOnly),
        path: new Path_1.Path(parsedUrl.pathString)
    };
};
/**
 *
 * @param {!string} dataURL
 * @return {{host: string, port: number, domain: string, subdomain: string, secure: boolean, scheme: string, pathString: string}}
 */
exports.parseURL = function (dataURL) {
    // Default to empty strings in the event of a malformed string.
    var host = '', domain = '', subdomain = '', pathString = '';
    // Always default to SSL, unless otherwise specified.
    var secure = true, scheme = 'https', port = 443;
    // Don't do any validation here. The caller is responsible for validating the result of parsing.
    if (typeof dataURL === 'string') {
        // Parse scheme.
        var colonInd = dataURL.indexOf('//');
        if (colonInd >= 0) {
            scheme = dataURL.substring(0, colonInd - 1);
            dataURL = dataURL.substring(colonInd + 2);
        }
        // Parse host, path, and query string.
        var slashInd = dataURL.indexOf('/');
        if (slashInd === -1) {
            slashInd = dataURL.length;
        }
        var questionMarkInd = dataURL.indexOf('?');
        if (questionMarkInd === -1) {
            questionMarkInd = dataURL.length;
        }
        host = dataURL.substring(0, Math.min(slashInd, questionMarkInd));
        if (slashInd < questionMarkInd) {
            // For pathString, questionMarkInd will always come after slashInd
            pathString = decodePath(dataURL.substring(slashInd, questionMarkInd));
        }
        var queryParams = decodeQuery(dataURL.substring(Math.min(dataURL.length, questionMarkInd)));
        // If we have a port, use scheme for determining if it's secure.
        colonInd = host.indexOf(':');
        if (colonInd >= 0) {
            secure = scheme === 'https' || scheme === 'wss';
            port = parseInt(host.substring(colonInd + 1), 10);
        }
        else {
            colonInd = dataURL.length;
        }
        var parts = host.split('.');
        if (parts.length === 3) {
            // Normalize namespaces to lowercase to share storage / connection.
            domain = parts[1];
            subdomain = parts[0].toLowerCase();
        }
        else if (parts.length === 2) {
            domain = parts[0];
        }
        else if (parts[0].slice(0, colonInd).toLowerCase() === 'localhost') {
            domain = 'localhost';
        }
        // Support `ns` query param if subdomain not already set
        if (subdomain === '' && 'ns' in queryParams) {
            subdomain = queryParams['ns'];
        }
    }
    return {
        host: host,
        port: port,
        domain: domain,
        subdomain: subdomain,
        secure: secure,
        scheme: scheme,
        pathString: pathString
    };
};

//# sourceMappingURL=parser.js.map


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var storage_1 = __webpack_require__(182);
var Constants_1 = __webpack_require__(183);
/**
 * A class that holds metadata about a Repo object
 *
 * @constructor
 */
var RepoInfo = /** @class */ (function () {
    /**
     * @param {string} host Hostname portion of the url for the repo
     * @param {boolean} secure Whether or not this repo is accessed over ssl
     * @param {string} namespace The namespace represented by the repo
     * @param {boolean} webSocketOnly Whether to prefer websockets over all other transports (used by Nest).
     * @param {string=} persistenceKey Override the default session persistence storage key
     */
    function RepoInfo(host, secure, namespace, webSocketOnly, persistenceKey) {
        if (persistenceKey === void 0) { persistenceKey = ''; }
        this.secure = secure;
        this.namespace = namespace;
        this.webSocketOnly = webSocketOnly;
        this.persistenceKey = persistenceKey;
        this.host = host.toLowerCase();
        this.domain = this.host.substr(this.host.indexOf('.') + 1);
        this.internalHost = storage_1.PersistentStorage.get('host:' + host) || this.host;
    }
    RepoInfo.prototype.needsQueryParam = function () {
        return this.host !== this.internalHost || this.isCustomHost();
    };
    RepoInfo.prototype.isCacheableHost = function () {
        return this.internalHost.substr(0, 2) === 's-';
    };
    RepoInfo.prototype.isDemoHost = function () {
        return this.domain === 'firebaseio-demo.com';
    };
    RepoInfo.prototype.isCustomHost = function () {
        return (this.domain !== 'firebaseio.com' && this.domain !== 'firebaseio-demo.com');
    };
    RepoInfo.prototype.updateHost = function (newHost) {
        if (newHost !== this.internalHost) {
            this.internalHost = newHost;
            if (this.isCacheableHost()) {
                storage_1.PersistentStorage.set('host:' + this.host, this.internalHost);
            }
        }
    };
    /**
     * Returns the websocket URL for this repo
     * @param {string} type of connection
     * @param {Object} params list
     * @return {string} The URL for this repo
     */
    RepoInfo.prototype.connectionURL = function (type, params) {
        util_1.assert(typeof type === 'string', 'typeof type must == string');
        util_1.assert(typeof params === 'object', 'typeof params must == object');
        var connURL;
        if (type === Constants_1.WEBSOCKET) {
            connURL =
                (this.secure ? 'wss://' : 'ws://') + this.internalHost + '/.ws?';
        }
        else if (type === Constants_1.LONG_POLLING) {
            connURL =
                (this.secure ? 'https://' : 'http://') + this.internalHost + '/.lp?';
        }
        else {
            throw new Error('Unknown connection type: ' + type);
        }
        if (this.needsQueryParam()) {
            params['ns'] = this.namespace;
        }
        var pairs = [];
        util_2.forEach(params, function (key, value) {
            pairs.push(key + '=' + value);
        });
        return connURL + pairs.join('&');
    };
    /** @return {string} */
    RepoInfo.prototype.toString = function () {
        var str = this.toURLString();
        if (this.persistenceKey) {
            str += '<' + this.persistenceKey + '>';
        }
        return str;
    };
    /** @return {string} */
    RepoInfo.prototype.toURLString = function () {
        return (this.secure ? 'https://' : 'http://') + this.host;
    };
    return RepoInfo;
}());
exports.RepoInfo = RepoInfo;

//# sourceMappingURL=RepoInfo.js.map


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var validation_1 = __webpack_require__(94);
var util_2 = __webpack_require__(21);
var util_3 = __webpack_require__(6);
/**
 * @constructor
 */
var OnDisconnect = /** @class */ (function () {
    /**
     * @param {!Repo} repo_
     * @param {!Path} path_
     */
    function OnDisconnect(repo_, path_) {
        this.repo_ = repo_;
        this.path_ = path_;
    }
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.cancel = function (onComplete) {
        util_1.validateArgCount('OnDisconnect.cancel', 0, 1, arguments.length);
        util_1.validateCallback('OnDisconnect.cancel', 1, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo_.onDisconnectCancel(this.path_, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.remove = function (onComplete) {
        util_1.validateArgCount('OnDisconnect.remove', 0, 1, arguments.length);
        validation_1.validateWritablePath('OnDisconnect.remove', this.path_);
        util_1.validateCallback('OnDisconnect.remove', 1, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo_.onDisconnectSet(this.path_, null, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.set = function (value, onComplete) {
        util_1.validateArgCount('OnDisconnect.set', 1, 2, arguments.length);
        validation_1.validateWritablePath('OnDisconnect.set', this.path_);
        validation_1.validateFirebaseDataArg('OnDisconnect.set', 1, value, this.path_, false);
        util_1.validateCallback('OnDisconnect.set', 2, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo_.onDisconnectSet(this.path_, value, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {*} value
     * @param {number|string|null} priority
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.setWithPriority = function (value, priority, onComplete) {
        util_1.validateArgCount('OnDisconnect.setWithPriority', 2, 3, arguments.length);
        validation_1.validateWritablePath('OnDisconnect.setWithPriority', this.path_);
        validation_1.validateFirebaseDataArg('OnDisconnect.setWithPriority', 1, value, this.path_, false);
        validation_1.validatePriority('OnDisconnect.setWithPriority', 2, priority, false);
        util_1.validateCallback('OnDisconnect.setWithPriority', 3, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo_.onDisconnectSetWithPriority(this.path_, value, priority, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    /**
     * @param {!Object} objectToMerge
     * @param {function(?Error)=} onComplete
     * @return {!firebase.Promise}
     */
    OnDisconnect.prototype.update = function (objectToMerge, onComplete) {
        util_1.validateArgCount('OnDisconnect.update', 1, 2, arguments.length);
        validation_1.validateWritablePath('OnDisconnect.update', this.path_);
        if (Array.isArray(objectToMerge)) {
            var newObjectToMerge = {};
            for (var i = 0; i < objectToMerge.length; ++i) {
                newObjectToMerge['' + i] = objectToMerge[i];
            }
            objectToMerge = newObjectToMerge;
            util_2.warn('Passing an Array to firebase.database.onDisconnect().update() is deprecated. Use set() if you want to overwrite the ' +
                'existing data, or an Object with integer keys if you really do want to only update some of the children.');
        }
        validation_1.validateFirebaseMergeDataArg('OnDisconnect.update', 1, objectToMerge, this.path_, false);
        util_1.validateCallback('OnDisconnect.update', 2, onComplete, true);
        var deferred = new util_3.Deferred();
        this.repo_.onDisconnectUpdate(this.path_, objectToMerge, deferred.wrapCallback(onComplete));
        return deferred.promise;
    };
    return OnDisconnect;
}());
exports.OnDisconnect = OnDisconnect;

//# sourceMappingURL=onDisconnect.js.map


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var KeyIndex_1 = __webpack_require__(145);
var PriorityIndex_1 = __webpack_require__(42);
var ValueIndex_1 = __webpack_require__(467);
var PathIndex_1 = __webpack_require__(471);
var util_2 = __webpack_require__(21);
var Path_1 = __webpack_require__(29);
var validation_1 = __webpack_require__(94);
var util_3 = __webpack_require__(6);
var EventRegistration_1 = __webpack_require__(1201);
var util_4 = __webpack_require__(6);
var __referenceConstructor;
/**
 * A Query represents a filter to be applied to a firebase location.  This object purely represents the
 * query expression (and exposes our public API to build the query).  The actual query logic is in ViewBase.js.
 *
 * Since every Firebase reference is a query, Firebase inherits from this object.
 */
var Query = /** @class */ (function () {
    function Query(repo, path, queryParams_, orderByCalled_) {
        this.repo = repo;
        this.path = path;
        this.queryParams_ = queryParams_;
        this.orderByCalled_ = orderByCalled_;
    }
    Object.defineProperty(Query, "__referenceConstructor", {
        get: function () {
            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Validates start/end values for queries.
     * @param {!QueryParams} params
     * @private
     */
    Query.validateQueryEndpoints_ = function (params) {
        var startNode = null;
        var endNode = null;
        if (params.hasStart()) {
            startNode = params.getIndexStartValue();
        }
        if (params.hasEnd()) {
            endNode = params.getIndexEndValue();
        }
        if (params.getIndex() === KeyIndex_1.KEY_INDEX) {
            var tooManyArgsError = 'Query: When ordering by key, you may only pass one argument to ' +
                'startAt(), endAt(), or equalTo().';
            var wrongArgTypeError = 'Query: When ordering by key, the argument passed to startAt(), endAt(),' +
                'or equalTo() must be a string.';
            if (params.hasStart()) {
                var startName = params.getIndexStartName();
                if (startName != util_2.MIN_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof startNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
            if (params.hasEnd()) {
                var endName = params.getIndexEndName();
                if (endName != util_2.MAX_NAME) {
                    throw new Error(tooManyArgsError);
                }
                else if (typeof endNode !== 'string') {
                    throw new Error(wrongArgTypeError);
                }
            }
        }
        else if (params.getIndex() === PriorityIndex_1.PRIORITY_INDEX) {
            if ((startNode != null && !validation_1.isValidPriority(startNode)) ||
                (endNode != null && !validation_1.isValidPriority(endNode))) {
                throw new Error('Query: When ordering by priority, the first argument passed to startAt(), ' +
                    'endAt(), or equalTo() must be a valid priority value (null, a number, or a string).');
            }
        }
        else {
            util_1.assert(params.getIndex() instanceof PathIndex_1.PathIndex ||
                params.getIndex() === ValueIndex_1.VALUE_INDEX, 'unknown index type.');
            if ((startNode != null && typeof startNode === 'object') ||
                (endNode != null && typeof endNode === 'object')) {
                throw new Error('Query: First argument passed to startAt(), endAt(), or equalTo() cannot be ' +
                    'an object.');
            }
        }
    };
    /**
     * Validates that limit* has been called with the correct combination of parameters
     * @param {!QueryParams} params
     * @private
     */
    Query.validateLimit_ = function (params) {
        if (params.hasStart() &&
            params.hasEnd() &&
            params.hasLimit() &&
            !params.hasAnchoredLimit()) {
            throw new Error("Query: Can't combine startAt(), endAt(), and limit(). Use limitToFirst() or limitToLast() instead.");
        }
    };
    /**
     * Validates that no other order by call has been made
     * @param {!string} fnName
     * @private
     */
    Query.prototype.validateNoPreviousOrderByCall_ = function (fnName) {
        if (this.orderByCalled_ === true) {
            throw new Error(fnName + ": You can't combine multiple orderBy calls.");
        }
    };
    /**
     * @return {!QueryParams}
     */
    Query.prototype.getQueryParams = function () {
        return this.queryParams_;
    };
    /**
     * @return {!Reference}
     */
    Query.prototype.getRef = function () {
        util_3.validateArgCount('Query.ref', 0, 0, arguments.length);
        // This is a slight hack. We cannot goog.require('fb.api.Firebase'), since Firebase requires fb.api.Query.
        // However, we will always export 'Firebase' to the global namespace, so it's guaranteed to exist by the time this
        // method gets called.
        return new Query.__referenceConstructor(this.repo, this.path);
    };
    /**
     * @param {!string} eventType
     * @param {!function(DataSnapshot, string=)} callback
     * @param {(function(Error)|Object)=} cancelCallbackOrContext
     * @param {Object=} context
     * @return {!function(DataSnapshot, string=)}
     */
    Query.prototype.on = function (eventType, callback, cancelCallbackOrContext, context) {
        util_3.validateArgCount('Query.on', 2, 4, arguments.length);
        validation_1.validateEventType('Query.on', 1, eventType, false);
        util_3.validateCallback('Query.on', 2, callback, false);
        var ret = Query.getCancelAndContextArgs_('Query.on', cancelCallbackOrContext, context);
        if (eventType === 'value') {
            this.onValueEvent(callback, ret.cancel, ret.context);
        }
        else {
            var callbacks = {};
            callbacks[eventType] = callback;
            this.onChildEvent(callbacks, ret.cancel, ret.context);
        }
        return callback;
    };
    /**
     * @param {!function(!DataSnapshot)} callback
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onValueEvent = function (callback, cancelCallback, context) {
        var container = new EventRegistration_1.ValueEventRegistration(callback, cancelCallback || null, context || null);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {!Object.<string, !function(!DataSnapshot, ?string)>} callbacks
     * @param {?function(Error)} cancelCallback
     * @param {?Object} context
     * @protected
     */
    Query.prototype.onChildEvent = function (callbacks, cancelCallback, context) {
        var container = new EventRegistration_1.ChildEventRegistration(callbacks, cancelCallback, context);
        this.repo.addEventCallbackForQuery(this, container);
    };
    /**
     * @param {string=} eventType
     * @param {(function(!DataSnapshot, ?string=))=} callback
     * @param {Object=} context
     */
    Query.prototype.off = function (eventType, callback, context) {
        util_3.validateArgCount('Query.off', 0, 3, arguments.length);
        validation_1.validateEventType('Query.off', 1, eventType, true);
        util_3.validateCallback('Query.off', 2, callback, true);
        util_3.validateContextObject('Query.off', 3, context, true);
        var container = null;
        var callbacks = null;
        if (eventType === 'value') {
            var valueCallback = callback || null;
            container = new EventRegistration_1.ValueEventRegistration(valueCallback, null, context || null);
        }
        else if (eventType) {
            if (callback) {
                callbacks = {};
                callbacks[eventType] = callback;
            }
            container = new EventRegistration_1.ChildEventRegistration(callbacks, null, context || null);
        }
        this.repo.removeEventCallbackForQuery(this, container);
    };
    /**
     * Attaches a listener, waits for the first event, and then removes the listener
     * @param {!string} eventType
     * @param {!function(!DataSnapshot, string=)} userCallback
     * @param cancelOrContext
     * @param context
     * @return {!firebase.Promise}
     */
    Query.prototype.once = function (eventType, userCallback, cancelOrContext, context) {
        var _this = this;
        util_3.validateArgCount('Query.once', 1, 4, arguments.length);
        validation_1.validateEventType('Query.once', 1, eventType, false);
        util_3.validateCallback('Query.once', 2, userCallback, true);
        var ret = Query.getCancelAndContextArgs_('Query.once', cancelOrContext, context);
        // TODO: Implement this more efficiently (in particular, use 'get' wire protocol for 'value' event)
        // TODO: consider actually wiring the callbacks into the promise. We cannot do this without a breaking change
        // because the API currently expects callbacks will be called synchronously if the data is cached, but this is
        // against the Promise specification.
        var firstCall = true;
        var deferred = new util_4.Deferred();
        // A dummy error handler in case a user wasn't expecting promises
        deferred.promise.catch(function () { });
        var onceCallback = function (snapshot) {
            // NOTE: Even though we unsubscribe, we may get called multiple times if a single action (e.g. set() with JSON)
            // triggers multiple events (e.g. child_added or child_changed).
            if (firstCall) {
                firstCall = false;
                _this.off(eventType, onceCallback);
                if (userCallback) {
                    userCallback.bind(ret.context)(snapshot);
                }
                deferred.resolve(snapshot);
            }
        };
        this.on(eventType, onceCallback, 
        /*cancel=*/ function (err) {
            _this.off(eventType, onceCallback);
            if (ret.cancel)
                ret.cancel.bind(ret.context)(err);
            deferred.reject(err);
        });
        return deferred.promise;
    };
    /**
     * Set a limit and anchor it to the start of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToFirst = function (limit) {
        util_3.validateArgCount('Query.limitToFirst', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToFirst: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToFirst: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToFirst(limit), this.orderByCalled_);
    };
    /**
     * Set a limit and anchor it to the end of the window.
     * @param {!number} limit
     * @return {!Query}
     */
    Query.prototype.limitToLast = function (limit) {
        util_3.validateArgCount('Query.limitToLast', 1, 1, arguments.length);
        if (typeof limit !== 'number' ||
            Math.floor(limit) !== limit ||
            limit <= 0) {
            throw new Error('Query.limitToLast: First argument must be a positive integer.');
        }
        if (this.queryParams_.hasLimit()) {
            throw new Error('Query.limitToLast: Limit was already set (by another call to limit, ' +
                'limitToFirst, or limitToLast).');
        }
        return new Query(this.repo, this.path, this.queryParams_.limitToLast(limit), this.orderByCalled_);
    };
    /**
     * Given a child path, return a new query ordered by the specified grandchild path.
     * @param {!string} path
     * @return {!Query}
     */
    Query.prototype.orderByChild = function (path) {
        util_3.validateArgCount('Query.orderByChild', 1, 1, arguments.length);
        if (path === '$key') {
            throw new Error('Query.orderByChild: "$key" is invalid.  Use Query.orderByKey() instead.');
        }
        else if (path === '$priority') {
            throw new Error('Query.orderByChild: "$priority" is invalid.  Use Query.orderByPriority() instead.');
        }
        else if (path === '$value') {
            throw new Error('Query.orderByChild: "$value" is invalid.  Use Query.orderByValue() instead.');
        }
        validation_1.validatePathString('Query.orderByChild', 1, path, false);
        this.validateNoPreviousOrderByCall_('Query.orderByChild');
        var parsedPath = new Path_1.Path(path);
        if (parsedPath.isEmpty()) {
            throw new Error('Query.orderByChild: cannot pass in empty path.  Use Query.orderByValue() instead.');
        }
        var index = new PathIndex_1.PathIndex(parsedPath);
        var newParams = this.queryParams_.orderBy(index);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the KeyIndex
     * @return {!Query}
     */
    Query.prototype.orderByKey = function () {
        util_3.validateArgCount('Query.orderByKey', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByKey');
        var newParams = this.queryParams_.orderBy(KeyIndex_1.KEY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the PriorityIndex
     * @return {!Query}
     */
    Query.prototype.orderByPriority = function () {
        util_3.validateArgCount('Query.orderByPriority', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByPriority');
        var newParams = this.queryParams_.orderBy(PriorityIndex_1.PRIORITY_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * Return a new query ordered by the ValueIndex
     * @return {!Query}
     */
    Query.prototype.orderByValue = function () {
        util_3.validateArgCount('Query.orderByValue', 0, 0, arguments.length);
        this.validateNoPreviousOrderByCall_('Query.orderByValue');
        var newParams = this.queryParams_.orderBy(ValueIndex_1.VALUE_INDEX);
        Query.validateQueryEndpoints_(newParams);
        return new Query(this.repo, this.path, newParams, /*orderByCalled=*/ true);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.startAt = function (value, name) {
        if (value === void 0) { value = null; }
        util_3.validateArgCount('Query.startAt', 0, 2, arguments.length);
        validation_1.validateFirebaseDataArg('Query.startAt', 1, value, this.path, true);
        validation_1.validateKey('Query.startAt', 2, name, true);
        var newParams = this.queryParams_.startAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.startAt: Starting point was already set (by another call to startAt ' +
                'or equalTo).');
        }
        // Calling with no params tells us to start at the beginning.
        if (value === undefined) {
            value = null;
            name = null;
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * @param {number|string|boolean|null} value
     * @param {?string=} name
     * @return {!Query}
     */
    Query.prototype.endAt = function (value, name) {
        if (value === void 0) { value = null; }
        util_3.validateArgCount('Query.endAt', 0, 2, arguments.length);
        validation_1.validateFirebaseDataArg('Query.endAt', 1, value, this.path, true);
        validation_1.validateKey('Query.endAt', 2, name, true);
        var newParams = this.queryParams_.endAt(value, name);
        Query.validateLimit_(newParams);
        Query.validateQueryEndpoints_(newParams);
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.endAt: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return new Query(this.repo, this.path, newParams, this.orderByCalled_);
    };
    /**
     * Load the selection of children with exactly the specified value, and, optionally,
     * the specified name.
     * @param {number|string|boolean|null} value
     * @param {string=} name
     * @return {!Query}
     */
    Query.prototype.equalTo = function (value, name) {
        util_3.validateArgCount('Query.equalTo', 1, 2, arguments.length);
        validation_1.validateFirebaseDataArg('Query.equalTo', 1, value, this.path, false);
        validation_1.validateKey('Query.equalTo', 2, name, true);
        if (this.queryParams_.hasStart()) {
            throw new Error('Query.equalTo: Starting point was already set (by another call to startAt or ' +
                'equalTo).');
        }
        if (this.queryParams_.hasEnd()) {
            throw new Error('Query.equalTo: Ending point was already set (by another call to endAt or ' +
                'equalTo).');
        }
        return this.startAt(value, name).endAt(value, name);
    };
    /**
     * @return {!string} URL for this location.
     */
    Query.prototype.toString = function () {
        util_3.validateArgCount('Query.toString', 0, 0, arguments.length);
        return this.repo.toString() + this.path.toUrlEncodedString();
    };
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users.
    Query.prototype.toJSON = function () {
        // An optional spacer argument is unnecessary for a string.
        util_3.validateArgCount('Query.toJSON', 0, 1, arguments.length);
        return this.toString();
    };
    /**
     * An object representation of the query parameters used by this Query.
     * @return {!Object}
     */
    Query.prototype.queryObject = function () {
        return this.queryParams_.getQueryObject();
    };
    /**
     * @return {!string}
     */
    Query.prototype.queryIdentifier = function () {
        var obj = this.queryObject();
        var id = util_2.ObjectToUniqueKey(obj);
        return id === '{}' ? 'default' : id;
    };
    /**
     * Return true if this query and the provided query are equivalent; otherwise, return false.
     * @param {Query} other
     * @return {boolean}
     */
    Query.prototype.isEqual = function (other) {
        util_3.validateArgCount('Query.isEqual', 1, 1, arguments.length);
        if (!(other instanceof Query)) {
            var error = 'Query.isEqual failed: First argument must be an instance of firebase.database.Query.';
            throw new Error(error);
        }
        var sameRepo = this.repo === other.repo;
        var samePath = this.path.equals(other.path);
        var sameQueryIdentifier = this.queryIdentifier() === other.queryIdentifier();
        return sameRepo && samePath && sameQueryIdentifier;
    };
    /**
     * Helper used by .on and .once to extract the context and or cancel arguments.
     * @param {!string} fnName The function name (on or once)
     * @param {(function(Error)|Object)=} cancelOrContext
     * @param {Object=} context
     * @return {{cancel: ?function(Error), context: ?Object}}
     * @private
     */
    Query.getCancelAndContextArgs_ = function (fnName, cancelOrContext, context) {
        var ret = { cancel: null, context: null };
        if (cancelOrContext && context) {
            ret.cancel = cancelOrContext;
            util_3.validateCallback(fnName, 3, ret.cancel, true);
            ret.context = context;
            util_3.validateContextObject(fnName, 4, ret.context, true);
        }
        else if (cancelOrContext) {
            // we have either a cancel callback or a context.
            if (typeof cancelOrContext === 'object' && cancelOrContext !== null) {
                // it's a context!
                ret.context = cancelOrContext;
            }
            else if (typeof cancelOrContext === 'function') {
                ret.cancel = cancelOrContext;
            }
            else {
                throw new Error(util_3.errorPrefix(fnName, 3, true) +
                    ' must either be a cancel callback or a context object.');
            }
        }
        return ret;
    };
    Object.defineProperty(Query.prototype, "ref", {
        get: function () {
            return this.getRef();
        },
        enumerable: true,
        configurable: true
    });
    return Query;
}());
exports.Query = Query;

//# sourceMappingURL=Query.js.map


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var util_3 = __webpack_require__(6);
var MAX_NODE;
function setMaxNode(val) {
    MAX_NODE = val;
}
exports.setMaxNode = setMaxNode;
/**
 * @param {(!string|!number)} priority
 * @return {!string}
 */
exports.priorityHashText = function (priority) {
    if (typeof priority === 'number')
        return 'number:' + util_2.doubleToIEEE754String(priority);
    else
        return 'string:' + priority;
};
/**
 * Validates that a priority snapshot Node is valid.
 *
 * @param {!Node} priorityNode
 */
exports.validatePriorityNode = function (priorityNode) {
    if (priorityNode.isLeafNode()) {
        var val = priorityNode.val();
        util_1.assert(typeof val === 'string' ||
            typeof val === 'number' ||
            (typeof val === 'object' && util_3.contains(val, '.sv')), 'Priority must be a string or number.');
    }
    else {
        util_1.assert(priorityNode === MAX_NODE || priorityNode.isEmpty(), 'priority of unexpected type.');
    }
    // Don't call getPriority() on MAX_NODE to avoid hitting assertion.
    util_1.assert(priorityNode === MAX_NODE || priorityNode.getPriority().isEmpty(), "Priority nodes can't have a priority of their own.");
};

//# sourceMappingURL=snap.js.map


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var Index_1 = __webpack_require__(184);
var Node_1 = __webpack_require__(53);
var util_1 = __webpack_require__(21);
var nodeFromJSON_1 = __webpack_require__(146);
/**
 * @constructor
 * @extends {Index}
 * @private
 */
var ValueIndex = /** @class */ (function (_super) {
    tslib_1.__extends(ValueIndex, _super);
    function ValueIndex() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.compare = function (a, b) {
        var indexCmp = a.node.compareTo(b.node);
        if (indexCmp === 0) {
            return util_1.nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.isDefinedOn = function (node) {
        return true;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.indexedValueChanged = function (oldNode, newNode) {
        return !oldNode.equals(newNode);
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.minPost = function () {
        return Node_1.NamedNode.MIN;
    };
    /**
     * @inheritDoc
     */
    ValueIndex.prototype.maxPost = function () {
        return Node_1.NamedNode.MAX;
    };
    /**
     * @param {*} indexValue
     * @param {string} name
     * @return {!NamedNode}
     */
    ValueIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
        return new Node_1.NamedNode(name, valueNode);
    };
    /**
     * @return {!string} String representation for inclusion in a query spec
     */
    ValueIndex.prototype.toString = function () {
        return '.value';
    };
    return ValueIndex;
}(Index_1.Index));
exports.ValueIndex = ValueIndex;
exports.VALUE_INDEX = new ValueIndex();

//# sourceMappingURL=ValueIndex.js.map


/***/ }),
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var childSet_1 = __webpack_require__(469);
var util_2 = __webpack_require__(6);
var Node_1 = __webpack_require__(53);
var PriorityIndex_1 = __webpack_require__(42);
var KeyIndex_1 = __webpack_require__(145);
var _defaultIndexMap;
var fallbackObject = {};
/**
 *
 * @param {Object.<string, FallbackType|SortedMap.<NamedNode, Node>>} indexes
 * @param {Object.<string, Index>} indexSet
 * @constructor
 */
var IndexMap = /** @class */ (function () {
    function IndexMap(indexes_, indexSet_) {
        this.indexes_ = indexes_;
        this.indexSet_ = indexSet_;
    }
    Object.defineProperty(IndexMap, "Default", {
        /**
         * The default IndexMap for nodes without a priority
         * @type {!IndexMap}
         * @const
         */
        get: function () {
            util_1.assert(fallbackObject && PriorityIndex_1.PRIORITY_INDEX, 'ChildrenNode.ts has not been loaded');
            _defaultIndexMap =
                _defaultIndexMap ||
                    new IndexMap({ '.priority': fallbackObject }, { '.priority': PriorityIndex_1.PRIORITY_INDEX });
            return _defaultIndexMap;
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @param {!string} indexKey
     * @return {?SortedMap.<NamedNode, Node>}
     */
    IndexMap.prototype.get = function (indexKey) {
        var sortedMap = util_2.safeGet(this.indexes_, indexKey);
        if (!sortedMap)
            throw new Error('No index defined for ' + indexKey);
        if (sortedMap === fallbackObject) {
            // The index exists, but it falls back to just name comparison. Return null so that the calling code uses the
            // regular child map
            return null;
        }
        else {
            return sortedMap;
        }
    };
    /**
     * @param {!Index} indexDefinition
     * @return {boolean}
     */
    IndexMap.prototype.hasIndex = function (indexDefinition) {
        return util_2.contains(this.indexSet_, indexDefinition.toString());
    };
    /**
     * @param {!Index} indexDefinition
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addIndex = function (indexDefinition, existingChildren) {
        util_1.assert(indexDefinition !== KeyIndex_1.KEY_INDEX, "KeyIndex always exists and isn't meant to be added to the IndexMap.");
        var childList = [];
        var sawIndexedValue = false;
        var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
        var next = iter.getNext();
        while (next) {
            sawIndexedValue =
                sawIndexedValue || indexDefinition.isDefinedOn(next.node);
            childList.push(next);
            next = iter.getNext();
        }
        var newIndex;
        if (sawIndexedValue) {
            newIndex = childSet_1.buildChildSet(childList, indexDefinition.getCompare());
        }
        else {
            newIndex = fallbackObject;
        }
        var indexName = indexDefinition.toString();
        var newIndexSet = util_2.clone(this.indexSet_);
        newIndexSet[indexName] = indexDefinition;
        var newIndexes = util_2.clone(this.indexes_);
        newIndexes[indexName] = newIndex;
        return new IndexMap(newIndexes, newIndexSet);
    };
    /**
     * Ensure that this node is properly tracked in any indexes that we're maintaining
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.addToIndexes = function (namedNode, existingChildren) {
        var _this = this;
        var newIndexes = util_2.map(this.indexes_, function (indexedChildren, indexName) {
            var index = util_2.safeGet(_this.indexSet_, indexName);
            util_1.assert(index, 'Missing index implementation for ' + indexName);
            if (indexedChildren === fallbackObject) {
                // Check to see if we need to index everything
                if (index.isDefinedOn(namedNode.node)) {
                    // We need to build this index
                    var childList = [];
                    var iter = existingChildren.getIterator(Node_1.NamedNode.Wrap);
                    var next = iter.getNext();
                    while (next) {
                        if (next.name != namedNode.name) {
                            childList.push(next);
                        }
                        next = iter.getNext();
                    }
                    childList.push(namedNode);
                    return childSet_1.buildChildSet(childList, index.getCompare());
                }
                else {
                    // No change, this remains a fallback
                    return fallbackObject;
                }
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                var newChildren = indexedChildren;
                if (existingSnap) {
                    newChildren = newChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
                }
                return newChildren.insert(namedNode, namedNode.node);
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    /**
     * Create a new IndexMap instance with the given value removed
     * @param {!NamedNode} namedNode
     * @param {!SortedMap.<string, !Node>} existingChildren
     * @return {!IndexMap}
     */
    IndexMap.prototype.removeFromIndexes = function (namedNode, existingChildren) {
        var newIndexes = util_2.map(this.indexes_, function (indexedChildren) {
            if (indexedChildren === fallbackObject) {
                // This is the fallback. Just return it, nothing to do in this case
                return indexedChildren;
            }
            else {
                var existingSnap = existingChildren.get(namedNode.name);
                if (existingSnap) {
                    return indexedChildren.remove(new Node_1.NamedNode(namedNode.name, existingSnap));
                }
                else {
                    // No record of this child
                    return indexedChildren;
                }
            }
        });
        return new IndexMap(newIndexes, this.indexSet_);
    };
    return IndexMap;
}());
exports.IndexMap = IndexMap;

//# sourceMappingURL=IndexMap.js.map


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var SortedMap_1 = __webpack_require__(186);
var SortedMap_2 = __webpack_require__(186);
var LOG_2 = Math.log(2);
/**
 * @constructor
 */
var Base12Num = /** @class */ (function () {
    /**
     * @param {number} length
     */
    function Base12Num(length) {
        var logBase2 = function (num) {
            return parseInt((Math.log(num) / LOG_2), 10);
        };
        var bitMask = function (bits) { return parseInt(Array(bits + 1).join('1'), 2); };
        this.count = logBase2(length + 1);
        this.current_ = this.count - 1;
        var mask = bitMask(this.count);
        this.bits_ = (length + 1) & mask;
    }
    /**
     * @return {boolean}
     */
    Base12Num.prototype.nextBitIsOne = function () {
        //noinspection JSBitwiseOperatorUsage
        var result = !(this.bits_ & (0x1 << this.current_));
        this.current_--;
        return result;
    };
    return Base12Num;
}());
/**
 * Takes a list of child nodes and constructs a SortedSet using the given comparison
 * function
 *
 * Uses the algorithm described in the paper linked here:
 * http://citeseerx.ist.psu.edu/viewdoc/summary?doi=10.1.1.46.1458
 *
 * @template K, V
 * @param {Array.<!NamedNode>} childList Unsorted list of children
 * @param {function(!NamedNode, !NamedNode):number} cmp The comparison method to be used
 * @param {(function(NamedNode):K)=} keyFn An optional function to extract K from a node wrapper, if K's
 *                                                        type is not NamedNode
 * @param {(function(K, K):number)=} mapSortFn An optional override for comparator used by the generated sorted map
 * @return {SortedMap.<K, V>}
 */
exports.buildChildSet = function (childList, cmp, keyFn, mapSortFn) {
    childList.sort(cmp);
    var buildBalancedTree = function (low, high) {
        var length = high - low;
        var namedNode;
        var key;
        if (length == 0) {
            return null;
        }
        else if (length == 1) {
            namedNode = childList[low];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, null, null);
        }
        else {
            var middle = parseInt((length / 2), 10) + low;
            var left = buildBalancedTree(low, middle);
            var right = buildBalancedTree(middle + 1, high);
            namedNode = childList[middle];
            key = keyFn ? keyFn(namedNode) : namedNode;
            return new SortedMap_1.LLRBNode(key, namedNode.node, SortedMap_1.LLRBNode.BLACK, left, right);
        }
    };
    var buildFrom12Array = function (base12) {
        var node = null;
        var root = null;
        var index = childList.length;
        var buildPennant = function (chunkSize, color) {
            var low = index - chunkSize;
            var high = index;
            index -= chunkSize;
            var childTree = buildBalancedTree(low + 1, high);
            var namedNode = childList[low];
            var key = keyFn ? keyFn(namedNode) : namedNode;
            attachPennant(new SortedMap_1.LLRBNode(key, namedNode.node, color, null, childTree));
        };
        var attachPennant = function (pennant) {
            if (node) {
                node.left = pennant;
                node = pennant;
            }
            else {
                root = pennant;
                node = pennant;
            }
        };
        for (var i = 0; i < base12.count; ++i) {
            var isOne = base12.nextBitIsOne();
            // The number of nodes taken in each slice is 2^(arr.length - (i + 1))
            var chunkSize = Math.pow(2, base12.count - (i + 1));
            if (isOne) {
                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
            }
            else {
                // current == 2
                buildPennant(chunkSize, SortedMap_1.LLRBNode.BLACK);
                buildPennant(chunkSize, SortedMap_1.LLRBNode.RED);
            }
        }
        return root;
    };
    var base12 = new Base12Num(childList.length);
    var root = buildFrom12Array(base12);
    return new SortedMap_2.SortedMap(mapSortFn || cmp, root);
};

//# sourceMappingURL=childSet.js.map


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
function NAME_ONLY_COMPARATOR(left, right) {
    return util_1.nameCompare(left.name, right.name);
}
exports.NAME_ONLY_COMPARATOR = NAME_ONLY_COMPARATOR;
function NAME_COMPARATOR(left, right) {
    return util_1.nameCompare(left, right);
}
exports.NAME_COMPARATOR = NAME_COMPARATOR;

//# sourceMappingURL=comparators.js.map


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var Index_1 = __webpack_require__(184);
var ChildrenNode_1 = __webpack_require__(49);
var Node_1 = __webpack_require__(53);
var nodeFromJSON_1 = __webpack_require__(146);
/**
 * @param {!Path} indexPath
 * @constructor
 * @extends {Index}
 */
var PathIndex = /** @class */ (function (_super) {
    tslib_1.__extends(PathIndex, _super);
    function PathIndex(indexPath_) {
        var _this = _super.call(this) || this;
        _this.indexPath_ = indexPath_;
        util_1.assert(!indexPath_.isEmpty() && indexPath_.getFront() !== '.priority', "Can't create PathIndex with empty path or .priority key");
        return _this;
    }
    /**
     * @param {!Node} snap
     * @return {!Node}
     * @protected
     */
    PathIndex.prototype.extractChild = function (snap) {
        return snap.getChild(this.indexPath_);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.isDefinedOn = function (node) {
        return !node.getChild(this.indexPath_).isEmpty();
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.compare = function (a, b) {
        var aChild = this.extractChild(a.node);
        var bChild = this.extractChild(b.node);
        var indexCmp = aChild.compareTo(bChild);
        if (indexCmp === 0) {
            return util_2.nameCompare(a.name, b.name);
        }
        else {
            return indexCmp;
        }
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.makePost = function (indexValue, name) {
        var valueNode = nodeFromJSON_1.nodeFromJSON(indexValue);
        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, valueNode);
        return new Node_1.NamedNode(name, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.maxPost = function () {
        var node = ChildrenNode_1.ChildrenNode.EMPTY_NODE.updateChild(this.indexPath_, ChildrenNode_1.MAX_NODE);
        return new Node_1.NamedNode(util_2.MAX_NAME, node);
    };
    /**
     * @inheritDoc
     */
    PathIndex.prototype.toString = function () {
        return this.indexPath_.slice().join('/');
    };
    return PathIndex;
}(Index_1.Index));
exports.PathIndex = PathIndex;

//# sourceMappingURL=PathIndex.js.map


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Path_1 = __webpack_require__(29);
var SparseSnapshotTree_1 = __webpack_require__(473);
var LeafNode_1 = __webpack_require__(185);
var nodeFromJSON_1 = __webpack_require__(146);
var PriorityIndex_1 = __webpack_require__(42);
/**
 * Generate placeholders for deferred values.
 * @param {?Object} values
 * @return {!Object}
 */
exports.generateWithValues = function (values) {
    values = values || {};
    values['timestamp'] = values['timestamp'] || new Date().getTime();
    return values;
};
/**
 * Value to use when firing local events. When writing server values, fire
 * local events with an approximate value, otherwise return value as-is.
 * @param {(Object|string|number|boolean)} value
 * @param {!Object} serverValues
 * @return {!(string|number|boolean)}
 */
exports.resolveDeferredValue = function (value, serverValues) {
    if (!value || typeof value !== 'object') {
        return value;
    }
    else {
        util_1.assert('.sv' in value, 'Unexpected leaf node or priority contents');
        return serverValues[value['.sv']];
    }
};
/**
 * Recursively replace all deferred values and priorities in the tree with the
 * specified generated replacement values.
 * @param {!SparseSnapshotTree} tree
 * @param {!Object} serverValues
 * @return {!SparseSnapshotTree}
 */
exports.resolveDeferredValueTree = function (tree, serverValues) {
    var resolvedTree = new SparseSnapshotTree_1.SparseSnapshotTree();
    tree.forEachTree(new Path_1.Path(''), function (path, node) {
        resolvedTree.remember(path, exports.resolveDeferredValueSnapshot(node, serverValues));
    });
    return resolvedTree;
};
/**
 * Recursively replace all deferred values and priorities in the node with the
 * specified generated replacement values.  If there are no server values in the node,
 * it'll be returned as-is.
 * @param {!Node} node
 * @param {!Object} serverValues
 * @return {!Node}
 */
exports.resolveDeferredValueSnapshot = function (node, serverValues) {
    var rawPri = node.getPriority().val();
    var priority = exports.resolveDeferredValue(rawPri, serverValues);
    var newNode;
    if (node.isLeafNode()) {
        var leafNode = node;
        var value = exports.resolveDeferredValue(leafNode.getValue(), serverValues);
        if (value !== leafNode.getValue() ||
            priority !== leafNode.getPriority().val()) {
            return new LeafNode_1.LeafNode(value, nodeFromJSON_1.nodeFromJSON(priority));
        }
        else {
            return node;
        }
    }
    else {
        var childrenNode = node;
        newNode = childrenNode;
        if (priority !== childrenNode.getPriority().val()) {
            newNode = newNode.updatePriority(new LeafNode_1.LeafNode(priority));
        }
        childrenNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
            var newChildNode = exports.resolveDeferredValueSnapshot(childNode, serverValues);
            if (newChildNode !== childNode) {
                newNode = newNode.updateImmediateChild(childName, newChildNode);
            }
        });
        return newNode;
    }
};

//# sourceMappingURL=ServerValues.js.map


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Path_1 = __webpack_require__(29);
var PriorityIndex_1 = __webpack_require__(42);
var CountedSet_1 = __webpack_require__(474);
/**
 * Helper class to store a sparse set of snapshots.
 *
 * @constructor
 */
var SparseSnapshotTree = /** @class */ (function () {
    function SparseSnapshotTree() {
        /**
         * @private
         * @type {Node}
         */
        this.value_ = null;
        /**
         * @private
         * @type {CountedSet}
         */
        this.children_ = null;
    }
    /**
     * Gets the node stored at the given path if one exists.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {?Node} The retrieved node, or null.
     */
    SparseSnapshotTree.prototype.find = function (path) {
        if (this.value_ != null) {
            return this.value_.getChild(path);
        }
        else if (!path.isEmpty() && this.children_ != null) {
            var childKey = path.getFront();
            path = path.popFront();
            if (this.children_.contains(childKey)) {
                var childTree = this.children_.get(childKey);
                return childTree.find(path);
            }
            else {
                return null;
            }
        }
        else {
            return null;
        }
    };
    /**
     * Stores the given node at the specified path. If there is already a node
     * at a shallower path, it merges the new data into that snapshot node.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @param {!Node} data The new data, or null.
     */
    SparseSnapshotTree.prototype.remember = function (path, data) {
        if (path.isEmpty()) {
            this.value_ = data;
            this.children_ = null;
        }
        else if (this.value_ !== null) {
            this.value_ = this.value_.updateChild(path, data);
        }
        else {
            if (this.children_ == null) {
                this.children_ = new CountedSet_1.CountedSet();
            }
            var childKey = path.getFront();
            if (!this.children_.contains(childKey)) {
                this.children_.add(childKey, new SparseSnapshotTree());
            }
            var child = this.children_.get(childKey);
            path = path.popFront();
            child.remember(path, data);
        }
    };
    /**
     * Purge the data at path from the cache.
     *
     * @param {!Path} path Path to look up snapshot for.
     * @return {boolean} True if this node should now be removed.
     */
    SparseSnapshotTree.prototype.forget = function (path) {
        if (path.isEmpty()) {
            this.value_ = null;
            this.children_ = null;
            return true;
        }
        else {
            if (this.value_ !== null) {
                if (this.value_.isLeafNode()) {
                    // We're trying to forget a node that doesn't exist
                    return false;
                }
                else {
                    var value = this.value_;
                    this.value_ = null;
                    var self_1 = this;
                    value.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, tree) {
                        self_1.remember(new Path_1.Path(key), tree);
                    });
                    return this.forget(path);
                }
            }
            else if (this.children_ !== null) {
                var childKey = path.getFront();
                path = path.popFront();
                if (this.children_.contains(childKey)) {
                    var safeToRemove = this.children_.get(childKey).forget(path);
                    if (safeToRemove) {
                        this.children_.remove(childKey);
                    }
                }
                if (this.children_.isEmpty()) {
                    this.children_ = null;
                    return true;
                }
                else {
                    return false;
                }
            }
            else {
                return true;
            }
        }
    };
    /**
     * Recursively iterates through all of the stored tree and calls the
     * callback on each one.
     *
     * @param {!Path} prefixPath Path to look up node for.
     * @param {!Function} func The function to invoke for each tree.
     */
    SparseSnapshotTree.prototype.forEachTree = function (prefixPath, func) {
        if (this.value_ !== null) {
            func(prefixPath, this.value_);
        }
        else {
            this.forEachChild(function (key, tree) {
                var path = new Path_1.Path(prefixPath.toString() + '/' + key);
                tree.forEachTree(path, func);
            });
        }
    };
    /**
     * Iterates through each immediate child and triggers the callback.
     *
     * @param {!Function} func The function to invoke for each child.
     */
    SparseSnapshotTree.prototype.forEachChild = function (func) {
        if (this.children_ !== null) {
            this.children_.each(function (key, tree) {
                func(key, tree);
            });
        }
    };
    return SparseSnapshotTree;
}());
exports.SparseSnapshotTree = SparseSnapshotTree;

//# sourceMappingURL=SparseSnapshotTree.js.map


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Implements a set with a count of elements.
 *
 * @template K, V
 */
var CountedSet = /** @class */ (function () {
    function CountedSet() {
        this.set = {};
    }
    /**
     * @param {!K} item
     * @param {V} val
     */
    CountedSet.prototype.add = function (item, val) {
        this.set[item] = val !== null ? val : true;
    };
    /**
     * @param {!K} key
     * @return {boolean}
     */
    CountedSet.prototype.contains = function (key) {
        return util_1.contains(this.set, key);
    };
    /**
     * @param {!K} item
     * @return {V}
     */
    CountedSet.prototype.get = function (item) {
        return this.contains(item) ? this.set[item] : undefined;
    };
    /**
     * @param {!K} item
     */
    CountedSet.prototype.remove = function (item) {
        delete this.set[item];
    };
    /**
     * Deletes everything in the set
     */
    CountedSet.prototype.clear = function () {
        this.set = {};
    };
    /**
     * True if there's nothing in the set
     * @return {boolean}
     */
    CountedSet.prototype.isEmpty = function () {
        return util_1.isEmpty(this.set);
    };
    /**
     * @return {number} The number of items in the set
     */
    CountedSet.prototype.count = function () {
        return util_1.getCount(this.set);
    };
    /**
     * Run a function on each k,v pair in the set
     * @param {function(K, V)} fn
     */
    CountedSet.prototype.each = function (fn) {
        util_1.forEach(this.set, function (k, v) { return fn(k, v); });
    };
    /**
     * Mostly for debugging
     * @return {Array.<K>} The keys present in this CountedSet
     */
    CountedSet.prototype.keys = function () {
        var keys = [];
        util_1.forEach(this.set, function (k) {
            keys.push(k);
        });
        return keys;
    };
    return CountedSet;
}());
exports.CountedSet = CountedSet;

//# sourceMappingURL=CountedSet.js.map


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = __webpack_require__(95);
var Path_1 = __webpack_require__(29);
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!Node} snap
 * @constructor
 * @implements {Operation}
 */
var Overwrite = /** @class */ (function () {
    function Overwrite(source, path, snap) {
        this.source = source;
        this.path = path;
        this.snap = snap;
        /** @inheritDoc */
        this.type = Operation_1.OperationType.OVERWRITE;
    }
    Overwrite.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new Overwrite(this.source, Path_1.Path.Empty, this.snap.getImmediateChild(childName));
        }
        else {
            return new Overwrite(this.source, this.path.popFront(), this.snap);
        }
    };
    return Overwrite;
}());
exports.Overwrite = Overwrite;

//# sourceMappingURL=Overwrite.js.map


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var CacheNode_1 = __webpack_require__(188);
var ChildrenNode_1 = __webpack_require__(49);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var ViewCache_1 = __webpack_require__(477);
var View_1 = __webpack_require__(1207);
var __referenceConstructor;
/**
 * SyncPoint represents a single location in a SyncTree with 1 or more event registrations, meaning we need to
 * maintain 1 or more Views at this location to cache server data and raise appropriate events for server changes
 * and user writes (set, transaction, update).
 *
 * It's responsible for:
 *  - Maintaining the set of 1 or more views necessary at this location (a SyncPoint with 0 views should be removed).
 *  - Proxying user / server operations to the views as appropriate (i.e. applyServerOverwrite,
 *    applyUserOverwrite, etc.)
 */
var SyncPoint = /** @class */ (function () {
    function SyncPoint() {
        /**
         * The Views being tracked at this location in the tree, stored as a map where the key is a
         * queryId and the value is the View for that query.
         *
         * NOTE: This list will be quite small (usually 1, but perhaps 2 or 3; any more is an odd use case).
         *
         * @type {!Object.<!string, !View>}
         * @private
         */
        this.views_ = {};
    }
    Object.defineProperty(SyncPoint, "__referenceConstructor", {
        get: function () {
            util_1.assert(__referenceConstructor, 'Reference.ts has not been loaded');
            return __referenceConstructor;
        },
        set: function (val) {
            util_1.assert(!__referenceConstructor, '__referenceConstructor has already been defined');
            __referenceConstructor = val;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.isEmpty = function () {
        return util_2.isEmpty(this.views_);
    };
    /**
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} optCompleteServerCache
     * @return {!Array.<!Event>}
     */
    SyncPoint.prototype.applyOperation = function (operation, writesCache, optCompleteServerCache) {
        var queryId = operation.source.queryId;
        if (queryId !== null) {
            var view = util_2.safeGet(this.views_, queryId);
            util_1.assert(view != null, 'SyncTree gave us an op for an invalid query.');
            return view.applyOperation(operation, writesCache, optCompleteServerCache);
        }
        else {
            var events_1 = [];
            util_2.forEach(this.views_, function (key, view) {
                events_1 = events_1.concat(view.applyOperation(operation, writesCache, optCompleteServerCache));
            });
            return events_1;
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache Complete server cache, if we have it.
     * @param {boolean} serverCacheComplete
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncPoint.prototype.addEventRegistration = function (query, eventRegistration, writesCache, serverCache, serverCacheComplete) {
        var queryId = query.queryIdentifier();
        var view = util_2.safeGet(this.views_, queryId);
        if (!view) {
            // TODO: make writesCache take flag for complete server node
            var eventCache = writesCache.calcCompleteEventCache(serverCacheComplete ? serverCache : null);
            var eventCacheComplete = false;
            if (eventCache) {
                eventCacheComplete = true;
            }
            else if (serverCache instanceof ChildrenNode_1.ChildrenNode) {
                eventCache = writesCache.calcCompleteEventChildren(serverCache);
                eventCacheComplete = false;
            }
            else {
                eventCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                eventCacheComplete = false;
            }
            var viewCache = new ViewCache_1.ViewCache(new CacheNode_1.CacheNode(
            /** @type {!Node} */ (eventCache), eventCacheComplete, false), new CacheNode_1.CacheNode(
            /** @type {!Node} */ (serverCache), serverCacheComplete, false));
            view = new View_1.View(query, viewCache);
            this.views_[queryId] = view;
        }
        // This is guaranteed to exist now, we just created anything that was missing
        view.addEventRegistration(eventRegistration);
        return view.getInitialEvents(eventRegistration);
    };
    /**
     * Remove event callback(s).  Return cancelEvents if a cancelError is specified.
     *
     * If query is the default query, we'll check all views for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified view(s).
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {{removed:!Array.<!Query>, events:!Array.<!Event>}} removed queries and any cancel events
     */
    SyncPoint.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var queryId = query.queryIdentifier();
        var removed = [];
        var cancelEvents = [];
        var hadCompleteView = this.hasCompleteView();
        if (queryId === 'default') {
            // When you do ref.off(...), we search all views for the registration to remove.
            var self_1 = this;
            util_2.forEach(this.views_, function (viewQueryId, view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete self_1.views_[viewQueryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            });
        }
        else {
            // remove the callback from the specific view.
            var view = util_2.safeGet(this.views_, queryId);
            if (view) {
                cancelEvents = cancelEvents.concat(view.removeEventRegistration(eventRegistration, cancelError));
                if (view.isEmpty()) {
                    delete this.views_[queryId];
                    // We'll deal with complete views later.
                    if (!view
                        .getQuery()
                        .getQueryParams()
                        .loadsAllData()) {
                        removed.push(view.getQuery());
                    }
                }
            }
        }
        if (hadCompleteView && !this.hasCompleteView()) {
            // We removed our last complete view.
            removed.push(new SyncPoint.__referenceConstructor(query.repo, query.path));
        }
        return { removed: removed, events: cancelEvents };
    };
    /**
     * @return {!Array.<!View>}
     */
    SyncPoint.prototype.getQueryViews = function () {
        var _this = this;
        var values = Object.keys(this.views_).map(function (key) { return _this.views_[key]; });
        return values.filter(function (view) {
            return !view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
    };
    /**
     *
     * @param {!Path} path The path to the desired complete snapshot
     * @return {?Node} A complete cache, if it exists
     */
    SyncPoint.prototype.getCompleteServerCache = function (path) {
        var serverCache = null;
        util_2.forEach(this.views_, function (key, view) {
            serverCache = serverCache || view.getCompleteServerCache(path);
        });
        return serverCache;
    };
    /**
     * @param {!Query} query
     * @return {?View}
     */
    SyncPoint.prototype.viewForQuery = function (query) {
        var params = query.getQueryParams();
        if (params.loadsAllData()) {
            return this.getCompleteView();
        }
        else {
            var queryId = query.queryIdentifier();
            return util_2.safeGet(this.views_, queryId);
        }
    };
    /**
     * @param {!Query} query
     * @return {boolean}
     */
    SyncPoint.prototype.viewExistsForQuery = function (query) {
        return this.viewForQuery(query) != null;
    };
    /**
     * @return {boolean}
     */
    SyncPoint.prototype.hasCompleteView = function () {
        return this.getCompleteView() != null;
    };
    /**
     * @return {?View}
     */
    SyncPoint.prototype.getCompleteView = function () {
        var completeView = util_2.findValue(this.views_, function (view) {
            return view
                .getQuery()
                .getQueryParams()
                .loadsAllData();
        });
        return completeView || null;
    };
    return SyncPoint;
}());
exports.SyncPoint = SyncPoint;

//# sourceMappingURL=SyncPoint.js.map


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenNode_1 = __webpack_require__(49);
var CacheNode_1 = __webpack_require__(188);
/**
 * Stores the data we have cached for a view.
 *
 * serverSnap is the cached server data, eventSnap is the cached event data (server data plus any local writes).
 *
 * @constructor
 */
var ViewCache = /** @class */ (function () {
    /**
     *
     * @param {!CacheNode} eventCache_
     * @param {!CacheNode} serverCache_
     */
    function ViewCache(eventCache_, serverCache_) {
        this.eventCache_ = eventCache_;
        this.serverCache_ = serverCache_;
    }
    /**
     * @param {!Node} eventSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateEventSnap = function (eventSnap, complete, filtered) {
        return new ViewCache(new CacheNode_1.CacheNode(eventSnap, complete, filtered), this.serverCache_);
    };
    /**
     * @param {!Node} serverSnap
     * @param {boolean} complete
     * @param {boolean} filtered
     * @return {!ViewCache}
     */
    ViewCache.prototype.updateServerSnap = function (serverSnap, complete, filtered) {
        return new ViewCache(this.eventCache_, new CacheNode_1.CacheNode(serverSnap, complete, filtered));
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getEventCache = function () {
        return this.eventCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteEventSnap = function () {
        return this.eventCache_.isFullyInitialized()
            ? this.eventCache_.getNode()
            : null;
    };
    /**
     * @return {!CacheNode}
     */
    ViewCache.prototype.getServerCache = function () {
        return this.serverCache_;
    };
    /**
     * @return {?Node}
     */
    ViewCache.prototype.getCompleteServerSnap = function () {
        return this.serverCache_.isFullyInitialized()
            ? this.serverCache_.getNode()
            : null;
    };
    /**
     * @const
     * @type {ViewCache}
     */
    ViewCache.Empty = new ViewCache(new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false), new CacheNode_1.CacheNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, 
    /*fullyInitialized=*/ false, 
    /*filtered=*/ false));
    return ViewCache;
}());
exports.ViewCache = ViewCache;

//# sourceMappingURL=ViewCache.js.map


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Returns the delta from the previous call to get stats.
 *
 * @param collection_ The collection to "listen" to.
 * @constructor
 */
var StatsListener = /** @class */ (function () {
    function StatsListener(collection_) {
        this.collection_ = collection_;
        this.last_ = null;
    }
    StatsListener.prototype.get = function () {
        var newStats = this.collection_.get();
        var delta = util_1.clone(newStats);
        if (this.last_) {
            util_1.forEach(this.last_, function (stat, value) {
                delta[stat] = delta[stat] - value;
            });
        }
        this.last_ = newStats;
        return delta;
    };
    return StatsListener;
}());
exports.StatsListener = StatsListener;

//# sourceMappingURL=StatsListener.js.map


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var app_1 = __webpack_require__(93);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var util_3 = __webpack_require__(6);
var util_4 = __webpack_require__(21);
var Path_1 = __webpack_require__(29);
var VisibilityMonitor_1 = __webpack_require__(1219);
var OnlineMonitor_1 = __webpack_require__(1220);
var util_5 = __webpack_require__(6);
var Connection_1 = __webpack_require__(481);
var util_6 = __webpack_require__(6);
var util_7 = __webpack_require__(6);
var ServerActions_1 = __webpack_require__(484);
var RECONNECT_MIN_DELAY = 1000;
var RECONNECT_MAX_DELAY_DEFAULT = 60 * 5 * 1000; // 5 minutes in milliseconds (Case: 1858)
var RECONNECT_MAX_DELAY_FOR_ADMINS = 30 * 1000; // 30 seconds for admin clients (likely to be a backend server)
var RECONNECT_DELAY_MULTIPLIER = 1.3;
var RECONNECT_DELAY_RESET_TIMEOUT = 30000; // Reset delay back to MIN_DELAY after being connected for 30sec.
var SERVER_KILL_INTERRUPT_REASON = 'server_kill';
// If auth fails repeatedly, we'll assume something is wrong and log a warning / back off.
var INVALID_AUTH_TOKEN_THRESHOLD = 3;
/**
 * Firebase connection.  Abstracts wire protocol and handles reconnecting.
 *
 * NOTE: All JSON objects sent to the realtime connection must have property names enclosed
 * in quotes to make sure the closure compiler does not minify them.
 */
var PersistentConnection = /** @class */ (function (_super) {
    tslib_1.__extends(PersistentConnection, _super);
    /**
     * @implements {ServerActions}
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param onConnectStatus_
     * @param onServerInfoUpdate_
     * @param authTokenProvider_
     * @param authOverride_
     */
    function PersistentConnection(repoInfo_, onDataUpdate_, onConnectStatus_, onServerInfoUpdate_, authTokenProvider_, authOverride_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.onConnectStatus_ = onConnectStatus_;
        _this.onServerInfoUpdate_ = onServerInfoUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        _this.authOverride_ = authOverride_;
        // Used for diagnostic logging.
        _this.id = PersistentConnection.nextPersistentConnectionId_++;
        _this.log_ = util_4.logWrapper('p:' + _this.id + ':');
        /** @private {Object} */
        _this.interruptReasons_ = {};
        _this.listens_ = {};
        _this.outstandingPuts_ = [];
        _this.outstandingPutCount_ = 0;
        _this.onDisconnectRequestQueue_ = [];
        _this.connected_ = false;
        _this.reconnectDelay_ = RECONNECT_MIN_DELAY;
        _this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_DEFAULT;
        _this.securityDebugCallback_ = null;
        _this.lastSessionId = null;
        /** @private {number|null} */
        _this.establishConnectionTimer_ = null;
        /** @private {boolean} */
        _this.visible_ = false;
        // Before we get connected, we keep a queue of pending messages to send.
        _this.requestCBHash_ = {};
        _this.requestNumber_ = 0;
        /** @private {?{
         *   sendRequest(Object),
         *   close()
         * }} */
        _this.realtime_ = null;
        /** @private {string|null} */
        _this.authToken_ = null;
        _this.forceTokenRefresh_ = false;
        _this.invalidAuthTokenCount_ = 0;
        _this.firstConnection_ = true;
        _this.lastConnectionAttemptTime_ = null;
        _this.lastConnectionEstablishedTime_ = null;
        if (authOverride_ && !util_7.isNodeSdk()) {
            throw new Error('Auth override specified in options, but not supported on non Node.js platforms');
        }
        _this.scheduleConnect_(0);
        VisibilityMonitor_1.VisibilityMonitor.getInstance().on('visible', _this.onVisible_, _this);
        if (repoInfo_.host.indexOf('fblocal') === -1) {
            OnlineMonitor_1.OnlineMonitor.getInstance().on('online', _this.onOnline_, _this);
        }
        return _this;
    }
    /**
     * @param {!string} action
     * @param {*} body
     * @param {function(*)=} onResponse
     * @protected
     */
    PersistentConnection.prototype.sendRequest = function (action, body, onResponse) {
        var curReqNum = ++this.requestNumber_;
        var msg = { r: curReqNum, a: action, b: body };
        this.log_(util_2.stringify(msg));
        util_3.assert(this.connected_, "sendRequest call when we're not connected not allowed.");
        this.realtime_.sendRequest(msg);
        if (onResponse) {
            this.requestCBHash_[curReqNum] = onResponse;
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var queryId = query.queryIdentifier();
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + queryId);
        this.listens_[pathString] = this.listens_[pathString] || {};
        util_3.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'listen() called for non-default but complete query');
        util_3.assert(!this.listens_[pathString][queryId], 'listen() called twice for same path/queryId.');
        var listenSpec = {
            onComplete: onComplete,
            hashFn: currentHashFn,
            query: query,
            tag: tag
        };
        this.listens_[pathString][queryId] = listenSpec;
        if (this.connected_) {
            this.sendListen_(listenSpec);
        }
    };
    /**
     * @param {!{onComplete(),
     *           hashFn():!string,
     *           query: !Query,
     *           tag: ?number}} listenSpec
     * @private
     */
    PersistentConnection.prototype.sendListen_ = function (listenSpec) {
        var _this = this;
        var query = listenSpec.query;
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Listen on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'q';
        // Only bother to send query if it's non-default.
        if (listenSpec.tag) {
            req['q'] = query.queryObject();
            req['t'] = listenSpec.tag;
        }
        req['h'] = listenSpec.hashFn();
        this.sendRequest(action, req, function (message) {
            var payload = message['d'];
            var status = message['s'];
            // print warnings in any case...
            PersistentConnection.warnOnListenWarnings_(payload, query);
            var currentListenSpec = _this.listens_[pathString] && _this.listens_[pathString][queryId];
            // only trigger actions if the listen hasn't been removed and readded
            if (currentListenSpec === listenSpec) {
                _this.log_('listen response', message);
                if (status !== 'ok') {
                    _this.removeListen_(pathString, queryId);
                }
                if (listenSpec.onComplete) {
                    listenSpec.onComplete(status, payload);
                }
            }
        });
    };
    /**
     * @param {*} payload
     * @param {!Query} query
     * @private
     */
    PersistentConnection.warnOnListenWarnings_ = function (payload, query) {
        if (payload && typeof payload === 'object' && util_1.contains(payload, 'w')) {
            var warnings = util_1.safeGet(payload, 'w');
            if (Array.isArray(warnings) && ~warnings.indexOf('no_index')) {
                var indexSpec = '".indexOn": "' +
                    query
                        .getQueryParams()
                        .getIndex()
                        .toString() +
                    '"';
                var indexPath = query.path.toString();
                util_4.warn("Using an unspecified index. Your data will be downloaded and " +
                    ("filtered on the client. Consider adding " + indexSpec + " at ") +
                    (indexPath + " to your security rules for better performance."));
            }
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.refreshAuthToken = function (token) {
        this.authToken_ = token;
        this.log_('Auth token refreshed');
        if (this.authToken_) {
            this.tryAuth();
        }
        else {
            //If we're connected we want to let the server know to unauthenticate us. If we're not connected, simply delete
            //the credential so we dont become authenticated next time we connect.
            if (this.connected_) {
                this.sendRequest('unauth', {}, function () { });
            }
        }
        this.reduceReconnectDelayIfAdminCredential_(token);
    };
    /**
     * @param {!string} credential
     * @private
     */
    PersistentConnection.prototype.reduceReconnectDelayIfAdminCredential_ = function (credential) {
        // NOTE: This isn't intended to be bulletproof (a malicious developer can always just modify the client).
        // Additionally, we don't bother resetting the max delay back to the default if auth fails / expires.
        var isFirebaseSecret = credential && credential.length === 40;
        if (isFirebaseSecret || util_5.isAdmin(credential)) {
            this.log_('Admin auth credential detected.  Reducing max reconnect time.');
            this.maxReconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
        }
    };
    /**
     * Attempts to authenticate with the given credentials. If the authentication attempt fails, it's triggered like
     * a auth revoked (the connection is closed).
     */
    PersistentConnection.prototype.tryAuth = function () {
        var _this = this;
        if (this.connected_ && this.authToken_) {
            var token_1 = this.authToken_;
            var authMethod = util_5.isValidFormat(token_1) ? 'auth' : 'gauth';
            var requestData = { cred: token_1 };
            if (this.authOverride_ === null) {
                requestData['noauth'] = true;
            }
            else if (typeof this.authOverride_ === 'object') {
                requestData['authvar'] = this.authOverride_;
            }
            this.sendRequest(authMethod, requestData, function (res) {
                var status = res['s'];
                var data = res['d'] || 'error';
                if (_this.authToken_ === token_1) {
                    if (status === 'ok') {
                        _this.invalidAuthTokenCount_ = 0;
                    }
                    else {
                        // Triggers reconnect and force refresh for auth token
                        _this.onAuthRevoked_(status, data);
                    }
                }
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.unlisten = function (query, tag) {
        var pathString = query.path.toString();
        var queryId = query.queryIdentifier();
        this.log_('Unlisten called for ' + pathString + ' ' + queryId);
        util_3.assert(query.getQueryParams().isDefault() ||
            !query.getQueryParams().loadsAllData(), 'unlisten() called for non-default but complete query');
        var listen = this.removeListen_(pathString, queryId);
        if (listen && this.connected_) {
            this.sendUnlisten_(pathString, queryId, query.queryObject(), tag);
        }
    };
    PersistentConnection.prototype.sendUnlisten_ = function (pathString, queryId, queryObj, tag) {
        this.log_('Unlisten on ' + pathString + ' for ' + queryId);
        var req = { /*path*/ p: pathString };
        var action = 'n';
        // Only bother sending queryId if it's non-default.
        if (tag) {
            req['q'] = queryObj;
            req['t'] = tag;
        }
        this.sendRequest(action, req);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectPut = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('o', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'o',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectMerge = function (pathString, data, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('om', pathString, data, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'om',
                data: data,
                onComplete: onComplete
            });
        }
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.onDisconnectCancel = function (pathString, onComplete) {
        if (this.connected_) {
            this.sendOnDisconnect_('oc', pathString, null, onComplete);
        }
        else {
            this.onDisconnectRequestQueue_.push({
                pathString: pathString,
                action: 'oc',
                data: null,
                onComplete: onComplete
            });
        }
    };
    PersistentConnection.prototype.sendOnDisconnect_ = function (action, pathString, data, onComplete) {
        var request = { /*path*/ p: pathString, /*data*/ d: data };
        this.log_('onDisconnect ' + action, request);
        this.sendRequest(action, request, function (response) {
            if (onComplete) {
                setTimeout(function () {
                    onComplete(response['s'], response['d']);
                }, Math.floor(0));
            }
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.put = function (pathString, data, onComplete, hash) {
        this.putInternal('p', pathString, data, onComplete, hash);
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.merge = function (pathString, data, onComplete, hash) {
        this.putInternal('m', pathString, data, onComplete, hash);
    };
    PersistentConnection.prototype.putInternal = function (action, pathString, data, onComplete, hash) {
        var request = {
            /*path*/ p: pathString,
            /*data*/ d: data
        };
        if (hash !== undefined)
            request['h'] = hash;
        // TODO: Only keep track of the most recent put for a given path?
        this.outstandingPuts_.push({
            action: action,
            request: request,
            onComplete: onComplete
        });
        this.outstandingPutCount_++;
        var index = this.outstandingPuts_.length - 1;
        if (this.connected_) {
            this.sendPut_(index);
        }
        else {
            this.log_('Buffering put: ' + pathString);
        }
    };
    PersistentConnection.prototype.sendPut_ = function (index) {
        var _this = this;
        var action = this.outstandingPuts_[index].action;
        var request = this.outstandingPuts_[index].request;
        var onComplete = this.outstandingPuts_[index].onComplete;
        this.outstandingPuts_[index].queued = this.connected_;
        this.sendRequest(action, request, function (message) {
            _this.log_(action + ' response', message);
            delete _this.outstandingPuts_[index];
            _this.outstandingPutCount_--;
            // Clean up array occasionally.
            if (_this.outstandingPutCount_ === 0) {
                _this.outstandingPuts_ = [];
            }
            if (onComplete)
                onComplete(message['s'], message['d']);
        });
    };
    /**
     * @inheritDoc
     */
    PersistentConnection.prototype.reportStats = function (stats) {
        var _this = this;
        // If we're not connected, we just drop the stats.
        if (this.connected_) {
            var request = { /*counters*/ c: stats };
            this.log_('reportStats', request);
            this.sendRequest(/*stats*/ 's', request, function (result) {
                var status = result['s'];
                if (status !== 'ok') {
                    var errorReason = result['d'];
                    _this.log_('reportStats', 'Error sending stats: ' + errorReason);
                }
            });
        }
    };
    /**
     * @param {*} message
     * @private
     */
    PersistentConnection.prototype.onDataMessage_ = function (message) {
        if ('r' in message) {
            // this is a response
            this.log_('from server: ' + util_2.stringify(message));
            var reqNum = message['r'];
            var onResponse = this.requestCBHash_[reqNum];
            if (onResponse) {
                delete this.requestCBHash_[reqNum];
                onResponse(message['b']);
            }
        }
        else if ('error' in message) {
            throw 'A server-side error has occurred: ' + message['error'];
        }
        else if ('a' in message) {
            // a and b are action and body, respectively
            this.onDataPush_(message['a'], message['b']);
        }
    };
    PersistentConnection.prototype.onDataPush_ = function (action, body) {
        this.log_('handleServerMessage', action, body);
        if (action === 'd')
            this.onDataUpdate_(body['p'], body['d'], 
            /*isMerge*/ false, body['t']);
        else if (action === 'm')
            this.onDataUpdate_(body['p'], body['d'], 
            /*isMerge=*/ true, body['t']);
        else if (action === 'c')
            this.onListenRevoked_(body['p'], body['q']);
        else if (action === 'ac')
            this.onAuthRevoked_(body['s'], body['d']);
        else if (action === 'sd')
            this.onSecurityDebugPacket_(body);
        else
            util_4.error('Unrecognized action received from server: ' +
                util_2.stringify(action) +
                '\nAre you using the latest client?');
    };
    PersistentConnection.prototype.onReady_ = function (timestamp, sessionId) {
        this.log_('connection ready');
        this.connected_ = true;
        this.lastConnectionEstablishedTime_ = new Date().getTime();
        this.handleTimestamp_(timestamp);
        this.lastSessionId = sessionId;
        if (this.firstConnection_) {
            this.sendConnectStats_();
        }
        this.restoreState_();
        this.firstConnection_ = false;
        this.onConnectStatus_(true);
    };
    PersistentConnection.prototype.scheduleConnect_ = function (timeout) {
        var _this = this;
        util_3.assert(!this.realtime_, "Scheduling a connect when we're already connected/ing?");
        if (this.establishConnectionTimer_) {
            clearTimeout(this.establishConnectionTimer_);
        }
        // NOTE: Even when timeout is 0, it's important to do a setTimeout to work around an infuriating "Security Error" in
        // Firefox when trying to write to our long-polling iframe in some scenarios (e.g. Forge or our unit tests).
        this.establishConnectionTimer_ = setTimeout(function () {
            _this.establishConnectionTimer_ = null;
            _this.establishConnection_();
        }, Math.floor(timeout));
    };
    /**
     * @param {boolean} visible
     * @private
     */
    PersistentConnection.prototype.onVisible_ = function (visible) {
        // NOTE: Tabbing away and back to a window will defeat our reconnect backoff, but I think that's fine.
        if (visible &&
            !this.visible_ &&
            this.reconnectDelay_ === this.maxReconnectDelay_) {
            this.log_('Window became visible.  Reducing delay.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        this.visible_ = visible;
    };
    PersistentConnection.prototype.onOnline_ = function (online) {
        if (online) {
            this.log_('Browser went online.');
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
        else {
            this.log_('Browser went offline.  Killing connection.');
            if (this.realtime_) {
                this.realtime_.close();
            }
        }
    };
    PersistentConnection.prototype.onRealtimeDisconnect_ = function () {
        this.log_('data client disconnected');
        this.connected_ = false;
        this.realtime_ = null;
        // Since we don't know if our sent transactions succeeded or not, we need to cancel them.
        this.cancelSentTransactions_();
        // Clear out the pending requests.
        this.requestCBHash_ = {};
        if (this.shouldReconnect_()) {
            if (!this.visible_) {
                this.log_("Window isn't visible.  Delaying reconnect.");
                this.reconnectDelay_ = this.maxReconnectDelay_;
                this.lastConnectionAttemptTime_ = new Date().getTime();
            }
            else if (this.lastConnectionEstablishedTime_) {
                // If we've been connected long enough, reset reconnect delay to minimum.
                var timeSinceLastConnectSucceeded = new Date().getTime() - this.lastConnectionEstablishedTime_;
                if (timeSinceLastConnectSucceeded > RECONNECT_DELAY_RESET_TIMEOUT)
                    this.reconnectDelay_ = RECONNECT_MIN_DELAY;
                this.lastConnectionEstablishedTime_ = null;
            }
            var timeSinceLastConnectAttempt = new Date().getTime() - this.lastConnectionAttemptTime_;
            var reconnectDelay = Math.max(0, this.reconnectDelay_ - timeSinceLastConnectAttempt);
            reconnectDelay = Math.random() * reconnectDelay;
            this.log_('Trying to reconnect in ' + reconnectDelay + 'ms');
            this.scheduleConnect_(reconnectDelay);
            // Adjust reconnect delay for next time.
            this.reconnectDelay_ = Math.min(this.maxReconnectDelay_, this.reconnectDelay_ * RECONNECT_DELAY_MULTIPLIER);
        }
        this.onConnectStatus_(false);
    };
    PersistentConnection.prototype.establishConnection_ = function () {
        if (this.shouldReconnect_()) {
            this.log_('Making a connection attempt');
            this.lastConnectionAttemptTime_ = new Date().getTime();
            this.lastConnectionEstablishedTime_ = null;
            var onDataMessage_1 = this.onDataMessage_.bind(this);
            var onReady_1 = this.onReady_.bind(this);
            var onDisconnect_1 = this.onRealtimeDisconnect_.bind(this);
            var connId_1 = this.id + ':' + PersistentConnection.nextConnectionId_++;
            var self_1 = this;
            var lastSessionId_1 = this.lastSessionId;
            var canceled_1 = false;
            var connection_1 = null;
            var closeFn_1 = function () {
                if (connection_1) {
                    connection_1.close();
                }
                else {
                    canceled_1 = true;
                    onDisconnect_1();
                }
            };
            var sendRequestFn = function (msg) {
                util_3.assert(connection_1, "sendRequest call when we're not connected not allowed.");
                connection_1.sendRequest(msg);
            };
            this.realtime_ = {
                close: closeFn_1,
                sendRequest: sendRequestFn
            };
            var forceRefresh = this.forceTokenRefresh_;
            this.forceTokenRefresh_ = false;
            // First fetch auth token, and establish connection after fetching the token was successful
            this.authTokenProvider_
                .getToken(forceRefresh)
                .then(function (result) {
                if (!canceled_1) {
                    util_4.log('getToken() completed. Creating connection.');
                    self_1.authToken_ = result && result.accessToken;
                    connection_1 = new Connection_1.Connection(connId_1, self_1.repoInfo_, onDataMessage_1, onReady_1, onDisconnect_1, 
                    /* onKill= */ function (reason) {
                        util_4.warn(reason + ' (' + self_1.repoInfo_.toString() + ')');
                        self_1.interrupt(SERVER_KILL_INTERRUPT_REASON);
                    }, lastSessionId_1);
                }
                else {
                    util_4.log('getToken() completed but was canceled');
                }
            })
                .then(null, function (error) {
                self_1.log_('Failed to get token: ' + error);
                if (!canceled_1) {
                    if (util_6.CONSTANTS.NODE_ADMIN) {
                        // This may be a critical error for the Admin Node.js SDK, so log a warning.
                        // But getToken() may also just have temporarily failed, so we still want to
                        // continue retrying.
                        util_4.warn(error);
                    }
                    closeFn_1();
                }
            });
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.interrupt = function (reason) {
        util_4.log('Interrupting connection for reason: ' + reason);
        this.interruptReasons_[reason] = true;
        if (this.realtime_) {
            this.realtime_.close();
        }
        else {
            if (this.establishConnectionTimer_) {
                clearTimeout(this.establishConnectionTimer_);
                this.establishConnectionTimer_ = null;
            }
            if (this.connected_) {
                this.onRealtimeDisconnect_();
            }
        }
    };
    /**
     * @param {string} reason
     */
    PersistentConnection.prototype.resume = function (reason) {
        util_4.log('Resuming connection for reason: ' + reason);
        delete this.interruptReasons_[reason];
        if (util_1.isEmpty(this.interruptReasons_)) {
            this.reconnectDelay_ = RECONNECT_MIN_DELAY;
            if (!this.realtime_) {
                this.scheduleConnect_(0);
            }
        }
    };
    PersistentConnection.prototype.handleTimestamp_ = function (timestamp) {
        var delta = timestamp - new Date().getTime();
        this.onServerInfoUpdate_({ serverTimeOffset: delta });
    };
    PersistentConnection.prototype.cancelSentTransactions_ = function () {
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            var put = this.outstandingPuts_[i];
            if (put && /*hash*/ 'h' in put.request && put.queued) {
                if (put.onComplete)
                    put.onComplete('disconnect');
                delete this.outstandingPuts_[i];
                this.outstandingPutCount_--;
            }
        }
        // Clean up array occasionally.
        if (this.outstandingPutCount_ === 0)
            this.outstandingPuts_ = [];
    };
    /**
     * @param {!string} pathString
     * @param {Array.<*>=} query
     * @private
     */
    PersistentConnection.prototype.onListenRevoked_ = function (pathString, query) {
        // Remove the listen and manufacture a "permission_denied" error for the failed listen.
        var queryId;
        if (!query) {
            queryId = 'default';
        }
        else {
            queryId = query.map(function (q) { return util_4.ObjectToUniqueKey(q); }).join('$');
        }
        var listen = this.removeListen_(pathString, queryId);
        if (listen && listen.onComplete)
            listen.onComplete('permission_denied');
    };
    /**
     * @param {!string} pathString
     * @param {!string} queryId
     * @return {{queries:Array.<Query>, onComplete:function(string)}}
     * @private
     */
    PersistentConnection.prototype.removeListen_ = function (pathString, queryId) {
        var normalizedPathString = new Path_1.Path(pathString).toString(); // normalize path.
        var listen;
        if (this.listens_[normalizedPathString] !== undefined) {
            listen = this.listens_[normalizedPathString][queryId];
            delete this.listens_[normalizedPathString][queryId];
            if (util_1.getCount(this.listens_[normalizedPathString]) === 0) {
                delete this.listens_[normalizedPathString];
            }
        }
        else {
            // all listens for this path has already been removed
            listen = undefined;
        }
        return listen;
    };
    PersistentConnection.prototype.onAuthRevoked_ = function (statusCode, explanation) {
        util_4.log('Auth token revoked: ' + statusCode + '/' + explanation);
        this.authToken_ = null;
        this.forceTokenRefresh_ = true;
        this.realtime_.close();
        if (statusCode === 'invalid_token' || statusCode === 'permission_denied') {
            // We'll wait a couple times before logging the warning / increasing the
            // retry period since oauth tokens will report as "invalid" if they're
            // just expired. Plus there may be transient issues that resolve themselves.
            this.invalidAuthTokenCount_++;
            if (this.invalidAuthTokenCount_ >= INVALID_AUTH_TOKEN_THRESHOLD) {
                // Set a long reconnect delay because recovery is unlikely
                this.reconnectDelay_ = RECONNECT_MAX_DELAY_FOR_ADMINS;
                // Notify the auth token provider that the token is invalid, which will log
                // a warning
                this.authTokenProvider_.notifyForInvalidToken();
            }
        }
    };
    PersistentConnection.prototype.onSecurityDebugPacket_ = function (body) {
        if (this.securityDebugCallback_) {
            this.securityDebugCallback_(body);
        }
        else {
            if ('msg' in body && typeof console !== 'undefined') {
                console.log('FIREBASE: ' + body['msg'].replace('\n', '\nFIREBASE: '));
            }
        }
    };
    PersistentConnection.prototype.restoreState_ = function () {
        var _this = this;
        //Re-authenticate ourselves if we have a credential stored.
        this.tryAuth();
        // Puts depend on having received the corresponding data update from the server before they complete, so we must
        // make sure to send listens before puts.
        util_1.forEach(this.listens_, function (pathString, queries) {
            util_1.forEach(queries, function (key, listenSpec) {
                _this.sendListen_(listenSpec);
            });
        });
        for (var i = 0; i < this.outstandingPuts_.length; i++) {
            if (this.outstandingPuts_[i])
                this.sendPut_(i);
        }
        while (this.onDisconnectRequestQueue_.length) {
            var request = this.onDisconnectRequestQueue_.shift();
            this.sendOnDisconnect_(request.action, request.pathString, request.data, request.onComplete);
        }
    };
    /**
     * Sends client stats for first connection
     * @private
     */
    PersistentConnection.prototype.sendConnectStats_ = function () {
        var stats = {};
        var clientName = 'js';
        if (util_6.CONSTANTS.NODE_ADMIN) {
            clientName = 'admin_node';
        }
        else if (util_6.CONSTANTS.NODE_CLIENT) {
            clientName = 'node';
        }
        stats['sdk.' + clientName + '.' + app_1.default.SDK_VERSION.replace(/\./g, '-')] = 1;
        if (util_7.isMobileCordova()) {
            stats['framework.cordova'] = 1;
        }
        else if (util_7.isReactNative()) {
            stats['framework.reactnative'] = 1;
        }
        this.reportStats(stats);
    };
    /**
     * @return {boolean}
     * @private
     */
    PersistentConnection.prototype.shouldReconnect_ = function () {
        var online = OnlineMonitor_1.OnlineMonitor.getInstance().currentlyOnline();
        return util_1.isEmpty(this.interruptReasons_) && online;
    };
    /**
     * @private
     */
    PersistentConnection.nextPersistentConnectionId_ = 0;
    /**
     * Counter for number of connections created. Mainly used for tagging in the logs
     * @type {number}
     * @private
     */
    PersistentConnection.nextConnectionId_ = 0;
    return PersistentConnection;
}(ServerActions_1.ServerActions));
exports.PersistentConnection = PersistentConnection;

//# sourceMappingURL=PersistentConnection.js.map


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Base class to be used if you want to emit events. Call the constructor with
 * the set of allowed event names.
 */
var EventEmitter = /** @class */ (function () {
    /**
     * @param {!Array.<string>} allowedEvents_
     */
    function EventEmitter(allowedEvents_) {
        this.allowedEvents_ = allowedEvents_;
        this.listeners_ = {};
        util_1.assert(Array.isArray(allowedEvents_) && allowedEvents_.length > 0, 'Requires a non-empty array');
    }
    /**
     * To be called by derived classes to trigger events.
     * @param {!string} eventType
     * @param {...*} var_args
     */
    EventEmitter.prototype.trigger = function (eventType) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (Array.isArray(this.listeners_[eventType])) {
            // Clone the list, since callbacks could add/remove listeners.
            var listeners = this.listeners_[eventType].slice();
            for (var i = 0; i < listeners.length; i++) {
                listeners[i].callback.apply(listeners[i].context, var_args);
            }
        }
    };
    EventEmitter.prototype.on = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        this.listeners_[eventType] = this.listeners_[eventType] || [];
        this.listeners_[eventType].push({ callback: callback, context: context });
        var eventData = this.getInitialEvent(eventType);
        if (eventData) {
            callback.apply(context, eventData);
        }
    };
    EventEmitter.prototype.off = function (eventType, callback, context) {
        this.validateEventType_(eventType);
        var listeners = this.listeners_[eventType] || [];
        for (var i = 0; i < listeners.length; i++) {
            if (listeners[i].callback === callback &&
                (!context || context === listeners[i].context)) {
                listeners.splice(i, 1);
                return;
            }
        }
    };
    EventEmitter.prototype.validateEventType_ = function (eventType) {
        util_1.assert(this.allowedEvents_.find(function (et) {
            return et === eventType;
        }), 'Unknown event: ' + eventType);
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;

//# sourceMappingURL=EventEmitter.js.map


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
var storage_1 = __webpack_require__(182);
var Constants_1 = __webpack_require__(183);
var TransportManager_1 = __webpack_require__(1221);
// Abort upgrade attempt if it takes longer than 60s.
var UPGRADE_TIMEOUT = 60000;
// For some transports (WebSockets), we need to "validate" the transport by exchanging a few requests and responses.
// If we haven't sent enough requests within 5s, we'll start sending noop ping requests.
var DELAY_BEFORE_SENDING_EXTRA_REQUESTS = 5000;
// If the initial data sent triggers a lot of bandwidth (i.e. it's a large put or a listen for a large amount of data)
// then we may not be able to exchange our ping/pong requests within the healthy timeout.  So if we reach the timeout
// but we've sent/received enough bytes, we don't cancel the connection.
var BYTES_SENT_HEALTHY_OVERRIDE = 10 * 1024;
var BYTES_RECEIVED_HEALTHY_OVERRIDE = 100 * 1024;
var MESSAGE_TYPE = 't';
var MESSAGE_DATA = 'd';
var CONTROL_SHUTDOWN = 's';
var CONTROL_RESET = 'r';
var CONTROL_ERROR = 'e';
var CONTROL_PONG = 'o';
var SWITCH_ACK = 'a';
var END_TRANSMISSION = 'n';
var PING = 'p';
var SERVER_HELLO = 'h';
/**
 * Creates a new real-time connection to the server using whichever method works
 * best in the current browser.
 *
 * @constructor
 */
var Connection = /** @class */ (function () {
    /**
     * @param {!string} id - an id for this connection
     * @param {!RepoInfo} repoInfo_ - the info for the endpoint to connect to
     * @param {function(Object)} onMessage_ - the callback to be triggered when a server-push message arrives
     * @param {function(number, string)} onReady_ - the callback to be triggered when this connection is ready to send messages.
     * @param {function()} onDisconnect_ - the callback to be triggered when a connection was lost
     * @param {function(string)} onKill_ - the callback to be triggered when this connection has permanently shut down.
     * @param {string=} lastSessionId - last session id in persistent connection. is used to clean up old session in real-time server
     */
    function Connection(id, repoInfo_, onMessage_, onReady_, onDisconnect_, onKill_, lastSessionId) {
        this.id = id;
        this.repoInfo_ = repoInfo_;
        this.onMessage_ = onMessage_;
        this.onReady_ = onReady_;
        this.onDisconnect_ = onDisconnect_;
        this.onKill_ = onKill_;
        this.lastSessionId = lastSessionId;
        this.connectionCount = 0;
        this.pendingDataMessages = [];
        this.state_ = 0 /* CONNECTING */;
        this.log_ = util_1.logWrapper('c:' + this.id + ':');
        this.transportManager_ = new TransportManager_1.TransportManager(repoInfo_);
        this.log_('Connection created');
        this.start_();
    }
    /**
     * Starts a connection attempt
     * @private
     */
    Connection.prototype.start_ = function () {
        var _this = this;
        var conn = this.transportManager_.initialTransport();
        this.conn_ = new conn(this.nextTransportId_(), this.repoInfo_, undefined, this.lastSessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.primaryResponsesRequired_ = conn['responsesRequiredToBeHealthy'] || 0;
        var onMessageReceived = this.connReceiver_(this.conn_);
        var onConnectionLost = this.disconnReceiver_(this.conn_);
        this.tx_ = this.conn_;
        this.rx_ = this.conn_;
        this.secondaryConn_ = null;
        this.isHealthy_ = false;
        /*
         * Firefox doesn't like when code from one iframe tries to create another iframe by way of the parent frame.
         * This can occur in the case of a redirect, i.e. we guessed wrong on what server to connect to and received a reset.
         * Somehow, setTimeout seems to make this ok. That doesn't make sense from a security perspective, since you should
         * still have the context of your originating frame.
         */
        setTimeout(function () {
            // this.conn_ gets set to null in some of the tests. Check to make sure it still exists before using it
            _this.conn_ && _this.conn_.open(onMessageReceived, onConnectionLost);
        }, Math.floor(0));
        var healthyTimeout_ms = conn['healthyTimeout'] || 0;
        if (healthyTimeout_ms > 0) {
            this.healthyTimeout_ = util_1.setTimeoutNonBlocking(function () {
                _this.healthyTimeout_ = null;
                if (!_this.isHealthy_) {
                    if (_this.conn_ &&
                        _this.conn_.bytesReceived > BYTES_RECEIVED_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has received ' +
                            _this.conn_.bytesReceived +
                            ' bytes.  Marking connection healthy.');
                        _this.isHealthy_ = true;
                        _this.conn_.markConnectionHealthy();
                    }
                    else if (_this.conn_ &&
                        _this.conn_.bytesSent > BYTES_SENT_HEALTHY_OVERRIDE) {
                        _this.log_('Connection exceeded healthy timeout but has sent ' +
                            _this.conn_.bytesSent +
                            ' bytes.  Leaving connection alive.');
                        // NOTE: We don't want to mark it healthy, since we have no guarantee that the bytes have made it to
                        // the server.
                    }
                    else {
                        _this.log_('Closing unhealthy connection after timeout.');
                        _this.close();
                    }
                }
            }, Math.floor(healthyTimeout_ms));
        }
    };
    /**
     * @return {!string}
     * @private
     */
    Connection.prototype.nextTransportId_ = function () {
        return 'c:' + this.id + ':' + this.connectionCount++;
    };
    Connection.prototype.disconnReceiver_ = function (conn) {
        var _this = this;
        return function (everConnected) {
            if (conn === _this.conn_) {
                _this.onConnectionLost_(everConnected);
            }
            else if (conn === _this.secondaryConn_) {
                _this.log_('Secondary connection lost.');
                _this.onSecondaryConnectionLost_();
            }
            else {
                _this.log_('closing an old connection');
            }
        };
    };
    Connection.prototype.connReceiver_ = function (conn) {
        var _this = this;
        return function (message) {
            if (_this.state_ != 2 /* DISCONNECTED */) {
                if (conn === _this.rx_) {
                    _this.onPrimaryMessageReceived_(message);
                }
                else if (conn === _this.secondaryConn_) {
                    _this.onSecondaryMessageReceived_(message);
                }
                else {
                    _this.log_('message on old connection');
                }
            }
        };
    };
    /**
     *
     * @param {Object} dataMsg An arbitrary data message to be sent to the server
     */
    Connection.prototype.sendRequest = function (dataMsg) {
        // wrap in a data message envelope and send it on
        var msg = { t: 'd', d: dataMsg };
        this.sendData_(msg);
    };
    Connection.prototype.tryCleanupConnection = function () {
        if (this.tx_ === this.secondaryConn_ && this.rx_ === this.secondaryConn_) {
            this.log_('cleaning up and promoting a connection: ' + this.secondaryConn_.connId);
            this.conn_ = this.secondaryConn_;
            this.secondaryConn_ = null;
            // the server will shutdown the old connection
        }
    };
    Connection.prototype.onSecondaryControl_ = function (controlData) {
        if (MESSAGE_TYPE in controlData) {
            var cmd = controlData[MESSAGE_TYPE];
            if (cmd === SWITCH_ACK) {
                this.upgradeIfSecondaryHealthy_();
            }
            else if (cmd === CONTROL_RESET) {
                // Most likely the session wasn't valid. Abandon the switch attempt
                this.log_('Got a reset on secondary, closing it');
                this.secondaryConn_.close();
                // If we were already using this connection for something, than we need to fully close
                if (this.tx_ === this.secondaryConn_ ||
                    this.rx_ === this.secondaryConn_) {
                    this.close();
                }
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on secondary.');
                this.secondaryResponsesRequired_--;
                this.upgradeIfSecondaryHealthy_();
            }
        }
    };
    Connection.prototype.onSecondaryMessageReceived_ = function (parsedData) {
        var layer = util_1.requireKey('t', parsedData);
        var data = util_1.requireKey('d', parsedData);
        if (layer == 'c') {
            this.onSecondaryControl_(data);
        }
        else if (layer == 'd') {
            // got a data message, but we're still second connection. Need to buffer it up
            this.pendingDataMessages.push(data);
        }
        else {
            throw new Error('Unknown protocol layer: ' + layer);
        }
    };
    Connection.prototype.upgradeIfSecondaryHealthy_ = function () {
        if (this.secondaryResponsesRequired_ <= 0) {
            this.log_('Secondary connection is healthy.');
            this.isHealthy_ = true;
            this.secondaryConn_.markConnectionHealthy();
            this.proceedWithUpgrade_();
        }
        else {
            // Send a ping to make sure the connection is healthy.
            this.log_('sending ping on secondary.');
            this.secondaryConn_.send({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.proceedWithUpgrade_ = function () {
        // tell this connection to consider itself open
        this.secondaryConn_.start();
        // send ack
        this.log_('sending client ack on secondary');
        this.secondaryConn_.send({ t: 'c', d: { t: SWITCH_ACK, d: {} } });
        // send end packet on primary transport, switch to sending on this one
        // can receive on this one, buffer responses until end received on primary transport
        this.log_('Ending transmission on primary');
        this.conn_.send({ t: 'c', d: { t: END_TRANSMISSION, d: {} } });
        this.tx_ = this.secondaryConn_;
        this.tryCleanupConnection();
    };
    Connection.prototype.onPrimaryMessageReceived_ = function (parsedData) {
        // Must refer to parsedData properties in quotes, so closure doesn't touch them.
        var layer = util_1.requireKey('t', parsedData);
        var data = util_1.requireKey('d', parsedData);
        if (layer == 'c') {
            this.onControl_(data);
        }
        else if (layer == 'd') {
            this.onDataMessage_(data);
        }
    };
    Connection.prototype.onDataMessage_ = function (message) {
        this.onPrimaryResponse_();
        // We don't do anything with data messages, just kick them up a level
        this.onMessage_(message);
    };
    Connection.prototype.onPrimaryResponse_ = function () {
        if (!this.isHealthy_) {
            this.primaryResponsesRequired_--;
            if (this.primaryResponsesRequired_ <= 0) {
                this.log_('Primary connection is healthy.');
                this.isHealthy_ = true;
                this.conn_.markConnectionHealthy();
            }
        }
    };
    Connection.prototype.onControl_ = function (controlData) {
        var cmd = util_1.requireKey(MESSAGE_TYPE, controlData);
        if (MESSAGE_DATA in controlData) {
            var payload = controlData[MESSAGE_DATA];
            if (cmd === SERVER_HELLO) {
                this.onHandshake_(payload);
            }
            else if (cmd === END_TRANSMISSION) {
                this.log_('recvd end transmission on primary');
                this.rx_ = this.secondaryConn_;
                for (var i = 0; i < this.pendingDataMessages.length; ++i) {
                    this.onDataMessage_(this.pendingDataMessages[i]);
                }
                this.pendingDataMessages = [];
                this.tryCleanupConnection();
            }
            else if (cmd === CONTROL_SHUTDOWN) {
                // This was previously the 'onKill' callback passed to the lower-level connection
                // payload in this case is the reason for the shutdown. Generally a human-readable error
                this.onConnectionShutdown_(payload);
            }
            else if (cmd === CONTROL_RESET) {
                // payload in this case is the host we should contact
                this.onReset_(payload);
            }
            else if (cmd === CONTROL_ERROR) {
                util_1.error('Server Error: ' + payload);
            }
            else if (cmd === CONTROL_PONG) {
                this.log_('got pong on primary.');
                this.onPrimaryResponse_();
                this.sendPingOnPrimaryIfNecessary_();
            }
            else {
                util_1.error('Unknown control packet command: ' + cmd);
            }
        }
    };
    /**
     *
     * @param {Object} handshake The handshake data returned from the server
     * @private
     */
    Connection.prototype.onHandshake_ = function (handshake) {
        var timestamp = handshake.ts;
        var version = handshake.v;
        var host = handshake.h;
        this.sessionId = handshake.s;
        this.repoInfo_.updateHost(host);
        // if we've already closed the connection, then don't bother trying to progress further
        if (this.state_ == 0 /* CONNECTING */) {
            this.conn_.start();
            this.onConnectionEstablished_(this.conn_, timestamp);
            if (Constants_1.PROTOCOL_VERSION !== version) {
                util_1.warn('Protocol version mismatch detected');
            }
            // TODO: do we want to upgrade? when? maybe a delay?
            this.tryStartUpgrade_();
        }
    };
    Connection.prototype.tryStartUpgrade_ = function () {
        var conn = this.transportManager_.upgradeTransport();
        if (conn) {
            this.startUpgrade_(conn);
        }
    };
    Connection.prototype.startUpgrade_ = function (conn) {
        var _this = this;
        this.secondaryConn_ = new conn(this.nextTransportId_(), this.repoInfo_, this.sessionId);
        // For certain transports (WebSockets), we need to send and receive several messages back and forth before we
        // can consider the transport healthy.
        this.secondaryResponsesRequired_ =
            conn['responsesRequiredToBeHealthy'] || 0;
        var onMessage = this.connReceiver_(this.secondaryConn_);
        var onDisconnect = this.disconnReceiver_(this.secondaryConn_);
        this.secondaryConn_.open(onMessage, onDisconnect);
        // If we haven't successfully upgraded after UPGRADE_TIMEOUT, give up and kill the secondary.
        util_1.setTimeoutNonBlocking(function () {
            if (_this.secondaryConn_) {
                _this.log_('Timed out trying to upgrade.');
                _this.secondaryConn_.close();
            }
        }, Math.floor(UPGRADE_TIMEOUT));
    };
    Connection.prototype.onReset_ = function (host) {
        this.log_('Reset packet received.  New host: ' + host);
        this.repoInfo_.updateHost(host);
        // TODO: if we're already "connected", we need to trigger a disconnect at the next layer up.
        // We don't currently support resets after the connection has already been established
        if (this.state_ === 1 /* CONNECTED */) {
            this.close();
        }
        else {
            // Close whatever connections we have open and start again.
            this.closeConnections_();
            this.start_();
        }
    };
    Connection.prototype.onConnectionEstablished_ = function (conn, timestamp) {
        var _this = this;
        this.log_('Realtime connection established.');
        this.conn_ = conn;
        this.state_ = 1 /* CONNECTED */;
        if (this.onReady_) {
            this.onReady_(timestamp, this.sessionId);
            this.onReady_ = null;
        }
        // If after 5 seconds we haven't sent enough requests to the server to get the connection healthy,
        // send some pings.
        if (this.primaryResponsesRequired_ === 0) {
            this.log_('Primary connection is healthy.');
            this.isHealthy_ = true;
        }
        else {
            util_1.setTimeoutNonBlocking(function () {
                _this.sendPingOnPrimaryIfNecessary_();
            }, Math.floor(DELAY_BEFORE_SENDING_EXTRA_REQUESTS));
        }
    };
    Connection.prototype.sendPingOnPrimaryIfNecessary_ = function () {
        // If the connection isn't considered healthy yet, we'll send a noop ping packet request.
        if (!this.isHealthy_ && this.state_ === 1 /* CONNECTED */) {
            this.log_('sending ping on primary.');
            this.sendData_({ t: 'c', d: { t: PING, d: {} } });
        }
    };
    Connection.prototype.onSecondaryConnectionLost_ = function () {
        var conn = this.secondaryConn_;
        this.secondaryConn_ = null;
        if (this.tx_ === conn || this.rx_ === conn) {
            // we are relying on this connection already in some capacity. Therefore, a failure is real
            this.close();
        }
    };
    /**
     *
     * @param {boolean} everConnected Whether or not the connection ever reached a server. Used to determine if
     * we should flush the host cache
     * @private
     */
    Connection.prototype.onConnectionLost_ = function (everConnected) {
        this.conn_ = null;
        // NOTE: IF you're seeing a Firefox error for this line, I think it might be because it's getting
        // called on window close and RealtimeState.CONNECTING is no longer defined.  Just a guess.
        if (!everConnected && this.state_ === 0 /* CONNECTING */) {
            this.log_('Realtime connection failed.');
            // Since we failed to connect at all, clear any cached entry for this namespace in case the machine went away
            if (this.repoInfo_.isCacheableHost()) {
                storage_1.PersistentStorage.remove('host:' + this.repoInfo_.host);
                // reset the internal host to what we would show the user, i.e. <ns>.firebaseio.com
                this.repoInfo_.internalHost = this.repoInfo_.host;
            }
        }
        else if (this.state_ === 1 /* CONNECTED */) {
            this.log_('Realtime connection lost.');
        }
        this.close();
    };
    /**
     *
     * @param {string} reason
     * @private
     */
    Connection.prototype.onConnectionShutdown_ = function (reason) {
        this.log_('Connection shutdown command received. Shutting down...');
        if (this.onKill_) {
            this.onKill_(reason);
            this.onKill_ = null;
        }
        // We intentionally don't want to fire onDisconnect (kill is a different case),
        // so clear the callback.
        this.onDisconnect_ = null;
        this.close();
    };
    Connection.prototype.sendData_ = function (data) {
        if (this.state_ !== 1 /* CONNECTED */) {
            throw 'Connection is not connected';
        }
        else {
            this.tx_.send(data);
        }
    };
    /**
     * Cleans up this connection, calling the appropriate callbacks
     */
    Connection.prototype.close = function () {
        if (this.state_ !== 2 /* DISCONNECTED */) {
            this.log_('Closing realtime connection.');
            this.state_ = 2 /* DISCONNECTED */;
            this.closeConnections_();
            if (this.onDisconnect_) {
                this.onDisconnect_();
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     *
     * @private
     */
    Connection.prototype.closeConnections_ = function () {
        this.log_('Shutting down all connections');
        if (this.conn_) {
            this.conn_.close();
            this.conn_ = null;
        }
        if (this.secondaryConn_) {
            this.secondaryConn_.close();
            this.secondaryConn_ = null;
        }
        if (this.healthyTimeout_) {
            clearTimeout(this.healthyTimeout_);
            this.healthyTimeout_ = null;
        }
    };
    return Connection;
}());
exports.Connection = Connection;

//# sourceMappingURL=Connection.js.map


/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
var CountedSet_1 = __webpack_require__(474);
var StatsManager_1 = __webpack_require__(272);
var PacketReceiver_1 = __webpack_require__(1222);
var Constants_1 = __webpack_require__(183);
var util_2 = __webpack_require__(6);
var util_3 = __webpack_require__(6);
// URL query parameters associated with longpolling
exports.FIREBASE_LONGPOLL_START_PARAM = 'start';
exports.FIREBASE_LONGPOLL_CLOSE_COMMAND = 'close';
exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME = 'pLPCommand';
exports.FIREBASE_LONGPOLL_DATA_CB_NAME = 'pRTLPCB';
exports.FIREBASE_LONGPOLL_ID_PARAM = 'id';
exports.FIREBASE_LONGPOLL_PW_PARAM = 'pw';
exports.FIREBASE_LONGPOLL_SERIAL_PARAM = 'ser';
exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM = 'cb';
exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM = 'seg';
exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET = 'ts';
exports.FIREBASE_LONGPOLL_DATA_PARAM = 'd';
exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM = 'disconn';
exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM = 'dframe';
//Data size constants.
//TODO: Perf: the maximum length actually differs from browser to browser.
// We should check what browser we're on and set accordingly.
var MAX_URL_DATA_SIZE = 1870;
var SEG_HEADER_SIZE = 30; //ie: &seg=8299234&ts=982389123&d=
var MAX_PAYLOAD_SIZE = MAX_URL_DATA_SIZE - SEG_HEADER_SIZE;
/**
 * Keepalive period
 * send a fresh request at minimum every 25 seconds. Opera has a maximum request
 * length of 30 seconds that we can't exceed.
 * @const
 * @type {number}
 */
var KEEPALIVE_REQUEST_INTERVAL = 25000;
/**
 * How long to wait before aborting a long-polling connection attempt.
 * @const
 * @type {number}
 */
var LP_CONNECT_TIMEOUT = 30000;
/**
 * This class manages a single long-polling connection.
 *
 * @constructor
 * @implements {Transport}
 */
var BrowserPollConnection = /** @class */ (function () {
    /**
     * @param {string} connId An identifier for this connection, used for logging
     * @param {RepoInfo} repoInfo The info for the endpoint to send data to.
     * @param {string=} transportSessionId Optional transportSessionid if we are reconnecting for an existing
     *                                         transport session
     * @param {string=}  lastSessionId Optional lastSessionId if the PersistentConnection has already created a
     *                                     connection previously
     */
    function BrowserPollConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.repoInfo = repoInfo;
        this.transportSessionId = transportSessionId;
        this.lastSessionId = lastSessionId;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.everConnected_ = false;
        this.log_ = util_1.logWrapper(connId);
        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
        this.urlFn = function (params) {
            return repoInfo.connectionURL(Constants_1.LONG_POLLING, params);
        };
    }
    /**
     *
     * @param {function(Object)} onMessage Callback when messages arrive
     * @param {function()} onDisconnect Callback with connection lost.
     */
    BrowserPollConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.curSegmentNum = 0;
        this.onDisconnect_ = onDisconnect;
        this.myPacketOrderer = new PacketReceiver_1.PacketReceiver(onMessage);
        this.isClosed_ = false;
        this.connectTimeoutTimer_ = setTimeout(function () {
            _this.log_('Timed out trying to connect.');
            // Make sure we clear the host cache
            _this.onClosed_();
            _this.connectTimeoutTimer_ = null;
        }, Math.floor(LP_CONNECT_TIMEOUT));
        // Ensure we delay the creation of the iframe until the DOM is loaded.
        util_1.executeWhenDOMReady(function () {
            if (_this.isClosed_)
                return;
            //Set up a callback that gets triggered once a connection is set up.
            _this.scriptTagHolder = new FirebaseIFrameScriptHolder(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var command = args[0], arg1 = args[1], arg2 = args[2], arg3 = args[3], arg4 = args[4];
                _this.incrementIncomingBytes_(args);
                if (!_this.scriptTagHolder)
                    return; // we closed the connection.
                if (_this.connectTimeoutTimer_) {
                    clearTimeout(_this.connectTimeoutTimer_);
                    _this.connectTimeoutTimer_ = null;
                }
                _this.everConnected_ = true;
                if (command == exports.FIREBASE_LONGPOLL_START_PARAM) {
                    _this.id = arg1;
                    _this.password = arg2;
                }
                else if (command === exports.FIREBASE_LONGPOLL_CLOSE_COMMAND) {
                    // Don't clear the host cache. We got a response from the server, so we know it's reachable
                    if (arg1) {
                        // We aren't expecting any more data (other than what the server's already in the process of sending us
                        // through our already open polls), so don't send any more.
                        _this.scriptTagHolder.sendNewPolls = false;
                        // arg1 in this case is the last response number sent by the server. We should try to receive
                        // all of the responses up to this one before closing
                        _this.myPacketOrderer.closeAfter(arg1, function () {
                            _this.onClosed_();
                        });
                    }
                    else {
                        _this.onClosed_();
                    }
                }
                else {
                    throw new Error('Unrecognized command received: ' + command);
                }
            }, function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var pN = args[0], data = args[1];
                _this.incrementIncomingBytes_(args);
                _this.myPacketOrderer.handleResponse(pN, data);
            }, function () {
                _this.onClosed_();
            }, _this.urlFn);
            //Send the initial request to connect. The serial number is simply to keep the browser from pulling previous results
            //from cache.
            var urlParams = {};
            urlParams[exports.FIREBASE_LONGPOLL_START_PARAM] = 't';
            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = Math.floor(Math.random() * 100000000);
            if (_this.scriptTagHolder.uniqueCallbackIdentifier)
                urlParams[exports.FIREBASE_LONGPOLL_CALLBACK_ID_PARAM] = _this.scriptTagHolder.uniqueCallbackIdentifier;
            urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
            if (_this.transportSessionId) {
                urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = _this.transportSessionId;
            }
            if (_this.lastSessionId) {
                urlParams[Constants_1.LAST_SESSION_PARAM] = _this.lastSessionId;
            }
            if (!util_3.isNodeSdk() &&
                typeof location !== 'undefined' &&
                location.href &&
                location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
                urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
            }
            var connectURL = _this.urlFn(urlParams);
            _this.log_('Connecting via long-poll to ' + connectURL);
            _this.scriptTagHolder.addTag(connectURL, function () {
                /* do nothing */
            });
        });
    };
    /**
     * Call this when a handshake has completed successfully and we want to consider the connection established
     */
    BrowserPollConnection.prototype.start = function () {
        this.scriptTagHolder.startLongPoll(this.id, this.password);
        this.addDisconnectPingFrame(this.id, this.password);
    };
    /**
     * Forces long polling to be considered as a potential transport
     */
    BrowserPollConnection.forceAllow = function () {
        BrowserPollConnection.forceAllow_ = true;
    };
    /**
     * Forces longpolling to not be considered as a potential transport
     */
    BrowserPollConnection.forceDisallow = function () {
        BrowserPollConnection.forceDisallow_ = true;
    };
    // Static method, use string literal so it can be accessed in a generic way
    BrowserPollConnection.isAvailable = function () {
        // NOTE: In React-Native there's normally no 'document', but if you debug a React-Native app in
        // the Chrome debugger, 'document' is defined, but document.createElement is null (2015/06/08).
        return (BrowserPollConnection.forceAllow_ ||
            (!BrowserPollConnection.forceDisallow_ &&
                typeof document !== 'undefined' &&
                document.createElement != null &&
                !util_1.isChromeExtensionContentScript() &&
                !util_1.isWindowsStoreApp() &&
                !util_3.isNodeSdk()));
    };
    /**
     * No-op for polling
     */
    BrowserPollConnection.prototype.markConnectionHealthy = function () { };
    /**
     * Stops polling and cleans up the iframe
     * @private
     */
    BrowserPollConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.scriptTagHolder) {
            this.scriptTagHolder.close();
            this.scriptTagHolder = null;
        }
        //remove the disconnect frame, which will trigger an XHR call to the server to tell it we're leaving.
        if (this.myDisconnFrame) {
            document.body.removeChild(this.myDisconnFrame);
            this.myDisconnFrame = null;
        }
        if (this.connectTimeoutTimer_) {
            clearTimeout(this.connectTimeoutTimer_);
            this.connectTimeoutTimer_ = null;
        }
    };
    /**
     * Triggered when this transport is closed
     * @private
     */
    BrowserPollConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is closing itself');
            this.shutdown_();
            if (this.onDisconnect_) {
                this.onDisconnect_(this.everConnected_);
                this.onDisconnect_ = null;
            }
        }
    };
    /**
     * External-facing close handler. RealTime has requested we shut down. Kill our connection and tell the server
     * that we've left.
     */
    BrowserPollConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('Longpoll is being closed.');
            this.shutdown_();
        }
    };
    /**
     * Send the JSON object down to the server. It will need to be stringified, base64 encoded, and then
     * broken into chunks (since URLs have a small maximum length).
     * @param {!Object} data The JSON data to transmit.
     */
    BrowserPollConnection.prototype.send = function (data) {
        var dataStr = util_2.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //first, lets get the base64-encoded data
        var base64data = util_2.base64Encode(dataStr);
        //We can only fit a certain amount in each URL, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = util_1.splitStringBySize(base64data, MAX_PAYLOAD_SIZE);
        //Enqueue each segment for transmission. We assign each chunk a sequential ID and a total number
        //of segments so that we can reassemble the packet on the server.
        for (var i = 0; i < dataSegs.length; i++) {
            this.scriptTagHolder.enqueueSegment(this.curSegmentNum, dataSegs.length, dataSegs[i]);
            this.curSegmentNum++;
        }
    };
    /**
     * This is how we notify the server that we're leaving.
     * We aren't able to send requests with DHTML on a window close event, but we can
     * trigger XHR requests in some browsers (everything but Opera basically).
     * @param {!string} id
     * @param {!string} pw
     */
    BrowserPollConnection.prototype.addDisconnectPingFrame = function (id, pw) {
        if (util_3.isNodeSdk())
            return;
        this.myDisconnFrame = document.createElement('iframe');
        var urlParams = {};
        urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_REQUEST_PARAM] = 't';
        urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = id;
        urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = pw;
        this.myDisconnFrame.src = this.urlFn(urlParams);
        this.myDisconnFrame.style.display = 'none';
        document.body.appendChild(this.myDisconnFrame);
    };
    /**
     * Used to track the bytes received by this client
     * @param {*} args
     * @private
     */
    BrowserPollConnection.prototype.incrementIncomingBytes_ = function (args) {
        // TODO: This is an annoying perf hit just to track the number of incoming bytes.  Maybe it should be opt-in.
        var bytesReceived = util_2.stringify(args).length;
        this.bytesReceived += bytesReceived;
        this.stats_.incrementCounter('bytes_received', bytesReceived);
    };
    return BrowserPollConnection;
}());
exports.BrowserPollConnection = BrowserPollConnection;
/*********************************************************************************************
 * A wrapper around an iframe that is used as a long-polling script holder.
 * @constructor
 *********************************************************************************************/
var FirebaseIFrameScriptHolder = /** @class */ (function () {
    /**
     * @param commandCB - The callback to be called when control commands are recevied from the server.
     * @param onMessageCB - The callback to be triggered when responses arrive from the server.
     * @param onDisconnect - The callback to be triggered when this tag holder is closed
     * @param urlFn - A function that provides the URL of the endpoint to send data to.
     */
    function FirebaseIFrameScriptHolder(commandCB, onMessageCB, onDisconnect, urlFn) {
        this.onDisconnect = onDisconnect;
        this.urlFn = urlFn;
        //We maintain a count of all of the outstanding requests, because if we have too many active at once it can cause
        //problems in some browsers.
        /**
         * @type {CountedSet.<number, number>}
         */
        this.outstandingRequests = new CountedSet_1.CountedSet();
        //A queue of the pending segments waiting for transmission to the server.
        this.pendingSegs = [];
        //A serial number. We use this for two things:
        // 1) A way to ensure the browser doesn't cache responses to polls
        // 2) A way to make the server aware when long-polls arrive in a different order than we started them. The
        //    server needs to release both polls in this case or it will cause problems in Opera since Opera can only execute
        //    JSONP code in the order it was added to the iframe.
        this.currentSerial = Math.floor(Math.random() * 100000000);
        // This gets set to false when we're "closing down" the connection (e.g. we're switching transports but there's still
        // incoming data from the server that we're waiting for).
        this.sendNewPolls = true;
        if (!util_3.isNodeSdk()) {
            //Each script holder registers a couple of uniquely named callbacks with the window. These are called from the
            //iframes where we put the long-polling script tags. We have two callbacks:
            //   1) Command Callback - Triggered for control issues, like starting a connection.
            //   2) Message Callback - Triggered when new data arrives.
            this.uniqueCallbackIdentifier = util_1.LUIDGenerator();
            window[exports.FIREBASE_LONGPOLL_COMMAND_CB_NAME + this.uniqueCallbackIdentifier] = commandCB;
            window[exports.FIREBASE_LONGPOLL_DATA_CB_NAME + this.uniqueCallbackIdentifier] = onMessageCB;
            //Create an iframe for us to add script tags to.
            this.myIFrame = FirebaseIFrameScriptHolder.createIFrame_();
            // Set the iframe's contents.
            var script = '';
            // if we set a javascript url, it's IE and we need to set the document domain. The javascript url is sufficient
            // for ie9, but ie8 needs to do it again in the document itself.
            if (this.myIFrame.src &&
                this.myIFrame.src.substr(0, 'javascript:'.length) === 'javascript:') {
                var currentDomain = document.domain;
                script = '<script>document.domain="' + currentDomain + '";</script>';
            }
            var iframeContents = '<html><body>' + script + '</body></html>';
            try {
                this.myIFrame.doc.open();
                this.myIFrame.doc.write(iframeContents);
                this.myIFrame.doc.close();
            }
            catch (e) {
                util_1.log('frame writing exception');
                if (e.stack) {
                    util_1.log(e.stack);
                }
                util_1.log(e);
            }
        }
        else {
            this.commandCB = commandCB;
            this.onMessageCB = onMessageCB;
        }
    }
    /**
     * Each browser has its own funny way to handle iframes. Here we mush them all together into one object that I can
     * actually use.
     * @private
     * @return {Element}
     */
    FirebaseIFrameScriptHolder.createIFrame_ = function () {
        var iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        // This is necessary in order to initialize the document inside the iframe
        if (document.body) {
            document.body.appendChild(iframe);
            try {
                // If document.domain has been modified in IE, this will throw an error, and we need to set the
                // domain of the iframe's document manually. We can do this via a javascript: url as the src attribute
                // Also note that we must do this *after* the iframe has been appended to the page. Otherwise it doesn't work.
                var a = iframe.contentWindow.document;
                if (!a) {
                    // Apologies for the log-spam, I need to do something to keep closure from optimizing out the assignment above.
                    util_1.log('No IE domain setting required');
                }
            }
            catch (e) {
                var domain = document.domain;
                iframe.src =
                    "javascript:void((function(){document.open();document.domain='" +
                        domain +
                        "';document.close();})())";
            }
        }
        else {
            // LongPollConnection attempts to delay initialization until the document is ready, so hopefully this
            // never gets hit.
            throw 'Document body has not initialized. Wait to initialize Firebase until after the document is ready.';
        }
        // Get the document of the iframe in a browser-specific way.
        if (iframe.contentDocument) {
            iframe.doc = iframe.contentDocument; // Firefox, Opera, Safari
        }
        else if (iframe.contentWindow) {
            iframe.doc = iframe.contentWindow.document; // Internet Explorer
        }
        else if (iframe.document) {
            iframe.doc = iframe.document; //others?
        }
        return iframe;
    };
    /**
     * Cancel all outstanding queries and remove the frame.
     */
    FirebaseIFrameScriptHolder.prototype.close = function () {
        var _this = this;
        //Mark this iframe as dead, so no new requests are sent.
        this.alive = false;
        if (this.myIFrame) {
            //We have to actually remove all of the html inside this iframe before removing it from the
            //window, or IE will continue loading and executing the script tags we've already added, which
            //can lead to some errors being thrown. Setting innerHTML seems to be the easiest way to do this.
            this.myIFrame.doc.body.innerHTML = '';
            setTimeout(function () {
                if (_this.myIFrame !== null) {
                    document.body.removeChild(_this.myIFrame);
                    _this.myIFrame = null;
                }
            }, Math.floor(0));
        }
        if (util_3.isNodeSdk() && this.myID) {
            var urlParams = {};
            urlParams[exports.FIREBASE_LONGPOLL_DISCONN_FRAME_PARAM] = 't';
            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            var theURL = this.urlFn(urlParams);
            FirebaseIFrameScriptHolder.nodeRestRequest(theURL);
        }
        // Protect from being called recursively.
        var onDisconnect = this.onDisconnect;
        if (onDisconnect) {
            this.onDisconnect = null;
            onDisconnect();
        }
    };
    /**
     * Actually start the long-polling session by adding the first script tag(s) to the iframe.
     * @param {!string} id - The ID of this connection
     * @param {!string} pw - The password for this connection
     */
    FirebaseIFrameScriptHolder.prototype.startLongPoll = function (id, pw) {
        this.myID = id;
        this.myPW = pw;
        this.alive = true;
        //send the initial request. If there are requests queued, make sure that we transmit as many as we are currently able to.
        while (this.newRequest_()) { }
    };
    /**
     * This is called any time someone might want a script tag to be added. It adds a script tag when there aren't
     * too many outstanding requests and we are still alive.
     *
     * If there are outstanding packet segments to send, it sends one. If there aren't, it sends a long-poll anyways if
     * needed.
     */
    FirebaseIFrameScriptHolder.prototype.newRequest_ = function () {
        // We keep one outstanding request open all the time to receive data, but if we need to send data
        // (pendingSegs.length > 0) then we create a new request to send the data.  The server will automatically
        // close the old request.
        if (this.alive &&
            this.sendNewPolls &&
            this.outstandingRequests.count() < (this.pendingSegs.length > 0 ? 2 : 1)) {
            //construct our url
            this.currentSerial++;
            var urlParams = {};
            urlParams[exports.FIREBASE_LONGPOLL_ID_PARAM] = this.myID;
            urlParams[exports.FIREBASE_LONGPOLL_PW_PARAM] = this.myPW;
            urlParams[exports.FIREBASE_LONGPOLL_SERIAL_PARAM] = this.currentSerial;
            var theURL = this.urlFn(urlParams);
            //Now add as much data as we can.
            var curDataString = '';
            var i = 0;
            while (this.pendingSegs.length > 0) {
                //first, lets see if the next segment will fit.
                var nextSeg = this.pendingSegs[0];
                if (nextSeg.d.length + SEG_HEADER_SIZE + curDataString.length <=
                    MAX_URL_DATA_SIZE) {
                    //great, the segment will fit. Lets append it.
                    var theSeg = this.pendingSegs.shift();
                    curDataString =
                        curDataString +
                            '&' +
                            exports.FIREBASE_LONGPOLL_SEGMENT_NUM_PARAM +
                            i +
                            '=' +
                            theSeg.seg +
                            '&' +
                            exports.FIREBASE_LONGPOLL_SEGMENTS_IN_PACKET +
                            i +
                            '=' +
                            theSeg.ts +
                            '&' +
                            exports.FIREBASE_LONGPOLL_DATA_PARAM +
                            i +
                            '=' +
                            theSeg.d;
                    i++;
                }
                else {
                    break;
                }
            }
            theURL = theURL + curDataString;
            this.addLongPollTag_(theURL, this.currentSerial);
            return true;
        }
        else {
            return false;
        }
    };
    /**
     * Queue a packet for transmission to the server.
     * @param segnum - A sequential id for this packet segment used for reassembly
     * @param totalsegs - The total number of segments in this packet
     * @param data - The data for this segment.
     */
    FirebaseIFrameScriptHolder.prototype.enqueueSegment = function (segnum, totalsegs, data) {
        //add this to the queue of segments to send.
        this.pendingSegs.push({ seg: segnum, ts: totalsegs, d: data });
        //send the data immediately if there isn't already data being transmitted, unless
        //startLongPoll hasn't been called yet.
        if (this.alive) {
            this.newRequest_();
        }
    };
    /**
     * Add a script tag for a regular long-poll request.
     * @param {!string} url - The URL of the script tag.
     * @param {!number} serial - The serial number of the request.
     * @private
     */
    FirebaseIFrameScriptHolder.prototype.addLongPollTag_ = function (url, serial) {
        var _this = this;
        //remember that we sent this request.
        this.outstandingRequests.add(serial, 1);
        var doNewRequest = function () {
            _this.outstandingRequests.remove(serial);
            _this.newRequest_();
        };
        // If this request doesn't return on its own accord (by the server sending us some data), we'll
        // create a new one after the KEEPALIVE interval to make sure we always keep a fresh request open.
        var keepaliveTimeout = setTimeout(doNewRequest, Math.floor(KEEPALIVE_REQUEST_INTERVAL));
        var readyStateCB = function () {
            // Request completed.  Cancel the keepalive.
            clearTimeout(keepaliveTimeout);
            // Trigger a new request so we can continue receiving data.
            doNewRequest();
        };
        this.addTag(url, readyStateCB);
    };
    /**
     * Add an arbitrary script tag to the iframe.
     * @param {!string} url - The URL for the script tag source.
     * @param {!function()} loadCB - A callback to be triggered once the script has loaded.
     */
    FirebaseIFrameScriptHolder.prototype.addTag = function (url, loadCB) {
        var _this = this;
        if (util_3.isNodeSdk()) {
            this.doNodeLongPoll(url, loadCB);
        }
        else {
            setTimeout(function () {
                try {
                    // if we're already closed, don't add this poll
                    if (!_this.sendNewPolls)
                        return;
                    var newScript_1 = _this.myIFrame.doc.createElement('script');
                    newScript_1.type = 'text/javascript';
                    newScript_1.async = true;
                    newScript_1.src = url;
                    newScript_1.onload = newScript_1.onreadystatechange = function () {
                        var rstate = newScript_1.readyState;
                        if (!rstate || rstate === 'loaded' || rstate === 'complete') {
                            newScript_1.onload = newScript_1.onreadystatechange = null;
                            if (newScript_1.parentNode) {
                                newScript_1.parentNode.removeChild(newScript_1);
                            }
                            loadCB();
                        }
                    };
                    newScript_1.onerror = function () {
                        util_1.log('Long-poll script failed to load: ' + url);
                        _this.sendNewPolls = false;
                        _this.close();
                    };
                    _this.myIFrame.doc.body.appendChild(newScript_1);
                }
                catch (e) {
                    // TODO: we should make this error visible somehow
                }
            }, Math.floor(1));
        }
    };
    return FirebaseIFrameScriptHolder;
}());
exports.FirebaseIFrameScriptHolder = FirebaseIFrameScriptHolder;

//# sourceMappingURL=BrowserPollConnection.js.map


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(93);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var StatsManager_1 = __webpack_require__(272);
var Constants_1 = __webpack_require__(183);
var util_3 = __webpack_require__(6);
var storage_1 = __webpack_require__(182);
var util_4 = __webpack_require__(6);
var util_5 = __webpack_require__(6);
var WEBSOCKET_MAX_FRAME_SIZE = 16384;
var WEBSOCKET_KEEPALIVE_INTERVAL = 45000;
var WebSocketImpl = null;
if (typeof MozWebSocket !== 'undefined') {
    WebSocketImpl = MozWebSocket;
}
else if (typeof WebSocket !== 'undefined') {
    WebSocketImpl = WebSocket;
}
function setWebSocketImpl(impl) {
    WebSocketImpl = impl;
}
exports.setWebSocketImpl = setWebSocketImpl;
/**
 * Create a new websocket connection with the given callbacks.
 * @constructor
 * @implements {Transport}
 */
var WebSocketConnection = /** @class */ (function () {
    /**
     * @param {string} connId identifier for this transport
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     */
    function WebSocketConnection(connId, repoInfo, transportSessionId, lastSessionId) {
        this.connId = connId;
        this.keepaliveTimer = null;
        this.frames = null;
        this.totalFrames = 0;
        this.bytesSent = 0;
        this.bytesReceived = 0;
        this.log_ = util_2.logWrapper(this.connId);
        this.stats_ = StatsManager_1.StatsManager.getCollection(repoInfo);
        this.connURL = WebSocketConnection.connectionURL_(repoInfo, transportSessionId, lastSessionId);
    }
    /**
     * @param {RepoInfo} repoInfo The info for the websocket endpoint.
     * @param {string=} transportSessionId Optional transportSessionId if this is connecting to an existing transport
     *                                         session
     * @param {string=} lastSessionId Optional lastSessionId if there was a previous connection
     * @return {string} connection url
     * @private
     */
    WebSocketConnection.connectionURL_ = function (repoInfo, transportSessionId, lastSessionId) {
        var urlParams = {};
        urlParams[Constants_1.VERSION_PARAM] = Constants_1.PROTOCOL_VERSION;
        if (!util_5.isNodeSdk() &&
            typeof location !== 'undefined' &&
            location.href &&
            location.href.indexOf(Constants_1.FORGE_DOMAIN) !== -1) {
            urlParams[Constants_1.REFERER_PARAM] = Constants_1.FORGE_REF;
        }
        if (transportSessionId) {
            urlParams[Constants_1.TRANSPORT_SESSION_PARAM] = transportSessionId;
        }
        if (lastSessionId) {
            urlParams[Constants_1.LAST_SESSION_PARAM] = lastSessionId;
        }
        return repoInfo.connectionURL(Constants_1.WEBSOCKET, urlParams);
    };
    /**
     *
     * @param onMessage Callback when messages arrive
     * @param onDisconnect Callback with connection lost.
     */
    WebSocketConnection.prototype.open = function (onMessage, onDisconnect) {
        var _this = this;
        this.onDisconnect = onDisconnect;
        this.onMessage = onMessage;
        this.log_('Websocket connecting to ' + this.connURL);
        this.everConnected_ = false;
        // Assume failure until proven otherwise.
        storage_1.PersistentStorage.set('previous_websocket_failure', true);
        try {
            if (util_5.isNodeSdk()) {
                var device = util_3.CONSTANTS.NODE_ADMIN ? 'AdminNode' : 'Node';
                // UA Format: Firebase/<wire_protocol>/<sdk_version>/<platform>/<device>
                var options = {
                    headers: {
                        'User-Agent': "Firebase/" + Constants_1.PROTOCOL_VERSION + "/" + app_1.default.SDK_VERSION + "/" + process.platform + "/" + device
                    }
                };
                // Plumb appropriate http_proxy environment variable into faye-websocket if it exists.
                var env = Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_APP_DISPLAY_NAME":"Hangover","REACT_APP_ENVIRONMENT":"PROD","REACT_APP_API_BASE":"https://us-central1-hangover-prod.cloudfunctions.net/api","REACT_APP_API_BASE_V2":"https://us-central1-hangover-prod.cloudfunctions.net/api_v2","REACT_APP_API_KEY":"AIzaSyAVWIoiYTaZhU_rPiz9Eonze1TE9xStLmY","REACT_APP_AUTH_DOMAIN":"hangover-prod.firebaseapp.com","REACT_APP_DATABASE_URL":"https://hangover-prod.firebaseio.com","REACT_APP_STORAGE_BUCKET":"hangover-prod.appspot.com","REACT_APP_MESSAGING_SENDER_ID":"993782657168","REACT_APP_PRODUCT_ID":"hangover","REACT_APP_USER_VERIFIED":"on","REACT_APP_HAS_BIRTHDATE_MIGRATED":"true","REACT_APP_HAS_LOYALY_ACTIVE":"inactive","REACT_APP_EXCEL_TEMPLATE":"https://firebasestorage.googleapis.com/v0/b/leparc-prod.appspot.com/o/template%2FTemplateCargaMasiva.xlsx?alt=media&token=4a5394db-a9a0-4901-811e-2d41a5212169"});
                var proxy = this.connURL.indexOf('wss://') == 0
                    ? env['HTTPS_PROXY'] || env['https_proxy']
                    : env['HTTP_PROXY'] || env['http_proxy'];
                if (proxy) {
                    options['proxy'] = { origin: proxy };
                }
                this.mySock = new WebSocketImpl(this.connURL, [], options);
            }
            else {
                this.mySock = new WebSocketImpl(this.connURL);
            }
        }
        catch (e) {
            this.log_('Error instantiating WebSocket.');
            var error = e.message || e.data;
            if (error) {
                this.log_(error);
            }
            this.onClosed_();
            return;
        }
        this.mySock.onopen = function () {
            _this.log_('Websocket connected.');
            _this.everConnected_ = true;
        };
        this.mySock.onclose = function () {
            _this.log_('Websocket connection was disconnected.');
            _this.mySock = null;
            _this.onClosed_();
        };
        this.mySock.onmessage = function (m) {
            _this.handleIncomingFrame(m);
        };
        this.mySock.onerror = function (e) {
            _this.log_('WebSocket error.  Closing connection.');
            var error = e.message || e.data;
            if (error) {
                _this.log_(error);
            }
            _this.onClosed_();
        };
    };
    /**
     * No-op for websockets, we don't need to do anything once the connection is confirmed as open
     */
    WebSocketConnection.prototype.start = function () { };
    WebSocketConnection.forceDisallow = function () {
        WebSocketConnection.forceDisallow_ = true;
    };
    WebSocketConnection.isAvailable = function () {
        var isOldAndroid = false;
        if (typeof navigator !== 'undefined' && navigator.userAgent) {
            var oldAndroidRegex = /Android ([0-9]{0,}\.[0-9]{0,})/;
            var oldAndroidMatch = navigator.userAgent.match(oldAndroidRegex);
            if (oldAndroidMatch && oldAndroidMatch.length > 1) {
                if (parseFloat(oldAndroidMatch[1]) < 4.4) {
                    isOldAndroid = true;
                }
            }
        }
        return (!isOldAndroid &&
            WebSocketImpl !== null &&
            !WebSocketConnection.forceDisallow_);
    };
    /**
     * Returns true if we previously failed to connect with this transport.
     * @return {boolean}
     */
    WebSocketConnection.previouslyFailed = function () {
        // If our persistent storage is actually only in-memory storage,
        // we default to assuming that it previously failed to be safe.
        return (storage_1.PersistentStorage.isInMemoryStorage ||
            storage_1.PersistentStorage.get('previous_websocket_failure') === true);
    };
    WebSocketConnection.prototype.markConnectionHealthy = function () {
        storage_1.PersistentStorage.remove('previous_websocket_failure');
    };
    WebSocketConnection.prototype.appendFrame_ = function (data) {
        this.frames.push(data);
        if (this.frames.length == this.totalFrames) {
            var fullMess = this.frames.join('');
            this.frames = null;
            var jsonMess = util_4.jsonEval(fullMess);
            //handle the message
            this.onMessage(jsonMess);
        }
    };
    /**
     * @param {number} frameCount The number of frames we are expecting from the server
     * @private
     */
    WebSocketConnection.prototype.handleNewFrameCount_ = function (frameCount) {
        this.totalFrames = frameCount;
        this.frames = [];
    };
    /**
     * Attempts to parse a frame count out of some text. If it can't, assumes a value of 1
     * @param {!String} data
     * @return {?String} Any remaining data to be process, or null if there is none
     * @private
     */
    WebSocketConnection.prototype.extractFrameCount_ = function (data) {
        util_1.assert(this.frames === null, 'We already have a frame buffer');
        // TODO: The server is only supposed to send up to 9999 frames (i.e. length <= 4), but that isn't being enforced
        // currently.  So allowing larger frame counts (length <= 6).  See https://app.asana.com/0/search/8688598998380/8237608042508
        if (data.length <= 6) {
            var frameCount = Number(data);
            if (!isNaN(frameCount)) {
                this.handleNewFrameCount_(frameCount);
                return null;
            }
        }
        this.handleNewFrameCount_(1);
        return data;
    };
    /**
     * Process a websocket frame that has arrived from the server.
     * @param mess The frame data
     */
    WebSocketConnection.prototype.handleIncomingFrame = function (mess) {
        if (this.mySock === null)
            return; // Chrome apparently delivers incoming packets even after we .close() the connection sometimes.
        var data = mess['data'];
        this.bytesReceived += data.length;
        this.stats_.incrementCounter('bytes_received', data.length);
        this.resetKeepAlive();
        if (this.frames !== null) {
            // we're buffering
            this.appendFrame_(data);
        }
        else {
            // try to parse out a frame count, otherwise, assume 1 and process it
            var remainingData = this.extractFrameCount_(data);
            if (remainingData !== null) {
                this.appendFrame_(remainingData);
            }
        }
    };
    /**
     * Send a message to the server
     * @param {Object} data The JSON object to transmit
     */
    WebSocketConnection.prototype.send = function (data) {
        this.resetKeepAlive();
        var dataStr = util_4.stringify(data);
        this.bytesSent += dataStr.length;
        this.stats_.incrementCounter('bytes_sent', dataStr.length);
        //We can only fit a certain amount in each websocket frame, so we need to split this request
        //up into multiple pieces if it doesn't fit in one request.
        var dataSegs = util_2.splitStringBySize(dataStr, WEBSOCKET_MAX_FRAME_SIZE);
        //Send the length header
        if (dataSegs.length > 1) {
            this.sendString_(String(dataSegs.length));
        }
        //Send the actual data in segments.
        for (var i = 0; i < dataSegs.length; i++) {
            this.sendString_(dataSegs[i]);
        }
    };
    WebSocketConnection.prototype.shutdown_ = function () {
        this.isClosed_ = true;
        if (this.keepaliveTimer) {
            clearInterval(this.keepaliveTimer);
            this.keepaliveTimer = null;
        }
        if (this.mySock) {
            this.mySock.close();
            this.mySock = null;
        }
    };
    WebSocketConnection.prototype.onClosed_ = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is closing itself');
            this.shutdown_();
            // since this is an internal close, trigger the close listener
            if (this.onDisconnect) {
                this.onDisconnect(this.everConnected_);
                this.onDisconnect = null;
            }
        }
    };
    /**
     * External-facing close handler.
     * Close the websocket and kill the connection.
     */
    WebSocketConnection.prototype.close = function () {
        if (!this.isClosed_) {
            this.log_('WebSocket is being closed');
            this.shutdown_();
        }
    };
    /**
     * Kill the current keepalive timer and start a new one, to ensure that it always fires N seconds after
     * the last activity.
     */
    WebSocketConnection.prototype.resetKeepAlive = function () {
        var _this = this;
        clearInterval(this.keepaliveTimer);
        this.keepaliveTimer = setInterval(function () {
            //If there has been no websocket activity for a while, send a no-op
            if (_this.mySock) {
                _this.sendString_('0');
            }
            _this.resetKeepAlive();
        }, Math.floor(WEBSOCKET_KEEPALIVE_INTERVAL));
    };
    /**
     * Send a string over the websocket.
     *
     * @param {string} str String to send.
     * @private
     */
    WebSocketConnection.prototype.sendString_ = function (str) {
        // Firefox seems to sometimes throw exceptions (NS_ERROR_UNEXPECTED) from websocket .send()
        // calls for some unknown reason.  We treat these as an error and disconnect.
        // See https://app.asana.com/0/58926111402292/68021340250410
        try {
            this.mySock.send(str);
        }
        catch (e) {
            this.log_('Exception thrown from WebSocket.send():', e.message || e.data, 'Closing connection.');
            setTimeout(this.onClosed_.bind(this), 0);
        }
    };
    /**
     * Number of response before we consider the connection "healthy."
     * @type {number}
     */
    WebSocketConnection.responsesRequiredToBeHealthy = 2;
    /**
     * Time to wait for the connection te become healthy before giving up.
     * @type {number}
     */
    WebSocketConnection.healthyTimeout = 30000;
    return WebSocketConnection;
}());
exports.WebSocketConnection = WebSocketConnection;

//# sourceMappingURL=WebSocketConnection.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(223)))

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Interface defining the set of actions that can be performed against the Firebase server
 * (basically corresponds to our wire protocol).
 *
 * @interface
 */
var ServerActions = /** @class */ (function () {
    function ServerActions() {
    }
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.put = function (pathString, data, onComplete, hash) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, ?string)} onComplete
     * @param {string=} hash
     */
    ServerActions.prototype.merge = function (pathString, data, onComplete, hash) { };
    /**
     * Refreshes the auth token for the current connection.
     * @param {string} token The authentication token
     */
    ServerActions.prototype.refreshAuthToken = function (token) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectPut = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {*} data
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectMerge = function (pathString, data, onComplete) { };
    /**
     * @param {string} pathString
     * @param {function(string, string)=} onComplete
     */
    ServerActions.prototype.onDisconnectCancel = function (pathString, onComplete) { };
    /**
     * @param {Object.<string, *>} stats
     */
    ServerActions.prototype.reportStats = function (stats) { };
    return ServerActions;
}());
exports.ServerActions = ServerActions;

//# sourceMappingURL=ServerActions.js.map


/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedFilter_1 = __webpack_require__(271);
var PriorityIndex_1 = __webpack_require__(42);
var Node_1 = __webpack_require__(53);
var ChildrenNode_1 = __webpack_require__(49);
/**
 * Filters nodes by range and uses an IndexFilter to track any changes after filtering the node
 *
 * @constructor
 * @implements {NodeFilter}
 */
var RangedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function RangedFilter(params) {
        this.indexedFilter_ = new IndexedFilter_1.IndexedFilter(params.getIndex());
        this.index_ = params.getIndex();
        this.startPost_ = RangedFilter.getStartPost_(params);
        this.endPost_ = RangedFilter.getEndPost_(params);
    }
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getStartPost = function () {
        return this.startPost_;
    };
    /**
     * @return {!NamedNode}
     */
    RangedFilter.prototype.getEndPost = function () {
        return this.endPost_;
    };
    /**
     * @param {!NamedNode} node
     * @return {boolean}
     */
    RangedFilter.prototype.matches = function (node) {
        return (this.index_.compare(this.getStartPost(), node) <= 0 &&
            this.index_.compare(node, this.getEndPost()) <= 0);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.matches(new Node_1.NamedNode(key, newChild))) {
            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        }
        return this.indexedFilter_.updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        if (newSnap.isLeafNode()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            newSnap = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        }
        var filtered = newSnap.withIndex(this.index_);
        // Don't support priorities on queries
        filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
        var self = this;
        newSnap.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
            if (!self.matches(new Node_1.NamedNode(key, childNode))) {
                filtered = filtered.updateImmediateChild(key, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
            }
        });
        return this.indexedFilter_.updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndexedFilter = function () {
        return this.indexedFilter_;
    };
    /**
     * @inheritDoc
     */
    RangedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getStartPost_ = function (params) {
        if (params.hasStart()) {
            var startName = params.getIndexStartName();
            return params.getIndex().makePost(params.getIndexStartValue(), startName);
        }
        else {
            return params.getIndex().minPost();
        }
    };
    /**
     * @param {!QueryParams} params
     * @return {!NamedNode}
     * @private
     */
    RangedFilter.getEndPost_ = function (params) {
        if (params.hasEnd()) {
            var endName = params.getIndexEndName();
            return params.getIndex().makePost(params.getIndexEndValue(), endName);
        }
        else {
            return params.getIndex().maxPost();
        }
    };
    return RangedFilter;
}());
exports.RangedFilter = RangedFilter;

//# sourceMappingURL=RangedFilter.js.map


/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_errors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_token_manager__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_notification_permission__ = __webpack_require__(492);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var SENDER_ID_OPTION_NAME = 'messagingSenderId';
var ControllerInterface = /** @class */ (function () {
    /**
     * An interface of the Messaging Service API
     * @param {!firebase.app.App} app
     */
    function ControllerInterface(app) {
        var _this = this;
        this.errorFactory_ = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('messaging', 'Messaging', __WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].map);
        if (!app.options[SENDER_ID_OPTION_NAME] ||
            typeof app.options[SENDER_ID_OPTION_NAME] !== 'string') {
            throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.BAD_SENDER_ID);
        }
        this.messagingSenderId_ = app.options[SENDER_ID_OPTION_NAME];
        this.tokenManager_ = new __WEBPACK_IMPORTED_MODULE_2__models_token_manager__["a" /* default */]();
        this.app = app;
        this.INTERNAL = {};
        this.INTERNAL.delete = function () { return _this.delete; };
    }
    /**
     * @export
     * @return {Promise<string> | Promise<null>} Returns a promise that
     * resolves to an FCM token.
     */
    ControllerInterface.prototype.getToken = function () {
        var _this = this;
        // Check with permissions
        var currentPermission = this.getNotificationPermission_();
        if (currentPermission !== __WEBPACK_IMPORTED_MODULE_3__models_notification_permission__["a" /* default */].granted) {
            if (currentPermission === __WEBPACK_IMPORTED_MODULE_3__models_notification_permission__["a" /* default */].denied) {
                return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.NOTIFICATIONS_BLOCKED));
            }
            // We must wait for permission to be granted
            return Promise.resolve(null);
        }
        return this.getSWRegistration_().then(function (registration) {
            return _this.tokenManager_
                .getSavedToken(_this.messagingSenderId_, registration)
                .then(function (token) {
                if (token) {
                    return token;
                }
                return _this.tokenManager_.createToken(_this.messagingSenderId_, registration);
            });
        });
    };
    /**
     * This method deletes tokens that the token manager looks after and then
     * unregisters the push subscription if it exists.
     * @export
     * @param {string} token
     * @return {Promise<void>}
     */
    ControllerInterface.prototype.deleteToken = function (token) {
        var _this = this;
        return this.tokenManager_.deleteToken(token).then(function () {
            return _this.getSWRegistration_()
                .then(function (registration) {
                if (registration) {
                    return registration.pushManager.getSubscription();
                }
            })
                .then(function (subscription) {
                if (subscription) {
                    return subscription.unsubscribe();
                }
            });
        });
    };
    ControllerInterface.prototype.getSWRegistration_ = function () {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.SHOULD_BE_INHERITED);
    };
    //
    // The following methods should only be available in the window.
    //
    ControllerInterface.prototype.requestPermission = function () {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!ServiceWorkerRegistration} registration
     */
    ControllerInterface.prototype.useServiceWorker = function (registration) {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!firebase.Observer|function(*)} nextOrObserver
     * @param {function(!Error)=} optError
     * @param {function()=} optCompleted
     * @return {!function()}
     */
    ControllerInterface.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.AVAILABLE_IN_WINDOW);
    };
    /**
     * @export
     * @param {!firebase.Observer|function()} nextOrObserver An observer object
     * or a function triggered on token refresh.
     * @param {function(!Error)=} optError Optional A function
     * triggered on token refresh error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    ControllerInterface.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.AVAILABLE_IN_WINDOW);
    };
    //
    // The following methods are used by the service worker only.
    //
    /**
     * @export
     * @param {function(Object)} callback
     */
    ControllerInterface.prototype.setBackgroundMessageHandler = function (callback) {
        throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.AVAILABLE_IN_SW);
    };
    //
    // The following methods are used by the service themselves and not exposed
    // publicly or not expected to be used by developers.
    //
    /**
     * This method is required to adhere to the Firebase interface.
     * It closes any currently open indexdb database connections.
     */
    ControllerInterface.prototype.delete = function () {
        return this.tokenManager_.closeDatabase();
    };
    /**
     * Returns the current Notification Permission state.
     * @private
     * @return {string} The currenct permission state.
     */
    ControllerInterface.prototype.getNotificationPermission_ = function () {
        return Notification.permission;
    };
    /**
     * @protected
     * @returns {TokenManager}
     */
    ControllerInterface.prototype.getTokenManager = function () {
        return this.tokenManager_;
    };
    return ControllerInterface;
}());
/* harmony default export */ __webpack_exports__["a"] = (ControllerInterface);

//# sourceMappingURL=controller-interface.js.map


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(275);
/**
 * Throws an error if the provided assertion is falsy
 * @param {*} assertion The assertion to be tested for falsiness
 * @param {!string} message The message to display if the check fails
 */
exports.assert = function (assertion, message) {
    if (!assertion) {
        throw exports.assertionError(message);
    }
};
/**
 * Returns an Error object suitable for throwing.
 * @param {string} message
 * @return {!Error}
 */
exports.assertionError = function (message) {
    return new Error('Firebase Database (' +
        constants_1.CONSTANTS.SDK_VERSION +
        ') INTERNAL ASSERT FAILED: ' +
        message);
};

//# sourceMappingURL=assert.js.map


/***/ }),
/* 488 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var stringToByteArray = function (str) {
    // TODO(user): Use native implementations if/when available
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if ((c & 0xfc00) == 0xd800 &&
            i + 1 < str.length &&
            (str.charCodeAt(i + 1) & 0xfc00) == 0xdc00) {
            // Surrogate Pair
            c = 0x10000 + ((c & 0x03ff) << 10) + (str.charCodeAt(++i) & 0x03ff);
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Turns an array of numbers into the string given by the concatenation of the
 * characters to which the numbers correspond.
 * @param {Array<number>} bytes Array of numbers representing characters.
 * @return {string} Stringification of the array.
 */
var byteArrayToString = function (bytes) {
    // TODO(user): Use native implementations if/when available
    var out = [], pos = 0, c = 0;
    while (pos < bytes.length) {
        var c1 = bytes[pos++];
        if (c1 < 128) {
            out[c++] = String.fromCharCode(c1);
        }
        else if (c1 > 191 && c1 < 224) {
            var c2 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 31) << 6) | (c2 & 63));
        }
        else if (c1 > 239 && c1 < 365) {
            // Surrogate Pair
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            var c4 = bytes[pos++];
            var u = (((c1 & 7) << 18) | ((c2 & 63) << 12) | ((c3 & 63) << 6) | (c4 & 63)) -
                0x10000;
            out[c++] = String.fromCharCode(0xd800 + (u >> 10));
            out[c++] = String.fromCharCode(0xdc00 + (u & 1023));
        }
        else {
            var c2 = bytes[pos++];
            var c3 = bytes[pos++];
            out[c++] = String.fromCharCode(((c1 & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
        }
    }
    return out.join('');
};
// Static lookup maps, lazily populated by init_()
exports.base64 = {
    /**
     * Maps bytes to characters.
     * @type {Object}
     * @private
     */
    byteToCharMap_: null,
    /**
     * Maps characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMap_: null,
    /**
     * Maps bytes to websafe characters.
     * @type {Object}
     * @private
     */
    byteToCharMapWebSafe_: null,
    /**
     * Maps websafe characters to bytes.
     * @type {Object}
     * @private
     */
    charToByteMapWebSafe_: null,
    /**
     * Our default alphabet, shared between
     * ENCODED_VALS and ENCODED_VALS_WEBSAFE
     * @type {string}
     */
    ENCODED_VALS_BASE: 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' + 'abcdefghijklmnopqrstuvwxyz' + '0123456789',
    /**
     * Our default alphabet. Value 64 (=) is special; it means "nothing."
     * @type {string}
     */
    get ENCODED_VALS() {
        return this.ENCODED_VALS_BASE + '+/=';
    },
    /**
     * Our websafe alphabet.
     * @type {string}
     */
    get ENCODED_VALS_WEBSAFE() {
        return this.ENCODED_VALS_BASE + '-_.';
    },
    /**
     * Whether this browser supports the atob and btoa functions. This extension
     * started at Mozilla but is now implemented by many browsers. We use the
     * ASSUME_* variables to avoid pulling in the full useragent detection library
     * but still allowing the standard per-browser compilations.
     *
     * @type {boolean}
     */
    HAS_NATIVE_SUPPORT: typeof atob === 'function',
    /**
     * Base64-encode an array of bytes.
     *
     * @param {Array<number>|Uint8Array} input An array of bytes (numbers with
     *     value in [0, 255]) to encode.
     * @param {boolean=} opt_webSafe Boolean indicating we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeByteArray: function (input, opt_webSafe) {
        if (!Array.isArray(input)) {
            throw Error('encodeByteArray takes an array as a parameter');
        }
        this.init_();
        var byteToCharMap = opt_webSafe
            ? this.byteToCharMapWebSafe_
            : this.byteToCharMap_;
        var output = [];
        for (var i = 0; i < input.length; i += 3) {
            var byte1 = input[i];
            var haveByte2 = i + 1 < input.length;
            var byte2 = haveByte2 ? input[i + 1] : 0;
            var haveByte3 = i + 2 < input.length;
            var byte3 = haveByte3 ? input[i + 2] : 0;
            var outByte1 = byte1 >> 2;
            var outByte2 = ((byte1 & 0x03) << 4) | (byte2 >> 4);
            var outByte3 = ((byte2 & 0x0f) << 2) | (byte3 >> 6);
            var outByte4 = byte3 & 0x3f;
            if (!haveByte3) {
                outByte4 = 64;
                if (!haveByte2) {
                    outByte3 = 64;
                }
            }
            output.push(byteToCharMap[outByte1], byteToCharMap[outByte2], byteToCharMap[outByte3], byteToCharMap[outByte4]);
        }
        return output.join('');
    },
    /**
     * Base64-encode a string.
     *
     * @param {string} input A string to encode.
     * @param {boolean=} opt_webSafe If true, we should use the
     *     alternative alphabet.
     * @return {string} The base64 encoded string.
     */
    encodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return btoa(input);
        }
        return this.encodeByteArray(stringToByteArray(input), opt_webSafe);
    },
    /**
     * Base64-decode a string.
     *
     * @param {string} input to decode.
     * @param {boolean=} opt_webSafe True if we should use the
     *     alternative alphabet.
     * @return {string} string representing the decoded value.
     */
    decodeString: function (input, opt_webSafe) {
        // Shortcut for Mozilla browsers that implement
        // a native base64 encoder in the form of "btoa/atob"
        if (this.HAS_NATIVE_SUPPORT && !opt_webSafe) {
            return atob(input);
        }
        return byteArrayToString(this.decodeStringToByteArray(input, opt_webSafe));
    },
    /**
     * Base64-decode a string.
     *
     * In base-64 decoding, groups of four characters are converted into three
     * bytes.  If the encoder did not apply padding, the input length may not
     * be a multiple of 4.
     *
     * In this case, the last group will have fewer than 4 characters, and
     * padding will be inferred.  If the group has one or two characters, it decodes
     * to one byte.  If the group has three characters, it decodes to two bytes.
     *
     * @param {string} input Input to decode.
     * @param {boolean=} opt_webSafe True if we should use the web-safe alphabet.
     * @return {!Array<number>} bytes representing the decoded value.
     */
    decodeStringToByteArray: function (input, opt_webSafe) {
        this.init_();
        var charToByteMap = opt_webSafe
            ? this.charToByteMapWebSafe_
            : this.charToByteMap_;
        var output = [];
        for (var i = 0; i < input.length;) {
            var byte1 = charToByteMap[input.charAt(i++)];
            var haveByte2 = i < input.length;
            var byte2 = haveByte2 ? charToByteMap[input.charAt(i)] : 0;
            ++i;
            var haveByte3 = i < input.length;
            var byte3 = haveByte3 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            var haveByte4 = i < input.length;
            var byte4 = haveByte4 ? charToByteMap[input.charAt(i)] : 64;
            ++i;
            if (byte1 == null || byte2 == null || byte3 == null || byte4 == null) {
                throw Error();
            }
            var outByte1 = (byte1 << 2) | (byte2 >> 4);
            output.push(outByte1);
            if (byte3 != 64) {
                var outByte2 = ((byte2 << 4) & 0xf0) | (byte3 >> 2);
                output.push(outByte2);
                if (byte4 != 64) {
                    var outByte3 = ((byte3 << 6) & 0xc0) | byte4;
                    output.push(outByte3);
                }
            }
        }
        return output;
    },
    /**
     * Lazy static initialization function. Called before
     * accessing any of the static map variables.
     * @private
     */
    init_: function () {
        if (!this.byteToCharMap_) {
            this.byteToCharMap_ = {};
            this.charToByteMap_ = {};
            this.byteToCharMapWebSafe_ = {};
            this.charToByteMapWebSafe_ = {};
            // We want quick mappings back and forth, so we precompute two maps.
            for (var i = 0; i < this.ENCODED_VALS.length; i++) {
                this.byteToCharMap_[i] = this.ENCODED_VALS.charAt(i);
                this.charToByteMap_[this.byteToCharMap_[i]] = i;
                this.byteToCharMapWebSafe_[i] = this.ENCODED_VALS_WEBSAFE.charAt(i);
                this.charToByteMapWebSafe_[this.byteToCharMapWebSafe_[i]] = i;
                // Be forgiving when decoding and correctly decode both encodings.
                if (i >= this.ENCODED_VALS_BASE.length) {
                    this.charToByteMap_[this.ENCODED_VALS_WEBSAFE.charAt(i)] = i;
                    this.charToByteMapWebSafe_[this.ENCODED_VALS.charAt(i)] = i;
                }
            }
        }
    }
};
/**
 * URL-safe base64 encoding
 * @param {!string} str
 * @return {!string}
 */
exports.base64Encode = function (str) {
    var utf8Bytes = stringToByteArray(str);
    return exports.base64.encodeByteArray(utf8Bytes, true);
};
/**
 * URL-safe base64 decoding
 *
 * NOTE: DO NOT use the global atob() function - it does NOT support the
 * base64Url variant encoding.
 *
 * @param {string} str To be decoded
 * @return {?string} Decoded result, if possible
 */
exports.base64Decode = function (str) {
    try {
        return exports.base64.decodeString(str, true);
    }
    catch (e) {
        console.error('base64Decode failed: ', e);
    }
    return null;
};

//# sourceMappingURL=crypt.js.map


/***/ }),
/* 489 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Evaluates a JSON string into a javascript object.
 *
 * @param {string} str A string containing JSON.
 * @return {*} The javascript object representing the specified JSON.
 */
function jsonEval(str) {
    return JSON.parse(str);
}
exports.jsonEval = jsonEval;
/**
 * Returns JSON representing a javascript object.
 * @param {*} data Javascript object to be stringified.
 * @return {string} The JSON contents of the object.
 */
function stringify(data) {
    return JSON.stringify(data);
}
exports.stringify = stringify;

//# sourceMappingURL=json.js.map


/***/ }),
/* 490 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// See http://www.devthought.com/2012/01/18/an-object-is-not-a-hash/
exports.contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
exports.safeGet = function (obj, key) {
    if (Object.prototype.hasOwnProperty.call(obj, key))
        return obj[key];
    // else return undefined.
};
/**
 * Enumerates the keys/values in an object, excluding keys defined on the prototype.
 *
 * @param {?Object.<K,V>} obj Object to enumerate.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.forEach = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn(key, obj[key]);
        }
    }
};
/**
 * Copies all the (own) properties from one object to another.
 * @param {!Object} objTo
 * @param {!Object} objFrom
 * @return {!Object} objTo
 */
exports.extend = function (objTo, objFrom) {
    exports.forEach(objFrom, function (key, value) {
        objTo[key] = value;
    });
    return objTo;
};
/**
 * Returns a clone of the specified object.
 * @param {!Object} obj
 * @return {!Object} cloned obj.
 */
exports.clone = function (obj) {
    return exports.extend({}, obj);
};
/**
 * Returns true if obj has typeof "object" and is not null.  Unlike goog.isObject(), does not return true
 * for functions.
 *
 * @param obj {*} A potential object.
 * @returns {boolean} True if it's an object.
 */
exports.isNonNullObject = function (obj) {
    return typeof obj === 'object' && obj !== null;
};
exports.isEmpty = function (obj) {
    for (var key in obj) {
        return false;
    }
    return true;
};
exports.getCount = function (obj) {
    var rv = 0;
    for (var key in obj) {
        rv++;
    }
    return rv;
};
exports.map = function (obj, f, opt_obj) {
    var res = {};
    for (var key in obj) {
        res[key] = f.call(opt_obj, obj[key], key, obj);
    }
    return res;
};
exports.findKey = function (obj, fn, opt_this) {
    for (var key in obj) {
        if (fn.call(opt_this, obj[key], key, obj)) {
            return key;
        }
    }
    return undefined;
};
exports.findValue = function (obj, fn, opt_this) {
    var key = exports.findKey(obj, fn, opt_this);
    return key && obj[key];
};
exports.getAnyKey = function (obj) {
    for (var key in obj) {
        return key;
    }
};
exports.getValues = function (obj) {
    var res = [];
    var i = 0;
    for (var key in obj) {
        res[i++] = obj[key];
    }
    return res;
};
/**
 * Tests whether every key/value pair in an object pass the test implemented
 * by the provided function
 *
 * @param {?Object.<K,V>} obj Object to test.
 * @param {!function(K, V)} fn Function to call for each key and value.
 * @template K,V
 */
exports.every = function (obj, fn) {
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (!fn(key, obj[key])) {
                return false;
            }
        }
    }
    return true;
};

//# sourceMappingURL=obj.js.map


/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var FCM_APPLICATION_SERVER_KEY = [
    0x04,
    0x33,
    0x94,
    0xf7,
    0xdf,
    0xa1,
    0xeb,
    0xb1,
    0xdc,
    0x03,
    0xa2,
    0x5e,
    0x15,
    0x71,
    0xdb,
    0x48,
    0xd3,
    0x2e,
    0xed,
    0xed,
    0xb2,
    0x34,
    0xdb,
    0xb7,
    0x47,
    0x3a,
    0x0c,
    0x8f,
    0xc4,
    0xcc,
    0xe1,
    0x6f,
    0x3c,
    0x8c,
    0x84,
    0xdf,
    0xab,
    0xb6,
    0x66,
    0x3e,
    0xf2,
    0x0c,
    0xd4,
    0x8b,
    0xfe,
    0xe3,
    0xf9,
    0x76,
    0x2f,
    0x14,
    0x1c,
    0x63,
    0x08,
    0x6a,
    0x6f,
    0x2d,
    0xb1,
    0x1a,
    0x95,
    0xb0,
    0xce,
    0x37,
    0xc0,
    0x9c,
    0x6e
];
var SUBSCRIPTION_DETAILS = {
    userVisibleOnly: true,
    applicationServerKey: new Uint8Array(FCM_APPLICATION_SERVER_KEY)
};
/* harmony default export */ __webpack_exports__["a"] = ({
    ENDPOINT: 'https://fcm.googleapis.com',
    APPLICATION_SERVER_KEY: FCM_APPLICATION_SERVER_KEY,
    SUBSCRIPTION_OPTIONS: SUBSCRIPTION_DETAILS
});

//# sourceMappingURL=fcm-details.js.map


/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
    granted: 'granted',
    default: 'default',
    denied: 'denied'
});

//# sourceMappingURL=notification-permission.js.map


/***/ }),
/* 493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// These fields are strings to prevent closure from thinking goog.getMsg
// should be used to initialise the values
var PARAMS = {
    TYPE_OF_MSG: 'firebase-messaging-msg-type',
    DATA: 'firebase-messaging-msg-data'
};
// This value isn't using the TYPE_OF_MSG short hand as closure
// expects the variable to be defined via goog.getMsg
var msgType = {
    PUSH_MSG_RECEIVED: 'push-msg-received',
    NOTIFICATION_CLICKED: 'notification-clicked'
};
var createNewMsg = function (msgType, msgData) {
    var message = (_a = {},
        _a[PARAMS.TYPE_OF_MSG] = msgType,
        _a[PARAMS.DATA] = msgData,
        _a);
    return message;
    var _a;
};
/* harmony default export */ __webpack_exports__["a"] = ({
    PARAMS: PARAMS,
    TYPES_OF_MSG: msgType,
    createNewMsg: createNewMsg
});

//# sourceMappingURL=worker-page-message.js.map


/***/ }),
/* 494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__UserConfig__ = __webpack_require__(1252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserService=function(){function UserService(){_classCallCheck(this,UserService);}_createClass(UserService,null,[{key:"getUsers",/******* USERS **********/value:function getUsers(app,filter,order,limit){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointUsers;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({filter:filter,order:order,limit:limit})});case 7:response=_context.sent;// console.log("getUsers", response, app)
if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](0);reject(_context.t0);case 14:case"end":return _context.stop();}}},_callee,_this,[[0,11]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"getUsersByReg",value:function getUsersByReg(app,filter){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointUsersByReg+"?filter="+filter;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context2.sent;// console.log("getUsers", response, app)
if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 14:case"end":return _context2.stop();}}},_callee2,_this2,[[0,11]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"getUsersByEmailOrDU",value:function getUsersByEmailOrDU(app,usersDU,usersEmail){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointUsersByEmailOrDU;console.log("getUsersByEmailOrDU 1",usersDU,usersEmail);_context3.next=8;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({usersDU:usersDU,usersEmail:usersEmail})});case 8:response=_context3.sent;console.log("getUsersByEmailOrDU 2",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=17;break;case 13:_context3.prev=13;_context3.t0=_context3["catch"](0);console.log("ERROR",_context3.t0);reject(_context3.t0);case 17:case"end":return _context3.stop();}}},_callee3,_this3,[[0,13]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}},{key:"getUsersFromStorage",value:function getUsersFromStorage(path,filename){var _this4=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context4.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointUsersFromStorage;console.log("getUsersFromStorage ",path,filename);_context4.next=8;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnectorLarge.post(endpoint,{headers:{Authorization:"Bearer "+token},body:JSON.stringify({path:path,filename:filename})});case 8:response=_context4.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context4.next=15;break;case 12:_context4.prev=12;_context4.t0=_context4["catch"](0);reject(_context4.t0);case 15:case"end":return _context4.stop();}}},_callee4,_this4,[[0,12]]);}));return function(_x7,_x8){return _ref4.apply(this,arguments);};}());}},{key:"saveUser",value:function saveUser(app,user){var _this5=this;return new Promise(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;_context5.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context5.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointSaveUser;_context5.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(user)});case 7:response=_context5.sent;// console.log("RESPONSE SAVE USER",response)
if(response.status==200){resolve(response.body);}else{reject(response);}_context5.next=14;break;case 11:_context5.prev=11;_context5.t0=_context5["catch"](0);reject(_context5.t0);case 14:case"end":return _context5.stop();}}},_callee5,_this5,[[0,11]]);}));return function(_x9,_x10){return _ref5.apply(this,arguments);};}());}},{key:"deleteUser",value:function deleteUser(app,userId){var _this6=this;return new Promise(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context6.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointDeleteUser;_context6.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:userId})});case 7:response=_context6.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context6.next=14;break;case 11:_context6.prev=11;_context6.t0=_context6["catch"](0);reject(_context6.t0);case 14:case"end":return _context6.stop();}}},_callee6,_this6,[[0,11]]);}));return function(_x11,_x12){return _ref6.apply(this,arguments);};}());}},{key:"transferPoints",value:function transferPoints(app,points,dni){var _this7=this;return new Promise(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;_context7.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context7.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].transferPointEndpoint.concat("?document="+dni);_context7.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({points:points,description:"Recarga de puntos"})});case 7:response=_context7.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context7.next=14;break;case 11:_context7.prev=11;_context7.t0=_context7["catch"](0);reject(_context7.t0);case 14:case"end":return _context7.stop();}}},_callee7,_this7,[[0,11]]);}));return function(_x13,_x14){return _ref7.apply(this,arguments);};}());}},{key:"addTagsToUsers",value:function addTagsToUsers(app,tags,allUsersSelected,users){var _this8=this;return new Promise(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context8.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointAddTagToUser;console.log("ADD TAG TO USERS",endpoint,{tags:tags,allUsersSelected:allUsersSelected,users:users});_context8.next=8;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({tags:tags,allUsersSelected:allUsersSelected,users:users})});case 8:response=_context8.sent;console.log("RESPONSE SAVE USER",response);if(response.status==200){resolve(response.body);}else{reject(response);}_context8.next=16;break;case 13:_context8.prev=13;_context8.t0=_context8["catch"](0);reject(_context8.t0);case 16:case"end":return _context8.stop();}}},_callee8,_this8,[[0,13]]);}));return function(_x15,_x16){return _ref8.apply(this,arguments);};}());}},{key:"sendNotification",value:function sendNotification(app,user,notification){var _this9=this;console.log(" >>>>>>>>>> user",user);return new Promise(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context9.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].endpointSendNotification;_context9.next=7;return __WEBPACK_IMPORTED_MODULE_1__UserConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({userToken:user.FCMToken,notification:notification,id:user.id})});case 7:response=_context9.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context9.next=14;break;case 11:_context9.prev=11;_context9.t0=_context9["catch"](0);reject(_context9.t0);case 14:case"end":return _context9.stop();}}},_callee9,_this9,[[0,11]]);}));return function(_x17,_x18){return _ref9.apply(this,arguments);};}());}/******** FIN USERS *********/}]);return UserService;}();/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Accordion__ = __webpack_require__(1260);
/* unused harmony reexport Accordion */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Alert__ = __webpack_require__(1283);
/* unused harmony reexport Alert */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Badge__ = __webpack_require__(1286);
/* unused harmony reexport Badge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Breadcrumb__ = __webpack_require__(1287);
/* unused harmony reexport Breadcrumb */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__BreadcrumbItem__ = __webpack_require__(511);
/* unused harmony reexport BreadcrumbItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(149);
/* unused harmony reexport Button */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonGroup__ = __webpack_require__(283);
/* unused harmony reexport ButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonToolbar__ = __webpack_require__(1288);
/* unused harmony reexport ButtonToolbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Carousel__ = __webpack_require__(1289);
/* unused harmony reexport Carousel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CarouselItem__ = __webpack_require__(512);
/* unused harmony reexport CarouselItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Checkbox__ = __webpack_require__(1299);
/* unused harmony reexport Checkbox */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Clearfix__ = __webpack_require__(1300);
/* unused harmony reexport Clearfix */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CloseButton__ = __webpack_require__(282);
/* unused harmony reexport CloseButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ControlLabel__ = __webpack_require__(1301);
/* unused harmony reexport ControlLabel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Col__ = __webpack_require__(1302);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__Col__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Collapse__ = __webpack_require__(285);
/* unused harmony reexport Collapse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Dropdown__ = __webpack_require__(200);
/* unused harmony reexport Dropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__DropdownButton__ = __webpack_require__(1325);
/* unused harmony reexport DropdownButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Fade__ = __webpack_require__(203);
/* unused harmony reexport Fade */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Form__ = __webpack_require__(1326);
/* unused harmony reexport Form */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__FormControl__ = __webpack_require__(1327);
/* unused harmony reexport FormControl */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__FormGroup__ = __webpack_require__(1330);
/* unused harmony reexport FormGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__Glyphicon__ = __webpack_require__(284);
/* unused harmony reexport Glyphicon */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__Grid__ = __webpack_require__(522);
/* unused harmony reexport Grid */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__HelpBlock__ = __webpack_require__(1331);
/* unused harmony reexport HelpBlock */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__Image__ = __webpack_require__(1332);
/* unused harmony reexport Image */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__InputGroup__ = __webpack_require__(1333);
/* unused harmony reexport InputGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__Jumbotron__ = __webpack_require__(1336);
/* unused harmony reexport Jumbotron */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__Label__ = __webpack_require__(1337);
/* unused harmony reexport Label */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__ListGroup__ = __webpack_require__(1338);
/* unused harmony reexport ListGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__ListGroupItem__ = __webpack_require__(523);
/* unused harmony reexport ListGroupItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__Media__ = __webpack_require__(204);
/* unused harmony reexport Media */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__MenuItem__ = __webpack_require__(1345);
/* unused harmony reexport MenuItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__Modal__ = __webpack_require__(1346);
/* unused harmony reexport Modal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__ModalBody__ = __webpack_require__(530);
/* unused harmony reexport ModalBody */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__ModalDialog__ = __webpack_require__(531);
/* unused harmony reexport ModalDialog */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__ModalFooter__ = __webpack_require__(532);
/* unused harmony reexport ModalFooter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__ModalHeader__ = __webpack_require__(533);
/* unused harmony reexport ModalHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__ModalTitle__ = __webpack_require__(534);
/* unused harmony reexport ModalTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__Nav__ = __webpack_require__(535);
/* unused harmony reexport Nav */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__Navbar__ = __webpack_require__(1359);
/* unused harmony reexport Navbar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__NavbarBrand__ = __webpack_require__(536);
/* unused harmony reexport NavbarBrand */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__NavDropdown__ = __webpack_require__(1363);
/* unused harmony reexport NavDropdown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__NavItem__ = __webpack_require__(537);
/* unused harmony reexport NavItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__Overlay__ = __webpack_require__(538);
/* unused harmony reexport Overlay */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__OverlayTrigger__ = __webpack_require__(1371);
/* unused harmony reexport OverlayTrigger */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__PageHeader__ = __webpack_require__(1376);
/* unused harmony reexport PageHeader */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__PageItem__ = __webpack_require__(1377);
/* unused harmony reexport PageItem */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__Pager__ = __webpack_require__(1379);
/* unused harmony reexport Pager */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__Pagination__ = __webpack_require__(1380);
/* unused harmony reexport Pagination */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__Panel__ = __webpack_require__(1382);
/* unused harmony reexport Panel */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__PanelGroup__ = __webpack_require__(507);
/* unused harmony reexport PanelGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__Popover__ = __webpack_require__(1388);
/* unused harmony reexport Popover */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__ProgressBar__ = __webpack_require__(1389);
/* unused harmony reexport ProgressBar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__Radio__ = __webpack_require__(1390);
/* unused harmony reexport Radio */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__ResponsiveEmbed__ = __webpack_require__(1391);
/* unused harmony reexport ResponsiveEmbed */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__Row__ = __webpack_require__(1392);
/* unused harmony reexport Row */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__SafeAnchor__ = __webpack_require__(61);
/* unused harmony reexport SafeAnchor */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__SplitButton__ = __webpack_require__(1393);
/* unused harmony reexport SplitButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__Tab__ = __webpack_require__(1395);
/* unused harmony reexport Tab */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__TabContainer__ = __webpack_require__(291);
/* unused harmony reexport TabContainer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__TabContent__ = __webpack_require__(292);
/* unused harmony reexport TabContent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__Table__ = __webpack_require__(1396);
/* unused harmony reexport Table */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__TabPane__ = __webpack_require__(544);
/* unused harmony reexport TabPane */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__Tabs__ = __webpack_require__(1397);
/* unused harmony reexport Tabs */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__Thumbnail__ = __webpack_require__(1398);
/* unused harmony reexport Thumbnail */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__ToggleButton__ = __webpack_require__(545);
/* unused harmony reexport ToggleButton */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__ToggleButtonGroup__ = __webpack_require__(1399);
/* unused harmony reexport ToggleButtonGroup */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__Tooltip__ = __webpack_require__(1400);
/* unused harmony reexport Tooltip */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__Well__ = __webpack_require__(1401);
/* unused harmony reexport Well */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__utils__ = __webpack_require__(1402);
/* unused harmony reexport utils */















































































































































/***/ }),
/* 496 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1261);

/***/ }),
/* 497 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(1263);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 498 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(276);
var document = __webpack_require__(120).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 499 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(279);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 500 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(280);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(54);
var global = __webpack_require__(120);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(502) ? 'pure' : 'global',
  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 502 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 503 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 504 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 505 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(192);
var dPs = __webpack_require__(1274);
var enumBugKeys = __webpack_require__(504);
var IE_PROTO = __webpack_require__(281)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(498)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(1275).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(510);










var propTypes = {
  accordion: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * When `accordion` is enabled, `activeKey` controls the which child `Panel` is expanded. `activeKey` should
   * match a child Panel `eventKey` prop exactly.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * A callback fired when a child Panel collapse state changes. It's called with the next expanded `activeKey`
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * An HTML role attribute
   */
  role: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * A function that takes an eventKey and type and returns a
   * unique id for each Panel heading and Panel Collapse. The function _must_ be a pure function,
   * meaning it should always return the _same_ id for the same set of inputs. The default
   * value requires that an `id` to be set for the PanelGroup.
   *
   * The `type` argument will either be `"body"` or `"heading"`.
   *
   * @defaultValue (eventKey, type) => `${this.props.id}-${type}-${key}`
   */
  generateChildId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * HTML id attribute, required if no `generateChildId` prop
   * is specified.
   */
  id: Object(__WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* generatedId */])('PanelGroup')
};
var defaultProps = {
  accordion: false
};
var childContextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
    headerRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    panelRole: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var PanelGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelGroup, _React$Component);

  function PanelGroup() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleSelect = function (key, expanded, e) {
      if (expanded) {
        _this.props.onSelect(key, e);
      } else if (_this.props.activeKey === key) {
        _this.props.onSelect(null, e);
      }
    };

    return _this;
  }

  var _proto = PanelGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        activeKey = _this$props.activeKey,
        accordion = _this$props.accordion,
        generateChildId = _this$props.generateChildId,
        id = _this$props.id;
    var getId = null;

    if (accordion) {
      getId = generateChildId || function (key, type) {
        return id ? id + "-" + type + "-" + key : null;
      };
    }

    return {
      $bs_panelGroup: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        getId: getId,
        headerRole: 'tab',
        panelRole: 'tabpanel'
      }, accordion && {
        activeKey: activeKey,
        onToggle: this.handleSelect
      })
    };
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        accordion = _this$props2.accordion,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["accordion", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onSelect', 'activeKey']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (accordion) {
      elementProps.role = elementProps.role || 'tablist';
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        bsStyle: child.props.bsStyle || bsProps.bsStyle
      });
    }));
  };

  return PanelGroup;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelGroup.propTypes = propTypes;
PanelGroup.defaultProps = defaultProps;
PanelGroup.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel-group', PanelGroup), {
  activeKey: 'onSelect'
}));

/***/ }),
/* 508 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1281);

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var DESCRIPTORS = __webpack_require__(121);
var getKeys = __webpack_require__(194);
var toIObject = __webpack_require__(278);
var isEnum = __webpack_require__(505).f;
module.exports = function (isEntries) {
  return function (it) {
    var O = toIObject(it);
    var keys = getKeys(O);
    var length = keys.length;
    var i = 0;
    var result = [];
    var key;
    while (length > i) {
      key = keys[i++];
      if (!DESCRIPTORS || isEnum.call(O, key)) {
        result.push(isEntries ? [key, O[key]] : O[key]);
      }
    }
    return result;
  };
};


/***/ }),
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = generatedId;
/* harmony export (immutable) */ __webpack_exports__["c"] = requiredRoles;
/* harmony export (immutable) */ __webpack_exports__["a"] = exclusiveRoles;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(43);



var idPropType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number]);
function generatedId(name) {
  return function (props) {
    var error = null;

    if (!props.generateChildId) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      error = idPropType.apply(void 0, [props].concat(args));

      if (!error && !props.id) {
        error = new Error("In order to properly initialize the " + name + " in a way that is accessible to assistive technologies " + ("(such as screen readers) an `id` or a `generateChildId` prop to " + name + " is required"));
      }
    }

    return error;
  };
}
function requiredRoles() {
  for (var _len2 = arguments.length, roles = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    roles[_key2] = arguments[_key2];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var missing;
    roles.every(function (role) {
      if (!__WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
        return child.props.bsRole === role;
      })) {
        missing = role;
        return false;
      }

      return true;
    });

    if (missing) {
      return new Error("(children) " + component + " - Missing a required child with bsRole: " + (missing + ". " + component + " must have at least one child of each of ") + ("the following bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}
function exclusiveRoles() {
  for (var _len3 = arguments.length, roles = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    roles[_key3] = arguments[_key3];
  }

  return __WEBPACK_IMPORTED_MODULE_1_prop_types_extra_lib_utils_createChainableTypeChecker___default()(function (props, propName, component) {
    var duplicate;
    roles.every(function (role) {
      var childrenWithRole = __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__["a" /* default */].filter(props.children, function (child) {
        return child.props.bsRole === role;
      });

      if (childrenWithRole.length > 1) {
        duplicate = role;
        return false;
      }

      return true;
    });

    if (duplicate) {
      return new Error("(children) " + component + " - Duplicate children detected of bsRole: " + (duplicate + ". Only one child each allowed with the following ") + ("bsRoles: " + roles.join(', ')));
    }

    return null;
  });
}

/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(61);







var propTypes = {
  /**
   * If set to true, renders `span` instead of `a`
   */
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * `href` attribute for the inner `a` element
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * `title` attribute for the inner `a` element
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node,

  /**
   * `target` attribute for the inner `a` element
   */
  target: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var defaultProps = {
  active: false
};

var BreadcrumbItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(BreadcrumbItem, _React$Component);

  function BreadcrumbItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = BreadcrumbItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        href = _this$props.href,
        title = _this$props.title,
        target = _this$props.target,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "href", "title", "target", "className"]); // Don't try to render these props on non-active <span>.


    var linkProps = {
      href: href,
      title: title,
      target: target
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      })
    }, active ? __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", props) : __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, linkProps)));
  };

  return BreadcrumbItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

BreadcrumbItem.propTypes = propTypes;
BreadcrumbItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (BreadcrumbItem);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition__);









var propTypes = {
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  onAnimateOutEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateIn: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  animateOut: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  index: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number
};
var defaultProps = {
  active: false,
  animateIn: false,
  animateOut: false
};

var CarouselItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselItem, _React$Component);

  function CarouselItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleAnimateOutEnd = _this.handleAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = CarouselItem.prototype;

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.active !== nextProps.active) {
      this.setState({
        direction: null
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    var active = this.props.active;
    var prevActive = prevProps.active;

    if (!active && prevActive) {
      __WEBPACK_IMPORTED_MODULE_8_dom_helpers_transition___default.a.end(__WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this), this.handleAnimateOutEnd);
    }

    if (active !== prevActive) {
      setTimeout(function () {
        return _this2.startAnimation();
      }, 20);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.isUnmounted = true;
  };

  _proto.handleAnimateOutEnd = function handleAnimateOutEnd() {
    if (this.isUnmounted) {
      return;
    }

    if (this.props.onAnimateOutEnd) {
      this.props.onAnimateOutEnd(this.props.index);
    }
  };

  _proto.startAnimation = function startAnimation() {
    if (this.isUnmounted) {
      return;
    }

    this.setState({
      direction: this.props.direction === 'prev' ? 'right' : 'left'
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        direction = _this$props.direction,
        active = _this$props.active,
        animateIn = _this$props.animateIn,
        animateOut = _this$props.animateOut,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["direction", "active", "animateIn", "animateOut", "className"]);

    delete props.onAnimateOutEnd;
    delete props.index;
    var classes = {
      item: true,
      active: active && !animateIn || animateOut
    };

    if (direction && active && animateIn) {
      classes[direction] = true;
    }

    if (this.state.direction && (animateIn || animateOut)) {
      classes[this.state.direction] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return CarouselItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

CarouselItem.propTypes = propTypes;
CarouselItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (CarouselItem);

/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = camelizeStyleName;

var _camelize = _interopRequireDefault(__webpack_require__(1293));

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/camelizeStyleName.js
 */
var msPattern = /^-ms-/;

function camelizeStyleName(string) {
  return (0, _camelize.default)(string.replace(msPattern, 'ms-'));
}

module.exports = exports["default"];

/***/ }),
/* 514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = capitalize;
function capitalize(string) {
  return "" + string.charAt(0).toUpperCase() + string.slice(1);
}

/***/ }),
/* 515 */
/***/ (function(module, exports) {

module.exports = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),
/* 516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(17));

var _reactLifecyclesCompat = __webpack_require__(111);

var _PropTypes = __webpack_require__(1308);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = activeElement;

var _ownerDocument = _interopRequireDefault(__webpack_require__(123));

function activeElement(doc) {
  if (doc === void 0) {
    doc = (0, _ownerDocument.default)();
  }

  try {
    return doc.activeElement;
  } catch (e) {
    /* ie throws if no active element */
  }
}

module.exports = exports["default"];

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(191).f;
var has = __webpack_require__(193);
var TAG = __webpack_require__(97)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _contains = __webpack_require__(124);

var _contains2 = _interopRequireDefault(_contains);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _addEventListener = __webpack_require__(520);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var escapeKeyCode = 27;

function isLeftClickEvent(event) {
  return event.button === 0;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

/**
 * The `<RootCloseWrapper/>` component registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 */

var RootCloseWrapper = function (_React$Component) {
  _inherits(RootCloseWrapper, _React$Component);

  function RootCloseWrapper(props, context) {
    _classCallCheck(this, RootCloseWrapper);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.addEventListeners = function () {
      var event = _this.props.event;

      var doc = (0, _ownerDocument2.default)(_this);

      // Use capture for this listener so it fires before React's listener, to
      // avoid false positives in the contains() check below if the target DOM
      // element is removed in the React mouse callback.
      _this.documentMouseCaptureListener = (0, _addEventListener2.default)(doc, event, _this.handleMouseCapture, true);

      _this.documentMouseListener = (0, _addEventListener2.default)(doc, event, _this.handleMouse);

      _this.documentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this.handleKeyUp);
    };

    _this.removeEventListeners = function () {
      if (_this.documentMouseCaptureListener) {
        _this.documentMouseCaptureListener.remove();
      }

      if (_this.documentMouseListener) {
        _this.documentMouseListener.remove();
      }

      if (_this.documentKeyupListener) {
        _this.documentKeyupListener.remove();
      }
    };

    _this.handleMouseCapture = function (e) {
      _this.preventMouseRootClose = isModifiedEvent(e) || !isLeftClickEvent(e) || (0, _contains2.default)(_reactDom2.default.findDOMNode(_this), e.target);
    };

    _this.handleMouse = function (e) {
      if (!_this.preventMouseRootClose && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.handleKeyUp = function (e) {
      if (e.keyCode === escapeKeyCode && _this.props.onRootClose) {
        _this.props.onRootClose(e);
      }
    };

    _this.preventMouseRootClose = false;
    return _this;
  }

  RootCloseWrapper.prototype.componentDidMount = function componentDidMount() {
    if (!this.props.disabled) {
      this.addEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (!this.props.disabled && prevProps.disabled) {
      this.addEventListeners();
    } else if (this.props.disabled && !prevProps.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.componentWillUnmount = function componentWillUnmount() {
    if (!this.props.disabled) {
      this.removeEventListeners();
    }
  };

  RootCloseWrapper.prototype.render = function render() {
    return this.props.children;
  };

  return RootCloseWrapper;
}(_react2.default.Component);

RootCloseWrapper.displayName = 'RootCloseWrapper';

RootCloseWrapper.propTypes = {
  /**
   * Callback fired after click or mousedown. Also triggers when user hits `esc`.
   */
  onRootClose: _propTypes2.default.func,
  /**
   * Children to render.
   */
  children: _propTypes2.default.element,
  /**
   * Disable the the RootCloseWrapper, preventing it from triggering `onRootClose`.
   */
  disabled: _propTypes2.default.bool,
  /**
   * Choose which document mouse event to bind to.
   */
  event: _propTypes2.default.oneOf(['click', 'mousedown'])
};

RootCloseWrapper.defaultProps = {
  event: 'click'
};

exports.default = RootCloseWrapper;
module.exports = exports['default'];

/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (node, event, handler, capture) {
  (0, _on2.default)(node, event, handler, capture);

  return {
    remove: function remove() {
      (0, _off2.default)(node, event, handler, capture);
    }
  };
};

var _on = __webpack_require__(288);

var _on2 = _interopRequireDefault(_on);

var _off = __webpack_require__(289);

var _off2 = _interopRequireDefault(_off);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = exports['default'];

/***/ }),
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Button__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(11);









var propTypes = {
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  open: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  useAnchor: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  open: false,
  useAnchor: false,
  bsRole: 'toggle'
};

var DropdownToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownToggle, _React$Component);

  function DropdownToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        noCaret = _this$props.noCaret,
        open = _this$props.open,
        useAnchor = _this$props.useAnchor,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["noCaret", "open", "useAnchor", "bsClass", "className", "children"]);

    delete props.bsRole;
    var Component = useAnchor ? __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_6__Button__["a" /* default */];
    var useCaret = !noCaret; // This intentionally forwards bsSize and bsStyle (if set) to the
    // underlying component, to allow it to render size and style variants.
    // FIXME: Should this really fall back to `title` as children?

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "button",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, bsClass),
      "aria-haspopup": true,
      "aria-expanded": open
    }), children || props.title, useCaret && ' ', useCaret && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      className: "caret"
    }));
  };

  return DropdownToggle;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownToggle.propTypes = propTypes;
DropdownToggle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-toggle', DropdownToggle));

/***/ }),
/* 522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * Turn any fixed-width grid layout into a full-width layout by this property.
   *
   * Adds `container-fluid` class.
   */
  fluid: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div',
  fluid: false
};

var Grid =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Grid, _React$Component);

  function Grid() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Grid.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        fluid = _this$props.fluid,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["fluid", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, fluid && 'fluid');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Grid.propTypes = propTypes;
Grid.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('container', Grid));

/***/ }),
/* 523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(37);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  listItem: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  type: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  listItem: false
};

var ListGroupItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroupItem, _React$Component);

  function ListGroupItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroupItem.prototype;

  _proto.renderHeader = function renderHeader(header, headingClassName) {
    if (__WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(header)) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(header, {
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(header.props.className, headingClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("h4", {
      className: headingClassName
    }, header);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        className = _this$props.className,
        header = _this$props.header,
        listItem = _this$props.listItem,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "className", "header", "listItem", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active,
      disabled: disabled
    });

    var Component;

    if (elementProps.href) {
      Component = 'a';
    } else if (elementProps.onClick) {
      Component = 'button';
      elementProps.type = elementProps.type || 'button';
    } else if (listItem) {
      Component = 'li';
    } else {
      Component = 'span';
    }

    elementProps.className = __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes); // TODO: Deprecate `header` prop.

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, this.renderHeader(header, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading')), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("p", {
        className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'text')
      }, children));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, elementProps, children);
  };

  return ListGroupItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ListGroupItem.propTypes = propTypes;
ListGroupItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group-item', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ListGroupItem)));

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = addClass;

var _hasClass = _interopRequireDefault(__webpack_require__(526));

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + ' ' + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + ' ' + className);
}

module.exports = exports["default"];

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hasClass;

function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);else return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

module.exports = exports["default"];

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp('(^|\\s)' + classToRemove + '(?:\\s|$)', 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

module.exports = function removeClass(element, className) {
  if (element.classList) element.classList.remove(className);else if (typeof element.className === 'string') element.className = replaceClassName(element.className, className);else element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
};

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isOverflowing;

var _isWindow = __webpack_require__(206);

var _isWindow2 = _interopRequireDefault(_isWindow);

var _ownerDocument = __webpack_require__(123);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isBody(node) {
  return node && node.tagName.toLowerCase() === 'body';
}

function bodyIsOverflowing(node) {
  var doc = (0, _ownerDocument2.default)(node);
  var win = (0, _isWindow2.default)(doc);
  var fullWidth = win.innerWidth;

  // Support: ie8, no innerWidth
  if (!fullWidth) {
    var documentElementRect = doc.documentElement.getBoundingClientRect();
    fullWidth = documentElementRect.right - Math.abs(documentElementRect.left);
  }

  return doc.body.clientWidth < fullWidth;
}

function isOverflowing(container) {
  var win = (0, _isWindow2.default)(container);

  return win || isBody(container) ? bodyIsOverflowing(container) : container.scrollHeight > container.clientHeight;
}
module.exports = exports['default'];

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(205);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(207);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

var _LegacyPortal = __webpack_require__(1356);

var _LegacyPortal2 = _interopRequireDefault(_LegacyPortal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.setContainer = function () {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;

      _this._portalContainerNode = (0, _getContainer2.default)(props.container, (0, _ownerDocument2.default)(_this).body);
    }, _this.getMountNode = function () {
      return _this._portalContainerNode;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this.setContainer();
    this.forceUpdate(this.props.onRendered);
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.container !== this.props.container) {
      this.setContainer(nextProps);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._portalContainerNode = null;
  };

  Portal.prototype.render = function render() {
    return this.props.children && this._portalContainerNode ? _reactDom2.default.createPortal(this.props.children, this._portalContainerNode) : null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = _reactDom2.default.createPortal ? Portal : _LegacyPortal2.default;
module.exports = exports['default'];

/***/ }),
/* 530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalBody, _React$Component);

  function ModalBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalBody.propTypes = propTypes;
ModalBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-body', ModalBody));

/***/ }),
/* 531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(37);








var propTypes = {
  /**
   * A css class to apply to the Modal dialog DOM node.
   */
  dialogClassName: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};

var ModalDialog =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalDialog, _React$Component);

  function ModalDialog() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalDialog.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        dialogClassName = _this$props.dialogClassName,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["dialogClassName", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps);

    var modalStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block'
    }, style);

    var dialogClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[bsClassName] = false, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dialog')] = true, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      tabIndex: "-1",
      role: "dialog",
      style: modalStyle,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(dialogClassName, dialogClasses)
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content'),
      role: "document"
    }, children)));
  };

  return ModalDialog;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalDialog.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], ModalDialog)));

/***/ }),
/* 532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var ModalFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalFooter, _React$Component);

  function ModalFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalFooter;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalFooter.propTypes = propTypes;
ModalFooter.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-footer', ModalFooter));

/***/ }),
/* 533 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CloseButton__ = __webpack_require__(282);








 // TODO: `aria-label` should be `closeLabel`.

var propTypes = {
  /**
   * Provides an accessible label for the close
   * button. It is used for Assistive Technology when the label text is not
   * readable.
   */
  closeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,

  /**
   * Specify whether the Component should contain a close button
   */
  closeButton: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * A Callback fired when the close button is clicked. If used directly inside
   * a Modal component, the onHide will automatically be propagated up to the
   * parent Modal `onHide`.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
};
var defaultProps = {
  closeLabel: 'Close',
  closeButton: false
};
var contextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
  })
};

var ModalHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalHeader, _React$Component);

  function ModalHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        closeLabel = _this$props.closeLabel,
        closeButton = _this$props.closeButton,
        onHide = _this$props.onHide,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["closeLabel", "closeButton", "onHide", "className", "children"]);

    var modal = this.context.$bs_modal;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), closeButton && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CloseButton__["a" /* default */], {
      label: closeLabel,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(modal && modal.onHide, onHide)
    }), children);
  };

  return ModalHeader;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ModalHeader.propTypes = propTypes;
ModalHeader.defaultProps = defaultProps;
ModalHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-header', ModalHeader));

/***/ }),
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var ModalTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ModalTitle, _React$Component);

  function ModalTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ModalTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ModalTitle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ModalTitle.propTypes = propTypes;
ModalTitle.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('modal-title', ModalTitle));

/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(43);












 // TODO: Should we expose `<NavItem>` as `<Nav.Item>`?
// TODO: This `bsStyle` is very unlike the others. Should we rename it?
// TODO: `pullRight` and `pullLeft` don't render right outside of `navbar`.
// Consider renaming or replacing them.

var propTypes = {
  /**
   * Marks the NavItem with a matching `eventKey` as active. Has a
   * higher precedence over `activeHref`.
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Marks the child NavItem with a matching `href` prop as active.
   */
  activeHref: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * NavItems are be positioned vertically.
   */
  stacked: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  justified: __WEBPACK_IMPORTED_MODULE_8_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var justified = _ref.justified,
        navbar = _ref.navbar;
    return justified && navbar ? Error('justified navbar `Nav`s are not supported') : null;
  }),

  /**
   * A callback fired when a NavItem is selected.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * ARIA role for the Nav, in the context of a TabContainer, the default will
   * be set to "tablist", but can be overridden by the Nav when set explicitly.
   *
   * When the role is set to "tablist" NavItem focus is managed according to
   * the ARIA authoring practices for tabs:
   * https://www.w3.org/TR/2013/WD-wai-aria-practices-20130307/#tabpanel
   */
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Apply styling an alignment for use in a Navbar. This prop will be set
   * automatically when the Nav is used inside a Navbar.
   */
  navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the right. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Float the Nav to the left. When `navbar` is `true` the appropriate
   * contextual classes are added as well.
   */
  pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  justified: false,
  pullRight: false,
  pullLeft: false,
  stacked: false
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired
  })
};

var Nav =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Nav, _React$Component);

  function Nav() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Nav.prototype;

  _proto.componentDidUpdate = function componentDidUpdate() {
    var _this = this;

    if (!this._needsRefocus) {
      return;
    }

    this._needsRefocus = false;
    var children = this.props.children;

    var _this$getActiveProps = this.getActiveProps(),
        activeKey = _this$getActiveProps.activeKey,
        activeHref = _this$getActiveProps.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    });
    var childrenArray = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].toArray(children);
    var activeChildIndex = childrenArray.indexOf(activeChild);
    var childNodes = __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(this).children;
    var activeNode = childNodes && childNodes[activeChildIndex];

    if (!activeNode || !activeNode.firstChild) {
      return;
    }

    activeNode.firstChild.focus();
  };

  _proto.getActiveProps = function getActiveProps() {
    var tabContainer = this.context.$bs_tabContainer;

    if (tabContainer) {
       false ? warning(this.props.activeKey == null && !this.props.activeHref, 'Specifying a `<Nav>` `activeKey` or `activeHref` in the context of ' + 'a `<TabContainer>` is not supported. Instead use `<TabContainer ' + ("activeKey={" + this.props.activeKey + "} />`.")) : void 0;
      return tabContainer;
    }

    return this.props;
  };

  _proto.getNextActiveChild = function getNextActiveChild(offset) {
    var _this2 = this;

    var children = this.props.children;
    var validChildren = children.filter(function (child) {
      return child.props.eventKey != null && !child.props.disabled;
    });

    var _this$getActiveProps2 = this.getActiveProps(),
        activeKey = _this$getActiveProps2.activeKey,
        activeHref = _this$getActiveProps2.activeHref;

    var activeChild = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].find(children, function (child) {
      return _this2.isActive(child, activeKey, activeHref);
    }); // This assumes the active child is not disabled.

    var activeChildIndex = validChildren.indexOf(activeChild);

    if (activeChildIndex === -1) {
      // Something has gone wrong. Select the first valid child we can find.
      return validChildren[0];
    }

    var nextIndex = activeChildIndex + offset;
    var numValidChildren = validChildren.length;

    if (nextIndex >= numValidChildren) {
      nextIndex = 0;
    } else if (nextIndex < 0) {
      nextIndex = numValidChildren - 1;
    }

    return validChildren[nextIndex];
  };

  _proto.getTabProps = function getTabProps(child, tabContainer, navRole, active, onSelect) {
    var _this3 = this;

    if (!tabContainer && navRole !== 'tablist') {
      // No tab props here.
      return null;
    }

    var _child$props = child.props,
        id = _child$props.id,
        controls = _child$props['aria-controls'],
        eventKey = _child$props.eventKey,
        role = _child$props.role,
        onKeyDown = _child$props.onKeyDown,
        tabIndex = _child$props.tabIndex;

    if (tabContainer) {
       false ? warning(!id && !controls, 'In the context of a `<TabContainer>`, `<NavItem>`s are given ' + 'generated `id` and `aria-controls` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly, provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      id = tabContainer.getTabId(eventKey);
      controls = tabContainer.getPaneId(eventKey);
    }

    if (navRole === 'tablist') {
      role = role || 'tab';
      onKeyDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(function (event) {
        return _this3.handleTabKeyDown(onSelect, event);
      }, onKeyDown);
      tabIndex = active ? tabIndex : -1;
    }

    return {
      id: id,
      role: role,
      onKeyDown: onKeyDown,
      'aria-controls': controls,
      tabIndex: tabIndex
    };
  };

  _proto.handleTabKeyDown = function handleTabKeyDown(onSelect, event) {
    var nextActiveChild;

    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.left:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.up:
        nextActiveChild = this.getNextActiveChild(-1);
        break;

      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.right:
      case __WEBPACK_IMPORTED_MODULE_4_keycode___default.a.codes.down:
        nextActiveChild = this.getNextActiveChild(1);
        break;

      default:
        // It was a different key; don't handle this keypress.
        return;
    }

    event.preventDefault();

    if (onSelect && nextActiveChild && nextActiveChild.props.eventKey != null) {
      onSelect(nextActiveChild.props.eventKey);
    }

    this._needsRefocus = true;
  };

  _proto.isActive = function isActive(_ref2, activeKey, activeHref) {
    var props = _ref2.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _extends2,
        _this4 = this;

    var _this$props = this.props,
        stacked = _this$props.stacked,
        justified = _this$props.justified,
        onSelect = _this$props.onSelect,
        propsRole = _this$props.role,
        propsNavbar = _this$props.navbar,
        pullRight = _this$props.pullRight,
        pullLeft = _this$props.pullLeft,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["stacked", "justified", "onSelect", "role", "navbar", "pullRight", "pullLeft", "className", "children"]);

    var tabContainer = this.context.$bs_tabContainer;
    var role = propsRole || (tabContainer ? 'tablist' : null);

    var _this$getActiveProps3 = this.getActiveProps(),
        activeKey = _this$getActiveProps3.activeKey,
        activeHref = _this$getActiveProps3.activeHref;

    delete props.activeKey; // Accessed via this.getActiveProps().

    delete props.activeHref; // Accessed via this.getActiveProps().

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'stacked')] = stacked, _extends2[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'justified')] = justified, _extends2));

    var navbar = propsNavbar != null ? propsNavbar : this.context.$bs_navbar;
    var pullLeftClassName;
    var pullRightClassName;

    if (navbar) {
      var navbarProps = this.context.$bs_navbar || {
        bsClass: 'navbar'
      };
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'nav')] = true;
      pullRightClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right');
      pullLeftClassName = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left');
    } else {
      pullRightClassName = 'pull-right';
      pullLeftClassName = 'pull-left';
    }

    classes[pullRightClassName] = pullRight;
    classes[pullLeftClassName] = pullLeft;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: role,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var active = _this4.isActive(child, activeKey, activeHref);

      var childOnSelect = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect, navbar && navbar.onSelect, tabContainer && tabContainer.onSelect);
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, _this4.getTabProps(child, tabContainer, role, active, childOnSelect), {
        active: active,
        activeKey: activeKey,
        activeHref: activeHref,
        onSelect: childOnSelect
      }));
    }));
  };

  return Nav;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Nav.propTypes = propTypes;
Nav.defaultProps = defaultProps;
Nav.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('nav', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["c" /* bsStyles */])(['tabs', 'pills'], Nav)));

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarBrand =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarBrand, _React$Component);

  function NavbarBrand() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarBrand.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'brand');

    if (__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(children)) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, className, bsClassName)
      });
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }), children);
  };

  return NavbarBrand;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarBrand.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarBrand);

/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(34);









var propTypes = {
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  active: false,
  disabled: false
};

var NavItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavItem, _React$Component);

  function NavItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = NavItem.prototype;

  _proto.handleClick = function handleClick(e) {
    if (this.props.disabled) {
      e.preventDefault();
      return;
    }

    if (this.props.onSelect) {
      this.props.onSelect(this.props.eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        active = _this$props.active,
        disabled = _this$props.disabled,
        onClick = _this$props.onClick,
        className = _this$props.className,
        style = _this$props.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["active", "disabled", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey; // These are injected down by `<Nav>` for building `<SubNav>`s.

    delete props.activeKey;
    delete props.activeHref;

    if (!props.role) {
      if (props.href === '#') {
        props.role = 'button';
      }
    } else if (props.role === 'tab') {
      props['aria-selected'] = active;
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return NavItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

NavItem.propTypes = propTypes;
NavItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (NavItem);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__ = __webpack_require__(1364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Fade__ = __webpack_require__(203);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a.propTypes, {
  /**
   * Set the visibility of the Overlay
   */
  show: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Specify whether the overlay should trigger onHide when the user clicks outside the overlay
   */
  rootClose: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback invoked by the overlay when it wishes to be hidden. Required if
   * `rootClose` is specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Use animation
   */
  animation: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * Sets the direction of the Overlay.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left'])
});

var defaultProps = {
  animation: __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */],
  rootClose: false,
  show: false,
  placement: 'right'
};

var Overlay =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Overlay, _React$Component);

  function Overlay() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Overlay.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animation = _this$props.animation,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["animation", "children"]);

    var transition = animation === true ? __WEBPACK_IMPORTED_MODULE_8__Fade__["a" /* default */] : animation || null;
    var child;

    if (!transition) {
      child = Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(children.props.className, 'in')
      });
    } else {
      child = children;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_overlays_lib_Overlay___default.a, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      transition: transition
    }), child);
  };

  return Overlay;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Overlay.propTypes = propTypes;
Overlay.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Overlay);

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = offset;

var _contains = _interopRequireDefault(__webpack_require__(124));

var _isWindow = _interopRequireDefault(__webpack_require__(206));

var _ownerDocument = _interopRequireDefault(__webpack_require__(123));

function offset(node) {
  var doc = (0, _ownerDocument.default)(node),
      win = (0, _isWindow.default)(doc),
      docElem = doc && doc.documentElement,
      box = {
    top: 0,
    left: 0,
    height: 0,
    width: 0
  };
  if (!doc) return; // Make sure it's not a disconnected DOM node

  if (!(0, _contains.default)(docElem, node)) return box;
  if (node.getBoundingClientRect !== undefined) box = node.getBoundingClientRect(); // IE8 getBoundingClientRect doesn't support width & height

  box = {
    top: box.top + (win.pageYOffset || docElem.scrollTop) - (docElem.clientTop || 0),
    left: box.left + (win.pageXOffset || docElem.scrollLeft) - (docElem.clientLeft || 0),
    width: (box.width == null ? node.offsetWidth : box.width) || 0,
    height: (box.height == null ? node.offsetHeight : box.height) || 0
  };
  return box;
}

module.exports = exports["default"];

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(206));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop : node.scrollTop;
  if (win) win.scrollTo('pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft, val);else node.scrollTop = val;
}

module.exports = exports["default"];

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(34);









var propTypes = {
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  previous: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  next: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
var defaultProps = {
  disabled: false,
  previous: false,
  next: false
};

var PagerItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PagerItem, _React$Component);

  function PagerItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleSelect = _this.handleSelect.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PagerItem.prototype;

  _proto.handleSelect = function handleSelect(e) {
    var _this$props = this.props,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (disabled) {
      e.preventDefault();
      return;
    }

    if (onSelect) {
      onSelect(eventKey, e);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        disabled = _this$props2.disabled,
        previous = _this$props2.previous,
        next = _this$props2.next,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["disabled", "previous", "next", "onClick", "className", "style"]);

    delete props.onSelect;
    delete props.eventKey;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        disabled: disabled,
        previous: previous,
        next: next
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      disabled: disabled,
      onClick: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleSelect)
    })));
  };

  return PagerItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PagerItem.propTypes = propTypes;
PagerItem.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (PagerItem);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(285);






var propTypes = {
  /**
   * Callback fired before the component expands
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to expand
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has expanded
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired before the component collapses
   */
  onExit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component starts to collapse
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,

  /**
   * Callback fired after the component has collapsed
   */
  onExited: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  })
};

var PanelCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelCollapse, _React$Component);

  function PanelCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelCollapse.prototype;

  _proto.render = function render() {
    var children = this.props.children;

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        bodyId = _ref.bodyId,
        _bsClass = _ref.bsClass,
        expanded = _ref.expanded;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        props = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId && bodyId) {
      props.id = bodyId;
      props.role = props.role || 'tabpanel';
      props['aria-labelledby'] = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'collapse')
    }, children));
  };

  return PanelCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelCollapse.propTypes = propTypes;
PanelCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelCollapse));

/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(34);









var propTypes = {
  /**
   * only here to satisfy linting, just the html onClick handler.
   *
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * You can use a custom element for this component
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: __WEBPACK_IMPORTED_MODULE_7__SafeAnchor__["a" /* default */]
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    bodyId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool
  })
};

var PanelToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelToggle, _React$Component);

  function PanelToggle() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = PanelToggle.prototype;

  _proto.handleToggle = function handleToggle(event) {
    var _ref = this.context.$bs_panel || {},
        onToggle = _ref.onToggle;

    if (onToggle) {
      onToggle(event);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        componentClass = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "componentClass"]);

    var _ref2 = this.context.$bs_panel || {},
        expanded = _ref2.expanded,
        bodyId = _ref2.bodyId;

    var Component = componentClass;
    props.onClick = Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(onClick, this.handleToggle);
    props['aria-expanded'] = expanded;
    props.className = __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, !expanded && 'collapsed');

    if (bodyId) {
      props['aria-controls'] = bodyId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, props);
  };

  return PanelToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelToggle.propTypes = propTypes;
PanelToggle.defaultProps = defaultProps;
PanelToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (PanelToggle);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Fade__ = __webpack_require__(203);












var propTypes = {
  /**
   * Uniquely identify the `<TabPane>` among its siblings.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Use animation when showing or hiding `<TabPane>`s. Use `false` to disable,
   * `true` to enable the default `<Fade>` animation or
   * a react-transition-group v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),

  /** @private * */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /** @private * */
  'aria-labelledby': __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * If not explicitly specified and rendered in the context of a
   * `<TabContent>`, the `bsClass` of the `<TabContent>` suffixed by `-pane`.
   * If otherwise not explicitly specified, `tab-pane`.
   */
  bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Transition onEnter callback when animation is not `false`
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntering callback when animation is not `false`
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onEntered callback when animation is not `false`
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExit callback when animation is not `false`
   */
  onExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExiting callback when animation is not `false`
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Transition onExited callback when animation is not `false`
   */
  onExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount the tab (add it to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Unmount the tab (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var contextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    getTabId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
    getPaneId: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  }),
  $bs_tabContent: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
    activeKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
    mountOnEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    unmountOnExit: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onPaneEnter: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onPaneExited: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    exiting: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool.isRequired
  })
};
/**
 * We override the `<TabContainer>` context so `<Nav>`s in `<TabPane>`s don't
 * conflict with the top level one.
 */

var childContextTypes = {
  $bs_tabContainer: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf([null])
};

var TabPane =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(TabPane, _React$Component);

  function TabPane(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEnter = _this.handleEnter.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.in = false;
    return _this;
  }

  var _proto = TabPane.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_tabContainer: null
    };
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.shouldBeIn()) {
      // In lieu of the action event firing.
      this.handleEnter();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.in) {
      if (!this.shouldBeIn()) {
        // We shouldn't be active any more. Notify the parent.
        this.handleExited();
      }
    } else if (this.shouldBeIn()) {
      // We are the active child. Notify the parent.
      this.handleEnter();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.in) {
      // In lieu of the action event firing.
      this.handleExited();
    }
  };

  _proto.getAnimation = function getAnimation() {
    if (this.props.animation != null) {
      return this.props.animation;
    }

    var tabContent = this.context.$bs_tabContent;
    return tabContent && tabContent.animation;
  };

  _proto.handleEnter = function handleEnter() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    this.in = tabContent.onPaneEnter(this, this.props.eventKey);
  };

  _proto.handleExited = function handleExited() {
    var tabContent = this.context.$bs_tabContent;

    if (!tabContent) {
      return;
    }

    tabContent.onPaneExited(this);
    this.in = false;
  };

  _proto.isActive = function isActive() {
    var tabContent = this.context.$bs_tabContent;
    var activeKey = tabContent && tabContent.activeKey;
    return this.props.eventKey === activeKey;
  };

  _proto.shouldBeIn = function shouldBeIn() {
    return this.getAnimation() && this.isActive();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        className = _this$props.className,
        onEnter = _this$props.onEnter,
        onEntering = _this$props.onEntering,
        onEntered = _this$props.onEntered,
        onExit = _this$props.onExit,
        onExiting = _this$props.onExiting,
        onExited = _this$props.onExited,
        propsMountOnEnter = _this$props.mountOnEnter,
        propsUnmountOnExit = _this$props.unmountOnExit,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["eventKey", "className", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "mountOnEnter", "unmountOnExit"]);

    var _this$context = this.context,
        tabContent = _this$context.$bs_tabContent,
        tabContainer = _this$context.$bs_tabContainer;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['animation']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var active = this.isActive();
    var animation = this.getAnimation();
    var mountOnEnter = propsMountOnEnter != null ? propsMountOnEnter : tabContent && tabContent.mountOnEnter;
    var unmountOnExit = propsUnmountOnExit != null ? propsUnmountOnExit : tabContent && tabContent.unmountOnExit;

    if (!active && !animation && unmountOnExit) {
      return null;
    }

    var Transition = animation === true ? __WEBPACK_IMPORTED_MODULE_11__Fade__["a" /* default */] : animation || null;

    if (tabContent) {
      bsProps.bsClass = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(tabContent, 'pane');
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      active: active
    });

    if (tabContainer) {
       false ? warning(!elementProps.id && !elementProps['aria-labelledby'], 'In the context of a `<TabContainer>`, `<TabPanes>` are given ' + 'generated `id` and `aria-labelledby` attributes for the sake of ' + 'proper component accessibility. Any provided ones will be ignored. ' + 'To control these attributes directly provide a `generateChildId` ' + 'prop to the parent `<TabContainer>`.') : void 0;
      elementProps.id = tabContainer.getPaneId(eventKey);
      elementProps['aria-labelledby'] = tabContainer.getTabId(eventKey);
    }

    var pane = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tabpanel",
      "aria-hidden": !active,
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));

    if (Transition) {
      var exiting = tabContent && tabContent.exiting;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Transition, {
        in: active && !exiting,
        onEnter: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleEnter, onEnter),
        onEntering: onEntering,
        onEntered: onEntered,
        onExit: onExit,
        onExiting: onExiting,
        onExited: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(this.handleExited, onExited),
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit
      }, pane);
    }

    return pane;
  };

  return TabPane;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

TabPane.propTypes = propTypes;
TabPane.contextTypes = contextTypes;
TabPane.childContextTypes = childContextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('tab-pane', TabPane));

/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(149);






var propTypes = {
  /**
   * The `<input>` `type`
   * @type {[type]}
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']),

  /**
   * The HTML input name, used to group like checkboxes or radio buttons together
   * semantically
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The checked state of the input, managed by `<ToggleButtonGroup>`` automatically
   */
  checked: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * The disabled state of both the label and input
   */
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * [onChange description]
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The value of the input, and unique identifier in the ToggleButtonGroup
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any.isRequired
};

var ToggleButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButton, _React$Component);

  function ToggleButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        name = _this$props.name,
        checked = _this$props.checked,
        type = _this$props.type,
        onChange = _this$props.onChange,
        value = _this$props.value,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "name", "checked", "type", "onChange", "value"]);

    var disabled = props.disabled;
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      active: !!checked,
      componentClass: "label"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", {
      name: name,
      type: type,
      autoComplete: "off",
      value: value,
      checked: !!checked,
      disabled: !!disabled,
      onChange: onChange
    }), children);
  };

  return ToggleButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButton.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (ToggleButton);

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _AvailableIconsets */
/* unused harmony export _DefaultIconset */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return _DefaultIconSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _DefaultIconColor; });
/* harmony export (immutable) */ __webpack_exports__["e"] = guessIconset;
/* harmony export (immutable) */ __webpack_exports__["c"] = getAllIcons;
/* harmony export (immutable) */ __webpack_exports__["f"] = isIonicons;
/* harmony export (immutable) */ __webpack_exports__["d"] = getReactIconsKitSvg;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_icons_kit_entypo___ = __webpack_require__(1403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_icons_kit_entypo____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_icons_kit_entypo___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icons_kit_fa___ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icons_kit_fa____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icons_kit_fa___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_kit_iconic___ = __webpack_require__(1405);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_kit_iconic____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_kit_iconic___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_kit_icomoon___ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_icons_kit_icomoon____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_icons_kit_icomoon___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_kit_ikons___ = __webpack_require__(1407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_icons_kit_ikons____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_icons_kit_ikons___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_kit_ionicons___ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_icons_kit_ionicons____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_icons_kit_ionicons___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_kit_linea___ = __webpack_require__(1409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_icons_kit_linea____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_icons_kit_linea___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_kit_md___ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_icons_kit_md____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_icons_kit_md___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_kit_metrize___ = __webpack_require__(1411);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_icons_kit_metrize____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_icons_kit_metrize___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_kit_oct___ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_icons_kit_oct____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_icons_kit_oct___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_kit_typicons___ = __webpack_require__(1413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_icons_kit_typicons____default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_icons_kit_typicons___);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_ionicons_src_icons__ = __webpack_require__(1414);
// https://www.npmjs.com/package/react-native-vector-icons
/*
 * react-icons-kit (https://www.npmjs.com/package/react-icons-kit)
 * provides 11 icon sets
 * unfortunatelly ionic iconset is quite old
 */// open iconic
// ionicons v2
/*
 * Ionic v3 has a separate import
 *///import Ionicon from "react-ionicons";
// ionicons v3
var _AvailableIconsets={entypo:function entypo(){return __WEBPACK_IMPORTED_MODULE_0_react_icons_kit_entypo___;},fontawesome:function fontawesome(){return __WEBPACK_IMPORTED_MODULE_1_react_icons_kit_fa___;},icomoon:function icomoon(){return __WEBPACK_IMPORTED_MODULE_3_react_icons_kit_icomoon___;},iconic:function iconic(){return __WEBPACK_IMPORTED_MODULE_2_react_icons_kit_iconic___;},ionicons2:function ionicons2(){return __WEBPACK_IMPORTED_MODULE_5_react_icons_kit_ionicons___;},ionicons3:function ionicons3(){return __WEBPACK_IMPORTED_MODULE_11_react_ionicons_src_icons__["a" /* default */].map(function(item){return item.tags[0];// return the first (and only) element of tags key
});},ikons:function ikons(){return __WEBPACK_IMPORTED_MODULE_4_react_icons_kit_ikons___;},linea:function linea(){return __WEBPACK_IMPORTED_MODULE_6_react_icons_kit_linea___;},metrize:function metrize(){return __WEBPACK_IMPORTED_MODULE_8_react_icons_kit_metrize___;},octicons:function octicons(){return __WEBPACK_IMPORTED_MODULE_9_react_icons_kit_oct___;},typicons:function typicons(){return __WEBPACK_IMPORTED_MODULE_10_react_icons_kit_typicons___;},material:function material(){return __WEBPACK_IMPORTED_MODULE_7_react_icons_kit_md___;}};var _DefaultIconset="material";var _DefaultIconSize=60;var _DefaultIconColor="#4F4F4F";/*
 * Functions
 */// try to guess the iconset, use the "_DefaultIconset" value otherwise...
function guessIconset(iconset){if(_AvailableIconsets[iconset]){return iconset;}var retval=void 0;switch(iconset){case"fa":retval="fontawesome";break;case"ionicons":retval="ionicons3";break;case"oct":retval="octicons";break;default:retval=_DefaultIconset;}return retval;}// get all icon
function getAllIcons(iconset){iconset=guessIconset(iconset);return _AvailableIconsets[iconset]();}// return true if is ionicons
function isIonicons(iconset){if(!iconset){console.log("Error: isIonicons (Iconset.js) null parameter");}return iconset==="ionicons3"?true:false;}// get svg data
function getReactIconsKitSvg(iconset,icon){if(isIonicons(iconset)){return null;}// get svg icon data
var data=_AvailableIconsets[iconset]();return data[icon];}

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1428);


/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {

  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null

};

module.exports = ReactCurrentOwner;

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2014-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypeLocationNames = {};

if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
}

module.exports = ReactPropTypeLocationNames;

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

if (false) {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(1440)();
}


/***/ }),
/* 554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * is-plain-object <https://github.com/jonschlinkert/is-plain-object>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



var isObject = __webpack_require__(1445);

function isObjectObject(o) {
  return isObject(o) === true
    && Object.prototype.toString.call(o) === '[object Object]';
}

module.exports = function isPlainObject(o) {
  var ctor,prot;

  if (isObjectObject(o) === false) return false;

  // If has modified constructor
  ctor = o.constructor;
  if (typeof ctor !== 'function') return false;

  // If has modified prototype
  prot = ctor.prototype;
  if (isObjectObject(prot) === false) return false;

  // If constructor does not have an Object-specific method
  if (prot.hasOwnProperty('isPrototypeOf') === false) {
    return false;
  }

  // Most likely a plain Object
  return true;
};


/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var style={ionicRow:{margin:0,padding:0},item:{marginLeft:15,marginRight:0,marginTop:10,marginBottom:0,padding:0,textAlign:'center',display:'inline-block',cursor:'pointer'},itemIcon:{margin:10},itemText:{paddingLeft:10,paddingRight:10,paddingTop:0,paddingBottom:10},itemHeader:{marginLeft:30,//>=item.marginLeft + itemIcon.margin
textAlign:'center',display:'inline-block'},icon:{margin:5}};/* harmony default export */ __webpack_exports__["a"] = (style);

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("defs", null, _react.default.createElement("path", {
  id: "a",
  d: "M0 0h24v24H0z"
})), _react.default.createElement("path", {
  d: "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
})), 'ConfirmationNumber');

exports.default = _default;

/***/ }),
/* 558 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M5 9.2h3V19H5zM10.6 5h2.8v14h-2.8zm5.6 8H19v6h-2.8z"
}), 'BarChart');

exports.default = _default;

/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useAutocomplete__ = __webpack_require__(1468);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__useAutocomplete__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__useAutocomplete__["a"]; });


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  fill: "none",
  d: "M24 24H0V0h24v24z"
}), _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "8"
})), 'FiberManualRecord');

exports.default = _default;

/***/ }),
/* 561 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
}), 'Block');

exports.default = _default;

/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckCircle');

exports.default = _default;

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
}), 'Notifications');

exports.default = _default;

/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "10"
}), 'Brightness1');

exports.default = _default;

/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Rating__ = __webpack_require__(1489);
/* unused harmony reexport default */


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Skeleton__ = __webpack_require__(1499);
/* unused harmony reexport default */


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpeedDial__ = __webpack_require__(1500);
/* unused harmony reexport default */


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpeedDialAction__ = __webpack_require__(1501);
/* unused harmony reexport default */


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SpeedDialIcon__ = __webpack_require__(1502);
/* unused harmony reexport default */


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleButton__ = __webpack_require__(1504);
/* unused harmony reexport default */


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ToggleButtonGroup__ = __webpack_require__(1505);
/* unused harmony reexport default */


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TreeItem__ = __webpack_require__(1507);
/* unused harmony reexport default */


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * @ignore - internal component.
 */

var TreeViewContext = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createContext({});

if (false) {
  TreeViewContext.displayName = 'TreeViewContext';
}

/* harmony default export */ __webpack_exports__["a"] = (TreeViewContext);

/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TreeView__ = __webpack_require__(1508);
/* unused harmony reexport default */


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetNotifications;
/* harmony export (immutable) */ __webpack_exports__["d"] = actionSaveNotification;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeleteNotification;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionGetUsersNotified;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AppActions__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__ = __webpack_require__(209);
/*** ACTIONS NOTIFICATIONS ******/function actionGetNotifications(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__["a" /* default */].getNotifications(getStore().app.app).then(function(response){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["d" /* ACT_NTF_CHANGE */],props:{notificationList:response}});succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveNotification(notification,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);notification.tskRunDate=new Date(notification.tskRunDate).getTime();if(notification.tskParams&&(!notification.tskParams.image||typeof notification.tskParams.image=='string')){//Si tiene una url y no un archivo seleccionado con el componente
if(notification.tskParams&&!notification.tskParams.image&&notification.tskParams.pathImg){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(notification.tskParams.pathImg);delete notification.tskParams.pathImg;delete notification.tskParams.nameImg;}__WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__["a" /* default */].saveNotification(getStore().app.app,notification).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}else{//Si tiene un archivo seleccionado por el componente
__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].uploadFile(notification.tskParams.image,'notifications','image').then(function(res){if(notification.tskParams&&notification.tskParams.pathImg&&notification.tskParams.pathImg!=res.path){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(notification.tskParams.pathImg);}notification.tskParams.image=res.downloadURL;notification.tskParams.nameImg=res.filename;notification.tskParams.pathImg=res.path;__WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__["a" /* default */].saveNotification(getStore().app.app,notification).then(function(response){successCallback();}).catch(errorCallback);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}};}function actionDeleteNotification(notification,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__["a" /* default */].deleteNotification(getStore().app.app,notification.id).then(function(response){if(notification.tskParams&&notification.tskParams.pathImg){__WEBPACK_IMPORTED_MODULE_3__provider_media_MediaService__["a" /* default */].deleteFile(notification.tskParams.pathImg);}successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionGetUsersNotified(notificationId,succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_notification_NotificationsService__["a" /* default */].getUsersNotified(getStore().app.app,notificationId).then(function(response){succesCallback&&succesCallback(response);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_2__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/****** FIN ACTION NOTIFICATIONS +**********/

/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = actionGetNews;
/* harmony export (immutable) */ __webpack_exports__["c"] = actionSaveNovelty;
/* harmony export (immutable) */ __webpack_exports__["a"] = actionDeleteNovelty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ActionTypes__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__provider_novelty_NoveltyService__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__provider_media_MediaService__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppActions__ = __webpack_require__(75);
/*** ACTIONS NEWS ******/function actionGetNews(succesCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_novelty_NoveltyService__["a" /* default */].getNews(getStore().app.app).then(function(response){// console.log("NEWS RESPONSE", response)
dispatch({type:__WEBPACK_IMPORTED_MODULE_0__ActionTypes__["e" /* ACT_NVT_CHANGE */],props:{noveltyList:response}});succesCallback&&succesCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}function actionSaveNovelty(novelty,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(true)(dispatch,getStore);novelty.nvtDate=new Date(novelty.nvtDate).getTime();if(!novelty.nvtImg||typeof novelty.nvtImg=='string'){//Si tiene una url y no un archivo seleccionado con el componente
if(!novelty.nvtImg&&novelty.nvtPathImg){__WEBPACK_IMPORTED_MODULE_2__provider_media_MediaService__["a" /* default */].deleteFile(novelty.nvtPathImg);delete novelty.nvtNameImg;delete novelty.nvtPathImg;}__WEBPACK_IMPORTED_MODULE_1__provider_novelty_NoveltyService__["a" /* default */].saveNovelty(getStore().app.app,novelty).then(function(response){successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}else{//Si tiene un archivo seleccionado por el componente
__WEBPACK_IMPORTED_MODULE_2__provider_media_MediaService__["a" /* default */].uploadFile(novelty.nvtImg,'news','image').then(function(res){if(novelty.nvtPathImg&&novelty.nvtPathImg!=res.path){__WEBPACK_IMPORTED_MODULE_2__provider_media_MediaService__["a" /* default */].deleteFile(novelty.nvtPathImg);}novelty.nvtImg=res.downloadURL;novelty.nvtNameImg=res.filename;novelty.nvtPathImg=res.path;__WEBPACK_IMPORTED_MODULE_1__provider_novelty_NoveltyService__["a" /* default */].saveNovelty(getStore().app.app,novelty).then(function(response){successCallback();}).catch(errorCallback);}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(false)(dispatch,getStore);});}};}function actionDeleteNovelty(novelty,successCallback,errorCallback){return function(dispatch,getStore){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(true)(dispatch,getStore);__WEBPACK_IMPORTED_MODULE_1__provider_novelty_NoveltyService__["a" /* default */].deleteNovelty(getStore().app.app,novelty.id).then(function(response){if(novelty.nvtPathImg){__WEBPACK_IMPORTED_MODULE_2__provider_media_MediaService__["a" /* default */].deleteFile(novelty.nvtPathImg);}successCallback();}).catch(errorCallback).finally(function(){Object(__WEBPACK_IMPORTED_MODULE_3__AppActions__["a" /* loading */])(false)(dispatch,getStore);});};}/****** FIN ACTION NEWS +**********/

/***/ }),
/* 577 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

exports.default = _default;

/***/ }),
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M7 14l5-5 5 5z"
}), 'ArrowDropUp');

exports.default = _default;

/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumb_css__ = __webpack_require__(1533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Breadcrumb_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__Breadcrumb_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/**
 * Componente que genera links con la pagina actual y su jerarquia. Tiene predefinido clases CSS, pero es necesario extenderlas para definir colores y background.
 */var Breadcrumb=function(_PureComponent){_inherits(Breadcrumb,_PureComponent);function Breadcrumb(props){_classCallCheck(this,Breadcrumb);var _this=_possibleConstructorReturn(this,(Breadcrumb.__proto__||Object.getPrototypeOf(Breadcrumb)).call(this,props));_this.generateBreadcrumb=_this.generateBreadcrumb.bind(_this);return _this;}_createClass(Breadcrumb,[{key:"generateBreadcrumb",value:function generateBreadcrumb(){var _props=this.props,path=_props.path,routesInfo=_props.routesInfo,separator=_props.separator,theme=_props.theme;var pathWithSlash=path[path.length-1]!=="/"?path.concat("/"):path;var pathArray=pathWithSlash.split("");var slashLocation=void 0;var screen=void 0;var key=1;pathArray.shift();var breadcrumb=[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:routesInfo.home.path,className:["breadcrumb-link",this.props.linkClass].join(" "),style:theme.breadcrumb.text},routesInfo.home.name))];while(pathArray.length>0){slashLocation=pathArray.indexOf("/");screen=pathArray.slice(0,slashLocation).join("");if(routesInfo[screen]){key++;breadcrumb.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{key:key},pathArray.length>0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span",{style:theme.breadcrumb.separator}," ",separator):null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["c" /* NavLink */],{to:routesInfo[screen].path,className:["breadcrumb-link",this.props.linkClass].join(" "),style:theme.breadcrumb.text},routesInfo[screen].name)));}pathArray.splice(0,slashLocation+1);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:["bc-ul-style",this.props.ulContainerClass].join(" ")},breadcrumb);}},{key:"render",value:function render(){var theme=this.props.theme;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:theme.breadcrumb.container// className={["breadcrumb-container", this.props.mainContainerClass].join(
// 	" "
// )}
},this.generateBreadcrumb());}}]);return Breadcrumb;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);Breadcrumb.propTypes={/**
	 * Ruta actual en el navegador.
	 */path:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,/**
	 * Objeto que tendra la informacion de las rutas.
	 */routesInfo:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,/**
	 * Separador entre los links.
	 */separator:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
	 * Agrega clase CSS a div contenedor de componente.
	 */mainContainerClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
	 * Agrega clase CSS a elemento ul de HTML.
	 */ulContainerClass:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
	 * Agrega InlineStyle a separador de links. Tomar principalmente para cambiar dicho color.
	 */separatorStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object};Breadcrumb.defaultProps={separator:">"};/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["h" /* withTheme */])(Breadcrumb));

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0px;\n      left: 0px;\n      background: ', ';\n      color: ', ';\n      transition: opacity ', 'ms ease-out;\n      display: flex;\n      text-align: center;\n      font-size: 1.2em;\n      z-index: ', ';\n      &._loading-overlay-transition-appear,\n      &._loading-overlay-transition-enter {\n        opacity: 0.01;\n      }\n      &._loading-overlay-transition-appear._loading-overlay-transition-appear-active,\n      &._loading-overlay-transition-enter._loading-overlay-transition-enter-active {\n        opacity: 1;\n        transition: opacity .5s ease-in;\n      }\n      &._loading-overlay-transition-leave {\n        opacity: 1;\n      }\n      &._loading-overlay-transition-leave._loading-overlay-transition-leave-active {\n        opacity: 0;\n        transition: opacity .5s ease-in;\n      }\n    '], ['\n      position: absolute;\n      height: 100%;\n      width: 100%;\n      top: 0px;\n      left: 0px;\n      background: ', ';\n      color: ', ';\n      transition: opacity ', 'ms ease-out;\n      display: flex;\n      text-align: center;\n      font-size: 1.2em;\n      z-index: ', ';\n      &._loading-overlay-transition-appear,\n      &._loading-overlay-transition-enter {\n        opacity: 0.01;\n      }\n      &._loading-overlay-transition-appear._loading-overlay-transition-appear-active,\n      &._loading-overlay-transition-enter._loading-overlay-transition-enter-active {\n        opacity: 1;\n        transition: opacity .5s ease-in;\n      }\n      &._loading-overlay-transition-leave {\n        opacity: 1;\n      }\n      &._loading-overlay-transition-leave._loading-overlay-transition-leave-active {\n        opacity: 0;\n        transition: opacity .5s ease-in;\n      }\n    ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      position: relative;\n      margin: 0px auto 10px auto;\n      width: ', ';\n      max-height: 100%;\n      &:before {\n        content: \'\';\n        display: block;\n        padding-top: 100%;\n      }\n    '], ['\n      position: relative;\n      margin: 0px auto 10px auto;\n      width: ', ';\n      max-height: 100%;\n      &:before {\n        content: \'\';\n        display: block;\n        padding-top: 100%;\n      }\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n      margin: auto;\n    '], ['\n      margin: auto;\n    ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    '], ['\n      from {\n        transform: rotate(0deg);\n      }\n      to {\n        transform: rotate(360deg);\n      }\n    ']),
    _templateObject5 = _taggedTemplateLiteral(['\n      0% {\n        stroke-dasharray: 1,200;\n        stroke-dashoffset: 0;\n      }\n      50% {\n        stroke-dasharray: 89,200;\n        stroke-dashoffset: -35px;\n      }\n      100% {\n        stroke-dasharray: 89,200;\n        stroke-dashoffset: -124px;\n      }\n    '], ['\n      0% {\n        stroke-dasharray: 1,200;\n        stroke-dashoffset: 0;\n      }\n      50% {\n        stroke-dasharray: 89,200;\n        stroke-dashoffset: -35px;\n      }\n      100% {\n        stroke-dasharray: 89,200;\n        stroke-dashoffset: -124px;\n      }\n    ']),
    _templateObject6 = _taggedTemplateLiteral(['\n      animation: ', ' 2s linear infinite;\n      height: 100%;\n      transform-origin: center center;\n      width: 100%;\n      position: absolute;\n      top: 0; bottom: 0; left: 0; right: 0;\n      margin: auto;\n    '], ['\n      animation: ', ' 2s linear infinite;\n      height: 100%;\n      transform-origin: center center;\n      width: 100%;\n      position: absolute;\n      top: 0; bottom: 0; left: 0; right: 0;\n      margin: auto;\n    ']),
    _templateObject7 = _taggedTemplateLiteral(['\n      animation: ', ' 1.5s ease-in-out infinite;\n      stroke-dasharray: 1,200;\n      stroke-dashoffset: 0;\n      stroke-linecap: round;\n      stroke: ', ';\n    '], ['\n      animation: ', ' 1.5s ease-in-out infinite;\n      stroke-dasharray: 1,200;\n      stroke-dashoffset: 0;\n      stroke-linecap: round;\n      stroke: ', ';\n    ']);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactTransitionGroup = __webpack_require__(1534);

var _styledComponents = __webpack_require__(1540);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * LoadingOverlay
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Set as child component in a container. Toggle state with `active` prop.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * React transition group will handle the fade of the overlay.
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var FirstChild = function FirstChild(props) {
  return _react.Children.toArray(props.children)[0] || null;
};

var LoadingOverlayWrapper = function (_React$Component) {
  _inherits(LoadingOverlayWrapper, _React$Component);

  function LoadingOverlayWrapper() {
    _classCallCheck(this, LoadingOverlayWrapper);

    return _possibleConstructorReturn(this, (LoadingOverlayWrapper.__proto__ || Object.getPrototypeOf(LoadingOverlayWrapper)).apply(this, arguments));
  }

  _createClass(LoadingOverlayWrapper, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var s = nextProps.style;
      if (nextProps.active && (s.overflow || s.overflowY || s.overflowX)) {
        this.wrapper.scrollTop = 0;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          active = _props.active,
          animate = _props.animate,
          spinner = _props.spinner;


      var loadNode = active && _react2.default.createElement(LoadingOverlay, _extends({ key: 'the_dimmer' }, this.props));
      if (animate || spinner) {
        loadNode = _react2.default.createElement(
          _reactTransitionGroup.CSSTransitionGroup,
          {
            transitionName: '_loading-overlay-transition',
            transitionAppear: true,
            transitionEnterTimeout: 500,
            transitionLeaveTimeout: 500,
            transitionAppearTimeout: 500,
            component: FirstChild
          },
          loadNode
        );
      }

      var styles = _extends({
        position: 'relative'
      }, this.props.style);
      if (active) {
        if (styles.overflow) styles.overflow = 'hidden';
        if (styles.overflowY) styles.overflowY = 'hidden';
        if (styles.overflowX) styles.overflowX = 'hidden';
      }
      return _react2.default.createElement(
        'div',
        {
          ref: function ref(n) {
            _this2.wrapper = n;
          },
          className: this.props.className,
          style: styles
        },
        loadNode,
        this.props.children
      );
    }
  }]);

  return LoadingOverlayWrapper;
}(_react2.default.Component);

LoadingOverlayWrapper.propTypes = {
  active: _propTypes2.default.bool,
  text: _propTypes2.default.string,
  spinner: _propTypes2.default.bool,
  spinnerSize: _propTypes2.default.string,
  className: _propTypes2.default.string,
  background: _propTypes2.default.string,
  color: _propTypes2.default.string,
  zIndex: _propTypes2.default.number,
  animate: _propTypes2.default.bool
};

LoadingOverlayWrapper.defaultProps = {
  active: false,
  className: '_loading-overlay',
  background: 'rgba(0, 0, 0, 0.7)',
  spinnerSize: '50px',
  color: '#FFF',
  zIndex: 800,
  animate: false,
  style: {}
};

var LoadingOverlay = function (_React$Component2) {
  _inherits(LoadingOverlay, _React$Component2);

  function LoadingOverlay() {
    _classCallCheck(this, LoadingOverlay);

    return _possibleConstructorReturn(this, (LoadingOverlay.__proto__ || Object.getPrototypeOf(LoadingOverlay)).apply(this, arguments));
  }

  _createClass(LoadingOverlay, [{
    key: 'render',
    value: function render() {
      var Overlay = _styledComponents2.default.div(_templateObject, this.props.background, this.props.color, this.props.speed, this.props.zIndex);

      var Spinner = _styledComponents2.default.div(_templateObject2, this.props.spinnerSize);

      var Content = _styledComponents2.default.div(_templateObject3);

      var rotate360 = (0, _styledComponents.keyframes)(_templateObject4);

      var spinnerDash = (0, _styledComponents.keyframes)(_templateObject5);

      var Svg = _styledComponents2.default.svg(_templateObject6, rotate360);

      var Circle = _styledComponents2.default.circle(_templateObject7, spinnerDash, this.props.color);

      var spinnerNode = null;
      if (this.props.spinner) {
        spinnerNode = _react2.default.createElement(
          Spinner,
          null,
          _react2.default.createElement(
            Svg,
            { viewBox: '25 25 50 50' },
            _react2.default.createElement(Circle, { cx: '50', cy: '50', r: '20', fill: 'none', strokeWidth: '2', strokeMiterlimit: '10' })
          )
        );
      }

      var textNode = null;
      if (this.props.text) textNode = _react2.default.createElement(
        'div',
        null,
        this.props.text
      );

      var contentNode = null;
      if (this.props.text || this.props.spinner) {
        contentNode = _react2.default.createElement(
          Content,
          null,
          spinnerNode,
          textNode
        );
      }

      return _react2.default.createElement(
        Overlay,
        { key: 'dimmer' },
        contentNode
      );
    }
  }]);

  return LoadingOverlay;
}(_react2.default.Component);

LoadingOverlay.defaultProps = {
  text: null,
  spinner: false
};

exports.default = LoadingOverlayWrapper;

/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _chainFunction = __webpack_require__(1536);

var _chainFunction2 = _interopRequireDefault(_chainFunction);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(45);

var _warning2 = _interopRequireDefault(_warning);

var _ChildMapping = __webpack_require__(1537);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  component: _propTypes2.default.any,
  childFactory: _propTypes2.default.func,
  children: _propTypes2.default.node
};

var defaultProps = {
  component: 'span',
  childFactory: function childFactory(child) {
    return child;
  }
};

var TransitionGroup = function (_React$Component) {
  _inherits(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    _classCallCheck(this, TransitionGroup);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.performAppear = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillAppear) {
        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
      } else {
        _this._handleDoneAppearing(key, component);
      }
    };

    _this._handleDoneAppearing = function (key, component) {
      if (component.componentDidAppear) {
        component.componentDidAppear();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully appeared. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performEnter = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillEnter) {
        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
      } else {
        _this._handleDoneEntering(key, component);
      }
    };

    _this._handleDoneEntering = function (key, component) {
      if (component.componentDidEnter) {
        component.componentDidEnter();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
        // This was removed before it had fully entered. Remove it.
        _this.performLeave(key, component);
      }
    };

    _this.performLeave = function (key, component) {
      _this.currentlyTransitioningKeys[key] = true;

      if (component.componentWillLeave) {
        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
      } else {
        // Note that this is somewhat dangerous b/c it calls setState()
        // again, effectively mutating the component before all the work
        // is done.
        _this._handleDoneLeaving(key, component);
      }
    };

    _this._handleDoneLeaving = function (key, component) {
      if (component.componentDidLeave) {
        component.componentDidLeave();
      }

      delete _this.currentlyTransitioningKeys[key];

      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);

      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
        // This entered again before it fully left. Add it again.
        _this.keysToEnter.push(key);
      } else {
        _this.setState(function (state) {
          var newChildren = _extends({}, state.children);
          delete newChildren[key];
          return { children: newChildren };
        });
      }
    };

    _this.childRefs = Object.create(null);

    _this.state = {
      children: (0, _ChildMapping.getChildMapping)(props.children)
    };
    return _this;
  }

  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
    this.currentlyTransitioningKeys = {};
    this.keysToEnter = [];
    this.keysToLeave = [];
  };

  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
    var initialChildMapping = this.state.children;
    for (var key in initialChildMapping) {
      if (initialChildMapping[key]) {
        this.performAppear(key, this.childRefs[key]);
      }
    }
  };

  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
    var prevChildMapping = this.state.children;

    this.setState({
      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
    });

    for (var key in nextChildMapping) {
      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
        this.keysToEnter.push(key);
      }
    }

    for (var _key in prevChildMapping) {
      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
        this.keysToLeave.push(_key);
      }
    }

    // If we want to someday check for reordering, we could do it here.
  };

  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
    var _this2 = this;

    var keysToEnter = this.keysToEnter;
    this.keysToEnter = [];
    keysToEnter.forEach(function (key) {
      return _this2.performEnter(key, _this2.childRefs[key]);
    });

    var keysToLeave = this.keysToLeave;
    this.keysToLeave = [];
    keysToLeave.forEach(function (key) {
      return _this2.performLeave(key, _this2.childRefs[key]);
    });
  };

  TransitionGroup.prototype.render = function render() {
    var _this3 = this;

    // TODO: we could get rid of the need for the wrapper node
    // by cloning a single child
    var childrenToRender = [];

    var _loop = function _loop(key) {
      var child = _this3.state.children[key];
      if (child) {
        var isCallbackRef = typeof child.ref !== 'string';
        var factoryChild = _this3.props.childFactory(child);
        var ref = function ref(r) {
          _this3.childRefs[key] = r;
        };

         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;

        // Always chaining the refs leads to problems when the childFactory
        // wraps the child. The child ref callback gets called twice with the
        // wrapper and the child. So we only need to chain the ref if the
        // factoryChild is not different from child.
        if (factoryChild === child && isCallbackRef) {
          ref = (0, _chainFunction2.default)(child.ref, ref);
        }

        // You may need to apply reactive updates to a child as it is leaving.
        // The normal React way to do it won't work since the child will have
        // already been removed. In case you need this behavior you can provide
        // a childFactory function to wrap every child, even the ones that are
        // leaving.
        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
          key: key,
          ref: ref
        }));
      }
    };

    for (var key in this.state.children) {
      _loop(key);
    }

    // Do not forward TransitionGroup props to primitive DOM nodes
    var props = _extends({}, this.props);
    delete props.transitionLeave;
    delete props.transitionName;
    delete props.transitionAppear;
    delete props.transitionEnter;
    delete props.childFactory;
    delete props.transitionLeaveTimeout;
    delete props.transitionEnterTimeout;
    delete props.transitionAppearTimeout;
    delete props.component;

    return _react2.default.createElement(this.props.component, props, childrenToRender);
  };

  return TransitionGroup;
}(_react2.default.Component);

TransitionGroup.displayName = 'TransitionGroup';


TransitionGroup.propTypes =  false ? propTypes : {};
TransitionGroup.defaultProps = defaultProps;

exports.default = TransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.nameShape = undefined;
exports.transitionTimeout = transitionTimeout;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transitionTimeout(transitionType) {
  var timeoutPropName = 'transition' + transitionType + 'Timeout';
  var enabledPropName = 'transition' + transitionType;

  return function (props) {
    // If the transition is enabled
    if (props[enabledPropName]) {
      // If no timeout duration is provided
      if (props[timeoutPropName] == null) {
        return new Error(timeoutPropName + ' wasn\'t supplied to CSSTransitionGroup: ' + 'this can cause unreliable animations and won\'t be supported in ' + 'a future version of React. See ' + 'https://fb.me/react-animation-transition-group-timeout for more ' + 'information.');

        // If the duration isn't a number
      } else if (typeof props[timeoutPropName] !== 'number') {
        return new Error(timeoutPropName + ' must be a number (in milliseconds)');
      }
    }

    return null;
  };
}

var nameShape = exports.nameShape = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  active: _propTypes2.default.string
}), _propTypes2.default.shape({
  enter: _propTypes2.default.string,
  enterActive: _propTypes2.default.string,
  leave: _propTypes2.default.string,
  leaveActive: _propTypes2.default.string,
  appear: _propTypes2.default.string,
  appearActive: _propTypes2.default.string
})]);

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(586);
module.exports = __webpack_require__(591);


/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(587).enable();
  window.Promise = __webpack_require__(589);
}

// fetch() polyfill for making API calls.
__webpack_require__(590);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(77);


/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(301);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(301);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 590 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_core_js_es6_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_core_js_es6_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__ = __webpack_require__(617);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_core_js_es6_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_core_js_es6_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill__ = __webpack_require__(619);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_raf_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_raf_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tap_event_plugin__ = __webpack_require__(626);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_tap_event_plugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_tap_event_plugin__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css__ = __webpack_require__(631);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Root__ = __webpack_require__(632);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_noty_lib_noty_css__ = __webpack_require__(1564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_noty_lib_noty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_noty_lib_noty_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__registerServiceWorker__ = __webpack_require__(1565);
// <-- added this line after installed packages
// <-- added this line after installed packages
// <-- added this line after installed packages
//injectTapEventPlugin();
__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Root__["a" /* default */],null),document.getElementById("root"));Object(__WEBPACK_IMPORTED_MODULE_9__registerServiceWorker__["a" /* default */])();

/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
__webpack_require__(309);
__webpack_require__(315);
__webpack_require__(607);
module.exports = __webpack_require__(102).Map;


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(215)('native-function-to-string', Function.toString);


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(217);
var defined = __webpack_require__(218);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 595 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(311);
var descriptor = __webpack_require__(216);
var setToStringTag = __webpack_require__(221);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(104)(IteratorPrototype, __webpack_require__(56)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(105);
var anObject = __webpack_require__(106);
var getKeys = __webpack_require__(312);

module.exports = __webpack_require__(87) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(107);
var toIObject = __webpack_require__(159);
var arrayIndexOf = __webpack_require__(600)(false);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(304);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(159);
var toLength = __webpack_require__(313);
var toAbsoluteIndex = __webpack_require__(601);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(217);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(71).document;
module.exports = document && document.documentElement;


/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(107);
var toObject = __webpack_require__(604);
var IE_PROTO = __webpack_require__(220)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(218);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(606);
var step = __webpack_require__(316);
var Iterators = __webpack_require__(128);
var toIObject = __webpack_require__(159);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(219)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.3.31 Array.prototype[@@unscopables]
var UNSCOPABLES = __webpack_require__(56)('unscopables');
var ArrayProto = Array.prototype;
if (ArrayProto[UNSCOPABLES] == undefined) __webpack_require__(104)(ArrayProto, UNSCOPABLES, {});
module.exports = function (key) {
  ArrayProto[UNSCOPABLES][key] = true;
};


/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(317);
var validate = __webpack_require__(222);
var MAP = 'Map';

// 23.1 Map Objects
module.exports = __webpack_require__(322)(MAP, function (get) {
  return function Map() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.1.3.6 Map.prototype.get(key)
  get: function get(key) {
    var entry = strong.getEntry(validate(this, MAP), key);
    return entry && entry.v;
  },
  // 23.1.3.9 Map.prototype.set(key, value)
  set: function set(key, value) {
    return strong.def(validate(this, MAP), key === 0 ? 0 : key, value);
  }
}, strong, true);


/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(106);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(128);
var ITERATOR = __webpack_require__(56)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(303);
var ITERATOR = __webpack_require__(56)('iterator');
var Iterators = __webpack_require__(128);
module.exports = __webpack_require__(102).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(71);
var dP = __webpack_require__(105);
var DESCRIPTORS = __webpack_require__(87);
var SPECIES = __webpack_require__(56)('species');

module.exports = function (KEY) {
  var C = global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(56)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(78);
var setPrototypeOf = __webpack_require__(614).set;
module.exports = function (that, target, C) {
  var S = target.constructor;
  var P;
  if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
    setPrototypeOf(that, P);
  } return that;
};


/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(78);
var anObject = __webpack_require__(106);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(158)(Function.call, __webpack_require__(615).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(616);
var createDesc = __webpack_require__(216);
var toIObject = __webpack_require__(159);
var toPrimitive = __webpack_require__(308);
var has = __webpack_require__(107);
var IE8_DOM_DEFINE = __webpack_require__(306);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(87) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 616 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(302);
__webpack_require__(309);
__webpack_require__(315);
__webpack_require__(618);
module.exports = __webpack_require__(102).Set;


/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var strong = __webpack_require__(317);
var validate = __webpack_require__(222);
var SET = 'Set';

// 23.2 Set Objects
module.exports = __webpack_require__(322)(SET, function (get) {
  return function Set() { return get(this, arguments.length > 0 ? arguments[0] : undefined); };
}, {
  // 23.2.3.1 Set.prototype.add(value)
  add: function add(value) {
    return strong.def(validate(this, SET), value = value === 0 ? 0 : value, value);
  }
}, strong);


/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(620).polyfill()


/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(621)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(223)))

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(77),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113;n&&Symbol.for("react.suspense_list");
var z=n?Symbol.for("react.memo"):60115,aa=n?Symbol.for("react.lazy"):60116;n&&Symbol.for("react.fundamental");n&&Symbol.for("react.responder");n&&Symbol.for("react.scope");var A="function"===typeof Symbol&&Symbol.iterator;
function B(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
function E(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(B(85));this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,c){this.props=a;this.context=b;this.refs=D;this.updater=c||C}var H=G.prototype=new F;
H.constructor=G;h(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,l=null;if(null!=b)for(e in void 0!==b.ref&&(l=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var k=Array(f),m=0;m<f;m++)k[m]=arguments[m+2];d.children=k}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:l,props:d,_owner:J.current}}
function ba(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,c,e){if(P.length){var d=P.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
function S(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var l=0;l<a.length;l++){d=a[l];var f=b+T(d,l);g+=S(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),l=
0;!(d=a.next()).done;)d=d.value,f=b+T(d,l++),g+=S(d,f,c,e);else if("object"===d)throw c=""+a,Error(B(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function U(a,b,c){return null==a?0:S(a,"",b,c)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ca(a,b){a.func.call(a.context,b,a.count++)}
function da(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,e,c,function(a){return a}):null!=a&&(N(a)&&(a=ba(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+c)),e.push(a))}function V(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(O,"$&/")+"/");b=Q(b,g,e,d);U(a,da,b);R(b)}function W(){var a=I.current;if(null===a)throw Error(B(321));return a}
var X={Children:{map:function(a,b,c){if(null==a)return a;var e=[];V(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=Q(null,null,b,c);U(a,ca,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){if(!N(a))throw Error(B(143));return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:x,render:a}},lazy:function(a){return{$$typeof:aa,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
b,c){return W().useImperativeHandle(a,b,c)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,c){return W().useReducer(a,b,c)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,Profiler:u,StrictMode:t,Suspense:y,createElement:M,cloneElement:function(a,b,c){if(null===a||void 0===a)throw Error(B(267,a));var e=h({},a.props),d=a.key,g=a.ref,l=a._owner;
if(null!=b){void 0!==b.ref&&(g=b.ref,l=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(k in b)K.call(b,k)&&!L.hasOwnProperty(k)&&(e[k]=void 0===b[k]&&void 0!==f?f[k]:b[k])}var k=arguments.length-2;if(1===k)e.children=c;else if(1<k){f=Array(k);for(var m=0;m<k;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,key:d,ref:g,props:e,_owner:l}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.12.0",
__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:h}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(77),q=__webpack_require__(624);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));var ba=null,ca={};
function da(){if(ba)for(var a in ca){var b=ca[a],c=ba.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!ea[c]){if(!b.extractEvents)throw Error(u(97,a));ea[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(fa.hasOwnProperty(h))throw Error(u(99,h));fa[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ha(k[e],g,h);e=!0}else f.registrationName?(ha(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ha(a,b,c){if(ia[a])throw Error(u(100,a));ia[a]=b;ja[a]=b.eventTypes[c].dependencies}var ea=[],fa={},ia={},ja={};function ka(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var la=!1,ma=null,na=!1,oa=null,pa={onError:function(a){la=!0;ma=a}};function qa(a,b,c,d,e,f,g,h,k){la=!1;ma=null;ka.apply(pa,arguments)}
function ra(a,b,c,d,e,f,g,h,k){qa.apply(this,arguments);if(la){if(la){var l=ma;la=!1;ma=null}else throw Error(u(198));na||(na=!0,oa=l)}}var sa=null,ua=null,va=null;function wa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=va(c);ra(d,b,void 0,a);a.currentTarget=null}function xa(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
function ya(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var za=null;function Aa(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)wa(a,b[d],c[d]);else b&&wa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function Ba(a){null!==a&&(za=xa(za,a));a=za;za=null;if(a){ya(a,Aa);if(za)throw Error(u(95));if(na)throw a=oa,na=!1,oa=null,a;}}
var Ca={injectEventPluginOrder:function(a){if(ba)throw Error(u(101));ba=Array.prototype.slice.call(a);da()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!ca.hasOwnProperty(c)||ca[c]!==d){if(ca[c])throw Error(u(102,c));ca[c]=d;b=!0}}b&&da()}};
function Da(a,b){var c=a.stateNode;if(!c)return null;var d=sa(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,b,typeof c));
return c}var Ea=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Ea.hasOwnProperty("ReactCurrentDispatcher")||(Ea.ReactCurrentDispatcher={current:null});Ea.hasOwnProperty("ReactCurrentBatchConfig")||(Ea.ReactCurrentBatchConfig={suspense:null});
var Fa=/^(.*)[\\\/]/,w="function"===typeof Symbol&&Symbol.for,Ga=w?Symbol.for("react.element"):60103,Ha=w?Symbol.for("react.portal"):60106,Ia=w?Symbol.for("react.fragment"):60107,Ja=w?Symbol.for("react.strict_mode"):60108,Ka=w?Symbol.for("react.profiler"):60114,La=w?Symbol.for("react.provider"):60109,Ma=w?Symbol.for("react.context"):60110,Na=w?Symbol.for("react.concurrent_mode"):60111,Oa=w?Symbol.for("react.forward_ref"):60112,Pa=w?Symbol.for("react.suspense"):60113,Qa=w?Symbol.for("react.suspense_list"):
60120,Ra=w?Symbol.for("react.memo"):60115,Sa=w?Symbol.for("react.lazy"):60116;w&&Symbol.for("react.fundamental");w&&Symbol.for("react.responder");w&&Symbol.for("react.scope");var Ta="function"===typeof Symbol&&Symbol.iterator;function Ua(a){if(null===a||"object"!==typeof a)return null;a=Ta&&a[Ta]||a["@@iterator"];return"function"===typeof a?a:null}
function Va(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function Wa(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case Ia:return"Fragment";case Ha:return"Portal";case Ka:return"Profiler";case Ja:return"StrictMode";case Pa:return"Suspense";case Qa:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case Ma:return"Context.Consumer";case La:return"Context.Provider";case Oa:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case Ra:return Wa(a.type);case Sa:if(a=1===a._status?a._result:null)return Wa(a)}return null}function Xa(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=Wa(a.type);c=null;d&&(c=Wa(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Fa,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
var Ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),Za=null,$a=null,ab=null;function bb(a){if(a=ua(a)){if("function"!==typeof Za)throw Error(u(280));var b=sa(a.stateNode);Za(a.stateNode,a.type,b)}}function cb(a){$a?ab?ab.push(a):ab=[a]:$a=a}function db(){if($a){var a=$a,b=ab;ab=$a=null;bb(a);if(b)for(a=0;a<b.length;a++)bb(b[a])}}function eb(a,b){return a(b)}function fb(a,b,c,d){return a(b,c,d)}function gb(){}
var hb=eb,ib=!1,jb=!1;function kb(){if(null!==$a||null!==ab)gb(),db()}new Map;var lb=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,mb=Object.prototype.hasOwnProperty,nb={},ob={};
function pb(a){if(mb.call(ob,a))return!0;if(mb.call(nb,a))return!1;if(lb.test(a))return ob[a]=!0;nb[a]=!0;return!1}function qb(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function rb(a,b,c,d){if(null===b||"undefined"===typeof b||qb(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function B(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1)});var sb=/[\-:]([a-z])/g;function tb(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(sb,
tb);D[b]=new B(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(sb,tb);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1)});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0)});function ub(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}
function vb(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(rb(b,c,e,d)&&(c=null),d||null===e?pb(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
function wb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function xb(a){var b=wb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function yb(a){a._valueTracker||(a._valueTracker=xb(a))}function zb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=wb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Ab(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Bb(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=ub(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Cb(a,b){b=b.checked;null!=b&&vb(a,"checked",b,!1)}
function Eb(a,b){Cb(a,b);var c=ub(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Fb(a,b.type,c):b.hasOwnProperty("defaultValue")&&Fb(a,b.type,ub(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Gb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Fb(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Hb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Ib(a,b){a=n({children:void 0},b);if(b=Hb(b.children))a.children=b;return a}
function Jb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+ub(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Kb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Lb(a,b){var c=b.value;if(null==c){c=b.defaultValue;b=b.children;if(null!=b){if(null!=c)throw Error(u(92));if(Array.isArray(b)){if(!(1>=b.length))throw Error(u(93));b=b[0]}c=b}null==c&&(c="")}a._wrapperState={initialValue:ub(c)}}
function Mb(a,b){var c=ub(b.value),d=ub(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Nb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Ob={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Pb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Qb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Pb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Rb,Sb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Ob.svg||"innerHTML"in a)a.innerHTML=b;else{Rb=Rb||document.createElement("div");Rb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Rb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Tb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Ub(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Vb={animationend:Ub("Animation","AnimationEnd"),animationiteration:Ub("Animation","AnimationIteration"),animationstart:Ub("Animation","AnimationStart"),transitionend:Ub("Transition","TransitionEnd")},Wb={},Xb={};
Ya&&(Xb=document.createElement("div").style,"AnimationEvent"in window||(delete Vb.animationend.animation,delete Vb.animationiteration.animation,delete Vb.animationstart.animation),"TransitionEvent"in window||delete Vb.transitionend.transition);function Yb(a){if(Wb[a])return Wb[a];if(!Vb[a])return a;var b=Vb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xb)return Wb[a]=b[c];return a}var Zb=Yb("animationend"),$b=Yb("animationiteration"),ac=Yb("animationstart"),bc=Yb("transitionend"),cc="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" ");
function ec(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function fc(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function gc(a){if(ec(a)!==a)throw Error(u(188));}
function hc(a){var b=a.alternate;if(!b){b=ec(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return gc(e),a;if(f===d)return gc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function ic(a){a=hc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
var jc,kc,lc,mc=!1,nc=[],oc=null,pc=null,qc=null,rc=new Map,sc=new Map,tc=[],uc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),vc="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function wc(a){var b=xc(a);uc.forEach(function(c){yc(c,a,b)});vc.forEach(function(c){yc(c,a,b)})}function zc(a,b,c,d){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:d}}function Ac(a,b){switch(a){case "focus":case "blur":oc=null;break;case "dragenter":case "dragleave":pc=null;break;case "mouseover":case "mouseout":qc=null;break;case "pointerover":case "pointerout":rc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":sc.delete(b.pointerId)}}
function Bc(a,b,c,d,e){if(null===a||a.nativeEvent!==e)return a=zc(b,c,d,e),null!==b&&(b=Cc(b),null!==b&&kc(b)),a;a.eventSystemFlags|=d;return a}function Dc(a,b,c,d){switch(b){case "focus":return oc=Bc(oc,a,b,c,d),!0;case "dragenter":return pc=Bc(pc,a,b,c,d),!0;case "mouseover":return qc=Bc(qc,a,b,c,d),!0;case "pointerover":var e=d.pointerId;rc.set(e,Bc(rc.get(e)||null,a,b,c,d));return!0;case "gotpointercapture":return e=d.pointerId,sc.set(e,Bc(sc.get(e)||null,a,b,c,d)),!0}return!1}
function Ec(a){var b=Fc(a.target);if(null!==b){var c=ec(b);if(null!==c)if(b=c.tag,13===b){if(b=fc(c),null!==b){a.blockedOn=b;q.unstable_runWithPriority(a.priority,function(){lc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Gc(a){if(null!==a.blockedOn)return!1;var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);if(null!==b){var c=Cc(b);null!==c&&kc(c);a.blockedOn=b;return!1}return!0}
function Ic(a,b,c){Gc(a)&&c.delete(b)}function Jc(){for(mc=!1;0<nc.length;){var a=nc[0];if(null!==a.blockedOn){a=Cc(a.blockedOn);null!==a&&jc(a);break}var b=Hc(a.topLevelType,a.eventSystemFlags,a.nativeEvent);null!==b?a.blockedOn=b:nc.shift()}null!==oc&&Gc(oc)&&(oc=null);null!==pc&&Gc(pc)&&(pc=null);null!==qc&&Gc(qc)&&(qc=null);rc.forEach(Ic);sc.forEach(Ic)}function Kc(a,b){a.blockedOn===b&&(a.blockedOn=null,mc||(mc=!0,q.unstable_scheduleCallback(q.unstable_NormalPriority,Jc)))}
function Lc(a){function b(b){return Kc(b,a)}if(0<nc.length){Kc(nc[0],a);for(var c=1;c<nc.length;c++){var d=nc[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==oc&&Kc(oc,a);null!==pc&&Kc(pc,a);null!==qc&&Kc(qc,a);rc.forEach(b);sc.forEach(b);for(c=0;c<tc.length;c++)d=tc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<tc.length&&(c=tc[0],null===c.blockedOn);)Ec(c),null===c.blockedOn&&tc.shift()}
function Mc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Nc(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oc(a,b,c){if(b=Da(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a)}
function Pc(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Nc(b);for(b=c.length;0<b--;)Oc(c[b],"captured",a);for(b=0;b<c.length;b++)Oc(c[b],"bubbled",a)}}function Qc(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Da(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=xa(c._dispatchListeners,b),c._dispatchInstances=xa(c._dispatchInstances,a))}function Rc(a){a&&a.dispatchConfig.registrationName&&Qc(a._targetInst,null,a)}
function Sc(a){ya(a,Pc)}function Tc(){return!0}function Uc(){return!1}function E(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?Tc:Uc;this.isPropagationStopped=Uc;return this}
n(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=Tc)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=Tc)},persist:function(){this.isPersistent=Tc},isPersistent:Uc,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=Uc;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;Vc(c);return c};Vc(E);function Wc(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function Xc(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function Vc(a){a.eventPool=[];a.getPooled=Wc;a.release=Xc}var Yc=E.extend({animationName:null,elapsedTime:null,pseudoElement:null}),Zc=E.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),$c=E.extend({view:null,detail:null}),ad=$c.extend({relatedTarget:null});
function bd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var cd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},dd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ed={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function gd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=ed[a])?!!b[a]:!1}function hd(){return gd}
var id=$c.extend({key:function(a){if(a.key){var b=cd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=bd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?dd[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:hd,charCode:function(a){return"keypress"===a.type?bd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===
a.type?bd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),jd=0,kd=0,ld=!1,md=!1,nd=$c.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:hd,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=jd;jd=a.screenX;return ld?"mousemove"===a.type?a.screenX-
b:0:(ld=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;var b=kd;kd=a.screenY;return md?"mousemove"===a.type?a.screenY-b:0:(md=!0,0)}}),od=nd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),pd=nd.extend({dataTransfer:null}),qd=$c.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:hd}),rd=E.extend({propertyName:null,
elapsedTime:null,pseudoElement:null}),sd=nd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),td=[["blur","blur",0],["cancel","cancel",0],["click","click",0],["close","close",0],["contextmenu","contextMenu",0],["copy","copy",0],["cut","cut",0],["auxclick","auxClick",0],["dblclick","doubleClick",0],["dragend","dragEnd",
0],["dragstart","dragStart",0],["drop","drop",0],["focus","focus",0],["input","input",0],["invalid","invalid",0],["keydown","keyDown",0],["keypress","keyPress",0],["keyup","keyUp",0],["mousedown","mouseDown",0],["mouseup","mouseUp",0],["paste","paste",0],["pause","pause",0],["play","play",0],["pointercancel","pointerCancel",0],["pointerdown","pointerDown",0],["pointerup","pointerUp",0],["ratechange","rateChange",0],["reset","reset",0],["seeked","seeked",0],["submit","submit",0],["touchcancel","touchCancel",
0],["touchend","touchEnd",0],["touchstart","touchStart",0],["volumechange","volumeChange",0],["drag","drag",1],["dragenter","dragEnter",1],["dragexit","dragExit",1],["dragleave","dragLeave",1],["dragover","dragOver",1],["mousemove","mouseMove",1],["mouseout","mouseOut",1],["mouseover","mouseOver",1],["pointermove","pointerMove",1],["pointerout","pointerOut",1],["pointerover","pointerOver",1],["scroll","scroll",1],["toggle","toggle",1],["touchmove","touchMove",1],["wheel","wheel",1],["abort","abort",
2],[Zb,"animationEnd",2],[$b,"animationIteration",2],[ac,"animationStart",2],["canplay","canPlay",2],["canplaythrough","canPlayThrough",2],["durationchange","durationChange",2],["emptied","emptied",2],["encrypted","encrypted",2],["ended","ended",2],["error","error",2],["gotpointercapture","gotPointerCapture",2],["load","load",2],["loadeddata","loadedData",2],["loadedmetadata","loadedMetadata",2],["loadstart","loadStart",2],["lostpointercapture","lostPointerCapture",2],["playing","playing",2],["progress",
"progress",2],["seeking","seeking",2],["stalled","stalled",2],["suspend","suspend",2],["timeupdate","timeUpdate",2],[bc,"transitionEnd",2],["waiting","waiting",2]],ud={},vd={},wd=0;for(;wd<td.length;wd++){var yd=td[wd],zd=yd[0],Ad=yd[1],Bd=yd[2],Cd="on"+(Ad[0].toUpperCase()+Ad.slice(1)),Dd={phasedRegistrationNames:{bubbled:Cd,captured:Cd+"Capture"},dependencies:[zd],eventPriority:Bd};ud[Ad]=Dd;vd[zd]=Dd}
var Ed={eventTypes:ud,getEventPriority:function(a){a=vd[a];return void 0!==a?a.eventPriority:2},extractEvents:function(a,b,c,d){var e=vd[a];if(!e)return null;switch(a){case "keypress":if(0===bd(c))return null;case "keydown":case "keyup":a=id;break;case "blur":case "focus":a=ad;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=nd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
pd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=qd;break;case Zb:case $b:case ac:a=Yc;break;case bc:a=rd;break;case "scroll":a=$c;break;case "wheel":a=sd;break;case "copy":case "cut":case "paste":a=Zc;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=od;break;default:a=E}b=a.getPooled(e,b,c,d);Sc(b);return b}},Fd=q.unstable_UserBlockingPriority,
Gd=q.unstable_runWithPriority,Hd=Ed.getEventPriority,Id=10,Jd=[];
function Kd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=Fc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Mc(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=a.eventSystemFlags,h=null,k=0;k<ea.length;k++){var l=ea[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=xa(h,l))}Ba(h)}}
var Ld=!0;function F(a,b){Md(b,a,!1)}function Md(a,b,c){switch(Hd(b)){case 0:var d=Nd.bind(null,b,1);break;case 1:d=Od.bind(null,b,1);break;default:d=Pd.bind(null,b,1)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function Nd(a,b,c){ib||gb();var d=Pd,e=ib;ib=!0;try{fb(d,a,b,c)}finally{(ib=e)||kb()}}function Od(a,b,c){Gd(Fd,Pd.bind(null,a,b,c))}
function Qd(a,b,c,d){if(Jd.length){var e=Jd.pop();e.topLevelType=a;e.eventSystemFlags=b;e.nativeEvent=c;e.targetInst=d;a=e}else a={topLevelType:a,eventSystemFlags:b,nativeEvent:c,targetInst:d,ancestors:[]};try{if(b=Kd,c=a,jb)b(c,void 0);else{jb=!0;try{hb(b,c,void 0)}finally{jb=!1,kb()}}}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,Jd.length<Id&&Jd.push(a)}}
function Pd(a,b,c){if(Ld)if(0<nc.length&&-1<uc.indexOf(a))a=zc(null,a,b,c),nc.push(a);else{var d=Hc(a,b,c);null===d?Ac(a,c):-1<uc.indexOf(a)?(a=zc(d,a,b,c),nc.push(a)):Dc(d,a,b,c)||(Ac(a,c),Qd(a,b,c,null))}}function Hc(a,b,c){var d=Mc(c);d=Fc(d);if(null!==d){var e=ec(d);if(null===e)d=null;else{var f=e.tag;if(13===f){d=fc(e);if(null!==d)return d;d=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;d=null}else e!==d&&(d=null)}}Qd(a,b,c,d);return null}
function Rd(a){if(!Ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var Sd=new ("function"===typeof WeakMap?WeakMap:Map);function xc(a){var b=Sd.get(a);void 0===b&&(b=new Set,Sd.set(a,b));return b}
function yc(a,b,c){if(!c.has(a)){switch(a){case "scroll":Md(b,"scroll",!0);break;case "focus":case "blur":Md(b,"focus",!0);Md(b,"blur",!0);c.add("blur");c.add("focus");break;case "cancel":case "close":Rd(a)&&Md(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===cc.indexOf(a)&&F(a,b)}c.add(a)}}
var Td={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},Ud=["Webkit","ms","Moz","O"];Object.keys(Td).forEach(function(a){Ud.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);Td[b]=Td[a]})});function Vd(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||Td.hasOwnProperty(a)&&Td[a]?(""+b).trim():b+"px"}
function Wd(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=Vd(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var Xd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function Yd(a,b){if(b){if(Xd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function Zd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}function $d(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=xc(a);b=ja[b];for(var d=0;d<b.length;d++)yc(b[d],a,c)}function ae(){}
function be(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ce(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function de(a,b){var c=ce(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ce(c)}}
function ee(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?ee(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function fe(){for(var a=window,b=be();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=be(a.document)}return b}
function ge(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var he="$",ie="/$",je="$?",ke="$!",le=null,me=null;function ne(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function oe(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var pe="function"===typeof setTimeout?setTimeout:void 0,qe="function"===typeof clearTimeout?clearTimeout:void 0;function re(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function se(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===he||c===ke||c===je){if(0===b)return a;b--}else c===ie&&b++}a=a.previousSibling}return null}var te=Math.random().toString(36).slice(2),ue="__reactInternalInstance$"+te,ve="__reactEventHandlers$"+te,we="__reactContainere$"+te;
function Fc(a){var b=a[ue];if(b)return b;for(var c=a.parentNode;c;){if(b=c[we]||c[ue]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=se(a);null!==a;){if(c=a[ue])return c;a=se(a)}return b}a=c;c=a.parentNode}return null}function Cc(a){a=a[ue]||a[we];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function xe(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function ye(a){return a[ve]||null}var ze=null,Ae=null,Be=null;
function Ce(){if(Be)return Be;var a,b=Ae,c=b.length,d,e="value"in ze?ze.value:ze.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return Be=e.slice(a,1<d?1-d:void 0)}var De=E.extend({data:null}),Ee=E.extend({data:null}),Fe=[9,13,27,32],Ge=Ya&&"CompositionEvent"in window,He=null;Ya&&"documentMode"in document&&(He=document.documentMode);
var Ie=Ya&&"TextEvent"in window&&!He,Je=Ya&&(!Ge||He&&8<He&&11>=He),Ke=String.fromCharCode(32),Le={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},Me=!1;
function Ne(a,b){switch(a){case "keyup":return-1!==Fe.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function Oe(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var Pe=!1;function Qe(a,b){switch(a){case "compositionend":return Oe(b);case "keypress":if(32!==b.which)return null;Me=!0;return Ke;case "textInput":return a=b.data,a===Ke&&Me?null:a;default:return null}}
function Re(a,b){if(Pe)return"compositionend"===a||!Ge&&Ne(a,b)?(a=Ce(),Be=Ae=ze=null,Pe=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return Je&&"ko"!==b.locale?null:b.data;default:return null}}
var Se={eventTypes:Le,extractEvents:function(a,b,c,d){var e;if(Ge)b:{switch(a){case "compositionstart":var f=Le.compositionStart;break b;case "compositionend":f=Le.compositionEnd;break b;case "compositionupdate":f=Le.compositionUpdate;break b}f=void 0}else Pe?Ne(a,c)&&(f=Le.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=Le.compositionStart);f?(Je&&"ko"!==c.locale&&(Pe||f!==Le.compositionStart?f===Le.compositionEnd&&Pe&&(e=Ce()):(ze=d,Ae="value"in ze?ze.value:ze.textContent,Pe=!0)),f=De.getPooled(f,
b,c,d),e?f.data=e:(e=Oe(c),null!==e&&(f.data=e)),Sc(f),e=f):e=null;(a=Ie?Qe(a,c):Re(a,c))?(b=Ee.getPooled(Le.beforeInput,b,c,d),b.data=a,Sc(b)):b=null;return null===e?b:null===b?e:[e,b]}},Te={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Ue(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Te[a.type]:"textarea"===b?!0:!1}
var Ve={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function We(a,b,c){a=E.getPooled(Ve.change,a,b,c);a.type="change";cb(c);Sc(a);return a}var Xe=null,Ye=null;function Ze(a){Ba(a)}function $e(a){var b=xe(a);if(zb(b))return a}function af(a,b){if("change"===a)return b}var bf=!1;Ya&&(bf=Rd("input")&&(!document.documentMode||9<document.documentMode));
function cf(){Xe&&(Xe.detachEvent("onpropertychange",df),Ye=Xe=null)}function df(a){if("value"===a.propertyName&&$e(Ye))if(a=We(Ye,a,Mc(a)),ib)Ba(a);else{ib=!0;try{eb(Ze,a)}finally{ib=!1,kb()}}}function ef(a,b,c){"focus"===a?(cf(),Xe=b,Ye=c,Xe.attachEvent("onpropertychange",df)):"blur"===a&&cf()}function ff(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return $e(Ye)}function gf(a,b){if("click"===a)return $e(b)}function hf(a,b){if("input"===a||"change"===a)return $e(b)}
var jf={eventTypes:Ve,_isInputEventSupported:bf,extractEvents:function(a,b,c,d){var e=b?xe(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=af;else if(Ue(e))if(bf)g=hf;else{g=ff;var h=ef}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=gf);if(g&&(g=g(a,b)))return We(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Fb(e,"number",e.value)}},kf={mouseEnter:{registrationName:"onMouseEnter",
dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",dependencies:["pointerout","pointerover"]}},lf,mf={eventTypes:kf,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;
e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?Fc(b):null,null!==b&&(f=ec(b),b!==f||5!==b.tag&&6!==b.tag))b=null}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===a){var h=nd;var k=kf.mouseLeave;var l=kf.mouseEnter;var m="mouse"}else if("pointerout"===a||"pointerover"===a)h=od,k=kf.pointerLeave,l=kf.pointerEnter,m="pointer";a=null==g?e:xe(g);e=null==b?e:xe(b);k=h.getPooled(k,g,c,d);k.type=m+"leave";k.target=
a;k.relatedTarget=e;d=h.getPooled(l,b,c,d);d.type=m+"enter";d.target=e;d.relatedTarget=a;h=g;m=b;if(h&&m)a:{l=h;a=m;g=0;for(b=l;b;b=Nc(b))g++;b=0;for(e=a;e;e=Nc(e))b++;for(;0<g-b;)l=Nc(l),g--;for(;0<b-g;)a=Nc(a),b--;for(;g--;){if(l===a||l===a.alternate)break a;l=Nc(l);a=Nc(a)}l=null}else l=null;a=l;for(l=[];h&&h!==a;){g=h.alternate;if(null!==g&&g===a)break;l.push(h);h=Nc(h)}for(h=[];m&&m!==a;){g=m.alternate;if(null!==g&&g===a)break;h.push(m);m=Nc(m)}for(m=0;m<l.length;m++)Qc(l[m],"bubbled",k);for(m=
h.length;0<m--;)Qc(h[m],"captured",d);if(c===lf)return lf=null,[k];lf=c;return[k,d]}};function nf(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var of="function"===typeof Object.is?Object.is:nf,pf=Object.prototype.hasOwnProperty;function qf(a,b){if(of(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!pf.call(b,c[d])||!of(a[c[d]],b[c[d]]))return!1;return!0}
var rf=Ya&&"documentMode"in document&&11>=document.documentMode,sf={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},tf=null,uf=null,vf=null,wf=!1;
function xf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(wf||null==tf||tf!==be(c))return null;c=tf;"selectionStart"in c&&ge(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return vf&&qf(vf,c)?null:(vf=c,a=E.getPooled(sf.select,uf,a,b),a.type="select",a.target=tf,Sc(a),a)}
var yf={eventTypes:sf,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=xc(e);f=ja.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?xe(b):window;switch(a){case "focus":if(Ue(e)||"true"===e.contentEditable)tf=e,uf=b,vf=null;break;case "blur":vf=uf=tf=null;break;case "mousedown":wf=!0;break;case "contextmenu":case "mouseup":case "dragend":return wf=!1,xf(c,d);case "selectionchange":if(rf)break;
case "keydown":case "keyup":return xf(c,d)}return null}};Ca.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));var zf=Cc;sa=ye;ua=zf;va=xe;Ca.injectEventPluginsByName({SimpleEventPlugin:Ed,EnterLeaveEventPlugin:mf,ChangeEventPlugin:jf,SelectEventPlugin:yf,BeforeInputEventPlugin:Se});new Set;var Af=[],Bf=-1;function G(a){0>Bf||(a.current=Af[Bf],Af[Bf]=null,Bf--)}
function I(a,b){Bf++;Af[Bf]=a.current;a.current=b}var Cf={},J={current:Cf},K={current:!1},Df=Cf;function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Ff(a){G(K,a);G(J,a)}function Gf(a){G(K,a);G(J,a)}function Hf(a,b,c){if(J.current!==Cf)throw Error(u(168));I(J,b,a);I(K,c,a)}function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,Wa(b)||"Unknown",e));return n({},c,{},d)}function Jf(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Cf;Df=J.current;I(J,b,a);I(K,K.current,a);return!0}
function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(b=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=b,G(K,a),G(J,a),I(J,b,a)):G(K,a);I(K,c,a)}
var Lf=q.unstable_runWithPriority,Mf=q.unstable_scheduleCallback,Nf=q.unstable_cancelCallback,Of=q.unstable_shouldYield,Pf=q.unstable_requestPaint,Qf=q.unstable_now,Rf=q.unstable_getCurrentPriorityLevel,Sf=q.unstable_ImmediatePriority,Tf=q.unstable_UserBlockingPriority,Uf=q.unstable_NormalPriority,Vf=q.unstable_LowPriority,Wf=q.unstable_IdlePriority,Xf={},Yf=void 0!==Pf?Pf:function(){},Zf=null,$f=null,ag=!1,bg=Qf(),cg=1E4>bg?Qf:function(){return Qf()-bg};
function dg(){switch(Rf()){case Sf:return 99;case Tf:return 98;case Uf:return 97;case Vf:return 96;case Wf:return 95;default:throw Error(u(332));}}function eg(a){switch(a){case 99:return Sf;case 98:return Tf;case 97:return Uf;case 96:return Vf;case 95:return Wf;default:throw Error(u(332));}}function fg(a,b){a=eg(a);return Lf(a,b)}function gg(a,b,c){a=eg(a);return Mf(a,b,c)}function hg(a){null===Zf?(Zf=[a],$f=Mf(Sf,ig)):Zf.push(a);return Xf}function jg(){if(null!==$f){var a=$f;$f=null;Nf(a)}ig()}
function ig(){if(!ag&&null!==Zf){ag=!0;var a=0;try{var b=Zf;fg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Zf=null}catch(c){throw null!==Zf&&(Zf=Zf.slice(a+1)),Mf(Sf,jg),c;}finally{ag=!1}}}var kg=3;function lg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function mg(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var ng={current:null},og=null,pg=null,qg=null;function rg(){qg=pg=og=null}
function sg(a,b){var c=a.type._context;I(ng,c._currentValue,a);c._currentValue=b}function tg(a){var b=ng.current;G(ng,a);a.type._context._currentValue=b}function ug(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}
function vg(a,b){og=a;qg=pg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(wg=!0),a.firstContext=null)}function xg(a,b){if(qg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)qg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===pg){if(null===og)throw Error(u(308));pg=b;og.dependencies={expirationTime:0,firstContext:b,responders:null}}else pg=pg.next=b}return a._currentValue}var yg=!1;
function zg(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function Ag(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
function Bg(a,b){return{expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null,nextEffect:null}}function Cg(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
function Dg(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=zg(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=zg(a.memoizedState),e=c.updateQueue=zg(c.memoizedState)):d=a.updateQueue=Ag(e):null===e&&(e=c.updateQueue=Ag(d));null===e||d===e?Cg(d,b):null===d.lastUpdate||null===e.lastUpdate?(Cg(d,b),Cg(e,b)):(Cg(d,b),e.lastUpdate=b)}
function Eg(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=zg(a.memoizedState):Fg(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function Fg(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=Ag(b));return b}
function Gg(a,b,c,d,e,f){switch(c.tag){case 1:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case 3:a.effectTag=a.effectTag&-4097|64;case 0:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return n({},d,e);case 2:yg=!0}return d}
function Hg(a,b,c,d,e){yg=!1;b=Fg(a,b);for(var f=b.baseState,g=null,h=0,k=b.firstUpdate,l=f;null!==k;){var m=k.expirationTime;m<e?(null===g&&(g=k,f=l),h<m&&(h=m)):(Ig(m,k.suspenseConfig),l=Gg(a,b,k,l,c,d),null!==k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=k:(b.lastEffect.nextEffect=k,b.lastEffect=k)));k=k.next}m=null;for(k=b.firstCapturedUpdate;null!==k;){var C=k.expirationTime;C<e?(null===m&&(m=k,null===g&&(f=l)),h<C&&(h=C)):(l=Gg(a,b,k,l,c,d),null!==
k.callback&&(a.effectTag|=32,k.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=k:(b.lastCapturedEffect.nextEffect=k,b.lastCapturedEffect=k)));k=k.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=l);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;Jg(h);a.expirationTime=h;a.memoizedState=l}
function Kg(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);Lg(b.firstEffect,c);b.firstEffect=b.lastEffect=null;Lg(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function Lg(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;if("function"!==typeof c)throw Error(u(191,c));c.call(d)}a=a.nextEffect}}
var Mg=Ea.ReactCurrentBatchConfig,Ng=(new aa.Component).refs;function Og(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
var Sg={isMounted:function(a){return(a=a._reactInternalFiber)?ec(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Pg(),e=Mg.suspense;d=Qg(d,a,e);e=Bg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);Dg(a,e);Rg(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Pg(),d=Mg.suspense;
c=Qg(c,a,d);d=Bg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);Dg(a,d);Rg(a,c)}};function Tg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!qf(c,d)||!qf(e,f):!0}
function Ug(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=xg(f):(e=L(b)?Df:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Sg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Vg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Sg.enqueueReplaceState(b,b.state,null)}
function Wg(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Ng;var f=b.contextType;"object"===typeof f&&null!==f?e.context=xg(f):(f=L(b)?Df:J.current,e.context=Ef(a,f));f=a.updateQueue;null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(Og(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Sg.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Hg(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Xg=Array.isArray;
function Yg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Ng&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Zg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function $g(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=ah(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=bh(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Yg(a,b,c),d.return=a,d;d=ch(c.type,c.key,c.props,null,a.mode,d);d.ref=Yg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=dh(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=eh(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function C(a,b,c){if("string"===typeof b||"number"===typeof b)return b=bh(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Ga:return c=ch(b.type,b.key,b.props,null,a.mode,c),c.ref=Yg(a,null,b),c.return=a,c;case Ha:return b=dh(b,a.mode,c),b.return=a,b}if(Xg(b)||
Ua(b))return b=eh(b,a.mode,c,null),b.return=a,b;Zg(a,b)}return null}function y(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Ga:return c.key===e?c.type===Ia?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case Ha:return c.key===e?l(a,b,c,d):null}if(Xg(c)||Ua(c))return null!==e?null:m(a,b,c,d,null);Zg(a,c)}return null}function H(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Ga:return a=a.get(null===d.key?c:d.key)||null,d.type===Ia?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case Ha:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Xg(d)||Ua(d))return a=a.get(c)||null,m(b,a,d,e,null);Zg(b,d)}return null}function z(e,g,h,k){for(var l=null,m=null,r=g,x=g=0,A=null;null!==r&&x<h.length;x++){r.index>x?(A=r,r=null):A=r.sibling;var p=y(e,r,h[x],k);if(null===p){null===r&&(r=A);break}a&&
r&&null===p.alternate&&b(e,r);g=f(p,g,x);null===m?l=p:m.sibling=p;m=p;r=A}if(x===h.length)return c(e,r),l;if(null===r){for(;x<h.length;x++)r=C(e,h[x],k),null!==r&&(g=f(r,g,x),null===m?l=r:m.sibling=r,m=r);return l}for(r=d(e,r);x<h.length;x++)A=H(r,e,x,h[x],k),null!==A&&(a&&null!==A.alternate&&r.delete(null===A.key?x:A.key),g=f(A,g,x),null===m?l=A:m.sibling=A,m=A);a&&r.forEach(function(a){return b(e,a)});return l}function ta(e,g,h,k){var l=Ua(h);if("function"!==typeof l)throw Error(u(150));h=l.call(h);
if(null==h)throw Error(u(151));for(var m=l=null,r=g,x=g=0,A=null,p=h.next();null!==r&&!p.done;x++,p=h.next()){r.index>x?(A=r,r=null):A=r.sibling;var z=y(e,r,p.value,k);if(null===z){null===r&&(r=A);break}a&&r&&null===z.alternate&&b(e,r);g=f(z,g,x);null===m?l=z:m.sibling=z;m=z;r=A}if(p.done)return c(e,r),l;if(null===r){for(;!p.done;x++,p=h.next())p=C(e,p.value,k),null!==p&&(g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);return l}for(r=d(e,r);!p.done;x++,p=h.next())p=H(r,e,x,p.value,k),null!==p&&(a&&null!==
p.alternate&&r.delete(null===p.key?x:p.key),g=f(p,g,x),null===m?l=p:m.sibling=p,m=p);a&&r.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===Ia&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Ga:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===Ia:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===Ia?f.props.children:f.props,h);d.ref=Yg(a,k,f);d.return=a;a=d;break a}else{c(a,
k);break}else b(a,k);k=k.sibling}f.type===Ia?(d=eh(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=ch(f.type,f.key,f.props,null,a.mode,h),h.ref=Yg(a,d,f),h.return=a,a=h)}return g(a);case Ha:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=dh(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===
typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=bh(f,a.mode,h),d.return=a,a=d),g(a);if(Xg(f))return z(a,d,f,h);if(Ua(f))return ta(a,d,f,h);l&&Zg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var fh=$g(!0),gh=$g(!1),hh={},ih={current:hh},jh={current:hh},kh={current:hh};function lh(a){if(a===hh)throw Error(u(174));return a}
function mh(a,b){I(kh,b,a);I(jh,a,a);I(ih,hh,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Qb(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=Qb(b,c)}G(ih,a);I(ih,b,a)}function nh(a){G(ih,a);G(jh,a);G(kh,a)}function oh(a){lh(kh.current);var b=lh(ih.current);var c=Qb(b,a.type);b!==c&&(I(jh,a,a),I(ih,c,a))}function ph(a){jh.current===a&&(G(ih,a),G(jh,a))}var M={current:0};
function qh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===je||c.data===ke))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function rh(a,b){return{responder:a,props:b}}
var sh=Ea.ReactCurrentDispatcher,N=Ea.ReactCurrentBatchConfig,th=0,uh=null,O=null,vh=null,wh=null,P=null,xh=null,yh=0,zh=null,Ah=0,Bh=!1,Ch=null,Gh=0;function Q(){throw Error(u(321));}function Hh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!of(a[c],b[c]))return!1;return!0}
function Ih(a,b,c,d,e,f){th=f;uh=b;vh=null!==a?a.memoizedState:null;sh.current=null===vh?Jh:Kh;b=c(d,e);if(Bh){do Bh=!1,Gh+=1,vh=null!==a?a.memoizedState:null,xh=wh,zh=P=O=null,sh.current=Kh,b=c(d,e);while(Bh);Ch=null;Gh=0}sh.current=Lh;a=uh;a.memoizedState=wh;a.expirationTime=yh;a.updateQueue=zh;a.effectTag|=Ah;a=null!==O&&null!==O.next;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;if(a)throw Error(u(300));return b}
function Mh(){sh.current=Lh;th=0;xh=P=wh=vh=O=uh=null;yh=0;zh=null;Ah=0;Bh=!1;Ch=null;Gh=0}function Nh(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===P?wh=P=a:P=P.next=a;return P}function Oh(){if(null!==xh)P=xh,xh=P.next,O=vh,vh=null!==O?O.next:null;else{if(null===vh)throw Error(u(310));O=vh;var a={memoizedState:O.memoizedState,baseState:O.baseState,queue:O.queue,baseUpdate:O.baseUpdate,next:null};P=null===P?wh=a:P.next=a;vh=O.next}return P}
function Ph(a,b){return"function"===typeof b?b(a):b}
function Qh(a){var b=Oh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;if(0<Gh){var d=c.dispatch;if(null!==Ch){var e=Ch.get(c);if(void 0!==e){Ch.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);c.lastRenderedState=f;return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==
d){var h=e=null,k=d,l=!1;do{var m=k.expirationTime;m<th?(l||(l=!0,h=g,e=f),m>yh&&(yh=m,Jg(yh))):(Ig(m,k.suspenseConfig),f=k.eagerReducer===a?k.eagerState:a(f,k.action));g=k;k=k.next}while(null!==k&&k!==d);l||(h=g,e=f);of(f,b.memoizedState)||(wg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.lastRenderedState=f}return[b.memoizedState,c.dispatch]}
function Rh(a){var b=Nh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,lastRenderedReducer:Ph,lastRenderedState:a};a=a.dispatch=Sh.bind(null,uh,a);return[b.memoizedState,a]}function Th(a){return Qh(Ph,a)}function Uh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===zh?(zh={lastEffect:null},zh.lastEffect=a.next=a):(b=zh.lastEffect,null===b?zh.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,zh.lastEffect=a));return a}
function Vh(a,b,c,d){var e=Nh();Ah|=a;e.memoizedState=Uh(b,c,void 0,void 0===d?null:d)}function Wh(a,b,c,d){var e=Oh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&Hh(d,g.deps)){Uh(0,c,f,d);return}}Ah|=a;e.memoizedState=Uh(b,c,f,d)}function Xh(a,b){return Vh(516,192,a,b)}function Yh(a,b){return Wh(516,192,a,b)}
function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function $h(){}function ai(a,b){Nh().memoizedState=[a,void 0===b?null:b];return a}function bi(a,b){var c=Oh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Sh(a,b,c){if(!(25>Gh))throw Error(u(301));var d=a.alternate;if(a===uh||null!==d&&d===uh)if(Bh=!0,a={expirationTime:th,suspenseConfig:null,action:c,eagerReducer:null,eagerState:null,next:null},null===Ch&&(Ch=new Map),c=Ch.get(b),void 0===c)Ch.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{var e=Pg(),f=Mg.suspense;e=Qg(e,a,f);f={expirationTime:e,suspenseConfig:f,action:c,eagerReducer:null,eagerState:null,next:null};var g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&
(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===d||0===d.expirationTime)&&(d=b.lastRenderedReducer,null!==d))try{var k=b.lastRenderedState,l=d(k,c);f.eagerReducer=d;f.eagerState=l;if(of(l,k))return}catch(m){}finally{}Rg(a,e)}}
var Lh={readContext:xg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},Jh={readContext:xg,useCallback:ai,useContext:xg,useEffect:Xh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Vh(4,36,a,b)},useMemo:function(a,b){var c=Nh();b=void 0===b?null:b;a=a();c.memoizedState=
[a,b];return a},useReducer:function(a,b,c){var d=Nh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Sh.bind(null,uh,a);return[d.memoizedState,a]},useRef:function(a){var b=Nh();a={current:a};return b.memoizedState=a},useState:Rh,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Rh(a),d=c[0],e=c[1];Xh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=
c}})},[a,b]);return d},useTransition:function(a){var b=Rh(!1),c=b[0],d=b[1];return[ai(function(b){d(!0);q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},Kh={readContext:xg,useCallback:bi,useContext:xg,useEffect:Yh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Wh(4,36,Zh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Wh(4,36,a,b)},useMemo:function(a,b){var c=Oh();b=void 0===b?
null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Hh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:Qh,useRef:function(){return Oh().memoizedState},useState:Th,useDebugValue:$h,useResponder:rh,useDeferredValue:function(a,b){var c=Th(a),d=c[0],e=c[1];Yh(function(){q.unstable_next(function(){var c=N.suspense;N.suspense=void 0===b?null:b;try{e(a)}finally{N.suspense=c}})},[a,b]);return d},useTransition:function(a){var b=Th(!1),c=b[0],d=b[1];return[bi(function(b){d(!0);q.unstable_next(function(){var c=
N.suspense;N.suspense=void 0===a?null:a;try{d(!1),b()}finally{N.suspense=c}})},[a,c]),c]}},ci=null,di=null,ei=!1;function fi(a,b){var c=gi(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function hi(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function ii(a){if(ei){var b=di;if(b){var c=b;if(!hi(a,b)){b=re(c.nextSibling);if(!b||!hi(a,b)){a.effectTag=a.effectTag&-1025|2;ei=!1;ci=a;return}fi(ci,c)}ci=a;di=re(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,ei=!1,ci=a}}function ji(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;ci=a}
function ki(a){if(a!==ci)return!1;if(!ei)return ji(a),ei=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!oe(b,a.memoizedProps))for(b=di;b;)fi(a,b),b=re(b.nextSibling);ji(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===ie){if(0===b){di=re(a.nextSibling);break a}b--}else c!==he&&c!==ke&&c!==je||b++}a=a.nextSibling}di=null}}else di=ci?re(a.stateNode.nextSibling):null;return!0}
function li(){di=ci=null;ei=!1}var mi=Ea.ReactCurrentOwner,wg=!1;function R(a,b,c,d){b.child=null===a?gh(b,null,c,d):fh(b,a.child,c,d)}function ni(a,b,c,d,e){c=c.render;var f=b.ref;vg(b,e);d=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function pi(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!qi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ri(a,b,g,d,e,f);a=ch(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:qf,c(e,d)&&a.ref===b.ref))return oi(a,b,f);b.effectTag|=1;a=ah(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
function ri(a,b,c,d,e,f){return null!==a&&qf(a.memoizedProps,d)&&a.ref===b.ref&&(wg=!1,e<f)?oi(a,b,f):si(a,b,c,d,f)}function ti(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function si(a,b,c,d,e){var f=L(c)?Df:J.current;f=Ef(b,f);vg(b,e);c=Ih(a,b,c,d,f,e);if(null!==a&&!wg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),oi(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function ui(a,b,c,d,e){if(L(c)){var f=!0;Jf(b)}else f=!1;vg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Ug(b,c,d,e),Wg(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l));var m=c.getDerivedStateFromProps,C="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;C||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l);yg=!1;var y=b.memoizedState;k=g.state=y;var H=b.updateQueue;null!==H&&(Hg(b,H,d,g,e),k=b.memoizedState);h!==d||y!==k||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),k=b.memoizedState),(h=yg||Tg(b,c,h,d,y,k,l))?(C||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:mg(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=xg(l):(l=L(c)?Df:J.current,l=Ef(b,l)),m=c.getDerivedStateFromProps,(C=
"function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Vg(b,g,d,l),yg=!1,k=b.memoizedState,y=g.state=k,H=b.updateQueue,null!==H&&(Hg(b,H,d,g,e),y=b.memoizedState),h!==d||k!==y||K.current||yg?("function"===typeof m&&(Og(b,c,m,d),y=b.memoizedState),(m=yg||Tg(b,c,h,d,k,y,l))?(C||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||
("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,y,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,y,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=
d,b.memoizedState=y),g.props=d,g.state=y,g.context=l,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return vi(a,b,c,d,f,e)}
function vi(a,b,c,d,e,f){ti(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Kf(b,c,!1),oi(a,b,f);d=b.stateNode;mi.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=fh(b,a.child,null,f),b.child=fh(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function wi(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);mh(a,b.containerInfo)}
var xi={dehydrated:null,retryTime:0};
function yi(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1,b);if(null===a){void 0!==e.fallback&&ii(b);if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=xi;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=gh(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=ah(a,a.pendingProps,0);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=ah(d,e,d.expirationTime);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=xi;b.child=c;return d}c=fh(b,a.child,e.children,c);b.memoizedState=
null;return b.child=c}a=a.child;if(g){g=e.fallback;e=eh(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=eh(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=xi;b.child=e;return c}b.memoizedState=null;return b.child=fh(b,a,e.children,c)}
function zi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);ug(a.return,b)}function Ai(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function Bi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&zi(a,c);else if(19===a.tag)zi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d,b);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===qh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);Ai(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===qh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}Ai(b,!0,c,null,f,b.lastEffect);break;case "together":Ai(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function oi(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Jg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=ah(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=ah(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}function Ci(a){a.effectTag|=4}var Hi,Ii,Ji,Ki;
Hi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};Ii=function(){};
Ji=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;lh(ih.current);a=null;switch(c){case "input":f=Ab(g,f);d=Ab(g,d);a=[];break;case "option":f=Ib(g,f);d=Ib(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Kb(g,f);d=Kb(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=ae)}Yd(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,""+l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(ia.hasOwnProperty(h)?(null!=l&&$d(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;(b.updateQueue=e)&&Ci(b)}};Ki=function(a,b,c,d){c!==d&&Ci(b)};
function Li(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function Mi(a){switch(a.tag){case 1:L(a.type)&&Ff(a);var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:nh(a);Gf(a);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return ph(a),null;case 13:return G(M,a),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return G(M,a),null;case 4:return nh(a),null;case 10:return tg(a),null;default:return null}}function Ni(a,b){return{value:a,source:b,stack:Xa(b)}}
var Oi="function"===typeof WeakSet?WeakSet:Set;function Pi(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=Xa(c));null!==c&&Wa(c.type);b=b.value;null!==a&&1===a.tag&&Wa(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Qi(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ri(a,c)}}function Si(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ri(a,c)}else b.current=null}
function Ti(a,b){switch(b.tag){case 0:case 11:case 15:Ui(2,0,b);break;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:mg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}break;case 3:case 5:case 6:case 4:case 17:break;default:throw Error(u(163));}}
function Ui(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if(0!==(d.tag&a)){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}0!==(d.tag&b)&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
function Vi(a,b,c){"function"===typeof Wi&&Wi(b);switch(b.tag){case 0:case 11:case 14:case 15:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;fg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ri(g,h)}}a=a.next}while(a!==d)})}break;case 1:Si(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Qi(b,c);break;case 5:Si(b);break;case 4:Xi(a,b,c)}}
function Yi(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;null!==b&&Yi(b)}function Zi(a){return 5===a.tag||3===a.tag||4===a.tag}
function $i(a){a:{for(var b=a.return;null!==b;){if(Zi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Tb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Zi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){var f=5===e.tag||6===e.tag;if(f){var g=f?e.stateNode:e.stateNode.instance;if(c)if(d){f=b;var h=g;g=c;8===f.nodeType?f.parentNode.insertBefore(h,g):f.insertBefore(h,g)}else b.insertBefore(g,c);else d?(h=b,8===h.nodeType?(f=h.parentNode,f.insertBefore(g,h)):(f=h,f.appendChild(g)),h=h._reactRootContainer,null!==h&&void 0!==h||null!==f.onclick||(f.onclick=ae)):b.appendChild(g)}else if(4!==
e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
function Xi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Vi(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Vi(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function aj(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Ui(4,8,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[ve]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Cb(c,d);Zd(a,e);b=Zd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?Wd(c,h):"dangerouslySetInnerHTML"===g?Sb(c,h):"children"===g?Tb(c,h):vb(c,g,h,b)}switch(a){case "input":Eb(c,d);break;case "textarea":Mb(c,
d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Jb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Jb(c,!!d.multiple,d.defaultValue,!0):Jb(c,!!d.multiple,d.multiple?[]:"",!1))}}}break;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;break;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Lc(b.containerInfo));break;case 12:break;case 13:c=b;null===b.memoizedState?d=!1:(d=!0,c=b.child,bj=cg());
if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=Vd("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=f;continue}else if(null!==a.child){a.child.return=
a;a=a.child;continue}if(a===c)break a;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}cj(b);break;case 19:cj(b);break;case 17:break;case 20:break;case 21:break;default:throw Error(u(163));}}function cj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Oi);b.forEach(function(b){var d=dj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}var ej="function"===typeof WeakMap?WeakMap:Map;
function fj(a,b,c){c=Bg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){gj||(gj=!0,hj=d);Pi(a,b)};return c}
function ij(a,b,c){c=Bg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Pi(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===jj?jj=new Set([this]):jj.add(this),Pi(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var kj=Math.ceil,lj=Ea.ReactCurrentDispatcher,mj=Ea.ReactCurrentOwner,S=0,nj=8,oj=16,pj=32,qj=0,rj=1,sj=2,tj=3,uj=4,vj=5,T=S,U=null,V=null,W=0,X=qj,wj=null,xj=1073741823,yj=1073741823,zj=null,Aj=0,Bj=!1,bj=0,Cj=500,Y=null,gj=!1,hj=null,jj=null,Dj=!1,Ej=null,Fj=90,Gj=null,Hj=0,Ij=null,Jj=0;function Pg(){return(T&(oj|pj))!==S?1073741821-(cg()/10|0):0!==Jj?Jj:Jj=1073741821-(cg()/10|0)}
function Qg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=dg();if(0===(b&4))return 99===d?1073741823:1073741822;if((T&oj)!==S)return W;if(null!==c)a=lg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=lg(a,150,100);break;case 97:case 96:a=lg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==U&&a===W&&--a;return a}
function Rg(a,b){if(50<Hj)throw Hj=0,Ij=null,Error(u(185));a=Kj(a,b);if(null!==a){var c=dg();1073741823===b?(T&nj)!==S&&(T&(oj|pj))===S?Lj(a):(Z(a),T===S&&jg()):Z(a);(T&4)===S||98!==c&&99!==c||(null===Gj?Gj=new Map([[a,b]]):(c=Gj.get(a),(void 0===c||c>b)&&Gj.set(a,b)))}}
function Kj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(U===e&&(Jg(b),X===uj&&Mj(e,W)),Nj(e,b));return e}
function Oj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Pj(a,b))return b;b=a.lastPingedTime;a=a.nextKnownPendingLevel;return b>a?b:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=hg(Lj.bind(null,a));else{var b=Oj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Pg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Xf&&Nf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?hg(Lj.bind(null,a)):gg(d,Qj.bind(null,a),{timeout:10*(1073741821-b)-cg()});a.callbackNode=b}}}
function Qj(a,b){Jj=0;if(b)return b=Pg(),Rj(a,b),Z(a),null;var c=Oj(a);if(0!==c){b=a.callbackNode;if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&c===W||Tj(a,c);if(null!==V){var d=T;T|=oj;var e=Uj(a);do try{Vj();break}catch(h){Wj(a,h)}while(1);rg();T=d;lj.current=e;if(X===rj)throw b=wj,Tj(a,c),Mj(a,c),Z(a),b;if(null===V)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=X,U=null,d){case qj:case rj:throw Error(u(345));case sj:Rj(a,2<c?2:c);break;case tj:Mj(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Xj(e));if(1073741823===xj&&(e=bj+Cj-cg(),10<e)){if(Bj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Tj(a,c);break}}f=Oj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=pe(Yj.bind(null,a),e);break}Yj(a);break;case uj:Mj(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Xj(e));if(Bj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Tj(a,c);break}e=Oj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==yj?d=10*(1073741821-yj)-cg():1073741823===xj?d=0:(d=10*(1073741821-xj)-5E3,e=cg(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*kj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=pe(Yj.bind(null,a),d);break}Yj(a);break;case vj:if(1073741823!==xj&&null!==zj){f=xj;var g=zj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=cg()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){Mj(a,c);a.timeoutHandle=
pe(Yj.bind(null,a),d);break}}Yj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Qj.bind(null,a)}}return null}
function Lj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if(a.finishedExpirationTime===b)Yj(a);else{if((T&(oj|pj))!==S)throw Error(u(327));Sj();a===U&&b===W||Tj(a,b);if(null!==V){var c=T;T|=oj;var d=Uj(a);do try{Zj();break}catch(e){Wj(a,e)}while(1);rg();T=c;lj.current=d;if(X===rj)throw c=wj,Tj(a,b),Mj(a,b),Z(a),c;if(null!==V)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;U=null;Yj(a);Z(a)}}return null}
function ak(){if(null!==Gj){var a=Gj;Gj=null;a.forEach(function(a,c){Rj(c,a);Z(c)});jg()}}function bk(a,b){var c=T;T|=1;try{return a(b)}finally{T=c,T===S&&jg()}}function ck(a,b){var c=T;T&=-2;T|=nj;try{return a(b)}finally{T=c,T===S&&jg()}}
function Tj(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,qe(c));if(null!==V)for(c=V.return;null!==c;){var d=c;switch(d.tag){case 1:var e=d.type.childContextTypes;null!==e&&void 0!==e&&Ff(d);break;case 3:nh(d);Gf(d);break;case 5:ph(d);break;case 4:nh(d);break;case 13:G(M,d);break;case 19:G(M,d);break;case 10:tg(d)}c=c.return}U=a;V=ah(a.current,null,b);W=b;X=qj;wj=null;yj=xj=1073741823;zj=null;Aj=0;Bj=!1}
function Wj(a,b){do{try{rg();Mh();if(null===V||null===V.return)return X=rj,wj=b,null;a:{var c=a,d=V.return,e=V,f=b;b=W;e.effectTag|=2048;e.firstEffect=e.lastEffect=null;if(null!==f&&"object"===typeof f&&"function"===typeof f.then){var g=f,h=0!==(M.current&1),k=d;do{var l;if(l=13===k.tag){var m=k.memoizedState;if(null!==m)l=null!==m.dehydrated?!0:!1;else{var C=k.memoizedProps;l=void 0===C.fallback?!1:!0!==C.unstable_avoidThisFallback?!0:h?!1:!0}}if(l){var y=k.updateQueue;if(null===y){var H=new Set;
H.add(g);k.updateQueue=H}else y.add(g);if(0===(k.mode&2)){k.effectTag|=64;e.effectTag&=-2981;if(1===e.tag)if(null===e.alternate)e.tag=17;else{var z=Bg(1073741823,null);z.tag=2;Dg(e,z)}e.expirationTime=1073741823;break a}f=void 0;e=b;var ta=c.pingCache;null===ta?(ta=c.pingCache=new ej,f=new Set,ta.set(g,f)):(f=ta.get(g),void 0===f&&(f=new Set,ta.set(g,f)));if(!f.has(e)){f.add(e);var r=dk.bind(null,c,g,e);g.then(r,r)}k.effectTag|=4096;k.expirationTime=b;break a}k=k.return}while(null!==k);f=Error((Wa(e.type)||
"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+Xa(e))}X!==vj&&(X=sj);f=Ni(f,e);k=d;do{switch(k.tag){case 3:g=f;k.effectTag|=4096;k.expirationTime=b;var x=fj(k,g,b);Eg(k,x);break a;case 1:g=f;var A=k.type,p=k.stateNode;if(0===(k.effectTag&64)&&("function"===typeof A.getDerivedStateFromError||null!==p&&"function"===typeof p.componentDidCatch&&
(null===jj||!jj.has(p)))){k.effectTag|=4096;k.expirationTime=b;var t=ij(k,g,b);Eg(k,t);break a}}k=k.return}while(null!==k)}V=ek(V)}catch(v){b=v;continue}break}while(1)}function Uj(){var a=lj.current;lj.current=Lh;return null===a?Lh:a}function Ig(a,b){a<xj&&2<a&&(xj=a);null!==b&&a<yj&&2<a&&(yj=a,zj=b)}function Jg(a){a>Aj&&(Aj=a)}function Zj(){for(;null!==V;)V=fk(V)}function Vj(){for(;null!==V&&!Of();)V=fk(V)}
function fk(a){var b=gk(a.alternate,a,W);a.memoizedProps=a.pendingProps;null===b&&(b=ek(a));mj.current=null;return b}
function ek(a){V=a;do{var b=V.alternate;a=V.return;if(0===(V.effectTag&2048)){a:{var c=b;b=V;var d=W;var e=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:L(b.type)&&Ff(b);break;case 3:nh(b);Gf(b);e=b.stateNode;e.pendingContext&&(e.context=e.pendingContext,e.pendingContext=null);(null===c||null===c.child)&&ki(b)&&Ci(b);Ii(b);break;case 5:ph(b);d=lh(kh.current);var f=b.type;if(null!==c&&null!=b.stateNode)Ji(c,b,f,e,d),c.ref!==b.ref&&(b.effectTag|=128);else if(e){var g=
lh(ih.current);if(ki(b)){e=b;var h=e.stateNode;c=e.type;var k=e.memoizedProps,l=d;h[ue]=e;h[ve]=k;f=void 0;d=h;switch(c){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(h=0;h<cc.length;h++)F(cc[h],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Bb(d,k);F("invalid",d);$d(l,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!k.multiple};F("invalid",d);$d(l,"onChange");break;case "textarea":Lb(d,k),F("invalid",d),$d(l,"onChange")}Yd(c,k);h=null;for(f in k)k.hasOwnProperty(f)&&(g=k[f],"children"===f?"string"===typeof g?d.textContent!==g&&(h=["children",g]):"number"===typeof g&&d.textContent!==""+g&&(h=["children",""+g]):ia.hasOwnProperty(f)&&null!=g&&$d(l,f));switch(c){case "input":yb(d);Gb(d,k,!0);break;case "textarea":yb(d);Nb(d,k);break;case "select":case "option":break;default:"function"===typeof k.onClick&&
(d.onclick=ae)}f=h;e.updateQueue=f;e=null!==f?!0:!1;e&&Ci(b)}else{c=b;l=f;k=e;h=9===d.nodeType?d:d.ownerDocument;g===Ob.html&&(g=Pb(l));g===Ob.html?"script"===l?(k=h.createElement("div"),k.innerHTML="<script>\x3c/script>",h=k.removeChild(k.firstChild)):"string"===typeof k.is?h=h.createElement(l,{is:k.is}):(h=h.createElement(l),"select"===l&&(l=h,k.multiple?l.multiple=!0:k.size&&(l.size=k.size))):h=h.createElementNS(g,l);k=h;k[ue]=c;k[ve]=e;Hi(k,b,!1,!1);b.stateNode=k;l=f;c=e;var m=d,C=Zd(l,c);switch(l){case "iframe":case "object":case "embed":F("load",
k);d=c;break;case "video":case "audio":for(d=0;d<cc.length;d++)F(cc[d],k);d=c;break;case "source":F("error",k);d=c;break;case "img":case "image":case "link":F("error",k);F("load",k);d=c;break;case "form":F("reset",k);F("submit",k);d=c;break;case "details":F("toggle",k);d=c;break;case "input":Bb(k,c);d=Ab(k,c);F("invalid",k);$d(m,"onChange");break;case "option":d=Ib(k,c);break;case "select":k._wrapperState={wasMultiple:!!c.multiple};d=n({},c,{value:void 0});F("invalid",k);$d(m,"onChange");break;case "textarea":Lb(k,
c);d=Kb(k,c);F("invalid",k);$d(m,"onChange");break;default:d=c}Yd(l,d);h=void 0;g=l;var y=k,H=d;for(h in H)if(H.hasOwnProperty(h)){var z=H[h];"style"===h?Wd(y,z):"dangerouslySetInnerHTML"===h?(z=z?z.__html:void 0,null!=z&&Sb(y,z)):"children"===h?"string"===typeof z?("textarea"!==g||""!==z)&&Tb(y,z):"number"===typeof z&&Tb(y,""+z):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(ia.hasOwnProperty(h)?null!=z&&$d(m,h):null!=z&&vb(y,h,z,C))}switch(l){case "input":yb(k);
Gb(k,c,!1);break;case "textarea":yb(k);Nb(k,c);break;case "option":null!=c.value&&k.setAttribute("value",""+ub(c.value));break;case "select":d=k;d.multiple=!!c.multiple;k=c.value;null!=k?Jb(d,!!c.multiple,k,!1):null!=c.defaultValue&&Jb(d,!!c.multiple,c.defaultValue,!0);break;default:"function"===typeof d.onClick&&(k.onclick=ae)}(e=ne(f,e))&&Ci(b)}null!==b.ref&&(b.effectTag|=128)}else if(null===b.stateNode)throw Error(u(166));break;case 6:if(c&&null!=b.stateNode)Ki(c,b,c.memoizedProps,e);else{if("string"!==
typeof e&&null===b.stateNode)throw Error(u(166));d=lh(kh.current);lh(ih.current);ki(b)?(e=b,f=e.stateNode,d=e.memoizedProps,f[ue]=e,(e=f.nodeValue!==d)&&Ci(b)):(f=b,e=(9===d.nodeType?d:d.ownerDocument).createTextNode(e),e[ue]=f,b.stateNode=e)}break;case 11:break;case 13:G(M,b);e=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=d;break a}e=null!==e;f=!1;null===c?void 0!==b.memoizedProps.fallback&&ki(b):(d=c.memoizedState,f=null!==d,e||null===d||(d=c.child.sibling,null!==d&&(k=b.firstEffect,
null!==k?(b.firstEffect=d,d.nextEffect=k):(b.firstEffect=b.lastEffect=d,d.nextEffect=null),d.effectTag=8)));if(e&&!f&&0!==(b.mode&2))if(null===c&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))X===qj&&(X=tj);else{if(X===qj||X===tj)X=uj;0!==Aj&&null!==U&&(Mj(U,W),Nj(U,Aj))}if(e||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:nh(b);Ii(b);break;case 10:tg(b);break;case 9:break;case 14:break;case 17:L(b.type)&&Ff(b);break;case 19:G(M,b);e=b.memoizedState;if(null===
e)break;f=0!==(b.effectTag&64);k=e.rendering;if(null===k)if(f)Li(e,!1);else{if(X!==qj||null!==c&&0!==(c.effectTag&64))for(c=b.child;null!==c;){k=qh(c);if(null!==k){b.effectTag|=64;Li(e,!1);f=k.updateQueue;null!==f&&(b.updateQueue=f,b.effectTag|=4);null===e.lastEffect&&(b.firstEffect=null);b.lastEffect=e.lastEffect;e=d;for(f=b.child;null!==f;)d=f,c=e,d.effectTag&=2,d.nextEffect=null,d.firstEffect=null,d.lastEffect=null,k=d.alternate,null===k?(d.childExpirationTime=0,d.expirationTime=c,d.child=null,
d.memoizedProps=null,d.memoizedState=null,d.updateQueue=null,d.dependencies=null):(d.childExpirationTime=k.childExpirationTime,d.expirationTime=k.expirationTime,d.child=k.child,d.memoizedProps=k.memoizedProps,d.memoizedState=k.memoizedState,d.updateQueue=k.updateQueue,c=k.dependencies,d.dependencies=null===c?null:{expirationTime:c.expirationTime,firstContext:c.firstContext,responders:c.responders}),f=f.sibling;I(M,M.current&1|2,b);b=b.child;break a}c=c.sibling}}else{if(!f)if(c=qh(k),null!==c){if(b.effectTag|=
64,f=!0,d=c.updateQueue,null!==d&&(b.updateQueue=d,b.effectTag|=4),Li(e,!0),null===e.tail&&"hidden"===e.tailMode&&!k.alternate){b=b.lastEffect=e.lastEffect;null!==b&&(b.nextEffect=null);break}}else cg()>e.tailExpiration&&1<d&&(b.effectTag|=64,f=!0,Li(e,!1),b.expirationTime=b.childExpirationTime=d-1);e.isBackwards?(k.sibling=b.child,b.child=k):(d=e.last,null!==d?d.sibling=k:b.child=k,e.last=k)}if(null!==e.tail){0===e.tailExpiration&&(e.tailExpiration=cg()+500);d=e.tail;e.rendering=d;e.tail=d.sibling;
e.lastEffect=b.lastEffect;d.sibling=null;e=M.current;e=f?e&1|2:e&1;I(M,e,b);b=d;break a}break;case 20:break;case 21:break;default:throw Error(u(156,b.tag));}b=null}e=V;if(1===W||1!==e.childExpirationTime){f=0;for(d=e.child;null!==d;)c=d.expirationTime,k=d.childExpirationTime,c>f&&(f=c),k>f&&(f=k),d=d.sibling;e.childExpirationTime=f}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=V.firstEffect),null!==V.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=
V.firstEffect),a.lastEffect=V.lastEffect),1<V.effectTag&&(null!==a.lastEffect?a.lastEffect.nextEffect=V:a.firstEffect=V,a.lastEffect=V))}else{b=Mi(V,W);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=V.sibling;if(null!==b)return b;V=a}while(null!==V);X===qj&&(X=vj);return null}function Xj(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Yj(a){var b=dg();fg(99,ik.bind(null,a,b));return null}
function ik(a,b){do Sj();while(null!==Ej);if((T&(oj|pj))!==S)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Xj(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===U&&(V=U=null,W=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=T;T|=pj;mj.current=null;le=Ld;var g=fe();if(ge(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(Db){h=null;break a}var C=0,y=-1,H=-1,z=0,ta=0,r=g,x=null;b:for(;;){for(var A;;){r!==h||0!==l&&3!==r.nodeType||(y=C+l);r!==m||0!==k&&3!==r.nodeType||(H=C+k);3===r.nodeType&&(C+=r.nodeValue.length);if(null===(A=r.firstChild))break;x=r;r=A}for(;;){if(r===g)break b;x===h&&++z===l&&(y=C);x===m&&++ta===k&&(H=C);if(null!==(A=r.nextSibling))break;r=x;x=r.parentNode}r=A}h=-1===y||-1===H?null:{start:y,end:H}}else h=null}h=h||{start:0,end:0}}else h=
null;me={focusedElem:g,selectionRange:h};Ld=!1;Y=e;do try{jk()}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var p=Y.effectTag;p&16&&Tb(Y.stateNode,"");if(p&128){var t=Y.alternate;if(null!==t){var v=t.ref;null!==v&&("function"===typeof v?v(null):v.current=null)}}switch(p&1038){case 2:$i(Y);Y.effectTag&=-3;break;case 6:$i(Y);Y.effectTag&=-3;aj(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=-1025;aj(Y.alternate,
Y);break;case 4:aj(Y.alternate,Y);break;case 8:l=Y,Xi(g,l,h),Yi(l)}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);v=me;t=fe();p=v.focusedElem;h=v.selectionRange;if(t!==p&&p&&p.ownerDocument&&ee(p.ownerDocument.documentElement,p)){null!==h&&ge(p)&&(t=h.start,v=h.end,void 0===v&&(v=t),"selectionStart"in p?(p.selectionStart=t,p.selectionEnd=Math.min(v,p.value.length)):(v=(t=p.ownerDocument||document)&&t.defaultView||window,v.getSelection&&(v=v.getSelection(),
l=p.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!v.extend&&g>h&&(l=h,h=g,g=l),l=de(p,g),m=de(p,h),l&&m&&(1!==v.rangeCount||v.anchorNode!==l.node||v.anchorOffset!==l.offset||v.focusNode!==m.node||v.focusOffset!==m.offset)&&(t=t.createRange(),t.setStart(l.node,l.offset),v.removeAllRanges(),g>h?(v.addRange(t),v.extend(m.node,m.offset)):(t.setEnd(m.node,m.offset),v.addRange(t))))));t=[];for(v=p;v=v.parentNode;)1===v.nodeType&&t.push({element:v,left:v.scrollLeft,top:v.scrollTop});
"function"===typeof p.focus&&p.focus();for(p=0;p<t.length;p++)v=t[p],v.element.scrollLeft=v.left,v.element.scrollTop=v.top}me=null;Ld=!!le;le=null;a.current=c;Y=e;do try{for(p=d;null!==Y;){var Dh=Y.effectTag;if(Dh&36){var dc=Y.alternate;t=Y;v=p;switch(t.tag){case 0:case 11:case 15:Ui(16,32,t);break;case 1:var fd=t.stateNode;if(t.effectTag&4)if(null===dc)fd.componentDidMount();else{var hk=t.elementType===t.type?dc.memoizedProps:mg(t.type,dc.memoizedProps);fd.componentDidUpdate(hk,dc.memoizedState,
fd.__reactInternalSnapshotBeforeUpdate)}var Eh=t.updateQueue;null!==Eh&&Kg(t,Eh,fd,v);break;case 3:var Fh=t.updateQueue;if(null!==Fh){g=null;if(null!==t.child)switch(t.child.tag){case 5:g=t.child.stateNode;break;case 1:g=t.child.stateNode}Kg(t,Fh,g,v)}break;case 5:var xk=t.stateNode;null===dc&&t.effectTag&4&&ne(t.type,t.memoizedProps)&&xk.focus();break;case 6:break;case 4:break;case 12:break;case 13:if(null===t.memoizedState){var Di=t.alternate;if(null!==Di){var Ei=Di.memoizedState;if(null!==Ei){var Fi=
Ei.dehydrated;null!==Fi&&Lc(Fi)}}}break;case 19:case 17:case 20:case 21:break;default:throw Error(u(163));}}if(Dh&128){t=void 0;var xd=Y.ref;if(null!==xd){var Gi=Y.stateNode;switch(Y.tag){case 5:t=Gi;break;default:t=Gi}"function"===typeof xd?xd(t):xd.current=t}}Y=Y.nextEffect}}catch(Db){if(null===Y)throw Error(u(330));Ri(Y,Db);Y=Y.nextEffect}while(null!==Y);Y=null;Yf();T=f}else a.current=c;if(Dj)Dj=!1,Ej=a,Fj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&
(jj=null);1073741823===b?a===Ij?Hj++:(Hj=0,Ij=a):Hj=0;"function"===typeof kk&&kk(c.stateNode,d);Z(a);if(gj)throw gj=!1,a=hj,hj=null,a;if((T&nj)!==S)return null;jg();return null}function jk(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Ti(Y.alternate,Y);0===(a&512)||Dj||(Dj=!0,gg(97,function(){Sj();return null}));Y=Y.nextEffect}}function Sj(){if(90!==Fj){var a=97<Fj?97:Fj;Fj=90;return fg(a,lk)}}
function lk(){if(null===Ej)return!1;var a=Ej;Ej=null;if((T&(oj|pj))!==S)throw Error(u(331));var b=T;T|=pj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:Ui(128,0,c),Ui(0,64,c)}}catch(d){if(null===a)throw Error(u(330));Ri(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}T=b;jg();return!0}function mk(a,b,c){b=Ni(c,b);b=fj(a,b,1073741823);Dg(a,b);a=Kj(a,1073741823);null!==a&&Z(a)}
function Ri(a,b){if(3===a.tag)mk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){mk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===jj||!jj.has(d))){a=Ni(b,a);a=ij(c,a,1073741823);Dg(c,a);c=Kj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function dk(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);U===a&&W===c?X===uj||X===tj&&1073741823===xj&&cg()-bj<Cj?Tj(a,W):Bj=!0:Pj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,a.finishedExpirationTime===c&&(a.finishedExpirationTime=0,a.finishedWork=null),Z(a)))}function dj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Pg(),b=Qg(b,a,null));a=Kj(a,b);null!==a&&Z(a)}var gk;
gk=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)wg=!0;else{if(d<c){wg=!1;switch(b.tag){case 3:wi(b);li();break;case 5:oh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Jf(b);break;case 4:mh(b,b.stateNode.containerInfo);break;case 10:sg(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return yi(a,b,c);I(M,M.current&
1,b);b=oi(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1,b);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return Bi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current,b);if(!d)return null}return oi(a,b,c)}wg=!1}}else wg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Ef(b,J.current);vg(b,c);e=Ih(null,b,d,a,e,c);b.effectTag|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;Mh();if(L(d)){var f=!0;Jf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&Og(b,d,g,a);e.updater=Sg;b.stateNode=e;e._reactInternalFiber=b;Wg(b,d,a,c);b=vi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;Va(e);if(1!==e._status)throw e._result;
e=e._result;b.type=e;f=b.tag=nk(e);a=mg(e,a);switch(f){case 0:b=si(null,b,e,a,c);break;case 1:b=ui(null,b,e,a,c);break;case 11:b=ni(null,b,e,a,c);break;case 14:b=pi(null,b,e,mg(e.type,a),d,c);break;default:throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),si(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ui(a,b,d,e,c);case 3:wi(b);d=b.updateQueue;if(null===d)throw Error(u(282));e=b.memoizedState;e=null!==e?e.element:
null;Hg(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)li(),b=oi(a,b,c);else{if(e=b.stateNode.hydrate)di=re(b.stateNode.containerInfo.firstChild),ci=b,e=ei=!0;if(e)for(c=gh(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),li();b=b.child}return b;case 5:return oh(b),null===a&&ii(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,oe(d,e)?g=null:null!==f&&oe(d,f)&&(b.effectTag|=16),ti(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=
b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&ii(b),null;case 13:return yi(a,b,c);case 4:return mh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=fh(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),ni(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;
e=b.pendingProps;g=b.memoizedProps;f=e.value;sg(b,f);if(null!==g){var h=g.value;f=of(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!K.current){b=oi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=Bg(c,null),l.tag=2,Dg(h,l));h.expirationTime<c&&(h.expirationTime=
c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);ug(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,vg(b,c),e=xg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;
case 14:return e=b.type,f=mg(e,b.pendingProps),f=mg(e.type,f),pi(a,b,e,f,d,c);case 15:return ri(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:mg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Jf(b)):a=!1,vg(b,c),Ug(b,d,e,c),Wg(b,d,e,c),vi(null,b,d,!0,a,c);case 19:return Bi(a,b,c)}throw Error(u(156,b.tag));};var kk=null,Wi=null;
function ok(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);kk=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Wi=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function pk(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function gi(a,b,c,d){return new pk(a,b,c,d)}
function qi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function nk(a){if("function"===typeof a)return qi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Oa)return 11;if(a===Ra)return 14}return 2}
function ah(a,b){var c=a.alternate;null===c?(c=gi(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function ch(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)qi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case Ia:return eh(c.children,e,f,b);case Na:g=8;e|=7;break;case Ja:g=8;e|=1;break;case Ka:return a=gi(12,c,b,e|8),a.elementType=Ka,a.type=Ka,a.expirationTime=f,a;case Pa:return a=gi(13,c,b,e),a.type=Pa,a.elementType=Pa,a.expirationTime=f,a;case Qa:return a=gi(19,c,b,e),a.elementType=Qa,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case La:g=
10;break a;case Ma:g=9;break a;case Oa:g=11;break a;case Ra:g=14;break a;case Sa:g=16;d=null;break a}throw Error(u(130,null==a?a:typeof a,""));}b=gi(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function eh(a,b,c,d){a=gi(7,a,d,b);a.expirationTime=c;return a}function bh(a,b,c){a=gi(6,a,null,b);a.expirationTime=c;return a}
function dh(a,b,c){b=gi(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function qk(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Pj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function Mj(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function Nj(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Rj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function rk(a,b,c,d){var e=b.current,f=Pg(),g=Mg.suspense;f=Qg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(ec(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=If(c,k,h);break a}}c=h}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=Bg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);Dg(e,b);Rg(e,f);return f}function sk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function tk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function uk(a,b){tk(a,b);(a=a.alternate)&&tk(a,b)}
function vk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new qk(a,b,c),e=gi(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;a[we]=d.current;c&&0!==b&&wc(9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}vk.prototype.render=function(a,b){rk(a,this._internalRoot,null,void 0===b?null:b)};vk.prototype.unmount=function(a){var b=this._internalRoot,c=void 0===a?null:a,d=b.containerInfo;rk(null,b,null,function(){d[we]=null;null!==c&&c()})};
function wk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function yk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new vk(a,0,b?{hydrate:!0}:void 0)}
function zk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=sk(g);h.call(a)}}rk(b,g,a,e)}else{f=c._reactRootContainer=yk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=sk(g);k.call(a)}}ck(function(){rk(b,g,a,e)})}return sk(g)}function Ak(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:Ha,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
jc=function(a){if(13===a.tag){var b=lg(Pg(),150,100);Rg(a,b);uk(a,b)}};kc=function(a){if(13===a.tag){Pg();var b=kg++;Rg(a,b);uk(a,b)}};lc=function(a){if(13===a.tag){var b=Pg();b=Qg(b,a,null);Rg(a,b);uk(a,b)}};
Za=function(a,b,c){switch(b){case "input":Eb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=ye(d);if(!e)throw Error(u(90));zb(d);Eb(d,e)}}}break;case "textarea":Mb(a,c);break;case "select":b=c.value,null!=b&&Jb(a,!!c.multiple,b,!1)}};eb=bk;
fb=function(a,b,c,d){var e=T;T|=4;try{return fg(98,a.bind(null,b,c,d))}finally{T=e,T===S&&jg()}};gb=function(){(T&(1|oj|pj))===S&&(ak(),Sj())};hb=function(a,b){var c=T;T|=2;try{return a(b)}finally{T=c,T===S&&jg()}};function Bk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!wk(b))throw Error(u(200));return Ak(a,b,null,c)}
var Ck={createPortal:Bk,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=ic(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!0,c)},render:function(a,b,c){if(!wk(b))throw Error(u(200));return zk(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){if(!wk(c))throw Error(u(200));
if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return zk(a,b,c,!1,d)},unmountComponentAtNode:function(a){if(!wk(a))throw Error(u(40));return a._reactRootContainer?(ck(function(){zk(null,null,a,!1,function(){a._reactRootContainer=null;a[we]=null})}),!0):!1},unstable_createPortal:function(){return Bk.apply(void 0,arguments)},unstable_batchedUpdates:bk,flushSync:function(a,b){if((T&(oj|pj))!==S)throw Error(u(187));var c=T;T|=1;try{return fg(99,a.bind(null,b))}finally{T=c,jg()}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Cc,
xe,ye,Ca.injectEventPluginsByName,fa,Sc,function(a){ya(a,Rc)},cb,db,Pd,Ba,Sj,{current:!1}]}};
(function(a){var b=a.findFiberByHostInstance;return ok(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Ea.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=ic(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:Fc,bundleType:0,version:"16.12.0",
rendererPackageName:"react-dom"});var Dk={default:Ck},Ek=Dk&&Ck||Dk;module.exports=Ek.default||Ek;


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(625);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.18.0
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=Math.floor((c-1)/2),e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};exports.unstable_cancelCallback=function(a){a.callback=null};
exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_requestPaint=Z;exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_Profiling=null;


/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

var invariant = __webpack_require__(79);
var defaultClickRejectionStrategy = __webpack_require__(627);

var alreadyInjected = false;

module.exports = function injectTapEventPlugin(strategyOverrides) {
  strategyOverrides = strategyOverrides || {}
  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;

  if (false) {
    invariant(
      !alreadyInjected,
      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
It is recommended to call injectTapEventPlugin() just before you call \
ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
itself, please contact the maintainer as it shouldn\'t be called in library code and \
should be injected by the application.'
    )
  }

  alreadyInjected = true;

  __webpack_require__(17).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPluginHub.injection.injectEventPluginsByName({
    'TapEventPlugin': __webpack_require__(628)(shouldRejectClick)
  });
};



/***/ }),
/* 627 */
/***/ (function(module, exports) {

module.exports = function(lastTouchEvent, clickTimestamp) {
  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
    return true;
  }
};


/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule TapEventPlugin
 * @flow
 */



var EventPropagators = __webpack_require__(17).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.EventPropagators;
var TouchEventUtils = __webpack_require__(629);
var SyntheticEvent = __webpack_require__(630);

function isEndish(topLevelType) {
  return (
    topLevelType === 'topMouseUp' ||
    topLevelType === 'topTouchEnd' ||
    topLevelType === 'topTouchCancel'
  );
}

function isStartish(topLevelType) {
  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
}

/**
 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
 * in order to still be considered a 'tap' event.
 */
var tapMoveThreshold = 10;
var startCoords = {x: 0, y: 0};

var Axis = {
  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
};

function getAxisCoordOfEvent(
  axis,
  nativeEvent
) {
  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
  if (singleTouch) {
    return singleTouch[axis.page];
  }
  return nativeEvent[axis.page];
}

function getDistance(coords, nativeEvent) {
  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
  return Math.pow(
    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
    0.5
  );
}

var touchEvents = [
  'topTouchStart',
  'topTouchCancel',
  'topTouchEnd',
  'topTouchMove'
];

var dependencies = ['topMouseDown', 'topMouseMove', 'topMouseUp'].concat(
  touchEvents
);

var eventTypes = {
  touchTap: {
    phasedRegistrationNames: {
      bubbled: 'onTouchTap',
      captured: 'onTouchTapCapture'
    },
    dependencies: dependencies
  }
};

var usedTouchTime = 0;

// var TapEventPlugin = {
function createTapEventPlugin(shouldRejectClick) {
  return {
    tapMoveThreshold: tapMoveThreshold,

    eventTypes: eventTypes,

    extractEvents: function(
      topLevelType,
      targetInst,
      nativeEvent,
      nativeEventTarget
    ) {
      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
        return null;
      }
      // on ios, there is a delay after touch event and synthetic
      // mouse events, so that user can perform double tap
      // solution: ignore mouse events following touchevent within small timeframe
      if (touchEvents.indexOf(topLevelType) !== -1) {
        usedTouchTime = Date.now();
      } else {
        if (shouldRejectClick(usedTouchTime, Date.now())) {
          return null;
        }
      }
      var event = null;
      var distance = getDistance(startCoords, nativeEvent);
      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
        event = SyntheticEvent.getPooled(
          eventTypes.touchTap,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      if (isStartish(topLevelType)) {
        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
      } else if (isEndish(topLevelType)) {
        startCoords.x = 0;
        startCoords.y = 0;
      }
      EventPropagators.accumulateTwoPhaseDispatches(event);
      return event;
    }
  };
}

module.exports = createTapEventPlugin;


/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;

    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};

module.exports = TouchEventUtils;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SyntheticEvent
 */

/* eslint valid-typeof: 0 */



var emptyFunction = __webpack_require__(129);
var invariant = __webpack_require__(79);

var didWarnForAddedNewProperty = false;
var isProxySupported = typeof Proxy === 'function';
var EVENT_POOL_SIZE = 10;

var __DEV__ = "production" !== 'production';

if (__DEV__) {
  var warning = __webpack_require__(80);
}

var shouldBeReleasedProperties = [
  'dispatchConfig',
  '_targetInst',
  'nativeEvent',
  'isDefaultPrevented',
  'isPropagationStopped',
  '_dispatchListeners',
  '_dispatchInstances'
];

/**
 * @interface Event
 * @see http://www.w3.org/TR/DOM-Level-3-Events/
 */
var EventInterface = {
  type: null,
  target: null,
  // currentTarget is set when dispatching; no use in copying it here
  currentTarget: emptyFunction.thatReturnsNull,
  eventPhase: null,
  bubbles: null,
  cancelable: null,
  timeStamp: function(event) {
    return event.timeStamp || Date.now();
  },
  defaultPrevented: null,
  isTrusted: null
};

/**
 * Synthetic events are dispatched by event plugins, typically in response to a
 * top-level event delegation handler.
 *
 * These systems should generally use pooling to reduce the frequency of garbage
 * collection. The system should check `isPersistent` to determine whether the
 * event should be released into the pool after being dispatched. Users that
 * need a persisted event should invoke `persist`.
 *
 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
 * normalizing browser quirks. Subclasses do not necessarily have to implement a
 * DOM interface; custom application-specific events can also subclass this.
 *
 * @param {object} dispatchConfig Configuration used to dispatch this event.
 * @param {*} targetInst Marker identifying the event target.
 * @param {object} nativeEvent Native browser event.
 * @param {DOMEventTarget} nativeEventTarget Target node.
 */
function SyntheticEvent(
  dispatchConfig,
  targetInst,
  nativeEvent,
  nativeEventTarget
) {
  if (__DEV__) {
    // these have a getter/setter for warnings
    delete this.nativeEvent;
    delete this.preventDefault;
    delete this.stopPropagation;
  }

  this.dispatchConfig = dispatchConfig;
  this._targetInst = targetInst;
  this.nativeEvent = nativeEvent;

  var Interface = this.constructor.Interface;
  for (var propName in Interface) {
    if (!Interface.hasOwnProperty(propName)) {
      continue;
    }
    if (__DEV__) {
      delete this[propName]; // this has a getter/setter for warnings
    }
    var normalize = Interface[propName];
    if (normalize) {
      this[propName] = normalize(nativeEvent);
    } else {
      if (propName === 'target') {
        this.target = nativeEventTarget;
      } else {
        this[propName] = nativeEvent[propName];
      }
    }
  }

  var defaultPrevented = nativeEvent.defaultPrevented != null
    ? nativeEvent.defaultPrevented
    : nativeEvent.returnValue === false;
  if (defaultPrevented) {
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  } else {
    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
  }
  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
  return this;
}

Object.assign(SyntheticEvent.prototype, {
  preventDefault: function() {
    this.defaultPrevented = true;
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.preventDefault) {
      event.preventDefault();
    } else if (typeof event.returnValue !== 'unknown') {
      event.returnValue = false;
    }
    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
  },

  stopPropagation: function() {
    var event = this.nativeEvent;
    if (!event) {
      return;
    }

    if (event.stopPropagation) {
      event.stopPropagation();
    } else if (typeof event.cancelBubble !== 'unknown') {
      // The ChangeEventPlugin registers a "propertychange" event for
      // IE. This event does not support bubbling or cancelling, and
      // any references to cancelBubble throw "Member not found".  A
      // typeof check of "unknown" circumvents this issue (and is also
      // IE specific).
      event.cancelBubble = true;
    }

    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
  },

  /**
   * We release all dispatched `SyntheticEvent`s after each event loop, adding
   * them back into the pool. This allows a way to hold onto a reference that
   * won't be added back into the pool.
   */
  persist: function() {
    this.isPersistent = emptyFunction.thatReturnsTrue;
  },

  /**
   * Checks if this event should be released back into the pool.
   *
   * @return {boolean} True if this should not be released, false otherwise.
   */
  isPersistent: emptyFunction.thatReturnsFalse,

  /**
   * `PooledClass` looks for `destructor` on each instance it releases.
   */
  destructor: function() {
    var Interface = this.constructor.Interface;
    for (var propName in Interface) {
      if (__DEV__) {
        Object.defineProperty(
          this,
          propName,
          getPooledWarningPropertyDefinition(propName, Interface[propName])
        );
      } else {
        this[propName] = null;
      }
    }
    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
      this[shouldBeReleasedProperties[i]] = null;
    }
    if (__DEV__) {
      Object.defineProperty(
        this,
        'nativeEvent',
        getPooledWarningPropertyDefinition('nativeEvent', null)
      );
      Object.defineProperty(
        this,
        'preventDefault',
        getPooledWarningPropertyDefinition('preventDefault', emptyFunction)
      );
      Object.defineProperty(
        this,
        'stopPropagation',
        getPooledWarningPropertyDefinition('stopPropagation', emptyFunction)
      );
    }
  }
});

SyntheticEvent.Interface = EventInterface;

/**
 * Helper to reduce boilerplate when creating subclasses.
 *
 * @param {function} Class
 * @param {?object} Interface
 */
SyntheticEvent.augmentClass = function(Class, Interface) {
  var Super = this;

  var E = function() {};
  E.prototype = Super.prototype;
  var prototype = new E();

  Object.assign(prototype, Class.prototype);
  Class.prototype = prototype;
  Class.prototype.constructor = Class;

  Class.Interface = Object.assign({}, Super.Interface, Interface);
  Class.augmentClass = Super.augmentClass;
  addEventPoolingTo(Class);
};

/** Proxying after everything set on SyntheticEvent
  * to resolve Proxy issue on some WebKit browsers
  * in which some Event properties are set to undefined (GH#10010)
  */
if (__DEV__) {
  if (isProxySupported) {
    /*eslint-disable no-func-assign */
    SyntheticEvent = new Proxy(SyntheticEvent, {
      construct: function(target, args) {
        return this.apply(target, Object.create(target.prototype), args);
      },
      apply: function(constructor, that, args) {
        return new Proxy(constructor.apply(that, args), {
          set: function(target, prop, value) {
            if (
              prop !== 'isPersistent' &&
              !target.constructor.Interface.hasOwnProperty(prop) &&
              shouldBeReleasedProperties.indexOf(prop) === -1
            ) {
              warning(
                didWarnForAddedNewProperty || target.isPersistent(),
                "This synthetic event is reused for performance reasons. If you're " +
                  "seeing this, you're adding a new property in the synthetic event object. " +
                  'The property is never released. See ' +
                  'https://fb.me/react-event-pooling for more information.'
              );
              didWarnForAddedNewProperty = true;
            }
            target[prop] = value;
            return true;
          }
        });
      }
    });
    /*eslint-enable no-func-assign */
  }
}

addEventPoolingTo(SyntheticEvent);

module.exports = SyntheticEvent;

/**
  * Helper to nullify syntheticEvent instance properties when destructing
  *
  * @param {String} propName
  * @param {?object} getVal
  * @return {object} defineProperty object
  */
function getPooledWarningPropertyDefinition(propName, getVal) {
  var isFunction = typeof getVal === 'function';
  return {
    configurable: true,
    set: set,
    get: get
  };

  function set(val) {
    var action = isFunction ? 'setting the method' : 'setting the property';
    warn(action, 'This is effectively a no-op');
    return val;
  }

  function get() {
    var action = isFunction ? 'accessing the method' : 'accessing the property';
    var result = isFunction
      ? 'This is a no-op function'
      : 'This is set to null';
    warn(action, result);
    return getVal;
  }

  function warn(action, result) {
    var warningCondition = false;
    warning(
      warningCondition,
      "This synthetic event is reused for performance reasons. If you're seeing this, " +
        "you're %s `%s` on a released/nullified synthetic event. %s. " +
        'If you must keep the original synthetic event around, use event.persist(). ' +
        'See https://fb.me/react-event-pooling for more information.',
      action,
      propName,
      result
    );
  }
}

function getPooledEvent(dispatchConfig, targetInst, nativeEvent, nativeInst) {
  var EventConstructor = this;
  if (EventConstructor.eventPool.length) {
    var instance = EventConstructor.eventPool.pop();
    EventConstructor.call(
      instance,
      dispatchConfig,
      targetInst,
      nativeEvent,
      nativeInst
    );
    return instance;
  }
  return new EventConstructor(
    dispatchConfig,
    targetInst,
    nativeEvent,
    nativeInst
  );
}

function releasePooledEvent(event) {
  var EventConstructor = this;
  invariant(
    event instanceof EventConstructor,
    'Trying to release an event instance  into a pool of a different type.'
  );
  event.destructor();
  if (EventConstructor.eventPool.length < EVENT_POOL_SIZE) {
    EventConstructor.eventPool.push(event);
  }
}

function addEventPoolingTo(EventConstructor) {
  EventConstructor.eventPool = [];
  EventConstructor.getPooled = getPooledEvent;
  EventConstructor.release = releasePooledEvent;
}


/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Store__ = __webpack_require__(678);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__App__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__App_css__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Root=function(_Component){_inherits(Root,_Component);function Root(){_classCallCheck(this,Root);return _possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).apply(this,arguments));}_createClass(Root,[{key:"componentDidMount",value:function componentDidMount(){document.title="Hangover";}},{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:__WEBPACK_IMPORTED_MODULE_3__config_Store__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__App__["a" /* default */],null)));}}]);return Root;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Root);

/***/ }),
/* 633 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__ = __webpack_require__(636);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createBrowserHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(635);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(323)('createBrowserHistory');
module.exports = __webpack_require__(324).createBrowserHistory;


/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(325)),valueEqual=_interopDefault(__webpack_require__(326));__webpack_require__(160);var invariant=_interopDefault(__webpack_require__(327));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ }),
/* 638 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(225);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (MemoryRouter);

/***/ }),
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Prompt);

/***/ }),
/* 641 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(328);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["d" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (Redirect);

/***/ }),
/* 642 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(225);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["a" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* unused harmony default export */ var _unused_webpack_default_export = (StaticRouter);

/***/ }),
/* 644 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(226);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(330);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 646 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__ = __webpack_require__(647);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_history_createHashHistory__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router__ = __webpack_require__(50);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = __WEBPACK_IMPORTED_MODULE_2_history_createHashHistory___default()(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router__["b" /* Router */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(['hashbang', 'noslash', 'slash']),
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

__webpack_require__(323)('createHashHistory');
module.exports = __webpack_require__(324).createHashHistory;


/***/ }),
/* 648 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 649 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(332);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive']);

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["a" /* Route */], {
    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [activeClassName, className].filter(function (i) {
          return i;
        }).join(' ') : className,
        style: isActive ? _extends({}, style, activeStyle) : style
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};

NavLink.defaultProps = {
  activeClassName: 'active'
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 650 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 651 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 652 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["a"]; });


/***/ }),
/* 653 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 655 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["c"]; });


/***/ }),
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* unused harmony reexport default */


/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router__ = __webpack_require__(50);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0_react_router__["d"]; });


/***/ }),
/* 658 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(227);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 659 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(72);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.12.0
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

Object.defineProperty(exports,"__esModule",{value:!0});
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ }),
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(676);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(342);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["b" /* bindActionCreators */])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 666 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(161);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getRawTag);


/***/ }),
/* 667 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/* harmony default export */ __webpack_exports__["a"] = (objectToString);


/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(669);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55), __webpack_require__(110)(module)))

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 670 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = combineReducers;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStore__ = __webpack_require__(336);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_warning__ = __webpack_require__(340);




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isPlainObject__["a" /* default */])(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + __WEBPACK_IMPORTED_MODULE_0__createStore__["a" /* ActionTypes */].INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = bindActionCreators;
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = applyMiddleware;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__compose__ = __webpack_require__(341);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = __WEBPACK_IMPORTED_MODULE_0__compose__["a" /* default */].apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}

/***/ }),
/* 673 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(342);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 675 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(343);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 676 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(677);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(227);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(679);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__reducers_index__ = __webpack_require__(680);
var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["d" /* createStore */])(__WEBPACK_IMPORTED_MODULE_2__reducers_index__["a" /* default */],Object(__WEBPACK_IMPORTED_MODULE_0_redux__["a" /* applyMiddleware */])(__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]));/* harmony default export */ __webpack_exports__["a"] = (store);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createThunkMiddleware(extraArgument) {
  return function (_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        if (typeof action === 'function') {
          return action(dispatch, getState, extraArgument);
        }

        return next(action);
      };
    };
  };
}

var thunk = createThunkMiddleware();
thunk.withExtraArgument = createThunkMiddleware;

/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AuthReducer__ = __webpack_require__(849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AppReducer__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__EventReducer__ = __webpack_require__(851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PlaceReducer__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__UserReducer__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RolReducer__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__NotificationReducer__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NoveltyReducer__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TagReducer__ = __webpack_require__(857);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StatsReducer__ = __webpack_require__(858);
var rootReducer=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["c" /* combineReducers */])({form:__WEBPACK_IMPORTED_MODULE_1_redux_form__["b" /* reducer */],auth:__WEBPACK_IMPORTED_MODULE_2__AuthReducer__["a" /* default */],app:__WEBPACK_IMPORTED_MODULE_3__AppReducer__["a" /* default */],evt:__WEBPACK_IMPORTED_MODULE_4__EventReducer__["a" /* default */],plc:__WEBPACK_IMPORTED_MODULE_5__PlaceReducer__["a" /* default */],usr:__WEBPACK_IMPORTED_MODULE_6__UserReducer__["a" /* default */],rol:__WEBPACK_IMPORTED_MODULE_7__RolReducer__["a" /* default */],ntf:__WEBPACK_IMPORTED_MODULE_8__NotificationReducer__["a" /* default */],nvt:__WEBPACK_IMPORTED_MODULE_9__NoveltyReducer__["a" /* default */],tag:__WEBPACK_IMPORTED_MODULE_10__TagReducer__["a" /* default */],stats:__WEBPACK_IMPORTED_MODULE_11__StatsReducer__["a" /* default */]});/* harmony default export */ __webpack_exports__["a"] = (rootReducer);

/***/ }),
/* 681 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var Form = function (_Component) {
  _inherits(Form, _Component);

  function Form(props, context) {
    _classCallCheck(this, Form);

    var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('Form must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(Form, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.context._reduxForm.registerInnerOnSubmit(this.props.onSubmit);
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('form', this.props);
    }
  }]);

  return Form;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

Form.propTypes = {
  onSubmit: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired
};
Form.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
};

Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Form);
/* unused harmony default export */ var _unused_webpack_default_export = (Form);

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);




var FormName = function FormName(_ref, _ref2) {
  var children = _ref.children;
  var _reduxForm = _ref2._reduxForm;
  return children({ form: _reduxForm && _reduxForm.form });
};
FormName.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    form: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired
  }).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormName);

/***/ }),
/* 683 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_prefixName__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var FormSection = function (_Component) {
  _inherits(FormSection, _Component);

  function FormSection(props, context) {
    _classCallCheck(this, FormSection);

    var _this = _possibleConstructorReturn(this, (FormSection.__proto__ || Object.getPrototypeOf(FormSection)).call(this, props, context));

    if (!context._reduxForm) {
      throw new Error('FormSection must be inside a component decorated with reduxForm()');
    }
    return _this;
  }

  _createClass(FormSection, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var context = this.context,
          name = this.props.name;

      return {
        _reduxForm: _extends({}, context._reduxForm, {
          sectionPrefix: Object(__WEBPACK_IMPORTED_MODULE_2__util_prefixName__["a" /* default */])(context, name)
        })
      };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          name = _props.name,
          component = _props.component,
          rest = _objectWithoutProperties(_props, ['children', 'name', 'component']);

      if (__WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(children)) {
        return children;
      }

      return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, rest, {
        children: children
      }));
    }
  }]);

  return FormSection;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

FormSection.propTypes = {
  name: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,
  component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node])
};

FormSection.defaultProps = {
  component: 'div'
};

FormSection.childContextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
};

FormSection.contextTypes = {
  _reduxForm: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};

/* unused harmony default export */ var _unused_webpack_default_export = (FormSection);

/***/ }),
/* 684 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _extendableBuiltin(cls) {
  function ExtendableBuiltin() {
    cls.apply(this, arguments);
  }

  ExtendableBuiltin.prototype = Object.create(cls.prototype, {
    constructor: {
      value: cls,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });

  if (Object.setPrototypeOf) {
    Object.setPrototypeOf(ExtendableBuiltin, cls);
  } else {
    ExtendableBuiltin.__proto__ = cls;
  }

  return ExtendableBuiltin;
}

var ExtendableError = function (_extendableBuiltin2) {
  _inherits(ExtendableError, _extendableBuiltin2);

  function ExtendableError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _classCallCheck(this, ExtendableError);

    // extending Error is weird and does not propagate `message`
    var _this = _possibleConstructorReturn(this, (ExtendableError.__proto__ || Object.getPrototypeOf(ExtendableError)).call(this, message));

    Object.defineProperty(_this, 'message', {
      configurable: true,
      enumerable: false,
      value: message,
      writable: true
    });

    Object.defineProperty(_this, 'name', {
      configurable: true,
      enumerable: false,
      value: _this.constructor.name,
      writable: true
    });

    if (Error.hasOwnProperty('captureStackTrace')) {
      Error.captureStackTrace(_this, _this.constructor);
      return _possibleConstructorReturn(_this);
    }

    Object.defineProperty(_this, 'stack', {
      configurable: true,
      enumerable: false,
      value: new Error(message).stack,
      writable: true
    });
    return _this;
  }

  return ExtendableError;
}(_extendableBuiltin(Error));

/* harmony default export */ __webpack_exports__["a"] = (ExtendableError);


/***/ }),
/* 685 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formPropTypes */
/* unused harmony export fieldInputPropTypes */
/* unused harmony export fieldMetaPropTypes */
/* unused harmony export fieldArrayMetaPropTypes */
/* unused harmony export fieldArrayFieldsPropTypes */
/* unused harmony export fieldPropTypes */
/* unused harmony export fieldArrayPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);


var any = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.any,
    bool = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
    func = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
    shape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape,
    string = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
    oneOfType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType,
    object = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
    number = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.number;


var formPropTypes = {
  // State:
  anyTouched: bool.isRequired, // true if any of the fields have been marked as touched
  asyncValidating: oneOfType([bool, string]).isRequired, // true if async validation is running, a string if a field triggered async validation
  dirty: bool.isRequired, // true if any values are different from initialValues
  error: any, // form-wide error from '_error' key in validation result
  form: string.isRequired, // the name of the form
  invalid: bool.isRequired, // true if there are any validation errors
  initialized: bool.isRequired, // true if the form has been initialized
  initialValues: object, // the initialValues object passed to reduxForm
  pristine: bool.isRequired, // true if the values are the same as initialValues
  pure: bool.isRequired, // if true, implements shouldComponentUpdate
  submitting: bool.isRequired, // true if the form is in the process of being submitted
  submitFailed: bool.isRequired, // true if the form was submitted and failed for any reason
  submitSucceeded: bool.isRequired, // true if the form was successfully submitted
  valid: bool.isRequired, // true if there are no validation errors
  warning: any, // form-wide warning from '_warning' key in validation result
  // Actions:
  array: shape({
    insert: func.isRequired, // function to insert a value into an array field
    move: func.isRequired, // function to move a value within an array field
    pop: func.isRequired, // function to pop a value off of an array field
    push: func.isRequired, // function to push a value onto an array field
    remove: func.isRequired, // function to remove a value from an array field
    removeAll: func.isRequired, // function to remove all the values from an array field
    shift: func.isRequired, // function to shift a value out of an array field
    splice: func.isRequired, // function to splice a value into an array field
    swap: func.isRequired, // function to swap values in an array field
    unshift: func.isRequired // function to unshift a value into an array field
  }),
  asyncValidate: func.isRequired, // function to trigger async validation
  autofill: func.isRequired, // action to set a value of a field and mark it as autofilled
  blur: func.isRequired, // action to mark a field as blurred
  change: func.isRequired, // action to change the value of a field
  clearAsyncError: func.isRequired, // action to clear the async error of a field
  clearFields: func.isRequired, // action to clean fields values for all fields
  clearSubmitErrors: func.isRequired, // action to remove submitErrors and error
  destroy: func.isRequired, // action to destroy the form's data in Redux
  dispatch: func.isRequired, // the Redux dispatch action
  handleSubmit: func.isRequired, // function to submit the form
  initialize: func.isRequired, // action to initialize form data
  reset: func.isRequired, // action to reset the form data to previously initialized values
  resetSection: func.isRequired, // action to reset the form sections data to previously initialized values
  touch: func.isRequired, // action to mark fields as touched
  submit: func.isRequired, // action to trigger a submission of the specified form
  untouch: func.isRequired, // action to mark fields as untouched

  // triggerSubmit
  triggerSubmit: bool, // if true, submits the form on componentWillReceiveProps
  clearSubmit: func.isRequired // called before a triggered submit, by default clears triggerSubmit
};

var fieldInputPropTypes = {
  checked: bool,
  name: string.isRequired,
  onBlur: func.isRequired,
  onChange: func.isRequired,
  onDragStart: func.isRequired,
  onDrop: func.isRequired,
  onFocus: func.isRequired,
  value: any
};

var fieldMetaPropTypes = {
  active: bool.isRequired,
  asyncValidating: bool.isRequired,
  autofilled: bool.isRequired,
  dirty: bool.isRequired,
  dispatch: func.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitting: bool.isRequired,
  submitFailed: bool.isRequired,
  touched: bool.isRequired,
  valid: bool.isRequired,
  visited: bool.isRequired,
  warning: string
};

var fieldArrayMetaPropTypes = {
  dirty: bool.isRequired,
  error: any,
  form: string.isRequired,
  invalid: bool.isRequired,
  pristine: bool.isRequired,
  submitFailed: bool,
  submitting: bool,
  valid: bool.isRequired,
  warning: string
};

var fieldArrayFieldsPropTypes = {
  name: string.isRequired,
  forEach: func.isRequired,
  get: func.isRequired,
  getAll: func.isRequired,
  insert: func.isRequired,
  length: number.isRequired,
  map: func.isRequired,
  move: func.isRequired,
  pop: func.isRequired,
  push: func.isRequired,
  reduce: func.isRequired,
  remove: func.isRequired,
  removeAll: func.isRequired,
  shift: func.isRequired,
  swap: func.isRequired,
  unshift: func.isRequired
};

var fieldPropTypes = {
  input: shape(fieldInputPropTypes).isRequired,
  meta: shape(fieldMetaPropTypes).isRequired
};

var fieldArrayPropTypes = {
  fields: shape(fieldArrayFieldsPropTypes).isRequired,
  meta: shape(fieldArrayMetaPropTypes).isRequired
};

/* unused harmony default export */ var _unused_webpack_default_export = (formPropTypes);

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createField__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createField__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedField__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__structure_plain__ = __webpack_require__(19);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var createField = function createField(structure) {
  var ConnectedField = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedField__["a" /* default */])(structure);

  var setIn = structure.setIn;

  var Field = function (_Component) {
    _inherits(Field, _Component);

    function Field(props, context) {
      _classCallCheck(this, Field);

      var _this = _possibleConstructorReturn(this, (Field.__proto__ || Object.getPrototypeOf(Field)).call(this, props, context));

      _this.saveRef = function (ref) {
        return _this.ref = ref;
      };

      _this.normalize = function (name, value) {
        var normalize = _this.props.normalize;

        if (!normalize) {
          return value;
        }
        var previousValues = _this.context._reduxForm.getValues();
        var previousValue = _this.value;
        var nextValues = setIn(previousValues, name, value);
        return normalize(value, previousValue, nextValues, previousValues);
      };

      if (!context._reduxForm) {
        throw new Error('Field must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(Field, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'Field', function () {
          return _this2.props.validate;
        }, function () {
          return _this2.props.warn;
        });
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps, nextState) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps, nextState);
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName ||
        // use deepEqual here because they could be a function or an array of functions
        !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.validate, nextProps.validate) || !__WEBPACK_IMPORTED_MODULE_7__structure_plain__["a" /* default */].deepEqual(this.props.warn, nextProps.warn)) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'Field', function () {
            return nextProps.validate;
          }, function () {
            return nextProps.warn;
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Field');
        return this.ref ? this.ref.getWrappedInstance().getRenderedComponent() : undefined;
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedField, _extends({}, this.props, {
          name: this.name,
          normalize: this.normalize,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.pristine;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().isPristine());
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref && this.ref.getWrappedInstance().getValue();
      }
    }]);

    return Field;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Field.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    normalize: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onBlur: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onFocus: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDragStart: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    onDrop: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
    immutableProps: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string)
  };
  Field.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Field);
  return Field;
};

/* harmony default export */ __webpack_exports__["a"] = (createField);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__ = __webpack_require__(351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__ = __webpack_require__(690);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isReactNative__ = __webpack_require__(353);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var propsToNotUpdateFor = ['_reduxForm'];

var isObject = function isObject(entity) {
  return entity && (typeof entity === 'undefined' ? 'undefined' : _typeof(entity)) === 'object';
};

var isFunction = function isFunction(entity) {
  return entity && typeof entity === 'function';
};

var eventPreventDefault = function eventPreventDefault(event) {
  if (isObject(event) && isFunction(event.preventDefault)) {
    event.preventDefault();
  }
};

var eventDataTransferGetData = function eventDataTransferGetData(event, key) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.getData)) {
    return event.dataTransfer.getData(key);
  }
};

var eventDataTransferSetData = function eventDataTransferSetData(event, key, value) {
  if (isObject(event) && isObject(event.dataTransfer) && isFunction(event.dataTransfer.setData)) {
    event.dataTransfer.setData(key, value);
  }
};

var createConnectedField = function createConnectedField(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn;

  var getSyncError = function getSyncError(syncErrors, name) {
    var error = __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name);
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return error && error._error ? error._error : error;
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedField = function (_Component) {
    _inherits(ConnectedField, _Component);

    function ConnectedField() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedField);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedField.__proto__ || Object.getPrototypeOf(ConnectedField)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        return _this.ref = ref;
      }, _this.isPristine = function () {
        return _this.props.pristine;
      }, _this.getValue = function () {
        return _this.props.value;
      }, _this.handleChange = function (event) {
        var _this$props = _this.props,
            name = _this$props.name,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            normalize = _this$props.normalize,
            onChange = _this$props.onChange,
            _reduxForm = _this$props._reduxForm,
            previousValue = _this$props.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        var defaultPrevented = false;
        if (onChange) {
          // Can't seem to find a way to extend Event in React Native,
          // thus I simply avoid adding preventDefault() in a RN environment
          // to prevent the following error:
          // `One of the sources for assign has an enumerable key on the prototype chain`
          // Reference: https://github.com/facebook/react-native/issues/5507
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onChange(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onChange(event, newValue, previousValue, name);
          }
        }
        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));

          // call post-change callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'change');
          }
        }
      }, _this.handleFocus = function (event) {
        var _this$props2 = _this.props,
            name = _this$props2.name,
            dispatch = _this$props2.dispatch,
            onFocus = _this$props2.onFocus,
            _reduxForm = _this$props2._reduxForm;


        var defaultPrevented = false;
        if (onFocus) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onFocus(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), name);
          } else {
            onFocus(event, name);
          }
        }

        if (!defaultPrevented) {
          dispatch(_reduxForm.focus(name));
        }
      }, _this.handleBlur = function (event) {
        var _this$props3 = _this.props,
            name = _this$props3.name,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            normalize = _this$props3.normalize,
            onBlur = _this$props3.onBlur,
            _reduxForm = _this$props3._reduxForm,
            _value = _this$props3._value,
            previousValue = _this$props3.value;

        var newValue = Object(__WEBPACK_IMPORTED_MODULE_4__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse, normalize: normalize });

        // for checkbox and radio, if the value property of checkbox or radio equals
        // the value passed by blur event, then fire blur action with previousValue.
        if (newValue === _value && _value !== undefined) {
          newValue = previousValue;
        }

        var defaultPrevented = false;
        if (onBlur) {
          if (!__WEBPACK_IMPORTED_MODULE_7__isReactNative__["a" /* default */]) {
            onBlur(_extends({}, event, {
              preventDefault: function preventDefault() {
                defaultPrevented = true;
                return eventPreventDefault(event);
              }
            }), newValue, previousValue, name);
          } else {
            onBlur(event, newValue, previousValue, name);
          }
        }

        if (!defaultPrevented) {
          // dispatch blur action
          dispatch(_reduxForm.blur(name, newValue));

          // call post-blur callback
          if (_reduxForm.asyncValidate) {
            _reduxForm.asyncValidate(name, newValue, 'blur');
          }
        }
      }, _this.handleDragStart = function (event) {
        var _this$props4 = _this.props,
            name = _this$props4.name,
            onDragStart = _this$props4.onDragStart,
            value = _this$props4.value;

        eventDataTransferSetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */], value == null ? '' : value);

        if (onDragStart) {
          onDragStart(event, name);
        }
      }, _this.handleDrop = function (event) {
        var _this$props5 = _this.props,
            name = _this$props5.name,
            dispatch = _this$props5.dispatch,
            onDrop = _this$props5.onDrop,
            _reduxForm = _this$props5._reduxForm,
            previousValue = _this$props5.value;

        var newValue = eventDataTransferGetData(event, __WEBPACK_IMPORTED_MODULE_5__util_eventConsts__["a" /* dataKey */]);

        var defaultPrevented = false;
        if (onDrop) {
          onDrop(_extends({}, event, {
            preventDefault: function preventDefault() {
              defaultPrevented = true;
              return eventPreventDefault(event);
            }
          }), newValue, previousValue, name);
        }

        if (!defaultPrevented) {
          // dispatch change action
          dispatch(_reduxForm.change(name, newValue));
          eventPreventDefault(event);
        }
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedField, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          if (~(nextProps.immutableProps || []).indexOf(prop)) {
            return _this2.props[prop] !== nextProps[prop];
          }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            normalize = _props.normalize,
            onBlur = _props.onBlur,
            onChange = _props.onChange,
            onFocus = _props.onFocus,
            onDragStart = _props.onDragStart,
            onDrop = _props.onDrop,
            immutableProps = _props.immutableProps,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'normalize', 'onBlur', 'onChange', 'onFocus', 'onDragStart', 'onDrop', 'immutableProps']);

        var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, rest, {
          form: _reduxForm.form,
          onBlur: this.handleBlur,
          onChange: this.handleChange,
          onDrop: this.handleDrop,
          onDragStart: this.handleDragStart,
          onFocus: this.handleFocus
        })),
            custom = _createFieldProps.custom,
            props = _objectWithoutProperties(_createFieldProps, ['custom']);

        if (withRef) {
          custom.ref = this.saveRef;
        }
        if (typeof component === 'string') {
          var input = props.input,
              meta = props.meta; // eslint-disable-line no-unused-vars
          // flatten input into other props

          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, input, custom));
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(component, _extends({}, props, custom));
        }
      }
    }]);

    return ConnectedField;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedField.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initialState = getIn(formState, 'initial.' + name);
    var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name),
      asyncValidating: getIn(formState, 'asyncValidating') === name,
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      initial: initial,
      value: value,
      _value: ownProps.value // save value passed in (for checkboxes)
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedField);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedField);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isEvent__ = __webpack_require__(352);



var getSelectedValues = function getSelectedValues(options) {
  var result = [];
  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];
      if (option.selected) {
        result.push(option.value);
      }
    }
  }
  return result;
};

var getValue = function getValue(event, isReactNative) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__isEvent__["a" /* default */])(event)) {
    if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
      return event.nativeEvent.text;
    }
    if (isReactNative && event.nativeEvent !== undefined) {
      return event.nativeEvent.text;
    }
    var detypedEvent = event;
    var _detypedEvent$target = detypedEvent.target,
        type = _detypedEvent$target.type,
        value = _detypedEvent$target.value,
        checked = _detypedEvent$target.checked,
        files = _detypedEvent$target.files,
        dataTransfer = detypedEvent.dataTransfer;

    if (type === 'checkbox') {
      return !!checked;
    }
    if (type === 'file') {
      return files || dataTransfer && dataTransfer.files;
    }
    if (type === 'select-multiple') {
      return getSelectedValues(event.target.options);
    }
    return value;
  }
  return event;
};

/* harmony default export */ __webpack_exports__["a"] = (getValue);

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return dataKey; });
var dataKey = 'text';

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var splice = function splice(array, index, removeNum, value) {
  array = array || [];

  if (index < array.length) {
    if (value === undefined && !removeNum) {
      // inserting undefined
      var _copy2 = [].concat(_toConsumableArray(array));
      _copy2.splice(index, 0, true); // temporary placeholder
      _copy2[index] = undefined; // set to undefined
      return _copy2;
    }
    if (value != null) {
      var _copy3 = [].concat(_toConsumableArray(array));
      _copy3.splice(index, removeNum, value); // removing and adding
      return _copy3;
    }
    var _copy = [].concat(_toConsumableArray(array));
    _copy.splice(index, removeNum); // removing
    return _copy;
  }
  if (removeNum) {
    // trying to remove non-existant item: return original array
    return array;
  }
  // trying to add outside of range: just set value
  var copy = [].concat(_toConsumableArray(array));
  copy[index] = value;
  return copy;
};

/* harmony default export */ __webpack_exports__["a"] = (splice);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(162);



var getIn = function getIn(state, field) {
  if (!state) {
    return state;
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field);
  var length = path.length;
  if (!length) {
    return undefined;
  }

  var result = state;
  for (var i = 0; i < length && result; ++i) {
    result = result[path[i]];
  }

  return result;
};

/* harmony default export */ __webpack_exports__["a"] = (getIn);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__memoize_js__ = __webpack_require__(694);


/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__memoize_js__["a" /* default */])(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (memoizeCapped);


/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(232);


/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */]);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (memoize);


/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hash_js__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ListCache_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Map_js__ = __webpack_require__(234);




/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */],
    'map': new (__WEBPACK_IMPORTED_MODULE_2__Map_js__["a" /* default */] || __WEBPACK_IMPORTED_MODULE_1__ListCache_js__["a" /* default */]),
    'string': new __WEBPACK_IMPORTED_MODULE_0__Hash_js__["a" /* default */]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheClear);


/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hashClear_js__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hashGet_js__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hashHas_js__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hashSet_js__ = __webpack_require__(705);






/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = __WEBPACK_IMPORTED_MODULE_0__hashClear_js__["a" /* default */];
Hash.prototype['delete'] = __WEBPACK_IMPORTED_MODULE_1__hashDelete_js__["a" /* default */];
Hash.prototype.get = __WEBPACK_IMPORTED_MODULE_2__hashGet_js__["a" /* default */];
Hash.prototype.has = __WEBPACK_IMPORTED_MODULE_3__hashHas_js__["a" /* default */];
Hash.prototype.set = __WEBPACK_IMPORTED_MODULE_4__hashSet_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (Hash);


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(164);


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? Object(__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */])(null) : {};
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (hashClear);


/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isFunction_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isMasked_js__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObject_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toSource_js__ = __webpack_require__(357);





/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__isObject_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_1__isMasked_js__["a" /* default */])(value)) {
    return false;
  }
  var pattern = Object(__WEBPACK_IMPORTED_MODULE_0__isFunction_js__["a" /* default */])(value) ? reIsNative : reIsHostCtor;
  return pattern.test(Object(__WEBPACK_IMPORTED_MODULE_3__toSource_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsNative);


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__ = __webpack_require__(700);


/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(__WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */] && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys && __WEBPACK_IMPORTED_MODULE_0__coreJsData_js__["a" /* default */].keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/* harmony default export */ __webpack_exports__["a"] = (isMasked);


/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(63);


/** Used to detect overreaching core-js shims. */
var coreJsData = __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */]['__core-js_shared__'];

/* harmony default export */ __webpack_exports__["a"] = (coreJsData);


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/* harmony default export */ __webpack_exports__["a"] = (getValue);


/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (hashDelete);


/***/ }),
/* 703 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(164);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */]) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/* harmony default export */ __webpack_exports__["a"] = (hashGet);


/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(164);


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

/* harmony default export */ __webpack_exports__["a"] = (hashHas);


/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__ = __webpack_require__(164);


/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (__WEBPACK_IMPORTED_MODULE_0__nativeCreate_js__["a" /* default */] && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (hashSet);


/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheClear);


/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(166);


/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheDelete);


/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(166);


/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  return index < 0 ? undefined : data[index][1];
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheGet);


/***/ }),
/* 709 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(166);


/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(this.__data__, key) > -1;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheHas);


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__ = __webpack_require__(166);


/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = Object(__WEBPACK_IMPORTED_MODULE_0__assocIndexOf_js__["a" /* default */])(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (listCacheSet);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(167);


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheDelete);


/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/* harmony default export */ __webpack_exports__["a"] = (isKeyable);


/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(167);


/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheGet);


/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(167);


/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key).has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheHas);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getMapData_js__ = __webpack_require__(167);


/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = Object(__WEBPACK_IMPORTED_MODULE_0__getMapData_js__["a" /* default */])(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (mapCacheSet);


/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__arrayMap_js__ = __webpack_require__(354);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isSymbol_js__ = __webpack_require__(163);





/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return Object(__WEBPACK_IMPORTED_MODULE_1__arrayMap_js__["a" /* default */])(value, baseToString) + '';
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isSymbol_js__["a" /* default */])(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseToString);


/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(162);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setInWithPath = function setInWithPath(state, value, path, pathIndex) {
  if (pathIndex >= path.length) {
    return value;
  }

  var first = path[pathIndex];
  var firstState = state && (Array.isArray(state) ? state[Number(first)] : state[first]);
  var next = setInWithPath(firstState, value, path, pathIndex + 1);

  if (!state) {
    if (isNaN(first)) {
      return _defineProperty({}, first, next);
    }
    var initialized = [];
    initialized[parseInt(first, 10)] = next;
    return initialized;
  }

  if (Array.isArray(state)) {
    var copy = [].concat(state);
    copy[parseInt(first, 10)] = next;
    return copy;
  }

  return _extends({}, state, _defineProperty({}, first, next));
};

var setIn = function setIn(state, field, value) {
  return setInWithPath(state, value, Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field), 0);
};

/* harmony default export */ __webpack_exports__["a"] = (setIn);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




var customizer = function customizer(obj, other) {
  if (obj === other) return true;

  if (!obj && !other) {
    var objIsEmpty = obj === null || obj === undefined || obj === '';
    var otherIsEmpty = other === null || other === undefined || other === '';
    return objIsEmpty === otherIsEmpty;
  }

  if (obj && other && obj._error !== other._error) return false;
  if (obj && other && obj._warning !== other._warning) return false;
  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(obj) || __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(other)) return false;
};

var deepEqual = function deepEqual(a, b) {
  return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_isEqualWith__["a" /* default */])(a, b, customizer);
};

/* harmony default export */ __webpack_exports__["a"] = (deepEqual);

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__equalArrays_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__equalByTag_js__ = __webpack_require__(730);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalObjects_js__ = __webpack_require__(733);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__getTag_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isBuffer_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(171);









/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(object),
      othIsArr = Object(__WEBPACK_IMPORTED_MODULE_5__isArray_js__["a" /* default */])(other),
      objTag = objIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(object),
      othTag = othIsArr ? arrayTag : Object(__WEBPACK_IMPORTED_MODULE_4__getTag_js__["a" /* default */])(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(object)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_6__isBuffer_js__["a" /* default */])(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    return (objIsArr || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(object))
      ? Object(__WEBPACK_IMPORTED_MODULE_1__equalArrays_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack)
      : Object(__WEBPACK_IMPORTED_MODULE_2__equalByTag_js__["a" /* default */])(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
  return Object(__WEBPACK_IMPORTED_MODULE_3__equalObjects_js__["a" /* default */])(object, other, bitmask, customizer, equalFunc, stack);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsEqualDeep);


/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(165);


/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */];
  this.size = 0;
}

/* harmony default export */ __webpack_exports__["a"] = (stackClear);


/***/ }),
/* 721 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (stackDelete);


/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackGet);


/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (stackHas);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListCache_js__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Map_js__ = __webpack_require__(234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MapCache_js__ = __webpack_require__(232);




/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof __WEBPACK_IMPORTED_MODULE_0__ListCache_js__["a" /* default */]) {
    var pairs = data.__data__;
    if (!__WEBPACK_IMPORTED_MODULE_1__Map_js__["a" /* default */] || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new __WEBPACK_IMPORTED_MODULE_2__MapCache_js__["a" /* default */](pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (stackSet);


/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MapCache_js__ = __webpack_require__(232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__ = __webpack_require__(726);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__ = __webpack_require__(727);




/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new __WEBPACK_IMPORTED_MODULE_0__MapCache_js__["a" /* default */];
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = __WEBPACK_IMPORTED_MODULE_1__setCacheAdd_js__["a" /* default */];
SetCache.prototype.has = __WEBPACK_IMPORTED_MODULE_2__setCacheHas_js__["a" /* default */];

/* harmony default export */ __webpack_exports__["a"] = (SetCache);


/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheAdd);


/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

/* harmony default export */ __webpack_exports__["a"] = (setCacheHas);


/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (arraySome);


/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

/* harmony default export */ __webpack_exports__["a"] = (cacheHas);


/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Symbol_js__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__ = __webpack_require__(361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eq_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__equalArrays_js__ = __webpack_require__(360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__setToArray_js__ = __webpack_require__(732);







/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_0__Symbol_js__["a" /* default */].prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](object), new __WEBPACK_IMPORTED_MODULE_1__Uint8Array_js__["a" /* default */](other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return Object(__WEBPACK_IMPORTED_MODULE_2__eq_js__["a" /* default */])(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = __WEBPACK_IMPORTED_MODULE_4__mapToArray_js__["a" /* default */];

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = __WEBPACK_IMPORTED_MODULE_5__setToArray_js__["a" /* default */]);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = Object(__WEBPACK_IMPORTED_MODULE_3__equalArrays_js__["a" /* default */])(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (equalByTag);


/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (mapToArray);


/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (setToArray);


/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__ = __webpack_require__(734);


/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(object),
      objLength = objProps.length,
      othProps = Object(__WEBPACK_IMPORTED_MODULE_0__getAllKeys_js__["a" /* default */])(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Assume cyclic values are equal.
  var stacked = stack.get(object);
  if (stacked && stack.get(other)) {
    return stacked == other;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (equalObjects);


/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__ = __webpack_require__(735);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__keys_js__ = __webpack_require__(236);




/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseGetAllKeys_js__["a" /* default */])(object, __WEBPACK_IMPORTED_MODULE_2__keys_js__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__getSymbols_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (getAllKeys);


/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayPush_js__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArray_js__ = __webpack_require__(58);



/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return Object(__WEBPACK_IMPORTED_MODULE_1__isArray_js__["a" /* default */])(object) ? result : Object(__WEBPACK_IMPORTED_MODULE_0__arrayPush_js__["a" /* default */])(result, symbolsFunc(object));
}

/* harmony default export */ __webpack_exports__["a"] = (baseGetAllKeys);


/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayPush);


/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__ = __webpack_require__(738);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__stubArray_js__ = __webpack_require__(739);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? __WEBPACK_IMPORTED_MODULE_1__stubArray_js__["a" /* default */] : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayFilter_js__["a" /* default */])(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

/* harmony default export */ __webpack_exports__["a"] = (getSymbols);


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (arrayFilter);


/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/* harmony default export */ __webpack_exports__["a"] = (stubArray);


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseTimes);


/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(88);



/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value) == argsTag;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsArguments);


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (stubFalse);


/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isLength_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__ = __webpack_require__(88);




/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isObjectLike_js__["a" /* default */])(value) &&
    Object(__WEBPACK_IMPORTED_MODULE_1__isLength_js__["a" /* default */])(value.length) && !!typedArrayTags[Object(__WEBPACK_IMPORTED_MODULE_0__baseGetTag_js__["a" /* default */])(value)];
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsTypedArray);


/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseUnary);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__ = __webpack_require__(337);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && __WEBPACK_IMPORTED_MODULE_0__freeGlobal_js__["a" /* default */].process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

/* harmony default export */ __webpack_exports__["a"] = (nodeUtil);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110)(module)))

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__overArg_js__ = __webpack_require__(339);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = Object(__WEBPACK_IMPORTED_MODULE_0__overArg_js__["a" /* default */])(Object.keys, Object);

/* harmony default export */ __webpack_exports__["a"] = (nativeKeys);


/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(63);



/* Built-in method references that are verified to be native. */
var DataView = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'DataView');

/* harmony default export */ __webpack_exports__["a"] = (DataView);


/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(63);



/* Built-in method references that are verified to be native. */
var Promise = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Promise');

/* harmony default export */ __webpack_exports__["a"] = (Promise);


/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(63);



/* Built-in method references that are verified to be native. */
var Set = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'Set');

/* harmony default export */ __webpack_exports__["a"] = (Set);


/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getNative_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__root_js__ = __webpack_require__(63);



/* Built-in method references that are verified to be native. */
var WeakMap = Object(__WEBPACK_IMPORTED_MODULE_0__getNative_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__root_js__["a" /* default */], 'WeakMap');

/* harmony default export */ __webpack_exports__["a"] = (WeakMap);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(162);


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function deleteInWithPath(state, first) {
  if (state === undefined || state === null || first === undefined || first === null) {
    return state;
  }

  for (var _len = arguments.length, rest = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    rest[_key - 2] = arguments[_key];
  }

  if (rest.length) {
    if (Array.isArray(state)) {
      if (isNaN(first)) {
        throw new Error('Must access array elements with a number, not "' + String(first) + '".');
      }
      var firstIndex = Number(first);
      if (firstIndex < state.length) {
        var result = deleteInWithPath.apply(undefined, [state && state[firstIndex]].concat(_toConsumableArray(rest)));
        if (result !== state[firstIndex]) {
          var copy = [].concat(_toConsumableArray(state));
          copy[firstIndex] = result;
          return copy;
        }
      }
      return state;
    }
    if (first in state) {
      var _result = deleteInWithPath.apply(undefined, [state && state[first]].concat(_toConsumableArray(rest)));
      return state[first] === _result ? state : _extends({}, state, _defineProperty({}, first, _result));
    }
    return state;
  }
  if (Array.isArray(state)) {
    if (isNaN(first)) {
      throw new Error('Cannot delete non-numerical index from an array. Given: "' + String(first));
    }
    var _firstIndex = Number(first);
    if (_firstIndex < state.length) {
      var _copy = [].concat(_toConsumableArray(state));
      _copy.splice(_firstIndex, 1);
      return _copy;
    }
    return state;
  }
  if (first in state) {
    var _copy2 = _extends({}, state);
    delete _copy2[first];
    return _copy2;
  }
  return state;
}

var deleteIn = function deleteIn(state, field) {
  return deleteInWithPath.apply(undefined, [state].concat(_toConsumableArray(Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(field))));
};

/* harmony default export */ __webpack_exports__["a"] = (deleteIn);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function keys(value) {
  if (!value) {
    return [];
  }

  if (Array.isArray(value)) {
    return value.map(function (i) {
      return i.name;
    });
  }

  return Object.keys(value);
}


/* harmony default export */ __webpack_exports__["a"] = (keys);

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFields__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFields__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFields__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__util_prefixName__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }











var validateNameProp = function validateNameProp(prop) {
  if (!prop) {
    return new Error('No "names" prop was specified <Fields/>');
  }
  if (!Array.isArray(prop) && !prop._isFieldArray) {
    return new Error('Invalid prop "names" supplied to <Fields/>. Must be either an array of strings or the fields array generated by FieldArray.');
  }
};

var createFields = function createFields(structure) {
  var ConnectedFields = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFields__["a" /* default */])(structure);

  var Fields = function (_Component) {
    _inherits(Fields, _Component);

    function Fields(props, context) {
      _classCallCheck(this, Fields);

      var _this = _possibleConstructorReturn(this, (Fields.__proto__ || Object.getPrototypeOf(Fields)).call(this, props, context));

      if (!context._reduxForm) {
        throw new Error('Fields must be inside a component decorated with reduxForm()');
      }
      var error = validateNameProp(props.names);
      if (error) {
        throw error;
      }
      return _this;
    }

    _createClass(Fields, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_shallowCompare__["a" /* default */])(this, nextProps);
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        var context = this.context;
        var register = context._reduxForm.register;

        this.names.forEach(function (name) {
          return register(name, 'Field');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        if (!__WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].deepEqual(this.props.names, nextProps.names)) {
          var context = this.context;
          var _context$_reduxForm = context._reduxForm,
              register = _context$_reduxForm.register,
              unregister = _context$_reduxForm.unregister;
          // unregister old name

          this.props.names.forEach(function (name) {
            return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
          });
          // register new name
          nextProps.names.forEach(function (name) {
            return register(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name), 'Field');
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        var context = this.context;
        var unregister = context._reduxForm.unregister;

        this.props.names.forEach(function (name) {
          return unregister(Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name));
        });
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to Fields');
        return this.refs.connected.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        var context = this.context;

        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFields, _extends({}, this.props, {
          names: this.props.names.map(function (name) {
            return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
          }),
          _reduxForm: this.context._reduxForm,
          ref: 'connected'
        }));
      }
    }, {
      key: 'names',
      get: function get() {
        var context = this.context;

        return this.props.names.map(function (name) {
          return Object(__WEBPACK_IMPORTED_MODULE_7__util_prefixName__["a" /* default */])(context, name);
        });
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.refs.connected.getWrappedInstance().isDirty();
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !this.dirty;
      }
    }, {
      key: 'values',
      get: function get() {
        return this.refs.connected && this.refs.connected.getWrappedInstance().getValues();
      }
    }]);

    return Fields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  Fields.propTypes = {
    names: function names(props, propName) {
      return validateNameProp(props[propName]);
    },
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    format: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    parse: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  Fields.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(Fields);
  return Fields;
};

/* harmony default export */ __webpack_exports__["a"] = (createFields);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__createFieldProps__ = __webpack_require__(350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__ = __webpack_require__(351);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









var propsToNotUpdateFor = ['_reduxForm'];

var createConnectedFields = function createConnectedFields(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;


  var getSyncError = function getSyncError(syncErrors, name) {
    // Because the error for this field might not be at a level in the error structure where
    // it can be set directly, it might need to be unwrapped from the _error property
    return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error') || __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].getIn(syncErrors, name);
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    var warning = getIn(syncWarnings, name);
    // Because the warning for this field might not be at a level in the warning structure where
    // it can be set directly, it might need to be unwrapped from the _warning property
    return warning && warning._warning ? warning._warning : warning;
  };

  var ConnectedFields = function (_React$Component) {
    _inherits(ConnectedFields, _React$Component);

    function ConnectedFields(props) {
      _classCallCheck(this, ConnectedFields);

      var _this = _possibleConstructorReturn(this, (ConnectedFields.__proto__ || Object.getPrototypeOf(ConnectedFields)).call(this, props));

      _this.onChangeFns = {};
      _this.onFocusFns = {};
      _this.onBlurFns = {};

      _this.prepareEventHandlers = function (_ref) {
        var names = _ref.names;
        return names.forEach(function (name) {
          _this.onChangeFns[name] = function (event) {
            return _this.handleChange(name, event);
          };
          _this.onFocusFns[name] = function () {
            return _this.handleFocus(name);
          };
          _this.onBlurFns[name] = function (event) {
            return _this.handleBlur(name, event);
          };
        });
      };

      _this.handleChange = function (name, event) {
        var _this$props = _this.props,
            dispatch = _this$props.dispatch,
            parse = _this$props.parse,
            _reduxForm = _this$props._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        dispatch(_reduxForm.change(name, value));

        // call post-change callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'change');
        }
      };

      _this.handleFocus = function (name) {
        var _this$props2 = _this.props,
            dispatch = _this$props2.dispatch,
            _reduxForm = _this$props2._reduxForm;

        dispatch(_reduxForm.focus(name));
      };

      _this.handleBlur = function (name, event) {
        var _this$props3 = _this.props,
            dispatch = _this$props3.dispatch,
            parse = _this$props3.parse,
            _reduxForm = _this$props3._reduxForm;

        var value = Object(__WEBPACK_IMPORTED_MODULE_5__events_onChangeValue__["a" /* default */])(event, { name: name, parse: parse });

        // dispatch blur action
        dispatch(_reduxForm.blur(name, value));

        // call post-blur callback
        if (_reduxForm.asyncValidate) {
          _reduxForm.asyncValidate(name, value, 'blur');
        }
      };

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      _this.prepareEventHandlers(props);
      return _this;
    }

    _createClass(ConnectedFields, [{
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps) {
        var _this2 = this;

        if (this.props.names !== nextProps.names && (size(this.props.names) !== size(nextProps.names) || nextProps.names.some(function (nextName) {
          return !_this2.props._fields[nextName];
        }))) {
          // names has changed. The cached event handlers need to be updated
          this.prepareEventHandlers(nextProps);
        }
      }
    }, {
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this3 = this;

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'isDirty',
      value: function isDirty() {
        var _fields = this.props._fields;

        return Object.keys(_fields).some(function (name) {
          return _fields[name].dirty;
        });
      }
    }, {
      key: 'getValues',
      value: function getValues() {
        var _fields = this.props._fields;

        return Object.keys(_fields).reduce(function (accumulator, name) {
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, name, _fields[name].value);
        }, {});
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _this4 = this;

        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            _fields = _props._fields,
            _reduxForm = _props._reduxForm,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', '_fields', '_reduxForm']);

        var sectionPrefix = _reduxForm.sectionPrefix,
            form = _reduxForm.form;

        var _Object$keys$reduce = Object.keys(_fields).reduce(function (accumulator, name) {
          var connectedProps = _fields[name];

          var _createFieldProps = Object(__WEBPACK_IMPORTED_MODULE_3__createFieldProps__["a" /* default */])(structure, name, _extends({}, connectedProps, rest, {
            form: form,
            onBlur: _this4.onBlurFns[name],
            onChange: _this4.onChangeFns[name],
            onFocus: _this4.onFocusFns[name]
          })),
              custom = _createFieldProps.custom,
              fieldProps = _objectWithoutProperties(_createFieldProps, ['custom']);

          accumulator.custom = custom;
          var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
          return __WEBPACK_IMPORTED_MODULE_4__structure_plain__["a" /* default */].setIn(accumulator, fieldName, fieldProps);
        }, {}),
            custom = _Object$keys$reduce.custom,
            props = _objectWithoutProperties(_Object$keys$reduce, ['custom']);

        if (withRef) {
          props.ref = this.saveRef;
        }

        return __WEBPACK_IMPORTED_MODULE_0_react__["createElement"](component, _extends({}, props, custom));
      }
    }]);

    return ConnectedFields;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ConnectedFields.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node]).isRequired,
    _fields: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired,
    props: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(function (state, ownProps) {
    var names = ownProps.names,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    return {
      _fields: names.reduce(function (accumulator, name) {
        var initialState = getIn(formState, 'initial.' + name);
        var initial = initialState !== undefined ? initialState : initialValues && getIn(initialValues, name);
        var value = getIn(formState, 'values.' + name);
        var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
        var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
        var submitting = getIn(formState, 'submitting');
        var pristine = value === initial;
        accumulator[name] = {
          asyncError: getIn(formState, 'asyncErrors.' + name),
          asyncValidating: getIn(formState, 'asyncValidating') === name,
          dirty: !pristine,
          initial: initial,
          pristine: pristine,
          state: getIn(formState, 'fields.' + name),
          submitError: getIn(formState, 'submitErrors.' + name),
          submitFailed: getIn(formState, 'submitFailed'),
          submitting: submitting,
          syncError: syncError,
          syncWarning: syncWarning,
          value: value,
          _value: ownProps.value // save value passed in (for checkboxes)
        };
        return accumulator;
      }, {})
    };
  }, undefined, undefined, { withRef: true });
  return connector(ConnectedFields);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFields);

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFieldArray__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFieldArray__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_prefixName__ = __webpack_require__(130);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var wrapError = function wrapError(fn, key) {
  return fn && function () {
    var validators = toArray(fn);
    for (var i = 0; i < validators.length; i++) {
      var result = validators[i].apply(validators, arguments);
      if (result) {
        return _defineProperty({}, key, result);
      }
    }
  };
};

var createFieldArray = function createFieldArray(structure) {
  var ConnectedFieldArray = Object(__WEBPACK_IMPORTED_MODULE_4__ConnectedFieldArray__["a" /* default */])(structure);

  var FieldArray = function (_Component) {
    _inherits(FieldArray, _Component);

    function FieldArray(props, context) {
      _classCallCheck(this, FieldArray);

      var _this = _possibleConstructorReturn(this, (FieldArray.__proto__ || Object.getPrototypeOf(FieldArray)).call(this, props, context));

      _this.saveRef = function (ref) {
        _this.ref = ref;
      };

      if (!context._reduxForm) {
        throw new Error('FieldArray must be inside a component decorated with reduxForm()');
      }
      return _this;
    }

    _createClass(FieldArray, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        var _this2 = this;

        this.context._reduxForm.register(this.name, 'FieldArray', function () {
          return wrapError(_this2.props.validate, '_error');
        }, function () {
          return wrapError(_this2.props.warn, '_warning');
        });
      }
    }, {
      key: 'componentWillReceiveProps',
      value: function componentWillReceiveProps(nextProps, nextContext) {
        var oldName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
        var newName = Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(nextContext, nextProps.name);

        if (oldName !== newName) {
          // unregister old name
          this.context._reduxForm.unregister(oldName);
          // register new name
          this.context._reduxForm.register(newName, 'FieldArray');
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        this.context._reduxForm.unregister(this.name);
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.props.withRef, 'If you want to access getRenderedComponent(), ' + 'you must specify a withRef prop to FieldArray');
        return this.ref && this.ref.getWrappedInstance().getRenderedComponent();
      }
    }, {
      key: 'render',
      value: function render() {
        return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ConnectedFieldArray, _extends({}, this.props, {
          name: this.name,
          _reduxForm: this.context._reduxForm,
          ref: this.saveRef
        }));
      }
    }, {
      key: 'name',
      get: function get() {
        return Object(__WEBPACK_IMPORTED_MODULE_5__util_prefixName__["a" /* default */])(this.context, this.props.name);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return !this.ref || this.ref.getWrappedInstance().dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return !!(this.ref && this.ref.getWrappedInstance().pristine);
      }
    }, {
      key: 'value',
      get: function get() {
        return this.ref ? this.ref.getWrappedInstance().value : undefined;
      }
    }]);

    return FieldArray;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  FieldArray.propTypes = {
    name: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.isRequired,
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    validate: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    warn: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func)]),
    withRef: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };
  FieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  Object(__WEBPACK_IMPORTED_MODULE_1_react_lifecycles_compat__["polyfill"])(FieldArray);
  return FieldArray;
};

/* harmony default export */ __webpack_exports__["a"] = (createFieldArray);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__ = __webpack_require__(773);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__structure_plain__ = __webpack_require__(19);


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }










var propsToNotUpdateFor = ['_reduxForm', 'value'];

var createConnectedFieldArray = function createConnectedFieldArray(structure) {
  var deepEqual = structure.deepEqual,
      getIn = structure.getIn,
      size = structure.size;

  var getSyncError = function getSyncError(syncErrors, name) {
    // For an array, the error can _ONLY_ be under _error.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return __WEBPACK_IMPORTED_MODULE_6__structure_plain__["a" /* default */].getIn(syncErrors, name + '._error');
  };

  var getSyncWarning = function getSyncWarning(syncWarnings, name) {
    // For an array, the warning can _ONLY_ be under _warning.
    // This is why this getSyncError is not the same as the
    // one in Field.
    return getIn(syncWarnings, name + '._warning');
  };

  var ConnectedFieldArray = function (_React$Component) {
    _inherits(ConnectedFieldArray, _React$Component);

    function ConnectedFieldArray() {
      var _ref;

      var _temp, _this, _ret;

      _classCallCheck(this, ConnectedFieldArray);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ConnectedFieldArray.__proto__ || Object.getPrototypeOf(ConnectedFieldArray)).call.apply(_ref, [this].concat(args))), _this), _this.saveRef = function (ref) {
        _this.ref = ref;
      }, _this.getValue = function (index) {
        return _this.props.value && getIn(_this.props.value, String(index));
      }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ConnectedFieldArray, [{
      key: 'shouldComponentUpdate',
      value: function shouldComponentUpdate(nextProps) {
        var _this2 = this;

        // Update if the elements of the value array was updated.
        var thisValue = this.props.value;
        var nextValue = nextProps.value;

        if (thisValue && nextValue) {
          var nextValueItemsSame = nextValue.every(function (val) {
            return ~thisValue.indexOf(val);
          });
          var nextValueItemsOrderChanged = nextValue.some(function (val, index) {
            return val !== thisValue[index];
          });
          if (thisValue.length !== nextValue.length || nextValueItemsSame && nextValueItemsOrderChanged || nextProps.rerenderOnEveryChange && thisValue.some(function (val, index) {
            return !deepEqual(val, nextValue[index]);
          })) {
            return true;
          }
        }

        var nextPropsKeys = Object.keys(nextProps);
        var thisPropsKeys = Object.keys(this.props);
        // if we have children, we MUST update in React 16
        // https://twitter.com/erikras/status/915866544558788608
        return !!(this.props.children || nextProps.children || nextPropsKeys.length !== thisPropsKeys.length || nextPropsKeys.some(function (prop) {
          // useful to debug rerenders
          // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
          //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
          // }
          return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this2.props[prop], nextProps[prop]);
        }));
      }
    }, {
      key: 'getRenderedComponent',
      value: function getRenderedComponent() {
        return this.ref;
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
            component = _props.component,
            withRef = _props.withRef,
            name = _props.name,
            _reduxForm = _props._reduxForm,
            validate = _props.validate,
            warn = _props.warn,
            rerenderOnEveryChange = _props.rerenderOnEveryChange,
            rest = _objectWithoutProperties(_props, ['component', 'withRef', 'name', '_reduxForm', 'validate', 'warn', 'rerenderOnEveryChange']);

        var props = Object(__WEBPACK_IMPORTED_MODULE_5__createFieldArrayProps__["a" /* default */])(structure, name, _reduxForm.form, _reduxForm.sectionPrefix, this.getValue, rest);
        if (withRef) {
          props.ref = this.saveRef;
        }
        return __WEBPACK_IMPORTED_MODULE_1_react__["createElement"](component, props);
      }
    }, {
      key: 'dirty',
      get: function get() {
        return this.props.dirty;
      }
    }, {
      key: 'pristine',
      get: function get() {
        return this.props.pristine;
      }
    }, {
      key: 'value',
      get: function get() {
        return this.props.value;
      }
    }]);

    return ConnectedFieldArray;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  ConnectedFieldArray.propTypes = {
    component: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node]).isRequired,
    props: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object,
    rerenderOnEveryChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool
  };

  ConnectedFieldArray.defaultProps = {
    rerenderOnEveryChange: false
  };

  ConnectedFieldArray.contextTypes = {
    _reduxForm: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.object
  };

  var connector = Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(function (state, ownProps) {
    var name = ownProps.name,
        _ownProps$_reduxForm = ownProps._reduxForm,
        initialValues = _ownProps$_reduxForm.initialValues,
        getFormState = _ownProps$_reduxForm.getFormState;

    var formState = getFormState(state);
    var initial = getIn(formState, 'initial.' + name) || initialValues && getIn(initialValues, name);
    var value = getIn(formState, 'values.' + name);
    var submitting = getIn(formState, 'submitting');
    var syncError = getSyncError(getIn(formState, 'syncErrors'), name);
    var syncWarning = getSyncWarning(getIn(formState, 'syncWarnings'), name);
    var pristine = deepEqual(value, initial);
    return {
      asyncError: getIn(formState, 'asyncErrors.' + name + '._error'),
      dirty: !pristine,
      pristine: pristine,
      state: getIn(formState, 'fields.' + name),
      submitError: getIn(formState, 'submitErrors.' + name + '._error'),
      submitFailed: getIn(formState, 'submitFailed'),
      submitting: submitting,
      syncError: syncError,
      syncWarning: syncWarning,
      value: value,
      length: size(value)
    };
  }, function (dispatch, ownProps) {
    var name = ownProps.name,
        _reduxForm = ownProps._reduxForm;
    var arrayInsert = _reduxForm.arrayInsert,
        arrayMove = _reduxForm.arrayMove,
        arrayPop = _reduxForm.arrayPop,
        arrayPush = _reduxForm.arrayPush,
        arrayRemove = _reduxForm.arrayRemove,
        arrayRemoveAll = _reduxForm.arrayRemoveAll,
        arrayShift = _reduxForm.arrayShift,
        arraySplice = _reduxForm.arraySplice,
        arraySwap = _reduxForm.arraySwap,
        arrayUnshift = _reduxForm.arrayUnshift;

    return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])({
      arrayInsert: arrayInsert,
      arrayMove: arrayMove,
      arrayPop: arrayPop,
      arrayPush: arrayPush,
      arrayRemove: arrayRemove,
      arrayRemoveAll: arrayRemoveAll,
      arrayShift: arrayShift,
      arraySplice: arraySplice,
      arraySwap: arraySwap,
      arrayUnshift: arrayUnshift
    }, function (actionCreator) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_redux__["b" /* bindActionCreators */])(actionCreator.bind(null, name), dispatch);
    });
  }, undefined, { withRef: true });
  return connector(ConnectedFieldArray);
};

/* harmony default export */ __webpack_exports__["a"] = (createConnectedFieldArray);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseFor_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(236);



/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && Object(__WEBPACK_IMPORTED_MODULE_0__baseFor_js__["a" /* default */])(object, iteratee, __WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseForOwn);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createBaseFor);


/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMatches_js__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__ = __webpack_require__(765);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__property_js__ = __webpack_require__(770);






/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */];
  }
  if (typeof value == 'object') {
    return Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value)
      ? Object(__WEBPACK_IMPORTED_MODULE_1__baseMatchesProperty_js__["a" /* default */])(value[0], value[1])
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseMatches_js__["a" /* default */])(value);
  }
  return Object(__WEBPACK_IMPORTED_MODULE_4__property_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (baseIteratee);


/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getMatchData_js__ = __webpack_require__(764);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__ = __webpack_require__(369);




/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = Object(__WEBPACK_IMPORTED_MODULE_1__getMatchData_js__["a" /* default */])(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__matchesStrictComparable_js__["a" /* default */])(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || Object(__WEBPACK_IMPORTED_MODULE_0__baseIsMatch_js__["a" /* default */])(object, source, matchData);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatches);


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__ = __webpack_require__(168);



/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */];
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? Object(__WEBPACK_IMPORTED_MODULE_1__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (baseIsMatch);


/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys_js__ = __webpack_require__(236);



/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = Object(__WEBPACK_IMPORTED_MODULE_1__keys_js__["a" /* default */])(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, Object(__WEBPACK_IMPORTED_MODULE_0__isStrictComparable_js__["a" /* default */])(value)];
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (getMatchData);


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__get_js__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hasIn_js__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isKey_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__ = __webpack_require__(368);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__toKey_js__ = __webpack_require__(132);








/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__isKey_js__["a" /* default */])(path) && Object(__WEBPACK_IMPORTED_MODULE_4__isStrictComparable_js__["a" /* default */])(srcValue)) {
    return Object(__WEBPACK_IMPORTED_MODULE_5__matchesStrictComparable_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_6__toKey_js__["a" /* default */])(path), srcValue);
  }
  return function(object) {
    var objValue = Object(__WEBPACK_IMPORTED_MODULE_1__get_js__["a" /* default */])(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? Object(__WEBPACK_IMPORTED_MODULE_2__hasIn_js__["a" /* default */])(object, path)
      : Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseMatchesProperty);


/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(370);


/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  return result === undefined ? defaultValue : result;
}

/* harmony default export */ __webpack_exports__["a"] = (get);


/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hasPath_js__ = __webpack_require__(769);



/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && Object(__WEBPACK_IMPORTED_MODULE_1__hasPath_js__["a" /* default */])(object, path, __WEBPACK_IMPORTED_MODULE_0__baseHasIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (hasIn);


/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

/* harmony default export */ __webpack_exports__["a"] = (baseHasIn);


/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__castPath_js__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArguments_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isIndex_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isLength_js__ = __webpack_require__(238);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__toKey_js__ = __webpack_require__(132);







/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = Object(__WEBPACK_IMPORTED_MODULE_0__castPath_js__["a" /* default */])(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = Object(__WEBPACK_IMPORTED_MODULE_5__toKey_js__["a" /* default */])(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && Object(__WEBPACK_IMPORTED_MODULE_4__isLength_js__["a" /* default */])(length) && Object(__WEBPACK_IMPORTED_MODULE_3__isIndex_js__["a" /* default */])(key, length) &&
    (Object(__WEBPACK_IMPORTED_MODULE_2__isArray_js__["a" /* default */])(object) || Object(__WEBPACK_IMPORTED_MODULE_1__isArguments_js__["a" /* default */])(object));
}

/* harmony default export */ __webpack_exports__["a"] = (hasPath);


/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseProperty_js__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isKey_js__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__toKey_js__ = __webpack_require__(132);





/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__isKey_js__["a" /* default */])(path) ? Object(__WEBPACK_IMPORTED_MODULE_0__baseProperty_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__toKey_js__["a" /* default */])(path)) : Object(__WEBPACK_IMPORTED_MODULE_1__basePropertyDeep_js__["a" /* default */])(path);
}

/* harmony default export */ __webpack_exports__["a"] = (property);


/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

/* harmony default export */ __webpack_exports__["a"] = (baseProperty);


/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseGet_js__ = __webpack_require__(370);


/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__baseGet_js__["a" /* default */])(object, path);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (basePropertyDeep);


/***/ }),
/* 773 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var createFieldArrayProps = function createFieldArrayProps(_ref2, name, form, sectionPrefix, getValue, _ref) {
  var getIn = _ref2.getIn;

  var arrayInsert = _ref.arrayInsert,
      arrayMove = _ref.arrayMove,
      arrayPop = _ref.arrayPop,
      arrayPush = _ref.arrayPush,
      arrayRemove = _ref.arrayRemove,
      arrayRemoveAll = _ref.arrayRemoveAll,
      arrayShift = _ref.arrayShift,
      arraySplice = _ref.arraySplice,
      arraySwap = _ref.arraySwap,
      arrayUnshift = _ref.arrayUnshift,
      asyncError = _ref.asyncError,
      dirty = _ref.dirty,
      length = _ref.length,
      pristine = _ref.pristine,
      submitError = _ref.submitError,
      state = _ref.state,
      submitFailed = _ref.submitFailed,
      submitting = _ref.submitting,
      syncError = _ref.syncError,
      syncWarning = _ref.syncWarning,
      value = _ref.value,
      props = _ref.props,
      rest = _objectWithoutProperties(_ref, ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncError', 'dirty', 'length', 'pristine', 'submitError', 'state', 'submitFailed', 'submitting', 'syncError', 'syncWarning', 'value', 'props']);

  var error = syncError || asyncError || submitError;
  var warning = syncWarning;
  var fieldName = sectionPrefix ? name.replace(sectionPrefix + '.', '') : name;
  var finalProps = _extends({
    fields: {
      _isFieldArray: true,
      forEach: function forEach(callback) {
        return (value || []).forEach(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      get: getValue,
      getAll: function getAll() {
        return value;
      },
      insert: arrayInsert,
      length: length,
      map: function map(callback) {
        return (value || []).map(function (item, index) {
          return callback(fieldName + '[' + index + ']', index, finalProps.fields);
        });
      },
      move: arrayMove,
      name: name,
      pop: function pop() {
        arrayPop();
        return getIn(value, String(length - 1));
      },
      push: arrayPush,
      reduce: function reduce(callback, initial) {
        return (value || []).reduce(function (accumulator, item, index) {
          return callback(accumulator, fieldName + '[' + index + ']', index, finalProps.fields);
        }, initial);
      },
      remove: arrayRemove,
      removeAll: arrayRemoveAll,
      shift: function shift() {
        arrayShift();
        return getIn(value, '0');
      },
      splice: arraySplice,
      swap: arraySwap,
      unshift: arrayUnshift
    },
    meta: {
      dirty: dirty,
      error: error,
      form: form,
      warning: warning,
      invalid: !!error,
      pristine: pristine,
      submitting: submitting,
      submitFailed: submitFailed,
      valid: !error
    }
  }, props, rest);
  return finalProps;
};


/* harmony default export */ __webpack_exports__["a"] = (createFieldArrayProps);

/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValueSelector__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);




var createFormValueSelector = function createFormValueSelector(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    __WEBPACK_IMPORTED_MODULE_0_invariant___default()(form, 'Form value must be specified');
    var nonNullGetFormState = getFormState || function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      __WEBPACK_IMPORTED_MODULE_0_invariant___default()(fields.length, 'No fields specified');
      return fields.length === 1 ? // only selecting one field, so return its value
      getIn(nonNullGetFormState(state), form + '.values.' + fields[0]) : // selecting many fields, so return an object of field values
      fields.reduce(function (accumulator, field) {
        var value = getIn(nonNullGetFormState(state), form + '.values.' + field);
        return value === undefined ? accumulator : __WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */].setIn(accumulator, field, value);
      }, {});
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createFormValueSelector);

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createFormValues__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__util_prefixName__ = __webpack_require__(130);




var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (firstArg) {
    for (var _len = arguments.length, rest = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    // create a class that reads current form name and creates a selector
    // return
    return function (Component) {
      var FormValues = function (_React$Component) {
        _inherits(FormValues, _React$Component);

        function FormValues(props, context) {
          _classCallCheck(this, FormValues);

          var _this = _possibleConstructorReturn(this, (FormValues.__proto__ || Object.getPrototypeOf(FormValues)).call(this, props, context));

          if (!context._reduxForm) {
            throw new Error('formValues() must be used inside a React tree decorated with reduxForm()');
          }
          _this.updateComponent(props);
          return _this;
        }

        _createClass(FormValues, [{
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(props) {
            if (typeof firstArg === 'function') {
              this.updateComponent(props);
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var Component = this.Component;

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component
            // so that the connected component updates props when sectionPrefix has changed
            , _extends({ sectionPrefix: this.context._reduxForm.sectionPrefix
            }, this.props));
          }
        }, {
          key: 'updateComponent',
          value: function updateComponent(props) {
            var valuesMap = void 0;
            var resolvedFirstArg = typeof firstArg === 'function' ? firstArg(props) : firstArg;
            if (typeof resolvedFirstArg === 'string') {
              valuesMap = rest.reduce(function (result, k) {
                result[k] = k;
                return result;
              }, _defineProperty({}, resolvedFirstArg, resolvedFirstArg));
            } else {
              valuesMap = resolvedFirstArg;
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_2_lodash_es_isEmpty__["a" /* default */])(valuesMap)) {
              // maybe that empty valuesMap is ok if firstArg is a function?
              // if this is the case, we probably should set this.Component = Component
              throw new Error('formValues(): You must specify values to get as formValues(name1, name2, ...) or formValues({propName1: propPath1, ...}) or formValues((props) => name) or formValues((props) => ({propName1: propPath1, ...}))');
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_isEqual__["a" /* default */])(valuesMap, this._valuesMap)) {
              // no change in valuesMap
              return;
            }
            this._valuesMap = valuesMap;
            this.setComponent();
          }
        }, {
          key: 'setComponent',
          value: function setComponent() {
            var _this2 = this;

            var formValuesSelector = function formValuesSelector(_, _ref2) {
              var sectionPrefix = _ref2.sectionPrefix;

              // Yes, we're only using connect() for listening to updates.
              // The second argument needs to be there so that connect calls
              // the selector when props change
              var getValues = _this2.context._reduxForm.getValues;

              var values = getValues();
              return Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_mapValues__["a" /* default */])(_this2._valuesMap, function (path) {
                return getIn(values, Object(__WEBPACK_IMPORTED_MODULE_6__util_prefixName__["a" /* default */])(_this2.context, path));
              });
            };
            this.Component = Object(__WEBPACK_IMPORTED_MODULE_5_react_redux__["b" /* connect */])(formValuesSelector, function () {
              return {};
            } // ignore dispatch
            )(function (_ref3) {
              var sectionPrefix = _ref3.sectionPrefix,
                  otherProps = _objectWithoutProperties(_ref3, ['sectionPrefix']);

              return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, otherProps);
            });
          }
        }]);

        return FormValues;
      }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

      FormValues.contextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object
      };
      return FormValues;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__ = __webpack_require__(168);


/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseIsEqual_js__["a" /* default */])(value, other);
}

/* harmony default export */ __webpack_exports__["a"] = (isEqual);


/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseKeys_js__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getTag_js__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isArguments_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isBuffer_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isPrototype_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__ = __webpack_require__(171);









/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_4__isArrayLike_js__["a" /* default */])(value) &&
      (Object(__WEBPACK_IMPORTED_MODULE_3__isArray_js__["a" /* default */])(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        Object(__WEBPACK_IMPORTED_MODULE_5__isBuffer_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_7__isTypedArray_js__["a" /* default */])(value) || Object(__WEBPACK_IMPORTED_MODULE_2__isArguments_js__["a" /* default */])(value))) {
    return !value.length;
  }
  var tag = Object(__WEBPACK_IMPORTED_MODULE_1__getTag_js__["a" /* default */])(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (Object(__WEBPACK_IMPORTED_MODULE_6__isPrototype_js__["a" /* default */])(value)) {
    return !Object(__WEBPACK_IMPORTED_MODULE_0__baseKeys_js__["a" /* default */])(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

/* harmony default export */ __webpack_exports__["a"] = (isEmpty);


/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormError__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormError = function createGetFormError(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.error');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormError);

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormNames__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function createGetFormNames(_ref) {
  var getIn = _ref.getIn,
      keys = _ref.keys;

  return function (getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return keys(nonNullGetFormState(state));
    };
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createGetFormNames);

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormValues = function createGetFormValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.values');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormValues);

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormInitialValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormInitialValues = function createGetFormInitialValues(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.initial');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormInitialValues);

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncErrors = function createGetFormSyncErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncErrors);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormMeta__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormMeta = function createGetFormMeta(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.fields') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormMeta);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__ = __webpack_require__(793);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormAsyncErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormAsyncErrors = function createGetFormAsyncErrors(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.asyncErrors');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormAsyncErrors);

/***/ }),
/* 794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSyncWarnings__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSyncWarnings = function createGetFormSyncWarnings(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.syncWarnings') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSyncWarnings);

/***/ }),
/* 796 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__ = __webpack_require__(797);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_getFormSubmitErrors__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createGetFormSubmitErrors = function createGetFormSubmitErrors(_ref) {
  var getIn = _ref.getIn,
      empty = _ref.empty;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return getIn(nonNullGetFormState(state), form + '.submitErrors') || empty;
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createGetFormSubmitErrors);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__ = __webpack_require__(799);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isAsyncValidating__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsAsyncValidating = function createIsAsyncValidating(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.asyncValidating');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsAsyncValidating);

/***/ }),
/* 800 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__ = __webpack_require__(801);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isDirty__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPristine__ = __webpack_require__(372);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }




var createIsDirty = function createIsDirty(structure) {
  return function (form, getFormState) {
    var isPristine = Object(__WEBPACK_IMPORTED_MODULE_0__isPristine__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      for (var _len = arguments.length, fields = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        fields[_key - 1] = arguments[_key];
      }

      return !isPristine.apply(undefined, [state].concat(_toConsumableArray(fields)));
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsDirty);

/***/ }),
/* 802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isInvalid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 803 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isValid__ = __webpack_require__(242);



var createIsInvalid = function createIsInvalid(structure) {
  return function (form, getFormState) {
    var isValid = Object(__WEBPACK_IMPORTED_MODULE_0__isValid__["a" /* default */])(structure)(form, getFormState);
    return function (state) {
      return !isValid(state);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsInvalid);

/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getErrorKeys = function getErrorKeys(name, type) {
  switch (type) {
    case 'Field':
      return [name, name + '._error'];
    case 'FieldArray':
      return [name + '._error'];
    default:
      throw new Error('Unknown field type');
  }
};


var createHasError = function createHasError(_ref) {
  var getIn = _ref.getIn;

  var hasError = function hasError(field, syncErrors, asyncErrors, submitErrors) {
    if (!syncErrors && !asyncErrors && !submitErrors) {
      return false;
    }

    var name = getIn(field, 'name');
    var type = getIn(field, 'type');
    return getErrorKeys(name, type).some(function (key) {
      return getIn(syncErrors, key) || getIn(asyncErrors, key) || getIn(submitErrors, key);
    });
  };
  return hasError;
};

/* harmony default export */ __webpack_exports__["a"] = (createHasError);

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__ = __webpack_require__(372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isPristine__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 806 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isValid__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isValid__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 807 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__ = __webpack_require__(808);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_isSubmitting__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitting');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createIsSubmitting);

/***/ }),
/* 809 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__ = __webpack_require__(810);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitSucceeded__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitSucceeded = function createHasSubmitSucceeded(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitSucceeded');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitSucceeded);

/***/ }),
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__selectors_hasSubmitFailed__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var createHasSubmitFailed = function createHasSubmitFailed(_ref) {
  var getIn = _ref.getIn;
  return function (form, getFormState) {
    return function (state) {
      var nonNullGetFormState = getFormState || function (state) {
        return getIn(state, 'form');
      };
      return !!getIn(nonNullGetFormState(state), form + '.submitFailed');
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createHasSubmitFailed);

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReduxForm__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReduxForm__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__ = __webpack_require__(815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__ = __webpack_require__(239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__asyncValidation__ = __webpack_require__(838);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__ = __webpack_require__(348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__ = __webpack_require__(839);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__generateValidator__ = __webpack_require__(840);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__handleSubmit__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__selectors_isValid__ = __webpack_require__(242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__structure_plain__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__ = __webpack_require__(843);



var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }



























var isClassComponent = function isClassComponent(Component) {
  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
};

// extract field-specific actions

var arrayInsert = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayInsert,
    arrayMove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayMove,
    arrayPop = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPop,
    arrayPush = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayPush,
    arrayRemove = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemove,
    arrayRemoveAll = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayRemoveAll,
    arrayShift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayShift,
    arraySplice = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySplice,
    arraySwap = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arraySwap,
    arrayUnshift = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].arrayUnshift,
    blur = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].blur,
    change = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].change,
    focus = __WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */].focus,
    formActions = _objectWithoutProperties(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */], ['arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'blur', 'change', 'focus']);

var arrayActions = {
  arrayInsert: arrayInsert,
  arrayMove: arrayMove,
  arrayPop: arrayPop,
  arrayPush: arrayPush,
  arrayRemove: arrayRemove,
  arrayRemoveAll: arrayRemoveAll,
  arrayShift: arrayShift,
  arraySplice: arraySplice,
  arraySwap: arraySwap,
  arrayUnshift: arrayUnshift
};

var propsToNotUpdateFor = [].concat(_toConsumableArray(Object.keys(__WEBPACK_IMPORTED_MODULE_10__actions__["a" /* default */])), ['array', 'asyncErrors', 'initialValues', 'syncErrors', 'syncWarnings', 'values', 'registeredFields']);

var checkSubmit = function checkSubmit(submit) {
  if (!submit || typeof submit !== 'function') {
    throw new Error('You must either pass handleSubmit() an onSubmit function or pass onSubmit as a prop');
  }
  return submit;
};

/**
 * The decorator that is the main API to redux-form
 */
var createReduxForm = function createReduxForm(structure) {
  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      setIn = structure.setIn,
      keys = structure.keys,
      fromJS = structure.fromJS;

  var isValid = Object(__WEBPACK_IMPORTED_MODULE_20__selectors_isValid__["a" /* default */])(structure);
  return function (initialConfig) {
    var config = _extends({
      touchOnBlur: true,
      touchOnChange: false,
      persistentSubmitErrors: false,
      destroyOnUnmount: true,
      shouldAsyncValidate: __WEBPACK_IMPORTED_MODULE_12__defaultShouldAsyncValidate__["a" /* default */],
      shouldValidate: __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */],
      shouldError: __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */],
      shouldWarn: __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */],
      enableReinitialize: false,
      keepDirtyOnReinitialize: false,
      updateUnregisteredFields: false,
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      },
      pure: true,
      forceUnregisterOnUnmount: false
    }, initialConfig);

    return function (WrappedComponent) {
      var Form = function (_Component) {
        _inherits(Form, _Component);

        function Form() {
          var _ref;

          var _temp, _this, _ret;

          _classCallCheck(this, Form);

          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Form.__proto__ || Object.getPrototypeOf(Form)).call.apply(_ref, [this].concat(args))), _this), _this.destroyed = false, _this.fieldCounts = {}, _this.fieldValidators = {}, _this.lastFieldValidatorKeys = [], _this.fieldWarners = {}, _this.lastFieldWarnerKeys = [], _this.innerOnSubmit = undefined, _this.submitPromise = undefined, _this.getValues = function () {
            return _this.props.values;
          }, _this.isValid = function () {
            return _this.props.valid;
          }, _this.isPristine = function () {
            return _this.props.pristine;
          }, _this.register = function (name, type, getValidator, getWarner) {
            var lastCount = _this.fieldCounts[name];
            var nextCount = (lastCount || 0) + 1;
            _this.fieldCounts[name] = nextCount;
            _this.props.registerField(name, type);
            if (getValidator) {
              _this.fieldValidators[name] = getValidator;
            }
            if (getWarner) {
              _this.fieldWarners[name] = getWarner;
            }
          }, _this.unregister = function (name) {
            var lastCount = _this.fieldCounts[name];
            if (lastCount === 1) delete _this.fieldCounts[name];else if (lastCount != null) _this.fieldCounts[name] = lastCount - 1;

            if (!_this.destroyed) {
              var _this$props = _this.props,
                  _destroyOnUnmount = _this$props.destroyOnUnmount,
                  _forceUnregisterOnUnmount = _this$props.forceUnregisterOnUnmount,
                  _unregisterField = _this$props.unregisterField;

              if (_destroyOnUnmount || _forceUnregisterOnUnmount) {
                _unregisterField(name, _destroyOnUnmount);
                if (!_this.fieldCounts[name]) {
                  delete _this.fieldValidators[name];
                  delete _this.fieldWarners[name];
                  _this.lastFieldValidatorKeys = _this.lastFieldValidatorKeys.filter(function (key) {
                    return key !== name;
                  });
                }
              } else {
                _unregisterField(name, false);
              }
            }
          }, _this.getFieldList = function (options) {
            var registeredFields = _this.props.registeredFields;
            var list = [];
            if (!registeredFields) {
              return list;
            }
            var keySeq = keys(registeredFields);
            if (options && options.excludeFieldArray) {
              keySeq = keySeq.filter(function (name) {
                return getIn(registeredFields, '[\'' + name + '\'].type') !== 'FieldArray';
              });
            }
            return fromJS(keySeq.reduce(function (acc, key) {
              acc.push(key);
              return acc;
            }, list));
          }, _this.getValidators = function () {
            var validators = {};
            Object.keys(_this.fieldValidators).forEach(function (name) {
              var validator = _this.fieldValidators[name]();
              if (validator) {
                validators[name] = validator;
              }
            });
            return validators;
          }, _this.generateValidator = function () {
            var validators = _this.getValidators();
            return Object.keys(validators).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(validators, structure) : undefined;
          }, _this.getWarners = function () {
            var warners = {};
            Object.keys(_this.fieldWarners).forEach(function (name) {
              var warner = _this.fieldWarners[name]();
              if (warner) {
                warners[name] = warner;
              }
            });
            return warners;
          }, _this.generateWarner = function () {
            var warners = _this.getWarners();
            return Object.keys(warners).length ? Object(__WEBPACK_IMPORTED_MODULE_18__generateValidator__["a" /* default */])(warners, structure) : undefined;
          }, _this.asyncValidate = function (name, value, trigger) {
            var _this$props2 = _this.props,
                asyncBlurFields = _this$props2.asyncBlurFields,
                asyncChangeFields = _this$props2.asyncChangeFields,
                asyncErrors = _this$props2.asyncErrors,
                asyncValidate = _this$props2.asyncValidate,
                dispatch = _this$props2.dispatch,
                initialized = _this$props2.initialized,
                pristine = _this$props2.pristine,
                shouldAsyncValidate = _this$props2.shouldAsyncValidate,
                startAsyncValidation = _this$props2.startAsyncValidation,
                stopAsyncValidation = _this$props2.stopAsyncValidation,
                syncErrors = _this$props2.syncErrors,
                values = _this$props2.values;

            var submitting = !name;

            var fieldNeedsValidation = function fieldNeedsValidation() {
              var fieldNeedsValidationForBlur = asyncBlurFields && name && ~asyncBlurFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var fieldNeedsValidationForChange = asyncChangeFields && name && ~asyncChangeFields.indexOf(name.replace(/\[[0-9]+\]/g, '[]'));
              var asyncValidateByDefault = !(asyncBlurFields || asyncChangeFields);

              return submitting || asyncValidateByDefault || (trigger === 'blur' ? fieldNeedsValidationForBlur : fieldNeedsValidationForChange);
            };

            if (asyncValidate) {
              var valuesToValidate = submitting ? values : setIn(values, name, value);
              var syncValidationPasses = submitting || !getIn(syncErrors, name);
              if (fieldNeedsValidation() && shouldAsyncValidate({
                asyncErrors: asyncErrors,
                initialized: initialized,
                trigger: submitting ? 'submit' : trigger,
                blurredField: name,
                pristine: pristine,
                syncValidationPasses: syncValidationPasses
              })) {
                return Object(__WEBPACK_IMPORTED_MODULE_11__asyncValidation__["a" /* default */])(function () {
                  return asyncValidate(valuesToValidate, dispatch, _this.props, name);
                }, startAsyncValidation, stopAsyncValidation, name);
              }
            }
          }, _this.submitCompleted = function (result) {
            delete _this.submitPromise;
            return result;
          }, _this.submitFailed = function (error) {
            delete _this.submitPromise;
            throw error;
          }, _this.listenToSubmit = function (promise) {
            if (!__WEBPACK_IMPORTED_MODULE_6_is_promise___default()(promise)) {
              return promise;
            }
            _this.submitPromise = promise;
            return promise.then(_this.submitCompleted, _this.submitFailed);
          }, _this.submit = function (submitOrEvent) {
            var _this$props3 = _this.props,
                onSubmit = _this$props3.onSubmit,
                blur = _this$props3.blur,
                change = _this$props3.change,
                dispatch = _this$props3.dispatch;


            if (!submitOrEvent || Object(__WEBPACK_IMPORTED_MODULE_16__events_silenceEvent__["a" /* default */])(submitOrEvent)) {
              // submitOrEvent is an event: fire submit if not already submitting
              if (!_this.submitPromise) {
                // avoid recursive stack trace if use Form with onSubmit as handleSubmit
                if (_this.innerOnSubmit && _this.innerOnSubmit !== _this.submit) {
                  // will call "submitOrEvent is the submit function" block below
                  return _this.innerOnSubmit();
                } else {
                  return _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(onSubmit), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
                }
              }
            } else {
              // submitOrEvent is the submit function: return deferred submit thunk
              return Object(__WEBPACK_IMPORTED_MODULE_17__events_silenceEvents__["a" /* default */])(function () {
                return !_this.submitPromise && _this.listenToSubmit(Object(__WEBPACK_IMPORTED_MODULE_19__handleSubmit__["a" /* default */])(checkSubmit(submitOrEvent), _extends({}, _this.props, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch)), _this.props.validExceptSubmit, _this.asyncValidate, _this.getFieldList({ excludeFieldArray: true })));
              });
            }
          }, _this.reset = function () {
            return _this.props.reset();
          }, _this.saveRef = function (ref) {
            _this.wrapped = ref;
          }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Form, [{
          key: 'getChildContext',
          value: function getChildContext() {
            var _this2 = this;

            return {
              _reduxForm: _extends({}, this.props, {
                getFormState: function getFormState(state) {
                  return getIn(_this2.props.getFormState(state), _this2.props.form);
                },
                asyncValidate: this.asyncValidate,
                getValues: this.getValues,
                sectionPrefix: undefined,
                register: this.register,
                unregister: this.unregister,
                registerInnerOnSubmit: function registerInnerOnSubmit(innerOnSubmit) {
                  return _this2.innerOnSubmit = innerOnSubmit;
                }
              })
            };
          }
        }, {
          key: 'initIfNeeded',
          value: function initIfNeeded(nextProps) {
            var enableReinitialize = this.props.enableReinitialize;

            if (nextProps) {
              if ((enableReinitialize || !nextProps.initialized) && !deepEqual(this.props.initialValues, nextProps.initialValues)) {
                var _keepDirty = nextProps.initialized && this.props.keepDirtyOnReinitialize;
                this.props.initialize(nextProps.initialValues, _keepDirty, {
                  keepValues: nextProps.keepValues,
                  lastInitialValues: this.props.initialValues,
                  updateUnregisteredFields: nextProps.updateUnregisteredFields
                });
              }
            } else if (this.props.initialValues && (!this.props.initialized || enableReinitialize)) {
              this.props.initialize(this.props.initialValues, this.props.keepDirtyOnReinitialize, {
                keepValues: this.props.keepValues,
                updateUnregisteredFields: this.props.updateUnregisteredFields
              });
            }
          }
        }, {
          key: 'updateSyncErrorsIfNeeded',
          value: function updateSyncErrorsIfNeeded(nextSyncErrors, nextError, lastSyncErrors) {
            var _props = this.props,
                error = _props.error,
                updateSyncErrors = _props.updateSyncErrors;

            var noErrors = (!lastSyncErrors || !Object.keys(lastSyncErrors).length) && !error;
            var nextNoErrors = (!nextSyncErrors || !Object.keys(nextSyncErrors).length) && !nextError;
            if (!(noErrors && nextNoErrors) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncErrors, nextSyncErrors) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(error, nextError))) {
              updateSyncErrors(nextSyncErrors, nextError);
            }
          }
        }, {
          key: 'clearSubmitPromiseIfNeeded',
          value: function clearSubmitPromiseIfNeeded(nextProps) {
            var submitting = this.props.submitting;

            if (this.submitPromise && submitting && !nextProps.submitting) {
              delete this.submitPromise;
            }
          }
        }, {
          key: 'submitIfNeeded',
          value: function submitIfNeeded(nextProps) {
            var _props2 = this.props,
                clearSubmit = _props2.clearSubmit,
                triggerSubmit = _props2.triggerSubmit;

            if (!triggerSubmit && nextProps.triggerSubmit) {
              clearSubmit();
              this.submit();
            }
          }
        }, {
          key: 'shouldErrorFunction',
          value: function shouldErrorFunction() {
            var _props3 = this.props,
                shouldValidate = _props3.shouldValidate,
                shouldError = _props3.shouldError;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldErrorOverridden = shouldError !== __WEBPACK_IMPORTED_MODULE_14__defaultShouldError__["a" /* default */];

            return shouldValidateOverridden && !shouldErrorOverridden ? shouldValidate : shouldError;
          }
        }, {
          key: 'validateIfNeeded',
          value: function validateIfNeeded(nextProps) {
            var _props4 = this.props,
                validate = _props4.validate,
                values = _props4.values;

            var shouldError = this.shouldErrorFunction();
            var fieldLevelValidate = this.generateValidator();
            if (validate || fieldLevelValidate) {
              var initialRender = nextProps === undefined;
              var fieldValidatorKeys = Object.keys(this.getValidators());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldValidatorKeys,
                fieldValidatorKeys: fieldValidatorKeys,
                structure: structure
              };

              if (shouldError(validateParams)) {
                var propsToValidate = initialRender || !nextProps ? this.props : nextProps;

                var _merge2 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(validate ? validate(propsToValidate.values, propsToValidate) || {} : {}, fieldLevelValidate ? fieldLevelValidate(propsToValidate.values, propsToValidate) || {} : {}),
                    _error = _merge2._error,
                    nextSyncErrors = _objectWithoutProperties(_merge2, ['_error']);

                this.lastFieldValidatorKeys = fieldValidatorKeys;
                this.updateSyncErrorsIfNeeded(nextSyncErrors, _error, propsToValidate.syncErrors);
              }
            } else {
              this.lastFieldValidatorKeys = [];
            }
          }
        }, {
          key: 'updateSyncWarningsIfNeeded',
          value: function updateSyncWarningsIfNeeded(nextSyncWarnings, nextWarning, lastSyncWarnings) {
            var _props5 = this.props,
                warning = _props5.warning,
                syncWarnings = _props5.syncWarnings,
                updateSyncWarnings = _props5.updateSyncWarnings;

            var noWarnings = (!syncWarnings || !Object.keys(syncWarnings).length) && !warning;
            var nextNoWarnings = (!nextSyncWarnings || !Object.keys(nextSyncWarnings).length) && !nextWarning;
            if (!(noWarnings && nextNoWarnings) && (!__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(lastSyncWarnings, nextSyncWarnings) || !__WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].deepEqual(warning, nextWarning))) {
              updateSyncWarnings(nextSyncWarnings, nextWarning);
            }
          }
        }, {
          key: 'shouldWarnFunction',
          value: function shouldWarnFunction() {
            var _props6 = this.props,
                shouldValidate = _props6.shouldValidate,
                shouldWarn = _props6.shouldWarn;

            var shouldValidateOverridden = shouldValidate !== __WEBPACK_IMPORTED_MODULE_13__defaultShouldValidate__["a" /* default */];
            var shouldWarnOverridden = shouldWarn !== __WEBPACK_IMPORTED_MODULE_15__defaultShouldWarn__["a" /* default */];

            return shouldValidateOverridden && !shouldWarnOverridden ? shouldValidate : shouldWarn;
          }
        }, {
          key: 'warnIfNeeded',
          value: function warnIfNeeded(nextProps) {
            var _props7 = this.props,
                warn = _props7.warn,
                values = _props7.values;

            var shouldWarn = this.shouldWarnFunction();
            var fieldLevelWarn = this.generateWarner();
            if (warn || fieldLevelWarn) {
              var initialRender = nextProps === undefined;
              var fieldWarnerKeys = Object.keys(this.getWarners());
              var validateParams = {
                values: values,
                nextProps: nextProps,
                props: this.props,
                initialRender: initialRender,
                lastFieldValidatorKeys: this.lastFieldWarnerKeys,
                fieldValidatorKeys: fieldWarnerKeys,
                structure: structure
              };

              if (shouldWarn(validateParams)) {
                var propsToWarn = initialRender || !nextProps ? this.props : nextProps;

                var _merge3 = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_merge__["a" /* default */])(warn ? warn(propsToWarn.values, propsToWarn) : {}, fieldLevelWarn ? fieldLevelWarn(propsToWarn.values, propsToWarn) : {}),
                    _warning = _merge3._warning,
                    nextSyncWarnings = _objectWithoutProperties(_merge3, ['_warning']);

                this.lastFieldWarnerKeys = fieldWarnerKeys;
                this.updateSyncWarningsIfNeeded(nextSyncWarnings, _warning, propsToWarn.syncWarnings);
              }
            }
          }
        }, {
          key: 'componentWillMount',
          value: function componentWillMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded();
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillReceiveProps',
          value: function componentWillReceiveProps(nextProps) {
            this.initIfNeeded(nextProps);
            this.validateIfNeeded(nextProps);
            this.warnIfNeeded(nextProps);
            this.clearSubmitPromiseIfNeeded(nextProps);
            this.submitIfNeeded(nextProps);
            var onChange = nextProps.onChange,
                values = nextProps.values,
                dispatch = nextProps.dispatch;

            if (onChange && !deepEqual(values, this.props.values)) {
              onChange(values, dispatch, nextProps, this.props.values);
            }
          }
        }, {
          key: 'shouldComponentUpdate',
          value: function shouldComponentUpdate(nextProps) {
            var _this3 = this;

            if (!this.props.pure) return true;
            var _config$immutableProp = config.immutableProps,
                immutableProps = _config$immutableProp === undefined ? [] : _config$immutableProp;
            // if we have children, we MUST update in React 16
            // https://twitter.com/erikras/status/915866544558788608

            return !!(this.props.children || nextProps.children || Object.keys(nextProps).some(function (prop) {
              // useful to debug rerenders
              // if (!plain.deepEqual(this.props[ prop ], nextProps[ prop ])) {
              //   console.info(prop, 'changed', this.props[ prop ], '==>', nextProps[ prop ])
              // }
              if (~immutableProps.indexOf(prop)) {
                return _this3.props[prop] !== nextProps[prop];
              }
              return !~propsToNotUpdateFor.indexOf(prop) && !deepEqual(_this3.props[prop], nextProps[prop]);
            }));
          }
        }, {
          key: 'componentDidMount',
          value: function componentDidMount() {
            if (!Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.initIfNeeded(this.props);
              this.validateIfNeeded();
              this.warnIfNeeded();
            }
            __WEBPACK_IMPORTED_MODULE_5_invariant___default()(this.props.shouldValidate, 'shouldValidate() is deprecated and will be removed in v8.0.0. Use shouldWarn() or shouldError() instead.');
          }
        }, {
          key: 'componentWillUnmount',
          value: function componentWillUnmount() {
            var _props8 = this.props,
                destroyOnUnmount = _props8.destroyOnUnmount,
                destroy = _props8.destroy;

            if (destroyOnUnmount && !Object(__WEBPACK_IMPORTED_MODULE_23__util_isHotReloading__["a" /* default */])()) {
              this.destroyed = true;
              destroy();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            // remove some redux-form config-only props
            /* eslint-disable no-unused-vars */
            var _props9 = this.props,
                anyTouched = _props9.anyTouched,
                array = _props9.array,
                arrayInsert = _props9.arrayInsert,
                arrayMove = _props9.arrayMove,
                arrayPop = _props9.arrayPop,
                arrayPush = _props9.arrayPush,
                arrayRemove = _props9.arrayRemove,
                arrayRemoveAll = _props9.arrayRemoveAll,
                arrayShift = _props9.arrayShift,
                arraySplice = _props9.arraySplice,
                arraySwap = _props9.arraySwap,
                arrayUnshift = _props9.arrayUnshift,
                asyncErrors = _props9.asyncErrors,
                asyncValidate = _props9.asyncValidate,
                asyncValidating = _props9.asyncValidating,
                blur = _props9.blur,
                change = _props9.change,
                clearSubmit = _props9.clearSubmit,
                destroy = _props9.destroy,
                destroyOnUnmount = _props9.destroyOnUnmount,
                forceUnregisterOnUnmount = _props9.forceUnregisterOnUnmount,
                dirty = _props9.dirty,
                dispatch = _props9.dispatch,
                enableReinitialize = _props9.enableReinitialize,
                error = _props9.error,
                focus = _props9.focus,
                form = _props9.form,
                getFormState = _props9.getFormState,
                immutableProps = _props9.immutableProps,
                initialize = _props9.initialize,
                initialized = _props9.initialized,
                initialValues = _props9.initialValues,
                invalid = _props9.invalid,
                keepDirtyOnReinitialize = _props9.keepDirtyOnReinitialize,
                keepValues = _props9.keepValues,
                updateUnregisteredFields = _props9.updateUnregisteredFields,
                pristine = _props9.pristine,
                propNamespace = _props9.propNamespace,
                registeredFields = _props9.registeredFields,
                registerField = _props9.registerField,
                reset = _props9.reset,
                resetSection = _props9.resetSection,
                setSubmitFailed = _props9.setSubmitFailed,
                setSubmitSucceeded = _props9.setSubmitSucceeded,
                shouldAsyncValidate = _props9.shouldAsyncValidate,
                shouldValidate = _props9.shouldValidate,
                shouldError = _props9.shouldError,
                shouldWarn = _props9.shouldWarn,
                startAsyncValidation = _props9.startAsyncValidation,
                startSubmit = _props9.startSubmit,
                stopAsyncValidation = _props9.stopAsyncValidation,
                stopSubmit = _props9.stopSubmit,
                submitting = _props9.submitting,
                submitFailed = _props9.submitFailed,
                submitSucceeded = _props9.submitSucceeded,
                touch = _props9.touch,
                touchOnBlur = _props9.touchOnBlur,
                touchOnChange = _props9.touchOnChange,
                persistentSubmitErrors = _props9.persistentSubmitErrors,
                syncErrors = _props9.syncErrors,
                syncWarnings = _props9.syncWarnings,
                unregisterField = _props9.unregisterField,
                untouch = _props9.untouch,
                updateSyncErrors = _props9.updateSyncErrors,
                updateSyncWarnings = _props9.updateSyncWarnings,
                valid = _props9.valid,
                validExceptSubmit = _props9.validExceptSubmit,
                values = _props9.values,
                warning = _props9.warning,
                rest = _objectWithoutProperties(_props9, ['anyTouched', 'array', 'arrayInsert', 'arrayMove', 'arrayPop', 'arrayPush', 'arrayRemove', 'arrayRemoveAll', 'arrayShift', 'arraySplice', 'arraySwap', 'arrayUnshift', 'asyncErrors', 'asyncValidate', 'asyncValidating', 'blur', 'change', 'clearSubmit', 'destroy', 'destroyOnUnmount', 'forceUnregisterOnUnmount', 'dirty', 'dispatch', 'enableReinitialize', 'error', 'focus', 'form', 'getFormState', 'immutableProps', 'initialize', 'initialized', 'initialValues', 'invalid', 'keepDirtyOnReinitialize', 'keepValues', 'updateUnregisteredFields', 'pristine', 'propNamespace', 'registeredFields', 'registerField', 'reset', 'resetSection', 'setSubmitFailed', 'setSubmitSucceeded', 'shouldAsyncValidate', 'shouldValidate', 'shouldError', 'shouldWarn', 'startAsyncValidation', 'startSubmit', 'stopAsyncValidation', 'stopSubmit', 'submitting', 'submitFailed', 'submitSucceeded', 'touch', 'touchOnBlur', 'touchOnChange', 'persistentSubmitErrors', 'syncErrors', 'syncWarnings', 'unregisterField', 'untouch', 'updateSyncErrors', 'updateSyncWarnings', 'valid', 'validExceptSubmit', 'values', 'warning']);
            /* eslint-enable no-unused-vars */


            var reduxFormProps = _extends({
              array: array,
              anyTouched: anyTouched,
              asyncValidate: this.asyncValidate,
              asyncValidating: asyncValidating
            }, Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])({ blur: blur, change: change }, dispatch), {
              clearSubmit: clearSubmit,
              destroy: destroy,
              dirty: dirty,
              dispatch: dispatch,
              error: error,
              form: form,
              handleSubmit: this.submit,
              initialize: initialize,
              initialized: initialized,
              initialValues: initialValues,
              invalid: invalid,
              pristine: pristine,
              reset: reset,
              resetSection: resetSection,
              submitting: submitting,
              submitFailed: submitFailed,
              submitSucceeded: submitSucceeded,
              touch: touch,
              untouch: untouch,
              valid: valid,
              warning: warning
            });
            var propsToPass = _extends({}, propNamespace ? _defineProperty({}, propNamespace, reduxFormProps) : reduxFormProps, rest);
            if (isClassComponent(WrappedComponent)) {
              ;propsToPass.ref = this.saveRef;
            }
            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(WrappedComponent, propsToPass);
          }
        }]);

        return Form;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Form.displayName = 'Form(' + Object(__WEBPACK_IMPORTED_MODULE_22__util_getDisplayName__["a" /* default */])(WrappedComponent) + ')';
      Form.WrappedComponent = WrappedComponent;
      Form.childContextTypes = {
        _reduxForm: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object.isRequired
      };
      Form.propTypes = {
        destroyOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        forceUnregisterOnUnmount: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        form: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string.isRequired,
        immutableProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string),
        initialValues: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.array, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
        getFormState: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitFail: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        onSubmitSuccess: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        propNamespace: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
        validate: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        warn: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
        touchOnBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        touchOnChange: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        triggerSubmit: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        persistentSubmitErrors: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
        registeredFields: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any
      };

      var connector = Object(__WEBPACK_IMPORTED_MODULE_8_react_redux__["b" /* connect */])(function (state, props) {
        var form = props.form,
            getFormState = props.getFormState,
            initialValues = props.initialValues,
            enableReinitialize = props.enableReinitialize,
            keepDirtyOnReinitialize = props.keepDirtyOnReinitialize;

        var formState = getIn(getFormState(state) || empty, form) || empty;
        var stateInitial = getIn(formState, 'initial');
        var initialized = !!stateInitial;

        var shouldUpdateInitialValues = enableReinitialize && initialized && !deepEqual(initialValues, stateInitial);
        var shouldResetValues = shouldUpdateInitialValues && !keepDirtyOnReinitialize;

        var initial = initialValues || stateInitial || empty;

        if (shouldUpdateInitialValues) {
          initial = stateInitial || empty;
        }

        var values = getIn(formState, 'values') || initial;

        if (shouldResetValues) {
          values = initial;
        }

        var pristine = shouldResetValues || deepEqual(initial, values);
        var asyncErrors = getIn(formState, 'asyncErrors');
        var syncErrors = getIn(formState, 'syncErrors') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var syncWarnings = getIn(formState, 'syncWarnings') || __WEBPACK_IMPORTED_MODULE_21__structure_plain__["a" /* default */].empty;
        var registeredFields = getIn(formState, 'registeredFields');
        var valid = isValid(form, getFormState, false)(state);
        var validExceptSubmit = isValid(form, getFormState, true)(state);
        var anyTouched = !!getIn(formState, 'anyTouched');
        var submitting = !!getIn(formState, 'submitting');
        var submitFailed = !!getIn(formState, 'submitFailed');
        var submitSucceeded = !!getIn(formState, 'submitSucceeded');
        var error = getIn(formState, 'error');
        var warning = getIn(formState, 'warning');
        var triggerSubmit = getIn(formState, 'triggerSubmit');
        return {
          anyTouched: anyTouched,
          asyncErrors: asyncErrors,
          asyncValidating: getIn(formState, 'asyncValidating') || false,
          dirty: !pristine,
          error: error,
          initialized: initialized,
          invalid: !valid,
          pristine: pristine,
          registeredFields: registeredFields,
          submitting: submitting,
          submitFailed: submitFailed,
          submitSucceeded: submitSucceeded,
          syncErrors: syncErrors,
          syncWarnings: syncWarnings,
          triggerSubmit: triggerSubmit,
          values: values,
          valid: valid,
          validExceptSubmit: validExceptSubmit,
          warning: warning
        };
      }, function (dispatch, initialProps) {
        var bindForm = function bindForm(actionCreator) {
          return actionCreator.bind(null, initialProps.form);
        };

        // Bind the first parameter on `props.form`
        var boundFormACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(formActions, bindForm);
        var boundArrayACs = Object(__WEBPACK_IMPORTED_MODULE_1_lodash_es_mapValues__["a" /* default */])(arrayActions, bindForm);
        var boundBlur = function boundBlur(field, value) {
          return blur(initialProps.form, field, value, !!initialProps.touchOnBlur);
        };
        var boundChange = function boundChange(field, value) {
          return change(initialProps.form, field, value, !!initialProps.touchOnChange, !!initialProps.persistentSubmitErrors);
        };
        var boundFocus = bindForm(focus);

        // Wrap action creators with `dispatch`
        var connectedFormACs = Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundFormACs, dispatch);
        var connectedArrayACs = {
          insert: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayInsert, dispatch),
          move: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayMove, dispatch),
          pop: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPop, dispatch),
          push: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayPush, dispatch),
          remove: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemove, dispatch),
          removeAll: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayRemoveAll, dispatch),
          shift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayShift, dispatch),
          splice: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySplice, dispatch),
          swap: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arraySwap, dispatch),
          unshift: Object(__WEBPACK_IMPORTED_MODULE_9_redux__["b" /* bindActionCreators */])(boundArrayACs.arrayUnshift, dispatch)
        };

        var computedActions = _extends({}, connectedFormACs, boundArrayACs, {
          blur: boundBlur,
          change: boundChange,
          array: connectedArrayACs,
          focus: boundFocus,
          dispatch: dispatch
        });

        return function () {
          return computedActions;
        };
      }, undefined, { withRef: true });
      var ConnectedForm = __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(connector(Form), WrappedComponent);
      ConnectedForm.defaultProps = config;

      // build outer component to expose instance api

      var ReduxForm = function (_Component2) {
        _inherits(ReduxForm, _Component2);

        function ReduxForm() {
          _classCallCheck(this, ReduxForm);

          return _possibleConstructorReturn(this, (ReduxForm.__proto__ || Object.getPrototypeOf(ReduxForm)).apply(this, arguments));
        }

        _createClass(ReduxForm, [{
          key: 'submit',
          value: function submit() {
            return this.ref && this.ref.getWrappedInstance().submit();
          }
        }, {
          key: 'reset',
          value: function reset() {
            if (this.ref) {
              this.ref.getWrappedInstance().reset();
            }
          }
        }, {
          key: 'render',
          value: function render() {
            var _this5 = this;

            var _props10 = this.props,
                initialValues = _props10.initialValues,
                rest = _objectWithoutProperties(_props10, ['initialValues']);

            return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(ConnectedForm, _extends({}, rest, {
              ref: function ref(_ref3) {
                _this5.ref = _ref3;
              },
              // convert initialValues if need to
              initialValues: fromJS(initialValues)
            }));
          }
        }, {
          key: 'valid',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isValid());
          }
        }, {
          key: 'invalid',
          get: function get() {
            return !this.valid;
          }
        }, {
          key: 'pristine',
          get: function get() {
            return !!(this.ref && this.ref.getWrappedInstance().isPristine());
          }
        }, {
          key: 'dirty',
          get: function get() {
            return !this.pristine;
          }
        }, {
          key: 'values',
          get: function get() {
            return this.ref ? this.ref.getWrappedInstance().getValues() : empty;
          }
        }, {
          key: 'fieldList',
          get: function get() {
            // mainly provided for testing
            return this.ref ? this.ref.getWrappedInstance().getFieldList() : [];
          }
        }, {
          key: 'wrappedInstance',
          get: function get() {
            // for testing
            return this.ref && this.ref.getWrappedInstance().wrapped;
          }
        }]);

        return ReduxForm;
      }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

      Object(__WEBPACK_IMPORTED_MODULE_3_react_lifecycles_compat__["polyfill"])(ReduxForm);
      return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(ReduxForm, WrappedComponent);
    };
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createReduxForm);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseMerge_js__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createAssigner_js__ = __webpack_require__(829);



/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = Object(__WEBPACK_IMPORTED_MODULE_1__createAssigner_js__["a" /* default */])(function(object, source, srcIndex) {
  Object(__WEBPACK_IMPORTED_MODULE_0__baseMerge_js__["a" /* default */])(object, source, srcIndex);
});

/* harmony default export */ __webpack_exports__["a"] = (merge);


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stack_js__ = __webpack_require__(235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__baseFor_js__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__isObject_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__keysIn_js__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__safeGet_js__ = __webpack_require__(374);








/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  Object(__WEBPACK_IMPORTED_MODULE_2__baseFor_js__["a" /* default */])(source, function(srcValue, key) {
    stack || (stack = new __WEBPACK_IMPORTED_MODULE_0__Stack_js__["a" /* default */]);
    if (Object(__WEBPACK_IMPORTED_MODULE_4__isObject_js__["a" /* default */])(srcValue)) {
      Object(__WEBPACK_IMPORTED_MODULE_3__baseMergeDeep_js__["a" /* default */])(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(Object(__WEBPACK_IMPORTED_MODULE_6__safeGet_js__["a" /* default */])(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      Object(__WEBPACK_IMPORTED_MODULE_1__assignMergeValue_js__["a" /* default */])(object, key, newValue);
    }
  }, __WEBPACK_IMPORTED_MODULE_5__keysIn_js__["a" /* default */]);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMerge);


/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__copyArray_js__ = __webpack_require__(355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__ = __webpack_require__(821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__isArguments_js__ = __webpack_require__(169);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__isArray_js__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__isBuffer_js__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__isFunction_js__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__isObject_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__ = __webpack_require__(230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__safeGet_js__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__ = __webpack_require__(824);
















/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(object, key),
      srcValue = Object(__WEBPACK_IMPORTED_MODULE_13__safeGet_js__["a" /* default */])(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(srcValue),
        isBuff = !isArr && Object(__WEBPACK_IMPORTED_MODULE_8__isBuffer_js__["a" /* default */])(srcValue),
        isTyped = !isArr && !isBuff && Object(__WEBPACK_IMPORTED_MODULE_12__isTypedArray_js__["a" /* default */])(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (Object(__WEBPACK_IMPORTED_MODULE_6__isArray_js__["a" /* default */])(objValue)) {
        newValue = objValue;
      }
      else if (Object(__WEBPACK_IMPORTED_MODULE_7__isArrayLikeObject_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_3__copyArray_js__["a" /* default */])(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_1__cloneBuffer_js__["a" /* default */])(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = Object(__WEBPACK_IMPORTED_MODULE_2__cloneTypedArray_js__["a" /* default */])(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (Object(__WEBPACK_IMPORTED_MODULE_11__isPlainObject_js__["a" /* default */])(srcValue) || Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(srcValue)) {
      newValue = objValue;
      if (Object(__WEBPACK_IMPORTED_MODULE_5__isArguments_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_14__toPlainObject_js__["a" /* default */])(objValue);
      }
      else if (!Object(__WEBPACK_IMPORTED_MODULE_10__isObject_js__["a" /* default */])(objValue) || Object(__WEBPACK_IMPORTED_MODULE_9__isFunction_js__["a" /* default */])(objValue)) {
        newValue = Object(__WEBPACK_IMPORTED_MODULE_4__initCloneObject_js__["a" /* default */])(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  Object(__WEBPACK_IMPORTED_MODULE_0__assignMergeValue_js__["a" /* default */])(object, key, newValue);
}

/* harmony default export */ __webpack_exports__["a"] = (baseMergeDeep);


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__root_js__ = __webpack_require__(63);


/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? __WEBPACK_IMPORTED_MODULE_0__root_js__["a" /* default */].Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneBuffer);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110)(module)))

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__ = __webpack_require__(820);


/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? Object(__WEBPACK_IMPORTED_MODULE_0__cloneArrayBuffer_js__["a" /* default */])(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/* harmony default export */ __webpack_exports__["a"] = (cloneTypedArray);


/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__ = __webpack_require__(361);


/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](result).set(new __WEBPACK_IMPORTED_MODULE_0__Uint8Array_js__["a" /* default */](arrayBuffer));
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (cloneArrayBuffer);


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseCreate_js__ = __webpack_require__(822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getPrototype_js__ = __webpack_require__(338);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isPrototype_js__ = __webpack_require__(172);




/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !Object(__WEBPACK_IMPORTED_MODULE_2__isPrototype_js__["a" /* default */])(object))
    ? Object(__WEBPACK_IMPORTED_MODULE_0__baseCreate_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__getPrototype_js__["a" /* default */])(object))
    : {};
}

/* harmony default export */ __webpack_exports__["a"] = (initCloneObject);


/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(81);


/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

/* harmony default export */ __webpack_exports__["a"] = (baseCreate);


/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__ = __webpack_require__(88);



/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__isObjectLike_js__["a" /* default */])(value) && Object(__WEBPACK_IMPORTED_MODULE_0__isArrayLike_js__["a" /* default */])(value);
}

/* harmony default export */ __webpack_exports__["a"] = (isArrayLikeObject);


/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__copyObject_js__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keysIn_js__ = __webpack_require__(375);



/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__copyObject_js__["a" /* default */])(value, Object(__WEBPACK_IMPORTED_MODULE_1__keysIn_js__["a" /* default */])(value));
}

/* harmony default export */ __webpack_exports__["a"] = (toPlainObject);


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__assignValue_js__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__ = __webpack_require__(173);



/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      Object(__WEBPACK_IMPORTED_MODULE_1__baseAssignValue_js__["a" /* default */])(object, key, newValue);
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_0__assignValue_js__["a" /* default */])(object, key, newValue);
    }
  }
  return object;
}

/* harmony default export */ __webpack_exports__["a"] = (copyObject);


/***/ }),
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__eq_js__ = __webpack_require__(131);



/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && Object(__WEBPACK_IMPORTED_MODULE_1__eq_js__["a" /* default */])(objValue, value)) ||
      (value === undefined && !(key in object))) {
    Object(__WEBPACK_IMPORTED_MODULE_0__baseAssignValue_js__["a" /* default */])(object, key, value);
  }
}

/* harmony default export */ __webpack_exports__["a"] = (assignValue);


/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isObject_js__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isPrototype_js__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__ = __webpack_require__(828);




/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isObject_js__["a" /* default */])(object)) {
    return Object(__WEBPACK_IMPORTED_MODULE_2__nativeKeysIn_js__["a" /* default */])(object);
  }
  var isProto = Object(__WEBPACK_IMPORTED_MODULE_1__isPrototype_js__["a" /* default */])(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (baseKeysIn);


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (nativeKeysIn);


/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseRest_js__ = __webpack_require__(830);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__ = __webpack_require__(837);



/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__baseRest_js__["a" /* default */])(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && Object(__WEBPACK_IMPORTED_MODULE_1__isIterateeCall_js__["a" /* default */])(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

/* harmony default export */ __webpack_exports__["a"] = (createAssigner);


/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__identity_js__ = __webpack_require__(241);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__overRest_js__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__setToString_js__ = __webpack_require__(833);




/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return Object(__WEBPACK_IMPORTED_MODULE_2__setToString_js__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__overRest_js__["a" /* default */])(func, start, __WEBPACK_IMPORTED_MODULE_0__identity_js__["a" /* default */]), func + '');
}

/* harmony default export */ __webpack_exports__["a"] = (baseRest);


/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apply_js__ = __webpack_require__(832);


/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return Object(__WEBPACK_IMPORTED_MODULE_0__apply_js__["a" /* default */])(func, this, otherArgs);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (overRest);


/***/ }),
/* 832 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

/* harmony default export */ __webpack_exports__["a"] = (apply);


/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortOut_js__ = __webpack_require__(836);



/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = Object(__WEBPACK_IMPORTED_MODULE_1__shortOut_js__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0__baseSetToString_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (setToString);


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constant_js__ = __webpack_require__(835);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defineProperty_js__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__identity_js__ = __webpack_require__(241);




/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */] ? __WEBPACK_IMPORTED_MODULE_2__identity_js__["a" /* default */] : function(func, string) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__defineProperty_js__["a" /* default */])(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': Object(__WEBPACK_IMPORTED_MODULE_0__constant_js__["a" /* default */])(string),
    'writable': true
  });
};

/* harmony default export */ __webpack_exports__["a"] = (baseSetToString);


/***/ }),
/* 835 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (constant);


/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (shortOut);


/***/ }),
/* 837 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eq_js__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__isIndex_js__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__isObject_js__ = __webpack_require__(81);





/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_3__isObject_js__["a" /* default */])(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (Object(__WEBPACK_IMPORTED_MODULE_1__isArrayLike_js__["a" /* default */])(object) && Object(__WEBPACK_IMPORTED_MODULE_2__isIndex_js__["a" /* default */])(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__eq_js__["a" /* default */])(object[index], value);
  }
  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (isIterateeCall);


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);


var asyncValidation = function asyncValidation(fn, start, stop, field) {
  start(field);
  var promise = fn();
  if (!__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(promise)) {
    throw new Error('asyncValidate function passed to reduxForm must return a promise');
  }
  var handleErrors = function handleErrors(rejected) {
    return function (errors) {
      if (rejected) {
        if (errors && Object.keys(errors).length) {
          stop(errors);
          return errors;
        } else {
          stop();
          throw new Error('Asynchronous validation promise was rejected without errors.');
        }
      }
      stop();
      return Promise.resolve();
    };
  };
  return promise.then(handleErrors(false), handleErrors(true));
};

/* harmony default export */ __webpack_exports__["a"] = (asyncValidation);

/***/ }),
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__silenceEvent__ = __webpack_require__(376);


var silenceEvents = function silenceEvents(fn) {
  return function (event) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return Object(__WEBPACK_IMPORTED_MODULE_0__silenceEvent__["a" /* default */])(event) ? fn.apply(undefined, args) : fn.apply(undefined, [event].concat(args));
  };
};

/* harmony default export */ __webpack_exports__["a"] = (silenceEvents);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__structure_plain__ = __webpack_require__(19);



var toArray = function toArray(value) {
  return Array.isArray(value) ? value : [value];
};

var getError = function getError(value, values, props, validators, name) {
  var array = toArray(validators);
  for (var i = 0; i < array.length; i++) {
    var error = array[i](value, values, props, name);
    if (error) {
      return error;
    }
  }
};

var generateValidator = function generateValidator(validators, _ref) {
  var getIn = _ref.getIn;
  return function (values, props) {
    var errors = {};
    Object.keys(validators).forEach(function (name) {
      var value = getIn(values, name);
      var error = getError(value, values, props, validators[name], name);
      if (error) {
        errors = __WEBPACK_IMPORTED_MODULE_0__structure_plain__["a" /* default */].setIn(errors, name, error);
      }
    });
    return errors;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (generateValidator);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise__ = __webpack_require__(243);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SubmissionError__ = __webpack_require__(349);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }





var handleSubmit = function handleSubmit(submit, props, valid, asyncValidate, fields) {
  var dispatch = props.dispatch,
      onSubmitFail = props.onSubmitFail,
      onSubmitSuccess = props.onSubmitSuccess,
      startSubmit = props.startSubmit,
      stopSubmit = props.stopSubmit,
      setSubmitFailed = props.setSubmitFailed,
      setSubmitSucceeded = props.setSubmitSucceeded,
      syncErrors = props.syncErrors,
      asyncErrors = props.asyncErrors,
      touch = props.touch,
      values = props.values,
      persistentSubmitErrors = props.persistentSubmitErrors;


  touch.apply(undefined, _toConsumableArray(fields)); // mark all fields as touched

  if (valid || persistentSubmitErrors) {
    var doSubmit = function doSubmit() {
      var result = void 0;
      try {
        result = submit(values, dispatch, props);
      } catch (submitError) {
        var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
        stopSubmit(error);
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(error, dispatch, submitError, props);
        }
        if (error || onSubmitFail) {
          // if you've provided an onSubmitFail callback, don't re-throw the error
          return error;
        } else {
          throw submitError;
        }
      }
      if (__WEBPACK_IMPORTED_MODULE_0_is_promise___default()(result)) {
        startSubmit();
        return result.then(function (submitResult) {
          stopSubmit();
          setSubmitSucceeded();
          if (onSubmitSuccess) {
            onSubmitSuccess(submitResult, dispatch, props);
          }
          return submitResult;
        }, function (submitError) {
          var error = submitError instanceof __WEBPACK_IMPORTED_MODULE_1__SubmissionError__["a" /* default */] ? submitError.errors : undefined;
          stopSubmit(error);
          setSubmitFailed.apply(undefined, _toConsumableArray(fields));
          if (onSubmitFail) {
            onSubmitFail(error, dispatch, submitError, props);
          }
          if (error || onSubmitFail) {
            // if you've provided an onSubmitFail callback, don't re-throw the error
            return error;
          } else {
            throw submitError;
          }
        });
      } else {
        setSubmitSucceeded();
        if (onSubmitSuccess) {
          onSubmitSuccess(result, dispatch, props);
        }
      }
      return result;
    };

    var asyncValidateResult = asyncValidate && asyncValidate();
    if (asyncValidateResult) {
      return asyncValidateResult.then(function (asyncErrors) {
        if (asyncErrors) {
          throw asyncErrors;
        }
        return doSubmit();
      }).catch(function (asyncErrors) {
        setSubmitFailed.apply(undefined, _toConsumableArray(fields));
        if (onSubmitFail) {
          onSubmitFail(asyncErrors, dispatch, null, props);
        }
        return Promise.reject(asyncErrors);
      });
    } else {
      return doSubmit();
    }
  } else {
    setSubmitFailed.apply(undefined, _toConsumableArray(fields));
    var errors = _extends({}, asyncErrors, syncErrors);
    if (onSubmitFail) {
      onSubmitFail(errors, dispatch, null, props);
    }
    return errors;
  }
};

/* harmony default export */ __webpack_exports__["a"] = (handleSubmit);

/***/ }),
/* 842 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var getDisplayName = function getDisplayName(Comp) {
  return Comp.displayName || Comp.name || 'Component';
};


/* harmony default export */ __webpack_exports__["a"] = (getDisplayName);

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(module) {var isHotReloading = function isHotReloading() {
  return !!(typeof module !== 'undefined' && module.hot && typeof module.hot.status === 'function' && module.hot.status() === 'apply');
};

/* harmony default export */ __webpack_exports__["a"] = (isHotReloading);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110)(module)))

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createReducer__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__createReducer__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 845 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionTypes__ = __webpack_require__(231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__structure_plain__ = __webpack_require__(19);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






var shouldDelete = function shouldDelete(_ref) {
  var getIn = _ref.getIn;
  return function (state, path) {
    var initialValuesPath = null;

    if (path.startsWith('values')) {
      initialValuesPath = path.replace('values', 'initial');
    }

    var initialValueComparison = initialValuesPath ? getIn(state, initialValuesPath) === undefined : true;

    return getIn(state, path) !== undefined && initialValueComparison;
  };
};

var isReduxFormAction = function isReduxFormAction(action) {
  return action && action.type && action.type.length > __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length && action.type.substring(0, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"].length) === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["prefix"];
};

function createReducer(structure) {
  var _behaviors;

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      forEach = structure.forEach,
      getIn = structure.getIn,
      setIn = structure.setIn,
      deleteIn = structure.deleteIn,
      fromJS = structure.fromJS,
      keys = structure.keys,
      size = structure.size,
      some = structure.some,
      splice = structure.splice;

  var deleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(structure)(shouldDelete);
  var plainDeleteInWithCleanUp = Object(__WEBPACK_IMPORTED_MODULE_1__deleteInWithCleanUp__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */])(shouldDelete);
  var doSplice = function doSplice(state, key, field, index, removeNum, value, force) {
    var existing = getIn(state, key + '.' + field);
    return existing || force ? setIn(state, key + '.' + field, splice(existing, index, removeNum, value)) : state;
  };
  var doPlainSplice = function doPlainSplice(state, key, field, index, removeNum, value, force) {
    var slice = getIn(state, key);
    var existing = __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].getIn(slice, field);
    return existing || force ? setIn(state, key, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].setIn(slice, field, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].splice(existing, index, removeNum, value))) : state;
  };
  var rootKeys = ['values', 'fields', 'submitErrors', 'asyncErrors'];
  var arraySplice = function arraySplice(state, field, index, removeNum, value) {
    var result = state;
    var nonValuesValue = value != null ? empty : undefined;
    result = doSplice(result, 'values', field, index, removeNum, value, true);
    result = doSplice(result, 'fields', field, index, removeNum, nonValuesValue);
    result = doPlainSplice(result, 'syncErrors', field, index, removeNum, undefined);
    result = doPlainSplice(result, 'syncWarnings', field, index, removeNum, undefined);
    result = doSplice(result, 'submitErrors', field, index, removeNum, undefined);
    result = doSplice(result, 'asyncErrors', field, index, removeNum, undefined);
    return result;
  };

  var behaviors = (_behaviors = {}, _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_INSERT"], function (state, _ref2) {
    var _ref2$meta = _ref2.meta,
        field = _ref2$meta.field,
        index = _ref2$meta.index,
        payload = _ref2.payload;

    return arraySplice(state, field, index, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_MOVE"], function (state, _ref3) {
    var _ref3$meta = _ref3.meta,
        field = _ref3$meta.field,
        from = _ref3$meta.from,
        to = _ref3$meta.to;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    var result = state;
    if (length) {
      rootKeys.forEach(function (key) {
        var path = key + '.' + field;
        if (getIn(result, path)) {
          var value = getIn(result, path + '[' + from + ']');
          result = setIn(result, path, splice(getIn(result, path), from, 1)); // remove
          result = setIn(result, path, splice(getIn(result, path), to, 0, value)); // insert
        }
      });
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_POP"], function (state, _ref4) {
    var field = _ref4.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, length - 1, 1) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_PUSH"], function (state, _ref5) {
    var field = _ref5.meta.field,
        payload = _ref5.payload;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return arraySplice(state, field, length, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE"], function (state, _ref6) {
    var _ref6$meta = _ref6.meta,
        field = _ref6$meta.field,
        index = _ref6$meta.index;

    return arraySplice(state, field, index, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_REMOVE_ALL"], function (state, _ref7) {
    var field = _ref7.meta.field;

    var array = getIn(state, 'values.' + field);
    var length = array ? size(array) : 0;
    return length ? arraySplice(state, field, 0, length) : state;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SHIFT"], function (state, _ref8) {
    var field = _ref8.meta.field;

    return arraySplice(state, field, 0, 1);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SPLICE"], function (state, _ref9) {
    var _ref9$meta = _ref9.meta,
        field = _ref9$meta.field,
        index = _ref9$meta.index,
        removeNum = _ref9$meta.removeNum,
        payload = _ref9.payload;

    return arraySplice(state, field, index, removeNum, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_SWAP"], function (state, _ref10) {
    var _ref10$meta = _ref10.meta,
        field = _ref10$meta.field,
        indexA = _ref10$meta.indexA,
        indexB = _ref10$meta.indexB;

    var result = state;
    rootKeys.forEach(function (key) {
      var valueA = getIn(result, key + '.' + field + '[' + indexA + ']');
      var valueB = getIn(result, key + '.' + field + '[' + indexB + ']');
      if (valueA !== undefined || valueB !== undefined) {
        result = setIn(result, key + '.' + field + '[' + indexA + ']', valueB);
        result = setIn(result, key + '.' + field + '[' + indexB + ']', valueA);
      }
    });
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["ARRAY_UNSHIFT"], function (state, _ref11) {
    var field = _ref11.meta.field,
        payload = _ref11.payload;

    return arraySplice(state, field, 0, 0, payload);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["AUTOFILL"], function (state, _ref12) {
    var field = _ref12.meta.field,
        payload = _ref12.payload;

    var result = state;
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    result = setIn(result, 'fields.' + field + '.autofilled', true);
    result = setIn(result, 'values.' + field, payload);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["BLUR"], function (state, _ref13) {
    var _ref13$meta = _ref13.meta,
        field = _ref13$meta.field,
        touch = _ref13$meta.touch,
        payload = _ref13.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    if (field === getIn(result, 'active')) {
      result = deleteIn(result, 'active');
    }
    result = deleteIn(result, 'fields.' + field + '.active');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CHANGE"], function (state, _ref14) {
    var _ref14$meta = _ref14.meta,
        field = _ref14$meta.field,
        touch = _ref14$meta.touch,
        persistentSubmitErrors = _ref14$meta.persistentSubmitErrors,
        payload = _ref14.payload;

    var result = state;
    var initial = getIn(result, 'initial.' + field);
    if (initial === undefined && payload === '') {
      result = deleteInWithCleanUp(result, 'values.' + field);
    } else if (payload !== undefined) {
      result = setIn(result, 'values.' + field, payload);
    }
    result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
    if (!persistentSubmitErrors) {
      result = deleteInWithCleanUp(result, 'submitErrors.' + field);
    }
    result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
    if (touch) {
      result = setIn(result, 'fields.' + field + '.touched', true);
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT"], function (state) {
    return deleteIn(state, 'triggerSubmit');
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_SUBMIT_ERRORS"], function (state) {
    var result = state;
    result = deleteInWithCleanUp(result, 'submitErrors');
    result = deleteIn(result, 'error');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_ASYNC_ERROR"], function (state, _ref15) {
    var field = _ref15.meta.field;

    return deleteIn(state, 'asyncErrors.' + field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["CLEAR_FIELDS"], function (state, _ref16) {
    var _ref16$meta = _ref16.meta,
        keepTouched = _ref16$meta.keepTouched,
        persistentSubmitErrors = _ref16$meta.persistentSubmitErrors,
        fields = _ref16$meta.fields;

    var result = state;
    fields.forEach(function (field) {
      result = deleteInWithCleanUp(result, 'values.' + field);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + field);
      if (!persistentSubmitErrors) {
        result = deleteInWithCleanUp(result, 'submitErrors.' + field);
      }
      result = deleteInWithCleanUp(result, 'fields.' + field + '.autofilled');
      if (!keepTouched) {
        result = deleteIn(result, 'fields.' + field + '.touched');
      }
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["FOCUS"], function (state, _ref17) {
    var field = _ref17.meta.field;

    var result = state;
    var previouslyActive = getIn(state, 'active');
    result = deleteIn(result, 'fields.' + previouslyActive + '.active');
    result = setIn(result, 'fields.' + field + '.visited', true);
    result = setIn(result, 'fields.' + field + '.active', true);
    result = setIn(result, 'active', field);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["INITIALIZE"], function (state, _ref18) {
    var payload = _ref18.payload,
        _ref18$meta = _ref18.meta,
        keepDirty = _ref18$meta.keepDirty,
        keepSubmitSucceeded = _ref18$meta.keepSubmitSucceeded,
        updateUnregisteredFields = _ref18$meta.updateUnregisteredFields,
        keepValues = _ref18$meta.keepValues;

    var mapData = fromJS(payload);
    var result = empty; // clean all field state

    // persist old warnings, they will get recalculated if the new form values are different from the old values
    var warning = getIn(state, 'warning');
    if (warning) {
      result = setIn(result, 'warning', warning);
    }
    var syncWarnings = getIn(state, 'syncWarnings');
    if (syncWarnings) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    }

    // persist old errors, they will get recalculated if the new form values are different from the old values
    var error = getIn(state, 'error');
    if (error) {
      result = setIn(result, 'error', error);
    }
    var syncErrors = getIn(state, 'syncErrors');
    if (syncErrors) {
      result = setIn(result, 'syncErrors', syncErrors);
    }

    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }

    var previousValues = getIn(state, 'values');
    var previousInitialValues = getIn(state, 'initial');

    var newInitialValues = mapData;
    var newValues = previousValues;

    if (keepDirty && registeredFields) {
      if (!deepEqual(newInitialValues, previousInitialValues)) {
        //
        // Keep the value of dirty fields while updating the value of
        // pristine fields. This way, apps can reinitialize forms while
        // avoiding stomping on user edits.
        //
        // Note 1: The initialize action replaces all initial values
        // regardless of keepDirty.
        //
        // Note 2: When a field is dirty, keepDirty is enabled, and the field
        // value is the same as the new initial value for the field, the
        // initialize action causes the field to become pristine. That effect
        // is what we want.
        //
        var overwritePristineValue = function overwritePristineValue(name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          var previousValue = getIn(previousValues, name);

          if (deepEqual(previousValue, previousInitialValue)) {
            // Overwrite the old pristine value with the new pristine value
            var newInitialValue = getIn(newInitialValues, name);

            // This check prevents any 'setIn' call that would create useless
            // nested objects, since the path to the new field value would
            // evaluate to the same (especially for undefined values)
            if (getIn(newValues, name) !== newInitialValue) {
              newValues = setIn(newValues, name, newInitialValue);
            }
          }
        };

        if (!updateUnregisteredFields) {
          forEach(keys(registeredFields), function (name) {
            return overwritePristineValue(name);
          });
        }

        forEach(keys(newInitialValues), function (name) {
          var previousInitialValue = getIn(previousInitialValues, name);
          if (typeof previousInitialValue === 'undefined') {
            // Add new values at the root level.
            var newInitialValue = getIn(newInitialValues, name);
            newValues = setIn(newValues, name, newInitialValue);
          }

          if (updateUnregisteredFields) {
            overwritePristineValue(name);
          }
        });
      }
    } else {
      newValues = newInitialValues;
    }

    if (keepValues) {
      forEach(keys(previousValues), function (name) {
        var previousValue = getIn(previousValues, name);

        newValues = setIn(newValues, name, previousValue);
      });

      forEach(keys(previousInitialValues), function (name) {
        var previousInitialValue = getIn(previousInitialValues, name);

        newInitialValues = setIn(newInitialValues, name, previousInitialValue);
      });
    }

    if (keepSubmitSucceeded && getIn(state, 'submitSucceeded')) {
      result = setIn(result, 'submitSucceeded', true);
    }
    result = setIn(result, 'values', newValues);
    result = setIn(result, 'initial', newInitialValues);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["REGISTER_FIELD"], function (state, _ref19) {
    var _ref19$payload = _ref19.payload,
        name = _ref19$payload.name,
        type = _ref19$payload.type;

    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(state, key);
    if (field) {
      var count = getIn(field, 'count') + 1;
      field = setIn(field, 'count', count);
    } else {
      field = fromJS({ name: name, type: type, count: 1 });
    }
    return setIn(state, key, field);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET"], function (state) {
    var result = empty;
    var registeredFields = getIn(state, 'registeredFields');
    if (registeredFields) {
      result = setIn(result, 'registeredFields', registeredFields);
    }
    var values = getIn(state, 'initial');
    if (values) {
      result = setIn(result, 'values', values);
      result = setIn(result, 'initial', values);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["RESET_SECTION"], function (state, _ref20) {
    var sections = _ref20.meta.sections;

    var result = state;

    sections.forEach(function (section) {
      result = deleteInWithCleanUp(result, 'asyncErrors.' + section);
      result = deleteInWithCleanUp(result, 'submitErrors.' + section);
      result = deleteInWithCleanUp(result, 'fields.' + section);

      var values = getIn(state, 'initial.' + section);
      result = values ? setIn(result, 'values.' + section, values) : deleteInWithCleanUp(result, 'values.' + section);
    });

    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');

    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SUBMIT"], function (state) {
    return setIn(state, 'triggerSubmit', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_ASYNC_VALIDATION"], function (state, _ref21) {
    var field = _ref21.meta.field;

    return setIn(state, 'asyncValidating', field || true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["START_SUBMIT"], function (state) {
    return setIn(state, 'submitting', true);
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_ASYNC_VALIDATION"], function (state, _ref22) {
    var payload = _ref22.payload;

    var result = state;
    result = deleteIn(result, 'asyncValidating');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'asyncErrors', fromJS(fieldErrors));
      }
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'asyncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["STOP_SUBMIT"], function (state, _ref23) {
    var payload = _ref23.payload;

    var result = state;
    result = deleteIn(result, 'submitting');
    result = deleteIn(result, 'submitFailed');
    result = deleteIn(result, 'submitSucceeded');
    if (payload && Object.keys(payload).length) {
      var _error = payload._error,
          fieldErrors = _objectWithoutProperties(payload, ['_error']);

      if (_error) {
        result = setIn(result, 'error', _error);
      } else {
        result = deleteIn(result, 'error');
      }
      if (Object.keys(fieldErrors).length) {
        result = setIn(result, 'submitErrors', fromJS(fieldErrors));
      } else {
        result = deleteIn(result, 'submitErrors');
      }
      result = setIn(result, 'submitFailed', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'submitErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_FAILED"], function (state, _ref24) {
    var fields = _ref24.meta.fields;

    var result = state;
    result = setIn(result, 'submitFailed', true);
    result = deleteIn(result, 'submitSucceeded');
    result = deleteIn(result, 'submitting');
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    if (fields.length) {
      result = setIn(result, 'anyTouched', true);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["SET_SUBMIT_SUCCEEDED"], function (state) {
    var result = state;
    result = deleteIn(result, 'submitFailed');
    result = setIn(result, 'submitSucceeded', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["TOUCH"], function (state, _ref25) {
    var fields = _ref25.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = setIn(result, 'fields.' + field + '.touched', true);
    });
    result = setIn(result, 'anyTouched', true);
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNREGISTER_FIELD"], function (state, _ref26) {
    var _ref26$payload = _ref26.payload,
        name = _ref26$payload.name,
        destroyOnUnmount = _ref26$payload.destroyOnUnmount;

    var result = state;
    var key = 'registeredFields[\'' + name + '\']';
    var field = getIn(result, key);
    if (!field) {
      return result;
    }

    var count = getIn(field, 'count') - 1;
    if (count <= 0 && destroyOnUnmount) {
      // Note: Cannot use deleteWithCleanUp here because of the flat nature of registeredFields
      result = deleteIn(result, key);
      if (deepEqual(getIn(result, 'registeredFields'), empty)) {
        result = deleteIn(result, 'registeredFields');
      }
      var syncErrors = getIn(result, 'syncErrors');
      if (syncErrors) {
        syncErrors = plainDeleteInWithCleanUp(syncErrors, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncErrors, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncErrors');
        } else {
          result = setIn(result, 'syncErrors', syncErrors);
        }
      }
      var syncWarnings = getIn(result, 'syncWarnings');
      if (syncWarnings) {
        syncWarnings = plainDeleteInWithCleanUp(syncWarnings, name);
        if (__WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].deepEqual(syncWarnings, __WEBPACK_IMPORTED_MODULE_2__structure_plain__["a" /* default */].empty)) {
          result = deleteIn(result, 'syncWarnings');
        } else {
          result = setIn(result, 'syncWarnings', syncWarnings);
        }
      }
      result = deleteInWithCleanUp(result, 'submitErrors.' + name);
      result = deleteInWithCleanUp(result, 'asyncErrors.' + name);
    } else {
      field = setIn(field, 'count', count);
      result = setIn(result, key, field);
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UNTOUCH"], function (state, _ref27) {
    var fields = _ref27.meta.fields;

    var result = state;
    fields.forEach(function (field) {
      return result = deleteIn(result, 'fields.' + field + '.touched');
    });
    var anyTouched = some(keys(getIn(result, 'registeredFields')), function (key) {
      return getIn(result, 'fields.' + key + '.touched');
    });
    result = anyTouched ? setIn(result, 'anyTouched', true) : deleteIn(result, 'anyTouched');
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_ERRORS"], function (state, _ref28) {
    var _ref28$payload = _ref28.payload,
        syncErrors = _ref28$payload.syncErrors,
        error = _ref28$payload.error;

    var result = state;
    if (error) {
      result = setIn(result, 'error', error);
      result = setIn(result, 'syncError', true);
    } else {
      result = deleteIn(result, 'error');
      result = deleteIn(result, 'syncError');
    }
    if (Object.keys(syncErrors).length) {
      result = setIn(result, 'syncErrors', syncErrors);
    } else {
      result = deleteIn(result, 'syncErrors');
    }
    return result;
  }), _defineProperty(_behaviors, __WEBPACK_IMPORTED_MODULE_0__actionTypes__["UPDATE_SYNC_WARNINGS"], function (state, _ref29) {
    var _ref29$payload = _ref29.payload,
        syncWarnings = _ref29$payload.syncWarnings,
        warning = _ref29$payload.warning;

    var result = state;
    if (warning) {
      result = setIn(result, 'warning', warning);
    } else {
      result = deleteIn(result, 'warning');
    }
    if (Object.keys(syncWarnings).length) {
      result = setIn(result, 'syncWarnings', syncWarnings);
    } else {
      result = deleteIn(result, 'syncWarnings');
    }
    return result;
  }), _behaviors);

  var reducer = function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
    var action = arguments[1];

    var behavior = behaviors[action.type];
    return behavior ? behavior(state, action) : state;
  };

  var byForm = function byForm(reducer) {
    return function () {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
      var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

      var form = action && action.meta && action.meta.form;
      if (!form || !isReduxFormAction(action)) {
        return state;
      }
      if (action.type === __WEBPACK_IMPORTED_MODULE_0__actionTypes__["DESTROY"] && action.meta && action.meta.form) {
        return action.meta.form.reduce(function (result, form) {
          return deleteInWithCleanUp(result, form);
        }, state);
      }
      var formState = getIn(state, form);
      var result = reducer(formState, action);
      return result === formState ? state : setIn(state, form, result);
    };
  };

  /**
   * Adds additional functionality to the reducer
   */
  function decorate(target) {
    target.plugin = function (reducers) {
      var _this = this;

      // use 'function' keyword to enable 'this'
      return decorate(function () {
        var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : empty;
        var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : { type: 'NONE' };

        var callPlugin = function callPlugin(processed, key) {
          var previousState = getIn(processed, key);
          var nextState = reducers[key](previousState, action, getIn(state, key));
          return nextState !== previousState ? setIn(processed, key, nextState) : processed;
        };

        var processed = _this(state, action); // run through redux-form reducer
        var form = action && action.meta && action.meta.form;

        if (form) {
          // this is an action aimed at forms, so only give it to the specified form's plugin
          return reducers[form] ? callPlugin(processed, form) : processed;
        } else {
          // this is not a form-specific action, so send it to all the plugins
          return Object.keys(reducers).reduce(callPlugin, processed);
        }
      });
    };

    return target;
  }

  return decorate(byForm(reducer));
}

/* harmony default export */ __webpack_exports__["a"] = (createReducer);

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__ = __webpack_require__(162);



function createDeleteInWithCleanUp(structure) {
  var shouldDeleteDefault = function shouldDeleteDefault(structure) {
    return function (state, path) {
      return structure.getIn(state, path) !== undefined;
    };
  };

  var deepEqual = structure.deepEqual,
      empty = structure.empty,
      getIn = structure.getIn,
      deleteIn = structure.deleteIn,
      setIn = structure.setIn;


  return function () {
    var shouldDelete = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : shouldDeleteDefault;

    var deleteInWithCleanUp = function deleteInWithCleanUp(state, path) {
      if (path[path.length - 1] === ']') {
        // array path
        var pathTokens = Object(__WEBPACK_IMPORTED_MODULE_0_lodash_es_toPath__["a" /* default */])(path);
        pathTokens.pop();
        var parent = getIn(state, pathTokens.join('.'));
        return parent ? setIn(state, path) : state;
      }

      var result = state;

      if (shouldDelete(structure)(state, path)) {
        result = deleteIn(state, path);
      }

      var dotIndex = path.lastIndexOf('.');
      if (dotIndex > 0) {
        var parentPath = path.substring(0, dotIndex);
        if (parentPath[parentPath.length - 1] !== ']') {
          var _parent = getIn(result, parentPath);
          if (deepEqual(_parent, empty)) {
            return deleteInWithCleanUp(result, parentPath);
          }
        }
      }
      return result;
    };

    return deleteInWithCleanUp;
  };
}

/* harmony default export */ __webpack_exports__["a"] = (createDeleteInWithCleanUp);

/***/ }),
/* 847 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createValues__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__structure_plain__ = __webpack_require__(19);



/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_0__createValues__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_1__structure_plain__["a" /* default */]));

/***/ }),
/* 848 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_redux__ = __webpack_require__(18);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




var createValues = function createValues(_ref) {
  var getIn = _ref.getIn;
  return function (config) {
    var _prop$getFormState$co = _extends({
      prop: 'values',
      getFormState: function getFormState(state) {
        return getIn(state, 'form');
      }
    }, config),
        form = _prop$getFormState$co.form,
        prop = _prop$getFormState$co.prop,
        getFormState = _prop$getFormState$co.getFormState;

    return Object(__WEBPACK_IMPORTED_MODULE_0_react_redux__["b" /* connect */])(function (state) {
      return _defineProperty({}, prop, getIn(getFormState(state), form + '.values'));
    }
    // ignore dispatch
    );
  };
};

/* harmony default export */ __webpack_exports__["a"] = (createValues);

/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={login:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["b" /* ACT_AUTH_CHANGE */]){console.log("AUTH REDUCER",action.props);return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={loading:0,login:false,//cambiar esto a false
username:"Germán",//Limpiar
email:"german.dias@gmail.com",//Limpiar
rol:"administrador",//cambiar esto a vacío
active:false,permissions:{countries:"",benefit:"",products:""}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["a" /* ACT_APP_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={eventList:[],ticketList:{items:[],size:0},categoryList:[],stats:{},event:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["c" /* ACT_EVT_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={placeList:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["f" /* ACT_PLC_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={userList:{items:[],size:0}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["j" /* ACT_USR_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={rolList:[],rolesRedimidoresList:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["g" /* ACT_ROL_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={notificationList:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["d" /* ACT_NTF_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={noveltyList:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["e" /* ACT_NVT_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={tagList:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["i" /* ACT_TAG_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__ = __webpack_require__(30);
var initialState={statsByClient:[]};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];if(action.type===__WEBPACK_IMPORTED_MODULE_0__actions_ActionTypes__["h" /* ACT_STATS_CHANGE */]){return Object.assign({},state,action.props);}return state;});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Header_Header__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Body_Body__ = __webpack_require__(1158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb_Breadcrumb__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_login_LoginMain__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_AppMem__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_AppMem___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_AppMem__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_FaviconSelector__ = __webpack_require__(1543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__provider_base__ = __webpack_require__(1548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__provider_base___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__provider_base__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Home__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_PermIdentity__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_PermIdentity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_PermIdentity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Lock__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Lock___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Lock__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Notifications__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Assignment__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Assignment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Assignment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Place__ = __webpack_require__(1553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Place___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Place__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_BarChart__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ExitToApp__ = __webpack_require__(1554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ExitToApp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ExitToApp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_helmet__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_loading_overlay__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_react_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_react_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__actions_AuthActions__ = __webpack_require__(454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__config_RolesConstants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_DrawerVault_DrawerVault__ = __webpack_require__(1558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__App_css__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__App_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__App_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__config_Themes__ = __webpack_require__(1560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__common_ValidateAccess__ = __webpack_require__(1562);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var App=function(_Component){_inherits(App,_Component);function App(props){_classCallCheck(this,App);var _this=_possibleConstructorReturn(this,(App.__proto__||Object.getPrototypeOf(App)).call(this,props));_this.toggleLeftDrawer=function(){return _this.setState({openLeftDrawer:!_this.state.openLeftDrawer});};_this.Logout=function(){_this.setState({openLeftDrawer:!_this.state.openLeftDrawer});_this.props.actionLogOut();};_this.getItems=function(){return{events:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["d" /* EVENTS_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Eventos",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Home___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}}),users:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["E" /* USERS_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Usuarios",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_PermIdentity___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}}),roles:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["v" /* ROLES_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Roles",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Lock___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}}),notifications:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["p" /* NOTIFICATIONS_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Notificaciones",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Notifications___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}}),news:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["m" /* NEWS_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Novedades",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Assignment___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}}),statistics:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["w" /* STATISTICS_ROUTE */],onTouchTap:_this.toggleLeftDrawer,textoItem:"Estad\xEDsticas",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_BarChart___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}})};};_this.state={openLeftDrawer:false};_this.Logout=_this.Logout.bind(_this);_this.routes={home:{name:"Home",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["i" /* INDEX_ROUTE */]},events:{name:"Eventos",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["d" /* EVENTS_ROUTE */]},ticketTypes:{name:"Tipos de Ticket",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["A" /* TICKET_TYPES_ROUTE */]},tickets:{name:"Tickets",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["x" /* TICKETS_ROUTE */]},users:{name:"Usuarios",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["E" /* USERS_ROUTE */]},roles:{name:"Roles",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["v" /* ROLES_ROUTE */]},places:{name:"Ubicaciones",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["s" /* PLACES_ROUTE */]},statistics:{name:"Estadísticas por evento",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["h" /* EVENTS_STATISTICS_ROUTE */]},// rrpp: {name:"Vendidas por RRPP", path: STATISTICS_RRPP_ROUTE },
directRrpp:{name:"Ventas directa por RRPP",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["e" /* EVENTS_STATISTICS_DIRECT_RRPP_ROUTE */]},referencedRrpp:{name:"Ventas referidas por RRPP",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["g" /* EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE */]},producer:{name:"Ventas por productor",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["f" /* EVENTS_STATISTICS_PRODUCER_ROUTE */]},notification:{name:"Notificaciones",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["p" /* NOTIFICATIONS_ROUTE */]},news:{name:"Novedades",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["m" /* NEWS_ROUTE */]},stats:{name:"Estadísticas",path:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["w" /* STATISTICS_ROUTE */]}// this.LogoutSuccess = this.LogoutSuccess.bind(this);
};return _this;}_createClass(App,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;this.props.actionVerifyLogin(function(){return _this2.props.history.replace(__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);});}},{key:"addItem",//Productor, RRPP, Redimidor/Guardia, Default, Admin, SuperAdmin.
value:function addItem(items,item){if(!items.includes(item)){items.push(item);}}},{key:"addSuperAdminItems",value:function addSuperAdminItems(items,allItems){var all=Object.keys(allItems);for(var i=0;i<all.length;i++){this.addItem(items,allItems[all[i]]);}}},{key:"addAdminItems",value:function addAdminItems(items,allItems){this.addItem(items,allItems.users);this.addItem(items,allItems.roles);}},{key:"addRedimidorItems",value:function addRedimidorItems(items,allItems){this.addItem(items,allItems.events);}},{key:"addProductorItems",value:function addProductorItems(items,allItems){this.addItem(items,allItems.events);this.addItem(items,allItems.notifications);this.addItem(items,allItems.statistics);}},{key:"addRrppItems",value:function addRrppItems(items,allItems){//this.addItem(items, allItems.) Agregar items del menú a los que puede acceder el rol Rrpp
}},{key:"addDefaultItems",value:function addDefaultItems(items,allItems){//this.addItem(items, allItems.) Agregar items del menú a los que puede acceder el rol Default
}},{key:"renderItemsByRoles",value:function renderItemsByRoles(roles){//Devolver los items a agregar según los roles.
var items=[];if(roles){console.log("ROLES",roles);var allItems=this.getItems();for(var i=0;i<roles.length;i++){var rol=roles[i];switch(rol.id){case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.SUPERADMIN:this.addSuperAdminItems(items,allItems);break;case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.ADMIN:this.addAdminItems(items,allItems);break;case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.REDIMIDOR:this.addRedimidorItems(items,allItems);break;case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.PRODUCTOR:this.addProductorItems(items,allItems);break;case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.RRPP:this.addRrppItems(items,allItems);break;case __WEBPACK_IMPORTED_MODULE_24__config_RolesConstants___default.a.DEFAULT:this.addDefaultItems(items,allItems);break;default:console.log("ROL DESCONOCIDO",rol.id);}}}return items;}},{key:"renderHeader",value:function renderHeader(loggedIn,roles){var _this3=this;if(loggedIn){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_Header_Header__["a" /* default */],{leftIconClick:this.toggleLeftDrawer,hideDrawer:this.state.openLeftDrawer}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Breadcrumb_Breadcrumb__["a" /* default */],{routesInfo:this.routes,path:window.location.pathname,separatorStyle:{color:"#1bb6b1"}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__components_DrawerVault_DrawerVault__["a" /* default */],{username:this.props.username,email:this.props.email,isOpen:this.state.openLeftDrawer,onRequestChangeDrawer:function onRequestChangeDrawer(openLeftDrawer){return _this3.setState({openLeftDrawer:openLeftDrawer});},avatarSrc:this.props.photo||__webpack_require__(1563)},this.renderItemsByRoles(roles),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__components_DrawerVault_DrawerGroupItem__["a" /* default */],{toLink:__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["j" /* LOGIN_ROUTE */],onTouchTap:this.Logout,textoItem:"Cerrar sesi\xF3n",icon:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_ExitToApp___default.a,null),innerDivStyle:{padding:"0px 16px 0px 53px"}})));}}},{key:"render",value:function render(){var _props=this.props,loading=_props.loading,login=_props.login,profile=_props.profile,history=_props.history;if(login){var path=history.location.pathname;var isAuthorized=path==__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["D" /* UNAUTHORIZED_ROUTE */]||login&&Object(__WEBPACK_IMPORTED_MODULE_29__common_ValidateAccess__["a" /* validateAccess */])(profile&&profile.proRoles,path);console.log("HEADER",login,profile,isAuthorized,history.location.pathname);if(!isAuthorized){history.replace(__WEBPACK_IMPORTED_MODULE_23__config_RoutesConstants__["D" /* UNAUTHORIZED_ROUTE */]);}}return(// <div style={{ height: "100%" }}>
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["a" /* ThemeProvider */],{theme:__WEBPACK_IMPORTED_MODULE_28__config_Themes__["a" /* default */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_helmet__["a" /* Helmet */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link",{id:"favicon",rel:"icon",type:"image/x-icon",href:__WEBPACK_IMPORTED_MODULE_10__components_FaviconSelector__["a" /* default */],sizes:"16x16"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21_react_loading_overlay___default.a,{spinner:true,active:loading,text:"Loading...",style:{height:"100%"}},this.renderHeader(login,profile&&profile.proRoles),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_Body_Body__["a" /* default */],{style:__WEBPACK_IMPORTED_MODULE_28__config_Themes__["a" /* default */].routesContainer})))// </div>
);}}]);return App;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(store){return{login:store.auth.login,username:store.auth.username,email:store.auth.email,photo:store.auth.photo,profile:store.auth.profile,loading:store.app.loading};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_2_redux__["b" /* bindActionCreators */])({actionLogOut:__WEBPACK_IMPORTED_MODULE_22__actions_AuthActions__["a" /* actionLogOut */],actionVerifyLogin:__WEBPACK_IMPORTED_MODULE_22__actions_AuthActions__["c" /* actionVerifyLogin */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_3_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(App)));

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* harmony export (immutable) */ __webpack_exports__["a"] = deepmerge;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);


function isObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && !Array.isArray(item);
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(244);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(244);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.PropTypes.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createMixins;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


function createMixins(breakpoints, spacing, mixins) {
  var _toolbar;

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    gutters: function gutters() {
      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      // To deprecate in v4.1
      //       warning(
      //         false,
      //         [
      //           'Material-UI: theme.mixins.gutters() is deprecated.',
      //           'You can use the source of the mixin directly:',
      //           `
      // paddingLeft: theme.spacing(2),
      // paddingRight: theme.spacing(2),
      // [theme.breakpoints.up('sm')]: {
      //   paddingLeft: theme.spacing(3),
      //   paddingRight: theme.spacing(3),
      // },
      // `,
      //         ].join('\n'),
      //       );
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(2),
        paddingRight: spacing(2)
      }, styles, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        paddingLeft: spacing(3),
        paddingRight: spacing(3)
      }, styles[breakpoints.up('sm')])));
    },
    toolbar: (_toolbar = {
      minHeight: 56
    }, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
      minHeight: 48
    }), Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_toolbar, breakpoints.up('sm'), {
      minHeight: 64
    }), _toolbar)
  }, mixins);
}

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export light */
/* unused harmony export dark */
/* harmony export (immutable) */ __webpack_exports__["a"] = createPalette;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__colors_common__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__colors_grey__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__colors_indigo__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__colors_pink__ = __webpack_require__(382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__colors_red__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__colorManipulator__ = __webpack_require__(36);









var light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.54)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)',
    // Text hints.
    hint: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    default: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][50]
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.08)',
    hoverOpacity: 0.08,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.14)',
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)'
  }
};
var dark = {
  text: {
    primary: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    hint: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */][800],
    default: '#303030'
  },
  action: {
    active: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */].white,
    hover: 'rgba(255, 255, 255, 0.1)',
    hoverOpacity: 0.1,
    selected: 'rgba(255, 255, 255, 0.2)',
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)'
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = Object(__WEBPACK_IMPORTED_MODULE_8__colorManipulator__["e" /* lighten */])(intent.main, tonalOffset);
    } else if (direction === 'dark') {
      intent.dark = Object(__WEBPACK_IMPORTED_MODULE_8__colorManipulator__["a" /* darken */])(intent.main, tonalOffset * 1.5);
    }
  }
}

function createPalette(palette) {
  var _palette$primary = palette.primary,
      primary = _palette$primary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_5__colors_indigo__["a" /* default */][700]
  } : _palette$primary,
      _palette$secondary = palette.secondary,
      secondary = _palette$secondary === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A200,
    main: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A400,
    dark: __WEBPACK_IMPORTED_MODULE_6__colors_pink__["a" /* default */].A700
  } : _palette$secondary,
      _palette$error = palette.error,
      error = _palette$error === void 0 ? {
    light: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][300],
    main: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][500],
    dark: __WEBPACK_IMPORTED_MODULE_7__colors_red__["a" /* default */][700]
  } : _palette$error,
      _palette$type = palette.type,
      type = _palette$type === void 0 ? 'light' : _palette$type,
      _palette$contrastThre = palette.contrastThreshold,
      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
      _palette$tonalOffset = palette.tonalOffset,
      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(palette, ["primary", "secondary", "error", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54


  function getContrastText(background) {
    if (false) {
      if (!background) {
        console.error("Material-UI: missing background argument in getContrastText(".concat(background, ")."));
      }
    }

    var contrastText = Object(__WEBPACK_IMPORTED_MODULE_8__colorManipulator__["d" /* getContrastRatio */])(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    if (false) {
      var contrast = getContrastRatio(background, contrastText);

      if (contrast < 3) {
        console.error(["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WACG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
      }
    }

    return contrastText;
  }

  function augmentColor(color) {
    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
    color = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (false) {
      if (!color.main) {
        throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
      }
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  }

  var types = {
    dark: dark,
    light: light
  };

  if (false) {
    if (!types[type]) {
      console.error("Material-UI: the palette type `".concat(type, "` is not supported."));
    }
  }

  var paletteOutput = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // A collection of common colors.
    common: __WEBPACK_IMPORTED_MODULE_3__colors_common__["a" /* default */],
    // The palette type, can be light or dark.
    type: type,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor(primary),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor(error),
    // The grey colors.
    grey: __WEBPACK_IMPORTED_MODULE_4__colors_grey__["a" /* default */],
    // Used by `getContrastText()` to maximize the contrast between the background and
    // the text.
    contrastThreshold: contrastThreshold,
    // Take a background color and return the color of the text to maximize the contrast.
    getContrastText: getContrastText,
    // Generate a rich color object.
    augmentColor: augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: tonalOffset
  }, types[type]), other);
  return paletteOutput;
}

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createTypography;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(12);




function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var caseAllCaps = {
  textTransform: 'uppercase'
};
var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  var _ref = typeof typography === 'function' ? typography(palette) : typography,
      _ref$fontFamily = _ref.fontFamily,
      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
      _ref$fontWeightLight = _ref.fontWeightLight,
      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
      _ref$fontWeightRegula = _ref.fontWeightRegular,
      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
      _ref$fontWeightMedium = _ref.fontWeightMedium,
      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
      _ref$fontWeightBold = _ref.fontWeightBold,
      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
      _ref$htmlFontSize = _ref.htmlFontSize,
      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
      allVariants = _ref.allVariants,
      pxToRem2 = _ref.pxToRem,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);

  if (false) {
    if (typeof fontSize !== 'number') {
      console.error("Material-UI: 'fontSize' is required to be a number.");
    }

    if (typeof htmlFontSize !== 'number') {
      console.error("Material-UI: 'htmlFontSize' is required to be a number.");
    }
  }

  var coef = fontSize / 14;

  var pxToRem = pxToRem2 || function (size) {
    return "".concat(size / htmlFontSize * coef, "rem");
  };

  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      fontFamily: fontFamily,
      fontWeight: fontWeight,
      fontSize: pxToRem(size),
      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
      lineHeight: lineHeight
    }, fontFamily === defaultFontFamily ? {
      letterSpacing: "".concat(round(letterSpacing / size), "em")
    } : {}, {}, casing, {}, allVariants);
  };

  var variants = {
    h1: buildVariant(fontWeightLight, 96, 1, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.04, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.17, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.33, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFontSize: htmlFontSize,
    pxToRem: pxToRem,
    round: round,
    // TODO To remove in v5?
    fontFamily: fontFamily,
    fontSize: fontSize,
    fontWeightLight: fontWeightLight,
    fontWeightRegular: fontWeightRegular,
    fontWeightMedium: fontWeightMedium,
    fontWeightBold: fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shadowKeyUmbraOpacity = 0.2;
var shadowKeyPenumbraOpacity = 0.14;
var shadowAmbientShadowOpacity = 0.12;

function createShadow() {
  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
/* harmony default export */ __webpack_exports__["a"] = (shadows);

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var shape = {
  borderRadius: 4
};
/* harmony default export */ __webpack_exports__["a"] = (shape);

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createSpacing;
var warnOnce;
function createSpacing() {
  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // All components align to an 8dp square baseline grid for mobile, tablet, and desktop.
  // https://material.io/design/layout/understanding-layout.html#pixel-density


  var transform;

  if (typeof spacingInput === 'function') {
    transform = spacingInput;
  } else {
    if (false) {
      if (typeof spacingInput !== 'number') {
        console.error(["Material-UI: the `theme.spacing` value (".concat(spacingInput, ") is invalid."), 'It should be a number or a function.'].join('\n'));
      }
    }

    transform = function transform(factor) {
      if (false) {
        if (typeof factor !== 'number') {
          console.error("Expected spacing argument to be a number, got ".concat(factor));
        }
      }

      return spacingInput * factor;
    };
  }

  var spacing = function spacing() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (false) {
      if (!(args.length <= 4)) {
        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
      }
    }

    if (args.length === 0) {
      return transform(1);
    }

    if (args.length === 1) {
      return transform(args[0]);
    }

    return args.map(function (factor) {
      var output = transform(factor);
      return typeof output === 'number' ? "".concat(output, "px") : output;
    }).join(' ');
  }; // Backward compatibility, to remove in v5.


  Object.defineProperty(spacing, 'unit', {
    get: function get() {
      if (false) {
        if (!warnOnce || process.env.NODE_ENV === 'test') {
          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
        }

        warnOnce = true;
      }

      return spacingInput;
    }
  });
  spacing.mui = true;
  return spacing;
}

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(59);
 // let warnOnce = false;
// To remove in v5

function createStyles(styles) {
  // warning(
  //   warnOnce,
  //   [
  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
  //     'Please use @material-ui/styles/createStyles',
  //   ].join('\n'),
  // );
  // warnOnce = true;
  return Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["b" /* createStyles */])(styles);
}

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createGenerateClassName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__ = __webpack_require__(385);

/**
 * This is the list of the style rule name we use as drop in replacement for the built-in
 * pseudo classes (:checked, :disabled, :focused, etc.).
 *
 * Why do they exist in the first place?
 * These classes are used at a specificity of 2.
 * It allows them to override previously definied styles as well as
 * being untouched by simple user overrides.
 */

var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
// When new generator function is created, rule counter is reset.
// We need to reset the rule counter for SSR for each request.
//
// It's inspired by
// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js

function createGenerateClassName() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _options$disableGloba = options.disableGlobal,
      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
      _options$productionPr = options.productionPrefix,
      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
      _options$seed = options.seed,
      seed = _options$seed === void 0 ? '' : _options$seed;
  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
  var ruleCounter = 0;
  return function (rule, styleSheet) {
    ruleCounter += 1;

    if (false) {
      if (ruleCounter >= 1e10) {
        console.warn(['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
      }
    }

    var name = styleSheet.options.name; // Is a global static MUI style?

    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
      // We can use a shorthand class name, we never use the keys to style the components.
      if (pseudoClasses.indexOf(rule.key) !== -1) {
        return "Mui-".concat(rule.key);
      }

      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);

      if (!styleSheet.options.theme[__WEBPACK_IMPORTED_MODULE_0__ThemeProvider_nested__["a" /* default */]] || seed !== '') {
        return prefix;
      }

      return "".concat(prefix, "-").concat(ruleCounter);
    }

    if (true) {
      return "".concat(seedPrefix).concat(productionPrefix).concat(ruleCounter);
    }

    var suffix = "".concat(rule.key, "-").concat(ruleCounter); // Help with debuggability.

    if (styleSheet.options.classNamePrefix) {
      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
    }

    return "".concat(seedPrefix).concat(suffix);
  };
}

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__createStyles__ = __webpack_require__(876);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__createStyles__["a"]; });


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createStyles;
function createStyles(styles) {
  return styles;
}

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  var theme = params.theme,
      name = params.name,
      props = params.props;

  if (!theme || !theme.props || !theme.props[name]) {
    return props;
  } // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  var defaultProps = theme.props[name];
  var propName;

  for (propName in defaultProps) {
    if (props[propName] === undefined) {
      props[propName] = defaultProps[propName];
    }
  }

  return props;
}

/* harmony default export */ __webpack_exports__["a"] = (getThemeProps);

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__ = __webpack_require__(879);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__ = __webpack_require__(889);






 // Subset of jss-preset-default with only the plugins the Material-UI components are using.

function jssPreset() {
  return {
    plugins: [Object(__WEBPACK_IMPORTED_MODULE_0_jss_plugin_rule_value_function__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_1_jss_plugin_global__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_2_jss_plugin_nested__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_3_jss_plugin_camel_case__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_4_jss_plugin_default_unit__["a" /* default */])(), // Disable the vendor prefixer server-side, it does nothing.
    // This way, we can get a performance boost.
    // In the documentation, we are using `autoprefixer` to solve this problem.
    typeof window === 'undefined' ? null : Object(__WEBPACK_IMPORTED_MODULE_5_jss_plugin_vendor_prefixer__["a" /* default */])(), Object(__WEBPACK_IMPORTED_MODULE_6_jss_plugin_props_sort__["a" /* default */])()]
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPreset);

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(90);


var now = Date.now();
var fnValuesNs = "fnValues" + now;
var fnRuleNs = "fnStyle" + ++now;
function functionPlugin() {
  return {
    onCreateRule: function onCreateRule(name, decl, options) {
      if (typeof decl !== 'function') return null;
      var rule = Object(__WEBPACK_IMPORTED_MODULE_0_jss__["d" /* createRule */])(name, {}, options);
      rule[fnRuleNs] = decl;
      return rule;
    },
    onProcessStyle: function onProcessStyle(style, rule) {
      // We need to extract function values from the declaration, so that we can keep core unaware of them.
      // We need to do that only once.
      // We don't need to extract functions on each style update, since this can happen only once.
      // We don't support function values inside of function rules.
      if (fnValuesNs in rule || fnRuleNs in rule) return style;
      var fnValues = {};

      for (var prop in style) {
        var value = style[prop];
        if (typeof value !== 'function') continue;
        delete style[prop];
        fnValues[prop] = value;
      } // $FlowFixMe


      rule[fnValuesNs] = fnValues;
      return style;
    },
    onUpdate: function onUpdate(data, rule, sheet, options) {
      var styleRule = rule;
      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
      // will be returned from that function.

      if (fnRule) {
        // Empty object will remove all currently defined props
        // in case function rule returns a falsy value.
        styleRule.style = fnRule(data) || {};
      }

      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.

      if (fnValues) {
        for (var prop in fnValues) {
          styleRule.prop(prop, fnValues[prop](data), options);
        }
      }
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (functionPlugin);


/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(90);



var at = '@global';
var atPrefix = '@global ';

var GlobalContainerRule =
/*#__PURE__*/
function () {
  function GlobalContainerRule(key, styles, options) {
    this.type = 'global';
    this.at = at;
    this.rules = void 0;
    this.options = void 0;
    this.key = void 0;
    this.isProcessed = false;
    this.key = key;
    this.options = options;
    this.rules = new __WEBPACK_IMPORTED_MODULE_1_jss__["a" /* RuleList */](Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));

    for (var selector in styles) {
      this.rules.add(selector, styles[selector]);
    }

    this.rules.process();
  }
  /**
   * Get a rule.
   */


  var _proto = GlobalContainerRule.prototype;

  _proto.getRule = function getRule(name) {
    return this.rules.get(name);
  }
  /**
   * Create and register rule, run plugins.
   */
  ;

  _proto.addRule = function addRule(name, style, options) {
    var rule = this.rules.add(name, style, options);
    this.options.jss.plugins.onProcessRule(rule);
    return rule;
  }
  /**
   * Get index of a rule.
   */
  ;

  _proto.indexOf = function indexOf(rule) {
    return this.rules.indexOf(rule);
  }
  /**
   * Generates a CSS string.
   */
  ;

  _proto.toString = function toString() {
    return this.rules.toString();
  };

  return GlobalContainerRule;
}();

var GlobalPrefixedRule =
/*#__PURE__*/
function () {
  function GlobalPrefixedRule(key, style, options) {
    this.type = 'global';
    this.at = at;
    this.options = void 0;
    this.rule = void 0;
    this.isProcessed = false;
    this.key = void 0;
    this.key = key;
    this.options = options;
    var selector = key.substr(atPrefix.length);
    this.rule = options.jss.createRule(selector, style, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      parent: this
    }));
  }

  var _proto2 = GlobalPrefixedRule.prototype;

  _proto2.toString = function toString(options) {
    return this.rule ? this.rule.toString(options) : '';
  };

  return GlobalPrefixedRule;
}();

var separatorRegExp = /\s*,\s*/g;

function addScope(selector, scope) {
  var parts = selector.split(separatorRegExp);
  var scoped = '';

  for (var i = 0; i < parts.length; i++) {
    scoped += scope + " " + parts[i].trim();
    if (parts[i + 1]) scoped += ', ';
  }

  return scoped;
}

function handleNestedGlobalContainerRule(rule) {
  var options = rule.options,
      style = rule.style;
  var rules = style ? style[at] : null;
  if (!rules) return;

  for (var name in rules) {
    options.sheet.addRule(name, rules[name], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: addScope(name, rule.selector)
    }));
  }

  delete style[at];
}

function handlePrefixedGlobalRule(rule) {
  var options = rule.options,
      style = rule.style;

  for (var prop in style) {
    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
    var selector = addScope(prop.substr(at.length), rule.selector);
    options.sheet.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      selector: selector
    }));
    delete style[prop];
  }
}
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */


function jssGlobal() {
  function onCreateRule(name, styles, options) {
    if (!name) return null;

    if (name === at) {
      return new GlobalContainerRule(name, styles, options);
    }

    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
      return new GlobalPrefixedRule(name, styles, options);
    }

    var parent = options.parent;

    if (parent) {
      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
        options.scoped = false;
      }
    }

    if (options.scoped === false) {
      options.selector = name;
    }

    return null;
  }

  function onProcessRule(rule) {
    if (rule.type !== 'style') return;
    handleNestedGlobalContainerRule(rule);
    handlePrefixedGlobalRule(rule);
  }

  return {
    onCreateRule: onCreateRule,
    onProcessRule: onProcessRule
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssGlobal);


/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tiny_warning__ = __webpack_require__(160);



var separatorRegExp = /\s*,\s*/g;
var parentRegExp = /&/g;
var refRegExp = /\$([\w-]+)/g;
/**
 * Convert nested rules to separate, remove them from original styles.
 *
 * @param {Rule} rule
 * @api public
 */

function jssNested() {
  // Get a function to be used for $ref replacement.
  function getReplaceRef(container, sheet) {
    return function (match, key) {
      var rule = container.getRule(key) || sheet && sheet.getRule(key);

      if (rule) {
        rule = rule;
        return rule.selector;
      }

       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
      return key;
    };
  }

  function replaceParentRefs(nestedProp, parentProp) {
    var parentSelectors = parentProp.split(separatorRegExp);
    var nestedSelectors = nestedProp.split(separatorRegExp);
    var result = '';

    for (var i = 0; i < parentSelectors.length; i++) {
      var parent = parentSelectors[i];

      for (var j = 0; j < nestedSelectors.length; j++) {
        var nested = nestedSelectors[j];
        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.

        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
      }
    }

    return result;
  }

  function getOptions(rule, container, options) {
    // Options has been already created, now we only increase index.
    if (options) return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
      index: options.index + 1
    });
    var nestingLevel = rule.options.nestingLevel;
    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rule.options, {
      nestingLevel: nestingLevel,
      index: container.indexOf(rule) + 1
    });
  }

  function onProcessStyle(style, rule, sheet) {
    if (rule.type !== 'style') return style;
    var styleRule = rule;
    var container = styleRule.options.parent;
    var options;
    var replaceRef;

    for (var prop in style) {
      var isNested = prop.indexOf('&') !== -1;
      var isNestedConditional = prop[0] === '@';
      if (!isNested && !isNestedConditional) continue;
      options = getOptions(styleRule, container, options);

      if (isNested) {
        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
        // all nested rules within the sheet.

        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.

        selector = selector.replace(refRegExp, replaceRef);
        container.addRule(selector, style[prop], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, options, {
          selector: selector
        }));
      } else if (isNestedConditional) {
        // Place conditional right after the parent rule to ensure right ordering.
        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
        // And flow doesn't know this will always be a StyleRule which has the addRule method
        // $FlowFixMe
        .addRule(styleRule.key, style[prop], {
          selector: styleRule.selector
        });
      }

      delete style[prop];
    }

    return style;
  }

  return {
    onProcessStyle: onProcessStyle
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssNested);


/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__ = __webpack_require__(883);


/**
 * Convert camel cased property names to dash separated.
 *
 * @param {Object} style
 * @return {Object}
 */

function convertCase(style) {
  var converted = {};

  for (var prop in style) {
    var key = prop.indexOf('--') === 0 ? prop : Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop);
    converted[key] = style[prop];
  }

  if (style.fallbacks) {
    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
  }

  return converted;
}
/**
 * Allow camel cased property names by converting them back to dasherized.
 *
 * @param {Rule} rule
 */


function camelCase() {
  function onProcessStyle(style) {
    if (Array.isArray(style)) {
      // Handle rules like @font-face, which can have multiple styles in an array
      for (var index = 0; index < style.length; index++) {
        style[index] = convertCase(style[index]);
      }

      return style;
    }

    return convertCase(style);
  }

  function onChangeValue(value, prop, rule) {
    if (prop.indexOf('--') === 0) {
      return value;
    }

    var hyphenatedProp = Object(__WEBPACK_IMPORTED_MODULE_0_hyphenate_style_name__["a" /* default */])(prop); // There was no camel case in place

    if (prop === hyphenatedProp) return value;
    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.

    return null;
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (camelCase);


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["a"] = (hyphenateStyleName);


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jss__ = __webpack_require__(90);


var px = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.px : 'px';
var ms = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.ms : 'ms';
var percent = __WEBPACK_IMPORTED_MODULE_0_jss__["f" /* hasCSSTOMSupport */] && CSS ? CSS.percent : '%';
/**
 * Generated jss-plugin-default-unit CSS property units
 *
 * @type object
 */

var defaultUnits = {
  // Animation properties
  'animation-delay': ms,
  'animation-duration': ms,
  // Background properties
  'background-position': px,
  'background-position-x': px,
  'background-position-y': px,
  'background-size': px,
  // Border Properties
  border: px,
  'border-bottom': px,
  'border-bottom-left-radius': px,
  'border-bottom-right-radius': px,
  'border-bottom-width': px,
  'border-left': px,
  'border-left-width': px,
  'border-radius': px,
  'border-right': px,
  'border-right-width': px,
  'border-top': px,
  'border-top-left-radius': px,
  'border-top-right-radius': px,
  'border-top-width': px,
  'border-width': px,
  // Margin properties
  margin: px,
  'margin-bottom': px,
  'margin-left': px,
  'margin-right': px,
  'margin-top': px,
  // Padding properties
  padding: px,
  'padding-bottom': px,
  'padding-left': px,
  'padding-right': px,
  'padding-top': px,
  // Mask properties
  'mask-position-x': px,
  'mask-position-y': px,
  'mask-size': px,
  // Width and height properties
  height: px,
  width: px,
  'min-height': px,
  'max-height': px,
  'min-width': px,
  'max-width': px,
  // Position properties
  bottom: px,
  left: px,
  top: px,
  right: px,
  // Shadow properties
  'box-shadow': px,
  'text-shadow': px,
  // Column properties
  'column-gap': px,
  'column-rule': px,
  'column-rule-width': px,
  'column-width': px,
  // Font and text properties
  'font-size': px,
  'font-size-delta': px,
  'letter-spacing': px,
  'text-indent': px,
  'text-stroke': px,
  'text-stroke-width': px,
  'word-spacing': px,
  // Motion properties
  motion: px,
  'motion-offset': px,
  // Outline properties
  outline: px,
  'outline-offset': px,
  'outline-width': px,
  // Perspective properties
  perspective: px,
  'perspective-origin-x': percent,
  'perspective-origin-y': percent,
  // Transform properties
  'transform-origin': percent,
  'transform-origin-x': percent,
  'transform-origin-y': percent,
  'transform-origin-z': percent,
  // Transition properties
  'transition-delay': ms,
  'transition-duration': ms,
  // Alignment properties
  'vertical-align': px,
  'flex-basis': px,
  // Some random properties
  'shape-margin': px,
  size: px,
  // Grid properties
  grid: px,
  'grid-gap': px,
  'grid-row-gap': px,
  'grid-column-gap': px,
  'grid-template-rows': px,
  'grid-template-columns': px,
  'grid-auto-rows': px,
  'grid-auto-columns': px,
  // Not existing properties.
  // Used to avoid issues with jss-plugin-expand integration.
  'box-shadow-x': px,
  'box-shadow-y': px,
  'box-shadow-blur': px,
  'box-shadow-spread': px,
  'font-line-height': px,
  'text-shadow-x': px,
  'text-shadow-y': px,
  'text-shadow-blur': px
};

/**
 * Clones the object and adds a camel cased property version.
 */
function addCamelCasedVersion(obj) {
  var regExp = /(-[a-z])/g;

  var replace = function replace(str) {
    return str[1].toUpperCase();
  };

  var newObj = {};

  for (var _key in obj) {
    newObj[_key] = obj[_key];
    newObj[_key.replace(regExp, replace)] = obj[_key];
  }

  return newObj;
}

var units = addCamelCasedVersion(defaultUnits);
/**
 * Recursive deep style passing function
 */

function iterate(prop, value, options) {
  if (!value) return value;

  if (Array.isArray(value)) {
    for (var i = 0; i < value.length; i++) {
      value[i] = iterate(prop, value[i], options);
    }
  } else if (typeof value === 'object') {
    if (prop === 'fallbacks') {
      for (var innerProp in value) {
        value[innerProp] = iterate(innerProp, value[innerProp], options);
      }
    } else {
      for (var _innerProp in value) {
        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
      }
    }
  } else if (typeof value === 'number') {
    if (options[prop]) {
      return "" + value + options[prop];
    }

    if (units[prop]) {
      return typeof units[prop] === 'function' ? units[prop](value).toString() : "" + value + units[prop];
    }

    return value.toString();
  }

  return value;
}
/**
 * Add unit to numeric values.
 */


function defaultUnit(options) {
  if (options === void 0) {
    options = {};
  }

  var camelCasedOptions = addCamelCasedVersion(options);

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;

    for (var prop in style) {
      style[prop] = iterate(prop, style[prop], camelCasedOptions);
    }

    return style;
  }

  function onChangeValue(value, prop) {
    return iterate(prop, value, camelCasedOptions);
  }

  return {
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (defaultUnit);


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_css_vendor__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jss__ = __webpack_require__(90);



/**
 * Add vendor prefix to a property name when needed.
 *
 * @api public
 */

function jssVendorPrefixer() {
  function onProcessRule(rule) {
    if (rule.type === 'keyframes') {
      var atRule = rule;
      atRule.at = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["a" /* supportedKeyframes */])(atRule.at);
    }
  }

  function prefixStyle(style) {
    for (var prop in style) {
      var value = style[prop];

      if (prop === 'fallbacks' && Array.isArray(value)) {
        style[prop] = value.map(prefixStyle);
        continue;
      }

      var changeProp = false;
      var supportedProp = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["b" /* supportedProperty */])(prop);
      if (supportedProp && supportedProp !== prop) changeProp = true;
      var changeValue = false;
      var supportedValue$$1 = Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(supportedProp, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value));
      if (supportedValue$$1 && supportedValue$$1 !== value) changeValue = true;

      if (changeProp || changeValue) {
        if (changeProp) delete style[prop];
        style[supportedProp || prop] = supportedValue$$1 || value;
      }
    }

    return style;
  }

  function onProcessStyle(style, rule) {
    if (rule.type !== 'style') return style;
    return prefixStyle(style);
  }

  function onChangeValue(value, prop) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_css_vendor__["c" /* supportedValue */])(prop, Object(__WEBPACK_IMPORTED_MODULE_1_jss__["g" /* toCssValue */])(value)) || value;
  }

  return {
    onProcessRule: onProcessRule,
    onProcessStyle: onProcessStyle,
    onChangeValue: onChangeValue
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssVendorPrefixer);


/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export prefix */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return supportedKeyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return supportedProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return supportedValue; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_in_browser__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);



// Export javascript style and css style vendor prefixes.
var js = '';
var css = '';
var vendor = '';
var browser = '';
var isTouch = __WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */] && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  // Order matters. We need to check Webkit the last one because
  // other vendors use to add Webkit prefixes to some properties
  var jsCssMap = {
    Moz: '-moz-',
    ms: '-ms-',
    O: '-o-',
    Webkit: '-webkit-'
  };

  var _document$createEleme = document.createElement('p'),
      style = _document$createEleme.style;

  var testProp = 'Transform';

  for (var key in jsCssMap) {
    if (key + testProp in style) {
      js = key;
      css = jsCssMap[key];
      break;
    }
  } // Correctly detect the Edge browser.


  if (js === 'Webkit' && 'msHyphens' in style) {
    js = 'ms';
    css = jsCssMap.ms;
    browser = 'edge';
  } // Correctly detect the Safari browser.


  if (js === 'Webkit' && '-apple-trailing-word' in style) {
    vendor = 'apple';
  }
}
/**
 * Vendor prefix string for the current browser.
 *
 * @type {{js: String, css: String, vendor: String, browser: String}}
 * @api public
 */


var prefix = {
  js: js,
  css: css,
  vendor: vendor,
  browser: browser,
  isTouch: isTouch
};

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes

  if (prefix.js === 'ms') return key;
  return "@" + prefix.css + "keyframes" + key.substr(10);
}

// https://caniuse.com/#search=appearance

var appearence = {
  noPrefill: ['appearance'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'appearance') return false;
    if (prefix.js === 'ms') return "-webkit-" + prop;
    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=color-adjust

var colorAdjust = {
  noPrefill: ['color-adjust'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'color-adjust') return false;
    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
    return prop;
  }
};

var regExp = /[-\s]+(.)?/g;
/**
 * Replaces the letter with the capital letter
 *
 * @param {String} match
 * @param {String} c
 * @return {String}
 * @api private
 */

function toUpper(match, c) {
  return c ? c.toUpperCase() : '';
}
/**
 * Convert dash separated strings to camel-cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */


function camelize(str) {
  return str.replace(regExp, toUpper);
}

/**
 * Convert dash separated strings to pascal cased.
 *
 * @param {String} str
 * @return {String}
 * @api private
 */

function pascalize(str) {
  return camelize("-" + str);
}

// but we can use a longhand property instead.
// https://caniuse.com/#search=mask

var mask = {
  noPrefill: ['mask'],
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^mask/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var longhand = 'mask-image';

      if (camelize(longhand) in style) {
        return prop;
      }

      if (prefix.js + pascalize(longhand) in style) {
        return prefix.css + prop;
      }
    }

    return prop;
  }
};

// https://caniuse.com/#search=text-orientation

var textOrientation = {
  noPrefill: ['text-orientation'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'text-orientation') return false;

    if (prefix.vendor === 'apple' && !prefix.isTouch) {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=transform

var transform = {
  noPrefill: ['transform'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transform') return false;

    if (options.transform) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=transition

var transition = {
  noPrefill: ['transition'],
  supportedProperty: function supportedProperty(prop, style, options) {
    if (prop !== 'transition') return false;

    if (options.transition) {
      return prop;
    }

    return prefix.css + prop;
  }
};

// https://caniuse.com/#search=writing-mode

var writingMode = {
  noPrefill: ['writing-mode'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'writing-mode') return false;

    if (prefix.js === 'Webkit' || prefix.js === 'ms') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=user-select

var userSelect = {
  noPrefill: ['user-select'],
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'user-select') return false;

    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
      return prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=multicolumn
// https://github.com/postcss/autoprefixer/issues/491
// https://github.com/postcss/autoprefixer/issues/177

var breakPropsOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^break-/.test(prop)) return false;

    if (prefix.js === 'Webkit') {
      var jsProp = "WebkitColumn" + pascalize(prop);
      return jsProp in style ? prefix.css + "column-" + prop : false;
    }

    if (prefix.js === 'Moz') {
      var _jsProp = "page" + pascalize(prop);

      return _jsProp in style ? "page-" + prop : false;
    }

    return false;
  }
};

// See https://github.com/postcss/autoprefixer/issues/324.

var inlineLogicalOld = {
  supportedProperty: function supportedProperty(prop, style) {
    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
    if (prefix.js === 'Moz') return prop;
    var newProp = prop.replace('-inline', '');
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

// Camelization is required because we can't test using.
// CSS syntax for e.g. in FF.

var unprefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    return camelize(prop) in style ? prop : false;
  }
};

var prefixed = {
  supportedProperty: function supportedProperty(prop, style) {
    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.

    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.

    if (prop[0] === '-' && prop[1] === '-') return prop;
    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.

    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
    return false;
  }
};

// https://caniuse.com/#search=scroll-snap

var scrollSnap = {
  supportedProperty: function supportedProperty(prop) {
    if (prop.substring(0, 11) !== 'scroll-snap') return false;

    if (prefix.js === 'ms') {
      return "" + prefix.css + prop;
    }

    return prop;
  }
};

// https://caniuse.com/#search=overscroll-behavior

var overscrollBehavior = {
  supportedProperty: function supportedProperty(prop) {
    if (prop !== 'overscroll-behavior') return false;

    if (prefix.js === 'ms') {
      return prefix.css + "scroll-chaining";
    }

    return prop;
  }
};

var propMap = {
  'flex-grow': 'flex-positive',
  'flex-shrink': 'flex-negative',
  'flex-basis': 'flex-preferred-size',
  'justify-content': 'flex-pack',
  order: 'flex-order',
  'align-items': 'flex-align',
  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.

}; // Support old flex spec from 2012.

var flex2012 = {
  supportedProperty: function supportedProperty(prop, style) {
    var newProp = propMap[prop];
    if (!newProp) return false;
    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
  }
};

var propMap$1 = {
  flex: 'box-flex',
  'flex-grow': 'box-flex',
  'flex-direction': ['box-orient', 'box-direction'],
  order: 'box-ordinal-group',
  'align-items': 'box-align',
  'flex-flow': ['box-orient', 'box-direction'],
  'justify-content': 'box-pack'
};
var propKeys = Object.keys(propMap$1);

var prefixCss = function prefixCss(p) {
  return prefix.css + p;
}; // Support old flex spec from 2009.


var flex2009 = {
  supportedProperty: function supportedProperty(prop, style, _ref) {
    var multiple = _ref.multiple;

    if (propKeys.indexOf(prop) > -1) {
      var newProp = propMap$1[prop];

      if (!Array.isArray(newProp)) {
        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
      }

      if (!multiple) return false;

      for (var i = 0; i < newProp.length; i++) {
        if (!(prefix.js + pascalize(newProp[0]) in style)) {
          return false;
        }
      }

      return newProp.map(prefixCss);
    }

    return false;
  }
};

// plugins = [
//   ...plugins,
//    breakPropsOld,
//    inlineLogicalOld,
//    unprefixed,
//    prefixed,
//    scrollSnap,
//    flex2012,
//    flex2009
// ]
// Plugins without 'noPrefill' value, going last.
// 'flex-*' plugins should be at the bottom.
// 'flex2009' going after 'flex2012'.
// 'prefixed' going after 'unprefixed'

var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
var propertyDetectors = plugins.filter(function (p) {
  return p.supportedProperty;
}).map(function (p) {
  return p.supportedProperty;
});
var noPrefill = plugins.filter(function (p) {
  return p.noPrefill;
}).reduce(function (a, p) {
  a.push.apply(a, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(p.noPrefill));
  return a;
}, []);

var el;
var cache = {};

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) {
  el = document.createElement('p'); // We test every property on vendor prefix requirement.
  // Once tested, result is cached. It gives us up to 70% perf boost.
  // http://jsperf.com/element-style-object-access-vs-plain-object
  //
  // Prefill cache with known css properties to reduce amount of
  // properties we need to feature test at runtime.
  // http://davidwalsh.name/vendor-prefix

  var computed = window.getComputedStyle(document.documentElement, '');

  for (var key$1 in computed) {
    // eslint-disable-next-line no-restricted-globals
    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
  } // Properties that cannot be correctly detected using the
  // cache prefill method.


  noPrefill.forEach(function (x) {
    return delete cache[x];
  });
}
/**
 * Test if a property is supported, returns supported property with vendor
 * prefix if required. Returns `false` if not supported.
 *
 * @param {String} prop dash separated
 * @param {Object} [options]
 * @return {String|Boolean}
 * @api public
 */


function supportedProperty(prop, options) {
  if (options === void 0) {
    options = {};
  }

  // For server-side rendering.
  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.

  if ("production" !== 'benchmark' && cache[prop] != null) {
    return cache[prop];
  } // Check if 'transition' or 'transform' natively supported in browser.


  if (prop === 'transition' || prop === 'transform') {
    options[prop] = prop in el.style;
  } // Find a plugin for current prefix property.


  for (var i = 0; i < propertyDetectors.length; i++) {
    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.

    if (cache[prop]) break;
  } // Reset styles for current property.
  // Firefox can even throw an error for invalid properties, e.g., "0".


  try {
    el.style[prop] = '';
  } catch (err) {
    return false;
  }

  return cache[prop];
}

var cache$1 = {};
var transitionProperties = {
  transition: 1,
  'transition-property': 1,
  '-webkit-transition': 1,
  '-webkit-transition-property': 1
};
var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
var el$1;
/**
 * Returns prefixed value transition/transform if needed.
 *
 * @param {String} match
 * @param {String} p1
 * @param {String} p2
 * @return {String}
 * @api private
 */

function prefixTransitionCallback(match, p1, p2) {
  if (p1 === 'var') return 'var';
  if (p1 === 'all') return 'all';
  if (p2 === 'all') return ', all';
  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
  if (!prefixedValue) return p1 || p2;
  return prefixedValue;
}

if (__WEBPACK_IMPORTED_MODULE_0_is_in_browser__["a" /* default */]) el$1 = document.createElement('p');
/**
 * Returns prefixed value if needed. Returns `false` if value is not supported.
 *
 * @param {String} property
 * @param {String} value
 * @return {String|Boolean}
 * @api public
 */

function supportedValue(property, value) {
  // For server-side rendering.
  var prefixedValue = value;
  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
  // We want only prefixable values here.
  // eslint-disable-next-line no-restricted-globals

  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
    return prefixedValue;
  } // Create cache key for current value.


  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.

  if ("production" !== 'benchmark' && cache$1[cacheKey] != null) {
    return cache$1[cacheKey];
  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.


  try {
    // Test value as it is.
    el$1.style[property] = prefixedValue;
  } catch (err) {
    // Return false if value not supported.
    cache$1[cacheKey] = false;
    return false;
  } // If 'transition' or 'transition-property' property.


  if (transitionProperties[property]) {
    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
  } else if (el$1.style[property] === '') {
    // Value with a vendor prefix.
    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.

    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.

    el$1.style[property] = prefixedValue; // Return false if value not supported.

    if (el$1.style[property] === '') {
      cache$1[cacheKey] = false;
      return false;
    }
  } // Reset styles for current property.


  el$1.style[property] = ''; // Write current value to cache.

  cache$1[cacheKey] = prefixedValue;
  return cache$1[cacheKey];
}




/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _arrayWithoutHoles;
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _nonIterableSpread;
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Sort props by length.
 */
function jssPropsSort() {
  var sort = function sort(prop0, prop1) {
    if (prop0.length === prop1.length) {
      return prop0 > prop1 ? 1 : -1;
    }

    return prop0.length - prop1.length;
  };

  return {
    onProcessStyle: function onProcessStyle(style, rule) {
      if (rule.type !== 'style') return style;
      var newStyle = {};
      var props = Object.keys(style).sort(sort);

      for (var i = 0; i < props.length; i++) {
        newStyle[props[i]] = style[props[i]];
      }

      return newStyle;
    }
  };
}

/* harmony default export */ __webpack_exports__["a"] = (jssPropsSort);


/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jss__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mergeClasses__ = __webpack_require__(390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__useTheme__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StylesProvider__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__indexCounter__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__getStylesCreator__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__ = __webpack_require__(393);












function getClasses(_ref, classes, Component) {
  var state = _ref.state,
      stylesOptions = _ref.stylesOptions;

  if (stylesOptions.disableGeneration) {
    return classes || {};
  }

  if (!state.cacheClasses) {
    state.cacheClasses = {
      // Cache for the finalized classes value.
      value: null,
      // Cache for the last used classes prop pointer.
      lastProp: null,
      // Cache for the last used rendered classes pointer.
      lastJSS: {}
    };
  } // Tracks if either the rendered classes or classes prop has changed,
  // requiring the generation of a new finalized classes object.


  var generate = false;

  if (state.classes !== state.cacheClasses.lastJSS) {
    state.cacheClasses.lastJSS = state.classes;
    generate = true;
  }

  if (classes !== state.cacheClasses.lastProp) {
    state.cacheClasses.lastProp = classes;
    generate = true;
  }

  if (generate) {
    state.cacheClasses.value = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: state.cacheClasses.lastJSS,
      newClasses: classes,
      Component: Component
    });
  }

  return state.cacheClasses.value;
}

function attach(_ref2, props) {
  var state = _ref2.state,
      theme = _ref2.theme,
      stylesOptions = _ref2.stylesOptions,
      stylesCreator = _ref2.stylesCreator,
      name = _ref2.name;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);

  if (!sheetManager) {
    sheetManager = {
      refs: 0,
      staticSheet: null,
      dynamicStyles: null
    };
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
  }

  var options = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, stylesCreator.options, {}, stylesOptions, {
    theme: theme,
    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
  });

  options.generateId = options.serverGenerateClassName || options.generateClassName;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    var staticSheet;

    if (stylesOptions.sheetsCache) {
      staticSheet = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsCache, stylesCreator, theme);
    }

    var styles = stylesCreator.create(theme, name);

    if (!staticSheet) {
      staticSheet = stylesOptions.jss.createStyleSheet(styles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        link: false
      }, options));
      staticSheet.attach();

      if (stylesOptions.sheetsCache) {
        __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
      }
    }

    if (sheetsRegistry) {
      sheetsRegistry.add(staticSheet);
    }

    sheetManager.staticSheet = staticSheet;
    sheetManager.dynamicStyles = Object(__WEBPACK_IMPORTED_MODULE_3_jss__["e" /* getDynamicStyles */])(styles);
  }

  if (sheetManager.dynamicStyles) {
    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      link: true
    }, options));
    dynamicSheet.update(props).attach();
    state.dynamicSheet = dynamicSheet;
    state.classes = Object(__WEBPACK_IMPORTED_MODULE_4__mergeClasses__["a" /* default */])({
      baseClasses: sheetManager.staticSheet.classes,
      newClasses: dynamicSheet.classes
    });

    if (sheetsRegistry) {
      sheetsRegistry.add(dynamicSheet);
    }
  } else {
    state.classes = sheetManager.staticSheet.classes;
  }

  sheetManager.refs += 1;
}

function update(_ref3, props) {
  var state = _ref3.state;

  if (state.dynamicSheet) {
    state.dynamicSheet.update(props);
  }
}

function detach(_ref4) {
  var state = _ref4.state,
      theme = _ref4.theme,
      stylesOptions = _ref4.stylesOptions,
      stylesCreator = _ref4.stylesCreator;

  if (stylesOptions.disableGeneration) {
    return;
  }

  var sheetManager = __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].get(stylesOptions.sheetsManager, stylesCreator, theme);
  sheetManager.refs -= 1;
  var sheetsRegistry = stylesOptions.sheetsRegistry;

  if (sheetManager.refs === 0) {
    __WEBPACK_IMPORTED_MODULE_5__multiKeyStore__["a" /* default */].delete(stylesOptions.sheetsManager, stylesCreator, theme);
    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(sheetManager.staticSheet);
    }
  }

  if (state.dynamicSheet) {
    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);

    if (sheetsRegistry) {
      sheetsRegistry.remove(state.dynamicSheet);
    }
  }
}

function useSynchronousEffect(func, values) {
  var key = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  var output; // Store "generation" key. Just returns a new object every time

  var currentKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {};
  }, values); // eslint-disable-line react-hooks/exhaustive-deps
  // "the first render", or "memo dropped the value"

  if (key.current !== currentKey) {
    key.current = currentKey;
    output = func();
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      if (output) {
        output();
      }
    };
  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
  );
}

function makeStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var name = options.name,
      classNamePrefixOption = options.classNamePrefix,
      Component = options.Component,
      _options$defaultTheme = options.defaultTheme,
      defaultTheme = _options$defaultTheme === void 0 ? __WEBPACK_IMPORTED_MODULE_10__getStylesCreator_noopTheme__["a" /* default */] : _options$defaultTheme,
      stylesOptions2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);

  var stylesCreator = Object(__WEBPACK_IMPORTED_MODULE_9__getStylesCreator__["a" /* default */])(stylesOrCreator);
  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
  stylesCreator.options = {
    index: Object(__WEBPACK_IMPORTED_MODULE_8__indexCounter__["a" /* increment */])(),
    name: name,
    meta: classNamePrefix,
    classNamePrefix: classNamePrefix
  };
  return function () {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var theme = Object(__WEBPACK_IMPORTED_MODULE_6__useTheme__["a" /* default */])() || defaultTheme;

    var stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__StylesProvider__["a" /* StylesContext */]), {}, stylesOptions2);

    var instance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    var shouldUpdate = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
    useSynchronousEffect(function () {
      var current = {
        name: name,
        state: {},
        stylesCreator: stylesCreator,
        stylesOptions: stylesOptions,
        theme: theme
      };
      attach(current, props);
      shouldUpdate.current = false;
      instance.current = current;
      return function () {
        detach(current);
      };
    }, [theme, stylesCreator]);
    __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
      if (shouldUpdate.current) {
        update(instance.current, props);
      }

      shouldUpdate.current = true;
    });
    return getClasses(instance.current, props.classes, Component);
  };
}

/* harmony default export */ __webpack_exports__["a"] = (makeStyles);

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(12);



function mergeClasses() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var baseClasses = options.baseClasses,
      newClasses = options.newClasses,
      Component = options.Component;

  if (!newClasses) {
    return baseClasses;
  }

  var nextClasses = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, baseClasses);

  if (false) {
    if (typeof newClasses === 'string') {
      console.error(["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat(getDisplayName(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
      return baseClasses;
    }
  }

  Object.keys(newClasses).forEach(function (key) {
    if (false) {
      if (!baseClasses[key] && newClasses[key]) {
        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat(getDisplayName(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
      }

      if (newClasses[key] && typeof newClasses[key] !== 'string') {
        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat(getDisplayName(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
      }
    }

    if (newClasses[key]) {
      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
    }
  });
  return nextClasses;
}

/* harmony default export */ __webpack_exports__["a"] = (mergeClasses);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// Used https://github.com/thinkloop/multi-key-cache as inspiration
var multiKeyStore = {
  set: function set(cache, key1, key2, value) {
    var subCache = cache.get(key1);

    if (!subCache) {
      subCache = new Map();
      cache.set(key1, subCache);
    }

    subCache.set(key2, value);
  },
  get: function get(cache, key1, key2) {
    var subCache = cache.get(key1);
    return subCache ? subCache.get(key2) : undefined;
  },
  delete: function _delete(cache, key1, key2) {
    var subCache = cache.get(key1);
    subCache.delete(key2);
  }
};
/* harmony default export */ __webpack_exports__["a"] = (multiKeyStore);

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = useTheme;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ThemeContext__ = __webpack_require__(391);


function useTheme() {
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_1__ThemeContext__["a" /* default */]);
}

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = increment;
/* eslint-disable import/prefer-default-export */
// Global index counter to preserve source order.
// We create the style sheet during at the creation of the component,
// children are handled after the parents, so the order of style elements would be parent->child.
// It is a problem though when a parent passes a className
// which needs to override any child's styles.
// StyleSheet of the child has a higher specificity, because of the source order.
// So our solution is to render sheets them in the reverse order child->sheet, so
// that parent has a higher specificity.
var indexCounter = -1e9;
function increment() {
  indexCounter += 1;

  if (false) {
    if (indexCounter >= 0) {
      console.warn(['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
    }
  }

  return indexCounter;
}

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__ = __webpack_require__(896);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__getStylesCreator__["a"]; });


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noopTheme__ = __webpack_require__(393);





function getStylesCreator(stylesOrCreator) {
  var themingEnabled = typeof stylesOrCreator === 'function';

  if (false) {
    if (_typeof(stylesOrCreator) !== 'object' && !themingEnabled) {
      console.error(['Material-UI: the `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
    }
  }

  return {
    create: function create(theme, name) {
      var styles;

      try {
        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
      } catch (err) {
        if (false) {
          if (themingEnabled === true && theme === noopTheme) {
            // TODO: prepend error message/name instead
            console.error(['Material-UI: the `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
          }
        }

        throw err;
      }

      if (!name || !theme.overrides || !theme.overrides[name]) {
        return styles;
      }

      var overrides = theme.overrides[name];

      var stylesWithOverrides = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles);

      Object.keys(overrides).forEach(function (key) {
        if (false) {
          if (!stylesWithOverrides[key]) {
            console.warn(['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
          }
        }

        stylesWithOverrides[key] = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_utils__["a" /* deepmerge */])(stylesWithOverrides[key], overrides[key]);
      });
      return stylesWithOverrides;
    },
    options: {}
  };
}

/* harmony default export */ __webpack_exports__["a"] = (getStylesCreator);

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ServerStyleSheets__ = __webpack_require__(898);
/* unused harmony reexport default */


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jss__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StylesProvider__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__ = __webpack_require__(245);








var ServerStyleSheets =
/*#__PURE__*/
function () {
  function ServerStyleSheets() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, ServerStyleSheets);

    this.options = options;
  }

  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_createClass__["a" /* default */])(ServerStyleSheets, [{
    key: "collect",
    value: function collect(children) {
      // This is needed in order to deduplicate the injection of CSS in the page.
      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.

      this.sheetsRegistry = new __WEBPACK_IMPORTED_MODULE_4_jss__["b" /* SheetsRegistry */](); // A new class name generator

      var generateClassName = Object(__WEBPACK_IMPORTED_MODULE_6__createGenerateClassName__["a" /* default */])();
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__StylesProvider__["b" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        sheetsManager: sheetsManager,
        serverGenerateClassName: generateClassName,
        sheetsRegistry: this.sheetsRegistry
      }, this.options), children);
    }
  }, {
    key: "toString",
    value: function toString() {
      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
    }
  }, {
    key: "getStyleElement",
    value: function getStyleElement(props) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('style', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: 'jss-server-side',
        key: 'jss-server-side',
        dangerouslySetInnerHTML: {
          __html: this.toString()
        }
      }, props));
    }
  }]);

  return ServerStyleSheets;
}();

/* unused harmony default export */ var _unused_webpack_default_export = (ServerStyleSheets);

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__styled__ = __webpack_require__(900);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__styled__["a"]; });


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__makeStyles__ = __webpack_require__(247);









function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
} // styled-components's API removes the mapping between components and styles.
// Using components as a low-level styling construct can be simpler.


function styled(Component) {
  var componentCreator = function componentCreator(style) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["name"]);

    if (false) {
      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var stylesOrCreator = typeof style === 'function' ? function (theme) {
      return {
        root: function root(props) {
          return style(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            theme: theme
          }, props));
        }
      };
    } : {
      root: style
    };
    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_7__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var filterProps;
    var propTypes = {};

    if (style.filterProps) {
      filterProps = style.filterProps;
      delete style.filterProps;
    }
    /* eslint-disable react/forbid-foreign-prop-types */


    if (style.propTypes) {
      propTypes = style.propTypes;
      delete style.propTypes;
    }
    /* eslint-enable react/forbid-foreign-prop-types */


    var StyledComponent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StyledComponent(props, ref) {
      var children = props.children,
          classNameProp = props.className,
          clone = props.clone,
          ComponentProp = props.component,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "className", "clone", "component"]);

      var classes = useStyles(props);
      var className = Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classNameProp);
      var spread = other;

      if (filterProps) {
        spread = omit(spread, filterProps);
      }

      if (clone) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(children.props.className, className)
        }, spread));
      }

      if (typeof children === 'function') {
        return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
          className: className
        }, spread));
      }

      var FinalComponent = ComponentProp || Component;
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(FinalComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: ref,
        className: className
      }, spread), children);
    });
     false ? StyledComponent.propTypes = _extends({
      /**
       * A render function or node.
       */
      children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),

      /**
       * @ignore
       */
      className: PropTypes.string,

      /**
       * If `true`, the component will recycle it's children DOM element.
       * It's using `React.cloneElement` internally.
       *
       * This prop will be deprecated and removed in v5
       */
      clone: chainPropTypes(PropTypes.bool, function (props) {
        if (props.clone && props.component) {
          return new Error('You can not use the clone and component prop at the same time.');
        }

        return null;
      }),

      /**
       * The component used for the root node.
       * Either a string to use a DOM element or a component.
       */
      component: PropTypes.elementType
    }, propTypes) : void 0;

    if (false) {
      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
    }

    __WEBPACK_IMPORTED_MODULE_6_hoist_non_react_statics___default()(StyledComponent, Component);
    return StyledComponent;
  };

  return componentCreator;
}

/* harmony default export */ __webpack_exports__["a"] = (styled);

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__ = __webpack_require__(902);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ThemeProvider__["a"]; });


/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__useTheme__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__nested__ = __webpack_require__(385);






 // To support composition of theme.

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    var mergedTheme = localTheme(outerTheme);

    if (false) {
      if (!mergedTheme) {
        console.error(['Material-UI: you should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
      }
    }

    return mergedTheme;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, outerTheme, {}, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider(props) {
  var children = props.children,
      localTheme = props.theme;
  var outerTheme = Object(__WEBPACK_IMPORTED_MODULE_5__useTheme__["a" /* default */])();

  if (false) {
    if (outerTheme === null && typeof localTheme === 'function') {
      console.error(['Material-UI: you are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
    }
  }

  var theme = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useMemo(function () {
    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[__WEBPACK_IMPORTED_MODULE_6__nested__["a" /* default */]] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__useTheme_ThemeContext__["a" /* default */].Provider, {
    value: theme
  }, children);
}

 false ? ThemeProvider.propTypes = {
  /**
   * Your component tree.
   */
  children: PropTypes.node.isRequired,

  /**
   * A theme object. You can provide a function to extend the outer theme.
   */
  theme: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = exactProp(ThemeProvider.propTypes) : void 0;
}

/* harmony default export */ __webpack_exports__["a"] = (ThemeProvider);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withStyles__ = __webpack_require__(904);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withStyles__["a"]; });


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__makeStyles__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__getThemeProps__ = __webpack_require__(386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__useTheme__ = __webpack_require__(134);








 // Link a style sheet with a component.
// It does not modify the component passed to it;
// instead, it returns a new component, with a `classes` property.

var withStyles = function withStyles(stylesOrCreator) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return function (Component) {
    var defaultTheme = options.defaultTheme,
        _options$withTheme = options.withTheme,
        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
        name = options.name,
        stylesOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["defaultTheme", "withTheme", "name"]);

    if (false) {
      if (Component === undefined) {
        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
      }
    }

    var classNamePrefix = name;

    if (false) {
      if (!name) {
        // Provide a better DX outside production.
        var displayName = getDisplayName(Component);

        if (displayName !== undefined) {
          classNamePrefix = displayName;
        }
      }
    }

    var useStyles = Object(__WEBPACK_IMPORTED_MODULE_6__makeStyles__["a" /* default */])(stylesOrCreator, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      defaultTheme: defaultTheme,
      Component: Component,
      name: name || Component.displayName,
      classNamePrefix: classNamePrefix
    }, stylesOptions));
    var WithStyles = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function WithStyles(props, ref) {
      var classesProp = props.classes,
          innerRef = props.innerRef,
          other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "innerRef"]);

      var classes = useStyles(props);
      var theme;
      var more = other;

      if (typeof name === 'string' || withTheme) {
        // name and withTheme are invariant in the outer scope
        // eslint-disable-next-line react-hooks/rules-of-hooks
        theme = Object(__WEBPACK_IMPORTED_MODULE_8__useTheme__["a" /* default */])() || defaultTheme;

        if (name) {
          more = Object(__WEBPACK_IMPORTED_MODULE_7__getThemeProps__["a" /* default */])({
            theme: theme,
            name: name,
            props: other
          });
        } // Provide the theme to the wrapped component.
        // So we don't have to use the `withTheme()` Higher-order Component.


        if (withTheme && !more.theme) {
          more.theme = theme;
        }
      }

      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        ref: innerRef || ref,
        classes: classes
      }, more));
    });
     false ? WithStyles.propTypes = {
      /**
       * Override or extend the styles applied to the component.
       */
      classes: PropTypes.object,

      /**
       * Use that prop to pass a ref to the decorated component.
       * @deprecated
       */
      innerRef: chainPropTypes(PropTypes.oneOfType([PropTypes.func, PropTypes.object]), function (props) {
        if (props.innerRef == null) {
          return null;
        }

        return null; // return new Error(
        //   'Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' +
        //     'Refs are now automatically forwarded to the inner component.',
        // );
      })
    } : void 0; // The wrapper receives only user supplied props, which could be a subset of
    // the actual props Component might receive due to merging with defaultProps.
    // So copying it here would give us the same result in the wrapper as well.

    WithStyles.defaultProps = Component.defaultProps;

    if (false) {
      WithStyles.displayName = "WithStyles(".concat(getDisplayName(Component), ")");
    }

    __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithStyles, Component);

    if (false) {
      // Exposed for test purposes.
      WithStyles.Naked = Component;
      WithStyles.options = options;
      WithStyles.useStyles = useStyles;
    }

    return WithStyles;
  };
};

/* harmony default export */ __webpack_exports__["a"] = (withStyles);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withTheme__ = __webpack_require__(394);
/* unused harmony reexport default */
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__withTheme__["a"]; });



/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_convert_css_length__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__cssUtils__ = __webpack_require__(908);




function isUnitless(value) {
  return String(parseFloat(value)).length === String(value).length;
}

function responsiveFontSizes(themeInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var _options$breakpoints = options.breakpoints,
      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
      _options$disableAlign = options.disableAlign,
      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
      _options$factor = options.factor,
      factor = _options$factor === void 0 ? 2 : _options$factor,
      _options$variants = options.variants,
      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;

  var theme = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, themeInput);

  theme.typography = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography);
  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).

  var convert = Object(__WEBPACK_IMPORTED_MODULE_1_convert_css_length__["a" /* default */])(typography.htmlFontSize);
  var breakpointValues = breakpoints.map(function (x) {
    return theme.breakpoints.values[x];
  });
  variants.forEach(function (variant) {
    var style = typography[variant];
    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));

    if (remFontSize <= 1) {
      return;
    }

    var maxFontSize = remFontSize;
    var minFontSize = 1 + (maxFontSize - 1) / factor;
    var lineHeight = style.lineHeight;

    if (!isUnitless(lineHeight) && !disableAlign) {
      throw new Error(["Material-UI: unsupported non-unitless line height with grid alignment.", 'Use unitless line heights instead.'].join('\n'));
    }

    if (!isUnitless(lineHeight)) {
      // make it unitless
      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
    }

    var transform = null;

    if (!disableAlign) {
      transform = function transform(value) {
        return Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["a" /* alignProperty */])({
          size: value,
          grid: Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["b" /* fontGrid */])({
            pixels: 4,
            lineHeight: lineHeight,
            htmlFontSize: typography.htmlFontSize
          })
        });
      };
    }

    typography[variant] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, style, {}, Object(__WEBPACK_IMPORTED_MODULE_2__cssUtils__["c" /* responsiveProperty */])({
      cssProperty: 'fontSize',
      min: minFontSize,
      max: maxFontSize,
      unit: 'rem',
      breakpoints: breakpointValues,
      transform: transform
    }));
  });
  return theme;
}

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var e=function(e){return parseFloat(e)};/* harmony default export */ __webpack_exports__["a"] = (function(r){return null==r&&(r=r),function(n,t,i,f){null==i&&(i=r),null==f&&(f=i);var l=String(n).match(/[\d.\-\+]*\s*(.*)/)[1]||"";if(l===t)return n;var u=e(n);if("px"!==l)if("em"===l)u=e(n)*e(i);else if("rem"===l)u=e(n)*e(r);else{if("ex"!==l)return n;u=e(n)*e(i)*2}var a=u;if("px"!==t)if("em"===t)a=u/e(f);else if("rem"===t)a=u/e(r);else{if("ex"!==t)return n;a=u/e(f)/2}return parseFloat(a.toFixed(5))+t}});
//# sourceMappingURL=index.esm.js.map


/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = alignProperty;
/* harmony export (immutable) */ __webpack_exports__["b"] = fontGrid;
/* harmony export (immutable) */ __webpack_exports__["c"] = responsiveProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);

function alignProperty(_ref) {
  var size = _ref.size,
      grid = _ref.grid;
  var sizeBelow = size - size % grid;
  var sizeAbove = sizeBelow + grid;
  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
// without changing the relative line height

function fontGrid(_ref2) {
  var lineHeight = _ref2.lineHeight,
      pixels = _ref2.pixels,
      htmlFontSize = _ref2.htmlFontSize;
  return pixels / (lineHeight * htmlFontSize);
}
/**
 * generate a responsive version of a given CSS property
 * @example
 * responsiveProperty({
 *   cssProperty: 'fontSize',
 *   min: 15,
 *   max: 20,
 *   unit: 'px',
 *   breakpoints: [300, 600],
 * })
 *
 * // this returns
 *
 * {
 *   fontSize: '15px',
 *   '@media (min-width:300px)': {
 *     fontSize: '17.5px',
 *   },
 *   '@media (min-width:600px)': {
 *     fontSize: '20px',
 *   },
 * }
 *
 * @param {Object} params
 * @param {string} params.cssProperty - The CSS property to be made responsive
 * @param {number} params.min - The smallest value of the CSS property
 * @param {number} params.max - The largest value of the CSS property
 * @param {string} [params.unit] - The unit to be used for the CSS property
 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
 * @returns {Object} responsive styles for {params.cssProperty}
 */

function responsiveProperty(_ref3) {
  var cssProperty = _ref3.cssProperty,
      min = _ref3.min,
      max = _ref3.max,
      _ref3$unit = _ref3.unit,
      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
      _ref3$breakpoints = _ref3.breakpoints,
      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
      _ref3$transform = _ref3.transform,
      transform = _ref3$transform === void 0 ? null : _ref3$transform;

  var output = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(min).concat(unit));

  var factor = (max - min) / breakpoints[breakpoints.length - 1];
  breakpoints.forEach(function (breakpoint) {
    var value = min + factor * breakpoint;

    if (transform !== null) {
      value = transform(value);
    }

    output["@media (min-width:".concat(breakpoint, "px)")] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
  });
  return output;
}

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultTheme__ = __webpack_require__(135);


var withTheme = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_styles__["i" /* withThemeCreator */])({
  defaultTheme: __WEBPACK_IMPORTED_MODULE_1__defaultTheme__["a" /* default */]
});
/* harmony default export */ __webpack_exports__["a"] = (withTheme);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Menu__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Menu___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Menu__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LogoHeader__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}//import logo from "../../common/assets/logoCreek.png";
var Header=function(_Component){_inherits(Header,_Component);function Header(){_classCallCheck(this,Header);return _possibleConstructorReturn(this,(Header.__proto__||Object.getPrototypeOf(Header)).apply(this,arguments));}_createClass(Header,[{key:"render",value:function render(){var _props=this.props,theme=_props.theme,leftIconClick=_props.leftIconClick,login=_props.login;var appDisplayName="Hangover";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["a" /* AppBar */],{style:theme.appBar.root// onLeftIconButtonTouchTap={this.props.leftIconClick}
// iconStyleLeft={{
//   color: "#1bb6b1",
//   display: !this.props.login ? "block" : "none",
//   marginLeft: 5,
//   marginRight: 0,
//   marginTop: 0
// }}
// titleStyle={styles.title}
// title={<img src={logo} className="App-logo" alt="logo" />}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["X" /* Toolbar */],{position:"sticky",style:theme.appBar.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["y" /* IconButton */],{onClick:leftIconClick,style:{display:!login?"block":"none"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_icons_Menu___default.a,{style:theme.appBar.leftIcon})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:__WEBPACK_IMPORTED_MODULE_3__LogoHeader__["a" /* default */],style:Object.assign({},theme.logo,{marginRight:10}),alt:"logo"}),appDisplayName));}}]);return Header;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_styles__["h" /* withTheme */])(Header));

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common__ = __webpack_require__(379);
/* unused harmony reexport common */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__red__ = __webpack_require__(383);
/* unused harmony reexport red */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pink__ = __webpack_require__(382);
/* unused harmony reexport pink */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__purple__ = __webpack_require__(912);
/* unused harmony reexport purple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__deepPurple__ = __webpack_require__(913);
/* unused harmony reexport deepPurple */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__indigo__ = __webpack_require__(381);
/* unused harmony reexport indigo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__blue__ = __webpack_require__(914);
/* unused harmony reexport blue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lightBlue__ = __webpack_require__(915);
/* unused harmony reexport lightBlue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__cyan__ = __webpack_require__(916);
/* unused harmony reexport cyan */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__teal__ = __webpack_require__(917);
/* unused harmony reexport teal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__green__ = __webpack_require__(918);
/* unused harmony reexport green */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__lightGreen__ = __webpack_require__(919);
/* unused harmony reexport lightGreen */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__lime__ = __webpack_require__(920);
/* unused harmony reexport lime */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__yellow__ = __webpack_require__(921);
/* unused harmony reexport yellow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__amber__ = __webpack_require__(922);
/* unused harmony reexport amber */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__orange__ = __webpack_require__(923);
/* unused harmony reexport orange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__deepOrange__ = __webpack_require__(924);
/* unused harmony reexport deepOrange */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__brown__ = __webpack_require__(925);
/* unused harmony reexport brown */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__grey__ = __webpack_require__(380);
/* unused harmony reexport grey */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__blueGrey__ = __webpack_require__(926);
/* unused harmony reexport blueGrey */





















/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
/* unused harmony default export */ var _unused_webpack_default_export = (purple);

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepPurple = {
  50: '#ede7f6',
  100: '#d1c4e9',
  200: '#b39ddb',
  300: '#9575cd',
  400: '#7e57c2',
  500: '#673ab7',
  600: '#5e35b1',
  700: '#512da8',
  800: '#4527a0',
  900: '#311b92',
  A100: '#b388ff',
  A200: '#7c4dff',
  A400: '#651fff',
  A700: '#6200ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepPurple);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
/* unused harmony default export */ var _unused_webpack_default_export = (blue);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightBlue);

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var cyan = {
  50: '#e0f7fa',
  100: '#b2ebf2',
  200: '#80deea',
  300: '#4dd0e1',
  400: '#26c6da',
  500: '#00bcd4',
  600: '#00acc1',
  700: '#0097a7',
  800: '#00838f',
  900: '#006064',
  A100: '#84ffff',
  A200: '#18ffff',
  A400: '#00e5ff',
  A700: '#00b8d4'
};
/* unused harmony default export */ var _unused_webpack_default_export = (cyan);

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var teal = {
  50: '#e0f2f1',
  100: '#b2dfdb',
  200: '#80cbc4',
  300: '#4db6ac',
  400: '#26a69a',
  500: '#009688',
  600: '#00897b',
  700: '#00796b',
  800: '#00695c',
  900: '#004d40',
  A100: '#a7ffeb',
  A200: '#64ffda',
  A400: '#1de9b6',
  A700: '#00bfa5'
};
/* unused harmony default export */ var _unused_webpack_default_export = (teal);

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
/* unused harmony default export */ var _unused_webpack_default_export = (green);

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lightGreen = {
  50: '#f1f8e9',
  100: '#dcedc8',
  200: '#c5e1a5',
  300: '#aed581',
  400: '#9ccc65',
  500: '#8bc34a',
  600: '#7cb342',
  700: '#689f38',
  800: '#558b2f',
  900: '#33691e',
  A100: '#ccff90',
  A200: '#b2ff59',
  A400: '#76ff03',
  A700: '#64dd17'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lightGreen);

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var lime = {
  50: '#f9fbe7',
  100: '#f0f4c3',
  200: '#e6ee9c',
  300: '#dce775',
  400: '#d4e157',
  500: '#cddc39',
  600: '#c0ca33',
  700: '#afb42b',
  800: '#9e9d24',
  900: '#827717',
  A100: '#f4ff81',
  A200: '#eeff41',
  A400: '#c6ff00',
  A700: '#aeea00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (lime);

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var yellow = {
  50: '#fffde7',
  100: '#fff9c4',
  200: '#fff59d',
  300: '#fff176',
  400: '#ffee58',
  500: '#ffeb3b',
  600: '#fdd835',
  700: '#fbc02d',
  800: '#f9a825',
  900: '#f57f17',
  A100: '#ffff8d',
  A200: '#ffff00',
  A400: '#ffea00',
  A700: '#ffd600'
};
/* unused harmony default export */ var _unused_webpack_default_export = (yellow);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var amber = {
  50: '#fff8e1',
  100: '#ffecb3',
  200: '#ffe082',
  300: '#ffd54f',
  400: '#ffca28',
  500: '#ffc107',
  600: '#ffb300',
  700: '#ffa000',
  800: '#ff8f00',
  900: '#ff6f00',
  A100: '#ffe57f',
  A200: '#ffd740',
  A400: '#ffc400',
  A700: '#ffab00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (amber);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (orange);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var deepOrange = {
  50: '#fbe9e7',
  100: '#ffccbc',
  200: '#ffab91',
  300: '#ff8a65',
  400: '#ff7043',
  500: '#ff5722',
  600: '#f4511e',
  700: '#e64a19',
  800: '#d84315',
  900: '#bf360c',
  A100: '#ff9e80',
  A200: '#ff6e40',
  A400: '#ff3d00',
  A700: '#dd2c00'
};
/* unused harmony default export */ var _unused_webpack_default_export = (deepOrange);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var brown = {
  50: '#efebe9',
  100: '#d7ccc8',
  200: '#bcaaa4',
  300: '#a1887f',
  400: '#8d6e63',
  500: '#795548',
  600: '#6d4c41',
  700: '#5d4037',
  800: '#4e342e',
  900: '#3e2723',
  A100: '#d7ccc8',
  A200: '#bcaaa4',
  A400: '#8d6e63',
  A700: '#5d4037'
};
/* unused harmony default export */ var _unused_webpack_default_export = (brown);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var blueGrey = {
  50: '#eceff1',
  100: '#cfd8dc',
  200: '#b0bec5',
  300: '#90a4ae',
  400: '#78909c',
  500: '#607d8b',
  600: '#546e7a',
  700: '#455a64',
  800: '#37474f',
  900: '#263238',
  A100: '#cfd8dc',
  A200: '#b0bec5',
  A400: '#78909c',
  A700: '#455a64'
};
/* unused harmony default export */ var _unused_webpack_default_export = (blueGrey);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AppBar__ = __webpack_require__(928);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AppBar__["a"]; });


/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(60);








var styles = function styles(theme) {
  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      boxSizing: 'border-box',
      // Prevent padding issue with the Modal and fixed positioned AppBar.
      zIndex: theme.zIndex.appBar,
      flexShrink: 0
    },

    /* Styles applied to the root element if `position="fixed"`. */
    positionFixed: {
      position: 'fixed',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="absolute"`. */
    positionAbsolute: {
      position: 'absolute',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="sticky"`. */
    positionSticky: {
      // ⚠️ sticky is not supported by IE 11.
      position: 'sticky',
      top: 0,
      left: 'auto',
      right: 0
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {
      position: 'static',
      transform: 'translateZ(0)' // Make sure we can see the elevation.

    },

    /* Styles applied to the root element if `position="relative"`. */
    positionRelative: {
      position: 'relative'
    },

    /* Styles applied to the root element if `color="default"`. */
    colorDefault: {
      backgroundColor: backgroundColorDefault,
      color: theme.palette.getContrastText(backgroundColorDefault)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    }
  };
};
var AppBar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function AppBar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$position = props.position,
      position = _props$position === void 0 ? 'fixed' : _props$position,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "position"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    component: "header",
    elevation: 4,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(position))], className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], {
      fixed: 'mui-fixed'
    }[position]),
    ref: ref
  }, other));
});
 false ? AppBar.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The positioning type. The behavior of the different options is described
   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
   */
  position: PropTypes.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAppBar'
})(AppBar));

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(32);







var styles = function styles(theme) {
  var elevations = {};
  theme.shadows.forEach(function (shadow, index) {
    elevations["elevation".concat(index)] = {
      boxShadow: shadow
    };
  });
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      color: theme.palette.text.primary,
      transition: theme.transitions.create('box-shadow')
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    }
  }, elevations);
};
var Paper = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Paper(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "square", "elevation"]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var theme = useTheme();

    if (!theme.shadows[elevation]) {
      console.error("Material-UI: this elevation `".concat(elevation, "` is not implemented."));
    }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["elevation".concat(elevation)], className, !square && classes.rounded),
    ref: ref
  }, other));
});
 false ? Paper.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It accepts values between 0 and 24 inclusive.
   */
  elevation: PropTypes.number,

  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPaper'
})(Paper));

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Avatar__ = __webpack_require__(931);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Avatar__["a"]; });


/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      width: 40,
      height: 40,
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(20),
      lineHeight: 1,
      borderRadius: '50%',
      overflow: 'hidden',
      userSelect: 'none'
    },

    /* Styles applied to the root element if there are children and not `src` or `srcSet`. */
    colorDefault: {
      color: theme.palette.background.default,
      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {},

    /* Styles applied to the root element if `variant="rounded"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="square"`. */
    square: {
      borderRadius: 0
    },

    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
    img: {
      width: '100%',
      height: '100%',
      textAlign: 'center',
      // Handle non-square image. The property isn't supported by IE 11.
      objectFit: 'cover'
    }
  };
};
var Avatar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Avatar(props, ref) {
  var alt = props.alt,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      imgProps = props.imgProps,
      sizes = props.sizes,
      src = props.src,
      srcSet = props.srcSet,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'circle' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);

  var children = null;
  var img = src || srcSet;

  if (img) {
    children = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      className: classes.img
    }, imgProps));
  } else {
    children = childrenProp;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.system, classes[variant], className, !img && classes.colorDefault),
    ref: ref
  }, other), children);
});
 false ? Avatar.propTypes = {
  /**
   * Used in combination with `src` or `srcSet` to
   * provide an alt attribute for the rendered `img` element.
   */
  alt: PropTypes.string,

  /**
   * Used to render icon or text elements inside the Avatar if `src` is not set.
   * This can be an element, or just a string.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Attributes applied to the `img` element if the component
   * is used to display an image.
   */
  imgProps: PropTypes.object,

  /**
   * The `sizes` attribute for the `img` element.
   */
  sizes: PropTypes.string,

  /**
   * The `src` attribute for the `img` element.
   */
  src: PropTypes.string,

  /**
   * The `srcSet` attribute for the `img` element.
   */
  srcSet: PropTypes.string,

  /**
   * The shape of the avatar.
   */
  variant: PropTypes.oneOf(['circle', 'rounded', 'square'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiAvatar'
})(Avatar));

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Fade__ = __webpack_require__(252);







var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
var Backdrop = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Backdrop(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      transitionDuration = props.transitionDuration,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: open,
    timeout: transitionDuration
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, invisible && classes.invisible),
    "aria-hidden": true,
    ref: ref
  }, children));
});
 false ? Backdrop.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBackdrop'
})(Backdrop));

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(28);









var styles = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_5__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_5__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Fade = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Fade(props, ref) {
  var children = props.children,
      inProp = props.in,
      onEnter = props.onEnter,
      onExit = props.onExit,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, ref);

  var handleEnter = function handleEnter(node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__["a" /* Transition */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    onEnter: handleEnter,
    onExit: handleExit,
    timeout: timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], {}, style, {}, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Fade.propTypes = {
  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Fade);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Transition__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_PropTypes__ = __webpack_require__(398);










var _addClass = function addClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_4_dom_helpers_addClass__["a" /* default */])(node, c);
  });
};

var removeClass = function removeClass(node, classes) {
  return node && classes && classes.split(' ').forEach(function (c) {
    return Object(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_removeClass__["a" /* default */])(node, c);
  });
};
/**
 * A transition component inspired by the excellent
 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
 * using CSS transitions or animations. It's built upon the
 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
 * component, so it inherits all of its props.
 *
 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
 * and `exit` states of the transition. The first class is applied and then a
 * second `*-active` class in order to activate the CSS transition. After the
 * transition, matching `*-done` class names are applied to persist the
 * transition state.
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
 *         <div>
 *           {"I'll receive my-node-* classes"}
 *         </div>
 *       </CSSTransition>
 *       <button type="button" onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the `in` prop is set to `true`, the child component will first receive
 * the class `example-enter`, then the `example-enter-active` will be added in
 * the next tick. `CSSTransition` [forces a
 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
 * between before adding the `example-enter-active`. This is an important trick
 * because it allows us to transition between `example-enter` and
 * `example-enter-active` even though they were added immediately one after
 * another. Most notably, this is what makes it possible for us to animate
 * _appearance_.
 *
 * ```css
 * .my-node-enter {
 *   opacity: 0;
 * }
 * .my-node-enter-active {
 *   opacity: 1;
 *   transition: opacity 200ms;
 * }
 * .my-node-exit {
 *   opacity: 1;
 * }
 * .my-node-exit-active {
 *   opacity: 0;
 *   transition: opacity 200ms;
 * }
 * ```
 *
 * `*-active` classes represent which styles you want to animate **to**.
 *
 * **Note**: If you're using the
 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
 * prop, make sure to define styles for `.appear-*` classes as well.
 */


var CSSTransition =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(CSSTransition, _React$Component);

  function CSSTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    };

    _this.onEnter = function (node, appearing) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');

      if (_this.props.onEnter) {
        _this.props.onEnter(node, appearing);
      }
    };

    _this.onEntering = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.addClass(node, type, 'active');

      if (_this.props.onEntering) {
        _this.props.onEntering(node, appearing);
      }
    };

    _this.onEntered = function (node, appearing) {
      var type = appearing ? 'appear' : 'enter';

      _this.removeClasses(node, type);

      _this.addClass(node, type, 'done');

      if (_this.props.onEntered) {
        _this.props.onEntered(node, appearing);
      }
    };

    _this.onExit = function (node) {
      _this.removeClasses(node, 'appear');

      _this.removeClasses(node, 'enter');

      _this.addClass(node, 'exit', 'base');

      if (_this.props.onExit) {
        _this.props.onExit(node);
      }
    };

    _this.onExiting = function (node) {
      _this.addClass(node, 'exit', 'active');

      if (_this.props.onExiting) {
        _this.props.onExiting(node);
      }
    };

    _this.onExited = function (node) {
      _this.removeClasses(node, 'exit');

      _this.addClass(node, 'exit', 'done');

      if (_this.props.onExited) {
        _this.props.onExited(node);
      }
    };

    _this.getClassNames = function (type) {
      var classNames = _this.props.classNames;
      var isStringClassNames = typeof classNames === 'string';
      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
      return {
        baseClassName: baseClassName,
        activeClassName: activeClassName,
        doneClassName: doneClassName
      };
    };

    return _this;
  }

  var _proto = CSSTransition.prototype;

  _proto.addClass = function addClass(node, type, phase) {
    var className = this.getClassNames(type)[phase + "ClassName"];

    if (type === 'appear' && phase === 'done') {
      className += " " + this.getClassNames('enter').doneClassName;
    } // This is for to force a repaint,
    // which is necessary in order to transition styles when adding a class name.


    if (phase === 'active') {
      /* eslint-disable no-unused-expressions */
      node && node.scrollTop;
    }

    this.appliedClasses[type][phase] = className;

    _addClass(node, className);
  };

  _proto.removeClasses = function removeClasses(node, type) {
    var _this$appliedClasses$ = this.appliedClasses[type],
        baseClassName = _this$appliedClasses$.base,
        activeClassName = _this$appliedClasses$.active,
        doneClassName = _this$appliedClasses$.done;
    this.appliedClasses[type] = {};

    if (baseClassName) {
      removeClass(node, baseClassName);
    }

    if (activeClassName) {
      removeClass(node, activeClassName);
    }

    if (doneClassName) {
      removeClass(node, doneClassName);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        _ = _this$props.classNames,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["classNames"]);

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Transition__["d" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  };

  return CSSTransition;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

CSSTransition.defaultProps = {
  classNames: ''
};
CSSTransition.propTypes =  false ? _extends({}, Transition.propTypes, {
  /**
   * The animation classNames applied to the component as it appears, enters,
   * exits or has finished the transition. A single name can be provided and it
   * will be suffixed for each stage: e.g.
   *
   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
   *
   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
   * This allows you to define different behavior for when appearing is done and
   * when regular entering is done, using selectors like
   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
   * epic entrance animation when element first appears in the DOM using
   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
   * simply use `fade-enter-done` for defining both cases.
   *
   * Each individual classNames can also be specified independently like:
   *
   * ```js
   * classNames={{
   *  appear: 'my-appear',
   *  appearActive: 'my-active-appear',
   *  appearDone: 'my-done-appear',
   *  enter: 'my-enter',
   *  enterActive: 'my-active-enter',
   *  enterDone: 'my-done-enter',
   *  exit: 'my-exit',
   *  exitActive: 'my-active-exit',
   *  exitDone: 'my-done-exit',
   * }}
   * ```
   *
   * If you want to set these classes using CSS Modules:
   *
   * ```js
   * import styles from './styles.css';
   * ```
   *
   * you might want to use camelCase in your CSS file, that way could simply
   * spread them instead of listing them one by one:
   *
   * ```js
   * classNames={{ ...styles }}
   * ```
   *
   * @type {string | {
   *  appear?: string,
   *  appearActive?: string,
   *  appearDone?: string,
   *  enter?: string,
   *  enterActive?: string,
   *  enterDone?: string,
   *  exit?: string,
   *  exitActive?: string,
   *  exitDone?: string,
   * }}
   */
  classNames: classNamesShape,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
   * applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEnter: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter-active' or
   * 'appear-active' class is applied.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'enter' or
   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntered: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' class is
   * applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExit: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
   *
   * @type Function(node: HtmlElement)
   */
  onExiting: PropTypes.func,

  /**
   * A `<Transition>` callback fired immediately after the 'exit' classes
   * are **removed** and the `exit-done` class is added to the DOM node.
   *
   * @type Function(node: HtmlElement)
   */
  onExited: PropTypes.func
}) : {};
/* unused harmony default export */ var _unused_webpack_default_export = (CSSTransition);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addClass;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__hasClass__ = __webpack_require__(936);

function addClass(element, className) {
  if (element.classList) element.classList.add(className);else if (!Object(__WEBPACK_IMPORTED_MODULE_0__hasClass__["a" /* default */])(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
}

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = hasClass;
function hasClass(element, className) {
  if (element.classList) return !!className && element.classList.contains(className);
  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = removeClass;
function replaceClassName(origClass, classToRemove) {
  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}

function removeClass(element, className) {
  if (element.classList) {
    element.classList.remove(className);
  } else if (typeof element.className === 'string') {
    ;
    element.className = replaceClassName(element.className, className);
  } else {
    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
  }
}

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TransitionGroup__ = __webpack_require__(399);






/**
 * The `<ReplaceTransition>` component is a specialized `Transition` component
 * that animates between two children.
 *
 * ```jsx
 * <ReplaceTransition in>
 *   <Fade><div>I appear first</div></Fade>
 *   <Fade><div>I replace the above</div></Fade>
 * </ReplaceTransition>
 * ```
 */

var ReplaceTransition =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReplaceTransition, _React$Component);

  function ReplaceTransition() {
    var _this;

    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
      _args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;

    _this.handleEnter = function () {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _this.handleLifecycle('onEnter', 0, args);
    };

    _this.handleEntering = function () {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return _this.handleLifecycle('onEntering', 0, args);
    };

    _this.handleEntered = function () {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return _this.handleLifecycle('onEntered', 0, args);
    };

    _this.handleExit = function () {
      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
        args[_key5] = arguments[_key5];
      }

      return _this.handleLifecycle('onExit', 1, args);
    };

    _this.handleExiting = function () {
      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
        args[_key6] = arguments[_key6];
      }

      return _this.handleLifecycle('onExiting', 1, args);
    };

    _this.handleExited = function () {
      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
        args[_key7] = arguments[_key7];
      }

      return _this.handleLifecycle('onExited', 1, args);
    };

    return _this;
  }

  var _proto = ReplaceTransition.prototype;

  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
    var _child$props;

    var children = this.props.children;
    var child = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children)[idx];
    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
    if (this.props[handler]) this.props[handler](__WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(this));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        inProp = _this$props.in,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "in"]);

    var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children),
        first = _React$Children$toArr[0],
        second = _React$Children$toArr[1];

    delete props.onEnter;
    delete props.onEntering;
    delete props.onEntered;
    delete props.onExit;
    delete props.onExiting;
    delete props.onExited;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__TransitionGroup__["a" /* default */], props, inProp ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(first, {
      key: 'first',
      onEnter: this.handleEnter,
      onEntering: this.handleEntering,
      onEntered: this.handleEntered
    }) : __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(second, {
      key: 'second',
      onEnter: this.handleExit,
      onEntering: this.handleExiting,
      onEntered: this.handleExited
    }));
  };

  return ReplaceTransition;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

ReplaceTransition.propTypes =  false ? {
  in: PropTypes.bool.isRequired,
  children: function children(props, propName) {
    if (React.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
    return null;
  }
} : {};
/* unused harmony default export */ var _unused_webpack_default_export = (ReplaceTransition);

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getChildMapping;
/* unused harmony export mergeChildMappings */
/* harmony export (immutable) */ __webpack_exports__["b"] = getInitialChildMapping;
/* harmony export (immutable) */ __webpack_exports__["c"] = getNextChildMapping;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) __WEBPACK_IMPORTED_MODULE_0_react__["Children"].map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(child)) return;
    var hasPrev = key in prevChildMapping;
    var hasNext = key in nextChildMapping;
    var prevChild = prevChildMapping[key];
    var isLeaving = Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        in: false
      });
    } else if (hasNext && hasPrev && Object(__WEBPACK_IMPORTED_MODULE_0_react__["isValidElement"])(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = Object(__WEBPACK_IMPORTED_MODULE_0_react__["cloneElement"])(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export modes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Transition__ = __webpack_require__(253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__ = __webpack_require__(254);


var _leaveRenders, _enterRenders;






function areChildrenDifferent(oldChildren, newChildren) {
  if (oldChildren === newChildren) return false;

  if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(oldChildren) && __WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
    return false;
  }

  return true;
}
/**
 * Enum of modes for SwitchTransition component
 * @enum { string }
 */


var modes = {
  out: 'out-in',
  in: 'in-out'
};

var callHook = function callHook(element, name, cb) {
  return function () {
    var _element$props;

    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
    cb();
  };
};

var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
  var current = _ref.current,
      changeState = _ref.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */], null);
    })
  });
}, _leaveRenders[modes.in] = function (_ref2) {
  var current = _ref2.current,
      changeState = _ref2.changeState,
      children = _ref2.children;
  return [current, __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]);
    })
  })];
}, _leaveRenders);
var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
  var children = _ref3.children,
      changeState = _ref3.changeState;
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true,
    onEntered: callHook(children, 'onEntered', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  });
}, _enterRenders[modes.in] = function (_ref4) {
  var current = _ref4.current,
      children = _ref4.children,
      changeState = _ref4.changeState;
  return [__WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(current, {
    in: false,
    onExited: callHook(current, 'onExited', function () {
      changeState(__WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */], __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
        in: true
      }));
    })
  }), __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    in: true
  })];
}, _enterRenders);
/**
 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
 * You can use it when you want to control the render between state transitions.
 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
 *
 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child
 *
 * ```jsx
 *
 * function App() {
 *  const [state, setState] = useState(false);
 *  return (
 *    <SwitchTransition>
 *      <FadeTransition key={state ? "Goodbye, world!" : "Hello, world!"}
 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
 *        classNames='fade' >
 *        <button onClick={() => setState(state => !state)}>
 *          {state ? "Goodbye, world!" : "Hello, world!"}
 *        </button>
 *      </FadeTransition>
 *    </SwitchTransition>
 *  )
 * }
 * ```
 */

var SwitchTransition =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(SwitchTransition, _React$Component);

  function SwitchTransition() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.state = {
      status: __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */],
      current: null
    };
    _this.appeared = false;

    _this.changeState = function (status, current) {
      if (current === void 0) {
        current = _this.state.current;
      }

      _this.setState({
        status: status,
        current: current
      });
    };

    return _this;
  }

  var _proto = SwitchTransition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.appeared = true;
  };

  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
    if (props.children == null) {
      return {
        current: null
      };
    }

    if (state.status === __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */] && props.mode === modes.in) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]
      };
    }

    if (state.current && areChildrenDifferent(state.current, props.children)) {
      return {
        status: __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]
      };
    }

    return {
      current: __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(props.children, {
        in: true
      })
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        mode = _this$props.mode,
        _this$state = this.state,
        status = _this$state.status,
        current = _this$state.current;
    var data = {
      children: children,
      current: current,
      changeState: this.changeState,
      status: status
    };
    var component;

    switch (status) {
      case __WEBPACK_IMPORTED_MODULE_3__Transition__["b" /* ENTERING */]:
        component = enterRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["c" /* EXITING */]:
        component = leaveRenders[mode](data);
        break;

      case __WEBPACK_IMPORTED_MODULE_3__Transition__["a" /* ENTERED */]:
        component = current;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__TransitionGroupContext__["a" /* default */].Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, component);
  };

  return SwitchTransition;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

SwitchTransition.propTypes =  false ? {
  /**
   * Transition modes.
   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
   * `in-out: New element transitions in first, then when complete, the current element transitions out.`
   *
   * @type {'out-in'|'in-out'}
   */
  mode: PropTypes.oneOf([modes.in, modes.out]),

  /**
   * Any `Transition` or `CSSTransition` component
   */
  children: PropTypes.oneOfType([PropTypes.element.isRequired])
} : {};
SwitchTransition.defaultProps = {
  mode: modes.out
};
/* unused harmony default export */ var _unused_webpack_default_export = (SwitchTransition);

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Badge__ = __webpack_require__(942);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Badge__["a"]; });


/***/ }),
/* 942 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var RADIUS_STANDARD = 10;
var RADIUS_DOT = 3;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'inline-flex',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      flexShrink: 0
    },

    /* Styles applied to the badge `span` element. */
    badge: {
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center',
      position: 'absolute',
      boxSizing: 'border-box',
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(12),
      minWidth: RADIUS_STANDARD * 2,
      lineHeight: 1,
      padding: '0 6px',
      height: RADIUS_STANDARD * 2,
      borderRadius: RADIUS_STANDARD,
      backgroundColor: theme.palette.color,
      color: theme.palette.textColor,
      zIndex: 1,
      // Render the badge on top of potential ripples.
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.enteringScreen
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.error.contrastText
    },

    /* Styles applied to the root element if `variant="dot"`. */
    dot: {
      height: RADIUS_DOT * 2,
      minWidth: RADIUS_DOT * 2,
      padding: 0
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
    anchorOriginTopRightRectangle: {
      top: 0,
      right: 0,
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
    anchorOriginBottomRightRectangle: {
      bottom: 0,
      right: 0,
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
    anchorOriginTopLeftRectangle: {
      top: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
    anchorOriginBottomLeftRectangle: {
      bottom: 0,
      left: 0,
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
    anchorOriginTopRightCircle: {
      top: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, -50%)',
      transformOrigin: '100% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
    anchorOriginBottomRightCircle: {
      bottom: '14%',
      right: '14%',
      transform: 'scale(1) translate(50%, 50%)',
      transformOrigin: '100% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(50%, 50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
    anchorOriginTopLeftCircle: {
      top: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, -50%)',
      transformOrigin: '0% 0%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, -50%)'
      }
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
    anchorOriginBottomLeftCircle: {
      bottom: '14%',
      left: '14%',
      transform: 'scale(1) translate(-50%, 50%)',
      transformOrigin: '0% 100%',
      '&$invisible': {
        transform: 'scale(0) translate(-50%, 50%)'
      }
    },

    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
    invisible: {
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeInOut,
        duration: theme.transitions.duration.leavingScreen
      })
    }
  };
};
var Badge = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Badge(props, ref) {
  var _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'right'
  } : _props$anchorOrigin,
      badgeContent = props.badgeContent,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
      invisibleProp = props.invisible,
      _props$max = props.max,
      max = _props$max === void 0 ? 99 : _props$max,
      _props$overlap = props.overlap,
      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
      _props$showZero = props.showZero,
      showZero = _props$showZero === void 0 ? false : _props$showZero,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);

  var invisible = invisibleProp;

  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
    invisible = true;
  }

  var displayValue = '';

  if (variant !== 'dot') {
    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), children, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.badge, classes["".concat(anchorOrigin.horizontal).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(anchorOrigin.horizontal)).concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(overlap))], color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], invisible && classes.invisible, {
      dot: classes.dot
    }[variant])
  }, displayValue));
});
 false ? Badge.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The anchor of the badge.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'right']).isRequired,
    vertical: PropTypes.oneOf(['bottom', 'top']).isRequired
  }),

  /**
   * The content rendered within the badge.
   */
  badgeContent: PropTypes.node,

  /**
   * The badge will be added relative to this node.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'error', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the badge will be invisible.
   */
  invisible: PropTypes.bool,

  /**
   * Max count to show.
   */
  max: PropTypes.number,

  /**
   * Wrapped shape the badge should overlap.
   */
  overlap: PropTypes.oneOf(['circle', 'rectangle']),

  /**
   * Controls whether the badge is hidden when `badgeContent` is zero.
   */
  showZero: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['dot', 'standard'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBadge'
})(Badge));

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigation__ = __webpack_require__(944);
/* unused harmony reexport default */


/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      justifyContent: 'center',
      height: 56,
      backgroundColor: theme.palette.background.paper
    }
  };
};
var BottomNavigation = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function BottomNavigation(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      onChange = props.onChange,
      _props$showLabels = props.showLabels,
      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, childIndex) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
      selected: childValue === value,
      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
      value: childValue,
      onChange: onChange
    });
  }));
});
 false ? BottomNavigation.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child
   */
  onChange: PropTypes.func,

  /**
   * If `true`, all `BottomNavigationAction`s will show their labels.
   * By default, only the selected `BottomNavigationAction` will show its label.
   */
  showLabels: PropTypes.bool,

  /**
   * The value of the currently selected `BottomNavigationAction`.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigation'
})(BottomNavigation));

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BottomNavigationAction__ = __webpack_require__(946);
/* unused harmony reexport default */


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_unsupportedProp__ = __webpack_require__(175);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      transition: theme.transitions.create(['color', 'padding-top'], {
        duration: theme.transitions.duration.short
      }),
      padding: '6px 12px 8px',
      minWidth: 80,
      maxWidth: 168,
      color: theme.palette.text.secondary,
      flex: '1',
      '&$iconOnly': {
        paddingTop: 16
      },
      '&$selected': {
        paddingTop: 6,
        color: theme.palette.primary.main
      }
    },

    /* Pseudo-class applied to the root element if selected. */
    selected: {},

    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
    iconOnly: {},

    /* Styles applied to the span element that wraps the icon and label. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    },

    /* Styles applied to the label's span element. */
    label: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(12),
      opacity: 1,
      transition: 'font-size 0.2s, opacity 0.2s',
      transitionDelay: '0.1s',
      '&$iconOnly': {
        opacity: 0,
        transitionDelay: '0s'
      },
      '&$selected': {
        fontSize: theme.typography.pxToRem(14)
      }
    }
  };
};
var BottomNavigationAction = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function BottomNavigationAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      icon = props.icon,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      showLabel = props.showLabel,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
    focusRipple: true,
    onClick: handleChange
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.wrapper
  }, icon, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
  }, label)));
});
 false ? BottomNavigationAction.propTypes = {
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * If `true`, the `BottomNavigationAction` will show its label.
   * By default, only the selected `BottomNavigationAction`
   * inside `BottomNavigation` will show its label.
   */
  showLabel: PropTypes.bool,

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBottomNavigationAction'
})(BottomNavigationAction));

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NoSsr__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_focusVisible__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__TouchRipple__ = __webpack_require__(949);













var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    textDecoration: 'none',
    // So we take precedent over the style of a native <a /> element.
    color: 'inherit',
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$disabled': {
      pointerEvents: 'none',
      // Disable link interactions
      cursor: 'default'
    }
  },

  /* Pseudo-class applied to the root element if `disabled={true}`. */
  disabled: {},

  /* Pseudo-class applied to the root element if keyboard focused. */
  focusVisible: {}
};
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

var ButtonBase = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ButtonBase(props, ref) {
  var action = props.action,
      buttonRefProp = props.buttonRef,
      _props$centerRipple = props.centerRipple,
      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$disableTouchRi = props.disableTouchRipple,
      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
      _props$focusRipple = props.focusRipple,
      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
      focusVisibleClassName = props.focusVisibleClassName,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onFocusVisible = props.onFocusVisible,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      onMouseDown = props.onMouseDown,
      onMouseLeave = props.onMouseLeave,
      onMouseUp = props.onMouseUp,
      onTouchEnd = props.onTouchEnd,
      onTouchMove = props.onTouchMove,
      onTouchStart = props.onTouchStart,
      onDragLeave = props.onDragLeave,
      _props$tabIndex = props.tabIndex,
      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
      TouchRippleProps = props.TouchRippleProps,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);

  var buttonRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  function getButtonNode() {
    // #StrictMode ready
    return __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(buttonRef.current);
  }

  var rippleRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_11__utils_focusVisible__["a" /* useIsFocusVisible */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(action, function () {
    return {
      focusVisible: function focusVisible() {
        setFocusVisible(true);
        buttonRef.current.focus();
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback) {
    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
    return Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
      if (eventCallback) {
        eventCallback(event);
      }

      var ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  var handleMouseDown = useRippleHandler('start', onMouseDown);
  var handleDragLeave = useRippleHandler('stop', onDragLeave);
  var handleMouseUp = useRippleHandler('stop', onMouseUp);
  var handleMouseLeave = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  var handleTouchStart = useRippleHandler('start', onTouchStart);
  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  var handleTouchMove = useRippleHandler('stop', onTouchMove);
  var handleBlur = useRippleHandler('stop', function (event) {
    if (focusVisible) {
      onBlurVisible(event);
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    if (disabled) {
      return;
    } // Fix for https://github.com/facebook/react/issues/7769


    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    if (isFocusVisible(event)) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  var isNonNativeButton = function isNonNativeButton() {
    var button = getButtonNode();
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  var keydownRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(false);
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.start(event);
      });
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter') {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var handleKeyUp = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useEventCallback__["a" /* default */])(function (event) {
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible) {
      keydownRef.current = false;
      event.persist();
      rippleRef.current.stop(event, function () {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  var ComponentProp = component;

  if (ComponentProp === 'button' && other.href) {
    ComponentProp = 'a';
  }

  var buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type;
    buttonProps.disabled = disabled;
  } else {
    if (ComponentProp !== 'a' || !other.href) {
      buttonProps.role = 'button';
    }

    buttonProps['aria-disabled'] = disabled;
  }

  var handleUserRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(buttonRefProp, ref);
  var handleOwnRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(focusVisibleRef, buttonRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(handleUserRef, handleOwnRef);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ComponentProp, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
    onBlur: handleBlur,
    onClick: onClick,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex
  }, buttonProps, other), children, !disableRipple && !disabled ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__NoSsr__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__TouchRipple__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: rippleRef,
    center: centerRipple
  }, TouchRippleProps))) : null);
});
 false ? ButtonBase.propTypes = {
  /**
   * A ref for imperative actions.
   * It currently only supports `focusVisible()` action.
   */
  action: refType,

  /**
   * @ignore
   *
   * Use that prop to pass a ref to the native button component.
   * @deprecated Use `ref` instead.
   */
  buttonRef: refType,

  /**
   * If `true`, the ripples will be centered.
   * They won't start at the cursor interaction position.
   */
  centerRipple: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * If `true`, the base button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the touch ripple effect will be disabled.
   */
  disableTouchRipple: PropTypes.bool,

  /**
   * If `true`, the base button will have a keyboard focus ripple.
   * `disableRipple` must also be `false`.
   */
  focusRipple: PropTypes.bool,

  /**
   * This prop can help a person know which element has the keyboard focus.
   * The class name will be applied when the element gain the focus through a keyboard interaction.
   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
   * if needed.
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onDragLeave: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component is focused with a keyboard.
   * We trigger a `onFocus` callback too.
   */
  onFocusVisible: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseUp: PropTypes.func,

  /**
   * @ignore
   */
  onTouchEnd: PropTypes.func,

  /**
   * @ignore
   */
  onTouchMove: PropTypes.func,

  /**
   * @ignore
   */
  onTouchStart: PropTypes.func,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * Props applied to the `TouchRipple` element.
   */
  TouchRippleProps: PropTypes.object,

  /**
   * Used to control the button's purpose.
   * This prop passes the value to the `type` attribute of the native button component.
   */
  type: PropTypes.oneOf(['submit', 'reset', 'button'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonBase'
})(ButtonBase));

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_utils__ = __webpack_require__(12);



var useEnhancedEffect = typeof window !== 'undefined' && "production" !== 'test' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect;
/**
 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
 *
 * This component can be useful in a variety of situations:
 * - Escape hatch for broken dependencies not supporting SSR.
 * - Improve the time-to-first paint on the client by only rendering above the fold.
 * - Reduce the rendering time on the server.
 * - Under too heavy server load, you can turn on service degradation.
 */

function NoSsr(props) {
  var children = props.children,
      _props$defer = props.defer,
      defer = _props$defer === void 0 ? false : _props$defer,
      _props$fallback = props.fallback,
      fallback = _props$fallback === void 0 ? null : _props$fallback;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
      mountedState = _React$useState[0],
      setMountedState = _React$useState[1];

  useEnhancedEffect(function () {
    if (!defer) {
      setMountedState(true);
    }
  }, [defer]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    if (defer) {
      setMountedState(true);
    }
  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, mountedState ? children : fallback);
}

 false ? NoSsr.propTypes = {
  /**
   * You can wrap a node.
   */
  children: PropTypes.node.isRequired,

  /**
   * If `true`, the component will not only prevent server-side rendering.
   * It will also defer the rendering of the children into a different screen frame.
   */
  defer: PropTypes.bool,

  /**
   * The fallback content to display.
   */
  fallback: PropTypes.node
} : void 0;

if (false) {
  // eslint-disable-next-line
  NoSsr['propTypes' + ''] = exactProp(NoSsr.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (NoSsr);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DELAY_RIPPLE */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Ripple__ = __webpack_require__(950);









var DURATION = 550;
var DELAY_RIPPLE = 80;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      zIndex: 0,
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit'
    },

    /* Styles applied to the internal `Ripple` components `ripple` class. */
    ripple: {
      opacity: 0,
      position: 'absolute'
    },

    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
    rippleVisible: {
      opacity: 0.3,
      transform: 'scale(1)',
      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
    ripplePulsate: {
      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
    },

    /* Styles applied to the internal `Ripple` components `child` class. */
    child: {
      opacity: 1,
      display: 'block',
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
    childLeaving: {
      opacity: 0,
      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
    },

    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
    childPulsate: {
      position: 'absolute',
      left: 0,
      top: 0,
      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
    },
    '@keyframes enter': {
      '0%': {
        transform: 'scale(0)',
        opacity: 0.1
      },
      '100%': {
        transform: 'scale(1)',
        opacity: 0.3
      }
    },
    '@keyframes exit': {
      '0%': {
        opacity: 1
      },
      '100%': {
        opacity: 0
      }
    },
    '@keyframes pulsate': {
      '0%': {
        transform: 'scale(1)'
      },
      '50%': {
        transform: 'scale(0.92)'
      },
      '100%': {
        transform: 'scale(1)'
      }
    }
  };
};
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

var TouchRipple = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function TouchRipple(props, ref) {
  var _props$center = props.center,
      centerProp = _props$center === void 0 ? false : _props$center,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["center", "classes", "className"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState([]),
      ripples = _React$useState[0],
      setRipples = _React$useState[1];

  var nextKey = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(0);
  var rippleCallback = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  var ignoringMouseDown = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  var startTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null); // This is the hook called once the previous timeout is ready.

  var startTimerCommit = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  var container = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    return function () {
      clearTimeout(startTimer.current);
    };
  }, []);
  var startCommit = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (params) {
    var pulsate = params.pulsate,
        rippleX = params.rippleX,
        rippleY = params.rippleY,
        rippleSize = params.rippleSize,
        cb = params.cb;
    setRipples(function (oldRipples) {
      return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(oldRipples), [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Ripple__["a" /* default */], {
        key: nextKey.current,
        classes: classes,
        timeout: DURATION,
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize
      })]);
    });
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  var start = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function () {
    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var cb = arguments.length > 2 ? arguments[2] : undefined;
    var _options$pulsate = options.pulsate,
        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
        _options$center = options.center,
        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
        _options$fakeElement = options.fakeElement,
        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    var element = fakeElement ? null : container.current;
    var rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    var rippleX;
    var rippleY;
    var rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
      var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
    } // Touche devices


    if (event.touches) {
      // Prepare the ripple effect.
      startTimerCommit.current = function () {
        startCommit({
          pulsate: pulsate,
          rippleX: rippleX,
          rippleY: rippleY,
          rippleSize: rippleSize,
          cb: cb
        });
      }; // Delay the execution of the ripple effect.


      startTimer.current = setTimeout(function () {
        if (startTimerCommit.current) {
          startTimerCommit.current();
          startTimerCommit.current = null;
        }
      }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
    } else {
      startCommit({
        pulsate: pulsate,
        rippleX: rippleX,
        rippleY: rippleY,
        rippleSize: rippleSize,
        cb: cb
      });
    }
  }, [centerProp, startCommit]);
  var pulsate = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function () {
    start({}, {
      pulsate: true
    });
  }, [start]);
  var stop = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (event, cb) {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      event.persist();
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(function () {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(function (oldRipples) {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useImperativeHandle(ref, function () {
    return {
      pulsate: pulsate,
      start: start,
      stop: stop
    };
  }, [pulsate, start, stop]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className),
    ref: container
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["b" /* TransitionGroup */], {
    component: null,
    exit: true
  }, ripples));
}); // TODO cleanup after https://github.com/reactjs/react-docgen/pull/378 is released

function withMuiName(Component) {
  Component.muiName = 'MuiTouchRipple';
  return Component;
}

 false ? TouchRipple.propTypes = {
  /**
   * If `true`, the ripple starts at the center of the component
   * rather than at the point of interaction.
   */
  center: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiTouchRipple'
})(withMuiName(__WEBPACK_IMPORTED_MODULE_3_react___default.a.memo(TouchRipple))));

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__ = __webpack_require__(83);




var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect : __WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect;
/**
 * @ignore - internal component.
 */

function Ripple(props) {
  var classes = props.classes,
      _props$pulsate = props.pulsate,
      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
      rippleX = props.rippleX,
      rippleY = props.rippleY,
      rippleSize = props.rippleSize,
      inProp = props.in,
      _props$onExited = props.onExited,
      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
      timeout = props.timeout;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(false),
      leaving = _React$useState[0],
      setLeaving = _React$useState[1];

  var rippleClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  var rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  var childClassName = Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
  var handleExited = Object(__WEBPACK_IMPORTED_MODULE_3__utils_useEventCallback__["a" /* default */])(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority

  useEnhancedEffect(function () {
    if (!inProp) {
      // react-transition-group#onExit
      setLeaving(true); // react-transition-group#onExited

      var timeoutId = setTimeout(handleExited, timeout);
      return function () {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [handleExited, inProp, timeout]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: rippleClassName,
    style: rippleStyles
  }, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("span", {
    className: childClassName
  }));
}

 false ? Ripple.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore - injected from TransitionGroup
   */
  in: PropTypes.bool,

  /**
   * @ignore - injected from TransitionGroup
   */
  onExited: PropTypes.func,

  /**
   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
   */
  pulsate: PropTypes.bool,

  /**
   * Diameter of the ripple.
   */
  rippleSize: PropTypes.number,

  /**
   * Horizontal position of the ripple center.
   */
  rippleX: PropTypes.number,

  /**
   * Vertical position of the ripple center.
   */
  rippleY: PropTypes.number,

  /**
   * exit delay
   */
  timeout: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Ripple);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Box__ = __webpack_require__(952);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Box__["a"]; });
/* unused harmony reexport styleFunction */


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styleFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_system__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_styled__ = __webpack_require__(396);


var styleFunction = Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["c" /* css */])(Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["b" /* compose */])(__WEBPACK_IMPORTED_MODULE_0__material_ui_system__["a" /* borders */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["d" /* display */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["e" /* flexbox */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["g" /* positions */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["f" /* palette */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["h" /* shadows */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["i" /* sizing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["j" /* spacing */], __WEBPACK_IMPORTED_MODULE_0__material_ui_system__["k" /* typography */]));
/**
 * @ignore - do not document.
 */

var Box = Object(__WEBPACK_IMPORTED_MODULE_1__styles_styled__["a" /* default */])('div')(styleFunction, {
  name: 'MuiBox'
});
/* harmony default export */ __webpack_exports__["a"] = (Box);

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__borders__ = __webpack_require__(400);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__borders__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__(256);
/* unused harmony reexport breakpoints */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__compose__ = __webpack_require__(84);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__compose__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__css__ = __webpack_require__(954);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__css__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__display__ = __webpack_require__(955);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__display__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__flexbox__ = __webpack_require__(402);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_5__flexbox__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__palette__ = __webpack_require__(403);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_6__palette__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__positions__ = __webpack_require__(404);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_7__positions__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shadows__ = __webpack_require__(956);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_8__shadows__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__sizing__ = __webpack_require__(405);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_9__sizing__["a"]; });
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__spacing__ = __webpack_require__(957);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_10__spacing__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__style__ = __webpack_require__(74);
/* unused harmony reexport style */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__typography__ = __webpack_require__(409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_12__typography__["a"]; });
/* unused harmony namespace reexport */
/** @license Material-UI v4.5.2
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */




















/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(176);





function omit(input, fields) {
  var output = {};
  Object.keys(input).forEach(function (prop) {
    if (fields.indexOf(prop) === -1) {
      output[prop] = input[prop];
    }
  });
  return output;
}

function css(styleFunction) {
  var newStyleFunction = function newStyleFunction(props) {
    var output = styleFunction(props);

    if (props.css) {
      return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */])(output, styleFunction(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
        theme: props.theme
      }, props.css))), {}, omit(props.css, [styleFunction.filterProps]));
    }

    return output;
  };

  newStyleFunction.propTypes =  false ? _extends({}, styleFunction.propTypes, {
    css: PropTypes.object
  }) : {};
  newStyleFunction.filterProps = ['css'].concat(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(styleFunction.filterProps));
  return newStyleFunction;
}

/* harmony default export */ __webpack_exports__["a"] = (css);

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export displayPrint */
/* unused harmony export displayRaw */
/* unused harmony export overflow */
/* unused harmony export textOverflow */
/* unused harmony export visibility */
/* unused harmony export whiteSpace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__compose__ = __webpack_require__(84);


var displayPrint = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'displayPrint',
  cssProperty: false,
  transform: function transform(value) {
    return {
      '@media print': {
        display: value
      }
    };
  }
});
var displayRaw = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'display'
});
var overflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'overflow'
});
var textOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'textOverflow'
});
var visibility = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'visibility'
});
var whiteSpace = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'whiteSpace'
});
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__compose__["a" /* default */])(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace));

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__style__ = __webpack_require__(74);

var boxShadow = Object(__WEBPACK_IMPORTED_MODULE_0__style__["a" /* default */])({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
/* harmony default export */ __webpack_exports__["a"] = (boxShadow);

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__responsivePropType__ = __webpack_require__(401);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__breakpoints__ = __webpack_require__(256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__merge__ = __webpack_require__(176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__memoize__ = __webpack_require__(959);





var properties = {
  m: 'margin',
  p: 'padding'
};
var directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
var aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

var getCssProperties = Object(__WEBPACK_IMPORTED_MODULE_4__memoize__["a" /* default */])(function (prop) {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  var _prop$split = prop.split(''),
      _prop$split2 = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_prop$split, 2),
      a = _prop$split2[0],
      b = _prop$split2[1];

  var property = properties[a];
  var direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(function (dir) {
    return property + dir;
  }) : [property + direction];
});
var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];

function getTransformer(theme) {
  var themeSpacing = theme.spacing || 8;

  if (typeof themeSpacing === 'number') {
    return function (abs) {
      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return function (abs) {
      if (false) {
        if (abs > themeSpacing.length - 1) {
          console.error(["@material-ui/system: the value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
        }
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  if (false) {
    console.error(["@material-ui/system: the `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
  }

  return function () {
    return undefined;
  };
}

function getValue(transformer, propValue) {
  if (typeof propValue === 'string') {
    return propValue;
  }

  var abs = Math.abs(propValue);
  var transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return "-".concat(transformed);
}

function getStyleFromPropValue(cssProperties, transformer) {
  return function (propValue) {
    return cssProperties.reduce(function (acc, cssProperty) {
      acc[cssProperty] = getValue(transformer, propValue);
      return acc;
    }, {});
  };
}

function spacing(props) {
  var theme = props.theme;
  var transformer = getTransformer(theme);
  return Object.keys(props).map(function (prop) {
    // Using a hash computation over an array iteration could be faster, but with only 28 items,
    // it's doesn't worth the bundle size.
    if (spacingKeys.indexOf(prop) === -1) {
      return null;
    }

    var cssProperties = getCssProperties(prop);
    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
    var propValue = props[prop];
    return Object(__WEBPACK_IMPORTED_MODULE_2__breakpoints__["a" /* handleBreakpoints */])(props, propValue, styleFromPropValue);
  }).reduce(__WEBPACK_IMPORTED_MODULE_3__merge__["a" /* default */], {});
}

spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
  obj[key] = responsivePropType;
  return obj;
}, {}) : {};
spacing.filterProps = spacingKeys;
/* harmony default export */ __webpack_exports__["a"] = (spacing);

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _iterableToArrayLimit;
function _iterableToArrayLimit(arr, i) {
  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
    return;
  }

  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize;
function memoize(fn) {
  var cache = {};
  return function (arg) {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Breadcrumbs__ = __webpack_require__(961);
/* unused harmony reexport default */


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__BreadcrumbCollapsed__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BreadcrumbSeparator__ = __webpack_require__(966);










var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ol element. */
  ol: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    // Reset
    margin: 0 // Reset

  },

  /* Styles applied to the li element. */
  li: {
    listStyle: 'none'
  },

  /* Styles applied to the separator element. */
  separator: {}
};

function insertSeparators(items, className, separator) {
  return items.reduce(function (acc, current, index) {
    if (index < items.length - 1) {
      acc = acc.concat(current, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__BreadcrumbSeparator__["a" /* default */], {
        key: "separator-".concat(index),
        className: className
      }, separator));
    } else {
      acc.push(current);
    }

    return acc;
  }, []);
}

var Breadcrumbs = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Breadcrumbs(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'nav' : _props$component,
      _props$itemsAfterColl = props.itemsAfterCollapse,
      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
      _props$itemsBeforeCol = props.itemsBeforeCollapse,
      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
      _props$maxItems = props.maxItems,
      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
      _props$separator = props.separator,
      separator = _props$separator === void 0 ? '/' : _props$separator,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(false),
      expanded = _React$useState[0],
      setExpanded = _React$useState[1];

  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
    var handleClickExpand = function handleClickExpand() {
      setExpanded(true);
    }; // This defends against someone passing weird input, to ensure that if all
    // items would be shown anyway, we just show all items without the EllipsisItem


    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
      if (false) {
        console.error(['Material-UI: you have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
      }

      return allItems;
    }

    return [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(0, itemsBeforeCollapse)), [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__BreadcrumbCollapsed__["a" /* default */], {
      key: "ellipsis",
      onClick: handleClickExpand
    })], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
  };

  var allItems = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(children).filter(function (child) {
    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child);
  }).map(function (child, index) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", {
      className: classes.li,
      key: "child-".concat(index)
    }, child);
  });
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    component: Component,
    color: "textSecondary",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className)
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ol", {
    className: classes.ol
  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
});
 false ? Breadcrumbs.propTypes = {
  /**
   * The breadcrumb children.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.elementType,

  /**
   * If max items is exceeded, the number of items to show after the ellipsis.
   */
  itemsAfterCollapse: PropTypes.number,

  /**
   * If max items is exceeded, the number of items to show before the ellipsis.
   */
  itemsBeforeCollapse: PropTypes.number,

  /**
   * Specifies the maximum number of breadcrumbs to display. When there are more
   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
   * will be shown, with an ellipsis in between.
   */
  maxItems: PropTypes.number,

  /**
   * Custom separator node.
   */
  separator: PropTypes.node
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiBreadcrumbs'
})(Breadcrumbs));

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      margin: 0
    },

    /* Styles applied to the root element if `variant="body2"`. */
    body2: theme.typography.body2,

    /* Styles applied to the root element if `variant="body1"`. */
    body1: theme.typography.body1,

    /* Styles applied to the root element if `variant="caption"`. */
    caption: theme.typography.caption,

    /* Styles applied to the root element if `variant="button"`. */
    button: theme.typography.button,

    /* Styles applied to the root element if `variant="h1"`. */
    h1: theme.typography.h1,

    /* Styles applied to the root element if `variant="h2"`. */
    h2: theme.typography.h2,

    /* Styles applied to the root element if `variant="h3"`. */
    h3: theme.typography.h3,

    /* Styles applied to the root element if `variant="h4"`. */
    h4: theme.typography.h4,

    /* Styles applied to the root element if `variant="h5"`. */
    h5: theme.typography.h5,

    /* Styles applied to the root element if `variant="h6"`. */
    h6: theme.typography.h6,

    /* Styles applied to the root element if `variant="subtitle1"`. */
    subtitle1: theme.typography.subtitle1,

    /* Styles applied to the root element if `variant="subtitle2"`. */
    subtitle2: theme.typography.subtitle2,

    /* Styles applied to the root element if `variant="overline"`. */
    overline: theme.typography.overline,

    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
    srOnly: {
      position: 'absolute',
      height: 1,
      width: 1,
      overflow: 'hidden'
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `nowrap={true}`. */
    noWrap: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the root element if `gutterBottom={true}`. */
    gutterBottom: {
      marginBottom: '0.35em'
    },

    /* Styles applied to the root element if `paragraph={true}`. */
    paragraph: {
      marginBottom: 16
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="textPrimary"`. */
    colorTextPrimary: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `color="textSecondary"`. */
    colorTextSecondary: {
      color: theme.palette.text.secondary
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `display="inline"`. */
    displayInline: {
      display: 'inline'
    },

    /* Styles applied to the root element if `display="block"`. */
    displayBlock: {
      display: 'block'
    }
  };
};
var defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p'
};
var Typography = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Typography(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'initial' : _props$color,
      component = props.component,
      _props$display = props.display,
      display = _props$display === void 0 ? 'initial' : _props$display,
      _props$gutterBottom = props.gutterBottom,
      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
      _props$noWrap = props.noWrap,
      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
      _props$paragraph = props.paragraph,
      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'body1' : _props$variant,
      _props$variantMapping = props.variantMapping,
      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);

  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], display !== 'initial' && classes["display".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(display))]),
    ref: ref
  }, other));
});
 false ? Typography.propTypes = {
  /**
   * Set the text-align on the component.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it maps the variant to a good default headline component.
   */
  component: PropTypes.elementType,

  /**
   * Controls the display type
   */
  display: PropTypes.oneOf(['initial', 'block', 'inline']),

  /**
   * If `true`, the text will have a bottom margin.
   */
  gutterBottom: PropTypes.bool,

  /**
   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
   *
   * Note that text overflow can only happen with block or inline-block level elements
   * (the element needs to have a width in order to overflow).
   */
  noWrap: PropTypes.bool,

  /**
   * If `true`, the text will have a bottom margin.
   */
  paragraph: PropTypes.bool,

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),

  /**
   * We are empirically mapping the variant prop to a range of different DOM element types.
   * For instance, subtitle1 to `<h6>`.
   * If you wish to change that mapping, you can provide your own.
   * Alternatively, you can use the `component` prop.
   */
  variantMapping: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTypography'
})(Typography));

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__ = __webpack_require__(964);








var styles = function styles(theme) {
  return {
    root: {
      display: 'flex'
    },
    icon: {
      width: 24,
      height: 16,
      backgroundColor: theme.palette.grey[100],
      color: theme.palette.grey[700],
      borderRadius: 2,
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: theme.palette.grey[200]
      },
      '&:active': {
        boxShadow: theme.shadows[0],
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__styles_colorManipulator__["b" /* emphasize */])(theme.palette.grey[200], 0.12)
      }
    }
  };
};
/**
 * @ignore - internal component.
 */


function BreadcrumbCollapsed(props) {
  var classes = props.classes,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.root
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_MoreHoriz__["a" /* default */], {
    className: classes.icon
  }));
}

 false ? BreadcrumbCollapsed.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateBreadcrumbCollapsed'
})(BreadcrumbCollapsed));

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
}), 'MoreHoriz'));

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      width: '1em',
      height: '1em',
      display: 'inline-block',
      fill: 'currentColor',
      flexShrink: 0,
      fontSize: theme.typography.pxToRem(24),
      transition: theme.transitions.create('fill', {
        duration: theme.transitions.duration.shorter
      })
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the root element if `fontSize="inherit"`. */
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(35)
    }
  };
};
var SvgIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SvgIcon(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'svg' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      htmlColor = props.htmlColor,
      titleAccess = props.titleAccess,
      _props$viewBox = props.viewBox,
      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(fontSize))]),
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? 'false' : 'true',
    role: titleAccess ? 'img' : 'presentation',
    ref: ref
  }, other), children, titleAccess ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("title", null, titleAccess) : null);
});
 false ? SvgIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Node passed into the SVG element.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
   */
  color: PropTypes.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['default', 'inherit', 'large', 'small']),

  /**
   * Applies a color attribute to the SVG element.
   */
  htmlColor: PropTypes.string,

  /**
   * The shape-rendering attribute. The behavior of the different options is described on the
   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
   * If you are having issues with blurry icons you should investigate this property.
   */
  shapeRendering: PropTypes.string,

  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: PropTypes.string,

  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: PropTypes.string
} : void 0;
SvgIcon.muiName = 'SvgIcon';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSvgIcon'
})(SvgIcon));

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  root: {
    display: 'flex',
    userSelect: 'none',
    marginLeft: 8,
    marginRight: 8
  }
};
/**
 * @ignore - internal component.
 */

function BreadcrumbSeparator(props) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className)
  }, other));
}

 false ? BreadcrumbSeparator.propTypes = {
  children: PropTypes.node.isRequired,
  classes: PropTypes.object.isRequired,
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateBreadcrumbSeparator'
})(BreadcrumbSeparator));

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minWidth: 64,
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.text.primary,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      padding: '6px 8px'
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      padding: '5px 15px',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.primary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.5)),
      '&:hover': {
        border: "1px solid ".concat(theme.palette.secondary.main),
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        border: "1px solid ".concat(theme.palette.action.disabled)
      }
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      boxShadow: theme.shadows[2],
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        boxShadow: theme.shadows[4],
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          boxShadow: theme.shadows[2],
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        }
      },
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:active': {
        boxShadow: theme.shadows[8]
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
    containedPrimary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
    containedSecondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit',
      borderColor: 'currentColor'
    },

    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
    textSizeSmall: {
      padding: '4px 5px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
    textSizeLarge: {
      padding: '8px 11px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
    outlinedSizeSmall: {
      padding: '3px 9px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
    outlinedSizeLarge: {
      padding: '7px 21px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
    containedSizeSmall: {
      padding: '4px 10px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
    containedSizeLarge: {
      padding: '8px 22px',
      fontSize: theme.typography.pxToRem(15)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {},

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the startIcon element if supplied. */
    startIcon: {
      display: 'inherit',
      marginRight: 8,
      marginLeft: -4,
      '&$iconSizeSmall': {
        marginLeft: -2
      }
    },

    /* Styles applied to the endIcon element if supplied. */
    endIcon: {
      display: 'inherit',
      marginRight: -4,
      marginLeft: 8,
      '&$iconSizeSmall': {
        marginRight: -2
      }
    },

    /* Styles applied to the icon element if supplied and `size="small"`. */
    iconSizeSmall: {
      '& > *:first-child': {
        fontSize: 18
      }
    },

    /* Styles applied to the icon element if supplied and `size="medium"`. */
    iconSizeMedium: {
      '& > *:first-child': {
        fontSize: 20
      }
    },

    /* Styles applied to the icon element if supplied and `size="large"`. */
    iconSizeLarge: {
      '& > *:first-child': {
        fontSize: 22
      }
    }
  };
};
var Button = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Button(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      endIconProp = props.endIcon,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      startIconProp = props.startIcon,
      _props$type = props.type,
      type = _props$type === void 0 ? 'button' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);

  var startIcon = startIconProp && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.startIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, startIconProp);
  var endIcon = endIconProp && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.endIcon, classes["iconSize".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))])
  }, endIconProp);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))], classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))]], disabled && classes.disabled, fullWidth && classes.fullWidth),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.label
  }, startIcon, children, endIcon));
});
 false ? Button.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   *
   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
   */
  disableRipple: PropTypes.bool,

  /**
   * Element placed after the children.
   */
  endIcon: PropTypes.node,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * If `true`, the button will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * Element placed before the children.
   */
  startIcon: PropTypes.node,

  /**
   * @ignore
   */
  type: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['text', 'outlined', 'contained'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButton'
})(Button));

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ButtonGroup__ = __webpack_require__(969);
/* unused harmony reexport default */


/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(410);








 // Force a side effect so we don't have any override priority issue.
// eslint-disable-next-line no-unused-expressions

__WEBPACK_IMPORTED_MODULE_8__Button__["a" /* default */].styles;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `variant="contained"`. */
    contained: {
      boxShadow: theme.shadows[2]
    },

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the children. */
    grouped: {
      minWidth: 40,
      '&:not(:first-child)': {
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    /* Styles applied to the children if `variant="text"`. */
    groupedText: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
    groupedTextPrimary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
    groupedTextSecondary: {
      '&:not(:last-child)': {
        borderColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.5)
      }
    },

    /* Styles applied to the children if `variant="outlined"`. */
    groupedOutlined: {
      '&:not(:first-child)': {
        marginLeft: -1
      },
      '&:not(:last-child)': {
        borderRightColor: 'transparent'
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
    groupedOutlinedPrimary: {
      '&:hover': {
        borderColor: theme.palette.primary.main
      }
    },

    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
    groupedOutlinedSecondary: {
      '&:hover': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the children if `variant="contained"`. */
    groupedContained: {
      boxShadow: 'none',
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.grey[400]),
        '&$disabled': {
          borderRight: "1px solid ".concat(theme.palette.action.disabled)
        }
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
    groupedContainedPrimary: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.primary.dark)
      }
    },

    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
    groupedContainedSecondary: {
      '&:not(:last-child)': {
        borderRight: "1px solid ".concat(theme.palette.secondary.dark)
      }
    },

    /* Pseudo-class applied to child elements if `disabled={true}`. */
    disabled: {}
  };
};
var ButtonGroup = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ButtonGroup(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "disableRipple", "fullWidth", "size", "variant"]);

  var buttonClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.grouped, classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(variant))], classes["grouped".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(variant)).concat(color !== 'default' ? Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color) : '')], disabled && classes.disabled);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "group",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, fullWidth && classes.fullWidth, {
      contained: classes.contained
    }[variant]),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(buttonClassName, child.props.className),
      disabled: child.props.disabled || disabled,
      color: child.props.color || color,
      disableFocusRipple: disableFocusRipple,
      disableRipple: disableRipple,
      fullWidth: fullWidth,
      size: child.props.size || size,
      variant: child.props.variant || variant
    });
  }));
});
 false ? ButtonGroup.propTypes = {
  /**
   * The content of the button group.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the buttons will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the button keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the button ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If `true`, the buttons will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['text', 'outlined', 'contained'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiButtonGroup'
})(ButtonGroup));

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Card__ = __webpack_require__(971);
/* unused harmony reexport default */


/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);







var styles = {
  /* Styles applied to the root element. */
  root: {
    overflow: 'hidden'
  }
};
var Card = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Card(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$raised = props.raised,
      raised = _props$raised === void 0 ? false : _props$raised,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "raised"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    elevation: raised ? 8 : 1,
    ref: ref
  }, other));
});
 false ? Card.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the card will use raised styling.
   */
  raised: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCard'
})(Card));

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActionArea__ = __webpack_require__(973);
/* unused harmony reexport default */


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(41);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      textAlign: 'inherit',
      width: '100%',
      '&:hover $focusHighlight': {
        opacity: theme.palette.action.hoverOpacity
      },
      '&$focusVisible $focusHighlight': {
        opacity: 0.12
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
    focusVisible: {},

    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
    focusHighlight: {
      overflow: 'hidden',
      pointerEvents: 'none',
      position: 'absolute',
      top: 0,
      right: 0,
      bottom: 0,
      left: 0,
      borderRadius: 'inherit',
      opacity: 0,
      backgroundColor: 'currentcolor',
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.short
      })
    }
  };
};
var CardActionArea = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CardActionArea(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      focusVisibleClassName = props.focusVisibleClassName,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "focusVisibleClassName"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(focusVisibleClassName, classes.focusVisible),
    ref: ref
  }, other), children, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.focusHighlight
  }));
});
 false ? CardActionArea.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActionArea'
})(CardActionArea));

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardActions__ = __webpack_require__(975);
/* unused harmony reexport default */


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var CardActions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CardActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? CardActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardActions'
})(CardActions));

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardContent__ = __webpack_require__(977);
/* unused harmony reexport default */


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 16,
    '&:last-child': {
      paddingBottom: 24
    }
  }
};
var CardContent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CardContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? CardContent.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardContent'
})(CardContent));

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardHeader__ = __webpack_require__(979);
/* unused harmony reexport default */


/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(46);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 16
  },

  /* Styles applied to the avatar element. */
  avatar: {
    flex: '0 0 auto',
    marginRight: 16
  },

  /* Styles applied to the action element. */
  action: {
    flex: '0 0 auto',
    alignSelf: 'flex-start',
    marginTop: -8,
    marginRight: -8
  },

  /* Styles applied to the content wrapper element. */
  content: {
    flex: '1 1 auto'
  },

  /* Styles applied to the title Typography element. */
  title: {},

  /* Styles applied to the subheader Typography element. */
  subheader: {}
};
var CardHeader = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CardHeader(props, ref) {
  var action = props.action,
      avatar = props.avatar,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      subheaderProp = props.subheader,
      subheaderTypographyProps = props.subheaderTypographyProps,
      titleProp = props.title,
      titleTypographyProps = props.titleTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);

  var title = titleProp;

  if (title != null && title.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    title = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'h5',
      className: classes.title,
      component: "span",
      display: "block"
    }, titleTypographyProps), title);
  }

  var subheader = subheaderProp;

  if (subheader != null && subheader.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    subheader = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: avatar ? 'body2' : 'body1',
      className: classes.subheader,
      color: "textSecondary",
      component: "span",
      display: "block"
    }, subheaderTypographyProps), subheader);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), avatar && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.avatar
  }, avatar), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.content
  }, title, subheader), action && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.action
  }, action));
});
 false ? CardHeader.propTypes = {
  /**
   * The action to display in the card header.
   */
  action: PropTypes.node,

  /**
   * The Avatar for the Card Header.
   */
  avatar: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `title` text, and optional `subheader` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * The content of the component.
   */
  subheader: PropTypes.node,

  /**
   * These props will be forwarded to the subheader
   * (as long as disableTypography is not `true`).
   */
  subheaderTypographyProps: PropTypes.object,

  /**
   * The content of the Card Title.
   */
  title: PropTypes.node,

  /**
   * These props will be forwarded to the title
   * (as long as disableTypography is not `true`).
   */
  titleTypographyProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardHeader'
})(CardHeader));

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CardMedia__ = __webpack_require__(981);
/* unused harmony reexport default */


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'block',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center'
  },

  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
  media: {
    width: '100%'
  },

  /* Styles applied to the root element if `component="picture or img"`. */
  img: {
    // ⚠️ object-fit is not supported by IE 11.
    objectFit: 'cover'
  }
};
var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
var CardMedia = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CardMedia(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      image = props.image,
      src = props.src,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "image", "src", "style"]);

  if (false) {
    if (!children && !image && !src) {
      console.error('Material-UI: either `children`, `image` or `src` prop must be specified.');
    }
  }

  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
  var composedStyle = !isMediaComponent && image ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    backgroundImage: "url(\"".concat(image, "\")")
  }, style) : style;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
    ref: ref,
    style: composedStyle,
    src: isMediaComponent ? image || src : undefined
  }, other), children);
});
 false ? CardMedia.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Component for rendering image.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Image to be displayed as a background image.
   * Either `image` or `src` prop must be specified.
   * Note that caller must specify height otherwise the image will not be visible.
   */
  image: PropTypes.string,

  /**
   * An alias for `image` property.
   * Available only with media components.
   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
   */
  src: PropTypes.string,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCardMedia'
})(CardMedia));

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(5);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
    indeterminate: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_CheckBox__["a" /* default */], null);
var defaultIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__internal_svg_icons_CheckBoxOutlineBlank__["a" /* default */], null);
var defaultIndeterminateIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__internal_svg_icons_IndeterminateCheckBox__["a" /* default */], null);
var Checkbox = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Checkbox(props, ref) {
  var _props$checkedIcon = props.checkedIcon,
      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$indeterminate = props.indeterminate,
      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
      _props$indeterminateI = props.indeterminateIcon,
      indeterminateIcon = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
      inputProps = props.inputProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checkedIcon", "classes", "color", "disabled", "icon", "indeterminate", "indeterminateIcon", "inputProps"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    checkedIcon: indeterminate ? indeterminateIcon : checkedIcon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_11__utils_capitalize__["a" /* default */])(color))], indeterminate && classes.indeterminate),
      checked: classes.checked,
      disabled: classes.disabled
    },
    color: color,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: indeterminate ? indeterminateIcon : icon,
    ref: ref,
    disabled: disabled
  }, other));
});
 false ? Checkbox.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * If `true`, the component appears indeterminate.
   * This does not set the native input element to indeterminate due
   * to inconsistent behavior across browsers.
   * However, we set a `data-indeterminate` attribute on the input.
   */
  indeterminate: PropTypes.bool,

  /**
   * The icon to display when the component is indeterminate.
   */
  indeterminateIcon: PropTypes.node,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string,

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCheckbox'
})(Checkbox));

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(16);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      textAlign: 'center',
      flex: '0 0 auto',
      fontSize: theme.typography.pxToRem(24),
      padding: 12,
      borderRadius: '50%',
      overflow: 'visible',
      // Explicitly set the default value to solve a bug on IE 11.
      color: theme.palette.action.active,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.action.active, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$disabled': {
        backgroundColor: 'transparent',
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -12,
      '$sizeSmall&': {
        marginLeft: -3
      }
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -12,
      '$sizeSmall&': {
        marginRight: -3
      }
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: 3,
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the children container element. */
    label: {
      width: '100%',
      display: 'flex',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    }
  };
};
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

var IconButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function IconButton(props, ref) {
  var _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))], disabled && classes.disabled, {
      small: classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(size))]
    }[size], {
      start: classes.edgeStart,
      end: classes.edgeEnd
    }[edge]),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.label
  }, children));
});
 false ? IconButton.propTypes = {
  /**
   * The icon element.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var found = React.Children.toArray(props.children).some(function (child) {
      return React.isValidElement(child) && child.props.onClick;
    });

    if (found) {
      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIconButton'
})(IconButton));

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank'));

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox'));

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox'));

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ButtonBase__ = __webpack_require__(41);












var styles = function styles(theme) {
  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
  var deleteIconColor = Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, 0.26);
  return {
    /* Styles applied to the root element. */
    root: {
      fontFamily: theme.typography.fontFamily,
      fontSize: theme.typography.pxToRem(13),
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: 32,
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      borderRadius: 32 / 2,
      whiteSpace: 'nowrap',
      transition: theme.transitions.create(['background-color', 'box-shadow']),
      // label will inherit this from root, then `clickable` class overrides this for both
      cursor: 'default',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      textDecoration: 'none',
      border: 'none',
      // Remove `button` border
      padding: 0,
      // Remove `button` padding
      verticalAlign: 'middle',
      boxSizing: 'border-box',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '& $avatar': {
        marginLeft: 5,
        marginRight: -6,
        width: 24,
        height: 24,
        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
        fontSize: theme.typography.pxToRem(12)
      },
      '& $avatarColorPrimary': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.dark
      },
      '& $avatarColorSecondary': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.dark
      },
      '& $avatarSmall': {
        marginLeft: 4,
        marginRight: -4,
        width: 18,
        height: 18,
        fontSize: theme.typography.pxToRem(10)
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 24
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.primary.contrastText
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
    clickable: {
      userSelect: 'none',
      WebkitTapHighlightColor: 'transparent',
      // Remove grey highlight
      cursor: 'pointer',
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(backgroundColor, 0.08)
      },
      '&:active': {
        boxShadow: theme.shadows[1]
      }
    },

    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
    clickableColorPrimary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.primary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
    clickableColorSecondary: {
      '&:hover, &:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.secondary.main, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` is defined. */
    deletable: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(backgroundColor, 0.08)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
    deletableColorPrimary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.primary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
    deletableColorSecondary: {
      '&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["b" /* emphasize */])(theme.palette.secondary.main, 0.2)
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.text.primary, theme.palette.action.hoverOpacity)
      },
      '& $avatar': {
        marginLeft: 4
      },
      '& $avatarSmall': {
        marginLeft: 2
      },
      '& $icon': {
        marginLeft: 4
      },
      '& $iconSmall': {
        marginLeft: 2
      },
      '& $deleteIcon': {
        marginRight: 5
      },
      '& $deleteIconSmall': {
        marginRight: 3
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      color: theme.palette.primary.main,
      border: "1px solid ".concat(theme.palette.primary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity)
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      color: theme.palette.secondary.main,
      border: "1px solid ".concat(theme.palette.secondary.main),
      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
      }
    },
    // TODO remove in V5

    /* Styles applied to the `avatar` element. */
    avatar: {},

    /* Styles applied to the `avatar` element if `size="small"`. */
    avatarSmall: {},

    /* Styles applied to the `avatar` element if `color="primary"`. */
    avatarColorPrimary: {},

    /* Styles applied to the `avatar` element if `color="secondary"`. */
    avatarColorSecondary: {},

    /* Styles applied to the `icon` element. */
    icon: {
      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    },

    /* Styles applied to the `icon` element if `size="small"`. */
    iconSmall: {
      width: 18,
      height: 18,
      marginLeft: 4,
      marginRight: -4
    },

    /* Styles applied to the `icon` element if `color="primary"`. */
    iconColorPrimary: {
      color: 'inherit'
    },

    /* Styles applied to the `icon` element if `color="secondary"`. */
    iconColorSecondary: {
      color: 'inherit'
    },

    /* Styles applied to the label `span` element`. */
    label: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap'
    },
    labelSmall: {
      paddingLeft: 8,
      paddingRight: 8
    },

    /* Styles applied to the `deleteIcon` element. */
    deleteIcon: {
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      height: 22,
      width: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(deleteIconColor, 0.4)
      }
    },

    /* Styles applied to the `deleteIcon` element if `size="small"`. */
    deleteIconSmall: {
      height: 16,
      width: 16,
      marginRight: 4,
      marginLeft: -4
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
    deleteIconColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
    deleteIconColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.contrastText
      }
    },

    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
    deleteIconOutlinedColorPrimary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.primary.main
      }
    },

    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
    deleteIconOutlinedColorSecondary: {
      color: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.7),
      '&:hover, &:active': {
        color: theme.palette.secondary.main
      }
    }
  };
};
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */

var Chip = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Chip(props, ref) {
  var avatarProp = props.avatar,
      classes = props.classes,
      className = props.className,
      clickableProp = props.clickable,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      ComponentProp = props.component,
      deleteIconProp = props.deleteIcon,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      iconProp = props.icon,
      label = props.label,
      onClick = props.onClick,
      onDelete = props.onDelete,
      onKeyUp = props.onKeyUp,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyUp", "size", "variant"]);

  var chipRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(chipRef, ref);

  var handleDeleteIconClick = function handleDeleteIconClick(event) {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  var handleKeyUp = function handleKeyUp(event) {
    if (onKeyUp) {
      onKeyUp(event);
    } // Ignore events from children of `Chip`.


    if (event.currentTarget !== event.target) {
      return;
    }

    var key = event.key;

    if (onDelete && (key === 'Backspace' || key === 'Delete')) {
      onDelete(event);
    } else if (key === 'Escape' && chipRef.current) {
      chipRef.current.blur();
    }
  };

  var clickable = clickableProp !== false && onClick ? true : clickableProp;
  var small = size === 'small';
  var Component = ComponentProp || (clickable ? __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] : 'div');
  var moreProps = Component === __WEBPACK_IMPORTED_MODULE_11__ButtonBase__["a" /* default */] ? {
    component: 'div'
  } : {};
  var deleteIcon = null;

  if (onDelete) {
    var customClasses = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))] : classes["deleteIconOutlinedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(deleteIconProp) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(deleteIconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_Cancel__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  var avatar = null;

  if (avatarProp && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(avatarProp)) {
    avatar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(avatarProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  var icon = null;

  if (iconProp && __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(iconProp)) {
    icon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(iconProp, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))])
    });
  }

  if (false) {
    if (avatar && icon) {
      console.error('Material-UI: the Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
    }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: clickable || onDelete ? 'button' : undefined,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], clickable && classes["clickableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))], onDelete && classes["deletableColor".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(color))]], variant !== "default" && [classes.outlined, {
      primary: classes.outlinedPrimary,
      secondary: classes.outlinedSecondary
    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
    "aria-disabled": disabled ? true : undefined,
    tabIndex: clickable || onDelete ? 0 : undefined,
    onClick: onClick,
    onKeyUp: handleKeyUp,
    ref: handleRef
  }, moreProps, other), avatar || icon, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, small && classes.labelSmall)
  }, label), deleteIcon);
});
 false ? Chip.propTypes = {
  /**
   * Avatar element.
   */
  avatar: PropTypes.element,

  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If true, the chip will appear clickable, and will raise when pressed,
   * even if the onClick prop is not defined.
   * If false, the chip will not be clickable, even if onClick prop is defined.
   * This can be used, for example,
   * along with the component prop to indicate an anchor Chip is clickable.
   */
  clickable: PropTypes.bool,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Override the default delete icon element. Shown only if `onDelete` is set.
   */
  deleteIcon: PropTypes.element,

  /**
   * If `true`, the chip should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * Icon element.
   */
  icon: PropTypes.element,

  /**
   * The content of the label.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * Callback function fired when the delete icon is clicked.
   * If set, the delete icon will be shown.
   */
  onDelete: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The size of the chip.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['default', 'outlined'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiChip'
})(Chip));

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel'));

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CircularProgress__ = __webpack_require__(990);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CircularProgress__["a"]; });


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);








var SIZE = 44;

function getRelativeValue(value, min, max) {
  var clampedValue = Math.min(Math.max(min, value), max);
  return (clampedValue - min) / (max - min);
}

function easeOut(t) {
  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294

  t = (t -= 1) * t * t + 1;
  return t;
}

function easeIn(t) {
  return t * t;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-block'
    },

    /* Styles applied to the root element if `variant="static"`. */
    static: {
      transition: theme.transitions.create('transform')
    },

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {
      animation: '$circular-rotate 1.4s linear infinite'
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the `svg` element. */
    svg: {
      display: 'block' // Keeps the progress centered

    },

    /* Styles applied to the `circle` svg path. */
    circle: {
      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
      // strokeLinecap: 'butt',

    },

    /* Styles applied to the `circle` svg path if `variant="static"`. */
    circleStatic: {
      transition: theme.transitions.create('stroke-dashoffset')
    },

    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
    circleIndeterminate: {
      animation: '$circular-dash 1.4s ease-in-out infinite',
      // Some default value that looks fine waiting for the animation to kicks in.
      strokeDasharray: '80px, 200px',
      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.

    },
    '@keyframes circular-rotate': {
      '100%': {
        transform: 'rotate(360deg)'
      }
    },
    '@keyframes circular-dash': {
      '0%': {
        strokeDasharray: '1px, 200px',
        strokeDashoffset: '0px'
      },
      '50%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-15px'
      },
      '100%': {
        strokeDasharray: '100px, 200px',
        strokeDashoffset: '-125px'
      }
    },

    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
    circleDisableShrink: {
      animation: 'none'
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var CircularProgress = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function CircularProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$disableShrink = props.disableShrink,
      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
      _props$size = props.size,
      size = _props$size === void 0 ? 40 : _props$size,
      style = props.style,
      _props$thickness = props.thickness,
      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
      _props$value = props.value,
      value = _props$value === void 0 ? 0 : _props$value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);

  var circleStyle = {};
  var rootStyle = {};
  var rootProps = {};

  if (variant === 'determinate' || variant === 'static') {
    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);

    if (variant === 'static') {
      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
      rootStyle.transform = 'rotate(-90deg)';
    } else {
      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
    }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(color))], {
      indeterminate: classes.indeterminate,
      static: classes.static
    }[variant]),
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      width: size,
      height: size
    }, rootStyle, {}, style),
    ref: ref,
    role: "progressbar"
  }, rootProps, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("svg", {
    className: classes.svg,
    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("circle", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.circle, disableShrink && classes.circleDisableShrink, {
      indeterminate: classes.circleIndeterminate,
      static: classes.circleStatic
    }[variant]),
    style: circleStyle,
    cx: SIZE,
    cy: SIZE,
    r: (SIZE - thickness) / 2,
    fill: "none",
    strokeWidth: thickness
  })));
});
 false ? CircularProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'inherit']),

  /**
   * If `true`, the shrink animation is disabled.
   * This only works if variant is `indeterminate`.
   */
  disableShrink: chainPropTypes(PropTypes.bool, function (props) {
    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
      return new Error('Material-UI: you have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
    }

    return null;
  }),

  /**
   * The size of the circle.
   * If using a number, the pixel unit is assumed.
   * If using a string, you need to provide the CSS unit, e.g '3rem'.
   */
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The thickness of the circle.
   */
  thickness: PropTypes.number,

  /**
   * The value of the progress indicator for the determinate and static variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate when there is no progress value.
   */
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'static'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCircularProgress',
  flip: false
})(CircularProgress));

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_setRef__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(12);









function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}
/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 */


var ClickAwayListener = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function ClickAwayListener(props, ref) {
  var children = props.children,
      _props$mouseEvent = props.mouseEvent,
      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
      _props$touchEvent = props.touchEvent,
      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent,
      onClickAway = props.onClickAway;
  var movedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  var nodeRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);
  var mountedRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(false);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    mountedRef.current = true;
    return function () {
      mountedRef.current = false;
    };
  }, []);
  var handleNodeRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(nodeRef, ref); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    Object(__WEBPACK_IMPORTED_MODULE_5__utils_setRef__["a" /* default */])(handleNodeRef, __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(instance));
  }, [handleNodeRef]);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var handleClickAway = Object(__WEBPACK_IMPORTED_MODULE_6__utils_useEventCallback__["a" /* default */])(function (event) {
    // Ignore events that have been `event.preventDefault()` marked.
    if (event.defaultPrevented) {
      return;
    } // IE 11 support, which trigger the handleClickAway even after the unbind


    if (!mountedRef.current) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    } // The child might render null.


    if (!nodeRef.current) {
      return;
    } // Multi window support


    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(nodeRef.current);

    if (doc.documentElement && doc.documentElement.contains(event.target) && !nodeRef.current.contains(event.target)) {
      onClickAway(event);
    }
  });
  var handleTouchMove = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function () {
    movedRef.current = true;
  }, []);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    if (touchEvent !== false) {
      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
      document.addEventListener(mappedTouchEvent, handleClickAway);
      document.addEventListener('touchmove', handleTouchMove);
      return function () {
        document.removeEventListener(mappedTouchEvent, handleClickAway);
        document.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, handleTouchMove, touchEvent]);
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    if (mouseEvent !== false) {
      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      document.addEventListener(mappedMouseEvent, handleClickAway);
      return function () {
        document.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
    ref: handleRef
  }));
});
 false ? ClickAwayListener.propTypes = {
  /**
   * The wrapped element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * The mouse event to listen to. You can disable the listener by providing `false`.
   */
  mouseEvent: PropTypes.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),

  /**
   * Callback fired when a "click away" event is detected.
   */
  onClickAway: PropTypes.func.isRequired,

  /**
   * The touch event to listen to. You can disable the listener by providing `false`.
   */
  touchEvent: PropTypes.oneOf(['onTouchStart', 'onTouchEnd', false])
} : void 0;

if (false) {
  // eslint-disable-next-line
  ClickAwayListener['propTypes' + ''] = exactProp(ClickAwayListener.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (ClickAwayListener);

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__transitions_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(32);










var styles = function styles(theme) {
  return {
    /* Styles applied to the container element. */
    container: {
      height: 0,
      overflow: 'hidden',
      transition: theme.transitions.create('height')
    },

    /* Styles applied to the container element when the transition has entered. */
    entered: {
      height: 'auto',
      overflow: 'visible'
    },

    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
    hidden: {
      visibility: 'hidden'
    },

    /* Styles applied to the outer wrapper element. */
    wrapper: {
      // Hack to get children with a negative margin to not falsify the height computation.
      display: 'flex'
    },

    /* Styles applied to the inner wrapper element. */
    wrapperInner: {
      width: '100%'
    }
  };
};
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Collapse = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Collapse(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$collapsedHeigh = props.collapsedHeight,
      collapsedHeight = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExiting = props.onExiting,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].standard : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var timer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var wrapperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var autoTransitionDuration = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);

  var handleEnter = function handleEnter(node, isAppearing) {
    node.style.height = collapsedHeight;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleEntering = function handleEntering(node, isAppearing) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = "".concat(wrapperHeight, "px");

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  };

  var handleEntered = function handleEntered(node, isAppearing) {
    node.style.height = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    node.style.height = "".concat(wrapperHeight, "px");

    if (onExit) {
      onExit(node);
    }
  };

  var handleExiting = function handleExiting(node) {
    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;

    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_8__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration;

    if (timeout === 'auto') {
      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
      node.style.transitionDuration = "".concat(duration2, "ms");
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
    }

    node.style.height = collapsedHeight;

    if (onExiting) {
      onExiting(node);
    }
  };

  var addEndListener = function addEndListener(_, next) {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_transition_group__["a" /* Transition */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExiting: handleExiting,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.container, className, {
        entered: classes.entered,
        exited: !inProp && collapsedHeight === '0px' && classes.hidden
      }[state]),
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minHeight: collapsedHeight
      }, style),
      ref: ref
    }, childProps), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: classes.wrapper,
      ref: wrapperRef
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: classes.wrapperInner
    }, children)));
  });
});
 false ? Collapse.propTypes = {
  /**
   * The content node to be collapsed.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The height of the container when collapsed.
   */
  collapsedHeight: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntered: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  }), PropTypes.oneOf(['auto'])])
} : void 0;
Collapse.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiCollapse'
})(Collapse));

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Container__ = __webpack_require__(994);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Container__["a"]; });


/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);








var styles = function styles(theme) {
  var _root;

  return {
    /* Styles applied to the root element. */
    root: (_root = {
      width: '100%',
      marginLeft: 'auto',
      boxSizing: 'border-box',
      marginRight: 'auto',
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_root, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_root, theme.breakpoints.up('md'), {
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4)
    }), _root),

    /* Styles applied to the root element if `fixed={true}`. */
    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
      var value = theme.breakpoints.values[breakpoint];

      if (value !== 0) {
        acc[theme.breakpoints.up(breakpoint)] = {
          maxWidth: value
        };
      }

      return acc;
    }, {}),

    /* Styles applied to the root element if `maxWidth="xs"`. */
    maxWidthXs: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xs'), {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
    }),

    /* Styles applied to the root element if `maxWidth="sm"`. */
    maxWidthSm: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), {
      maxWidth: theme.breakpoints.values.sm
    }),

    /* Styles applied to the root element if `maxWidth="md"`. */
    maxWidthMd: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('md'), {
      maxWidth: theme.breakpoints.values.md
    }),

    /* Styles applied to the root element if `maxWidth="lg"`. */
    maxWidthLg: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('lg'), {
      maxWidth: theme.breakpoints.values.lg
    }),

    /* Styles applied to the root element if `maxWidth="xl"`. */
    maxWidthXl: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('xl'), {
      maxWidth: theme.breakpoints.values.xl
    })
  };
};
var Container = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Container(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$fixed = props.fixed,
      fixed = _props$fixed === void 0 ? false : _props$fixed,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "fixed", "maxWidth"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, fixed && classes.fixed, maxWidth !== false && classes["maxWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))]),
    ref: ref
  }, other));
});
 false ? Container.propTypes = {
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Set the max-width to match the min-width of the current breakpoint.
   * This is useful if you'd prefer to design for a fixed set of sizes
   * instead of trying to accommodate a fully fluid viewport.
   * It's fluid by default.
   */
  fixed: PropTypes.bool,

  /**
   * Determine the max-width of the container.
   * The container width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiContainer'
})(Container));

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CssBaseline__ = __webpack_require__(996);
/* unused harmony reexport default */


/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_makeStyles__ = __webpack_require__(395);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(12);





var useStyles = Object(__WEBPACK_IMPORTED_MODULE_3__styles_makeStyles__["a" /* default */])(function (theme) {
  return {
    '@global': {
      html: {
        WebkitFontSmoothing: 'antialiased',
        // Antialiasing.
        MozOsxFontSmoothing: 'grayscale',
        // Antialiasing.
        // Change from `box-sizing: content-box` so that `width`
        // is not affected by `padding` or `border`.
        boxSizing: 'border-box'
      },
      '*, *::before, *::after': {
        boxSizing: 'inherit'
      },
      'strong, b': {
        fontWeight: 'bolder'
      },
      body: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        margin: 0,
        // Remove the margin in all browsers.
        color: theme.palette.text.primary
      }, theme.typography.body2, {
        backgroundColor: theme.palette.background.default,
        '@media print': {
          // Save printer ink.
          backgroundColor: theme.palette.common.white
        },
        // Add support for document.body.requestFullScreen().
        // Other elements, if background transparent, are not supported.
        '&::backdrop': {
          backgroundColor: theme.palette.background.default
        }
      })
    }
  };
}, {
  name: 'MuiCssBaseline'
});
/**
 * Kickstart an elegant, consistent, and simple baseline to build upon.
 */

function CssBaseline(props) {
  var _props$children = props.children,
      children = _props$children === void 0 ? null : _props$children;
  useStyles();
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment, null, children);
}

 false ? CssBaseline.propTypes = {
  /**
   * You can wrap a node.
   */
  children: PropTypes.node
} : void 0;

if (false) {
  // eslint-disable-next-line
  CssBaseline['propTypes' + ''] = exactProp(CssBaseline.propTypes);
}

/* unused harmony default export */ var _unused_webpack_default_export = (CssBaseline);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dialog__ = __webpack_require__(998);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Dialog__["a"]; });


/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Modal__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Backdrop__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Fade__ = __webpack_require__(252);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Paper__ = __webpack_require__(60);




/* eslint-disable jsx-a11y/click-events-have-key-events */










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      '@media print': {
        // Use !important to override the Modal inline-style.
        position: 'absolute !important'
      }
    },

    /* Styles applied to the container element if `scroll="paper"`. */
    scrollPaper: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the container element if `scroll="body"`. */
    scrollBody: {
      overflowY: 'auto',
      overflowX: 'hidden',
      textAlign: 'center',
      '&:after': {
        content: '""',
        display: 'inline-block',
        verticalAlign: 'middle',
        height: '100%',
        width: '0'
      }
    },

    /* Styles applied to the container element. */
    container: {
      height: '100%',
      '@media print': {
        height: 'auto'
      },
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0
    },

    /* Styles applied to the `Paper` component. */
    paper: {
      margin: 32,
      position: 'relative',
      overflowY: 'auto',
      // Fix IE 11 issue, to remove at some point.
      '@media print': {
        overflowY: 'visible',
        boxShadow: 'none'
      }
    },

    /* Styles applied to the `Paper` component if `scroll="paper"`. */
    paperScrollPaper: {
      display: 'flex',
      flexDirection: 'column',
      maxHeight: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `scroll="body"`. */
    paperScrollBody: {
      display: 'inline-block',
      verticalAlign: 'middle',
      textAlign: 'left' // 'initial' doesn't work on IE 11

    },

    /* Styles applied to the `Paper` component if `maxWidth=false`. */
    paperWidthFalse: {
      maxWidth: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
    paperWidthXs: {
      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
    paperWidthSm: {
      maxWidth: theme.breakpoints.values.sm,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
    paperWidthMd: {
      maxWidth: theme.breakpoints.values.md,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
    paperWidthLg: {
      maxWidth: theme.breakpoints.values.lg,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
    paperWidthXl: {
      maxWidth: theme.breakpoints.values.xl,
      '&$paperScrollBody': Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
        maxWidth: 'calc(100% - 64px)'
      })
    },

    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
    paperFullWidth: {
      width: 'calc(100% - 64px)'
    },

    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
    paperFullScreen: {
      margin: 0,
      width: '100%',
      maxWidth: '100%',
      height: '100%',
      maxHeight: 'none',
      borderRadius: 0,
      '&$paperScrollBody': {
        margin: 0,
        maxWidth: '100%'
      }
    }
  };
};
var defaultTransitionDuration = {
  enter: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_11__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

var Dialog = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Dialog(props, ref) {
  var BackdropProps = props.BackdropProps,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$fullScreen = props.fullScreen,
      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$maxWidth = props.maxWidth,
      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_12__Paper__["a" /* default */] : _props$PaperComponent,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$scroll = props.scroll,
      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_10__Fade__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      ariaDescribedby = props['aria-describedby'],
      ariaLabelledby = props['aria-labelledby'],
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);

  var mouseDownTarget = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();

  var handleMouseDown = function handleMouseDown(event) {
    mouseDownTarget.current = event.target;
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    // Ignore the events not coming from the "backdrop"
    // We don't want to close the dialog when clicking the dialog content.
    if (event.target !== event.currentTarget) {
      return;
    } // Make sure the event starts and ends on the same DOM element.


    if (event.target !== mouseDownTarget.current) {
      return;
    }

    mouseDownTarget.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    BackdropComponent: __WEBPACK_IMPORTED_MODULE_9__Backdrop__["a" /* default */],
    BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      transitionDuration: transitionDuration
    }, BackdropProps),
    closeAfterTransition: true,
    disableBackdropClick: disableBackdropClick,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onEscapeKeyDown: onEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    timeout: transitionDuration,
    onEnter: onEnter,
    onEntering: onEntering,
    onEntered: onEntered,
    onExit: onExit,
    onExiting: onExiting,
    onExited: onExited,
    role: "none presentation"
  }, TransitionProps), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.container, classes["scroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))]),
    onClick: handleBackdropClick,
    onMouseDown: handleMouseDown
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PaperComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: 24,
    role: "dialog",
    "aria-describedby": ariaDescribedby,
    "aria-labelledby": ariaLabelledby
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.paper, classes["paperScroll".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(scroll))], classes["paperWidth".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
  }), children))));
});
 false ? Dialog.propTypes = {
  /**
   * The id(s) of the element(s) that describe the dialog.
   */
  'aria-describedby': PropTypes.string,

  /**
   * The id(s) of the element(s) that label the dialog.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * @ignore
   */
  BackdropProps: PropTypes.object,

  /**
   * Dialog children, usually the included sub-components.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clicking the backdrop will not fire the `onClose` callback.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire the `onClose` callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * If `true`, the dialog will be full-screen
   */
  fullScreen: PropTypes.bool,

  /**
   * If `true`, the dialog stretches to `maxWidth`.
   *
   * Notice that the dialog width grow is limited by the default margin.
   */
  fullWidth: PropTypes.bool,

  /**
   * Determine the max-width of the dialog.
   * The dialog width grows with the size of the screen.
   * Set to `false` to disable `maxWidth`.
   */
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the dialog enters.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the dialog has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the dialog is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableKeyboard` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired before the dialog exits.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the dialog has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the dialog is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the Dialog is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The component used to render the body of the dialog.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.object,

  /**
   * Determine the container for scrolling the dialog.
   */
  scroll: PropTypes.oneOf(['body', 'paper']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialog'
})(Dialog));

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Portal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ModalManager__ = __webpack_require__(414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TrapFocus__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__ = __webpack_require__(1002);

















function getContainer(container) {
  container = typeof container === 'function' ? container() : container;
  return __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(container);
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


var defaultManager = new __WEBPACK_IMPORTED_MODULE_13__ModalManager__["b" /* default */]();
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      zIndex: theme.zIndex.modal,
      right: 0,
      bottom: 0,
      top: 0,
      left: 0
    },

    /* Styles applied to the root element if the `Modal` has exited. */
    hidden: {
      visibility: 'hidden'
    }
  };
};
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

var Modal = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Modal(inProps, ref) {
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["g" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_styles__["c" /* getThemeProps */])({
    name: 'MuiModal',
    props: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inProps),
    theme: theme
  });

  var _props$BackdropCompon = props.BackdropComponent,
      BackdropComponent = _props$BackdropCompon === void 0 ? __WEBPACK_IMPORTED_MODULE_15__SimpleBackdrop__["a" /* default */] : _props$BackdropCompon,
      BackdropProps = props.BackdropProps,
      children = props.children,
      _props$closeAfterTran = props.closeAfterTransition,
      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
      container = props.container,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableBackdro = props.disableBackdropClick,
      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableEscapeK = props.disableEscapeKeyDown,
      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      _props$disableScrollL = props.disableScrollLock,
      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
      _props$hideBackdrop = props.hideBackdrop,
      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      _props$manager = props.manager,
      manager = _props$manager === void 0 ? defaultManager : _props$manager,
      onBackdropClick = props.onBackdropClick,
      onClose = props.onClose,
      onEscapeKeyDown = props.onEscapeKeyDown,
      onRendered = props.onRendered,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var modal = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({});
  var mountNodeRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var modalRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(modalRef, ref);
  var hasTransition = getHasTransition(props);

  var getDoc = function getDoc() {
    return Object(__WEBPACK_IMPORTED_MODULE_7__utils_ownerDocument__["a" /* default */])(mountNodeRef.current);
  };

  var getModal = function getModal() {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  var handleMounted = function handleMounted() {
    manager.mount(getModal(), {
      disableScrollLock: disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  var handleOpen = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function () {
    var resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  var isTopModal = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    return manager.isTopModal(getModal());
  }, [manager]);
  var handlePortalRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (node) {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (onRendered) {
      onRendered();
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      Object(__WEBPACK_IMPORTED_MODULE_13__ModalManager__["a" /* ariaHidden */])(modalRef.current, true);
    }
  });
  var handleClose = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    manager.remove(getModal());
  }, [manager]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      handleClose();
    };
  }, [handleClose]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleExited = function handleExited() {
    setExited(true);

    if (closeAfterTransition) {
      handleClose();
    }
  };

  var handleBackdropClick = function handleBackdropClick(event) {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  var handleKeyDown = function handleKeyDown(event) {
    // We don't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviours like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.
    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    } // Swallow the event, in case someone is listening for the escape key on the body.


    event.stopPropagation();

    if (onEscapeKeyDown) {
      onEscapeKeyDown(event);
    }

    if (!disableEscapeKeyDown && onClose) {
      onClose(event, 'escapeKeyDown');
    }
  };

  var inlineStyle = styles(theme || {
    zIndex: __WEBPACK_IMPORTED_MODULE_12__styles_zIndex__["a" /* default */]
  });
  var childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = children.props.tabIndex || '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(handleEnter, children.props.onEnter);
    childProps.onExited = Object(__WEBPACK_IMPORTED_MODULE_9__utils_createChainedFunction__["a" /* default */])(handleExited, children.props.onExited);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Portal__["a" /* default */], {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    onKeyDown: handleKeyDown,
    role: "presentation"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inlineStyle.root, {}, !open && exited ? inlineStyle.hidden : {}, {}, other.style)
  }), hideBackdrop ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BackdropComponent, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: open,
    onClick: handleBackdropClick
  }, BackdropProps)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__TrapFocus__["a" /* default */], {
    disableEnforceFocus: disableEnforceFocus,
    disableAutoFocus: disableAutoFocus,
    disableRestoreFocus: disableRestoreFocus,
    getDoc: getDoc,
    isEnabled: isTopModal,
    open: open
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, childProps))));
});
 false ? Modal.propTypes = {
  /**
   * A backdrop component. This prop enables custom backdrop rendering.
   */
  BackdropComponent: PropTypes.elementType,

  /**
   * Props applied to the [`Backdrop`](/api/backdrop/) element.
   */
  BackdropProps: PropTypes.object,

  /**
   * A single child content element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * When set to true the Modal waits until a nested Transition is completed before closing.
   */
  closeAfterTransition: PropTypes.bool,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, clicking the backdrop will not fire any callback.
   */
  disableBackdropClick: PropTypes.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, hitting escape will not fire any callback.
   */
  disableEscapeKeyDown: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Disable the scroll lock behavior.
   */
  disableScrollLock: PropTypes.bool,

  /**
   * If `true`, the backdrop is not rendered.
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Modal.
   */
  keepMounted: PropTypes.bool,

  /**
   * @ignore
   */
  manager: PropTypes.object,

  /**
   * Callback fired when the backdrop is clicked.
   */
  onBackdropClick: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * The `reason` parameter can optionally be used to control the response to `onClose`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the escape key is pressed,
   * `disableEscapeKeyDown` is false and the modal is in focus.
   */
  onEscapeKeyDown: PropTypes.func,

  /**
   * Callback fired once the children has been mounted into the `container`.
   * It signals that the `open={true}` prop took effect.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func,

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Modal);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_setRef__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(28);







function getContainer(container) {
  container = typeof container === 'function' ? container() : container; // #StrictMode ready

  return __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(container);
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect;
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */

var Portal = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function Portal(props, ref) {
  var children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      onRendered = props.onRendered;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useState(null),
      mountNode = _React$useState[0],
      setMountNode = _React$useState[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(children.ref, ref);
  useEnhancedEffect(function () {
    if (!disablePortal) {
      setMountNode(getContainer(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect(function () {
    if (mountNode && !disablePortal) {
      Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" /* default */])(ref, mountNode);
      return function () {
        Object(__WEBPACK_IMPORTED_MODULE_4__utils_setRef__["a" /* default */])(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);
  useEnhancedEffect(function () {
    if (onRendered && (mountNode || disablePortal)) {
      onRendered();
    }
  }, [onRendered, mountNode, disablePortal]);

  if (disablePortal) {
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
      ref: handleRef
    });
  }

  return mountNode ? __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.createPortal(children, mountNode) : mountNode;
});
 false ? Portal.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The children to render into the `container`.
   */
  children: PropTypes.node,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will have the portal children appended to it.
   * By default, it uses the body of the top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([PropTypes.func, PropTypes.instanceOf(React.Component), PropTypes.instanceOf(typeof Element === 'undefined' ? Object : Element)]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Callback fired once the children has been mounted into the `container`.
   *
   * This prop will be deprecated and removed in v5, the ref can be used instead.
   */
  onRendered: PropTypes.func
} : void 0;

if (false) {
  // eslint-disable-next-line
  Portal['propTypes' + ''] = exactProp(Portal.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Portal);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__ = __webpack_require__(28);
/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */





/**
 * @ignore - internal component.
 */

function TrapFocus(props) {
  var children = props.children,
      _props$disableAutoFoc = props.disableAutoFocus,
      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
      _props$disableEnforce = props.disableEnforceFocus,
      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
      _props$disableRestore = props.disableRestoreFocus,
      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
      getDoc = props.getDoc,
      isEnabled = props.isEnabled,
      open = props.open;
  var ignoreNextEnforceFocus = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  var sentinelStart = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);
  var sentinelEnd = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null);
  var nodeToRestore = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef();
  var rootRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useRef(null); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_0_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    rootRef.current = __WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.findDOMNode(instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_4__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // ⚠️ You may rely on React.useMemo as a performance optimization, not as a semantic guarantee.
  // https://reactjs.org/docs/hooks-reference.html#usememo

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useMemo(function () {
    if (!open || typeof window === 'undefined') {
      return;
    }

    nodeToRestore.current = getDoc().activeElement;
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps

  __WEBPACK_IMPORTED_MODULE_0_react___default.a.useEffect(function () {
    if (!open) {
      return;
    }

    var doc = Object(__WEBPACK_IMPORTED_MODULE_3__utils_ownerDocument__["a" /* default */])(rootRef.current); // We might render an empty child.

    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {
        if (false) {
          console.error(['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
        }

        rootRef.current.setAttribute('tabIndex', -1);
      }

      rootRef.current.focus();
    }

    var contain = function contain() {
      if (disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
        rootRef.current.focus();
      }
    };

    var loopFocus = function loopFocus(event) {
      // 9 = Tab
      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
        return;
      } // Make sure the next tab starts from the right place.


      if (doc.activeElement === rootRef.current) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;

        if (event.shiftKey) {
          sentinelEnd.current.focus();
        } else {
          sentinelStart.current.focus();
        }
      }
    };

    doc.addEventListener('focus', contain, true);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    var interval = setInterval(function () {
      contain();
    }, 50);
    return function () {
      clearInterval(interval);
      doc.removeEventListener('focus', contain, true);
      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()

      if (!disableRestoreFocus) {
        // In IE 11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE 11 have a focus method.
        // Once IE 11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    tabIndex: 0,
    ref: sentinelStart,
    "data-test": "sentinelStart"
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, {
    ref: handleRef
  }), __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    tabIndex: 0,
    ref: sentinelEnd,
    "data-test": "sentinelEnd"
  }));
}

 false ? TrapFocus.propTypes = {
  /**
   * A single child content element.
   */
  children: PropTypes.element.isRequired,

  /**
   * If `true`, the modal will not automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes.
   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableAutoFocus: PropTypes.bool,

  /**
   * If `true`, the modal will not prevent focus from leaving the modal while open.
   *
   * Generally this should never be set to `true` as it makes the modal less
   * accessible to assistive technologies, like screen readers.
   */
  disableEnforceFocus: PropTypes.bool,

  /**
   * If `true`, the modal will not restore focus to previously focused element once
   * modal is hidden.
   */
  disableRestoreFocus: PropTypes.bool,

  /**
   * Return the document to consider.
   * We use it to implement the restore focus between different browser documents.
   */
  getDoc: PropTypes.func.isRequired,

  /**
   * Do we still want to enforce the focus?
   * This prop helps nesting TrapFocus elements.
   */
  isEnabled: PropTypes.func.isRequired,

  /**
   * If `true`, the modal is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/*

In the future, we should be able to replace TrapFocus with:
https://github.com/facebook/react/blob/master/packages/react-events/docs/FocusScope.md

```jsx
import FocusScope from 'react-dom/FocusScope';

function TrapFocus(props) {
  const {
    children
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    open,
  } = props;

  if (!open) {
    return children;
  }

  return (
    <FocusScope
      autoFocus={!disableAutoFocus}
      contain={!disableEnforceFocus}
      restoreFocus={!disableRestoreFocus}
    >
      {children}
    </FocusScope>
  );
}
```

*/

/* harmony default export */ __webpack_exports__["a"] = (TrapFocus);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);




var styles = {
  /* Styles applied to the root element. */
  root: {
    zIndex: -1,
    position: 'fixed',
    right: 0,
    bottom: 0,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    // Disable scroll capabilities.
    touchAction: 'none'
  },

  /* Styles applied to the root element if `invisible={true}`. */
  invisible: {
    backgroundColor: 'transparent'
  }
};
/**
 * @ignore - internal component.
 */

var SimpleBackdrop = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SimpleBackdrop(props, ref) {
  var _props$invisible = props.invisible,
      invisible = _props$invisible === void 0 ? false : _props$invisible,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["invisible", "open"]);

  return open ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    ref: ref
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.root, {}, invisible ? styles.invisible : {}, {}, other.style)
  })) : null;
});
 false ? SimpleBackdrop.propTypes = {
  /**
   * If `true`, the backdrop is invisible.
   * It can be used when rendering a popover or a custom select component.
   */
  invisible: PropTypes.bool,

  /**
   * If `true`, the backdrop is open.
   */
  open: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SimpleBackdrop);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogActions__ = __webpack_require__(1004);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogActions__["a"]; });


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end',
    flex: '0 0 auto'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var DialogActions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function DialogActions(props, ref) {
  var _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableSpacing", "classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? DialogActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogActions'
})(DialogActions));

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContent__ = __webpack_require__(1006);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogContent__["a"]; });


/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto',
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      overflowY: 'auto',
      padding: '8px 24px',
      '&:first-child': {
        // dialog without title
        paddingTop: 20
      }
    },

    /* Styles applied to the root element if `dividers={true}`. */
    dividers: {
      padding: '16px 24px',
      borderTop: "1px solid ".concat(theme.palette.divider),
      borderBottom: "1px solid ".concat(theme.palette.divider)
    }
  };
};
var DialogContent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function DialogContent(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$dividers = props.dividers,
      dividers = _props$dividers === void 0 ? false : _props$dividers,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "dividers"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dividers && classes.dividers),
    ref: ref
  }, other));
});
 false ? DialogContent.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display the top and bottom dividers.
   */
  dividers: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContent'
})(DialogContent));

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogContentText__ = __webpack_require__(1008);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogContentText__["a"]; });


/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Typography__ = __webpack_require__(46);





var styles = {
  /* Styles applied to the root element. */
  root: {
    marginBottom: 12
  }
};
var DialogContentText = __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef(function DialogContentText(props, ref) {
  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "p",
    variant: "body1",
    color: "textSecondary",
    ref: ref
  }, props));
});
 false ? DialogContentText.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogContentText'
})(DialogContentText));

/***/ }),
/* 1009 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DialogTitle__ = __webpack_require__(1010);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__DialogTitle__["a"]; });


/***/ }),
/* 1010 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(46);







var styles = {
  /* Styles applied to the root element. */
  root: {
    margin: 0,
    padding: '16px 24px',
    flex: '0 0 auto'
  }
};
var DialogTitle = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function DialogTitle(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), disableTypography ? children : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    component: "h2",
    variant: "h6"
  }, children));
});
 false ? DialogTitle.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a typography component.
   * For instance, this can be useful to render an h4 instead of the default h2.
   */
  disableTypography: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDialogTitle'
})(DialogTitle));

/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Divider__ = __webpack_require__(1012);
/* unused harmony reexport default */


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__ = __webpack_require__(36);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 1,
      margin: 0,
      // Reset browser default style.
      border: 'none',
      flexShrink: 0,
      backgroundColor: theme.palette.divider
    },

    /* Styles applied to the root element if `absolute={true}`. */
    absolute: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%'
    },

    /* Styles applied to the root element if `variant="inset"`. */
    inset: {
      marginLeft: 72
    },

    /* Styles applied to the root element if `light={true}`. */
    light: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_6__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 0.08)
    },

    /* Styles applied to the root element if `variant="middle"`. */
    middle: {
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2)
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      height: '100%',
      width: 1
    }
  };
};
var Divider = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Divider(props, ref) {
  var _props$absolute = props.absolute,
      absolute = _props$absolute === void 0 ? false : _props$absolute,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'hr' : _props$component,
      _props$light = props.light,
      light = _props$light === void 0 ? false : _props$light,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$role = props.role,
      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["absolute", "classes", "className", "component", "light", "orientation", "role", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, light && classes.light, {
      vertical: classes.vertical
    }[orientation]),
    role: role,
    ref: ref
  }, other));
});
 false ? Divider.propTypes = {
  /**
   * Absolutely position the element.
   */
  absolute: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the divider will have a lighter color.
   */
  light: PropTypes.bool,

  /**
   * The divider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['fullWidth', 'inset', 'middle'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiDivider'
})(Divider));

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Drawer__ = __webpack_require__(259);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Drawer__["a"]; });


/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export setTranslateValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__transitions_utils__ = __webpack_require__(115);











 // Translate the node so he can't be seen on the screen.
// Later, we gonna translate back the node to his original location
// with `none`.`

function getTranslateValue(direction, node) {
  var rect = node.getBoundingClientRect();
  var transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    var computedStyle = window.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  var offsetX = 0;
  var offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    var transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    return "translateX(".concat(window.innerWidth, "px) translateX(-").concat(rect.left - offsetX, "px)");
  }

  if (direction === 'right') {
    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
  }

  if (direction === 'up') {
    return "translateY(".concat(window.innerHeight, "px) translateY(-").concat(rect.top - offsetY, "px)");
  } // direction === 'down'


  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
}

function setTranslateValue(direction, node) {
  var transform = getTranslateValue(direction, node);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_10__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Slide = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Slide(props, ref) {
  var children = props.children,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'down' : _props$direction,
      inProp = props.in,
      onEnter = props.onEnter,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "direction", "in", "onEnter", "onEntering", "onExit", "onExited", "style", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();
  var childrenRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  /**
   * used in cloneElement(children, { ref: handleRef })
   */

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    childrenRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance);
  }, []);
  var handleRefIntermediary = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(handleRefIntermediary, ref);

  var handleEnter = function handleEnter(_, isAppearing) {
    var node = childrenRef.current;
    setTranslateValue(direction, node);
    Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["b" /* reflow */])(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleEntering = function handleEntering(_, isAppearing) {
    var node = childrenRef.current;
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.easeOut
    }));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  };

  var handleExit = function handleExit() {
    var node = childrenRef.current;
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_11__transitions_utils__["a" /* getTransitionProps */])({
      timeout: timeout,
      style: style
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    node.style.transition = theme.transitions.create('transform', Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionProps, {
      easing: theme.transitions.easing.sharp
    }));
    setTranslateValue(direction, node);

    if (onExit) {
      onExit(node);
    }
  };

  var handleExited = function handleExited() {
    var node = childrenRef.current; // No need for transitions when the component is hidden

    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  };

  var updatePosition = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current);
    }
  }, [direction]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    // Skip configuration where the position is screen size invariant.
    if (!inProp && direction !== 'down' && direction !== 'right') {
      var handleResize = Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce__["a" /* default */])(function () {
        if (childrenRef.current) {
          setTranslateValue(direction, childrenRef.current);
        }
      });
      window.addEventListener('resize', handleResize);
      return function () {
        handleResize.clear();
        window.removeEventListener('resize', handleResize);
      };
    }

    return undefined;
  }, [direction, inProp]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_react_transition_group__["a" /* Transition */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onEnter: handleEnter,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    appear: true,
    in: inProp,
    timeout: timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      ref: handleRef,
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, style, {}, children.props.style)
    }, childProps));
  });
});
 false ? Slide.propTypes = {
  /**
   * A single child content element.
   */
  children: elementAcceptingRef,

  /**
   * Direction the child node will enter from.
   */
  direction: PropTypes.oneOf(['left', 'right', 'up', 'down']),

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onEntering: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  onExited: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Slide);

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanel__ = __webpack_require__(1016);
/* unused harmony reexport default */


/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__ = __webpack_require__(1017);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Collapse__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ExpansionPanelContext__ = __webpack_require__(417);











var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      transition: theme.transitions.create(['margin'], transition),
      '&:before': {
        position: 'absolute',
        left: 0,
        top: -1,
        right: 0,
        height: 1,
        content: '""',
        opacity: 1,
        backgroundColor: theme.palette.divider,
        transition: theme.transitions.create(['opacity', 'background-color'], transition)
      },
      '&:first-child': {
        '&:before': {
          display: 'none'
        }
      },
      '&$expanded': {
        margin: '16px 0',
        '&:first-child': {
          marginTop: 0
        },
        '&:last-child': {
          marginBottom: 0
        },
        '&:before': {
          opacity: 0
        }
      },
      '&$expanded + &': {
        '&:before': {
          display: 'none'
        }
      },
      '&$disabled': {
        backgroundColor: theme.palette.action.disabledBackground
      }
    },

    /* Styles applied to the root element if `square={false}`. */
    rounded: {
      borderRadius: 0,
      '&:first-child': {
        borderTopLeftRadius: theme.shape.borderRadius,
        borderTopRightRadius: theme.shape.borderRadius
      },
      '&:last-child': {
        borderBottomLeftRadius: theme.shape.borderRadius,
        borderBottomRightRadius: theme.shape.borderRadius,
        // Fix a rendering issue on Edge
        '@supports (-ms-ime-align: auto)': {
          borderBottomLeftRadius: 0,
          borderBottomRightRadius: 0
        }
      }
    },

    /* Styles applied to the root element if `expanded={true}`. */
    expanded: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {}
  };
};
var ExpansionPanel = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function ExpansionPanel(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      expandedProp = props.expanded,
      onChange = props.onChange,
      _props$square = props.square,
      square = _props$square === void 0 ? false : _props$square,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_7__Collapse__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(expandedProp != null),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(defaultExpanded),
      expandedState = _React$useState[0],
      setExpandedState = _React$useState[1];

  var expanded = isControlled ? expandedProp : expandedState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (expandedProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled ExpansionPanel to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled ExpansionPanel ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [expandedProp, isControlled]);
  }

  var handleChange = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (event) {
    if (!isControlled) {
      setExpandedState(!expanded);
    }

    if (onChange) {
      onChange(event, !expanded);
    }
  }, [expanded, isControlled, onChange]);

  var _React$Children$toArr = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.toArray(childrenProp),
      _React$Children$toArr2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toArray__["a" /* default */])(_React$Children$toArr),
      summary = _React$Children$toArr2[0],
      children = _React$Children$toArr2.slice(1);

  var contextValue = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useMemo(function () {
    return {
      expanded: expanded,
      disabled: disabled,
      toggle: handleChange
    };
  }, [expanded, disabled, handleChange]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
    ref: ref,
    square: square
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__ExpansionPanelContext__["a" /* default */].Provider, {
    value: contextValue
  }, summary), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: expanded,
    timeout: "auto"
  }, TransitionProps), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    "aria-labelledby": summary.props.id,
    id: summary.props['aria-controls'],
    role: "region"
  }, children)));
});
 false ? ExpansionPanel.propTypes = {
  /**
   * The content of the expansion panel.
   */
  children: chainPropTypes(PropTypes.node.isRequired, function (props) {
    var summary = React.Children.toArray(props.children)[0];

    if (summary.type === React.Fragment) {
      return new Error("Material-UI: the ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
    }

    if (!React.isValidElement(summary)) {
      return new Error('Material-UI: expected the first child of ExpansionPanel to be a valid element.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, expands the panel by default.
   */
  defaultExpanded: PropTypes.bool,

  /**
   * If `true`, the panel will be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, expands the panel, otherwise collapse it.
   * Setting this prop enables control over the panel.
   */
  expanded: PropTypes.bool,

  /**
   * Callback fired when the expand/collapse state is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {boolean} expanded The `expanded` state of the panel.
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  square: PropTypes.bool,

  /**
   * The component used for the collapse effect.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanel'
})(ExpansionPanel));

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _toArray;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__ = __webpack_require__(407);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__iterableToArray__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__nonIterableRest__ = __webpack_require__(408);



function _toArray(arr) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__arrayWithHoles__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_1__iterableToArray__["a" /* default */])(arr) || Object(__WEBPACK_IMPORTED_MODULE_2__nonIterableRest__["a" /* default */])();
}

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelActions__ = __webpack_require__(1019);
/* unused harmony reexport default */


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: 8,
    justifyContent: 'flex-end'
  },

  /* Styles applied to the root element if `disableSpacing={false}`. */
  spacing: {
    '& > :not(:first-child)': {
      marginLeft: 8
    }
  }
};
var ExpansionPanelActions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ExpansionPanelActions(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableSpacing = props.disableSpacing,
      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableSpacing"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, !disableSpacing && classes.spacing),
    ref: ref
  }, other));
});
 false ? ExpansionPanelActions.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the actions do not have additional margin.
   */
  disableSpacing: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelActions'
})(ExpansionPanelActions));

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelDetails__ = __webpack_require__(1021);
/* unused harmony reexport default */


/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: '8px 24px 24px'
  }
};
var ExpansionPanelDetails = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ExpansionPanelDetails(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ExpansionPanelDetails.propTypes = {
  /**
   * The content of the expansion panel details.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelDetails'
})(ExpansionPanelDetails));

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ExpansionPanelSummary__ = __webpack_require__(1023);
/* unused harmony reexport default */


/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IconButton__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__ = __webpack_require__(417);



/* eslint-disable jsx-a11y/aria-role */







var styles = function styles(theme) {
  var transition = {
    duration: theme.transitions.duration.shortest
  };
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      minHeight: 8 * 6,
      transition: theme.transitions.create(['min-height', 'background-color'], transition),
      padding: '0 24px 0 24px',
      '&:hover:not($disabled)': {
        cursor: 'pointer'
      },
      '&$expanded': {
        minHeight: 64
      },
      '&$focused': {
        backgroundColor: theme.palette.grey[300]
      },
      '&$disabled': {
        opacity: 0.38
      }
    },

    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
    expanded: {},

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the children wrapper element. */
    content: {
      display: 'flex',
      flexGrow: 1,
      transition: theme.transitions.create(['margin'], transition),
      margin: '12px 0',
      '&$expanded': {
        margin: '20px 0'
      }
    },

    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
    expandIcon: {
      transform: 'rotate(0deg)',
      transition: theme.transitions.create('transform', transition),
      '&:hover': {
        // Disable the hover effect for the IconButton,
        // because a hover effect should apply to the entire Expand button and
        // not only to the IconButton.
        backgroundColor: 'transparent'
      },
      '&$expanded': {
        transform: 'rotate(180deg)'
      }
    }
  };
};
var ExpansionPanelSummary = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ExpansionPanelSummary(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      expandIcon = props.expandIcon,
      IconButtonProps = props.IconButtonProps,
      onBlur = props.onBlur,
      onClick = props.onClick,
      onFocusVisible = props.onFocusVisible,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focusedState = _React$useState[0],
      setFocusedState = _React$useState[1];

  var handleFocusVisible = function handleFocusVisible(event) {
    setFocusedState(true);

    if (onFocusVisible) {
      onFocusVisible(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocusedState(false);

    if (onBlur) {
      onBlur(event);
    }
  };

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_8__ExpansionPanel_ExpansionPanelContext__["a" /* default */]),
      _React$useContext$dis = _React$useContext.disabled,
      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
      expanded = _React$useContext.expanded,
      toggle = _React$useContext.toggle;

  var handleChange = function handleChange(event) {
    if (toggle) {
      toggle(event);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: false,
    disableRipple: true,
    disabled: disabled,
    component: "div",
    "aria-expanded": expanded,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
    onFocusVisible: handleFocusVisible,
    onBlur: handleBlur,
    onClick: handleChange,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.content, expanded && classes.expanded)
  }, children), expandIcon && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.expandIcon, expanded && classes.expanded),
    edge: "end",
    component: "div",
    tabIndex: null,
    role: null,
    "aria-hidden": true
  }, IconButtonProps), expandIcon));
});
 false ? ExpansionPanelSummary.propTypes = {
  /**
   * The content of the expansion panel summary.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display as the expand indicator.
   */
  expandIcon: PropTypes.node,

  /**
   * Props applied to the `IconButton` element wrapping the expand icon.
   */
  IconButtonProps: PropTypes.object,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocusVisible: PropTypes.func
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiExpansionPanelSummary'
})(ExpansionPanelSummary));

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      minHeight: 36,
      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
        duration: theme.transitions.duration.short
      }),
      borderRadius: '50%',
      padding: 0,
      minWidth: 0,
      width: 56,
      height: 56,
      boxShadow: theme.shadows[6],
      '&:active': {
        boxShadow: theme.shadows[12]
      },
      color: theme.palette.getContrastText(theme.palette.grey[300]),
      backgroundColor: theme.palette.grey[300],
      '&$focusVisible': {
        boxShadow: theme.shadows[6]
      },
      '&:hover': {
        backgroundColor: theme.palette.grey.A100,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.grey[300]
        },
        '&$disabled': {
          backgroundColor: theme.palette.action.disabledBackground
        },
        textDecoration: 'none'
      },
      '&$disabled': {
        color: theme.palette.action.disabled,
        boxShadow: theme.shadows[0],
        backgroundColor: theme.palette.action.disabledBackground
      }
    }),

    /* Styles applied to the span element that wraps the children. */
    label: {
      width: '100%',
      // assure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `color="primary"`. */
    primary: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.main,
      '&:hover': {
        backgroundColor: theme.palette.primary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.primary.main
        }
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    secondary: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        backgroundColor: theme.palette.secondary.dark,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: theme.palette.secondary.main
        }
      }
    },

    /* Styles applied to the root element if `variant="extended"`. */
    extended: {
      borderRadius: 48 / 2,
      padding: '0 16px',
      width: 'auto',
      minHeight: 'auto',
      minWidth: 48,
      height: 48,
      '&$sizeSmall': {
        width: 'auto',
        padding: '0 8px',
        borderRadius: 34 / 2,
        minWidth: 34,
        height: 34
      },
      '&$sizeMedium': {
        width: 'auto',
        padding: '0 16px',
        borderRadius: 40 / 2,
        minWidth: 40,
        height: 40
      }
    },

    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the root element if `size="small"``. */
    sizeSmall: {
      width: 40,
      height: 40
    },

    /* Styles applied to the root element if `size="medium"``. */
    sizeMedium: {
      width: 48,
      height: 48
    }
  };
};
var Fab = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Fab(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'button' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$size = props.size,
      size = _props$size === void 0 ? 'large' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'round' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(size))], disabled && classes.disabled, {
      primary: classes.primary,
      secondary: classes.secondary,
      inherit: classes.colorInherit
    }[color]),
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.label
  }, children));
});
 false ? Fab.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'inherit', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * The URL to link to when the button is clicked.
   * If defined, an `a` element will be used as the root node.
   */
  href: PropTypes.string,

  /**
   * The size of the button.
   * `small` is equivalent to the dense button styling.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * @ignore
   */
  type: PropTypes.string,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['round', 'extended'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFab'
})(Fab));

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      backgroundColor: backgroundColor,
      borderTopLeftRadius: theme.shape.borderRadius,
      borderTopRightRadius: theme.shape.borderRadius,
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      '&:hover': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: backgroundColor
        }
      },
      '&$focused': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
      },
      '&$disabled': {
        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
      }
    },

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:before': {
        borderBottom: "1px solid ".concat(theme.palette.text.primary)
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Pseudo-class applied to the root element if the component is focused. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 12
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 12
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '27px 12px 10px',
      '&$marginDense': {
        paddingTop: 23,
        paddingBottom: 6
      }
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '27px 12px 10px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
        borderTopLeftRadius: 'inherit',
        borderTopRightRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 23,
      paddingBottom: 6
    },

    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
    inputHiddenLabel: {
      paddingTop: 18,
      paddingBottom: 19,
      '&$inputMarginDense': {
        paddingTop: 10,
        paddingBottom: 11
      }
    },

    /* Styles applied to the `input` element if `select={true}`. */
    inputSelect: {
      paddingRight: 24
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var FilledInput = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FilledInput(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? FilledInput.propTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
FilledInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFilledInput'
})(FilledInput));

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__ = __webpack_require__(418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils__ = __webpack_require__(262);



/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */











var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  var placeholderHidden = {
    opacity: '0 !important'
  };
  var placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return {
    /* Styles applied to the root element. */
    root: {
      // Mimics the default input display property used by browsers for an input.
      fontFamily: theme.typography.fontFamily,
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '1.1875em',
      // Reset (19px), match the native input line-height
      boxSizing: 'border-box',
      // Prevent padding issue with fullWidth.
      position: 'relative',
      cursor: 'text',
      display: 'inline-flex',
      alignItems: 'center',
      '&$disabled': {
        color: theme.palette.text.disabled,
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {},

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {},

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {},

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      '&$marginDense': {
        paddingTop: 4 - 1
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {
      width: '100%'
    },

    /* Styles applied to the `input` element. */
    input: {
      font: 'inherit',
      color: 'currentColor',
      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
      border: 0,
      boxSizing: 'content-box',
      background: 'none',
      height: '1.1875em',
      // Reset (19px), match the native input line-height
      margin: 0,
      // Reset for Safari
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      display: 'block',
      // Make the flex item shrink with Firefox
      minWidth: 0,
      width: '100%',
      // Fix IE 11 width issue
      animationName: '$auto-fill-cancel',
      '&::-webkit-input-placeholder': placeholder,
      '&::-moz-placeholder': placeholder,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholder,
      // IE 11
      '&::-ms-input-placeholder': placeholder,
      // Edge
      '&:focus': {
        outline: 0
      },
      // Reset Firefox invalid required input style
      '&:invalid': {
        boxShadow: 'none'
      },
      '&::-webkit-search-decoration': {
        // Remove the padding when type=search.
        '-webkit-appearance': 'none'
      },
      // Show and hide the placeholder logic
      'label[data-shrink=false] + $formControl &': {
        '&::-webkit-input-placeholder': placeholderHidden,
        '&::-moz-placeholder': placeholderHidden,
        // Firefox 19+
        '&:-ms-input-placeholder': placeholderHidden,
        // IE 11
        '&::-ms-input-placeholder': placeholderHidden,
        // Edge
        '&:focus::-webkit-input-placeholder': placeholderVisible,
        '&:focus::-moz-placeholder': placeholderVisible,
        // Firefox 19+
        '&:focus:-ms-input-placeholder': placeholderVisible,
        // IE 11
        '&:focus::-ms-input-placeholder': placeholderVisible // Edge

      },
      '&$disabled': {
        opacity: 1 // Reset iOS opacity

      },
      '&:-webkit-autofill': {
        animationDuration: '5000s',
        animationName: '$auto-fill'
      }
    },
    '@keyframes auto-fill': {
      from: {}
    },
    '@keyframes auto-fill-cancel': {
      from: {}
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 4 - 1
    },

    /* Styles applied to the `input` element if `select={true}`. */
    inputSelect: {
      paddingRight: 24
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      height: 'auto',
      resize: 'none',
      padding: 0
    },

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {
      // Improve type search style.
      '-moz-appearance': 'textfield',
      '-webkit-appearance': 'textfield'
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {},

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {},

    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
    inputHiddenLabel: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect;
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */

var InputBase = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function InputBase(props, ref) {
  var ariaDescribedby = props['aria-describedby'],
      autoComplete = props.autoComplete,
      autoFocus = props.autoFocus,
      classes = props.classes,
      className = props.className,
      color = props.color,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      endAdornment = props.endAdornment,
      error = props.error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      id = props.id,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$inputProps = props.inputProps,
      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
      inputRefProp = props.inputRef,
      margin = props.margin,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onKeyUp = props.onKeyUp,
      placeholder = props.placeholder,
      readOnly = props.readOnly,
      renderSuffix = props.renderSuffix,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      startAdornment = props.startAdornment,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "select", "startAdornment", "type", "value"]);

  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var handleInputRefWarning = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    if (false) {
      if (instance && !(instance instanceof HTMLInputElement) && !instance.focus) {
        console.error(['Material-UI: you have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
      }
    }
  }, []);
  var handleInputPropsRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputPropsProp.ref, handleInputRefWarning);
  var handleInputRefProp = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRefProp, handleInputPropsRefProp);
  var handleInputRef = Object(__WEBPACK_IMPORTED_MODULE_10__utils_useForkRef__["a" /* default */])(inputRef, handleInputRefProp);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focused = _React$useState[0],
      setFocused = _React$useState[1];

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])();

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (muiFormControl) {
        return muiFormControl.registerEffect();
      }

      return undefined;
    }, [muiFormControl]);
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  var onFilled = muiFormControl && muiFormControl.onFilled;
  var onEmpty = muiFormControl && muiFormControl.onEmpty;
  var checkDirty = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (obj) {
    if (Object(__WEBPACK_IMPORTED_MODULE_12__utils__["b" /* isFilled */])(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect(function () {
    if (isControlled) {
      checkDirty({
        value: value
      });
    }
  }, [value, checkDirty, isControlled]);

  var handleFocus = function handleFocus(event) {
    // Fix a bug with IE 11 where the focus/blur events are triggered
    // while the input is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      var element = event.target || inputRef.current;

      if (element == null) {
        throw new TypeError('Material-UI: Expected valid input target. ' + 'Did you use a custom `inputComponent` and forget to forward refs? ' + 'See https://material-ui.com/r/input-component-ref-interface for more info.');
      }

      checkDirty({
        value: element.value
      });
    }

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
    } // Perform in the willUpdate


    if (onChange) {
      onChange.apply(void 0, [event].concat(args));
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    checkDirty(inputRef.current);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  var handleClick = function handleClick(event) {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  var InputComponent = inputComponent;

  var inputProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, inputPropsProp, {
    ref: handleInputRef
  });

  if (typeof InputComponent !== 'string') {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Rename ref to inputRef as we don't know the
      // provided `inputComponent` structure.
      inputRef: handleInputRef,
      type: type
    }, inputProps, {
      ref: null
    });
  } else if (multiline) {
    if (rows && !rowsMax) {
      InputComponent = 'textarea';
    } else {
      inputProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        rows: rows,
        rowsMax: rowsMax
      }, inputProps);
      InputComponent = __WEBPACK_IMPORTED_MODULE_11__TextareaAutosize__["a" /* default */];
    }
  } else {
    inputProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      type: type
    }, inputProps);
  }

  var handleAutoFill = function handleAutoFill(event) {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName.indexOf('auto-fill-cancel') !== -1 ? inputRef.current : {
      value: 'x'
    });
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, {
      dense: classes.marginDense
    }[fcs.margin]),
    onClick: handleClick,
    ref: ref
  }, other), startAdornment, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-invalid": fcs.error,
    "aria-describedby": ariaDescribedby,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    disabled: fcs.disabled,
    id: id,
    onAnimationStart: handleAutoFill,
    name: name,
    placeholder: placeholder,
    readOnly: readOnly,
    required: fcs.required,
    rows: rows,
    value: value,
    onKeyDown: onKeyDown,
    onKeyUp: onKeyUp
  }, inputProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, select && classes.inputSelect, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, {
      search: classes.inputTypeSearch
    }[type], {
      dense: classes.inputMarginDense
    }[fcs.margin]),
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus
  }))), endAdornment, renderSuffix ? renderSuffix(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fcs, {
    startAdornment: startAdornment
  })) : null);
});
 false ? InputBase.propTypes = {
  /**
   * @ignore
   */
  'aria-describedby': PropTypes.string,

  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the `input` element.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onKeyUp: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * @ignore
   */
  renderSuffix: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Should be `true` when the component hosts a select.
   */
  select: PropTypes.bool,

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputBase'
})(InputBase));

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(28);







function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect;
var styles = {
  /* Styles applied to the shadow textarea element. */
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
var TextareaAutosize = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TextareaAutosize(props, ref) {
  var onChange = props.onChange,
      rows = props.rows,
      rowsMax = props.rowsMax,
      style = props.style,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange", "rows", "rowsMax", "style", "value"]);

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(value != null),
      isControlled = _React$useRef.current;

  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(ref, inputRef);
  var shadowRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState({}),
      state = _React$useState[0],
      setState = _React$useState[1];

  var syncHeight = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    var input = inputRef.current;
    var computedStyle = window.getComputedStyle(input);
    var inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';
    var boxSizing = computedStyle['box-sizing'];
    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content

    var outerHeight = innerHeight;

    if (rows != null) {
      outerHeight = Math.max(Number(rows) * singleRowHeight, outerHeight);
    }

    if (rowsMax != null) {
      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(function (prevState) {
      // Need a large enough different to update the height.
      // This prevents infinite rendering loop.
      if (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow) {
        return {
          overflow: overflow,
          outerHeightStyle: outerHeightStyle
        };
      }

      return prevState;
    });
  }, [rows, rowsMax, props.placeholder]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      syncHeight();
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [syncHeight]);
  useEnhancedEffect(function () {
    syncHeight();
  });

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("textarea", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: value,
    onChange: handleChange,
    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
    ,
    rows: rows || 1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      height: state.outerHeightStyle,
      // Need a large enough different to allow scrolling.
      // This prevents infinite rendering loop.
      overflow: state.overflow ? 'hidden' : null
    }, style)
  }, other)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("textarea", {
    "aria-hidden": true,
    className: props.className,
    readOnly: true,
    ref: shadowRef,
    tabIndex: -1,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, styles.shadow, {}, style)
  }));
});
 false ? TextareaAutosize.propTypes = {
  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  placeholder: PropTypes.string,

  /**
   * Minimum number of rows to display.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * @ignore
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TextareaAutosize);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputBase_utils__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlContext__ = __webpack_require__(177);










var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'inline-flex',
    flexDirection: 'column',
    position: 'relative',
    // Reset fieldset default style.
    minWidth: 0,
    padding: 0,
    margin: 0,
    border: 0,
    verticalAlign: 'top' // Fix alignment issue on Safari.

  },

  /* Styles applied to the root element if `margin="normal"`. */
  marginNormal: {
    marginTop: 16,
    marginBottom: 8
  },

  /* Styles applied to the root element if `margin="dense"`. */
  marginDense: {
    marginTop: 8,
    marginBottom: 4
  },

  /* Styles applied to the root element if `fullWidth={true}`. */
  fullWidth: {
    width: '100%'
  }
};
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️Only one input can be used within a FormControl.
 */

var FormControl = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FormControl(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$hiddenLabel = props.hiddenLabel,
      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
      _props$margin = props.margin,
      margin = _props$margin === void 0 ? 'none' : _props$margin,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disabled", "error", "fullWidth", "hiddenLabel", "margin", "color", "required", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialAdornedStart = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        var input = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Select']) ? child.props.input : child;

        if (input && Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["a" /* isAdornedStart */])(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  }),
      adornedStart = _React$useState[0],
      setAdornedStart = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(function () {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    var initialFilled = false;

    if (children) {
      __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(children, function (child) {
        if (!Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Input', 'Select'])) {
          return;
        }

        if (Object(__WEBPACK_IMPORTED_MODULE_5__InputBase_utils__["b" /* isFilled */])(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  }),
      filled = _React$useState2[0],
      setFilled = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  if (disabled && focused) {
    setFocused(false);
  }

  var registerEffect;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    var registeredInput = React.useRef(false);

    registerEffect = function registerEffect() {
      if (registeredInput.current) {
        console.error(['Material-UI: there are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
      }

      registeredInput.current = true;
      return function () {
        registeredInput.current = false;
      };
    };
  }

  var onFilled = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    setFilled(true);
  }, []);
  var onEmpty = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    setFilled(false);
  }, []);
  var childContext = {
    adornedStart: adornedStart,
    setAdornedStart: setAdornedStart,
    color: color,
    disabled: disabled,
    error: error,
    filled: filled,
    focused: focused,
    hiddenLabel: hiddenLabel,
    margin: margin,
    onBlur: function onBlur() {
      setFocused(false);
    },
    onEmpty: onEmpty,
    onFilled: onFilled,
    onFocus: function onFocus() {
      setFocused(true);
    },
    registerEffect: registerEffect,
    required: required,
    variant: variant
  };
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__FormControlContext__["a" /* default */].Provider, {
    value: childContext
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, margin !== 'none' && classes["margin".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(margin))], fullWidth && classes.fullWidth),
    ref: ref
  }, other), children));
});
 false ? FormControl.propTypes = {
  /**
   * The contents of the form control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the label, input and helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the component will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * If `true`, the label will be hidden.
   * This is used to increase density for a `FilledInput`.
   * Be sure to add `aria-label` to the `input` element.
   */
  hiddenLabel: PropTypes.bool,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControl'
})(FormControl));

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__FormControlLabel__ = __webpack_require__(1030);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__FormControlLabel__["a"]; });


/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(16);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      alignItems: 'center',
      cursor: 'pointer',
      // For correct alignment with the text.
      verticalAlign: 'middle',
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      marginLeft: -11,
      marginRight: 16,
      // used for row presentation of radio/checkbox
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `labelPlacement="start"`. */
    labelPlacementStart: {
      flexDirection: 'row-reverse',
      marginLeft: 16,
      // used for row presentation of radio/checkbox
      marginRight: -11
    },

    /* Styles applied to the root element if `labelPlacement="top"`. */
    labelPlacementTop: {
      flexDirection: 'column-reverse',
      marginLeft: 16
    },

    /* Styles applied to the root element if `labelPlacement="bottom"`. */
    labelPlacementBottom: {
      flexDirection: 'column',
      marginLeft: 16
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the label's Typography component. */
    label: {
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    }
  };
};
/**
 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

var FormControlLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FormControlLabel(props, ref) {
  var checked = props.checked,
      classes = props.classes,
      className = props.className,
      control = props.control,
      disabledProp = props.disabled,
      inputRef = props.inputRef,
      label = props.label,
      _props$labelPlacement = props.labelPlacement,
      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
      name = props.name,
      onChange = props.onChange,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl__["b" /* useFormControl */])();
  var disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  var controlProps = {
    disabled: disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(labelPlacement))], disabled && classes.disabled),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(control, controlProps), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */], {
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, disabled && classes.disabled)
  }, label));
});
 false ? FormControlLabel.propTypes = {
  /**
   * If `true`, the component appears selected.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
   */
  control: PropTypes.element,

  /**
   * If `true`, the control will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The text to be used in an enclosing label element.
   */
  label: PropTypes.node,

  /**
   * The position of the label.
   */
  labelPlacement: PropTypes.oneOf(['end', 'start', 'top', 'bottom']),

  /*
   * @ignore
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * The value of the component.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormControlLabel'
})(FormControlLabel));

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexDirection: 'column',
    flexWrap: 'wrap'
  },

  /* Styles applied to the root element if `row={true}`. */
  row: {
    flexDirection: 'row'
  }
};
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

var FormGroup = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FormGroup(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$row = props.row,
      row = _props$row === void 0 ? false : _props$row,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "row"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, row && classes.row),
    ref: ref
  }, other));
});
 false ? FormGroup.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Display group of elements in a compact row.
   */
  row: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormGroup'
})(FormGroup));

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.caption, {
      textAlign: 'left',
      marginTop: 8,
      lineHeight: '1em',
      minHeight: '1em',
      margin: 0,
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      marginTop: 4
    },

    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
    contained: {
      margin: '8px 14px 0'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {}
  };
};
var FormHelperText = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FormHelperText(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'p' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      margin = props.margin,
      required = props.required,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, {
      dense: classes.marginDense
    }[fcs.margin]),
    ref: ref
  }, other));
});
 false ? FormHelperText.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the helper text should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, helper text should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the helper text should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the helper text should use focused classes key.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * If `true`, the helper text should use required classes key.
   */
  required: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormHelperText'
})(FormHelperText));

/***/ }),
/* 1033 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(5);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      color: theme.palette.text.secondary
    }, theme.typography.body1, {
      lineHeight: 1,
      padding: 0,
      '&$focused': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      },
      '&$error': {
        color: theme.palette.error.main
      }
    }),

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused': {
        color: theme.palette.secondary.main
      }
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `filled={true}`. */
    filled: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Styles applied to the asterisk element. */
    asterisk: {
      '&$error': {
        color: theme.palette.error.main
      }
    }
  };
};
var FormLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function FormLabel(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      color = props.color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'label' : _props$component,
      disabled = props.disabled,
      error = props.error,
      filled = props.filled,
      focused = props.focused,
      required = props.required,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
    ref: ref
  }, other), children, fcs.required && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.asterisk, fcs.error && classes.error)
  }, "\u2009", '*'));
});
 false ? FormLabel.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the label should be displayed in a disabled state.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label should be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the label should use filled classes key.
   */
  filled: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused (used by `FormGroup` components).
   */
  focused: PropTypes.bool,

  /**
   * If `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiFormLabel'
})(FormLabel));

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(1035);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_requirePropFactory__ = __webpack_require__(422);


// A grid component using the following libs as inspiration.
//
// For the implementation:
// - https://getbootstrap.com/docs/4.3/layout/grid/
// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
// - https://github.com/roylee0704/react-flexbox-grid
// - https://material.angularjs.org/latest/layout/introduction
//
// Follow this flexbox Guide to better understand the underlying model:
// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/





var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

function generateGrid(globalStyles, theme, breakpoint) {
  var styles = {};
  GRID_SIZES.forEach(function (size) {
    var key = "grid-".concat(breakpoint, "-").concat(size);

    if (size === true) {
      // For the auto layouting
      styles[key] = {
        flexBasis: 0,
        flexGrow: 1,
        maxWidth: '100%'
      };
      return;
    }

    if (size === 'auto') {
      styles[key] = {
        flexBasis: 'auto',
        flexGrow: 0,
        maxWidth: 'none'
      };
      return;
    } // Keep 7 significant numbers.


    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41

    styles[key] = {
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    };
  }); // No need for a media query for the first size.

  if (breakpoint === 'xs') {
    Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function getOffset(val) {
  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var parse = parseFloat(val);
  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
}

function generateGutter(theme, breakpoint) {
  var styles = {};
  SPACINGS.forEach(function (spacing) {
    var themeSpacing = theme.spacing(spacing);

    if (themeSpacing === 0) {
      return;
    }

    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
      margin: "-".concat(getOffset(themeSpacing, 2)),
      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
      '& > $item': {
        padding: getOffset(themeSpacing, 2)
      }
    };
  });
  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',


var styles = function styles(theme) {
  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    /* Styles applied to the root element */
    root: {},

    /* Styles applied to the root element if `container={true}`. */
    container: {
      boxSizing: 'border-box',
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%'
    },

    /* Styles applied to the root element if `item={true}`. */
    item: {
      boxSizing: 'border-box',
      margin: '0' // For instance, it's useful when used with a `figure` element.

    },

    /* Styles applied to the root element if `zeroMinWidth={true}`. */
    zeroMinWidth: {
      minWidth: 0
    },

    /* Styles applied to the root element if `direction="column"`. */
    'direction-xs-column': {
      flexDirection: 'column'
    },

    /* Styles applied to the root element if `direction="column-reverse"`. */
    'direction-xs-column-reverse': {
      flexDirection: 'column-reverse'
    },

    /* Styles applied to the root element if `direction="rwo-reverse"`. */
    'direction-xs-row-reverse': {
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `wrap="nowrap"`. */
    'wrap-xs-nowrap': {
      flexWrap: 'nowrap'
    },

    /* Styles applied to the root element if `wrap="reverse"`. */
    'wrap-xs-wrap-reverse': {
      flexWrap: 'wrap-reverse'
    },

    /* Styles applied to the root element if `alignItems="center"`. */
    'align-items-xs-center': {
      alignItems: 'center'
    },

    /* Styles applied to the root element if `alignItems="flex-start"`. */
    'align-items-xs-flex-start': {
      alignItems: 'flex-start'
    },

    /* Styles applied to the root element if `alignItems="flex-end"`. */
    'align-items-xs-flex-end': {
      alignItems: 'flex-end'
    },

    /* Styles applied to the root element if `alignItems="baseline"`. */
    'align-items-xs-baseline': {
      alignItems: 'baseline'
    },

    /* Styles applied to the root element if `alignContent="center"`. */
    'align-content-xs-center': {
      alignContent: 'center'
    },

    /* Styles applied to the root element if `alignContent="flex-start"`. */
    'align-content-xs-flex-start': {
      alignContent: 'flex-start'
    },

    /* Styles applied to the root element if `alignContent="flex-end"`. */
    'align-content-xs-flex-end': {
      alignContent: 'flex-end'
    },

    /* Styles applied to the root element if `alignContent="space-between"`. */
    'align-content-xs-space-between': {
      alignContent: 'space-between'
    },

    /* Styles applied to the root element if `alignContent="space-around"`. */
    'align-content-xs-space-around': {
      alignContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="center"`. */
    'justify-xs-center': {
      justifyContent: 'center'
    },

    /* Styles applied to the root element if `justify="flex-end"`. */
    'justify-xs-flex-end': {
      justifyContent: 'flex-end'
    },

    /* Styles applied to the root element if `justify="space-between"`. */
    'justify-xs-space-between': {
      justifyContent: 'space-between'
    },

    /* Styles applied to the root element if `justify="space-around"`. */
    'justify-xs-space-around': {
      justifyContent: 'space-around'
    },

    /* Styles applied to the root element if `justify="space-evenly"`. */
    'justify-xs-space-evenly': {
      justifyContent: 'space-evenly'
    }
  }, generateGutter(theme, 'xs'), {}, theme.breakpoints.keys.reduce(function (accumulator, key) {
    // Use side effect over immutability for better performance.
    generateGrid(accumulator, theme, key);
    return accumulator;
  }, {}));
};
var Grid = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function (props, ref) {
  var _props$alignContent = props.alignContent,
      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
      _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
      classes = props.classes,
      classNameProp = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$container = props.container,
      container = _props$container === void 0 ? false : _props$container,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'row' : _props$direction,
      _props$item = props.item,
      item = _props$item === void 0 ? false : _props$item,
      _props$justify = props.justify,
      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
      _props$lg = props.lg,
      lg = _props$lg === void 0 ? false : _props$lg,
      _props$md = props.md,
      md = _props$md === void 0 ? false : _props$md,
      _props$sm = props.sm,
      sm = _props$sm === void 0 ? false : _props$sm,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
      _props$wrap = props.wrap,
      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
      _props$xl = props.xl,
      xl = _props$xl === void 0 ? false : _props$xl,
      _props$xs = props.xs,
      xs = _props$xs === void 0 ? false : _props$xs,
      _props$zeroMinWidth = props.zeroMinWidth,
      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);

  var className = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: className,
    ref: ref
  }, other));
});

if (false) {
  // can't use named function expression since the function body references `Grid`
  // which would point to the render function instead of the actual component
  Grid.displayName = 'ForwardRef(Grid)';
}

 false ? Grid.propTypes = {
  /**
   * Defines the `align-content` style property.
   * It's applied for all screen sizes.
   */
  alignContent: PropTypes.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),

  /**
   * Defines the `align-items` style property.
   * It's applied for all screen sizes.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the component will have the flex *container* behavior.
   * You should be wrapping *items* with a *container*.
   */
  container: PropTypes.bool,

  /**
   * Defines the `flex-direction` style property.
   * It is applied for all screen sizes.
   */
  direction: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),

  /**
   * If `true`, the component will have the flex *item* behavior.
   * You should be wrapping *items* with a *container*.
   */
  item: PropTypes.bool,

  /**
   * Defines the `justify-content` style property.
   * It is applied for all screen sizes.
   */
  justify: PropTypes.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `lg` breakpoint and wider screens if not overridden.
   */
  lg: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `md` breakpoint and wider screens if not overridden.
   */
  md: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `sm` breakpoint and wider screens if not overridden.
   */
  sm: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the space between the type `item` component.
   * It can only be used on a type `container` component.
   */
  spacing: PropTypes.oneOf(SPACINGS),

  /**
   * Defines the `flex-wrap` style property.
   * It's applied for all screen sizes.
   */
  wrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for the `xl` breakpoint and wider screens.
   */
  xl: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * Defines the number of grids the component is going to use.
   * It's applied for all the screen sizes with the lowest priority.
   */
  xs: PropTypes.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),

  /**
   * If `true`, it sets `min-width: 0` on the item.
   * Refer to the limitations section of the documentation to better understand the use case.
   */
  zeroMinWidth: PropTypes.bool
} : void 0;
var StyledGrid = Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGrid'
})(Grid);

if (false) {
  var requireProp = requirePropFactory('Grid');
  StyledGrid.propTypes = _extends({}, StyledGrid.propTypes, {
    alignContent: requireProp('container'),
    alignItems: requireProp('container'),
    direction: requireProp('container'),
    justify: requireProp('container'),
    lg: requireProp('item'),
    md: requireProp('item'),
    sm: requireProp('item'),
    spacing: requireProp('container'),
    wrap: requireProp('container'),
    xs: requireProp('item'),
    zeroMinWidth: requireProp('item')
  });
}

/* harmony default export */ __webpack_exports__["a"] = (StyledGrid);

/***/ }),
/* 1036 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridList__ = __webpack_require__(1037);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GridList__["a"]; });


/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    overflowY: 'auto',
    listStyle: 'none',
    padding: 0,
    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.

  }
};
var GridList = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function GridList(props, ref) {
  var _props$cellHeight = props.cellHeight,
      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 2 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      margin: -spacing / 2
    }, style)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childCols = child.props.cols || 1;
    var childRows = child.props.rows || 1;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        width: "".concat(100 / cols * childCols, "%"),
        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
        padding: spacing / 2
      }, child.props.style)
    });
  }));
});
 false ? GridList.propTypes = {
  /**
   * Number of px for one cell height.
   * You can set `'auto'` if you want to let the children determine the height.
   */
  cellHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['auto'])]),

  /**
   * Grid Tiles that will be in Grid List.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Number of columns.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Number of px for the spacing between tiles.
   */
  spacing: PropTypes.number,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridList'
})(GridList));

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTile__ = __webpack_require__(1039);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__GridListTile__["a"]; });


/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_debounce__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(141);









var styles = {
  /* Styles applied to the root element. */
  root: {
    boxSizing: 'border-box',
    flexShrink: 0
  },

  /* Styles applied to the `div` element that wraps the children. */
  tile: {
    position: 'relative',
    display: 'block',
    // In case it's not rendered with a div.
    height: '100%',
    overflow: 'hidden'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullHeight: {
    height: '100%',
    transform: 'translateX(-50%)',
    position: 'relative',
    left: '50%'
  },

  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
  imgFullWidth: {
    width: '100%',
    position: 'relative',
    transform: 'translateY(-50%)',
    top: '50%'
  }
};

var fit = function fit(imgEl, classes) {
  if (!imgEl || !imgEl.complete) {
    return;
  }

  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
    var _imgEl$classList, _imgEl$classList2;

    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));

    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));
  } else {
    var _imgEl$classList3, _imgEl$classList4;

    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullHeight.split(' ')));

    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(classes.imgFullWidth.split(' ')));
  }
};

function ensureImageCover(imgEl, classes) {
  if (!imgEl) {
    return;
  }

  if (imgEl.complete) {
    fit(imgEl, classes);
  } else {
    imgEl.addEventListener('load', function () {
      fit(imgEl, classes);
    });
  }
}

var GridListTile = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function GridListTile(props, ref) {
  // cols rows default values are for docs only
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$cols = props.cols,
      cols = _props$cols === void 0 ? 1 : _props$cols,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 1 : _props$rows,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "cols", "component", "rows"]);

  var imgRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    ensureImageCover(imgRef.current, classes);
  });
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_6__utils_debounce__["a" /* default */])(function () {
      fit(imgRef.current, classes);
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [classes]);
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.tile
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) {
      return null;
    }

    if (child.type === 'img' || Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(child, ['Image'])) {
      return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
        ref: imgRef
      });
    }

    return child;
  })));
});
 false ? GridListTile.propTypes = {
  /**
   * Theoretically you can pass any node as children, but the main use case is to pass an img,
   * in which case GridListTile takes care of making the image "cover" available space
   * (similar to `background-size: cover` or to `object-fit: cover`).
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Width of the tile in number of grid cells.
   */
  cols: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Height of the tile in number of grid cells.
   */
  rows: PropTypes.number
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTile'
})(GridListTile));

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GridListTileBar__ = __webpack_require__(1041);
/* unused harmony reexport default */


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      left: 0,
      right: 0,
      height: 48,
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      fontFamily: theme.typography.fontFamily
    },

    /* Styles applied to the root element if `titlePosition="bottom"`. */
    titlePositionBottom: {
      bottom: 0
    },

    /* Styles applied to the root element if `titlePosition="top"`. */
    titlePositionTop: {
      top: 0
    },

    /* Styles applied to the root element if a `subtitle` is provided. */
    rootSubtitle: {
      height: 68
    },

    /* Styles applied to the title and subtitle container element. */
    titleWrap: {
      flexGrow: 1,
      marginLeft: 16,
      marginRight: 16,
      color: theme.palette.common.white,
      overflow: 'hidden'
    },

    /* Styles applied to the container element if `actionPosition="left"`. */
    titleWrapActionPosLeft: {
      marginLeft: 0
    },

    /* Styles applied to the container element if `actionPosition="right"`. */
    titleWrapActionPosRight: {
      marginRight: 0
    },

    /* Styles applied to the title container element. */
    title: {
      fontSize: theme.typography.pxToRem(16),
      lineHeight: '24px',
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the subtitle container element. */
    subtitle: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1,
      textOverflow: 'ellipsis',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the actionIcon if supplied. */
    actionIcon: {},

    /* Styles applied to the actionIcon if `actionPosition="left"`. */
    actionIconActionPosLeft: {
      order: -1
    }
  };
};
var GridListTileBar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function GridListTileBar(props, ref) {
  var actionIcon = props.actionIcon,
      _props$actionPosition = props.actionPosition,
      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
      classes = props.classes,
      className = props.className,
      subtitle = props.subtitle,
      title = props.title,
      _props$titlePosition = props.titlePosition,
      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);

  var actionPos = actionIcon && actionPosition;
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.titleWrap, {
      left: classes.titleWrapActionPosLeft,
      right: classes.titleWrapActionPosRight
    }[actionPos])
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.title
  }, title), subtitle ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.subtitle
  }, subtitle) : null), actionIcon ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.actionIcon, {
      left: classes.actionIconActionPosLeft
    }[actionPos])
  }, actionIcon) : null);
});
 false ? GridListTileBar.propTypes = {
  /**
   * An IconButton element to be used as secondary action target
   * (primary action target is the tile itself).
   */
  actionIcon: PropTypes.node,

  /**
   * Position of secondary action IconButton.
   */
  actionPosition: PropTypes.oneOf(['left', 'right']),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * String or element serving as subtitle (support text).
   */
  subtitle: PropTypes.node,

  /**
   * Title to be displayed on tile.
   */
  title: PropTypes.node,

  /**
   * Position of the title bar.
   */
  titlePosition: PropTypes.oneOf(['top', 'bottom'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiGridListTileBar'
})(GridListTileBar));

/***/ }),
/* 1042 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__transitions_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__ = __webpack_require__(28);









function getScale(value) {
  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
}

var styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Grow = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Grow(props, ref) {
  var children = props.children,
      inProp = props.in,
      onEnter = props.onEnter,
      onExit = props.onExit,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);

  var timer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var autoTimeout = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useForkRef__["a" /* default */])(children.ref, ref);
  var theme = Object(__WEBPACK_IMPORTED_MODULE_5__styles_useTheme__["a" /* default */])();

  var handleEnter = function handleEnter(node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_6__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var _getTransitionProps = Object(__WEBPACK_IMPORTED_MODULE_6__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    }),
        transitionDuration = _getTransitionProps.duration,
        delay = _getTransitionProps.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var _getTransitionProps2 = Object(__WEBPACK_IMPORTED_MODULE_6__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    }),
        transitionDuration = _getTransitionProps2.duration,
        delay = _getTransitionProps2.delay;

    var duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration: duration,
      delay: delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  };

  var addEndListener = function addEndListener(_, next) {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      clearTimeout(timer.current);
    };
  }, []);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__["a" /* Transition */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    onEnter: handleEnter,
    onExit: handleExit,
    addEndListener: addEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        opacity: 0,
        transform: getScale(0.75),
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], {}, style, {}, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Grow.propTypes = {
  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * If `true`, show the component; triggers the enter or exit animation.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  }), PropTypes.oneOf(['auto'])])
} : void 0;
Grow.muiSupportAuto = true;
/* harmony default export */ __webpack_exports__["a"] = (Grow);

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Hidden__ = __webpack_require__(1044);
/* unused harmony reexport default */


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__HiddenJs__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__HiddenCss__ = __webpack_require__(1048);






/**
 * Responsively hides children based on the selected implementation.
 */

function Hidden(props) {
  var _props$implementation = props.implementation,
      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
      _props$lgDown = props.lgDown,
      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
      _props$lgUp = props.lgUp,
      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
      _props$mdDown = props.mdDown,
      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
      _props$mdUp = props.mdUp,
      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
      _props$smDown = props.smDown,
      smDown = _props$smDown === void 0 ? false : _props$smDown,
      _props$smUp = props.smUp,
      smUp = _props$smUp === void 0 ? false : _props$smUp,
      _props$xlDown = props.xlDown,
      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
      _props$xlUp = props.xlUp,
      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
      _props$xsDown = props.xsDown,
      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
      _props$xsUp = props.xsUp,
      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);

  if (implementation === 'js') {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__HiddenJs__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      lgDown: lgDown,
      lgUp: lgUp,
      mdDown: mdDown,
      mdUp: mdUp,
      smDown: smDown,
      smUp: smUp,
      xlDown: xlDown,
      xlUp: xlUp,
      xsDown: xsDown,
      xsUp: xsUp
    }, other));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__HiddenCss__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    lgDown: lgDown,
    lgUp: lgUp,
    mdDown: mdDown,
    mdUp: mdUp,
    smDown: smDown,
    smUp: smUp,
    xlDown: xlDown,
    xlUp: xlUp,
    xsDown: xsDown,
    xsUp: xsUp
  }, other));
}

 false ? Hidden.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Hidden);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__withWidth__ = __webpack_require__(264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_useTheme__ = __webpack_require__(32);




/**
 * @ignore - internal component.
 */

function HiddenJs(props) {
  var children = props.children,
      only = props.only,
      width = props.width;
  var theme = Object(__WEBPACK_IMPORTED_MODULE_3__styles_useTheme__["a" /* default */])();
  var visible = true; // `only` check is faster to get out sooner if used.

  if (only) {
    if (Array.isArray(only)) {
      for (var i = 0; i < only.length; i += 1) {
        var breakpoint = only[i];

        if (width === breakpoint) {
          visible = false;
          break;
        }
      }
    } else if (only && width === only) {
      visible = false;
    }
  } // Allow `only` to be combined with other props. If already hidden, no need to check others.


  if (visible) {
    // determine visibility based on the smallest size up
    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
      var _breakpoint = theme.breakpoints.keys[_i];
      var breakpointUp = props["".concat(_breakpoint, "Up")];
      var breakpointDown = props["".concat(_breakpoint, "Down")];

      if (breakpointUp && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["c" /* isWidthUp */])(_breakpoint, width) || breakpointDown && Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["b" /* isWidthDown */])(_breakpoint, width)) {
        visible = false;
        break;
      }
    }
  }

  if (!visible) {
    return null;
  }

  return children;
}

HiddenJs.propTypes = {
  /**
   * The content of the component.
   */
  children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node,

  /**
   * @ignore
   */
  className: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['js', 'css']),

  /**
   * You can use this prop when choosing the `js` implementation with server-side rendering.
   *
   * As `window.innerWidth` is unavailable on the server,
   * we default to rendering an empty component during the first mount.
   * You might want to use an heuristic to approximate
   * the screen width of the client browser screen width.
   *
   * For instance, you could be using the user-agent or the client-hints.
   * https://caniuse.com/#search=client%20hint
   */
  initialWidth: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * @ignore
   * width prop provided by withWidth decorator.
   */
  width: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string.isRequired,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool
};

if (false) {
  HiddenJs.propTypes = exactProp(HiddenJs.propTypes);
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__withWidth__["a" /* default */])()(HiddenJs));

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(72);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;

function getStatics(component) {
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  }

  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export testReset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_styles__ = __webpack_require__(59);


 // This variable will be true once the server-side hydration is completed.

var hydrationCompleted = false;

function useMediaQuery(queryInput) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var theme = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["g" /* useTheme */])();
  var props = Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_styles__["c" /* getThemeProps */])({
    theme: theme,
    name: 'MuiUseMediaQuery',
    props: {}
  });

  if (false) {
    if (typeof queryInput === 'function' && theme === null) {
      console.error(['Material-UI: the `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
    }
  }

  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
  // All the browsers Material-UI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';

  var _props$options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, {}, options),
      _props$options$defaul = _props$options.defaultMatches,
      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
      _props$options$noSsr = _props$options.noSsr,
      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
      _props$options$ssrMat = _props$options.ssrMatchMedia,
      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(function () {
    if ((hydrationCompleted || noSsr) && supportMatchMedia) {
      return window.matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  }),
      match = _React$useState[0],
      setMatch = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function () {
    var active = true;
    hydrationCompleted = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    var queryList = window.matchMedia(query);

    var updateMatch = function updateMatch() {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return function () {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, supportMatchMedia]);
  return match;
}

function testReset() {
  hydrationCompleted = false;
}
/* harmony default export */ __webpack_exports__["a"] = (useMediaQuery);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(32);








var styles = function styles(theme) {
  var hidden = {
    display: 'none'
  };
  return theme.breakpoints.keys.reduce(function (acc, key) {
    acc["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(key))] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.only(key), hidden);
    acc["".concat(key, "Up")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up(key), hidden);
    acc["".concat(key, "Down")] = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down(key), hidden);
    return acc;
  }, {});
};
/**
 * @ignore - internal component.
 */


function HiddenCss(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      lgDown = props.lgDown,
      lgUp = props.lgUp,
      mdDown = props.mdDown,
      mdUp = props.mdUp,
      only = props.only,
      smDown = props.smDown,
      smUp = props.smUp,
      xlDown = props.xlDown,
      xlUp = props.xlUp,
      xsDown = props.xsDown,
      xsUp = props.xsUp,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "lgDown", "lgUp", "mdDown", "mdUp", "only", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  if (false) {
    if (Object.keys(other).length !== 0 && !(Object.keys(other).length === 1 && other.hasOwnProperty('ref'))) {
      console.error("Material-UI: unsupported props received ".concat(Object.keys(other).join(', '), " by `<Hidden />`."));
    }
  }

  var clsx = [];

  if (className) {
    clsx.push(className);
  }

  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
    var breakpoint = theme.breakpoints.keys[i];
    var breakpointUp = props["".concat(breakpoint, "Up")];
    var breakpointDown = props["".concat(breakpoint, "Down")];

    if (breakpointUp) {
      clsx.push(classes["".concat(breakpoint, "Up")]);
    }

    if (breakpointDown) {
      clsx.push(classes["".concat(breakpoint, "Down")]);
    }
  }

  if (only) {
    var onlyBreakpoints = Array.isArray(only) ? only : [only];
    onlyBreakpoints.forEach(function (breakpoint) {
      clsx.push(classes["only".concat(Object(__WEBPACK_IMPORTED_MODULE_4__utils_capitalize__["a" /* default */])(breakpoint))]);
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: clsx.join(' ')
  }, children);
}

 false ? HiddenCss.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Specify which implementation to use.  'js' is the default, 'css' works better for
   * server-side rendering.
   */
  implementation: PropTypes.oneOf(['js', 'css']),

  /**
   * If true, screens this size and down will be hidden.
   */
  lgDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  lgUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  mdDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  mdUp: PropTypes.bool,

  /**
   * Hide the given breakpoint(s).
   */
  only: PropTypes.oneOfType([PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), PropTypes.arrayOf(PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),

  /**
   * If true, screens this size and down will be hidden.
   */
  smDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  smUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xlDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xlUp: PropTypes.bool,

  /**
   * If true, screens this size and down will be hidden.
   */
  xsDown: PropTypes.bool,

  /**
   * If true, screens this size and up will be hidden.
   */
  xsUp: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateHiddenCss'
})(HiddenCss));

/***/ }),
/* 1049 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Icon__ = __webpack_require__(1050);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Icon__["a"]; });


/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      userSelect: 'none',
      fontSize: theme.typography.pxToRem(24),
      width: '1em',
      height: '1em',
      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
      // To remove at some point.
      overflow: 'hidden',
      flexShrink: 0
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `color="action"`. */
    colorAction: {
      color: theme.palette.action.active
    },

    /* Styles applied to the root element if `color="error"`. */
    colorError: {
      color: theme.palette.error.main
    },

    /* Styles applied to the root element if `color="disabled"`. */
    colorDisabled: {
      color: theme.palette.action.disabled
    },
    fontSizeInherit: {
      fontSize: 'inherit'
    },

    /* Styles applied to the root element if `fontSize="small"`. */
    fontSizeSmall: {
      fontSize: theme.typography.pxToRem(20)
    },

    /* Styles applied to the root element if `fontSize="large"`. */
    fontSizeLarge: {
      fontSize: theme.typography.pxToRem(36)
    }
  };
};
var Icon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Icon(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'inherit' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      _props$fontSize = props.fontSize,
      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "fontSize"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], fontSize !== 'default' && classes["fontSize".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(fontSize))]),
    "aria-hidden": true,
    ref: ref
  }, other));
});
 false ? Icon.propTypes = {
  /**
   * The name of the icon font ligature.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: PropTypes.oneOf(['inherit', 'default', 'small', 'large'])
} : void 0;
Icon.muiName = 'Icon';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiIcon'
})(Icon));

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);








var styles = function styles(theme) {
  var light = theme.palette.type === 'light';
  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative'
    },

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      'label + &': {
        marginTop: 16
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if color secondary. */
    colorSecondary: {
      '&$underline:after': {
        borderBottomColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if `disableUnderline={false}`. */
    underline: {
      '&:after': {
        borderBottom: "2px solid ".concat(theme.palette.primary.main),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '""',
        position: 'absolute',
        right: 0,
        transform: 'scaleX(0)',
        transition: theme.transitions.create('transform', {
          duration: theme.transitions.duration.shorter,
          easing: theme.transitions.easing.easeOut
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&$focused:after': {
        transform: 'scaleX(1)'
      },
      '&$error:after': {
        borderBottomColor: theme.palette.error.main,
        transform: 'scaleX(1)' // error is always underlined in red

      },
      '&:before': {
        borderBottom: "1px solid ".concat(bottomLineColor),
        left: 0,
        bottom: 0,
        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
        content: '"\\00a0"',
        position: 'absolute',
        right: 0,
        transition: theme.transitions.create('border-bottom-color', {
          duration: theme.transitions.duration.shorter
        }),
        pointerEvents: 'none' // Transparent to the hover style.

      },
      '&:hover:not($disabled):before': {
        borderBottom: "2px solid ".concat(theme.palette.text.primary),
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          borderBottom: "1px solid ".concat(bottomLineColor)
        }
      },
      '&$disabled:before': {
        borderBottomStyle: 'dotted'
      }
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {},

    /* Styles applied to the root element if `fullWidth={true}`. */
    fullWidth: {},

    /* Styles applied to the `input` element. */
    input: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {},

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {},

    /* Styles applied to the `input` element if `type="search"`. */
    inputTypeSearch: {}
  };
};
var Input = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Input(props, ref) {
  var disableUnderline = props.disableUnderline,
      classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, !disableUnderline && classes.underline),
      underline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? Input.propTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the input will not have an underline.
   */
  disableUnderline: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
Input.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInput'
})(Input));

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InputAdornment__ = __webpack_require__(1053);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InputAdornment__["a"]; });


/***/ }),
/* 1053 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__ = __webpack_require__(177);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    height: '0.01em',
    // Fix IE 11 flexbox alignment. To remove at some point.
    maxHeight: '2em',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `variant="filled"`. */
  filled: {
    '&$positionStart:not($hiddenLabel)': {
      marginTop: 16
    }
  },

  /* Styles applied to the root element if `position="start"`. */
  positionStart: {
    marginRight: 8
  },

  /* Styles applied to the root element if `position="end"`. */
  positionEnd: {
    marginLeft: 8
  },

  /* Styles applied to the root element if `disablePointerEvents=true`. */
  disablePointerEvents: {
    pointerEvents: 'none'
  },

  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
  hiddenLabel: {},

  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
  marginDense: {}
};
var InputAdornment = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function InputAdornment(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disablePointer = props.disablePointerEvents,
      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      position = props.position,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["b" /* useFormControl */])() || {};
  var variant = variantProp;

  if (variantProp && muiFormControl.variant) {
    if (false) {
      if (variantProp === muiFormControl.variant) {
        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
      }
    }
  }

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__FormControl_FormControlContext__["a" /* default */].Provider, {
    value: null
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, {
      filled: classes.filled
    }[variant], {
      start: classes.positionStart,
      end: classes.positionEnd
    }[position], {
      dense: classes.marginDense
    }[muiFormControl.margin]),
    ref: ref
  }, other), typeof children === 'string' && !disableTypography ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Typography__["a" /* default */], {
    color: "textSecondary"
  }, children) : children));
});
 false ? InputAdornment.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or string.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Disable pointer events on the root.
   * This allows for the content of the adornment to focus the input on click.
   */
  disablePointerEvents: PropTypes.bool,

  /**
   * If children is a string then disable wrapping in a Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * @ignore
   */
  muiFormControl: PropTypes.object,

  /**
   * The position this adornment should appear relative to the `Input`.
   */
  position: PropTypes.oneOf(['start', 'end']),

  /**
   * The variant to use.
   * Note: If you are using the `TextField` component or the `FormControl` component
   * you do not have to set this manually.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputAdornment'
})(InputAdornment));

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormLabel__ = __webpack_require__(421);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      transformOrigin: 'top left'
    },

    /* Pseudo-class applied to the root element if `focused={true}`. */
    focused: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element if `required={true}`. */
    required: {},

    /* Pseudo-class applied to the asterisk element. */
    asterisk: {},

    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
    formControl: {
      position: 'absolute',
      left: 0,
      top: 0,
      // slight alteration to spec spacing to match visual spec result
      transform: 'translate(0, 24px) scale(1)'
    },

    /* Styles applied to the root element if `margin="dense"`. */
    marginDense: {
      // Compensation for the `Input.inputDense` style.
      transform: 'translate(0, 21px) scale(1)'
    },

    /* Styles applied to the `input` element if `shrink={true}`. */
    shrink: {
      transform: 'translate(0, 1.5px) scale(0.75)',
      transformOrigin: 'top left'
    },

    /* Styles applied to the `input` element if `disableAnimation={false}`. */
    animated: {
      transition: theme.transitions.create(['color', 'transform'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the root element if `variant="filled"`. */
    filled: {
      // Chrome's autofill feature gives the input field a yellow background.
      // Since the input field is behind the label in the HTML tree,
      // the input field is drawn last and hides the label with an opaque background color.
      // zIndex: 1 will raise the label above opaque background-colors of input.
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(12px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(12px, 17px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(12px, 10px) scale(0.75)',
        '&$marginDense': {
          transform: 'translate(12px, 7px) scale(0.75)'
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"`. */
    outlined: {
      // see comment above on filled.zIndex
      zIndex: 1,
      pointerEvents: 'none',
      transform: 'translate(14px, 20px) scale(1)',
      '&$marginDense': {
        transform: 'translate(14px, 12px) scale(1)'
      },
      '&$shrink': {
        transform: 'translate(14px, -6px) scale(0.75)'
      }
    }
  };
};
var InputLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function InputLabel(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disableAnimati = props.disableAnimation,
      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
      margin = props.margin,
      shrinkProp = props.shrink,
      variant = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);

  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_useFormControl__["a" /* default */])();
  var shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  var fcs = Object(__WEBPACK_IMPORTED_MODULE_5__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['margin', 'variant']
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__FormLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "data-shrink": shrink,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, {
      dense: classes.marginDense
    }[fcs.margin], {
      filled: classes.filled,
      outlined: classes.outlined
    }[fcs.variant]),
    classes: {
      focused: classes.focused,
      disabled: classes.disabled,
      error: classes.error,
      required: classes.required,
      asterisk: classes.asterisk
    },
    ref: ref
  }, other));
});
 false ? InputLabel.propTypes = {
  /**
   * The contents of the `InputLabel`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * If `true`, the transition animation is disabled.
   */
  disableAnimation: PropTypes.bool,

  /**
   * If `true`, apply disabled class.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input of this label is focused.
   */
  focused: PropTypes.bool,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense']),

  /**
   * if `true`, the label will indicate that the input is required.
   */
  required: PropTypes.bool,

  /**
   * If `true`, the label is shrunk.
   */
  shrink: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiInputLabel'
})(InputLabel));

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_useTheme__ = __webpack_require__(32);









var TRANSITION_DURATION = 4; // seconds

var styles = function styles(theme) {
  var getColor = function getColor(color) {
    return theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["e" /* lighten */])(color, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* darken */])(color, 0.5);
  };

  var backgroundPrimary = getColor(theme.palette.primary.main);
  var backgroundSecondary = getColor(theme.palette.secondary.main);
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      overflow: 'hidden',
      height: 4
    },

    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant-"buffer"`. */
    colorPrimary: {
      backgroundColor: backgroundPrimary
    },

    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
    colorSecondary: {
      backgroundColor: backgroundSecondary
    },

    /* Styles applied to the root element if `variant="determinate"`. */
    determinate: {},

    /* Styles applied to the root element if `variant="indeterminate"`. */
    indeterminate: {},

    /* Styles applied to the root element if `variant="buffer"`. */
    buffer: {
      backgroundColor: 'transparent'
    },

    /* Styles applied to the root element if `variant="query"`. */
    query: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the additional bar element if `variant="buffer"`. */
    dashed: {
      position: 'absolute',
      marginTop: 0,
      height: '100%',
      width: '100%',
      animation: '$buffer 3s infinite linear'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
    dashedColorPrimary: {
      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
    dashedColorSecondary: {
      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
      backgroundSize: '10px 10px',
      backgroundPosition: '0px -23px'
    },

    /* Styles applied to the layered bar1 and bar2 elements. */
    bar: {
      width: '100%',
      position: 'absolute',
      left: 0,
      bottom: 0,
      top: 0,
      transition: 'transform 0.2s linear',
      transformOrigin: 'left'
    },

    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
    barColorPrimary: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
    barColorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },

    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
    bar1Indeterminate: {
      width: 'auto',
      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
    },

    /* Styles applied to the bar1 element if `variant="determinate"`. */
    bar1Determinate: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar1 element if `variant="buffer"`. */
    bar1Buffer: {
      zIndex: 1,
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },

    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
    bar2Indeterminate: {
      width: 'auto',
      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) infinite',
      animationDelay: '1.15s'
    },

    /* Styles applied to the bar2 element if `variant="buffer"`. */
    bar2Buffer: {
      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
    },
    // Legends:
    // || represents the viewport
    // -  represents a light background
    // x  represents a dark background
    '@keyframes indeterminate1': {
      //  |-----|---x-||-----||-----|
      '0%': {
        left: '-35%',
        right: '100%'
      },
      //  |-----|-----||-----||xxxx-|
      '60%': {
        left: '100%',
        right: '-90%'
      },
      '100%': {
        left: '100%',
        right: '-90%'
      }
    },
    '@keyframes indeterminate2': {
      //  |xxxxx|xxxxx||-----||-----|
      '0%': {
        left: '-200%',
        right: '100%'
      },
      //  |-----|-----||-----||-x----|
      '60%': {
        left: '107%',
        right: '-8%'
      },
      '100%': {
        left: '107%',
        right: '-8%'
      }
    },
    '@keyframes buffer': {
      '0%': {
        opacity: 1,
        backgroundPosition: '0px -23px'
      },
      '50%': {
        opacity: 0,
        backgroundPosition: '0px -23px'
      },
      '100%': {
        opacity: 1,
        backgroundPosition: '-200px -23px'
      }
    }
  };
};
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

var LinearProgress = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function LinearProgress(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      value = props.value,
      valueBuffer = props.valueBuffer,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_8__styles_useTheme__["a" /* default */])();
  var rootProps = {};
  var inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      var transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
    } else if (false) {
      console.error('Material-UI: you need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      var _transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        _transform = -_transform;
      }

      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
    } else if (false) {
      console.error('Material-UI: you need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
    }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], className, {
      determinate: classes.determinate,
      indeterminate: classes.indeterminate,
      buffer: classes.buffer,
      query: classes.query
    }[variant]),
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other), variant === 'buffer' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.dashed, classes["dashedColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))])
  }) : null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
      determinate: classes.bar1Determinate,
      buffer: classes.bar1Buffer
    }[variant]),
    style: inlineStyles.bar1
  }), variant === 'determinate' ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))], classes.bar2Buffer] : classes["barColor".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(color))]),
    style: inlineStyles.bar2
  }));
});
 false ? LinearProgress.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The value of the progress indicator for the determinate and buffer variants.
   * Value between 0 and 100.
   */
  value: PropTypes.number,

  /**
   * The value for the buffer variant.
   * Value between 0 and 100.
   */
  valueBuffer: PropTypes.number,

  /**
   * The variant to use.
   * Use indeterminate or query when there is no progress value.
   */
  variant: PropTypes.oneOf(['determinate', 'indeterminate', 'buffer', 'query'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLinearProgress'
})(LinearProgress));

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Link__ = __webpack_require__(1057);
/* unused harmony reexport default */


/***/ }),
/* 1057 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_focusVisible__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Typography__ = __webpack_require__(46);











var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `underline="none"`. */
  underlineNone: {
    textDecoration: 'none'
  },

  /* Styles applied to the root element if `underline="hover"`. */
  underlineHover: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  },

  /* Styles applied to the root element if `underline="always"`. */
  underlineAlways: {
    textDecoration: 'underline'
  },
  // Same reset as ButtonBase.root

  /* Styles applied to the root element if `component="button"`. */
  button: {
    position: 'relative',
    // Remove grey highlight
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    '-moz-appearance': 'none',
    // Reset
    '-webkit-appearance': 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    '&$focusVisible': {
      outline: 'auto'
    }
  },

  /* Pseudo-class applied to the root element if the link is keyboard focused. */
  focusVisible: {}
};
var Link = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Link(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      component = _props$component === void 0 ? 'a' : _props$component,
      onBlur = props.onBlur,
      onFocus = props.onFocus,
      TypographyClasses = props.TypographyClasses,
      _props$underline = props.underline,
      underline = _props$underline === void 0 ? 'hover' : _props$underline,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_8__utils_focusVisible__["a" /* useIsFocusVisible */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focusVisible = _React$useState[0],
      setFocusVisible = _React$useState[1];

  var handlerRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(ref, focusVisibleRef);

  var handleBlur = function handleBlur(event) {
    if (focusVisible) {
      onBlurVisible();
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["underline".concat(Object(__WEBPACK_IMPORTED_MODULE_5__utils_capitalize__["a" /* default */])(underline))], className, focusVisible && classes.focusVisible, {
      button: classes.button
    }[component]),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    variant: variant
  }, other));
});
 false ? Link.propTypes = {
  /**
   * The content of the link.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the link.
   */
  color: PropTypes.oneOf(['default', 'error', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: elementTypeAcceptingRef,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * `classes` prop applied to the [`Typography`](/api/typography/) element.
   */
  TypographyClasses: PropTypes.object,

  /**
   * Controls when the link should have an underline.
   */
  underline: PropTypes.oneOf(['none', 'hover', 'always']),

  /**
   * Applies the theme typography styles.
   */
  variant: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiLink'
})(Link));

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListContext__ = __webpack_require__(142);







var styles = {
  /* Styles applied to the root element. */
  root: {
    listStyle: 'none',
    margin: 0,
    padding: 0,
    position: 'relative'
  },

  /* Styles applied to the root element if `disablePadding={false}`. */
  padding: {
    paddingTop: 8,
    paddingBottom: 8
  },

  /* Styles applied to the root element if dense. */
  dense: {},

  /* Styles applied to the root element if a `subheader` is provided. */
  subheader: {
    paddingTop: 0
  }
};
var List = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function List(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'ul' : _props$component,
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disablePadding = props.disablePadding,
      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
      subheader = props.subheader,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {
      dense: dense
    };
  }, [dense]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ListContext__["a" /* default */].Provider, {
    value: context
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
    ref: ref
  }, other), subheader, children));
});
 false ? List.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
   * the list and list items.
   * The prop is available to descendant components as the `dense` context.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, vertical padding will be removed from the list.
   */
  disablePadding: PropTypes.bool,

  /**
   * The content of the subheader, normally `ListSubheader`.
   */
  subheader: PropTypes.node
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiList'
})(List));

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__List_ListContext__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);












var styles = function styles(theme) {
  return {
    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
    root: {
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      position: 'relative',
      textDecoration: 'none',
      width: '100%',
      boxSizing: 'border-box',
      textAlign: 'left',
      paddingTop: 8,
      paddingBottom: 8,
      '&$focusVisible': {
        backgroundColor: theme.palette.action.selected
      },
      '&$selected, &$selected:hover': {
        backgroundColor: theme.palette.action.selected
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
    container: {
      position: 'relative'
    },

    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
    focusVisible: {},

    /* Styles applied to the `component` element if dense. */
    dense: {
      paddingTop: 4,
      paddingBottom: 4
    },

    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      alignItems: 'flex-start'
    },

    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the inner `component` element if `divider={true}`. */
    divider: {
      borderBottom: "1px solid ".concat(theme.palette.divider),
      backgroundClip: 'padding-box'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the inner `component` element if `button={true}`. */
    button: {
      transition: theme.transitions.create('background-color', {
        duration: theme.transitions.duration.shortest
      }),
      '&:hover': {
        textDecoration: 'none',
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      }
    },

    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
    secondaryAction: {
      // Add some space to avoid collision as `ListItemSecondaryAction`
      // is absolutely positioned.
      paddingRight: 48
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {}
  };
};
var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect;
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

var ListItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListItem(props, ref) {
  var _props$alignItems = props.alignItems,
      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$button = props.button,
      button = _props$button === void 0 ? false : _props$button,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      componentProp = props.component,
      _props$ContainerCompo = props.ContainerComponent,
      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
      _props$ContainerProps = props.ContainerProps;
  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;

  var ContainerClassName = _props$ContainerProps.className,
      ContainerProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ContainerProps, ["className"]),
      _props$dense = props.dense,
      dense = _props$dense === void 0 ? false : _props$dense,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$divider = props.divider,
      divider = _props$divider === void 0 ? false : _props$divider,
      focusVisibleClassName = props.focusVisibleClassName,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */]);
  var childContext = {
    dense: dense || context.dense || false,
    alignItems: alignItems
  };
  var listItemRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  useEnhancedEffect(function () {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      } else if (false) {
        console.error('Material-UI: unable to set focus to a ListItem whose component has not been rendered.');
      }
    }
  }, [autoFocus]);
  var children = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(childrenProp);
  var hasSecondaryAction = children.length && Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children[children.length - 1], ['ListItemSecondaryAction']);
  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    listItemRef.current = __WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);

  var componentProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
    disabled: disabled
  }, other);

  var Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.focusVisible, focusVisibleClassName);
    Component = __WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */];
  }

  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
      value: childContext
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.container, ContainerClassName),
      ref: handleRef
    }, ContainerProps), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, componentProps, children), children.pop()));
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__List_ListContext__["a" /* default */].Provider, {
    value: childContext
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef
  }, componentProps), children));
});
 false ? ListItem.propTypes = {
  /**
   * Defines the `align-items` style property.
   */
  alignItems: PropTypes.oneOf(['flex-start', 'center']),

  /**
   * If `true`, the list item will be focused during the first mount.
   * Focus will also be triggered if the value changes from false to true.
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
   * for `ButtonBase` can then be applied to `ListItem`.
   */
  button: PropTypes.bool,

  /**
   * The content of the component. If a `ListItemSecondaryAction` is used it must
   * be the last child.
   */
  children: chainPropTypes(PropTypes.node, function (props) {
    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)

    var secondaryActionIndex = -1;

    for (var i = children.length - 1; i >= 0; i -= 1) {
      var child = children[i];

      if (isMuiElement(child, ['ListItemSecondaryAction'])) {
        secondaryActionIndex = i;
        break;
      }
    } //  is ListItemSecondaryAction the last child of ListItem


    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
   */
  component: PropTypes.elementType,

  /**
   * The container component used when a `ListItemSecondaryAction` is the last child.
   */
  ContainerComponent: PropTypes.elementType,

  /**
   * Props applied to the container component if used.
   */
  ContainerProps: PropTypes.object,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * If `true`, the list item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, a 1px light border is added to the bottom of the list item.
   */
  divider: PropTypes.bool,

  /**
   * @ignore
   */
  focusVisibleClassName: PropTypes.string,

  /**
   * Use to apply selected styling.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItem'
})(ListItem));

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemAvatar__ = __webpack_require__(1061);
/* unused harmony reexport default */


/***/ }),
/* 1061 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(142);







var styles = {
  /* Styles applied to the root element. */
  root: {
    minWidth: 56,
    flexShrink: 0
  },

  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
  alignItemsFlexStart: {
    marginTop: 8
  }
};
/**
 * A simple wrapper to apply `List` styles to an `Avatar`.
 */

var ListItemAvatar = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListItemAvatar(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemAvatar.propTypes = {
  /**
   * The content of the component – normally `Avatar`.
   */
  children: PropTypes.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemAvatar'
})(ListItemAvatar));

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemIcon__ = __webpack_require__(1063);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItemIcon__["a"]; });


/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List_ListContext__ = __webpack_require__(142);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      minWidth: 56,
      color: theme.palette.action.active,
      flexShrink: 0,
      display: 'inline-flex'
    },

    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
    alignItemsFlexStart: {
      marginTop: 8
    }
  };
};
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

var ListItemIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListItemIcon(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  var context = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_6__List_ListContext__["a" /* default */]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
    ref: ref
  }, other));
});
 false ? ListItemIcon.propTypes = {
  /**
   * The content of the component, normally `Icon`, `SvgIcon`,
   * or a `@material-ui/icons` SVG icon element.
   */
  children: PropTypes.element.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemIcon'
})(ListItemIcon));

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemSecondaryAction__ = __webpack_require__(1065);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItemSecondaryAction__["a"]; });


/***/ }),
/* 1065 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {
    position: 'absolute',
    right: 16,
    top: '50%',
    transform: 'translateY(-50%)'
  }
};
/**
 * Must be used as the last child of ListItem to function properly.
 */

var ListItemSecondaryAction = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListItemSecondaryAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other));
});
 false ? ListItemSecondaryAction.propTypes = {
  /**
   * The content of the component, normally an `IconButton` or selection control.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string
} : void 0;
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemSecondaryAction'
})(ListItemSecondaryAction));

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ListItemText__ = __webpack_require__(1067);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ListItemText__["a"]; });


/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__List_ListContext__ = __webpack_require__(142);








var styles = {
  /* Styles applied to the root element. */
  root: {
    flex: '1 1 auto',
    minWidth: 0,
    marginTop: 4,
    marginBottom: 4
  },

  /* Styles applied to the `Typography` components if primary and secondary are set. */
  multiline: {
    marginTop: 6,
    marginBottom: 6
  },

  /* Styles applied to the `Typography` components if dense. */
  dense: {},

  /* Styles applied to the root element if `inset={true}`. */
  inset: {
    paddingLeft: 56
  },

  /* Styles applied to the primary `Typography` component. */
  primary: {},

  /* Styles applied to the secondary `Typography` component. */
  secondary: {}
};
var ListItemText = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListItemText(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disableTypogra = props.disableTypography,
      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      primaryProp = props.primary,
      primaryTypographyProps = props.primaryTypographyProps,
      secondaryProp = props.secondary,
      secondaryTypographyProps = props.secondaryTypographyProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_7__List_ListContext__["a" /* default */]),
      dense = _React$useContext.dense;

  var primary = primaryProp != null ? primaryProp : children;

  if (primary != null && primary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    primary = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span"
    }, primaryTypographyProps), primary);
  }

  var secondary = secondaryProp;

  if (secondary != null && secondary.type !== __WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */] && !disableTypography) {
    secondary = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      variant: "body2",
      className: classes.secondary,
      color: "textSecondary"
    }, secondaryTypographyProps), secondary);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
    ref: ref
  }, other), primary, secondary);
});
 false ? ListItemText.propTypes = {
  /**
   * Alias for the `primary` property.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the children won't be wrapped by a Typography component.
   * This can be useful to render an alternative Typography variant by wrapping
   * the `children` (or `primary`) text, and optional `secondary` text
   * with the Typography component.
   */
  disableTypography: PropTypes.bool,

  /**
   * If `true`, the children will be indented.
   * This should be used if there is no left avatar or left icon.
   */
  inset: PropTypes.bool,

  /**
   * The main content element.
   */
  primary: PropTypes.node,

  /**
   * These props will be forwarded to the primary typography component
   * (as long as disableTypography is not `true`).
   */
  primaryTypographyProps: PropTypes.object,

  /**
   * The secondary content element.
   */
  secondary: PropTypes.node,

  /**
   * These props will be forwarded to the secondary typography component
   * (as long as disableTypography is not `true`).
   */
  secondaryTypographyProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListItemText'
})(ListItemText));

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      boxSizing: 'border-box',
      lineHeight: '48px',
      listStyle: 'none',
      color: theme.palette.text.secondary,
      fontFamily: theme.typography.fontFamily,
      fontWeight: theme.typography.fontWeightMedium,
      fontSize: theme.typography.pxToRem(14)
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      color: theme.palette.primary.main
    },

    /* Styles applied to the root element if `color="inherit"`. */
    colorInherit: {
      color: 'inherit'
    },

    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
    gutters: {
      paddingLeft: 16,
      paddingRight: 16
    },

    /* Styles applied to the root element if `inset={true}`. */
    inset: {
      paddingLeft: 72
    },

    /* Styles applied to the root element if `disableSticky={false}`. */
    sticky: {
      position: 'sticky',
      top: 0,
      zIndex: 1,
      backgroundColor: 'inherit'
    }
  };
};
var ListSubheader = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ListSubheader(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'default' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$disableSticky = props.disableSticky,
      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
      _props$inset = props.inset,
      inset = _props$inset === void 0 ? false : _props$inset,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, color !== 'default' && classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? ListSubheader.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['default', 'primary', 'inherit']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the List Subheader will not have gutters.
   */
  disableGutters: PropTypes.bool,

  /**
   * If `true`, the List Subheader will not stick to the top during scroll.
   */
  disableSticky: PropTypes.bool,

  /**
   * If `true`, the List Subheader will be indented.
   */
  inset: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiListSubheader'
})(ListSubheader));

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Menu__ = __webpack_require__(430);
/* unused harmony reexport default */


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOffsetTop */
/* unused harmony export getOffsetLeft */
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_debounce__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Modal__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Grow__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Paper__ = __webpack_require__(60);















function getOffsetTop(rect, vertical) {
  var offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  var offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
    return typeof n === 'number' ? "".concat(n, "px") : n;
  }).join(' ');
} // Sum the scrollTop between two elements.


function getScrollParent(parent, child) {
  var element = child;
  var scrollTop = 0;

  while (element && element !== parent) {
    element = element.parentElement;
    scrollTop += element.scrollTop;
  }

  return scrollTop;
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var styles = {
  /* Styles applied to the root element */
  root: {},

  /* Styles applied to the `Paper` component. */
  paper: {
    position: 'absolute',
    overflowY: 'auto',
    overflowX: 'hidden',
    // So we see the popover when it's empty.
    // It's most likely on issue on userland.
    minWidth: 16,
    minHeight: 16,
    maxWidth: 'calc(100% - 32px)',
    maxHeight: 'calc(100% - 32px)',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0
  }
};
var Popover = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Popover(props, ref) {
  var action = props.action,
      anchorEl = props.anchorEl,
      _props$anchorOrigin = props.anchorOrigin,
      anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$anchorOrigin,
      anchorPosition = props.anchorPosition,
      _props$anchorReferenc = props.anchorReference,
      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
      children = props.children,
      classes = props.classes,
      className = props.className,
      containerProp = props.container,
      _props$elevation = props.elevation,
      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
      getContentAnchorEl = props.getContentAnchorEl,
      _props$marginThreshol = props.marginThreshold,
      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      _props$transformOrigi = props.transformOrigin,
      transformOrigin = _props$transformOrigi === void 0 ? {
    vertical: 'top',
    horizontal: 'left'
  } : _props$transformOrigi,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_13__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      _props$TransitionProp = props.TransitionProps,
      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  var getAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (contentAnchorOffset) {
    if (anchorReference === 'anchorPosition') {
      if (false) {
        if (!anchorPosition) {
          console.error('Material-UI: you need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
        }
      }

      return anchorPosition;
    }

    var resolvedAnchorEl = getAnchorEl(anchorEl);
    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(resolvedAnchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    var anchorElement = resolvedAnchorEl instanceof containerWindow.Element ? resolvedAnchorEl : Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(paperRef.current).body;
    var anchorRect = anchorElement.getBoundingClientRect();

    if (false) {
      var box = anchorElement.getBoundingClientRect();

      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
        console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
      }
    }

    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided

  var getContentAnchorOffset = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (element) {
    var contentAnchorOffset = 0;

    if (getContentAnchorEl && anchorReference === 'anchorEl') {
      var contentAnchorEl = getContentAnchorEl(element);

      if (contentAnchorEl && element.contains(contentAnchorEl)) {
        var scrollTop = getScrollParent(element, contentAnchorEl);
        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
      } // != the default value


      if (false) {
        if (anchorOrigin.vertical !== 'top') {
          console.error(['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
        }
      }
    }

    return contentAnchorOffset;
  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
  // and taking the content anchor offset into account if in use

  var getTransformOrigin = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (elemRect) {
    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  var getPositioningStyle = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (element) {
    // Check if the parent has requested anchoring on an inner content node
    var contentAnchorOffset = getContentAnchorOffset(element);
    var elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of of the anchoring element


    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning

    var top = anchorOffset.top - elemTransformOrigin.vertical;
    var left = anchorOffset.left - elemTransformOrigin.horizontal;
    var bottom = top + elemRect.height;
    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    var containerWindow = Object(__WEBPACK_IMPORTED_MODULE_9__utils_ownerWindow__["a" /* default */])(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    var heightThreshold = containerWindow.innerHeight - marginThreshold;
    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      var diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      var _diff = bottom - heightThreshold;

      top -= _diff;
      elemTransformOrigin.vertical += _diff;
    }

    if (false) {
      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
        console.error(['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
      }
    } // Check if the horizontal axis needs shifting


    if (left < marginThreshold) {
      var _diff2 = left - marginThreshold;

      left -= _diff2;
      elemTransformOrigin.horizontal += _diff2;
    } else if (right > widthThreshold) {
      var _diff3 = right - widthThreshold;

      left -= _diff3;
      elemTransformOrigin.horizontal += _diff3;
    }

    return {
      top: "".concat(top, "px"),
      left: "".concat(left, "px"),
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
  var setPositioningStyles = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (element) {
    var positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  var handleEntering = function handleEntering(element, isAppearing) {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles(element);
  };

  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance);
  }, []);
  var updatePosition = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    if (!open) {
      return undefined;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_5__utils_debounce__["a" /* default */])(function () {
      setPositioningStyles(paperRef.current);
    });
  }, [open, setPositioningStyles]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(action, function () {
    return open ? {
      updatePosition: updatePosition
    } : null;
  }, [open, updatePosition]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!updatePosition) {
      return undefined;
    }

    window.addEventListener('resize', updatePosition);
    return function () {
      window.removeEventListener('resize', updatePosition);
      updatePosition.clear();
    };
  }, [updatePosition]);
  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  var container = containerProp || (anchorEl ? Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerDocument__["a" /* default */])(getAnchorEl(anchorEl)).body : undefined);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Modal__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    container: container,
    open: open,
    ref: ref,
    BackdropProps: {
      invisible: true
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className)
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: onEnter,
    onEntered: onEntered,
    onExit: onExit,
    onExited: onExited,
    onExiting: onExiting,
    timeout: transitionDuration
  }, TransitionProps, {
    onEntering: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEntering, TransitionProps.onEntering)
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    elevation: elevation,
    ref: handlePaperRef
  }, PaperProps, {
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.paper, PaperProps.className)
  }), children)));
});
 false ? Popover.propTypes = {
  /**
   * A ref for imperative actions.
   * It currently only supports updatePosition() action.
   */
  action: refType,

  /**
   * This is the DOM element, or a function that returns the DOM element,
   * that may be used to set the position of the popover.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([PropTypes.object, PropTypes.func]), function (props) {
    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
      var containerWindow = ownerWindow(resolvedAnchorEl);

      if (resolvedAnchorEl instanceof containerWindow.Element) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else {
        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
      }
    }

    return null;
  }),

  /**
   * This is the point on the anchor where the popover's
   * `anchorEl` will attach to. This is not used when the
   * anchorReference is 'anchorPosition'.
   *
   * Options:
   * vertical: [top, center, bottom];
   * horizontal: [left, center, right].
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * This is the position that may be used
   * to set the position of the popover.
   * The coordinates are relative to
   * the application's client area.
   */
  anchorPosition: PropTypes.shape({
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired
  }),

  /*
   * This determines which anchor prop to refer to to set
   * the position of the popover.
   */
  anchorReference: PropTypes.oneOf(['anchorEl', 'anchorPosition', 'none']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * The elevation of the popover.
   */
  elevation: PropTypes.number,

  /**
   * This function is called in order to retrieve the content anchor element.
   * It's the opposite of the `anchorEl` prop.
   * The content anchor element should be an element inside the popover.
   * It's used to correctly scroll and set the position of the popover.
   * The positioning strategy tries to make the content anchor element just above the
   * anchor element.
   */
  getContentAnchorEl: PropTypes.func,

  /**
   * Specifies how close to the edge of the window the popover can appear.
   */
  marginThreshold: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"escapeKeyDown"`, `"backdropClick"`
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the component is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the component has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the component is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the component is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the component has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the component is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * If `true`, the popover is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Props applied to the [`Paper`](/api/paper/) element.
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef
  }),

  /**
   * This is the point on the popover which
   * will attach to the anchor's origin.
   *
   * Options:
   * vertical: [top, center, bottom, x(px)];
   * horizontal: [left, center, right, x(px)].
   */
  transformOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['left', 'center', 'right'])]).isRequired,
    vertical: PropTypes.oneOfType([PropTypes.number, PropTypes.oneOf(['top', 'center', 'bottom'])]).isRequired
  }),

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  }), PropTypes.oneOf(['auto'])]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiPopover'
})(Popover));

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_ownerDocument__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__List__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_getScrollbarSize__ = __webpack_require__(415);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(28);










function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  var text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  if (text === undefined) {
    return false;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, traversalFunction, textCriteria) {
  var wrappedOnce = false;
  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }

      wrappedOnce = true;
    } // Move to the next element.


    if (!nextFocus.hasAttribute('tabindex') || nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true' || !textCriteriaMatches(nextFocus, textCriteria)) {
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }

  return false;
}

var useEnhancedEffect = typeof window === 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect;
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton
 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */

var MenuList = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function MenuList(props, ref) {
  var actions = props.actions,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      _props$autoFocusItem = props.autoFocusItem,
      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
      children = props.children,
      className = props.className,
      onKeyDown = props.onKeyDown,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "onKeyDown", "disableListWrap", "variant"]);

  var listRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var textCriteriaRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect(function () {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(actions, function () {
    return {
      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
        // Let's ignore that piece of logic if users are already overriding the width
        // of the menu.
        var noExplicitWidth = !listRef.current.style.width;

        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
          var scrollbarSize = "".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_getScrollbarSize__["a" /* default */])(true), "px");
          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
        }

        return listRef.current;
      }
    };
  }, []);

  var handleKeyDown = function handleKeyDown(event) {
    var list = listRef.current;
    var key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    var currentFocus = Object(__WEBPACK_IMPORTED_MODULE_5__utils_ownerDocument__["a" /* default */])(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, previousItem);
    } else if (key.length === 1) {
      var criteria = textCriteriaRef.current;
      var lowerKey = key.toLowerCase();
      var currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    listRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance);
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(handleOwnRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.forEach(children, function (child, index) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  var items = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child, index) {
    if (index === activeItemIndex) {
      var newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      if (newChildProps !== null) {
        return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, newChildProps);
      }
    }

    return child;
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__List__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other), items);
});
 false ? MenuList.propTypes = {
  /**
   * @ignore
   */
  actions: PropTypes.shape({
    current: PropTypes.object
  }),

  /**
   * If `true`, will focus the `[role="menu"]` container and move into tab order
   */
  autoFocus: PropTypes.bool,

  /**
   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
   * if `variant="selectedMenu"`
   */
  autoFocusItem: PropTypes.bool,

  /**
   * MenuList contents, normally `MenuItem`s.
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the menu items will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
   * and the vertical alignment relative to the anchor element.
   */
  variant: PropTypes.oneOf(['menu', 'selectedMenu'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (MenuList);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ListItem__ = __webpack_require__(428);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      minHeight: 48,
      paddingTop: 6,
      paddingBottom: 6,
      boxSizing: 'border-box',
      width: 'auto',
      overflow: 'hidden',
      whiteSpace: 'nowrap'
    }, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    })),
    // TODO To remove in v5?

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: {},

    /* Styles applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the root element if dense. */
    dense: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      minHeight: 'auto'
    })
  };
};
var MenuItem = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function MenuItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      component = _props$component === void 0 ? 'li' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$role = props.role,
      role = _props$role === void 0 ? 'menuitem' : _props$role,
      selected = props.selected,
      tabIndexProp = props.tabIndex,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "role", "selected", "tabIndex"]);

  var tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ListItem__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    button: true,
    role: role,
    tabIndex: tabIndex,
    component: component,
    selected: selected,
    disableGutters: disableGutters,
    classes: {
      dense: classes.dense
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? MenuItem.propTypes = {
  /**
   * Menu item contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
   */
  dense: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the left and right padding is removed.
   */
  disableGutters: PropTypes.bool,

  /**
   * @ignore
   */
  role: PropTypes.string,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  tabIndex: PropTypes.number
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMenuItem'
})(MenuItem));

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MobileStepper__ = __webpack_require__(1074);
/* unused harmony reexport default */


/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__LinearProgress__ = __webpack_require__(426);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      background: theme.palette.background.default,
      padding: 8
    },

    /* Styles applied to the root element if `position="bottom"`. */
    positionBottom: {
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="top"`. */
    positionTop: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      zIndex: theme.zIndex.mobileStepper
    },

    /* Styles applied to the root element if `position="static"`. */
    positionStatic: {},

    /* Styles applied to the dots container if `variant="dots"`. */
    dots: {
      display: 'flex',
      flexDirection: 'row'
    },

    /* Styles applied to each dot if `variant="dots"`. */
    dot: {
      backgroundColor: theme.palette.action.disabled,
      borderRadius: '50%',
      width: 8,
      height: 8,
      margin: '0 2px'
    },

    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
    dotActive: {
      backgroundColor: theme.palette.primary.main
    },

    /* Styles applied to the Linear Progress component if `variant="progress"`. */
    progress: {
      width: '50%'
    }
  };
};
var MobileStepper = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function MobileStepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      backButton = props.backButton,
      classes = props.classes,
      className = props.className,
      LinearProgressProps = props.LinearProgressProps,
      nextButton = props.nextButton,
      _props$position = props.position,
      position = _props$position === void 0 ? 'bottom' : _props$position,
      steps = props.steps,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'dots' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["position".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(position))], className),
    ref: ref
  }, other), backButton, variant === 'text' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.dots
  }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(new Array(steps)).map(function (_, index) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      key: index,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.dot, index === activeStep && classes.dotActive)
    });
  })), variant === 'progress' && __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__LinearProgress__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.progress,
    variant: "determinate",
    value: Math.ceil(activeStep / (steps - 1) * 100)
  }, LinearProgressProps)), nextButton);
});
 false ? MobileStepper.propTypes = {
  /**
   * Set the active step (zero based index).
   * Defines which dot is highlighted when the variant is 'dots'.
   */
  activeStep: PropTypes.number,

  /**
   * A back button element. For instance, it can be a `Button` or an `IconButton`.
   */
  backButton: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `LinearProgress` element.
   */
  LinearProgressProps: PropTypes.object,

  /**
   * A next button element. For instance, it can be a `Button` or an `IconButton`.
   */
  nextButton: PropTypes.node,

  /**
   * Set the positioning type.
   */
  position: PropTypes.oneOf(['bottom', 'top', 'static']),

  /**
   * The total steps.
   */
  steps: PropTypes.number.isRequired,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['text', 'dots', 'progress'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiMobileStepper'
})(MobileStepper));

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NativeSelect__ = __webpack_require__(434);
/* unused harmony reexport default */


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputBase__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotchedOutline__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(5);









var styles = function styles(theme) {
  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      '&:hover $notchedOutline': {
        borderColor: theme.palette.text.primary
      },
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        '&:hover $notchedOutline': {
          borderColor: borderColor
        }
      },
      '&$focused $notchedOutline': {
        borderColor: theme.palette.primary.main,
        borderWidth: 2
      },
      '&$error $notchedOutline': {
        borderColor: theme.palette.error.main
      },
      '&$disabled $notchedOutline': {
        borderColor: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if the color is secondary. */
    colorSecondary: {
      '&$focused $notchedOutline': {
        borderColor: theme.palette.secondary.main
      }
    },

    /* Styles applied to the root element if the component is focused. */
    focused: {},

    /* Styles applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `startAdornment` is provided. */
    adornedStart: {
      paddingLeft: 14
    },

    /* Styles applied to the root element if `endAdornment` is provided. */
    adornedEnd: {
      paddingRight: 14
    },

    /* Styles applied to the root element if `error={true}`. */
    error: {},

    /* Styles applied to the `input` element if `margin="dense"`. */
    marginDense: {},

    /* Styles applied to the root element if `multiline={true}`. */
    multiline: {
      padding: '18.5px 14px',
      '&$marginDense': {
        paddingTop: 10.5,
        paddingBottom: 10.5
      }
    },

    /* Styles applied to the `NotchedOutline` element. */
    notchedOutline: {
      borderColor: borderColor
    },

    /* Styles applied to the `input` element. */
    input: {
      padding: '18.5px 14px',
      '&:-webkit-autofill': {
        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
        borderRadius: 'inherit'
      }
    },

    /* Styles applied to the `input` element if `margin="dense"`. */
    inputMarginDense: {
      paddingTop: 10.5,
      paddingBottom: 10.5
    },

    /* Styles applied to the `input` element if `select={true}`. */
    inputSelect: {
      paddingRight: 24
    },

    /* Styles applied to the `input` element if `multiline={true}`. */
    inputMultiline: {
      padding: 0
    },

    /* Styles applied to the `input` element if `startAdornment` is provided. */
    inputAdornedStart: {
      paddingLeft: 0
    },

    /* Styles applied to the `input` element if `endAdornment` is provided. */
    inputAdornedEnd: {
      paddingRight: 0
    }
  };
};
var OutlinedInput = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function OutlinedInput(props, ref) {
  var classes = props.classes,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      _props$inputComponent = props.inputComponent,
      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      notched = props.notched,
      _props$type = props.type,
      type = _props$type === void 0 ? 'text' : _props$type,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "fullWidth", "inputComponent", "labelWidth", "multiline", "notched", "type"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__InputBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    renderSuffix: function renderSuffix(state) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__NotchedOutline__["a" /* default */], {
        className: classes.notchedOutline,
        labelWidth: labelWidth,
        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
      });
    },
    classes: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, classes, {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes.underline),
      notchedOutline: null
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other));
});
 false ? OutlinedInput.propTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the wrapper element.
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * End `InputAdornment` for this component.
   */
  endAdornment: PropTypes.node,

  /**
   * If `true`, the input will indicate an error. This is normally obtained via context from
   * FormControl.
   */
  error: PropTypes.bool,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * The component used for the native input.
   * Either a string to use a DOM element or a component.
   */
  inputComponent: PropTypes.elementType,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number,

  /**
   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
   * FormControl.
   */
  margin: PropTypes.oneOf(['dense', 'none']),

  /**
   * If `true`, a textarea element will be rendered.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * It prevents the user from changing the value of the field
   * (not from interacting with the field).
   */
  readOnly: PropTypes.bool,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Start `InputAdornment` for this component.
   */
  startAdornment: PropTypes.node,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any
} : void 0;
OutlinedInput.muiName = 'Input';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiOutlinedInput'
})(OutlinedInput));

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);









var styles = function styles(theme) {
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'absolute',
      bottom: 0,
      right: 0,
      top: -5,
      left: 0,
      margin: 0,
      padding: 0,
      pointerEvents: 'none',
      borderRadius: 'inherit',
      borderStyle: 'solid',
      borderWidth: 1,
      // Match the Input Label
      transition: theme.transitions.create(["padding-".concat(align), 'border-color', 'border-width'], {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    },

    /* Styles applied to the legend element. */
    legend: {
      textAlign: 'left',
      padding: 0,
      lineHeight: '11px',
      transition: theme.transitions.create('width', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      })
    }
  };
};
/**
 * @ignore - internal component.
 */

var NotchedOutline = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function NotchedOutline(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      labelWidthProp = props.labelWidth,
      notched = props.notched,
      style = props.style,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "labelWidth", "notched", "style"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_7__styles_useTheme__["a" /* default */])();
  var align = theme.direction === 'rtl' ? 'right' : 'left';
  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0;
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("fieldset", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-hidden": true,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, "padding".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(align)), 8 + (notched ? 0 : labelWidth / 2)), style),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("legend", {
    className: classes.legend,
    style: {
      // IE 11: fieldset with legend does not render
      // a border radius. This maintains consistency
      // by always having a legend rendered
      width: notched ? labelWidth : 0.01
    }
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  })));
});
 false ? NotchedOutline.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The width of the label.
   */
  labelWidth: PropTypes.number.isRequired,

  /**
   * If `true`, the outline is notched to accommodate the label.
   */
  notched: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  style: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateNotchedOutline'
})(NotchedOutline));

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_popper_js__ = __webpack_require__(1079);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Portal__ = __webpack_require__(258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_setRef__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_ownerWindow__ = __webpack_require__(139);











/**
 * Flips placement if in <body dir="rtl" />
 * @param {string} placement
 */

function flipPlacement(placement) {
  var direction = typeof window !== 'undefined' && document.body.getAttribute('dir') || 'ltr';

  if (direction !== 'rtl') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function getAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect;
var defaultPopperOptions = {};
/**
 * Poppers rely on the 3rd party library [Popper.js](https://github.com/FezVrasta/popper.js) for positioning.
 */

var Popper = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Popper(props, ref) {
  var anchorEl = props.anchorEl,
      children = props.children,
      container = props.container,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      _props$keepMounted = props.keepMounted,
      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
      modifiers = props.modifiers,
      open = props.open,
      _props$placement = props.placement,
      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
      _props$popperOptions = props.popperOptions,
      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
      popperRefProp = props.popperRef,
      _props$transition = props.transition,
      transition = _props$transition === void 0 ? false : _props$transition,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "transition"]);

  var tooltipRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var ownRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(tooltipRef, ref);
  var popperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var handlePopperRef = Object(__WEBPACK_IMPORTED_MODULE_9__utils_useForkRef__["a" /* default */])(popperRef, popperRefProp);
  var handlePopperRefRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(handlePopperRef);
  useEnhancedEffect(function () {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(popperRefProp, function () {
    return popperRef.current;
  }, []);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1];

  var rtlPlacement = flipPlacement(initialPlacement);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(rtlPlacement),
      placement = _React$useState2[0],
      setPlacement = _React$useState2[1];

  var handleOpen = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function () {
    if (!tooltipRef.current || !anchorEl || !open) {
      return;
    }

    if (popperRef.current) {
      popperRef.current.destroy();
      handlePopperRefRef.current(null);
    }

    var handlePopperUpdate = function handlePopperUpdate(data) {
      setPlacement(data.placement);
    };

    var resolvedAnchorEl = getAnchorEl(anchorEl);

    if (false) {
      var containerWindow = ownerWindow(resolvedAnchorEl);

      if (resolvedAnchorEl instanceof containerWindow.Element) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      }
    }

    var popper = new __WEBPACK_IMPORTED_MODULE_4_popper_js__["a" /* default */](getAnchorEl(anchorEl), tooltipRef.current, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, disablePortal ? {} : {
        // It's using scrollParent by default, we can use the viewport when using a portal.
        preventOverflow: {
          boundariesElement: 'window'
        }
      }, {}, modifiers, {}, popperOptions.modifiers),
      // We could have been using a custom modifier like react-popper is doing.
      // But it seems this is the best public API for this use case.
      onCreate: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onCreate),
      onUpdate: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(handlePopperUpdate, popperOptions.onUpdate)
    }));
    handlePopperRefRef.current(popper);
  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
  var handleRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_8__utils_setRef__["a" /* default */])(ownRef, node);
    handleOpen();
  }, [ownRef, handleOpen]);

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  var handleClose = function handleClose() {
    if (!popperRef.current) {
      return;
    }

    popperRef.current.destroy();
    handlePopperRefRef.current(null);
  };

  var handleExited = function handleExited() {
    setExited(true);
    handleClose();
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    // Let's update the popper position.
    handleOpen();
  }, [handleOpen]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      handleClose();
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!open && !transition) {
      // Otherwise handleExited will call this.
      handleClose();
    }
  }, [open, transition]);

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  }

  var childProps = {
    placement: placement
  };

  if (transition) {
    childProps.TransitionProps = {
      in: open,
      onEnter: handleEnter,
      onExited: handleExited
    };
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Portal__["a" /* default */], {
    disablePortal: disablePortal,
    container: container
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    role: "tooltip"
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
      position: 'fixed',
      // Fix Popper.js display issue
      top: 0,
      left: 0
    }, other.style)
  }), typeof children === 'function' ? children(childProps) : children));
});
 false ? Popper.propTypes = {
  /**
   * This is the reference element, or a function that returns the reference element,
   * that may be used to set the position of the popover.
   * The return value will passed as the reference object of the Popper
   * instance.
   *
   * The reference element should be an HTML Element instance or a referenceObject:
   * https://popper.js.org/popper-documentation.html#referenceObject.
   */
  anchorEl: chainPropTypes(PropTypes.oneOfType([PropTypes.object, PropTypes.func]), function (props) {
    if (props.open) {
      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
      var containerWindow = ownerWindow(resolvedAnchorEl);

      if (resolvedAnchorEl instanceof containerWindow.Element) {
        var box = resolvedAnchorEl.getBoundingClientRect();

        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
        }
      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'It should be an HTML Element instance or a referenceObject:', 'https://popper.js.org/popper-documentation.html#referenceObject.'].join('\n'));
      }
    }

    return null;
  }),

  /**
   * Popper render function or node.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]).isRequired,

  /**
   * A node, component instance, or function that returns either.
   * The `container` will passed to the Modal component.
   * By default, it uses the body of the anchorEl's top-level document object,
   * so it's simply `document.body` most of the time.
   */
  container: PropTypes.oneOfType([PropTypes.object, PropTypes.func]),

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * Always keep the children in the DOM.
   * This prop can be useful in SEO situation or
   * when you want to maximize the responsiveness of the Popper.
   */
  keepMounted: PropTypes.bool,

  /**
   * Popper.js is based on a "plugin-like" architecture,
   * most of its features are fully encapsulated "modifiers".
   *
   * A modifier is a function that is called each time Popper.js needs to
   * compute the position of the popper.
   * For this reason, modifiers should be very performant to avoid bottlenecks.
   * To learn how to create a modifier, [read the modifiers documentation](https://github.com/FezVrasta/popper.js/blob/master/docs/_includes/popper-documentation.md#modifiers--object).
   */
  modifiers: PropTypes.object,

  /**
   * If `true`, the popper is visible.
   */
  open: PropTypes.bool.isRequired,

  /**
   * Popper placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Options provided to the [`popper.js`](https://github.com/FezVrasta/popper.js) instance.
   */
  popperOptions: PropTypes.object,

  /**
   * A ref that points to the used popper instance.
   */
  popperRef: refType,

  /**
   * Help supporting a react-transition-group/Transition component.
   */
  transition: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Popper);

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/**!
 * @fileOverview Kickass library to create and place poppers near their reference elements.
 * @version 1.16.0
 * @license
 * Copyright (c) 2016 Federico Zivolo and contributors
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';

var timeoutDuration = function () {
  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
      return 1;
    }
  }
  return 0;
}();

function microtaskDebounce(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }
    called = true;
    window.Promise.resolve().then(function () {
      called = false;
      fn();
    });
  };
}

function taskDebounce(fn) {
  var scheduled = false;
  return function () {
    if (!scheduled) {
      scheduled = true;
      setTimeout(function () {
        scheduled = false;
        fn();
      }, timeoutDuration);
    }
  };
}

var supportsMicroTasks = isBrowser && window.Promise;

/**
* Create a debounced version of a method, that's asynchronously deferred
* but called in the minimum time possible.
*
* @method
* @memberof Popper.Utils
* @argument {Function} fn
* @returns {Function}
*/
var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;

/**
 * Check if the given variable is a function
 * @method
 * @memberof Popper.Utils
 * @argument {Any} functionToCheck - variable to check
 * @returns {Boolean} answer to: is a function?
 */
function isFunction(functionToCheck) {
  var getType = {};
  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
}

/**
 * Get CSS computed property of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Eement} element
 * @argument {String} property
 */
function getStyleComputedProperty(element, property) {
  if (element.nodeType !== 1) {
    return [];
  }
  // NOTE: 1 DOM access here
  var window = element.ownerDocument.defaultView;
  var css = window.getComputedStyle(element, null);
  return property ? css[property] : css;
}

/**
 * Returns the parentNode or the host of the element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} parent
 */
function getParentNode(element) {
  if (element.nodeName === 'HTML') {
    return element;
  }
  return element.parentNode || element.host;
}

/**
 * Returns the scrolling parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} scroll parent
 */
function getScrollParent(element) {
  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
  if (!element) {
    return document.body;
  }

  switch (element.nodeName) {
    case 'HTML':
    case 'BODY':
      return element.ownerDocument.body;
    case '#document':
      return element.body;
  }

  // Firefox want us to check `-x` and `-y` variations as well

  var _getStyleComputedProp = getStyleComputedProperty(element),
      overflow = _getStyleComputedProp.overflow,
      overflowX = _getStyleComputedProp.overflowX,
      overflowY = _getStyleComputedProp.overflowY;

  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
    return element;
  }

  return getScrollParent(getParentNode(element));
}

/**
 * Returns the reference node of the reference object, or the reference object itself.
 * @method
 * @memberof Popper.Utils
 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
 * @returns {Element} parent
 */
function getReferenceNode(reference) {
  return reference && reference.referenceNode ? reference.referenceNode : reference;
}

var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);

/**
 * Determines if the browser is Internet Explorer
 * @method
 * @memberof Popper.Utils
 * @param {Number} version to check
 * @returns {Boolean} isIE
 */
function isIE(version) {
  if (version === 11) {
    return isIE11;
  }
  if (version === 10) {
    return isIE10;
  }
  return isIE11 || isIE10;
}

/**
 * Returns the offset parent of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} offset parent
 */
function getOffsetParent(element) {
  if (!element) {
    return document.documentElement;
  }

  var noOffsetParent = isIE(10) ? document.body : null;

  // NOTE: 1 DOM access here
  var offsetParent = element.offsetParent || null;
  // Skip hidden elements which don't have an offsetParent
  while (offsetParent === noOffsetParent && element.nextElementSibling) {
    offsetParent = (element = element.nextElementSibling).offsetParent;
  }

  var nodeName = offsetParent && offsetParent.nodeName;

  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
    return element ? element.ownerDocument.documentElement : document.documentElement;
  }

  // .offsetParent will return the closest TH, TD or TABLE in case
  // no offsetParent is present, I hate this job...
  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
    return getOffsetParent(offsetParent);
  }

  return offsetParent;
}

function isOffsetContainer(element) {
  var nodeName = element.nodeName;

  if (nodeName === 'BODY') {
    return false;
  }
  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
}

/**
 * Finds the root node (document, shadowDOM root) of the given element
 * @method
 * @memberof Popper.Utils
 * @argument {Element} node
 * @returns {Element} root node
 */
function getRoot(node) {
  if (node.parentNode !== null) {
    return getRoot(node.parentNode);
  }

  return node;
}

/**
 * Finds the offset parent common to the two provided nodes
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element1
 * @argument {Element} element2
 * @returns {Element} common offset parent
 */
function findCommonOffsetParent(element1, element2) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
    return document.documentElement;
  }

  // Here we make sure to give as "start" the element that comes first in the DOM
  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
  var start = order ? element1 : element2;
  var end = order ? element2 : element1;

  // Get common ancestor container
  var range = document.createRange();
  range.setStart(start, 0);
  range.setEnd(end, 0);
  var commonAncestorContainer = range.commonAncestorContainer;

  // Both nodes are inside #document

  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
    if (isOffsetContainer(commonAncestorContainer)) {
      return commonAncestorContainer;
    }

    return getOffsetParent(commonAncestorContainer);
  }

  // one of the nodes is inside shadowDOM, find which one
  var element1root = getRoot(element1);
  if (element1root.host) {
    return findCommonOffsetParent(element1root.host, element2);
  } else {
    return findCommonOffsetParent(element1, getRoot(element2).host);
  }
}

/**
 * Gets the scroll value of the given element in the given side (top and left)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {String} side `top` or `left`
 * @returns {number} amount of scrolled pixels
 */
function getScroll(element) {
  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';

  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
  var nodeName = element.nodeName;

  if (nodeName === 'BODY' || nodeName === 'HTML') {
    var html = element.ownerDocument.documentElement;
    var scrollingElement = element.ownerDocument.scrollingElement || html;
    return scrollingElement[upperSide];
  }

  return element[upperSide];
}

/*
 * Sum or subtract the element scroll values (left and top) from a given rect object
 * @method
 * @memberof Popper.Utils
 * @param {Object} rect - Rect object you want to change
 * @param {HTMLElement} element - The element from the function reads the scroll values
 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
 * @return {Object} rect - The modifier rect object
 */
function includeScroll(rect, element) {
  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var scrollTop = getScroll(element, 'top');
  var scrollLeft = getScroll(element, 'left');
  var modifier = subtract ? -1 : 1;
  rect.top += scrollTop * modifier;
  rect.bottom += scrollTop * modifier;
  rect.left += scrollLeft * modifier;
  rect.right += scrollLeft * modifier;
  return rect;
}

/*
 * Helper to detect borders of a given element
 * @method
 * @memberof Popper.Utils
 * @param {CSSStyleDeclaration} styles
 * Result of `getStyleComputedProperty` on the given element
 * @param {String} axis - `x` or `y`
 * @return {number} borders - The borders size of the given axis
 */

function getBordersSize(styles, axis) {
  var sideA = axis === 'x' ? 'Left' : 'Top';
  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';

  return parseFloat(styles['border' + sideA + 'Width'], 10) + parseFloat(styles['border' + sideB + 'Width'], 10);
}

function getSize(axis, body, html, computedStyle) {
  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
}

function getWindowSizes(document) {
  var body = document.body;
  var html = document.documentElement;
  var computedStyle = isIE(10) && getComputedStyle(html);

  return {
    height: getSize('Height', body, html, computedStyle),
    width: getSize('Width', body, html, computedStyle)
  };
}

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();





var defineProperty = function (obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/**
 * Given element offsets, generate an output similar to getBoundingClientRect
 * @method
 * @memberof Popper.Utils
 * @argument {Object} offsets
 * @returns {Object} ClientRect like output
 */
function getClientRect(offsets) {
  return _extends({}, offsets, {
    right: offsets.left + offsets.width,
    bottom: offsets.top + offsets.height
  });
}

/**
 * Get bounding client rect of given element
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} element
 * @return {Object} client rect
 */
function getBoundingClientRect(element) {
  var rect = {};

  // IE10 10 FIX: Please, don't ask, the element isn't
  // considered in DOM in some circumstances...
  // This isn't reproducible in IE10 compatibility mode of IE11
  try {
    if (isIE(10)) {
      rect = element.getBoundingClientRect();
      var scrollTop = getScroll(element, 'top');
      var scrollLeft = getScroll(element, 'left');
      rect.top += scrollTop;
      rect.left += scrollLeft;
      rect.bottom += scrollTop;
      rect.right += scrollLeft;
    } else {
      rect = element.getBoundingClientRect();
    }
  } catch (e) {}

  var result = {
    left: rect.left,
    top: rect.top,
    width: rect.right - rect.left,
    height: rect.bottom - rect.top
  };

  // subtract scrollbar size from sizes
  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
  var width = sizes.width || element.clientWidth || result.width;
  var height = sizes.height || element.clientHeight || result.height;

  var horizScrollbar = element.offsetWidth - width;
  var vertScrollbar = element.offsetHeight - height;

  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
  // we make this check conditional for performance reasons
  if (horizScrollbar || vertScrollbar) {
    var styles = getStyleComputedProperty(element);
    horizScrollbar -= getBordersSize(styles, 'x');
    vertScrollbar -= getBordersSize(styles, 'y');

    result.width -= horizScrollbar;
    result.height -= vertScrollbar;
  }

  return getClientRect(result);
}

function getOffsetRectRelativeToArbitraryNode(children, parent) {
  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var isIE10 = isIE(10);
  var isHTML = parent.nodeName === 'HTML';
  var childrenRect = getBoundingClientRect(children);
  var parentRect = getBoundingClientRect(parent);
  var scrollParent = getScrollParent(children);

  var styles = getStyleComputedProperty(parent);
  var borderTopWidth = parseFloat(styles.borderTopWidth, 10);
  var borderLeftWidth = parseFloat(styles.borderLeftWidth, 10);

  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
  if (fixedPosition && isHTML) {
    parentRect.top = Math.max(parentRect.top, 0);
    parentRect.left = Math.max(parentRect.left, 0);
  }
  var offsets = getClientRect({
    top: childrenRect.top - parentRect.top - borderTopWidth,
    left: childrenRect.left - parentRect.left - borderLeftWidth,
    width: childrenRect.width,
    height: childrenRect.height
  });
  offsets.marginTop = 0;
  offsets.marginLeft = 0;

  // Subtract margins of documentElement in case it's being used as parent
  // we do this only on HTML because it's the only element that behaves
  // differently when margins are applied to it. The margins are included in
  // the box of the documentElement, in the other cases not.
  if (!isIE10 && isHTML) {
    var marginTop = parseFloat(styles.marginTop, 10);
    var marginLeft = parseFloat(styles.marginLeft, 10);

    offsets.top -= borderTopWidth - marginTop;
    offsets.bottom -= borderTopWidth - marginTop;
    offsets.left -= borderLeftWidth - marginLeft;
    offsets.right -= borderLeftWidth - marginLeft;

    // Attach marginTop and marginLeft because in some circumstances we may need them
    offsets.marginTop = marginTop;
    offsets.marginLeft = marginLeft;
  }

  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
    offsets = includeScroll(offsets, parent);
  }

  return offsets;
}

function getViewportOffsetRectRelativeToArtbitraryNode(element) {
  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var html = element.ownerDocument.documentElement;
  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
  var width = Math.max(html.clientWidth, window.innerWidth || 0);
  var height = Math.max(html.clientHeight, window.innerHeight || 0);

  var scrollTop = !excludeScroll ? getScroll(html) : 0;
  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;

  var offset = {
    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
    width: width,
    height: height
  };

  return getClientRect(offset);
}

/**
 * Check if the given element is fixed or is inside a fixed parent
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @argument {Element} customContainer
 * @returns {Boolean} answer to "isFixed?"
 */
function isFixed(element) {
  var nodeName = element.nodeName;
  if (nodeName === 'BODY' || nodeName === 'HTML') {
    return false;
  }
  if (getStyleComputedProperty(element, 'position') === 'fixed') {
    return true;
  }
  var parentNode = getParentNode(element);
  if (!parentNode) {
    return false;
  }
  return isFixed(parentNode);
}

/**
 * Finds the first parent of an element that has a transformed property defined
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Element} first transformed parent or documentElement
 */

function getFixedPositionOffsetParent(element) {
  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
  if (!element || !element.parentElement || isIE()) {
    return document.documentElement;
  }
  var el = element.parentElement;
  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
    el = el.parentElement;
  }
  return el || document.documentElement;
}

/**
 * Computed the boundaries limits and return them
 * @method
 * @memberof Popper.Utils
 * @param {HTMLElement} popper
 * @param {HTMLElement} reference
 * @param {number} padding
 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
 * @param {Boolean} fixedPosition - Is in fixed position mode
 * @returns {Object} Coordinates of the boundaries
 */
function getBoundaries(popper, reference, padding, boundariesElement) {
  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

  // NOTE: 1 DOM access here

  var boundaries = { top: 0, left: 0 };
  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));

  // Handle viewport case
  if (boundariesElement === 'viewport') {
    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
  } else {
    // Handle other cases based on DOM element used as boundaries
    var boundariesNode = void 0;
    if (boundariesElement === 'scrollParent') {
      boundariesNode = getScrollParent(getParentNode(reference));
      if (boundariesNode.nodeName === 'BODY') {
        boundariesNode = popper.ownerDocument.documentElement;
      }
    } else if (boundariesElement === 'window') {
      boundariesNode = popper.ownerDocument.documentElement;
    } else {
      boundariesNode = boundariesElement;
    }

    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);

    // In case of HTML, we need a different computation
    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
          height = _getWindowSizes.height,
          width = _getWindowSizes.width;

      boundaries.top += offsets.top - offsets.marginTop;
      boundaries.bottom = height + offsets.top;
      boundaries.left += offsets.left - offsets.marginLeft;
      boundaries.right = width + offsets.left;
    } else {
      // for all the other DOM elements, this one is good
      boundaries = offsets;
    }
  }

  // Add paddings
  padding = padding || 0;
  var isPaddingNumber = typeof padding === 'number';
  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;

  return boundaries;
}

function getArea(_ref) {
  var width = _ref.width,
      height = _ref.height;

  return width * height;
}

/**
 * Utility used to transform the `auto` placement to the placement with more
 * available space.
 * @method
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;

  if (placement.indexOf('auto') === -1) {
    return placement;
  }

  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);

  var rects = {
    top: {
      width: boundaries.width,
      height: refRect.top - boundaries.top
    },
    right: {
      width: boundaries.right - refRect.right,
      height: boundaries.height
    },
    bottom: {
      width: boundaries.width,
      height: boundaries.bottom - refRect.bottom
    },
    left: {
      width: refRect.left - boundaries.left,
      height: boundaries.height
    }
  };

  var sortedAreas = Object.keys(rects).map(function (key) {
    return _extends({
      key: key
    }, rects[key], {
      area: getArea(rects[key])
    });
  }).sort(function (a, b) {
    return b.area - a.area;
  });

  var filteredAreas = sortedAreas.filter(function (_ref2) {
    var width = _ref2.width,
        height = _ref2.height;
    return width >= popper.clientWidth && height >= popper.clientHeight;
  });

  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;

  var variation = placement.split('-')[1];

  return computedPlacement + (variation ? '-' + variation : '');
}

/**
 * Get offsets to the reference element
 * @method
 * @memberof Popper.Utils
 * @param {Object} state
 * @param {Element} popper - the popper element
 * @param {Element} reference - the reference element (the popper will be relative to this)
 * @param {Element} fixedPosition - is in fixed position mode
 * @returns {Object} An object containing the offsets which will be applied to the popper
 */
function getReferenceOffsets(state, popper, reference) {
  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
}

/**
 * Get the outer sizes of the given element (offset size + margins)
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element
 * @returns {Object} object containing width and height properties
 */
function getOuterSizes(element) {
  var window = element.ownerDocument.defaultView;
  var styles = window.getComputedStyle(element);
  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
  var result = {
    width: element.offsetWidth + y,
    height: element.offsetHeight + x
  };
  return result;
}

/**
 * Get the opposite placement of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement
 * @returns {String} flipped placement
 */
function getOppositePlacement(placement) {
  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash[matched];
  });
}

/**
 * Get offsets to the popper
 * @method
 * @memberof Popper.Utils
 * @param {Object} position - CSS position the Popper will get applied
 * @param {HTMLElement} popper - the popper element
 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
 * @param {String} placement - one of the valid placement options
 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
 */
function getPopperOffsets(popper, referenceOffsets, placement) {
  placement = placement.split('-')[0];

  // Get popper node sizes
  var popperRect = getOuterSizes(popper);

  // Add position, width and height to our offsets object
  var popperOffsets = {
    width: popperRect.width,
    height: popperRect.height
  };

  // depending by the popper placement we have to compute its offsets slightly differently
  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
  var mainSide = isHoriz ? 'top' : 'left';
  var secondarySide = isHoriz ? 'left' : 'top';
  var measurement = isHoriz ? 'height' : 'width';
  var secondaryMeasurement = !isHoriz ? 'height' : 'width';

  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
  if (placement === secondarySide) {
    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
  } else {
    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
  }

  return popperOffsets;
}

/**
 * Mimics the `find` method of Array
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function find(arr, check) {
  // use native find if supported
  if (Array.prototype.find) {
    return arr.find(check);
  }

  // use `filter` to obtain the same behavior of `find`
  return arr.filter(check)[0];
}

/**
 * Return the index of the matching object
 * @method
 * @memberof Popper.Utils
 * @argument {Array} arr
 * @argument prop
 * @argument value
 * @returns index or -1
 */
function findIndex(arr, prop, value) {
  // use native findIndex if supported
  if (Array.prototype.findIndex) {
    return arr.findIndex(function (cur) {
      return cur[prop] === value;
    });
  }

  // use `find` + `indexOf` if `findIndex` isn't supported
  var match = find(arr, function (obj) {
    return obj[prop] === value;
  });
  return arr.indexOf(match);
}

/**
 * Loop trough the list of modifiers and run them in order,
 * each of them will then edit the data object.
 * @method
 * @memberof Popper.Utils
 * @param {dataObject} data
 * @param {Array} modifiers
 * @param {String} ends - Optional modifier name used as stopper
 * @returns {dataObject}
 */
function runModifiers(modifiers, data, ends) {
  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));

  modifiersToRun.forEach(function (modifier) {
    if (modifier['function']) {
      // eslint-disable-line dot-notation
      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
    }
    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
    if (modifier.enabled && isFunction(fn)) {
      // Add properties to offsets to make them a complete clientRect object
      // we do this before each modifier to make sure the previous one doesn't
      // mess with these values
      data.offsets.popper = getClientRect(data.offsets.popper);
      data.offsets.reference = getClientRect(data.offsets.reference);

      data = fn(data, modifier);
    }
  });

  return data;
}

/**
 * Updates the position of the popper, computing the new offsets and applying
 * the new style.<br />
 * Prefer `scheduleUpdate` over `update` because of performance reasons.
 * @method
 * @memberof Popper
 */
function update() {
  // if popper is destroyed, don't perform any further update
  if (this.state.isDestroyed) {
    return;
  }

  var data = {
    instance: this,
    styles: {},
    arrowStyles: {},
    attributes: {},
    flipped: false,
    offsets: {}
  };

  // compute reference element offsets
  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);

  // store the computed placement inside `originalPlacement`
  data.originalPlacement = data.placement;

  data.positionFixed = this.options.positionFixed;

  // compute the popper offsets
  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);

  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';

  // run the modifiers
  data = runModifiers(this.modifiers, data);

  // the first `update` will call `onCreate` callback
  // the other ones will call `onUpdate` callback
  if (!this.state.isCreated) {
    this.state.isCreated = true;
    this.options.onCreate(data);
  } else {
    this.options.onUpdate(data);
  }
}

/**
 * Helper used to know if the given modifier is enabled.
 * @method
 * @memberof Popper.Utils
 * @returns {Boolean}
 */
function isModifierEnabled(modifiers, modifierName) {
  return modifiers.some(function (_ref) {
    var name = _ref.name,
        enabled = _ref.enabled;
    return enabled && name === modifierName;
  });
}

/**
 * Get the prefixed supported property name
 * @method
 * @memberof Popper.Utils
 * @argument {String} property (camelCase)
 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
 */
function getSupportedPropertyName(property) {
  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);

  for (var i = 0; i < prefixes.length; i++) {
    var prefix = prefixes[i];
    var toCheck = prefix ? '' + prefix + upperProp : property;
    if (typeof document.body.style[toCheck] !== 'undefined') {
      return toCheck;
    }
  }
  return null;
}

/**
 * Destroys the popper.
 * @method
 * @memberof Popper
 */
function destroy() {
  this.state.isDestroyed = true;

  // touch DOM only if `applyStyle` modifier is enabled
  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
    this.popper.removeAttribute('x-placement');
    this.popper.style.position = '';
    this.popper.style.top = '';
    this.popper.style.left = '';
    this.popper.style.right = '';
    this.popper.style.bottom = '';
    this.popper.style.willChange = '';
    this.popper.style[getSupportedPropertyName('transform')] = '';
  }

  this.disableEventListeners();

  // remove the popper if user explicitly asked for the deletion on destroy
  // do not use `remove` because IE11 doesn't support it
  if (this.options.removeOnDestroy) {
    this.popper.parentNode.removeChild(this.popper);
  }
  return this;
}

/**
 * Get the window associated with the element
 * @argument {Element} element
 * @returns {Window}
 */
function getWindow(element) {
  var ownerDocument = element.ownerDocument;
  return ownerDocument ? ownerDocument.defaultView : window;
}

function attachToScrollParents(scrollParent, event, callback, scrollParents) {
  var isBody = scrollParent.nodeName === 'BODY';
  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
  target.addEventListener(event, callback, { passive: true });

  if (!isBody) {
    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
  }
  scrollParents.push(target);
}

/**
 * Setup needed event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function setupEventListeners(reference, options, state, updateBound) {
  // Resize event listener on window
  state.updateBound = updateBound;
  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });

  // Scroll event listener on scroll parents
  var scrollElement = getScrollParent(reference);
  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
  state.scrollElement = scrollElement;
  state.eventsEnabled = true;

  return state;
}

/**
 * It will add resize/scroll events and start recalculating
 * position of the popper element when they are triggered.
 * @method
 * @memberof Popper
 */
function enableEventListeners() {
  if (!this.state.eventsEnabled) {
    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
  }
}

/**
 * Remove event listeners used to update the popper position
 * @method
 * @memberof Popper.Utils
 * @private
 */
function removeEventListeners(reference, state) {
  // Remove resize event listener on window
  getWindow(reference).removeEventListener('resize', state.updateBound);

  // Remove scroll event listener on scroll parents
  state.scrollParents.forEach(function (target) {
    target.removeEventListener('scroll', state.updateBound);
  });

  // Reset state
  state.updateBound = null;
  state.scrollParents = [];
  state.scrollElement = null;
  state.eventsEnabled = false;
  return state;
}

/**
 * It will remove resize/scroll events and won't recalculate popper position
 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
 * unless you call `update` method manually.
 * @method
 * @memberof Popper
 */
function disableEventListeners() {
  if (this.state.eventsEnabled) {
    cancelAnimationFrame(this.scheduleUpdate);
    this.state = removeEventListeners(this.reference, this.state);
  }
}

/**
 * Tells if a given input is a number
 * @method
 * @memberof Popper.Utils
 * @param {*} input to check
 * @return {Boolean}
 */
function isNumeric(n) {
  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
}

/**
 * Set the style to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the style to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setStyles(element, styles) {
  Object.keys(styles).forEach(function (prop) {
    var unit = '';
    // add unit if the value is numeric and is one of the following
    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
      unit = 'px';
    }
    element.style[prop] = styles[prop] + unit;
  });
}

/**
 * Set the attributes to the given popper
 * @method
 * @memberof Popper.Utils
 * @argument {Element} element - Element to apply the attributes to
 * @argument {Object} styles
 * Object with a list of properties and values which will be applied to the element
 */
function setAttributes(element, attributes) {
  Object.keys(attributes).forEach(function (prop) {
    var value = attributes[prop];
    if (value !== false) {
      element.setAttribute(prop, attributes[prop]);
    } else {
      element.removeAttribute(prop);
    }
  });
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} data.styles - List of style properties - values to apply to popper element
 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The same data object
 */
function applyStyle(data) {
  // any property present in `data.styles` will be applied to the popper,
  // in this way we can make the 3rd party modifiers add custom styles to it
  // Be aware, modifiers could override the properties defined in the previous
  // lines of this modifier!
  setStyles(data.instance.popper, data.styles);

  // any property present in `data.attributes` will be applied to the popper,
  // they will be set as HTML attributes of the element
  setAttributes(data.instance.popper, data.attributes);

  // if arrowElement is defined and arrowStyles has some properties
  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
    setStyles(data.arrowElement, data.arrowStyles);
  }

  return data;
}

/**
 * Set the x-placement attribute before everything else because it could be used
 * to add margins to the popper margins needs to be calculated to get the
 * correct popper offsets.
 * @method
 * @memberof Popper.modifiers
 * @param {HTMLElement} reference - The reference element used to position the popper
 * @param {HTMLElement} popper - The HTML element used as popper
 * @param {Object} options - Popper.js options
 */
function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
  // compute reference element offsets
  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);

  // compute auto placement, store placement inside the data object,
  // modifiers will be able to edit `placement` if needed
  // and refer to originalPlacement to know the original value
  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);

  popper.setAttribute('x-placement', placement);

  // Apply `position` to popper before anything else because
  // without the position applied we can't guarantee correct computations
  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });

  return options;
}

/**
 * @function
 * @memberof Popper.Utils
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
 * @returns {Object} The popper's position offsets rounded
 *
 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
 * good as it can be within reason.
 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
 *
 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
 * as well on High DPI screens).
 *
 * Firefox prefers no rounding for positioning and does not have blurriness on
 * high DPI screens.
 *
 * Only horizontal placement and left/right values need to be considered.
 */
function getRoundedOffsets(data, shouldRound) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;
  var round = Math.round,
      floor = Math.floor;

  var noRound = function noRound(v) {
    return v;
  };

  var referenceWidth = round(reference.width);
  var popperWidth = round(popper.width);

  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
  var isVariation = data.placement.indexOf('-') !== -1;
  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;

  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
  var verticalToInteger = !shouldRound ? noRound : round;

  return {
    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
    top: verticalToInteger(popper.top),
    bottom: verticalToInteger(popper.bottom),
    right: horizontalToInteger(popper.right)
  };
}

var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function computeStyle(data, options) {
  var x = options.x,
      y = options.y;
  var popper = data.offsets.popper;

  // Remove this legacy support in Popper.js v2

  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'applyStyle';
  }).gpuAcceleration;
  if (legacyGpuAccelerationOption !== undefined) {
    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
  }
  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;

  var offsetParent = getOffsetParent(data.instance.popper);
  var offsetParentRect = getBoundingClientRect(offsetParent);

  // Styles
  var styles = {
    position: popper.position
  };

  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);

  var sideA = x === 'bottom' ? 'top' : 'bottom';
  var sideB = y === 'right' ? 'left' : 'right';

  // if gpuAcceleration is set to `true` and transform is supported,
  //  we use `translate3d` to apply the position to the popper we
  // automatically use the supported prefixed version if needed
  var prefixedProperty = getSupportedPropertyName('transform');

  // now, let's make a step back and look at this code closely (wtf?)
  // If the content of the popper grows once it's been positioned, it
  // may happen that the popper gets misplaced because of the new content
  // overflowing its reference element
  // To avoid this problem, we provide two options (x and y), which allow
  // the consumer to define the offset origin.
  // If we position a popper on top of a reference element, we can set
  // `x` to `top` to make the popper grow towards its top instead of
  // its bottom.
  var left = void 0,
      top = void 0;
  if (sideA === 'bottom') {
    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
    // and not the bottom of the html element
    if (offsetParent.nodeName === 'HTML') {
      top = -offsetParent.clientHeight + offsets.bottom;
    } else {
      top = -offsetParentRect.height + offsets.bottom;
    }
  } else {
    top = offsets.top;
  }
  if (sideB === 'right') {
    if (offsetParent.nodeName === 'HTML') {
      left = -offsetParent.clientWidth + offsets.right;
    } else {
      left = -offsetParentRect.width + offsets.right;
    }
  } else {
    left = offsets.left;
  }
  if (gpuAcceleration && prefixedProperty) {
    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
    styles[sideA] = 0;
    styles[sideB] = 0;
    styles.willChange = 'transform';
  } else {
    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
    var invertTop = sideA === 'bottom' ? -1 : 1;
    var invertLeft = sideB === 'right' ? -1 : 1;
    styles[sideA] = top * invertTop;
    styles[sideB] = left * invertLeft;
    styles.willChange = sideA + ', ' + sideB;
  }

  // Attributes
  var attributes = {
    'x-placement': data.placement
  };

  // Update `data` attributes, styles and arrowStyles
  data.attributes = _extends({}, attributes, data.attributes);
  data.styles = _extends({}, styles, data.styles);
  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);

  return data;
}

/**
 * Helper used to know if the given modifier depends from another one.<br />
 * It checks if the needed modifier is listed and enabled.
 * @method
 * @memberof Popper.Utils
 * @param {Array} modifiers - list of modifiers
 * @param {String} requestingName - name of requesting modifier
 * @param {String} requestedName - name of requested modifier
 * @returns {Boolean}
 */
function isModifierRequired(modifiers, requestingName, requestedName) {
  var requesting = find(modifiers, function (_ref) {
    var name = _ref.name;
    return name === requestingName;
  });

  var isRequired = !!requesting && modifiers.some(function (modifier) {
    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
  });

  if (!isRequired) {
    var _requesting = '`' + requestingName + '`';
    var requested = '`' + requestedName + '`';
    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
  }
  return isRequired;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function arrow(data, options) {
  var _data$offsets$arrow;

  // arrow depends on keepTogether in order to work
  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
    return data;
  }

  var arrowElement = options.element;

  // if arrowElement is a string, suppose it's a CSS selector
  if (typeof arrowElement === 'string') {
    arrowElement = data.instance.popper.querySelector(arrowElement);

    // if arrowElement is not found, don't run the modifier
    if (!arrowElement) {
      return data;
    }
  } else {
    // if the arrowElement isn't a query selector we must check that the
    // provided DOM node is child of its popper node
    if (!data.instance.popper.contains(arrowElement)) {
      console.warn('WARNING: `arrow.element` must be child of its popper element!');
      return data;
    }
  }

  var placement = data.placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isVertical = ['left', 'right'].indexOf(placement) !== -1;

  var len = isVertical ? 'height' : 'width';
  var sideCapitalized = isVertical ? 'Top' : 'Left';
  var side = sideCapitalized.toLowerCase();
  var altSide = isVertical ? 'left' : 'top';
  var opSide = isVertical ? 'bottom' : 'right';
  var arrowElementSize = getOuterSizes(arrowElement)[len];

  //
  // extends keepTogether behavior making sure the popper and its
  // reference have enough pixels in conjunction
  //

  // top/left side
  if (reference[opSide] - arrowElementSize < popper[side]) {
    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
  }
  // bottom/right side
  if (reference[side] + arrowElementSize > popper[opSide]) {
    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
  }
  data.offsets.popper = getClientRect(data.offsets.popper);

  // compute center of the popper
  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;

  // Compute the sideValue using the updated popper offsets
  // take popper margin in account because we don't have this info available
  var css = getStyleComputedProperty(data.instance.popper);
  var popperMarginSide = parseFloat(css['margin' + sideCapitalized], 10);
  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width'], 10);
  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;

  // prevent arrowElement from being placed not contiguously to its popper
  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);

  data.arrowElement = arrowElement;
  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);

  return data;
}

/**
 * Get the opposite placement variation of the given one
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement variation
 * @returns {String} flipped placement variation
 */
function getOppositeVariation(variation) {
  if (variation === 'end') {
    return 'start';
  } else if (variation === 'start') {
    return 'end';
  }
  return variation;
}

/**
 * List of accepted placements to use as values of the `placement` option.<br />
 * Valid placements are:
 * - `auto`
 * - `top`
 * - `right`
 * - `bottom`
 * - `left`
 *
 * Each placement can have a variation from this list:
 * - `-start`
 * - `-end`
 *
 * Variations are interpreted easily if you think of them as the left to right
 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
 * is right.<br />
 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
 *
 * Some valid examples are:
 * - `top-end` (on top of reference, right aligned)
 * - `right-start` (on right of reference, top aligned)
 * - `bottom` (on bottom, centered)
 * - `auto-end` (on the side with more space available, alignment depends by placement)
 *
 * @static
 * @type {Array}
 * @enum {String}
 * @readonly
 * @method placements
 * @memberof Popper
 */
var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];

// Get rid of `auto` `auto-start` and `auto-end`
var validPlacements = placements.slice(3);

/**
 * Given an initial placement, returns all the subsequent placements
 * clockwise (or counter-clockwise).
 *
 * @method
 * @memberof Popper.Utils
 * @argument {String} placement - A valid placement (it accepts variations)
 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
 * @returns {Array} placements including their variations
 */
function clockwise(placement) {
  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var index = validPlacements.indexOf(placement);
  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
  return counter ? arr.reverse() : arr;
}

var BEHAVIORS = {
  FLIP: 'flip',
  CLOCKWISE: 'clockwise',
  COUNTERCLOCKWISE: 'counterclockwise'
};

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function flip(data, options) {
  // if `inner` modifier is enabled, we can't use the `flip` modifier
  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
    return data;
  }

  if (data.flipped && data.placement === data.originalPlacement) {
    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
    return data;
  }

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);

  var placement = data.placement.split('-')[0];
  var placementOpposite = getOppositePlacement(placement);
  var variation = data.placement.split('-')[1] || '';

  var flipOrder = [];

  switch (options.behavior) {
    case BEHAVIORS.FLIP:
      flipOrder = [placement, placementOpposite];
      break;
    case BEHAVIORS.CLOCKWISE:
      flipOrder = clockwise(placement);
      break;
    case BEHAVIORS.COUNTERCLOCKWISE:
      flipOrder = clockwise(placement, true);
      break;
    default:
      flipOrder = options.behavior;
  }

  flipOrder.forEach(function (step, index) {
    if (placement !== step || flipOrder.length === index + 1) {
      return data;
    }

    placement = data.placement.split('-')[0];
    placementOpposite = getOppositePlacement(placement);

    var popperOffsets = data.offsets.popper;
    var refOffsets = data.offsets.reference;

    // using floor because the reference offsets may contain decimals we are not going to consider here
    var floor = Math.floor;
    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);

    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);

    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;

    // flip the variation if required
    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;

    // flips variation if reference element overflows boundaries
    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);

    // flips variation if popper content overflows boundaries
    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);

    var flippedVariation = flippedVariationByRef || flippedVariationByContent;

    if (overlapsRef || overflowsBoundaries || flippedVariation) {
      // this boolean to detect any flip loop
      data.flipped = true;

      if (overlapsRef || overflowsBoundaries) {
        placement = flipOrder[index + 1];
      }

      if (flippedVariation) {
        variation = getOppositeVariation(variation);
      }

      data.placement = placement + (variation ? '-' + variation : '');

      // this object contains `position`, we want to preserve it along with
      // any additional property we may add in the future
      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));

      data = runModifiers(data.instance.modifiers, data, 'flip');
    }
  });
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function keepTogether(data) {
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var placement = data.placement.split('-')[0];
  var floor = Math.floor;
  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
  var side = isVertical ? 'right' : 'bottom';
  var opSide = isVertical ? 'left' : 'top';
  var measurement = isVertical ? 'width' : 'height';

  if (popper[side] < floor(reference[opSide])) {
    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
  }
  if (popper[opSide] > floor(reference[side])) {
    data.offsets.popper[opSide] = floor(reference[side]);
  }

  return data;
}

/**
 * Converts a string containing value + unit into a px value number
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} str - Value + unit string
 * @argument {String} measurement - `height` or `width`
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @returns {Number|String}
 * Value in pixels, or original string if no values were extracted
 */
function toValue(str, measurement, popperOffsets, referenceOffsets) {
  // separate value from unit
  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
  var value = +split[1];
  var unit = split[2];

  // If it's not a number it's an operator, I guess
  if (!value) {
    return str;
  }

  if (unit.indexOf('%') === 0) {
    var element = void 0;
    switch (unit) {
      case '%p':
        element = popperOffsets;
        break;
      case '%':
      case '%r':
      default:
        element = referenceOffsets;
    }

    var rect = getClientRect(element);
    return rect[measurement] / 100 * value;
  } else if (unit === 'vh' || unit === 'vw') {
    // if is a vh or vw, we calculate the size based on the viewport
    var size = void 0;
    if (unit === 'vh') {
      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    } else {
      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    }
    return size / 100 * value;
  } else {
    // if is an explicit pixel unit, we get rid of the unit and keep the value
    // if is an implicit unit, it's px, and we return just the value
    return value;
  }
}

/**
 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
 * @function
 * @memberof {modifiers~offset}
 * @private
 * @argument {String} offset
 * @argument {Object} popperOffsets
 * @argument {Object} referenceOffsets
 * @argument {String} basePlacement
 * @returns {Array} a two cells array with x and y offsets in numbers
 */
function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
  var offsets = [0, 0];

  // Use height if placement is left or right and index is 0 otherwise use width
  // in this way the first offset will use an axis and the second one
  // will use the other one
  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;

  // Split the offset string to obtain a list of values and operands
  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
    return frag.trim();
  });

  // Detect if the offset string contains a pair of values or a single one
  // they could be separated by comma or space
  var divider = fragments.indexOf(find(fragments, function (frag) {
    return frag.search(/,|\s/) !== -1;
  }));

  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
  }

  // If divider is found, we divide the list of values and operands to divide
  // them by ofset X and Y.
  var splitRegex = /\s*,\s*|\s+/;
  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];

  // Convert the values with units to absolute pixels to allow our computations
  ops = ops.map(function (op, index) {
    // Most of the units rely on the orientation of the popper
    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
    var mergeWithPrevious = false;
    return op
    // This aggregates any `+` or `-` sign that aren't considered operators
    // e.g.: 10 + +5 => [10, +, +5]
    .reduce(function (a, b) {
      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
        a[a.length - 1] = b;
        mergeWithPrevious = true;
        return a;
      } else if (mergeWithPrevious) {
        a[a.length - 1] += b;
        mergeWithPrevious = false;
        return a;
      } else {
        return a.concat(b);
      }
    }, [])
    // Here we convert the string values into number values (in px)
    .map(function (str) {
      return toValue(str, measurement, popperOffsets, referenceOffsets);
    });
  });

  // Loop trough the offsets arrays and execute the operations
  ops.forEach(function (op, index) {
    op.forEach(function (frag, index2) {
      if (isNumeric(frag)) {
        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
      }
    });
  });
  return offsets;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @argument {Number|String} options.offset=0
 * The offset value as described in the modifier description
 * @returns {Object} The data object, properly modified
 */
function offset(data, _ref) {
  var offset = _ref.offset;
  var placement = data.placement,
      _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var basePlacement = placement.split('-')[0];

  var offsets = void 0;
  if (isNumeric(+offset)) {
    offsets = [+offset, 0];
  } else {
    offsets = parseOffset(offset, popper, reference, basePlacement);
  }

  if (basePlacement === 'left') {
    popper.top += offsets[0];
    popper.left -= offsets[1];
  } else if (basePlacement === 'right') {
    popper.top += offsets[0];
    popper.left += offsets[1];
  } else if (basePlacement === 'top') {
    popper.left += offsets[0];
    popper.top -= offsets[1];
  } else if (basePlacement === 'bottom') {
    popper.left += offsets[0];
    popper.top += offsets[1];
  }

  data.popper = popper;
  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function preventOverflow(data, options) {
  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);

  // If offsetParent is the reference element, we really want to
  // go one step up and use the next offsetParent as reference to
  // avoid to make this modifier completely useless and look like broken
  if (data.instance.reference === boundariesElement) {
    boundariesElement = getOffsetParent(boundariesElement);
  }

  // NOTE: DOM access here
  // resets the popper's position so that the document size can be calculated excluding
  // the size of the popper element itself
  var transformProp = getSupportedPropertyName('transform');
  var popperStyles = data.instance.popper.style; // assignment to help minification
  var top = popperStyles.top,
      left = popperStyles.left,
      transform = popperStyles[transformProp];

  popperStyles.top = '';
  popperStyles.left = '';
  popperStyles[transformProp] = '';

  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);

  // NOTE: DOM access here
  // restores the original style properties after the offsets have been computed
  popperStyles.top = top;
  popperStyles.left = left;
  popperStyles[transformProp] = transform;

  options.boundaries = boundaries;

  var order = options.priority;
  var popper = data.offsets.popper;

  var check = {
    primary: function primary(placement) {
      var value = popper[placement];
      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
        value = Math.max(popper[placement], boundaries[placement]);
      }
      return defineProperty({}, placement, value);
    },
    secondary: function secondary(placement) {
      var mainSide = placement === 'right' ? 'left' : 'top';
      var value = popper[mainSide];
      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
      }
      return defineProperty({}, mainSide, value);
    }
  };

  order.forEach(function (placement) {
    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
    popper = _extends({}, popper, check[side](placement));
  });

  data.offsets.popper = popper;

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function shift(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var shiftvariation = placement.split('-')[1];

  // if shift shiftvariation is specified, run the modifier
  if (shiftvariation) {
    var _data$offsets = data.offsets,
        reference = _data$offsets.reference,
        popper = _data$offsets.popper;

    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
    var side = isVertical ? 'left' : 'top';
    var measurement = isVertical ? 'width' : 'height';

    var shiftOffsets = {
      start: defineProperty({}, side, reference[side]),
      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
    };

    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by update method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function hide(data) {
  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
    return data;
  }

  var refRect = data.offsets.reference;
  var bound = find(data.instance.modifiers, function (modifier) {
    return modifier.name === 'preventOverflow';
  }).boundaries;

  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === true) {
      return data;
    }

    data.hide = true;
    data.attributes['x-out-of-boundaries'] = '';
  } else {
    // Avoid unnecessary DOM access if visibility hasn't changed
    if (data.hide === false) {
      return data;
    }

    data.hide = false;
    data.attributes['x-out-of-boundaries'] = false;
  }

  return data;
}

/**
 * @function
 * @memberof Modifiers
 * @argument {Object} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {Object} The data object, properly modified
 */
function inner(data) {
  var placement = data.placement;
  var basePlacement = placement.split('-')[0];
  var _data$offsets = data.offsets,
      popper = _data$offsets.popper,
      reference = _data$offsets.reference;

  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;

  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;

  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);

  data.placement = getOppositePlacement(placement);
  data.offsets.popper = getClientRect(popper);

  return data;
}

/**
 * Modifier function, each modifier can have a function of this type assigned
 * to its `fn` property.<br />
 * These functions will be called on each update, this means that you must
 * make sure they are performant enough to avoid performance bottlenecks.
 *
 * @function ModifierFn
 * @argument {dataObject} data - The data object generated by `update` method
 * @argument {Object} options - Modifiers configuration and options
 * @returns {dataObject} The data object, properly modified
 */

/**
 * Modifiers are plugins used to alter the behavior of your poppers.<br />
 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
 * needed by the library.
 *
 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
 * All the other properties are configurations that could be tweaked.
 * @namespace modifiers
 */
var modifiers = {
  /**
   * Modifier used to shift the popper on the start or end of its reference
   * element.<br />
   * It will read the variation of the `placement` property.<br />
   * It can be one either `-end` or `-start`.
   * @memberof modifiers
   * @inner
   */
  shift: {
    /** @prop {number} order=100 - Index used to define the order of execution */
    order: 100,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: shift
  },

  /**
   * The `offset` modifier can shift your popper on both its axis.
   *
   * It accepts the following units:
   * - `px` or unit-less, interpreted as pixels
   * - `%` or `%r`, percentage relative to the length of the reference element
   * - `%p`, percentage relative to the length of the popper element
   * - `vw`, CSS viewport width unit
   * - `vh`, CSS viewport height unit
   *
   * For length is intended the main axis relative to the placement of the popper.<br />
   * This means that if the placement is `top` or `bottom`, the length will be the
   * `width`. In case of `left` or `right`, it will be the `height`.
   *
   * You can provide a single value (as `Number` or `String`), or a pair of values
   * as `String` divided by a comma or one (or more) white spaces.<br />
   * The latter is a deprecated method because it leads to confusion and will be
   * removed in v2.<br />
   * Additionally, it accepts additions and subtractions between different units.
   * Note that multiplications and divisions aren't supported.
   *
   * Valid examples are:
   * ```
   * 10
   * '10%'
   * '10, 10'
   * '10%, 10'
   * '10 + 10%'
   * '10 - 5vh + 3%'
   * '-10px + 5vh, 5px - 6%'
   * ```
   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
   *
   * @memberof modifiers
   * @inner
   */
  offset: {
    /** @prop {number} order=200 - Index used to define the order of execution */
    order: 200,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: offset,
    /** @prop {Number|String} offset=0
     * The offset value as described in the modifier description
     */
    offset: 0
  },

  /**
   * Modifier used to prevent the popper from being positioned outside the boundary.
   *
   * A scenario exists where the reference itself is not within the boundaries.<br />
   * We can say it has "escaped the boundaries" — or just "escaped".<br />
   * In this case we need to decide whether the popper should either:
   *
   * - detach from the reference and remain "trapped" in the boundaries, or
   * - if it should ignore the boundary and "escape with its reference"
   *
   * When `escapeWithReference` is set to`true` and reference is completely
   * outside its boundaries, the popper will overflow (or completely leave)
   * the boundaries in order to remain attached to the edge of the reference.
   *
   * @memberof modifiers
   * @inner
   */
  preventOverflow: {
    /** @prop {number} order=300 - Index used to define the order of execution */
    order: 300,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: preventOverflow,
    /**
     * @prop {Array} [priority=['left','right','top','bottom']]
     * Popper will try to prevent overflow following these priorities by default,
     * then, it could overflow on the left and on top of the `boundariesElement`
     */
    priority: ['left', 'right', 'top', 'bottom'],
    /**
     * @prop {number} padding=5
     * Amount of pixel used to define a minimum distance between the boundaries
     * and the popper. This makes sure the popper always has a little padding
     * between the edges of its container
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='scrollParent'
     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
     * `viewport` or any DOM element.
     */
    boundariesElement: 'scrollParent'
  },

  /**
   * Modifier used to make sure the reference and its popper stay near each other
   * without leaving any gap between the two. Especially useful when the arrow is
   * enabled and you want to ensure that it points to its reference element.
   * It cares only about the first axis. You can still have poppers with margin
   * between the popper and its reference element.
   * @memberof modifiers
   * @inner
   */
  keepTogether: {
    /** @prop {number} order=400 - Index used to define the order of execution */
    order: 400,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: keepTogether
  },

  /**
   * This modifier is used to move the `arrowElement` of the popper to make
   * sure it is positioned between the reference element and its popper element.
   * It will read the outer size of the `arrowElement` node to detect how many
   * pixels of conjunction are needed.
   *
   * It has no effect if no `arrowElement` is provided.
   * @memberof modifiers
   * @inner
   */
  arrow: {
    /** @prop {number} order=500 - Index used to define the order of execution */
    order: 500,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: arrow,
    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
    element: '[x-arrow]'
  },

  /**
   * Modifier used to flip the popper's placement when it starts to overlap its
   * reference element.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   *
   * **NOTE:** this modifier will interrupt the current update cycle and will
   * restart it if it detects the need to flip the placement.
   * @memberof modifiers
   * @inner
   */
  flip: {
    /** @prop {number} order=600 - Index used to define the order of execution */
    order: 600,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: flip,
    /**
     * @prop {String|Array} behavior='flip'
     * The behavior used to change the popper's placement. It can be one of
     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
     * placements (with optional variations)
     */
    behavior: 'flip',
    /**
     * @prop {number} padding=5
     * The popper will flip if it hits the edges of the `boundariesElement`
     */
    padding: 5,
    /**
     * @prop {String|HTMLElement} boundariesElement='viewport'
     * The element which will define the boundaries of the popper position.
     * The popper will never be placed outside of the defined boundaries
     * (except if `keepTogether` is enabled)
     */
    boundariesElement: 'viewport',
    /**
     * @prop {Boolean} flipVariations=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the reference element overlaps its boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariations: false,
    /**
     * @prop {Boolean} flipVariationsByContent=false
     * The popper will switch placement variation between `-start` and `-end` when
     * the popper element overlaps its reference boundaries.
     *
     * The original placement should have a set variation.
     */
    flipVariationsByContent: false
  },

  /**
   * Modifier used to make the popper flow toward the inner of the reference element.
   * By default, when this modifier is disabled, the popper will be placed outside
   * the reference element.
   * @memberof modifiers
   * @inner
   */
  inner: {
    /** @prop {number} order=700 - Index used to define the order of execution */
    order: 700,
    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
    enabled: false,
    /** @prop {ModifierFn} */
    fn: inner
  },

  /**
   * Modifier used to hide the popper when its reference element is outside of the
   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
   * be used to hide with a CSS selector the popper when its reference is
   * out of boundaries.
   *
   * Requires the `preventOverflow` modifier before it in order to work.
   * @memberof modifiers
   * @inner
   */
  hide: {
    /** @prop {number} order=800 - Index used to define the order of execution */
    order: 800,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: hide
  },

  /**
   * Computes the style that will be applied to the popper element to gets
   * properly positioned.
   *
   * Note that this modifier will not touch the DOM, it just prepares the styles
   * so that `applyStyle` modifier can apply it. This separation is useful
   * in case you need to replace `applyStyle` with a custom implementation.
   *
   * This modifier has `850` as `order` value to maintain backward compatibility
   * with previous versions of Popper.js. Expect the modifiers ordering method
   * to change in future major versions of the library.
   *
   * @memberof modifiers
   * @inner
   */
  computeStyle: {
    /** @prop {number} order=850 - Index used to define the order of execution */
    order: 850,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: computeStyle,
    /**
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: true,
    /**
     * @prop {string} [x='bottom']
     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
     * Change this if your popper should grow in a direction different from `bottom`
     */
    x: 'bottom',
    /**
     * @prop {string} [x='left']
     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
     * Change this if your popper should grow in a direction different from `right`
     */
    y: 'right'
  },

  /**
   * Applies the computed styles to the popper element.
   *
   * All the DOM manipulations are limited to this modifier. This is useful in case
   * you want to integrate Popper.js inside a framework or view library and you
   * want to delegate all the DOM manipulations to it.
   *
   * Note that if you disable this modifier, you must make sure the popper element
   * has its position set to `absolute` before Popper.js can do its work!
   *
   * Just disable this modifier and define your own to achieve the desired effect.
   *
   * @memberof modifiers
   * @inner
   */
  applyStyle: {
    /** @prop {number} order=900 - Index used to define the order of execution */
    order: 900,
    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
    enabled: true,
    /** @prop {ModifierFn} */
    fn: applyStyle,
    /** @prop {Function} */
    onLoad: applyStyleOnLoad,
    /**
     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
     * @prop {Boolean} gpuAcceleration=true
     * If true, it uses the CSS 3D transformation to position the popper.
     * Otherwise, it will use the `top` and `left` properties
     */
    gpuAcceleration: undefined
  }
};

/**
 * The `dataObject` is an object containing all the information used by Popper.js.
 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
 * @name dataObject
 * @property {Object} data.instance The Popper.js instance
 * @property {String} data.placement Placement applied to popper
 * @property {String} data.originalPlacement Placement originally defined on init
 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
 * @property {Object} data.boundaries Offsets of the popper boundaries
 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
 */

/**
 * Default options provided to Popper.js constructor.<br />
 * These can be overridden using the `options` argument of Popper.js.<br />
 * To override an option, simply pass an object with the same
 * structure of the `options` object, as the 3rd argument. For example:
 * ```
 * new Popper(ref, pop, {
 *   modifiers: {
 *     preventOverflow: { enabled: false }
 *   }
 * })
 * ```
 * @type {Object}
 * @static
 * @memberof Popper
 */
var Defaults = {
  /**
   * Popper's placement.
   * @prop {Popper.placements} placement='bottom'
   */
  placement: 'bottom',

  /**
   * Set this to true if you want popper to position it self in 'fixed' mode
   * @prop {Boolean} positionFixed=false
   */
  positionFixed: false,

  /**
   * Whether events (resize, scroll) are initially enabled.
   * @prop {Boolean} eventsEnabled=true
   */
  eventsEnabled: true,

  /**
   * Set to true if you want to automatically remove the popper when
   * you call the `destroy` method.
   * @prop {Boolean} removeOnDestroy=false
   */
  removeOnDestroy: false,

  /**
   * Callback called when the popper is created.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onCreate}
   */
  onCreate: function onCreate() {},

  /**
   * Callback called when the popper is updated. This callback is not called
   * on the initialization/creation of the popper, but only on subsequent
   * updates.<br />
   * By default, it is set to no-op.<br />
   * Access Popper.js instance with `data.instance`.
   * @prop {onUpdate}
   */
  onUpdate: function onUpdate() {},

  /**
   * List of modifiers used to modify the offsets before they are applied to the popper.
   * They provide most of the functionalities of Popper.js.
   * @prop {modifiers}
   */
  modifiers: modifiers
};

/**
 * @callback onCreate
 * @param {dataObject} data
 */

/**
 * @callback onUpdate
 * @param {dataObject} data
 */

// Utils
// Methods
var Popper = function () {
  /**
   * Creates a new Popper.js instance.
   * @class Popper
   * @param {Element|referenceObject} reference - The reference element used to position the popper
   * @param {Element} popper - The HTML / XML element used as the popper
   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
   * @return {Object} instance - The generated Popper.js instance
   */
  function Popper(reference, popper) {
    var _this = this;

    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, Popper);

    this.scheduleUpdate = function () {
      return requestAnimationFrame(_this.update);
    };

    // make update() debounced, so that it only runs at most once-per-tick
    this.update = debounce(this.update.bind(this));

    // with {} we create a new object with the options inside it
    this.options = _extends({}, Popper.Defaults, options);

    // init state
    this.state = {
      isDestroyed: false,
      isCreated: false,
      scrollParents: []
    };

    // get reference and popper elements (allow jQuery wrappers)
    this.reference = reference && reference.jquery ? reference[0] : reference;
    this.popper = popper && popper.jquery ? popper[0] : popper;

    // Deep merge modifiers options
    this.options.modifiers = {};
    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
    });

    // Refactoring modifiers' list (Object => Array)
    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
      return _extends({
        name: name
      }, _this.options.modifiers[name]);
    })
    // sort the modifiers by order
    .sort(function (a, b) {
      return a.order - b.order;
    });

    // modifiers have the ability to execute arbitrary code when Popper.js get inited
    // such code is executed in the same order of its modifier
    // they could add new properties to their options configuration
    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
    this.modifiers.forEach(function (modifierOptions) {
      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
      }
    });

    // fire the first update to position the popper in the right place
    this.update();

    var eventsEnabled = this.options.eventsEnabled;
    if (eventsEnabled) {
      // setup event listeners, they will take care of update the position in specific situations
      this.enableEventListeners();
    }

    this.state.eventsEnabled = eventsEnabled;
  }

  // We can't use class properties because they don't get listed in the
  // class prototype and break stuff like Sinon stubs


  createClass(Popper, [{
    key: 'update',
    value: function update$$1() {
      return update.call(this);
    }
  }, {
    key: 'destroy',
    value: function destroy$$1() {
      return destroy.call(this);
    }
  }, {
    key: 'enableEventListeners',
    value: function enableEventListeners$$1() {
      return enableEventListeners.call(this);
    }
  }, {
    key: 'disableEventListeners',
    value: function disableEventListeners$$1() {
      return disableEventListeners.call(this);
    }

    /**
     * Schedules an update. It will run on the next UI update available.
     * @method scheduleUpdate
     * @memberof Popper
     */


    /**
     * Collection of utilities useful when writing custom modifiers.
     * Starting from version 1.7, this method is available only if you
     * include `popper-utils.js` before `popper.js`.
     *
     * **DEPRECATION**: This way to access PopperUtils is deprecated
     * and will be removed in v2! Use the PopperUtils module directly instead.
     * Due to the high instability of the methods contained in Utils, we can't
     * guarantee them to follow semver. Use them at your own risk!
     * @static
     * @private
     * @type {Object}
     * @deprecated since version 1.8
     * @member Utils
     * @memberof Popper
     */

  }]);
  return Popper;
}();

/**
 * The `referenceObject` is an object that provides an interface compatible with Popper.js
 * and lets you use it as replacement of a real DOM node.<br />
 * You can use this method to position a popper relatively to a set of coordinates
 * in case you don't have a DOM node to use as reference.
 *
 * ```
 * new Popper(referenceObject, popperNode);
 * ```
 *
 * NB: This feature isn't supported in Internet Explorer 10.
 * @name referenceObject
 * @property {Function} data.getBoundingClientRect
 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
 * @property {number} data.clientWidth
 * An ES6 getter that will return the width of the virtual reference element.
 * @property {number} data.clientHeight
 * An ES6 getter that will return the height of the virtual reference element.
 */


Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
Popper.placements = placements;
Popper.Defaults = Defaults;

/* harmony default export */ __webpack_exports__["a"] = (Popper);
//# sourceMappingURL=popper.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Radio__ = __webpack_require__(1081);
/* unused harmony reexport default */


/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__ = __webpack_require__(257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__RadioGroup_RadioGroupContext__ = __webpack_require__(437);













var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.secondary
    },

    /* Pseudo-class applied to the root element if `checked={true}`. */
    checked: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.action.disabled
      }
    }
  };
};
var defaultCheckedIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], {
  checked: true
});
var defaultIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__RadioButtonIcon__["a" /* default */], null);
var Radio = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Radio(props, ref) {
  var checkedProp = props.checked,
      classes = props.classes,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      nameProp = props.name,
      onChangeProp = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["checked", "classes", "color", "disabled", "name", "onChange"]);

  var radioGroup = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_12__RadioGroup_RadioGroupContext__["a" /* default */]);
  var checked = checkedProp;
  var onChange = Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onChangeProp, radioGroup && radioGroup.onChange);
  var name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = radioGroup.value === props.value;
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: color,
    type: "radio",
    icon: defaultIcon,
    checkedIcon: defaultCheckedIcon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(color))]),
      checked: classes.checked,
      disabled: classes.disabled
    },
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref,
    disabled: disabled
  }, other));
});
 false ? Radio.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string,

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiRadio'
})(Radio));

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__ = __webpack_require__(1083);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    root: {
      position: 'relative',
      display: 'flex',
      '&$checked $layer': {
        transform: 'scale(1)',
        transition: theme.transitions.create('transform', {
          easing: theme.transitions.easing.easeOut,
          duration: theme.transitions.duration.shortest
        })
      }
    },
    layer: {
      left: 0,
      position: 'absolute',
      transform: 'scale(0)',
      transition: theme.transitions.create('transform', {
        easing: theme.transitions.easing.easeIn,
        duration: theme.transitions.duration.shortest
      })
    },
    checked: {}
  };
};
/**
 * @ignore - internal component.
 */

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_RadioButtonUnchecked__["a" /* default */], null);

function RadioButtonIcon(props) {
  var checked = props.checked,
      classes = props.classes;
  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, checked && classes.checked)
  }, _ref, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_RadioButtonChecked__["a" /* default */], {
    className: classes.layer
  }));
}

 false ? RadioButtonIcon.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateRadioButtonIcon'
})(RadioButtonIcon));

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked'));

/***/ }),
/* 1084 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked'));

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__FormGroup__ = __webpack_require__(419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__RadioGroupContext__ = __webpack_require__(437);







var RadioGroup = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function RadioGroup(props, ref) {
  var actions = props.actions,
      children = props.children,
      name = props.name,
      valueProp = props.value,
      onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["actions", "children", "name", "value", "onChange"]);

  var rootRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(valueProp != null),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(props.defaultValue),
      valueState = _React$useState[0],
      setValue = _React$useState[1];

  var value = isControlled ? valueProp : valueState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (valueProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled RadioGroup to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled RadioGroup ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [valueProp, isControlled]);
  }

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useImperativeHandle(actions, function () {
    return {
      focus: function focus() {
        var input = rootRef.current.querySelector('input:not(:disabled):checked');

        if (!input) {
          input = rootRef.current.querySelector('input:not(:disabled)');
        }

        if (input) {
          input.focus();
        }
      }
    };
  }, []);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_5__utils_useForkRef__["a" /* default */])(ref, rootRef);

  var handleChange = function handleChange(event) {
    if (!isControlled) {
      setValue(event.target.value);
    }

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__RadioGroupContext__["a" /* default */].Provider, {
    value: {
      name: name,
      onChange: handleChange,
      value: value
    }
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__FormGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "radiogroup",
    ref: handleRef
  }, other), children));
});
 false ? RadioGroup.propTypes = {
  /**
   * @ignore
   */
  actions: PropTypes.shape({
    current: PropTypes.object
  }),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * The default `input` element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * The name used to reference the value of the control.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when a radio button is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * Value of the selected radio button. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (RadioGroup);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__RootRef__ = __webpack_require__(1087);
/* unused harmony reexport default */


/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_setRef__ = __webpack_require__(82);










/**
 * ⚠️⚠️⚠️
 * If you want the DOM element of a Material-UI component check out
 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
 * first.
 *
 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
 *
 * Helper component to allow attaching a ref to a
 * wrapped element to access the underlying DOM element.
 *
 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
 * For example:
 * ```jsx
 * import React from 'react';
 * import RootRef from '@material-ui/core/RootRef';
 *
 * function MyComponent() {
 *   const domRef = React.useRef();
 *
 *   React.useEffect(() => {
 *     console.log(domRef.current); // DOM node
 *   }, []);
 *
 *   return (
 *     <RootRef rootRef={domRef}>
 *       <SomeChildComponent />
 *     </RootRef>
 *   );
 * }
 * ```
 */

var RootRef =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_helpers_esm_inherits__["a" /* default */])(RootRef, _React$Component);

  function RootRef() {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_classCallCheck__["a" /* default */])(this, RootRef);

    return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_possibleConstructorReturn__["a" /* default */])(this, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_getPrototypeOf__["a" /* default */])(RootRef).apply(this, arguments));
  }

  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_createClass__["a" /* default */])(RootRef, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.ref = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var ref = __WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this);

      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
        if (prevProps.rootRef !== this.props.rootRef) {
          Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(prevProps.rootRef, null);
        }

        this.ref = ref;
        Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, this.ref);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.ref = null;
      Object(__WEBPACK_IMPORTED_MODULE_9__utils_setRef__["a" /* default */])(this.props.rootRef, null);
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return RootRef;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

 false ? RootRef.propTypes = {
  /**
   * The wrapped element.
   */
  children: PropTypes.element.isRequired,

  /**
   * A ref that points to the first DOM node of the wrapped element.
   */
  rootRef: refType.isRequired
} : void 0;

if (false) {
  process.env.NODE_ENV !== "production" ? RootRef.propTypes = exactProp(RootRef.propTypes) : void 0;
}

/* unused harmony default export */ var _unused_webpack_default_export = (RootRef);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _possibleConstructorReturn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__ = __webpack_require__(246);


function _possibleConstructorReturn(self, call) {
  if (call && (Object(__WEBPACK_IMPORTED_MODULE_0__helpers_esm_typeof__["a" /* default */])(call) === "object" || typeof call === "function")) {
    return call;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__assertThisInitialized__["a" /* default */])(self);
}

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _getPrototypeOf;
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inherits;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__ = __webpack_require__(1091);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_styles__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SelectInput__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__ = __webpack_require__(436);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Input__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__ = __webpack_require__(434);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__ = __webpack_require__(435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__FilledInput__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__OutlinedInput__ = __webpack_require__(265);















var styles = __WEBPACK_IMPORTED_MODULE_11__NativeSelect_NativeSelect__["a" /* styles */];

var _ref = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Input__["a" /* default */], null);

var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__FilledInput__["a" /* default */], null);

var Select = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Select(props, ref) {
  var _props$autoWidth = props.autoWidth,
      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
      children = props.children,
      classes = props.classes,
      _props$displayEmpty = props.displayEmpty,
      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__internal_svg_icons_ArrowDropDown__["a" /* default */] : _props$IconComponent,
      id = props.id,
      input = props.input,
      inputProps = props.inputProps,
      labelId = props.labelId,
      MenuProps = props.MenuProps,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$native = props.native,
      native = _props$native === void 0 ? false : _props$native,
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      renderValue = props.renderValue,
      SelectDisplayProps = props.SelectDisplayProps,
      _props$variant = props.variant,
      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
      _props$labelWidth = props.labelWidth,
      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant", "labelWidth"]);

  var inputComponent = native ? __WEBPACK_IMPORTED_MODULE_12__NativeSelect_NativeSelectInput__["a" /* default */] : __WEBPACK_IMPORTED_MODULE_5__SelectInput__["a" /* default */];
  var muiFormControl = Object(__WEBPACK_IMPORTED_MODULE_7__FormControl_useFormControl__["a" /* default */])();
  var fcs = Object(__WEBPACK_IMPORTED_MODULE_6__FormControl_formControlState__["a" /* default */])({
    props: props,
    muiFormControl: muiFormControl,
    states: ['variant']
  });
  var variant = fcs.variant || variantProps;
  var InputComponent = input || {
    standard: _ref,
    outlined: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__OutlinedInput__["a" /* default */], {
      labelWidth: labelWidth
    }),
    filled: _ref2
  }[variant];
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent: inputComponent,
    select: true,
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      children: children,
      IconComponent: IconComponent,
      variant: variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple: multiple
    }, native ? {
      id: id
    } : {
      autoWidth: autoWidth,
      displayEmpty: displayEmpty,
      labelId: labelId,
      MenuProps: MenuProps,
      onClose: onClose,
      onOpen: onOpen,
      open: open,
      renderValue: renderValue,
      SelectDisplayProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        id: id
      }, SelectDisplayProps)
    }, {}, inputProps, {
      classes: inputProps ? Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_styles__["e" /* mergeClasses */])({
        baseClasses: classes,
        newClasses: inputProps.classes,
        Component: Select
      }) : classes
    }, input ? input.props.inputProps : {}),
    ref: ref
  }, other));
});
 false ? Select.propTypes = {
  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
   *
   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, a value is displayed even if no items are selected.
   *
   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
   * You can only use it when the `native` prop is `false` (default).
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType,

  /**
   * @ignore
   */
  id: PropTypes.string,

  /**
   * An `Input` element; does not have to be a material-ui specific `Input`.
   */
  input: PropTypes.element,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   * When `native` is `true`, the attributes are applied on the `select` element.
   */
  inputProps: PropTypes.object,

  /**
   * The idea of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * The label width to be used on OutlinedInput.
   * This prop is required when the `variant` prop is `outlined`.
   */
  labelWidth: PropTypes.number,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * If `true`, the component will be using a native `select` element.
   */
  native: PropTypes.bool,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected when `native` is `false` (default).
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   * You can only use it when the `native` prop is `false` (default).
   */
  open: PropTypes.bool,

  /**
   * Render the selected value.
   * You can only use it when the `native` prop is `false` (default).
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * The input value. Providing an empty string will select no options.
   * This prop is required when the `native` prop is `false` (default).
   * Set to an empty string `''` if you don't want any of the available options to be selected.
   *
   * If the value is an object it must have reference equality with the option in order to be selected.
   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
Select.muiName = 'Select';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSelect'
})(Select));

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Menu_Menu__ = __webpack_require__(430);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputBase_utils__ = __webpack_require__(262);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__ = __webpack_require__(28);













function areEqualValues(a, b) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_typeof__["a" /* default */])(b) === 'object' && b !== null) {
    return a === b;
  }

  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}
/**
 * @ignore - internal component.
 */


var SelectInput = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function SelectInput(props, ref) {
  var autoFocus = props.autoFocus,
      autoWidth = props.autoWidth,
      children = props.children,
      classes = props.classes,
      className = props.className,
      defaultValue = props.defaultValue,
      disabled = props.disabled,
      displayEmpty = props.displayEmpty,
      labelId = props.labelId,
      IconComponent = props.IconComponent,
      inputRefProp = props.inputRef,
      _props$MenuProps = props.MenuProps,
      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
      multiple = props.multiple,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onOpen = props.onOpen,
      openProp = props.open,
      readOnly = props.readOnly,
      renderValue = props.renderValue,
      required = props.required,
      _props$SelectDisplayP = props.SelectDisplayProps,
      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
      tabIndexProp = props.tabIndex,
      type = props.type,
      valueProp = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "labelId", "IconComponent", "inputRef", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef(valueProp != null),
      isControlled = _React$useRef.current;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(defaultValue),
      valueState = _React$useState[0],
      setValueState = _React$useState[1];

  var value = isControlled ? valueProp : valueState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (valueProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Select to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Select ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [valueProp, isControlled]);
  }

  var inputRef = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef(null);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(null),
      displayNode = _React$useState2[0],
      setDisplayNode = _React$useState2[1];

  var _React$useRef2 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef(openProp != null),
      isOpenControlled = _React$useRef2.current;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(),
      menuMinWidthState = _React$useState3[0],
      setMenuMinWidthState = _React$useState3[1];

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(false),
      openState = _React$useState4[0],
      setOpenState = _React$useState4[1];

  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useForkRef__["a" /* default */])(ref, inputRefProp);
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.useImperativeHandle(handleRef, function () {
    return {
      focus: function focus() {
        displayNode.focus();
      },
      node: inputRef.current,
      value: value
    };
  }, [displayNode, value]);
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.useEffect(function () {
    if (autoFocus && displayNode) {
      displayNode.focus();
    }
  }, [autoFocus, displayNode]);

  var update = function update(open, event) {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else {
      displayNode.focus();

      if (onClose) {
        onClose(event);
      }
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  var handleClick = function handleClick(event) {
    update(true, event);
  };

  var handleClose = function handleClose(event) {
    update(false, event);
  };

  var handleItemClick = function handleItemClick(child) {
    return function (event) {
      if (!multiple) {
        update(false, event);
      }

      var newValue;

      if (multiple) {
        newValue = Array.isArray(value) ? Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value) : [];
        var itemIndex = value.indexOf(child.props.value);

        if (itemIndex === -1) {
          newValue.push(child.props.value);
        } else {
          newValue.splice(itemIndex, 1);
        }
      } else {
        newValue = child.props.value;
      }

      if (!isControlled) {
        setValueState(newValue);
      }

      if (onChange) {
        event.persist(); // Preact support, target is read only property on a native event.

        Object.defineProperty(event, 'target', {
          writable: true,
          value: {
            value: newValue,
            name: name
          }
        });
        onChange(event, child);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (!readOnly) {
      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  var open = displayNode !== null && (isOpenControlled ? openProp : openState);

  var handleBlur = function handleBlur(event) {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      event.persist(); // Preact support, target is read only property on a native event.

      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value: value,
          name: name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  var display;
  var displaySingle;
  var displayMultiple = [];
  var computeDisplay = false;
  var foundMatch = false; // No need to display any value if the field is empty.

  if (Object(__WEBPACK_IMPORTED_MODULE_10__InputBase_utils__["b" /* isFilled */])({
    value: value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  var items = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_4_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error('Material-UI: the `value` prop must be an array ' + 'when using the `Select` component with `multiple`.');
      }

      selected = value.some(function (v) {
        return areEqualValues(v, child.props.value);
      });

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    if (selected) {
      foundMatch = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      role: 'option',
      selected: selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (!foundMatch && !multiple && value !== '') {
        var values = React.Children.toArray(children).map(function (child) {
          return child.props.value;
        });
        console.warn(["Material-UI: you have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
          return x != null;
        }).map(function (x) {
          return "`".concat(x, "`");
        }).join(', ') || '""', ".")].join('\n'));
      }
    }, [foundMatch, children, multiple, name, value]);
  }

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  var menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  var tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, // TODO v5: merge root and select
    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
    ref: setDisplayNode,
    tabIndex: tabIndex,
    role: "button",
    "aria-expanded": open ? 'true' : undefined,
    "aria-labelledby": "".concat(labelId || '', " ").concat(buttonId || ''),
    "aria-haspopup": "listbox",
    onKeyDown: handleKeyDown,
    onClick: disabled || readOnly ? null : handleClick,
    onBlur: handleBlur,
    onFocus: onFocus
  }, SelectDisplayProps, {
    // The id is required for proper a11y
    id: buttonId
  }), isEmpty(display) ? // eslint-disable-next-line react/no-danger
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
    dangerouslySetInnerHTML: {
      __html: '&#8203;'
    }
  }) : display), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    value: Array.isArray(value) ? value.join(',') : value,
    name: name,
    ref: inputRef,
    type: "hidden",
    autoFocus: autoFocus
  }, other)), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.icon, classes["icon".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(variant))], open && classes.iconOpen)
  }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Menu_Menu__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: "menu-".concat(name || ''),
    anchorEl: displayNode,
    open: open,
    onClose: handleClose
  }, MenuProps, {
    MenuListProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      'aria-labelledby': labelId,
      role: 'listbox',
      disableListWrap: true
    }, MenuProps.MenuListProps),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, MenuProps.PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        minWidth: menuMinWidth
      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
    })
  }), items));
});
 false ? SelectInput.propTypes = {
  /**
   * @ignore
   */
  autoFocus: PropTypes.bool,

  /**
   * If true, the width of the popover will automatically be set according to the items inside the
   * menu, otherwise it will be at least the width of the select input.
   */
  autoWidth: PropTypes.bool,

  /**
   * The option elements to populate the select with.
   * Can be some `<MenuItem>` elements.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * The CSS class name of the select element.
   */
  className: PropTypes.string,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the select will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the selected item is displayed even if its value is empty.
   */
  displayEmpty: PropTypes.bool,

  /**
   * The icon that displays the arrow.
   */
  IconComponent: PropTypes.elementType.isRequired,

  /**
   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
   * Equivalent to `ref`
   */
  inputRef: refType,

  /**
   * The idea of an element that acts as an additional label. The Select will
   * be labelled by the additional label and the selected value.
   */
  labelId: PropTypes.string,

  /**
   * Props applied to the [`Menu`](/api/menu/) element.
   */
  MenuProps: PropTypes.object,

  /**
   * If true, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Name attribute of the `select` or hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback function fired when a menu item is selected.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (any).
   * @param {object} [child] The react element that was selected.
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * Callback fired when the component requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control `select` open state.
   */
  open: PropTypes.bool,

  /**
   * @ignore
   */
  readOnly: PropTypes.bool,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @returns {ReactNode}
   */
  renderValue: PropTypes.func,

  /**
   * @ignore
   */
  required: PropTypes.bool,

  /**
   * Props applied to the clickable div element.
   */
  SelectDisplayProps: PropTypes.object,

  /**
   * @ignore
   */
  tabIndex: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * @ignore
   */
  type: PropTypes.any,

  /**
   * The input value.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (SelectInput);

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Slider__ = __webpack_require__(1095);
/* unused harmony reexport default */


/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_focusVisible__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ValueLabel__ = __webpack_require__(1096);
















function asc(a, b) {
  return a - b;
}

function clamp(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

function findClosest(values, currentValue) {
  var _values$reduce = values.reduce(function (acc, value, index) {
    var distance = Math.abs(currentValue - value);

    if (acc === null || distance < acc.distance || distance === acc.distance) {
      return {
        distance: distance,
        index: index
      };
    }

    return acc;
  }, null),
      closestIndex = _values$reduce.index;

  return closestIndex;
}

function trackFinger(event, touchId) {
  if (touchId.current !== undefined && event.changedTouches) {
    for (var i = 0; i < event.changedTouches.length; i += 1) {
      var touch = event.changedTouches[i];

      if (touch.identifier === touchId.current) {
        return {
          x: touch.clientX,
          y: touch.clientY
        };
      }
    }

    return false;
  }

  return {
    x: event.clientX,
    y: event.clientY
  };
}

function valueToPercent(value, min, max) {
  return (value - min) * 100 / (max - min);
}

function percentToValue(percent, min, max) {
  return (max - min) * percent + min;
}

function getDecimalPrecision(num) {
  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
  if (Math.abs(num) < 1) {
    var parts = num.toExponential().split('e-');
    var matissaDecimalPart = parts[0].split('.')[1];
    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
  }

  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToStep(value, step) {
  var nearest = Math.round(value / step) * step;
  return Number(nearest.toFixed(getDecimalPrecision(step)));
}

function setValueIndex(_ref) {
  var values = _ref.values,
      source = _ref.source,
      newValue = _ref.newValue,
      index = _ref.index;

  // Performance shortcut
  if (values[index] === newValue) {
    return source;
  }

  var output = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(values);

  output[index] = newValue;
  return output;
}

function focusThumb(_ref2) {
  var sliderRef = _ref2.sliderRef,
      activeIndex = _ref2.activeIndex,
      setActive = _ref2.setActive;

  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
    sliderRef.current.querySelector("[data-index=\"".concat(activeIndex, "\"]")).focus();
  }

  if (setActive) {
    setActive(activeIndex);
  }
}

var axisProps = {
  horizontal: {
    offset: function offset(percent) {
      return {
        left: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  'horizontal-reverse': {
    offset: function offset(percent) {
      return {
        right: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        width: "".concat(percent, "%")
      };
    }
  },
  vertical: {
    offset: function offset(percent) {
      return {
        bottom: "".concat(percent, "%")
      };
    },
    leap: function leap(percent) {
      return {
        height: "".concat(percent, "%")
      };
    }
  }
};
var defaultMarks = [];

var Identity = function Identity(x) {
  return x;
};

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 2,
      width: '100%',
      boxSizing: 'content-box',
      padding: '11px 0',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      touchAction: 'none',
      color: theme.palette.primary.main,
      // Remove grey highlight
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        pointerEvents: 'none',
        cursor: 'default',
        color: theme.palette.grey[400]
      },
      '&$vertical': {
        width: 2,
        height: '100%',
        padding: '0 11px'
      },
      // The primary input mechanism of the device includes a pointing device of limited accuracy.
      '@media (pointer: coarse)': {
        // Reach 42px touch target, about ~8mm on screen.
        padding: '20px 0',
        '&$vertical': {
          padding: '0 20px'
        }
      }
    },

    /* Styles applied to the root element if `color="primary"`. */
    colorPrimary: {// TODO v5, move the style here
    },

    /* Styles applied to the root element if `color="secondary"`. */
    colorSecondary: {
      color: theme.palette.secondary.main
    },

    /* Styles applied to the root element if `marks` is provided with at least one label. */
    marked: {
      marginBottom: 20,
      '&$vertical': {
        marginBottom: 'auto',
        marginRight: 20
      }
    },

    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
    vertical: {},

    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the rail element. */
    rail: {
      display: 'block',
      position: 'absolute',
      width: '100%',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      opacity: 0.38,
      '$vertical &': {
        height: '100%',
        width: 2
      }
    },

    /* Styles applied to the track element. */
    track: {
      display: 'block',
      position: 'absolute',
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor',
      '$vertical &': {
        width: 2
      }
    },

    /* Styles applied to the track element if `track={false}`. */
    trackFalse: {
      '& $track': {
        display: 'none'
      }
    },

    /* Styles applied to the track element if `track="inverted"`. */
    trackInverted: {
      '& $track': {
        backgroundColor: // Same logic as the LinearProgress track color
        theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["e" /* lighten */])(theme.palette.primary.main, 0.62) : Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["a" /* darken */])(theme.palette.primary.main, 0.5)
      },
      '& $rail': {
        opacity: 1
      }
    },

    /* Styles applied to the thumb element. */
    thumb: {
      position: 'absolute',
      width: 12,
      height: 12,
      marginLeft: -6,
      marginTop: -5,
      boxSizing: 'border-box',
      borderRadius: '50%',
      outline: 0,
      backgroundColor: 'currentColor',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      transition: theme.transitions.create(['box-shadow'], {
        duration: theme.transitions.duration.shortest
      }),
      '&::after': {
        position: 'absolute',
        content: '""',
        // reach 48px touch target (2 * 18 + thumb circumference)
        left: -18,
        top: -18,
        right: -18,
        bottom: -18
      },
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.16)),
        '@media (hover: none)': {
          boxShadow: 'none'
        }
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, 0.16))
      },
      '&$disabled': {
        width: 8,
        height: 8,
        marginLeft: -4,
        marginTop: -3,
        '&:hover': {
          boxShadow: 'none'
        }
      },
      '$vertical &': {
        marginLeft: -5,
        marginBottom: -6
      },
      '$vertical &$disabled': {
        marginLeft: -3,
        marginBottom: -4
      }
    },

    /* Styles applied to the thumb element if `color="primary"`. */
    thumbColorPrimary: {// TODO v5, move the style here
    },

    /* Styles applied to the thumb element if `color="secondary"`. */
    thumbColorSecondary: {
      '&$focusVisible,&:hover': {
        boxShadow: "0px 0px 0px 8px ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.16))
      },
      '&$active': {
        boxShadow: "0px 0px 0px 14px ".concat(Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, 0.16))
      }
    },

    /* Pseudo-class applied to the thumb element if it's active. */
    active: {},

    /* Pseudo-class applied to the thumb element if keyboard focused. */
    focusVisible: {},

    /* Styles applied to the thumb label element. */
    valueLabel: {},

    /* Styles applied to the mark element. */
    mark: {
      position: 'absolute',
      width: 2,
      height: 2,
      borderRadius: 1,
      backgroundColor: 'currentColor'
    },

    /* Styles applied to the mark element if active (depending on the value). */
    markActive: {
      backgroundColor: theme.palette.background.paper,
      opacity: 0.8
    },

    /* Styles applied to the mark label element. */
    markLabel: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      color: theme.palette.text.secondary,
      position: 'absolute',
      top: 22,
      transform: 'translateX(-50%)',
      whiteSpace: 'nowrap',
      '$vertical &': {
        top: 'auto',
        left: 22,
        transform: 'translateY(50%)'
      },
      '@media (pointer: coarse)': {
        top: 40,
        '$vertical &': {
          left: 31
        }
      }
    }),

    /* Styles applied to the mark label element if active (depending on the value). */
    markLabelActive: {
      color: theme.palette.text.primary
    }
  };
};
var Slider = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Slider(props, ref) {
  var ariaLabel = props['aria-label'],
      ariaLabelledby = props['aria-labelledby'],
      ariaValuetext = props['aria-valuetext'],
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'span' : _props$component,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      getAriaLabel = props.getAriaLabel,
      getAriaValueText = props.getAriaValueText,
      _props$marks = props.marks,
      marksProp = _props$marks === void 0 ? defaultMarks : _props$marks,
      _props$max = props.max,
      max = _props$max === void 0 ? 100 : _props$max,
      _props$min = props.min,
      min = _props$min === void 0 ? 0 : _props$min,
      name = props.name,
      onChange = props.onChange,
      onChangeCommitted = props.onChangeCommitted,
      onMouseDown = props.onMouseDown,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$step = props.step,
      step = _props$step === void 0 ? 1 : _props$step,
      _props$ThumbComponent = props.ThumbComponent,
      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
      _props$track = props.track,
      track = _props$track === void 0 ? 'normal' : _props$track,
      valueProp = props.value,
      _props$ValueLabelComp = props.ValueLabelComponent,
      ValueLabelComponent = _props$ValueLabelComp === void 0 ? __WEBPACK_IMPORTED_MODULE_14__ValueLabel__["a" /* default */] : _props$ValueLabelComp,
      _props$valueLabelDisp = props.valueLabelDisplay,
      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
      _props$valueLabelForm = props.valueLabelFormat,
      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_8__styles_useTheme__["a" /* default */])();
  var touchId = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(); // We can't use the :active browser pseudo-classes.
  // - The active state isn't triggered when clicking on the rail.
  // - The active state isn't transfered when inversing a range slider.

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(-1),
      active = _React$useState[0],
      setActive = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(-1),
      open = _React$useState2[0],
      setOpen = _React$useState2[1];

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(valueProp != null),
      isControlled = _React$useRef.current;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(defaultValue),
      valueState = _React$useState3[0],
      setValueState = _React$useState3[1];

  var valueDerived = isControlled ? valueProp : valueState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (valueProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Slider to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Slider ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [valueProp, isControlled]);
  }

  var range = Array.isArray(valueDerived);
  var instanceRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var values = range ? Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(valueDerived).sort(asc) : [valueDerived];
  values = values.map(function (value) {
    return clamp(value, min, max);
  });
  var marks = marksProp === true && step !== null ? Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
    return {
      value: min + step * index
    };
  }) : marksProp;
  instanceRef.current = {
    source: valueDerived // Keep track of the input value to leverage immutable state comparison.

  };

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_10__utils_focusVisible__["a" /* useIsFocusVisible */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(-1),
      focusVisible = _React$useState4[0],
      setFocusVisible = _React$useState4[1];

  var sliderRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useForkRef__["a" /* default */])(focusVisibleRef, sliderRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_12__utils_useForkRef__["a" /* default */])(ref, handleFocusRef);
  var handleFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));

    if (isFocusVisible(event)) {
      setFocusVisible(index);
    }

    setOpen(index);
  });
  var handleBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function () {
    if (focusVisible !== -1) {
      setFocusVisible(-1);
      onBlurVisible();
    }

    setOpen(-1);
  });
  var handleMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    setOpen(index);
  });
  var handleMouseLeave = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function () {
    setOpen(-1);
  });
  var handleKeyDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    var index = Number(event.currentTarget.getAttribute('data-index'));
    var value = values[index];
    var tenPercents = (max - min) / 10;
    var marksValues = marks.map(function (mark) {
      return mark.value;
    });
    var marksIndex = marksValues.indexOf(value);
    var newValue;

    switch (event.key) {
      case 'Home':
        newValue = min;
        break;

      case 'End':
        newValue = max;
        break;

      case 'PageUp':
        if (step) {
          newValue = value + tenPercents;
        }

        break;

      case 'PageDown':
        if (step) {
          newValue = value - tenPercents;
        }

        break;

      case 'ArrowRight':
      case 'ArrowUp':
        if (step) {
          newValue = value + step;
        } else {
          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
        }

        break;

      case 'ArrowLeft':
      case 'ArrowDown':
        if (step) {
          newValue = value - step;
        } else {
          newValue = marksValues[marksIndex - 1] || marksValues[0];
        }

        break;

      default:
        return;
    } // Prevent scroll of the page


    event.preventDefault();

    if (step) {
      newValue = roundValueToStep(newValue, step);
    }

    newValue = clamp(newValue, min, max);

    if (range) {
      var previousValue = newValue;
      newValue = setValueIndex({
        values: values,
        source: valueDerived,
        newValue: newValue,
        index: index
      }).sort(asc);
      focusThumb({
        sliderRef: sliderRef,
        activeIndex: newValue.indexOf(previousValue)
      });
    }

    if (!isControlled) {
      setValueState(newValue);
    }

    setFocusVisible(index);

    if (onChange) {
      onChange(event, newValue);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }
  });
  var previousIndex = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var axis = orientation;

  if (theme.direction === 'rtl' && orientation !== "vertical") {
    axis += '-reverse';
  }

  var getFingerNewValue = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (_ref3) {
    var finger = _ref3.finger,
        _ref3$move = _ref3.move,
        move = _ref3$move === void 0 ? false : _ref3$move,
        values2 = _ref3.values,
        source = _ref3.source;
    var slider = sliderRef.current;

    var _slider$getBoundingCl = slider.getBoundingClientRect(),
        width = _slider$getBoundingCl.width,
        height = _slider$getBoundingCl.height,
        bottom = _slider$getBoundingCl.bottom,
        left = _slider$getBoundingCl.left;

    var percent;

    if (axis.indexOf('vertical') === 0) {
      percent = (bottom - finger.y) / height;
    } else {
      percent = (finger.x - left) / width;
    }

    if (axis.indexOf('-reverse') !== -1) {
      percent = 1 - percent;
    }

    var newValue;
    newValue = percentToValue(percent, min, max);

    if (step) {
      newValue = roundValueToStep(newValue, step);
    } else {
      var marksValues = marks.map(function (mark) {
        return mark.value;
      });
      var closestIndex = findClosest(marksValues, newValue);
      newValue = marksValues[closestIndex];
    }

    newValue = clamp(newValue, min, max);
    var activeIndex = 0;

    if (range) {
      if (!move) {
        activeIndex = findClosest(values2, newValue);
      } else {
        activeIndex = previousIndex.current;
      }

      var previousValue = newValue;
      newValue = setValueIndex({
        values: values2,
        source: source,
        newValue: newValue,
        index: activeIndex
      }).sort(asc);
      activeIndex = newValue.indexOf(previousValue);
      previousIndex.current = activeIndex;
    }

    return {
      newValue: newValue,
      activeIndex: activeIndex
    };
  }, [max, min, axis, range, step, marks]);
  var handleTouchMove = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue = getFingerNewValue({
      finger: finger,
      move: true,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue.newValue,
        activeIndex = _getFingerNewValue.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });

    if (!isControlled) {
      setValueState(newValue);
    }

    if (onChange) {
      onChange(event, newValue);
    }
  });
  var handleTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    var finger = trackFinger(event, touchId);

    if (!finger) {
      return;
    }

    var _getFingerNewValue2 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue2.newValue;

    setActive(-1);

    if (event.type === 'touchend') {
      setOpen(-1);
    }

    if (onChangeCommitted) {
      onChangeCommitted(event, newValue);
    }

    touchId.current = undefined;
    document.body.removeEventListener('mousemove', handleTouchMove);
    document.body.removeEventListener('mouseup', handleTouchEnd); // eslint-disable-next-line no-use-before-define

    document.body.removeEventListener('mouseenter', handleMouseEnter);
    document.body.removeEventListener('touchmove', handleTouchMove);
    document.body.removeEventListener('touchend', handleTouchEnd);
  });
  var handleMouseEnter = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    // If the slider was being interacted with but the mouse went off the window
    // and then re-entered while unclicked then end the interaction.
    if (event.buttons === 0) {
      handleTouchEnd(event);
    }
  });
  var handleTouchStart = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    // Workaround as Safari has partial support for touchAction: 'none'.
    event.preventDefault();
    var touch = event.changedTouches[0];

    if (touch != null) {
      // A number that uniquely identifies the current finger in the touch session.
      touchId.current = touch.identifier;
    }

    var finger = trackFinger(event, touchId);

    var _getFingerNewValue3 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue3.newValue,
        activeIndex = _getFingerNewValue3.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });

    if (!isControlled) {
      setValueState(newValue);
    }

    if (onChange) {
      onChange(event, newValue);
    }

    document.body.addEventListener('touchmove', handleTouchMove);
    document.body.addEventListener('touchend', handleTouchEnd);
  });
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    var slider = sliderRef.current;
    slider.addEventListener('touchstart', handleTouchStart);
    return function () {
      slider.removeEventListener('touchstart', handleTouchStart);
      document.body.removeEventListener('mousemove', handleTouchMove);
      document.body.removeEventListener('mouseup', handleTouchEnd);
      document.body.removeEventListener('mouseenter', handleMouseEnter);
      document.body.removeEventListener('touchmove', handleTouchMove);
      document.body.removeEventListener('touchend', handleTouchEnd);
    };
  }, [handleMouseEnter, handleTouchEnd, handleTouchMove, handleTouchStart]);

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (valueProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Slider to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Slider ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [valueProp, isControlled]);
  }

  var handleMouseDown = Object(__WEBPACK_IMPORTED_MODULE_11__utils_useEventCallback__["a" /* default */])(function (event) {
    if (onMouseDown) {
      onMouseDown(event);
    }

    event.preventDefault();
    var finger = trackFinger(event, touchId);

    var _getFingerNewValue4 = getFingerNewValue({
      finger: finger,
      values: values,
      source: valueDerived
    }),
        newValue = _getFingerNewValue4.newValue,
        activeIndex = _getFingerNewValue4.activeIndex;

    focusThumb({
      sliderRef: sliderRef,
      activeIndex: activeIndex,
      setActive: setActive
    });

    if (!isControlled) {
      setValueState(newValue);
    }

    if (onChange) {
      onChange(event, newValue);
    }

    document.body.addEventListener('mousemove', handleTouchMove);
    document.body.addEventListener('mouseenter', handleMouseEnter);
    document.body.addEventListener('mouseup', handleTouchEnd);
  });
  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;

  var trackStyle = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, axisProps[axis].offset(trackOffset), {}, axisProps[axis].leap(trackLeap));

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_13__utils_capitalize__["a" /* default */])(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
      return mark.label;
    }) && classes.marked, track === false && classes.trackFalse, {
      vertical: classes.vertical
    }[orientation], {
      inverted: classes.trackInverted
    }[track]),
    onMouseDown: handleMouseDown
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: classes.rail
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: classes.track,
    style: trackStyle
  }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("input", {
    value: values.join(','),
    name: name,
    type: "hidden"
  }), marks.map(function (mark) {
    var percent = valueToPercent(mark.value, min, max);
    var style = axisProps[axis].offset(percent);
    var markActive;

    if (track === false) {
      markActive = values.indexOf(mark.value) !== -1;
    } else {
      var isMarkActive = range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0];
      markActive = isMarkActive && track === 'normal' || !isMarkActive && track === 'inverted';
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, {
      key: mark.value
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      style: style,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.mark, markActive && classes.markActive)
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
      "aria-hidden": true,
      style: style,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.markLabel, markActive && classes.markLabelActive)
    }, mark.label));
  }), values.map(function (value, index) {
    var percent = valueToPercent(value, min, max);
    var style = axisProps[axis].offset(percent);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ValueLabelComponent, {
      key: index,
      valueLabelFormat: valueLabelFormat,
      valueLabelDisplay: valueLabelDisplay,
      className: classes.valueLabel,
      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(value, index) : valueLabelFormat,
      index: index,
      open: open === index || active === index || valueLabelDisplay === 'on',
      disabled: disabled
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ThumbComponent, {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.thumb, classes["thumbColor".concat(Object(__WEBPACK_IMPORTED_MODULE_13__utils_capitalize__["a" /* default */])(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
      tabIndex: disabled ? null : 0,
      role: "slider",
      style: style,
      "data-index": index,
      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
      "aria-labelledby": ariaLabelledby,
      "aria-orientation": orientation,
      "aria-valuemax": max,
      "aria-valuemin": min,
      "aria-valuenow": value,
      "aria-valuetext": getAriaValueText ? getAriaValueText(value, index) : ariaValuetext,
      onKeyDown: handleKeyDown,
      onFocus: handleFocus,
      onBlur: handleBlur,
      onMouseOver: handleMouseOver,
      onMouseLeave: handleMouseLeave
    }));
  }));
});
 false ? Slider.propTypes = {
  /**
   * The label of the slider.
   */
  'aria-label': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-label'] != null) {
      return new Error('Material-UI: you need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
    }

    return null;
  }),

  /**
   * The id of the element containing a label for the slider.
   */
  'aria-labelledby': PropTypes.string,

  /**
   * A string value that provides a user-friendly name for the current value of the slider.
   */
  'aria-valuetext': chainPropTypes(PropTypes.string, function (props) {
    var range = Array.isArray(props.value || props.defaultValue);

    if (range && props['aria-valuetext'] != null) {
      return new Error('Material-UI: you need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
    }

    return null;
  }),

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * The default element value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * If `true`, the slider will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
   *
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaLabel: PropTypes.func,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
   *
   * @param {number} value The thumb label's value to format.
   * @param {number} index The thumb label's index to format.
   * @returns {string}
   */
  getAriaValueText: PropTypes.func,

  /**
   * Marks indicate predetermined values to which the user can move the slider.
   * If `true` the marks will be spaced according the value of the `step` prop.
   * If an array, it should contain objects with `value` and an optional `label` keys.
   */
  marks: PropTypes.oneOfType([PropTypes.bool, PropTypes.array]),

  /**
   * The maximum allowed value of the slider.
   * Should not be equal to min.
   */
  max: PropTypes.number,

  /**
   * The minimum allowed value of the slider.
   * Should not be equal to max.
   */
  min: PropTypes.number,

  /**
   * Name attribute of the hidden `input` element.
   */
  name: PropTypes.string,

  /**
   * Callback function that is fired when the slider's value changed.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the `mouseup` is triggered.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value The new value.
   */
  onChangeCommitted: PropTypes.func,

  /**
   * @ignore
   */
  onMouseDown: PropTypes.func,

  /**
   * The slider orientation.
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The granularity with which the slider can step through values. (A "discrete" slider.)
   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
   */
  step: PropTypes.number,

  /**
   * The component used to display the value label.
   */
  ThumbComponent: PropTypes.elementType,

  /**
   * The track presentation:
   *
   * - `normal` the track will render a bar representing the slider value.
   * - `inverted` the track will render a bar representing the remaining slider value.
   * - `false` the track will render without a bar.
   */
  track: PropTypes.oneOf(['normal', false, 'inverted']),

  /**
   * The value of the slider.
   * For ranged sliders, provide an array with two values.
   */
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.arrayOf(PropTypes.number)]),

  /**
   * The value label component.
   */
  ValueLabelComponent: PropTypes.elementType,

  /**
   * Controls when the value label is displayed:
   *
   * - `auto` the value label will display when the thumb is hovered or focused.
   * - `on` will display persistently.
   * - `off` will never display.
   */
  valueLabelDisplay: PropTypes.oneOf(['on', 'auto', 'off']),

  /**
   * The format function the value label's value.
   *
   * When a function is provided, it should have the following signature:
   *
   * - {number} value The value label's value to format
   * - {number} index The value label's index to format
   */
  valueLabelFormat: PropTypes.oneOfType([PropTypes.string, PropTypes.func])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSlider'
})(Slider));

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__styles_withStyles__ = __webpack_require__(5);





var styles = function styles(theme) {
  return {
    thumb: {
      '&$open': {
        '& $offset': {
          transform: 'scale(1) translateY(-10px)'
        }
      }
    },
    open: {},
    offset: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      zIndex: 1
    }, theme.typography.body2, {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.2,
      transition: theme.transitions.create(['transform'], {
        duration: theme.transitions.duration.shortest
      }),
      top: -34,
      left: 'calc(-50% + -4px)',
      transformOrigin: 'bottom center',
      transform: 'scale(0)',
      position: 'absolute'
    }),
    circle: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 32,
      height: 32,
      borderRadius: '50% 50% 50% 0',
      backgroundColor: 'currentColor',
      transform: 'rotate(-45deg)'
    },
    label: {
      color: theme.palette.primary.contrastText,
      transform: 'rotate(45deg)'
    }
  };
};
/**
 * @ignore - internal component.
 */


function ValueLabel(props) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      open = props.open,
      value = props.value,
      valueLabelDisplay = props.valueLabelDisplay;

  if (valueLabelDisplay === 'off') {
    return children;
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.cloneElement(children, {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.offset, className)
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: classes.circle
  }, __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("span", {
    className: classes.label
  }, value))));
}

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateValueLabel'
})(ValueLabel));

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Snackbar__ = __webpack_require__(1098);
/* unused harmony reexport default */


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__ = __webpack_require__(413);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grow__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SnackbarContent__ = __webpack_require__(439);













var styles = function styles(theme) {
  var top1 = {
    top: 8
  };
  var bottom1 = {
    bottom: 8
  };
  var right = {
    justifyContent: 'flex-end'
  };
  var left = {
    justifyContent: 'flex-start'
  };
  var top3 = {
    top: 24
  };
  var bottom3 = {
    bottom: 24
  };
  var right3 = {
    right: 24
  };
  var left3 = {
    left: 24
  };
  var center = {
    left: '50%',
    right: 'auto',
    transform: 'translateX(-50%)'
  };
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.snackbar,
      position: 'fixed',
      display: 'flex',
      left: 8,
      right: 8,
      justifyContent: 'center',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
    anchorOriginTopCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top3, {}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
    anchorOriginBottomCenter: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom3, {}, center))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
    anchorOriginTopRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, {}, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, top3, {}, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
    anchorOriginBottomRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, {}, right, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      left: 'auto'
    }, bottom3, {}, right3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
    anchorOriginTopLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, top1, {}, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, top3, {}, left3))),

    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
    anchorOriginBottomLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, bottom1, {}, left, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.up('sm'), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      right: 'auto'
    }, bottom3, {}, left3)))
  };
};
var Snackbar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Snackbar(props, ref) {
  var action = props.action,
      _props$anchorOrigin = props.anchorOrigin;
  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
    vertical: 'bottom',
    horizontal: 'center'
  } : _props$anchorOrigin;

  var vertical = _props$anchorOrigin.vertical,
      horizontal = _props$anchorOrigin.horizontal,
      autoHideDuration = props.autoHideDuration,
      children = props.children,
      classes = props.classes,
      className = props.className,
      ClickAwayListenerProps = props.ClickAwayListenerProps,
      ContentProps = props.ContentProps,
      _props$disableWindowB = props.disableWindowBlurListener,
      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
      message = props.message,
      onClose = props.onClose,
      onEnter = props.onEnter,
      onEntered = props.onEntered,
      onEntering = props.onEntering,
      onExit = props.onExit,
      onExited = props.onExited,
      onExiting = props.onExiting,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      open = props.open,
      resumeHideDuration = props.resumeHideDuration,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_11__Grow__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].enteringScreen,
    exit: __WEBPACK_IMPORTED_MODULE_7__styles_transitions__["b" /* duration */].leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var timerAutoHide = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(true),
      exited = _React$useState[0],
      setExited = _React$useState[1]; // Timer that controls delay before snackbar auto hides


  var setAutoHideTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (autoHideDurationParam) {
    var autoHideDurationBefore = autoHideDurationParam != null ? autoHideDurationParam : autoHideDuration;

    if (!onClose || autoHideDurationBefore == null) {
      return;
    }

    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      var autoHideDurationAfter = autoHideDurationParam != null ? autoHideDurationParam : autoHideDuration;

      if (!onClose || autoHideDurationAfter == null) {
        return;
      }

      onClose(null, 'timeout');
    }, autoHideDurationBefore);
  }, [autoHideDuration, onClose]);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    if (open) {
      setAutoHideTimer();
    }

    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
  // or when the user hide the window.

  var handlePause = function handlePause() {
    clearTimeout(timerAutoHide.current);
  }; // Restart the timer when the user is no longer interacting with the Snackbar
  // or when the window is shown back.


  var handleResume = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function () {
    if (autoHideDuration != null) {
      if (resumeHideDuration != null) {
        setAutoHideTimer(resumeHideDuration);
        return;
      }

      setAutoHideTimer(autoHideDuration * 0.5);
    }
  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);

  var handleMouseEnter = function handleMouseEnter(event) {
    if (onMouseEnter) {
      onMouseEnter(event);
    }

    handlePause();
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    handleResume();
  };

  var handleClickAway = function handleClickAway(event) {
    if (onClose) {
      onClose(event, 'clickaway');
    }
  };

  var handleExited = function handleExited() {
    setExited(true);
  };

  var handleEnter = function handleEnter() {
    setExited(false);
  };

  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    if (!disableWindowBlurListener && open) {
      window.addEventListener('focus', handleResume);
      window.addEventListener('blur', handlePause);
      return function () {
        window.removeEventListener('focus', handleResume);
        window.removeEventListener('blur', handlePause);
      };
    }

    return undefined;
  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.

  if (!open && exited) {
    return null;
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ClickAwayListener__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClickAway: handleClickAway
  }, ClickAwayListenerProps), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchorOrigin".concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(vertical)).concat(Object(__WEBPACK_IMPORTED_MODULE_9__utils_capitalize__["a" /* default */])(horizontal))], className),
    onMouseEnter: handleMouseEnter,
    onMouseLeave: handleMouseLeave,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: open,
    onEnter: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleEnter, onEnter),
    onEntered: onEntered,
    onEntering: onEntering,
    onExit: onExit,
    onExited: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(handleExited, onExited),
    onExiting: onExiting,
    timeout: transitionDuration,
    direction: vertical === 'top' ? 'down' : 'up'
  }, TransitionProps), children || __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SnackbarContent__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    message: message,
    action: action
  }, ContentProps)))));
});
 false ? Snackbar.propTypes = {
  /**
   * The action to display.
   */
  action: PropTypes.node,

  /**
   * The anchor of the `Snackbar`.
   */
  anchorOrigin: PropTypes.shape({
    horizontal: PropTypes.oneOf(['left', 'center', 'right']).isRequired,
    vertical: PropTypes.oneOf(['top', 'bottom']).isRequired
  }),

  /**
   * The number of milliseconds to wait before automatically calling the
   * `onClose` function. `onClose` should then set the state of the `open`
   * prop to hide the Snackbar. This behavior is disabled by default with
   * the `null` value.
   */
  autoHideDuration: PropTypes.number,

  /**
   * Replace the `SnackbarContent` component.
   */
  children: PropTypes.element,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Props applied to the `ClickAwayListener` element.
   */
  ClickAwayListenerProps: PropTypes.object,

  /**
   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
   */
  ContentProps: PropTypes.object,

  /**
   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
   */
  disableWindowBlurListener: PropTypes.bool,

  /**
   * When displaying multiple consecutive Snackbars from a parent rendering a single
   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
   * features such as autoHideDuration may be canceled.
   */
  key: PropTypes.any,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * Callback fired when the component requests to be closed.
   * Typically `onClose` is used to set state in the parent component,
   * which is used to control the `Snackbar` `open` prop.
   * The `reason` parameter can optionally be used to control the response to `onClose`,
   * for example ignoring `clickaway`.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired before the transition is entering.
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired when the transition has entered.
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired when the transition is entering.
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired before the transition is exiting.
   */
  onExit: PropTypes.func,

  /**
   * Callback fired when the transition has exited.
   */
  onExited: PropTypes.func,

  /**
   * Callback fired when the transition is exiting.
   */
  onExiting: PropTypes.func,

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * If true, `Snackbar` is open.
   */
  open: PropTypes.bool,

  /**
   * The number of milliseconds to wait before dismissing after user interaction.
   * If `autoHideDuration` prop isn't specified, it does nothing.
   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
   * we default to `autoHideDuration / 2` ms.
   */
  resumeHideDuration: PropTypes.number,

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  flip: false,
  name: 'MuiSnackbar'
})(Snackbar));

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__ = __webpack_require__(36);










var styles = function styles(theme) {
  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
  var backgroundColor = Object(__WEBPACK_IMPORTED_MODULE_9__styles_colorManipulator__["b" /* emphasize */])(theme.palette.background.default, emphasis);
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      color: theme.palette.getContrastText(backgroundColor),
      backgroundColor: backgroundColor,
      display: 'flex',
      alignItems: 'center',
      flexWrap: 'wrap',
      padding: '6px 16px',
      borderRadius: theme.shape.borderRadius,
      flexGrow: 1
    }, theme.breakpoints.up('sm'), {
      flexGrow: 'initial',
      minWidth: 288
    }),

    /* Styles applied to the message wrapper element. */
    message: {
      padding: '8px 0'
    },

    /* Styles applied to the action wrapper element if `action` is provided. */
    action: {
      display: 'flex',
      alignItems: 'center',
      marginLeft: 'auto',
      paddingLeft: 16,
      marginRight: -8
    }
  };
};
var SnackbarContent = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function SnackbarContent(props, ref) {
  var action = props.action,
      classes = props.classes,
      className = props.className,
      message = props.message,
      _props$role = props.role,
      role = _props$role === void 0 ? 'alert' : _props$role,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "classes", "className", "message", "role"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: __WEBPACK_IMPORTED_MODULE_8__Typography__["a" /* default */],
    variant: "body2",
    variantMapping: {
      body1: 'div',
      body2: 'div'
    },
    role: role,
    square: true,
    elevation: 6,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.message
  }, message), action ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.action
  }, action) : null);
});
 false ? SnackbarContent.propTypes = {
  /**
   * The action to display.
   */
  action: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The message to display.
   */
  message: PropTypes.node,

  /**
   * The role of the SnackbarContent. If the Snackbar requires focus
   * to be closed, the `alertdialog` role should be used instead.
   */
  role: PropTypes.oneOf(['alert', 'alertdialog'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSnackbarContent'
})(SnackbarContent));

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Step__ = __webpack_require__(1101);
/* unused harmony reexport default */


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    paddingLeft: 8,
    paddingRight: 8
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {},

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    flex: 1,
    position: 'relative'
  },

  /* Pseudo-class applied to the root element if `completed={true}`. */
  completed: {}
};
var Step = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Step(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      connector = props.connector,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      index = props.index,
      last = props.last,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "index", "last", "orientation"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
    ref: ref
  }, other), connector && alternativeLabel && index !== 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(connector, {
    orientation: orientation,
    alternativeLabel: alternativeLabel,
    index: index,
    active: active,
    completed: completed,
    disabled: disabled
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      active: active,
      alternativeLabel: alternativeLabel,
      completed: completed,
      disabled: disabled,
      last: last,
      icon: index + 1,
      orientation: orientation
    }, child.props));
  }));
});
 false ? Step.propTypes = {
  /**
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   * Passed down from Stepper if alternativeLabel is also set.
   */
  connector: PropTypes.element,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepButton` is a child of `Step`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   * Used internally for numbering.
   */
  index: PropTypes.number,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStep'
})(Step));

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepButton__ = __webpack_require__(1103);
/* unused harmony reexport default */


/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepLabel__ = __webpack_require__(440);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__ = __webpack_require__(141);









var styles = {
  /* Styles applied to the root element. */
  root: {
    width: '100%',
    padding: '24px 16px',
    margin: '-24px -16px',
    boxSizing: 'content-box'
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {},

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    justifyContent: 'flex-start',
    padding: '8px',
    margin: '-8px'
  },

  /* Styles applied to the `ButtonBase` touch-ripple. */
  touchRipple: {
    color: 'rgba(0, 0, 0, 0.3)'
  }
};
var StepButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StepButton(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "icon", "last", "optional", "orientation"]);

  var childProps = {
    active: active,
    alternativeLabel: alternativeLabel,
    completed: completed,
    disabled: disabled,
    icon: icon,
    optional: optional,
    orientation: orientation
  };
  var child = Object(__WEBPACK_IMPORTED_MODULE_8__utils_isMuiElement__["a" /* default */])(children, ['StepLabel']) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, childProps) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StepLabel__["a" /* default */], childProps, children);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    disabled: disabled,
    TouchRippleProps: {
      className: classes.touchRipple
    },
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className),
    ref: ref
  }, other), child);
});
 false ? StepButton.propTypes = {
  /**
   * @ignore
   * Passed in via `Step` - passed through to `StepLabel`.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Sets completed styling. Is passed to StepLabel.
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   * Disables the button and sets disabled styling. Is passed to StepLabel.
   */
  disabled: PropTypes.bool,

  /**
   * The icon displayed by the step label.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepButton'
})(StepButton));

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepIcon__ = __webpack_require__(441);








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex',
      alignItems: 'center',
      '&$alternativeLabel': {
        flexDirection: 'column'
      },
      '&$disabled': {
        cursor: 'default'
      }
    },

    /* Styles applied to the root element if `orientation="horizontal". */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical". */
    vertical: {},

    /* Styles applied to the `Typography` component which wraps `children`. */
    label: {
      color: theme.palette.text.secondary,
      '&$active': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$completed': {
        color: theme.palette.text.primary,
        fontWeight: 500
      },
      '&$alternativeLabel': {
        textAlign: 'center',
        marginTop: 16
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
    error: {},

    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the `icon` container element. */
    iconContainer: {
      flexShrink: 0,
      // Fix IE 11 issue
      display: 'flex',
      paddingRight: 8,
      '&$alternativeLabel': {
        paddingRight: 0
      }
    },

    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
    alternativeLabel: {},

    /* Styles applied to the container element which wraps `Typography` and `optional`. */
    labelContainer: {
      width: '100%'
    }
  };
};
var StepLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StepLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      icon = props.icon,
      last = props.last,
      optional = props.optional,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      StepIconComponentProp = props.StepIconComponent,
      StepIconProps = props.StepIconProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);

  var StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = __WEBPACK_IMPORTED_MODULE_7__StepIcon__["a" /* default */];
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
    ref: ref
  }, other), icon || StepIconComponent ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(StepIconComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    completed: completed,
    active: active,
    error: error,
    icon: icon
  }, StepIconProps))) : null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.labelContainer
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Typography__["a" /* default */], {
    variant: "body2",
    component: "span",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error),
    display: "block"
  }, children), optional));
});
 false ? StepLabel.propTypes = {
  /**
   * @ignore
   * Sets the step as active. Is passed to child components.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Stepper when it's supplied with the alternativeLabel prop.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * In most cases will simply be a string containing a title for the label.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as disabled, will also disable the button if
   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
   */
  disabled: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * Override the default label of the step icon.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * The optional node to display.
   */
  optional: PropTypes.node,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component to render in place of the [`StepIcon`](/api/step-icon/).
   */
  StepIconComponent: PropTypes.elementType,

  /**
   * Props applied to the [`StepIcon`](/api/step-icon/) element.
   */
  StepIconProps: PropTypes.object
} : void 0;
StepLabel.muiName = 'StepLabel';
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepLabel'
})(StepLabel));

/***/ }),
/* 1105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SvgIcon__ = __webpack_require__(116);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      color: theme.palette.text.disabled,
      '&$active': {
        color: theme.palette.primary.main
      },
      '&$completed': {
        color: theme.palette.primary.main
      },
      '&$error': {
        color: theme.palette.error.main
      }
    },

    /* Styles applied to the SVG text element. */
    text: {
      fill: theme.palette.primary.contrastText,
      fontSize: theme.typography.caption.fontSize,
      fontFamily: theme.typography.fontFamily
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `error={true}`. */
    error: {}
  };
};

var _ref = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "12"
});

var StepIcon = __WEBPACK_IMPORTED_MODULE_0_react___default.a.forwardRef(function StepIcon(props, ref) {
  var _props$completed = props.completed,
      completed = _props$completed === void 0 ? false : _props$completed,
      icon = props.icon,
      _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      classes = props.classes;

  if (typeof icon === 'number' || typeof icon === 'string') {
    if (error) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_Warning__["a" /* default */], {
        className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, classes.error),
        ref: ref
      });
    }

    if (completed) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__internal_svg_icons_CheckCircle__["a" /* default */], {
        className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, classes.completed),
        ref: ref
      });
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__SvgIcon__["default"], {
      className: Object(__WEBPACK_IMPORTED_MODULE_2_clsx__["a" /* default */])(classes.root, active && classes.active),
      ref: ref
    }, _ref, __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text", {
      className: classes.text,
      x: "12",
      y: "16",
      textAnchor: "middle"
    }, icon));
  }

  return icon;
});
 false ? StepIcon.propTypes = {
  /**
   * Whether this step is active.
   */
  active: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * Mark the step as completed. Is passed to child components.
   */
  completed: PropTypes.bool,

  /**
   * Mark the step as failed.
   */
  error: PropTypes.bool,

  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepIcon'
})(StepIcon));

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle'));

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning'));

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      flex: '1 1 auto'
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    horizontal: {},

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      marginLeft: 12,
      // half icon
      padding: '0 0 8px'
    },

    /* Styles applied to the root element if `alternativeLabel={true}`. */
    alternativeLabel: {
      position: 'absolute',
      top: 8 + 4,
      left: 'calc(-50% + 20px)',
      right: 'calc(50% + 20px)'
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Pseudo-class applied to the root element if `completed={true}`. */
    completed: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Styles applied to the line element. */
    line: {
      display: 'block',
      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
    },

    /* Styles applied to the root element if `orientation="horizontal"`. */
    lineHorizontal: {
      borderTopStyle: 'solid',
      borderTopWidth: 1
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    lineVertical: {
      borderLeftStyle: 'solid',
      borderLeftWidth: 1,
      minHeight: 24
    }
  };
};
var StepConnector = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StepConnector(props, ref) {
  var active = props.active,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      disabled = props.disabled,
      index = props.index,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.line, orientation === 'vertical' ? classes.lineVertical : classes.lineHorizontal)
  }));
});
 false ? StepConnector.propTypes = {
  /**
   * @ignore
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel property.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   */
  disabled: PropTypes.bool,

  /**
   * @ignore
   */
  index: PropTypes.number,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepConnector'
})(StepConnector));

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__StepContent__ = __webpack_require__(1110);
/* unused harmony reexport default */


/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      marginTop: 8,
      marginLeft: 12,
      // half icon
      paddingLeft: 8 + 12,
      // margin + half icon
      paddingRight: 8,
      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
    },

    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
    last: {
      borderLeft: 'none'
    },

    /* Styles applied to the Transition component. */
    transition: {}
  };
};
var StepContent = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function StepContent(props, ref) {
  var active = props.active,
      alternativeLabel = props.alternativeLabel,
      children = props.children,
      classes = props.classes,
      className = props.className,
      completed = props.completed,
      last = props.last,
      optional = props.optional,
      orientation = props.orientation,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  if (false) {
    if (orientation !== 'vertical') {
      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
    }
  }

  var transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, last && classes.last),
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: active,
    className: classes.transition,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), children));
});
 false ? StepContent.propTypes = {
  /**
   * @ignore
   * Expands the content.
   */
  active: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the alternativeLabel prop.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Step content.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  completed: PropTypes.bool,

  /**
   * @ignore
   */
  last: PropTypes.bool,

  /**
   * @ignore
   * Set internally by Step when it's supplied with the optional prop.
   */
  optional: PropTypes.bool,

  /**
   * @ignore
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Adjust the duration of the content expand transition.
   * Passed as a prop to the transition component.
   *
   * Set to 'auto' to automatically calculate transition time based on height.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  }), PropTypes.oneOf(['auto'])]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepContent'
})(StepContent));

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Stepper__ = __webpack_require__(1112);
/* unused harmony reexport default */


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StepConnector__ = __webpack_require__(442);








var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'flex',
    padding: 24
  },

  /* Styles applied to the root element if `orientation="horizontal"`. */
  horizontal: {
    flexDirection: 'row',
    alignItems: 'center'
  },

  /* Styles applied to the root element if `orientation="vertical"`. */
  vertical: {
    flexDirection: 'column'
  },

  /* Styles applied to the root element if `alternativeLabel={true}`. */
  alternativeLabel: {
    alignItems: 'flex-start'
  }
};
var defaultConnector = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__StepConnector__["a" /* default */], null);
var Stepper = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Stepper(props, ref) {
  var _props$activeStep = props.activeStep,
      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
      _props$alternativeLab = props.alternativeLabel,
      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$connector = props.connector,
      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
      _props$nonLinear = props.nonLinear,
      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);

  var connector = __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(connectorProp) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(connectorProp, {
    orientation: orientation
  }) : null;
  var childrenArray = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(children);
  var steps = childrenArray.map(function (step, index) {
    var controlProps = {
      alternativeLabel: alternativeLabel,
      connector: connectorProp,
      last: index + 1 === childrenArray.length,
      orientation: orientation
    };
    var state = {
      index: index,
      active: false,
      completed: false,
      disabled: false
    };

    if (activeStep === index) {
      state.active = true;
    } else if (!nonLinear && activeStep > index) {
      state.completed = true;
    } else if (!nonLinear && activeStep < index) {
      state.disabled = true;
    }

    return [!alternativeLabel && connector && index !== 0 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(connector, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      key: index
    }, state)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(step, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, controlProps, {}, state, {}, step.props))];
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Paper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    square: true,
    elevation: 0,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
    ref: ref
  }, other), steps);
});
 false ? Stepper.propTypes = {
  /**
   * Set the active step (zero based index).
   */
  activeStep: PropTypes.number,

  /**
   * If set to 'true' and orientation is horizontal,
   * then the step label will be positioned under the icon.
   */
  alternativeLabel: PropTypes.bool,

  /**
   * Two or more `<Step />` components.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * An element to be placed between each step.
   */
  connector: PropTypes.element,

  /**
   * If set the `Stepper` will not assist in controlling steps for linear flow.
   */
  nonLinear: PropTypes.bool,

  /**
   * The stepper orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiStepper'
})(Stepper));

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SwipeableDrawer__ = __webpack_require__(1114);
/* unused harmony reexport default */


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export reset */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__transitions_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NoSsr__ = __webpack_require__(255);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SwipeArea__ = __webpack_require__(1115);












 // This value is closed to what browsers are using internally to
// trigger a native scroll.

var UNCERTAINTY_THRESHOLD = 3; // px
// We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.

var nodeThatClaimedTheSwipe = null; // Exported for test purposes.

function reset() {
  nodeThatClaimedTheSwipe = null;
}

function calculateCurrentX(anchor, touches) {
  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
}

function calculateCurrentY(anchor, touches) {
  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
}

function getMaxTranslate(horizontalSwipe, paperInstance) {
  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
}

function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
}

function getDomTreeShapes(element, rootNode) {
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push(element);
    }

    element = element.parentElement;
  }

  return domTreeShapes;
}

function findNativeHandler(_ref) {
  var domTreeShapes = _ref.domTreeShapes,
      start = _ref.start,
      current = _ref.current,
      anchor = _ref.anchor;
  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
  var axisProperties = {
    scrollPosition: {
      x: 'scrollLeft',
      y: 'scrollTop'
    },
    scrollLength: {
      x: 'scrollWidth',
      y: 'scrollHeight'
    },
    clientLength: {
      x: 'clientWidth',
      y: 'clientHeight'
    }
  };
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = current >= start;

    if (anchor === 'top' || anchor === 'left') {
      goingForward = !goingForward;
    }

    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      return shape;
    }

    return null;
  });
}

var disableSwipeToOpenDefault = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
var transitionDurationDefault = {
  enter: __WEBPACK_IMPORTED_MODULE_8__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_8__styles_transitions__["b" /* duration */].leavingScreen
};
var useEnhancedEffect = typeof window !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.useLayoutEffect : __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect;
var SwipeableDrawer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SwipeableDrawer(props, ref) {
  var _props$anchor = props.anchor,
      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
      _props$disableBackdro = props.disableBackdropTransition,
      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
      _props$disableDiscove = props.disableDiscovery,
      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
      _props$disableSwipeTo = props.disableSwipeToOpen,
      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? disableSwipeToOpenDefault : _props$disableSwipeTo,
      hideBackdrop = props.hideBackdrop,
      _props$hysteresis = props.hysteresis,
      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
      _props$minFlingVeloci = props.minFlingVelocity,
      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
      _props$ModalProps = props.ModalProps;
  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;

  var BackdropProps = _props$ModalProps.BackdropProps,
      ModalPropsProp = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$ModalProps, ["BackdropProps"]),
      onClose = props.onClose,
      onOpen = props.onOpen,
      open = props.open,
      _props$PaperProps = props.PaperProps,
      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
      SwipeAreaProps = props.SwipeAreaProps,
      _props$swipeAreaWidth = props.swipeAreaWidth,
      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_9__styles_useTheme__["a" /* default */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      maybeSwiping = _React$useState[0],
      setMaybeSwiping = _React$useState[1];

  var swipeInstance = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef({
    isSwiping: null
  });
  var swipeAreaRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var backdropRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var paperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var touchDetected = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(false); // Ref for transition duration based on / to match swipe speed

  var calculatedDurationRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(); // Use a ref so the open value used is always up to date inside useCallback.

  useEnhancedEffect(function () {
    calculatedDurationRef.current = null;
  }, [open]);
  var setPosition = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (translate) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _options$mode = options.mode,
        mode = _options$mode === void 0 ? null : _options$mode,
        _options$changeTransi = options.changeTransition,
        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
    var drawerStyle = paperRef.current.style;
    drawerStyle.webkitTransform = transform;
    drawerStyle.transform = transform;
    var transition = '';

    if (mode) {
      transition = theme.transitions.create('all', Object(__WEBPACK_IMPORTED_MODULE_10__transitions_utils__["a" /* getTransitionProps */])({
        timeout: transitionDuration
      }, {
        mode: mode
      }));
    }

    if (changeTransition) {
      drawerStyle.webkitTransition = transition;
      drawerStyle.transition = transition;
    }

    if (!disableBackdropTransition && !hideBackdrop) {
      var backdropStyle = backdropRef.current.style;
      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);

      if (changeTransition) {
        backdropStyle.webkitTransition = transition;
        backdropStyle.transition = transition;
      }
    }
  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
  var handleBodyTouchEnd = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useEventCallback__["a" /* default */])(function (event) {
    if (!touchDetected.current) {
      return;
    }

    nodeThatClaimedTheSwipe = null;
    touchDetected.current = false;
    setMaybeSwiping(false); // The swipe wasn't started.

    if (!swipeInstance.current.isSwiping) {
      swipeInstance.current.isSwiping = null;
      return;
    }

    swipeInstance.current.isSwiping = null;
    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontal = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var current;

    if (horizontal) {
      current = calculateCurrentX(anchorRtl, event.changedTouches);
    } else {
      current = calculateCurrentY(anchorRtl, event.changedTouches);
    }

    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
    var translateRatio = currentTranslate / maxTranslate;

    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
      // Calculate transition duration to match swipe speed
      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
    }

    if (open) {
      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
        onClose();
      } else {
        // Reset the position, the swipe was aborted.
        setPosition(0, {
          mode: 'exit'
        });
      }

      return;
    }

    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
      onOpen();
    } else {
      // Reset the position, the swipe was aborted.
      setPosition(getMaxTranslate(horizontal, paperRef.current), {
        mode: 'enter'
      });
    }
  });
  var handleBodyTouchMove = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useEventCallback__["a" /* default */])(function (event) {
    // the ref may be null when a parent component updates while swiping
    if (!paperRef.current || !touchDetected.current) {
      return;
    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer


    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
      var nativeHandler = findNativeHandler({
        domTreeShapes: domTreeShapes,
        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
        current: horizontalSwipe ? currentX : currentY,
        anchor: anchor
      });

      if (nativeHandler) {
        nodeThatClaimedTheSwipe = nativeHandler;
        return;
      }

      nodeThatClaimedTheSwipe = swipeInstance.current;
    } // We don't know yet.


    if (swipeInstance.current.isSwiping == null) {
      var dx = Math.abs(currentX - swipeInstance.current.startX);
      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.

      if (dx > dy) {
        if (event.cancelable) {
          event.preventDefault();
        }
      }

      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;

      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
        swipeInstance.current.isSwiping = definitelySwiping;

        if (!definitelySwiping) {
          handleBodyTouchEnd(event);
          return;
        } // Shift the starting point.


        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.

        if (!disableDiscovery && !open) {
          if (horizontalSwipe) {
            swipeInstance.current.startX -= swipeAreaWidth;
          } else {
            swipeInstance.current.startY -= swipeAreaWidth;
          }
        }
      }
    }

    if (!swipeInstance.current.isSwiping) {
      return;
    }

    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;

    if (open && !swipeInstance.current.paperHit) {
      startLocation = Math.min(startLocation, maxTranslate);
    }

    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);

    if (open) {
      if (!swipeInstance.current.paperHit) {
        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;

        if (paperHit) {
          swipeInstance.current.paperHit = true;
          swipeInstance.current.startX = currentX;
          swipeInstance.current.startY = currentY;
        } else {
          return;
        }
      } else if (translate === 0) {
        swipeInstance.current.startX = currentX;
        swipeInstance.current.startY = currentY;
      }
    }

    if (swipeInstance.current.lastTranslate === null) {
      swipeInstance.current.lastTranslate = translate;
      swipeInstance.current.lastTime = performance.now() + 1;
    }

    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.

    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
    swipeInstance.current.lastTranslate = translate;
    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.

    if (event.cancelable) {
      event.preventDefault();
    }

    setPosition(translate);
  });
  var handleBodyTouchStart = Object(__WEBPACK_IMPORTED_MODULE_7__utils_useEventCallback__["a" /* default */])(function (event) {
    // We are not supposed to handle this touch move.
    // Example of use case: ignore the event if there is a Slider.
    if (event.defaultPrevented) {
      return;
    } // We can only have one node at the time claiming ownership for handling the swipe.


    if (event.muiHandled) {
      return;
    } // At least one element clogs the drawer interaction zone.


    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
      return;
    }

    var anchorRtl = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["b" /* getAnchor */])(theme, anchor);
    var horizontalSwipe = Object(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["c" /* isHorizontal */])(anchor);
    var currentX = calculateCurrentX(anchorRtl, event.touches);
    var currentY = calculateCurrentY(anchorRtl, event.touches);

    if (!open) {
      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
        return;
      }

      if (horizontalSwipe) {
        if (currentX > swipeAreaWidth) {
          return;
        }
      } else if (currentY > swipeAreaWidth) {
        return;
      }
    }

    event.muiHandled = true;
    nodeThatClaimedTheSwipe = null;
    swipeInstance.current.startX = currentX;
    swipeInstance.current.startY = currentY;
    setMaybeSwiping(true);

    if (!open && paperRef.current) {
      // The ref may be null when a parent component updates while swiping.
      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
        changeTransition: false
      });
    }

    swipeInstance.current.velocity = 0;
    swipeInstance.current.lastTime = null;
    swipeInstance.current.lastTranslate = null;
    swipeInstance.current.paperHit = false;
    touchDetected.current = true;
  });
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (variant === 'temporary') {
      document.body.addEventListener('touchstart', handleBodyTouchStart);
      document.body.addEventListener('touchmove', handleBodyTouchMove, {
        passive: false
      });
      document.body.addEventListener('touchend', handleBodyTouchEnd);
      return function () {
        document.body.removeEventListener('touchstart', handleBodyTouchStart);
        document.body.removeEventListener('touchmove', handleBodyTouchMove, {
          passive: false
        });
        document.body.removeEventListener('touchend', handleBodyTouchEnd);
      };
    }

    return undefined;
  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      // We need to release the lock.
      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
        nodeThatClaimedTheSwipe = null;
      }
    };
  }, []);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (!open) {
      setMaybeSwiping(false);
    }
  }, [open]);
  var handleBackdropRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    backdropRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance);
  }, []);
  var handlePaperRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    paperRef.current = __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance);
  }, []);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Drawer_Drawer__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    open: variant === 'temporary' && maybeSwiping ? true : open,
    variant: variant,
    ModalProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      BackdropProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, BackdropProps, {
        ref: handleBackdropRef
      })
    }, ModalPropsProp),
    PaperProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, PaperProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
      }, PaperProps.style),
      ref: handlePaperRef
    }),
    anchor: anchor,
    transitionDuration: calculatedDurationRef.current || transitionDuration,
    onClose: onClose,
    ref: ref
  }, other)), !disableSwipeToOpen && variant === 'temporary' && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__NoSsr__["a" /* default */], null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__SwipeArea__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    anchor: anchor,
    ref: swipeAreaRef,
    width: swipeAreaWidth
  }, SwipeAreaProps))));
});
 false ? SwipeableDrawer.propTypes = {
  /**
   * @ignore
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']),

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Disable the backdrop transition.
   * This can improve the FPS on low-end devices.
   */
  disableBackdropTransition: PropTypes.bool,

  /**
   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
   * to promote accidental discovery of the swipe gesture.
   */
  disableDiscovery: PropTypes.bool,

  /**
   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
   * navigation actions. Swipe to open is disabled on iOS browsers by default.
   */
  disableSwipeToOpen: PropTypes.bool,

  /**
   * @ignore
   */
  hideBackdrop: PropTypes.bool,

  /**
   * Affects how far the drawer must be opened/closed to change his state.
   * Specified as percent (0-1) of the width of the drawer
   */
  hysteresis: PropTypes.number,

  /**
   * Defines, from which (average) velocity on, the swipe is
   * defined as complete although hysteresis isn't reached.
   * Good threshold is between 250 - 1000 px/s
   */
  minFlingVelocity: PropTypes.number,

  /**
   * @ignore
   */
  ModalProps: PropTypes.shape({
    BackdropProps: PropTypes.shape({
      component: elementTypeAcceptingRef
    })
  }),

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func.isRequired,

  /**
   * Callback fired when the component requests to be opened.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func.isRequired,

  /**
   * If `true`, the drawer is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * @ignore
   */
  PaperProps: PropTypes.shape({
    component: elementTypeAcceptingRef,
    style: PropTypes.object
  }),

  /**
   * Props applied to the swipe area element.
   */
  SwipeAreaProps: PropTypes.object,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  swipeAreaWidth: PropTypes.number,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * @ignore
   */
  variant: PropTypes.oneOf(['permanent', 'persistent', 'temporary'])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (SwipeableDrawer);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__ = __webpack_require__(259);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'fixed',
      top: 0,
      left: 0,
      bottom: 0,
      zIndex: theme.zIndex.drawer - 1
    },
    anchorLeft: {
      right: 'auto'
    },
    anchorRight: {
      left: 'auto',
      right: 0
    },
    anchorTop: {
      bottom: 'auto',
      right: 0
    },
    anchorBottom: {
      top: 'auto',
      bottom: 0,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var SwipeArea = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function SwipeArea(props, ref) {
  var anchor = props.anchor,
      classes = props.classes,
      className = props.className,
      width = props.width,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["anchor", "classes", "className", "width"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["anchor".concat(Object(__WEBPACK_IMPORTED_MODULE_7__utils_capitalize__["a" /* default */])(anchor))], className),
    ref: ref,
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_8__Drawer_Drawer__["c" /* isHorizontal */])(anchor) ? 'width' : 'height', width)
  }, other));
});
 false ? SwipeArea.propTypes = {
  /**
   * Side on which to attach the discovery area.
   */
  anchor: PropTypes.oneOf(['left', 'top', 'right', 'bottom']).isRequired,

  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The width of the left most (or right most) area in pixels where the
   * drawer can be swiped open from.
   */
  width: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateSwipeArea'
})(SwipeArea));

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__ = __webpack_require__(257);


// @inheritedComponent IconButton








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      width: 34 + 12 * 2,
      height: 14 + 12 * 2,
      overflow: 'hidden',
      padding: 12,
      boxSizing: 'border-box',
      position: 'relative',
      flexShrink: 0,
      zIndex: 0,
      // Reset the stacking context.
      verticalAlign: 'middle' // For correct alignment with the text.

    },

    /* Styles applied to the root element if `edge="start"`. */
    edgeStart: {
      marginLeft: -8
    },

    /* Styles applied to the root element if `edge="end"`. */
    edgeEnd: {
      marginRight: -8
    },

    /* Styles applied to the internal `SwitchBase` component's `root` class. */
    switchBase: {
      position: 'absolute',
      top: 0,
      left: 0,
      zIndex: 1,
      // Render above the focus ripple.
      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
      transition: theme.transitions.create(['left', 'transform'], {
        duration: theme.transitions.duration.shortest
      }),
      '&$checked': {
        transform: 'translateX(50%)'
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        opacity: 0.5
      },
      '&$disabled + $track': {
        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
    colorPrimary: {
      '&$checked': {
        color: theme.palette.primary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.primary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.primary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
    colorSecondary: {
      '&$checked': {
        color: theme.palette.secondary.main,
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        }
      },
      '&$disabled': {
        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
      },
      '&$checked + $track': {
        backgroundColor: theme.palette.secondary.main
      },
      '&$disabled + $track': {
        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      width: 40,
      height: 24,
      padding: 7,
      '& $thumb': {
        width: 16,
        height: 16
      },
      '& $switchBase': {
        padding: 4
      }
    },

    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
    checked: {},

    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
    disabled: {},

    /* Styles applied to the internal SwitchBase component's input element. */
    input: {
      left: '-100%',
      width: '300%'
    },

    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
    thumb: {
      boxShadow: theme.shadows[1],
      backgroundColor: 'currentColor',
      width: 20,
      height: 20,
      borderRadius: '50%'
    },

    /* Styles applied to the track element. */
    track: {
      height: '100%',
      width: '100%',
      borderRadius: 14 / 2,
      zIndex: -1,
      transition: theme.transitions.create(['opacity', 'background-color'], {
        duration: theme.transitions.duration.shortest
      }),
      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
    }
  };
};
var Switch = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Switch(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'secondary' : _props$color,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$edge = props.edge,
      edge = _props$edge === void 0 ? false : _props$edge,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "disabled", "edge", "size"]);

  var icon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.thumb
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, {
      start: classes.edgeStart,
      end: classes.edgeEnd
    }[edge], {
      small: classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size))]
    }[size])
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__internal_SwitchBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    type: "checkbox",
    icon: icon,
    checkedIcon: icon,
    classes: {
      root: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.switchBase, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(color))]),
      input: classes.input,
      checked: classes.checked,
      disabled: classes.disabled
    },
    ref: ref,
    disabled: disabled
  }, other)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.track
  }));
});
 false ? Switch.propTypes = {
  /**
   * If `true`, the component is checked.
   */
  checked: PropTypes.bool,

  /**
   * The icon to display when the component is checked.
   */
  checkedIcon: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'default']),

  /**
   * @ignore
   */
  defaultChecked: PropTypes.bool,

  /**
   * If `true`, the switch will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * If given, uses a negative margin to counteract the padding on one
   * side (this is often helpful for aligning the left or right
   * side of the icon with content above or below, without ruining the border
   * size and shape).
   */
  edge: PropTypes.oneOf(['start', 'end', false]),

  /**
   * The icon to display when the component is unchecked.
   */
  icon: PropTypes.node,

  /**
   * The id of the `input` element.
   */
  id: PropTypes.string,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * Callback fired when the state is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
   */
  onChange: PropTypes.func,

  /**
   * If `true`, the `input` element will be required.
   */
  required: PropTypes.bool,

  /**
   * The size of the switch.
   * `small` is equivalent to the dense switch styling.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * The input component prop `type`.
   */
  type: PropTypes.string,

  /**
   * The value of the component. The DOM API casts this to a string.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiSwitch'
})(Switch));

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tab__ = __webpack_require__(1118);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tab__["a"]; });


/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_unsupportedProp__ = __webpack_require__(175);










var styles = function styles(theme) {
  var _extends2;

  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, (_extends2 = {
      maxWidth: 264,
      minWidth: 72,
      position: 'relative',
      boxSizing: 'border-box',
      minHeight: 48,
      flexShrink: 0,
      padding: '6px 12px'
    }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      padding: '6px 24px'
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "overflow", 'hidden'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "whiteSpace", 'normal'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, "textAlign", 'center'), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_extends2, theme.breakpoints.up('sm'), {
      fontSize: theme.typography.pxToRem(13),
      minWidth: 160
    }), _extends2)),

    /* Styles applied to the root element if both `icon` and `label` are provided. */
    labelIcon: {
      minHeight: 72,
      paddingTop: 9,
      '& $wrapper > *:first-child': {
        marginBottom: 6
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
    textColorInherit: {
      color: 'inherit',
      opacity: 0.7,
      '&$selected': {
        opacity: 1
      },
      '&$disabled': {
        opacity: 0.5
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
    textColorPrimary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.primary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
    textColorSecondary: {
      color: theme.palette.text.secondary,
      '&$selected': {
        color: theme.palette.secondary.main
      },
      '&$disabled': {
        color: theme.palette.text.disabled
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
    selected: {},

    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
    disabled: {},

    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
    fullWidth: {
      flexShrink: 1,
      flexGrow: 1,
      flexBasis: 0,
      maxWidth: 'none'
    },

    /* Styles applied to the root element if `wrapped={true}`. */
    wrapped: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: 1.5
    },

    /* Styles applied to the `icon` and `label`'s wrapper element. */
    wrapper: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      flexDirection: 'column'
    }
  };
};
var Tab = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Tab(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      fullWidth = props.fullWidth,
      icon = props.icon,
      indicator = props.indicator,
      label = props.label,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$wrapped = props.wrapped,
      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "selected", "textColor", "value", "wrapped"]);

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, value);
    }

    if (onClick) {
      onClick(event);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    focusRipple: !disableFocusRipple,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["textColor".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
    ref: ref,
    role: "tab",
    "aria-selected": selected,
    disabled: disabled,
    onClick: handleChange
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span", {
    className: classes.wrapper
  }, icon, label), indicator);
});
 false ? Tab.propTypes = {
  /**
   * This prop isn't supported.
   * Use the `component` prop if you need to change the children structure.
   */
  children: unsupportedProp,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the tab will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  fullWidth: PropTypes.bool,

  /**
   * The icon element.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   * For server-side rendering consideration, we let the selected tab
   * render the indicator.
   */
  indicator: PropTypes.node,

  /**
   * The label element.
   */
  label: PropTypes.node,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  textColor: PropTypes.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * You can provide your own value. Otherwise, we fallback to the child position index.
   */
  value: PropTypes.any,

  /**
   * Tab labels appear in a single row.
   * They can use a second line if needed.
   */
  wrapped: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTab'
})(Tab));

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(1120);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TableContext__ = __webpack_require__(444);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'table',
      width: '100%',
      borderCollapse: 'collapse',
      borderSpacing: 0,
      '& caption': Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
        padding: theme.spacing(2),
        color: theme.palette.text.secondary,
        textAlign: 'left',
        captionSide: 'bottom'
      })
    },

    /* Styles applied to the root element if `stickyHeader={true}`. */
    stickyHeader: {
      borderCollapse: 'separate'
    }
  };
};
var Table = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Table(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'table' : _props$component,
      _props$padding = props.padding,
      padding = _props$padding === void 0 ? 'default' : _props$padding,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$stickyHeader = props.stickyHeader,
      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useMemo(function () {
    return {
      padding: padding,
      size: size,
      stickyHeader: stickyHeader
    };
  }, [padding, size, stickyHeader]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TableContext__["a" /* default */].Provider, {
    value: table
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, stickyHeader && classes.stickyHeader)
  }, other)));
});
 false ? Table.propTypes = {
  /**
   * The content of the table, normally `TableHead` and `TableBody`.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Allows TableCells to inherit padding of the Table.
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Allows TableCells to inherit size of the Table.
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set the header sticky.
   *
   * ⚠️ It doesn't work with IE 11.
   */
  stickyHeader: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTable'
})(Table));

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableBody__ = __webpack_require__(1122);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableBody__["a"]; });


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(143);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-row-group'
  }
};
var tablelvl2 = {
  variant: 'body'
};
var TableBody = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableBody(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'tbody' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other)));
});
 false ? TableBody.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableBody'
})(TableBody));

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Table_TableContext__ = __webpack_require__(444);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__ = __webpack_require__(143);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body2, {
      display: 'table-cell',
      verticalAlign: 'inherit',
      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["e" /* lighten */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 1), 0.88) : Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["a" /* darken */])(Object(__WEBPACK_IMPORTED_MODULE_7__styles_colorManipulator__["c" /* fade */])(theme.palette.divider, 1), 0.68)),
      textAlign: 'left',
      padding: 16
    }),

    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
    head: {
      color: theme.palette.text.primary,
      lineHeight: theme.typography.pxToRem(24),
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
    body: {
      color: theme.palette.text.primary
    },

    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
    footer: {
      color: theme.palette.text.secondary,
      lineHeight: theme.typography.pxToRem(21),
      fontSize: theme.typography.pxToRem(12)
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      padding: '6px 24px 6px 16px',
      '&:last-child': {
        paddingRight: 16
      },
      '&$paddingCheckbox': {
        width: 24,
        // prevent the checkbox column from growing
        padding: '0px 12px 0 16px',
        '&:last-child': {
          paddingLeft: 12,
          paddingRight: 16
        },
        '& > *': {
          padding: 0
        }
      }
    },

    /* Styles applied to the root element if `padding="checkbox"`. */
    paddingCheckbox: {
      width: 48,
      // prevent the checkbox column from growing
      padding: '0 0 0 4px',
      '&:last-child': {
        paddingLeft: 0,
        paddingRight: 4
      }
    },

    /* Styles applied to the root element if `padding="none"`. */
    paddingNone: {
      padding: 0,
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the root element if `align="left"`. */
    alignLeft: {
      textAlign: 'left'
    },

    /* Styles applied to the root element if `align="center"`. */
    alignCenter: {
      textAlign: 'center'
    },

    /* Styles applied to the root element if `align="right"`. */
    alignRight: {
      textAlign: 'right',
      flexDirection: 'row-reverse'
    },

    /* Styles applied to the root element if `align="justify"`. */
    alignJustify: {
      textAlign: 'justify'
    },

    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
    stickyHeader: {
      position: 'sticky',
      top: 0,
      left: 0,
      zIndex: 2,
      backgroundColor: theme.palette.background.default
    }
  };
};
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

var TableCell = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableCell(props, ref) {
  var _props$align = props.align,
      align = _props$align === void 0 ? 'inherit' : _props$align,
      classes = props.classes,
      className = props.className,
      component = props.component,
      paddingProp = props.padding,
      scopeProp = props.scope,
      sizeProp = props.size,
      sortDirection = props.sortDirection,
      variantProp = props.variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);

  var table = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_8__Table_TableContext__["a" /* default */]);
  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_9__Table_Tablelvl2Context__["a" /* default */]);
  var Component;

  if (component) {
    Component = component;
  } else {
    Component = tablelvl2 && tablelvl2.variant === 'head' ? 'th' : 'td';
  }

  var scope = scopeProp;

  if (!scope && tablelvl2 && tablelvl2.variant === 'head') {
    scope = 'col';
  }

  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
  var size = sizeProp || (table && table.size ? table.size : 'medium');
  var variant = variantProp || tablelvl2 && tablelvl2.variant;
  var ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(align))], padding !== 'default' && classes["padding".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(padding))], size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(size))], {
      head: table && table.stickyHeader && classes.stickyHeader
    }[variant]),
    "aria-sort": ariaSort,
    scope: scope
  }, other));
});
 false ? TableCell.propTypes = {
  /**
   * Set the text-align on the table cell content.
   *
   * Monetary or generally number fields **should be right aligned** as that allows
   * you to add them up quickly in your head without having to worry about decimals.
   */
  align: PropTypes.oneOf(['inherit', 'left', 'center', 'right', 'justify']),

  /**
   * The table cell contents.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Sets the padding applied to the cell.
   * By default, the Table parent component set the value (`default`).
   */
  padding: PropTypes.oneOf(['default', 'checkbox', 'none']),

  /**
   * Set scope attribute.
   */
  scope: PropTypes.string,

  /**
   * Specify the size of the cell.
   * By default, the Table parent component set the value (`medium`).
   */
  size: PropTypes.oneOf(['small', 'medium']),

  /**
   * Set aria-sort direction.
   */
  sortDirection: PropTypes.oneOf(['asc', 'desc', false]),

  /**
   * Specify the cell type.
   * By default, the TableHead, TableBody or TableFooter parent component set the value.
   */
  variant: PropTypes.oneOf(['head', 'body', 'footer'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableCell'
})(TableCell));

/***/ }),
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableFooter__ = __webpack_require__(1125);
/* unused harmony reexport default */


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(143);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-footer-group'
  }
};
var tablelvl2 = {
  variant: 'footer'
};
var TableFooter = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableFooter(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'tfoot' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other)));
});
 false ? TableFooter.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableFooter'
})(TableFooter));

/***/ }),
/* 1126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableHead__ = __webpack_require__(1127);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableHead__["a"]; });


/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(143);







var styles = {
  /* Styles applied to the root element. */
  root: {
    display: 'table-header-group'
  }
};
var tablelvl2 = {
  variant: 'head'
};
var TableHead = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableHead(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'thead' : _props$component,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */].Provider, {
    value: tablelvl2
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other)));
});
 false ? TableHead.propTypes = {
  /**
   * The content of the component, normally `TableRow`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableHead'
})(TableHead));

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TablePagination__ = __webpack_require__(1129);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TablePagination__["a"]; });


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InputBase__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__MenuItem__ = __webpack_require__(433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Select__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TableCell__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Toolbar__ = __webpack_require__(446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TablePaginationActions__ = __webpack_require__(1131);














var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: theme.palette.text.primary,
      fontSize: theme.typography.pxToRem(14),
      // Increase the specificity to override TableCell.
      '&:last-child': {
        padding: 0
      }
    },

    /* Styles applied to the Toolbar component. */
    toolbar: {
      minHeight: 52,
      paddingRight: 2
    },

    /* Styles applied to the spacer element. */
    spacer: {
      flex: '1 1 100%'
    },

    /* Styles applied to the caption Typography components if `variant="caption"`. */
    caption: {
      flexShrink: 0
    },

    /* Styles applied to the Select component root element. */
    selectRoot: {
      // `.selectRoot` should be merged with `.input` in v5.
      marginRight: 32,
      marginLeft: 8
    },

    /* Styles applied to the Select component `select` class. */
    select: {
      paddingLeft: 8,
      paddingRight: 24,
      textAlign: 'right',
      textAlignLast: 'right' // Align <select> on Chrome.

    },

    /* Styles applied to the Select component `icon` class. */
    selectIcon: {
      top: 1
    },

    /* Styles applied to the `InputBase` component. */
    input: {
      color: 'inherit',
      fontSize: 'inherit',
      flexShrink: 0
    },

    /* Styles applied to the MenuItem component. */
    menuItem: {},

    /* Styles applied to the internal `TablePaginationActions` component. */
    actions: {
      flexShrink: 0,
      marginLeft: 20
    }
  };
};

var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
  var from = _ref.from,
      to = _ref.to,
      count = _ref.count;
  return "".concat(from, "-").concat(to === -1 ? count : to, " of ").concat(count);
};

var defaultRowsPerPageOptions = [10, 25, 50, 100];
/**
 * A `TableCell` based component for placing inside `TableFooter` for pagination.
 */

var TablePagination = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TablePagination(props, ref) {
  var _props$ActionsCompone = props.ActionsComponent,
      ActionsComponent = _props$ActionsCompone === void 0 ? __WEBPACK_IMPORTED_MODULE_13__TablePaginationActions__["a" /* default */] : _props$ActionsCompone,
      backIconButtonProps = props.backIconButtonProps,
      classes = props.classes,
      className = props.className,
      colSpanProp = props.colSpan,
      _props$component = props.component,
      Component = _props$component === void 0 ? __WEBPACK_IMPORTED_MODULE_10__TableCell__["a" /* default */] : _props$component,
      count = props.count,
      _props$labelDisplayed = props.labelDisplayedRows,
      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
      _props$labelRowsPerPa = props.labelRowsPerPage,
      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage,
      onChangeRowsPerPage = props.onChangeRowsPerPage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      _props$rowsPerPageOpt = props.rowsPerPageOptions,
      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
      _props$SelectProps = props.SelectProps,
      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["ActionsComponent", "backIconButtonProps", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);

  var colSpan;

  if (Component === __WEBPACK_IMPORTED_MODULE_10__TableCell__["a" /* default */] || Component === 'td') {
    colSpan = colSpanProp || 1000; // col-span over everything
  }

  var MenuItemComponent = SelectProps.native ? 'option' : __WEBPACK_IMPORTED_MODULE_8__MenuItem__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    colSpan: colSpan,
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Toolbar__["a" /* default */], {
    className: classes.toolbar
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.spacer
  }), rowsPerPageOptions.length > 1 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Select__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    classes: {
      select: classes.select,
      icon: classes.selectIcon
    },
    input: __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__InputBase__["a" /* default */], {
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, classes.selectRoot)
    }),
    value: rowsPerPage,
    onChange: onChangeRowsPerPage
  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(MenuItemComponent, {
      className: classes.menuItem,
      key: rowsPerPageOption,
      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Typography__["a" /* default */], {
    color: "inherit",
    variant: "body2",
    className: classes.caption
  }, labelDisplayedRows({
    from: count === 0 ? 0 : page * rowsPerPage + 1,
    to: Math.min(count, (page + 1) * rowsPerPage),
    count: count,
    page: page
  })), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(ActionsComponent, {
    className: classes.actions,
    backIconButtonProps: backIconButtonProps,
    count: count,
    nextIconButtonProps: nextIconButtonProps,
    onChangePage: onChangePage,
    page: page,
    rowsPerPage: rowsPerPage
  })));
});
 false ? TablePagination.propTypes = {
  /**
   * The component used for displaying the actions.
   * Either a string to use a DOM element or a component.
   */
  ActionsComponent: PropTypes.elementType,

  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  colSpan: PropTypes.number,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Customize the displayed rows label.
   */
  labelDisplayedRows: PropTypes.func,

  /**
   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelRowsPerPage: PropTypes.node,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback.
   */
  onChangeRowsPerPage: PropTypes.func,

  /**
   * The zero-based index of the current page.
   */
  page: chainPropTypes(PropTypes.number.isRequired, function (props) {
    var count = props.count,
        page = props.page,
        rowsPerPage = props.rowsPerPage;
    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);

    if (page < 0 || page > newLastPage) {
      return new Error('Material-UI: the page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
    }

    return null;
  }),

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired,

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed.
   */
  rowsPerPageOptions: PropTypes.array,

  /**
   * Props applied to the rows per page [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTablePagination'
})(TablePagination));

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center'
    },

    /* Styles applied to the root element if `disableGutters={false}`. */
    gutters: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      paddingLeft: theme.spacing(2),
      paddingRight: theme.spacing(2)
    }, theme.breakpoints.up('sm'), {
      paddingLeft: theme.spacing(3),
      paddingRight: theme.spacing(3)
    }),

    /* Styles applied to the root element if `variant="regular"`. */
    regular: theme.mixins.toolbar,

    /* Styles applied to the root element if `variant="dense"`. */
    dense: {
      minHeight: 48
    }
  };
};
var Toolbar = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Toolbar(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableGutters = props.disableGutters,
      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'regular' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableGutters", "variant"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes[variant], className, !disableGutters && classes.gutters),
    ref: ref
  }, other));
});
 false ? Toolbar.propTypes = {
  /**
   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, disables gutter padding.
   */
  disableGutters: PropTypes.bool,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['regular', 'dense'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiToolbar'
})(Toolbar));

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(137);








/**
 * @ignore - internal component.
 */

var _ref = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], null);

var _ref4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowRight__["a" /* default */], null);

var TablePaginationActions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TablePaginationActions(props, ref) {
  var backIconButtonProps = props.backIconButtonProps,
      count = props.count,
      nextIconButtonProps = props.nextIconButtonProps,
      onChangePage = props.onChangePage,
      page = props.page,
      rowsPerPage = props.rowsPerPage,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();

  var handleBackButtonClick = function handleBackButtonClick(event) {
    onChangePage(event, page - 1);
  };

  var handleNextButtonClick = function handleNextButtonClick(event) {
    onChangePage(event, page + 1);
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleBackButtonClick,
    disabled: page === 0,
    color: "inherit"
  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    onClick: handleNextButtonClick,
    disabled: page >= Math.ceil(count / rowsPerPage) - 1,
    color: "inherit"
  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
});
 false ? TablePaginationActions.propTypes = {
  /**
   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
   */
  backIconButtonProps: PropTypes.object,

  /**
   * The total number of rows.
   */
  count: PropTypes.number.isRequired,

  /**
   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
   */
  nextIconButtonProps: PropTypes.object,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChangePage: PropTypes.func.isRequired,

  /**
   * The zero-based index of the current page.
   */
  page: PropTypes.number.isRequired,

  /**
   * The number of rows per page.
   */
  rowsPerPage: PropTypes.number.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (TablePaginationActions);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableRow__ = __webpack_require__(1133);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableRow__["a"]; });


/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__ = __webpack_require__(143);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      color: 'inherit',
      display: 'table-row',
      verticalAlign: 'middle',
      // We disable the focus ring for mouse, touch and keyboard users.
      outline: 0,
      '&$selected': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.04)' // grey[100]
        : 'rgba(255, 255, 255, 0.08)'
      },
      '&$hover:hover': {
        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.07)' // grey[200]
        : 'rgba(255, 255, 255, 0.14)'
      }
    },

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Pseudo-class applied to the root element if `hover={true}`. */
    hover: {},

    /* Styles applied to the root element if table variant="head". */
    head: {},

    /* Styles applied to the root element if table variant="footer". */
    footer: {}
  };
};
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

var TableRow = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableRow(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'tr' : _props$component,
      _props$hover = props.hover,
      hover = _props$hover === void 0 ? false : _props$hover,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "hover", "selected"]);

  var tablelvl2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_6__Table_Tablelvl2Context__["a" /* default */]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, tablelvl2 && {
      head: classes.head,
      footer: classes.footer
    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected)
  }, other));
});
 false ? TableRow.propTypes = {
  /**
   * Should be valid <tr> children such as `TableCell`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true`, the table row will shade on hover.
   */
  hover: PropTypes.bool,

  /**
   * If `true`, the table row will have the selected shading.
   */
  selected: PropTypes.bool
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableRow'
})(TableRow));

/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__ = __webpack_require__(1135);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__TableSortLabel__["a"]; });


/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(16);









var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      cursor: 'pointer',
      display: 'inline-flex',
      justifyContent: 'flex-start',
      flexDirection: 'inherit',
      alignItems: 'center',
      '&:focus': {
        color: theme.palette.text.secondary
      },
      '&:hover': {
        color: theme.palette.text.secondary,
        '& $icon': {
          opacity: 1
        }
      },
      '&$active': {
        color: theme.palette.text.primary,
        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
        '&& $icon': {
          opacity: 1,
          color: theme.palette.text.secondary
        }
      }
    },

    /* Pseudo-class applied to the root element if `active={true}`. */
    active: {},

    /* Styles applied to the icon component. */
    icon: {
      marginRight: 4,
      marginLeft: 4,
      opacity: 0,
      transition: theme.transitions.create(['opacity', 'transform'], {
        duration: theme.transitions.duration.shorter
      }),
      userSelect: 'none'
    },

    /* Styles applied to the icon component if `direction="desc"`. */
    iconDirectionDesc: {
      transform: 'rotate(0deg)'
    },

    /* Styles applied to the icon component if `direction="asc"`. */
    iconDirectionAsc: {
      transform: 'rotate(180deg)'
    }
  };
};
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

var TableSortLabel = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TableSortLabel(props, ref) {
  var _props$active = props.active,
      active = _props$active === void 0 ? false : _props$active,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'desc' : _props$direction,
      _props$hideSortIcon = props.hideSortIcon,
      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
      _props$IconComponent = props.IconComponent,
      IconComponent = _props$IconComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_ArrowDownward__["a" /* default */] : _props$IconComponent,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, active && classes.active),
    component: "span",
    disableRipple: true,
    ref: ref
  }, other), children, hideSortIcon && !active ? null : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, classes["iconDirection".concat(Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(direction))])
  }));
});
 false ? TableSortLabel.propTypes = {
  /**
   * If `true`, the label will have the active styling (should be true for the sorted column).
   */
  active: PropTypes.bool,

  /**
   * Label contents, the arrow will be appended automatically.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The current sort direction.
   */
  direction: PropTypes.oneOf(['asc', 'desc']),

  /**
   * Hide sort icon when active is false.
   */
  hideSortIcon: PropTypes.bool,

  /**
   * Sort icon to use.
   */
  IconComponent: PropTypes.elementType
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTableSortLabel'
})(TableSortLabel));

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(47);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward'));

/***/ }),
/* 1137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Tabs__ = __webpack_require__(1138);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Tabs__["a"]; });


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_debounce__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ownerWindow__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_normalize_scroll_left__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__internal_animate__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__ScrollbarSize__ = __webpack_require__(1141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TabIndicator__ = __webpack_require__(1142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TabScrollButton__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_useEventCallback__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_useTheme__ = __webpack_require__(32);

















var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      overflow: 'hidden',
      minHeight: 48,
      WebkitOverflowScrolling: 'touch',
      // Add iOS momentum scrolling.
      display: 'flex'
    },

    /* Styles applied to the root element if `orientation="vertical"`. */
    vertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element. */
    flexContainer: {
      display: 'flex'
    },

    /* Styles applied to the flex container element if `orientation="vertical"`. */
    flexContainerVertical: {
      flexDirection: 'column'
    },

    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
    centered: {
      justifyContent: 'center'
    },

    /* Styles applied to the tablist element. */
    scroller: {
      position: 'relative',
      display: 'inline-block',
      flex: '1 1 auto',
      whiteSpace: 'nowrap'
    },

    /* Styles applied to the tablist element if `!variant="scrollable"`. */
    fixed: {
      overflowX: 'hidden',
      width: '100%'
    },

    /* Styles applied to the tablist element if `variant="scrollable"`. */
    scrollable: {
      overflowX: 'scroll',
      // Hide dimensionless scrollbar on MacOS
      scrollbarWidth: 'none',
      // Firefox
      '&::-webkit-scrollbar': {
        display: 'none' // Safari + Chrome

      }
    },

    /* Styles applied to the `ScrollButtonComponent` component. */
    scrollButtons: {},

    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
    scrollButtonsDesktop: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, theme.breakpoints.down('xs'), {
      display: 'none'
    }),

    /* Styles applied to the `TabIndicator` component. */
    indicator: {}
  };
};
var Tabs = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Tabs(props, ref) {
  var action = props.action,
      _props$centered = props.centered,
      centered = _props$centered === void 0 ? false : _props$centered,
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$indicatorColor = props.indicatorColor,
      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
      onChange = props.onChange,
      _props$orientation = props.orientation,
      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
      _props$ScrollButtonCo = props.ScrollButtonComponent,
      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? __WEBPACK_IMPORTED_MODULE_14__TabScrollButton__["a" /* default */] : _props$ScrollButtonCo,
      _props$scrollButtons = props.scrollButtons,
      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
      _props$TabIndicatorPr = props.TabIndicatorProps,
      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
      _props$textColor = props.textColor,
      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "value", "variant"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_16__styles_useTheme__["a" /* default */])();
  var scrollable = variant === 'scrollable';
  var isRtl = theme.direction === 'rtl';
  var vertical = orientation === 'vertical';
  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
  var start = vertical ? 'top' : 'left';
  var end = vertical ? 'bottom' : 'right';
  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
  var size = vertical ? 'height' : 'width';

  if (false) {
    if (centered && scrollable) {
      console.error('Material-UI: you can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
    }
  }

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(false),
      mounted = _React$useState[0],
      setMounted = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState({}),
      indicatorStyle = _React$useState2[0],
      setIndicatorStyle = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState({
    start: false,
    end: false
  }),
      displayScroll = _React$useState3[0],
      setDisplayScroll = _React$useState3[1];

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState({
    overflow: 'hidden',
    marginBottom: null
  }),
      scrollerStyle = _React$useState4[0],
      setScrollerStyle = _React$useState4[1];

  var valueToIndex = new Map();
  var tabsRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  var childrenWrapperRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);

  var getTabsMeta = function getTabsMeta() {
    var tabsNode = tabsRef.current;
    var tabsMeta;

    if (tabsNode) {
      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft

      tabsMeta = {
        clientWidth: tabsNode.clientWidth,
        scrollLeft: tabsNode.scrollLeft,
        scrollTop: tabsNode.scrollTop,
        scrollLeftNormalized: Object(__WEBPACK_IMPORTED_MODULE_9_normalize_scroll_left__["b" /* getNormalizedScrollLeft */])(tabsNode, theme.direction),
        scrollWidth: tabsNode.scrollWidth,
        top: rect.top,
        bottom: rect.bottom,
        left: rect.left,
        right: rect.right
      };
    }

    var tabMeta;

    if (tabsNode && value !== false) {
      var _children = childrenWrapperRef.current.children;

      if (_children.length > 0) {
        var tab = _children[valueToIndex.get(value)];

        if (false) {
          if (!tab) {
            console.error(["Material-UI: the value provided `".concat(value, "` to the Tabs component is invalid."), 'None of the Tabs children have this value.', valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
          }
        }

        tabMeta = tab ? tab.getBoundingClientRect() : null;
      }
    }

    return {
      tabsMeta: tabsMeta,
      tabMeta: tabMeta
    };
  };

  var updateIndicatorState = Object(__WEBPACK_IMPORTED_MODULE_15__utils_useEventCallback__["a" /* default */])(function () {
    var _newIndicatorStyle;

    var _getTabsMeta = getTabsMeta(),
        tabsMeta = _getTabsMeta.tabsMeta,
        tabMeta = _getTabsMeta.tabMeta;

    var startValue = 0;

    if (tabMeta && tabsMeta) {
      if (vertical) {
        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
      } else {
        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
        startValue = tabMeta.left - tabsMeta.left + correction;
      }
    }

    var newIndicatorStyle = (_newIndicatorStyle = {}, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, start, startValue), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);

    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
      setIndicatorStyle(newIndicatorStyle);
    } else {
      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);

      if (dStart >= 1 || dSize >= 1) {
        setIndicatorStyle(newIndicatorStyle);
      }
    }
  });

  var scroll = function scroll(scrollValue) {
    Object(__WEBPACK_IMPORTED_MODULE_10__internal_animate__["a" /* default */])(scrollStart, tabsRef.current, scrollValue);
  };

  var moveTabsScroll = function moveTabsScroll(delta) {
    var scrollValue = tabsRef.current[scrollStart];

    if (vertical) {
      scrollValue += delta;
    } else {
      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge

      scrollValue *= isRtl && Object(__WEBPACK_IMPORTED_MODULE_9_normalize_scroll_left__["a" /* detectScrollType */])() === 'reverse' ? -1 : 1;
    }

    scroll(scrollValue);
  };

  var handleStartScrollClick = function handleStartScrollClick() {
    moveTabsScroll(-tabsRef.current[clientSize]);
  };

  var handleEndScrollClick = function handleEndScrollClick() {
    moveTabsScroll(tabsRef.current[clientSize]);
  };

  var handleScrollbarSizeChange = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (scrollbarHeight) {
    setScrollerStyle({
      overflow: null,
      marginBottom: -scrollbarHeight
    });
  }, []);

  var getConditionalElements = function getConditionalElements() {
    var conditionalElements = {};
    conditionalElements.scrollbarSizeListener = scrollable ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__ScrollbarSize__["a" /* default */], {
      className: classes.scrollable,
      onChange: handleScrollbarSizeChange
    }) : null;
    var scrollButtonsActive = displayScroll.start || displayScroll.end;
    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
    conditionalElements.scrollButtonStart = showScrollButtons ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ScrollButtonComponent, {
      orientation: orientation,
      direction: isRtl ? 'right' : 'left',
      onClick: handleStartScrollClick,
      visible: displayScroll.start,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }) : null;
    conditionalElements.scrollButtonEnd = showScrollButtons ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ScrollButtonComponent, {
      orientation: orientation,
      direction: isRtl ? 'left' : 'right',
      onClick: handleEndScrollClick,
      visible: displayScroll.end,
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
    }) : null;
    return conditionalElements;
  };

  var scrollSelectedIntoView = Object(__WEBPACK_IMPORTED_MODULE_15__utils_useEventCallback__["a" /* default */])(function () {
    var _getTabsMeta2 = getTabsMeta(),
        tabsMeta = _getTabsMeta2.tabsMeta,
        tabMeta = _getTabsMeta2.tabMeta;

    if (!tabMeta || !tabsMeta) {
      return;
    }

    if (tabMeta[start] < tabsMeta[start]) {
      // left side of button is out of view
      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
      scroll(nextScrollStart);
    } else if (tabMeta[end] > tabsMeta[end]) {
      // right side of button is out of view
      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);

      scroll(_nextScrollStart);
    }
  });
  var updateScrollButtonState = Object(__WEBPACK_IMPORTED_MODULE_15__utils_useEventCallback__["a" /* default */])(function () {
    if (scrollable && scrollButtons !== 'off') {
      var _tabsRef$current = tabsRef.current,
          scrollTop = _tabsRef$current.scrollTop,
          scrollHeight = _tabsRef$current.scrollHeight,
          clientHeight = _tabsRef$current.clientHeight,
          scrollWidth = _tabsRef$current.scrollWidth,
          clientWidth = _tabsRef$current.clientWidth;
      var showStartScroll;
      var showEndScroll;

      if (vertical) {
        showStartScroll = scrollTop > 1;
        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
      } else {
        var scrollLeft = Object(__WEBPACK_IMPORTED_MODULE_9_normalize_scroll_left__["b" /* getNormalizedScrollLeft */])(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.

        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
      }

      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
        setDisplayScroll({
          start: showStartScroll,
          end: showEndScroll
        });
      }
    }
  });
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_7__utils_debounce__["a" /* default */])(function () {
      updateIndicatorState();
      updateScrollButtonState();
    });
    var win = Object(__WEBPACK_IMPORTED_MODULE_8__utils_ownerWindow__["a" /* default */])(tabsRef.current);
    win.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      win.removeEventListener('resize', handleResize);
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var handleTabsScroll = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(Object(__WEBPACK_IMPORTED_MODULE_7__utils_debounce__["a" /* default */])(function () {
    updateScrollButtonState();
  }));
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    return function () {
      handleTabsScroll.clear();
    };
  }, [handleTabsScroll]);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    setMounted(true);
  }, []);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    updateIndicatorState();
    updateScrollButtonState();
  });
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    scrollSelectedIntoView();
  }, [scrollSelectedIntoView, indicatorStyle]);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useImperativeHandle(action, function () {
    return {
      updateIndicator: updateIndicatorState,
      updateScrollButtons: updateScrollButtonState
    };
  }, [updateIndicatorState, updateScrollButtonState]);
  var indicator = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__TabIndicator__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.indicator,
    orientation: orientation,
    color: indicatorColor
  }, TabIndicatorProps, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, indicatorStyle, {}, TabIndicatorProps.style)
  }));
  var childIndex = 0;
  var children = __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(childrenProp, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (child.type === React.Fragment) {
        console.error(["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var childValue = child.props.value === undefined ? childIndex : child.props.value;
    valueToIndex.set(childValue, childIndex);
    var selected = childValue === value;
    childIndex += 1;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
      fullWidth: variant === 'fullWidth',
      indicator: selected && !mounted && indicator,
      selected: selected,
      onChange: onChange,
      textColor: textColor,
      value: childValue
    });
  });
  var conditionalElements = getConditionalElements();
  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, vertical && classes.vertical),
    ref: ref
  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
    style: scrollerStyle,
    ref: tabsRef,
    onScroll: handleTabsScroll
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
    ref: childrenWrapperRef,
    role: "tablist"
  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
});
 false ? Tabs.propTypes = {
  /**
   * Callback fired when the component mounts.
   * This is useful when you want to trigger an action programmatically.
   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
   *
   * @param {object} actions This object contains all possible actions
   * that can be triggered programmatically.
   */
  action: refType,

  /**
   * If `true`, the tabs will be centered.
   * This property is intended for large views.
   */
  centered: PropTypes.bool,

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * Determines the color of the indicator.
   */
  indicatorColor: PropTypes.oneOf(['secondary', 'primary']),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value We default to the index of the child (number)
   */
  onChange: PropTypes.func,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']),

  /**
   * The component used to render the scroll buttons.
   */
  ScrollButtonComponent: PropTypes.elementType,

  /**
   * Determine behavior of scroll buttons when tabs are set to scroll:
   *
   * - `auto` will only present them when not all the items are visible.
   * - `desktop` will only present them on medium and larger viewports.
   * - `on` will always present them.
   * - `off` will never present them.
   */
  scrollButtons: PropTypes.oneOf(['auto', 'desktop', 'on', 'off']),

  /**
   * Props applied to the tab indicator element.
   */
  TabIndicatorProps: PropTypes.object,

  /**
   * Determines the color of the `Tab`.
   */
  textColor: PropTypes.oneOf(['secondary', 'primary', 'inherit']),

  /**
   * The value of the currently selected `Tab`.
   * If you don't want any selected `Tab`, you can set this property to `false`.
   */
  value: PropTypes.any,

  /**
   *  Determines additional display behavior of the tabs:
   *
   *  - `scrollable` will invoke scrolling properties and allow for horizontally
   *  scrolling (or swiping) of the tab bar.
   *  -`fullWidth` will make the tabs grow to use all the available space,
   *  which should be used for small views, like on mobile.
   *  - `standard` will render the default state.
   */
  variant: PropTypes.oneOf(['standard', 'scrollable', 'fullWidth'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_12__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTabs'
})(Tabs));

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _setScrollType */
/* harmony export (immutable) */ __webpack_exports__["a"] = detectScrollType;
/* harmony export (immutable) */ __webpack_exports__["b"] = getNormalizedScrollLeft;
/* unused harmony export setNormalizedScrollLeft */
// Based on https://github.com/react-bootstrap/dom-helpers/blob/master/src/util/inDOM.js
var inDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var cachedType;
function _setScrollType(type) {
    cachedType = type;
}
// Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
function detectScrollType() {
    if (cachedType) {
        return cachedType;
    }
    if (!inDOM || !window.document.body) {
        return 'indeterminate';
    }
    var dummy = window.document.createElement('div');
    dummy.appendChild(document.createTextNode('ABCD'));
    dummy.dir = 'rtl';
    dummy.style.fontSize = '14px';
    dummy.style.width = '4px';
    dummy.style.height = '1px';
    dummy.style.position = 'absolute';
    dummy.style.top = '-1000px';
    dummy.style.overflow = 'scroll';
    document.body.appendChild(dummy);
    cachedType = 'reverse';
    if (dummy.scrollLeft > 0) {
        cachedType = 'default';
    }
    else {
        dummy.scrollLeft = 1;
        if (dummy.scrollLeft === 0) {
            cachedType = 'negative';
        }
    }
    document.body.removeChild(dummy);
    return cachedType;
}
// Based on https://stackoverflow.com/a/24394376
function getNormalizedScrollLeft(element, direction) {
    var scrollLeft = element.scrollLeft;
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        return scrollLeft;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return Number.NaN;
    }
    switch (type) {
        case 'negative':
            return element.scrollWidth - element.clientWidth + scrollLeft;
        case 'reverse':
            return element.scrollWidth - element.clientWidth - scrollLeft;
    }
    return scrollLeft;
}
function setNormalizedScrollLeft(element, scrollLeft, direction) {
    // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
    if (direction !== 'rtl') {
        element.scrollLeft = scrollLeft;
        return;
    }
    var type = detectScrollType();
    if (type === 'indeterminate') {
        return;
    }
    switch (type) {
        case 'negative':
            element.scrollLeft = element.clientWidth - element.scrollWidth + scrollLeft;
            break;
        case 'reverse':
            element.scrollLeft = element.scrollWidth - element.clientWidth - scrollLeft;
            break;
        default:
            element.scrollLeft = scrollLeft;
            break;
    }
}


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = animate;
function easeInOutSin(time) {
  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
}

function animate(property, element, to) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
  var _options$ease = options.ease,
      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
      _options$duration = options.duration,
      duration = _options$duration === void 0 ? 300 : _options$duration;
  var start = null;
  var from = element[property];
  var cancelled = false;

  var cancel = function cancel() {
    cancelled = true;
  };

  var step = function step(timestamp) {
    if (cancelled) {
      cb(new Error('Animation cancelled'));
      return;
    }

    if (start === null) {
      start = timestamp;
    }

    var time = Math.min(1, (timestamp - start) / duration);
    element[property] = ease(time) * (to - from) + from;

    if (time >= 1) {
      requestAnimationFrame(function () {
        cb(null);
      });
      return;
    }

    requestAnimationFrame(step);
  };

  if (from === to) {
    cb(new Error('Element already at target position'));
    return cancel;
  }

  requestAnimationFrame(step);
  return cancel;
}

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScrollbarSize;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_debounce__ = __webpack_require__(117);





var styles = {
  width: 99,
  height: 99,
  position: 'absolute',
  top: -9999,
  overflow: 'scroll'
};
/**
 * @ignore - internal component.
 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
 * It has been moved into the core in order to minimize the bundle size.
 */

function ScrollbarSize(props) {
  var onChange = props.onChange,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["onChange"]);

  var scrollbarHeight = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var nodeRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var setMeasurements = function setMeasurements() {
    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    var handleResize = Object(__WEBPACK_IMPORTED_MODULE_4__utils_debounce__["a" /* default */])(function () {
      var prevHeight = scrollbarHeight.current;
      setMeasurements();

      if (prevHeight !== scrollbarHeight.current) {
        onChange(scrollbarHeight.current);
      }
    });
    window.addEventListener('resize', handleResize);
    return function () {
      handleResize.clear();
      window.removeEventListener('resize', handleResize);
    };
  }, [onChange]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    setMeasurements();
    onChange(scrollbarHeight.current);
  }, [onChange]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    style: styles,
    ref: nodeRef
  }, other));
}
 false ? ScrollbarSize.propTypes = {
  onChange: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_capitalize__ = __webpack_require__(16);







var styles = function styles(theme) {
  return {
    root: {
      position: 'absolute',
      height: 2,
      bottom: 0,
      width: '100%',
      transition: theme.transitions.create()
    },
    colorPrimary: {
      backgroundColor: theme.palette.primary.main
    },
    colorSecondary: {
      backgroundColor: theme.palette.secondary.main
    },
    vertical: {
      height: '100%',
      width: 2,
      right: 0
    }
  };
};
/**
 * @ignore - internal component.
 */

var TabIndicator = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TabIndicator(props, ref) {
  var classes = props.classes,
      className = props.className,
      color = props.color,
      orientation = props.orientation,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "color", "orientation"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classes["color".concat(Object(__WEBPACK_IMPORTED_MODULE_6__utils_capitalize__["a" /* default */])(color))], className, {
      vertical: classes.vertical
    }[orientation]),
    ref: ref
  }, other));
});
 false ? TabIndicator.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   * The color of the tab indicator.
   */
  color: PropTypes.oneOf(['primary', 'secondary']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateTabIndicator'
})(TabIndicator));

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__ = __webpack_require__(447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__ = __webpack_require__(448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ButtonBase__ = __webpack_require__(41);



/* eslint-disable jsx-a11y/aria-role */







var styles = {
  root: {
    width: 40,
    flexShrink: 0
  },
  vertical: {
    width: '100%',
    height: 40,
    '& svg': {
      transform: 'rotate(90deg)'
    }
  }
};
/**
 * @ignore - internal component.
 */

var _ref = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__internal_svg_icons_KeyboardArrowLeft__["a" /* default */], {
  fontSize: "small"
});

var _ref2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_KeyboardArrowRight__["a" /* default */], {
  fontSize: "small"
});

var TabScrollButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TabScrollButton(props, ref) {
  var classes = props.classes,
      classNameProp = props.className,
      direction = props.direction,
      orientation = props.orientation,
      visible = props.visible,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "direction", "orientation", "visible"]);

  var className = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, classNameProp, {
    vertical: classes.vertical
  }[orientation]);

  if (!visible) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
      className: className
    });
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    component: "div",
    className: className,
    ref: ref,
    role: null,
    tabIndex: null
  }, other), direction === 'left' ? _ref : _ref2);
});
 false ? TabScrollButton.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Which direction should the button indicate?
   */
  direction: PropTypes.oneOf(['left', 'right']).isRequired,

  /**
   * The tabs orientation (layout flow direction).
   */
  orientation: PropTypes.oneOf(['horizontal', 'vertical']).isRequired,

  /**
   * Should the button be present or just consume space.
   */
  visible: PropTypes.bool.isRequired
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__styles_withStyles__["a" /* default */])(styles, {
  name: 'PrivateTabScrollButton'
})(TabScrollButton));

/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Input__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FilledInput__ = __webpack_require__(261);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__OutlinedInput__ = __webpack_require__(265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__InputLabel__ = __webpack_require__(425);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__FormControl__ = __webpack_require__(263);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FormHelperText__ = __webpack_require__(420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Select__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__styles_withStyles__ = __webpack_require__(5);















var variantComponent = {
  standard: __WEBPACK_IMPORTED_MODULE_7__Input__["a" /* default */],
  filled: __WEBPACK_IMPORTED_MODULE_8__FilledInput__["a" /* default */],
  outlined: __WEBPACK_IMPORTED_MODULE_9__OutlinedInput__["a" /* default */]
};
var styles = {
  /* Styles applied to the root element. */
  root: {}
};
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

var TextField = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TextField(props, ref) {
  var autoComplete = props.autoComplete,
      _props$autoFocus = props.autoFocus,
      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
      children = props.children,
      classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'primary' : _props$color,
      defaultValue = props.defaultValue,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$error = props.error,
      error = _props$error === void 0 ? false : _props$error,
      FormHelperTextProps = props.FormHelperTextProps,
      _props$fullWidth = props.fullWidth,
      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
      helperText = props.helperText,
      hiddenLabel = props.hiddenLabel,
      id = props.id,
      InputLabelProps = props.InputLabelProps,
      inputProps = props.inputProps,
      InputProps = props.InputProps,
      inputRef = props.inputRef,
      label = props.label,
      _props$multiline = props.multiline,
      multiline = _props$multiline === void 0 ? false : _props$multiline,
      name = props.name,
      onBlur = props.onBlur,
      onChange = props.onChange,
      onFocus = props.onFocus,
      placeholder = props.placeholder,
      _props$required = props.required,
      required = _props$required === void 0 ? false : _props$required,
      rows = props.rows,
      rowsMax = props.rowsMax,
      _props$select = props.select,
      select = _props$select === void 0 ? false : _props$select,
      SelectProps = props.SelectProps,
      type = props.type,
      value = props.value,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'standard' : _props$variant,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(0),
      labelWidth = _React$useState[0],
      setLabelWidth = _React$useState[1];

  var labelRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (variant === 'outlined') {
      // #StrictMode ready
      var labelNode = __WEBPACK_IMPORTED_MODULE_3_react_dom___default.a.findDOMNode(labelRef.current);
      setLabelWidth(labelNode != null ? labelNode.offsetWidth : 0);
    }
  }, [variant, required, label]);

  if (false) {
    if (select && !children) {
      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
    }
  }

  var InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    InputMore.labelWidth = labelWidth;
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
  var InputComponent = variantComponent[variant];
  var InputElement = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(InputComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    rowsMax: rowsMax,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__FormControl__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    hiddenLabel: hiddenLabel,
    ref: ref,
    required: required,
    color: color,
    variant: variant
  }, other), label && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__InputLabel__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    htmlFor: id,
    ref: labelRef,
    id: inputLabelId
  }, InputLabelProps), label), select ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Select__["default"], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    "aria-describedby": helperTextId,
    id: id,
    labelId: inputLabelId,
    value: value,
    input: InputElement
  }, SelectProps), children) : InputElement, helperText && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__FormHelperText__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: helperTextId
  }, FormHelperTextProps), helperText));
});
 false ? TextField.propTypes = {
  /**
   * This prop helps users to fill forms faster, especially on mobile devices.
   * The name can be confusing, as it's more like an autofill.
   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
   */
  autoComplete: PropTypes.string,

  /**
   * If `true`, the `input` element will be focused during the first mount.
   */
  autoFocus: PropTypes.bool,

  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   */
  color: PropTypes.oneOf(['primary', 'secondary']),

  /**
   * The default value of the `input` element.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the `input` element will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the label will be displayed in an error state.
   */
  error: PropTypes.bool,

  /**
   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
   */
  FormHelperTextProps: PropTypes.object,

  /**
   * If `true`, the input will take up the full width of its container.
   */
  fullWidth: PropTypes.bool,

  /**
   * The helper text content.
   */
  helperText: PropTypes.node,

  /**
   * @ignore
   */
  hiddenLabel: PropTypes.bool,

  /**
   * The id of the `input` element.
   * Use this prop to make `label` and `helperText` accessible for screen readers.
   */
  id: PropTypes.string,

  /**
   * Props applied to the [`InputLabel`](/api/input-label/) element.
   */
  InputLabelProps: PropTypes.object,

  /**
   * Props applied to the Input element.
   * It will be a [`FilledInput`](/api/filled-input/),
   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
   * component depending on the `variant` prop value.
   */
  InputProps: PropTypes.object,

  /**
   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
   */
  inputProps: PropTypes.object,

  /**
   * Pass a ref to the `input` element.
   */
  inputRef: refType,

  /**
   * The label content.
   */
  label: PropTypes.node,

  /**
   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
   */
  margin: PropTypes.oneOf(['none', 'dense', 'normal']),

  /**
   * If `true`, a textarea element will be rendered instead of an input.
   */
  multiline: PropTypes.bool,

  /**
   * Name attribute of the `input` element.
   */
  name: PropTypes.string,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the value is changed.
   *
   * @param {object} event The event source of the callback.
   * You can pull out the new value by accessing `event.target.value` (string).
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * The short hint displayed in the input before the user enters a value.
   */
  placeholder: PropTypes.string,

  /**
   * If `true`, the label is displayed as required and the `input` element` will be required.
   */
  required: PropTypes.bool,

  /**
   * Number of rows to display when multiline option is set to true.
   */
  rows: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Maximum number of rows to display when multiline option is set to true.
   */
  rowsMax: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
   * If this option is set you must pass the options of the select as children.
   */
  select: PropTypes.bool,

  /**
   * Props applied to the [`Select`](/api/select/) element.
   */
  SelectProps: PropTypes.object,

  /**
   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
   */
  type: PropTypes.string,

  /**
   * The value of the `input` element, required for a controlled component.
   */
  value: PropTypes.any,

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['standard', 'outlined', 'filled'])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTextField'
})(TextField));

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_utils__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__styles_withStyles__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_capitalize__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grow__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Popper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_setRef__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_focusVisible__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__styles_useTheme__ = __webpack_require__(32);


















function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the Popper component. */
    popper: {
      zIndex: theme.zIndex.tooltip,
      pointerEvents: 'none',
      flip: false // disable jss-rtl plugin

    },

    /* Styles applied to the Popper component if `interactive={true}`. */
    popperInteractive: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the tooltip (label wrapper) element. */
    tooltip: {
      backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_8__styles_colorManipulator__["c" /* fade */])(theme.palette.grey[700], 0.9),
      borderRadius: theme.shape.borderRadius,
      color: theme.palette.common.white,
      fontFamily: theme.typography.fontFamily,
      padding: '4px 8px',
      fontSize: theme.typography.pxToRem(10),
      lineHeight: "".concat(round(14 / 10), "em"),
      maxWidth: 300,
      wordWrap: 'break-word',
      fontWeight: theme.typography.fontWeightMedium
    },

    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
    touch: {
      padding: '8px 16px',
      fontSize: theme.typography.pxToRem(14),
      lineHeight: "".concat(round(16 / 14), "em"),
      fontWeight: theme.typography.fontWeightRegular
    },

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
    tooltipPlacementLeft: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'right center',
      margin: '0 24px '
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
    tooltipPlacementRight: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'left center',
      margin: '0 24px'
    }, theme.breakpoints.up('sm'), {
      margin: '0 14px'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
    tooltipPlacementTop: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center bottom',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    }),

    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
    tooltipPlacementBottom: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({
      transformOrigin: 'center top',
      margin: '24px 0'
    }, theme.breakpoints.up('sm'), {
      margin: '14px 0'
    })
  };
};
var Tooltip = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Tooltip(props, ref) {
  var children = props.children,
      classes = props.classes,
      _props$disableFocusLi = props.disableFocusListener,
      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
      _props$disableHoverLi = props.disableHoverListener,
      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
      _props$disableTouchLi = props.disableTouchListener,
      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
      _props$enterDelay = props.enterDelay,
      enterDelay = _props$enterDelay === void 0 ? 0 : _props$enterDelay,
      _props$enterTouchDela = props.enterTouchDelay,
      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
      id = props.id,
      _props$interactive = props.interactive,
      interactive = _props$interactive === void 0 ? false : _props$interactive,
      _props$leaveDelay = props.leaveDelay,
      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
      _props$leaveTouchDela = props.leaveTouchDelay,
      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
      onClose = props.onClose,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$placement = props.placement,
      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
      PopperProps = props.PopperProps,
      title = props.title,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_11__Grow__["a" /* default */] : _props$TransitionComp,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_16__styles_useTheme__["a" /* default */])();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(0),
      forceUpdate = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(),
      childNode = _React$useState2[0],
      setChildNode = _React$useState2[1];

  var ignoreNonTouchEvents = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(false);
  var defaultId = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var closeTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var enterTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var leaveTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();
  var touchTimer = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef();

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(openProp != null),
      isControlled = _React$useRef.current;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(false),
      openState = _React$useState3[0],
      setOpenState = _React$useState3[1];

  var open = isControlled ? openProp : openState;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (openProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled Tooltip to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled Tooltip ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [openProp, isControlled]);
  }

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
        console.error(['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
      }
    }, [isControlled, title, childNode]);
  }

  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    // Fallback to this default id when possible.
    // Use the random value for client-side rendering only.
    // We can't use it server-side.
    if (!defaultId.current) {
      defaultId.current = "mui-tooltip-".concat(Math.round(Math.random() * 1e5));
    } // Rerender with defaultId and childNode.


    if (openProp) {
      forceUpdate(function (n) {
        return !n;
      });
    }
  }, [openProp]);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    return function () {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      clearTimeout(touchTimer.current);
    };
  }, []);

  var handleOpen = function handleOpen(event) {
    // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
    if (!isControlled) {
      setOpenState(true);
    }

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleEnter = function handleEnter(event) {
    var childrenProps = children.props;

    if (event.type === 'mouseover' && childrenProps.onMouseOver) {
      childrenProps.onMouseOver(event);
    }

    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    } // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).


    if (childNode) {
      childNode.removeAttribute('title');
    }

    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);

    if (enterDelay) {
      event.persist();
      enterTimer.current = setTimeout(function () {
        handleOpen(event);
      }, enterDelay);
    } else {
      handleOpen(event);
    }
  };

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_15__utils_focusVisible__["a" /* useIsFocusVisible */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useState(false),
      childIsFocusVisible = _React$useState4[0],
      setChildIsFocusVisible = _React$useState4[1];

  var handleBlur = function handleBlur() {
    if (childIsFocusVisible) {
      setChildIsFocusVisible(false);
      onBlurVisible();
    }
  };

  var handleFocus = function handleFocus(event) {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }

    if (isFocusVisible(event)) {
      setChildIsFocusVisible(true);
      handleEnter(event);
    }

    var childrenProps = children.props;

    if (childrenProps.onFocus) {
      childrenProps.onFocus(event);
    }
  };

  var handleClose = function handleClose(event) {
    if (!isControlled) {
      setOpenState(false);
    }

    if (onClose) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(function () {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  };

  var handleLeave = function handleLeave(event) {
    var childrenProps = children.props;

    if (event.type === 'blur') {
      if (childrenProps.onBlur) {
        childrenProps.onBlur(event);
      }

      handleBlur(event);
    }

    if (event.type === 'mouseleave' && childrenProps.onMouseLeave) {
      childrenProps.onMouseLeave(event);
    }

    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveDelay);
  };

  var handleTouchStart = function handleTouchStart(event) {
    ignoreNonTouchEvents.current = true;
    var childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }

    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    clearTimeout(touchTimer.current);
    event.persist();
    touchTimer.current = setTimeout(function () {
      handleEnter(event);
    }, enterTouchDelay);
  };

  var handleTouchEnd = function handleTouchEnd(event) {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    clearTimeout(touchTimer.current);
    clearTimeout(leaveTimer.current);
    event.persist();
    leaveTimer.current = setTimeout(function () {
      handleClose(event);
    }, leaveTouchDelay);
  };

  var handleUseRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(setChildNode, ref);
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components

  var handleOwnRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useCallback(function (instance) {
    // #StrictMode ready
    Object(__WEBPACK_IMPORTED_MODULE_14__utils_setRef__["a" /* default */])(handleFocusRef, __WEBPACK_IMPORTED_MODULE_4_react_dom___default.a.findDOMNode(instance));
  }, [handleFocusRef]);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_13__utils_useForkRef__["a" /* default */])(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  } // For accessibility and SEO concerns, we render the title to the DOM node when
  // the tooltip is hidden. However, we have made a tradeoff when
  // `disableHoverListener` is set. This title logic is disabled.
  // It's allowing us to keep the implementation size minimal.
  // We are open to change the tradeoff.


  var shouldShowNativeTitle = !open && !disableHoverListener;

  var childrenProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    'aria-describedby': open ? id || defaultId.current : null,
    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
  }, other, {}, children.props, {
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(other.className, children.props.className)
  });

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = handleEnter;
    childrenProps.onMouseLeave = handleLeave;
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = handleFocus;
    childrenProps.onBlur = handleLeave;
  }

  var interactiveWrapperListeners = interactive ? {
    onMouseOver: childrenProps.onMouseOver,
    onMouseLeave: childrenProps.onMouseLeave,
    onFocus: childrenProps.onFocus,
    onBlur: childrenProps.onBlur
  } : {};

  if (false) {
    if (children.props.title) {
      console.error(['Material-UI: you have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
    }
  }

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef
  }, childrenProps)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Popper__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.popper, interactive && classes.popperInteractive),
    placement: placement,
    anchorEl: childNode,
    open: childNode ? open : false,
    id: childrenProps['aria-describedby'],
    transition: true
  }, interactiveWrapperListeners, PopperProps), function (_ref) {
    var placementInner = _ref.placement,
        TransitionPropsInner = _ref.TransitionProps;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      timeout: theme.transitions.duration.shorter
    }, TransitionPropsInner, TransitionProps), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.tooltip, classes["tooltipPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_10__utils_capitalize__["a" /* default */])(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch)
    }, title));
  }));
});
 false ? Tooltip.propTypes = {
  /**
   * Tooltip reference element.
   */
  children: elementAcceptingRef.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * Do not respond to focus events.
   */
  disableFocusListener: PropTypes.bool,

  /**
   * Do not respond to hover events.
   */
  disableHoverListener: PropTypes.bool,

  /**
   * Do not respond to long press touch events.
   */
  disableTouchListener: PropTypes.bool,

  /**
   * The number of milliseconds to wait before showing the tooltip.
   * This prop won't impact the enter touch delay (`enterTouchDelay`).
   */
  enterDelay: PropTypes.number,

  /**
   * The number of milliseconds a user must touch the element before showing the tooltip.
   */
  enterTouchDelay: PropTypes.number,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * Makes a tooltip interactive, i.e. will not close when the user
   * hovers over the tooltip before the `leaveDelay` is expired.
   */
  interactive: PropTypes.bool,

  /**
   * The number of milliseconds to wait before hiding the tooltip.
   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
   */
  leaveDelay: PropTypes.number,

  /**
   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
   */
  leaveTouchDelay: PropTypes.number,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the tooltip is shown.
   */
  open: PropTypes.bool,

  /**
   * Tooltip placement.
   */
  placement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Props applied to the [`Popper`](/api/popper/) element.
   */
  PopperProps: PropTypes.object,

  /**
   * Tooltip title. Zero-length titles string are never displayed.
   */
  title: PropTypes.node.isRequired,

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_9__styles_withStyles__["a" /* default */])(styles, {
  name: 'MuiTooltip'
})(Tooltip));

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__useScrollTrigger__ = __webpack_require__(1147);
/* unused harmony reexport default */


/***/ }),
/* 1147 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);



function getScrollY(ref) {
  return ref.pageYOffset !== undefined ? ref.pageYOffset : ref.scrollTop;
}

function defaultTrigger(event, store, options) {
  var _options$disableHyste = options.disableHysteresis,
      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
      _options$threshold = options.threshold,
      threshold = _options$threshold === void 0 ? 100 : _options$threshold;
  var previous = store.current;
  store.current = event ? getScrollY(event.currentTarget) : previous;

  if (!disableHysteresis && previous !== undefined) {
    if (store.current < previous) {
      return false;
    }
  }

  return store.current > threshold;
}

var defaultTarget = typeof window !== 'undefined' ? window : null;
function useScrollTrigger() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _options$getTrigger = options.getTrigger,
      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
      _options$target = options.target,
      target = _options$target === void 0 ? defaultTarget : _options$target,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(options, ["getTrigger", "target"]);

  var store = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useRef();

  var _React$useState = __WEBPACK_IMPORTED_MODULE_1_react___default.a.useState(function () {
    return getTrigger(null, store, other);
  }),
      trigger = _React$useState[0],
      setTrigger = _React$useState[1];

  __WEBPACK_IMPORTED_MODULE_1_react___default.a.useEffect(function () {
    var handleScroll = function handleScroll(event) {
      setTrigger(getTrigger(event, store, other));
    };

    handleScroll(null); // Re-evaluate trigger when dependencies change

    target.addEventListener('scroll', handleScroll);
    return function () {
      target.removeEventListener('scroll', handleScroll);
    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target, getTrigger, JSON.stringify(other)]);
  return trigger;
}

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withMobileDialog__ = __webpack_require__(1149);
/* unused harmony reexport default */


/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__withWidth__ = __webpack_require__(264);




/**
 * Dialog will responsively be full screen *at or below* the given breakpoint
 * (defaults to 'sm' for mobile devices).
 * Notice that this Higher-order Component is incompatible with server-side rendering.
 */

var withMobileDialog = function withMobileDialog() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (Component) {
    var _options$breakpoint = options.breakpoint,
        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;

    function WithMobileDialog(props) {
      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        fullScreen: Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["b" /* isWidthDown */])(breakpoint, props.width)
      }, props));
    }

     false ? WithMobileDialog.propTypes = {
      width: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
    } : void 0;
    return Object(__WEBPACK_IMPORTED_MODULE_3__withWidth__["a" /* default */])()(WithMobileDialog);
  };
};

/* unused harmony default export */ var _unused_webpack_default_export = (withMobileDialog);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_transition_group__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__styles_transitions__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__styles_useTheme__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__transitions_utils__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__ = __webpack_require__(28);









var styles = {
  entering: {
    transform: 'none'
  },
  entered: {
    transform: 'none'
  }
};
var defaultTimeout = {
  enter: __WEBPACK_IMPORTED_MODULE_5__styles_transitions__["b" /* duration */].enteringScreen,
  exit: __WEBPACK_IMPORTED_MODULE_5__styles_transitions__["b" /* duration */].leavingScreen
};
/**
 * The Zoom transition can be used for the floating variant of the
 * [Button](/components/buttons/#floating-action-buttons) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

var Zoom = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Zoom(props, ref) {
  var children = props.children,
      inProp = props.in,
      onEnter = props.onEnter,
      onExit = props.onExit,
      style = props.style,
      _props$timeout = props.timeout,
      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);

  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__styles_useTheme__["a" /* default */])();
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__utils_useForkRef__["a" /* default */])(children.ref, ref);

  var handleEnter = function handleEnter(node, isAppearing) {
    Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["b" /* reflow */])(node); // So the animation always start from the start.

    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  };

  var handleExit = function handleExit(node) {
    var transitionProps = Object(__WEBPACK_IMPORTED_MODULE_7__transitions_utils__["a" /* getTransitionProps */])({
      style: style,
      timeout: timeout
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);

    if (onExit) {
      onExit(node);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_transition_group__["a" /* Transition */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    appear: true,
    in: inProp,
    onEnter: handleEnter,
    onExit: handleExit,
    timeout: timeout
  }, other), function (state, childProps) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        transform: 'scale(0)',
        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
      }, styles[state], {}, style, {}, children.props.style),
      ref: handleRef
    }, childProps));
  });
});
 false ? Zoom.propTypes = {
  /**
   * A single child content element.
   */
  children: PropTypes.element,

  /**
   * If `true`, the component will transition in.
   */
  in: PropTypes.bool,

  /**
   * @ignore
   */
  onEnter: PropTypes.func,

  /**
   * @ignore
   */
  onExit: PropTypes.func,

  /**
   * @ignore
   */
  style: PropTypes.object,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  timeout: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    enter: PropTypes.number,
    exit: PropTypes.number
  })])
} : void 0;
/* harmony default export */ __webpack_exports__["a"] = (Zoom);

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
}), 'Menu');

exports.default = _default;

/***/ }),
/* 1152 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_logoCreek_png__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_logoCreek_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_logoCreek_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_logoNuevamente_png__ = __webpack_require__(1155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_logoNuevamente_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_assets_logoNuevamente_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_logoHangover_png__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_logoHangover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_logoHangover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_logoLeparc_png__ = __webpack_require__(1157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_logoLeparc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_logoLeparc_png__);
//import logoLeparc from "../../common/assets/logoLeparc.png";
var logo=null;var tenantId="hangover";if(tenantId=="creek"){logo=__WEBPACK_IMPORTED_MODULE_0__common_assets_logoCreek_png___default.a;}else if(tenantId=="nuevamente"){logo=__WEBPACK_IMPORTED_MODULE_1__common_assets_logoNuevamente_png___default.a;}else if(tenantId=="leparc"){logo=__WEBPACK_IMPORTED_MODULE_3__common_assets_logoLeparc_png___default.a;}else if(tenantId=="hangover"){logo=__WEBPACK_IMPORTED_MODULE_2__common_assets_logoHangover_png___default.a;}/* harmony default export */ __webpack_exports__["a"] = (logo);

/***/ }),
/* 1154 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAE8AAABuCAYAAABmxE4VAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAABUmSURBVHgB7Z0HkFRFE8fnEAPmLGbFWCbMAbNiQMGMmCktxSwq5oBQaqGAAbVQS1EsE2YwYw4YMIsZc85ZzDpf/7rordnZvWN337y9W7/rqle3t+/tvnk9nab7P71Nzjnv2qkm6uDaqWZqZ14GamdeBmpnXgZqZ14GamdeBmpnXgbq6NoINTU1uQ4dOujff//9180222yuc+fOeiy55JJu1lln1fO//fab++qrr9wXX3zhPv74Y/07wwwzOO+9+/vvv90///zj6kWtxjyYxAPb37nmmsutt956boMNNnBbbrmlW2qppdznn3/uPvvsM/fdd9+5P/74Q6+dccYZ3cwzz6zXL7roovrZl156yd1www3uhRdecG+88UbR9+ZNvjUOeTg/3XTT+WWXXdYPHTrUf/LJJ14e3J977rl+00039Ysssoie57r4c/bZTp06+dVWW80fcMAB/rbbbvM//vijHzdunN922231XB2eo/6Mm3766b2oor/iiiv8t99+6y+++GK/9tprFxgTM6wc40NG2iGq7fv37+9fe+01L9Loe/furfeC0Tk9S30YZg/Iw5xwwgn+yy+/9MOHD/dLLLFE0gfke0S1/W677eZffvllf8cdd+hEib3M47mcr8fBQy233HL+ueee848//rhfeeWVy6plyvvNN998/uSTT/biYFS1U9+jyTiYF2G45UHcDjvs4EaMGOEuueQSd8YZZ5Q15nhTDnlot84667iNNtrIzT///G6xxRZzCy20kJ775ZdfnEitOhNRT/f000+7Z555Rh0KXjomkWq3+uqru9GjR7uxY8e6gQMHFjxz5mdzOTKPh+3YsaMTFXJnnnmmO/LII50Ydh28MS8MUbbeemvXr18/J/ZPvSaMefHFF504E/frr7/qZ8zb4mm7d+/u1lxzTWXahAkT3Hnnnefee+89/d8Yad8N86+++mo9f9xxx7nvv/9er8nqkX1eB7anb9++/tlnn/UShpTYNVQWW9SrVy9V5UmTJnlhsNoorm1Jrfkc52Vy9LsvuOACdT44IQlz9Hz4WV7PM888/qGHHvL33HOPn2mmmVKYjHwYhxPYZJNNvMRofsMNNyxhHP8vsMAC/rrrrvNvvfWWP+KII7wEuzU/EMzC+Yj0eQme/YknnqhjiL9PzIB/+OGH1VklsLlpmWZedYUVVvBvv/22ej2kI/R2nBc7pOeRFB4o/GyW+3JIoK2hCrEfTiOeOCTw3Xff9QMGDFAGtxnmmToxu4MHD1ZpCs/zf48ePbwsq/xRRx1VwthyzGiOWc2NgXvI8s5ff/31XpyJF4dTosIrrbSSF6fjxTFlkb60zINxhAcTJ04sifIZJIyTJZfaORjX3ATMOeecXrytP+WUU7wYen/77berrUKahg0bpp9nddKc5DAOvoNrWbmIwyhiEvc+8MADvTgklcQaGZiOcTy0eEGVqm7dupUMdumll/affvqp79OnT4m9sQAaKTn++OO9eEX//vvvq1offfTR+pmePXv6/fbbz4vn9o899pj/6aefNAhmicZn48mwZdxll13m77//fr0mlHKcxl133eUPO+yw1mceg5c4zl944YVFD8LA5phjDvWmgwYN0geKbSCqBmM++OADP2bMGL/GGmsUGMy15j3ttUkWjgEmX3PNNSpd5qXDCWXZJmGPl/iy5L54aiZ77rnnrmWVk455Cy+8sJf4SSUsnEkGJbGVSgtMjKUDCRg1apQyl0V9bCdbknQmCWllwt58802/yiqrlNhQrsGB4SSWWWaZonOMDdt46qmnNmtGcmceA0YKbrnllpIQgQEjUTxAzDhiQUkn+XvvvVcZW8sa1CT34IMPVntKiBTbQq7BHKCm3DN8nywOdhEJrTvzTAJQnzAYNm85cuRIPcL37TPEeXfeeaeX/FymmMuYzhqWEIgJi1WUezCJW2yxRckEEsjjzKocQ3bmcUOMNmoRzjjvEzJ89NFHmggIH4bXe++9t3/nnXdU3VNlVWDE2WefraFSbHcZ25AhQ/zll19e4qzQGiayStXNPmAOQgoGFTKBgey7777+7rvvLplRgldWFptvvnkttqbFAya9+uqr/tBDDy25L07lhx9+KJF0HBTZl2rMRpICEIvv9ddf38n6tGihzWuxJ07sYNH1ZFl23XVXXfA/8sgjSesOln6XWNNJHKdJBN4zIiMjaTG38cYbF31OVF0zM6LurhrKPNMEwx9++KGmzsPZZBYJA2KVRTpRV2xMivvHh9lTMsqbbbZZiedHSy666KKSOPSBBx5QU1LxfVxGYlapbski30kAXJRq4n1SSJMnTy6SyC5dumjF66mnnnJ5EKkmpPnGG2/UPGIoeZx75ZVXNJUVa8mTTz6pY6uUkjBPljdaAgyJwcA8ib1UHcKBkuTkAX7++eeiB0tNTzzxhJO4r+R9Sc8rk2KmkmCVGNVVSklsHjVWmBcnFmUF4ESdS66HqdidMCmaB6EJkgAoYhL3w9bOMsss+n54TvKBbsEFF6z4+zMzz7K7U6ZMKZEijDVF6pjI6lomN0/iHpgHWcEU3sNZSTCu91511VXV2dlzSOlSBaFSSiJ5xrRYiiQ5qUyNidQ8qpwnWZ2CvzAM4i+2WVYzqrqyLHMSYxbOW7G8Ukpi8ziQsvh9VANGxe8zuzbjeRLSBQNhDveDUYRNDz74oJPstpM0l5MYVO0f13BUY0Yywy1stnAaIcSBv1TB4vd5CKAS9STuif29+eabtah00kkn6fsSsihzZb3rtt9++wJOpuLvdYmIEmE4awwEFaFsGBpmw6Xk6WXt/haySPzpxo8frxW2/v37F6pmf/75p5NsiuJcZH2tY62GeUmAPtwQtUUdqasyMNSV2TaVYIZ5IKSRQeZN5skZ25VXXukkAHayftVzpp5IJH8lx6gmZujQoQoaqpSSMM9qr8svv7x7/vnndUB4OBjHa2qsks3QB8GJzD777LlLnhH3B3GF55Wyo04ozGMMeGK0gMI4dWEm+Pfff6/4u5NBzGAexWpgXpDUF9SjEgyz7oV5MAz1hvJmHuNBLVFT/krK3v3111/KHFSZA2YRSpkalwurWqIkzGOgDISVA3AKqGvXrlrtf/31191aa62l1XoYts0229QFgAhDYAZLtLwomcOQhb5bd9119TVMkgW5GmHWrwAWzWmAQQnXwI1MyZgHBoSVBvYNZwGTkDo8HLaPGIuVxbzzzqsS+V+gzGob2i5yczvuuKPm9VBNmISNYYEudQW1OSCb8Mj1CJLzpiRBsv0lYu/bt6/Gd0gchhrmSkrcScZYJVMK105S9v/famvhScgE1oxkaPfaay83bty4wvswjAgeqcQOhmtIg4A1ItXEPB6W2Kh3794aK0GWlWCtiIQRlBpjcSbYP0CIwP/tOzh69eqlsVcjUk3MQ1oIOQYPHlwkRfwlofjNN9+oyhph/6ToUshyGFMJVqVI4/bYY49CZqORqCbm8fAUcPCiqKmpLxK33Xbb6fvYNSMpdjupTmn+zFYXfIZlWrdu3ZzUDQoS3EjEdA9yVRKZYKTuqquuUiZJsdtJkUeXQMR6pH1g4KOPPqrBqpQfVRKJ7whXWBJ9/fXXyjgklfAGdSZl32j2r+JqEdUmqkzUZwHNgG5n80m/fv0U+gUMjFopNVDQmUC3uJ5KmUik7969uwJuRo8erdAHAIi8B0wCWG0Ig2iQo3LGUdIDGQAocPHFF9fi8tixY73EcQrhkoKOQmW5ThKOfqeddvLiZRUDB2Mo+1HoBtoA1g6EAe+BKgDkA4wsp/0Srcc8w5wAxOHBwYMYzGvnnXf2sob0kgQogisgTYBqkDIQSMZ8gI8SLHvJYigylGv5HnFACsuIUZwNzzweDhQS25zuu+++IumQPJ6qLgwBQGPngFOwy0dWEwq0NoaAlJJVh75vqCkDIY4YMcLLKsWLU2nrTGuZeTwMwOjTTz9dIWAgAsB/gL0LmYekYf9gYFyZB24GTiWEnHE9cP6bbrqpYOOagq1VqD9mAak966yz1FYC/WqL0tji8mzixImK4cAbElYMGzZMCyd415DYYUMmlnoF2zvxsCQH8MpkjgmobccNr/G4fCfhiVXR8LJ8N3lAYZquh6kFxzFjW6OKuGwwMpBEYE/sfVQSFZQHVGyvoaRQYQCDQL2wkeH7wlwvgbPfaqutCrYQnAseGs+dGjWV41HdB9ixCCCGB+QAY4yXxXNOnjy5AKy+9tprdWPKIYcconbMVPPWW2/VCQDYjYMxxwMsFvD2f87bhgcOQlLr6mXBEoMGBa4Ps/CWoOAlZ6fOgm1MnTt3VmatuOKKKl3AXokH2aDMa0IbPlMOZdXWj6pXGNgzVhIiVWqPSLFT96S8x8Ifu0WRhzzeqFGjNHeHfQOVRL8AlmVg5MCLYPNYrpFtIW1lGZdGoqo5jvRJoUfV9PDDD1f0p5T3dMPdlClTFBeHlzQVRLKQSlYa4OXAxh177LF+l112Ufwwnpr4rpaxtOZRU2IADylqql6TKrwVipEmCaIVSEOR2d6nFgoCiUwyFXtDELD/lWQCf2nE0GhUUyaZBx8zZoxWyFBBI5hlJUbLIltlHpWmrstrS2ORqhKnoRPQiFQT82ASkgLmgzycZUKQIjYcgx6QpIEiQiF6ovTs2VNjvE6dOhXZNTYYk2HJG26WB9Vcw4ABMDBMbpKOwpkQ4Eo8V2AezoJGMqgu+b7wO2Bco9YzMpWwYmkB/0sujwMPakTilOIQB9eEzEqxVb21KCm4EcZg/MGEkDUmNOEc2WYwcTCPei7q3ahFn5CSlB4NzEMMR62W/1kXs+YFk4xdxMuyvsVTA7yRFYlrdEqGDCU4BiFlqky1jDQ7sAteE6bAVElpKfDnv0DJyvZ4UqTLikGUHlFRvC61DCPiQDIu9VLbGPEenwuvaenacpQEJQWziNlYYpkaA5hm6UYgDVLJYj7Uuh5QC+5HsA68g1DJYGXEmRy8ps4MkgpTwnKSpSQB/ZAhQyq6RzJwI8SNTW1Z95KPY1MIjDSmWo4ubzJUKMRmmXPOOUcRDaynQbCiKbbNAJsMloa9auAH68o8QwuEqEqcA+VEgmKAhUYkS4n36kGGAwQ2C2QWJtIWycIjU1MgcEQKdBsCxVUpJUOGysK/CPXOa6SMWQ3BjDCV+m09bJ7hjoGAsGxk3wXBOv8bRhqHBkMHDBig2fA999yz4u9PFufFgEVml9UDg44fCIkk1sub8PC2libOJFgfPny4IhRwWvSiGjlypNt///11rc711VAyySuniqhyOSahunVpSTnV7hn6HdwgeUgyQsSawOEkM65BfS2UzOaVe491Lt42prx3O4ZjiE0GcSYQOPZe7LPPPprINYkzbHWllGTjHjcsh7PDq+LVYiI8wL7kGbLYNi1wMeH+NyQRr4vaghsMVRXPy8RWSklWGMRJ5bZaMmhKljFjcSQAg/KO95B6iwSMuCfvW7xnhGozoeG106IkzMODwaRYfUlJYVviyJ1lHInRcCtnauJ+rLcnTZpUNEm8pjaMgwuJsSMAANMrpSRTz0AILmMVBTLGbFL4DhkLUwlQYWBexP2A8rL1Pbw3NhC8YLkt+lLh05CrUsrMPGwIasjSBoRAvKuaHd09evQo+oyBv/v06ZMLIpTvBL1A9jrurIHkke3G84ZEMM9qiPFWQ9mrSFIlo7kz1f64iwUN/mRtW9KQBogaVTO6nqUudFsxnk5B1rjLztFwi4J7ly5dSvqqULyvtI/V1CP7YBkEkAop5BQ1pbEO3LQHATUVfoZzlCABA6VuAs09JUDXBoPxJNPDFCBl3IKO9wFotkpHHyQJlAAogvgcDAJtFQ7MQI10HqOGm0L6mqY2VQXRwP3CHqQGYwNESefukKFARABjUn+uchxpmAdjwKTQDTHu4URrSeAUsYryGhiGJEv9McccU9JXr5rD+uTRjBDYb9xJje+W4FhRqmG3Mj5H0y6K8mhHlXCPNMzjpiAA6NEZD9y6lQGOjFvwIh1SXdPuYqeddto0e4WWu69JPq02wRKCYC3XZBVILw1g4+aE559/vvbQq2Hi0jCPQ8ISVUPxZiXnkDrgGTQXbIo6iPEwPLyEDyqFwNBg6rQehs9a90YkB1VlDOWaDzJxtL8MtYLraMyFTQalWgPIKA3jDCl/0EEHKY4F1GesNjRJBVUFLiVuFdc0tV0cOGWuAcaG9wZxb3A2g6PRu4ruZyBHwbqMHz/eS824wJCmqJ8VpgQIHBMUnmMMfAc4GxtHqzAvlCLaW8KE8EHsHO0vkUDsTLnBcg1qh1FHlWhSTedt1BpGIWH87gUQX9QNlY8ZFn4XWxuAslnX7vAcPyNBuBSHLa3CPJtp+nYyYBpJx90TQVgNHDhQmSC13RYHbUBJ0FcgrWhn2bVrVzX4Jo0tTSSt0mEO2OrYiRnSi/0gGVqdp2WeDQ47xO9RAF6MmcuDcB5JYstBc7+H0VRlk2mTbuwgbTaxn0hX6MC4P/YUVSWui81LqzPPpAbPR4PomAlmu7BbMJDWvgS21qa32qDZQhwOEKvgA1F52mmGKm2MY+JwbDixjEjUfJiHdGG72CLF/grUJB4oD0NsJZUtVWOkJW7Y6lqQbvuLpLHbaMKECRogs9qJG0obk3EeqLL9mEnG58yHeTZY0PKS2dCdQM210kV1cCD8ogDBNCELYQchD4Y+lEj7mRqQ+ZIJ1h9cops3O5NA45drVW57PACX43UJ2hM9Y37Ms4ED6ib0AMgtObOSxbpJIdIKY2DapZdeqgzBswLVBRSOxLBmZesCG11Yo7I1y7p5h528wwkktGGjDR4b85BRVevHPA5mnQegpzsxHPHetH4oBNtkDEGaeGi8OGEF3xVKYjlJs794Z9SZnUVIceJny5959iAwcffdd9cwhvUnBjt1RoUDCWalQWNVzADpKexvQomrL/NCJvLjIWxaoV8xv5mBNMHEcr+cUulhao8D4lcMsIOYikSOoW0wj8PUDZUi3rKNenhMkxAYEYc4cbhj5/ku2gazfiXRyV5e+r3j4cvZ12SCYBxsDSJlTxFIsrva5QKoA9vuKdqApqIGAgiSuoKVD6l9UKhhGz6bZWhiTUGHQjqoVDbO2MbCvHtWtSrzyhEVLxCltOilPMnOInYJwWTrTEapE4ZShYNR/AVAWW9EfZtjXtg91oBDIaIp7CAUXt8aWxHaHPMaidp/WTkDtTMvA7UzLwO1My8DtZkfRK+A2pxj+x/PVyIaoJ5HpAAAAABJRU5ErkJggg=="

/***/ }),
/* 1155 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1156 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/logoLeparc.de19d411.png";

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_Routes__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Breadcrumb_Breadcrumb__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loading_overlay__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_loading_overlay___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_loading_overlay__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_bootstrap__ = __webpack_require__(495);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Body=function(_Component){_inherits(Body,_Component);function Body(){_classCallCheck(this,Body);return _possibleConstructorReturn(this,(Body.__proto__||Object.getPrototypeOf(Body)).apply(this,arguments));}_createClass(Body,[{key:"render",value:function render(){// const rutas = {
//   home: { name: "Home", path: "/" },
//   events: { name: "Eventos", path: "/events" },
//   tickets: { name: "Tickets", path: "/events/tickets" },
//   users: { name: "Usuarios", path: "/users" },
// };
return(// <div style={{ height: "100%", overflow:"scroll", backgroundColor:"blue" }}>
//    {this.props.login ? (
//     <Breadcrumb
//       routesInfo={rutas}
//       path={window.location.pathname}
//       separatorStyle={{ color: "#1bb6b1" }}
//     />
//   ) : null}
__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:this.props.style},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__config_Routes__["a" /* default */],null)));}}]);return Body;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);function mapStateToProps(store){return{login:store.auth.login,loading:store.app.loading};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Body)));

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__screens_login_LoginMain__ = __webpack_require__(452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__screens_Events__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__screens_events_AddEditEvent__ = __webpack_require__(1453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__screens_events_AddEditTicketType__ = __webpack_require__(1470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__screens_events_AddEditTicket__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__screens_events_StatisticsEvent__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__screens_events_StatisticsDirectRRPP__ = __webpack_require__(1476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__screens_events_StatisticsReferencedRRPP__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__screens_events_StatisticsProducer__ = __webpack_require__(1478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__screens_events_TicketTypes__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__screens_events_Tickets__ = __webpack_require__(1480);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__screens_Users__ = __webpack_require__(1482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__screens_Places__ = __webpack_require__(1512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__screens_Notifications__ = __webpack_require__(1513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__screens_notifications_AddEditNotifications__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__screens_News__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__screens_news_AddEditNovelty__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__screens_Roles__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__screens_roles_AddEditRoles__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__screens_statistics_Statistics__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__screens_Home__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__RoutesConstants__ = __webpack_require__(24);
// import PasswordRecovery from "../screens/login/LoginPasswordRecovery";
// import StatisticsRRPP from "../screens/events/StatisticsRRPP"
/*INIT_IMPORT_SCREENS*/var Routes=function Routes(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["e" /* Switch */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["j" /* LOGIN_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__screens_login_LoginMain__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["B" /* TICKET_TYPE_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__screens_events_AddEditTicketType__["a" /* default */],{isEditing:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["C" /* TICKET_TYPE_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__screens_events_AddEditTicketType__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["A" /* TICKET_TYPES_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__screens_events_TicketTypes__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["y" /* TICKET_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__screens_events_AddEditTicket__["a" /* default */],{isEditing:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["z" /* TICKET_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__screens_events_AddEditTicket__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["x" /* TICKETS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__screens_events_Tickets__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["a" /* EVENTS_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__screens_events_AddEditEvent__["a" /* default */],{isEditing:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["c" /* EVENTS_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__screens_events_AddEditEvent__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["b" /* EVENTS_COPY_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__screens_events_AddEditEvent__["a" /* default */],{isCopy:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["e" /* EVENTS_STATISTICS_DIRECT_RRPP_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__screens_events_StatisticsDirectRRPP__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["g" /* EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__screens_events_StatisticsReferencedRRPP__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["f" /* EVENTS_STATISTICS_PRODUCER_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__screens_events_StatisticsProducer__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["h" /* EVENTS_STATISTICS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__screens_events_StatisticsEvent__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["d" /* EVENTS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__screens_Events__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["E" /* USERS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__screens_Users__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["t" /* ROLES_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__screens_roles_AddEditRoles__["a" /* default */],{isEditing:false})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["u" /* ROLES_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__screens_roles_AddEditRoles__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["v" /* ROLES_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__screens_Roles__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["s" /* PLACES_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__screens_Places__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["D" /* UNAUTHORIZED_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"Desautorizado")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["n" /* NOTIFICATIONS_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__screens_notifications_AddEditNotifications__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["o" /* NOTIFICATIONS_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__screens_notifications_AddEditNotifications__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["p" /* NOTIFICATIONS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__screens_Notifications__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["k" /* NEWS_ADD_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__screens_news_AddEditNovelty__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["l" /* NEWS_EDIT_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__screens_news_AddEditNovelty__["a" /* default */],{isEditing:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["m" /* NEWS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__screens_News__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["w" /* STATISTICS_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__screens_statistics_Statistics__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* Route */],{path:__WEBPACK_IMPORTED_MODULE_23__RoutesConstants__["i" /* INDEX_ROUTE */]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__screens_Home__["a" /* default */],null)));};/* harmony default export */ __webpack_exports__["a"] = (Routes);

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Checkbox = __webpack_require__(411);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _createComponent = __webpack_require__(144);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Checkbox2.default, function (_ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value']),
      meta = _ref.meta,
      ignoredOnChange = _ref.onChange,
      defaultChecked = _ref.defaultChecked,
      props = _objectWithoutProperties(_ref, ['input', 'meta', 'onChange', 'defaultChecked']);

  return _extends({}, inputProps, props, {
    checked: value ? true : false,
    onChange: function onChange(event, isInputChecked) {
      _onChange(isInputChecked);
    }
  });
});

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isStateLess = exports.isStateLess = function isStateLess(Component) {
  return !Component.render;
};

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _RadioGroup = __webpack_require__(438);

var _RadioGroup2 = _interopRequireDefault(_RadioGroup);

var _createComponent = __webpack_require__(144);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_RadioGroup2.default, function (_ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value']),
      meta = _ref.meta,
      onChangeFromField = _ref.onChange,
      props = _objectWithoutProperties(_ref, ['input', 'meta', 'onChange']);

  return _extends({}, inputProps, props, {
    value: value,
    onChange: function onChange(event, value) {
      _onChange(value);
      if (onChangeFromField) {
        onChangeFromField(value);
      }
    }
  });
});

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Select = __webpack_require__(92);

var _Select2 = _interopRequireDefault(_Select);

var _createComponent = __webpack_require__(144);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(453);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Select2.default, function (_ref) {
  var _ref$input = _ref.input,
      _onChange = _ref$input.onChange,
      value = _ref$input.value,
      _onBlur = _ref$input.onBlur,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value', 'onBlur']),
      onChangeFromField = _ref.onChange,
      defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ['input', 'onChange', 'defaultValue']);

  return _extends({}, (0, _mapError2.default)(_extends({}, props, { hasHelperText: false })), inputProps, {
    value: value,
    onChange: function onChange(event) {
      _onChange(event.target.value);
      if (onChangeFromField) {
        onChangeFromField(event.target.value);
      }
    },
    onBlur: function onBlur() {
      return _onBlur(value);
    }
  });
});

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _Switch = __webpack_require__(443);

var _Switch2 = _interopRequireDefault(_Switch);

var _createComponent = __webpack_require__(144);

var _createComponent2 = _interopRequireDefault(_createComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_Switch2.default, function (_ref) {
  var _ref$input = _ref.input,
      onChange = _ref$input.onChange,
      value = _ref$input.value,
      inputProps = _objectWithoutProperties(_ref$input, ['onChange', 'value']),
      checked = _ref.checked,
      meta = _ref.meta,
      props = _objectWithoutProperties(_ref, ['input', 'checked', 'meta']);

  return _extends({}, inputProps, props, {
    onChange: onChange,
    checked: !!value
  });
});

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _TextField = __webpack_require__(449);

var _TextField2 = _interopRequireDefault(_TextField);

var _createComponent = __webpack_require__(144);

var _createComponent2 = _interopRequireDefault(_createComponent);

var _mapError = __webpack_require__(453);

var _mapError2 = _interopRequireDefault(_mapError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = (0, _createComponent2.default)(_TextField2.default, function (_ref) {
  var defaultValue = _ref.defaultValue,
      props = _objectWithoutProperties(_ref, ['defaultValue']);

  return _extends({}, (0, _mapError2.default)(props));
});

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(1167);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 1167 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_FirebaseConnector__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_Endpoints__ = __webpack_require__(1250);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var firebaseConnector=new __WEBPACK_IMPORTED_MODULE_1__lib_FirebaseConnector__["a" /* default */]({timeout:30000});var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var AuthConfig=function(){function AuthConfig(){_classCallCheck(this,AuthConfig);}_createClass(AuthConfig,null,[{key:"base",get:function get(){return __WEBPACK_IMPORTED_MODULE_2__config_Endpoints__["a" /* SERVER_URL */]+"/verifyToken";}},{key:"endpointVerifyToken",get:function get(){return AuthConfig.base+"/isAllowed";}},{key:"FirebaseConnector",get:function get(){return firebaseConnector;}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return AuthConfig;}();/* harmony default export */ __webpack_exports__["a"] = (AuthConfig);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export LogLevels */
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var LogLevels={LOG:'log',INFO:'info',WARN:'warn',ERROR:'error'};var Logger=function(){function Logger(){var name=arguments.length>0&&arguments[0]!==undefined?arguments[0]:'main';var printTimestamp=arguments.length>1&&arguments[1]!==undefined?arguments[1]:false;_classCallCheck(this,Logger);this._name=name;this._printTimestamp=!!printTimestamp;this._console=console;}_createClass(Logger,[{key:'log',value:function log(){for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return this._log.apply(this,[LogLevels.LOG].concat(args));}},{key:'info',value:function info(){for(var _len2=arguments.length,args=Array(_len2),_key2=0;_key2<_len2;_key2++){args[_key2]=arguments[_key2];}return this._log.apply(this,[LogLevels.INFO].concat(args));}},{key:'warn',value:function warn(){for(var _len3=arguments.length,args=Array(_len3),_key3=0;_key3<_len3;_key3++){args[_key3]=arguments[_key3];}return this._log.apply(this,[LogLevels.WARN].concat(args));}},{key:'error',value:function error(){for(var _len4=arguments.length,args=Array(_len4),_key4=0;_key4<_len4;_key4++){args[_key4]=arguments[_key4];}return this._log.apply(this,[LogLevels.ERROR].concat(args));}},{key:'setPrintTimestamp',value:function setPrintTimestamp(){var val=arguments.length>0&&arguments[0]!==undefined?arguments[0]:true;this._printTimestamp=!!val;return this;}},{key:'_log',value:function _log(){var level=arguments.length>0&&arguments[0]!==undefined?arguments[0]:LogLevels.INFO;var ts=this._printTimestamp?+new Date()+' ':'';try{var _console;for(var _len5=arguments.length,args=Array(_len5>1?_len5-1:0),_key5=1;_key5<_len5;_key5++){args[_key5-1]=arguments[_key5];}(_console=this._console)[level].apply(_console,['['+this._name+'] '+ts+level+':'].concat(args));}catch(e){console.error(e);}return this;}}]);return Logger;}();/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

/* 
  @package NOTY - Dependency-free notification library 
  @version version: 3.1.4 
  @contributors https://github.com/needim/noty/graphs/contributors 
  @documentation Examples and Documentation - http://needim.github.com/noty 
  @license Licensed under the MIT licenses: http://www.opensource.org/licenses/mit-license.php 
*/

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("Noty", [], factory);
	else if(typeof exports === 'object')
		exports["Noty"] = factory();
	else
		root["Noty"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 6);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.css = exports.deepExtend = exports.animationEndEvents = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.inArray = inArray;
exports.stopPropagation = stopPropagation;
exports.generateID = generateID;
exports.outerHeight = outerHeight;
exports.addListener = addListener;
exports.hasClass = hasClass;
exports.addClass = addClass;
exports.removeClass = removeClass;
exports.remove = remove;
exports.classList = classList;
exports.visibilityChangeFlow = visibilityChangeFlow;
exports.createAudioElements = createAudioElements;

var _api = __webpack_require__(1);

var API = _interopRequireWildcard(_api);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var animationEndEvents = exports.animationEndEvents = 'webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend';

function inArray(needle, haystack, argStrict) {
  var key = void 0;
  var strict = !!argStrict;

  if (strict) {
    for (key in haystack) {
      if (haystack.hasOwnProperty(key) && haystack[key] === needle) {
        return true;
      }
    }
  } else {
    for (key in haystack) {
      if (haystack.hasOwnProperty(key) && haystack[key] === needle) {
        return true;
      }
    }
  }
  return false;
}

function stopPropagation(evt) {
  evt = evt || window.event;

  if (typeof evt.stopPropagation !== 'undefined') {
    evt.stopPropagation();
  } else {
    evt.cancelBubble = true;
  }
}

var deepExtend = exports.deepExtend = function deepExtend(out) {
  out = out || {};

  for (var i = 1; i < arguments.length; i++) {
    var obj = arguments[i];

    if (!obj) continue;

    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (Array.isArray(obj[key])) {
          out[key] = obj[key];
        } else if (_typeof(obj[key]) === 'object' && obj[key] !== null) {
          out[key] = deepExtend(out[key], obj[key]);
        } else {
          out[key] = obj[key];
        }
      }
    }
  }

  return out;
};

function generateID() {
  var prefix = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  var id = 'noty_' + prefix + '_';

  id += 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === 'x' ? r : r & 0x3 | 0x8;
    return v.toString(16);
  });

  return id;
}

function outerHeight(el) {
  var height = el.offsetHeight;
  var style = window.getComputedStyle(el);

  height += parseInt(style.marginTop) + parseInt(style.marginBottom);
  return height;
}

var css = exports.css = function () {
  var cssPrefixes = ['Webkit', 'O', 'Moz', 'ms'];
  var cssProps = {};

  function camelCase(string) {
    return string.replace(/^-ms-/, 'ms-').replace(/-([\da-z])/gi, function (match, letter) {
      return letter.toUpperCase();
    });
  }

  function getVendorProp(name) {
    var style = document.body.style;
    if (name in style) return name;

    var i = cssPrefixes.length;
    var capName = name.charAt(0).toUpperCase() + name.slice(1);
    var vendorName = void 0;

    while (i--) {
      vendorName = cssPrefixes[i] + capName;
      if (vendorName in style) return vendorName;
    }

    return name;
  }

  function getStyleProp(name) {
    name = camelCase(name);
    return cssProps[name] || (cssProps[name] = getVendorProp(name));
  }

  function applyCss(element, prop, value) {
    prop = getStyleProp(prop);
    element.style[prop] = value;
  }

  return function (element, properties) {
    var args = arguments;
    var prop = void 0;
    var value = void 0;

    if (args.length === 2) {
      for (prop in properties) {
        if (properties.hasOwnProperty(prop)) {
          value = properties[prop];
          if (value !== undefined && properties.hasOwnProperty(prop)) {
            applyCss(element, prop, value);
          }
        }
      }
    } else {
      applyCss(element, args[1], args[2]);
    }
  };
}();

function addListener(el, events, cb) {
  var useCapture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  events = events.split(' ');
  for (var i = 0; i < events.length; i++) {
    if (document.addEventListener) {
      el.addEventListener(events[i], cb, useCapture);
    } else if (document.attachEvent) {
      el.attachEvent('on' + events[i], cb);
    }
  }
}

function hasClass(element, name) {
  var list = typeof element === 'string' ? element : classList(element);
  return list.indexOf(' ' + name + ' ') >= 0;
}

function addClass(element, name) {
  var oldList = classList(element);
  var newList = oldList + name;

  if (hasClass(oldList, name)) return;

  // Trim the opening space.
  element.className = newList.substring(1);
}

function removeClass(element, name) {
  var oldList = classList(element);
  var newList = void 0;

  if (!hasClass(element, name)) return;

  // Replace the class name.
  newList = oldList.replace(' ' + name + ' ', ' ');

  // Trim the opening and closing spaces.
  element.className = newList.substring(1, newList.length - 1);
}

function remove(element) {
  if (element.parentNode) {
    element.parentNode.removeChild(element);
  }
}

function classList(element) {
  return (' ' + (element && element.className || '') + ' ').replace(/\s+/gi, ' ');
}

function visibilityChangeFlow() {
  var hidden = void 0;
  var visibilityChange = void 0;
  if (typeof document.hidden !== 'undefined') {
    // Opera 12.10 and Firefox 18 and later support
    hidden = 'hidden';
    visibilityChange = 'visibilitychange';
  } else if (typeof document.msHidden !== 'undefined') {
    hidden = 'msHidden';
    visibilityChange = 'msvisibilitychange';
  } else if (typeof document.webkitHidden !== 'undefined') {
    hidden = 'webkitHidden';
    visibilityChange = 'webkitvisibilitychange';
  }

  function onVisibilityChange() {
    API.PageHidden = document[hidden];
    handleVisibilityChange();
  }

  function onBlur() {
    API.PageHidden = true;
    handleVisibilityChange();
  }

  function onFocus() {
    API.PageHidden = false;
    handleVisibilityChange();
  }

  function handleVisibilityChange() {
    if (API.PageHidden) stopAll();else resumeAll();
  }

  function stopAll() {
    setTimeout(function () {
      Object.keys(API.Store).forEach(function (id) {
        if (API.Store.hasOwnProperty(id)) {
          if (API.Store[id].options.visibilityControl) {
            API.Store[id].stop();
          }
        }
      });
    }, 100);
  }

  function resumeAll() {
    setTimeout(function () {
      Object.keys(API.Store).forEach(function (id) {
        if (API.Store.hasOwnProperty(id)) {
          if (API.Store[id].options.visibilityControl) {
            API.Store[id].resume();
          }
        }
      });
      API.queueRenderAll();
    }, 100);
  }

  if (visibilityChange) {
    addListener(document, visibilityChange, onVisibilityChange);
  }

  addListener(window, 'blur', onBlur);
  addListener(window, 'focus', onFocus);
}

function createAudioElements(ref) {
  if (ref.hasSound) {
    var audioElement = document.createElement('audio');

    ref.options.sounds.sources.forEach(function (s) {
      var source = document.createElement('source');
      source.src = s;
      source.type = 'audio/' + getExtension(s);
      audioElement.appendChild(source);
    });

    if (ref.barDom) {
      ref.barDom.appendChild(audioElement);
    } else {
      document.querySelector('body').appendChild(audioElement);
    }

    audioElement.volume = ref.options.sounds.volume;

    if (!ref.soundPlayed) {
      audioElement.play();
      ref.soundPlayed = true;
    }

    audioElement.onended = function () {
      remove(audioElement);
    };
  }
}

function getExtension(fileName) {
  return fileName.match(/\.([^.]+)$/)[1];
}

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Defaults = exports.Store = exports.Queues = exports.DefaultMaxVisible = exports.docTitle = exports.DocModalCount = exports.PageHidden = undefined;
exports.getQueueCounts = getQueueCounts;
exports.addToQueue = addToQueue;
exports.removeFromQueue = removeFromQueue;
exports.queueRender = queueRender;
exports.queueRenderAll = queueRenderAll;
exports.ghostFix = ghostFix;
exports.build = build;
exports.hasButtons = hasButtons;
exports.handleModal = handleModal;
exports.handleModalClose = handleModalClose;
exports.queueClose = queueClose;
exports.dequeueClose = dequeueClose;
exports.fire = fire;
exports.openFlow = openFlow;
exports.closeFlow = closeFlow;

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var PageHidden = exports.PageHidden = false;
var DocModalCount = exports.DocModalCount = 0;

var DocTitleProps = {
  originalTitle: null,
  count: 0,
  changed: false,
  timer: -1
};

var docTitle = exports.docTitle = {
  increment: function increment() {
    DocTitleProps.count++;

    docTitle._update();
  },

  decrement: function decrement() {
    DocTitleProps.count--;

    if (DocTitleProps.count <= 0) {
      docTitle._clear();
      return;
    }

    docTitle._update();
  },

  _update: function _update() {
    var title = document.title;

    if (!DocTitleProps.changed) {
      DocTitleProps.originalTitle = title;
      document.title = '(' + DocTitleProps.count + ') ' + title;
      DocTitleProps.changed = true;
    } else {
      document.title = '(' + DocTitleProps.count + ') ' + DocTitleProps.originalTitle;
    }
  },

  _clear: function _clear() {
    if (DocTitleProps.changed) {
      DocTitleProps.count = 0;
      document.title = DocTitleProps.originalTitle;
      DocTitleProps.changed = false;
    }
  }
};

var DefaultMaxVisible = exports.DefaultMaxVisible = 5;

var Queues = exports.Queues = {
  global: {
    maxVisible: DefaultMaxVisible,
    queue: []
  }
};

var Store = exports.Store = {};

var Defaults = exports.Defaults = {
  type: 'alert',
  layout: 'topRight',
  theme: 'mint',
  text: '',
  timeout: false,
  progressBar: true,
  closeWith: ['click'],
  animation: {
    open: 'noty_effects_open',
    close: 'noty_effects_close'
  },
  id: false,
  force: false,
  killer: false,
  queue: 'global',
  container: false,
  buttons: [],
  callbacks: {
    beforeShow: null,
    onShow: null,
    afterShow: null,
    onClose: null,
    afterClose: null,
    onClick: null,
    onHover: null,
    onTemplate: null
  },
  sounds: {
    sources: [],
    volume: 1,
    conditions: []
  },
  titleCount: {
    conditions: []
  },
  modal: false,
  visibilityControl: false

  /**
   * @param {string} queueName
   * @return {object}
   */
};function getQueueCounts() {
  var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';

  var count = 0;
  var max = DefaultMaxVisible;

  if (Queues.hasOwnProperty(queueName)) {
    max = Queues[queueName].maxVisible;
    Object.keys(Store).forEach(function (i) {
      if (Store[i].options.queue === queueName && !Store[i].closed) count++;
    });
  }

  return {
    current: count,
    maxVisible: max
  };
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function addToQueue(ref) {
  if (!Queues.hasOwnProperty(ref.options.queue)) {
    Queues[ref.options.queue] = { maxVisible: DefaultMaxVisible, queue: [] };
  }

  Queues[ref.options.queue].queue.push(ref);
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function removeFromQueue(ref) {
  if (Queues.hasOwnProperty(ref.options.queue)) {
    var queue = [];
    Object.keys(Queues[ref.options.queue].queue).forEach(function (i) {
      if (Queues[ref.options.queue].queue[i].id !== ref.id) {
        queue.push(Queues[ref.options.queue].queue[i]);
      }
    });
    Queues[ref.options.queue].queue = queue;
  }
}

/**
 * @param {string} queueName
 * @return {void}
 */
function queueRender() {
  var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'global';

  if (Queues.hasOwnProperty(queueName)) {
    var noty = Queues[queueName].queue.shift();

    if (noty) noty.show();
  }
}

/**
 * @return {void}
 */
function queueRenderAll() {
  Object.keys(Queues).forEach(function (queueName) {
    queueRender(queueName);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function ghostFix(ref) {
  var ghostID = Utils.generateID('ghost');
  var ghost = document.createElement('div');
  ghost.setAttribute('id', ghostID);
  Utils.css(ghost, {
    height: Utils.outerHeight(ref.barDom) + 'px'
  });

  ref.barDom.insertAdjacentHTML('afterend', ghost.outerHTML);

  Utils.remove(ref.barDom);
  ghost = document.getElementById(ghostID);
  Utils.addClass(ghost, 'noty_fix_effects_height');
  Utils.addListener(ghost, Utils.animationEndEvents, function () {
    Utils.remove(ghost);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function build(ref) {
  findOrCreateContainer(ref);

  var markup = '<div class="noty_body">' + ref.options.text + '</div>' + buildButtons(ref) + '<div class="noty_progressbar"></div>';

  ref.barDom = document.createElement('div');
  ref.barDom.setAttribute('id', ref.id);
  Utils.addClass(ref.barDom, 'noty_bar noty_type__' + ref.options.type + ' noty_theme__' + ref.options.theme);

  ref.barDom.innerHTML = markup;

  fire(ref, 'onTemplate');
}

/**
 * @param {Noty} ref
 * @return {boolean}
 */
function hasButtons(ref) {
  return !!(ref.options.buttons && Object.keys(ref.options.buttons).length);
}

/**
 * @param {Noty} ref
 * @return {string}
 */
function buildButtons(ref) {
  if (hasButtons(ref)) {
    var buttons = document.createElement('div');
    Utils.addClass(buttons, 'noty_buttons');

    Object.keys(ref.options.buttons).forEach(function (key) {
      buttons.appendChild(ref.options.buttons[key].dom);
    });

    ref.options.buttons.forEach(function (btn) {
      buttons.appendChild(btn.dom);
    });
    return buttons.outerHTML;
  }
  return '';
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function handleModal(ref) {
  if (ref.options.modal) {
    if (DocModalCount === 0) {
      createModal(ref);
    }

    exports.DocModalCount = DocModalCount += 1;
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function handleModalClose(ref) {
  if (ref.options.modal && DocModalCount > 0) {
    exports.DocModalCount = DocModalCount -= 1;

    if (DocModalCount <= 0) {
      var modal = document.querySelector('.noty_modal');

      if (modal) {
        Utils.removeClass(modal, 'noty_modal_open');
        Utils.addClass(modal, 'noty_modal_close');
        Utils.addListener(modal, Utils.animationEndEvents, function () {
          Utils.remove(modal);
        });
      }
    }
  }
}

/**
 * @return {void}
 */
function createModal() {
  var body = document.querySelector('body');
  var modal = document.createElement('div');
  Utils.addClass(modal, 'noty_modal');
  body.insertBefore(modal, body.firstChild);
  Utils.addClass(modal, 'noty_modal_open');

  Utils.addListener(modal, Utils.animationEndEvents, function () {
    Utils.removeClass(modal, 'noty_modal_open');
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function findOrCreateContainer(ref) {
  if (ref.options.container) {
    ref.layoutDom = document.querySelector(ref.options.container);
    return;
  }

  var layoutID = 'noty_layout__' + ref.options.layout;
  ref.layoutDom = document.querySelector('div#' + layoutID);

  if (!ref.layoutDom) {
    ref.layoutDom = document.createElement('div');
    ref.layoutDom.setAttribute('id', layoutID);
    ref.layoutDom.setAttribute('role', 'alert');
    ref.layoutDom.setAttribute('aria-live', 'polite');
    Utils.addClass(ref.layoutDom, 'noty_layout');
    document.querySelector('body').appendChild(ref.layoutDom);
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function queueClose(ref) {
  if (ref.options.timeout) {
    if (ref.options.progressBar && ref.progressDom) {
      Utils.css(ref.progressDom, {
        transition: 'width ' + ref.options.timeout + 'ms linear',
        width: '0%'
      });
    }

    clearTimeout(ref.closeTimer);

    ref.closeTimer = setTimeout(function () {
      ref.close();
    }, ref.options.timeout);
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function dequeueClose(ref) {
  if (ref.options.timeout && ref.closeTimer) {
    clearTimeout(ref.closeTimer);
    ref.closeTimer = -1;

    if (ref.options.progressBar && ref.progressDom) {
      Utils.css(ref.progressDom, {
        transition: 'width 0ms linear',
        width: '100%'
      });
    }
  }
}

/**
 * @param {Noty} ref
 * @param {string} eventName
 * @return {void}
 */
function fire(ref, eventName) {
  if (ref.listeners.hasOwnProperty(eventName)) {
    ref.listeners[eventName].forEach(function (cb) {
      if (typeof cb === 'function') {
        cb.apply(ref);
      }
    });
  }
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function openFlow(ref) {
  fire(ref, 'afterShow');
  queueClose(ref);

  Utils.addListener(ref.barDom, 'mouseenter', function () {
    dequeueClose(ref);
  });

  Utils.addListener(ref.barDom, 'mouseleave', function () {
    queueClose(ref);
  });
}

/**
 * @param {Noty} ref
 * @return {void}
 */
function closeFlow(ref) {
  delete Store[ref.id];
  ref.closing = false;
  fire(ref, 'afterClose');

  Utils.remove(ref.barDom);

  if (ref.layoutDom.querySelectorAll('.noty_bar').length === 0 && !ref.options.container) {
    Utils.remove(ref.layoutDom);
  }

  if (Utils.inArray('docVisible', ref.options.titleCount.conditions) || Utils.inArray('docHidden', ref.options.titleCount.conditions)) {
    docTitle.decrement();
  }

  queueRender(ref.options.queue);
}

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NotyButton = undefined;

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var NotyButton = exports.NotyButton = function NotyButton(html, classes, cb) {
  var _this = this;

  var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  _classCallCheck(this, NotyButton);

  this.dom = document.createElement('button');
  this.dom.innerHTML = html;
  this.id = attributes.id = attributes.id || Utils.generateID('button');
  this.cb = cb;
  Object.keys(attributes).forEach(function (propertyName) {
    _this.dom.setAttribute(propertyName, attributes[propertyName]);
  });
  Utils.addClass(this.dom, classes || 'noty_btn');

  return this;
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Push = exports.Push = function () {
  function Push() {
    var workerPath = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/service-worker.js';

    _classCallCheck(this, Push);

    this.subData = {};
    this.workerPath = workerPath;
    this.listeners = {
      onPermissionGranted: [],
      onPermissionDenied: [],
      onSubscriptionSuccess: [],
      onSubscriptionCancel: [],
      onWorkerError: [],
      onWorkerSuccess: [],
      onWorkerNotSupported: []
    };
    return this;
  }

  /**
   * @param {string} eventName
   * @param {function} cb
   * @return {Push}
   */


  _createClass(Push, [{
    key: 'on',
    value: function on(eventName) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (typeof cb === 'function' && this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].push(cb);
      }

      return this;
    }
  }, {
    key: 'fire',
    value: function fire(eventName) {
      var _this = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      if (this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].forEach(function (cb) {
          if (typeof cb === 'function') {
            cb.apply(_this, params);
          }
        });
      }
    }
  }, {
    key: 'create',
    value: function create() {
      console.log('NOT IMPLEMENTED YET');
    }

    /**
     * @return {boolean}
     */

  }, {
    key: 'isSupported',
    value: function isSupported() {
      var result = false;

      try {
        result = window.Notification || window.webkitNotifications || navigator.mozNotification || window.external && window.external.msIsSiteMode() !== undefined;
      } catch (e) {}

      return result;
    }

    /**
     * @return {string}
     */

  }, {
    key: 'getPermissionStatus',
    value: function getPermissionStatus() {
      var perm = 'default';

      if (window.Notification && window.Notification.permissionLevel) {
        perm = window.Notification.permissionLevel;
      } else if (window.webkitNotifications && window.webkitNotifications.checkPermission) {
        switch (window.webkitNotifications.checkPermission()) {
          case 1:
            perm = 'default';
            break;
          case 0:
            perm = 'granted';
            break;
          default:
            perm = 'denied';
        }
      } else if (window.Notification && window.Notification.permission) {
        perm = window.Notification.permission;
      } else if (navigator.mozNotification) {
        perm = 'granted';
      } else if (window.external && window.external.msIsSiteMode() !== undefined) {
        perm = window.external.msIsSiteMode() ? 'granted' : 'default';
      }

      return perm.toString().toLowerCase();
    }

    /**
     * @return {string}
     */

  }, {
    key: 'getEndpoint',
    value: function getEndpoint(subscription) {
      var endpoint = subscription.endpoint;
      var subscriptionId = subscription.subscriptionId;

      // fix for Chrome < 45
      if (subscriptionId && endpoint.indexOf(subscriptionId) === -1) {
        endpoint += '/' + subscriptionId;
      }

      return endpoint;
    }

    /**
     * @return {boolean}
     */

  }, {
    key: 'isSWRegistered',
    value: function isSWRegistered() {
      try {
        return navigator.serviceWorker.controller.state === 'activated';
      } catch (e) {
        return false;
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'unregisterWorker',
    value: function unregisterWorker() {
      var self = this;
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistrations().then(function (registrations) {
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = registrations[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var registration = _step.value;

              registration.unregister();
              self.fire('onSubscriptionCancel');
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }
        });
      }
    }

    /**
     * @return {void}
     */

  }, {
    key: 'requestSubscription',
    value: function requestSubscription() {
      var _this2 = this;

      var userVisibleOnly = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var self = this;
      var current = this.getPermissionStatus();
      var cb = function cb(result) {
        if (result === 'granted') {
          _this2.fire('onPermissionGranted');

          if ('serviceWorker' in navigator) {
            navigator.serviceWorker.register(_this2.workerPath).then(function () {
              navigator.serviceWorker.ready.then(function (serviceWorkerRegistration) {
                self.fire('onWorkerSuccess');
                serviceWorkerRegistration.pushManager.subscribe({
                  userVisibleOnly: userVisibleOnly
                }).then(function (subscription) {
                  var key = subscription.getKey('p256dh');
                  var token = subscription.getKey('auth');

                  self.subData = {
                    endpoint: self.getEndpoint(subscription),
                    p256dh: key ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null,
                    auth: token ? window.btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null
                  };

                  self.fire('onSubscriptionSuccess', [self.subData]);
                }).catch(function (err) {
                  self.fire('onWorkerError', [err]);
                });
              });
            });
          } else {
            self.fire('onWorkerNotSupported');
          }
        } else if (result === 'denied') {
          _this2.fire('onPermissionDenied');
          _this2.unregisterWorker();
        }
      };

      if (current === 'default') {
        if (window.Notification && window.Notification.requestPermission) {
          window.Notification.requestPermission(cb);
        } else if (window.webkitNotifications && window.webkitNotifications.checkPermission) {
          window.webkitNotifications.requestPermission(cb);
        }
      } else {
        cb(current);
      }
    }
  }]);

  return Push;
}();

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process, global) {var require;/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   4.1.1
 */

(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}

var _isArray = undefined;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = undefined;
var customSchedulerFn = undefined;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && ({}).toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var r = require;
    var vertx = __webpack_require__(9);
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = undefined;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && "function" === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var _arguments = arguments;

  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;

  if (_state) {
    (function () {
      var callback = _arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    })();
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(16);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var GET_THEN_ERROR = new ErrorObject();

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    GET_THEN_ERROR.error = error;
    return GET_THEN_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === GET_THEN_ERROR) {
      reject(promise, GET_THEN_ERROR.error);
      GET_THEN_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;

  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = undefined,
      callback = undefined,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function ErrorObject() {
  this.error = null;
}

var TRY_CATCH_ERROR = new ErrorObject();

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = undefined,
      error = undefined,
      succeeded = undefined,
      failed = undefined;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function Enumerator$1(Constructor, input) {
  this._instanceConstructor = Constructor;
  this.promise = new Constructor(noop);

  if (!this.promise[PROMISE_ID]) {
    makePromise(this.promise);
  }

  if (isArray(input)) {
    this.length = input.length;
    this._remaining = input.length;

    this._result = new Array(this.length);

    if (this.length === 0) {
      fulfill(this.promise, this._result);
    } else {
      this.length = this.length || 0;
      this._enumerate(input);
      if (this._remaining === 0) {
        fulfill(this.promise, this._result);
      }
    }
  } else {
    reject(this.promise, validationError());
  }
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

Enumerator$1.prototype._enumerate = function (input) {
  for (var i = 0; this._state === PENDING && i < input.length; i++) {
    this._eachEntry(input[i], i);
  }
};

Enumerator$1.prototype._eachEntry = function (entry, i) {
  var c = this._instanceConstructor;
  var resolve$$1 = c.resolve;

  if (resolve$$1 === resolve$1) {
    var _then = getThen(entry);

    if (_then === then && entry._state !== PENDING) {
      this._settledAt(entry._state, i, entry._result);
    } else if (typeof _then !== 'function') {
      this._remaining--;
      this._result[i] = entry;
    } else if (c === Promise$2) {
      var promise = new c(noop);
      handleMaybeThenable(promise, entry, _then);
      this._willSettleAt(promise, i);
    } else {
      this._willSettleAt(new c(function (resolve$$1) {
        return resolve$$1(entry);
      }), i);
    }
  } else {
    this._willSettleAt(resolve$$1(entry), i);
  }
};

Enumerator$1.prototype._settledAt = function (state, i, value) {
  var promise = this.promise;

  if (promise._state === PENDING) {
    this._remaining--;

    if (state === REJECTED) {
      reject(promise, value);
    } else {
      this._result[i] = value;
    }
  }

  if (this._remaining === 0) {
    fulfill(promise, this._result);
  }
};

Enumerator$1.prototype._willSettleAt = function (promise, i) {
  var enumerator = this;

  subscribe(promise, undefined, function (value) {
    return enumerator._settledAt(FULFILLED, i, value);
  }, function (reason) {
    return enumerator._settledAt(REJECTED, i, reason);
  });
};

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all$1(entries) {
  return new Enumerator$1(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race$1(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {function} resolver
  Useful for tooling.
  @constructor
*/
function Promise$2(resolver) {
  this[PROMISE_ID] = nextId();
  this._result = this._state = undefined;
  this._subscribers = [];

  if (noop !== resolver) {
    typeof resolver !== 'function' && needsResolver();
    this instanceof Promise$2 ? initializePromise(this, resolver) : needsNew();
  }
}

Promise$2.all = all$1;
Promise$2.race = race$1;
Promise$2.resolve = resolve$1;
Promise$2.reject = reject$1;
Promise$2._setScheduler = setScheduler;
Promise$2._setAsap = setAsap;
Promise$2._asap = asap;

Promise$2.prototype = {
  constructor: Promise$2,

  /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
  
    ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
  
    Chaining
    --------
  
    The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
  
    ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
  
    findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
  
    ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
  
    Assimilation
    ------------
  
    Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
  
    If the assimliated promise rejects, then the downstream promise will also reject.
  
    ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
  
    Simple Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let result;
  
    try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
  
    Advanced Example
    --------------
  
    Synchronous Example
  
    ```javascript
    let author, books;
  
    try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
  
    Errback Example
  
    ```js
  
    function foundBooks(books) {
  
    }
  
    function failure(reason) {
  
    }
  
    findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
  
    Promise Example;
  
    ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
  
    @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
  */
  then: then,

  /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
  
    ```js
    function findAuthor(){
      throw new Error('couldn't find that author');
    }
  
    // synchronous
    try {
      findAuthor();
    } catch(reason) {
      // something went wrong
    }
  
    // async with promises
    findAuthor().catch(function(reason){
      // something went wrong
    });
    ```
  
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
  */
  'catch': function _catch(onRejection) {
    return this.then(null, onRejection);
  }
};

/*global self*/
function polyfill$1() {
    var local = undefined;

    if (typeof global !== 'undefined') {
        local = global;
    } else if (typeof self !== 'undefined') {
        local = self;
    } else {
        try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
    }

    var P = local.Promise;

    if (P) {
        var promiseToString = null;
        try {
            promiseToString = Object.prototype.toString.call(P.resolve());
        } catch (e) {
            // silently ignored
        }

        if (promiseToString === '[object Promise]' && !P.cast) {
            return;
        }
    }

    local.Promise = Promise$2;
}

// Strange compat..
Promise$2.polyfill = polyfill$1;
Promise$2.Promise = Promise$2;

return Promise$2;

})));

//# sourceMappingURL=es6-promise.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7), __webpack_require__(8)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /* global VERSION */

__webpack_require__(5);

var _es6Promise = __webpack_require__(4);

var _es6Promise2 = _interopRequireDefault(_es6Promise);

var _utils = __webpack_require__(0);

var Utils = _interopRequireWildcard(_utils);

var _api = __webpack_require__(1);

var API = _interopRequireWildcard(_api);

var _button = __webpack_require__(2);

var _push = __webpack_require__(3);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Noty = function () {
  /**
   * @param {object} options
   * @return {Noty}
   */
  function Noty() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Noty);

    this.options = Utils.deepExtend({}, API.Defaults, options);
    this.id = this.options.id || Utils.generateID('bar');
    this.closeTimer = -1;
    this.barDom = null;
    this.layoutDom = null;
    this.progressDom = null;
    this.showing = false;
    this.shown = false;
    this.closed = false;
    this.closing = false;
    this.killable = this.options.timeout || this.options.closeWith.length > 0;
    this.hasSound = this.options.sounds.sources.length > 0;
    this.soundPlayed = false;
    this.listeners = {
      beforeShow: [],
      onShow: [],
      afterShow: [],
      onClose: [],
      afterClose: [],
      onClick: [],
      onHover: [],
      onTemplate: []
    };
    this.promises = {
      show: null,
      close: null
    };
    this.on('beforeShow', this.options.callbacks.beforeShow);
    this.on('onShow', this.options.callbacks.onShow);
    this.on('afterShow', this.options.callbacks.afterShow);
    this.on('onClose', this.options.callbacks.onClose);
    this.on('afterClose', this.options.callbacks.afterClose);
    this.on('onClick', this.options.callbacks.onClick);
    this.on('onHover', this.options.callbacks.onHover);
    this.on('onTemplate', this.options.callbacks.onTemplate);

    return this;
  }

  /**
   * @param {string} eventName
   * @param {function} cb
   * @return {Noty}
   */


  _createClass(Noty, [{
    key: 'on',
    value: function on(eventName) {
      var cb = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};

      if (typeof cb === 'function' && this.listeners.hasOwnProperty(eventName)) {
        this.listeners[eventName].push(cb);
      }

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'show',
    value: function show() {
      var _this = this;

      if (this.options.killer === true) {
        Noty.closeAll();
      } else if (typeof this.options.killer === 'string') {
        Noty.closeAll(this.options.killer);
      }

      var queueCounts = API.getQueueCounts(this.options.queue);

      if (queueCounts.current >= queueCounts.maxVisible || API.PageHidden && this.options.visibilityControl) {
        API.addToQueue(this);

        if (API.PageHidden && this.hasSound && Utils.inArray('docHidden', this.options.sounds.conditions)) {
          Utils.createAudioElements(this);
        }

        if (API.PageHidden && Utils.inArray('docHidden', this.options.titleCount.conditions)) {
          API.docTitle.increment();
        }

        return this;
      }

      API.Store[this.id] = this;

      API.fire(this, 'beforeShow');

      this.showing = true;

      if (this.closing) {
        this.showing = false;
        return this;
      }

      API.build(this);
      API.handleModal(this);

      if (this.options.force) {
        this.layoutDom.insertBefore(this.barDom, this.layoutDom.firstChild);
      } else {
        this.layoutDom.appendChild(this.barDom);
      }

      if (this.hasSound && !this.soundPlayed && Utils.inArray('docVisible', this.options.sounds.conditions)) {
        Utils.createAudioElements(this);
      }

      if (Utils.inArray('docVisible', this.options.titleCount.conditions)) {
        API.docTitle.increment();
      }

      this.shown = true;
      this.closed = false;

      // bind button events if any
      if (API.hasButtons(this)) {
        Object.keys(this.options.buttons).forEach(function (key) {
          var btn = _this.barDom.querySelector('#' + _this.options.buttons[key].id);
          Utils.addListener(btn, 'click', function (e) {
            Utils.stopPropagation(e);
            _this.options.buttons[key].cb();
          });
        });
      }

      this.progressDom = this.barDom.querySelector('.noty_progressbar');

      if (Utils.inArray('click', this.options.closeWith)) {
        Utils.addClass(this.barDom, 'noty_close_with_click');
        Utils.addListener(this.barDom, 'click', function (e) {
          Utils.stopPropagation(e);
          API.fire(_this, 'onClick');
          _this.close();
        }, false);
      }

      Utils.addListener(this.barDom, 'mouseenter', function () {
        API.fire(_this, 'onHover');
      }, false);

      if (this.options.timeout) Utils.addClass(this.barDom, 'noty_has_timeout');
      if (this.options.progressBar) {
        Utils.addClass(this.barDom, 'noty_has_progressbar');
      }

      if (Utils.inArray('button', this.options.closeWith)) {
        Utils.addClass(this.barDom, 'noty_close_with_button');

        var closeButton = document.createElement('div');
        Utils.addClass(closeButton, 'noty_close_button');
        closeButton.innerHTML = '×';
        this.barDom.appendChild(closeButton);

        Utils.addListener(closeButton, 'click', function (e) {
          Utils.stopPropagation(e);
          _this.close();
        }, false);
      }

      API.fire(this, 'onShow');

      if (this.options.animation.open === null) {
        this.promises.show = new _es6Promise2.default(function (resolve) {
          resolve();
        });
      } else if (typeof this.options.animation.open === 'function') {
        this.promises.show = new _es6Promise2.default(this.options.animation.open.bind(this));
      } else {
        Utils.addClass(this.barDom, this.options.animation.open);
        this.promises.show = new _es6Promise2.default(function (resolve) {
          Utils.addListener(_this.barDom, Utils.animationEndEvents, function () {
            Utils.removeClass(_this.barDom, _this.options.animation.open);
            resolve();
          });
        });
      }

      this.promises.show.then(function () {
        var _t = _this;
        setTimeout(function () {
          API.openFlow(_t);
        }, 100);
      });

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'stop',
    value: function stop() {
      API.dequeueClose(this);
      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'resume',
    value: function resume() {
      API.queueClose(this);
      return this;
    }

    /**
     * @param {int|boolean} ms
     * @return {Noty}
     */

  }, {
    key: 'setTimeout',
    value: function (_setTimeout) {
      function setTimeout(_x) {
        return _setTimeout.apply(this, arguments);
      }

      setTimeout.toString = function () {
        return _setTimeout.toString();
      };

      return setTimeout;
    }(function (ms) {
      this.stop();
      this.options.timeout = ms;

      if (this.barDom) {
        if (this.options.timeout) {
          Utils.addClass(this.barDom, 'noty_has_timeout');
        } else {
          Utils.removeClass(this.barDom, 'noty_has_timeout');
        }

        var _t = this;
        setTimeout(function () {
          // ugly fix for progressbar display bug
          _t.resume();
        }, 100);
      }

      return this;
    })

    /**
     * @param {string} html
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setText',
    value: function setText(html) {
      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        this.barDom.querySelector('.noty_body').innerHTML = html;
      }

      if (optionsOverride) this.options.text = html;

      return this;
    }

    /**
     * @param {string} type
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setType',
    value: function setType(type) {
      var _this2 = this;

      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        var classList = Utils.classList(this.barDom).split(' ');

        classList.forEach(function (c) {
          if (c.substring(0, 11) === 'noty_type__') {
            Utils.removeClass(_this2.barDom, c);
          }
        });

        Utils.addClass(this.barDom, 'noty_type__' + type);
      }

      if (optionsOverride) this.options.type = type;

      return this;
    }

    /**
     * @param {string} theme
     * @param {boolean} optionsOverride
     * @return {Noty}
     */

  }, {
    key: 'setTheme',
    value: function setTheme(theme) {
      var _this3 = this;

      var optionsOverride = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.barDom) {
        var classList = Utils.classList(this.barDom).split(' ');

        classList.forEach(function (c) {
          if (c.substring(0, 12) === 'noty_theme__') {
            Utils.removeClass(_this3.barDom, c);
          }
        });

        Utils.addClass(this.barDom, 'noty_theme__' + theme);
      }

      if (optionsOverride) this.options.theme = theme;

      return this;
    }

    /**
     * @return {Noty}
     */

  }, {
    key: 'close',
    value: function close() {
      var _this4 = this;

      if (this.closed) return this;

      if (!this.shown) {
        // it's in the queue
        API.removeFromQueue(this);
        return this;
      }

      API.fire(this, 'onClose');

      this.closing = true;

      if (this.options.animation.close === null) {
        this.promises.close = new _es6Promise2.default(function (resolve) {
          resolve();
        });
      } else if (typeof this.options.animation.close === 'function') {
        this.promises.close = new _es6Promise2.default(this.options.animation.close.bind(this));
      } else {
        Utils.addClass(this.barDom, this.options.animation.close);
        this.promises.close = new _es6Promise2.default(function (resolve) {
          Utils.addListener(_this4.barDom, Utils.animationEndEvents, function () {
            if (_this4.options.force) {
              Utils.remove(_this4.barDom);
            } else {
              API.ghostFix(_this4);
            }
            resolve();
          });
        });
      }

      this.promises.close.then(function () {
        API.closeFlow(_this4);
        API.handleModalClose(_this4);
      });

      this.closed = true;

      return this;
    }

    // API functions

    /**
     * @param {boolean|string} queueName
     * @return {Noty}
     */

  }], [{
    key: 'closeAll',
    value: function closeAll() {
      var queueName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      Object.keys(API.Store).forEach(function (id) {
        if (queueName) {
          if (API.Store[id].options.queue === queueName && API.Store[id].killable) {
            API.Store[id].close();
          }
        } else if (API.Store[id].killable) {
          API.Store[id].close();
        }
      });
      return this;
    }

    /**
     * @param {Object} obj
     * @return {Noty}
     */

  }, {
    key: 'overrideDefaults',
    value: function overrideDefaults(obj) {
      API.Defaults = Utils.deepExtend({}, API.Defaults, obj);
      return this;
    }

    /**
     * @param {int} amount
     * @param {string} queueName
     * @return {Noty}
     */

  }, {
    key: 'setMaxVisible',
    value: function setMaxVisible() {
      var amount = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : API.DefaultMaxVisible;
      var queueName = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'global';

      if (!API.Queues.hasOwnProperty(queueName)) {
        API.Queues[queueName] = { maxVisible: amount, queue: [] };
      }

      API.Queues[queueName].maxVisible = amount;
      return this;
    }

    /**
     * @param {string} innerHtml
     * @param {String} classes
     * @param {Function} cb
     * @param {Object} attributes
     * @return {NotyButton}
     */

  }, {
    key: 'button',
    value: function button(innerHtml) {
      var classes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var cb = arguments[2];
      var attributes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

      return new _button.NotyButton(innerHtml, classes, cb, attributes);
    }

    /**
     * @return {string}
     */

  }, {
    key: 'version',
    value: function version() {
      return "3.1.4";
    }

    /**
     * @param {String} workerPath
     * @return {Push}
     */

  }, {
    key: 'Push',
    value: function Push(workerPath) {
      return new _push.Push(workerPath);
    }
  }]);

  return Noty;
}();

// Document visibility change controller


exports.default = Noty;
Utils.visibilityChangeFlow();
module.exports = exports['default'];

/***/ }),
/* 7 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 8 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
/******/ ]);
});
//# sourceMappingURL=noty.js.map

/***/ }),
/* 1171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return firebaseApp; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_firebase___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_firebase__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var firebaseConfig={apiKey:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.API_KEY,authDomain:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.AUTH_DOMAIN,databaseURL:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.DATABASE_URL,projectId:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.PRODUCT_ID,storageBucket:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.STORAGE_BUCKET,messagingSenderId:__WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.MESSAGING_SENDER_ID// ,appId: "1:638458887693:web:960d7e9a5aa32384a61f44",
// measurementId: "G-PSS5J6Q02B"
};var firebaseApp=__WEBPACK_IMPORTED_MODULE_0_firebase__["initializeApp"](firebaseConfig);

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var firebase = __webpack_require__(1173);
__webpack_require__(1193);
__webpack_require__(1195);
__webpack_require__(1230);
__webpack_require__(1248);

module.exports = firebase;


/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1174);
module.exports = __webpack_require__(93).default;


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__ = __webpack_require__(1175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__src_polyfills_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_shims_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__src_shims_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__src_shims_findIndex__);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




//# sourceMappingURL=index.js.map


/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __global = (function () {
    if (typeof global !== 'undefined') {
        return global;
    }
    if (typeof window !== 'undefined') {
        return window;
    }
    if (typeof self !== 'undefined') {
        return self;
    }
    throw new Error('unable to locate global object');
})();
// Polyfill Promise
if (typeof Promise === 'undefined') {
    // HACK: TS throws an error if I attempt to use 'dot-notation'
    __global['Promise'] = Promise = __webpack_require__(1176);
}

//# sourceMappingURL=promise.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(setImmediate) {

// Store setTimeout reference so promise-polyfill will be unaffected by
// other code modifying setTimeout (like sinon.useFakeTimers())
var setTimeoutFunc = setTimeout;

function noop() {}

// Polyfill for Function.prototype.bind
function bind(fn, thisArg) {
  return function() {
    fn.apply(thisArg, arguments);
  };
}

function Promise(fn) {
  if (!(this instanceof Promise))
    throw new TypeError('Promises must be constructed via new');
  if (typeof fn !== 'function') throw new TypeError('not a function');
  this._state = 0;
  this._handled = false;
  this._value = undefined;
  this._deferreds = [];

  doResolve(fn, this);
}

function handle(self, deferred) {
  while (self._state === 3) {
    self = self._value;
  }
  if (self._state === 0) {
    self._deferreds.push(deferred);
    return;
  }
  self._handled = true;
  Promise._immediateFn(function() {
    var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
      return;
    }
    var ret;
    try {
      ret = cb(self._value);
    } catch (e) {
      reject(deferred.promise, e);
      return;
    }
    resolve(deferred.promise, ret);
  });
}

function resolve(self, newValue) {
  try {
    // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
    if (newValue === self)
      throw new TypeError('A promise cannot be resolved with itself.');
    if (
      newValue &&
      (typeof newValue === 'object' || typeof newValue === 'function')
    ) {
      var then = newValue.then;
      if (newValue instanceof Promise) {
        self._state = 3;
        self._value = newValue;
        finale(self);
        return;
      } else if (typeof then === 'function') {
        doResolve(bind(then, newValue), self);
        return;
      }
    }
    self._state = 1;
    self._value = newValue;
    finale(self);
  } catch (e) {
    reject(self, e);
  }
}

function reject(self, newValue) {
  self._state = 2;
  self._value = newValue;
  finale(self);
}

function finale(self) {
  if (self._state === 2 && self._deferreds.length === 0) {
    Promise._immediateFn(function() {
      if (!self._handled) {
        Promise._unhandledRejectionFn(self._value);
      }
    });
  }

  for (var i = 0, len = self._deferreds.length; i < len; i++) {
    handle(self, self._deferreds[i]);
  }
  self._deferreds = null;
}

function Handler(onFulfilled, onRejected, promise) {
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, self) {
  var done = false;
  try {
    fn(
      function(value) {
        if (done) return;
        done = true;
        resolve(self, value);
      },
      function(reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      }
    );
  } catch (ex) {
    if (done) return;
    done = true;
    reject(self, ex);
  }
}

Promise.prototype['catch'] = function(onRejected) {
  return this.then(null, onRejected);
};

Promise.prototype.then = function(onFulfilled, onRejected) {
  var prom = new this.constructor(noop);

  handle(this, new Handler(onFulfilled, onRejected, prom));
  return prom;
};

Promise.prototype['finally'] = function(callback) {
  var constructor = this.constructor;
  return this.then(
    function(value) {
      return constructor.resolve(callback()).then(function() {
        return value;
      });
    },
    function(reason) {
      return constructor.resolve(callback()).then(function() {
        return constructor.reject(reason);
      });
    }
  );
};

Promise.all = function(arr) {
  return new Promise(function(resolve, reject) {
    if (!arr || typeof arr.length === 'undefined')
      throw new TypeError('Promise.all accepts an array');
    var args = Array.prototype.slice.call(arr);
    if (args.length === 0) return resolve([]);
    var remaining = args.length;

    function res(i, val) {
      try {
        if (val && (typeof val === 'object' || typeof val === 'function')) {
          var then = val.then;
          if (typeof then === 'function') {
            then.call(
              val,
              function(val) {
                res(i, val);
              },
              reject
            );
            return;
          }
        }
        args[i] = val;
        if (--remaining === 0) {
          resolve(args);
        }
      } catch (ex) {
        reject(ex);
      }
    }

    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.resolve = function(value) {
  if (value && typeof value === 'object' && value.constructor === Promise) {
    return value;
  }

  return new Promise(function(resolve) {
    resolve(value);
  });
};

Promise.reject = function(value) {
  return new Promise(function(resolve, reject) {
    reject(value);
  });
};

Promise.race = function(values) {
  return new Promise(function(resolve, reject) {
    for (var i = 0, len = values.length; i < len; i++) {
      values[i].then(resolve, reject);
    }
  });
};

// Use polyfill for setImmediate for performance gains
Promise._immediateFn =
  (typeof setImmediate === 'function' &&
    function(fn) {
      setImmediate(fn);
    }) ||
  function(fn) {
    setTimeoutFunc(fn, 0);
  };

Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
  if (typeof console !== 'undefined' && console) {
    console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
  }
};

module.exports = Promise;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1177).setImmediate))

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1178);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55), __webpack_require__(223)))

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This is the Array.prototype.find polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/find
 * https://tc39.github.io/ecma262/#sec-array.prototype.find
 */
if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return kValue.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return kValue;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return undefined.
            return undefined;
        }
    });
}

//# sourceMappingURL=find.js.map


/***/ }),
/* 1180 */
/***/ (function(module, exports) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * This is the Array.prototype.findIndex polyfill from MDN
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/findIndex
 * https://tc39.github.io/ecma262/#sec-array.prototype.findIndex
 */
if (!Array.prototype.findIndex) {
    Object.defineProperty(Array.prototype, 'findIndex', {
        value: function (predicate) {
            // 1. Let O be ? ToObject(this value).
            if (this == null) {
                throw new TypeError('"this" is null or not defined');
            }
            var o = Object(this);
            // 2. Let len be ? ToLength(? Get(O, "length")).
            var len = o.length >>> 0;
            // 3. If IsCallable(predicate) is false, throw a TypeError exception.
            if (typeof predicate !== 'function') {
                throw new TypeError('predicate must be a function');
            }
            // 4. If thisArg was supplied, let T be thisArg; else let T be undefined.
            var thisArg = arguments[1];
            // 5. Let k be 0.
            var k = 0;
            // 6. Repeat, while k < len
            while (k < len) {
                // a. Let Pk be ! ToString(k).
                // b. Let kValue be ? Get(O, Pk).
                // c. Let testResult be ToBoolean(? Call(predicate, T, « kValue, k, O »)).
                // d. If testResult is true, return k.
                var kValue = o[k];
                if (predicate.call(thisArg, kValue, k, o)) {
                    return k;
                }
                // e. Increase k by 1.
                k++;
            }
            // 7. Return -1.
            return -1;
        }
    });
}

//# sourceMappingURL=findIndex.js.map


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFirebaseNamespace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var contains = function (obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
};
var DEFAULT_ENTRY_NAME = '[DEFAULT]';
// An array to capture listeners before the true auth functions
// exist
var tokenListeners = [];
/**
 * Global context object for a collection of services using
 * a shared authentication state.
 */
var FirebaseAppImpl = /** @class */ (function () {
    function FirebaseAppImpl(options, name, firebase_) {
        this.firebase_ = firebase_;
        this.isDeleted_ = false;
        this.services_ = {};
        this.name_ = name;
        this.options_ = Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepCopy"])(options);
        this.INTERNAL = {
            getUid: function () { return null; },
            getToken: function () { return Promise.resolve(null); },
            addAuthTokenListener: function (callback) {
                tokenListeners.push(callback);
                // Make sure callback is called, asynchronously, in the absence of the auth module
                setTimeout(function () { return callback(null); }, 0);
            },
            removeAuthTokenListener: function (callback) {
                tokenListeners = tokenListeners.filter(function (listener) { return listener !== callback; });
            }
        };
    }
    Object.defineProperty(FirebaseAppImpl.prototype, "name", {
        get: function () {
            this.checkDestroyed_();
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseAppImpl.prototype, "options", {
        get: function () {
            this.checkDestroyed_();
            return this.options_;
        },
        enumerable: true,
        configurable: true
    });
    FirebaseAppImpl.prototype.delete = function () {
        var _this = this;
        return new Promise(function (resolve) {
            _this.checkDestroyed_();
            resolve();
        })
            .then(function () {
            _this.firebase_.INTERNAL.removeApp(_this.name_);
            var services = [];
            Object.keys(_this.services_).forEach(function (serviceKey) {
                Object.keys(_this.services_[serviceKey]).forEach(function (instanceKey) {
                    services.push(_this.services_[serviceKey][instanceKey]);
                });
            });
            return Promise.all(services.map(function (service) {
                return service.INTERNAL.delete();
            }));
        })
            .then(function () {
            _this.isDeleted_ = true;
            _this.services_ = {};
        });
    };
    /**
     * Return a service instance associated with this app (creating it
     * on demand), identified by the passed instanceIdentifier.
     *
     * NOTE: Currently storage is the only one that is leveraging this
     * functionality. They invoke it by calling:
     *
     * ```javascript
     * firebase.app().storage('STORAGE BUCKET ID')
     * ```
     *
     * The service name is passed to this already
     * @internal
     */
    FirebaseAppImpl.prototype._getService = function (name, instanceIdentifier) {
        if (instanceIdentifier === void 0) { instanceIdentifier = DEFAULT_ENTRY_NAME; }
        this.checkDestroyed_();
        if (!this.services_[name]) {
            this.services_[name] = {};
        }
        if (!this.services_[name][instanceIdentifier]) {
            /**
             * If a custom instance has been defined (i.e. not '[DEFAULT]')
             * then we will pass that instance on, otherwise we pass `null`
             */
            var instanceSpecifier = instanceIdentifier !== DEFAULT_ENTRY_NAME
                ? instanceIdentifier
                : undefined;
            var service = this.firebase_.INTERNAL.factories[name](this, this.extendApp.bind(this), instanceSpecifier);
            this.services_[name][instanceIdentifier] = service;
        }
        return this.services_[name][instanceIdentifier];
    };
    /**
     * Callback function used to extend an App instance at the time
     * of service instance creation.
     */
    FirebaseAppImpl.prototype.extendApp = function (props) {
        var _this = this;
        // Copy the object onto the FirebaseAppImpl prototype
        Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(this, props);
        /**
         * If the app has overwritten the addAuthTokenListener stub, forward
         * the active token listeners on to the true fxn.
         *
         * TODO: This function is required due to our current module
         * structure. Once we are able to rely strictly upon a single module
         * implementation, this code should be refactored and Auth should
         * provide these stubs and the upgrade logic
         */
        if (props.INTERNAL && props.INTERNAL.addAuthTokenListener) {
            tokenListeners.forEach(function (listener) {
                _this.INTERNAL.addAuthTokenListener(listener);
            });
            tokenListeners = [];
        }
    };
    /**
     * This function will throw an Error if the App has already been deleted -
     * use before performing API actions on the App.
     */
    FirebaseAppImpl.prototype.checkDestroyed_ = function () {
        if (this.isDeleted_) {
            error('app-deleted', { name: this.name_ });
        }
    };
    return FirebaseAppImpl;
}());
// Prevent dead-code elimination of these methods w/o invalid property
// copying.
(FirebaseAppImpl.prototype.name && FirebaseAppImpl.prototype.options) ||
    FirebaseAppImpl.prototype.delete ||
    console.log('dc');
/**
 * Return a firebase namespace object.
 *
 * In production, this will be called exactly once and the result
 * assigned to the 'firebase' global.  It may be called multiple times
 * in unit tests.
 */
function createFirebaseNamespace() {
    var apps_ = {};
    var factories = {};
    var appHooks = {};
    // A namespace is a plain JavaScript Object.
    var namespace = {
        // Hack to prevent Babel from modifying the object returned
        // as the firebase namespace.
        __esModule: true,
        initializeApp: initializeApp,
        app: app,
        apps: null,
        Promise: Promise,
        SDK_VERSION: '4.10.1',
        INTERNAL: {
            registerService: registerService,
            createFirebaseNamespace: createFirebaseNamespace,
            extendNamespace: extendNamespace,
            createSubscribe: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["createSubscribe"],
            ErrorFactory: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"],
            removeApp: removeApp,
            factories: factories,
            useAsService: useAsService,
            Promise: Promise,
            deepExtend: __WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"]
        }
    };
    // Inject a circular default export to allow Babel users who were previously
    // using:
    //
    //   import firebase from 'firebase';
    //   which becomes: var firebase = require('firebase').default;
    //
    // instead of
    //
    //   import * as firebase from 'firebase';
    //   which becomes: var firebase = require('firebase');
    Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(namespace, 'default', namespace);
    // firebase.apps is a read-only getter.
    Object.defineProperty(namespace, 'apps', {
        get: getApps
    });
    /**
     * Called by App.delete() - but before any services associated with the App
     * are deleted.
     */
    function removeApp(name) {
        var app = apps_[name];
        callAppHooks(app, 'delete');
        delete apps_[name];
    }
    /**
     * Get the App object for a given name (or DEFAULT).
     */
    function app(name) {
        name = name || DEFAULT_ENTRY_NAME;
        if (!contains(apps_, name)) {
            error('no-app', { name: name });
        }
        return apps_[name];
    }
    Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["patchProperty"])(app, 'App', FirebaseAppImpl);
    /**
     * Create a new App instance (name must be unique).
     */
    function initializeApp(options, name) {
        if (name === undefined) {
            name = DEFAULT_ENTRY_NAME;
        }
        else {
            if (typeof name !== 'string' || name === '') {
                error('bad-app-name', { name: name + '' });
            }
        }
        if (contains(apps_, name)) {
            error('duplicate-app', { name: name });
        }
        var app = new FirebaseAppImpl(options, name, namespace);
        apps_[name] = app;
        callAppHooks(app, 'create');
        return app;
    }
    /*
     * Return an array of all the non-deleted FirebaseApps.
     */
    function getApps() {
        // Make a copy so caller cannot mutate the apps list.
        return Object.keys(apps_).map(function (name) { return apps_[name]; });
    }
    /*
     * Register a Firebase Service.
     *
     * firebase.INTERNAL.registerService()
     *
     * TODO: Implement serviceProperties.
     */
    function registerService(name, createService, serviceProperties, appHook, allowMultipleInstances) {
        // Cannot re-register a service that already exists
        if (factories[name]) {
            error('duplicate-service', { name: name });
        }
        // Capture the service factory for later service instantiation
        factories[name] = createService;
        // Capture the appHook, if passed
        if (appHook) {
            appHooks[name] = appHook;
            // Run the **new** app hook on all existing apps
            getApps().forEach(function (app) {
                appHook('create', app);
            });
        }
        // The Service namespace is an accessor function ...
        var serviceNamespace = function (appArg) {
            if (appArg === void 0) { appArg = app(); }
            if (typeof appArg[name] !== 'function') {
                // Invalid argument.
                // This happens in the following case: firebase.storage('gs:/')
                error('invalid-app-argument', { name: name });
            }
            // Forward service instance lookup to the FirebaseApp.
            return appArg[name]();
        };
        // ... and a container for service-level properties.
        if (serviceProperties !== undefined) {
            Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(serviceNamespace, serviceProperties);
        }
        // Monkey-patch the serviceNamespace onto the firebase namespace
        namespace[name] = serviceNamespace;
        // Patch the FirebaseAppImpl prototype
        FirebaseAppImpl.prototype[name] = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var serviceFxn = this._getService.bind(this, name);
            return serviceFxn.apply(this, allowMultipleInstances ? args : []);
        };
        return serviceNamespace;
    }
    /**
     * Patch the top-level firebase namespace with additional properties.
     *
     * firebase.INTERNAL.extendNamespace()
     */
    function extendNamespace(props) {
        Object(__WEBPACK_IMPORTED_MODULE_0__firebase_util__["deepExtend"])(namespace, props);
    }
    function callAppHooks(app, eventName) {
        Object.keys(factories).forEach(function (serviceName) {
            // Ignore virtual services
            var factoryName = useAsService(app, serviceName);
            if (factoryName === null) {
                return;
            }
            if (appHooks[factoryName]) {
                appHooks[factoryName](eventName, app);
            }
        });
    }
    // Map the requested service to a registered service name
    // (used to map auth to serverAuth service when needed).
    function useAsService(app, name) {
        if (name === 'serverAuth') {
            return null;
        }
        var useService = name;
        var options = app.options;
        return useService;
    }
    return namespace;
}
function error(code, args) {
    throw appErrors.create(code, args);
}
// TypeScript does not support non-string indexes!
// let errors: {[code: AppError: string} = {
var errors = {
    'no-app': "No Firebase App '{$name}' has been created - " +
        'call Firebase App.initializeApp()',
    'bad-app-name': "Illegal App name: '{$name}",
    'duplicate-app': "Firebase App named '{$name}' already exists",
    'app-deleted': "Firebase App named '{$name}' already deleted",
    'duplicate-service': "Firebase service named '{$name}' already registered",
    'sa-not-supported': 'Initializing the Firebase SDK with a service ' +
        'account is only allowed in a Node.js environment. On client ' +
        'devices, you should instead initialize the SDK with an api key and ' +
        'auth domain',
    'invalid-app-argument': 'firebase.{$name}() takes either no argument or a ' +
        'Firebase App instance.'
};
var appErrors = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('app', 'Firebase', errors);


//# sourceMappingURL=firebaseApp.js.map


/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
exports.deepCopy = deepCopy;
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
exports.deepExtend = deepExtend;
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}
exports.patchProperty = patchProperty;

//# sourceMappingURL=deepCopy.js.map


/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());
exports.Deferred = Deferred;

//# sourceMappingURL=deferred.js.map


/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(267);
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
exports.getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
exports.isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(exports.getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
exports.isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
exports.isNodeSdk = function () {
    return constants_1.CONSTANTS.NODE_CLIENT === true || constants_1.CONSTANTS.NODE_ADMIN === true;
};

//# sourceMappingURL=environment.js.map


/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
exports.patchCapture = patchCapture;
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        var stack;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function () {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}());
exports.FirebaseError = FirebaseError;
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());
exports.ErrorFactory = ErrorFactory;

//# sourceMappingURL=errors.js.map


/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var crypt_1 = __webpack_require__(458);
var json_1 = __webpack_require__(459);
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
exports.decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = json_1.jsonEval(crypt_1.base64Decode(parts[0]) || '');
        claims = json_1.jsonEval(crypt_1.base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidTimestamp = function (token) {
    var claims = exports.decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
exports.issuedAtTime = function (token) {
    var claims = exports.decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidFormat = function (token) {
    var decoded = exports.decode(token), claims = decoded.claims;
    return (!!decoded.signature &&
        !!claims &&
        typeof claims === 'object' &&
        claims.hasOwnProperty('iat'));
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isAdmin = function (token) {
    var claims = exports.decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

//# sourceMappingURL=jwt.js.map


/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var obj_1 = __webpack_require__(460);
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
exports.querystring = function (querystringParams) {
    var params = [];
    obj_1.forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
exports.querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

//# sourceMappingURL=query.js.map


/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var hash_1 = __webpack_require__(1189);
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    tslib_1.__extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(hash_1.Hash));
exports.Sha1 = Sha1;

//# sourceMappingURL=sha1.js.map


/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());
exports.Hash = Hash;

//# sourceMappingURL=hash.js.map


/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
exports.createSubscribe = createSubscribe;
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
exports.async = async;
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

//# sourceMappingURL=subscribe.js.map


/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
exports.validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
exports.errorPrefix = errorPrefix;
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
exports.validateNamespace = validateNamespace;
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
exports.validateCallback = validateCallback;
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}
exports.validateContextObject = validateContextObject;

//# sourceMappingURL=validation.js.map


/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __webpack_require__(457);
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
exports.stringToByteArray = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert_1.assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
exports.stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

//# sourceMappingURL=utf8.js.map


/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1194);


/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {(function() {
  var firebase = __webpack_require__(93).default;
  var h,aa=aa||{},k=this;function m(a){return"string"==typeof a}function ba(a){return"boolean"==typeof a}function ca(){}
function da(a){var b=typeof a;if("object"==b)if(a){if(a instanceof Array)return"array";if(a instanceof Object)return b;var c=Object.prototype.toString.call(a);if("[object Window]"==c)return"object";if("[object Array]"==c||"number"==typeof a.length&&"undefined"!=typeof a.splice&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("splice"))return"array";if("[object Function]"==c||"undefined"!=typeof a.call&&"undefined"!=typeof a.propertyIsEnumerable&&!a.propertyIsEnumerable("call"))return"function"}else return"null";
else if("function"==b&&"undefined"==typeof a.call)return"object";return b}function ea(a){return null===a}function fa(a){return"array"==da(a)}function ha(a){var b=da(a);return"array"==b||"object"==b&&"number"==typeof a.length}function p(a){return"function"==da(a)}function q(a){var b=typeof a;return"object"==b&&null!=a||"function"==b}var ia="closure_uid_"+(1E9*Math.random()>>>0),ja=0;function ka(a,b,c){return a.call.apply(a.bind,arguments)}
function la(a,b,c){if(!a)throw Error();if(2<arguments.length){var d=Array.prototype.slice.call(arguments,2);return function(){var c=Array.prototype.slice.call(arguments);Array.prototype.unshift.apply(c,d);return a.apply(b,c)}}return function(){return a.apply(b,arguments)}}function r(a,b,c){Function.prototype.bind&&-1!=Function.prototype.bind.toString().indexOf("native code")?r=ka:r=la;return r.apply(null,arguments)}
function ma(a,b){var c=Array.prototype.slice.call(arguments,1);return function(){var b=c.slice();b.push.apply(b,arguments);return a.apply(this,b)}}var na=Date.now||function(){return+new Date};function t(a,b){function c(){}c.prototype=b.prototype;a.ib=b.prototype;a.prototype=new c;a.prototype.constructor=a;a.Nc=function(a,c,f){for(var d=Array(arguments.length-2),e=2;e<arguments.length;e++)d[e-2]=arguments[e];return b.prototype[c].apply(a,d)}};function u(a){if(Error.captureStackTrace)Error.captureStackTrace(this,u);else{var b=Error().stack;b&&(this.stack=b)}a&&(this.message=String(a))}t(u,Error);u.prototype.name="CustomError";function oa(a,b){for(var c=a.split("%s"),d="",e=Array.prototype.slice.call(arguments,1);e.length&&1<c.length;)d+=c.shift()+e.shift();return d+c.join("%s")}var pa=String.prototype.trim?function(a){return a.trim()}:function(a){return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g,"")};
function qa(a){if(!ra.test(a))return a;-1!=a.indexOf("&")&&(a=a.replace(sa,"&amp;"));-1!=a.indexOf("<")&&(a=a.replace(ta,"&lt;"));-1!=a.indexOf(">")&&(a=a.replace(ua,"&gt;"));-1!=a.indexOf('"')&&(a=a.replace(va,"&quot;"));-1!=a.indexOf("'")&&(a=a.replace(wa,"&#39;"));-1!=a.indexOf("\x00")&&(a=a.replace(xa,"&#0;"));return a}var sa=/&/g,ta=/</g,ua=/>/g,va=/"/g,wa=/'/g,xa=/\x00/g,ra=/[\x00&<>"']/;function v(a,b){return-1!=a.indexOf(b)}function ya(a,b){return a<b?-1:a>b?1:0};function za(a,b){b.unshift(a);u.call(this,oa.apply(null,b));b.shift()}t(za,u);za.prototype.name="AssertionError";function Aa(a,b){throw new za("Failure"+(a?": "+a:""),Array.prototype.slice.call(arguments,1));};var Ba=Array.prototype.indexOf?function(a,b,c){return Array.prototype.indexOf.call(a,b,c)}:function(a,b,c){c=null==c?0:0>c?Math.max(0,a.length+c):c;if(m(a))return m(b)&&1==b.length?a.indexOf(b,c):-1;for(;c<a.length;c++)if(c in a&&a[c]===b)return c;return-1},w=Array.prototype.forEach?function(a,b,c){Array.prototype.forEach.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)f in e&&b.call(c,e[f],f,a)};
function Ca(a,b){var c=a.length,d=m(a)?a.split(""):a;for(--c;0<=c;--c)c in d&&b.call(void 0,d[c],c,a)}var Da=Array.prototype.map?function(a,b,c){return Array.prototype.map.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=Array(d),f=m(a)?a.split(""):a,g=0;g<d;g++)g in f&&(e[g]=b.call(c,f[g],g,a));return e},Ea=Array.prototype.some?function(a,b,c){return Array.prototype.some.call(a,b,c)}:function(a,b,c){for(var d=a.length,e=m(a)?a.split(""):a,f=0;f<d;f++)if(f in e&&b.call(c,e[f],f,a))return!0;return!1};
function Fa(a){a:{var b=Ga;for(var c=a.length,d=m(a)?a.split(""):a,e=0;e<c;e++)if(e in d&&b.call(void 0,d[e],e,a)){b=e;break a}b=-1}return 0>b?null:m(a)?a.charAt(b):a[b]}function Ha(a,b){return 0<=Ba(a,b)}function Ia(a,b){b=Ba(a,b);var c;(c=0<=b)&&Array.prototype.splice.call(a,b,1);return c}function Ja(a,b){var c=0;Ca(a,function(d,e){b.call(void 0,d,e,a)&&1==Array.prototype.splice.call(a,e,1).length&&c++})}function Ka(a){return Array.prototype.concat.apply([],arguments)}
function La(a){var b=a.length;if(0<b){for(var c=Array(b),d=0;d<b;d++)c[d]=a[d];return c}return[]};var Ma;a:{var Na=k.navigator;if(Na){var Oa=Na.userAgent;if(Oa){Ma=Oa;break a}}Ma=""}function x(a){return v(Ma,a)};function Pa(a,b){for(var c in a)b.call(void 0,a[c],c,a)}function Qa(a){var b=[],c=0,d;for(d in a)b[c++]=a[d];return b}function Ra(a){var b=[],c=0,d;for(d in a)b[c++]=d;return b}function Sa(a){for(var b in a)return!1;return!0}function Ta(a,b){for(var c in a)if(!(c in b)||a[c]!==b[c])return!1;for(c in b)if(!(c in a))return!1;return!0}function Ua(a){var b={},c;for(c in a)b[c]=a[c];return b}var Va="constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");
function Wa(a,b){for(var c,d,e=1;e<arguments.length;e++){d=arguments[e];for(c in d)a[c]=d[c];for(var f=0;f<Va.length;f++)c=Va[f],Object.prototype.hasOwnProperty.call(d,c)&&(a[c]=d[c])}};function Xa(a){Xa[" "](a);return a}Xa[" "]=ca;function Ya(a,b){var c=Za;return Object.prototype.hasOwnProperty.call(c,a)?c[a]:c[a]=b(a)};var $a=x("Opera"),y=x("Trident")||x("MSIE"),ab=x("Edge"),bb=ab||y,cb=x("Gecko")&&!(v(Ma.toLowerCase(),"webkit")&&!x("Edge"))&&!(x("Trident")||x("MSIE"))&&!x("Edge"),db=v(Ma.toLowerCase(),"webkit")&&!x("Edge");function eb(){var a=k.document;return a?a.documentMode:void 0}var fb;
a:{var gb="",hb=function(){var a=Ma;if(cb)return/rv\:([^\);]+)(\)|;)/.exec(a);if(ab)return/Edge\/([\d\.]+)/.exec(a);if(y)return/\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);if(db)return/WebKit\/(\S+)/.exec(a);if($a)return/(?:Version)[ \/]?(\S+)/.exec(a)}();hb&&(gb=hb?hb[1]:"");if(y){var ib=eb();if(null!=ib&&ib>parseFloat(gb)){fb=String(ib);break a}}fb=gb}var Za={};
function jb(a){return Ya(a,function(){for(var b=0,c=pa(String(fb)).split("."),d=pa(String(a)).split("."),e=Math.max(c.length,d.length),f=0;0==b&&f<e;f++){var g=c[f]||"",l=d[f]||"";do{g=/(\d*)(\D*)(.*)/.exec(g)||["","","",""];l=/(\d*)(\D*)(.*)/.exec(l)||["","","",""];if(0==g[0].length&&0==l[0].length)break;b=ya(0==g[1].length?0:parseInt(g[1],10),0==l[1].length?0:parseInt(l[1],10))||ya(0==g[2].length,0==l[2].length)||ya(g[2],l[2]);g=g[3];l=l[3]}while(0==b)}return 0<=b})}var kb;var lb=k.document;
kb=lb&&y?eb()||("CSS1Compat"==lb.compatMode?parseInt(fb,10):5):void 0;function mb(a){a.prototype.then=a.prototype.then;a.prototype.$goog_Thenable=!0}function nb(a){if(!a)return!1;try{return!!a.$goog_Thenable}catch(b){return!1}};function ob(a,b,c){this.f=c;this.c=a;this.g=b;this.b=0;this.a=null}ob.prototype.get=function(){if(0<this.b){this.b--;var a=this.a;this.a=a.next;a.next=null}else a=this.c();return a};function pb(a,b){a.g(b);a.b<a.f&&(a.b++,b.next=a.a,a.a=b)};var rb=new ob(function(){return new qb},function(a){a.reset()},100);function sb(){var a=tb,b=null;a.a&&(b=a.a,a.a=a.a.next,a.a||(a.b=null),b.next=null);return b}function qb(){this.next=this.b=this.a=null}qb.prototype.set=function(a,b){this.a=a;this.b=b;this.next=null};qb.prototype.reset=function(){this.next=this.b=this.a=null};function ub(a){k.setTimeout(function(){throw a;},0)}var wb;
function xb(){var a=k.MessageChannel;"undefined"===typeof a&&"undefined"!==typeof window&&window.postMessage&&window.addEventListener&&!x("Presto")&&(a=function(){var a=document.createElement("IFRAME");a.style.display="none";a.src="";document.documentElement.appendChild(a);var b=a.contentWindow;a=b.document;a.open();a.write("");a.close();var c="callImmediate"+Math.random(),d="file:"==b.location.protocol?"*":b.location.protocol+"//"+b.location.host;a=r(function(a){if(("*"==d||a.origin==d)&&a.data==
c)this.port1.onmessage()},this);b.addEventListener("message",a,!1);this.port1={};this.port2={postMessage:function(){b.postMessage(c,d)}}});if("undefined"!==typeof a&&!x("Trident")&&!x("MSIE")){var b=new a,c={},d=c;b.port1.onmessage=function(){if(void 0!==c.next){c=c.next;var a=c.pb;c.pb=null;a()}};return function(a){d.next={pb:a};d=d.next;b.port2.postMessage(0)}}return"undefined"!==typeof document&&"onreadystatechange"in document.createElement("SCRIPT")?function(a){var b=document.createElement("SCRIPT");
b.onreadystatechange=function(){b.onreadystatechange=null;b.parentNode.removeChild(b);b=null;a();a=null};document.documentElement.appendChild(b)}:function(a){k.setTimeout(a,0)}};function yb(a,b){zb||Ab();Bb||(zb(),Bb=!0);var c=tb,d=rb.get();d.set(a,b);c.b?c.b.next=d:c.a=d;c.b=d}var zb;function Ab(){if(-1!=String(k.Promise).indexOf("[native code]")){var a=k.Promise.resolve(void 0);zb=function(){a.then(Cb)}}else zb=function(){var a=Cb;!p(k.setImmediate)||k.Window&&k.Window.prototype&&!x("Edge")&&k.Window.prototype.setImmediate==k.setImmediate?(wb||(wb=xb()),wb(a)):k.setImmediate(a)}}var Bb=!1,tb=new function(){this.b=this.a=null};
function Cb(){for(var a;a=sb();){try{a.a.call(a.b)}catch(b){ub(b)}pb(rb,a)}Bb=!1};function z(a,b){this.a=Db;this.i=void 0;this.f=this.b=this.c=null;this.g=this.h=!1;if(a!=ca)try{var c=this;a.call(b,function(a){Eb(c,Fb,a)},function(a){if(!(a instanceof Gb))try{if(a instanceof Error)throw a;throw Error("Promise rejected.");}catch(e){}Eb(c,Hb,a)})}catch(d){Eb(this,Hb,d)}}var Db=0,Fb=2,Hb=3;function Ib(){this.next=this.f=this.b=this.g=this.a=null;this.c=!1}Ib.prototype.reset=function(){this.f=this.b=this.g=this.a=null;this.c=!1};
var Jb=new ob(function(){return new Ib},function(a){a.reset()},100);function Kb(a,b,c){var d=Jb.get();d.g=a;d.b=b;d.f=c;return d}function A(a){if(a instanceof z)return a;var b=new z(ca);Eb(b,Fb,a);return b}function B(a){return new z(function(b,c){c(a)})}function Lb(a,b,c){Mb(a,b,c,null)||yb(ma(b,a))}function Nb(a){return new z(function(b,c){var d=a.length,e=[];if(d)for(var f=function(a,c){d--;e[a]=c;0==d&&b(e)},g=function(a){c(a)},l=0,n;l<a.length;l++)n=a[l],Lb(n,ma(f,l),g);else b(e)})}
function Ob(a){return new z(function(b){var c=a.length,d=[];if(c)for(var e=function(a,e,f){c--;d[a]=e?{Qb:!0,value:f}:{Qb:!1,reason:f};0==c&&b(d)},f=0,g;f<a.length;f++)g=a[f],Lb(g,ma(e,f,!0),ma(e,f,!1));else b(d)})}z.prototype.then=function(a,b,c){return Pb(this,p(a)?a:null,p(b)?b:null,c)};mb(z);function Qb(a,b){b=Kb(b,b,void 0);b.c=!0;Rb(a,b);return a}h=z.prototype;h.s=function(a,b){return Pb(this,null,a,b)};h.cancel=function(a){this.a==Db&&yb(function(){var b=new Gb(a);Sb(this,b)},this)};
function Sb(a,b){if(a.a==Db)if(a.c){var c=a.c;if(c.b){for(var d=0,e=null,f=null,g=c.b;g&&(g.c||(d++,g.a==a&&(e=g),!(e&&1<d)));g=g.next)e||(f=g);e&&(c.a==Db&&1==d?Sb(c,b):(f?(d=f,d.next==c.f&&(c.f=d),d.next=d.next.next):Tb(c),Ub(c,e,Hb,b)))}a.c=null}else Eb(a,Hb,b)}function Rb(a,b){a.b||a.a!=Fb&&a.a!=Hb||Vb(a);a.f?a.f.next=b:a.b=b;a.f=b}
function Pb(a,b,c,d){var e=Kb(null,null,null);e.a=new z(function(a,g){e.g=b?function(c){try{var e=b.call(d,c);a(e)}catch(D){g(D)}}:a;e.b=c?function(b){try{var e=c.call(d,b);void 0===e&&b instanceof Gb?g(b):a(e)}catch(D){g(D)}}:g});e.a.c=a;Rb(a,e);return e.a}h.wc=function(a){this.a=Db;Eb(this,Fb,a)};h.xc=function(a){this.a=Db;Eb(this,Hb,a)};
function Eb(a,b,c){a.a==Db&&(a===c&&(b=Hb,c=new TypeError("Promise cannot resolve to itself")),a.a=1,Mb(c,a.wc,a.xc,a)||(a.i=c,a.a=b,a.c=null,Vb(a),b!=Hb||c instanceof Gb||Wb(a,c)))}function Mb(a,b,c,d){if(a instanceof z)return Rb(a,Kb(b||ca,c||null,d)),!0;if(nb(a))return a.then(b,c,d),!0;if(q(a))try{var e=a.then;if(p(e))return Xb(a,e,b,c,d),!0}catch(f){return c.call(d,f),!0}return!1}
function Xb(a,b,c,d,e){function f(a){l||(l=!0,d.call(e,a))}function g(a){l||(l=!0,c.call(e,a))}var l=!1;try{b.call(a,g,f)}catch(n){f(n)}}function Vb(a){a.h||(a.h=!0,yb(a.Mb,a))}function Tb(a){var b=null;a.b&&(b=a.b,a.b=b.next,b.next=null);a.b||(a.f=null);return b}h.Mb=function(){for(var a;a=Tb(this);)Ub(this,a,this.a,this.i);this.h=!1};
function Ub(a,b,c,d){if(c==Hb&&b.b&&!b.c)for(;a&&a.g;a=a.c)a.g=!1;if(b.a)b.a.c=null,Yb(b,c,d);else try{b.c?b.g.call(b.f):Yb(b,c,d)}catch(e){Zb.call(null,e)}pb(Jb,b)}function Yb(a,b,c){b==Fb?a.g.call(a.f,c):a.b&&a.b.call(a.f,c)}function Wb(a,b){a.g=!0;yb(function(){a.g&&Zb.call(null,b)})}var Zb=ub;function Gb(a){u.call(this,a)}t(Gb,u);Gb.prototype.name="cancel";var $b=!y||9<=Number(kb);function ac(){this.a="";this.b=bc}ac.prototype.la=!0;ac.prototype.ja=function(){return this.a};ac.prototype.toString=function(){return"Const{"+this.a+"}"};function cc(a){if(a instanceof ac&&a.constructor===ac&&a.b===bc)return a.a;Aa("expected object of type Const, got '"+a+"'");return"type_error:Const"}var bc={};function dc(a){var b=new ac;b.a=a;return b}dc("");function ec(){this.a="";this.b=fc}ec.prototype.la=!0;ec.prototype.ja=function(){return this.a};ec.prototype.toString=function(){return"TrustedResourceUrl{"+this.a+"}"};function gc(a){if(a instanceof ec&&a.constructor===ec&&a.b===fc)return a.a;Aa("expected object of type TrustedResourceUrl, got '"+a+"' of type "+da(a));return"type_error:TrustedResourceUrl"}function hc(a,b){a=ic(a,b);b=new ec;b.a=a;return b}
function ic(a,b){var c=cc(a);if(!jc.test(c))throw Error("Invalid TrustedResourceUrl format: "+c);return c.replace(kc,function(a,e){if(!Object.prototype.hasOwnProperty.call(b,e))throw Error('Found marker, "'+e+'", in format string, "'+c+'", but no valid label mapping found in args: '+JSON.stringify(b));a=b[e];return a instanceof ac?cc(a):encodeURIComponent(String(a))})}var kc=/%{(\w+)}/g,jc=/^(?:https:)?\/\/[0-9a-z.:[\]-]+\/|^\/[^\/\\]|^about:blank(#|$)/i,fc={};function lc(){this.a="";this.b=mc}lc.prototype.la=!0;lc.prototype.ja=function(){return this.a};lc.prototype.toString=function(){return"SafeUrl{"+this.a+"}"};function nc(a){if(a instanceof lc&&a.constructor===lc&&a.b===mc)return a.a;Aa("expected object of type SafeUrl, got '"+a+"' of type "+da(a));return"type_error:SafeUrl"}var oc=/^(?:(?:https?|mailto|ftp):|[^:/?#]*(?:[/?#]|$))/i;
function pc(a){if(a instanceof lc)return a;a=a.la?a.ja():String(a);oc.test(a)||(a="about:invalid#zClosurez");return qc(a)}var mc={};function qc(a){var b=new lc;b.a=a;return b}qc("about:blank");function rc(){this.a="";this.b=sc}rc.prototype.la=!0;rc.prototype.ja=function(){return this.a};rc.prototype.toString=function(){return"SafeHtml{"+this.a+"}"};function uc(a){if(a instanceof rc&&a.constructor===rc&&a.b===sc)return a.a;Aa("expected object of type SafeHtml, got '"+a+"' of type "+da(a));return"type_error:SafeHtml"}var sc={};function vc(a){var b=new rc;b.a=a;return b}vc("<!DOCTYPE html>");vc("");vc("<br>");function wc(a){var b=document;return m(a)?b.getElementById(a):a}function xc(a,b){Pa(b,function(b,d){b&&b.la&&(b=b.ja());"style"==d?a.style.cssText=b:"class"==d?a.className=b:"for"==d?a.htmlFor=b:yc.hasOwnProperty(d)?a.setAttribute(yc[d],b):0==d.lastIndexOf("aria-",0)||0==d.lastIndexOf("data-",0)?a.setAttribute(d,b):a[d]=b})}
var yc={cellpadding:"cellPadding",cellspacing:"cellSpacing",colspan:"colSpan",frameborder:"frameBorder",height:"height",maxlength:"maxLength",nonce:"nonce",role:"role",rowspan:"rowSpan",type:"type",usemap:"useMap",valign:"vAlign",width:"width"};
function zc(a,b,c){var d=arguments,e=document,f=String(d[0]),g=d[1];if(!$b&&g&&(g.name||g.type)){f=["<",f];g.name&&f.push(' name="',qa(g.name),'"');if(g.type){f.push(' type="',qa(g.type),'"');var l={};Wa(l,g);delete l.type;g=l}f.push(">");f=f.join("")}f=e.createElement(f);g&&(m(g)?f.className=g:fa(g)?f.className=g.join(" "):xc(f,g));2<d.length&&Ac(e,f,d);return f}
function Ac(a,b,c){function d(c){c&&b.appendChild(m(c)?a.createTextNode(c):c)}for(var e=2;e<c.length;e++){var f=c[e];!ha(f)||q(f)&&0<f.nodeType?d(f):w(Bc(f)?La(f):f,d)}}function Bc(a){if(a&&"number"==typeof a.length){if(q(a))return"function"==typeof a.item||"string"==typeof a.item;if(p(a))return"function"==typeof a.item}return!1};function Cc(a){var b=[];Dc(new Ec,a,b);return b.join("")}function Ec(){}
function Dc(a,b,c){if(null==b)c.push("null");else{if("object"==typeof b){if(fa(b)){var d=b;b=d.length;c.push("[");for(var e="",f=0;f<b;f++)c.push(e),Dc(a,d[f],c),e=",";c.push("]");return}if(b instanceof String||b instanceof Number||b instanceof Boolean)b=b.valueOf();else{c.push("{");e="";for(d in b)Object.prototype.hasOwnProperty.call(b,d)&&(f=b[d],"function"!=typeof f&&(c.push(e),Fc(d,c),c.push(":"),Dc(a,f,c),e=","));c.push("}");return}}switch(typeof b){case "string":Fc(b,c);break;case "number":c.push(isFinite(b)&&
!isNaN(b)?String(b):"null");break;case "boolean":c.push(String(b));break;case "function":c.push("null");break;default:throw Error("Unknown type: "+typeof b);}}}var Gc={'"':'\\"',"\\":"\\\\","/":"\\/","\b":"\\b","\f":"\\f","\n":"\\n","\r":"\\r","\t":"\\t","\x0B":"\\u000b"},Hc=/\uffff/.test("\uffff")?/[\\\"\x00-\x1f\x7f-\uffff]/g:/[\\\"\x00-\x1f\x7f-\xff]/g;
function Fc(a,b){b.push('"',a.replace(Hc,function(a){var b=Gc[a];b||(b="\\u"+(a.charCodeAt(0)|65536).toString(16).substr(1),Gc[a]=b);return b}),'"')};function Ic(){0!=Jc&&(Kc[this[ia]||(this[ia]=++ja)]=this);this.oa=this.oa;this.Fa=this.Fa}var Jc=0,Kc={};Ic.prototype.oa=!1;function Lc(a){a.oa||(a.oa=!0,a.ta(),0!=Jc&&(a=a[ia]||(a[ia]=++ja),delete Kc[a]))}Ic.prototype.ta=function(){if(this.Fa)for(;this.Fa.length;)this.Fa.shift()()};var Mc=Object.freeze||function(a){return a};var Nc=!y||9<=Number(kb),Oc=y&&!jb("9"),Pc=function(){if(!k.addEventListener||!Object.defineProperty)return!1;var a=!1,b=Object.defineProperty({},"passive",{get:function(){a=!0}});k.addEventListener("test",ca,b);k.removeEventListener("test",ca,b);return a}();function C(a,b){this.type=a;this.b=this.target=b;this.Ab=!0}C.prototype.c=function(){this.Ab=!1};function Qc(a,b){C.call(this,a?a.type:"");this.relatedTarget=this.b=this.target=null;this.button=this.screenY=this.screenX=this.clientY=this.clientX=0;this.key="";this.metaKey=this.shiftKey=this.altKey=this.ctrlKey=!1;this.pointerId=0;this.pointerType="";this.a=null;if(a){var c=this.type=a.type,d=a.changedTouches?a.changedTouches[0]:null;this.target=a.target||a.srcElement;this.b=b;if(b=a.relatedTarget){if(cb){a:{try{Xa(b.nodeName);var e=!0;break a}catch(f){}e=!1}e||(b=null)}}else"mouseover"==c?b=
a.fromElement:"mouseout"==c&&(b=a.toElement);this.relatedTarget=b;null===d?(this.clientX=void 0!==a.clientX?a.clientX:a.pageX,this.clientY=void 0!==a.clientY?a.clientY:a.pageY,this.screenX=a.screenX||0,this.screenY=a.screenY||0):(this.clientX=void 0!==d.clientX?d.clientX:d.pageX,this.clientY=void 0!==d.clientY?d.clientY:d.pageY,this.screenX=d.screenX||0,this.screenY=d.screenY||0);this.button=a.button;this.key=a.key||"";this.ctrlKey=a.ctrlKey;this.altKey=a.altKey;this.shiftKey=a.shiftKey;this.metaKey=
a.metaKey;this.pointerId=a.pointerId||0;this.pointerType=m(a.pointerType)?a.pointerType:Rc[a.pointerType]||"";this.a=a;a.defaultPrevented&&this.c()}}t(Qc,C);var Rc=Mc({2:"touch",3:"pen",4:"mouse"});Qc.prototype.c=function(){Qc.ib.c.call(this);var a=this.a;if(a.preventDefault)a.preventDefault();else if(a.returnValue=!1,Oc)try{if(a.ctrlKey||112<=a.keyCode&&123>=a.keyCode)a.keyCode=-1}catch(b){}};Qc.prototype.g=function(){return this.a};var Sc="closure_listenable_"+(1E6*Math.random()|0),Tc=0;function Uc(a,b,c,d,e){this.listener=a;this.a=null;this.src=b;this.type=c;this.capture=!!d;this.La=e;this.key=++Tc;this.ma=this.Ha=!1}function Vc(a){a.ma=!0;a.listener=null;a.a=null;a.src=null;a.La=null};function Wc(a){this.src=a;this.a={};this.b=0}function Xc(a,b,c,d,e,f){var g=b.toString();b=a.a[g];b||(b=a.a[g]=[],a.b++);var l=Yc(b,c,e,f);-1<l?(a=b[l],d||(a.Ha=!1)):(a=new Uc(c,a.src,g,!!e,f),a.Ha=d,b.push(a));return a}function Zc(a,b){var c=b.type;c in a.a&&Ia(a.a[c],b)&&(Vc(b),0==a.a[c].length&&(delete a.a[c],a.b--))}function Yc(a,b,c,d){for(var e=0;e<a.length;++e){var f=a[e];if(!f.ma&&f.listener==b&&f.capture==!!c&&f.La==d)return e}return-1};var $c="closure_lm_"+(1E6*Math.random()|0),ad={},bd=0;function cd(a,b,c,d,e){if(d&&d.once)dd(a,b,c,d,e);else if(fa(b))for(var f=0;f<b.length;f++)cd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?fd(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!1,d,e)}
function gd(a,b,c,d,e,f){if(!b)throw Error("Invalid event type");var g=q(e)?!!e.capture:!!e,l=hd(a);l||(a[$c]=l=new Wc(a));c=Xc(l,b,c,d,g,f);if(!c.a){d=id();c.a=d;d.src=a;d.listener=c;if(a.addEventListener)Pc||(e=g),void 0===e&&(e=!1),a.addEventListener(b.toString(),d,e);else if(a.attachEvent)a.attachEvent(jd(b.toString()),d);else throw Error("addEventListener and attachEvent are unavailable.");bd++}}
function id(){var a=kd,b=Nc?function(c){return a.call(b.src,b.listener,c)}:function(c){c=a.call(b.src,b.listener,c);if(!c)return c};return b}function dd(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)dd(a,b[f],c,d,e);else c=ed(c),a&&a[Sc]?ld(a,b,c,q(d)?!!d.capture:!!d,e):gd(a,b,c,!0,d,e)}
function E(a,b,c,d,e){if(fa(b))for(var f=0;f<b.length;f++)E(a,b[f],c,d,e);else(d=q(d)?!!d.capture:!!d,c=ed(c),a&&a[Sc])?(a=a.u,b=String(b).toString(),b in a.a&&(f=a.a[b],c=Yc(f,c,d,e),-1<c&&(Vc(f[c]),Array.prototype.splice.call(f,c,1),0==f.length&&(delete a.a[b],a.b--)))):a&&(a=hd(a))&&(b=a.a[b.toString()],a=-1,b&&(a=Yc(b,c,d,e)),(c=-1<a?b[a]:null)&&md(c))}
function md(a){if("number"!=typeof a&&a&&!a.ma){var b=a.src;if(b&&b[Sc])Zc(b.u,a);else{var c=a.type,d=a.a;b.removeEventListener?b.removeEventListener(c,d,a.capture):b.detachEvent&&b.detachEvent(jd(c),d);bd--;(c=hd(b))?(Zc(c,a),0==c.b&&(c.src=null,b[$c]=null)):Vc(a)}}}function jd(a){return a in ad?ad[a]:ad[a]="on"+a}function nd(a,b,c,d){var e=!0;if(a=hd(a))if(b=a.a[b.toString()])for(b=b.concat(),a=0;a<b.length;a++){var f=b[a];f&&f.capture==c&&!f.ma&&(f=od(f,d),e=e&&!1!==f)}return e}
function od(a,b){var c=a.listener,d=a.La||a.src;a.Ha&&md(a);return c.call(d,b)}
function kd(a,b){if(a.ma)return!0;if(!Nc){if(!b)a:{b=["window","event"];for(var c=k,d=0;d<b.length;d++)if(c=c[b[d]],null==c){b=null;break a}b=c}d=b;b=new Qc(d,this);c=!0;if(!(0>d.keyCode||void 0!=d.returnValue)){a:{var e=!1;if(0==d.keyCode)try{d.keyCode=-1;break a}catch(g){e=!0}if(e||void 0==d.returnValue)d.returnValue=!0}d=[];for(e=b.b;e;e=e.parentNode)d.push(e);a=a.type;for(e=d.length-1;0<=e;e--){b.b=d[e];var f=nd(d[e],a,!0,b);c=c&&f}for(e=0;e<d.length;e++)b.b=d[e],f=nd(d[e],a,!1,b),c=c&&f}return c}return od(a,
new Qc(b,this))}function hd(a){a=a[$c];return a instanceof Wc?a:null}var pd="__closure_events_fn_"+(1E9*Math.random()>>>0);function ed(a){if(p(a))return a;a[pd]||(a[pd]=function(b){return a.handleEvent(b)});return a[pd]};function F(){Ic.call(this);this.u=new Wc(this);this.Eb=this;this.Ra=null}t(F,Ic);F.prototype[Sc]=!0;F.prototype.removeEventListener=function(a,b,c,d){E(this,a,b,c,d)};
function G(a,b){var c,d=a.Ra;if(d)for(c=[];d;d=d.Ra)c.push(d);a=a.Eb;d=b.type||b;if(m(b))b=new C(b,a);else if(b instanceof C)b.target=b.target||a;else{var e=b;b=new C(d,a);Wa(b,e)}e=!0;if(c)for(var f=c.length-1;0<=f;f--){var g=b.b=c[f];e=qd(g,d,!0,b)&&e}g=b.b=a;e=qd(g,d,!0,b)&&e;e=qd(g,d,!1,b)&&e;if(c)for(f=0;f<c.length;f++)g=b.b=c[f],e=qd(g,d,!1,b)&&e}
F.prototype.ta=function(){F.ib.ta.call(this);if(this.u){var a=this.u,b=0,c;for(c in a.a){for(var d=a.a[c],e=0;e<d.length;e++)++b,Vc(d[e]);delete a.a[c];a.b--}}this.Ra=null};function fd(a,b,c,d,e){Xc(a.u,String(b),c,!1,d,e)}function ld(a,b,c,d,e){Xc(a.u,String(b),c,!0,d,e)}function qd(a,b,c,d){b=a.u.a[String(b)];if(!b)return!0;b=b.concat();for(var e=!0,f=0;f<b.length;++f){var g=b[f];if(g&&!g.ma&&g.capture==c){var l=g.listener,n=g.La||g.src;g.Ha&&Zc(a.u,g);e=!1!==l.call(n,d)&&e}}return e&&0!=d.Ab};function rd(a,b,c){if(p(a))c&&(a=r(a,c));else if(a&&"function"==typeof a.handleEvent)a=r(a.handleEvent,a);else throw Error("Invalid listener argument");return 2147483647<Number(b)?-1:k.setTimeout(a,b||0)}function sd(a){var b=null;return(new z(function(c,d){b=rd(function(){c(void 0)},a);-1==b&&d(Error("Failed to schedule timer."))})).s(function(a){k.clearTimeout(b);throw a;})};function td(a,b,c,d,e){this.reset(a,b,c,d,e)}td.prototype.a=null;var ud=0;td.prototype.reset=function(a,b,c,d,e){"number"==typeof e||ud++;d||na();this.b=b;delete this.a};function vd(a){this.f=a;this.b=this.c=this.a=null}function wd(a,b){this.name=a;this.value=b}wd.prototype.toString=function(){return this.name};var xd=new wd("SEVERE",1E3),yd=new wd("CONFIG",700),zd=new wd("FINE",500);function Ad(a){if(a.c)return a.c;if(a.a)return Ad(a.a);Aa("Root logger has no level set.");return null}
vd.prototype.log=function(a,b,c){if(a.value>=Ad(this).value)for(p(b)&&(b=b()),a=new td(a,String(b),this.f),c&&(a.a=c),c="log:"+a.b,(a=k.console)&&a.timeStamp&&a.timeStamp(c),(a=k.msWriteProfilerMark)&&a(c),c=this;c;)c=c.a};var Bd={},Cd=null;function Dd(a){Cd||(Cd=new vd(""),Bd[""]=Cd,Cd.c=yd);var b;if(!(b=Bd[a])){b=new vd(a);var c=a.lastIndexOf("."),d=a.substr(c+1);c=Dd(a.substr(0,c));c.b||(c.b={});c.b[d]=b;b.a=c;Bd[a]=b}return b};function Ed(a,b){this.b={};this.a=[];this.c=0;var c=arguments.length;if(1<c){if(c%2)throw Error("Uneven number of arguments");for(var d=0;d<c;d+=2)this.set(arguments[d],arguments[d+1])}else if(a){a instanceof Ed?(c=a.S(),d=a.P()):(c=Ra(a),d=Qa(a));for(var e=0;e<c.length;e++)this.set(c[e],d[e])}}h=Ed.prototype;h.P=function(){Fd(this);for(var a=[],b=0;b<this.a.length;b++)a.push(this.b[this.a[b]]);return a};h.S=function(){Fd(this);return this.a.concat()};
h.clear=function(){this.b={};this.c=this.a.length=0};function Fd(a){if(a.c!=a.a.length){for(var b=0,c=0;b<a.a.length;){var d=a.a[b];Gd(a.b,d)&&(a.a[c++]=d);b++}a.a.length=c}if(a.c!=a.a.length){var e={};for(c=b=0;b<a.a.length;)d=a.a[b],Gd(e,d)||(a.a[c++]=d,e[d]=1),b++;a.a.length=c}}h.get=function(a,b){return Gd(this.b,a)?this.b[a]:b};h.set=function(a,b){Gd(this.b,a)||(this.c++,this.a.push(a));this.b[a]=b};
h.forEach=function(a,b){for(var c=this.S(),d=0;d<c.length;d++){var e=c[d],f=this.get(e);a.call(b,f,e,this)}};function Gd(a,b){return Object.prototype.hasOwnProperty.call(a,b)};function H(a,b){a&&a.log(zd,b,void 0)};function Hd(a){return Da(a,function(a){a=a.toString(16);return 1<a.length?a:"0"+a}).join("")};var Id=null,Jd=null;function Kd(a){var b="";Ld(a,function(a){b+=String.fromCharCode(a)});return b}function Ld(a,b){function c(b){for(;d<a.length;){var c=a.charAt(d++),e=Jd[c];if(null!=e)return e;if(!/^[\s\xa0]*$/.test(c))throw Error("Unknown base64 encoding at char: "+c);}return b}Md();for(var d=0;;){var e=c(-1),f=c(0),g=c(64),l=c(64);if(64===l&&-1===e)break;b(e<<2|f>>4);64!=g&&(b(f<<4&240|g>>2),64!=l&&b(g<<6&192|l))}}
function Md(){if(!Id){Id={};Jd={};for(var a=0;65>a;a++)Id[a]="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=".charAt(a),Jd[Id[a]]=a,62<=a&&(Jd["ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_.".charAt(a)]=a)}};/*
 Portions of this code are from MochiKit, received by
 The Closure Authors under the MIT license. All other code is Copyright
 2005-2009 The Closure Authors. All Rights Reserved.
*/
function Nd(a,b){this.g=[];this.v=a;this.o=b||null;this.f=this.a=!1;this.c=void 0;this.u=this.w=this.i=!1;this.h=0;this.b=null;this.l=0}Nd.prototype.cancel=function(a){if(this.a)this.c instanceof Nd&&this.c.cancel();else{if(this.b){var b=this.b;delete this.b;a?b.cancel(a):(b.l--,0>=b.l&&b.cancel())}this.v?this.v.call(this.o,this):this.u=!0;this.a||(a=new Od,Pd(this),Qd(this,!1,a))}};Nd.prototype.m=function(a,b){this.i=!1;Qd(this,a,b)};function Qd(a,b,c){a.a=!0;a.c=c;a.f=!b;Rd(a)}
function Pd(a){if(a.a){if(!a.u)throw new Sd;a.u=!1}}Nd.prototype.A=function(a){Pd(this);Qd(this,!0,a)};function Td(a,b){Ud(a,null,b,void 0)}function Ud(a,b,c,d){a.g.push([b,c,d]);a.a&&Rd(a)}Nd.prototype.then=function(a,b,c){var d,e,f=new z(function(a,b){d=a;e=b});Ud(this,d,function(a){a instanceof Od?f.cancel():e(a)});return f.then(a,b,c)};mb(Nd);function Vd(a){return Ea(a.g,function(a){return p(a[1])})}
function Rd(a){if(a.h&&a.a&&Vd(a)){var b=a.h,c=Wd[b];c&&(k.clearTimeout(c.a),delete Wd[b]);a.h=0}a.b&&(a.b.l--,delete a.b);b=a.c;for(var d=c=!1;a.g.length&&!a.i;){var e=a.g.shift(),f=e[0],g=e[1];e=e[2];if(f=a.f?g:f)try{var l=f.call(e||a.o,b);void 0!==l&&(a.f=a.f&&(l==b||l instanceof Error),a.c=b=l);if(nb(b)||"function"===typeof k.Promise&&b instanceof k.Promise)d=!0,a.i=!0}catch(n){b=n,a.f=!0,Vd(a)||(c=!0)}}a.c=b;d&&(l=r(a.m,a,!0),d=r(a.m,a,!1),b instanceof Nd?(Ud(b,l,d),b.w=!0):b.then(l,d));c&&(b=
new Xd(b),Wd[b.a]=b,a.h=b.a)}function Sd(){u.call(this)}t(Sd,u);Sd.prototype.message="Deferred has already fired";Sd.prototype.name="AlreadyCalledError";function Od(){u.call(this)}t(Od,u);Od.prototype.message="Deferred was canceled";Od.prototype.name="CanceledError";function Xd(a){this.a=k.setTimeout(r(this.c,this),0);this.b=a}Xd.prototype.c=function(){delete Wd[this.a];throw this.b;};var Wd={};function Yd(){this.b=-1};function Zd(a,b){this.b=-1;this.b=$d;this.f=k.Uint8Array?new Uint8Array(this.b):Array(this.b);this.g=this.c=0;this.a=[];this.i=a;this.h=b;this.l=k.Int32Array?new Int32Array(64):Array(64);ae||(k.Int32Array?ae=new Int32Array(be):ae=be);this.reset()}var ae;t(Zd,Yd);for(var $d=64,ce=$d-1,de=[],ee=0;ee<ce;ee++)de[ee]=0;var fe=Ka(128,de);Zd.prototype.reset=function(){this.g=this.c=0;this.a=k.Int32Array?new Int32Array(this.h):La(this.h)};
function ge(a){for(var b=a.f,c=a.l,d=0,e=0;e<b.length;)c[d++]=b[e]<<24|b[e+1]<<16|b[e+2]<<8|b[e+3],e=4*d;for(b=16;64>b;b++){e=c[b-15]|0;d=c[b-2]|0;var f=(c[b-16]|0)+((e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3)|0,g=(c[b-7]|0)+((d>>>17|d<<15)^(d>>>19|d<<13)^d>>>10)|0;c[b]=f+g|0}d=a.a[0]|0;e=a.a[1]|0;var l=a.a[2]|0,n=a.a[3]|0,D=a.a[4]|0,vb=a.a[5]|0,tc=a.a[6]|0;f=a.a[7]|0;for(b=0;64>b;b++){var Bj=((d>>>2|d<<30)^(d>>>13|d<<19)^(d>>>22|d<<10))+(d&e^d&l^e&l)|0;g=D&vb^~D&tc;f=f+((D>>>6|D<<26)^(D>>>11|D<<21)^(D>>>
25|D<<7))|0;g=g+(ae[b]|0)|0;g=f+(g+(c[b]|0)|0)|0;f=tc;tc=vb;vb=D;D=n+g|0;n=l;l=e;e=d;d=g+Bj|0}a.a[0]=a.a[0]+d|0;a.a[1]=a.a[1]+e|0;a.a[2]=a.a[2]+l|0;a.a[3]=a.a[3]+n|0;a.a[4]=a.a[4]+D|0;a.a[5]=a.a[5]+vb|0;a.a[6]=a.a[6]+tc|0;a.a[7]=a.a[7]+f|0}
function he(a,b,c){void 0===c&&(c=b.length);var d=0,e=a.c;if(m(b))for(;d<c;)a.f[e++]=b.charCodeAt(d++),e==a.b&&(ge(a),e=0);else if(ha(b))for(;d<c;){var f=b[d++];if(!("number"==typeof f&&0<=f&&255>=f&&f==(f|0)))throw Error("message must be a byte array");a.f[e++]=f;e==a.b&&(ge(a),e=0)}else throw Error("message must be string or array");a.c=e;a.g+=c}
var be=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,
4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function ie(){Zd.call(this,8,je)}t(ie,Zd);var je=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];function ke(a){if(a.P&&"function"==typeof a.P)return a.P();if(m(a))return a.split("");if(ha(a)){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}return Qa(a)}function le(a){if(a.S&&"function"==typeof a.S)return a.S();if(!a.P||"function"!=typeof a.P){if(ha(a)||m(a)){var b=[];a=a.length;for(var c=0;c<a;c++)b.push(c);return b}return Ra(a)}}
function me(a,b){if(a.forEach&&"function"==typeof a.forEach)a.forEach(b,void 0);else if(ha(a)||m(a))w(a,b,void 0);else for(var c=le(a),d=ke(a),e=d.length,f=0;f<e;f++)b.call(void 0,d[f],c&&c[f],a)};var ne=/^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#([\s\S]*))?$/;function oe(a,b){if(a){a=a.split("&");for(var c=0;c<a.length;c++){var d=a[c].indexOf("="),e=null;if(0<=d){var f=a[c].substring(0,d);e=a[c].substring(d+1)}else f=a[c];b(f,e?decodeURIComponent(e.replace(/\+/g," ")):"")}}};function pe(a,b){this.b=this.l=this.c="";this.i=null;this.h=this.g="";this.f=!1;if(a instanceof pe){this.f=void 0!==b?b:a.f;qe(this,a.c);this.l=a.l;this.b=a.b;re(this,a.i);this.g=a.g;b=a.a;var c=new se;c.c=b.c;b.a&&(c.a=new Ed(b.a),c.b=b.b);te(this,c);this.h=a.h}else a&&(c=String(a).match(ne))?(this.f=!!b,qe(this,c[1]||"",!0),this.l=ue(c[2]||""),this.b=ue(c[3]||"",!0),re(this,c[4]),this.g=ue(c[5]||"",!0),te(this,c[6]||"",!0),this.h=ue(c[7]||"")):(this.f=!!b,this.a=new se(null,0,this.f))}
pe.prototype.toString=function(){var a=[],b=this.c;b&&a.push(ve(b,we,!0),":");var c=this.b;if(c||"file"==b)a.push("//"),(b=this.l)&&a.push(ve(b,we,!0),"@"),a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g,"%$1")),c=this.i,null!=c&&a.push(":",String(c));if(c=this.g)this.b&&"/"!=c.charAt(0)&&a.push("/"),a.push(ve(c,"/"==c.charAt(0)?xe:ye,!0));(c=this.a.toString())&&a.push("?",c);(c=this.h)&&a.push("#",ve(c,ze));return a.join("")};
function qe(a,b,c){a.c=c?ue(b,!0):b;a.c&&(a.c=a.c.replace(/:$/,""))}function re(a,b){if(b){b=Number(b);if(isNaN(b)||0>b)throw Error("Bad port number "+b);a.i=b}else a.i=null}function te(a,b,c){b instanceof se?(a.a=b,Ae(a.a,a.f)):(c||(b=ve(b,Be)),a.a=new se(b,0,a.f))}function I(a,b,c){a.a.set(b,c)}function Ce(a,b){return a.a.get(b)}function De(a){return a instanceof pe?new pe(a):new pe(a,void 0)}function Ee(a,b){var c=new pe(null,void 0);qe(c,"https");a&&(c.b=a);b&&(c.g=b);return c}
function ue(a,b){return a?b?decodeURI(a.replace(/%25/g,"%2525")):decodeURIComponent(a):""}function ve(a,b,c){return m(a)?(a=encodeURI(a).replace(b,Fe),c&&(a=a.replace(/%25([0-9a-fA-F]{2})/g,"%$1")),a):null}function Fe(a){a=a.charCodeAt(0);return"%"+(a>>4&15).toString(16)+(a&15).toString(16)}var we=/[#\/\?@]/g,ye=/[\#\?:]/g,xe=/[\#\?]/g,Be=/[\#\?@]/g,ze=/#/g;function se(a,b,c){this.b=this.a=null;this.c=a||null;this.f=!!c}
function Ge(a){a.a||(a.a=new Ed,a.b=0,a.c&&oe(a.c,function(b,c){He(a,decodeURIComponent(b.replace(/\+/g," ")),c)}))}function Ie(a){var b=le(a);if("undefined"==typeof b)throw Error("Keys are undefined");var c=new se(null,0,void 0);a=ke(a);for(var d=0;d<b.length;d++){var e=b[d],f=a[d];fa(f)?Je(c,e,f):He(c,e,f)}return c}function He(a,b,c){Ge(a);a.c=null;b=Ke(a,b);var d=a.a.get(b);d||a.a.set(b,d=[]);d.push(c);a.b+=1}
function Le(a,b){Ge(a);b=Ke(a,b);Gd(a.a.b,b)&&(a.c=null,a.b-=a.a.get(b).length,a=a.a,Gd(a.b,b)&&(delete a.b[b],a.c--,a.a.length>2*a.c&&Fd(a)))}h=se.prototype;h.clear=function(){this.a=this.c=null;this.b=0};function Me(a,b){Ge(a);b=Ke(a,b);return Gd(a.a.b,b)}h.forEach=function(a,b){Ge(this);this.a.forEach(function(c,d){w(c,function(c){a.call(b,c,d,this)},this)},this)};h.S=function(){Ge(this);for(var a=this.a.P(),b=this.a.S(),c=[],d=0;d<b.length;d++)for(var e=a[d],f=0;f<e.length;f++)c.push(b[d]);return c};
h.P=function(a){Ge(this);var b=[];if(m(a))Me(this,a)&&(b=Ka(b,this.a.get(Ke(this,a))));else{a=this.a.P();for(var c=0;c<a.length;c++)b=Ka(b,a[c])}return b};h.set=function(a,b){Ge(this);this.c=null;a=Ke(this,a);Me(this,a)&&(this.b-=this.a.get(a).length);this.a.set(a,[b]);this.b+=1;return this};h.get=function(a,b){a=a?this.P(a):[];return 0<a.length?String(a[0]):b};function Je(a,b,c){Le(a,b);0<c.length&&(a.c=null,a.a.set(Ke(a,b),La(c)),a.b+=c.length)}
h.toString=function(){if(this.c)return this.c;if(!this.a)return"";for(var a=[],b=this.a.S(),c=0;c<b.length;c++){var d=b[c],e=encodeURIComponent(String(d));d=this.P(d);for(var f=0;f<d.length;f++){var g=e;""!==d[f]&&(g+="="+encodeURIComponent(String(d[f])));a.push(g)}}return this.c=a.join("&")};function Ke(a,b){b=String(b);a.f&&(b=b.toLowerCase());return b}function Ae(a,b){b&&!a.f&&(Ge(a),a.c=null,a.a.forEach(function(a,b){var c=b.toLowerCase();b!=c&&(Le(this,b),Je(this,c,a))},a));a.f=b};function Ne(){}Ne.prototype.c=null;function Oe(a){return a.c||(a.c=a.b())};var Pe;function Qe(){}t(Qe,Ne);Qe.prototype.a=function(){var a=Re(this);return a?new ActiveXObject(a):new XMLHttpRequest};Qe.prototype.b=function(){var a={};Re(this)&&(a[0]=!0,a[1]=!0);return a};
function Re(a){if(!a.f&&"undefined"==typeof XMLHttpRequest&&"undefined"!=typeof ActiveXObject){for(var b=["MSXML2.XMLHTTP.6.0","MSXML2.XMLHTTP.3.0","MSXML2.XMLHTTP","Microsoft.XMLHTTP"],c=0;c<b.length;c++){var d=b[c];try{return new ActiveXObject(d),a.f=d}catch(e){}}throw Error("Could not create ActiveXObject. ActiveX might be disabled, or MSXML might not be installed");}return a.f}Pe=new Qe;function Se(a){F.call(this);this.headers=new Ed;this.w=a||null;this.b=!1;this.v=this.a=null;this.g=this.I=this.i="";this.c=this.G=this.h=this.A=!1;this.f=0;this.m=null;this.l=Te;this.o=this.N=!1}t(Se,F);var Te="",Ue=Se.prototype,Ve=Dd("goog.net.XhrIo");Ue.J=Ve;var We=/^https?$/i,Xe=["POST","PUT"];
function Ye(a,b,c,d,e){if(a.a)throw Error("[goog.net.XhrIo] Object is active with another request="+a.i+"; newUri="+b);c=c?c.toUpperCase():"GET";a.i=b;a.g="";a.I=c;a.A=!1;a.b=!0;a.a=a.w?a.w.a():Pe.a();a.v=a.w?Oe(a.w):Oe(Pe);a.a.onreadystatechange=r(a.zb,a);try{H(a.J,Ze(a,"Opening Xhr")),a.G=!0,a.a.open(c,String(b),!0),a.G=!1}catch(g){H(a.J,Ze(a,"Error opening Xhr: "+g.message));$e(a,g);return}b=d||"";var f=new Ed(a.headers);e&&me(e,function(a,b){f.set(b,a)});e=Fa(f.S());d=k.FormData&&b instanceof
k.FormData;!Ha(Xe,c)||e||d||f.set("Content-Type","application/x-www-form-urlencoded;charset=utf-8");f.forEach(function(a,b){this.a.setRequestHeader(b,a)},a);a.l&&(a.a.responseType=a.l);"withCredentials"in a.a&&a.a.withCredentials!==a.N&&(a.a.withCredentials=a.N);try{af(a),0<a.f&&(a.o=bf(a.a),H(a.J,Ze(a,"Will abort after "+a.f+"ms if incomplete, xhr2 "+a.o)),a.o?(a.a.timeout=a.f,a.a.ontimeout=r(a.Ea,a)):a.m=rd(a.Ea,a.f,a)),H(a.J,Ze(a,"Sending request")),a.h=!0,a.a.send(b),a.h=!1}catch(g){H(a.J,Ze(a,
"Send error: "+g.message)),$e(a,g)}}function bf(a){return y&&jb(9)&&"number"==typeof a.timeout&&void 0!==a.ontimeout}function Ga(a){return"content-type"==a.toLowerCase()}h=Se.prototype;h.Ea=function(){"undefined"!=typeof aa&&this.a&&(this.g="Timed out after "+this.f+"ms, aborting",H(this.J,Ze(this,this.g)),G(this,"timeout"),this.abort(8))};function $e(a,b){a.b=!1;a.a&&(a.c=!0,a.a.abort(),a.c=!1);a.g=b;cf(a);df(a)}function cf(a){a.A||(a.A=!0,G(a,"complete"),G(a,"error"))}
h.abort=function(){this.a&&this.b&&(H(this.J,Ze(this,"Aborting")),this.b=!1,this.c=!0,this.a.abort(),this.c=!1,G(this,"complete"),G(this,"abort"),df(this))};h.ta=function(){this.a&&(this.b&&(this.b=!1,this.c=!0,this.a.abort(),this.c=!1),df(this,!0));Se.ib.ta.call(this)};h.zb=function(){this.oa||(this.G||this.h||this.c?ef(this):this.fc())};h.fc=function(){ef(this)};
function ef(a){if(a.b&&"undefined"!=typeof aa)if(a.v[1]&&4==ff(a)&&2==gf(a))H(a.J,Ze(a,"Local request error detected and ignored"));else if(a.h&&4==ff(a))rd(a.zb,0,a);else if(G(a,"readystatechange"),4==ff(a)){H(a.J,Ze(a,"Request complete"));a.b=!1;try{var b=gf(a);a:switch(b){case 200:case 201:case 202:case 204:case 206:case 304:case 1223:var c=!0;break a;default:c=!1}var d;if(!(d=c)){var e;if(e=0===b){var f=String(a.i).match(ne)[1]||null;if(!f&&k.self&&k.self.location){var g=k.self.location.protocol;
f=g.substr(0,g.length-1)}e=!We.test(f?f.toLowerCase():"")}d=e}if(d)G(a,"complete"),G(a,"success");else{try{var l=2<ff(a)?a.a.statusText:""}catch(n){H(a.J,"Can not get status: "+n.message),l=""}a.g=l+" ["+gf(a)+"]";cf(a)}}finally{df(a)}}}function df(a,b){if(a.a){af(a);var c=a.a,d=a.v[0]?ca:null;a.a=null;a.v=null;b||G(a,"ready");try{c.onreadystatechange=d}catch(e){(a=a.J)&&a.log(xd,"Problem encountered resetting onreadystatechange: "+e.message,void 0)}}}
function af(a){a.a&&a.o&&(a.a.ontimeout=null);"number"==typeof a.m&&(k.clearTimeout(a.m),a.m=null)}function ff(a){return a.a?a.a.readyState:0}function gf(a){try{return 2<ff(a)?a.a.status:-1}catch(b){return-1}}function hf(a){try{return a.a?a.a.responseText:""}catch(b){return H(a.J,"Can not get responseText: "+b.message),""}}
h.getResponse=function(){try{if(!this.a)return null;if("response"in this.a)return this.a.response;switch(this.l){case Te:case "text":return this.a.responseText;case "arraybuffer":if("mozResponseArrayBuffer"in this.a)return this.a.mozResponseArrayBuffer}var a=this.J;a&&a.log(xd,"Response type "+this.l+" is not supported on this browser",void 0);return null}catch(b){return H(this.J,"Can not get response: "+b.message),null}};function Ze(a,b){return b+" ["+a.I+" "+a.i+" "+gf(a)+"]"};var jf=/^[+a-zA-Z0-9_.!#$%&'*\/=?^`{|}~-]+@([a-zA-Z0-9-]+\.)+[a-zA-Z0-9]{2,63}$/;function kf(a){var b={},c=b.document||document,d=gc(a),e=document.createElement("SCRIPT"),f={Bb:e,Ea:void 0},g=new Nd(lf,f),l=null,n=null!=b.timeout?b.timeout:5E3;0<n&&(l=window.setTimeout(function(){mf(e,!0);var a=new nf(of,"Timeout reached for loading script "+d);Pd(g);Qd(g,!1,a)},n),f.Ea=l);e.onload=e.onreadystatechange=function(){e.readyState&&"loaded"!=e.readyState&&"complete"!=e.readyState||(mf(e,b.Oc||!1,l),g.A(null))};e.onerror=function(){mf(e,!0,l);var a=new nf(pf,"Error while loading script "+
d);Pd(g);Qd(g,!1,a)};f=b.attributes||{};Wa(f,{type:"text/javascript",charset:"UTF-8"});xc(e,f);e.src=gc(a);qf(c).appendChild(e);return g}function qf(a){var b;return(b=(a||document).getElementsByTagName("HEAD"))&&0!=b.length?b[0]:a.documentElement}function lf(){if(this&&this.Bb){var a=this.Bb;a&&"SCRIPT"==a.tagName&&mf(a,!0,this.Ea)}}
function mf(a,b,c){null!=c&&k.clearTimeout(c);a.onload=ca;a.onerror=ca;a.onreadystatechange=ca;b&&window.setTimeout(function(){a&&a.parentNode&&a.parentNode.removeChild(a)},0)}var pf=0,of=1;function nf(a,b){var c="Jsloader error (code #"+a+")";b&&(c+=": "+b);u.call(this,c);this.code=a}t(nf,u);function rf(){}t(rf,Ne);rf.prototype.a=function(){var a=new XMLHttpRequest;if("withCredentials"in a)return a;if("undefined"!=typeof XDomainRequest)return new sf;throw Error("Unsupported browser");};rf.prototype.b=function(){return{}};
function sf(){this.a=new XDomainRequest;this.readyState=0;this.onreadystatechange=null;this.responseText="";this.status=-1;this.statusText=this.responseXML=null;this.a.onload=r(this.Sb,this);this.a.onerror=r(this.wb,this);this.a.onprogress=r(this.Tb,this);this.a.ontimeout=r(this.Ub,this)}h=sf.prototype;h.open=function(a,b,c){if(null!=c&&!c)throw Error("Only async requests are supported.");this.a.open(a,b)};
h.send=function(a){if(a)if("string"==typeof a)this.a.send(a);else throw Error("Only string data is supported");else this.a.send()};h.abort=function(){this.a.abort()};h.setRequestHeader=function(){};h.getResponseHeader=function(a){return"content-type"==a.toLowerCase()?this.a.contentType:""};h.Sb=function(){this.status=200;this.responseText=this.a.responseText;tf(this,4)};h.wb=function(){this.status=500;this.responseText="";tf(this,4)};h.Ub=function(){this.wb()};
h.Tb=function(){this.status=200;tf(this,1)};function tf(a,b){a.readyState=b;if(a.onreadystatechange)a.onreadystatechange()}h.getAllResponseHeaders=function(){return"content-type: "+this.a.contentType};function uf(){var a=J();return y&&!!kb&&11==kb||/Edge\/\d+/.test(a)}function vf(){return k.window&&k.window.location.href||""}function wf(a,b){b=b||k.window;var c="about:blank";a&&(c=nc(pc(a)));b.location.href=c}function xf(a,b){var c=[],d;for(d in a)d in b?typeof a[d]!=typeof b[d]?c.push(d):fa(a[d])?Ta(a[d],b[d])||c.push(d):"object"==typeof a[d]&&null!=a[d]&&null!=b[d]?0<xf(a[d],b[d]).length&&c.push(d):a[d]!==b[d]&&c.push(d):c.push(d);for(d in b)d in a||c.push(d);return c}
function yf(){var a=J();a=zf(a)!=Af?null:(a=a.match(/\sChrome\/(\d+)/i))&&2==a.length?parseInt(a[1],10):null;return a&&30>a?!1:!y||!kb||9<kb}function Bf(a){a=(a||J()).toLowerCase();return a.match(/android/)||a.match(/webos/)||a.match(/iphone|ipad|ipod/)||a.match(/blackberry/)||a.match(/windows phone/)||a.match(/iemobile/)?!0:!1}function Cf(a){a=a||k.window;try{a.close()}catch(b){}}
function Df(a,b,c){var d=Math.floor(1E9*Math.random()).toString();b=b||500;c=c||600;var e=(window.screen.availHeight-c)/2,f=(window.screen.availWidth-b)/2;b={width:b,height:c,top:0<e?e:0,left:0<f?f:0,location:!0,resizable:!0,statusbar:!0,toolbar:!1};c=J().toLowerCase();d&&(b.target=d,v(c,"crios/")&&(b.target="_blank"));zf(J())==Ef&&(a=a||"http://localhost",b.scrollbars=!0);c=a||"";(d=b)||(d={});a=window;b=c instanceof lc?c:pc("undefined"!=typeof c.href?c.href:String(c));c=d.target||c.target;e=[];
for(g in d)switch(g){case "width":case "height":case "top":case "left":e.push(g+"="+d[g]);break;case "target":case "noreferrer":break;default:e.push(g+"="+(d[g]?1:0))}var g=e.join(",");(x("iPhone")&&!x("iPod")&&!x("iPad")||x("iPad")||x("iPod"))&&a.navigator&&a.navigator.standalone&&c&&"_self"!=c?(g=a.document.createElement("A"),b instanceof lc||b instanceof lc||(b=b.la?b.ja():String(b),oc.test(b)||(b="about:invalid#zClosurez"),b=qc(b)),g.href=nc(b),g.setAttribute("target",c),d.noreferrer&&g.setAttribute("rel",
"noreferrer"),d=document.createEvent("MouseEvent"),d.initMouseEvent("click",!0,!0,a,1),g.dispatchEvent(d),g={}):d.noreferrer?(g=a.open("",c,g),a=nc(b),g&&(bb&&v(a,";")&&(a="'"+a.replace(/'/g,"%27")+"'"),g.opener=null,dc("b/12014412, meta tag with sanitized URL"),a='<META HTTP-EQUIV="refresh" content="0; url='+qa(a)+'">',a=vc(a),g.document.write(uc(a)),g.document.close())):g=a.open(nc(b),c,g);if(g)try{g.focus()}catch(l){}return g}
function Ff(a){return new z(function(b){function c(){sd(2E3).then(function(){if(!a||a.closed)b();else return c()})}return c()})}var Gf=/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/;function Hf(){var a=null;return(new z(function(b){"complete"==k.document.readyState?b():(a=function(){b()},dd(window,"load",a))})).s(function(b){E(window,"load",a);throw b;})}
function If(){return Jf(void 0)?Hf().then(function(){return new z(function(a,b){var c=k.document,d=setTimeout(function(){b(Error("Cordova framework is not ready."))},1E3);c.addEventListener("deviceready",function(){clearTimeout(d);a()},!1)})}):B(Error("Cordova must run in an Android or iOS file scheme."))}function Jf(a){a=a||J();return!("file:"!==Kf()||!a.toLowerCase().match(/iphone|ipad|ipod|android/))}function Lf(){var a=k.window;try{return!(!a||a==a.top)}catch(b){return!1}}
function K(){return firebase.INTERNAL.hasOwnProperty("reactNative")?"ReactNative":firebase.INTERNAL.hasOwnProperty("node")?"Node":"Browser"}function Mf(){var a=K();return"ReactNative"===a||"Node"===a}var Ef="Firefox",Af="Chrome";
function zf(a){var b=a.toLowerCase();if(v(b,"opera/")||v(b,"opr/")||v(b,"opios/"))return"Opera";if(v(b,"iemobile"))return"IEMobile";if(v(b,"msie")||v(b,"trident/"))return"IE";if(v(b,"edge/"))return"Edge";if(v(b,"firefox/"))return Ef;if(v(b,"silk/"))return"Silk";if(v(b,"blackberry"))return"Blackberry";if(v(b,"webos"))return"Webos";if(!v(b,"safari/")||v(b,"chrome/")||v(b,"crios/")||v(b,"android"))if(!v(b,"chrome/")&&!v(b,"crios/")||v(b,"edge/")){if(v(b,"android"))return"Android";if((a=a.match(/([a-zA-Z\d\.]+)\/[a-zA-Z\d\.]*$/))&&
2==a.length)return a[1]}else return Af;else return"Safari";return"Other"}var Nf={Cc:"FirebaseCore-web",Ec:"FirebaseUI-web"};function Of(a,b){b=b||[];var c=[],d={},e;for(e in Nf)d[Nf[e]]=!0;for(e=0;e<b.length;e++)"undefined"!==typeof d[b[e]]&&(delete d[b[e]],c.push(b[e]));c.sort();b=c;b.length||(b=["FirebaseCore-web"]);c=K();d="";"Browser"===c?d=zf(J()):d=c;return d+"/JsCore/"+a+"/"+b.join(",")}function J(){return k.navigator&&k.navigator.userAgent||""}
function L(a,b){a=a.split(".");b=b||k;for(var c=0;c<a.length&&"object"==typeof b&&null!=b;c++)b=b[a[c]];c!=a.length&&(b=void 0);return b}function Pf(){try{var a=k.localStorage,b=Qf();if(a)return a.setItem(b,"1"),a.removeItem(b),uf()?!!k.indexedDB:!0}catch(c){}return!1}function Rf(){return(Sf()||"chrome-extension:"===Kf()||Jf())&&!Mf()&&Pf()}function Sf(){return"http:"===Kf()||"https:"===Kf()}function Kf(){return k.location&&k.location.protocol||null}
function Tf(a){a=a||J();return Bf(a)||zf(a)==Ef?!1:!0}function Uf(a){return"undefined"===typeof a?null:Cc(a)}function Vf(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&null!==a[c]&&void 0!==a[c]&&(b[c]=a[c]);return b}function Wf(a){if(null!==a)return JSON.parse(a)}function Qf(a){return a?a:""+Math.floor(1E9*Math.random()).toString()}function Xf(a){a=a||J();return"Safari"==zf(a)||a.toLowerCase().match(/iphone|ipad|ipod/)?!1:!0}
function Yf(){var a=k.___jsl;if(a&&a.H)for(var b in a.H)if(a.H[b].r=a.H[b].r||[],a.H[b].L=a.H[b].L||[],a.H[b].r=a.H[b].L.concat(),a.CP)for(var c=0;c<a.CP.length;c++)a.CP[c]=null}function Zf(){var a=k.navigator;return a&&"boolean"===typeof a.onLine&&(Sf()||"chrome-extension:"===Kf()||"undefined"!==typeof a.connection)?a.onLine:!0}function $f(a,b,c,d){if(a>b)throw Error("Short delay should be less than long delay!");this.c=a;this.b=b;a=c||J();d=d||K();this.a=Bf(a)||"ReactNative"===d}
$f.prototype.get=function(){return this.a?this.b:this.c};function ag(){var a=k.document;return a&&"undefined"!==typeof a.visibilityState?"visible"==a.visibilityState:!0}function bg(){var a=k.document,b=null;return ag()||!a?A():(new z(function(c){b=function(){ag()&&(a.removeEventListener("visibilitychange",b,!1),c())};a.addEventListener("visibilitychange",b,!1)})).s(function(c){a.removeEventListener("visibilitychange",b,!1);throw c;})}
function cg(a){try{var b=new Date(parseInt(a,10));if(!isNaN(b.getTime())&&!/[^0-9]/.test(a))return b.toUTCString()}catch(c){}return null};var dg={};var eg;try{var fg={};Object.defineProperty(fg,"abcd",{configurable:!0,enumerable:!0,value:1});Object.defineProperty(fg,"abcd",{configurable:!0,enumerable:!0,value:2});eg=2==fg.abcd}catch(a){eg=!1}function M(a,b,c){eg?Object.defineProperty(a,b,{configurable:!0,enumerable:!0,value:c}):a[b]=c}function gg(a,b){if(b)for(var c in b)b.hasOwnProperty(c)&&M(a,c,b[c])}function hg(a){var b={};gg(b,a);return b}function ig(a){var b={},c;for(c in a)a.hasOwnProperty(c)&&(b[c]=a[c]);return b}
function jg(a,b){if(!b||!b.length)return!0;if(!a)return!1;for(var c=0;c<b.length;c++){var d=a[b[c]];if(void 0===d||null===d||""===d)return!1}return!0}function kg(a){var b=a;if("object"==typeof a&&null!=a){b="length"in a?[]:{};for(var c in a)M(b,c,kg(a[c]))}return b};function lg(a){var b={},c=a[mg],d=a[ng];a=a[og];if(!c||!a)throw Error("Invalid provider user info!");b[pg]=d||null;b[qg]=c;M(this,rg,a);M(this,sg,kg(b))}var mg="email",ng="newEmail",og="requestType",qg="email",pg="fromEmail",sg="data",rg="operation";function N(a,b){this.code=tg+a;this.message=b||ug[a]||""}t(N,Error);N.prototype.B=function(){return{code:this.code,message:this.message}};N.prototype.toJSON=function(){return this.B()};function vg(a){var b=a&&a.code;return b?new N(b.substring(tg.length),a.message):null}
var tg="auth/",ug={"argument-error":"","app-not-authorized":"This app, identified by the domain where it's hosted, is not authorized to use Firebase Authentication with the provided API key. Review your key configuration in the Google API console.","app-not-installed":"The requested mobile application corresponding to the identifier (Android package name or iOS bundle ID) provided is not installed on this device.","captcha-check-failed":"The reCAPTCHA response token provided is either invalid, expired, already used or the domain associated with it does not match the list of whitelisted domains.",
"code-expired":"The SMS code has expired. Please re-send the verification code to try again.","cordova-not-ready":"Cordova framework is not ready.","cors-unsupported":"This browser is not supported.","credential-already-in-use":"This credential is already associated with a different user account.","custom-token-mismatch":"The custom token corresponds to a different audience.","requires-recent-login":"This operation is sensitive and requires recent authentication. Log in again before retrying this request.",
"dynamic-link-not-activated":"Please activate Dynamic Links in the Firebase Console and agree to the terms and conditions.","email-already-in-use":"The email address is already in use by another account.","expired-action-code":"The action code has expired. ","cancelled-popup-request":"This operation has been cancelled due to another conflicting popup being opened.","internal-error":"An internal error has occurred.","invalid-app-credential":"The phone verification request contains an invalid application verifier. The reCAPTCHA token response is either invalid or expired.",
"invalid-app-id":"The mobile app identifier is not registed for the current project.","invalid-user-token":"The user's credential is no longer valid. The user must sign in again.","invalid-auth-event":"An internal error has occurred.","invalid-verification-code":"The SMS verification code used to create the phone auth credential is invalid. Please resend the verification code sms and be sure use the verification code provided by the user.","invalid-continue-uri":"The continue URL provided in the request is invalid.",
"invalid-cordova-configuration":"The following Cordova plugins must be installed to enable OAuth sign-in: cordova-plugin-buildinfo, cordova-universal-links-plugin, cordova-plugin-browsertab, cordova-plugin-inappbrowser and cordova-plugin-customurlscheme.","invalid-custom-token":"The custom token format is incorrect. Please check the documentation.","invalid-email":"The email address is badly formatted.","invalid-api-key":"Your API key is invalid, please check you have copied it correctly.","invalid-cert-hash":"The SHA-1 certificate hash provided is invalid.",
"invalid-credential":"The supplied auth credential is malformed or has expired.","invalid-persistence-type":"The specified persistence type is invalid. It can only be local, session or none.","invalid-message-payload":"The email template corresponding to this action contains invalid characters in its message. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-oauth-provider":"EmailAuthProvider is not supported for this operation. This operation only supports OAuth providers.",
"invalid-oauth-client-id":"The OAuth client ID provided is either invalid or does not match the specified API key.","unauthorized-domain":"This domain is not authorized for OAuth operations for your Firebase project. Edit the list of authorized domains from the Firebase console.","invalid-action-code":"The action code is invalid. This can happen if the code is malformed, expired, or has already been used.","wrong-password":"The password is invalid or the user does not have a password.","invalid-phone-number":"The format of the phone number provided is incorrect. Please enter the phone number in a format that can be parsed into E.164 format. E.164 phone numbers are written in the format [+][country code][subscriber number including area code].",
"invalid-recipient-email":"The email corresponding to this action failed to send as the provided recipient email address is invalid.","invalid-sender":"The email template corresponding to this action contains an invalid sender email or name. Please fix by going to the Auth email templates section in the Firebase Console.","invalid-verification-id":"The verification ID used to create the phone auth credential is invalid.","missing-android-pkg-name":"An Android Package Name must be provided if the Android App is required to be installed.",
"auth-domain-config-required":"Be sure to include authDomain when calling firebase.initializeApp(), by following the instructions in the Firebase console.","missing-app-credential":"The phone verification request is missing an application verifier assertion. A reCAPTCHA response token needs to be provided.","missing-verification-code":"The phone auth credential was created with an empty SMS verification code.","missing-continue-uri":"A continue URL must be provided in the request.","missing-iframe-start":"An internal error has occurred.",
"missing-ios-bundle-id":"An iOS Bundle ID must be provided if an App Store ID is provided.","missing-phone-number":"To send verification codes, provide a phone number for the recipient.","missing-verification-id":"The phone auth credential was created with an empty verification ID.","app-deleted":"This instance of FirebaseApp has been deleted.","account-exists-with-different-credential":"An account already exists with the same email address but different sign-in credentials. Sign in using a provider associated with this email address.",
"network-request-failed":"A network error (such as timeout, interrupted connection or unreachable host) has occurred.","no-auth-event":"An internal error has occurred.","no-such-provider":"User was not linked to an account with the given provider.","operation-not-allowed":"The given sign-in provider is disabled for this Firebase project. Enable it in the Firebase console, under the sign-in method tab of the Auth section.","operation-not-supported-in-this-environment":'This operation is not supported in the environment this application is running on. "location.protocol" must be http, https or chrome-extension and web storage must be enabled.',
"popup-blocked":"Unable to establish a connection with the popup. It may have been blocked by the browser.","popup-closed-by-user":"The popup has been closed by the user before finalizing the operation.","provider-already-linked":"User can only be linked to one identity for the given provider.","quota-exceeded":"The project's quota for this operation has been exceeded.","redirect-cancelled-by-user":"The redirect operation has been cancelled by the user before finalizing.","redirect-operation-pending":"A redirect sign-in operation is already pending.",
timeout:"The operation has timed out.","user-token-expired":"The user's credential is no longer valid. The user must sign in again.","too-many-requests":"We have blocked all requests from this device due to unusual activity. Try again later.","unauthorized-continue-uri":"The domain of the continue URL is not whitelisted.  Please whitelist the domain in the Firebase console.","unsupported-persistence-type":"The current environment does not support the specified persistence type.","user-cancelled":"User did not grant your application the permissions it requested.",
"user-not-found":"There is no user record corresponding to this identifier. The user may have been deleted.","user-disabled":"The user account has been disabled by an administrator.","user-mismatch":"The supplied credentials do not correspond to the previously signed in user.","user-signed-out":"","weak-password":"The password must be 6 characters long or more.","web-storage-unsupported":"This browser is not supported or 3rd party cookies and data may be disabled."};function wg(a){var b=a[xg];if("undefined"===typeof b)throw new N("missing-continue-uri");if("string"!==typeof b||"string"===typeof b&&!b.length)throw new N("invalid-continue-uri");this.h=b;this.c=this.a=null;this.g=!1;var c=a[yg];if(c&&"object"===typeof c){b=c[zg];var d=c[Ag];c=c[Bg];if("string"===typeof b&&b.length){this.a=b;if("undefined"!==typeof d&&"boolean"!==typeof d)throw new N("argument-error",Ag+" property must be a boolean when specified.");this.g=!!d;if("undefined"!==typeof c&&("string"!==
typeof c||"string"===typeof c&&!c.length))throw new N("argument-error",Bg+" property must be a non empty string when specified.");this.c=c||null}else{if("undefined"!==typeof b)throw new N("argument-error",zg+" property must be a non empty string when specified.");if("undefined"!==typeof d||"undefined"!==typeof c)throw new N("missing-android-pkg-name");}}else if("undefined"!==typeof c)throw new N("argument-error",yg+" property must be a non null object when specified.");this.b=null;if((b=a[Cg])&&"object"===
typeof b)if(b=b[Dg],"string"===typeof b&&b.length)this.b=b;else{if("undefined"!==typeof b)throw new N("argument-error",Dg+" property must be a non empty string when specified.");}else if("undefined"!==typeof b)throw new N("argument-error",Cg+" property must be a non null object when specified.");a=a[Eg];if("undefined"!==typeof a&&"boolean"!==typeof a)throw new N("argument-error",Eg+" property must be a boolean when specified.");if((this.f=!!a)&&!this.b&&!this.a)throw new N("argument-error",Eg+" property can't be true when no mobile application is provided.");
}var yg="android",Eg="handleCodeInApp",Cg="iOS",xg="url",Ag="installApp",Bg="minimumVersion",zg="packageName",Dg="bundleId";function Fg(a){var b={};b.continueUrl=a.h;b.canHandleCodeInApp=a.f;if(b.androidPackageName=a.a)b.androidMinimumVersion=a.c,b.androidInstallApp=a.g;b.iOSBundleId=a.b;for(var c in b)null===b[c]&&delete b[c];return b};function Gg(a){this.b=a.sub;na();this.a=a.provider_id||a.firebase&&a.firebase.sign_in_provider||null}function Hg(a){a=a.split(".");if(3!=a.length)return null;a=a[1];for(var b=(4-a.length%4)%4,c=0;c<b;c++)a+=".";try{var d=JSON.parse(Kd(a));if(d.sub&&d.iss&&d.aud&&d.exp)return new Gg(d)}catch(e){}return null};var Ig="oauth_consumer_key oauth_nonce oauth_signature oauth_signature_method oauth_timestamp oauth_token oauth_version".split(" "),Jg=["client_id","response_type","scope","redirect_uri","state"],Kg={Dc:{Ma:"locale",za:500,ya:600,Na:"facebook.com",$a:Jg},Fc:{Ma:null,za:500,ya:620,Na:"github.com",$a:Jg},Gc:{Ma:"hl",za:515,ya:680,Na:"google.com",$a:Jg},Mc:{Ma:"lang",za:485,ya:705,Na:"twitter.com",$a:Ig}};function Lg(a){for(var b in Kg)if(Kg[b].Na==a)return Kg[b];return null};function Mg(a){var b={};b["facebook.com"]=Ng;b["google.com"]=Og;b["github.com"]=Pg;b["twitter.com"]=Qg;var c=a&&a[Rg];try{if(c)return b[c]?new b[c](a):new Sg(a);if("undefined"!==typeof a[Tg])return new Ug(a)}catch(d){}return null}var Tg="idToken",Rg="providerId";function Ug(a){var b=a[Rg];if(!b&&a[Tg]){var c=Hg(a[Tg]);c&&c.a&&(b=c.a)}if(!b)throw Error("Invalid additional user info!");a=!!a.isNewUser;M(this,"providerId",b);M(this,"isNewUser",a)}
function Sg(a){Ug.call(this,a);a=Wf(a.rawUserInfo||"{}");M(this,"profile",kg(a||{}))}t(Sg,Ug);function Ng(a){Sg.call(this,a);if("facebook.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Ng,Sg);function Pg(a){Sg.call(this,a);if("github.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",this.profile&&this.profile.login||null)}t(Pg,Sg);function Og(a){Sg.call(this,a);if("google.com"!=this.providerId)throw Error("Invalid provider ID!");}t(Og,Sg);
function Qg(a){Sg.call(this,a);if("twitter.com"!=this.providerId)throw Error("Invalid provider ID!");M(this,"username",a.screenName||null)}t(Qg,Sg);function Vg(a,b){return a.then(function(a){if(a[O]){var c=Hg(a[O]);if(!c||b!=c.b)throw new N("user-mismatch");return a}throw new N("user-mismatch");}).s(function(a){throw a&&a.code&&a.code==tg+"user-not-found"?new N("user-mismatch"):a;})}
function Wg(a,b){if(b.idToken||b.accessToken)b.idToken&&M(this,"idToken",b.idToken),b.accessToken&&M(this,"accessToken",b.accessToken);else if(b.oauthToken&&b.oauthTokenSecret)M(this,"accessToken",b.oauthToken),M(this,"secret",b.oauthTokenSecret);else throw new N("internal-error","failed to construct a credential");M(this,"providerId",a)}Wg.prototype.wa=function(a){return Xg(a,Yg(this))};Wg.prototype.b=function(a,b){var c=Yg(this);c.idToken=b;return Zg(a,c)};
Wg.prototype.c=function(a,b){var c=Yg(this);return Vg($g(a,c),b)};function Yg(a){var b={};a.idToken&&(b.id_token=a.idToken);a.accessToken&&(b.access_token=a.accessToken);a.secret&&(b.oauth_token_secret=a.secret);b.providerId=a.providerId;return{postBody:Ie(b).toString(),requestUri:"http://localhost"}}
Wg.prototype.B=function(){var a={providerId:this.providerId};this.idToken&&(a.oauthIdToken=this.idToken);this.accessToken&&(a.oauthAccessToken=this.accessToken);this.secret&&(a.oauthTokenSecret=this.secret);return a};function ah(a,b){this.nc=b||[];gg(this,{providerId:a,isOAuthProvider:!0});this.qb={};this.Wa=(Lg(a)||{}).Ma||null;this.Ua=null}ah.prototype.Ba=function(a){this.qb=Ua(a);return this};function P(a){ah.call(this,a,Jg);this.a=[]}t(P,ah);
P.prototype.sa=function(a){Ha(this.a,a)||this.a.push(a);return this};P.prototype.vb=function(){return La(this.a)};P.prototype.credential=function(a,b){if(!a&&!b)throw new N("argument-error","credential failed: must provide the ID token and/or the access token.");return new Wg(this.providerId,{idToken:a||null,accessToken:b||null})};function bh(){P.call(this,"facebook.com")}t(bh,P);M(bh,"PROVIDER_ID","facebook.com");
function ch(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new bh).credential(null,b)}function dh(){P.call(this,"github.com")}t(dh,P);M(dh,"PROVIDER_ID","github.com");function eh(a){if(!a)throw new N("argument-error","credential failed: expected 1 argument (the OAuth access token).");var b=a;q(a)&&(b=a.accessToken);return(new dh).credential(null,b)}
function fh(){P.call(this,"google.com");this.sa("profile")}t(fh,P);M(fh,"PROVIDER_ID","google.com");function gh(a,b){var c=a;q(a)&&(c=a.idToken,b=a.accessToken);return(new fh).credential(c,b)}function hh(){ah.call(this,"twitter.com",Ig)}t(hh,ah);M(hh,"PROVIDER_ID","twitter.com");
function ih(a,b){var c=a;q(c)||(c={oauthToken:a,oauthTokenSecret:b});if(!c.oauthToken||!c.oauthTokenSecret)throw new N("argument-error","credential failed: expected 2 arguments (the OAuth access token and secret).");return new Wg("twitter.com",c)}function jh(a,b){this.a=a;this.f=b;M(this,"providerId","password")}jh.prototype.wa=function(a){return Q(a,kh,{email:this.a,password:this.f})};jh.prototype.b=function(a,b){return Q(a,lh,{idToken:b,email:this.a,password:this.f})};
jh.prototype.c=function(a,b){return Vg(this.wa(a),b)};jh.prototype.B=function(){return{email:this.a,password:this.f}};function mh(){gg(this,{providerId:"password",isOAuthProvider:!1})}gg(mh,{PROVIDER_ID:"password"});function nh(a){if(!(a.Pa&&a.Oa||a.Da&&a.Y))throw new N("internal-error");this.a=a;M(this,"providerId","phone")}nh.prototype.wa=function(a){return a.Qa(oh(this))};nh.prototype.b=function(a,b){var c=oh(this);c.idToken=b;return Q(a,ph,c)};
nh.prototype.c=function(a,b){var c=oh(this);c.operation="REAUTH";a=Q(a,qh,c);return Vg(a,b)};nh.prototype.B=function(){var a={providerId:"phone"};this.a.Pa&&(a.verificationId=this.a.Pa);this.a.Oa&&(a.verificationCode=this.a.Oa);this.a.Da&&(a.temporaryProof=this.a.Da);this.a.Y&&(a.phoneNumber=this.a.Y);return a};function oh(a){return a.a.Da&&a.a.Y?{temporaryProof:a.a.Da,phoneNumber:a.a.Y}:{sessionInfo:a.a.Pa,code:a.a.Oa}}
function rh(a){try{this.a=a||firebase.auth()}catch(b){throw new N("argument-error","Either an instance of firebase.auth.Auth must be passed as an argument to the firebase.auth.PhoneAuthProvider constructor, or the default firebase App instance must be initialized via firebase.initializeApp().");}gg(this,{providerId:"phone",isOAuthProvider:!1})}
rh.prototype.Qa=function(a,b){var c=this.a.c;return A(b.verify()).then(function(d){if(!m(d))throw new N("argument-error","An implementation of firebase.auth.ApplicationVerifier.prototype.verify() must return a firebase.Promise that resolves with a string.");switch(b.type){case "recaptcha":return sh(c,{phoneNumber:a,recaptchaToken:d}).then(function(a){"function"===typeof b.reset&&b.reset();return a},function(a){"function"===typeof b.reset&&b.reset();throw a;});default:throw new N("argument-error",
'Only firebase.auth.ApplicationVerifiers with type="recaptcha" are currently supported.');}})};function th(a,b){if(!a)throw new N("missing-verification-id");if(!b)throw new N("missing-verification-code");return new nh({Pa:a,Oa:b})}gg(rh,{PROVIDER_ID:"phone"});
function uh(a){if(a.temporaryProof&&a.phoneNumber)return new nh({Da:a.temporaryProof,Y:a.phoneNumber});var b=a&&a.providerId;if(!b||"password"===b)return null;var c=a&&a.oauthAccessToken,d=a&&a.oauthTokenSecret;a=a&&a.oauthIdToken;try{switch(b){case "google.com":return gh(a,c);case "facebook.com":return ch(c);case "github.com":return eh(c);case "twitter.com":return ih(c,d);default:return(new P(b)).credential(a,c)}}catch(e){return null}}
function vh(a){if(!a.isOAuthProvider)throw new N("invalid-oauth-provider");};function wh(a,b,c,d,e){this.b=a;this.c=b||null;this.f=c||null;this.g=d||null;this.a=e||null;if(this.f||this.a){if(this.f&&this.a)throw new N("invalid-auth-event");if(this.f&&!this.g)throw new N("invalid-auth-event");}else throw new N("invalid-auth-event");}wh.prototype.B=function(){return{type:this.b,eventId:this.c,urlResponse:this.f,sessionId:this.g,error:this.a&&this.a.B()}};function xh(a){a=a||{};return a.type?new wh(a.type,a.eventId,a.urlResponse,a.sessionId,a.error&&vg(a.error)):null};function yh(a){var b="unauthorized-domain",c=void 0,d=De(a);a=d.b;d=d.c;"chrome-extension"==d?c=oa("This chrome extension ID (chrome-extension://%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):"http"==d||"https"==d?c=oa("This domain (%s) is not authorized to run this operation. Add it to the OAuth redirect domains list in the Firebase console -> Auth section -> Sign in method tab.",a):b="operation-not-supported-in-this-environment";
N.call(this,b,c)}t(yh,N);function zh(a,b,c){N.call(this,a,c);a=b||{};a.rb&&M(this,"email",a.rb);a.Y&&M(this,"phoneNumber",a.Y);a.credential&&M(this,"credential",a.credential)}t(zh,N);zh.prototype.B=function(){var a={code:this.code,message:this.message};this.email&&(a.email=this.email);this.phoneNumber&&(a.phoneNumber=this.phoneNumber);var b=this.credential&&this.credential.B();b&&Wa(a,b);return a};zh.prototype.toJSON=function(){return this.B()};
function Ah(a){if(a.code){var b=a.code||"";0==b.indexOf(tg)&&(b=b.substring(tg.length));var c={credential:uh(a)};if(a.email)c.rb=a.email;else if(a.phoneNumber)c.Y=a.phoneNumber;else return new N(b,a.message||void 0);return new zh(b,c,a.message)}return null};function Bh(a){this.f=a}t(Bh,Ne);Bh.prototype.a=function(){return new this.f};Bh.prototype.b=function(){return{}};
function Ch(a,b,c){var d="Node"==K();d=k.XMLHttpRequest||d&&firebase.INTERNAL.node&&firebase.INTERNAL.node.XMLHttpRequest;if(!d)throw new N("internal-error","The XMLHttpRequest compatibility library was not found.");this.b=a;a=b||{};this.i=a.secureTokenEndpoint||"https://securetoken.googleapis.com/v1/token";this.l=a.secureTokenTimeout||Dh;this.c=Ua(a.secureTokenHeaders||Eh);this.g=a.firebaseEndpoint||"https://www.googleapis.com/identitytoolkit/v3/relyingparty/";this.h=a.firebaseTimeout||Fh;this.a=
Ua(a.firebaseHeaders||Gh);c&&(this.a["X-Client-Version"]=c,this.c["X-Client-Version"]=c);this.f=new rf;this.o=new Bh(d)}var Hh,O="idToken",Dh=new $f(3E4,6E4),Eh={"Content-Type":"application/x-www-form-urlencoded"},Fh=new $f(3E4,6E4),Gh={"Content-Type":"application/json"};function Ih(a,b){b?a.a["X-Firebase-Locale"]=b:delete a.a["X-Firebase-Locale"]}function Jh(a,b){b?(a.a["X-Client-Version"]=b,a.c["X-Client-Version"]=b):(delete a.a["X-Client-Version"],delete a.c["X-Client-Version"])}
function Kh(a,b,c,d,e,f,g){Zf()?(yf()?a=r(a.m,a):(Hh||(Hh=new z(function(a,b){Lh(a,b)})),a=r(a.u,a)),a(b,c,d,e,f,g)):c&&c(null)}
Ch.prototype.m=function(a,b,c,d,e,f){var g="Node"==K(),l=Mf()?g?new Se(this.o):new Se:new Se(this.f);if(f){l.f=Math.max(0,f);var n=setTimeout(function(){G(l,"timeout")},f)}fd(l,"complete",function(){n&&clearTimeout(n);var a=null;try{a=JSON.parse(hf(this))||null}catch(vb){a=null}b&&b(a)});ld(l,"ready",function(){n&&clearTimeout(n);Lc(this)});ld(l,"timeout",function(){n&&clearTimeout(n);Lc(this);b&&b(null)});Ye(l,a,c,d,e)};
var Mh=dc("https://apis.google.com/js/client.js?onload=%{onload}"),Nh="__fcb"+Math.floor(1E6*Math.random()).toString();function Lh(a,b){if(((window.gapi||{}).client||{}).request)a();else{k[Nh]=function(){((window.gapi||{}).client||{}).request?a():b(Error("CORS_UNSUPPORTED"))};var c=hc(Mh,{onload:Nh});Td(kf(c),function(){b(Error("CORS_UNSUPPORTED"))})}}
Ch.prototype.u=function(a,b,c,d,e){var f=this;Hh.then(function(){window.gapi.client.setApiKey(f.b);var g=window.gapi.auth.getToken();window.gapi.auth.setToken(null);window.gapi.client.request({path:a,method:c,body:d,headers:e,authType:"none",callback:function(a){window.gapi.auth.setToken(g);b&&b(a)}})}).s(function(a){b&&b({error:{message:a&&a.message||"CORS_UNSUPPORTED"}})})};
function Oh(a,b){return new z(function(c,d){"refresh_token"==b.grant_type&&b.refresh_token||"authorization_code"==b.grant_type&&b.code?Kh(a,a.i+"?key="+encodeURIComponent(a.b),function(a){a?a.error?d(Ph(a)):a.access_token&&a.refresh_token?c(a):d(new N("internal-error")):d(new N("network-request-failed"))},"POST",Ie(b).toString(),a.c,a.l.get()):d(new N("internal-error"))})}
function Qh(a,b,c,d,e,f){var g=De(a.g+b);I(g,"key",a.b);f&&I(g,"cb",na().toString());var l="GET"==c;if(l)for(var n in d)d.hasOwnProperty(n)&&I(g,n,d[n]);return new z(function(b,f){Kh(a,g.toString(),function(a){a?a.error?f(Ph(a,e||{})):b(a):f(new N("network-request-failed"))},c,l?void 0:Cc(Vf(d)),a.a,a.h.get())})}function Rh(a){if(!jf.test(a.email))throw new N("invalid-email");}function Sh(a){"email"in a&&Rh(a)}
function Th(a,b){return Q(a,Uh,{identifier:b,continueUri:Sf()?vf():"http://localhost"}).then(function(a){return a.allProviders||[]})}function Vh(a){return Q(a,Wh,{}).then(function(a){return a.authorizedDomains||[]})}function Xh(a){if(!a[O])throw new N("internal-error");}
function Yh(a){if(a.phoneNumber||a.temporaryProof){if(!a.phoneNumber||!a.temporaryProof)throw new N("internal-error");}else{if(!a.sessionInfo)throw new N("missing-verification-id");if(!a.code)throw new N("missing-verification-code");}}Ch.prototype.gb=function(){return Q(this,Zh,{})};Ch.prototype.kb=function(a,b){return Q(this,$h,{idToken:a,email:b})};Ch.prototype.lb=function(a,b){return Q(this,lh,{idToken:a,password:b})};var ai={displayName:"DISPLAY_NAME",photoUrl:"PHOTO_URL"};h=Ch.prototype;
h.mb=function(a,b){var c={idToken:a},d=[];Pa(ai,function(a,f){var e=b[f];null===e?d.push(a):f in b&&(c[f]=e)});d.length&&(c.deleteAttribute=d);return Q(this,$h,c)};h.cb=function(a,b){a={requestType:"PASSWORD_RESET",email:a};Wa(a,b);return Q(this,bi,a)};h.bb=function(a,b){a={requestType:"VERIFY_EMAIL",idToken:a};Wa(a,b);return Q(this,ci,a)};function sh(a,b){return Q(a,di,b)}h.Qa=function(a){return Q(this,ei,a)};function fi(a,b,c){return Q(a,gi,{idToken:b,deleteProvider:c})}
function hi(a){if(!a.requestUri||!a.sessionId&&!a.postBody)throw new N("internal-error");}function ii(a){var b=null;a.needConfirmation?(a.code="account-exists-with-different-credential",b=Ah(a)):"FEDERATED_USER_ID_ALREADY_LINKED"==a.errorMessage?(a.code="credential-already-in-use",b=Ah(a)):"EMAIL_EXISTS"==a.errorMessage?(a.code="email-already-in-use",b=Ah(a)):a.errorMessage&&(b=ji(a.errorMessage));if(b)throw b;if(!a[O])throw new N("internal-error");}
function Xg(a,b){b.returnIdpCredential=!0;return Q(a,ki,b)}function Zg(a,b){b.returnIdpCredential=!0;return Q(a,li,b)}function $g(a,b){b.returnIdpCredential=!0;b.autoCreate=!1;return Q(a,mi,b)}function ni(a){if(!a.oobCode)throw new N("invalid-action-code");}h.Ta=function(a,b){return Q(this,oi,{oobCode:a,newPassword:b})};h.Ia=function(a){return Q(this,pi,{oobCode:a})};h.Sa=function(a){return Q(this,qi,{oobCode:a})};
var qi={endpoint:"setAccountInfo",D:ni,ga:"email"},pi={endpoint:"resetPassword",D:ni,O:function(a){if(!a.email||!a.requestType)throw new N("internal-error");}},ri={endpoint:"signupNewUser",D:function(a){Rh(a);if(!a.password)throw new N("weak-password");},O:Xh,T:!0},Uh={endpoint:"createAuthUri"},si={endpoint:"deleteAccount",ea:["idToken"]},gi={endpoint:"setAccountInfo",ea:["idToken","deleteProvider"],D:function(a){if(!fa(a.deleteProvider))throw new N("internal-error");}},ti={endpoint:"getAccountInfo"},
ci={endpoint:"getOobConfirmationCode",ea:["idToken","requestType"],D:function(a){if("VERIFY_EMAIL"!=a.requestType)throw new N("internal-error");},ga:"email"},bi={endpoint:"getOobConfirmationCode",ea:["requestType"],D:function(a){if("PASSWORD_RESET"!=a.requestType)throw new N("internal-error");Rh(a)},ga:"email"},Wh={nb:!0,endpoint:"getProjectConfig",yb:"GET"},ui={nb:!0,endpoint:"getRecaptchaParam",yb:"GET",O:function(a){if(!a.recaptchaSiteKey)throw new N("internal-error");}},oi={endpoint:"resetPassword",
D:ni,ga:"email"},di={endpoint:"sendVerificationCode",ea:["phoneNumber","recaptchaToken"],ga:"sessionInfo"},$h={endpoint:"setAccountInfo",ea:["idToken"],D:Sh,T:!0},lh={endpoint:"setAccountInfo",ea:["idToken"],D:function(a){Sh(a);if(!a.password)throw new N("weak-password");},O:Xh,T:!0},Zh={endpoint:"signupNewUser",O:Xh,T:!0},ki={endpoint:"verifyAssertion",D:hi,O:ii,T:!0},mi={endpoint:"verifyAssertion",D:hi,O:function(a){if(a.errorMessage&&"USER_NOT_FOUND"==a.errorMessage)throw new N("user-not-found");
if(a.errorMessage)throw ji(a.errorMessage);if(!a[O])throw new N("internal-error");},T:!0},li={endpoint:"verifyAssertion",D:function(a){hi(a);if(!a.idToken)throw new N("internal-error");},O:ii,T:!0},vi={endpoint:"verifyCustomToken",D:function(a){if(!a.token)throw new N("invalid-custom-token");},O:Xh,T:!0},kh={endpoint:"verifyPassword",D:function(a){Rh(a);if(!a.password)throw new N("wrong-password");},O:Xh,T:!0},ei={endpoint:"verifyPhoneNumber",D:Yh,O:Xh},ph={endpoint:"verifyPhoneNumber",D:function(a){if(!a.idToken)throw new N("internal-error");
Yh(a)},O:function(a){if(a.temporaryProof)throw a.code="credential-already-in-use",Ah(a);Xh(a)}},qh={Lb:{USER_NOT_FOUND:"user-not-found"},endpoint:"verifyPhoneNumber",D:Yh,O:Xh};
function Q(a,b,c){if(!jg(c,b.ea))return B(new N("internal-error"));var d=b.yb||"POST",e;return A(c).then(b.D).then(function(){b.T&&(c.returnSecureToken=!0);return Qh(a,b.endpoint,d,c,b.Lb,b.nb||!1)}).then(function(a){return e=a}).then(b.O).then(function(){if(!b.ga)return e;if(!(b.ga in e))throw new N("internal-error");return e[b.ga]})}function ji(a){return Ph({error:{errors:[{message:a}],code:400,message:a}})}
function Ph(a,b){var c=(a.error&&a.error.errors&&a.error.errors[0]||{}).reason||"";var d={keyInvalid:"invalid-api-key",ipRefererBlocked:"app-not-authorized"};if(c=d[c]?new N(d[c]):null)return c;c=a.error&&a.error.message||"";d={INVALID_CUSTOM_TOKEN:"invalid-custom-token",CREDENTIAL_MISMATCH:"custom-token-mismatch",MISSING_CUSTOM_TOKEN:"internal-error",INVALID_IDENTIFIER:"invalid-email",MISSING_CONTINUE_URI:"internal-error",INVALID_EMAIL:"invalid-email",INVALID_PASSWORD:"wrong-password",USER_DISABLED:"user-disabled",
MISSING_PASSWORD:"internal-error",EMAIL_EXISTS:"email-already-in-use",PASSWORD_LOGIN_DISABLED:"operation-not-allowed",INVALID_IDP_RESPONSE:"invalid-credential",FEDERATED_USER_ID_ALREADY_LINKED:"credential-already-in-use",INVALID_MESSAGE_PAYLOAD:"invalid-message-payload",INVALID_RECIPIENT_EMAIL:"invalid-recipient-email",INVALID_SENDER:"invalid-sender",EMAIL_NOT_FOUND:"user-not-found",EXPIRED_OOB_CODE:"expired-action-code",INVALID_OOB_CODE:"invalid-action-code",MISSING_OOB_CODE:"internal-error",CREDENTIAL_TOO_OLD_LOGIN_AGAIN:"requires-recent-login",
INVALID_ID_TOKEN:"invalid-user-token",TOKEN_EXPIRED:"user-token-expired",USER_NOT_FOUND:"user-token-expired",CORS_UNSUPPORTED:"cors-unsupported",DYNAMIC_LINK_NOT_ACTIVATED:"dynamic-link-not-activated",INVALID_APP_ID:"invalid-app-id",TOO_MANY_ATTEMPTS_TRY_LATER:"too-many-requests",WEAK_PASSWORD:"weak-password",OPERATION_NOT_ALLOWED:"operation-not-allowed",USER_CANCELLED:"user-cancelled",CAPTCHA_CHECK_FAILED:"captcha-check-failed",INVALID_APP_CREDENTIAL:"invalid-app-credential",INVALID_CODE:"invalid-verification-code",
INVALID_PHONE_NUMBER:"invalid-phone-number",INVALID_SESSION_INFO:"invalid-verification-id",INVALID_TEMPORARY_PROOF:"invalid-credential",MISSING_APP_CREDENTIAL:"missing-app-credential",MISSING_CODE:"missing-verification-code",MISSING_PHONE_NUMBER:"missing-phone-number",MISSING_SESSION_INFO:"missing-verification-id",QUOTA_EXCEEDED:"quota-exceeded",SESSION_EXPIRED:"code-expired",INVALID_CONTINUE_URI:"invalid-continue-uri",MISSING_ANDROID_PACKAGE_NAME:"missing-android-pkg-name",MISSING_IOS_BUNDLE_ID:"missing-ios-bundle-id",
UNAUTHORIZED_DOMAIN:"unauthorized-continue-uri",INVALID_OAUTH_CLIENT_ID:"invalid-oauth-client-id",INVALID_CERT_HASH:"invalid-cert-hash"};Wa(d,b||{});b=(b=c.match(/^[^\s]+\s*:\s*(.*)$/))&&1<b.length?b[1]:void 0;for(var e in d)if(0===c.indexOf(e))return new N(d[e],b);!b&&a&&(b=Uf(a));return new N("internal-error",b)};var wi={Ic:{Va:"https://www.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://securetoken.googleapis.com/v1/token",id:"p"},Kc:{Va:"https://staging-www.sandbox.googleapis.com/identitytoolkit/v3/relyingparty/",ab:"https://staging-securetoken.sandbox.googleapis.com/v1/token",id:"s"},Lc:{Va:"https://www-googleapis-test.sandbox.google.com/identitytoolkit/v3/relyingparty/",ab:"https://test-securetoken.sandbox.googleapis.com/v1/token",id:"t"}};
function xi(a){for(var b in wi)if(wi[b].id===a)return a=wi[b],{firebaseEndpoint:a.Va,secureTokenEndpoint:a.ab};return null}var yi;yi=xi("__EID__")?"__EID__":void 0;function zi(a){this.b=a;this.a=null;this.Ya=Ai(this)}
function Ai(a){return Bi().then(function(){return new z(function(b,c){L("gapi.iframes.getContext")().open({where:document.body,url:a.b,messageHandlersFilter:L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"),attributes:{style:{position:"absolute",top:"-100px",width:"1px",height:"1px"}},dontclear:!0},function(d){function e(){clearTimeout(f);b()}a.a=d;a.a.restyle({setHideOnLeave:!1});var f=setTimeout(function(){c(Error("Network Error"))},Ci.get());d.ping(e).then(e,function(){c(Error("Network Error"))})})})})}
function Di(a,b){return a.Ya.then(function(){return new z(function(c){a.a.send(b.type,b,c,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})})}function Ei(a,b){a.Ya.then(function(){a.a.register("authEvent",b,L("gapi.iframes.CROSS_ORIGIN_IFRAMES_FILTER"))})}var Fi=dc("https://apis.google.com/js/api.js?onload=%{onload}"),Gi=new $f(3E4,6E4),Ci=new $f(5E3,15E3),Hi=null;
function Bi(){return Hi?Hi:Hi=(new z(function(a,b){if(Zf()){var c=function(){Yf();L("gapi.load")("gapi.iframes",{callback:a,ontimeout:function(){Yf();b(Error("Network Error"))},timeout:Gi.get()})};if(L("gapi.iframes.Iframe"))a();else if(L("gapi.load"))c();else{var d="__iframefcb"+Math.floor(1E6*Math.random()).toString();k[d]=function(){L("gapi.load")?c():b(Error("Network Error"))};d=hc(Fi,{onload:d});A(kf(d)).s(function(){b(Error("Network Error"))})}}else b(Error("Network Error"))})).s(function(a){Hi=
null;throw a;})};function Ii(a,b,c){this.i=a;this.g=b;this.h=c;this.f=null;this.a=Ee(this.i,"/__/auth/iframe");I(this.a,"apiKey",this.g);I(this.a,"appName",this.h);this.b=null;this.c=[]}Ii.prototype.toString=function(){this.f?I(this.a,"v",this.f):Le(this.a.a,"v");this.b?I(this.a,"eid",this.b):Le(this.a.a,"eid");this.c.length?I(this.a,"fw",this.c.join(",")):Le(this.a.a,"fw");return this.a.toString()};function Ji(a,b,c,d,e){this.m=a;this.u=b;this.c=c;this.l=d;this.i=this.g=this.h=null;this.a=e;this.f=null}
Ji.prototype.toString=function(){var a=Ee(this.m,"/__/auth/handler");I(a,"apiKey",this.u);I(a,"appName",this.c);I(a,"authType",this.l);if(this.a.isOAuthProvider){var b=this.a;try{var c=firebase.app(this.c).auth().$()}catch(l){c=null}b.Ua=c;I(a,"providerId",this.a.providerId);b=this.a;c=Vf(b.qb);for(var d in c)c[d]=c[d].toString();d=b.nc;c=Ua(c);for(var e=0;e<d.length;e++){var f=d[e];f in c&&delete c[f]}b.Wa&&b.Ua&&!c[b.Wa]&&(c[b.Wa]=b.Ua);Sa(c)||I(a,"customParameters",Uf(c))}"function"===typeof this.a.vb&&
(b=this.a.vb(),b.length&&I(a,"scopes",b.join(",")));this.h?I(a,"redirectUrl",this.h):Le(a.a,"redirectUrl");this.g?I(a,"eventId",this.g):Le(a.a,"eventId");this.i?I(a,"v",this.i):Le(a.a,"v");if(this.b)for(var g in this.b)this.b.hasOwnProperty(g)&&!Ce(a,g)&&I(a,g,this.b[g]);this.f?I(a,"eid",this.f):Le(a.a,"eid");g=Ki(this.c);g.length&&I(a,"fw",g.join(","));return a.toString()};function Ki(a){try{return firebase.app(a).auth().Ka()}catch(b){return[]}}
function Li(a,b,c,d,e){this.u=a;this.f=b;this.b=c;this.c=d||null;this.h=e||null;this.m=this.o=this.v=null;this.g=[];this.l=this.a=null}
function Mi(a){var b=vf();return Vh(a).then(function(a){a:{var c=De(b),e=c.c;c=c.b;for(var f=0;f<a.length;f++){var g=a[f];var l=c;var n=e;0==g.indexOf("chrome-extension://")?l=De(g).b==l&&"chrome-extension"==n:"http"!=n&&"https"!=n?l=!1:Gf.test(g)?l=l==g:(g=g.split(".").join("\\."),l=(new RegExp("^(.+\\."+g+"|"+g+")$","i")).test(l));if(l){a=!0;break a}}a=!1}if(!a)throw new yh(vf());})}
function Ni(a){if(a.l)return a.l;a.l=Hf().then(function(){if(!a.o){var b=a.c,c=a.h,d=Ki(a.b),e=new Ii(a.u,a.f,a.b);e.f=b;e.b=c;e.c=La(d||[]);a.o=e.toString()}a.i=new zi(a.o);Oi(a)});return a.l}h=Li.prototype;h.Ca=function(a,b,c){var d=new N("popup-closed-by-user"),e=new N("web-storage-unsupported"),f=this,g=!1;return this.ba().then(function(){Pi(f).then(function(c){c||(a&&Cf(a),b(e),g=!0)})}).s(function(){}).then(function(){if(!g)return Ff(a)}).then(function(){if(!g)return sd(c).then(function(){b(d)})})};
h.Cb=function(){var a=J();return!Tf(a)&&!Xf(a)};h.xb=function(){return!1};
h.ub=function(a,b,c,d,e,f,g){if(!a)return B(new N("popup-blocked"));if(g&&!Tf())return this.ba().s(function(b){Cf(a);e(b)}),d(),A();this.a||(this.a=Mi(Qi(this)));var l=this;return this.a.then(function(){var b=l.ba().s(function(b){Cf(a);e(b);throw b;});d();return b}).then(function(){vh(c);if(!g){var d=Ri(l.u,l.f,l.b,b,c,null,f,l.c,void 0,l.h);wf(d,a)}}).s(function(a){"auth/network-request-failed"==a.code&&(l.a=null);throw a;})};
function Qi(a){a.m||(a.v=a.c?Of(a.c,Ki(a.b)):null,a.m=new Ch(a.f,xi(a.h),a.v));return a.m}h.Aa=function(a,b,c){this.a||(this.a=Mi(Qi(this)));var d=this;return this.a.then(function(){vh(b);var e=Ri(d.u,d.f,d.b,a,b,vf(),c,d.c,void 0,d.h);wf(e)}).s(function(a){"auth/network-request-failed"==a.code&&(d.a=null);throw a;})};h.ba=function(){var a=this;return Ni(this).then(function(){return a.i.Ya}).s(function(){a.a=null;throw new N("network-request-failed");})};h.Db=function(){return!0};
function Ri(a,b,c,d,e,f,g,l,n,D){a=new Ji(a,b,c,d,e);a.h=f;a.g=g;a.i=l;a.b=Ua(n||null);a.f=D;return a.toString()}function Oi(a){if(!a.i)throw Error("IfcHandler must be initialized!");Ei(a.i,function(b){var c={};if(b&&b.authEvent){var d=!1;b=xh(b.authEvent);for(c=0;c<a.g.length;c++)d=a.g[c](b)||d;c={};c.status=d?"ACK":"ERROR";return A(c)}c.status="ERROR";return A(c)})}
function Pi(a){var b={type:"webStorageSupport"};return Ni(a).then(function(){return Di(a.i,b)}).then(function(a){if(a&&a.length&&"undefined"!==typeof a[0].webStorageSupport)return a[0].webStorageSupport;throw Error();})}h.ua=function(a){this.g.push(a)};h.Ja=function(a){Ja(this.g,function(b){return b==a})};function Si(a){this.a=a||firebase.INTERNAL.reactNative&&firebase.INTERNAL.reactNative.AsyncStorage;if(!this.a)throw new N("internal-error","The React Native compatibility library was not found.");}h=Si.prototype;h.get=function(a){return A(this.a.getItem(a)).then(function(a){return a&&Wf(a)})};h.set=function(a,b){return A(this.a.setItem(a,Uf(b)))};h.X=function(a){return A(this.a.removeItem(a))};h.ia=function(){};h.da=function(){};function Ti(){this.a={}}h=Ti.prototype;h.get=function(a){return A(this.a[a])};h.set=function(a,b){this.a[a]=b;return A()};h.X=function(a){delete this.a[a];return A()};h.ia=function(){};h.da=function(){};function Ui(a,b,c,d,e,f){try{var g=!!k.indexedDB}catch(l){g=!1}if(!g)throw new N("web-storage-unsupported");this.u=a;this.h=b;this.g=c;this.l=d;this.m=e;this.f={};this.c=[];this.a=0;this.o=f||k.indexedDB}var Vi;function Wi(a){return new z(function(b,c){var d=a.o.open(a.u,a.m);d.onerror=function(a){c(Error(a.target.errorCode))};d.onupgradeneeded=function(b){b=b.target.result;try{b.createObjectStore(a.h,{keyPath:a.g})}catch(f){c(f)}};d.onsuccess=function(a){b(a.target.result)}})}
function Xi(a){a.i||(a.i=Wi(a));return a.i}function Yi(a,b){return b.objectStore(a.h)}function Zi(a,b,c){return b.transaction([a.h],c?"readwrite":"readonly")}function $i(a){return new z(function(b,c){a.onsuccess=function(a){a&&a.target?b(a.target.result):b()};a.onerror=function(a){c(Error(a.target.errorCode))}})}h=Ui.prototype;
h.set=function(a,b){var c=!1,d,e=this;return Qb(Xi(this).then(function(b){d=b;b=Yi(e,Zi(e,d,!0));return $i(b.get(a))}).then(function(f){var g=Yi(e,Zi(e,d,!0));if(f)return f.value=b,$i(g.put(f));e.a++;c=!0;f={};f[e.g]=a;f[e.l]=b;return $i(g.add(f))}).then(function(){e.f[a]=b}),function(){c&&e.a--})};h.get=function(a){var b=this;return Xi(this).then(function(c){return $i(Yi(b,Zi(b,c,!1)).get(a))}).then(function(a){return a&&a.value})};
h.X=function(a){var b=!1,c=this;return Qb(Xi(this).then(function(d){b=!0;c.a++;return $i(Yi(c,Zi(c,d,!0))["delete"](a))}).then(function(){delete c.f[a]}),function(){b&&c.a--})};
h.vc=function(){var a=this;return Xi(this).then(function(b){var c=Yi(a,Zi(a,b,!1));return c.getAll?$i(c.getAll()):new z(function(a,b){var d=[],e=c.openCursor();e.onsuccess=function(b){(b=b.target.result)?(d.push(b.value),b["continue"]()):a(d)};e.onerror=function(a){b(Error(a.target.errorCode))}})}).then(function(b){var c={},d=[];if(0==a.a){for(d=0;d<b.length;d++)c[b[d][a.g]]=b[d][a.l];d=xf(a.f,c);a.f=c}return d})};h.ia=function(a){0==this.c.length&&aj(this);this.c.push(a)};
h.da=function(a){Ja(this.c,function(b){return b==a});0==this.c.length&&this.b&&this.b.cancel("STOP_EVENT")};function aj(a){function b(){a.b=sd(800).then(r(a.vc,a)).then(function(b){0<b.length&&w(a.c,function(a){a(b)})}).then(b).s(function(a){"STOP_EVENT"!=a.message&&b()});return a.b}a.b&&a.b.cancel("STOP_EVENT");b()};function bj(){if(!cj()){if("Node"==K())throw new N("internal-error","The LocalStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=dj()||firebase.INTERNAL.node.localStorage}function dj(){try{var a=k.localStorage,b=Qf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function cj(){var a="Node"==K();a=dj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.localStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=bj.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Wf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Uf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};
h.ia=function(a){k.window&&cd(k.window,"storage",a)};h.da=function(a){k.window&&E(k.window,"storage",a)};function ej(){}h=ej.prototype;h.get=function(){return A(null)};h.set=function(){return A()};h.X=function(){return A()};h.ia=function(){};h.da=function(){};function fj(){if(!gj()){if("Node"==K())throw new N("internal-error","The SessionStorage compatibility library was not found.");throw new N("web-storage-unsupported");}this.a=hj()||firebase.INTERNAL.node.sessionStorage}function hj(){try{var a=k.sessionStorage,b=Qf();a&&(a.setItem(b,"1"),a.removeItem(b));return a}catch(c){return null}}
function gj(){var a="Node"==K();a=hj()||a&&firebase.INTERNAL.node&&firebase.INTERNAL.node.sessionStorage;if(!a)return!1;try{return a.setItem("__sak","1"),a.removeItem("__sak"),!0}catch(b){return!1}}h=fj.prototype;h.get=function(a){var b=this;return A().then(function(){var c=b.a.getItem(a);return Wf(c)})};h.set=function(a,b){var c=this;return A().then(function(){var d=Uf(b);null===d?c.X(a):c.a.setItem(a,d)})};h.X=function(a){var b=this;return A().then(function(){b.a.removeItem(a)})};h.ia=function(){};
h.da=function(){};function ij(){var a={};a.Browser=jj;a.Node=kj;a.ReactNative=lj;this.a=a[K()]}var mj,jj={C:bj,jb:fj},kj={C:bj,jb:fj},lj={C:Si,jb:ej};var nj={Hc:"local",NONE:"none",Jc:"session"};function oj(a){var b=new N("invalid-persistence-type"),c=new N("unsupported-persistence-type");a:{for(d in nj)if(nj[d]==a){var d=!0;break a}d=!1}if(!d||"string"!==typeof a)throw b;switch(K()){case "ReactNative":if("session"===a)throw c;break;case "Node":if("none"!==a)throw c;break;default:if(!Pf()&&"none"!==a)throw c;}}
function pj(a,b,c,d,e){this.i=a;this.g=b;this.A=c;this.u=d;this.v=e;this.a={};mj||(mj=new ij);a=mj;try{if(uf()){Vi||(Vi=new Ui("firebaseLocalStorageDb","firebaseLocalStorage","fbase_key","value",1));var f=Vi}else f=new a.a.C;this.l=f}catch(g){this.l=new Ti,this.u=!0}try{this.o=new a.a.jb}catch(g){this.o=new Ti}this.w=new Ti;this.h=r(this.m,this);this.b={}}var qj;function rj(){qj||(qj=new pj("firebase",":",!Xf(J())&&Lf()?!0:!1,Tf(),Pf()));return qj}
function sj(a,b){switch(b){case "session":return a.o;case "none":return a.w;default:return a.l}}function tj(a,b,c){return a.i+a.g+b.name+(c?a.g+c:"")}pj.prototype.get=function(a,b){return sj(this,a.C).get(tj(this,a,b))};function uj(a,b,c){c=tj(a,b,c);"local"==b.C&&(a.b[c]=null);return sj(a,b.C).X(c)}pj.prototype.set=function(a,b,c){var d=tj(this,a,c),e=this,f=sj(this,a.C);return f.set(d,b).then(function(){return f.get(d)}).then(function(b){"local"==a.C&&(e.b[d]=b)})};
function vj(a,b,c,d){b=tj(a,b,c);a.v&&(a.b[b]=k.localStorage.getItem(b));Sa(a.a)&&(sj(a,"local").ia(a.h),a.u||uf()||!a.v||wj(a));a.a[b]||(a.a[b]=[]);a.a[b].push(d)}function xj(a,b,c){b=tj(a,yj("local"),b);a.a[b]&&(Ja(a.a[b],function(a){return a==c}),0==a.a[b].length&&delete a.a[b]);Sa(a.a)&&zj(a)}
function wj(a){Aj(a);a.f=setInterval(function(){for(var b in a.a){var c=k.localStorage.getItem(b),d=a.b[b];c!=d&&(a.b[b]=c,c=new Qc({type:"storage",key:b,target:window,oldValue:d,newValue:c,a:!0}),a.m(c))}},1E3)}function Aj(a){a.f&&(clearInterval(a.f),a.f=null)}function zj(a){sj(a,"local").da(a.h);Aj(a)}
pj.prototype.m=function(a){if(a&&a.g){var b=a.a.key;if(null==b)for(var c in this.a){var d=this.b[c];"undefined"===typeof d&&(d=null);var e=k.localStorage.getItem(c);e!==d&&(this.b[c]=e,this.c(c))}else if(0==b.indexOf(this.i+this.g)&&this.a[b]){"undefined"!==typeof a.a.a?sj(this,"local").da(this.h):Aj(this);if(this.A)if(c=k.localStorage.getItem(b),d=a.a.newValue,d!==c)null!==d?k.localStorage.setItem(b,d):k.localStorage.removeItem(b);else if(this.b[b]===d&&"undefined"===typeof a.a.a)return;var f=this;
c=function(){if("undefined"!==typeof a.a.a||f.b[b]!==k.localStorage.getItem(b))f.b[b]=k.localStorage.getItem(b),f.c(b)};y&&kb&&10==kb&&k.localStorage.getItem(b)!==a.a.newValue&&a.a.newValue!==a.a.oldValue?setTimeout(c,10):c()}}else w(a,r(this.c,this))};pj.prototype.c=function(a){this.a[a]&&w(this.a[a],function(a){a()})};function Cj(a){this.a=a;this.b=rj()}var Dj={name:"authEvent",C:"local"};function Ej(a){return a.b.get(Dj,a.a).then(function(a){return xh(a)})};function Fj(){this.a=rj()};function Gj(a,b,c,d,e,f,g){this.u=a;this.i=b;this.l=c;this.m=d||null;this.o=g||null;this.h=b+":"+c;this.A=new Fj;this.g=new Cj(this.h);this.f=null;this.b=[];this.v=e||500;this.w=f||2E3;this.a=this.c=null}function Hj(a){return new N("invalid-cordova-configuration",a)}h=Gj.prototype;
h.ba=function(){return this.xa?this.xa:this.xa=If().then(function(){if("function"!==typeof L("universalLinks.subscribe",k))throw Hj("cordova-universal-links-plugin is not installed");if("undefined"===typeof L("BuildInfo.packageName",k))throw Hj("cordova-plugin-buildinfo is not installed");if("function"!==typeof L("cordova.plugins.browsertab.openUrl",k))throw Hj("cordova-plugin-browsertab is not installed");if("function"!==typeof L("cordova.InAppBrowser.open",k))throw Hj("cordova-plugin-inappbrowser is not installed");
},function(){throw new N("cordova-not-ready");})};function Ij(){for(var a=20,b=[];0<a;)b.push("1234567890abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ".charAt(Math.floor(62*Math.random()))),a--;return b.join("")}function Jj(a){var b=new ie;he(b,a);a=[];var c=8*b.g;56>b.c?he(b,fe,56-b.c):he(b,fe,b.b-(b.c-56));for(var d=63;56<=d;d--)b.f[d]=c&255,c/=256;ge(b);for(d=c=0;d<b.i;d++)for(var e=24;0<=e;e-=8)a[c++]=b.a[d]>>e&255;return Hd(a)}
h.Ca=function(a,b){b(new N("operation-not-supported-in-this-environment"));return A()};h.ub=function(){return B(new N("operation-not-supported-in-this-environment"))};h.Db=function(){return!1};h.Cb=function(){return!0};h.xb=function(){return!0};
h.Aa=function(a,b,c){if(this.c)return B(new N("redirect-operation-pending"));var d=this,e=k.document,f=null,g=null,l=null,n=null;return this.c=Qb(A().then(function(){vh(b);return Kj(d)}).then(function(){return Lj(d,a,b,c)}).then(function(){return(new z(function(a,b){g=function(){var b=L("cordova.plugins.browsertab.close",k);a();"function"===typeof b&&b();d.a&&"function"===typeof d.a.close&&(d.a.close(),d.a=null);return!1};d.ua(g);l=function(){f||(f=sd(d.w).then(function(){b(new N("redirect-cancelled-by-user"))}))};
n=function(){ag()&&l()};e.addEventListener("resume",l,!1);J().toLowerCase().match(/android/)||e.addEventListener("visibilitychange",n,!1)})).s(function(a){return Mj(d).then(function(){throw a;})})}),function(){l&&e.removeEventListener("resume",l,!1);n&&e.removeEventListener("visibilitychange",n,!1);f&&f.cancel();g&&d.Ja(g);d.c=null})};
function Lj(a,b,c,d){var e=Ij(),f=new wh(b,d,null,e,new N("no-auth-event")),g=L("BuildInfo.packageName",k);if("string"!==typeof g)throw new N("invalid-cordova-configuration");var l=L("BuildInfo.displayName",k),n={};if(J().toLowerCase().match(/iphone|ipad|ipod/))n.ibi=g;else if(J().toLowerCase().match(/android/))n.apn=g;else return B(new N("operation-not-supported-in-this-environment"));l&&(n.appDisplayName=l);e=Jj(e);n.sessionId=e;var D=Ri(a.u,a.i,a.l,b,c,null,d,a.m,n,a.o);return a.ba().then(function(){var b=
a.h;return a.A.a.set(Dj,f.B(),b)}).then(function(){var b=L("cordova.plugins.browsertab.isAvailable",k);if("function"!==typeof b)throw new N("invalid-cordova-configuration");var c=null;b(function(b){if(b){c=L("cordova.plugins.browsertab.openUrl",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");c(D)}else{c=L("cordova.InAppBrowser.open",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");b=J();b=!(!b.match(/(iPad|iPhone|iPod).*OS 7_\d/i)&&!b.match(/(iPad|iPhone|iPod).*OS 8_\d/i));
a.a=c(D,b?"_blank":"_system","location=yes")}})})}function Nj(a,b){for(var c=0;c<a.b.length;c++)try{a.b[c](b)}catch(d){}}function Kj(a){a.f||(a.f=a.ba().then(function(){return new z(function(b){function c(d){b(d);a.Ja(c);return!1}a.ua(c);Oj(a)})}));return a.f}function Mj(a){var b=null;return Ej(a.g).then(function(c){b=c;c=a.g;return uj(c.b,Dj,c.a)}).then(function(){return b})}
function Oj(a){function b(b){e=!0;f&&f.cancel();Mj(a).then(function(c){var e=d;if(c&&b&&b.url){e=null;var f=b.url;var g=De(f),l=Ce(g,"link"),n=Ce(De(l),"link");g=Ce(g,"deep_link_id");f=Ce(De(g),"link")||g||n||l||f;-1!=f.indexOf("/__/auth/callback")&&(e=De(f),e=Wf(Ce(e,"firebaseError")||null),e=(e="object"===typeof e?vg(e):null)?new wh(c.b,c.c,null,null,e):new wh(c.b,c.c,f,c.g));e=e||d}Nj(a,e)})}var c=L("universalLinks.subscribe",k);if("function"!==typeof c)throw new N("invalid-cordova-configuration");
var d=new wh("unknown",null,null,null,new N("no-auth-event")),e=!1,f=sd(a.v).then(function(){return Mj(a).then(function(){e||Nj(a,d)})}),g=k.handleOpenURL;k.handleOpenURL=function(a){0==a.toLowerCase().indexOf(L("BuildInfo.packageName",k).toLowerCase()+"://")&&b({url:a});if("function"===typeof g)try{g(a)}catch(n){console.error(n)}};c(null,b)}
h.ua=function(a){this.b.push(a);Kj(this).s(function(b){"auth/invalid-cordova-configuration"===b.code&&(b=new wh("unknown",null,null,null,new N("no-auth-event")),a(b))})};h.Ja=function(a){Ja(this.b,function(b){return b==a})};function Pj(a){this.a=a;this.b=rj()}var Qj={name:"pendingRedirect",C:"session"};function Rj(a){return a.b.set(Qj,"pending",a.a)}function Sj(a){return uj(a.b,Qj,a.a)}function Tj(a){return a.b.get(Qj,a.a).then(function(a){return"pending"==a})};function Uj(a,b,c){this.v=a;this.l=b;this.u=c;this.h=[];this.f=!1;this.i=r(this.m,this);this.c=new Vj;this.o=new Wj;this.g=new Pj(this.l+":"+this.u);this.b={};this.b.unknown=this.c;this.b.signInViaRedirect=this.c;this.b.linkViaRedirect=this.c;this.b.reauthViaRedirect=this.c;this.b.signInViaPopup=this.o;this.b.linkViaPopup=this.o;this.b.reauthViaPopup=this.o;this.a=Xj(this.v,this.l,this.u,yi)}
function Xj(a,b,c,d){var e=firebase.SDK_VERSION||null;return Jf()?new Gj(a,b,c,e,void 0,void 0,d):new Li(a,b,c,e,d)}Uj.prototype.reset=function(){this.f=!1;this.a.Ja(this.i);this.a=Xj(this.v,this.l,this.u)};function Yj(a){a.f||(a.f=!0,a.a.ua(a.i));var b=a.a;return a.a.ba().s(function(c){a.a==b&&a.reset();throw c;})}function Zj(a){a.a.Cb()&&Yj(a).s(function(b){var c=new wh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ak(b)&&a.m(c)});a.a.xb()||bk(a.c)}
Uj.prototype.subscribe=function(a){Ha(this.h,a)||this.h.push(a);if(!this.f){var b=this;Tj(this.g).then(function(a){a?Sj(b.g).then(function(){Yj(b).s(function(a){var c=new wh("unknown",null,null,null,new N("operation-not-supported-in-this-environment"));ak(a)&&b.m(c)})}):Zj(b)}).s(function(){Zj(b)})}};Uj.prototype.unsubscribe=function(a){Ja(this.h,function(b){return b==a})};
Uj.prototype.m=function(a){if(!a)throw new N("invalid-auth-event");for(var b=!1,c=0;c<this.h.length;c++){var d=this.h[c];if(d.ob(a.b,a.c)){(b=this.b[a.b])&&b.h(a,d);b=!0;break}}bk(this.c);return b};var ck=new $f(2E3,1E4),dk=new $f(3E4,6E4);Uj.prototype.aa=function(){return this.c.aa()};function ek(a,b,c,d,e,f){return a.a.ub(b,c,d,function(){a.f||(a.f=!0,a.a.ua(a.i))},function(){a.reset()},e,f)}function ak(a){return a&&"auth/cordova-not-ready"==a.code?!0:!1}
Uj.prototype.Aa=function(a,b,c){var d=this,e;return Rj(this.g).then(function(){return d.a.Aa(a,b,c).s(function(a){if(ak(a))throw new N("operation-not-supported-in-this-environment");e=a;return Sj(d.g).then(function(){throw e;})}).then(function(){return d.a.Db()?new z(function(){}):Sj(d.g).then(function(){return d.aa()}).then(function(){}).s(function(){})})})};Uj.prototype.Ca=function(a,b,c,d){return this.a.Ca(c,function(c){a.fa(b,null,c,d)},ck.get())};var fk={};
function gk(a,b,c){var d=b+":"+c;fk[d]||(fk[d]=new Uj(a,b,c));return fk[d]}function Vj(){this.b=null;this.f=[];this.c=[];this.a=null;this.g=!1}Vj.prototype.reset=function(){this.b=null;this.a&&(this.a.cancel(),this.a=null)};
Vj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));this.reset();this.g=!0;var c=a.b,d=a.c,e=a.a&&"auth/web-storage-unsupported"==a.a.code,f=a.a&&"auth/operation-not-supported-in-this-environment"==a.a.code;"unknown"!=c||e||f?a.a?(hk(this,!0,null,a.a),a=A()):a=b.va(c,d)?ik(this,a,b):B(new N("invalid-auth-event")):(hk(this,!1,null,null),a=A());return a};function bk(a){a.g||(a.g=!0,hk(a,!1,null,null))}
function ik(a,b,c){c=c.va(b.b,b.c);var d=b.f,e=b.g,f=!!b.b.match(/Redirect$/);return c(d,e).then(function(b){hk(a,f,b,null)}).s(function(b){hk(a,f,null,b)})}function jk(a,b){a.b=function(){return B(b)};if(a.c.length)for(var c=0;c<a.c.length;c++)a.c[c](b)}function kk(a,b){a.b=function(){return A(b)};if(a.f.length)for(var c=0;c<a.f.length;c++)a.f[c](b)}function hk(a,b,c,d){b?d?jk(a,d):kk(a,c):kk(a,{user:null});a.f=[];a.c=[]}
Vj.prototype.aa=function(){var a=this;return new z(function(b,c){a.b?a.b().then(b,c):(a.f.push(b),a.c.push(c),lk(a))})};function lk(a){var b=new N("timeout");a.a&&a.a.cancel();a.a=sd(dk.get()).then(function(){a.b||hk(a,!0,null,b)})}function Wj(){}Wj.prototype.h=function(a,b){if(!a)return B(new N("invalid-auth-event"));var c=a.b,d=a.c;a.a?(b.fa(a.b,null,a.a,a.c),a=A()):a=b.va(c,d)?mk(a,b):B(new N("invalid-auth-event"));return a};
function mk(a,b){var c=a.c,d=a.b;return b.va(d,c)(a.f,a.g).then(function(a){b.fa(d,a,null,c)}).s(function(a){b.fa(d,null,a,c)})};function nk(a,b){this.a=b;M(this,"verificationId",a)}nk.prototype.confirm=function(a){a=th(this.verificationId,a);return this.a(a)};function ok(a,b,c,d){return(new rh(a)).Qa(b,c).then(function(a){return new nk(a,d)})};function pk(a,b,c,d,e,f){this.h=a;this.i=b;this.g=c;this.c=d;this.f=e;this.l=!!f;this.b=null;this.a=this.c;if(this.f<this.c)throw Error("Proactive refresh lower bound greater than upper bound!");}pk.prototype.start=function(){this.a=this.c;qk(this,!0)};function rk(a,b){if(b)return a.a=a.c,a.g();b=a.a;a.a*=2;a.a>a.f&&(a.a=a.f);return b}
function qk(a,b){sk(a);a.b=sd(rk(a,b)).then(function(){return a.l?A():bg()}).then(function(){return a.h()}).then(function(){qk(a,!0)}).s(function(b){a.i(b)&&qk(a,!1)})}function sk(a){a.b&&(a.b.cancel(),a.b=null)};function tk(a){this.f=a;this.b=this.a=null;this.c=0}tk.prototype.B=function(){return{apiKey:this.f.b,refreshToken:this.a,accessToken:this.b,expirationTime:this.c}};function uk(a,b){var c=b[O],d=b.refreshToken;b=vk(b.expiresIn);a.b=c;a.c=b;a.a=d}function vk(a){return na()+1E3*parseInt(a,10)}
function wk(a,b){return Oh(a.f,b).then(function(b){a.b=b.access_token;a.c=vk(b.expires_in);a.a=b.refresh_token;return{accessToken:a.b,expirationTime:a.c,refreshToken:a.a}}).s(function(b){"auth/user-token-expired"==b.code&&(a.a=null);throw b;})}tk.prototype.getToken=function(a){a=!!a;return this.b&&!this.a?B(new N("user-token-expired")):a||!this.b||na()>this.c-3E4?this.a?wk(this,{grant_type:"refresh_token",refresh_token:this.a}):A(null):A({accessToken:this.b,expirationTime:this.c,refreshToken:this.a})};function xk(a,b){this.a=a||null;this.b=b||null;gg(this,{lastSignInTime:cg(b||null),creationTime:cg(a||null)})}function yk(a){return new xk(a.a,a.b)}xk.prototype.B=function(){return{lastLoginAt:this.b,createdAt:this.a}};function zk(a,b,c,d,e,f){gg(this,{uid:a,displayName:d||null,photoURL:e||null,email:c||null,phoneNumber:f||null,providerId:b})}function Ak(a,b){C.call(this,a);for(var c in b)this[c]=b[c]}t(Ak,C);
function Bk(a,b,c){this.A=[];this.G=a.apiKey;this.o=a.appName;this.w=a.authDomain||null;a=firebase.SDK_VERSION?Of(firebase.SDK_VERSION):null;this.c=new Ch(this.G,xi(yi),a);this.h=new tk(this.c);Ck(this,b[O]);uk(this.h,b);M(this,"refreshToken",this.h.a);Dk(this,c||{});F.call(this);this.I=!1;this.w&&Rf()&&(this.a=gk(this.w,this.G,this.o));this.N=[];this.i=null;this.l=Ek(this);this.U=r(this.Ga,this);var d=this;this.ha=null;this.ra=function(a){d.na(a.h)};this.W=null;this.R=[];this.qa=function(a){Fk(d,
a.f)};this.V=null}t(Bk,F);Bk.prototype.na=function(a){this.ha=a;Ih(this.c,a)};Bk.prototype.$=function(){return this.ha};function Gk(a,b){a.W&&E(a.W,"languageCodeChanged",a.ra);(a.W=b)&&cd(b,"languageCodeChanged",a.ra)}function Fk(a,b){a.R=b;Jh(a.c,firebase.SDK_VERSION?Of(firebase.SDK_VERSION,a.R):null)}Bk.prototype.Ka=function(){return La(this.R)};function Hk(a,b){a.V&&E(a.V,"frameworkChanged",a.qa);(a.V=b)&&cd(b,"frameworkChanged",a.qa)}Bk.prototype.Ga=function(){this.l.b&&(sk(this.l),this.l.start())};
function Ik(a){try{return firebase.app(a.o).auth()}catch(b){throw new N("internal-error","No firebase.auth.Auth instance is available for the Firebase App '"+a.o+"'!");}}function Ek(a){return new pk(function(){return a.F(!0)},function(a){return a&&"auth/network-request-failed"==a.code?!0:!1},function(){var b=a.h.c-na()-3E5;return 0<b?b:0},3E4,96E4,!1)}function Jk(a){a.m||a.l.b||(a.l.start(),E(a,"tokenChanged",a.U),cd(a,"tokenChanged",a.U))}function Kk(a){E(a,"tokenChanged",a.U);sk(a.l)}
function Ck(a,b){a.pa=b;M(a,"_lat",b)}function Lk(a,b){Ja(a.N,function(a){return a==b})}function Mk(a){for(var b=[],c=0;c<a.N.length;c++)b.push(a.N[c](a));return Ob(b).then(function(){return a})}function Nk(a){a.a&&!a.I&&(a.I=!0,a.a.subscribe(a))}
function Dk(a,b){gg(a,{uid:b.uid,displayName:b.displayName||null,photoURL:b.photoURL||null,email:b.email||null,emailVerified:b.emailVerified||!1,phoneNumber:b.phoneNumber||null,isAnonymous:b.isAnonymous||!1,metadata:new xk(b.createdAt,b.lastLoginAt),providerData:[]})}M(Bk.prototype,"providerId","firebase");function Ok(){}function Pk(a){return A().then(function(){if(a.m)throw new N("app-deleted");})}function Qk(a){return Da(a.providerData,function(a){return a.providerId})}
function Rk(a,b){b&&(Sk(a,b.providerId),a.providerData.push(b))}function Sk(a,b){Ja(a.providerData,function(a){return a.providerId==b})}function Tk(a,b,c){("uid"!=b||c)&&a.hasOwnProperty(b)&&M(a,b,c)}
function Uk(a,b){a!=b&&(gg(a,{uid:b.uid,displayName:b.displayName,photoURL:b.photoURL,email:b.email,emailVerified:b.emailVerified,phoneNumber:b.phoneNumber,isAnonymous:b.isAnonymous,providerData:[]}),b.metadata?M(a,"metadata",yk(b.metadata)):M(a,"metadata",new xk),w(b.providerData,function(b){Rk(a,b)}),a.h=b.h,M(a,"refreshToken",a.h.a))}h=Bk.prototype;h.reload=function(){var a=this;return R(this,Pk(this).then(function(){return Vk(a).then(function(){return Mk(a)}).then(Ok)}))};
function Vk(a){return a.F().then(function(b){var c=a.isAnonymous;return Wk(a,b).then(function(){c||Tk(a,"isAnonymous",!1);return b})})}h.F=function(a){var b=this;return R(this,Pk(this).then(function(){return b.h.getToken(a)}).then(function(a){if(!a)throw new N("internal-error");a.accessToken!=b.pa&&(Ck(b,a.accessToken),G(b,new Ak("tokenChanged")));Tk(b,"refreshToken",a.refreshToken);return a.accessToken}))};
h.getToken=function(a){dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]||(dg["firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."]=!0,"undefined"!==typeof console&&"function"===typeof console.warn&&console.warn("firebase.User.prototype.getToken is deprecated. Please use firebase.User.prototype.getIdToken instead."));return this.F(a)};
function Xk(a,b){b[O]&&a.pa!=b[O]&&(uk(a.h,b),G(a,new Ak("tokenChanged")),Ck(a,b[O]),Tk(a,"refreshToken",a.h.a))}function Wk(a,b){return Q(a.c,ti,{idToken:b}).then(r(a.gc,a))}
h.gc=function(a){a=a.users;if(!a||!a.length)throw new N("internal-error");a=a[0];Dk(this,{uid:a.localId,displayName:a.displayName,photoURL:a.photoUrl,email:a.email,emailVerified:!!a.emailVerified,phoneNumber:a.phoneNumber,lastLoginAt:a.lastLoginAt,createdAt:a.createdAt});for(var b=Yk(a),c=0;c<b.length;c++)Rk(this,b[c]);Tk(this,"isAnonymous",!(this.email&&a.passwordHash)&&!(this.providerData&&this.providerData.length))};
function Yk(a){return(a=a.providerUserInfo)&&a.length?Da(a,function(a){return new zk(a.rawId,a.providerId,a.email,a.displayName,a.photoUrl,a.phoneNumber)}):[]}h.Za=function(a){var b=this,c=null;return R(this,a.c(this.c,this.uid).then(function(a){Xk(b,a);c=Zk(b,a,"reauthenticate");b.i=null;return b.reload()}).then(function(){return c}),!0)};h.hc=function(a){return this.Za(a).then(function(){})};
function $k(a,b){return Vk(a).then(function(){if(Ha(Qk(a),b))return Mk(a).then(function(){throw new N("provider-already-linked");})})}h.Xa=function(a){var b=this,c=null;return R(this,$k(this,a.providerId).then(function(){return b.F()}).then(function(c){return a.b(b.c,c)}).then(function(a){c=Zk(b,a,"link");return al(b,a)}).then(function(){return c}))};h.Zb=function(a){return this.Xa(a).then(function(a){return a.user})};
h.$b=function(a,b){var c=this;return R(this,$k(this,"phone").then(function(){return ok(Ik(c),a,b,r(c.Xa,c))}))};h.ic=function(a,b){var c=this;return R(this,A().then(function(){return ok(Ik(c),a,b,r(c.Za,c))}),!0)};function Zk(a,b,c){var d=uh(b);b=Mg(b);return hg({user:a,credential:d,additionalUserInfo:b,operationType:c})}function al(a,b){Xk(a,b);return a.reload().then(function(){return a})}
h.kb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.kb(c,a)}).then(function(a){Xk(b,a);return b.reload()}))};h.zc=function(a){var b=this;return R(this,this.F().then(function(c){return a.b(b.c,c)}).then(function(a){Xk(b,a);return b.reload()}))};h.lb=function(a){var b=this;return R(this,this.F().then(function(c){return b.c.lb(c,a)}).then(function(a){Xk(b,a);return b.reload()}))};
h.mb=function(a){if(void 0===a.displayName&&void 0===a.photoURL)return Pk(this);var b=this;return R(this,this.F().then(function(c){return b.c.mb(c,{displayName:a.displayName,photoUrl:a.photoURL})}).then(function(a){Xk(b,a);Tk(b,"displayName",a.displayName||null);Tk(b,"photoURL",a.photoUrl||null);w(b.providerData,function(a){"password"===a.providerId&&(M(a,"displayName",b.displayName),M(a,"photoURL",b.photoURL))});return Mk(b)}).then(Ok))};
h.yc=function(a){var b=this;return R(this,Vk(this).then(function(c){return Ha(Qk(b),a)?fi(b.c,c,[a]).then(function(a){var c={};w(a.providerUserInfo||[],function(a){c[a.providerId]=!0});w(Qk(b),function(a){c[a]||Sk(b,a)});c[rh.PROVIDER_ID]||M(b,"phoneNumber",null);return Mk(b)}):Mk(b).then(function(){throw new N("no-such-provider");})}))};
h.delete=function(){var a=this;return R(this,this.F().then(function(b){return Q(a.c,si,{idToken:b})}).then(function(){G(a,new Ak("userDeleted"))})).then(function(){for(var b=0;b<a.A.length;b++)a.A[b].cancel("app-deleted");Gk(a,null);Hk(a,null);a.A=[];a.m=!0;Kk(a);M(a,"refreshToken",null);a.a&&a.a.unsubscribe(a)})};
h.ob=function(a,b){return"linkViaPopup"==a&&(this.g||null)==b&&this.f||"reauthViaPopup"==a&&(this.g||null)==b&&this.f||"linkViaRedirect"==a&&(this.Z||null)==b||"reauthViaRedirect"==a&&(this.Z||null)==b?!0:!1};h.fa=function(a,b,c,d){"linkViaPopup"!=a&&"reauthViaPopup"!=a||d!=(this.g||null)||(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};
h.va=function(a,b){return"linkViaPopup"==a&&b==(this.g||null)?r(this.sb,this):"reauthViaPopup"==a&&b==(this.g||null)?r(this.tb,this):"linkViaRedirect"==a&&(this.Z||null)==b?r(this.sb,this):"reauthViaRedirect"==a&&(this.Z||null)==b?r(this.tb,this):null};h.ac=function(a){var b=this;return bl(this,"linkViaPopup",a,function(){return $k(b,a.providerId).then(function(){return Mk(b)})},!1)};h.jc=function(a){return bl(this,"reauthViaPopup",a,function(){return A()},!0)};
function bl(a,b,c,d,e){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=Lg(c.providerId),g=Qf(a.uid+":::"),l=null;(!Tf()||Lf())&&a.w&&c.isOAuthProvider&&(l=Ri(a.w,a.G,a.o,b,c,null,g,firebase.SDK_VERSION||null));var n=Df(l,f&&f.za,f&&f.ya);d=d().then(function(){cl(a);if(!e)return a.F().then(function(){})}).then(function(){return ek(a.a,n,b,c,g,!!l)}).then(function(){return new z(function(c,d){a.fa(b,null,new N("cancelled-popup-request"),a.g||null);
a.f=c;a.v=d;a.g=g;a.b=a.a.Ca(a,b,n,g)})}).then(function(a){n&&Cf(n);return a?hg(a):null}).s(function(a){n&&Cf(n);throw a;});return R(a,d,e)}h.bc=function(a){var b=this;return dl(this,"linkViaRedirect",a,function(){return $k(b,a.providerId)},!1)};h.kc=function(a){return dl(this,"reauthViaRedirect",a,function(){return A()},!0)};
function dl(a,b,c,d,e){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));if(a.i&&!e)return B(a.i);var f=null,g=Qf(a.uid+":::");d=d().then(function(){cl(a);if(!e)return a.F().then(function(){})}).then(function(){a.Z=g;return Mk(a)}).then(function(b){a.ca&&(b=a.ca,b=b.b.set(el,a.B(),b.a));return b}).then(function(){return a.a.Aa(b,c,g)}).s(function(b){f=b;if(a.ca)return fl(a.ca);throw f;}).then(function(){if(f)throw f;});return R(a,d,e)}
function cl(a){if(!a.a||!a.I){if(a.a&&!a.I)throw new N("internal-error");throw new N("auth-domain-config-required");}}h.sb=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=this.F().then(function(d){return Zg(c.c,{requestUri:a,sessionId:b,idToken:d})}).then(function(a){d=Zk(c,a,"link");return al(c,a)}).then(function(){return d});return R(this,e)};
h.tb=function(a,b){var c=this;this.b&&(this.b.cancel(),this.b=null);var d=null,e=A().then(function(){return Vg($g(c.c,{requestUri:a,sessionId:b}),c.uid)}).then(function(a){d=Zk(c,a,"reauthenticate");Xk(c,a);c.i=null;return c.reload()}).then(function(){return d});return R(this,e,!0)};h.bb=function(a){var b=this,c=null;return R(this,this.F().then(function(b){c=b;return"undefined"===typeof a||Sa(a)?{}:Fg(new wg(a))}).then(function(a){return b.c.bb(c,a)}).then(function(a){if(b.email!=a)return b.reload()}).then(function(){}))};
function R(a,b,c){var d=gl(a,b,c);a.A.push(d);Qb(d,function(){Ia(a.A,d)});return d}function gl(a,b,c){return a.i&&!c?(b.cancel(),B(a.i)):b.s(function(b){!b||"auth/user-disabled"!=b.code&&"auth/user-token-expired"!=b.code||(a.i||G(a,new Ak("userInvalidated")),a.i=b);throw b;})}h.toJSON=function(){return this.B()};
h.B=function(){var a={uid:this.uid,displayName:this.displayName,photoURL:this.photoURL,email:this.email,emailVerified:this.emailVerified,phoneNumber:this.phoneNumber,isAnonymous:this.isAnonymous,providerData:[],apiKey:this.G,appName:this.o,authDomain:this.w,stsTokenManager:this.h.B(),redirectEventId:this.Z||null};this.metadata&&Wa(a,this.metadata.B());w(this.providerData,function(b){a.providerData.push(ig(b))});return a};
function hl(a){if(!a.apiKey)return null;var b={apiKey:a.apiKey,authDomain:a.authDomain,appName:a.appName},c={};if(a.stsTokenManager&&a.stsTokenManager.accessToken&&a.stsTokenManager.expirationTime)c[O]=a.stsTokenManager.accessToken,c.refreshToken=a.stsTokenManager.refreshToken||null,c.expiresIn=(a.stsTokenManager.expirationTime-na())/1E3;else return null;var d=new Bk(b,c,a);a.providerData&&w(a.providerData,function(a){a&&Rk(d,hg(a))});a.redirectEventId&&(d.Z=a.redirectEventId);return d}
function il(a,b,c,d){var e=new Bk(a,b);c&&(e.ca=c);d&&Fk(e,d);return e.reload().then(function(){return e})};function jl(a){this.a=a;this.b=rj()}var el={name:"redirectUser",C:"session"};function fl(a){return uj(a.b,el,a.a)}function kl(a,b){return a.b.get(el,a.a).then(function(a){a&&b&&(a.authDomain=b);return hl(a||{})})};function ll(a,b){this.a=a;this.b=b||rj();this.c=null;this.f=ml(this);vj(this.b,yj("local"),this.a,r(this.g,this))}ll.prototype.g=function(){var a=this,b=yj("local");nl(this,function(){return A().then(function(){return a.c&&"local"!=a.c.C?a.b.get(b,a.a):null}).then(function(c){if(c)return ol(a,"local").then(function(){a.c=b})})})};function ol(a,b){var c=[],d;for(d in nj)nj[d]!==b&&c.push(uj(a.b,yj(nj[d]),a.a));c.push(uj(a.b,pl,a.a));return Nb(c)}
function ml(a){var b=yj("local"),c=yj("session"),d=yj("none");return a.b.get(c,a.a).then(function(e){return e?c:a.b.get(d,a.a).then(function(c){return c?d:a.b.get(b,a.a).then(function(c){return c?b:a.b.get(pl,a.a).then(function(a){return a?yj(a):b})})})}).then(function(b){a.c=b;return ol(a,b.C)}).s(function(){a.c||(a.c=b)})}var pl={name:"persistence",C:"session"};function yj(a){return{name:"authUser",C:a}}
ll.prototype.eb=function(a){var b=null,c=this;oj(a);return nl(this,function(){return a!=c.c.C?c.b.get(c.c,c.a).then(function(d){b=d;return ol(c,a)}).then(function(){c.c=yj(a);if(b)return c.b.set(c.c,b,c.a)}):A()})};function ql(a){return nl(a,function(){return a.b.set(pl,a.c.C,a.a)})}function rl(a,b){return nl(a,function(){return a.b.set(a.c,b.B(),a.a)})}function sl(a){return nl(a,function(){return uj(a.b,a.c,a.a)})}
function tl(a,b){return nl(a,function(){return a.b.get(a.c,a.a).then(function(a){a&&b&&(a.authDomain=b);return hl(a||{})})})}function nl(a,b){a.f=a.f.then(b,b);return a.f};function ul(a){this.l=!1;M(this,"app",a);if(S(this).options&&S(this).options.apiKey)a=firebase.SDK_VERSION?Of(firebase.SDK_VERSION):null,this.c=new Ch(S(this).options&&S(this).options.apiKey,xi(yi),a);else throw new N("invalid-api-key");this.N=[];this.m=[];this.I=[];this.Gb=firebase.INTERNAL.createSubscribe(r(this.Xb,this));this.R=void 0;this.Hb=firebase.INTERNAL.createSubscribe(r(this.Yb,this));vl(this,null);this.h=new ll(S(this).options.apiKey+":"+S(this).name);this.G=new jl(S(this).options.apiKey+
":"+S(this).name);this.U=T(this,wl(this));this.i=T(this,xl(this));this.W=!1;this.ha=r(this.uc,this);this.Ga=r(this.ka,this);this.pa=r(this.Pb,this);this.qa=r(this.Vb,this);this.ra=r(this.Wb,this);yl(this);this.INTERNAL={};this.INTERNAL["delete"]=r(this.delete,this);this.INTERNAL.logFramework=r(this.cc,this);this.o=0;F.call(this);zl(this);this.A=[]}t(ul,F);function Al(a){C.call(this,"languageCodeChanged");this.h=a}t(Al,C);function Bl(a){C.call(this,"frameworkChanged");this.f=a}t(Bl,C);h=ul.prototype;
h.eb=function(a){a=this.h.eb(a);return T(this,a)};h.na=function(a){this.V===a||this.l||(this.V=a,Ih(this.c,this.V),G(this,new Al(this.$())))};h.$=function(){return this.V};h.Ac=function(){var a=k.navigator;this.na(a?a.languages&&a.languages[0]||a.language||a.userLanguage||null:null)};h.cc=function(a){this.A.push(a);Jh(this.c,firebase.SDK_VERSION?Of(firebase.SDK_VERSION,this.A):null);G(this,new Bl(this.A))};h.Ka=function(){return La(this.A)};
function zl(a){Object.defineProperty(a,"lc",{get:function(){return this.$()},set:function(a){this.na(a)},enumerable:!1});a.V=null}h.toJSON=function(){return{apiKey:S(this).options.apiKey,authDomain:S(this).options.authDomain,appName:S(this).name,currentUser:U(this)&&U(this).B()}};function Cl(a){return a.Fb||B(new N("auth-domain-config-required"))}
function yl(a){var b=S(a).options.authDomain,c=S(a).options.apiKey;b&&Rf()&&(a.Fb=a.U.then(function(){if(!a.l){a.a=gk(b,c,S(a).name);a.a.subscribe(a);U(a)&&Nk(U(a));if(a.w){Nk(a.w);var d=a.w;d.na(a.$());Gk(d,a);d=a.w;Fk(d,a.A);Hk(d,a);a.w=null}return a.a}}))}h.ob=function(a,b){switch(a){case "unknown":case "signInViaRedirect":return!0;case "signInViaPopup":return this.g==b&&!!this.f;default:return!1}};
h.fa=function(a,b,c,d){"signInViaPopup"==a&&this.g==d&&(c&&this.v?this.v(c):b&&!c&&this.f&&this.f(b),this.b&&(this.b.cancel(),this.b=null),delete this.f,delete this.v)};h.va=function(a,b){return"signInViaRedirect"==a||"signInViaPopup"==a&&this.g==b&&this.f?r(this.Ob,this):null};
h.Ob=function(a,b){var c=this;a={requestUri:a,sessionId:b};this.b&&(this.b.cancel(),this.b=null);var d=null,e=null,f=Xg(c.c,a).then(function(a){d=uh(a);e=Mg(a);return a});a=c.U.then(function(){return f}).then(function(a){return Dl(c,a)}).then(function(){return hg({user:U(c),credential:d,additionalUserInfo:e,operationType:"signIn"})});return T(this,a)};
h.sc=function(a){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=Lg(a.providerId),d=Qf(),e=null;(!Tf()||Lf())&&S(this).options.authDomain&&a.isOAuthProvider&&(e=Ri(S(this).options.authDomain,S(this).options.apiKey,S(this).name,"signInViaPopup",a,null,d,firebase.SDK_VERSION||null));var f=Df(e,c&&c.za,c&&c.ya);c=Cl(this).then(function(b){return ek(b,f,"signInViaPopup",a,d,!!e)}).then(function(){return new z(function(a,c){b.fa("signInViaPopup",null,new N("cancelled-popup-request"),
b.g);b.f=a;b.v=c;b.g=d;b.b=b.a.Ca(b,"signInViaPopup",f,d)})}).then(function(a){f&&Cf(f);return a?hg(a):null}).s(function(a){f&&Cf(f);throw a;});return T(this,c)};h.tc=function(a){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var b=this,c=Cl(this).then(function(){return ql(b.h)}).then(function(){return b.a.Aa("signInViaRedirect",a)});return T(this,c)};
h.aa=function(){if(!Rf())return B(new N("operation-not-supported-in-this-environment"));var a=this,b=Cl(this).then(function(){return a.a.aa()}).then(function(a){return a?hg(a):null});return T(this,b)};function Dl(a,b){var c={};c.apiKey=S(a).options.apiKey;c.authDomain=S(a).options.authDomain;c.appName=S(a).name;return a.U.then(function(){return il(c,b,a.G,a.Ka())}).then(function(b){if(U(a)&&b.uid==U(a).uid)return Uk(U(a),b),a.ka(b);vl(a,b);Nk(b);return a.ka(b)}).then(function(){El(a)})}
function vl(a,b){U(a)&&(Lk(U(a),a.Ga),E(U(a),"tokenChanged",a.pa),E(U(a),"userDeleted",a.qa),E(U(a),"userInvalidated",a.ra),Kk(U(a)));b&&(b.N.push(a.Ga),cd(b,"tokenChanged",a.pa),cd(b,"userDeleted",a.qa),cd(b,"userInvalidated",a.ra),0<a.o&&Jk(b));M(a,"currentUser",b);b&&(b.na(a.$()),Gk(b,a),Fk(b,a.A),Hk(b,a))}h.hb=function(){var a=this,b=this.i.then(function(){if(!U(a))return A();vl(a,null);return sl(a.h).then(function(){El(a)})});return T(this,b)};
function Fl(a){var b=kl(a.G,S(a).options.authDomain).then(function(b){if(a.w=b)b.ca=a.G;return fl(a.G)});return T(a,b)}function wl(a){var b=S(a).options.authDomain,c=Fl(a).then(function(){return tl(a.h,b)}).then(function(b){return b?(b.ca=a.G,a.w&&(a.w.Z||null)==(b.Z||null)?b:b.reload().then(function(){return rl(a.h,b).then(function(){return b})}).s(function(c){return"auth/network-request-failed"==c.code?b:sl(a.h)})):null}).then(function(b){vl(a,b||null)});return T(a,c)}
function xl(a){return a.U.then(function(){return a.aa()}).s(function(){}).then(function(){if(!a.l)return a.ha()}).s(function(){}).then(function(){if(!a.l){a.W=!0;var b=a.h;vj(b.b,yj("local"),b.a,a.ha)}})}
h.uc=function(){var a=this;return tl(this.h,S(this).options.authDomain).then(function(b){if(!a.l){var c;if(c=U(a)&&b){c=U(a).uid;var d=b.uid;c=void 0===c||null===c||""===c||void 0===d||null===d||""===d?!1:c==d}if(c)return Uk(U(a),b),U(a).F();if(U(a)||b)vl(a,b),b&&(Nk(b),b.ca=a.G),a.a&&a.a.subscribe(a),El(a)}})};h.ka=function(a){return rl(this.h,a)};h.Pb=function(){El(this);this.ka(U(this))};h.Vb=function(){this.hb()};h.Wb=function(){this.hb()};
function Gl(a,b){var c=null,d=null;return T(a,b.then(function(b){c=uh(b);d=Mg(b);return Dl(a,b)}).then(function(){return hg({user:U(a),credential:c,additionalUserInfo:d,operationType:"signIn"})}))}h.Xb=function(a){var b=this;this.addAuthTokenListener(function(){a.next(U(b))})};h.Yb=function(a){var b=this;Hl(this,function(){a.next(U(b))})};h.ec=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Gb(a,b,c)};
h.dc=function(a,b,c){var d=this;this.W&&firebase.Promise.resolve().then(function(){d.R=d.getUid();p(a)?a(U(d)):p(a.next)&&a.next(U(d))});return this.Hb(a,b,c)};h.Rb=function(a){var b=this,c=this.i.then(function(){return U(b)?U(b).F(a).then(function(a){return{accessToken:a}}):null});return T(this,c)};h.pc=function(a){var b=this;return this.i.then(function(){return Gl(b,Q(b.c,vi,{token:a}))}).then(function(a){a=a.user;Tk(a,"isAnonymous",!1);return b.ka(a)}).then(function(){return U(b)})};
h.qc=function(a,b){var c=this;return this.i.then(function(){return Gl(c,Q(c.c,kh,{email:a,password:b}))}).then(function(a){return a.user})};h.Kb=function(a,b){var c=this;return this.i.then(function(){return Gl(c,Q(c.c,ri,{email:a,password:b}))}).then(function(a){return a.user})};h.oc=function(a){return this.fb(a).then(function(a){return a.user})};h.fb=function(a){var b=this;return this.i.then(function(){return Gl(b,a.wa(b.c))})};
h.gb=function(){var a=this;return this.i.then(function(){var b=U(a);return b&&b.isAnonymous?b:Gl(a,a.c.gb()).then(function(b){b=b.user;Tk(b,"isAnonymous",!0);return a.ka(b)}).then(function(){return U(a)})})};function S(a){return a.app}function U(a){return a.currentUser}h.getUid=function(){return U(this)&&U(this).uid||null};function Il(a){return U(a)&&U(a)._lat||null}
function El(a){if(a.W){for(var b=0;b<a.m.length;b++)if(a.m[b])a.m[b](Il(a));if(a.R!==a.getUid()&&a.I.length)for(a.R=a.getUid(),b=0;b<a.I.length;b++)if(a.I[b])a.I[b](Il(a))}}h.Ib=function(a){this.addAuthTokenListener(a);this.o++;0<this.o&&U(this)&&Jk(U(this))};h.mc=function(a){var b=this;w(this.m,function(c){c==a&&b.o--});0>this.o&&(this.o=0);0==this.o&&U(this)&&Kk(U(this));this.removeAuthTokenListener(a)};
h.addAuthTokenListener=function(a){var b=this;this.m.push(a);T(this,this.i.then(function(){b.l||Ha(b.m,a)&&a(Il(b))}))};h.removeAuthTokenListener=function(a){Ja(this.m,function(b){return b==a})};function Hl(a,b){a.I.push(b);T(a,a.i.then(function(){!a.l&&Ha(a.I,b)&&a.R!==a.getUid()&&(a.R=a.getUid(),b(Il(a)))}))}h.delete=function(){this.l=!0;for(var a=0;a<this.N.length;a++)this.N[a].cancel("app-deleted");this.N=[];this.h&&(a=this.h,xj(a.b,a.a,this.ha));this.a&&this.a.unsubscribe(this);return firebase.Promise.resolve()};
function T(a,b){a.N.push(b);Qb(b,function(){Ia(a.N,b)});return b}h.Nb=function(a){return T(this,Th(this.c,a))};h.Bc=function(a){return this.Ia(a).then(function(a){return a.data.email})};h.Ta=function(a,b){return T(this,this.c.Ta(a,b).then(function(){}))};h.Ia=function(a){return T(this,this.c.Ia(a).then(function(a){return new lg(a)}))};h.Sa=function(a){return T(this,this.c.Sa(a).then(function(){}))};
h.cb=function(a,b){var c=this;return T(this,A().then(function(){return"undefined"===typeof b||Sa(b)?{}:Fg(new wg(b))}).then(function(b){return c.c.cb(a,b)}).then(function(){}))};h.rc=function(a,b){return T(this,ok(this,a,b,r(this.fb,this)))};function Jl(a,b,c,d){a:{c=Array.prototype.slice.call(c);var e=0;for(var f=!1,g=0;g<b.length;g++)if(b[g].optional)f=!0;else{if(f)throw new N("internal-error","Argument validator encountered a required argument after an optional argument.");e++}f=b.length;if(c.length<e||f<c.length)d="Expected "+(e==f?1==e?"1 argument":e+" arguments":e+"-"+f+" arguments")+" but got "+c.length+".";else{for(e=0;e<c.length;e++)if(f=b[e].optional&&void 0===c[e],!b[e].M(c[e])&&!f){b=b[e];if(0>e||e>=Kl.length)throw new N("internal-error",
"Argument validator received an unsupported number of arguments.");c=Kl[e];d=(d?"":c+" argument ")+(b.name?'"'+b.name+'" ':"")+"must be "+b.K+".";break a}d=null}}if(d)throw new N("argument-error",a+" failed: "+d);}var Kl="First Second Third Fourth Fifth Sixth Seventh Eighth Ninth".split(" ");function V(a,b){return{name:a||"",K:"a valid string",optional:!!b,M:m}}function Ll(){return{name:"opt_forceRefresh",K:"a boolean",optional:!0,M:ba}}
function W(a,b){return{name:a||"",K:"a valid object",optional:!!b,M:q}}function Ml(a,b){return{name:a||"",K:"a function",optional:!!b,M:p}}function Nl(a,b){return{name:a||"",K:"null",optional:!!b,M:ea}}function Ol(){return{name:"",K:"an HTML element",optional:!1,M:function(a){return!!(a&&a instanceof Element)}}}function Pl(){return{name:"auth",K:"an instance of Firebase Auth",optional:!0,M:function(a){return!!(a&&a instanceof ul)}}}
function Ql(){return{name:"app",K:"an instance of Firebase App",optional:!0,M:function(a){return!!(a&&a instanceof firebase.app.App)}}}function Rl(a){return{name:a?a+"Credential":"credential",K:a?"a valid "+a+" credential":"a valid credential",optional:!1,M:function(b){if(!b)return!1;var c=!a||b.providerId===a;return!(!b.wa||!c)}}}
function Sl(){return{name:"authProvider",K:"a valid Auth provider",optional:!1,M:function(a){return!!(a&&a.providerId&&a.hasOwnProperty&&a.hasOwnProperty("isOAuthProvider"))}}}function Tl(){return{name:"applicationVerifier",K:"an implementation of firebase.auth.ApplicationVerifier",optional:!1,M:function(a){return!!(a&&m(a.type)&&p(a.verify))}}}function X(a,b,c,d){return{name:c||"",K:a.K+" or "+b.K,optional:!!d,M:function(c){return a.M(c)||b.M(c)}}};function Ul(a,b,c,d,e,f){M(this,"type","recaptcha");this.b=this.c=null;this.m=!1;this.l=b;this.a=c||{theme:"light",type:"image"};this.g=[];if(this.a[Vl])throw new N("argument-error","sitekey should not be provided for reCAPTCHA as one is automatically provisioned for the current project.");this.h="invisible"===this.a[Wl];if(!wc(b)||!this.h&&wc(b).hasChildNodes())throw new N("argument-error","reCAPTCHA container is either not found or already contains inner elements!");this.u=new Ch(a,f||null,e||null);
this.o=d||function(){return null};var g=this;this.i=[];var l=this.a[Xl];this.a[Xl]=function(a){Yl(g,a);if("function"===typeof l)l(a);else if("string"===typeof l){var b=L(l,k);"function"===typeof b&&b(a)}};var n=this.a[Zl];this.a[Zl]=function(){Yl(g,null);if("function"===typeof n)n();else if("string"===typeof n){var a=L(n,k);"function"===typeof a&&a()}}}var Xl="callback",Zl="expired-callback",Vl="sitekey",Wl="size";function Yl(a,b){for(var c=0;c<a.i.length;c++)try{a.i[c](b)}catch(d){}}
function $l(a,b){Ja(a.i,function(a){return a==b})}function am(a,b){a.g.push(b);Qb(b,function(){Ia(a.g,b)});return b}h=Ul.prototype;
h.xa=function(){var a=this;return this.c?this.c:this.c=am(this,A().then(function(){if(Sf())return Hf();throw new N("operation-not-supported-in-this-environment","RecaptchaVerifier is only supported in a browser HTTP/HTTPS environment.");}).then(function(){return bm(cm(),a.o())}).then(function(){return Q(a.u,ui,{})}).then(function(b){a.a[Vl]=b.recaptchaSiteKey}).s(function(b){a.c=null;throw b;}))};
h.render=function(){dm(this);var a=this;return am(this,this.xa().then(function(){if(null===a.b){var b=a.l;if(!a.h){var c=wc(b);b=zc("DIV");c.appendChild(b)}a.b=grecaptcha.render(b,a.a)}return a.b}))};h.verify=function(){dm(this);var a=this;return am(this,this.render().then(function(b){return new z(function(c){var d=grecaptcha.getResponse(b);if(d)c(d);else{var e=function(b){b&&($l(a,e),c(b))};a.i.push(e);a.h&&grecaptcha.execute(a.b)}})}))};h.reset=function(){dm(this);null!==this.b&&grecaptcha.reset(this.b)};
function dm(a){if(a.m)throw new N("internal-error","RecaptchaVerifier instance has been destroyed.");}h.clear=function(){dm(this);this.m=!0;cm().b--;for(var a=0;a<this.g.length;a++)this.g[a].cancel("RecaptchaVerifier instance has been destroyed.");if(!this.h){a=wc(this.l);for(var b;b=a.firstChild;)a.removeChild(b)}};var em=dc("https://www.google.com/recaptcha/api.js?onload=%{onload}&render=explicit&hl=%{hl}");
function fm(){this.b=k.grecaptcha?Infinity:0;this.c=null;this.a="__rcb"+Math.floor(1E6*Math.random()).toString()}
function bm(a,b){return new z(function(c,d){if(Zf())if(!k.grecaptcha||b!==a.c&&!a.b){k[a.a]=function(){if(k.grecaptcha){a.c=b;var e=k.grecaptcha.render;k.grecaptcha.render=function(b,c){b=e(b,c);a.b++;return b};c()}else d(new N("internal-error"));delete k[a.a]};var e=hc(em,{onload:a.a,hl:b||""});A(kf(e)).s(function(){d(new N("internal-error","Unable to load external reCAPTCHA dependencies!"))})}else c();else d(new N("network-request-failed"))})}var gm=null;
function cm(){gm||(gm=new fm);return gm}function hm(a,b,c){try{this.f=c||firebase.app()}catch(f){throw new N("argument-error","No firebase.app.App instance is currently initialized.");}if(this.f.options&&this.f.options.apiKey)c=this.f.options.apiKey;else throw new N("invalid-api-key");var d=this,e=null;try{e=this.f.auth().Ka()}catch(f){}e=firebase.SDK_VERSION?Of(firebase.SDK_VERSION,e):null;Ul.call(this,c,a,b,function(){try{var a=d.f.auth().$()}catch(g){a=null}return a},e,xi(yi))}t(hm,Ul);function Y(a,b){for(var c in b){var d=b[c].name;a[d]=im(d,a[c],b[c].j)}}function Z(a,b,c,d){a[b]=im(b,c,d)}function im(a,b,c){function d(){var a=Array.prototype.slice.call(arguments);Jl(e,c,a);return b.apply(this,a)}if(!c)return b;var e=jm(a),f;for(f in b)d[f]=b[f];for(f in b.prototype)d.prototype[f]=b.prototype[f];return d}function jm(a){a=a.split(".");return a[a.length-1]};Y(ul.prototype,{Sa:{name:"applyActionCode",j:[V("code")]},Ia:{name:"checkActionCode",j:[V("code")]},Ta:{name:"confirmPasswordReset",j:[V("code"),V("newPassword")]},Kb:{name:"createUserWithEmailAndPassword",j:[V("email"),V("password")]},Nb:{name:"fetchProvidersForEmail",j:[V("email")]},aa:{name:"getRedirectResult",j:[]},dc:{name:"onAuthStateChanged",j:[X(W(),Ml(),"nextOrObserver"),Ml("opt_error",!0),Ml("opt_completed",!0)]},ec:{name:"onIdTokenChanged",j:[X(W(),Ml(),"nextOrObserver"),Ml("opt_error",
!0),Ml("opt_completed",!0)]},cb:{name:"sendPasswordResetEmail",j:[V("email"),X(W("opt_actionCodeSettings",!0),Nl(null,!0),"opt_actionCodeSettings",!0)]},eb:{name:"setPersistence",j:[V("persistence")]},fb:{name:"signInAndRetrieveDataWithCredential",j:[Rl()]},gb:{name:"signInAnonymously",j:[]},oc:{name:"signInWithCredential",j:[Rl()]},pc:{name:"signInWithCustomToken",j:[V("token")]},qc:{name:"signInWithEmailAndPassword",j:[V("email"),V("password")]},rc:{name:"signInWithPhoneNumber",j:[V("phoneNumber"),
Tl()]},sc:{name:"signInWithPopup",j:[Sl()]},tc:{name:"signInWithRedirect",j:[Sl()]},hb:{name:"signOut",j:[]},toJSON:{name:"toJSON",j:[V(null,!0)]},Ac:{name:"useDeviceLanguage",j:[]},Bc:{name:"verifyPasswordResetCode",j:[V("code")]}});(function(a,b){for(var c in b){var d=b[c].name;if(d!==c){var e=b[c].Jb;Object.defineProperty(a,d,{get:function(){return this[c]},set:function(a){Jl(d,[e],[a],!0);this[c]=a},enumerable:!0})}}})(ul.prototype,{lc:{name:"languageCode",Jb:X(V(),Nl(),"languageCode")}});
ul.Persistence=nj;ul.Persistence.LOCAL="local";ul.Persistence.SESSION="session";ul.Persistence.NONE="none";
Y(Bk.prototype,{"delete":{name:"delete",j:[]},F:{name:"getIdToken",j:[Ll()]},getToken:{name:"getToken",j:[Ll()]},Xa:{name:"linkAndRetrieveDataWithCredential",j:[Rl()]},Zb:{name:"linkWithCredential",j:[Rl()]},$b:{name:"linkWithPhoneNumber",j:[V("phoneNumber"),Tl()]},ac:{name:"linkWithPopup",j:[Sl()]},bc:{name:"linkWithRedirect",j:[Sl()]},Za:{name:"reauthenticateAndRetrieveDataWithCredential",j:[Rl()]},hc:{name:"reauthenticateWithCredential",j:[Rl()]},ic:{name:"reauthenticateWithPhoneNumber",j:[V("phoneNumber"),
Tl()]},jc:{name:"reauthenticateWithPopup",j:[Sl()]},kc:{name:"reauthenticateWithRedirect",j:[Sl()]},reload:{name:"reload",j:[]},bb:{name:"sendEmailVerification",j:[X(W("opt_actionCodeSettings",!0),Nl(null,!0),"opt_actionCodeSettings",!0)]},toJSON:{name:"toJSON",j:[V(null,!0)]},yc:{name:"unlink",j:[V("provider")]},kb:{name:"updateEmail",j:[V("email")]},lb:{name:"updatePassword",j:[V("password")]},zc:{name:"updatePhoneNumber",j:[Rl("phone")]},mb:{name:"updateProfile",j:[W("profile")]}});
Y(z.prototype,{s:{name:"catch"},then:{name:"then"}});Y(nk.prototype,{confirm:{name:"confirm",j:[V("verificationCode")]}});Z(mh,"credential",function(a,b){return new jh(a,b)},[V("email"),V("password")]);Y(bh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(bh,"credential",ch,[X(V(),W(),"token")]);Y(dh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});
Z(dh,"credential",eh,[X(V(),W(),"token")]);Y(fh.prototype,{sa:{name:"addScope",j:[V("scope")]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(fh,"credential",gh,[X(V(),X(W(),Nl()),"idToken"),X(V(),Nl(),"accessToken",!0)]);Y(hh.prototype,{Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(hh,"credential",ih,[X(V(),W(),"token"),V("secret",!0)]);
Y(P.prototype,{sa:{name:"addScope",j:[V("scope")]},credential:{name:"credential",j:[X(V(),Nl(),"idToken",!0),X(V(),Nl(),"accessToken",!0)]},Ba:{name:"setCustomParameters",j:[W("customOAuthParameters")]}});Z(rh,"credential",th,[V("verificationId"),V("verificationCode")]);Y(rh.prototype,{Qa:{name:"verifyPhoneNumber",j:[V("phoneNumber"),Tl()]}});Y(N.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(zh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});
Y(yh.prototype,{toJSON:{name:"toJSON",j:[V(null,!0)]}});Y(hm.prototype,{clear:{name:"clear",j:[]},render:{name:"render",j:[]},verify:{name:"verify",j:[]}});
(function(){if("undefined"!==typeof firebase&&firebase.INTERNAL&&firebase.INTERNAL.registerService){var a={Auth:ul,Error:N};Z(a,"EmailAuthProvider",mh,[]);Z(a,"FacebookAuthProvider",bh,[]);Z(a,"GithubAuthProvider",dh,[]);Z(a,"GoogleAuthProvider",fh,[]);Z(a,"TwitterAuthProvider",hh,[]);Z(a,"OAuthProvider",P,[V("providerId")]);Z(a,"PhoneAuthProvider",rh,[Pl()]);Z(a,"RecaptchaVerifier",hm,[X(V(),Ol(),"recaptchaContainer"),W("recaptchaParameters",!0),Ql()]);firebase.INTERNAL.registerService("auth",function(a,
c){a=new ul(a);c({INTERNAL:{getUid:r(a.getUid,a),getToken:r(a.Rb,a),addAuthTokenListener:r(a.Ib,a),removeAuthTokenListener:r(a.mc,a)}});return a},a,function(a,c){if("create"===a)try{c.auth()}catch(d){}});firebase.INTERNAL.extendNamespace({User:Bk})}else throw Error("Cannot find the firebase namespace; be sure to include firebase-app.js before this library.");})();
}).call(typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : typeof window !== 'undefined' ? window : {});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(55)))

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

module.exports = __webpack_require__(1196);


/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var app_1 = __webpack_require__(93);
var Database_1 = __webpack_require__(461);
exports.Database = Database_1.Database;
var Query_1 = __webpack_require__(465);
exports.Query = Query_1.Query;
var Reference_1 = __webpack_require__(268);
exports.Reference = Reference_1.Reference;
var util_1 = __webpack_require__(21);
exports.enableLogging = util_1.enableLogging;
var RepoManager_1 = __webpack_require__(273);
var INTERNAL = __webpack_require__(1228);
var TEST_ACCESS = __webpack_require__(1229);
var util_2 = __webpack_require__(6);
var ServerValue = Database_1.Database.ServerValue;
exports.ServerValue = ServerValue;
function registerDatabase(instance) {
    // Register the Database Service with the 'firebase' namespace.
    var namespace = instance.INTERNAL.registerService('database', function (app, unused, url) { return RepoManager_1.RepoManager.getInstance().databaseFromApp(app, url); }, 
    // firebase.database namespace properties
    {
        Reference: Reference_1.Reference,
        Query: Query_1.Query,
        Database: Database_1.Database,
        enableLogging: util_1.enableLogging,
        INTERNAL: INTERNAL,
        ServerValue: ServerValue,
        TEST_ACCESS: TEST_ACCESS
    }, null, true);
    if (util_2.isNodeSdk()) {
        module.exports = namespace;
    }
}
exports.registerDatabase = registerDatabase;
registerDatabase(app_1.default);
var DataSnapshot_1 = __webpack_require__(269);
exports.DataSnapshot = DataSnapshot_1.DataSnapshot;
var onDisconnect_1 = __webpack_require__(464);
exports.OnDisconnect = onDisconnect_1.OnDisconnect;

//# sourceMappingURL=index.js.map


/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Wraps a DOM Storage object and:
 * - automatically encode objects as JSON strings before storing them to allow us to store arbitrary types.
 * - prefixes names with "firebase:" to avoid collisions with app data.
 *
 * We automatically (see storage.js) create two such wrappers, one for sessionStorage,
 * and one for localStorage.
 *
 * @constructor
 */
var DOMStorageWrapper = /** @class */ (function () {
    /**
     * @param {Storage} domStorage_ The underlying storage object (e.g. localStorage or sessionStorage)
     */
    function DOMStorageWrapper(domStorage_) {
        this.domStorage_ = domStorage_;
        // Use a prefix to avoid collisions with other stuff saved by the app.
        this.prefix_ = 'firebase:';
    }
    /**
     * @param {string} key The key to save the value under
     * @param {?Object} value The value being stored, or null to remove the key.
     */
    DOMStorageWrapper.prototype.set = function (key, value) {
        if (value == null) {
            this.domStorage_.removeItem(this.prefixedName_(key));
        }
        else {
            this.domStorage_.setItem(this.prefixedName_(key), util_1.stringify(value));
        }
    };
    /**
     * @param {string} key
     * @return {*} The value that was stored under this key, or null
     */
    DOMStorageWrapper.prototype.get = function (key) {
        var storedVal = this.domStorage_.getItem(this.prefixedName_(key));
        if (storedVal == null) {
            return null;
        }
        else {
            return util_1.jsonEval(storedVal);
        }
    };
    /**
     * @param {string} key
     */
    DOMStorageWrapper.prototype.remove = function (key) {
        this.domStorage_.removeItem(this.prefixedName_(key));
    };
    /**
     * @param {string} name
     * @return {string}
     */
    DOMStorageWrapper.prototype.prefixedName_ = function (name) {
        return this.prefix_ + name;
    };
    DOMStorageWrapper.prototype.toString = function () {
        return this.domStorage_.toString();
    };
    return DOMStorageWrapper;
}());
exports.DOMStorageWrapper = DOMStorageWrapper;

//# sourceMappingURL=DOMStorageWrapper.js.map


/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * An in-memory storage implementation that matches the API of DOMStorageWrapper
 * (TODO: create interface for both to implement).
 *
 * @constructor
 */
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache_ = {};
        this.isInMemoryStorage = true;
    }
    MemoryStorage.prototype.set = function (key, value) {
        if (value == null) {
            delete this.cache_[key];
        }
        else {
            this.cache_[key] = value;
        }
    };
    MemoryStorage.prototype.get = function (key) {
        if (util_1.contains(this.cache_, key)) {
            return this.cache_[key];
        }
        return null;
    };
    MemoryStorage.prototype.remove = function (key) {
        delete this.cache_[key];
    };
    return MemoryStorage;
}());
exports.MemoryStorage = MemoryStorage;

//# sourceMappingURL=MemoryStorage.js.map


/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var TransactionResult = /** @class */ (function () {
    /**
     * A type for the resolve value of Firebase.transaction.
     * @constructor
     * @dict
     * @param {boolean} committed
     * @param {DataSnapshot} snapshot
     */
    function TransactionResult(committed, snapshot) {
        this.committed = committed;
        this.snapshot = snapshot;
    }
    // Do not create public documentation. This is intended to make JSON serialization work but is otherwise unnecessary
    // for end-users
    TransactionResult.prototype.toJSON = function () {
        util_1.validateArgCount('TransactionResult.toJSON', 0, 1, arguments.length);
        return { committed: this.committed, snapshot: this.snapshot.toJSON() };
    };
    return TransactionResult;
}());
exports.TransactionResult = TransactionResult;

//# sourceMappingURL=TransactionResult.js.map


/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Fancy ID generator that creates 20-character string identifiers with the
 * following properties:
 *
 * 1. They're based on timestamp so that they sort *after* any existing ids.
 * 2. They contain 72-bits of random data after the timestamp so that IDs won't
 *    collide with other clients' IDs.
 * 3. They sort *lexicographically* (so the timestamp is converted to characters
 *    that will sort properly).
 * 4. They're monotonically increasing. Even if you generate more than one in
 *    the same timestamp, the latter ones will sort after the former ones. We do
 *    this by using the previous random bits but "incrementing" them by 1 (only
 *    in the case of a timestamp collision).
 */
exports.nextPushId = (function () {
    // Modeled after base64 web-safe chars, but ordered by ASCII.
    var PUSH_CHARS = '-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz';
    // Timestamp of last push, used to prevent local collisions if you push twice
    // in one ms.
    var lastPushTime = 0;
    // We generate 72-bits of randomness which get turned into 12 characters and
    // appended to the timestamp to prevent collisions with other clients. We
    // store the last characters we generated because in the event of a collision,
    // we'll use those same characters except "incremented" by one.
    var lastRandChars = [];
    return function (now) {
        var duplicateTime = now === lastPushTime;
        lastPushTime = now;
        var i;
        var timeStampChars = new Array(8);
        for (i = 7; i >= 0; i--) {
            timeStampChars[i] = PUSH_CHARS.charAt(now % 64);
            // NOTE: Can't use << here because javascript will convert to int and lose
            // the upper bits.
            now = Math.floor(now / 64);
        }
        util_1.assert(now === 0, 'Cannot push at time == 0');
        var id = timeStampChars.join('');
        if (!duplicateTime) {
            for (i = 0; i < 12; i++) {
                lastRandChars[i] = Math.floor(Math.random() * 64);
            }
        }
        else {
            // If the timestamp hasn't changed since last push, use the same random
            // number, except incremented by 1.
            for (i = 11; i >= 0 && lastRandChars[i] === 63; i--) {
                lastRandChars[i] = 0;
            }
            lastRandChars[i]++;
        }
        for (i = 0; i < 12; i++) {
            id += PUSH_CHARS.charAt(lastRandChars[i]);
        }
        util_1.assert(id.length === 20, 'nextPushId: Length should be 20.');
        return id;
    };
})();

//# sourceMappingURL=NextPushId.js.map


/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var DataSnapshot_1 = __webpack_require__(269);
var Event_1 = __webpack_require__(1202);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
/**
 * Represents registration for 'value' events.
 */
var ValueEventRegistration = /** @class */ (function () {
    /**
     * @param {?function(!DataSnapshot)} callback_
     * @param {?function(Error)} cancelCallback_
     * @param {?Object} context_
     */
    function ValueEventRegistration(callback_, cancelCallback_, context_) {
        this.callback_ = callback_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.respondsTo = function (eventType) {
        return eventType === 'value';
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createEvent = function (change, query) {
        var index = query.getQueryParams().getIndex();
        return new Event_1.DataEvent('value', this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, query.getRef(), index));
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_1 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_1.call(ctx, eventData.error);
            };
        }
        else {
            var cb_1 = this.callback_;
            return function () {
                cb_1.call(ctx, eventData.snapshot);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new Event_1.CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.matches = function (other) {
        if (!(other instanceof ValueEventRegistration)) {
            return false;
        }
        else if (!other.callback_ || !this.callback_) {
            // If no callback specified, we consider it to match any callback.
            return true;
        }
        else {
            return (other.callback_ === this.callback_ && other.context_ === this.context_);
        }
    };
    /**
     * @inheritDoc
     */
    ValueEventRegistration.prototype.hasAnyCallback = function () {
        return this.callback_ !== null;
    };
    return ValueEventRegistration;
}());
exports.ValueEventRegistration = ValueEventRegistration;
/**
 * Represents the registration of 1 or more child_xxx events.
 *
 * Currently, it is always exactly 1 child_xxx event, but the idea is we might let you
 * register a group of callbacks together in the future.
 *
 * @constructor
 * @implements {EventRegistration}
 */
var ChildEventRegistration = /** @class */ (function () {
    /**
     * @param {?Object.<string, function(!DataSnapshot, ?string=)>} callbacks_
     * @param {?function(Error)} cancelCallback_
     * @param {Object=} context_
     */
    function ChildEventRegistration(callbacks_, cancelCallback_, context_) {
        this.callbacks_ = callbacks_;
        this.cancelCallback_ = cancelCallback_;
        this.context_ = context_;
    }
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.respondsTo = function (eventType) {
        var eventToCheck = eventType === 'children_added' ? 'child_added' : eventType;
        eventToCheck =
            eventToCheck === 'children_removed' ? 'child_removed' : eventToCheck;
        return util_1.contains(this.callbacks_, eventToCheck);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createCancelEvent = function (error, path) {
        if (this.cancelCallback_) {
            return new Event_1.CancelEvent(this, error, path);
        }
        else {
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.createEvent = function (change, query) {
        util_2.assert(change.childName != null, 'Child events should have a childName.');
        var ref = query.getRef().child(/** @type {!string} */ (change.childName));
        var index = query.getQueryParams().getIndex();
        return new Event_1.DataEvent(change.type, this, new DataSnapshot_1.DataSnapshot(change.snapshotNode, ref, index), change.prevName);
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.getEventRunner = function (eventData) {
        var ctx = this.context_;
        if (eventData.getEventType() === 'cancel') {
            util_2.assert(this.cancelCallback_, 'Raising a cancel event on a listener with no cancel callback');
            var cancelCB_2 = this.cancelCallback_;
            return function () {
                // We know that error exists, we checked above that this is a cancel event
                cancelCB_2.call(ctx, eventData.error);
            };
        }
        else {
            var cb_2 = this.callbacks_[eventData.eventType];
            return function () {
                cb_2.call(ctx, eventData.snapshot, eventData.prevName);
            };
        }
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.matches = function (other) {
        if (other instanceof ChildEventRegistration) {
            if (!this.callbacks_ || !other.callbacks_) {
                return true;
            }
            else if (this.context_ === other.context_) {
                var otherCount = util_1.getCount(other.callbacks_);
                var thisCount = util_1.getCount(this.callbacks_);
                if (otherCount === thisCount) {
                    // If count is 1, do an exact match on eventType, if either is defined but null, it's a match.
                    //  If event types don't match, not a match
                    // If count is not 1, exact match across all
                    if (otherCount === 1) {
                        var otherKey /** @type {!string} */ = util_1.getAnyKey(other.callbacks_);
                        var thisKey /** @type {!string} */ = util_1.getAnyKey(this.callbacks_);
                        return (thisKey === otherKey &&
                            (!other.callbacks_[otherKey] ||
                                !this.callbacks_[thisKey] ||
                                other.callbacks_[otherKey] === this.callbacks_[thisKey]));
                    }
                    else {
                        // Exact match on each key.
                        return util_1.every(this.callbacks_, function (eventType, cb) { return other.callbacks_[eventType] === cb; });
                    }
                }
            }
        }
        return false;
    };
    /**
     * @inheritDoc
     */
    ChildEventRegistration.prototype.hasAnyCallback = function () {
        return this.callbacks_ !== null;
    };
    return ChildEventRegistration;
}());
exports.ChildEventRegistration = ChildEventRegistration;

//# sourceMappingURL=EventRegistration.js.map


/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
/**
 * Encapsulates the data needed to raise an event
 * @implements {Event}
 */
var DataEvent = /** @class */ (function () {
    /**
     * @param {!string} eventType One of: value, child_added, child_changed, child_moved, child_removed
     * @param {!EventRegistration} eventRegistration The function to call to with the event data. User provided
     * @param {!DataSnapshot} snapshot The data backing the event
     * @param {?string=} prevName Optional, the name of the previous child for child_* events.
     */
    function DataEvent(eventType, eventRegistration, snapshot, prevName) {
        this.eventType = eventType;
        this.eventRegistration = eventRegistration;
        this.snapshot = snapshot;
        this.prevName = prevName;
    }
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getPath = function () {
        var ref = this.snapshot.getRef();
        if (this.eventType === 'value') {
            return ref.path;
        }
        else {
            return ref.getParent().path;
        }
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventType = function () {
        return this.eventType;
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    DataEvent.prototype.toString = function () {
        return (this.getPath().toString() +
            ':' +
            this.eventType +
            ':' +
            util_1.stringify(this.snapshot.exportVal()));
    };
    return DataEvent;
}());
exports.DataEvent = DataEvent;
var CancelEvent = /** @class */ (function () {
    /**
     * @param {EventRegistration} eventRegistration
     * @param {Error} error
     * @param {!Path} path
     */
    function CancelEvent(eventRegistration, error, path) {
        this.eventRegistration = eventRegistration;
        this.error = error;
        this.path = path;
    }
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getPath = function () {
        return this.path;
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventType = function () {
        return 'cancel';
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.getEventRunner = function () {
        return this.eventRegistration.getEventRunner(this);
    };
    /**
     * @inheritDoc
     */
    CancelEvent.prototype.toString = function () {
        return this.path.toString() + ':cancel';
    };
    return CancelEvent;
}());
exports.CancelEvent = CancelEvent;

//# sourceMappingURL=Event.js.map


/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var AckUserWrite_1 = __webpack_require__(1204);
var ChildrenNode_1 = __webpack_require__(49);
var util_3 = __webpack_require__(6);
var ImmutableTree_1 = __webpack_require__(270);
var ListenComplete_1 = __webpack_require__(1205);
var Merge_1 = __webpack_require__(1206);
var Operation_1 = __webpack_require__(95);
var Overwrite_1 = __webpack_require__(475);
var Path_1 = __webpack_require__(29);
var SyncPoint_1 = __webpack_require__(476);
var WriteTree_1 = __webpack_require__(1212);
/**
 * SyncTree is the central class for managing event callback registration, data caching, views
 * (query processing), and event generation.  There are typically two SyncTree instances for
 * each Repo, one for the normal Firebase data, and one for the .info data.
 *
 * It has a number of responsibilities, including:
 *  - Tracking all user event callbacks (registered via addEventRegistration() and removeEventRegistration()).
 *  - Applying and caching data changes for user set(), transaction(), and update() calls
 *    (applyUserOverwrite(), applyUserMerge()).
 *  - Applying and caching data changes for server data changes (applyServerOverwrite(),
 *    applyServerMerge()).
 *  - Generating user-facing events for server and user changes (all of the apply* methods
 *    return the set of events that need to be raised as a result).
 *  - Maintaining the appropriate set of server listens to ensure we are always subscribed
 *    to the correct set of paths and queries to satisfy the current set of user event
 *    callbacks (listens are started/stopped using the provided listenProvider).
 *
 * NOTE: Although SyncTree tracks event callbacks and calculates events to raise, the actual
 * events are returned to the caller rather than raised synchronously.
 *
 * @constructor
 */
var SyncTree = /** @class */ (function () {
    /**
     * @param {!ListenProvider} listenProvider_ Used by SyncTree to start / stop listening
     *   to server data.
     */
    function SyncTree(listenProvider_) {
        this.listenProvider_ = listenProvider_;
        /**
         * Tree of SyncPoints.  There's a SyncPoint at any location that has 1 or more views.
         * @type {!ImmutableTree.<!SyncPoint>}
         * @private
         */
        this.syncPointTree_ = ImmutableTree_1.ImmutableTree.Empty;
        /**
         * A tree of all pending user writes (user-initiated set()'s, transaction()'s, update()'s, etc.).
         * @type {!WriteTree}
         * @private
         */
        this.pendingWriteTree_ = new WriteTree_1.WriteTree();
        this.tagToQueryMap_ = {};
        this.queryToTagMap_ = {};
    }
    /**
     * Apply the data changes for a user-generated set() or transaction() call.
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @param {number} writeId
     * @param {boolean=} visible
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserOverwrite = function (path, newData, writeId, visible) {
        // Record pending write.
        this.pendingWriteTree_.addOverwrite(path, newData, writeId, visible);
        if (!visible) {
            return [];
        }
        else {
            return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.User, path, newData));
        }
    };
    /**
     * Apply the data from a user-generated update() call
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyUserMerge = function (path, changedChildren, writeId) {
        // Record pending merge.
        this.pendingWriteTree_.addMerge(path, changedChildren, writeId);
        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.User, path, changeTree));
    };
    /**
     * Acknowledge a pending user write that was previously registered with applyUserOverwrite() or applyUserMerge().
     *
     * @param {!number} writeId
     * @param {boolean=} revert True if the given write failed and needs to be reverted
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.ackUserWrite = function (writeId, revert) {
        if (revert === void 0) { revert = false; }
        var write = this.pendingWriteTree_.getWrite(writeId);
        var needToReevaluate = this.pendingWriteTree_.removeWrite(writeId);
        if (!needToReevaluate) {
            return [];
        }
        else {
            var affectedTree_1 = ImmutableTree_1.ImmutableTree.Empty;
            if (write.snap != null) {
                // overwrite
                affectedTree_1 = affectedTree_1.set(Path_1.Path.Empty, true);
            }
            else {
                util_3.forEach(write.children, function (pathString, node) {
                    affectedTree_1 = affectedTree_1.set(new Path_1.Path(pathString), node);
                });
            }
            return this.applyOperationToSyncPoints_(new AckUserWrite_1.AckUserWrite(write.path, affectedTree_1, revert));
        }
    };
    /**
     * Apply new server data for the specified path..
     *
     * @param {!Path} path
     * @param {!Node} newData
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerOverwrite = function (path, newData) {
        return this.applyOperationToSyncPoints_(new Overwrite_1.Overwrite(Operation_1.OperationSource.Server, path, newData));
    };
    /**
     * Apply new server data to be merged in at the specified path.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyServerMerge = function (path, changedChildren) {
        var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
        return this.applyOperationToSyncPoints_(new Merge_1.Merge(Operation_1.OperationSource.Server, path, changeTree));
    };
    /**
     * Apply a listen complete for a query
     *
     * @param {!Path} path
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyListenComplete = function (path) {
        return this.applyOperationToSyncPoints_(new ListenComplete_1.ListenComplete(Operation_1.OperationSource.Server, path));
    };
    /**
     * Apply new server data for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryOverwrite = function (path, snap, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey != null) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path_1.Path.relativePath(queryPath, path);
            var op = new Overwrite_1.Overwrite(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, snap);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // Query must have been removed already
            return [];
        }
    };
    /**
     * Apply server data to be merged in for the specified tagged query.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedQueryMerge = function (path, changedChildren, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path_1.Path.relativePath(queryPath, path);
            var changeTree = ImmutableTree_1.ImmutableTree.fromObject(changedChildren);
            var op = new Merge_1.Merge(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath, changeTree);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Apply a listen complete for a tagged query
     *
     * @param {!Path} path
     * @param {!number} tag
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.applyTaggedListenComplete = function (path, tag) {
        var queryKey = this.queryKeyForTag_(tag);
        if (queryKey) {
            var r = SyncTree.parseQueryKey_(queryKey);
            var queryPath = r.path, queryId = r.queryId;
            var relativePath = Path_1.Path.relativePath(queryPath, path);
            var op = new ListenComplete_1.ListenComplete(Operation_1.OperationSource.forServerTaggedQuery(queryId), relativePath);
            return this.applyTaggedOperation_(queryPath, op);
        }
        else {
            // We've already removed the query. No big deal, ignore the update
            return [];
        }
    };
    /**
     * Add an event callback for the specified query.
     *
     * @param {!Query} query
     * @param {!EventRegistration} eventRegistration
     * @return {!Array.<!Event>} Events to raise.
     */
    SyncTree.prototype.addEventRegistration = function (query, eventRegistration) {
        var path = query.path;
        var serverCache = null;
        var foundAncestorDefaultView = false;
        // Any covering writes will necessarily be at the root, so really all we need to find is the server cache.
        // Consider optimizing this once there's a better understanding of what actual behavior will be.
        this.syncPointTree_.foreachOnPath(path, function (pathToSyncPoint, sp) {
            var relativePath = Path_1.Path.relativePath(pathToSyncPoint, path);
            serverCache = serverCache || sp.getCompleteServerCache(relativePath);
            foundAncestorDefaultView =
                foundAncestorDefaultView || sp.hasCompleteView();
        });
        var syncPoint = this.syncPointTree_.get(path);
        if (!syncPoint) {
            syncPoint = new SyncPoint_1.SyncPoint();
            this.syncPointTree_ = this.syncPointTree_.set(path, syncPoint);
        }
        else {
            foundAncestorDefaultView =
                foundAncestorDefaultView || syncPoint.hasCompleteView();
            serverCache = serverCache || syncPoint.getCompleteServerCache(Path_1.Path.Empty);
        }
        var serverCacheComplete;
        if (serverCache != null) {
            serverCacheComplete = true;
        }
        else {
            serverCacheComplete = false;
            serverCache = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
            var subtree = this.syncPointTree_.subtree(path);
            subtree.foreachChild(function (childName, childSyncPoint) {
                var completeCache = childSyncPoint.getCompleteServerCache(Path_1.Path.Empty);
                if (completeCache) {
                    serverCache = serverCache.updateImmediateChild(childName, completeCache);
                }
            });
        }
        var viewAlreadyExists = syncPoint.viewExistsForQuery(query);
        if (!viewAlreadyExists && !query.getQueryParams().loadsAllData()) {
            // We need to track a tag for this query
            var queryKey = SyncTree.makeQueryKey_(query);
            util_1.assert(!(queryKey in this.queryToTagMap_), 'View does not exist, but we have a tag');
            var tag = SyncTree.getNextQueryTag_();
            this.queryToTagMap_[queryKey] = tag;
            // Coerce to string to avoid sparse arrays.
            this.tagToQueryMap_['_' + tag] = queryKey;
        }
        var writesCache = this.pendingWriteTree_.childWrites(path);
        var events = syncPoint.addEventRegistration(query, eventRegistration, writesCache, serverCache, serverCacheComplete);
        if (!viewAlreadyExists && !foundAncestorDefaultView) {
            var view /** @type !View */ = syncPoint.viewForQuery(query);
            events = events.concat(this.setupListener_(query, view));
        }
        return events;
    };
    /**
     * Remove event callback(s).
     *
     * If query is the default query, we'll check all queries for the specified eventRegistration.
     * If eventRegistration is null, we'll remove all callbacks for the specified query/queries.
     *
     * @param {!Query} query
     * @param {?EventRegistration} eventRegistration If null, all callbacks are removed.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    SyncTree.prototype.removeEventRegistration = function (query, eventRegistration, cancelError) {
        var _this = this;
        // Find the syncPoint first. Then deal with whether or not it has matching listeners
        var path = query.path;
        var maybeSyncPoint = this.syncPointTree_.get(path);
        var cancelEvents = [];
        // A removal on a default query affects all queries at that location. A removal on an indexed query, even one without
        // other query constraints, does *not* affect all queries at that location. So this check must be for 'default', and
        // not loadsAllData().
        if (maybeSyncPoint &&
            (query.queryIdentifier() === 'default' ||
                maybeSyncPoint.viewExistsForQuery(query))) {
            /**
             * @type {{removed: !Array.<!Query>, events: !Array.<!Event>}}
             */
            var removedAndEvents = maybeSyncPoint.removeEventRegistration(query, eventRegistration, cancelError);
            if (maybeSyncPoint.isEmpty()) {
                this.syncPointTree_ = this.syncPointTree_.remove(path);
            }
            var removed = removedAndEvents.removed;
            cancelEvents = removedAndEvents.events;
            // We may have just removed one of many listeners and can short-circuit this whole process
            // We may also not have removed a default listener, in which case all of the descendant listeners should already be
            // properly set up.
            //
            // Since indexed queries can shadow if they don't have other query constraints, check for loadsAllData(), instead of
            // queryId === 'default'
            var removingDefault = -1 !==
                removed.findIndex(function (query) {
                    return query.getQueryParams().loadsAllData();
                });
            var covered = this.syncPointTree_.findOnPath(path, function (relativePath, parentSyncPoint) {
                return parentSyncPoint.hasCompleteView();
            });
            if (removingDefault && !covered) {
                var subtree = this.syncPointTree_.subtree(path);
                // There are potentially child listeners. Determine what if any listens we need to send before executing the
                // removal
                if (!subtree.isEmpty()) {
                    // We need to fold over our subtree and collect the listeners to send
                    var newViews = this.collectDistinctViewsForSubTree_(subtree);
                    // Ok, we've collected all the listens we need. Set them up.
                    for (var i = 0; i < newViews.length; ++i) {
                        var view = newViews[i], newQuery = view.getQuery();
                        var listener = this.createListenerForView_(view);
                        this.listenProvider_.startListening(SyncTree.queryForListening_(newQuery), this.tagForQuery_(newQuery), listener.hashFn, listener.onComplete);
                    }
                }
                else {
                    // There's nothing below us, so nothing we need to start listening on
                }
            }
            // If we removed anything and we're not covered by a higher up listen, we need to stop listening on this query
            // The above block has us covered in terms of making sure we're set up on listens lower in the tree.
            // Also, note that if we have a cancelError, it's already been removed at the provider level.
            if (!covered && removed.length > 0 && !cancelError) {
                // If we removed a default, then we weren't listening on any of the other queries here. Just cancel the one
                // default. Otherwise, we need to iterate through and cancel each individual query
                if (removingDefault) {
                    // We don't tag default listeners
                    var defaultTag = null;
                    this.listenProvider_.stopListening(SyncTree.queryForListening_(query), defaultTag);
                }
                else {
                    removed.forEach(function (queryToRemove) {
                        var tagToRemove = _this.queryToTagMap_[SyncTree.makeQueryKey_(queryToRemove)];
                        _this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToRemove), tagToRemove);
                    });
                }
            }
            // Now, clear all of the tags we're tracking for the removed listens
            this.removeTags_(removed);
        }
        else {
            // No-op, this listener must've been already removed
        }
        return cancelEvents;
    };
    /**
     * Returns a complete cache, if we have one, of the data at a particular path. The location must have a listener above
     * it, but as this is only used by transaction code, that should always be the case anyways.
     *
     * Note: this method will *include* hidden writes from transaction with applyLocally set to false.
     * @param {!Path} path The path to the data we want
     * @param {Array.<number>=} writeIdsToExclude A specific set to be excluded
     * @return {?Node}
     */
    SyncTree.prototype.calcCompleteEventCache = function (path, writeIdsToExclude) {
        var includeHiddenSets = true;
        var writeTree = this.pendingWriteTree_;
        var serverCache = this.syncPointTree_.findOnPath(path, function (pathSoFar, syncPoint) {
            var relativePath = Path_1.Path.relativePath(pathSoFar, path);
            var serverCache = syncPoint.getCompleteServerCache(relativePath);
            if (serverCache) {
                return serverCache;
            }
        });
        return writeTree.calcCompleteEventCache(path, serverCache, writeIdsToExclude, includeHiddenSets);
    };
    /**
     * This collapses multiple unfiltered views into a single view, since we only need a single
     * listener for them.
     *
     * @param {!ImmutableTree.<!SyncPoint>} subtree
     * @return {!Array.<!View>}
     * @private
     */
    SyncTree.prototype.collectDistinctViewsForSubTree_ = function (subtree) {
        return subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
            if (maybeChildSyncPoint && maybeChildSyncPoint.hasCompleteView()) {
                var completeView = maybeChildSyncPoint.getCompleteView();
                return [completeView];
            }
            else {
                // No complete view here, flatten any deeper listens into an array
                var views_1 = [];
                if (maybeChildSyncPoint) {
                    views_1 = maybeChildSyncPoint.getQueryViews();
                }
                util_3.forEach(childMap, function (key, childViews) {
                    views_1 = views_1.concat(childViews);
                });
                return views_1;
            }
        });
    };
    /**
     * @param {!Array.<!Query>} queries
     * @private
     */
    SyncTree.prototype.removeTags_ = function (queries) {
        for (var j = 0; j < queries.length; ++j) {
            var removedQuery = queries[j];
            if (!removedQuery.getQueryParams().loadsAllData()) {
                // We should have a tag for this
                var removedQueryKey = SyncTree.makeQueryKey_(removedQuery);
                var removedQueryTag = this.queryToTagMap_[removedQueryKey];
                delete this.queryToTagMap_[removedQueryKey];
                delete this.tagToQueryMap_['_' + removedQueryTag];
            }
        }
    };
    /**
     * Normalizes a query to a query we send the server for listening
     * @param {!Query} query
     * @return {!Query} The normalized query
     * @private
     */
    SyncTree.queryForListening_ = function (query) {
        if (query.getQueryParams().loadsAllData() &&
            !query.getQueryParams().isDefault()) {
            // We treat queries that load all data as default queries
            // Cast is necessary because ref() technically returns Firebase which is actually fb.api.Firebase which inherits
            // from Query
            return /** @type {!Query} */ query.getRef();
        }
        else {
            return query;
        }
    };
    /**
     * For a given new listen, manage the de-duplication of outstanding subscriptions.
     *
     * @param {!Query} query
     * @param {!View} view
     * @return {!Array.<!Event>} This method can return events to support synchronous data sources
     * @private
     */
    SyncTree.prototype.setupListener_ = function (query, view) {
        var path = query.path;
        var tag = this.tagForQuery_(query);
        var listener = this.createListenerForView_(view);
        var events = this.listenProvider_.startListening(SyncTree.queryForListening_(query), tag, listener.hashFn, listener.onComplete);
        var subtree = this.syncPointTree_.subtree(path);
        // The root of this subtree has our query. We're here because we definitely need to send a listen for that, but we
        // may need to shadow other listens as well.
        if (tag) {
            util_1.assert(!subtree.value.hasCompleteView(), "If we're adding a query, it shouldn't be shadowed");
        }
        else {
            // Shadow everything at or below this location, this is a default listener.
            var queriesToStop = subtree.fold(function (relativePath, maybeChildSyncPoint, childMap) {
                if (!relativePath.isEmpty() &&
                    maybeChildSyncPoint &&
                    maybeChildSyncPoint.hasCompleteView()) {
                    return [maybeChildSyncPoint.getCompleteView().getQuery()];
                }
                else {
                    // No default listener here, flatten any deeper queries into an array
                    var queries_1 = [];
                    if (maybeChildSyncPoint) {
                        queries_1 = queries_1.concat(maybeChildSyncPoint.getQueryViews().map(function (view) { return view.getQuery(); }));
                    }
                    util_3.forEach(childMap, function (key, childQueries) {
                        queries_1 = queries_1.concat(childQueries);
                    });
                    return queries_1;
                }
            });
            for (var i = 0; i < queriesToStop.length; ++i) {
                var queryToStop = queriesToStop[i];
                this.listenProvider_.stopListening(SyncTree.queryForListening_(queryToStop), this.tagForQuery_(queryToStop));
            }
        }
        return events;
    };
    /**
     *
     * @param {!View} view
     * @return {{hashFn: function(), onComplete: function(!string, *)}}
     * @private
     */
    SyncTree.prototype.createListenerForView_ = function (view) {
        var _this = this;
        var query = view.getQuery();
        var tag = this.tagForQuery_(query);
        return {
            hashFn: function () {
                var cache = view.getServerCache() || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                return cache.hash();
            },
            onComplete: function (status) {
                if (status === 'ok') {
                    if (tag) {
                        return _this.applyTaggedListenComplete(query.path, tag);
                    }
                    else {
                        return _this.applyListenComplete(query.path);
                    }
                }
                else {
                    // If a listen failed, kill all of the listeners here, not just the one that triggered the error.
                    // Note that this may need to be scoped to just this listener if we change permissions on filtered children
                    var error = util_2.errorForServerCode(status, query);
                    return _this.removeEventRegistration(query, 
                    /*eventRegistration*/ null, error);
                }
            }
        };
    };
    /**
     * Given a query, computes a "queryKey" suitable for use in our queryToTagMap_.
     * @private
     * @param {!Query} query
     * @return {string}
     */
    SyncTree.makeQueryKey_ = function (query) {
        return query.path.toString() + '$' + query.queryIdentifier();
    };
    /**
     * Given a queryKey (created by makeQueryKey), parse it back into a path and queryId.
     * @private
     * @param {!string} queryKey
     * @return {{queryId: !string, path: !Path}}
     */
    SyncTree.parseQueryKey_ = function (queryKey) {
        var splitIndex = queryKey.indexOf('$');
        util_1.assert(splitIndex !== -1 && splitIndex < queryKey.length - 1, 'Bad queryKey.');
        return {
            queryId: queryKey.substr(splitIndex + 1),
            path: new Path_1.Path(queryKey.substr(0, splitIndex))
        };
    };
    /**
     * Return the query associated with the given tag, if we have one
     * @param {!number} tag
     * @return {?string}
     * @private
     */
    SyncTree.prototype.queryKeyForTag_ = function (tag) {
        return this.tagToQueryMap_['_' + tag];
    };
    /**
     * Return the tag associated with the given query.
     * @param {!Query} query
     * @return {?number}
     * @private
     */
    SyncTree.prototype.tagForQuery_ = function (query) {
        var queryKey = SyncTree.makeQueryKey_(query);
        return util_3.safeGet(this.queryToTagMap_, queryKey);
    };
    /**
     * Static accessor for query tags.
     * @return {number}
     * @private
     */
    SyncTree.getNextQueryTag_ = function () {
        return SyncTree.nextQueryTag_++;
    };
    /**
     * A helper method to apply tagged operations
     *
     * @param {!Path} queryPath
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyTaggedOperation_ = function (queryPath, operation) {
        var syncPoint = this.syncPointTree_.get(queryPath);
        util_1.assert(syncPoint, "Missing sync point for query tag that we're tracking");
        var writesCache = this.pendingWriteTree_.childWrites(queryPath);
        return syncPoint.applyOperation(operation, writesCache, 
        /*serverCache=*/ null);
    };
    /**
     * A helper method that visits all descendant and ancestor SyncPoints, applying the operation.
     *
     * NOTES:
     * - Descendant SyncPoints will be visited first (since we raise events depth-first).
  
     * - We call applyOperation() on each SyncPoint passing three things:
     *   1. A version of the Operation that has been made relative to the SyncPoint location.
     *   2. A WriteTreeRef of any writes we have cached at the SyncPoint location.
     *   3. A snapshot Node with cached server data, if we have it.
  
     * - We concatenate all of the events returned by each SyncPoint and return the result.
     *
     * @param {!Operation} operation
     * @return {!Array.<!Event>}
     * @private
     */
    SyncTree.prototype.applyOperationToSyncPoints_ = function (operation) {
        return this.applyOperationHelper_(operation, this.syncPointTree_, 
        /*serverCache=*/ null, this.pendingWriteTree_.childWrites(Path_1.Path.Empty));
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        if (operation.path.isEmpty()) {
            return this.applyOperationDescendantsHelper_(operation, syncPointTree, serverCache, writesCache);
        }
        else {
            var syncPoint = syncPointTree.get(Path_1.Path.Empty);
            // If we don't have cached server data, see if we can get it from this SyncPoint.
            if (serverCache == null && syncPoint != null) {
                serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
            }
            var events = [];
            var childName = operation.path.getFront();
            var childOperation = operation.operationForChild(childName);
            var childTree = syncPointTree.children.get(childName);
            if (childTree && childOperation) {
                var childServerCache = serverCache
                    ? serverCache.getImmediateChild(childName)
                    : null;
                var childWritesCache = writesCache.child(childName);
                events = events.concat(this.applyOperationHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
            if (syncPoint) {
                events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
            }
            return events;
        }
    };
    /**
     * Recursive helper for applyOperationToSyncPoints_
     *
     * @private
     * @param {!Operation} operation
     * @param {ImmutableTree.<!SyncPoint>} syncPointTree
     * @param {?Node} serverCache
     * @param {!WriteTreeRef} writesCache
     * @return {!Array.<!Event>}
     */
    SyncTree.prototype.applyOperationDescendantsHelper_ = function (operation, syncPointTree, serverCache, writesCache) {
        var _this = this;
        var syncPoint = syncPointTree.get(Path_1.Path.Empty);
        // If we don't have cached server data, see if we can get it from this SyncPoint.
        if (serverCache == null && syncPoint != null) {
            serverCache = syncPoint.getCompleteServerCache(Path_1.Path.Empty);
        }
        var events = [];
        syncPointTree.children.inorderTraversal(function (childName, childTree) {
            var childServerCache = serverCache
                ? serverCache.getImmediateChild(childName)
                : null;
            var childWritesCache = writesCache.child(childName);
            var childOperation = operation.operationForChild(childName);
            if (childOperation) {
                events = events.concat(_this.applyOperationDescendantsHelper_(childOperation, childTree, childServerCache, childWritesCache));
            }
        });
        if (syncPoint) {
            events = events.concat(syncPoint.applyOperation(operation, writesCache, serverCache));
        }
        return events;
    };
    /**
     * Static tracker for next query tag.
     * @type {number}
     * @private
     */
    SyncTree.nextQueryTag_ = 1;
    return SyncTree;
}());
exports.SyncTree = SyncTree;

//# sourceMappingURL=SyncTree.js.map


/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Path_1 = __webpack_require__(29);
var Operation_1 = __webpack_require__(95);
var AckUserWrite = /** @class */ (function () {
    /**
     *
     * @param {!Path} path
     * @param {!ImmutableTree<!boolean>} affectedTree A tree containing true for each affected path. Affected paths can't overlap.
     * @param {!boolean} revert
     */
    function AckUserWrite(
    /**@inheritDoc */ path, 
    /**@inheritDoc */ affectedTree, 
    /**@inheritDoc */ revert) {
        this.path = path;
        this.affectedTree = affectedTree;
        this.revert = revert;
        /** @inheritDoc */
        this.type = Operation_1.OperationType.ACK_USER_WRITE;
        /** @inheritDoc */
        this.source = Operation_1.OperationSource.User;
    }
    /**
     * @inheritDoc
     */
    AckUserWrite.prototype.operationForChild = function (childName) {
        if (!this.path.isEmpty()) {
            util_1.assert(this.path.getFront() === childName, 'operationForChild called for unrelated child.');
            return new AckUserWrite(this.path.popFront(), this.affectedTree, this.revert);
        }
        else if (this.affectedTree.value != null) {
            util_1.assert(this.affectedTree.children.isEmpty(), 'affectedTree should not have overlapping affected paths.');
            // All child locations are affected as well; just return same operation.
            return this;
        }
        else {
            var childTree = this.affectedTree.subtree(new Path_1.Path(childName));
            return new AckUserWrite(Path_1.Path.Empty, childTree, this.revert);
        }
    };
    return AckUserWrite;
}());
exports.AckUserWrite = AckUserWrite;

//# sourceMappingURL=AckUserWrite.js.map


/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Path_1 = __webpack_require__(29);
var Operation_1 = __webpack_require__(95);
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @constructor
 * @implements {Operation}
 */
var ListenComplete = /** @class */ (function () {
    function ListenComplete(source, path) {
        this.source = source;
        this.path = path;
        /** @inheritDoc */
        this.type = Operation_1.OperationType.LISTEN_COMPLETE;
    }
    ListenComplete.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            return new ListenComplete(this.source, Path_1.Path.Empty);
        }
        else {
            return new ListenComplete(this.source, this.path.popFront());
        }
    };
    return ListenComplete;
}());
exports.ListenComplete = ListenComplete;

//# sourceMappingURL=ListenComplete.js.map


/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = __webpack_require__(95);
var Overwrite_1 = __webpack_require__(475);
var Path_1 = __webpack_require__(29);
var util_1 = __webpack_require__(6);
/**
 * @param {!OperationSource} source
 * @param {!Path} path
 * @param {!ImmutableTree.<!Node>} children
 * @constructor
 * @implements {Operation}
 */
var Merge = /** @class */ (function () {
    function Merge(
    /**@inheritDoc */ source, 
    /**@inheritDoc */ path, 
    /**@inheritDoc */ children) {
        this.source = source;
        this.path = path;
        this.children = children;
        /** @inheritDoc */
        this.type = Operation_1.OperationType.MERGE;
    }
    /**
     * @inheritDoc
     */
    Merge.prototype.operationForChild = function (childName) {
        if (this.path.isEmpty()) {
            var childTree = this.children.subtree(new Path_1.Path(childName));
            if (childTree.isEmpty()) {
                // This child is unaffected
                return null;
            }
            else if (childTree.value) {
                // We have a snapshot for the child in question.  This becomes an overwrite of the child.
                return new Overwrite_1.Overwrite(this.source, Path_1.Path.Empty, childTree.value);
            }
            else {
                // This is a merge at a deeper level
                return new Merge(this.source, Path_1.Path.Empty, childTree);
            }
        }
        else {
            util_1.assert(this.path.getFront() === childName, "Can't get a merge for a child not on the path of the operation");
            return new Merge(this.source, this.path.popFront(), this.children);
        }
    };
    /**
     * @inheritDoc
     */
    Merge.prototype.toString = function () {
        return ('Operation(' +
            this.path +
            ': ' +
            this.source.toString() +
            ' merge: ' +
            this.children.toString() +
            ')');
    };
    return Merge;
}());
exports.Merge = Merge;

//# sourceMappingURL=Merge.js.map


/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var IndexedFilter_1 = __webpack_require__(271);
var ViewProcessor_1 = __webpack_require__(1208);
var ChildrenNode_1 = __webpack_require__(49);
var CacheNode_1 = __webpack_require__(188);
var ViewCache_1 = __webpack_require__(477);
var EventGenerator_1 = __webpack_require__(1211);
var util_1 = __webpack_require__(6);
var Operation_1 = __webpack_require__(95);
var Change_1 = __webpack_require__(119);
var PriorityIndex_1 = __webpack_require__(42);
/**
 * A view represents a specific location and query that has 1 or more event registrations.
 *
 * It does several things:
 *  - Maintains the list of event registrations for this location/query.
 *  - Maintains a cache of the data visible for this location/query.
 *  - Applies new operations (via applyOperation), updates the cache, and based on the event
 *    registrations returns the set of events to be raised.
 * @constructor
 */
var View = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     * @param {!ViewCache} initialViewCache
     */
    function View(query_, initialViewCache) {
        this.query_ = query_;
        this.eventRegistrations_ = [];
        var params = this.query_.getQueryParams();
        var indexFilter = new IndexedFilter_1.IndexedFilter(params.getIndex());
        var filter = params.getNodeFilter();
        /**
         * @type {ViewProcessor}
         * @private
         */
        this.processor_ = new ViewProcessor_1.ViewProcessor(filter);
        var initialServerCache = initialViewCache.getServerCache();
        var initialEventCache = initialViewCache.getEventCache();
        // Don't filter server node with other filter than index, wait for tagged listen
        var serverSnap = indexFilter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialServerCache.getNode(), null);
        var eventSnap = filter.updateFullNode(ChildrenNode_1.ChildrenNode.EMPTY_NODE, initialEventCache.getNode(), null);
        var newServerCache = new CacheNode_1.CacheNode(serverSnap, initialServerCache.isFullyInitialized(), indexFilter.filtersNodes());
        var newEventCache = new CacheNode_1.CacheNode(eventSnap, initialEventCache.isFullyInitialized(), filter.filtersNodes());
        /**
         * @type {!ViewCache}
         * @private
         */
        this.viewCache_ = new ViewCache_1.ViewCache(newEventCache, newServerCache);
        /**
         * @type {!EventGenerator}
         * @private
         */
        this.eventGenerator_ = new EventGenerator_1.EventGenerator(this.query_);
    }
    /**
     * @return {!Query}
     */
    View.prototype.getQuery = function () {
        return this.query_;
    };
    /**
     * @return {?Node}
     */
    View.prototype.getServerCache = function () {
        return this.viewCache_.getServerCache().getNode();
    };
    /**
     * @param {!Path} path
     * @return {?Node}
     */
    View.prototype.getCompleteServerCache = function (path) {
        var cache = this.viewCache_.getCompleteServerSnap();
        if (cache) {
            // If this isn't a "loadsAllData" view, then cache isn't actually a complete cache and
            // we need to see if it contains the child we're interested in.
            if (this.query_.getQueryParams().loadsAllData() ||
                (!path.isEmpty() && !cache.getImmediateChild(path.getFront()).isEmpty())) {
                return cache.getChild(path);
            }
        }
        return null;
    };
    /**
     * @return {boolean}
     */
    View.prototype.isEmpty = function () {
        return this.eventRegistrations_.length === 0;
    };
    /**
     * @param {!EventRegistration} eventRegistration
     */
    View.prototype.addEventRegistration = function (eventRegistration) {
        this.eventRegistrations_.push(eventRegistration);
    };
    /**
     * @param {?EventRegistration} eventRegistration If null, remove all callbacks.
     * @param {Error=} cancelError If a cancelError is provided, appropriate cancel events will be returned.
     * @return {!Array.<!Event>} Cancel events, if cancelError was provided.
     */
    View.prototype.removeEventRegistration = function (eventRegistration, cancelError) {
        var cancelEvents = [];
        if (cancelError) {
            util_1.assert(eventRegistration == null, 'A cancel should cancel all event registrations.');
            var path_1 = this.query_.path;
            this.eventRegistrations_.forEach(function (registration) {
                cancelError /** @type {!Error} */ = cancelError;
                var maybeEvent = registration.createCancelEvent(cancelError, path_1);
                if (maybeEvent) {
                    cancelEvents.push(maybeEvent);
                }
            });
        }
        if (eventRegistration) {
            var remaining = [];
            for (var i = 0; i < this.eventRegistrations_.length; ++i) {
                var existing = this.eventRegistrations_[i];
                if (!existing.matches(eventRegistration)) {
                    remaining.push(existing);
                }
                else if (eventRegistration.hasAnyCallback()) {
                    // We're removing just this one
                    remaining = remaining.concat(this.eventRegistrations_.slice(i + 1));
                    break;
                }
            }
            this.eventRegistrations_ = remaining;
        }
        else {
            this.eventRegistrations_ = [];
        }
        return cancelEvents;
    };
    /**
     * Applies the given Operation, updates our cache, and returns the appropriate events.
     *
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @return {!Array.<!Event>}
     */
    View.prototype.applyOperation = function (operation, writesCache, completeServerCache) {
        if (operation.type === Operation_1.OperationType.MERGE &&
            operation.source.queryId !== null) {
            util_1.assert(this.viewCache_.getCompleteServerSnap(), 'We should always have a full cache before handling merges');
            util_1.assert(this.viewCache_.getCompleteEventSnap(), 'Missing event cache, even though we have a server cache');
        }
        var oldViewCache = this.viewCache_;
        var result = this.processor_.applyOperation(oldViewCache, operation, writesCache, completeServerCache);
        this.processor_.assertIndexed(result.viewCache);
        util_1.assert(result.viewCache.getServerCache().isFullyInitialized() ||
            !oldViewCache.getServerCache().isFullyInitialized(), 'Once a server snap is complete, it should never go back');
        this.viewCache_ = result.viewCache;
        return this.generateEventsForChanges_(result.changes, result.viewCache.getEventCache().getNode(), null);
    };
    /**
     * @param {!EventRegistration} registration
     * @return {!Array.<!Event>}
     */
    View.prototype.getInitialEvents = function (registration) {
        var eventSnap = this.viewCache_.getEventCache();
        var initialChanges = [];
        if (!eventSnap.getNode().isLeafNode()) {
            var eventNode = eventSnap.getNode();
            eventNode.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (key, childNode) {
                initialChanges.push(Change_1.Change.childAddedChange(key, childNode));
            });
        }
        if (eventSnap.isFullyInitialized()) {
            initialChanges.push(Change_1.Change.valueChange(eventSnap.getNode()));
        }
        return this.generateEventsForChanges_(initialChanges, eventSnap.getNode(), registration);
    };
    /**
     * @private
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {EventRegistration=} eventRegistration
     * @return {!Array.<!Event>}
     */
    View.prototype.generateEventsForChanges_ = function (changes, eventCache, eventRegistration) {
        var registrations = eventRegistration
            ? [eventRegistration]
            : this.eventRegistrations_;
        return this.eventGenerator_.generateEventsForChanges(changes, eventCache, registrations);
    };
    return View;
}());
exports.View = View;

//# sourceMappingURL=View.js.map


/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Operation_1 = __webpack_require__(95);
var util_1 = __webpack_require__(6);
var ChildChangeAccumulator_1 = __webpack_require__(1209);
var Change_1 = __webpack_require__(119);
var ChildrenNode_1 = __webpack_require__(49);
var KeyIndex_1 = __webpack_require__(145);
var ImmutableTree_1 = __webpack_require__(270);
var Path_1 = __webpack_require__(29);
var CompleteChildSource_1 = __webpack_require__(1210);
/**
 * @constructor
 * @struct
 */
var ProcessorResult = /** @class */ (function () {
    /**
     * @param {!ViewCache} viewCache
     * @param {!Array.<!Change>} changes
     */
    function ProcessorResult(viewCache, changes) {
        this.viewCache = viewCache;
        this.changes = changes;
    }
    return ProcessorResult;
}());
exports.ProcessorResult = ProcessorResult;
/**
 * @constructor
 */
var ViewProcessor = /** @class */ (function () {
    /**
     * @param {!NodeFilter} filter_
     */
    function ViewProcessor(filter_) {
        this.filter_ = filter_;
    }
    /**
     * @param {!ViewCache} viewCache
     */
    ViewProcessor.prototype.assertIndexed = function (viewCache) {
        util_1.assert(viewCache
            .getEventCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Event snap not indexed');
        util_1.assert(viewCache
            .getServerCache()
            .getNode()
            .isIndexed(this.filter_.getIndex()), 'Server snap not indexed');
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Operation} operation
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @return {!ProcessorResult}
     */
    ViewProcessor.prototype.applyOperation = function (oldViewCache, operation, writesCache, completeCache) {
        var accumulator = new ChildChangeAccumulator_1.ChildChangeAccumulator();
        var newViewCache, filterServerNode;
        if (operation.type === Operation_1.OperationType.OVERWRITE) {
            var overwrite = operation;
            if (overwrite.source.fromUser) {
                newViewCache = this.applyUserOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, accumulator);
            }
            else {
                util_1.assert(overwrite.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered  and the
                // update is not at the root in which case it is ok (and necessary) to mark the node unfiltered
                // again
                filterServerNode =
                    overwrite.source.tagged ||
                        (oldViewCache.getServerCache().isFiltered() &&
                            !overwrite.path.isEmpty());
                newViewCache = this.applyServerOverwrite_(oldViewCache, overwrite.path, overwrite.snap, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === Operation_1.OperationType.MERGE) {
            var merge = operation;
            if (merge.source.fromUser) {
                newViewCache = this.applyUserMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, accumulator);
            }
            else {
                util_1.assert(merge.source.fromServer, 'Unknown source.');
                // We filter the node if it's a tagged update or the node has been previously filtered
                filterServerNode =
                    merge.source.tagged || oldViewCache.getServerCache().isFiltered();
                newViewCache = this.applyServerMerge_(oldViewCache, merge.path, merge.children, writesCache, completeCache, filterServerNode, accumulator);
            }
        }
        else if (operation.type === Operation_1.OperationType.ACK_USER_WRITE) {
            var ackUserWrite = operation;
            if (!ackUserWrite.revert) {
                newViewCache = this.ackUserWrite_(oldViewCache, ackUserWrite.path, ackUserWrite.affectedTree, writesCache, completeCache, accumulator);
            }
            else {
                newViewCache = this.revertUserWrite_(oldViewCache, ackUserWrite.path, writesCache, completeCache, accumulator);
            }
        }
        else if (operation.type === Operation_1.OperationType.LISTEN_COMPLETE) {
            newViewCache = this.listenComplete_(oldViewCache, operation.path, writesCache, accumulator);
        }
        else {
            throw util_1.assertionError('Unknown operation type: ' + operation.type);
        }
        var changes = accumulator.getChanges();
        ViewProcessor.maybeAddValueEvent_(oldViewCache, newViewCache, changes);
        return new ProcessorResult(newViewCache, changes);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!ViewCache} newViewCache
     * @param {!Array.<!Change>} accumulator
     * @private
     */
    ViewProcessor.maybeAddValueEvent_ = function (oldViewCache, newViewCache, accumulator) {
        var eventSnap = newViewCache.getEventCache();
        if (eventSnap.isFullyInitialized()) {
            var isLeafOrEmpty = eventSnap.getNode().isLeafNode() || eventSnap.getNode().isEmpty();
            var oldCompleteSnap = oldViewCache.getCompleteEventSnap();
            if (accumulator.length > 0 ||
                !oldViewCache.getEventCache().isFullyInitialized() ||
                (isLeafOrEmpty &&
                    !eventSnap
                        .getNode()
                        .equals(/** @type {!Node} */ (oldCompleteSnap))) ||
                !eventSnap
                    .getNode()
                    .getPriority()
                    .equals(oldCompleteSnap.getPriority())) {
                accumulator.push(Change_1.Change.valueChange(
                /** @type {!Node} */ newViewCache.getCompleteEventSnap()));
            }
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} changePath
     * @param {!WriteTreeRef} writesCache
     * @param {!CompleteChildSource} source
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.generateEventCacheAfterServerEvent_ = function (viewCache, changePath, writesCache, source, accumulator) {
        var oldEventSnap = viewCache.getEventCache();
        if (writesCache.shadowingWrite(changePath) != null) {
            // we have a shadowing write, ignore changes
            return viewCache;
        }
        else {
            var newEventCache = void 0, serverNode = void 0;
            if (changePath.isEmpty()) {
                // TODO: figure out how this plays with "sliding ack windows"
                util_1.assert(viewCache.getServerCache().isFullyInitialized(), 'If change path is empty, we must have complete server data');
                if (viewCache.getServerCache().isFiltered()) {
                    // We need to special case this, because we need to only apply writes to complete children, or
                    // we might end up raising events for incomplete children. If the server data is filtered deep
                    // writes cannot be guaranteed to be complete
                    var serverCache = viewCache.getCompleteServerSnap();
                    var completeChildren = serverCache instanceof ChildrenNode_1.ChildrenNode
                        ? serverCache
                        : ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                    var completeEventChildren = writesCache.calcCompleteEventChildren(completeChildren);
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeEventChildren, accumulator);
                }
                else {
                    var completeNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    newEventCache = this.filter_.updateFullNode(viewCache.getEventCache().getNode(), completeNode, accumulator);
                }
            }
            else {
                var childKey = changePath.getFront();
                if (childKey == '.priority') {
                    util_1.assert(changePath.getLength() == 1, "Can't have a priority with additional path components");
                    var oldEventNode = oldEventSnap.getNode();
                    serverNode = viewCache.getServerCache().getNode();
                    // we might have overwrites for this priority
                    var updatedPriority = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventNode, serverNode);
                    if (updatedPriority != null) {
                        newEventCache = this.filter_.updatePriority(oldEventNode, updatedPriority);
                    }
                    else {
                        // priority didn't change, keep old node
                        newEventCache = oldEventSnap.getNode();
                    }
                }
                else {
                    var childChangePath = changePath.popFront();
                    // update child
                    var newEventChild = void 0;
                    if (oldEventSnap.isCompleteForChild(childKey)) {
                        serverNode = viewCache.getServerCache().getNode();
                        var eventChildUpdate = writesCache.calcEventCacheAfterServerOverwrite(changePath, oldEventSnap.getNode(), serverNode);
                        if (eventChildUpdate != null) {
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey)
                                .updateChild(childChangePath, eventChildUpdate);
                        }
                        else {
                            // Nothing changed, just keep the old child
                            newEventChild = oldEventSnap
                                .getNode()
                                .getImmediateChild(childKey);
                        }
                    }
                    else {
                        newEventChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                    }
                    if (newEventChild != null) {
                        newEventCache = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newEventChild, childChangePath, source, accumulator);
                    }
                    else {
                        // no complete child available or no change
                        newEventCache = oldEventSnap.getNode();
                    }
                }
            }
            return viewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized() || changePath.isEmpty(), this.filter_.filtersNodes());
        }
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, filterServerNode, accumulator) {
        var oldServerSnap = oldViewCache.getServerCache();
        var newServerCache;
        var serverFilter = filterServerNode
            ? this.filter_
            : this.filter_.getIndexedFilter();
        if (changePath.isEmpty()) {
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), changedSnap, null);
        }
        else if (serverFilter.filtersNodes() && !oldServerSnap.isFiltered()) {
            // we want to filter the server node, but we didn't filter the server node yet, so simulate a full update
            var newServerNode = oldServerSnap
                .getNode()
                .updateChild(changePath, changedSnap);
            newServerCache = serverFilter.updateFullNode(oldServerSnap.getNode(), newServerNode, null);
        }
        else {
            var childKey = changePath.getFront();
            if (!oldServerSnap.isCompleteForPath(changePath) &&
                changePath.getLength() > 1) {
                // We don't update incomplete nodes with updates intended for other listeners
                return oldViewCache;
            }
            var childChangePath = changePath.popFront();
            var childNode = oldServerSnap.getNode().getImmediateChild(childKey);
            var newChildNode = childNode.updateChild(childChangePath, changedSnap);
            if (childKey == '.priority') {
                newServerCache = serverFilter.updatePriority(oldServerSnap.getNode(), newChildNode);
            }
            else {
                newServerCache = serverFilter.updateChild(oldServerSnap.getNode(), childKey, newChildNode, childChangePath, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, null);
            }
        }
        var newViewCache = oldViewCache.updateServerSnap(newServerCache, oldServerSnap.isFullyInitialized() || changePath.isEmpty(), serverFilter.filtersNodes());
        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, newViewCache, completeCache);
        return this.generateEventCacheAfterServerEvent_(newViewCache, changePath, writesCache, source, accumulator);
    };
    /**
     * @param {!ViewCache} oldViewCache
     * @param {!Path} changePath
     * @param {!Node} changedSnap
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserOverwrite_ = function (oldViewCache, changePath, changedSnap, writesCache, completeCache, accumulator) {
        var oldEventSnap = oldViewCache.getEventCache();
        var newViewCache, newEventCache;
        var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, oldViewCache, completeCache);
        if (changePath.isEmpty()) {
            newEventCache = this.filter_.updateFullNode(oldViewCache.getEventCache().getNode(), changedSnap, accumulator);
            newViewCache = oldViewCache.updateEventSnap(newEventCache, true, this.filter_.filtersNodes());
        }
        else {
            var childKey = changePath.getFront();
            if (childKey === '.priority') {
                newEventCache = this.filter_.updatePriority(oldViewCache.getEventCache().getNode(), changedSnap);
                newViewCache = oldViewCache.updateEventSnap(newEventCache, oldEventSnap.isFullyInitialized(), oldEventSnap.isFiltered());
            }
            else {
                var childChangePath = changePath.popFront();
                var oldChild = oldEventSnap.getNode().getImmediateChild(childKey);
                var newChild = void 0;
                if (childChangePath.isEmpty()) {
                    // Child overwrite, we can replace the child
                    newChild = changedSnap;
                }
                else {
                    var childNode = source.getCompleteChild(childKey);
                    if (childNode != null) {
                        if (childChangePath.getBack() === '.priority' &&
                            childNode.getChild(childChangePath.parent()).isEmpty()) {
                            // This is a priority update on an empty node. If this node exists on the server, the
                            // server will send down the priority in the update, so ignore for now
                            newChild = childNode;
                        }
                        else {
                            newChild = childNode.updateChild(childChangePath, changedSnap);
                        }
                    }
                    else {
                        // There is no complete child node available
                        newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                    }
                }
                if (!oldChild.equals(newChild)) {
                    var newEventSnap = this.filter_.updateChild(oldEventSnap.getNode(), childKey, newChild, childChangePath, source, accumulator);
                    newViewCache = oldViewCache.updateEventSnap(newEventSnap, oldEventSnap.isFullyInitialized(), this.filter_.filtersNodes());
                }
                else {
                    newViewCache = oldViewCache;
                }
            }
        }
        return newViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {string} childKey
     * @return {boolean}
     * @private
     */
    ViewProcessor.cacheHasChild_ = function (viewCache, childKey) {
        return viewCache.getEventCache().isCompleteForChild(childKey);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyUserMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, accumulator) {
        var _this = this;
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        changedChildren.foreach(function (relativePath, childNode) {
            var writePath = path.child(relativePath);
            if (!ViewProcessor.cacheHasChild_(viewCache, writePath.getFront())) {
                curViewCache = _this.applyUserOverwrite_(curViewCache, writePath, childNode, writesCache, serverCache, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!Node} node
     * @param {ImmutableTree.<!Node>} merge
     * @return {!Node}
     * @private
     */
    ViewProcessor.prototype.applyMerge_ = function (node, merge) {
        merge.foreach(function (relativePath, childNode) {
            node = node.updateChild(relativePath, childNode);
        });
        return node;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!ImmutableTree.<!Node>} changedChildren
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} serverCache
     * @param {boolean} filterServerNode
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.applyServerMerge_ = function (viewCache, path, changedChildren, writesCache, serverCache, filterServerNode, accumulator) {
        var _this = this;
        // If we don't have a cache yet, this merge was intended for a previously listen in the same location. Ignore it and
        // wait for the complete data update coming soon.
        if (viewCache
            .getServerCache()
            .getNode()
            .isEmpty() &&
            !viewCache.getServerCache().isFullyInitialized()) {
            return viewCache;
        }
        // HACK: In the case of a limit query, there may be some changes that bump things out of the
        // window leaving room for new items.  It's important we process these changes first, so we
        // iterate the changes twice, first processing any that affect items currently in view.
        // TODO: I consider an item "in view" if cacheHasChild is true, which checks both the server
        // and event snap.  I'm not sure if this will result in edge cases when a child is in one but
        // not the other.
        var curViewCache = viewCache;
        var viewMergeTree;
        if (path.isEmpty()) {
            viewMergeTree = changedChildren;
        }
        else {
            viewMergeTree = ImmutableTree_1.ImmutableTree.Empty.setTree(path, changedChildren);
        }
        var serverNode = viewCache.getServerCache().getNode();
        viewMergeTree.children.inorderTraversal(function (childKey, childTree) {
            if (serverNode.hasChild(childKey)) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        viewMergeTree.children.inorderTraversal(function (childKey, childMergeTree) {
            var isUnknownDeepMerge = !viewCache.getServerCache().isCompleteForChild(childKey) &&
                childMergeTree.value == null;
            if (!serverNode.hasChild(childKey) && !isUnknownDeepMerge) {
                var serverChild = viewCache
                    .getServerCache()
                    .getNode()
                    .getImmediateChild(childKey);
                var newChild = _this.applyMerge_(serverChild, childMergeTree);
                curViewCache = _this.applyServerOverwrite_(curViewCache, new Path_1.Path(childKey), newChild, writesCache, serverCache, filterServerNode, accumulator);
            }
        });
        return curViewCache;
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} ackPath
     * @param {!ImmutableTree<!boolean>} affectedTree
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.ackUserWrite_ = function (viewCache, ackPath, affectedTree, writesCache, completeCache, accumulator) {
        if (writesCache.shadowingWrite(ackPath) != null) {
            return viewCache;
        }
        // Only filter server node if it is currently filtered
        var filterServerNode = viewCache.getServerCache().isFiltered();
        // Essentially we'll just get our existing server cache for the affected paths and re-apply it as a server update
        // now that it won't be shadowed.
        var serverCache = viewCache.getServerCache();
        if (affectedTree.value != null) {
            // This is an overwrite.
            if ((ackPath.isEmpty() && serverCache.isFullyInitialized()) ||
                serverCache.isCompleteForPath(ackPath)) {
                return this.applyServerOverwrite_(viewCache, ackPath, serverCache.getNode().getChild(ackPath), writesCache, completeCache, filterServerNode, accumulator);
            }
            else if (ackPath.isEmpty()) {
                // This is a goofy edge case where we are acking data at this location but don't have full data.  We
                // should just re-apply whatever we have in our cache as a merge.
                var changedChildren_1 = ImmutableTree_1.ImmutableTree.Empty;
                serverCache.getNode().forEachChild(KeyIndex_1.KEY_INDEX, function (name, node) {
                    changedChildren_1 = changedChildren_1.set(new Path_1.Path(name), node);
                });
                return this.applyServerMerge_(viewCache, ackPath, changedChildren_1, writesCache, completeCache, filterServerNode, accumulator);
            }
            else {
                return viewCache;
            }
        }
        else {
            // This is a merge.
            var changedChildren_2 = ImmutableTree_1.ImmutableTree.Empty;
            affectedTree.foreach(function (mergePath, value) {
                var serverCachePath = ackPath.child(mergePath);
                if (serverCache.isCompleteForPath(serverCachePath)) {
                    changedChildren_2 = changedChildren_2.set(mergePath, serverCache.getNode().getChild(serverCachePath));
                }
            });
            return this.applyServerMerge_(viewCache, ackPath, changedChildren_2, writesCache, completeCache, filterServerNode, accumulator);
        }
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.listenComplete_ = function (viewCache, path, writesCache, accumulator) {
        var oldServerNode = viewCache.getServerCache();
        var newViewCache = viewCache.updateServerSnap(oldServerNode.getNode(), oldServerNode.isFullyInitialized() || path.isEmpty(), oldServerNode.isFiltered());
        return this.generateEventCacheAfterServerEvent_(newViewCache, path, writesCache, CompleteChildSource_1.NO_COMPLETE_CHILD_SOURCE, accumulator);
    };
    /**
     * @param {!ViewCache} viewCache
     * @param {!Path} path
     * @param {!WriteTreeRef} writesCache
     * @param {?Node} completeServerCache
     * @param {!ChildChangeAccumulator} accumulator
     * @return {!ViewCache}
     * @private
     */
    ViewProcessor.prototype.revertUserWrite_ = function (viewCache, path, writesCache, completeServerCache, accumulator) {
        var complete;
        if (writesCache.shadowingWrite(path) != null) {
            return viewCache;
        }
        else {
            var source = new CompleteChildSource_1.WriteTreeCompleteChildSource(writesCache, viewCache, completeServerCache);
            var oldEventCache = viewCache.getEventCache().getNode();
            var newEventCache = void 0;
            if (path.isEmpty() || path.getFront() === '.priority') {
                var newNode = void 0;
                if (viewCache.getServerCache().isFullyInitialized()) {
                    newNode = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                }
                else {
                    var serverChildren = viewCache.getServerCache().getNode();
                    util_1.assert(serverChildren instanceof ChildrenNode_1.ChildrenNode, 'serverChildren would be complete if leaf node');
                    newNode = writesCache.calcCompleteEventChildren(serverChildren);
                }
                newNode = newNode;
                newEventCache = this.filter_.updateFullNode(oldEventCache, newNode, accumulator);
            }
            else {
                var childKey = path.getFront();
                var newChild = writesCache.calcCompleteChild(childKey, viewCache.getServerCache());
                if (newChild == null &&
                    viewCache.getServerCache().isCompleteForChild(childKey)) {
                    newChild = oldEventCache.getImmediateChild(childKey);
                }
                if (newChild != null) {
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, newChild, path.popFront(), source, accumulator);
                }
                else if (viewCache
                    .getEventCache()
                    .getNode()
                    .hasChild(childKey)) {
                    // No complete child available, delete the existing one, if any
                    newEventCache = this.filter_.updateChild(oldEventCache, childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE, path.popFront(), source, accumulator);
                }
                else {
                    newEventCache = oldEventCache;
                }
                if (newEventCache.isEmpty() &&
                    viewCache.getServerCache().isFullyInitialized()) {
                    // We might have reverted all child writes. Maybe the old event was a leaf node
                    complete = writesCache.calcCompleteEventCache(viewCache.getCompleteServerSnap());
                    if (complete.isLeafNode()) {
                        newEventCache = this.filter_.updateFullNode(newEventCache, complete, accumulator);
                    }
                }
            }
            complete =
                viewCache.getServerCache().isFullyInitialized() ||
                    writesCache.shadowingWrite(Path_1.Path.Empty) != null;
            return viewCache.updateEventSnap(newEventCache, complete, this.filter_.filtersNodes());
        }
    };
    return ViewProcessor;
}());
exports.ViewProcessor = ViewProcessor;

//# sourceMappingURL=ViewProcessor.js.map


/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Change_1 = __webpack_require__(119);
var util_2 = __webpack_require__(6);
/**
 * @constructor
 */
var ChildChangeAccumulator = /** @class */ (function () {
    function ChildChangeAccumulator() {
        this.changeMap_ = {};
    }
    /**
     * @param {!Change} change
     */
    ChildChangeAccumulator.prototype.trackChildChange = function (change) {
        var type = change.type;
        var childKey /** @type {!string} */ = change.childName;
        util_2.assert(type == Change_1.Change.CHILD_ADDED ||
            type == Change_1.Change.CHILD_CHANGED ||
            type == Change_1.Change.CHILD_REMOVED, 'Only child changes supported for tracking');
        util_2.assert(childKey !== '.priority', 'Only non-priority child changes can be tracked.');
        var oldChange = util_1.safeGet(this.changeMap_, childKey);
        if (oldChange) {
            var oldType = oldChange.type;
            if (type == Change_1.Change.CHILD_ADDED && oldType == Change_1.Change.CHILD_REMOVED) {
                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.snapshotNode);
            }
            else if (type == Change_1.Change.CHILD_REMOVED &&
                oldType == Change_1.Change.CHILD_ADDED) {
                delete this.changeMap_[childKey];
            }
            else if (type == Change_1.Change.CHILD_REMOVED &&
                oldType == Change_1.Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change_1.Change.childRemovedChange(childKey, oldChange.oldSnap);
            }
            else if (type == Change_1.Change.CHILD_CHANGED &&
                oldType == Change_1.Change.CHILD_ADDED) {
                this.changeMap_[childKey] = Change_1.Change.childAddedChange(childKey, change.snapshotNode);
            }
            else if (type == Change_1.Change.CHILD_CHANGED &&
                oldType == Change_1.Change.CHILD_CHANGED) {
                this.changeMap_[childKey] = Change_1.Change.childChangedChange(childKey, change.snapshotNode, oldChange.oldSnap);
            }
            else {
                throw util_2.assertionError('Illegal combination of changes: ' +
                    change +
                    ' occurred after ' +
                    oldChange);
            }
        }
        else {
            this.changeMap_[childKey] = change;
        }
    };
    /**
     * @return {!Array.<!Change>}
     */
    ChildChangeAccumulator.prototype.getChanges = function () {
        return util_1.getValues(this.changeMap_);
    };
    return ChildChangeAccumulator;
}());
exports.ChildChangeAccumulator = ChildChangeAccumulator;

//# sourceMappingURL=ChildChangeAccumulator.js.map


/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var CacheNode_1 = __webpack_require__(188);
/**
 * An implementation of CompleteChildSource that never returns any additional children
 *
 * @private
 * @constructor
 * @implements CompleteChildSource
 */
var NoCompleteChildSource_ = /** @class */ (function () {
    function NoCompleteChildSource_() {
    }
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getCompleteChild = function (childKey) {
        return null;
    };
    /**
     * @inheritDoc
     */
    NoCompleteChildSource_.prototype.getChildAfterChild = function (index, child, reverse) {
        return null;
    };
    return NoCompleteChildSource_;
}());
exports.NoCompleteChildSource_ = NoCompleteChildSource_;
/**
 * Singleton instance.
 * @const
 * @type {!CompleteChildSource}
 */
exports.NO_COMPLETE_CHILD_SOURCE = new NoCompleteChildSource_();
/**
 * An implementation of CompleteChildSource that uses a WriteTree in addition to any other server data or
 * old event caches available to calculate complete children.
 *
 *
 * @implements CompleteChildSource
 */
var WriteTreeCompleteChildSource = /** @class */ (function () {
    /**
     * @param {!WriteTreeRef} writes_
     * @param {!ViewCache} viewCache_
     * @param {?Node} optCompleteServerCache_
     */
    function WriteTreeCompleteChildSource(writes_, viewCache_, optCompleteServerCache_) {
        if (optCompleteServerCache_ === void 0) { optCompleteServerCache_ = null; }
        this.writes_ = writes_;
        this.viewCache_ = viewCache_;
        this.optCompleteServerCache_ = optCompleteServerCache_;
    }
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getCompleteChild = function (childKey) {
        var node = this.viewCache_.getEventCache();
        if (node.isCompleteForChild(childKey)) {
            return node.getNode().getImmediateChild(childKey);
        }
        else {
            var serverNode = this.optCompleteServerCache_ != null
                ? new CacheNode_1.CacheNode(this.optCompleteServerCache_, true, false)
                : this.viewCache_.getServerCache();
            return this.writes_.calcCompleteChild(childKey, serverNode);
        }
    };
    /**
     * @inheritDoc
     */
    WriteTreeCompleteChildSource.prototype.getChildAfterChild = function (index, child, reverse) {
        var completeServerData = this.optCompleteServerCache_ != null
            ? this.optCompleteServerCache_
            : this.viewCache_.getCompleteServerSnap();
        var nodes = this.writes_.calcIndexedSlice(completeServerData, child, 1, reverse, index);
        if (nodes.length === 0) {
            return null;
        }
        else {
            return nodes[0];
        }
    };
    return WriteTreeCompleteChildSource;
}());
exports.WriteTreeCompleteChildSource = WriteTreeCompleteChildSource;

//# sourceMappingURL=CompleteChildSource.js.map


/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Node_1 = __webpack_require__(53);
var Change_1 = __webpack_require__(119);
var util_1 = __webpack_require__(6);
/**
 * An EventGenerator is used to convert "raw" changes (Change) as computed by the
 * CacheDiffer into actual events (Event) that can be raised.  See generateEventsForChanges()
 * for details.
 *
 * @constructor
 */
var EventGenerator = /** @class */ (function () {
    /**
     *
     * @param {!Query} query_
     */
    function EventGenerator(query_) {
        this.query_ = query_;
        /**
         * @private
         * @type {!Index}
         */
        this.index_ = this.query_.getQueryParams().getIndex();
    }
    /**
     * Given a set of raw changes (no moved events and prevName not specified yet), and a set of
     * EventRegistrations that should be notified of these changes, generate the actual events to be raised.
     *
     * Notes:
     *  - child_moved events will be synthesized at this time for any child_changed events that affect
     *    our index.
     *  - prevName will be calculated based on the index ordering.
     *
     * @param {!Array.<!Change>} changes
     * @param {!Node} eventCache
     * @param {!Array.<!EventRegistration>} eventRegistrations
     * @return {!Array.<!Event>}
     */
    EventGenerator.prototype.generateEventsForChanges = function (changes, eventCache, eventRegistrations) {
        var _this = this;
        var events = [];
        var moves = [];
        changes.forEach(function (change) {
            if (change.type === Change_1.Change.CHILD_CHANGED &&
                _this.index_.indexedValueChanged(change.oldSnap, change.snapshotNode)) {
                moves.push(Change_1.Change.childMovedChange(change.childName, change.snapshotNode));
            }
        });
        this.generateEventsForType_(events, Change_1.Change.CHILD_REMOVED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change_1.Change.CHILD_ADDED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change_1.Change.CHILD_MOVED, moves, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change_1.Change.CHILD_CHANGED, changes, eventRegistrations, eventCache);
        this.generateEventsForType_(events, Change_1.Change.VALUE, changes, eventRegistrations, eventCache);
        return events;
    };
    /**
     * Given changes of a single change type, generate the corresponding events.
     *
     * @param {!Array.<!Event>} events
     * @param {!string} eventType
     * @param {!Array.<!Change>} changes
     * @param {!Array.<!EventRegistration>} registrations
     * @param {!Node} eventCache
     * @private
     */
    EventGenerator.prototype.generateEventsForType_ = function (events, eventType, changes, registrations, eventCache) {
        var _this = this;
        var filteredChanges = changes.filter(function (change) { return change.type === eventType; });
        filteredChanges.sort(this.compareChanges_.bind(this));
        filteredChanges.forEach(function (change) {
            var materializedChange = _this.materializeSingleChange_(change, eventCache);
            registrations.forEach(function (registration) {
                if (registration.respondsTo(change.type)) {
                    events.push(registration.createEvent(materializedChange, _this.query_));
                }
            });
        });
    };
    /**
     * @param {!Change} change
     * @param {!Node} eventCache
     * @return {!Change}
     * @private
     */
    EventGenerator.prototype.materializeSingleChange_ = function (change, eventCache) {
        if (change.type === 'value' || change.type === 'child_removed') {
            return change;
        }
        else {
            change.prevName = eventCache.getPredecessorChildName(
            /** @type {!string} */
            change.childName, change.snapshotNode, this.index_);
            return change;
        }
    };
    /**
     * @param {!Change} a
     * @param {!Change} b
     * @return {number}
     * @private
     */
    EventGenerator.prototype.compareChanges_ = function (a, b) {
        if (a.childName == null || b.childName == null) {
            throw util_1.assertionError('Should only compare child_ events.');
        }
        var aWrapped = new Node_1.NamedNode(a.childName, a.snapshotNode);
        var bWrapped = new Node_1.NamedNode(b.childName, b.snapshotNode);
        return this.index_.compare(aWrapped, bWrapped);
    };
    return EventGenerator;
}());
exports.EventGenerator = EventGenerator;

//# sourceMappingURL=EventGenerator.js.map


/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
var Path_1 = __webpack_require__(29);
var CompoundWrite_1 = __webpack_require__(1213);
var PriorityIndex_1 = __webpack_require__(42);
var ChildrenNode_1 = __webpack_require__(49);
/**
 * WriteTree tracks all pending user-initiated writes and has methods to calculate the result of merging them
 * with underlying server data (to create "event cache" data).  Pending writes are added with addOverwrite()
 * and addMerge(), and removed with removeWrite().
 *
 * @constructor
 */
var WriteTree = /** @class */ (function () {
    function WriteTree() {
        /**
         * A tree tracking the result of applying all visible writes.  This does not include transactions with
         * applyLocally=false or writes that are completely shadowed by other writes.
         *
         * @type {!CompoundWrite}
         * @private
         */
        this.visibleWrites_ = CompoundWrite_1.CompoundWrite.Empty;
        /**
         * A list of all pending writes, regardless of visibility and shadowed-ness.  Used to calculate arbitrary
         * sets of the changed data, such as hidden writes (from transactions) or changes with certain writes excluded (also
         * used by transactions).
         *
         * @type {!Array.<!WriteRecord>}
         * @private
         */
        this.allWrites_ = [];
        this.lastWriteId_ = -1;
    }
    /**
     * Create a new WriteTreeRef for the given path. For use with a new sync point at the given path.
     *
     * @param {!Path} path
     * @return {!WriteTreeRef}
     */
    WriteTree.prototype.childWrites = function (path) {
        return new WriteTreeRef(path, this);
    };
    /**
     * Record a new overwrite from user code.
     *
     * @param {!Path} path
     * @param {!Node} snap
     * @param {!number} writeId
     * @param {boolean=} visible This is set to false by some transactions. It should be excluded from event caches
     */
    WriteTree.prototype.addOverwrite = function (path, snap, writeId, visible) {
        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older write on top of newer ones');
        if (visible === undefined) {
            visible = true;
        }
        this.allWrites_.push({
            path: path,
            snap: snap,
            writeId: writeId,
            visible: visible
        });
        if (visible) {
            this.visibleWrites_ = this.visibleWrites_.addWrite(path, snap);
        }
        this.lastWriteId_ = writeId;
    };
    /**
     * Record a new merge from user code.
     *
     * @param {!Path} path
     * @param {!Object.<string, !Node>} changedChildren
     * @param {!number} writeId
     */
    WriteTree.prototype.addMerge = function (path, changedChildren, writeId) {
        util_2.assert(writeId > this.lastWriteId_, 'Stacking an older merge on top of newer ones');
        this.allWrites_.push({
            path: path,
            children: changedChildren,
            writeId: writeId,
            visible: true
        });
        this.visibleWrites_ = this.visibleWrites_.addWrites(path, changedChildren);
        this.lastWriteId_ = writeId;
    };
    /**
     * @param {!number} writeId
     * @return {?WriteRecord}
     */
    WriteTree.prototype.getWrite = function (writeId) {
        for (var i = 0; i < this.allWrites_.length; i++) {
            var record = this.allWrites_[i];
            if (record.writeId === writeId) {
                return record;
            }
        }
        return null;
    };
    /**
     * Remove a write (either an overwrite or merge) that has been successfully acknowledge by the server. Recalculates
     * the tree if necessary.  We return true if it may have been visible, meaning views need to reevaluate.
     *
     * @param {!number} writeId
     * @return {boolean} true if the write may have been visible (meaning we'll need to reevaluate / raise
     * events as a result).
     */
    WriteTree.prototype.removeWrite = function (writeId) {
        // Note: disabling this check. It could be a transaction that preempted another transaction, and thus was applied
        // out of order.
        //const validClear = revert || this.allWrites_.length === 0 || writeId <= this.allWrites_[0].writeId;
        //assert(validClear, "Either we don't have this write, or it's the first one in the queue");
        var _this = this;
        var idx = this.allWrites_.findIndex(function (s) {
            return s.writeId === writeId;
        });
        util_2.assert(idx >= 0, 'removeWrite called with nonexistent writeId.');
        var writeToRemove = this.allWrites_[idx];
        this.allWrites_.splice(idx, 1);
        var removedWriteWasVisible = writeToRemove.visible;
        var removedWriteOverlapsWithOtherWrites = false;
        var i = this.allWrites_.length - 1;
        while (removedWriteWasVisible && i >= 0) {
            var currentWrite = this.allWrites_[i];
            if (currentWrite.visible) {
                if (i >= idx &&
                    this.recordContainsPath_(currentWrite, writeToRemove.path)) {
                    // The removed write was completely shadowed by a subsequent write.
                    removedWriteWasVisible = false;
                }
                else if (writeToRemove.path.contains(currentWrite.path)) {
                    // Either we're covering some writes or they're covering part of us (depending on which came first).
                    removedWriteOverlapsWithOtherWrites = true;
                }
            }
            i--;
        }
        if (!removedWriteWasVisible) {
            return false;
        }
        else if (removedWriteOverlapsWithOtherWrites) {
            // There's some shadowing going on. Just rebuild the visible writes from scratch.
            this.resetTree_();
            return true;
        }
        else {
            // There's no shadowing.  We can safely just remove the write(s) from visibleWrites.
            if (writeToRemove.snap) {
                this.visibleWrites_ = this.visibleWrites_.removeWrite(writeToRemove.path);
            }
            else {
                var children = writeToRemove.children;
                util_1.forEach(children, function (childName) {
                    _this.visibleWrites_ = _this.visibleWrites_.removeWrite(writeToRemove.path.child(childName));
                });
            }
            return true;
        }
    };
    /**
     * Return a complete snapshot for the given path if there's visible write data at that path, else null.
     * No server data is considered.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.getCompleteWriteData = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * Given optional, underlying server data, and an optional set of constraints (exclude some sets, include hidden
     * writes), attempt to calculate a complete snapshot for the given path
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude An optional set to be excluded
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteEventCache = function (treePath, completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        if (!writeIdsToExclude && !includeHiddenWrites) {
            var shadowingNode = this.visibleWrites_.getCompleteNode(treePath);
            if (shadowingNode != null) {
                return shadowingNode;
            }
            else {
                var subMerge = this.visibleWrites_.childCompoundWrite(treePath);
                if (subMerge.isEmpty()) {
                    return completeServerCache;
                }
                else if (completeServerCache == null &&
                    !subMerge.hasCompleteWrite(Path_1.Path.Empty)) {
                    // We wouldn't have a complete snapshot, since there's no underlying data and no complete shadow
                    return null;
                }
                else {
                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                    return subMerge.apply(layeredCache);
                }
            }
        }
        else {
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            if (!includeHiddenWrites && merge.isEmpty()) {
                return completeServerCache;
            }
            else {
                // If the server cache is null, and we don't have a complete cache, we need to return null
                if (!includeHiddenWrites &&
                    completeServerCache == null &&
                    !merge.hasCompleteWrite(Path_1.Path.Empty)) {
                    return null;
                }
                else {
                    var filter = function (write) {
                        return ((write.visible || includeHiddenWrites) &&
                            (!writeIdsToExclude ||
                                !~writeIdsToExclude.indexOf(write.writeId)) &&
                            (write.path.contains(treePath) || treePath.contains(write.path)));
                    };
                    var mergeAtPath = WriteTree.layerTree_(this.allWrites_, filter, treePath);
                    var layeredCache = completeServerCache || ChildrenNode_1.ChildrenNode.EMPTY_NODE;
                    return mergeAtPath.apply(layeredCache);
                }
            }
        }
    };
    /**
     * With optional, underlying server data, attempt to return a children node of children that we have complete data for.
     * Used when creating new views, to pre-fill their complete event children snapshot.
     *
     * @param {!Path} treePath
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTree.prototype.calcCompleteEventChildren = function (treePath, completeServerChildren) {
        var completeChildren = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        var topLevelSet = this.visibleWrites_.getCompleteNode(treePath);
        if (topLevelSet) {
            if (!topLevelSet.isLeafNode()) {
                // we're shadowing everything. Return the children.
                topLevelSet.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childSnap) {
                    completeChildren = completeChildren.updateImmediateChild(childName, childSnap);
                });
            }
            return completeChildren;
        }
        else if (completeServerChildren) {
            // Layer any children we have on top of this
            // We know we don't have a top-level set, so just enumerate existing children
            var merge_1 = this.visibleWrites_.childCompoundWrite(treePath);
            completeServerChildren.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
                var node = merge_1
                    .childCompoundWrite(new Path_1.Path(childName))
                    .apply(childNode);
                completeChildren = completeChildren.updateImmediateChild(childName, node);
            });
            // Add any complete children we have from the set
            merge_1.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
        else {
            // We don't have anything to layer on top of. Layer on any children we have
            // Note that we can return an empty snap if we have a defined delete
            var merge = this.visibleWrites_.childCompoundWrite(treePath);
            merge.getCompleteChildren().forEach(function (namedNode) {
                completeChildren = completeChildren.updateImmediateChild(namedNode.name, namedNode.node);
            });
            return completeChildren;
        }
    };
    /**
     * Given that the underlying server data has updated, determine what, if anything, needs to be
     * applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events
     *
     * Either existingEventSnap or existingServerSnap must exist
     *
     * @param {!Path} treePath
     * @param {!Path} childPath
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcEventCacheAfterServerOverwrite = function (treePath, childPath, existingEventSnap, existingServerSnap) {
        util_2.assert(existingEventSnap || existingServerSnap, 'Either existingEventSnap or existingServerSnap must exist');
        var path = treePath.child(childPath);
        if (this.visibleWrites_.hasCompleteWrite(path)) {
            // At this point we can probably guarantee that we're in case 2, meaning no events
            // May need to check visibility while doing the findRootMostValueAndPath call
            return null;
        }
        else {
            // No complete shadowing. We're either partially shadowing or not shadowing at all.
            var childMerge = this.visibleWrites_.childCompoundWrite(path);
            if (childMerge.isEmpty()) {
                // We're not shadowing at all. Case 1
                return existingServerSnap.getChild(childPath);
            }
            else {
                // This could be more efficient if the serverNode + updates doesn't change the eventSnap
                // However this is tricky to find out, since user updates don't necessary change the server
                // snap, e.g. priority updates on empty nodes, or deep deletes. Another special case is if the server
                // adds nodes, but doesn't change any existing writes. It is therefore not enough to
                // only check if the updates change the serverNode.
                // Maybe check if the merge tree contains these special cases and only do a full overwrite in that case?
                return childMerge.apply(existingServerSnap.getChild(childPath));
            }
        }
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!Path} treePath
     * @param {!string} childKey
     * @param {!CacheNode} existingServerSnap
     * @return {?Node}
     */
    WriteTree.prototype.calcCompleteChild = function (treePath, childKey, existingServerSnap) {
        var path = treePath.child(childKey);
        var shadowingNode = this.visibleWrites_.getCompleteNode(path);
        if (shadowingNode != null) {
            return shadowingNode;
        }
        else {
            if (existingServerSnap.isCompleteForChild(childKey)) {
                var childMerge = this.visibleWrites_.childCompoundWrite(path);
                return childMerge.apply(existingServerSnap.getNode().getImmediateChild(childKey));
            }
            else {
                return null;
            }
        }
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTree.prototype.shadowingWrite = function (path) {
        return this.visibleWrites_.getCompleteNode(path);
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window.
     *
     * @param {!Path} treePath
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTree.prototype.calcIndexedSlice = function (treePath, completeServerData, startPost, count, reverse, index) {
        var toIterate;
        var merge = this.visibleWrites_.childCompoundWrite(treePath);
        var shadowingNode = merge.getCompleteNode(Path_1.Path.Empty);
        if (shadowingNode != null) {
            toIterate = shadowingNode;
        }
        else if (completeServerData != null) {
            toIterate = merge.apply(completeServerData);
        }
        else {
            // no children to iterate on
            return [];
        }
        toIterate = toIterate.withIndex(index);
        if (!toIterate.isEmpty() && !toIterate.isLeafNode()) {
            var nodes = [];
            var cmp = index.getCompare();
            var iter = reverse
                ? toIterate.getReverseIteratorFrom(startPost, index)
                : toIterate.getIteratorFrom(startPost, index);
            var next = iter.getNext();
            while (next && nodes.length < count) {
                if (cmp(next, startPost) !== 0) {
                    nodes.push(next);
                }
                next = iter.getNext();
            }
            return nodes;
        }
        else {
            return [];
        }
    };
    /**
     * @param {!WriteRecord} writeRecord
     * @param {!Path} path
     * @return {boolean}
     * @private
     */
    WriteTree.prototype.recordContainsPath_ = function (writeRecord, path) {
        if (writeRecord.snap) {
            return writeRecord.path.contains(path);
        }
        else {
            // findKey can return undefined, so use !! to coerce to boolean
            return !!util_1.findKey(writeRecord.children, function (childSnap, childName) {
                return writeRecord.path.child(childName).contains(path);
            });
        }
    };
    /**
     * Re-layer the writes and merges into a tree so we can efficiently calculate event snapshots
     * @private
     */
    WriteTree.prototype.resetTree_ = function () {
        this.visibleWrites_ = WriteTree.layerTree_(this.allWrites_, WriteTree.DefaultFilter_, Path_1.Path.Empty);
        if (this.allWrites_.length > 0) {
            this.lastWriteId_ = this.allWrites_[this.allWrites_.length - 1].writeId;
        }
        else {
            this.lastWriteId_ = -1;
        }
    };
    /**
     * The default filter used when constructing the tree. Keep everything that's visible.
     *
     * @param {!WriteRecord} write
     * @return {boolean}
     * @private
     */
    WriteTree.DefaultFilter_ = function (write) {
        return write.visible;
    };
    /**
     * Static method. Given an array of WriteRecords, a filter for which ones to include, and a path, construct the tree of
     * event data at that path.
     *
     * @param {!Array.<!WriteRecord>} writes
     * @param {!function(!WriteRecord):boolean} filter
     * @param {!Path} treeRoot
     * @return {!CompoundWrite}
     * @private
     */
    WriteTree.layerTree_ = function (writes, filter, treeRoot) {
        var compoundWrite = CompoundWrite_1.CompoundWrite.Empty;
        for (var i = 0; i < writes.length; ++i) {
            var write = writes[i];
            // Theory, a later set will either:
            // a) abort a relevant transaction, so no need to worry about excluding it from calculating that transaction
            // b) not be relevant to a transaction (separate branch), so again will not affect the data for that transaction
            if (filter(write)) {
                var writePath = write.path;
                var relativePath = void 0;
                if (write.snap) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrite(relativePath, write.snap);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
                        compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, write.snap.getChild(relativePath));
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else if (write.children) {
                    if (treeRoot.contains(writePath)) {
                        relativePath = Path_1.Path.relativePath(treeRoot, writePath);
                        compoundWrite = compoundWrite.addWrites(relativePath, write.children);
                    }
                    else if (writePath.contains(treeRoot)) {
                        relativePath = Path_1.Path.relativePath(writePath, treeRoot);
                        if (relativePath.isEmpty()) {
                            compoundWrite = compoundWrite.addWrites(Path_1.Path.Empty, write.children);
                        }
                        else {
                            var child = util_1.safeGet(write.children, relativePath.getFront());
                            if (child) {
                                // There exists a child in this node that matches the root path
                                var deepNode = child.getChild(relativePath.popFront());
                                compoundWrite = compoundWrite.addWrite(Path_1.Path.Empty, deepNode);
                            }
                        }
                    }
                    else {
                        // There is no overlap between root path and write path, ignore write
                    }
                }
                else {
                    throw util_2.assertionError('WriteRecord should have .snap or .children');
                }
            }
        }
        return compoundWrite;
    };
    return WriteTree;
}());
exports.WriteTree = WriteTree;
/**
 * A WriteTreeRef wraps a WriteTree and a path, for convenient access to a particular subtree.  All of the methods
 * just proxy to the underlying WriteTree.
 *
 * @constructor
 */
var WriteTreeRef = /** @class */ (function () {
    /**
     * @param {!Path} path
     * @param {!WriteTree} writeTree
     */
    function WriteTreeRef(path, writeTree) {
        this.treePath_ = path;
        this.writeTree_ = writeTree;
    }
    /**
     * If possible, returns a complete event cache, using the underlying server data if possible. In addition, can be used
     * to get a cache that includes hidden writes, and excludes arbitrary writes. Note that customizing the returned node
     * can lead to a more expensive calculation.
     *
     * @param {?Node} completeServerCache
     * @param {Array.<number>=} writeIdsToExclude Optional writes to exclude.
     * @param {boolean=} includeHiddenWrites Defaults to false, whether or not to layer on writes with visible set to false
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteEventCache = function (completeServerCache, writeIdsToExclude, includeHiddenWrites) {
        return this.writeTree_.calcCompleteEventCache(this.treePath_, completeServerCache, writeIdsToExclude, includeHiddenWrites);
    };
    /**
     * If possible, returns a children node containing all of the complete children we have data for. The returned data is a
     * mix of the given server data and write data.
     *
     * @param {?ChildrenNode} completeServerChildren
     * @return {!ChildrenNode}
     */
    WriteTreeRef.prototype.calcCompleteEventChildren = function (completeServerChildren) {
        return this.writeTree_.calcCompleteEventChildren(this.treePath_, completeServerChildren);
    };
    /**
     * Given that either the underlying server data has updated or the outstanding writes have updated, determine what,
     * if anything, needs to be applied to the event cache.
     *
     * Possibilities:
     *
     * 1. No writes are shadowing. Events should be raised, the snap to be applied comes from the server data
     *
     * 2. Some write is completely shadowing. No events to be raised
     *
     * 3. Is partially shadowed. Events should be raised
     *
     * Either existingEventSnap or existingServerSnap must exist, this is validated via an assert
     *
     * @param {!Path} path
     * @param {?Node} existingEventSnap
     * @param {?Node} existingServerSnap
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcEventCacheAfterServerOverwrite = function (path, existingEventSnap, existingServerSnap) {
        return this.writeTree_.calcEventCacheAfterServerOverwrite(this.treePath_, path, existingEventSnap, existingServerSnap);
    };
    /**
     * Returns a node if there is a complete overwrite for this path. More specifically, if there is a write at
     * a higher path, this will return the child of that write relative to the write and this path.
     * Returns null if there is no write at this path.
     *
     * @param {!Path} path
     * @return {?Node}
     */
    WriteTreeRef.prototype.shadowingWrite = function (path) {
        return this.writeTree_.shadowingWrite(this.treePath_.child(path));
    };
    /**
     * This method is used when processing child remove events on a query. If we can, we pull in children that were outside
     * the window, but may now be in the window
     *
     * @param {?Node} completeServerData
     * @param {!NamedNode} startPost
     * @param {!number} count
     * @param {boolean} reverse
     * @param {!Index} index
     * @return {!Array.<!NamedNode>}
     */
    WriteTreeRef.prototype.calcIndexedSlice = function (completeServerData, startPost, count, reverse, index) {
        return this.writeTree_.calcIndexedSlice(this.treePath_, completeServerData, startPost, count, reverse, index);
    };
    /**
     * Returns a complete child for a given server snap after applying all user writes or null if there is no
     * complete child for this ChildKey.
     *
     * @param {!string} childKey
     * @param {!CacheNode} existingServerCache
     * @return {?Node}
     */
    WriteTreeRef.prototype.calcCompleteChild = function (childKey, existingServerCache) {
        return this.writeTree_.calcCompleteChild(this.treePath_, childKey, existingServerCache);
    };
    /**
     * Return a WriteTreeRef for a child.
     *
     * @param {string} childName
     * @return {!WriteTreeRef}
     */
    WriteTreeRef.prototype.child = function (childName) {
        return new WriteTreeRef(this.treePath_.child(childName), this.writeTree_);
    };
    return WriteTreeRef;
}());
exports.WriteTreeRef = WriteTreeRef;

//# sourceMappingURL=WriteTree.js.map


/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ImmutableTree_1 = __webpack_require__(270);
var Path_1 = __webpack_require__(29);
var util_1 = __webpack_require__(6);
var Node_1 = __webpack_require__(53);
var PriorityIndex_1 = __webpack_require__(42);
var util_2 = __webpack_require__(6);
/**
 * This class holds a collection of writes that can be applied to nodes in unison. It abstracts away the logic with
 * dealing with priority writes and multiple nested writes. At any given path there is only allowed to be one write
 * modifying that path. Any write to an existing path or shadowing an existing path will modify that existing write
 * to reflect the write added.
 *
 * @constructor
 * @param {!ImmutableTree.<!Node>} writeTree
 */
var CompoundWrite = /** @class */ (function () {
    function CompoundWrite(writeTree_) {
        this.writeTree_ = writeTree_;
    }
    /**
     * @param {!Path} path
     * @param {!Node} node
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrite = function (path, node) {
        if (path.isEmpty()) {
            return new CompoundWrite(new ImmutableTree_1.ImmutableTree(node));
        }
        else {
            var rootmost = this.writeTree_.findRootMostValueAndPath(path);
            if (rootmost != null) {
                var rootMostPath = rootmost.path;
                var value = rootmost.value;
                var relativePath = Path_1.Path.relativePath(rootMostPath, path);
                value = value.updateChild(relativePath, node);
                return new CompoundWrite(this.writeTree_.set(rootMostPath, value));
            }
            else {
                var subtree = new ImmutableTree_1.ImmutableTree(node);
                var newWriteTree = this.writeTree_.setTree(path, subtree);
                return new CompoundWrite(newWriteTree);
            }
        }
    };
    /**
     * @param {!Path} path
     * @param {!Object.<string, !Node>} updates
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.addWrites = function (path, updates) {
        var newWrite = this;
        util_1.forEach(updates, function (childKey, node) {
            newWrite = newWrite.addWrite(path.child(childKey), node);
        });
        return newWrite;
    };
    /**
     * Will remove a write at the given path and deeper paths. This will <em>not</em> modify a write at a higher
     * location, which must be removed by calling this method with that path.
     *
     * @param {!Path} path The path at which a write and all deeper writes should be removed
     * @return {!CompoundWrite} The new CompoundWrite with the removed path
     */
    CompoundWrite.prototype.removeWrite = function (path) {
        if (path.isEmpty()) {
            return CompoundWrite.Empty;
        }
        else {
            var newWriteTree = this.writeTree_.setTree(path, ImmutableTree_1.ImmutableTree.Empty);
            return new CompoundWrite(newWriteTree);
        }
    };
    /**
     * Returns whether this CompoundWrite will fully overwrite a node at a given location and can therefore be
     * considered "complete".
     *
     * @param {!Path} path The path to check for
     * @return {boolean} Whether there is a complete write at that path
     */
    CompoundWrite.prototype.hasCompleteWrite = function (path) {
        return this.getCompleteNode(path) != null;
    };
    /**
     * Returns a node for a path if and only if the node is a "complete" overwrite at that path. This will not aggregate
     * writes from deeper paths, but will return child nodes from a more shallow path.
     *
     * @param {!Path} path The path to get a complete write
     * @return {?Node} The node if complete at that path, or null otherwise.
     */
    CompoundWrite.prototype.getCompleteNode = function (path) {
        var rootmost = this.writeTree_.findRootMostValueAndPath(path);
        if (rootmost != null) {
            return this.writeTree_
                .get(rootmost.path)
                .getChild(Path_1.Path.relativePath(rootmost.path, path));
        }
        else {
            return null;
        }
    };
    /**
     * Returns all children that are guaranteed to be a complete overwrite.
     *
     * @return {!Array.<NamedNode>} A list of all complete children.
     */
    CompoundWrite.prototype.getCompleteChildren = function () {
        var children = [];
        var node = this.writeTree_.value;
        if (node != null) {
            // If it's a leaf node, it has no children; so nothing to do.
            if (!node.isLeafNode()) {
                node.forEachChild(PriorityIndex_1.PRIORITY_INDEX, function (childName, childNode) {
                    children.push(new Node_1.NamedNode(childName, childNode));
                });
            }
        }
        else {
            this.writeTree_.children.inorderTraversal(function (childName, childTree) {
                if (childTree.value != null) {
                    children.push(new Node_1.NamedNode(childName, childTree.value));
                }
            });
        }
        return children;
    };
    /**
     * @param {!Path} path
     * @return {!CompoundWrite}
     */
    CompoundWrite.prototype.childCompoundWrite = function (path) {
        if (path.isEmpty()) {
            return this;
        }
        else {
            var shadowingNode = this.getCompleteNode(path);
            if (shadowingNode != null) {
                return new CompoundWrite(new ImmutableTree_1.ImmutableTree(shadowingNode));
            }
            else {
                return new CompoundWrite(this.writeTree_.subtree(path));
            }
        }
    };
    /**
     * Returns true if this CompoundWrite is empty and therefore does not modify any nodes.
     * @return {boolean} Whether this CompoundWrite is empty
     */
    CompoundWrite.prototype.isEmpty = function () {
        return this.writeTree_.isEmpty();
    };
    /**
     * Applies this CompoundWrite to a node. The node is returned with all writes from this CompoundWrite applied to the
     * node
     * @param {!Node} node The node to apply this CompoundWrite to
     * @return {!Node} The node with all writes applied
     */
    CompoundWrite.prototype.apply = function (node) {
        return CompoundWrite.applySubtreeWrite_(Path_1.Path.Empty, this.writeTree_, node);
    };
    /**
     * @type {!CompoundWrite}
     */
    CompoundWrite.Empty = new CompoundWrite(new ImmutableTree_1.ImmutableTree(null));
    /**
     * @param {!Path} relativePath
     * @param {!ImmutableTree.<!Node>} writeTree
     * @param {!Node} node
     * @return {!Node}
     * @private
     */
    CompoundWrite.applySubtreeWrite_ = function (relativePath, writeTree, node) {
        if (writeTree.value != null) {
            // Since there a write is always a leaf, we're done here
            return node.updateChild(relativePath, writeTree.value);
        }
        else {
            var priorityWrite_1 = null;
            writeTree.children.inorderTraversal(function (childKey, childTree) {
                if (childKey === '.priority') {
                    // Apply priorities at the end so we don't update priorities for either empty nodes or forget
                    // to apply priorities to empty nodes that are later filled
                    util_2.assert(childTree.value !== null, 'Priority writes must always be leaf nodes');
                    priorityWrite_1 = childTree.value;
                }
                else {
                    node = CompoundWrite.applySubtreeWrite_(relativePath.child(childKey), childTree, node);
                }
            });
            // If there was a priority write, we only apply it if the node is not empty
            if (!node.getChild(relativePath).isEmpty() && priorityWrite_1 !== null) {
                node = node.updateChild(relativePath.child('.priority'), priorityWrite_1);
            }
            return node;
        }
    };
    return CompoundWrite;
}());
exports.CompoundWrite = CompoundWrite;

//# sourceMappingURL=CompoundWrite.js.map


/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var ChildrenNode_1 = __webpack_require__(49);
/**
 * Mutable object which basically just stores a reference to the "latest" immutable snapshot.
 *
 * @constructor
 */
var SnapshotHolder = /** @class */ (function () {
    function SnapshotHolder() {
        this.rootNode_ = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
    }
    SnapshotHolder.prototype.getNode = function (path) {
        return this.rootNode_.getChild(path);
    };
    SnapshotHolder.prototype.updateSnapshot = function (path, newSnapshotNode) {
        this.rootNode_ = this.rootNode_.updateChild(path, newSnapshotNode);
    };
    return SnapshotHolder;
}());
exports.SnapshotHolder = SnapshotHolder;

//# sourceMappingURL=SnapshotHolder.js.map


/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
/**
 * Abstraction around FirebaseApp's token fetching capabilities.
 */
var AuthTokenProvider = /** @class */ (function () {
    /**
     * @param {!FirebaseApp} app_
     */
    function AuthTokenProvider(app_) {
        this.app_ = app_;
    }
    /**
     * @param {boolean} forceRefresh
     * @return {!Promise<FirebaseAuthTokenData>}
     */
    AuthTokenProvider.prototype.getToken = function (forceRefresh) {
        return this.app_['INTERNAL']['getToken'](forceRefresh).then(null, 
        // .catch
        function (error) {
            // TODO: Need to figure out all the cases this is raised and whether
            // this makes sense.
            if (error && error.code === 'auth/token-not-initialized') {
                util_1.log('Got auth/token-not-initialized error.  Treating as null token.');
                return null;
            }
            else {
                return Promise.reject(error);
            }
        });
    };
    AuthTokenProvider.prototype.addTokenChangeListener = function (listener) {
        // TODO: We might want to wrap the listener and call it with no args to
        // avoid a leaky abstraction, but that makes removing the listener harder.
        this.app_['INTERNAL']['addAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.removeTokenChangeListener = function (listener) {
        this.app_['INTERNAL']['removeAuthTokenListener'](listener);
    };
    AuthTokenProvider.prototype.notifyForInvalidToken = function () {
        var errorMessage = 'Provided authentication credentials for the app named "' +
            this.app_.name +
            '" are invalid. This usually indicates your app was not ' +
            'initialized correctly. ';
        if ('credential' in this.app_.options) {
            errorMessage +=
                'Make sure the "credential" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else if ('serviceAccount' in this.app_.options) {
            errorMessage +=
                'Make sure the "serviceAccount" property provided to initializeApp() ' +
                    'is authorized to access the specified "databaseURL" and is from the correct ' +
                    'project.';
        }
        else {
            errorMessage +=
                'Make sure the "apiKey" and "databaseURL" properties provided to ' +
                    'initializeApp() match the values provided for your app at ' +
                    'https://console.firebase.google.com/.';
        }
        util_1.warn(errorMessage);
    };
    return AuthTokenProvider;
}());
exports.AuthTokenProvider = AuthTokenProvider;

//# sourceMappingURL=AuthTokenProvider.js.map


/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(6);
/**
 * Tracks a collection of stats.
 *
 * @constructor
 */
var StatsCollection = /** @class */ (function () {
    function StatsCollection() {
        this.counters_ = {};
    }
    StatsCollection.prototype.incrementCounter = function (name, amount) {
        if (amount === void 0) { amount = 1; }
        if (!util_2.contains(this.counters_, name))
            this.counters_[name] = 0;
        this.counters_[name] += amount;
    };
    StatsCollection.prototype.get = function () {
        return util_1.deepCopy(this.counters_);
    };
    return StatsCollection;
}());
exports.StatsCollection = StatsCollection;

//# sourceMappingURL=StatsCollection.js.map


/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var StatsListener_1 = __webpack_require__(478);
// Assuming some apps may have a short amount of time on page, and a bulk of firebase operations probably
// happen on page load, we try to report our first set of stats pretty quickly, but we wait at least 10
// seconds to try to ensure the Firebase connection is established / settled.
var FIRST_STATS_MIN_TIME = 10 * 1000;
var FIRST_STATS_MAX_TIME = 30 * 1000;
// We'll continue to report stats on average every 5 minutes.
var REPORT_STATS_INTERVAL = 5 * 60 * 1000;
/**
 * @constructor
 */
var StatsReporter = /** @class */ (function () {
    /**
     * @param collection
     * @param server_
     */
    function StatsReporter(collection, server_) {
        this.server_ = server_;
        this.statsToReport_ = {};
        this.statsListener_ = new StatsListener_1.StatsListener(collection);
        var timeout = FIRST_STATS_MIN_TIME +
            (FIRST_STATS_MAX_TIME - FIRST_STATS_MIN_TIME) * Math.random();
        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(timeout));
    }
    StatsReporter.prototype.includeStat = function (stat) {
        this.statsToReport_[stat] = true;
    };
    StatsReporter.prototype.reportStats_ = function () {
        var _this = this;
        var stats = this.statsListener_.get();
        var reportedStats = {};
        var haveStatsToReport = false;
        util_1.forEach(stats, function (stat, value) {
            if (value > 0 && util_1.contains(_this.statsToReport_, stat)) {
                reportedStats[stat] = value;
                haveStatsToReport = true;
            }
        });
        if (haveStatsToReport) {
            this.server_.reportStats(reportedStats);
        }
        // queue our next run.
        util_2.setTimeoutNonBlocking(this.reportStats_.bind(this), Math.floor(Math.random() * 2 * REPORT_STATS_INTERVAL));
    };
    return StatsReporter;
}());
exports.StatsReporter = StatsReporter;

//# sourceMappingURL=StatsReporter.js.map


/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
/**
 * The event queue serves a few purposes:
 * 1. It ensures we maintain event order in the face of event callbacks doing operations that result in more
 *    events being queued.
 * 2. raiseQueuedEvents() handles being called reentrantly nicely.  That is, if in the course of raising events,
 *    raiseQueuedEvents() is called again, the "inner" call will pick up raising events where the "outer" call
 *    left off, ensuring that the events are still raised synchronously and in order.
 * 3. You can use raiseEventsAtPath and raiseEventsForChangedPath to ensure only relevant previously-queued
 *    events are raised synchronously.
 *
 * NOTE: This can all go away if/when we move to async events.
 *
 * @constructor
 */
var EventQueue = /** @class */ (function () {
    function EventQueue() {
        /**
         * @private
         * @type {!Array.<EventList>}
         */
        this.eventLists_ = [];
        /**
         * Tracks recursion depth of raiseQueuedEvents_, for debugging purposes.
         * @private
         * @type {!number}
         */
        this.recursionDepth_ = 0;
    }
    /**
     * @param {!Array.<Event>} eventDataList The new events to queue.
     */
    EventQueue.prototype.queueEvents = function (eventDataList) {
        // We group events by path, storing them in a single EventList, to make it easier to skip over them quickly.
        var currList = null;
        for (var i = 0; i < eventDataList.length; i++) {
            var eventData = eventDataList[i];
            var eventPath = eventData.getPath();
            if (currList !== null && !eventPath.equals(currList.getPath())) {
                this.eventLists_.push(currList);
                currList = null;
            }
            if (currList === null) {
                currList = new EventList(eventPath);
            }
            currList.add(eventData);
        }
        if (currList) {
            this.eventLists_.push(currList);
        }
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones)
     * for the specified path.
     *
     * It is assumed that the new events are all for the specified path.
     *
     * @param {!Path} path The path to raise events for.
     * @param {!Array.<Event>} eventDataList The new events to raise.
     */
    EventQueue.prototype.raiseEventsAtPath = function (path, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.equals(path);
        });
    };
    /**
     * Queues the specified events and synchronously raises all events (including previously queued ones) for
     * locations related to the specified change path (i.e. all ancestors and descendants).
     *
     * It is assumed that the new events are all related (ancestor or descendant) to the specified path.
     *
     * @param {!Path} changedPath The path to raise events for.
     * @param {!Array.<!Event>} eventDataList The events to raise
     */
    EventQueue.prototype.raiseEventsForChangedPath = function (changedPath, eventDataList) {
        this.queueEvents(eventDataList);
        this.raiseQueuedEventsMatchingPredicate_(function (eventPath) {
            return eventPath.contains(changedPath) || changedPath.contains(eventPath);
        });
    };
    /**
     * @param {!function(!Path):boolean} predicate
     * @private
     */
    EventQueue.prototype.raiseQueuedEventsMatchingPredicate_ = function (predicate) {
        this.recursionDepth_++;
        var sentAll = true;
        for (var i = 0; i < this.eventLists_.length; i++) {
            var eventList = this.eventLists_[i];
            if (eventList) {
                var eventPath = eventList.getPath();
                if (predicate(eventPath)) {
                    this.eventLists_[i].raise();
                    this.eventLists_[i] = null;
                }
                else {
                    sentAll = false;
                }
            }
        }
        if (sentAll) {
            this.eventLists_ = [];
        }
        this.recursionDepth_--;
    };
    return EventQueue;
}());
exports.EventQueue = EventQueue;
/**
 * @param {!Path} path
 * @constructor
 */
var EventList = /** @class */ (function () {
    function EventList(path_) {
        this.path_ = path_;
        /**
         * @type {!Array.<Event>}
         * @private
         */
        this.events_ = [];
    }
    /**
     * @param {!Event} eventData
     */
    EventList.prototype.add = function (eventData) {
        this.events_.push(eventData);
    };
    /**
     * Iterates through the list and raises each event
     */
    EventList.prototype.raise = function () {
        for (var i = 0; i < this.events_.length; i++) {
            var eventData = this.events_[i];
            if (eventData !== null) {
                this.events_[i] = null;
                var eventFn = eventData.getEventRunner();
                if (util_1.logger) {
                    util_1.log('event: ' + eventData.toString());
                }
                util_1.exceptionGuard(eventFn);
            }
        }
    };
    /**
     * @return {!Path}
     */
    EventList.prototype.getPath = function () {
        return this.path_;
    };
    return EventList;
}());
exports.EventList = EventList;

//# sourceMappingURL=EventQueue.js.map


/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var EventEmitter_1 = __webpack_require__(480);
var util_1 = __webpack_require__(6);
/**
 * @extends {EventEmitter}
 */
var VisibilityMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(VisibilityMonitor, _super);
    function VisibilityMonitor() {
        var _this = _super.call(this, ['visible']) || this;
        var hidden;
        var visibilityChange;
        if (typeof document !== 'undefined' &&
            typeof document.addEventListener !== 'undefined') {
            if (typeof document['hidden'] !== 'undefined') {
                // Opera 12.10 and Firefox 18 and later support
                visibilityChange = 'visibilitychange';
                hidden = 'hidden';
            }
            else if (typeof document['mozHidden'] !== 'undefined') {
                visibilityChange = 'mozvisibilitychange';
                hidden = 'mozHidden';
            }
            else if (typeof document['msHidden'] !== 'undefined') {
                visibilityChange = 'msvisibilitychange';
                hidden = 'msHidden';
            }
            else if (typeof document['webkitHidden'] !== 'undefined') {
                visibilityChange = 'webkitvisibilitychange';
                hidden = 'webkitHidden';
            }
        }
        // Initially, we always assume we are visible. This ensures that in browsers
        // without page visibility support or in cases where we are never visible
        // (e.g. chrome extension), we act as if we are visible, i.e. don't delay
        // reconnects
        _this.visible_ = true;
        if (visibilityChange) {
            document.addEventListener(visibilityChange, function () {
                var visible = !document[hidden];
                if (visible !== _this.visible_) {
                    _this.visible_ = visible;
                    _this.trigger('visible', visible);
                }
            }, false);
        }
        return _this;
    }
    VisibilityMonitor.getInstance = function () {
        return new VisibilityMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    VisibilityMonitor.prototype.getInitialEvent = function (eventType) {
        util_1.assert(eventType === 'visible', 'Unknown event type: ' + eventType);
        return [this.visible_];
    };
    return VisibilityMonitor;
}(EventEmitter_1.EventEmitter));
exports.VisibilityMonitor = VisibilityMonitor;

//# sourceMappingURL=VisibilityMonitor.js.map


/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var util_1 = __webpack_require__(6);
var EventEmitter_1 = __webpack_require__(480);
var util_2 = __webpack_require__(6);
/**
 * Monitors online state (as reported by window.online/offline events).
 *
 * The expectation is that this could have many false positives (thinks we are online
 * when we're not), but no false negatives.  So we can safely use it to determine when
 * we definitely cannot reach the internet.
 *
 * @extends {EventEmitter}
 */
var OnlineMonitor = /** @class */ (function (_super) {
    tslib_1.__extends(OnlineMonitor, _super);
    function OnlineMonitor() {
        var _this = _super.call(this, ['online']) || this;
        _this.online_ = true;
        // We've had repeated complaints that Cordova apps can get stuck "offline", e.g.
        // https://forum.ionicframework.com/t/firebase-connection-is-lost-and-never-come-back/43810
        // It would seem that the 'online' event does not always fire consistently. So we disable it
        // for Cordova.
        if (typeof window !== 'undefined' &&
            typeof window.addEventListener !== 'undefined' &&
            !util_2.isMobileCordova()) {
            window.addEventListener('online', function () {
                if (!_this.online_) {
                    _this.online_ = true;
                    _this.trigger('online', true);
                }
            }, false);
            window.addEventListener('offline', function () {
                if (_this.online_) {
                    _this.online_ = false;
                    _this.trigger('online', false);
                }
            }, false);
        }
        return _this;
    }
    OnlineMonitor.getInstance = function () {
        return new OnlineMonitor();
    };
    /**
     * @param {!string} eventType
     * @return {Array.<boolean>}
     */
    OnlineMonitor.prototype.getInitialEvent = function (eventType) {
        util_1.assert(eventType === 'online', 'Unknown event type: ' + eventType);
        return [this.online_];
    };
    /**
     * @return {boolean}
     */
    OnlineMonitor.prototype.currentlyOnline = function () {
        return this.online_;
    };
    return OnlineMonitor;
}(EventEmitter_1.EventEmitter));
exports.OnlineMonitor = OnlineMonitor;

//# sourceMappingURL=OnlineMonitor.js.map


/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var BrowserPollConnection_1 = __webpack_require__(482);
var WebSocketConnection_1 = __webpack_require__(483);
var util_1 = __webpack_require__(21);
/**
 * Currently simplistic, this class manages what transport a Connection should use at various stages of its
 * lifecycle.
 *
 * It starts with longpolling in a browser, and httppolling on node. It then upgrades to websockets if
 * they are available.
 * @constructor
 */
var TransportManager = /** @class */ (function () {
    /**
     * @param {!RepoInfo} repoInfo Metadata around the namespace we're connecting to
     */
    function TransportManager(repoInfo) {
        this.initTransports_(repoInfo);
    }
    Object.defineProperty(TransportManager, "ALL_TRANSPORTS", {
        /**
         * @const
         * @type {!Array.<function(new:Transport, string, RepoInfo, string=)>}
         */
        get: function () {
            return [BrowserPollConnection_1.BrowserPollConnection, WebSocketConnection_1.WebSocketConnection];
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @param {!RepoInfo} repoInfo
     * @private
     */
    TransportManager.prototype.initTransports_ = function (repoInfo) {
        var isWebSocketsAvailable = WebSocketConnection_1.WebSocketConnection && WebSocketConnection_1.WebSocketConnection['isAvailable']();
        var isSkipPollConnection = isWebSocketsAvailable && !WebSocketConnection_1.WebSocketConnection.previouslyFailed();
        if (repoInfo.webSocketOnly) {
            if (!isWebSocketsAvailable)
                util_1.warn("wss:// URL used, but browser isn't known to support websockets.  Trying anyway.");
            isSkipPollConnection = true;
        }
        if (isSkipPollConnection) {
            this.transports_ = [WebSocketConnection_1.WebSocketConnection];
        }
        else {
            var transports_1 = (this.transports_ = []);
            util_1.each(TransportManager.ALL_TRANSPORTS, function (i, transport) {
                if (transport && transport['isAvailable']()) {
                    transports_1.push(transport);
                }
            });
        }
    };
    /**
     * @return {function(new:Transport, !string, !RepoInfo, string=, string=)} The constructor for the
     * initial transport to use
     */
    TransportManager.prototype.initialTransport = function () {
        if (this.transports_.length > 0) {
            return this.transports_[0];
        }
        else {
            throw new Error('No transports available');
        }
    };
    /**
     * @return {?function(new:Transport, function(),function(), string=)} The constructor for the next
     * transport, or null
     */
    TransportManager.prototype.upgradeTransport = function () {
        if (this.transports_.length > 1) {
            return this.transports_[1];
        }
        else {
            return null;
        }
    };
    return TransportManager;
}());
exports.TransportManager = TransportManager;

//# sourceMappingURL=TransportManager.js.map


/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(21);
/**
 * This class ensures the packets from the server arrive in order
 * This class takes data from the server and ensures it gets passed into the callbacks in order.
 * @constructor
 */
var PacketReceiver = /** @class */ (function () {
    /**
     * @param onMessage_
     */
    function PacketReceiver(onMessage_) {
        this.onMessage_ = onMessage_;
        this.pendingResponses = [];
        this.currentResponseNum = 0;
        this.closeAfterResponse = -1;
        this.onClose = null;
    }
    PacketReceiver.prototype.closeAfter = function (responseNum, callback) {
        this.closeAfterResponse = responseNum;
        this.onClose = callback;
        if (this.closeAfterResponse < this.currentResponseNum) {
            this.onClose();
            this.onClose = null;
        }
    };
    /**
     * Each message from the server comes with a response number, and an array of data. The responseNumber
     * allows us to ensure that we process them in the right order, since we can't be guaranteed that all
     * browsers will respond in the same order as the requests we sent
     * @param {number} requestNum
     * @param {Array} data
     */
    PacketReceiver.prototype.handleResponse = function (requestNum, data) {
        var _this = this;
        this.pendingResponses[requestNum] = data;
        var _loop_1 = function () {
            var toProcess = this_1.pendingResponses[this_1.currentResponseNum];
            delete this_1.pendingResponses[this_1.currentResponseNum];
            var _loop_2 = function (i) {
                if (toProcess[i]) {
                    util_1.exceptionGuard(function () {
                        _this.onMessage_(toProcess[i]);
                    });
                }
            };
            for (var i = 0; i < toProcess.length; ++i) {
                _loop_2(i);
            }
            if (this_1.currentResponseNum === this_1.closeAfterResponse) {
                if (this_1.onClose) {
                    this_1.onClose();
                    this_1.onClose = null;
                }
                return "break";
            }
            this_1.currentResponseNum++;
        };
        var this_1 = this;
        while (this.pendingResponses[this.currentResponseNum]) {
            var state_1 = _loop_1();
            if (state_1 === "break")
                break;
        }
    };
    return PacketReceiver;
}());
exports.PacketReceiver = PacketReceiver;

//# sourceMappingURL=PacketReceiver.js.map


/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = __webpack_require__(52);
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var util_3 = __webpack_require__(6);
var util_4 = __webpack_require__(6);
var util_5 = __webpack_require__(6);
var ServerActions_1 = __webpack_require__(484);
/**
 * An implementation of ServerActions that communicates with the server via REST requests.
 * This is mostly useful for compatibility with crawlers, where we don't want to spin up a full
 * persistent connection (using WebSockets or long-polling)
 */
var ReadonlyRestClient = /** @class */ (function (_super) {
    tslib_1.__extends(ReadonlyRestClient, _super);
    /**
     * @param {!RepoInfo} repoInfo_ Data about the namespace we are connecting to
     * @param {function(string, *, boolean, ?number)} onDataUpdate_ A callback for new data from the server
     * @param {AuthTokenProvider} authTokenProvider_
     * @implements {ServerActions}
     */
    function ReadonlyRestClient(repoInfo_, onDataUpdate_, authTokenProvider_) {
        var _this = _super.call(this) || this;
        _this.repoInfo_ = repoInfo_;
        _this.onDataUpdate_ = onDataUpdate_;
        _this.authTokenProvider_ = authTokenProvider_;
        /** @private {function(...[*])} */
        _this.log_ = util_2.logWrapper('p:rest:');
        /**
         * We don't actually need to track listens, except to prevent us calling an onComplete for a listen
         * that's been removed. :-/
         *
         * @private {!Object.<string, !Object>}
         */
        _this.listens_ = {};
        return _this;
    }
    ReadonlyRestClient.prototype.reportStats = function (stats) {
        throw new Error('Method not implemented.');
    };
    /**
     * @param {!Query} query
     * @param {?number=} tag
     * @return {string}
     * @private
     */
    ReadonlyRestClient.getListenId_ = function (query, tag) {
        if (tag !== undefined) {
            return 'tag$' + tag;
        }
        else {
            util_1.assert(query.getQueryParams().isDefault(), "should have a tag if it's not a default query.");
            return query.path.toString();
        }
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.listen = function (query, currentHashFn, tag, onComplete) {
        var _this = this;
        var pathString = query.path.toString();
        this.log_('Listen called for ' + pathString + ' ' + query.queryIdentifier());
        // Mark this listener so we can tell if it's removed.
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        var thisListen = {};
        this.listens_[listenId] = thisListen;
        var queryStringParamaters = query
            .getQueryParams()
            .toRestQueryStringParameters();
        this.restRequest_(pathString + '.json', queryStringParamaters, function (error, result) {
            var data = result;
            if (error === 404) {
                data = null;
                error = null;
            }
            if (error === null) {
                _this.onDataUpdate_(pathString, data, /*isMerge=*/ false, tag);
            }
            if (util_4.safeGet(_this.listens_, listenId) === thisListen) {
                var status_1;
                if (!error) {
                    status_1 = 'ok';
                }
                else if (error == 401) {
                    status_1 = 'permission_denied';
                }
                else {
                    status_1 = 'rest_error:' + error;
                }
                onComplete(status_1, null);
            }
        });
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.unlisten = function (query, tag) {
        var listenId = ReadonlyRestClient.getListenId_(query, tag);
        delete this.listens_[listenId];
    };
    /** @inheritDoc */
    ReadonlyRestClient.prototype.refreshAuthToken = function (token) {
        // no-op since we just always call getToken.
    };
    /**
     * Performs a REST request to the given path, with the provided query string parameters,
     * and any auth credentials we have.
     *
     * @param {!string} pathString
     * @param {!Object.<string, *>} queryStringParameters
     * @param {?function(?number, *=)} callback
     * @private
     */
    ReadonlyRestClient.prototype.restRequest_ = function (pathString, queryStringParameters, callback) {
        var _this = this;
        if (queryStringParameters === void 0) { queryStringParameters = {}; }
        queryStringParameters['format'] = 'export';
        this.authTokenProvider_
            .getToken(/*forceRefresh=*/ false)
            .then(function (authTokenData) {
            var authToken = authTokenData && authTokenData.accessToken;
            if (authToken) {
                queryStringParameters['auth'] = authToken;
            }
            var url = (_this.repoInfo_.secure ? 'https://' : 'http://') +
                _this.repoInfo_.host +
                pathString +
                '?' +
                util_5.querystring(queryStringParameters);
            _this.log_('Sending REST request for ' + url);
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (callback && xhr.readyState === 4) {
                    _this.log_('REST Response for ' + url + ' received. status:', xhr.status, 'response:', xhr.responseText);
                    var res = null;
                    if (xhr.status >= 200 && xhr.status < 300) {
                        try {
                            res = util_3.jsonEval(xhr.responseText);
                        }
                        catch (e) {
                            util_2.warn('Failed to parse JSON response for ' +
                                url +
                                ': ' +
                                xhr.responseText);
                        }
                        callback(null, res);
                    }
                    else {
                        // 401 and 404 are expected.
                        if (xhr.status !== 401 && xhr.status !== 404) {
                            util_2.warn('Got unsuccessful REST response for ' +
                                url +
                                ' Status: ' +
                                xhr.status);
                        }
                        callback(xhr.status);
                    }
                    callback = null;
                }
            };
            xhr.open('GET', url, /*asynchronous=*/ true);
            xhr.send();
        });
    };
    return ReadonlyRestClient;
}(ServerActions_1.ServerActions));
exports.ReadonlyRestClient = ReadonlyRestClient;

//# sourceMappingURL=ReadonlyRestClient.js.map


/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var util_2 = __webpack_require__(21);
var KeyIndex_1 = __webpack_require__(145);
var PriorityIndex_1 = __webpack_require__(42);
var ValueIndex_1 = __webpack_require__(467);
var PathIndex_1 = __webpack_require__(471);
var IndexedFilter_1 = __webpack_require__(271);
var LimitedFilter_1 = __webpack_require__(1225);
var RangedFilter_1 = __webpack_require__(485);
var util_3 = __webpack_require__(6);
/**
 * This class is an immutable-from-the-public-api struct containing a set of query parameters defining a
 * range to be returned for a particular location. It is assumed that validation of parameters is done at the
 * user-facing API level, so it is not done here.
 * @constructor
 */
var QueryParams = /** @class */ (function () {
    function QueryParams() {
        this.limitSet_ = false;
        this.startSet_ = false;
        this.startNameSet_ = false;
        this.endSet_ = false;
        this.endNameSet_ = false;
        this.limit_ = 0;
        this.viewFrom_ = '';
        this.indexStartValue_ = null;
        this.indexStartName_ = '';
        this.indexEndValue_ = null;
        this.indexEndName_ = '';
        this.index_ = PriorityIndex_1.PRIORITY_INDEX;
    }
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasStart = function () {
        return this.startSet_;
    };
    /**
     * @return {boolean} True if it would return from left.
     */
    QueryParams.prototype.isViewFromLeft = function () {
        if (this.viewFrom_ === '') {
            // limit(), rather than limitToFirst or limitToLast was called.
            // This means that only one of startSet_ and endSet_ is true. Use them
            // to calculate which side of the view to anchor to. If neither is set,
            // anchor to the end.
            return this.startSet_;
        }
        else {
            return (this.viewFrom_ === QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT);
        }
    };
    /**
     * Only valid to call if hasStart() returns true
     * @return {*}
     */
    QueryParams.prototype.getIndexStartValue = function () {
        util_1.assert(this.startSet_, 'Only valid if start has been set');
        return this.indexStartValue_;
    };
    /**
     * Only valid to call if hasStart() returns true.
     * Returns the starting key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexStartName = function () {
        util_1.assert(this.startSet_, 'Only valid if start has been set');
        if (this.startNameSet_) {
            return this.indexStartName_;
        }
        else {
            return util_2.MIN_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasEnd = function () {
        return this.endSet_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * @return {*}
     */
    QueryParams.prototype.getIndexEndValue = function () {
        util_1.assert(this.endSet_, 'Only valid if end has been set');
        return this.indexEndValue_;
    };
    /**
     * Only valid to call if hasEnd() returns true.
     * Returns the end key name for the range defined by these query parameters
     * @return {!string}
     */
    QueryParams.prototype.getIndexEndName = function () {
        util_1.assert(this.endSet_, 'Only valid if end has been set');
        if (this.endNameSet_) {
            return this.indexEndName_;
        }
        else {
            return util_2.MAX_NAME;
        }
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.hasLimit = function () {
        return this.limitSet_;
    };
    /**
     * @return {boolean} True if a limit has been set and it has been explicitly anchored
     */
    QueryParams.prototype.hasAnchoredLimit = function () {
        return this.limitSet_ && this.viewFrom_ !== '';
    };
    /**
     * Only valid to call if hasLimit() returns true
     * @return {!number}
     */
    QueryParams.prototype.getLimit = function () {
        util_1.assert(this.limitSet_, 'Only valid if limit has been set');
        return this.limit_;
    };
    /**
     * @return {!Index}
     */
    QueryParams.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @return {!QueryParams}
     * @private
     */
    QueryParams.prototype.copy_ = function () {
        var copy = new QueryParams();
        copy.limitSet_ = this.limitSet_;
        copy.limit_ = this.limit_;
        copy.startSet_ = this.startSet_;
        copy.indexStartValue_ = this.indexStartValue_;
        copy.startNameSet_ = this.startNameSet_;
        copy.indexStartName_ = this.indexStartName_;
        copy.endSet_ = this.endSet_;
        copy.indexEndValue_ = this.indexEndValue_;
        copy.endNameSet_ = this.endNameSet_;
        copy.indexEndName_ = this.indexEndName_;
        copy.index_ = this.index_;
        copy.viewFrom_ = this.viewFrom_;
        return copy;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limit = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = '';
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToFirst = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_LEFT;
        return newParams;
    };
    /**
     * @param {!number} newLimit
     * @return {!QueryParams}
     */
    QueryParams.prototype.limitToLast = function (newLimit) {
        var newParams = this.copy_();
        newParams.limitSet_ = true;
        newParams.limit_ = newLimit;
        newParams.viewFrom_ = QueryParams.WIRE_PROTOCOL_CONSTANTS_.VIEW_FROM_RIGHT;
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.startAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.startSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexStartValue_ = indexValue;
        if (key != null) {
            newParams.startNameSet_ = true;
            newParams.indexStartName_ = key;
        }
        else {
            newParams.startNameSet_ = false;
            newParams.indexStartName_ = '';
        }
        return newParams;
    };
    /**
     * @param {*} indexValue
     * @param {?string=} key
     * @return {!QueryParams}
     */
    QueryParams.prototype.endAt = function (indexValue, key) {
        var newParams = this.copy_();
        newParams.endSet_ = true;
        if (!(indexValue !== undefined)) {
            indexValue = null;
        }
        newParams.indexEndValue_ = indexValue;
        if (key !== undefined) {
            newParams.endNameSet_ = true;
            newParams.indexEndName_ = key;
        }
        else {
            newParams.endNameSet_ = false;
            newParams.indexEndName_ = '';
        }
        return newParams;
    };
    /**
     * @param {!Index} index
     * @return {!QueryParams}
     */
    QueryParams.prototype.orderBy = function (index) {
        var newParams = this.copy_();
        newParams.index_ = index;
        return newParams;
    };
    /**
     * @return {!Object}
     */
    QueryParams.prototype.getQueryObject = function () {
        var WIRE_PROTOCOL_CONSTANTS = QueryParams.WIRE_PROTOCOL_CONSTANTS_;
        var obj = {};
        if (this.startSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_VALUE] = this.indexStartValue_;
            if (this.startNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_START_NAME] = this.indexStartName_;
            }
        }
        if (this.endSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_VALUE] = this.indexEndValue_;
            if (this.endNameSet_) {
                obj[WIRE_PROTOCOL_CONSTANTS.INDEX_END_NAME] = this.indexEndName_;
            }
        }
        if (this.limitSet_) {
            obj[WIRE_PROTOCOL_CONSTANTS.LIMIT] = this.limit_;
            var viewFrom = this.viewFrom_;
            if (viewFrom === '') {
                if (this.isViewFromLeft()) {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_LEFT;
                }
                else {
                    viewFrom = WIRE_PROTOCOL_CONSTANTS.VIEW_FROM_RIGHT;
                }
            }
            obj[WIRE_PROTOCOL_CONSTANTS.VIEW_FROM] = viewFrom;
        }
        // For now, priority index is the default, so we only specify if it's some other index
        if (this.index_ !== PriorityIndex_1.PRIORITY_INDEX) {
            obj[WIRE_PROTOCOL_CONSTANTS.INDEX] = this.index_.toString();
        }
        return obj;
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.loadsAllData = function () {
        return !(this.startSet_ || this.endSet_ || this.limitSet_);
    };
    /**
     * @return {boolean}
     */
    QueryParams.prototype.isDefault = function () {
        return this.loadsAllData() && this.index_ == PriorityIndex_1.PRIORITY_INDEX;
    };
    /**
     * @return {!NodeFilter}
     */
    QueryParams.prototype.getNodeFilter = function () {
        if (this.loadsAllData()) {
            return new IndexedFilter_1.IndexedFilter(this.getIndex());
        }
        else if (this.hasLimit()) {
            return new LimitedFilter_1.LimitedFilter(this);
        }
        else {
            return new RangedFilter_1.RangedFilter(this);
        }
    };
    /**
     * Returns a set of REST query string parameters representing this query.
     *
     * @return {!Object.<string,*>} query string parameters
     */
    QueryParams.prototype.toRestQueryStringParameters = function () {
        var REST_CONSTANTS = QueryParams.REST_QUERY_CONSTANTS_;
        var qs = {};
        if (this.isDefault()) {
            return qs;
        }
        var orderBy;
        if (this.index_ === PriorityIndex_1.PRIORITY_INDEX) {
            orderBy = REST_CONSTANTS.PRIORITY_INDEX;
        }
        else if (this.index_ === ValueIndex_1.VALUE_INDEX) {
            orderBy = REST_CONSTANTS.VALUE_INDEX;
        }
        else if (this.index_ === KeyIndex_1.KEY_INDEX) {
            orderBy = REST_CONSTANTS.KEY_INDEX;
        }
        else {
            util_1.assert(this.index_ instanceof PathIndex_1.PathIndex, 'Unrecognized index type!');
            orderBy = this.index_.toString();
        }
        qs[REST_CONSTANTS.ORDER_BY] = util_3.stringify(orderBy);
        if (this.startSet_) {
            qs[REST_CONSTANTS.START_AT] = util_3.stringify(this.indexStartValue_);
            if (this.startNameSet_) {
                qs[REST_CONSTANTS.START_AT] += ',' + util_3.stringify(this.indexStartName_);
            }
        }
        if (this.endSet_) {
            qs[REST_CONSTANTS.END_AT] = util_3.stringify(this.indexEndValue_);
            if (this.endNameSet_) {
                qs[REST_CONSTANTS.END_AT] += ',' + util_3.stringify(this.indexEndName_);
            }
        }
        if (this.limitSet_) {
            if (this.isViewFromLeft()) {
                qs[REST_CONSTANTS.LIMIT_TO_FIRST] = this.limit_;
            }
            else {
                qs[REST_CONSTANTS.LIMIT_TO_LAST] = this.limit_;
            }
        }
        return qs;
    };
    /**
     * Wire Protocol Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.WIRE_PROTOCOL_CONSTANTS_ = {
        INDEX_START_VALUE: 'sp',
        INDEX_START_NAME: 'sn',
        INDEX_END_VALUE: 'ep',
        INDEX_END_NAME: 'en',
        LIMIT: 'l',
        VIEW_FROM: 'vf',
        VIEW_FROM_LEFT: 'l',
        VIEW_FROM_RIGHT: 'r',
        INDEX: 'i'
    };
    /**
     * REST Query Constants
     * @const
     * @enum {string}
     * @private
     */
    QueryParams.REST_QUERY_CONSTANTS_ = {
        ORDER_BY: 'orderBy',
        PRIORITY_INDEX: '$priority',
        VALUE_INDEX: '$value',
        KEY_INDEX: '$key',
        START_AT: 'startAt',
        END_AT: 'endAt',
        LIMIT_TO_FIRST: 'limitToFirst',
        LIMIT_TO_LAST: 'limitToLast'
    };
    /**
     * Default, empty query parameters
     * @type {!QueryParams}
     * @const
     */
    QueryParams.DEFAULT = new QueryParams();
    return QueryParams;
}());
exports.QueryParams = QueryParams;

//# sourceMappingURL=QueryParams.js.map


/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var RangedFilter_1 = __webpack_require__(485);
var ChildrenNode_1 = __webpack_require__(49);
var Node_1 = __webpack_require__(53);
var util_1 = __webpack_require__(6);
var Change_1 = __webpack_require__(119);
/**
 * Applies a limit and a range to a node and uses RangedFilter to do the heavy lifting where possible
 *
 * @constructor
 * @implements {NodeFilter}
 */
var LimitedFilter = /** @class */ (function () {
    /**
     * @param {!QueryParams} params
     */
    function LimitedFilter(params) {
        this.rangedFilter_ = new RangedFilter_1.RangedFilter(params);
        this.index_ = params.getIndex();
        this.limit_ = params.getLimit();
        this.reverse_ = !params.isViewFromLeft();
    }
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateChild = function (snap, key, newChild, affectedPath, source, optChangeAccumulator) {
        if (!this.rangedFilter_.matches(new Node_1.NamedNode(key, newChild))) {
            newChild = ChildrenNode_1.ChildrenNode.EMPTY_NODE;
        }
        if (snap.getImmediateChild(key).equals(newChild)) {
            // No change
            return snap;
        }
        else if (snap.numChildren() < this.limit_) {
            return this.rangedFilter_
                .getIndexedFilter()
                .updateChild(snap, key, newChild, affectedPath, source, optChangeAccumulator);
        }
        else {
            return this.fullLimitUpdateChild_(snap, key, newChild, source, optChangeAccumulator);
        }
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updateFullNode = function (oldSnap, newSnap, optChangeAccumulator) {
        var filtered;
        if (newSnap.isLeafNode() || newSnap.isEmpty()) {
            // Make sure we have a children node with the correct index, not a leaf node;
            filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
        }
        else {
            if (this.limit_ * 2 < newSnap.numChildren() &&
                newSnap.isIndexed(this.index_)) {
                // Easier to build up a snapshot, since what we're given has more than twice the elements we want
                filtered = ChildrenNode_1.ChildrenNode.EMPTY_NODE.withIndex(this.index_);
                // anchor to the startPost, endPost, or last element as appropriate
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = newSnap.getReverseIteratorFrom(this.rangedFilter_.getEndPost(), this.index_);
                }
                else {
                    iterator = newSnap.getIteratorFrom(this.rangedFilter_.getStartPost(), this.index_);
                }
                var count = 0;
                while (iterator.hasNext() && count < this.limit_) {
                    var next = iterator.getNext();
                    var inRange = void 0;
                    if (this.reverse_) {
                        inRange =
                            this.index_.compare(this.rangedFilter_.getStartPost(), next) <= 0;
                    }
                    else {
                        inRange =
                            this.index_.compare(next, this.rangedFilter_.getEndPost()) <= 0;
                    }
                    if (inRange) {
                        filtered = filtered.updateImmediateChild(next.name, next.node);
                        count++;
                    }
                    else {
                        // if we have reached the end post, we cannot keep adding elemments
                        break;
                    }
                }
            }
            else {
                // The snap contains less than twice the limit. Faster to delete from the snap than build up a new one
                filtered = newSnap.withIndex(this.index_);
                // Don't support priorities on queries
                filtered = filtered.updatePriority(ChildrenNode_1.ChildrenNode.EMPTY_NODE);
                var startPost = void 0;
                var endPost = void 0;
                var cmp = void 0;
                var iterator = void 0;
                if (this.reverse_) {
                    iterator = filtered.getReverseIterator(this.index_);
                    startPost = this.rangedFilter_.getEndPost();
                    endPost = this.rangedFilter_.getStartPost();
                    var indexCompare_1 = this.index_.getCompare();
                    cmp = function (a, b) { return indexCompare_1(b, a); };
                }
                else {
                    iterator = filtered.getIterator(this.index_);
                    startPost = this.rangedFilter_.getStartPost();
                    endPost = this.rangedFilter_.getEndPost();
                    cmp = this.index_.getCompare();
                }
                var count = 0;
                var foundStartPost = false;
                while (iterator.hasNext()) {
                    var next = iterator.getNext();
                    if (!foundStartPost && cmp(startPost, next) <= 0) {
                        // start adding
                        foundStartPost = true;
                    }
                    var inRange = foundStartPost && count < this.limit_ && cmp(next, endPost) <= 0;
                    if (inRange) {
                        count++;
                    }
                    else {
                        filtered = filtered.updateImmediateChild(next.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
                    }
                }
            }
        }
        return this.rangedFilter_
            .getIndexedFilter()
            .updateFullNode(oldSnap, filtered, optChangeAccumulator);
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.updatePriority = function (oldSnap, newPriority) {
        // Don't support priorities on queries
        return oldSnap;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.filtersNodes = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndexedFilter = function () {
        return this.rangedFilter_.getIndexedFilter();
    };
    /**
     * @inheritDoc
     */
    LimitedFilter.prototype.getIndex = function () {
        return this.index_;
    };
    /**
     * @param {!Node} snap
     * @param {string} childKey
     * @param {!Node} childSnap
     * @param {!CompleteChildSource} source
     * @param {?ChildChangeAccumulator} changeAccumulator
     * @return {!Node}
     * @private
     */
    LimitedFilter.prototype.fullLimitUpdateChild_ = function (snap, childKey, childSnap, source, changeAccumulator) {
        // TODO: rename all cache stuff etc to general snap terminology
        var cmp;
        if (this.reverse_) {
            var indexCmp_1 = this.index_.getCompare();
            cmp = function (a, b) { return indexCmp_1(b, a); };
        }
        else {
            cmp = this.index_.getCompare();
        }
        var oldEventCache = snap;
        util_1.assert(oldEventCache.numChildren() == this.limit_, '');
        var newChildNamedNode = new Node_1.NamedNode(childKey, childSnap);
        var windowBoundary = this.reverse_
            ? oldEventCache.getFirstChild(this.index_)
            : oldEventCache.getLastChild(this.index_);
        var inRange = this.rangedFilter_.matches(newChildNamedNode);
        if (oldEventCache.hasChild(childKey)) {
            var oldChildSnap = oldEventCache.getImmediateChild(childKey);
            var nextChild = source.getChildAfterChild(this.index_, windowBoundary, this.reverse_);
            while (nextChild != null &&
                (nextChild.name == childKey || oldEventCache.hasChild(nextChild.name))) {
                // There is a weird edge case where a node is updated as part of a merge in the write tree, but hasn't
                // been applied to the limited filter yet. Ignore this next child which will be updated later in
                // the limited filter...
                nextChild = source.getChildAfterChild(this.index_, nextChild, this.reverse_);
            }
            var compareNext = nextChild == null ? 1 : cmp(nextChild, newChildNamedNode);
            var remainsInWindow = inRange && !childSnap.isEmpty() && compareNext >= 0;
            if (remainsInWindow) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change_1.Change.childChangedChange(childKey, childSnap, oldChildSnap));
                }
                return oldEventCache.updateImmediateChild(childKey, childSnap);
            }
            else {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(childKey, oldChildSnap));
                }
                var newEventCache = oldEventCache.updateImmediateChild(childKey, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
                var nextChildInRange = nextChild != null && this.rangedFilter_.matches(nextChild);
                if (nextChildInRange) {
                    if (changeAccumulator != null) {
                        changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(nextChild.name, nextChild.node));
                    }
                    return newEventCache.updateImmediateChild(nextChild.name, nextChild.node);
                }
                else {
                    return newEventCache;
                }
            }
        }
        else if (childSnap.isEmpty()) {
            // we're deleting a node, but it was not in the window, so ignore it
            return snap;
        }
        else if (inRange) {
            if (cmp(windowBoundary, newChildNamedNode) >= 0) {
                if (changeAccumulator != null) {
                    changeAccumulator.trackChildChange(Change_1.Change.childRemovedChange(windowBoundary.name, windowBoundary.node));
                    changeAccumulator.trackChildChange(Change_1.Change.childAddedChange(childKey, childSnap));
                }
                return oldEventCache
                    .updateImmediateChild(childKey, childSnap)
                    .updateImmediateChild(windowBoundary.name, ChildrenNode_1.ChildrenNode.EMPTY_NODE);
            }
            else {
                return snap;
            }
        }
        else {
            return snap;
        }
    };
    return LimitedFilter;
}());
exports.LimitedFilter = LimitedFilter;

//# sourceMappingURL=LimitedFilter.js.map


/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Reference_1 = __webpack_require__(268);
var DataSnapshot_1 = __webpack_require__(269);
var Path_1 = __webpack_require__(29);
var Tree_1 = __webpack_require__(1227);
var PriorityIndex_1 = __webpack_require__(42);
var util_2 = __webpack_require__(21);
var ServerValues_1 = __webpack_require__(472);
var validation_1 = __webpack_require__(94);
var util_3 = __webpack_require__(6);
var nodeFromJSON_1 = __webpack_require__(146);
var ChildrenNode_1 = __webpack_require__(49);
var Repo_1 = __webpack_require__(187);
// TODO: This is pretty messy.  Ideally, a lot of this would move into FirebaseData, or a transaction-specific
// component used by FirebaseData, but it has ties to user callbacks (transaction update and onComplete) as well
// as the realtime connection (to send transactions to the server).  So that all needs to be decoupled first.
// For now it's part of Repo, but in its own file.
/**
 * @enum {number}
 */
var TransactionStatus;
(function (TransactionStatus) {
    // We've run the transaction and updated transactionResultData_ with the result, but it isn't currently sent to the
    // server. A transaction will go from RUN -> SENT -> RUN if it comes back from the server as rejected due to
    // mismatched hash.
    TransactionStatus[TransactionStatus["RUN"] = 0] = "RUN";
    // We've run the transaction and sent it to the server and it's currently outstanding (hasn't come back as accepted
    // or rejected yet).
    TransactionStatus[TransactionStatus["SENT"] = 1] = "SENT";
    // Temporary state used to mark completed transactions (whether successful or aborted).  The transaction will be
    // removed when we get a chance to prune completed ones.
    TransactionStatus[TransactionStatus["COMPLETED"] = 2] = "COMPLETED";
    // Used when an already-sent transaction needs to be aborted (e.g. due to a conflicting set() call that was made).
    // If it comes back as unsuccessful, we'll abort it.
    TransactionStatus[TransactionStatus["SENT_NEEDS_ABORT"] = 3] = "SENT_NEEDS_ABORT";
    // Temporary state used to mark transactions that need to be aborted.
    TransactionStatus[TransactionStatus["NEEDS_ABORT"] = 4] = "NEEDS_ABORT";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
/**
 * If a transaction does not succeed after 25 retries, we abort it.  Among other things this ensure that if there's
 * ever a bug causing a mismatch between client / server hashes for some data, we won't retry indefinitely.
 * @type {number}
 * @const
 * @private
 */
Repo_1.Repo.MAX_TRANSACTION_RETRIES_ = 25;
/**
 * Setup the transaction data structures
 * @private
 */
Repo_1.Repo.prototype.transactions_init_ = function () {
    /**
     * Stores queues of outstanding transactions for Firebase locations.
     *
     * @type {!Tree.<Array.<!Transaction>>}
     * @private
     */
    this.transactionQueueTree_ = new Tree_1.Tree();
};
/**
 * Creates a new transaction, adds it to the transactions we're tracking, and sends it to the server if possible.
 *
 * @param {!Path} path Path at which to do transaction.
 * @param {function(*):*} transactionUpdate Update callback.
 * @param {?function(?Error, boolean, ?DataSnapshot)} onComplete Completion callback.
 * @param {boolean} applyLocally Whether or not to make intermediate results visible
 */
Repo_1.Repo.prototype.startTransaction = function (path, transactionUpdate, onComplete, applyLocally) {
    this.log_('transaction on ' + path);
    // Add a watch to make sure we get server updates.
    var valueCallback = function () { };
    var watchRef = new Reference_1.Reference(this, path);
    watchRef.on('value', valueCallback);
    var unwatcher = function () {
        watchRef.off('value', valueCallback);
    };
    // Initialize transaction.
    var transaction = {
        path: path,
        update: transactionUpdate,
        onComplete: onComplete,
        // One of TransactionStatus enums.
        status: null,
        // Used when combining transactions at different locations to figure out which one goes first.
        order: util_2.LUIDGenerator(),
        // Whether to raise local events for this transaction.
        applyLocally: applyLocally,
        // Count of how many times we've retried the transaction.
        retryCount: 0,
        // Function to call to clean up our .on() listener.
        unwatcher: unwatcher,
        // Stores why a transaction was aborted.
        abortReason: null,
        currentWriteId: null,
        currentInputSnapshot: null,
        currentOutputSnapshotRaw: null,
        currentOutputSnapshotResolved: null
    };
    // Run transaction initially.
    var currentState = this.getLatestState_(path);
    transaction.currentInputSnapshot = currentState;
    var newVal = transaction.update(currentState.val());
    if (newVal === undefined) {
        // Abort transaction.
        transaction.unwatcher();
        transaction.currentOutputSnapshotRaw = null;
        transaction.currentOutputSnapshotResolved = null;
        if (transaction.onComplete) {
            // We just set the input snapshot, so this cast should be safe
            var snapshot = new DataSnapshot_1.DataSnapshot(transaction.currentInputSnapshot, new Reference_1.Reference(this, transaction.path), PriorityIndex_1.PRIORITY_INDEX);
            transaction.onComplete(null, false, snapshot);
        }
    }
    else {
        validation_1.validateFirebaseData('transaction failed: Data returned ', newVal, transaction.path);
        // Mark as run and add to our queue.
        transaction.status = TransactionStatus.RUN;
        var queueNode = this.transactionQueueTree_.subTree(path);
        var nodeQueue = queueNode.getValue() || [];
        nodeQueue.push(transaction);
        queueNode.setValue(nodeQueue);
        // Update visibleData and raise events
        // Note: We intentionally raise events after updating all of our transaction state, since the user could
        // start new transactions from the event callbacks.
        var priorityForNode = void 0;
        if (typeof newVal === 'object' &&
            newVal !== null &&
            util_3.contains(newVal, '.priority')) {
            priorityForNode = util_3.safeGet(newVal, '.priority');
            util_1.assert(validation_1.isValidPriority(priorityForNode), 'Invalid priority returned by transaction. ' +
                'Priority must be a valid string, finite number, server value, or null.');
        }
        else {
            var currentNode = this.serverSyncTree_.calcCompleteEventCache(path) ||
                ChildrenNode_1.ChildrenNode.EMPTY_NODE;
            priorityForNode = currentNode.getPriority().val();
        }
        priorityForNode /** @type {null|number|string} */ = priorityForNode;
        var serverValues = this.generateServerValues();
        var newNodeUnresolved = nodeFromJSON_1.nodeFromJSON(newVal, priorityForNode);
        var newNode = ServerValues_1.resolveDeferredValueSnapshot(newNodeUnresolved, serverValues);
        transaction.currentOutputSnapshotRaw = newNodeUnresolved;
        transaction.currentOutputSnapshotResolved = newNode;
        transaction.currentWriteId = this.getNextWriteId_();
        var events = this.serverSyncTree_.applyUserOverwrite(path, newNode, transaction.currentWriteId, transaction.applyLocally);
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        this.sendReadyTransactions_();
    }
};
/**
 * @param {!Path} path
 * @param {Array.<number>=} excludeSets A specific set to exclude
 * @return {Node}
 * @private
 */
Repo_1.Repo.prototype.getLatestState_ = function (path, excludeSets) {
    return (this.serverSyncTree_.calcCompleteEventCache(path, excludeSets) ||
        ChildrenNode_1.ChildrenNode.EMPTY_NODE);
};
/**
 * Sends any already-run transactions that aren't waiting for outstanding transactions to
 * complete.
 *
 * Externally it's called with no arguments, but it calls itself recursively with a particular
 * transactionQueueTree node to recurse through the tree.
 *
 * @param {Tree.<Array.<Transaction>>=} node  transactionQueueTree node to start at.
 * @private
 */
Repo_1.Repo.prototype.sendReadyTransactions_ = function (node) {
    var _this = this;
    if (node === void 0) { node = this.transactionQueueTree_; }
    // Before recursing, make sure any completed transactions are removed.
    if (!node) {
        this.pruneCompletedTransactionsBelowNode_(node);
    }
    if (node.getValue() !== null) {
        var queue = this.buildTransactionQueue_(node);
        util_1.assert(queue.length > 0, 'Sending zero length transaction queue');
        var allRun = queue.every(function (transaction) { return transaction.status === TransactionStatus.RUN; });
        // If they're all run (and not sent), we can send them.  Else, we must wait.
        if (allRun) {
            this.sendTransactionQueue_(node.path(), queue);
        }
    }
    else if (node.hasChildren()) {
        node.forEachChild(function (childNode) {
            _this.sendReadyTransactions_(childNode);
        });
    }
};
/**
 * Given a list of run transactions, send them to the server and then handle the result (success or failure).
 *
 * @param {!Path} path The location of the queue.
 * @param {!Array.<Transaction>} queue Queue of transactions under the specified location.
 * @private
 */
Repo_1.Repo.prototype.sendTransactionQueue_ = function (path, queue) {
    var _this = this;
    // Mark transactions as sent and increment retry count!
    var setsToIgnore = queue.map(function (txn) {
        return txn.currentWriteId;
    });
    var latestState = this.getLatestState_(path, setsToIgnore);
    var snapToSend = latestState;
    var latestHash = latestState.hash();
    for (var i = 0; i < queue.length; i++) {
        var txn = queue[i];
        util_1.assert(txn.status === TransactionStatus.RUN, 'tryToSendTransactionQueue_: items in queue should all be run.');
        txn.status = TransactionStatus.SENT;
        txn.retryCount++;
        var relativePath = Path_1.Path.relativePath(path, txn.path);
        // If we've gotten to this point, the output snapshot must be defined.
        snapToSend = snapToSend.updateChild(relativePath /**@type {!Node} */, txn.currentOutputSnapshotRaw);
    }
    var dataToSend = snapToSend.val(true);
    var pathToSend = path;
    // Send the put.
    this.server_.put(pathToSend.toString(), dataToSend, function (status) {
        _this.log_('transaction put response', {
            path: pathToSend.toString(),
            status: status
        });
        var events = [];
        if (status === 'ok') {
            // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
            // the callback could trigger more transactions or sets.
            var callbacks = [];
            for (var i = 0; i < queue.length; i++) {
                queue[i].status = TransactionStatus.COMPLETED;
                events = events.concat(_this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId));
                if (queue[i].onComplete) {
                    // We never unset the output snapshot, and given that this transaction is complete, it should be set
                    var node = queue[i].currentOutputSnapshotResolved;
                    var ref = new Reference_1.Reference(_this, queue[i].path);
                    var snapshot = new DataSnapshot_1.DataSnapshot(node, ref, PriorityIndex_1.PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, true, snapshot));
                }
                queue[i].unwatcher();
            }
            // Now remove the completed transactions.
            _this.pruneCompletedTransactionsBelowNode_(_this.transactionQueueTree_.subTree(path));
            // There may be pending transactions that we can now send.
            _this.sendReadyTransactions_();
            _this.eventQueue_.raiseEventsForChangedPath(path, events);
            // Finally, trigger onComplete callbacks.
            for (var i = 0; i < callbacks.length; i++) {
                util_2.exceptionGuard(callbacks[i]);
            }
        }
        else {
            // transactions are no longer sent.  Update their status appropriately.
            if (status === 'datastale') {
                for (var i = 0; i < queue.length; i++) {
                    if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT)
                        queue[i].status = TransactionStatus.NEEDS_ABORT;
                    else
                        queue[i].status = TransactionStatus.RUN;
                }
            }
            else {
                util_2.warn('transaction at ' + pathToSend.toString() + ' failed: ' + status);
                for (var i = 0; i < queue.length; i++) {
                    queue[i].status = TransactionStatus.NEEDS_ABORT;
                    queue[i].abortReason = status;
                }
            }
            _this.rerunTransactions_(path);
        }
    }, latestHash);
};
/**
 * Finds all transactions dependent on the data at changedPath and reruns them.
 *
 * Should be called any time cached data changes.
 *
 * Return the highest path that was affected by rerunning transactions.  This is the path at which events need to
 * be raised for.
 *
 * @param {!Path} changedPath The path in mergedData that changed.
 * @return {!Path} The rootmost path that was affected by rerunning transactions.
 * @private
 */
Repo_1.Repo.prototype.rerunTransactions_ = function (changedPath) {
    var rootMostTransactionNode = this.getAncestorTransactionNode_(changedPath);
    var path = rootMostTransactionNode.path();
    var queue = this.buildTransactionQueue_(rootMostTransactionNode);
    this.rerunTransactionQueue_(queue, path);
    return path;
};
/**
 * Does all the work of rerunning transactions (as well as cleans up aborted transactions and whatnot).
 *
 * @param {Array.<Transaction>} queue The queue of transactions to run.
 * @param {!Path} path The path the queue is for.
 * @private
 */
Repo_1.Repo.prototype.rerunTransactionQueue_ = function (queue, path) {
    if (queue.length === 0) {
        return; // Nothing to do!
    }
    // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
    // the callback could trigger more transactions or sets.
    var callbacks = [];
    var events = [];
    // Ignore all of the sets we're going to re-run.
    var txnsToRerun = queue.filter(function (q) {
        return q.status === TransactionStatus.RUN;
    });
    var setsToIgnore = txnsToRerun.map(function (q) {
        return q.currentWriteId;
    });
    for (var i = 0; i < queue.length; i++) {
        var transaction = queue[i];
        var relativePath = Path_1.Path.relativePath(path, transaction.path);
        var abortTransaction = false, abortReason = void 0;
        util_1.assert(relativePath !== null, 'rerunTransactionsUnderNode_: relativePath should not be null.');
        if (transaction.status === TransactionStatus.NEEDS_ABORT) {
            abortTransaction = true;
            abortReason = transaction.abortReason;
            events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
        }
        else if (transaction.status === TransactionStatus.RUN) {
            if (transaction.retryCount >= Repo_1.Repo.MAX_TRANSACTION_RETRIES_) {
                abortTransaction = true;
                abortReason = 'maxretry';
                events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
            }
            else {
                // This code reruns a transaction
                var currentNode = this.getLatestState_(transaction.path, setsToIgnore);
                transaction.currentInputSnapshot = currentNode;
                var newData = queue[i].update(currentNode.val());
                if (newData !== undefined) {
                    validation_1.validateFirebaseData('transaction failed: Data returned ', newData, transaction.path);
                    var newDataNode = nodeFromJSON_1.nodeFromJSON(newData);
                    var hasExplicitPriority = typeof newData === 'object' &&
                        newData != null &&
                        util_3.contains(newData, '.priority');
                    if (!hasExplicitPriority) {
                        // Keep the old priority if there wasn't a priority explicitly specified.
                        newDataNode = newDataNode.updatePriority(currentNode.getPriority());
                    }
                    var oldWriteId = transaction.currentWriteId;
                    var serverValues = this.generateServerValues();
                    var newNodeResolved = ServerValues_1.resolveDeferredValueSnapshot(newDataNode, serverValues);
                    transaction.currentOutputSnapshotRaw = newDataNode;
                    transaction.currentOutputSnapshotResolved = newNodeResolved;
                    transaction.currentWriteId = this.getNextWriteId_();
                    // Mutates setsToIgnore in place
                    setsToIgnore.splice(setsToIgnore.indexOf(oldWriteId), 1);
                    events = events.concat(this.serverSyncTree_.applyUserOverwrite(transaction.path, newNodeResolved, transaction.currentWriteId, transaction.applyLocally));
                    events = events.concat(this.serverSyncTree_.ackUserWrite(oldWriteId, true));
                }
                else {
                    abortTransaction = true;
                    abortReason = 'nodata';
                    events = events.concat(this.serverSyncTree_.ackUserWrite(transaction.currentWriteId, true));
                }
            }
        }
        this.eventQueue_.raiseEventsForChangedPath(path, events);
        events = [];
        if (abortTransaction) {
            // Abort.
            queue[i].status = TransactionStatus.COMPLETED;
            // Removing a listener can trigger pruning which can muck with mergedData/visibleData (as it prunes data).
            // So defer the unwatcher until we're done.
            (function (unwatcher) {
                setTimeout(unwatcher, Math.floor(0));
            })(queue[i].unwatcher);
            if (queue[i].onComplete) {
                if (abortReason === 'nodata') {
                    var ref = new Reference_1.Reference(this, queue[i].path);
                    // We set this field immediately, so it's safe to cast to an actual snapshot
                    var lastInput /** @type {!Node} */ = queue[i].currentInputSnapshot;
                    var snapshot = new DataSnapshot_1.DataSnapshot(lastInput, ref, PriorityIndex_1.PRIORITY_INDEX);
                    callbacks.push(queue[i].onComplete.bind(null, null, false, snapshot));
                }
                else {
                    callbacks.push(queue[i].onComplete.bind(null, new Error(abortReason), false, null));
                }
            }
        }
    }
    // Clean up completed transactions.
    this.pruneCompletedTransactionsBelowNode_(this.transactionQueueTree_);
    // Now fire callbacks, now that we're in a good, known state.
    for (var i = 0; i < callbacks.length; i++) {
        util_2.exceptionGuard(callbacks[i]);
    }
    // Try to send the transaction result to the server.
    this.sendReadyTransactions_();
};
/**
 * Returns the rootmost ancestor node of the specified path that has a pending transaction on it, or just returns
 * the node for the given path if there are no pending transactions on any ancestor.
 *
 * @param {!Path} path The location to start at.
 * @return {!Tree.<Array.<!Transaction>>} The rootmost node with a transaction.
 * @private
 */
Repo_1.Repo.prototype.getAncestorTransactionNode_ = function (path) {
    var front;
    // Start at the root and walk deeper into the tree towards path until we find a node with pending transactions.
    var transactionNode = this.transactionQueueTree_;
    while ((front = path.getFront()) !== null &&
        transactionNode.getValue() === null) {
        transactionNode = transactionNode.subTree(front);
        path = path.popFront();
    }
    return transactionNode;
};
/**
 * Builds the queue of all transactions at or below the specified transactionNode.
 *
 * @param {!Tree.<Array.<Transaction>>} transactionNode
 * @return {Array.<Transaction>} The generated queue.
 * @private
 */
Repo_1.Repo.prototype.buildTransactionQueue_ = function (transactionNode) {
    // Walk any child transaction queues and aggregate them into a single queue.
    var transactionQueue = [];
    this.aggregateTransactionQueuesForNode_(transactionNode, transactionQueue);
    // Sort them by the order the transactions were created.
    transactionQueue.sort(function (a, b) {
        return a.order - b.order;
    });
    return transactionQueue;
};
/**
 * @param {!Tree.<Array.<Transaction>>} node
 * @param {Array.<Transaction>} queue
 * @private
 */
Repo_1.Repo.prototype.aggregateTransactionQueuesForNode_ = function (node, queue) {
    var _this = this;
    var nodeQueue = node.getValue();
    if (nodeQueue !== null) {
        for (var i = 0; i < nodeQueue.length; i++) {
            queue.push(nodeQueue[i]);
        }
    }
    node.forEachChild(function (child) {
        _this.aggregateTransactionQueuesForNode_(child, queue);
    });
};
/**
 * Remove COMPLETED transactions at or below this node in the transactionQueueTree_.
 *
 * @param {!Tree.<Array.<!Transaction>>} node
 * @private
 */
Repo_1.Repo.prototype.pruneCompletedTransactionsBelowNode_ = function (node) {
    var _this = this;
    var queue = node.getValue();
    if (queue) {
        var to = 0;
        for (var from = 0; from < queue.length; from++) {
            if (queue[from].status !== TransactionStatus.COMPLETED) {
                queue[to] = queue[from];
                to++;
            }
        }
        queue.length = to;
        node.setValue(queue.length > 0 ? queue : null);
    }
    node.forEachChild(function (childNode) {
        _this.pruneCompletedTransactionsBelowNode_(childNode);
    });
};
/**
 * Aborts all transactions on ancestors or descendants of the specified path.  Called when doing a set() or update()
 * since we consider them incompatible with transactions.
 *
 * @param {!Path} path Path for which we want to abort related transactions.
 * @return {!Path}
 * @private
 */
Repo_1.Repo.prototype.abortTransactions_ = function (path) {
    var _this = this;
    var affectedPath = this.getAncestorTransactionNode_(path).path();
    var transactionNode = this.transactionQueueTree_.subTree(path);
    transactionNode.forEachAncestor(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    this.abortTransactionsOnNode_(transactionNode);
    transactionNode.forEachDescendant(function (node) {
        _this.abortTransactionsOnNode_(node);
    });
    return affectedPath;
};
/**
 * Abort transactions stored in this transaction queue node.
 *
 * @param {!Tree.<Array.<Transaction>>} node Node to abort transactions for.
 * @private
 */
Repo_1.Repo.prototype.abortTransactionsOnNode_ = function (node) {
    var queue = node.getValue();
    if (queue !== null) {
        // Queue up the callbacks and fire them after cleaning up all of our transaction state, since
        // the callback could trigger more transactions or sets.
        var callbacks = [];
        // Go through queue.  Any already-sent transactions must be marked for abort, while the unsent ones
        // can be immediately aborted and removed.
        var events = [];
        var lastSent = -1;
        for (var i = 0; i < queue.length; i++) {
            if (queue[i].status === TransactionStatus.SENT_NEEDS_ABORT) {
                // Already marked.  No action needed.
            }
            else if (queue[i].status === TransactionStatus.SENT) {
                util_1.assert(lastSent === i - 1, 'All SENT items should be at beginning of queue.');
                lastSent = i;
                // Mark transaction for abort when it comes back.
                queue[i].status = TransactionStatus.SENT_NEEDS_ABORT;
                queue[i].abortReason = 'set';
            }
            else {
                util_1.assert(queue[i].status === TransactionStatus.RUN, 'Unexpected transaction status in abort');
                // We can abort it immediately.
                queue[i].unwatcher();
                events = events.concat(this.serverSyncTree_.ackUserWrite(queue[i].currentWriteId, true));
                if (queue[i].onComplete) {
                    var snapshot = null;
                    callbacks.push(queue[i].onComplete.bind(null, new Error('set'), false, snapshot));
                }
            }
        }
        if (lastSent === -1) {
            // We're not waiting for any sent transactions.  We can clear the queue.
            node.setValue(null);
        }
        else {
            // Remove the transactions we aborted.
            queue.length = lastSent + 1;
        }
        // Now fire the callbacks.
        this.eventQueue_.raiseEventsForChangedPath(node.path(), events);
        for (var i = 0; i < callbacks.length; i++) {
            util_2.exceptionGuard(callbacks[i]);
        }
    }
};

//# sourceMappingURL=Repo_transaction.js.map


/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var util_1 = __webpack_require__(6);
var Path_1 = __webpack_require__(29);
var util_2 = __webpack_require__(6);
/**
 * Node in a Tree.
 */
var TreeNode = /** @class */ (function () {
    function TreeNode() {
        // TODO: Consider making accessors that create children and value lazily or
        // separate Internal / Leaf 'types'.
        this.children = {};
        this.childCount = 0;
        this.value = null;
    }
    return TreeNode;
}());
exports.TreeNode = TreeNode;
/**
 * A light-weight tree, traversable by path.  Nodes can have both values and children.
 * Nodes are not enumerated (by forEachChild) unless they have a value or non-empty
 * children.
 */
var Tree = /** @class */ (function () {
    /**
     * @template T
     * @param {string=} name_ Optional name of the node.
     * @param {Tree=} parent_ Optional parent node.
     * @param {TreeNode=} node_ Optional node to wrap.
     */
    function Tree(name_, parent_, node_) {
        if (name_ === void 0) { name_ = ''; }
        if (parent_ === void 0) { parent_ = null; }
        if (node_ === void 0) { node_ = new TreeNode(); }
        this.name_ = name_;
        this.parent_ = parent_;
        this.node_ = node_;
    }
    /**
     * Returns a sub-Tree for the given path.
     *
     * @param {!(string|Path)} pathObj Path to look up.
     * @return {!Tree.<T>} Tree for path.
     */
    Tree.prototype.subTree = function (pathObj) {
        // TODO: Require pathObj to be Path?
        var path = pathObj instanceof Path_1.Path ? pathObj : new Path_1.Path(pathObj);
        var child = this, next;
        while ((next = path.getFront()) !== null) {
            var childNode = util_2.safeGet(child.node_.children, next) || new TreeNode();
            child = new Tree(next, child, childNode);
            path = path.popFront();
        }
        return child;
    };
    /**
     * Returns the data associated with this tree node.
     *
     * @return {?T} The data or null if no data exists.
     */
    Tree.prototype.getValue = function () {
        return this.node_.value;
    };
    /**
     * Sets data to this tree node.
     *
     * @param {!T} value Value to set.
     */
    Tree.prototype.setValue = function (value) {
        util_1.assert(typeof value !== 'undefined', 'Cannot set value to undefined');
        this.node_.value = value;
        this.updateParents_();
    };
    /**
     * Clears the contents of the tree node (its value and all children).
     */
    Tree.prototype.clear = function () {
        this.node_.value = null;
        this.node_.children = {};
        this.node_.childCount = 0;
        this.updateParents_();
    };
    /**
     * @return {boolean} Whether the tree has any children.
     */
    Tree.prototype.hasChildren = function () {
        return this.node_.childCount > 0;
    };
    /**
     * @return {boolean} Whether the tree is empty (no value or children).
     */
    Tree.prototype.isEmpty = function () {
        return this.getValue() === null && !this.hasChildren();
    };
    /**
     * Calls action for each child of this tree node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachChild = function (action) {
        var _this = this;
        util_2.forEach(this.node_.children, function (child, childTree) {
            action(new Tree(child, _this, childTree));
        });
    };
    /**
     * Does a depth-first traversal of this node's descendants, calling action for each one.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     * @param {boolean=} includeSelf Whether to call action on this node as well. Defaults to
     *   false.
     * @param {boolean=} childrenFirst Whether to call action on children before calling it on
     *   parent.
     */
    Tree.prototype.forEachDescendant = function (action, includeSelf, childrenFirst) {
        if (includeSelf && !childrenFirst)
            action(this);
        this.forEachChild(function (child) {
            child.forEachDescendant(action, /*includeSelf=*/ true, childrenFirst);
        });
        if (includeSelf && childrenFirst)
            action(this);
    };
    /**
     * Calls action on each ancestor node.
     *
     * @param {function(!Tree.<T>)} action Action to be called on each parent; return
     *   true to abort.
     * @param {boolean=} includeSelf Whether to call action on this node as well.
     * @return {boolean} true if the action callback returned true.
     */
    Tree.prototype.forEachAncestor = function (action, includeSelf) {
        var node = includeSelf ? this : this.parent();
        while (node !== null) {
            if (action(node)) {
                return true;
            }
            node = node.parent();
        }
        return false;
    };
    /**
     * Does a depth-first traversal of this node's descendants.  When a descendant with a value
     * is found, action is called on it and traversal does not continue inside the node.
     * Action is *not* called on this node.
     *
     * @param {function(!Tree.<T>)} action Action to be called for each child.
     */
    Tree.prototype.forEachImmediateDescendantWithValue = function (action) {
        this.forEachChild(function (child) {
            if (child.getValue() !== null)
                action(child);
            else
                child.forEachImmediateDescendantWithValue(action);
        });
    };
    /**
     * @return {!Path} The path of this tree node, as a Path.
     */
    Tree.prototype.path = function () {
        return new Path_1.Path(this.parent_ === null
            ? this.name_
            : this.parent_.path() + '/' + this.name_);
    };
    /**
     * @return {string} The name of the tree node.
     */
    Tree.prototype.name = function () {
        return this.name_;
    };
    /**
     * @return {?Tree} The parent tree node, or null if this is the root of the tree.
     */
    Tree.prototype.parent = function () {
        return this.parent_;
    };
    /**
     * Adds or removes this child from its parent based on whether it's empty or not.
     *
     * @private
     */
    Tree.prototype.updateParents_ = function () {
        if (this.parent_ !== null)
            this.parent_.updateChild_(this.name_, this);
    };
    /**
     * Adds or removes the passed child to this tree node, depending on whether it's empty.
     *
     * @param {string} childName The name of the child to update.
     * @param {!Tree.<T>} child The child to update.
     * @private
     */
    Tree.prototype.updateChild_ = function (childName, child) {
        var childEmpty = child.isEmpty();
        var childExists = util_2.contains(this.node_.children, childName);
        if (childEmpty && childExists) {
            delete this.node_.children[childName];
            this.node_.childCount--;
            this.updateParents_();
        }
        else if (!childEmpty && !childExists) {
            this.node_.children[childName] = child.node_;
            this.node_.childCount++;
            this.updateParents_();
        }
    };
    return Tree;
}());
exports.Tree = Tree;

//# sourceMappingURL=Tree.js.map


/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var WebSocketConnection_1 = __webpack_require__(483);
var BrowserPollConnection_1 = __webpack_require__(482);
/**
 * INTERNAL methods for internal-use only (tests, etc.).
 *
 * Customers shouldn't use these or else should be aware that they could break at any time.
 *
 * @const
 */
exports.forceLongPolling = function () {
    WebSocketConnection_1.WebSocketConnection.forceDisallow();
    BrowserPollConnection_1.BrowserPollConnection.forceAllow();
};
exports.forceWebSockets = function () {
    BrowserPollConnection_1.BrowserPollConnection.forceDisallow();
};
/* Used by App Manager */
exports.isWebSocketsAvailable = function () {
    return WebSocketConnection_1.WebSocketConnection['isAvailable']();
};
exports.setSecurityDebugCallback = function (ref, callback) {
    ref.repo.persistentConnection_.securityDebugCallback_ = callback;
};
exports.stats = function (ref, showDelta) {
    ref.repo.stats(showDelta);
};
exports.statsIncrementCounter = function (ref, metric) {
    ref.repo.statsIncrementCounter(metric);
};
exports.dataUpdateCount = function (ref) {
    return ref.repo.dataUpdateCount;
};
exports.interceptServerData = function (ref, callback) {
    return ref.repo.interceptServerData_(callback);
};

//# sourceMappingURL=internal.js.map


/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var RepoInfo_1 = __webpack_require__(463);
var PersistentConnection_1 = __webpack_require__(479);
var RepoManager_1 = __webpack_require__(273);
var Connection_1 = __webpack_require__(481);
exports.DataConnection = PersistentConnection_1.PersistentConnection;
/**
 * @param {!string} pathString
 * @param {function(*)} onComplete
 */
PersistentConnection_1.PersistentConnection.prototype.simpleListen = function (pathString, onComplete) {
    this.sendRequest('q', { p: pathString }, onComplete);
};
/**
 * @param {*} data
 * @param {function(*)} onEcho
 */
PersistentConnection_1.PersistentConnection.prototype.echo = function (data, onEcho) {
    this.sendRequest('echo', { d: data }, onEcho);
};
// RealTimeConnection properties that we use in tests.
exports.RealTimeConnection = Connection_1.Connection;
/**
 * @param {function(): string} newHash
 * @return {function()}
 */
exports.hijackHash = function (newHash) {
    var oldPut = PersistentConnection_1.PersistentConnection.prototype.put;
    PersistentConnection_1.PersistentConnection.prototype.put = function (pathString, data, opt_onComplete, opt_hash) {
        if (opt_hash !== undefined) {
            opt_hash = newHash();
        }
        oldPut.call(this, pathString, data, opt_onComplete, opt_hash);
    };
    return function () {
        PersistentConnection_1.PersistentConnection.prototype.put = oldPut;
    };
};
/**
 * @type {function(new:RepoInfo, !string, boolean, !string, boolean): undefined}
 */
exports.ConnectionTarget = RepoInfo_1.RepoInfo;
/**
 * @param {!Query} query
 * @return {!string}
 */
exports.queryIdentifier = function (query) {
    return query.queryIdentifier();
};
/**
 * @param {!Query} firebaseRef
 * @return {!Object}
 */
exports.listens = function (firebaseRef) {
    return firebaseRef.repo.persistentConnection_.listens_;
};
/**
 * Forces the RepoManager to create Repos that use ReadonlyRestClient instead of PersistentConnection.
 *
 * @param {boolean} forceRestClient
 */
exports.forceRestClient = function (forceRestClient) {
    RepoManager_1.RepoManager.getInstance().forceRestClient(forceRestClient);
};

//# sourceMappingURL=test_access.js.map


/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1231);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["registerMessaging"] = registerMessaging;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__src_controllers_window_controller__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__src_controllers_sw_controller__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__firebase_app__ = __webpack_require__(93);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */




function registerMessaging(instance) {
    var messagingName = 'messaging';
    var factoryMethod = function (app) {
        if (self && 'ServiceWorkerGlobalScope' in self) {
            return new __WEBPACK_IMPORTED_MODULE_1__src_controllers_sw_controller__["a" /* default */](app);
        }
        // Assume we are in the window context.
        return new __WEBPACK_IMPORTED_MODULE_0__src_controllers_window_controller__["a" /* default */](app);
    };
    var namespaceExports = {
        // no-inline
        Messaging: __WEBPACK_IMPORTED_MODULE_0__src_controllers_window_controller__["a" /* default */]
    };
    instance.INTERNAL.registerService(messagingName, factoryMethod, namespaceExports);
}
registerMessaging(__WEBPACK_IMPORTED_MODULE_2__firebase_app__["firebase"]);

//# sourceMappingURL=index.js.map


/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_interface__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_errors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_default_sw__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__models_notification_permission__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_util__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__firebase_util__);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();






var WindowController = /** @class */ (function (_super) {
    __extends(WindowController, _super);
    /**
     * A service that provides a MessagingService instance.
     * @param {!firebase.app.App} app
     */
    function WindowController(app) {
        var _this = _super.call(this, app) || this;
        _this.messageObserver_ = null;
        _this.onMessage_ = Object(__WEBPACK_IMPORTED_MODULE_5__firebase_util__["createSubscribe"])(function (observer) {
            _this.messageObserver_ = observer;
        });
        _this.tokenRefreshObserver_ = null;
        _this.onTokenRefresh_ = Object(__WEBPACK_IMPORTED_MODULE_5__firebase_util__["createSubscribe"])(function (observer) {
            _this.tokenRefreshObserver_ = observer;
        });
        _this.setupSWMessageListener_();
        return _this;
    }
    /**
     * This method returns an FCM token if it can be generated.
     * The return promise will reject if the browser doesn't support
     * FCM, if permission is denied for notifications or it's not
     * possible to generate a token.
     * @export
     * @return {Promise<string> | Promise<null>} Returns a promise the
     * resolves to an FCM token or null if permission isn't granted.
     */
    WindowController.prototype.getToken = function () {
        var _this = this;
        // Check that the required API's are available
        if (!this.isSupported_()) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.UNSUPPORTED_BROWSER));
        }
        return this.manifestCheck_().then(function () {
            return _super.prototype.getToken.call(_this);
        });
    };
    /**
     * The method checks that a manifest is defined and has the correct GCM
     * sender ID.
     * @private
     * @return {Promise} Returns a promise that resolves if the manifest matches
     * our required sender ID
     */
    WindowController.prototype.manifestCheck_ = function () {
        var _this = this;
        if (this.manifestCheckPromise_) {
            return this.manifestCheckPromise_;
        }
        var manifestTag = document.querySelector('link[rel="manifest"]');
        if (!manifestTag) {
            this.manifestCheckPromise_ = Promise.resolve();
        }
        else {
            this.manifestCheckPromise_ = fetch(manifestTag.href)
                .then(function (response) {
                return response.json();
            })
                .catch(function () {
                // If the download or parsing fails allow check.
                // We only want to error if we KNOW that the gcm_sender_id is incorrect.
                return Promise.resolve();
            })
                .then(function (manifestContent) {
                if (!manifestContent) {
                    return;
                }
                if (!manifestContent['gcm_sender_id']) {
                    return;
                }
                if (manifestContent['gcm_sender_id'] !== '103953800507') {
                    throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.INCORRECT_GCM_SENDER_ID);
                }
            });
        }
        return this.manifestCheckPromise_;
    };
    /**
     * Request permission if it is not currently granted
     * @export
     * @returns {Promise} Resolves if the permission was granted, otherwise
     * rejects
     */
    WindowController.prototype.requestPermission = function () {
        var _this = this;
        if (Notification.permission === __WEBPACK_IMPORTED_MODULE_4__models_notification_permission__["a" /* default */].granted) {
            return Promise.resolve();
        }
        return new Promise(function (resolve, reject) {
            var managePermissionResult = function (result) {
                if (result === __WEBPACK_IMPORTED_MODULE_4__models_notification_permission__["a" /* default */].granted) {
                    return resolve();
                }
                else if (result === __WEBPACK_IMPORTED_MODULE_4__models_notification_permission__["a" /* default */].denied) {
                    return reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.PERMISSION_BLOCKED));
                }
                else {
                    return reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.PERMISSION_DEFAULT));
                }
            };
            // The Notification.requestPermission API was changed to
            // return a promise so now have to handle both in case
            // browsers stop support callbacks for promised version
            var permissionPromise = Notification.requestPermission(function (result) {
                if (permissionPromise) {
                    // Let the promise manage this
                    return;
                }
                managePermissionResult(result);
            });
            if (permissionPromise) {
                // Prefer the promise version as it's the future API.
                permissionPromise.then(managePermissionResult);
            }
        });
    };
    /**
     * This method allows a developer to override the default service worker and
     * instead use a custom service worker.
     * @export
     * @param {!ServiceWorkerRegistration} registration The service worker
     * registration that should be used to receive the push messages.
     */
    WindowController.prototype.useServiceWorker = function (registration) {
        if (!(registration instanceof ServiceWorkerRegistration)) {
            throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.SW_REGISTRATION_EXPECTED);
        }
        if (typeof this.registrationToUse_ !== 'undefined') {
            throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.USE_SW_BEFORE_GET_TOKEN);
        }
        this.registrationToUse_ = registration;
    };
    /**
     * @export
     * @param {!firebase.Observer|function(*)} nextOrObserver An observer object
     * or a function triggered on message.
     * @param {function(!Error)=} optError Optional A function triggered on
     * message error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    WindowController.prototype.onMessage = function (nextOrObserver, optError, optCompleted) {
        return this.onMessage_(nextOrObserver, optError, optCompleted);
    };
    /**
     * @export
     * @param {!firebase.Observer|function()} nextOrObserver An observer object
     * or a function triggered on token refresh.
     * @param {function(!Error)=} optError Optional A function
     * triggered on token refresh error.
     * @param {function()=} optCompleted Optional function triggered when the
     * observer is removed.
     * @return {!function()} The unsubscribe function for the observer.
     */
    WindowController.prototype.onTokenRefresh = function (nextOrObserver, optError, optCompleted) {
        return this.onTokenRefresh_(nextOrObserver, optError, optCompleted);
    };
    /**
     * Given a registration, wait for the service worker it relates to
     * become activer
     * @private
     * @param  {ServiceWorkerRegistration} registration Registration to wait
     * for service worker to become active
     * @return {Promise<!ServiceWorkerRegistration>} Wait for service worker
     * registration to become active
     */
    WindowController.prototype.waitForRegistrationToActivate_ = function (registration) {
        var _this = this;
        var serviceWorker = registration.installing || registration.waiting || registration.active;
        return new Promise(function (resolve, reject) {
            if (!serviceWorker) {
                // This is a rare scenario but has occured in firefox
                reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.NO_SW_IN_REG));
                return;
            }
            // Because the Promise function is called on next tick there is a
            // small chance that the worker became active or redundant already.
            if (serviceWorker.state === 'activated') {
                resolve(registration);
                return;
            }
            if (serviceWorker.state === 'redundant') {
                reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.SW_REG_REDUNDANT));
                return;
            }
            var stateChangeListener = function () {
                if (serviceWorker.state === 'activated') {
                    resolve(registration);
                }
                else if (serviceWorker.state === 'redundant') {
                    reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.SW_REG_REDUNDANT));
                }
                else {
                    // Return early and wait to next state change
                    return;
                }
                serviceWorker.removeEventListener('statechange', stateChangeListener);
            };
            serviceWorker.addEventListener('statechange', stateChangeListener);
        });
    };
    /**
     * This will regiater the default service worker and return the registration
     * @private
     * @return {Promise<!ServiceWorkerRegistration>} The service worker
     * registration to be used for the push service.
     */
    WindowController.prototype.getSWRegistration_ = function () {
        var _this = this;
        if (this.registrationToUse_) {
            return this.waitForRegistrationToActivate_(this.registrationToUse_);
        }
        // Make the registration null so we know useServiceWorker will not
        // use a new service worker as registrationToUse_ is no longer undefined
        this.registrationToUse_ = null;
        return navigator.serviceWorker
            .register(__WEBPACK_IMPORTED_MODULE_3__models_default_sw__["a" /* default */].path, {
            scope: __WEBPACK_IMPORTED_MODULE_3__models_default_sw__["a" /* default */].scope
        })
            .catch(function (err) {
            throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.FAILED_DEFAULT_REGISTRATION, {
                browserErrorMessage: err.message
            });
        })
            .then(function (registration) {
            return _this.waitForRegistrationToActivate_(registration).then(function () {
                _this.registrationToUse_ = registration;
                // We update after activation due to an issue with Firefox v49 where
                // a race condition occassionally causes the service work to not
                // install
                registration.update();
                return registration;
            });
        });
    };
    /**
     * This method will set up a message listener to handle
     * events from the service worker that should trigger
     * events in the page.
     *
     * @private
     */
    WindowController.prototype.setupSWMessageListener_ = function () {
        var _this = this;
        if (!('serviceWorker' in navigator)) {
            return;
        }
        navigator.serviceWorker.addEventListener('message', function (event) {
            if (!event.data || !event.data[__WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].PARAMS.TYPE_OF_MSG]) {
                // Not a message from FCM
                return;
            }
            var workerPageMessage = event.data;
            switch (workerPageMessage[__WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].PARAMS.TYPE_OF_MSG]) {
                case __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].TYPES_OF_MSG.PUSH_MSG_RECEIVED:
                case __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].TYPES_OF_MSG.NOTIFICATION_CLICKED:
                    var pushMessage = workerPageMessage[__WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].PARAMS.DATA];
                    _this.messageObserver_.next(pushMessage);
                    break;
                default:
                    // Noop.
                    break;
            }
        }, false);
    };
    /**
     * Checks to see if the required API's are valid or not.
     * @private
     * @return {boolean} Returns true if the desired APIs are available.
     */
    WindowController.prototype.isSupported_ = function () {
        return ('serviceWorker' in navigator &&
            'PushManager' in window &&
            'Notification' in window &&
            'fetch' in window &&
            ServiceWorkerRegistration.prototype.hasOwnProperty('showNotification') &&
            PushSubscription.prototype.hasOwnProperty('getKey'));
    };
    return WindowController;
}(__WEBPACK_IMPORTED_MODULE_0__controller_interface__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (WindowController);

//# sourceMappingURL=window-controller.js.map


/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Do a deep-copy of basic JavaScript Objects or Arrays.
 */
function deepCopy(value) {
    return deepExtend(undefined, value);
}
exports.deepCopy = deepCopy;
/**
 * Copy properties from source to target (recursively allows extension
 * of Objects and Arrays).  Scalar values in the target are over-written.
 * If target is undefined, an object of the appropriate type will be created
 * (and returned).
 *
 * We recursively copy all child properties of plain Objects in the source- so
 * that namespace- like dictionaries are merged.
 *
 * Note that the target can be a function, in which case the properties in
 * the source Object are copied onto it as static properties of the Function.
 */
function deepExtend(target, source) {
    if (!(source instanceof Object)) {
        return source;
    }
    switch (source.constructor) {
        case Date:
            // Treat Dates like scalars; if the target date object had any child
            // properties - they will be lost!
            var dateValue = source;
            return new Date(dateValue.getTime());
        case Object:
            if (target === undefined) {
                target = {};
            }
            break;
        case Array:
            // Always copy the array source and overwrite the target.
            target = [];
            break;
        default:
            // Not a plain Object - treat it as a scalar.
            return source;
    }
    for (var prop in source) {
        if (!source.hasOwnProperty(prop)) {
            continue;
        }
        target[prop] = deepExtend(target[prop], source[prop]);
    }
    return target;
}
exports.deepExtend = deepExtend;
// TODO: Really needed (for JSCompiler type checking)?
function patchProperty(obj, prop, value) {
    obj[prop] = value;
}
exports.patchProperty = patchProperty;

//# sourceMappingURL=deepCopy.js.map


/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var Deferred = /** @class */ (function () {
    function Deferred() {
        var _this = this;
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
    }
    /**
     * Our API internals are not promiseified and cannot because our callback APIs have subtle expectations around
     * invoking promises inline, which Promises are forbidden to do. This method accepts an optional node-style callback
     * and returns a node-style callback which will resolve or reject the Deferred's promise.
     * @param {((?function(?(Error)): (?|undefined))| (?function(?(Error),?=): (?|undefined)))=} callback
     * @return {!function(?(Error), ?=)}
     */
    Deferred.prototype.wrapCallback = function (callback) {
        var _this = this;
        return function (error, value) {
            if (error) {
                _this.reject(error);
            }
            else {
                _this.resolve(value);
            }
            if (typeof callback === 'function') {
                // Attaching noop handler just in case developer wasn't expecting
                // promises
                _this.promise.catch(function () { });
                // Some of our callbacks don't expect a value and our own tests
                // assert that the parameter length is 1
                if (callback.length === 1) {
                    callback(error);
                }
                else {
                    callback(error, value);
                }
            }
        };
    };
    return Deferred;
}());
exports.Deferred = Deferred;

//# sourceMappingURL=deferred.js.map


/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var constants_1 = __webpack_require__(275);
/**
 * Returns navigator.userAgent string or '' if it's not defined.
 * @return {string} user agent string
 */
exports.getUA = function () {
    if (typeof navigator !== 'undefined' &&
        typeof navigator['userAgent'] === 'string') {
        return navigator['userAgent'];
    }
    else {
        return '';
    }
};
/**
 * Detect Cordova / PhoneGap / Ionic frameworks on a mobile device.
 *
 * Deliberately does not rely on checking `file://` URLs (as this fails PhoneGap in the Ripple emulator) nor
 * Cordova `onDeviceReady`, which would normally wait for a callback.
 *
 * @return {boolean} isMobileCordova
 */
exports.isMobileCordova = function () {
    return (typeof window !== 'undefined' &&
        !!(window['cordova'] || window['phonegap'] || window['PhoneGap']) &&
        /ios|iphone|ipod|ipad|android|blackberry|iemobile/i.test(exports.getUA()));
};
/**
 * Detect React Native.
 *
 * @return {boolean} True if ReactNative environment is detected.
 */
exports.isReactNative = function () {
    return (typeof navigator === 'object' && navigator['product'] === 'ReactNative');
};
/**
 * Detect Node.js.
 *
 * @return {boolean} True if Node.js environment is detected.
 */
exports.isNodeSdk = function () {
    return constants_1.CONSTANTS.NODE_CLIENT === true || constants_1.CONSTANTS.NODE_ADMIN === true;
};

//# sourceMappingURL=environment.js.map


/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ERROR_NAME = 'FirebaseError';
var captureStackTrace = Error
    .captureStackTrace;
// Export for faking in tests
function patchCapture(captureFake) {
    var result = captureStackTrace;
    captureStackTrace = captureFake;
    return result;
}
exports.patchCapture = patchCapture;
var FirebaseError = /** @class */ (function () {
    function FirebaseError(code, message) {
        this.code = code;
        this.message = message;
        var stack;
        // We want the stack value, if implemented by Error
        if (captureStackTrace) {
            // Patches this.stack, omitted calls above ErrorFactory#create
            captureStackTrace(this, ErrorFactory.prototype.create);
        }
        else {
            var err_1 = Error.apply(this, arguments);
            this.name = ERROR_NAME;
            // Make non-enumerable getter for the property.
            Object.defineProperty(this, 'stack', {
                get: function () {
                    return err_1.stack;
                }
            });
        }
    }
    return FirebaseError;
}());
exports.FirebaseError = FirebaseError;
// Back-door inheritance
FirebaseError.prototype = Object.create(Error.prototype);
FirebaseError.prototype.constructor = FirebaseError;
FirebaseError.prototype.name = ERROR_NAME;
var ErrorFactory = /** @class */ (function () {
    function ErrorFactory(service, serviceName, errors) {
        this.service = service;
        this.serviceName = serviceName;
        this.errors = errors;
        // Matches {$name}, by default.
        this.pattern = /\{\$([^}]+)}/g;
        // empty
    }
    ErrorFactory.prototype.create = function (code, data) {
        if (data === undefined) {
            data = {};
        }
        var template = this.errors[code];
        var fullCode = this.service + '/' + code;
        var message;
        if (template === undefined) {
            message = 'Error';
        }
        else {
            message = template.replace(this.pattern, function (match, key) {
                var value = data[key];
                return value !== undefined ? value.toString() : '<' + key + '?>';
            });
        }
        // Service: Error message (service/code).
        message = this.serviceName + ': ' + message + ' (' + fullCode + ').';
        var err = new FirebaseError(fullCode, message);
        // Populate the Error object with message parts for programmatic
        // accesses (e.g., e.file).
        for (var prop in data) {
            if (!data.hasOwnProperty(prop) || prop.slice(-1) === '_') {
                continue;
            }
            err[prop] = data[prop];
        }
        return err;
    };
    return ErrorFactory;
}());
exports.ErrorFactory = ErrorFactory;

//# sourceMappingURL=errors.js.map


/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var crypt_1 = __webpack_require__(488);
var json_1 = __webpack_require__(489);
/**
 * Decodes a Firebase auth. token into constituent parts.
 *
 * Notes:
 * - May return with invalid / incomplete claims if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {{header: *, claims: *, data: *, signature: string}}
 */
exports.decode = function (token) {
    var header = {}, claims = {}, data = {}, signature = '';
    try {
        var parts = token.split('.');
        header = json_1.jsonEval(crypt_1.base64Decode(parts[0]) || '');
        claims = json_1.jsonEval(crypt_1.base64Decode(parts[1]) || '');
        signature = parts[2];
        data = claims['d'] || {};
        delete claims['d'];
    }
    catch (e) { }
    return {
        header: header,
        claims: claims,
        data: data,
        signature: signature
    };
};
/**
 * Decodes a Firebase auth. token and checks the validity of its time-based claims. Will return true if the
 * token is within the time window authorized by the 'nbf' (not-before) and 'iat' (issued-at) claims.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidTimestamp = function (token) {
    var claims = exports.decode(token).claims, now = Math.floor(new Date().getTime() / 1000), validSince, validUntil;
    if (typeof claims === 'object') {
        if (claims.hasOwnProperty('nbf')) {
            validSince = claims['nbf'];
        }
        else if (claims.hasOwnProperty('iat')) {
            validSince = claims['iat'];
        }
        if (claims.hasOwnProperty('exp')) {
            validUntil = claims['exp'];
        }
        else {
            // token will expire after 24h by default
            validUntil = validSince + 86400;
        }
    }
    return (now && validSince && validUntil && now >= validSince && now <= validUntil);
};
/**
 * Decodes a Firebase auth. token and returns its issued at time if valid, null otherwise.
 *
 * Notes:
 * - May return null if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {?number}
 */
exports.issuedAtTime = function (token) {
    var claims = exports.decode(token).claims;
    if (typeof claims === 'object' && claims.hasOwnProperty('iat')) {
        return claims['iat'];
    }
    return null;
};
/**
 * Decodes a Firebase auth. token and checks the validity of its format. Expects a valid issued-at time and non-empty
 * signature.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isValidFormat = function (token) {
    var decoded = exports.decode(token), claims = decoded.claims;
    return (!!decoded.signature &&
        !!claims &&
        typeof claims === 'object' &&
        claims.hasOwnProperty('iat'));
};
/**
 * Attempts to peer into an auth token and determine if it's an admin auth token by looking at the claims portion.
 *
 * Notes:
 * - May return a false negative if there's no native base64 decoding support.
 * - Doesn't check if the token is actually valid.
 *
 * @param {?string} token
 * @return {boolean}
 */
exports.isAdmin = function (token) {
    var claims = exports.decode(token).claims;
    return typeof claims === 'object' && claims['admin'] === true;
};

//# sourceMappingURL=jwt.js.map


/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var obj_1 = __webpack_require__(490);
/**
 * Returns a querystring-formatted string (e.g. &arg=val&arg2=val2) from a params
 * object (e.g. {arg: 'val', arg2: 'val2'})
 * Note: You must prepend it with ? when adding it to a URL.
 *
 * @param {!Object} querystringParams
 * @return {string}
 */
exports.querystring = function (querystringParams) {
    var params = [];
    obj_1.forEach(querystringParams, function (key, value) {
        if (Array.isArray(value)) {
            value.forEach(function (arrayVal) {
                params.push(encodeURIComponent(key) + '=' + encodeURIComponent(arrayVal));
            });
        }
        else {
            params.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
        }
    });
    return params.length ? '&' + params.join('&') : '';
};
/**
 * Decodes a querystring (e.g. ?arg=val&arg2=val2) into a params object (e.g. {arg: 'val', arg2: 'val2'})
 *
 * @param {string} querystring
 * @return {!Object}
 */
exports.querystringDecode = function (querystring) {
    var obj = {};
    var tokens = querystring.replace(/^\?/, '').split('&');
    tokens.forEach(function (token) {
        if (token) {
            var key = token.split('=');
            obj[key[0]] = key[1];
        }
    });
    return obj;
};

//# sourceMappingURL=query.js.map


/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var hash_1 = __webpack_require__(1240);
/**
 * @fileoverview SHA-1 cryptographic hash.
 * Variable names follow the notation in FIPS PUB 180-3:
 * http://csrc.nist.gov/publications/fips/fips180-3/fips180-3_final.pdf.
 *
 * Usage:
 *   var sha1 = new sha1();
 *   sha1.update(bytes);
 *   var hash = sha1.digest();
 *
 * Performance:
 *   Chrome 23:   ~400 Mbit/s
 *   Firefox 16:  ~250 Mbit/s
 *
 */
/**
 * SHA-1 cryptographic hash constructor.
 *
 * The properties declared here are discussed in the above algorithm document.
 * @constructor
 * @extends {Hash}
 * @final
 * @struct
 */
var Sha1 = /** @class */ (function (_super) {
    __extends(Sha1, _super);
    function Sha1() {
        var _this = _super.call(this) || this;
        /**
         * Holds the previous values of accumulated variables a-e in the compress_
         * function.
         * @type {!Array<number>}
         * @private
         */
        _this.chain_ = [];
        /**
         * A buffer holding the partially computed hash result.
         * @type {!Array<number>}
         * @private
         */
        _this.buf_ = [];
        /**
         * An array of 80 bytes, each a part of the message to be hashed.  Referred to
         * as the message schedule in the docs.
         * @type {!Array<number>}
         * @private
         */
        _this.W_ = [];
        /**
         * Contains data needed to pad messages less than 64 bytes.
         * @type {!Array<number>}
         * @private
         */
        _this.pad_ = [];
        /**
         * @private {number}
         */
        _this.inbuf_ = 0;
        /**
         * @private {number}
         */
        _this.total_ = 0;
        _this.blockSize = 512 / 8;
        _this.pad_[0] = 128;
        for (var i = 1; i < _this.blockSize; ++i) {
            _this.pad_[i] = 0;
        }
        _this.reset();
        return _this;
    }
    Sha1.prototype.reset = function () {
        this.chain_[0] = 0x67452301;
        this.chain_[1] = 0xefcdab89;
        this.chain_[2] = 0x98badcfe;
        this.chain_[3] = 0x10325476;
        this.chain_[4] = 0xc3d2e1f0;
        this.inbuf_ = 0;
        this.total_ = 0;
    };
    /**
     * Internal compress helper function.
     * @param {!Array<number>|!Uint8Array|string} buf Block to compress.
     * @param {number=} opt_offset Offset of the block in the buffer.
     * @private
     */
    Sha1.prototype.compress_ = function (buf, opt_offset) {
        if (!opt_offset) {
            opt_offset = 0;
        }
        var W = this.W_;
        // get 16 big endian words
        if (typeof buf === 'string') {
            for (var i = 0; i < 16; i++) {
                // TODO(user): [bug 8140122] Recent versions of Safari for Mac OS and iOS
                // have a bug that turns the post-increment ++ operator into pre-increment
                // during JIT compilation.  We have code that depends heavily on SHA-1 for
                // correctness and which is affected by this bug, so I've removed all uses
                // of post-increment ++ in which the result value is used.  We can revert
                // this change once the Safari bug
                // (https://bugs.webkit.org/show_bug.cgi?id=109036) has been fixed and
                // most clients have been updated.
                W[i] =
                    (buf.charCodeAt(opt_offset) << 24) |
                        (buf.charCodeAt(opt_offset + 1) << 16) |
                        (buf.charCodeAt(opt_offset + 2) << 8) |
                        buf.charCodeAt(opt_offset + 3);
                opt_offset += 4;
            }
        }
        else {
            for (var i = 0; i < 16; i++) {
                W[i] =
                    (buf[opt_offset] << 24) |
                        (buf[opt_offset + 1] << 16) |
                        (buf[opt_offset + 2] << 8) |
                        buf[opt_offset + 3];
                opt_offset += 4;
            }
        }
        // expand to 80 words
        for (var i = 16; i < 80; i++) {
            var t = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
            W[i] = ((t << 1) | (t >>> 31)) & 0xffffffff;
        }
        var a = this.chain_[0];
        var b = this.chain_[1];
        var c = this.chain_[2];
        var d = this.chain_[3];
        var e = this.chain_[4];
        var f, k;
        // TODO(user): Try to unroll this loop to speed up the computation.
        for (var i = 0; i < 80; i++) {
            if (i < 40) {
                if (i < 20) {
                    f = d ^ (b & (c ^ d));
                    k = 0x5a827999;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0x6ed9eba1;
                }
            }
            else {
                if (i < 60) {
                    f = (b & c) | (d & (b | c));
                    k = 0x8f1bbcdc;
                }
                else {
                    f = b ^ c ^ d;
                    k = 0xca62c1d6;
                }
            }
            var t = (((a << 5) | (a >>> 27)) + f + e + k + W[i]) & 0xffffffff;
            e = d;
            d = c;
            c = ((b << 30) | (b >>> 2)) & 0xffffffff;
            b = a;
            a = t;
        }
        this.chain_[0] = (this.chain_[0] + a) & 0xffffffff;
        this.chain_[1] = (this.chain_[1] + b) & 0xffffffff;
        this.chain_[2] = (this.chain_[2] + c) & 0xffffffff;
        this.chain_[3] = (this.chain_[3] + d) & 0xffffffff;
        this.chain_[4] = (this.chain_[4] + e) & 0xffffffff;
    };
    Sha1.prototype.update = function (bytes, opt_length) {
        // TODO(johnlenz): tighten the function signature and remove this check
        if (bytes == null) {
            return;
        }
        if (opt_length === undefined) {
            opt_length = bytes.length;
        }
        var lengthMinusBlock = opt_length - this.blockSize;
        var n = 0;
        // Using local instead of member variables gives ~5% speedup on Firefox 16.
        var buf = this.buf_;
        var inbuf = this.inbuf_;
        // The outer while loop should execute at most twice.
        while (n < opt_length) {
            // When we have no data in the block to top up, we can directly process the
            // input buffer (assuming it contains sufficient data). This gives ~25%
            // speedup on Chrome 23 and ~15% speedup on Firefox 16, but requires that
            // the data is provided in large chunks (or in multiples of 64 bytes).
            if (inbuf == 0) {
                while (n <= lengthMinusBlock) {
                    this.compress_(bytes, n);
                    n += this.blockSize;
                }
            }
            if (typeof bytes === 'string') {
                while (n < opt_length) {
                    buf[inbuf] = bytes.charCodeAt(n);
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
            else {
                while (n < opt_length) {
                    buf[inbuf] = bytes[n];
                    ++inbuf;
                    ++n;
                    if (inbuf == this.blockSize) {
                        this.compress_(buf);
                        inbuf = 0;
                        // Jump to the outer loop so we use the full-block optimization.
                        break;
                    }
                }
            }
        }
        this.inbuf_ = inbuf;
        this.total_ += opt_length;
    };
    /** @override */
    Sha1.prototype.digest = function () {
        var digest = [];
        var totalBits = this.total_ * 8;
        // Add pad 0x80 0x00*.
        if (this.inbuf_ < 56) {
            this.update(this.pad_, 56 - this.inbuf_);
        }
        else {
            this.update(this.pad_, this.blockSize - (this.inbuf_ - 56));
        }
        // Add # bits.
        for (var i = this.blockSize - 1; i >= 56; i--) {
            this.buf_[i] = totalBits & 255;
            totalBits /= 256; // Don't use bit-shifting here!
        }
        this.compress_(this.buf_);
        var n = 0;
        for (var i = 0; i < 5; i++) {
            for (var j = 24; j >= 0; j -= 8) {
                digest[n] = (this.chain_[i] >> j) & 255;
                ++n;
            }
        }
        return digest;
    };
    return Sha1;
}(hash_1.Hash));
exports.Sha1 = Sha1;

//# sourceMappingURL=sha1.js.map


/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
// Copyright 2011 The Closure Library Authors. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS-IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
/**
 * @fileoverview Abstract cryptographic hash interface.
 *
 * See Sha1 and Md5 for sample implementations.
 *
 */
/**
 * Create a cryptographic hash instance.
 *
 * @constructor
 * @struct
 */
var Hash = /** @class */ (function () {
    function Hash() {
        /**
         * The block size for the hasher.
         * @type {number}
         */
        this.blockSize = -1;
    }
    return Hash;
}());
exports.Hash = Hash;

//# sourceMappingURL=hash.js.map


/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Helper to make a Subscribe function (just like Promise helps make a
 * Thenable).
 *
 * @param executor Function which can make calls to a single Observer
 *     as a proxy.
 * @param onNoObservers Callback when count of Observers goes to zero.
 */
function createSubscribe(executor, onNoObservers) {
    var proxy = new ObserverProxy(executor, onNoObservers);
    return proxy.subscribe.bind(proxy);
}
exports.createSubscribe = createSubscribe;
/**
 * Implement fan-out for any number of Observers attached via a subscribe
 * function.
 */
var ObserverProxy = /** @class */ (function () {
    /**
     * @param executor Function which can make calls to a single Observer
     *     as a proxy.
     * @param onNoObservers Callback when count of Observers goes to zero.
     */
    function ObserverProxy(executor, onNoObservers) {
        var _this = this;
        this.observers = [];
        this.unsubscribes = [];
        this.observerCount = 0;
        // Micro-task scheduling by calling task.then().
        this.task = Promise.resolve();
        this.finalized = false;
        this.onNoObservers = onNoObservers;
        // Call the executor asynchronously so subscribers that are called
        // synchronously after the creation of the subscribe function
        // can still receive the very first value generated in the executor.
        this.task
            .then(function () {
            executor(_this);
        })
            .catch(function (e) {
            _this.error(e);
        });
    }
    ObserverProxy.prototype.next = function (value) {
        this.forEachObserver(function (observer) {
            observer.next(value);
        });
    };
    ObserverProxy.prototype.error = function (error) {
        this.forEachObserver(function (observer) {
            observer.error(error);
        });
        this.close(error);
    };
    ObserverProxy.prototype.complete = function () {
        this.forEachObserver(function (observer) {
            observer.complete();
        });
        this.close();
    };
    /**
     * Subscribe function that can be used to add an Observer to the fan-out list.
     *
     * - We require that no event is sent to a subscriber sychronously to their
     *   call to subscribe().
     */
    ObserverProxy.prototype.subscribe = function (nextOrObserver, error, complete) {
        var _this = this;
        var observer;
        if (nextOrObserver === undefined &&
            error === undefined &&
            complete === undefined) {
            throw new Error('Missing Observer.');
        }
        // Assemble an Observer object when passed as callback functions.
        if (implementsAnyMethods(nextOrObserver, ['next', 'error', 'complete'])) {
            observer = nextOrObserver;
        }
        else {
            observer = {
                next: nextOrObserver,
                error: error,
                complete: complete
            };
        }
        if (observer.next === undefined) {
            observer.next = noop;
        }
        if (observer.error === undefined) {
            observer.error = noop;
        }
        if (observer.complete === undefined) {
            observer.complete = noop;
        }
        var unsub = this.unsubscribeOne.bind(this, this.observers.length);
        // Attempt to subscribe to a terminated Observable - we
        // just respond to the Observer with the final error or complete
        // event.
        if (this.finalized) {
            this.task.then(function () {
                try {
                    if (_this.finalError) {
                        observer.error(_this.finalError);
                    }
                    else {
                        observer.complete();
                    }
                }
                catch (e) {
                    // nothing
                }
                return;
            });
        }
        this.observers.push(observer);
        return unsub;
    };
    // Unsubscribe is synchronous - we guarantee that no events are sent to
    // any unsubscribed Observer.
    ObserverProxy.prototype.unsubscribeOne = function (i) {
        if (this.observers === undefined || this.observers[i] === undefined) {
            return;
        }
        delete this.observers[i];
        this.observerCount -= 1;
        if (this.observerCount === 0 && this.onNoObservers !== undefined) {
            this.onNoObservers(this);
        }
    };
    ObserverProxy.prototype.forEachObserver = function (fn) {
        if (this.finalized) {
            // Already closed by previous event....just eat the additional values.
            return;
        }
        // Since sendOne calls asynchronously - there is no chance that
        // this.observers will become undefined.
        for (var i = 0; i < this.observers.length; i++) {
            this.sendOne(i, fn);
        }
    };
    // Call the Observer via one of it's callback function. We are careful to
    // confirm that the observe has not been unsubscribed since this asynchronous
    // function had been queued.
    ObserverProxy.prototype.sendOne = function (i, fn) {
        var _this = this;
        // Execute the callback asynchronously
        this.task.then(function () {
            if (_this.observers !== undefined && _this.observers[i] !== undefined) {
                try {
                    fn(_this.observers[i]);
                }
                catch (e) {
                    // Ignore exceptions raised in Observers or missing methods of an
                    // Observer.
                    // Log error to console. b/31404806
                    if (typeof console !== 'undefined' && console.error) {
                        console.error(e);
                    }
                }
            }
        });
    };
    ObserverProxy.prototype.close = function (err) {
        var _this = this;
        if (this.finalized) {
            return;
        }
        this.finalized = true;
        if (err !== undefined) {
            this.finalError = err;
        }
        // Proxy is no longer needed - garbage collect references
        this.task.then(function () {
            _this.observers = undefined;
            _this.onNoObservers = undefined;
        });
    };
    return ObserverProxy;
}());
/** Turn synchronous function into one called asynchronously. */
function async(fn, onError) {
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        Promise.resolve(true)
            .then(function () {
            fn.apply(void 0, args);
        })
            .catch(function (error) {
            if (onError) {
                onError(error);
            }
        });
    };
}
exports.async = async;
/**
 * Return true if the object passed in implements any of the named methods.
 */
function implementsAnyMethods(obj, methods) {
    if (typeof obj !== 'object' || obj === null) {
        return false;
    }
    for (var _i = 0, methods_1 = methods; _i < methods_1.length; _i++) {
        var method = methods_1[_i];
        if (method in obj && typeof obj[method] === 'function') {
            return true;
        }
    }
    return false;
}
function noop() {
    // do nothing
}

//# sourceMappingURL=subscribe.js.map


/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Check to make sure the appropriate number of arguments are provided for a public function.
 * Throws an error if it fails.
 *
 * @param {!string} fnName The function name
 * @param {!number} minCount The minimum number of arguments to allow for the function call
 * @param {!number} maxCount The maximum number of argument to allow for the function call
 * @param {!number} argCount The actual number of arguments provided.
 */
exports.validateArgCount = function (fnName, minCount, maxCount, argCount) {
    var argError;
    if (argCount < minCount) {
        argError = 'at least ' + minCount;
    }
    else if (argCount > maxCount) {
        argError = maxCount === 0 ? 'none' : 'no more than ' + maxCount;
    }
    if (argError) {
        var error = fnName +
            ' failed: Was called with ' +
            argCount +
            (argCount === 1 ? ' argument.' : ' arguments.') +
            ' Expects ' +
            argError +
            '.';
        throw new Error(error);
    }
};
/**
 * Generates a string to prefix an error message about failed argument validation
 *
 * @param {!string} fnName The function name
 * @param {!number} argumentNumber The index of the argument
 * @param {boolean} optional Whether or not the argument is optional
 * @return {!string} The prefix to add to the error thrown for validation.
 */
function errorPrefix(fnName, argumentNumber, optional) {
    var argName = '';
    switch (argumentNumber) {
        case 1:
            argName = optional ? 'first' : 'First';
            break;
        case 2:
            argName = optional ? 'second' : 'Second';
            break;
        case 3:
            argName = optional ? 'third' : 'Third';
            break;
        case 4:
            argName = optional ? 'fourth' : 'Fourth';
            break;
        default:
            throw new Error('errorPrefix called with argumentNumber > 4.  Need to update it?');
    }
    var error = fnName + ' failed: ';
    error += argName + ' argument ';
    return error;
}
exports.errorPrefix = errorPrefix;
/**
 * @param {!string} fnName
 * @param {!number} argumentNumber
 * @param {!string} namespace
 * @param {boolean} optional
 */
function validateNamespace(fnName, argumentNumber, namespace, optional) {
    if (optional && !namespace)
        return;
    if (typeof namespace !== 'string') {
        //TODO: I should do more validation here. We only allow certain chars in namespaces.
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid firebase namespace.');
    }
}
exports.validateNamespace = validateNamespace;
function validateCallback(fnName, argumentNumber, callback, optional) {
    if (optional && !callback)
        return;
    if (typeof callback !== 'function')
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid function.');
}
exports.validateCallback = validateCallback;
function validateContextObject(fnName, argumentNumber, context, optional) {
    if (optional && !context)
        return;
    if (typeof context !== 'object' || context === null)
        throw new Error(errorPrefix(fnName, argumentNumber, optional) +
            'must be a valid context object.');
}
exports.validateContextObject = validateContextObject;

//# sourceMappingURL=validation.js.map


/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var assert_1 = __webpack_require__(487);
// Code originally came from goog.crypt.stringToUtf8ByteArray, but for some reason they
// automatically replaced '\r\n' with '\n', and they didn't handle surrogate pairs,
// so it's been modified.
// Note that not all Unicode characters appear as single characters in JavaScript strings.
// fromCharCode returns the UTF-16 encoding of a character - so some Unicode characters
// use 2 characters in Javascript.  All 4-byte UTF-8 characters begin with a first
// character in the range 0xD800 - 0xDBFF (the first character of a so-called surrogate
// pair).
// See http://www.ecma-international.org/ecma-262/5.1/#sec-15.1.3
/**
 * @param {string} str
 * @return {Array}
 */
exports.stringToByteArray = function (str) {
    var out = [], p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        // Is this the lead surrogate in a surrogate pair?
        if (c >= 0xd800 && c <= 0xdbff) {
            var high = c - 0xd800; // the high 10 bits.
            i++;
            assert_1.assert(i < str.length, 'Surrogate pair missing trail surrogate.');
            var low = str.charCodeAt(i) - 0xdc00; // the low 10 bits.
            c = 0x10000 + (high << 10) + low;
        }
        if (c < 128) {
            out[p++] = c;
        }
        else if (c < 2048) {
            out[p++] = (c >> 6) | 192;
            out[p++] = (c & 63) | 128;
        }
        else if (c < 65536) {
            out[p++] = (c >> 12) | 224;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
        else {
            out[p++] = (c >> 18) | 240;
            out[p++] = ((c >> 12) & 63) | 128;
            out[p++] = ((c >> 6) & 63) | 128;
            out[p++] = (c & 63) | 128;
        }
    }
    return out;
};
/**
 * Calculate length without actually converting; useful for doing cheaper validation.
 * @param {string} str
 * @return {number}
 */
exports.stringLength = function (str) {
    var p = 0;
    for (var i = 0; i < str.length; i++) {
        var c = str.charCodeAt(i);
        if (c < 128) {
            p++;
        }
        else if (c < 2048) {
            p += 2;
        }
        else if (c >= 0xd800 && c <= 0xdbff) {
            // Lead surrogate of a surrogate pair.  The pair together will take 4 bytes to represent.
            p += 4;
            i++; // skip trail surrogate.
        }
        else {
            p += 3;
        }
    }
    return p;
};

//# sourceMappingURL=utf8.js.map


/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util__ = __webpack_require__(274);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_util___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__firebase_util__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__errors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__ = __webpack_require__(1245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fcm_details__ = __webpack_require__(491);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */





var FCM_TOKEN_OBJ_STORE = 'fcm_token_object_Store';
var FCM_TOKEN_DETAILS_DB_VERSION = 1;
var TokenManager = /** @class */ (function () {
    function TokenManager() {
        this.errorFactory_ = new __WEBPACK_IMPORTED_MODULE_0__firebase_util__["ErrorFactory"]('messaging', 'Messaging', __WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].map);
        this.openDbPromise_ = null;
    }
    /**
     * Get the indexedDB as a promsie.
     * @private
     * @return {Promise<IDBDatabase>} The IndexedDB database
     */
    TokenManager.prototype.openDatabase_ = function () {
        if (this.openDbPromise_) {
            return this.openDbPromise_;
        }
        this.openDbPromise_ = new Promise(function (resolve, reject) {
            var request = indexedDB.open(TokenManager.DB_NAME, FCM_TOKEN_DETAILS_DB_VERSION);
            request.onerror = function (event) {
                reject(event.target.error);
            };
            request.onsuccess = function (event) {
                resolve(event.target.result);
            };
            request.onupgradeneeded = function (event) {
                var db = event.target.result;
                var objectStore = db.createObjectStore(FCM_TOKEN_OBJ_STORE, {
                    keyPath: 'swScope'
                });
                // Make sure the sender ID can be searched
                objectStore.createIndex('fcmSenderId', 'fcmSenderId', {
                    unique: false
                });
                objectStore.createIndex('fcmToken', 'fcmToken', {
                    unique: true
                });
            };
        });
        return this.openDbPromise_;
    };
    /**
     * Close the currently open database.
     * @return {Promise<?>} Returns the result of the promise chain.
     */
    TokenManager.prototype.closeDatabase = function () {
        var _this = this;
        if (this.openDbPromise_) {
            return this.openDbPromise_.then(function (db) {
                db.close();
                _this.openDbPromise_ = null;
            });
        }
        return Promise.resolve();
    };
    /**
     * Given a token, this method will look up the details in indexedDB.
     * @public
     * @param {string} fcmToken
     * @return {Promise<Object>} The details associated with that token.
     */
    TokenManager.prototype.getTokenDetailsFromToken = function (fcmToken) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var index = objectStore.index('fcmToken');
                var request = index.get(fcmToken);
                request.onerror = function (event) {
                    reject(event.target.error);
                };
                request.onsuccess = function (event) {
                    resolve(event.target.result);
                };
            });
        });
    };
    TokenManager.prototype.getTokenDetailsFromSWScope_ = function (swScope) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var scopeRequest = objectStore.get(swScope);
                scopeRequest.onerror = function (event) {
                    reject(event.target.error);
                };
                scopeRequest.onsuccess = function (event) {
                    resolve(event.target.result);
                };
            });
        });
    };
    TokenManager.prototype.getAllTokenDetailsForSenderId_ = function (senderId) {
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE]);
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var senderIdTokens = [];
                var cursorRequest = objectStore.openCursor();
                cursorRequest.onerror = function (event) {
                    reject(event.target.error);
                };
                cursorRequest.onsuccess = function (event) {
                    var cursor = event.target.result;
                    if (cursor) {
                        if (cursor.value['fcmSenderId'] === senderId) {
                            senderIdTokens.push(cursor.value);
                        }
                        cursor.continue();
                    }
                    else {
                        resolve(senderIdTokens);
                    }
                };
            });
        });
    };
    /**
     * Given a PushSubscription and messagingSenderId, get an FCM token.
     * @public
     * @param  {string} senderId The 'messagingSenderId' to tie the token to.
     * @param  {PushSubscription} subscription The PushSusbcription to "federate".
     * @param  {string=} pushSet If defined this will swap the subscription for
     * matching FCM token.
     * @return {Promise<!Object>} Returns the FCM token to be used in place
     * of the PushSubscription.
     */
    TokenManager.prototype.subscribeToFCM = function (senderId, subscription, pushSet) {
        var _this = this;
        var p256dh = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('p256dh'));
        var auth = Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('auth'));
        var fcmSubscribeBody = "authorized_entity=" + senderId + "&" +
            ("endpoint=" + subscription.endpoint + "&") +
            ("encryption_key=" + p256dh + "&") +
            ("encryption_auth=" + auth);
        if (pushSet) {
            fcmSubscribeBody += "&pushSet=" + pushSet;
        }
        var headers = new Headers();
        headers.append('Content-Type', 'application/x-www-form-urlencoded');
        var subscribeOptions = {
            method: 'POST',
            headers: headers,
            body: fcmSubscribeBody
        };
        return fetch(__WEBPACK_IMPORTED_MODULE_3__fcm_details__["a" /* default */].ENDPOINT + '/fcm/connect/subscribe', subscribeOptions)
            .then(function (response) { return response.json(); })
            .then(function (response) {
            var fcmTokenResponse = response;
            if (fcmTokenResponse['error']) {
                var message = fcmTokenResponse['error']['message'];
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.TOKEN_SUBSCRIBE_FAILED, {
                    message: message
                });
            }
            if (!fcmTokenResponse['token']) {
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.TOKEN_SUBSCRIBE_NO_TOKEN);
            }
            if (!fcmTokenResponse['pushSet']) {
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.TOKEN_SUBSCRIBE_NO_PUSH_SET);
            }
            return {
                token: fcmTokenResponse['token'],
                pushSet: fcmTokenResponse['pushSet']
            };
        });
    };
    /**
     * Checks the that fields in the PushSubscription are equivalent to the
     * details stores in the masterTokenDetails.
     * @private
     * @param  {PushSubscription} subscription The push subscription we expect
     * the master token to match.
     * @param  {Object}  masterTokenDetails The saved details we wish to compare
     * with the PushSubscription
     * @return {boolean} true if the subscription and token details are
     * equivalent.
     */
    TokenManager.prototype.isSameSubscription_ = function (subscription, masterTokenDetails) {
        // getKey() isn't defined in the PushSubscription externs file, hence
        // subscription['getKey']('<key name>').
        return (subscription.endpoint === masterTokenDetails['endpoint'] &&
            Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('auth')) ===
                masterTokenDetails['auth'] &&
            Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('p256dh')) ===
                masterTokenDetails['p256dh']);
    };
    /**
     * Save the details for the fcm token for re-use at a later date.
     * @private
     * @param  {string} senderId The 'messagingSenderId' used for this project
     * @param  {ServiceWorkerRegistration} swRegistration The service worker
     * used to subscribe the user for web push
     * @param  {PushSubscription} subscription The push subscription passed to
     * FCM for the current token.
     * @param  {string} fcmToken The FCM token currently used on this
     * device.
     * @param  {string} fcmPushSet The FCM push tied to the fcm token.
     * @return {Promise<void>}
     */
    TokenManager.prototype.saveTokenDetails_ = function (senderId, swRegistration, subscription, fcmToken, fcmPushSet) {
        var details = {
            swScope: swRegistration.scope,
            endpoint: subscription.endpoint,
            auth: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('auth')),
            p256dh: Object(__WEBPACK_IMPORTED_MODULE_2__helpers_array_buffer_to_base64__["a" /* default */])(subscription['getKey']('p256dh')),
            fcmToken: fcmToken,
            fcmPushSet: fcmPushSet,
            fcmSenderId: senderId
        };
        return this.openDatabase_().then(function (db) {
            return new Promise(function (resolve, reject) {
                var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
                var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                var request = objectStore.put(details);
                request.onerror = function (event) {
                    reject(event.target.error);
                };
                request.onsuccess = function (event) {
                    resolve();
                };
            });
        });
    };
    /**
     * Returns the saved FCM Token if one is available and still valid,
     * otherwise `null` is returned.
     * @param {string} senderId This should be the sender ID associated with the
     * FCM Token being retrieved.
     * @param {ServiceWorkerRegistration} swRegistration Registration to be used
     * to subscribe the user to push.
     * @return {Promise<string> | Promise} Returns the saved FCM Token if
     * avilable and valid.
     * @export
     */
    TokenManager.prototype.getSavedToken = function (senderId, swRegistration) {
        var _this = this;
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.SW_REGISTRATION_EXPECTED));
        }
        if (typeof senderId !== 'string' || senderId.length === 0) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.BAD_SENDER_ID));
        }
        return this.getAllTokenDetailsForSenderId_(senderId)
            .then(function (allTokenDetails) {
            if (allTokenDetails.length === 0) {
                return;
            }
            var index = allTokenDetails.findIndex(function (tokenDetails) {
                return (swRegistration.scope === tokenDetails['swScope'] &&
                    senderId === tokenDetails['fcmSenderId']);
            });
            if (index === -1) {
                return;
            }
            return allTokenDetails[index];
        })
            .then(function (tokenDetails) {
            if (!tokenDetails) {
                return;
            }
            return swRegistration.pushManager
                .getSubscription()
                .catch(function (err) {
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.GET_SUBSCRIPTION_FAILED);
            })
                .then(function (subscription) {
                if (subscription &&
                    _this.isSameSubscription_(subscription, tokenDetails)) {
                    return tokenDetails['fcmToken'];
                }
            });
        });
    };
    /**
     * Creates a new FCM token.
     */
    TokenManager.prototype.createToken = function (senderId, swRegistration) {
        var _this = this;
        if (typeof senderId !== 'string' || senderId.length === 0) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.BAD_SENDER_ID));
        }
        if (!(swRegistration instanceof ServiceWorkerRegistration)) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.SW_REGISTRATION_EXPECTED));
        }
        // Check for existing subscription first
        var subscription;
        var fcmTokenDetails;
        return swRegistration.pushManager
            .getSubscription()
            .then(function (subscription) {
            if (subscription) {
                return subscription;
            }
            return swRegistration.pushManager.subscribe(__WEBPACK_IMPORTED_MODULE_3__fcm_details__["a" /* default */].SUBSCRIPTION_OPTIONS);
        })
            .then(function (sub) {
            subscription = sub;
            return _this.subscribeToFCM(senderId, subscription);
        })
            .then(function (tokenDetails) {
            fcmTokenDetails = tokenDetails;
            return _this.saveTokenDetails_(senderId, swRegistration, subscription, fcmTokenDetails['token'], fcmTokenDetails['pushSet']);
        })
            .then(function () { return fcmTokenDetails['token']; });
    };
    /**
     * This method deletes details of the current FCM token.
     * It's returning a promise in case we need to move to an async
     * method for deleting at a later date.
     * @param {string} token Token to be deleted
     * @return {Promise<Object>} Resolves once the FCM token details have been
     * deleted and returns the deleted details.
     */
    TokenManager.prototype.deleteToken = function (token) {
        var _this = this;
        if (typeof token !== 'string' || token.length === 0) {
            return Promise.reject(this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.INVALID_DELETE_TOKEN));
        }
        return this.getTokenDetailsFromToken(token).then(function (details) {
            if (!details) {
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.DELETE_TOKEN_NOT_FOUND);
            }
            return _this.openDatabase_().then(function (db) {
                return new Promise(function (resolve, reject) {
                    var transaction = db.transaction([FCM_TOKEN_OBJ_STORE], 'readwrite');
                    var objectStore = transaction.objectStore(FCM_TOKEN_OBJ_STORE);
                    var request = objectStore.delete(details['swScope']);
                    request.onerror = function (event) {
                        reject(event.target.error);
                    };
                    request.onsuccess = function (event) {
                        if (event.target.result === 0) {
                            reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__errors__["a" /* default */].codes.FAILED_TO_DELETE_TOKEN));
                            return;
                        }
                        resolve(details);
                    };
                });
            });
        });
    };
    return TokenManager;
}());
/* harmony default export */ __webpack_exports__["a"] = (TokenManager);

//# sourceMappingURL=token-manager.js.map


/***/ }),
/* 1245 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function toBase64(arrayBuffer) {
    var uint8Version = new Uint8Array(arrayBuffer);
    return window.btoa(String.fromCharCode.apply(null, uint8Version));
}
/* harmony default export */ __webpack_exports__["a"] = (function (arrayBuffer) {
    var base64String = toBase64(arrayBuffer);
    return base64String
        .replace(/=/g, '')
        .replace(/\+/g, '-')
        .replace(/\//g, '_');
});;

//# sourceMappingURL=array-buffer-to-base64.js.map


/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* harmony default export */ __webpack_exports__["a"] = ({
    path: '/firebase-messaging-sw.js',
    scope: '/firebase-cloud-messaging-push-scope'
});

//# sourceMappingURL=default-sw.js.map


/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__controller_interface__ = __webpack_require__(486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__models_errors__ = __webpack_require__(189);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__models_fcm_details__ = __webpack_require__(491);
/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();




var FCM_MSG = 'FCM_MSG';
var SWController = /** @class */ (function (_super) {
    __extends(SWController, _super);
    function SWController(app) {
        var _this = _super.call(this, app) || this;
        self.addEventListener('push', function (e) { return _this.onPush_(e); }, false);
        self.addEventListener('pushsubscriptionchange', function (e) { return _this.onSubChange_(e); }, false);
        self.addEventListener('notificationclick', function (e) { return _this.onNotificationClick_(e); }, false);
        /**
         * @private
         * @type {function(Object)|null}
         */
        _this.bgMessageHandler_ = null;
        return _this;
    }
    /**
     * A handler for push events that shows notifications based on the content of
     * the payload.
     *
     * The payload must be a JSON-encoded Object with a `notification` key. The
     * value of the `notification` property will be used as the NotificationOptions
     * object passed to showNotification. Additionally, the `title` property of the
     * notification object will be used as the title.
     *
     * If there is no notification data in the payload then no notification will be
     * shown.
     * @private
     */
    SWController.prototype.onPush_ = function (event) {
        var _this = this;
        var msgPayload;
        try {
            msgPayload = event.data.json();
        }
        catch (err) {
            // Not JSON so not an FCM message
            return;
        }
        var handleMsgPromise = this.hasVisibleClients_().then(function (hasVisibleClients) {
            if (hasVisibleClients) {
                // Do not need to show a notification.
                if (msgPayload.notification || _this.bgMessageHandler_) {
                    // Send to page
                    return _this.sendMessageToWindowClients_(msgPayload);
                }
                return;
            }
            var notificationDetails = _this.getNotificationData_(msgPayload);
            if (notificationDetails) {
                var notificationTitle = notificationDetails.title || '';
                return self.registration.showNotification(notificationTitle, notificationDetails);
            }
            else if (_this.bgMessageHandler_) {
                return _this.bgMessageHandler_(msgPayload);
            }
        });
        event.waitUntil(handleMsgPromise);
    };
    /**
     * @private
     */
    SWController.prototype.onSubChange_ = function (event) {
        var _this = this;
        var promiseChain = this.getToken().then(function (token) {
            if (!token) {
                // We can't resubscribe if we don't have an FCM token for this scope.
                throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.NO_FCM_TOKEN_FOR_RESUBSCRIBE);
            }
            var tokenDetails = null;
            var tokenManager = _this.getTokenManager();
            return tokenManager
                .getTokenDetailsFromToken(token)
                .then(function (details) {
                tokenDetails = details;
                if (!tokenDetails) {
                    throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.INVALID_SAVED_TOKEN);
                }
                // Attempt to get a new subscription
                return self.registration.pushManager.subscribe(__WEBPACK_IMPORTED_MODULE_3__models_fcm_details__["a" /* default */].SUBSCRIPTION_OPTIONS);
            })
                .then(function (newSubscription) {
                // Send new subscription to FCM.
                return tokenManager.subscribeToFCM(tokenDetails.fcmSenderId, newSubscription, tokenDetails.fcmPushSet);
            })
                .catch(function (err) {
                // The best thing we can do is log this to the terminal so
                // developers might notice the error.
                return tokenManager.deleteToken(tokenDetails.fcmToken).then(function () {
                    throw _this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.UNABLE_TO_RESUBSCRIBE, {
                        message: err
                    });
                });
            });
        });
        event.waitUntil(promiseChain);
    };
    /**
     * @private
     */
    SWController.prototype.onNotificationClick_ = function (event) {
        var _this = this;
        if (!(event.notification &&
            event.notification.data &&
            event.notification.data[FCM_MSG])) {
            // Not an FCM notification, do nothing.
            return;
        }
        // Prevent other listeners from receiving the event
        event.stopImmediatePropagation();
        event.notification.close();
        var msgPayload = event.notification.data[FCM_MSG];
        var clickAction = msgPayload['notification']['click_action'];
        if (!clickAction) {
            // Nothing to do.
            return;
        }
        var promiseChain = this.getWindowClient_(clickAction)
            .then(function (windowClient) {
            if (!windowClient) {
                // Unable to find window client so need to open one.
                return self.clients.openWindow(clickAction);
            }
            return windowClient;
        })
            .then(function (windowClient) {
            if (!windowClient) {
                // Window Client will not be returned if it's for a third party origin.
                return;
            }
            // Delete notification data from payload before sending to the page.
            var notificationData = msgPayload['notification'];
            delete msgPayload['notification'];
            var internalMsg = __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].createNewMsg(__WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].TYPES_OF_MSG.NOTIFICATION_CLICKED, msgPayload);
            // Attempt to send a message to the client to handle the data
            // Is affected by: https://github.com/slightlyoff/ServiceWorker/issues/728
            return _this.attemptToMessageClient_(windowClient, internalMsg);
        });
        event.waitUntil(promiseChain);
    };
    /**
     * @private
     * @param {Object} msgPayload
     * @return {NotificationOptions|undefined}
     */
    SWController.prototype.getNotificationData_ = function (msgPayload) {
        if (!msgPayload) {
            return;
        }
        if (typeof msgPayload.notification !== 'object') {
            return;
        }
        var notificationInformation = Object.assign({}, msgPayload.notification);
        // Put the message payload under FCM_MSG name so we can identify the
        // notification as being an FCM notification vs a notification from
        // somewhere else (i.e. normal web push or developer generated
        // notification).
        notificationInformation['data'] = (_a = {},
            _a[FCM_MSG] = msgPayload,
            _a);
        return notificationInformation;
        var _a;
    };
    /**
     * Calling setBackgroundMessageHandler will opt in to some specific
     * behaviours.
     * 1.) If a notification doesn't need to be shown due to a window already
     * being visible, then push messages will be sent to the page.
     * 2.) If a notification needs to be shown, and the message contains no
     * notification data this method will be called
     * and the promise it returns will be passed to event.waitUntil.
     * If you do not set this callback then all push messages will let and the
     * developer can handle them in a their own 'push' event callback
     * @export
     * @param {function(Object)} callback The callback to be called when a push
     * message is received and a notification must be shown. The callback will
     * be given the data from the push message.
     */
    SWController.prototype.setBackgroundMessageHandler = function (callback) {
        if (callback && typeof callback !== 'function') {
            throw this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.BG_HANDLER_FUNCTION_EXPECTED);
        }
        this.bgMessageHandler_ = callback;
    };
    /**
     * @private
     * @param {string} url The URL to look for when focusing a client.
     * @return {Object} Returns an existing window client or a newly opened
     * WindowClient.
     */
    SWController.prototype.getWindowClient_ = function (url) {
        // Use URL to normalize the URL when comparing to windowClients.
        // This at least handles whether to include trailing slashes or not
        var parsedURL = new URL(url).href;
        return self.clients
            .matchAll({
            type: 'window',
            includeUncontrolled: true
        })
            .then(function (clientList) {
            var suitableClient = null;
            for (var i = 0; i < clientList.length; i++) {
                var parsedClientUrl = new URL(clientList[i].url).href;
                if (parsedClientUrl === parsedURL) {
                    suitableClient = clientList[i];
                    break;
                }
            }
            if (suitableClient) {
                suitableClient.focus();
                return suitableClient;
            }
        });
    };
    /**
     * This message will attempt to send the message to a window client.
     * @private
     * @param {Object} client The WindowClient to send the message to.
     * @param {Object} message The message to send to the client.
     * @returns {Promise} Returns a promise that resolves after sending the
     * message. This does not guarantee that the message was successfully
     * received.
     */
    SWController.prototype.attemptToMessageClient_ = function (client, message) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            if (!client) {
                return reject(_this.errorFactory_.create(__WEBPACK_IMPORTED_MODULE_1__models_errors__["a" /* default */].codes.NO_WINDOW_CLIENT_TO_MSG));
            }
            client.postMessage(message);
            resolve();
        });
    };
    /**
     * @private
     * @returns {Promise<boolean>} If there is currently a visible WindowClient,
     * this method will resolve to true, otherwise false.
     */
    SWController.prototype.hasVisibleClients_ = function () {
        return self.clients
            .matchAll({
            type: 'window',
            includeUncontrolled: true
        })
            .then(function (clientList) {
            return clientList.some(function (client) { return client.visibilityState === 'visible'; });
        });
    };
    /**
     * @private
     * @param {Object} msgPayload The data from the push event that should be sent
     * to all available pages.
     * @returns {Promise} Returns a promise that resolves once the message
     * has been sent to all WindowClients.
     */
    SWController.prototype.sendMessageToWindowClients_ = function (msgPayload) {
        var _this = this;
        return self.clients
            .matchAll({
            type: 'window',
            includeUncontrolled: true
        })
            .then(function (clientList) {
            var internalMsg = __WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].createNewMsg(__WEBPACK_IMPORTED_MODULE_2__models_worker_page_message__["a" /* default */].TYPES_OF_MSG.PUSH_MSG_RECEIVED, msgPayload);
            return Promise.all(clientList.map(function (client) {
                return _this.attemptToMessageClient_(client, internalMsg);
            }));
        });
    };
    /**
     * This will register the default service worker and return the registration.
     * @private
     * @return {Promise<!ServiceWorkerRegistration>} The service worker
     * registration to be used for the push service.
     */
    SWController.prototype.getSWRegistration_ = function () {
        return Promise.resolve(self.registration);
    };
    return SWController;
}(__WEBPACK_IMPORTED_MODULE_0__controller_interface__["a" /* default */]));
/* harmony default export */ __webpack_exports__["a"] = (SWController);

//# sourceMappingURL=sw-controller.js.map


/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

__webpack_require__(1249);


/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerStorage", function() { return registerStorage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__firebase_app__ = __webpack_require__(93);


/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Constants used in the Firebase Storage library.
 */
/**
 * Domain and scheme for API calls.
 */
var domainBase = 'https://firebasestorage.googleapis.com';
/**
 * Domain and scheme for object downloads.
 */
var downloadBase = 'https://firebasestorage.googleapis.com';
/**
 * Base URL for non-upload calls to the API.
 */
var apiBaseUrl = '/v0';
/**
 * Base URL for upload calls to the API.
 */
var apiUploadBaseUrl = '/v0';
var configOption = 'storageBucket';
/**
 * 2 minutes
 */
var defaultMaxOperationRetryTime = 2 * 60 * 1000;
/**
 * 10 minutes
 */
var defaultMaxUploadRetryTime = 10 * 60 * 100;
/**
 * This is the value of Number.MIN_SAFE_INTEGER, which is not well supported
 * enough for us to use it directly.
 */
var minSafeInteger = -9007199254740991;

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var FirebaseStorageError = /** @class */ (function () {
    function FirebaseStorageError(code, message) {
        this.code_ = prependCode(code);
        this.message_ = 'Firebase Storage: ' + message;
        this.serverResponse_ = null;
        this.name_ = 'FirebaseError';
    }
    FirebaseStorageError.prototype.codeProp = function () {
        return this.code;
    };
    FirebaseStorageError.prototype.codeEquals = function (code) {
        return prependCode(code) === this.codeProp();
    };
    FirebaseStorageError.prototype.serverResponseProp = function () {
        return this.serverResponse_;
    };
    FirebaseStorageError.prototype.setServerResponseProp = function (serverResponse) {
        this.serverResponse_ = serverResponse;
    };
    Object.defineProperty(FirebaseStorageError.prototype, "name", {
        get: function () {
            return this.name_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "code", {
        get: function () {
            return this.code_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "message", {
        get: function () {
            return this.message_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(FirebaseStorageError.prototype, "serverResponse", {
        get: function () {
            return this.serverResponse_;
        },
        enumerable: true,
        configurable: true
    });
    return FirebaseStorageError;
}());
var Code = {
    // Shared between all platforms
    UNKNOWN: 'unknown',
    OBJECT_NOT_FOUND: 'object-not-found',
    BUCKET_NOT_FOUND: 'bucket-not-found',
    PROJECT_NOT_FOUND: 'project-not-found',
    QUOTA_EXCEEDED: 'quota-exceeded',
    UNAUTHENTICATED: 'unauthenticated',
    UNAUTHORIZED: 'unauthorized',
    RETRY_LIMIT_EXCEEDED: 'retry-limit-exceeded',
    INVALID_CHECKSUM: 'invalid-checksum',
    CANCELED: 'canceled',
    // JS specific
    INVALID_EVENT_NAME: 'invalid-event-name',
    INVALID_URL: 'invalid-url',
    INVALID_DEFAULT_BUCKET: 'invalid-default-bucket',
    NO_DEFAULT_BUCKET: 'no-default-bucket',
    CANNOT_SLICE_BLOB: 'cannot-slice-blob',
    SERVER_FILE_WRONG_SIZE: 'server-file-wrong-size',
    NO_DOWNLOAD_URL: 'no-download-url',
    INVALID_ARGUMENT: 'invalid-argument',
    INVALID_ARGUMENT_COUNT: 'invalid-argument-count',
    APP_DELETED: 'app-deleted',
    INVALID_ROOT_OPERATION: 'invalid-root-operation',
    INVALID_FORMAT: 'invalid-format',
    INTERNAL_ERROR: 'internal-error'
};
function prependCode(code) {
    return 'storage/' + code;
}
function unknown() {
    var message = 'An unknown error occurred, please check the error payload for ' +
        'server response.';
    return new FirebaseStorageError(Code.UNKNOWN, message);
}
function objectNotFound(path) {
    return new FirebaseStorageError(Code.OBJECT_NOT_FOUND, "Object '" + path + "' does not exist.");
}
function quotaExceeded(bucket) {
    return new FirebaseStorageError(Code.QUOTA_EXCEEDED, "Quota for bucket '" +
        bucket +
        "' exceeded, please view quota on " +
        'https://firebase.google.com/pricing/.');
}
function unauthenticated() {
    var message = 'User is not authenticated, please authenticate using Firebase ' +
        'Authentication and try again.';
    return new FirebaseStorageError(Code.UNAUTHENTICATED, message);
}
function unauthorized(path) {
    return new FirebaseStorageError(Code.UNAUTHORIZED, "User does not have permission to access '" + path + "'.");
}
function retryLimitExceeded() {
    return new FirebaseStorageError(Code.RETRY_LIMIT_EXCEEDED, 'Max retry time for operation exceeded, please try again.');
}
function canceled() {
    return new FirebaseStorageError(Code.CANCELED, 'User canceled the upload/download.');
}
function invalidUrl(url) {
    return new FirebaseStorageError(Code.INVALID_URL, "Invalid URL '" + url + "'.");
}
function invalidDefaultBucket(bucket) {
    return new FirebaseStorageError(Code.INVALID_DEFAULT_BUCKET, "Invalid default bucket '" + bucket + "'.");
}
function cannotSliceBlob() {
    return new FirebaseStorageError(Code.CANNOT_SLICE_BLOB, 'Cannot slice blob for upload. Please retry the upload.');
}
function serverFileWrongSize() {
    return new FirebaseStorageError(Code.SERVER_FILE_WRONG_SIZE, 'Server recorded incorrect upload file size, please retry the upload.');
}
function noDownloadURL() {
    return new FirebaseStorageError(Code.NO_DOWNLOAD_URL, 'The given file does not have any download URLs.');
}
function invalidArgument(index, fnName, message) {
    return new FirebaseStorageError(Code.INVALID_ARGUMENT, 'Invalid argument in `' + fnName + '` at index ' + index + ': ' + message);
}
function invalidArgumentCount(argMin, argMax, fnName, real) {
    var countPart;
    var plural;
    if (argMin === argMax) {
        countPart = argMin;
        plural = argMin === 1 ? 'argument' : 'arguments';
    }
    else {
        countPart = 'between ' + argMin + ' and ' + argMax;
        plural = 'arguments';
    }
    return new FirebaseStorageError(Code.INVALID_ARGUMENT_COUNT, 'Invalid argument count in `' +
        fnName +
        '`: Expected ' +
        countPart +
        ' ' +
        plural +
        ', received ' +
        real +
        '.');
}
function appDeleted() {
    return new FirebaseStorageError(Code.APP_DELETED, 'The Firebase app was deleted.');
}
/**
 * @param name The name of the operation that was invalid.
 */
function invalidRootOperation(name) {
    return new FirebaseStorageError(Code.INVALID_ROOT_OPERATION, "The operation '" +
        name +
        "' cannot be performed on a root reference, create a non-root " +
        "reference using child, such as .child('file.png').");
}
/**
 * @param format The format that was not valid.
 * @param message A message describing the format violation.
 */
function invalidFormat(format, message) {
    return new FirebaseStorageError(Code.INVALID_FORMAT, "String does not match format '" + format + "': " + message);
}
/**
 * @param message A message describing the internal error.
 */
function internalError(message) {
    throw new FirebaseStorageError(Code.INTERNAL_ERROR, 'Internal error: ' + message);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var StringFormat = {
    RAW: 'raw',
    BASE64: 'base64',
    BASE64URL: 'base64url',
    DATA_URL: 'data_url'
};
function formatValidator(stringFormat) {
    switch (stringFormat) {
        case StringFormat.RAW:
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
        case StringFormat.DATA_URL:
            return;
        default:
            throw 'Expected one of the event types: [' +
                StringFormat.RAW +
                ', ' +
                StringFormat.BASE64 +
                ', ' +
                StringFormat.BASE64URL +
                ', ' +
                StringFormat.DATA_URL +
                '].';
    }
}
/**
 * @struct
 */
var StringData = /** @class */ (function () {
    function StringData(data, opt_contentType) {
        this.data = data;
        this.contentType = opt_contentType || null;
    }
    return StringData;
}());
function dataFromString(format, string) {
    switch (format) {
        case StringFormat.RAW:
            return new StringData(utf8Bytes_(string));
        case StringFormat.BASE64:
        case StringFormat.BASE64URL:
            return new StringData(base64Bytes_(format, string));
        case StringFormat.DATA_URL:
            return new StringData(dataURLBytes_(string), dataURLContentType_(string));
    }
    // assert(false);
    throw unknown();
}
function utf8Bytes_(string) {
    var b = [];
    for (var i = 0; i < string.length; i++) {
        var c = string.charCodeAt(i);
        if (c <= 127) {
            b.push(c);
        }
        else {
            if (c <= 2047) {
                b.push(192 | (c >> 6), 128 | (c & 63));
            }
            else {
                if ((c & 64512) == 55296) {
                    // The start of a surrogate pair.
                    var valid = i < string.length - 1 &&
                        (string.charCodeAt(i + 1) & 64512) == 56320;
                    if (!valid) {
                        // The second surrogate wasn't there.
                        b.push(239, 191, 189);
                    }
                    else {
                        var hi = c;
                        var lo = string.charCodeAt(++i);
                        c = 65536 | ((hi & 1023) << 10) | (lo & 1023);
                        b.push(240 | (c >> 18), 128 | ((c >> 12) & 63), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
                else {
                    if ((c & 64512) == 56320) {
                        // Invalid low surrogate.
                        b.push(239, 191, 189);
                    }
                    else {
                        b.push(224 | (c >> 12), 128 | ((c >> 6) & 63), 128 | (c & 63));
                    }
                }
            }
        }
    }
    return new Uint8Array(b);
}
function percentEncodedBytes_(string) {
    var decoded;
    try {
        decoded = decodeURIComponent(string);
    }
    catch (e) {
        throw invalidFormat(StringFormat.DATA_URL, 'Malformed data URL.');
    }
    return utf8Bytes_(decoded);
}
function base64Bytes_(format, string) {
    switch (format) {
        case StringFormat.BASE64: {
            var hasMinus = string.indexOf('-') !== -1;
            var hasUnder = string.indexOf('_') !== -1;
            if (hasMinus || hasUnder) {
                var invalidChar = hasMinus ? '-' : '_';
                throw invalidFormat(format, "Invalid character '" +
                    invalidChar +
                    "' found: is it base64url encoded?");
            }
            break;
        }
        case StringFormat.BASE64URL: {
            var hasPlus = string.indexOf('+') !== -1;
            var hasSlash = string.indexOf('/') !== -1;
            if (hasPlus || hasSlash) {
                var invalidChar = hasPlus ? '+' : '/';
                throw invalidFormat(format, "Invalid character '" + invalidChar + "' found: is it base64 encoded?");
            }
            string = string.replace(/-/g, '+').replace(/_/g, '/');
            break;
        }
    }
    var bytes;
    try {
        bytes = atob(string);
    }
    catch (e) {
        throw invalidFormat(format, 'Invalid character found');
    }
    var array = new Uint8Array(bytes.length);
    for (var i = 0; i < bytes.length; i++) {
        array[i] = bytes.charCodeAt(i);
    }
    return array;
}
/**
 * @struct
 */
var DataURLParts = /** @class */ (function () {
    function DataURLParts(dataURL) {
        this.base64 = false;
        this.contentType = null;
        var matches = dataURL.match(/^data:([^,]+)?,/);
        if (matches === null) {
            throw invalidFormat(StringFormat.DATA_URL, "Must be formatted 'data:[<mediatype>][;base64],<data>");
        }
        var middle = matches[1] || null;
        if (middle != null) {
            this.base64 = endsWith(middle, ';base64');
            this.contentType = this.base64
                ? middle.substring(0, middle.length - ';base64'.length)
                : middle;
        }
        this.rest = dataURL.substring(dataURL.indexOf(',') + 1);
    }
    return DataURLParts;
}());
function dataURLBytes_(string) {
    var parts = new DataURLParts(string);
    if (parts.base64) {
        return base64Bytes_(StringFormat.BASE64, parts.rest);
    }
    else {
        return percentEncodedBytes_(parts.rest);
    }
}
function dataURLContentType_(string) {
    var parts = new DataURLParts(string);
    return parts.contentType;
}
function endsWith(s, end) {
    var longEnough = s.length >= end.length;
    if (!longEnough) {
        return false;
    }
    return s.substring(s.length - end.length) === end;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var TaskEvent = {
    /** Triggered whenever the task changes or progress is updated. */
    STATE_CHANGED: 'state_changed'
};
var InternalTaskState = {
    RUNNING: 'running',
    PAUSING: 'pausing',
    PAUSED: 'paused',
    SUCCESS: 'success',
    CANCELING: 'canceling',
    CANCELED: 'canceled',
    ERROR: 'error'
};
var TaskState = {
    /** The task is currently transferring data. */
    RUNNING: 'running',
    /** The task was paused by the user. */
    PAUSED: 'paused',
    /** The task completed successfully. */
    SUCCESS: 'success',
    /** The task was canceled. */
    CANCELED: 'canceled',
    /** The task failed with an error. */
    ERROR: 'error'
};
function taskStateFromInternalTaskState(state) {
    switch (state) {
        case InternalTaskState.RUNNING:
        case InternalTaskState.PAUSING:
        case InternalTaskState.CANCELING:
            return TaskState.RUNNING;
        case InternalTaskState.PAUSED:
            return TaskState.PAUSED;
        case InternalTaskState.SUCCESS:
            return TaskState.SUCCESS;
        case InternalTaskState.CANCELED:
            return TaskState.CANCELED;
        case InternalTaskState.ERROR:
            return TaskState.ERROR;
        default:
            // TODO(andysoto): assert(false);
            return TaskState.ERROR;
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains methods for working with objects.
 */
function contains(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
function forEach(obj, f) {
    for (var key in obj) {
        if (contains(obj, key)) {
            f(key, obj[key]);
        }
    }
}
function clone(obj) {
    if (obj == null) {
        return {};
    }
    var c = {};
    forEach(obj, function (key, val) {
        c[key] = val;
    });
    return c;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Implements the promise abstraction interface for external
 * (public SDK) packaging, which just passes through to the firebase-app impl.
 */
/**
 * @template T
 * @param {function((function(T): void),
 *                  (function(!Error): void))} resolver
 */
function make(resolver) {
    return new Promise(resolver);
}
/**
 * @template T
 */
function resolve(value) {
    return Promise.resolve(value);
}
function reject(error) {
    return Promise.reject(error);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @return False if the object is undefined or null, true otherwise.
 */
function isDef(p) {
    return p != null;
}
function isJustDef(p) {
    return p !== void 0;
}
function isFunction(p) {
    return typeof p === 'function';
}
function isObject(p) {
    return typeof p === 'object';
}
function isNonNullObject(p) {
    return isObject(p) && p !== null;
}
function isNonArrayObject(p) {
    return isObject(p) && !Array.isArray(p);
}
function isString(p) {
    return typeof p === 'string' || p instanceof String;
}
function isNumber(p) {
    return typeof p === 'number' || p instanceof Number;
}
function isNativeBlob(p) {
    return isNativeBlobDefined() && p instanceof Blob;
}
function isNativeBlobDefined() {
    return typeof Blob !== 'undefined';
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @enum{number}
 */
var ErrorCode;
(function (ErrorCode) {
    ErrorCode[ErrorCode["NO_ERROR"] = 0] = "NO_ERROR";
    ErrorCode[ErrorCode["NETWORK_ERROR"] = 1] = "NETWORK_ERROR";
    ErrorCode[ErrorCode["ABORT"] = 2] = "ABORT";
})(ErrorCode || (ErrorCode = {}));

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * We use this instead of goog.net.XhrIo because goog.net.XhrIo is hyuuuuge and
 * doesn't work in React Native on Android.
 */
var NetworkXhrIo = /** @class */ (function () {
    function NetworkXhrIo() {
        var _this = this;
        this.sent_ = false;
        this.xhr_ = new XMLHttpRequest();
        this.errorCode_ = ErrorCode.NO_ERROR;
        this.sendPromise_ = make(function (resolve$$1, reject$$1) {
            _this.xhr_.addEventListener('abort', function (event) {
                _this.errorCode_ = ErrorCode.ABORT;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('error', function (event) {
                _this.errorCode_ = ErrorCode.NETWORK_ERROR;
                resolve$$1(_this);
            });
            _this.xhr_.addEventListener('load', function (event) {
                resolve$$1(_this);
            });
        });
    }
    /**
     * @override
     */
    NetworkXhrIo.prototype.send = function (url, method, opt_body, opt_headers) {
        var _this = this;
        if (this.sent_) {
            throw internalError('cannot .send() more than once');
        }
        this.sent_ = true;
        this.xhr_.open(method, url, true);
        if (isDef(opt_headers)) {
            var headers = opt_headers;
            forEach(headers, function (key, val) {
                _this.xhr_.setRequestHeader(key, val.toString());
            });
        }
        if (isDef(opt_body)) {
            this.xhr_.send(opt_body);
        }
        else {
            this.xhr_.send();
        }
        return this.sendPromise_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getErrorCode = function () {
        if (!this.sent_) {
            throw internalError('cannot .getErrorCode() before sending');
        }
        return this.errorCode_;
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getStatus = function () {
        if (!this.sent_) {
            throw internalError('cannot .getStatus() before sending');
        }
        try {
            return this.xhr_.status;
        }
        catch (e) {
            return -1;
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseText = function () {
        if (!this.sent_) {
            throw internalError('cannot .getResponseText() before sending');
        }
        return this.xhr_.responseText;
    };
    /**
     * Aborts the request.
     * @override
     */
    NetworkXhrIo.prototype.abort = function () {
        this.xhr_.abort();
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.getResponseHeader = function (header) {
        return this.xhr_.getResponseHeader(header);
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.addUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.addEventListener('progress', listener);
        }
    };
    /**
     * @override
     */
    NetworkXhrIo.prototype.removeUploadProgressListener = function (listener) {
        if (isDef(this.xhr_.upload)) {
            this.xhr_.upload.removeEventListener('progress', listener);
        }
    };
    return NetworkXhrIo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Factory-like class for creating XhrIo instances.
 */
var XhrIoPool = /** @class */ (function () {
    function XhrIoPool() {
    }
    XhrIoPool.prototype.createXhrIo = function () {
        return new NetworkXhrIo();
    };
    return XhrIoPool;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns the Object resulting from parsing the given JSON, or null if the
 * given string does not represent a JSON object.
 */
function jsonObjectOrNull(s) {
    var obj;
    try {
        obj = JSON.parse(s);
    }
    catch (e) {
        return null;
    }
    if (isNonArrayObject(obj)) {
        return obj;
    }
    else {
        return null;
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Location = /** @class */ (function () {
    function Location(bucket, path) {
        this.bucket = bucket;
        this.path_ = path;
    }
    Object.defineProperty(Location.prototype, "path", {
        get: function () {
            return this.path_;
        },
        enumerable: true,
        configurable: true
    });
    Location.prototype.fullServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o/' + encode(this.path);
    };
    Location.prototype.bucketOnlyServerUrl = function () {
        var encode = encodeURIComponent;
        return '/b/' + encode(this.bucket) + '/o';
    };
    Location.makeFromBucketSpec = function (bucketString) {
        var bucketLocation;
        try {
            bucketLocation = Location.makeFromUrl(bucketString);
        }
        catch (e) {
            // Not valid URL, use as-is. This lets you put bare bucket names in
            // config.
            return new Location(bucketString, '');
        }
        if (bucketLocation.path === '') {
            return bucketLocation;
        }
        else {
            throw invalidDefaultBucket(bucketString);
        }
    };
    Location.makeFromUrl = function (url) {
        var location = null;
        var bucketDomain = '([A-Za-z0-9.\\-]+)';
        function gsModify(loc) {
            if (loc.path.charAt(loc.path.length - 1) === '/') {
                loc.path_ = loc.path_.slice(0, -1);
            }
        }
        var gsPath = '(/(.*))?$';
        var path = '(/([^?#]*).*)?$';
        var gsRegex = new RegExp('^gs://' + bucketDomain + gsPath, 'i');
        var gsIndices = { bucket: 1, path: 3 };
        function httpModify(loc) {
            loc.path_ = decodeURIComponent(loc.path);
        }
        var version = 'v[A-Za-z0-9_]+';
        var httpRegex = new RegExp('^https?://firebasestorage\\.googleapis\\.com/' +
            version +
            '/b/' +
            bucketDomain +
            '/o' +
            path, 'i');
        var httpIndices = { bucket: 1, path: 3 };
        var groups = [
            { regex: gsRegex, indices: gsIndices, postModify: gsModify },
            { regex: httpRegex, indices: httpIndices, postModify: httpModify }
        ];
        for (var i = 0; i < groups.length; i++) {
            var group = groups[i];
            var captures = group.regex.exec(url);
            if (captures) {
                var bucketValue = captures[group.indices.bucket];
                var pathValue = captures[group.indices.path];
                if (!pathValue) {
                    pathValue = '';
                }
                location = new Location(bucketValue, pathValue);
                group.postModify(location);
                break;
            }
        }
        if (location == null) {
            throw invalidUrl(url);
        }
        return location;
    };
    return Location;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Contains helper methods for manipulating paths.
 */
/**
 * @return Null if the path is already at the root.
 */
function parent(path) {
    if (path.length == 0) {
        return null;
    }
    var index = path.lastIndexOf('/');
    if (index === -1) {
        return '';
    }
    var newPath = path.slice(0, index);
    return newPath;
}
function child(path, childPath) {
    var canonicalChildPath = childPath
        .split('/')
        .filter(function (component) {
        return component.length > 0;
    })
        .join('/');
    if (path.length === 0) {
        return canonicalChildPath;
    }
    else {
        return path + '/' + canonicalChildPath;
    }
}
/**
 * Returns the last component of a path.
 * '/foo/bar' -> 'bar'
 * '/foo/bar/baz/' -> 'baz/'
 * '/a' -> 'a'
 */
function lastComponent(path) {
    var index = path.lastIndexOf('/', path.length - 2);
    if (index === -1) {
        return path;
    }
    else {
        return path.slice(index + 1);
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function makeNormalUrl(urlPart) {
    return domainBase + apiBaseUrl + urlPart;
}
function makeDownloadUrl(urlPart) {
    return downloadBase + apiBaseUrl + urlPart;
}
function makeUploadUrl(urlPart) {
    return domainBase + apiUploadBaseUrl + urlPart;
}
function makeQueryString(params) {
    var encode = encodeURIComponent;
    var queryPart = '?';
    forEach(params, function (key, val) {
        var nextPart = encode(key) + '=' + encode(val);
        queryPart = queryPart + nextPart + '&';
    });
    // Chop off the extra '&' or '?' on the end
    queryPart = queryPart.slice(0, -1);
    return queryPart;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
function noXform_(metadata, value) {
    return value;
}
/**
 * @struct
 */
var Mapping = /** @class */ (function () {
    function Mapping(server, opt_local, opt_writable, opt_xform) {
        this.server = server;
        this.local = opt_local || server;
        this.writable = !!opt_writable;
        this.xform = opt_xform || noXform_;
    }
    return Mapping;
}());
var mappings_ = null;
function xformPath(fullPath) {
    var valid = isString(fullPath);
    if (!valid || fullPath.length < 2) {
        return fullPath;
    }
    else {
        fullPath = fullPath;
        return lastComponent(fullPath);
    }
}
function getMappings() {
    if (mappings_) {
        return mappings_;
    }
    var mappings = [];
    mappings.push(new Mapping('bucket'));
    mappings.push(new Mapping('generation'));
    mappings.push(new Mapping('metageneration'));
    mappings.push(new Mapping('name', 'fullPath', true));
    function mappingsXformPath(metadata, fullPath) {
        return xformPath(fullPath);
    }
    var nameMapping = new Mapping('name');
    nameMapping.xform = mappingsXformPath;
    mappings.push(nameMapping);
    /**
     * Coerces the second param to a number, if it is defined.
     */
    function xformSize(metadata, size) {
        if (isDef(size)) {
            return +size;
        }
        else {
            return size;
        }
    }
    var sizeMapping = new Mapping('size');
    sizeMapping.xform = xformSize;
    mappings.push(sizeMapping);
    mappings.push(new Mapping('timeCreated'));
    mappings.push(new Mapping('updated'));
    mappings.push(new Mapping('md5Hash', null, true));
    mappings.push(new Mapping('cacheControl', null, true));
    mappings.push(new Mapping('contentDisposition', null, true));
    mappings.push(new Mapping('contentEncoding', null, true));
    mappings.push(new Mapping('contentLanguage', null, true));
    mappings.push(new Mapping('contentType', null, true));
    mappings.push(new Mapping('metadata', 'customMetadata', true));
    /**
     * Transforms a comma-separated string of tokens into a list of download
     * URLs.
     */
    function xformTokens(metadata, tokens) {
        var valid = isString(tokens) && tokens.length > 0;
        if (!valid) {
            // This can happen if objects are uploaded through GCS and retrieved
            // through list, so we don't want to throw an Error.
            return [];
        }
        var encode = encodeURIComponent;
        var tokensList = tokens.split(',');
        var urls = tokensList.map(function (token) {
            var bucket = metadata['bucket'];
            var path = metadata['fullPath'];
            var urlPart = '/b/' + encode(bucket) + '/o/' + encode(path);
            var base = makeDownloadUrl(urlPart);
            var queryString = makeQueryString({
                alt: 'media',
                token: token
            });
            return base + queryString;
        });
        return urls;
    }
    mappings.push(new Mapping('downloadTokens', 'downloadURLs', false, xformTokens));
    mappings_ = mappings;
    return mappings_;
}
function addRef(metadata, authWrapper) {
    function generateRef() {
        var bucket = metadata['bucket'];
        var path = metadata['fullPath'];
        var loc = new Location(bucket, path);
        return authWrapper.makeStorageReference(loc);
    }
    Object.defineProperty(metadata, 'ref', { get: generateRef });
}
function fromResource(authWrapper, resource, mappings) {
    var metadata = {};
    metadata['type'] = 'file';
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        metadata[mapping.local] = mapping.xform(metadata, resource[mapping.server]);
    }
    addRef(metadata, authWrapper);
    return metadata;
}
function fromResourceString(authWrapper, resourceString, mappings) {
    var obj = jsonObjectOrNull(resourceString);
    if (obj === null) {
        return null;
    }
    var resource = obj;
    return fromResource(authWrapper, resource, mappings);
}
function toResourceString(metadata, mappings) {
    var resource = {};
    var len = mappings.length;
    for (var i = 0; i < len; i++) {
        var mapping = mappings[i];
        if (mapping.writable) {
            resource[mapping.server] = metadata[mapping.local];
        }
    }
    return JSON.stringify(resource);
}
function metadataValidator(p) {
    var validType = p && isObject(p);
    if (!validType) {
        throw 'Expected Metadata object.';
    }
    for (var key in p) {
        var val = p[key];
        if (key === 'customMetadata') {
            if (!isObject(val)) {
                throw 'Expected object for \'customMetadata\' mapping.';
            }
        }
        else {
            if (isNonNullObject(val)) {
                throw "Mapping for '" + key + "' cannot be an object.";
            }
        }
    }
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param name Name of the function.
 * @param specs Argument specs.
 * @param passed The actual arguments passed to the function.
 * @throws {fbs.Error} If the arguments are invalid.
 */
function validate(name, specs, passed) {
    var minArgs = specs.length;
    var maxArgs = specs.length;
    for (var i = 0; i < specs.length; i++) {
        if (specs[i].optional) {
            minArgs = i;
            break;
        }
    }
    var validLength = minArgs <= passed.length && passed.length <= maxArgs;
    if (!validLength) {
        throw invalidArgumentCount(minArgs, maxArgs, name, passed.length);
    }
    for (var i = 0; i < passed.length; i++) {
        try {
            specs[i].validator(passed[i]);
        }
        catch (e) {
            if (e instanceof Error) {
                throw invalidArgument(i, name, e.message);
            }
            else {
                throw invalidArgument(i, name, e);
            }
        }
    }
}
/**
 * @struct
 */
var ArgSpec = /** @class */ (function () {
    function ArgSpec(validator, opt_optional) {
        var self = this;
        this.validator = function (p) {
            if (self.optional && !isJustDef(p)) {
                return;
            }
            validator(p);
        };
        this.optional = !!opt_optional;
    }
    return ArgSpec;
}());
function and_(v1, v2) {
    return function (p) {
        v1(p);
        v2(p);
    };
}
function stringSpec(opt_validator, opt_optional) {
    function stringValidator(p) {
        if (!isString(p)) {
            throw 'Expected string.';
        }
    }
    var validator;
    if (opt_validator) {
        validator = and_(stringValidator, opt_validator);
    }
    else {
        validator = stringValidator;
    }
    return new ArgSpec(validator, opt_optional);
}
function uploadDataSpec() {
    function validator(p) {
        var valid = p instanceof Uint8Array ||
            p instanceof ArrayBuffer ||
            (isNativeBlobDefined() && p instanceof Blob);
        if (!valid) {
            throw 'Expected Blob or File.';
        }
    }
    return new ArgSpec(validator);
}
function metadataSpec(opt_optional) {
    return new ArgSpec(metadataValidator, opt_optional);
}
function nonNegativeNumberSpec() {
    function validator(p) {
        var valid = isNumber(p) && p >= 0;
        if (!valid) {
            throw 'Expected a number 0 or greater.';
        }
    }
    return new ArgSpec(validator);
}
function looseObjectSpec(opt_validator, opt_optional) {
    function validator(p) {
        var isLooseObject = p === null || (isDef(p) && p instanceof Object);
        if (!isLooseObject) {
            throw 'Expected an Object.';
        }
        if (opt_validator !== undefined && opt_validator !== null) {
            opt_validator(p);
        }
    }
    return new ArgSpec(validator, opt_optional);
}
function nullFunctionSpec(opt_optional) {
    function validator(p) {
        var valid = p === null || isFunction(p);
        if (!valid) {
            throw 'Expected a Function.';
        }
    }
    return new ArgSpec(validator, opt_optional);
}

function getBlobBuilder() {
    if (typeof BlobBuilder !== 'undefined') {
        return BlobBuilder;
    }
    else if (typeof WebKitBlobBuilder !== 'undefined') {
        return WebKitBlobBuilder;
    }
    else {
        return undefined;
    }
}
/**
 * Concatenates one or more values together and converts them to a Blob.
 *
 * @param var_args The values that will make up the resulting blob.
 * @return The blob.
 */
function getBlob() {
    var var_args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        var_args[_i] = arguments[_i];
    }
    var BlobBuilder = getBlobBuilder();
    if (BlobBuilder !== undefined) {
        var bb = new BlobBuilder();
        for (var i = 0; i < var_args.length; i++) {
            bb.append(var_args[i]);
        }
        return bb.getBlob();
    }
    else {
        if (isNativeBlobDefined()) {
            return new Blob(var_args);
        }
        else {
            throw Error("This browser doesn't seem to support creating Blobs");
        }
    }
}
/**
 * Slices the blob. The returned blob contains data from the start byte
 * (inclusive) till the end byte (exclusive). Negative indices cannot be used.
 *
 * @param blob The blob to be sliced.
 * @param start Index of the starting byte.
 * @param end Index of the ending byte.
 * @return The blob slice or null if not supported.
 */
function sliceBlob(blob, start, end) {
    if (blob.webkitSlice) {
        return blob.webkitSlice(start, end);
    }
    else if (blob.mozSlice) {
        return blob.mozSlice(start, end);
    }
    else if (blob.slice) {
        return blob.slice(start, end);
    }
    return null;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param opt_elideCopy If true, doesn't copy mutable input data
 *     (e.g. Uint8Arrays). Pass true only if you know the objects will not be
 *     modified after this blob's construction.
 */
var FbsBlob = /** @class */ (function () {
    function FbsBlob(data, opt_elideCopy) {
        var size = 0;
        var blobType = '';
        if (isNativeBlob(data)) {
            this.data_ = data;
            size = data.size;
            blobType = data.type;
        }
        else if (data instanceof ArrayBuffer) {
            if (opt_elideCopy) {
                this.data_ = new Uint8Array(data);
            }
            else {
                this.data_ = new Uint8Array(data.byteLength);
                this.data_.set(new Uint8Array(data));
            }
            size = this.data_.length;
        }
        else if (data instanceof Uint8Array) {
            if (opt_elideCopy) {
                this.data_ = data;
            }
            else {
                this.data_ = new Uint8Array(data.length);
                this.data_.set(data);
            }
            size = data.length;
        }
        this.size_ = size;
        this.type_ = blobType;
    }
    FbsBlob.prototype.size = function () {
        return this.size_;
    };
    FbsBlob.prototype.type = function () {
        return this.type_;
    };
    FbsBlob.prototype.slice = function (startByte, endByte) {
        if (isNativeBlob(this.data_)) {
            var realBlob = this.data_;
            var sliced = sliceBlob(realBlob, startByte, endByte);
            if (sliced === null) {
                return null;
            }
            return new FbsBlob(sliced);
        }
        else {
            var slice = new Uint8Array(this.data_.buffer, startByte, endByte - startByte);
            return new FbsBlob(slice, true);
        }
    };
    FbsBlob.getBlob = function () {
        var var_args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            var_args[_i] = arguments[_i];
        }
        if (isNativeBlobDefined()) {
            var blobby = var_args.map(function (val) {
                if (val instanceof FbsBlob) {
                    return val.data_;
                }
                else {
                    return val;
                }
            });
            return new FbsBlob(getBlob.apply(null, blobby));
        }
        else {
            var uint8Arrays = var_args.map(function (val) {
                if (isString(val)) {
                    return dataFromString(StringFormat.RAW, val).data;
                }
                else {
                    // Blobs don't exist, so this has to be a Uint8Array.
                    return val.data_;
                }
            });
            var finalLength_1 = 0;
            uint8Arrays.forEach(function (array) {
                finalLength_1 += array.byteLength;
            });
            var merged_1 = new Uint8Array(finalLength_1);
            var index_1 = 0;
            uint8Arrays.forEach(function (array) {
                for (var i = 0; i < array.length; i++) {
                    merged_1[index_1++] = array[i];
                }
            });
            return new FbsBlob(merged_1, true);
        }
    };
    FbsBlob.prototype.uploadData = function () {
        return this.data_;
    };
    return FbsBlob;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns true if the object is contained in the array (compared with ===).
 * @template T
 */
function contains$1(array, elem) {
    return array.indexOf(elem) !== -1;
}
/**
 * Returns a shallow copy of the array or array-like object (e.g. arguments).
 * @template T
 */
function clone$1(arraylike) {
    return Array.prototype.slice.call(arraylike);
}
/**
 * Removes the given element from the given array, if it is contained.
 * Directly modifies the passed-in array.
 * @template T
 */
function remove(array, elem) {
    var i = array.indexOf(elem);
    if (i !== -1) {
        array.splice(i, 1);
    }
}

var RequestInfo = /** @class */ (function () {
    function RequestInfo(url, method, 
    /**
     * Returns the value with which to resolve the request's promise. Only called
     * if the request is successful. Throw from this function to reject the
     * returned Request's promise with the thrown error.
     * Note: The XhrIo passed to this function may be reused after this callback
     * returns. Do not keep a reference to it in any way.
     */
    handler, timeout) {
        this.url = url;
        this.method = method;
        this.handler = handler;
        this.timeout = timeout;
        this.urlParams = {};
        this.headers = {};
        this.body = null;
        this.errorHandler = null;
        /**
         * Called with the current number of bytes uploaded and total size (-1 if not
         * computable) of the request body (i.e. used to report upload progress).
         */
        this.progressCallback = null;
        this.successCodes = [200];
        this.additionalRetryCodes = [];
    }
    return RequestInfo;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Throws the UNKNOWN FirebaseStorageError if cndn is false.
 */
function handlerCheck(cndn) {
    if (!cndn) {
        throw unknown();
    }
}
function metadataHandler(authWrapper, mappings) {
    function handler(xhr, text) {
        var metadata = fromResourceString(authWrapper, text, mappings);
        handlerCheck(metadata !== null);
        return metadata;
    }
    return handler;
}
function sharedErrorHandler(location) {
    function errorHandler(xhr, err) {
        var newErr;
        if (xhr.getStatus() === 401) {
            newErr = unauthenticated();
        }
        else {
            if (xhr.getStatus() === 402) {
                newErr = quotaExceeded(location.bucket);
            }
            else {
                if (xhr.getStatus() === 403) {
                    newErr = unauthorized(location.path);
                }
                else {
                    newErr = err;
                }
            }
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function objectErrorHandler(location) {
    var shared = sharedErrorHandler(location);
    function errorHandler(xhr, err) {
        var newErr = shared(xhr, err);
        if (xhr.getStatus() === 404) {
            newErr = objectNotFound(location.path);
        }
        newErr.setServerResponseProp(err.serverResponseProp());
        return newErr;
    }
    return errorHandler;
}
function getMetadata(authWrapper, location, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'GET';
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function updateMetadata(authWrapper, location, metadata, mappings) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'PATCH';
    var body = toResourceString(metadata, mappings);
    var headers = { 'Content-Type': 'application/json; charset=utf-8' };
    var timeout = authWrapper.maxOperationRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function deleteObject(authWrapper, location) {
    var urlPart = location.fullServerUrl();
    var url = makeNormalUrl(urlPart);
    var method = 'DELETE';
    var timeout = authWrapper.maxOperationRetryTime();
    function handler(xhr, text) { }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.successCodes = [200, 204];
    requestInfo.errorHandler = objectErrorHandler(location);
    return requestInfo;
}
function determineContentType_(metadata, blob) {
    return ((metadata && metadata['contentType']) ||
        (blob && blob.type()) ||
        'application/octet-stream');
}
function metadataForUpload_(location, blob, opt_metadata) {
    var metadata = clone(opt_metadata);
    metadata['fullPath'] = location.path;
    metadata['size'] = blob.size();
    if (!metadata['contentType']) {
        metadata['contentType'] = determineContentType_(null, blob);
    }
    return metadata;
}
function multipartUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var headers = {
        'X-Goog-Upload-Protocol': 'multipart'
    };
    function genBoundary() {
        var str = '';
        for (var i = 0; i < 2; i++) {
            str =
                str +
                    Math.random()
                        .toString()
                        .slice(2);
        }
        return str;
    }
    var boundary = genBoundary();
    headers['Content-Type'] = 'multipart/related; boundary=' + boundary;
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var metadataString = toResourceString(metadata, mappings);
    var preBlobPart = '--' +
        boundary +
        '\r\n' +
        'Content-Type: application/json; charset=utf-8\r\n\r\n' +
        metadataString +
        '\r\n--' +
        boundary +
        '\r\n' +
        'Content-Type: ' +
        metadata['contentType'] +
        '\r\n\r\n';
    var postBlobPart = '\r\n--' + boundary + '--';
    var body = FbsBlob.getBlob(preBlobPart, blob, postBlobPart);
    if (body === null) {
        throw cannotSliceBlob();
    }
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, metadataHandler(authWrapper, mappings), timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param current The number of bytes that have been uploaded so far.
 * @param total The total number of bytes in the upload.
 * @param opt_finalized True if the server has finished the upload.
 * @param opt_metadata The upload metadata, should
 *     only be passed if opt_finalized is true.
 * @struct
 */
var ResumableUploadStatus = /** @class */ (function () {
    function ResumableUploadStatus(current, total, finalized, metadata) {
        this.current = current;
        this.total = total;
        this.finalized = !!finalized;
        this.metadata = metadata || null;
    }
    return ResumableUploadStatus;
}());
function checkResumeHeader_(xhr, opt_allowed) {
    var status;
    try {
        status = xhr.getResponseHeader('X-Goog-Upload-Status');
    }
    catch (e) {
        handlerCheck(false);
    }
    var allowed = opt_allowed || ['active'];
    handlerCheck(contains$1(allowed, status));
    return status;
}
function createResumableUpload(authWrapper, location, mappings, blob, opt_metadata) {
    var urlPart = location.bucketOnlyServerUrl();
    var metadata = metadataForUpload_(location, blob, opt_metadata);
    var urlParams = { name: metadata['fullPath'] };
    var url = makeUploadUrl(urlPart);
    var method = 'POST';
    var headers = {
        'X-Goog-Upload-Protocol': 'resumable',
        'X-Goog-Upload-Command': 'start',
        'X-Goog-Upload-Header-Content-Length': blob.size(),
        'X-Goog-Upload-Header-Content-Type': metadata['contentType'],
        'Content-Type': 'application/json; charset=utf-8'
    };
    var body = toResourceString(metadata, mappings);
    var timeout = authWrapper.maxUploadRetryTime();
    function handler(xhr, text) {
        checkResumeHeader_(xhr);
        var url;
        try {
            url = xhr.getResponseHeader('X-Goog-Upload-URL');
        }
        catch (e) {
            handlerCheck(false);
        }
        handlerCheck(isString(url));
        return url;
    }
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.urlParams = urlParams;
    requestInfo.headers = headers;
    requestInfo.body = body;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 */
function getResumableUploadStatus(authWrapper, location, url, blob) {
    var headers = { 'X-Goog-Upload-Command': 'query' };
    function handler(xhr, text) {
        var status = checkResumeHeader_(xhr, ['active', 'final']);
        var sizeString;
        try {
            sizeString = xhr.getResponseHeader('X-Goog-Upload-Size-Received');
        }
        catch (e) {
            handlerCheck(false);
        }
        var size = parseInt(sizeString, 10);
        handlerCheck(!isNaN(size));
        return new ResumableUploadStatus(size, blob.size(), status === 'final');
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}
/**
 * Any uploads via the resumable upload API must transfer a number of bytes
 * that is a multiple of this number.
 */
var resumableUploadChunkSize = 256 * 1024;
/**
 * @param url From a call to fbs.requests.createResumableUpload.
 * @param chunkSize Number of bytes to upload.
 * @param opt_status The previous status.
 *     If not passed or null, we start from the beginning.
 * @throws fbs.Error If the upload is already complete, the passed in status
 *     has a final size inconsistent with the blob, or the blob cannot be sliced
 *     for upload.
 */
function continueResumableUpload(location, authWrapper, url, blob, chunkSize, mappings, opt_status, opt_progressCallback) {
    // TODO(andysoto): standardize on internal asserts
    // assert(!(opt_status && opt_status.finalized));
    var status = new ResumableUploadStatus(0, 0);
    if (opt_status) {
        status.current = opt_status.current;
        status.total = opt_status.total;
    }
    else {
        status.current = 0;
        status.total = blob.size();
    }
    if (blob.size() !== status.total) {
        throw serverFileWrongSize();
    }
    var bytesLeft = status.total - status.current;
    var bytesToUpload = bytesLeft;
    if (chunkSize > 0) {
        bytesToUpload = Math.min(bytesToUpload, chunkSize);
    }
    var startByte = status.current;
    var endByte = startByte + bytesToUpload;
    var uploadCommand = bytesToUpload === bytesLeft ? 'upload, finalize' : 'upload';
    var headers = {
        'X-Goog-Upload-Command': uploadCommand,
        'X-Goog-Upload-Offset': status.current
    };
    var body = blob.slice(startByte, endByte);
    if (body === null) {
        throw cannotSliceBlob();
    }
    function handler(xhr, text) {
        // TODO(andysoto): Verify the MD5 of each uploaded range:
        // the 'x-range-md5' header comes back with status code 308 responses.
        // We'll only be able to bail out though, because you can't re-upload a
        // range that you previously uploaded.
        var uploadStatus = checkResumeHeader_(xhr, ['active', 'final']);
        var newCurrent = status.current + bytesToUpload;
        var size = blob.size();
        var metadata;
        if (uploadStatus === 'final') {
            metadata = metadataHandler(authWrapper, mappings)(xhr, text);
        }
        else {
            metadata = null;
        }
        return new ResumableUploadStatus(newCurrent, size, uploadStatus === 'final', metadata);
    }
    var method = 'POST';
    var timeout = authWrapper.maxUploadRetryTime();
    var requestInfo = new RequestInfo(url, method, handler, timeout);
    requestInfo.headers = headers;
    requestInfo.body = body.uploadData();
    requestInfo.progressCallback = opt_progressCallback || null;
    requestInfo.errorHandler = sharedErrorHandler(location);
    return requestInfo;
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var Observer = /** @class */ (function () {
    function Observer(nextOrObserver, opt_error, opt_complete) {
        var asFunctions = isFunction(nextOrObserver) ||
            isDef(opt_error) ||
            isDef(opt_complete);
        if (asFunctions) {
            this.next = nextOrObserver;
            this.error = opt_error || null;
            this.complete = opt_complete || null;
        }
        else {
            var observer = nextOrObserver;
            this.next = observer.next || null;
            this.error = observer.error || null;
            this.complete = observer.complete || null;
        }
    }
    return Observer;
}());

var UploadTaskSnapshot = /** @class */ (function () {
    function UploadTaskSnapshot(bytesTransferred, totalBytes, state, metadata, task, ref) {
        this.bytesTransferred = bytesTransferred;
        this.totalBytes = totalBytes;
        this.state = state;
        this.metadata = metadata;
        this.task = task;
        this.ref = ref;
    }
    Object.defineProperty(UploadTaskSnapshot.prototype, "downloadURL", {
        get: function () {
            if (this.metadata !== null) {
                var urls = this.metadata['downloadURLs'];
                if (urls != null && urls[0] != null) {
                    return urls[0];
                }
                else {
                    return null;
                }
            }
            else {
                return null;
            }
        },
        enumerable: true,
        configurable: true
    });
    return UploadTaskSnapshot;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Returns a function that invokes f with its arguments asynchronously as a
 * microtask, i.e. as soon as possible after the current script returns back
 * into browser code.
 */
function async(f) {
    return function () {
        var argsToForward = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            argsToForward[_i] = arguments[_i];
        }
        resolve(true).then(function () {
            f.apply(null, argsToForward);
        });
    };
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Represents a blob being uploaded. Can be used to pause/resume/cancel the
 * upload and manage callbacks for various events.
 */
var UploadTask = /** @class */ (function () {
    /**
     * @param ref The firebaseStorage.Reference object this task came
     *     from, untyped to avoid cyclic dependencies.
     * @param blob The blob to upload.
     */
    function UploadTask(ref, authWrapper, location, mappings, blob, metadata) {
        if (metadata === void 0) { metadata = null; }
        var _this = this;
        this.transferred_ = 0;
        this.needToFetchStatus_ = false;
        this.needToFetchMetadata_ = false;
        this.observers_ = [];
        this.error_ = null;
        this.uploadUrl_ = null;
        this.request_ = null;
        this.chunkMultiplier_ = 1;
        this.resolve_ = null;
        this.reject_ = null;
        this.ref_ = ref;
        this.authWrapper_ = authWrapper;
        this.location_ = location;
        this.blob_ = blob;
        this.metadata_ = metadata;
        this.mappings_ = mappings;
        this.resumable_ = this.shouldDoResumable_(this.blob_);
        this.state_ = InternalTaskState.RUNNING;
        this.errorHandler_ = function (error) {
            _this.request_ = null;
            _this.chunkMultiplier_ = 1;
            if (error.codeEquals(Code.CANCELED)) {
                _this.needToFetchStatus_ = true;
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.metadataErrorHandler_ = function (error) {
            _this.request_ = null;
            if (error.codeEquals(Code.CANCELED)) {
                _this.completeTransitions_();
            }
            else {
                _this.error_ = error;
                _this.transition_(InternalTaskState.ERROR);
            }
        };
        this.promise_ = make(function (resolve$$1, reject$$1) {
            _this.resolve_ = resolve$$1;
            _this.reject_ = reject$$1;
            _this.start_();
        });
        // Prevent uncaught rejections on the internal promise from bubbling out
        // to the top level with a dummy handler.
        this.promise_.then(null, function () { });
    }
    UploadTask.prototype.makeProgressCallback_ = function () {
        var _this = this;
        var sizeBefore = this.transferred_;
        return function (loaded, total) {
            _this.updateProgress_(sizeBefore + loaded);
        };
    };
    UploadTask.prototype.shouldDoResumable_ = function (blob) {
        return blob.size() > 256 * 1024;
    };
    UploadTask.prototype.start_ = function () {
        if (this.state_ !== InternalTaskState.RUNNING) {
            // This can happen if someone pauses us in a resume callback, for example.
            return;
        }
        if (this.request_ !== null) {
            return;
        }
        if (this.resumable_) {
            if (this.uploadUrl_ === null) {
                this.createResumable_();
            }
            else {
                if (this.needToFetchStatus_) {
                    this.fetchStatus_();
                }
                else {
                    if (this.needToFetchMetadata_) {
                        // Happens if we miss the metadata on upload completion.
                        this.fetchMetadata_();
                    }
                    else {
                        this.continueUpload_();
                    }
                }
            }
        }
        else {
            this.oneShotUpload_();
        }
    };
    UploadTask.prototype.resolveToken_ = function (callback) {
        var _this = this;
        this.authWrapper_.getAuthToken().then(function (authToken) {
            switch (_this.state_) {
                case InternalTaskState.RUNNING:
                    callback(authToken);
                    break;
                case InternalTaskState.CANCELING:
                    _this.transition_(InternalTaskState.CANCELED);
                    break;
                case InternalTaskState.PAUSING:
                    _this.transition_(InternalTaskState.PAUSED);
                    break;
                default:
            }
        });
    };
    // TODO(andysoto): assert false
    UploadTask.prototype.createResumable_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = createResumableUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var createRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = createRequest;
            createRequest.getPromise().then(function (url) {
                _this.request_ = null;
                _this.uploadUrl_ = url;
                _this.needToFetchStatus_ = false;
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.fetchStatus_ = function () {
        var _this = this;
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo = getResumableUploadStatus(_this.authWrapper_, _this.location_, url, _this.blob_);
            var statusRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = statusRequest;
            statusRequest.getPromise().then(function (status) {
                status = status;
                _this.request_ = null;
                _this.updateProgress_(status.current);
                _this.needToFetchStatus_ = false;
                if (status.finalized) {
                    _this.needToFetchMetadata_ = true;
                }
                _this.completeTransitions_();
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.continueUpload_ = function () {
        var _this = this;
        var chunkSize = resumableUploadChunkSize * this.chunkMultiplier_;
        var status = new ResumableUploadStatus(this.transferred_, this.blob_.size());
        // TODO(andysoto): assert(this.uploadUrl_ !== null);
        var url = this.uploadUrl_;
        this.resolveToken_(function (authToken) {
            var requestInfo;
            try {
                requestInfo = continueResumableUpload(_this.location_, _this.authWrapper_, url, _this.blob_, chunkSize, _this.mappings_, status, _this.makeProgressCallback_());
            }
            catch (e) {
                _this.error_ = e;
                _this.transition_(InternalTaskState.ERROR);
                return;
            }
            var uploadRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = uploadRequest;
            uploadRequest
                .getPromise()
                .then(function (newStatus) {
                _this.increaseMultiplier_();
                _this.request_ = null;
                _this.updateProgress_(newStatus.current);
                if (newStatus.finalized) {
                    _this.metadata_ = newStatus.metadata;
                    _this.transition_(InternalTaskState.SUCCESS);
                }
                else {
                    _this.completeTransitions_();
                }
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.increaseMultiplier_ = function () {
        var currentSize = resumableUploadChunkSize * this.chunkMultiplier_;
        // Max chunk size is 32M.
        if (currentSize < 32 * 1024 * 1024) {
            this.chunkMultiplier_ *= 2;
        }
    };
    UploadTask.prototype.fetchMetadata_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = getMetadata(_this.authWrapper_, _this.location_, _this.mappings_);
            var metadataRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = metadataRequest;
            metadataRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.metadataErrorHandler_);
        });
    };
    UploadTask.prototype.oneShotUpload_ = function () {
        var _this = this;
        this.resolveToken_(function (authToken) {
            var requestInfo = multipartUpload(_this.authWrapper_, _this.location_, _this.mappings_, _this.blob_, _this.metadata_);
            var multipartRequest = _this.authWrapper_.makeRequest(requestInfo, authToken);
            _this.request_ = multipartRequest;
            multipartRequest.getPromise().then(function (metadata) {
                _this.request_ = null;
                _this.metadata_ = metadata;
                _this.updateProgress_(_this.blob_.size());
                _this.transition_(InternalTaskState.SUCCESS);
            }, _this.errorHandler_);
        });
    };
    UploadTask.prototype.updateProgress_ = function (transferred) {
        var old = this.transferred_;
        this.transferred_ = transferred;
        // A progress update can make the "transferred" value smaller (e.g. a
        // partial upload not completed by server, after which the "transferred"
        // value may reset to the value at the beginning of the request).
        if (this.transferred_ !== old) {
            this.notifyObservers_();
        }
    };
    UploadTask.prototype.transition_ = function (state) {
        if (this.state_ === state) {
            return;
        }
        switch (state) {
            case InternalTaskState.CANCELING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.PAUSING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING);
                this.state_ = state;
                if (this.request_ !== null) {
                    this.request_.cancel();
                }
                break;
            case InternalTaskState.RUNNING:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.PAUSING);
                var wasPaused = this.state_ === InternalTaskState.PAUSED;
                this.state_ = state;
                if (wasPaused) {
                    this.notifyObservers_();
                    this.start_();
                }
                break;
            case InternalTaskState.PAUSED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.CANCELED:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.PAUSED ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.error_ = canceled();
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.ERROR:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
            case InternalTaskState.SUCCESS:
                // TODO(andysoto):
                // assert(this.state_ === InternalTaskState.RUNNING ||
                //        this.state_ === InternalTaskState.PAUSING ||
                //        this.state_ === InternalTaskState.CANCELING);
                this.state_ = state;
                this.notifyObservers_();
                break;
        }
    };
    UploadTask.prototype.completeTransitions_ = function () {
        switch (this.state_) {
            case InternalTaskState.PAUSING:
                this.transition_(InternalTaskState.PAUSED);
                break;
            case InternalTaskState.CANCELING:
                this.transition_(InternalTaskState.CANCELED);
                break;
            case InternalTaskState.RUNNING:
                this.start_();
                break;
            default:
                // TODO(andysoto): assert(false);
                break;
        }
    };
    Object.defineProperty(UploadTask.prototype, "snapshot", {
        get: function () {
            var externalState = taskStateFromInternalTaskState(this.state_);
            return new UploadTaskSnapshot(this.transferred_, this.blob_.size(), externalState, this.metadata_, this, this.ref_);
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Adds a callback for an event.
     * @param type The type of event to listen for.
     */
    UploadTask.prototype.on = function (type, nextOrObserver, error, completed) {
        if (nextOrObserver === void 0) { nextOrObserver = undefined; }
        if (error === void 0) { error = undefined; }
        if (completed === void 0) { completed = undefined; }
        function typeValidator(_p) {
            if (type !== TaskEvent.STATE_CHANGED) {
                throw "Expected one of the event types: [" + TaskEvent.STATE_CHANGED + "].";
            }
        }
        var nextOrObserverMessage = 'Expected a function or an Object with one of ' +
            '`next`, `error`, `complete` properties.';
        var nextValidator = nullFunctionSpec(true).validator;
        var observerValidator = looseObjectSpec(null, true).validator;
        function nextOrObserverValidator(p) {
            try {
                nextValidator(p);
                return;
            }
            catch (e) { }
            try {
                observerValidator(p);
                var anyDefined = isJustDef(p['next']) ||
                    isJustDef(p['error']) ||
                    isJustDef(p['complete']);
                if (!anyDefined) {
                    throw '';
                }
                return;
            }
            catch (e) {
                throw nextOrObserverMessage;
            }
        }
        var specs = [
            stringSpec(typeValidator),
            looseObjectSpec(nextOrObserverValidator, true),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        validate('on', specs, arguments);
        var self = this;
        function makeBinder(specs) {
            function binder(nextOrObserver, error, opt_complete) {
                if (specs !== null) {
                    validate('on', specs, arguments);
                }
                var observer = new Observer(nextOrObserver, error, completed);
                self.addObserver_(observer);
                return function () {
                    self.removeObserver_(observer);
                };
            }
            return binder;
        }
        function binderNextOrObserverValidator(p) {
            if (p === null) {
                throw nextOrObserverMessage;
            }
            nextOrObserverValidator(p);
        }
        var binderSpecs = [
            looseObjectSpec(binderNextOrObserverValidator),
            nullFunctionSpec(true),
            nullFunctionSpec(true)
        ];
        var typeOnly = !(isJustDef(nextOrObserver) ||
            isJustDef(error) ||
            isJustDef(completed));
        if (typeOnly) {
            return makeBinder(binderSpecs);
        }
        else {
            return makeBinder(null)(nextOrObserver, error, completed);
        }
    };
    /**
     * This object behaves like a Promise, and resolves with its snapshot data
     * when the upload completes.
     * @param onFulfilled The fulfillment callback. Promise chaining works as normal.
     * @param onRejected The rejection callback.
     */
    UploadTask.prototype.then = function (onFulfilled, onRejected) {
        // These casts are needed so that TypeScript can infer the types of the
        // resulting Promise.
        return this.promise_.then(onFulfilled, onRejected);
    };
    /**
     * Equivalent to calling `then(null, onRejected)`.
     */
    UploadTask.prototype.catch = function (onRejected) {
        return this.then(null, onRejected);
    };
    /**
     * Adds the given observer.
     */
    UploadTask.prototype.addObserver_ = function (observer) {
        this.observers_.push(observer);
        this.notifyObserver_(observer);
    };
    /**
     * Removes the given observer.
     */
    UploadTask.prototype.removeObserver_ = function (observer) {
        remove(this.observers_, observer);
    };
    UploadTask.prototype.notifyObservers_ = function () {
        var _this = this;
        this.finishPromise_();
        var observers = clone$1(this.observers_);
        observers.forEach(function (observer) {
            _this.notifyObserver_(observer);
        });
    };
    UploadTask.prototype.finishPromise_ = function () {
        if (this.resolve_ !== null) {
            var triggered = true;
            switch (taskStateFromInternalTaskState(this.state_)) {
                case TaskState.SUCCESS:
                    async(this.resolve_.bind(null, this.snapshot))();
                    break;
                case TaskState.CANCELED:
                case TaskState.ERROR:
                    var toCall = this.reject_;
                    async(toCall.bind(null, this.error_))();
                    break;
                default:
                    triggered = false;
                    break;
            }
            if (triggered) {
                this.resolve_ = null;
                this.reject_ = null;
            }
        }
    };
    UploadTask.prototype.notifyObserver_ = function (observer) {
        var externalState = taskStateFromInternalTaskState(this.state_);
        switch (externalState) {
            case TaskState.RUNNING:
            case TaskState.PAUSED:
                if (observer.next !== null) {
                    async(observer.next.bind(observer, this.snapshot))();
                }
                break;
            case TaskState.SUCCESS:
                if (observer.complete !== null) {
                    async(observer.complete.bind(observer))();
                }
                break;
            case TaskState.CANCELED:
            case TaskState.ERROR:
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
                break;
            default:
                // TODO(andysoto): assert(false);
                if (observer.error !== null) {
                    async(observer.error.bind(observer, this.error_))();
                }
        }
    };
    /**
     * Resumes a paused task. Has no effect on a currently running or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.resume = function () {
        validate('resume', [], arguments);
        var valid = this.state_ === InternalTaskState.PAUSED ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.RUNNING);
        }
        return valid;
    };
    /**
     * Pauses a currently running task. Has no effect on a paused or failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.pause = function () {
        validate('pause', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING;
        if (valid) {
            this.transition_(InternalTaskState.PAUSING);
        }
        return valid;
    };
    /**
     * Cancels a currently running or paused task. Has no effect on a complete or
     * failed task.
     * @return True if the operation took effect, false if ignored.
     */
    UploadTask.prototype.cancel = function () {
        validate('cancel', [], arguments);
        var valid = this.state_ === InternalTaskState.RUNNING ||
            this.state_ === InternalTaskState.PAUSING;
        if (valid) {
            this.transition_(InternalTaskState.CANCELING);
        }
        return valid;
    };
    return UploadTask;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Provides methods to interact with a bucket in the Firebase Storage service.
 * @param location An fbs.location, or the URL at
 *     which to base this object, in one of the following forms:
 *         gs://<bucket>/<object-path>
 *         http[s]://firebasestorage.googleapis.com/
 *                     <api-version>/b/<bucket>/o/<object-path>
 *     Any query or fragment strings will be ignored in the http[s]
 *     format. If no value is passed, the storage object will use a URL based on
 *     the project ID of the base firebase.App instance.
 */
var Reference = /** @class */ (function () {
    function Reference(authWrapper, location) {
        this.authWrapper = authWrapper;
        if (location instanceof Location) {
            this.location = location;
        }
        else {
            this.location = Location.makeFromUrl(location);
        }
    }
    /**
     * @return The URL for the bucket and path this object references,
     *     in the form gs://<bucket>/<object-path>
     * @override
     */
    Reference.prototype.toString = function () {
        validate('toString', [], arguments);
        return 'gs://' + this.location.bucket + '/' + this.location.path;
    };
    Reference.prototype.newRef = function (authWrapper, location) {
        return new Reference(authWrapper, location);
    };
    Reference.prototype.mappings = function () {
        return getMappings();
    };
    /**
     * @return A reference to the object obtained by
     *     appending childPath, removing any duplicate, beginning, or trailing
     *     slashes.
     */
    Reference.prototype.child = function (childPath) {
        validate('child', [stringSpec()], arguments);
        var newPath = child(this.location.path, childPath);
        var location = new Location(this.location.bucket, newPath);
        return this.newRef(this.authWrapper, location);
    };
    Object.defineProperty(Reference.prototype, "parent", {
        /**
         * @return A reference to the parent of the
         *     current object, or null if the current object is the root.
         */
        get: function () {
            var newPath = parent(this.location.path);
            if (newPath === null) {
                return null;
            }
            var location = new Location(this.location.bucket, newPath);
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "root", {
        /**
         * @return An reference to the root of this
         *     object's bucket.
         */
        get: function () {
            var location = new Location(this.location.bucket, '');
            return this.newRef(this.authWrapper, location);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "bucket", {
        get: function () {
            return this.location.bucket;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "fullPath", {
        get: function () {
            return this.location.path;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "name", {
        get: function () {
            return lastComponent(this.location.path);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "storage", {
        get: function () {
            return this.authWrapper.service();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Uploads a blob to this object's location.
     * @param data The blob to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.put = function (data, metadata) {
        if (metadata === void 0) { metadata = null; }
        validate('put', [uploadDataSpec(), metadataSpec(true)], arguments);
        this.throwIfRoot_('put');
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data), metadata);
    };
    /**
     * Uploads a string to this object's location.
     * @param string The string to upload.
     * @param opt_format The format of the string to upload.
     * @return An UploadTask that lets you control and
     *     observe the upload.
     */
    Reference.prototype.putString = function (string, format, opt_metadata) {
        if (format === void 0) { format = StringFormat.RAW; }
        validate('putString', [
            stringSpec(),
            stringSpec(formatValidator, true),
            metadataSpec(true)
        ], arguments);
        this.throwIfRoot_('putString');
        var data = dataFromString(format, string);
        var metadata = clone(opt_metadata);
        if (!isDef(metadata['contentType']) && isDef(data.contentType)) {
            metadata['contentType'] = data.contentType;
        }
        return new UploadTask(this, this.authWrapper, this.location, this.mappings(), new FbsBlob(data.data, true), metadata);
    };
    /**
     * Deletes the object at this location.
     * @return A promise that resolves if the deletion succeeds.
     */
    Reference.prototype.delete = function () {
        validate('delete', [], arguments);
        this.throwIfRoot_('delete');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = deleteObject(self.authWrapper, self.location);
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     *     A promise that resolves with the metadata for this object. If this
     *     object doesn't exist or metadata cannot be retreived, the promise is
     *     rejected.
     */
    Reference.prototype.getMetadata = function () {
        validate('getMetadata', [], arguments);
        this.throwIfRoot_('getMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = getMetadata(self.authWrapper, self.location, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * Updates the metadata for this object.
     * @param metadata The new metadata for the object.
     *     Only values that have been explicitly set will be changed. Explicitly
     *     setting a value to null will remove the metadata.
     * @return A promise that resolves
     *     with the new metadata for this object.
     *     @see firebaseStorage.Reference.prototype.getMetadata
     */
    Reference.prototype.updateMetadata = function (metadata) {
        validate('updateMetadata', [metadataSpec()], arguments);
        this.throwIfRoot_('updateMetadata');
        var self = this;
        return this.authWrapper.getAuthToken().then(function (authToken) {
            var requestInfo = updateMetadata(self.authWrapper, self.location, metadata, self.mappings());
            return self.authWrapper.makeRequest(requestInfo, authToken).getPromise();
        });
    };
    /**
     * @return A promise that resolves with the download
     *     URL for this object.
     */
    Reference.prototype.getDownloadURL = function () {
        validate('getDownloadURL', [], arguments);
        this.throwIfRoot_('getDownloadURL');
        return this.getMetadata().then(function (metadata) {
            var url = metadata['downloadURLs'][0];
            if (isDef(url)) {
                return url;
            }
            else {
                throw noDownloadURL();
            }
        });
    };
    Reference.prototype.throwIfRoot_ = function (name) {
        if (this.location.path === '') {
            throw invalidRootOperation(name);
        }
    };
    return Reference;
}());

/**
 * A request whose promise always fails.
 * @struct
 * @template T
 */
var FailRequest = /** @class */ (function () {
    function FailRequest(error) {
        this.promise_ = reject(error);
    }
    /** @inheritDoc */
    FailRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    FailRequest.prototype.cancel = function (appDelete) {
        if (appDelete === void 0) { appDelete = false; }
    };
    return FailRequest;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 */
var RequestMap = /** @class */ (function () {
    function RequestMap() {
        this.map_ = {};
        this.id_ = minSafeInteger;
    }
    /**
     * Registers the given request with this map.
     * The request is unregistered when it completes.
     * @param r The request to register.
     */
    RequestMap.prototype.addRequest = function (r) {
        var id = this.id_;
        this.id_++;
        this.map_[id] = r;
        var self = this;
        function unmap() {
            delete self.map_[id];
        }
        r.getPromise().then(unmap, unmap);
    };
    /**
     * Cancels all registered requests.
     */
    RequestMap.prototype.clear = function () {
        forEach(this.map_, function (key, val) {
            if (val) {
                val.cancel(true);
            }
        });
        this.map_ = {};
    };
    return RequestMap;
}());

/**
 * @param app If null, getAuthToken always resolves with null.
 * @param service The storage service associated with this auth wrapper.
 *     Untyped to avoid circular type dependencies.
 * @struct
 */
var AuthWrapper = /** @class */ (function () {
    function AuthWrapper(app, maker, requestMaker, service, pool) {
        this.bucket_ = null;
        this.deleted_ = false;
        this.app_ = app;
        if (this.app_ !== null) {
            var options = this.app_.options;
            if (isDef(options)) {
                this.bucket_ = AuthWrapper.extractBucket_(options);
            }
        }
        this.storageRefMaker_ = maker;
        this.requestMaker_ = requestMaker;
        this.pool_ = pool;
        this.service_ = service;
        this.maxOperationRetryTime_ = defaultMaxOperationRetryTime;
        this.maxUploadRetryTime_ = defaultMaxUploadRetryTime;
        this.requestMap_ = new RequestMap();
    }
    AuthWrapper.extractBucket_ = function (config) {
        var bucketString = config[configOption] || null;
        if (bucketString == null) {
            return null;
        }
        var loc = Location.makeFromBucketSpec(bucketString);
        return loc.bucket;
    };
    AuthWrapper.prototype.getAuthToken = function () {
        // TODO(andysoto): remove ifDef checks after firebase-app implements stubs
        // (b/28673818).
        if (this.app_ !== null &&
            isDef(this.app_.INTERNAL) &&
            isDef(this.app_.INTERNAL.getToken)) {
            return this.app_.INTERNAL.getToken().then(function (response) {
                if (response !== null) {
                    return response.accessToken;
                }
                else {
                    return null;
                }
            }, function (_error) {
                return null;
            });
        }
        else {
            return resolve(null);
        }
    };
    AuthWrapper.prototype.bucket = function () {
        if (this.deleted_) {
            throw appDeleted();
        }
        else {
            return this.bucket_;
        }
    };
    /**
     * The service associated with this auth wrapper. Untyped to avoid circular
     * type dependencies.
     */
    AuthWrapper.prototype.service = function () {
        return this.service_;
    };
    /**
     * Returns a new firebaseStorage.Reference object referencing this AuthWrapper
     * at the given Location.
     * @param loc The Location.
     * @return Actually a firebaseStorage.Reference, typing not allowed
     *     because of circular dependency problems.
     */
    AuthWrapper.prototype.makeStorageReference = function (loc) {
        return this.storageRefMaker_(this, loc);
    };
    AuthWrapper.prototype.makeRequest = function (requestInfo, authToken) {
        if (!this.deleted_) {
            var request = this.requestMaker_(requestInfo, authToken, this.pool_);
            this.requestMap_.addRequest(request);
            return request;
        }
        else {
            return new FailRequest(appDeleted());
        }
    };
    /**
     * Stop running requests and prevent more from being created.
     */
    AuthWrapper.prototype.deleteApp = function () {
        this.deleted_ = true;
        this.app_ = null;
        this.requestMap_.clear();
    };
    AuthWrapper.prototype.maxUploadRetryTime = function () {
        return this.maxUploadRetryTime_;
    };
    AuthWrapper.prototype.setMaxUploadRetryTime = function (time) {
        this.maxUploadRetryTime_ = time;
    };
    AuthWrapper.prototype.maxOperationRetryTime = function () {
        return this.maxOperationRetryTime_;
    };
    AuthWrapper.prototype.setMaxOperationRetryTime = function (time) {
        this.maxOperationRetryTime_ = time;
    };
    return AuthWrapper;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @param f May be invoked
 *     before the function returns.
 * @param callback Get all the arguments passed to the function
 *     passed to f, including the initial boolean.
 */
function start(f, callback, timeout) {
    // TODO(andysoto): make this code cleaner (probably refactor into an actual
    // type instead of a bunch of functions with state shared in the closure)
    var waitSeconds = 1;
    // Would type this as "number" but that doesn't work for Node so ¯\_(ツ)_/¯
    var timeoutId = null;
    var hitTimeout = false;
    var cancelState = 0;
    function canceled() {
        return cancelState === 2;
    }
    var triggeredCallback = false;
    function triggerCallback() {
        if (!triggeredCallback) {
            triggeredCallback = true;
            callback.apply(null, arguments);
        }
    }
    function callWithDelay(millis) {
        timeoutId = setTimeout(function () {
            timeoutId = null;
            f(handler, canceled());
        }, millis);
    }
    function handler(success) {
        var var_args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            var_args[_i - 1] = arguments[_i];
        }
        if (triggeredCallback) {
            return;
        }
        if (success) {
            triggerCallback.apply(null, arguments);
            return;
        }
        var mustStop = canceled() || hitTimeout;
        if (mustStop) {
            triggerCallback.apply(null, arguments);
            return;
        }
        if (waitSeconds < 64) {
            /* TODO(andysoto): don't back off so quickly if we know we're offline. */
            waitSeconds *= 2;
        }
        var waitMillis;
        if (cancelState === 1) {
            cancelState = 2;
            waitMillis = 0;
        }
        else {
            waitMillis = (waitSeconds + Math.random()) * 1000;
        }
        callWithDelay(waitMillis);
    }
    var stopped = false;
    function stop(wasTimeout) {
        if (stopped) {
            return;
        }
        stopped = true;
        if (triggeredCallback) {
            return;
        }
        if (timeoutId !== null) {
            if (!wasTimeout) {
                cancelState = 2;
            }
            clearTimeout(timeoutId);
            callWithDelay(0);
        }
        else {
            if (!wasTimeout) {
                cancelState = 1;
            }
        }
    }
    callWithDelay(0);
    setTimeout(function () {
        hitTimeout = true;
        stop(true);
    }, timeout);
    return stop;
}
/**
 * Stops the retry loop from repeating.
 * If the function is currently "in between" retries, it is invoked immediately
 * with the second parameter as "true". Otherwise, it will be invoked once more
 * after the current invocation finishes iff the current invocation would have
 * triggered another retry.
 */
function stop(id) {
    id(false);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @struct
 * @template T
 */
var NetworkRequest = /** @class */ (function () {
    function NetworkRequest(url, method, headers, body, successCodes, additionalRetryCodes, callback, errorCallback, timeout, progressCallback, pool) {
        this.pendingXhr_ = null;
        this.backoffId_ = null;
        this.resolve_ = null;
        this.reject_ = null;
        this.canceled_ = false;
        this.appDelete_ = false;
        this.url_ = url;
        this.method_ = method;
        this.headers_ = headers;
        this.body_ = body;
        this.successCodes_ = successCodes.slice();
        this.additionalRetryCodes_ = additionalRetryCodes.slice();
        this.callback_ = callback;
        this.errorCallback_ = errorCallback;
        this.progressCallback_ = progressCallback;
        this.timeout_ = timeout;
        this.pool_ = pool;
        var self = this;
        this.promise_ = make(function (resolve$$1, reject$$1) {
            self.resolve_ = resolve$$1;
            self.reject_ = reject$$1;
            self.start_();
        });
    }
    /**
     * Actually starts the retry loop.
     */
    NetworkRequest.prototype.start_ = function () {
        var self = this;
        function doTheRequest(backoffCallback, canceled$$1) {
            if (canceled$$1) {
                backoffCallback(false, new RequestEndStatus(false, null, true));
                return;
            }
            var xhr = self.pool_.createXhrIo();
            self.pendingXhr_ = xhr;
            function progressListener(progressEvent) {
                var loaded = progressEvent.loaded;
                var total = progressEvent.lengthComputable ? progressEvent.total : -1;
                if (self.progressCallback_ !== null) {
                    self.progressCallback_(loaded, total);
                }
            }
            if (self.progressCallback_ !== null) {
                xhr.addUploadProgressListener(progressListener);
            }
            xhr
                .send(self.url_, self.method_, self.body_, self.headers_)
                .then(function (xhr) {
                if (self.progressCallback_ !== null) {
                    xhr.removeUploadProgressListener(progressListener);
                }
                self.pendingXhr_ = null;
                xhr = xhr;
                var hitServer = xhr.getErrorCode() === ErrorCode.NO_ERROR;
                var status = xhr.getStatus();
                if (!hitServer || self.isRetryStatusCode_(status)) {
                    var wasCanceled = xhr.getErrorCode() === ErrorCode.ABORT;
                    backoffCallback(false, new RequestEndStatus(false, null, wasCanceled));
                    return;
                }
                var successCode = contains$1(self.successCodes_, status);
                backoffCallback(true, new RequestEndStatus(successCode, xhr));
            });
        }
        /**
         * @param requestWentThrough True if the request eventually went
         *     through, false if it hit the retry limit or was canceled.
         */
        function backoffDone(requestWentThrough, status) {
            var resolve$$1 = self.resolve_;
            var reject$$1 = self.reject_;
            var xhr = status.xhr;
            if (status.wasSuccessCode) {
                try {
                    var result = self.callback_(xhr, xhr.getResponseText());
                    if (isJustDef(result)) {
                        resolve$$1(result);
                    }
                    else {
                        resolve$$1();
                    }
                }
                catch (e) {
                    reject$$1(e);
                }
            }
            else {
                if (xhr !== null) {
                    var err = unknown();
                    err.setServerResponseProp(xhr.getResponseText());
                    if (self.errorCallback_) {
                        reject$$1(self.errorCallback_(xhr, err));
                    }
                    else {
                        reject$$1(err);
                    }
                }
                else {
                    if (status.canceled) {
                        var err = self.appDelete_
                            ? appDeleted()
                            : canceled();
                        reject$$1(err);
                    }
                    else {
                        var err = retryLimitExceeded();
                        reject$$1(err);
                    }
                }
            }
        }
        if (this.canceled_) {
            backoffDone(false, new RequestEndStatus(false, null, true));
        }
        else {
            this.backoffId_ = start(doTheRequest, backoffDone, this.timeout_);
        }
    };
    /** @inheritDoc */
    NetworkRequest.prototype.getPromise = function () {
        return this.promise_;
    };
    /** @inheritDoc */
    NetworkRequest.prototype.cancel = function (appDelete) {
        this.canceled_ = true;
        this.appDelete_ = appDelete || false;
        if (this.backoffId_ !== null) {
            stop(this.backoffId_);
        }
        if (this.pendingXhr_ !== null) {
            this.pendingXhr_.abort();
        }
    };
    NetworkRequest.prototype.isRetryStatusCode_ = function (status) {
        // The codes for which to retry came from this page:
        // https://cloud.google.com/storage/docs/exponential-backoff
        var isFiveHundredCode = status >= 500 && status < 600;
        var extraRetryCodes = [
            // Request Timeout: web server didn't receive full request in time.
            408,
            // Too Many Requests: you're getting rate-limited, basically.
            429
        ];
        var isExtraRetryCode = contains$1(extraRetryCodes, status);
        var isRequestSpecificRetryCode = contains$1(this.additionalRetryCodes_, status);
        return isFiveHundredCode || isExtraRetryCode || isRequestSpecificRetryCode;
    };
    return NetworkRequest;
}());
/**
 * A collection of information about the result of a network request.
 * @param opt_canceled Defaults to false.
 * @struct
 */
var RequestEndStatus = /** @class */ (function () {
    function RequestEndStatus(wasSuccessCode, xhr, opt_canceled) {
        this.wasSuccessCode = wasSuccessCode;
        this.xhr = xhr;
        this.canceled = !!opt_canceled;
    }
    return RequestEndStatus;
}());
function addAuthHeader_(headers, authToken) {
    if (authToken !== null && authToken.length > 0) {
        headers['Authorization'] = 'Firebase ' + authToken;
    }
}
function addVersionHeader_(headers) {
    var number = typeof __WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"] !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"].SDK_VERSION : 'AppManager';
    headers['X-Firebase-Storage-Version'] = 'webjs/' + number;
}
/**
 * @template T
 */
function makeRequest(requestInfo, authToken, pool) {
    var queryPart = makeQueryString(requestInfo.urlParams);
    var url = requestInfo.url + queryPart;
    var headers = clone(requestInfo.headers);
    addAuthHeader_(headers, authToken);
    addVersionHeader_(headers);
    return new NetworkRequest(url, requestInfo.method, headers, requestInfo.body, requestInfo.successCodes, requestInfo.additionalRetryCodes, requestInfo.handler, requestInfo.errorHandler, requestInfo.timeout, requestInfo.progressCallback, pool);
}

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * A service that provides firebaseStorage.Reference instances.
 * @param opt_url gs:// url to a custom Storage Bucket
 *
 * @struct
 */
var Service = /** @class */ (function () {
    function Service(app, pool, url) {
        this.bucket_ = null;
        function maker(authWrapper, loc) {
            return new Reference(authWrapper, loc);
        }
        this.authWrapper_ = new AuthWrapper(app, maker, makeRequest, this, pool);
        this.app_ = app;
        if (url != null) {
            this.bucket_ = Location.makeFromBucketSpec(url);
        }
        else {
            var authWrapperBucket = this.authWrapper_.bucket();
            if (authWrapperBucket != null) {
                this.bucket_ = new Location(authWrapperBucket, '');
            }
        }
        this.internals_ = new ServiceInternals(this);
    }
    /**
     * Returns a firebaseStorage.Reference for the given path in the default
     * bucket.
     */
    Service.prototype.ref = function (path) {
        function validator(path) {
            if (/^[A-Za-z]+:\/\//.test(path)) {
                throw 'Expected child path but got a URL, use refFromURL instead.';
            }
        }
        validate('ref', [stringSpec(validator, true)], arguments);
        if (this.bucket_ == null) {
            throw new Error('No Storage Bucket defined in Firebase Options.');
        }
        var ref = new Reference(this.authWrapper_, this.bucket_);
        if (path != null) {
            return ref.child(path);
        }
        else {
            return ref;
        }
    };
    /**
     * Returns a firebaseStorage.Reference object for the given absolute URL,
     * which must be a gs:// or http[s]:// URL.
     */
    Service.prototype.refFromURL = function (url) {
        function validator(p) {
            if (!/^[A-Za-z]+:\/\//.test(p)) {
                throw 'Expected full URL but got a child path, use ref instead.';
            }
            try {
                Location.makeFromUrl(p);
            }
            catch (e) {
                throw 'Expected valid full URL but got an invalid one.';
            }
        }
        validate('refFromURL', [stringSpec(validator, false)], arguments);
        return new Reference(this.authWrapper_, url);
    };
    Object.defineProperty(Service.prototype, "maxUploadRetryTime", {
        get: function () {
            return this.authWrapper_.maxUploadRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxUploadRetryTime = function (time) {
        validate('setMaxUploadRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxUploadRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "maxOperationRetryTime", {
        get: function () {
            return this.authWrapper_.maxOperationRetryTime();
        },
        enumerable: true,
        configurable: true
    });
    Service.prototype.setMaxOperationRetryTime = function (time) {
        validate('setMaxOperationRetryTime', [nonNegativeNumberSpec()], arguments);
        this.authWrapper_.setMaxOperationRetryTime(time);
    };
    Object.defineProperty(Service.prototype, "app", {
        get: function () {
            return this.app_;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Service.prototype, "INTERNAL", {
        get: function () {
            return this.internals_;
        },
        enumerable: true,
        configurable: true
    });
    return Service;
}());
/**
 * @struct
 */
var ServiceInternals = /** @class */ (function () {
    function ServiceInternals(service) {
        this.service_ = service;
    }
    /**
     * Called when the associated app is deleted.
     * @see {!fbs.AuthWrapper.prototype.deleteApp}
     */
    ServiceInternals.prototype.delete = function () {
        this.service_.authWrapper_.deleteApp();
        return resolve(undefined);
    };
    return ServiceInternals;
}());

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Type constant for Firebase Storage.
 */
var STORAGE_TYPE = 'storage';
function factory(app, unused, opt_url) {
    return new Service(app, new XhrIoPool(), opt_url);
}
function registerStorage(instance) {
    var namespaceExports = {
        // no-inline
        TaskState: TaskState,
        TaskEvent: TaskEvent,
        StringFormat: StringFormat,
        Storage: Service,
        Reference: Reference
    };
    instance.INTERNAL.registerService(STORAGE_TYPE, factory, namespaceExports, undefined, 
    // Allow multiple storage instances per app.
    true);
}
registerStorage(__WEBPACK_IMPORTED_MODULE_0__firebase_app__["default"]);




/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SERVER_URL; });
/* unused harmony export API_DEVICE */
/* unused harmony export API_PARKING */
/* unused harmony export API_PARKING_CONTROL */
/* unused harmony export API_PAYMENT */
/* unused harmony export API_RATE */
/* unused harmony export API_SECURITY */
/* unused harmony export API_USER */
/* unused harmony export API_VEHICLE */
/* unused harmony export API_ZONE */
/* unused harmony export API_ROL */
/* unused harmony export API_PENALTY */
/* unused harmony export API_PARAMETER */
/* unused harmony export API_STATS */
/* unused harmony export API_PERMISSION */
/* unused harmony export Endpoint */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_CrudEndpoint__ = __webpack_require__(1251);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _get=function get(object,property,receiver){if(object===null)object=Function.prototype;var desc=Object.getOwnPropertyDescriptor(object,property);if(desc===undefined){var parent=Object.getPrototypeOf(object);if(parent===null){return undefined;}else{return get(parent,property,receiver);}}else if("value"in desc){return desc.value;}else{var getter=desc.get;if(getter===undefined){return undefined;}return getter.call(receiver);}};function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/*
 * Constantes con la url del server y de su api expuesta
 */var SERVER_URL="https://us-central1-hangover-prod.cloudfunctions.net/api";var API_DEVICE="/device";var API_PARKING="/parking";var API_PARKING_CONTROL="/parking_control";var API_PAYMENT="/payment_method";var API_RATE="/rate";var API_SECURITY="/security";var API_USER="/user";var API_VEHICLE="/vehicle";var API_ZONE="/zone";var API_ROL="/rol";var API_PENALTY="/parking_penalty";var API_PARAMETER="/parameter";var API_STATS="/stats/home";var API_PERMISSION="/permission";/*
 * Estructura de base para endpoints del proyecto
 */var endpointConfiguration={list:"{base}",add:"{base}",id:"{base}",edit:"{base}",delete:"{base}"};// clase para endpoints
var Endpoint=function(_CrudEndpoint){_inherits(Endpoint,_CrudEndpoint);function Endpoint(api){_classCallCheck(this,Endpoint);var _this=_possibleConstructorReturn(this,(Endpoint.__proto__||Object.getPrototypeOf(Endpoint)).call(this,SERVER_URL+api,endpointConfiguration));// {base} = SERVER_URL + api
_this.api=api;return _this;}_createClass(Endpoint,[{key:"queryString",value:function queryString(params){// pager translatror "page=1&pageSize=10" => "from=0&size=10"
if(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(params,"page")&&Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(params,"pageSize")){var size=parseInt(params.pageSize,10);var from=parseInt(params.page,10)*size-size;params.from=from;params.size=size;delete params.page;delete params.pageSize;}if(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(params,"searchText")&&Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(params["searchText"])){delete params.searchText;}return _get(Endpoint.prototype.__proto__||Object.getPrototypeOf(Endpoint.prototype),"queryString",this).call(this,params);}}]);return Endpoint;}(__WEBPACK_IMPORTED_MODULE_1__lib_CrudEndpoint__["a" /* default */]);

/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}/**
 * Generic REST Endpoint for: list, add, edit & delete
 *
 * let endpoint = new CrudEndpoint('http://server/api')
 * let url = endpoint.list({from:0, size:25})
 * // url = "http://server/api/list?from=0&size=25"
 */var defaultUri={list:"{base}",create:"{base}",id:"{base}/id",edit:"{base}/id",delete:"{base}/id"};var CrudEndpoint=function(){function CrudEndpoint(base){var config=arguments.length>1&&arguments[1]!==undefined?arguments[1]:defaultUri;_classCallCheck(this,CrudEndpoint);this._base=base;this.config=config;}_createClass(CrudEndpoint,[{key:"url",value:function url(key){if(!Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isEmpty"])(key)&&Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["has"])(this.config,key)){var url=""||this.config[key];if(url.length){return url.replace("{base}",this._base);}}return this._base;}},{key:"queryString",value:function queryString(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};if(Object(__WEBPACK_IMPORTED_MODULE_0_lodash__["isString"])(params)){return params.length?'?'+params:params;}var queryString="",arr=[],key=void 0,value=void 0;for(key in params){value=params[key];if(value!==null&&value!==undefined){arr.push(key.toString()+'='+value.toString());}}if(arr.length){queryString='?'+arr.join('&');}return queryString;}/*
   * Endpoints (urls)
   */},{key:"base",value:function base(args){return this.url()+this.queryString(args);}},{key:"list",value:function list(args){return this.url("list")+this.queryString(args);}},{key:"id",value:function id(_id,args){_id=_id.toString();return this.url("id")+'/'+_id+this.queryString(args);}},{key:"create",value:function create(args){return this.url("create")+this.queryString(args);}},{key:"update",value:function update(id,args){id=id.toString();return this.url("update")+'/'+id+this.queryString(args);}},{key:"delete",value:function _delete(id,args){id=id.toString();return this.url("delete")+'/'+id+this.queryString(args);}}]);return CrudEndpoint;}();/* harmony default export */ __webpack_exports__["a"] = (CrudEndpoint);

/***/ }),
/* 1252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var apiConnectorLarge=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:120000});var UserConfig=function(){function UserConfig(){_classCallCheck(this,UserConfig);}_createClass(UserConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpoint2",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN_V2;}},{key:"endpointUsers",get:function get(){return UserConfig.endpoint+"/users";}},{key:"endpointLoyaly",get:function get(){return UserConfig.endpoint+"/loyaly";}},{key:"transferPointEndpoint",get:function get(){return UserConfig.endpointLoyaly+"/recharge-points";}},{key:"endpointUsersByReg",get:function get(){return UserConfig.endpointUsers+"/reg";}},{key:"endpointUsersByEmailOrDU",get:function get(){return UserConfig.endpointUsers+"/usersByEmailOrDU";}},{key:"endpointUsersFromStorage",get:function get(){return UserConfig.endpoint2+"/users/usersFromStorage";}},{key:"endpointSaveUser",get:function get(){return UserConfig.endpointUsers+"/save";}},{key:"endpointDeleteUser",get:function get(){return UserConfig.endpointUsers+"/delete";}},{key:"endpointAddTagToUser",get:function get(){return UserConfig.endpointUsers+"/add-tags";}},{key:"endpointSendNotification",get:function get(){return UserConfig.endpointUsers+"/sendNotification";}},{key:"APIConnector",get:function get(){return apiConnector;}},{key:"APIConnectorLarge",get:function get(){return apiConnectorLarge;}}]);return UserConfig;}();/* harmony default export */ __webpack_exports__["a"] = (UserConfig);

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

exports.default = _default;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
}), 'VpnKey');

exports.default = _default;

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_bgCreek_png__ = __webpack_require__(1256);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_bgCreek_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_bgCreek_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_bgNuevamente_png__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_bgNuevamente_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_assets_bgNuevamente_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_bgHangover_png__ = __webpack_require__(1258);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_bgHangover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_bgHangover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_bgLeparc_png__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_bgLeparc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_bgLeparc_png__);
var bgLoginImage=null;var tenantId="hangover";if(tenantId=="creek"){bgLoginImage=__WEBPACK_IMPORTED_MODULE_0__common_assets_bgCreek_png___default.a;}else if(tenantId=="nuevamente"){bgLoginImage=__WEBPACK_IMPORTED_MODULE_1__common_assets_bgNuevamente_png___default.a;}else if(tenantId=="leparc"){bgLoginImage=__WEBPACK_IMPORTED_MODULE_3__common_assets_bgLeparc_png___default.a;}else if(tenantId=="hangover"){bgLoginImage=__WEBPACK_IMPORTED_MODULE_2__common_assets_bgHangover_png___default.a;}/* harmony default export */ __webpack_exports__["a"] = (bgLoginImage);

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bgCreek.4ca1868a.png";

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bgNuevamente.5c2eaf8e.png";

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bgHangover.99b3d3b9.png";

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/bgLeparc.bf2fc122.png";

/***/ }),
/* 1260 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelGroup__ = __webpack_require__(507);





var Accordion =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Accordion, _React$Component);

  function Accordion() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Accordion.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__PanelGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      accordion: true
    }), this.props.children);
  };

  return Accordion;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Accordion);

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1262);
module.exports = __webpack_require__(54).Object.assign;


/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(68);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(1266) });


/***/ }),
/* 1263 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(121) && !__webpack_require__(148)(function () {
  return Object.defineProperty(__webpack_require__(498)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(276);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(121);
var getKeys = __webpack_require__(194);
var gOPS = __webpack_require__(1270);
var pIE = __webpack_require__(505);
var toObject = __webpack_require__(196);
var IObject = __webpack_require__(499);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(148)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(193);
var toIObject = __webpack_require__(278);
var arrayIndexOf = __webpack_require__(1268)(false);
var IE_PROTO = __webpack_require__(281)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 1268 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(278);
var toLength = __webpack_require__(500);
var toAbsoluteIndex = __webpack_require__(1269);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(280);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 1270 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 1271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1272);

/***/ }),
/* 1272 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1273);
var $Object = __webpack_require__(54).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(68);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(506) });


/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(191);
var anObject = __webpack_require__(192);
var getKeys = __webpack_require__(194);

module.exports = __webpack_require__(121) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 1275 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(120).document;
module.exports = document && document.documentElement;


/***/ }),
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1277);

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1278);
module.exports = __webpack_require__(54).Object.keys;


/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 Object.keys(O)
var toObject = __webpack_require__(196);
var $keys = __webpack_require__(194);

__webpack_require__(1279)('keys', function () {
  return function keys(it) {
    return $keys(toObject(it));
  };
});


/***/ }),
/* 1279 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(68);
var core = __webpack_require__(54);
var fails = __webpack_require__(148);
module.exports = function (KEY, exec) {
  var fn = (core.Object || {})[KEY] || Object[KEY];
  var exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
};


/***/ }),
/* 1280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.uncontrolledPropTypes = uncontrolledPropTypes;
exports.isProp = isProp;
exports.defaultKey = defaultKey;
exports.isReactComponent = isReactComponent;

var _invariant = _interopRequireDefault(__webpack_require__(35));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var noop = function noop() {};

function readOnlyPropType(handler, name) {
  return function (props, propName) {
    if (props[propName] !== undefined) {
      if (!props[handler]) {
        return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + defaultKey(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
      }
    }
  };
}

function uncontrolledPropTypes(controlledValues, displayName) {
  var propTypes = {};
  Object.keys(controlledValues).forEach(function (prop) {
    // add default propTypes for folks that use runtime checks
    propTypes[defaultKey(prop)] = noop;

    if (false) {
      var handler = controlledValues[prop];
      !(typeof handler === 'string' && handler.trim().length) ? process.env.NODE_ENV !== "production" ? (0, _invariant.default)(false, 'Uncontrollable - [%s]: the prop `%s` needs a valid handler key name in order to make it uncontrollable', displayName, prop) : invariant(false) : void 0;
      propTypes[prop] = readOnlyPropType(handler, displayName);
    }
  });
  return propTypes;
}

function isProp(props, prop) {
  return props[prop] !== undefined;
}

function defaultKey(key) {
  return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */


function isReactComponent(component) {
  return !!(component && component.prototype && component.prototype.isReactComponent);
}

/***/ }),
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1282);
module.exports = __webpack_require__(54).Object.entries;


/***/ }),
/* 1282 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(68);
var $entries = __webpack_require__(509)(true);

$export($export.S, 'Object', {
  entries: function entries(it) {
    return $entries(it);
  }
});


/***/ }),
/* 1283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__CloseButton__ = __webpack_require__(282);










var propTypes = {
  onDismiss: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  closeLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  closeLabel: 'Close alert'
};

var Alert =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Alert, _React$Component);

  function Alert() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Alert.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        onDismiss = _this$props.onDismiss,
        closeLabel = _this$props.closeLabel,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onDismiss", "closeLabel", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var dismissable = !!onDismiss;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'dismissable')] = dismissable, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "alert",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), dismissable && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__CloseButton__["a" /* default */], {
      onClick: onDismiss,
      label: closeLabel
    }), children);
  };

  return Alert;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Alert.propTypes = propTypes;
Alert.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */].INFO, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('alert', Alert)));

/***/ }),
/* 1284 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1285);
module.exports = __webpack_require__(54).Object.values;


/***/ }),
/* 1285 */
/***/ (function(module, exports, __webpack_require__) {

// https://github.com/tc39/proposal-object-values-entries
var $export = __webpack_require__(68);
var $values = __webpack_require__(509)(false);

$export($export.S, 'Object', {
  values: function values(it) {
    return $values(it);
  }
});


/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);






 // TODO: `pullRight` doesn't belong here. There's no special handling here.

var propTypes = {
  pullRight: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  pullRight: false
};

var Badge =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Badge, _React$Component);

  function Badge() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Badge.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        pullRight = _this$props.pullRight,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["pullRight", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'pull-right': pullRight,
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Badge;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Badge.propTypes = propTypes;
Badge.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('badge', Badge));

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__ = __webpack_require__(511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);








var Breadcrumb =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Breadcrumb, _React$Component);

  function Breadcrumb() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Breadcrumb.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ol", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "navigation",
      "aria-label": "breadcrumbs",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Breadcrumb;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Breadcrumb.Item = __WEBPACK_IMPORTED_MODULE_5__BreadcrumbItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('breadcrumb', Breadcrumb));

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var ButtonToolbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ButtonToolbar, _React$Component);

  function ButtonToolbar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ButtonToolbar.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "toolbar",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ButtonToolbar;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('btn-toolbar', ButtonToolbar));

/***/ }),
/* 1289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__ = __webpack_require__(1290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CarouselItem__ = __webpack_require__(512);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Glyphicon__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__ = __webpack_require__(43);












 // TODO: `slide` should be `animate`.
// TODO: Use uncontrollable.

var propTypes = {
  slide: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  indicators: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * The amount of time to delay between automatically cycling an item.
   * If `null`, carousel will not automatically cycle.
   */
  interval: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  controls: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  pauseOnHover: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  wrap: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Callback fired when the active item changes.
   *
   * ```js
   * (eventKey: any, ?event: Object) => any
   * ```
   *
   * If this callback takes two or more arguments, the second argument will
   * be a persisted event object with `direction` set to the direction of the
   * transition.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  onSlideEnd: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,
  activeIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  defaultActiveIndex: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  direction: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.oneOf(['prev', 'next']),
  prevIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the previous element
   * in the carousel.
   * Set to null to deactivate.
   */
  prevLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
  nextIcon: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,

  /**
   * Label shown to screen readers only, can be used to show the next element
   * in the carousel.
   * Set to null to deactivate.
   */
  nextLabel: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  slide: true,
  interval: 5000,
  pauseOnHover: true,
  wrap: true,
  indicators: true,
  controls: true,
  prevIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-left"
  }),
  prevLabel: 'Previous',
  nextIcon: __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Glyphicon__["a" /* default */], {
    glyph: "chevron-right"
  }),
  nextLabel: 'Next'
};

var Carousel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Carousel, _React$Component);

  function Carousel(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleMouseOver = _this.handleMouseOver.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleMouseOut = _this.handleMouseOut.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handlePrev = _this.handlePrev.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleNext = _this.handleNext.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleItemAnimateOutEnd = _this.handleItemAnimateOutEnd.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    var defaultActiveIndex = props.defaultActiveIndex;
    _this.state = {
      activeIndex: defaultActiveIndex != null ? defaultActiveIndex : 0,
      previousActiveIndex: null,
      direction: null
    };
    _this.isUnmounted = false;
    return _this;
  }

  var _proto = Carousel.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.waitForNext();
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var activeIndex = this.getActiveIndex();

    if (nextProps.activeIndex != null && nextProps.activeIndex !== activeIndex) {
      clearTimeout(this.timeout);
      this.setState({
        previousActiveIndex: activeIndex,
        direction: nextProps.direction != null ? nextProps.direction : this.getDirection(activeIndex, nextProps.activeIndex)
      });
    }

    if (nextProps.activeIndex == null && this.state.activeIndex >= nextProps.children.length) {
      this.setState({
        activeIndex: 0,
        previousActiveIndex: null,
        direction: null
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    clearTimeout(this.timeout);
    this.isUnmounted = true;
  };

  _proto.getActiveIndex = function getActiveIndex() {
    var activeIndexProp = this.props.activeIndex;
    return activeIndexProp != null ? activeIndexProp : this.state.activeIndex;
  };

  _proto.getDirection = function getDirection(prevIndex, index) {
    if (prevIndex === index) {
      return null;
    }

    return prevIndex > index ? 'prev' : 'next';
  };

  _proto.handleItemAnimateOutEnd = function handleItemAnimateOutEnd() {
    var _this2 = this;

    this.setState({
      previousActiveIndex: null,
      direction: null
    }, function () {
      _this2.waitForNext();

      if (_this2.props.onSlideEnd) {
        _this2.props.onSlideEnd();
      }
    });
  };

  _proto.handleMouseOut = function handleMouseOut() {
    if (this.isPaused) {
      this.play();
    }
  };

  _proto.handleMouseOver = function handleMouseOver() {
    if (this.props.pauseOnHover) {
      this.pause();
    }
  };

  _proto.handleNext = function handleNext(e) {
    var index = this.getActiveIndex() + 1;
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children);

    if (index > count - 1) {
      if (!this.props.wrap) {
        return;
      }

      index = 0;
    }

    this.select(index, e, 'next');
  };

  _proto.handlePrev = function handlePrev(e) {
    var index = this.getActiveIndex() - 1;

    if (index < 0) {
      if (!this.props.wrap) {
        return;
      }

      index = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(this.props.children) - 1;
    }

    this.select(index, e, 'prev');
  }; // This might be a public API.


  _proto.pause = function pause() {
    this.isPaused = true;
    clearTimeout(this.timeout);
  }; // This might be a public API.


  _proto.play = function play() {
    this.isPaused = false;
    this.waitForNext();
  };

  _proto.select = function select(index, e, direction) {
    clearTimeout(this.timeout); // TODO: Is this necessary? Seems like the only risk is if the component
    // unmounts while handleItemAnimateOutEnd fires.

    if (this.isUnmounted) {
      return;
    }

    var previousActiveIndex = this.props.slide ? this.getActiveIndex() : null;
    direction = direction || this.getDirection(previousActiveIndex, index);
    var onSelect = this.props.onSelect;

    if (onSelect) {
      if (onSelect.length > 1) {
        // React SyntheticEvents are pooled, so we need to remove this event
        // from the pool to add a custom property. To avoid unnecessarily
        // removing objects from the pool, only do this when the listener
        // actually wants the event.
        if (e) {
          e.persist();
          e.direction = direction;
        } else {
          e = {
            direction: direction
          };
        }

        onSelect(index, e);
      } else {
        onSelect(index);
      }
    }

    if (this.props.activeIndex == null && index !== previousActiveIndex) {
      if (this.state.previousActiveIndex != null) {
        // If currently animating don't activate the new index.
        // TODO: look into queueing this canceled call and
        // animating after the current animation has ended.
        return;
      }

      this.setState({
        activeIndex: index,
        previousActiveIndex: previousActiveIndex,
        direction: direction
      });
    }
  };

  _proto.waitForNext = function waitForNext() {
    var _this$props = this.props,
        slide = _this$props.slide,
        interval = _this$props.interval,
        activeIndexProp = _this$props.activeIndex;

    if (!this.isPaused && slide && interval && activeIndexProp == null) {
      this.timeout = setTimeout(this.handleNext, interval);
    }
  };

  _proto.renderControls = function renderControls(properties) {
    var wrap = properties.wrap,
        children = properties.children,
        activeIndex = properties.activeIndex,
        prevIcon = properties.prevIcon,
        nextIcon = properties.nextIcon,
        bsProps = properties.bsProps,
        prevLabel = properties.prevLabel,
        nextLabel = properties.nextLabel;
    var controlClassName = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'control');
    var count = __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].count(children);
    return [(wrap || activeIndex !== 0) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "prev",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'left'),
      onClick: this.handlePrev
    }, prevIcon, prevLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, prevLabel)), (wrap || activeIndex !== count - 1) && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__SafeAnchor__["a" /* default */], {
      key: "next",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(controlClassName, 'right'),
      onClick: this.handleNext
    }, nextIcon, nextLabel && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, nextLabel))];
  };

  _proto.renderIndicators = function renderIndicators(children, activeIndex, bsProps) {
    var _this3 = this;

    var indicators = [];
    __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child, index) {
      indicators.push(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
        key: index,
        className: index === activeIndex ? 'active' : null,
        onClick: function onClick(e) {
          return _this3.select(index, e);
        }
      }), // Force whitespace between indicator elements. Bootstrap requires
      // this for correct spacing of elements.
      ' ');
    });
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("ol", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'indicators')
    }, indicators);
  };

  _proto.render = function render() {
    var _this4 = this;

    var _this$props2 = this.props,
        slide = _this$props2.slide,
        indicators = _this$props2.indicators,
        controls = _this$props2.controls,
        wrap = _this$props2.wrap,
        prevIcon = _this$props2.prevIcon,
        prevLabel = _this$props2.prevLabel,
        nextIcon = _this$props2.nextIcon,
        nextLabel = _this$props2.nextLabel,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["slide", "indicators", "controls", "wrap", "prevIcon", "prevLabel", "nextIcon", "nextLabel", "className", "children"]);

    var _this$state = this.state,
        previousActiveIndex = _this$state.previousActiveIndex,
        direction = _this$state.direction;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['interval', 'pauseOnHover', 'onSelect', 'onSlideEnd', 'activeIndex', // Accessed via this.getActiveIndex().
    'defaultActiveIndex', 'direction']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var activeIndex = this.getActiveIndex();

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      slide: slide
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      onMouseOver: this.handleMouseOver,
      onMouseOut: this.handleMouseOut
    }), indicators && this.renderIndicators(children, activeIndex, bsProps), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, __WEBPACK_IMPORTED_MODULE_12__utils_ValidComponentChildren__["a" /* default */].map(children, function (child, index) {
      var active = index === activeIndex;
      var previousActive = slide && index === previousActiveIndex;
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        active: active,
        index: index,
        animateOut: previousActive,
        animateIn: active && previousActiveIndex != null && slide,
        direction: direction,
        onAnimateOutEnd: previousActive ? _this4.handleItemAnimateOutEnd : null
      });
    })), controls && this.renderControls({
      wrap: wrap,
      children: children,
      activeIndex: activeIndex,
      prevIcon: prevIcon,
      prevLabel: prevLabel,
      nextIcon: nextIcon,
      nextLabel: nextLabel,
      bsProps: bsProps
    }));
  };

  return Carousel;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Carousel.propTypes = propTypes;
Carousel.defaultProps = defaultProps;
Carousel.Caption = __WEBPACK_IMPORTED_MODULE_7__CarouselCaption__["a" /* default */];
Carousel.Item = __WEBPACK_IMPORTED_MODULE_8__CarouselItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('carousel', Carousel));

/***/ }),
/* 1290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var CarouselCaption =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(CarouselCaption, _React$Component);

  function CarouselCaption() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = CarouselCaption.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return CarouselCaption;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

CarouselCaption.propTypes = propTypes;
CarouselCaption.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('carousel-caption', CarouselCaption));

/***/ }),
/* 1291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _end = _interopRequireDefault(__webpack_require__(1292));

exports.end = _end.default;

var _properties = _interopRequireDefault(__webpack_require__(199));

exports.properties = _properties.default;
var _default = {
  end: _end.default,
  properties: _properties.default
};
exports.default = _default;

/***/ }),
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _properties = _interopRequireDefault(__webpack_require__(199));

var _style = _interopRequireDefault(__webpack_require__(150));

function onEnd(node, handler, duration) {
  var fakeEvent = {
    target: node,
    currentTarget: node
  },
      backup;
  if (!_properties.default.end) duration = 0;else if (duration == null) duration = parseDuration(node) || 0;

  if (_properties.default.end) {
    node.addEventListener(_properties.default.end, done, false);
    backup = setTimeout(function () {
      return done(fakeEvent);
    }, (duration || 100) * 1.5);
  } else setTimeout(done.bind(null, fakeEvent), 0);

  function done(event) {
    if (event.target !== event.currentTarget) return;
    clearTimeout(backup);
    event.target.removeEventListener(_properties.default.end, done);
    handler.call(this);
  }
}

onEnd._parseDuration = parseDuration;
var _default = onEnd;
exports.default = _default;

function parseDuration(node) {
  var str = (0, _style.default)(node, _properties.default.duration),
      mult = str.indexOf('ms') === -1 ? 1000 : 1;
  return parseFloat(str) * mult;
}

module.exports = exports["default"];

/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = camelize;
var rHyphen = /-(.)/g;

function camelize(string) {
  return string.replace(rHyphen, function (_, chr) {
    return chr.toUpperCase();
  });
}

module.exports = exports["default"];

/***/ }),
/* 1294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = hyphenateStyleName;

var _hyphenate = _interopRequireDefault(__webpack_require__(1295));

/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */
var msPattern = /^ms-/;

function hyphenateStyleName(string) {
  return (0, _hyphenate.default)(string).replace(msPattern, '-ms-');
}

module.exports = exports["default"];

/***/ }),
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = hyphenate;
var rUpper = /([A-Z])/g;

function hyphenate(string) {
  return string.replace(rUpper, '-$1').toLowerCase();
}

module.exports = exports["default"];

/***/ }),
/* 1296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = _getComputedStyle;

var _camelizeStyle = _interopRequireDefault(__webpack_require__(513));

var rposition = /^(top|right|bottom|left)$/;
var rnumnonpx = /^([+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|))(?!px)[a-z%]+$/i;

function _getComputedStyle(node) {
  if (!node) throw new TypeError('No Element passed to `getComputedStyle()`');
  var doc = node.ownerDocument;
  return 'defaultView' in doc ? doc.defaultView.opener ? node.ownerDocument.defaultView.getComputedStyle(node, null) : window.getComputedStyle(node, null) : {
    //ie 8 "magic" from: https://github.com/jquery/jquery/blob/1.11-stable/src/css/curCSS.js#L72
    getPropertyValue: function getPropertyValue(prop) {
      var style = node.style;
      prop = (0, _camelizeStyle.default)(prop);
      if (prop == 'float') prop = 'styleFloat';
      var current = node.currentStyle[prop] || null;
      if (current == null && style && style[prop]) current = style[prop];

      if (rnumnonpx.test(current) && !rposition.test(prop)) {
        // Remember the original values
        var left = style.left;
        var runStyle = node.runtimeStyle;
        var rsLeft = runStyle && runStyle.left; // Put in the new values to get a computed value out

        if (rsLeft) runStyle.left = node.currentStyle.left;
        style.left = prop === 'fontSize' ? '1em' : current;
        current = style.pixelLeft + 'px'; // Revert the changed values

        style.left = left;
        if (rsLeft) runStyle.left = rsLeft;
      }

      return current;
    }
  };
}

module.exports = exports["default"];

/***/ }),
/* 1297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = removeStyle;

function removeStyle(node, key) {
  return 'removeProperty' in node.style ? node.style.removeProperty(key) : node.style.removeAttribute(key);
}

module.exports = exports["default"];

/***/ }),
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = isTransform;
var supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;

function isTransform(property) {
  return !!(property && supportedTransforms.test(property));
}

module.exports = exports["default"];

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Checkbox inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Checkbox =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Checkbox, _React$Component);

  function Checkbox() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Checkbox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "checkbox",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Checkbox inline>`. To display ' + 'validation state on an inline checkbox, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Checkbox;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Checkbox.propTypes = propTypes;
Checkbox.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('checkbox', Checkbox));

/***/ }),
/* 1300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_capitalize__ = __webpack_require__(514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__ = __webpack_require__(37);










var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Apply clearfix
   *
   * on Extra small devices Phones
   *
   * adds class `visible-xs-block`
   */
  visibleXsBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Small devices Tablets
   *
   * adds class `visible-sm-block`
   */
  visibleSmBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Medium devices Desktops
   *
   * adds class `visible-md-block`
   */
  visibleMdBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Apply clearfix
   *
   * on Large devices Desktops
   *
   * adds class `visible-lg-block`
   */
  visibleLgBlock: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  componentClass: 'div'
};

var Clearfix =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Clearfix, _React$Component);

  function Clearfix() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Clearfix.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    __WEBPACK_IMPORTED_MODULE_9__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      var propName = "visible" + Object(__WEBPACK_IMPORTED_MODULE_8__utils_capitalize__["a" /* default */])(size) + "Block";

      if (elementProps[propName]) {
        classes["visible-" + size + "-block"] = true;
      }

      delete elementProps[propName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Clearfix;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Clearfix.propTypes = propTypes;
Clearfix.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('clearfix', Clearfix));

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  htmlFor: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  srOnly: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  srOnly: false
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var ControlLabel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ControlLabel, _React$Component);

  function ControlLabel() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ControlLabel.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        _this$props$htmlFor = _this$props.htmlFor,
        htmlFor = _this$props$htmlFor === void 0 ? controlId : _this$props$htmlFor,
        srOnly = _this$props.srOnly,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["htmlFor", "srOnly", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || htmlFor === controlId, '`controlId` is ignored on `<ControlLabel>` when `htmlFor` is specified.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'sr-only': srOnly
    });

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      htmlFor: htmlFor,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return ControlLabel;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ControlLabel.propTypes = propTypes;
ControlLabel.defaultProps = defaultProps;
ControlLabel.contextTypes = contextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('control-label', ControlLabel));

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(37);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * The number of columns you wish to span
   *
   * for Extra small devices Phones (<768px)
   *
   * class-prefix `col-xs-`
   */
  xs: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Small devices Tablets (≥768px)
   *
   * class-prefix `col-sm-`
   */
  sm: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Medium devices Desktops (≥992px)
   *
   * class-prefix `col-md-`
   */
  md: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * The number of columns you wish to span
   *
   * for Large devices Desktops (≥1200px)
   *
   * class-prefix `col-lg-`
   */
  lg: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Hide column
   *
   * on Extra small devices Phones
   *
   * adds class `hidden-xs`
   */
  xsHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Small devices Tablets
   *
   * adds class `hidden-sm`
   */
  smHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Medium devices Desktops
   *
   * adds class `hidden-md`
   */
  mdHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Hide column
   *
   * on Large devices Desktops
   *
   * adds class `hidden-lg`
   */
  lgHidden: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Move columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-offset-`
   */
  xsOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-offset-`
   */
  smOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-offset-`
   */
  mdOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Move columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-offset-`
   */
  lgOffset: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-push-`
   */
  xsPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-push-`
   */
  smPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-push-`
   */
  mdPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the right
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-push-`
   */
  lgPush: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Extra small devices Phones
   *
   * class-prefix `col-xs-pull-`
   */
  xsPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Small devices Tablets
   *
   * class-prefix `col-sm-pull-`
   */
  smPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Medium devices Desktops
   *
   * class-prefix `col-md-pull-`
   */
  mdPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number,

  /**
   * Change the order of grid columns to the left
   *
   * for Large devices Desktops
   *
   * class-prefix `col-lg-pull-`
   */
  lgPull: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number
};
var defaultProps = {
  componentClass: 'div'
};

var Col =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Col, _React$Component);

  function Col() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Col.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];
    __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["a" /* DEVICE_SIZES */].forEach(function (size) {
      function popProp(propSuffix, modifier) {
        var propName = "" + size + propSuffix;
        var propValue = elementProps[propName];

        if (propValue != null) {
          classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, "" + size + modifier + "-" + propValue));
        }

        delete elementProps[propName];
      }

      popProp('', '');
      popProp('Offset', '-offset');
      popProp('Push', '-push');
      popProp('Pull', '-pull');
      var hiddenPropName = size + "Hidden";

      if (elementProps[hiddenPropName]) {
        classes.push("hidden-" + size);
      }

      delete elementProps[hiddenPropName];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Col;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Col.propTypes = propTypes;
Col.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('col', Col));

/***/ }),
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1304);

/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1305);
module.exports = __webpack_require__(54).parseInt;


/***/ }),
/* 1305 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(68);
var $parseInt = __webpack_require__(1306);
// 18.2.5 parseInt(string, radix)
$export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });


/***/ }),
/* 1306 */
/***/ (function(module, exports, __webpack_require__) {

var $parseInt = __webpack_require__(120).parseInt;
var $trim = __webpack_require__(1307).trim;
var ws = __webpack_require__(515);
var hex = /^[-+]?0[xX]/;

module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
  var string = $trim(String(str), 3);
  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
} : $parseInt;


/***/ }),
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(68);
var defined = __webpack_require__(195);
var fails = __webpack_require__(148);
var spaces = __webpack_require__(515);
var space = '[' + spaces + ']';
var non = '\u200b\u0085';
var ltrim = RegExp('^' + space + space + '*');
var rtrim = RegExp(space + space + '*$');

var exporter = function (KEY, exec, ALIAS) {
  var exp = {};
  var FORCE = fails(function () {
    return !!spaces[KEY]() || non[KEY]() != non;
  });
  var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
  if (ALIAS) exp[ALIAS] = fn;
  $export($export.P + $export.F * FORCE, 'String', exp);
};

// 1 -> String#trimLeft
// 2 -> String#trimRight
// 3 -> String#trim
var trim = exporter.trim = function (string, TYPE) {
  string = String(defined(string));
  if (TYPE & 1) string = string.replace(ltrim, '');
  if (TYPE & 2) string = string.replace(rtrim, '');
  return string;
};

module.exports = exporter;


/***/ }),
/* 1308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__ = __webpack_require__(1310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode__ = __webpack_require__(286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_keycode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_keycode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(43);














var propTypes = {
  open: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  pullRight: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.bool,
  onClose: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  labelledBy: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.number]),
  onSelect: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,
  rootCloseEvent: __WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.oneOf(['click', 'mousedown'])
};
var defaultProps = {
  bsRole: 'menu',
  pullRight: false
};

var DropdownMenu =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownMenu, _React$Component);

  function DropdownMenu(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.handleRootClose = _this.handleRootClose.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleKeyDown = _this.handleKeyDown.bind(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = DropdownMenu.prototype;

  _proto.getFocusableMenuItems = function getFocusableMenuItems() {
    var node = __WEBPACK_IMPORTED_MODULE_9_react_dom___default.a.findDOMNode(this);

    if (!node) {
      return [];
    }

    return __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_core_js_array_from___default()(node.querySelectorAll('[tabIndex="-1"]'));
  };

  _proto.getItemsAndActiveIndex = function getItemsAndActiveIndex() {
    var items = this.getFocusableMenuItems();
    var activeIndex = items.indexOf(document.activeElement);
    return {
      items: items,
      activeIndex: activeIndex
    };
  };

  _proto.focusNext = function focusNext() {
    var _this$getItemsAndActi = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi.items,
        activeIndex = _this$getItemsAndActi.activeIndex;

    if (items.length === 0) {
      return;
    }

    var nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    items[nextIndex].focus();
  };

  _proto.focusPrevious = function focusPrevious() {
    var _this$getItemsAndActi2 = this.getItemsAndActiveIndex(),
        items = _this$getItemsAndActi2.items,
        activeIndex = _this$getItemsAndActi2.activeIndex;

    if (items.length === 0) {
      return;
    }

    var prevIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    items[prevIndex].focus();
  };

  _proto.handleKeyDown = function handleKeyDown(event) {
    switch (event.keyCode) {
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.down:
        this.focusNext();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.up:
        this.focusPrevious();
        event.preventDefault();
        break;

      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.esc:
      case __WEBPACK_IMPORTED_MODULE_6_keycode___default.a.codes.tab:
        this.props.onClose(event, {
          source: 'keydown'
        });
        break;

      default:
    }
  };

  _proto.handleRootClose = function handleRootClose(event) {
    this.props.onClose(event, {
      source: 'rootClose'
    });
  };

  _proto.render = function render() {
    var _extends2,
        _this2 = this;

    var _this$props = this.props,
        open = _this$props.open,
        pullRight = _this$props.pullRight,
        labelledBy = _this$props.labelledBy,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        rootCloseEvent = _this$props.rootCloseEvent,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["open", "pullRight", "labelledBy", "onSelect", "className", "rootCloseEvent", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['onClose']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'right')] = pullRight, _extends2));

    return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_overlays_lib_RootCloseWrapper___default.a, {
      disabled: !open,
      onRootClose: this.handleRootClose,
      event: rootCloseEvent
    }, __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menu",
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, classes),
      "aria-labelledby": labelledBy
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.cloneElement(child, {
        onKeyDown: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onKeyDown, _this2.handleKeyDown),
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_12__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    })));
  };

  return DropdownMenu;
}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component);

DropdownMenu.propTypes = propTypes;
DropdownMenu.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11__utils_bootstrapUtils__["a" /* bsClass */])('dropdown-menu', DropdownMenu));

/***/ }),
/* 1310 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1311);

/***/ }),
/* 1311 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1312);
__webpack_require__(1318);
module.exports = __webpack_require__(54).Array.from;


/***/ }),
/* 1312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(1313)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(1314)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(280);
var defined = __webpack_require__(195);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 1314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(502);
var $export = __webpack_require__(68);
var redefine = __webpack_require__(1315);
var hide = __webpack_require__(190);
var Iterators = __webpack_require__(287);
var $iterCreate = __webpack_require__(1316);
var setToStringTag = __webpack_require__(518);
var getPrototypeOf = __webpack_require__(1317);
var ITERATOR = __webpack_require__(97)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 1315 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(190);


/***/ }),
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(506);
var descriptor = __webpack_require__(277);
var setToStringTag = __webpack_require__(518);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(190)(IteratorPrototype, __webpack_require__(97)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 1317 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(193);
var toObject = __webpack_require__(196);
var IE_PROTO = __webpack_require__(281)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 1318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(497);
var $export = __webpack_require__(68);
var toObject = __webpack_require__(196);
var call = __webpack_require__(1319);
var isArrayIter = __webpack_require__(1320);
var toLength = __webpack_require__(500);
var createProperty = __webpack_require__(1321);
var getIterFn = __webpack_require__(1322);

$export($export.S + $export.F * !__webpack_require__(1324)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1319 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(192);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 1320 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(287);
var ITERATOR = __webpack_require__(97)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 1321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(191);
var createDesc = __webpack_require__(277);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1322 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(1323);
var ITERATOR = __webpack_require__(97)('iterator');
var Iterators = __webpack_require__(287);
module.exports = __webpack_require__(54).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(279);
var TAG = __webpack_require__(97)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 1324 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(97)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__ = __webpack_require__(202);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var DropdownButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DropdownButton, _React$Component);

  function DropdownButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = DropdownButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Dropdown__["a" /* default */].Menu, null, children));
  };

  return DropdownButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

DropdownButton.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (DropdownButton);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  horizontal: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  horizontal: false,
  inline: false,
  componentClass: 'form'
};

var Form =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Form, _React$Component);

  function Form() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Form.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        horizontal = _this$props.horizontal,
        inline = _this$props.inline,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["horizontal", "inline", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = [];

    if (horizontal) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'horizontal'));
    }

    if (inline) {
      classes.push(Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline'));
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Form;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Form.propTypes = propTypes;
Form.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form', Form));

/***/ }),
/* 1327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__ = __webpack_require__(1329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__ = __webpack_require__(37);












var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a,

  /**
   * Only relevant if `componentClass` is `'input'`.
   */
  type: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Uses `controlId` from `<FormGroup>` if not explicitly specified.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <FormControl inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  componentClass: 'input'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControl =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControl, _React$Component);

  function FormControl() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControl.prototype;

  _proto.render = function render() {
    var formGroup = this.context.$bs_formGroup;
    var controlId = formGroup && formGroup.controlId;

    var _this$props = this.props,
        Component = _this$props.componentClass,
        type = _this$props.type,
        _this$props$id = _this$props.id,
        id = _this$props$id === void 0 ? controlId : _this$props$id,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        bsSize = _this$props.bsSize,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "type", "id", "inputRef", "className", "bsSize"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(controlId == null || id === controlId, '`controlId` is ignored on `<FormControl>` when `id` is specified.') : void 0; // input[type="file"] should not have .form-control.

    var classes;

    if (type !== 'file') {
      classes = Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    } // If user provides a size, make sure to append it to classes as input-
    // e.g. if bsSize is small, it will append input-sm


    if (bsSize) {
      var size = __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["b" /* SIZE_MAP */][bsSize] || bsSize;
      classes[Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["e" /* prefix */])({
        bsClass: 'input'
      }, size)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      type: type,
      id: id,
      ref: inputRef,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControl;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControl.propTypes = propTypes;
FormControl.defaultProps = defaultProps;
FormControl.contextTypes = contextTypes;
FormControl.Feedback = __WEBPACK_IMPORTED_MODULE_8__FormControlFeedback__["a" /* default */];
FormControl.Static = __WEBPACK_IMPORTED_MODULE_9__FormControlStatic__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["a" /* bsClass */])('form-control', Object(__WEBPACK_IMPORTED_MODULE_10__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].SMALL, __WEBPACK_IMPORTED_MODULE_11__utils_StyleConfig__["c" /* Size */].LARGE], FormControl)));

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Glyphicon__ = __webpack_require__(284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var defaultProps = {
  bsRole: 'feedback'
};
var contextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object
};

var FormControlFeedback =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlFeedback, _React$Component);

  function FormControlFeedback() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlFeedback.prototype;

  _proto.getGlyph = function getGlyph(validationState) {
    switch (validationState) {
      case 'success':
        return 'ok';

      case 'warning':
        return 'warning-sign';

      case 'error':
        return 'remove';

      default:
        return null;
    }
  };

  _proto.renderDefaultFeedback = function renderDefaultFeedback(formGroup, className, classes, elementProps) {
    var glyph = this.getGlyph(formGroup && formGroup.validationState);

    if (!glyph) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Glyphicon__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      glyph: glyph,
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (!children) {
      return this.renderDefaultFeedback(this.context.$bs_formGroup, className, classes, elementProps);
    }

    var child = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.only(children);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(child.props.className, className, classes)
    }));
  };

  return FormControlFeedback;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlFeedback.defaultProps = defaultProps;
FormControlFeedback.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('form-control-feedback', FormControlFeedback));

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'p'
};

var FormControlStatic =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormControlStatic, _React$Component);

  function FormControlStatic() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormControlStatic.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return FormControlStatic;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormControlStatic.propTypes = propTypes;
FormControlStatic.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-control-static', FormControlStatic));

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(43);









var propTypes = {
  /**
   * Sets `id` on `<FormControl>` and `htmlFor` on `<FormGroup.Label>`.
   */
  controlId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null])
};
var childContextTypes = {
  $bs_formGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.object.isRequired
};

var FormGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(FormGroup, _React$Component);

  function FormGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FormGroup.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        controlId = _this$props.controlId,
        validationState = _this$props.validationState;
    return {
      $bs_formGroup: {
        controlId: controlId,
        validationState: validationState
      }
    };
  };

  _proto.hasFeedback = function hasFeedback(children) {
    var _this = this;

    return __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
      return child.props.bsRole === 'feedback' || child.props.children && _this.hasFeedback(child.props.children);
    });
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        validationState = _this$props2.validationState,
        className = _this$props2.className,
        children = _this$props2.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["validationState", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['controlId']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      'has-feedback': this.hasFeedback(children)
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return FormGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

FormGroup.propTypes = propTypes;
FormGroup.childContextTypes = childContextTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('form-group', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["c" /* Size */].SMALL], FormGroup)));

/***/ }),
/* 1331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var HelpBlock =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(HelpBlock, _React$Component);

  function HelpBlock() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = HelpBlock.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return HelpBlock;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('help-block', HelpBlock));

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  /**
   * Sets image as responsive image
   */
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as rounded
   */
  rounded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as circle
   */
  circle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * Sets image shape as thumbnail
   */
  thumbnail: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  responsive: false,
  rounded: false,
  circle: false,
  thumbnail: false
};

var Image =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Image, _React$Component);

  function Image() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Image.prototype;

  _proto.render = function render() {
    var _classes;

    var _this$props = this.props,
        responsive = _this$props.responsive,
        rounded = _this$props.rounded,
        circle = _this$props.circle,
        thumbnail = _this$props.thumbnail,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["responsive", "rounded", "circle", "thumbnail", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = (_classes = {}, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')] = responsive, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'rounded')] = rounded, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'circle')] = circle, _classes[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'thumbnail')] = thumbnail, _classes);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Image;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Image.propTypes = propTypes;
Image.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('img', Image));

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(37);










var InputGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroup, _React$Component);

  function InputGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

InputGroup.Addon = __WEBPACK_IMPORTED_MODULE_5__InputGroupAddon__["a" /* default */];
InputGroup.Button = __WEBPACK_IMPORTED_MODULE_6__InputGroupButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('input-group', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["c" /* Size */].SMALL], InputGroup)));

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var InputGroupAddon =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupAddon, _React$Component);

  function InputGroupAddon() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupAddon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupAddon;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-addon', InputGroupAddon));

/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var InputGroupButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(InputGroupButton, _React$Component);

  function InputGroupButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = InputGroupButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return InputGroupButton;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('input-group-btn', InputGroupButton));

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Jumbotron =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Jumbotron, _React$Component);

  function Jumbotron() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Jumbotron.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }));
  };

  return Jumbotron;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Jumbotron.propTypes = propTypes;
Jumbotron.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('jumbotron', Jumbotron));

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__ = __webpack_require__(37);









var Label =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Label, _React$Component);

  function Label() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Label.prototype;

  _proto.hasContent = function hasContent(children) {
    var result = false;
    __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
      if (result) {
        return;
      }

      if (child || child === 0) {
        result = true;
      }
    });
    return result;
  };

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      // Hack for collapsing on IE8.
      hidden: !this.hasContent(children)
    });

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), children);
  };

  return Label;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('label', Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_7__utils_StyleConfig__["e" /* Style */].DEFAULT, Label)));

/***/ }),
/* 1338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(43);









var propTypes = {
  /**
   * You can use a custom element type for this component.
   *
   * If not specified, it will be treated as `'li'` if every child is a
   * non-actionable `<ListGroupItem>`, and `'div'` otherwise.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};

function getDefaultComponent(children) {
  if (!children) {
    // FIXME: This is the old behavior. Is this right?
    return 'div';
  }

  if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(children, function (child) {
    return child.type !== __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */] || child.props.href || child.props.onClick;
  })) {
    return 'div';
  }

  return 'ul';
}

var ListGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ListGroup, _React$Component);

  function ListGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ListGroup.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        _this$props$component = _this$props.componentClass,
        Component = _this$props$component === void 0 ? getDefaultComponent(children) : _this$props$component,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    var useListItem = Component === 'ul' && __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].every(children, function (child) {
      return child.type === __WEBPACK_IMPORTED_MODULE_6__ListGroupItem__["a" /* default */];
    });
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), useListItem ? __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        listItem: true
      });
    }) : children);
  };

  return ListGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ListGroup.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('list-group', ListGroup));

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Media__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__ = __webpack_require__(11);









var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom']),
  componentClass: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var MediaBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaBody, _React$Component);

  function MediaBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_7__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaBody;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaBody.propTypes = propTypes;
MediaBody.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_8__utils_bootstrapUtils__["a" /* bsClass */])('media-body', MediaBody));

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'h4'
};

var MediaHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaHeading, _React$Component);

  function MediaHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaHeading.propTypes = propTypes;
MediaHeading.defaultProps = defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('media-heading', MediaHeading));

/***/ }),
/* 1341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaLeft =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaLeft, _React$Component);

  function MediaLeft() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaLeft.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-left-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaLeft;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaLeft.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-left', MediaLeft));

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var MediaList =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaList, _React$Component);

  function MediaList() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaList.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaList;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media-list', MediaList));

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var MediaListItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaListItem, _React$Component);

  function MediaListItem() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaListItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaListItem;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('media', MediaListItem));

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Media__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * Align the media to the top, middle, or bottom of the media object.
   */
  align: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'middle', 'bottom'])
};

var MediaRight =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MediaRight, _React$Component);

  function MediaRight() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = MediaRight.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        align = _this$props.align,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["align", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);

    if (align) {
      // The class is e.g. `media-top`, not `media-right-top`.
      classes[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(__WEBPACK_IMPORTED_MODULE_6__Media__["a" /* default */].defaultProps, align)] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return MediaRight;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

MediaRight.propTypes = propTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('media-right', MediaRight));

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__ = __webpack_require__(34);











var propTypes = {
  /**
   * Highlight the menu item as active.
   */
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Disable the menu item, making it unselectable.
   */
  disabled: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Styles the menu item as a horizontal rule, providing visual separation between
   * groups of menu items.
   */
  divider: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_all___default()(__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool, function (_ref) {
    var divider = _ref.divider,
        children = _ref.children;
    return divider && children ? new Error('Children will not be rendered for dividers') : null;
  }),

  /**
   * Value passed to the `onSelect` handler, useful for identifying the selected menu item.
   */
  eventKey: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,

  /**
   * Styles the menu item as a header label, useful for describing a group of menu items.
   */
  header: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * HTML `href` attribute corresponding to `a.href`.
   */
  href: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,

  /**
   * Callback fired when the menu item is clicked.
   */
  onClick: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Callback fired when the menu item is selected.
   *
   * ```js
   * (eventKey: any, event: Object) => any
   * ```
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
};
var defaultProps = {
  divider: false,
  disabled: false,
  header: false
};

var MenuItem =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(MenuItem, _React$Component);

  function MenuItem(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleClick = _this.handleClick.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = MenuItem.prototype;

  _proto.handleClick = function handleClick(event) {
    var _this$props = this.props,
        href = _this$props.href,
        disabled = _this$props.disabled,
        onSelect = _this$props.onSelect,
        eventKey = _this$props.eventKey;

    if (!href || disabled) {
      event.preventDefault();
    }

    if (disabled) {
      return;
    }

    if (onSelect) {
      onSelect(eventKey, event);
    }
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        active = _this$props2.active,
        disabled = _this$props2.disabled,
        divider = _this$props2.divider,
        header = _this$props2.header,
        onClick = _this$props2.onClick,
        className = _this$props2.className,
        style = _this$props2.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["active", "disabled", "divider", "header", "onClick", "className", "style"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['eventKey', 'onSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    if (divider) {
      // Forcibly blank out the children; separators shouldn't render any.
      elementProps.children = undefined;
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "separator",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'divider'),
        style: style
      }));
    }

    if (header) {
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
        role: "heading",
        className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'header')),
        style: style
      }));
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
      role: "presentation",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, {
        active: active,
        disabled: disabled
      }),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__SafeAnchor__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "menuitem",
      tabIndex: "-1",
      onClick: Object(__WEBPACK_IMPORTED_MODULE_10__utils_createChainedFunction__["a" /* default */])(onClick, this.handleClick)
    })));
  };

  return MenuItem;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

MenuItem.propTypes = propTypes;
MenuItem.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('dropdown', MenuItem));

/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__ = __webpack_require__(1347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_events__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__ = __webpack_require__(1351);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__ = __webpack_require__(528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Fade__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__ModalBody__ = __webpack_require__(530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__ModalDialog__ = __webpack_require__(531);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__ModalFooter__ = __webpack_require__(532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__ModalHeader__ = __webpack_require__(533);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ModalTitle__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__ = __webpack_require__(37);


























var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes, __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */].propTypes, {
  /**
   * Include a backdrop component. Specify 'static' for a backdrop that doesn't
   * trigger an "onHide" when clicked.
   */
  backdrop: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.oneOf(['static', true, false]),

  /**
   * Add an optional extra class name to .modal-backdrop
   * It could end up looking like class="modal-backdrop foo-modal-backdrop in".
   */
  backdropClassName: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * Open and close the Modal with a slide and fade animation.
   */
  animation: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A Component type that provides the modal content Markup. This is a useful
   * prop when you want to use your own styles and markup to create a custom
   * modal component.
   */
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_14_prop_types_extra_lib_elementType___default.a,

  /**
   * When `true` The modal will automatically shift focus to itself when it
   * opens, and replace it to the last focused element when it closes.
   * Generally this should never be set to false as it makes the Modal less
   * accessible to assistive technologies, like screen-readers.
   */
  autoFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while
   * open. Consider leaving the default value here, as it is necessary to make
   * the Modal work well with assistive technologies, such as screen readers.
   */
  enforceFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * When `true` The modal will show itself.
   */
  show: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool,

  /**
   * A callback fired when the header closeButton or non-static backdrop is
   * clicked. Required if either are specified.
   */
  onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func,

  /**
   * @private
   */
  container: __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.propTypes.container
});

var defaultProps = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a.defaultProps, {
  animation: true,
  dialogComponentClass: __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */]
});

var childContextTypes = {
  $bs_modal: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.shape({
    onHide: __WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func
  })
};
/* eslint-disable no-use-before-define, react/no-multi-comp */

function DialogTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.TRANSITION_DURATION
  }));
}

function BackdropTransition(props) {
  return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Fade__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
    timeout: Modal.BACKDROP_TRANSITION_DURATION
  }));
}
/* eslint-enable no-use-before-define */


var Modal =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Modal, _React$Component);

  function Modal(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleEntering = _this.handleEntering.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleExited = _this.handleExited.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleWindowResize = _this.handleWindowResize.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDialogClick = _this.handleDialogClick.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.setModalRef = _this.setModalRef.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.state = {
      style: {}
    };
    return _this;
  }

  var _proto = Modal.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      $bs_modal: {
        onHide: this.props.onHide
      }
    };
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // Clean up the listener if we need to.
    this.handleExited();
  };

  _proto.setModalRef = function setModalRef(ref) {
    this._modal = ref;
  };

  _proto.handleDialogClick = function handleDialogClick(e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    this.props.onHide();
  };

  _proto.handleEntering = function handleEntering() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.on(window, 'resize', this.handleWindowResize);
    this.updateStyle();
  };

  _proto.handleExited = function handleExited() {
    // FIXME: This should work even when animation is disabled.
    __WEBPACK_IMPORTED_MODULE_5_dom_helpers_events___default.a.off(window, 'resize', this.handleWindowResize);
  };

  _proto.handleWindowResize = function handleWindowResize() {
    this.updateStyle();
  };

  _proto.updateStyle = function updateStyle() {
    if (!__WEBPACK_IMPORTED_MODULE_7_dom_helpers_util_inDOM___default.a) {
      return;
    }

    var dialogNode = this._modal.getDialogElement();

    var dialogHeight = dialogNode.scrollHeight;
    var document = __WEBPACK_IMPORTED_MODULE_6_dom_helpers_ownerDocument___default()(dialogNode);
    var bodyIsOverflowing = __WEBPACK_IMPORTED_MODULE_13_react_overlays_lib_utils_isOverflowing___default()(__WEBPACK_IMPORTED_MODULE_11_react_dom___default.a.findDOMNode(this.props.container || document.body));
    var modalIsOverflowing = dialogHeight > document.documentElement.clientHeight;
    this.setState({
      style: {
        paddingRight: bodyIsOverflowing && !modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined,
        paddingLeft: !bodyIsOverflowing && modalIsOverflowing ? __WEBPACK_IMPORTED_MODULE_8_dom_helpers_util_scrollbarSize___default()() : undefined
      }
    });
  };

  _proto.render = function render() {
    var _this$props = this.props,
        backdrop = _this$props.backdrop,
        backdropClassName = _this$props.backdropClassName,
        animation = _this$props.animation,
        show = _this$props.show,
        Dialog = _this$props.dialogComponentClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        onEntering = _this$props.onEntering,
        onExited = _this$props.onExited,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["backdrop", "backdropClassName", "animation", "show", "dialogComponentClass", "className", "style", "children", "onEntering", "onExited"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_23__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a),
        baseModalProps = _splitComponentProps[0],
        dialogProps = _splitComponentProps[1];

    var inClassName = show && !animation && 'in';
    return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_overlays_lib_Modal___default.a, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, baseModalProps, {
      ref: this.setModalRef,
      show: show,
      containerClassName: Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'open'),
      transition: animation ? DialogTransition : undefined,
      backdrop: backdrop,
      backdropTransition: animation ? BackdropTransition : undefined,
      backdropClassName: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["e" /* prefix */])(props, 'backdrop'), backdropClassName, inClassName),
      onEntering: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onEntering, this.handleEntering),
      onExited: Object(__WEBPACK_IMPORTED_MODULE_22__utils_createChainedFunction__["a" /* default */])(onExited, this.handleExited)
    }), __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(Dialog, Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dialogProps, {
      style: Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.state.style, style),
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, inClassName),
      onClick: backdrop === true ? this.handleDialogClick : null
    }), children));
  };

  return Modal;
}(__WEBPACK_IMPORTED_MODULE_9_react___default.a.Component);

Modal.propTypes = propTypes;
Modal.defaultProps = defaultProps;
Modal.childContextTypes = childContextTypes;
Modal.Body = __WEBPACK_IMPORTED_MODULE_16__ModalBody__["a" /* default */];
Modal.Header = __WEBPACK_IMPORTED_MODULE_19__ModalHeader__["a" /* default */];
Modal.Title = __WEBPACK_IMPORTED_MODULE_20__ModalTitle__["a" /* default */];
Modal.Footer = __WEBPACK_IMPORTED_MODULE_18__ModalFooter__["a" /* default */];
Modal.Dialog = __WEBPACK_IMPORTED_MODULE_17__ModalDialog__["a" /* default */];
Modal.TRANSITION_DURATION = 300;
Modal.BACKDROP_TRANSITION_DURATION = 150;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["a" /* bsClass */])('modal', Object(__WEBPACK_IMPORTED_MODULE_21__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_24__utils_StyleConfig__["c" /* Size */].SMALL], Modal)));

/***/ }),
/* 1347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _on = _interopRequireDefault(__webpack_require__(288));

exports.on = _on.default;

var _off = _interopRequireDefault(__webpack_require__(289));

exports.off = _off.default;

var _filter = _interopRequireDefault(__webpack_require__(1348));

exports.filter = _filter.default;

var _listen = _interopRequireDefault(__webpack_require__(1350));

exports.listen = _listen.default;
var _default = {
  on: _on.default,
  off: _off.default,
  filter: _filter.default,
  listen: _listen.default
};
exports.default = _default;

/***/ }),
/* 1348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = filterEvents;

var _contains = _interopRequireDefault(__webpack_require__(124));

var _querySelectorAll = _interopRequireDefault(__webpack_require__(1349));

function filterEvents(selector, handler) {
  return function filterHandler(e) {
    var top = e.currentTarget,
        target = e.target,
        matches = (0, _querySelectorAll.default)(top, selector);
    if (matches.some(function (match) {
      return (0, _contains.default)(match, target);
    })) handler.call(this, e);
  };
}

module.exports = exports["default"];

/***/ }),
/* 1349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = qsa;
// Zepto.js
// (c) 2010-2015 Thomas Fuchs
// Zepto.js may be freely distributed under the MIT license.
var simpleSelectorRE = /^[\w-]*$/;
var toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);

function qsa(element, selector) {
  var maybeID = selector[0] === '#',
      maybeClass = selector[0] === '.',
      nameOnly = maybeID || maybeClass ? selector.slice(1) : selector,
      isSimple = simpleSelectorRE.test(nameOnly),
      found;

  if (isSimple) {
    if (maybeID) {
      element = element.getElementById ? element : document;
      return (found = element.getElementById(nameOnly)) ? [found] : [];
    }

    if (element.getElementsByClassName && maybeClass) return toArray(element.getElementsByClassName(nameOnly));
    return toArray(element.getElementsByTagName(selector));
  }

  return toArray(element.querySelectorAll(selector));
}

module.exports = exports["default"];

/***/ }),
/* 1350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var _on = _interopRequireDefault(__webpack_require__(288));

var _off = _interopRequireDefault(__webpack_require__(289));

var listen = function listen() {};

if (_inDOM.default) {
  listen = function listen(node, eventName, handler, capture) {
    (0, _on.default)(node, eventName, handler, capture);
    return function () {
      (0, _off.default)(node, eventName, handler, capture);
    };
  };
}

var _default = listen;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _activeElement = __webpack_require__(517);

var _activeElement2 = _interopRequireDefault(_activeElement);

var _contains = __webpack_require__(124);

var _contains2 = _interopRequireDefault(_contains);

var _inDOM = __webpack_require__(76);

var _inDOM2 = _interopRequireDefault(_inDOM);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(205);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _deprecated = __webpack_require__(1352);

var _deprecated2 = _interopRequireDefault(_deprecated);

var _elementType = __webpack_require__(25);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _warning = __webpack_require__(45);

var _warning2 = _interopRequireDefault(_warning);

var _ModalManager = __webpack_require__(1353);

var _ModalManager2 = _interopRequireDefault(_ModalManager);

var _Portal = __webpack_require__(529);

var _Portal2 = _interopRequireDefault(_Portal);

var _RefHolder = __webpack_require__(1357);

var _RefHolder2 = _interopRequireDefault(_RefHolder);

var _addEventListener = __webpack_require__(520);

var _addEventListener2 = _interopRequireDefault(_addEventListener);

var _addFocusListener = __webpack_require__(1358);

var _addFocusListener2 = _interopRequireDefault(_addFocusListener);

var _getContainer = __webpack_require__(207);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable react/prop-types */

var modalManager = new _ModalManager2.default();

/**
 * Love them or hate them, `<Modal/>` provides a solid foundation for creating dialogs, lightboxes, or whatever else.
 * The Modal component renders its `children` node in front of a backdrop component.
 *
 * The Modal offers a few helpful features over using just a `<Portal/>` component and some styles:
 *
 * - Manages dialog stacking when one-at-a-time just isn't enough.
 * - Creates a backdrop, for disabling interaction below the modal.
 * - It properly manages focus; moving to the modal content, and keeping it there until the modal is closed.
 * - It disables scrolling of the page content while open.
 * - Adds the appropriate ARIA roles are automatically.
 * - Easily pluggable animations via a `<Transition/>` component.
 *
 * Note that, in the same way the backdrop element prevents users from clicking or interacting
 * with the page content underneath the Modal, Screen readers also need to be signaled to not to
 * interact with page content while the Modal is open. To do this, we use a common technique of applying
 * the `aria-hidden='true'` attribute to the non-Modal elements in the Modal `container`. This means that for
 * a Modal to be truly modal, it should have a `container` that is _outside_ your app's
 * React hierarchy (such as the default: document.body).
 */

var Modal = function (_React$Component) {
  _inherits(Modal, _React$Component);

  function Modal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Modal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  }

  Modal.prototype.omitProps = function omitProps(props, propTypes) {

    var keys = Object.keys(props);
    var newProps = {};
    keys.map(function (prop) {
      if (!Object.prototype.hasOwnProperty.call(propTypes, prop)) {
        newProps[prop] = props[prop];
      }
    });

    return newProps;
  };

  Modal.prototype.render = function render() {
    var _props = this.props,
        show = _props.show,
        container = _props.container,
        children = _props.children,
        Transition = _props.transition,
        backdrop = _props.backdrop,
        className = _props.className,
        style = _props.style,
        onExit = _props.onExit,
        onExiting = _props.onExiting,
        onEnter = _props.onEnter,
        onEntering = _props.onEntering,
        onEntered = _props.onEntered;


    var dialog = _react2.default.Children.only(children);
    var filteredProps = this.omitProps(this.props, Modal.propTypes);

    var mountModal = show || Transition && !this.state.exited;
    if (!mountModal) {
      return null;
    }

    var _dialog$props = dialog.props,
        role = _dialog$props.role,
        tabIndex = _dialog$props.tabIndex;


    if (role === undefined || tabIndex === undefined) {
      dialog = (0, _react.cloneElement)(dialog, {
        role: role === undefined ? 'document' : role,
        tabIndex: tabIndex == null ? '-1' : tabIndex
      });
    }

    if (Transition) {
      dialog = _react2.default.createElement(
        Transition,
        {
          appear: true,
          unmountOnExit: true,
          'in': show,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.handleHidden,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        dialog
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      {
        ref: this.setMountNode,
        container: container,
        onRendered: this.onPortalRendered
      },
      _react2.default.createElement(
        'div',
        _extends({
          ref: this.setModalNodeRef,
          role: role || 'dialog'
        }, filteredProps, {
          style: style,
          className: className
        }),
        backdrop && this.renderBackdrop(),
        _react2.default.createElement(
          _RefHolder2.default,
          { ref: this.setDialogRef },
          dialog
        )
      )
    );
  };

  Modal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Modal.prototype.componentWillUpdate = function componentWillUpdate(nextProps) {
    if (!this.props.show && nextProps.show) {
      this.checkForFocus();
    }
  };

  Modal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    if (this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var transition = this.props.transition;


    if (prevProps.show && !this.props.show && !transition) {
      // Otherwise handleHidden will call this.
      this.onHide();
    } else if (!prevProps.show && this.props.show) {
      this.onShow();
    }
  };

  Modal.prototype.componentWillUnmount = function componentWillUnmount() {
    var _props2 = this.props,
        show = _props2.show,
        transition = _props2.transition;


    this._isMounted = false;

    if (show || transition && !this.state.exited) {
      this.onHide();
    }
  };

  Modal.prototype.autoFocus = function autoFocus() {
    if (!this.props.autoFocus) {
      return;
    }

    var dialogElement = this.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(this));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      this.lastFocus = currentActiveElement;

      if (!dialogElement.hasAttribute('tabIndex')) {
        (0, _warning2.default)(false, 'The modal content node does not accept focus. For the benefit of ' + 'assistive technologies, the tabIndex of the node is being set ' + 'to "-1".');

        dialogElement.setAttribute('tabIndex', -1);
      }

      dialogElement.focus();
    }
  };

  Modal.prototype.restoreLastFocus = function restoreLastFocus() {
    // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
    if (this.lastFocus && this.lastFocus.focus) {
      this.lastFocus.focus();
      this.lastFocus = null;
    }
  };

  Modal.prototype.getDialogElement = function getDialogElement() {
    return _reactDom2.default.findDOMNode(this.dialog);
  };

  Modal.prototype.isTopModal = function isTopModal() {
    return this.props.manager.isTopModal(this);
  };

  return Modal;
}(_react2.default.Component);

Modal.propTypes = _extends({}, _Portal2.default.propTypes, {

  /**
   * Set the visibility of the Modal
   */
  show: _propTypes2.default.bool,

  /**
   * A Node, Component instance, or function that returns either. The Modal is appended to it's container element.
   *
   * For the sake of assistive technologies, the container should usually be the document body, so that the rest of the
   * page content can be placed behind a virtual backdrop as well as a visual one.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * A callback fired when the Modal is opening.
   */
  onShow: _propTypes2.default.func,

  /**
   * A callback fired when either the backdrop is clicked, or the escape key is pressed.
   *
   * The `onHide` callback only signals intent from the Modal,
   * you must actually set the `show` prop to `false` for the Modal to close.
   */
  onHide: _propTypes2.default.func,

  /**
   * Include a backdrop component.
   */
  backdrop: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.oneOf(['static'])]),

  /**
   * A function that returns a backdrop component. Useful for custom
   * backdrop rendering.
   *
   * ```js
   *  renderBackdrop={props => <MyBackdrop {...props} />}
   * ```
   */
  renderBackdrop: _propTypes2.default.func,

  /**
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   */
  onEscapeKeyDown: _propTypes2.default.func,

  /**
   * Support for this function will be deprecated. Please use `onEscapeKeyDown` instead
   * A callback fired when the escape key, if specified in `keyboard`, is pressed.
   * @deprecated
   */
  onEscapeKeyUp: (0, _deprecated2.default)(_propTypes2.default.func, 'Please use onEscapeKeyDown instead for consistency'),

  /**
   * A callback fired when the backdrop, if specified, is clicked.
   */
  onBackdropClick: _propTypes2.default.func,

  /**
   * A style object for the backdrop component.
   */
  backdropStyle: _propTypes2.default.object,

  /**
   * A css class or classes for the backdrop component.
   */
  backdropClassName: _propTypes2.default.string,

  /**
   * A css class or set of classes applied to the modal container when the modal is open,
   * and removed when it is closed.
   */
  containerClassName: _propTypes2.default.string,

  /**
   * Close the modal when escape key is pressed
   */
  keyboard: _propTypes2.default.bool,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the dialog component.
   */
  transition: _elementType2.default,

  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component used
   * to control animations for the backdrop components.
   */
  backdropTransition: _elementType2.default,

  /**
   * When `true` The modal will automatically shift focus to itself when it opens, and
   * replace it to the last focused element when it closes. This also
   * works correctly with any Modal children that have the `autoFocus` prop.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  autoFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will prevent focus from leaving the Modal while open.
   *
   * Generally this should never be set to `false` as it makes the Modal less
   * accessible to assistive technologies, like screen readers.
   */
  enforceFocus: _propTypes2.default.bool,

  /**
   * When `true` The modal will restore focus to previously focused element once
   * modal is hidden
   */
  restoreFocus: _propTypes2.default.bool,

  /**
   * Callback fired before the Modal transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Modal transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Modal begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Modal finishes transitioning out
   */
  onExited: _propTypes2.default.func,

  /**
   * A ModalManager instance used to track and manage the state of open
   * Modals. Useful when customizing how modals interact within a container
   */
  manager: _propTypes2.default.object.isRequired
});
Modal.defaultProps = {
  show: false,
  backdrop: true,
  keyboard: true,
  autoFocus: true,
  enforceFocus: true,
  restoreFocus: true,
  onHide: function onHide() {},
  manager: modalManager,
  renderBackdrop: function renderBackdrop(props) {
    return _react2.default.createElement('div', props);
  }
};

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.state = { exited: !this.props.show };

  this.renderBackdrop = function () {
    var _props3 = _this2.props,
        backdropStyle = _props3.backdropStyle,
        backdropClassName = _props3.backdropClassName,
        renderBackdrop = _props3.renderBackdrop,
        Transition = _props3.backdropTransition;


    var backdropRef = function backdropRef(ref) {
      return _this2.backdrop = ref;
    };

    var backdrop = renderBackdrop({
      ref: backdropRef,
      style: backdropStyle,
      className: backdropClassName,
      onClick: _this2.handleBackdropClick
    });

    if (Transition) {
      backdrop = _react2.default.createElement(
        Transition,
        {
          appear: true,
          'in': _this2.props.show
        },
        backdrop
      );
    }

    return backdrop;
  };

  this.onPortalRendered = function () {
    _this2.autoFocus();

    if (_this2.props.onShow) {
      _this2.props.onShow();
    }
  };

  this.onShow = function () {
    var doc = (0, _ownerDocument2.default)(_this2);
    var container = (0, _getContainer2.default)(_this2.props.container, doc.body);

    _this2.props.manager.add(_this2, container, _this2.props.containerClassName);

    _this2._onDocumentKeydownListener = (0, _addEventListener2.default)(doc, 'keydown', _this2.handleDocumentKeyDown);

    _this2._onDocumentKeyupListener = (0, _addEventListener2.default)(doc, 'keyup', _this2.handleDocumentKeyUp);

    _this2._onFocusinListener = (0, _addFocusListener2.default)(_this2.enforceFocus);
  };

  this.onHide = function () {
    _this2.props.manager.remove(_this2);

    _this2._onDocumentKeydownListener.remove();

    _this2._onDocumentKeyupListener.remove();

    _this2._onFocusinListener.remove();

    if (_this2.props.restoreFocus) {
      _this2.restoreLastFocus();
    }
  };

  this.setMountNode = function (ref) {
    _this2.mountNode = ref ? ref.getMountNode() : ref;
  };

  this.setModalNodeRef = function (ref) {
    _this2.modalNode = ref;
  };

  this.setDialogRef = function (ref) {
    _this2.dialog = ref;
  };

  this.handleHidden = function () {
    _this2.setState({ exited: true });
    _this2.onHide();

    if (_this2.props.onExited) {
      var _props4;

      (_props4 = _this2.props).onExited.apply(_props4, arguments);
    }
  };

  this.handleBackdropClick = function (e) {
    if (e.target !== e.currentTarget) {
      return;
    }

    if (_this2.props.onBackdropClick) {
      _this2.props.onBackdropClick(e);
    }

    if (_this2.props.backdrop === true) {
      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyDown = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyDown) {
        _this2.props.onEscapeKeyDown(e);
      }

      _this2.props.onHide();
    }
  };

  this.handleDocumentKeyUp = function (e) {
    if (_this2.props.keyboard && e.keyCode === 27 && _this2.isTopModal()) {
      if (_this2.props.onEscapeKeyUp) {
        _this2.props.onEscapeKeyUp(e);
      }
    }
  };

  this.checkForFocus = function () {
    if (_inDOM2.default) {
      _this2.lastFocus = (0, _activeElement2.default)();
    }
  };

  this.enforceFocus = function () {
    if (!_this2.props.enforceFocus || !_this2._isMounted || !_this2.isTopModal()) {
      return;
    }

    var dialogElement = _this2.getDialogElement();
    var currentActiveElement = (0, _activeElement2.default)((0, _ownerDocument2.default)(_this2));

    if (dialogElement && !(0, _contains2.default)(dialogElement, currentActiveElement)) {
      dialogElement.focus();
    }
  };
};

Modal.Manager = _ModalManager2.default;

exports.default = Modal;
module.exports = exports['default'];

/***/ }),
/* 1352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = deprecated;

var _warning = __webpack_require__(45);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var warned = {};

function deprecated(validator, reason) {
  return function validate(props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] != null) {
      var messageKey = componentName + '.' + propName;

      (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason + '.'));

      warned[messageKey] = true;
    }

    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      args[_key - 5] = arguments[_key];
    }

    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
  };
}

/* eslint-disable no-underscore-dangle */
function _resetWarned() {
  warned = {};
}

deprecated._resetWarned = _resetWarned;
/* eslint-enable no-underscore-dangle */

module.exports = exports['default'];

/***/ }),
/* 1353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _class = __webpack_require__(1354);

var _class2 = _interopRequireDefault(_class);

var _style = __webpack_require__(150);

var _style2 = _interopRequireDefault(_style);

var _scrollbarSize = __webpack_require__(524);

var _scrollbarSize2 = _interopRequireDefault(_scrollbarSize);

var _isOverflowing = __webpack_require__(528);

var _isOverflowing2 = _interopRequireDefault(_isOverflowing);

var _manageAriaHidden = __webpack_require__(1355);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function findIndexOf(arr, cb) {
  var idx = -1;
  arr.some(function (d, i) {
    if (cb(d, i)) {
      idx = i;
      return true;
    }
  });
  return idx;
}

function findContainer(data, modal) {
  return findIndexOf(data, function (d) {
    return d.modals.indexOf(modal) !== -1;
  });
}

function setContainerStyle(state, container) {
  var style = { overflow: 'hidden' };

  // we are only interested in the actual `style` here
  // becasue we will override it
  state.style = {
    overflow: container.style.overflow,
    paddingRight: container.style.paddingRight
  };

  if (state.overflowing) {
    // use computed style, here to get the real padding
    // to add our scrollbar width
    style.paddingRight = parseInt((0, _style2.default)(container, 'paddingRight') || 0, 10) + (0, _scrollbarSize2.default)() + 'px';
  }

  (0, _style2.default)(container, style);
}

function removeContainerStyle(_ref, container) {
  var style = _ref.style;


  Object.keys(style).forEach(function (key) {
    return container.style[key] = style[key];
  });
}
/**
 * Proper state managment for containers and the modals in those containers.
 *
 * @internal Used by the Modal to ensure proper styling of containers.
 */

var ModalManager = function ModalManager() {
  var _this = this;

  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref2$hideSiblingNode = _ref2.hideSiblingNodes,
      hideSiblingNodes = _ref2$hideSiblingNode === undefined ? true : _ref2$hideSiblingNode,
      _ref2$handleContainer = _ref2.handleContainerOverflow,
      handleContainerOverflow = _ref2$handleContainer === undefined ? true : _ref2$handleContainer;

  _classCallCheck(this, ModalManager);

  this.add = function (modal, container, className) {
    var modalIdx = _this.modals.indexOf(modal);
    var containerIdx = _this.containers.indexOf(container);

    if (modalIdx !== -1) {
      return modalIdx;
    }

    modalIdx = _this.modals.length;
    _this.modals.push(modal);

    if (_this.hideSiblingNodes) {
      (0, _manageAriaHidden.hideSiblings)(container, modal.mountNode);
    }

    if (containerIdx !== -1) {
      _this.data[containerIdx].modals.push(modal);
      return modalIdx;
    }

    var data = {
      modals: [modal],
      //right now only the first modal of a container will have its classes applied
      classes: className ? className.split(/\s+/) : [],

      overflowing: (0, _isOverflowing2.default)(container)
    };

    if (_this.handleContainerOverflow) {
      setContainerStyle(data, container);
    }

    data.classes.forEach(_class2.default.addClass.bind(null, container));

    _this.containers.push(container);
    _this.data.push(data);

    return modalIdx;
  };

  this.remove = function (modal) {
    var modalIdx = _this.modals.indexOf(modal);

    if (modalIdx === -1) {
      return;
    }

    var containerIdx = findContainer(_this.data, modal);
    var data = _this.data[containerIdx];
    var container = _this.containers[containerIdx];

    data.modals.splice(data.modals.indexOf(modal), 1);

    _this.modals.splice(modalIdx, 1);

    // if that was the last modal in a container,
    // clean up the container
    if (data.modals.length === 0) {
      data.classes.forEach(_class2.default.removeClass.bind(null, container));

      if (_this.handleContainerOverflow) {
        removeContainerStyle(data, container);
      }

      if (_this.hideSiblingNodes) {
        (0, _manageAriaHidden.showSiblings)(container, modal.mountNode);
      }
      _this.containers.splice(containerIdx, 1);
      _this.data.splice(containerIdx, 1);
    } else if (_this.hideSiblingNodes) {
      //otherwise make sure the next top modal is visible to a SR
      (0, _manageAriaHidden.ariaHidden)(false, data.modals[data.modals.length - 1].mountNode);
    }
  };

  this.isTopModal = function (modal) {
    return !!_this.modals.length && _this.modals[_this.modals.length - 1] === modal;
  };

  this.hideSiblingNodes = hideSiblingNodes;
  this.handleContainerOverflow = handleContainerOverflow;
  this.modals = [];
  this.containers = [];
  this.data = [];
};

exports.default = ModalManager;
module.exports = exports['default'];

/***/ }),
/* 1354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _addClass = _interopRequireDefault(__webpack_require__(525));

exports.addClass = _addClass.default;

var _removeClass = _interopRequireDefault(__webpack_require__(527));

exports.removeClass = _removeClass.default;

var _hasClass = _interopRequireDefault(__webpack_require__(526));

exports.hasClass = _hasClass.default;
var _default = {
  addClass: _addClass.default,
  removeClass: _removeClass.default,
  hasClass: _hasClass.default
};
exports.default = _default;

/***/ }),
/* 1355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.ariaHidden = ariaHidden;
exports.hideSiblings = hideSiblings;
exports.showSiblings = showSiblings;

var BLACKLIST = ['template', 'script', 'style'];

var isHidable = function isHidable(_ref) {
  var nodeType = _ref.nodeType,
      tagName = _ref.tagName;
  return nodeType === 1 && BLACKLIST.indexOf(tagName.toLowerCase()) === -1;
};

var siblings = function siblings(container, mount, cb) {
  mount = [].concat(mount);

  [].forEach.call(container.children, function (node) {
    if (mount.indexOf(node) === -1 && isHidable(node)) {
      cb(node);
    }
  });
};

function ariaHidden(show, node) {
  if (!node) {
    return;
  }
  if (show) {
    node.setAttribute('aria-hidden', 'true');
  } else {
    node.removeAttribute('aria-hidden');
  }
}

function hideSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(true, node);
  });
}

function showSiblings(container, mountNode) {
  siblings(container, mountNode, function (node) {
    return ariaHidden(false, node);
  });
}

/***/ }),
/* 1356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(205);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _getContainer = __webpack_require__(207);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The `<Portal/>` component renders its children into a new "subtree" outside of current component hierarchy.
 * You can think of it as a declarative `appendChild()`, or jQuery's `$.fn.appendTo()`.
 * The children of `<Portal/>` component will be appended to the `container` specified.
 */
var Portal = function (_React$Component) {
  _inherits(Portal, _React$Component);

  function Portal() {
    var _temp, _this, _ret;

    _classCallCheck(this, Portal);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._mountOverlayTarget = function () {
      if (!_this._overlayTarget) {
        _this._overlayTarget = document.createElement('div');
        _this._portalContainerNode = (0, _getContainer2.default)(_this.props.container, (0, _ownerDocument2.default)(_this).body);
        _this._portalContainerNode.appendChild(_this._overlayTarget);
      }
    }, _this._unmountOverlayTarget = function () {
      if (_this._overlayTarget) {
        _this._portalContainerNode.removeChild(_this._overlayTarget);
        _this._overlayTarget = null;
      }
      _this._portalContainerNode = null;
    }, _this._renderOverlay = function () {
      var overlay = !_this.props.children ? null : _react2.default.Children.only(_this.props.children);

      // Save reference for future access.
      if (overlay !== null) {
        _this._mountOverlayTarget();

        var initialRender = !_this._overlayInstance;

        _this._overlayInstance = _reactDom2.default.unstable_renderSubtreeIntoContainer(_this, overlay, _this._overlayTarget, function () {
          if (initialRender && _this.props.onRendered) {
            _this.props.onRendered();
          }
        });
      } else {
        // Unrender if the component is null for transitions to null
        _this._unrenderOverlay();
        _this._unmountOverlayTarget();
      }
    }, _this._unrenderOverlay = function () {
      if (_this._overlayTarget) {
        _reactDom2.default.unmountComponentAtNode(_this._overlayTarget);
        _this._overlayInstance = null;
      }
    }, _this.getMountNode = function () {
      return _this._overlayTarget;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Portal.prototype.componentDidMount = function componentDidMount() {
    this._isMounted = true;
    this._renderOverlay();
  };

  Portal.prototype.componentDidUpdate = function componentDidUpdate() {
    this._renderOverlay();
  };

  Portal.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this._overlayTarget && nextProps.container !== this.props.container) {
      this._portalContainerNode.removeChild(this._overlayTarget);
      this._portalContainerNode = (0, _getContainer2.default)(nextProps.container, (0, _ownerDocument2.default)(this).body);
      this._portalContainerNode.appendChild(this._overlayTarget);
    }
  };

  Portal.prototype.componentWillUnmount = function componentWillUnmount() {
    this._isMounted = false;
    this._unrenderOverlay();
    this._unmountOverlayTarget();
  };

  Portal.prototype.render = function render() {
    return null;
  };

  return Portal;
}(_react2.default.Component);

Portal.displayName = 'Portal';
Portal.propTypes = {
  /**
   * A Node, Component instance, or function that returns either. The `container` will have the Portal children
   * appended to it.
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  onRendered: _propTypes2.default.func
};
exports.default = Portal;
module.exports = exports['default'];

/***/ }),
/* 1357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  children: _propTypes2.default.node
};

/**
 * Internal helper component to allow attaching a non-conflicting ref to a
 * child element that may not accept refs.
 */

var RefHolder = function (_React$Component) {
  _inherits(RefHolder, _React$Component);

  function RefHolder() {
    _classCallCheck(this, RefHolder);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  RefHolder.prototype.render = function render() {
    return this.props.children;
  };

  return RefHolder;
}(_react2.default.Component);

RefHolder.propTypes = propTypes;

exports.default = RefHolder;
module.exports = exports['default'];

/***/ }),
/* 1358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = addFocusListener;
/**
 * Firefox doesn't have a focusin event so using capture is easiest way to get bubbling
 * IE8 can't do addEventListener, but does have onfocusin, so we use that in ie8
 *
 * We only allow one Listener at a time to avoid stack overflows
 */
function addFocusListener(handler) {
  var useFocusin = !document.addEventListener;
  var remove = void 0;

  if (useFocusin) {
    document.attachEvent('onfocusin', handler);
    remove = function remove() {
      return document.detachEvent('onfocusin', handler);
    };
  } else {
    document.addEventListener('focus', handler, true);
    remove = function remove() {
      return document.removeEventListener('focus', handler, true);
    };
  }

  return { remove: remove };
}
module.exports = exports['default'];

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__ = __webpack_require__(1360);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__ = __webpack_require__(1362);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__ = __webpack_require__(34);




// TODO: Remove this pragma once we upgrade eslint-config-airbnb.

/* eslint-disable react/no-multi-comp */













var propTypes = {
  /**
   * Create a fixed navbar along the top of the screen, that scrolls with the
   * page
   */
  fixedTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a fixed navbar along the bottom of the screen, that scrolls with
   * the page
   */
  fixedBottom: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Create a full-width navbar that scrolls away with the page
   */
  staticTop: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * An alternative dark visual style for the Navbar
   */
  inverse: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Allow the Navbar to fluidly adjust to the page or container width, instead
   * of at the predefined screen breakpoints
   */
  fluid: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Set a custom element for this component.
   */
  componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,

  /**
   * A callback fired when the `<Navbar>` body collapses or expands. Fired when
   * a `<Navbar.Toggle>` is clicked and called with the new `expanded`
   * boolean value.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * A callback fired when a descendant of a child `<Nav>` is selected. Should
   * be used to execute complex closing or other miscellaneous actions desired
   * after selecting a descendant of `<Nav>`. Does nothing if no `<Nav>` or `<Nav>`
   * descendants exist. The callback is called with an eventKey, which is a
   * prop from the selected `<Nav>` descendant, and an event.
   *
   * ```js
   * function (
   *  Any eventKey,
   *  SyntheticEvent event?
   * )
   * ```
   *
   * For basic closing behavior after all `<Nav>` descendant onSelect events in
   * mobile viewports, try using collapseOnSelect.
   *
   * Note: If you are manually closing the navbar using this `OnSelect` prop,
   * ensure that you are setting `expanded` to false and not *toggling* between
   * true and false.
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,

  /**
   * Sets `expanded` to `false` after the onSelect event of a descendant of a
   * child `<Nav>`. Does nothing if no `<Nav>` or `<Nav>` descendants exist.
   *
   * The onSelect callback should be used instead for more complex operations
   * that need to be executed after the `select` event of `<Nav>` descendants.
   */
  collapseOnSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,

  /**
   * Explicitly set the visiblity of the navbar body
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  role: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
};
var defaultProps = {
  componentClass: 'nav',
  fixedTop: false,
  fixedBottom: false,
  staticTop: false,
  inverse: false,
  fluid: false,
  collapseOnSelect: false
};
var childContextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,
    onSelect: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func
  })
};

var Navbar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Navbar, _React$Component);

  function Navbar(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleCollapse = _this.handleCollapse.bind(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    return _this;
  }

  var _proto = Navbar.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        bsClass = _this$props.bsClass,
        expanded = _this$props.expanded,
        onSelect = _this$props.onSelect,
        collapseOnSelect = _this$props.collapseOnSelect;
    return {
      $bs_navbar: {
        bsClass: bsClass,
        expanded: expanded,
        onToggle: this.handleToggle,
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_16__utils_createChainedFunction__["a" /* default */])(onSelect, collapseOnSelect ? this.handleCollapse : null)
      }
    };
  };

  _proto.handleCollapse = function handleCollapse() {
    var _this$props2 = this.props,
        onToggle = _this$props2.onToggle,
        expanded = _this$props2.expanded;

    if (expanded) {
      onToggle(false);
    }
  };

  _proto.handleToggle = function handleToggle() {
    var _this$props3 = this.props,
        onToggle = _this$props3.onToggle,
        expanded = _this$props3.expanded;
    onToggle(!expanded);
  };

  _proto.render = function render() {
    var _extends2;

    var _this$props4 = this.props,
        Component = _this$props4.componentClass,
        fixedTop = _this$props4.fixedTop,
        fixedBottom = _this$props4.fixedBottom,
        staticTop = _this$props4.staticTop,
        inverse = _this$props4.inverse,
        fluid = _this$props4.fluid,
        className = _this$props4.className,
        children = _this$props4.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props4, ["componentClass", "fixedTop", "fixedBottom", "staticTop", "inverse", "fluid", "className", "children"]);

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(props, ['expanded', 'onToggle', 'onSelect', 'collapseOnSelect']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1]; // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one


    if (elementProps.role === undefined && Component !== 'nav') {
      elementProps.role = 'navigation';
    }

    if (inverse) {
      bsProps.bsStyle = __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE;
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-top')] = fixedTop, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'fixed-bottom')] = fixedBottom, _extends2[Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'static-top')] = staticTop, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["a" /* default */], {
      fluid: fluid
    }, children));
  };

  return Navbar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

Navbar.propTypes = propTypes;
Navbar.defaultProps = defaultProps;
Navbar.childContextTypes = childContextTypes;
Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["a" /* bsClass */])('navbar', Navbar);
var UncontrollableNavbar = __WEBPACK_IMPORTED_MODULE_8_uncontrollable___default()(Navbar, {
  expanded: 'onToggle'
});

function createSimpleWrapper(tag, suffix, displayName) {
  var Wrapper = function Wrapper(_ref, _ref2) {
    var Component = _ref.componentClass,
        className = _ref.className,
        pullRight = _ref.pullRight,
        pullLeft = _ref.pullLeft,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["componentClass", "className", "pullRight", "pullLeft"]);

    var _ref2$$bs_navbar = _ref2.$bs_navbar,
        navbarProps = _ref2$$bs_navbar === void 0 ? {
      bsClass: 'navbar'
    } : _ref2$$bs_navbar;
    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, suffix), pullRight && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'right'), pullLeft && Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'left'))
    }));
  };

  Wrapper.displayName = displayName;
  Wrapper.propTypes = {
    componentClass: __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a,
    pullRight: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
    pullLeft: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
  };
  Wrapper.defaultProps = {
    componentClass: tag,
    pullRight: false,
    pullLeft: false
  };
  Wrapper.contextTypes = {
    $bs_navbar: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.shape({
      bsClass: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string
    })
  };
  return Wrapper;
}

UncontrollableNavbar.Brand = __WEBPACK_IMPORTED_MODULE_10__NavbarBrand__["a" /* default */];
UncontrollableNavbar.Header = __WEBPACK_IMPORTED_MODULE_12__NavbarHeader__["a" /* default */];
UncontrollableNavbar.Toggle = __WEBPACK_IMPORTED_MODULE_13__NavbarToggle__["a" /* default */];
UncontrollableNavbar.Collapse = __WEBPACK_IMPORTED_MODULE_11__NavbarCollapse__["a" /* default */];
UncontrollableNavbar.Form = createSimpleWrapper('div', 'form', 'NavbarForm');
UncontrollableNavbar.Text = createSimpleWrapper('p', 'text', 'NavbarText');
UncontrollableNavbar.Link = createSimpleWrapper('a', 'link', 'NavbarLink'); // Set bsStyles here so they can be overridden.

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_14__utils_bootstrapUtils__["c" /* bsStyles */])([__WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].INVERSE], __WEBPACK_IMPORTED_MODULE_15__utils_StyleConfig__["e" /* Style */].DEFAULT, UncontrollableNavbar));

/***/ }),
/* 1360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Collapse__ = __webpack_require__(285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  })
};

var NavbarCollapse =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarCollapse, _React$Component);

  function NavbarCollapse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarCollapse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'collapse');
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Collapse__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      in: navbarProps.expanded
    }, props), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
      className: bsClassName
    }, children));
  };

  return NavbarCollapse;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

NavbarCollapse.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarCollapse);

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
  })
};

var NavbarHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarHeader, _React$Component);

  function NavbarHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };
    var bsClassName = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'header');
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, bsClassName)
    }));
  };

  return NavbarHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarHeader.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarHeader);

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(34);








var propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * The toggle content, if left empty it will render the default toggle (seen above).
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var contextTypes = {
  $bs_navbar: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired
  })
};

var NavbarToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavbarToggle, _React$Component);

  function NavbarToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavbarToggle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onClick = _this$props.onClick,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onClick", "className", "children"]);

    var navbarProps = this.context.$bs_navbar || {
      bsClass: 'navbar'
    };

    var buttonProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      type: 'button'
    }, props, {
      onClick: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onClick, navbarProps.onToggle),
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(navbarProps, 'toggle'), !navbarProps.expanded && 'collapsed')
    });

    if (children) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, children);
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button", buttonProps, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "sr-only"
    }, "Toggle navigation"), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span", {
      className: "icon-bar"
    }));
  };

  return NavbarToggle;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavbarToggle.propTypes = propTypes;
NavbarToggle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (NavbarToggle);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(43);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node.isRequired,
  noCaret: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
  activeHref: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
});

var NavDropdown =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(NavDropdown, _React$Component);

  function NavDropdown() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = NavDropdown.prototype;

  _proto.isActive = function isActive(_ref, activeKey, activeHref) {
    var _this = this;

    var props = _ref.props;

    if (props.active || activeKey != null && props.eventKey === activeKey || activeHref && props.href === activeHref) {
      return true;
    }

    if (__WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].some(props.children, function (child) {
      return _this.isActive(child, activeKey, activeHref);
    })) {
      return true;
    }

    return props.active;
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        title = _this$props.title,
        activeKey = _this$props.activeKey,
        activeHref = _this$props.activeHref,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["title", "activeKey", "activeHref", "className", "style", "children"]);

    var active = this.isActive(this, activeKey, activeHref);
    delete props.active; // Accessed via this.isActive().

    delete props.eventKey; // Accessed via this.isActive().

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        toggleProps = _splitComponentProps[1]; // Unlike for the other dropdowns, styling needs to go to the `<Dropdown>`
    // rather than the `<Dropdown.Toggle>`.


    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      componentClass: "li",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
        active: active
      }),
      style: style
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Toggle, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, toggleProps, {
      useAnchor: true
    }), title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        active: _this2.isActive(child, activeKey, activeHref)
      });
    })));
  };

  return NavDropdown;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

NavDropdown.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (NavDropdown);

/***/ }),
/* 1364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _elementType = __webpack_require__(25);

var _elementType2 = _interopRequireDefault(_elementType);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Portal = __webpack_require__(529);

var _Portal2 = _interopRequireDefault(_Portal);

var _Position = __webpack_require__(1365);

var _Position2 = _interopRequireDefault(_Position);

var _RootCloseWrapper = __webpack_require__(519);

var _RootCloseWrapper2 = _interopRequireDefault(_RootCloseWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Built on top of `<Position/>` and `<Portal/>`, the overlay component is great for custom tooltip overlays.
 */
var Overlay = function (_React$Component) {
  _inherits(Overlay, _React$Component);

  function Overlay(props, context) {
    _classCallCheck(this, Overlay);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.handleHidden = function () {
      _this.setState({ exited: true });

      if (_this.props.onExited) {
        var _this$props;

        (_this$props = _this.props).onExited.apply(_this$props, arguments);
      }
    };

    _this.state = { exited: !props.show };
    _this.onHiddenListener = _this.handleHidden.bind(_this);
    return _this;
  }

  Overlay.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.show) {
      this.setState({ exited: false });
    } else if (!nextProps.transition) {
      // Otherwise let handleHidden take care of marking exited.
      this.setState({ exited: true });
    }
  };

  Overlay.prototype.render = function render() {
    var _props = this.props,
        container = _props.container,
        containerPadding = _props.containerPadding,
        target = _props.target,
        placement = _props.placement,
        shouldUpdatePosition = _props.shouldUpdatePosition,
        rootClose = _props.rootClose,
        children = _props.children,
        Transition = _props.transition,
        props = _objectWithoutProperties(_props, ['container', 'containerPadding', 'target', 'placement', 'shouldUpdatePosition', 'rootClose', 'children', 'transition']);

    // Don't un-render the overlay while it's transitioning out.


    var mountOverlay = props.show || Transition && !this.state.exited;
    if (!mountOverlay) {
      // Don't bother showing anything if we don't have to.
      return null;
    }

    var child = children;

    // Position is be inner-most because it adds inline styles into the child,
    // which the other wrappers don't forward correctly.
    child = _react2.default.createElement(
      _Position2.default,
      { container: container, containerPadding: containerPadding, target: target, placement: placement, shouldUpdatePosition: shouldUpdatePosition },
      child
    );

    if (Transition) {
      var onExit = props.onExit,
          onExiting = props.onExiting,
          onEnter = props.onEnter,
          onEntering = props.onEntering,
          onEntered = props.onEntered;

      // This animates the child node by injecting props, so it must precede
      // anything that adds a wrapping div.

      child = _react2.default.createElement(
        Transition,
        {
          'in': props.show,
          appear: true,
          onExit: onExit,
          onExiting: onExiting,
          onExited: this.onHiddenListener,
          onEnter: onEnter,
          onEntering: onEntering,
          onEntered: onEntered
        },
        child
      );
    }

    // This goes after everything else because it adds a wrapping div.
    if (rootClose) {
      child = _react2.default.createElement(
        _RootCloseWrapper2.default,
        { onRootClose: props.onHide },
        child
      );
    }

    return _react2.default.createElement(
      _Portal2.default,
      { container: container },
      child
    );
  };

  return Overlay;
}(_react2.default.Component);

Overlay.propTypes = _extends({}, _Portal2.default.propTypes, _Position2.default.propTypes, {

  /**
   * Set the visibility of the Overlay
   */
  show: _propTypes2.default.bool,

  /**
   * Specify whether the overlay should trigger `onHide` when the user clicks outside the overlay
   */
  rootClose: _propTypes2.default.bool,

  /**
   * A Callback fired by the Overlay when it wishes to be hidden.
   *
   * __required__ when `rootClose` is `true`.
   *
   * @type func
   */
  onHide: function onHide(props) {
    var propType = _propTypes2.default.func;
    if (props.rootClose) {
      propType = propType.isRequired;
    }

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return propType.apply(undefined, [props].concat(args));
  },


  /**
   * A `react-transition-group@2.0.0` `<Transition/>` component
   * used to animate the overlay as it changes visibility.
   */
  transition: _elementType2.default,

  /**
   * Callback fired before the Overlay transitions in
   */
  onEnter: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition in
   */
  onEntering: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning in
   */
  onEntered: _propTypes2.default.func,

  /**
   * Callback fired right before the Overlay transitions out
   */
  onExit: _propTypes2.default.func,

  /**
   * Callback fired as the Overlay begins to transition out
   */
  onExiting: _propTypes2.default.func,

  /**
   * Callback fired after the Overlay finishes transitioning out
   */
  onExited: _propTypes2.default.func
});

exports.default = Overlay;
module.exports = exports['default'];

/***/ }),
/* 1365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _classnames = __webpack_require__(10);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _componentOrElement = __webpack_require__(205);

var _componentOrElement2 = _interopRequireDefault(_componentOrElement);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(17);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _calculatePosition = __webpack_require__(1366);

var _calculatePosition2 = _interopRequireDefault(_calculatePosition);

var _getContainer = __webpack_require__(207);

var _getContainer2 = _interopRequireDefault(_getContainer);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The Position component calculates the coordinates for its child, to position
 * it relative to a `target` component or node. Useful for creating callouts
 * and tooltips, the Position component injects a `style` props with `left` and
 * `top` values for positioning your component.
 *
 * It also injects "arrow" `left`, and `top` values for styling callout arrows
 * for giving your components a sense of directionality.
 */
var Position = function (_React$Component) {
  _inherits(Position, _React$Component);

  function Position(props, context) {
    _classCallCheck(this, Position);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));

    _this.getTarget = function () {
      var target = _this.props.target;

      var targetElement = typeof target === 'function' ? target() : target;
      return targetElement && _reactDom2.default.findDOMNode(targetElement) || null;
    };

    _this.maybeUpdatePosition = function (placementChanged) {
      var target = _this.getTarget();

      if (!_this.props.shouldUpdatePosition && target === _this._lastTarget && !placementChanged) {
        return;
      }

      _this.updatePosition(target);
    };

    _this.state = {
      positionLeft: 0,
      positionTop: 0,
      arrowOffsetLeft: null,
      arrowOffsetTop: null
    };

    _this._needsFlush = false;
    _this._lastTarget = null;
    return _this;
  }

  Position.prototype.componentDidMount = function componentDidMount() {
    this.updatePosition(this.getTarget());
  };

  Position.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    this._needsFlush = true;
  };

  Position.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this._needsFlush) {
      this._needsFlush = false;
      this.maybeUpdatePosition(this.props.placement !== prevProps.placement);
    }
  };

  Position.prototype.render = function render() {
    var _props = this.props,
        children = _props.children,
        className = _props.className,
        props = _objectWithoutProperties(_props, ['children', 'className']);

    var _state = this.state,
        positionLeft = _state.positionLeft,
        positionTop = _state.positionTop,
        arrowPosition = _objectWithoutProperties(_state, ['positionLeft', 'positionTop']);

    // These should not be forwarded to the child.


    delete props.target;
    delete props.container;
    delete props.containerPadding;
    delete props.shouldUpdatePosition;

    var child = _react2.default.Children.only(children);
    return (0, _react.cloneElement)(child, _extends({}, props, arrowPosition, {
      // FIXME: Don't forward `positionLeft` and `positionTop` via both props
      // and `props.style`.
      positionLeft: positionLeft,
      positionTop: positionTop,
      className: (0, _classnames2.default)(className, child.props.className),
      style: _extends({}, child.props.style, {
        left: positionLeft,
        top: positionTop
      })
    }));
  };

  Position.prototype.updatePosition = function updatePosition(target) {
    this._lastTarget = target;

    if (!target) {
      this.setState({
        positionLeft: 0,
        positionTop: 0,
        arrowOffsetLeft: null,
        arrowOffsetTop: null
      });

      return;
    }

    var overlay = _reactDom2.default.findDOMNode(this);
    var container = (0, _getContainer2.default)(this.props.container, (0, _ownerDocument2.default)(this).body);

    this.setState((0, _calculatePosition2.default)(this.props.placement, overlay, target, container, this.props.containerPadding));
  };

  return Position;
}(_react2.default.Component);

Position.propTypes = {
  /**
   * A node, element, or function that returns either. The child will be
   * be positioned next to the `target` specified.
   */
  target: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),

  /**
   * "offsetParent" of the component
   */
  container: _propTypes2.default.oneOfType([_componentOrElement2.default, _propTypes2.default.func]),
  /**
   * Minimum spacing in pixels between container border and component border
   */
  containerPadding: _propTypes2.default.number,
  /**
   * How to position the component relative to the target
   */
  placement: _propTypes2.default.oneOf(['top', 'right', 'bottom', 'left']),
  /**
   * Whether the position should be changed on each update
   */
  shouldUpdatePosition: _propTypes2.default.bool
};

Position.displayName = 'Position';

Position.defaultProps = {
  containerPadding: 0,
  placement: 'right',
  shouldUpdatePosition: false
};

exports.default = Position;
module.exports = exports['default'];

/***/ }),
/* 1366 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = calculatePosition;

var _offset = __webpack_require__(539);

var _offset2 = _interopRequireDefault(_offset);

var _position = __webpack_require__(1367);

var _position2 = _interopRequireDefault(_position);

var _scrollTop = __webpack_require__(540);

var _scrollTop2 = _interopRequireDefault(_scrollTop);

var _ownerDocument = __webpack_require__(125);

var _ownerDocument2 = _interopRequireDefault(_ownerDocument);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getContainerDimensions(containerNode) {
  var width = void 0,
      height = void 0,
      scroll = void 0;

  if (containerNode.tagName === 'BODY') {
    width = window.innerWidth;
    height = window.innerHeight;

    scroll = (0, _scrollTop2.default)((0, _ownerDocument2.default)(containerNode).documentElement) || (0, _scrollTop2.default)(containerNode);
  } else {
    var _getOffset = (0, _offset2.default)(containerNode);

    width = _getOffset.width;
    height = _getOffset.height;

    scroll = (0, _scrollTop2.default)(containerNode);
  }

  return { width: width, height: height, scroll: scroll };
}

function getTopDelta(top, overlayHeight, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerScroll = containerDimensions.scroll;
  var containerHeight = containerDimensions.height;

  var topEdgeOffset = top - padding - containerScroll;
  var bottomEdgeOffset = top + padding - containerScroll + overlayHeight;

  if (topEdgeOffset < 0) {
    return -topEdgeOffset;
  } else if (bottomEdgeOffset > containerHeight) {
    return containerHeight - bottomEdgeOffset;
  } else {
    return 0;
  }
}

function getLeftDelta(left, overlayWidth, container, padding) {
  var containerDimensions = getContainerDimensions(container);
  var containerWidth = containerDimensions.width;

  var leftEdgeOffset = left - padding;
  var rightEdgeOffset = left + padding + overlayWidth;

  if (leftEdgeOffset < 0) {
    return -leftEdgeOffset;
  } else if (rightEdgeOffset > containerWidth) {
    return containerWidth - rightEdgeOffset;
  }

  return 0;
}

function calculatePosition(placement, overlayNode, target, container, padding) {
  var childOffset = container.tagName === 'BODY' ? (0, _offset2.default)(target) : (0, _position2.default)(target, container);

  var _getOffset2 = (0, _offset2.default)(overlayNode),
      overlayHeight = _getOffset2.height,
      overlayWidth = _getOffset2.width;

  var positionLeft = void 0,
      positionTop = void 0,
      arrowOffsetLeft = void 0,
      arrowOffsetTop = void 0;

  if (placement === 'left' || placement === 'right') {
    positionTop = childOffset.top + (childOffset.height - overlayHeight) / 2;

    if (placement === 'left') {
      positionLeft = childOffset.left - overlayWidth;
    } else {
      positionLeft = childOffset.left + childOffset.width;
    }

    var topDelta = getTopDelta(positionTop, overlayHeight, container, padding);

    positionTop += topDelta;
    arrowOffsetTop = 50 * (1 - 2 * topDelta / overlayHeight) + '%';
    arrowOffsetLeft = void 0;
  } else if (placement === 'top' || placement === 'bottom') {
    positionLeft = childOffset.left + (childOffset.width - overlayWidth) / 2;

    if (placement === 'top') {
      positionTop = childOffset.top - overlayHeight;
    } else {
      positionTop = childOffset.top + childOffset.height;
    }

    var leftDelta = getLeftDelta(positionLeft, overlayWidth, container, padding);

    positionLeft += leftDelta;
    arrowOffsetLeft = 50 * (1 - 2 * leftDelta / overlayWidth) + '%';
    arrowOffsetTop = void 0;
  } else {
    throw new Error('calcOverlayPosition(): No such placement of "' + placement + '" found.');
  }

  return { positionLeft: positionLeft, positionTop: positionTop, arrowOffsetLeft: arrowOffsetLeft, arrowOffsetTop: arrowOffsetTop };
}
module.exports = exports['default'];

/***/ }),
/* 1367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = position;

var _extends2 = _interopRequireDefault(__webpack_require__(1368));

var _offset = _interopRequireDefault(__webpack_require__(539));

var _offsetParent = _interopRequireDefault(__webpack_require__(1369));

var _scrollTop = _interopRequireDefault(__webpack_require__(540));

var _scrollLeft = _interopRequireDefault(__webpack_require__(1370));

var _style = _interopRequireDefault(__webpack_require__(150));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function position(node, offsetParent) {
  var parentOffset = {
    top: 0,
    left: 0
  },
      offset; // Fixed elements are offset from window (parentOffset = {top:0, left: 0},
  // because it is its only offset parent

  if ((0, _style.default)(node, 'position') === 'fixed') {
    offset = node.getBoundingClientRect();
  } else {
    offsetParent = offsetParent || (0, _offsetParent.default)(node);
    offset = (0, _offset.default)(node);
    if (nodeName(offsetParent) !== 'html') parentOffset = (0, _offset.default)(offsetParent);
    parentOffset.top += parseInt((0, _style.default)(offsetParent, 'borderTopWidth'), 10) - (0, _scrollTop.default)(offsetParent) || 0;
    parentOffset.left += parseInt((0, _style.default)(offsetParent, 'borderLeftWidth'), 10) - (0, _scrollLeft.default)(offsetParent) || 0;
  } // Subtract parent offsets and node margins


  return (0, _extends2.default)({}, offset, {
    top: offset.top - parentOffset.top - (parseInt((0, _style.default)(node, 'marginTop'), 10) || 0),
    left: offset.left - parentOffset.left - (parseInt((0, _style.default)(node, 'marginLeft'), 10) || 0)
  });
}

module.exports = exports["default"];

/***/ }),
/* 1368 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 1369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = offsetParent;

var _ownerDocument = _interopRequireDefault(__webpack_require__(123));

var _style = _interopRequireDefault(__webpack_require__(150));

function nodeName(node) {
  return node.nodeName && node.nodeName.toLowerCase();
}

function offsetParent(node) {
  var doc = (0, _ownerDocument.default)(node),
      offsetParent = node && node.offsetParent;

  while (offsetParent && nodeName(node) !== 'html' && (0, _style.default)(offsetParent, 'position') === 'static') {
    offsetParent = offsetParent.offsetParent;
  }

  return offsetParent || doc.documentElement;
}

module.exports = exports["default"];

/***/ }),
/* 1370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = scrollTop;

var _isWindow = _interopRequireDefault(__webpack_require__(206));

function scrollTop(node, val) {
  var win = (0, _isWindow.default)(node);
  if (val === undefined) return win ? 'pageXOffset' in win ? win.pageXOffset : win.document.documentElement.scrollLeft : node.scrollLeft;
  if (win) win.scrollTo(val, 'pageYOffset' in win ? win.pageYOffset : win.document.documentElement.scrollTop);else node.scrollLeft = val;
}

module.exports = exports["default"];

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__ = __webpack_require__(1372);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Overlay__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__ = __webpack_require__(34);












/**
 * Check if value one is inside or equal to the of value
 *
 * @param {string} one
 * @param {string|array} of
 * @returns {boolean}
 */

function isOneOf(one, of) {
  if (__WEBPACK_IMPORTED_MODULE_4__babel_runtime_corejs2_core_js_array_is_array___default()(of)) {
    return of.indexOf(one) >= 0;
  }

  return one === of;
}

var triggerType = __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf(['click', 'hover', 'focus']);

var propTypes = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */].propTypes, {
  /**
   * Specify which action or actions trigger Overlay visibility
   */
  trigger: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([triggerType, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.arrayOf(triggerType)]),

  /**
   * A millisecond delay amount to show and hide the Overlay once triggered
   */
  delay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before showing the Overlay once triggered.
   */
  delayShow: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,

  /**
   * A millisecond delay amount before hiding the Overlay once triggered.
   */
  delayHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.number,
  // FIXME: This should be `defaultShow`.

  /**
   * The initial visibility state of the Overlay. For more nuanced visibility
   * control, consider using the Overlay component directly.
   */
  defaultOverlayShown: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,

  /**
   * An element or text to overlay next to the target.
   */
  overlay: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node.isRequired,

  /**
   * @private
   */
  onBlur: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onClick: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onFocus: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOut: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,

  /**
   * @private
   */
  onMouseOver: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  // Overridden props from `<Overlay>`.

  /**
   * @private
   */
  target: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  onHide: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null]),

  /**
   * @private
   */
  show: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOf([null])
});

var defaultProps = {
  defaultOverlayShown: false,
  trigger: ['hover', 'focus']
};

var OverlayTrigger =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(OverlayTrigger, _React$Component);

  function OverlayTrigger(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this.handleToggle = _this.handleToggle.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedShow = _this.handleDelayedShow.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleDelayedHide = _this.handleDelayedHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
    _this.handleHide = _this.handleHide.bind(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));

    _this.handleMouseOver = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedShow, e, 'fromElement');
    };

    _this.handleMouseOut = function (e) {
      return _this.handleMouseOverOut(_this.handleDelayedHide, e, 'toElement');
    };

    _this._mountNode = null;
    _this.state = {
      show: props.defaultOverlayShown
    };
    return _this;
  }

  var _proto = OverlayTrigger.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._mountNode = document.createElement('div');
    this.renderOverlay();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this.renderOverlay();
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unmountComponentAtNode(this._mountNode);
    this._mountNode = null;
    clearTimeout(this._hoverShowDelay);
    clearTimeout(this._hoverHideDelay);
  };

  _proto.handleDelayedHide = function handleDelayedHide() {
    var _this2 = this;

    if (this._hoverShowDelay != null) {
      clearTimeout(this._hoverShowDelay);
      this._hoverShowDelay = null;
      return;
    }

    if (!this.state.show || this._hoverHideDelay != null) {
      return;
    }

    var delay = this.props.delayHide != null ? this.props.delayHide : this.props.delay;

    if (!delay) {
      this.hide();
      return;
    }

    this._hoverHideDelay = setTimeout(function () {
      _this2._hoverHideDelay = null;

      _this2.hide();
    }, delay);
  };

  _proto.handleDelayedShow = function handleDelayedShow() {
    var _this3 = this;

    if (this._hoverHideDelay != null) {
      clearTimeout(this._hoverHideDelay);
      this._hoverHideDelay = null;
      return;
    }

    if (this.state.show || this._hoverShowDelay != null) {
      return;
    }

    var delay = this.props.delayShow != null ? this.props.delayShow : this.props.delay;

    if (!delay) {
      this.show();
      return;
    }

    this._hoverShowDelay = setTimeout(function () {
      _this3._hoverShowDelay = null;

      _this3.show();
    }, delay);
  };

  _proto.handleHide = function handleHide() {
    this.hide();
  }; // Simple implementation of mouseEnter and mouseLeave.
  // React's built version is broken: https://github.com/facebook/react/issues/4251
  // for cases when the trigger is disabled and mouseOut/Over can cause flicker
  // moving from one child element to another.


  _proto.handleMouseOverOut = function handleMouseOverOut(handler, e, relatedNative) {
    var target = e.currentTarget;
    var related = e.relatedTarget || e.nativeEvent[relatedNative];

    if ((!related || related !== target) && !__WEBPACK_IMPORTED_MODULE_5_dom_helpers_query_contains___default()(target, related)) {
      handler(e);
    }
  };

  _proto.handleToggle = function handleToggle() {
    if (this.state.show) {
      this.hide();
    } else {
      this.show();
    }
  };

  _proto.hide = function hide() {
    this.setState({
      show: false
    });
  };

  _proto.makeOverlay = function makeOverlay(overlay, props) {
    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Overlay__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      show: this.state.show,
      onHide: this.handleHide,
      target: this
    }), overlay);
  };

  _proto.show = function show() {
    this.setState({
      show: true
    });
  };

  _proto.renderOverlay = function renderOverlay() {
    __WEBPACK_IMPORTED_MODULE_8_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, this._overlay, this._mountNode);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        trigger = _this$props.trigger,
        overlay = _this$props.overlay,
        children = _this$props.children,
        onBlur = _this$props.onBlur,
        onClick = _this$props.onClick,
        onFocus = _this$props.onFocus,
        onMouseOut = _this$props.onMouseOut,
        onMouseOver = _this$props.onMouseOver,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["trigger", "overlay", "children", "onBlur", "onClick", "onFocus", "onMouseOut", "onMouseOver"]);

    delete props.delay;
    delete props.delayShow;
    delete props.delayHide;
    delete props.defaultOverlayShown;
    var child = __WEBPACK_IMPORTED_MODULE_6_react___default.a.Children.only(children);
    var childProps = child.props;
    var triggerProps = {};

    if (this.state.show) {
      triggerProps['aria-describedby'] = overlay.props.id;
    } // FIXME: The logic here for passing through handlers on this component is
    // inconsistent. We shouldn't be passing any of these props through.


    triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onClick, onClick);

    if (isOneOf('click', trigger)) {
      triggerProps.onClick = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(triggerProps.onClick, this.handleToggle);
    }

    if (isOneOf('hover', trigger)) {
       false ? warning(!(trigger === 'hover'), '[react-bootstrap] Specifying only the `"hover"` trigger limits the ' + 'visibility of the overlay to just mouse users. Consider also ' + 'including the `"focus"` trigger so that touch and keyboard only ' + 'users can see the overlay as well.') : void 0;
      triggerProps.onMouseOver = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOver, onMouseOver, this.handleMouseOver);
      triggerProps.onMouseOut = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onMouseOut, onMouseOut, this.handleMouseOut);
    }

    if (isOneOf('focus', trigger)) {
      triggerProps.onFocus = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onFocus, onFocus, this.handleDelayedShow);
      triggerProps.onBlur = Object(__WEBPACK_IMPORTED_MODULE_11__utils_createChainedFunction__["a" /* default */])(childProps.onBlur, onBlur, this.handleDelayedHide);
    }

    this._overlay = this.makeOverlay(overlay, props);
    return Object(__WEBPACK_IMPORTED_MODULE_6_react__["cloneElement"])(child, triggerProps);
  };

  return OverlayTrigger;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

OverlayTrigger.propTypes = propTypes;
OverlayTrigger.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (OverlayTrigger);

/***/ }),
/* 1372 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1373);

/***/ }),
/* 1373 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1374);
module.exports = __webpack_require__(54).Array.isArray;


/***/ }),
/* 1374 */
/***/ (function(module, exports, __webpack_require__) {

// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
var $export = __webpack_require__(68);

$export($export.S, 'Array', { isArray: __webpack_require__(1375) });


/***/ }),
/* 1375 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(279);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);







var PageHeader =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PageHeader, _React$Component);

  function PageHeader() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PageHeader.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h1", null, children));
  };

  return PageHeader;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('page-header', PageHeader));

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PagerItem__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__ = __webpack_require__(1378);


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_1__utils_deprecationWarning__["a" /* default */].wrapper(__WEBPACK_IMPORTED_MODULE_0__PagerItem__["a" /* default */], '`<PageItem>`', '`<Pager.Item>`'));

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export _resetWarned */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_warning__);


var warned = {};

function deprecationWarning(oldname, newname, link) {
  var message;

  if (typeof oldname === 'object') {
    message = oldname.message;
  } else {
    message = oldname + " is deprecated. Use " + newname + " instead.";

    if (link) {
      message += "\nYou can read more about it at " + link;
    }
  }

  if (warned[message]) {
    return;
  }

   false ? warning(false, message) : void 0;
  warned[message] = true;
}

deprecationWarning.wrapper = function (Component) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return (
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(DeprecatedComponent, _Component);

      function DeprecatedComponent() {
        return _Component.apply(this, arguments) || this;
      }

      var _proto = DeprecatedComponent.prototype;

      _proto.componentWillMount = function componentWillMount() {
        deprecationWarning.apply(void 0, args);

        if (_Component.prototype.componentWillMount) {
          var _Component$prototype$;

          for (var _len2 = arguments.length, methodArgs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            methodArgs[_key2] = arguments[_key2];
          }

          (_Component$prototype$ = _Component.prototype.componentWillMount).call.apply(_Component$prototype$, [this].concat(methodArgs));
        }
      };

      return DeprecatedComponent;
    }(Component)
  );
};

/* harmony default export */ __webpack_exports__["a"] = (deprecationWarning);
function _resetWarned() {
  warned = {};
}

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PagerItem__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(43);










var propTypes = {
  onSelect: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Pager =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pager, _React$Component);

  function Pager() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pager.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        onSelect = _this$props.onSelect,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onSelect", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(child, {
        onSelect: Object(__WEBPACK_IMPORTED_MODULE_8__utils_createChainedFunction__["a" /* default */])(child.props.onSelect, onSelect)
      });
    }));
  };

  return Pager;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Pager.propTypes = propTypes;
Pager.Item = __WEBPACK_IMPORTED_MODULE_6__PagerItem__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('pager', Pager));

/***/ }),
/* 1380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PaginationItem__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);








var Pagination =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Pagination, _React$Component);

  function Pagination() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Pagination.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), children);
  };

  return Pagination;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('pagination', Pagination);
Pagination.First = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["b" /* First */];
Pagination.Prev = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["e" /* Prev */];
Pagination.Ellipsis = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["a" /* Ellipsis */];
Pagination.Item = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["f" /* default */];
Pagination.Next = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["d" /* Next */];
Pagination.Last = __WEBPACK_IMPORTED_MODULE_5__PaginationItem__["c" /* Last */];
/* unused harmony default export */ var _unused_webpack_default_export = (Pagination);

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = PaginationItem;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return First; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return Prev; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ellipsis; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Next; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Last; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(61);




/* eslint-disable react/no-multi-comp */




var propTypes = {
  eventKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,
  className: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,
  activeLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string.isRequired
};
var defaultProps = {
  active: false,
  disabled: false,
  activeLabel: '(current)'
};
function PaginationItem(_ref) {
  var active = _ref.active,
      disabled = _ref.disabled,
      className = _ref.className,
      style = _ref.style,
      activeLabel = _ref.activeLabel,
      children = _ref.children,
      props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["active", "disabled", "className", "style", "activeLabel", "children"]);

  var Component = active || disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
  return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", {
    style: style,
    className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
      active: active,
      disabled: disabled
    })
  }, __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
    disabled: disabled
  }, props), children, active && __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
    className: "sr-only"
  }, activeLabel)));
}
PaginationItem.propTypes = propTypes;
PaginationItem.defaultProps = defaultProps;

function createButton(name, defaultValue, label) {
  var _class, _temp;

  if (label === void 0) {
    label = name;
  }

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          children = _this$props.children,
          className = _this$props.className,
          props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["disabled", "children", "className"]);

      var Component = disabled ? 'span' : __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */];
      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        "aria-label": label,
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, {
          disabled: disabled
        })
      }, props), __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, null, children || defaultValue));
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component), _class.displayName = name, _class.propTypes = {
    disabled: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
  }, _temp;
}

var First = createButton('First', "\xAB");
var Prev = createButton('Prev', "\u2039");
var Ellipsis = createButton('Ellipsis', "\u2026", 'More');
var Next = createButton('Next', "\u203A");
var Last = createButton('Last', "\xBB");

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PanelBody__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelHeading__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PanelTitle__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PanelFooter__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__PanelToggle__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__ = __webpack_require__(542);

















var has = Object.prototype.hasOwnProperty;

var defaultGetId = function defaultGetId(id, type) {
  return id ? id + "--" + type : null;
};

var propTypes = {
  /**
   * Controls the collapsed/expanded state ofthe Panel. Requires
   * a `Panel.Collapse` or `<Panel.Body collapsible>` child component
   * in order to actually animate out or in.
   *
   * @controllable onToggle
   */
  expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * A callback fired when the collapse state changes.
   *
   * @controllable expanded
   */
  onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
  eventKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,

  /**
   * An HTML `id` attribute uniquely identifying the Panel component.
   */
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string
};
var contextTypes = {
  $bs_panelGroup: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    getId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    activeKey: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.any,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
  })
};
var childContextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bodyId: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,
    onToggle: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,
    expanded: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
  })
};

var Panel =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Panel, _React$Component);

  function Panel() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handleToggle = function (e) {
      var panelGroup = _this.context.$bs_panelGroup;
      var expanded = !_this.getExpanded();

      if (panelGroup && panelGroup.onToggle) {
        panelGroup.onToggle(_this.props.eventKey, expanded, e);
      } else {
        _this.props.onToggle(expanded, e);
      }
    };

    return _this;
  }

  var _proto = Panel.prototype;

  _proto.getChildContext = function getChildContext() {
    var _this$props = this.props,
        eventKey = _this$props.eventKey,
        id = _this$props.id;
    var idKey = eventKey == null ? id : eventKey;
    var ids;

    if (idKey !== null) {
      var panelGroup = this.context.$bs_panelGroup;
      var getId = panelGroup && panelGroup.getId || defaultGetId;
      ids = {
        headingId: getId(idKey, 'heading'),
        bodyId: getId(idKey, 'body')
      };
    }

    return {
      $bs_panel: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, ids, {
        bsClass: this.props.bsClass,
        expanded: this.getExpanded(),
        onToggle: this.handleToggle
      })
    };
  };

  _proto.getExpanded = function getExpanded() {
    var panelGroup = this.context.$bs_panelGroup;

    if (panelGroup && has.call(panelGroup, 'activeKey')) {
       false ? warning(this.props.expanded == null, 'Specifying `<Panel>` `expanded` in the context of an accordion ' + '`<PanelGroup>` is not supported. Set `activeKey` on the ' + '`<PanelGroup>` instead.') : void 0;
      return panelGroup.activeKey === this.props.eventKey;
    }

    return !!this.props.expanded;
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        className = _this$props2.className,
        children = _this$props2.children;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['onToggle', 'eventKey', 'expanded']),
        bsProps = _splitBsPropsAndOmit[0],
        props = _splitBsPropsAndOmit[1];

    return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps))
    }), children);
  };

  return Panel;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Panel.propTypes = propTypes;
Panel.contextTypes = contextTypes;
Panel.childContextTypes = childContextTypes;
var UncontrolledPanel = __WEBPACK_IMPORTED_MODULE_7_uncontrollable___default()(Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["a" /* bsClass */])('panel', Object(__WEBPACK_IMPORTED_MODULE_9__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["d" /* State */]).concat([__WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].PRIMARY]), __WEBPACK_IMPORTED_MODULE_10__utils_StyleConfig__["e" /* Style */].DEFAULT, Panel)), {
  expanded: 'onToggle'
});

__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_assign___default()(UncontrolledPanel, {
  Heading: __WEBPACK_IMPORTED_MODULE_12__PanelHeading__["a" /* default */],
  Title: __WEBPACK_IMPORTED_MODULE_13__PanelTitle__["a" /* default */],
  Body: __WEBPACK_IMPORTED_MODULE_11__PanelBody__["a" /* default */],
  Footer: __WEBPACK_IMPORTED_MODULE_14__PanelFooter__["a" /* default */],
  Toggle: __WEBPACK_IMPORTED_MODULE_15__PanelToggle__["a" /* default */],
  Collapse: __WEBPACK_IMPORTED_MODULE_16__PanelCollapse__["a" /* default */]
});

/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledPanel);

/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelCollapse__ = __webpack_require__(542);







var propTypes = {
  /**
   * A convenience prop that renders a Collapse component around the Body for
   * situations when the parent Panel only contains a single Panel.Body child.
   *
   * renders:
   * ```jsx
   * <Panel.Collapse>
   *  <Panel.Body />
   * </Panel.Collapse>
   * ```
   */
  collapsible: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool.isRequired
};
var defaultProps = {
  collapsible: false
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelBody =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelBody, _React$Component);

  function PanelBody() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelBody.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        collapsible = _this$props.collapsible;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsPropsAndOmit = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["g" /* splitBsPropsAndOmit */])(this.props, ['collapsible']),
        bsProps = _splitBsPropsAndOmit[0],
        elementProps = _splitBsPropsAndOmit[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    var body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'body'))
    }), children);

    if (collapsible) {
      body = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__PanelCollapse__["a" /* default */], null, body);
    }

    return body;
  };

  return PanelBody;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelBody.propTypes = propTypes;
PanelBody.defaultProps = defaultProps;
PanelBody.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelBody));

/***/ }),
/* 1384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    headingId: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
    bsClass: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
  })
};

var PanelHeading =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelHeading, _React$Component);

  function PanelHeading() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelHeading.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        headingId = _ref.headingId,
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (headingId) {
      elementProps.role = elementProps.role || 'tab';
      elementProps.id = headingId;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_5_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'heading'))
    }), children);
  };

  return PanelHeading;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

PanelHeading.propTypes = propTypes;
PanelHeading.defaultProps = defaultProps;
PanelHeading.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelHeading));

/***/ }),
/* 1385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = createChainableTypeChecker;
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */

// Mostly taken from ReactPropTypes.

function createChainableTypeChecker(validate) {
  function checkType(isRequired, props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (props[propName] == null) {
      if (isRequired) {
        return new Error('Required ' + location + ' `' + propFullNameSafe + '` was not specified ' + ('in `' + componentNameSafe + '`.'));
      }

      return null;
    }

    for (var _len = arguments.length, args = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++) {
      args[_key - 6] = arguments[_key];
    }

    return validate.apply(undefined, [props, propName, componentNameSafe, location, propFullNameSafe].concat(args));
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PanelToggle__ = __webpack_require__(543);









var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_6_react_prop_types_lib_elementType___default.a,

  /**
   * A convenience prop that renders the Panel.Title as a panel collapse toggle component
   * for the common use-case.
   */
  toggle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string
  })
};
var defaultProps = {
  componentClass: 'div'
};

var PanelTitle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelTitle, _React$Component);

  function PanelTitle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelTitle.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className,
        toggle = _this$props.toggle,
        Component = _this$props.componentClass,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["children", "className", "toggle", "componentClass"]);

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;

    if (toggle) {
      children = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__PanelToggle__["a" /* default */], null, children);
    }

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title'))
    }), children);
  };

  return PanelTitle;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

PanelTitle.propTypes = propTypes;
PanelTitle.defaultProps = defaultProps;
PanelTitle.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelTitle));

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);






var contextTypes = {
  $bs_panel: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({
    bsClass: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string
  })
};

var PanelFooter =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(PanelFooter, _React$Component);

  function PanelFooter() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = PanelFooter.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        className = _this$props.className;

    var _ref = this.context.$bs_panel || {},
        _bsClass = _ref.bsClass;

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(this.props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    bsProps.bsClass = _bsClass || bsProps.bsClass;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'footer'))
    }), children);
  };

  return PanelFooter;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

PanelFooter.contextTypes = contextTypes;
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('panel', PanelFooter));

/***/ }),
/* 1388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Popover is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Popover.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Popover arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Popover arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * Title content
   */
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.node
};
var defaultProps = {
  placement: 'right'
};

var Popover =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Popover, _React$Component);

  function Popover() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Popover.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        title = _this$props.title,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "title", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      display: 'block',
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "arrow",
      style: arrowStyle
    }), title && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("h3", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'title')
    }, title), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'content')
    }, children));
  };

  return Popover;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Popover.propTypes = propTypes;
Popover.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('popover', Popover));

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__ = __webpack_require__(43);










var ROUND_PRECISION = 1000;
/**
 * Validate that children, if any, are instances of `<ProgressBar>`.
 */

function onlyProgressBar(props, propName, componentName) {
  var children = props[propName];

  if (!children) {
    return null;
  }

  var error = null;
  __WEBPACK_IMPORTED_MODULE_5_react___default.a.Children.forEach(children, function (child) {
    if (error) {
      return;
    }
    /**
     * Compare types in a way that works with libraries that patch and proxy
     * components like react-hot-loader.
     *
     * see https://github.com/gaearon/react-hot-loader#checking-element-types
     */


    var element = __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(ProgressBar, null);
    if (child.type === element.type) return;
    var childIdentifier = __WEBPACK_IMPORTED_MODULE_5_react___default.a.isValidElement(child) ? child.type.displayName || child.type.name || child.type : child;
    error = new Error("Children of " + componentName + " can contain only ProgressBar " + ("components. Found " + childIdentifier + "."));
  });
  return error;
}

var propTypes = {
  min: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  now: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  max: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.number,
  label: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,
  srOnly: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  striped: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  active: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool,
  children: onlyProgressBar,

  /**
   * @private
   */
  isChild: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.bool
};
var defaultProps = {
  min: 0,
  max: 100,
  active: false,
  isChild: false,
  srOnly: false,
  striped: false
};

function getPercentage(now, min, max) {
  var percentage = (now - min) / (max - min) * 100;
  return Math.round(percentage * ROUND_PRECISION) / ROUND_PRECISION;
}

var ProgressBar =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ProgressBar, _React$Component);

  function ProgressBar() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ProgressBar.prototype;

  _proto.renderProgressBar = function renderProgressBar(_ref) {
    var _extends2;

    var min = _ref.min,
        now = _ref.now,
        max = _ref.max,
        label = _ref.label,
        srOnly = _ref.srOnly,
        striped = _ref.striped,
        active = _ref.active,
        className = _ref.className,
        style = _ref.style,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref, ["min", "now", "max", "label", "srOnly", "striped", "active", "className", "style"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {
      active: active
    }, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = active || striped, _extends2));

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "progressbar",
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, classes),
      style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
        width: getPercentage(now, min, max) + "%"
      }, style),
      "aria-valuenow": now,
      "aria-valuemin": min,
      "aria-valuemax": max
    }), srOnly ? __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("span", {
      className: "sr-only"
    }, label) : label);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        isChild = _this$props.isChild,
        props = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["isChild"]);

    if (isChild) {
      return this.renderProgressBar(props);
    }

    var min = props.min,
        now = props.now,
        max = props.max,
        label = props.label,
        srOnly = props.srOnly,
        striped = props.striped,
        active = props.active,
        bsClass = props.bsClass,
        bsStyle = props.bsStyle,
        className = props.className,
        children = props.children,
        wrapperProps = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["min", "now", "max", "label", "srOnly", "striped", "active", "bsClass", "bsStyle", "className", "children"]);

    return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, wrapperProps, {
      className: __WEBPACK_IMPORTED_MODULE_4_classnames___default()(className, 'progress')
    }), children ? __WEBPACK_IMPORTED_MODULE_9__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      return Object(__WEBPACK_IMPORTED_MODULE_5_react__["cloneElement"])(child, {
        isChild: true
      });
    }) : this.renderProgressBar({
      min: min,
      now: now,
      max: max,
      label: label,
      srOnly: srOnly,
      striped: striped,
      active: active,
      bsClass: bsClass,
      bsStyle: bsStyle
    }));
  };

  return ProgressBar;
}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.Component);

ProgressBar.propTypes = propTypes;
ProgressBar.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('progress-bar', Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["c" /* bsStyles */])(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_core_js_object_values___default()(__WEBPACK_IMPORTED_MODULE_8__utils_StyleConfig__["d" /* State */]), ProgressBar)));

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);




/* eslint-disable jsx-a11y/label-has-for */





var propTypes = {
  inline: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  disabled: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * Only valid if `inline` is not set.
   */
  validationState: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['success', 'warning', 'error', null]),

  /**
   * Attaches a ref to the `<input>` element. Only functions can be used here.
   *
   * ```js
   * <Radio inputRef={ref => { this.input = ref; }} />
   * ```
   */
  inputRef: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};
var defaultProps = {
  inline: false,
  disabled: false,
  title: ''
};

var Radio =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Radio, _React$Component);

  function Radio() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Radio.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        inline = _this$props.inline,
        disabled = _this$props.disabled,
        validationState = _this$props.validationState,
        inputRef = _this$props.inputRef,
        className = _this$props.className,
        style = _this$props.style,
        title = _this$props.title,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["inline", "disabled", "validationState", "inputRef", "className", "style", "title", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var input = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("input", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      ref: inputRef,
      type: "radio",
      disabled: disabled
    }));

    if (inline) {
      var _classes2;

      var _classes = (_classes2 = {}, _classes2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inline')] = true, _classes2.disabled = disabled, _classes2); // Use a warning here instead of in propTypes to get better-looking
      // generated documentation.


       false ? warning(!validationState, '`validationState` is ignored on `<Radio inline>`. To display ' + 'validation state on an inline radio, set `validationState` on a ' + 'parent `<FormGroup>` or other element instead.') : void 0;
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
        className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, _classes),
        style: style,
        title: title
      }, input, children);
    }

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), {
      disabled: disabled
    });

    if (validationState) {
      classes["has-" + validationState] = true;
    }

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: style
    }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("label", {
      title: title
    }, input, children));
  };

  return Radio;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Radio.propTypes = propTypes;
Radio.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('radio', Radio));

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);







 // TODO: This should probably take a single `aspectRatio` prop.

var propTypes = {
  /**
   * This component requires a single child element
   */
  children: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.element.isRequired,

  /**
   * 16by9 aspect ratio
   */
  a16by9: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,

  /**
   * 4by3 aspect ratio
   */
  a4by3: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  a16by9: false,
  a4by3: false
};

var ResponsiveEmbed =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ResponsiveEmbed, _React$Component);

  function ResponsiveEmbed() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ResponsiveEmbed.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        a16by9 = _this$props.a16by9,
        a4by3 = _this$props.a4by3,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["a16by9", "a4by3", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

     false ? warning(a16by9 || a4by3, 'Either `a16by9` or `a4by3` must be set.') : void 0;
     false ? warning(!(a16by9 && a4by3), 'Only one of `a16by9` or `a4by3` can be set.') : void 0;

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '16by9')] = a16by9, _extends2[Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, '4by3')] = a4by3, _extends2));

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(classes)
    }, Object(__WEBPACK_IMPORTED_MODULE_4_react__["cloneElement"])(children, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'item'))
    })));
  };

  return ResponsiveEmbed;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ResponsiveEmbed.propTypes = propTypes;
ResponsiveEmbed.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('embed-responsive', ResponsiveEmbed));

/***/ }),
/* 1392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  componentClass: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_elementType___default.a
};
var defaultProps = {
  componentClass: 'div'
};

var Row =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Row, _React$Component);

  function Row() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Row.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.componentClass,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["componentClass", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Row;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Row.propTypes = propTypes;
Row.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('row', Row));

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Button__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Dropdown__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SplitToggle__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__ = __webpack_require__(202);










var propTypes = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].propTypes, {
  // Toggle props.
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  bsSize: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  href: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  onClick: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * The content of the split button.
   */
  title: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node.isRequired,

  /**
   * Accessible label for the toggle; the value of `title` if not specified.
   */
  toggleLabel: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string,
  // Override generated docs from <Dropdown>.

  /**
   * @private
   */
  children: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.node
});

var SplitButton =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitButton, _React$Component);

  function SplitButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitButton.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        bsSize = _this$props.bsSize,
        bsStyle = _this$props.bsStyle,
        title = _this$props.title,
        toggleLabel = _this$props.toggleLabel,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["bsSize", "bsStyle", "title", "toggleLabel", "children"]);

    var _splitComponentProps = Object(__WEBPACK_IMPORTED_MODULE_8__utils_splitComponentProps__["a" /* default */])(props, __WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].ControlledComponent),
        dropdownProps = _splitComponentProps[0],
        buttonProps = _splitComponentProps[1];

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, dropdownProps, {
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Button__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, buttonProps, {
      disabled: props.disabled,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), title), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */], {
      "aria-label": toggleLabel || title,
      bsSize: bsSize,
      bsStyle: bsStyle
    }), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Dropdown__["a" /* default */].Menu, null, children));
  };

  return SplitButton;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

SplitButton.propTypes = propTypes;
SplitButton.Toggle = __WEBPACK_IMPORTED_MODULE_7__SplitToggle__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (SplitButton);

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__ = __webpack_require__(521);





var SplitToggle =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(SplitToggle, _React$Component);

  function SplitToggle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = SplitToggle.prototype;

  _proto.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props, {
      useAnchor: false,
      noCaret: false
    }));
  };

  return SplitToggle;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

SplitToggle.defaultProps = __WEBPACK_IMPORTED_MODULE_3__DropdownToggle__["a" /* default */].defaultProps;
/* harmony default export */ __webpack_exports__["a"] = (SplitToggle);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TabContainer__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TabContent__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TabPane__ = __webpack_require__(544);








var propTypes = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */].propTypes, {
  disabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  title: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node,

  /**
   * tabClassName is used as className for the associated NavItem
   */
  tabClassName: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string
});

var Tab =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tab, _React$Component);

  function Tab() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tab.prototype;

  _proto.render = function render() {
    var props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, this.props); // These props are for the parent `<Tabs>` rather than the `<TabPane>`.


    delete props.title;
    delete props.disabled;
    delete props.tabClassName;
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */], props);
  };

  return Tab;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Tab.propTypes = propTypes;
Tab.Container = __WEBPACK_IMPORTED_MODULE_4__TabContainer__["a" /* default */];
Tab.Content = __WEBPACK_IMPORTED_MODULE_5__TabContent__["a" /* default */];
Tab.Pane = __WEBPACK_IMPORTED_MODULE_6__TabPane__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (Tab);

/***/ }),
/* 1396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__ = __webpack_require__(11);







var propTypes = {
  striped: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  bordered: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  condensed: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  hover: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool,
  responsive: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.bool
};
var defaultProps = {
  bordered: false,
  condensed: false,
  hover: false,
  responsive: false,
  striped: false
};

var Table =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Table, _React$Component);

  function Table() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Table.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        striped = _this$props.striped,
        bordered = _this$props.bordered,
        condensed = _this$props.condensed,
        hover = _this$props.hover,
        responsive = _this$props.responsive,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["striped", "bordered", "condensed", "hover", "responsive", "className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'striped')] = striped, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'bordered')] = bordered, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'condensed')] = condensed, _extends2[Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'hover')] = hover, _extends2));

    var table = __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("table", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));

    if (responsive) {
      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
        className: Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'responsive')
      }, table);
    }

    return table;
  };

  return Table;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Table.propTypes = propTypes;
Table.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__utils_bootstrapUtils__["a" /* bsClass */])('table', Table));

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Nav__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__NavItem__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__TabContainer__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__TabContent__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__ = __webpack_require__(43);














var TabContainer = __WEBPACK_IMPORTED_MODULE_10__TabContainer__["a" /* default */].ControlledComponent;
var propTypes = {
  /**
   * Mark the Tab with a matching `eventKey` as active.
   *
   * @controllable onSelect
   */
  activeKey: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.any,

  /**
   * Navigation style
   */
  bsStyle: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOf(['tabs', 'pills']),

  /**
   * Sets a default animation strategy. Use `false` to disable, `true`
   * to enable the default `<Fade>` animation, or a react-transition-group
   * v2 `<Transition/>` component.
   */
  animation: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool, __WEBPACK_IMPORTED_MODULE_7_prop_types_extra_lib_elementType___default.a]),
  id: __WEBPACK_IMPORTED_MODULE_5_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number])),

  /**
   * Callback fired when a Tab is selected.
   *
   * ```js
   * function (
   *   Any eventKey,
   *   SyntheticEvent event?
   * )
   * ```
   *
   * @controllable activeKey
   */
  onSelect: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,

  /**
   * Wait until the first "enter" transition to mount tabs (add them to the DOM)
   */
  mountOnEnter: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool,

  /**
   * Unmount tabs (remove it from the DOM) when it is no longer visible
   */
  unmountOnExit: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.bool
};
var defaultProps = {
  bsStyle: 'tabs',
  animation: true,
  mountOnEnter: false,
  unmountOnExit: false
};

function getDefaultActiveKey(children) {
  var defaultActiveKey;
  __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].forEach(children, function (child) {
    if (defaultActiveKey == null) {
      defaultActiveKey = child.props.eventKey;
    }
  });
  return defaultActiveKey;
}

var Tabs =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tabs, _React$Component);

  function Tabs() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tabs.prototype;

  _proto.renderTab = function renderTab(child) {
    var _child$props = child.props,
        title = _child$props.title,
        eventKey = _child$props.eventKey,
        disabled = _child$props.disabled,
        tabClassName = _child$props.tabClassName;

    if (title == null) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__NavItem__["a" /* default */], {
      eventKey: eventKey,
      disabled: disabled,
      className: tabClassName
    }, title);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        id = _this$props.id,
        onSelect = _this$props.onSelect,
        animation = _this$props.animation,
        mountOnEnter = _this$props.mountOnEnter,
        unmountOnExit = _this$props.unmountOnExit,
        bsClass = _this$props.bsClass,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        _this$props$activeKey = _this$props.activeKey,
        activeKey = _this$props$activeKey === void 0 ? getDefaultActiveKey(children) : _this$props$activeKey,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["id", "onSelect", "animation", "mountOnEnter", "unmountOnExit", "bsClass", "className", "style", "children", "activeKey"]);

    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TabContainer, {
      id: id,
      activeKey: activeKey,
      onSelect: onSelect,
      className: className,
      style: style
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Nav__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      role: "tablist"
    }), __WEBPACK_IMPORTED_MODULE_13__utils_ValidComponentChildren__["a" /* default */].map(children, this.renderTab)), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__TabContent__["a" /* default */], {
      bsClass: bsClass,
      animation: animation,
      mountOnEnter: mountOnEnter,
      unmountOnExit: unmountOnExit
    }, children)));
  };

  return Tabs;
}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component);

Tabs.propTypes = propTypes;
Tabs.defaultProps = defaultProps;
Object(__WEBPACK_IMPORTED_MODULE_12__utils_bootstrapUtils__["a" /* bsClass */])('tab', Tabs);
/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(Tabs, {
  activeKey: 'onSelect'
}));

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);




/* eslint-disable jsx-a11y/alt-text */





var propTypes = {
  /**
   * src property that is passed down to the image inside this component
   */
  src: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * alt property that is passed down to the image inside this component
   */
  alt: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * href property that is passed down to the image inside this component
   */
  href: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string,

  /**
   * onError callback that is passed down to the image inside this component
   */
  onError: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func,

  /**
   * onLoad callback that is passed down to the image inside this component
   */
  onLoad: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func
};

var Thumbnail =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Thumbnail, _React$Component);

  function Thumbnail() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Thumbnail.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        src = _this$props.src,
        alt = _this$props.alt,
        onError = _this$props.onError,
        onLoad = _this$props.onLoad,
        className = _this$props.className,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["src", "alt", "onError", "onLoad", "className", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var Component = elementProps.href ? __WEBPACK_IMPORTED_MODULE_6__SafeAnchor__["a" /* default */] : 'div';
    var classes = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("img", {
      src: src,
      alt: alt,
      onError: onError,
      onLoad: onLoad
    }), children && __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: "caption"
    }, children));
  };

  return Thumbnail;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Thumbnail.propTypes = propTypes;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('thumbnail', Thumbnail));

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uncontrollable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ButtonGroup__ = __webpack_require__(283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ToggleButton__ = __webpack_require__(545);











var propTypes = {
  /**
   * An HTML `<input>` name for each child button.
   *
   * __Required if `type` is set to `'radio'`__
   */
  name: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * The value, or array of values, of the active (pressed) buttons
   *
   * @controllable onChange
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /**
   * Callback fired when a button is pressed, depending on whether the `type`
   * is `'radio'` or `'checkbox'`, `onChange` will be called with the value or
   * array of active values
   *
   * @controllable values
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * The input `type` of the rendered buttons, determines the toggle behavior
   * of the buttons
   */
  type: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOf(['checkbox', 'radio']).isRequired
};
var defaultProps = {
  type: 'radio'
};

var ToggleButtonGroup =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(ToggleButtonGroup, _React$Component);

  function ToggleButtonGroup() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ToggleButtonGroup.prototype;

  _proto.getValues = function getValues() {
    var value = this.props.value;
    return value == null ? [] : [].concat(value);
  };

  _proto.handleToggle = function handleToggle(value) {
    var _this$props = this.props,
        type = _this$props.type,
        onChange = _this$props.onChange;
    var values = this.getValues();
    var isActive = values.indexOf(value) !== -1;

    if (type === 'radio') {
      if (!isActive) {
        onChange(value);
      }

      return;
    }

    if (isActive) {
      onChange(values.filter(function (n) {
        return n !== value;
      }));
    } else {
      onChange(values.concat([value]));
    }
  };

  _proto.render = function render() {
    var _this = this;

    var _this$props2 = this.props,
        children = _this$props2.children,
        type = _this$props2.type,
        name = _this$props2.name,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props2, ["children", "type", "name"]);

    var values = this.getValues();
    !(type !== 'radio' || !!name) ?  false ? invariant(false, 'A `name` is required to group the toggle buttons when the `type` ' + 'is set to "radio"') : __WEBPACK_IMPORTED_MODULE_5_invariant___default()(false) : void 0;
    delete props.onChange;
    delete props.value; // the data attribute is required b/c twbs css uses it in the selector

    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__ButtonGroup__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, props, {
      "data-toggle": "buttons"
    }), __WEBPACK_IMPORTED_MODULE_8__utils_ValidComponentChildren__["a" /* default */].map(children, function (child) {
      var _child$props = child.props,
          value = _child$props.value,
          onChange = _child$props.onChange;

      var handler = function handler() {
        return _this.handleToggle(value);
      };

      return __WEBPACK_IMPORTED_MODULE_4_react___default.a.cloneElement(child, {
        type: type,
        name: child.name || name,
        checked: values.indexOf(value) !== -1,
        onChange: Object(__WEBPACK_IMPORTED_MODULE_7__utils_createChainedFunction__["a" /* default */])(onChange, handler)
      });
    }));
  };

  return ToggleButtonGroup;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

ToggleButtonGroup.propTypes = propTypes;
ToggleButtonGroup.defaultProps = defaultProps;
var UncontrolledToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_6_uncontrollable___default()(ToggleButtonGroup, {
  value: 'onChange'
});
UncontrolledToggleButtonGroup.Button = __WEBPACK_IMPORTED_MODULE_10__ToggleButton__["a" /* default */];
/* unused harmony default export */ var _unused_webpack_default_export = (UncontrolledToggleButtonGroup);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__ = __webpack_require__(11);








var propTypes = {
  /**
   * An html id attribute, necessary for accessibility
   * @type {string|number}
   * @required
   */
  id: __WEBPACK_IMPORTED_MODULE_6_prop_types_extra_lib_isRequiredForA11y___default()(__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number])),

  /**
   * Sets the direction the Tooltip is positioned towards.
   */
  placement: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOf(['top', 'right', 'bottom', 'left']),

  /**
   * The "top" position value for the Tooltip.
   */
  positionTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip.
   */
  positionLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "top" position value for the Tooltip arrow.
   */
  arrowOffsetTop: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string]),

  /**
   * The "left" position value for the Tooltip arrow.
   */
  arrowOffsetLeft: __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.number, __WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.string])
};
var defaultProps = {
  placement: 'right'
};

var Tooltip =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Tooltip, _React$Component);

  function Tooltip() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Tooltip.prototype;

  _proto.render = function render() {
    var _extends2;

    var _this$props = this.props,
        placement = _this$props.placement,
        positionTop = _this$props.positionTop,
        positionLeft = _this$props.positionLeft,
        arrowOffsetTop = _this$props.arrowOffsetTop,
        arrowOffsetLeft = _this$props.arrowOffsetLeft,
        className = _this$props.className,
        style = _this$props.style,
        children = _this$props.children,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["placement", "positionTop", "positionLeft", "arrowOffsetTop", "arrowOffsetLeft", "className", "style", "children"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps), (_extends2 = {}, _extends2[placement] = true, _extends2));

    var outerStyle = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({
      top: positionTop,
      left: positionLeft
    }, style);

    var arrowStyle = {
      top: arrowOffsetTop,
      left: arrowOffsetLeft
    };
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      role: "tooltip",
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes),
      style: outerStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'arrow'),
      style: arrowStyle
    }), __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", {
      className: Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["e" /* prefix */])(bsProps, 'inner')
    }, children));
  };

  return Tooltip;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

Tooltip.propTypes = propTypes;
Tooltip.defaultProps = defaultProps;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__utils_bootstrapUtils__["a" /* bsClass */])('tooltip', Tooltip));

/***/ }),
/* 1401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__ = __webpack_require__(37);








var Well =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_corejs2_helpers_esm_inheritsLoose__["a" /* default */])(Well, _React$Component);

  function Well() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Well.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        className = _this$props.className,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_corejs2_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["className"]);

    var _splitBsProps = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["f" /* splitBsProps */])(props),
        bsProps = _splitBsProps[0],
        elementProps = _splitBsProps[1];

    var classes = Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["d" /* getClassSet */])(bsProps);
    return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_corejs2_helpers_esm_extends__["a" /* default */])({}, elementProps, {
      className: __WEBPACK_IMPORTED_MODULE_3_classnames___default()(className, classes)
    }));
  };

  return Well;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["a" /* bsClass */])('well', Object(__WEBPACK_IMPORTED_MODULE_5__utils_bootstrapUtils__["b" /* bsSizes */])([__WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].LARGE, __WEBPACK_IMPORTED_MODULE_6__utils_StyleConfig__["c" /* Size */].SMALL], Well)));

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__bootstrapUtils__ = __webpack_require__(11);
/* unused harmony reexport bootstrapUtils */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createChainedFunction__ = __webpack_require__(34);
/* unused harmony reexport createChainedFunction */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ValidComponentChildren__ = __webpack_require__(43);
/* unused harmony reexport ValidComponentChildren */







/***/ }),
/* 1403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cross = exports.crop = exports.credit = exports.card = exports.commons = exports.commonsSharealike = exports.commonsShare = exports.commonsRemix = exports.commonsPublicDomain = exports.commonsNoncommercialUs = exports.commonsNoncommercialEu = exports.commonsNoderivs = exports.commonsAttribution = exports.copy = exports.volume = exports.stop = exports.record = exports.play = exports.paus = exports.next = exports.jumpToStart = exports.fastForward = exports.fastBackward = exports.compass = exports.colours = exports.cog = exports.code = exports.cloud = exports.clock = exports.clipboard = exports.computer = exports.clapperboard = exports.circle = exports.withPlus = exports.withMinus = exports.withCross = exports.thinUp = exports.thinRight = exports.thinLeft = exports.thinDown = exports.smallUp = exports.smallRight = exports.smallLeft = exports.smallDown = exports.check = exports.chat = exports.ccw = exports.camera = exports.calendar = exports.calculator = exports.cake = exports.bug = exports.bucket = exports.brush = exports.browser = exports.briefcase = exports.box = exports.bowl = exports.bookmarks = exports.bookmark = exports.book = exports.block = exports.blackboard = exports.bell = exports.note = exports.battery = exports.back = exports.inTime = exports.ribbon = exports.attachment = exports.withCircleUp = exports.withCircleRight = exports.withCircleLeft = exports.withCircleDown = exports.up = exports.longUp = exports.longRight = exports.longLeft = exports.longDown = exports.down = exports.boldUp = exports.boldRight = exports.boldLeft = exports.boldDown = exports.graph = exports.archive = exports.verticalMiddle = exports.top = exports.right = exports.left = exports.horizontalMiddle = exports.bottom = exports.aircraft = exports.takeOff = exports.landing = exports.air = exports.adjust = exports.address = exports.user = exports.toList = void 0;
exports.network = exports.mouse = exports.pointer = exports.moon = exports.mobile = exports.minus = exports.mic = exports.message = exports.merge = exports.menu = exports.megaphone = exports.medal = exports.mask = exports.map = exports.man = exports.mail = exports.magnet = exports.loop = exports.login = exports.out = exports.lock = exports.open = exports.location = exports.pin = exports.list = exports.link = exports.bulb = exports.lifebuoy = exports.leaf = exports.layers = exports.laptop = exports.language = exports.landline = exports.flask = exports.keyboard = exports.key = exports.install = exports.info = exports.infinity = exports.inbox = exports.image = exports.inverted = exports.glass = exports.home = exports.help = exports.withCircle = exports.heart = exports.outlined = exports.hand = exports.grid = exports.cap = exports.globe = exports.gauge = exports.controller = exports.funnel = exports.forward = exports.folder = exports.video = exports.music = exports.images = exports.flower = exports.tree = exports.parallel = exports.line = exports.cascade = exports.branch = exports.flashlight = exports.flash = exports.flag = exports.fingerprint = exports.feather = exports.eye = exports.withLine = exports.exportIcon = exports.eraser = exports.erase = exports.sad = exports.neutral = exports.happy = exports.flirt = exports.email = exports.edit = exports.drop = exports.drive = exports.drink = exports.download = exports.twoVertical = exports.twoHorizontal = exports.threeVertical = exports.threeHorizontal = exports.single = exports.documents = exports.document = exports.landscape = exports.direction = exports.pad = exports.database = exports.cycle = exports.cw = exports.cup = void 0;
exports.medium = exports.linkedin = exports.lastfm = exports.instagram = exports.icloud = exports.houzz = exports.grooveshark = exports.hangouts = exports.googlePlus = exports.github = exports.foursquare = exports.flickr = exports.flattr = exports.facebook = exports.evernote = exports.dropbox = exports.dribbble = exports.behance = exports.basecamp = exports.baidu = exports.store = exports.fiveHundredPX = exports.water = exports.warning = exports.wallet = exports.voicemail = exports.vinyl = exports.users = exports.upload = exports.toCloud = exports.untag = exports.unread = exports.uninstall = exports.typing = exports.tv = exports.trophy = exports.trash = exports.cone = exports.tools = exports.slot = exports.ticket = exports.thermometer = exports.text = exports.documentInverted = exports.tablet = exports.mobileCombo = exports.switchIcon = exports.sweden = exports.swap = exports.suitcase = exports.stopwatch = exports.star = exports.spreadsheet = exports.club = exports.sound = exports.mute = exports.mix = exports.signal = exports.shuffle = exports.cart = exports.basket = exports.bag = exports.shop = exports.shield = exports.shareable = exports.share = exports.alternative = exports.arrows = exports.scissors = exports.save = exports.ruler = exports.rss = exports.rocket = exports.retweet = exports.fullScreen = exports.oneHundredPercent = exports.reply = exports.all = exports.radio = exports.quote = exports.publish = exports.two = exports.one = exports.full = exports.empty = exports.print = exports.tag = exports.plug = exports.popup = exports.plus = exports.chart = exports.pencil = exports.plane = exports.palette = exports.phone = exports.off = exports.notification = exports.newsletter = exports.news = exports.newIcon = void 0;
exports.youtube = exports.youko = exports.yelp = exports.xing = exports.vk = exports.alternitive = exports.vine = exports.vimeo = exports.twitter = exports.tumblr = exports.tripadvisor = exports.swarm = exports.stumbleupon = exports.spotify = exports.soundcloud = exports.smashing = exports.slideshare = exports.skype = exports.weibo = exports.scribd = exports.renren = exports.rdio = exports.rainbow = exports.raft = exports.qq = exports.pinterest = exports.picasa = exports.paypal = exports.onedrive = exports.mixi = void 0;
var toList = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.4,9H16V5.6C16,5,15.6,5,15,5s-1,0-1,0.6V9h-3.4C10,9,10,9.4,10,10s0,1,0.6,1H14v3.4c0,0.6,0.4,0.6,1,0.6s1,0,1-0.6V11\r\n\th3.4c0.6,0,0.6-0.4,0.6-1S20,9,19.4,9z M7.4,9H0.6C0,9,0,9.4,0,10s0,1,0.6,1h6.8C8,11,8,10.6,8,10S8,9,7.4,9z M7.4,14H0.6\r\n\tC0,14,0,14.4,0,15s0,1,0.6,1h6.8C8,16,8,15.6,8,15S8,14,7.4,14z M7.4,4H0.6C0,4,0,4.4,0,5s0,1,0.6,1h6.8C8,6,8,5.6,8,5S8,4,7.4,4z"
    }
  }]
};
exports.toList = toList;
var user = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.989,19.129C16,17,13.803,15.74,11.672,14.822c-2.123-0.914-2.801-1.684-2.801-3.334c0-0.989,0.648-0.667,0.932-2.481\r\n\tc0.12-0.752,0.692-0.012,0.802-1.729c0-0.684-0.313-0.854-0.313-0.854s0.159-1.013,0.221-1.793c0.064-0.817-0.398-2.56-2.301-3.095\r\n\tC7.88,1.195,7.655,0.654,8.679,0.112c-2.24-0.104-2.761,1.068-3.954,1.93c-1.015,0.756-1.289,1.953-1.24,2.59\r\n\tc0.065,0.78,0.223,1.793,0.223,1.793s-0.314,0.17-0.314,0.854c0.11,1.718,0.684,0.977,0.803,1.729\r\n\tC4.481,10.822,5.13,10.5,5.13,11.489c0,1.65-0.212,2.21-2.336,3.124C0.663,15.53,0,17,0.011,19.129C0.014,19.766,0,20,0,20h16\r\n\tC16,20,15.986,19.766,15.989,19.129z M17,10V7h-2v3h-3v2h3v3h2v-3h3v-2H17z"
    }
  }]
};
exports.user = user;
var address = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.799,5.165l-2.375-1.83c-0.135-0.093-0.324-0.176-0.521-0.237C16.705,3.037,16.5,3,16.336,3H9.5l0.801,5h6.035\r\n\tc0.164,0,0.369-0.037,0.566-0.098s0.387-0.145,0.521-0.236l2.375-1.832C19.933,5.743,20,5.622,20,5.5S19.933,5.257,19.799,5.165z\r\n\t M8.5,1h-1C7.224,1,7,1.224,7,1.5V5H3.664c-0.166,0-0.37,0.037-0.567,0.099C2.899,5.159,2.71,5.242,2.576,5.335l-2.375,1.83\r\n\tC0.066,7.256,0,7.378,0,7.5c0,0.121,0.066,0.242,0.201,0.335l2.375,1.832C2.71,9.758,2.899,9.842,3.097,9.902\r\n\tC3.294,9.963,3.498,10,3.664,10H7v8.5C7,18.776,7.224,19,7.5,19h1C8.776,19,9,18.776,9,18.5v-17C9,1.224,8.776,1,8.5,1z"
    }
  }]
};
exports.address = address;
var adjust = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,9.199c-0.182,0-0.799,0-0.98,0c-0.553,0-1,0.359-1,0.801c0,0.441,0.447,0.799,1,0.799c0.182,0,0.799,0,0.98,0\r\n\tc0.552,0,1-0.357,1-0.799C20,9.559,19.551,9.199,19,9.199z M10,4.5c-3.051,0-5.5,2.449-5.5,5.5c0,3.051,2.449,5.5,5.5,5.5\r\n\tc3.05,0,5.5-2.449,5.5-5.5C15.5,6.949,13.049,4.5,10,4.5z M10,14c-2.211,0-4-1.791-4-4c0-2.211,1.789-4,4-4V14z M3,10\r\n\tc0-0.441-0.449-0.801-1-0.801c-0.185,0-0.816,0-1,0c-0.553,0-1,0.359-1,0.801c0,0.441,0.447,0.799,1,0.799c0.184,0,0.815,0,1,0\r\n\tC2.551,10.799,3,10.441,3,10z M10,3c0.441,0,0.799-0.447,0.799-1c0-0.184,0-0.816,0-1c0-0.553-0.358-1-0.799-1\r\n\tC9.558,0,9.199,0.447,9.199,1c0,0.184,0,0.816,0,1C9.199,2.553,9.558,3,10,3z M10,17c-0.442,0-0.801,0.447-0.801,1\r\n\tc0,0.184,0,0.816,0,1c0,0.553,0.359,1,0.801,1c0.441,0,0.799-0.447,0.799-1c0-0.184,0-0.816,0-1C10.799,17.447,10.441,17,10,17z\r\n\t M17.365,3.766c0.391-0.391,0.454-0.961,0.142-1.273s-0.883-0.248-1.272,0.143c-0.108,0.107-0.593,0.592-0.7,0.699\r\n\tc-0.391,0.391-0.454,0.961-0.142,1.273s0.883,0.248,1.273-0.143C16.773,4.357,17.257,3.873,17.365,3.766z M3.334,15.533\r\n\tc-0.108,0.109-0.593,0.594-0.7,0.701c-0.391,0.391-0.454,0.959-0.142,1.271s0.883,0.25,1.272-0.141\r\n\tc0.108-0.107,0.593-0.592,0.7-0.699c0.391-0.391,0.454-0.961,0.142-1.274S3.723,15.144,3.334,15.533z M3.765,2.635\r\n\tC3.375,2.244,2.804,2.18,2.492,2.492S2.244,3.375,2.633,3.766c0.108,0.107,0.593,0.592,0.7,0.699\r\n\tc0.391,0.391,0.96,0.455,1.272,0.143s0.249-0.883-0.141-1.273C4.357,3.227,3.873,2.742,3.765,2.635z M15.534,16.666\r\n\tc0.108,0.107,0.593,0.592,0.7,0.699c0.391,0.391,0.96,0.453,1.272,0.143c0.312-0.312,0.249-0.883-0.142-1.273\r\n\tc-0.107-0.107-0.592-0.592-0.699-0.699c-0.391-0.391-0.961-0.455-1.274-0.143S15.143,16.275,15.534,16.666z"
    }
  }]
};
exports.adjust = adjust;
var air = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.643,6.357c1.747-1.5,3.127-2.686,6.872-0.57c1.799,1.016,3.25,1.4,4.457,1.398c2.115,0,3.486-1.176,4.671-2.193\r\n\tc0.423-0.363,0.477-1.008,0.122-1.439c-0.357-0.432-0.987-0.488-1.41-0.125c-1.746,1.502-3.127,2.688-6.872,0.57\r\n\tC5.535,1.205,3.217,3.195,1.355,4.795C0.933,5.158,0.879,5.801,1.234,6.234C1.59,6.664,2.22,6.721,2.643,6.357z M17.355,8.535\r\n\tc-1.746,1.5-3.127,2.688-6.872,0.57C5.535,6.31,3.217,8.301,1.355,9.9c-0.422,0.363-0.477,1.008-0.121,1.439\r\n\tc0.355,0.432,0.986,0.488,1.409,0.125C4.39,9.963,5.77,8.777,9.515,10.892c1.799,1.018,3.25,1.4,4.457,1.4\r\n\tc2.115,0,3.486-1.176,4.671-2.195c0.423-0.363,0.477-1.008,0.122-1.438C18.409,8.226,17.778,8.172,17.355,8.535z M17.355,13.641\r\n\tc-1.746,1.502-3.127,2.688-6.872,0.572c-4.948-2.795-7.266-0.805-9.128,0.795c-0.422,0.363-0.477,1.008-0.121,1.439\r\n\tc0.355,0.432,0.986,0.486,1.409,0.123C4.39,15.07,5.77,13.885,9.515,16c1.799,1.016,3.25,1.4,4.457,1.4\r\n\tc2.115,0,3.486-1.178,4.671-2.195c0.423-0.363,0.477-1.008,0.122-1.439C18.409,13.334,17.778,13.279,17.355,13.641z"
    }
  }]
};
exports.air = air;
var landing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.752,16.038c-0.097,0.266-0.822,1.002-6.029-0.878l-5.105-1.843C5.841,12.676,3.34,11.668,2.36,11.1\r\n\tc-0.686-0.397-0.836-1.282-0.836-1.282S1.361,6.862,1.261,6.134c-0.1-0.728,0.095-0.853,0.796-0.492\r\n\tc0.436,0.225,1.865,2.562,2.464,3.567C6.033,9.59,7.383,9.97,8.014,10.158C7.757,8.441,7.274,5.23,7.101,4.225\r\n\tC6.935,3.262,7.651,3.69,7.651,3.69c0.331,0.19,0.983,0.661,1.206,1.002c1.522,2.326,3.672,6.6,3.836,6.928\r\n\tc0.896,0.28,2.277,0.733,3.102,1.03C17.951,13.429,18.882,15.684,18.752,16.038z"
    }
  }]
};
exports.landing = landing;
var takeOff = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.87,6.453c0.119,0.257,0.127,1.29-4.884,3.642l-4.913,2.306c-1.71,0.803-4.191,1.859-5.285,2.151\r\n\tc-0.766,0.204-1.497-0.316-1.497-0.316s-2.206-1.975-2.792-2.419c-0.585-0.444-0.535-0.67,0.215-0.91\r\n\tc0.467-0.149,3.13,0.493,4.265,0.78c1.339-0.8,2.562-1.486,3.141-1.798c-1.396-1.033-4.008-2.962-4.841-3.55\r\n\tc-0.799-0.565,0.01-0.768,0.01-0.768c0.368-0.099,1.162-0.228,1.562-0.144c2.721,0.569,7.263,2.071,7.611,2.186\r\n\tc0.832-0.436,2.128-1.092,2.922-1.465C17.459,5.174,19.711,6.111,19.87,6.453z"
    }
  }]
};
exports.takeOff = takeOff;
var aircraft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.496,17.414c-0.394-1.096-1.805-4.775-2.39-6.297c-1.103,0.737-2.334,1.435-3.512,1.928\r\n\tc-0.366,1.28-1.094,3.709-1.446,4.033c-0.604,0.557-0.832,0.485-0.925-0.279c-0.093-0.764-0.485-3.236-0.485-3.236\r\n\ts-2.162-1.219-2.84-1.568s-0.667-0.591,0.057-0.974c0.422-0.223,2.927-0.085,4.242,0.005c0.861-0.951,1.931-1.882,2.993-2.679\r\n\tC6.975,7.271,4.04,4.672,3.156,3.923C2.38,3.265,3.235,3.126,3.235,3.126c0.39-0.07,1.222-0.132,1.628-0.009\r\n\tc2.524,0.763,6.442,2.068,7.363,2.376c0.353-0.249,0.737-0.52,1.162-0.821c4.702-3.33,5.887-2.593,6.111-2.27\r\n\ts0.503,1.701-4.199,5.032c-0.425,0.301-0.808,0.573-1.16,0.823c-0.029,0.98-0.157,5.151-0.311,7.811\r\n\tc-0.025,0.428-0.367,1.198-0.565,1.544C13.263,17.612,12.841,18.377,12.496,17.414z"
    }
  }]
};
exports.aircraft = aircraft;
var bottom = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,11h-2V3H9v8H7l3,3L13,11z M17.4,15H2.6C2.048,15,2,15.447,2,16c0,0.553,0.048,1,0.6,1H17.4c0.552,0,0.6-0.447,0.6-1\r\n\tC18,15.447,17.952,15,17.4,15z"
    }
  }]
};
exports.bottom = bottom;
var horizontalMiddle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8,10L5,7v2H1v2h4v2L8,10z M15,13v-2h4V9h-4V7l-3,3L15,13z M10,18c0.553,0,1-0.049,1-0.6V2.6C11,2.047,10.553,2,10,2\r\n\tC9.448,2,9,2.047,9,2.6V17.4C9,17.951,9.448,18,10,18z"
    }
  }]
};
exports.horizontalMiddle = horizontalMiddle;
var left = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,10l3,3v-2h8V9H9V7L6,10z M4,2C3.447,2,3,2.047,3,2.6V17.4C3,17.951,3.447,18,4,18c0.552,0,1-0.049,1-0.6V2.6\r\n\tC5,2.047,4.552,2,4,2z"
    }
  }]
};
exports.left = left;
var right = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,7v2H3v2h8v2l3-3L11,7z M15,2.6V17.4c0,0.551,0.448,0.6,1,0.6c0.553,0,1-0.049,1-0.6V2.6C17,2.047,16.553,2,16,2\r\n\tC15.448,2,15,2.047,15,2.6z"
    }
  }]
};
exports.right = right;
var top = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,6L7,9h2v8h2V9h2L10,6z M18,4c0-0.553-0.048-1-0.6-1H2.6C2.048,3,2,3.447,2,4c0,0.553,0.048,1,0.6,1H17.4\r\n\tC17.952,5,18,4.553,18,4z"
    }
  }]
};
exports.top = top;
var verticalMiddle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,12l-3,3h2v4h2v-4h2L10,12z M13,5h-2V1H9v4H7l3,3L13,5z M18,10c0-0.553-0.048-1-0.6-1H2.6C2.048,9,2,9.447,2,10\r\n\tc0,0.551,0.048,1,0.6,1H17.4C17.952,11,18,10.551,18,10z"
    }
  }]
};
exports.verticalMiddle = verticalMiddle;
var archive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.981,2H6.018c0,0-0.996,0-0.996,1h9.955C14.977,2,13.981,2,13.981,2z M16.968,5c0-1-0.995-1-0.995-1H4.027\r\n\tc0,0-0.995,0-0.995,1v1h13.936V5z M18.958,6C18.37,5.408,18.37,5.408,18.37,5.408V7H1.63V5.408c0,0,0,0-0.589,0.592\r\n\tC0.452,6.592,0.03,6.75,0.267,8c0.236,1.246,1.379,8.076,1.549,9c0.186,1.014,1.217,1,1.217,1h13.936c0,0,1.03,0.014,1.217-1\r\n\tc0.17-0.924,1.312-7.754,1.549-9C19.97,6.75,19.548,6.592,18.958,6z M14,11.997C14,12.551,13.551,13,12.997,13H7.003\r\n\tC6.449,13,6,12.551,6,11.997V10h1v2h6v-2h1V11.997z"
    }
  }]
};
exports.archive = archive;
var graph = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,2v16H0.32c-0.318,0-0.416-0.209-0.216-0.465l4.469-5.748c0.199-0.256,0.553-0.283,0.789-0.062l1.419,1.334\r\n\tc0.235,0.221,0.572,0.178,0.747-0.096l3.047-4.74c0.175-0.273,0.509-0.312,0.741-0.09l2.171,2.096c0.232,0.225,0.559,0.18,0.724-0.1\r\n\tl5.133-7.785C19.51,2.062,19.75,2,20,2z"
    }
  }]
};
exports.graph = graph;
var boldDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5,10H6V3h8v7h3.5L10,17.5L2.5,10z"
    }
  }]
};
exports.boldDown = boldDown;
var boldLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5V6h7v8h-7v3.5L2.5,10L10,2.5z"
    }
  }]
};
exports.boldLeft = boldLeft;
var boldRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.5,10L10,17.5V14H3V6h7V2.5L17.5,10z"
    }
  }]
};
exports.boldRight = boldRight;
var boldUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5l7.5,7.5H14v7H6v-7H2.5L10,2.5z"
    }
  }]
};
exports.boldUp = boldUp;
var down = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,17.5L3.5,11H7V3h6v8h3.5L10,17.5z"
    }
  }]
};
exports.down = down;
var longDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,19.25L4.5,14H8V1h4v13h3.5L10,19.25z"
    }
  }]
};
exports.longDown = longDown;
var longLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.75,10L6,4.5V8h13v4H6v3.5L0.75,10z"
    }
  }]
};
exports.longLeft = longLeft;
var longRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,15.5V12H1V8h13V4.5l5.25,5.5L14,15.5z"
    }
  }]
};
exports.longRight = longRight;
var longUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.75L15.5,6H12v13H8V6H4.5L10,0.75z"
    }
  }]
};
exports.longUp = longUp;
var up = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.5L16.5,9H13v8H7V9H3.5L10,2.5z"
    }
  }]
};
exports.up = up;
var withCircleDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M12,6H8v4H5.5l4.5,4.5l4.5-4.5H12V6z"
    }
  }]
};
exports.withCircleDown = withCircleDown;
var withCircleLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,5.5L5.5,10l4.5,4.5V12h4V8h-4V5.5z"
    }
  }]
};
exports.withCircleLeft = withCircleLeft;
var withCircleRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,8H6v4h4v2.5l4.5-4.5L10,5.5V8z"
    }
  }]
};
exports.withCircleRight = withCircleRight;
var withCircleUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6s3.402-7.6,7.6-7.6S17.6,5.803,17.6,10\r\n\tS14.196,17.6,9.999,17.6z M10,5.5l4.5,4.5H12v4H8v-4H5.5L10,5.5z"
    }
  }]
};
exports.withCircleUp = withCircleUp;
var attachment = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.602,19.8c-1.293,0-2.504-0.555-3.378-1.44c-1.695-1.716-2.167-4.711,0.209-7.116c1.391-1.408,6.966-7.053,9.748-9.87\r\n\tc0.988-1,2.245-1.387,3.448-1.06c1.183,0.32,2.151,1.301,2.468,2.498c0.322,1.22-0.059,2.493-1.046,3.493l-9.323,9.44\r\n\tc-0.532,0.539-1.134,0.858-1.738,0.922c-0.599,0.064-1.17-0.13-1.57-0.535c-0.724-0.736-0.828-2.117,0.378-3.337l6.548-6.63\r\n\tc0.269-0.272,0.705-0.272,0.974,0s0.269,0.714,0,0.986l-6.549,6.631c-0.566,0.572-0.618,1.119-0.377,1.364\r\n\tC5.5,15.252,5.66,15.301,5.845,15.28c0.283-0.029,0.606-0.216,0.909-0.521l9.323-9.439c0.64-0.648,0.885-1.41,0.69-2.145\r\n\tc-0.192-0.725-0.778-1.318-1.493-1.513c-0.726-0.197-1.48,0.052-2.12,0.7c-2.782,2.818-8.356,8.462-9.748,9.87\r\n\tc-1.816,1.839-1.381,3.956-0.209,5.143c1.173,1.187,3.262,1.629,5.079-0.212l9.748-9.87c0.269-0.272,0.705-0.272,0.974,0\r\n\tc0.269,0.272,0.269,0.714,0,0.987L9.25,18.15C8.101,19.312,6.814,19.8,5.602,19.8z"
    }
  }]
};
exports.attachment = attachment;
var ribbon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.574,16.338c-0.757-1.051-2.851-3.824-4.57-6.106c0.696-0.999,1.251-1.815,1.505-2.242\r\n\tc1.545-2.594,0.874-4.26,0.022-5.67C12.677,0.909,12.542,0.094,10,0.094c-2.543,0-2.678,0.815-3.531,2.227\r\n\tC5.615,3.731,4.945,5.397,6.49,7.991c0.254,0.426,0.809,1.243,1.506,2.242c-1.72,2.281-3.814,5.055-4.571,6.106\r\n\tc-0.176,0.244-0.16,0.664,0.009,1.082c0.13,0.322,0.63,1.762,0.752,2.064c0.156,0.389,0.664,0.67,1.082,0.092\r\n\tc0.241-0.334,2.582-3.525,4.732-6.522c2.149,2.996,4.491,6.188,4.732,6.522c0.417,0.578,0.926,0.297,1.082-0.092\r\n\tc0.122-0.303,0.622-1.742,0.752-2.064C16.733,17.002,16.75,16.582,16.574,16.338z M9.634,7.063C8.566,5.579,7.802,3.852,7.802,3.852\r\n\tS8.222,3.094,10,3.094c1.778,0,2.198,0.758,2.198,0.758s-0.766,1.727-1.833,3.211C10.277,7.184,10.147,7.36,10,7.56\r\n\tC9.851,7.36,9.721,7.184,9.634,7.063z"
    }
  }]
};
exports.ribbon = ribbon;
var inTime = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,1.799c-4.445,0-8.061,3.562-8.169,7.996V10H0.459l3.594,3.894L7.547,10H4.875V9.795C4.982,6.492,7.683,3.85,11,3.85\r\n\tc3.386,0,6.131,2.754,6.131,6.15c0,3.396-2.745,6.15-6.131,6.15c-1.357,0-2.611-0.445-3.627-1.193l-1.406,1.504\r\n\tc1.388,1.088,3.135,1.738,5.033,1.738c4.515,0,8.174-3.67,8.174-8.199S15.515,1.799,11,1.799z M10,5v5\r\n\tc0,0.13,0.027,0.26,0.077,0.382c0.051,0.122,0.124,0.233,0.216,0.325l3.2,3.2c0.283-0.183,0.55-0.389,0.787-0.628L12,11V5H10z"
    }
  }]
};
exports.inTime = inTime;
var back = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,7v6c0,1.103-0.896,2-2,2H3v-3h13V8H5v2L1,6.5L5,3v2h12C18.104,5,19,5.896,19,7z"
    }
  }]
};
exports.back = back;
var battery = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.408,10c0-2.766,1.277-4.32,2.277-4.32c0.363,0,1.315,0,1.315,0C18.332,4.621,17.779,4,15.342,4H5.334\r\n\tC1.6,4,0,7.441,0,10c0,2.559,1.6,6,5.334,6h10.008c2.438,0,2.99-0.621,3.658-1.68c0,0-0.315,0-1.315,0S15.408,12.766,15.408,10z\r\n\t M12.688,11.795c-0.164,0.25-0.676,0.016-0.676,0.016l-2.957-1.338c0,0-0.264,0.67-0.467,1.141\r\n\tc-0.205,0.471-0.361,1.004-1.209,0.408c-0.849-0.598-3.581-3.25-3.581-3.25S3.453,8.488,3.625,8.221\r\n\tc0.163-0.252,0.676-0.016,0.676-0.016l2.956,1.336c0,0,0.265-0.668,0.468-1.139C7.93,7.932,8.086,7.396,8.934,7.994\r\n\tc0.849,0.596,3.58,3.25,3.58,3.25S12.859,11.527,12.688,11.795z M18.874,7.928h-0.749c-0.559,0-1.105,0.754-1.105,1.979\r\n\tc0,1.227,0.547,1.98,1.105,1.98h0.749c0.56,0,1.126-0.754,1.126-1.98C20,8.682,19.434,7.928,18.874,7.928z"
    }
  }]
};
exports.battery = battery;
var note = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,1l-0.002,13c0,1.243-1.301,3-3.748,3C12.007,17,11,16.347,11,15.125c0-1.589,1.445-2.55,3-2.55\r\n\tc0.432,0,0.754,0.059,1,0.123V5.364L8,6.637L8,16H7.998c0,1.243-1.301,3-3.748,3C3.007,19,2,18.347,2,17.125\r\n\tc0-1.589,1.445-2.55,3-2.55c0.432,0,0.754,0.059,1,0.123V3L17,1z"
    }
  }]
};
exports.note = note;
var bell = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.65,8.512c-2.28-4.907-3.466-6.771-7.191-6.693C6.132,1.846,6.45,0.857,5.438,1.232C4.428,1.607,5.295,2.156,4.261,3.005\r\n\tc-2.902,2.383-2.635,4.587-1.289,9.84c0.567,2.213-1.367,2.321-0.602,4.465c0.559,1.564,4.679,2.219,9.025,0.607\r\n\tc4.347-1.613,7.086-4.814,6.527-6.378C17.157,9.394,15.611,10.578,14.65,8.512z M10.924,16.595c-3.882,1.44-7.072,0.594-7.207,0.217\r\n\tc-0.232-0.65,1.253-2.816,5.691-4.463c4.438-1.647,6.915-1.036,7.174-0.311C16.735,12.467,14.807,15.154,10.924,16.595z\r\n\t M9.676,13.101c-2.029,0.753-3.439,1.614-4.353,2.389c0.643,0.584,1.847,0.726,3.046,0.281c1.527-0.565,2.466-1.866,2.095-2.904\r\n\tc-0.005-0.013-0.011-0.023-0.016-0.036C10.197,12.913,9.94,13.002,9.676,13.101z"
    }
  }]
};
exports.bell = bell;
var blackboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M2.539,20H6l1.406-3.698L4.44,15.298L2.539,20z M12.594,16.302L14,20h3.461\r\n\tl-1.901-4.702L12.594,16.302z M18,2h-6.5L11,0H9L8.5,2H2C1.447,2,1,2.447,1,3v11c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V3\r\n\tC19,2.448,18.553,2,18,2z"
    }
  }]
};
exports.blackboard = blackboard;
var block = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M2.399,10c0-4.197,3.402-7.6,7.6-7.6c1.829,0,3.506,0.647,4.817,1.723L4.122,14.817\r\n\tC3.046,13.505,2.399,11.829,2.399,10z M9.999,17.599c-1.828,0-3.505-0.646-4.815-1.722L15.878,5.184\r\n\tC16.953,6.496,17.6,8.171,17.6,10C17.6,14.197,14.196,17.599,9.999,17.599z"
    }
  }]
};
exports.block = block;
var book = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,5.95v10.351c0,0.522-0.452,0.771-1,1.16c-0.44,0.313-1-0.075-1-0.587c0,0,0-9.905,0-10.114\r\n\tc0-0.211-0.074-0.412-0.314-0.535c-0.24-0.123-7.738-4.065-7.738-4.065C6.827,2.115,6.299,1.782,5.595,2.144\r\n\tC4.926,2.488,4.562,2.862,4.469,3.038l8.18,4.482C12.866,7.634,13,7.81,13,8.036v10.802c0,0.23-0.142,0.476-0.369,0.585\r\n\tc-0.104,0.052-0.219,0.077-0.333,0.077c-0.135,0-0.271-0.033-0.386-0.104c-0.215-0.131-7.774-4.766-8.273-5.067\r\n\tc-0.24-0.144-0.521-0.439-0.527-0.658L3,3.385c0-0.198-0.023-0.547,0.289-1.032c0.697-1.084,3.129-2.317,4.36-1.678l8.999,4.555\r\n\tC16.865,5.342,17,5.566,17,5.95z"
    }
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,2v17l-4-4l-4,4V2c0-0.553,0.585-1.02,1-1h6C13.689,0.98,14,1.447,14,2z"
    }
  }]
};
exports.bookmark = bookmark;
var bookmarks = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,0h-4c-0.553,0-1,0.447-1,1l0.023,0.222c1.102,0,2,0.897,2,2v11.359L13,13.4l3,3.6V1C16,0.447,15.553,0,15,0z M9.023,3H5\r\n\tC4.447,3,4,3.447,4,4v16l3-3.6l3,3.6V4C10,3.447,9.576,3,9.023,3z"
    }
  }]
};
exports.bookmarks = bookmarks;
var bowl = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.949,7.472c-2.176,2.902-4.095,3.002-7.046,3.152H9.802c-3.591-0.002-6.138-1.336-6.138-1.832\r\n\tC3.662,8.321,5.962,7.095,9.269,6.973l0.59-1.473c-0.019,0-0.037-0.002-0.057-0.002c-4.908,0-7.791,1.562-7.791,3.051v2\r\n\tc0,0.918,0.582,8.949,7.582,8.949s8-8.031,8-8.949v-2c0-0.391-0.201-0.787-0.584-1.158L16.949,7.472z M17.589,2.702\r\n\tc-0.441-0.33-1.069-0.242-1.399,0.201l-3.608,4.809l2.336-5.838c0.206-0.512-0.044-1.094-0.557-1.301\r\n\tc-0.508-0.205-1.096,0.043-1.3,0.559L9.802,9.274c2.882-0.147,4.277-0.227,6.067-2.611c1.789-2.387,1.919-2.561,1.919-2.561\r\n\tC18.12,3.661,18.031,3.034,17.589,2.702z"
    }
  }]
};
exports.bowl = bowl;
var box = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.399,2H1.6C1.268,2,1,2.267,1,2.6V5h18V2.6C19,2.267,18.73,2,18.399,2z M2,16.6c0,0.77,0.629,1.4,1.399,1.4h13.2\r\n\tc0.77,0,1.4-0.631,1.4-1.4V6H2V16.6z M7,8h6v2H7V8z"
    }
  }]
};
exports.box = box;
var briefcase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9,10h2v2h9c0,0-0.149-4.459-0.2-5.854C19.75,4.82,19.275,4,17.8,4h-3.208c-0.497-0.938-1.032-1.945-1.197-2.256\r\n\tC13.064,1.121,12.951,1,12.216,1H7.783C7.048,1,6.936,1.121,6.604,1.744C6.439,2.055,5.904,3.062,5.408,4H2.199\r\n\tc-1.476,0-1.945,0.82-2,2.146C0.145,7.473,0,12,0,12h9V10z M7.649,2.916C7.879,2.484,7.957,2.4,8.466,2.4h3.067\r\n\tc0.509,0,0.588,0.084,0.816,0.516c0.086,0.16,0.318,0.6,0.575,1.084H7.074C7.331,3.516,7.563,3.076,7.649,2.916z M11,15H9v-2H0.5\r\n\tc0,0,0.124,1.797,0.199,3.322C0.73,16.955,0.917,18,2.499,18H17.5c1.582,0,1.765-1.047,1.8-1.678C19.387,14.754,19.5,13,19.5,13H11\r\n\tV15z"
    }
  }]
};
exports.briefcase = briefcase;
var browser = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,2H2C0.9,2,0,2.9,0,4v12c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V4C20,2.9,19.1,2,18,2z M4.5,3.75\r\n\tc0.414,0,0.75,0.336,0.75,0.75c0,0.414-0.336,0.75-0.75,0.75c-0.414,0-0.75-0.336-0.75-0.75C3.75,4.086,4.086,3.75,4.5,3.75z\r\n\t M1.75,4.5c0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75c0,0.414-0.336,0.75-0.75,0.75\r\n\tC2.086,5.25,1.75,4.914,1.75,4.5z M18,16H2V7h16V16z M18,5H6V4h12.019L18,5z"
    }
  }]
};
exports.browser = browser;
var brush = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.763,13.563c-1.515,1.488-0.235,3.016-2.247,5.279c-0.908,1.023,3.738,0.711,6.039-1.551\r\n\tc0.977-0.961,0.701-2.359-0.346-3.389C5.162,12.874,3.739,12.602,2.763,13.563z M19.539,0.659C18.763-0.105,10.16,6.788,7.6,9.305\r\n\tc-1.271,1.25-1.695,1.92-2.084,2.42c-0.17,0.219,0.055,0.285,0.154,0.336c0.504,0.258,0.856,0.496,1.311,0.943\r\n\tc0.456,0.447,0.699,0.793,0.959,1.289c0.053,0.098,0.121,0.318,0.342,0.152c0.51-0.383,1.191-0.801,2.462-2.049\r\n\tC13.305,9.88,20.317,1.422,19.539,0.659z"
    }
  }]
};
exports.brush = brush;
var bucket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,1C6.092,1,3.002,2.592,3.21,3.95c0.06,0.389,0.225,1.945,0.434,3.273c-2.405,0.934-3.202,2.449-3.095,3.684\r\n\tc0.127,1.461,1.441,3.025,4.328,3.295c1.648,0.154,3.631-0.75,4.916-2.295C9.671,11.7,9.6,11.457,9.6,11.2\r\n\tc0-0.774,0.627-1.4,1.4-1.4c0.774,0,1.4,0.627,1.4,1.4c0,0.762-0.61,1.381-1.369,1.398c-1.529,1.973-3.858,3.164-6.064,3.025\r\n\tc0.051,0.324,0.07,0.947,0.096,1.113C5.153,17.315,7.41,18.996,11,19c3.59-0.004,5.847-1.685,5.938-2.263\r\n\tC17.026,16.16,18.579,5.328,18.79,3.95C18.998,2.592,15.907,1,11,1z M1.943,10.785c-0.055-0.643,0.455-1.498,1.924-2.139\r\n\tc0.211,1.34,0.441,2.797,0.643,4.074C2.906,12.407,2.012,11.571,1.943,10.785z M11,6.024C7.41,6.022,4.863,4.69,4.863,4.192\r\n\tC4.861,3.698,7.41,2.402,11,2.404c3.59-0.002,6.139,1.294,6.137,1.788C17.137,4.69,14.59,6.022,11,6.024z"
    }
  }]
};
exports.bucket = bucket;
var bug = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C7.7907715,1,6,2.7908325,6,5h8C14,2.7908325,12.2092285,1,10,1z M19,10h-3V7.5031738\r\n\tc0-0.02771-0.0065918-0.0535278-0.0080566-0.0808716l2.2150879-2.21521c0.390625-0.3905029,0.390625-1.0236816,0-1.4141846\r\n\tc-0.3903809-0.390564-1.0236816-0.390564-1.4140625,0l-2.215332,2.21521C14.550293,6.0066528,14.5246582,6,14.4970703,6H5.5029297\r\n\tC5.4753418,6,5.449707,6.0066528,5.4223633,6.0081177l-2.215332-2.21521c-0.3903809-0.390564-1.0236816-0.390564-1.4140625,0\r\n\tc-0.390625,0.3905029-0.390625,1.0236816,0,1.4141846l2.2150879,2.21521C4.0065918,7.449646,4,7.4754639,4,7.5031738V10H1\r\n\tc-0.5522461,0-1,0.4476929-1,1c0,0.5522461,0.4477539,1,1,1h3c0,0.7799683,0.15625,1.520813,0.4272461,2.2037354\r\n\tc-0.0441895,0.0316162-0.0947266,0.0494995-0.1342773,0.0891724l-2.8286133,2.8283691\r\n\tc-0.3903809,0.390564-0.3903809,1.0237427,0,1.4142456c0.390625,0.3905029,1.0239258,0.3905029,1.4143066,0L5.4802246,15.93396\r\n\tC6.3725586,16.9555054,7.6027832,17.6751099,9,17.9100342V8h2v9.9100342\r\n\tc1.3972168-0.2349243,2.6274414-0.9545288,3.5197754-1.9760132l2.6015625,2.6015015\r\n\tc0.3903809,0.3905029,1.0236816,0.3905029,1.4143066,0c0.3903809-0.3905029,0.3903809-1.0236816,0-1.4142456l-2.8286133-2.8283691\r\n\tc-0.0395508-0.0396729-0.0900879-0.0575562-0.1342773-0.0891724C15.84375,13.520813,16,12.7799683,16,12h3\r\n\tc0.5522461,0,1-0.4477539,1-1C20,10.4476929,19.5522461,10,19,10z"
    }
  }]
};
exports.bug = bug;
var cake = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.584,6.036c1.952,0,2.591-1.381,1.839-2.843c-0.871-1.693,1.895-3.155,0.521-3.155c-1.301,0-3.736,1.418-4.19,3.183\r\n\tC7.415,4.545,8.05,6.036,9.584,6.036z M14.796,14.987l-0.444-0.383c-0.487-0.42-1.25-0.418-1.735,0l-0.442,0.382\r\n\tc-0.62,0.534-1.397,0.801-2.174,0.801c-0.777,0-1.554-0.267-2.173-0.8l-0.444-0.384c-0.487-0.418-1.249-0.419-1.734,0.001\r\n\tl-0.444,0.383c-1.193,1.028-2.967,1.056-4.204,0.1V19c0,0.552,0.448,1,1,1h16c0.552,0,1-0.448,1-1v-3.912\r\n\tC17.765,16.042,15.991,16.017,14.796,14.987z M10,7c-7.574,0-9,3.361-9,5v0.469l1.164,1.003c0.486,0.421,1.249,0.417,1.735,0\r\n\tl0.444-0.383c1.237-1.065,3.105-1.066,4.345,0l0.444,0.384c0.484,0.417,1.245,0.42,1.735-0.001l0.442-0.382\r\n\tc1.24-1.067,3.107-1.067,4.346-0.001l0.444,0.383c0.487,0.421,1.25,0.417,1.735,0L19,12.469V12C19,10.361,17.574,7,10,7z"
    }
  }]
};
exports.cake = cake;
var calculator = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.6,1H5.398C4.629,1,4,1.629,4,2.4V17.6c0,0.77,0.629,1.4,1.398,1.4H14.6c0.769,0,1.4-0.631,1.4-1.4V2.4\r\n\tC16,1.629,15.369,1,14.6,1z M7,12c0.689,0,1.25,0.447,1.25,1S7.689,14,7,14c-0.69,0-1.25-0.447-1.25-1S6.31,12,7,12z M5.75,10\r\n\tc0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1c0,0.553-0.561,1-1.25,1C6.31,11,5.75,10.553,5.75,10z M7,15\r\n\tc0.689,0,1.25,0.447,1.25,1S7.689,17,7,17c-0.69,0-1.25-0.447-1.25-1S6.31,15,7,15z M10,12c0.689,0,1.25,0.447,1.25,1\r\n\ts-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S9.31,12,10,12z M8.75,10c0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1\r\n\tc0,0.553-0.561,1-1.25,1C9.31,11,8.75,10.553,8.75,10z M10,15c0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1\r\n\tS9.31,15,10,15z M13,12c0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S12.31,12,13,12z M11.75,10\r\n\tc0-0.553,0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1c0,0.553-0.561,1-1.25,1C12.31,11,11.75,10.553,11.75,10z M13,15\r\n\tc0.689,0,1.25,0.447,1.25,1s-0.561,1-1.25,1c-0.69,0-1.25-0.447-1.25-1S12.31,15,13,15z M5,7V4h10v3H5z"
    }
  }]
};
exports.calculator = calculator;
var calendar = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,3h-1v2h-3V3H7v2H4V3H3C1.899,3,1,3.9,1,5v12c0,1.1,0.899,2,2,2h14c1.1,0,2-0.9,2-2V5C19,3.9,18.1,3,17,3z M17,17H3V9h14\r\n\tV17z M6.5,1h-2v3.5h2V1z M15.5,1h-2v3.5h2V1z"
    }
  }]
};
exports.calendar = calendar;
var camera = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,8c-1.657,0-3,1.344-3,3c0,1.656,1.343,3,3,3c1.656,0,3-1.344,3-3C13,9.344,11.656,8,10,8z M18,5h-2.4\r\n\tc-0.33,0-0.686-0.256-0.789-0.57l-0.621-1.861C14.085,2.256,13.731,2,13.4,2H6.6C6.27,2,5.914,2.256,5.811,2.568L5.189,4.43\r\n\tC5.085,4.744,4.73,5,4.4,5H2C0.9,5,0,5.9,0,7v9c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M10,16\r\n\tc-2.762,0-5-2.238-5-5c0-2.762,2.238-5,5-5c2.761,0,5,2.238,5,5C15,13.762,12.761,16,10,16z M17.5,8.2c-0.387,0-0.7-0.314-0.7-0.701\r\n\tc0-0.385,0.313-0.7,0.7-0.7s0.7,0.314,0.7,0.7C18.2,7.886,17.887,8.2,17.5,8.2z"
    }
  }]
};
exports.camera = camera;
var ccw = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.685,10h2.372V9.795c0.108-4.434,3.724-7.996,8.169-7.996c4.515,0,8.174,3.672,8.174,8.201s-3.659,8.199-8.174,8.199\r\n\tc-1.898,0-3.645-0.65-5.033-1.738l1.406-1.504c1.016,0.748,2.27,1.193,3.627,1.193c3.386,0,6.131-2.754,6.131-6.15\r\n\tc0-3.396-2.745-6.15-6.131-6.15c-3.317,0-6.018,2.643-6.125,5.945V10h2.672l-3.494,3.894L0.685,10z"
    }
  }]
};
exports.ccw = ccw;
var chat = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.8,12.2V6H2C0.9,6,0,6.9,0,8v6c0,1.1,0.9,2,2,2h1v3l3-3h5c1.1,0,2-0.9,2-2v-1.82c-0.064,0.014-0.132,0.021-0.2,0.021h-7\r\n\tV12.2z M18,1H9C7.9,1,7,1.9,7,3v8h7l3,3v-3h1c1.1,0,2-0.899,2-2V3C20,1.9,19.1,1,18,1z"
    }
  }]
};
exports.chat = chat;
var check = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.294,16.998c-0.435,0-0.847-0.203-1.111-0.553L3.61,11.724c-0.465-0.613-0.344-1.486,0.27-1.951\r\n\tc0.615-0.467,1.488-0.344,1.953,0.27l2.351,3.104l5.911-9.492c0.407-0.652,1.267-0.852,1.921-0.445\r\n\tc0.653,0.406,0.854,1.266,0.446,1.92L9.478,16.34c-0.242,0.391-0.661,0.635-1.12,0.656C8.336,16.998,8.316,16.998,8.294,16.998z"
    }
  }]
};
exports.check = check;
var smallDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.418,7.859c0.271-0.268,0.709-0.268,0.978,0c0.27,0.268,0.272,0.701,0,0.969l-3.908,3.83\r\n\tc-0.27,0.268-0.707,0.268-0.979,0l-3.908-3.83c-0.27-0.267-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.978,0L10,11L13.418,7.859z\r\n\t"
    }
  }]
};
exports.smallDown = smallDown;
var smallLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.141,13.418c0.268,0.271,0.268,0.709,0,0.978c-0.268,0.27-0.701,0.272-0.969,0l-3.83-3.908\r\n\tc-0.268-0.27-0.268-0.707,0-0.979l3.83-3.908c0.267-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.978L9,10L12.141,13.418z"
    }
  }]
};
exports.smallLeft = smallLeft;
var smallRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,10L7.859,6.58c-0.268-0.27-0.268-0.707,0-0.978c0.268-0.27,0.701-0.27,0.969,0l3.83,3.908\r\n\tc0.268,0.271,0.268,0.709,0,0.979l-3.83,3.908c-0.267,0.272-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.978L11,10z"
    }
  }]
};
exports.smallRight = smallRight;
var smallUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.582,12.141c-0.271,0.268-0.709,0.268-0.978,0c-0.269-0.268-0.272-0.701,0-0.969l3.908-3.83\r\n\tc0.27-0.268,0.707-0.268,0.979,0l3.908,3.83c0.27,0.267,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.979,0L10,9L6.582,12.141z"
    }
  }]
};
exports.smallUp = smallUp;
var thinDown = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.418,6.109c0.272-0.268,0.709-0.268,0.979,0c0.27,0.268,0.271,0.701,0,0.969l-7.908,7.83\r\n\tc-0.27,0.268-0.707,0.268-0.979,0l-7.908-7.83c-0.27-0.268-0.27-0.701,0-0.969c0.271-0.268,0.709-0.268,0.979,0L10,13.25\r\n\tL17.418,6.109z"
    }
  }]
};
exports.thinDown = thinDown;
var thinLeft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.891,17.418c0.268,0.272,0.268,0.709,0,0.979c-0.268,0.27-0.701,0.271-0.969,0l-7.83-7.908\r\n\tc-0.268-0.27-0.268-0.707,0-0.979l7.83-7.908c0.268-0.27,0.701-0.27,0.969,0c0.268,0.271,0.268,0.709,0,0.979L6.75,10L13.891,17.418\r\n\tz"
    }
  }]
};
exports.thinLeft = thinLeft;
var thinRight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.25,10L6.109,2.58c-0.268-0.27-0.268-0.707,0-0.979c0.268-0.27,0.701-0.27,0.969,0l7.83,7.908\r\n\tc0.268,0.271,0.268,0.709,0,0.979l-7.83,7.908c-0.268,0.271-0.701,0.27-0.969,0c-0.268-0.269-0.268-0.707,0-0.979L13.25,10z"
    }
  }]
};
exports.thinRight = thinRight;
var thinUp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.582,13.891c-0.272,0.268-0.709,0.268-0.979,0s-0.271-0.701,0-0.969l7.908-7.83c0.27-0.268,0.707-0.268,0.979,0\r\n\tl7.908,7.83c0.27,0.268,0.27,0.701,0,0.969c-0.271,0.268-0.709,0.268-0.978,0L10,6.75L2.582,13.891z"
    }
  }]
};
exports.thinUp = thinUp;
var withCross = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z\r\n\t M14.789,13.061l-1.729,1.729L10,11.729l-3.061,3.06l-1.729-1.729L8.272,10L5.211,6.939L6.94,5.211L10,8.271l3.061-3.061\r\n\tl1.729,1.729L11.728,10L14.789,13.061z"
    }
  }]
};
exports.withCross = withCross;
var withMinus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z M15,11H5V9\r\n\th10V11z"
    }
  }]
};
exports.withMinus = withMinus;
var withPlus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.6c-4.639,0-8.4,3.761-8.4,8.4c0,4.639,3.761,8.4,8.4,8.4s8.4-3.761,8.4-8.4C18.4,5.361,14.639,1.6,10,1.6z M15,11h-4\r\n\tv4H9v-4H5V9h4V5h2v4h4V11z"
    }
  }]
};
exports.withPlus = withPlus;
var circle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6S5.802,2.4,10,2.4c4.197,0,7.601,3.402,7.601,7.6\r\n\tS14.197,17.599,10,17.599z"
    }
  }]
};
exports.circle = circle;
var clapperboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20,3v14c0,0.552-0.447,1-1,1H1c-0.553,0-1-0.448-1-1V3c0-0.553,0.447-1,1-1h1l3,3\r\n\th2.5l-3-3h3l3,3H13l-3-3h3l3,3h2.5l-3-3H19C19.553,2,20,2.448,20,3z"
    }
  }]
};
exports.clapperboard = clapperboard;
var computer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,0H4C2.9,0,2,0.899,2,2v15c0,0.552,0.447,1,1,1v2h14v-2c0.553,0,1-0.448,1-1V2C18,0.899,17.101,0,16,0z M14,15h-4v-1h4\r\n\tV15z M15,11H5V3h10V11z"
    }
  }]
};
exports.computer = computer;
var clipboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,2l-1.2,3H5.6l-1.2-3C3.629,2,3,2.629,3,3.4V18.6c0,0.77,0.629,1.4,1.399,1.4h11.2c0.77,0,1.4-0.631,1.4-1.4V3.4\r\n\tC17,2.629,16.369,2,15.6,2z M13.6,4l0.9-2h-2.181L11.6,0h-3.2L7.68,2H5.5l0.899,2H13.6z"
    }
  }]
};
exports.clipboard = clipboard;
var clock = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.303,0-9.601,4.298-9.601,9.6c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M9.999,17.6c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.601,3.402,7.601,7.6\r\n\tC17.6,14.197,14.196,17.6,9.999,17.6z M11,9.33V4H9v6.245l-3.546,2.048l1,1.732l4.115-2.377C10.807,11.511,11,11.175,11,10.9v-0.168\r\n\tl4.24-4.166c-0.198-0.271-0.411-0.529-0.647-0.766L11,9.33z"
    }
  }]
};
exports.clock = clock;
var cloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,11.32c0,2.584-2.144,4.68-4.787,4.68H3.617C1.619,16,0,14.416,0,12.463c0-1.951,1.619-3.535,3.617-3.535\r\n\tc0.146,0,0.288,0.012,0.429,0.027C4.009,8.709,3.989,8.457,3.989,8.199C3.989,5.328,6.37,3,9.309,3c2.407,0,4.439,1.562,5.096,3.707\r\n\tc0.263-0.043,0.532-0.066,0.809-0.066C17.856,6.641,20,8.734,20,11.32z"
    }
  }]
};
exports.cloud = cloud;
var code = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.719,14.75c-0.236,0-0.474-0.083-0.664-0.252L-0.005,10l5.341-4.748C5.748,4.887,6.38,4.922,6.747,5.335\r\n\tc0.367,0.413,0.33,1.045-0.083,1.412L3.005,10l3.378,3.002c0.413,0.367,0.45,0.999,0.083,1.412\r\n\tC6.269,14.637,5.994,14.75,5.719,14.75z M14.664,14.748L20.005,10l-5.06-4.498c-0.413-0.367-1.045-0.33-1.411,0.083\r\n\tc-0.367,0.413-0.33,1.045,0.083,1.412L16.995,10l-3.659,3.252c-0.413,0.367-0.45,0.999-0.083,1.412C13.45,14.887,13.725,15,14,15\r\n\tC14.236,15,14.474,14.917,14.664,14.748z M9.986,16.165l2-12c0.091-0.545-0.277-1.06-0.822-1.151\r\n\tc-0.547-0.092-1.061,0.277-1.15,0.822l-2,12c-0.091,0.545,0.277,1.06,0.822,1.151C8.892,16.996,8.946,17,9.001,17\r\n\tC9.481,17,9.905,16.653,9.986,16.165z"
    }
  }]
};
exports.code = code;
var cog = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.783,10c0-1.049,0.646-1.875,1.617-2.443c-0.176-0.584-0.407-1.145-0.692-1.672c-1.089,0.285-1.97-0.141-2.711-0.883\r\n\tc-0.741-0.74-0.968-1.621-0.683-2.711c-0.527-0.285-1.088-0.518-1.672-0.691C12.074,2.57,11.047,3.215,10,3.215\r\n\tc-1.048,0-2.074-0.645-2.643-1.615C6.772,1.773,6.213,2.006,5.686,2.291c0.285,1.09,0.059,1.971-0.684,2.711\r\n\tC4.262,5.744,3.381,6.17,2.291,5.885C2.006,6.412,1.774,6.973,1.6,7.557C2.57,8.125,3.215,8.951,3.215,10\r\n\tc0,1.047-0.645,2.074-1.615,2.643c0.175,0.584,0.406,1.144,0.691,1.672c1.09-0.285,1.971-0.059,2.711,0.682\r\n\tc0.741,0.742,0.969,1.623,0.684,2.711c0.527,0.285,1.087,0.518,1.672,0.693c0.568-0.973,1.595-1.617,2.643-1.617\r\n\tc1.047,0,2.074,0.645,2.643,1.617c0.584-0.176,1.144-0.408,1.672-0.693c-0.285-1.088-0.059-1.969,0.683-2.711\r\n\tc0.741-0.74,1.622-1.166,2.711-0.883c0.285-0.527,0.517-1.086,0.692-1.672C17.429,11.873,16.783,11.047,16.783,10z M10,13.652\r\n\tc-2.018,0-3.653-1.635-3.653-3.652c0-2.018,1.636-3.654,3.653-3.654c2.018,0,3.652,1.637,3.652,3.654\r\n\tC13.652,12.018,12.018,13.652,10,13.652z"
    }
  }]
};
exports.cog = cog;
var colours = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.179,5.998C2.756,5.648,2.122,5.708,1.771,6.13L0.494,7.669c-0.35,0.423-0.291,1.058,0.131,1.407l7.888,6.542L4.706,7.264\r\n\tL3.179,5.998z M7.013,2.683l-1.82,0.829C4.694,3.74,4.471,4.337,4.698,4.836l4.25,9.325l0.213-9.179L8.339,3.178\r\n\tC8.109,2.678,7.513,2.455,7.013,2.683z M14.211,2.887c0.013-0.55-0.427-1.01-0.976-1.023l-2-0.046\r\n\tc-0.549-0.013-1.009,0.427-1.022,0.976L9.974,13.037l4.19-8.167L14.211,2.887z M19.191,3.837l-1.779-0.913\r\n\tc-0.489-0.25-1.096-0.055-1.347,0.434L9.674,15.814c-0.251,0.489-0.056,1.096,0.434,1.347l1.779,0.913\r\n\tc0.489,0.251,1.095,0.056,1.346-0.433l6.391-12.456C19.875,4.694,19.68,4.088,19.191,3.837z M12.799,16.293\r\n\tc-0.252,0.492-0.855,0.686-1.346,0.434c-0.492-0.252-0.685-0.854-0.433-1.346c0.252-0.492,0.854-0.685,1.346-0.433\r\n\tC12.858,15.199,13.051,15.802,12.799,16.293z"
    }
  }]
};
exports.colours = colours;
var compass = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.454,14.548c0,0,4.568-0.627,6.518-2.576s2.576-6.518,2.576-6.518S9.979,6.081,8.03,8.03S5.454,14.548,5.454,14.548z\r\n\t M9.017,9.015c0.818-0.818,2.385-1.4,3.729-1.762c-0.361,1.342-0.945,2.92-1.76,3.732c-0.543,0.545-1.426,0.545-1.969,0\r\n\tC8.472,10.442,8.472,9.56,9.017,9.015z M10.001,0.4C4.698,0.4,0.4,4.698,0.4,10c0,5.303,4.298,9.601,9.601,9.601\r\n\tc5.301,0,9.6-4.298,9.6-9.601C19.601,4.698,15.302,0.4,10.001,0.4z M10,17.6c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6\r\n\tc4.197,0,7.601,3.402,7.601,7.6C17.601,14.197,14.197,17.6,10,17.6z"
    }
  }]
};
exports.compass = compass;
var fastBackward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.959,4.571L10.756,9.52c0,0-0.279,0.201-0.279,0.481s0.279,0.479,0.279,0.479l7.203,4.951\r\n\tC18.531,15.811,19,15.53,19,14.805V5.196C19,4.469,18.531,4.188,17.959,4.571z M8.883,4.571L1.68,9.52c0,0-0.279,0.201-0.279,0.481\r\n\ts0.279,0.479,0.279,0.479l7.203,4.951c0.572,0.381,1.041,0.1,1.041-0.625V5.196C9.924,4.469,9.455,4.188,8.883,4.571z"
    }
  }]
};
exports.fastBackward = fastBackward;
var fastForward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.244,9.52L2.041,4.571C1.469,4.188,1,4.469,1,5.196v9.609c0,0.725,0.469,1.006,1.041,0.625l7.203-4.951\r\n\tc0,0,0.279-0.199,0.279-0.478C9.523,9.721,9.244,9.52,9.244,9.52z M18.6,10.001c0,0.279-0.279,0.478-0.279,0.478l-7.203,4.951\r\n\tc-0.572,0.381-1.041,0.1-1.041-0.625V5.196c0-0.727,0.469-1.008,1.041-0.625L18.32,9.52C18.32,9.52,18.6,9.721,18.6,10.001z"
    }
  }]
};
exports.fastForward = fastForward;
var jumpToStart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.959,4.571L7.756,9.52c0,0-0.279,0.201-0.279,0.481s0.279,0.479,0.279,0.479l7.203,4.951\r\n\tC15.531,15.811,16,15.53,16,14.805V5.196C16,4.469,15.531,4.188,14.959,4.571z M6,4H5C4.447,4,4,4.048,4,4.6V15.4\r\n\tC4,15.952,4.447,16,5,16h1c0.553,0,1-0.048,1-0.6V4.6C7,4.048,6.553,4,6,4z"
    }
  }]
};
exports.jumpToStart = jumpToStart;
var next = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.244,9.52L5.041,4.571C4.469,4.188,4,4.469,4,5.196v9.609c0,0.725,0.469,1.006,1.041,0.625l7.203-4.951\r\n\tc0,0,0.279-0.199,0.279-0.478C12.523,9.721,12.244,9.52,12.244,9.52z M14,4h1c0.553,0,1,0.048,1,0.6V15.4c0,0.552-0.447,0.6-1,0.6\r\n\th-1c-0.553,0-1-0.048-1-0.6V4.6C13,4.048,13.447,4,14,4z"
    }
  }]
};
exports.next = next;
var paus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,3h-2c-0.553,0-1,0.048-1,0.6V16.4c0,0.552,0.447,0.6,1,0.6h2c0.553,0,1-0.048,1-0.6V3.6C16,3.048,15.553,3,15,3z M7,3H5\r\n\tC4.447,3,4,3.048,4,3.6V16.4C4,16.952,4.447,17,5,17h2c0.553,0,1-0.048,1-0.6V3.6C8,3.048,7.553,3,7,3z"
    }
  }]
};
exports.paus = paus;
var play = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,10.001c0,0.299-0.305,0.514-0.305,0.514l-8.561,5.303C5.51,16.227,5,15.924,5,15.149V4.852\r\n\tc0-0.777,0.51-1.078,1.135-0.67l8.561,5.305C14.695,9.487,15,9.702,15,10.001z"
    }
  }]
};
exports.play = play;
var record = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,3c-3.866,0-7,3.133-7,7c0,3.865,3.134,7,7,7s7-3.135,7-7C17,6.133,13.866,3,10,3z"
    }
  }]
};
exports.record = record;
var stop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,4.995v9.808C16,15.464,15.464,16,14.804,16H4.997C4.446,16,4,15.554,4,15.003V5.196C4,4.536,4.536,4,5.196,4h9.808\r\n\tC15.554,4,16,4.446,16,4.995z"
    }
  }]
};
exports.stop = stop;
var volume = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,13.805C19,14.462,18.462,15,17.805,15H1.533c-0.88,0-0.982-0.371-0.229-0.822l16.323-9.055C18.382,4.67,19,5.019,19,5.9\r\n\tV13.805z"
    }
  }]
};
exports.volume = volume;
var copy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,0H3C2.447,0,2,0.447,2,1v12c0,0.552,0.447,1,1,1h5v2h2v-2H8.001v-2H10v-2H8v2H4V2h6v4h2V1C12,0.448,11.553,0,11,0z M8,7\r\n\tv1h2V6H9C8.447,6,8,6.447,8,7z M12,20h2v-2h-2V20z M12,8h2V6h-2V8z M8,19c0,0.552,0.447,1,1,1h1v-2H8V19z M17,6h-1v2h2V7\r\n\tC18,6.448,17.553,6,17,6z M16,20h1c0.553,0,1-0.448,1-1v-1h-2V20z M16,12h2v-2h-2V12z M16,16h2v-2h-2V16z"
    }
  }]
};
exports.copy = copy;
var commonsAttribution = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.6,7.6v3.9h-1.1v4.6h-3v-4.6H7.4V7.6C7.4,7.3,7.7,7,8,7H12C12.3,7,12.6,7.3,12.6,7.6z M10,6.5c0.7,0,1.3-0.6,1.3-1.3\r\n\tc0-0.7-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.6-1.3,1.3C8.7,5.9,9.3,6.5,10,6.5z M19.6,10c0,2.7-0.9,4.9-2.7,6.7c-1.9,1.9-4.2,2.9-6.9,2.9\r\n\tc-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.9-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8C5.1,1.3,7.3,0.4,10,0.4c2.7,0,5,0.9,6.8,2.8\r\n\tC18.7,5,19.6,7.3,19.6,10z M17.9,10c0-2.2-0.8-4-2.3-5.6C14,2.9,12.2,2.1,10,2.1c-2.2,0-4,0.8-5.5,2.3C2.9,6,2.1,7.9,2.1,10\r\n\tc0,2.1,0.8,4,2.3,5.5s3.4,2.3,5.6,2.3c2.1,0,4-0.8,5.6-2.4C17.1,14,17.9,12.2,17.9,10z"
    }
  }]
};
exports.commonsAttribution = commonsAttribution;
var commonsNoderivs = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1s4,0.8,5.6,2.3\r\n\tc1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M6.6,10.8h7v1.7h-7V10.8z M6.6,7.7h7v1.7h-7V7.7z"
    }
  }]
};
exports.commonsNoderivs = commonsNoderivs;
var commonsNoncommercialEu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-0.9,0.1-1.8,0.4-2.6l2.5,1.1H4.9v1.1h0.9\r\n\tc0,0.2,0,0.3,0,0.5v0.3H4.9v1.1h1c0.1,0.9,0.5,1.5,0.9,2.1c0.9,1.2,2.3,1.8,3.9,1.8c1,0,2-0.3,2.5-0.6l-0.4-1.8\r\n\tc-0.3,0.2-1.1,0.4-1.8,0.4c-0.8,0-1.6-0.2-2.1-0.8c-0.2-0.3-0.4-0.6-0.5-1.1H12l5,2.2C16.6,14.4,16.1,15,15.6,15.5z M9.3,10.5\r\n\tL9.3,10.5L9.3,10.5L9.3,10.5z M12.4,9.7h0.1V8.6H9.8L8.7,8.1C8.8,7.9,8.9,7.7,9,7.5c0.5-0.6,1.2-0.9,2-0.9c0.7,0,1.4,0.2,1.8,0.4\r\n\tl0.5-1.8c-0.6-0.3-1.4-0.5-2.4-0.5C9.3,4.7,8,5.3,7.1,6.4C6.9,6.6,6.7,6.9,6.6,7.1L3.4,5.8c0.3-0.5,0.7-0.9,1.1-1.3\r\n\tC6,2.9,7.8,2.1,10,2.1c2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6c0,0.7-0.1,1.4-0.2,2L12.4,9.7z"
    }
  }]
};
exports.commonsNoncommercialEu = commonsNoncommercialEu;
var commonsNoncommercialUs = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10s0.9,4.9,2.8,6.8c1.9,1.9,4.1,2.8,6.8,2.8\r\n\tc2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7S18.7,5,16.8,3.2z M15.6,15.5c-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3\r\n\tC2.9,14,2.1,12.1,2.1,10c0-0.9,0.1-1.8,0.4-2.6l4.9,2.2c0.5,0.2,1,0.4,1.5,0.7l1.1,0.5l0.9,0.4c0.2,0.1,0.3,0.3,0.3,0.6\r\n\tc0,0.7-0.6,1-1.2,1c-0.9,0-1.5-0.3-2.1-0.9l-1.3,1.3c0.8,0.7,1.8,1.1,2.9,1.1v1.5h1.1v-1.5c1.3-0.1,2.4-0.9,2.6-2.1l3.6,1.6\r\n\tC16.6,14.4,16.1,15,15.6,15.5z M12.7,9.9c-0.5-0.2-1-0.4-1.5-0.7l-0.8-0.4L9.1,8.3C9.1,8.2,9,8.1,9,8c0-0.6,0.7-0.7,1.2-0.7\r\n\tc0.6,0,1.2,0.2,1.6,0.6l1.3-1.3c-0.8-0.6-1.7-0.8-2.4-0.9V4.2H9.6v1.5C8.4,5.7,7.4,6.3,7.1,7.4L3.4,5.7c0.3-0.5,0.7-0.9,1.1-1.3\r\n\tC6,2.9,7.8,2.1,10,2.1c2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6c0,0.7-0.1,1.4-0.2,2.1L12.7,9.9z"
    }
  }]
};
exports.commonsNoncommercialUs = commonsNoncommercialUs;
var commonsPublicDomain = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M8.1,7.3H5.5v5.3h1.3v-1.7h1c1.8,0,2.2-1.1,2.2-1.8\r\n\tC10.1,8,9.6,7.3,8.1,7.3z M7.9,9.9H6.8V8.3h1.1c0.6,0,0.9,0.3,0.9,0.8C8.8,9.5,8.5,9.9,7.9,9.9z M12.5,7.3h-2.1v5.3h2.1\r\n\tc1.6,0,2.7-0.8,2.7-2.7C15.2,8.1,14.1,7.3,12.5,7.3z M12.5,11.5h-0.8V8.4h0.8c1,0,1.4,0.7,1.4,1.5C13.9,10.8,13.5,11.5,12.5,11.5z"
    }
  }]
};
exports.commonsPublicDomain = commonsPublicDomain;
var commonsRemix = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M16.3,10.2l-1.9-0.8V7L8.5,4.6L5.9,5.7v2.7l0,0l-2.3,1\r\n\tv2.5l2.5,1.1l2.5-1L8.7,12l5,2.1l0.1,0l0.1,0l2.3-1l0.2-0.1v-2.7L16.3,10.2z M13.6,13.3L13.6,13.3L13.6,13.3l-4.4-1.8V9.8l4.4,1.8\r\n\tv0.1l0,0V13.3z M13.8,11.1l-1.4-0.6L14,9.9l1.4,0.6L13.8,11.1z M15.9,12.6l-1.7,0.7v-1.7l1.7-0.7V12.6z"
    }
  }]
};
exports.commonsRemix = commonsRemix;
var commonsShare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10c0,2.6,0.9,4.9,2.8,6.8\r\n\tc1.9,1.9,4.1,2.8,6.8,2.8c2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7C19.6,7.3,18.7,5,16.8,3.2z M15.6,15.5\r\n\tc-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3C2.9,14,2.1,12.1,2.1,10c0-2.1,0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1\r\n\tc2.2,0,4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z M13.9,7.2h-2.1V5.2c0-0.3-0.2-0.5-0.5-0.5H6.1\r\n\tc0,0,0,0,0,0c-0.3,0-0.5,0.3-0.5,0.5v7.1c0,0.3,0.2,0.5,0.5,0.5h2.1v2.1c0,0.3,0.2,0.5,0.5,0.5h5.2c0.3,0,0.5-0.2,0.5-0.5V7.8\r\n\tC14.5,7.5,14.2,7.2,13.9,7.2z M8.6,7.2c-0.3,0-0.5,0.3-0.5,0.5v3.9H6.6v-6h4.2v1.6H8.6C8.7,7.2,8.7,7.2,8.6,7.2z M13.4,14.3H9.2v-6\r\n\th4.2V14.3z"
    }
  }]
};
exports.commonsShare = commonsShare;
var commonsSharealike = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.8,3.2C15,1.3,12.7,0.4,10,0.4c-2.7,0-4.9,0.9-6.8,2.8C1.3,5.1,0.4,7.4,0.4,10s0.9,4.9,2.8,6.8c1.9,1.9,4.1,2.8,6.8,2.8\r\n\tc2.6,0,4.9-1,6.9-2.9c1.8-1.8,2.7-4.1,2.7-6.7S18.7,5,16.8,3.2z M15.6,15.5c-1.6,1.6-3.5,2.4-5.6,2.4c-2.1,0-4-0.8-5.6-2.3\r\n\tC2.9,14,2.1,12.1,2.1,10s0.8-4,2.4-5.6C6,2.9,7.8,2.1,10,2.1s4,0.8,5.6,2.3c1.5,1.5,2.3,3.4,2.3,5.6C17.9,12.2,17.1,14,15.6,15.5z\r\n\t M14.9,10.1c0,2.9-2,5.1-5,5.1c-2.1,0-3.9-1.3-4.2-3.8h2.4c0.1,1.3,0.9,1.7,2.1,1.7c1.4,0,2.3-1.3,2.3-3.2c0-2-0.8-3.1-2.2-3.1\r\n\tc-1.1,0-2,0.4-2.2,1.7l0.7,0l-1.9,1.9L5,8.6l0.8,0c0.4-2.4,2.1-3.7,4.2-3.7C13,4.9,14.9,7.2,14.9,10.1z"
    }
  }]
};
exports.commonsSharealike = commonsSharealike;
var commons = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.8,10.8l1.1,0.6c-0.2,0.4-0.6,0.8-1,1.1c-0.4,0.3-0.9,0.4-1.4,0.4c-0.8,0-1.5-0.2-2-0.8C5,11.6,4.8,10.9,4.8,10\r\n\tc0-0.9,0.3-1.6,0.8-2.1C6,7.4,6.7,7.1,7.5,7.1c1.1,0,2,0.4,2.4,1.3L8.7,9.1C8.5,8.8,8.4,8.6,8.2,8.5S7.8,8.4,7.7,8.4\r\n\tc-0.8,0-1.2,0.5-1.2,1.6c0,0.5,0.1,0.9,0.3,1.2c0.2,0.3,0.5,0.4,0.9,0.4C8.2,11.6,8.6,11.4,8.8,10.8z M13,11.6\r\n\tc-0.4,0-0.7-0.1-0.9-0.4c-0.2-0.3-0.3-0.7-0.3-1.2c0-1.1,0.4-1.6,1.2-1.6c0.2,0,0.4,0.1,0.5,0.2c0.2,0.1,0.4,0.3,0.5,0.6l1.2-0.6\r\n\tc-0.5-0.9-1.3-1.3-2.4-1.3c-0.8,0-1.4,0.3-1.9,0.8c-0.5,0.5-0.8,1.2-0.8,2.1c0,0.9,0.2,1.6,0.7,2.1c0.5,0.5,1.2,0.8,2,0.8\r\n\tc0.5,0,1-0.1,1.4-0.4c0.4-0.3,0.8-0.6,1-1.1l-1.2-0.6C13.9,11.4,13.5,11.6,13,11.6z M19.6,10c0,2.7-0.9,4.9-2.7,6.7\r\n\tc-1.9,1.9-4.2,2.9-6.9,2.9c-2.6,0-4.9-0.9-6.8-2.8c-1.9-1.9-2.8-4.1-2.8-6.8c0-2.6,0.9-4.9,2.8-6.8C5.1,1.3,7.3,0.4,10,0.4\r\n\tc2.7,0,5,0.9,6.8,2.8C18.7,5,19.6,7.3,19.6,10z M17.9,10c0-2.2-0.8-4-2.3-5.6C14,2.9,12.2,2.1,10,2.1c-2.2,0-4,0.8-5.5,2.3\r\n\tC2.9,6,2.1,7.9,2.1,10c0,2.1,0.8,4,2.3,5.5c1.6,1.6,3.4,2.3,5.6,2.3c2.1,0,4-0.8,5.6-2.4C17.1,14,17.9,12.2,17.9,10z"
    }
  }]
};
exports.commons = commons;
var card = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C0.899,3,0,3.9,0,5v10c0,1.1,0.899,2,2,2h16c1.1,0,2-0.9,2-2V5C20,3.9,19.1,3,18,3z M18,15H2V9h16V15z M18,6H2V5h16\r\n\tV6z M4,11.1v0.6h0.6v-0.6H4z M7.6,12.299V12.9h1.2v-0.601h0.6v-0.6H10v-0.6H8.8v0.6H8.199v0.6H7.6z M10,12.9v-0.601H9.399V12.9H10z\r\n\t M7,12.9v-0.601H5.8V12.9H7z M7.6,11.699h0.6v-0.6H7v1.199h0.6V11.699z M5.199,12.299H5.8v-0.6h0.6v-0.6h-1.2v0.6H4.6v0.6H4V12.9\r\n\th1.199V12.299z"
    }
  }]
};
exports.card = card;
var credit = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,16.755V19H9v-2.143c-1.712-0.1-3.066-0.589-4.241-1.797l1.718-1.74c0.859,0.87,2.023,1.16,3.282,1.16\r\n\tc1.565,0,2.405-0.599,2.405-1.702c0-0.483-0.133-0.889-0.42-1.16c-0.267-0.251-0.572-0.387-1.202-0.483L8.9,10.903\r\n\tc-1.164-0.174-2.022-0.541-2.634-1.141C5.618,9.105,5.293,8.216,5.293,7.055c0-2.155,1.382-3.743,3.707-4.1V1h2v1.932\r\n\tc1.382,0.145,2.465,0.62,3.415,1.551l-1.679,1.682c-0.859-0.832-1.889-0.947-2.787-0.947c-1.412,0-2.099,0.792-2.099,1.74\r\n\tc0,0.348,0.115,0.716,0.401,0.986c0.267,0.252,0.706,0.464,1.26,0.541l1.602,0.232c1.241,0.174,2.023,0.522,2.596,1.063\r\n\tc0.726,0.696,1.05,1.702,1.05,2.92C14.759,14.95,13.192,16.362,11,16.755z"
    }
  }]
};
exports.credit = credit;
var crop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,14V1H4v3H1v2h3v8c0,1.0996094,0.8989258,2,2,2h8v3h2v-3h3v-2H6z M14,13h2V6c0-1.0996094-0.8989258-2-2-2H7v2h7V13z"
    }
  }]
};
exports.crop = crop;
var cross = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.348,14.849c-0.469,0.469-1.229,0.469-1.697,0L10,11.819l-2.651,3.029c-0.469,0.469-1.229,0.469-1.697,0\r\n\tc-0.469-0.469-0.469-1.229,0-1.697l2.758-3.15L5.651,6.849c-0.469-0.469-0.469-1.228,0-1.697c0.469-0.469,1.228-0.469,1.697,0\r\n\tL10,8.183l2.651-3.031c0.469-0.469,1.228-0.469,1.697,0c0.469,0.469,0.469,1.229,0,1.697l-2.758,3.152l2.758,3.15\r\n\tC14.817,13.62,14.817,14.38,14.348,14.849z"
    }
  }]
};
exports.cross = cross;
var cup = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C5.721,1,3.06,2.41,3.205,3.555l1.442,13.467C4.705,17.482,6.868,18.998,10,19c3.131-0.002,5.295-1.518,5.351-1.979\r\n\tl1.442-13.467C16.938,2.41,14.279,1,10,1z M10,5.291C6.868,5.289,4.647,4.174,4.647,3.756C4.646,3.342,6.869,2.225,10,2.227\r\n\tc3.131-0.002,5.354,1.115,5.351,1.529C15.351,4.174,13.131,5.289,10,5.291z"
    }
  }]
};
exports.cup = cup;
var cw = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.315,10h-2.372V9.795c-0.108-4.434-3.724-7.996-8.169-7.996C4.259,1.799,0.6,5.471,0.6,10s3.659,8.199,8.174,8.199\r\n\tc1.898,0,3.645-0.65,5.033-1.738l-1.406-1.504c-1.016,0.748-2.27,1.193-3.627,1.193c-3.386,0-6.131-2.754-6.131-6.15\r\n\ts2.745-6.15,6.131-6.15c3.317,0,6.018,2.643,6.125,5.945V10h-2.672l3.494,3.894L19.315,10z"
    }
  }]
};
exports.cw = cw;
var cycle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.516,14.224c-2.262-2.432-2.222-6.244,0.128-8.611c0.962-0.969,2.164-1.547,3.414-1.736L8.989,1.8\r\n\tC7.234,2.013,5.537,2.796,4.192,4.151c-3.149,3.17-3.187,8.289-0.123,11.531l-1.741,1.752l5.51,0.301l-0.015-5.834L5.516,14.224z\r\n\t M12.163,2.265l0.015,5.834l2.307-2.322c2.262,2.434,2.222,6.246-0.128,8.611c-0.961,0.969-2.164,1.547-3.414,1.736l0.069,2.076\r\n\tc1.755-0.213,3.452-0.996,4.798-2.35c3.148-3.172,3.186-8.291,0.122-11.531l1.741-1.754L12.163,2.265z"
    }
  }]
};
exports.cycle = cycle;
var database = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.726,12.641c-0.843,1.363-3.535,2.361-6.726,2.361c-3.191,0-5.883-0.998-6.727-2.361C3.095,12.351,3,12.506,3,12.648\r\n\tc0,0.144,0,2.002,0,2.002C3,16.59,6.134,18.6,10,18.6s7-2.01,7-3.949c0,0,0-1.858,0-2.002C17,12.506,16.904,12.351,16.726,12.641z\r\n\t M16.737,7.525c-0.83,1.205-3.532,2.09-6.737,2.09c-3.205,0-5.908-0.885-6.738-2.09C3.091,7.277,3,7.412,3,7.523\r\n\tc0,0.113,0,2.357,0,2.357c0,1.762,3.134,3.189,7,3.189s7-1.428,7-3.189c0,0,0-2.244,0-2.357C17,7.412,16.908,7.277,16.737,7.525z\r\n\t M10,1C6.134,1,3,2.18,3,3.633v1.26c0,1.541,3.134,2.791,7,2.791s7-1.25,7-2.791v-1.26C17,2.18,13.866,1,10,1z"
    }
  }]
};
exports.database = database;
var pad = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6,0H4C3.448,0,3,0.448,3,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1\r\n\tC7,0.448,6.552,0,6,0z M11,0H9C8.448,0,8,0.448,8,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1C12,0.448,11.552,0,11,0z M16,0\r\n\th-2c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V1C17,0.448,16.552,0,16,0z M6,5H4C3.448,5,3,5.448,3,6v2\r\n\tc0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V6C7,5.448,6.552,5,6,5z M11,5H9C8.448,5,8,5.448,8,6v2c0,0.552,0.448,1,1,1h2\r\n\tc0.552,0,1-0.448,1-1V6C12,5.448,11.552,5,11,5z M16,5h-2c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1V6\r\n\tC17,5.448,16.552,5,16,5z M6,10H4c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C7,10.448,6.552,10,6,10z\r\n\t M11,10H9c-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C12,10.448,11.552,10,11,10z M11,16H9\r\n\tc-0.552,0-1,0.448-1,1v2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C12,16.448,11.552,16,11,16z M16,10h-2c-0.552,0-1,0.448-1,1\r\n\tv2c0,0.552,0.448,1,1,1h2c0.552,0,1-0.448,1-1v-2C17,10.448,16.552,10,16,10z"
    }
  }]
};
exports.pad = pad;
var direction = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.06,1.941c-0.586-0.586-1.144-0.033-3.041,0.879C9.944,5.259,1.1,10.216,1.1,10.216L8.699,11.3l1.085,7.599\r\n\tc0,0,4.958-8.843,7.396-13.916C18.092,3.085,18.645,2.527,18.06,1.941z M16.236,3.896l-5.519,10.247l-0.561-4.655L16.236,3.896z"
    }
  }]
};
exports.direction = direction;
var landscape = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,3H1C0.448,3,0,3.447,0,4v12c0,0.553,0.448,1,1,1h18c0.552,0,1-0.447,1-1V4C20,3.447,19.553,3,19,3z M18,15H2V5h16V15z"
    }
  }]
};
exports.landscape = landscape;
var document = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M15,17H5V3h10V17z"
    }
  }]
};
exports.document = document;
var documents = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.398,7.415l-7.444-1.996l-1.303-4.861c-0.109-0.406-0.545-0.642-0.973-0.529L0.602,2.461\r\n\tC0.174,2.575-0.084,2.999,0.025,3.405l3.23,12.051c0.109,0.406,0.544,0.643,0.971,0.527l3.613-0.967l-0.492,1.838\r\n\tc-0.109,0.406,0.149,0.83,0.577,0.943l8.11,2.174c0.428,0.115,0.862-0.121,0.972-0.529l2.97-11.084\r\n\tC20.084,7.952,19.826,7.528,19.398,7.415z M1.633,3.631l7.83-2.096l2.898,10.818l-7.83,2.096L1.633,3.631z M15.678,18.463\r\n\tL8.864,16.6L9.4,14.598l3.901-1.047c0.428-0.113,0.688-0.537,0.578-0.943l-1.508-5.627l5.947,1.631L15.678,18.463z"
    }
  }]
};
exports.documents = documents;
var single = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.8,10c0,1.215,0.986,2.2,2.201,2.2S12.2,11.214,12.2,10c0-1.215-0.984-2.199-2.199-2.199S7.8,8.785,7.8,10z"
    }
  }]
};
exports.single = single;
var threeHorizontal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,7.8C8.786,7.8,7.8,8.785,7.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,7.8,10.001,7.8z\r\n\t M3.001,7.8C1.786,7.8,0.8,8.785,0.8,10s0.986,2.2,2.201,2.2C4.216,12.2,5.2,11.214,5.2,10S4.216,7.8,3.001,7.8z M17.001,7.8\r\n\tC15.786,7.8,14.8,8.785,14.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S18.216,7.8,17.001,7.8z"
    }
  }]
};
exports.threeHorizontal = threeHorizontal;
var threeVertical = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,7.8C8.786,7.8,7.8,8.785,7.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,7.8,10.001,7.8z\r\n\t M10.001,5.2C11.216,5.2,12.2,4.214,12.2,3S11.216,0.8,10.001,0.8C8.786,0.8,7.8,1.785,7.8,3S8.786,5.2,10.001,5.2z M10.001,14.8\r\n\tC8.786,14.8,7.8,15.785,7.8,17s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,14.8,10.001,14.8z"
    }
  }]
};
exports.threeVertical = threeVertical;
var twoHorizontal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.001,7.8C12.786,7.8,11.8,8.785,11.8,10s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S15.216,7.8,14.001,7.8z\r\n\t M6.001,7.8C4.786,7.8,3.8,8.785,3.8,10s0.986,2.2,2.201,2.2C7.216,12.2,8.2,11.214,8.2,10S7.216,7.8,6.001,7.8z"
    }
  }]
};
exports.twoHorizontal = twoHorizontal;
var twoVertical = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,8.2C11.216,8.2,12.2,7.214,12.2,6S11.216,3.8,10.001,3.8C8.786,3.8,7.8,4.785,7.8,6S8.786,8.2,10.001,8.2z\r\n\t M10.001,11.8C8.786,11.8,7.8,12.785,7.8,14s0.986,2.2,2.201,2.2c1.215,0,2.199-0.985,2.199-2.2S11.216,11.8,10.001,11.8z"
    }
  }]
};
exports.twoVertical = twoVertical;
var download = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,7h-3V1H8v6H5l5,5L15,7z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757\r\n\tl3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408\r\n\tL5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449\r\n\tl0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074\r\n\tC20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  }]
};
exports.download = download;
var drink = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.538,2.639C17.932,2.094,18,1,18,1H2c0,0,0.068,1.094,0.462,1.639L9,11v6H7c-2,0-2,2-2,2h10c0,0,0-2-2-2h-2v-6\r\n\tL17.538,2.639z M9.4,6c0-0.885,0.716-1.6,1.6-1.6s1.6,0.715,1.6,1.6c0,0.883-0.716,1.6-1.6,1.6S9.4,6.883,9.4,6z"
    }
  }]
};
exports.drink = drink;
var drive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H5.546C4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927\r\n\tc-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18h14.383c0.755,0,1.399-0.546,1.523-1.291\r\n\tl0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M16.959,15.245C16.887,15.681,16.51,16,16.068,16H3.932\r\n\tc-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867c0.558,0,0.983,0.501,0.891,1.052\r\n\tL16.959,15.245z"
    }
  }]
};
exports.drive = drive;
var drop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.203,0.561c-0.027-0.215-0.38-0.215-0.406,0C8.914,7.668,4.399,9.133,4.399,14.073c0,3.053,2.564,5.527,5.601,5.527\r\n\tc3.036,0,5.6-2.475,5.6-5.527C15.6,9.133,11.086,7.668,10.203,0.561z M9.35,8.418C9.291,8.637,9.227,8.862,9.161,9.096\r\n\tc-0.401,1.424-0.856,3.039-0.856,4.906c0,1.012-0.598,1.371-1.156,1.371c-0.639,0-1.156-0.523-1.156-1.166\r\n\tc0-2.207,1.062-3.649,2-4.92c0.295-0.398,0.572-0.775,0.797-1.15C8.893,7.965,9.17,7.973,9.296,8.143\r\n\tC9.355,8.223,9.375,8.325,9.35,8.418z"
    }
  }]
};
exports.drop = drop;
var edit = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.561,2.439c-1.442-1.443-2.525-1.227-2.525-1.227L8.984,7.264L2.21,14.037L1.2,18.799l4.763-1.01l6.774-6.771\r\n\tl6.052-6.052C18.788,4.966,19.005,3.883,17.561,2.439z M5.68,17.217l-1.624,0.35c-0.156-0.293-0.345-0.586-0.69-0.932\r\n\tc-0.346-0.346-0.639-0.533-0.932-0.691l0.35-1.623l0.47-0.469c0,0,0.883,0.018,1.881,1.016c0.997,0.996,1.016,1.881,1.016,1.881\r\n\tL5.68,17.217z"
    }
  }]
};
exports.edit = edit;
var email = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.608,12.172c0,0.84,0.239,1.175,0.864,1.175c1.393,0,2.28-1.775,2.28-4.727c0-4.512-3.288-6.672-7.393-6.672\r\n\tc-4.223,0-8.064,2.832-8.064,8.184c0,5.112,3.36,7.896,8.52,7.896c1.752,0,2.928-0.192,4.727-0.792l0.386,1.607\r\n\tc-1.776,0.577-3.674,0.744-5.137,0.744c-6.768,0-10.393-3.72-10.393-9.456c0-5.784,4.201-9.72,9.985-9.72\r\n\tc6.024,0,9.215,3.6,9.215,8.016c0,3.744-1.175,6.6-4.871,6.6c-1.681,0-2.784-0.672-2.928-2.161\r\n\tc-0.432,1.656-1.584,2.161-3.145,2.161c-2.088,0-3.84-1.609-3.84-4.848c0-3.264,1.537-5.28,4.297-5.28\r\n\tc1.464,0,2.376,0.576,2.782,1.488l0.697-1.272h2.016v7.057H14.608z M11.657,9.004c0-1.319-0.985-1.872-1.801-1.872\r\n\tc-0.888,0-1.871,0.719-1.871,2.832c0,1.68,0.744,2.616,1.871,2.616c0.792,0,1.801-0.504,1.801-1.896V9.004z"
    }
  }]
};
exports.email = email;
var flirt = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.5,9.75C8.329,9.75,9,8.967,9,8S8.329,6.25,7.5,6.25S6,7.034,6,8S6.672,9.75,7.5,9.75z M10,0.4\r\n\tC4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601C19.6,4.698,15.301,0.4,10,0.4z M10,17.599\r\n\tc-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6S17.6,5.802,17.6,10C17.6,14.197,14.197,17.599,10,17.599z M14.341,11.336\r\n\tc-0.363-0.187-0.815-0.043-1.008,0.32c-0.034,0.065-0.869,1.593-3.332,1.593c-2.451,0-3.291-1.513-3.333-1.592\r\n\tc-0.188-0.365-0.632-0.514-1.004-0.329c-0.37,0.185-0.521,0.636-0.335,1.007c0.05,0.099,1.248,2.414,4.672,2.414\r\n\tc3.425,0,4.621-2.316,4.67-2.415C14.855,11.967,14.707,11.524,14.341,11.336z M11.25,8.75h2.5c0.414,0,0.75-0.336,0.75-0.75\r\n\tc0-0.414-0.336-0.75-0.75-0.75h-2.5c-0.414,0-0.75,0.336-0.75,0.75C10.5,8.415,10.836,8.75,11.25,8.75z"
    }
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }, {
    "name": "g",
    "attribs": {}
  }]
};
exports.flirt = flirt;
var happy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6S5.802,2.4,10,2.4c4.197,0,7.601,3.402,7.601,7.6\r\n\tS14.197,17.599,10,17.599z M7.501,9.75C8.329,9.75,9,8.967,9,8s-0.672-1.75-1.5-1.75s-1.5,0.783-1.5,1.75S6.672,9.75,7.501,9.75z\r\n\t M12.5,9.75C13.329,9.75,14,8.967,14,8s-0.672-1.75-1.5-1.75S11,7.034,11,8S11.672,9.75,12.5,9.75z M14.341,11.336\r\n\tc-0.363-0.186-0.815-0.043-1.008,0.32c-0.034,0.066-0.869,1.593-3.332,1.593c-2.451,0-3.291-1.513-3.333-1.592\r\n\tc-0.188-0.365-0.632-0.514-1.004-0.329c-0.37,0.186-0.52,0.636-0.335,1.007c0.05,0.099,1.248,2.414,4.672,2.414\r\n\tc3.425,0,4.621-2.316,4.67-2.415C14.855,11.967,14.707,11.524,14.341,11.336z"
    }
  }]
};
exports.happy = happy;
var neutral = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.6,3.402,7.6,7.6\r\n\tC17.6,14.197,14.197,17.599,10,17.599z M12.5,6.251C11.672,6.251,11,7.034,11,8s0.672,1.75,1.5,1.75C13.329,9.75,14,8.967,14,8\r\n\tS13.329,6.251,12.5,6.251z M7.501,9.75C8.329,9.75,9,8.967,9,8s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS6.672,9.75,7.501,9.75z M13,12.25h-6c-0.414,0-0.75,0.336-0.75,0.75c0,0.414,0.336,0.75,0.75,0.75h6c0.414,0,0.75-0.336,0.75-0.75\r\n\tC13.75,12.585,13.415,12.25,13,12.25z"
    }
  }]
};
exports.neutral = neutral;
var sad = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.001,0.4C4.698,0.4,0.4,4.698,0.4,10c0,5.303,4.298,9.601,9.601,9.601c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10.001,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6c4.197,0,7.6,3.402,7.6,7.6\r\n\tC17.6,14.197,14.197,17.599,10,17.599z M12.501,9.75c0.828,0,1.5-0.783,1.5-1.75s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS11.672,9.75,12.501,9.75z M7.501,9.75c0.828,0,1.5-0.783,1.5-1.75s-0.672-1.75-1.5-1.75c-0.828,0-1.5,0.783-1.5,1.75\r\n\tS6.672,9.75,7.501,9.75z M10.002,11.25c-3.424,0-4.622,2.315-4.672,2.414c-0.186,0.371-0.035,0.821,0.335,1.007\r\n\tC5.773,14.724,5.887,14.75,6,14.75c0.275,0,0.54-0.151,0.672-0.414c0.008-0.017,0.822-1.586,3.33-1.586\r\n\tc2.463,0,3.298,1.527,3.328,1.585c0.184,0.37,0.635,0.523,1.006,0.336c0.371-0.184,0.521-0.636,0.336-1.006\r\n\tC14.623,13.566,13.426,11.25,10.002,11.25z"
    }
  }]
};
exports.sad = sad;
var erase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H8.446c-0.44,0-1.071,0.236-1.402,0.525L0.248,9.473c-0.331,0.289-0.331,0.764,0,1.053l6.796,5.947\r\n\tC7.375,16.762,8.006,17,8.446,17H18c1.1,0,2-0.9,2-2V5C20,3.9,19.1,3,18,3z M15.191,14l-2.557-2.557L10.078,14l-1.443-1.443\r\n\tL11.191,10L8.635,7.443L10.078,6l2.557,2.555L15.19,6l1.444,1.443L14.078,10l2.557,2.555L15.191,14z"
    }
  }]
};
exports.erase = erase;
var eraser = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.998,4.18l-3.154-2.425c-0.872-0.671-2.135-0.506-2.807,0.365l-8.4,10.897c-0.671,0.871-0.507,2.132,0.365,2.803\r\n\tl3.153,2.425c0.872,0.671,2.135,0.506,2.807-0.365l8.401-10.897C18.034,6.112,17.87,4.851,16.998,4.18z M8.548,16.467l-0.537,0.681\r\n\tc-0.152,0.197-0.385,0.31-0.639,0.31c-0.124,0-0.309-0.029-0.485-0.164l-3.153-2.425c-0.168-0.129-0.275-0.317-0.303-0.53\r\n\tc-0.028-0.213,0.028-0.422,0.157-0.589l0.537-0.681c0.152-0.197,0.385-0.311,0.64-0.311c0.124,0,0.309,0.029,0.485,0.164\r\n\tl3.154,2.425c0.168,0.129,0.275,0.317,0.303,0.53C8.733,16.09,8.677,16.299,8.548,16.467z"
    }
  }]
};
exports.eraser = eraser;
var exportIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,15H2V6h2.595c0,0,0.689-0.896,2.17-2H1C0.447,4,0,4.449,0,5v11c0,0.553,0.447,1,1,1h15c0.553,0,1-0.447,1-1v-3.746\r\n\tl-2,1.645V15z M13.361,8.05v3.551L20,6.4l-6.639-4.999v3.131C5.3,4.532,5.3,12.5,5.3,12.5C7.582,8.752,8.986,8.05,13.361,8.05z"
    }
  }]
};
exports.exportIcon = exportIcon;
var withLine = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.5214844,1.4776001C18.131958,1.086853,17.4981079,1.086792,17.1074829,1.477478L1.4785156,17.1084595\r\n\tc-0.390625,0.390625-0.390625,1.0244141,0.0001221,1.4140015c0.390625,0.390686,1.0233765,0.390625,1.4140015-0.000061\r\n\tL18.5214233,2.8916016C18.9121704,2.5009766,18.9121704,1.8682251,18.5214844,1.4776001z M3.1083984,13.4973145l2.5593262-2.5584717\r\n\tC5.5981445,10.6357422,5.5546875,10.3234863,5.5546875,10c0-2.3789062,1.9902344-4.3085938,4.4453125-4.3085938\r\n\tc0.2861328,0,0.5644531,0.0314941,0.8354492,0.081665l1.2021484-1.2016602C11.394043,4.467041,10.7192383,4.4003906,10,4.4003906\r\n\tC3.4394531,4.4003906,0,9.2324219,0,10C0,10.4234619,1.057373,12.0908203,3.1083984,13.4973145z M16.8950195,6.5046387\r\n\tL14.3330078,9.065918C14.4018555,9.3674316,14.4443359,9.6784668,14.4443359,10\r\n\tc0,2.3789062-1.9892578,4.3066406-4.4443359,4.3066406c-0.2839355,0-0.5598145-0.0317383-0.8288574-0.0810547L7.967041,15.4291992\r\n\tC8.609375,15.5330811,9.2827148,15.5996094,10,15.5996094c6.5605469,0,10-4.8339844,10-5.5996094\r\n\tC20,9.5756836,18.9438477,7.9101562,16.8950195,6.5046387z"
    }
  }]
};
exports.withLine = withLine;
var eye = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,4.4C3.439,4.4,0,9.232,0,10c0,0.766,3.439,5.6,10,5.6c6.56,0,10-4.834,10-5.6C20,9.232,16.56,4.4,10,4.4z M10,14.307\r\n\tc-2.455,0-4.445-1.928-4.445-4.307c0-2.379,1.99-4.309,4.445-4.309c2.455,0,4.444,1.93,4.444,4.309\r\n\tC14.444,12.379,12.455,14.307,10,14.307z M10,10c-0.407-0.447,0.663-2.154,0-2.154c-1.228,0-2.223,0.965-2.223,2.154\r\n\tc0,1.189,0.995,2.154,2.223,2.154c1.227,0,2.223-0.965,2.223-2.154C12.223,9.453,10.346,10.379,10,10z"
    }
  }]
};
exports.eye = eye;
var feather = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.254,19.567c0.307-0.982,0.77-2.364,1.391-4.362c2.707-0.429,3.827,0.341,5.546-2.729\r\n\tc-1.395,0.427-3.077-0.792-2.987-1.321c0.091-0.528,3.913,0.381,6.416-3.173c-3.155,0.696-4.164-0.836-3.757-1.067\r\n\tc0.939-0.534,3.726-0.222,5.212-1.669c0.766-0.745,1.125-2.556,0.813-3.202c-0.374-0.781-2.656-1.946-3.914-1.836\r\n\tc-1.258,0.109-3.231,4.79-3.817,4.754C8.573,4.925,8.454,2.864,9.476,0.949c-1.077,0.477-3.051,1.959-3.67,3.226\r\n\tc-1.153,2.357,0.108,7.766-0.296,7.958c-0.405,0.193-1.766-2.481-2.172-3.694c-0.555,1.859-0.568,3.721,1.053,6.194\r\n\tc-0.611,1.623-0.945,3.491-0.996,4.441C3.371,19.833,4.119,19.996,4.254,19.567z"
    }
  }]
};
exports.feather = feather;
var fingerprint = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.6795855,7.8502398c-0.3737011,0.09375-0.6062469,0.4970703-0.5193815,0.9003906\r\n\tc0.7166376,3.3271484,0.8731756,6.8144531,0.4515181,10.0849619c-0.0524817,0.4106445,0.2126379,0.7895508,0.5926733,0.8461914\r\n\tc0.0325747,0.0048828,0.0651484,0.0073242,0.096818,0.0073242c0.3411264,0,0.6388206-0.2714844,0.6876822-0.6464844\r\n\tc0.4442797-3.4511728,0.2805023-7.1274424-0.4750433-10.6318369C10.4269867,8.0064898,10.0532856,7.7584429,9.6795855,7.8502398z\r\n\t M8.0689611,12.0733843c-0.3818445,0.0380859-0.6632514,0.4033203-0.6279626,0.815918\r\n\tc0.1692061,1.9672852,0.1248689,3.9091806-0.1321073,5.7714853c-0.0561004,0.409668,0.2063046,0.7915039,0.5854349,0.8520508\r\n\tc0.0343838,0.0058594,0.068768,0.0083008,0.1031523,0.0083008c0.3384123,0,0.6352015-0.2675781,0.6867771-0.6396484\r\n\tc0.2723579-1.980957,0.3203154-4.0439463,0.1411562-6.1308603C8.790122,12.3380327,8.439043,12.0304155,8.0689611,12.0733843z\r\n\t M9.1583948,5.4142046c-0.783596,0.1967773-1.4495621,0.7114258-1.8757439,1.4487305\r\n\tC6.8564687,7.6012163,6.7225518,8.4727983,6.9044256,9.3165483c0.08777,0.409668,0.1673961,0.8198242,0.2370691,1.2294922\r\n\tc0.0678635,0.4077148,0.4388499,0.6767578,0.8080268,0.6025391c0.3782248-0.074707,0.6279626-0.4658203,0.5582891-0.8730469\r\n\tc-0.0732918-0.4321289-0.156538-0.8647461-0.2497368-1.2983398c-0.097723-0.4541016-0.0253363-0.9228516,0.2044945-1.3203125\r\n\tc0.2298307-0.3979492,0.5890541-0.6757812,1.0098076-0.78125c0.8722706-0.2192383,1.7418261,0.3706055,1.9436064,1.309082\r\n\tc0.7464972,3.4614258,0.9419441,6.9296875,0.5809107,10.309083c-0.0443373,0.4116211,0.2298307,0.7836914,0.6107702,0.8310547\r\n\tc0.0271454,0.003418,0.0542908,0.0048828,0.0805311,0.0048828c0.3483658,0,0.6487741-0.2817383,0.6894922-0.6640625\r\n\tc0.3791304-3.5507822,0.1746349-7.1914072-0.6080561-10.8203135C12.3950253,6.1026812,10.7789717,5.0118608,9.1583948,5.4142046z\r\n\t M6.7478876,5.9469194c0.2388787-0.3251953,0.1873026-0.796875-0.1140108-1.0537109\r\n\tc-0.302218-0.2573242-0.7383533-0.2001953-0.9754229,0.1230469C5.5363002,5.1827593,5.4222894,5.3580523,5.3173275,5.5396929\r\n\tc-0.753736,1.3056641-0.9917102,2.8481445-0.6686802,4.34375c0.5935779,2.7563477,0.7320194,5.5878906,0.400846,8.1889658\r\n\tc-0.0524807,0.4101562,0.2135434,0.7885742,0.5935783,0.8452148c0.0325747,0.0043945,0.0642443,0.0068359,0.0959134,0.0068359\r\n\tc0.3420315,0,0.6397257-0.2719727,0.6876826-0.6479492c0.3537941-2.7802744,0.2072091-5.7998056-0.4243727-8.7329111\r\n\tC5.7643209,8.4386187,5.9398608,7.2984819,6.4972453,6.3326616C6.5750618,6.197896,6.6583076,6.069478,6.7478876,5.9469194z\r\n\t M15.10956,12.8189898c-0.3827496,0.0205078-0.6786337,0.3720703-0.6596327,0.7861328\r\n\tc0.0633392,1.3837891,0.0434332,2.7739267-0.058814,4.1313486c-0.0316696,0.4130859,0.253356,0.7749023,0.6361055,0.8085938\r\n\tc0.019002,0.0014648,0.0380039,0.0024414,0.0570049,0.0024414c0.3583193,0,0.6623468-0.296875,0.6913023-0.6889648\r\n\tc0.1076765-1.4223633,0.1284876-2.8784189,0.0624342-4.3276377C15.8189583,13.1168413,15.4841652,12.8082476,15.10956,12.8189898z\r\n\t M14.9403534,11.7843218c0.0289555,0,0.05791-0.0019531,0.0868654-0.0058594\r\n\tc0.3809395-0.0507812,0.6505833-0.4257812,0.6035318-0.8364258c-0.1402512-1.2226562-0.3447466-2.4550781-0.6053419-3.6625977\r\n\tc-0.5528603-2.574707-2.7498236-4.4438477-5.22367-4.4438477c-0.390893,0-0.781786,0.0478516-1.1636305,0.1425781\r\n\tc-0.3157902,0.0791016-0.625248,0.1889648-0.9211321,0.3271484C7.3649917,3.4698689,7.2030244,3.9117634,7.3550382,4.291646\r\n\tC7.507957,4.6720171,7.9178519,4.8473101,8.2689314,4.682271c0.2189732-0.1025391,0.449708-0.184082,0.6822538-0.2426758\r\n\tc0.2777872-0.0688477,0.5637178-0.1040039,0.8505535-0.1040039c1.8341208,0,3.4610329,1.3803711,3.8700228,3.2836914\r\n\tc0.2497368,1.1572266,0.4451838,2.3374023,0.5800056,3.5073242C14.2951994,11.5064898,14.5947027,11.7843218,14.9403534,11.7843218z\r\n\t M17.282093,6.7164507c-0.3157921-1.4726562-1.0152359-2.8251951-2.0205193-3.913574\r\n\tc-0.2705488-0.2929688-0.7103033-0.2920532-0.9826622,0.0009155c-0.2723579,0.2924805-0.2723579,0.7734375-0.0018091,1.0664062\r\n\tc0.822504,0.8906248,1.3934612,2.0072629,1.6513424,3.2074583c0.6469641,3.003418,0.9365149,6.0850124,0.860507,9.0986834\r\n\tC16.7789993,16.5904026,17.0812168,17,17.4648705,17h0.0190029c0.3755093,0,0.684063-0.3749294,0.6949196-0.782156\r\n\tC18.257515,13.0757551,17.9562016,9.8443804,17.282093,6.7164507z M3.3900077,12.8546343\r\n\tc0.0334792,0,0.0678635-0.0024414,0.1022475-0.0078125c0.3791301-0.0600586,0.6415353-0.4414062,0.5863395-0.8510742\r\n\tc-0.0841506-0.6181641-0.1954465-1.2524414-0.332078-1.8867188C3.3673866,8.3546343,3.6460788,6.5435991,4.5319219,5.0108843\r\n\tc0.8831291-1.5297849,2.2675419-2.597656,3.8944526-3.0063474c1.4052248-0.3491211,2.9009333-0.1430664,4.1930523,0.5581055\r\n\tc0.3411264,0.1875,0.7600698,0.0371094,0.9328947-0.3325195c0.1728258-0.3701172,0.0343838-0.8212891-0.3085518-1.0073242\r\n\tc-1.5789547-0.8579102-3.4076462-1.105957-5.1304712-0.6796875c-1.9897542,0.5-3.6809092,1.8046875-4.7612944,3.6738279\r\n\tC2.2698097,6.0909624,1.929588,8.3043413,2.3928685,10.4488726c0.1275833,0.59375,0.2316403,1.1870117,0.3103619,1.7646484\r\n\tC2.7539017,12.5865679,3.0506909,12.8546343,3.3900077,12.8546343z M3.5972173,14h-0.023526\r\n\tc-0.3836544,0-0.684063,0.2493391-0.6713951,0.6634016c0.0271454,0.8476562,0.0036194,1.5799913-0.0696731,2.3895617\r\n\tc-0.0380034,0.4121094,0.2415936,0.777544,0.6234381,0.8180714c0.0226212,0.0024414,0.0461471,0.0025425,0.0687683,0.0025425\r\n\tc0.3528895,0,0.6551077-0.2373772,0.6903965-0.6245842c0.0796266-0.875,0.1058669-1.7228241,0.0769119-2.6368866\r\n\tC4.2785654,14.2068329,3.9700134,14,3.5972173,14z"
    }
  }]
};
exports.fingerprint = fingerprint;
var flag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.926,5.584c-9.339,13.568-6.142-0.26-14.037,6.357L6.684,19H4.665L1,4.59l1.85-0.664\r\n\tc8.849-6.471,4.228,5.82,15.637,1.254C18.851,5.033,19.142,5.27,18.926,5.584z"
    }
  }]
};
exports.flag = flag;
var flash = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.803,18.998c-0.194-0.127,3.153-7.16,3.038-7.469c-0.116-0.309-3.665-1.436-3.838-1.979\r\n\tc-0.174-0.543,7.007-8.707,7.196-8.549c0.188,0.158-3.129,7.238-3.039,7.469c0.091,0.23,3.728,1.404,3.838,1.979\r\n\tC14.109,11.024,6.996,19.125,6.803,18.998z"
    }
  }]
};
exports.flash = flash;
var flashlight = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.115,2.884c-1.676-1.676-3.779-2.288-4.449-1.618L9.97,3.962C9.561,4.372,9.204,5.741,9.368,7.126l-8.161,8.161\r\n\tc-0.484,0.484-0.092,1.66,0.876,2.629c0.968,0.969,2.146,1.359,2.629,0.877l8.161-8.162c1.386,0.164,2.755-0.193,3.164-0.601\r\n\tl2.696-2.697C19.403,6.663,18.791,4.559,17.115,2.884z M8.141,11.039C7.768,10.667,7.89,9.943,8.41,9.422\r\n\tc0.521-0.521,1.246-0.643,1.618-0.27c0.372,0.371,0.251,1.097-0.27,1.617C9.237,11.291,8.513,11.412,8.141,11.039z M14.891,5.108\r\n\tc-1.298-1.297-1.623-3.01-1.508-3.125c0.115-0.116,1.76,0.277,3.059,1.575c1.298,1.298,1.688,2.946,1.575,3.059\r\n\tC17.905,6.729,16.188,6.407,14.891,5.108z"
    }
  }]
};
exports.flashlight = flashlight;
var branch = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.4,4c0-1.326-1.074-2.4-2.4-2.4S11.6,2.674,11.6,4c0,0.961,0.568,1.784,1.384,2.167c-0.082,1.584-1.27,2.122-3.335,2.896\r\n\tC8.779,9.39,7.82,9.752,7,10.297V6.176C7.825,5.796,8.4,4.967,8.4,4c0-1.326-1.074-2.4-2.4-2.4S3.6,2.674,3.6,4\r\n\tc0,0.967,0.576,1.796,1.4,2.176v7.649C4.175,14.204,3.6,15.033,3.6,16c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4\r\n\tc0-0.961-0.568-1.784-1.384-2.167c0.082-1.583,1.271-2.122,3.335-2.896c2.03-0.762,4.541-1.711,4.64-4.756\r\n\tC15.82,5.803,16.4,4.971,16.4,4z M6,2.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385\r\n\tC5.235,5.385,4.616,4.764,4.616,4C4.616,3.234,5.235,2.615,6,2.615z M6,17.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C7.384,16.764,6.764,17.385,6,17.385z M14,5.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC15.384,4.764,14.764,5.385,14,5.385z"
    }
  }]
};
exports.branch = branch;
var cascade = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,14.6c-0.967,0-1.796,0.576-2.176,1.4H8.5C7.672,16,7,15.328,7,14.5v-3.85C7.456,10.868,7.961,11,8.5,11h3.324\r\n\tc0.38,0.824,1.208,1.4,2.176,1.4c1.326,0,2.4-1.075,2.4-2.4S15.326,7.6,14,7.6c-0.967,0-1.796,0.576-2.176,1.4H8.5\r\n\tC7.672,9,7,8.328,7,7.5V5.176C7.825,4.796,8.4,3.967,8.4,3c0-1.326-1.074-2.4-2.4-2.4S3.6,1.674,3.6,3\r\n\tc0,0.967,0.576,1.796,1.4,2.176V14.5C5,16.433,6.567,18,8.5,18h3.324c0.38,0.824,1.208,1.4,2.176,1.4c1.326,0,2.4-1.075,2.4-2.4\r\n\tS15.326,14.6,14,14.6z M14,8.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tC12.616,9.234,13.235,8.615,14,8.615z M6,1.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385\r\n\tC5.235,4.385,4.616,3.764,4.616,3C4.616,2.234,5.235,1.615,6,1.615z M14,18.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C15.384,17.764,14.764,18.385,14,18.385z"
    }
  }]
};
exports.cascade = cascade;
var line = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,13.824V6.176c0.825-0.38,1.4-1.208,1.4-2.176c0-1.326-1.074-2.4-2.4-2.4S7.6,2.674,7.6,4c0,0.967,0.576,1.796,1.4,2.176\r\n\tv7.649C8.175,14.204,7.6,15.033,7.6,16c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C12.4,15.033,11.825,14.204,11,13.824z\r\n\t M10,2.615c0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C9.235,5.385,8.616,4.764,8.616,4\r\n\tC8.616,3.234,9.235,2.615,10,2.615z M10,17.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C11.384,16.764,10.764,17.385,10,17.385z"
    }
  }]
};
exports.line = line;
var parallel = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.4,4c0-1.326-1.074-2.4-2.4-2.4S3.6,2.674,3.6,4c0,0.967,0.576,1.796,1.4,2.176v7.649C4.175,14.204,3.6,15.033,3.6,16\r\n\tc0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V6.176C7.825,5.796,8.4,4.967,8.4,4z M7.384,16\r\n\tc0,0.764-0.62,1.385-1.384,1.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tC6.764,14.615,7.384,15.234,7.384,16z M6,5.385C5.235,5.385,4.616,4.764,4.616,4c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C7.384,4.764,6.764,5.385,6,5.385z M15,13.824V6.176c0.825-0.38,1.4-1.208,1.4-2.176\r\n\tc0-1.326-1.074-2.4-2.4-2.4S11.6,2.674,11.6,4c0,0.967,0.576,1.796,1.4,2.176v7.649c-0.825,0.38-1.4,1.208-1.4,2.176\r\n\tc0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C16.4,15.033,15.825,14.204,15,13.824z M12.616,4c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C13.235,5.385,12.616,4.764,12.616,4z M14,17.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC15.384,16.764,14.764,17.385,14,17.385z"
    }
  }]
};
exports.parallel = parallel;
var tree = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,14.824V12.5c0-1.933-1.567-3.5-3.5-3.5h-2C11.672,9,11,8.328,11,7.5V5.176c0.825-0.38,1.4-1.208,1.4-2.176\r\n\tc0-1.326-1.074-2.4-2.4-2.4S7.6,1.674,7.6,3c0,0.967,0.576,1.796,1.4,2.176V7.5C9,8.328,8.328,9,7.5,9h-2C3.567,9,2,10.567,2,12.5\r\n\tv2.324C1.175,15.204,0.6,16.033,0.6,17c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V12.5\r\n\tC4,11.672,4.672,11,5.5,11h2c0.539,0,1.044-0.132,1.5-0.35v4.174C8.175,15.204,7.6,16.033,7.6,17c0,1.326,1.074,2.4,2.4,2.4\r\n\ts2.4-1.075,2.4-2.4c0-0.967-0.576-1.796-1.4-2.176V10.65c0.456,0.218,0.961,0.35,1.5,0.35h2c0.828,0,1.5,0.672,1.5,1.5v2.324\r\n\tc-0.825,0.38-1.4,1.208-1.4,2.176c0,1.326,1.074,2.4,2.4,2.4s2.4-1.075,2.4-2.4C19.4,16.033,18.825,15.204,18,14.824z M10,1.615\r\n\tc0.764,0,1.384,0.619,1.384,1.385c0,0.764-0.62,1.385-1.384,1.385C9.235,4.385,8.616,3.764,8.616,3\r\n\tC8.616,2.234,9.235,1.615,10,1.615z M3,18.385c-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385\r\n\tc0.764,0,1.384,0.619,1.384,1.385C4.384,17.764,3.764,18.385,3,18.385z M10,18.385c-0.766,0-1.385-0.621-1.385-1.385\r\n\tc0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385C11.384,17.764,10.764,18.385,10,18.385z M17,18.385\r\n\tc-0.766,0-1.385-0.621-1.385-1.385c0-0.766,0.619-1.385,1.385-1.385c0.764,0,1.384,0.619,1.384,1.385\r\n\tC18.384,17.764,17.764,18.385,17,18.385z"
    }
  }]
};
exports.tree = tree;
var flower = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.6591797,8.7595215c0.4396973-1.0861816-0.3630371-2.5083008-1.2099609-3.4055176\r\n\tc0.3283691-1.1893311,0.3718262-2.8215332-0.5253906-3.5754395c-0.8969727-0.7540283-2.4973145-0.4300537-3.6125488,0.0980225\r\n\tC6.2817383,1.1970215,4.7426758,0.651123,3.748291,1.2713623C2.7543945,1.8916016,2.5678711,3.513916,2.7253418,4.7375488\r\n\tc-0.9645996,0.7692871-1.9592285,2.064209-1.6765137,3.201416s1.7678223,1.815918,2.9804688,2.0440674\r\n\tc0.4333496,1.1551514,1.357666,2.5012207,2.5266113,2.5838623c0.828125,0.0585938,1.619873-0.53125,2.223877-1.2633057\r\n\tc1.2209473,1.5201416,2.0817871,3.1278076,2.5551758,4.706543C10.6123047,14.9285889,9.1147461,14,6,14\r\n\tc0,4.1550293,3.0419922,5.0028076,5,5.0028076l3.2001953,0.0020752c0-2.7229004-0.986084-5.909668-3.2895508-8.9008789\r\n\tC11.692627,9.8570557,12.388916,9.4267578,12.6591797,8.7595215z M8.2827148,8.5396729\r\n\tC7.1357422,9.255127,5.6259766,8.9055176,4.9106445,7.7585449C4.1950684,6.6116943,4.5446777,5.1018066,5.6916504,4.3863525\r\n\tS8.3483887,4.020752,9.0639648,5.1674805C9.7792969,6.3144531,9.4296875,7.8242188,8.2827148,8.5396729z M14.0200195,12.2478027\r\n\tc1.0825195,2.1699219,1.6687012,4.4530029,1.6774902,6.7053223C18.9963379,16.5820312,19,12.2062988,19,8.0028076\r\n\tC19,8.0028076,15.3293457,9.0374756,14.0200195,12.2478027z"
    }
  }]
};
exports.flower = flower;
var images = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M12.438,8.375c0.518,0,0.938,0.42,0.938,0.938\r\n\tc0,0.518-0.42,0.938-0.938,0.938S11.5,9.83,11.5,9.312C11.5,8.795,11.92,8.375,12.438,8.375z M5.5,14l2.486-5.714l2.827,4.576\r\n\tl2.424-1.204L14.5,14H5.5z"
    }
  }]
};
exports.images = images;
var music = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M11.942,12.521c-0.128,0.265-0.258,0.279-0.202,0\r\n\tc0.146-0.721,0.047-2.269-1.043-2.441v3.294c0,0.674-0.311,1.262-1.136,1.528c-0.802,0.256-1.699-0.011-1.908-0.586\r\n\tc-0.21-0.576,0.261-1.276,1.052-1.564c0.442-0.161,0.954-0.203,1.299-0.07V8h0.694C10.697,9.633,13.516,9.275,11.942,12.521z"
    }
  }]
};
exports.music = music;
var video = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,2.799C18.293,2.359,17.749,2,17.195,2H2.805c-0.555,0-1.099,0.359-1.21,0.799L1.394,4h17.211L18.405,2.799z\r\n\t M19.412,5H0.587C0.245,5-0.022,5.294,0.01,5.635l0.923,11.669C0.971,17.698,1.303,18,1.699,18H18.3\r\n\tc0.397,0,0.728-0.302,0.766-0.696l0.923-11.669C20.022,5.294,19.754,5,19.412,5z M8,14V9l4.383,2.5L8,14z"
    }
  }]
};
exports.video = video;
var folder = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.405,4.799C18.294,4.359,17.75,4,17.195,4h-6.814C9.827,4,9.051,3.682,8.659,3.293L8.063,2.705\r\n\tC7.671,2.316,6.896,2,6.342,2H3.087C2.532,2,2.028,2.447,1.967,2.994L1.675,6h16.931L18.405,4.799z M19.412,7H0.588\r\n\tc-0.342,0-0.61,0.294-0.577,0.635l0.923,9.669C0.971,17.698,1.303,18,1.7,18H18.3c0.397,0,0.728-0.302,0.766-0.696l0.923-9.669\r\n\tC20.022,7.294,19.754,7,19.412,7z"
    }
  }]
};
exports.folder = folder;
var forward = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12,11.874v4.357l7-6.69l-7-6.572v3.983c-8.775,0-11,9.732-11,9.732C3.484,12.296,7.237,11.874,12,11.874z"
    }
  }]
};
exports.forward = forward;
var funnel = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1C5.092,1,2,2.512,2,4.001v2c0,0.918,6,6,6,6v6c-0.001,0.684,1,1,2,1s2.001-0.316,2-1v-6c0,0,6-5.082,6-6v-2\r\n\tC18,2.512,14.908,1,10,1z M10,6.123C6.409,6.122,3.862,4.79,3.862,4.292C3.86,3.797,6.41,2.461,10,2.463\r\n\tc3.59-0.002,6.14,1.334,6.138,1.828C16.138,4.79,13.591,6.122,10,6.123z"
    }
  }]
};
exports.funnel = funnel;
var controller = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.444,9.361c-0.882-4.926-2.854-6.379-3.903-6.379\r\n\tc-1.637,0-2.057,1.217-5.541,1.258C6.516,4.199,6.096,2.982,4.459,2.982c-1.049,0-3.022,1.453-3.904,6.379\r\n\tc-0.503,2.812-1.049,7.01,0.252,7.514c1.619,0.627,2.168-0.941,3.946-2.266C6.558,13.266,7.424,12.95,10,12.95\r\n\tc2.576,0,3.442,0.316,5.247,1.659c1.778,1.324,2.327,2.893,3.946,2.266C20.494,16.371,19.948,12.174,19.444,9.361z M6,10\r\n\tc-1.105,0-2-0.896-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C8,9.104,7.104,10,6,10z M13,10c-0.553,0-1-0.447-1-1s0.447-1,1-1\r\n\tc0.553,0,1,0.447,1,1S13.553,10,13,10z M15,8c-0.553,0-1-0.447-1-1s0.447-1,1-1c0.553,0,1,0.447,1,1S15.553,8,15,8z"
    }
  }]
};
exports.controller = controller;
var gauge = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.127,13.6c-0.689,1.197-0.225,2.18,0.732,2.732c0.956,0.553,2.041,0.465,2.732-0.732\r\n\tc0.689-1.195,5.047-11.865,4.668-12.084C15.88,3.297,8.817,12.404,8.127,13.6z M10,6c0.438,0,0.864,0.037,1.281,0.109\r\n\tc0.438-0.549,0.928-1.154,1.405-1.728C11.834,4.135,10.934,4,10,4C4.393,4,0,8.729,0,14.766c0,0.371,0.016,0.742,0.049,1.103\r\n\tc0.049,0.551,0.54,0.955,1.084,0.908c0.551-0.051,0.957-0.535,0.908-1.086C2.014,15.389,2,15.076,2,14.766C2,9.85,5.514,6,10,6z\r\n\t M17.219,7.25C16.94,8,16.645,8.764,16.385,9.424C17.4,10.894,18,12.738,18,14.766c0,0.316-0.015,0.635-0.043,0.943\r\n\tc-0.05,0.551,0.355,1.037,0.905,1.088c0.03,0.002,0.061,0.004,0.092,0.004c0.511,0,0.948-0.391,0.995-0.91\r\n\tC19.982,15.521,20,15.143,20,14.766C20,11.812,18.947,9.176,17.219,7.25z"
    }
  }]
};
exports.gauge = gauge;
var globe = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.295,0-9.601,4.307-9.601,9.6c0,5.293,4.306,9.6,9.601,9.6c5.293,0,9.6-4.307,9.6-9.6\r\n\tC19.6,4.707,15.293,0.4,10,0.4z M18.188,10c0,1.873-0.636,3.6-1.696,4.98c-0.3-0.234-0.619-0.867-0.319-1.523\r\n\tc0.303-0.66,0.382-2.188,0.312-2.783c-0.066-0.594-0.375-2.025-1.214-2.039c-0.838-0.012-1.413-0.289-1.911-1.283\r\n\tc-1.033-2.068,1.939-2.465,0.906-3.609c-0.289-0.322-1.783,1.322-2.002-0.869C12.25,2.717,12.399,2.482,12.6,2.238\r\n\tC15.844,3.328,18.188,6.395,18.188,10z M8.875,1.893C8.679,2.275,8.162,2.43,7.848,2.717C7.164,3.336,6.87,3.25,6.502,3.844\r\n\tC6.131,4.438,4.935,5.293,4.935,5.723s0.604,0.936,0.906,0.838c0.302-0.1,1.099-0.094,1.567,0.07\r\n\tc0.469,0.166,3.914,0.332,2.816,3.244c-0.348,0.926-1.873,0.77-2.279,2.303c-0.061,0.225-0.272,1.186-0.285,1.5\r\n\tc-0.025,0.486,0.344,2.318-0.125,2.318c-0.471,0-1.738-1.639-1.738-1.936c0-0.297-0.328-1.338-0.328-2.23\r\n\tc0-0.891-1.518-0.877-1.518-2.062c0-1.068,0.823-1.6,0.638-2.113c-0.181-0.51-1.627-0.527-2.23-0.59\r\n\tC3.412,4.334,5.889,2.307,8.875,1.893z M7.424,17.77c0.492-0.26,0.542-0.596,0.988-0.613c0.51-0.023,0.925-0.199,1.5-0.326\r\n\tc0.51-0.111,1.423-0.629,2.226-0.695c0.678-0.055,2.015,0.035,2.375,0.689c-1.295,0.861-2.848,1.363-4.514,1.363\r\n\tC9.1,18.188,8.234,18.039,7.424,17.77z"
    }
  }]
};
exports.globe = globe;
var cap = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.302,12.238c0.464,1.879,1.054,2.701,3.022,3.562C8.293,16.66,9.228,17.6,10,17.6c0.771,0,1.648-0.822,3.616-1.684\r\n\tc1.969-0.861,1.443-1.123,1.907-3.002L10,15.6L3.302,12.238z M19.511,7.336l-8.325-4.662c-0.652-0.365-1.72-0.365-2.372,0\r\n\tL0.488,7.336c-0.652,0.365-0.652,0.963,0,1.328l8.325,4.662c0.652,0.365,1.72,0.365,2.372,0l5.382-3.014l-5.836-1.367\r\n\tC10.506,9,10.259,9.031,10,9.031c-1.052,0-1.904-0.506-1.904-1.131c0-0.627,0.853-1.133,1.904-1.133c0.816,0,1.51,0.307,1.78,0.734\r\n\tl6.182,2.029l1.549-0.867C20.162,8.299,20.162,7.701,19.511,7.336z M16.967,16.17c-0.065,0.385,1.283,1.018,1.411-0.107\r\n\tc0.579-5.072-0.416-6.531-0.416-6.531l-1.395,0.781C16.567,10.312,17.75,11.438,16.967,16.17z"
    }
  }]
};
exports.cap = cap;
var grid = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M8,4H5C4.447,4,4,4.447,4,5v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1V5\r\n\tC9,4.448,8.553,4,8,4z M15,4h-3c-0.553,0-1,0.447-1,1v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1V5C16,4.448,15.553,4,15,4z M8,11\r\n\tH5c-0.553,0-1,0.447-1,1v3c0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1v-3C9,11.448,8.553,11,8,11z M15,11h-3c-0.553,0-1,0.447-1,1v3\r\n\tc0,0.552,0.447,1,1,1h3c0.553,0,1-0.448,1-1v-3C16,11.448,15.553,11,15,11z"
    }
  }]
};
exports.grid = grid;
var hand = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.924,17.315c-0.057,0.174-0.193,0.367-0.416,0.432c-0.161,0.047-5.488,1.59-5.652,1.633\r\n\tc-0.469,0.125-0.795,0.033-1.009-0.156c-0.326-0.287-4.093-2.85-8.845-3.092c-0.508-0.025-0.259-1.951,1.193-1.951\r\n\tc0.995,0,3.904,0.723,4.255,0.371c0.271-0.272,0.394-1.879-0.737-4.683l0,0L4.438,4.232C4.222,3.697,4.482,3.089,5.016,2.873\r\n\tc0.535-0.216,1.145,0.043,1.359,0.578c0,0,1.791,4.438,1.986,4.919c0.193,0.48,0.431,0.662,0.69,0.562\r\n\tC9.282,8.844,9.33,8.69,9.19,8.223L7.144,2.195C6.958,1.649,7.25,1.057,7.796,0.871c0.547-0.187,1.141,0.106,1.325,0.652\r\n\tl1.946,5.732c0.172,0.504,0.354,0.768,0.642,0.646c0.173-0.073,0.161-0.338,0.115-0.569l-1.366-5.471\r\n\tc-0.14-0.561,0.201-1.127,0.761-1.267c0.56-0.139,1.125,0.2,1.266,0.761l1.26,5.042c0.184,0.741,0.353,1.008,0.646,0.935\r\n\tc0.299-0.073,0.285-0.319,0.244-0.522c-0.095-0.475-0.872-4.328-0.872-4.328c-0.103-0.515,0.23-1.015,0.744-1.118\r\n\tc0.513-0.103,1.014,0.23,1.116,0.743l0.948,4.711l0.001,0.001c0,0,0,0,0,0.001l0.568,2.825c0.124,0.533,0.266,1.035,0.45,1.527\r\n\tC18.675,14.061,18.109,16.736,17.924,17.315z"
    }
  }]
};
exports.hand = hand;
var outlined = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.19,4.156c-1.672-1.535-4.383-1.535-6.055,0L10,5.197L8.864,4.156c-1.672-1.535-4.382-1.535-6.054,0\r\n\tc-1.881,1.726-1.881,4.519,0,6.245L10,17l7.19-6.599C19.07,8.675,19.07,5.881,17.19,4.156z M16.124,9.375L10,15.09L3.875,9.375\r\n\tC3.258,8.808,3.019,8.068,3.019,7.281s0.138-1.433,0.756-1.999C4.32,4.781,5.053,4.505,5.838,4.505c0.784,0,1.517,0.476,2.062,0.978\r\n\tL10,7.308l2.099-1.826c0.546-0.502,1.278-0.978,2.063-0.978s1.518,0.276,2.063,0.777c0.618,0.566,0.755,1.212,0.755,1.999\r\n\tS16.742,8.808,16.124,9.375z"
    }
  }]
};
exports.outlined = outlined;
var heart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.19,4.155c-1.672-1.534-4.383-1.534-6.055,0L10,5.197L8.864,4.155c-1.672-1.534-4.382-1.534-6.054,0\r\n\tc-1.881,1.727-1.881,4.52,0,6.246L10,17l7.19-6.599C19.07,8.675,19.07,5.881,17.19,4.155z"
    }
  }]
};
exports.heart = heart;
var withCircle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4c-5.302,0-9.6,4.298-9.6,9.6s4.298,9.6,9.6,9.6c5.301,0,9.6-4.298,9.6-9.601C19.6,4.698,15.301,0.4,10,0.4z\r\n\t M9.849,15.599H9.798c-0.782-0.023-1.334-0.6-1.311-1.371c0.022-0.758,0.587-1.309,1.343-1.309l0.046,0.002\r\n\tc0.804,0.023,1.35,0.594,1.327,1.387C11.18,15.068,10.625,15.599,9.849,15.599z M13.14,9.068c-0.184,0.26-0.588,0.586-1.098,0.983\r\n\tl-0.562,0.387c-0.308,0.24-0.494,0.467-0.563,0.688c-0.056,0.174-0.082,0.221-0.087,0.576v0.09H8.685l0.006-0.182\r\n\tc0.027-0.744,0.045-1.184,0.354-1.547c0.485-0.568,1.555-1.258,1.6-1.287c0.154-0.115,0.283-0.246,0.379-0.387\r\n\tc0.225-0.311,0.324-0.555,0.324-0.793c0-0.334-0.098-0.643-0.293-0.916c-0.188-0.266-0.545-0.398-1.061-0.398\r\n\tc-0.512,0-0.863,0.162-1.072,0.496c-0.216,0.341-0.325,0.7-0.325,1.067v0.092H6.386L6.39,7.841c0.057-1.353,0.541-2.328,1.435-2.897\r\n\tC8.388,4.583,9.089,4.4,9.906,4.4c1.068,0,1.972,0.26,2.682,0.772c0.721,0.519,1.086,1.297,1.086,2.311\r\n\tC13.673,8.05,13.494,8.583,13.14,9.068z"
    }
  }]
};
exports.withCircle = withCircle;
var help = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.help = help;
var home = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.672,11H17v6c0,0.445-0.194,1-1,1h-4v-6H8v6H4c-0.806,0-1-0.555-1-1v-6H1.328c-0.598,0-0.47-0.324-0.06-0.748L9.292,2.22\r\n\tC9.487,2.018,9.743,1.918,10,1.908c0.257,0.01,0.513,0.109,0.708,0.312l8.023,8.031C19.142,10.676,19.27,11,18.672,11z"
    }
  }]
};
exports.home = home;
var glass = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,4.576c0-2.139,0-2.348,0-2.348C15.6,1.439,13.092,0,10,0C6.907,0,4.4,1.439,4.4,2.228c0,0,0,0.209,0,2.348\r\n\tC4.4,6.717,8.277,8.484,8.277,10c0,1.514-3.877,3.281-3.877,5.422c0,2.141,0,2.35,0,2.35C4.4,18.56,6.907,20,10,20\r\n\tc3.092,0,5.6-1.44,5.6-2.229c0,0,0-0.209,0-2.35c0-2.141-3.877-3.908-3.877-5.422C11.723,8.484,15.6,6.717,15.6,4.576z M5.941,2.328\r\n\tc0.696-0.439,2-1.082,4.114-1.082c2.113,0,4.006,1.082,4.006,1.082c0.142,0.086,0.698,0.383,0.317,0.609\r\n\tC13.54,3.434,11.9,3.957,10,3.957c-1.9,0-3.484-0.576-4.324-1.074C5.295,2.658,5.941,2.328,5.941,2.328z M10.501,10\r\n\tc0,1.193,0.996,1.961,2.051,2.986c0.771,0.748,1.826,1.773,1.826,2.435v1.328c-0.97-0.483-3.872-0.955-3.872-2.504\r\n\tc0-0.783-1.013-0.783-1.013,0c0,1.549-2.902,2.021-3.872,2.504v-1.328c0-0.662,1.056-1.688,1.826-2.435\r\n\tC8.502,11.961,9.498,11.193,9.498,10c0-1.193-0.996-1.961-2.051-2.986c-0.771-0.75-1.826-1.775-1.826-2.438L5.575,3.578\r\n\tC6.601,4.131,8.227,4.656,10,4.656c1.772,0,3.406-0.525,4.433-1.078l-0.055,0.998c0,0.662-1.056,1.688-1.826,2.438\r\n\tC11.498,8.039,10.501,8.807,10.501,10z"
    }
  }]
};
exports.glass = glass;
var inverted = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C1.447,3,1,3.447,1,4v12c0,0.552,0.447,1,1,1h16c0.553,0,1-0.448,1-1V4C19,3.448,18.553,3,18,3z M13.25,6.5\r\n\tc0.69,0,1.25,0.56,1.25,1.25S13.94,9,13.25,9S12,8.44,12,7.75S12.56,6.5,13.25,6.5z M4,14l3.314-7.619l3.769,6.102l3.231-1.605\r\n\tL16,14H4z"
    }
  }]
};
exports.inverted = inverted;
var image = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19,2H1C0.447,2,0,2.447,0,3v14c0,0.552,0.447,1,1,1h18c0.553,0,1-0.448,1-1V3\r\n\tC20,2.448,19.553,2,19,2z M18,16H2V4h16V16z M14.315,10.877l-3.231,1.605L7.314,6.381L4,14h12L14.315,10.877z M13.25,9\r\n\tc0.69,0,1.25-0.56,1.25-1.25S13.94,6.5,13.25,6.5S12,7.06,12,7.75S12.56,9,13.25,9z"
    }
  }]
};
exports.image = image;
var inbox = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.253,9.542c-0.388-0.416-2.265-2.271-3.122-3.118C15.868,6.165,15.492,6,15.098,6H4.902c-0.394,0-0.77,0.165-1.033,0.424\r\n\tC3.011,7.271,1.135,9.125,0.747,9.542c-0.485,0.521-0.723,0.902-0.624,1.449s0.466,2.654,0.556,3.074\r\n\tC0.767,14.484,1.363,15,1.919,15h16.162c0.556,0,1.152-0.516,1.241-0.935c0.089-0.42,0.457-2.527,0.556-3.074\r\n\tS19.739,10.062,19.253,9.542z M14.014,10.003c-0.101,0-0.193,0.052-0.238,0.133L12.966,12H7.034l-0.809-1.864\r\n\tc-0.045-0.081-0.137-0.133-0.238-0.133H2.473L4.495,8h11.01l2.023,2.003H14.014z"
    }
  }]
};
exports.inbox = inbox;
var infinity = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.902,5.6c-2.079,0-4.358,1.158-5.902,2.916C8.455,6.758,6.175,5.6,4.096,5.6C2.116,5.6,0,6.756,0,10\r\n\tc0,3.244,2.116,4.398,4.096,4.4l0,0c2.079,0,4.358-1.158,5.903-2.916c1.544,1.758,3.823,2.916,5.902,2.916\r\n\tC17.882,14.4,20,13.244,20,10C20,6.756,17.882,5.6,15.902,5.6z M4.096,12.641C2.584,12.641,1.8,11.752,1.8,10\r\n\tc0-1.752,0.784-2.641,2.296-2.641c1.673,0,3.614,1.086,4.807,2.641C7.71,11.555,5.769,12.641,4.096,12.641z M15.902,12.641\r\n\tc-1.673,0-3.614-1.086-4.807-2.641c1.192-1.555,3.135-2.641,4.807-2.641c1.512,0,2.298,0.889,2.298,2.641\r\n\tC18.2,11.752,17.414,12.641,15.902,12.641z"
    }
  }]
};
exports.infinity = infinity;
var info = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.432,0c1.34,0,2.01,0.912,2.01,1.957c0,1.305-1.164,2.512-2.679,2.512c-1.269,0-2.009-0.75-1.974-1.99\r\n\tC9.789,1.436,10.67,0,12.432,0z M8.309,20c-1.058,0-1.833-0.652-1.093-3.524l1.214-5.092c0.211-0.814,0.246-1.141,0-1.141\r\n\tc-0.317,0-1.689,0.562-2.502,1.117L5.4,10.48c2.572-2.186,5.531-3.467,6.801-3.467c1.057,0,1.233,1.273,0.705,3.23l-1.391,5.352\r\n\tc-0.246,0.945-0.141,1.271,0.106,1.271c0.317,0,1.357-0.392,2.379-1.207l0.6,0.814C12.098,19.02,9.365,20,8.309,20z"
    }
  }]
};
exports.info = info;
var install = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H12.02l0.38,4.065h2.7L10,10.293L4.9,6.065h2.7L7.98,2H5.546\r\n\tC4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927c-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18\r\n\th14.383c0.755,0,1.399-0.546,1.523-1.291l0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M16.959,15.245\r\n\tC16.887,15.681,16.51,16,16.068,16H3.932c-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867\r\n\tc0.558,0,0.983,0.501,0.891,1.052L16.959,15.245z"
    }
  }]
};
exports.install = install;
var key = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.691,4.725c-0.503-2.977-3.22-4.967-6.069-4.441C8.772,0.809,6.366,3.1,6.869,6.079c0.107,0.641,0.408,1.644,0.763,2.365\r\n\tl-5.175,7.723c-0.191,0.285-0.299,0.799-0.242,1.141l0.333,1.971c0.058,0.342,0.372,0.572,0.7,0.514l1.516-0.281\r\n\tc0.328-0.059,0.744-0.348,0.924-0.639l2.047-3.311l0.018-0.022l1.386-0.256l2.39-3.879c0.785,0.139,1.912,0.092,2.578-0.031\r\n\tC16.955,10.848,18.194,7.704,17.691,4.725z M15.166,6.252c-0.784,1.17-1.584,0.346-2.703-0.475\r\n\tc-1.119-0.818-2.135-1.322-1.352-2.492c0.784-1.17,2.326-1.455,3.447-0.635C15.678,3.469,15.949,5.082,15.166,6.252z"
    }
  }]
};
exports.key = key;
var keyboard = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.6,4h-17.2C0.629,4,0,4.629,0,5.4V14.6C0,15.369,0.629,16,1.399,16h17.2c0.77,0,1.4-0.631,1.4-1.4V5.4\r\n\tC20,4.629,19.369,4,18.6,4z M11,6h2v2h-2V6z M14,9v2h-2V9H14z M8,6h2v2H8V6z M11,9v2H9V9H11z M5,6h2v2H5V6z M8,9v2H6V9H8z M2,6h2v2\r\n\tH2V6z M5,9v2H3V9H5z M4,14H2v-2h2V14z M15,14H5v-2h10V14z M18,14h-2v-2h2V14z M15,11V9h2v2H15z M18,8h-4V6h4V8z"
    }
  }]
};
exports.keyboard = keyboard;
var flask = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.432,15C14.387,9.893,12,8.547,12,6V3h0.5C12.776,3,13,2.776,13,2.5v-1\r\n\tC13,1.224,12.776,1,12.5,1h-5C7.224,1,7,1.224,7,1.5v1C7,2.776,7.224,3,7.5,3H8v3c0,2.547-2.387,3.893-4.432,9\r\n\tC2.917,16.625,1.245,19,10,19S17.083,16.625,16.432,15z M14.815,16.751C14.113,16.961,12.716,17.2,10,17.2s-4.113-0.239-4.815-0.449\r\n\tc-0.249-0.074-0.346-0.363-0.258-0.628c0.22-0.67,0.635-1.828,1.411-3.121c1.896-3.159,3.863,0.497,5.5,0.497\r\n\tc1.637,0,1.188-1.561,1.824-0.497c0.774,1.294,1.191,2.451,1.411,3.121C15.161,16.388,15.064,16.676,14.815,16.751z"
    }
  }]
};
exports.flask = flask;
var landline = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.902,0.25C3.498-0.027,2.115,0.875,1.833,2.273c-1.105,5.455-1.105,9.997,0,15.454C2.08,18.952,3.17,19.8,4.388,19.8\r\n\tc0.17,0,0.342-0.016,0.515-0.05c1.412-0.279,2.329-1.638,2.046-3.036c-0.978-4.832-0.978-8.598,0-13.43\r\n\tC7.231,1.888,6.314,0.529,4.902,0.25z M17,2H8.436c0.073,0.467,0.081,0.951-0.017,1.44c-0.936,4.72-0.936,8.398,0,13.12\r\n\tc0.098,0.49,0.09,0.973,0.017,1.44H17c1.1,0,2-0.9,2-2V4C19,2.9,18.101,2,17,2z M12,14.5c-0.828,0-1.5-0.672-1.5-1.5\r\n\ts0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5S12.828,14.5,12,14.5z M17,9h-7V5h7V9z"
    }
  }]
};
exports.landline = landline;
var language = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.753,10.909c-0.624-1.707-2.366-2.726-4.661-2.726c-0.09,0-0.176,0.002-0.262,0.006l-0.016-2.063\r\n\tc0,0,3.41-0.588,3.525-0.607s0.133-0.119,0.109-0.231c-0.023-0.111-0.167-0.883-0.188-0.976c-0.027-0.131-0.102-0.127-0.207-0.109\r\n\tc-0.104,0.018-3.25,0.461-3.25,0.461s-0.012-1.953-0.013-2.078c-0.001-0.125-0.069-0.158-0.194-0.156\r\n\tc-0.125,0.002-0.92,0.014-1.025,0.016c-0.105,0.002-0.164,0.049-0.162,0.148c0.002,0.1,0.033,2.307,0.033,2.307\r\n\ts-3.061,0.527-3.144,0.543c-0.084,0.014-0.17,0.053-0.151,0.143c0.019,0.09,0.19,1.094,0.208,1.172\r\n\tc0.018,0.08,0.072,0.129,0.188,0.107c0.115-0.019,2.924-0.504,2.924-0.504l0.035,2.018c-1.077,0.281-1.801,0.824-2.256,1.303\r\n\tc-0.768,0.807-1.207,1.887-1.207,2.963c0,1.586,0.971,2.529,2.328,2.695c3.162,0.387,5.119-3.06,5.769-4.715\r\n\tc1.097,1.506,0.256,4.354-2.094,5.98c-0.043,0.029-0.098,0.129-0.033,0.207c0.065,0.078,0.541,0.662,0.619,0.756\r\n\tc0.08,0.096,0.206,0.059,0.256,0.023C19.394,15.862,20.545,13.077,19.753,10.909z M12.367,14.097\r\n\tc-0.966-0.121-0.944-0.914-0.944-1.453c0-0.773,0.327-1.58,0.876-2.156c0.335-0.354,0.75-0.621,1.229-0.799l0.082,4.277\r\n\tC13.225,14.097,12.811,14.151,12.367,14.097z M14.794,13.544l0.046-4.109c0.084-0.004,0.166-0.01,0.252-0.01\r\n\tc0.773,0,1.494,0.145,1.885,0.361C17.368,10.003,15.954,12.499,14.794,13.544z M5.844,5.876C5.814,5.782,5.741,5.731,5.648,5.731\r\n\th-1.95c-0.093,0-0.165,0.051-0.194,0.144c-0.412,1.299-3.48,10.99-3.496,11.041c-0.017,0.051-0.011,0.076,0.062,0.076h1.733\r\n\tc0.075,0,0.099-0.023,0.114-0.072c0.015-0.051,1.008-3.318,1.008-3.318h3.496c0,0,0.992,3.268,1.008,3.318\r\n\tc0.016,0.049,0.039,0.072,0.113,0.072h1.734c0.072,0,0.078-0.025,0.062-0.076C9.324,16.866,6.255,7.175,5.844,5.876z M3.226,12.194\r\n\tl1.447-5.25l1.447,5.25H3.226z"
    }
  }]
};
exports.language = language;
var laptop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.754,15.631C19.507,15.26,18,13,18,13V4c0-1.102-0.9-2-2-2H4C2.899,2,2,2.898,2,4v9c0,0-1.507,2.26-1.754,2.631\r\n\tC0,16,0,16.213,0,16.5V17c0,0.5,0.5,1,0.999,1h18.002C19.5,18,20,17.5,20,17v-0.5C20,16.213,20,16,19.754,15.631z M7,16l0.6-1h4.8\r\n\tl0.6,1H7z M16,12H4V4h12V12z"
    }
  }]
};
exports.laptop = laptop;
var layers = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.248,11.601c0.45,0.313,1.05,0.313,1.5,0l9.088-5.281c0.236-0.164,0.21-0.518-0.048-0.646l-9.205-3.537\r\n\tc-0.368-0.183-0.802-0.183-1.17,0L0.208,5.674C-0.05,5.801-0.076,6.156,0.16,6.32L9.248,11.601z M19.788,10.811l-2.486-1.233\r\n\tl-5.725,3.327c-0.469,0.309-1.014,0.471-1.579,0.471s-1.11-0.163-1.579-0.471L2.698,9.576l-2.49,1.234\r\n\tc-0.258,0.128-0.284,0.482-0.048,0.646l9.088,6.309c0.45,0.313,1.05,0.313,1.5,0l9.088-6.309\r\n\tC20.072,11.293,20.046,10.939,19.788,10.811z"
    }
  }]
};
exports.layers = layers;
var leaf = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.025,3.587c-4.356,2.556-4.044,7.806-7.096,10.175c-2.297,1.783-5.538,0.88-7.412,0.113c0,0-1.27,1.603-2.181,3.74\r\n\tc-0.305,0.717-1.644-0.073-1.409-0.68C3.905,9.25,14.037,5.416,14.037,5.416S6.888,5.113,2.11,11.356\r\n\tC1.982,9.93,1.77,6.072,5.47,3.706C10.486,0.495,20.042,2.991,19.025,3.587z"
    }
  }]
};
exports.leaf = leaf;
var lifebuoy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.788,3.212c-3.749-3.749-9.827-3.749-13.575,0c-3.75,3.75-3.75,9.828-0.002,13.576c3.75,3.75,9.828,3.75,13.578,0\r\n\tC20.537,13.039,20.537,6.961,16.788,3.212z M6.748,13.252c-1.797-1.797-1.797-4.709,0-6.505c1.795-1.796,4.709-1.796,6.506,0\r\n\tc1.797,1.797,1.795,4.709,0,6.505C11.457,15.049,8.545,15.049,6.748,13.252z M15.347,12.879c0.968-1.799,0.969-3.959,0-5.759\r\n\tl1.783-0.96c1.289,2.391,1.289,5.29,0.002,7.678L15.347,12.879z M13.839,2.869l-0.961,1.784c-1.799-0.967-3.959-0.967-5.756,0\r\n\tL6.161,2.87C8.551,1.582,11.448,1.582,13.839,2.869z M2.87,6.16l1.784,0.961c-0.968,1.798-0.968,3.957-0.001,5.756l-1.784,0.961\r\n\tC1.581,11.449,1.582,8.551,2.87,6.16z M6.159,17.129l0.961-1.783c1.799,0.969,3.96,0.969,5.759,0l0.961,1.785\r\n\tC11.448,18.418,8.55,18.418,6.159,17.129z"
    }
  }]
};
exports.lifebuoy = lifebuoy;
var bulb = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M7.186,19.172C7.975,19.682,8.887,20.027,10,20\r\n\tc1.111,0.027,2.025-0.318,2.814-0.828L12.797,17H7.203L7.186,19.172z M12.697,16c0-4.357,4.63-5.848,4.283-10.188\r\n\tC16.762,3.074,14.907,0.002,10,0.002c-4.907,0-6.762,3.072-6.981,5.811C2.672,10.152,7.303,11.643,7.303,16H12.697z M5,6\r\n\tc0.207-2.598,2.113-4,5-4c2.886,0,4.654,1.371,4.861,3.969c0.113,1.424-0.705,2.373-1.809,3.926C12.238,11.041,11.449,12.238,11,14\r\n\tH9c-0.449-1.762-1.238-2.959-2.053-4.106C5.844,8.342,4.886,7.424,5,6z"
    }
  }]
};
exports.bulb = bulb;
var link = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.859,14.691l-0.81,0.805c-0.701,0.695-1.843,0.695-2.545,0c-0.336-0.334-0.521-0.779-0.521-1.252\r\n\tc0-0.473,0.186-0.916,0.521-1.252l2.98-2.955c0.617-0.613,1.779-1.515,2.626-0.675c0.389,0.386,1.016,0.384,1.403-0.005\r\n\tc0.385-0.389,0.383-1.017-0.006-1.402C10.069,6.527,7.941,6.791,6.088,8.63l-2.98,2.956C2.393,12.295,2,13.24,2,14.244\r\n\tc0,1.006,0.394,1.949,1.108,2.658c0.736,0.73,1.702,1.096,2.669,1.096c0.967,0,1.934-0.365,2.669-1.096l0.811-0.805\r\n\tc0.389-0.385,0.391-1.012,0.005-1.4C8.875,14.309,8.248,14.307,7.859,14.691z M16.891,3.207c-1.547-1.534-3.709-1.617-5.139-0.197\r\n\tl-1.009,1.002c-0.389,0.386-0.392,1.013-0.006,1.401c0.386,0.389,1.013,0.391,1.402,0.005l1.01-1.001\r\n\tc0.74-0.736,1.711-0.431,2.346,0.197c0.336,0.335,0.522,0.779,0.522,1.252s-0.186,0.917-0.522,1.251l-3.18,3.154\r\n\tc-1.454,1.441-2.136,0.766-2.427,0.477c-0.389-0.386-1.016-0.383-1.401,0.005c-0.386,0.389-0.384,1.017,0.005,1.401\r\n\tc0.668,0.662,1.43,0.99,2.228,0.99c0.977,0,2.01-0.492,2.993-1.467l3.18-3.153C17.605,7.814,18,6.87,18,5.866\r\n\tC18,4.861,17.605,3.917,16.891,3.207z"
    }
  }]
};
exports.link = link;
var list = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.4,9H8.6C8.048,9,8,9.447,8,10s0.048,1,0.6,1H14.4c0.552,0,0.6-0.447,0.6-1S14.952,9,14.4,9z M16.4,14H8.6\r\n\tC8.048,14,8,14.447,8,15s0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1S16.952,14,16.4,14z M8.6,6H16.4C16.952,6,17,5.553,17,5\r\n\ts-0.048-1-0.6-1H8.6C8.048,4,8,4.447,8,5S8.048,6,8.6,6z M5.4,9H3.6C3.048,9,3,9.447,3,10s0.048,1,0.6,1H5.4C5.952,11,6,10.553,6,10\r\n\tS5.952,9,5.4,9z M5.4,14H3.6C3.048,14,3,14.447,3,15s0.048,1,0.6,1H5.4C5.952,16,6,15.553,6,15S5.952,14,5.4,14z M5.4,4H3.6\r\n\tC3.048,4,3,4.447,3,5s0.048,1,0.6,1H5.4C5.952,6,6,5.553,6,5S5.952,4,5.4,4z"
    }
  }]
};
exports.list = list;
var pin = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.009c-2.762,0-5,2.229-5,4.99c0,4.774,5,11,5,11s5-6.227,5-11C15,4.239,12.762,2.009,10,2.009z M10,9.76\r\n\tc-1.492,0-2.7-1.209-2.7-2.7s1.208-2.7,2.7-2.7c1.49,0,2.699,1.209,2.699,2.7S11.49,9.76,10,9.76z"
    }
  }]
};
exports.pin = pin;
var location = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.367,18.102L18,14h-1.5l0.833,4H2.667L3.5,14H2l-1.368,4.102C0.285,19.146,0.9,20,2,20h16\r\n\tC19.1,20,19.715,19.146,19.367,18.102z M15,5c0-2.761-2.238-5-5-5S5,2.239,5,5c0,4.775,5,10,5,10S15,9.775,15,5z M7.3,5.06\r\n\tc0-1.491,1.208-2.699,2.7-2.699s2.7,1.208,2.7,2.699c0,1.492-1.209,2.7-2.7,2.7S7.3,6.551,7.3,5.06z"
    }
  }]
};
exports.location = location;
var open = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.8,8H14V5.6C14,2.703,12.665,1,10,1C7.334,1,6,2.703,6,5.6V6h2V5.199C8,3.754,8.797,3,10,3c1.203,0,2,0.754,2,2.199V8H4\r\n\tC3.447,8,3,8.646,3,9.199V17c0,0.549,0.428,1.139,0.951,1.307l1.197,0.387C5.672,18.861,6.55,19,7.1,19H12.9\r\n\tc0.549,0,1.428-0.139,1.951-0.307l1.196-0.387C16.571,18.139,17,17.549,17,17V9.199C17,8.646,16.352,8,15.8,8z"
    }
  }]
};
exports.open = open;
var lock = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.8,8H14V5.6C14,2.703,12.665,1,10,1C7.334,1,6,2.703,6,5.6V8H4C3.447,8,3,8.646,3,9.199V17\r\n\tc0,0.549,0.428,1.139,0.951,1.307l1.197,0.387C5.672,18.861,6.55,19,7.1,19H12.9c0.549,0,1.428-0.139,1.951-0.307l1.196-0.387\r\n\tC16.571,18.139,17,17.549,17,17V9.199C17,8.646,16.352,8,15.8,8z M12,8H8V5.199C8,3.754,8.797,3,10,3c1.203,0,2,0.754,2,2.199V8z"
    }
  }]
};
exports.lock = lock;
var out = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,10l-6-5v3H6v4h7v3L19,10z M3,3h8V1H3C1.9,1,1,1.9,1,3v14c0,1.1,0.9,2,2,2h8v-2H3V3z"
    }
  }]
};
exports.out = out;
var login = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,10L8,5v3H1v4h7v3L14,10z M17,17H9v2h8c1.1,0,2-0.9,2-2V3c0-1.1-0.9-2-2-2H9v2h8V17z"
    }
  }]
};
exports.login = login;
var loop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,7v7c0,1.103-0.896,2-2,2H2c-1.104,0-2-0.897-2-2V7c0-1.104,0.896-2,2-2h7V3l4,3.5L9,10V8H3v5h14V8h-3V5h4\r\n\tC19.104,5,20,5.896,20,7z"
    }
  }]
};
exports.loop = loop;
var magnet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.165,17.86c-0.028,0.309,0.217,0.584,0.545,0.611l3.985,0.326c0.329,0.027,0.621-0.203,0.65-0.512l0.311-3.287\r\n\tl-5.18-0.426L12.165,17.86z M2.344,14.999l0.312,3.287c0.028,0.309,0.321,0.539,0.65,0.512l3.985-0.326\r\n\tc0.328-0.027,0.573-0.303,0.546-0.611l-0.312-3.287L2.344,14.999z M1.831,9.583l0.321,3.391l5.181-0.426L7.011,9.161\r\n\tc-0.007-0.082-0.011-0.166-0.011-0.25c0-1.555,1.346-2.82,3-2.82s3,1.266,3,2.82c0,0.084-0.004,0.168-0.012,0.25l-0.321,3.387\r\n\tl5.181,0.426l0.321-3.391c0.021-0.225,0.03-0.449,0.03-0.672C18.2,4.659,14.522,1.2,10,1.2S1.8,4.659,1.8,8.911\r\n\tC1.8,9.134,1.811,9.358,1.831,9.583z"
    }
  }]
};
exports.magnet = magnet;
var mail = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.574,5.286c0.488,0.262,7.248,3.894,7.5,4.029C9.326,9.45,9.652,9.514,9.98,9.514c0.328,0,0.654-0.064,0.906-0.199\r\n\ts7.012-3.767,7.5-4.029C18.875,5.023,19.337,4,18.44,4H1.521C0.624,4,1.086,5.023,1.574,5.286z M18.613,7.489\r\n\tc-0.555,0.289-7.387,3.849-7.727,4.027s-0.578,0.199-0.906,0.199s-0.566-0.021-0.906-0.199S1.941,7.777,1.386,7.488\r\n\tC0.996,7.284,1,7.523,1,7.707S1,15,1,15c0,0.42,0.566,1,1,1h16c0.434,0,1-0.58,1-1c0,0,0-7.108,0-7.292S19.004,7.285,18.613,7.489z"
    }
  }]
};
exports.mail = mail;
var man = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,4c1.104,0,2-0.896,2-2c0-1.105-0.896-2-2-2S8,0.895,8,2C8,3.104,8.896,4,10,4z M15.978,11.583\r\n\tc-0.385-1.775-1.058-4.688-2.042-5.894C12.979,4.516,11.051,4.467,10,4.467h0c-1.051,0-2.979,0.049-3.936,1.222\r\n\tC5.08,6.895,4.407,9.808,4.022,11.583c-0.213,0.983,1.154,1.344,1.511,0.355c0.531-1.473,0.941-2.71,1.839-3.736\r\n\tC7.844,11.109,6.102,16.168,6,19c0,0.552,0.448,1,1,1c0.426,0,0.79-0.266,0.934-0.642C8.391,17.771,10,13.355,10,13.355l0,0l0,0\r\n\tc0,0,1.609,4.416,2.066,6.003C12.21,19.734,12.574,20,13,20c0.552,0,1-0.448,1-1c-0.102-2.832-1.844-7.891-1.372-10.797\r\n\tc0.898,1.026,1.308,2.263,1.839,3.736C14.823,12.927,16.191,12.566,15.978,11.583z"
    }
  }]
};
exports.man = man;
var map = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.447,3.718l-6-3c-0.281-0.141-0.613-0.141-0.895,0l-5.63,2.815L1.316,1.664C1.01,1.562,0.676,1.613,0.415,1.802\r\n\tC0.154,1.99,0,2.292,0,2.613v13.001c0,0.379,0.214,0.725,0.553,0.894l6,3c0.141,0.07,0.294,0.106,0.447,0.106\r\n\ts0.307-0.035,0.447-0.106l5.63-2.814l5.606,1.869c0.305,0.1,0.64,0.049,0.901-0.139c0.261-0.188,0.415-0.49,0.415-0.81V4.612\r\n\tC20,4.233,19.786,3.887,19.447,3.718z M8,5.231l4-2v11.763l-4,2V5.231z M2,4l4,1.333v11.661l-4-2V4z M18,16.227l-4-1.334V3.231l4,2\r\n\tV16.227z"
    }
  }]
};
exports.map = map;
var mask = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.581,5.84c-0.043-0.469-0.462-0.803-0.92-0.73C16.919,5.388,12.835,7,10,7C7.165,7,3.081,5.388,1.339,5.11\r\n\tc-0.458-0.073-0.876,0.26-0.92,0.729C0.277,7.371,0,11.45,0,12.068c0,0.83,3.472,2.732,6,2.732c2.452,0,2.95-2.732,4-2.732\r\n\ts1.548,2.732,4,2.732c2.528,0,6-1.902,6-2.732C20,11.45,19.723,7.371,19.581,5.84z M7.66,10.72c-0.353,0.318-1.335,1.07-2.531,0.835\r\n\tc-1.196-0.235-1.919-1.323-2.166-1.758C2.903,9.691,2.922,9.557,3.007,9.48C3.36,9.162,4.342,8.41,5.539,8.645\r\n\tc1.196,0.235,1.919,1.323,2.166,1.758C7.764,10.509,7.745,10.643,7.66,10.72z M17.037,9.797c-0.246,0.436-0.969,1.523-2.166,1.758\r\n\tc-1.196,0.235-2.179-0.517-2.531-0.835c-0.086-0.077-0.104-0.211-0.045-0.317c0.246-0.436,0.969-1.523,2.166-1.758\r\n\tc1.196-0.235,2.179,0.517,2.531,0.835C17.078,9.557,17.097,9.691,17.037,9.797z"
    }
  }]
};
exports.mask = mask;
var medal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,10c0.528,0,1.026,0.104,1.504,0.256L5.427,1.141C5.368,1.053,5.27,1,5.164,1H1.608C1.491,1,1.42,1.131,1.486,1.229\r\n\tl6.231,9.347C8.404,10.22,9.173,10,10,10z M18.392,1h-3.556c-0.106,0-0.204,0.053-0.263,0.141L10.75,6.875l2,3l5.764-8.646\r\n\tC18.579,1.131,18.509,1,18.392,1z M10,11c-2.209,0-4,1.791-4,4c0,2.209,1.791,4,4,4s4-1.791,4-4C14,12.791,12.209,11,10,11z\r\n\t M12.112,15.117c0.062,0.064,0.052,0.158-0.022,0.208c-0.074,0.05-0.095,0.153-0.049,0.229c0.047,0.076,0.018,0.165-0.065,0.199\r\n\ts-0.125,0.13-0.095,0.214s-0.017,0.165-0.104,0.181s-0.149,0.101-0.137,0.189s-0.051,0.158-0.14,0.155\r\n\tc-0.089-0.003-0.167,0.068-0.174,0.156s-0.083,0.144-0.169,0.123s-0.178,0.031-0.203,0.117s-0.111,0.124-0.191,0.085\r\n\tc-0.08-0.039-0.18-0.006-0.222,0.072s-0.134,0.098-0.205,0.043s-0.175-0.044-0.232,0.024s-0.151,0.068-0.209,0\r\n\ts-0.162-0.079-0.232-0.024s-0.162,0.035-0.205-0.043s-0.142-0.111-0.222-0.072c-0.08,0.039-0.166,0-0.191-0.085\r\n\ts-0.116-0.138-0.203-0.117s-0.163-0.034-0.169-0.123S8.589,16.489,8.5,16.491c-0.089,0.003-0.152-0.067-0.14-0.155\r\n\ts-0.05-0.173-0.137-0.189s-0.135-0.097-0.104-0.181s-0.013-0.18-0.095-0.214s-0.111-0.123-0.065-0.199\r\n\tc0.047-0.076,0.025-0.179-0.049-0.229c-0.074-0.05-0.083-0.144-0.022-0.208c0.062-0.064,0.062-0.169,0-0.234\r\n\ts-0.052-0.158,0.022-0.208s0.095-0.153,0.049-0.229c-0.047-0.076-0.018-0.165,0.065-0.199s0.125-0.13,0.095-0.214\r\n\ts0.017-0.165,0.104-0.181s0.149-0.101,0.137-0.189s0.051-0.158,0.14-0.155c0.089,0.003,0.167-0.068,0.174-0.156\r\n\ts0.083-0.144,0.169-0.123s0.178-0.031,0.203-0.117s0.111-0.124,0.191-0.085c0.08,0.039,0.18,0.006,0.222-0.072\r\n\ts0.134-0.098,0.205-0.043s0.175,0.044,0.232-0.024s0.151-0.068,0.209,0s0.162,0.079,0.232,0.024s0.162-0.035,0.205,0.043\r\n\ts0.142,0.111,0.222,0.072c0.08-0.039,0.166,0,0.191,0.085s0.116,0.138,0.203,0.117s0.163,0.034,0.169,0.123s0.085,0.159,0.174,0.156\r\n\tc0.089-0.003,0.152,0.067,0.14,0.155s0.05,0.173,0.137,0.189s0.135,0.097,0.104,0.181s0.013,0.18,0.095,0.214\r\n\ts0.111,0.123,0.065,0.199c-0.047,0.076-0.025,0.179,0.049,0.229s0.083,0.144,0.022,0.208S12.05,15.053,12.112,15.117z"
    }
  }]
};
exports.medal = medal;
var megaphone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.223,7.03c-1.584-3.686-4.132-6.49-5.421-5.967c-2.189,0.891,1.304,5.164-9.447,9.533\r\n\tc-0.929,0.379-1.164,1.888-0.775,2.792c0.388,0.902,1.658,1.801,2.587,1.424c0.161-0.066,0.751-0.256,0.751-0.256\r\n\tc0.663,0.891,1.357,0.363,1.604,0.928c0.296,0.68,0.939,2.158,1.158,2.66c0.219,0.502,0.715,0.967,1.075,0.83\r\n\tc0.359-0.137,1.582-0.602,2.05-0.779c0.468-0.178,0.579-0.596,0.436-0.924c-0.154-0.355-0.786-0.459-0.967-0.873\r\n\tc-0.18-0.412-0.769-1.738-0.938-2.156c-0.23-0.568,0.259-1.031,0.97-1.104c4.894-0.512,5.809,2.512,7.475,1.834\r\n\tC19.068,14.447,18.806,10.713,17.223,7.03z M16.672,13.006c-0.287,0.115-2.213-1.402-3.443-4.267\r\n\tc-1.231-2.863-1.076-5.48-0.79-5.597c0.286-0.115,2.165,1.717,3.395,4.58C17.065,10.585,16.958,12.889,16.672,13.006z"
    }
  }]
};
exports.megaphone = megaphone;
var menu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.4,9H3.6C3.048,9,3,9.447,3,10c0,0.553,0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1C17,9.447,16.952,9,16.4,9z M16.4,13\r\n\tH3.6C3.048,13,3,13.447,3,14c0,0.553,0.048,1,0.6,1H16.4c0.552,0,0.6-0.447,0.6-1C17,13.447,16.952,13,16.4,13z M3.6,7H16.4\r\n\tC16.952,7,17,6.553,17,6c0-0.553-0.048-1-0.6-1H3.6C3.048,5,3,5.447,3,6C3,6.553,3.048,7,3.6,7z"
    }
  }]
};
exports.menu = menu;
var merge = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.8896484,17.7070312L16.8916016,20C13.7548828,18.6341553,11.3964844,16.8476562,10,14.7250977\r\n\tC8.6035156,16.8476562,6.2451172,18.6341553,3.1083984,20l-0.9980469-2.2929688\r\n\tC5.1396484,16.3886719,8.5498047,14.1015625,8.5498047,10V7H5.5L10,0l4.5,7h-3.0498047v3\r\n\tC11.4501953,14.1015625,14.8603516,16.3886719,17.8896484,17.7070312z"
    }
  }]
};
exports.merge = merge;
var message = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,6v7c0,1.1-0.9,2-2,2h-4v3l-4-3H4c-1.101,0-2-0.9-2-2V6c0-1.1,0.899-2,2-2h12C17.1,4,18,4.9,18,6z"
    }
  }]
};
exports.message = message;
var mic = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.399,7.643V10.4c0,2.236-1.643,4.629-5.399,4.959V18h2.6c0.22,0,0.4,0.18,0.4,0.4V19.6c0,0.221-0.181,0.4-0.4,0.4h-7.2\r\n\tC6.18,20,6,19.82,6,19.6V18.4C6,18.18,6.18,18,6.399,18H9v-2.641c-3.758-0.33-5.4-2.723-5.4-4.959V7.643c0-0.221,0.18-0.4,0.4-0.4\r\n\th0.6c0.22,0,0.4,0.18,0.4,0.4V10.4c0,1.336,1.053,3.6,5,3.6c3.946,0,5-2.264,5-3.6V7.643c0-0.221,0.18-0.4,0.399-0.4H16\r\n\tC16.22,7.242,16.399,7.422,16.399,7.643z M10,12c2.346,0,3-0.965,3-1.6V7.242H7V10.4C7,11.035,7.652,12,10,12z M13,1.6\r\n\tC13,0.963,12.346,0,10,0C7.652,0,7,0.963,7,1.6v4.242h6V1.6z"
    }
  }]
};
exports.mic = mic;
var minus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,10c0,0.553-0.048,1-0.601,1H4.601C4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1h10.799C15.952,9,16,9.447,16,10z"
    }
  }]
};
exports.minus = minus;
var mobile = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.004,0H5.996C4.894,0,4,0.894,4,1.996v16.007C4,19.106,4.894,20,5.996,20h8.007C15.106,20,16,19.106,16,18.004V1.996\r\n\tC16,0.894,15.106,0,14.004,0z M10,19c-0.69,0-1.25-0.447-1.25-1s0.56-1,1.25-1s1.25,0.447,1.25,1S10.69,19,10,19z M14,16H6V2h8V16z"
    }
  }]
};
exports.mobile = mobile;
var moon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.719,1.8c0.686,0.385,1.332,0.867,1.916,1.449c3.42,3.422,3.42,8.966,0,12.386c-3.42,3.42-8.965,3.42-12.386,0\r\n\tc-0.583-0.584-1.065-1.231-1.449-1.916c3.335,1.867,7.633,1.387,10.469-1.449C15.106,9.433,15.587,5.136,13.719,1.8z"
    }
  }]
};
exports.moon = moon;
var pointer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.8601685,11.9953299l2.5251465,6.0802317L11.1703491,19l-2.5252075-6.050354L5,16.6248779V1.1005249\r\n\tl10.9461327,10.8882742L10.8601685,11.9953299z"
    }
  }]
};
exports.pointer = pointer;
var mouse = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.402,14.402l-2.627-7.535c-0.722-2.073-2.966-3.22-5.092-2.653L5.707,0.379C5.528,0.033,5.109-0.1,4.769,0.083\r\n\tC4.43,0.266,4.3,0.697,4.48,1.044l1.929,3.742C4.872,5.806,4.073,7.74,4.58,9.56l2.139,7.696c0.602,2.162,3.08,3.264,5.571,2.502\r\n\tC14.749,18.895,16.14,16.521,15.402,14.402z M8.899,8.923c-0.73,0.24-1.511-0.172-1.745-0.921C6.919,7.254,7.322,6.454,8.051,6.214\r\n\tc0.73-0.24,1.512,0.172,1.746,0.92S9.629,8.683,8.899,8.923z"
    }
  }]
};
exports.mouse = mouse;
var network = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.274,6.915c0.2,0,0.394,0.029,0.576,0.086c0.69-0.773,1.455-1.477,2.283-2.1C8.098,4.755,8.079,4.602,8.079,4.446\r\n\tc0-0.217,0.036-0.426,0.102-0.621C7.252,3.161,6.244,2.602,5.17,2.171C4.165,2.792,3.288,3.602,2.588,4.552\r\n\tc0.519,0.92,1.136,1.777,1.838,2.557C4.682,6.985,4.969,6.915,5.274,6.915z M3.316,8.872c0-0.275,0.058-0.537,0.159-0.773\r\n\tC2.847,7.407,2.278,6.663,1.78,5.87C1.155,7.112,0.8,8.515,0.8,10.001c0,1.719,0.474,3.328,1.295,4.705\r\n\tc0.294-1.654,0.851-3.219,1.62-4.652C3.465,9.726,3.316,9.315,3.316,8.872z M10.036,2.489c0.517,0,0.985,0.201,1.336,0.529\r\n\tc1.021-0.439,2.096-0.777,3.215-0.992C13.236,1.247,11.67,0.8,10,0.8c-1.139,0-2.229,0.209-3.236,0.588\r\n\tc0.799,0.395,1.561,0.855,2.277,1.375C9.333,2.589,9.672,2.489,10.036,2.489z M12.962,11.708c0.122-0.254,0.295-0.479,0.509-0.656\r\n\tc-0.578-1.777-1.493-3.404-2.672-4.803c-0.234,0.1-0.492,0.154-0.764,0.154c-0.425,0-0.816-0.137-1.137-0.365\r\n\tc-0.71,0.539-1.367,1.143-1.964,1.803C7.122,8.14,7.231,8.493,7.231,8.872c0,0.203-0.031,0.4-0.09,0.586\r\n\tC8.858,10.604,10.835,11.392,12.962,11.708z M15.501,14.351c0.026,0.371,0.041,0.744,0.041,1.121c0,0.664-0.042,1.318-0.122,1.961\r\n\tc1.56-1.139,2.748-2.758,3.347-4.639c-0.71,0.172-1.438,0.295-2.181,0.365C16.413,13.696,16.014,14.128,15.501,14.351z\r\n\t M12.504,13.024c-2.272-0.377-4.377-1.244-6.21-2.484c-0.298,0.182-0.647,0.289-1.021,0.289c-0.139,0-0.272-0.014-0.402-0.041\r\n\tc-0.877,1.662-1.438,3.517-1.599,5.484c0.876,0.94,1.944,1.697,3.145,2.205C7.909,16.184,9.993,14.288,12.504,13.024z M16.176,3.181\r\n\tc-1.475,0.143-2.883,0.514-4.193,1.068c0.006,0.066,0.01,0.131,0.01,0.197c0,0.309-0.074,0.6-0.201,0.859\r\n\tc1.311,1.539,2.327,3.33,2.969,5.291c0.797,0.016,1.477,0.502,1.77,1.195c0.886-0.09,1.748-0.26,2.578-0.504\r\n\tc0.06-0.42,0.092-0.85,0.092-1.287C19.2,7.296,18.034,4.864,16.176,3.181z M13.489,14.069c-2.344,1.098-4.304,2.789-5.723,4.856\r\n\tC8.481,19.104,9.229,19.2,10,19.2c1.387,0,2.702-0.309,3.882-0.859c0.19-0.928,0.29-1.887,0.29-2.869\r\n\tc0-0.355-0.016-0.707-0.043-1.055C13.893,14.341,13.676,14.224,13.489,14.069z"
    }
  }]
};
exports.network = network;
var newIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.69,12.344l-1.727-1.538c-0.5-0.445-0.5-1.174,0-1.619l1.727-1.539c0.5-0.445,0.367-0.859-0.296-0.924l-2.29-0.217\r\n\tc-0.662-0.062-1.02-0.633-0.791-1.266l1.215-3.383c0.228-0.635-0.051-0.865-0.619-0.514l-2.701,1.67\r\n\tc-0.568,0.354-1.303,0.16-1.631-0.426l-0.978-1.746c-0.329-0.588-0.872-0.59-1.207-0.008l-0.909,1.58\r\n\tC8.146,2.999,7.375,3.247,6.77,2.97l-1.6-0.734C4.562,1.956,4.097,2.278,4.133,2.952l0.086,1.615\r\n\tc0.037,0.674-0.461,1.367-1.104,1.541L1.57,6.522C0.928,6.696,0.81,7.202,1.31,7.647l1.727,1.539c0.5,0.445,0.5,1.174,0,1.619\r\n\tL1.31,12.344c-0.5,0.445-0.368,0.877,0.293,0.957l2.095,0.254c0.661,0.08,1.029,0.67,0.818,1.311l-1.074,3.258\r\n\tc-0.211,0.641,0.09,0.889,0.668,0.555l2.463-1.426c0.578-0.334,1.356-0.15,1.729,0.408l1.022,1.539\r\n\tc0.372,0.559,0.931,0.529,1.24-0.068l0.899-1.733c0.31-0.598,1.052-0.842,1.648-0.543l1.734,0.867\r\n\tc0.598,0.297,1.057-0.01,1.021-0.682l-0.087-1.617c-0.035-0.674,0.461-1.365,1.106-1.539l1.543-0.416\r\n\tC19.072,13.295,19.19,12.789,18.69,12.344z M11,14H9v-2h2V14z M11,11H9V6h2V11z"
    }
  }]
};
exports.newIcon = newIcon;
var news = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14,5h-4v2h4V5z M14,8h-4v1h4V8z M9,5H6v4h3V5z M9,11h5v-1H9V11z M12,13h2v-1h-2\r\n\tV13z M14,14H6v1h8V14z M11,12H6v1h5V12z M8,10H6v1h2V10z M17,1H3C2.447,1,2,1.447,2,2v16c0,0.552,0.447,1,1,1h14\r\n\tc0.553,0,1-0.448,1-1V2C18,1.448,17.553,1,17,1z M16,17H4V3h12V17z"
    }
  }]
};
exports.news = news;
var newsletter = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,3H2C1.4472656,3,1,3.4472656,1,4v12c0,0.5517578,0.4472656,1,1,1h16c0.5527344,0,1-0.4482422,1-1V4\r\n\tC19,3.4481812,18.5527344,3,18,3z M4,10h6v1H4V10z M12,14H4v-1h8V14z M17,8h-3V5h3V8z"
    }
  }]
};
exports.newsletter = newsletter;
var notification = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,8.38V17H3V5h8.62c-0.073-0.322-0.12-0.655-0.12-1s0.047-0.678,0.12-1H3C1.898,3,1,3.9,1,5v12c0,1.1,0.9,2,2,2h12\r\n\tc1.1,0,2-0.9,2-2V8.38c-0.322,0.073-0.655,0.12-1,0.12S15.322,8.453,15,8.38z M16,1c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3\r\n\tS17.657,1,16,1z"
    }
  }]
};
exports.notification = notification;
var off = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.8,17.4c0.2,0.2,0.2,0.5,0,0.7l-0.7,0.7c-0.2,0.2-0.5,0.2-0.7,0L1.2,2.6C1,2.4,1,2.1,1.2,1.9l0.7-0.7\r\n\tC2.1,1,2.4,1,2.6,1.2L18.8,17.4z M16,7c1.7,0,3-1.3,3-3c0-1.7-1.3-3-3-3s-3,1.3-3,3C13,5.7,14.3,7,16,7z M15,8.4v3.8l2,2V8.4\r\n\tc-0.3,0.1-0.7,0.1-1,0.1S15.3,8.5,15,8.4z M11.6,5c-0.1-0.3-0.1-0.7-0.1-1c0-0.3,0-0.7,0.1-1H5.8l2,2H11.6z M5,15V7.8l-2-2V15\r\n\tc0,1.1,0.9,2,2,2h9.2l-2-2H5z"
    }
  }]
};
exports.off = off;
var phone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.256,12.253c-0.096-0.667-0.611-1.187-1.274-1.342c-2.577-0.604-3.223-2.088-3.332-3.734C12.193,7.092,11.38,7,10,7\r\n\tS7.807,7.092,7.35,7.177c-0.109,1.646-0.755,3.13-3.332,3.734c-0.663,0.156-1.178,0.675-1.274,1.342l-0.497,3.442\r\n\tC2.072,16.907,2.962,18,4.2,18h11.6c1.237,0,2.128-1.093,1.953-2.305L17.256,12.253z M10,15.492c-1.395,0-2.526-1.12-2.526-2.5\r\n\ts1.131-2.5,2.526-2.5s2.526,1.12,2.526,2.5S11.394,15.492,10,15.492z M19.95,6C19.926,4.5,16.108,2.001,10,2\r\n\tC3.891,2.001,0.073,4.5,0.05,6s0.021,3.452,2.535,3.127c2.941-0.381,2.76-1.408,2.76-2.876C5.345,5.227,7.737,4.98,10,4.98\r\n\ts4.654,0.247,4.655,1.271c0,1.468-0.181,2.495,2.76,2.876C19.928,9.452,19.973,7.5,19.95,6z"
    }
  }]
};
exports.phone = phone;
var palette = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.74,2.608C12.212,1.422,8.674,1.647,5.02,3.882c-2.853,1.743-4.718,6.076-4.103,9.182\r\n\tc0.728,3.671,4.351,5.995,9.243,4.651c5.275-1.449,6.549-4.546,6.379-5.334c-0.17-0.788-2.665-1.652-1.718-3.498\r\n\tc1.188-2.313,3.129-1.149,3.982-1.622C19.658,6.789,19.342,3.819,15.74,2.608z M12.094,13.314c-0.798,0.218-1.623-0.256-1.843-1.059\r\n\tc-0.221-0.805,0.248-1.631,1.046-1.849c0.798-0.218,1.622,0.254,1.843,1.059C13.36,12.268,12.892,13.096,12.094,13.314z"
    }
  }]
};
exports.palette = palette;
var plane = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.64,2.634C18.296,2.755,1.319,8.738,0.984,8.856c-0.284,0.1-0.347,0.345-0.01,0.479c0.401,0.161,3.796,1.521,3.796,1.521\r\n\tl0,0l2.25,0.901c0,0,10.838-7.958,10.984-8.066c0.148-0.108,0.318,0.095,0.211,0.211c-0.107,0.117-7.871,8.513-7.871,8.513v0.002\r\n\tL9.892,12.92l0.599,0.322l0,0c0,0,4.65,2.504,4.982,2.682c0.291,0.156,0.668,0.027,0.752-0.334\r\n\tc0.099-0.426,2.845-12.261,2.906-12.525C19.21,2.722,18.983,2.513,18.64,2.634z M7,17.162c0,0.246,0.139,0.315,0.331,0.141\r\n\tc0.251-0.229,2.85-2.561,2.85-2.561L7,13.098V17.162z"
    }
  }]
};
exports.plane = plane;
var pencil = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.69,2.661c-1.894-1.379-3.242-1.349-3.754-1.266c-0.144,0.023-0.265,0.106-0.35,0.223l-4.62,6.374l-2.263,3.123\r\n\tc-0.277,0.382-0.437,0.836-0.462,1.307l-0.296,5.624c-0.021,0.405,0.382,0.698,0.76,0.553l5.256-2.01\r\n\tc0.443-0.17,0.828-0.465,1.106-0.849l1.844-2.545l5.036-6.949c0.089-0.123,0.125-0.273,0.1-0.423\r\n\tC16.963,5.297,16.56,4.021,14.69,2.661z M8.977,15.465l-2.043,0.789c-0.08,0.031-0.169,0.006-0.221-0.062\r\n\tc-0.263-0.335-0.576-0.667-1.075-1.03c-0.499-0.362-0.911-0.558-1.31-0.706c-0.08-0.03-0.131-0.106-0.126-0.192l0.122-2.186\r\n\tl0.549-0.755c0,0,1.229-0.169,2.833,0.998c1.602,1.166,1.821,2.388,1.821,2.388L8.977,15.465z"
    }
  }]
};
exports.pencil = pencil;
var chart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11,0.958v9.039C11,10.551,10.551,11,9.997,11H0.958c0.498,4.555,4.355,8.1,9.042,8.1c5.026,0,9.1-4.074,9.1-9.1\r\n\tC19.1,5.312,15.555,1.456,11,0.958z M9,0.958C4.774,1.42,1.42,4.774,0.958,9H9V0.958z"
    }
  }]
};
exports.chart = chart;
var plus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,10c0,0.553-0.048,1-0.601,1H11v4.399C11,15.951,10.553,16,10,16c-0.553,0-1-0.049-1-0.601V11H4.601\r\n\tC4.049,11,4,10.553,4,10c0-0.553,0.049-1,0.601-1H9V4.601C9,4.048,9.447,4,10,4c0.553,0,1,0.048,1,0.601V9h4.399\r\n\tC15.952,9,16,9.447,16,10z"
    }
  }]
};
exports.plus = plus;
var popup = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,2H7.979C6.88,2,6,2.88,6,3.98V12c0,1.1,0.9,2,2,2h8c1.1,0,2-0.9,2-2V4C18,2.9,17.1,2,16,2z M16,12H8V4h8V12z M4,10H2v6\r\n\tc0,1.1,0.9,2,2,2h6v-2H4V10z"
    }
  }]
};
exports.popup = popup;
var plug = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0,14v1.498C0,15.775,0.225,16,0.502,16h0.997C1.775,16,2,15.775,2,15.498V14c0-0.959,0.801-2.273,2-2.779V9.116\r\n\tC1.684,9.652,0,11.97,0,14z M12.065,4.701L9.535,6.599C9.188,6.859,8.766,7,8.332,7H6.005C5.45,7,5,7.45,5,8.005v3.991\r\n\tC5,12.55,5.45,13,6.005,13h2.327c0.434,0,0.856,0.141,1.203,0.401l2.531,1.898C12.672,15.754,13.41,16,14.168,16H16V4h-1.832\r\n\tC13.41,4,12.672,4.246,12.065,4.701z M17,6v2h3V6H17z M17,14h3v-2h-3V14z"
    }
  }]
};
exports.plug = plug;
var tag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.tag = tag;
var print = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.501,6h17c0.57,0,0.477-0.608,0.193-0.707C18.409,5.194,15.251,4,14.7,4H14V1H6v3H5.301c-0.55,0-3.709,1.194-3.993,1.293\r\n\tC1.024,5.392,0.931,6,1.501,6z M19,7H1C0.45,7,0,7.45,0,8v5c0,0.551,0.45,1,1,1h2.283l-0.882,5h15.199l-0.883-5H19\r\n\tc0.551,0,1-0.449,1-1V8C20,7.45,19.551,7,19,7z M4.603,17l1.198-7.003H14.2L15.399,17H4.603z"
    }
  }]
};
exports.print = print;
var empty = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z"
    }
  }]
};
exports.empty = empty;
var full = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z\r\n\t M12,8H8v4h4V8z M17,8h-4v4h4V8z"
    }
  }]
};
exports.full = full;
var one = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z"
    }
  }]
};
exports.one = one;
var two = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,5H2C0.9,5,0,5.9,0,7v6c0,1.1,0.9,2,2,2h16c1.1,0,2-0.9,2-2V7C20,5.9,19.1,5,18,5z M18,13H2V7h16V13z M7,8H3v4h4V8z\r\n\t M12,8H8v4h4V8z"
    }
  }]
};
exports.two = two;
var publish = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.967,8.193L5,13h3v6h4v-6h3L9.967,8.193z M18,1H2C0.9,1,0,1.9,0,3v12c0,1.1,0.9,2,2,2h4v-2H2V6h16v9h-4v2h4\r\n\tc1.1,0,2-0.9,2-2V3C20,1.9,19.1,1,18,1z M2.5,4.25c-0.414,0-0.75-0.336-0.75-0.75c0-0.414,0.336-0.75,0.75-0.75\r\n\tc0.414,0,0.75,0.336,0.75,0.75C3.25,3.914,2.914,4.25,2.5,4.25z M4.5,4.25c-0.414,0-0.75-0.336-0.75-0.75\r\n\tc0-0.414,0.336-0.75,0.75-0.75c0.414,0,0.75,0.336,0.75,0.75C5.25,3.914,4.914,4.25,4.5,4.25z M18,4H6V3h12.019L18,4z"
    }
  }]
};
exports.publish = publish;
var quote = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.315,3.401c-1.61,0-2.916,1.343-2.916,3c0,1.656,1.306,3,2.916,3c2.915,0,0.972,5.799-2.916,5.799v1.4\r\n\tC9.338,16.601,12.057,3.401,5.315,3.401z M13.715,3.401c-1.609,0-2.915,1.343-2.915,3c0,1.656,1.306,3,2.915,3\r\n\tc2.916,0,0.973,5.799-2.915,5.799v1.4C17.738,16.601,20.457,3.401,13.715,3.401z"
    }
  }]
};
exports.quote = quote;
var radio = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,8H5.021l8.974-5.265L13,1L1.736,7.571C1.28,7.837,1,8.324,1,8.852V17c0,1.105,0.895,2,2,2h14c1.105,0,2-0.895,2-2v-7\r\n\tC19,8.895,18.105,8,17,8z M15.5,17c-0.828,0-1.5-0.672-1.5-1.5c0-0.828,0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5\r\n\tC17,16.328,16.328,17,15.5,17z M17,12H3v-2h14V12z"
    }
  }]
};
exports.radio = radio;
var all = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.225,5.767V3.086L0,9.542l7.225,6.691v-2.777L3,9.542L7.225,5.767z M12.225,6.953V3.086L5,9.542l7.225,6.691v-4.357\r\n\tc3.292,0,5.291,0.422,7.775,4.81C20,16.685,19.632,6.953,12.225,6.953z"
    }
  }]
};
exports.all = all;
var reply = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,16.685c0,0-2.225-9.732-11-9.732V2.969L1,9.542l7,6.69v-4.357C12.763,11.874,16.516,12.296,19,16.685z"
    }
  }]
};
exports.reply = reply;
var oneHundredPercent = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.1,14.1L1,17l2,2l2.9-3.1L8,18v-6H2L4.1,14.1z M19,3l-2-2l-2.9,3.1L12,2v6h6l-2.1-2.1L19,3z"
    }
  }]
};
exports.oneHundredPercent = oneHundredPercent;
var fullScreen = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.987,10.987l-2.931,3.031L2,11.589V18h6.387l-2.43-2.081l3.03-2.932L6.987,10.987z M11.613,2l2.43,2.081l-3.03,2.932l2,2\r\n\tl2.931-3.031L18,8.411V2H11.613z"
    }
  }]
};
exports.fullScreen = fullScreen;
var retweet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,13V8h2L3.5,4L0,8h2v6c0,1.104,0.895,2,2,2h9.482l-2.638-3H5z M9.156,7L6.518,4H16c1.104,0,2,0.897,2,2v6h2l-3.5,4L13,12\r\n\th2V7H9.156z"
    }
  }]
};
exports.retweet = retweet;
var rocket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.933,13.069c0,0,7.059-5.094,6.276-10.924c-0.017-0.127-0.059-0.213-0.112-0.268c-0.054-0.055-0.137-0.098-0.263-0.115\r\n\tC12.137,0.961,7.16,8.184,7.16,8.184C2.842,7.667,3.156,8.528,1.186,13.26c-0.377,0.902,0.234,1.213,0.904,0.959\r\n\tc0.67-0.252,2.148-0.811,2.148-0.811l2.59,2.648c0,0-0.546,1.514-0.793,2.199c-0.248,0.686,0.055,1.311,0.938,0.926\r\n\tC11.597,17.165,12.439,17.487,11.933,13.069z M12.942,7.153c-0.598-0.613-0.598-1.604,0-2.217c0.598-0.611,1.567-0.611,2.166,0\r\n\tc0.598,0.611,0.598,1.603,0,2.217C14.509,7.764,13.539,7.764,12.942,7.153z"
    }
  }]
};
exports.rocket = rocket;
var rss = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.4,2.4v2.367c7.086,0,12.83,5.746,12.83,12.832h2.369C17.599,9.205,10.794,2.4,2.4,2.4z M2.4,7.137v2.369\r\n\tc4.469,0,8.093,3.623,8.093,8.094h2.368C12.861,11.822,8.177,7.137,2.4,7.137z M4.669,13.059c-1.254,0-2.27,1.018-2.27,2.271\r\n\ts1.016,2.27,2.27,2.27s2.269-1.016,2.269-2.27S5.923,13.059,4.669,13.059z"
    }
  }]
};
exports.rss = rss;
var ruler = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.249,0.438L0.438,14.251c-0.584,0.584-0.584,1.538,0.002,2.124l3.185,3.187c0.584,0.584,1.541,0.586,2.124,0.002\r\n\tL19.562,5.751c0.584-0.585,0.584-1.541,0-2.125l-3.186-3.188C15.789-0.148,14.834-0.145,14.249,0.438z M3.929,15.312L3.17,16.071\r\n\tl-1.896-1.897l0.759-0.759L3.929,15.312z M6.965,15.312l-0.759,0.759l-3.415-3.415l0.759-0.76L6.965,15.312z M6.965,12.276\r\n\tl-0.759,0.759l-1.898-1.896l0.76-0.76L6.965,12.276z M8.483,10.758l-0.759,0.759L5.828,9.621l0.759-0.76L8.483,10.758z\r\n\t M11.518,10.758l-0.759,0.759L7.345,8.103l0.759-0.759L11.518,10.758z M11.518,7.723l-0.759,0.759L8.863,6.586l0.759-0.759\r\n\tL11.518,7.723z M13.036,6.206l-0.759,0.759L10.38,5.068l0.759-0.759L13.036,6.206z M16.072,6.206l-0.76,0.759L11.898,3.55\r\n\tl0.759-0.76L16.072,6.206z M16.071,3.171l-0.759,0.759l-1.896-1.898l0.759-0.758L16.071,3.171z"
    }
  }]
};
exports.ruler = ruler;
var save = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.173,2H4C2.899,2,2,2.9,2,4v12c0,1.1,0.899,2,2,2h12c1.101,0,2-0.9,2-2V5.127L15.173,2z M14,8c0,0.549-0.45,1-1,1H7\r\n\tC6.45,9,6,8.549,6,8V3h8V8z M13,4h-2v4h2V4z"
    }
  }]
};
exports.save = save;
var scissors = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.38,5.59c0-2.038-1.652-3.69-3.69-3.69S1,3.552,1,5.59c0,2.038,1.652,3.69,3.69,3.69c0.96,0,1.826-0.376,2.483-0.976\r\n\tL9,9.991L9.012,10l-0.004,0.003l-1.836,1.693C6.516,11.096,5.65,10.72,4.69,10.72C2.652,10.72,1,12.372,1,14.41\r\n\tc0,2.038,1.652,3.69,3.69,3.69s3.69-1.652,3.69-3.69c0-0.297-0.044-0.582-0.111-0.858l2.844-1.991l4.127,3.065\r\n\tc2.212,1.549,3.76-0.663,3.76-0.663L8.269,6.448C8.335,6.172,8.38,5.887,8.38,5.59z M4.69,7.39c-0.994,0-1.8-0.806-1.8-1.8\r\n\ts0.806-1.8,1.8-1.8s1.8,0.806,1.8,1.8S5.684,7.39,4.69,7.39z M4.69,16.21c-0.994,0-1.8-0.806-1.8-1.8s0.806-1.8,1.8-1.8\r\n\ts1.8,0.806,1.8,1.8S5.684,16.21,4.69,16.21z M19,6.038c0,0-1.548-2.212-3.76-0.663L12.035,7.61l2.354,1.648L19,6.038z"
    }
  }]
};
exports.scissors = scissors;
var arrows = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1L5,8h10L10,1z M10,19l5-7H5L10,19z"
    }
  }]
};
exports.arrows = arrows;
var alternative = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9,13h2V4h2l-3-4L7,4h2V13z M17,7h-3v2h2v9H4V9h2V7H3C2.447,7,2,7.447,2,8v11c0,0.552,0.447,1,1,1h14c0.553,0,1-0.448,1-1V8\r\n\tC18,7.448,17.553,7,17,7z"
    }
  }]
};
exports.alternative = alternative;
var share = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15,13.442c-0.633,0-1.204,0.246-1.637,0.642l-5.938-3.463C7.471,10.433,7.5,10.237,7.5,10.037S7.471,9.642,7.425,9.454\r\n\tL13.3,6.025C13.746,6.442,14.342,6.7,15,6.7c1.379,0,2.5-1.121,2.5-2.5S16.379,1.7,15,1.7s-2.5,1.121-2.5,2.5\r\n\tc0,0.2,0.029,0.396,0.075,0.583L6.7,8.212C6.254,7.796,5.658,7.537,5,7.537c-1.379,0-2.5,1.121-2.5,2.5s1.121,2.5,2.5,2.5\r\n\tc0.658,0,1.254-0.258,1.7-0.675l5.938,3.463c-0.042,0.175-0.067,0.358-0.067,0.546c0,1.342,1.087,2.429,2.429,2.429\r\n\ts2.429-1.088,2.429-2.429S16.342,13.442,15,13.442z"
    }
  }]
};
exports.share = share;
var shareable = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.8,10c0,1.768,1.433,3.201,3.2,3.201c1.768,0,3.199-1.433,3.199-3.201c0-1.767-1.431-3.2-3.199-3.2S6.8,8.233,6.8,10z\r\n\t M4.529,8.8C5.078,6.284,7.318,4.4,10,4.4c1.546,0,2.945,0.627,3.959,1.64c0.469,0.469,1.229,0.469,1.697,0\r\n\tc0.469-0.469,0.469-1.229,0-1.697C14.209,2.896,12.209,2,10,2C6.418,2,3.386,4.354,2.367,7.601H0V10h3.199\r\n\tC4.198,10,4.444,9.187,4.529,8.8z M16.8,10c-0.999,0-1.245,0.814-1.329,1.199c-0.549,2.516-2.789,4.4-5.471,4.4\r\n\tc-1.547,0-2.946-0.627-3.959-1.641c-0.469-0.469-1.229-0.469-1.698,0c-0.468,0.469-0.468,1.229,0,1.697C5.791,17.104,7.791,18,10,18\r\n\tc3.582,0,6.613-2.356,7.633-5.6H20V10H16.8z"
    }
  }]
};
exports.shareable = shareable;
var shield = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.604,3.332C12.99,4,12.075,2.833,10,1C7.925,2.833,7.01,4,2.396,3.332C-0.063,15.58,10,19,10,19\r\n\tS20.063,15.58,17.604,3.332z M12.473,13.309L10,12.009l-2.472,1.3L8,10.556L6,8.606l2.764-0.401L10,5.7l1.236,2.505L14,8.606\r\n\tl-2,1.949L12.473,13.309z"
    }
  }]
};
exports.shield = shield;
var shop = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.123,7.25L6.914,2H2.8L1.081,6.5C1.028,6.66,1,6.826,1,7c0,1.104,1.15,2,2.571,2C4.881,9,5.964,8.236,6.123,7.25z M10,9\r\n\tc1.42,0,2.571-0.896,2.571-2c0-0.041-0.003-0.082-0.005-0.121L12.057,2H7.943l-0.51,4.875C7.431,6.916,7.429,6.957,7.429,7\r\n\tC7.429,8.104,8.58,9,10,9z M15,10.046V14H5v-3.948C4.562,10.21,4.08,10.3,3.571,10.3c-0.195,0-0.384-0.023-0.571-0.049V16.6\r\n\tc0,0.77,0.629,1.4,1.398,1.4H15.6c0.77,0,1.4-0.631,1.4-1.4v-6.348c-0.188,0.025-0.376,0.049-0.571,0.049\r\n\tC15.923,10.3,15.439,10.208,15,10.046z M18.92,6.5L17.199,2h-4.113l0.79,5.242C14.03,8.232,15.113,9,16.429,9\r\n\tC17.849,9,19,8.104,19,7C19,6.826,18.972,6.66,18.92,6.5z"
    }
  }]
};
exports.shop = shop;
var bag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.121,3.271c-0.295-0.256-1.906-1.731-2.207-1.991C15.615,1.021,15.158,1,14.812,1H5.188C4.843,1,4.386,1.021,4.086,1.28\r\n\tC3.785,1.54,2.174,3.016,1.879,3.271C1.582,3.527,1.336,3.914,1.415,4.463c0.079,0.551,1.89,13.661,1.937,13.973\r\n\tC3.398,18.747,3.67,18.993,4,19h12c0.33-0.007,0.602-0.253,0.648-0.565c0.047-0.311,1.858-13.422,1.938-13.973\r\n\tC18.664,3.914,18.418,3.527,18.121,3.271z M10,11.973c-3.248,0-3.943-4.596-4.087-5.543H7.75c0.276,1.381,0.904,3.744,2.25,3.744\r\n\ts1.975-2.363,2.25-3.744h1.838C13.943,7.377,13.248,11.973,10,11.973z M3.17,4.006L5,2h10l1.83,2.006H3.17z"
    }
  }]
};
exports.bag = bag;
var basket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.399,7h-5.007l-1.812,1.812c-0.453,0.453-1.056,0.702-1.696,0.702c-0.642,0-1.244-0.25-1.698-0.703\r\n\tC7.734,8.359,7.484,7.757,7.483,7.116c0-0.039,0.01-0.077,0.011-0.116H1.6C1.268,7,1,7.268,1,7.6V10h18V7.6\r\n\tC19,7.268,18.73,7,18.399,7z M10.768,7.999l5.055-5.055c0.235-0.234,0.237-0.613,0.002-0.849l-0.92-0.92\r\n\tc-0.234-0.234-0.614-0.233-0.85,0L9,6.231c-0.488,0.488-0.488,1.28,0,1.768C9.488,8.486,10.279,8.487,10.768,7.999z M3.823,17.271\r\n\tC3.92,17.672,4.338,18,4.75,18h10.5c0.412,0,0.83-0.328,0.927-0.729L17.7,11H2.3L3.823,17.271z"
    }
  }]
};
exports.basket = basket;
var cart = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,17c0,1.104,0.894,2,2,2c1.104,0,2-0.896,2-2c0-1.106-0.896-2-2-2C13.894,15,13,15.894,13,17z M3,17c0,1.104,0.895,2,2,2\r\n\tc1.103,0,2-0.896,2-2c0-1.106-0.897-2-2-2C3.895,15,3,15.894,3,17z M6.547,12.172L17.615,9.01C17.826,8.949,18,8.721,18,8.5V3H4V1.4\r\n\tC4,1.18,3.819,1,3.601,1H0.399C0.18,1,0,1.18,0,1.4L0,3h2l1.91,8.957L4,12.9v1.649c0,0.219,0.18,0.4,0.4,0.4H17.6\r\n\tc0.22,0,0.4-0.182,0.4-0.4V13H6.752C5.602,13,5.578,12.449,6.547,12.172z"
    }
  }]
};
exports.cart = cart;
var shuffle = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.093,6.694h0.92v2.862L20,5.532l-3.988-4.025v2.387h-0.92c-3.694,0-5.776,2.738-7.614,5.152\r\n\tc-1.652,2.172-3.08,4.049-5.386,4.049H0v2.799h2.093c3.694,0,5.776-2.736,7.614-5.152C11.359,8.569,12.787,6.694,15.093,6.694z\r\n\t M5.41,8.458c0.158-0.203,0.316-0.412,0.477-0.623C6.277,7.321,6.691,6.78,7.139,6.239C5.817,5.005,4.224,4.095,2.093,4.095H0v2.799\r\n\th2.093C3.42,6.894,4.455,7.517,5.41,8.458z M16.012,13.294h-0.92c-1.407,0-2.487-0.701-3.491-1.738\r\n\tc-0.1,0.131-0.201,0.264-0.303,0.397c-0.441,0.58-0.915,1.201-1.439,1.818c1.356,1.324,3,2.324,5.232,2.324h0.92v2.398L20,14.468\r\n\tl-3.988-4.025V13.294z"
    }
  }]
};
exports.shuffle = shuffle;
var signal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,14c-1.094,0-1.981,0.894-1.981,2c0,1.104,0.887,2,1.981,2c1.094,0,1.98-0.896,1.98-2C11.98,14.895,11.094,14,10,14z\r\n\t M5.8,11.758l1.4,1.414c1.546-1.562,4.054-1.562,5.601,0l1.399-1.414C11.881,9.415,8.119,9.415,5.8,11.758z M3,8.928l1.4,1.414\r\n\tc3.092-3.123,8.106-3.123,11.199,0L17,8.928C13.135,5.024,6.865,5.024,3,8.928z M0.199,6.1l1.4,1.414\r\n\tc4.639-4.686,12.161-4.686,16.801,0L19.8,6.1C14.388,0.633,5.612,0.633,0.199,6.1z"
    }
  }]
};
exports.signal = signal;
var mix = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,1.6C5,1.047,4.552,1,4,1C3.447,1,3,1.047,3,1.6V10h2V1.6z M3,18.4C3,18.951,3.447,19,4,19c0.552,0,1-0.049,1-0.6V15H3\r\n\tV18.4z M6.399,11H1.599C1.046,11,1,11.448,1,12v1c0,0.553,0.046,1,0.599,1h4.801C6.95,14,7,13.553,7,13v-1\r\n\tC7,11.448,6.95,11,6.399,11z M18.399,12h-4.801C13.046,12,13,12.448,13,13v1c0,0.553,0.046,1,0.599,1h4.801\r\n\tC18.95,15,19,14.553,19,14v-1C19,12.448,18.95,12,18.399,12z M13,7c0-0.552-0.05-1-0.601-1H7.599C7.046,6,7,6.448,7,7v1\r\n\tc0,0.553,0.046,1,0.599,1h4.801C12.95,9,13,8.553,13,8V7z M11,1.6C11,1.047,10.552,1,10,1C9.447,1,9,1.047,9,1.6V5h2V1.6z M9,18.4\r\n\tc0,0.551,0.447,0.6,1,0.6c0.552,0,1-0.049,1-0.6V10H9V18.4z M17,1.6C17,1.047,16.552,1,16,1c-0.553,0-1,0.047-1,0.6V11h2V1.6z\r\n\t M15,18.4c0,0.551,0.447,0.6,1,0.6c0.552,0,1-0.049,1-0.6V16h-2V18.4z"
    }
  }]
};
exports.mix = mix;
var mute = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.201,9.194c1.389,1.883,1.818,3.517,1.559,3.777c-0.26,0.258-1.893-0.17-3.778-1.559l-5.526,5.527\r\n\tc4.186,1.838,9.627-2.018,10.605-2.996c0.925-0.922,0.097-3.309-1.856-5.754L14.201,9.194z M8.667,7.941\r\n\tc-1.099-1.658-1.431-3.023-1.194-3.26c0.233-0.234,1.6,0.096,3.257,1.197l1.023-1.025C9.489,3.179,7.358,2.519,6.496,3.384\r\n\tC5.568,4.31,2.048,9.261,3.265,13.341L8.667,7.941z M18.521,1.478c-0.39-0.391-1.023-0.391-1.414,0L1.478,17.108\r\n\tc-0.391,0.391-0.391,1.024,0,1.414c0.391,0.391,1.023,0.391,1.414,0L18.521,2.892C18.912,2.501,18.912,1.868,18.521,1.478z"
    }
  }]
};
exports.mute = mute;
var sound = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.312,4.566C4.19,5.685-0.715,12.681,3.523,16.918c4.236,4.238,11.23-0.668,12.354-1.789\r\n\tc1.121-1.119-0.335-4.395-3.252-7.312C9.706,4.898,6.434,3.441,5.312,4.566z M14.576,14.156c-0.332,0.328-2.895-0.457-5.364-2.928\r\n\tC6.745,8.759,5.956,6.195,6.288,5.865c0.328-0.332,2.894,0.457,5.36,2.926C14.119,11.258,14.906,13.824,14.576,14.156z\r\n\t M15.434,5.982l1.904-1.906c0.391-0.391,0.391-1.023,0-1.414c-0.39-0.391-1.023-0.391-1.414,0l-1.904,1.906\r\n\tc-0.391,0.391-0.391,1.024,0,1.414C14.41,6.372,15.043,6.372,15.434,5.982z M11.124,3.8c0.483,0.268,1.091,0.095,1.36-0.388\r\n\tl1.087-1.926c0.268-0.483,0.095-1.091-0.388-1.36c-0.482-0.269-1.091-0.095-1.36,0.388l-1.087,1.926\r\n\tC10.468,2.924,10.642,3.533,11.124,3.8z M19.872,6.816c-0.267-0.483-0.877-0.657-1.36-0.388l-1.94,1.061\r\n\tc-0.483,0.268-0.657,0.878-0.388,1.36c0.268,0.483,0.877,0.657,1.36,0.388l1.94-1.061C19.967,7.907,20.141,7.299,19.872,6.816z"
    }
  }]
};
exports.sound = sound;
var club = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6,13.5l4,2.5l4-2.5V5H6V13.5z M4.5,10c0-1.105-0.896-2-2-2s-2,0.895-2,2c0,1.105,0.896,2,2,2S4.5,11.105,4.5,10z M17.5,8\r\n\tc-1.104,0-2,0.895-2,2c0,1.105,0.896,2,2,2s2-0.895,2-2C19.5,8.895,18.604,8,17.5,8z M4.485,6.199C5.74,4.384,7.802,3.3,10,3.3\r\n\tc2.158,0,4.198,1.056,5.456,2.823c0.449,0.629,1.323,0.776,1.952,0.329c0.63-0.448,0.777-1.323,0.329-1.953\r\n\tC15.955,1.995,13.062,0.5,10,0.5c-3.117,0-6.04,1.535-7.817,4.107c-0.439,0.636-0.28,1.508,0.355,1.948\r\n\tC3.175,6.993,4.046,6.834,4.485,6.199z M15.456,13.877C14.198,15.645,12.158,16.7,10,16.7c-2.198,0-4.26-1.084-5.515-2.899\r\n\tc-0.439-0.636-1.311-0.794-1.947-0.356c-0.636,0.44-0.795,1.312-0.355,1.948C3.96,17.965,6.883,19.5,10,19.5\r\n\tc3.062,0,5.955-1.495,7.737-3.999c0.448-0.63,0.301-1.504-0.329-1.953C16.779,13.101,15.905,13.248,15.456,13.877z"
    }
  }]
};
exports.club = club;
var spreadsheet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M15,8H9v9H8V8H5V7h3V3h1v4h6V8z"
    }
  }]
};
exports.spreadsheet = spreadsheet;
var star = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,1.3l2.388,6.722H18.8l-5.232,3.948l1.871,6.928L10,14.744l-5.438,4.154l1.87-6.928L1.199,8.022h6.412L10,1.3z"
    }
  }]
};
exports.star = star;
var stopwatch = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.376,6.745c-0.447,0.275,1.197,4.242,1.598,4.888c0.35,0.569,1.093,0.742,1.658,0.394c0.568-0.352,0.745-1.094,0.395-1.66\r\n\tC10.63,9.719,7.822,6.469,7.376,6.745z M7.041,2.402C7.969,2.079,8.963,1.9,10,1.9s2.031,0.179,2.959,0.502\r\n\tc0.329,0.114,0.765-0.115,0.572-0.611c-0.141-0.36-0.277-0.712-0.332-0.855c-0.131-0.339-0.6-0.619-0.804-0.665\r\n\tC11.623,0.097,10.823,0,10,0S8.377,0.097,7.604,0.271C7.4,0.317,6.932,0.597,6.801,0.936C6.746,1.079,6.609,1.431,6.469,1.791\r\n\tC6.276,2.287,6.712,2.517,7.041,2.402z M19.098,3.186c-0.192-0.23-0.396-0.455-0.613-0.672c-0.216-0.217-0.441-0.42-0.67-0.613\r\n\tc-0.153-0.129-0.603-0.234-0.888,0.051c-0.284,0.285-1.648,1.647-1.648,1.647c0.402,0.288,0.793,0.605,1.155,0.966\r\n\tc0.362,0.361,0.677,0.752,0.966,1.155c0,0,1.363-1.362,1.647-1.647C19.333,3.787,19.228,3.338,19.098,3.186z M10,2.9\r\n\tc-4.475,0-8.101,3.626-8.101,8.1c0,4.475,3.626,8.101,8.101,8.101c4.473,0,8.1-3.626,8.1-8.101C18.1,6.527,14.473,2.9,10,2.9z\r\n\t M10,17.101c-3.368,0-6.1-2.731-6.1-6.1c0-3.369,2.731-6.1,6.1-6.1c3.369,0,6.101,2.731,6.101,6.1\r\n\tC16.101,14.369,13.369,17.101,10,17.101z"
    }
  }]
};
exports.stopwatch = stopwatch;
var suitcase = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,4h-1v15h1c1.1,0,2-0.9,2-2V6C20,4.9,19.1,4,18,4z M0,6l0,11c0,1.1,0.899,2,2,2h1V4H2C0.899,4,0,4.9,0,6z M13.5,1.906\r\n\tC12.819,1.59,11.611,1,9.981,1C8.348,1,7.181,1.59,6.5,1.906V4H4v15h12V4h-2.5V1.906z M12,4H8V2.664\r\n\tc0.534-0.23,1.078-0.465,1.981-0.465c0.902,0,1.486,0.234,2.019,0.465V4z"
    }
  }]
};
exports.suitcase = suitcase;
var swap = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14,5H4V3L0,6.5L4,10V8h10V5z M20,13.5L16,10v2H6v3h10v2L20,13.5z"
    }
  }]
};
exports.swap = swap;
var sweden = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.sweden = sweden;
var switchIcon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,3H7c-3.866,0-7,3.134-7,7c0,3.866,3.134,7,7,7h6c3.866,0,7-3.134,7-7C20,6.134,16.866,3,13,3z M13,15\r\n\tc-2.761,0-5-2.239-5-5s2.239-5,5-5s5,2.239,5,5S15.761,15,13,15z"
    }
  }]
};
exports.switchIcon = switchIcon;
var mobileCombo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.00354,5H11.99646C10.8938599,5,10,5.8937988,10,6.9963989V18.00354C10,19.1061401,10.8938599,20,11.99646,20H17.00354\r\n\tC18.1061401,20,19,19.1061401,19,18.00354V6.9963989C19,5.8937988,18.1061401,5,17.00354,5z M14.5,19\r\n\tc-0.6904297,0-1.25-0.4473267-1.25-1c0-0.5527344,0.5595703-1,1.25-1c0.6895142,0,1.25,0.4472656,1.25,1\r\n\tC15.75,18.5526733,15.1895142,19,14.5,19z M17,16h-5V7h5V16z M8,16H3V2h12v1h2V2c0-1.1010742-0.8994141-2-2-2H3\r\n\tC1.9003906,0,1,0.8989258,1,2v16c0,1.0996094,0.9003906,2,2,2h5.5551758C8.2114258,19.4101562,8,18.7338867,8,18.003418V16z"
    }
  }]
};
exports.mobileCombo = mobileCombo;
var tablet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,0H4C2.9,0,2,0.899,2,2v16c0,1.1,0.9,2,2,2h12c1.101,0,2-0.9,2-2V2C18,0.899,17.101,0,16,0z M10,19\r\n\tc-0.69,0-1.25-0.447-1.25-1s0.56-1,1.25-1c0.689,0,1.25,0.447,1.25,1S10.689,19,10,19z M16,16H4V2h12V16z"
    }
  }]
};
exports.tablet = tablet;
var documentInverted = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16,1H4C3.447,1,3,1.447,3,2v16c0,0.552,0.447,1,1,1h12c0.553,0,1-0.448,1-1V2\r\n\tC17,1.448,16.553,1,16,1z M13,15H7v-2h6V15z M13,11H7V9h6V11z M13,7H7V5h6V7z"
    }
  }]
};
exports.documentInverted = documentInverted;
var text = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M15.5,11h-11C4.225,11,4,11.225,4,11.5v1C4,12.776,4.225,13,4.5,13h11\r\n\tc0.276,0,0.5-0.224,0.5-0.5v-1C16,11.225,15.776,11,15.5,11z M15.5,7h-11C4.225,7,4,7.225,4,7.5v1C4,8.776,4.225,9,4.5,9h11\r\n\tC15.776,9,16,8.776,16,8.5v-1C16,7.225,15.776,7,15.5,7z M10.5,15h-6C4.225,15,4,15.225,4,15.5v1C4,16.776,4.225,17,4.5,17h6\r\n\tc0.276,0,0.5-0.224,0.5-0.5v-1C11,15.225,10.776,15,10.5,15z M15.5,3h-11C4.225,3,4,3.225,4,3.5v1C4,4.776,4.225,5,4.5,5h11\r\n\tC15.776,5,16,4.776,16,4.5v-1C16,3.225,15.776,3,15.5,3z"
    }
  }]
};
exports.text = text;
var thermometer = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,10.123V1c0-0.553-0.447-1-1-1H7.799C7.247,0,7,0.447,7,1v9.123c-1.444,0.969-2.4,2.608-2.4,4.477\r\n\tc0,2.982,2.418,5.4,5.4,5.4c2.982,0,5.4-2.418,5.4-5.4C15.4,12.731,14.444,11.092,13,10.123z M10,17.9c-1.823,0-3.3-1.477-3.3-3.3\r\n\tc0-1.472,0.97-2.703,2.3-3.129V4h2v7.471c1.33,0.426,2.3,1.657,2.3,3.129C13.3,16.422,11.823,17.9,10,17.9z"
    }
  }]
};
exports.thermometer = thermometer;
var ticket = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.906,11.541l3.551,3.553l6.518-6.518l-3.553-3.551L4.906,11.541z M19.104,6.664l-1.511-1.512\r\n\tc-0.289,0.156-0.618,0.246-0.969,0.246c-1.118,0-2.024-0.906-2.024-2.023c0-0.352,0.089-0.682,0.246-0.969l-1.511-1.512\r\n\tc-0.394-0.393-1.038-0.393-1.432,0l-11.01,11.01c-0.393,0.392-0.393,1.037,0,1.432l1.512,1.51C2.694,14.69,3.023,14.6,3.375,14.6\r\n\tc1.117,0,2.023,0.906,2.023,2.025c0,0.35-0.089,0.68-0.246,0.969l1.512,1.51c0.394,0.394,1.037,0.394,1.432,0L19.104,8.096\r\n\tC19.498,7.701,19.498,7.057,19.104,6.664z M8.457,16.719l-5.176-5.178l8.142-8.141l5.176,5.176L8.457,16.719z"
    }
  }]
};
exports.ticket = ticket;
var slot = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0.4C4.698,0.4,0.4,4.698,0.4,10C0.4,15.302,4.698,19.6,10,19.6c5.301,0,9.6-4.298,9.6-9.601\r\n\tC19.6,4.698,15.301,0.4,10,0.4z M10,17.599c-4.197,0-7.6-3.402-7.6-7.6c0-4.197,3.402-7.6,7.6-7.6h0V10l6.792-3.396\r\n\tC17.305,7.627,17.6,8.777,17.6,10C17.6,14.197,14.197,17.599,10,17.599z"
    }
  }]
};
exports.slot = slot;
var tools = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.135,6.89c0.933-0.725,1.707-0.225,2.74,0.971c0.116,0.135,0.272-0.023,0.361-0.1c0.088-0.078,1.451-1.305,1.518-1.361\r\n\tC7.82,6.341,7.9,6.231,7.795,6.108C7.688,5.985,7.301,5.483,7.052,5.157c-1.808-2.365,4.946-3.969,3.909-3.994\r\n\tc-0.528-0.014-2.646-0.039-2.963-0.004C6.715,1.294,5.104,2.493,4.293,3.052C3.232,3.778,2.836,4.204,2.771,4.263\r\n\tc-0.3,0.262-0.048,0.867-0.592,1.344C1.604,6.11,1.245,5.729,0.912,6.021C0.747,6.167,0.285,6.513,0.153,6.628\r\n\tC0.02,6.745-0.004,6.942,0.132,7.099c0,0,1.264,1.396,1.37,1.52C1.607,8.741,1.893,8.847,2.069,8.69\r\n\tc0.177-0.156,0.632-0.553,0.708-0.623C2.855,8.001,2.727,7.206,3.135,6.89z M8.843,7.407c-0.12-0.139-0.269-0.143-0.397-0.029\r\n\tL7.012,8.63c-0.113,0.1-0.129,0.283-0.027,0.4l8.294,9.439c0.194,0.223,0.53,0.246,0.751,0.053L17,17.709\r\n\tc0.222-0.195,0.245-0.533,0.052-0.758L8.843,7.407z M19.902,3.39c-0.074-0.494-0.33-0.391-0.463-0.182\r\n\tc-0.133,0.211-0.721,1.102-0.963,1.506c-0.24,0.4-0.832,1.191-1.934,0.41c-1.148-0.811-0.749-1.377-0.549-1.758\r\n\tc0.201-0.383,0.818-1.457,0.907-1.59c0.089-0.135-0.015-0.527-0.371-0.363c-0.357,0.164-2.523,1.025-2.823,2.26\r\n\tc-0.307,1.256,0.257,2.379-0.85,3.494l-1.343,1.4l1.349,1.566l1.654-1.57c0.394-0.396,1.236-0.781,1.998-0.607\r\n\tc1.633,0.369,2.524-0.244,3.061-1.258C20.057,5.792,19.977,3.884,19.902,3.39z M2.739,17.053c-0.208,0.209-0.208,0.549,0,0.758\r\n\tl0.951,0.93c0.208,0.209,0.538,0.121,0.746-0.088l4.907-4.824L7.84,12.115L2.739,17.053z"
    }
  }]
};
exports.tools = tools;
var cone = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,12.078c2.39,0,4.392-0.812,4.513-1.873c-0.356-0.996-0.744-2.084-1.125-3.152C13.124,7.814,11.663,8.354,10,8.354\r\n\tS6.876,7.814,6.612,7.053c-0.381,1.068-0.769,2.156-1.124,3.152C5.609,11.266,7.61,12.078,10,12.078z M10,5.373\r\n\tc1.124,0,2.167-0.348,2.473-0.889c-0.421-1.182-0.782-2.197-1.011-2.836C11.31,1.221,10.621,1,10,1S8.69,1.221,8.538,1.648\r\n\tc-0.228,0.639-0.59,1.654-1.011,2.836C7.833,5.025,8.877,5.373,10,5.373z M18.78,13.066l-3.755-1.514l0.433,1.207\r\n\tc-0.022,1.279-2.504,2.299-5.458,2.299c-2.953,0-5.437-1.019-5.458-2.299l0.433-1.207L1.22,13.066\r\n\tc-1.053,0.424-1.098,1.209-0.098,1.744l7.062,3.787c0.998,0.535,2.633,0.535,3.632,0l7.063-3.787\r\n\tC19.878,14.275,19.833,13.49,18.78,13.066z"
    }
  }]
};
exports.cone = cone;
var trash = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.389,7.113L4.49,18.021C4.551,18.482,6.777,19.998,10,20c3.225-0.002,5.451-1.518,5.511-1.979l1.102-10.908\r\n\tC14.929,8.055,12.412,8.5,10,8.5C7.59,8.5,5.072,8.055,3.389,7.113z M13.168,1.51l-0.859-0.951C11.977,0.086,11.617,0,10.916,0\r\n\tH9.085c-0.7,0-1.061,0.086-1.392,0.559L6.834,1.51C4.264,1.959,2.4,3.15,2.4,4.029v0.17C2.4,5.746,5.803,7,10,7\r\n\tc4.198,0,7.601-1.254,7.601-2.801v-0.17C17.601,3.15,15.738,1.959,13.168,1.51z M12.07,4.34L11,3H9L7.932,4.34h-1.7\r\n\tc0,0,1.862-2.221,2.111-2.522C8.533,1.588,8.727,1.5,8.979,1.5h2.043c0.253,0,0.447,0.088,0.637,0.318\r\n\tc0.248,0.301,2.111,2.522,2.111,2.522H12.07z"
    }
  }]
};
exports.trash = trash;
var trophy = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.trophy = trophy;
var tv = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,1H2C0.899,1,0,1.9,0,3v11c0,1.1,0.882,2.178,1.961,2.393l4.372,0.875C6.333,17.268,2.57,19,5,19h10\r\n\tc2.43,0-1.334-1.732-1.334-1.732l4.373-0.875C19.117,16.178,20,15.1,20,14V3C20,1.9,19.1,1,18,1z M18,14H2V3h16V14z"
    }
  }]
};
exports.tv = tv;
var typing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,4H4C2.899,4,2,4.9,2,6v7c0,1.1,0.899,2,2,2h4l4,3v-3h4c1.1,0,2-0.9,2-2V6C18,4.9,17.1,4,16,4z M6,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C7.1,10.107,6.607,10.6,6,10.6z M10,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C11.1,10.107,10.607,10.6,10,10.6z M14,10.6\r\n\tc-0.607,0-1.1-0.492-1.1-1.1c0-0.608,0.492-1.1,1.1-1.1s1.1,0.492,1.1,1.1C15.1,10.107,14.607,10.6,14,10.6z"
    }
  }]
};
exports.typing = typing;
var uninstall = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.059,10.898l-3.171-7.927C15.654,2.384,15.086,2,14.454,2H5.546C4.914,2,4.346,2.384,4.112,2.971l-3.171,7.927\r\n\tc-0.288,0.721-0.373,1.507-0.246,2.272l0.59,3.539C1.409,17.454,2.053,18,2.808,18h14.383c0.755,0,1.399-0.546,1.523-1.291\r\n\tl0.59-3.539C19.433,12.405,19.348,11.619,19.059,10.898z M5.52,4.786l1.639-1.132l2.868,2.011l2.868-2.011l1.639,1.132l-2.869,2.033\r\n\tl2.928,2.06l-1.639,1.171l-2.927-2.076L7.1,10.05L5.461,8.879l2.928-2.06L5.52,4.786z M16.959,15.245\r\n\tC16.887,15.681,16.51,16,16.068,16H3.932c-0.442,0-0.819-0.319-0.891-0.755l-0.365-2.193C2.583,12.501,3.008,12,3.567,12h12.867\r\n\tc0.558,0,0.983,0.501,0.891,1.052L16.959,15.245z"
    }
  }]
};
exports.uninstall = uninstall;
var unread = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17,3c-1.104,0-2,0.895-2,2c0,1.105,0.896,2,2,2s2-0.895,2-2\r\n\tC19,3.895,18.104,3,17,3z M12.5,4h-11C1.224,4,1,4.224,1,4.5v1C1,5.776,1.224,6,1.5,6h11C12.776,6,13,5.776,13,5.5v-1\r\n\tC13,4.224,12.776,4,12.5,4z M12.5,9h-11C1.224,9,1,9.224,1,9.5v1C1,10.776,1.224,11,1.5,11h11c0.276,0,0.5-0.224,0.5-0.5v-1\r\n\tC13,9.224,12.776,9,12.5,9z M12.5,14h-11C1.224,14,1,14.224,1,14.5v1C1,15.776,1.224,16,1.5,16h11c0.276,0,0.5-0.224,0.5-0.5v-1\r\n\tC13,14.224,12.776,14,12.5,14z"
    }
  }]
};
exports.unread = unread;
var untag = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1,14.742l4.945-0.709L5.239,19l5.962-5.985L7.132,8.586L1,14.742z M18.664,5.521c0.391-0.393,0.5-0.945,0-1.419\r\n\tl-2.826-2.839c-0.279-0.308-1.021-0.392-1.412,0l-3.766,3.78l4.068,4.429L18.664,5.521z M18.706,15.293l-14.001-14\r\n\tc-0.391-0.391-1.023-0.391-1.414,0c-0.391,0.391-0.391,1.023,0,1.414l14.001,14C17.488,16.903,17.744,17,17.999,17\r\n\tc0.256,0,0.512-0.098,0.707-0.293C19.097,16.317,19.097,15.684,18.706,15.293z"
    }
  }]
};
exports.untag = untag;
var toCloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.toCloud = toCloud;
var upload = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8,12h4V6h3l-5-5L5,6h3V12z M19.338,13.532c-0.21-0.224-1.611-1.723-2.011-2.114C17.062,11.159,16.683,11,16.285,11h-1.757\r\n\tl3.064,2.994h-3.544c-0.102,0-0.194,0.052-0.24,0.133L12.992,16H7.008l-0.816-1.873c-0.046-0.081-0.139-0.133-0.24-0.133H2.408\r\n\tL5.471,11H3.715c-0.397,0-0.776,0.159-1.042,0.418c-0.4,0.392-1.801,1.891-2.011,2.114c-0.489,0.521-0.758,0.936-0.63,1.449\r\n\tl0.561,3.074c0.128,0.514,0.691,0.936,1.252,0.936h16.312c0.561,0,1.124-0.422,1.252-0.936l0.561-3.074\r\n\tC20.096,14.468,19.828,14.053,19.338,13.532z"
    }
  }]
};
exports.upload = upload;
var users = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.989,19.129c0-2.246-2.187-3.389-4.317-4.307c-2.123-0.914-2.801-1.684-2.801-3.334c0-0.989,0.648-0.667,0.932-2.481\r\n\tc0.12-0.752,0.692-0.012,0.802-1.729c0-0.684-0.313-0.854-0.313-0.854s0.159-1.013,0.221-1.793c0.064-0.817-0.398-2.56-2.301-3.095\r\n\tC7.88,1.195,7.655,0.654,8.679,0.112c-2.24-0.104-2.761,1.068-3.954,1.93c-1.015,0.756-1.289,1.953-1.24,2.59\r\n\tc0.065,0.78,0.223,1.793,0.223,1.793s-0.314,0.17-0.314,0.854c0.11,1.718,0.684,0.977,0.803,1.729\r\n\tC4.481,10.822,5.13,10.5,5.13,11.489c0,1.65-0.212,2.21-2.336,3.124C0.663,15.53,0,17,0.011,19.129C0.014,19.766,0,20,0,20h16\r\n\tC16,20,15.989,19.766,15.989,19.129z M18.528,13.365c-1.135-0.457-1.605-1.002-1.605-2.066c0-0.641,0.418-0.432,0.602-1.603\r\n\tc0.077-0.484,0.447-0.008,0.518-1.115c0-0.441-0.202-0.551-0.202-0.551s0.103-0.656,0.143-1.159c0.05-0.627-0.364-2.247-2.268-2.247\r\n\tc-1.903,0-2.318,1.62-2.269,2.247c0.042,0.502,0.144,1.159,0.144,1.159s-0.202,0.109-0.202,0.551\r\n\tc0.071,1.107,0.441,0.631,0.518,1.115c0.184,1.172,0.602,0.963,0.602,1.603c0,1.064-0.438,1.562-1.809,2.152\r\n\tc-0.069,0.029-0.12,0.068-0.183,0.102c1.64,0.712,4.226,1.941,4.838,4.447H20c0,0,0-1.906,0-2.318\r\n\tC20,14.682,19.727,13.848,18.528,13.365z"
    }
  }]
};
exports.users = users;
var vinyl = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.999,0.8C4.918,0.8,0.8,4.919,0.8,10.001c0,5.08,4.118,9.199,9.199,9.199c5.081,0,9.2-4.119,9.2-9.199\r\n\tC19.199,4.919,15.08,0.8,9.999,0.8z M10,13.001c-1.657,0-3-1.344-3-3c0-1.656,1.343-3,3-3c1.656,0,3,1.344,3,3\r\n\tC13,11.657,11.656,13.001,10,13.001z"
    }
  }]
};
exports.vinyl = vinyl;
var voicemail = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.4,5.801c-2.541,0-4.601,2.059-4.601,4.6c0,0.965,0.298,1.859,0.806,2.6H8.394c0.508-0.74,0.805-1.635,0.805-2.6\r\n\tc0-2.541-2.059-4.6-4.6-4.6c-2.54,0-4.6,2.059-4.6,4.6C0,12.941,2.059,15,4.6,15H15.4c2.54,0,4.6-2.059,4.6-4.6\r\n\tC20,7.859,17.94,5.801,15.4,5.801z M2,10.4c0-1.436,1.164-2.6,2.6-2.6c1.436,0,2.6,1.164,2.6,2.6c0,1.436-1.164,2.6-2.6,2.6\r\n\tC3.164,13,2,11.836,2,10.4z M15.4,13c-1.437,0-2.601-1.164-2.601-2.6c0-1.436,1.164-2.6,2.601-2.6c1.435,0,2.6,1.164,2.6,2.6\r\n\tC18,11.836,16.836,13,15.4,13z"
    }
  }]
};
exports.voicemail = voicemail;
var wallet = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16,6H3.5V5.5l11-0.88V5.5H16V4c0-1.1-0.891-1.872-1.979-1.717L3.98,3.717C2.891,3.873,2,4.9,2,6v10c0,1.104,0.895,2,2,2h12\r\n\tc1.104,0,2-0.896,2-2V8C18,6.896,17.104,6,16,6z M14.5,13.006c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5s1.5,0.672,1.5,1.5\r\n\tS15.328,13.006,14.5,13.006z"
    }
  }]
};
exports.wallet = wallet;
var warning = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.511,17.98L10.604,1.348C10.48,1.133,10.25,1,10,1C9.749,1,9.519,1.133,9.396,1.348L0.49,17.98\r\n\tc-0.121,0.211-0.119,0.471,0.005,0.68C0.62,18.871,0.847,19,1.093,19h17.814c0.245,0,0.474-0.129,0.598-0.34\r\n\tC19.629,18.451,19.631,18.191,19.511,17.98z M11,17H9v-2h2V17z M11,13.5H9V7h2V13.5z"
    }
  }]
};
exports.warning = warning;
var water = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.882,9.093c-0.511,4.115-3.121,4.847-3.121,7.708C6.761,18.567,8.244,20,10,20c1.756,0,3.238-1.434,3.238-3.199\r\n\tc0-2.861-2.61-3.593-3.121-7.708C10.101,8.97,9.898,8.97,9.882,9.093z M3.883,0.093C3.372,4.208,0.762,4.939,0.762,7.801\r\n\tC0.762,9.566,2.244,11,4,11c1.756,0,3.238-1.434,3.238-3.199c0-2.861-2.61-3.593-3.121-7.708C4.102-0.03,3.898-0.03,3.883,0.093z\r\n\t M15.883,0.093c-0.511,4.115-3.121,4.847-3.121,7.708C12.762,9.566,14.244,11,16,11c1.756,0,3.238-1.434,3.238-3.199\r\n\tc0-2.861-2.61-3.593-3.121-7.708C16.101-0.03,15.898-0.03,15.883,0.093z"
    }
  }]
};
exports.water = water;
var fiveHundredPX = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.398,14.775c0.481-0.174,0.928-0.4,1.337-0.683c0.41-0.282,0.797-0.608,1.16-0.982c0.363-0.373,0.736-0.759,1.118-1.159\r\n\tc0.346,0.4,0.71,0.786,1.092,1.159c0.382,0.374,0.787,0.7,1.214,0.982c0.428,0.282,0.887,0.509,1.379,0.683\r\n\tc0.49,0.173,1.017,0.259,1.582,0.259c0.727,0,1.387-0.132,1.977-0.396c0.591-0.264,1.087-0.627,1.487-1.092\r\n\tc0.399-0.464,0.71-1.005,0.928-1.623C19.891,11.306,20,10.642,20,9.932c0-0.71-0.109-1.364-0.328-1.964\r\n\tc-0.218-0.602-0.528-1.123-0.928-1.569c-0.4-0.446-0.892-0.795-1.473-1.05c-0.583-0.256-1.238-0.383-1.966-0.383\r\n\tc-0.581,0-1.123,0.092-1.623,0.273c-0.5,0.182-0.964,0.423-1.391,0.723c-0.428,0.3-0.828,0.65-1.201,1.051\r\n\tc-0.372,0.399-0.732,0.81-1.078,1.228C9.648,7.804,9.28,7.391,8.908,6.999C8.535,6.608,8.135,6.262,7.707,5.962\r\n\tc-0.428-0.3-0.891-0.541-1.391-0.723c-0.5-0.182-1.051-0.273-1.65-0.273c-0.728,0-1.385,0.133-1.965,0.396\r\n\tC2.117,5.626,1.628,5.979,1.227,6.426c-0.4,0.446-0.706,0.974-0.914,1.583C0.104,8.618,0,9.277,0,9.985\r\n\tc0,0.71,0.108,1.374,0.326,1.992c0.219,0.619,0.537,1.15,0.955,1.597c0.419,0.446,0.919,0.801,1.5,1.064\r\n\tc0.584,0.264,1.246,0.396,1.993,0.396C5.374,15.034,5.916,14.948,6.398,14.775z M3.164,11.65c-0.383-0.418-0.573-0.955-0.573-1.609\r\n\tc0-0.6,0.186-1.142,0.561-1.624c0.372-0.48,0.876-0.723,1.515-0.723c0.345,0,0.689,0.078,1.035,0.232\r\n\tc0.346,0.154,0.678,0.35,0.997,0.587C7.016,8.75,7.321,9.009,7.611,9.29c0.291,0.283,0.546,0.542,0.765,0.778\r\n\tc-0.219,0.255-0.464,0.515-0.737,0.776c-0.273,0.266-0.562,0.502-0.872,0.71c-0.311,0.21-0.637,0.382-0.983,0.519\r\n\tc-0.345,0.137-0.691,0.205-1.036,0.205C4.073,12.278,3.546,12.069,3.164,11.65z M14.256,12.088c-0.336-0.127-0.66-0.296-0.968-0.505\r\n\tc-0.311-0.209-0.603-0.445-0.874-0.709c-0.273-0.264-0.528-0.532-0.764-0.806c0.218-0.236,0.463-0.495,0.736-0.778\r\n\tc0.273-0.281,0.56-0.54,0.859-0.776c0.3-0.237,0.619-0.433,0.955-0.587c0.337-0.154,0.688-0.232,1.051-0.232\r\n\tc0.673,0,1.204,0.227,1.596,0.683c0.392,0.454,0.587,1,0.587,1.638c0,0.637-0.183,1.172-0.546,1.608\r\n\tc-0.364,0.438-0.882,0.655-1.555,0.655C14.952,12.278,14.592,12.215,14.256,12.088z"
    }
  }]
};
exports.fiveHundredPX = fiveHundredPX;
var store = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.5640259,13.8623047\r\n\tc-0.4133301,0.9155273-0.6115723,1.3251343-1.1437988,2.1346436c-0.7424927,1.1303711-1.7894897,2.5380249-3.086853,2.5500488\r\n\tc-1.1524048,0.0109253-1.4483032-0.749939-3.0129395-0.741333c-1.5640259,0.008606-1.8909302,0.755127-3.0438843,0.7442017\r\n\tc-1.296814-0.0120239-2.2891235-1.2833252-3.0321655-2.4136963c-2.0770874-3.1607666-2.2941895-6.8709106-1.0131836-8.8428955\r\n\tc0.9106445-1.4013062,2.3466187-2.2217407,3.6970215-2.2217407c1.375,0,2.239502,0.7539673,3.3761597,0.7539673\r\n\tc1.1028442,0,1.7749023-0.755127,3.3641357-0.755127c1.201416,0,2.4744263,0.6542969,3.3816528,1.7846069\r\n\tC14.0778809,8.4837646,14.5608521,12.7279663,17.5640259,13.8623047z M12.4625244,3.8076782\r\n\tc0.5775146-0.741333,1.0163574-1.7880859,0.8571167-2.857666c-0.9436035,0.0653076-2.0470581,0.6651611-2.6912842,1.4477539\r\n\tC10.0437012,3.107605,9.56073,4.1605835,9.7486572,5.1849365C10.7787476,5.2164917,11.8443604,4.6011963,12.4625244,3.8076782z"
    }
  }]
};
exports.store = store;
var baidu = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.4116364,6.9370399c-0.3587151-0.2830696-0.923996-0.4004283-1.4627256-0.3652954\r\n\tc-0.4163361,0.0265503-0.7609177,0.0346184-1.0045052,0.1825905c-1.1165419,0.6770897-1.2169638,4.3529868,0.1820755,4.9340606\r\n\tC18.100399,12.9238987,19.1828365,8.3379107,17.4116364,6.9370399z M12.933279,10.7750425\r\n\tc-0.9637632-1.1185446-1.6411963-2.6815205-3.5630016-2.375906c-1.7067132,0.2714539-1.9238648,1.6706648-2.8335552,2.6501064\r\n\tc-1.0796924,1.1637497-3.1049521,2.0173635-3.5640316,3.8376598c-0.3346822,1.3286009,0.1159286,2.8923788,0.9135242,3.4726515\r\n\tc1.5661802,1.1375408,4.473722-0.1246262,6.5796628,0.0911503c1.2606802,0.1290321,2.2246733,0.571804,3.197649,0.5484009\r\n\tc2.2625532-0.0532722,4.0896587-1.669405,3.1077557-4.294507C16.2904587,13.418684,14.1704426,12.21099,12.933279,10.7750425z\r\n\t M12.6592512,6.8458877c1.1333075,0.0318718,2.3012905-1.2649717,2.3760777-2.467402\r\n\tc0.0976181-1.5697851-0.929431-3.1436331-2.4671726-2.7416024c-0.9137535,0.2387236-1.66397,1.4105408-1.7361822,2.5593553\r\n\tC10.7485466,5.5281014,11.4487524,6.8116126,12.6592512,6.8458877z M8.2726755,6.4801922\r\n\tC9.4498711,6.321291,9.9402504,4.9083467,9.7355728,3.2816844c-0.1689148-1.338729-0.8955564-2.6371751-2.4675736-2.192801\r\n\tC5.1026068,1.7001691,5.4477601,6.8620238,8.2726755,6.4801922z M4.1614451,10.5923948\r\n\tc2.5823007-0.3854933,1.9797125-5.9385071-0.8224294-5.2997556C0.9296925,5.8418407,1.2518435,11.0266409,4.1614451,10.5923948z"
    }
  }]
};
exports.baidu = baidu;
var basecamp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2C5.327,2,0.7,8.481,0.7,14.422C0.7,15.799,5.234,18,10,18s9.3-2.201,9.3-3.578C19.3,8.481,14.673,2,10,2z\r\n\t M10.006,15.615c-5.198,0-6.673-2.068-6.673-2.722c0-1.287,2.13-4.485,2.906-4.485c0.719,0,1.542,1.811,2.314,1.811\r\n\tc1.241,0,2.567-3.954,3.579-3.954s4.601,5.178,4.601,6.749C16.733,13.285,15.649,15.615,10.006,15.615z"
    }
  }]
};
exports.basecamp = basecamp;
var behance = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.072,9.301c0,0,1.892-0.147,1.892-2.459c0-2.315-1.548-3.441-3.51-3.441H0v12.926h6.454c0,0,3.941,0.129,3.941-3.816\r\n\tC10.394,12.51,10.566,9.301,8.072,9.301z M2.844,5.697h3.61c0,0,0.878,0,0.878,1.344c0,1.346-0.516,1.541-1.102,1.541H2.844V5.697z\r\n\t M6.271,14.029H2.844v-3.455h3.61c0,0,1.308-0.018,1.308,1.775C7.762,13.861,6.785,14.018,6.271,14.029z M15.649,6.688\r\n\tc-4.771,0-4.767,4.967-4.767,4.967s-0.326,4.941,4.767,4.941c0,0,4.243,0.254,4.243-3.437h-2.182c0,0,0.072,1.391-1.988,1.391\r\n\tc0,0-2.184,0.152-2.184-2.25h6.423C19.962,12.299,20.67,6.688,15.649,6.688z M17.59,10.574h-4.074c0,0,0.266-1.992,2.182-1.992\r\n\tS17.59,10.574,17.59,10.574z M18.097,4.16H12.98v1.594h5.117V4.16z"
    }
  }]
};
exports.behance = behance;
var dribbble = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.565,7.421C8.207,5.007,6.754,3.038,6.648,2.893C4.457,3.929,2.822,5.948,2.311,8.38C2.517,8.384,5.793,8.423,9.565,7.421\r\n\tz M10.543,10.061c0.102-0.033,0.206-0.064,0.309-0.094c-0.197-0.447-0.412-0.895-0.637-1.336C6.169,9.843,2.287,9.755,2.15,9.751\r\n\tc-0.003,0.084-0.007,0.166-0.007,0.25c0,2.019,0.763,3.861,2.016,5.252l-0.005-0.006C4.154,15.247,6.304,11.433,10.543,10.061z\r\n\t M5.171,16.194V16.19c-0.058-0.045-0.12-0.086-0.178-0.135C5.099,16.14,5.171,16.194,5.171,16.194z M8.118,2.372\r\n\tC8.111,2.374,8.103,2.376,8.103,2.376c0.006-0.002,0.014-0.002,0.014-0.002L8.118,2.372z M15.189,4.104\r\n\tC13.805,2.886,11.99,2.143,10,2.143c-0.639,0-1.258,0.078-1.852,0.221c0.12,0.16,1.595,2.119,2.938,4.584\r\n\tC14.048,5.839,15.167,4.136,15.189,4.104z M10,19.2c-5.08,0-9.199-4.119-9.199-9.199C0.8,4.919,4.919,0.8,10,0.8\r\n\tc5.082,0,9.2,4.119,9.2,9.201C19.2,15.081,15.082,19.2,10,19.2z M11.336,11.286c-4.611,1.607-6.134,4.838-6.165,4.904\r\n\tc1.334,1.041,3.006,1.666,4.828,1.666c1.088,0,2.125-0.221,3.067-0.621c-0.116-0.689-0.573-3.096-1.679-5.967\r\n\tC11.371,11.274,11.354,11.28,11.336,11.286z M11.69,8.12c0.184,0.373,0.358,0.754,0.523,1.139c0.059,0.135,0.114,0.272,0.17,0.406\r\n\tc2.713-0.342,5.385,0.238,5.473,0.256c-0.019-1.863-0.686-3.572-1.787-4.912C16.051,5.032,14.79,6.852,11.69,8.12z M12.861,10.905\r\n\tc1.031,2.836,1.449,5.142,1.529,5.611c1.764-1.191,3.018-3.08,3.367-5.27C17.601,11.196,15.401,10.499,12.861,10.905z"
    }
  }]
};
exports.dribbble = dribbble;
var dropbox = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.109,0.902L0.4,4.457l3.911,3.279L10,4.043L6.109,0.902z M13.452,15.992c-0.102,0-0.203-0.033-0.285-0.102L10,13.262\r\n\tl-3.167,2.629c-0.082,0.068-0.184,0.102-0.285,0.102c-0.085,0-0.17-0.023-0.244-0.072l-2.346-1.533v0.904L10,19.098l6.042-3.807\r\n\tv-0.904l-2.346,1.533C13.622,15.969,13.537,15.992,13.452,15.992z M19.6,4.457l-5.71-3.555L10,4.043l5.688,3.693L19.6,4.457z\r\n\t M10,11.291l3.528,2.928l5.641-3.688l-3.481-2.795L10,11.291z M6.472,14.219L10,11.291L4.311,7.736l-3.48,2.795L6.472,14.219z"
    }
  }]
};
exports.dropbox = dropbox;
var evernote = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.3,4.3c0-1.2-1.7-1.3-1.7-1.3l-4.1-0.3c0,0-0.1-1.1-0.9-1.5C9.8,0.9,8.9,1,8.3,1C7.6,1,7.5,1.9,7.5,2.6\r\n\tc0,0.8,0,1.7,0,2.2c0,1-0.4,1.4-1.6,1.4H3.6c-0.6,0-1.1,0.1-1.1,0.6c0,0.5,0.8,5,1.8,6c0.6,0.6,4.3,1,5.1,1s0.5-2.3,0.7-2.3\r\n\ts0.5,1.3,1.7,1.6c1.2,0.3,2.9,0.2,3,1.1c0.1,1.2,0.2,2.6-0.5,2.7l-1.7,0.1c-1.2-0.1-0.9-1.4-0.3-1.4c0.5,0,0.8,0,0.8,0l0.1-1.4\r\n\tc0,0-2.7-0.3-2.8,1.5c-0.1,1.7,0.2,2.4,0.4,2.6c0.2,0.2,0.6,0.5,3.9,0.5C19,19,17.3,5.5,17.3,4.3z M15.4,10.3\r\n\tC15.3,10.5,14.6,10,14,10c-0.6,0-1.3,0.3-1.5,0.1c-0.2-0.2,0.1-2,1.3-2S15.6,10.1,15.4,10.3z M5.3,4.6c-0.5,0-2.9,0-2.9,0l3.5-3.4\r\n\tc0,0-0.1,2.8-0.1,3C5.8,4.4,5.7,4.6,5.3,4.6z"
    }
  }]
};
exports.evernote = evernote;
var facebook = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17,1H3C1.9,1,1,1.9,1,3v14c0,1.101,0.9,2,2,2h7v-7H8V9.525h2V7.475c0-2.164,1.212-3.684,3.766-3.684l1.803,0.002v2.605\r\n\th-1.197C13.378,6.398,13,7.144,13,7.836v1.69h2.568L15,12h-2v7h4c1.1,0,2-0.899,2-2V3C19,1.9,18.1,1,17,1z"
    }
  }]
};
exports.facebook = facebook;
var flattr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.598,8.541c0-1.637,0.434-2.678,1.889-2.912c0.508-0.1,1.566-0.064,2.239-0.064v2.5c0,0.024,0.003,0.064,0.009,0.084\r\n\tC9.762,8.25,9.854,8.324,9.963,8.324c0.061,0,0.118-0.031,0.178-0.09L16.377,2H12.19H7.548C3.874,2,2,4.115,2,8.066v8.287\r\n\tl3.598-3.602V8.541z M14.4,7.248v4.209c0,1.637-0.434,2.68-1.889,2.912c-0.508,0.1-1.566,0.065-2.238,0.065v-2.5\r\n\tc0-0.022-0.004-0.062-0.009-0.084c-0.028-0.1-0.12-0.174-0.228-0.176c-0.062,0-0.118,0.033-0.179,0.092l-6.235,6.232L7.809,18h4.643\r\n\tC16.125,18,18,15.885,18,11.934V3.647L14.4,7.248z"
    }
  }]
};
exports.flattr = flattr;
var flickr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,14c-2.188,0-3.96-1.789-3.96-4c0-2.211,1.772-4,3.96-4c2.187,0,3.96,1.789,3.96,4C8.96,12.211,7.187,14,5,14z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M15,14c-2.188,0-3.96-1.789-3.96-4c0-2.211,1.772-4,3.96-4c2.187,0,3.96,1.789,3.96,4C18.96,12.211,17.187,14,15,14z"
    }
  }]
};
exports.flickr = flickr;
var foursquare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.92,1C4.412,1,4,1.412,4,1.92v16.516c0,0.625,0.765,0.926,1.192,0.47l4.471-4.79C9.731,14.042,9.826,14,9.927,14h3.237\r\n\tc0.486,0,0.905-0.343,1.001-0.82l2.111-10.514C16.449,1.804,15.79,1,14.911,1H4.92z M8.838,12.19L6,15.527V3.343\r\n\tC6,3.154,6.154,3,6.343,3h7.14c0.342,0,0.598,0.313,0.53,0.648l-0.413,2.055C13.566,5.876,13.414,6,13.238,6h-3.71\r\n\tC9.236,6,9,6.236,9,6.528v1.22C9,7.887,9.113,8,9.253,8h3.294c0.306,0,0.536,0.28,0.476,0.581l-0.614,3.058\r\n\tC12.366,11.849,12.181,12,11.967,12H9.25C9.091,12,8.941,12.069,8.838,12.19z"
    }
  }]
};
exports.foursquare = foursquare;
var github = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.18,11.309c-0.718,0-1.3,0.807-1.3,1.799c0,0.994,0.582,1.801,1.3,1.801s1.3-0.807,1.3-1.801\r\n\tC14.479,12.116,13.898,11.309,13.18,11.309z M17.706,6.626c0.149-0.365,0.155-2.439-0.635-4.426c0,0-1.811,0.199-4.551,2.08\r\n\tc-0.575-0.16-1.548-0.238-2.519-0.238c-0.973,0-1.945,0.078-2.52,0.238C4.74,2.399,2.929,2.2,2.929,2.2\r\n\tC2.14,4.187,2.148,6.261,2.295,6.626C1.367,7.634,0.8,8.845,0.8,10.497c0,7.186,5.963,7.301,7.467,7.301\r\n\tc0.342,0,1.018,0.002,1.734,0.002c0.715,0,1.392-0.002,1.732-0.002c1.506,0,7.467-0.115,7.467-7.301\r\n\tC19.2,8.845,18.634,7.634,17.706,6.626z M10.028,16.915H9.972c-3.771,0-6.709-0.449-6.709-4.115c0-0.879,0.31-1.693,1.047-2.369\r\n\tc1.227-1.127,3.305-0.531,5.662-0.531c0.01,0,0.02,0,0.029,0c0.01,0,0.018,0,0.027,0c2.357,0,4.436-0.596,5.664,0.531\r\n\tc0.735,0.676,1.045,1.49,1.045,2.369C16.737,16.466,13.8,16.915,10.028,16.915z M6.821,11.309c-0.718,0-1.3,0.807-1.3,1.799\r\n\tc0,0.994,0.582,1.801,1.3,1.801c0.719,0,1.301-0.807,1.301-1.801C8.122,12.116,7.54,11.309,6.821,11.309z"
    }
  }]
};
exports.github = github;
var googlePlus = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.989,5.589c0,1.494,0.499,2.572,1.482,3.205c0.806,0.52,1.74,0.598,2.226,0.598c0.118,0,0.213-0.006,0.279-0.01\r\n\tc0,0-0.154,1.004,0.59,1.996H6.532c-1.289,0-5.493,0.269-5.493,3.727c0,3.516,3.861,3.695,4.636,3.695\r\n\tc0.061,0,0.097-0.002,0.097-0.002c0.008,0,0.063,0.002,0.158,0.002c0.497,0,1.782-0.062,2.975-0.643\r\n\tc1.548-0.75,2.333-2.059,2.333-3.885c0-1.764-1.196-2.814-2.069-3.582c-0.533-0.469-0.994-0.873-0.994-1.266\r\n\tc0-0.4,0.337-0.701,0.762-1.082c0.689-0.615,1.339-1.492,1.339-3.15c0-1.457-0.189-2.436-1.354-3.057\r\n\tc0.121-0.062,0.551-0.107,0.763-0.137c0.631-0.086,1.554-0.184,1.554-0.699V1.2H6.64C6.594,1.202,1.989,1.372,1.989,5.589z\r\n\t M9.413,14.602c0.088,1.406-1.115,2.443-2.922,2.574c-1.835,0.135-3.345-0.691-3.433-2.096c-0.043-0.676,0.254-1.336,0.835-1.863\r\n\tc0.589-0.533,1.398-0.863,2.278-0.928c0.104-0.006,0.207-0.012,0.31-0.012C8.18,12.278,9.33,13.276,9.413,14.602z M8.212,4.626\r\n\tc0.451,1.588-0.23,3.246-1.316,3.553C6.771,8.214,6.643,8.231,6.512,8.231c-0.994,0-1.979-1.006-2.345-2.393\r\n\tC3.963,5.062,3.98,4.38,4.214,3.726c0.229-0.645,0.643-1.078,1.163-1.225c0.125-0.035,0.254-0.053,0.385-0.053\r\n\tC6.962,2.448,7.734,2.946,8.212,4.626z M16,8V5h-2v3h-3v2h3v3h2v-3h3V8H16z"
    }
  }]
};
exports.googlePlus = googlePlus;
var hangouts = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,0C5.25,0,1.4,3.806,1.4,8.5C1.4,13.194,5.25,17,10,17v3c3.368-1.672,8.6-5.305,8.6-11.5C18.6,3.806,14.75,0,10,0z\r\n\t M9,9.741c0,1.328-1.021,2.422-2.32,2.538c-0.123,0.011-0.228-0.088-0.228-0.211v-0.852c0-0.106,0.079-0.194,0.184-0.21\r\n\tC7.167,10.93,7.573,10.519,7.683,10H5.732C5.328,10,5,9.672,5,9.268V6.732C5,6.328,5.328,6,5.732,6h2.536C8.672,6,9,6.328,9,6.732\r\n\tV9.741z M15,9.741c0,1.328-1.021,2.422-2.32,2.538c-0.123,0.011-0.228-0.088-0.228-0.211v-0.852c0-0.106,0.079-0.194,0.184-0.21\r\n\tc0.531-0.077,0.937-0.487,1.047-1.006h-1.951C11.328,10,11,9.672,11,9.268V6.732C11,6.328,11.328,6,11.732,6h2.536\r\n\tC14.672,6,15,6.328,15,6.732V9.741z"
    }
  }]
};
exports.hangouts = hangouts;
var grooveshark = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.grooveshark = grooveshark;
var houzz = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4,10l6,3l-6,3V10z M10,7l6,3V4L10,7z M10,20l6-3v-7l-6,3V20z M10,0L4,3v7l6-3V0z"
    }
  }]
};
exports.houzz = houzz;
var icloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.909,5c1.884,0,3.417,1.598,3.417,3.561c0,0.136-0.012,0.29-0.037,0.484c0,0-0.163,1.262-0.206,1.594\r\n\tc-0.043,0.332,0.186,0.65,0.528,0.653c0.342,0.002,1.65,0.01,1.65,0.01C17.219,11.308,18,12.137,18,13.15\r\n\tc0,1.02-0.785,1.85-1.75,1.85H4.167C2.972,15,2,13.978,2,12.722c0-0.913,0.519-1.735,1.323-2.095c0,0,0.421-0.188,0.651-0.291\r\n\tc0.23-0.103,0.508-0.431,0.516-0.775c0.008-0.344,0.016-0.714,0.016-0.714c0.012-0.535,0.421-0.97,0.91-0.97\r\n\tc0.032,0,0.094,0.006,0.207,0.035c0,0,0.774,0.197,1.039,0.264c0.265,0.067,0.606-0.066,0.73-0.309\r\n\tc0.124-0.243,0.503-0.981,0.503-0.981C8.493,5.723,9.648,5,10.909,5 M10.909,3C8.828,3,7.023,4.207,6.116,5.974\r\n\tC5.891,5.917,5.659,5.878,5.417,5.878c-1.587,0-2.873,1.304-2.91,2.924C1.033,9.461,0,10.966,0,12.722C0,15.085,1.865,17,4.167,17\r\n\tH16.25c2.071,0,3.75-1.724,3.75-3.85c0-2.118-1.667-3.835-3.728-3.848c0.031-0.243,0.053-0.489,0.053-0.741\r\n\tC16.326,5.49,13.901,3,10.909,3L10.909,3z"
    }
  }]
};
exports.icloud = icloud;
var instagram = {
  "viewBox": "0 0 18 18",
  "children": [{
    "name": "title",
    "attribs": {}
  }, {
    "name": "path",
    "attribs": {
      "d": "M18.94586,6.28931a6.60561,6.60561,0,0,0-.41833-2.18463,4.41189,4.41189,0,0,0-1.03809-1.59412,4.41189,4.41189,0,0,0-1.59412-1.03809,6.60561,6.60561,0,0,0-2.18463-.41833C12.75073,1.01038,12.44427,1,10,1s-2.75073.01038-3.71069,0.05414a6.60561,6.60561,0,0,0-2.18463.41833A4.41189,4.41189,0,0,0,2.51056,2.51056,4.41189,4.41189,0,0,0,1.47247,4.10468a6.60561,6.60561,0,0,0-.41833,2.18463C1.01038,7.24927,1,7.55573,1,10s0.01038,2.75073.05414,3.71069a6.60561,6.60561,0,0,0,.41833,2.18463,4.41189,4.41189,0,0,0,1.03809,1.59412,4.41109,4.41109,0,0,0,1.59412,1.03809,6.60561,6.60561,0,0,0,2.18463.41833C7.24927,18.98969,7.55573,19,10,19s2.75073-.01031,3.71069-0.05414a6.60561,6.60561,0,0,0,2.18463-.41833,4.60208,4.60208,0,0,0,2.6322-2.6322,6.60561,6.60561,0,0,0,.41833-2.18463C18.98962,12.75073,19,12.44427,19,10S18.98962,7.24927,18.94586,6.28931Zm-1.61993,7.34747a4.97824,4.97824,0,0,1-.30994,1.67114A2.98017,2.98017,0,0,1,15.30792,17.016a4.9786,4.9786,0,0,1-1.67114.30994C12.68787,17.3692,12.40326,17.37836,10,17.37836s-2.68787-.00916-3.63678-0.05243A4.9786,4.9786,0,0,1,4.69208,17.016a2.78769,2.78769,0,0,1-1.03485-.67322A2.78769,2.78769,0,0,1,2.984,15.30792a4.97824,4.97824,0,0,1-.30994-1.67114C2.6308,12.68774,2.62164,12.40314,2.62164,10s0.00916-2.68774.05243-3.63678A4.9786,4.9786,0,0,1,2.984,4.69208a2.78769,2.78769,0,0,1,.67322-1.03485A2.78769,2.78769,0,0,1,4.69208,2.984a4.9786,4.9786,0,0,1,1.67114-.30994C7.31226,2.6308,7.59686,2.62164,10,2.62164s2.68774,0.00916,3.63678.05243a4.9786,4.9786,0,0,1,1.67114.30994,2.78769,2.78769,0,0,1,1.03485.67322A2.78769,2.78769,0,0,1,17.016,4.69208a4.9786,4.9786,0,0,1,.30994,1.67114c0.04327,0.949.05243,1.2337,0.05243,3.63678S17.3692,12.68774,17.32593,13.63678ZM10,5.37836A4.62164,4.62164,0,1,0,14.62164,10,4.62169,4.62169,0,0,0,10,5.37836ZM10,13a3,3,0,1,1,3-3A3,3,0,0,1,10,13Zm5.88422-7.8042a1.08,1.08,0,1,1-1.08-1.08A1.08,1.08,0,0,1,15.88422,5.1958Z",
      "transform": "translate(-1 -1)"
    }
  }]
};
exports.instagram = instagram;
var lastfm = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.574,14.576C8.097,14.924,7.119,15.6,5.193,15.6C2.532,15.6,0,13.707,0,10.195C0,6.547,2.637,4.4,5.354,4.4\r\n\tc3.047,0,4.183,1.108,5.144,4.109l0.756,2.309c0.551,1.688,1.713,2.91,4.026,2.91c1.558,0,2.382-0.346,2.382-1.199\r\n\tc0-0.67-0.389-1.156-1.557-1.434l-1.559-0.369c-1.9-0.461-2.656-1.455-2.656-3.025c0-2.516,2.016-3.301,4.077-3.301\r\n\tc2.337,0,3.757,0.854,3.94,2.932l-2.291,0.277c-0.092-0.992-0.688-1.408-1.787-1.408c-1.008,0-1.627,0.461-1.627,1.246\r\n\tc0,0.693,0.299,1.109,1.307,1.34l1.466,0.324C18.945,9.572,20,10.543,20,12.414c0,2.309-1.924,3.186-4.766,3.186\r\n\tc-3.963,0-5.338-1.801-6.07-4.041L8.43,9.25c-0.549-1.687-0.99-2.902-3.006-2.902c-1.398,0-3.219,0.916-3.219,3.756\r\n\tc0,2.217,1.523,3.604,3.104,3.604c1.34,0,2.146-0.754,2.564-1.131L8.574,14.576z"
    }
  }]
};
exports.lastfm = lastfm;
var linkedin = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5,3c0,1.1-0.7,2-2,2C1.8,5,1,4.1,1,3.1C1,2,1.8,1,3,1S5,1.9,5,3z M1,19h4V6H1V19z M14.6,6.2c-2.1,0-3.3,1.2-3.8,2h-0.1\r\n\tl-0.2-1.7H6.9C6.9,7.6,7,8.9,7,10.4V19h4v-7.1c0-0.4,0-0.7,0.1-1c0.3-0.7,0.8-1.6,1.9-1.6c1.4,0,2,1.2,2,2.8V19h4v-7.4\r\n\tC19,7.9,17.1,6.2,14.6,6.2z"
    }
  }]
};
exports.linkedin = linkedin;
var medium = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.7502384,5C18.7502384,5,18,5,18,5.7501426s0,8.5002785,0,8.5002785S18,15,18.7502384,15H19v2h-6v-2h1V5.6999512\r\n\th-0.0999756L10.8354492,17H8.1365967L5.0999761,5.6999512H5.0000005V15h1v2h-5v-2h0.2497627c0,0,0.7502373,0,0.7502373-0.7501431\r\n\tc0-0.7501421,0-8.5002775,0-8.5002775S2.0000005,5,1.2497631,5H1.0000005V3h6.6340332l2.3269038,8.6591797h0.0766602L12.3859863,3\r\n\tH19v2H18.7502384z"
    }
  }]
};
exports.medium = medium;
var mixi = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.mixi = mixi;
var onedrive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.429,9.847c0.487-1.961,2.249-3.394,4.341-3.394c1.236,0,2.394,0.505,3.232,1.382c0.354-0.114,0.768-0.202,1.136-0.21\r\n\tv-0.13c0-2.482-1.845-4.495-4.12-4.495C9.392,3,7.998,4.038,7.328,5.531C6.834,5.197,6.257,4.996,5.634,4.996\r\n\tc-1.785,0-3.231,1.577-3.231,3.523c0,0.21,0.024,0.414,0.057,0.613c-1.377,0.136-2.455,1.544-2.455,3.08\r\n\tc0,0.016,0.004,0.029,0.004,0.045C0.008,12.271,0,12.285,0,12.299c0,0.615,0.214,1.177,0.561,1.631C1.053,14.592,1.823,15,2.701,15\r\n\th1.261c-0.246-0.488-0.398-1.032-0.398-1.615C3.563,11.648,4.794,10.193,6.429,9.847z M17.889,11.777\r\n\tc-0.025,0-0.05,0.007-0.075,0.008c0.007-0.074,0.022-0.146,0.022-0.222c0-1.472-1.193-2.664-2.665-2.664\r\n\tc-0.586,0-1.123,0.194-1.564,0.516c-0.546-1.015-1.604-1.712-2.838-1.712c-1.788,0-3.237,1.449-3.237,3.237\r\n\tc0,0.023,0.006,0.043,0.007,0.066C7.421,10.988,7.303,10.97,7.18,10.97c-1.335,0-2.415,1.081-2.415,2.415\r\n\tc0,0.167,0.017,0.33,0.049,0.487C5.042,15.083,6.102,16,7.38,16h10.706v-0.019C19.158,15.879,20,14.987,20,13.889\r\n\tC20,12.723,19.055,11.777,17.889,11.777z"
    }
  }]
};
exports.onedrive = onedrive;
var paypal = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.914,10.677h1.659c3.604,0,5.649-1.623,6.3-4.96c0.021-0.11,0.04-0.216,0.056-0.322c0.036-0.226,0.054-0.429,0.062-0.624\r\n\tC15.997,4.637,16.001,4.558,16,4.484c-0.008-0.391-0.077-0.722-0.216-1.039c-0.129-0.296-0.324-0.587-0.613-0.918\r\n\tC14.318,1.557,12.832,1,11.057,1H5.404C5.006,1,4.667,1.29,4.605,1.683l-1.02,6.571l-1.269,8.185C2.27,16.734,2.498,17,2.796,17\r\n\tl2.772,0l0.849-5.043C6.534,11.217,7.164,10.677,7.914,10.677z M17.017,6.09c-0.792,3.771-3.357,5.772-7.445,5.772H7.914\r\n\tc-0.164,0-0.302,0.118-0.328,0.282L6.481,19h2.907c0.348,0,0.645-0.253,0.699-0.597l0.029-0.15l0.555-3.514l0.036-0.194\r\n\tc0.054-0.344,0.351-0.597,0.699-0.597h0.44c2.85,0,5.081-1.158,5.733-4.506C17.847,8.062,17.711,6.908,17.017,6.09z"
    }
  }]
};
exports.paypal = paypal;
var picasa = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.808,1.823C2.719,3.411,0.8,6.544,0.8,10.021c0,0.633,0.08,1.275,0.221,1.918L8.97,4.7\r\n\tC8.122,3.929,5.894,1.901,5.808,1.823z M13.793,1.626C12.593,1.081,11.317,0.8,9.999,0.8c-0.934,0-1.855,0.156-2.749,0.441\r\n\tl6.543,5.951V1.626z M15.192,2.438v10.617h3.485c0.343-0.982,0.522-2.004,0.522-3.035C19.2,6.987,17.677,4.148,15.192,2.438z\r\n\t M1.463,13.429c0.674,1.693,1.857,3.15,3.368,4.184v-7.25l-2.045,1.861C2.088,12.858,1.506,13.39,1.463,13.429z M6.23,18.425\r\n\tc0.935,0.422,1.913,0.682,2.92,0.775h1.689c3.019-0.281,5.727-2.068,7.199-4.744H6.23V18.425z"
    }
  }]
};
exports.picasa = picasa;
var pinterest = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.617,13.227C8.091,15.981,7.45,18.621,5.549,20C4.963,15.838,6.41,12.713,7.083,9.395\r\n\tc-1.147-1.93,0.138-5.812,2.555-4.855c2.975,1.176-2.576,7.172,1.15,7.922c3.891,0.781,5.479-6.75,3.066-9.199\r\n\tC10.369-0.275,3.708,3.18,4.528,8.245c0.199,1.238,1.478,1.613,0.511,3.322c-2.231-0.494-2.897-2.254-2.811-4.6\r\n\tc0.138-3.84,3.449-6.527,6.771-6.9c4.201-0.471,8.144,1.543,8.689,5.494c0.613,4.461-1.896,9.293-6.389,8.945\r\n\tC10.081,14.411,9.571,13.807,8.617,13.227z"
    }
  }]
};
exports.pinterest = pinterest;
var qq = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.005,13.018c-0.779-0.547-1.751-0.51-2.304,0.277c-0.553,0.785-4.418,5.633-10.751,3.619\r\n\tc0.239,0.209,0.49,0.406,0.755,0.592c4.153,2.926,9.892,1.928,12.816-2.225C18.076,14.494,17.784,13.567,17.005,13.018z\r\n\t M4.785,12.401C4.381,11.53,2.116,5.758,7.025,1.28c-0.3,0.104-0.597,0.221-0.89,0.357C1.526,3.772-0.481,9.24,1.654,13.85\r\n\tc0.403,0.871,1.353,1.084,2.218,0.684C4.736,14.133,5.188,13.272,4.785,12.401z M10.826,0.823c-0.956-0.086-1.614,0.629-1.7,1.578\r\n\tC9.041,3.35,9.561,4.172,10.517,4.258c0.956,0.086,7.087,1.01,8.51,7.502c0.062-0.311,0.106-0.627,0.136-0.949\r\n\tC19.618,5.75,15.886,1.278,10.826,0.823z M6.891,10.53c-0.264,0.619-0.306,1.213-0.094,1.322c0.146,0.076,0.374-0.098,0.588-0.416\r\n\tC7.47,11.783,7.68,12.098,7.98,12.35c-0.314,0.115-0.52,0.305-0.52,0.519c0,0.354,0.556,0.639,1.241,0.639\r\n\tc0.618,0,1.13-0.232,1.225-0.537c0.025,0,0.123,0,0.147,0c0.095,0.305,0.607,0.537,1.226,0.537c0.686,0,1.241-0.285,1.241-0.639\r\n\tc0-0.215-0.205-0.404-0.52-0.519c0.299-0.252,0.51-0.566,0.594-0.914c0.214,0.318,0.442,0.492,0.589,0.416\r\n\tc0.211-0.109,0.17-0.703-0.095-1.322c-0.207-0.488-0.488-0.848-0.702-0.926C12.41,9.573,12.41,9.541,12.41,9.51\r\n\tc0-0.19-0.052-0.363-0.142-0.504c0.002-0.012,0.002-0.023,0.002-0.033c0-0.088-0.021-0.168-0.056-0.238\r\n\tC12.16,7.467,11.335,6.461,10,6.461c-1.336,0-2.161,1.006-2.215,2.273c-0.035,0.07-0.057,0.15-0.057,0.238\r\n\tc0,0.01,0.001,0.021,0.002,0.033C7.642,9.147,7.589,9.321,7.589,9.51c0,0.031,0.001,0.062,0.004,0.094\r\n\tC7.38,9.682,7.098,10.041,6.891,10.53z"
    }
  }]
};
exports.qq = qq;
var raft = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.6734395,19c-0.877316,0-1.6501045-0.3605442-2.1763153-1.0143661\r\n\tc-0.6450326-0.8027058-0.8514075-1.9354591-0.5816016-3.1901903l0.0580709-0.2699594l1.9735143,0.4313974l-0.0580707,0.269063\r\n\tc-0.13937,0.6448536-0.083086,1.1650429,0.1581311,1.4654961c0.148304,0.1838589,0.3591456,0.2780323,0.6262712,0.2780323\r\n\tc0.7754688,0,1.5446839-1.2412777,2.125392-3.4179964c-0.6360989-0.2161474-1.2203803-0.5354357-1.7403374-0.9524832\r\n\tl-0.213522-0.1713028l1.2579031-1.5892649l0.2153087,0.1722002c0.2742729,0.2206316,0.580708,0.4009037,0.9139452,0.5372286\r\n\tc0.1688519-0.968626,0.3037548-2.0323219,0.4029226-3.168664L8.659173,8.1047468l2.0110369,0.1775808l-0.0241213,0.2744446\r\n\tc-0.1018476,1.1695271-0.240324,2.2673035-0.4109631,3.2682171c1.3874464-0.1399126,2.6516027-0.9273701,3.3547068-2.1112471\r\n\tc1.152482-1.9408398,0.694169-4.3704782-1.0890512-5.7776766c-0.7620678-0.601804-1.8814945-0.9433796-2.9267693-0.8913608\r\n\tc-1.3043594,0.0547094-2.4041319,0.642029-3.2680469,1.765815C5.2660508,6.1621122,5.1561627,8.1881561,6.0450931,9.6267452\r\n\tl0.1447301,0.2340851L4.4745007,10.934391l-0.1447301-0.2349815c-1.338309-2.1677494-1.182858-5.1014323,0.3796935-7.1328573\r\n\tc1.2266345-1.59644,2.8794193-2.4716568,4.7805681-2.5514789c1.5518312-0.0609876,3.1134892,0.4205006,4.2570381,1.3218613\r\n\tc2.5944252,2.0466716,3.2573261,5.5875397,1.5768461,8.4180813c-0.7397337,1.2457609-1.8823881,2.1955528-3.2430325,2.7067728\r\n\tc0.2519379,0.3838625,0.4663534,0.8430634,0.712038,1.5139265l0.1581316,0.4394693\r\n\tc0.4967279,1.3874674,0.7236509,1.5112371,1.2453957,1.5112371c0.2358561,0,0.4940481-0.1004505,0.6566467-0.256506\r\n\tc0.3126888-0.2995567,0.4047089-0.8753519,0.2742729-1.7121372l-0.0428829-0.2726507l1.9949551-0.3148041l0.0428829,0.2726507\r\n\tc0.235857,1.513031-0.0678978,2.7229156-0.8773155,3.4987144c-0.5422916,0.5183945-1.2891722,0.8152599-2.0485592,0.8152599\r\n\tc-0.9309206,0-1.684948-0.3479881-2.239747-1.0332012c-0.3850546-0.4735508-0.5985765-0.9641418-0.9050112-1.8179684\r\n\tl-0.152771-0.4260159c-0.3546791-0.9677296-0.6682615-1.4565268-1.1203203-1.7067556\r\n\tc-0.1375828,0.5264664-0.2894602,1.0188513-0.453846,1.4681864C8.4599457,17.8026695,7.2315245,19,5.6734395,19z"
    }
  }]
};
exports.raft = raft;
var rainbow = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,5C4.4771729,5,0,9.4771118,0,15h1.5c0-4.694458,3.8056641-8.5,8.5-8.5s8.5,3.805542,8.5,8.5H20\r\n\tC20,9.4771118,15.5228271,5,10,5z M10,11c-2.2092285,0-4,1.7908325-4,4h1.5c0-1.3807373,1.1192627-2.5,2.5-2.5\r\n\ts2.5,1.1192627,2.5,2.5H14C14,12.7908325,12.2092285,11,10,11z M10,8c-3.8659668,0-7,3.1339722-7,7h1.5\r\n\tc0-3.0375977,2.4624023-5.5,5.5-5.5s5.5,2.4624023,5.5,5.5H17C17,11.1339722,13.8659668,8,10,8z"
    }
  }]
};
exports.rainbow = rainbow;
var rdio = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.203,10.001c0,4.307-3.448,7.799-7.701,7.799S0.8,14.308,0.8,10.001C0.8,5.692,4.248,2.2,8.501,2.2\r\n\tc0.611,0,1.204,0.076,1.774,0.213v4.441c-0.902-0.33-2.01-0.281-3.053,0.223c-1.885,0.91-2.841,2.957-2.135,4.57\r\n\tc0.705,1.615,2.807,2.188,4.691,1.277c1.299-0.627,2.443-2.137,2.443-4.029V3.171c0.162,0.09,0.32,0.188,0.475,0.289\r\n\tc1.464,0.92,3.638,2.152,6.178,2.281c0.99,0.049-0.389,2.541-2.738,3.236C16.18,9.311,16.203,9.653,16.203,10.001z"
    }
  }]
};
exports.rdio = rdio;
var renren = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.468,0.865C4.117,1.594,0.8,5.377,0.8,9.936c0,2.266,0.82,4.338,2.179,5.941c3.221-1.559,5.472-5.086,5.489-9.191V0.865z\r\n\t M10.002,12.258c-0.573,2.373-2.285,4.4-4.418,5.748C6.894,18.725,8.4,19.135,10,19.135c1.602,0,3.108-0.41,4.418-1.129\r\n\tC12.285,16.658,10.574,14.631,10.002,12.258z M11.535,6.643c0,4.123,2.256,7.668,5.487,9.234c1.358-1.603,2.178-3.676,2.178-5.941\r\n\tc0-4.559-3.315-8.34-7.665-9.07V6.643z"
    }
  }]
};
exports.renren = renren;
var scribd = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.643,18.284c0,0.224-0.072,0.492-0.148,0.716h5.737c0.328-0.377,0.513-0.831,0.513-1.342c0-1.385-1.644-2.154-5.241-3.842\r\n\tL4.998,13.58C3.225,12.737,1.912,11.995,1,11.111v4.398c0.176-0.024,0.359-0.042,0.558-0.042\r\n\tC4.559,15.468,4.643,18.256,4.643,18.284z M17,1h-3.738c1.748,1.178,2.467,2.842,2.467,4.142c0,2.194-1.836,2.905-2.727,2.905\r\n\tl-0.271,0.002c-2.046,0-3.09-1.247-3.104-3.707C9.506,4.246,8.939,3.889,7.28,3.889c-1.96,0-2.773,1.543-2.773,2.369\r\n\tc0,0.973,0.543,2.055,4.484,3.382c6.736,2.254,6.736,5.255,6.736,7.903v0.026c0,0.437-0.031,0.924-0.117,1.431H17c1.1,0,2-0.899,2-2\r\n\tV3C19,1.9,18.1,1,17,1z"
    }
  }]
};
exports.scribd = scribd;
var weibo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.688,10.068c-0.274-0.084-0.463-0.142-0.319-0.508c0.311-0.797,0.344-1.484,0.007-1.975\r\n\tc-0.633-0.92-2.364-0.871-4.348-0.025c0-0.002-0.623,0.277-0.464-0.227C9.87,6.336,9.823,5.5,9.348,5.018\r\n\tC8.272,3.92,5.411,5.059,2.956,7.557C1.117,9.428,0.05,11.41,0.05,13.125c0,3.281,4.132,5.475,8.175,5.475\r\n\tc5.299,0,8.825-3.334,8.825-5.822C17.05,11.273,15.806,10.42,14.688,10.068z M8.236,17.129c-3.225,0.32-6.011-1.147-6.22-3.275\r\n\tc-0.209-2.129,2.236-4.115,5.462-4.438c3.226-0.32,6.011,1.146,6.22,3.275C13.907,14.822,11.462,16.809,8.236,17.129z M19.95,7.397\r\n\tc-0.001-3.312-2.686-5.996-6-5.996c-0.387,0-0.699,0.312-0.699,0.699s0.312,0.699,0.699,0.699c2.541,0,4.601,2.061,4.601,4.602\r\n\tc0,0.387,0.313,0.699,0.7,0.699S19.95,7.787,19.95,7.4V7.397z M17.169,7.295c-0.319-1.562-1.551-2.793-3.113-3.113\r\n\tc-0.378-0.078-0.748,0.166-0.826,0.545c-0.077,0.377,0.166,0.748,0.545,0.826c1.016,0.207,1.816,1.008,2.024,2.023\r\n\tc0.078,0.379,0.448,0.621,0.826,0.545C17.002,8.043,17.247,7.672,17.169,7.295z M6.582,11.502c-1.3,0.262-2.177,1.352-1.959,2.434\r\n\tc0.218,1.084,1.447,1.75,2.747,1.488c1.299-0.262,2.176-1.352,1.959-2.434C9.111,11.908,7.88,11.24,6.582,11.502z"
    }
  }]
};
exports.weibo = weibo;
var skype = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.671,12.037c0.132-0.623,0.203-1.272,0.203-1.938c0-4.986-3.93-9.029-8.777-9.029c-0.511,0-1.012,0.047-1.5,0.133\r\n\tC7.812,0.695,6.885,0.4,5.89,0.4C3.079,0.4,0.8,2.744,0.8,5.637c0,0.965,0.256,1.871,0.699,2.648\r\n\tC1.383,8.871,1.321,9.479,1.321,10.1c0,4.986,3.93,9.029,8.775,9.029c0.551,0,1.087-0.051,1.607-0.15\r\n\tc0.717,0.396,1.535,0.621,2.406,0.621c2.811,0,5.09-2.344,5.09-5.236C19.2,13.527,19.009,12.738,18.671,12.037z M14.599,14.416\r\n\tc-0.406,0.59-1.006,1.059-1.783,1.391c-0.769,0.33-1.692,0.496-2.742,0.496c-1.26,0-2.317-0.227-3.143-0.678\r\n\tc-0.59-0.328-1.076-0.771-1.445-1.318c-0.372-0.555-0.561-1.104-0.561-1.633c0-0.33,0.123-0.617,0.365-0.852\r\n\tc0.24-0.232,0.549-0.352,0.916-0.352c0.301,0,0.562,0.094,0.773,0.277c0.202,0.176,0.375,0.438,0.514,0.773\r\n\tc0.156,0.367,0.326,0.676,0.505,0.92c0.172,0.234,0.42,0.432,0.735,0.586c0.318,0.154,0.748,0.232,1.275,0.232\r\n\tc0.725,0,1.32-0.158,1.768-0.473c0.438-0.309,0.65-0.676,0.65-1.127c0-0.357-0.111-0.637-0.34-0.857\r\n\tc-0.238-0.228-0.555-0.408-0.936-0.531c-0.399-0.127-0.941-0.266-1.611-0.41c-0.91-0.201-1.683-0.439-2.299-0.707\r\n\tc-0.63-0.275-1.137-0.658-1.508-1.137C5.357,8.533,5.165,7.924,5.165,7.209c0-0.682,0.2-1.297,0.596-1.828\r\n\tc0.393-0.525,0.965-0.935,1.703-1.217C8.192,3.887,9.06,3.746,10.04,3.746c0.783,0,1.473,0.094,2.047,0.277\r\n\tc0.578,0.186,1.066,0.436,1.449,0.744c0.387,0.311,0.674,0.643,0.854,0.986c0.182,0.35,0.275,0.695,0.275,1.031\r\n\tc0,0.322-0.121,0.615-0.361,0.871c-0.24,0.258-0.543,0.387-0.9,0.387c-0.324,0-0.58-0.082-0.756-0.242\r\n\tc-0.164-0.148-0.336-0.383-0.524-0.717c-0.219-0.428-0.484-0.766-0.788-1.002c-0.295-0.232-0.788-0.35-1.466-0.35\r\n\tc-0.629,0-1.141,0.131-1.519,0.387C7.983,6.367,7.806,6.65,7.806,6.984c0,0.207,0.058,0.379,0.176,0.525\r\n\tc0.125,0.158,0.301,0.295,0.523,0.41C8.735,8.039,8.972,8.133,9.21,8.201c0.244,0.07,0.654,0.172,1.215,0.307\r\n\tc0.711,0.156,1.363,0.332,1.939,0.521c0.585,0.193,1.09,0.43,1.502,0.705c0.42,0.283,0.754,0.645,0.989,1.076\r\n\tc0.237,0.434,0.357,0.969,0.357,1.59C15.213,13.145,15.006,13.822,14.599,14.416z"
    }
  }]
};
exports.skype = skype;
var slideshare = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13,7.08c1.381,0,2.5-1.119,2.5-2.5s-1.119-2.5-2.5-2.5s-2.5,1.119-2.5,2.5S11.62,7.08,13,7.08z M18.845,5.943\r\n\tC15.265,8.498,13.616,8.051,12,8c-1.118-0.057-1.5,0.298-1.5,1.08l0.001,6c0,5,8.421,3.43,5.165-4.949\r\n\tc1.671-0.959,3.076-2.434,3.876-3.412C19.953,6.111,19.514,5.474,18.845,5.943z M7,2.08c-1.381,0-2.5,1.119-2.5,2.5\r\n\ts1.119,2.5,2.5,2.5s2.5-1.119,2.5-2.5S8.38,2.08,7,2.08z M8,8C6.384,8.051,4.735,8.498,1.155,5.943\r\n\tC0.486,5.474,0.047,6.111,0.458,6.718c0.8,0.979,2.205,2.453,3.876,3.412c-3.256,8.379,5.165,9.949,5.165,4.949l0.001-6\r\n\tC9.5,8.298,9.118,7.943,8,8z"
    }
  }]
};
exports.slideshare = slideshare;
var smashing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.023,16.032c-2.508,0-4.253-1.555-4.253-1.555L4.287,17.84c1.023,0.547,2.092,0.936,2.709,1.141l-1.592,0.381\r\n\tc-0.746,0.178-1.496-0.283-1.675-1.029L0.639,5.405C0.46,4.659,0.92,3.909,1.667,3.729L5.383,2.84\r\n\tc-0.91,1.029-1.263,2.252-1.174,3.65c0.139,2.193,2.237,3.879,4.734,4.822C13.644,13.088,12.529,16.032,10.023,16.032z\r\n\t M19.361,14.594L16.27,1.666c-0.178-0.746-0.928-1.207-1.675-1.027l-2.663,0.637c0.679,0.105,2.024,0.4,3.505,1.178l-1.159,3.213\r\n\tc0,0-0.965-1.078-3.553-1.209c-2.46-0.125-3.828,2.537,0.969,4.105c3.674,1.201,4.848,3.516,4.787,5.658\r\n\tc-0.031,1.113-0.421,2.018-0.872,2.701l2.725-0.652C19.08,16.092,19.54,15.342,19.361,14.594z"
    }
  }]
};
exports.smashing = smashing;
var soundcloud = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0.672,13.055L1,11.654l-0.328-1.447c-0.009-0.043-0.092-0.076-0.191-0.076c-0.102,0-0.184,0.033-0.191,0.076L0,11.654\r\n\tl0.289,1.4c0.008,0.045,0.09,0.076,0.191,0.076C0.58,13.131,0.663,13.1,0.672,13.055z M2.723,13.832L3,11.668L2.723,8.32\r\n\tC2.714,8.236,2.609,8.168,2.484,8.168c-0.127,0-0.233,0.068-0.238,0.152L2,11.668l0.246,2.164c0.006,0.086,0.111,0.152,0.238,0.152\r\n\tC2.609,13.984,2.714,13.918,2.723,13.832z M4.768,13.797L5,11.67L4.768,7.213C4.762,7.107,4.639,7.025,4.486,7.025\r\n\tc-0.152,0-0.275,0.082-0.281,0.188L4,11.67l0.205,2.129c0.006,0.103,0.129,0.186,0.281,0.186\r\n\tC4.639,13.984,4.762,13.902,4.768,13.797z M6.81,13.766L7,11.67L6.81,7.18C6.805,7.057,6.664,6.959,6.49,6.959\r\n\tc-0.176,0-0.316,0.098-0.321,0.221L6,11.67l0.17,2.096c0.004,0.123,0.145,0.221,0.32,0.221C6.664,13.986,6.805,13.891,6.81,13.766z\r\n\t M8.85,13.738L9,11.672L8.85,6.523C8.846,6.381,8.686,6.268,8.492,6.268c-0.194,0-0.354,0.115-0.357,0.256L8,11.67l0.135,2.068\r\n\tc0.003,0.141,0.163,0.256,0.357,0.256C8.686,13.994,8.846,13.881,8.85,13.738z M10.277,13.996c0.008,0,7.1,0.004,7.145,0.004\r\n\tC18.846,14,20,12.883,20,11.506c0-1.377-1.154-2.492-2.578-2.492c-0.353,0-0.689,0.07-0.996,0.193\r\n\tc-0.205-2.246-2.153-4.008-4.529-4.008c-0.581,0-1.148,0.111-1.648,0.297C10.053,5.57,10.002,5.644,10,5.791v7.91\r\n\tC10.002,13.854,10.124,13.98,10.277,13.996z"
    }
  }]
};
exports.soundcloud = soundcloud;
var spotify = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "g",
    "attribs": {}
  }]
};
exports.spotify = spotify;
var stumbleupon = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.051,8.059l1.365,0.66l2.059-0.66V6.865C14.475,4.402,12.467,2.4,10,2.4S5.525,4.402,5.525,6.865v6.27\r\n\tc0,0.578-0.472,1.049-1.051,1.049c-0.58,0-1.051-0.471-1.051-1.049V10.51H0v2.625C0,15.596,2.007,17.6,4.475,17.6\r\n\tc2.467,0,4.474-2.004,4.474-4.465v-6.27c0-0.578,0.472-1.049,1.052-1.049c0.579,0,1.051,0.471,1.051,1.049V8.059z M16.576,10.51\r\n\tv2.625c0,0.578-0.471,1.049-1.051,1.049c-0.58,0-1.051-0.471-1.051-1.049v-2.678l-2.059,0.658l-1.365-0.658v2.678\r\n\tc0,2.461,2.008,4.465,4.475,4.465S20,15.596,20,13.135V10.51H16.576z"
    }
  }]
};
exports.stumbleupon = stumbleupon;
var swarm = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.286,18.821c-1.429-0.232-2.733-0.607-3.677-0.923c-0.046-0.015-0.781-0.282-1.007-0.37\r\n\tc-0.278-0.107-0.423-0.431-0.317-0.71c0.086-0.225,0.379-0.949,0.399-0.994c0.4-0.92,1-2.153,1.795-3.379\r\n\tc0.029,1.203,0.297,2.399,0.791,3.506C8.75,17.028,9.439,18.007,10.286,18.821z M10.173,7.027c-2.791-5.689-8.99-5.486-9.968-2.943\r\n\tc-0.751,1.952,2.535,6.602,10.097,3.244c0.002-0.001,0.002-0.001,0.004-0.002C10.28,7.279,10.192,7.079,10.173,7.027z M11.56,6.805\r\n\tc0.001,0,0.002-0.001,0.002-0.001c4.271-1.897,3.674-5.191,2.569-5.614c-1.487-0.569-4.19,1.624-2.647,5.447\r\n\tC11.499,6.664,11.55,6.777,11.56,6.805z M19.413,10.97C18.767,9.52,17.58,8.481,16.2,7.986c-0.139-0.05-0.281-0.073-0.423-0.073\r\n\tc-0.717,0-1.407,0.595-1.472,1.338c-0.109,1.239,0.137,2.501,0.68,3.718c0.535,1.199,1.294,2.213,2.27,2.957\r\n\tc0.254,0.194,0.565,0.285,0.875,0.285c0.559,0,1.117-0.296,1.339-0.826C20.04,14.023,20.066,12.432,19.413,10.97z M16.172,17.339\r\n\tc-1.195-0.912-2.142-2.139-2.815-3.646c-0.682-1.529-0.961-3.075-0.827-4.596c0.037-0.423,0.161-0.831,0.36-1.204\r\n\tc-0.035,0.009-0.111,0.027-0.114,0.028c-0.628,0.157-1.237,0.429-1.778,0.784c-0.784,0.514-1.475,1.277-1.772,2.177\r\n\tc-0.08,0.243-0.141,0.51-0.161,0.765c-0.095,1.218,0.103,2.476,0.636,3.67c0.516,1.155,1.285,2.118,2.213,2.853\r\n\tC12.48,18.617,13.5,18.9,14.334,18.9c0.783,0,1.556-0.233,2.25-0.585c0.217-0.11,0.695-0.408,0.726-0.429\r\n\tC16.895,17.78,16.506,17.594,16.172,17.339z"
    }
  }]
};
exports.swarm = swarm;
var tripadvisor = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20,6.0090332h-2.8286133C15.2119141,4.6748047,12.8125,4,10,4S4.7880859,4.6748047,2.8286133,6.0090332H0\r\n\tC0.4279785,6.4293823,0.8271484,7.348877,0.9931641,8.0480957C0.3771973,8.8793335,0,9.8972778,0,11.0090332\r\n\tc0,2.7568359,2.2431641,5,5,5c1.3266602,0,2.5268555-0.5282593,3.4228516-1.3746338L10,17l1.5771484-2.3656006\r\n\tC12.4731445,15.4807739,13.6733398,16.0090332,15,16.0090332c2.7568359,0,5-2.2431641,5-5\r\n\tc0-1.1117554-0.3771973-2.1296997-0.9931641-2.9609375C19.1728516,7.348877,19.5720215,6.4293823,20,6.0090332z M5,14.4090576\r\n\tc-1.8745117,0-3.3999023-1.5254517-3.3999023-3.4000244S3.1254883,7.6090088,5,7.6090088s3.3999023,1.5254517,3.3999023,3.4000244\r\n\tS6.8745117,14.4090576,5,14.4090576z M10,11.0090332c0-2.4172974-1.7250977-4.4382935-4.0085449-4.8997803\r\n\tC7.1948242,5.7042847,8.5290527,5.5,10,5.5s2.8051758,0.2042847,4.0085449,0.6092529\r\n\tC11.7250977,6.5707397,10,8.5917358,10,11.0090332z M15,14.4090576c-1.8745117,0-3.3999023-1.5254517-3.3999023-3.4000244\r\n\tS13.1254883,7.6090088,15,7.6090088s3.3999023,1.5254517,3.3999023,3.4000244S16.8745117,14.4090576,15,14.4090576z M5,8.8590088\r\n\tc-1.1850586,0-2.1499023,0.9644775-2.1499023,2.1500244S3.8149414,13.1590576,5,13.1590576s2.1499023-0.9644775,2.1499023-2.1500244\r\n\tS6.1850586,8.8590088,5,8.8590088z M5,11.6500244c-0.3588867,0-0.6499023-0.2910156-0.6499023-0.6500244\r\n\tS4.6411133,10.3499756,5,10.3499756S5.6499023,10.6409912,5.6499023,11S5.3588867,11.6500244,5,11.6500244z M15,8.8590088\r\n\tc-1.1850586,0-2.1499023,0.9644775-2.1499023,2.1500244S13.8149414,13.1590576,15,13.1590576\r\n\ts2.1499023-0.9644775,2.1499023-2.1500244S16.1850586,8.8590088,15,8.8590088z M15,11.6500244\r\n\tc-0.3588867,0-0.6499023-0.2910156-0.6499023-0.6500244S14.6411133,10.3499756,15,10.3499756S15.6499023,10.6409912,15.6499023,11\r\n\tS15.3588867,11.6500244,15,11.6500244z"
    }
  }]
};
exports.tripadvisor = tripadvisor;
var tumblr = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6,18.196c-0.777,0.371-1.48,0.631-2.109,0.781c-0.63,0.148-1.311,0.223-2.043,0.223c-0.831,0-1.566-0.107-2.205-0.318\r\n\tc-0.639-0.213-1.183-0.516-1.635-0.908c-0.451-0.395-0.764-0.812-0.938-1.254c-0.174-0.443-0.261-1.086-0.261-1.926V8.339H4.4V5.735\r\n\tc0.714-0.234,1.326-0.57,1.835-1.01c0.51-0.438,0.918-0.965,1.227-1.58C7.77,2.532,7.981,1.749,8.098,0.8h2.585v4.652h4.314v2.887\r\n\th-4.314v4.719c0,1.066,0.056,1.752,0.168,2.055c0.111,0.303,0.319,0.545,0.622,0.725c0.403,0.244,0.863,0.367,1.381,0.367\r\n\tc0.92,0,1.836-0.303,2.746-0.908V18.196z"
    }
  }]
};
exports.tumblr = tumblr;
var twitter = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.316,6.246c0.008,0.162,0.011,0.326,0.011,0.488c0,4.99-3.797,10.742-10.74,10.742c-2.133,0-4.116-0.625-5.787-1.697\r\n\tc0.296,0.035,0.596,0.053,0.9,0.053c1.77,0,3.397-0.604,4.688-1.615c-1.651-0.031-3.046-1.121-3.526-2.621\r\n\tc0.23,0.043,0.467,0.066,0.71,0.066c0.345,0,0.679-0.045,0.995-0.131c-1.727-0.348-3.028-1.873-3.028-3.703c0-0.016,0-0.031,0-0.047\r\n\tc0.509,0.283,1.092,0.453,1.71,0.473c-1.013-0.678-1.68-1.832-1.68-3.143c0-0.691,0.186-1.34,0.512-1.898\r\n\tC3.942,5.498,6.725,7,9.862,7.158C9.798,6.881,9.765,6.594,9.765,6.297c0-2.084,1.689-3.773,3.774-3.773\r\n\tc1.086,0,2.067,0.457,2.756,1.191c0.859-0.17,1.667-0.484,2.397-0.916c-0.282,0.881-0.881,1.621-1.66,2.088\r\n\tc0.764-0.092,1.49-0.293,2.168-0.594C18.694,5.051,18.054,5.715,17.316,6.246z"
    }
  }]
};
exports.twitter = twitter;
var vimeo = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.91,5.84c-1.006,5.773-6.625,10.66-8.315,11.777c-1.69,1.115-3.233-0.447-3.792-1.631\r\n\tC6.162,14.639,4.244,7.33,3.741,6.725C3.238,6.119,1.731,7.33,1.731,7.33L1,6.354c0,0,3.061-3.725,5.391-4.191\r\n\tC8.861,1.67,8.857,6.027,9.451,8.445c0.574,2.342,0.961,3.68,1.463,3.68c0.502,0,1.462-1.305,2.512-3.305\r\n\tc1.053-2.004-0.045-3.772-2.101-2.514C12.148,1.279,19.916,0.07,18.91,5.84z"
    }
  }]
};
exports.vimeo = vimeo;
var vine = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.452,9.951c-0.438,0.101-0.863,0.145-1.244,0.145c-2.145,0-3.797-1.496-3.797-4.102c0-1.277,0.493-1.941,1.192-1.941\r\n\tc0.664,0,1.107,0.596,1.107,1.805c0,0.688-0.184,1.44-0.32,1.887c0,0,0.66,1.152,2.469,0.799c0.385-0.852,0.593-1.956,0.593-2.924\r\n\tc0-2.605-1.33-4.119-3.763-4.119c-2.504,0-3.968,1.922-3.968,4.461c0,2.512,1.175,4.668,3.113,5.651\r\n\tc-0.815,1.629-1.852,3.065-2.933,4.146c-1.961-2.371-3.734-5.534-4.463-11.706H2.548c1.335,10.279,5.319,13.553,6.373,14.181\r\n\tc0.596,0.358,1.108,0.341,1.654,0.034c0.855-0.485,3.422-3.054,4.847-6.061c0.597-0.002,1.314-0.069,2.03-0.231V9.951z"
    }
  }]
};
exports.vine = vine;
var alternitive = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19,17V3c0-1.1-0.903-2-2.005-2H3.005C1.855,1,1,1.853,1,3v14c0,1.148,0.855,2,2.005,2h13.99C18.097,19,19,18.101,19,17z\r\n\t M15.184,11.607c0,0,1.132,1.117,1.411,1.635c0.008,0.011,0.011,0.021,0.014,0.025c0.113,0.19,0.142,0.34,0.085,0.45\r\n\tC16.6,13.9,16.28,13.992,16.171,14c0,0-1.943,0-1.999,0c-0.14,0-0.43-0.036-0.782-0.279c-0.27-0.188-0.537-0.499-0.797-0.802\r\n\tc-0.388-0.45-0.724-0.84-1.062-0.84c-0.043,0-0.086,0.007-0.126,0.021c-0.257,0.082-0.583,0.447-0.583,1.422\r\n\tc0,0.305-0.24,0.479-0.41,0.479c0,0-0.872,0-0.916,0c-0.312,0-1.937-0.109-3.376-1.628c-1.766-1.86-3.352-5.591-3.366-5.624\r\n\tc-0.1-0.241,0.107-0.372,0.332-0.372h2.02c0.271,0,0.358,0.164,0.42,0.311C5.596,6.855,5.86,7.529,6.292,8.287\r\n\tc0.703,1.233,1.136,1.735,1.481,1.735c0.064,0,0.126-0.017,0.184-0.049c0.451-0.249,0.367-1.857,0.347-2.189\r\n\tc0-0.063-0.001-0.719-0.231-1.034C7.907,6.522,7.626,6.435,7.456,6.402c0.045-0.065,0.142-0.166,0.266-0.226\r\n\tC8.031,6.022,8.588,6,9.142,6h0.308c0.601,0.008,0.757,0.047,0.974,0.102c0.439,0.105,0.448,0.39,0.409,1.36\r\n\tc-0.011,0.276-0.023,0.589-0.023,0.956c0,0.079-0.003,0.166-0.003,0.256c-0.014,0.496-0.03,1.057,0.32,1.287\r\n\tc0.046,0.028,0.097,0.044,0.151,0.044c0.122,0,0.487,0,1.476-1.697c0.435-0.749,0.77-1.633,0.793-1.699\r\n\tc0.02-0.036,0.079-0.142,0.148-0.183c0.056-0.033,0.128-0.039,0.166-0.039h2.375c0.26,0,0.436,0.039,0.469,0.138\r\n\tc0.057,0.159-0.011,0.644-1.096,2.11c-0.184,0.243-0.343,0.455-0.483,0.64C14.142,10.563,14.142,10.629,15.184,11.607z"
    }
  }]
};
exports.alternitive = alternitive;
var vk = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.802,12.298c0,0,1.617,1.597,2.017,2.336c0.011,0.016,0.016,0.028,0.018,0.035\r\n\tc0.163,0.273,0.203,0.487,0.123,0.645c-0.135,0.261-0.592,0.392-0.747,0.403c0,0-2.778,0-2.858,0c-0.199,0-0.613-0.052-1.117-0.4\r\n\tc-0.385-0.269-0.768-0.712-1.139-1.145c-0.554-0.643-1.033-1.201-1.518-1.201c-0.062,0-0.122,0.01-0.18,0.03\r\n\tc-0.367,0.116-0.833,0.639-0.833,2.032c0,0.436-0.344,0.684-0.585,0.684c0,0-1.248,0-1.309,0c-0.446,0-2.768-0.156-4.827-2.327\r\n\tc-2.523-2.658-4.789-7.99-4.811-8.037C-0.105,5.008,0.191,4.82,0.511,4.82h2.886c0.387,0,0.513,0.234,0.601,0.444\r\n\tc0.102,0.241,0.48,1.205,1.1,2.288c1.004,1.762,1.621,2.479,2.114,2.479c0.093,0,0.181-0.023,0.264-0.07\r\n\tc0.644-0.354,0.524-2.654,0.494-3.128c0-0.092-0.001-1.027-0.331-1.479C7.403,5.03,7.001,4.904,6.758,4.858\r\n\tc0.065-0.094,0.203-0.238,0.38-0.323c0.441-0.22,1.238-0.252,2.029-0.252h0.439c0.858,0.012,1.08,0.067,1.392,0.146\r\n\tc0.628,0.15,0.64,0.557,0.585,1.943c-0.016,0.396-0.033,0.842-0.033,1.367c0,0.112-0.005,0.237-0.005,0.364\r\n\tc-0.019,0.711-0.044,1.512,0.458,1.841c0.064,0.04,0.139,0.062,0.217,0.062c0.174,0,0.695,0,2.108-2.425\r\n\tc0.62-1.071,1.1-2.334,1.133-2.429c0.028-0.053,0.112-0.202,0.214-0.262c0.078-0.048,0.182-0.056,0.236-0.056h3.395\r\n\tc0.37,0,0.621,0.056,0.67,0.196c0.082,0.227-0.016,0.92-1.566,3.016c-0.261,0.349-0.49,0.651-0.691,0.915\r\n\tC16.314,10.805,16.314,10.898,17.802,12.298z"
    }
  }]
};
exports.vk = vk;
var xing = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.703,1h-2.828c-0.223,0-0.553,0.105-0.69,0.381S13.875,2,13.875,2l-5,10l3,6c0,0,0.172,0.344,0.31,0.619\r\n\tS12.652,19,12.875,19h2.828c0.5,0,0.48-0.381,0.355-0.631S15.875,18,15.875,18l-3-6l5-10c0,0,0.059-0.119,0.184-0.369\r\n\tS18.203,1,17.703,1z M6.815,5.381C6.678,5.105,6.348,5,6.125,5H3.297c-0.5,0-0.48,0.381-0.355,0.631S3.125,6,3.125,6l1.25,2.5\r\n\tL2.125,13c0,0-0.059,0.119-0.184,0.369S1.797,14,2.297,14h2.828c0.223,0,0.553-0.106,0.691-0.381C5.953,13.344,6.125,13,6.125,13\r\n\tl2.25-4.5L7.125,6C7.125,6,6.953,5.656,6.815,5.381z"
    }
  }]
};
exports.xing = xing;
var yelp = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.538,12.471l4.523,1.466c0,0,0.647,0.119,0.64,0.552c-0.004,0.305-0.197,0.652-0.197,0.652l-1.91,2.756\r\n\tc0,0-0.341,0.286-0.686,0.286c-0.344,0-0.741-0.537-0.741-0.537l-2.417-4.073c0,0-0.272-0.594,0.05-0.921\r\n\tC12.095,12.352,12.538,12.471,12.538,12.471z M11.57,10.6c0.231,0.396,0.87,0.281,0.87,0.281l4.513-1.331\r\n\tc0,0,0.615-0.253,0.703-0.589c0.086-0.337-0.102-0.743-0.102-0.743l-2.157-2.564c0,0-0.187-0.324-0.575-0.357\r\n\tc-0.428-0.037-0.691,0.486-0.691,0.486l-2.55,4.05C11.582,9.832,11.357,10.235,11.57,10.6z M9.438,9.021\r\n\tc0.531-0.132,0.616-0.911,0.616-0.911l-0.036-6.485c0,0-0.08-0.8-0.436-1.017c-0.559-0.342-0.724-0.164-0.884-0.14L4.951,1.873\r\n\tc0,0-0.367,0.123-0.558,0.432C4.12,2.742,4.67,3.384,4.67,3.384l3.894,5.358C8.564,8.742,8.949,9.143,9.438,9.021z M8.513,11.645\r\n\tc0.013-0.5-0.595-0.801-0.595-0.801L3.89,8.791c0,0-0.597-0.248-0.887-0.075C2.782,8.848,2.585,9.088,2.566,9.299l-0.262,3.259\r\n\tc0,0-0.039,0.565,0.106,0.822c0.205,0.364,0.881,0.111,0.881,0.111l4.702-1.049C8.175,12.318,8.495,12.306,8.513,11.645z\r\n\t M9.682,13.404c-0.404-0.209-0.887,0.224-0.887,0.224l-3.148,3.498c0,0-0.393,0.535-0.293,0.863c0.094,0.308,0.25,0.461,0.47,0.569\r\n\tl3.162,1.007c0,0,0.383,0.08,0.674-0.005c0.412-0.121,0.336-0.772,0.336-0.772l0.071-4.736\r\n\tC10.067,14.053,10.051,13.597,9.682,13.404z"
    }
  }]
};
exports.yelp = yelp;
var youko = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.418047,12.0796385c-0.5478516-1.0457487-2.1255493-1.7149191-2.8060303-2.6412954\r\n\tc0.4585571-1.0617428,2.9511719-1.7141776,2.7406616-3.5655117c-0.1517944-1.3371668-2.1604614-1.4112105-2.6756592-0.3305092\r\n\tc-0.3861084,0.4457431-0.7995005,0.8636346-1.2400522,1.254293c-0.2116089,0.269928-0.4511719,0.5119433-0.7175293,0.7264161\r\n\tc-0.3097534,0.3260632-0.5610962,0.7093105-0.979187,0.9249573V5.8728313c-0.0095825-1.400774-2.6002808-1.400774-2.6101685,0\r\n\tv7.3295012c0.1132812,0.5230598,0.3482666,0.9234743,0.9133911,0.9899845h0.7833252\r\n\tc0.5371704-0.0944233,0.8428955-0.4238205,0.9134521-0.9899845v-1.5851727c0-0.549428-0.1014404-1.4766083,0.2612305-0.9241543\r\n\tc0.5316772,0.5263948,1.2804565,1.0925589,1.9580078,1.7160301c0.6503305,0.6000061,1.272706,1.5688076,1.9572153,1.7170801\r\n\tC19.3184376,14.4302559,19.9368458,13.068881,19.418047,12.0796385z M8.1933756,4.1556897\r\n\tC7.636735,4.5449276,7.3271646,5.7449384,6.9533243,6.5988774C6.5416422,7.5382848,6.1798868,8.4847937,5.7787027,9.1743431\r\n\tC4.6934977,7.9286342,3.9533243,5.1675968,2.6461954,4.1556897c-0.4216309-0.3260012-1.3457031-0.3167379-1.7619629,0\r\n\tC-0.241744,5.0133343,0.8880777,6.5300832,1.3409586,7.3256645c0.9940186,1.7442522,2.0955811,3.6115799,2.9366455,5.2160816\r\n\tc-0.5467529,1.4587612-3.3081665,5.5814819,0.3916626,5.3487911c0.8953857-0.5855541,1.2750854-1.8037815,1.762146-2.9060354\r\n\tc0.9957275-2.255393,1.8415527-4.204113,2.8713989-6.5365133c0.4280396-0.9695439,1.4592285-2.4023066,1.2398682-3.500052\r\n\tC10.3683634,4.0776324,9.0449381,3.5608718,8.1933756,4.1556897z"
    }
  }]
};
exports.youko = youko;
var youtube = {
  "viewBox": "0 0 20 20",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10,2.3C0.172,2.3,0,3.174,0,10s0.172,7.7,10,7.7s10-0.874,10-7.7S19.828,2.3,10,2.3z M13.205,10.334l-4.49,2.096\r\n\tC8.322,12.612,8,12.408,8,11.974V8.026C8,7.593,8.322,7.388,8.715,7.57l4.49,2.096C13.598,9.85,13.598,10.15,13.205,10.334z"
    }
  }]
};
exports.youtube = youtube;

/***/ }),
/* 1404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.arrowRight = exports.arrowLeft = exports.ban = exports.checkCircleO = exports.timesCircleO = exports.crosshairs = exports.infoCircle = exports.questionCircle = exports.checkCircle = exports.timesCircle = exports.minusCircle = exports.plusCircle = exports.chevronRight = exports.chevronLeft = exports.eject = exports.stepForward = exports.fastForward = exports.forward = exports.stop = exports.pause = exports.play = exports.backward = exports.fastBackward = exports.stepBackward = exports.arrows = exports.checkSquareO = exports.shareSquareO = exports.pencilSquareO = exports.edit = exports.tint = exports.adjust = exports.mapMarker = exports.pencil = exports.pictureO = exports.photo = exports.image = exports.videoCamera = exports.indent = exports.outdent = exports.dedent = exports.list = exports.alignJustify = exports.alignRight = exports.alignCenter = exports.alignLeft = exports.textWidth = exports.textHeight = exports.italic = exports.bold = exports.font = exports.camera = exports.print = exports.bookmark = exports.book = exports.tags = exports.tag = exports.barcode = exports.qrcode = exports.volumeUp = exports.volumeDown = exports.volumeOff = exports.headphones = exports.flag = exports.lock = exports.listAlt = exports.refresh = exports.rotateRight = exports.repeat = exports.playCircleO = exports.inbox = exports.arrowCircleOUp = exports.arrowCircleODown = exports.download = exports.road = exports.clockO = exports.fileO = exports.home = exports.trashO = exports.gear = exports.cog = exports.signal = exports.powerOff = exports.searchMinus = exports.searchPlus = exports.times = exports.remove = exports.close = exports.check = exports.thList = exports.th = exports.thLarge = exports.film = exports.user = exports.starO = exports.star = exports.heart = exports.envelopeO = exports.search = exports.music = exports.glass = void 0;
exports.listUl = exports.reorder = exports.navicon = exports.bars = exports.square = exports.save = exports.floppyO = exports.paperclip = exports.filesO = exports.copy = exports.scissors = exports.cut = exports.flask = exports.cloud = exports.link = exports.chain = exports.users = exports.group = exports.arrowsAlt = exports.briefcase = exports.filter = exports.tasks = exports.wrench = exports.globe = exports.arrowCircleDown = exports.arrowCircleUp = exports.arrowCircleRight = exports.arrowCircleLeft = exports.handODown = exports.handOUp = exports.handOLeft = exports.handORight = exports.certificate = exports.bellO = exports.bullhorn = exports.hddO = exports.rss = exports.feed = exports.creditCard = exports.unlock = exports.github = exports.facebookF = exports.facebook = exports.twitter = exports.phoneSquare = exports.bookmarkO = exports.squareO = exports.phone = exports.lemonO = exports.upload = exports.githubSquare = exports.trophy = exports.signIn = exports.externalLink = exports.thumbTack = exports.linkedinSquare = exports.signOut = exports.heartO = exports.starHalf = exports.thumbsODown = exports.thumbsOUp = exports.comments = exports.gears = exports.cogs = exports.key = exports.cameraRetro = exports.facebookSquare = exports.twitterSquare = exports.barChartO = exports.barChart = exports.arrowsH = exports.arrowsV = exports.folderOpen = exports.folder = exports.shoppingCart = exports.retweet = exports.chevronDown = exports.chevronUp = exports.magnet = exports.comment = exports.random = exports.calendar = exports.plane = exports.warning = exports.exclamationTriangle = exports.eyeSlash = exports.eye = exports.fire = exports.leaf = exports.gift = exports.exclamationCircle = exports.asterisk = exports.minus = exports.plus = exports.compress = exports.expand = exports.share = exports.mailForward = exports.arrowDown = exports.arrowUp = void 0;
exports.question = exports.unlink = exports.chainBroken = exports.codeFork = exports.crop = exports.locationArrow = exports.starHalfO = exports.starHalfFull = exports.starHalfEmpty = exports.replyAll = exports.mailReplyAll = exports.code = exports.terminal = exports.flagCheckered = exports.flagO = exports.keyboardO = exports.gamepad = exports.mehO = exports.frownO = exports.smileO = exports.folderOpenO = exports.folderO = exports.githubAlt = exports.reply = exports.mailReply = exports.circle = exports.spinner = exports.quoteRight = exports.quoteLeft = exports.circleO = exports.mobilePhone = exports.mobile = exports.tablet = exports.laptop = exports.desktop = exports.angleDown = exports.angleUp = exports.angleRight = exports.angleLeft = exports.angleDoubleDown = exports.angleDoubleUp = exports.angleDoubleRight = exports.angleDoubleLeft = exports.plusSquare = exports.hSquare = exports.beer = exports.fighterJet = exports.medkit = exports.ambulance = exports.hospitalO = exports.buildingO = exports.fileTextO = exports.cutlery = exports.coffee = exports.bell = exports.suitcase = exports.stethoscope = exports.userMd = exports.cloudUpload = exports.cloudDownload = exports.exchange = exports.lightbulbO = exports.paste = exports.clipboard = exports.umbrella = exports.sitemap = exports.flash = exports.bolt = exports.commentsO = exports.commentO = exports.tachometer = exports.dashboard = exports.legal = exports.gavel = exports.undo = exports.rotateLeft = exports.linkedin = exports.envelope = exports.sortUp = exports.sortAsc = exports.sortDown = exports.sortDesc = exports.unsorted = exports.sort = exports.columns = exports.caretRight = exports.caretLeft = exports.caretUp = exports.caretDown = exports.money = exports.googlePlus = exports.googlePlusSquare = exports.pinterestSquare = exports.pinterest = exports.truck = exports.magic = exports.table = exports.underline = exports.strikethrough = exports.listOl = void 0;
exports.gratipay = exports.gittip = exports.male = exports.female = exports.trello = exports.foursquare = exports.skype = exports.dribbble = exports.linux = exports.android = exports.windows = exports.apple = exports.longArrowRight = exports.longArrowLeft = exports.longArrowUp = exports.longArrowDown = exports.tumblrSquare = exports.tumblr = exports.bitbucketSquare = exports.bitbucket = exports.adn = exports.flickr = exports.instagram = exports.stackOverflow = exports.dropbox = exports.youtubePlay = exports.xingSquare = exports.xing = exports.youtube = exports.youtubeSquare = exports.thumbsDown = exports.thumbsUp = exports.sortNumericDesc = exports.sortNumericAsc = exports.sortAmountDesc = exports.sortAmountAsc = exports.sortAlphaDesc = exports.sortAlphaAsc = exports.fileText = exports.file = exports.btc = exports.bitcoin = exports.won = exports.krw = exports.ruble = exports.rub = exports.rouble = exports.yen = exports.rmb = exports.jpy = exports.cny = exports.rupee = exports.inr = exports.usd = exports.dollar = exports.gbp = exports.euro = exports.eur = exports.toggleRight = exports.caretSquareORight = exports.toggleUp = exports.caretSquareOUp = exports.toggleDown = exports.caretSquareODown = exports.compass = exports.shareSquare = exports.externalLinkSquare = exports.pencilSquare = exports.checkSquare = exports.levelDown = exports.levelUp = exports.minusSquareO = exports.minusSquare = exports.ticket = exports.playCircle = exports.rssSquare = exports.ellipsisV = exports.ellipsisH = exports.bullseye = exports.unlockAlt = exports.anchor = exports.css3 = exports.html5 = exports.chevronCircleDown = exports.chevronCircleUp = exports.chevronCircleRight = exports.chevronCircleLeft = exports.maxcdn = exports.rocket = exports.fireExtinguisher = exports.calendarO = exports.shield = exports.microphoneSlash = exports.microphone = exports.puzzlePiece = exports.eraser = exports.subscript = exports.superscript = exports.exclamation = exports.info = void 0;
exports.weixin = exports.wechat = exports.qq = exports.tencentWeibo = exports.ycSquare = exports.yCombinatorSquare = exports.hackerNews = exports.git = exports.gitSquare = exports.ge = exports.empire = exports.resistance = exports.rebel = exports.ra = exports.circleONotch = exports.support = exports.lifeSaver = exports.lifeRing = exports.lifeBuoy = exports.lifeBouy = exports.jsfiddle = exports.codepen = exports.vine = exports.fileCodeO = exports.fileVideoO = exports.fileMovieO = exports.fileSoundO = exports.fileAudioO = exports.fileZipO = exports.fileArchiveO = exports.filePictureO = exports.filePhotoO = exports.fileImageO = exports.filePowerpointO = exports.fileExcelO = exports.fileWordO = exports.filePdfO = exports.database = exports.soundcloud = exports.deviantart = exports.spotify = exports.tree = exports.taxi = exports.cab = exports.car = exports.automobile = exports.recycle = exports.steamSquare = exports.steam = exports.behanceSquare = exports.behance = exports.cubes = exports.cube = exports.spoon = exports.paw = exports.child = exports.building = exports.fax = exports.language = exports.joomla = exports.drupal = exports.piedPiperAlt = exports.piedPiperPp = exports.digg = exports.delicious = exports.stumbleupon = exports.stumbleuponCircle = exports.redditSquare = exports.reddit = exports.google = exports.yahoo = exports.mortarBoard = exports.graduationCap = exports.university = exports.institution = exports.bank = exports.openid = exports.wordpress = exports.envelopeSquare = exports.slack = exports.spaceShuttle = exports.plusSquareO = exports.turkishLira = exports.tryIcon = exports.vimeoSquare = exports.wheelchair = exports.dotCircleO = exports.toggleLeft = exports.caretSquareOLeft = exports.arrowCircleOLeft = exports.arrowCircleORight = exports.stackExchange = exports.pagelines = exports.renren = exports.weibo = exports.vk = exports.bug = exports.archive = exports.moonO = exports.sunO = void 0;
exports.yc = exports.yCombinator = exports.medium = exports.subway = exports.train = exports.viacoin = exports.hotel = exports.bed = exports.userTimes = exports.userPlus = exports.server = exports.whatsapp = exports.pinterestP = exports.facebookOfficial = exports.genderless = exports.neuter = exports.marsStrokeH = exports.marsStrokeV = exports.marsStroke = exports.venusMars = exports.marsDouble = exports.venusDouble = exports.transgenderAlt = exports.transgender = exports.intersex = exports.mercury = exports.mars = exports.venus = exports.heartbeat = exports.streetView = exports.motorcycle = exports.userSecret = exports.ship = exports.diamond = exports.cartArrowDown = exports.cartPlus = exports.skyatlas = exports.simplybuilt = exports.shirtsinbulk = exports.sellsy = exports.leanpub = exports.forumbee = exports.dashcube = exports.connectdevelop = exports.buysellads = exports.meanpath = exports.sheqel = exports.shekel = exports.ils = exports.cc = exports.angellist = exports.ioxhost = exports.bus = exports.bicycle = exports.toggleOn = exports.toggleOff = exports.lastfmSquare = exports.lastfm = exports.lineChart = exports.pieChart = exports.areaChart = exports.birthdayCake = exports.paintBrush = exports.eyedropper = exports.at = exports.copyright = exports.trash = exports.bellSlashO = exports.bellSlash = exports.ccStripe = exports.ccPaypal = exports.ccAmex = exports.ccDiscover = exports.ccMastercard = exports.ccVisa = exports.googleWallet = exports.paypal = exports.calculator = exports.wifi = exports.newspaperO = exports.yelp = exports.twitch = exports.slideshare = exports.plug = exports.binoculars = exports.tty = exports.soccerBallO = exports.futbolO = exports.bomb = exports.shareAltSquare = exports.shareAlt = exports.sliders = exports.paragraph = exports.header = exports.circleThin = exports.history = exports.sendO = exports.paperPlaneO = exports.send = exports.paperPlane = void 0;
exports.envira = exports.wpforms = exports.wpbeginner = exports.gitlab = exports.percent = exports.bluetoothB = exports.bluetooth = exports.hashtag = exports.shoppingBasket = exports.shoppingBag = exports.stopCircleO = exports.stopCircle = exports.pauseCircleO = exports.pauseCircle = exports.scribd = exports.mixcloud = exports.productHunt = exports.usb = exports.fortAwesome = exports.modx = exports.codiepie = exports.creditCardAlt = exports.edge = exports.redditAlien = exports.fonticons = exports.blackTie = exports.vimeo = exports.houzz = exports.commentingO = exports.commenting = exports.map = exports.mapO = exports.mapSigns = exports.mapPin = exports.industry = exports.calendarCheckO = exports.calendarTimesO = exports.calendarMinusO = exports.calendarPlusO = exports.amazon = exports.fiveHundredPX = exports.contao = exports.tv = exports.television = exports.internetExplorer = exports.opera = exports.firefox = exports.chrome = exports.safari = exports.wikipediaW = exports.getPocket = exports.odnoklassnikiSquare = exports.odnoklassniki = exports.tripadvisor = exports.ggCircle = exports.gg = exports.creativeCommons = exports.registered = exports.trademark = exports.handPeaceO = exports.handPointerO = exports.handSpockO = exports.handLizardO = exports.handScissorsO = exports.handStopO = exports.handPaperO = exports.handRockO = exports.handGrabO = exports.hourglass = exports.hourglassEnd = exports.hourglass3 = exports.hourglassHalf = exports.hourglass2 = exports.hourglassStart = exports.hourglass1 = exports.hourglassO = exports.balanceScale = exports.clone = exports.ccDinersClub = exports.ccJcb = exports.stickyNoteO = exports.stickyNote = exports.objectUngroup = exports.objectGroup = exports.iCursor = exports.mousePointer = exports.batteryEmpty = exports.battery0 = exports.batteryQuarter = exports.battery1 = exports.batteryHalf = exports.battery2 = exports.batteryThreeQuarters = exports.battery3 = exports.batteryFull = exports.battery4 = exports.battery = exports.expeditedssl = exports.opencart = exports.optinMonster = void 0;
exports.meetup = exports.wpexplorer = exports.superpowers = exports.snowflakeO = exports.microchip = exports.eercast = exports.ravelry = exports.imdb = exports.etsy = exports.grav = exports.bandcamp = exports.windowCloseO = exports.timesRectangleO = exports.windowClose = exports.timesRectangle = exports.windowRestore = exports.windowMinimize = exports.windowMaximize = exports.podcast = exports.s15 = exports.bathtub = exports.bath = exports.shower = exports.thermometerEmpty = exports.thermometer0 = exports.thermometerQuarter = exports.thermometer1 = exports.thermometerHalf = exports.thermometer2 = exports.thermometerThreeQuarters = exports.thermometer3 = exports.thermometerFull = exports.thermometer4 = exports.thermometer = exports.telegram = exports.freeCodeCamp = exports.quora = exports.idCardO = exports.driversLicenseO = exports.idCard = exports.driversLicense = exports.idBadge = exports.userO = exports.userCircleO = exports.userCircle = exports.vcardO = exports.addressCardO = exports.vcard = exports.addressCard = exports.addressBookO = exports.addressBook = exports.linode = exports.envelopeOpenO = exports.envelopeOpen = exports.handshakeO = exports.fontAwesome = exports.fa = exports.googlePlusOfficial = exports.googlePlusCircle = exports.themeisle = exports.yoast = exports.firstOrder = exports.piedPiper = exports.snapchatSquare = exports.snapchatGhost = exports.snapchat = exports.viadeoSquare = exports.viadeo = exports.lowVision = exports.signing = exports.signLanguage = exports.glideG = exports.glide = exports.hardOfHearing = exports.deafness = exports.deaf = exports.aslInterpreting = exports.americanSignLanguageInterpreting = exports.assistiveListeningSystems = exports.braille = exports.volumeControlPhone = exports.audioDescription = exports.blind = exports.questionCircleO = exports.wheelchairAlt = exports.universalAccess = void 0;
var glass = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1699 186q0 35-43 78l-632 632v768h320q26 0 45 19t19 45-19 45-45 19h-896q-26 0-45-19t-19-45 19-45 45-19h320v-768l-632-632q-43-43-43-78 0-23 18-36.5t38-17.5 43-4h1408q23 0 43 4t38 17.5 18 36.5z"
    }
  }]
};
exports.glass = glass;
var music = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 224v1120q0 50-34 89t-86 60.5-103.5 32-96.5 10.5-96.5-10.5-103.5-32-86-60.5-34-89 34-89 86-60.5 103.5-32 96.5-10.5q105 0 192 39v-537l-768 237v709q0 50-34 89t-86 60.5-103.5 32-96.5 10.5-96.5-10.5-103.5-32-86-60.5-34-89 34-89 86-60.5 103.5-32 96.5-10.5q105 0 192 39v-967q0-31 19-56.5t49-35.5l832-256q12-4 28-4 40 0 68 28t28 68z"
    }
  }]
};
exports.music = music;
var search = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 52-38 90t-90 38q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"
    }
  }]
};
exports.search = search;
var envelopeO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1504v-768q-32 36-69 66-268 206-426 338-51 43-83 67t-86.5 48.5-102.5 24.5h-1-1q-48 0-102.5-24.5t-86.5-48.5-83-67q-158-132-426-338-37-30-69-66v768q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1664 453v-11-13.5t-0.5-13-3-12.5-5.5-9-9-7.5-14-2.5h-1472q-13 0-22.5 9.5t-9.5 22.5q0 168 147 284 193 152 401 317 6 5 35 29.5t46 37.5 44.5 31.5 50.5 27.5 43 9h1 1q20 0 43-9t50.5-27.5 44.5-31.5 46-37.5 35-29.5q208-165 401-317 54-43 100.5-115.5t46.5-131.5zM1792 416v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.envelopeO = envelopeO;
var heart = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1664q-26 0-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344q0 221-229 450l-623 600q-18 18-44 18z"
    }
  }]
};
exports.heart = heart;
var star = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 21-10.5 35.5t-30.5 14.5q-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"
    }
  }]
};
exports.star = star;
var starO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1137 1004l306-297-422-62-189-382-189 382-422 62 306 297-73 421 378-199 377 199zM1664 647q0 22-26 48l-363 354 86 500q1 7 1 20 0 50-41 50-19 0-40-12l-449-236-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41t49 41l225 455 502 73q56 9 56 46z"
    }
  }]
};
exports.starO = starO;
var user = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1399q0 109-62.5 187t-150.5 78h-854q-88 0-150.5-78t-62.5-187q0-85 8.5-160.5t31.5-152 58.5-131 94-89 134.5-34.5q131 128 313 128t313-128q76 0 134.5 34.5t94 89 58.5 131 31.5 152 8.5 160.5zM1024 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  }]
};
exports.user = user;
var film = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1600v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM384 1216v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM384 832v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1408 1600v-512q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v512q0 26 19 45t45 19h768q26 0 45-19t19-45zM384 448v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 1600v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1408 832v-512q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v512q0 26 19 45t45 19h768q26 0 45-19t19-45zM1792 1216v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 832v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1792 448v-128q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v128q0 26 19 45t45 19h128q26 0 45-19t19-45zM1920 288v1344q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1344q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.film = film;
var thLarge = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 1024v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM768 256v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM1664 1024v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90zM1664 256v384q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h512q52 0 90 38t38 90z"
    }
  }]
};
exports.thLarge = thLarge;
var th = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1152 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68z"
    }
  }]
};
exports.th = th;
var thList = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1248v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM512 736v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 1248v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zM512 224v192q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h320q40 0 68 28t28 68zM1792 736v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68zM1792 224v192q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h960q40 0 68 28t28 68z"
    }
  }]
};
exports.thList = thList;
var check = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1671 566q0 40-28 68l-724 724-136 136q-28 28-68 28t-68-28l-136-136-362-362q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 295 656-657q28-28 68-28t68 28l136 136q28 28 28 68z"
    }
  }]
};
exports.check = check;
var close = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"
    }
  }]
};
exports.close = close;
var remove = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"
    }
  }]
};
exports.remove = remove;
var times = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1298 1322q0 40-28 68l-136 136q-28 28-68 28t-68-28l-294-294-294 294q-28 28-68 28t-68-28l-136-136q-28-28-28-68t28-68l294-294-294-294q-28-28-28-68t28-68l136-136q28-28 68-28t68 28l294 294 294-294q28-28 68-28t68 28l136 136q28 28 28 68t-28 68l-294 294 294 294q28 28 28 68z"
    }
  }]
};
exports.times = times;
var searchPlus = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 800v64q0 13-9.5 22.5t-22.5 9.5h-224v224q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-224h-224q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h224v-224q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5v224h224q13 0 22.5 9.5t9.5 22.5zM1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 53-37.5 90.5t-90.5 37.5q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"
    }
  }]
};
exports.searchPlus = searchPlus;
var searchMinus = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 800v64q0 13-9.5 22.5t-22.5 9.5h-576q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h576q13 0 22.5 9.5t9.5 22.5zM1152 832q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1664 1664q0 53-37.5 90.5t-90.5 37.5q-54 0-90-38l-343-342q-179 124-399 124-143 0-273.5-55.5t-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5q0 220-124 399l343 343q37 37 37 90z"
    }
  }]
};
exports.searchMinus = searchMinus;
var powerOff = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 156-61 298t-164 245-245 164-298 61-298-61-245-164-164-245-61-298q0-182 80.5-343t226.5-270q43-32 95.5-25t83.5 50q32 42 24.5 94.5t-49.5 84.5q-98 74-151.5 181t-53.5 228q0 104 40.5 198.5t109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5q0-121-53.5-228t-151.5-181q-42-32-49.5-84.5t24.5-94.5q31-43 84-50t95 25q146 109 226.5 270t80.5 343zM896 128v640q0 52-38 90t-90 38-90-38-38-90v-640q0-52 38-90t90-38 90 38 38 90z"
    }
  }]
};
exports.powerOff = powerOff;
var signal = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1440v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM640 1312v320q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-320q0-14 9-23t23-9h192q14 0 23 9t9 23zM1024 1056v576q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23zM1408 672v960q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 160v1472q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1472q0-14 9-23t23-9h192q14 0 23 9t9 23z"
    }
  }]
};
exports.signal = signal;
var cog = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1536 787v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z"
    }
  }]
};
exports.cog = cog;
var gear = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1536 787v222q0 12-8 23t-20 13l-185 28q-19 54-39 91 35 50 107 138 10 12 10 25t-9 23q-27 37-99 108t-94 71q-12 0-26-9l-138-108q-44 23-91 38-16 136-29 186-7 28-36 28h-222q-14 0-24.5-8.5t-11.5-21.5l-28-184q-49-16-90-37l-141 107q-10 9-25 9-14 0-25-11-126-114-165-168-7-10-7-23 0-12 8-23 15-21 51-66.5t54-70.5q-27-50-41-99l-183-27q-13-2-21-12.5t-8-23.5v-222q0-12 8-23t19-13l186-28q14-46 39-92-40-57-107-138-10-12-10-24 0-10 9-23 26-36 98.5-107.5t94.5-71.5q13 0 26 10l138 107q44-23 91-38 16-136 29-186 7-28 36-28h222q14 0 24.5 8.5t11.5 21.5l28 184q49 16 90 37l142-107q9-9 24-9 13 0 25 10 129 119 165 170 7 8 7 22 0 12-8 23-15 21-51 66.5t-54 70.5q26 50 41 98l183 28q13 2 21 12.5t8 23.5z"
    }
  }]
};
exports.gear = gear;
var trashO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM768 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM1024 736v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23zM1152 1460v-948h-896v948q0 22 7 40.5t14.5 27 10.5 8.5h832q3 0 10.5-8.5t14.5-27 7-40.5zM480 384h448l-48-117q-7-9-17-11h-317q-10 2-17 11zM1408 416v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"
    }
  }]
};
exports.trashO = trashO;
var home = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 992v480q0 26-19 45t-45 19h-384v-384h-256v384h-384q-26 0-45-19t-19-45v-480q0-1 0.5-3t0.5-3l575-474 575 474q1 2 1 6zM1631 923l-62 74q-8 9-21 11h-3q-13 0-21-7l-692-577-692 577q-12 8-24 7-13-2-21-11l-62-74q-8-10-7-23.5t11-21.5l719-599q32-26 76-26t76 26l244 204v-195q0-14 9-23t23-9h192q14 0 23 9t9 23v408l219 182q10 8 11 21.5t-7 23.5z"
    }
  }]
};
exports.home = home;
var fileO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280z"
    }
  }]
};
exports.fileO = fileO;
var clockO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 544v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.clockO = clockO;
var road = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1111 996v-4l-24-320q-1-13-11-22.5t-23-9.5h-186q-13 0-23 9.5t-11 22.5l-24 320v4q-1 12 8 20t21 8h244q12 0 21-8t8-20zM1870 1463q0 73-46 73h-704q13 0 22-9.5t8-22.5l-20-256q-1-13-11-22.5t-23-9.5h-272q-13 0-23 9.5t-11 22.5l-20 256q-1 13 8 22.5t22 9.5h-704q-46 0-46-73 0-54 26-116l417-1044q8-19 26-33t38-14h339q-13 0-23 9.5t-11 22.5l-15 192q-1 14 8 23t22 9h166q13 0 22-9t8-23l-15-192q-1-13-11-22.5t-23-9.5h339q20 0 38 14t26 33l417 1044q26 62 26 116z"
    }
  }]
};
exports.road = road;
var download = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 1120v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h465l135 136q58 56 136 56t136-56l136-136h464q40 0 68 28t28 68zM1339 551q17 41-14 70l-448 448q-18 19-45 19t-45-19l-448-448q-31-29-14-70 17-39 59-39h256v-448q0-26 19-45t45-19h256q26 0 45 19t19 45v448h256q42 0 59 39z"
    }
  }]
};
exports.download = download;
var arrowCircleODown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1120 928q0 12-10 24l-319 319q-11 9-23 9t-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-352q0-14 9-23t23-9h192q14 0 23 9t9 23v352h192q14 0 23 9t9 23zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleODown = arrowCircleODown;
var arrowCircleOUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1118 876q-8 20-30 20h-192v352q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-352h-192q-14 0-23-9t-9-23q0-12 10-24l319-319q11-9 23-9t23 9l320 320q15 16 7 35zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleOUp = arrowCircleOUp;
var inbox = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1023 960h316q-1-3-2.5-8.5t-2.5-7.5l-212-496h-708l-212 496q-1 3-2.5 8.5t-2.5 7.5h316l95 192h320zM1536 990v482q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-482q0-62 25-123l238-552q10-25 36.5-42t52.5-17h832q26 0 52.5 17t36.5 42l238 552q25 61 25 123z"
    }
  }]
};
exports.inbox = inbox;
var playCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1184 896q0 37-32 55l-544 320q-15 9-32 9-16 0-32-8-32-19-32-56v-640q0-37 32-56 33-18 64 1l544 320q32 18 32 55zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.playCircleO = playCircleO;
var repeat = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"
    }
  }]
};
exports.repeat = repeat;
var rotateRight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 256v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l138-138q-148-137-349-137-104 0-198.5 40.5t-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5q119 0 225-52t179-147q7-10 23-12 15 0 25 9l137 138q9 8 9.5 20.5t-7.5 22.5q-109 132-264 204.5t-327 72.5q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q147 0 284.5 55.5t244.5 156.5l130-129q29-31 70-14 39 17 39 59z"
    }
  }]
};
exports.rotateRight = rotateRight;
var refresh = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1511 1056q0 5-1 7-64 268-268 434.5t-478 166.5q-146 0-282.5-55t-243.5-157l-129 129q-19 19-45 19t-45-19-19-45v-448q0-26 19-45t45-19h448q26 0 45 19t19 45-19 45l-137 137q71 66 161 102t187 36q134 0 250-65t186-179q11-17 53-117 8-23 30-23h192q13 0 22.5 9.5t9.5 22.5zM1536 256v448q0 26-19 45t-45 19h-448q-26 0-45-19t-19-45 19-45l138-138q-148-137-349-137-134 0-250 65t-186 179q-11 17-53 117-8 23-30 23h-199q-13 0-22.5-9.5t-9.5-22.5v-7q65-268 270-434.5t480-166.5q146 0 284 55.5t245 156.5l130-129q19-19 45-19t45 19 19 45z"
    }
  }]
};
exports.refresh = refresh;
var listAlt = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1184v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 928v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 672v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1536 1184v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1536 928v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1536 672v64q0 13-9.5 22.5t-22.5 9.5h-960q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h960q13 0 22.5 9.5t9.5 22.5zM1664 1376v-832q0-13-9.5-22.5t-22.5-9.5h-1472q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1792 288v1088q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.listAlt = listAlt;
var lock = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M320 768h512v-192q0-106-75-181t-181-75-181 75-75 181v192zM1152 864v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-192q0-184 132-316t316-132 316 132 132 316v192h32q40 0 68 28t28 68z"
    }
  }]
};
exports.lock = lock;
var flag = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M320 256q0 72-64 110v1266q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-1266q-64-38-64-110 0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 25-12.5 38.5t-39.5 27.5q-215 116-369 116-61 0-123.5-22t-108.5-48-115.5-48-142.5-22q-192 0-464 146-17 9-33 9-26 0-45-19t-19-45v-742q0-32 31-55 21-14 79-43 236-120 421-120 107 0 200 29t219 88q38 19 88 19 54 0 117.5-21t110-47 88-47 54.5-21q26 0 45 19t19 45z"
    }
  }]
};
exports.flag = flag;
var headphones = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 886q0 166-60 314l-20 49-185 33q-22 83-90.5 136.5t-156.5 53.5v32q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h64q14 0 23 9t9 23v32q71 0 130 35.5t93 95.5l68-12q29-95 29-193 0-148-88-279t-236.5-209-315.5-78-315.5 78-236.5 209-88 279q0 98 29 193l68 12q34-60 93-95.5t130-35.5v-32q0-14 9-23t23-9h64q14 0 23 9t9 23v576q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-32q-88 0-156.5-53.5t-90.5-136.5l-185-33-20-49q-60-148-60-314 0-151 67-291t179-242.5 266-163.5 320-61 320 61 266 163.5 179 242.5 67 291z"
    }
  }]
};
exports.headphones = headphones;
var volumeOff = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45z"
    }
  }]
};
exports.volumeOff = volumeOff;
var volumeDown = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zM1152 896q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142z"
    }
  }]
};
exports.volumeDown = volumeDown;
var volumeUp = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 352v1088q0 26-19 45t-45 19-45-19l-333-333h-262q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h262l333-333q19-19 45-19t45 19 19 45zM1152 896q0 76-42.5 141.5t-112.5 93.5q-10 5-25 5-26 0-45-18.5t-19-45.5q0-21 12-35.5t29-25 34-23 29-36 12-56.5-12-56.5-29-36-34-23-29-25-12-35.5q0-27 19-45.5t45-18.5q15 0 25 5 70 27 112.5 93t42.5 142zM1408 896q0 153-85 282.5t-225 188.5q-13 5-25 5-27 0-46-19t-19-45q0-39 39-59 56-29 76-44 74-54 115.5-135.5t41.5-173.5-41.5-173.5-115.5-135.5q-20-15-76-44-39-20-39-59 0-26 19-45t45-19q13 0 26 5 140 59 225 188.5t85 282.5zM1664 896q0 230-127 422.5t-338 283.5q-13 5-26 5-26 0-45-19t-19-45q0-36 39-59 7-4 22.5-10.5t22.5-10.5q46-25 82-51 123-91 192-227t69-289-69-289-192-227q-36-26-82-51-7-4-22.5-10.5t-22.5-10.5q-39-23-39-59 0-26 19-45t45-19q13 0 26 5 211 91 338 283.5t127 422.5z"
    }
  }]
};
exports.volumeUp = volumeUp;
var qrcode = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1152v128h-128v-128h128zM384 384v128h-128v-128h128zM1152 384v128h-128v-128h128zM128 1407h384v-383h-384v383zM128 640h384v-384h-384v384zM896 640h384v-384h-384v384zM640 896v640h-640v-640h640zM1152 1408v128h-128v-128h128zM1408 1408v128h-128v-128h128zM1408 896v384h-384v-128h-128v384h-128v-640h384v128h128v-128h128zM640 128v640h-640v-640h640zM1408 128v640h-640v-640h640z"
    }
  }]
};
exports.qrcode = qrcode;
var barcode = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M63 1536h-63v-1408h63v1408zM126 1535h-32v-1407h32v1407zM220 1535h-31v-1407h31v1407zM377 1535h-31v-1407h31v1407zM534 1535h-62v-1407h62v1407zM660 1535h-31v-1407h31v1407zM723 1535h-31v-1407h31v1407zM786 1535h-31v-1407h31v1407zM943 1535h-63v-1407h63v1407zM1100 1535h-63v-1407h63v1407zM1226 1535h-63v-1407h63v1407zM1352 1535h-63v-1407h63v1407zM1446 1535h-63v-1407h63v1407zM1635 1535h-94v-1407h94v1407zM1698 1535h-32v-1407h32v1407zM1792 1536h-63v-1408h63v1408z"
    }
  }]
};
exports.barcode = barcode;
var tag = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M448 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1515 1024q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"
    }
  }]
};
exports.tag = tag;
var tags = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M448 448q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1515 1024q0 53-37 90l-491 492q-39 37-91 37-53 0-90-37l-715-716q-38-37-64.5-101t-26.5-117v-416q0-52 38-90t90-38h416q53 0 117 26.5t102 64.5l715 714q37 39 37 91zM1899 1024q0 53-37 90l-491 492q-39 37-91 37-36 0-59-14t-53-45l470-470q37-37 37-90 0-52-37-91l-715-714q-38-38-102-64.5t-117-26.5h224q53 0 117 26.5t102 64.5l715 714q37 39 37 91z"
    }
  }]
};
exports.tags = tags;
var book = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1639 478q40 57 18 129l-275 906q-19 64-76.5 107.5t-122.5 43.5h-923q-77 0-148.5-53.5t-99.5-131.5q-24-67-2-127 0-4 3-27t4-37q1-8-3-21.5t-3-19.5q2-11 8-21t16.5-23.5 16.5-23.5q23-38 45-91.5t30-91.5q3-10 0.5-30t-0.5-28q3-11 17-28t17-23q21-36 42-92t25-90q1-9-2.5-32t0.5-28q4-13 22-30.5t22-22.5q19-26 42.5-84.5t27.5-96.5q1-8-3-25.5t-2-26.5q2-8 9-18t18-23 17-21q8-12 16.5-30.5t15-35 16-36 19.5-32 26.5-23.5 36-11.5 47.5 5.5l-1 3q38-9 51-9h761q74 0 114 56t18 130l-274 906q-36 119-71.5 153.5t-128.5 34.5h-869q-27 0-38 15-11 16-1 43 24 70 144 70h923q29 0 56-15.5t35-41.5l300-987q7-22 5-57 38 15 59 43zM575 480q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5zM492 736q-4 13 2 22.5t20 9.5h608q13 0 25.5-9.5t16.5-22.5l21-64q4-13-2-22.5t-20-9.5h-608q-13 0-25.5 9.5t-16.5 22.5z"
    }
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1164 128q23 0 44 9 33 13 52.5 41t19.5 62v1289q0 34-19.5 62t-52.5 41q-19 8-44 8-48 0-83-32l-441-424-441 424q-36 33-83 33-23 0-44-9-33-13-52.5-41t-19.5-62v-1289q0-34 19.5-62t52.5-41q21-9 44-9h1048z"
    }
  }]
};
exports.bookmark = bookmark;
var print = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1536h896v-256h-896v256zM384 896h896v-384h-160q-40 0-68-28t-28-68v-160h-640v640zM1536 960q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 960v416q0 13-9.5 22.5t-22.5 9.5h-224v160q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-224q-13 0-22.5-9.5t-9.5-22.5v-416q0-79 56.5-135.5t135.5-56.5h64v-544q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v256h64q79 0 135.5 56.5t56.5 135.5z"
    }
  }]
};
exports.print = print;
var camera = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 672q119 0 203.5 84.5t84.5 203.5-84.5 203.5-203.5 84.5-203.5-84.5-84.5-203.5 84.5-203.5 203.5-84.5zM1664 256q106 0 181 75t75 181v896q0 106-75 181t-181 75h-1408q-106 0-181-75t-75-181v-896q0-106 75-181t181-75h224l51-136q19-49 69.5-84.5t103.5-35.5h512q53 0 103.5 35.5t69.5 84.5l51 136h224zM960 1408q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.camera = camera;
var font = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M725 559l-170 450q33 0 136.5 2t160.5 2q19 0 57-2-87-253-184-452zM0 1664l2-79q23-7 56-12.5t57-10.5 49.5-14.5 44.5-29 31-50.5l237-616 280-724h75 53q8 14 11 21l205 480q33 78 106 257.5t114 274.5q15 34 58 144.5t72 168.5q20 45 35 57 19 15 88 29.5t84 20.5q6 38 6 57 0 5-0.5 13.5t-0.5 12.5q-63 0-190-8t-191-8q-76 0-215 7t-178 8q0-43 4-78l131-28q1 0 12.5-2.5t15.5-3.5 14.5-4.5 15-6.5 11-8 9-11 2.5-14q0-16-31-96.5t-72-177.5-42-100l-450-2q-26 58-76.5 195.5t-50.5 162.5q0 22 14 37.5t43.5 24.5 48.5 13.5 57 8.5 41 4q1 19 1 58 0 9-2 27-58 0-174.5-10t-174.5-10q-8 0-26.5 4t-21.5 4q-80 14-188 14z"
    }
  }]
};
exports.font = font;
var bold = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M555 1521q74 32 140 32 376 0 376-335 0-114-41-180-27-44-61.5-74t-67.5-46.5-80.5-25-84-10.5-94.5-2q-73 0-101 10 0 53-0.5 159t-0.5 158q0 8-1 67.5t-0.5 96.5 4.5 83.5 12 66.5zM541 775q42 7 109 7 82 0 143-13t110-44.5 74.5-89.5 25.5-142q0-70-29-122.5t-79-82-108-43.5-124-14q-50 0-130 13 0 50 4 151t4 152q0 27-0.5 80t-0.5 79q0 46 1 69zM0 1664l2-94q15-4 85-16t106-27q7-12 12.5-27t8.5-33.5 5.5-32.5 3-37.5 0.5-34v-35.5-30q0-982-22-1025-4-8-22-14.5t-44.5-11-49.5-7-48.5-4.5-30.5-3l-4-83q98-2 340-11.5t373-9.5q23 0 68 0.5t68 0.5q70 0 136.5 13t128.5 42 108 71 74 104.5 28 137.5q0 52-16.5 95.5t-39 72-64.5 57.5-73 45-84 40q154 35 256.5 134t102.5 248q0 100-35 179.5t-93.5 130.5-138 85.5-163.5 48.5-176 14q-44 0-132-3t-132-3q-106 0-307 11t-231 12z"
    }
  }]
};
exports.bold = bold;
var italic = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 1662l17-85q22-7 61.5-16.5t72-19 59.5-23.5q28-35 41-101 1-7 62-289t114-543.5 52-296.5v-25q-24-13-54.5-18.5t-69.5-8-58-5.5l19-103q33 2 120 6.5t149.5 7 120.5 2.5q48 0 98.5-2.5t121-7 98.5-6.5q-5 39-19 89-30 10-101.5 28.5t-108.5 33.5q-8 19-14 42.5t-9 40-7.5 45.5-6.5 42q-27 148-87.5 419.5t-77.5 355.5q-2 9-13 58t-20 90-16 83.5-6 57.5l1 18q17 4 185 31-3 44-16 99-11 0-32.5 1.5t-32.5 1.5q-29 0-87-10t-86-10q-138-2-206-2-51 0-143 9t-121 11z"
    }
  }]
};
exports.italic = italic;
var textHeight = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1744 1408q33 0 42 18.5t-11 44.5l-126 162q-20 26-49 26t-49-26l-126-162q-20-26-11-44.5t42-18.5h80v-1024h-80q-33 0-42-18.5t11-44.5l126-162q20-26 49-26t49 26l126 162q20 26 11 44.5t-42 18.5h-80v1024h80zM81 129l54 27q12 5 211 5 44 0 132-2t132-2q36 0 107.5 0.5t107.5 0.5h293q6 0 21 0.5t20.5 0 16-3 17.5-9 15-17.5l42-1q4 0 14 0.5t14 0.5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-48t-14.5-73.5-7.5-35.5q-6-8-12-12.5t-15.5-6-13-2.5-18-0.5-16.5 0.5q-17 0-66.5-0.5t-74.5-0.5-64 2-71 6q-9 81-8 136 0 94 2 388t2 455q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q19-42 19-383 0-101-3-303t-3-303v-117q0-2 0.5-15.5t0.5-25-1-25.5-3-24-5-14q-11-12-162-12-33 0-93 12t-80 26q-19 13-34 72.5t-31.5 111-42.5 53.5q-42-26-56-44v-383z"
    }
  }]
};
exports.textHeight = textHeight;
var textWidth = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M81 129l54 27q12 5 211 5 44 0 132-2t132-2q70 0 246.5-1t304.5-0.5 247 4.5q33 1 56-31l42-1q4 0 14 0.5t14 0.5q2 112 2 336 0 80-5 109-39 14-68 18-25-44-54-128-3-9-11-47.5t-15-73.5-7-36q-10-13-27-19-5-2-66-2-30 0-93-1t-103-1-94 2-96 7q-9 81-8 136l1 152v-52q0 55 1 154t1.5 180 0.5 153q0 16-2.5 71.5t0 91.5 12.5 69q40 21 124 42.5t120 37.5q5 40 5 50 0 14-3 29l-34 1q-76 2-218-8t-207-10q-50 0-151 9t-152 9q-3-51-3-52v-9q17-27 61.5-43t98.5-29 78-27q7-16 11.5-74t6-145.5 1.5-155-0.5-153.5-0.5-89q0-7-2.5-21.5t-2.5-22.5q0-7 0.5-44t1-73 0-76.5-3-67.5-6.5-32q-11-12-162-12-41 0-163 13.5t-138 24.5q-19 12-34 71.5t-31.5 111.5-42.5 54q-42-26-56-44v-383zM1310 1411q12 0 42 19.5t57.5 41.5 59.5 49 36 30q26 21 26 49t-26 49q-4 3-36 30t-59.5 49-57.5 41.5-42 19.5q-13 0-20.5-10.5t-10-28.5-2.5-33.5 1.5-33 1.5-19.5h-1024q0 2 1.5 19.5t1.5 33-2.5 33.5-10 28.5-20.5 10.5q-12 0-42-19.5t-57.5-41.5-59.5-49-36-30q-26-21-26-49t26-49q4-3 36-30t59.5-49 57.5-41.5 42-19.5q13 0 20.5 10.5t10 28.5 2.5 33.5-1.5 33-1.5 19.5h1024q0-2-1.5-19.5t-1.5-33 2.5-33.5 10-28.5 20.5-10.5z"
    }
  }]
};
exports.textWidth = textWidth;
var alignLeft = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1408 960v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zM1664 576v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zM1280 192v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"
    }
  }]
};
exports.alignLeft = alignLeft;
var alignCenter = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1408 960v128q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h896q26 0 45 19t19 45zM1664 576v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1280 192v128q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h640q26 0 45 19t19 45z"
    }
  }]
};
exports.alignCenter = alignCenter;
var alignRight = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 960v128q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1280q26 0 45 19t19 45zM1792 576v128q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1536q26 0 45 19t19 45zM1792 192v128q0 26-19 45t-45 19h-1152q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1152q26 0 45 19t19 45z"
    }
  }]
};
exports.alignRight = alignRight;
var alignJustify = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1344v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 960v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 576v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 192v128q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1664q26 0 45 19t19 45z"
    }
  }]
};
exports.alignJustify = alignJustify;
var list = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1312v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM256 928v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM256 544v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM256 160v192q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.list = list;
var dedent = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.dedent = dedent;
var outdent = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 544v576q0 13-9.5 22.5t-22.5 9.5q-14 0-23-9l-288-288q-9-9-9-23t9-23l288-288q9-9 23-9 13 0 22.5 9.5t9.5 22.5zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.outdent = outdent;
var indent = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M352 832q0 14-9 23l-288 288q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-576q0-13 9.5-22.5t22.5-9.5q14 0 23 9l288 288q9 9 9 23zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5zM1792 928v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 544v192q0 13-9.5 22.5t-22.5 9.5h-1088q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1088q13 0 22.5 9.5t9.5 22.5zM1792 160v192q0 13-9.5 22.5t-22.5 9.5h-1728q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1728q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.indent = indent;
var videoCamera = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 352v1088q0 42-39 59-13 5-25 5-27 0-45-19l-403-403v166q0 119-84.5 203.5t-203.5 84.5h-704q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h704q119 0 203.5 84.5t84.5 203.5v165l403-402q18-19 45-19 12 0 25 5 39 17 39 59z"
    }
  }]
};
exports.videoCamera = videoCamera;
var image = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.image = image;
var photo = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.photo = photo;
var pictureO = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 576q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 960v448h-1408v-192l320-320 160 160 512-512zM1760 256h-1600q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5v-1216q0-13-9.5-22.5t-22.5-9.5zM1920 288v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.pictureO = pictureO;
var pencil = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M363 1536l91-91-235-235-91 91v107h128v128h107zM886 608q0-22-22-22-10 0-17 7l-542 542q-7 7-7 17 0 22 22 22 10 0 17-7l542-542q7-7 7-17zM832 416l416 416-832 832h-416v-416zM1515 512q0 53-37 90l-166 166-416-416 166-165q36-38 90-38 53 0 91 38l235 234q37 39 37 91z"
    }
  }]
};
exports.pencil = pencil;
var mapMarker = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 640q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1024 640q0 109-33 179l-364 774q-16 33-47.5 52t-67.5 19-67.5-19-46.5-52l-365-774q-33-70-33-179 0-212 150-362t362-150 362 150 150 362z"
    }
  }]
};
exports.mapMarker = mapMarker;
var adjust = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 1440v-1088q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.adjust = adjust;
var tint = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1152q0-36-20-69-1-1-15.5-22.5t-25.5-38-25-44-21-50.5q-4-16-21-16t-21 16q-7 23-21 50.5t-25 44-25.5 38-15.5 22.5q-20 33-20 69 0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1024 1024q0 212-150 362t-362 150-362-150-150-362q0-145 81-275 6-9 62.5-90.5t101-151 99.5-178 83-201.5q9-30 34-47t51-17 51.5 17 33.5 47q28 93 83 201.5t99.5 178 101 151 62.5 90.5q81 127 81 275z"
    }
  }]
};
exports.tint = tint;
var edit = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M888 1184l116-116-152-152-116 116v56h96v96h56zM1328 464q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zM1408 1058v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zM1312 320l288 288-672 672h-288v-288zM1756 452l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z"
    }
  }]
};
exports.edit = edit;
var pencilSquareO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M888 1184l116-116-152-152-116 116v56h96v96h56zM1328 464q-16-16-33 1l-350 350q-17 17-1 33t33-1l350-350q17-17 1-33zM1408 1058v190q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-14 14-32 8-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-126q0-13 9-22l64-64q15-15 35-7t20 29zM1312 320l288 288-672 672h-288v-288zM1756 452l-92 92-288-288 92-92q28-28 68-28t68 28l152 152q28 28 28 68t-28 68z"
    }
  }]
};
exports.pencilSquareO = pencilSquareO;
var shareSquareO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 989v259q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h255v0q13 0 22.5 9.5t9.5 22.5q0 27-26 32-77 26-133 60-10 4-16 4h-112q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-214q0-19 18-29 28-13 54-37 16-16 35-8 21 9 21 29zM1645 493l-384 384q-18 19-45 19-12 0-25-5-39-17-39-59v-192h-160q-323 0-438 131-119 137-74 473 3 23-20 34-8 2-12 2-16 0-26-13-10-14-21-31t-39.5-68.5-49.5-99.5-38.5-114-17.5-122q0-49 3.5-91t14-90 28-88 47-81.5 68.5-74 94.5-61.5 124.5-48.5 159.5-30.5 196.5-11h160v-192q0-42 39-59 13-5 25-5 26 0 45 19l384 384q19 19 19 45t-19 45z"
    }
  }]
};
exports.shareSquareO = shareSquareO;
var checkSquareO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 930v318q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q63 0 117 25 15 7 18 23 3 17-9 29l-49 49q-10 10-23 10-3 0-9-2-23-6-45-6h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-254q0-13 9-22l64-64q10-10 23-10 6 0 12 3 20 8 20 29zM1639 441l-814 814q-24 24-57 24t-57-24l-430-430q-24-24-24-57t24-57l110-110q24-24 57-24t57 24l263 263 647-647q24-24 57-24t57 24l110 110q24 24 24 57t-24 57z"
    }
  }]
};
exports.checkSquareO = checkSquareO;
var arrows = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-384v384h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-384h-384v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h384v-384h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45t-19 45-45 19h-128v384h384v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"
    }
  }]
};
exports.arrows = arrows;
var stepBackward = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M979 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v678q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h128q26 0 45 19t19 45v678q4-10 13-19z"
    }
  }]
};
exports.stepBackward = stepBackward;
var fastBackward = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1747 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v710q0 26-13 32t-32-13l-710-710q-9-9-13-19v678q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h128q26 0 45 19t19 45v678q4-10 13-19l710-710q19-19 32-13t13 32v710q4-10 13-19z"
    }
  }]
};
exports.fastBackward = fastBackward;
var backward = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1619 141q19-19 32-13t13 32v1472q0 26-13 32t-32-13l-710-710q-9-9-13-19v710q0 26-13 32t-32-13l-710-710q-19-19-19-45t19-45l710-710q19-19 32-13t13 32v710q4-10 13-19z"
    }
  }]
};
exports.backward = backward;
var play = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1384 927l-1328 738q-23 13-39.5 3t-16.5-36v-1472q0-26 16.5-36t39.5 3l1328 738q23 13 23 31t-23 31z"
    }
  }]
};
exports.play = play;
var pause = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45zM640 192v1408q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h512q26 0 45 19t19 45z"
    }
  }]
};
exports.pause = pause;
var stop = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
    }
  }]
};
exports.stop = stop;
var forward = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-710q0-26 13-32t32 13l710 710q19 19 19 45t-19 45l-710 710q-19 19-32 13t-13-32v-710q-4 10-13 19z"
    }
  }]
};
exports.forward = forward;
var fastForward = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-710q0-26 13-32t32 13l710 710q9 9 13 19v-678q0-26 19-45t45-19h128q26 0 45 19t19 45v1408q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-678q-4 10-13 19l-710 710q-19 19-32 13t-13-32v-710q-4 10-13 19z"
    }
  }]
};
exports.fastForward = fastForward;
var stepForward = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M45 1651q-19 19-32 13t-13-32v-1472q0-26 13-32t32 13l710 710q9 9 13 19v-678q0-26 19-45t45-19h128q26 0 45 19t19 45v1408q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-678q-4 10-13 19z"
    }
  }]
};
exports.stepForward = stepForward;
var eject = {
  "viewBox": "0 0 1538 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 979l710-710q19-19 45-19t45 19l710 710q19 19 13 32t-32 13h-1472q-26 0-32-13t13-32zM1473 1536h-1408q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1408q26 0 45 19t19 45v256q0 26-19 45t-45 19z"
    }
  }]
};
exports.eject = eject;
var chevronLeft = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1171 301l-531 531 531 531q19 19 19 45t-19 45l-166 166q-19 19-45 19t-45-19l-742-742q-19-19-19-45t19-45l742-742q19-19 45-19t45 19l166 166q19 19 19 45t-19 45z"
    }
  }]
};
exports.chevronLeft = chevronLeft;
var chevronRight = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1107 877l-742 742q-19 19-45 19t-45-19l-166-166q-19-19-19-45t19-45l531-531-531-531q-19-19-19-45t19-45l166-166q19-19 45-19t45 19l742 742q19 19 19 45t-19 45z"
    }
  }]
};
exports.chevronRight = chevronRight;
var plusCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1216 960v-128q0-26-19-45t-45-19h-256v-256q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v256h-256q-26 0-45 19t-19 45v128q0 26 19 45t45 19h256v256q0 26 19 45t45 19h128q26 0 45-19t19-45v-256h256q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.plusCircle = plusCircle;
var minusCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1216 960v-128q0-26-19-45t-45-19h-768q-26 0-45 19t-19 45v128q0 26 19 45t45 19h768q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.minusCircle = minusCircle;
var timesCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1149 1122q0-26-19-45l-181-181 181-181q19-19 19-45 0-27-19-46l-90-90q-19-19-46-19-26 0-45 19l-181 181-181-181q-19-19-45-19-27 0-46 19l-90 90q-19 19-19 46 0 26 19 45l181 181-181 181q-19 19-19 45 0 27 19 46l90 90q19 19 46 19 26 0 45-19l181-181 181 181q19 19 45 19 27 0 46-19l90-90q19-19 19-46zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.timesCircle = timesCircle;
var checkCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1284 734q0-28-18-46l-91-90q-19-19-45-19t-45 19l-408 407-226-226q-19-19-45-19t-45 19l-91 90q-18 18-18 46 0 27 18 45l362 362q19 19 45 19 27 0 46-19l543-543q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.checkCircle = checkCircle;
var questionCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1376v-192q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v192q0 14 9 23t23 9h192q14 0 23-9t9-23zM1152 704q0-88-55.5-163t-138.5-116-170-41q-243 0-371 213-15 24 8 42l132 100q7 6 19 6 16 0 25-12 53-68 86-92 34-24 86-24 48 0 85.5 26t37.5 59q0 38-20 61t-68 45q-63 28-115.5 86.5t-52.5 125.5v36q0 14 9 23t23 9h192q14 0 23-9t9-23q0-19 21.5-49.5t54.5-49.5q32-18 49-28.5t46-35 44.5-48 28-60.5 12.5-81zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.questionCircle = questionCircle;
var infoCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1376v-160q0-14-9-23t-23-9h-96v-512q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v160q0 14 9 23t23 9h96v320h-96q-14 0-23 9t-9 23v160q0 14 9 23t23 9h448q14 0 23-9t9-23zM896 480v-160q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v160q0 14 9 23t23 9h192q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.infoCircle = infoCircle;
var crosshairs = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1197 1024h-109q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h109q-32-108-112.5-188.5t-188.5-112.5v109q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-109q-108 32-188.5 112.5t-112.5 188.5h109q26 0 45 19t19 45v128q0 26-19 45t-45 19h-109q32 108 112.5 188.5t188.5 112.5v-109q0-26 19-45t45-19h128q26 0 45 19t19 45v109q108-32 188.5-112.5t112.5-188.5zM1536 832v128q0 26-19 45t-45 19h-143q-37 161-154.5 278.5t-278.5 154.5v143q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-143q-161-37-278.5-154.5t-154.5-278.5h-143q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h143q37-161 154.5-278.5t278.5-154.5v-143q0-26 19-45t45-19h128q26 0 45 19t19 45v143q161 37 278.5 154.5t154.5 278.5h143q26 0 45 19t19 45z"
    }
  }]
};
exports.crosshairs = crosshairs;
var timesCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1097 1079l-146 146q-10 10-23 10t-23-10l-137-137-137 137q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l137-137-137-137q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l137 137 137-137q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-137 137 137 137q10 10 10 23t-10 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.timesCircleO = timesCircleO;
var checkCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1171 813l-422 422q-19 19-45 19t-45-19l-294-294q-19-19-19-45t19-45l102-102q19-19 45-19t45 19l147 147 275-275q19-19 45-19t45 19l102 102q19 19 19 45t-19 45zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.checkCircleO = checkCircleO;
var ban = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1312 893q0-161-87-295l-754 753q137 89 297 89 111 0 211.5-43.5t173.5-116.5 116-174.5 43-212.5zM313 1192l755-754q-135-91-300-91-148 0-273 73t-198 199-73 274q0 162 89 299zM1536 893q0 157-61 300t-163.5 246-245 164-298.5 61-298.5-61-245-164-163.5-246-61-300 61-299.5 163.5-245.5 245-164 298.5-61 298.5 61 245 164 163.5 245.5 61 299.5z"
    }
  }]
};
exports.ban = ban;
var arrowLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896v128q0 53-32.5 90.5t-84.5 37.5h-704l293 294q38 36 38 90t-38 90l-75 76q-37 37-90 37-52 0-91-37l-651-652q-37-37-37-90 0-52 37-91l651-650q38-38 91-38 52 0 90 38l75 74q38 38 38 91t-38 91l-293 293h704q52 0 84.5 37.5t32.5 90.5z"
    }
  }]
};
exports.arrowLeft = arrowLeft;
var arrowRight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1472 960q0 54-37 91l-651 651q-39 37-91 37-51 0-90-37l-75-75q-38-38-38-91t38-91l293-293h-704q-52 0-84.5-37.5t-32.5-90.5v-128q0-53 32.5-90.5t84.5-37.5h704l-293-294q-38-36-38-90t38-90l75-75q38-38 90-38 53 0 91 38l651 651q37 35 37 90z"
    }
  }]
};
exports.arrowRight = arrowRight;
var arrowUp = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1611 971q0 51-37 90l-75 75q-38 38-91 38-54 0-90-38l-294-293v704q0 52-37.5 84.5t-90.5 32.5h-128q-53 0-90.5-32.5t-37.5-84.5v-704l-294 293q-36 38-90 38t-90-38l-75-75q-38-38-38-90 0-53 38-91l651-651q35-37 90-37 54 0 91 37l651 651q37 39 37 91z"
    }
  }]
};
exports.arrowUp = arrowUp;
var arrowDown = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1611 832q0 53-37 90l-651 652q-39 37-91 37-53 0-90-37l-651-652q-38-36-38-90 0-53 38-91l74-75q39-37 91-37 53 0 90 37l294 294v-704q0-52 38-90t90-38h128q52 0 90 38t38 90v704l294-294q37-37 90-37 52 0 91 37l75 75q37 39 37 91z"
    }
  }]
};
exports.arrowDown = arrowDown;
var mailForward = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 640q0 26-19 45l-512 512q-19 19-45 19t-45-19-19-45v-256h-224q-98 0-175.5 6t-154 21.5-133 42.5-105.5 69.5-80 101-48.5 138.5-17.5 181q0 55 5 123 0 6 2.5 23.5t2.5 26.5q0 15-8.5 25t-23.5 10q-16 0-28-17-7-9-13-22t-13.5-30-10.5-24q-127-285-127-451 0-199 53-333 162-403 875-403h224v-256q0-26 19-45t45-19 45 19l512 512q19 19 19 45z"
    }
  }]
};
exports.mailForward = mailForward;
var share = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 640q0 26-19 45l-512 512q-19 19-45 19t-45-19-19-45v-256h-224q-98 0-175.5 6t-154 21.5-133 42.5-105.5 69.5-80 101-48.5 138.5-17.5 181q0 55 5 123 0 6 2.5 23.5t2.5 26.5q0 15-8.5 25t-23.5 10q-16 0-28-17-7-9-13-22t-13.5-30-10.5-24q-127-285-127-451 0-199 53-333 162-403 875-403h224v-256q0-26 19-45t45-19 45 19l512 512q19 19 19 45z"
    }
  }]
};
exports.share = share;
var expand = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M755 1056q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23zM1536 192v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45z"
    }
  }]
};
exports.expand = expand;
var compress = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 960v448q0 26-19 45t-45 19-45-19l-144-144-332 332q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l332-332-144-144q-19-19-19-45t19-45 45-19h448q26 0 45 19t19 45zM1523 288q0 13-10 23l-332 332 144 144q19 19 19 45t-19 45-45 19h-448q-26 0-45-19t-19-45v-448q0-26 19-45t45-19 45 19l144 144 332-332q10-10 23-10t23 10l114 114q10 10 10 23z"
    }
  }]
};
exports.compress = compress;
var plus = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 736v192q0 40-28 68t-68 28h-416v416q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-416h-416q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h416v-416q0-40 28-68t68-28h192q40 0 68 28t28 68v416h416q40 0 68 28t28 68z"
    }
  }]
};
exports.plus = plus;
var minus = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 736v192q0 40-28 68t-68 28h-1216q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h1216q40 0 68 28t28 68z"
    }
  }]
};
exports.minus = minus;
var asterisk = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1482 1050q46 26 59.5 77.5t-12.5 97.5l-64 110q-26 46-77.5 59.5t-97.5-12.5l-266-153v307q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-307l-266 153q-46 26-97.5 12.5t-77.5-59.5l-64-110q-26-46-12.5-97.5t59.5-77.5l266-154-266-154q-46-26-59.5-77.5t12.5-97.5l64-110q26-46 77.5-59.5t97.5 12.5l266 153v-307q0-52 38-90t90-38h128q52 0 90 38t38 90v307l266-153q46-26 97.5-12.5t77.5 59.5l64 110q26 46 12.5 97.5t-59.5 77.5l-266 154z"
    }
  }]
};
exports.asterisk = asterisk;
var exclamationCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM896 1375v-190q0-14-9-23.5t-22-9.5h-192q-13 0-23 10t-10 23v190q0 13 10 23t23 10h192q13 0 22-9.5t9-23.5zM894 1031l18-621q0-12-10-18-10-8-24-8h-220q-14 0-24 8-10 6-10 18l17 621q0 10 10 17.5t24 7.5h185q14 0 23.5-7.5t10.5-17.5z"
    }
  }]
};
exports.exclamationCircle = exclamationCircle;
var gift = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M928 1356v-56-468-192h-320v192 468 56q0 25 18 38.5t46 13.5h192q28 0 46-13.5t18-38.5zM472 512h195l-126-161q-26-31-69-31-40 0-68 28t-28 68 28 68 68 28zM1160 416q0-40-28-68t-68-28q-43 0-69 31l-125 161h194q40 0 68-28t28-68zM1536 672v320q0 14-9 23t-23 9h-96v416q0 40-28 68t-68 28h-1088q-40 0-68-28t-28-68v-416h-96q-14 0-23-9t-9-23v-320q0-14 9-23t23-9h440q-93 0-158.5-65.5t-65.5-158.5 65.5-158.5 158.5-65.5q107 0 168 77l128 165 128-165q61-77 168-77 93 0 158.5 65.5t65.5 158.5-65.5 158.5-158.5 65.5h440q14 0 23 9t9 23z"
    }
  }]
};
exports.gift = gift;
var leaf = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 704q0-26-19-45t-45-19q-172 0-318 49.5t-259.5 134-235.5 219.5q-19 21-19 45 0 26 19 45t45 19q24 0 45-19 27-24 74-71t67-66q137-124 268.5-176t313.5-52q26 0 45-19t19-45zM1792 506q0 95-20 193-46 224-184.5 383t-357.5 268q-214 108-438 108-148 0-286-47-15-5-88-42t-96-37q-16 0-39.5 32t-45 70-52.5 70-60 32q-43 0-63.5-17.5t-45.5-59.5q-2-4-6-11t-5.5-10-3-9.5-1.5-13.5q0-35 31-73.5t68-65.5 68-56 31-48q0-4-14-38t-16-44q-9-51-9-104 0-115 43.5-220t119-184.5 170.5-139 204-95.5q55-18 145-25.5t179.5-9 178.5-6 163.5-24 113.5-56.5l29.5-29.5t29.5-28 27-20 36.5-16 43.5-4.5q39 0 70.5 46t47.5 112 24 124 8 96z"
    }
  }]
};
exports.leaf = leaf;
var fire = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 1696v64q0 13-9.5 22.5t-22.5 9.5h-1344q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h1344q13 0 22.5 9.5t9.5 22.5zM1152 640q0 78-24.5 144t-64 112.5-87.5 88-96 77.5-87.5 72-64 81.5-24.5 96.5q0 96 67 224l-4-1 1 1q-90-41-160-83t-138.5-100-113.5-122.5-72.5-150.5-27.5-184q0-78 24.5-144t64-112.5 87.5-88 96-77.5 87.5-72 64-81.5 24.5-96.5q0-94-66-224l3 1-1-1q90 41 160 83t138.5 100 113.5 122.5 72.5 150.5 27.5 184z"
    }
  }]
};
exports.fire = fire;
var eye = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 960q-152-236-381-353 61 104 61 225 0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-121 61-225-229 117-381 353 133 205 333.5 326.5t434.5 121.5 434.5-121.5 333.5-326.5zM944 576q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zM1792 960q0 34-20 69-140 230-376.5 368.5t-499.5 138.5-499.5-139-376.5-368q-20-35-20-69t20-69q140-229 376.5-368t499.5-139 499.5 139 376.5 368q20 35 20 69z"
    }
  }]
};
exports.eye = eye;
var eyeSlash = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M555 1335l78-141q-87-63-136-159t-49-203q0-121 61-225-229 117-381 353 167 258 427 375zM944 576q0-20-14-34t-34-14q-125 0-214.5 89.5t-89.5 214.5q0 20 14 34t34 14 34-14 14-34q0-86 61-147t147-61q20 0 34-14t14-34zM1307 385q0 7-1 9-106 189-316 567t-315 566l-49 89q-10 16-28 16-12 0-134-70-16-10-16-28 0-12 44-87-143-65-263.5-173t-208.5-245q-20-31-20-69t20-69q153-235 380-371t496-136q89 0 180 17l54-97q10-16 28-16 5 0 18 6t31 15.5 33 18.5 31.5 18.5 19.5 11.5q16 10 16 27zM1344 832q0 139-79 253.5t-209 164.5l280-502q8 45 8 84zM1792 960q0 35-20 69-39 64-109 145-150 172-347.5 267t-419.5 95l74-132q212-18 392.5-137t301.5-307q-115-179-282-294l63-112q95 64 182.5 153t144.5 184q20 34 20 69z"
    }
  }]
};
exports.eyeSlash = eyeSlash;
var exclamationTriangle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zM1022 1001l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zM1008 67l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"
    }
  }]
};
exports.exclamationTriangle = exclamationTriangle;
var warning = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1375v-190q0-14-9.5-23.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 23.5v190q0 14 9.5 23.5t22.5 9.5h192q13 0 22.5-9.5t9.5-23.5zM1022 1001l18-459q0-12-10-19-13-11-24-11h-220q-11 0-24 11-10 7-10 21l17 457q0 10 10 16.5t24 6.5h185q14 0 23.5-6.5t10.5-16.5zM1008 67l768 1408q35 63-2 126-17 29-46.5 46t-63.5 17h-1536q-34 0-63.5-17t-46.5-46q-37-63-2-126l768-1408q17-31 47-49t65-18 65 18 47 49z"
    }
  }]
};
exports.warning = warning;
var plane = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1376 160q44 52 12 148t-108 172l-161 161 160 696q5 19-12 33l-128 96q-7 6-19 6-4 0-7-1-15-3-21-16l-279-508-259 259 53 194q5 17-8 31l-96 96q-9 9-23 9h-2q-15-2-24-13l-189-252-252-189q-11-7-13-23-1-13 9-25l96-97q9-9 23-9 6 0 8 1l194 53 259-259-508-279q-14-8-17-24-2-16 9-27l128-128q14-13 30-8l665 159 160-160q76-76 172-108t148 12z"
    }
  }]
};
exports.plane = plane;
var calendar = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M128 1664h288v-288h-288v288zM480 1664h320v-288h-320v288zM128 1312h288v-320h-288v320zM480 1312h320v-320h-320v320zM128 928h288v-288h-288v288zM864 1664h320v-288h-320v288zM480 928h320v-288h-320v288zM1248 1664h288v-288h-288v288zM864 1312h320v-320h-320v320zM512 448v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1248 1312h288v-320h-288v320zM864 928h320v-288h-320v288zM1248 928h288v-288h-288v288zM1280 448v-288q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v288q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"
    }
  }]
};
exports.calendar = calendar;
var random = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M666 481q-60 92-137 273-22-45-37-72.5t-40.5-63.5-51-56.5-63-35-81.5-14.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q250 0 410 225zM1792 1280q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192q-32 0-85 0.5t-81 1-73-1-71-5-64-10.5-63-18.5-58-28.5-59-40-55-53.5-56-69.5q59-93 136-273 22 45 37 72.5t40.5 63.5 51 56.5 63 35 81.5 14.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zM1792 384q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-256q-48 0-87 15t-69 45-51 61.5-45 77.5q-32 62-78 171-29 66-49.5 111t-54 105-64 100-74 83-90 68.5-106.5 42-128 16.5h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224q48 0 87-15t69-45 51-61.5 45-77.5q32-62 78-171 29-66 49.5-111t54-105 64-100 74-83 90-68.5 106.5-42 128-16.5h256v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z"
    }
  }]
};
exports.random = random;
var comment = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22-17 2-30.5-9t-17.5-29v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5q244 0 450 85.5t326 233 120 321.5z"
    }
  }]
};
exports.comment = comment;
var magnet = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 832v128q0 201-98.5 362t-274 251.5-395.5 90.5-395.5-90.5-274-251.5-98.5-362v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v128q0 52 23.5 90t53.5 57 71 30 64 13 44 2 44-2 64-13 71-30 53.5-57 23.5-90v-128q0-26 19-45t45-19h384q26 0 45 19t19 45zM512 192v384q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h384q26 0 45 19t19 45zM1536 192v384q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h384q26 0 45 19t19 45z"
    }
  }]
};
exports.magnet = magnet;
var chevronUp = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1683 1331l-166 165q-19 19-45 19t-45-19l-531-531-531 531q-19 19-45 19t-45-19l-166-165q-19-19-19-45.5t19-45.5l742-741q19-19 45-19t45 19l742 741q19 19 19 45.5t-19 45.5z"
    }
  }]
};
exports.chevronUp = chevronUp;
var chevronDown = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1683 808l-742 741q-19 19-45 19t-45-19l-742-741q-19-19-19-45.5t19-45.5l166-165q19-19 45-19t45 19l531 531 531-531q19-19 45-19t45 19l166 165q19 19 19 45.5t-19 45.5z"
    }
  }]
};
exports.chevronDown = chevronDown;
var retweet = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1504q0 13-9.5 22.5t-22.5 9.5h-960q-8 0-13.5-2t-9-7-5.5-8-3-11.5-1-11.5v-13-11-160-416h-192q-26 0-45-19t-19-45q0-24 15-41l320-384q19-22 49-22t49 22l320 384q15 17 15 41 0 26-19 45t-45 19h-192v384h576q16 0 25 11l160 192q7 10 7 21zM1920 1088q0 24-15 41l-320 384q-20 23-49 23t-49-23l-320-384q-15-17-15-41 0-26 19-45t45-19h192v-384h-576q-16 0-25-12l-160-192q-7-9-7-20 0-13 9.5-22.5t22.5-9.5h960q8 0 13.5 2t9 7 5.5 8 3 11.5 1 11.5v13 11 160 416h192q26 0 45 19t19 45z"
    }
  }]
};
exports.retweet = retweet;
var shoppingCart = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1536q0 52-38 90t-90 38-90-38-38-90 38-90 90-38 90 38 38 90zM1536 1536q0 52-38 90t-90 38-90-38-38-90 38-90 90-38 90 38 38 90zM1664 448v512q0 24-16.5 42.5t-40.5 21.5l-1044 122q13 60 13 70 0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-11 8-31.5t16-36 21.5-40 15.5-29.5l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t19.5 15.5 13 24.5 8 26 5.5 29.5 4.5 26h1201q26 0 45 19t19 45z"
    }
  }]
};
exports.shoppingCart = shoppingCart;
var folder = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"
    }
  }]
};
exports.folder = folder;
var folderOpen = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1879 952q0 31-31 66l-336 396q-43 51-120.5 86.5t-143.5 35.5h-1088q-34 0-60.5-13t-26.5-43q0-31 31-66l336-396q43-51 120.5-86.5t143.5-35.5h1088q34 0 60.5 13t26.5 43zM1536 608v160h-832q-94 0-197 47.5t-164 119.5l-337 396-5 6q0-4-0.5-12.5t-0.5-12.5v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158z"
    }
  }]
};
exports.folderOpen = folderOpen;
var arrowsV = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 320q0 26-19 45t-45 19h-128v1024h128q26 0 45 19t19 45-19 45l-256 256q-19 19-45 19t-45-19l-256-256q-19-19-19-45t19-45 45-19h128v-1024h-128q-26 0-45-19t-19-45 19-45l256-256q19-19 45-19t45 19l256 256q19 19 19 45z"
    }
  }]
};
exports.arrowsV = arrowsV;
var arrowsH = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 896q0 26-19 45l-256 256q-19 19-45 19t-45-19-19-45v-128h-1024v128q0 26-19 45t-45 19-45-19l-256-256q-19-19-19-45t19-45l256-256q19-19 45-19t45 19 19 45v128h1024v-128q0-26 19-45t45-19 45 19l256 256q19 19 19 45z"
    }
  }]
};
exports.arrowsH = arrowsH;
var barChart = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"
    }
  }]
};
exports.barChart = barChart;
var barChartO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896v512h-256v-512h256zM1024 384v1024h-256v-1024h256zM2048 1536v128h-2048v-1536h128v1408h1920zM1408 640v768h-256v-768h256zM1792 256v1152h-256v-1152h256z"
    }
  }]
};
exports.barChartO = barChartO;
var twitterSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 610q-56 25-121 34 68-40 93-117-65 38-134 51-61-66-153-66-87 0-148.5 61.5t-61.5 148.5q0 29 5 48-129-7-242-65t-192-155q-29 50-29 106 0 114 91 175-47-1-100-26v2q0 75 50 133.5t123 72.5q-29 8-51 8-13 0-39-4 21 63 74.5 104t121.5 42q-116 90-261 90-26 0-50-3 148 94 322 94 112 0 210-35.5t168-95 120.5-137 75-162 24.5-168.5q0-18-1-27 63-45 105-109zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.twitterSquare = twitterSquare;
var facebookSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-188v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-532q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z"
    }
  }]
};
exports.facebookSquare = facebookSquare;
var cameraRetro = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M928 832q0-14-9-23t-23-9q-66 0-113 47t-47 113q0 14 9 23t23 9 23-9 9-23q0-40 28-68t68-28q14 0 23-9t9-23zM1152 962q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM128 1536h1536v-128h-1536v128zM1280 962q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM256 320h384v-128h-384v128zM128 512h1536v-118-138h-828l-64 128h-644v128zM1792 256v1280q0 53-37.5 90.5t-90.5 37.5h-1536q-53 0-90.5-37.5t-37.5-90.5v-1280q0-53 37.5-90.5t90.5-37.5h1536q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.cameraRetro = cameraRetro;
var key = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M832 512q0-80-56-136t-136-56-136 56-56 136q0 42 19 83-41-19-83-19-80 0-136 56t-56 136 56 136 136 56 136-56 56-136q0-42-19-83 41 19 83 19 80 0 136-56t56-136zM1683 1216q0 17-49 66t-66 49q-9 0-28.5-16t-36.5-33-38.5-40-24.5-26l-96 96 220 220q28 28 28 68 0 42-39 81t-81 39q-40 0-68-28l-671-671q-176 131-365 131-163 0-265.5-102.5t-102.5-265.5q0-160 95-313t248-248 313-95q163 0 265.5 102.5t102.5 265.5q0 189-131 365l355 355 96-96q-3-3-26-24.5t-40-38.5-33-36.5-16-28.5q0-17 49-66t66-49q13 0 23 10 6 6 46 44.5t82 79.5 86.5 86 73 78 28.5 41z"
    }
  }]
};
exports.key = key;
var cogs = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1664 1408q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1664 384q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1280 805v185q0 10-7 19.5t-16 10.5l-155 24q-11 35-32 76 34 48 90 115 7 11 7 20 0 12-7 19-23 30-82.5 89.5t-78.5 59.5q-11 0-21-7l-115-90q-37 19-77 31-11 108-23 155-7 24-30 24h-186q-11 0-20-7.5t-10-17.5l-23-153q-34-10-75-31l-118 89q-7 7-20 7-11 0-21-8-144-133-144-160 0-9 7-19 10-14 41-53t47-61q-23-44-35-82l-152-24q-10-1-17-9.5t-7-19.5v-185q0-10 7-19.5t16-10.5l155-24q11-35 32-76-34-48-90-115-7-11-7-20 0-12 7-20 22-30 82-89t79-59q11 0 21 7l115 90q34-18 77-32 11-108 23-154 7-24 30-24h186q11 0 20 7.5t10 17.5l23 153q34 10 75 31l118-89q8-7 20-7 11 0 21 8 144 133 144 160 0 8-7 19-12 16-42 54t-45 60q23 48 34 82l152 23q10 2 17 10.5t7 19.5zM1920 1338v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31zM1920 314v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31z"
    }
  }]
};
exports.cogs = cogs;
var gears = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1664 1408q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1664 384q0-52-38-90t-90-38-90 38-38 90q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5zM1280 805v185q0 10-7 19.5t-16 10.5l-155 24q-11 35-32 76 34 48 90 115 7 11 7 20 0 12-7 19-23 30-82.5 89.5t-78.5 59.5q-11 0-21-7l-115-90q-37 19-77 31-11 108-23 155-7 24-30 24h-186q-11 0-20-7.5t-10-17.5l-23-153q-34-10-75-31l-118 89q-7 7-20 7-11 0-21-8-144-133-144-160 0-9 7-19 10-14 41-53t47-61q-23-44-35-82l-152-24q-10-1-17-9.5t-7-19.5v-185q0-10 7-19.5t16-10.5l155-24q11-35 32-76-34-48-90-115-7-11-7-20 0-12 7-20 22-30 82-89t79-59q11 0 21 7l115 90q34-18 77-32 11-108 23-154 7-24 30-24h186q11 0 20 7.5t10 17.5l23 153q34 10 75 31l118-89q8-7 20-7 11 0 21 8 144 133 144 160 0 8-7 19-12 16-42 54t-45 60q23 48 34 82l152 23q10 2 17 10.5t7 19.5zM1920 1338v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31zM1920 314v140q0 16-149 31-12 27-30 52 51 113 51 138 0 4-4 7-122 71-124 71-8 0-46-47t-52-68q-20 2-30 2t-30-2q-14 21-52 68t-46 47q-2 0-124-71-4-3-4-7 0-25 51-138-18-25-30-52-149-15-149-31v-140q0-16 149-31 13-29 30-52-51-113-51-138 0-4 4-7 4-2 35-20t59-34 30-16q8 0 46 46.5t52 67.5q20-2 30-2t30 2q51-71 92-112l6-2q4 0 124 70 4 3 4 7 0 25-51 138 17 23 30 52 149 15 149 31z"
    }
  }]
};
exports.gears = gears;
var comments = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 768q0 139-94 257t-256.5 186.5-353.5 68.5q-86 0-176-16-124 88-278 128-36 9-86 16h-3q-11 0-20.5-8t-11.5-21q-1-3-1-6.5t0.5-6.5 2-6l2.5-5t3.5-5.5 4-5 4.5-5 4-4.5q5-6 23-25t26-29.5 22.5-29 25-38.5 20.5-44q-124-72-195-177t-71-224q0-139 94-257t256.5-186.5 353.5-68.5 353.5 68.5 256.5 186.5 94 257zM1792 1024q0 120-71 224.5t-195 176.5q10 24 20.5 44t25 38.5 22.5 29 26 29.5 23 25q1 1 4 4.5t4.5 5 4 5 3.5 5.5l2.5 5t2 6 0.5 6.5-1 6.5q-3 14-13 22t-22 7q-50-7-86-16-154-40-278-128-90 16-176 16-271 0-472-132 58 4 88 4 161 0 309-45t264-129q125-92 192-212t67-254q0-77-23-152 129 71 204 178t75 230z"
    }
  }]
};
exports.comments = comments;
var thumbsOUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 768q0-51-39-89.5t-89-38.5h-352q0-58 48-159.5t48-160.5q0-98-32-145t-128-47q-26 26-38 85t-30.5 125.5-59.5 109.5q-22 23-77 91-4 5-23 30t-31.5 41-34.5 42.5-40 44-38.5 35.5-40 27-35.5 9h-32v640h32q13 0 31.5 3t33 6.5 38 11 35 11.5 35.5 12.5 29 10.5q211 73 342 73h121q192 0 192-167 0-26-5-56 30-16 47.5-52.5t17.5-73.5-18-69q53-50 53-119 0-25-10-55.5t-25-47.5q32-1 53.5-47t21.5-81zM1536 767q0 89-49 163 9 33 9 69 0 77-38 144 3 21 3 43 0 101-60 178 1 139-85 219.5t-227 80.5h-36-93q-96 0-189.5-22.5t-216.5-65.5q-116-40-138-40h-288q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h274q36-24 137-155 58-75 107-128 24-25 35.5-85.5t30.5-126.5 62-108q39-37 90-37 84 0 151 32.5t102 101.5 35 186q0 93-48 192h176q104 0 180 76t76 179z"
    }
  }]
};
exports.thumbsOUp = thumbsOUp;
var thumbsODown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 448q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 1024q0-35-21.5-81t-53.5-47q15-17 25-47.5t10-55.5q0-69-53-119 18-31 18-69 0-37-17.5-73.5t-47.5-52.5q5-30 5-56 0-85-49-126t-136-41h-128q-131 0-342 73-5 2-29 10.5t-35.5 12.5-35 11.5-38 11-33 6.5-31.5 3h-32v640h32q16 0 35.5 9t40 27 38.5 35.5 40 44 34.5 42.5 31.5 41 23 30q55 68 77 91 41 43 59.5 109.5t30.5 125.5 38 85q96 0 128-47t32-145q0-59-48-160.5t-48-159.5h352q50 0 89-38.5t39-89.5zM1536 1025q0 103-76 179t-180 76h-176q48 99 48 192 0 118-35 186-35 69-102 101.5t-151 32.5q-51 0-90-37-34-33-54-82t-25.5-90.5-17.5-84.5-31-64q-48-50-107-127-101-131-137-155h-274q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h288q22 0 138-40 128-44 223-66t200-22h112q140 0 226.5 79t85.5 216v5q60 77 60 178 0 22-3 43 38 67 38 144 0 36-9 69 49 73 49 163z"
    }
  }]
};
exports.thumbsODown = thumbsODown;
var starHalf = {
  "viewBox": "0 0 896 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M832 32v1339l-449 236q-22 12-40 12-21 0-31.5-14.5t-10.5-35.5q0-6 2-20l86-500-364-354q-25-27-25-48 0-37 56-46l502-73 225-455q19-41 49-41z"
    }
  }]
};
exports.starHalf = starHalf;
var heartO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 596q0-81-21.5-143t-55-98.5-81.5-59.5-94-31-98-8-112 25.5-110.5 64-86.5 72-60 61.5q-18 22-49 22t-49-22q-24-28-60-61.5t-86.5-72-110.5-64-112-25.5-98 8-94 31-81.5 59.5-55 98.5-21.5 143q0 168 187 355l581 560 580-559q188-188 188-356zM1792 596q0 221-229 450l-623 600q-18 18-44 18t-44-18l-624-602q-10-8-27.5-26t-55.5-65.5-68-97.5-53.5-121-23.5-138q0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z"
    }
  }]
};
exports.heartO = heartO;
var signOut = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1440q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-119 0-203.5-84.5t-84.5-203.5v-704q0-119 84.5-203.5t203.5-84.5h320q13 0 22.5 9.5t9.5 22.5q0 4 1 20t0.5 26.5-3 23.5-10 19.5-20.5 6.5h-320q-66 0-113 47t-47 113v704q0 66 47 113t113 47h288 11 13t11.5 1 11.5 3 8 5.5 7 9 2 13.5zM1568 896q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288h-448q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h448v-288q0-26 19-45t45-19 45 19l544 544q19 19 19 45z"
    }
  }]
};
exports.signOut = signOut;
var linkedinSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M237 1414h231v-694h-231v694zM483 506q-1-52-36-86t-93-34-94.5 34-36.5 86q0 51 35.5 85.5t92.5 34.5h1q59 0 95-34.5t36-85.5zM1068 1414h231v-398q0-154-73-233t-193-79q-136 0-209 117h2v-101h-231q3 66 0 694h231v-388q0-38 7-56 15-35 45-59.5t74-24.5q116 0 116 157v371zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.linkedinSquare = linkedinSquare;
var thumbTack = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M480 864v-448q0-14-9-23t-23-9-23 9-9 23v448q0 14 9 23t23 9 23-9 9-23zM1152 1216q0 26-19 45t-45 19h-429l-51 483q-2 12-10.5 20.5t-20.5 8.5h-1q-27 0-32-27l-76-485h-404q-26 0-45-19t-19-45q0-123 78.5-221.5t177.5-98.5v-512q-52 0-90-38t-38-90 38-90 90-38h640q52 0 90 38t38 90-38 90-90 38v512q99 0 177.5 98.5t78.5 221.5z"
    }
  }]
};
exports.thumbTack = thumbTack;
var externalLink = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 928v320q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-320q0-14 9-23t23-9h64q14 0 23 9t9 23zM1792 64v512q0 26-19 45t-45 19-45-19l-176-176-652 652q-10 10-23 10t-23-10l-114-114q-10-10-10-23t10-23l652-652-176-176q-19-19-19-45t19-45 45-19h512q26 0 45 19t19 45z"
    }
  }]
};
exports.externalLink = externalLink;
var signIn = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1184 896q0 26-19 45l-544 544q-19 19-45 19t-45-19-19-45v-288h-448q-26 0-45-19t-19-45v-384q0-26 19-45t45-19h448v-288q0-26 19-45t45-19 45 19l544 544q19 19 19 45zM1536 544v704q0 119-84.5 203.5t-203.5 84.5h-320q-13 0-22.5-9.5t-9.5-22.5q0-4-1-20t-0.5-26.5 3-23.5 10-19.5 20.5-6.5h320q66 0 113-47t47-113v-704q0-66-47-113t-113-47h-288-11-13t-11.5-1-11.5-3-8-5.5-7-9-2-13.5q0-4-1-20t-0.5-26.5 3-23.5 10-19.5 20.5-6.5h320q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.signIn = signIn;
var trophy = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M458 883q-74-162-74-371h-256v96q0 78 94.5 162t235.5 113zM1536 608v-96h-256q0 209-74 371 141-29 235.5-113t94.5-162zM1664 480v128q0 71-41.5 143t-112 130-173 97.5-215.5 44.5q-42 54-95 95-38 34-52.5 72.5t-14.5 89.5q0 54 30.5 91t97.5 37q75 0 133.5 45.5t58.5 114.5v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-69 58.5-114.5t133.5-45.5q67 0 97.5-37t30.5-91q0-51-14.5-89.5t-52.5-72.5q-53-41-95-95-113-5-215.5-44.5t-173-97.5-112-130-41.5-143v-128q0-40 28-68t68-28h288v-96q0-66 47-113t113-47h576q66 0 113 47t47 113v96h288q40 0 68 28t28 68z"
    }
  }]
};
exports.trophy = trophy;
var githubSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M519 1200q4-6-3-13-9-7-14-2-4 6 3 13 9 7 14 2zM491 1159q-5-7-12-4-6 4 0 12 7 8 12 5 6-4 0-13zM450 1119q2-4-5-8-7-2-8 2-3 5 4 8 8 2 9-2zM471 1142q2-1 1.5-4.5t-3.5-5.5q-6-7-10-3t1 11q6 6 11 2zM557 1217q2-7-9-11-9-3-13 4-2 7 9 11 9 3 13-4zM599 1220q0-8-12-8-10 0-10 8t11 8 11-8zM638 1213q-2-7-13-5t-9 9q2 8 12 6t10-10zM1280 896q0-212-150-362t-362-150-362 150-150 362q0 167 98 300.5t252 185.5q18 3 26.5-5t8.5-20q0-52-1-95-6 1-15.5 2.5t-35.5 2-48-4-43.5-20-29.5-41.5q-23-59-57-74-2-1-4.5-3.5l-8-8t-7-9.5 4-7.5 19.5-3.5q6 0 15 2t30 15.5 33 35.5q16 28 37.5 42t43.5 14 38-3.5 30-9.5q7-47 33-69-49-6-86-18.5t-73-39-55.5-76-19.5-119.5q0-79 53-137-24-62 5-136 19-6 54.5 7.5t60.5 29.5l26 16q58-17 128-17t128 17q11-7 28.5-18t55.5-26 57-9q29 74 5 136 53 58 53 137 0 57-14 100.5t-35.5 70-53.5 44.5-62.5 26-68.5 12q35 31 35 95 0 40-0.5 89t-0.5 51q0 12 8.5 20t26.5 5q154-52 252-185.5t98-300.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.githubSquare = githubSquare;
var upload = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 1248v320q0 40-28 68t-68 28h-1472q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h427q21 56 70.5 92t110.5 36h256q61 0 110.5-36t70.5-92h427q40 0 68 28t28 68zM1339 600q-17 40-59 40h-256v448q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-448h-256q-42 0-59-40-17-39 14-69l448-448q18-19 45-19t45 19l448 448q31 30 14 69z"
    }
  }]
};
exports.upload = upload;
var lemonO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1407 826q0-44-7-113.5t-18-96.5q-12-30-17-44t-9-36.5-4-48.5q0-23 5-68.5t5-67.5q0-37-10-55-4-1-13-1-19 0-58 4.5t-59 4.5q-60 0-176-24t-175-24q-43 0-94.5 11.5t-85 23.5-89.5 34q-137 54-202 103-96 73-159.5 189.5t-88 236-24.5 248.5q0 40 12.5 120t12.5 121q0 23-11 66.5t-11 65.5 12 36.5 34 14.5q24 0 72.5-11t73.5-11q57 0 169.5 15.5t169.5 15.5q181 0 284-36 129-45 235.5-152.5t166-245.5 59.5-275zM1535 824q0 165-70 327.5t-196 288-281 180.5q-124 44-326 44-57 0-170-14.5t-169-14.5q-24 0-72.5 14.5t-73.5 14.5q-73 0-123.5-55.5t-50.5-128.5q0-24 11-68t11-67q0-40-12.5-120.5t-12.5-121.5q0-111 18-217.5t54.5-209.5 100.5-194 150-156q78-59 232-120 194-78 316-78 60 0 175.5 24t173.5 24q19 0 57-5t58-5q81 0 118 50.5t37 134.5q0 23-5 68t-5 68q0 13 2 25t3.5 16.5 7.5 20.5 8 20q16 40 25 118.5t9 136.5z"
    }
  }]
};
exports.lemonO = lemonO;
var phone = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 1240q0 27-10 70.5t-21 68.5q-21 50-122 106-94 51-186 51-27 0-53-3.5t-57.5-12.5-47-14.5-55.5-20.5-49-18q-98-35-175-83-127-79-264-216t-216-264q-48-77-83-175-3-9-18-49t-20.5-55.5-14.5-47-12.5-57.5-3.5-53q0-92 51-186 56-101 106-122 25-11 68.5-21t70.5-10q14 0 21 3 18 6 53 76 11 19 30 54t35 63.5 31 53.5q3 4 17.5 25t21.5 35.5 7 28.5q0 20-28.5 50t-62 55-62 53-28.5 46q0 9 5 22.5t8.5 20.5 14 24 11.5 19q76 137 174 235t235 174q2 1 19 11.5t24 14 20.5 8.5 22.5 5q18 0 46-28.5t53-62 55-62 50-28.5q14 0 28.5 7t35.5 21.5 25 17.5q25 15 53.5 31t63.5 35 54 30q70 35 76 53 3 7 3 21z"
    }
  }]
};
exports.phone = phone;
var squareO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1120 256h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113v-832q0-66-47-113t-113-47zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.squareO = squareO;
var bookmarkO = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 256h-1024v1242l423-406 89-85 89 85 423 406v-1242zM1164 128q23 0 44 9 33 13 52.5 41t19.5 62v1289q0 34-19.5 62t-52.5 41q-19 8-44 8-48 0-83-32l-441-424-441 424q-36 33-83 33-23 0-44-9-33-13-52.5-41t-19.5-62v-1289q0-34 19.5-62t52.5-41q21-9 44-9h1048z"
    }
  }]
};
exports.bookmarkO = bookmarkO;
var phoneSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1193q0-11-2-16t-18-16.5-40.5-25-47.5-26.5-45.5-25-28.5-15q-5-3-19-13t-25-15-21-5q-15 0-36.5 20.5t-39.5 45-38.5 45-33.5 20.5q-7 0-16.5-3.5t-15.5-6.5-17-9.5-14-8.5q-99-55-170-126.5t-127-170.5q-2-3-8.5-14t-9.5-17-6.5-15.5-3.5-16.5q0-13 20.5-33.5t45-38.5 45-39.5 20.5-36.5q0-10-5-21t-15-25-13-19q-3-6-15-28.5t-25-45.5-26.5-47.5-25-40.5-16.5-18-16-2q-48 0-101 22-46 21-80 94.5t-34 130.5q0 16 2.5 34t5 30.5 9 33 10 29.5 12.5 33 11 30q60 164 216.5 320.5t320.5 216.5q6 2 30 11t33 12.5 29.5 10 33 9 30.5 5 34 2.5q57 0 130.5-34t94.5-80q22-53 22-101zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.phoneSquare = phoneSquare;
var twitter = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1620 408q-67 98-162 167 1 14 1 42 0 130-38 259.5t-115.5 248.5-184.5 210.5-258 146-323 54.5q-271 0-496-145 35 4 78 4 225 0 401-138-105-2-188-64.5t-114-159.5q33 5 61 5 43 0 85-11-112-23-185.5-111.5t-73.5-205.5v-4q68 38 146 41-66-44-105-115t-39-154q0-88 44-163 121 149 294.5 238.5t371.5 99.5q-8-38-8-74 0-134 94.5-228.5t228.5-94.5q140 0 236 102 109-21 205-78-37 115-142 178 93-10 186-50z"
    }
  }]
};
exports.twitter = twitter;
var facebook = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"
    }
  }]
};
exports.facebook = facebook;
var facebookF = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M959 12v264h-157q-86 0-116 36t-30 108v189h293l-39 296h-254v759h-306v-759h-255v-296h255v-218q0-186 104-288.5t277-102.5q147 0 228 12z"
    }
  }]
};
exports.facebookF = facebookF;
var github = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5q0 251-146.5 451.5t-378.5 277.5q-27 5-40-7t-13-30q0-3 0.5-76.5t0.5-134.5q0-97-52-142 57-6 102.5-18t94-39 81-66.5 53-105 20.5-150.5q0-119-79-206 37-91-8-204-28-9-81 11t-92 44l-38 24q-93-26-192-26t-192 26q-16-11-42.5-27t-83.5-38.5-85-13.5q-45 113-8 204-79 87-79 206 0 85 20.5 150t52.5 105 80.5 67 94 39 102.5 18q-39 36-49 103-21 10-45 15t-57 5-65.5-21.5-55.5-62.5q-19-32-48.5-52t-49.5-24l-20-3q-21 0-29 4.5t-5 11.5 9 14 13 12l7 5q22 10 43.5 38t31.5 51l10 23q13 38 44 61.5t67 30 69.5 7 55.5-3.5l23-4q0 38 0.5 88.5t0.5 54.5q0 18-13 30t-40 7q-232-77-378.5-277.5t-146.5-451.5q0-209 103-385.5t279.5-279.5 385.5-103zM291 1231q3-7-7-12-10-3-13 2-3 7 7 12 9 6 13-2zM322 1265q7-5-2-16-10-9-16-3-7 5 2 16 10 10 16 3zM352 1310q9-7 0-19-8-13-17-6-9 5 0 18t17 7zM394 1352q8-8-4-19-12-12-20-3-9 8 4 19 12 12 20 3zM451 1377q3-11-13-16-15-4-19 7t13 15q15 6 19-6zM514 1382q0-13-17-11-16 0-16 11 0 13 17 11 16 0 16-11zM572 1372q-2-11-18-9-16 3-14 15t18 8 14-14z"
    }
  }]
};
exports.github = github;
var unlock = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 576v256q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45v-256q0-106-75-181t-181-75-181 75-75 181v192h96q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h672v-192q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5z"
    }
  }]
};
exports.unlock = unlock;
var creditCard = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1760 128q66 0 113 47t47 113v1216q0 66-47 113t-113 47h-1600q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1600zM160 256q-13 0-22.5 9.5t-9.5 22.5v224h1664v-224q0-13-9.5-22.5t-22.5-9.5h-1600zM1760 1536q13 0 22.5-9.5t9.5-22.5v-608h-1664v608q0 13 9.5 22.5t22.5 9.5h1600zM256 1408v-128h256v128h-256zM640 1408v-128h384v128h-384z"
    }
  }]
};
exports.creditCard = creditCard;
var feed = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1467q2 28-17 48-18 21-47 21h-135q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5t-391.5-184.5q-25-2-41.5-20t-16.5-43v-135q0-29 21-47 17-17 43-17h5q160 13 306 80.5t259 181.5q114 113 181.5 259t80.5 306zM1408 1469q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5t-19.5-42.5q-12-215-101-408.5t-231.5-336-336-231.5-408.5-102q-25-1-42.5-19.5t-17.5-43.5v-143q0-28 20-46 18-18 44-18h3q262 13 501.5 120t425.5 294q187 186 294 425.5t120 501.5z"
    }
  }]
};
exports.feed = feed;
var rss = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1467q2 28-17 48-18 21-47 21h-135q-25 0-43-16.5t-20-41.5q-22-229-184.5-391.5t-391.5-184.5q-25-2-41.5-20t-16.5-43v-135q0-29 21-47 17-17 43-17h5q160 13 306 80.5t259 181.5q114 113 181.5 259t80.5 306zM1408 1469q2 27-18 47-18 20-46 20h-143q-26 0-44.5-17.5t-19.5-42.5q-12-215-101-408.5t-231.5-336-336-231.5-408.5-102q-25-1-42.5-19.5t-17.5-43.5v-143q0-28 20-46 18-18 44-18h3q262 13 501.5 120t425.5 294q187 186 294 425.5t120 501.5z"
    }
  }]
};
exports.rss = rss;
var hddO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1040 1216q0 33-23.5 56.5t-56.5 23.5-56.5-23.5-23.5-56.5 23.5-56.5 56.5-23.5 56.5 23.5 23.5 56.5zM1296 1216q0 33-23.5 56.5t-56.5 23.5-56.5-23.5-23.5-56.5 23.5-56.5 56.5-23.5 56.5 23.5 23.5 56.5zM1408 1376v-320q0-13-9.5-22.5t-22.5-9.5h-1216q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5zM178 896h1180l-157-482q-4-13-16-21.5t-26-8.5h-782q-14 0-26 8.5t-16 21.5zM1536 1056v320q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-320q0-25 16-75l197-606q17-53 63-86t101-33h782q55 0 101 33t63 86l197 606q16 50 16 75z"
    }
  }]
};
exports.hddO = hddO;
var bullhorn = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 640q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5v384q0 52-38 90t-90 38q-417-347-812-380-58 19-91 66t-31 100.5 40 92.5q-20 33-23 65.5t6 58 33.5 55 48 50 61.5 50.5q-29 58-111.5 83t-168.5 11.5-132-55.5q-7-23-29.5-87.5t-32-94.5-23-89-15-101 3.5-98.5 22-110.5h-122q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h480q435 0 896-384 52 0 90 38t38 90v384zM1536 1244v-954q-394 302-768 343v270q377 42 768 341z"
    }
  }]
};
exports.bullhorn = bullhorn;
var bellO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM246 1408h1300q-266-300-266-832 0-51-24-105t-69-103-121.5-80.5-169.5-31.5-169.5 31.5-121.5 80.5-69 103-24 105q0 532-266 832zM1728 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"
    }
  }]
};
exports.bellO = bellO;
var certificate = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1376 896l138 135q30 28 20 70-12 41-52 51l-188 48 53 186q12 41-19 70-29 31-70 19l-186-53-48 188q-10 40-51 52-12 2-19 2-31 0-51-22l-135-138-135 138q-28 30-70 20-41-11-51-52l-48-188-186 53q-41 12-70-19-31-29-19-70l53-186-188-48q-40-10-52-51-10-42 20-70l138-135-138-135q-30-28-20-70 12-41 52-51l188-48-53-186q-12-41 19-70 29-31 70-19l186 53 48-188q10-41 51-51 41-12 70 19l135 139 135-139q29-30 70-19 41 10 51 51l48 188 186-53q41-12 70 19 31 29 19 70l-53 186 188 48q40 10 52 51 10 42-20 70z"
    }
  }]
};
exports.certificate = certificate;
var handORight = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1664 768q0-51-39-89.5t-89-38.5h-576q0-20 15-48.5t33-55 33-68 15-84.5q0-67-44.5-97.5t-115.5-30.5q-24 0-90 139-24 44-37 65-40 64-112 145-71 81-101 106-69 57-140 57h-32v640h32q72 0 167 32t193.5 64 179.5 32q189 0 189-167 0-26-5-56 30-16 47.5-52.5t17.5-73.5-18-69q53-50 53-119 0-25-10-55.5t-25-47.5h331q52 0 90-38t38-90zM1792 767q0 105-75.5 181t-180.5 76h-169q-4 62-37 119 3 21 3 43 0 101-60 178 1 139-85 219.5t-227 80.5q-133 0-322-69-164-59-223-59h-288q-53 0-90.5-37.5t-37.5-90.5v-640q0-53 37.5-90.5t90.5-37.5h288q10 0 21.5-4.5t23.5-14 22.5-18 24-22.5 20.5-21.5 19-21.5 14-17q65-74 100-129 13-21 33-62t37-72 40.5-63 55-49.5 69.5-17.5q125 0 206.5 67t81.5 189q0 68-22 128h374q104 0 180 76t76 179z"
    }
  }]
};
exports.handORight = handORight;
var handOLeft = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1376 1408h32v-640h-32q-35 0-67.5-12t-62.5-37-50-46-49-54q-8-9-12-14-72-81-112-145-14-22-38-68-1-3-10.5-22.5t-18.5-36-20-35.5-21.5-30.5-18.5-11.5q-71 0-115.5 30.5t-44.5 97.5q0 43 15 84.5t33 68 33 55 15 48.5h-576q-50 0-89 38.5t-39 89.5q0 52 38 90t90 38h331q-15 17-25 47.5t-10 55.5q0 69 53 119-18 32-18 69t17.5 73.5 47.5 52.5q-4 24-4 56 0 85 48.5 126t135.5 41q84 0 183-32t194-64 167-32zM1664 1344q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1792 768v640q0 53-37.5 90.5t-90.5 37.5h-288q-59 0-223 59-190 69-317 69-142 0-230-77.5t-87-217.5l1-5q-61-76-61-178 0-22 3-43-33-57-37-119h-169q-105 0-180.5-76t-75.5-181q0-103 76-179t180-76h374q-22-60-22-128 0-122 81.5-189t206.5-67q38 0 69.5 17.5t55 49.5 40.5 63 37 72 33 62q35 55 100 129 2 3 14 17t19 21.5 20.5 21.5 24 22.5 22.5 18 23.5 14 21.5 4.5h288q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.handOLeft = handOLeft;
var handOUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1600q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 836q0-189-167-189-26 0-56 5-16-30-52.5-47.5t-73.5-17.5-69 18q-50-53-119-53-25 0-55.5 10t-47.5 25v-331q0-52-38-90t-90-38q-51 0-89.5 39t-38.5 89v576q-20 0-48.5-15t-55-33-68-33-84.5-15q-67 0-97.5 44.5t-30.5 115.5q0 24 139 90 44 24 65 37 64 40 145 112 81 71 106 101 57 69 57 140v32h640v-32q0-72 32-167t64-193.5 32-179.5zM1536 831q0 133-69 322-59 164-59 223v288q0 53-37.5 90.5t-90.5 37.5h-640q-53 0-90.5-37.5t-37.5-90.5v-288q0-10-4.5-21.5t-14-23.5-18-22.5-22.5-24-21.5-20.5-21.5-19-17-14q-74-65-129-100-21-13-62-33t-72-37-63-40.5-49.5-55-17.5-69.5q0-125 67-206.5t189-81.5q68 0 128 22v-374q0-104 76-180t179-76q105 0 181 75.5t76 180.5v169q62 4 119 37 21-3 43-3 101 0 178 60 139-1 219.5 85t80.5 227z"
    }
  }]
};
exports.handOUp = handOUp;
var handODown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 960q0-84-32-183t-64-194-32-167v-32h-640v32q0 35-12 67.5t-37 62.5-46 50-54 49q-9 8-14 12-81 72-145 112-22 14-68 38-3 1-22.5 10.5t-36 18.5-35.5 20-30.5 21.5-11.5 18.5q0 71 30.5 115.5t97.5 44.5q43 0 84.5-15t68-33 55-33 48.5-15v576q0 50 38.5 89t89.5 39q52 0 90-38t38-90v-331q46 35 103 35 69 0 119-53 32 18 69 18t73.5-17.5 52.5-47.5q24 4 56 4 85 0 126-48.5t41-135.5zM1280 192q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1536 956q0 142-77.5 230t-217.5 87l-5-1q-76 61-178 61-22 0-43-3-54 30-119 37v169q0 105-76 180.5t-181 75.5q-103 0-179-76t-76-180v-374q-54 22-128 22-121 0-188.5-81.5t-67.5-206.5q0-38 17.5-69.5t49.5-55 63-40.5 72-37 62-33q55-35 129-100 3-2 17-14t21.5-19 21.5-20.5 22.5-24 18-22.5 14-23.5 4.5-21.5v-288q0-53 37.5-90.5t90.5-37.5h640q53 0 90.5 37.5t37.5 90.5v288q0 59 59 223 69 190 69 317z"
    }
  }]
};
exports.handODown = handODown;
var arrowCircleLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 960v-128q0-26-19-45t-45-19h-502l189-189q19-19 19-45t-19-45l-91-91q-18-18-45-18t-45 18l-362 362-91 91q-18 18-18 45t18 45l91 91 362 362q18 18 45 18t45-18l91-91q18-18 18-45t-18-45l-189-189h502q26 0 45-19t19-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleLeft = arrowCircleLeft;
var arrowCircleRight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1285 896q0-27-18-45l-91-91-362-362q-18-18-45-18t-45 18l-91 91q-18 18-18 45t18 45l189 189h-502q-26 0-45 19t-19 45v128q0 26 19 45t45 19h502l-189 189q-19 19-19 45t19 45l91 91q18 18 45 18t45-18l362-362 91-91q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleRight = arrowCircleRight;
var arrowCircleUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1284 895q0-27-18-45l-362-362-91-91q-18-18-45-18t-45 18l-91 91-362 362q-18 18-18 45t18 45l91 91q18 18 45 18t45-18l189-189v502q0 26 19 45t45 19h128q26 0 45-19t19-45v-502l189 189q19 19 45 19t45-19l91-91q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleUp = arrowCircleUp;
var arrowCircleDown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1284 897q0-27-18-45l-91-91q-18-18-45-18t-45 18l-189 189v-502q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v502l-189-189q-19-19-45-19t-45 19l-91 91q-18 18-18 45t18 45l362 362 91 91q18 18 45 18t45-18l91-91 362-362q18-18 18-45zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleDown = arrowCircleDown;
var globe = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM1042 649q-2 1-9.5 9.5t-13.5 9.5q2 0 4.5-5t5-11 3.5-7q6-7 22-15 14-6 52-12 34-8 51 11-2-2 9.5-13t14.5-12q3-2 15-4.5t15-7.5l2-22q-12 1-17.5-7t-6.5-21q0 2-6 8 0-7-4.5-8t-11.5 1-9 1q-10-3-15-7.5t-8-16.5-4-15q-2-5-9.5-11t-9.5-10q-1-2-2.5-5.5t-3-6.5-4-5.5-5.5-2.5-7 5-7.5 10-4.5 5q-3-2-6-1.5t-4.5 1-4.5 3-5 3.5q-3 2-8.5 3t-8.5 2q15-5-1-11-10-4-16-3 9-4 7.5-12t-8.5-14h5q-1-4-8.5-8.5t-17.5-8.5-13-6q-8-5-34-9.5t-33-0.5q-5 6-4.5 10.5t4 14 3.5 12.5q1 6-5.5 13t-6.5 12q0 7 14 15.5t10 21.5q-3 8-16 16t-16 12q-5 8-1.5 18.5t10.5 16.5q2 2 1.5 4t-3.5 4.5-5.5 4-6.5 3.5l-3 2q-11 5-20.5-6t-13.5-26q-7-25-16-30-23-8-29 1-5-13-41-26-25-9-58-4 6-1 0-15-7-15-19-12 3-6 4-17.5t1-13.5q3-13 12-23 1-1 7-8.5t9.5-13.5 0.5-6q35 4 50-11 5-5 11.5-17t10.5-17q9-6 14-5.5t14.5 5.5 14.5 5q14 1 15.5-11t-7.5-20q12 1 3-17-4-7-8-9-12-4-27 5-8 4 2 8-1-1-9.5 10.5t-16.5 17.5-16-5q-1-1-5.5-13.5t-9.5-13.5q-8 0-16 15 3-8-11-15t-24-8q19-12-8-27-7-4-20.5-5t-19.5 4q-5 7-5.5 11.5t5 8 10.5 5.5 11.5 4 8.5 3q14 10 8 14-2 1-8.5 3.5t-11.5 4.5-6 4q-3 4 0 14t-2 14q-5-5-9-17.5t-7-16.5q7 9-25 6l-10-1q-4 0-16 2t-20.5 1-13.5-8q-4-8 0-20 1-4 4-2-4-3-11-9.5t-10-8.5q-46 15-94 41 6 1 12-1 5-2 13-6.5t10-5.5q34-14 42-7l5-5q14 16 20 25-7-4-30-1-20 6-22 12 7 12 5 18-4-3-11.5-10t-14.5-11-15-5q-16 0-22 1-146 80-235 222 7 7 12 8 4 1 5 9t2.5 11 11.5-3q9 8 3 19 1-1 44 27 19 17 21 21 3 11-10 18-1-2-9-9t-9-4q-3 5 0.5 18.5t10.5 12.5q-7 0-9.5 16t-2.5 35.5-1 23.5l2 1q-3 12 5.5 34.5t21.5 19.5q-13 3 20 43 6 8 8 9 3 2 12 7.5t15 10 10 10.5q4 5 10 22.5t14 23.5q-2 6 9.5 20t10.5 23q-1 0-2.5 1t-2.5 1q3 7 15.5 14t15.5 13q1 3 2 10t3 11 8 2q2-20-24-62-15-25-17-29-3-5-5.5-15.5t-4.5-14.5q2 0 6 1.5t8.5 3.5 7.5 4 2 3q-3 7 2 17.5t12 18.5 17 19 12 13q6 6 14 19.5t0 13.5q9 0 20 10.5t17 19.5q5 8 8 26t5 24q2 7 8.5 13.5t12.5 9.5l16 8t13 7q5 2 18.5 10.5t21.5 11.5q10 4 16 4t14.5-2.5 13.5-3.5q15-2 29 15t21 21q36 19 55 11-2 1 0.5 7.5t8 15.5 9 14.5 5.5 8.5q5 6 18 15t18 15q6-4 7-9-3 8 7 20t18 10q14-3 14-32-31 15-49-18 0-1-2.5-5.5t-4-8.5-2.5-8.5 0-7.5 5-3q9 0 10-3.5t-2-12.5-4-13q-1-8-11-20t-12-15q-5 9-16 8t-16-9q0 1-1.5 5.5t-1.5 6.5q-13 0-15-1 1-3 2.5-17.5t3.5-22.5q1-4 5.5-12t7.5-14.5 4-12.5-4.5-9.5-17.5-2.5q-19 1-26 20-1 3-3 10.5t-5 11.5-9 7q-7 3-24 2t-24-5q-13-8-22.5-29t-9.5-37q0-10 2.5-26.5t3-25-5.5-24.5q3-2 9-9.5t10-10.5q2-1 4.5-1.5t4.5 0 4-1.5 3-6q-1-1-4-3-3-3-4-3 7 3 28.5-1.5t27.5 1.5q15 11 22-2 0-1-2.5-9.5t-0.5-13.5q5 27 29 9 3 3 15.5 5t17.5 5q3 2 7 5.5t5.5 4.5 5-0.5 8.5-6.5q10 14 12 24 11 40 19 44 7 3 11 2t4.5-9.5 0-14-1.5-12.5l-1-8v-18l-1-8q-15-3-18.5-12t1.5-18.5 15-18.5q1-1 8-3.5t15.5-6.5 12.5-8q21-19 15-35 7 0 11-9-1 0-5-3t-7.5-5-4.5-2q9-5 2-16 5-3 7.5-11t7.5-10q9 12 21 2 8-8 1-16 5-7 20.5-10.5t18.5-9.5q7 2 8-2t1-12 3-12q4-5 15-9t13-5l17-11q3-4 0-4 18 2 31-11 10-11-6-20 3-6-3-9.5t-15-5.5q3-1 11.5-0.5t10.5-1.5q15-10-7-16-17-5-43 12zM879 1526q206-36 351-189-3-3-12.5-4.5t-12.5-3.5q-18-7-24-8 1-7-2.5-13t-8-9-12.5-8-11-7q-2-2-7-6t-7-5.5-7.5-4.5-8.5-2-10 1l-3 1q-3 1-5.5 2.5t-5.5 3-4 3 0 2.5q-21-17-36-22-5-1-11-5.5t-10.5-7-10-1.5-11.5 7q-5 5-6 15t-2 13q-7-5 0-17.5t2-18.5q-3-6-10.5-4.5t-12 4.5-11.5 8.5-9 6.5-8.5 5.5-8.5 7.5q-3 4-6 12t-5 11q-2-4-11.5-6.5t-9.5-5.5q2 10 4 35t5 38q7 31-12 48-27 25-29 40-4 22 12 26 0 7-8 20.5t-7 21.5q0 6 2 16z"
    }
  }]
};
exports.globe = globe;
var wrench = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1472q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1028 1052l-682 682q-37 37-90 37-52 0-91-37l-106-108q-38-36-38-90 0-53 38-91l681-681q39 98 114.5 173.5t173.5 114.5zM1662 617q0 39-23 106-47 134-164.5 217.5t-258.5 83.5q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q58 0 121.5 16.5t107.5 46.5q16 11 16 28t-16 28l-293 169v224l193 107q5-3 79-48.5t135.5-81 70.5-35.5q15 0 23.5 10t8.5 25z"
    }
  }]
};
exports.wrench = wrench;
var tasks = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1408h640v-128h-640v128zM640 896h1024v-128h-1024v128zM1280 384h384v-128h-384v128zM1792 1216v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 704v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45zM1792 192v256q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1664q26 0 45 19t19 45z"
    }
  }]
};
exports.tasks = tasks;
var filter = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1403 295q17 41-14 70l-493 493v742q0 42-39 59-13 5-25 5-27 0-45-19l-256-256q-19-19-19-45v-486l-493-493q-31-29-14-70 17-39 59-39h1280q42 0 59 39z"
    }
  }]
};
exports.filter = filter;
var briefcase = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 256h512v-128h-512v128zM1792 896v480q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-480h672v160q0 26 19 45t45 19h320q26 0 45-19t19-45v-160h672zM1024 896v128h-256v-128h256zM1792 416v384h-1792v-384q0-66 47-113t113-47h352v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h352q66 0 113 47t47 113z"
    }
  }]
};
exports.briefcase = briefcase;
var arrowsAlt = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1283 541l-355 355 355 355 144-144q29-31 70-14 39 17 39 59v448q0 26-19 45t-45 19h-448q-42 0-59-40-17-39 14-69l144-144-355-355-355 355 144 144q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l144 144 355-355-355-355-144 144q-19 19-45 19-12 0-24-5-40-17-40-59v-448q0-26 19-45t45-19h448q42 0 59 40 17 39-14 69l-144 144 355 355 355-355-144-144q-31-30-14-69 17-40 59-40h448q26 0 45 19t19 45v448q0 42-39 59-13 5-25 5-26 0-45-19z"
    }
  }]
};
exports.arrowsAlt = arrowsAlt;
var group = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M593 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zM1664 1533q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zM640 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1344 640q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1920 865q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zM1792 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z"
    }
  }]
};
exports.group = group;
var users = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M593 896q-162 5-265 128h-134q-82 0-138-40.5t-56-118.5q0-353 124-353 6 0 43.5 21t97.5 42.5 119 21.5q67 0 133-23-5 37-5 66 0 139 81 256zM1664 1533q0 120-73 189.5t-194 69.5h-874q-121 0-194-69.5t-73-189.5q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q10 0 43 21.5t73 48 107 48 135 21.5 135-21.5 107-48 73-48 43-21.5q61 0 111.5 20t85.5 53.5 62 81 43 97.5 26.5 108.5 14 109 3.5 103.5zM640 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1344 640q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1920 865q0 78-56 118.5t-138 40.5h-134q-103-123-265-128 81-117 81-256 0-29-5-66 66 23 133 23 59 0 119-21.5t97.5-42.5 43.5-21q124 0 124 353zM1792 256q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181z"
    }
  }]
};
exports.users = users;
var chain = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1456 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zM753 511q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"
    }
  }]
};
exports.chain = chain;
var link = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1456 1216q0-40-28-68l-208-208q-28-28-68-28-42 0-72 32 3 3 19 18.5t21.5 21.5 15 19 13 25.5 3.5 27.5q0 40-28 68t-68 28q-15 0-27.5-3.5t-25.5-13-19-15-21.5-21.5-18.5-19q-33 31-33 73 0 40 28 68l206 207q27 27 68 27 40 0 68-26l147-146q28-28 28-67zM753 511q0-40-28-68l-206-207q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l208 208q27 27 68 27 42 0 72-31-3-3-19-18.5t-21.5-21.5-15-19-13-25.5-3.5-27.5q0-40 28-68t68-28q15 0 27.5 3.5t25.5 13 19 15 21.5 21.5 18.5 19q33-31 33-73zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-206-207q-83-83-83-203 0-123 88-209l-88-88q-86 88-208 88-120 0-204-84l-208-208q-84-84-84-204t85-203l147-146q83-83 203-83 121 0 204 85l206 207q83 83 83 203 0 123-88 209l88 88q86-88 208-88 120 0 204 84l208 208q84 84 84 204z"
    }
  }]
};
exports.link = link;
var cloud = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-132 71-241.5t187-163.5q-2-28-2-43 0-212 150-362t362-150q158 0 286.5 88t187.5 230q70-62 166-62 106 0 181 75t75 181q0 75-41 138 129 30 213 134.5t84 239.5z"
    }
  }]
};
exports.cloud = cloud;
var flask = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1527 1448q56 89 21.5 152.5t-140.5 63.5h-1152q-106 0-140.5-63.5t21.5-152.5l503-793v-399h-64q-26 0-45-19t-19-45 19-45 45-19h512q26 0 45 19t19 45-19 45-45 19h-64v399zM748 723l-272 429h712l-272-429-20-31v-37-399h-128v399 37z"
    }
  }]
};
exports.flask = flask;
var cut = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1260 960l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zM579 700q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zM494 1445q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zM672 832l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zM896 1056l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zM1600 1472l128-64-520-408-177 138q-2 3-13 7z"
    }
  }]
};
exports.cut = cut;
var scissors = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1260 960l507 398q28 20 25 56-5 35-35 51l-128 64q-13 7-29 7-17 0-31-8l-690-387-110 66q-8 4-12 5 14 49 10 97-7 77-56 147.5t-132 123.5q-132 84-277 84-136 0-222-78-90-84-79-207 7-76 56-147t131-124q132-84 278-84 83 0 151 31 9-13 22-22l122-73-122-73q-13-9-22-22-68 31-151 31-146 0-278-84-82-53-131-124t-56-147q-5-59 15.5-113t63.5-93q85-79 222-79 145 0 277 84 83 52 132 123t56 148q4 48-10 97 4 1 12 5l110 66 690-387q14-8 31-8 16 0 29 7l128 64q30 16 35 51 3 36-25 56zM579 700q46-42 21-108t-106-117q-92-59-192-59-74 0-113 36-46 42-21 108t106 117q92 59 192 59 74 0 113-36zM494 1445q81-51 106-117t-21-108q-39-36-113-36-100 0-192 59-81 51-106 117t21 108q39 36 113 36 100 0 192-59zM672 832l96 58v-11q0-36 33-56l14-8-79-47-26 26q-3 3-10 11t-12 12q-2 2-4 3.5t-3 2.5zM896 1056l96 32 736-576-128-64-768 431v113l-160 96 9 8q2 2 7 6 4 4 11 12t11 12l26 26zM1600 1472l128-64-520-408-177 138q-2 3-13 7z"
    }
  }]
};
exports.scissors = scissors;
var copy = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zM1152 597l-299 299h299v-299zM512 213l-299 299h299v-299zM708 860l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zM1664 1664v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z"
    }
  }]
};
exports.copy = copy;
var filesO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1696 384q40 0 68 28t28 68v1216q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-288h-544q-40 0-68-28t-28-68v-672q0-40 20-88t48-76l408-408q28-28 76-48t88-20h416q40 0 68 28t28 68v328q68-40 128-40h416zM1152 597l-299 299h299v-299zM512 213l-299 299h299v-299zM708 860l316-316v-416h-384v416q0 40-28 68t-68 28h-416v640h512v-256q0-40 20-88t48-76zM1664 1664v-1152h-384v416q0 40-28 68t-68 28h-416v640h896z"
    }
  }]
};
exports.filesO = filesO;
var paperclip = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1404 1385q0 117-79 196t-196 79q-135 0-235-100l-777-776q-113-115-113-271 0-159 110-270t269-111q158 0 273 113l605 606q10 10 10 22 0 16-30.5 46.5t-46.5 30.5q-13 0-23-10l-606-607q-79-77-181-77-106 0-179 75t-73 181q0 105 76 181l776 777q63 63 145 63 64 0 106-42t42-106q0-82-63-145l-581-581q-26-24-60-24-29 0-48 19t-19 48q0 32 25 59l410 410q10 10 10 22 0 16-31 47t-47 31q-12 0-22-10l-410-410q-63-61-63-149 0-82 57-139t139-57q88 0 149 63l581 581q100 98 100 235z"
    }
  }]
};
exports.paperclip = paperclip;
var floppyO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1536h768v-384h-768v384zM1280 1536h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zM896 608v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zM1536 640v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"
    }
  }]
};
exports.floppyO = floppyO;
var save = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1536h768v-384h-768v384zM1280 1536h128v-896q0-14-10-38.5t-20-34.5l-281-281q-10-10-34-20t-39-10v416q0 40-28 68t-68 28h-576q-40 0-68-28t-28-68v-416h-128v1280h128v-416q0-40 28-68t68-28h832q40 0 68 28t28 68v416zM896 608v-320q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5zM1536 640v928q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h928q40 0 88 20t76 48l280 280q28 28 48 76t20 88z"
    }
  }]
};
exports.save = save;
var square = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.square = square;
var bars = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
    }
  }]
};
exports.bars = bars;
var navicon = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
    }
  }]
};
exports.navicon = navicon;
var reorder = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
    }
  }]
};
exports.reorder = reorder;
var listUl = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1408q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 896q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zM384 384q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 800v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5zM1792 288v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.listUl = listUl;
var listOl = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M381 1620q0 80-54.5 126t-135.5 46q-106 0-172-66l57-88q49 45 106 45 29 0 50.5-14.5t21.5-42.5q0-64-105-56l-26-56q8-10 32.5-43.5t42.5-54 37-38.5v-1q-16 0-48.5 1t-48.5 1v53h-106v-152h333v88l-95 115q51 12 81 49t30 88zM383 993v159h-362q-6-36-6-54 0-51 23.5-93t56.5-68 66-47.5 56.5-43.5 23.5-45q0-25-14.5-38.5t-39.5-13.5q-46 0-81 58l-85-59q24-51 71.5-79.5t105.5-28.5q73 0 123 41.5t50 112.5q0 50-34 91.5t-75 64.5-75.5 50.5-35.5 52.5h127v-60h105zM1792 1312v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zM384 413v99h-335v-99h107q0-41 0.5-121.5t0.5-121.5v-12h-2q-8 17-50 54l-71-76 136-127h106v404h108zM1792 800v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-14 9-23t23-9h1216q13 0 22.5 9.5t9.5 22.5zM1792 288v192q0 13-9.5 22.5t-22.5 9.5h-1216q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1216q13 0 22.5 9.5t9.5 22.5z"
    }
  }]
};
exports.listOl = listOl;
var strikethrough = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1760 896q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1728zM483 832q-28-35-51-80-48-98-48-188 0-181 134-309 133-127 393-127 50 0 167 19 66 12 177 48 10 38 21 118 14 123 14 183 0 18-5 45l-12 3-84-6-14-2q-50-149-103-205-88-91-210-91-114 0-182 59-67 58-67 146 0 73 66 140t279 129q69 20 173 66 58 28 95 52h-743zM990 1088h411q7 39 7 92 0 111-41 212-23 56-71 104-37 35-109 81-80 48-153 66-80 21-203 21-114 0-195-23l-140-40q-57-16-72-28-8-8-8-22v-13q0-108-2-156-1-30 0-68l2-37v-44l102-2q15 34 30 71t22.5 56 12.5 27q35 57 80 94 43 36 105 57 59 22 132 22 64 0 139-27 77-26 122-86 47-61 47-129 0-84-81-157-34-29-137-71z"
    }
  }]
};
exports.strikethrough = strikethrough;
var underline = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M48 223q-37-2-45-4l-3-88q13-1 40-1 60 0 112 4 132 7 166 7 86 0 168-3 116-4 146-5 56 0 86-2l-1 14 2 64v9q-60 9-124 9-60 0-79 25-13 14-13 132 0 13 0.5 32.5t0.5 25.5l1 229 14 280q6 124 51 202 35 59 96 92 88 47 177 47 104 0 191-28 56-18 99-51 48-36 65-64 36-56 53-114 21-73 21-229 0-79-3.5-128t-11-122.5-13.5-159.5l-4-59q-5-67-24-88-34-35-77-34l-100 2-14-3 2-86h84l205 10q76 3 196-10l18 2q6 38 6 51 0 7-4 31-45 12-84 13-73 11-79 17-15 15-15 41 0 7 1.5 27t1.5 31q8 19 22 396 6 195-15 304-15 76-41 122-38 65-112 123-75 57-182 89-109 33-255 33-167 0-284-46-119-47-179-122-61-76-83-195-16-80-16-237v-333q0-188-17-213-25-36-147-39zM1536 1632v-64q0-14-9-23t-23-9h-1472q-14 0-23 9t-9 23v64q0 14 9 23t23 9h1472q14 0 23-9t9-23z"
    }
  }]
};
exports.underline = underline;
var table = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM512 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 1376v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1024 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 992v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1536 608v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM1664 288v1088q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1344q66 0 113 47t47 113z"
    }
  }]
};
exports.table = table;
var magic = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1190 581l293-293-107-107-293 293zM1637 288q0 27-18 45l-1286 1286q-18 18-45 18t-45-18l-198-198q-18-18-18-45t18-45l1286-1286q18-18 45-18t45 18l198 198q18 18 18 45zM286 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM636 260l196 60-196 60-60 196-60-196-196-60 196-60 60-196zM1566 738l98 30-98 30-30 98-30-98-98-30 98-30 30-98zM926 98l98 30-98 30-30 98-30-98-98-30 98-30 30-98z"
    }
  }]
};
exports.magic = magic;
var truck = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1408q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM256 896h384v-256h-158q-13 0-22 9l-195 195q-9 9-9 22v30zM1536 1408q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM1792 320v1024q0 15-4 26.5t-13.5 18.5-16.5 11.5-23.5 6-22.5 2-25.5 0-22.5-0.5q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-64q-3 0-22.5 0.5t-25.5 0-22.5-2-23.5-6-16.5-11.5-13.5-18.5-4-26.5q0-26 19-45t45-19v-320q0-8-0.5-35t0-38 2.5-34.5 6.5-37 14-30.5 22.5-30l198-198q19-19 50.5-32t58.5-13h160v-192q0-26 19-45t45-19h1024q26 0 45 19t19 45z"
    }
  }]
};
exports.truck = truck;
var pinterest = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 209-103 385.5t-279.5 279.5-385.5 103q-111 0-218-32 59-93 78-164 9-34 54-211 20 39 73 67.5t114 28.5q121 0 216-68.5t147-188.5 52-270q0-114-59.5-214t-172.5-163-255-63q-105 0-196 29t-154.5 77-109 110.5-67 129.5-21.5 134q0 104 40 183t117 111q30 12 38-20 2-7 8-31t8-30q6-23-11-43-51-61-51-151 0-151 104.5-259.5t273.5-108.5q151 0 235.5 82t84.5 213q0 170-68.5 289t-175.5 119q-61 0-98-43.5t-23-104.5q8-35 26.5-93.5t30-103 11.5-75.5q0-50-27-83t-77-33q-62 0-105 57t-43 142q0 73 25 122l-99 418q-17 70-13 177-206-91-333-281t-127-423q0-209 103-385.5t279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.pinterest = pinterest;
var pinterestSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-725q85-122 108-210 9-34 53-209 21 39 73.5 67t112.5 28q181 0 295.5-147.5t114.5-373.5q0-84-35-162.5t-96.5-139-152.5-97-197-36.5q-104 0-194.5 28.5t-153 76.5-107.5 109.5-66.5 128-21.5 132.5q0 102 39.5 180t116.5 110q13 5 23.5 0t14.5-19q10-44 15-61 6-23-11-42-50-62-50-150 0-150 103.5-256.5t270.5-106.5q149 0 232.5 81t83.5 210q0 168-67.5 286t-173.5 118q-60 0-97-43.5t-23-103.5q8-34 26.5-92.5t29.5-102 11-74.5q0-49-26.5-81.5t-75.5-32.5q-61 0-103.5 56.5t-42.5 139.5q0 72 24 121l-98 414q-24 100-7 254h-183q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960z"
    }
  }]
};
exports.pinterestSquare = pinterestSquare;
var googlePlusSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M917 905q0-26-6-64h-362v132h217q-3 24-16.5 50t-37.5 53-66.5 44.5-96.5 17.5q-99 0-169-71t-70-171 70-171 169-71q92 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.googlePlusSquare = googlePlusSquare;
var googlePlus = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1437 913q0 208-87 370.5t-248 254-369 91.5q-149 0-285-58t-234-156-156-234-58-285 58-285 156-234 234-156 285-58q286 0 491 192l-199 191q-117-113-292-113-123 0-227.5 62t-165.5 168.5-61 232.5 61 232.5 165.5 168.5 227.5 62q83 0 152.5-23t114.5-57.5 78.5-78.5 49-83 21.5-74h-416v-252h692q12 63 12 122zM2304 791v210h-209v209h-210v-209h-209v-210h209v-209h210v209h209z"
    }
  }]
};
exports.googlePlus = googlePlus;
var money = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 1152h384v-96h-128v-448h-114l-148 137 77 80q42-37 55-57h2v288h-128v96zM1280 896q0 70-21 142t-59.5 134-101.5 101-138 39-138-39-101.5-101-59.5-134-21-142 21-142 59.5-134 101.5-101 138-39 138 39 101.5 101 59.5 134 21 142zM1792 1152v-512q-106 0-181-75t-75-181h-1152q0 106-75 181t-181 75v512q106 0 181 75t75 181h1152q0-106 75-181t181-75zM1920 320v1152q0 26-19 45t-45 19h-1792q-26 0-45-19t-19-45v-1152q0-26 19-45t45-19h1792q26 0 45 19t19 45z"
    }
  }]
};
exports.money = money;
var caretDown = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 704q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"
    }
  }]
};
exports.caretDown = caretDown;
var caretUp = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1216q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.caretUp = caretUp;
var caretLeft = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 448v896q0 26-19 45t-45 19-45-19l-448-448q-19-19-19-45t19-45l448-448q19-19 45-19t45 19 19 45z"
    }
  }]
};
exports.caretLeft = caretLeft;
var caretRight = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M576 896q0 26-19 45l-448 448q-19 19-45 19t-45-19-19-45v-896q0-26 19-45t45-19 45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.caretRight = caretRight;
var columns = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M160 1536h608v-1152h-640v1120q0 13 9.5 22.5t22.5 9.5zM1536 1504v-1120h-640v1152h608q13 0 22.5-9.5t9.5-22.5zM1664 288v1216q0 66-47 113t-113 47h-1344q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1344q66 0 113 47t47 113z"
    }
  }]
};
exports.columns = columns;
var sort = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zM1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.sort = sort;
var unsorted = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45zM1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.unsorted = unsorted;
var sortDesc = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"
    }
  }]
};
exports.sortDesc = sortDesc;
var sortDown = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1088q0 26-19 45l-448 448q-19 19-45 19t-45-19l-448-448q-19-19-19-45t19-45 45-19h896q26 0 45 19t19 45z"
    }
  }]
};
exports.sortDown = sortDown;
var sortAsc = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.sortAsc = sortAsc;
var sortUp = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 704q0 26-19 45t-45 19h-896q-26 0-45-19t-19-45 19-45l448-448q19-19 45-19t45 19l448 448q19 19 19 45z"
    }
  }]
};
exports.sortUp = sortUp;
var envelope = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 710v794q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-794q44 49 101 87 362 246 497 345 57 42 92.5 65.5t94.5 48 110 24.5h1 1q51 0 110-24.5t94.5-48 92.5-65.5q170-123 498-345 57-39 100-87zM1792 416q0 79-49 151t-122 123q-376 261-468 325-10 7-42.5 30.5t-54 38-52 32.5-57.5 27-50 9h-1-1q-23 0-50-9t-57.5-27-52-32.5-54-38-42.5-30.5q-91-64-262-182.5t-205-142.5q-62-42-117-115.5t-55-136.5q0-78 41.5-130t118.5-52h1472q65 0 112.5 47t47.5 113z"
    }
  }]
};
exports.envelope = envelope;
var linkedin = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M349 625v991h-330v-991h330zM370 319q1 73-50.5 122t-135.5 49h-2q-82 0-132-49t-50-122q0-74 51.5-122.5t134.5-48.5 133 48.5 51 122.5zM1536 1048v568h-329v-530q0-105-40.5-164.5t-126.5-59.5q-63 0-105.5 34.5t-63.5 85.5q-11 30-11 81v553h-329q2-399 2-647t-1-296l-1-48h329v144h-2q20-32 41-56t56.5-52 87-43.5 114.5-15.5q171 0 275 113.5t104 332.5z"
    }
  }]
};
exports.linkedin = linkedin;
var rotateLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"
    }
  }]
};
exports.rotateLeft = rotateLeft;
var undo = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298z"
    }
  }]
};
exports.undo = undo;
var gavel = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1771 1536q0 53-37 90l-107 108q-39 37-91 37-53 0-90-37l-363-364q-38-36-38-90 0-53 43-96l-256-256-126 126q-14 14-34 14t-34-14q2 2 12.5 12t12.5 13 10 11.5 10 13.5 6 13.5 5.5 16.5 1.5 18q0 38-28 68-3 3-16.5 18t-19 20.5-18.5 16.5-22 15.5-22 9-26 4.5q-40 0-68-28l-408-408q-28-28-28-68 0-13 4.5-26t9-22 15.5-22 16.5-18.5 20.5-19 18-16.5q30-28 68-28 10 0 18 1.5t16.5 5.5 13.5 6 13.5 10 11.5 10 13 12.5 12 12.5q-14-14-14-34t14-34l348-348q14-14 34-14t34 14q-2-2-12.5-12t-12.5-13-10-11.5-10-13.5-6-13.5-5.5-16.5-1.5-18q0-38 28-68 3-3 16.5-18t19-20.5 18.5-16.5 22-15.5 22-9 26-4.5q40 0 68 28l408 408q28 28 28 68 0 13-4.5 26t-9 22-15.5 22-16.5 18.5-20.5 19-18 16.5q-30 28-68 28-10 0-18-1.5t-16.5-5.5-13.5-6-13.5-10-11.5-10-13-12.5-12-12.5q14 14 14 34t-14 34l-126 126 256 256q43-43 96-43 52 0 91 37l363 363q37 39 37 91z"
    }
  }]
};
exports.gavel = gavel;
var legal = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1771 1536q0 53-37 90l-107 108q-39 37-91 37-53 0-90-37l-363-364q-38-36-38-90 0-53 43-96l-256-256-126 126q-14 14-34 14t-34-14q2 2 12.5 12t12.5 13 10 11.5 10 13.5 6 13.5 5.5 16.5 1.5 18q0 38-28 68-3 3-16.5 18t-19 20.5-18.5 16.5-22 15.5-22 9-26 4.5q-40 0-68-28l-408-408q-28-28-28-68 0-13 4.5-26t9-22 15.5-22 16.5-18.5 20.5-19 18-16.5q30-28 68-28 10 0 18 1.5t16.5 5.5 13.5 6 13.5 10 11.5 10 13 12.5 12 12.5q-14-14-14-34t14-34l348-348q14-14 34-14t34 14q-2-2-12.5-12t-12.5-13-10-11.5-10-13.5-6-13.5-5.5-16.5-1.5-18q0-38 28-68 3-3 16.5-18t19-20.5 18.5-16.5 22-15.5 22-9 26-4.5q40 0 68 28l408 408q28 28 28 68 0 13-4.5 26t-9 22-15.5 22-16.5 18.5-20.5 19-18 16.5q-30 28-68 28-10 0-18-1.5t-16.5-5.5-13.5-6-13.5-10-11.5-10-13-12.5-12-12.5q14 14 14 34t-14 34l-126 126 256 256q43-43 96-43 52 0 91 37l363 363q37 39 37 91z"
    }
  }]
};
exports.legal = legal;
var dashboard = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM576 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1004 1185l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zM1664 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1472 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 1152q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.dashboard = dashboard;
var tachometer = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM576 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1004 1185l101-382q6-26-7.5-48.5t-38.5-29.5-48 6.5-30 39.5l-101 382q-60 5-107 43.5t-63 98.5q-20 77 20 146t117 89 146-20 89-117q16-60-6-117t-72-91zM1664 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1472 704q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 1152q0 261-141 483-19 29-54 29h-1402q-35 0-54-29-141-221-141-483 0-182 71-348t191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.tachometer = tachometer;
var commentO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 384q-204 0-381.5 69.5t-282 187.5-104.5 255q0 112 71.5 213.5t201.5 175.5l87 50-27 96q-24 91-70 172 152-63 275-171l43-38 57 6q69 8 130 8 204 0 381.5-69.5t282-187.5 104.5-255-104.5-255-282-187.5-381.5-69.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22h-5q-15 0-27-10.5t-16-27.5v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-174 120-321.5t326-233 450-85.5 450 85.5 326 233 120 321.5z"
    }
  }]
};
exports.commentO = commentO;
var commentsO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 384q-153 0-286 52t-211.5 141-78.5 191q0 82 53 158t149 132l97 56-35 84q34-20 62-39l44-31 53 10q78 14 153 14 153 0 286-52t211.5-141 78.5-191-78.5-191-211.5-141-286-52zM704 256q191 0 353.5 68.5t256.5 186.5 94 257-94 257-256.5 186.5-353.5 68.5q-86 0-176-16-124 88-278 128-36 9-86 16h-3q-11 0-20.5-8t-11.5-21q-1-3-1-6.5t0.5-6.5 2-6l2.5-5t3.5-5.5 4-5 4.5-5 4-4.5q5-6 23-25t26-29.5 22.5-29 25-38.5 20.5-44q-124-72-195-177t-71-224q0-139 94-257t256.5-186.5 353.5-68.5zM1526 1425q10 24 20.5 44t25 38.5 22.5 29 26 29.5 23 25q1 1 4 4.5t4.5 5 4 5 3.5 5.5l2.5 5t2 6 0.5 6.5-1 6.5q-3 14-13 22t-22 7q-50-7-86-16-154-40-278-128-90 16-176 16-271 0-472-132 58 4 88 4 161 0 309-45t264-129q125-92 192-212t67-254q0-77-23-152 129 71 204 178t75 230q0 120-71 224.5t-195 176.5z"
    }
  }]
};
exports.commentsO = commentsO;
var bolt = {
  "viewBox": "0 0 896 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M885 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"
    }
  }]
};
exports.bolt = bolt;
var flash = {
  "viewBox": "0 0 896 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M885 566q18 20 7 44l-540 1157q-13 25-42 25-4 0-14-2-17-5-25.5-19t-4.5-30l197-808-406 101q-4 1-12 1-18 0-31-11-18-15-13-39l201-825q4-14 16-23t28-9h328q19 0 32 12.5t13 29.5q0 8-5 18l-171 463 396-98q8-2 12-2 19 0 34 15z"
    }
  }]
};
exports.flash = flash;
var sitemap = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1248v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192h-512v192h96q40 0 68 28t28 68v320q0 40-28 68t-68 28h-320q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h96v-192q0-52 38-90t90-38h512v-192h-96q-40 0-68-28t-28-68v-320q0-40 28-68t68-28h320q40 0 68 28t28 68v320q0 40-28 68t-68 28h-96v192h512q52 0 90 38t38 90v192h96q40 0 68 28t28 68z"
    }
  }]
};
exports.sitemap = sitemap;
var umbrella = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 828v580q0 104-76 180t-180 76-180-76-76-180q0-26 19-45t45-19 45 19 19 45q0 50 39 89t89 39 89-39 39-89v-580q33-11 64-11t64 11zM1664 855q0 13-9.5 22.5t-22.5 9.5q-11 0-23-10-49-46-93-69t-102-23q-68 0-128 37t-103 97q-7 10-17.5 28t-14.5 24q-11 17-28 17-18 0-29-17-4-6-14.5-24t-17.5-28q-43-60-102.5-97t-127.5-37-127.5 37-102.5 97q-7 10-17.5 28t-14.5 24q-11 17-29 17-17 0-28-17-4-6-14.5-24t-17.5-28q-43-60-103-97t-128-37q-58 0-102 23t-93 69q-12 10-23 10-13 0-22.5-9.5t-9.5-22.5q0-5 1-7 45-183 172.5-319.5t298-204.5 360.5-68q140 0 274.5 40t246.5 113.5 194.5 187 115.5 251.5q1 2 1 7zM896 128v98q-42-2-64-2t-64 2v-98q0-26 19-45t45-19 45 19 19 45z"
    }
  }]
};
exports.umbrella = umbrella;
var clipboard = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 1664h896v-640h-416q-40 0-68-28t-28-68v-416h-384v1152zM1024 224v-64q0-13-9.5-22.5t-22.5-9.5h-704q-13 0-22.5 9.5t-9.5 22.5v64q0 13 9.5 22.5t22.5 9.5h704q13 0 22.5-9.5t9.5-22.5zM1280 896h299l-299-299v299zM1792 1024v672q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-544q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1088q40 0 68 28t28 68v328q21 13 36 28l408 408q28 28 48 76t20 88z"
    }
  }]
};
exports.clipboard = clipboard;
var paste = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 1664h896v-640h-416q-40 0-68-28t-28-68v-416h-384v1152zM1024 224v-64q0-13-9.5-22.5t-22.5-9.5h-704q-13 0-22.5 9.5t-9.5 22.5v64q0 13 9.5 22.5t22.5 9.5h704q13 0 22.5-9.5t9.5-22.5zM1280 896h299l-299-299v299zM1792 1024v672q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-160h-544q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1088q40 0 68 28t28 68v328q21 13 36 28l408 408q28 28 48 76t20 88z"
    }
  }]
};
exports.paste = paste;
var lightbulbO = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M736 576q0 13-9.5 22.5t-22.5 9.5-22.5-9.5-9.5-22.5q0-46-54-71t-106-25q-13 0-22.5-9.5t-9.5-22.5 9.5-22.5 22.5-9.5q50 0 99.5 16t87 54 37.5 90zM896 576q0-72-34.5-134t-90-101.5-123-62-136.5-22.5-136.5 22.5-123 62-90 101.5-34.5 134q0 101 68 180 10 11 30.5 33t30.5 33q128 153 141 298h228q13-145 141-298 10-11 30.5-33t30.5-33q68-79 68-180zM1024 576q0 155-103 268-45 49-74.5 87t-59.5 95.5-34 107.5q47 28 47 82 0 37-25 64 25 27 25 64 0 52-45 81 13 23 13 47 0 46-31.5 71t-77.5 25q-20 44-60 70t-87 26-87-26-60-70q-46 0-77.5-25t-31.5-71q0-24 13-47-45-29-45-81 0-37 25-64-25-27-25-64 0-54 47-82-4-50-34-107.5t-59.5-95.5-74.5-87q-103-113-103-268 0-99 44.5-184.5t117-142 164-89 186.5-32.5 186.5 32.5 164 89 117 142 44.5 184.5z"
    }
  }]
};
exports.lightbulbO = lightbulbO;
var exchange = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1184v192q0 13-9.5 22.5t-22.5 9.5h-1376v192q0 13-9.5 22.5t-22.5 9.5q-12 0-24-10l-319-320q-9-9-9-22 0-14 9-23l320-320q9-9 23-9 13 0 22.5 9.5t9.5 22.5v192h1376q13 0 22.5 9.5t9.5 22.5zM1792 640q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-1376q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h1376v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23z"
    }
  }]
};
exports.exchange = exchange;
var cloudDownload = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 928q0-14-9-23t-23-9h-224v-352q0-13-9.5-22.5t-22.5-9.5h-192q-13 0-22.5 9.5t-9.5 22.5v352h-224q-13 0-22.5 9.5t-9.5 22.5q0 14 9 23l352 352q9 9 23 9t23-9l351-351q10-12 10-24zM1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"
    }
  }]
};
exports.cloudDownload = cloudDownload;
var cloudUpload = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 864q0-14-9-23l-352-352q-9-9-23-9t-23 9l-351 351q-10 12-10 24 0 14 9 23t23 9h224v352q0 13 9.5 22.5t22.5 9.5h192q13 0 22.5-9.5t9.5-22.5v-352h224q13 0 22.5-9.5t9.5-22.5zM1920 1152q0 159-112.5 271.5t-271.5 112.5h-1088q-185 0-316.5-131.5t-131.5-316.5q0-130 70-240t188-165q-2-30-2-43 0-212 150-362t362-150q156 0 285.5 87t188.5 231q71-62 166-62 106 0 181 75t75 181q0 76-41 138 130 31 213.5 135.5t83.5 238.5z"
    }
  }]
};
exports.cloudUpload = cloudUpload;
var userMd = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1344q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1408 1405q0 121-73 190t-194 69h-874q-121 0-194-69t-73-190q0-68 5.5-131t24-138 47.5-132.5 81-103 120-60.5q-22 52-22 120v203q-58 20-93 70t-35 111q0 80 56 136t136 56 136-56 56-136q0-61-35.5-111t-92.5-70v-203q0-62 25-93 132 104 295 104t295-104q25 31 25 93v64q-106 0-181 75t-75 181v89q-32 29-32 71 0 40 28 68t68 28 68-28 28-68q0-42-32-71v-89q0-52 38-90t90-38 90 38 38 90v89q-32 29-32 71 0 40 28 68t68 28 68-28 28-68q0-42-32-71v-89q0-68-34.5-127.5t-93.5-93.5q0-10 0.5-42.5t0-48-2.5-41.5-7-47-13-40q68 15 120 60.5t81 103 47.5 132.5 24 138 5.5 131zM1088 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  }]
};
exports.userMd = userMd;
var stethoscope = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 704q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 704q0 62-35.5 111t-92.5 70v395q0 159-131.5 271.5t-316.5 112.5-316.5-112.5-131.5-271.5v-132q-164-20-274-128t-110-252v-512q0-26 19-45t45-19q6 0 16 2 17-30 47-48t65-18q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5q-33 0-64-18v402q0 106 94 181t226 75 226-75 94-181v-402q-31 18-64 18-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5q35 0 65 18t47 48q10-2 16-2 26 0 45 19t19 45v512q0 144-110 252t-274 128v132q0 106 94 181t226 75 226-75 94-181v-395q-57-21-92.5-70t-35.5-111q0-80 56-136t136-56 136 56 56 136z"
    }
  }]
};
exports.stethoscope = stethoscope;
var suitcase = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 384h512v-128h-512v128zM288 384v1280h-64q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h64zM1408 384v1280h-1024v-1280h128v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h128zM1792 608v832q0 92-66 158t-158 66h-64v-1280h64q92 0 158 66t66 158z"
    }
  }]
};
exports.suitcase = suitcase;
var bell = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M912 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM1728 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-181-75-75-181h-448q-52 0-90-38t-38-90q50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 190 28 307 158.5t117 282.5q0 139 19.5 260t50 206 74.5 158.5 85 119.5 91 88z"
    }
  }]
};
exports.bell = bell;
var coffee = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 640q0-80-56-136t-136-56h-64v384h64q80 0 136-56t56-136zM0 1408h1792q0 106-75 181t-181 75h-1280q-106 0-181-75t-75-181zM1856 640q0 159-112.5 271.5t-271.5 112.5h-64v32q0 92-66 158t-158 66h-704q-92 0-158-66t-66-158v-736q0-26 19-45t45-19h1152q159 0 271.5 112.5t112.5 271.5z"
    }
  }]
};
exports.coffee = coffee;
var cutlery = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 64v640q0 61-35.5 111t-92.5 70v779q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-779q-57-20-92.5-70t-35.5-111v-640q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45v-416q0-26 19-45t45-19 45 19 19 45v416q0 26 19 45t45 19 45-19 19-45v-416q0-26 19-45t45-19 45 19 19 45zM1408 64v1600q0 52-38 90t-90 38h-128q-52 0-90-38t-38-90v-512h-224q-13 0-22.5-9.5t-9.5-22.5v-800q0-132 94-226t226-94h256q26 0 45 19t19 45z"
    }
  }]
};
exports.cutlery = cutlery;
var fileTextO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM384 800q0-14 9-23t23-9h704q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64zM1120 1024q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704zM1120 1280q14 0 23 9t9 23v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704z"
    }
  }]
};
exports.fileTextO = fileTextO;
var buildingO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 544v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 288v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1664h384v-1536h-1152v1536h384v-224q0-13 9.5-22.5t22.5-9.5h320q13 0 22.5 9.5t9.5 22.5v224zM1408 64v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280q26 0 45 19t19 45z"
    }
  }]
};
exports.buildingO = buildingO;
var hospitalO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM384 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1312v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM640 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 1056v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM1152 800v64q0 13-9.5 22.5t-22.5 9.5h-64q-13 0-22.5-9.5t-9.5-22.5v-64q0-13 9.5-22.5t22.5-9.5h64q13 0 22.5 9.5t9.5 22.5zM896 1664h384v-1152h-256v32q0 40-28 68t-68 28h-448q-40 0-68-28t-28-68v-32h-256v1152h384v-224q0-13 9.5-22.5t22.5-9.5h320q13 0 22.5 9.5t9.5 22.5v224zM896 480v-320q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v96h-128v-96q0-13-9.5-22.5t-22.5-9.5h-64q-13 0-22.5 9.5t-9.5 22.5v320q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5v-96h128v96q0 13 9.5 22.5t22.5 9.5h64q13 0 22.5-9.5t9.5-22.5zM1408 448v1280q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1280q0-26 19-45t45-19h320v-288q0-40 28-68t68-28h448q40 0 68 28t28 68v288h320q26 0 45 19t19 45z"
    }
  }]
};
exports.hospitalO = hospitalO;
var ambulance = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM256 896h384v-256h-158q-14 2-22 9l-195 195q-7 12-9 22v30zM1536 1408q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 736v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zM1920 192v1152q0 26-19 45t-45 19h-192q0 106-75 181t-181 75-181-75-75-181h-384q0 106-75 181t-181 75-181-75-75-181h-128q-26 0-45-19t-19-45 19-45 45-19v-416q0-26 13-58t32-51l198-198q19-19 51-32t58-13h160v-320q0-26 19-45t45-19h1152q26 0 45 19t19 45z"
    }
  }]
};
exports.ambulance = ambulance;
var medkit = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1120v-192q0-14-9-23t-23-9h-224v-224q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v224h-224q-14 0-23 9t-9 23v192q0 14 9 23t23 9h224v224q0 14 9 23t23 9h192q14 0 23-9t9-23v-224h224q14 0 23-9t9-23zM640 384h512v-128h-512v128zM256 384v1280h-32q-92 0-158-66t-66-158v-832q0-92 66-158t158-66h32zM1440 384v1280h-1088v-1280h160v-160q0-40 28-68t68-28h576q40 0 68 28t28 68v160h160zM1792 608v832q0 92-66 158t-158 66h-32v-1280h32q92 0 158 66t66 158z"
    }
  }]
};
exports.medkit = medkit;
var fighterJet = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 960q-1 32-288 96l-352 32-224 64h-64l-293 352h69q26 0 45 4.5t19 11.5-19 11.5-45 4.5h-96-160-64v-32h64v-416h-160l-192 224h-96l-32-32v-192h32v-32h128v-8l-192-24v-128l192-24v-8h-128v-32h-32v-192l32-32h96l192 224h160v-416h-64v-32h64 160 96q26 0 45 4.5t19 11.5-19 11.5-45 4.5h-69l293 352h64l224 64 352 32q128 28 200 52t80 34z"
    }
  }]
};
exports.fighterJet = fighterJet;
var beer = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896v-384h-256v256q0 53 37.5 90.5t90.5 37.5h128zM1664 1344v192h-1152v-192l128-192h-128q-159 0-271.5-112.5t-112.5-271.5v-320l-64-64 32-128h480l32-128h960l32 192-64 32v800z"
    }
  }]
};
exports.beer = beer;
var hSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1344v-896q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v320h-512v-320q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v896q0 26 19 45t45 19h128q26 0 45-19t19-45v-320h512v320q0 26 19 45t45 19h128q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.hSquare = hSquare;
var plusSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 960v-128q0-26-19-45t-45-19h-320v-320q0-26-19-45t-45-19h-128q-26 0-45 19t-19 45v320h-320q-26 0-45 19t-19 45v128q0 26 19 45t45 19h320v320q0 26 19 45t45 19h128q26 0 45-19t19-45v-320h320q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.plusSquare = plusSquare;
var angleDoubleLeft = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M627 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23zM1011 1376q0 13-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23z"
    }
  }]
};
exports.angleDoubleLeft = angleDoubleLeft;
var angleDoubleRight = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M595 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23zM979 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
    }
  }]
};
exports.angleDoubleRight = angleDoubleRight;
var angleDoubleUp = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1075 1312q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23zM1075 928q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"
    }
  }]
};
exports.angleDoubleUp = angleDoubleUp;
var angleDoubleDown = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1075 864q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23zM1075 480q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
    }
  }]
};
exports.angleDoubleDown = angleDoubleDown;
var angleLeft = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M627 544q0 13-10 23l-393 393 393 393q10 10 10 23t-10 23l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23z"
    }
  }]
};
exports.angleLeft = angleLeft;
var angleRight = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M595 960q0 13-10 23l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23z"
    }
  }]
};
exports.angleRight = angleRight;
var angleUp = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1075 1184q0 13-10 23l-50 50q-10 10-23 10t-23-10l-393-393-393 393q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l466 466q10 10 10 23z"
    }
  }]
};
exports.angleUp = angleUp;
var angleDown = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1075 736q0 13-10 23l-466 466q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l393 393 393-393q10-10 23-10t23 10l50 50q10 10 10 23z"
    }
  }]
};
exports.angleDown = angleDown;
var desktop = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 992v-832q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v832q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 160v1088q0 66-47 113t-113 47h-544q0 37 16 77.5t32 71 16 43.5q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45q0-14 16-44t32-70 16-78h-544q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.desktop = desktop;
var laptop = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M416 1280q-66 0-113-47t-47-113v-704q0-66 47-113t113-47h1088q66 0 113 47t47 113v704q0 66-47 113t-113 47h-1088zM384 416v704q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5v-704q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5zM1760 1344h160v96q0 40-47 68t-113 28h-1600q-66 0-113-28t-47-68v-96h160 1600zM1040 1440q16 0 16-16t-16-16h-160q-16 0-16 16t16 16h160z"
    }
  }]
};
exports.laptop = laptop;
var tablet = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1408q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1024 1248v-960q0-13-9.5-22.5t-22.5-9.5h-832q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h832q13 0 22.5-9.5t9.5-22.5zM1152 288v1088q0 66-47 113t-113 47h-832q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h832q66 0 113 47t47 113z"
    }
  }]
};
exports.tablet = tablet;
var mobile = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M464 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zM672 1248v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zM480 400q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zM768 384v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z"
    }
  }]
};
exports.mobile = mobile;
var mobilePhone = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M464 1408q0-33-23.5-56.5t-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5 56.5-23.5 23.5-56.5zM672 1248v-704q0-13-9.5-22.5t-22.5-9.5h-512q-13 0-22.5 9.5t-9.5 22.5v704q0 13 9.5 22.5t22.5 9.5h512q13 0 22.5-9.5t9.5-22.5zM480 400q0-16-16-16h-160q-16 0-16 16t16 16h160q16 0 16-16zM768 384v1024q0 52-38 90t-90 38h-512q-52 0-90-38t-38-90v-1024q0-52 38-90t90-38h512q52 0 90 38t38 90z"
    }
  }]
};
exports.mobilePhone = mobilePhone;
var circleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.circleO = circleO;
var quoteLeft = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 960v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-704q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136zM1664 960v384q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-704q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5h64q26 0 45 19t19 45v128q0 26-19 45t-45 19h-64q-106 0-181 75t-75 181v32q0 40 28 68t68 28h224q80 0 136 56t56 136z"
    }
  }]
};
exports.quoteLeft = quoteLeft;
var quoteRight = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 320v704q0 104-40.5 198.5t-109.5 163.5-163.5 109.5-198.5 40.5h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64q106 0 181-75t75-181v-32q0-40-28-68t-68-28h-224q-80 0-136-56t-56-136v-384q0-80 56-136t136-56h384q80 0 136 56t56 136zM1664 320v704q0 104-40.5 198.5t-109.5 163.5-163.5 109.5-198.5 40.5h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64q106 0 181-75t75-181v-32q0-40-28-68t-68-28h-224q-80 0-136-56t-56-136v-384q0-80 56-136t136-56h384q80 0 136 56t56 136z"
    }
  }]
};
exports.quoteRight = quoteRight;
var spinner = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M526 1394q0 53-37.5 90.5t-90.5 37.5q-52 0-90-38t-38-90q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1024 1600q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM320 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1522 1394q0 52-38 90t-90 38q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM558 398q0 66-47 113t-113 47-113-47-47-113 47-113 113-47 113 47 47 113zM1728 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1088 192q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1618 398q0 93-66 158.5t-158 65.5q-93 0-158.5-65.5t-65.5-158.5q0-92 65.5-158t158.5-66q92 0 158 66t66 158z"
    }
  }]
};
exports.spinner = spinner;
var circle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.circle = circle;
var mailReply = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z"
    }
  }]
};
exports.mailReply = mailReply;
var reply = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1120q0 166-127 451-3 7-10.5 24t-13.5 30-13 22q-12 17-28 17-15 0-23.5-10t-8.5-25q0-9 2.5-26.5t2.5-23.5q5-68 5-123 0-101-17.5-181t-48.5-138.5-80-101-105.5-69.5-133-42.5-154-21.5-175.5-6h-224v256q0 26-19 45t-45 19-45-19l-512-512q-19-19-19-45t19-45l512-512q19-19 45-19t45 19 19 45v256h224q713 0 875 403 53 134 53 333z"
    }
  }]
};
exports.reply = reply;
var githubAlt = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1216q0 40-12.5 82t-43 76-72.5 34-72.5-34-43-76-12.5-82 12.5-82 43-76 72.5-34 72.5 34 43 76 12.5 82zM1280 1216q0 40-12.5 82t-43 76-72.5 34-72.5-34-43-76-12.5-82 12.5-82 43-76 72.5-34 72.5 34 43 76 12.5 82zM1440 1216q0-120-69-204t-187-84q-41 0-195 21-71 11-157 11t-157-11q-152-21-195-21-118 0-187 84t-69 204q0 88 32 153.5t81 103 122 60 140 29.5 149 7h168q82 0 149-7t140-29.5 122-60 81-103 32-153.5zM1664 1040q0 207-61 331-38 77-105.5 133t-141 86-170 47.5-171.5 22-167 4.5q-78 0-142-3t-147.5-12.5-152.5-30-137-51.5-121-81-86-115q-62-123-62-331 0-237 136-396-27-82-27-170 0-116 51-218 108 0 190 39.5t189 123.5q147-35 309-35 148 0 280 32 105-82 187-121t189-39q51 102 51 218 0 87-27 168 136 160 136 398z"
    }
  }]
};
exports.githubAlt = githubAlt;
var folderO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 1312v-704q0-40-28-68t-68-28h-704q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v960q0 40 28 68t68 28h1216q40 0 68-28t28-68zM1664 608v704q0 92-66 158t-158 66h-1216q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h672q92 0 158 66t66 158z"
    }
  }]
};
exports.folderO = folderO;
var folderOpenO = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1781 931q0-35-53-35h-1088q-40 0-85.5 21.5t-71.5 52.5l-294 363q-18 24-18 40 0 35 53 35h1088q40 0 86-22t71-53l294-363q18-22 18-39zM640 768h768v-160q0-40-28-68t-68-28h-576q-40 0-68-28t-28-68v-64q0-40-28-68t-68-28h-320q-40 0-68 28t-28 68v853l256-315q44-53 116-87.5t140-34.5zM1909 931q0 62-46 120l-295 363q-43 53-116 87.5t-140 34.5h-1088q-92 0-158-66t-66-158v-960q0-92 66-158t158-66h320q92 0 158 66t66 158v32h544q92 0 158 66t66 158v160h192q54 0 99 24.5t67 70.5q15 32 15 68z"
    }
  }]
};
exports.folderOpenO = folderOpenO;
var smileO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1134 1075q-37 121-138 195t-228 74-228-74-138-195q-8-25 4-48.5t38-31.5q25-8 48.5 4t31.5 38q25 80 92.5 129.5t151.5 49.5 151.5-49.5 92.5-129.5q8-26 32-38t49-4 37 31.5 4 48.5zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.smileO = smileO;
var frownO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1134 1229q8 25-4 48.5t-37 31.5-49-4-32-38q-25-80-92.5-129.5t-151.5-49.5-151.5 49.5-92.5 129.5q-8 26-31.5 38t-48.5 4q-26-8-38-31.5t-4-48.5q37-121 138-195t228-74 228 74 138 195zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.frownO = frownO;
var mehO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 1088q0 26-19 45t-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h640q26 0 45 19t19 45zM640 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1152 640q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.mehO = mehO;
var gamepad = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M832 1088v-128q0-14-9-23t-23-9h-192v-192q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v192h-192q-14 0-23 9t-9 23v128q0 14 9 23t23 9h192v192q0 14 9 23t23 9h128q14 0 23-9t9-23v-192h192q14 0 23-9t9-23zM1408 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1920 1024q0 212-150 362t-362 150q-192 0-338-128h-220q-146 128-338 128-212 0-362-150t-150-362 150-362 362-150h896q212 0 362 150t150 362z"
    }
  }]
};
exports.gamepad = gamepad;
var keyboardO = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1168v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM512 912v96q0 16-16 16h-224q-16 0-16-16v-96q0-16 16-16h224q16 0 16 16zM384 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1408 1168v96q0 16-16 16h-864q-16 0-16-16v-96q0-16 16-16h864q16 0 16 16zM768 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM640 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1024 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM896 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1280 912v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1664 1168v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1152 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1408 656v96q0 16-16 16h-96q-16 0-16-16v-96q0-16 16-16h96q16 0 16 16zM1664 656v352q0 16-16 16h-224q-16 0-16-16v-96q0-16 16-16h112v-240q0-16 16-16h96q16 0 16 16zM1792 1408v-896h-1664v896h1664zM1920 512v896q0 53-37.5 90.5t-90.5 37.5h-1664q-53 0-90.5-37.5t-37.5-90.5v-896q0-53 37.5-90.5t90.5-37.5h1664q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.keyboardO = keyboardO;
var flagO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1045v-616q-169 91-306 91-82 0-145-32-100-49-184-76.5t-178-27.5q-173 0-403 127v599q245-113 433-113 55 0 103.5 7.5t98 26 77 31 82.5 39.5l28 14q44 22 101 22 120 0 293-92zM320 256q0 35-17.5 64t-46.5 46v1266q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-1266q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 39-35 57-10 5-17 9-218 116-369 116-88 0-158-35l-28-14q-64-33-99-48t-91-29-114-14q-102 0-235.5 44t-228.5 102q-15 9-33 9-16 0-32-8-32-19-32-56v-742q0-35 31-55 35-21 78.5-42.5t114-52 152.5-49.5 155-19q112 0 209 31t209 86q38 19 89 19 122 0 310-112 22-12 31-17 31-16 62 2 31 20 31 55z"
    }
  }]
};
exports.flagO = flagO;
var flagCheckered = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M832 1000v-192q-181 16-384 117v185q205-96 384-110zM832 582v-197q-172 8-384 126v189q215-111 384-118zM1664 1045v-184q-235 116-384 71v-224q-20-6-39-15-5-3-33-17t-34.5-17-31.5-15-34.5-15.5-32.5-13-36-12.5-35-8.5-39.5-7.5-39.5-4-44-2q-23 0-49 3v222h19q102 0 192.5 29t197.5 82q19 9 39 15v188q42 17 91 17 120 0 293-92zM1664 618v-189q-169 91-306 91-45 0-78-8v196q148 42 384-90zM320 256q0 35-17.5 64t-46.5 46v1266q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-1266q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5 90.5 37.5 37.5 90.5zM1792 320v763q0 39-35 57-10 5-17 9-218 116-369 116-88 0-158-35l-28-14q-64-33-99-48t-91-29-114-14q-102 0-235.5 44t-228.5 102q-15 9-33 9-16 0-32-8-32-19-32-56v-742q0-35 31-55 35-21 78.5-42.5t114-52 152.5-49.5 155-19q112 0 209 31t209 86q38 19 89 19 122 0 310-112 22-12 31-17 31-16 62 2 31 20 31 55z"
    }
  }]
};
exports.flagCheckered = flagCheckered;
var terminal = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M585 983l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23zM1664 1440v64q0 14-9 23t-23 9h-960q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h960q14 0 23 9t9 23z"
    }
  }]
};
exports.terminal = terminal;
var code = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M617 1399l-50 50q-10 10-23 10t-23-10l-466-466q-10-10-10-23t10-23l466-466q10-10 23-10t23 10l50 50q10 10 10 23t-10 23l-393 393 393 393q10 10 10 23t-10 23zM1208 332l-373 1291q-4 13-15.5 19.5t-23.5 2.5l-62-17q-13-4-19.5-15.5t-2.5-24.5l373-1291q4-13 15.5-19.5t23.5-2.5l62 17q13 4 19.5 15.5t2.5 24.5zM1865 983l-466 466q-10 10-23 10t-23-10l-50-50q-10-10-10-23t10-23l393-393-393-393q-10-10-10-23t10-23l50-50q10-10 23-10t23 10l466 466q10 10 10 23t-10 23z"
    }
  }]
};
exports.code = code;
var mailReplyAll = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1082v70q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v69l-397 398q-19 19-19 45t19 45zM1792 1120q0 58-17 133.5t-38.5 138-48 125-40.5 90.5l-20 40q-8 17-28 17-6 0-9-1-25-8-23-34 43-400-106-565-64-71-170.5-110.5t-267.5-52.5v251q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v262q411 28 599 221 169 173 169 509z"
    }
  }]
};
exports.mailReplyAll = mailReplyAll;
var replyAll = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1082v70q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v69l-397 398q-19 19-19 45t19 45zM1792 1120q0 58-17 133.5t-38.5 138-48 125-40.5 90.5l-20 40q-8 17-28 17-6 0-9-1-25-8-23-34 43-400-106-565-64-71-170.5-110.5t-267.5-52.5v251q0 42-39 59-13 5-25 5-27 0-45-19l-512-512q-19-19-19-45t19-45l512-512q29-31 70-14 39 17 39 59v262q411 28 599 221 169 173 169 509z"
    }
  }]
};
exports.replyAll = replyAll;
var starHalfEmpty = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"
    }
  }]
};
exports.starHalfEmpty = starHalfEmpty;
var starHalfFull = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"
    }
  }]
};
exports.starHalfFull = starHalfFull;
var starHalfO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1186 957l257-250-356-52-66-10-30-60-159-322v963l59 31 318 168-60-355-12-66zM1638 695l-363 354 86 500q5 33-6 51.5t-34 18.5q-17 0-40-12l-449-236-449 236q-23 12-40 12-23 0-34-18.5t-6-51.5l86-500-364-354q-32-32-23-59.5t54-34.5l502-73 225-455q20-41 49-41 28 0 49 41l225 455 502 73q45 7 54 34.5t-24 59.5z"
    }
  }]
};
exports.starHalfO = starHalfO;
var locationArrow = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1401 349l-640 1280q-17 35-57 35-5 0-15-2-22-5-35.5-22.5t-13.5-39.5v-576h-576q-22 0-39.5-13.5t-22.5-35.5 4-42 29-30l1280-640q13-7 29-7 27 0 45 19 15 14 18.5 34.5t-6.5 39.5z"
    }
  }]
};
exports.locationArrow = locationArrow;
var crop = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M557 1280h595v-595zM512 1235l595-595h-595v595zM1664 1312v192q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-224h-864q-14 0-23-9t-9-23v-864h-224q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h192q14 0 23 9t9 23v224h851l246-247q10-9 23-9t23 9q9 10 9 23t-9 23l-247 246v851h224q14 0 23 9t9 23z"
    }
  }]
};
exports.crop = crop;
var codeFork = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M288 1472q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM288 320q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM928 448q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1024 448q0 52-26 96.5t-70 69.5q-2 287-226 414-67 38-203 81-128 40-169.5 71t-41.5 100v26q44 25 70 69.5t26 96.5q0 80-56 136t-136 56-136-56-56-136q0-52 26-96.5t70-69.5v-820q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136q0 52-26 96.5t-70 69.5v497q54-26 154-57 55-17 87.5-29.5t70.5-31 59-39.5 40.5-51 28-69.5 8.5-91.5q-44-25-70-69.5t-26-96.5q0-80 56-136t136-56 136 56 56 136z"
    }
  }]
};
exports.codeFork = codeFork;
var chainBroken = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M439 1271l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zM608 1312v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM384 1088q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zM1031 492l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zM1664 576q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1120 32v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM1527 183l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"
    }
  }]
};
exports.chainBroken = chainBroken;
var unlink = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M439 1271l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23zM608 1312v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM384 1088q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1648 1216q0 120-85 203l-147 146q-83 83-203 83-121 0-204-85l-334-335q-21-21-42-56l239-18 273 274q27 27 68 27.5t68-26.5l147-146q28-28 28-67 0-40-28-68l-274-275 18-239q35 21 56 42l336 336q84 86 84 204zM1031 492l-239 18-273-274q-28-28-68-28-39 0-68 27l-147 146q-28 28-28 67 0 40 28 68l274 274-18 240q-35-21-56-42l-336-336q-84-86-84-204 0-120 85-203l147-146q83-83 203-83 121 0 204 85l334 335q21 21 42 56zM1664 576q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23 9-23 23-9h320q14 0 23 9t9 23zM1120 32v320q0 14-9 23t-23 9-23-9-9-23v-320q0-14 9-23t23-9 23 9 9 23zM1527 183l-256 256q-11 9-23 9t-23-9q-9-10-9-23t9-23l256-256q10-9 23-9t23 9q9 10 9 23t-9 23z"
    }
  }]
};
exports.unlink = unlink;
var question = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 1256v240q0 16-12 28t-28 12h-240q-16 0-28-12t-12-28v-240q0-16 12-28t28-12h240q16 0 28 12t12 28zM1020 656q0 54-15.5 101t-35 76.5-55 59.5-57.5 43.5-61 35.5q-41 23-68.5 65t-27.5 67q0 17-12 32.5t-28 15.5h-240q-15 0-25.5-18.5t-10.5-37.5v-45q0-83 65-156.5t143-108.5q59-27 84-56t25-76q0-42-46.5-74t-107.5-32q-65 0-108 29-35 25-107 115-13 16-31 16-12 0-25-8l-164-125q-13-10-15.5-25t5.5-28q160-266 464-266 80 0 161 31t146 83 106 127.5 41 158.5z"
    }
  }]
};
exports.question = question;
var info = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344v128q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h64v-384h-64q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h384q26 0 45 19t19 45v576h64q26 0 45 19t19 45zM512 192v192q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-192q0-26 19-45t45-19h256q26 0 45 19t19 45z"
    }
  }]
};
exports.info = info;
var exclamation = {
  "viewBox": "0 0 640 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1248v224q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-224q0-26 19-45t45-19h256q26 0 45 19t19 45zM542 192l-28 768q-1 26-20.5 45t-45.5 19h-256q-26 0-45.5-19t-20.5-45l-28-768q-1-26 17.5-45t44.5-19h320q26 0 44.5 19t17.5 45z"
    }
  }]
};
exports.exclamation = exclamation;
var superscript = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M897 1369v167h-248l-159-252-24-42q-8-9-11-21h-3q-1 3-2.5 6.5t-3.5 8-3 6.5q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zM1534 690v206h-514l-3-27q-4-28-4-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 83-65 188-65 110 0 178 59.5t68 158.5q0 56-24.5 103t-62 76.5-81.5 58.5-82 50.5-65.5 51.5-30.5 63h232v-80h126z"
    }
  }]
};
exports.superscript = superscript;
var subscript = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M897 1369v167h-248l-159-252-24-42q-8-9-11-21h-3q-1 3-2.5 6.5t-3.5 8-3 6.5q-10 20-25 44l-155 250h-258v-167h128l197-291-185-272h-137v-168h276l139 228q2 4 23 42 8 9 11 21h3q3-9 11-21l25-42 140-228h257v168h-125l-184 267 204 296h109zM1536 1586v206h-514l-4-27q-3-45-3-46 0-64 26-117t65-86.5 84-65 84-54.5 65-54 26-64q0-38-29.5-62.5t-70.5-24.5q-51 0-97 39-14 11-36 38l-105-92q26-37 63-66 80-65 188-65 110 0 178 59.5t68 158.5q0 66-34.5 118.5t-84 86-99.5 62.5-87 63-41 73h232v-80h126z"
    }
  }]
};
exports.subscript = subscript;
var eraser = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1408l336-384h-768l-336 384h768zM1909 331q15 34 9.5 71.5t-30.5 65.5l-896 1024q-38 44-96 44h-768q-38 0-69.5-20.5t-47.5-54.5q-15-34-9.5-71.5t30.5-65.5l896-1024q38-44 96-44h768q38 0 69.5 20.5t47.5 54.5z"
    }
  }]
};
exports.eraser = eraser;
var puzzlePiece = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1098q0 81-44.5 135t-123.5 54q-41 0-77.5-17.5t-59-38-56.5-38-71-17.5q-110 0-110 124 0 39 16 115t15 115v5q-22 0-33 1-34 3-97.5 11.5t-115.5 13.5-98 5q-61 0-103-26.5t-42-83.5q0-37 17.5-71t38-56.5 38-59 17.5-77.5q0-79-54-123.5t-135-44.5q-84 0-143 45.5t-59 127.5q0 43 15 83t33.5 64.5 33.5 53 15 50.5q0 45-46 89-37 35-117 35-95 0-245-24-9-2-27.5-4t-27.5-4l-13-2q-1 0-3-1-2 0-2-1v-1024q2 1 17.5 3.5t34 5 21.5 3.5q150 24 245 24 80 0 117-35 46-44 46-89 0-22-15-50.5t-33.5-53-33.5-64.5-15-83q0-82 59-127.5t144-45.5q80 0 134 44.5t54 123.5q0 41-17.5 77.5t-38 59-38 56.5-17.5 71q0 57 42 83.5t103 26.5q64 0 180-15t163-17v2q-1 2-3.5 17.5t-5 34-3.5 21.5q-24 150-24 245 0 80 35 117 44 46 89 46 22 0 50.5-15t53-33.5 64.5-33.5 83-15q82 0 127.5 59t45.5 143z"
    }
  }]
};
exports.puzzlePiece = puzzlePiece;
var microphone = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 704v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-217-24-364.5-187.5t-147.5-384.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45zM896 320v512q0 132-94 226t-226 94-226-94-94-226v-512q0-132 94-226t226-94 226 94 94 226z"
    }
  }]
};
exports.microphone = microphone;
var microphoneSlash = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M271 945l-101 101q-42-103-42-214v-128q0-26 19-45t45-19 45 19 19 45v128q0 53 15 113zM1385 343l-361 361v128q0 132-94 226t-226 94q-55 0-109-19l-96 96q97 51 205 51 185 0 316.5-131.5t131.5-316.5v-128q0-26 19-45t45-19 45 19 19 45v128q0 221-147.5 384.5t-364.5 187.5v132h256q26 0 45 19t19 45-19 45-45 19h-640q-26 0-45-19t-19-45 19-45 45-19h256v-132q-125-13-235-81l-254 254q-10 10-23 10t-23-10l-82-82q-10-10-10-23t10-23l1234-1234q10-10 23-10t23 10l82 82q10 10 10 23t-10 23zM1005 211l-621 621v-512q0-132 94-226t226-94q102 0 184.5 59t116.5 152z"
    }
  }]
};
exports.microphoneSlash = microphoneSlash;
var shield = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 960v-640h-448v1137q119-63 213-137 235-184 235-360zM1280 192v768q0 86-33.5 170.5t-83 150-118 127.5-126.5 103-121 77.5-89.5 49.5-42.5 20q-12 6-26 6t-26-6q-16-7-42.5-20t-89.5-49.5-121-77.5-126.5-103-118-127.5-83-150-33.5-170.5v-768q0-26 19-45t45-19h1152q26 0 45 19t19 45z"
    }
  }]
};
exports.shield = shield;
var calendarO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"
    }
  }]
};
exports.calendarO = calendarO;
var fireExtinguisher = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 192q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1408 160v320q0 16-12 25-8 7-20 7-4 0-7-1l-448-96q-11-2-18-11t-7-20h-256v102q111 23 183.5 111t72.5 203v800q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-800q0-106 62.5-190.5t161.5-114.5v-111h-32q-59 0-115 23.5t-91.5 53-66 66.5-40.5 53.5-14 24.5q-17 35-57 35-16 0-29-7-23-12-31.5-37t3.5-49q5-10 14.5-26t37.5-53.5 60.5-70 85-67 108.5-52.5q-25-42-25-86 0-66 47-113t113-47 113 47 47 113q0 33-14 64h302q0-11 7-20t18-11l448-96q3-1 7-1 12 0 20 7 12 9 12 25z"
    }
  }]
};
exports.fireExtinguisher = fireExtinguisher;
var rocket = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1440 448q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1664 160q0 249-75.5 430.5t-253.5 360.5q-81 80-195 176l-20 379q-2 16-16 26l-384 224q-7 4-16 4-12 0-23-9l-64-64q-13-14-8-32l85-276-281-281-276 85q-3 1-9 1-14 0-23-9l-64-64q-17-19-5-39l224-384q10-14 26-16l379-20q96-114 176-195 188-187 358-258t431-71q14 0 24 9.5t10 22.5z"
    }
  }]
};
exports.rocket = rocket;
var maxcdn = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1745 773l-164 763h-334l178-832q13-56-15-88-27-33-83-33h-169l-204 953h-334l204-953h-286l-204 953h-334l204-953-153-327h1276q101 0 189.5 40.5t147.5 113.5q60 73 81 168.5t0 194.5z"
    }
  }]
};
exports.maxcdn = maxcdn;
var chevronCircleLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M909 1395l102-102q19-19 19-45t-19-45l-307-307 307-307q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-454 454q-19 19-19 45t19 45l454 454q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.chevronCircleLeft = chevronCircleLeft;
var chevronCircleRight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M717 1395l454-454q19-19 19-45t-19-45l-454-454q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l307 307-307 307q-19 19-19 45t19 45l102 102q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.chevronCircleRight = chevronCircleRight;
var chevronCircleUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1165 1139l102-102q19-19 19-45t-19-45l-454-454q-19-19-45-19t-45 19l-454 454q-19 19-19 45t19 45l102 102q19 19 45 19t45-19l307-307 307 307q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.chevronCircleUp = chevronCircleUp;
var chevronCircleDown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M813 1299l454-454q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-307 307-307-307q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l454 454q19 19 45 19t45-19zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.chevronCircleDown = chevronCircleDown;
var html5 = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1130 597l16-175h-884l47 534h612l-22 228-197 53-196-53-13-140h-175l22 278 362 100h4v-1l359-99 50-544h-644l-15-181h674zM0 128h1408l-128 1438-578 162-574-162z"
    }
  }]
};
exports.html5 = html5;
var css3 = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M275 128h1505l-266 1333-804 267-698-267 71-356h297l-29 147 422 161 486-161 68-339h-1208l58-297h1209l38-191h-1208z"
    }
  }]
};
exports.css3 = css3;
var anchor = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 256q0-26-19-45t-45-19-45 19-19 45 19 45 45 19 45-19 19-45zM1792 1184v352q0 22-20 30-8 2-12 2-12 0-23-9l-93-93q-119 143-318.5 226.5t-429.5 83.5-429.5-83.5-318.5-226.5l-93 93q-9 9-23 9-4 0-12-2-20-8-20-30v-352q0-14 9-23t23-9h352q22 0 30 20 8 19-7 35l-100 100q67 91 189.5 153.5t271.5 82.5v-647h-192q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h192v-163q-58-34-93-92.5t-35-128.5q0-106 75-181t181-75 181 75 75 181q0 70-35 128.5t-93 92.5v163h192q26 0 45 19t19 45v128q0 26-19 45t-45 19h-192v647q149-20 271.5-82.5t189.5-153.5l-100-100q-15-16-7-35 8-20 30-20h352q14 0 23 9t9 23z"
    }
  }]
};
exports.anchor = anchor;
var unlockAlt = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1056 768q40 0 68 28t28 68v576q0 40-28 68t-68 28h-960q-40 0-68-28t-28-68v-576q0-40 28-68t68-28h32v-320q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 26-19 45t-45 19h-64q-26 0-45-19t-19-45q0-106-75-181t-181-75-181 75-75 181v320h736z"
    }
  }]
};
exports.unlockAlt = unlockAlt;
var bullseye = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM1152 896q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM1280 896q0 212-150 362t-362 150-362-150-150-362 150-362 362-150 362 150 150 362zM1408 896q0-130-51-248.5t-136.5-204-204-136.5-248.5-51-248.5 51-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.bullseye = bullseye;
var ellipsisH = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM896 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM1408 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z"
    }
  }]
};
exports.ellipsisH = ellipsisH;
var ellipsisV = {
  "viewBox": "0 0 384 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1248v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 736v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68zM384 224v192q0 40-28 68t-68 28h-192q-40 0-68-28t-28-68v-192q0-40 28-68t68-28h192q40 0 68 28t28 68z"
    }
  }]
};
exports.ellipsisV = ellipsisV;
var rssSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1280q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM863 1374q-13-233-176.5-396.5t-396.5-176.5q-14-1-24 9t-10 23v128q0 13 8.5 22t21.5 10q154 11 264 121t121 264q1 13 10 21.5t22 8.5h128q13 0 23-10t9-24zM1247 1375q-5-154-56-297.5t-139.5-260-205-205-260-139.5-297.5-56q-14-1-23 9-10 10-10 23v128q0 13 9 22t22 10q204 7 378 111.5t278.5 278.5 111.5 378q1 13 10 22t22 9h128q13 0 23-10 11-9 9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.rssSquare = rssSquare;
var playCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM1152 951q32-18 32-55t-32-55l-544-320q-31-19-64-1-32 19-32 56v640q0 37 32 56 16 8 32 8 17 0 32-9z"
    }
  }]
};
exports.playCircle = playCircle;
var ticket = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 452l316 316-572 572-316-316zM813 1431l618-618q19-19 19-45t-19-45l-362-362q-18-18-45-18t-45 18l-618 618q-19 19-19 45t19 45l362 362q18 18 45 18t45-18zM1702 794l-907 908q-37 37-90.5 37t-90.5-37l-126-126q56-56 56-136t-56-136-136-56-136 56l-125-126q-37-37-37-90.5t37-90.5l907-906q37-37 90.5-37t90.5 37l125 125q-56 56-56 136t56 136 136 56 136-56l126 125q37 37 37 90.5t-37 90.5z"
    }
  }]
};
exports.ticket = ticket;
var minusSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 960v-128q0-26-19-45t-45-19h-896q-26 0-45 19t-19 45v128q0 26 19 45t45 19h896q26 0 45-19t19-45zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.minusSquare = minusSquare;
var minusSquareO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 800v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h832q14 0 23 9t9 23zM1280 1248v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.minusSquareO = minusSquareO;
var levelUp = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1018 603q-18 37-58 37h-192v864q0 14-9 23t-23 9h-704q-21 0-29-18-8-20 4-35l160-192q9-11 25-11h320v-640h-192q-40 0-58-37-17-37 9-68l320-384q18-22 49-22t49 22l320 384q27 32 9 68z"
    }
  }]
};
exports.levelUp = levelUp;
var levelDown = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M32 256h704q13 0 22.5 9.5t9.5 23.5v863h192q40 0 58 37t-9 69l-320 384q-18 22-49 22t-49-22l-320-384q-26-31-9-69 18-37 58-37h192v-640h-320q-14 0-25-11l-160-192q-13-14-4-34 9-19 29-19z"
    }
  }]
};
exports.levelDown = levelDown;
var checkSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M685 1299l614-614q19-19 19-45t-19-45l-102-102q-19-19-45-19t-45 19l-467 467-211-211q-19-19-45-19t-45 19l-102 102q-19 19-19 45t19 45l358 358q19 19 45 19t45-19zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.checkSquare = checkSquare;
var pencilSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M404 1108l152 152-52 52h-56v-96h-96v-56zM818 718q14 13-3 30l-291 291q-17 17-30 3-14-13 3-30l291-291q17-17 30-3zM544 1408l544-544-288-288-544 544v288h288zM1152 800l92-92q28-28 28-68t-28-68l-152-152q-28-28-68-28t-68 28l-92 92zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.pencilSquare = pencilSquare;
var externalLinkSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 928v-480q0-26-19-45t-45-19h-480q-42 0-59 39-17 41 14 70l144 144-534 534q-19 19-19 45t19 45l102 102q19 19 45 19t45-19l534-534 144 144q18 19 45 19 12 0 25-5 39-17 39-59zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.externalLinkSquare = externalLinkSquare;
var shareSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1005 1101l352-352q19-19 19-45t-19-45l-352-352q-30-31-69-14-40 17-40 59v160q-119 0-216 19.5t-162.5 51-114 79-76.5 95.5-44.5 109-21.5 111.5-5 110.5q0 181 167 404 11 12 25 12 7 0 13-3 22-9 19-33-44-354 62-473 46-52 130-75.5t224-23.5v160q0 42 40 59 12 5 24 5 26 0 45-19zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.shareSquare = shareSquare;
var compass = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1088l256-128-256-128v256zM1024 497v542l-512 256v-542zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.compass = compass;
var caretSquareODown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1145 675q18 35-5 66l-320 448q-19 27-52 27t-52-27l-320-448q-23-31-5-66 17-35 57-35h640q40 0 57 35zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.caretSquareODown = caretSquareODown;
var toggleDown = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1145 675q18 35-5 66l-320 448q-19 27-52 27t-52-27l-320-448q-23-31-5-66 17-35 57-35h640q40 0 57 35zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.toggleDown = toggleDown;
var caretSquareOUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1145 1117q-17 35-57 35h-640q-40 0-57-35-18-35 5-66l320-448q19-27 52-27t52 27l320 448q23 31 5 66zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.caretSquareOUp = caretSquareOUp;
var toggleUp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1145 1117q-17 35-57 35h-640q-40 0-57-35-18-35 5-66l320-448q19-27 52-27t52 27l320 448q23 31 5 66zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.toggleUp = toggleUp;
var caretSquareORight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 896q0 33-27 52l-448 320q-31 23-66 5-35-17-35-57v-640q0-40 35-57 35-18 66 5l448 320q27 19 27 52zM1280 1376v-960q0-14-9-23t-23-9h-960q-14 0-23 9t-9 23v960q0 14 9 23t23 9h960q14 0 23-9t9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.caretSquareORight = caretSquareORight;
var toggleRight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 896q0 33-27 52l-448 320q-31 23-66 5-35-17-35-57v-640q0-40 35-57 35-18 66 5l448 320q27 19 27 52zM1280 1376v-960q0-14-9-23t-23-9h-960q-14 0-23 9t-9 23v960q0 14 9 23t23 9h960q14 0 23-9t9-23zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.toggleRight = toggleRight;
var eur = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M976 1307l35 159q3 12-3 22.5t-17 14.5l-5 1q-4 2-10.5 3.5t-16 4.5-21.5 5.5-25.5 5-30 5-33.5 4.5-36.5 3-38.5 1q-234 0-409-130.5t-238-351.5h-95q-13 0-22.5-9.5t-9.5-22.5v-113q0-13 9.5-22.5t22.5-9.5h66q-2-57 1-105h-67q-14 0-23-9t-9-23v-114q0-14 9-23t23-9h98q67-210 243.5-338t400.5-128q102 0 194 23 11 3 20 15 6 11 3 24l-43 159q-3 13-14 19.5t-24 2.5l-4-1q-4-1-11.5-2.5l-17.5-3.5t-22.5-3.5-26-3-29-2.5-29.5-1q-126 0-226 64t-150 176h468q16 0 25 12 10 12 7 26l-24 114q-5 26-32 26h-488q-3 37 0 105h459q15 0 25 12 9 12 6 27l-24 112q-2 11-11 18.5t-20 7.5h-387q48 117 149.5 185.5t228.5 68.5q18 0 36-1.5t33.5-3.5 29.5-4.5 24.5-5 18.5-4.5l12-3 5-2q13-5 26 2 12 7 15 21z"
    }
  }]
};
exports.eur = eur;
var euro = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M976 1307l35 159q3 12-3 22.5t-17 14.5l-5 1q-4 2-10.5 3.5t-16 4.5-21.5 5.5-25.5 5-30 5-33.5 4.5-36.5 3-38.5 1q-234 0-409-130.5t-238-351.5h-95q-13 0-22.5-9.5t-9.5-22.5v-113q0-13 9.5-22.5t22.5-9.5h66q-2-57 1-105h-67q-14 0-23-9t-9-23v-114q0-14 9-23t23-9h98q67-210 243.5-338t400.5-128q102 0 194 23 11 3 20 15 6 11 3 24l-43 159q-3 13-14 19.5t-24 2.5l-4-1q-4-1-11.5-2.5l-17.5-3.5t-22.5-3.5-26-3-29-2.5-29.5-1q-126 0-226 64t-150 176h468q16 0 25 12 10 12 7 26l-24 114q-5 26-32 26h-488q-3 37 0 105h459q15 0 25 12 9 12 6 27l-24 112q-2 11-11 18.5t-20 7.5h-387q48 117 149.5 185.5t228.5 68.5q18 0 36-1.5t33.5-3.5 29.5-4.5 24.5-5 18.5-4.5l12-3 5-2q13-5 26 2 12 7 15 21z"
    }
  }]
};
exports.euro = euro;
var gbp = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1020 1137v367q0 14-9 23t-23 9h-956q-14 0-23-9t-9-23v-150q0-13 9.5-22.5t22.5-9.5h97v-383h-95q-14 0-23-9.5t-9-22.5v-131q0-14 9-23t23-9h95v-223q0-171 123.5-282t314.5-111q185 0 335 125 9 8 10 20.5t-7 22.5l-103 127q-9 11-22 12-13 2-23-7-5-5-26-19t-69-32-93-18q-85 0-137 47t-52 123v215h305q13 0 22.5 9t9.5 23v131q0 13-9.5 22.5t-22.5 9.5h-305v379h414v-181q0-13 9-22.5t23-9.5h162q14 0 23 9.5t9 22.5z"
    }
  }]
};
exports.gbp = gbp;
var dollar = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M978 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z"
    }
  }]
};
exports.dollar = dollar;
var usd = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M978 1185q0 153-99.5 263.5t-258.5 136.5v175q0 14-9 23t-23 9h-135q-13 0-22.5-9.5t-9.5-22.5v-175q-66-9-127.5-31t-101.5-44.5-74-48-46.5-37.5-17.5-18q-17-21-2-41l103-135q7-10 23-12 15-2 24 9l2 2q113 99 243 125 37 8 74 8 81 0 142.5-43t61.5-122q0-28-15-53t-33.5-42-58.5-37.5-66-32-80-32.5q-39-16-61.5-25t-61.5-26.5-62.5-31-56.5-35.5-53.5-42.5-43.5-49-35.5-58-21-66.5-8.5-78q0-138 98-242t255-134v-180q0-13 9.5-22.5t22.5-9.5h135q14 0 23 9t9 23v176q57 6 110.5 23t87 33.5 63.5 37.5 39 29 15 14q17 18 5 38l-81 146q-8 15-23 16-14 3-27-7-3-3-14.5-12t-39-26.5-58.5-32-74.5-26-85.5-11.5q-95 0-155 43t-60 111q0 26 8.5 48t29.5 41.5 39.5 33 56 31 60.5 27 70 27.5q53 20 81 31.5t76 35 75.5 42.5 62 50 53 63.5 31.5 76.5 13 94z"
    }
  }]
};
exports.usd = usd;
var inr = {
  "viewBox": "0 0 898 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M898 470v102q0 14-9 23t-23 9h-168q-23 144-129 234t-276 110q167 178 459 536 14 16 4 34-8 18-29 18h-195q-16 0-25-12-306-367-498-571-9-9-9-22v-127q0-13 9.5-22.5t22.5-9.5h112q132 0 212.5-43t102.5-125h-427q-14 0-23-9t-9-23v-102q0-14 9-23t23-9h413q-57-113-268-113h-145q-13 0-22.5-9.5t-9.5-22.5v-133q0-14 9-23t23-9h832q14 0 23 9t9 23v102q0 14-9 23t-23 9h-233q47 61 64 144h171q14 0 23 9t9 23z"
    }
  }]
};
exports.inr = inr;
var rupee = {
  "viewBox": "0 0 898 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M898 470v102q0 14-9 23t-23 9h-168q-23 144-129 234t-276 110q167 178 459 536 14 16 4 34-8 18-29 18h-195q-16 0-25-12-306-367-498-571-9-9-9-22v-127q0-13 9.5-22.5t22.5-9.5h112q132 0 212.5-43t102.5-125h-427q-14 0-23-9t-9-23v-102q0-14 9-23t23-9h413q-57-113-268-113h-145q-13 0-22.5-9.5t-9.5-22.5v-133q0-14 9-23t23-9h832q14 0 23 9t9 23v102q0 14-9 23t-23 9h-233q47 61 64 144h171q14 0 23 9t9 23z"
    }
  }]
};
exports.rupee = rupee;
var cny = {
  "viewBox": "0 0 1027 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"
    }
  }]
};
exports.cny = cny;
var jpy = {
  "viewBox": "0 0 1027 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"
    }
  }]
};
exports.jpy = jpy;
var rmb = {
  "viewBox": "0 0 1027 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"
    }
  }]
};
exports.rmb = rmb;
var yen = {
  "viewBox": "0 0 1027 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M603 1536h-172q-13 0-22.5-9t-9.5-23v-330h-288q-13 0-22.5-9t-9.5-23v-103q0-13 9.5-22.5t22.5-9.5h288v-85h-288q-13 0-22.5-9t-9.5-23v-104q0-13 9.5-22.5t22.5-9.5h214l-321-578q-8-16 0-32 10-16 28-16h194q19 0 29 18l215 425q19 38 56 125 10-24 30.5-68t27.5-61l191-420q8-19 29-19h191q17 0 27 16 9 14 1 31l-313 579h215q13 0 22.5 9.5t9.5 22.5v104q0 14-9.5 23t-22.5 9h-290v85h290q13 0 22.5 9.5t9.5 22.5v103q0 14-9.5 23t-22.5 9h-290v330q0 13-9.5 22.5t-22.5 9.5z"
    }
  }]
};
exports.yen = yen;
var rouble = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"
    }
  }]
};
exports.rouble = rouble;
var rub = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"
    }
  }]
};
exports.rub = rub;
var ruble = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1043 565q0-100-65-162t-171-62h-320v448h320q106 0 171-62t65-162zM1280 565q0 193-126.5 315t-326.5 122h-340v118h505q14 0 23 9t9 23v128q0 14-9 23t-23 9h-505v192q0 14-9.5 23t-22.5 9h-167q-14 0-23-9t-9-23v-192h-224q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h224v-118h-224q-14 0-23-9t-9-23v-149q0-13 9-22.5t23-9.5h224v-629q0-14 9-23t23-9h539q200 0 326.5 122t126.5 315z"
    }
  }]
};
exports.ruble = ruble;
var krw = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M514 1195l81-299h-159l75 300q1 1 1 3t1 3q0-1 0.5-3.5t0.5-3.5zM630 768l35-128h-292l32 128h225zM822 768h139l-35-128h-70zM1271 1196l78-300h-162l81 299q0 1 0.5 3.5t1.5 3.5q0-1 0.5-3t0.5-3zM1382 768l33-128h-297l34 128h230zM1792 800v64q0 14-9 23t-23 9h-213l-164 616q-7 24-31 24h-159q-24 0-31-24l-166-616h-209l-167 616q-7 24-31 24h-159q-11 0-19.5-7t-10.5-17l-160-616h-208q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h175l-33-128h-142q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h109l-89-344q-5-15 5-28 10-12 26-12h137q26 0 31 24l90 360h359l97-360q7-24 31-24h126q24 0 31 24l98 360h365l93-360q5-24 31-24h137q16 0 26 12 10 13 5 28l-91 344h111q14 0 23 9t9 23v64q0 14-9 23t-23 9h-145l-34 128h179q14 0 23 9t9 23z"
    }
  }]
};
exports.krw = krw;
var won = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M514 1195l81-299h-159l75 300q1 1 1 3t1 3q0-1 0.5-3.5t0.5-3.5zM630 768l35-128h-292l32 128h225zM822 768h139l-35-128h-70zM1271 1196l78-300h-162l81 299q0 1 0.5 3.5t1.5 3.5q0-1 0.5-3t0.5-3zM1382 768l33-128h-297l34 128h230zM1792 800v64q0 14-9 23t-23 9h-213l-164 616q-7 24-31 24h-159q-24 0-31-24l-166-616h-209l-167 616q-7 24-31 24h-159q-11 0-19.5-7t-10.5-17l-160-616h-208q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h175l-33-128h-142q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h109l-89-344q-5-15 5-28 10-12 26-12h137q26 0 31 24l90 360h359l97-360q7-24 31-24h126q24 0 31 24l98 360h365l93-360q5-24 31-24h137q16 0 26 12 10 13 5 28l-91 344h111q14 0 23 9t9 23v64q0 14-9 23t-23 9h-145l-34 128h179q14 0 23 9t9 23z"
    }
  }]
};
exports.won = won;
var bitcoin = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1167 640q18 182-131 258 117 28 175 103t45 214q-7 71-32.5 125t-64.5 89-97 58.5-121.5 34.5-145.5 15v255h-154v-251q-80 0-122-1v252h-154v-255q-18 0-54-0.5t-55-0.5h-200l31-183h111q50 0 58-51v-402h16q-6-1-16-1v-287q-13-68-89-68h-111v-164l212 1q64 0 97-1v-252h154v247q82-2 122-2v-245h154v252q79 7 140 22.5t113 45 82.5 78 36.5 114.5zM952 1185q0-36-15-64t-37-46-57.5-30.5-65.5-18.5-74-9-69-3-64.5 1-47.5 1v338q8 0 37 0.5t48 0.5 53-1.5 58.5-4 57-8.5 55.5-14 47.5-21 39.5-30 24.5-40 9.5-51zM881 709q0-33-12.5-58.5t-30.5-42-48-28-55-16.5-61.5-8-58-2.5-54 1-39.5 0.5v307q5 0 34.5 0.5t46.5 0 50-2 55-5.5 51.5-11 48.5-18.5 37-27 27-38.5 9-51z"
    }
  }]
};
exports.bitcoin = bitcoin;
var btc = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1167 640q18 182-131 258 117 28 175 103t45 214q-7 71-32.5 125t-64.5 89-97 58.5-121.5 34.5-145.5 15v255h-154v-251q-80 0-122-1v252h-154v-255q-18 0-54-0.5t-55-0.5h-200l31-183h111q50 0 58-51v-402h16q-6-1-16-1v-287q-13-68-89-68h-111v-164l212 1q64 0 97-1v-252h154v247q82-2 122-2v-245h154v252q79 7 140 22.5t113 45 82.5 78 36.5 114.5zM952 1185q0-36-15-64t-37-46-57.5-30.5-65.5-18.5-74-9-69-3-64.5 1-47.5 1v338q8 0 37 0.5t48 0.5 53-1.5 58.5-4 57-8.5 55.5-14 47.5-21 39.5-30 24.5-40 9.5-51zM881 709q0-33-12.5-58.5t-30.5-42-48-28-55-16.5-61.5-8-58-2.5-54 1-39.5 0.5v307q5 0 34.5 0.5t46.5 0 50-2 55-5.5 51.5-11 48.5-18.5 37-27 27-38.5 9-51z"
    }
  }]
};
exports.btc = btc;
var file = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 512v-472q22 14 36 28l408 408q14 14 28 36h-472zM896 544q0 40 28 68t68 28h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544z"
    }
  }]
};
exports.file = file;
var fileText = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 476q14 14 28 36h-472v-472q22 14 36 28zM992 640h544v1056q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h800v544q0 40 28 68t68 28zM1152 1376v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1152 1120v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1152 864v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23z"
    }
  }]
};
exports.fileText = fileText;
var sortAlphaAsc = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1191 408h177l-72-218-12-47q-2-16-2-20h-4l-3 20q0 1-3.5 18t-7.5 29zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1572 1559v233h-584v-90l369-529q12-18 21-27l11-9v-3q-2 0-6.5 0.5t-7.5 0.5q-12 3-30 3h-232v115h-120v-229h567v89l-369 530q-6 8-21 26l-11 11v2l14-2q9-2 30-2h248v-119h121zM1661 662v106h-288v-106h75l-47-144h-243l-47 144h75v106h-287v-106h70l230-662h162l230 662h70z"
    }
  }]
};
exports.sortAlphaAsc = sortAlphaAsc;
var sortAlphaDesc = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1191 1432h177l-72-218-12-47q-2-16-2-20h-4l-3 20q0 1-3.5 18t-7.5 29zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1661 1686v106h-288v-106h75l-47-144h-243l-47 144h75v106h-287v-106h70l230-662h162l230 662h70zM1572 535v233h-584v-90l369-529q12-18 21-27l11-9v-3q-2 0-6.5 0.5t-7.5 0.5q-12 3-30 3h-232v115h-120v-229h567v89l-369 530q-6 8-21 26l-11 10v3l14-3q9-1 30-1h248v-119h121z"
    }
  }]
};
exports.sortAlphaDesc = sortAlphaDesc;
var sortAmountAsc = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1792 1568v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23zM1600 1056v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zM1408 544v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zM1216 32v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23z"
    }
  }]
};
exports.sortAmountAsc = sortAmountAsc;
var sortAmountDesc = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1216 1568v192q0 14-9 23t-23 9h-256q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h256q14 0 23 9t9 23zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1408 1056v192q0 14-9 23t-23 9h-448q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h448q14 0 23 9t9 23zM1600 544v192q0 14-9 23t-23 9h-640q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h640q14 0 23 9t9 23zM1792 32v192q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h832q14 0 23 9t9 23z"
    }
  }]
};
exports.sortAmountDesc = sortAmountDesc;
var sortNumericAsc = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1346 1313q0-63-44-116t-103-53q-52 0-83 37t-31 94 36.5 95 104.5 38q50 0 85-27t35-68zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1486 1371q0 62-13 121.5t-41 114-68 95.5-98.5 65.5-127.5 24.5q-62 0-108-16-24-8-42-15l39-113q15 7 31 11 37 13 75 13 84 0 134.5-58.5t66.5-145.5h-2q-21 23-61.5 37t-84.5 14q-106 0-173-71.5t-67-172.5q0-105 72-178t181-73q123 0 205 94.5t82 252.5zM1456 654v114h-469v-114h167v-432q0-7 0.5-19t0.5-17v-16h-2l-7 12q-8 13-26 31l-62 58-82-86 192-185h123v654h165z"
    }
  }]
};
exports.sortNumericAsc = sortNumericAsc;
var sortNumericDesc = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1346 289q0-63-44-116t-103-53q-52 0-83 37t-31 94 36.5 95 104.5 38q50 0 85-27t35-68zM736 1440q0 12-10 24l-319 319q-10 9-23 9-12 0-23-9l-320-320q-15-16-7-35 8-20 30-20h192v-1376q0-14 9-23t23-9h192q14 0 23 9t9 23v1376h192q14 0 23 9t9 23zM1456 1678v114h-469v-114h167v-432q0-7 0.5-19t0.5-17v-16h-2l-7 12q-8 13-26 31l-62 58-82-86 192-185h123v654h165zM1486 347q0 62-13 121.5t-41 114-68 95.5-98.5 65.5-127.5 24.5q-62 0-108-16-24-8-42-15l39-113q15 7 31 11 37 13 75 13 84 0 134.5-58.5t66.5-145.5h-2q-21 23-61.5 37t-84.5 14q-106 0-173-71.5t-67-172.5q0-105 72-178t181-73q123 0 205 94.5t82 252.5z"
    }
  }]
};
exports.sortNumericDesc = sortNumericDesc;
var thumbsUp = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1344q0-26-19-45t-45-19q-27 0-45.5 19t-18.5 45q0 27 18.5 45.5t45.5 18.5q26 0 45-18.5t19-45.5zM416 832v640q0 26-19 45t-45 19h-288q-26 0-45-19t-19-45v-640q0-26 19-45t45-19h288q26 0 45 19t19 45zM1600 832q0 86-55 149 15 44 15 76 3 76-43 137 17 56 0 117-15 57-54 94 9 112-49 181-64 76-197 78h-36-76-17q-66 0-144-15.5t-121.5-29-120.5-39.5q-123-43-158-44-26-1-45-19.5t-19-44.5v-641q0-25 18-43.5t43-20.5q24-2 76-59t101-121q68-87 101-120 18-18 31-48t17.5-48.5 13.5-60.5q7-39 12.5-61t19.5-52 34-50q19-19 45-19 46 0 82.5 10.5t60 26 40 40.5 24 45 12 50 5 45 0.5 39q0 38-9.5 76t-19 60-27.5 56q-3 6-10 18t-11 22-8 24h277q78 0 135 57t57 135z"
    }
  }]
};
exports.thumbsUp = thumbsUp;
var thumbsDown = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 576q0 26-19 45t-45 19q-27 0-45.5-19t-18.5-45q0-27 18.5-45.5t45.5-18.5q26 0 45 18.5t19 45.5zM416 1088v-640q0-26-19-45t-45-19h-288q-26 0-45 19t-19 45v640q0 26 19 45t45 19h288q26 0 45-19t19-45zM1545 939q55 61 55 149-1 78-57.5 135t-134.5 57h-277q4 14 8 24t11 22 10 18q18 37 27 57t19 58.5 10 76.5q0 24-0.5 39t-5 45-12 50-24 45-40 40.5-60 26-82.5 10.5q-26 0-45-19-20-20-34-50t-19.5-52-12.5-61q-9-42-13.5-60.5t-17.5-48.5-31-48q-33-33-101-120-49-64-101-121t-76-59q-25-2-43-20.5t-18-43.5v-641q0-26 19-44.5t45-19.5q35-1 158-44 77-26 120.5-39.5t121.5-29 144-15.5h17 76 36q133 2 197 78 58 69 49 181 39 37 54 94 17 61 0 117 46 61 43 137 0 32-15 76z"
    }
  }]
};
exports.thumbsDown = thumbsDown;
var youtubeSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M919 1303v-157q0-50-29-50-17 0-33 16v224q16 16 33 16 29 0 29-49zM1103 1181h66v-34q0-51-33-51t-33 51v34zM532 915v70h-80v423h-74v-423h-78v-70h232zM733 1041v367h-67v-40q-39 45-76 45-33 0-42-28-6-17-6-54v-290h66v270q0 24 1 26 1 15 15 15 20 0 42-31v-280h67zM985 1152v146q0 52-7 73-12 42-53 42-35 0-68-41v36h-67v-493h67v161q32-40 68-40 41 0 53 42 7 21 7 74zM1236 1281v9q0 29-2 43-3 22-15 40-27 40-80 40-52 0-81-38-21-27-21-86v-129q0-59 20-86 29-38 80-38t78 38q21 29 21 86v76h-133v65q0 51 34 51 24 0 30-26 0-1 0.5-7t0.5-16.5v-21.5h68zM785 457v156q0 51-32 51t-32-51v-156q0-52 32-52t32 52zM1318 1170q0-177-19-260-10-44-43-73.5t-76-34.5q-136-15-412-15-275 0-411 15-44 5-76.5 34.5t-42.5 73.5q-20 87-20 260 0 176 20 260 10 43 42.5 73t75.5 35q137 15 412 15t412-15q43-5 75.5-35t42.5-73q20-84 20-260zM563 519l90-296h-75l-51 195-53-195h-78q7 23 23 69l24 69q35 103 46 158v201h74v-201zM852 600v-130q0-58-21-87-29-38-78-38-51 0-78 38-21 29-21 87v130q0 58 21 87 27 38 78 38 49 0 78-38 21-27 21-87zM1033 720h67v-370h-67v283q-22 31-42 31-15 0-16-16-1-2-1-26v-272h-67v293q0 37 6 55 11 27 43 27 36 0 77-45v40zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.youtubeSquare = youtubeSquare;
var youtube = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M971 1244v211q0 67-39 67-23 0-45-22v-301q22-22 45-22 39 0 39 67zM1309 1245v46h-90v-46q0-68 45-68t45 68zM343 1027h107v-94h-312v94h105v569h100v-569zM631 1596h89v-494h-89v378q-30 42-57 42-18 0-21-21-1-3-1-35v-364h-89v391q0 49 8 73 12 37 58 37 48 0 102-61v54zM1060 1448v-197q0-73-9-99-17-56-71-56-50 0-93 54v-217h-89v663h89v-48q45 55 93 55 54 0 71-55 9-27 9-100zM1398 1438v-13h-91q0 51-2 61-7 36-40 36-46 0-46-69v-87h179v-103q0-79-27-116-39-51-106-51-68 0-107 51-28 37-28 116v173q0 79 29 116 39 51 108 51 72 0 108-53 18-27 21-54 2-9 2-58zM790 525v-210q0-69-43-69t-43 69v210q0 70 43 70t43-70zM1509 1276q0 234-26 350-14 59-58 99t-102 46q-184 21-555 21t-555-21q-58-6-102.5-46t-57.5-99q-26-112-26-350 0-234 26-350 14-59 58-99t103-47q183-20 554-20t555 20q58 7 102.5 47t57.5 99q26 112 26 350zM511 0h102l-121 399v271h-100v-271q-14-74-61-212-37-103-65-187h106l71 263zM881 333v175q0 81-28 118-38 51-106 51-67 0-105-51-28-38-28-118v-175q0-80 28-117 38-51 105-51 68 0 106 51 28 37 28 117zM1216 171v499h-91v-55q-53 62-103 62-46 0-59-37-8-24-8-75v-394h91v367q0 33 1 35 3 22 21 22 27 0 57-43v-381h91z"
    }
  }]
};
exports.youtube = youtube;
var xing = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M597 667q-10 18-257 456-27 46-65 46h-239q-21 0-31-17t0-36l253-448q1 0 0-1l-161-279q-12-22-1-37 9-15 32-15h239q40 0 66 45zM1403 25q11 16 0 37l-528 934v1l336 615q11 20 1 37-10 15-32 15h-239q-42 0-66-45l-339-622q18-32 531-942 25-45 64-45h241q22 0 31 15z"
    }
  }]
};
exports.xing = xing;
var xingSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M685 765q0-1-126-222-21-34-52-34h-184q-18 0-26 11-7 12 1 29l125 216v1l-196 346q-9 14 0 28 8 13 24 13h185q31 0 50-36zM1309 268q-7-12-24-12h-187q-30 0-49 35l-411 729q1 2 262 481 20 35 52 35h184q18 0 25-12 8-13-1-28l-260-476v-1l409-723q8-16 0-28zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.xingSquare = xingSquare;
var youtubePlay = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M711 1128l484-250-484-253v503zM896 266q168 0 324.5 4.5t229.5 9.5l73 4q1 0 17 1.5t23 3 23.5 4.5 28.5 8 28 13 31 19.5 29 26.5q6 6 15.5 18.5t29 58.5 26.5 101q8 64 12.5 136.5t5.5 113.5v40 136q1 145-18 290-7 55-25 99.5t-32 61.5l-14 17q-14 15-29 26.5t-31 19-28 12.5-28.5 8-24 4.5-23 3-16.5 1.5q-251 19-627 19-207-2-359.5-6.5t-200.5-7.5l-49-4-36-4q-36-5-54.5-10t-51-21-56.5-41q-6-6-15.5-18.5t-29-58.5-26.5-101q-8-64-12.5-136.5t-5.5-113.5v-40-136q-1-145 18-290 7-55 25-99.5t32-61.5l14-17q14-15 29-26.5t31-19.5 28-13 28.5-8 23.5-4.5 23-3 17-1.5q251-18 627-18z"
    }
  }]
};
exports.youtubePlay = youtubePlay;
var dropbox = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M402 707l494 305-342 285-490-319zM1388 1262v108l-490 293v1l-1-1-1 1v-1l-489-293v-108l147 96 342-284v-2l1 1 1-1v2l343 284zM554 118l342 285-494 304-338-270zM1390 707l338 271-489 319-343-285zM1239 118l489 319-338 270-494-304z"
    }
  }]
};
exports.dropbox = dropbox;
var stackOverflow = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1289 1632h-1118v-480h-160v640h1438v-640h-160v480zM347 1108l33-157 783 165-33 156zM450 734l67-146 725 339-67 145zM651 378l102-123 614 513-102 123zM1048 0l477 641-128 96-477-641zM330 1471v-159h800v159h-800z"
    }
  }]
};
exports.stackOverflow = stackOverflow;
var instagram = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 896q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM1162 896q0 164-115 279t-279 115-279-115-115-279 115-279 279-115 279 115 115 279zM1270 486q0 38-27 65t-65 27-65-27-27-65 27-65 65-27 65 27 27 65zM768 266q-7 0-76.5-0.5t-105.5 0-96.5 3-103 10-71.5 18.5q-50 20-88 58t-58 88q-11 29-18.5 71.5t-10 103-3 96.5 0 105.5 0.5 76.5-0.5 76.5 0 105.5 3 96.5 10 103 18.5 71.5q20 50 58 88t88 58q29 11 71.5 18.5t103 10 96.5 3 105.5 0 76.5-0.5 76.5 0.5 105.5 0 96.5-3 103-10 71.5-18.5q50-20 88-58t58-88q11-29 18.5-71.5t10-103 3-96.5 0-105.5-0.5-76.5 0.5-76.5 0-105.5-3-96.5-10-103-18.5-71.5q-20-50-58-88t-88-58q-29-11-71.5-18.5t-103-10-96.5-3-105.5 0-76.5 0.5zM1536 896q0 229-5 317-10 208-124 322t-322 124q-88 5-317 5t-317-5q-208-10-322-124t-124-322q-5-88-5-317t5-317q10-208 124-322t322-124q88-5 317-5t317 5q208 10 322 124t124 322q5 88 5 317z"
    }
  }]
};
exports.instagram = instagram;
var flickr = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM698 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150zM1262 896q0-88-62-150t-150-62-150 62-62 150 62 150 150 62 150-62 62-150z"
    }
  }]
};
exports.flickr = flickr;
var adn = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 622l201 306h-402zM1133 1152h94l-459-691-459 691h94l104-160h522zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.adn = adn;
var bitbucket = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M815 859q8 63-50.5 101t-111.5 6q-39-17-53.5-58t-0.5-82 52-58q36-18 72.5-12t64 35.5 27.5 67.5zM926 838q-14-107-113-164t-197-13q-63 28-100.5 88.5t-34.5 129.5q4 91 77.5 155t165.5 56q91-8 152-84t50-168zM1165 296q-20-27-56-44.5t-58-22-71-12.5q-291-47-566 2-43 7-66 12t-55 22-50 43q30 28 76 45.5t73.5 22 87.5 11.5q228 29 448 1 63-8 89.5-12t72.5-21.5 75-46.5zM1222 1331q-8 26-15.5 76.5t-14 84-28.5 70-58 56.5q-86 48-189.5 71.5t-202 22-201.5-18.5q-46-8-81.5-18t-76.5-27-73-43.5-52-61.5q-25-96-57-292l6-16 18-9q223 148 506.5 148t507.5-148q21 6 24 23t-5 45-8 37zM1403 370q-26 167-111 655-5 30-27 56t-43.5 40-54.5 31q-252 126-610 88-248-27-394-139-15-12-25.5-26.5t-17-35-9-34-6-39.5-5.5-35q-9-50-26.5-150t-28-161.5-23.5-147.5-22-158q3-26 17.5-48.5t31.5-37.5 45-30 46-22.5 48-18.5q125-46 313-64 379-37 676 50 155 46 215 122 16 20 16.5 51t-5.5 54z"
    }
  }]
};
exports.bitbucket = bitbucket;
var bitbucketSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M848 870q0-43-41-66t-77-1q-43 20-42.5 72.5t43.5 70.5q39 23 81-4t36-72zM928 854q8 66-36 121t-110 61-119-40-56-113q-2-49 25.5-93t72.5-64q70-31 141.5 10t81.5 118zM1100 463q-20 21-53.5 34t-53 16-63.5 8q-155 20-324 0-44-6-63-9.5t-52.5-16-54.5-32.5q13-19 36-31t40-15.5 47-8.5q198-35 408-1 33 5 51 8.5t43 16 39 31.5zM1142 1209q0-7 5.5-26.5t3-32-17.5-16.5q-161 106-365 106t-366-106l-12 6-5 12q26 154 41 210 47 81 204 108 249 46 428-53 34-19 49-51.5t22.5-85.5 12.5-71zM1272 516q9-53-8-75-43-55-155-88-216-63-487-36-132 12-226 46-38 15-59.5 25t-47 34-29.5 54q8 68 19 138t29 171 24 137q1 5 5 31t7 36 12 27 22 28q105 80 284 100 259 28 440-63 24-13 39.5-23t31-29 19.5-40q48-267 80-473zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.bitbucketSquare = bitbucketSquare;
var tumblr = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M944 1329l80 237q-23 35-111 66t-177 32q-104 2-190.5-26t-142.5-74-95-106-55.5-120-16.5-118v-544h-168v-215q72-26 129-69.5t91-90 58-102 34-99 15-88.5q1-5 4.5-8.5t7.5-3.5h244v424h333v252h-334v518q0 30 6.5 56t22.5 52.5 49.5 41.5 81.5 14q78-2 134-29z"
    }
  }]
};
exports.tumblr = tumblr;
var tumblrSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1136 1461l-62-183q-44 22-103 22-36 1-62-10.5t-38.5-31.5-17.5-40.5-5-43.5v-398h257v-194h-256v-326h-188q-8 0-9 10-5 44-17.5 87t-39 95-77 95-118.5 68v165h130v418q0 57 21.5 115t65 111 121 85.5 176.5 30.5q69-1 136.5-25t85.5-50zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.tumblrSquare = tumblrSquare;
var longArrowDown = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M765 1299q8 19-5 35l-350 384q-10 10-23 10-14 0-24-10l-355-384q-13-16-5-35 9-19 29-19h224v-1248q0-14 9-23t23-9h192q14 0 23 9t9 23v1248h224q21 0 29 19z"
    }
  }]
};
exports.longArrowDown = longArrowDown;
var longArrowUp = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M765 493q-9 19-29 19h-224v1248q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-1248h-224q-21 0-29-19t5-35l350-384q10-10 23-10 14 0 24 10l355 384q13 16 5 35z"
    }
  }]
};
exports.longArrowUp = longArrowUp;
var longArrowLeft = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 800v192q0 14-9 23t-23 9h-1248v224q0 21-19 29t-35-5l-384-350q-10-10-10-23 0-14 10-24l384-354q16-14 35-6 19 9 19 29v224h1248q14 0 23 9t9 23z"
    }
  }]
};
exports.longArrowLeft = longArrowLeft;
var longArrowRight = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1728 893q0 14-10 24l-384 354q-16 14-35 6-19-9-19-29v-224h-1248q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h1248v-224q0-21 19-29t35 5l384 350q10 10 10 23z"
    }
  }]
};
exports.longArrowRight = longArrowRight;
var apple = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1393 1215q-39 125-123 250-129 196-257 196-49 0-140-32-86-32-151-32-61 0-142 33-81 34-132 34-152 0-301-259-147-261-147-503 0-228 113-374 113-144 284-144 72 0 177 30 104 30 138 30 45 0 143-34 102-34 173-34 119 0 213 65 52 36 104 100-79 67-114 118-65 94-65 207 0 124 69 223t158 126zM1017 42q0 61-29 136-30 75-93 138-54 54-108 72-37 11-104 17 3-149 78-257 74-107 250-148 1 3 2.5 11t2.5 11q0 4 0.5 10t0.5 10z"
    }
  }]
};
exports.apple = apple;
var windows = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M682 1006v651l-682-94v-557h682zM682 263v659h-682v-565zM1664 1006v786l-907-125v-661h907zM1664 128v794h-907v-669z"
    }
  }]
};
exports.windows = windows;
var android = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M493 483q16 0 27.5-11.5t11.5-27.5-11.5-27.5-27.5-11.5-27 11.5-11 27.5 11 27.5 27 11.5zM915 483q16 0 27-11.5t11-27.5-11-27.5-27-11.5-27.5 11.5-11.5 27.5 11.5 27.5 27.5 11.5zM103 667q42 0 72 30t30 72v430q0 43-29.5 73t-72.5 30-73-30-30-73v-430q0-42 30-72t73-30zM1163 686v666q0 46-32 78t-77 32h-75v227q0 43-30 73t-73 30-73-30-30-73v-227h-138v227q0 43-30 73t-73 30q-42 0-72-30t-30-73l-1-227h-74q-46 0-78-32t-32-78v-666h918zM931 281q107 55 171 153.5t64 215.5h-925q0-117 64-215.5t172-153.5l-71-131q-7-13 5-20 13-6 20 6l72 132q95-42 201-42t201 42l72-132q7-12 20-6 12 7 5 20zM1408 769v430q0 43-30 73t-73 30q-42 0-72-30t-30-73v-430q0-43 30-72.5t72-29.5q43 0 73 29.5t30 72.5z"
    }
  }]
};
exports.android = android;
var linux = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M663 411q-11 1-15.5 10.5t-8.5 9.5q-5 1-5-5 0-12 19-15h10zM750 425q-4 1-11.5-6.5t-17.5-4.5q24-11 32 2 3 6-3 9zM399 852q-4-1-6 3t-4.5 12.5-5.5 13.5-10 13q-10 11-1 12 4 1 12.5-7t12.5-18q1-3 2-7t2-6 1.5-4.5 0.5-4v-3t-1-2.5-3-2zM1254 1211q0-18-55-42 4-15 7.5-27.5t5-26 3-21.5 0.5-22.5-1-19.5-3.5-22-4-20.5-5-25-5.5-26.5q-10-48-47-103t-72-75q24 20 57 83 87 162 54 278-11 40-50 42-31 4-38.5-18.5t-8-83.5-11.5-107q-9-39-19.5-69t-19.5-45.5-15.5-24.5-13-15-7.5-7q-14-62-31-103t-29.5-56-23.5-33-15-40q-4-21 6-53.5t4.5-49.5-44.5-25q-15-3-44.5-18t-35.5-16q-8-1-11-26t8-51 36-27q37-3 51 30t4 58q-11 19-2 26.5t30 0.5q13-4 13-36v-37q-5-30-13.5-50t-21-30.5-23.5-15-27-7.5q-107 8-89 134 0 15-1 15-9-9-29.5-10.5t-33 0.5-15.5-5q1-57-16-90t-45-34q-27-1-41.5 27.5t-16.5 59.5q-1 15 3.5 37t13 37.5 15.5 13.5q10-3 16-14 4-9-7-8-7 0-15.5-14.5t-9.5-33.5q-1-22 9-37t34-14q17 0 27 21t9.5 39-1.5 22q-22 15-31 29-8 12-27.5 23.5t-20.5 12.5q-13 14-15.5 27t7.5 18q14 8 25 19.5t16 19 18.5 13 35.5 6.5q47 2 102-15 2-1 23-7t34.5-10.5 29.5-13 21-17.5q9-14 20-8 5 3 6.5 8.5t-3 12-16.5 9.5q-20 6-56.5 21.5t-45.5 19.5q-44 19-70 23-25 5-79-2-10-2-9 2t17 19q25 23 67 22 17-1 36-7t36-14 33.5-17.5 30-17 24.5-12 17.5-2.5 8.5 11q0 2-1 4.5t-4 5-6 4.5-8.5 5-9 4.5-10 5-9.5 4.5q-28 14-67.5 44t-66.5 43-49 1q-21-11-63-73-22-31-25-22-1 3-1 10 0 25-15 56.5t-29.5 55.5-21 58 11.5 63q-23 6-62.5 90t-47.5 141q-2 18-1.5 69t-5.5 59q-8 24-29 3-32-31-36-94-2-28 4-56 4-19-1-18-2 1-4 5-36 65 10 166 5 12 25 28t24 20q20 23 104 90.5t93 76.5q16 15 17.5 38t-14 43-45.5 23q8 15 29 44.5t28 54 7 70.5q46-24 7-92-4-8-10.5-16t-9.5-12-2-6q3-5 13-9.5t20 2.5q46 52 166 36 133-15 177-87 23-38 34-30 12 6 10 52-1 25-23 92-9 23-6 37.5t24 15.5q3-19 14.5-77t13.5-90q2-21-6.5-73.5t-7.5-97 23-70.5q15-18 51-18 1-37 34.5-53t72.5-10.5 60 22.5zM626 384q3-17-2.5-30t-11.5-15q-9-2-9 7 2 5 5 6 10 0 7 15-3 20 8 20 3 0 3-3zM1045 581q-2-8-6.5-11.5t-13-5-14.5-5.5q-5-3-9.5-8t-7-8-5.5-6.5-4-4-4 1.5q-14 16 7 43.5t39 31.5q9 1 14.5-8t3.5-20zM867 368q0-11-5-19.5t-11-12.5-9-3q-6 0-8 2t0 4 5 3q14 4 18 31 0 3 8-2 2-2 2-3zM921 135q0-2-2.5-5t-9-7-9.5-6q-15-15-24-15-9 1-11.5 7.5t-1 13-0.5 12.5q-1 4-6 10.5t-6 9 3 8.5q4 3 8 0t11-9 15-9q1-1 9-1t15-2 9-7zM1486 1476q20 12 31 24.5t12 24-2.5 22.5-15.5 22-23.5 19.5-30 18.5-31.5 16.5-32 15.5-27 13q-38 19-85.5 56t-75.5 64q-17 16-68 19.5t-89-14.5q-18-9-29.5-23.5t-16.5-25.5-22-19.5-47-9.5q-44-1-130-1-19 0-57 1.5t-58 2.5q-44 1-79.5 15t-53.5 30-43.5 28.5-53.5 11.5q-29-1-111-31t-146-43q-19-4-51-9.5t-50-9-39.5-9.5-33.5-14.5-17-19.5q-10-23 7-66.5t18-54.5q1-16-4-40t-10-42.5-4.5-36.5 10.5-27q14-12 57-14t60-12q30-18 42-35t12-51q21 73-32 106-32 20-83 15-34-3-43 10-13 15 5 57 2 6 8 18t8.5 18 4.5 17 1 22q0 15-17 49t-14 48q3 17 37 26 20 6 84.5 18.5t99.5 20.5q24 6 74 22t82.5 23 55.5 4q43-6 64.5-28t23-48-7.5-58.5-19-52-20-36.5q-121-190-169-242-68-74-113-40-11 9-15-15-3-16-2-38 1-29 10-52t24-47 22-42q8-21 26.5-72t29.5-78 30-61 39-54q110-143 124-195-12-112-16-310-2-90 24-151.5t106-104.5q39-21 104-21 53-1 106 13.5t89 41.5q57 42 91.5 121.5t29.5 147.5q-5 95 30 214 34 113 133 218 55 59 99.5 163t59.5 191q8 49 5 84.5t-12 55.5-20 22q-10 2-23.5 19t-27 35.5-40.5 33.5-61 14q-18-1-31.5-5t-22.5-13.5-13.5-15.5-11.5-20.5-9-19.5q-22-37-41-30t-28 49 7 97q20 70 1 195-10 65 18 100.5t73 33 85-35.5q59-49 89.5-66.5t103.5-42.5q53-18 77-36.5t18.5-34.5-25-28.5-51.5-23.5q-33-11-49.5-48t-15-72.5 15.5-47.5q1 31 8 56.5t14.5 40.5 20.5 28.5 21 19 21.5 13 16.5 9.5z"
    }
  }]
};
exports.linux = linux;
var dribbble = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1500q-42-241-140-498h-2l-2 1q-16 6-43 16.5t-101 49-137 82-131 114.5-103 148l-15-11q184 150 418 150 132 0 256-52zM839 893q-21-49-53-111-311 93-673 93-1 7-1 21 0 124 44 236.5t124 201.5q50-89 123.5-166.5t142.5-124.5 130.5-81 99.5-48l37-13q4-1 13-3.5t13-4.5zM732 681q-120-213-244-378-138 65-234 186t-128 272q302 0 606-80zM1416 1000q-210-60-409-29 87 239 128 469 111-75 185-189.5t96-250.5zM611 259q-1 0-2 1 1-1 2-1zM1201 404q-185-164-433-164-76 0-155 19 131 170 246 382 69-26 130-60.5t96.5-61.5 65.5-57 37.5-40.5zM1424 889q-3-232-149-410l-1 1q-9 12-19 24.5t-43.5 44.5-71 60.5-100 65-131.5 64.5q25 53 44 95 2 5 6.5 17t7.5 17q36-5 74.5-7t73.5-2 69 1.5 64 4 56.5 5.5 48 6.5 36.5 6 25 4.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.dribbble = dribbble;
var skype = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1173 1063q0-50-19.5-91.5t-48.5-68.5-73-49-82.5-34-87.5-23l-104-24q-30-7-44-10.5t-35-11.5-30-16-16.5-21-7.5-30q0-77 144-77 43 0 77 12t54 28.5 38 33.5 40 29 48 12q47 0 75.5-32t28.5-77q0-55-56-99.5t-142-67.5-182-23q-68 0-132 15.5t-119.5 47-89 87-33.5 128.5q0 61 19 106.5t56 75.5 80 48.5 103 32.5l146 36q90 22 112 36 32 20 32 60 0 39-40 64.5t-105 25.5q-51 0-91.5-16t-65-38.5-45.5-45-46-38.5-54-16q-50 0-75.5 30t-25.5 75q0 92 122 157.5t291 65.5q73 0 140-18.5t122.5-53.5 88.5-93.5 33-131.5zM1536 1280q0 159-112.5 271.5t-271.5 112.5q-130 0-234-80-77 16-150 16-143 0-273.5-55.5t-225-150-150-225-55.5-273.5q0-73 16-150-80-104-80-234 0-159 112.5-271.5t271.5-112.5q130 0 234 80 77-16 150-16 143 0 273.5 55.5t225 150 150 225 55.5 273.5q0 73-16 150 80 104 80 234z"
    }
  }]
};
exports.skype = skype;
var foursquare = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1000 434l37-194q5-23-9-40t-35-17h-712q-23 0-38.5 17t-15.5 37v1101q0 7 6 1l291-352q23-26 38-33.5t48-7.5h239q22 0 37-14.5t18-29.5q24-130 37-191 4-21-11.5-40t-36.5-19h-294q-29 0-48-19t-19-48v-42q0-29 19-47.5t48-18.5h346q18 0 35-13.5t20-29.5zM1227 212q-15 73-53.5 266.5t-69.5 350-35 173.5q-6 22-9 32.5t-14 32.5-24.5 33-38.5 21-58 10h-271q-13 0-22 10-8 9-426 494-22 25-58.5 28.5t-48.5-5.5q-55-22-55-98v-1410q0-55 38-102.5t120-47.5h888q95 0 127 53t10 159zM1227 212l-158 790q4-17 35-173.5t69.5-350 53.5-266.5z"
    }
  }]
};
exports.foursquare = foursquare;
var trello = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 1344v-1024q0-14-9-23t-23-9h-480q-14 0-23 9t-9 23v1024q0 14 9 23t23 9h480q14 0 23-9t9-23zM1376 960v-640q0-14-9-23t-23-9h-480q-14 0-23 9t-9 23v640q0 14 9 23t23 9h480q14 0 23-9t9-23zM1536 192v1408q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-1408q0-26 19-45t45-19h1408q26 0 45 19t19 45z"
    }
  }]
};
exports.trello = trello;
var female = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1056q0 40-28 68t-68 28q-51 0-80-43l-227-341h-45v132l247 411q9 15 9 33 0 26-19 45t-45 19h-192v272q0 46-33 79t-79 33h-160q-46 0-79-33t-33-79v-272h-192q-26 0-45-19t-19-45q0-18 9-33l247-411v-132h-45l-227 341q-29 43-80 43-40 0-68-28t-28-68q0-29 16-53l256-384q73-107 176-107h384q103 0 176 107l256 384q16 24 16 53zM864 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"
    }
  }]
};
exports.female = female;
var male = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 704v416q0 40-28 68t-68 28-68-28-28-68v-352h-64v912q0 46-33 79t-79 33-79-33-33-79v-464h-64v464q0 46-33 79t-79 33-79-33-33-79v-912h-64v352q0 40-28 68t-68 28-68-28-28-68v-416q0-80 56-136t136-56h640q80 0 136 56t56 136zM736 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"
    }
  }]
};
exports.male = male;
var gittip = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M773 1302l350-473q16-22 24.5-59t-6-85-61.5-79q-40-26-83-25.5t-73.5 17.5-54.5 45q-36 40-96 40-59 0-95-40-24-28-54.5-45t-73.5-17.5-84 25.5q-46 31-60.5 79t-6 85 24.5 59zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.gittip = gittip;
var gratipay = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M773 1302l350-473q16-22 24.5-59t-6-85-61.5-79q-40-26-83-25.5t-73.5 17.5-54.5 45q-36 40-96 40-59 0-95-40-24-28-54.5-45t-73.5-17.5-84 25.5q-46 31-60.5 79t-6 85 24.5 59zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.gratipay = gratipay;
var sunO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1472 896q0-117-45.5-223.5t-123-184-184-123-223.5-45.5-223.5 45.5-184 123-123 184-45.5 223.5 45.5 223.5 123 184 184 123 223.5 45.5 223.5-45.5 184-123 123-184 45.5-223.5zM1748 1173q-4 15-20 20l-292 96v306q0 16-13 26-15 10-29 4l-292-94-180 248q-10 13-26 13t-26-13l-180-248-292 94q-14 6-29-4-13-10-13-26v-306l-292-96q-16-5-20-20-5-17 4-29l180-248-180-248q-9-13-4-29 4-15 20-20l292-96v-306q0-16 13-26 15-10 29-4l292 94 180-248q9-12 26-12t26 12l180 248 292-94q14-6 29 4 13 10 13 26v306l292 96q16 5 20 20 5 16-4 29l-180 248 180 248q9 12 4 29z"
    }
  }]
};
exports.sunO = sunO;
var moonO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1262 1303q-54 9-110 9-182 0-337-90t-245-245-90-337q0-192 104-357-201 60-328.5 229t-127.5 384q0 130 51 248.5t136.5 204 204 136.5 248.5 51q144 0 273.5-61.5t220.5-171.5zM1465 1218q-94 203-283.5 324.5t-413.5 121.5q-156 0-298-61t-245-164-164-245-61-298q0-153 57.5-292.5t156-241.5 235.5-164.5 290-68.5q44-2 61 39 18 41-15 72-86 78-131.5 181.5t-45.5 218.5q0 148 73 273t198 198 273 73q118 0 228-51 41-18 72 13 14 14 17.5 34t-4.5 38z"
    }
  }]
};
exports.moonO = moonO;
var archive = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 832q0-26-19-45t-45-19h-256q-26 0-45 19t-19 45 19 45 45 19h256q26 0 45-19t19-45zM1664 640v960q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-960q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1728 192v256q0 26-19 45t-45 19h-1536q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h1536q26 0 45 19t19 45z"
    }
  }]
};
exports.archive = archive;
var bug = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1632 960q0 26-19 45t-45 19h-224q0 171-67 290l208 209q19 19 19 45t-19 45q-18 19-45 19t-45-19l-198-197q-5 5-15 13t-42 28.5-65 36.5-82 29-97 13v-896h-128v896q-51 0-101.5-13.5t-87-33-66-39-43.5-32.5l-15-14-183 207q-20 21-48 21-24 0-43-16-19-18-20.5-44.5t15.5-46.5l202-227q-58-114-58-274h-224q-26 0-45-19t-19-45 19-45 45-19h224v-294l-173-173q-19-19-19-45t19-45 45-19 45 19l173 173h844l173-173q19-19 45-19t45 19 19 45-19 45l-173 173v294h224q26 0 45 19t19 45zM1152 384h-640q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5z"
    }
  }]
};
exports.bug = bug;
var vk = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1917 520q23 64-150 294-24 32-65 85-40 51-55 72t-30.5 49.5-12 42 13 34.5 32.5 43 57 53q4 2 5 4 141 131 191 221 3 5 6.5 12.5t7 26.5-0.5 34-25 27.5-59 12.5l-256 4q-24 5-56-5t-52-22l-20-12q-30-21-70-64t-68.5-77.5-61-58-56.5-15.5q-3 1-8 3.5t-17 14.5-21.5 29.5-17 52-6.5 77.5q0 15-3.5 27.5t-7.5 18.5l-4 5q-18 19-53 22h-115q-71 4-146-16.5t-131.5-53-103-66-70.5-57.5l-25-24q-10-10-27.5-30t-71.5-91-106-151-122.5-211-130.5-272q-6-16-6-27t3-16l4-6q15-19 57-19l274-2q12 2 23 6.5t16 8.5l5 3q16 11 24 32 20 50 46 103.5t41 81.5l16 29q29 60 56 104t48.5 68.5 41.5 38.5 34 14 27-5q2-1 5-5t12-22 13.5-47 9.5-81 0-125q-2-40-9-73t-14-46l-6-12q-25-34-85-43-13-2 5-24 16-19 38-30 53-26 239-24 82 1 135 13 20 5 33.5 13.5t20.5 24 10.5 32 3.5 45.5-1 55-2.5 70.5-1.5 82.5q0 11-1 42t-0.5 48 3.5 40.5 11.5 39 22.5 24.5q8 2 17 4t26-11 38-34.5 52-67 68-107.5q60-104 107-225 4-10 10-17.5t11-10.5l4-3 5-2.5t13-3 20-0.5l288-2q39-5 64 2.5t31 16.5z"
    }
  }]
};
exports.vk = vk;
var weibo = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M675 1284q21-34 11-69t-45-50q-34-14-73-1t-60 46q-22 34-13 68.5t43 50.5 74.5 2.5 62.5-47.5zM769 1163q8-13 3.5-26.5t-17.5-18.5q-14-5-28.5 0.5t-21.5 18.5q-17 31 13 45 14 5 29-0.5t22-18.5zM943 1270q-45 102-158 150t-224 12q-107-34-147.5-126.5t6.5-187.5q47-93 151.5-139t210.5-19q111 29 158.5 119.5t2.5 190.5zM1255 1110q-9-96-89-170t-208.5-109-274.5-21q-223 23-369.5 141.5t-132.5 264.5q9 96 89 170t208.5 109 274.5 21q223-23 369.5-141.5t132.5-264.5zM1563 1114q0 68-37 139.5t-109 137-168.5 117.5-226 83-270.5 31-275-33.5-240.5-93-171.5-151-65-199.5q0-115 69.5-245t197.5-258q169-169 341.5-236t246.5 7q65 64 20 209-4 14-1 20t10 7 14.5-0.5 13.5-3.5l6-2q139-59 246-59t153 61q45 63 0 178-2 13-4.5 20t4.5 12.5 12 7.5 17 6q57 18 103 47t80 81.5 34 116.5zM1489 490q42 47 54.5 108.5t-6.5 117.5q-8 23-29.5 34t-44.5 4q-23-8-34-29.5t-4-44.5q20-63-24-111t-107-35q-24 5-45-8t-25-37q-5-24 8-44.5t37-25.5q60-13 119 5.5t101 65.5zM1670 327q87 96 112.5 222.5t-13.5 241.5q-9 27-34 40t-52 4-40-34-5-52q28-82 10-172t-80-158q-62-69-148-95.5t-173-8.5q-28 6-52-9.5t-30-43.5 9.5-51.5 43.5-29.5q123-26 244 11.5t208 134.5z"
    }
  }]
};
exports.weibo = weibo;
var renren = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1133 1570q-171 94-368 94-196 0-367-94 138-87 235.5-211t131.5-268q35 144 132.5 268t235.5 211zM638 142v485q0 252-126.5 459.5t-330.5 306.5q-181-215-181-495 0-187 83.5-349.5t229.5-269.5 325-137zM1536 898q0 280-181 495-204-99-330.5-306.5t-126.5-459.5v-485q179 30 325 137t229.5 269.5 83.5 349.5z"
    }
  }]
};
exports.renren = renren;
var pagelines = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1402 1103q-32 80-76 138t-91 88.5-99 46.5-101.5 14.5-96.5-8.5-86.5-22-69.5-27.5-46-22.5l-17-10q-113 228-289.5 359.5t-384.5 132.5q-19 0-32-13t-13-32 13-31.5 32-12.5q173-1 322.5-107.5t251.5-294.5q-36 14-72 23t-83 13-91-2.5-93-28.5-92-59-84.5-100-74.5-146q114-47 214-57t167.5 7.5 124.5 56.5 88.5 77 56.5 82q53-131 79-291-7 1-18 2.5t-46.5 2.5-69.5-0.5-81.5-10-88.5-23-84-42.5-75-65-54.5-94.5-28.5-127.5q70-28 133.5-36.5t112.5 1 92 30 73.5 50 56 61 42 63 27.5 56 16 39.5l4 16q12-122 12-195-8-6-21.5-16t-49-44.5-63.5-71.5-54-93-33-112.5 12-127 70-138.5q73 25 127.5 61.5t84.5 76.5 48 85 20.5 89-0.5 85.5-13 76.5-19 62-17 42l-7 15q1 4 1 50t-1 72q3-7 10-18.5t30.5-43 50.5-58 71-55.5 91.5-44.5 112-14.5 132.5 24q-2 78-21.5 141.5t-50 104.5-69.5 71.5-81.5 45.5-84.5 24-80 9.5-67.5-1-46.5-4.5l-17-3q-23 147-73 283 6-7 18-18.5t49.5-41 77.5-52.5 99.5-42 117.5-20 129 23.5 137 77.5z"
    }
  }]
};
exports.pagelines = pagelines;
var stackExchange = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1259 1253v66q0 85-57.5 144.5t-138.5 59.5h-57l-260 269v-269h-529q-81 0-138.5-59.5t-57.5-144.5v-66h1238zM1259 927v255h-1238v-255h1238zM1259 599v255h-1238v-255h1238zM1259 459v67h-1238v-67q0-84 57.5-143.5t138.5-59.5h846q81 0 138.5 59.5t57.5 143.5z"
    }
  }]
};
exports.stackExchange = stackExchange;
var arrowCircleORight = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 896q0 14-9 23l-320 320q-9 9-23 9-13 0-22.5-9.5t-9.5-22.5v-192h-352q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h352v-192q0-14 9-23t23-9q12 0 24 10l319 319q9 9 9 23zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleORight = arrowCircleORight;
var arrowCircleOLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 800v192q0 13-9.5 22.5t-22.5 9.5h-352v192q0 14-9 23t-23 9q-12 0-24-10l-319-319q-9-9-9-23t9-23l320-320q9-9 23-9 13 0 22.5 9.5t9.5 22.5v192h352q13 0 22.5 9.5t9.5 22.5zM1312 896q0-148-73-273t-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.arrowCircleOLeft = arrowCircleOLeft;
var caretSquareOLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 576v640q0 26-19 45t-45 19q-20 0-37-12l-448-320q-27-19-27-52t27-52l448-320q17-12 37-12 26 0 45 19t19 45zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.caretSquareOLeft = caretSquareOLeft;
var toggleLeft = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 576v640q0 26-19 45t-45 19q-20 0-37-12l-448-320q-27-19-27-52t27-52l448-320q17-12 37-12 26 0 45 19t19 45zM1280 1376v-960q0-13-9.5-22.5t-22.5-9.5h-960q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.toggleLeft = toggleLeft;
var dotCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 896q0 106-75 181t-181 75-181-75-75-181 75-181 181-75 181 75 75 181zM768 352q-148 0-273 73t-198 198-73 273 73 273 198 198 273 73 273-73 198-198 73-273-73-273-198-198-273-73zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.dotCircleO = dotCircleO;
var wheelchair = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1023 1187l102 204q-58 179-210 290t-339 111q-156 0-288.5-77.5t-210-210-77.5-288.5q0-181 104.5-330t274.5-211l17 131q-122 54-195 165.5t-73 244.5q0 185 131.5 316.5t316.5 131.5q126 0 232.5-65t165-175.5 49.5-236.5zM1571 1287l58 114-256 128q-13 7-29 7-40 0-57-35l-239-477h-472q-24 0-42.5-16.5t-21.5-40.5l-96-779q-2-17 6-42 14-51 57-82.5t97-31.5q66 0 113 47t47 113q0 69-52 117.5t-120 41.5l37 289h423v128h-407l16 128h455q40 0 57 35l228 455z"
    }
  }]
};
exports.wheelchair = wheelchair;
var vimeoSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1292 638q10-216-161-222-231-8-312 261 44-19 82-19 85 0 74 96-4 57-74 167t-105 110q-43 0-82-169-13-54-45-255-30-189-160-177-59 7-164 100l-81 72-81 72 52 67q76-52 87-52 57 0 107 179 15 55 45 164.5t45 164.5q68 179 164 179 157 0 383-294 220-283 226-444zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.vimeoSquare = vimeoSquare;
var tryIcon = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 832q0 191-94.5 353t-256.5 256.5-353 94.5h-160q-14 0-23-9t-9-23v-611l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-93l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-250q0-14 9-23t23-9h160q14 0 23 9t9 23v181l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v93l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v487q188-13 318-151t130-328q0-14 9-23t23-9h160q14 0 23 9t9 23z"
    }
  }]
};
exports.tryIcon = tryIcon;
var turkishLira = {
  "viewBox": "0 0 1152 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 832q0 191-94.5 353t-256.5 256.5-353 94.5h-160q-14 0-23-9t-9-23v-611l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-93l-215 66q-3 1-9 1-10 0-19-6-13-10-13-26v-128q0-23 23-31l233-71v-250q0-14 9-23t23-9h160q14 0 23 9t9 23v181l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v93l375-116q15-5 28 5t13 26v128q0 23-23 31l-393 121v487q188-13 318-151t130-328q0-14 9-23t23-9h160q14 0 23 9t9 23z"
    }
  }]
};
exports.turkishLira = turkishLira;
var plusSquareO = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 800v64q0 14-9 23t-23 9h-352v352q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-352h-352q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-352q0-14 9-23t23-9h64q14 0 23 9t9 23v352h352q14 0 23 9t9 23zM1280 1248v-832q0-66-47-113t-113-47h-832q-66 0-113 47t-47 113v832q0 66 47 113t113 47h832q66 0 113-47t47-113zM1408 416v832q0 119-84.5 203.5t-203.5 84.5h-832q-119 0-203.5-84.5t-84.5-203.5v-832q0-119 84.5-203.5t203.5-84.5h832q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.plusSquareO = plusSquareO;
var spaceShuttle = {
  "viewBox": "0 0 2176 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M620 1120q-110 64-268 64h-128v-64h-64q-13 0-22.5-23.5t-9.5-56.5q0-24 7-49-58-2-96.5-10.5t-38.5-20.5 38.5-20.5 96.5-10.5q-7-25-7-49 0-33 9.5-56.5t22.5-23.5h64v-64h128q158 0 268 64h1113q42 7 106.5 18t80.5 14q89 15 150 40.5t83.5 47.5 22.5 40-22.5 40-83.5 47.5-150 40.5q-16 3-80.5 14t-106.5 18h-1113zM1739 868q53 36 53 92t-53 92l81 30q68-48 68-122t-68-122zM625 1136h1015q-217 38-456 80-57 0-113 24t-83 48l-28 24-288 288q-26 26-70.5 45t-89.5 19h-96l-93-464h29q157 0 273-64zM352 720h-29l93-464h96q46 0 90 19t70 45l288 288q4 4 11 10.5t30.5 23 48.5 29 61.5 23 72.5 10.5l456 80h-1015q-116-64-273-64z"
    }
  }]
};
exports.spaceShuttle = spaceShuttle;
var slack = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1519 776q62 0 103.5 40.5t41.5 101.5q0 97-93 130l-172 59 56 167q7 21 7 47 0 59-42 102t-101 43q-47 0-85.5-27t-53.5-72l-55-165-310 106 55 164q8 24 8 47 0 59-42 102t-102 43q-47 0-85-27t-53-72l-55-163-153 53q-29 9-50 9-61 0-101.5-40t-40.5-101q0-47 27.5-85t71.5-53l156-53-105-313-156 54q-26 8-48 8-60 0-101-40.5t-41-100.5q0-47 27.5-85t71.5-53l157-53-53-159q-8-24-8-47 0-60 42-102.5t102-42.5q47 0 85 27t53 72l54 160 310-105-54-160q-8-24-8-47 0-59 42.5-102t101.5-43q47 0 85.5 27.5t53.5 71.5l53 161 162-55q21-6 43-6 60 0 102.5 39.5t42.5 98.5q0 45-30 81.5t-74 51.5l-157 54 105 316 164-56q24-8 46-8zM725 1038l310-105-105-315-310 107z"
    }
  }]
};
exports.slack = slack;
var envelopeSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM1280 1184v-436q-31 35-64 55-34 22-132.5 85t-151.5 99q-98 69-164 69v0 0q-66 0-164-69-47-32-142-92.5t-142-92.5q-12-8-33-27t-31-27v436q0 40 28 68t68 28h832q40 0 68-28t28-68zM1280 611q0-41-27.5-70t-68.5-29h-832q-40 0-68 28t-28 68q0 37 30.5 76.5t67.5 64.5q47 32 137.5 89t129.5 83q3 2 17 11.5t21 14 21 13 23.5 13 21.5 9.5 22.5 7.5 20.5 2.5 20.5-2.5 22.5-7.5 21.5-9.5 23.5-13 21-13 21-14 17-11.5l267-174q35-23 66.5-62.5t31.5-73.5z"
    }
  }]
};
exports.envelopeSquare = envelopeSquare;
var wordpress = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M127 896q0-163 67-313l367 1005q-196-95-315-281t-119-411zM1415 857q0 19-2.5 38.5t-10 49.5-11.5 44-17.5 59-17.5 58l-76 256-278-826q46-3 88-8 19-2 26-18.5t-2.5-31-28.5-13.5l-205 10q-75-1-202-10-12-1-20.5 5t-11.5 15-1.5 18.5 9 16.5 19.5 8l80 8 120 328-168 504-280-832q46-3 88-8 19-2 26-18.5t-2.5-31-28.5-13.5l-205 10q-7 0-23-0.5t-26-0.5q105-160 274.5-253.5t367.5-93.5q147 0 280.5 53t238.5 149h-10q-55 0-92 40.5t-37 95.5q0 12 2 24t4 21.5 8 23 9 21 12 22.5 12.5 21 14.5 24 14 23q63 107 63 212zM909 963l237 647q1 6 5 11-126 44-255 44-112 0-217-32zM1570 527q95 174 95 369 0 209-104 385.5t-279 278.5l235-678q59-169 59-276 0-42-6-79zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 1751q173 0 331.5-68t273-182.5 182.5-273 68-331.5-68-331.5-182.5-273-273-182.5-331.5-68-331.5 68-273 182.5-182.5 273-68 331.5 68 331.5 182.5 273 273 182.5 331.5 68z"
    }
  }]
};
exports.wordpress = wordpress;
var openid = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1086 0v1536l-272 128q-228-20-414-102t-293-208.5-107-272.5q0-140 100.5-263.5t275-205.5 391.5-108v172q-217 38-356.5 150t-139.5 255q0 152 154.5 267t388.5 145v-1360zM1755 582l37 390-525-114 147-83q-119-70-280-99v-172q277 33 481 157z"
    }
  }]
};
exports.openid = openid;
var bank = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"
    }
  }]
};
exports.bank = bank;
var institution = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"
    }
  }]
};
exports.institution = institution;
var university = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M960 0l960 384v128h-128q0 26-20.5 45t-48.5 19h-1526q-28 0-48.5-19t-20.5-45h-128v-128zM256 640h256v768h128v-768h256v768h128v-768h256v768h128v-768h256v768h59q28 0 48.5 19t20.5 45v64h-1664v-64q0-26 20.5-45t48.5-19h59v-768zM1851 1600q28 0 48.5 19t20.5 45v128h-1920v-128q0-26 20.5-45t48.5-19h1782z"
    }
  }]
};
exports.university = university;
var graduationCap = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zM2304 512q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z"
    }
  }]
};
exports.graduationCap = graduationCap;
var mortarBoard = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1774 836l18 316q4 69-82 128t-235 93.5-323 34.5-323-34.5-235-93.5-82-128l18-316 574 181q22 7 48 7t48-7zM2304 512q0 23-22 31l-1120 352q-4 1-10 1t-10-1l-652-206q-43 34-71 111.5t-34 178.5q63 36 63 109 0 69-58 107l58 433q2 14-8 25-9 11-24 11h-192q-15 0-24-11-10-11-8-25l58-433q-58-38-58-107 0-73 65-111 11-207 98-330l-333-104q-22-8-22-31t22-31l1120-352q4-1 10-1t10 1l1120 352q22 8 22 31z"
    }
  }]
};
exports.mortarBoard = mortarBoard;
var yahoo = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M859 957l13 707q-62-11-105-11-41 0-105 11l13-707q-40-69-168.5-295.5t-216.5-374.5-181-287q58 15 108 15 44 0 111-15 63 111 133.5 229.5t167 276.5 138.5 227q37-61 109.5-177.5t117.5-190 105-176 107-189.5q54 14 107 14 56 0 114-14v0q-28 39-60 88.5t-49.5 78.5-56.5 96-49 84q-146 248-353 610z"
    }
  }]
};
exports.yahoo = yahoo;
var google = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 786h725q12 67 12 128 0 217-91 387.5t-259.5 266.5-386.5 96q-157 0-299-60.5t-245-163.5-163.5-245-60.5-299 60.5-299 163.5-245 245-163.5 299-60.5q300 0 515 201l-209 201q-123-119-306-119-129 0-238.5 65t-173.5 176.5-64 243.5 64 243.5 173.5 176.5 238.5 65q87 0 160-24t120-60 82-82 51.5-87 22.5-78h-436v-264z"
    }
  }]
};
exports.google = google;
var reddit = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1095 1167q16 16 0 31-62 62-199 62t-199-62q-16-15 0-31 6-6 15-6t15 6q48 49 169 49 120 0 169-49 6-6 15-6t15 6zM788 986q0 37-26 63t-63 26-63.5-26-26.5-63q0-38 26.5-64t63.5-26 63 26.5 26 63.5zM1183 986q0 37-26.5 63t-63.5 26-63-26-26-63 26-63.5 63-26.5 63.5 26 26.5 64zM1434 866q0-49-35-84t-85-35-86 36q-130-90-311-96l63-283 200 45q0 37 26 63t63 26 63.5-26.5 26.5-63.5-26.5-63.5-63.5-26.5q-54 0-80 50l-221-49q-19-5-25 16l-69 312q-180 7-309 97-35-37-87-37-50 0-85 35t-35 84q0 35 18.5 64t49.5 44q-6 27-6 56 0 142 140 243t337 101q198 0 338-101t140-243q0-32-7-57 30-15 48-43.5t18-63.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.reddit = reddit;
var redditSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M939 1129q13 13 0 26-53 53-171 53t-171-53q-13-13 0-26 5-6 13-6t13 6q42 42 145 42t145-42q5-6 13-6t13 6zM676 973q0 31-23 54t-54 23-54-23-23-54q0-32 22.5-54.5t54.5-22.5 54.5 22.5 22.5 54.5zM1014 973q0 31-23 54t-54 23-54-23-23-54q0-32 22.5-54.5t54.5-22.5 54.5 22.5 22.5 54.5zM1229 870q0-42-30-72t-73-30q-42 0-73 31-113-78-267-82l54-243 171 39q1 32 23.5 54t53.5 22q32 0 54.5-22.5t22.5-54.5-22.5-54.5-54.5-22.5q-48 0-69 43l-189-42q-17-5-21 13l-60 268q-154 6-265 83-30-32-74-32-43 0-73 30t-30 72q0 30 16 55t42 38q-5 25-5 48 0 122 120 208.5t289 86.5q170 0 290-86.5t120-208.5q0-25-6-49 25-13 40.5-37.5t15.5-54.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.redditSquare = redditSquare;
var stumbleuponCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M866 839l90-27v-62q0-79-58-135t-138-56-138 55.5-58 134.5v283q0 20-14 33.5t-33 13.5-32.5-13.5-13.5-33.5v-120h-151v122q0 82 57.5 139t139.5 57q81 0 138.5-56.5t57.5-136.5v-280q0-19 13.5-33t33.5-14q19 0 32.5 14t13.5 33v54zM1199 1034v-122h-150v126q0 20-13.5 33.5t-33.5 13.5q-19 0-32.5-14t-13.5-33v-123l-90 26-60-28v123q0 80 58 137t139 57 138.5-57 57.5-139zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.stumbleuponCircle = stumbleuponCircle;
var stumbleupon = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1062 712v-118q0-42-30-72t-72-30-72 30-30 72v612q0 175-126 299t-303 124q-178 0-303.5-125.5t-125.5-303.5v-266h328v262q0 43 30 72.5t72 29.5 72-29.5 30-72.5v-620q0-171 126.5-292t301.5-121q176 0 302 122t126 294v136l-195 58zM1592 934h328v266q0 178-125.5 303.5t-303.5 125.5q-177 0-303-124.5t-126-300.5v-268l131 61 195-58v270q0 42 30 71.5t72 29.5 72-29.5 30-71.5v-275z"
    }
  }]
};
exports.stumbleupon = stumbleupon;
var delicious = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1472 1376v-480h-704v-704h-480q-93 0-158.5 65.5t-65.5 158.5v480h704v704h480q93 0 158.5-65.5t65.5-158.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.delicious = delicious;
var digg = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M328 282h204v983h-532v-697h328v-286zM328 1101v-369h-123v369h123zM614 568v697h205v-697h-205zM614 282v204h205v-204h-205zM901 568h533v942h-533v-163h328v-82h-328v-697zM1229 1101v-369h-123v369h123zM1516 568h532v942h-532v-163h327v-82h-327v-697zM1843 1101v-369h-123v369h123z"
    }
  }]
};
exports.digg = digg;
var piedPiperPp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1046 1020q0 64-38 109t-91 45q-43 0-70-15v-277q28-17 70-17 53 0 91 45.5t38 109.5zM703 592q0 64-38 109.5t-91 45.5q-43 0-70-15v-277q28-17 70-17 53 0 91 45t38 109zM1265 1023q0-134-88-229t-213-95q-20 0-39 3-23 78-78 136-87 95-211 101v636l211-41v-206q51 19 117 19 125 0 213-95t88-229zM922 596q0-134-88.5-229t-213.5-95q-74 0-141 36h-186v840l211-41v-206q55 19 116 19 125 0 213.5-95t88.5-229zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.piedPiperPp = piedPiperPp;
var piedPiperAlt = {
  "viewBox": "0 0 2038 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1222 929q75-3 143.5 20.5t118 58.5 101 94.5 84 108 75.5 120.5q33 56 78.5 109t75.5 80.5 99 88.5q-48 30-108.5 57.5t-138.5 59-114 47.5q-44-37-74-115t-43.5-164.5-33-180.5-42.5-168.5-72.5-123-122.5-48.5l-10 2-6 4q4 5 13 14 6 5 28 23.5t25.5 22 19 18 18 20.5 11.5 21 10.5 27.5 4.5 31 4 40.5l1 33q1 26-2.5 57.5t-7.5 52-12.5 58.5-11.5 53q-35-1-101 9.5t-98 10.5q-39 0-72-10-2-16-2-47 0-74 3-96 2-13 31.5-41.5t57-59 26.5-51.5q-24-2-43 24-36 53-111.5 99.5t-136.5 46.5q-25 0-75.5-63t-106.5-139.5-84-96.5q-6-4-27-30-482 112-513 112-16 0-28-11t-12-27q0-15 8.5-26.5t22.5-14.5l486-106q-8-14-8-25t5.5-17.5 16-11.5 20-7 23-4.5 18.5-4.5q4-1 15.5-7.5t17.5-6.5q15 0 28 16t20 33q163-37 172-37 17 0 29.5 11t12.5 28q0 15-8.5 26t-23.5 14l-182 40-1 16q-1 26 81.5 117.5t104.5 91.5q47 0 119-80t72-129q0-36-23.5-53t-51-18.5-51-11.5-23.5-34q0-16 10-34l-68-19q43-44 43-117 0-26-5-58 82-16 144-16 44 0 71.5 1.5t48.5 8.5 31 13.5 20.5 24.5 15.5 33.5 17 47.5 24 60l50-25q-3 40-23 60t-42.5 21-40 6.5-16.5 20.5zM1282 694q-5-5-13.5-15.5t-12-14.5-10.5-11.5-10-10.5l-8-8t-8.5-7.5-8-5-8.5-4.5q-7-3-14.5-5t-20.5-2.5-22-0.5h-32.5-37.5q-126 0-217 43 16-30 36-46.5t54-29.5 65.5-36 46-36.5 50-55 43.5-50.5q12 9 28 31.5t32 36.5 38 13l12-1v76l22 1q247-95 371-190 28-21 50-39t42.5-37.5 33-31 29.5-34 24-31 24.5-37 23-38 27-47.5 29.5-53l7-9q-2 53-43 139-79 165-205 264t-306 142q-14 3-42 7.5t-50 9.5-39 14q3 19 24.5 46t21.5 34q0 11-26 30zM1061 1615q39-26 131.5-47.5t146.5-21.5q9 0 22.5 15.5t28 42.5 26 50 24 51 14.5 33q-121 45-244 45-61 0-125-11zM822 968l48-12 109 177-73 48zM1323 1485q3 15 3 16 0 7-17.5 14.5t-46 13-54 9.5-53.5 7.5-32 4.5l-7-43q21-2 60.5-8.5t72-10 60.5-3.5h14zM866 857l-96 20-6-17q10-1 32.5-7t34.5-6q19 0 35 10zM1061 1491h31l10 83-41 12v-95zM1950 1v-1 1zM1950 1l-1 5-2 2 1-3zM1950 1l1-1z"
    }
  }]
};
exports.piedPiperAlt = piedPiperAlt;
var drupal = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1167 1586q-5-19-24-5-30 22-87 39t-131 17q-129 0-193-49-5-4-13-4-11 0-26 12-7 6-7.5 16t7.5 20q34 32 87.5 46t102.5 12.5 99-4.5q41-4 84.5-20.5t65-30 28.5-20.5q12-12 7-29zM1128 1471q-19-47-39-61-23-15-76-15-47 0-71 10-29 12-78 56-26 24-12 44 9 8 17.5 4.5t31.5-23.5q3-2 10.5-8.5t10.5-8.5 10-7 11.5-7 12.5-5 15-4.5 16.5-2.5 20.5-1q27 0 44.5 7.5t23 14.5 13.5 22q10 17 12.5 20t12.5-1q23-12 14-34zM1483 1190q0-22-5-44.5t-16.5-45-34-36.5-52.5-14q-33 0-97 41.5t-129 83.5-101 42q-27 1-63.5-19t-76-49-83.5-58-100-49-111-19q-115 1-197 78.5t-84 178.5q-2 112 74 164 29 20 62.5 28.5t103.5 8.5q57 0 132-32.5t134-71 120-70.5 93-31q26 1 65 31.5t71.5 67 68 67.5 55.5 32q35 3 58.5-14t55.5-63q28-41 42.5-101t14.5-106zM1536 1030q0 164-62 304.5t-166 236-242.5 149.5-290.5 54-293-57.5-247.5-157-170.5-241.5-64-302q0-89 19.5-172.5t49-145.5 70.5-118.5 78.5-94 78.5-69.5 64.5-46.5 42.5-24.5q14-8 51-26.5t54.5-28.5 48-30 60.5-44q36-28 58-72.5t30-125.5q129 155 186 193 44 29 130 68t129 66q21 13 39 25t60.5 46.5 76 70.5 75 95 69 122 47 148.5 19.5 177.5z"
    }
  }]
};
exports.drupal = drupal;
var joomla = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1070 1073l-160 160-151 152-30 30q-65 64-151.5 87t-171.5 2q-16 70-72 115t-129 45q-85 0-145-60.5t-60-145.5q0-72 44.5-128t113.5-72q-22-86 1-173t88-152l12-12 151 152-11 11q-37 37-37 89t37 90q37 37 89 37t89-37l30-30 151-152 161-160zM729 391l12 12-152 152-12-12q-37-37-89-37t-89 37-37 89.5 37 89.5l29 29 152 152 160 160-151 152-161-160-151-152-30-30q-68-67-90-159.5t5-179.5q-70-15-115-71t-45-129q0-85 60-145.5t145-60.5q76 0 133.5 49t69.5 123q84-20 169.5 3.5t149.5 87.5zM1536 1458q0 85-60 145.5t-145 60.5q-74 0-131-47t-71-118q-86 28-179.5 6t-161.5-90l-11-12 151-152 12 12q37 37 89 37t89-37 37-89-37-89l-30-30-152-152-160-160 152-152 160 160 152 152 29 30q64 64 87.5 150.5t2.5 171.5q76 11 126.5 68.5t50.5 134.5zM1534 334q0 77-51 135t-127 69q26 85 3 176.5t-90 158.5l-12 12-151-152 12-12q37-37 37-89t-37-89-89-37-89 37l-30 30-152 152-160 160-152-152 161-160 152-152 29-30q67-67 159-89.5t178 3.5q11-75 68.5-126t135.5-51q85 0 145 60.5t60 145.5z"
    }
  }]
};
exports.joomla = joomla;
var language = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M654 1078q-1 3-12.5-0.5t-31.5-11.5l-20-9q-44-20-87-49-7-5-41-31.5t-38-28.5q-67 103-134 181-81 95-105 110-4 2-19.5 4t-18.5 0q6-4 82-92 21-24 85.5-115t78.5-118q17-30 51-98.5t36-77.5q-8-1-110 33-8 2-27.5 7.5t-34.5 9.5-17 5q-2 2-2 10.5t-1 9.5q-5 10-31 15-23 7-47 0-18-4-28-21-4-6-5-23 6-2 24.5-5t29.5-6q58-16 105-32 100-35 102-35 10-2 43-19.5t44-21.5q9-3 21.5-8t14.5-5.5 6 0.5q2 12-1 33 0 2-12.5 27t-26.5 53.5-17 33.5q-25 50-77 131l64 28q12 6 74.5 32t67.5 28q4 1 10.5 25.5t4.5 30.5zM449 592q3 15-4 28-12 23-50 38-30 12-60 12-26-3-49-26-14-15-18-41l1-3q3 3 19.5 5t26.5 0 58-16q36-12 55-14 17 0 21 17zM1147 721l63 227-139-42zM39 1521l694-232v-1032l-694 233v1031zM1280 1204l102 31-181-657-100-31-216 536 102 31 45-110 211 65zM777 242l573 184v-380zM1088 1565l158 13-54 160-40-66q-130 83-276 108-58 12-91 12h-84q-79 0-199.5-39t-183.5-85q-8-7-8-16 0-8 5-13.5t13-5.5q4 0 18 7.5t30.5 16.5 20.5 11q73 37 159.5 61.5t157.5 24.5q95 0 167-14.5t157-50.5q15-7 30.5-15.5t34-19 28.5-16.5zM1536 486v1079l-774-246q-14 6-375 127.5t-368 121.5q-13 0-18-13 0-1-1-3v-1078q3-9 4-10 5-6 20-11 107-36 149-50v-384l558 198q2 0 160.5-55t316-108.5 161.5-53.5q20 0 20 21v418z"
    }
  }]
};
exports.language = language;
var fax = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M288 384q66 0 113 47t47 113v1088q0 66-47 113t-113 47h-128q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h128zM1664 547q58 34 93 93t35 128v768q0 106-75 181t-181 75h-864q-66 0-113-47t-47-113v-1536q0-40 28-68t68-28h672q40 0 88 20t76 48l152 152q28 28 48 76t20 88v163zM928 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM928 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM928 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1184 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1536v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1280v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1440 1024v-128q0-14-9-23t-23-9h-128q-14 0-23 9t-9 23v128q0 14 9 23t23 9h128q14 0 23-9t9-23zM1536 640v-256h-160q-40 0-68-28t-28-68v-160h-640v512h896z"
    }
  }]
};
exports.fax = fax;
var building = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1344 0q26 0 45 19t19 45v1664q0 26-19 45t-45 19h-1280q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h1280zM512 288v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 544v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 800v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM512 1056v64q0 14 9 23t23 9h64q14 0 23-9t9-23v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM384 1376v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM384 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 1632v-192q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v192q0 14 9 23t23 9h320q14 0 23-9t9-23zM896 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM896 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 1376v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 1120v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 864v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 608v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23zM1152 352v-64q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v64q0 14 9 23t23 9h64q14 0 23-9t9-23z"
    }
  }]
};
exports.building = building;
var child = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1188 548l-292 292v824q0 46-33 79t-79 33-79-33-33-79v-384h-64v384q0 46-33 79t-79 33-79-33-33-79v-824l-292-292q-28-28-28-68t28-68q29-28 68.5-28t67.5 28l228 228h368l228-228q28-28 68-28t68 28q28 29 28 68.5t-28 67.5zM864 384q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"
    }
  }]
};
exports.child = child;
var paw = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M780 472q0 60-19 113.5t-63 92.5-105 39q-76 0-138-57.5t-92-135.5-30-151q0-60 19-113.5t63-92.5 105-39q77 0 138.5 57.5t91.5 135 30 151.5zM438 955q0 80-42 139t-119 59q-76 0-141.5-55.5t-100.5-133.5-35-152q0-80 42-139.5t119-59.5q76 0 141.5 55.5t100.5 134 35 152.5zM832 928q118 0 255 97.5t229 237 92 254.5q0 46-17 76.5t-48.5 45-64.5 20-76 5.5q-68 0-187.5-45t-182.5-45q-66 0-192.5 44.5t-200.5 44.5q-183 0-183-146 0-86 56-191.5t139.5-192.5 187.5-146 193-59zM1071 717q-61 0-105-39t-63-92.5-19-113.5q0-74 30-151.5t91.5-135 138.5-57.5q61 0 105 39t63 92.5 19 113.5q0 73-30 151t-92 135.5-138 57.5zM1503 613q77 0 119 59.5t42 139.5q0 74-35 152t-100.5 133.5-141.5 55.5q-77 0-119-59t-42-139q0-74 35-152.5t100.5-134 141.5-55.5z"
    }
  }]
};
exports.paw = paw;
var spoon = {
  "viewBox": "0 0 768 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 528q0 145-57 243.5t-152 135.5l45 821q2 26-16 45t-44 19h-192q-26 0-44-19t-16-45l45-821q-95-37-152-135.5t-57-243.5q0-128 42.5-249.5t117.5-200 160-78.5 160 78.5 117.5 200 42.5 249.5z"
    }
  }]
};
exports.spoon = spoon;
var cube = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1629l640-349v-636l-640 233v752zM832 764l698-254-698-254-698 254zM1664 512v768q0 35-18 65t-49 47l-704 384q-28 16-61 16t-61-16l-704-384q-31-17-49-47t-18-65v-768q0-40 23-73t61-47l704-256q22-8 44-8t44 8l704 256q38 14 61 47t23 73z"
    }
  }]
};
exports.cube = cube;
var cubes = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1632l384-192v-314l-384 164v342zM576 1178l404-173-404-173-404 173zM1664 1632l384-192v-314l-384 164v342zM1600 1178l404-173-404-173-404 173zM1152 885l384-165v-266l-384 164v267zM1088 506l441-189-441-189-441 189zM2176 1024v416q0 36-19 67t-52 47l-448 224q-25 14-57 14t-57-14l-448-224q-4-2-7-4-2 2-7 4l-448 224q-25 14-57 14t-57-14l-448-224q-33-16-52-47t-19-67v-416q0-38 21.5-70t56.5-48l434-186v-400q0-38 21.5-70t56.5-48l448-192q23-10 50-10t50 10l448 192q35 16 56.5 48t21.5 70v400l434 186q36 16 57 48t21 70z"
    }
  }]
};
exports.cubes = cubes;
var behance = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1848 339h-511v124h511v-124zM1596 765q-90 0-146 52.5t-62 142.5h408q-18-195-200-195zM1612 1350q63 0 122-32t76-87h221q-100 307-427 307-214 0-340.5-132t-126.5-347q0-208 130.5-345.5t336.5-137.5q138 0 240.5 68t153 179 50.5 248q0 17-2 47h-658q0 111 57.5 171.5t166.5 60.5zM277 1300h296q205 0 205-167 0-180-199-180h-302v347zM277 763h281q78 0 123.5-36.5t45.5-113.5q0-144-190-144h-260v294zM0 254h594q87 0 155 14t126.5 47.5 90 96.5 31.5 154q0 181-172 263 114 32 172 115t58 204q0 75-24.5 136.5t-66 103.5-98.5 71-121 42-134 13h-611v-1260z"
    }
  }]
};
exports.behance = behance;
var behanceSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1248 128q119 0 203.5 84.5t84.5 203.5v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960zM499 495h-371v787h382q117 0 197-57.5t80-170.5q0-158-143-200 107-52 107-164 0-57-19.5-96.5t-56.5-60.5-79-29.5-97-8.5zM477 813h-176v-184h163q119 0 119 90 0 94-106 94zM486 1148h-185v-217h189q124 0 124 113 0 104-128 104zM1136 1180q-68 0-104-38t-36-107h411q1-10 1-30 0-132-74.5-220.5t-203.5-88.5q-128 0-210 86t-82 216q0 135 79 217t213 82q205 0 267-191h-138q-11 34-47.5 54t-75.5 20zM1126 814q113 0 124 122h-254q4-56 39-89t91-33zM964 548h319v77h-319v-77z"
    }
  }]
};
exports.behanceSquare = behanceSquare;
var steam = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1582 582q0 101-71.5 172.5t-172.5 71.5-172.5-71.5-71.5-172.5 71.5-172.5 172.5-71.5 172.5 71.5 71.5 172.5zM812 1324q0-104-73-177t-177-73q-27 0-54 6l104 42q77 31 109.5 106.5t1.5 151.5q-31 77-107 109t-152 1q-21-8-62-24.5t-61-24.5q32 60 91 96.5t130 36.5q104 0 177-73t73-177zM1642 583q0-126-89.5-215.5t-215.5-89.5q-127 0-216.5 89.5t-89.5 215.5q0 127 89.5 216t216.5 89q126 0 215.5-89t89.5-216zM1792 583q0 189-133.5 322t-321.5 133l-437 319q-12 129-109 218t-229 89q-121 0-214-76t-118-192l-230-92v-429l389 157q79-48 173-48 13 0 35 2l284-407q2-187 135.5-319t320.5-132q188 0 321.5 133.5t133.5 321.5z"
    }
  }]
};
exports.steam = steam;
var steamSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1242 647q0-80-57-136.5t-137-56.5-136.5 57-56.5 136q0 80 56.5 136.5t136.5 56.5 137-56.5 57-136.5zM632 1235q0 83-58 140.5t-140 57.5q-56 0-103-29t-72-77q52 20 98 40 60 24 120-1.5t85-86.5q24-60-1.5-120t-86.5-84l-82-33q22-5 42-5 82 0 140 57.5t58 140.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-153l172 69q20 92 93.5 152t168.5 60q104 0 181-70t87-173l345-252q150 0 255.5-105.5t105.5-254.5q0-150-105.5-255.5t-255.5-105.5q-148 0-253 104.5t-107 252.5l-225 322q-9-1-28-1-75 0-137 37l-297-119v-468q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5zM1289 649q0 100-71 170.5t-171 70.5-170.5-70.5-70.5-170.5 70.5-171 170.5-71q101 0 171.5 70.5t70.5 171.5z"
    }
  }]
};
exports.steamSquare = steamSquare;
var recycle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M836 1169l-15 368-2 22-420-29q-36-3-67-31.5t-47-65.5q-11-27-14.5-55t4-65 12-55 21.5-64 19-53q78 12 509 28zM449 583l180 379-147-92q-63 72-111.5 144.5t-72.5 125-39.5 94.5-18.5 63l-4 21-190-357q-17-26-18-56t6-47l8-18q35-63 114-188l-140-86zM1680 1100l-188 359q-12 29-36.5 46.5t-43.5 20.5l-18 4q-71 7-219 12l8 164-230-367 211-362 7 173q170 16 283 5t170-33zM895 176q-47 63-265 435l-317-187-19-12 225-356q20-31 60-45t80-10q24 2 48.5 12t42 21 41.5 33 36 34.5 36 39.5 32 35zM1550 483l212 363q18 37 12.5 76t-27.5 74q-13 20-33 37t-38 28-48.5 22-47 16-51.5 14-46 12q-34-72-265-436l313-195zM1407 257l142-83-220 373-419-20 151-86q-34-89-75-166t-75.5-123.5-64.5-80-47-46.5l-17-13 405 1q31-3 58 10.5t39 28.5l11 15q39 61 112 190z"
    }
  }]
};
exports.recycle = recycle;
var automobile = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M480 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM516 768h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1888 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM2048 992v384q0 14-9 23t-23 9h-96v128q0 80-56 136t-136 56-136-56-56-136v-128h-1024v128q0 80-56 136t-136 56-136-56-56-136v-128h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h768q98 0 179 63.5t104 157.5l105 419h28q93 0 158.5 65.5t65.5 158.5z"
    }
  }]
};
exports.automobile = automobile;
var car = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M480 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM516 768h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1888 1088q0-66-47-113t-113-47-113 47-47 113 47 113 113 47 113-47 47-113zM2048 992v384q0 14-9 23t-23 9h-96v128q0 80-56 136t-136 56-136-56-56-136v-128h-1024v128q0 80-56 136t-136 56-136-56-56-136v-128h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h768q98 0 179 63.5t104 157.5l105 419h28q93 0 158.5 65.5t65.5 158.5z"
    }
  }]
};
exports.car = car;
var cab = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1824 896q93 0 158.5 65.5t65.5 158.5v384q0 14-9 23t-23 9h-96v64q0 80-56 136t-136 56-136-56-56-136v-64h-1024v64q0 80-56 136t-136 56-136-56-56-136v-64h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h128v-224q0-14 9-23t23-9h448q14 0 23 9t9 23v224h128q98 0 179 63.5t104 157.5l105 419h28zM320 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM516 896h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1728 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47z"
    }
  }]
};
exports.cab = cab;
var taxi = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1824 896q93 0 158.5 65.5t65.5 158.5v384q0 14-9 23t-23 9h-96v64q0 80-56 136t-136 56-136-56-56-136v-64h-1024v64q0 80-56 136t-136 56-136-56-56-136v-64h-96q-14 0-23-9t-9-23v-384q0-93 65.5-158.5t158.5-65.5h28l105-419q23-94 104-157.5t179-63.5h128v-224q0-14 9-23t23-9h448q14 0 23 9t9 23v224h128q98 0 179 63.5t104 157.5l105 419h28zM320 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM516 896h1016l-89-357q-2-8-14-17.5t-21-9.5h-768q-9 0-21 9.5t-14 17.5zM1728 1376q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47z"
    }
  }]
};
exports.taxi = taxi;
var tree = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1504 1472q0 26-19 45t-45 19h-462q1 17 6 87.5t5 108.5q0 25-18 42.5t-43 17.5h-320q-25 0-43-17.5t-18-42.5q0-38 5-108.5t6-87.5h-462q-26 0-45-19t-19-45 19-45l402-403h-229q-26 0-45-19t-19-45 19-45l402-403h-197q-26 0-45-19t-19-45 19-45l384-384q19-19 45-19t45 19l384 384q19 19 19 45t-19 45-45 19h-197l402 403q19 19 19 45t-19 45-45 19h-229l402 403q19 19 19 45z"
    }
  }]
};
exports.tree = tree;
var spotify = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1127 1210q0-32-30-51-193-115-447-115-133 0-287 34-42 9-42 52 0 20 13.5 34.5t35.5 14.5q5 0 37-8 132-27 243-27 226 0 397 103 19 11 33 11 19 0 33-13.5t14-34.5zM1223 995q0-40-35-61-237-141-548-141-153 0-303 42-48 13-48 64 0 25 17.5 42.5t42.5 17.5q7 0 37-8 122-33 251-33 279 0 488 124 24 13 38 13 25 0 42.5-17.5t17.5-42.5zM1331 747q0-47-40-70-126-73-293-110.5t-343-37.5q-204 0-364 47-23 7-38.5 25.5t-15.5 48.5q0 31 20.5 52t51.5 21q11 0 40-8 133-37 307-37 159 0 309.5 34t253.5 95q21 12 40 12 29 0 50.5-20.5t21.5-51.5zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.spotify = spotify;
var deviantart = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 303l-303 582 24 31h279v415h-507l-44 30-142 273-30 30h-301v-303l303-583-24-30h-279v-415h507l44-30 142-273 30-30h301v303z"
    }
  }]
};
exports.deviantart = deviantart;
var soundcloud = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M784 1372l16-241-16-523q-1-10-7.5-17t-16.5-7q-9 0-16 7t-7 17l-14 523 14 241q1 10 7.5 16.5t15.5 6.5q22 0 24-23zM1080 1343l11-211-12-586q0-16-13-24-8-5-16-5t-16 5q-13 8-13 24l-1 6-10 579q0 1 11 236v1q0 10 6 17 9 11 23 11 11 0 20-9 9-7 9-20zM35 1003l20 128-20 126q-2 9-9 9t-9-9l-17-126 17-128q2-9 9-9t9 9zM121 924l26 207-26 203q-2 9-10 9-9 0-9-10l-23-202 23-207q0-9 9-9 8 0 10 9zM401 1377zM213 886l25 245-25 237q0 11-11 11-10 0-12-11l-21-237 21-245q2-12 12-12 11 0 11 12zM307 879l23 252-23 244q-2 13-14 13-13 0-13-13l-21-244 21-252q0-13 13-13 12 0 14 13zM401 897l21 234-21 246q-2 16-16 16-6 0-10.5-4.5t-4.5-11.5l-20-246 20-234q0-6 4.5-10.5t10.5-4.5q14 0 16 15zM784 1372zM495 751l21 380-21 246q0 7-5 12.5t-12 5.5q-16 0-18-18l-18-246 18-380q2-18 18-18 7 0 12 5.5t5 12.5zM589 665l19 468-19 244q0 8-5.5 13.5t-13.5 5.5q-18 0-20-19l-16-244 16-468q2-19 20-19 8 0 13.5 5.5t5.5 13.5zM687 625l18 506-18 242q-2 21-22 21-19 0-21-21l-16-242 16-506q0-9 6.5-15.5t14.5-6.5q9 0 15 6.5t7 15.5zM1079 1367v0 0 0zM881 621l15 510-15 239q0 10-7.5 17.5t-17.5 7.5-17-7-8-18l-14-239 14-510q0-11 7.5-18t17.5-7 17.5 7 7.5 18zM980 640l14 492-14 236q0 11-8 19t-19 8-19-8-9-19l-12-236 12-492q1-12 9-20t19-8 18.5 8 8.5 20zM1192 1132l-14 231v0q0 13-9 22t-22 9-22-9-10-22l-6-114-6-117 12-636v-3q2-15 12-24 9-7 20-7 8 0 15 5 14 8 16 26zM2304 1113q0 117-83 199.5t-200 82.5h-786q-13-2-22-11t-9-22v-899q0-23 28-33 85-34 181-34 195 0 338 131.5t160 323.5q53-22 110-22 117 0 200 83t83 201z"
    }
  }]
};
exports.soundcloud = soundcloud;
var database = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 768q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 1536q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 1152q237 0 443-43t325-127v170q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-170q119 84 325 127t443 43zM768 0q208 0 385 34.5t280 93.5 103 128v128q0 69-103 128t-280 93.5-385 34.5-385-34.5-280-93.5-103-128v-128q0-69 103-128t280-93.5 385-34.5z"
    }
  }]
};
exports.database = database;
var filePdfO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM894 1071q33 26 84 56 59-7 117-7 147 0 177 49 16 22 2 52 0 1-1 2l-2 2v1q-6 38-71 38-48 0-115-20t-130-53q-221 24-392 83-153 262-242 262-15 0-28-7l-24-12q-1-1-6-5-10-10-6-36 9-40 56-91.5t132-96.5q14-9 23 6 2 2 2 4 52-85 107-197 68-136 104-262-24-82-30.5-159.5t6.5-127.5q11-40 42-40h21 1q23 0 35 15 18 21 9 68-2 6-4 8 1 3 1 8v30q-2 123-14 192 55 164 146 238zM318 1482q52-24 137-158-51 40-87.5 84t-49.5 74zM716 562q-15 42-2 132 1-7 7-44 0-3 7-43 1-4 4-8-1-1-1-2-1-2-1-3-1-22-13-36 0 1-1 2v2zM592 1223q135-54 284-81-2-1-13-9.5t-16-13.5q-76-67-127-176-27 86-83 197-30 56-45 83zM1238 1207q-24-24-140-24 76 28 124 28 14 0 18-1 0-1-2-3z"
    }
  }]
};
exports.filePdfO = filePdfO;
var fileWordO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM233 768v107h70l164 661h159l128-485q7-20 10-46 2-16 2-24h4l3 24q1 3 3.5 20t5.5 26l128 485h159l164-661h70v-107h-300v107h90l-99 438q-5 20-7 46l-2 21h-4q0-3-0.5-6.5t-1.5-8-1-6.5q-1-5-4-21t-5-25l-144-545h-114l-144 545q-2 9-4.5 24.5t-3.5 21.5l-4 21h-4l-2-21q-2-26-7-46l-99-438h90v-107h-300z"
    }
  }]
};
exports.fileWordO = fileWordO;
var fileExcelO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM429 1430v106h281v-106h-75l103-161q5-7 10-16.5t7.5-13.5 3.5-4h2q1 4 5 10 2 4 4.5 7.5t6 8 6.5 8.5l107 161h-76v106h291v-106h-68l-192-273 195-282h67v-107h-279v107h74l-103 159q-4 7-10 16.5t-9 13.5l-2 3h-2q-1-4-5-10-6-11-17-23l-106-159h76v-107h-290v107h68l189 272-194 283h-68z"
    }
  }]
};
exports.fileExcelO = fileExcelO;
var filePowerpointO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM416 1430v106h327v-106h-93v-167h137q76 0 118-15 67-23 106.5-87t39.5-146q0-81-37-141t-100-87q-48-19-130-19h-368v107h92v555h-92zM769 1150h-119v-268h120q52 0 83 18 56 33 56 115 0 89-62 120-31 15-78 15z"
    }
  }]
};
exports.filePowerpointO = filePowerpointO;
var fileImageO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"
    }
  }]
};
exports.fileImageO = fileImageO;
var filePhotoO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"
    }
  }]
};
exports.filePhotoO = filePhotoO;
var filePictureO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM1280 1216v320h-1024v-192l192-192 128 128 384-384zM448 1024q-80 0-136-56t-56-136 56-136 136-56 136 56 56 136-56 136-136 56z"
    }
  }]
};
exports.filePictureO = filePictureO;
var fileArchiveO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 384v-128h-128v128h128zM768 512v-128h-128v128h128zM640 640v-128h-128v128h128zM768 768v-128h-128v128h128zM1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zM781 943l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zM640 1408q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z"
    }
  }]
};
exports.fileArchiveO = fileArchiveO;
var fileZipO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 384v-128h-128v128h128zM768 512v-128h-128v128h128zM640 640v-128h-128v128h128zM768 768v-128h-128v128h128zM1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-128v128h-128v-128h-512v1536h1280zM781 943l107 349q8 27 8 52 0 83-72.5 137.5t-183.5 54.5-183.5-54.5-72.5-137.5q0-25 8-52 21-63 120-396v-128h128v128h79q22 0 39 13t23 34zM640 1408q53 0 90.5-19t37.5-45-37.5-45-90.5-19-90.5 19-37.5 45 37.5 45 90.5 19z"
    }
  }]
};
exports.fileZipO = fileZipO;
var fileAudioO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM620 850q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zM1037 1539q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zM826 1391q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z"
    }
  }]
};
exports.fileAudioO = fileAudioO;
var fileSoundO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM620 850q20 8 20 30v544q0 22-20 30-8 2-12 2-12 0-23-9l-166-167h-131q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h131l166-167q16-15 35-7zM1037 1539q31 0 50-24 129-159 129-363t-129-363q-16-21-43-24t-47 14q-21 17-23.5 43.5t14.5 47.5q100 123 100 282t-100 282q-17 21-14.5 47.5t23.5 42.5q18 15 40 15zM826 1391q27 0 47-20 87-93 87-219t-87-219q-18-19-45-20t-46 17-20 44.5 18 46.5q52 57 52 131t-52 131q-19 20-18 46.5t20 44.5q20 17 44 17z"
    }
  }]
};
exports.fileSoundO = fileSoundO;
var fileMovieO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM768 768q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zM1260 770q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z"
    }
  }]
};
exports.fileMovieO = fileMovieO;
var fileVideoO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM768 768q52 0 90 38t38 90v384q0 52-38 90t-90 38h-384q-52 0-90-38t-38-90v-384q0-52 38-90t90-38h384zM1260 770q20 8 20 30v576q0 22-20 30-8 2-12 2-14 0-23-9l-265-266v-90l265-266q9-9 23-9 4 0 12 2z"
    }
  }]
};
exports.fileVideoO = fileVideoO;
var fileCodeO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1468 380q28 28 48 76t20 88v1152q0 40-28 68t-68 28h-1344q-40 0-68-28t-28-68v-1600q0-40 28-68t68-28h896q40 0 88 20t76 48zM1024 136v376h376q-10-29-22-41l-313-313q-12-12-41-22zM1408 1664v-1024h-416q-40 0-68-28t-28-68v-416h-768v1536h1280zM480 768q8-11 21-12.5t24 6.5l51 38q11 8 12.5 21t-6.5 24l-182 243 182 243q8 11 6.5 24t-12.5 21l-51 38q-11 8-24 6.5t-21-12.5l-226-301q-14-19 0-38zM1282 1069q14 19 0 38l-226 301q-8 11-21 12.5t-24-6.5l-51-38q-11-8-12.5-21t6.5-24l182-243-182-243q-8-11-6.5-24t12.5-21l51-38q11-8 24-6.5t21 12.5zM662 1530q-13-2-20.5-13t-5.5-24l138-831q2-13 13-20.5t24-5.5l63 10q13 2 20.5 13t5.5 24l-138 831q-2 13-13 20.5t-24 5.5z"
    }
  }]
};
exports.fileCodeO = fileCodeO;
var vine = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1497 827v198q-101 23-198 23-65 136-165.5 271t-181.5 215.5-128 106.5q-80 45-162-3-28-17-60.5-43.5t-85-83.5-102.5-128.5-107.5-184-105.5-244-91.5-314.5-70.5-390h283q26 218 70 398.5t104.5 317 121.5 235.5 140 195q169-169 287-406-142-72-223-220t-81-333q0-192 104-314.5t284-122.5q178 0 273 105.5t95 297.5q0 159-58 286-7 1-19.5 3t-46 2-63-6-62-25.5-50.5-51.5q31-103 31-184 0-87-29-132t-79-45q-53 0-85 49.5t-32 140.5q0 186 105 293.5t267 107.5q62 0 121-14z"
    }
  }]
};
exports.vine = vine;
var codepen = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M216 1169l603 402v-359l-334-223zM154 1025l193-129-193-129v258zM973 1571l603-402-269-180-334 223v359zM896 1078l272-182-272-182-272 182zM485 803l334-223v-359l-603 402zM1445 896l193 129v-258zM1307 803l269-180-603-402v359zM1792 623v546q0 41-34 64l-819 546q-21 13-43 13t-43-13l-819-546q-34-23-34-64v-546q0-41 34-64l819-546q21-13 43-13t43 13l819 546q34 23 34 64z"
    }
  }]
};
exports.codepen = codepen;
var jsfiddle = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1800 772q111 46 179.5 145.5t68.5 221.5q0 164-118 280.5t-285 116.5q-4 0-11.5-0.5t-10.5-0.5h-1209-1-2-5q-170-10-288-125.5t-118-280.5q0-110 55-203t147-147q-12-39-12-82 0-115 82-196t199-81q95 0 172 58 75-154 222.5-248t326.5-94q166 0 306 80.5t221.5 218.5 81.5 301q0 6-0.5 18t-0.5 18zM468 1038q0 122 84 193t208 71q137 0 240-99-16-20-47.5-56.5t-43.5-50.5q-67 65-144 65-55 0-93.5-33.5t-38.5-87.5q0-53 38.5-87t91.5-34q44 0 84.5 21t73 55 65 75 69 82 77 75 97 55 121.5 21q121 0 204.5-71.5t83.5-190.5q0-121-84-192t-207-71q-143 0-241 97l93 108q66-64 142-64 52 0 92 33t40 84q0 57-37 91.5t-94 34.5q-43 0-82.5-21t-72-55-65.5-75-69.5-82-77.5-75-96.5-55-118.5-21q-122 0-207 70.5t-85 189.5z"
    }
  }]
};
exports.jsfiddle = jsfiddle;
var lifeBouy = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
    }
  }]
};
exports.lifeBouy = lifeBouy;
var lifeBuoy = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
    }
  }]
};
exports.lifeBuoy = lifeBuoy;
var lifeRing = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
    }
  }]
};
exports.lifeRing = lifeRing;
var lifeSaver = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
    }
  }]
};
exports.lifeSaver = lifeSaver;
var support = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM896 128q-190 0-361 90l194 194q82-28 167-28t167 28l194-194q-171-90-361-90zM218 1257l194-194q-28-82-28-167t28-167l-194-194q-90 171-90 361t90 361zM896 1664q190 0 361-90l-194-194q-82 28-167 28t-167-28l-194 194q171 90 361 90zM896 1280q159 0 271.5-112.5t112.5-271.5-112.5-271.5-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5zM1380 1063l194 194q90-171 90-361t-90-361l-194 194q28 82 28 167t-28 167z"
    }
  }]
};
exports.support = support;
var circleONotch = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1760 896q0 176-68.5 336t-184 275.5-275.5 184-336 68.5-336-68.5-275.5-184-184-275.5-68.5-336q0-213 97-398.5t265-305.5 374-151v228q-221 45-366.5 221t-145.5 406q0 130 51 248.5t136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5q0-230-145.5-406t-366.5-221v-228q206 31 374 151t265 305.5 97 398.5z"
    }
  }]
};
exports.circleONotch = circleONotch;
var ra = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"
    }
  }]
};
exports.ra = ra;
var rebel = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"
    }
  }]
};
exports.rebel = rebel;
var resistance = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 874q8-217 116-406t305-318h5q0 1-1 3-8 8-28 33.5t-52 76.5-60 110.5-44.5 135.5-14 150.5 39 157.5 108.5 154q50 50 102 69.5t90.5 11.5 69.5-23.5 47-32.5l16-16q39-51 53-116.5t6.5-122.5-21-107-26.5-80l-14-29q-10-25-30.5-49.5t-43-41-43.5-29.5-35-19l-13-6 104-115q39 17 78 52t59 61l19 27q1-48-18.5-103.5t-40.5-87.5l-20-31 161-183 160 181q-33 46-52.5 102.5t-22.5 90.5l-4 33q22-37 61.5-72.5t67.5-52.5l28-17 103 115q-44 14-85 50t-60 65l-19 29q-31 56-48 133.5t-7 170 57 156.5q33 45 77.5 60.5t85 5.5 76-26.5 57.5-33.5l21-16q60-53 96.5-115t48.5-121.5 10-121.5-18-118-37-107.5-45.5-93-45-72-34.5-47.5l-13-17q-14-13-7-13l10 3q40 29 62.5 46t62 50 64 58 58.5 65 55.5 77 45.5 88 38 103 23.5 117 10.5 136q3 259-108 465t-312 321-456 115q-185 0-351-74t-283.5-198-184-293-60.5-353z"
    }
  }]
};
exports.resistance = resistance;
var empire = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M874 1638v66q-208-6-385-109.5t-283-275.5l58-34q29 49 73 99l65-57q148 168 368 212l-17 86q65 12 121 13zM276 1108l-83 28q22 60 49 112l-57 33q-98-180-98-385t98-385l57 33q-30 56-49 112l82 28q-35 100-35 212 0 109 36 212zM1528 1285l58 34q-106 172-283 275.5t-385 109.5v-66q56-1 121-13l-17-86q220-44 368-212l65 57q44-50 73-99zM1377 731l-233 80q14 42 14 85t-14 85l232 80q-31 92-98 169l-185-162q-57 67-147 85l48 241q-52 10-98 10t-98-10l48-241q-90-18-147-85l-185 162q-67-77-98-169l232-80q-14-42-14-85t14-85l-233-80q33-93 99-169l185 162q59-68 147-86l-48-240q44-10 98-10t98 10l-48 240q88 18 147 86l185-162q66 76 99 169zM874 88v66q-65 2-121 13l17 86q-220 42-368 211l-65-56q-38 42-73 98l-57-33q106-172 282-275.5t385-109.5zM1705 896q0 205-98 385l-57-33q27-52 49-112l-83-28q36-103 36-212 0-112-35-212l82-28q-19-56-49-112l57-33q98 180 98 385zM1585 473l-57 33q-35-56-73-98l-65 56q-148-169-368-211l17-86q-56-11-121-13v-66q209 6 385 109.5t282 275.5zM1748 896q0-173-67.5-331t-181.5-272-272-181.5-331-67.5-331 67.5-272 181.5-181.5 272-67.5 331 67.5 331 181.5 272 272 181.5 331 67.5 331-67.5 272-181.5 181.5-272 67.5-331zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.empire = empire;
var ge = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M874 1638v66q-208-6-385-109.5t-283-275.5l58-34q29 49 73 99l65-57q148 168 368 212l-17 86q65 12 121 13zM276 1108l-83 28q22 60 49 112l-57 33q-98-180-98-385t98-385l57 33q-30 56-49 112l82 28q-35 100-35 212 0 109 36 212zM1528 1285l58 34q-106 172-283 275.5t-385 109.5v-66q56-1 121-13l-17-86q220-44 368-212l65 57q44-50 73-99zM1377 731l-233 80q14 42 14 85t-14 85l232 80q-31 92-98 169l-185-162q-57 67-147 85l48 241q-52 10-98 10t-98-10l48-241q-90-18-147-85l-185 162q-67-77-98-169l232-80q-14-42-14-85t14-85l-233-80q33-93 99-169l185 162q59-68 147-86l-48-240q44-10 98-10t98 10l-48 240q88 18 147 86l185-162q66 76 99 169zM874 88v66q-65 2-121 13l17 86q-220 42-368 211l-65-56q-38 42-73 98l-57-33q106-172 282-275.5t385-109.5zM1705 896q0 205-98 385l-57-33q27-52 49-112l-83-28q36-103 36-212 0-112-35-212l82-28q-19-56-49-112l57-33q98 180 98 385zM1585 473l-57 33q-35-56-73-98l-65 56q-148-169-368-211l17-86q-56-11-121-13v-66q209 6 385 109.5t282 275.5zM1748 896q0-173-67.5-331t-181.5-272-272-181.5-331-67.5-331 67.5-272 181.5-181.5 272-67.5 331 67.5 331 181.5 272 272 181.5 331 67.5 331-67.5 272-181.5 181.5-272 67.5-331zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.ge = ge;
var gitSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M582 1308q0 66-93 66-107 0-107-63 0-64 98-64 102 0 102 61zM546 842q0 85-74 85-77 0-77-84 0-90 77-90 36 0 55 25.5t19 63.5zM712 767v-125q-78 29-135 29-50-29-110-29-86 0-145 57t-59 143q0 50 29.5 102t73.5 67v3q-38 17-38 85 0 53 41 77v3q-113 37-113 139 0 45 20 78.5t54 51 72 25.5 81 8q224 0 224-188 0-67-48-99t-126-46q-27-5-51.5-20.5t-24.5-39.5q0-44 49-52 77-15 122-70t45-134q0-24-10-52 37-9 49-13zM771 1186h137q-2-27-2-82v-387q0-46 2-69h-137q3 23 3 71v392q0 50-3 75zM1280 1170v-121q-30 21-68 21-53 0-53-82v-225h52q9 0 26.5 1t26.5 1v-117h-105q0-82 3-102h-140q4 24 4 55v47h-60v117q36-3 37-3 3 0 11 0.5t12 0.5v2h-2v217q0 37 2.5 64t11.5 56.5 24.5 48.5 43.5 31 66 12q64 0 108-24zM924 464q0-36-24-63.5t-60-27.5-60.5 27-24.5 64q0 36 25 62.5t60 26.5 59.5-27 24.5-62zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.gitSquare = gitSquare;
var git = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M595 1514q0-100-165-100-158 0-158 104 0 101 172 101 151 0 151-105zM536 759q0-61-30-102t-89-41q-124 0-124 145 0 135 124 135 119 0 119-137zM805 435v202q-36 12-79 22 16 43 16 84 0 127-73 216.5t-197 112.5q-40 8-59.5 27t-19.5 58q0 31 22.5 51.5t58 32 78.5 22 86 25.5 78.5 37.5 58 64 22.5 98.5q0 304-363 304-69 0-130-12.5t-116-41-87.5-82-32.5-127.5q0-165 182-225v-4q-67-41-67-126 0-109 63-137v-4q-72-24-119.5-108.5t-47.5-165.5q0-139 95-231.5t235-92.5q96 0 178 47 98 0 218-47zM1123 1316h-222q4-45 4-134v-609q0-94-4-128h222q-4 33-4 124v613q0 89 4 134zM1724 1094v196q-71 39-174 39-62 0-107-20t-70-50-39.5-78-18.5-92-4-103v-351h2v-4q-7 0-19-1t-18-1q-21 0-59 6v-190h96v-76q0-54-6-89h227q-6 41-6 165h171v190q-15 0-43.5-2t-42.5-2h-85v365q0 131 87 131 61 0 109-33zM1148 147q0 58-39 101.5t-96 43.5q-58 0-98-43.5t-40-101.5q0-59 39.5-103t98.5-44q58 0 96.5 44.5t38.5 102.5z"
    }
  }]
};
exports.git = git;
var hackerNews = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.hackerNews = hackerNews;
var yCombinatorSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.yCombinatorSquare = yCombinatorSquare;
var ycSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.ycSquare = ycSquare;
var tencentWeibo = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M842 572q0 80-57 136.5t-136 56.5q-60 0-111-35-62 67-115 146-247 371-202 859 1 22-12.5 38.5t-34.5 18.5h-5q-20 0-35-13.5t-17-33.5q-14-126-3.5-247.5t29.5-217 54-186 69-155.5 74-125q61-90 132-165-16-35-16-77 0-80 56.5-136.5t136.5-56.5 136.5 56.5 56.5 136.5zM1223 583q0 158-78 292t-212.5 212-292.5 78q-64 0-131-14-21-5-32.5-23.5t-6.5-39.5q5-20 23-31.5t39-7.5q51 13 108 13 97 0 186-38t153-102 102-153 38-186-38-186-102-153-153-102-186-38-186 38-153 102-102 153-38 186q0 114 52 218 10 20 3.5 40t-25.5 30-39.5 3-30.5-26q-64-123-64-265 0-119 46.5-227t124.5-186 186-124 226-46q158 0 292.5 78t212.5 212.5 78 292.5z"
    }
  }]
};
exports.tencentWeibo = tencentWeibo;
var qq = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M270 806q-8-19-8-52 0-20 11-49t24-45q-1-22 7.5-53t22.5-43q0-139 92.5-288.5t217.5-209.5q139-66 324-66 133 0 266 55 49 21 90 48t71 56 55 68 42 74 32.5 84.5 25.5 89.5 22 98l1 5q55 83 55 150 0 14-9 40t-9 38q0 1 1.5 3.5t3.5 5 2 3.5q77 114 120.5 214.5t43.5 208.5q0 43-19.5 100t-55.5 57q-9 0-19.5-7.5t-19-17.5-19-26-16-26.5-13.5-26-9-17.5q-1-1-3-1l-5 4q-59 154-132 223 20 20 61.5 38.5t69 41.5 35.5 65q-2 4-4 16t-7 18q-64 97-302 97-53 0-110.5-9t-98-20-104.5-30q-15-5-23-7-14-4-46-4.5t-40-1.5q-41 45-127.5 65t-168.5 20q-35 0-69-1.5t-93-9-101-20.5-74.5-40-32.5-64q0-40 10-59.5t41-48.5q11-2 40.5-13t49.5-12q4 0 14-2 2-2 2-4l-2-3q-48-11-108-105.5t-73-156.5l-5-3q-4 0-12 20-18 41-54.5 74.5t-77.5 37.5h-1q-4 0-6-4.5t-5-5.5q-23-54-23-100 0-275 252-466z"
    }
  }]
};
exports.qq = qq;
var wechat = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M580 461q0-41-25-66t-66-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 66-24.5t25-65.5zM1323 968q0-28-25.5-50t-65.5-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q40 0 65.5-22t25.5-51zM1087 461q0-41-24.5-66t-65.5-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 65.5-24.5t24.5-65.5zM1722 968q0-28-26-50t-65-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q39 0 65-22t26-51zM1456 571q-31-4-70-4-169 0-311 77t-223.5 208.5-81.5 287.5q0 78 23 152-35 3-68 3-26 0-50-1.5t-55-6.5-44.5-7-54.5-10.5-50-10.5l-253 127 72-218q-290-203-290-490 0-169 97.5-311t264-223.5 363.5-81.5q176 0 332.5 66t262 182.5 136.5 260.5zM2048 1132q0 117-68.5 223.5t-185.5 193.5l55 181-199-109q-150 37-218 37-169 0-311-70.5t-223.5-191.5-81.5-264 81.5-264 223.5-191.5 311-70.5q161 0 303 70.5t227.5 192 85.5 263.5z"
    }
  }]
};
exports.wechat = wechat;
var weixin = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M580 461q0-41-25-66t-66-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 66-24.5t25-65.5zM1323 968q0-28-25.5-50t-65.5-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q40 0 65.5-22t25.5-51zM1087 461q0-41-24.5-66t-65.5-25q-43 0-76 25.5t-33 65.5q0 39 33 64.5t76 25.5q41 0 65.5-24.5t24.5-65.5zM1722 968q0-28-26-50t-65-22q-27 0-49.5 22.5t-22.5 49.5q0 28 22.5 50.5t49.5 22.5q39 0 65-22t26-51zM1456 571q-31-4-70-4-169 0-311 77t-223.5 208.5-81.5 287.5q0 78 23 152-35 3-68 3-26 0-50-1.5t-55-6.5-44.5-7-54.5-10.5-50-10.5l-253 127 72-218q-290-203-290-490 0-169 97.5-311t264-223.5 363.5-81.5q176 0 332.5 66t262 182.5 136.5 260.5zM2048 1132q0 117-68.5 223.5t-185.5 193.5l55 181-199-109q-150 37-218 37-169 0-311-70.5t-223.5-191.5-81.5-264 81.5-264 223.5-191.5 311-70.5q161 0 303 70.5t227.5 192 85.5 263.5z"
    }
  }]
};
exports.weixin = weixin;
var paperPlane = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z"
    }
  }]
};
exports.paperPlane = paperPlane;
var send = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-453-185-242 295q-18 23-49 23-13 0-22-4-19-7-30.5-23.5t-11.5-36.5v-349l864-1059-1069 925-395-162q-37-14-40-55-2-40 32-59l1664-960q15-9 32-9 20 0 36 11z"
    }
  }]
};
exports.send = send;
var paperPlaneO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-527-215-298 327q-18 21-47 21-14 0-23-4-19-7-30-23.5t-11-36.5v-452l-472-193q-37-14-40-55-3-39 32-59l1664-960q35-21 68 2zM1422 1510l221-1323-1434 827 336 137 863-639-478 797z"
    }
  }]
};
exports.paperPlaneO = paperPlaneO;
var sendO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1764 11q33 24 27 64l-256 1536q-5 29-32 45-14 8-31 8-11 0-24-5l-527-215-298 327q-18 21-47 21-14 0-23-4-19-7-30-23.5t-11-36.5v-452l-472-193q-37-14-40-55-3-39 32-59l1664-960q35-21 68 2zM1422 1510l221-1323-1434 827 336 137 863-639-478 797z"
    }
  }]
};
exports.sendO = sendO;
var history = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 896q0 156-61 298t-164 245-245 164-298 61q-172 0-327-72.5t-264-204.5q-7-10-6.5-22.5t8.5-20.5l137-138q10-9 25-9 16 2 23 12 73 95 179 147t225 52q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5q-98 0-188 35.5t-160 101.5l137 138q31 30 14 69-17 40-59 40h-448q-26 0-45-19t-19-45v-448q0-42 40-59 39-17 69 14l130 129q107-101 244.5-156.5t284.5-55.5q156 0 298 61t245 164 164 245 61 298zM896 608v448q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-352q0-14 9-23t23-9h64q14 0 23 9t9 23z"
    }
  }]
};
exports.history = history;
var circleThin = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.circleThin = circleThin;
var header = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1682 1664q-44 0-132.5-3.5t-133.5-3.5q-44 0-132 3.5t-132 3.5q-24 0-37-20.5t-13-45.5q0-31 17-46t39-17 51-7 45-15q33-21 33-140l-1-391q0-21-1-31-13-4-50-4h-675q-38 0-51 4-1 10-1 31l-1 371q0 142 37 164 16 10 48 13t57 3.5 45 15 20 45.5q0 26-12.5 48t-36.5 22q-47 0-139.5-3.5t-138.5-3.5q-43 0-128 3.5t-127 3.5q-23 0-35.5-21t-12.5-45q0-30 15.5-45t36-17.5 47.5-7.5 42-15q33-23 33-143l-1-57v-813q0-3 0.5-26t0-36.5-1.5-38.5-3.5-42-6.5-36.5-11-31.5-16-18q-15-10-45-12t-53-2-41-14-18-45q0-26 12-48t36-22q46 0 138.5 3.5t138.5 3.5q42 0 126.5-3.5t126.5-3.5q25 0 37.5 22t12.5 48q0 30-17 43.5t-38.5 14.5-49.5 4-43 13q-35 21-35 160l1 320q0 21 1 32 13 3 39 3h699q25 0 38-3 1-11 1-32l1-320q0-139-35-160-18-11-58.5-12.5t-66-13-25.5-49.5q0-26 12.5-48t37.5-22q44 0 132 3.5t132 3.5q43 0 129-3.5t129-3.5q25 0 37.5 22t12.5 48q0 30-17.5 44t-40 14.5-51.5 3-44 12.5q-35 23-35 161l1 943q0 119 34 140 16 10 46 13.5t53.5 4.5 41.5 15.5 18 44.5q0 26-12 48t-36 22z"
    }
  }]
};
exports.header = header;
var paragraph = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1278 189v73q0 29-18.5 61t-42.5 32q-50 0-54 1-26 6-32 31-3 11-3 64v1152q0 25-18 43t-43 18h-108q-25 0-43-18t-18-43v-1218h-143v1218q0 25-17.5 43t-43.5 18h-108q-26 0-43.5-18t-17.5-43v-496q-147-12-245-59-126-58-192-179-64-117-64-259 0-166 88-286 88-118 209-159 111-37 417-37h479q25 0 43 18t18 43z"
    }
  }]
};
exports.paragraph = paragraph;
var sliders = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M352 1408v128h-352v-128h352zM704 1280q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM864 896v128h-864v-128h864zM224 384v128h-224v-128h224zM1536 1408v128h-736v-128h736zM576 256q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM1216 768q26 0 45 19t19 45v256q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h256zM1536 896v128h-224v-128h224zM1536 384v128h-864v-128h864z"
    }
  }]
};
exports.sliders = sliders;
var shareAlt = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1216 1024q133 0 226.5 93.5t93.5 226.5-93.5 226.5-226.5 93.5-226.5-93.5-93.5-226.5q0-12 2-34l-360-180q-92 86-218 86-133 0-226.5-93.5t-93.5-226.5 93.5-226.5 226.5-93.5q126 0 218 86l360-180q-2-22-2-34 0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5-93.5 226.5-226.5 93.5q-126 0-218-86l-360 180q2 22 2 34t-2 34l360 180q92-86 218-86z"
    }
  }]
};
exports.shareAlt = shareAlt;
var shareAltSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1195q0-88-62.5-151t-150.5-63q-84 0-145 58l-241-120q2-16 2-23t-2-23l241-120q61 58 145 58 88 0 150.5-63t62.5-151-62.5-150.5-150.5-62.5-151 62.5-63 150.5q0 7 2 23l-241 120q-62-57-145-57-88 0-150.5 62.5t-62.5 150.5 62.5 150.5 150.5 62.5q83 0 145-57l241 120q-2 16-2 23 0 88 63 150.5t151 62.5 150.5-62.5 62.5-150.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.shareAltSquare = shareAltSquare;
var bomb = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M571 589q-10-25-34-35t-49 0q-108 44-191 127t-127 191q-10 25 0 49t35 34q13 5 24 5 42 0 60-40 34-84 98.5-148.5t148.5-98.5q25-11 35-35t0-49zM1513 233l46 46-244 243 68 68q19 19 19 45.5t-19 45.5l-64 64q89 161 89 343 0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5q182 0 343 89l64-64q19-19 45.5-19t45.5 19l68 68zM1521 177q-10 10-22 10-13 0-23-10l-91-90q-9-10-9-23t9-23q10-9 23-9t23 9l90 91q10 9 10 22.5t-10 22.5zM1751 407q-11 9-23 9t-23-9l-90-91q-10-9-10-22.5t10-22.5q9-10 22.5-10t22.5 10l91 90q9 10 9 23t-9 23zM1792 224q0 14-9 23t-23 9h-96q-14 0-23-9t-9-23 9-23 23-9h96q14 0 23 9t9 23zM1600 32v96q0 14-9 23t-23 9-23-9-9-23v-96q0-14 9-23t23-9 23 9 9 23zM1751 87l-91 90q-10 10-22 10-13 0-23-10-10-9-10-22.5t10-22.5l90-91q10-9 23-9t23 9q9 10 9 23t-9 23z"
    }
  }]
};
exports.bomb = bomb;
var futbolO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M609 816l287-208 287 208-109 336h-355zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM1515 1350q149-203 149-454v-3l-102 89-240-224 63-323 134 12q-150-206-389-282l53 124-287 159-287-159 53-124q-239 76-389 282l135-12 62 323-240 224-102-89v3q0 251 149 454l30-132 326 40 139 298-116 69q117 39 240 39t240-39l-116-69 139-298 326-40z"
    }
  }]
};
exports.futbolO = futbolO;
var soccerBallO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M609 816l287-208 287 208-109 336h-355zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM1515 1350q149-203 149-454v-3l-102 89-240-224 63-323 134 12q-150-206-389-282l53 124-287 159-287-159 53-124q-239 76-389 282l135-12 62 323-240 224-102-89v3q0 251 149 454l30-132 326 40 139 298-116 69q117 39 240 39t240-39l-116-69 139-298 326-40z"
    }
  }]
};
exports.soccerBallO = soccerBallO;
var tty = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M448 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM256 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM832 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM640 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM66 768q-28 0-47-19t-19-46v-129h514v129q0 27-19 46t-46 19h-383zM1216 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1024 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1600 1312v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1408 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 520v13h-514v-10q0-104-382-102-382 1-382 102v10h-514v-13q0-17 8.5-43t34-64 65.5-75.5 110.5-76 160-67.5 224-47.5 293.5-18.5 293 18.5 224 47.5 160.5 67.5 110.5 76 65.5 75.5 34 64 8.5 43zM1792 928v192q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-192q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 574v129q0 27-19 46t-46 19h-384q-27 0-46-19t-19-46v-129h514z"
    }
  }]
};
exports.tty = tty;
var binoculars = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 320v768q0 26-19 45t-45 19v576q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-512l249-873q7-23 31-23h424zM1024 320v704h-256v-704h256zM1792 1216v512q0 26-19 45t-45 19h-512q-26 0-45-19t-19-45v-576q-26 0-45-19t-19-45v-768h424q24 0 31 23zM736 32v224h-352v-224q0-14 9-23t23-9h288q14 0 23 9t9 23zM1408 32v224h-352v-224q0-14 9-23t23-9h288q14 0 23 9t9 23z"
    }
  }]
};
exports.binoculars = binoculars;
var plug = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1755 453q37 38 37 90.5t-37 90.5l-401 400 150 150-160 160q-163 163-389.5 186.5t-411.5-100.5l-362 362h-181v-181l362-362q-124-185-100.5-411.5t186.5-389.5l160-160 150 150 400-401q38-37 91-37t90 37 37 90.5-37 90.5l-400 401 234 234 401-400q38-37 91-37t90 37z"
    }
  }]
};
exports.plug = plug;
var slideshare = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M873 740q0 83-63.5 142.5t-152.5 59.5-152.5-59.5-63.5-142.5q0-84 63.5-143t152.5-59 152.5 59 63.5 143zM1375 740q0 83-63 142.5t-153 59.5q-89 0-152.5-59.5t-63.5-142.5q0-84 63.5-143t152.5-59q90 0 153 59t63 143zM1600 920v-667q0-87-32-123.5t-111-36.5h-1112q-83 0-112.5 34t-29.5 126v673q43 23 88.5 40t81 28 81 18.5 71 11 70 4 58.5 0.5 56.5-2 44.5-2q68-1 95 27 6 6 10 9 26 25 61 51 7-91 118-87 5 0 36.5 1.5t43 2 45.5 1 53-1 54.5-4.5 61-8.5 62-13.5 67-19.5 67.5-27 72-34.5zM1763 915q-121 149-372 252 84 285-23 465-66 113-183 148-104 32-182-15-86-51-82-164l-1-326v-1q-8-2-24.5-6t-23.5-5l-1 338q4 114-83 164-79 47-183 15-117-36-182-150-105-180-22-463-251-103-372-252-25-37-4-63t60 1q4 2 11.5 7t10.5 8v-694q0-72 47-123t114-51h1257q67 0 114 51t47 123v694l21-15q39-27 60-1t-4 63z"
    }
  }]
};
exports.slideshare = slideshare;
var twitch = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 434v434h-145v-434h145zM1294 434v434h-145v-434h145zM1294 1194l253-254v-795h-1194v1049h326v217l217-217h398zM1692 0v1013l-434 434h-326l-217 217h-217v-217h-398v-1158l109-289h1483z"
    }
  }]
};
exports.twitch = twitch;
var yelp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M773 1319v127q-1 292-6 305-12 32-51 40-54 9-181.5-38t-162.5-89q-13-15-17-36-1-12 4-26 4-10 34-47t181-216q1 0 60-70 15-19 39.5-24.5t49.5 3.5q24 10 37.5 29t12.5 42zM624 1068q-3 55-52 70l-120 39q-275 88-292 88-35-2-54-36-12-25-17-75-8-76 1-166.5t30-124.5 56-32q13 0 202 77 71 29 115 47l84 34q23 9 35.5 30.5t11.5 48.5zM1450 1365q-7 54-91.5 161t-135.5 127q-37 14-63-7-14-10-184-287l-47-77q-14-21-11.5-46t19.5-46q35-43 83-26 1 1 119 40 203 66 242 79.5t47 20.5q28 22 22 61zM778 733q5 102-54 122-58 17-114-71l-378-598q-8-35 19-62 41-43 207.5-89.5t224.5-31.5q40 10 49 45 3 18 22 305.5t24 379.5zM1440 841q3 39-26 59-15 10-329 86-67 15-91 23l1-2q-23 6-46-4t-37-32q-30-47 0-87 1-1 75-102 125-171 150-204t34-39q28-19 65-2 48 23 123 133.5t81 167.5v3z"
    }
  }]
};
exports.yelp = yelp;
var newspaperO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 512h-384v384h384v-384zM1152 1152v128h-640v-128h640zM1152 384v640h-640v-640h640zM1792 1152v128h-512v-128h512zM1792 896v128h-512v-128h512zM1792 640v128h-512v-128h512zM1792 384v128h-512v-128h512zM256 1344v-960h-128v960q0 26 19 45t45 19 45-19 19-45zM1920 1344v-1088h-1536v1088q0 33-11 64h1483q26 0 45-19t19-45zM2048 128v1216q0 80-56 136t-136 56h-1664q-80 0-136-56t-56-136v-1088h256v-128h1792z"
    }
  }]
};
exports.newspaperO = newspaperO;
var wifi = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1523q-20 0-93-73.5t-73-93.5q0-32 62.5-54t103.5-22 103.5 22 62.5 54q0 20-73 93.5t-93 73.5zM1294 1252q-2 0-40-25t-101.5-50-128.5-25-128.5 25-101 50-40.5 25q-18 0-93.5-75t-75.5-93q0-13 10-23 78-77 196-121t233-44 233 44 196 121q10 10 10 23 0 18-75.5 93t-93.5 75zM1567 980q-11 0-23-8-136-105-252-154.5t-268-49.5q-85 0-170.5 22t-149 53-113.5 62-79 53-31 22q-17 0-92-75t-75-93q0-12 10-22 132-132 320-205t380-73 380 73 320 205q10 10 10 22 0 18-75 93t-92 75zM1838 709q-11 0-22-9-179-157-371.5-236.5t-420.5-79.5-420.5 79.5-371.5 236.5q-11 9-22 9-17 0-92.5-75t-75.5-93q0-13 10-23 187-186 445-288t527-102 527 102 445 288q10 10 10 23 0 18-75.5 93t-92.5 75z"
    }
  }]
};
exports.wifi = wifi;
var calculator = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM384 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1152 1536q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM384 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1152 1152q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM768 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1536 1536v-384q0-52-38-90t-90-38-90 38-38 90v384q0 52 38 90t90 38 90-38 38-90zM1152 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1536 448v-256q0-26-19-45t-45-19h-1280q-26 0-45 19t-19 45v256q0 26 19 45t45 19h1280q26 0 45-19t19-45zM1536 768q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1664 128v1536q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1536q0-52 38-90t90-38h1408q52 0 90 38t38 90z"
    }
  }]
};
exports.calculator = calculator;
var paypal = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1519 646q18 84-4 204-87 444-565 444h-44q-25 0-44 16.5t-24 42.5l-4 19-55 346-2 15q-5 26-24.5 42.5t-44.5 16.5h-251q-21 0-33-15t-9-36q9-56 26.5-168t26.5-168 27-167.5 27-167.5q5-37 43-37h131q133 2 236-21 175-39 287-144 102-95 155-246 24-70 35-133 1-6 2.5-7.5t3.5-1 6 3.5q79 59 98 162zM1347 364q0 107-46 236-80 233-302 315-113 40-252 42 0 1-90 1l-90-1q-100 0-118 96-2 8-85 530-1 10-12 10h-295q-22 0-36.5-16.5t-11.5-38.5l232-1471q5-29 27.5-48t51.5-19h598q34 0 97.5 13t111.5 32q107 41 163.5 123t56.5 196z"
    }
  }]
};
exports.paypal = paypal;
var googleWallet = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M441 672q33 0 52 26 266 364 362 774h-446q-127-441-367-749-12-16-3-33.5t29-17.5h373zM1000 1029q-49 199-125 393-79-310-256-594 40-221 44-449 211 340 337 650zM1099 320q235 324 384.5 698.5t184.5 773.5h-451q-41-665-553-1472h435zM1792 896q0 424-101 812-67-560-359-1083-25-301-106-584-4-16 5.5-28.5t25.5-12.5h359q21 0 38.5 13t22.5 33q115 409 115 850z"
    }
  }]
};
exports.googleWallet = googleWallet;
var ccVisa = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1975 990h-138q14-37 66-179l3-9q4-10 10-26t9-26l12 55zM531 925l-58-295q-11-54-75-54h-268l-2 13q311 79 403 336zM710 576l-162 438-17-89q-26-70-85-129.5t-131-88.5l135 510h175l261-641h-176zM849 1218h166l104-642h-166zM1617 592q-69-27-149-27-123 0-201 59t-79 153q-1 102 145 174 48 23 67 41t19 39q0 30-30 46t-69 16q-86 0-156-33l-22-11-23 144q74 34 185 34 130 1 208.5-59t80.5-160q0-106-140-174-49-25-71-42t-22-38q0-22 24.5-38.5t70.5-16.5q70-1 124 24l15 8zM2042 576h-128q-65 0-87 54l-246 588h174l35-96h212q5 22 20 96h154zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccVisa = ccVisa;
var ccMastercard = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1119 341q-128-85-281-85-103 0-197.5 40.5t-162.5 108.5-108.5 162-40.5 197q0 104 40.5 198t108.5 162 162 108.5 198 40.5q153 0 281-85-131-107-178-265.5t0.5-316.5 177.5-265zM1152 365q-126 99-172 249.5t-0.5 300.5 172.5 249q127-99 172.5-249t-0.5-300.5-172-249.5zM1185 341q130 107 177.5 265.5t0.5 317-178 264.5q128 85 281 85 104 0 198-40.5t162-108.5 108.5-162 40.5-198q0-103-40.5-197t-108.5-162-162.5-108.5-197.5-40.5q-153 0-281 85zM1926 1063h7v-3h-17v3h7v17h3v-17zM1955 1080h4v-20h-5l-6 13-6-13h-5v20h3v-15l6 13h4l5-13v15zM1947 1520v2h-2-3v-3h3 2v1zM1947 1529h3l-4-5h2l1-1q1-1 1-3t-1-3l-1-1h-3-6v13h3v-5h1zM685 1461q0-19 11-31t30-12q18 0 29 12.5t11 30.5q0 19-11 31t-29 12q-19 0-30-12t-11-31zM1158 1417q30 0 35 32h-70q5-32 35-32zM1514 1461q0-19 11-31t29-12 29.5 12.5 11.5 30.5q0 19-11 31t-30 12q-18 0-29-12t-11-31zM1786 1461q0-18 11.5-30.5t29.5-12.5 29.5 12.5 11.5 30.5q0 19-11.5 31t-29.5 12-29.5-12.5-11.5-30.5zM1944 1533q-2 0-4-1-1 0-3-2t-2-3q-1-2-1-4 0-3 1-4 0-2 2-4l1-1q2 0 2-1 2-1 4-1 3 0 4 1l4 2 2 4v1q1 2 1 3l-1 1v3t-1 1l-1 2q-2 2-4 2-1 1-4 1zM599 1529h30v-85q0-24-14.5-38.5t-39.5-15.5q-32 0-47 24-14-24-45-24-24 0-39 20v-16h-30v135h30v-75q0-36 33-36 30 0 30 36v75h29v-75q0-36 33-36 30 0 30 36v75zM765 1529h29v-68-67h-29v16q-17-20-43-20-29 0-48 20t-19 51 19 51 48 20q28 0 43-20v17zM943 1488q0-34-47-40l-14-2q-23-4-23-14 0-15 25-15 23 0 43 11l12-24q-22-14-55-14-26 0-41 12t-15 32q0 33 47 39l13 2q24 4 24 14 0 17-31 17-25 0-45-14l-13 23q25 17 58 17 29 0 45.5-12t16.5-32zM1073 1522l-8-25q-13 7-26 7-19 0-19-22v-61h48v-27h-48v-41h-30v41h-28v27h28v61q0 50 47 50 21 0 36-10zM1159 1390q-29 0-48 20t-19 51q0 32 19.5 51.5t49.5 19.5q33 0 55-19l-14-22q-18 15-39 15-34 0-41-33h101v-12q0-32-18-51.5t-46-19.5zM1318 1390q-23 0-35 20v-16h-30v135h30v-76q0-35 29-35 10 0 18 4l9-28q-9-4-21-4zM1348 1461q0 31 19.5 51t52.5 20q29 0 48-16l-14-24q-18 13-35 12-18 0-29.5-12t-11.5-31 11.5-31 29.5-12q19 0 35 12l14-24q-20-16-48-16-33 0-52.5 20t-19.5 51zM1593 1529h30v-68-67h-30v16q-15-20-42-20-29 0-48.5 20t-19.5 51 19.5 51 48.5 20q28 0 42-20v17zM1726 1390q-23 0-35 20v-16h-29v135h29v-76q0-35 29-35 10 0 18 4l9-28q-8-4-21-4zM1866 1529h29v-68-122h-29v71q-15-20-43-20t-47.5 20.5-19.5 50.5 19.5 50.5 47.5 20.5q29 0 43-20v17zM1944 1509l-2 1h-3q-2 1-4 3-3 1-3 4-1 2-1 6 0 3 1 5 0 2 3 4 2 2 4 3t5 1q4 0 6-1 0-1 2-2l2-1q1-1 3-4 1-2 1-5 0-4-1-6-1-1-3-4 0-1-2-2l-2-1q-1 0-3-0.5t-3-0.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccMastercard = ccMastercard;
var ccDiscover = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M313 777q0 51-36 84-29 26-89 26h-17v-220h17q61 0 89 27 36 31 36 83zM2089 712q0 52-64 52h-19v-101h20q63 0 63 49zM380 777q0-74-50-120.5t-129-46.5h-95v333h95q74 0 119-38 60-51 60-128zM410 943h65v-333h-65v333zM730 842q0-40-20.5-62t-75.5-42q-29-10-39.5-19t-10.5-23q0-16 13.5-26.5t34.5-10.5q29 0 53 27l34-44q-41-37-98-37-44 0-74 27.5t-30 67.5q0 35 18 55.5t64 36.5q37 13 45 19 19 12 19 34 0 20-14 33.5t-36 13.5q-48 0-71-44l-42 40q44 64 115 64 51 0 83-30.5t32-79.5zM1008 932v-77q-37 37-78 37-49 0-80.5-32.5t-31.5-82.5q0-48 31.5-81.5t77.5-33.5q43 0 81 38v-77q-40-20-80-20-74 0-125.5 50.5t-51.5 123.5 51 123.5 125 50.5q42 0 81-19zM2240 1536v-527q-65 40-144.5 84t-237.5 117-329.5 137.5-417.5 134.5-504 118h1569q26 0 45-19t19-45zM1389 779q0-75-53-128t-128-53-128 53-53 128 53 128 128 53 128-53 53-128zM1541 952l144-342h-71l-90 224-89-224h-71l142 342h35zM1714 943h184v-56h-119v-90h115v-56h-115v-74h119v-57h-184v333zM2105 943h80l-105-140q76-16 76-94 0-47-31-73t-87-26h-97v333h65v-133h9zM2304 262v1268q0 56-38.5 95t-93.5 39h-2040q-55 0-93.5-39t-38.5-95v-1268q0-56 38.5-95t93.5-39h2040q55 0 93.5 39t38.5 95z"
    }
  }]
};
exports.ccDiscover = ccDiscover;
var ccAmex = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M119 682h89l-45-108zM740 1208l74-79-70-79h-163v49h142v55h-142v54h159zM898 1130l99 110v-217zM1186 1083q0-33-40-33h-84v69h83q41 0 41-36zM1475 1079q0-29-42-29h-82v61h81q43 0 43-32zM1197 613q0-29-42-29h-82v60h81q43 0 43-31zM1656 682h89l-44-108zM699 527v271h-66v-212l-94 212h-57l-94-212v212h-132l-25-60h-135l-25 60h-70l116-271h96l110 257v-257h106l85 184 77-184h108zM1255 1083q0 20-5.5 35t-14 25-22.5 16.5-26 10-31.5 4.5-31.5 1-32.5-0.5-29.5-0.5v91h-126l-80-90-83 90h-256v-271h260l80 89 82-89h207q109 0 109 89zM964 742v56h-217v-271h217v57h-152v49h148v55h-148v54h152zM2304 1301v229q0 55-38.5 94.5t-93.5 39.5h-2040q-55 0-93.5-39.5t-38.5-94.5v-678h111l25-61h55l25 61h218v-46l19 46h113l20-47v47h541v-99l10-1q10 0 10 14v86h279v-23q23 12 55 18t52.5 6.5 63-0.5 51.5-1l25-61h56l25 61h227v-58l34 58h182v-378h-180v44l-25-44h-185v44l-23-44h-249q-69 0-109 22v-22h-172v22q-24-22-73-22h-628l-43 97-43-97h-198v44l-22-44h-169l-78 179v-391q0-55 38.5-94.5t93.5-39.5h2040q55 0 93.5 39.5t38.5 94.5v678h-120q-51 0-81 22v-22h-177q-55 0-78 22v-22h-316v22q-31-22-87-22h-209v22q-23-22-91-22h-234l-54 58-50-58h-349v378h343l55-59 52 59h211v-89h21q59 0 90-13v102h174v-99h8q8 0 10 2t2 10v87h529q57 0 88-24v24h168q60 0 95-17zM1546 1067q0 23-12 43t-34 29q25 9 34 26t9 46v54h-65v-45q0-33-12-43.5t-46-10.5h-69v99h-65v-271h154q48 0 77 15t29 58zM1269 600q0 24-12.5 44t-33.5 29q26 9 34.5 25.5t8.5 46.5v53h-65q0-9 0.5-26.5t0-25-3-18.5-8.5-16-17.5-8.5-29.5-3.5h-70v98h-64v-271l153 1q49 0 78 14.5t29 57.5zM1798 1209v56h-216v-271h216v56h-151v49h148v55h-148v54zM1372 527v271h-66v-271h66zM2065 1179q0 86-102 86h-126v-58h126q34 0 34-25 0-16-17-21t-41.5-5-49.5-3.5-42-22.5-17-55q0-39 26-60t66-21h130v57h-119q-36 0-36 25 0 16 17.5 20.5t42 4 49 2.5 42 21.5 17.5 54.5zM2304 1129v101q-24 35-88 35h-125v-58h125q33 0 33-25 0-13-12.5-19t-31-5.5-40-2-40-8-31-24-12.5-48.5q0-39 26.5-60t66.5-21h129v57h-118q-36 0-36 25 0 20 29 22t68.5 5 56.5 26zM2139 528v270h-92l-122-203v203h-132l-26-60h-134l-25 60h-75q-129 0-129-133 0-138 133-138h63v59q-7 0-28-1t-28.5-0.5-23 2-21.5 6.5-14.5 13.5-11.5 23-3 33.5q0 38 13.5 58t49.5 20h29l92-213h97l109 256v-256h99l114 188v-188h66z"
    }
  }]
};
exports.ccAmex = ccAmex;
var ccPaypal = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M745 906q0 37-25.5 61.5t-62.5 24.5q-29 0-46.5-16t-17.5-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zM1530 757q0 42-22 57t-66 15l-32 1 17-107q2-11 13-11h18q22 0 35 2t25 12.5 12 30.5zM1881 906q0 36-25.5 61t-61.5 25q-29 0-47-16t-18-44q0-37 25-62.5t62-25.5q28 0 46.5 16.5t18.5 45.5zM513 735q0-59-38.5-85.5t-100.5-26.5h-160q-19 0-21 19l-65 408q-1 6 3 11t10 5h76q20 0 22-19l18-110q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zM822 1047l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-27-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q28 0 58-12t48-32q-4 12-4 21 0 16 13 16h69q19 0 22-19zM1269 784q0-5-4-9.5t-9-4.5h-77q-11 0-18 10l-106 156-44-150q-5-16-22-16h-75q-5 0-9 4.5t-4 9.5q0 2 19.5 59t42 123 23.5 70q-82 112-82 120 0 13 13 13h77q11 0 18-10l255-368q2-2 2-7zM1649 735q0-59-38.5-85.5t-100.5-26.5h-159q-20 0-22 19l-65 408q-1 6 3 11t10 5h82q12 0 16-13l18-116q1-8 7-13t15-6.5 17-1.5 19 1 14 1q86 0 135-48.5t49-134.5zM1958 1047l41-261q1-6-3-11t-10-5h-76q-14 0-17 33-26-40-95-40-72 0-122.5 54t-50.5 127q0 59 34.5 94t92.5 35q29 0 59-12t47-32q0 1-2 9t-2 12q0 16 13 16h69q19 0 22-19zM2176 638v-1q0-14-13-14h-74q-11 0-13 11l-65 416-1 2q0 5 4 9.5t10 4.5h66q19 0 21-19zM392 772q-5 35-26 46t-60 11l-33 1 17-107q2-11 13-11h19q40 0 58 11.5t12 48.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccPaypal = ccPaypal;
var ccStripe = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1597 903q0 69-21 106-19 35-52 35-23 0-41-9v-224q29-30 57-30 57 0 57 122zM2035 867h-110q6-98 56-98 51 0 54 98zM476 1002q0-59-33-91.5t-101-57.5q-36-13-52-24t-16-25q0-26 38-26 58 0 124 33l18-112q-67-32-149-32-77 0-123 38-48 39-48 109 0 58 32.5 90.5t99.5 56.5q39 14 54.5 25.5t15.5 27.5q0 31-48 31-29 0-70-12.5t-72-30.5l-18 113q72 41 168 41 81 0 129-37 51-41 51-117zM771 787l19-111h-96v-135l-129 21-18 114-46 8-17 103h62v219q0 84 44 120 38 30 111 30 32 0 79-11v-118q-32 7-44 7-42 0-42-50v-197h77zM1087 812v-139q-15-3-28-3-32 0-55.5 16t-33.5 46l-10-56h-131v471h150v-306q26-31 82-31 16 0 26 2zM1124 1147h150v-471h-150v471zM1746 898q0-122-45-179-40-52-111-52-64 0-117 56l-8-47h-132v645l150-25v-151q36 11 68 11 83 0 134-56 61-65 61-202zM1278 550q0-33-23-56t-56-23-56 23-23 56 23 56.5 56 23.5 56-23.5 23-56.5zM2176 907q0-113-48-176-50-64-144-64-96 0-151.5 66t-55.5 180q0 128 63 188 55 55 161 55 101 0 160-40l-16-103q-57 31-128 31-43 0-63-19-23-19-28-66h248q2-14 2-52zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccStripe = ccStripe;
var bellSlash = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1558 852q61 356 298 556 0 52-38 90t-90 38h-448q0 106-75 181t-181 75-180.5-74.5-75.5-180.5zM1024 1712q16 0 16-16t-16-16q-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5zM2026 112q8 10 7.5 23.5t-10.5 22.5l-1872 1622q-10 8-23.5 7t-21.5-11l-84-96q-8-10-7.5-23.5t10.5-21.5l186-161q-19-32-19-66 50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 124 18 219 82.5t148 157.5l418-363q10-8 23.5-7t21.5 11z"
    }
  }]
};
exports.bellSlash = bellSlash;
var bellSlashO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1040 1696q0-16-16-16-59 0-101.5-42.5t-42.5-101.5q0-16-16-16t-16 16q0 73 51.5 124.5t124.5 51.5q16 0 16-16zM503 1221l877-760q-42-88-132.5-146.5t-223.5-58.5q-93 0-169.5 31.5t-121.5 80.5-69 103-24 105q0 384-137 645zM1856 1408q0 52-38 90t-90 38h-448q0 106-75 181t-181 75-180.5-74.5-75.5-180.5l149-129h757q-166-187-227-459l111-97q61 356 298 556zM1942 16l84 96q8 10 7.5 23.5t-10.5 22.5l-1872 1622q-10 8-23.5 7t-21.5-11l-84-96q-8-10-7.5-23.5t10.5-21.5l186-161q-19-32-19-66 50-42 91-88t85-119.5 74.5-158.5 50-206 19.5-260q0-152 117-282.5t307-158.5q-8-19-8-39 0-40 28-68t68-28 68 28 28 68q0 20-8 39 124 18 219 82.5t148 157.5l418-363q10-8 23.5-7t21.5 11z"
    }
  }]
};
exports.bellSlashO = bellSlashO;
var trash = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM768 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM1024 1376v-704q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v704q0 14 9 23t23 9h64q14 0 23-9t9-23zM480 384h448l-48-117q-7-9-17-11h-317q-10 2-17 11zM1408 416v64q0 14-9 23t-23 9h-96v948q0 83-47 143.5t-113 60.5h-832q-66 0-113-58.5t-47-141.5v-952h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h309l70-167q15-37 54-63t79-26h320q40 0 79 26t54 63l70 167h309q14 0 23 9t9 23z"
    }
  }]
};
exports.trash = trash;
var copyright = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1150 1074v109q0 50-36.5 89t-94 60.5-118 32.5-117.5 11q-205 0-342.5-139t-137.5-346q0-203 136-339t339-136q34 0 75.5 4.5t93 18 92.5 34 69 56.5 28 81v109q0 16-16 16h-118q-16 0-16-16v-70q0-43-65.5-67.5t-137.5-24.5q-140 0-228.5 91.5t-88.5 237.5q0 151 91.5 249.5t233.5 98.5q68 0 138-24t70-66v-70q0-7 4.5-11.5t10.5-4.5h119q6 0 11 4.5t5 11.5zM768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.copyright = copyright;
var at = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M972 775q0-108-53.5-169t-147.5-61q-63 0-124 30.5t-110 84.5-79.5 137-30.5 180q0 112 53.5 173t150.5 61q96 0 176-66.5t122.5-166 42.5-203.5zM1536 896q0 111-37 197t-98.5 135-131.5 74.5-145 27.5q-6 0-15.5 0.5t-16.5 0.5q-95 0-142-53-28-33-33-83-52 66-131.5 110t-173.5 44q-161 0-249.5-95.5t-88.5-269.5q0-157 66-290t179-210.5 246-77.5q87 0 155 35.5t106 99.5l2-19 11-56q1-6 5.5-12t9.5-6h118q5 0 13 11 5 5 3 16l-120 614q-5 24-5 48 0 39 12.5 52t44.5 13q28-1 57-5.5t73-24 77-50 57-89.5 24-137q0-292-174-466t-466-174q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51q228 0 405-144 11-9 24-8t21 12l41 49q8 12 7 24-2 13-12 22-102 83-227.5 128t-258.5 45q-156 0-298-61t-245-164-164-245-61-298 61-298 164-245 245-164 298-61q344 0 556 212t212 556z"
    }
  }]
};
exports.at = at;
var eyedropper = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1698 94q94 94 94 226.5t-94 225.5l-225 223 104 104q10 10 10 23t-10 23l-210 210q-10 10-23 10t-23-10l-105-105-603 603q-37 37-90 37h-203l-256 128-64-64 128-256v-203q0-53 37-90l603-603-105-105q-10-10-10-23t10-23l210-210q10-10 23-10t23 10l104 104 223-225q93-94 225.5-94t226.5 94zM512 1472l576-576-192-192-576 576v192h192z"
    }
  }]
};
exports.eyedropper = eyedropper;
var paintBrush = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1615 0q70 0 122.5 46.5t52.5 116.5q0 63-45 151-332 629-465 752-97 91-218 91-126 0-216.5-92.5t-90.5-219.5q0-128 92-212l638-579q59-54 130-54zM706 1034q39 76 106.5 130t150.5 76l1 71q4 213-129.5 347t-348.5 134q-123 0-218-46.5t-152.5-127.5-86.5-183-29-220q7 5 41 30t62 44.5 59 36.5 46 17q41 0 55-37 25-66 57.5-112.5t69.5-76 88-47.5 103-25.5 125-10.5z"
    }
  }]
};
exports.paintBrush = paintBrush;
var birthdayCake = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1408v384h-1792v-384q45 0 85-14t59-27.5 47-37.5q30-27 51.5-38t56.5-11q24 0 44 7t31 15 33 27q29 25 47 38t58 27 86 14q45 0 85-14.5t58-27 48-37.5q21-19 32.5-27t31-15 43.5-7q35 0 56.5 11t51.5 38q28 24 47 37.5t59 27.5 85 14 85-14 59-27.5 47-37.5q30-27 51.5-38t56.5-11q34 0 55.5 11t51.5 38q28 24 47 37.5t59 27.5 85 14zM1792 1088v192q-24 0-44-7t-31-15-33-27q-29-25-47-38t-58-27-85-14q-46 0-86 14t-58 27-47 38q-22 19-33 27t-31 15-44 7q-35 0-56.5-11t-51.5-38q-29-25-47-38t-58-27-86-14q-45 0-85 14.5t-58 27-48 37.5q-21 19-32.5 27t-31 15-43.5 7q-35 0-56.5-11t-51.5-38q-28-24-47-37.5t-59-27.5-85-14q-46 0-86 14t-58 27-47 38q-30 27-51.5 38t-56.5 11v-192q0-80 56-136t136-56h64v-448h256v448h256v-448h256v448h256v-448h256v448h64q80 0 136 56t56 136zM512 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150zM1024 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150zM1536 224q0 77-36 118.5t-92 41.5q-53 0-90.5-37.5t-37.5-90.5q0-29 9.5-51t23.5-34 31-28 31-31.5 23.5-44.5 9.5-67q38 0 83 74t45 150z"
    }
  }]
};
exports.birthdayCake = birthdayCake;
var areaChart = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2048 1536v128h-2048v-1536h128v1408h1920zM1664 512l256 896h-1664v-576l448-576 576 576z"
    }
  }]
};
exports.areaChart = areaChart;
var pieChart = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 890l546 546q-106 108-247.5 168t-298.5 60q-209 0-385.5-103t-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103v762zM955 896h773q0 157-60 298.5t-168 247.5zM1664 768h-768v-768q209 0 385.5 103t279.5 279.5 103 385.5z"
    }
  }]
};
exports.pieChart = pieChart;
var lineChart = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2048 1536v128h-2048v-1536h128v1408h1920zM1920 288v435q0 21-19.5 29.5t-35.5-7.5l-121-121-633 633q-10 10-23 10t-23-10l-233-233-416 416-192-192 585-585q10-10 23-10t23 10l233 233 464-464-121-121q-16-16-7.5-35.5t29.5-19.5h435q14 0 23 9t9 23z"
    }
  }]
};
exports.lineChart = lineChart;
var lastfm = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1292 704q0 6 10 41 10 29 25 49.5t41 34 44 20 55 16.5q325 91 325 332 0 146-105.5 242.5t-254.5 96.5q-59 0-111.5-18.5t-91.5-45.5-77-74.5-63-87.5-53.5-103.5-43.5-103-39.5-106.5-35.5-95q-32-81-61.5-133.5t-73.5-96.5-104-64-142-20q-96 0-183 55.5t-138 144.5-51 185q0 160 106.5 279.5t263.5 119.5q177 0 258-95 56-63 83-116l84 152q-15 34-44 70l1 1q-131 152-388 152-147 0-269.5-79t-190.5-207.5-68-274.5q0-105 43.5-206t116-176.5 172-121.5 204.5-46q87 0 159 19t123.5 50 95 80 72.5 99 58.5 117 50.5 124.5 50 130.5 55 127q96 200 233 200 81 0 138.5-48.5t57.5-128.5q0-42-19-72t-50.5-46-72.5-31.5-84.5-27-87.5-34-81-52-65-82-39-122.5q-3-16-3-33 0-110 87.5-192t198.5-78q78 3 120.5 14.5t90.5 53.5h-1q12 11 23 24.5t26 36 19 27.5l-129 99q-26-49-54-70v-1q-23-21-97-21-49 0-84 33t-35 83z"
    }
  }]
};
exports.lastfm = lastfm;
var lastfmSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1432 1052q0-173-234-239-35-10-53-16.5t-38-25-29-46.5q0-2-2-8.5t-3-12-1-7.5q0-36 24.5-59.5t60.5-23.5q54 0 71 15h-1q20 15 39 51l93-71q-39-54-49-64-33-29-67.5-39t-85.5-10q-80 0-142 57.5t-62 137.5q0 7 2 23 16 96 64.5 140t148.5 73q29 8 49 15.5t45 21.5 38.5 34.5 13.5 46.5v5q1 58-40.5 93t-100.5 35q-97 0-167-144-23-47-51.5-121.5t-48-125.5-54-110.5-74-95.5-103.5-60.5-147-24.5q-101 0-192 56t-144 148-50 192v1q4 108 50.5 199t133.5 147.5 196 56.5q186 0 279-110 20-27 31-51l-60-109q-42 80-99 116t-146 36q-115 0-191-87t-76-204q0-105 82-189t186-84q112 0 170 53.5t104 172.5q8 21 25.5 68.5t28.5 76.5 31.5 74.5 38.5 74 45.5 62.5 55.5 53.5 66 33 80 13.5q107 0 183-69.5t76-174.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.lastfmSquare = lastfmSquare;
var toggleOff = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 896q0-104-40.5-198.5t-109.5-163.5-163.5-109.5-198.5-40.5-198.5 40.5-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5 198.5-40.5 163.5-109.5 109.5-163.5 40.5-198.5zM1920 896q0-104-40.5-198.5t-109.5-163.5-163.5-109.5-198.5-40.5h-386q119 90 188.5 224t69.5 288-69.5 288-188.5 224h386q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5zM2048 896q0 130-51 248.5t-136.5 204-204 136.5-248.5 51h-768q-130 0-248.5-51t-204-136.5-136.5-204-51-248.5 51-248.5 136.5-204 204-136.5 248.5-51h768q130 0 248.5 51t204 136.5 136.5 204 51 248.5z"
    }
  }]
};
exports.toggleOff = toggleOff;
var toggleOn = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 896q0-130 51-248.5t136.5-204 204-136.5 248.5-51h768q130 0 248.5 51t204 136.5 136.5 204 51 248.5-51 248.5-136.5 204-204 136.5-248.5 51h-768q-130 0-248.5-51t-204-136.5-136.5-204-51-248.5zM1408 1408q104 0 198.5-40.5t163.5-109.5 109.5-163.5 40.5-198.5-40.5-198.5-109.5-163.5-163.5-109.5-198.5-40.5-198.5 40.5-163.5 109.5-109.5 163.5-40.5 198.5 40.5 198.5 109.5 163.5 163.5 109.5 198.5 40.5z"
    }
  }]
};
exports.toggleOn = toggleOn;
var bicycle = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M762 1152h-314q-40 0-57.5-35t6.5-67l188-251q-65-31-137-31-132 0-226 94t-94 226 94 226 226 94q115 0 203-72.5t111-183.5zM576 1024h186q-18-85-75-148zM1056 1024l288-384h-480l-99 132q105 103 126 252h165zM2176 1088q0-132-94-226t-226-94q-60 0-121 24l174 260q15 23 10 49t-27 40q-15 11-36 11-35 0-53-29l-174-260q-93 95-93 225 0 132 94 226t226 94 226-94 94-226zM2304 1088q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-97 39.5-183.5t109.5-149.5l-65-98-353 469q-18 26-51 26h-197q-23 164-149 274t-294 110q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q114 0 215 55l137-183h-224q-26 0-45-19t-19-45 19-45 45-19h384v128h435l-85-128h-222q-26 0-45-19t-19-45 19-45 45-19h256q33 0 53 28l267 400q91-44 192-44 185 0 316.5 131.5t131.5 316.5z"
    }
  }]
};
exports.bicycle = bicycle;
var bus = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 1216q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1408 1216q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1362 820l-72-384q-5-23-22.5-37.5t-40.5-14.5h-918q-23 0-40.5 14.5t-22.5 37.5l-72 384q-5 30 14 53t49 23h1062q30 0 49-23t14-53zM1136 208q0-20-14-34t-34-14h-640q-20 0-34 14t-14 34 14 34 34 14h640q20 0 34-14t14-34zM1536 933v603h-128v128q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5v-128h-768v128q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5v-128h-128v-603q0-112 25-223l103-454q9-78 97.5-137t230-89 312.5-30 312.5 30 230 89 97.5 137l105 454q23 102 23 223z"
    }
  }]
};
exports.bus = bus;
var ioxhost = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1463 832q0 35-25 60.5t-61 25.5h-702q-36 0-61-25.5t-25-60.5 25-60.5 61-25.5h702q36 0 61 25.5t25 60.5zM1677 832q0-86-23-170h-982q-36 0-61-25t-25-60q0-36 25-61t61-25h908q-88-143-235-227t-320-84q-177 0-327.5 87.5t-238 237.5-87.5 327q0 86 23 170h982q36 0 61 25t25 60q0 36-25 61t-61 25h-908q88 143 235.5 227t320.5 84q132 0 253-51.5t208-139 139-208 52-253.5zM2048 577q0 35-25 60t-61 25h-131q17 85 17 170 0 167-65.5 319.5t-175.5 263-262.5 176-319.5 65.5q-246 0-448.5-133t-301.5-350h-189q-36 0-61-25t-25-61q0-35 25-60t61-25h132q-17-85-17-170 0-167 65.5-319.5t175.5-263 262.5-176 320.5-65.5q245 0 447.5 133t301.5 350h188q36 0 61 25t25 61z"
    }
  }]
};
exports.ioxhost = ioxhost;
var angellist = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M953 378l-114 328 117 21q165-451 165-518 0-56-38-56-57 0-130 225zM654 1065l33 88q37-42 71-67l-33-5.5t-38.5-7-32.5-8.5zM362 169q0 98 159 521 17-10 49-10 15 0 75 5l-121-351q-75-220-123-220-19 0-29 17.5t-10 37.5zM283 928q0 36 51.5 119t117.5 153 100 70q14 0 25.5-13t11.5-27q0-24-32-102-13-32-32-72t-47.5-89-61.5-81-62-32q-20 0-45.5 27t-25.5 47zM125 1263q0 41 25 104 59 145 183.5 227t281.5 82q227 0 382-170 152-169 152-427 0-43-1-67t-11.5-62-30.5-56q-56-49-211.5-75.5t-270.5-26.5q-37 0-49 11-12 5-12 35 0 34 21.5 60t55.5 40 77.5 23.5 87.5 11.5 85 4 70 0h23q24 0 40 19 15 19 19 55-28 28-96 54-61 22-93 46-64 46-108.5 114t-44.5 137q0 31 18.5 88.5t18.5 87.5l-3 12q-4 12-4 14-137-10-146-216-8 2-41 2 2 7 2 21 0 53-40.5 89.5t-94.5 36.5q-82 0-166.5-78t-84.5-159q0-34 33-67 52 64 60 76 77 104 133 104 12 0 26.5-8.5t14.5-20.5q0-34-87.5-145t-116.5-111q-43 0-70 44.5t-27 90.5zM11 1272q0-101 42.5-163t136.5-88q-28-74-28-104 0-62 61-123t122-61q29 0 70 15-163-462-163-567 0-80 41-130.5t119-50.5q131 0 325 581 6 17 8 23 6-16 29-79.5t43.5-118.5 54-127.5 64.5-123 70.5-86.5 76.5-36q71 0 112 49t41 122q0 108-159 550 61 15 100.5 46t58.5 78 26 93.5 7 110.5q0 150-47 280t-132 225-211 150-278 55q-111 0-223-42-149-57-258-191.5t-109-286.5z"
    }
  }]
};
exports.angellist = angellist;
var cc = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M785 1008h207q-14 158-98.5 248.5t-214.5 90.5q-162 0-254.5-116t-92.5-316q0-194 93-311.5t233-117.5q148 0 232 87t97 247h-203q-5-64-35.5-99t-81.5-35q-57 0-88.5 60.5t-31.5 177.5q0 48 5 84t18 69.5 40 51.5 66 18q95 0 109-139zM1497 1008h206q-14 158-98 248.5t-214 90.5q-162 0-254.5-116t-92.5-316q0-194 93-311.5t233-117.5q148 0 232 87t97 247h-204q-4-64-35-99t-81-35q-57 0-88.5 60.5t-31.5 177.5q0 48 5 84t18 69.5 39.5 51.5 65.5 18q49 0 76.5-38t33.5-101zM1856 889q0-207-15.5-307t-60.5-161q-6-8-13.5-14t-21.5-15-16-11q-86-63-697-63-625 0-710 63-5 4-17.5 11.5t-21 14-14.5 14.5q-45 60-60 159.5t-15 308.5q0 208 15 307.5t60 160.5q6 8 15 15t20.5 14 17.5 12q44 33 239.5 49t470.5 16q610 0 697-65 5-4 17-11t20.5-14 13.5-16q46-60 61-159t15-309zM2048 128v1536h-2048v-1536h2048z"
    }
  }]
};
exports.cc = cc;
var ils = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"
    }
  }]
};
exports.ils = ils;
var shekel = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"
    }
  }]
};
exports.shekel = shekel;
var sheqel = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M992 624v496q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-496q0-112-80-192t-192-80h-272v1152q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-1344q0-14 9-23t23-9h464q135 0 249 66.5t180.5 180.5 66.5 249zM1376 160v880q0 135-66.5 249t-180.5 180.5-249 66.5h-464q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h160q14 0 23 9t9 23v768h272q112 0 192-80t80-192v-880q0-14 9-23t23-9h160q14 0 23 9t9 23z"
    }
  }]
};
exports.sheqel = sheqel;
var meanpath = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1311 842v114q0 24-13.5 38t-37.5 14h-202q-24 0-38-14t-14-38v-114q0-24 14-38t38-14h202q24 0 37.5 14t13.5 38zM821 1072v-250q0-53-32.5-85.5t-85.5-32.5h-133q-68 0-96 52-28-52-96-52h-130q-53 0-85.5 32.5t-32.5 85.5v250q0 22 21 22h55q22 0 22-22v-230q0-24 13.5-38t38.5-14h94q24 0 38 14t14 38v230q0 22 21 22h54q22 0 22-22v-230q0-24 14-38t38-14h97q24 0 37.5 14t13.5 38v230q0 22 22 22h55q21 0 21-22zM1410 976v-154q0-53-33-85.5t-86-32.5h-264q-53 0-86 32.5t-33 85.5v410q0 21 22 21h55q21 0 21-21v-180q31 42 94 42h191q53 0 86-32.5t33-85.5zM1536 360v1072q0 96-68 164t-164 68h-1072q-96 0-164-68t-68-164v-1072q0-96 68-164t164-68h1072q96 0 164 68t68 164z"
    }
  }]
};
exports.meanpath = meanpath;
var buysellads = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M915 1086h-294l147-551zM1001 1408h311l-324-1024h-440l-324 1024h311l383-314zM1536 416v960q0 118-85 203t-203 85h-960q-118 0-203-85t-85-203v-960q0-118 85-203t203-85h960q118 0 203 85t85 203z"
    }
  }]
};
exports.buysellads = buysellads;
var connectdevelop = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2048 895q0 21-13 36.5t-33 19.5l-205 356q3 9 3 18 0 20-12.5 35.5t-32.5 19.5l-193 337q3 8 3 16 0 23-16.5 40t-40.5 17q-25 0-41-18h-400q-17 20-43 20t-43-20h-399q-17 20-43 20-23 0-40-16.5t-17-40.5q0-8 4-20l-193-335q-20-4-32.5-19.5t-12.5-35.5q0-9 3-18l-206-356q-20-5-32.5-20.5t-12.5-35.5q0-21 13.5-36.5t33.5-19.5l199-344q0-1-0.5-3t-0.5-3q0-36 34-51l209-363q-4-10-4-18 0-24 17-40.5t40-16.5q26 0 44 21h396q16-21 43-21t43 21h398q18-21 44-21 23 0 40 16.5t17 40.5q0 6-4 18l207 358q23 1 39 17.5t16 38.5q0 13-7 27l187 324q19 4 31.5 19.5t12.5 35.5zM1063 1694h389l-342-354h-143l-342 354h360q18-16 39-16t39 16zM112 882q1 4 1 13 0 10-2 15l208 360 15 6 188-199v-347l-187-194q-13 8-29 10zM986 98h-388l190 200 554-200h-280q-16 16-38 16t-38-16zM1689 1310q1-6 5-11l-64-68-17 79h76zM1583 1310l22-105-252-266-296 307 63 64h463zM1495 1678l16-28 65-310h-427l333 343q8-4 13-5zM578 1694h5l342-354h-373v335l4 6q14 5 22 13zM552 1310h402l64-66-309-321-157 166v221zM359 1310h163v-189l-168 177q4 8 5 12zM358 485q0 1 0.5 2t0.5 2q0 16-8 29l171 177v-269zM552 415v311l153 157 297-314-223-236zM556 111l-4 8v264l205-74-191-201q-6 2-10 3zM1447 98h-16l-621 224 213 225zM1023 590l-297 315 311 319 296-307zM688 902l-136-141v284zM1038 1266l-42 44h85zM1374 918l238 251 132-624-3-5-1-1zM1718 518q-8-13-8-29v-2l-216-376q-5-1-13-5l-437 463 310 327zM522 394v-223l-163 282zM522 1340h-163l163 283v-283zM1607 1340l-48 227 130-227h-82zM1729 1270l207-361q-2-10-2-14 0-1 3-16l-171-296-129 612 77 82q5-3 15-7z"
    }
  }]
};
exports.connectdevelop = connectdevelop;
var dashcube = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 680q0-131 91.5-226.5t222.5-95.5h742l352-358v1470q0 132-91.5 227t-222.5 95h-780q-131 0-222.5-95t-91.5-227v-790zM1232 1434l-176-180v-425q0-46-32-79t-78-33h-484q-46 0-78 33t-32 79v492q0 46 32.5 79.5t77.5 33.5h770z"
    }
  }]
};
exports.dashcube = dashcube;
var forumbee = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M934 150q-317 121-556 362.5t-358 560.5q-20-89-20-176 0-208 102.5-384.5t278.5-279 384-102.5q82 0 169 19zM1203 269q93 65 164 155-389 113-674.5 400.5t-396.5 676.5q-93-72-155-162 112-386 395-671t667-399zM470 1603q115-356 379.5-622t619.5-384q40 92 54 195-292 120-516 345t-343 518q-103-14-194-52zM1536 1661q-193-50-367-115-135 84-290 107 109-205 274-370.5t369-275.5q-21 152-101 284 65 175 115 370z"
    }
  }]
};
exports.forumbee = forumbee;
var leanpub = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1893 392l155 1272q-131 0-257-57-200-91-393-91-226 0-374 148-148-148-374-148-193 0-393 91-128 57-252 57h-5l155-1272q224-127 482-127 233 0 387 106 154-106 387-106 258 0 482 127zM1398 1379q129 0 232 28.5t260 93.5l-124-1021q-171-78-368-78-224 0-374 141-150-141-374-141-197 0-368 78l-124 1021q105-43 165.5-65t148.5-39.5 178-17.5q202 0 374 108 172-108 374-108zM1438 1345l-55-907q-211 4-359 155-152-155-374-155-176 0-336 66l-114 941q124-51 228.5-76t221.5-25q209 0 374 102 172-107 374-102z"
    }
  }]
};
exports.leanpub = leanpub;
var sellsy = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1500 1371v-733q0-21-15-36t-35-15h-93q-20 0-35 15t-15 36v733q0 20 15 35t35 15h93q20 0 35-15t15-35zM1216 1371v-531q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v531q0 20 15 35t35 15h101q20 0 35-15t15-35zM924 1371v-429q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v429q0 20 15 35t35 15h101q20 0 35-15t15-35zM632 1371v-362q0-20-15-35t-35-15h-101q-20 0-35 15t-15 35v362q0 20 15 35t35 15h101q20 0 35-15t15-35zM2048 1225q0 166-118 284t-284 118h-1244q-166 0-284-118t-118-284q0-116 63-214.5t168-148.5q-10-34-10-73 0-113 80.5-193.5t193.5-80.5q102 0 180 67 45-183 194-300t338-117q149 0 275 73.5t199.5 199.5 73.5 275q0 66-14 122 135 33 221 142.5t86 247.5z"
    }
  }]
};
exports.sellsy = sellsy;
var shirtsinbulk = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0h1536v1392l-776 338-760-338v-1392zM1436 1327v-926h-1336v926l661 294zM1436 301v-201h-1336v201h1336zM181 599v115h-37v-115h37zM181 747v115h-37v-115h37zM181 895v115h-37v-115h37zM181 1043v115h-37v-115h37zM181 1191v115h-37v-115h37zM207 1334l15-34 105 47-15 33zM343 1394l15-34 105 46-15 34zM478 1454l15-34 105 46-15 34zM614 1513l15-33 104 46-15 34zM797 1526l105-46 15 33-105 47zM932 1466l105-46 15 34-105 46zM1068 1406l105-46 15 34-105 46zM1203 1347l105-47 15 34-105 46zM259 147v36h-114v-36h114zM421 147v36h-115v-36h115zM583 147v36h-115v-36h115zM744 147v36h-114v-36h114zM906 147v36h-114v-36h114zM1068 147v36h-115v-36h115zM1230 147v36h-115v-36h115zM1391 147v36h-114v-36h114zM181 487v79h-37v-115h115v36h-78zM421 451v36h-115v-36h115zM583 451v36h-115v-36h115zM744 451v36h-114v-36h114zM906 451v36h-114v-36h114zM1068 451v36h-115v-36h115zM1230 451v36h-115v-36h115zM1355 566v-79h-78v-36h115v115h-37zM1355 714v-115h37v115h-37zM1355 862v-115h37v115h-37zM1355 1010v-115h37v115h-37zM1355 1158v-115h37v115h-37zM1355 1306v-115h37v115h-37zM760 1271q-129 0-221-91.5t-92-221.5q0-129 92-221t221-92q130 0 221.5 92t91.5 221q0 130-91.5 221.5t-221.5 91.5zM595 890q0 36 19.5 56.5t49.5 25 64 7 64 2 49.5 9 19.5 30.5q0 49-112 49-97 0-123-51h-3l-31 63q67 42 162 42 29 0 56.5-5t55.5-16 45.5-33 17.5-53q0-46-27.5-69.5t-67.5-27-79.5-3-67-5-27.5-25.5q0-21 20.5-33t40.5-15 41-3q34 0 70.5 11t51.5 34h3l30-58q-3-1-21-8.5t-22.5-9-19.5-7-22-7-20-4.5-24-4-23-1q-29 0-56.5 5t-54 16.5-43 34-16.5 53.5z"
    }
  }]
};
exports.shirtsinbulk = shirtsinbulk;
var simplybuilt = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M863 1032q0-112-79.5-191.5t-191.5-79.5-191 79.5-79 191.5 79 191 191 79 191.5-79 79.5-191zM1726 1031q0-112-79-191t-191-79-191.5 79-79.5 191q0 113 79.5 192t191.5 79 191-79.5 79-191.5zM2048 222v1348q0 44-31.5 75.5t-76.5 31.5h-1832q-45 0-76.5-31.5t-31.5-75.5v-1348q0-44 31.5-75.5t76.5-31.5h431q44 0 76 31.5t32 75.5v161h754v-161q0-44 32-75.5t76-31.5h431q45 0 76.5 31.5t31.5 75.5z"
    }
  }]
};
exports.simplybuilt = simplybuilt;
var skyatlas = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1430 583zM1690 787q148 0 253 98.5t105 244.5q0 157-109 261.5t-267 104.5q-85 0-162-27.5t-138-73.5-118-106-109-126-103.5-132.5-108.5-126.5-117-106-136-73.5-159-27.5q-154 0-251.5 91.5t-97.5 244.5q0 157 104 250t263 93q100 0 208-37.5t193-98.5q5-4 21-18.5t30-24 22-9.5q14 0 24.5 10.5t10.5 24.5q0 24-60 77-101 88-234.5 142t-260.5 54q-133 0-245.5-58t-180-165-67.5-241q0-205 141.5-341t347.5-136q120 0 226.5 43.5t185.5 113 151.5 153 139 167.5 133.5 153.5 149.5 113 172.5 43.5q102 0 168.5-61.5t66.5-162.5q0-95-64.5-159t-159.5-64q-30 0-81.5 18.5t-68.5 18.5q-20 0-35.5-15t-15.5-35q0-18 8.5-57t8.5-59q0-159-107.5-263t-266.5-104q-58 0-111.5 18.5t-84 40.5-55.5 40.5-33 18.5q-15 0-25.5-10.5t-10.5-25.5q0-19 25-46 59-67 147-103.5t182-36.5q191 0 318 125.5t127 315.5q0 37-4 66 57-15 115-15z"
    }
  }]
};
exports.skyatlas = skyatlas;
var cartPlus = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1216 704q0-26-19-45t-45-19h-128v-128q0-26-19-45t-45-19-45 19-19 45v128h-128q-26 0-45 19t-19 45 19 45 45 19h128v128q0 26 19 45t45 19 45-19 19-45v-128h128q26 0 45-19t19-45zM640 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1536 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1664 448v512q0 24-16 42.5t-41 21.5l-1044 122q1 7 4.5 21.5t6 26.5 2.5 22q0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-14 11-39.5t29.5-59.5 20.5-38l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t20 15.5 13 24.5 7.5 26.5 5.5 29.5 4.5 25.5h1201q26 0 45 19t19 45z"
    }
  }]
};
exports.cartPlus = cartPlus;
var cartArrowDown = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 704q0-26-19-45t-45-19-45 19l-147 146v-293q0-26-19-45t-45-19-45 19-19 45v293l-147-146q-19-19-45-19t-45 19-19 45 19 45l256 256q19 19 45 19t45-19l256-256q19-19 19-45zM640 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1536 1536q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1664 448v512q0 24-16 42.5t-41 21.5l-1044 122q1 7 4.5 21.5t6 26.5 2.5 22q0 16-24 64h920q26 0 45 19t19 45-19 45-45 19h-1024q-26 0-45-19t-19-45q0-14 11-39.5t29.5-59.5 20.5-38l-177-823h-204q-26 0-45-19t-19-45 19-45 45-19h256q16 0 28.5 6.5t20 15.5 13 24.5 7.5 26.5 5.5 29.5 4.5 25.5h1201q26 0 45 19t19 45z"
    }
  }]
};
exports.cartArrowDown = cartArrowDown;
var diamond = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M212 768l623 665-300-665h-323zM1024 1540l349-772h-698zM538 640l204-384h-262l-288 384h346zM1213 1433l623-665h-323zM683 640h682l-204-384h-274zM1510 640h346l-288-384h-262zM1651 154l384 512q14 18 13 41.5t-17 40.5l-960 1024q-18 20-47 20t-47-20l-960-1024q-16-17-17-40.5t13-41.5l384-512q18-26 51-26h1152q33 0 51 26z"
    }
  }]
};
exports.diamond = diamond;
var ship = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1811 1555q19-19 45-19t45 19l128 128-90 90-83-83-83 83q-18 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-128-128 90-90 83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83 83-83q19-19 45-19t45 19l83 83zM237 1517q-19 19-45 19t-45-19l-128-128 90-90 83 82 83-82q19-19 45-19t45 19l83 82 64-64v-293l-210-314q-17-26-7-56.5t40-40.5l177-58v-299h128v-128h256v-128h256v128h256v128h128v299l177 58q30 10 40 40.5t-7 56.5l-210 314v293l19-18q19-19 45-19t45 19l83 82 83-82q19-19 45-19t45 19l128 128-90 90-83-83-83 83q-18 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83-83 83q-19 19-45 19t-45-19l-83-83zM640 384v128l384-128 384 128v-128h-128v-128h-512v128h-128z"
    }
  }]
};
exports.ship = ship;
var userSecret = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M576 1536l96-448-96-128-128-64zM832 1536l128-640-128 64-96 128zM992 526q-2-4-4-6-10-8-96-8-70 0-167 19-7 2-21 2t-21-2q-97-19-167-19-86 0-96 8-2 2-4 6 2 18 4 27 2 3 7.5 6.5t7.5 10.5q2 4 7.5 20.5t7 20.5 7.5 17 8.5 17 9 14 12 13.5 14 9.5 17.5 8 20.5 4 24.5 2q36 0 59-12.5t32.5-30 14.5-34.5 11.5-29.5 17.5-12.5h12q11 0 17.5 12.5t11.5 29.5 14.5 34.5 32.5 30 59 12.5q13 0 24.5-2t20.5-4 17.5-8 14-9.5 12-13.5 9-14 8.5-17 7.5-17 7-20.5 7.5-20.5q2-7 7.5-10.5t7.5-6.5q2-9 4-27zM1408 1405q0 121-73 190t-194 69h-874q-121 0-194-69t-73-190q0-61 4.5-118t19-125.5 37.5-123.5 63.5-103.5 93.5-74.5l-90-220h214q-22-64-22-128 0-12 2-32-194-40-194-96 0-57 210-99 17-62 51.5-134t70.5-114q32-37 76-37 30 0 84 31t84 31 84-31 84-31q44 0 76 37 36 42 70.5 114t51.5 134q210 42 210 99 0 56-194 96 7 81-20 160h214l-82 225q63 33 107.5 96.5t65.5 143.5 29 151.5 8 148.5z"
    }
  }]
};
exports.userSecret = userSecret;
var motorcycle = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2301 1036q12 103-22 198.5t-99 163.5-158.5 106-196.5 31q-161-11-279.5-125t-134.5-274q-12-111 27.5-210.5t118.5-170.5l-71-107q-96 80-151 194t-55 244q0 27-18.5 46.5t-45.5 19.5h-256-69q-23 164-149 274t-294 110q-185 0-316.5-131.5t-131.5-316.5 131.5-316.5 316.5-131.5q76 0 152 27l24-45q-123-110-304-110h-64q-26 0-45-19t-19-45 19-45 45-19h128q78 0 145 13.5t116.5 38.5 71.5 39.5 51 36.5h512 115l-85-128h-222q-30 0-49-22.5t-14-52.5q4-23 23-38t43-15h253q33 0 53 28l70 105 114-114q19-19 46-19h101q26 0 45 19t19 45v128q0 26-19 45t-45 19h-179l115 172q131-63 275-36 143 26 244 134.5t118 253.5zM448 1408q115 0 203-72.5t111-183.5h-314q-35 0-55-31-18-32-1-63l147-277q-47-13-91-13-132 0-226 94t-94 226 94 226 226 94zM1856 1408q132 0 226-94t94-226-94-226-226-94q-60 0-121 24l174 260q15 23 10 49t-27 40q-15 11-36 11-35 0-53-29l-174-260q-93 95-93 225 0 132 94 226t226 94z"
    }
  }]
};
exports.motorcycle = motorcycle;
var streetView = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 1536q0 63-61.5 113.5t-164 81-225 46-253.5 15.5-253.5-15.5-225-46-164-81-61.5-113.5q0-49 33-88.5t91-66.5 118-44.5 131-29.5q26-5 48 10.5t26 41.5q5 26-10.5 48t-41.5 26q-58 10-106 23.5t-76.5 25.5-48.5 23.5-27.5 19.5-8.5 12q3 11 27 26.5t73 33 114 32.5 160.5 25 201.5 10 201.5-10 160.5-25 114-33 73-33.5 27-27.5q-1-4-8.5-11t-27.5-19-48.5-23.5-76.5-25-106-23.5q-26-4-41.5-26t-10.5-48q4-26 26-41.5t48-10.5q71 12 131 29.5t118 44.5 91 66.5 33 88.5zM1024 640v384q0 26-19 45t-45 19h-64v384q0 26-19 45t-45 19h-256q-26 0-45-19t-19-45v-384h-64q-26 0-45-19t-19-45v-384q0-53 37.5-90.5t90.5-37.5h384q53 0 90.5 37.5t37.5 90.5zM928 256q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5z"
    }
  }]
};
exports.streetView = streetView;
var heartbeat = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1024h305q-5 6-10 10.5t-9 7.5l-3 4-623 600q-18 18-44 18t-44-18l-624-602q-5-2-21-20h369q22 0 39.5-13.5t22.5-34.5l70-281 190 667q6 20 23 33t39 13q21 0 38-13t23-33l146-485 56 112q18 35 57 35zM1792 596q0 145-103 300h-369l-111-221q-8-17-25.5-27t-36.5-8q-45 5-56 46l-129 430-196-686q-6-20-23.5-33t-39.5-13-39 13.5-22 34.5l-116 464h-423q-103-155-103-300 0-220 127-344t351-124q62 0 126.5 21.5t120 58 95.5 68.5 76 68q36-36 76-68t95.5-68.5 120-58 126.5-21.5q224 0 351 124t127 344z"
    }
  }]
};
exports.heartbeat = heartbeat;
var venus = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 576q0 221-147.5 384.5t-364.5 187.5v260h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-260q-150-16-271.5-103t-186-224-52.5-292q11-134 80.5-249t182-188 245.5-88q170-19 319 54t236 212 87 306zM128 576q0 185 131.5 316.5t316.5 131.5 316.5-131.5 131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5z"
    }
  }]
};
exports.venus = venus;
var mars = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1472 128q26 0 45 19t19 45v416q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-262l-382 383q126 156 126 359 0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5q203 0 359 126l382-382h-261q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h416zM576 1536q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.mars = mars;
var mercury = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M830 316q145 72 233.5 210.5t88.5 305.5q0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-217-24-364.5-187.5t-147.5-384.5q0-167 88.5-305.5t233.5-210.5q-165-96-228-273-6-16 3.5-29.5t26.5-13.5h69q21 0 29 20 44 106 140 171t214 65 214-65 140-171q8-20 37-20h61q17 0 26.5 13.5t3.5 29.5q-63 177-228 273zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.mercury = mercury;
var intersex = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-149-16-270.5-103t-186.5-223.5-53-291.5q16-204 160-353.5t347-172.5q118-14 228 19t198 103l255-254h-134q-14 0-23-9t-9-23v-64zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.intersex = intersex;
var transgender = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-149-16-270.5-103t-186.5-223.5-53-291.5q16-204 160-353.5t347-172.5q118-14 228 19t198 103l255-254h-134q-14 0-23-9t-9-23v-64zM576 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.transgender = transgender;
var transgenderAlt = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q126 158 126 359 0 221-147.5 384.5t-364.5 187.5v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-217-24-364.5-187.5t-147.5-384.5q0-201 126-359l-52-53-101 111q-9 10-22 10.5t-23-7.5l-48-44q-10-8-10.5-21.5t8.5-23.5l105-115-111-112v134q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-288q0-26 19-45t45-19h288q14 0 23 9t9 23v64q0 14-9 23t-23 9h-133l106 107 86-94q9-10 22-10.5t23 7.5l48 44q10 8 10.5 21.5t-8.5 23.5l-90 99 57 56q158-126 359-126t359 126l255-254h-134q-14 0-23-9t-9-23v-64zM832 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.transgenderAlt = transgenderAlt;
var venusDouble = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1790 529q12 155-52.5 292t-186 224-271.5 103v260h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-512v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-260q-150-16-271.5-103t-186-224-52.5-292q17-206 164.5-356.5t352.5-169.5q206-21 377 94 171-115 377-94 205 19 352.5 169.5t164.5 356.5zM896 889q128-131 128-313t-128-313q-128 131-128 313t128 313zM576 1024q115 0 218-57-154-165-154-391 0-224 154-391-103-57-218-57-185 0-316.5 131.5t-131.5 316.5 131.5 316.5 316.5 131.5zM1152 1408v-260q-137-15-256-94-119 79-256 94v260h512zM1216 1024q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5q-115 0-218 57 154 167 154 391 0 226-154 391 103 57 218 57z"
    }
  }]
};
exports.venusDouble = venusDouble;
var marsDouble = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 416q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q76 95 107.5 214t9.5 247q-31 182-166 312t-318 156q-210 29-384.5-80t-241.5-300q-117-6-221-57.5t-177.5-133-113.5-192.5-32-230q9-135 78-252t182-191.5 248-89.5q118-14 227.5 19t198.5 103l255-254h-134q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q59 74 93 169 182 9 328 124l255-254h-134q-14 0-23-9t-9-23v-64zM1024 832q0-20-4-58-162 25-271 150t-109 292q0 20 4 58 162-25 271-150t109-292zM128 832q0 168 111 294t276 149q-3-29-3-59 0-210 135-369.5t338-196.5q-53-120-163.5-193t-245.5-73q-185 0-316.5 131.5t-131.5 316.5zM1088 1664q185 0 316.5-131.5t131.5-316.5q0-168-111-294t-276-149q3 28 3 59 0 210-135 369.5t-338 196.5q53 120 163.5 193t245.5 73z"
    }
  }]
};
exports.marsDouble = marsDouble;
var venusMars = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 32q0-14 9-23t23-9h288q26 0 45 19t19 45v288q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-134l-254 255q76 95 107.5 214t9.5 247q-32 180-164.5 310t-313.5 157q-223 34-409-90-117 78-256 93v132h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96v96q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-96h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-132q-155-17-279.5-109.5t-187-237.5-39.5-307q25-187 159.5-322.5t320.5-164.5q224-34 410 90 146-97 320-97 201 0 359 126l255-254h-134q-14 0-23-9t-9-23v-64zM896 1145q128-131 128-313t-128-313q-128 131-128 313t128 313zM128 832q0 185 131.5 316.5t316.5 131.5q117 0 218-57-154-167-154-391t154-391q-101-57-218-57-185 0-316.5 131.5t-131.5 316.5zM1216 1280q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5q-117 0-218 57 154 167 154 391t-154 391q101 57 218 57z"
    }
  }]
};
exports.venusMars = venusMars;
var marsStroke = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1472 128q26 0 45 19t19 45v416q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-262l-213 214 140 140q9 10 9 23t-9 22l-46 46q-9 9-22 9t-23-9l-140-141-78 79q126 156 126 359 0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5q203 0 359 126l78-78-172-172q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l172 172 213-213h-261q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h416zM576 1536q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.marsStroke = marsStroke;
var marsStrokeV = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 644q217 24 364.5 187.5t147.5 384.5q0 167-87 306t-236 212-319 54q-133-15-245.5-88t-182-188-80.5-249q-12-155 52.5-292t186-224 271.5-103v-132h-160q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h160v-165l-92 92q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l202-201q19-19 45-19t45 19l202 201q9 10 9 23t-9 22l-46 46q-9 9-22 9t-23-9l-92-92v165h160q14 0 23 9t9 23v64q0 14-9 23t-23 9h-160v132zM576 1664q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.marsStrokeV = marsStrokeV;
var marsStrokeH = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1901 915q19 19 19 45t-19 45l-294 294q-9 10-22.5 10t-22.5-10l-45-45q-10-9-10-22.5t10-22.5l185-185h-294v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-132q-24 217-187.5 364.5t-384.5 147.5q-167 0-306-87t-212-236-54-319q15-133 88-245.5t188-182 249-80.5q155-12 292 52.5t224 186 103 271.5h132v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224h294l-185-185q-10-9-10-22.5t10-22.5l45-45q9-10 22.5-10t22.5 10zM576 1408q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.marsStrokeH = marsStrokeH;
var neuter = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 576q0 221-147.5 384.5t-364.5 187.5v612q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-612q-217-24-364.5-187.5t-147.5-384.5q0-117 45.5-223.5t123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5zM576 1024q185 0 316.5-131.5t131.5-316.5-131.5-316.5-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5z"
    }
  }]
};
exports.neuter = neuter;
var genderless = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 960q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5 131.5 316.5 316.5 131.5 316.5-131.5 131.5-316.5zM1152 960q0 117-45.5 223.5t-123 184-184 123-223.5 45.5-223.5-45.5-184-123-123-184-45.5-223.5 45.5-223.5 123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5z"
    }
  }]
};
exports.genderless = genderless;
var facebookOfficial = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1451 128q35 0 60 25t25 60v1366q0 35-25 60t-60 25h-391v-595h199l30-232h-229v-148q0-56 23.5-84t91.5-28l122-1v-207q-63-9-178-9-136 0-217.5 80t-81.5 226v171h-200v232h200v595h-735q-35 0-60-25t-25-60v-1366q0-35 25-60t60-25h1366z"
    }
  }]
};
exports.facebookOfficial = facebookOfficial;
var pinterestP = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 597q0-108 37.5-203.5t103.5-166.5 152-123 185-78 202-26q158 0 294 66.5t221 193.5 85 287q0 96-19 188t-60 177-100 149.5-145 103-189 38.5q-68 0-135-32t-96-88q-10 39-28 112.5t-23.5 95-20.5 71-26 71-32 62.5-46 77.5-62 86.5l-14 5-9-10q-15-157-15-188 0-92 21.5-206.5t66.5-287.5 52-203q-32-65-32-169 0-83 52-156t132-73q61 0 95 40.5t34 102.5q0 66-44 191t-44 187q0 63 45 104.5t109 41.5q55 0 102-25t78.5-68 56-95 38-110.5 20-111 6.5-99.5q0-173-109.5-269.5t-285.5-96.5q-200 0-334 129.5t-134 328.5q0 44 12.5 85t27 65 27 45.5 12.5 30.5q0 28-15 73t-37 45q-2 0-17-3-51-15-90.5-56t-61-94.5-32.5-108-11-106.5z"
    }
  }]
};
exports.pinterestP = pinterestP;
var whatsapp = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M985 974q13 0 97.5 44t89.5 53q2 5 2 15 0 33-17 76-16 39-71 65.5t-102 26.5q-57 0-190-62-98-45-170-118t-148-185q-72-107-71-194v-8q3-91 74-158 24-22 52-22 6 0 18 1.5t19 1.5q19 0 26.5 6.5t15.5 27.5q8 20 33 88t25 75q0 21-34.5 57.5t-34.5 46.5q0 7 5 15 34 73 102 137 56 53 151 101 12 7 22 7 15 0 54-48.5t52-48.5zM782 1504q127 0 243.5-50t200.5-134 134-200.5 50-243.5-50-243.5-134-200.5-200.5-134-243.5-50-243.5 50-200.5 134-134 200.5-50 243.5q0 203 120 368l-79 233 242-77q158 104 345 104zM782 122q153 0 292.5 60t240.5 161 161 240.5 60 292.5-60 292.5-161 240.5-240.5 161-292.5 60q-195 0-365-94l-417 134 136-405q-108-178-108-389 0-153 60-292.5t161-240.5 240.5-161 292.5-60z"
    }
  }]
};
exports.whatsapp = whatsapp;
var server = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M128 1408h1024v-128h-1024v128zM128 896h1024v-128h-1024v128zM1696 1344q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM128 384h1024v-128h-1024v128zM1696 832q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1696 320q0-40-28-68t-68-28-68 28-28 68 28 68 68 28 68-28 28-68zM1792 1152v384h-1792v-384h1792zM1792 640v384h-1792v-384h1792zM1792 128v384h-1792v-384h1792z"
    }
  }]
};
exports.server = server;
var userPlus = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 896q-159 0-271.5-112.5t-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5-112.5 271.5-271.5 112.5zM1664 1024h352q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-352v352q0 13-9.5 22.5t-22.5 9.5h-192q-13 0-22.5-9.5t-9.5-22.5v-352h-352q-13 0-22.5-9.5t-9.5-22.5v-192q0-13 9.5-22.5t22.5-9.5h352v-352q0-13 9.5-22.5t22.5-9.5h192q13 0 22.5 9.5t9.5 22.5v352zM928 1248q0 52 38 90t90 38h256v238q-68 50-171 50h-874q-121 0-194-69t-73-190q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q19 0 39 17 79 61 154.5 91.5t164.5 30.5 164.5-30.5 154.5-91.5q20-17 39-17 132 0 217 96h-223q-52 0-90 38t-38 90v192z"
    }
  }]
};
exports.userPlus = userPlus;
var userTimes = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 896q-159 0-271.5-112.5t-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5-112.5 271.5-271.5 112.5zM1781 1216l249 249q9 9 9 23 0 13-9 22l-136 136q-9 9-22 9-14 0-23-9l-249-249-249 249q-9 9-23 9-13 0-22-9l-136-136q-9-9-9-22 0-14 9-23l249-249-249-249q-9-9-9-23 0-13 9-22l136-136q9-9 22-9 14 0 23 9l249 249 249-249q9-9 23-9 13 0 22 9l136 136q9 9 9 22 0 14-9 23zM1283 1216l-181 181q-37 37-37 91 0 53 37 90l83 83q-21 3-44 3h-874q-121 0-194-69t-73-190q0-53 3.5-103.5t14-109 26.5-108.5 43-97.5 62-81 85.5-53.5 111.5-20q19 0 39 17 154 122 319 122t319-122q20-17 39-17 28 0 57 6-28 27-41 50t-13 56q0 54 37 91z"
    }
  }]
};
exports.userTimes = userTimes;
var bed = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1024h1728q26 0 45 19t19 45v448h-256v-256h-1536v256h-256v-1216q0-26 19-45t45-19h128q26 0 45 19t19 45v704zM832 704q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM2048 960v-64q0-159-112.5-271.5t-271.5-112.5h-704q-26 0-45 19t-19 45v384h1152z"
    }
  }]
};
exports.bed = bed;
var hotel = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1024h1728q26 0 45 19t19 45v448h-256v-256h-1536v256h-256v-1216q0-26 19-45t45-19h128q26 0 45 19t19 45v704zM832 704q0-106-75-181t-181-75-181 75-75 181 75 181 181 75 181-75 75-181zM2048 960v-64q0-159-112.5-271.5t-271.5-112.5h-704q-26 0-45 19t-19 45v384h1152z"
    }
  }]
};
exports.hotel = hotel;
var viacoin = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 0l-192 448h192v192h-274l-55 128h329v192h-411l-357 832-357-832h-411v-192h329l-55-128h-274v-192h192l-192-448h256l323 768h378l323-768h256zM768 1216l108-256h-216z"
    }
  }]
};
exports.viacoin = viacoin;
var train = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 0q185 0 316.5 93.5t131.5 226.5v896q0 130-125.5 222t-305.5 97l213 202q16 15 8 35t-30 20h-1056q-22 0-30-20t8-35l213-202q-180-5-305.5-97t-125.5-222v-896q0-133 131.5-226.5t316.5-93.5h640zM768 1344q80 0 136-56t56-136-56-136-136-56-136 56-56 136 56 136 136 56zM1344 768v-512h-1152v512h1152z"
    }
  }]
};
exports.train = train;
var subway = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 0q185 0 316.5 93.5t131.5 226.5v896q0 130-125.5 222t-305.5 97l213 202q16 15 8 35t-30 20h-1056q-22 0-30-20t8-35l213-202q-180-5-305.5-97t-125.5-222v-896q0-133 131.5-226.5t316.5-93.5h640zM288 1312q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM704 768v-512h-544v512h544zM1248 1312q66 0 113-47t47-113-47-113-113-47-113 47-47 113 47 113 113 47zM1408 768v-512h-576v512h576z"
    }
  }]
};
exports.subway = subway;
var medium = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M597 421v1173q0 25-12.5 42.5t-36.5 17.5q-17 0-33-8l-465-233q-21-10-35.5-33.5t-14.5-46.5v-1140q0-20 10-34t29-14q14 0 44 15l511 256q3 3 3 5zM661 522l534 866-534-266v-600zM1792 540v1054q0 25-14 40.5t-38 15.5-47-13l-441-220zM1789 420q0 3-256.5 419.5t-300.5 487.5l-390-634 324-527q17-28 52-28 14 0 26 6l541 270q4 2 4 6z"
    }
  }]
};
exports.medium = medium;
var yCombinator = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 128v1536h-1536v-1536h1536z"
    }
  }]
};
exports.yCombinator = yCombinator;
var yc = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M809 1004l266-499h-112l-157 312q-24 48-44 92l-42-92-155-312h-120l263 493v324h101v-318zM1536 128v1536h-1536v-1536h1536z"
    }
  }]
};
exports.yc = yc;
var optinMonster = {
  "viewBox": "0 0 2296 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M478 1675q-8 16-27 34.5t-37 25.5q-25 9-51.5-3.5t-28.5-31.5q-1-22 40-55t68-38q23-4 34 21.5t2 46.5zM1819 1675q7 16 26 34.5t38 25.5q25 9 51.5-3.5t27.5-31.5q2-22-39.5-55t-68.5-38q-22-4-33 21.5t-2 46.5zM1867 1566q13 27 56.5 59.5t77.5 41.5q45 13 82-4.5t37-50.5q0-46-67.5-100.5t-115.5-59.5q-40-5-63.5 37.5t-6.5 76.5zM428 1566q-13 27-56 59.5t-77 41.5q-45 13-82-4.5t-37-50.5q0-46 67.5-100.5t115.5-59.5q40-5 63 37.5t6 76.5zM1158 442h1q-41 0-76 15 27 8 44 30.5t17 49.5q0 35-27 60t-65 25q-52 0-80-43-5 23-5 42 0 74 56 126.5t135 52.5q80 0 136-52.5t56-126.5-56-126.5-136-52.5zM1462 224q-99-109-220.5-131.5t-245.5 44.5q27-60 82.5-96.5t118-39.5 121.5 17 99.5 74.5 44.5 131.5zM2212 1463q8 11-11 42 7 23 7 40 1 56-44.5 112.5t-109.5 91.5-118 37q-48 2-92-21.5t-66-65.5q-687 25-1259 0-23 41-66.5 65t-92.5 22q-86-3-179.5-80.5t-92.5-160.5q2-22 7-40-19-31-11-42 6-10 31-1 14-22 41-51-7-29 2-38 11-10 39 4 29-20 59-34 0-29 13-37 23-12 51 16 35-5 61 2 18 4 38 19v-73q-11 0-18-2-53-10-97-44.5t-55-87.5q-9-38 0-81 15-62 93-95 2-17 19-35.5t36-23.5 33 7.5 19 30.5h13q46 5 60 23 3 3 5 7 10-1 30.5-3.5t30.5-3.5q-15-11-30-17-23-40-91-43 0-6 1-10-62-2-118.5-18.5t-84.5-47.5q-32-36-42.5-92t-2.5-112q16-126 90-179 23-16 52-4.5t32 40.5q0 1 1.5 14t2.5 21 3 20 5.5 19 8.5 10q27 14 76 12 48-46 98-74-40-4-162 14l47-46q61-58 163-111 145-73 282-86-20-8-41-15.5t-47-14-42.5-10.5-47.5-11-43-10q595-126 904 139 98 84 158 222 85 10 121-9h1q5-3 8.5-10t5.5-19 3-19.5 3-21.5l1-14q3-28 32-40t52 5q73 52 91 178 7 57-3.5 113t-42.5 91q-28 32-83.5 48.5t-115.5 18.5v10q-71 2-95 43-14 5-31 17 11 1 32 3.5t30 3.5q1-5 5-8 16-18 60-23h13q5-18 19-30t33-8 36 23 19 36q79 32 93 95 9 40 1 81-12 53-56 88t-97 44q-10 2-17 2 0 49-1 73 20-15 38-19 26-7 61-2 28-28 51-16 14 9 14 37 33 16 59 34 27-13 38-4 10 10 2 38 28 30 41 51 23-8 31 1zM1937 511q0 29-9 54 82 32 112 132 4-37-9.5-98.5t-41.5-90.5q-20-19-36-17t-16 20zM1859 611q35 42 47.5 108.5t-0.5 124.5q67-13 97-45 13-14 18-28-3-64-31-114.5t-79-66.5q-15 15-52 21zM1822 615q-30 0-44-1 42 115 53 239 21 0 43-3 16-68 1-135t-53-100zM258 697q30-100 112-132-9-25-9-54 0-18-16.5-20t-35.5 17q-28 29-41.5 90.5t-9.5 98.5zM294 799q29 31 97 45-13-58-0.5-124.5t47.5-108.5v0q-37-6-52-21-51 16-78.5 66t-31.5 115q9 17 18 28zM471 853q14-124 73-235-19 4-55 18l-45 19v-1q-46 89-20 196 25 3 47 3zM1434 892q8 38 16.5 108.5t11.5 89.5q3 18 9.5 21.5t23.5-4.5q40-20 62-85.5t23-125.5q-24-2-146-4zM1152 251q-116 0-199 82.5t-83 198.5q0 117 83 199.5t199 82.5 199-82.5 83-199.5q0-116-83-198.5t-199-82.5zM1380 890q-105-2-211 0v-1q-1 27 2.5 86t13.5 66q29 14 93.5 14.5t95.5-10.5q9-3 11-39t-0.5-69.5-4.5-46.5zM1112 1089q8-4 9.5-48t-0.5-88-4-63v-1q-212 3-214 3-4 20-7 62t0 83 14 46q34 15 101 16t101-10zM718 900q-16 59 4.5 118.5t77.5 84.5q15 8 24 5t12-21q3-16 8-90t10-103q-69 2-136 6zM591 1026q3 23-34 36 132 141 271.5 240t305.5 154q172-49 310.5-146t293.5-250q-33-13-30-34 0-2 0.5-3.5t1.5-3 1-2.5v-1 1q-17-2-50-5.5t-48-4.5q-26 90-82 132-51 38-82-1-5-6-9-14-7-13-17-62-2 5-5 9t-7.5 7-8 5.5-9.5 4l-10 2.5t-12 2l-12 1.5t-13.5 1-13.5 0.5q-106 9-163-11-4 17-10 26.5t-21 15-23 7-36 3.5q-6 1-9 1-179 17-203-40-2 63-56 54-47-8-91-54-12-13-20-26-17-29-26-65-58 6-87 10 1 2 4 10zM507 1654q3-14 3-30-17-71-51-130t-73-70q-41-12-101.5 14.5t-104.5 80-39 107.5q35 53 100 93t119 42q51 2 94-28t53-79zM510 1483q23 63 27 119 195-113 392-174-98-52-180.5-120t-179.5-165q-6 4-29 13 0 1-1 4t-1 5q31 18 22 37-12 23-56 34-10 13-29 24h-1q-2 83 1 150 19 34 35 73zM579 1649q532 21 1145 0-254-147-428-196-76 35-156 57-8 3-16 0-65-21-129-49-208 60-416 188h-1v1q1 0 1-1zM1763 1603q4-54 28-120 14-38 33-71l-1 1q3-77 3-153-15-8-30-25-42-9-56-33-9-20 22-38-2-4-2-9-16-4-28-12-204 190-383 284 198 59 414 176zM2155 1626q5-54-39-107.5t-104-80-102-14.5q-38 11-72.5 70.5t-51.5 129.5q0 16 3 30 10 49 53 79t94 28q54-2 119-42t100-93z"
    }
  }]
};
exports.optinMonster = optinMonster;
var opencart = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1524 1561q0 68-48 116t-116 48-116.5-48-48.5-116 48.5-116.5 116.5-48.5 116 48.5 48 116.5zM775 1561q0 68-48.5 116t-116.5 48-116-48-48-116 48-116.5 116-48.5 116.5 48.5 48.5 116.5zM0 67q57 60 110.5 104.5t121 82 136 63 166 45.5 200 31.5 250 18.5 304 9.5 372.5 2.5q139 0 244.5 5t181 16.5 124 27.5 71 39.5 24 51.5-19.5 64-56.5 76.5-89.5 91-116 104.5-139 119q-185 157-286 247 29-51 76.5-109t94-105.5 94.5-98.5 83-91.5 54-80.5 13-70-45.5-55.5-116.5-41-204-23.5-304-5q-168 2-314-6t-256-23-204.5-41-159.5-51.5-122.5-62.5-91.5-66.5-68-71.5-50.5-69.5-40-68-36.5-59.5z"
    }
  }]
};
exports.opencart = opencart;
var expeditedssl = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 64q-169 0-323 66t-265.5 177.5-177.5 265.5-66 323 66 323 177.5 265.5 265.5 177.5 323 66 323-66 265.5-177.5 177.5-265.5 66-323-66-323-177.5-265.5-265.5-177.5-323-66zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71zM496 832q16 0 16 16v480q0 16-16 16h-32q-16 0-16-16v-480q0-16 16-16h32zM896 896q53 0 90.5 37.5t37.5 90.5q0 35-17.5 64t-46.5 46v114q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-114q-29-17-46.5-46t-17.5-64q0-53 37.5-90.5t90.5-37.5zM896 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM544 608v96q0 14 9 23t23 9h64q14 0 23-9t9-23v-96q0-93 65.5-158.5t158.5-65.5 158.5 65.5 65.5 158.5v96q0 14 9 23t23 9h64q14 0 23-9t9-23v-96q0-146-103-249t-249-103-249 103-103 249zM1408 1344v-512q0-26-19-45t-45-19h-896q-26 0-45 19t-19 45v512q0 26 19 45t45 19h896q26 0 45-19t19-45z"
    }
  }]
};
exports.expeditedssl = expeditedssl;
var battery = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.battery = battery;
var battery4 = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.battery4 = battery4;
var batteryFull = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 512v768h-1664v-768h1664zM2048 1088h128v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288zM2304 704v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160q53 0 90.5 37.5t37.5 90.5z"
    }
  }]
};
exports.batteryFull = batteryFull;
var battery3 = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h1280v768h-1280zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.battery3 = battery3;
var batteryThreeQuarters = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h1280v768h-1280zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.batteryThreeQuarters = batteryThreeQuarters;
var battery2 = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h896v768h-896zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.battery2 = battery2;
var batteryHalf = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h896v768h-896zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.batteryHalf = batteryHalf;
var battery1 = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h512v768h-512zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.battery1 = battery1;
var batteryQuarter = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1280v-768h512v768h-512zM2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.batteryQuarter = batteryQuarter;
var battery0 = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.battery0 = battery0;
var batteryEmpty = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2176 576q53 0 90.5 37.5t37.5 90.5v384q0 53-37.5 90.5t-90.5 37.5v160q0 66-47 113t-113 47h-1856q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1856q66 0 113 47t47 113v160zM2176 1088v-384h-128v-288q0-14-9-23t-23-9h-1856q-14 0-23 9t-9 23v960q0 14 9 23t23 9h1856q14 0 23-9t9-23v-288h128z"
    }
  }]
};
exports.batteryEmpty = batteryEmpty;
var mousePointer = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1133 1043q31 30 14 69-17 40-59 40h-382l201 476q10 25 0 49t-34 35l-177 75q-25 10-49 0t-35-34l-191-452-312 312q-19 19-45 19-12 0-24-5-40-17-40-59v-1504q0-42 40-59 12-5 24-5 27 0 45 19z"
    }
  }]
};
exports.mousePointer = mousePointer;
var iCursor = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M832 128q-320 0-320 224v416h128v128h-128v544q0 224 320 224h64v128h-64q-272 0-384-146-112 146-384 146h-64v-128h64q320 0 320-224v-544h-128v-128h128v-416q0-224-320-224h-64v-128h64q272 0 384 146 112-146 384-146h64v128h-64z"
    }
  }]
};
exports.iCursor = iCursor;
var objectGroup = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2048 384h-128v1024h128v384h-384v-128h-1280v128h-384v-384h128v-1024h-128v-384h384v128h1280v-128h384v384zM1792 128v128h128v-128h-128zM128 128v128h128v-128h-128zM256 1664v-128h-128v128h128zM1664 1536v-128h128v-1024h-128v-128h-1280v128h-128v1024h128v128h1280zM1920 1664v-128h-128v128h128zM1280 640h384v768h-896v-256h-384v-768h896v256zM512 1024h640v-512h-640v512zM1536 1280v-512h-256v384h-384v128h640z"
    }
  }]
};
exports.objectGroup = objectGroup;
var objectUngroup = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2304 768h-128v640h128v384h-384v-128h-896v128h-384v-384h128v-128h-384v128h-384v-384h128v-640h-128v-384h384v128h896v-128h384v384h-128v128h384v-128h384v384zM2048 512v128h128v-128h-128zM1408 128v128h128v-128h-128zM128 128v128h128v-128h-128zM256 1280v-128h-128v128h128zM1536 1152h-128v128h128v-128zM384 1152h896v-128h128v-640h-128v-128h-896v128h-128v640h128v128zM896 1664v-128h-128v128h128zM2176 1664v-128h-128v128h128zM2048 1408v-640h-128v-128h-384v384h128v384h-384v-128h-384v128h128v128h896v-128h128z"
    }
  }]
};
exports.objectUngroup = objectUngroup;
var stickyNote = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1248v416h-928q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1344q40 0 68 28t28 68v928h-416q-40 0-68 28t-28 68zM1152 1280h381q-15 82-65 132l-184 184q-50 50-132 65v-381z"
    }
  }]
};
exports.stickyNote = stickyNote;
var stickyNoteO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1400 1280h-248v248q29-10 41-22l185-185q12-12 22-41zM1120 1152h288v-896h-1280v1280h896v-288q0-40 28-68t68-28zM1536 224v1024q0 40-20 88t-48 76l-184 184q-28 28-76 48t-88 20h-1024q-40 0-68-28t-28-68v-1344q0-40 28-68t68-28h1344q40 0 68 28t28 68z"
    }
  }]
};
exports.stickyNoteO = stickyNoteO;
var ccJcb = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1951 998q0 26-15.5 44.5t-38.5 23.5q-8 2-18 2h-153v-140h153q10 0 18 2 23 5 38.5 23.5t15.5 44.5zM1933 785q0 25-15 42t-38 21q-3 1-15 1h-139v-129h139q3 0 8.5 0.5t6.5 0.5q23 4 38 21.5t15 42.5zM728 949v-308h-228v308q0 58-38 94.5t-105 36.5q-108 0-229-59v112q53 15 121 23t109 9l42 1q328 0 328-217zM1442 1133v-113q-99 52-200 59-108 8-169-41t-61-142 61-142 169-41q101 7 200 58v-112q-48-12-100-19.5t-80-9.5l-28-2q-127-6-218.5 14t-140.5 60-71 88-22 106 22 106 71 88 140.5 60 218.5 14q101-4 208-31zM2176 1018q0-54-43-88.5t-109-39.5v-3q57-8 89-41.5t32-79.5q0-55-41-88t-107-36q-3 0-12-0.5t-14-0.5h-455v510h491q74 0 121.5-36.5t47.5-96.5zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccJcb = ccJcb;
var ccDinersClub = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M858 1241v-693q-106 41-172 135.5t-66 211.5 66 211.5 172 134.5zM1362 895q0-117-66-211.5t-172-135.5v694q106-41 172-135.5t66-211.5zM1577 895q0 159-78.5 294t-213.5 213.5-294 78.5q-119 0-227.5-46.5t-187-125-125-187-46.5-227.5q0-159 78.5-294t213.5-213.5 294-78.5 294 78.5 213.5 213.5 78.5 294zM1960 902q0-139-55.5-261.5t-147.5-205.5-213.5-131-252.5-48h-301q-176 0-323.5 81t-235 230-87.5 335q0 171 87 317.5t236 231.5 323 85h301q129 0 251.5-50.5t214.5-135 147.5-202.5 55.5-246zM2304 256v1280q0 52-38 90t-90 38h-2048q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h2048q52 0 90 38t38 90z"
    }
  }]
};
exports.ccDinersClub = ccDinersClub;
var clone = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1632v-1088q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h1088q13 0 22.5-9.5t9.5-22.5zM1792 544v1088q0 66-47 113t-113 47h-1088q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113zM1408 160v160h-128v-160q0-13-9.5-22.5t-22.5-9.5h-1088q-13 0-22.5 9.5t-9.5 22.5v1088q0 13 9.5 22.5t22.5 9.5h160v128h-160q-66 0-113-47t-47-113v-1088q0-66 47-113t113-47h1088q66 0 113 47t47 113z"
    }
  }]
};
exports.clone = clone;
var balanceScale = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1728 448l-384 704h768zM448 448l-384 704h768zM1269 256q-14 40-45.5 71.5t-71.5 45.5v1291h608q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1344q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h608v-1291q-40-14-71.5-45.5t-45.5-71.5h-491q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h491q21-57 70-92.5t111-35.5 111 35.5 70 92.5h491q14 0 23 9t9 23v64q0 14-9 23t-23 9h-491zM1088 272q33 0 56.5-23.5t23.5-56.5-23.5-56.5-56.5-23.5-56.5 23.5-23.5 56.5 23.5 56.5 56.5 23.5zM2176 1152q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81zM896 1152q0 73-46.5 131t-117.5 91-144.5 49.5-139.5 16.5-139.5-16.5-144.5-49.5-117.5-91-46.5-131q0-11 35-81t92-174.5 107-195.5 102-184 56-100q18-33 56-33t56 33q4 7 56 100t102 184 107 195.5 92 174.5 35 81z"
    }
  }]
};
exports.balanceScale = balanceScale;
var hourglassO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-77 29-149 92.5t-129.5 152.5-92.5 210-35 253h1024q0-132-35-253t-92.5-210-129.5-152.5-149-92.5q-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"
    }
  }]
};
exports.hourglassO = hourglassO;
var hourglass1 = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 66 9 128h1006q9-61 9-128zM1280 1664q0-130-34-249.5t-90.5-208-126.5-152-146-94.5h-230q-76 31-146 94.5t-126.5 152-90.5 208-34 249.5h1024z"
    }
  }]
};
exports.hourglass1 = hourglass1;
var hourglassStart = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 66 9 128h1006q9-61 9-128zM1280 1664q0-130-34-249.5t-90.5-208-126.5-152-146-94.5h-230q-76 31-146 94.5t-126.5 152-90.5 208-34 249.5h1024z"
    }
  }]
};
exports.hourglassStart = hourglassStart;
var hourglass2 = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 206 85 384h854q85-178 85-384zM1223 1344q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z"
    }
  }]
};
exports.hourglass2 = hourglass2;
var hourglassHalf = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM1280 128h-1024q0 206 85 384h854q85-178 85-384zM1223 1344q-54-141-145.5-241.5t-194.5-142.5h-230q-103 42-194.5 142.5t-145.5 241.5h910z"
    }
  }]
};
exports.hourglassHalf = hourglassHalf;
var hourglass3 = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-137 51-244 196h700q-107-145-244-196-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"
    }
  }]
};
exports.hourglass3 = hourglass3;
var hourglassEnd = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1408 128q0 261-106.5 461.5t-266.5 306.5q160 106 266.5 306.5t106.5 461.5h96q14 0 23 9t9 23v64q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96q0-261 106.5-461.5t266.5-306.5q-160-106-266.5-306.5t-106.5-461.5h-96q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h1472q14 0 23 9t9 23v64q0 14-9 23t-23 9h-96zM874 836q77-29 149-92.5t129.5-152.5 92.5-210 35-253h-1024q0 132 35 253t92.5 210 129.5 152.5 149 92.5q19 7 30.5 23.5t11.5 36.5-11.5 36.5-30.5 23.5q-137 51-244 196h700q-107-145-244-196-19-7-30.5-23.5t-11.5-36.5 11.5-36.5 30.5-23.5z"
    }
  }]
};
exports.hourglassEnd = hourglassEnd;
var hourglass = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1504 1600q14 0 23 9t9 23v128q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h1472zM130 1536q3-55 16-107t30-95 46-87 53.5-76 64.5-69.5 66-60 70.5-55 66.5-47.5 65-43q-43-28-65-43t-66.5-47.5-70.5-55-66-60-64.5-69.5-53.5-76-46-87-30-95-16-107h1276q-3 55-16 107t-30 95-46 87-53.5 76-64.5 69.5-66 60-70.5 55-66.5 47.5-65 43q43 28 65 43t66.5 47.5 70.5 55 66 60 64.5 69.5 53.5 76 46 87 30 95 16 107h-1276zM1504 0q14 0 23 9t9 23v128q0 14-9 23t-23 9h-1472q-14 0-23-9t-9-23v-128q0-14 9-23t23-9h1472z"
    }
  }]
};
exports.hourglass = hourglass;
var handGrabO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 384q-53 0-90.5 37.5t-37.5 90.5v128h-32v-93q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v429l-32-30v-172q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v224q0 47 35 82l310 296q39 39 39 102 0 26 19 45t45 19h640q26 0 45-19t19-45v-25q0-41 10-77l108-436q10-36 10-77v-246q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v32h-32v-125q0-40-25-72.5t-64-40.5q-14-2-23-2-46 0-79 33t-33 79v128h-32v-122q0-51-32.5-89.5t-82.5-43.5q-5-1-13-1zM768 256q84 0 149 50 57-34 123-34 59 0 111 27t86 76q27-7 59-7 100 0 170 71.5t70 171.5v246q0 51-13 108l-109 436q-6 24-6 71 0 80-56 136t-136 56h-640q-84 0-138-58.5t-54-142.5l-308-296q-76-73-76-175v-224q0-99 70.5-169.5t169.5-70.5q11 0 16 1 6-95 75.5-160t164.5-65q52 0 98 21 72-69 174-69z"
    }
  }]
};
exports.handGrabO = handGrabO;
var handRockO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 384q-53 0-90.5 37.5t-37.5 90.5v128h-32v-93q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v429l-32-30v-172q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v224q0 47 35 82l310 296q39 39 39 102 0 26 19 45t45 19h640q26 0 45-19t19-45v-25q0-41 10-77l108-436q10-36 10-77v-246q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v32h-32v-125q0-40-25-72.5t-64-40.5q-14-2-23-2-46 0-79 33t-33 79v128h-32v-122q0-51-32.5-89.5t-82.5-43.5q-5-1-13-1zM768 256q84 0 149 50 57-34 123-34 59 0 111 27t86 76q27-7 59-7 100 0 170 71.5t70 171.5v246q0 51-13 108l-109 436q-6 24-6 71 0 80-56 136t-136 56h-640q-84 0-138-58.5t-54-142.5l-308-296q-76-73-76-175v-224q0-99 70.5-169.5t169.5-70.5q11 0 16 1 6-95 75.5-160t164.5-65q52 0 98 21 72-69 174-69z"
    }
  }]
};
exports.handRockO = handRockO;
var handPaperO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M880 128q-46 0-79 33t-33 79v656h-32v-528q0-46-33-79t-79-33-79 33-33 79v528 256l-154-205q-38-51-102-51-53 0-90.5 37.5t-37.5 90.5q0 43 26 77l384 512q38 51 102 51h688q34 0 61-22t34-56l76-405q5-32 5-59v-498q0-46-33-79t-79-33-79 33-33 79v272h-32v-528q0-46-33-79t-79-33-79 33-33 79v528h-32v-656q0-46-33-79t-79-33zM880 0q68 0 125.5 35.5t88.5 96.5q19-4 42-4 99 0 169.5 70.5t70.5 169.5v17q105-6 180.5 64t75.5 175v498q0 40-8 83l-76 404q-14 79-76.5 131t-143.5 52h-688q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-106 75-181t181-75q78 0 128 34v-434q0-99 70.5-169.5t169.5-70.5q23 0 42 4 31-61 88.5-96.5t125.5-35.5z"
    }
  }]
};
exports.handPaperO = handPaperO;
var handStopO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M880 128q-46 0-79 33t-33 79v656h-32v-528q0-46-33-79t-79-33-79 33-33 79v528 256l-154-205q-38-51-102-51-53 0-90.5 37.5t-37.5 90.5q0 43 26 77l384 512q38 51 102 51h688q34 0 61-22t34-56l76-405q5-32 5-59v-498q0-46-33-79t-79-33-79 33-33 79v272h-32v-528q0-46-33-79t-79-33-79 33-33 79v528h-32v-656q0-46-33-79t-79-33zM880 0q68 0 125.5 35.5t88.5 96.5q19-4 42-4 99 0 169.5 70.5t70.5 169.5v17q105-6 180.5 64t75.5 175v498q0 40-8 83l-76 404q-14 79-76.5 131t-143.5 52h-688q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-106 75-181t181-75q78 0 128 34v-434q0-99 70.5-169.5t169.5-70.5q23 0 42 4 31-61 88.5-96.5t125.5-35.5z"
    }
  }]
};
exports.handStopO = handStopO;
var handScissorsO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1073 1664h-177q-163 0-226-141-23-49-23-102v-5q-62-30-98.5-88.5t-36.5-127.5q0-38 5-48h-261q-106 0-181-75t-75-181 75-181 181-75h113l-44-17q-74-28-119.5-93.5t-45.5-145.5q0-106 75-181t181-75q46 0 91 17l628 239h401q106 0 181 75t75 181v668q0 88-54 157.5t-140 90.5l-339 85q-92 23-186 23zM1024 953l-155 71-163 74q-30 14-48 41.5t-18 60.5q0 46 33 79t79 33q26 0 46-10l338-154q-49-10-80.5-50t-31.5-90v-55zM1344 1264q0-46-33-79t-79-33q-26 0-46 10l-290 132q-28 13-37 17t-30.5 17-29.5 23.5-16 29-8 40.5q0 50 31.5 82t81.5 32q20 0 38-9l352-160q30-14 48-41.5t18-60.5zM1112 512l-650-248q-24-8-46-8-53 0-90.5 37.5t-37.5 90.5q0 40 22.5 73t59.5 47l526 200v64h-640q-53 0-90.5 37.5t-37.5 90.5 37.5 90.5 90.5 37.5h535l233-106v-198q0-63 46-106l111-102h-69zM1073 1536q82 0 155-19l339-85q43-11 70-45.5t27-78.5v-668q0-53-37.5-90.5t-90.5-37.5h-308l-136 126q-36 33-36 82v296q0 46 33 77t79 31 79-35 33-81v-208h32v208q0 70-57 114 52 8 86.5 48.5t34.5 93.5q0 42-23 78t-61 53l-310 141h91z"
    }
  }]
};
exports.handScissorsO = handScissorsO;
var handLizardO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1151 0q61 0 116 28t91 77l572 781q118 159 118 359v355q0 80-56 136t-136 56h-384q-80 0-136-56t-56-136v-177l-286-143h-546q-80 0-136-56t-56-136v-32q0-119 84.5-203.5t203.5-84.5h420l42-128h-686q-100 0-173.5-67.5t-81.5-166.5q-65-79-65-182v-32q0-80 56-136t136-56h959zM1920 1600v-355q0-157-93-284l-573-781q-39-52-103-52h-959q-26 0-45 19t-19 45q0 32 1.5 49.5t9.5 40.5 25 43q10-31 35.5-50t56.5-19h832v32h-832q-26 0-45 19t-19 45q0 44 3 58 8 44 44 73t81 29h640 91q40 0 68 28t28 68q0 15-5 30l-64 192q-10 29-35 47.5t-56 18.5h-443q-66 0-113 47t-47 113v32q0 26 19 45t45 19h561q16 0 29 7l317 158q24 13 38.5 36t14.5 50v197q0 26 19 45t45 19h384q26 0 45-19t19-45z"
    }
  }]
};
exports.handLizardO = handLizardO;
var handSpockO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M459 1792q-77 0-137.5-47.5t-79.5-122.5l-101-401q-13-57-13-108 0-45-5-67l-116-477q-7-27-7-57 0-93 62-161t155-78q17-85 82.5-139t152.5-54q83 0 148 51.5t85 132.5l83 348 103-428q20-81 85-132.5t148-51.5q89 0 155.5 57.5t80.5 144.5q92 10 152 79t60 162q0 24-7 59l-123 512q10-7 37.5-28.5t38.5-29.5 35-23 41-20.5 41.5-11 49.5-5.5q105 0 180 74t75 179q0 62-28.5 118t-78.5 94l-507 380q-68 51-153 51h-694zM1104 128q-38 0-68.5 24t-39.5 62l-164 682h-127l-145-602q-9-38-39.5-62t-68.5-24q-48 0-80 33t-32 80q0 15 3 28l132 547h-26l-99-408q-9-37-40-62.5t-69-25.5q-47 0-80 33t-33 79q0 14 3 26l116 478q7 28 9 86t10 88l100 401q8 32 34 52.5t59 20.5h694q42 0 76-26l507-379q56-43 56-110 0-52-37.5-88.5t-89.5-36.5q-43 0-77 26l-307 230v-227q0-4 32-138t68-282 39-161q4-18 4-29 0-47-32-81t-79-34q-39 0-69.5 24t-39.5 62l-116 482h-26l150-624q3-14 3-28 0-48-31.5-82t-79.5-34z"
    }
  }]
};
exports.handSpockO = handSpockO;
var handPointerO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 128q-53 0-90.5 37.5t-37.5 90.5v512 384l-151-202q-41-54-107-54-52 0-89 38t-37 90q0 43 26 77l384 512q38 51 102 51h718q22 0 39.5-13.5t22.5-34.5l92-368q24-96 24-194v-217q0-41-28-71t-68-30-68 28-28 68h-32v-61q0-48-32-81.5t-80-33.5q-46 0-79 33t-33 79v64h-32v-90q0-55-37-94.5t-91-39.5q-53 0-90.5 37.5t-37.5 90.5v96h-32v-570q0-55-37-94.5t-91-39.5zM640 0q107 0 181.5 77.5t74.5 184.5v220q22-2 32-2 99 0 173 69 47-21 99-21 113 0 184 87 27-7 56-7 94 0 159 67.5t65 161.5v217q0 116-28 225l-92 368q-16 64-68 104.5t-118 40.5h-718q-60 0-114.5-27.5t-90.5-74.5l-384-512q-51-68-51-154 0-105 74.5-180.5t179.5-75.5q71 0 130 35v-547q0-106 75-181t181-75zM768 1408v-384h-32v384h32zM1024 1408v-384h-32v384h32zM1280 1408v-384h-32v384h32z"
    }
  }]
};
exports.handPointerO = handPointerO;
var handPeaceO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1288 647q60 0 107 23 141 63 141 226v177q0 94-23 186l-85 339q-21 86-90.5 140t-157.5 54h-668q-106 0-181-75t-75-181v-401l-239-628q-17-45-17-91 0-106 75-181t181-75q80 0 145.5 45.5t93.5 119.5l17 44v-113q0-106 75-181t181-75 181 75 75 181v261q27-5 48-5 69 0 127.5 36.5t88.5 98.5zM1072 640q-33 0-60.5 18t-41.5 48l-74 163-71 155h55q50 0 90 31.5t50 80.5l154-338q10-20 10-46 0-46-33-79t-79-33zM1293 775q-22 0-40.5 8t-29 16-23.5 29.5-17 30.5-17 37l-132 290q-10 20-10 46 0 46 33 79t79 33q33 0 60.5-18t41.5-48l160-352q9-18 9-38 0-50-32-81.5t-82-31.5zM128 416q0 22 8 46l248 650v69l102-111q43-46 106-46h198l106-233v-535q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5v640h-64l-200-526q-14-37-47-59.5t-73-22.5q-53 0-90.5 37.5t-37.5 90.5zM1180 1664q44 0 78.5-27t45.5-70l85-339q19-73 19-155v-91l-141 310q-17 38-53 61t-78 23q-53 0-93.5-34.5t-48.5-86.5q-44 57-114 57h-208v-32h208q46 0 81-33t35-79-31-79-77-33h-296q-49 0-82 36l-126 136v308q0 53 37.5 90.5t90.5 37.5h668z"
    }
  }]
};
exports.handPeaceO = handPeaceO;
var trademark = {
  "viewBox": "0 0 1973 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M857 544v117q0 13-9.5 22t-22.5 9h-298v812q0 13-9 22.5t-22 9.5h-135q-13 0-22.5-9t-9.5-23v-812h-297q-13 0-22.5-9t-9.5-22v-117q0-14 9-23t23-9h793q13 0 22.5 9.5t9.5 22.5zM1895 541l77 961q1 13-8 24-10 10-23 10h-134q-12 0-21-8.5t-10-20.5l-46-588-189 425q-8 19-29 19h-120q-20 0-29-19l-188-427-45 590q-1 12-10 20.5t-21 8.5h-135q-13 0-23-10-9-10-9-24l78-961q1-12 10-20.5t21-8.5h142q20 0 29 19l220 520q10 24 20 51 3-7 9.5-24.5t10.5-26.5l221-520q9-19 29-19h141q13 0 22 8.5t10 20.5z"
    }
  }]
};
exports.trademark = trademark;
var registered = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1042 703q0-88-60-121-33-18-117-18h-123v281h162q66 0 102-37t36-105zM1094 988l205 373q8 17-1 31-8 16-27 16h-152q-20 0-28-17l-194-365h-155v350q0 14-9 23t-23 9h-134q-14 0-23-9t-9-23v-960q0-14 9-23t23-9h294q128 0 190 24 85 31 134 109t49 180q0 92-42.5 165.5t-115.5 109.5q6 10 9 16zM896 160q-150 0-286 58.5t-234.5 157-157 234.5-58.5 286 58.5 286 157 234.5 234.5 157 286 58.5 286-58.5 234.5-157 157-234.5 58.5-286-58.5-286-157-234.5-234.5-157-286-58.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.registered = registered;
var creativeCommons = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M605 1233q153 0 257-104 14-18 3-36l-45-82q-6-13-24-17-16-2-27 11l-4 3q-4 4-11.5 10t-17.5 13.5-23.5 14.5-28.5 13-33.5 9.5-37.5 3.5q-76 0-125-50t-49-127q0-76 48-125.5t122-49.5q37 0 71.5 14t50.5 28l16 14q11 11 26 10 16-2 24-14l53-78q13-20-2-39-3-4-11-12t-30-23.5-48.5-28-67.5-22.5-86-10q-148 0-246 96.5t-98 240.5q0 146 97 241.5t247 95.5zM1235 1233q153 0 257-104 14-18 4-36l-45-82q-8-14-25-17-16-2-27 11l-4 3q-4 4-11.5 10t-17.5 13.5-23.5 14.5-28.5 13-33.5 9.5-37.5 3.5q-76 0-125-50t-49-127q0-76 48-125.5t122-49.5q37 0 71.5 14t50.5 28l16 14q11 11 26 10 16-2 24-14l53-78q13-20-2-39-3-4-11-12t-30-23.5-48.5-28-67.5-22.5-86-10q-147 0-245.5 96.5t-98.5 240.5q0 146 97 241.5t247 95.5zM896 160q-150 0-286 58.5t-234.5 157-157 234.5-58.5 286 58.5 286 157 234.5 234.5 157 286 58.5 286-58.5 234.5-157 157-234.5 58.5-286-58.5-286-157-234.5-234.5-157-286-58.5zM896 0q182 0 348 71t286 191 191 286 71 348-71 348-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71z"
    }
  }]
};
exports.creativeCommons = creativeCommons;
var gg = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M736 800l384 384-384 384-672-672 672-672 168 168-96 96-72-72-480 480 480 480 193-193-289-287zM1312 224l672 672-672 672-168-168 96-96 72 72 480-480-480-480-193 193 289 287-96 96-384-384z"
    }
  }]
};
exports.gg = gg;
var ggCircle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M717 1354l271-271-279-279-88 88 192 191-96 96-279-279 279-279 40 40 87-87-127-128-454 454zM1075 1346l454-454-454-454-271 271 279 279 88-88-192-191 96-96 279 279-279 279-40-40-87 88zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.ggCircle = ggCircle;
var tripadvisor = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M651 997q0 39-27.5 66.5t-65.5 27.5q-39 0-66.5-27.5t-27.5-66.5q0-38 27.5-65.5t66.5-27.5q38 0 65.5 27.5t27.5 65.5zM1805 996q0 39-27.5 66.5t-66.5 27.5-66.5-27.5-27.5-66.5 27.5-66 66.5-27 66.5 27 27.5 66zM765 997q0-79-56.5-136t-136.5-57-136.5 56.5-56.5 136.5 56.5 136.5 136.5 56.5 136.5-56.5 56.5-136.5zM1918 996q0-80-56.5-136.5t-136.5-56.5q-79 0-136 56.5t-57 136.5 56.5 136.5 136.5 56.5 136.5-56.5 56.5-136.5zM850 997q0 116-81.5 197.5t-196.5 81.5q-116 0-197.5-82t-81.5-197 82-196.5 197-81.5 196.5 81.5 81.5 196.5zM2004 996q0 115-81.5 196.5t-197.5 81.5q-115 0-196.5-81.5t-81.5-196.5 81.5-196.5 196.5-81.5q116 0 197.5 81.5t81.5 196.5zM1040 999q0-191-135.5-326.5t-326.5-135.5q-125 0-231 62t-168 168.5-62 231.5 62 231.5 168 168.5 231 62q191 0 326.5-135.5t135.5-326.5zM1708 426q-254-111-556-111-319 0-573 110 117 0 223 45.5t182.5 122.5 122 183 45.5 223q0-115 43.5-219.5t118-180.5 177.5-123 217-50zM2187 999q0-191-135-326.5t-326-135.5-326.5 135.5-135.5 326.5 135.5 326.5 326.5 135.5 326-135.5 135-326.5zM1921 433h383q-44 51-75 114.5t-40 114.5q110 151 110 337 0 156-77 288t-209 208.5-287 76.5q-133 0-249-56t-196-155q-47 56-129 179-11-22-53.5-82.5t-74.5-97.5q-80 99-196.5 155.5t-249.5 56.5q-155 0-287-76.5t-209-208.5-77-288q0-186 110-337-9-51-40-114.5t-75-114.5h365q149-100 355-156.5t432-56.5q224 0 421 56t348 157z"
    }
  }]
};
exports.tripadvisor = tripadvisor;
var odnoklassniki = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 907q-188 0-321-133t-133-320q0-188 133-321t321-133 321 133 133 321q0 187-133 320t-321 133zM640 230q-92 0-157.5 65.5t-65.5 158.5q0 92 65.5 157.5t157.5 65.5 157.5-65.5 65.5-157.5q0-93-65.5-158.5t-157.5-65.5zM1163 962q13 27 15 49.5t-4.5 40.5-26.5 38.5-42.5 37-61.5 41.5q-115 73-315 94l73 72 267 267q30 31 30 74t-30 73l-12 13q-31 30-74 30t-74-30q-67-68-267-268l-267 268q-31 30-74 30t-73-30l-12-13q-31-30-31-73t31-74l267-267 72-72q-203-21-317-94-39-25-61.5-41.5t-42.5-37-26.5-38.5-4.5-40.5 15-49.5q10-20 28-35t42-22 56 2 65 35q5 4 15 11t43 24.5 69 30.5 92 24 113 11q91 0 174-25.5t120-50.5l38-25q33-26 65-35t56-2 42 22 28 35z"
    }
  }]
};
exports.odnoklassniki = odnoklassniki;
var odnoklassnikiSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M927 580q0 66-46.5 112.5t-112.5 46.5-112.5-46.5-46.5-112.5 46.5-112.5 112.5-46.5 112.5 46.5 46.5 112.5zM1141 943q-10-20-28-32t-47.5-9.5-60.5 27.5q-10 8-29 20t-81 32-127 20-124-18-86-36l-27-18q-31-25-60.5-27.5t-47.5 9.5-28 32q-22 45-2 74.5t87 73.5q83 53 226 67l-51 52q-142 142-191 190-22 22-22 52.5t22 52.5l9 9q22 22 52.5 22t52.5-22l191-191q114 115 191 191 22 22 52.5 22t52.5-22l9-9q22-22 22-52.5t-22-52.5l-191-190-52-52q141-14 225-67 67-44 87-73.5t-2-74.5zM1092 580q0-134-95-229t-229-95-229 95-95 229 95 229 229 95 229-95 95-229zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.odnoklassnikiSquare = odnoklassnikiSquare;
var getPocket = {
  "viewBox": "0 0 1720 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1565 128q65 0 110 45.5t45 110.5v519q0 176-68 336t-182.5 275-274 182.5-334.5 67.5q-176 0-335.5-67.5t-274.5-182.5-183-275-68-336v-519q0-64 46-110t110-46h1409zM861 1192q47 0 82-33l404-388q37-35 37-85 0-49-34.5-83.5t-83.5-34.5q-47 0-82 33l-323 310-323-310q-35-33-81-33-49 0-83.5 34.5t-34.5 83.5q0 51 36 85l405 388q33 33 81 33z"
    }
  }]
};
exports.getPocket = getPocket;
var wikipediaW = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1494 1639l-295-695q-25 49-158.5 305.5t-198.5 389.5q-1 1-27.5 0.5t-26.5-1.5q-82-193-255.5-587t-259.5-596q-21-50-66.5-107.5t-103.5-100.5-102-43q0-5-0.5-24t-0.5-27h583v50q-39 2-79.5 16t-66.5 43-10 64q26 59 216.5 499t235.5 540q31-61 140-266.5t131-247.5q-19-39-126-281t-136-295q-38-69-201-71v-50l513 1v47q-60 2-93.5 25t-12.5 69q33 70 87 189.5t86 187.5q110-214 173-363 24-55-10-79.5t-129-26.5q1-7 1-25v-24q64 0 170.5-0.5t180-1 92.5-0.5v49q-62 2-119 33t-90 81l-213 442q13 33 127.5 290t121.5 274l441-1017q-14-38-49.5-62.5t-65-31.5-55.5-8v-50l460 4 1 2-1 44q-139 4-201 145-526 1216-559 1291h-49z"
    }
  }]
};
exports.wikipediaW = wikipediaW;
var safari = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M949 893q0 26-16.5 45t-41.5 19q-26 0-45-16.5t-19-41.5q0-26 17-45t42-19 44 16.5 19 41.5zM964 951l350-581q-9 8-67.5 62.5t-125.5 116.5-136.5 127-117 110.5-50.5 51.5l-349 580q7-7 67-62t126-116.5 136-127 117-111 50-50.5zM1611 896q0 201-104 371-3-2-17-11t-26.5-16.5-16.5-7.5q-13 0-13 13 0 10 59 44-74 112-184.5 190.5t-241.5 110.5l-16-67q-1-10-15-10-5 0-8 5.5t-2 9.5l16 68q-72 15-146 15-199 0-372-105 1-2 13-20.5t21.5-33.5 9.5-19q0-13-13-13-6 0-17 14.5t-22.5 34.5-13.5 23q-113-75-192-187.5t-110-244.5l69-15q10-3 10-15 0-5-5.5-8t-10.5-2l-68 15q-14-72-14-139 0-206 109-379 2 1 18.5 12t30 19 17.5 8q13 0 13-12 0-6-12.5-15.5t-32.5-21.5l-20-12q77-112 189-189t244-107l15 67q2 10 15 10 5 0 8-5.5t2-10.5l-15-66q71-13 134-13 204 0 379 109-39 56-39 65 0 13 12 13 11 0 48-64 111 75 187.5 186t107.5 241l-56 12q-10 2-10 16 0 5 5.5 8t9.5 2l57-13q14 72 14 140zM1696 896q0-163-63.5-311t-170.5-255-255-170.5-311-63.5-311 63.5-255 170.5-170.5 255-63.5 311 63.5 311 170.5 255 255 170.5 311 63.5 311-63.5 255-170.5 170.5-255 63.5-311zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.safari = safari;
var chrome = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M893 0q240-2 451 120 232 134 352 372l-742-39q-160-9-294 74.5t-185 229.5l-276-424q128-159 311-245.5t383-87.5zM146 405l337 663q72 143 211 217t293 45l-230 451q-212-33-385-157.5t-272.5-316-99.5-411.5q0-267 146-491zM1732 574q58 150 59.5 310.5t-48.5 306-153 272-246 209.5q-230 133-498 119l405-623q88-131 82.5-290.5t-106.5-277.5zM896 594q125 0 213.5 88.5t88.5 213.5-88.5 213.5-213.5 88.5-213.5-88.5-88.5-213.5 88.5-213.5 213.5-88.5z"
    }
  }]
};
exports.chrome = chrome;
var firefox = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M903 1792q-283 0-504.5-150.5t-329.5-398.5q-58-131-67-301t26-332.5 111-312 179-242.5l-11 281q11-14 68-15.5t70 15.5q42-81 160.5-138t234.5-59q-54 45-119.5 148.5t-58.5 163.5q25 8 62.5 13.5t63 7.5 68 4 50.5 3q15 5 9.5 45.5t-30.5 75.5q-5 7-16.5 18.5t-56.5 35.5-101 34l15 189-139-67q-18 43-7.5 81.5t36 66.5 65.5 41.5 81 6.5q51-9 98-34.5t83.5-45 73.5-17.5q61 4 89.5 33t19.5 65q-1 2-2.5 5.5t-8.5 12.5-18 15.5-31.5 10.5-46.5 1q-60 95-144.5 135.5t-209.5 29.5q74 61 162.5 82.5t168.5 6 154.5-52 128-87.5 80.5-104q43-91 39-192.5t-37.5-188.5-78.5-125q87 38 137 79.5t77 112.5q15-170-57.5-343t-209.5-284q265 77 412 279.5t151 517.5q2 127-40.5 255t-123.5 238-189 196-247.5 135.5-288.5 49.5z"
    }
  }]
};
exports.firefox = firefox;
var opera = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1493 228q-165-110-359-110-155 0-293 73t-240 200q-75 93-119.5 218t-48.5 266v42q4 141 48.5 266t119.5 218q102 127 240 200t293 73q194 0 359-110-121 108-274.5 168t-322.5 60q-29 0-43-1-175-8-333-82t-272-193-181-281-67-339q0-182 71-348t191-286 286-191 348-71h3q168 1 320.5 60.5t273.5 167.5zM1792 896q0 192-77 362.5t-213 296.5q-104 63-222 63-137 0-255-84 154-56 253.5-233t99.5-405q0-227-99-404t-253-234q119-83 254-83 119 0 226 65 135 125 210.5 295t75.5 361z"
    }
  }]
};
exports.opera = opera;
var internetExplorer = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 937q0 56-7 104h-1151q0 146 109.5 244.5t257.5 98.5q99 0 185.5-46.5t136.5-130.5h423q-56 159-170.5 281t-267.5 188.5-321 66.5q-187 0-356-83-228 116-394 116-237 0-237-263 0-115 45-275 17-60 109-229 199-360 475-606-184 79-427 354 63-274 283.5-449.5t501.5-175.5q30 0 45 1 255-117 433-117 64 0 116 13t94.5 40.5 66.5 76.5 24 115q0 116-75 286 101 182 101 390zM1722 297q0-83-53-132t-137-49q-108 0-254 70 121 47 222.5 131.5t170.5 195.5q51-135 51-216zM128 1534q0 86 48.5 132.5t134.5 46.5q115 0 266-83-122-72-213.5-183t-137.5-245q-98 205-98 332zM632 821h728q-5-142-113-237t-251-95q-144 0-251.5 95t-112.5 237z"
    }
  }]
};
exports.internetExplorer = internetExplorer;
var television = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1248v-960q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 288v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128h-736q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.television = television;
var tv = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1248v-960q0-13-9.5-22.5t-22.5-9.5h-1600q-13 0-22.5 9.5t-9.5 22.5v960q0 13 9.5 22.5t22.5 9.5h1600q13 0 22.5-9.5t9.5-22.5zM1920 288v960q0 66-47 113t-113 47h-736v128h352q14 0 23 9t9 23v64q0 14-9 23t-23 9h-832q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h352v-128h-736q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h1600q66 0 113 47t47 113z"
    }
  }]
};
exports.tv = tv;
var contao = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M138 128h197q-70 64-126 149-36 56-59 115t-30 125.5-8.5 120 10.5 132 21 126 28 136.5q4 19 6 28 51 238 81 329 57 171 152 275h-272q-48 0-82-34t-34-82v-1304q0-48 34-82t82-34zM1346 128h308q48 0 82 34t34 82v1304q0 48-34 82t-82 34h-178q212-210 196-565l-469 101q-2 45-12 82t-31 72-59.5 59.5-93.5 36.5q-123 26-199-40-32-27-53-61t-51.5-129-64.5-258q-35-163-45.5-263t-5.5-139 23-77q20-41 62.5-73t102.5-45q45-12 83.5-6.5t67 17 54 35 43 48 34.5 56.5l468-100q-68-175-180-287z"
    }
  }]
};
exports.contao = contao;
var fiveHundredPX = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1401 1547l-6 6q-113 113-259 175-154 64-317 64-165 0-317-64-148-63-259-175-113-112-175-258-42-103-54-189-4-28 48-36 51-8 56 20 1 1 1 4 18 90 46 159 50 124 152 226 98 98 226 152 132 56 276 56 143 0 276-56 128-55 225-152l6-6q10-10 25-6 12 3 33 22 36 37 17 58zM929 932l-66 66 63 63q21 21-7 49-17 17-32 17-10 0-19-10l-62-61-66 66q-5 5-15 5-15 0-31-16l-2-2q-18-15-18-29 0-7 8-17l66-65-66-66q-16-16 14-45 18-18 31-18 6 0 13 5l65 66 65-65q18-17 48 13 27 27 11 44zM1400 989q0 118-46 228-45 105-126 186-80 80-187 126t-228 46-228-46-187-126q-82-82-125-186-15-33-15-40h-1q-9-27 43-44 50-16 60 12 37 99 97 167h1v-339-2q3-136 102-232 105-103 253-103 147 0 251 103t104 249q0 147-104.5 251t-250.5 104q-58 0-112-16-28-11-13-61 16-51 44-43l14 3q14 3 33 6t30 3q104 0 176-71.5t72-174.5q0-101-72-171-71-71-175-71-107 0-178 80-64 72-64 160v413q110 67 242 67 96 0 185-36.5t156-103.5 103.5-155 36.5-183q0-198-141-339-140-140-339-140-200 0-340 140-53 53-77 87l-2 2q-8 11-13 15.5t-21.5 9.5-38.5-3q-21-5-36.5-16.5t-15.5-26.5v-680q0-15 10.5-26.5t27.5-11.5h877q30 0 30 55t-30 55h-811v483h1q40-42 102-84t108-61q109-46 231-46 121 0 228 46t187 126q81 81 126 186 46 112 46 229zM1369 408q9 8 9 18t-5.5 18-16.5 21q-26 26-39 26-9 0-16-7-106-91-207-133-128-56-276-56-133 0-262 49-27 10-45-37-9-25-8-38 3-16 16-20 130-57 299-57 164 0 316 64 137 58 235 152z"
    }
  }]
};
exports.fiveHundredPX = fiveHundredPX;
var amazon = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1551 1476q15-6 26-3t11 17.5-15 33.5q-13 16-44 43.5t-95.5 68-141 74-188 58-229.5 24.5q-119 0-238-31t-209-76.5-172.5-104-132.5-105-84-87.5q-8-9-10-16.5t1-12 8-7 11.5-2 11.5 4.5q192 117 300 166 389 176 799 90 190-40 391-135zM1758 1361q11 16 2.5 69.5t-28.5 102.5q-34 83-85 124-17 14-26 9t0-24q21-45 44.5-121.5t6.5-98.5q-5-7-15.5-11.5t-27-6-29.5-2.5-35 0-31.5 2-31 3-22.5 2q-6 1-13 1.5t-11 1-8.5 1-7 0.5h-5.5-4.5t-3-0.5-2-1.5l-1.5-3q-6-16 47-40t103-30q46-7 108-1t76 24zM1364 918q0 31 13.5 64t32 58 37.5 46 33 32l13 11-227 224q-40-37-79-75.5t-58-58.5l-19-20q-11-11-25-33-38 59-97.5 102.5t-127.5 63.5-140 23-137.5-21-117.5-65.5-83-113-31-162.5q0-84 28-154t72-116.5 106.5-83 122.5-57 130-34.5 119.5-18.5 99.5-6.5v-127q0-65-21-97-34-53-121-53-6 0-16.5 1t-40.5 12-56 29.5-56 59.5-48 96l-294-27q0-60 22-119t67-113 108-95 151.5-65.5 190.5-24.5q100 0 181 25t129.5 61.5 81 83 45 86 12.5 73.5v589zM692 939q0 86 70 133 66 44 139 22 84-25 114-123 14-45 14-101v-162q-59 2-111 12t-106.5 33.5-87 71-32.5 114.5z"
    }
  }]
};
exports.amazon = amazon;
var calendarPlusO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 256q52 0 90 38t38 90v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128zM1152 160v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM384 160v288q0 14 9 23t23 9h64q14 0 23-9t9-23v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23zM1536 1664v-1024h-1408v1024h1408zM896 1088h224q14 0 23 9t9 23v64q0 14-9 23t-23 9h-224v224q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-224h-224q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h224v-224q0-14 9-23t23-9h64q14 0 23 9t9 23v224z"
    }
  }]
};
exports.calendarPlusO = calendarPlusO;
var calendarMinusO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1152 1120v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"
    }
  }]
};
exports.calendarMinusO = calendarMinusO;
var calendarTimesO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1111 1385l-46 46q-9 9-22 9t-23-9l-188-189-188 189q-10 9-23 9t-22-9l-46-46q-9-9-9-22t9-23l189-188-189-188q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l188 188 188-188q10-9 23-9t22 9l46 46q9 9 9 22t-9 23l-188 188 188 188q9 10 9 23t-9 22zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"
    }
  }]
};
exports.calendarTimesO = calendarTimesO;
var calendarCheckO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1303 964l-512 512q-10 9-23 9t-23-9l-288-288q-9-10-9-23t9-22l46-46q9-9 22-9t23 9l220 220 444-444q10-9 23-9t22 9l46 46q9 9 9 22t-9 23zM128 1664h1408v-1024h-1408v1024zM512 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1280 448v-288q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v288q0 14 9 23t23 9h64q14 0 23-9t9-23zM1664 384v1280q0 52-38 90t-90 38h-1408q-52 0-90-38t-38-90v-1280q0-52 38-90t90-38h128v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h384v-96q0-66 47-113t113-47h64q66 0 113 47t47 113v96h128q52 0 90 38t38 90z"
    }
  }]
};
exports.calendarCheckO = calendarCheckO;
var industry = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M448 0q26 0 45 19t19 45v891l536-429q17-14 40-14 26 0 45 19t19 45v379l536-429q17-14 40-14 26 0 45 19t19 45v1152q0 26-19 45t-45 19h-1664q-26 0-45-19t-19-45v-1664q0-26 19-45t45-19h384z"
    }
  }]
};
exports.industry = industry;
var mapPin = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1088q66 0 128-15v655q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-655q62 15 128 15zM512 0q212 0 362 150t150 362-150 362-362 150-362-150-150-362 150-362 362-150zM512 224q14 0 23-9t9-23-9-23-23-9q-146 0-249 103t-103 249q0 14 9 23t23 9 23-9 9-23q0-119 84.5-203.5t203.5-84.5z"
    }
  }]
};
exports.mapPin = mapPin;
var mapSigns = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1745 297q10 10 10 23t-10 23l-141 141q-28 28-68 28h-1344q-26 0-45-19t-19-45v-256q0-26 19-45t45-19h576v-64q0-26 19-45t45-19h128q26 0 45 19t19 45v64h512q40 0 68 28zM768 1216h256v512q0 26-19 45t-45 19h-128q-26 0-45-19t-19-45v-512zM1600 768q26 0 45 19t19 45v256q0 26-19 45t-45 19h-1344q-40 0-68-28l-141-141q-10-10-10-23t10-23l141-141q28-28 68-28h512v-192h256v192h576z"
    }
  }]
};
exports.mapSigns = mapSigns;
var mapO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2020 11q28 20 28 53v1408q0 20-11 36t-29 23l-640 256q-24 11-48 0l-616-246-616 246q-10 5-24 5-19 0-36-11-28-20-28-53v-1408q0-20 11-36t29-23l640-256q24-11 48 0l616 246 616-246q32-13 60 6zM736 146v1270l576 230v-1270zM128 363v1270l544-217v-1270zM1920 1429v-1270l-544 217v1270z"
    }
  }]
};
exports.mapO = mapO;
var map = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 0q13 0 22.5 9.5t9.5 22.5v1472q0 20-17 28l-480 256q-7 4-15 4-13 0-22.5-9.5t-9.5-22.5v-1472q0-20 17-28l480-256q7-4 15-4zM1760 0q13 0 22.5 9.5t9.5 22.5v1472q0 20-17 28l-480 256q-7 4-15 4-13 0-22.5-9.5t-9.5-22.5v-1472q0-20 17-28l480-256q7-4 15-4zM640 0q8 0 14 3l512 256q18 10 18 29v1472q0 13-9.5 22.5t-22.5 9.5q-8 0-14-3l-512-256q-18-10-18-29v-1472q0-13 9.5-22.5t22.5-9.5z"
    }
  }]
};
exports.map = map;
var commenting = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1024 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1408 896q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-110 0-211-18-173 173-435 229-52 10-86 13-12 1-22-6t-13-18q-4-15 20-37 5-5 23.5-21.5t25.5-23.5 23.5-25.5 24-31.5 20.5-37 20-48 14.5-57.5 12.5-72.5q-146-90-229.5-216.5t-83.5-269.5q0-174 120-321.5t326-233 450-85.5 450 85.5 326 233 120 321.5z"
    }
  }]
};
exports.commenting = commenting;
var commentingO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1024 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM1408 896q0 53-37.5 90.5t-90.5 37.5-90.5-37.5-37.5-90.5 37.5-90.5 90.5-37.5 90.5 37.5 37.5 90.5zM896 384q-204 0-381.5 69.5t-282 187.5-104.5 255q0 112 71.5 213.5t201.5 175.5l87 50-27 96q-24 91-70 172 152-63 275-171l43-38 57 6q69 8 130 8 204 0 381.5-69.5t282-187.5 104.5-255-104.5-255-282-187.5-381.5-69.5zM1792 896q0 174-120 321.5t-326 233-450 85.5q-70 0-145-8-198 175-460 242-49 14-114 22h-5q-15 0-27-10.5t-16-27.5v-1q-3-4-0.5-12t2-10 4.5-9.5l6-9t7-8.5 8-9q7-8 31-34.5t34.5-38 31-39.5 32.5-51 27-59 26-76q-157-89-247.5-220t-90.5-281q0-130 71-248.5t191-204.5 286-136.5 348-50.5 348 50.5 286 136.5 191 204.5 71 248.5z"
    }
  }]
};
exports.commentingO = commentingO;
var houzz = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M512 1191l512-295v591l-512 296v-592zM0 896v591l512-296zM512 9v591l-512 296v-591zM512 600l512-295v591z"
    }
  }]
};
exports.houzz = houzz;
var vimeo = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1709 518q-10 236-332 651-333 431-562 431-142 0-240-263-44-160-132-482-72-262-157-262-18 0-127 76l-77-98q24-21 108-96.5t130-115.5q156-138 241-146 95-9 153 55.5t81 203.5q44 287 66 373 55 249 120 249 51 0 154-161 101-161 109-246 13-139-109-139-57 0-121 26 120-393 459-382 251 8 236 326z"
    }
  }]
};
exports.vimeo = vimeo;
var blackTie = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 128h1536v1536h-1536v-1536zM1085 1243l-221-631 221-297h-634l221 297-221 631 317 304z"
    }
  }]
};
exports.blackTie = blackTie;
var fonticons = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 128h1536v1536h-1536v-1536zM908 448l-12 33 75 83-31 114 25 25 107-57 107 57 25-25-31-114 75-83-12-33h-95l-53-96h-32l-53 96h-95zM641 611q32 0 44.5 16t11.5 63l174-21q0-55-17.5-92.5t-50.5-56-69-25.5-85-7q-133 0-199 57.5t-66 182.5v72h-96v128h76q20 0 20 8v382q0 14-5 20t-18 7l-73 7v88h448v-86l-149-14q-6-1-8.5-1.5t-3.5-2.5-0.5-4 1-7 0.5-10v-387h191l38-128h-231q-6 0-2-6t4-9v-80q0-27 1.5-40.5t7.5-28 19.5-20 36.5-5.5zM1248 1440v-86l-54-9q-7-1-9.5-2.5t-2.5-3 1-7.5 1-12v-520h-275l-23 101 83 22q23 7 23 27v370q0 14-6 18.5t-20 6.5l-70 9v86h352z"
    }
  }]
};
exports.fonticons = fonticons;
var redditAlien = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 846q0 58-29.5 105.5t-79.5 72.5q12 46 12 96 0 155-106.5 287t-290.5 208.5-400 76.5-399.5-76.5-290-208.5-106.5-287q0-47 11-94-51-25-82-73.5t-31-106.5q0-82 58-140.5t141-58.5q85 0 145 63 218-152 515-162l116-521q3-13 15-21t26-5l369 81q18-37 54-59.5t79-22.5q62 0 106 43.5t44 105.5-44 106-106 44-105.5-43.5-43.5-105.5l-334-74-104 472q300 9 519 160 58-61 143-61 83 0 141 58.5t58 140.5zM418 1045q0 62 43.5 106t105.5 44 106-44 44-106-44-105.5-106-43.5q-61 0-105 44t-44 105zM1228 1400q11-11 11-26t-11-26q-10-10-25-10t-26 10q-41 42-121 62t-160 20-160-20-121-62q-11-10-26-10t-25 10q-11 10-11 25.5t11 26.5q43 43 118.5 68t122.5 29.5 91 4.5 91-4.5 122.5-29.5 118.5-68zM1225 1195q62 0 105.5-44t43.5-106q0-61-44-105t-105-44q-62 0-106 43.5t-44 105.5 44 106 106 44z"
    }
  }]
};
exports.redditAlien = redditAlien;
var edge = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M69 795h1q16-126 58.5-241.5t115-217 167.5-176 223.5-117.5 276.5-43q231 0 414 105.5t294 303.5q104 187 104 442v188h-1125q1 111 53.5 192.5t136.5 122.5 189.5 57 213 3 208-46.5 173.5-84.5v377q-92 55-229.5 92t-312.5 38-316-53q-189-73-311.5-249t-124.5-372q-3-242 111-412t325-268q-48 60-78 125.5t-46 159.5h635q8-77-8-140t-47-101.5-70.5-66.5-80.5-41-75-20.5-56-8.5l-22-1q-135 5-259.5 44.5t-223.5 104.5-176 140.5-138 163.5z"
    }
  }]
};
exports.edge = edge;
var creditCardAlt = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 1504v-608h2304v608q0 66-47 113t-113 47h-1984q-66 0-113-47t-47-113zM640 1280v128h384v-128h-384zM256 1280v128h256v-128h-256zM2144 128q66 0 113 47t47 113v224h-2304v-224q0-66 47-113t113-47h1984z"
    }
  }]
};
exports.creditCardAlt = creditCardAlt;
var codiepie = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1584 1290l-218-111q-74 120-196.5 189t-263.5 69q-147 0-271-72t-196-196-72-270q0-110 42.5-209.5t115-172 172-115 209.5-42.5q131 0 247.5 60.5t192.5 168.5l215-125q-110-169-286.5-265t-378.5-96q-161 0-308 63t-253 169-169 253-63 308 63 308 169 253 253 169 308 63q213 0 397.5-107t290.5-292zM1030 893l693 352q-116 253-334.5 400t-492.5 147q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71q260 0 470.5 133.5t335.5 366.5zM1543 896h-39v160h-96v-352h136q32 0 54.5 20t28.5 48 1 56-27.5 48-57.5 20z"
    }
  }]
};
exports.codiepie = codiepie;
var modx = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1427 709l-614-386 92-151h855zM405 974l-184-116v-858l1183 743zM1424 839l147 95v858l-532-335zM1387 818l-500 802h-855l356-571z"
    }
  }]
};
exports.modx = modx;
var fortAwesome = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1008v-224q0-16-16-16h-96q-16 0-16 16v224q0 16 16 16h96q16 0 16-16zM1152 1008v-224q0-16-16-16h-96q-16 0-16 16v224q0 16 16 16h96q16 0 16-16zM1664 1040v752h-640v-320q0-80-56-136t-136-56-136 56-56 136v320h-640v-752q0-16 16-16h96q16 0 16 16v112h128v-624q0-16 16-16h96q16 0 16 16v112h128v-112q0-16 16-16h96q16 0 16 16v112h128v-112q0-6 2.5-9.5t8.5-5 9.5-2 11.5 0 9 0.5v-391q-32-15-32-50 0-23 16.5-39t38.5-16 38.5 16 16.5 39q0 35-32 50v17q45-10 83-10 21 0 59.5 7.5t54.5 7.5q17 0 47-7.5t37-7.5q16 0 16 16v210q0 15-35 21.5t-62 6.5q-18 0-54.5-7.5t-55.5-7.5q-40 0-90 12v133q1 0 9-0.5t11.5 0 9.5 2 8.5 5 2.5 9.5v112h128v-112q0-16 16-16h96q16 0 16 16v112h128v-112q0-16 16-16h96q16 0 16 16v624h128v-112q0-16 16-16h96q16 0 16 16z"
    }
  }]
};
exports.fortAwesome = fortAwesome;
var usb = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2288 805q16 8 16 27t-16 27l-320 192q-8 5-16 5-9 0-16-4-16-10-16-28v-128h-858q37 58 83 165 16 37 24.5 55t24 49 27 47 27 34 31.5 26 33 8h96v-96q0-14 9-23t23-9h320q14 0 23 9t9 23v320q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-96h-96q-32 0-61-10t-51-23.5-45-40.5-37-46-33.5-57-28.5-57.5-28-60.5q-23-53-37-81.5t-36-65-44.5-53.5-46.5-17h-360q-22 84-91 138t-157 54q-106 0-181-75t-75-181 75-181 181-75q88 0 157 54t91 138h104q24 0 46.5-17t44.5-53.5 36-65 37-81.5q19-41 28-60.5t28.5-57.5 33.5-57 37-46 45-40.5 51-23.5 61-10h107q21-57 70-92.5t111-35.5q80 0 136 56t56 136-56 136-136 56q-62 0-111-35.5t-70-92.5h-107q-17 0-33 8t-31.5 26-27 34-27 47-24 49-24.5 55q-46 107-83 165h1114v-128q0-18 16-28t32 1z"
    }
  }]
};
exports.usb = usb;
var productHunt = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1150 762q0 56-39.5 95t-95.5 39h-253v-269h253q56 0 95.5 39.5t39.5 95.5zM1329 762q0-130-91.5-222t-222.5-92h-433v896h180v-269h253q130 0 222-91.5t92-221.5zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.productHunt = productHunt;
var mixcloud = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1645 1098q0-59-34-106.5t-87-68.5q-7 45-23 92-7 24-27.5 38t-44.5 14q-12 0-24-3-31-10-45-38.5t-4-58.5q23-71 23-143 0-123-61-227.5t-166-165.5-228-61q-134 0-247 73t-167 194q108 28 188 106 22 23 22 55t-22 54-54 22-55-22q-75-75-180-75-106 0-181 74.5t-75 180.5 75 180.5 181 74.5h1046q79 0 134.5-55.5t55.5-133.5zM1798 1098q0 142-100.5 242t-242.5 100h-1046q-169 0-289-119.5t-120-288.5q0-153 100-267t249-136q62-184 221-298t354-114q235 0 408.5 158.5t196.5 389.5q116 25 192.5 118.5t76.5 214.5zM2048 1098q0 175-97 319-23 33-64 33-24 0-43-13-26-17-32-48.5t12-57.5q71-104 71-233t-71-233q-18-26-12-57t32-49 57.5-11.5 49.5 32.5q97 142 97 318zM2304 1098q0 244-134 443-23 34-64 34-23 0-42-13-26-18-32.5-49t11.5-57q108-164 108-358 0-195-108-357-18-26-11.5-57.5t32.5-48.5q26-18 57-12t49 33q134 198 134 442z"
    }
  }]
};
exports.mixcloud = mixcloud;
var scribd = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1500 1549q0 89-63 152.5t-153 63.5-153.5-63.5-63.5-152.5q0-90 63.5-153.5t153.5-63.5 153 63.5 63 153.5zM1267 1268q-115 15-192.5 102.5t-77.5 205.5q0 74 33 138-146 78-379 78-109 0-201-21t-153.5-54.5-110.5-76.5-76-85-44.5-83-23.5-66.5-6-39.5q0-19 4.5-42.5t18.5-56 36.5-58 64-43.5 94.5-18 94 17.5 63 41 35.5 53 17.5 49 4 33.5q0 34-23 81 28 27 82 42t93 17l40 1q115 0 190-51t75-133q0-26-9-48.5t-31.5-44.5-49.5-41-74-44-93.5-47.5-119.5-56.5q-28-13-43-20-116-55-187-100t-122.5-102-72-125.5-20.5-162.5q0-78 20.5-150t66-137.5 112.5-114 166.5-77 221.5-28.5q120 0 220 26t164.5 67 109.5 94 64 105.5 19 103.5q0 46-15 82.5t-36.5 58-48.5 36-49 19.5-39 5h-8-32t-39-5-44-14-41-28-37-46-24-70.5-10-97.5q-15-16-59-25.5t-81-10.5l-37-1q-68 0-117.5 31t-70.5 70-21 76q0 24 5 43t24 46 53 51 97 53.5 150 58.5q76 25 138.5 53.5t109 55.5 83 59 60.5 59.5 41 62.5 26.5 62 14.5 63.5 6 62 1 62.5z"
    }
  }]
};
exports.scribd = scribd;
var pauseCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M704 1184v-576q0-14-9-23t-23-9h-256q-14 0-23 9t-9 23v576q0 14 9 23t23 9h256q14 0 23-9t9-23zM1152 1184v-576q0-14-9-23t-23-9h-256q-14 0-23 9t-9 23v576q0 14 9 23t23 9h256q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.pauseCircle = pauseCircle;
var pauseCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM768 1440q148 0 273-73t198-198 73-273-73-273-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73zM864 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23v576q0 14-9 23t-23 9h-192zM480 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h192q14 0 23 9t9 23v576q0 14-9 23t-23 9h-192z"
    }
  }]
};
exports.pauseCircleO = pauseCircleO;
var stopCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1088 1184v-576q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v576q0 14 9 23t23 9h576q14 0 23-9t9-23zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.stopCircle = stopCircle;
var stopCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M768 128q209 0 385.5 103t279.5 279.5 103 385.5-103 385.5-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103zM768 1440q148 0 273-73t198-198 73-273-73-273-198-198-273-73-273 73-198 198-73 273 73 273 198 198 273 73zM480 1216q-14 0-23-9t-9-23v-576q0-14 9-23t23-9h576q14 0 23 9t9 23v576q0 14-9 23t-23 9h-576z"
    }
  }]
};
exports.stopCircleO = stopCircleO;
var shoppingBag = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1757 1408l35 313q3 28-16 50-19 21-48 21h-1664q-29 0-48-21-19-22-16-50l35-313h1722zM1664 569l86 775h-1708l86-775q3-24 21-40.5t43-16.5h256v128q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5v-128h384v128q0 53 37.5 90.5t90.5 37.5 90.5-37.5 37.5-90.5v-128h256q25 0 43 16.5t21 40.5zM1280 384v256q0 26-19 45t-45 19-45-19-19-45v-256q0-106-75-181t-181-75-181 75-75 181v256q0 26-19 45t-45 19-45-19-19-45v-256q0-159 112.5-271.5t271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  }]
};
exports.shoppingBag = shoppingBag;
var shoppingBasket = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1920 768q53 0 90.5 37.5t37.5 90.5-37.5 90.5-90.5 37.5h-15l-115 662q-8 46-44 76t-82 30h-1280q-46 0-82-30t-44-76l-115-662h-15q-53 0-90.5-37.5t-37.5-90.5 37.5-90.5 90.5-37.5h1792zM485 1568q26-2 43.5-22.5t15.5-46.5l-32-416q-2-26-22.5-43.5t-46.5-15.5-43.5 22.5-15.5 46.5l32 416q2 25 20.5 42t43.5 17h5zM896 1504v-416q0-26-19-45t-45-19-45 19-19 45v416q0 26 19 45t45 19 45-19 19-45zM1280 1504v-416q0-26-19-45t-45-19-45 19-19 45v416q0 26 19 45t45 19 45-19 19-45zM1632 1509l32-416q2-26-15.5-46.5t-43.5-22.5-46.5 15.5-22.5 43.5l-32 416q-2 26 15.5 46.5t43.5 22.5h5q25 0 43.5-17t20.5-42zM476 292l-93 412h-132l101-441q19-88 89-143.5t160-55.5h167q0-26 19-45t45-19h384q26 0 45 19t19 45h167q90 0 160 55.5t89 143.5l101 441h-132l-93-412q-11-44-45.5-72t-79.5-28h-167q0 26-19 45t-45 19h-384q-26 0-45-19t-19-45h-167q-45 0-79.5 28t-45.5 72z"
    }
  }]
};
exports.shoppingBasket = shoppingBasket;
var hashtag = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M991 1024l64-256h-254l-64 256h254zM1759 520l-56 224q-7 24-31 24h-327l-64 256h311q15 0 25 12 10 14 6 28l-56 224q-5 24-31 24h-327l-81 328q-7 24-31 24h-224q-16 0-26-12-9-12-6-28l78-312h-254l-81 328q-7 24-31 24h-225q-15 0-25-12-9-12-6-28l78-312h-311q-15 0-25-12-9-12-6-28l56-224q7-24 31-24h327l64-256h-311q-15 0-25-12-10-14-6-28l56-224q5-24 31-24h327l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h254l81-328q7-24 32-24h224q15 0 25 12 9 12 6 28l-78 312h311q15 0 25 12 9 12 6 28z"
    }
  }]
};
exports.hashtag = hashtag;
var bluetooth = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M841 1053l148 148-149 149zM840 442l149 149-148 148zM710 1666l464-464-306-306 306-306-464-464v611l-255-255-93 93 320 321-320 321 93 93 255-255v611zM1429 896q0 209-32 365.5t-87.5 257-140.5 162.5-181.5 86.5-219.5 24.5-219.5-24.5-181.5-86.5-140.5-162.5-87.5-257-32-365.5 32-365.5 87.5-257 140.5-162.5 181.5-86.5 219.5-24.5 219.5 24.5 181.5 86.5 140.5 162.5 87.5 257 32 365.5z"
    }
  }]
};
exports.bluetooth = bluetooth;
var bluetoothB = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M596 1423l173-172-173-172v344zM596 713l173-172-173-172v344zM628 896l356 356-539 540v-711l-297 296-108-108 372-373-372-373 108-108 297 296v-711l539 540z"
    }
  }]
};
exports.bluetoothB = bluetoothB;
var percent = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1280q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM512 512q0-52-38-90t-90-38-90 38-38 90 38 90 90 38 90-38 38-90zM1536 1280q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5zM1440 192q0 20-13 38l-1056 1408q-19 26-51 26h-160q-26 0-45-19t-19-45q0-20 13-38l1056-1408q19-26 51-26h160q26 0 45 19t19 45zM768 512q0 159-112.5 271.5t-271.5 112.5-271.5-112.5-112.5-271.5 112.5-271.5 271.5-112.5 271.5 112.5 112.5 271.5z"
    }
  }]
};
exports.percent = percent;
var gitlab = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M104 706l792 1015-868-630q-18-13-25-34.5t0-42.5l101-308v0zM566 706h660l-330 1015v0zM368 94l198 612h-462l198-612q8-23 33-23t33 23zM1688 706l101 308q7 21 0 42.5t-25 34.5l-868 630 792-1015v0zM1688 706h-462l198-612q8-23 33-23t33 23z"
    }
  }]
};
exports.gitlab = gitlab;
var wpbeginner = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M384 832h160v-224h-160v224zM1221 1164v-92q-104 36-243 38-135 1-259.5-46.5t-220.5-122.5l1 96q88 80 212 128.5t272 47.5q129 0 238-49zM640 832h640v-224h-640v224zM1792 800q0 187-99 352 89 102 89 229 0 157-129.5 268t-313.5 111q-122 0-225-52.5t-161-140.5q-19 1-57 1t-57-1q-58 88-161 140.5t-225 52.5q-184 0-313.5-111t-129.5-268q0-127 89-229-99-165-99-352 0-209 120-385.5t326.5-279.5 449.5-103 449.5 103 326.5 279.5 120 385.5z"
    }
  }]
};
exports.wpbeginner = wpbeginner;
var wpforms = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M515 911v128h-252v-128h252zM515 656v127h-252v-127h252zM1273 1167v128h-341v-128h341zM1273 911v128h-672v-128h672zM1273 656v127h-672v-127h672zM1408 1516v-1240q0-8-6-14t-14-6h-32l-378 256-210-171-210 171-378-256h-32q-8 0-14 6t-6 14v1240q0 8 6 14t14 6h1240q8 0 14-6t6-14zM553 406l185-150h-406zM983 406l221-150h-406zM1536 276v1240q0 62-43 105t-105 43h-1240q-62 0-105-43t-43-105v-1240q0-62 43-105t105-43h1240q62 0 105 43t43 105z"
    }
  }]
};
exports.wpforms = wpforms;
var envira = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 816q-104-196-160-278-139-202-347-318-34-19-70-36-89-40-94-32t34 38l39 31q62 43 112.5 93.5t94.5 116.5 70.5 113 70.5 131q9 17 13 25 44 84 84 153t98 154 115.5 150 131 123.5 148.5 90.5q153 66 154 60 1-3-49-37-53-36-81-57-77-58-179-211t-185-310zM549 1359q-76-60-132.5-125t-98-143.5-71-154.5-58.5-186-52-209-60.5-252-76.5-289q273 0 497.5 36t379 92 271 144.5 185.5 172.5 110 198.5 56 199.5 12.5 198.5-9.5 173-20 143.5-13 107l323 327h-104l-281-285q-22 2-91.5 14t-121.5 19-138 6-160.5-17-167.5-59-179-111z"
    }
  }]
};
exports.envira = envira;
var universalAccess = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1374 657q-6-26-28.5-39.5t-48.5-7.5q-261 62-401 62t-401-62q-26-6-48.5 7.5t-28.5 39.5 7.5 48.5 39.5 28.5q194 46 303 58-2 158-15.5 269t-26.5 155.5-41 115.5l-9 21q-10 25 1 49t36 34q9 4 23 4 44 0 60-41l8-20q54-139 71-259h42q17 120 71 259l8 20q16 41 60 41 14 0 23-4 25-10 36-34t1-49l-9-21q-28-71-41-115.5t-26.5-155.5-15.5-269q109-12 303-58 26-6 39.5-28.5t7.5-48.5zM1024 512q0-53-37.5-90.5t-90.5-37.5-90.5 37.5-37.5 90.5 37.5 90.5 90.5 37.5 90.5-37.5 37.5-90.5zM1600 896q0 143-55.5 273.5t-150 225-225 150-273.5 55.5-273.5-55.5-225-150-150-225-55.5-273.5 55.5-273.5 150-225 225-150 273.5-55.5 273.5 55.5 225 150 150 225 55.5 273.5zM896 128q-156 0-298 61t-245 164-164 245-61 298 61 298 164 245 245 164 298 61 298-61 245-164 164-245 61-298-61-298-164-245-245-164-298-61zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.universalAccess = universalAccess;
var wheelchairAlt = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1438 813q34 35 29 82l-44 551q-4 42-34.5 70t-71.5 28q-6 0-9-1-44-3-72.5-36.5t-25.5-77.5l35-429-143 8q55 113 55 240 0 216-148 372l-137-137q91-101 91-235 0-145-102.5-248t-247.5-103q-134 0-236 92l-137-138q120-114 284-141l264-300-149-87-181 161q-33 30-77 27.5t-73-35.5-26.5-77 34.5-73l239-213q26-23 60-26.5t64 14.5l488 283q36 21 48 68 17 67-26 117l-205 232 371-20q49-3 83 32zM1240 356q-74 0-126-52t-52-126 52-126 126-52 126.5 52 52.5 126-52.5 126-126.5 52zM613 1598q106 0 196-61l139 139q-146 116-335 116-148 0-273.5-73t-198.5-198-73-273q0-188 116-336l139 139q-60 88-60 197 0 145 102.5 247.5t247.5 102.5z"
    }
  }]
};
exports.wheelchairAlt = wheelchairAlt;
var questionCircleO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M880 1200v160q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-160q0-14 9-23t23-9h160q14 0 23 9t9 23zM1136 704q0 50-15 90t-45.5 69-52 44-59.5 36q-32 18-46.5 28t-26 24-11.5 29v32q0 14-9 23t-23 9h-160q-14 0-23-9t-9-23v-68q0-35 10.5-64.5t24-47.5 39-35.5 41-25.5 44.5-21q53-25 75-43t22-49q0-42-43.5-71.5t-95.5-29.5q-56 0-95 27-29 20-80 83-9 12-25 12-11 0-19-6l-108-82q-10-7-12-20t5-23q122-192 349-192 129 0 238.5 89.5t109.5 214.5zM768 256q-130 0-248.5 51t-204 136.5-136.5 204-51 248.5 51 248.5 136.5 204 204 136.5 248.5 51 248.5-51 204-136.5 136.5-204 51-248.5-51-248.5-136.5-204-204-136.5-248.5-51zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.questionCircleO = questionCircleO;
var blind = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M366 311q-64 0-110-45.5t-46-110.5q0-64 46-109.5t110-45.5 109.5 45.5 45.5 109.5q0 65-45.5 110.5t-109.5 45.5zM917 953q0 50-30 67.5t-63.5 6.5-47.5-34l-367-438q-7-12-14-15.5t-11-1.5l-3 3q-7 8 4 21l122 139 1 354-161 457q-67 192-92 234-15 26-28 32-50 26-103 1-29-13-41.5-43t-9.5-57q2-17 197-618l5-416-85 164 35 222q4 24-1 42t-14 27.5-19 16-17 7.5l-7 2q-19 3-34.5-3t-24-16-14-22-7.5-19.5-2-9.5l-46-299 211-381q23-34 113-34 75 0 107 40l424 521q7 5 14 17l3 3-1 1q7 13 7 29zM514 1103q43 113 88.5 225t69.5 168l24 55q36 93 42 125 11 70-36 97-35 22-66 16t-51-22-29-35h-1q-6-16-8-25l-124-351zM1338 1695q31 49 31 57 0 5-3 7-9 5-14.5-0.5t-15.5-26-16-30.5q-114-172-423-661 3 1 7-1t7-4l3-2q11-9 11-17z"
    }
  }]
};
exports.blind = blind;
var audioDescription = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M504 994h171l-1-265zM1530 895q0-87-50.5-140t-146.5-53h-54v388h52q91 0 145-57t54-138zM956 518l1 756q0 14-9.5 24t-23.5 10h-216q-14 0-23.5-10t-9.5-24v-62h-291l-55 81q-10 15-28 15h-267q-21 0-30.5-18t3.5-35l556-757q9-14 27-14h332q14 0 24 10t10 24zM1783 895q0 193-125.5 303t-324.5 110h-270q-14 0-24-10t-10-24v-756q0-14 10-24t24-10h268q200 0 326 109t126 302zM1939 896q0 11-0.5 29t-8 71.5-21.5 102-44.5 108-73.5 102.5h-51q38-45 66.5-104.5t41.5-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-20-91.5-41-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 10.5 70.5zM2123 896q0 11-0.5 29t-8 71.5-21.5 102-45 108-74 102.5h-51q38-45 66.5-104.5t41.5-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-19.5-91.5-40.5-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 10.5 70.5zM2304 896q0 11-0.5 29t-8 71.5-21.5 102-44.5 108-73.5 102.5h-51q38-45 66-104.5t41-112 21-98 9-72.5l1-27q0-8-0.5-22.5t-7.5-60-19.5-91.5-40.5-111.5-66-124.5h43q41 47 72 107t45.5 111.5 23 96 9.5 70.5z"
    }
  }]
};
exports.audioDescription = audioDescription;
var volumeControlPhone = {
  "viewBox": "0 0 1408 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M617 1689q0-11-13-58t-31-107-20-69q-1-4-5-26.5t-8.5-36-13.5-21.5q-15-14-51-14-23 0-70 5.5t-71 5.5q-34 0-47-11-6-5-11-15.5t-7.5-20-6.5-24-5-18.5q-37-128-37-255t37-255q1-4 5-18.5t6.5-24 7.5-20 11-15.5q13-11 47-11 24 0 71 5.5t70 5.5q36 0 51-14 9-8 13.5-21.5t8.5-36 5-26.5q2-9 20-69t31-107 13-58q0-22-43.5-52.5t-75.5-42.5q-20-8-45-8-34 0-98 18-57 17-96.5 40.5t-71 66-46 70-45.5 94.5q-6 12-9 19-49 107-68 216t-19 244 19 244 68 216q56 122 83 161 63 91 179 127l6 2q64 18 98 18 25 0 45-8 32-12 75.5-42.5t43.5-52.5zM776 776q-26 0-45-19t-19-45.5 19-45.5q37-37 37-90 0-52-37-91-19-19-19-45t19-45 45-19 45 19q75 75 75 181t-75 181q-21 19-45 19zM957 957q-27 0-45-19-19-19-19-45t19-45q112-114 112-272t-112-272q-19-19-19-45t19-45 45-19 45 19q150 150 150 362t-150 362q-18 19-45 19zM1138 1138q-27 0-45-19-19-19-19-45t19-45q90-91 138.5-208t48.5-245-48.5-245-138.5-208q-19-19-19-45t19-45 45-19 45 19q109 109 167 249t58 294-58 294-167 249q-18 19-45 19z"
    }
  }]
};
exports.volumeControlPhone = volumeControlPhone;
var braille = {
  "viewBox": "0 0 2176 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M192 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM704 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM704 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1472 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 1184q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1472 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 672q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM1984 160q-66 0-113 47t-47 113 47 113 113 47 113-47 47-113-47-113-113-47zM384 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM384 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM896 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 1344q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 832q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1664 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM2176 320q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136z"
    }
  }]
};
exports.braille = braille;
var assistiveListeningSystems = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M128 1728q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM320 1536q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM365 1171l256 256-90 90-256-256zM704 1152q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1411 832q0 59-11.5 108.5t-37.5 93.5-44 67.5-53 64.5q-31 35-45.5 54t-33.5 50-26.5 64-7.5 74q0 159-112.5 271.5t-271.5 112.5q-26 0-45-19t-19-45 19-45 45-19q106 0 181-75t75-181q0-57 11.5-105.5t37-91 43.5-66.5 52-63q40-46 59.5-72t37.5-74.5 18-103.5q0-185-131.5-316.5t-316.5-131.5-316.5 131.5-131.5 316.5q0 26-19 45t-45 19-45-19-19-45q0-117 45.5-223.5t123-184 184-123 223.5-45.5 223.5 45.5 184 123 123 184 45.5 223.5zM896 960q0 26-19 45t-45 19-45-19-19-45 19-45 45-19 45 19 19 45zM1184 832q0 26-19 45t-45 19-45-19-19-45q0-93-65.5-158.5t-158.5-65.5q-92 0-158 65.5t-66 158.5q0 26-19 45t-45 19-45-19-19-45q0-146 103-249t249-103 249 103 103 249zM1578 543q10 25-1 49t-36 34q-9 4-23 4-19 0-35.5-11t-23.5-30q-68-178-224-295-21-16-25-42t12-47q17-21 43-25t47 12q183 137 266 351zM1788 462q9 25-1.5 49t-35.5 34q-11 4-23 4-44 0-60-41-92-238-297-393-22-16-25.5-42t12.5-47q16-22 42-25.5t47 12.5q235 175 341 449z"
    }
  }]
};
exports.assistiveListeningSystems = assistiveListeningSystems;
var americanSignLanguageInterpreting = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1032 960q-59-2-84-55-17-34-48-53.5t-68-19.5q-53 0-90.5 37.5t-37.5 90.5q0 56 36 89l10 8q34 31 82 31 37 0 68-19.5t48-53.5q25-53 84-55zM1600 832q0-56-36-89l-10-8q-34-31-82-31-37 0-68 19.5t-48 53.5q-25 53-84 55 59 2 84 55 17 34 48 53.5t68 19.5q53 0 90.5-37.5t37.5-90.5zM1174 611q-17 35-55 48t-73-4q-62-31-134-31-51 0-99 17 3 0 9.5-0.5t9.5-0.5q92 0 170.5 50t118.5 133q17 36 3.5 73.5t-49.5 54.5q-18 9-39 9 21 0 39 9 36 17 49.5 54.5t-3.5 73.5q-40 83-118.5 133t-170.5 50h-6q-16-2-44-4l-290-27-239 120q-14 7-29 7-40 0-57-35l-160-320q-11-23-4-47.5t29-37.5l209-119 148-267q17-155 91.5-291.5t195.5-236.5q31-25 70.5-21.5t64.5 34.5 21.5 70-34.5 65q-70 59-117 128 123-84 267-101 40-5 71.5 19t35.5 64q5 40-19 71.5t-64 35.5q-84 10-159 55 46-10 99-10 115 0 218 50 36 18 49 55.5t-5 73.5zM2137 451l160 320q11 23 4 47.5t-29 37.5l-209 119-148 267q-17 155-91.5 291.5t-195.5 236.5q-26 22-61 22-45 0-74-35-25-31-21.5-70t34.5-65q70-59 117-128-123 84-267 101-4 1-12 1-36 0-63.5-24t-31.5-60q-5-40 19-71.5t64-35.5q84-10 159-55-46 10-99 10-115 0-218-50-36-18-49-55.5t5-73.5q17-35 55-48t73 4q62 31 134 31 51 0 99-17-3 0-9.5 0.5t-9.5 0.5q-92 0-170.5-50t-118.5-133q-17-36-3.5-73.5t49.5-54.5q18-9 39-9-21 0-39-9-36-17-49.5-54.5t3.5-73.5q40-83 118.5-133t170.5-50h6 1q14 2 42 4l291 27 239-120q14-7 29-7 40 0 57 35z"
    }
  }]
};
exports.americanSignLanguageInterpreting = americanSignLanguageInterpreting;
var aslInterpreting = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1032 960q-59-2-84-55-17-34-48-53.5t-68-19.5q-53 0-90.5 37.5t-37.5 90.5q0 56 36 89l10 8q34 31 82 31 37 0 68-19.5t48-53.5q25-53 84-55zM1600 832q0-56-36-89l-10-8q-34-31-82-31-37 0-68 19.5t-48 53.5q-25 53-84 55 59 2 84 55 17 34 48 53.5t68 19.5q53 0 90.5-37.5t37.5-90.5zM1174 611q-17 35-55 48t-73-4q-62-31-134-31-51 0-99 17 3 0 9.5-0.5t9.5-0.5q92 0 170.5 50t118.5 133q17 36 3.5 73.5t-49.5 54.5q-18 9-39 9 21 0 39 9 36 17 49.5 54.5t-3.5 73.5q-40 83-118.5 133t-170.5 50h-6q-16-2-44-4l-290-27-239 120q-14 7-29 7-40 0-57-35l-160-320q-11-23-4-47.5t29-37.5l209-119 148-267q17-155 91.5-291.5t195.5-236.5q31-25 70.5-21.5t64.5 34.5 21.5 70-34.5 65q-70 59-117 128 123-84 267-101 40-5 71.5 19t35.5 64q5 40-19 71.5t-64 35.5q-84 10-159 55 46-10 99-10 115 0 218 50 36 18 49 55.5t-5 73.5zM2137 451l160 320q11 23 4 47.5t-29 37.5l-209 119-148 267q-17 155-91.5 291.5t-195.5 236.5q-26 22-61 22-45 0-74-35-25-31-21.5-70t34.5-65q70-59 117-128-123 84-267 101-4 1-12 1-36 0-63.5-24t-31.5-60q-5-40 19-71.5t64-35.5q84-10 159-55-46 10-99 10-115 0-218-50-36-18-49-55.5t5-73.5q17-35 55-48t73 4q62 31 134 31 51 0 99-17-3 0-9.5 0.5t-9.5 0.5q-92 0-170.5-50t-118.5-133q-17-36-3.5-73.5t49.5-54.5q18-9 39-9-21 0-39-9-36-17-49.5-54.5t3.5-73.5q40-83 118.5-133t170.5-50h6 1q14 2 42 4l291 27 239-120q14-7 29-7 40 0 57 35z"
    }
  }]
};
exports.aslInterpreting = aslInterpreting;
var deaf = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"
    }
  }]
};
exports.deaf = deaf;
var deafness = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"
    }
  }]
};
exports.deafness = deafness;
var hardOfHearing = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1056 832q0 26 19 45t45 19 45-19 19-45q0-146-103-249t-249-103-249 103-103 249q0 26 19 45t45 19 45-19 19-45q0-93 66-158.5t158-65.5 158 65.5 66 158.5zM835 256q-117 0-223.5 45.5t-184 123-123 184-45.5 223.5q0 26 19 45t45 19 45-19 19-45q0-185 131.5-316.5t316.5-131.5 316.5 131.5 131.5 316.5q0 55-18 103.5t-37.5 74.5-59.5 72q-34 39-52 63t-43.5 66.5-37 91-11.5 105.5q0 106-75 181t-181 75q-26 0-45 19t-19 45 19 45 45 19q159 0 271.5-112.5t112.5-271.5q0-41 7.5-74t26.5-64 33.5-50 45.5-54q35-41 53-64.5t44-67.5 37.5-93.5 11.5-108.5q0-117-45.5-223.5t-123-184-184-123-223.5-45.5zM591 975l226 226-579 579q-12 12-29 12t-29-12l-168-168q-12-12-12-29t12-29zM1612 12l168 168q12 12 12 29t-12 30l-233 233-26 25-71 71q-66-153-195-258l91-91 207-207q13-12 30-12t29 12z"
    }
  }]
};
exports.hardOfHearing = hardOfHearing;
var glide = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M866 515q0 27-13 94-11 50-31.5 150t-30.5 150q-2 11-4.5 12.5t-13.5 2.5q-20 2-31 2-58 0-84-49.5t-26-113.5q0-88 35-174t103-124q28-14 51-14 28 0 36.5 16.5t8.5 47.5zM1352 939q0-14-39-75.5t-52-66.5q-21-8-34-8-91 0-226 77l-2-2q3-22 27.5-135t24.5-178q0-233-242-233-24 0-68 6-94 17-168.5 89.5t-111.5 166.5-37 189q0 146 80.5 225t227.5 79q25 0 25 3t-1 5q-4 34-26 117-14 52-51.5 101t-82.5 49q-42 0-42-47 0-24 10.5-47.5t25-39.5 29.5-28.5 26-20 11-8.5q0-3-7-10-24-22-58.5-36.5t-65.5-14.5q-35 0-63.5 34t-41 75-12.5 75q0 88 51.5 142t138.5 54q82 0 155-53t117.5-126 65.5-153q6-22 15.5-66.5t14.5-66.5q3-12 14-18 118-60 227-60 48 0 127 18 1 1 4 1 5 0 9.5-4.5t4.5-8.5zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.glide = glide;
var glideG = {
  "viewBox": "0 0 1535 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M744 305q0-24-2-38.5t-8.5-30-21-23-37.5-7.5q-39 0-78 23-105 58-159 190.5t-54 269.5q0 44 8.5 85.5t26.5 80.5 52.5 62.5 81.5 23.5q4 0 18 0.5t20 0 16-3 15-8.5 7-16q16-77 48-231.5t48-231.5q19-91 19-146zM1498 961q0 7-7.5 13.5t-15.5 6.5l-6-1q-22-3-62-11t-72-12.5-63-4.5q-167 0-351 93-15 8-21 27-10 36-24.5 105.5t-22.5 100.5q-23 91-70 179.5t-112.5 164.5-154.5 123-185 47q-135 0-214.5-83.5t-79.5-219.5q0-53 19.5-117t63-116.5 97.5-52.5q38 0 120 33.5t83 61.5q0 1-16.5 12.5t-39.5 31-46 44.5-39 61-16 74q0 33 16.5 53t48.5 20q45 0 85-31.5t66.5-78 48-105.5 32.5-107 16-90v-9q0-2-3.5-3.5t-8.5-1.5h-10t-10 0.5-6 0.5q-227 0-352-122.5t-125-348.5q0-108 34.5-221t96-210 156-167.5 204.5-89.5q52-9 106-9 374 0 374 360 0 98-38 273t-43 211l3 3q101-57 182.5-88t167.5-31q22 0 53 13 19 7 80 102.5t61 116.5z"
    }
  }]
};
exports.glideG = glideG;
var signLanguage = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M831 673q32 0 59 18l222 148q61 40 110 97l146 170q40 46 29 106l-72 413q-6 32-29.5 53.5t-55.5 25.5l-527 56-352 32h-9q-39 0-67.5-28t-28.5-68q0-37 27-64t65-32l260-32h-448q-41 0-69.5-30t-26.5-71q2-39 32-65t69-26l442-1-521-64q-41-5-66-37t-19-73q6-35 34.5-57.5t65.5-22.5h10l481 60-351-94q-38-10-62-41.5t-18-68.5q6-36 33-58.5t62-22.5q6 0 20 2l448 96 217 37q1 0 3 0.5t3 0.5q23 0 30.5-23t-12.5-36l-186-125q-35-23-42-63.5t18-73.5q27-38 76-38zM761 875l186 125-218-37-5-2-36-38-238-262q-1-1-2.5-3.5t-2.5-3.5q-24-31-18.5-70t37.5-64q31-23 68-17.5t64 33.5l142 147q-2 1-5 3.5t-4 4.5q-32 45-23 99t55 85zM1648 421l15 266q4 73-11 147l-48 219q-12 59-67 87l-106 54q2-62-39-109l-146-170q-53-61-117-103l-222-148q-34-23-76-23-51 0-88 37l-235-312q-25-33-18-73.5t41-63.5q33-22 71.5-14t62.5 40l266 352-262-455q-21-35-10.5-75t47.5-59q35-18 72.5-6t57.5 46l241 420-136-337q-15-35-4.5-74t44.5-56q37-19 76-6t56 51l193 415 101 196q8 15 23 17.5t27-7.5 11-26l-12-224q-2-41 26-71t69-31q39 0 67 28.5t30 67.5z"
    }
  }]
};
exports.signLanguage = signLanguage;
var signing = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M831 673q32 0 59 18l222 148q61 40 110 97l146 170q40 46 29 106l-72 413q-6 32-29.5 53.5t-55.5 25.5l-527 56-352 32h-9q-39 0-67.5-28t-28.5-68q0-37 27-64t65-32l260-32h-448q-41 0-69.5-30t-26.5-71q2-39 32-65t69-26l442-1-521-64q-41-5-66-37t-19-73q6-35 34.5-57.5t65.5-22.5h10l481 60-351-94q-38-10-62-41.5t-18-68.5q6-36 33-58.5t62-22.5q6 0 20 2l448 96 217 37q1 0 3 0.5t3 0.5q23 0 30.5-23t-12.5-36l-186-125q-35-23-42-63.5t18-73.5q27-38 76-38zM761 875l186 125-218-37-5-2-36-38-238-262q-1-1-2.5-3.5t-2.5-3.5q-24-31-18.5-70t37.5-64q31-23 68-17.5t64 33.5l142 147q-2 1-5 3.5t-4 4.5q-32 45-23 99t55 85zM1648 421l15 266q4 73-11 147l-48 219q-12 59-67 87l-106 54q2-62-39-109l-146-170q-53-61-117-103l-222-148q-34-23-76-23-51 0-88 37l-235-312q-25-33-18-73.5t41-63.5q33-22 71.5-14t62.5 40l266 352-262-455q-21-35-10.5-75t47.5-59q35-18 72.5-6t57.5 46l241 420-136-337q-15-35-4.5-74t44.5-56q37-19 76-6t56 51l193 415 101 196q8 15 23 17.5t27-7.5 11-26l-12-224q-2-41 26-71t69-31q39 0 67 28.5t30 67.5z"
    }
  }]
};
exports.signing = signing;
var lowVision = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M335 1356q-2 0-6-2-86-57-168.5-145t-139.5-180q-21-30-21-69 0-9 2-19t4-18 7-18 8.5-16 10.5-17 10-15 12-15.5 11-14.5q184-251 452-365-110-198-110-211 0-19 17-29 116-64 128-64 18 0 28 16l124 229q92-19 192-19 266 0 497.5 137.5t378.5 369.5q20 31 20 69t-20 69q-91 142-218.5 253.5t-278.5 175.5q110 198 110 211 0 20-17 29-116 64-127 64-19 0-29-16l-124-229-64-119-444-820 7-7q-58 24-99 47 3 5 127 234t243 449 119 223q0 7-9 9-13 3-72 3-57 0-60-7l-456-841q-39 28-82 68 24 43 214 393.5t190 354.5q0 10-11 10-14 0-82.5-22t-72.5-28l-106-197-224-413q-44 53-78 106 2 3 18 25t23 34l176 327q0 10-10 10zM1165 1254l49 91q273-111 450-385-180-277-459-389 67 64 103 148.5t36 176.5q0 106-47 200.5t-132 157.5zM848 640q0 20 14 34t34 14q86 0 147 61t61 147q0 20 14 34t34 14 34-14 14-34q0-126-89-215t-215-89q-20 0-34 14t-14 34zM1214 575l-9-4 7 7z"
    }
  }]
};
exports.lowVision = lowVision;
var viadeo = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1050 1106q0 215-147 374-148 161-378 161-232 0-378-161-147-159-147-374 0-147 68-270.5t189-196.5 268-73q96 0 182 31-32 62-39 126-66-28-143-28-167 0-280.5 123t-113.5 291q0 170 112.5 288.5t281.5 118.5 281-118.5 112-288.5q0-89-32-166 66-13 123-49 41 98 41 212zM846 917q0 192-79.5 345t-238.5 253l-14 1q-29 0-62-5 83-32 146.5-102.5t99.5-154.5 58.5-189 30-192.5 7.5-178.5q0-69-3-103 55 160 55 326zM791 589v2q-73-214-206-440 88 59 142.5 186.5t63.5 251.5zM1035 792q-83 0-160-75 218-120 290-247 19-37 21-56-42 94-139.5 166.5t-204.5 97.5q-35-54-35-113 0-37 17-79t43-68q46-44 157-74 59-16 106-58.5t74-100.5q74 105 74 253 0 109-24 170-32 77-88.5 130.5t-130.5 53.5z"
    }
  }]
};
exports.viadeo = viadeo;
var viadeoSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1050 1041q0-78-28-147-41 25-85 34 22 50 22 114 0 117-77 198.5t-193 81.5-193.5-81.5-77.5-198.5q0-115 78-199.5t193-84.5q53 0 98 19 4-43 27-87-60-21-125-21-154 0-257.5 108.5t-103.5 263.5 103.5 261 257.5 106 257.5-106.5 103.5-260.5zM872 686q2 24 2 71 0 63-5 123t-20.5 132.5-40.5 130-68.5 106-100.5 70.5q21 3 42 3h10q219-139 219-411 0-116-38-225zM872 686q-4-80-44-171.5t-98-130.5q92 156 142 302zM1207 581q0-102-51-174-41 86-124 109-69 19-109 53.5t-40 99.5q0 40 24 77 74-17 140.5-67t95.5-115q-4 52-74.5 111.5t-138.5 97.5q52 52 110 52 51 0 90-37t60-90q17-42 17-117zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.viadeoSquare = viadeoSquare;
var snapchat = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1279 1148q0-22-22-27-67-15-118-59t-80-108q-7-19-7-25 0-15 19.5-26t43-17 43-20.5 19.5-36.5q0-19-18.5-31.5t-38.5-12.5q-12 0-32 8t-31 8q-4 0-12-2 5-95 5-114 0-79-17-114-36-78-103-121.5t-152-43.5q-199 0-275 165-17 35-17 114 0 19 5 114-4 2-14 2-12 0-32-7.5t-30-7.5q-21 0-38.5 12t-17.5 32q0 21 19.5 35.5t43 20.5 43 17 19.5 26q0 6-7 25-64 138-198 167-22 5-22 27 0 46 137 68 2 5 6 26t11.5 30.5 23.5 9.5q12 0 37.5-4.5t39.5-4.5q35 0 67 15t54 32.5 57.5 32.5 76.5 15q43 0 79-15t57.5-32.5 53.5-32.5 67-15q14 0 39.5 4t38.5 4q16 0 23-10t11-30 6-25q137-22 137-68zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.snapchat = snapchat;
var snapchatGhost = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M848 128q134-1 240.5 68.5t163.5 192.5q27 58 27 179 0 47-9 191 14 7 28 7 18 0 51-13.5t51-13.5q29 0 56 18t27 46q0 32-31.5 54t-69 31.5-69 29-31.5 47.5q0 15 12 43 37 82 102.5 150t144.5 101q28 12 80 23 28 6 28 35 0 70-219 103-7 11-11 39t-14 46.5-33 18.5q-20 0-62-6.5t-64-6.5q-37 0-62 5-32 5-63 22.5t-58 38-58 40.5-76 33.5-99 13.5q-52 0-96.5-13.5t-75-33.5-57.5-40.5-58-38-62-22.5q-26-5-63-5-24 0-65.5 7.5t-58.5 7.5q-25 0-35-18.5t-14-47.5-11-40q-219-33-219-103 0-29 28-35 52-11 80-23 78-32 144.5-101t102.5-150q12-28 12-43 0-28-31.5-47.5t-69.5-29.5-69.5-31.5-31.5-52.5q0-27 26-45.5t55-18.5q15 0 48 13t53 13q18 0 32-7-9-142-9-190 0-122 27-180 64-137 172-198t264-63z"
    }
  }]
};
exports.snapchatGhost = snapchatGhost;
var snapchatSquare = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1280 1148q0-22-22-27-67-14-118-58t-80-109q-7-14-7-25 0-15 19.5-26t42.5-17 42.5-20.5 19.5-36.5q0-19-18.5-31.5t-38.5-12.5q-11 0-31 8t-32 8q-4 0-12-2 5-63 5-115 0-78-17-114-36-78-102.5-121.5t-152.5-43.5q-198 0-275 165-18 38-18 115 0 38 6 114-10 2-15 2-11 0-31.5-8t-30.5-8q-20 0-37.5 12.5t-17.5 32.5q0 21 19.5 35.5t42.5 20.5 42.5 17 19.5 26q0 11-7 25-64 138-198 167-22 5-22 27 0 47 138 69 2 5 6 26t11 30.5 23 9.5q13 0 38.5-5t38.5-5q35 0 67.5 15t54.5 32.5 57.5 32.5 76.5 15q43 0 79-15t57.5-32.5 54-32.5 67.5-15q13 0 39 4.5t39 4.5q15 0 22.5-9.5t11.5-31 5-24.5q138-22 138-69zM1536 416v960q0 119-84.5 203.5t-203.5 84.5h-960q-119 0-203.5-84.5t-84.5-203.5v-960q0-119 84.5-203.5t203.5-84.5h960q119 0 203.5 84.5t84.5 203.5z"
    }
  }]
};
exports.snapchatSquare = snapchatSquare;
var piedPiper = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2304 0q-69 46-125 92t-89 81-59.5 71.5-37.5 57.5-22 44.5-14 29.5q-10 18-35.5 136.5t-48.5 164.5q-15 29-50 60.5t-67.5 50.5-72.5 41-48 28q-47 31-151 231-341-14-630 158-92 53-303 179 47-16 86-31t55-22l15-7q71-27 163-64.5t133.5-53.5 108-34.5 142.5-31.5q186-31 465 7 1 0 10 3 11 6 14 17t-3 22l-194 345q-15 29-47 22-128-24-354-24-146 0-402 44.5t-392 46.5q-82 1-149-13t-107-37-61-40-33-34l-1-1v-2q0-6 6-6 138 0 371-55 192-366 374.5-524t383.5-158q5 0 14.5 0.5t38 5 55 12 61.5 24.5 63 39.5 54 59 40 82.5l102-177q2-4 21-42.5t44.5-86.5 61-109.5 84-133.5 100.5-137q66-82 128-141.5t121.5-96.5 92.5-53.5 88-39.5z"
    }
  }]
};
exports.piedPiper = piedPiper;
var firstOrder = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1322 896q0 45-5 76l-236-14 224 78q-19 73-58 141l-214-103 177 158q-44 61-107 108l-157-178 103 215q-61 37-140 59l-79-228 14 240q-38 6-76 6t-76-6l14-238-78 226q-74-19-140-59l103-215-157 178q-59-43-108-108l178-158-214 104q-39-69-58-141l224-79-237 14q-5-42-5-76 0-35 5-77l238 14-225-79q19-73 58-140l214 104-177-159q46-61 107-108l158 178-103-215q67-39 140-58l77 224-13-236q36-6 75-6 38 0 76 6l-14 237 78-225q74 19 140 59l-103 214 158-178q61 47 107 108l-177 159 213-104q37 62 58 141l-224 78 237-14q5 31 5 77zM1352 896q0-160-78.5-295.5t-213-214-292.5-78.5q-119 0-227 46.5t-186.5 125-124.5 187.5-46 229q0 119 46 228t124.5 187.5 186.5 125 227 46.5q158 0 292.5-78.5t213-214 78.5-294.5zM1425 513v766l-657 383-657-383v-766l657-383zM768 1719l708-412v-823l-708-411-708 411v823zM1536 448v896l-768 448-768-448v-896l768-448z"
    }
  }]
};
exports.firstOrder = firstOrder;
var yoast = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M339 218h691l-26 72h-665q-110 0-188.5 79t-78.5 189v771q0 95 60.5 169.5t153.5 93.5q23 5 98 5v72h-45q-140 0-239.5-100t-99.5-240v-771q0-140 99.5-240t239.5-100zM1190 0h247l-482 1294q-23 61-40.5 103.5t-45 98-54 93.5-64.5 78.5-79.5 65-95.5 41-116 18.5v-195q163-26 220-182 20-52 20-105 0-54-20-106l-285-733h228l187 585zM1664 558v1111h-795q37-55 45-73h678v-1038q0-85-49.5-155t-129.5-99l25-67q101 34 163.5 123.5t62.5 197.5z"
    }
  }]
};
exports.yoast = yoast;
var themeisle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M852 309q0 29-17 52.5t-45 23.5-45-23.5-17-52.5 17-52.5 45-23.5 45 23.5 17 52.5zM688 1685v-114q0-30-20.5-51.5t-50.5-21.5-50 21.5-20 51.5v114q0 30 20.5 52t49.5 22q30 0 50.5-22t20.5-52zM860 1685v-114q0-30-20-51.5t-50-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22q29 0 49.5-22t20.5-52zM1034 1685v-114q0-30-20.5-51.5t-50.5-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22 50.5-22 20.5-52zM1208 1685v-114q0-30-20.5-51.5t-50.5-21.5-50.5 21.5-20.5 51.5v114q0 30 20.5 52t50.5 22 50.5-22 20.5-52zM1476 1001q-84 160-232 259.5t-323 99.5q-123 0-229.5-51.5t-178.5-137-113-197.5-41-232q0-88 21-174-104 175-104 390 0 162 65 312t185 251q30-57 91-57 56 0 86 50 32-50 87-50 56 0 86 50 32-50 87-50t87 50q30-50 86-50 28 0 52.5 15.5t37.5 40.5q112-94 177-231.5t73-287.5zM1326 972q0-75-72-75-17 0-47 6-95 19-149 19-226 0-226-243 0-86 30-204-83 127-83 275 0 150 89 260.5t235 110.5q111 0 210-70 13-48 13-79zM884 313q0-50-32-89.5t-81-39.5-81 39.5-32 89.5q0 51 31.5 90.5t81.5 39.5 81.5-39.5 31.5-90.5zM1513 652q0-96-37.5-179t-113-137-173.5-54q-77 0-149 35t-127 94q-48 159-48 268 0 104 45.5 157t147.5 53q53 0 142-19 36-6 53-6 51 0 77.5 28t26.5 80q0 26-4 46 75-68 117.5-165.5t42.5-200.5zM1792 869q0 111-33.5 249.5t-93.5 204.5q-58 64-195 142.5t-228 104.5l-4 1v114q0 43-29.5 75t-72.5 32q-56 0-86-50-32 50-87 50t-87-50q-30 50-86 50-55 0-87-50-30 50-86 50-47 0-75-33.5t-28-81.5q-90 68-198 68-118 0-211-80 54-1 106-20-113-31-182-127 32 7 71 7 89 0 164-46-192-192-240-306-24-56-24-160 0-57 9-125.5t31.5-146.5 55-141 86.5-105 120-42q59 0 81 52 19-29 42-54 2-3 12-13t13-16q10-15 23-38t25-42 28-39q87-111 211.5-177t260.5-66q35 0 62 4 59-64 146-64 83 0 140 57 5 5 5 12 0 5-6 13.5t-12.5 16-16 17l-10.5 10.5q17 6 36 18t19 24q0 6-16 25 157 138 197 378 25-30 60-30 45 0 100 49 90 80 90 279z"
    }
  }]
};
exports.themeisle = themeisle;
var googlePlusCircle = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M917 905q0-33-6-64h-362v132h217q-12 76-74.5 120.5t-142.5 44.5q-99 0-169-71.5t-70-170.5 70-170.5 169-71.5q93 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.googlePlusCircle = googlePlusCircle;
var googlePlusOfficial = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M917 905q0-33-6-64h-362v132h217q-12 76-74.5 120.5t-142.5 44.5q-99 0-169-71.5t-70-170.5 70-170.5 169-71.5q93 0 153 59l104-101q-108-100-257-100-160 0-272 112.5t-112 271.5 112 271.5 272 112.5q165 0 266.5-105t101.5-270zM1262 951h109v-110h-109v-110h-110v110h-110v110h110v110h110v-110zM1536 896q0 209-103 385.5t-279.5 279.5-385.5 103-385.5-103-279.5-279.5-103-385.5 103-385.5 279.5-279.5 385.5-103 385.5 103 279.5 279.5 103 385.5z"
    }
  }]
};
exports.googlePlusOfficial = googlePlusOfficial;
var fa = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 512v839q0 48-49 62-174 52-338 52-73 0-215.5-29.5t-227.5-29.5q-164 0-370 48v338h-160v-1368q-63-25-101-81t-38-124q0-91 64-155t155-64 155 64 64 155q0 68-38 124t-101 81v68q190-44 343-44 99 0 198 15 14 2 111.5 22.5t149.5 20.5q77 0 165-18 11-2 80-21t89-19q26 0 45 19t19 45z"
    }
  }]
};
exports.fa = fa;
var fontAwesome = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1536 512v839q0 48-49 62-174 52-338 52-73 0-215.5-29.5t-227.5-29.5q-164 0-370 48v338h-160v-1368q-63-25-101-81t-38-124q0-91 64-155t155-64 155 64 64 155q0 68-38 124t-101 81v68q190-44 343-44 99 0 198 15 14 2 111.5 22.5t149.5 20.5q77 0 165-18 11-2 80-21t89-19q26 0 45 19t19 45z"
    }
  }]
};
exports.fontAwesome = fontAwesome;
var handshakeO = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M192 1152q40 0 56-32t0-64-56-32-56 32 0 64 56 32zM1665 1094q-10-13-38.5-50t-41.5-54-38-49-42.5-53-40.5-47-45-49l-125 140q-83 94-208.5 92t-205.5-98q-57-69-56.5-158t58.5-157l177-206q-22-11-51-16.5t-47.5-6-56.5 0.5-49 1q-92 0-158 66l-158 158h-155v544q5 0 21-0.5t22 0 19.5 2 20.5 4.5 17.5 8.5 18.5 13.5l297 292q115 111 227 111 78 0 125-47 57 20 112.5-8t72.5-85q74 6 127-44 20-18 36-45.5t14-50.5q10 10 43 10 43 0 77-21t49.5-53 12-71.5-30.5-73.5zM1824 1152h96v-512h-93l-157-180q-66-76-169-76h-167q-89 0-146 67l-209 243q-28 33-28 75t27 75q43 51 110 52t111-49l193-218q25-23 53.5-21.5t47 27 8.5 56.5q16 19 56 63t60 68q29 36 82.5 105.5t64.5 84.5q52 66 60 140zM2112 1152q40 0 56-32t0-64-56-32-56 32 0 64 56 32zM2304 576v640q0 26-19 45t-45 19h-434q-27 65-82 106.5t-125 51.5q-33 48-80.5 81.5t-102.5 45.5q-42 53-104.5 81.5t-128.5 24.5q-60 34-126 39.5t-127.5-14-117-53.5-103.5-81l-287-282h-358q-26 0-45-19t-19-45v-672q0-26 19-45t45-19h421q14-14 47-48t47.5-48 44-40 50.5-37.5 51-25.5 62-19.5 68-5.5h117q99 0 181 56 82-56 181-56h167q35 0 67 6t56.5 14.5 51.5 26.5 44.5 31 43 39.5 39 42 41 48 41.5 48.5h355q26 0 45 19t19 45z"
    }
  }]
};
exports.handshakeO = handshakeO;
var envelopeOpen = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 654v978q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-978q0-15 11-24 8-7 39-34.5t41.5-36 45.5-37.5 70-55.5 96-73 143.5-107 192.5-140.5q5-4 52.5-40t71.5-52.5 64-35 69-18.5 69 18.5 65 35.5 71 52 52 40q110 80 192.5 140.5t143.5 107 96 73 70 55.5 45.5 37.5 41.5 36 39 34.5q11 9 11 24zM1228 1239q263-191 345-252 11-8 12.5-20.5t-6.5-23.5l-38-52q-8-11-21-12.5t-24 6.5q-231 169-343 250-5 3-52 39t-71.5 52.5-64.5 35-69 18.5-69-18.5-64.5-35-71.5-52.5-52-39q-186-134-343-250-11-8-24-6.5t-21 12.5l-38 52q-8 11-6.5 23.5t12.5 20.5q82 61 345 252 10 8 50 38t65 47 64 39.5 77.5 33.5 75.5 11 75.5-11 79-34.5 64.5-39.5 65-47.5 48-36.5z"
    }
  }]
};
exports.envelopeOpen = envelopeOpen;
var envelopeOpenO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1474 913l39 51q8 11 6.5 23.5t-11.5 20.5q-43 34-126.5 98.5t-146.5 113-67 51.5q-39 32-60 48t-60.5 41-76.5 36.5-74 11.5h-1-1q-37 0-74-11.5t-76-36.5-61-41.5-60-47.5q-5-4-65-50.5t-143.5-111-122.5-94.5q-11-8-12.5-20.5t6.5-23.5l37-52q8-11 21.5-13t24.5 7q94 73 306 236 5 4 43.5 35t60.5 46.5 56.5 32.5 58.5 17h1 1q24 0 58.5-17t56.5-32.5 60.5-46.5 43.5-35q258-198 313-242 11-8 24-6.5t21 12.5zM1664 1632v-928q-90-83-159-139-91-74-389-304-3-2-43-35t-61-48-56-32.5-59-17.5h-1-1q-24 0-59 17.5t-56 32.5-61 48-43 35q-215 166-315.5 245.5t-129.5 104-82 74.5q-14 12-21 19v928q0 13 9.5 22.5t22.5 9.5h1472q13 0 22.5-9.5t9.5-22.5zM1792 704v928q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-928q0-56 41-94 123-114 350-290.5t233-181.5q36-30 59-47.5t61.5-42 76-36.5 74.5-12h1 1q37 0 74.5 12t76 36.5 61.5 42 59 47.5q43 36 156 122t226 177 201 173q41 38 41 94z"
    }
  }]
};
exports.envelopeOpenO = envelopeOpenO;
var linode = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M330 1535l202 214-34-236-216-213zM556 1761l274-218-11-245-300 215zM245 1123l227 213-48-327-245-204zM495 1347l317-214-14-324-352 200zM843 1358l95 80-2-239-103-79q0 1 1 8.5t0 12-5 7.5l-78 52 85 70q7 6 7 88zM138 606l256 200-68-465-279-173zM1173 1269l15-234-230 164 2 240zM417 814l373-194-19-441-423 163zM1270 1179l20-233-226-142-2 105 144 95q6 4 4 9l-7 119zM1461 1040l30-222-179 128-20 228zM1273 1207l-71-49-8 117q0 5-4 8l-234 187q-7 5-14 0l-98-83 7 161q0 5-4 8l-293 234q-4 2-6 2-8-2-8-3l-228-242q-4-4-59-277-2-7 5-11l61-37q-94-86-95-92l-72-351q-2-7 6-12l94-45q-133-100-135-108l-96-466q-2-10 7-13l433-135q5 0 8 1l317 153q6 4 6 9l20 463q0 7-6 10l-118 61 126 85q5 2 5 8l5 123 121-74q5-4 11 0l84 56 3-110q0-6 5-9l206-126q6-3 11 0l245 135q4 4 5 7t-6.5 60-17.5 124.5-10 70.5q0 5-4 7l-191 153q-6 5-13 0z"
    }
  }]
};
exports.linode = linode;
var addressBook = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1201 1238q0-57-5.5-107t-21-100.5-39.5-86-64-58-91-22.5q-6 4-33.5 20.5t-42.5 24.5-40.5 20-49 17-46.5 5-46.5-5-49-17-40.5-20-42.5-24.5-33.5-20.5q-51 0-91 22.5t-64 58-39.5 86-21 100.5-5.5 107q0 73 42 121.5t103 48.5h576q61 0 103-48.5t42-121.5zM1028 644q0-108-76.5-184t-183.5-76-183.5 76-76.5 184q0 107 76.5 183t183.5 76 183.5-76 76.5-183zM1664 1184v192q0 14-9 23t-23 9h-96v224q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h1216q66 0 113 47t47 113v224h96q14 0 23 9t9 23v192q0 14-9 23t-23 9h-96v128h96q14 0 23 9t9 23v192q0 14-9 23t-23 9h-96v128h96q14 0 23 9t9 23z"
    }
  }]
};
exports.addressBook = addressBook;
var addressBookO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1028 644q0 107-76.5 183t-183.5 76-183.5-76-76.5-183q0-108 76.5-184t183.5-76 183.5 76 76.5 184zM980 864q46 0 82.5 17t60 47.5 39.5 67 24 81 11.5 82.5 3.5 79q0 67-39.5 118.5t-105.5 51.5h-576q-66 0-105.5-51.5t-39.5-118.5q0-48 4.5-93.5t18.5-98.5 36.5-91.5 63-64.5 93.5-26h5q7 4 32 19.5t35.5 21 33 17 37 16 35 9 39.5 4.5 39.5-4.5 35-9 37-16 33-17 35.5-21 32-19.5zM1664 608q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v128h96q13 0 22.5 9.5t9.5 22.5v192q0 13-9.5 22.5t-22.5 9.5h-96v224q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h1216q66 0 113 47t47 113v224h96q13 0 22.5 9.5t9.5 22.5v192zM1408 1632v-1472q0-13-9.5-22.5t-22.5-9.5h-1216q-13 0-22.5 9.5t-9.5 22.5v1472q0 13 9.5 22.5t22.5 9.5h1216q13 0 22.5-9.5t9.5-22.5z"
    }
  }]
};
exports.addressBookO = addressBookO;
var addressCard = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1131q0-64-9-117.5t-29.5-103-60.5-78-97-28.5q-6 4-30 18t-37.5 21.5-35.5 17.5-43 14.5-42 4.5-42-4.5-43-14.5-35.5-17.5-37.5-21.5-30-18q-57 0-97 28.5t-60.5 78-29.5 103-9 117.5 37 106.5 91 42.5h512q54 0 91-42.5t37-106.5zM867 611q0-94-66.5-160.5t-160.5-66.5-160.5 66.5-66.5 160.5 66.5 160.5 160.5 66.5 160.5-66.5 66.5-160.5zM1792 1120v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM1792 860v-56q0-15-10.5-25.5t-25.5-10.5h-568q-15 0-25.5 10.5t-10.5 25.5v56q0 15 10.5 25.5t25.5 10.5h568q15 0 25.5-10.5t10.5-25.5zM1792 608v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM2048 288v1216q0 66-47 113t-113 47h-352v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-768v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-352q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.addressCard = addressCard;
var vcard = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1131q0-64-9-117.5t-29.5-103-60.5-78-97-28.5q-6 4-30 18t-37.5 21.5-35.5 17.5-43 14.5-42 4.5-42-4.5-43-14.5-35.5-17.5-37.5-21.5-30-18q-57 0-97 28.5t-60.5 78-29.5 103-9 117.5 37 106.5 91 42.5h512q54 0 91-42.5t37-106.5zM867 611q0-94-66.5-160.5t-160.5-66.5-160.5 66.5-66.5 160.5 66.5 160.5 160.5 66.5 160.5-66.5 66.5-160.5zM1792 1120v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM1792 860v-56q0-15-10.5-25.5t-25.5-10.5h-568q-15 0-25.5 10.5t-10.5 25.5v56q0 15 10.5 25.5t25.5 10.5h568q15 0 25.5-10.5t10.5-25.5zM1792 608v-64q0-14-9-23t-23-9h-576q-14 0-23 9t-9 23v64q0 14 9 23t23 9h576q14 0 23-9t9-23zM2048 288v1216q0 66-47 113t-113 47h-352v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-768v-96q0-14-9-23t-23-9h-64q-14 0-23 9t-9 23v96h-352q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.vcard = vcard;
var addressCardO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1131q0 64-37 106.5t-91 42.5h-512q-54 0-91-42.5t-37-106.5 9-117.5 29.5-103 60.5-78 97-28.5q6 4 30 18t37.5 21.5 35.5 17.5 43 14.5 42 4.5 42-4.5 43-14.5 35.5-17.5 37.5-21.5 30-18q57 0 97 28.5t60.5 78 29.5 103 9 117.5zM867 611q0 94-66.5 160.5t-160.5 66.5-160.5-66.5-66.5-160.5 66.5-160.5 160.5-66.5 160.5 66.5 66.5 160.5zM1792 1056v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1792 804v56q0 15-10.5 25.5t-25.5 10.5h-568q-15 0-25.5-10.5t-10.5-25.5v-56q0-15 10.5-25.5t25.5-10.5h568q15 0 25.5 10.5t10.5 25.5zM1792 544v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1920 1504v-1216q0-13-9.5-22.5t-22.5-9.5h-1728q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h352v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h768v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h352q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.addressCardO = addressCardO;
var vcardO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1131q0 64-37 106.5t-91 42.5h-512q-54 0-91-42.5t-37-106.5 9-117.5 29.5-103 60.5-78 97-28.5q6 4 30 18t37.5 21.5 35.5 17.5 43 14.5 42 4.5 42-4.5 43-14.5 35.5-17.5 37.5-21.5 30-18q57 0 97 28.5t60.5 78 29.5 103 9 117.5zM867 611q0 94-66.5 160.5t-160.5 66.5-160.5-66.5-66.5-160.5 66.5-160.5 160.5-66.5 160.5 66.5 66.5 160.5zM1792 1056v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1792 804v56q0 15-10.5 25.5t-25.5 10.5h-568q-15 0-25.5-10.5t-10.5-25.5v-56q0-15 10.5-25.5t25.5-10.5h568q15 0 25.5 10.5t10.5 25.5zM1792 544v64q0 14-9 23t-23 9h-576q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h576q14 0 23 9t9 23zM1920 1504v-1216q0-13-9.5-22.5t-22.5-9.5h-1728q-13 0-22.5 9.5t-9.5 22.5v1216q0 13 9.5 22.5t22.5 9.5h352v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h768v-96q0-14 9-23t23-9h64q14 0 23 9t9 23v96h352q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.vcardO = vcardO;
var userCircle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1523 1339q-22-155-87.5-257.5t-184.5-118.5q-67 74-159.5 115.5t-195.5 41.5-195.5-41.5-159.5-115.5q-119 16-184.5 118.5t-87.5 257.5q106 150 271 237.5t356 87.5 356-87.5 271-237.5zM1280 640q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5zM1792 896q0 182-71 347.5t-190.5 286-285.5 191.5-349 71q-182 0-348-71t-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.userCircle = userCircle;
var userCircleO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 0q182 0 348 71t286 191 191 286 71 348q0 181-70.5 347t-190.5 286-286 191.5-349 71.5-349-71-285.5-191.5-190.5-286-71-347.5 71-348 191-286 286-191 348-71zM1515 1351q149-205 149-455 0-156-61-298t-164-245-245-164-298-61-298 61-245 164-164 245-61 298q0 250 149 455 66-327 306-327 131 128 313 128t313-128q240 0 306 327zM1280 704q0-159-112.5-271.5t-271.5-112.5-271.5 112.5-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5z"
    }
  }]
};
exports.userCircleO = userCircleO;
var userO = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1201 784q47 14 89.5 38t89 73 79.5 115.5 55 172 22 236.5q0 154-100 263.5t-241 109.5h-854q-141 0-241-109.5t-100-263.5q0-131 22-236.5t55-172 79.5-115.5 89-73 89.5-38q-79-125-79-272 0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5 198.5 40.5 163.5 109.5 109.5 163.5 40.5 198.5q0 147-79 272zM768 128q-159 0-271.5 112.5t-112.5 271.5 112.5 271.5 271.5 112.5 271.5-112.5 112.5-271.5-112.5-271.5-271.5-112.5zM1195 1664q88 0 150.5-71.5t62.5-173.5q0-239-78.5-377t-225.5-145q-145 127-336 127t-336-127q-147 7-225.5 145t-78.5 377q0 102 62.5 173.5t150.5 71.5h854z"
    }
  }]
};
exports.userO = userO;
var idBadge = {
  "viewBox": "0 0 1280 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1024 1258q0 64-37 107t-91 43h-512q-54 0-91-43t-37-107 9-118 29.5-104 61-78.5 96.5-28.5q80 75 188 75t188-75q56 0 96.5 28.5t61 78.5 29.5 104 9 118zM870 739q0 94-67.5 160.5t-162.5 66.5-162.5-66.5-67.5-160.5 67.5-160.5 162.5-66.5 162.5 66.5 67.5 160.5zM1152 1632v-1376h-1024v1376q0 13 9.5 22.5t22.5 9.5h960q13 0 22.5-9.5t9.5-22.5zM1280 160v1472q0 66-47 113t-113 47h-960q-66 0-113-47t-47-113v-1472q0-66 47-113t113-47h352v96q0 14 9 23t23 9h192q14 0 23-9t9-23v-96h352q66 0 113 47t47 113z"
    }
  }]
};
exports.idBadge = idBadge;
var driversLicense = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1212q0-54-7.5-100.5t-24.5-90-51-68.5-81-25q-64 64-156 64t-156-64q-47 0-81 25t-51 68.5-24.5 90-7.5 100.5q0 55 31.5 93.5t75.5 38.5h426q44 0 75.5-38.5t31.5-93.5zM768 768q0-80-56-136t-136-56-136 56-56 136 56 136 136 56 136-56 56-136zM1792 1248v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1408 992v-64q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v64q0 14 9 23t23 9h320q14 0 23-9t9-23zM1792 992v-64q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v64q0 14 9 23t23 9h192q14 0 23-9t9-23zM1792 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM128 384h1792v-96q0-14-9-23t-23-9h-1728q-14 0-23 9t-9 23v96zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.driversLicense = driversLicense;
var idCard = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1212q0-54-7.5-100.5t-24.5-90-51-68.5-81-25q-64 64-156 64t-156-64q-47 0-81 25t-51 68.5-24.5 90-7.5 100.5q0 55 31.5 93.5t75.5 38.5h426q44 0 75.5-38.5t31.5-93.5zM768 768q0-80-56-136t-136-56-136 56-56 136 56 136 136 56 136-56 56-136zM1792 1248v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM1408 992v-64q0-14-9-23t-23-9h-320q-14 0-23 9t-9 23v64q0 14 9 23t23 9h320q14 0 23-9t9-23zM1792 992v-64q0-14-9-23t-23-9h-192q-14 0-23 9t-9 23v64q0 14 9 23t23 9h192q14 0 23-9t9-23zM1792 736v-64q0-14-9-23t-23-9h-704q-14 0-23 9t-9 23v64q0 14 9 23t23 9h704q14 0 23-9t9-23zM128 384h1792v-96q0-14-9-23t-23-9h-1728q-14 0-23 9t-9 23v96zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.idCard = idCard;
var driversLicenseO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zM768 768q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1184v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1408 928v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zM1792 928v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 672v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1920 1504v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.driversLicenseO = driversLicenseO;
var idCardO = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M896 1212q0 55-31.5 93.5t-75.5 38.5h-426q-44 0-75.5-38.5t-31.5-93.5q0-54 7.5-100.5t24.5-90 51-68.5 81-25q64 64 156 64t156-64q47 0 81 25t51 68.5 24.5 90 7.5 100.5zM768 768q0 80-56 136t-136 56-136-56-56-136 56-136 136-56 136 56 56 136zM1792 1184v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1408 928v64q0 14-9 23t-23 9h-320q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h320q14 0 23 9t9 23zM1792 928v64q0 14-9 23t-23 9h-192q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h192q14 0 23 9t9 23zM1792 672v64q0 14-9 23t-23 9h-704q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h704q14 0 23 9t9 23zM1920 1504v-1120h-1792v1120q0 13 9.5 22.5t22.5 9.5h1728q13 0 22.5-9.5t9.5-22.5zM2048 288v1216q0 66-47 113t-113 47h-1728q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1728q66 0 113 47t47 113z"
    }
  }]
};
exports.idCardO = idCardO;
var quora = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1255 787q0-318-105-474.5t-330-156.5q-222 0-326 157t-104 474q0 316 104 471.5t326 155.5q74 0 131-17-22-43-39-73t-44-65-53.5-56.5-63-36-77.5-14.5q-46 0-79 16l-49-97q105-91 276-91 132 0 215.5 54t150.5 155q67-149 67-402zM1645 1419h117q3 27-2 67t-26.5 95-58 100.5-107 78-162.5 32.5q-71 0-130.5-19t-105.5-56-79-78-66-96q-97 27-205 27-150 0-292.5-58t-253-158.5-178-249-67.5-317.5q0-170 67.5-319.5t178.5-250.5 253.5-159 291.5-58q121 0 238.5 36t217 106 176 164.5 119.5 219 43 261.5q0 190-80.5 347.5t-218.5 264.5q47 70 93.5 106.5t104.5 36.5q61 0 94-37.5t38-85.5z"
    }
  }]
};
exports.quora = quora;
var freeCodeCamp = {
  "viewBox": "0 0 2304 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M453 1637q0 21-16 37.5t-37 16.5q-1 0-13-3-63-15-162-140-225-284-225-676 0-341 213-614 39-51 95-103.5t94-52.5q19 0 35 13.5t16 32.5q0 27-63 90-98 102-147 184-119 199-119 449 0 281 123 491 50 85 136 173 2 3 14.5 16t19.5 21 17 20.5 14.5 23.5 4.5 21zM1796 1503q0 29-17.5 48.5t-46.5 19.5h-1081q-26 0-45-19t-19-45q0-29 17.5-48.5t46.5-19.5h1081q26 0 45 19t19 45zM1581 892q0 134-67 233-25 38-69.5 78.5t-83.5 60.5q-16 10-27 10-7 0-15-6t-8-12q0-9 19-30t42-46 42-67.5 19-88.5q0-76-35-130-29-42-46-42-3 0-3 5 0 12 7.5 35.5t7.5 36.5q0 22-21.5 35t-44.5 13q-66 0-66-76 0-15 1.5-44t1.5-44q0-25-10-46-13-25-42-53.5t-51-28.5q-5 0-7 0.5t-3.5 2.5-1.5 6q0 2 16 26t16 54q0 37-19 68t-46 54-53.5 46-45.5 54-19 68q0 98 42 160 29 43 79 63 16 5 17 10 1 2 1 5 0 16-18 16-6 0-33-11-119-43-195-139.5t-76-218.5q0-55 24.5-115.5t60-115 70.5-108.5 59.5-113.5 24.5-111.5q0-53-25-94-29-48-56-64-19-9-19-21 0-20 41-20 50 0 110 29 41 19 71 44.5t49.5 51 33.5 62.5 22 69 16 80q0 1 3 17.5t4.5 25 5.5 25 9 27 11 21.5 14.5 16.5 18.5 5.5q23 0 37-14t14-37q0-25-20-67t-20-52 10-10q27 0 93 70 72 76 102.5 156t30.5 186zM2304 921q0 274-138 503-19 32-48 72t-68 86.5-81 77-74 30.5q-16 0-31-15.5t-15-31.5q0-15 29-50.5t68.5-77 48.5-52.5q183-230 183-531 0-131-20.5-235t-72.5-211q-58-119-163-228-2-3-13-13.5t-16.5-16.5-15-17.5-15-20-9.5-18.5-4-19q0-19 16-35.5t35-16.5q70 0 196 169 98 131 146 273t60 314q2 42 2 64z"
    }
  }]
};
exports.freeCodeCamp = freeCodeCamp;
var telegram = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1189 1307l147-693q9-44-10.5-63t-51.5-7l-864 333q-29 11-39.5 25t-2.5 26.5 32 19.5l221 69 513-323q21-14 32-6 7 5-4 15l-415 375v0 0l-16 228q23 0 45-22l108-104 224 165q64 36 81-38zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.telegram = telegram;
var thermometer = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer = thermometer;
var thermometer4 = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer4 = thermometer4;
var thermometerFull = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-907h128v907q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometerFull = thermometerFull;
var thermometer3 = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-651h128v651q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer3 = thermometer3;
var thermometerThreeQuarters = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-651h128v651q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometerThreeQuarters = thermometerThreeQuarters;
var thermometer2 = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-395h128v395q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer2 = thermometer2;
var thermometerHalf = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-395h128v395q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometerHalf = thermometerHalf;
var thermometer1 = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-139h128v139q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer1 = thermometer1;
var thermometerQuarter = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-60 35-110t93-71v-139h128v139q58 21 93 71t35 110zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometerQuarter = thermometerQuarter;
var thermometer0 = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-79 56-135.5t136-56.5 136 56.5 56 135.5zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometer0 = thermometer0;
var thermometerEmpty = {
  "viewBox": "0 0 1024 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M640 1344q0 80-56 136t-136 56-136-56-56-136q0-79 56-135.5t136-56.5 136 56.5 56 135.5zM768 1344q0-77-34-144t-94-112v-768q0-80-56-136t-136-56-136 56-56 136v768q-60 45-94 112t-34 144q0 133 93.5 226.5t226.5 93.5 226.5-93.5 93.5-226.5zM896 1344q0 185-131.5 316.5t-316.5 131.5-316.5-131.5-131.5-316.5q0-182 128-313v-711q0-133 93.5-226.5t226.5-93.5 226.5 93.5 93.5 226.5v711q128 131 128 313zM1024 768v128h-192v-128h192zM1024 512v128h-192v-128h192zM1024 256v128h-192v-128h192z"
    }
  }]
};
exports.thermometerEmpty = thermometerEmpty;
var shower = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1433 249q10 10 10 23t-10 23l-626 626q-10 10-23 10t-23-10l-82-82q-10-10-10-23t10-23l44-44q-72-91-81.5-207t46.5-215q-74-71-176-71-106 0-181 75t-75 181v1280h-256v-1280q0-104 40.5-198.5t109.5-163.5 163.5-109.5 198.5-40.5q106 0 201 41t166 115q94-39 197-24.5t185 79.5l44-44q10-10 23-10t23 10zM1344 512q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1600 640q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1856 512q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 640q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1408 704q0-26 19-45t45-19 45 19 19 45-19 45-45 19-45-19-19-45zM1728 640q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 768q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1344 896q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1600 768q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 1024q-26 0-45-19t-19-45 19-45 45-19 45 19 19 45-19 45-45 19zM1472 896q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 1024q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1344 1024q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1216 1152q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19zM1088 1280q26 0 45 19t19 45-19 45-45 19-45-19-19-45 19-45 45-19z"
    }
  }]
};
exports.shower = shower;
var bath = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"
    }
  }]
};
exports.bath = bath;
var bathtub = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"
    }
  }]
};
exports.bathtub = bathtub;
var s15 = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1664 1088v192q0 169-128 286v194q0 14-9 23t-23 9h-64q-14 0-23-9t-9-23v-118q-63 22-128 22h-768q-65 0-128-22v110q0 17-9.5 28.5t-22.5 11.5h-64q-13 0-22.5-11.5t-9.5-28.5v-186q-128-117-128-286v-192h1536zM704 672q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 608q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 544q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM704 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1792 928v64q0 14-9 23t-23 9h-1728q-14 0-23-9t-9-23v-64q0-14 9-23t23-9h96v-640q0-106 75-181t181-75q108 0 184 78 46-19 98-12t93 39l22-22q11-11 22 0l42 42q11 11 0 22l-314 314q-11 11-22 0l-42-42q-11-11 0-22l22-22q-36-46-40.5-104t23.5-108q-37-35-88-35-53 0-90.5 37.5t-37.5 90.5v640h1504q14 0 23 9t9 23zM896 480q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM768 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 416q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM896 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM832 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1024 352q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM960 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23zM1088 288q0 14-9 23t-23 9-23-9-9-23 9-23 23-9 23 9 9 23z"
    }
  }]
};
exports.s15 = s15;
var podcast = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M994 1192q0 86-17 197-31 215-55 313-22 90-152 90t-152-90q-24-98-55-313-17-110-17-197 0-168 224-168t224 168zM1536 768q0 240-134 434t-350 280q-8 3-15-3t-6-15q7-48 10-66 4-32 6-47 1-9 9-12 159-81 255.5-234t96.5-337q0-180-91-330.5t-247-234.5-337-74q-124 7-237 61t-193.5 140.5-128 202-46.5 240.5q1 184 99 336.5t257 231.5q7 3 9 12 3 21 6 45 1 9 5 32.5t6 35.5q1 9-6.5 15t-15.5 2q-148-58-261-169.5t-173.5-264-52.5-319.5q7-143 66-273.5t154.5-227 225-157.5 272.5-70q164-10 315.5 46.5t261 160.5 175 250.5 65.5 308.5zM994 736q0 93-65.5 158.5t-158.5 65.5-158.5-65.5-65.5-158.5 65.5-158.5 158.5-65.5 158.5 65.5 65.5 158.5zM1282 768q0 122-53.5 228.5t-146.5 177.5q-8 6-16 2t-10-14q-6-52-29-92-7-10 3-20 58-54 91-127t33-155q0-111-58.5-204t-157.5-141.5-212-36.5q-133 15-229 113t-109 231q-10 92 23.5 176t98.5 144q10 10 3 20-24 41-29 93-2 9-10 13t-16-2q-95-74-148.5-183t-51.5-234q3-131 69-244t177-181.5 241-74.5q144-7 268 60t196.5 187.5 72.5 263.5z"
    }
  }]
};
exports.podcast = podcast;
var windowMaximize = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1408h1280v-768h-1280v768zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.windowMaximize = windowMaximize;
var windowMinimize = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1792 1312v192q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-192q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.windowMinimize = windowMinimize;
var windowRestore = {
  "viewBox": "0 0 2048 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M256 1536h768v-512h-768v512zM1280 1024h512v-768h-768v256h96q66 0 113 47t47 113v352zM2048 160v960q0 66-47 113t-113 47h-608v352q0 66-47 113t-113 47h-960q-66 0-113-47t-47-113v-960q0-66 47-113t113-47h608v-352q0-66 47-113t113-47h960q66 0 113 47t47 113z"
    }
  }]
};
exports.windowRestore = windowRestore;
var timesRectangle = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1175 1321l146-146q10-10 10-23t-10-23l-233-233 233-233q10-10 10-23t-10-23l-146-146q-10-10-23-10t-23 10l-233 233-233-233q-10-10-23-10t-23 10l-146 146q-10 10-10 23t10 23l233 233-233 233q-10 10-10 23t10 23l146 146q10 10 23 10t23-10l233-233 233 233q10 10 23 10t23-10zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.timesRectangle = timesRectangle;
var windowClose = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1175 1321l146-146q10-10 10-23t-10-23l-233-233 233-233q10-10 10-23t-10-23l-146-146q-10-10-23-10t-23 10l-233 233-233-233q-10-10-23-10t-23 10l-146 146q-10 10-10 23t10 23l233 233-233 233q-10 10-10 23t10 23l146 146q10 10 23 10t23-10l233-233 233 233q10 10 23 10t23-10zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.windowClose = windowClose;
var timesRectangleO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1257 1111l-146 146q-10 10-23 10t-23-10l-169-169-169 169q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l169-169-169-169q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l169 169 169-169q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-169 169 169 169q10 10 10 23t-10 23zM256 1408h1280v-1024h-1280v1024zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.timesRectangleO = timesRectangleO;
var windowCloseO = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1257 1111l-146 146q-10 10-23 10t-23-10l-169-169-169 169q-10 10-23 10t-23-10l-146-146q-10-10-10-23t10-23l169-169-169-169q-10-10-10-23t10-23l146-146q10-10 23-10t23 10l169 169 169-169q10-10 23-10t23 10l146 146q10 10 10 23t-10 23l-169 169 169 169q10 10 10 23t-10 23zM256 1408h1280v-1024h-1280v1024zM1792 288v1216q0 66-47 113t-113 47h-1472q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1472q66 0 113 47t47 113z"
    }
  }]
};
exports.windowCloseO = windowCloseO;
var bandcamp = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1070 1178l306-564h-654l-306 564h654zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.bandcamp = bandcamp;
var grav = {
  "viewBox": "0 0 1794 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1291 476q-15-17-35-8.5t-26 28.5 5 38q14 17 40 14.5t34-20.5-18-52zM895 722q-8 8-19.5 8t-18.5-8q-8-8-8-19t8-18q7-8 18.5-8t19.5 8q7 7 7 18t-7 19zM1060 796l-35 35q-12 13-29.5 13t-30.5-13l-38-38q-12-13-12-30t12-30l35-35q12-12 29.5-12t30.5 12l38 39q12 12 12 29.5t-12 29.5zM951 666q-7 8-18.5 8t-19.5-8q-7-8-7-19t7-19q8-8 19-8t19 8 8 19-8 19zM1354 568q-34 64-107.5 85.5t-127.5-16.5q-38-28-61-66.5t-21-87.5 39-92 75.5-53 70.5 5 70 51q2 2 13 12.5t14.5 13.5 13 13.5 12.5 15.5 10 15.5 8.5 18 4 18.5 1 21-5 22-9.5 24zM1555 1050q3-20-8.5-34.5t-27.5-21.5-33-17-23-20q-40-71-84-98.5t-113-11.5q19-13 40-18.5t33-4.5l12 1q2-45-34-90 6-20 6.5-40.5t-2.5-30.5l-3-10q43-24 71-65t34-91q10-84-43-150.5t-137-76.5q-60-7-114 18.5t-82 74.5q-30 51-33.5 101t14.5 87 43.5 64 56.5 42q-45-4-88-36t-57-88q-28-108 32-222-16-21-29-32-50 0-89 19 19-24 42-37t36-14l13-1q0-50-13-78-10-21-32.5-28.5t-47 3.5-37.5 40q2-4 4-7-7 28-6.5 75.5t19 117 48.5 122.5q-25 14-47 36-35 16-85.5 70.5t-84.5 101.5l-33 46q-90 34-181 125.5t-75 162.5q1 16 11 27-15 12-30 30-21 25-21 54t21.5 40 63.5-6q41-19 77-49.5t55-60.5q-2-2-6.5-5t-20.5-7.5-33-3.5q23-5 51-12.5t40-10 27.5-6 26-4 23.5-0.5q14 7 22-34 7-37 7-90 0-102-40-150 106 103 101 219-1 29-15 50t-27 27l-13 6q-4 7-19 32t-26 45.5-26.5 52-25 61-17 63-6.5 66.5 10 63q-35-54-37-80-22 24-34.5 39t-33.5 42-30.5 46-16.5 41-0.5 38 25.5 27q45 25 144-64t190.5-221.5 122.5-228.5q86-52 145-115.5t86-119.5q47 93 154 178 104 83 167 80 39-2 46-43zM1794 896q0 182-71 348t-191 286-286.5 191-348.5 71-348.5-71-286.5-191-191-286-71-348 71-348 191-286 286.5-191 348.5-71 348.5 71 286.5 191 191 286 71 348z"
    }
  }]
};
exports.grav = grav;
var etsy = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M518 183v655q103 1 191.5-1.5t125.5-5.5l37-3q68-2 90.5-24.5t39.5-94.5l33-142h103l-14 322 7 319h-103l-29-127q-15-68-45-93t-84-26q-87-8-352-8v556q0 78 43.5 115.5t133.5 37.5h357q35 0 59.5-2t55-7.5 54-18 48.5-32 46-50.5 39-73l93-216h89q-6 37-31.5 252t-30.5 276q-146-5-263.5-8t-162.5-4h-44-628l-376 12v-102l127-25q67-13 91.5-37t25.5-79l8-643q3-402-8-645-2-61-25.5-84t-91.5-36l-127-24v-102l376 12h702q139 0 374-27-6 68-14 194.5t-12 219.5l-5 92h-93l-32-124q-31-121-74-179.5t-113-58.5h-548q-28 0-35.5 8.5t-7.5 30.5z"
    }
  }]
};
exports.etsy = etsy;
var imdb = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M922 797v182q0 4 0.5 15t0 15l-1.5 12t-3.5 11.5-6.5 7.5-11 5.5-16 1.5v-309q9 0 16 1t11 5 6.5 5.5 3.5 9.5 1 10.5v13.5 14zM1238 893v121q0 1 0.5 12.5t0 15.5-2.5 11.5-7.5 10.5-13.5 3q-9 0-14-9-4-10-4-165v-7-8.5-9t1.5-8.5l3.5-7t5-5.5 8-1.5q6 0 10 1.5t6.5 4.5 4 6 2 8.5 0.5 8v9.5 9zM180 1129h122v-472h-122v472zM614 1129h106v-472h-159l-28 221q-20-148-32-221h-158v472h107v-312l45 312h76l43-319v319zM1039 824q0-67-5-90-3-16-11-28.5t-17-20.5-25-14-26.5-8.5-31-4-29-1.5h-29.5-12-91v472h56q169 1 197-24.5t25-180.5q-1-62-1-100zM1356 1021v-133q0-29-2-45t-9.5-33.5-24.5-25-46-7.5q-46 0-77 34v-154h-117v472h110l7-30q30 36 77 36 50 0 66-30.5t16-83.5zM1536 288v1216q0 66-47 113t-113 47h-1216q-66 0-113-47t-47-113v-1216q0-66 47-113t113-47h1216q66 0 113 47t47 113z"
    }
  }]
};
exports.imdb = imdb;
var ravelry = {
  "viewBox": "0 0 2176 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1143 1733q-6-1-11-4-13-8-36-23t-86-65-116.5-104.5-112-140-89.5-172.5q-17-3-175-37 66 213 235 362t391 184zM502 1127l168 28q-25-76-41-167.5t-19-145.5l-4-53q-84 82-121 224 5 65 17 114zM612 518q-43 64-77 148 44-46 74-68zM2049 952q0-161-62-307t-167.5-252-250.5-168.5-304-62.5q-147 0-281 52.5t-240 148.5q-30 58-45 160 60-51 143-83.5t158.5-43 143-13.5 108.5 1l40 3q33 1 53 15.5t24.5 33 6.5 37-1 28.5q-126-11-227.5-0.5t-183 43.5-142.5 71.5-131 98.5q4 36 11.5 92.5t35.5 178 62 179.5q123 6 247.5-14.5t214.5-53.5 162.5-67 109.5-59l37-24q22-16 39.5-20.5t30.5 5 17 34.5q14 97-39 121-208 97-467 134-135 20-317 16 41 96 110 176.5t137 127 130.5 79 101.5 43.5l39 12q143 23 263-15 195-99 314-289t119-418zM2123 915q-14 135-40 212-70 208-181.5 346.5t-318.5 253.5q-48 33-82 44-72 26-163 16-36 3-73 3-283 0-504.5-173t-295.5-442q-1 0-4-0.5t-5-0.5q-6 50 2.5 112.5t26 115 36 98 31.5 71.5l14 26q8 12 54 82-71-38-124.5-106.5t-78.5-140-39.5-137-17.5-107.5l-2-42q-5-2-33.5-12.5t-48.5-18-53-20.5-57.5-25-50-25.5-42.5-27-25-25.5q19 10 50.5 25.5t113 45.5 145.5 38l2-32q11-149 94-290 41-202 176-365 28-115 81-214 15-28 32-45t49-32q158-74 303.5-104t302-11 306.5 97q220 115 333 336t87 474z"
    }
  }]
};
exports.ravelry = ravelry;
var eercast = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1341 784q29-44-6.5-129.5t-121.5-142.5q-58-39-125.5-53.5t-118-4.5-68.5 37q-12 23-4.5 28t42.5 10q23 3 38.5 5t44.5 9.5 56 17.5q36 13 67.5 31.5t53 37 40 38.5 30.5 38 22 34.5 16.5 28.5 12 18.5 10.5 6 11-9.5zM1704 1358q-52 127-148.5 220t-214.5 141.5-253 60.5-266-13.5-251-91-210-161.5-141.5-235.5-46.5-303.5q1-41 8.5-84.5t12.5-64 24-80.5 23-73q-51 208 1 397t173 318 291 206 346 83 349-74.5 289-244.5q20-27 18-14 0 4-4 14zM1465 909q0 104-40.5 199t-108.5 164-162 109.5-198 40.5-198-40.5-162-109.5-108.5-164-40.5-199 40.5-199 108.5-164 162-109.5 198-40.5 198 40.5 162 109.5 108.5 164 40.5 199zM1752 621q-65-147-180.5-251t-253-153.5-292-53.5-301 36.5-275.5 129-220 211.5-131 297-10 373q-49-161-51.5-311.5t35.5-272.5 109-227 165.5-180.5 207-126 232-71 242.5-9 236 54 216 124.5 178 197q33 50 62 121t31 112zM1690 963q12-244-136.5-416t-396.5-240q-8 0-10-5t24-8q125 4 230 50t173 120 116 168.5 58.5 199-1 208-61.5 197.5-122.5 167-185 117.5-248.5 46.5q108-30 201.5-80t174-123 129.5-176.5 55-225.5z"
    }
  }]
};
exports.eercast = eercast;
var microchip = {
  "viewBox": "0 0 1536 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M192 1280v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 1024v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 768v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 512v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM192 256v128h-112q-16 0-16-16v-16h-48q-16 0-16-16v-32q0-16 16-16h48v-16q0-16 16-16h112zM1280 96v1472q0 40-28 68t-68 28h-832q-40 0-68-28t-28-68v-1472q0-40 28-68t68-28h832q40 0 68 28t28 68zM1536 1328v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 1072v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 816v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 560v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16zM1536 304v32q0 16-16 16h-48v16q0 16-16 16h-112v-128h112q16 0 16 16v16h48q16 0 16 16z"
    }
  }]
};
exports.microchip = microchip;
var snowflakeO = {
  "viewBox": "0 0 1664 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1566 1117l-167 33 186 107q23 13 29.5 38.5t-6.5 48.5q-14 23-39 29.5t-48-6.5l-186-106 55 160q13 38-12 63.5t-60.5 20.5-48.5-42l-102-300-271-156v313l208 238q16 18 17 39t-11 36.5-28.5 25-37 5.5-36.5-22l-112-128v214q0 26-19 45t-45 19-45-19-19-45v-214l-112 128q-16 18-36.5 22t-37-5.5-28.5-25-11-36.5 17-39l208-238v-313l-271 156-102 300q-13 37-48.5 42t-60.5-20.5-12-63.5l55-160-186 106q-23 13-48 6.5t-39-29.5q-13-23-6.5-48.5t29.5-38.5l186-107-167-33q-29-6-42-29t-8.5-46.5 25.5-40 50-10.5l310 62 271-157-271-157-310 62q-4 1-13 1-27 0-44-18t-19-40 11-43 40-26l167-33-186-107q-23-13-29.5-38.5t6.5-48.5 39-30 48 7l186 106-55-160q-13-38 12-63.5t60.5-20.5 48.5 42l102 300 271 156v-313l-208-238q-16-18-17-39t11-36.5 28.5-25 37-5.5 36.5 22l112 128v-214q0-26 19-45t45-19 45 19 19 45v214l112-128q16-18 36.5-22t37 5.5 28.5 25 11 36.5-17 39l-208 238v313l271-156 102-300q13-37 48.5-42t60.5 20.5 12 63.5l-55 160 186-106q23-13 48-6.5t39 29.5q13 23 6.5 48.5t-29.5 38.5l-186 107 167 33q27 5 40 26t11 43-19 40-44 18q-9 0-13-1l-310-62-271 157 271 157 310-62q29-6 50 10.5t25.5 40-8.5 46.5-42 29z"
    }
  }]
};
exports.snowflakeO = snowflakeO;
var superpowers = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1473 929q7-118-33-226.5t-113-189-177-131-221-57.5q-116-7-225.5 32t-192 110.5-135 175-59.5 220.5q-7 118 33 226.5t113 189 177.5 131 221.5 57.5q155 9 293-59t224-195.5 94-283.5zM1792 0l-349 348q120 117 180.5 272t50.5 321q-11 183-102 339t-241 255.5-332 124.5l-999 132 347-347q-120-116-180.5-271.5t-50.5-321.5q11-184 102-340t241.5-255.5 332.5-124.5q167-22 500-66t500-66z"
    }
  }]
};
exports.superpowers = superpowers;
var wpexplorer = {
  "viewBox": "0 0 1792 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M948 1028l163 329h-51l-175-350-171 350h-49l179-374-78-33 21-49 240 102-21 50zM563 436l304 130-130 304-304-130zM907 621l240 103-103 239-239-102zM1188 771l191 81-82 190-190-81zM1680 896q0-159-62-304t-167.5-250.5-250.5-167.5-304-62-304 62-250.5 167.5-167.5 250.5-62 304 62 304 167.5 250.5 250.5 167.5 304 62 304-62 250.5-167.5 167.5-250.5 62-304zM1792 896q0 182-71 348t-191 286-286 191-348 71-348-71-286-191-191-286-71-348 71-348 191-286 286-191 348-71 348 71 286 191 191 286 71 348z"
    }
  }]
};
exports.wpexplorer = wpexplorer;
var meetup = {
  "viewBox": "0 0 1920 1792",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1334 1234q-4-24-27.5-34t-49.5-10.5-48.5-12.5-25.5-38q-5-47 33-139.5t75-181 32-127.5q-14-101-117-103-45-1-75 16l-3 2-5 2.5t-4.5 2-5 2-5 0.5-6-1.5-6-3.5-6.5-5q-3-2-9-8.5t-9-9-8.5-7.5-9.5-7.5-9.5-5.5-11-4.5-11.5-2.5q-30-5-48 3t-45 31q-1 1-9 8.5t-12.5 11-15 10-16.5 5.5-17-3q-54-27-84-40-41-18-94 5t-76 65q-16 28-41 98.5t-43.5 132.5-40 134-21.5 73q-22 69 18.5 119t110.5 46q30-2 50.5-15t38.5-46q7-13 79-199.5t77-194.5q6-11 21.5-18t29.5 0q27 15 21 53-2 18-51 139.5t-50 132.5q-6 38 19.5 56.5t60.5 7 55-49.5q4-8 45.5-92t81.5-163.5 46-88.5q20-29 41-28 29 0 25 38-2 16-65.5 147.5t-70.5 159.5q-12 53 13 103t74 74q17 9 51 15.5t71.5 8 62.5-14 20-48.5zM383 1450q3 15-5 27.5t-23 15.5q-14 3-26.5-5t-15.5-23q-3-14 5-27t22-16 27 5 16 23zM953 1713q12 17 8.5 37.5t-20.5 32.5-37.5 8-32.5-21q-11-17-7.5-37.5t20.5-32.5 37.5-8 31.5 21zM177 901q-18 27-49.5 33t-57.5-13q-26-18-32-50t12-58q18-27 49.5-33t57.5 12q26 19 32 50.5t-12 58.5zM1467 1578q19 28 13 61.5t-34 52.5-60.5 13-51.5-34-13-61 33-53q28-19 60.5-13t52.5 34zM1579 974q69 113 42.5 244.5t-134.5 207.5q-90 63-199 60-20 80-84.5 127t-143.5 44.5-140-57.5q-12 9-13 10-103 71-225 48.5t-193-126.5q-50-73-53-164-83-14-142.5-70.5t-80.5-128-2-152 81-138.5q-36-60-38-128t24.5-125 79.5-98.5 121-50.5q32-85 99-148t146.5-91.5 168-17 159.5 66.5q72-21 140-17.5t128.5 36 104.5 80 67.5 115 17.5 140.5q52 16 87 57t45.5 89-5.5 99.5-58 87.5zM455 314q14 20 9.5 44.5t-24.5 38.5q-19 14-43.5 9.5t-37.5-24.5q-14-20-9.5-44.5t24.5-38.5q19-14 43.5-9.5t37.5 24.5zM614 33q4 16-5 30.5t-26 18.5-31-5.5-18-26.5q-3-17 6.5-31t25.5-18q17-4 31 5.5t17 26.5zM1800 981q4 20-6.5 37t-30.5 21q-19 4-36-6.5t-21-30.5 6.5-37 30.5-22q20-4 36.5 7.5t20.5 30.5zM1136 88q16 27 8.5 58.5t-35.5 47.5q-27 16-57.5 8.5t-46.5-34.5q-16-28-8.5-59t34.5-48 58-9 47 36zM1882 744q4 15-4 27.5t-23 16.5q-15 3-27.5-5.5t-15.5-22.5q-3-15 5-28t23-16q14-3 26.5 5t15.5 23zM1691 503q15 22 10.5 49t-26.5 43q-22 15-49 10t-42-27-10-49 27-43 48.5-11 41.5 28z"
    }
  }]
};
exports.meetup = meetup;

/***/ }),
/* 1405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drive = exports.twoUp = exports.threeUp = exports.fourUp = exports.graph = exports.globe = exports.exit = exports.enter = exports.fork = exports.folder = exports.flash = exports.flag = exports.fire = exports.file = exports.eyedropper = exports.eye = exports.link = exports.excerpt = exports.euro = exports.open = exports.closed = exports.ellipses = exports.elevator = exports.eject = exports.droplet = exports.quoteSerifRight = exports.quoteSerifLeft = exports.quoteSansRight = exports.quoteSansLeft = exports.dollar = exports.document = exports.dial = exports.deleteIconic = exports.transferUpload = exports.transferDownload = exports.dashboard = exports.crop = exports.card = exports.copywriting = exports.contrast = exports.compass = exports.square = exports.command = exports.up = exports.down = exports.cog = exports.code = exports.cloudy = exports.cloud = exports.upload = exports.download = exports.clock = exports.clipboard = exports.x = exports.check = exports.chat = exports.cart = exports.slr = exports.calendar = exports.calculator = exports.bullhorn = exports.bug = exports.brush = exports.browser = exports.pound = exports.briefcase = exports.box = exports.bookmark = exports.book = exports.bolt = exports.bold = exports.bluetooth = exports.bell = exports.beaker = exports.full = exports.empty = exports.basket = exports.chart = exports.ban = exports.badge = exports.audio = exports.spectrum = exports.top = exports.thickTop = exports.thickRight = exports.thickLeft = exports.thickBottom = exports.circleTop = exports.circleRight = exports.circleLeft = exports.circleBottom = exports.bottom = exports.aperture = exports.right = exports.left = exports.center = exports.undo = exports.redo = exports.logout = exports.login = void 0;
exports.out = exports.inIconic = exports.yen = exports.wrench = exports.wifi = exports.warning = exports.off = exports.low = exports.high = exports.video = exports.alignTop = exports.alignCenter = exports.alignBottom = exports.underline = exports.trash = exports.transfer = exports.timer = exports.text = exports.terminal = exports.task = exports.target = exports.tags = exports.tag = exports.tablet = exports.sun = exports.star = exports.spreadsheet = exports.descending = exports.ascending = exports.signpost = exports.signal = exports.shield = exports.share = exports.boxed = exports.script = exports.rss = exports.alt = exports.width = exports.height = exports.both = exports.reload = exports.random = exports.rain = exports.mark = exports.piece = exports.pulse = exports.project = exports.print = exports.standby = exports.plus = exports.circle = exports.pin = exports.phone = exports.person = exports.people = exports.pencil = exports.paperclip = exports.note = exports.move = exports.moon = exports.monitor = exports.minus = exports.microphone = exports.menu = exports.cross = exports.stop = exports.stepForward = exports.stepBackward = exports.skipForward = exports.skipBackward = exports.record = exports.play = exports.pause = exports.map = exports.marker = exports.glass = exports.loop = exports.circular = exports.unlocked = exports.locked = exports.location = exports.list = exports.rich = exports.intact = exports.broken = exports.lightbulb = exports.layers = exports.laptop = exports.key = exports.italic = exports.info = exports.infinity = exports.inbox = exports.image = exports.home = exports.heart = exports.headphones = exports.header = void 0;
var login = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v1h4v5h-4v1h5v-7h-5zm1 2v1h-4v1h4v1l2-1.5-2-1.5z"
    }
  }]
};
exports.login = login;
var logout = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v1h4v5h-4v1h5v-7h-5zm-1 2l-2 1.5 2 1.5v-1h4v-1h-4v-1z"
    }
  }]
};
exports.logout = logout;
var redo = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-1.93 0-3.5 1.57-3.5 3.5 0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v.5h-1l2 2 2-2h-1v-.5c0-1.93-1.57-3.5-3.5-3.5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.redo = redo;
var undo = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 0c-1.93 0-3.5 1.57-3.5 3.5v.5h-1l2 2 2-2h-1v-.5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5c0-1.93-1.57-3.5-3.5-3.5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.undo = undo;
var center = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm1 2v1h6v-1h-6zm-1 2v1h8v-1h-8zm1 2v1h6v-1h-6z"
    }
  }]
};
exports.center = center;
var left = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm0 2v1h6v-1h-6zm0 2v1h8v-1h-8zm0 2v1h6v-1h-6z"
    }
  }]
};
exports.left = left;
var right = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm2 2v1h6v-1h-6zm-2 2v1h8v-1h-8zm2 2v1h6v-1h-6z"
    }
  }]
};
exports.right = right;
var aperture = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-.69 0-1.34.19-1.91.5l3.22 2.34.75-2.25c-.6-.36-1.31-.59-2.06-.59zm-2.75 1.13c-.76.73-1.25 1.74-1.25 2.88 0 .25.02.48.06.72l3.09-2.22-1.91-1.38zm5.63.13l-1.22 3.75h2.19c.08-.32.16-.65.16-1 0-1.07-.44-2.03-1.13-2.75zm-4.72 3.22l-1.75 1.25c.55 1.13 1.6 1.99 2.88 2.22l-1.13-3.47zm1.56 1.53l.63 1.97c1.33-.12 2.46-.88 3.09-1.97h-3.72z"
    }
  }]
};
exports.aperture = aperture;
var bottom = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v5h-2l2.53 3 2.47-3h-2v-5h-1z",
      "transform": "translate(1)"
    }
  }]
};
exports.bottom = bottom;
var circleBottom = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-1 1h2v3h2l-3 3-3-3h2v-3z"
    }
  }]
};
exports.circleBottom = circleBottom;
var circleLeft = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1v2h3v2h-3v2l-3-3 3-3z"
    }
  }]
};
exports.circleLeft = circleLeft;
var circleRight = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1l3 3-3 3v-2h-3v-2h3v-2z"
    }
  }]
};
exports.circleRight = circleRight;
var circleTop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1l3 3h-2v3h-2v-3h-2l3-3z"
    }
  }]
};
exports.circleTop = circleTop;
var thickBottom = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v5h-2l3.03 3 2.97-3h-2v-5h-2z",
      "transform": "translate(1)"
    }
  }]
};
exports.thickBottom = thickBottom;
var thickLeft = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-3 3.03 3 2.97v-2h5v-2h-5v-2z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.thickLeft = thickLeft;
var thickRight = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 0v2h-5v2h5v2l3-3.03-3-2.97z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.thickRight = thickRight;
var thickTop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.97 0l-2.97 3h2v5h2v-5h2l-3.03-3z",
      "transform": "translate(1)"
    }
  }]
};
exports.thickTop = thickTop;
var top = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.47 0l-2.47 3h2v5h1v-5h2l-2.53-3z",
      "transform": "translate(1)"
    }
  }]
};
exports.top = top;
var spectrum = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0v8h1v-8h-1zm-2 1v6h1v-6h-1zm4 1v4h1v-4h-1zm-6 1v2h1v-2h-1z"
    }
  }]
};
exports.spectrum = spectrum;
var audio = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.16 0c-.72.72-1.16 1.71-1.16 2.81s.43 2.12 1.16 2.84l.72-.72c-.54-.54-.88-1.29-.88-2.13 0-.83.33-1.55.88-2.09l-.72-.72zm5.69 0l-.72.72c.54.54.88 1.26.88 2.09 0 .83-.33 1.58-.88 2.13l.72.72c.72-.72 1.16-1.74 1.16-2.84 0-1.1-.43-2.09-1.16-2.81zm-4.25 1.41c-.36.36-.59.86-.59 1.41 0 .55.23 1.08.59 1.44l.69-.72c-.18-.18-.28-.44-.28-.72 0-.28.1-.5.28-.69l-.69-.72zm2.81 0l-.69.72c.18.18.28.41.28.69 0 .28-.1.54-.28.72l.69.72c.36-.36.59-.89.59-1.44 0-.55-.23-1.05-.59-1.41z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.audio = audio;
var badge = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-1 4.81v3.19l1-1 1 1v-3.19c-.31.11-.65.19-1 .19s-.69-.08-1-.19z",
      "transform": "translate(2)"
    }
  }]
};
exports.badge = badge;
var ban = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c.66 0 1.26.21 1.75.56l-4.19 4.19c-.35-.49-.56-1.09-.56-1.75 0-1.66 1.34-3 3-3zm2.44 1.25c.35.49.56 1.09.56 1.75 0 1.66-1.34 3-3 3-.66 0-1.26-.21-1.75-.56l4.19-4.19z"
    }
  }]
};
exports.ban = ban;
var chart = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v7h8v-1h-7v-6h-1zm5 0v5h2v-5h-2zm-3 2v3h2v-3h-2z"
    }
  }]
};
exports.chart = chart;
var basket = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.97 0c-.13.01-.26.08-.34.19l-2.34 2.81h-1.28v1h1v3.66c0 .18.16.34.34.34h5.31c.18 0 .34-.16.34-.34v-3.66h1v-1h-1.28c-.27-.33-2.39-2.86-2.41-2.88-.11-.09-.22-.14-.34-.13zm.03 1.28l1.44 1.72h-2.88l1.44-1.72zm-1.5 3.72c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5zm3 0c.28 0 .5.22.5.5v1c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1c0-.28.22-.5.5-.5z"
    }
  }]
};
exports.basket = basket;
var empty = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v5.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-1.91h1v-2h-1v-1.91c0-.06-.04-.09-.09-.09h-6.81zm.91 1h5v4h-5v-4z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.empty = empty;
var full = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v5.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-1.91h1v-2h-1v-1.91c0-.06-.04-.09-.09-.09h-6.81z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.full = full;
var beaker = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.34 0a.5.5 0 0 0 .16 1h.5v1.41c-.09.17-1.2 2.31-1.66 3.09-.16.26-.34.61-.34 1.06 0 .39.15.77.41 1.03s.64.41 1.03.41h5.13c.38 0 .74-.16 1-.41h.03c.26-.26.41-.64.41-1.03 0-.45-.19-.8-.34-1.06-.46-.78-1.57-2.92-1.66-3.09v-1.41h.5a.5.5 0 1 0 0-1h-5a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0zm1.66 1h2v1.63l.06.09s.63 1.23 1.19 2.28h-4.5c.56-1.05 1.19-2.28 1.19-2.28l.06-.09v-1.63z"
    }
  }]
};
exports.beaker = beaker;
var bell = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-1.1 0-2 .9-2 2 0 1.04-.52 1.98-1.34 2.66-.41.34-.66.82-.66 1.34h8c0-.52-.24-1-.66-1.34-.82-.68-1.34-1.62-1.34-2.66 0-1.1-.89-2-2-2zm-1 7c0 .55.45 1 1 1s1-.45 1-1h-2z"
    }
  }]
};
exports.bell = bell;
var bluetooth = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.5 0v2.5l-.75-.75-.75.75 1.5 1.5-1.5 1.5.75.75.75-.75v2.5h.5l3.5-2.5-2.25-1.53 2.25-1.47-3.5-2.5h-.5zm1 1.5l1.5 1-1.5 1v-2zm0 3l1.5 1-1.5 1v-2z",
      "transform": "translate(1)"
    }
  }]
};
exports.bluetooth = bluetooth;
var bold = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1v1h5.5c1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.44-2.25.27-.34.44-.78.44-1.25 0-1.1-.89-2-2-2h-5zm3 1h1c.55 0 1 .45 1 1s-.45 1-1 1h-1v-2zm0 3h1.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-1.5v-3z"
    }
  }]
};
exports.bold = bold;
var bolt = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-3 5h2v3l3-5h-2v-3z",
      "transform": "translate(1)"
    }
  }]
};
exports.bolt = bolt;
var book = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 0c-.07 0-.13.01-.19.03-.39.08-.7.39-.78.78-.03.06-.03.12-.03.19v5.5c0 .83.67 1.5 1.5 1.5h5.5v-1h-5.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h5.5v-5.5c0-.28-.22-.5-.5-.5h-.5v3l-1-1-1 1v-3h-3z"
    }
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8l2-2 2 2v-8h-4z",
      "transform": "translate(2)"
    }
  }]
};
exports.bookmark = bookmark;
var box = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm0 2v5.91c0 .05.04.09.09.09h7.81c.05 0 .09-.04.09-.09v-5.91h-2.97v1.03h-2.03v-1.03h-3z"
    }
  }]
};
exports.box = box;
var briefcase = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.55 0-1 .45-1 1v1h-1.91c-.06 0-.09.04-.09.09v2.41c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5v-2.41c0-.06-.04-.09-.09-.09h-1.91v-1c0-.55-.45-1-1-1h-2zm0 1h2v1h-2v-1zm-3 4.91v2c0 .05.04.09.09.09h7.81c.05 0 .09-.04.09-.09v-2c-.16.06-.32.09-.5.09h-7c-.18 0-.34-.04-.5-.09z"
    }
  }]
};
exports.briefcase = briefcase;
var pound = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.62 0-1.16.26-1.5.69-.34.43-.5.99-.5 1.56 0 .69.16 1.25.25 1.75h-1.25v1h1.22c-.11.45-.37.96-1.06 1.66l-.16.13v1.22h6v-1h-4.91c.64-.73.98-1.4 1.13-2h1.78v-1h-1.72c-.08-.68-.28-1.24-.28-1.75 0-.39.11-.73.28-.94.17-.21.37-.31.72-.31.39 0 .61.11.75.25s.25.36.25.75h1c0-.58-.17-1.1-.53-1.47-.37-.37-.89-.53-1.47-.53z",
      "transform": "translate(1)"
    }
  }]
};
exports.pound = pound;
var browser = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.34 0a.5.5 0 0 0-.34.5v7a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0zm1.16 1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5zm2 0h3c.28 0 .5.22.5.5s-.22.5-.5.5h-3c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zm-2.5 2h6v4h-6v-4z"
    }
  }]
};
exports.browser = browser;
var brush = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.44.03c-.03 0-.04.02-.06.03l-3.75 2.66c-.04.03-.1.11-.13.16l-.13.25c.72.23 1.27.78 1.5 1.5l.25-.13c.05-.03.12-.08.16-.13l2.66-3.75c.03-.05.04-.09 0-.13l-.44-.44c-.02-.02-.04-.03-.06-.03zm-4.78 3.97c-.74 0-1.31.61-1.31 1.34 0 .99-.55 1.85-1.34 2.31.39.22.86.34 1.34.34 1.47 0 2.66-1.18 2.66-2.66 0-.74-.61-1.34-1.34-1.34z"
    }
  }]
};
exports.brush = brush;
var bug = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-1.19 0-1.98 1.69-1.19 2.5-.09.07-.2.14-.28.22l-1.31-.66a.5.5 0 0 0-.34-.06.5.5 0 0 0-.09.94l1.16.56c-.09.16-.19.33-.25.5h-.69a.5.5 0 0 0-.09 0 .5.5 0 1 0 .09 1h.5c0 .23.02.45.06.66l-.78.41a.5.5 0 1 0 .44.88l.66-.34c.25.46.62.85 1.03 1.09.35-.19.59-.44.59-.72v-1.44a.5.5 0 0 0 0-.09v-.81a.5.5 0 0 0 0-.22c.05-.23.26-.41.5-.41.28 0 .5.22.5.5v.88a.5.5 0 0 0 0 .09v.06a.5.5 0 0 0 0 .09v1.34c0 .27.24.53.59.72.41-.25.79-.63 1.03-1.09l.66.34a.5.5 0 1 0 .44-.88l-.78-.41c.04-.21.06-.43.06-.66h.5a.5.5 0 1 0 0-1h-.69c-.06-.17-.16-.34-.25-.5l1.16-.56a.5.5 0 0 0-.31-.94.5.5 0 0 0-.13.06l-1.31.66c-.09-.08-.19-.15-.28-.22.78-.83 0-2.5-1.19-2.5z"
    }
  }]
};
exports.bug = bug;
var bullhorn = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0v6c.03.01.07 0 .09 0h.81c.05 0 .09-.04.09-.09v-5.81c0-.06-.04-.09-.09-.09h-.91zm-1 .5l-2.91 1.47c-.05.02-.13.03-.19.03h-1.81c-.06 0-.09.04-.09.09v1.81c0 .06.04.09.09.09h.91l1.03 2.72c.11.25.44.36.69.25.25-.11.36-.44.25-.69l-.75-1.78c.03-.14.13-.22.28-.22v-.03l2.5 1.25v-5z"
    }
  }]
};
exports.bullhorn = bullhorn;
var calculator = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v7.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-7.81c0-.06-.04-.09-.09-.09h-6.81zm.91 1h5v2h-5v-2zm0 3h1v1h-1v-1zm2 0h1v1h-1v-1zm2 0h1v3h-1v-3zm-4 2h1v1h-1v-1zm2 0h1v1h-1v-1z"
    }
  }]
};
exports.calculator = calculator;
var calendar = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h7v-2h-7zm0 3v4.91c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-4.91h-7zm1 1h1v1h-1v-1zm2 0h1v1h-1v-1zm2 0h1v1h-1v-1zm-4 2h1v1h-1v-1zm2 0h1v1h-1v-1z"
    }
  }]
};
exports.calendar = calendar;
var slr = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.09 0c-.05 0-.1.04-.13.09l-.94 1.81c-.02.05-.07.09-.13.09h-1.41c-.83 0-1.5.67-1.5 1.5v4.41c0 .05.04.09.09.09h7.81c.05 0 .09-.04.09-.09v-5.81c0-.06-.04-.09-.09-.09h-.81c-.05 0-.1-.04-.13-.09l-.94-1.81c-.03-.05-.07-.09-.13-.09h-1.81zm-2.59 3c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5zm3.5 0c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm0 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
    }
  }]
};
exports.slr = slr;
var cart = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.34 0a.5.5 0 0 0 .16 1h1.5l.09.25.41 1.25.41 1.25c.04.13.21.25.34.25h3.5c.14 0 .3-.12.34-.25l.81-2.5c.04-.13-.02-.25-.16-.25h-4.44l-.38-.72a.5.5 0 0 0-.44-.28h-2a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0zm3.16 5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.cart = cart;
var chat = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v5l1-1h1v-3h3v-1h-5zm3 2v4h4l1 1v-5h-5z"
    }
  }]
};
exports.chat = chat;
var check = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.41 0l-.69.72-2.78 2.78-.81-.78-.72-.72-1.41 1.41.72.72 1.5 1.5.69.72.72-.72 3.5-3.5.72-.72-1.44-1.41z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.check = check;
var x = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-1.5 1.78l1.5 1.5 1.5-1.5.72.72-1.5 1.5 1.5 1.5-.72.72-1.5-1.5-1.5 1.5-.72-.72 1.5-1.5-1.5-1.5.72-.72z"
    }
  }]
};
exports.x = x;
var clipboard = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-.28 0-.5.22-.5.5v.5h-.75c-.14 0-.25.11-.25.25v.75h3v-.75c0-.14-.11-.25-.25-.25h-.75v-.5c0-.28-.22-.5-.5-.5zm-3.25 1c-.14 0-.25.11-.25.25v6.5c0 .14.11.25.25.25h6.5c.14 0 .25-.11.25-.25v-6.5c0-.14-.11-.25-.25-.25h-.75v2h-5v-2h-.75z"
    }
  }]
};
exports.clipboard = clipboard;
var clock = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm-.5 1v2.22l.16.13.5.5.34.38.72-.72-.38-.34-.34-.34v-1.81h-1z"
    }
  }]
};
exports.clock = clock;
var download = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 0c-1.21 0-2.27.86-2.5 2-1.1 0-2 .9-2 2 0 .37.11.71.28 1h2.72v-.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v.5h1.91c.06-.16.09-.32.09-.5 0-.65-.42-1.29-1-1.5v-.5c0-1.38-1.12-2.5-2.5-2.5zm-.16 4a.5.5 0 0 0-.34.5v1.5h-1.5l2 2 2-2h-1.5v-1.5a.5.5 0 0 0-.59-.5.5.5 0 0 0-.06 0z"
    }
  }]
};
exports.download = download;
var upload = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 0c-1.21 0-2.27.86-2.5 2-1.1 0-2 .9-2 2 0 .37.11.71.28 1h2.22l2-2 2 2h1.41c.06-.16.09-.32.09-.5 0-.65-.42-1.29-1-1.5v-.5c0-1.38-1.12-2.5-2.5-2.5zm0 4.5l-2.5 2.5h2v.5a.5.5 0 1 0 1 0v-.5h2l-2.5-2.5z"
    }
  }]
};
exports.upload = upload;
var cloud = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 0c-1.21 0-2.27.86-2.5 2-1.1 0-2 .9-2 2s.9 2 2 2h4.5c.83 0 1.5-.67 1.5-1.5 0-.65-.42-1.29-1-1.5v-.5c0-1.38-1.12-2.5-2.5-2.5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.cloud = cloud;
var cloudy = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5 0c-1.38 0-2.5 1.12-2.5 2.5 0 .39.09.74.25 1.06.3-.21.64-.37 1-.47.55-1.25 1.82-2.09 3.25-2.09-.46-.6-1.18-1-2-1zm2 2c-1.21 0-2.27.86-2.5 2-1.1 0-2 .9-2 2s.9 2 2 2h4.5c.83 0 1.5-.67 1.5-1.5 0-.65-.42-1.29-1-1.5v-.5c0-1.38-1.12-2.5-2.5-2.5z"
    }
  }]
};
exports.cloudy = cloudy;
var code = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 0l-3 6h1l3-6h-1zm-4 1l-1 2 1 2h1l-1-2 1-2h-1zm5 0l1 2-1 2h1l1-2-1-2h-1z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.code = code;
var cog = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0l-.5 1.19c-.1.03-.19.08-.28.13l-1.19-.5-.72.72.5 1.19c-.05.1-.09.18-.13.28l-1.19.5v1l1.19.5c.04.1.08.18.13.28l-.5 1.19.72.72 1.19-.5c.09.04.18.09.28.13l.5 1.19h1l.5-1.19c.09-.04.19-.08.28-.13l1.19.5.72-.72-.5-1.19c.04-.09.09-.19.13-.28l1.19-.5v-1l-1.19-.5c-.03-.09-.08-.19-.13-.28l.5-1.19-.72-.72-1.19.5c-.09-.04-.19-.09-.28-.13l-.5-1.19h-1zm.5 2.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5-1.5-.67-1.5-1.5.67-1.5 1.5-1.5z"
    }
  }]
};
exports.cog = cog;
var down = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h8v-2h-8zm2 3l2 2 2-2h-4zm-2 4v1h8v-1h-8z"
    }
  }]
};
exports.down = down;
var up = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm4 3l-2 2h4l-2-2zm-4 3v2h8v-2h-8z"
    }
  }]
};
exports.up = up;
var command = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.5 0c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5h.5v1h-.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5v-.5h1v.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5h-.5v-1h.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5v.5h-1v-.5c0-.83-.67-1.5-1.5-1.5zm0 1c.28 0 .5.22.5.5v.5h-.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5zm4 0c.28 0 .5.22.5.5s-.22.5-.5.5h-.5v-.5c0-.28.22-.5.5-.5zm-2.5 2h1v1h-1v-1zm-1.5 2h.5v.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5.22-.5.5-.5zm3.5 0h.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5v-.5z"
    }
  }]
};
exports.command = command;
var square = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v5.81c0 .05.04.09.09.09h5.91l2 2v-7.91c0-.06-.04-.09-.09-.09h-7.81z"
    }
  }]
};
exports.square = square;
var compass = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm2 1l-3 1-1 3 3-1 1-3zm-2 1.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z"
    }
  }]
};
exports.compass = compass;
var contrast = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c1.66 0 3 1.34 3 3s-1.34 3-3 3v-6z"
    }
  }]
};
exports.contrast = contrast;
var copywriting = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm0 2v1h5v-1h-5zm0 3v1h8v-1h-8zm0 2v1h6v-1h-6zm7.5 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
    }
  }]
};
exports.copywriting = copywriting;
var card = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.25 0c-.14 0-.25.11-.25.25v.75h8v-.75c0-.14-.11-.25-.25-.25h-7.5zm-.25 2v3.75c0 .14.11.25.25.25h7.5c.14 0 .25-.11.25-.25v-3.75h-8zm1 2h1v1h-1v-1zm2 0h1v1h-1v-1z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.card = card;
var crop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 0v1h-1v1h1v5h5v1h1v-1h1v-1h-1v-4.5l1-1-.5-.5-1 1h-4.5v-1h-1zm1 2h3.5l-3.5 3.5v-3.5zm4 .5v3.5h-3.5l3.5-3.5z"
    }
  }]
};
exports.crop = crop;
var dashboard = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 1c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-1.66 1a.5.5 0 0 0-.19.84l.91.91c-.02.08-.06.16-.06.25 0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1c-.09 0-.17.04-.25.06l-.91-.91a.5.5 0 0 0-.44-.16.5.5 0 0 0-.06 0zm3.16 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
    }
  }]
};
exports.dashboard = dashboard;
var transferDownload = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v3h-2l3 3 3-3h-2v-3h-2zm-3 7v1h8v-1h-8z"
    }
  }]
};
exports.transferDownload = transferDownload;
var transferUpload = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm4 2l-3 3h2v3h2v-3h2l-3-3z"
    }
  }]
};
exports.transferUpload = transferUpload;
var deleteIconic = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0l-2 3 2 3h6v-6h-6zm1.5.78l1.5 1.5 1.5-1.5.72.72-1.5 1.5 1.5 1.5-.72.72-1.5-1.5-1.5 1.5-.72-.72 1.5-1.5-1.5-1.5.72-.72z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.deleteIconic = deleteIconic;
var dial = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4h1c0-1.66 1.34-3 3-3s3 1.34 3 3h1c0-2.2-1.8-4-4-4zm-.59 2.09c-.81.25-1.41 1.01-1.41 1.91 0 1.11.9 2 2 2 1.11 0 2-.89 2-2 0-.9-.59-1.65-1.41-1.91l-.59.88-.59-.88z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.dial = dial;
var document = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h7v-4h-4v-4h-3zm4 0v3h3l-3-3zm-3 2h1v1h-1v-1zm0 2h1v1h-1v-1zm0 2h4v1h-4v-1z"
    }
  }]
};
exports.document = document;
var dollar = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v1h-.75c-.68 0-1.25.57-1.25 1.25v.5c0 .68.44 1.24 1.09 1.41l2.56.66c.14.04.34.29.34.44v.5c0 .14-.11.25-.25.25h-2.5c-.12 0-.21-.04-.25-.06v-.94h-1v1c0 .34.2.63.44.78.23.16.52.22.81.22h.75v1h1v-1h.75c.69 0 1.25-.56 1.25-1.25v-.5c0-.68-.44-1.24-1.09-1.41l-2.56-.66c-.14-.04-.34-.29-.34-.44v-.5c0-.14.11-.25.25-.25h2.5c.11 0 .21.04.25.06v.94h1v-1c0-.34-.2-.63-.44-.78-.23-.16-.52-.22-.81-.22h-.75v-1h-1z",
      "transform": "translate(1)"
    }
  }]
};
exports.dollar = dollar;
var quoteSansLeft = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6l3-3v-3h-3zm5 0v6l3-3v-3h-3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.quoteSansLeft = quoteSansLeft;
var quoteSansRight = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-3 3v3h3v-6zm5 0l-3 3v3h3v-6z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.quoteSansRight = quoteSansRight;
var quoteSerifLeft = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-1.65 0-3 1.35-3 3v3h3v-3h-2c0-1.11.89-2 2-2v-1zm5 0c-1.65 0-3 1.35-3 3v3h3v-3h-2c0-1.11.89-2 2-2v-1z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.quoteSerifLeft = quoteSerifLeft;
var quoteSerifRight = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v3h2c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3v-3h-3zm5 0v3h2c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3v-3h-3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.quoteSerifRight = quoteSerifRight;
var droplet = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-.34.34c-.11.11-2.66 2.69-2.66 4.88 0 1.65 1.35 3 3 3s3-1.35 3-3c0-2.18-2.55-4.77-2.66-4.88l-.34-.34zm-1.5 4.72c.28 0 .5.22.5.5 0 .55.45 1 1 1 .28 0 .5.22.5.5s-.22.5-.5.5c-1.1 0-2-.9-2-2 0-.28.22-.5.5-.5z",
      "transform": "translate(1)"
    }
  }]
};
exports.droplet = droplet;
var eject = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-4 5h8l-4-5zm-4 6v2h8v-2h-8z"
    }
  }]
};
exports.eject = eject;
var elevator = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-3 3h6l-3-3zm-3 5l3 3 3-3h-6z",
      "transform": "translate(1)"
    }
  }]
};
exports.elevator = elevator;
var ellipses = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2z",
      "transform": "translate(0 3)"
    }
  }]
};
exports.ellipses = ellipses;
var closed = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1l4 2 4-2v-1h-8zm0 2v4h8v-4l-4 2-4-2z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.closed = closed;
var open = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-4 2v6h8v-6l-4-2zm0 1.13l3 1.5v1.88l-3 1.5-3-1.5v-1.88l3-1.5zm-2 1.88v1l2 1 2-1v-1h-4z"
    }
  }]
};
exports.open = open;
var euro = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0c-1.86 0-3.4 1.28-3.84 3h-1.91l-.25 1h2.01c0 .35.07.68.16 1h-1.97l-.19 1h2.56c.7 1.19 1.97 2 3.44 2 .73 0 1.41-.21 2-.56v-1.22c-.53.48-1.22.78-2 .78-.89 0-1.67-.39-2.22-1h2.22l.16-1h-2.97c-.11-.32-.19-.64-.19-1h3.34l.16-1h-3.31c.41-1.16 1.51-2 2.81-2 .66 0 1.26.21 1.75.56l.16-1.06c-.57-.31-1.21-.5-1.91-.5z",
      "transform": "translate(-1)"
    }
  }]
};
exports.euro = euro;
var excerpt = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h7v-1h-7zm0 2v1h5v-1h-5zm0 2v1h8v-1h-8zm0 2v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1z"
    }
  }]
};
exports.excerpt = excerpt;
var link = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h8v-2h-1v1h-6v-6h1v-1h-2zm4 0l1.5 1.5-2.5 2.5 1 1 2.5-2.5 1.5 1.5v-4h-4z"
    }
  }]
};
exports.link = link;
var eye = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.03 0c-2.53 0-4.03 3-4.03 3s1.5 3 4.03 3c2.47 0 3.97-3 3.97-3s-1.5-3-3.97-3zm-.03 1c1.11 0 2 .9 2 2 0 1.11-.89 2-2 2-1.1 0-2-.89-2-2 0-1.1.9-2 2-2zm0 1c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.04-.19-.06-.28-.08.16-.24.28-.44.28-.28 0-.5-.22-.5-.5 0-.2.12-.36.28-.44-.09-.03-.18-.06-.28-.06z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.eye = eye;
var eyedropper = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.31 0a.5.5 0 0 0-.19.84l.63.63-3.59 3.66-.16.16v2.7199999999999998h2.69l.16-.16 3.66-3.66.63.66a.5.5 0 1 0 .72-.69l-.94-.94.66-.66c.59-.58.59-1.54 0-2.13-.57-.57-1.56-.57-2.13 0l-.66.66-.94-.94a.5.5 0 0 0-.47-.16.5.5 0 0 0-.06 0zm1.16 2.19l1.31 1.31-3.16 3.16-1.28-1.31 3.13-3.16z"
    }
  }]
};
exports.eyedropper = eyedropper;
var file = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h7v-4h-4v-4h-3zm4 0v3h3l-3-3z"
    }
  }]
};
exports.file = file;
var fire = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0c1 2-2 3-2 5s2 3 2 3c-.98-1.98 2-3 2-5s-2-3-2-3zm3 3c1 2-2 3-2 5h3c.4 0 1-.5 1-2 0-2-2-3-2-3z"
    }
  }]
};
exports.fire = fire;
var flag = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h1v-8h-1zm2 0v4h2v1h4l-2-1.97 2-2.03h-3v-1h-3z"
    }
  }]
};
exports.flag = flag;
var flash = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.5 0l-1.5 3h2l-.66 2h-1.34l1 3 3-3h-1.5l1.5-3h-2l1-2h-1.5z",
      "transform": "translate(2)"
    }
  }]
};
exports.flash = flash;
var folder = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h8v-1h-5v-1h-3zm0 3v4.5c0 .28.22.5.5.5h7c.28 0 .5-.22.5-.5v-4.5h-8z"
    }
  }]
};
exports.folder = folder;
var fork = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.5 0c-.83 0-1.5.67-1.5 1.5 0 .66.41 1.2 1 1.41v2.19c-.59.2-1 .75-1 1.41 0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5c0-.6-.34-1.1-.84-1.34.09-.09.21-.16.34-.16h2c.82 0 1.5-.68 1.5-1.5v-.59c.59-.2 1-.75 1-1.41 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .66.41 1.2 1 1.41v.59c0 .28-.22.5-.5.5h-2c-.17 0-.35.04-.5.09v-1.19c.59-.2 1-.75 1-1.41 0-.83-.67-1.5-1.5-1.5z"
    }
  }]
};
exports.fork = fork;
var enter = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v4l1.5-1.5 1.5 1.5 1-1-1.5-1.5 1.5-1.5h-4zm5 4l-1 1 1.5 1.5-1.5 1.5h4v-4l-1.5 1.5-1.5-1.5z"
    }
  }]
};
exports.enter = enter;
var exit = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 0l-1 1 1.5 1.5-1.5 1.5h4v-4l-1.5 1.5-1.5-1.5zm3 4v4l1.5-1.5 1.5 1.5 1-1-1.5-1.5 1.5-1.5h-4z"
    }
  }]
};
exports.exit = exit;
var globe = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 1c.33 0 .64.09.94.19-.21.2-.45.38-.41.56.04.18.69.13.69.5 0 .27-.42.35-.13.66.35.35-.64.98-.66 1.44-.03.83.84.97 1.53.97.42 0 .53.2.5.44-.54.77-1.46 1.25-2.47 1.25-.38 0-.73-.09-1.06-.22.22-.44-.28-1.31-.75-1.59-.23-.23-.72-.14-1-.25-.09-.27-.18-.54-.19-.84.03-.05.08-.09.16-.09.19 0 .45.38.59.34.18-.04-.74-1.31-.31-1.56.2-.12.6.39.47-.16-.12-.51.36-.28.66-.41.26-.11.45-.41.13-.59-.06-.03-.13-.1-.22-.19.45-.27.97-.44 1.53-.44zm2.31 1.09c.18.22.32.46.44.72 0 .01 0 .02 0 .03-.04.07-.11.11-.22.22-.28.28-.32-.21-.44-.31-.13-.12-.6.02-.66-.13-.07-.18.5-.42.88-.53z"
    }
  }]
};
exports.globe = globe;
var graph = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.03 0l-3.03 3-1-1-3 3.03 1 1 2-2.03 1 1 4-4-.97-1zm-7.03 7v1h8v-1h-8z"
    }
  }]
};
exports.graph = graph;
var fourUp = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm-6 2v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm-6 2v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm-6 2v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1zm2 0v1h1v-1h-1z"
    }
  }]
};
exports.fourUp = fourUp;
var threeUp = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2zm-6 3v2h2v-2h-2zm3 0v2h2v-2h-2zm3 0v2h2v-2h-2z"
    }
  }]
};
exports.threeUp = threeUp;
var twoUp = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v3h3v-3h-3zm5 0v3h3v-3h-3zm-5 5v3h3v-3h-3zm5 0v3h3v-3h-3z"
    }
  }]
};
exports.twoUp = twoUp;
var drive = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.19 0c-.11 0-.19.08-.19.19v3.31c0 .28.22.5.5.5h6c.28 0 .5-.22.5-.5v-3.31c0-.11-.08-.19-.19-.19h-6.63zm-.19 4.91v2.91c0 .11.08.19.19.19h6.63c.11 0 .19-.08.19-.19v-2.91c-.16.06-.32.09-.5.09h-6c-.18 0-.34-.04-.5-.09zm5.5 1.09c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z"
    }
  }]
};
exports.drive = drive;
var header = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h.5c.28 0 .5.22.5.5v4c0 .28-.22.5-.5.5h-.5v1h3v-1h-.5c-.28 0-.5-.22-.5-.5v-1.5h3v1.5c0 .28-.22.5-.5.5h-.5v1h3v-1h-.5c-.28 0-.5-.22-.5-.5v-4c0-.28.22-.5.5-.5h.5v-1h-3v1h.5c.28 0 .5.22.5.5v1.5h-3v-1.5c0-.28.22-.5.5-.5h.5v-1h-3z"
    }
  }]
};
exports.header = header;
var headphones = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-1.65 0-3 1.35-3 3v1h-.5a.5.5 0 0 0-.5.5v2a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-3.5c0-1.11.89-2 2-2 1.11 0 2 .89 2 2v3.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-2a.5.5 0 0 0-.5-.5h-.5v-1c0-1.65-1.35-3-3-3z"
    }
  }]
};
exports.headphones = headphones;
var heart = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0c-.55 0-1.04.23-1.41.59-.36.36-.59.85-.59 1.41 0 .55.23 1.04.59 1.41l3.41 3.41 3.41-3.41c.36-.36.59-.85.59-1.41 0-.55-.23-1.04-.59-1.41-.36-.36-.85-.59-1.41-.59-.55 0-1.04.23-1.41.59-.36.36-.59.85-.59 1.41 0-.55-.23-1.04-.59-1.41-.36-.36-.85-.59-1.41-.59z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.heart = heart;
var home = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-4 3h1v4h2v-2h2v2h2v-4.03l1 .03-4-3z"
    }
  }]
};
exports.home = home;
var image = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h8v-8h-8zm1 1h6v3l-1-1-1 1 2 2v1h-1l-4-4-1 1v-3z"
    }
  }]
};
exports.image = image;
var inbox = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.19 0c-.11 0-.19.08-.19.19v7.63c0 .11.08.19.19.19h7.63c.11 0 .19-.08.19-.19v-7.63c0-.11-.08-.19-.19-.19h-7.63zm.81 2h6v3h-1l-1 1h-2l-1-1h-1v-3z"
    }
  }]
};
exports.inbox = inbox;
var infinity = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0c-1.31 0-2 1.01-2 2s.69 2 2 2c.79 0 1.42-.56 2-1.22.58.66 1.19 1.22 2 1.22 1.31 0 2-1.01 2-2s-.69-2-2-2c-.81 0-1.42.56-2 1.22-.58-.66-1.21-1.22-2-1.22zm0 1c.42 0 .88.47 1.34 1-.46.53-.92 1-1.34 1-.74 0-1-.54-1-1 0-.46.26-1 1-1zm4 0c.74 0 1 .54 1 1 0 .46-.26 1-1 1-.43 0-.89-.47-1.34-1 .46-.53.91-1 1.34-1z",
      "transform": "translate(0 2)"
    }
  }]
};
exports.infinity = infinity;
var info = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-1.5 2.5c-.83 0-1.5.67-1.5 1.5h1c0-.28.22-.5.5-.5s.5.22.5.5-1 1.64-1 2.5c0 .86.67 1.5 1.5 1.5s1.5-.67 1.5-1.5h-1c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-.36 1-1.84 1-2.5 0-.81-.67-1.5-1.5-1.5z",
      "transform": "translate(2)"
    }
  }]
};
exports.info = info;
var italic = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v1h1.63l-.06.13-2 5-.34.88h-1.22v1h5v-1h-1.63l.06-.13 2-5 .34-.88h1.22v-1h-5z"
    }
  }]
};
exports.italic = italic;
var key = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.5 0c-1.38 0-2.5 1.12-2.5 2.5 0 .16 0 .32.03.47l-3.03 3.03v2h3v-2h2v-1l.03-.03c.15.03.31.03.47.03 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5zm.5 1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
    }
  }]
};
exports.key = key;
var laptop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.34 0a.5.5 0 0 0-.34.5v3.5h-1v1.5c0 .28.22.5.5.5h7.010000000000001c.28 0 .5-.22.5-.5v-1.5h-1v-3.5a.5.5 0 0 0-.5-.5h-5a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0zm.66 1h4v3h-1v1h-2v-1h-1v-3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.laptop = laptop;
var layers = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v4h4v-4h-4zm5 2v3h-3v1h4v-4h-1zm2 2v3h-3v1h4v-4h-1z"
    }
  }]
};
exports.layers = layers;
var lightbulb = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.41 0a.5.5 0 0 0-.13.06l-3 1.5a.5.5 0 1 0 .44.88l3-1.5a.5.5 0 0 0-.31-.94zm1 1.5a.5.5 0 0 0-.13.06l-4 2a.5.5 0 1 0 .44.88l4-2a.5.5 0 0 0-.31-.94zm0 2a.5.5 0 0 0-.13.06l-3 1.5a.5.5 0 0 0 .22.94h2a.5.5 0 0 0 .16-1l1.06-.56a.5.5 0 0 0-.31-.94zm-2.56 3.5a.5.5 0 0 0 .16 1h1a.5.5 0 1 0 0-1h-1a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0z",
      "transform": "translate(1)"
    }
  }]
};
exports.lightbulb = lightbulb;
var broken = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v1h-1v1h2v-2h-1zm3.88.03c-.18.01-.36.03-.53.09-.27.1-.53.25-.75.47l-.44.44a.5.5 0 1 0 .69.69l.44-.44c.11-.11.24-.17.38-.22.35-.12.78-.07 1.06.22.39.39.39 1.04 0 1.44l-1.5 1.5a.5.5 0 1 0 .69.69l1.5-1.5c.78-.78.78-2.04 0-2.81-.28-.28-.61-.45-.97-.53-.18-.04-.38-.04-.56-.03zm-3.59 2.91a.5.5 0 0 0-.19.16l-1.5 1.5c-.78.78-.78 2.04 0 2.81.56.56 1.36.72 2.06.47.27-.1.53-.25.75-.47l.44-.44a.5.5 0 1 0-.69-.69l-.44.44c-.11.11-.24.17-.38.22-.35.12-.78.07-1.06-.22-.39-.39-.39-1.04 0-1.44l1.5-1.5a.5.5 0 0 0-.44-.84.5.5 0 0 0-.06 0zm2.72 3.06v2h1v-1h1v-1h-2z"
    }
  }]
};
exports.broken = broken;
var intact = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.88.03c-.18.01-.36.03-.53.09-.27.1-.53.25-.75.47a.5.5 0 1 0 .69.69c.11-.11.24-.17.38-.22.35-.12.78-.07 1.06.22.39.39.39 1.04 0 1.44l-1.5 1.5c-.44.44-.8.48-1.06.47-.26-.01-.41-.13-.41-.13a.5.5 0 1 0-.5.88s.34.22.84.25c.5.03 1.2-.16 1.81-.78l1.5-1.5c.78-.78.78-2.04 0-2.81-.28-.28-.61-.45-.97-.53-.18-.04-.38-.04-.56-.03zm-2 2.31c-.5-.02-1.19.15-1.78.75l-1.5 1.5c-.78.78-.78 2.04 0 2.81.56.56 1.36.72 2.06.47.27-.1.53-.25.75-.47a.5.5 0 1 0-.69-.69c-.11.11-.24.17-.38.22-.35.12-.78.07-1.06-.22-.39-.39-.39-1.04 0-1.44l1.5-1.5c.4-.4.75-.45 1.03-.44.28.01.47.09.47.09a.5.5 0 1 0 .44-.88s-.34-.2-.84-.22z"
    }
  }]
};
exports.intact = intact;
var rich = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v3h3v-3h-3zm4 0v1h4v-1h-4zm0 2v1h3v-1h-3zm-4 2v3h3v-3h-3zm4 0v1h4v-1h-4zm0 2v1h3v-1h-3z"
    }
  }]
};
exports.rich = rich;
var list = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.5 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm1.5 0v1h6v-1h-6zm-1.5 2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm1.5 0v1h6v-1h-6zm-1.5 2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm1.5 0v1h6v-1h-6zm-1.5 2c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm1.5 0v1h6v-1h-6z"
    }
  }]
};
exports.list = list;
var location = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 0l-8 4 3 1 1 3 4-8z"
    }
  }]
};
exports.location = location;
var locked = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-1.1 0-2 .9-2 2v1h-1v4h6v-4h-1v-1c0-1.1-.9-2-2-2zm0 1c.56 0 1 .44 1 1v1h-2v-1c0-.56.44-1 1-1z",
      "transform": "translate(1)"
    }
  }]
};
exports.locked = locked;
var unlocked = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-1.1 0-2 .9-2 2h1c0-.56.44-1 1-1s1 .44 1 1v2h-4v4h6v-4h-1v-2c0-1.1-.9-2-2-2z",
      "transform": "translate(1)"
    }
  }]
};
exports.unlocked = unlocked;
var circular = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-1.65 0-3 1.35-3 3h-1l1.5 2 1.5-2h-1c0-1.11.89-2 2-2v-1zm2.5 1l-1.5 2h1c0 1.11-.89 2-2 2v1c1.65 0 3-1.35 3-3h1l-1.5-2z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.circular = circular;
var loop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0v1h-5c-.55 0-1 .45-1 1v1h1v-1h5v1l2-1.5-2-1.5zm-4 4l-2 1.5 2 1.5v-1h5c.55 0 1-.45 1-1v-1h-1v1h-5v-1z"
    }
  }]
};
exports.loop = loop;
var glass = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5c.59 0 1.17-.14 1.66-.41a1 1 0 0 0 .13.13l1 1a1.02 1.02 0 1 0 1.44-1.44l-1-1a1 1 0 0 0-.16-.13c.27-.49.44-1.06.44-1.66 0-1.93-1.57-3.5-3.5-3.5zm0 1c1.39 0 2.5 1.11 2.5 2.5 0 .66-.24 1.27-.66 1.72-.01.01-.02.02-.03.03a1 1 0 0 0-.13.13c-.44.4-1.04.63-1.69.63-1.39 0-2.5-1.11-2.5-2.5s1.11-2.5 2.5-2.5z"
    }
  }]
};
exports.glass = glass;
var marker = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-1.66 0-3 1.34-3 3 0 2 3 5 3 5s3-3 3-5c0-1.66-1.34-3-3-3zm0 1c1.11 0 2 .9 2 2 0 1.11-.89 2-2 2-1.1 0-2-.89-2-2 0-1.1.9-2 2-2z",
      "transform": "translate(1)"
    }
  }]
};
exports.marker = marker;
var map = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v8h8v-2.38a.5.5 0 0 0 0-.22v-5.41h-8zm1 1h6v4h-1.5a.5.5 0 0 0-.09 0 .5.5 0 1 0 .09 1h1.5v1h-6v-6zm2.5 1c-.83 0-1.5.67-1.5 1.5 0 1 1.5 2.5 1.5 2.5s1.5-1.5 1.5-2.5c0-.83-.67-1.5-1.5-1.5zm0 1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z"
    }
  }]
};
exports.map = map;
var pause = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6h2v-6h-2zm4 0v6h2v-6h-2z",
      "transform": "translate(1 1)"
    }
  }]
};
exports.pause = pause;
var play = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6l6-3-6-3z",
      "transform": "translate(1 1)"
    }
  }]
};
exports.play = play;
var record = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z",
      "transform": "translate(1 1)"
    }
  }]
};
exports.record = record;
var skipBackward = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-4 3 4 3v-6zm0 3l4 3v-6l-4 3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.skipBackward = skipBackward;
var skipForward = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6l4-3-4-3zm4 3v3l4-3-4-3v3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.skipForward = skipForward;
var stepBackward = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6h2v-6h-2zm2 3l5 3v-6l-5 3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.stepBackward = stepBackward;
var stepForward = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6l5-3-5-3zm5 3v3h2v-6h-2v3z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.stepForward = stepForward;
var stop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v6h6v-6h-6z",
      "transform": "translate(1 1)"
    }
  }]
};
exports.stop = stop;
var cross = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v2h-2v4h2v2h4v-2h2v-4h-2v-2h-4z"
    }
  }]
};
exports.cross = cross;
var menu = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm0 2.97v1h8v-1h-8zm0 3v1h8v-1h-8z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.menu = menu;
var microphone = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.91-.03a1 1 0 0 0-.13.03 1 1 0 0 0-.78 1v2a1 1 0 1 0 2 0v-2a1 1 0 0 0-1.09-1.03zm-2.56 2.03a.5.5 0 0 0-.34.5v.5c0 1.48 1.09 2.69 2.5 2.94v1.06h-.5c-.55 0-1 .45-1 1h4.01c0-.55-.45-1-1-1h-.5v-1.06c1.41-.24 2.5-1.46 2.5-2.94v-.5a.5.5 0 1 0-1 0v.5c0 1.11-.89 2-2 2-1.11 0-2-.89-2-2v-.5a.5.5 0 0 0-.59-.5.5.5 0 0 0-.06 0z",
      "transform": "translate(1)"
    }
  }]
};
exports.microphone = microphone;
var minus = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h8v-2h-8z",
      "transform": "translate(0 3)"
    }
  }]
};
exports.minus = minus;
var monitor = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.34 0a.5.5 0 0 0-.34.5v5a.5.5 0 0 0 .5.5h2.5v1h-1c-.55 0-1 .45-1 1h6c0-.55-.45-1-1-1h-1v-1h2.5a.5.5 0 0 0 .5-.5v-5a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0zm.66 1h6v4h-6v-4z"
    }
  }]
};
exports.monitor = monitor;
var moon = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.72 0c-1.58.53-2.72 2.02-2.72 3.78 0 2.21 1.79 4 4 4 1.76 0 3.25-1.14 3.78-2.72-.4.13-.83.22-1.28.22-2.21 0-4-1.79-4-4 0-.45.08-.88.22-1.28z"
    }
  }]
};
exports.moon = moon;
var move = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0l-1.5 1.5h1v1.5h-1.5v-1l-1.5 1.5 1.5 1.5v-1h1.5v1.5h-1l1.5 1.5 1.5-1.5h-1v-1.5h1.5v1l1.5-1.5-1.5-1.5v1h-1.5v-1.5h1l-1.5-1.5z"
    }
  }]
};
exports.move = move;
var note = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 0c-5 0-6 1-6 1v4.09c-.15-.05-.33-.09-.5-.09-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5v-3.97c.73-.23 1.99-.44 4-.5v2.06c-.15-.05-.33-.09-.5-.09-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5v-5.5z"
    }
  }]
};
exports.note = note;
var paperclip = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 0c-.51 0-1.02.21-1.41.59l-2.78 2.72c-1.07 1.07-1.07 2.8 0 3.88 1.07 1.07 2.8 1.07 3.88 0l1.25-1.25-.69-.69-1.16 1.13-.09.13c-.69.69-1.81.69-2.5 0-.68-.68-.66-1.78 0-2.47l2.78-2.75c.39-.39 1.04-.39 1.44 0 .39.39.37 1.01 0 1.41l-2.5 2.47c-.1.1-.27.1-.38 0-.1-.1-.1-.27 0-.38l.06-.03.91-.94-.69-.69-.97.97c-.48.48-.48 1.27 0 1.75s1.27.49 1.75 0l2.5-2.44c.78-.78.78-2.04 0-2.81-.39-.39-.89-.59-1.41-.59z"
    }
  }]
};
exports.paperclip = paperclip;
var pencil = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0l-1 1 2 2 1-1-2-2zm-2 2l-4 4v2h2l4-4-2-2z"
    }
  }]
};
exports.pencil = pencil;
var people = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.5 0c-.51 0-.95.35-1.22.88.45.54.72 1.28.72 2.13 0 .29-.03.55-.09.81.19.11.38.19.59.19.83 0 1.5-.9 1.5-2s-.67-2-1.5-2zm-3 1c-.83 0-1.5.9-1.5 2s.67 2 1.5 2 1.5-.9 1.5-2-.67-2-1.5-2zm4.75 3.16c-.43.51-1.02.82-1.69.84.27.38.44.84.44 1.34v.66h2v-1.66c0-.52-.31-.97-.75-1.19zm-6.5 1c-.44.22-.75.67-.75 1.19v1.66h5v-1.66c0-.52-.31-.97-.75-1.19-.45.53-1.06.84-1.75.84s-1.3-.32-1.75-.84z"
    }
  }]
};
exports.people = people;
var person = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-1.1 0-2 1.12-2 2.5s.9 2.5 2 2.5 2-1.12 2-2.5-.9-2.5-2-2.5zm-2.09 5c-1.06.05-1.91.92-1.91 2v1h8v-1c0-1.08-.84-1.95-1.91-2-.54.61-1.28 1-2.09 1-.81 0-1.55-.39-2.09-1z"
    }
  }]
};
exports.person = person;
var phone = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.19 0c-.11 0-.19.08-.19.19v7.63c0 .11.08.19.19.19h4.63c.11 0 .19-.08.19-.19v-7.63c0-.11-.08-.19-.19-.19h-4.63zm.81 1h3v5h-3v-5zm1.5 5.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z",
      "transform": "translate(1)"
    }
  }]
};
exports.phone = phone;
var pin = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.34 0a.5.5 0 0 0 .16 1h.5v2h-1c-.55 0-1 .45-1 1h3v3l.44 1 .56-1v-3h3c0-.55-.45-1-1-1h-1v-2h.5a.5.5 0 1 0 0-1h-4a.5.5 0 0 0-.09 0 .5.5 0 0 0-.06 0z"
    }
  }]
};
exports.pin = pin;
var circle = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-1 2l3 2-3 2v-4z"
    }
  }]
};
exports.circle = circle;
var plus = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v3h-3v2h3v3h2v-3h3v-2h-3v-3h-2z"
    }
  }]
};
exports.plus = plus;
var standby = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v4h1v-4h-1zm-1.28 1.44l-.38.31c-.81.64-1.34 1.64-1.34 2.75 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-1.11-.53-2.11-1.34-2.75l-.38-.31-.63.78.38.31c.58.46.97 1.17.97 1.97 0 1.39-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5c0-.8.36-1.51.94-1.97l.41-.31-.63-.78z"
    }
  }]
};
exports.standby = standby;
var print = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v2h4v-2h-4zm-1.91 3c-.06 0-.09.04-.09.09v2.81c0 .05.04.09.09.09h.91v-2h6v2h.91c.05 0 .09-.04.09-.09v-2.81c0-.06-.04-.09-.09-.09h-7.81zm1.91 2v3h4v-3h-4z"
    }
  }]
};
exports.print = print;
var project = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v7h1v-7h-1zm7 0v7h1v-7h-1zm-5 1v1h2v-1h-2zm1 2v1h2v-1h-2zm1 2v1h2v-1h-2z"
    }
  }]
};
exports.project = project;
var pulse = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.25 0l-.47 1.53-.78 2.56-.03-.06-.09-.34h-1.88v1h1.1600000000000001l.38 1.16.47 1.47.47-1.5.78-2.5.78 2.5.41 1.34.53-1.28.59-1.47.13.28h2.31v-1h-1.69l-.38-.75-.5-.97-.41 1.03-.47 1.19-.84-2.66-.47-1.53z"
    }
  }]
};
exports.pulse = pulse;
var piece = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.28 0-.54.1-.72.28-.18.18-.28.44-.28.72 0 .28.18.48.28.72.03.06.03.16.03.28h-2.31v6h2.31c0-.12-.01-.22-.03-.28-.1-.24-.28-.44-.28-.72 0-.28.1-.54.28-.72.18-.18.44-.28.72-.28.28 0 .54.1.72.28.18.18.28.44.28.72 0 .28-.18.48-.28.72-.03.06-.03.16-.03.28h2.31v-2.31c.12 0 .22.01.28.03.24.1.44.28.72.28.28 0 .54-.1.72-.28.18-.18.28-.44.28-.72 0-.28-.1-.54-.28-.72-.18-.18-.44-.28-.72-.28-.28 0-.48.18-.72.28-.06.03-.16.03-.28.03v-2.31h-2.31c0-.12.01-.22.03-.28.1-.24.28-.44.28-.72 0-.28-.1-.54-.28-.72-.18-.18-.44-.28-.72-.28z"
    }
  }]
};
exports.piece = piece;
var mark = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.47 0c-.85 0-1.48.26-1.88.66-.4.4-.54.9-.59 1.28l1 .13c.04-.25.12-.5.31-.69.19-.19.49-.38 1.16-.38.66 0 1.02.16 1.22.34.2.18.28.4.28.66 0 .83-.34 1.06-.84 1.5-.5.44-1.16 1.08-1.16 2.25v.25h1v-.25c0-.83.31-1.06.81-1.5.5-.44 1.19-1.08 1.19-2.25 0-.48-.17-1.02-.59-1.41-.43-.39-1.07-.59-1.91-.59zm-.5 7v1h1v-1h-1z",
      "transform": "translate(2)"
    }
  }]
};
exports.mark = mark;
var rain = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 0c-1.21 0-2.27.86-2.5 2-1.1 0-2 .9-2 2 0 .53.2.99.53 1.34.26-.22.6-.34.97-.34.2 0 .39.05.56.13.17-.64.74-1.13 1.44-1.13.69 0 1.27.49 1.44 1.13.17-.07.36-.13.56-.13.63 0 1.15.39 1.38.94.64-.17 1.13-.75 1.13-1.44 0-.65-.42-1.29-1-1.5v-.5c0-1.38-1.12-2.5-2.5-2.5zm-1.16 5a.5.5 0 0 0-.34.5v2a.5.5 0 1 0 1 0v-2a.5.5 0 0 0-.59-.5.5.5 0 0 0-.06 0zm-2 1a.5.5 0 0 0-.34.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.59-.5.5.5 0 0 0-.06 0zm4 0a.5.5 0 0 0-.34.5v1a.5.5 0 1 0 1 0v-1a.5.5 0 0 0-.59-.5.5.5 0 0 0-.06 0z"
    }
  }]
};
exports.rain = rain;
var random = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0v1h-.5c-.35 0-.56.1-.78.38l-1.41 1.78-1.53-1.78c-.22-.26-.44-.38-.78-.38h-1v1h1c-.05 0 .01.04.03.03l1.63 1.91-1.66 2.06h-1v1h1c.35 0 .56-.1.78-.38l1.53-1.91 1.66 1.91c.22.26.44.38.78.38h.25v1l2-1.5-2-1.5v1h-.22c-.01-.01-.05-.04-.06-.03l-1.75-2.06 1.53-1.91h.5v1l2-1.5-2-1.5z"
    }
  }]
};
exports.random = random;
var reload = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4c1.1 0 2.12-.43 2.84-1.16l-.72-.72c-.54.54-1.29.88-2.13.88-1.66 0-3-1.34-3-3s1.34-3 3-3c.83 0 1.55.36 2.09.91l-1.09 1.09h3v-3l-1.19 1.19c-.72-.72-1.71-1.19-2.81-1.19z"
    }
  }]
};
exports.reload = reload;
var both = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l1.66 1.66-4 4-1.66-1.66v4h4l-1.66-1.66 4-4 1.66 1.66v-4h-4z"
    }
  }]
};
exports.both = both;
var height = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5 0l-2.5 3h2v2h-2l2.5 3 2.5-3h-2v-2h2l-2.5-3z",
      "transform": "translate(1)"
    }
  }]
};
exports.height = height;
var width = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0l-3 2.5 3 2.5v-2h2v2l3-2.5-3-2.5v2h-2v-2z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.width = width;
var alt = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2c3.33 0 6 2.67 6 6h2c0-4.41-3.59-8-8-8zm0 3v2c1.67 0 3 1.33 3 3h2c0-2.75-2.25-5-5-5zm0 3v2h2c0-1.11-.9-2-2-2z"
    }
  }]
};
exports.alt = alt;
var rss = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 0v1c3.32 0 6 2.68 6 6h1c0-3.86-3.14-7-7-7zm0 2v1c2.21 0 4 1.79 4 4h1c0-2.76-2.24-5-5-5zm0 2v1c1.11 0 2 .89 2 2h1c0-1.65-1.35-3-3-3zm0 2c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
    }
  }]
};
exports.rss = rss;
var script = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.55 0-1 .45-1 1v5.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-1.5h-1v2c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-3h-4v-2.5c0-.28.22-.5.5-.5s.5.22.5.5v1.5h4v-2c0-.55-.45-1-1-1h-4z"
    }
  }]
};
exports.script = script;
var boxed = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.75 0c-.41 0-.75.34-.75.75v5.5c0 .41.34.75.75.75h4.5c.41 0 .75-.34.75-.75v-1.25h-1v1h-4v-5h2v-1h-2.25zm5.25 0v1c-2.05 0-3.7 1.54-3.94 3.53.21-.88.99-1.53 1.94-1.53h2v1l2-2-2-2z"
    }
  }]
};
exports.boxed = boxed;
var share = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 0v2c-4 0-5 2.05-5 5 .52-1.98 2-3 4-3h1v2l3-3.16-3-2.84z"
    }
  }]
};
exports.share = share;
var shield = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-.19.09-3.5 1.47-.31.13v.31c0 1.66.67 3.12 1.47 4.19.4.53.83.97 1.25 1.28.42.31.83.53 1.28.53.46 0 .86-.22 1.28-.53.42-.31.85-.75 1.25-1.28.8-1.07 1.47-2.53 1.47-4.19v-.31l-.31-.13-3.5-1.47-.19-.09zm0 1.09v5.91c-.04 0-.33-.07-.66-.31s-.71-.63-1.06-1.09c-.64-.85-1.14-2.03-1.22-3.28l2.94-1.22z"
    }
  }]
};
exports.shield = shield;
var signal = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0v8h1v-8h-1zm-2 1v7h1v-7h-1zm-2 2v5h1v-5h-1zm-2 2v3h1v-3h-1z"
    }
  }]
};
exports.signal = signal;
var signpost = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0v1h-2l-1 1 1 1h2v5h1v-4h2l1-1-1-1h-2v-2h-1z"
    }
  }]
};
exports.signpost = signpost;
var ascending = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v6h-2l2.5 2 2.5-2h-2v-6h-1zm2 0v1h2v-1h-2zm0 2v1h3v-1h-3zm0 2v1h4v-1h-4z"
    }
  }]
};
exports.ascending = ascending;
var descending = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v6h-2l2.5 2 2.5-2h-2v-6h-1zm2 0v1h4v-1h-4zm0 2v1h3v-1h-3zm0 2v1h2v-1h-2z"
    }
  }]
};
exports.descending = descending;
var spreadsheet = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.75 0c-.41 0-.75.34-.75.75v5.5c0 .41.34.75.75.75h6.5c.41 0 .75-.34.75-.75v-5.5c0-.41-.34-.75-.75-.75h-6.5zm.25 1h1v1h-1v-1zm2 0h4v1h-4v-1zm-2 2h1v1h-1v-1zm2 0h4v1h-4v-1zm-2 2h1v1h-1v-1zm2 0h4v1h-4v-1z"
    }
  }]
};
exports.spreadsheet = spreadsheet;
var star = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0l-1 3h-3l2.5 2-1 3 2.5-2 2.5 2-1-3 2.5-2h-3l-1-3z"
    }
  }]
};
exports.star = star;
var sun = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-2.5 1c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm5 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-2.5 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-3.5 1.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-6 2.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm5 0c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-2.5 1c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
    }
  }]
};
exports.sun = sun;
var tablet = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.34 0c-.18 0-.34.16-.34.34v7.31c0 .18.16.34.34.34h6.31c.18 0 .34-.16.34-.34v-7.31c0-.18-.16-.34-.34-.34h-6.31zm.66 1h5v5h-5v-5zm2.5 5.5c.38 0 .63.42.44.75s-.68.33-.88 0c-.19-.33.05-.75.44-.75z"
    }
  }]
};
exports.tablet = tablet;
var tag = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v3l5 5 3-3-5-5h-3zm2 1c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1z"
    }
  }]
};
exports.tag = tag;
var tags = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2l3 3 1.5-1.5.5-.5-2-2-1-1h-2zm3.41 0l3 3-1.19 1.22.78.78 2-2-3-3h-1.59zm-1.91 1c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.tags = tags;
var target = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 0c-2.2 0-4 1.8-4 4s1.8 4 4 4 4-1.8 4-4-1.8-4-4-4zm0 1c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 1c.56 0 1 .44 1 1s-.44 1-1 1-1-.44-1-1 .44-1 1-1z"
    }
  }]
};
exports.target = target;
var task = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v7h7v-3.59l-1 1v1.59h-5v-5h3.59l1-1h-5.59zm7 0l-3 3-1-1-1 1 2 2 4-4-1-1z"
    }
  }]
};
exports.task = task;
var terminal = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v7.81c0 .05.04.09.09.09h7.81c.05 0 .09-.04.09-.09v-7.81c0-.06-.04-.09-.09-.09h-7.81zm1.41.78l1.72 1.72-1.72 1.72-.72-.72 1-1-1-1 .72-.72zm2.5 2.22h3v1h-3v-1z"
    }
  }]
};
exports.terminal = terminal;
var text = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v2h.5c0-.55.45-1 1-1h1.5v5.5c0 .28-.22.5-.5.5h-.5v1h4v-1h-.5c-.28 0-.5-.22-.5-.5v-5.5h1.5c.55 0 1 .45 1 1h.5v-2h-8z"
    }
  }]
};
exports.text = text;
var timer = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 0v1h1v.03c-1.7.24-3 1.71-3 3.47 0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5c0-.45-.1-.87-.25-1.25l-.91.38c.11.29.16.57.16.88 0 1.39-1.11 2.5-2.5 2.5s-2.5-1.11-2.5-2.5 1.11-2.5 2.5-2.5c.3 0 .59.05.88.16l.34-.94c-.23-.08-.47-.12-.72-.16v-.06h1v-1h-3zm5 1.16s-3.65 2.81-3.84 3c-.19.2-.19.49 0 .69.19.2.49.2.69 0 .2-.2 3.16-3.69 3.16-3.69z"
    }
  }]
};
exports.timer = timer;
var transfer = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 0v1h-6v1h6v1l2-1.5-2-1.5zm-4 4l-2 1.5 2 1.5v-1h6v-1h-6v-1z"
    }
  }]
};
exports.transfer = transfer;
var trash = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 0c-.55 0-1 .45-1 1h-1c-.55 0-1 .45-1 1h7c0-.55-.45-1-1-1h-1c0-.55-.45-1-1-1h-1zm-2 3v4.81c0 .11.08.19.19.19h4.63c.11 0 .19-.08.19-.19v-4.81h-1v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3.5h-1v3.5c0 .28-.22.5-.5.5s-.5-.22-.5-.5v-3.5h-1z"
    }
  }]
};
exports.trash = trash;
var underline = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 0v4c0 1.1 1.12 2 2.5 2h.5c1.1 0 2-.9 2-2v-4h-1v4c0 .55-.45 1-1 1s-1-.45-1-1v-4h-2zm-1 7v1h7v-1h-7z"
    }
  }]
};
exports.underline = underline;
var alignBottom = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v4.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-4.81c0-.06-.04-.09-.09-.09h-1.81zm6 0c-.05 0-.09.04-.09.09v4.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-4.81c0-.06-.04-.09-.09-.09h-1.81zm-3 2c-.06 0-.09.04-.09.09v2.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-2.81c0-.06-.04-.09-.09-.09h-1.81zm-3.09 4v1h8v-1h-8z"
    }
  }]
};
exports.alignBottom = alignBottom;
var alignCenter = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.09 0c-.06 0-.09.04-.09.09v1.91h2v-1.91c0-.06-.04-.09-.09-.09h-1.81zm6 0c-.05 0-.09.04-.09.09v1.91h2v-1.91c0-.06-.04-.09-.09-.09h-1.81zm-3 1c-.06 0-.09.04-.09.09v.91h2v-.91c0-.05-.04-.09-.09-.09h-1.81zm-3.09 2v1h8v-1h-8zm0 2v1.91c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-1.91h-2zm3 0v.91c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-.91h-2zm3 0v1.91c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-1.91h-2z"
    }
  }]
};
exports.alignCenter = alignCenter;
var alignTop = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0v1h8v-1h-8zm.09 2c-.06 0-.09.04-.09.09v4.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-4.81c0-.06-.04-.09-.09-.09h-1.81zm3 0c-.06 0-.09.04-.09.09v2.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-2.81c0-.06-.04-.09-.09-.09h-1.81zm3 0c-.05 0-.09.04-.09.09v4.81c0 .05.04.09.09.09h1.81c.05 0 .09-.04.09-.09v-4.81c0-.06-.04-.09-.09-.09h-1.81z"
    }
  }]
};
exports.alignTop = alignTop;
var video = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M.5 0c-.28 0-.5.23-.5.5v4c0 .28.23.5.5.5h5c.28 0 .5-.22.5-.5v-1.5l1 1h1v-3h-1l-1 1v-1.5c0-.28-.22-.5-.5-.5h-5z",
      "transform": "translate(0 1)"
    }
  }]
};
exports.video = video;
var high = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.34 0l-1.34 2h-2v4h2l1.34 2h.66v-8h-.66zm1.66 1v1c.17 0 .34.02.5.06.86.22 1.5 1 1.5 1.94s-.63 1.72-1.5 1.94c-.16.04-.33.06-.5.06v1c.25 0 .48-.04.72-.09h.03c1.3-.33 2.25-1.51 2.25-2.91 0-1.4-.95-2.58-2.25-2.91-.23-.06-.49-.09-.75-.09zm0 2v2c.09 0 .18-.01.25-.03.43-.11.75-.51.75-.97 0-.46-.31-.86-.75-.97-.08-.02-.17-.03-.25-.03z"
    }
  }]
};
exports.high = high;
var low = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.34 0l-1.34 2h-2v4h2l1.34 2h.66v-8h-.66zm1.66 3v2c.09 0 .18-.01.25-.03.43-.11.75-.51.75-.97 0-.46-.31-.86-.75-.97-.08-.02-.17-.03-.25-.03z",
      "transform": "translate(1)"
    }
  }]
};
exports.low = low;
var off = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.34 0l-1.34 2h-2v4h2l1.34 2h.66v-8h-.66z",
      "transform": "translate(2)"
    }
  }]
};
exports.off = off;
var warning = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.09 0c-.06 0-.1.04-.13.09l-2.94 6.81c-.02.05-.03.13-.03.19v.81c0 .05.04.09.09.09h6.81c.05 0 .09-.04.09-.09v-.81c0-.05-.01-.14-.03-.19l-2.94-6.81c-.02-.05-.07-.09-.13-.09h-.81zm-.09 3h1v2h-1v-2zm0 3h1v1h-1v-1z"
    }
  }]
};
exports.warning = warning;
var wifi = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.75 0c-1.38 0-2.66.4-3.75 1.09l.53.81c.93-.59 2.03-.91 3.22-.91 1.2 0 2.32.31 3.25.91l.53-.81c-1.09-.7-2.4-1.09-3.78-1.09zm0 3c-.79 0-1.5.23-2.13.63l.53.84c.47-.3 1-.47 1.59-.47.59 0 1.16.17 1.63.47l.53-.84c-.62-.39-1.37-.63-2.16-.63zm0 3c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
    }
  }]
};
exports.wifi = wifi;
var wrench = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.5 0c-1.38 0-2.5 1.12-2.5 2.5 0 .32.08.62.19.91l-2.91 2.88c-.39.39-.39 1.05 0 1.44.2.2.46.28.72.28.26 0 .52-.09.72-.28l2.88-2.91c.28.11.58.19.91.19 1.38 0 2.5-1.12 2.5-2.5 0-.16 0-.32-.03-.47l-.97.97h-2v-2l.97-.97c-.15-.03-.31-.03-.47-.03zm-4.5 6.5c.28 0 .5.22.5.5s-.22.5-.5.5-.5-.22-.5-.5.22-.5.5-.5z"
    }
  }]
};
exports.wrench = wrench;
var yen = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 0l2.25 3h-2.25v1h3v1h-3v1h3v2h1v-2h3v-1h-3v-1h3v-1h-2.25l2.25-3h-1l-2.31 3h-.38l-2.31-3h-1z"
    }
  }]
};
exports.yen = yen;
var inIconic = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5c.61 0 1.19-.16 1.69-.44a1 1 0 0 0 .09.13l1 1.03a1.02 1.02 0 1 0 1.44-1.44l-1.03-1a1 1 0 0 0-.13-.09c.27-.5.44-1.08.44-1.69 0-1.93-1.57-3.5-3.5-3.5zm0 1c1.39 0 2.5 1.11 2.5 2.5 0 .59-.2 1.14-.53 1.56-.01.01-.02.02-.03.03a1 1 0 0 0-.06.03 1 1 0 0 0-.25.28c-.44.37-1.01.59-1.63.59-1.39 0-2.5-1.11-2.5-2.5s1.11-2.5 2.5-2.5zm-.5 1v1h-1v1h1v1h1v-1h1v-1h-1v-1h-1z"
    }
  }]
};
exports.inIconic = inIconic;
var out = {
  "viewBox": "0 0 8 8",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 0c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5c.61 0 1.19-.16 1.69-.44a1 1 0 0 0 .09.13l1 1.03a1.02 1.02 0 1 0 1.44-1.44l-1.03-1a1 1 0 0 0-.13-.09c.27-.5.44-1.08.44-1.69 0-1.93-1.57-3.5-3.5-3.5zm0 1c1.39 0 2.5 1.11 2.5 2.5 0 .59-.2 1.14-.53 1.56-.01.01-.02.02-.03.03a1 1 0 0 0-.06.03 1 1 0 0 0-.25.28c-.44.37-1.01.59-1.63.59-1.39 0-2.5-1.11-2.5-2.5s1.11-2.5 2.5-2.5zm-1.5 2v1h3v-1h-3z"
    }
  }]
};
exports.out = out;

/***/ }),
/* 1406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.drive = exports.floppyDisk = exports.upload = exports.download = exports.boxRemove = exports.boxAdd = exports.drawer2 = exports.drawer = exports.tv = exports.tablet = exports.mobile2 = exports.mobile = exports.laptop = exports.display = exports.keyboard = exports.printer = exports.calendar = exports.stopwatch = exports.bell = exports.alarm = exports.clock2 = exports.clock = exports.history = exports.map2 = exports.map = exports.compass2 = exports.compass = exports.location2 = exports.location = exports.pushpin = exports.envelop = exports.addressBook = exports.phoneHangUp = exports.phone = exports.lifebuoy = exports.calculator = exports.creditCard = exports.coinYen = exports.coinPound = exports.coinEuro = exports.coinDollar = exports.cart = exports.ticket = exports.qrcode = exports.barcode = exports.priceTags = exports.priceTag = exports.folderUpload = exports.folderDownload = exports.folderMinus = exports.folderPlus = exports.folderOpen = exports.folder = exports.stack = exports.paste = exports.copy = exports.fileZip = exports.fileVideo = exports.filePlay = exports.fileMusic = exports.filePicture = exports.fileText2 = exports.filesEmpty = exports.fileEmpty = exports.profile = exports.fileText = exports.library = exports.books = exports.book = exports.mic = exports.feed = exports.podcast = exports.connection = exports.bullhorn = exports.diamonds = exports.clubs = exports.spades = exports.pacman = exports.dice = exports.videoCamera = exports.film = exports.play = exports.music = exports.headphones = exports.camera = exports.images = exports.image = exports.paintFormat = exports.droplet = exports.eyedropper = exports.blog = exports.pen = exports.quill = exports.pencil2 = exports.pencil = exports.newspaper = exports.office = exports.home3 = exports.home2 = exports.home = void 0;
exports.download3 = exports.upload2 = exports.download2 = exports.cloudCheck = exports.cloudUpload = exports.cloudDownload = exports.cloud = exports.menu4 = exports.menu3 = exports.menu2 = exports.menu = exports.tree = exports.list2 = exports.list = exports.listNumbered = exports.clipboard = exports.powerCord = exports.switchIcon = exports.power = exports.shield = exports.target = exports.accessibility = exports.road = exports.truck = exports.airplane = exports.briefcase = exports.bin2 = exports.bin = exports.magnet = exports.lab = exports.fire = exports.hammer2 = exports.meter2 = exports.meter = exports.rocket = exports.leaf = exports.spoonKnife = exports.mug = exports.glass2 = exports.glass = exports.gift = exports.trophy = exports.statsBars2 = exports.statsBars = exports.statsDots = exports.pieChart = exports.bug = exports.aidKit = exports.magicWand = exports.hammer = exports.cogs = exports.cog = exports.equalizer2 = exports.equalizer = exports.wrench = exports.unlocked = exports.lock = exports.key2 = exports.key = exports.shrink2 = exports.enlarge2 = exports.shrink = exports.enlarge = exports.zoomOut = exports.zoomIn = exports.search = exports.binoculars = exports.spinner11 = exports.spinner10 = exports.spinner9 = exports.spinner8 = exports.spinner7 = exports.spinner6 = exports.spinner5 = exports.spinner4 = exports.spinner3 = exports.spinner2 = exports.spinner = exports.hourGlass = exports.quotesRight = exports.quotesLeft = exports.userTie = exports.userCheck = exports.userMinus = exports.userPlus = exports.users = exports.user = exports.bubbles4 = exports.bubbles3 = exports.bubble2 = exports.bubbles2 = exports.bubbles = exports.bubble = exports.reply = exports.forward = exports.redo2 = exports.undo2 = exports.redo = exports.undo = exports.database = void 0;
exports.volumeIncrease = exports.volumeMute2 = exports.volumeMute = exports.volumeLow = exports.volumeMedium = exports.volumeHigh = exports.eject = exports.next2 = exports.previous2 = exports.last = exports.first = exports.forward3 = exports.backward2 = exports.stop2 = exports.pause2 = exports.play3 = exports.forward2 = exports.backward = exports.next = exports.previous = exports.stop = exports.pause = exports.play2 = exports.exit = exports.enter = exports.spellCheck = exports.checkmark2 = exports.checkmark = exports.cross = exports.blocked = exports.cancelCircle = exports.info = exports.minus = exports.plus = exports.question = exports.notification = exports.warning = exports.pointLeft = exports.pointDown = exports.pointRight = exports.pointUp = exports.crying2 = exports.crying = exports.frustrated2 = exports.frustrated = exports.sleepy2 = exports.sleepy = exports.wondering2 = exports.wondering = exports.hipster2 = exports.hipster = exports.neutral2 = exports.neutral = exports.confused2 = exports.confused = exports.baffled2 = exports.baffled = exports.shocked2 = exports.shocked = exports.evil2 = exports.evil = exports.angry2 = exports.angry = exports.cool2 = exports.cool = exports.grin2 = exports.grin = exports.wink2 = exports.wink = exports.sad2 = exports.sad = exports.tongue2 = exports.tongue = exports.smile2 = exports.smile = exports.happy2 = exports.happy = exports.manWoman = exports.woman = exports.man = exports.heartBroken = exports.heart = exports.starFull = exports.starHalf = exports.starEmpty = exports.brightnessContrast = exports.contrast = exports.sun = exports.bookmarks = exports.bookmark = exports.eyeBlocked = exports.eyeMinus = exports.eyePlus = exports.eye = exports.attachment = exports.flag = exports.link = exports.earth = exports.sphere = exports.upload3 = void 0;
exports.googleDrive = exports.hangouts = exports.googlePlus3 = exports.googlePlus2 = exports.googlePlus = exports.google3 = exports.google2 = exports.google = exports.amazon = exports.mail4 = exports.mail3 = exports.mail2 = exports.mail = exports.share2 = exports.terminal = exports.embed2 = exports.embed = exports.newTab = exports.share = exports.indentDecrease = exports.indentIncrease = exports.paragraphJustify = exports.paragraphRight = exports.paragraphCenter = exports.paragraphLeft = exports.section = exports.rtl = exports.ltr = exports.pilcrow = exports.insertTemplate = exports.table2 = exports.table = exports.clearFormatting = exports.pagebreak = exports.textColor = exports.subscript2 = exports.superscript2 = exports.subscript = exports.superscript = exports.pageBreak = exports.sigma = exports.omega = exports.strikethrough = exports.italic = exports.underline = exports.bold = exports.fontSize = exports.textWidth = exports.textHeight = exports.ligature2 = exports.ligature = exports.font = exports.filter = exports.scissors = exports.ungroup = exports.makeGroup = exports.crop = exports.radioUnchecked = exports.radioChecked2 = exports.radioChecked = exports.checkboxUnchecked = exports.checkboxChecked = exports.opt = exports.ctrl = exports.shift = exports.command = exports.sortAmountDesc = exports.sortAmountAsc = exports.sortNumbericDesc = exports.sortNumericAsc = exports.sortAlphaDesc = exports.sortAlphaAsc = exports.moveDown = exports.moveUp = exports.tab = exports.circleLeft = exports.circleDown = exports.circleRight = exports.circleUp = exports.arrowLeft2 = exports.arrowDownLeft2 = exports.arrowDown2 = exports.arrowDownRight2 = exports.arrowRight2 = exports.arrowUpRight2 = exports.arrowUp2 = exports.arrowUpLeft2 = exports.arrowLeft = exports.arrowDownLeft = exports.arrowDown = exports.arrowDownRight = exports.arrowRight = exports.arrowUpRight = exports.arrowUp = exports.arrowUpLeft = exports.shuffle = exports.infinite = exports.loop2 = exports.loop = exports.volumeDecrease = void 0;
exports.IcoMoon = exports.svg = exports.codepen = exports.git = exports.css3 = exports.htmlFive2 = exports.htmlFive = exports.libreoffice = exports.fileExcel = exports.fileWord = exports.fileOpenoffice = exports.filePdf = exports.opera = exports.safari = exports.edge = exports.IE = exports.firefox = exports.chrome = exports.paypal = exports.yelp = exports.foursquare = exports.flattr = exports.xing2 = exports.xing = exports.pinterest2 = exports.pinterest = exports.stackoverflow = exports.stumbleupon2 = exports.stumbleupon = exports.delicious = exports.lastfm2 = exports.lastfm = exports.linkedin2 = exports.linkedin = exports.wikipedia = exports.hackernews = exports.reddit = exports.skype = exports.soundcloud2 = exports.soundcloud = exports.windows8 = exports.windows = exports.android = exports.finder = exports.appleinc = exports.tux = exports.yahoo2 = exports.yahoo = exports.tumblr2 = exports.tumblr = exports.blogger2 = exports.blogger = exports.ello = exports.joomla = exports.wordpress = exports.trello = exports.basecamp = exports.npm = exports.github = exports.onedrive = exports.dropbox = exports.steam2 = exports.steam = exports.fiveHundredPX = exports.deviantart = exports.behance2 = exports.behance = exports.dribbble = exports.flickr4 = exports.flickr3 = exports.flickr2 = exports.flickr = exports.lanyrd = exports.vimeo2 = exports.vimeo = exports.twitch = exports.youtube2 = exports.youtube = exports.rss2 = exports.rss = exports.sinaWeibo = exports.renren = exports.vk = exports.vine = exports.twitter = exports.telegram = exports.spotify = exports.whatsapp = exports.instagram = exports.facebook2 = exports.facebook = void 0;
var home = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9.226l-8-6.21-8 6.21v-2.532l8-6.21 8 6.21zM14 9v6h-4v-4h-4v4h-4v-6l6-4.5z"
    }
  }]
};
exports.home = home;
var home2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0.5l-8 8 1.5 1.5 1.5-1.5v6.5h4v-3h2v3h4v-6.5l1.5 1.5 1.5-1.5-8-8zM8 7c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1z"
    }
  }]
};
exports.home2 = home2;
var home3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9.5l-3-3v-4.5h-2v2.5l-3-3-8 8v0.5h2v5h5v-3h2v3h5v-5h2z"
    }
  }]
};
exports.home3 = home3;
var office = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 16h8v-16h-8v16zM5 2h2v2h-2v-2zM5 6h2v2h-2v-2zM5 10h2v2h-2v-2zM1 2h2v2h-2v-2zM1 6h2v2h-2v-2zM1 10h2v2h-2v-2zM9 5h7v1h-7zM9 16h2v-4h3v4h2v-9h-7z"
    }
  }]
};
exports.office = office;
var newspaper = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 4v-2h-14v11c0 0.552 0.448 1 1 1h13.5c0.828 0 1.5-0.672 1.5-1.5v-8.5h-2zM13 13h-12v-10h12v10zM2 5h10v1h-10zM8 7h4v1h-4zM8 9h4v1h-4zM8 11h3v1h-3zM2 7h5v5h-5z"
    }
  }]
};
exports.newspaper = newspaper;
var pencil = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 0c1.381 0 2.5 1.119 2.5 2.5 0 0.563-0.186 1.082-0.5 1.5l-1 1-3.5-3.5 1-1c0.418-0.314 0.937-0.5 1.5-0.5zM1 11.5l-1 4.5 4.5-1 9.25-9.25-3.5-3.5-9.25 9.25zM11.181 5.681l-7 7-0.862-0.862 7-7 0.862 0.862z"
    }
  }]
};
exports.pencil = pencil;
var pencil2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 10l2-1 7-7-1-1-7 7-1 2zM4.52 13.548c-0.494-1.043-1.026-1.574-2.069-2.069l1.548-4.262 2-1.217 6-6h-3l-6 6-3 10 10-3 6-6v-3l-6 6-1.217 2z"
    }
  }]
};
exports.pencil2 = pencil2;
var quill = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 16c2-6 7.234-16 16-16-4.109 3.297-6 11-9 11s-3 0-3 0l-3 5h-1z"
    }
  }]
};
exports.quill = quill;
var pen = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.909 4.561l-4.47-4.47c-0.146-0.146-0.338-0.113-0.427 0.073l-0.599 1.248 4.175 4.175 1.248-0.599c0.186-0.089 0.219-0.282 0.073-0.427z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.615 2.115l-4.115 0.343c-0.273 0.034-0.501 0.092-0.58 0.449-0 0-0 0.001-0 0.001-1.116 5.36-4.92 10.591-4.92 10.591l0.896 0.896 4.25-4.25c-0.094-0.196-0.146-0.415-0.146-0.647 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5c-0.232 0-0.451-0.053-0.647-0.146l-4.25 4.25 0.896 0.896c0 0 5.231-3.804 10.591-4.92 0-0 0.001-0 0.001-0 0.357-0.078 0.415-0.306 0.449-0.58l0.343-4.115-4.269-4.269z"
    }
  }]
};
exports.pen = pen;
var blog = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 0v1.5c1.148 0 2.261 0.225 3.308 0.667 1.012 0.428 1.921 1.041 2.702 1.822s1.394 1.69 1.822 2.702c0.443 1.047 0.667 2.16 0.667 3.308h1.5c0-5.523-4.477-10-10-10z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 3v1.5c1.469 0 2.85 0.572 3.889 1.611s1.611 2.42 1.611 3.889h1.5c0-3.866-3.134-7-7-7z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 6l-1 1-3.5 1-3 6.5 0.396 0.396 3.638-3.638c-0.022-0.083-0.034-0.169-0.034-0.259 0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1c-0.090 0-0.176-0.012-0.259-0.034l-3.638 3.638 0.396 0.396 6.5-3 1-3.5 1-1-2.5-2.5z"
    }
  }]
};
exports.blog = blog;
var eyedropper = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.414 0.586c-0.781-0.781-2.047-0.781-2.828 0l-2.689 2.689-1.896-1.896-2.121 2.121 1.663 1.663-7.377 7.377c-0.126 0.126-0.179 0.296-0.161 0.46h-0.004v2.5c0 0.276 0.224 0.5 0.5 0.5h2.5c0 0 0.042 0 0.063 0 0.144 0 0.288-0.055 0.398-0.165l7.377-7.377 1.663 1.663 2.121-2.121-1.896-1.896 2.689-2.689c0.781-0.781 0.781-2.047 0-2.828zM2.705 15h-1.705v-1.705l7.337-7.337 1.704 1.704-7.337 7.337z"
    }
  }]
};
exports.eyedropper = eyedropper;
var droplet = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.51 7.393c-1.027-2.866-3.205-5.44-5.51-7.393-2.305 1.953-4.482 4.527-5.51 7.393-0.635 1.772-0.698 3.696 0.197 5.397 1.029 1.955 3.104 3.21 5.313 3.21s4.284-1.255 5.313-3.21c0.895-1.701 0.832-3.624 0.197-5.397zM11.543 11.859c-0.684 1.301-2.075 2.141-3.543 2.141-0.861 0-1.696-0.29-2.377-0.791 0.207 0.027 0.416 0.041 0.627 0.041 1.835 0 3.573-1.050 4.428-2.676 0.701-1.333 0.64-2.716 0.373-3.818 0.227 0.44 0.42 0.878 0.576 1.311 0.353 0.985 0.625 2.443-0.084 3.791z"
    }
  }]
};
exports.droplet = droplet;
var paintFormat = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9v-6h-3v-1c0-0.55-0.45-1-1-1h-11c-0.55 0-1 0.45-1 1v3c0 0.55 0.45 1 1 1h11c0.55 0 1-0.45 1-1v-1h2v4h-9v2h-0.5c-0.276 0-0.5 0.224-0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5h2c0.276 0 0.5-0.224 0.5-0.5v-5c0-0.276-0.224-0.5-0.5-0.5h-0.5v-1h9zM12 3h-11v-1h11v1z"
    }
  }]
};
exports.paintFormat = paintFormat;
var image = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.998 2c0.001 0.001 0.001 0.001 0.002 0.002v11.996c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996zM15 1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 4.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 13h-12v-2l3.5-6 4 5h1l3.5-3z"
    }
  }]
};
exports.image = image;
var images = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M17 2h-1v-1c0-0.55-0.45-1-1-1h-14c-0.55 0-1 0.45-1 1v12c0 0.55 0.45 1 1 1h1v1c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-12c0-0.55-0.45-1-1-1zM2 3v10h-0.998c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-12c-0.55 0-1 0.45-1 1v0zM17 14.998c-0.001 0.001-0.001 0.001-0.002 0.002h-13.996c-0.001-0.001-0.001-0.001-0.002-0.002v-11.996c0.001-0.001 0.001-0.001 0.002-0.002h13.996c0.001 0.001 0.001 0.001 0.002 0.002v11.996z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 5.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 14h-12v-2l3.5-6 4 5h1l3.5-3z"
    }
  }]
};
exports.images = images;
var camera = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.75 9.5c0 1.795 1.455 3.25 3.25 3.25s3.25-1.455 3.25-3.25-1.455-3.25-3.25-3.25-3.25 1.455-3.25 3.25zM15 4h-3.5c-0.25-1-0.5-2-1.5-2h-4c-1 0-1.25 1-1.5 2h-3.5c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM8 13.938c-2.451 0-4.438-1.987-4.438-4.438s1.987-4.438 4.438-4.438c2.451 0 4.438 1.987 4.438 4.438s-1.987 4.438-4.438 4.438zM15 7h-2v-1h2v1z"
    }
  }]
};
exports.camera = camera;
var headphones = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 9h-1v7h1c0.275 0 0.5-0.225 0.5-0.5v-6c0-0.275-0.225-0.5-0.5-0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 9c-0.275 0-0.5 0.225-0.5 0.5v6c0 0.275 0.225 0.5 0.5 0.5h1v-7h-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 0.96 0.169 1.88 0.479 2.732-0.304 0.519-0.479 1.123-0.479 1.768 0 1.763 1.304 3.222 3 3.464v-6.928c-0.499 0.071-0.963 0.248-1.371 0.506-0.084-0.417-0.129-0.849-0.129-1.292 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 0.442-0.044 0.874-0.128 1.292-0.408-0.259-0.873-0.435-1.372-0.507v6.929c1.696-0.243 3-1.701 3-3.464 0-0.645-0.175-1.249-0.479-1.768 0.31-0.853 0.479-1.773 0.479-2.732z"
    }
  }]
};
exports.headphones = headphones;
var music = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 0h1v11.5c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-5.751l-8 1.778v7.722c0 1.381-1.567 2.5-3.5 2.5s-3.5-1.119-3.5-2.5c0-1.381 1.567-2.5 3.5-2.5 0.979 0 1.865 0.287 2.5 0.751v-9.751l9-2z"
    }
  }]
};
exports.music = music;
var play = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.331 2.502c-2.244-0.323-4.724-0.502-7.331-0.502s-5.087 0.179-7.331 0.502c-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM6 11v-6l5 3-5 3z"
    }
  }]
};
exports.play = play;
var film = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 2v12h16v-12h-16zM3 13h-2v-2h2v2zM3 9h-2v-2h2v2zM3 5h-2v-2h2v2zM12 13h-8v-10h8v10zM15 13h-2v-2h2v2zM15 9h-2v-2h2v2zM15 5h-2v-2h2v2zM6 5v6l4-3z"
    }
  }]
};
exports.film = film;
var videoCamera = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM0 4.5c0-1.381 1.119-2.5 2.5-2.5s2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5s-2.5-1.119-2.5-2.5zM12 9.5v-1.5c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1v-1.5l4 2.5v-7l-4 2.5zM10 12h-8v-3h8v3z"
    }
  }]
};
exports.videoCamera = videoCamera;
var dice = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 3h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.375 1.125 2.5 2.5 2.5h8c1.375 0 2.5-1.125 2.5-2.5v-8c0-1.375-1.125-2.5-2.5-2.5zM6.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM6.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM9.5 11c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 14c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5zM12.949 2c-0.233-1.138-1.245-2-2.449-2h-8c-1.375 0-2.5 1.125-2.5 2.5v8c0 1.204 0.862 2.216 2 2.449v-9.949c0-0.55 0.45-1 1-1h9.949z"
    }
  }]
};
exports.dice = dice;
var pacman = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.074 2.794c-1.467-1.71-3.644-2.794-6.074-2.794-4.418 0-8 3.582-8 8s3.582 8 8 8c2.43 0 4.607-1.084 6.074-2.794l-5.074-5.206 5.074-5.206zM11 1.884c0.616 0 1.116 0.499 1.116 1.116s-0.499 1.116-1.116 1.116-1.116-0.499-1.116-1.116c0-0.616 0.499-1.116 1.116-1.116z"
    }
  }]
};
exports.pacman = pacman;
var spades = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.775 5.44c-3.024-2.248-4.067-4.047-4.774-5.44v0c-0 0-0-0-0-0v0c-0.708 1.393-1.75 3.192-4.774 5.44-5.157 3.833-0.303 9.182 3.965 6.238-0.278 1.827-1.227 3.159-2.191 3.733v0.59h6v-0.59c-0.964-0.574-1.913-1.906-2.191-3.733 4.268 2.944 9.122-2.405 3.965-6.238z"
    }
  }]
};
exports.spades = spades;
var clubs = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.294 6.137c-0.922 0-1.751 0.384-2.341 1.011-0.25 0.265-0.684 0.58-1.153 0.856 0.22-0.842 0.917-1.902 1.4-2.367 0.619-0.596 1-1.435 1-2.367 0-1.795-1.429-3.252-3.2-3.271-1.771 0.019-3.2 1.475-3.2 3.271 0 0.932 0.38 1.771 1 2.367 0.484 0.465 1.18 1.525 1.4 2.367-0.469-0.277-0.903-0.591-1.153-0.856-0.59-0.627-1.419-1.011-2.341-1.011-1.787 0-3.236 1.463-3.236 3.271s1.448 3.271 3.236 3.271c0.923 0 1.751-0.396 2.341-1.023 0.263-0.279 0.726-0.627 1.223-0.916-0.047 2.308-1.149 4.003-2.271 4.67v0.59h6v-0.59c-1.122-0.668-2.224-2.363-2.271-4.67 0.498 0.289 0.961 0.637 1.223 0.916 0.59 0.626 1.419 1.023 2.341 1.023 1.787 0 3.236-1.464 3.236-3.271s-1.448-3.271-3.236-3.271z"
    }
  }]
};
exports.clubs = clubs;
var diamonds = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0l-5 8 5 8 5-8z"
    }
  }]
};
exports.diamonds = diamonds;
var bullhorn = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 6.707c0-3.139-0.919-5.687-2.054-5.707 0.005-0 0.009-0 0.014-0h-1.296c0 0-3.044 2.287-7.425 3.184-0.134 0.708-0.219 1.551-0.219 2.523s0.085 1.816 0.219 2.523c4.382 0.897 7.425 3.184 7.425 3.184h1.296c-0.005 0-0.009-0-0.014-0.001 1.136-0.020 2.054-2.567 2.054-5.707zM13.513 11.551c-0.147 0-0.305-0.152-0.387-0.243-0.197-0.22-0.387-0.562-0.55-0.989-0.363-0.957-0.564-2.239-0.564-3.611s0.2-2.655 0.564-3.611c0.162-0.428 0.353-0.77 0.55-0.99 0.081-0.091 0.24-0.243 0.387-0.243s0.305 0.152 0.387 0.243c0.197 0.22 0.387 0.562 0.55 0.99 0.363 0.957 0.564 2.239 0.564 3.611s-0.2 2.655-0.564 3.611c-0.162 0.428-0.353 0.77-0.55 0.989-0.081 0.091-0.24 0.243-0.387 0.243zM3.935 6.707c0-0.812 0.060-1.6 0.173-2.33-0.74 0.102-1.39 0.161-2.193 0.161-1.048 0-1.048 0-1.048 0l-0.867 1.479v1.378l0.867 1.479c0 0 0 0 1.048 0 0.803 0 1.453 0.059 2.193 0.161-0.113-0.729-0.173-1.518-0.173-2.33zM5.752 10.034l-2-0.383 1.279 5.024c0.066 0.26 0.324 0.391 0.573 0.291l1.852-0.741c0.249-0.1 0.349-0.374 0.222-0.611l-1.926-3.581zM13.513 8.574c-0.057 0-0.118-0.059-0.149-0.094-0.076-0.085-0.149-0.217-0.212-0.381-0.14-0.369-0.217-0.863-0.217-1.392s0.077-1.023 0.217-1.392c0.063-0.165 0.136-0.297 0.212-0.381 0.031-0.035 0.092-0.094 0.149-0.094s0.118 0.059 0.149 0.094c0.076 0.085 0.149 0.217 0.212 0.381 0.14 0.369 0.217 0.863 0.217 1.392s-0.077 1.023-0.217 1.392c-0.063 0.165-0.136 0.297-0.212 0.381-0.031 0.035-0.092 0.094-0.149 0.094z"
    }
  }]
};
exports.bullhorn = bullhorn;
var connection = {
  "viewBox": "0 0 20 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 9c1.654 0 3.154 0.673 4.241 1.759l-1.414 1.414c-0.724-0.724-1.724-1.173-2.827-1.173s-2.103 0.449-2.827 1.173l-1.414-1.414c1.086-1.086 2.586-1.759 4.241-1.759zM2.929 7.929c1.889-1.889 4.4-2.929 7.071-2.929s5.182 1.040 7.071 2.929l-1.414 1.414c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343l-1.414-1.414zM15.45 2.101c1.667 0.705 3.164 1.715 4.45 3v0l-1.414 1.414c-2.267-2.266-5.28-3.515-8.485-3.515s-6.219 1.248-8.485 3.515l-1.414-1.414c1.285-1.285 2.783-2.295 4.45-3 1.727-0.73 3.56-1.101 5.45-1.101s3.723 0.37 5.45 1.101zM9 14c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
    }
  }]
};
exports.connection = connection;
var podcast = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8c0 3.438 2.169 6.37 5.214 7.501l-0.214 0.499h6l-0.214-0.499c3.045-1.131 5.214-4.063 5.214-7.501zM7.606 9.919c-0.356-0.153-0.606-0.507-0.606-0.919 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.412-0.25 0.766-0.606 0.919l-0.394-0.919-0.394 0.919zM8.41 9.958c0.908-0.189 1.59-0.994 1.59-1.958 0-1.105-0.895-2-2-2s-2 0.895-2 2c0 0.964 0.682 1.768 1.59 1.957l-1.166 2.721c-1.425-0.612-2.424-2.028-2.424-3.677 0-2.209 1.791-4.188 4-4.188s4 1.978 4 4.188c0 1.649-0.999 3.066-2.424 3.677l-1.166-2.72zM10.757 15.433l-1.155-2.695c1.976-0.668 3.398-2.537 3.398-4.738 0-2.761-2.239-5-5-5s-5 2.239-5 5c0 2.201 1.422 4.070 3.398 4.738l-1.155 2.695c-2.494-1.070-4.24-3.547-4.24-6.433 0-3.865 3.133-7.185 6.997-7.185s6.997 3.32 6.997 7.185c0 2.886-1.747 5.363-4.24 6.433z"
    }
  }]
};
exports.podcast = podcast;
var feed = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.38 3.602c1.56 0.846 2.62 2.498 2.62 4.398s-1.059 3.552-2.62 4.398c0.689-1.096 1.12-2.66 1.12-4.398s-0.431-3.302-1.12-4.398zM4.5 8c0 1.738 0.431 3.302 1.12 4.398-1.56-0.846-2.62-2.498-2.62-4.398s1.059-3.552 2.62-4.398c-0.689 1.096-1.12 2.66-1.12 4.398zM1.5 8c0 2.686 0.85 5.097 2.198 6.746-2.223-1.421-3.698-3.911-3.698-6.746s1.474-5.325 3.698-6.746c-1.348 1.649-2.198 4.060-2.198 6.746zM12.302 1.254c2.223 1.421 3.698 3.911 3.698 6.746s-1.474 5.325-3.698 6.746c1.348-1.649 2.198-4.060 2.198-6.746s-0.85-5.097-2.198-6.746z"
    }
  }]
};
exports.feed = feed;
var mic = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 11c1.381 0 2.5-1.119 2.5-2.5v-6c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v6c0 1.381 1.119 2.5 2.5 2.5zM11 7v1.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5v-1.5h-1v1.5c0 2.316 1.75 4.223 4 4.472v2.028h-2v1h5v-1h-2v-2.028c2.25-0.249 4-2.156 4-4.472v-1.5h-1z"
    }
  }]
};
exports.mic = mic;
var book = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 2v13h-10.5c-0.829 0-1.5-0.672-1.5-1.5s0.671-1.5 1.5-1.5h9.5v-12h-10c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12v-14h-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.501 13v0c-0 0-0.001 0-0.001 0-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0 0 0.001-0 0.001-0v0h9.498v-1h-9.498z"
    }
  }]
};
exports.book = book;
var books = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM3 5h-2v-1h2v1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM8 5h-2v-1h2v1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.954 2.773l-2.679 1.35c-0.246 0.124-0.345 0.426-0.222 0.671l4.5 8.93c0.124 0.246 0.426 0.345 0.671 0.222l2.679-1.35c0.246-0.124 0.345-0.426 0.222-0.671l-4.5-8.93c-0.124-0.246-0.426-0.345-0.671-0.222z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
    }
  }]
};
exports.books = books;
var library = {
  "viewBox": "0 0 17 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 15v-1h-1v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-3v-6h1v-1h-3v1h1v6h-1v1h-1v1h17v-1h-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0h1l8 5v1h-17v-1l8-5z"
    }
  }]
};
exports.library = library;
var fileText = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 7h7v1h-7zM4 9h7v1h-7zM4 11h7v1h-7zM4 5h7v1h-7z"
    }
  }]
};
exports.fileText = fileText;
var profile = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 0h-12c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h12c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13 14h-11v-12h11v12zM4 9h7v1h-7zM4 11h7v1h-7zM5 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM7.5 6h-2c-0.825 0-1.5 0.45-1.5 1v1h5v-1c0-0.55-0.675-1-1.5-1z"
    }
  }]
};
exports.profile = profile;
var fileEmpty = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.fileEmpty = fileEmpty;
var filesEmpty = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 5.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.689 0.561 1.25 1.25 1.25h9.5c0.689 0 1.25-0.561 1.25-1.25v-7.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 4.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-9.5c-0.136 0-0.25-0.114-0.25-0.25v-11.5c0-0.135 0.114-0.25 0.25-0.25 0 0 5.749-0 5.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v7.75z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.421 0.659c-0.806-0.591-1.197-0.659-1.421-0.659h-5.75c-0.689 0-1.25 0.561-1.25 1.25v11.5c0 0.604 0.43 1.109 1 1.225v-12.725c0-0.135 0.115-0.25 0.25-0.25h7.607c-0.151-0.124-0.297-0.238-0.437-0.341z"
    }
  }]
};
exports.filesEmpty = filesEmpty;
var fileText2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 13h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 11h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 9h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.fileText2 = fileText2;
var filePicture = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 14h-10v-2l3-5 4.109 5 2.891-2v4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 7.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.filePicture = filePicture;
var fileMusic = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.817 6.113c-0.116-0.095-0.268-0.133-0.415-0.104l-5 1c-0.234 0.047-0.402 0.252-0.402 0.49v3.701c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-3.59l4-0.8v2.091c-0.294-0.128-0.636-0.201-1-0.201-1.105 0-2 0.672-2 1.5s0.895 1.5 2 1.5 2-0.672 2-1.5v-5c0-0.15-0.067-0.292-0.183-0.387z"
    }
  }]
};
exports.fileMusic = fileMusic;
var filePlay = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 6l5 3.5-5 3.5v-7z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.filePlay = filePlay;
var fileVideo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 8h5v5h-5v-5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 10l3-2v5l-3-2z"
    }
  }]
};
exports.fileVideo = fileVideo;
var fileZip = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0 0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0 0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 1h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 2h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 3h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 4h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 5h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 6h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 7h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 8h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 13.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-1.25v-1h-2v4.25zM7 12v1h-2v-1h2z"
    }
  }]
};
exports.fileZip = fileZip;
var copy = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 4v-4h-7l-3 3v9h6v4h10v-12h-6zM3 1.414v1.586h-1.586l1.586-1.586zM1 11v-7h3v-3h5v3l-3 3v4h-5zM9 5.414v1.586h-1.586l1.586-1.586zM15 15h-8v-7h3v-3h5v10z"
    }
  }]
};
exports.copy = copy;
var paste = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 2h-2v-1c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v1h-2v2h8v-2zM8 2h-2v-0.998c0.001-0.001 0.001-0.001 0.002-0.002h1.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998zM13 5v-2.5c0-0.275-0.225-0.5-0.5-0.5h-1v1h0.5v2h-3l-3 3v4h-4v-9h0.5v-1h-1c-0.275 0-0.5 0.225-0.5 0.5v10c0 0.275 0.225 0.5 0.5 0.5h4.5v3h10v-11h-3zM9 6.414v1.586h-1.586l1.586-1.586zM15 15h-8v-6h3v-3h5v9z"
    }
  }]
};
exports.paste = paste;
var stack = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 5l-8-4-8 4 8 4 8-4zM8 2.328l5.345 2.672-5.345 2.672-5.345-2.672 5.345-2.672zM14.398 7.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199zM14.398 10.199l1.602 0.801-8 4-8-4 1.602-0.801 6.398 3.199z"
    }
  }]
};
exports.stack = stack;
var folder = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 2l2 2h7v11h-16v-13z"
    }
  }]
};
exports.folder = folder;
var folderOpen = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 15l3-8h-13l-3 8zM2 6l-2 9v-13h4.5l2 2h6.5v2z"
    }
  }]
};
exports.folderOpen = folderOpen;
var folderPlus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-2v2h-2v-2h-2v-2h2v-2h2v2h2v2z"
    }
  }]
};
exports.folderPlus = folderPlus;
var folderMinus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 4l-2-2h-7v13h16v-11h-7zM11 11h-6v-2h6v2z"
    }
  }]
};
exports.folderMinus = folderMinus;
var folderDownload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 13.5l-3.5-3.5h2.5v-4h2v4h2.5l-3.5 3.5z"
    }
  }]
};
exports.folderDownload = folderDownload;
var folderUpload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 4l-2-2h-7v13h16v-11h-7zM8 7.5l3.5 3.5h-2.5v4h-2v-4h-2.5l3.5-3.5z"
    }
  }]
};
exports.folderUpload = folderUpload;
var priceTag = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.338-0.75-0.75-0.75zM11.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
    }
  }]
};
exports.priceTag = priceTag;
var priceTags = {
  "viewBox": "0 0 20 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M19.25 0h-6c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l7.439-7.439c0.292-0.292 0.53-0.868 0.53-1.28v-6c0-0.412-0.337-0.75-0.75-0.75zM15.5 6c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 8.5l8.5-8.5h-1.25c-0.412 0-0.989 0.239-1.28 0.53l-7.439 7.439c-0.292 0.292-0.292 0.769 0 1.061l6.439 6.439c0.292 0.292 0.769 0.292 1.061 0l0.47-0.47-6.5-6.5z"
    }
  }]
};
exports.priceTags = priceTags;
var barcode = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 2h2v10h-2zM3 2h1v10h-1zM5 2h1v10h-1zM8 2h1v10h-1zM12 2h1v10h-1zM15 2h1v10h-1zM10 2h0.5v10h-0.5zM7 2h0.5v10h-0.5zM13.5 2h0.5v10h-0.5zM0 13h1v1h-1zM3 13h1v1h-1zM5 13h1v1h-1zM10 13h1v1h-1zM15 13h1v1h-1zM12 13h2v1h-2zM7 13h2v1h-2z"
    }
  }]
};
exports.barcode = barcode;
var qrcode = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 1h-4v4h4v-4zM6 0v0 6h-6v-6h6zM2 2h2v2h-2zM15 1h-4v4h4v-4zM16 0v0 6h-6v-6h6zM12 2h2v2h-2zM5 11h-4v4h4v-4zM6 10v0 6h-6v-6h6zM2 12h2v2h-2zM7 0h1v1h-1zM8 1h1v1h-1zM7 2h1v1h-1zM8 3h1v1h-1zM7 4h1v1h-1zM8 5h1v1h-1zM7 6h1v1h-1zM7 8h1v1h-1zM8 9h1v1h-1zM7 10h1v1h-1zM8 11h1v1h-1zM7 12h1v1h-1zM8 13h1v1h-1zM7 14h1v1h-1zM8 15h1v1h-1zM15 8h1v1h-1zM1 8h1v1h-1zM2 7h1v1h-1zM0 7h1v1h-1zM4 7h1v1h-1zM5 8h1v1h-1zM6 7h1v1h-1zM9 8h1v1h-1zM10 7h1v1h-1zM11 8h1v1h-1zM12 7h1v1h-1zM13 8h1v1h-1zM14 7h1v1h-1zM15 10h1v1h-1zM9 10h1v1h-1zM10 9h1v1h-1zM11 10h1v1h-1zM13 10h1v1h-1zM14 9h1v1h-1zM15 12h1v1h-1zM9 12h1v1h-1zM10 11h1v1h-1zM12 11h1v1h-1zM13 12h1v1h-1zM14 11h1v1h-1zM15 14h1v1h-1zM10 13h1v1h-1zM11 14h1v1h-1zM12 13h1v1h-1zM13 14h1v1h-1zM10 15h1v1h-1zM12 15h1v1h-1zM14 15h1v1h-1z"
    }
  }]
};
exports.qrcode = qrcode;
var ticket = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 5l2 2-4 4-2-2zM15.649 4.649l-1.149-1.149-0.5 0.5c-0.256 0.256-0.61 0.414-1 0.414-0.781 0-1.414-0.633-1.414-1.414 0-0.391 0.158-0.744 0.415-1l0.5-0.5-1.149-1.149c-0.468-0.468-1.235-0.468-1.703 0l-9.297 9.297c-0.468 0.468-0.468 1.235 0 1.703l1.149 1.149 0.499-0.499c0.256-0.256 0.61-0.415 1.001-0.415 0.781 0 1.414 0.633 1.414 1.414 0 0.391-0.158 0.744-0.415 1l-0.5 0.5 1.149 1.149c0.468 0.468 1.234 0.468 1.703 0l9.297-9.297c0.468-0.468 0.468-1.235 0-1.703zM7 13l-4-4 6-6 4 4-6 6z"
    }
  }]
};
exports.ticket = ticket;
var cart = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 14.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8v-6h-12c0-0.552-0.448-1-1-1h-3v1h2l0.751 6.438c-0.458 0.367-0.751 0.93-0.751 1.562 0 1.105 0.895 2 2 2h12v-1h-12c-0.552 0-1-0.448-1-1 0-0.003 0-0.007 0-0.010l13-1.99z"
    }
  }]
};
exports.cart = cart;
var coinDollar = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM8 8v-2h2v-1h-2v-1h-1v1h-2v4h2v2h-2v1h2v1h1v-1h2l-0-4h-2zM7 8h-1v-2h1v2zM9 11h-1v-2h1v2z"
    }
  }]
};
exports.coinDollar = coinDollar;
var coinEuro = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.482 10.068c-0.239-0.139-0.545-0.058-0.684 0.181-0.27 0.463-0.767 0.751-1.298 0.751h-2c-0.652 0-1.208-0.418-1.414-1h2.414c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.5v-1h2.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2.414c0.206-0.582 0.762-1 1.414-1h2c0.531 0 1.028 0.288 1.298 0.751 0.139 0.239 0.445 0.32 0.684 0.181s0.32-0.445 0.181-0.684c-0.448-0.77-1.277-1.249-2.162-1.249h-2c-1.207 0-2.217 0.86-2.45 2h-0.55c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v1h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.55c0.232 1.14 1.242 2 2.45 2h2c0.886 0 1.714-0.478 2.162-1.249 0.139-0.239 0.058-0.545-0.181-0.684z"
    }
  }]
};
exports.coinEuro = coinEuro;
var coinPound = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 11h-3.5v-2h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-0.5c0-0.827 0.673-1.5 1.5-1.5 0.534 0 1.032 0.288 1.3 0.75 0.138 0.239 0.444 0.321 0.683 0.182s0.321-0.444 0.182-0.683c-0.446-0.771-1.276-1.25-2.165-1.25-1.378 0-2.5 1.122-2.5 2.5v0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5v3h4.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5z"
    }
  }]
};
exports.coinPound = coinPound;
var coinYen = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM7.5 14.5c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 9c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.066l1.482-2.223c0.153-0.23 0.091-0.54-0.139-0.693s-0.54-0.091-0.693 0.139l-1.584 2.376-1.584-2.376c-0.153-0.23-0.464-0.292-0.693-0.139s-0.292 0.464-0.139 0.693l1.482 2.223h-1.066c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h1.5v1.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-1.5h1.5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-1h1.5z"
    }
  }]
};
exports.coinYen = coinYen;
var creditCard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v9c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-9c0-0.825-0.675-1.5-1.5-1.5zM1.5 3h13c0.271 0 0.5 0.229 0.5 0.5v1.5h-14v-1.5c0-0.271 0.229-0.5 0.5-0.5zM14.5 13h-13c-0.271 0-0.5-0.229-0.5-0.5v-4.5h14v4.5c0 0.271-0.229 0.5-0.5 0.5zM2 10h1v2h-1zM4 10h1v2h-1zM6 10h1v2h-1z"
    }
  }]
};
exports.creditCard = creditCard;
var calculator = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 1h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 5h-5v-1h5v1zM14 1h-5c-0.55 0-1 0.45-1 1v13c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-13c0-0.55-0.45-1-1-1zM14 10h-5v-1h5v1zM14 7h-5v-1h5v1zM6 9h-5c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h5c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM6 13h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
    }
  }]
};
exports.calculator = calculator;
var lifebuoy = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3-1.343 3-3 3-3-1.343-3-3zM14.468 10.679v0l-2.772-1.148c0.196-0.472 0.304-0.989 0.304-1.531s-0.108-1.059-0.304-1.531l2.772-1.148c0.342 0.825 0.532 1.73 0.532 2.679s-0.189 1.854-0.532 2.679v0zM10.679 1.532v0 0l-1.148 2.772c-0.472-0.196-0.989-0.304-1.531-0.304s-1.059 0.108-1.531 0.304l-1.148-2.772c0.825-0.342 1.73-0.532 2.679-0.532s1.854 0.189 2.679 0.532zM1.532 5.321l2.772 1.148c-0.196 0.472-0.304 0.989-0.304 1.531s0.108 1.059 0.304 1.531l-2.772 1.148c-0.342-0.825-0.532-1.73-0.532-2.679s0.189-1.854 0.532-2.679zM5.321 14.468l1.148-2.772c0.472 0.196 0.989 0.304 1.531 0.304s1.059-0.108 1.531-0.304l1.148 2.772c-0.825 0.342-1.73 0.532-2.679 0.532s-1.854-0.189-2.679-0.532z"
    }
  }]
};
exports.lifebuoy = lifebuoy;
var phone = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 10c-1 1-1 2-2 2s-2-1-3-2-2-2-2-3 1-1 2-2-2-4-3-4-3 3-3 3c0 2 2.055 6.055 4 8s6 4 8 4c0 0 3-2 3-3s-3-4-4-3z"
    }
  }]
};
exports.phone = phone;
var phoneHangUp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.897 9c0.125 0.867 0.207 2.053-0.182 2.507-0.643 0.751-4.714 0.751-4.714-0.751 0-0.756 0.67-1.252 0.027-2.003-0.632-0.738-1.766-0.75-3.027-0.751s-2.394 0.012-3.027 0.751c-0.643 0.751 0.027 1.247 0.027 2.003 0 1.501-4.071 1.501-4.714 0.751-0.389-0.454-0.307-1.64-0.182-2.507 0.096-0.579 0.339-1.203 1.118-2 0-0 0-0 0-0 1.168-1.090 2.935-1.98 6.716-2v-0c0.021 0 0.042 0 0.063 0s0.041-0 0.063-0v0c3.781 0.019 5.548 0.91 6.716 2 0 0 0 0 0 0 0.778 0.797 1.022 1.421 1.118 2z"
    }
  }]
};
exports.phoneHangUp = phoneHangUp;
var addressBook = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 0v16h12v-16h-12zM9 4.005c1.102 0 1.995 0.893 1.995 1.995s-0.893 1.995-1.995 1.995-1.995-0.893-1.995-1.995 0.893-1.995 1.995-1.995v0zM12 12h-6v-1c0-1.105 0.895-2 2-2v0h2c1.105 0 2 0.895 2 2v1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 1h1.5v3h-1.5v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 5h1.5v3h-1.5v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 9h1.5v3h-1.5v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 13h1.5v3h-1.5v-3z"
    }
  }]
};
exports.addressBook = addressBook;
var envelop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 2h-13c-0.825 0-1.5 0.675-1.5 1.5v10c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-10c0-0.825-0.675-1.5-1.5-1.5zM6.23 8.6l-4.23 3.295v-7.838l4.23 4.543zM2.756 4h10.488l-5.244 3.938-5.244-3.938zM6.395 8.777l1.605 1.723 1.605-1.723 3.29 4.223h-9.79l3.29-4.223zM9.77 8.6l4.23-4.543v7.838l-4.23-3.295z"
    }
  }]
};
exports.envelop = envelop;
var pushpin = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.5 0l-1.5 1.5 1.5 1.5-3.5 4h-3.5l2.75 2.75-4.25 5.635v0.615h0.615l5.635-4.25 2.75 2.75v-3.5l4-3.5 1.5 1.5 1.5-1.5-7.5-7.5zM7 8.5l-1-1 3.5-3.5 1 1-3.5 3.5z"
    }
  }]
};
exports.pushpin = pushpin;
var location = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z"
    }
  }]
};
exports.location = location;
var location2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-2.761 0-5 2.239-5 5 0 5 5 11 5 11s5-6 5-11c0-2.761-2.239-5-5-5zM8 8.063c-1.691 0-3.063-1.371-3.063-3.063s1.371-3.063 3.063-3.063 3.063 1.371 3.063 3.063-1.371 3.063-3.063 3.063zM6.063 5c0-1.070 0.867-1.938 1.938-1.938s1.938 0.867 1.938 1.938c0 1.070-0.867 1.938-1.938 1.938s-1.938-0.867-1.938-1.938z"
    }
  }]
};
exports.location2 = location2;
var compass = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.5 16c-0.036 0-0.072-0.004-0.108-0.012-0.229-0.051-0.392-0.254-0.392-0.488v-7.5h-7.5c-0.234 0-0.437-0.163-0.488-0.392s0.064-0.462 0.277-0.561l15-7c0.191-0.089 0.416-0.049 0.565 0.1s0.188 0.374 0.1 0.565l-7 15c-0.083 0.179-0.262 0.289-0.453 0.289zM2.754 7h5.746c0.276 0 0.5 0.224 0.5 0.5v5.746l5.465-11.712-11.712 5.465z"
    }
  }]
};
exports.compass = compass;
var compass2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5 1.712 0 3.269 0.662 4.43 1.744l-6.43 2.756-2.756 6.43c-1.082-1.161-1.744-2.718-1.744-4.43zM9.143 9.143l-4.001 1.715 1.715-4.001 2.286 2.286zM8 14.5c-1.712 0-3.269-0.662-4.43-1.744l6.43-2.756 2.756-6.43c1.082 1.161 1.744 2.718 1.744 4.43 0 3.59-2.91 6.5-6.5 6.5z"
    }
  }]
};
exports.compass2 = compass2;
var map = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3l5-2v12l-5 2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 0.5l5 3v11.5l-5-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 3.5l4-3v12l-4 3z"
    }
  }]
};
exports.map = map;
var map2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.5 3l-5-2-5.5 2v12l5.5-2 5 2 5.5-2v-12l-5.5 2zM6 2.277l4 1.6v9.846l-4-1.6v-9.846zM1 3.7l4-1.455v9.872l-4 1.454v-9.872zM15 12.3l-4 1.455v-9.872l4-1.455v9.872z"
    }
  }]
};
exports.map2 = map2;
var history = {
  "viewBox": "0 0 17 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 1c3.866 0 7 3.134 7 7s-3.134 7-7 7v-1.5c1.469 0 2.85-0.572 3.889-1.611s1.611-2.42 1.611-3.889c0-1.469-0.572-2.85-1.611-3.889s-2.42-1.611-3.889-1.611c-1.469 0-2.85 0.572-3.889 1.611-0.799 0.799-1.322 1.801-1.52 2.889h2.909l-3.5 4-3.5-4h2.571c0.485-3.392 3.402-6 6.929-6zM13 7v2h-4v-5h2v3z"
    }
  }]
};
exports.history = history;
var clock = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
    }
  }]
};
exports.clock = clock;
var clock2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM10.293 11.707l-3.293-3.293v-4.414h2v3.586l2.707 2.707-1.414 1.414z"
    }
  }]
};
exports.clock2 = clock2;
var alarm = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 2c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zM8 14.625c-3.107 0-5.625-2.518-5.625-5.625s2.518-5.625 5.625-5.625c3.107 0 5.625 2.518 5.625 5.625s-2.518 5.625-5.625 5.625zM14.606 4.487c0.251-0.438 0.394-0.946 0.394-1.487 0-1.657-1.343-3-3-3-0.966 0-1.825 0.457-2.374 1.166 2.061 0.426 3.831 1.644 4.98 3.322v0zM6.374 1.166c-0.549-0.709-1.408-1.166-2.374-1.166-1.657 0-3 1.343-3 3 0 0.541 0.143 1.049 0.394 1.487 1.148-1.678 2.919-2.896 4.98-3.322z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 9v-4h-1v5h4v-1z"
    }
  }]
};
exports.alarm = alarm;
var bell = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16.023 12.5c0-4.5-4-3.5-4-7 0-0.29-0.028-0.538-0.079-0.749-0.263-1.766-1.44-3.183-2.965-3.615 0.014-0.062 0.021-0.125 0.021-0.191 0-0.52-0.45-0.945-1-0.945s-1 0.425-1 0.945c0 0.065 0.007 0.129 0.021 0.191-1.71 0.484-2.983 2.208-3.020 4.273-0.001 0.030-0.001 0.060-0.001 0.091 0 3.5-4 2.5-4 7 0 1.191 2.665 2.187 6.234 2.439 0.336 0.631 1.001 1.061 1.766 1.061s1.43-0.43 1.766-1.061c3.568-0.251 6.234-1.248 6.234-2.439 0-0.004-0-0.007-0-0.011l0.024 0.011zM12.91 13.345c-0.847 0.226-1.846 0.389-2.918 0.479-0.089-1.022-0.947-1.824-1.992-1.824s-1.903 0.802-1.992 1.824c-1.072-0.090-2.071-0.253-2.918-0.479-1.166-0.311-1.724-0.659-1.928-0.845 0.204-0.186 0.762-0.534 1.928-0.845 1.356-0.362 3.1-0.561 4.91-0.561s3.554 0.199 4.91 0.561c1.166 0.311 1.724 0.659 1.928 0.845-0.204 0.186-0.762 0.534-1.928 0.845z"
    }
  }]
};
exports.bell = bell;
var stopwatch = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 3.019v-1.019h2v-1c0-0.552-0.448-1-1-1h-3c-0.552 0-1 0.448-1 1v1h2v1.019c-3.356 0.255-6 3.059-6 6.481 0 3.59 2.91 6.5 6.5 6.5s6.5-2.91 6.5-6.5c0-3.422-2.644-6.226-6-6.481zM11.036 13.036c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.907-0.907 2.101-1.422 3.377-1.462l-0.339 4.907c-0.029 0.411 0.195 0.591 0.497 0.591s0.527-0.18 0.497-0.591l-0.339-4.907c1.276 0.040 2.47 0.555 3.377 1.462 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536z"
    }
  }]
};
exports.stopwatch = stopwatch;
var calendar = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 6h2v2h-2zM8 6h2v2h-2zM11 6h2v2h-2zM2 12h2v2h-2zM5 12h2v2h-2zM8 12h2v2h-2zM5 9h2v2h-2zM8 9h2v2h-2zM11 9h2v2h-2zM2 9h2v2h-2zM13 0v1h-2v-1h-7v1h-2v-1h-2v16h15v-16h-2zM14 15h-13v-11h13v11z"
    }
  }]
};
exports.calendar = calendar;
var printer = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 1h8v2h-8v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 4h-14c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v4h8v-4h3c0.55 0 1-0.45 1-1v-5c0-0.55-0.45-1-1-1zM2 7c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM11 14h-6v-5h6v5z"
    }
  }]
};
exports.printer = printer;
var keyboard = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M17 2h-16c-0.55 0-1 0.45-1 1v10c0 0.55 0.45 1 1 1h16c0.55 0 1-0.45 1-1v-10c0-0.55-0.45-1-1-1zM10 4h2v2h-2v-2zM13 7v2h-2v-2h2zM7 4h2v2h-2v-2zM10 7v2h-2v-2h2zM4 4h2v2h-2v-2zM7 7v2h-2v-2h2zM2 4h1v2h-1v-2zM2 7h2v2h-2v-2zM3 12h-1v-2h1v2zM12 12h-8v-2h8v2zM16 12h-3v-2h3v2zM16 9h-2v-2h2v2zM16 6h-3v-2h3v2z"
    }
  }]
};
exports.keyboard = keyboard;
var display = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1v10h16v-10h-16zM15 10h-14v-8h14v8zM10.5 12h-5l-0.5 2-1 1h8l-1-1z"
    }
  }]
};
exports.display = display;
var laptop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 11v-8c0-0.55-0.45-1-1-1h-10c-0.55 0-1 0.45-1 1v8h-2v3h16v-3h-2zM10 13h-4v-1h4v1zM13 11h-10v-7.998c0.001-0.001 0.001-0.001 0.002-0.002h9.996c0.001 0.001 0.001 0.001 0.002 0.002v7.998z"
    }
  }]
};
exports.laptop = laptop;
var mobile = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 0h-7c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h7c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 0.75h4v0.5h-4v-0.5zM8 15c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM12 12h-8v-10h8v10z"
    }
  }]
};
exports.mobile = mobile;
var mobile2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 0h-9c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM7.5 15.278c-0.43 0-0.778-0.348-0.778-0.778s0.348-0.778 0.778-0.778 0.778 0.348 0.778 0.778-0.348 0.778-0.778 0.778zM12 13h-9v-11h9v11z"
    }
  }]
};
exports.mobile2 = mobile2;
var tablet = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 0h-10c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h10c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7.5 15.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM12 14h-9v-12h9v12z"
    }
  }]
};
exports.tablet = tablet;
var tv = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.331 4.502c-1.388-0.199-2.865-0.344-4.407-0.425l2.576-2.576-1-1-3.509 3.509c-0.328-0.006-0.659-0.009-0.991-0.009v0l-4-4-1 1 3.034 3.034c-1.889 0.066-3.693 0.227-5.365 0.467-0.43 1.683-0.669 3.543-0.669 5.498s0.239 3.815 0.669 5.498c2.244 0.323 4.724 0.502 7.331 0.502s5.087-0.179 7.331-0.502c0.43-1.683 0.669-3.543 0.669-5.498s-0.239-3.815-0.669-5.498zM13.498 13.666c-1.683 0.215-3.543 0.334-5.498 0.334s-3.815-0.119-5.498-0.334c-0.323-1.122-0.502-2.362-0.502-3.666s0.179-2.543 0.502-3.666c1.683-0.215 3.543-0.334 5.498-0.334s3.815 0.119 5.498 0.334c0.323 1.122 0.502 2.362 0.502 3.666s-0.179 2.543-0.502 3.666z"
    }
  }]
};
exports.tv = tv;
var drawer = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 8h-7c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 10h-9c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h9c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.drawer = drawer;
var drawer2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.89 10.188l-4-5c-0.095-0.119-0.239-0.188-0.39-0.188h-7c-0.152 0-0.296 0.069-0.39 0.188l-4 5c-0.071 0.089-0.11 0.199-0.11 0.312v4.5c0 0.552 0.448 1 1 1h14c0.552 0 1-0.448 1-1v-4.5c0-0.114-0.039-0.224-0.11-0.312zM15 11h-3.5l-2 2h-3l-2-2h-3.5v-0.325l3.74-4.675h6.519l3.74 4.675v0.325z"
    }
  }]
};
exports.drawer2 = drawer2;
var boxAdd = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM8 13l-5-4h3v-3h4v3h3l-5 4zM2.414 3l1-1h9.172l1 1h-11.172z"
    }
  }]
};
exports.boxAdd = boxAdd;
var boxRemove = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 1h-10l-3 3v10.5c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-10.5l-3-3zM10 10v3h-4v-3h-3l5-4 5 4h-3zM2.414 3l1-1h9.171l1 1h-11.171z"
    }
  }]
};
exports.boxRemove = boxRemove;
var download = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 9l4-4h-3v-4h-2v4h-3zM11.636 7.364l-1.121 1.121 4.064 1.515-6.579 2.453-6.579-2.453 4.064-1.515-1.121-1.121-4.364 1.636v4l8 3 8-3v-4z"
    }
  }]
};
exports.download = download;
var upload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9h2v-4h3l-4-4-4 4h3zM10 6.75v1.542l4.579 1.708-6.579 2.453-6.579-2.453 4.579-1.708v-1.542l-6 2.25v4l8 3 8-3v-4z"
    }
  }]
};
exports.upload = upload;
var floppyDisk = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 0h-14v16h16v-14l-2-2zM8 2h2v4h-2v-4zM14 14h-12v-12h1v5h9v-5h1.172l0.828 0.828v11.172z"
    }
  }]
};
exports.floppyDisk = floppyDisk;
var drive = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 14h10c1.657 0 3-1.343 3-3h-16c0 1.657 1.343 3 3 3zM13 12h1v1h-1v-1zM15 2h-14l-1 8h16z"
    }
  }]
};
exports.drive = drive;
var database = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 1.119-8 2.5v2c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-2c0-1.381-3.582-2.5-8-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 8.5c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 13c-4.418 0-8-1.119-8-2.5v3c0 1.381 3.582 2.5 8 2.5s8-1.119 8-2.5v-3c0 1.381-3.582 2.5-8 2.5z"
    }
  }]
};
exports.database = database;
var undo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1c-2.209 0-4.209 0.896-5.657 2.343l-2.343-2.343v6h6l-2.243-2.243c1.086-1.086 2.586-1.757 4.243-1.757 3.314 0 6 2.686 6 6 0 1.792-0.786 3.401-2.032 4.5l1.323 1.5c1.661-1.466 2.709-3.611 2.709-6 0-4.418-3.582-8-8-8z"
    }
  }]
};
exports.undo = undo;
var redo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 9c0 2.389 1.048 4.534 2.709 6l1.323-1.5c-1.246-1.099-2.031-2.708-2.031-4.5 0-3.314 2.686-6 6-6 1.657 0 3.157 0.672 4.243 1.757l-2.243 2.243h6v-6l-2.343 2.343c-1.448-1.448-3.448-2.343-5.657-2.343-4.418 0-8 3.582-8 8z"
    }
  }]
};
exports.redo = redo;
var undo2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.904 16c1.777-3.219 2.076-8.13-4.904-7.966v3.966l-6-6 6-6v3.881c8.359-0.218 9.29 7.378 4.904 12.119z"
    }
  }]
};
exports.undo2 = undo2;
var redo2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 3.881v-3.881l6 6-6 6v-3.966c-6.98-0.164-6.681 4.747-4.904 7.966-4.386-4.741-3.455-12.337 4.904-12.119z"
    }
  }]
};
exports.redo2 = redo2;
var forward = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.096 0c-1.777 3.219-2.076 8.13 4.904 7.966v-3.966l6 6-6 6v-3.881c-8.359 0.218-9.29-7.378-4.904-12.119z"
    }
  }]
};
exports.forward = forward;
var reply = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 12.119v3.881l-6-6 6-6v3.966c6.98 0.164 6.681-4.747 4.904-7.966 4.386 4.741 3.455 12.337-4.904 12.119z"
    }
  }]
};
exports.reply = reply;
var bubble = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
    }
  }]
};
exports.bubble = bubble;
var bubbles = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM8 0c4.351 0 7.89 2.822 7.997 6.336-0.768-0.343-1.619-0.524-2.497-0.524-1.493 0-2.903 0.523-3.971 1.472-1.107 0.984-1.717 2.304-1.717 3.716 0 0.698 0.149 1.373 0.433 1.997-0.082 0.002-0.164 0.003-0.246 0.003-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
    }
  }]
};
exports.bubbles = bubbles;
var bubbles2 = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
    }
  }]
};
exports.bubbles2 = bubbles2;
var bubble2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 3c-0.858 0-1.687 0.135-2.464 0.402-0.73 0.251-1.38 0.605-1.932 1.054-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.328 0.042 0.662 0.063 0.995 0.063 0.858 0 1.687-0.135 2.464-0.402 0.73-0.251 1.38-0.605 1.932-1.054 1.035-0.841 1.604-1.922 1.604-3.044s-0.57-2.203-1.604-3.044c-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402zM8 1v0c4.418 0 8 2.91 8 6.5s-3.582 6.5-8 6.5c-0.424 0-0.841-0.027-1.247-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5z"
    }
  }]
};
exports.bubble2 = bubble2;
var bubbles3 = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M17 14.081c0 0.711 0.407 1.327 1 1.628v0.249c-0.166 0.023-0.335 0.035-0.508 0.035-1.063 0-2.021-0.446-2.699-1.16-0.41 0.109-0.844 0.168-1.293 0.168-2.485 0-4.5-1.791-4.5-4s2.015-4 4.5-4c2.485 0 4.5 1.791 4.5 4 0 0.865-0.309 1.665-0.834 2.32-0.107 0.232-0.166 0.489-0.166 0.761zM3.604 3.456c-1.035 0.841-1.604 1.922-1.604 3.044 0 0.63 0.175 1.24 0.52 1.815 0.356 0.592 0.89 1.134 1.547 1.566 0.474 0.312 0.793 0.812 0.878 1.373 0.028 0.187 0.046 0.376 0.053 0.564 0.117-0.097 0.23-0.201 0.342-0.312 0.377-0.377 0.887-0.586 1.414-0.586 0.084 0 0.168 0.005 0.252 0.016 0.327 0.042 0.662 0.063 0.994 0.063v2c-0.424-0-0.84-0.027-1.246-0.079-1.718 1.718-3.77 2.027-5.753 2.072v-0.421c1.071-0.525 2-1.48 2-2.572 0-0.152-0.012-0.302-0.034-0.448-1.809-1.192-2.966-3.012-2.966-5.052 0-3.59 3.582-6.5 8-6.5 4.351 0 7.89 2.822 7.997 6.336-0.642-0.286-1.341-0.46-2.067-0.509-0.18-0.876-0.709-1.7-1.535-2.371-0.552-0.448-1.202-0.803-1.932-1.054-0.777-0.267-1.606-0.402-2.464-0.402s-1.687 0.135-2.464 0.402c-0.73 0.251-1.38 0.605-1.932 1.054z"
    }
  }]
};
exports.bubbles3 = bubbles3;
var bubbles4 = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 2c-0.792 0-1.556 0.124-2.272 0.369-0.671 0.23-1.267 0.554-1.773 0.963-0.938 0.759-1.455 1.731-1.455 2.737 0 0.562 0.157 1.109 0.467 1.623 0.323 0.537 0.811 1.028 1.41 1.421 0.476 0.312 0.796 0.812 0.881 1.374 0.014 0.094 0.025 0.188 0.034 0.282 0.043-0.039 0.085-0.080 0.127-0.122 0.377-0.376 0.886-0.583 1.411-0.583 0.084 0 0.167 0.005 0.251 0.016 0.303 0.038 0.611 0.058 0.918 0.058 0.792 0 1.556-0.124 2.272-0.369 0.671-0.23 1.267-0.554 1.774-0.963 0.938-0.759 1.455-1.731 1.455-2.737s-0.517-1.978-1.455-2.737c-0.506-0.41-1.103-0.734-1.774-0.963-0.716-0.245-1.48-0.369-2.272-0.369zM7.5 0v0c4.142 0 7.5 2.717 7.5 6.069s-3.358 6.069-7.5 6.069c-0.398 0-0.788-0.025-1.169-0.074-1.611 1.605-3.471 1.892-5.331 1.935v-0.393c1.004-0.49 1.813-1.382 1.813-2.402 0-0.142-0.011-0.282-0.032-0.419-1.696-1.113-2.781-2.812-2.781-4.717 0-3.352 3.358-6.069 7.5-6.069zM15.563 13.604c0 0.874 0.567 1.639 1.438 2.059v0.337c-1.611-0.036-3.090-0.283-4.487-1.658-0.33 0.041-0.669 0.063-1.013 0.063-1.492 0-2.866-0.402-3.963-1.079 2.261-0.008 4.395-0.732 6.013-2.042 0.816-0.66 1.459-1.435 1.913-2.302 0.481-0.92 0.724-1.9 0.724-2.913 0-0.163-0.007-0.326-0.020-0.487 1.134 0.936 1.832 2.213 1.832 3.62 0 1.633-0.94 3.089-2.41 4.043-0.018 0.117-0.027 0.237-0.027 0.359z"
    }
  }]
};
exports.bubbles4 = bubbles4;
var user = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 11.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
    }
  }]
};
exports.user = user;
var users = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 12.041v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h14c0-2.015-2.608-3.682-6-3.959z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.112 12.427c0.864-0.565 1.939-0.994 3.122-1.256-0.235-0.278-0.449-0.588-0.633-0.922-0.475-0.863-0.726-1.813-0.726-2.748 0-1.344 0-2.614 0.478-3.653 0.464-1.008 1.299-1.633 2.488-1.867-0.264-1.195-0.968-1.98-2.841-1.98-3 0-3 2.015-3 4.5 0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h4.359c0.227-0.202 0.478-0.393 0.753-0.573z"
    }
  }]
};
exports.users = users;
var userPlus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1z"
    }
  }]
};
exports.userPlus = userPlus;
var userMinus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 11.5c0-2.363 1.498-4.383 3.594-5.159 0.254-0.571 0.406-1.206 0.406-1.841 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h6.208c-0.135-0.477-0.208-0.98-0.208-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 7c-2.485 0-4.5 2.015-4.5 4.5s2.015 4.5 4.5 4.5c2.485 0 4.5-2.015 4.5-4.5s-2.015-4.5-4.5-4.5zM14 12h-5v-1h5v1z"
    }
  }]
};
exports.userMinus = userMinus;
var userCheck = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 9.5l-4.5 4.5-1.5-1.5-1 1 2.5 2.5 5.5-5.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 12h5v-1.799c-1.050-0.613-2.442-1.033-4-1.16v-0.825c1.102-0.621 2-2.168 2-3.716 0-2.485 0-4.5-3-4.5s-3 2.015-3 4.5c0 1.548 0.898 3.095 2 3.716v0.825c-3.392 0.277-6 1.944-6 3.959h7v-1z"
    }
  }]
};
exports.userCheck = userCheck;
var userTie = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 3c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3zM12.001 7h-0.553l-3.111 6.316 1.163-5.816-1.5-1.5-1.5 1.5 1.163 5.816-3.111-6.316h-0.554c-1.999 0-1.999 1.344-1.999 3v5h12v-5c0-1.656 0-3-1.999-3z"
    }
  }]
};
exports.userTie = userTie;
var quotesLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.548-0.043zM12.516 7c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5l-0.016-0.5c0-3.866 3.134-7 7-7v2c-1.336 0-2.591 0.52-3.536 1.464-0.182 0.182-0.348 0.375-0.497 0.578 0.179-0.028 0.362-0.043 0.549-0.043z"
    }
  }]
};
exports.quotesLeft = quotesLeft;
var quotesRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043zM3.5 10c-1.933 0-3.5-1.567-3.5-3.5s1.567-3.5 3.5-3.5 3.5 1.567 3.5 3.5l0.016 0.5c0 3.866-3.134 7-7 7v-2c1.336 0 2.591-0.52 3.536-1.464 0.182-0.182 0.348-0.375 0.497-0.578-0.179 0.028-0.362 0.043-0.549 0.043z"
    }
  }]
};
exports.quotesRight = quotesRight;
var hourGlass = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.39 8c2.152-1.365 3.61-3.988 3.61-7 0-0.339-0.019-0.672-0.054-1h-13.891c-0.036 0.328-0.054 0.661-0.054 1 0 3.012 1.457 5.635 3.609 7-2.152 1.365-3.609 3.988-3.609 7 0 0.339 0.019 0.672 0.054 1h13.891c0.036-0.328 0.054-0.661 0.054-1 0-3.012-1.457-5.635-3.609-7zM2.5 15c0-2.921 1.253-5.397 3.5-6.214v-1.572c-2.247-0.817-3.5-3.294-3.5-6.214v0h11c0 2.921-1.253 5.397-3.5 6.214v1.572c2.247 0.817 3.5 3.294 3.5 6.214h-11zM9.682 10.462c-1.12-0.635-1.181-1.459-1.182-1.959v-1.004c0-0.5 0.059-1.327 1.184-1.963 0.602-0.349 1.122-0.88 1.516-1.537h-6.4c0.395 0.657 0.916 1.188 1.518 1.538 1.12 0.635 1.181 1.459 1.182 1.959v1.004c0 0.5-0.059 1.327-1.184 1.963-1.135 0.659-1.98 1.964-2.236 3.537h7.839c-0.256-1.574-1.102-2.879-2.238-3.538z"
    }
  }]
};
exports.hourGlass = hourGlass;
var spinner = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10.243 3.757c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM13 8c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.243 12.243c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM7 14c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.757 12.243c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM2.257 3.757c0 0 0 0 0 0 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0 0 0 0 0 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0.875 8c0-0.621 0.504-1.125 1.125-1.125s1.125 0.504 1.125 1.125c0 0.621-0.504 1.125-1.125 1.125s-1.125-0.504-1.125-1.125z"
    }
  }]
};
exports.spinner = spinner;
var spinner2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8c-0.020-1.045-0.247-2.086-0.665-3.038-0.417-0.953-1.023-1.817-1.766-2.53s-1.624-1.278-2.578-1.651c-0.953-0.374-1.978-0.552-2.991-0.531-1.013 0.020-2.021 0.24-2.943 0.646-0.923 0.405-1.758 0.992-2.449 1.712s-1.237 1.574-1.597 2.497c-0.361 0.923-0.533 1.914-0.512 2.895 0.020 0.981 0.234 1.955 0.627 2.847 0.392 0.892 0.961 1.7 1.658 2.368s1.523 1.195 2.416 1.543c0.892 0.348 1.851 0.514 2.799 0.493 0.949-0.020 1.89-0.227 2.751-0.608 0.862-0.379 1.642-0.929 2.287-1.604s1.154-1.472 1.488-2.335c0.204-0.523 0.342-1.069 0.415-1.622 0.019 0.001 0.039 0.002 0.059 0.002 0.552 0 1-0.448 1-1 0-0.028-0.001-0.056-0.004-0.083h0.004zM14.411 10.655c-0.367 0.831-0.898 1.584-1.55 2.206s-1.422 1.112-2.254 1.434c-0.832 0.323-1.723 0.476-2.608 0.454-0.884-0.020-1.759-0.215-2.56-0.57-0.801-0.354-1.526-0.867-2.125-1.495s-1.071-1.371-1.38-2.173c-0.31-0.801-0.457-1.66-0.435-2.512s0.208-1.694 0.551-2.464c0.342-0.77 0.836-1.468 1.441-2.044s1.321-1.029 2.092-1.326c0.771-0.298 1.596-0.438 2.416-0.416s1.629 0.202 2.368 0.532c0.74 0.329 1.41 0.805 1.963 1.387s0.988 1.27 1.272 2.011c0.285 0.74 0.418 1.532 0.397 2.32h0.004c-0.002 0.027-0.004 0.055-0.004 0.083 0 0.516 0.39 0.94 0.892 0.994-0.097 0.544-0.258 1.075-0.481 1.578z"
    }
  }]
};
exports.spinner2 = spinner2;
var spinner3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 4.736c-0.515 0-0.933-0.418-0.933-0.933v-2.798c0-0.515 0.418-0.933 0.933-0.933s0.933 0.418 0.933 0.933v2.798c0 0.515-0.418 0.933-0.933 0.933z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 15.577c-0.322 0-0.583-0.261-0.583-0.583v-2.798c0-0.322 0.261-0.583 0.583-0.583s0.583 0.261 0.583 0.583v2.798c0 0.322-0.261 0.583-0.583 0.583z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.902 5.24c-0.302 0-0.596-0.157-0.758-0.437l-1.399-2.423c-0.241-0.418-0.098-0.953 0.32-1.194s0.953-0.098 1.194 0.32l1.399 2.423c0.241 0.418 0.098 0.953-0.32 1.194-0.138 0.079-0.288 0.117-0.436 0.117z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.498 14.582c-0.181 0-0.358-0.094-0.455-0.262l-1.399-2.423c-0.145-0.251-0.059-0.572 0.192-0.717s0.572-0.059 0.717 0.192l1.399 2.423c0.145 0.251 0.059 0.572-0.192 0.717-0.083 0.048-0.173 0.070-0.262 0.070z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.365 6.718c-0.138 0-0.279-0.035-0.407-0.109l-2.423-1.399c-0.39-0.225-0.524-0.724-0.299-1.115s0.724-0.524 1.115-0.299l2.423 1.399c0.39 0.225 0.524 0.724 0.299 1.115-0.151 0.262-0.425 0.408-0.707 0.408z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.057 11.964c-0.079 0-0.159-0.020-0.233-0.063l-2.423-1.399c-0.223-0.129-0.299-0.414-0.171-0.637s0.414-0.299 0.637-0.171l2.423 1.399c0.223 0.129 0.299 0.414 0.171 0.637-0.086 0.15-0.243 0.233-0.404 0.233z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.803 8.758h-2.798c-0.418 0-0.758-0.339-0.758-0.758s0.339-0.758 0.758-0.758h2.798c0.419 0 0.758 0.339 0.758 0.758s-0.339 0.758-0.758 0.758z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.995 8.466c-0 0 0 0 0 0h-2.798c-0.258-0-0.466-0.209-0.466-0.466s0.209-0.466 0.466-0.466c0 0 0 0 0 0h2.798c0.258 0 0.466 0.209 0.466 0.466s-0.209 0.466-0.466 0.466z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.943 12.197c-0.242 0-0.477-0.125-0.606-0.35-0.193-0.335-0.079-0.762 0.256-0.955l2.423-1.399c0.335-0.193 0.762-0.079 0.955 0.256s0.079 0.762-0.256 0.955l-2.423 1.399c-0.11 0.064-0.23 0.094-0.349 0.094z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.635 6.368c-0.161 0-0.318-0.084-0.404-0.233-0.129-0.223-0.052-0.508 0.171-0.637l2.423-1.399c0.223-0.129 0.508-0.052 0.637 0.171s0.052 0.508-0.171 0.637l-2.423 1.399c-0.073 0.042-0.154 0.063-0.233 0.063z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.502 14.699c-0.109 0-0.219-0.028-0.32-0.086-0.307-0.177-0.412-0.569-0.235-0.876l1.399-2.423c0.177-0.307 0.569-0.412 0.876-0.235s0.412 0.569 0.235 0.876l-1.399 2.423c-0.119 0.206-0.334 0.321-0.556 0.321z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.098 4.832c-0.079 0-0.159-0.020-0.233-0.063-0.223-0.129-0.299-0.414-0.171-0.637l1.399-2.423c0.129-0.223 0.414-0.299 0.637-0.171s0.299 0.414 0.171 0.637l-1.399 2.423c-0.086 0.15-0.243 0.233-0.404 0.233z"
    }
  }]
};
exports.spinner3 = spinner3;
var spinner4 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 8c0-0.19 0.011-0.378 0.032-0.563l-2.89-0.939c-0.092 0.487-0.141 0.989-0.141 1.502 0 2.3 0.971 4.374 2.526 5.833l1.786-2.458c-0.814-0.889-1.312-2.074-1.312-3.375zM13 8c0 1.301-0.497 2.486-1.312 3.375l1.786 2.458c1.555-1.459 2.526-3.533 2.526-5.833 0-0.513-0.049-1.015-0.141-1.502l-2.89 0.939c0.021 0.185 0.032 0.373 0.032 0.563zM9 3.1c1.436 0.292 2.649 1.199 3.351 2.435l2.89-0.939c-1.144-2.428-3.473-4.188-6.241-4.534v3.038zM3.649 5.535c0.702-1.236 1.914-2.143 3.351-2.435v-3.038c-2.769 0.345-5.097 2.105-6.241 4.534l2.89 0.939zM10.071 12.552c-0.631 0.288-1.332 0.448-2.071 0.448s-1.44-0.16-2.071-0.448l-1.786 2.458c1.144 0.631 2.458 0.99 3.857 0.99s2.713-0.359 3.857-0.99l-1.786-2.458z"
    }
  }]
};
exports.spinner4 = spinner4;
var spinner5 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 4c2.209 0 4 1.791 4 4s-1.791 4-4 4-4-1.791-4-4 1.791-4 4-4zM12.773 12.773c-1.275 1.275-2.97 1.977-4.773 1.977s-3.498-0.702-4.773-1.977-1.977-2.97-1.977-4.773c0-1.803 0.702-3.498 1.977-4.773l1.061 1.061c0 0 0 0 0 0-2.047 2.047-2.047 5.378 0 7.425 0.992 0.992 2.31 1.538 3.712 1.538s2.721-0.546 3.712-1.538c2.047-2.047 2.047-5.378 0-7.425l1.061-1.061c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773z"
    }
  }]
};
exports.spinner5 = spinner5;
var spinner6 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM12.359 8c0 0 0 0 0 0 0-0.906 0.735-1.641 1.641-1.641s1.641 0.735 1.641 1.641c0 0 0 0 0 0 0 0.906-0.735 1.641-1.641 1.641s-1.641-0.735-1.641-1.641zM10.757 12.243c0-0.821 0.665-1.486 1.486-1.486s1.486 0.665 1.486 1.486c0 0.821-0.665 1.486-1.486 1.486s-1.486-0.665-1.486-1.486zM6.654 14c0-0.743 0.603-1.346 1.346-1.346s1.346 0.603 1.346 1.346c0 0.743-0.603 1.346-1.346 1.346s-1.346-0.603-1.346-1.346zM2.538 12.243c0-0.673 0.546-1.219 1.219-1.219s1.219 0.546 1.219 1.219c0 0.673-0.546 1.219-1.219 1.219s-1.219-0.546-1.219-1.219zM0.896 8c0-0.61 0.494-1.104 1.104-1.104s1.104 0.494 1.104 1.104c0 0.61-0.494 1.104-1.104 1.104s-1.104-0.494-1.104-1.104zM2.757 3.757c0 0 0 0 0 0 0-0.552 0.448-1 1-1s1 0.448 1 1c0 0 0 0 0 0 0 0.552-0.448 1-1 1s-1-0.448-1-1zM14.054 3.757c0 1-0.811 1.811-1.812 1.811s-1.812-0.811-1.812-1.811c0-1.001 0.811-1.811 1.812-1.811s1.812 0.811 1.812 1.811z"
    }
  }]
};
exports.spinner6 = spinner6;
var spinner7 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 14.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM0 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM13 8c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM1.904 12.596c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM11.096 3.404c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
    }
  }]
};
exports.spinner7 = spinner7;
var spinner8 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c-2.137 0-4.146-0.832-5.657-2.343s-2.343-3.52-2.343-5.657c0-1.513 0.425-2.986 1.228-4.261 0.781-1.239 1.885-2.24 3.193-2.895l0.672 1.341c-1.063 0.533-1.961 1.347-2.596 2.354-0.652 1.034-0.997 2.231-0.997 3.461 0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5c0-1.23-0.345-2.426-0.997-3.461-0.635-1.008-1.533-1.822-2.596-2.354l0.672-1.341c1.308 0.655 2.412 1.656 3.193 2.895 0.803 1.274 1.228 2.748 1.228 4.261 0 2.137-0.832 4.146-2.343 5.657s-3.52 2.343-5.657 2.343z"
    }
  }]
};
exports.spinner8 = spinner8;
var spinner9 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.355 0-7.898 3.481-7.998 7.812 0.092-3.779 2.966-6.812 6.498-6.812 3.59 0 6.5 3.134 6.5 7 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-4.418-3.582-8-8-8zM8 16c4.355 0 7.898-3.481 7.998-7.812-0.092 3.779-2.966 6.812-6.498 6.812-3.59 0-6.5-3.134-6.5-7 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 4.418 3.582 8 8 8z"
    }
  }]
};
exports.spinner9 = spinner9;
var spinner10 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.001 8.025l-0 0c0 0 0 0.001 0 0.003 0.002 0.061 0.009 0.12 0.021 0.177 0.003 0.027 0.007 0.057 0.011 0.090 0.003 0.029 0.007 0.061 0.011 0.095 0.006 0.040 0.012 0.083 0.019 0.128 0.013 0.090 0.028 0.189 0.045 0.296 0.021 0.101 0.044 0.21 0.068 0.326 0.011 0.058 0.028 0.117 0.044 0.178s0.032 0.123 0.049 0.188c0.009 0.032 0.016 0.065 0.027 0.097s0.021 0.065 0.031 0.098 0.043 0.134 0.065 0.203c0.006 0.017 0.011 0.035 0.017 0.052s0.013 0.034 0.019 0.052 0.026 0.070 0.039 0.105c0.027 0.070 0.053 0.142 0.081 0.215 0.031 0.071 0.062 0.144 0.094 0.218 0.016 0.037 0.032 0.074 0.048 0.111s0.035 0.073 0.053 0.111 0.073 0.148 0.11 0.224c0.039 0.075 0.081 0.149 0.123 0.224 0.021 0.037 0.042 0.075 0.063 0.113s0.045 0.074 0.068 0.112 0.093 0.149 0.14 0.224c0.198 0.295 0.417 0.587 0.66 0.864 0.245 0.275 0.511 0.535 0.792 0.775 0.284 0.236 0.582 0.452 0.886 0.642 0.306 0.188 0.619 0.349 0.928 0.487 0.078 0.032 0.156 0.063 0.232 0.095 0.038 0.015 0.076 0.032 0.115 0.046s0.077 0.027 0.115 0.041 0.151 0.054 0.226 0.078c0.075 0.022 0.15 0.044 0.224 0.066 0.037 0.011 0.073 0.022 0.109 0.031s0.073 0.018 0.109 0.027 0.143 0.035 0.213 0.052c0.070 0.014 0.139 0.027 0.207 0.040 0.034 0.006 0.067 0.013 0.101 0.019 0.017 0.003 0.033 0.006 0.049 0.009s0.033 0.005 0.049 0.007c0.066 0.009 0.13 0.018 0.192 0.027 0.031 0.004 0.062 0.009 0.093 0.013s0.061 0.006 0.091 0.009 0.118 0.010 0.174 0.015c0.056 0.005 0.111 0.011 0.164 0.012 0.004 0 0.007 0 0.011 0 0.010 0.544 0.453 0.982 1 0.982 0.008 0 0.017-0 0.025-0.001v0c0 0 0.001-0 0.004-0 0.061-0.002 0.12-0.009 0.177-0.021 0.027-0.003 0.057-0.007 0.090-0.011 0.029-0.003 0.061-0.007 0.095-0.011 0.040-0.006 0.083-0.012 0.128-0.019 0.090-0.013 0.189-0.028 0.296-0.045 0.101-0.021 0.21-0.044 0.326-0.068 0.058-0.011 0.117-0.028 0.178-0.044s0.123-0.033 0.188-0.049c0.032-0.009 0.065-0.016 0.097-0.027s0.065-0.021 0.098-0.031 0.134-0.043 0.203-0.065c0.017-0.006 0.035-0.011 0.052-0.017s0.034-0.013 0.052-0.019 0.070-0.026 0.105-0.039c0.070-0.027 0.142-0.053 0.215-0.081 0.071-0.031 0.144-0.062 0.218-0.094 0.037-0.016 0.074-0.032 0.111-0.048s0.073-0.035 0.111-0.053 0.148-0.073 0.224-0.11c0.075-0.039 0.149-0.081 0.224-0.123 0.037-0.021 0.075-0.042 0.113-0.063s0.074-0.045 0.112-0.068 0.149-0.093 0.224-0.14c0.295-0.197 0.587-0.417 0.864-0.66 0.275-0.245 0.535-0.511 0.775-0.792 0.236-0.284 0.452-0.582 0.642-0.886 0.188-0.306 0.349-0.619 0.487-0.928 0.032-0.078 0.063-0.156 0.095-0.232 0.015-0.038 0.032-0.076 0.046-0.115s0.027-0.077 0.040-0.115 0.054-0.151 0.078-0.226c0.022-0.075 0.044-0.15 0.066-0.224 0.011-0.037 0.022-0.073 0.031-0.109s0.018-0.073 0.027-0.109 0.035-0.143 0.052-0.213c0.014-0.070 0.027-0.139 0.040-0.207 0.006-0.034 0.013-0.067 0.019-0.101 0.003-0.017 0.006-0.033 0.009-0.049s0.005-0.033 0.007-0.050c0.009-0.065 0.018-0.13 0.027-0.192 0.004-0.031 0.009-0.062 0.013-0.093s0.006-0.061 0.009-0.091 0.010-0.118 0.015-0.174c0.005-0.056 0.011-0.111 0.012-0.165 0-0.008 0.001-0.016 0.001-0.025 0.55-0.002 0.996-0.449 0.996-1 0-0.008-0-0.017-0.001-0.025h0c0 0-0-0.001-0-0.003-0.002-0.061-0.009-0.12-0.021-0.177-0.003-0.027-0.007-0.057-0.011-0.090-0.003-0.029-0.007-0.061-0.011-0.095-0.006-0.040-0.012-0.083-0.019-0.128-0.013-0.090-0.028-0.189-0.045-0.296-0.021-0.101-0.044-0.21-0.068-0.326-0.011-0.058-0.028-0.117-0.044-0.178s-0.032-0.123-0.049-0.188c-0.009-0.032-0.016-0.065-0.027-0.097s-0.021-0.065-0.031-0.098-0.043-0.134-0.065-0.203c-0.005-0.017-0.011-0.035-0.017-0.052s-0.013-0.034-0.019-0.052-0.026-0.070-0.039-0.105c-0.027-0.070-0.053-0.142-0.081-0.215-0.031-0.071-0.062-0.144-0.094-0.218-0.016-0.037-0.032-0.074-0.048-0.111s-0.035-0.073-0.053-0.111-0.073-0.148-0.11-0.224c-0.039-0.075-0.081-0.149-0.123-0.224-0.021-0.037-0.042-0.075-0.063-0.113s-0.045-0.074-0.068-0.112-0.093-0.149-0.14-0.224c-0.197-0.295-0.417-0.587-0.66-0.864-0.245-0.275-0.511-0.535-0.792-0.775-0.284-0.236-0.582-0.452-0.886-0.642-0.306-0.188-0.619-0.349-0.928-0.487-0.078-0.032-0.156-0.063-0.232-0.095-0.038-0.015-0.076-0.032-0.115-0.046s-0.077-0.027-0.115-0.040-0.151-0.054-0.226-0.078c-0.075-0.022-0.15-0.044-0.224-0.066-0.037-0.010-0.073-0.022-0.109-0.031s-0.073-0.018-0.109-0.027-0.143-0.035-0.213-0.052c-0.070-0.014-0.139-0.027-0.207-0.040-0.034-0.006-0.067-0.013-0.101-0.019-0.017-0.003-0.033-0.006-0.049-0.009s-0.033-0.005-0.049-0.007c-0.066-0.009-0.13-0.018-0.192-0.027-0.031-0.004-0.062-0.009-0.093-0.013s-0.061-0.006-0.091-0.009-0.118-0.010-0.174-0.015c-0.056-0.005-0.111-0.011-0.164-0.012-0.013-0-0.026-0.001-0.039-0.001-0.010-0.543-0.454-0.981-0.999-0.981-0.008 0-0.017 0-0.025 0.001l-0-0c0 0-0.001 0-0.003 0-0.061 0.002-0.12 0.009-0.177 0.021-0.027 0.003-0.057 0.007-0.090 0.011-0.029 0.003-0.061 0.007-0.095 0.011-0.040 0.006-0.083 0.012-0.128 0.019-0.090 0.013-0.189 0.028-0.296 0.045-0.101 0.021-0.21 0.044-0.326 0.068-0.058 0.011-0.117 0.028-0.178 0.044s-0.123 0.033-0.188 0.049c-0.032 0.009-0.065 0.016-0.097 0.027s-0.065 0.021-0.098 0.031-0.134 0.043-0.203 0.065c-0.017 0.006-0.035 0.011-0.052 0.017s-0.034 0.013-0.052 0.019-0.070 0.026-0.105 0.039c-0.070 0.027-0.142 0.053-0.215 0.081-0.071 0.031-0.144 0.062-0.218 0.094-0.037 0.016-0.074 0.032-0.111 0.048s-0.073 0.035-0.111 0.053-0.148 0.073-0.224 0.11c-0.075 0.039-0.149 0.081-0.224 0.123-0.037 0.021-0.075 0.042-0.113 0.063s-0.074 0.045-0.112 0.068-0.149 0.093-0.224 0.14c-0.295 0.198-0.587 0.417-0.864 0.66-0.275 0.245-0.535 0.511-0.775 0.792-0.236 0.284-0.452 0.582-0.642 0.886-0.188 0.306-0.349 0.619-0.487 0.928-0.032 0.078-0.063 0.156-0.095 0.232-0.015 0.038-0.032 0.076-0.046 0.115s-0.027 0.077-0.040 0.115-0.054 0.151-0.078 0.226c-0.022 0.075-0.044 0.15-0.066 0.224-0.011 0.037-0.022 0.073-0.032 0.109s-0.018 0.073-0.027 0.109-0.035 0.143-0.052 0.213c-0.014 0.070-0.027 0.139-0.040 0.207-0.006 0.034-0.013 0.067-0.019 0.101-0.003 0.017-0.006 0.033-0.009 0.049s-0.005 0.033-0.007 0.050c-0.009 0.065-0.018 0.13-0.027 0.192-0.004 0.031-0.009 0.062-0.013 0.093s-0.006 0.061-0.009 0.091-0.010 0.118-0.015 0.174c-0.005 0.056-0.011 0.111-0.012 0.165-0 0.009-0.001 0.017-0.001 0.025-0.537 0.017-0.967 0.458-0.967 0.999 0 0.008 0 0.017 0.001 0.025zM1.149 7.011c0.001-0.003 0.001-0.006 0.002-0.009 0.010-0.051 0.026-0.102 0.040-0.155s0.030-0.107 0.045-0.163c0.008-0.028 0.015-0.056 0.024-0.084s0.019-0.057 0.028-0.086 0.038-0.116 0.058-0.176c0.005-0.015 0.010-0.030 0.015-0.045s0.012-0.030 0.017-0.045 0.023-0.060 0.035-0.091 0.048-0.123 0.073-0.186c0.028-0.062 0.056-0.125 0.084-0.189 0.014-0.032 0.028-0.064 0.043-0.096s0.032-0.064 0.048-0.096 0.065-0.128 0.098-0.194c0.034-0.065 0.073-0.128 0.109-0.194 0.018-0.032 0.037-0.065 0.056-0.098s0.040-0.064 0.061-0.096c0.041-0.064 0.082-0.129 0.124-0.194 0.176-0.255 0.369-0.506 0.583-0.744 0.217-0.236 0.451-0.459 0.697-0.665 0.25-0.202 0.511-0.385 0.776-0.547 0.268-0.159 0.541-0.294 0.808-0.41 0.068-0.027 0.135-0.053 0.202-0.079 0.033-0.013 0.066-0.027 0.099-0.038s0.067-0.022 0.1-0.033 0.131-0.045 0.196-0.065c0.065-0.018 0.13-0.036 0.194-0.054 0.032-0.009 0.063-0.019 0.095-0.026s0.063-0.014 0.094-0.021 0.123-0.028 0.184-0.042c0.061-0.011 0.12-0.021 0.179-0.032 0.029-0.005 0.058-0.010 0.087-0.015 0.014-0.003 0.029-0.005 0.043-0.008s0.029-0.003 0.043-0.005c0.056-0.007 0.112-0.014 0.166-0.020 0.027-0.003 0.053-0.007 0.080-0.010s0.053-0.004 0.078-0.006 0.102-0.007 0.15-0.011c0.049-0.003 0.095-0.008 0.142-0.008 0.091-0.002 0.177-0.004 0.256-0.006 0.073 0.003 0.14 0.005 0.2 0.007 0.030 0.001 0.058 0.002 0.085 0.002 0.033 0.002 0.064 0.004 0.093 0.006 0.033 0.002 0.063 0.004 0.091 0.006 0.051 0.008 0.103 0.012 0.156 0.012 0.007 0 0.015-0 0.022-0.001 0.002 0 0.004 0 0.004 0v-0c0.487-0.012 0.887-0.372 0.962-0.84 0.008 0.002 0.017 0.004 0.025 0.006 0.051 0.010 0.102 0.026 0.155 0.040s0.107 0.030 0.163 0.045c0.028 0.008 0.056 0.015 0.084 0.024s0.057 0.019 0.086 0.028 0.116 0.038 0.176 0.058c0.015 0.005 0.030 0.010 0.045 0.015s0.030 0.012 0.045 0.017 0.060 0.023 0.091 0.035 0.123 0.048 0.186 0.073c0.062 0.028 0.125 0.056 0.189 0.084 0.032 0.014 0.064 0.028 0.096 0.043s0.064 0.032 0.096 0.048 0.128 0.065 0.194 0.098c0.065 0.034 0.129 0.073 0.194 0.109 0.032 0.018 0.065 0.037 0.098 0.056s0.064 0.040 0.096 0.061 0.129 0.082 0.194 0.124c0.255 0.176 0.506 0.369 0.744 0.583 0.236 0.217 0.459 0.451 0.665 0.697 0.202 0.25 0.385 0.511 0.547 0.776 0.159 0.268 0.294 0.541 0.41 0.808 0.027 0.068 0.053 0.135 0.079 0.202 0.013 0.033 0.027 0.066 0.038 0.099s0.022 0.067 0.033 0.1 0.045 0.131 0.065 0.196c0.018 0.065 0.036 0.13 0.054 0.194 0.009 0.032 0.019 0.063 0.026 0.095s0.014 0.063 0.021 0.094 0.028 0.123 0.042 0.184c0.011 0.061 0.021 0.12 0.032 0.179 0.005 0.029 0.010 0.058 0.015 0.087 0.003 0.014 0.005 0.029 0.008 0.043s0.003 0.029 0.005 0.043c0.007 0.056 0.014 0.112 0.020 0.166 0.003 0.027 0.007 0.053 0.010 0.080s0.004 0.053 0.006 0.078 0.007 0.102 0.011 0.15c0.003 0.049 0.008 0.095 0.008 0.142 0.002 0.091 0.004 0.177 0.006 0.256-0.003 0.073-0.005 0.14-0.007 0.2-0.001 0.030-0.002 0.058-0.002 0.085-0.002 0.033-0.004 0.064-0.006 0.093-0.002 0.033-0.004 0.063-0.006 0.091-0.008 0.051-0.012 0.103-0.012 0.156 0 0.007 0 0.015 0.001 0.022-0 0.002-0 0.004-0 0.004h0c0.012 0.481 0.363 0.877 0.823 0.959-0.001 0.005-0.002 0.009-0.003 0.014-0.010 0.051-0.025 0.102-0.040 0.155s-0.030 0.107-0.045 0.163c-0.008 0.028-0.015 0.056-0.024 0.084s-0.019 0.057-0.028 0.086-0.039 0.116-0.058 0.176c-0.005 0.015-0.010 0.030-0.015 0.045s-0.012 0.030-0.017 0.045-0.023 0.060-0.035 0.091-0.048 0.123-0.073 0.186c-0.028 0.062-0.056 0.125-0.084 0.189-0.014 0.032-0.028 0.064-0.043 0.096s-0.032 0.064-0.048 0.096-0.065 0.128-0.098 0.194c-0.034 0.065-0.073 0.129-0.109 0.194-0.018 0.032-0.037 0.065-0.056 0.098s-0.040 0.064-0.061 0.096-0.082 0.129-0.124 0.194c-0.176 0.255-0.369 0.506-0.583 0.744-0.217 0.236-0.451 0.459-0.697 0.665-0.25 0.202-0.511 0.385-0.776 0.547-0.268 0.159-0.541 0.294-0.808 0.41-0.068 0.027-0.135 0.053-0.202 0.079-0.033 0.013-0.066 0.027-0.099 0.038s-0.067 0.022-0.1 0.033-0.131 0.045-0.196 0.065c-0.065 0.018-0.13 0.036-0.194 0.054-0.032 0.009-0.063 0.019-0.095 0.026s-0.063 0.014-0.094 0.021-0.123 0.028-0.184 0.042c-0.061 0.011-0.12 0.021-0.179 0.032-0.029 0.005-0.058 0.010-0.087 0.015-0.014 0.003-0.028 0.005-0.043 0.008s-0.029 0.003-0.043 0.005c-0.056 0.007-0.112 0.014-0.166 0.020-0.027 0.003-0.053 0.007-0.080 0.010s-0.053 0.004-0.078 0.006-0.102 0.007-0.15 0.011c-0.049 0.003-0.095 0.008-0.142 0.008-0.091 0.002-0.177 0.004-0.256 0.006-0.073-0.003-0.14-0.005-0.2-0.007-0.030-0.001-0.058-0.002-0.085-0.002-0.033-0.002-0.064-0.004-0.093-0.006-0.033-0.002-0.063-0.004-0.091-0.006-0.051-0.008-0.103-0.012-0.156-0.012-0.007 0-0.015 0-0.022 0.001-0.002-0-0.003-0-0.003-0v0c-0.484 0.012-0.883 0.369-0.961 0.834-0.050-0.010-0.101-0.025-0.153-0.039s-0.107-0.030-0.163-0.045c-0.028-0.008-0.056-0.015-0.084-0.024s-0.057-0.019-0.086-0.028-0.116-0.039-0.176-0.058c-0.015-0.005-0.030-0.010-0.045-0.015s-0.030-0.012-0.045-0.017-0.060-0.023-0.091-0.035-0.123-0.048-0.186-0.073c-0.062-0.028-0.125-0.056-0.189-0.084-0.032-0.014-0.064-0.028-0.096-0.043s-0.064-0.032-0.096-0.048-0.128-0.065-0.194-0.098c-0.065-0.034-0.129-0.073-0.194-0.109-0.032-0.018-0.065-0.037-0.098-0.056s-0.064-0.040-0.096-0.061c-0.064-0.041-0.129-0.082-0.194-0.124-0.255-0.175-0.506-0.369-0.744-0.583-0.236-0.217-0.459-0.451-0.665-0.697-0.202-0.25-0.385-0.511-0.547-0.776-0.159-0.268-0.294-0.541-0.41-0.808-0.027-0.068-0.053-0.135-0.079-0.202-0.013-0.033-0.027-0.066-0.038-0.099s-0.022-0.067-0.033-0.1-0.045-0.131-0.065-0.196c-0.018-0.065-0.036-0.13-0.054-0.194-0.009-0.032-0.019-0.063-0.026-0.095s-0.014-0.063-0.021-0.094-0.028-0.123-0.042-0.184c-0.011-0.061-0.021-0.12-0.032-0.179-0.005-0.029-0.010-0.058-0.015-0.087-0.003-0.014-0.005-0.028-0.008-0.043s-0.003-0.029-0.005-0.043c-0.007-0.056-0.014-0.112-0.020-0.166-0.003-0.027-0.007-0.053-0.010-0.080s-0.004-0.053-0.006-0.078-0.007-0.101-0.011-0.15c-0.003-0.049-0.008-0.095-0.008-0.142-0.002-0.091-0.004-0.177-0.006-0.256 0.003-0.073 0.005-0.14 0.007-0.2 0.001-0.030 0.002-0.058 0.002-0.085 0.002-0.033 0.004-0.064 0.006-0.093 0.002-0.033 0.004-0.063 0.006-0.091 0.008-0.051 0.012-0.103 0.012-0.156 0-0.007-0-0.015-0.001-0.022 0-0.002 0-0.003 0-0.003h-0c-0.012-0.49-0.377-0.893-0.851-0.964z"
    }
  }]
};
exports.spinner10 = spinner10;
var spinner11 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 6h-6l2.243-2.243c-1.133-1.133-2.64-1.757-4.243-1.757s-3.109 0.624-4.243 1.757c-1.133 1.133-1.757 2.64-1.757 4.243s0.624 3.109 1.757 4.243c1.133 1.133 2.64 1.757 4.243 1.757s3.109-0.624 4.243-1.757c0.095-0.095 0.185-0.192 0.273-0.292l1.505 1.317c-1.466 1.674-3.62 2.732-6.020 2.732-4.418 0-8-3.582-8-8s3.582-8 8-8c2.209 0 4.209 0.896 5.656 2.344l2.343-2.344v6z"
    }
  }]
};
exports.spinner11 = spinner11;
var binoculars = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 0h6v1h-6zM9 0h6v1h-6zM14.875 5h-0.875v-4h-4v4h-4v-4h-4v4h-0.875c-0.619 0-1.125 0.506-1.125 1.125v8.75c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-5.875h2v5.875c0 0.619 0.506 1.125 1.125 1.125h4.75c0.619 0 1.125-0.506 1.125-1.125v-8.75c0-0.619-0.506-1.125-1.125-1.125zM5.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5zM8.5 8h-1c-0.275 0-0.5-0.225-0.5-0.5s0.225-0.5 0.5-0.5h1c0.275 0 0.5 0.225 0.5 0.5s-0.225 0.5-0.5 0.5zM14.438 15h-3.875c-0.309 0-0.563-0.225-0.563-0.5s0.253-0.5 0.563-0.5h3.875c0.309 0 0.563 0.225 0.563 0.5s-0.253 0.5-0.563 0.5z"
    }
  }]
};
exports.binoculars = binoculars;
var search = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4z"
    }
  }]
};
exports.search = search;
var zoomIn = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM7 3h-2v2h-2v2h2v2h2v-2h2v-2h-2z"
    }
  }]
};
exports.zoomIn = zoomIn;
var zoomOut = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.504 13.616l-3.79-3.223c-0.392-0.353-0.811-0.514-1.149-0.499 0.895-1.048 1.435-2.407 1.435-3.893 0-3.314-2.686-6-6-6s-6 2.686-6 6 2.686 6 6 6c1.486 0 2.845-0.54 3.893-1.435-0.016 0.338 0.146 0.757 0.499 1.149l3.223 3.79c0.552 0.613 1.453 0.665 2.003 0.115s0.498-1.452-0.115-2.003zM6 10c-2.209 0-4-1.791-4-4s1.791-4 4-4 4 1.791 4 4-1.791 4-4 4zM3 5h6v2h-6z"
    }
  }]
};
exports.zoomOut = zoomOut;
var enlarge = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 0h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 16v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 16h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
    }
  }]
};
exports.enlarge = enlarge;
var shrink = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 7h6.5l-2.5-2.5 3-3-1.5-1.5-3 3-2.5-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 9v6.5l2.5-2.5 3 3 1.5-1.5-3-3 2.5-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9h-6.5l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 7v-6.5l-2.5 2.5-3-3-1.5 1.5 3 3-2.5 2.5z"
    }
  }]
};
exports.shrink = shrink;
var enlarge2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 0v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM7 10.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
    }
  }]
};
exports.enlarge2 = enlarge2;
var shrink2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9v6.5l-2.5-2.5-3 3-1.5-1.5 3-3-2.5-2.5zM16 1.5l-3 3 2.5 2.5h-6.5v-6.5l2.5 2.5 3-3z"
    }
  }]
};
exports.shrink2 = shrink2;
var key = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 0c-2.761 0-5 2.239-5 5 0 0.313 0.029 0.619 0.084 0.916l-6.084 6.084v3c0 0.552 0.448 1 1 1h1v-1h2v-2h2v-2h2l1.298-1.298c0.531 0.192 1.105 0.298 1.702 0.298 2.761 0 5-2.239 5-5s-2.239-5-5-5zM12.498 5.002c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
    }
  }]
};
exports.key = key;
var key2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.658 4.91l-1.58-1.58c-0.387-0.387-1.021-1.021-1.409-1.409l-1.58-1.58c-0.387-0.387-1.077-0.456-1.533-0.152l-4.319 2.88c-0.456 0.304-0.628 0.954-0.383 1.444l1.101 2.203c0.034 0.067 0.073 0.139 0.115 0.213l-5.571 5.571-0.5 3.5h3v-1h2v-2h2v-2h2v-1.112c0.1 0.060 0.196 0.113 0.284 0.157l2.203 1.101c0.49 0.245 1.14 0.072 1.444-0.383l2.88-4.319c0.304-0.456 0.236-1.146-0.152-1.533zM2.354 13.354l-0.707-0.707 4.868-4.868 0.707 0.707-4.868 4.868zM14.328 6.621l-0.707 0.707c-0.194 0.194-0.513 0.194-0.707 0l-4.243-4.243c-0.194-0.194-0.194-0.513 0-0.707l0.707-0.707c0.194-0.194 0.513-0.194 0.707 0l4.243 4.243c0.194 0.194 0.194 0.513 0 0.707z"
    }
  }]
};
exports.key2 = key2;
var lock = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.25 7h-0.25v-3c0-1.654-1.346-3-3-3h-2c-1.654 0-3 1.346-3 3v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v7.5c0 0.412 0.338 0.75 0.75 0.75h8.5c0.412 0 0.75-0.338 0.75-0.75v-7.5c0-0.412-0.338-0.75-0.75-0.75zM3 4c0-0.551 0.449-1 1-1h2c0.551 0 1 0.449 1 1v3h-4v-3z"
    }
  }]
};
exports.lock = lock;
var unlocked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 1c1.654 0 3 1.346 3 3v3h-2v-3c0-0.551-0.449-1-1-1h-2c-0.551 0-1 0.449-1 1v3h0.25c0.412 0 0.75 0.338 0.75 0.75v7.5c0 0.412-0.338 0.75-0.75 0.75h-8.5c-0.412 0-0.75-0.338-0.75-0.75v-7.5c0-0.412 0.338-0.75 0.75-0.75h6.25v-3c0-1.654 1.346-3 3-3h2z"
    }
  }]
};
exports.unlocked = unlocked;
var wrench = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.671 12.779l-7.196-6.168c0.335-0.63 0.525-1.348 0.525-2.111 0-2.485-2.015-4.5-4.5-4.5-0.455 0-0.893 0.068-1.307 0.193l2.6 2.6c0.389 0.389 0.389 1.025 0 1.414l-1.586 1.586c-0.389 0.389-1.025 0.389-1.414 0l-2.6-2.6c-0.125 0.414-0.193 0.852-0.193 1.307 0 2.485 2.015 4.5 4.5 4.5 0.763 0 1.482-0.19 2.111-0.525l6.168 7.196c0.358 0.418 0.969 0.441 1.358 0.052l1.586-1.586c0.389-0.389 0.365-1-0.052-1.358z"
    }
  }]
};
exports.wrench = wrench;
var equalizer = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 2v-0.25c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.337-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9zM4 4v-2h2v2h-2zM13 6.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.338-0.75 0.75v0.25h-9v2h9v0.25c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h3v-2h-3v-0.25zM10 9v-2h2v2h-2zM7 11.75c0-0.412-0.338-0.75-0.75-0.75h-2.5c-0.413 0-0.75 0.338-0.75 0.75v0.25h-3v2h3v0.25c0 0.412 0.337 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-0.25h9v-2h-9v-0.25zM4 14v-2h2v2h-2z"
    }
  }]
};
exports.equalizer = equalizer;
var equalizer2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 7h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v9h2v-9zM12 4h2v2h-2v-2zM9.25 13c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-9h-2v9h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v3h2v-3h0.25zM7 10h2v2h-2v-2zM4.25 7c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-0.25v-3h-2v3h-0.25c-0.413 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.337 0.75 0.75 0.75h0.25v9h2v-9h0.25zM2 4h2v2h-2v-2z"
    }
  }]
};
exports.equalizer2 = equalizer2;
var cog = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.59 9.535c-0.839-1.454-0.335-3.317 1.127-4.164l-1.572-2.723c-0.449 0.263-0.972 0.414-1.529 0.414-1.68 0-3.042-1.371-3.042-3.062h-3.145c0.004 0.522-0.126 1.051-0.406 1.535-0.839 1.454-2.706 1.948-4.17 1.106l-1.572 2.723c0.453 0.257 0.845 0.634 1.123 1.117 0.838 1.452 0.336 3.311-1.12 4.16l1.572 2.723c0.448-0.261 0.967-0.41 1.522-0.41 1.675 0 3.033 1.362 3.042 3.046h3.145c-0.001-0.517 0.129-1.040 0.406-1.519 0.838-1.452 2.7-1.947 4.163-1.11l1.572-2.723c-0.45-0.257-0.839-0.633-1.116-1.113zM8 11.24c-1.789 0-3.24-1.45-3.24-3.24s1.45-3.24 3.24-3.24c1.789 0 3.24 1.45 3.24 3.24s-1.45 3.24-3.24 3.24z"
    }
  }]
};
exports.cog = cog;
var cogs = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.683 11.282l0.645-0.903-0.707-0.707-0.903 0.645c-0.168-0.094-0.347-0.168-0.535-0.222l-0.183-1.095h-1l-0.183 1.095c-0.188 0.053-0.368 0.128-0.535 0.222l-0.903-0.645-0.707 0.707 0.645 0.903c-0.094 0.168-0.168 0.347-0.222 0.535l-1.095 0.183v1l1.095 0.183c0.053 0.188 0.128 0.368 0.222 0.535l-0.645 0.903 0.707 0.707 0.903-0.645c0.168 0.094 0.347 0.168 0.535 0.222l0.183 1.095h1l0.183-1.095c0.188-0.053 0.368-0.128 0.535-0.222l0.903 0.645 0.707-0.707-0.645-0.903c0.094-0.168 0.168-0.347 0.222-0.535l1.095-0.182v-1l-1.095-0.183c-0.053-0.188-0.128-0.368-0.222-0.535zM3.5 13.5c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1zM16 6v-1l-1.053-0.191c-0.019-0.126-0.044-0.25-0.074-0.372l0.899-0.58-0.383-0.924-1.046 0.226c-0.066-0.108-0.136-0.213-0.211-0.315l0.609-0.88-0.707-0.707-0.88 0.609c-0.102-0.074-0.207-0.145-0.315-0.211l0.226-1.046-0.924-0.383-0.58 0.899c-0.122-0.030-0.246-0.054-0.372-0.074l-0.191-1.053h-1l-0.191 1.053c-0.126 0.019-0.25 0.044-0.372 0.074l-0.58-0.899-0.924 0.383 0.226 1.046c-0.108 0.066-0.213 0.136-0.315 0.211l-0.88-0.609-0.707 0.707 0.609 0.88c-0.074 0.102-0.145 0.207-0.211 0.315l-1.046-0.226-0.383 0.924 0.899 0.58c-0.030 0.122-0.054 0.246-0.074 0.372l-1.053 0.191v1l1.053 0.191c0.019 0.126 0.044 0.25 0.074 0.372l-0.899 0.58 0.383 0.924 1.046-0.226c0.066 0.108 0.136 0.213 0.211 0.315l-0.609 0.88 0.707 0.707 0.88-0.609c0.102 0.074 0.207 0.145 0.315 0.211l-0.226 1.046 0.924 0.383 0.58-0.899c0.122 0.030 0.246 0.054 0.372 0.074l0.191 1.053h1l0.191-1.053c0.126-0.019 0.25-0.044 0.372-0.074l0.58 0.899 0.924-0.383-0.226-1.046c0.108-0.066 0.213-0.136 0.315-0.211l0.88 0.609 0.707-0.707-0.609-0.88c0.074-0.102 0.145-0.207 0.211-0.315l1.046 0.226 0.383-0.924-0.899-0.58c0.030-0.122 0.054-0.246 0.074-0.372l1.053-0.191zM10.5 7.675c-1.201 0-2.175-0.974-2.175-2.175s0.974-2.175 2.175-2.175 2.175 0.974 2.175 2.175c0 1.201-0.974 2.175-2.175 2.175z"
    }
  }]
};
exports.cogs = cogs;
var hammer = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.781 12.953l-4.712-4.712c-0.292-0.292-0.769-0.292-1.061 0l-0.354 0.354-2.875-2.875 4.72-4.72h-5l-2.22 2.22-0.22-0.22h-1.061v1.061l0.22 0.22-3.22 3.22 2.5 2.5 3.22-3.22 2.875 2.875-0.354 0.354c-0.292 0.292-0.292 0.769 0 1.061l4.712 4.712c0.292 0.292 0.769 0.292 1.061 0l1.768-1.768c0.292-0.292 0.292-0.769 0-1.061z"
    }
  }]
};
exports.hammer = hammer;
var magicWand = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 3l-2-2h-1v1l2 2zM5 0h1v2h-1zM9 5h2v1h-2zM10 2v-1h-1l-2 2 1 1zM0 5h2v1h-2zM5 9h1v2h-1zM1 9v1h1l2-2-1-1zM15.781 13.781l-9.939-9.939c-0.292-0.292-0.769-0.292-1.061 0l-0.939 0.939c-0.292 0.292-0.292 0.769 0 1.061l9.939 9.939c0.292 0.292 0.769 0.292 1.061 0l0.939-0.939c0.292-0.292 0.292-0.769 0-1.061zM7.5 8.5l-3-3 1-1 3 3-1 1z"
    }
  }]
};
exports.magicWand = magicWand;
var aidKit = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 4h-3v-2c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v2h-3c-1.1 0-2 0.9-2 2v8c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-8c0-1.1-0.9-2-2-2zM6 2h4v2h-4v-2zM12 11h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
    }
  }]
};
exports.aidKit = aidKit;
var bug = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9v-1h-3.020c-0.092-1.136-0.497-2.172-1.12-3.004h2.53l1.095-4.379-0.97-0.243-0.905 3.621h-2.729c-0.014-0.011-0.028-0.021-0.042-0.032 0.105-0.305 0.162-0.632 0.162-0.972 0-1.653-1.343-2.992-3-2.992s-3 1.34-3 2.992c0 0.34 0.057 0.667 0.162 0.972-0.014 0.011-0.028 0.021-0.042 0.032h-2.729l-0.905-3.621-0.97 0.243 1.095 4.379h2.53c-0.623 0.832-1.028 1.868-1.12 3.004h-3.020v1h3.021c0.059 0.713 0.242 1.388 0.526 1.996h-1.937l-1.095 4.379 0.97 0.243 0.905-3.621h1.756c0.917 1.219 2.303 1.996 3.854 1.996s2.937-0.777 3.854-1.996h1.756l0.905 3.621 0.97-0.243-1.095-4.379h-1.937c0.283-0.608 0.466-1.283 0.526-1.996h3.021z"
    }
  }]
};
exports.bug = bug;
var pieChart = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9v-7c-3.866 0-7 3.134-7 7s3.134 7 7 7 7-3.134 7-7c0-1.126-0.266-2.189-0.738-3.131l-6.262 3.131zM14.262 3.869c-1.149-2.294-3.521-3.869-6.262-3.869v7l6.262-3.131z"
    }
  }]
};
exports.pieChart = pieChart;
var statsDots = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 14h14v2h-16v-16h2zM4.5 13c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.044 0 0.088 0.002 0.131 0.006l1.612-2.687c-0.154-0.235-0.243-0.517-0.243-0.819 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.302-0.090 0.583-0.243 0.819l1.612 2.687c0.043-0.004 0.087-0.006 0.131-0.006 0.033 0 0.066 0.001 0.099 0.004l2.662-4.658c-0.165-0.241-0.261-0.532-0.261-0.845 0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5-0.033 0-0.066-0.001-0.099-0.004l-2.662 4.658c0.165 0.241 0.261 0.532 0.261 0.845 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.302 0.090-0.583 0.243-0.819l-1.612-2.687c-0.043 0.004-0.087 0.006-0.131 0.006s-0.088-0.002-0.131-0.006l-1.612 2.687c0.154 0.235 0.243 0.517 0.243 0.819 0 0.828-0.672 1.5-1.5 1.5z"
    }
  }]
};
exports.statsDots = statsDots;
var statsBars = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 13h16v2h-16zM2 9h2v3h-2zM5 5h2v7h-2zM8 8h2v4h-2zM11 2h2v10h-2z"
    }
  }]
};
exports.statsBars = statsBars;
var statsBars2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 6h-3c-0.275 0-0.5 0.225-0.5 0.5v9c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.225-0.5-0.5-0.5zM4.5 15h-3v-4h3v4zM9.5 4h-3c-0.275 0-0.5 0.225-0.5 0.5v11c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-11c0-0.275-0.225-0.5-0.5-0.5zM9.5 15h-3v-5h3v5zM14.5 2h-3c-0.275 0-0.5 0.225-0.5 0.5v13c0 0.275 0.225 0.5 0.5 0.5h3c0.275 0 0.5-0.225 0.5-0.5v-13c0-0.275-0.225-0.5-0.5-0.5zM14.5 15h-3v-6h3v6z"
    }
  }]
};
exports.statsBars2 = statsBars2;
var trophy = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 3v-2h-10v2h-3v2c0 1.657 1.343 3 3 3 0.314 0 0.616-0.048 0.9-0.138 0.721 1.031 1.822 1.778 3.1 2.037v3.1h-1c-1.105 0-2 0.895-2 2h8c0-1.105-0.895-2-2-2h-1v-3.1c1.278-0.259 2.378-1.006 3.1-2.037 0.284 0.089 0.587 0.138 0.9 0.138 1.657 0 3-1.343 3-3v-2h-3zM3 6.813c-0.999 0-1.813-0.813-1.813-1.813v-1h1.813v1c0 0.628 0.116 1.229 0.327 1.782-0.106 0.019-0.216 0.030-0.327 0.030zM14.813 5c0 0.999-0.813 1.813-1.813 1.813-0.112 0-0.221-0.011-0.327-0.030 0.211-0.554 0.327-1.154 0.327-1.782v-1h1.813v1z"
    }
  }]
};
exports.trophy = trophy;
var gift = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.055 5c0.283-0.201 0.555-0.425 0.804-0.674 0.522-0.522 0.871-1.164 0.983-1.808 0.123-0.706-0.057-1.362-0.494-1.798-0.348-0.348-0.82-0.533-1.365-0.533-0.775 0-1.593 0.372-2.242 1.021-1.039 1.039-1.644 2.472-1.97 3.496-0.241-1.028-0.722-2.416-1.657-3.351-0.501-0.501-1.142-0.759-1.748-0.759-0.495 0-0.965 0.172-1.317 0.523-0.781 0.781-0.675 2.153 0.236 3.064 0.325 0.325 0.705 0.595 1.105 0.819h-3.391v4h1v7h12v-7h1v-4h-2.945zM10.536 2.003c0.433-0.433 0.974-0.692 1.446-0.692 0.167 0 0.402 0.035 0.57 0.203 0.407 0.407 0.178 1.349-0.489 2.016-0.687 0.687-1.61 1.159-2.413 1.47h-0.792c0.29-0.899 0.813-2.132 1.678-2.997zM3.655 2.514c-0.011-0.143-0.001-0.41 0.191-0.601 0.16-0.16 0.372-0.194 0.521-0.194v0c0.332 0 0.679 0.157 0.952 0.429 0.529 0.529 0.965 1.371 1.26 2.436 0.008 0.029 0.016 0.057 0.023 0.086-0.028-0.008-0.057-0.015-0.086-0.023-1.064-0.295-1.906-0.731-2.436-1.26-0.247-0.247-0.403-0.565-0.426-0.872zM7 15h-4v-6.5h4v6.5zM7 8h-5v-2h5v2zM13 15h-4v-6.5h4v6.5zM14 8h-5v-2h5v2z"
    }
  }]
};
exports.gift = gift;
var glass = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.153 0.263c-0.087-0.162-0.256-0.263-0.44-0.263h-7.425c-0.184 0-0.353 0.101-0.44 0.263-0.554 1.032-0.847 2.237-0.847 3.487 0 1.647 0.506 3.2 1.424 4.374 0.71 0.907 1.601 1.508 2.576 1.753v5.123h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.123c0.975-0.244 1.866-0.846 2.576-1.753 0.918-1.174 1.424-2.727 1.424-4.374 0-1.249-0.293-2.455-0.847-3.487zM4.595 1h6.809c0.39 0.827 0.595 1.771 0.595 2.75 0 0.084-0.002 0.167-0.005 0.25h-7.991c-0.003-0.083-0.005-0.166-0.005-0.25-0-0.979 0.205-1.923 0.595-2.75z"
    }
  }]
};
exports.glass = glass;
var glass2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.893 2.809c0.118-0.151 0.14-0.355 0.057-0.527s-0.258-0.281-0.45-0.281h-11c-0.191 0-0.366 0.109-0.45 0.281s-0.062 0.377 0.057 0.527l4.893 6.228v5.963h-1.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-1.5v-5.963l4.893-6.228zM12.471 3l-1.571 2h-5.8l-1.571-2h8.943z"
    }
  }]
};
exports.glass2 = glass2;
var mug = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 5h-3v-1.5c0-1.381-2.686-2.5-6-2.5s-6 1.119-6 2.5v10c0 1.381 2.686 2.5 6 2.5s6-1.119 6-2.5v-1.5h3c0.552 0 1-0.448 1-1v-5c0-0.552-0.448-1-1-1zM2.751 4.037c-0.578-0.19-0.928-0.394-1.116-0.537 0.188-0.143 0.538-0.347 1.116-0.537 0.905-0.298 2.059-0.463 3.249-0.463s2.344 0.164 3.249 0.463c0.578 0.19 0.928 0.394 1.116 0.537-0.188 0.143-0.538 0.347-1.116 0.537-0.905 0.298-2.059 0.463-3.249 0.463s-2.344-0.164-3.249-0.463zM14 10h-2v-3h2v3z"
    }
  }]
};
exports.mug = mug;
var spoonKnife = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.5 0c-1.657 0-3 1.567-3 3.5 0 1.655 0.985 3.042 2.308 3.406l-0.497 8.096c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.497-8.096c1.323-0.365 2.308-1.751 2.308-3.406 0-1.933-1.343-3.5-3-3.5zM13.583 0l-0.833 5h-0.625l-0.417-5h-0.417l-0.417 5h-0.625l-0.833-5h-0.417v6.5c0 0.276 0.224 0.5 0.5 0.5h1.302l-0.491 8.002c-0.034 0.549 0.389 0.998 0.939 0.998h0.5c0.55 0 0.972-0.449 0.939-0.998l-0.491-8.002h1.302c0.276 0 0.5-0.224 0.5-0.5v-6.5h-0.417z"
    }
  }]
};
exports.spoonKnife = spoonKnife;
var leaf = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.802 2.102c-1.73-1.311-4.393-2.094-7.124-2.094-3.377 0-6.129 1.179-7.549 3.235-0.667 0.965-1.036 2.109-1.097 3.398-0.054 1.148 0.139 2.418 0.573 3.784 1.482-4.444 5.622-7.923 10.395-7.923 0 0-4.466 1.175-7.274 4.816-0.002 0.002-0.039 0.048-0.103 0.136-0.564 0.754-1.055 1.612-1.423 2.583-0.623 1.482-1.2 3.515-1.2 5.965h2c0 0-0.304-1.91 0.224-4.106 0.873 0.118 1.654 0.177 2.357 0.177 1.839 0 3.146-0.398 4.115-1.252 0.868-0.765 1.347-1.794 1.854-2.882 0.774-1.663 1.651-3.547 4.198-5.002 0.146-0.083 0.24-0.234 0.251-0.402s-0.063-0.329-0.197-0.431z"
    }
  }]
};
exports.leaf = leaf;
var rocket = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 1l-5 5h-3l-3 4c0 0 3.178-0.885 5.032-0.47l-5.032 6.47 6.592-5.127c0.919 2.104-0.592 5.127-0.592 5.127l4-3v-3l5-5 1-5-5 1z"
    }
  }]
};
exports.rocket = rocket;
var meter = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1c4.418 0 8 3.582 8 8 0 3.012-1.665 5.635-4.125 7h-7.75c-2.46-1.365-4.125-3.988-4.125-7 0-4.418 3.582-8 8-8zM12.53 13.53c1.21-1.21 1.876-2.819 1.876-4.53h-1.406v-1h1.329c-0.11-0.703-0.334-1.377-0.665-2h-1.664v-1h1.004c-0.147-0.184-0.306-0.361-0.475-0.53-0.722-0.722-1.587-1.251-2.53-1.559v1.089h-1v-1.329c-0.328-0.051-0.662-0.078-1-0.078s-0.672 0.026-1 0.078v1.329h-1v-1.089c-0.943 0.309-1.808 0.837-2.53 1.559-0.169 0.169-0.327 0.346-0.475 0.53h1.004v1h-1.664c-0.331 0.623-0.555 1.297-0.665 2h1.329v1h-1.406c0 1.711 0.666 3.32 1.876 4.53 0.167 0.167 0.343 0.324 0.524 0.47h3.006l0.571-8h0.857l0.571 8h3.006c0.182-0.146 0.357-0.303 0.524-0.47z"
    }
  }]
};
exports.meter = meter;
var meter2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.732 13.034c0.174-0.479 0.268-0.995 0.268-1.534 0-1.943-1.231-3.598-2.956-4.228 0.16-1.327 0.754-2.555 1.714-3.514 1.133-1.133 2.64-1.757 4.243-1.757s3.109 0.624 4.243 1.757c0.96 0.96 1.554 2.188 1.714 3.514-1.725 0.63-2.956 2.285-2.956 4.228 0 0.539 0.095 1.055 0.268 1.534-0.964 0.629-2.090 0.966-3.268 0.966s-2.304-0.338-3.268-0.966zM8.621 10.016c0.217 0.055 0.379 0.251 0.379 0.484v1c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1c0-0.233 0.162-0.43 0.379-0.484l0.371-7.016h0.5l0.371 7.016z"
    }
  }]
};
exports.meter2 = meter2;
var hammer2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.784 14.309l-8.572-7.804 0.399-0.4c0.326-0.327 0.503-0.75 0.53-1.181 0.016-0.007 0.031-0.014 0.046-0.023l1.609-1.006c0.218-0.256 0.202-0.66-0.036-0.898l-2.799-2.806c-0.237-0.238-0.641-0.254-0.896-0.036l-1.004 1.614c-0.008 0.015-0.015 0.031-0.022 0.046-0.43 0.027-0.852 0.204-1.178 0.531l-1.522 1.527c-0.327 0.327-0.503 0.75-0.53 1.181-0.016 0.007-0.031 0.014-0.046 0.023l-1.609 1.006c-0.218 0.256-0.202 0.66 0.036 0.898l2.799 2.806c0.237 0.238 0.641 0.254 0.896 0.036l1.004-1.614c0.008-0.015 0.015-0.031 0.023-0.046 0.43-0.027 0.852-0.204 1.178-0.531l0.442-0.443 7.783 8.596c0.226 0.249 0.573 0.289 0.773 0.089l0.787-0.789c0.199-0.2 0.159-0.549-0.089-0.775z"
    }
  }]
};
exports.hammer2 = hammer2;
var fire = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.016 16c-1.066-2.219-0.498-3.49 0.321-4.688 0.897-1.312 1.129-2.61 1.129-2.61s0.706 0.917 0.423 2.352c1.246-1.387 1.482-3.598 1.293-4.445 2.817 1.969 4.021 6.232 2.399 9.392 8.631-4.883 2.147-12.19 1.018-13.013 0.376 0.823 0.448 2.216-0.313 2.893-1.287-4.879-4.468-5.879-4.468-5.879 0.376 2.516-1.364 5.268-3.042 7.324-0.059-1.003-0.122-1.696-0.649-2.656-0.118 1.823-1.511 3.309-1.889 5.135-0.511 2.473 0.383 4.284 3.777 6.197z"
    }
  }]
};
exports.fire = fire;
var lab = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.942 12.57l-4.942-8.235v-3.335h0.5c0.275 0 0.5-0.225 0.5-0.5s-0.225-0.5-0.5-0.5h-5c-0.275 0-0.5 0.225-0.5 0.5s0.225 0.5 0.5 0.5h0.5v3.335l-4.942 8.235c-1.132 1.886-0.258 3.43 1.942 3.43h10c2.2 0 3.074-1.543 1.942-3.43zM3.766 10l3.234-5.39v-3.61h2v3.61l3.234 5.39h-8.468z"
    }
  }]
};
exports.lab = lab;
var magnet = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 0h-4l1 9c0 1.657-1.343 3-3 3s-3-1.343-3-3l1-9h-4l-1 9c0 3.866 3.134 7 7 7s7-3.134 7-7l-1-9zM12.154 13.154c-1.11 1.11-2.585 1.721-4.154 1.721s-3.045-0.611-4.154-1.721c-1.096-1.096-1.705-2.548-1.72-4.095l0.564-5.075h1.736l-0.55 4.953v0.062c0 1.102 0.429 2.138 1.208 2.917s1.815 1.208 2.917 1.208 2.138-0.429 2.917-1.208c0.779-0.779 1.208-1.815 1.208-2.917v-0.062l-0.007-0.062-0.543-4.891h1.736l0.564 5.075c-0.015 1.547-0.625 2.999-1.72 4.095z"
    }
  }]
};
exports.magnet = magnet;
var bin = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 5v10c0 0.55 0.45 1 1 1h9c0.55 0 1-0.45 1-1v-10h-11zM5 14h-1v-7h1v7zM7 14h-1v-7h1v7zM9 14h-1v-7h1v7zM11 14h-1v-7h1v7z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.25 2h-3.25v-1.25c0-0.412-0.338-0.75-0.75-0.75h-3.5c-0.412 0-0.75 0.338-0.75 0.75v1.25h-3.25c-0.413 0-0.75 0.337-0.75 0.75v1.25h13v-1.25c0-0.413-0.338-0.75-0.75-0.75zM9 2h-3v-0.987h3v0.987z"
    }
  }]
};
exports.bin = bin;
var bin2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 16h10l1-11h-12zM10 2v-2h-4v2h-5v3l1-1h12l1 1v-3h-5zM9 2h-2v-1h2v1z"
    }
  }]
};
exports.bin2 = bin2;
var briefcase = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 4h-4v-1c0-0.55-0.45-1-1-1h-4c-0.55 0-1 0.45-1 1v1h-4c-0.55 0-1 0.45-1 1v9c0 0.55 0.45 1 1 1h14c0.55 0 1-0.45 1-1v-9c0-0.55-0.45-1-1-1zM6 3.002c0.001-0.001 0.001-0.001 0.002-0.002h3.996c0.001 0.001 0.001 0.001 0.002 0.002v0.998h-4v-0.998zM15 8h-2v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-6v1.5c0 0.275-0.225 0.5-0.5 0.5h-1c-0.275 0-0.5-0.225-0.5-0.5v-1.5h-2v-1h14v1z"
    }
  }]
};
exports.briefcase = briefcase;
var airplane = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 9.999l-2.857-2.857 6.857-5.143-2-2-8.571 3.429-2.698-2.699c-0.778-0.778-1.864-0.964-2.414-0.414s-0.364 1.636 0.414 2.414l2.698 2.698-3.429 8.572 2 2 5.144-6.857 2.857 2.857v4h2l1-3 3-1v-2l-4 0z"
    }
  }]
};
exports.airplane = airplane;
var truck = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9l-2-4h-3v-2c0-0.55-0.45-1-1-1h-9c-0.55 0-1 0.45-1 1v8l1 1h1.268c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h5.536c-0.17 0.294-0.268 0.636-0.268 1 0 1.105 0.895 2 2 2s2-0.895 2-2c0-0.364-0.098-0.706-0.268-1h1.268v-3zM11 9v-3h2.073l1.5 3h-3.573z"
    }
  }]
};
exports.truck = truck;
var road = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 16h5l-4-16h-3l0.5 4h-3l0.5-4h-3l-4 16h5l0.5-4h5l0.5 4zM5.75 10l0.5-4h3.5l0.5 4h-4.5z"
    }
  }]
};
exports.road = road;
var accessibility = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 5l5.15-2.221-0.371-0.929-6.279 2.15h-1l-6.279-2.15-0.371 0.929 5.15 2.221v4l-2.051 6.634 0.935 0.355 2.902-6.489h0.429l2.902 6.489 0.935-0.355-2.051-6.634z"
    }
  }]
};
exports.accessibility = accessibility;
var target = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 7h-1.577c-0.432-2.785-2.638-4.991-5.423-5.423v-1.577h-2v1.577c-2.785 0.432-4.991 2.638-5.423 5.423h-1.577v2h1.577c0.432 2.785 2.638 4.991 5.423 5.423v1.577h2v-1.577c2.785-0.432 4.991-2.638 5.423-5.423h1.577v-2zM12.388 7h-1.559c-0.301-0.852-0.977-1.528-1.829-1.829v-1.559c1.68 0.383 3.005 1.708 3.388 3.388zM8 9c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1s-0.448 1-1 1zM7 3.612v1.559c-0.852 0.301-1.528 0.977-1.829 1.829h-1.559c0.383-1.68 1.708-3.005 3.388-3.388zM3.612 9h1.559c0.301 0.852 0.977 1.528 1.829 1.829v1.559c-1.68-0.383-3.005-1.708-3.388-3.388zM9 12.388v-1.559c0.852-0.301 1.528-0.977 1.829-1.829h1.559c-0.383 1.68-1.708 3.005-3.388 3.388z"
    }
  }]
};
exports.target = target;
var shield = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 0l-7 2-7-2c0 0-0.070 0.808 0 2l7 2.189 7-2.189c0.070-1.192 0-2 0-2zM1.128 3.049c0.375 3.917 1.773 10.504 6.872 12.951 5.099-2.448 6.497-9.034 6.872-12.951l-6.872 2.584-6.872-2.584z"
    }
  }]
};
exports.shield = shield;
var power = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 0l-6 8h6l-4 8 14-10h-8l6-6z"
    }
  }]
};
exports.power = power;
var switchIcon = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 2.29v2.124c0.566 0.247 1.086 0.6 1.536 1.050 0.944 0.944 1.464 2.2 1.464 3.536s-0.52 2.591-1.464 3.536c-0.944 0.944-2.2 1.464-3.536 1.464s-2.591-0.52-3.536-1.464c-0.944-0.944-1.464-2.2-1.464-3.536s0.52-2.591 1.464-3.536c0.45-0.45 0.97-0.803 1.536-1.050v-2.124c-2.891 0.861-5 3.539-5 6.71 0 3.866 3.134 7 7 7s7-3.134 7-7c0-3.171-2.109-5.849-5-6.71zM7 0h2v8h-2z"
    }
  }]
};
exports.switchIcon = switchIcon;
var powerCord = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 4.414l-1.414-1.414-2.793 2.793-1.586-1.586 2.793-2.793-1.414-1.414-2.793 2.793-1.793-1.793-1.354 1.353 8 8 1.354-1.353-1.793-1.793 2.793-2.793z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.407 10.528l-6.935-6.935c-1.497 1.795-3.196 4.57-2.022 6.957l-2.066 2.066c-0.486 0.486-0.486 1.282 0 1.768l0.232 0.232c0.486 0.486 1.282 0.486 1.768 0l2.066-2.066c2.387 1.174 5.161-0.524 6.957-2.022z"
    }
  }]
};
exports.powerCord = powerCord;
var clipboard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 2h-4.5c0-1.105-0.895-2-2-2s-2 0.895-2 2h-4.5c-0.276 0-0.5 0.224-0.5 0.5v13c0 0.276 0.224 0.5 0.5 0.5h13c0.276 0 0.5-0.224 0.5-0.5v-13c0-0.276-0.224-0.5-0.5-0.5zM8 1c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1s0.448-1 1-1zM14 15h-12v-12h2v1.5c0 0.276 0.224 0.5 0.5 0.5h7c0.276 0 0.5-0.224 0.5-0.5v-1.5h2v12z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 13.414l-3.207-3.707 0.914-0.914 2.293 1.793 4.293-3.793 0.914 0.914z"
    }
  }]
};
exports.clipboard = clipboard;
var listNumbered = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 13h10v2h-10zM6 7h10v2h-10zM6 1h10v2h-10zM3 0v4h-1v-3h-1v-1zM2 8.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM4 11v5h-3v-1h2v-1h-2v-1h2v-1h-2v-1z"
    }
  }]
};
exports.listNumbered = listNumbered;
var list = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0h4v4h-4zM6 1h10v2h-10zM0 6h4v4h-4zM6 7h10v2h-10zM0 12h4v4h-4zM6 13h10v2h-10z"
    }
  }]
};
exports.list = list;
var list2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 1h10v2h-10v-2zM6 7h10v2h-10v-2zM6 13h10v2h-10v-2zM0 2c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 8c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM0 14c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2z"
    }
  }]
};
exports.list2 = list2;
var tree = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.25 12h-0.25v-3.25c0-0.965-0.785-1.75-1.75-1.75h-4.25v-2h0.25c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.413-0.338-0.75-0.75-0.75h-2.5c-0.412 0-0.75 0.337-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h0.25v2h-4.25c-0.965 0-1.75 0.785-1.75 1.75v3.25h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.413 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.337-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75h-0.25v-3h4v3h-0.25c-0.412 0-0.75 0.338-0.75 0.75v2.5c0 0.412 0.338 0.75 0.75 0.75h2.5c0.412 0 0.75-0.338 0.75-0.75v-2.5c0-0.412-0.338-0.75-0.75-0.75zM3 15h-2v-2h2v2zM9 15h-2v-2h2v2zM7 4v-2h2v2h-2zM15 15h-2v-2h2v2z"
    }
  }]
};
exports.tree = tree;
var menu = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 3h14v3h-14zM1 7h14v3h-14zM1 11h14v3h-14z"
    }
  }]
};
exports.menu = menu;
var menu2 = {
  "viewBox": "0 0 22 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.5 9l3 3 3-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M21.5 8l-3-3-3 3z"
    }
  }]
};
exports.menu2 = menu2;
var menu3 = {
  "viewBox": "0 0 22 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.5 7l3 3 3-3z"
    }
  }]
};
exports.menu3 = menu3;
var menu4 = {
  "viewBox": "0 0 22 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3h14v3h-14v-3zM0 7h14v3h-14v-3zM0 11h14v3h-14v-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.5 10l3-3 3 3z"
    }
  }]
};
exports.menu4 = menu4;
var cloud = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 10.274c0-1.283-0.886-2.358-2.078-2.648-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029l10.254-0c1.502-0.003 2.719-1.222 2.719-2.726z"
    }
  }]
};
exports.cloud = cloud;
var cloudDownload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.922 5.626c-0.051-2.011-1.695-3.626-3.717-3.626-1.184 0-2.239 0.555-2.92 1.418-0.382-0.494-0.98-0.812-1.652-0.812-1.153 0-2.088 0.936-2.088 2.089 0 0.101 0.007 0.199 0.021 0.296-0.175-0.032-0.356-0.049-0.54-0.049-1.672-0-3.027 1.356-3.027 3.029s1.355 3.029 3.027 3.029h1.434l3.539 3.664 3.539-3.664 1.742-0c1.502-0.003 2.719-1.222 2.719-2.726 0-1.283-0.886-2.358-2.078-2.648zM8 13l-3-3h2v-3h2v3h2l-3 3z"
    }
  }]
};
exports.cloudDownload = cloudDownload;
var cloudUpload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.942 6.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h2v3h4v-3h3.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.253-2.058-2.461zM9 10v3h-2v-3h-2.5l3.5-3.5 3.5 3.5h-2.5z"
    }
  }]
};
exports.cloudUpload = cloudUpload;
var cloudCheck = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.942 8.039c0.038-0.174 0.058-0.354 0.058-0.539 0-1.381-1.119-2.5-2.5-2.5-0.222 0-0.438 0.029-0.643 0.084-0.387-1.209-1.52-2.084-2.857-2.084-1.365 0-2.516 0.911-2.88 2.159-0.355-0.103-0.731-0.159-1.12-0.159-2.209 0-4 1.791-4 4s1.791 4 4 4h9.5c1.381 0 2.5-1.119 2.5-2.5 0-1.23-0.888-2.252-2.058-2.461zM6.5 12l-2.5-2.5 1-1 1.5 1.5 3.5-3.5 1 1-4.5 4.5z"
    }
  }]
};
exports.cloudCheck = cloudCheck;
var download2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 8h-2.5l-3.5 3.5-3.5-3.5h-2.5l-2 4v1h16v-1l-2-4zM0 14h16v1h-16v-1zM9 5v-4h-2v4h-3.5l4.5 4.5 4.5-4.5h-3.5z"
    }
  }]
};
exports.download2 = download2;
var upload2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 14h16v1h-16zM16 12v1h-16v-1l2-4h4v2h4v-2h4zM3.5 5l4.5-4.5 4.5 4.5h-3.5v4h-2v-4z"
    }
  }]
};
exports.upload2 = upload2;
var download3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 7l-4 4-4-4h2.5v-6h3v6zM7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1z"
    }
  }]
};
exports.download3 = download3;
var upload3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 11h-7.5v4h15v-4h-7.5zM14 13h-2v-1h2v1zM3.5 5l4-4 4 4h-2.5v5h-3v-5z"
    }
  }]
};
exports.upload3 = upload3;
var sphere = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.5 1c-4.142 0-7.5 3.358-7.5 7.5s3.358 7.5 7.5 7.5c4.142 0 7.5-3.358 7.5-7.5s-3.358-7.5-7.5-7.5zM11.744 11c0.134-0.632 0.219-1.303 0.246-2h1.991c-0.052 0.691-0.213 1.361-0.479 2h-1.758zM3.256 6c-0.134 0.632-0.219 1.303-0.246 2h-1.991c0.052-0.691 0.213-1.361 0.479-2h1.758zM10.719 6c0.15 0.64 0.241 1.31 0.27 2h-2.989v-2h2.719zM8 5v-2.927c0.228 0.066 0.454 0.178 0.675 0.334 0.415 0.293 0.813 0.744 1.149 1.304 0.233 0.388 0.434 0.819 0.601 1.289h-2.426zM5.176 3.711c0.336-0.561 0.734-1.012 1.149-1.304 0.222-0.156 0.447-0.268 0.675-0.334v2.927h-2.426c0.168-0.47 0.369-0.901 0.601-1.289zM7 6v2h-2.989c0.029-0.69 0.12-1.36 0.27-2h2.719zM1.498 11c-0.266-0.639-0.427-1.309-0.479-2h1.991c0.028 0.697 0.112 1.368 0.246 2h-1.758zM4.011 9h2.989v2h-2.719c-0.15-0.64-0.241-1.31-0.27-2zM7 12v2.927c-0.228-0.066-0.454-0.178-0.675-0.334-0.415-0.293-0.813-0.744-1.149-1.304-0.233-0.388-0.434-0.819-0.602-1.289h2.426zM9.825 13.289c-0.336 0.561-0.734 1.012-1.149 1.304-0.222 0.156-0.447 0.268-0.675 0.334v-2.927h2.426c-0.168 0.47-0.369 0.901-0.602 1.289zM8 11v-2h2.989c-0.029 0.69-0.12 1.36-0.27 2h-2.719zM11.99 8c-0.028-0.697-0.112-1.368-0.246-2h1.758c0.267 0.639 0.427 1.309 0.479 2h-1.991zM12.979 5h-1.498c-0.291-0.918-0.693-1.723-1.177-2.366 0.665 0.318 1.267 0.744 1.792 1.27 0.336 0.336 0.631 0.702 0.883 1.096zM2.904 3.904c0.526-0.526 1.128-0.952 1.792-1.27-0.483 0.643-0.886 1.448-1.177 2.366h-1.498c0.252-0.394 0.547-0.761 0.883-1.096zM2.021 12h1.498c0.291 0.918 0.693 1.723 1.177 2.366-0.665-0.318-1.267-0.744-1.792-1.27-0.336-0.336-0.631-0.702-0.883-1.096zM12.096 13.096c-0.526 0.526-1.128 0.952-1.792 1.27 0.483-0.643 0.886-1.448 1.177-2.366h1.498c-0.252 0.394-0.547 0.761-0.883 1.096z"
    }
  }]
};
exports.sphere = sphere;
var earth = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-0.984 0-1.92-0.203-2.769-0.57l3.643-4.098c0.081-0.092 0.126-0.21 0.126-0.332v-1.5c0-0.276-0.224-0.5-0.5-0.5-1.765 0-3.628-1.835-3.646-1.854-0.094-0.094-0.221-0.146-0.354-0.146h-2c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.189 0.107 0.363 0.276 0.447l1.724 0.862v2.936c-1.813-1.265-3-3.366-3-5.745 0-1.074 0.242-2.091 0.674-3h1.826c0.133 0 0.26-0.053 0.354-0.146l2-2c0.094-0.094 0.146-0.221 0.146-0.354v-1.21c0.634-0.189 1.305-0.29 2-0.29 1.1 0 2.141 0.254 3.067 0.706-0.065 0.055-0.128 0.112-0.188 0.172-0.567 0.567-0.879 1.32-0.879 2.121s0.312 1.555 0.879 2.121c0.569 0.569 1.332 0.879 2.119 0.879 0.049 0 0.099-0.001 0.149-0.004 0.216 0.809 0.605 2.917-0.131 5.818-0.007 0.027-0.011 0.055-0.013 0.082-1.271 1.298-3.042 2.104-5.002 2.104z"
    }
  }]
};
exports.earth = earth;
var link = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.879 9.934c-0.208 0-0.416-0.079-0.575-0.238-1.486-1.486-1.486-3.905 0-5.392l3-3c0.72-0.72 1.678-1.117 2.696-1.117s1.976 0.397 2.696 1.117c1.486 1.487 1.486 3.905 0 5.392l-1.371 1.371c-0.317 0.317-0.832 0.317-1.149 0s-0.317-0.832 0-1.149l1.371-1.371c0.853-0.853 0.853-2.241 0-3.094-0.413-0.413-0.963-0.641-1.547-0.641s-1.134 0.228-1.547 0.641l-3 3c-0.853 0.853-0.853 2.241 0 3.094 0.317 0.317 0.317 0.832 0 1.149-0.159 0.159-0.367 0.238-0.575 0.238z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 15.813c-1.018 0-1.976-0.397-2.696-1.117-1.486-1.486-1.486-3.905 0-5.392l1.371-1.371c0.317-0.317 0.832-0.317 1.149 0s0.317 0.832 0 1.149l-1.371 1.371c-0.853 0.853-0.853 2.241 0 3.094 0.413 0.413 0.962 0.641 1.547 0.641s1.134-0.228 1.547-0.641l3-3c0.853-0.853 0.853-2.241 0-3.094-0.317-0.317-0.317-0.832 0-1.149s0.832-0.317 1.149 0c1.486 1.486 1.486 3.905 0 5.392l-3 3c-0.72 0.72-1.678 1.117-2.696 1.117z"
    }
  }]
};
exports.link = link;
var flag = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0h2v16h-2v-16z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 10.047c1.291 0 2.415-0.312 3-0.773v-8c-0.585 0.461-1.709 0.773-3 0.773s-2.415-0.312-3-0.773v8c0.585 0.461 1.709 0.773 3 0.773z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 0.508c-0.733-0.312-1.805-0.508-3-0.508-1.506 0-2.818 0.312-3.5 0.773v8c0.682-0.461 1.994-0.773 3.5-0.773 1.195 0 2.267 0.197 3 0.508v-8z"
    }
  }]
};
exports.flag = flag;
var attachment = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.404 5.11l-1.015-1.014-5.075 5.074c-0.841 0.841-0.841 2.204 0 3.044s2.204 0.841 3.045 0l6.090-6.089c1.402-1.401 1.402-3.673 0-5.074s-3.674-1.402-5.075 0l-6.394 6.393c-0.005 0.005-0.010 0.009-0.014 0.013-1.955 1.955-1.955 5.123 0 7.077s5.123 1.954 7.078 0c0.004-0.004 0.008-0.009 0.013-0.014l0.001 0.001 4.365-4.364-1.015-1.014-4.365 4.363c-0.005 0.004-0.009 0.009-0.013 0.013-1.392 1.392-3.656 1.392-5.048 0s-1.392-3.655 0-5.047c0.005-0.005 0.009-0.009 0.014-0.013l-0.001-0.001 6.395-6.393c0.839-0.84 2.205-0.84 3.045 0s0.839 2.205 0 3.044l-6.090 6.089c-0.28 0.28-0.735 0.28-1.015 0s-0.28-0.735 0-1.014l5.075-5.075z"
    }
  }]
};
exports.attachment = attachment;
var eye = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 3c-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-1.486-2.968-4.511-5-8-5zM11.945 5.652c0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.737-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114v0zM8 6.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5z"
    }
  }]
};
exports.eye = eye;
var eyePlus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 2h-2v-2h-2v2h-2v2h2v2h2v-2h2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.498 6.969c0.288 0.32 0.55 0.665 0.782 1.031-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.011-0-0.022-0-0.032-1.708-0.44-2.973-1.979-2.999-3.817-0.329-0.037-0.662-0.057-1.001-0.057-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.276-0.55-0.604-1.069-0.979-1.548-0.457 0.268-0.973 0.449-1.523 0.517zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5z"
    }
  }]
};
exports.eyePlus = eyePlus;
var eyeMinus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 2h6v2h-6v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.599 5h-4.599v-1.944c-0.328-0.037-0.662-0.056-1-0.056-3.489 0-6.514 2.032-8 5 1.486 2.968 4.511 5 8 5s6.514-2.032 8-5c-0.584-1.167-1.407-2.189-2.401-3zM6.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM11.944 10.348c-1.181 0.753-2.545 1.152-3.944 1.152s-2.763-0.398-3.945-1.152c-0.94-0.6-1.736-1.403-2.335-2.348 0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 2.209 1.791 4 4 4s4-1.791 4-4c0-0.481-0.085-0.942-0.241-1.369 0.062 0.037 0.124 0.075 0.185 0.114 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348z"
    }
  }]
};
exports.eyeMinus = eyeMinus;
var eyeBlocked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.78 0.22c-0.293-0.293-0.768-0.293-1.061 0l-3.159 3.159c-0.812-0.246-1.671-0.378-2.561-0.378-3.489 0-6.514 2.032-8 5 0.643 1.283 1.573 2.391 2.703 3.236l-2.484 2.484c-0.293 0.293-0.293 0.768 0 1.061 0.146 0.146 0.338 0.22 0.53 0.22s0.384-0.073 0.53-0.22l13.5-13.5c0.293-0.293 0.293-0.768 0-1.061zM6.5 5c0.66 0 1.22 0.426 1.421 1.019l-1.902 1.902c-0.592-0.201-1.019-0.761-1.019-1.421 0-0.828 0.672-1.5 1.5-1.5zM1.721 8c0.598-0.946 1.395-1.749 2.335-2.348 0.061-0.039 0.123-0.077 0.185-0.114-0.156 0.427-0.241 0.888-0.241 1.369 0 0.858 0.27 1.652 0.73 2.303l-0.952 0.952c-0.819-0.576-1.519-1.311-2.057-2.162z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 6.906c0-0.424-0.066-0.833-0.189-1.217l-5.028 5.028c0.384 0.123 0.793 0.189 1.217 0.189 2.209 0 4-1.791 4-4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.969 4.531l-1.084 1.084c0.020 0.012 0.040 0.024 0.059 0.037 0.94 0.6 1.737 1.403 2.335 2.348-0.598 0.946-1.395 1.749-2.335 2.348-1.181 0.753-2.545 1.152-3.944 1.152-0.604 0-1.202-0.074-1.781-0.219l-1.201 1.201c0.933 0.335 1.937 0.518 2.982 0.518 3.489 0 6.514-2.032 8-5-0.703-1.405-1.752-2.6-3.031-3.469z"
    }
  }]
};
exports.eyeBlocked = eyeBlocked;
var bookmark = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 0v16l5-5 5 5v-16z"
    }
  }]
};
exports.bookmark = bookmark;
var bookmarks = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 2v14l5-5 5 5v-14zM12 0h-10v14l1-1v-12h9z"
    }
  }]
};
exports.bookmarks = bookmarks;
var sun = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4c2.209 0 4-1.791 4-4s-1.791-4-4-4zM8 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
    }
  }]
};
exports.sun = sun;
var contrast = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM2 8c0-3.314 2.686-6 6-6v12c-3.314 0-6-2.686-6-6z"
    }
  }]
};
exports.contrast = contrast;
var brightnessContrast = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 4c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4zM8 10.5v-5c1.379 0 2.5 1.122 2.5 2.5s-1.121 2.5-2.5 2.5zM8 13c0.552 0 1 0.448 1 1v1c0 0.552-0.448 1-1 1s-1-0.448-1-1v-1c0-0.552 0.448-1 1-1zM8 3c-0.552 0-1-0.448-1-1v-1c0-0.552 0.448-1 1-1s1 0.448 1 1v1c0 0.552-0.448 1-1 1zM15 7c0.552 0 1 0.448 1 1s-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1zM3 8c0 0.552-0.448 1-1 1h-1c-0.552 0-1-0.448-1-1s0.448-1 1-1h1c0.552 0 1 0.448 1 1zM12.95 11.536l0.707 0.707c0.39 0.39 0.39 1.024 0 1.414s-1.024 0.39-1.414 0l-0.707-0.707c-0.39-0.39-0.39-1.024 0-1.414s1.024-0.39 1.414 0zM3.050 4.464l-0.707-0.707c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l0.707 0.707c0.391 0.391 0.391 1.024 0 1.414s-1.024 0.391-1.414 0zM12.95 4.464c-0.39 0.391-1.024 0.391-1.414 0s-0.39-1.024 0-1.414l0.707-0.707c0.39-0.391 1.024-0.391 1.414 0s0.39 1.024 0 1.414l-0.707 0.707zM3.050 11.536c0.39-0.39 1.024-0.39 1.414 0s0.391 1.024 0 1.414l-0.707 0.707c-0.391 0.39-1.024 0.39-1.414 0s-0.391-1.024 0-1.414l0.707-0.707z"
    }
  }]
};
exports.brightnessContrast = brightnessContrast;
var starEmpty = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-3.492 1.836 0.667-3.888-2.825-2.753 3.904-0.567 1.746-3.537 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
    }
  }]
};
exports.starEmpty = starEmpty;
var starHalf = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899zM8 11.773l-0.015 0.008 0.015-8.918 1.746 3.537 3.904 0.567-2.825 2.753 0.667 3.888-3.492-1.836z"
    }
  }]
};
exports.starHalf = starHalf;
var starFull = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 6.204l-5.528-0.803-2.472-5.009-2.472 5.009-5.528 0.803 4 3.899-0.944 5.505 4.944-2.599 4.944 2.599-0.944-5.505 4-3.899z"
    }
  }]
};
exports.starFull = starFull;
var heart = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.8 1c-1.682 0-3.129 1.368-3.799 2.797-0.671-1.429-2.118-2.797-3.8-2.797-2.318 0-4.2 1.882-4.2 4.2 0 4.716 4.758 5.953 8 10.616 3.065-4.634 8-6.050 8-10.616 0-2.319-1.882-4.2-4.2-4.2z"
    }
  }]
};
exports.heart = heart;
var heartBroken = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.8 1c2.318 0 4.2 1.882 4.2 4.2 0 4.566-4.935 5.982-8 10.616-3.243-4.663-8-5.9-8-10.616 0-2.319 1.882-4.2 4.2-4.2 0.943 0 1.812 0.43 2.512 1.060l-1.213 1.94 3.5 2-2 5 5.5-6-3.5-2 0.967-1.451c0.553-0.34 1.175-0.549 1.833-0.549z"
    }
  }]
};
exports.heartBroken = heartBroken;
var man = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
    }
  }]
};
exports.man = man;
var woman = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
    }
  }]
};
exports.woman = woman;
var manWoman = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 4h-3c-0.552 0-1 0.448-1 1v5h1v6h1.25v-6h0.5v6h1.25v-6h1v-5c0-0.552-0.448-1-1-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.234 8l0.766-0.555-2.083-3.221c-0.092-0.14-0.249-0.225-0.417-0.225h-4c-0.168 0-0.325 0.084-0.417 0.225l-2.083 3.221 0.766 0.555 1.729-2.244 0.601 1.402-2.095 3.841h1.917l0.333 5h1v-5h0.5v5h1l0.333-5h1.917l-2.095-3.842 0.601-1.402 1.729 2.244z"
    }
  }]
};
exports.manWoman = manWoman;
var happy = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8 9.356c1.812 0 3.535-0.481 5-1.327-0.228 2.788-2.393 4.971-5 4.971s-4.772-2.186-5-4.973c1.465 0.845 3.188 1.329 5 1.329zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
    }
  }]
};
exports.happy = happy;
var happy2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM8 14c-2.607 0-4.772-2.186-5-4.973 1.465 0.846 3.188 1.329 5 1.329s3.535-0.481 5-1.327c-0.228 2.788-2.393 4.971-5 4.971z"
    }
  }]
};
exports.happy2 = happy2;
var smile = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.002 9.801l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699z"
    }
  }]
};
exports.smile = smile;
var smile2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
    }
  }]
};
exports.smile2 = smile2;
var tongue = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM12 9v1h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8z"
    }
  }]
};
exports.tongue = tongue;
var tongue2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM12 10h-1v1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5v-1.5h-4v-1h8v1zM11 6c-0.552 0-1-0.448-1-1s0.448-1 1-1 1 0.448 1 1-0.448 1-1 1z"
    }
  }]
};
exports.tongue2 = tongue2;
var sad = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM4.998 12.199l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.413 0.973 4.288 2.427l-1.286 0.772c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699z"
    }
  }]
};
exports.sad = sad;
var sad2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
    }
  }]
};
exports.sad2 = sad2;
var wink = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM8.48 11.11c2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM5.5 5.805c-0.653 0-1.208 0.245-1.414 0.586-0.055-0.092-0.086-0.503-0.086-0.605 0-0.485 0.672-0.879 1.5-0.879s1.5 0.394 1.5 0.879c0 0.103-0.030 0.514-0.086 0.605-0.206-0.341-0.761-0.586-1.414-0.586z"
    }
  }]
};
exports.wink = wink;
var wink2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.672 1 1.5s-0.448 1.5-1 1.5-1-0.672-1-1.5 0.448-1.5 1-1.5zM5.5 4.876c0.932 0 1.594 0.349 1.594 0.895 0 0.116 0.060 0.672-0.003 0.775-0.232-0.384-0.856-0.659-1.591-0.659s-1.359 0.275-1.591 0.659c-0.062-0.103-0.003-0.659-0.003-0.775 0-0.546 0.662-0.895 1.594-0.895zM7.818 13c-1.863 0-3.498-1.004-4.42-2.515 1.1 0.86 3.040 1.028 5.083 0.625 2.191-0.433 3.892-1.43 4.507-2.759-0.338 2.624-2.524 4.649-5.17 4.649z"
    }
  }]
};
exports.wink2 = wink2;
var grin = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM3 8v1c0 2.2 1.8 4 4 4h2c2.2 0 4-1.8 4-4v-1h-10zM6 11.828c-0.415-0.148-0.796-0.388-1.118-0.71-0.569-0.569-0.882-1.321-0.882-2.118h2v2.828zM9 12h-2v-3h2v3zM11.118 11.118c-0.322 0.322-0.703 0.562-1.118 0.71v-2.828h2c0 0.797-0.313 1.549-0.882 2.118zM3.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.009 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261zM9.521 6c0 0 0 0 0 0 0.153 0 0.283-0.11 0.308-0.261 0.096-0.573 0.589-0.989 1.171-0.989s1.074 0.416 1.171 0.989c0.025 0.151 0.156 0.261 0.308 0.261s0.283-0.11 0.308-0.261c0.017-0.101 0.025-0.202 0.025-0.302 0-0.999-0.813-1.813-1.813-1.813s-1.813 0.813-1.813 1.813c0 0.1 0.008 0.201 0.025 0.302 0.025 0.151 0.156 0.261 0.308 0.261z"
    }
  }]
};
exports.grin = grin;
var grin2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261-0 0 0 0-0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM5 3.688c0.999 0 1.813 0.813 1.813 1.813 0 0.1-0.009 0.201-0.025 0.302-0.025 0.151-0.156 0.261-0.308 0.261s-0.283-0.11-0.308-0.261c-0.096-0.573-0.589-0.833-1.171-0.833s-1.074 0.26-1.171 0.833c-0.025 0.151-0.156 0.261-0.308 0.261 0 0 0 0 0 0-0.153 0-0.283-0.11-0.308-0.261-0.017-0.101-0.025-0.202-0.025-0.302 0-0.999 0.813-1.813 1.813-1.813zM3 9h3v3.873c-1.72-0.447-3-2.018-3-3.873zM7 13v-4h2v4h-2zM10 12.873v-3.873h3c0 1.855-1.28 3.426-3 3.873z"
    }
  }]
};
exports.grin2 = grin2;
var cool = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM12.5 4c0.275 0 0.5 0.225 0.5 0.5v1.5c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3zM8 12c1.456 0 2.731-0.778 3.43-1.942l0.857 0.515c-0.874 1.454-2.467 2.427-4.288 2.427-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334z"
    }
  }]
};
exports.cool = cool;
var cool2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM8 13c-0.757 0-1.475-0.169-2.118-0.47l0.518-0.864c0.49 0.214 1.031 0.334 1.6 0.334 1.456 0 2.731-0.778 3.43-1.942l0.858 0.515c-0.874 1.454-2.467 2.427-4.288 2.427zM13 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1h-2c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-1.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v0.5h2v-0.5c0-0.275 0.225-0.5 0.5-0.5h3c0.275 0 0.5 0.225 0.5 0.5v1.5z"
    }
  }]
};
exports.cool2 = cool2;
var angry = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772zM11.985 4.379c0.067 0.268-0.096 0.539-0.364 0.606-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606z"
    }
  }]
};
exports.angry = angry;
var angry2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM11.002 12.199c-0.612-1.018-1.727-1.699-3.002-1.699s-2.389 0.681-3.002 1.699l-1.286-0.772c0.874-1.454 2.467-2.427 4.288-2.427s3.414 0.973 4.288 2.427l-1.286 0.772z"
    }
  }]
};
exports.angry2 = angry2;
var evil = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 7c-0.552 0-1-0.448-1-1 0-0.018 0.001-0.036 0.002-0.054 0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1zM4.379 4.985c-0.268-0.067-0.431-0.338-0.364-0.606s0.338-0.431 0.606-0.364c0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334zM8 11.5c1.274 0 2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427s-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699zM16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }
  }]
};
exports.evil = evil;
var evil2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 1c0-0.711-0.149-1.387-0.416-2-0.525 1.201-1.507 2.155-2.726 2.643-1.347-1.031-3.030-1.643-4.857-1.643s-3.51 0.613-4.857 1.643c-1.22-0.488-2.202-1.443-2.726-2.643-0.268 0.613-0.416 1.289-0.416 2 0 1.15 0.388 2.208 1.040 3.053-0.662 1.165-1.040 2.512-1.040 3.947 0 4.418 3.582 8 8 8s8-3.582 8-8c0-1.436-0.378-2.783-1.040-3.947 0.652-0.845 1.040-1.903 1.040-3.053zM9.001 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM8 13c-1.82 0-3.413-0.973-4.288-2.427l1.286-0.772c0.612 1.018 1.727 1.699 3.002 1.699s2.389-0.681 3.002-1.699l1.286 0.772c-0.874 1.454-2.467 2.427-4.288 2.427z"
    }
  }]
};
exports.evil2 = evil2;
var shocked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM6 11c0-1.105 0.895-2 2-2s2 0.895 2 2c0 1.105-0.895 2-2 2s-2-0.895-2-2zM10 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5zM4 5.5c0-0.828 0.448-1.5 1-1.5s1 0.672 1 1.5c0 0.828-0.448 1.5-1 1.5s-1-0.672-1-1.5z"
    }
  }]
};
exports.shocked = shocked;
var shocked2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5zM8 13c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2zM11 7c-0.552 0-1-0.672-1-1.5s0.448-1.5 1-1.5 1 0.672 1 1.5-0.448 1.5-1 1.5z"
    }
  }]
};
exports.shocked2 = shocked2;
var baffled = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM5.5 4c-1.378 0-2.5 1.122-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.122-2.5-2.5-2.5v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.5 5c0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5 0.672-1.5 1.5-1.5zM10.5 4c-1.379 0-2.5 1.122-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.122 2.5-2.5-1.121-2.5-2.5-2.5v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 11h4v1h-4v-1z"
    }
  }]
};
exports.baffled = baffled;
var baffled2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 6.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 6.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5zM10 12h-4v-1h4v1zM10.5 8c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5 1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5z"
    }
  }]
};
exports.baffled2 = baffled2;
var confused = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM11.345 10h1.014c0.144 1.133-0.507 2.258-1.624 2.665-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725z"
    }
  }]
};
exports.confused = confused;
var confused2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM10.735 12.665c-1.295 0.472-2.733-0.199-3.204-1.494-0.283-0.777-1.145-1.179-1.923-0.896-0.712 0.259-1.109 1.005-0.953 1.725h-1.013c-0.144-1.133 0.507-2.258 1.624-2.665 1.295-0.472 2.733 0.199 3.204 1.494 0.283 0.777 1.145 1.179 1.923 0.896 0.712-0.259 1.109-1.005 0.953-1.725h1.014c0.144 1.133-0.507 2.258-1.624 2.665z"
    }
  }]
};
exports.confused2 = confused2;
var neutral = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM10 5c0 0.552 0.448 1 1 1s1-0.448 1-1-0.448-1-1-1-1 0.448-1 1zM6 11h4v1h-4v-1z"
    }
  }]
};
exports.neutral = neutral;
var neutral2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM10 12h-4v-1h4v1zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1c0-0.552 0.448-1 1-1z"
    }
  }]
};
exports.neutral2 = neutral2;
var hipster = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.561 8.439c-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.019 0.019 0.038 0.037 0.058 0.055 1.352 1.227 4.503-0.029 4.503-1.615-0.969 0.625-1.726 0.153-2.439-0.561z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.439 8.439c0.586-0.586 1.536-0.586 2.121 0s0.586 1.536 0 2.121c-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561z"
    }
  }]
};
exports.hipster = hipster;
var hipster2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM5 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM8.497 10.615c-0.020-0.018-0.039-0.036-0.058-0.055-0.293-0.293-0.439-0.677-0.439-1.060-0 0.384-0.146 0.768-0.439 1.060-0.019 0.019-0.038 0.037-0.058 0.055-1.352 1.227-4.503-0.029-4.503-1.615 0.969 0.625 1.726 0.153 2.439-0.561 0.586-0.586 1.536-0.586 2.121 0 0.293 0.293 0.439 0.677 0.439 1.060 0-0.384 0.146-0.768 0.439-1.060 0.586-0.586 1.536-0.586 2.121 0 0.713 0.714 1.471 1.186 2.439 0.561 0 1.586-3.151 2.842-4.503 1.615z"
    }
  }]
};
exports.hipster2 = hipster2;
var wondering = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11.652 9.4l0.351 1.2-6.828 2-0.351-1.2zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 5c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1z"
    }
  }]
};
exports.wondering = wondering;
var wondering2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM11 4c0.552 0 1 0.448 1 1s-0.448 1-1 1-1-0.448-1-1 0.448-1 1-1zM4 5c0-0.552 0.448-1 1-1s1 0.448 1 1-0.448 1-1 1-1-0.448-1-1zM5.176 12.6l-0.351-1.2 6.828-2 0.351 1.2-6.828 2z"
    }
  }]
};
exports.wondering2 = wondering2;
var sleepy = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 10.5c0 1.381-0.895 2.5-2 2.5s-2-1.119-2-2.5c0-1.381 0.895-2.5 2-2.5s2 1.119 2 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 5.313c-0.128 0-0.256-0.049-0.354-0.146-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
    }
  }]
};
exports.sleepy = sleepy;
var sleepy2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4.854 5.166c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0zM8 13c-1.105 0-2-1.119-2-2.5s0.895-2.5 2-2.5 2 1.119 2 2.5-0.895 2.5-2 2.5zM11.854 5.166c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.302-0.302-0.991-0.302-1.293 0-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.696-0.696 2.011-0.696 2.707 0 0.195 0.195 0.195 0.512 0 0.707z"
    }
  }]
};
exports.sleepy2 = sleepy2;
var frustrated = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.724 4.428c-0.543-0.271-1.080-0.407-1.102-0.413-0.268-0.067-0.539 0.096-0.606 0.364s0.096 0.539 0.364 0.606c0.275 0.070 0.602 0.189 0.89 0.334-0.166 0.179-0.268 0.418-0.268 0.681 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.018-0.001-0.036-0.002-0.054-0.032-0.741-0.706-1.234-1.275-1.518z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM3.695 12.87c0.167 0.083 0.356 0.13 0.555 0.13h7.5c0.199 0 0.387-0.047 0.555-0.13-1.147 1.014-2.654 1.63-4.305 1.63s-3.158-0.616-4.305-1.63zM4 11.75v-1.5c0-0.136 0.114-0.25 0.25-0.25h1.75v2h-1.75c-0.136 0-0.25-0.114-0.25-0.25zM7 12v-2h2v2h-2zM10 12v-2h1.75c0.136 0 0.25 0.114 0.25 0.25v1.5c0 0.136-0.114 0.25-0.25 0.25h-1.75zM12.87 12.305c0.083-0.167 0.13-0.356 0.13-0.555v-1.5c0-0.689-0.561-1.25-1.25-1.25h-7.5c-0.689 0-1.25 0.561-1.25 1.25v1.5c0 0.199 0.047 0.387 0.13 0.555-1.014-1.147-1.63-2.654-1.63-4.305 0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5c0 1.651-0.616 3.158-1.63 4.305z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.379 4.015c-0.023 0.006-0.559 0.141-1.102 0.413-0.568 0.284-1.243 0.776-1.275 1.518-0.001 0.018-0.002 0.036-0.002 0.054 0 0.552 0.448 1 1 1s1-0.448 1-1c0-0.263-0.102-0.503-0.268-0.681 0.288-0.144 0.614-0.264 0.89-0.334 0.268-0.067 0.431-0.338 0.364-0.606s-0.338-0.431-0.606-0.364z"
    }
  }]
};
exports.frustrated = frustrated;
var frustrated2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 10.25v1.5c0 0.136 0.114 0.25 0.25 0.25h1.75v-2h-1.75c-0.136 0-0.25 0.114-0.25 0.25z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 10h2v2h-2v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.75 10h-1.75v2h1.75c0.136 0 0.25-0.114 0.25-0.25v-1.5c0-0.136-0.114-0.25-0.25-0.25z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM9.002 5.946c0.032-0.741 0.706-1.234 1.275-1.518 0.543-0.271 1.080-0.407 1.102-0.413 0.268-0.067 0.539 0.096 0.606 0.364s-0.096 0.539-0.364 0.606c-0.275 0.070-0.602 0.189-0.89 0.334 0.166 0.179 0.268 0.418 0.268 0.681 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.018 0.001-0.036 0.002-0.054zM4.015 4.379c0.067-0.268 0.338-0.431 0.606-0.364 0.023 0.006 0.559 0.141 1.102 0.413 0.568 0.284 1.243 0.776 1.275 1.518 0.001 0.018 0.002 0.036 0.002 0.054 0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.263 0.102-0.503 0.268-0.681-0.288-0.144-0.614-0.264-0.89-0.334-0.268-0.067-0.431-0.338-0.364-0.606zM13 11.75c0 0.689-0.561 1.25-1.25 1.25h-7.5c-0.689 0-1.25-0.561-1.25-1.25v-1.5c0-0.689 0.561-1.25 1.25-1.25h7.5c0.689 0 1.25 0.561 1.25 1.25v1.5z"
    }
  }]
};
exports.frustrated2 = frustrated2;
var crying = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 13.375c-0.128 0-0.256-0.049-0.354-0.146-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707-0.098 0.098-0.226 0.146-0.354 0.146z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 9c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 12c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.crying = crying;
var crying2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM5 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM5.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5zM9.854 13.229c-0.098 0.098-0.226 0.146-0.354 0.146s-0.256-0.049-0.354-0.146c-0.072-0.072-0.46-0.229-1.146-0.229s-1.075 0.157-1.146 0.229c-0.195 0.195-0.512 0.195-0.707 0s-0.195-0.512 0-0.707c0.471-0.471 1.453-0.521 1.854-0.521s1.383 0.051 1.854 0.521c0.195 0.195 0.195 0.512 0 0.707zM12 11.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12 8.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1zM12.5 6h-2c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.crying2 = crying2;
var pointUp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 9.5v-2.5c0-0.827-0.673-1.5-1.5-1.5-0.267 0-0.518 0.070-0.736 0.193-0.267-0.417-0.734-0.693-1.264-0.693-0.384 0-0.734 0.145-1 0.383-0.266-0.238-0.616-0.383-1-0.383-0.175 0-0.344 0.030-0.5 0.086v-3.586c0-0.827-0.673-1.5-1.5-1.5s-1.5 0.673-1.5 1.5v6.167l-2.75-1.466c-0.227-0.131-0.486-0.201-0.75-0.201-0.827 0-1.5 0.673-1.5 1.5 0 0.412 0.164 0.796 0.461 1.082 0.004 0.004 0.008 0.007 0.012 0.011l3.737 3.407h-0.71c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h10c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-0.691l1.138-2.276c0.035-0.069 0.053-0.146 0.053-0.224zM14 13.5c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5 0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5zM14 9.382l-1.309 2.618h-5.997l-4.544-4.143c-0.097-0.095-0.15-0.221-0.15-0.357 0-0.276 0.224-0.5 0.5-0.5 0.085 0 0.166 0.020 0.239 0.061 0.008 0.005 0.017 0.010 0.025 0.014l3.5 1.866c0.155 0.083 0.342 0.078 0.492-0.012s0.243-0.253 0.243-0.429v-7c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v2.382z"
    }
  }]
};
exports.pointUp = pointUp;
var pointRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15h2.5c0.827 0 1.5-0.673 1.5-1.5 0-0.267-0.070-0.518-0.193-0.736 0.417-0.267 0.693-0.734 0.693-1.264 0-0.384-0.145-0.734-0.383-1 0.238-0.266 0.383-0.616 0.383-1 0-0.175-0.030-0.344-0.086-0.5h3.586c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5h-6.167l1.466-2.75c0.131-0.227 0.201-0.486 0.201-0.75 0-0.827-0.673-1.5-1.5-1.5-0.412 0-0.796 0.164-1.082 0.461-0.004 0.004-0.007 0.008-0.011 0.012l-3.407 3.737v-0.71c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v10c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-0.691l2.276 1.138c0.069 0.035 0.146 0.053 0.224 0.053zM2.5 14c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM6.618 14l-2.618-1.309v-5.997l4.143-4.544c0.095-0.097 0.221-0.15 0.357-0.15 0.276 0 0.5 0.224 0.5 0.5 0 0.085-0.020 0.166-0.061 0.239-0.005 0.008-0.010 0.017-0.014 0.025l-1.866 3.5c-0.083 0.155-0.078 0.342 0.013 0.492s0.253 0.243 0.429 0.243h7c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2.382z"
    }
  }]
};
exports.pointRight = pointRight;
var pointDown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 6.5v2.5c0 0.827-0.673 1.5-1.5 1.5-0.267 0-0.518-0.070-0.736-0.193-0.267 0.417-0.734 0.693-1.264 0.693-0.384 0-0.734-0.145-1-0.383-0.266 0.238-0.616 0.383-1 0.383-0.175 0-0.344-0.030-0.5-0.086v3.586c0 0.827-0.673 1.5-1.5 1.5s-1.5-0.673-1.5-1.5v-6.167l-2.75 1.466c-0.227 0.131-0.486 0.201-0.75 0.201-0.827 0-1.5-0.673-1.5-1.5 0-0.412 0.164-0.796 0.461-1.082 0.004-0.004 0.008-0.007 0.012-0.011l3.737-3.407h-0.71c-0.276 0-0.5-0.224-0.5-0.5v-3c0-0.276 0.224-0.5 0.5-0.5h10c0.276 0 0.5 0.224 0.5 0.5v3c0 0.276-0.224 0.5-0.5 0.5h-0.691l1.138 2.276c0.035 0.069 0.053 0.146 0.053 0.224zM14 2.5c0-0.276-0.224-0.5-0.5-0.5s-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5 0.5-0.224 0.5-0.5zM14 6.618l-1.309-2.618h-5.997l-4.544 4.143c-0.097 0.095-0.15 0.221-0.15 0.357 0 0.276 0.224 0.5 0.5 0.5 0.085 0 0.166-0.020 0.239-0.061 0.008-0.005 0.017-0.010 0.025-0.014l3.5-1.866c0.155-0.083 0.342-0.078 0.492 0.013s0.243 0.253 0.243 0.429v7c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-0.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5c0 0.276 0.224 0.5 0.5 0.5s0.5-0.224 0.5-0.5v-2.382z"
    }
  }]
};
exports.pointDown = pointDown;
var pointLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 15h-2.5c-0.827 0-1.5-0.673-1.5-1.5 0-0.267 0.070-0.518 0.193-0.736-0.417-0.267-0.693-0.734-0.693-1.264 0-0.384 0.145-0.734 0.383-1-0.238-0.266-0.383-0.616-0.383-1 0-0.175 0.030-0.344 0.086-0.5h-3.586c-0.827 0-1.5-0.673-1.5-1.5s0.673-1.5 1.5-1.5h6.167l-1.466-2.75c-0.131-0.227-0.201-0.486-0.201-0.75 0-0.827 0.673-1.5 1.5-1.5 0.412 0 0.796 0.164 1.082 0.461 0.004 0.004 0.007 0.008 0.011 0.012l3.407 3.737v-0.71c0-0.276 0.224-0.5 0.5-0.5h3c0.276 0 0.5 0.224 0.5 0.5v10c0 0.276-0.224 0.5-0.5 0.5h-3c-0.276 0-0.5-0.224-0.5-0.5v-0.691l-2.276 1.138c-0.069 0.035-0.146 0.053-0.224 0.053zM13.5 14c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5-0.5 0.224-0.5 0.5 0.224 0.5 0.5 0.5zM9.382 14l2.618-1.309v-5.997l-4.143-4.544c-0.095-0.097-0.221-0.15-0.357-0.15-0.276 0-0.5 0.224-0.5 0.5 0 0.085 0.020 0.166 0.061 0.239 0.005 0.008 0.010 0.017 0.014 0.025l1.866 3.5c0.083 0.155 0.078 0.342-0.012 0.492s-0.253 0.243-0.429 0.243h-7c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h0.5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2.382z"
    }
  }]
};
exports.pointLeft = pointLeft;
var warning = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1.45l6.705 13.363h-13.409l6.705-13.363zM8 0c-0.345 0-0.69 0.233-0.951 0.698l-6.829 13.611c-0.523 0.93-0.078 1.691 0.989 1.691h13.583c1.067 0 1.512-0.761 0.989-1.691h0l-6.829-13.611c-0.262-0.465-0.606-0.698-0.951-0.698v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 11c-0.552 0-1-0.448-1-1v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v3c0 0.552-0.448 1-1 1z"
    }
  }]
};
exports.warning = warning;
var notification = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8zM7 11h2v2h-2zM7 3h2v6h-2z"
    }
  }]
};
exports.notification = notification;
var question = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 11h2v2h-2zM11 4c0.552 0 1 0.448 1 1v3l-3 2h-2v-1l3-2v-1h-5v-2h6zM8 1.5c-1.736 0-3.369 0.676-4.596 1.904s-1.904 2.86-1.904 4.596c0 1.736 0.676 3.369 1.904 4.596s2.86 1.904 4.596 1.904c1.736 0 3.369-0.676 4.596-1.904s1.904-2.86 1.904-4.596c0-1.736-0.676-3.369-1.904-4.596s-2.86-1.904-4.596-1.904zM8 0v0c4.418 0 8 3.582 8 8s-3.582 8-8 8c-4.418 0-8-3.582-8-8s3.582-8 8-8z"
    }
  }]
};
exports.question = question;
var plus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.5 6h-5.5v-5.5c0-0.276-0.224-0.5-0.5-0.5h-3c-0.276 0-0.5 0.224-0.5 0.5v5.5h-5.5c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h5.5v5.5c0 0.276 0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-5.5h5.5c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5z"
    }
  }]
};
exports.plus = plus;
var minus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 6.5v3c0 0.276 0.224 0.5 0.5 0.5h15c0.276 0 0.5-0.224 0.5-0.5v-3c0-0.276-0.224-0.5-0.5-0.5h-15c-0.276 0-0.5 0.224-0.5 0.5z"
    }
  }]
};
exports.minus = minus;
var info = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 4.75c0-0.412 0.338-0.75 0.75-0.75h0.5c0.412 0 0.75 0.338 0.75 0.75v0.5c0 0.412-0.338 0.75-0.75 0.75h-0.5c-0.412 0-0.75-0.338-0.75-0.75v-0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 12h-4v-1h1v-3h-1v-1h3v4h1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }
  }]
};
exports.info = info;
var cancelCircle = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.5 4l-2.5 2.5-2.5-2.5-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 2.5-2.5 2.5 2.5 1.5-1.5-2.5-2.5 2.5-2.5z"
    }
  }]
};
exports.cancelCircle = cancelCircle;
var blocked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.657 2.343c-1.511-1.511-3.52-2.343-5.657-2.343s-4.146 0.832-5.657 2.343c-1.511 1.511-2.343 3.52-2.343 5.657s0.832 4.146 2.343 5.657c1.511 1.511 3.52 2.343 5.657 2.343s4.146-0.832 5.657-2.343c1.511-1.511 2.343-3.52 2.343-5.657s-0.832-4.146-2.343-5.657zM14 8c0 1.294-0.412 2.494-1.111 3.475l-8.364-8.364c0.981-0.699 2.181-1.111 3.475-1.111 3.308 0 6 2.692 6 6zM2 8c0-1.294 0.412-2.494 1.111-3.475l8.364 8.364c-0.981 0.699-2.181 1.111-3.475 1.111-3.308 0-6-2.692-6-6z"
    }
  }]
};
exports.blocked = blocked;
var cross = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.854 12.854c-0-0-0-0-0-0l-4.854-4.854 4.854-4.854c0-0 0-0 0-0 0.052-0.052 0.090-0.113 0.114-0.178 0.066-0.178 0.028-0.386-0.114-0.529l-2.293-2.293c-0.143-0.143-0.351-0.181-0.529-0.114-0.065 0.024-0.126 0.062-0.178 0.114 0 0-0 0-0 0l-4.854 4.854-4.854-4.854c-0-0-0-0-0-0-0.052-0.052-0.113-0.090-0.178-0.114-0.178-0.066-0.386-0.029-0.529 0.114l-2.293 2.293c-0.143 0.143-0.181 0.351-0.114 0.529 0.024 0.065 0.062 0.126 0.114 0.178 0 0 0 0 0 0l4.854 4.854-4.854 4.854c-0 0-0 0-0 0-0.052 0.052-0.090 0.113-0.114 0.178-0.066 0.178-0.029 0.386 0.114 0.529l2.293 2.293c0.143 0.143 0.351 0.181 0.529 0.114 0.065-0.024 0.126-0.062 0.178-0.114 0-0 0-0 0-0l4.854-4.854 4.854 4.854c0 0 0 0 0 0 0.052 0.052 0.113 0.090 0.178 0.114 0.178 0.066 0.386 0.029 0.529-0.114l2.293-2.293c0.143-0.143 0.181-0.351 0.114-0.529-0.024-0.065-0.062-0.126-0.114-0.178z"
    }
  }]
};
exports.cross = cross;
var checkmark = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 2l-7.5 7.5-3.5-3.5-2.5 2.5 6 6 10-10z"
    }
  }]
};
exports.checkmark = checkmark;
var checkmark2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.21 14.339l-6.217-6.119 3.084-3.035 3.133 3.083 6.713-6.607 3.084 3.035-9.797 9.643zM1.686 8.22l4.524 4.453 8.104-7.976-1.391-1.369-6.713 6.607-3.133-3.083-1.391 1.369z"
    }
  }]
};
exports.checkmark2 = checkmark2;
var spellCheck = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 4h2v3h1v-6c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v6h1v-3zM2 1h2v2h-2v-2zM15 1v-1h-3c-0.55 0-1 0.45-1 1v5c0 0.55 0.45 1 1 1h3v-1h-3v-5h3zM10 2.5v-1.5c0-0.55-0.45-1-1-1h-3v7h3c0.55 0 1-0.45 1-1v-1.5c0-0.55-0.137-1-0.688-1 0.55 0 0.688-0.45 0.688-1zM9 6h-2v-2h2v2zM9 3h-2v-2h2v2zM13 9l-6.5 7-3.5-4.5 1.281-1.094 2.219 2.313 5.5-4.719z"
    }
  }]
};
exports.spellCheck = spellCheck;
var enter = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 8h-5v-2h5v-2l3 3-3 3zM16 0v13l-6 3v-3h-6v-4h1v3h5v-9l4-2h-9v4h-1v-5z"
    }
  }]
};
exports.enter = enter;
var exit = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 10v-2h-5v-2h5v-2l3 3zM11 9v4h-5v3l-6-3v-13h11v5h-1v-4h-8l4 2v9h4v-3z"
    }
  }]
};
exports.exit = exit;
var play2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM6 4.5l6 3.5-6 3.5z"
    }
  }]
};
exports.play2 = play2;
var pause = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h2v6h-2zM9 5h2v6h-2z"
    }
  }]
};
exports.pause = pause;
var stop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5h6v6h-6z"
    }
  }]
};
exports.stop = stop;
var previous = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 8l4-3v6z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 5h2v6h-2v-6z"
    }
  }]
};
exports.previous = previous;
var next = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c4.418 0 8 3.582 8 8s-3.582 8-8 8-8-3.582-8-8 3.582-8 8-8zM8 14.5c3.59 0 6.5-2.91 6.5-6.5s-2.91-6.5-6.5-6.5-6.5 2.91-6.5 6.5 2.91 6.5 6.5 6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 8l-4-3v6z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 5h-2v6h2v-6z"
    }
  }]
};
exports.next = next;
var backward = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5zM11 10.5l-3.5-2.5 3.5-2.5zM7 10.5l-3.5-2.5 3.5-2.5z"
    }
  }]
};
exports.backward = backward;
var forward2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5zM5 5.5l3.5 2.5-3.5 2.5zM9 5.5l3.5 2.5-3.5 2.5z"
    }
  }]
};
exports.forward2 = forward2;
var play3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 2l10 6-10 6z"
    }
  }]
};
exports.play3 = play3;
var pause2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 2h5v12h-5zM9 2h5v12h-5z"
    }
  }]
};
exports.pause2 = pause2;
var stop2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 2h12v12h-12z"
    }
  }]
};
exports.stop2 = stop2;
var backward2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 2.5v5l5-5v11l-5-5v5l-5.5-5.5z"
    }
  }]
};
exports.backward2 = backward2;
var forward3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 13.5v-5l-5 5v-11l5 5v-5l5.5 5.5z"
    }
  }]
};
exports.forward3 = forward3;
var first = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 14v-12h2v5.5l5-5v5l5-5v11l-5-5v5l-5-5v5.5z"
    }
  }]
};
exports.first = first;
var last = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 2v12h-2v-5.5l-5 5v-5l-5 5v-11l5 5v-5l5 5v-5.5z"
    }
  }]
};
exports.last = last;
var previous2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 14v-12h2v5.5l5-5v11l-5-5v5.5z"
    }
  }]
};
exports.previous2 = previous2;
var next2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 2v12h-2v-5.5l-5 5v-11l5 5v-5.5z"
    }
  }]
};
exports.next2 = next2;
var eject = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 12h16v2h-16zM8 2l8 8h-16z"
    }
  }]
};
exports.eject = eject;
var volumeHigh = {
  "viewBox": "0 0 17 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.907 14.407c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.369-1.369 2.123-3.19 2.123-5.127s-0.754-3.757-2.123-5.127c-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.653 1.653 2.563 3.85 2.563 6.187s-0.91 4.534-2.563 6.187c-0.146 0.146-0.338 0.22-0.53 0.22zM11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeHigh = volumeHigh;
var volumeMedium = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.243 12.993c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 2.047-2.047 2.047-5.378 0-7.425-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.275 1.275 1.977 2.97 1.977 4.773s-0.702 3.498-1.977 4.773c-0.146 0.146-0.338 0.22-0.53 0.22v0zM8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeMedium = volumeMedium;
var volumeLow = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.578 11.578c-0.192 0-0.384-0.073-0.53-0.22-0.293-0.293-0.293-0.768 0-1.061 1.267-1.267 1.267-3.329 0-4.596-0.293-0.293-0.293-0.768 0-1.061s0.768-0.293 1.061 0c1.852 1.852 1.852 4.865 0 6.718-0.146 0.146-0.338 0.22-0.53 0.22z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeLow = volumeLow;
var volumeMute = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeMute = volumeMute;
var volumeMute2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 9.674v1.326h-1.326l-1.674-1.674-1.674 1.674h-1.326v-1.326l1.674-1.674-1.674-1.674v-1.326h1.326l1.674 1.674 1.674-1.674h1.326v1.326l-1.674 1.674 1.674 1.674z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeMute2 = volumeMute2;
var volumeIncrease = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 9h-3v3h-2v-3h-3v-2h3v-3h2v3h3v2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeIncrease = volumeIncrease;
var volumeDecrease = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 7h8v2h-8v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 15c-0.13 0-0.258-0.051-0.354-0.146l-3.854-3.854h-1.793c-0.276 0-0.5-0.224-0.5-0.5v-5c0-0.276 0.224-0.5 0.5-0.5h1.793l3.854-3.854c0.143-0.143 0.358-0.186 0.545-0.108s0.309 0.26 0.309 0.462v13c0 0.202-0.122 0.385-0.309 0.462-0.062 0.026-0.127 0.038-0.191 0.038z"
    }
  }]
};
exports.volumeDecrease = volumeDecrease;
var loop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 5h10v3l4-4-4-4v3h-12v6h2zM14 11h-10v-3l-4 4 4 4v-3h12v-6h-2z"
    }
  }]
};
exports.loop = loop;
var loop2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.901 2.599c-1.463-1.597-3.565-2.599-5.901-2.599-4.418 0-8 3.582-8 8h1.5c0-3.59 2.91-6.5 6.5-6.5 1.922 0 3.649 0.835 4.839 2.161l-2.339 2.339h5.5v-5.5l-2.099 2.099z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 8c0 3.59-2.91 6.5-6.5 6.5-1.922 0-3.649-0.835-4.839-2.161l2.339-2.339h-5.5v5.5l2.099-2.099c1.463 1.597 3.565 2.599 5.901 2.599 4.418 0 8-3.582 8-8h-1.5z"
    }
  }]
};
exports.loop2 = loop2;
var infinite = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.25 11.75c-1.002 0-1.943-0.39-2.652-1.098l-1.598-1.598-1.598 1.598c-0.708 0.708-1.65 1.098-2.652 1.098s-1.944-0.39-2.652-1.098c-0.708-0.708-1.098-1.65-1.098-2.652s0.39-1.943 1.098-2.652c0.708-0.708 1.65-1.098 2.652-1.098s1.943 0.39 2.652 1.098l1.598 1.598 1.598-1.598c0.708-0.708 1.65-1.098 2.652-1.098s1.944 0.39 2.652 1.098c0.708 0.708 1.098 1.65 1.098 2.652s-0.39 1.943-1.098 2.652c-0.708 0.708-1.65 1.098-2.652 1.098zM10.652 9.598c0.427 0.427 0.994 0.662 1.598 0.662s1.171-0.235 1.598-0.662c0.427-0.427 0.662-0.994 0.662-1.598s-0.235-1.171-0.662-1.598c-0.427-0.427-0.994-0.662-1.598-0.662s-1.171 0.235-1.598 0.662l-1.598 1.598 1.598 1.598zM3.75 5.74c-0.604 0-1.171 0.235-1.598 0.662s-0.662 0.994-0.662 1.598c0 0.604 0.235 1.171 0.662 1.598s0.994 0.662 1.598 0.662c0.604 0 1.171-0.235 1.598-0.662l1.598-1.598-1.598-1.598c-0.427-0.427-0.994-0.662-1.598-0.662v0z"
    }
  }]
};
exports.infinite = infinite;
var shuffle = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 11h-1.586l-2.5-2.5 2.5-2.5h1.586v2.5l3.5-3.5-3.5-3.5v2.5h-2c-0.265 0-0.52 0.105-0.707 0.293l-2.793 2.793-2.793-2.793c-0.188-0.188-0.442-0.293-0.707-0.293h-3v2h2.586l2.5 2.5-2.5 2.5h-2.586v2h3c0.265 0 0.52-0.105 0.707-0.293l2.793-2.793 2.793 2.793c0.188 0.188 0.442 0.293 0.707 0.293h2v2.5l3.5-3.5-3.5-3.5v2.5z"
    }
  }]
};
exports.shuffle = shuffle;
var arrowUpLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 11.5l4-4 8.5 8.5 3.5-3.5-8.5-8.5 4-4h-11.5v11.5z"
    }
  }]
};
exports.arrowUpLeft = arrowUpLeft;
var arrowUp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0.5l-7.5 7.5h4.5v8h6v-8h4.5z"
    }
  }]
};
exports.arrowUp = arrowUp;
var arrowUpRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 0l4 4-8.5 8.5 3.5 3.5 8.5-8.5 4 4v-11.5h-11.5z"
    }
  }]
};
exports.arrowUpRight = arrowUpRight;
var arrowRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.5 8l-7.5-7.5v4.5h-8v6h8v4.5z"
    }
  }]
};
exports.arrowRight = arrowRight;
var arrowDownRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 4.5l-4 4-8.5-8.5-3.5 3.5 8.5 8.5-4 4h11.5v-11.5z"
    }
  }]
};
exports.arrowDownRight = arrowDownRight;
var arrowDown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 15.5l7.5-7.5h-4.5v-8h-6v8h-4.5z"
    }
  }]
};
exports.arrowDown = arrowDown;
var arrowDownLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 16l-4-4 8.5-8.5-3.5-3.5-8.5 8.5-4-4v11.5h11.5z"
    }
  }]
};
exports.arrowDownLeft = arrowDownLeft;
var arrowLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.5 8l7.5 7.5v-4.5h8v-6h-8v-4.5z"
    }
  }]
};
exports.arrowLeft = arrowLeft;
var arrowUpLeft2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.707 12.293l-8.293-8.293h3.586c0.552 0 1-0.448 1-1s-0.448-1-1-1h-6c-0.404 0-0.769 0.244-0.924 0.617-0.051 0.124-0.076 0.254-0.076 0.383h-0.001v6c0 0.552 0.448 1 1 1s1-0.448 1-1v-3.586l8.293 8.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.39 0.391-1.024 0-1.414z"
    }
  }]
};
exports.arrowUpLeft2 = arrowUpLeft2;
var arrowUp2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.707 6.293l-5-5c-0.39-0.391-1.024-0.391-1.414 0l-5 5c-0.391 0.391-0.391 1.024 0 1.414s1.024 0.391 1.414 0l3.293-3.293v9.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-9.586l3.293 3.293c0.195 0.195 0.451 0.293 0.707 0.293s0.512-0.098 0.707-0.293c0.391-0.391 0.391-1.024 0-1.414z"
    }
  }]
};
exports.arrowUp2 = arrowUp2;
var arrowUpRight2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.707 13.707l8.293-8.293v3.586c0 0.552 0.448 1 1 1s1-0.448 1-1v-6c0-0.404-0.244-0.769-0.617-0.924-0.124-0.051-0.254-0.076-0.383-0.076v-0.001h-6c-0.552 0-1 0.448-1 1s0.448 1 1 1h3.586l-8.293 8.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.39 0.391 1.024 0.391 1.414 0z"
    }
  }]
};
exports.arrowUpRight2 = arrowUpRight2;
var arrowRight2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.707 13.707l5-5c0.391-0.39 0.391-1.024 0-1.414l-5-5c-0.391-0.391-1.024-0.391-1.414 0s-0.391 1.024 0 1.414l3.293 3.293h-9.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h9.586l-3.293 3.293c-0.195 0.195-0.293 0.451-0.293 0.707s0.098 0.512 0.293 0.707c0.391 0.391 1.024 0.391 1.414 0z"
    }
  }]
};
exports.arrowRight2 = arrowRight2;
var arrowDownRight2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.293 3.707l8.293 8.293h-3.586c-0.552 0-1 0.448-1 1s0.448 1 1 1h6c0.404 0 0.769-0.244 0.924-0.617 0.051-0.124 0.076-0.254 0.076-0.383h0.001v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v3.586l-8.293-8.293c-0.195-0.195-0.451-0.293-0.707-0.293s-0.512 0.098-0.707 0.293c-0.391 0.39-0.391 1.024 0 1.414z"
    }
  }]
};
exports.arrowDownRight2 = arrowDownRight2;
var arrowDown2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.707 9.707l-5 5c-0.39 0.391-1.024 0.391-1.414 0l-5-5c-0.391-0.391-0.391-1.024 0-1.414s1.024-0.391 1.414 0l3.293 3.293v-9.586c0-0.552 0.448-1 1-1s1 0.448 1 1v9.586l3.293-3.293c0.195-0.195 0.451-0.293 0.707-0.293s0.512 0.098 0.707 0.293c0.391 0.391 0.391 1.024 0 1.414z"
    }
  }]
};
exports.arrowDown2 = arrowDown2;
var arrowDownLeft2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.293 2.293l-8.293 8.293v-3.586c0-0.552-0.448-1-1-1s-1 0.448-1 1v6c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.383 0.076v0.001l6-0c0.552 0 1-0.448 1-1s-0.448-1-1-1h-3.586l8.293-8.293c0.195-0.195 0.293-0.451 0.293-0.707s-0.098-0.512-0.293-0.707c-0.39-0.391-1.024-0.391-1.414 0v0z"
    }
  }]
};
exports.arrowDownLeft2 = arrowDownLeft2;
var arrowLeft2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.293 13.707l-5-5c-0.391-0.39-0.391-1.024 0-1.414l5-5c0.391-0.391 1.024-0.391 1.414 0s0.391 1.024 0 1.414l-3.293 3.293h9.586c0.552 0 1 0.448 1 1s-0.448 1-1 1h-9.586l3.293 3.293c0.195 0.195 0.293 0.451 0.293 0.707s-0.098 0.512-0.293 0.707c-0.391 0.391-1.024 0.391-1.414 0z"
    }
  }]
};
exports.arrowLeft2 = arrowLeft2;
var circleUp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 8c0 4.418 3.582 8 8 8s8-3.582 8-8-3.582-8-8-8-8 3.582-8 8zM14.5 8c0 3.59-2.91 6.5-6.5 6.5s-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.043 10.457l1.414-1.414-4.457-4.457-4.457 4.457 1.414 1.414 3.043-3.043z"
    }
  }]
};
exports.circleUp = circleUp;
var circleRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14.5c-3.59 0-6.5-2.91-6.5-6.5s2.91-6.5 6.5-6.5 6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.543 11.043l1.414 1.414 4.457-4.457-4.457-4.457-1.414 1.414 3.043 3.043z"
    }
  }]
};
exports.circleRight = circleRight;
var circleDown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8c0-4.418-3.582-8-8-8s-8 3.582-8 8 3.582 8 8 8 8-3.582 8-8zM1.5 8c0-3.59 2.91-6.5 6.5-6.5s6.5 2.91 6.5 6.5-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.957 5.543l-1.414 1.414 4.457 4.457 4.457-4.457-1.414-1.414-3.043 3.043z"
    }
  }]
};
exports.circleDown = circleDown;
var circleLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c4.418 0 8-3.582 8-8s-3.582-8-8-8-8 3.582-8 8 3.582 8 8 8zM8 1.5c3.59 0 6.5 2.91 6.5 6.5s-2.91 6.5-6.5 6.5-6.5-2.91-6.5-6.5 2.91-6.5 6.5-6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.457 4.957l-1.414-1.414-4.457 4.457 4.457 4.457 1.414-1.414-3.043-3.043z"
    }
  }]
};
exports.circleLeft = circleLeft;
var tab = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 0h1v8h-1v-8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 8h1v8h-1v-8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 11h11v2h-11v2.5l-3.5-3.5 3.5-3.5v2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 5h-11v-2h11v-2.5l3.5 3.5-3.5 3.5z"
    }
  }]
};
exports.tab = tab;
var moveUp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 8v6h1v-6h2.5l-3-3-3 3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 3h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 3h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 3h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 6.5h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.5 7h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 7h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 4.5h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 5h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 11v3h-3v-3h3zM6 10h-5v5h5v-5z"
    }
  }]
};
exports.moveUp = moveUp;
var moveDown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 11v-6h-1v6h-2.5l3 3 3-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 4v3h-3v-3h3zM6 3h-5v5h5v-5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 10h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 10h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 10h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 13.5h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.5 14h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.5 14h1.5v1h-1.5v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 11.5h1v1.5h-1v-1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12h1v1.5h-1v-1.5z"
    }
  }]
};
exports.moveDown = moveDown;
var sortAlphaAsc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 16h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.101 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.947 6.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 4l1.191-2.382 1.191 2.382h-2.382z"
    }
  }]
};
exports.sortAlphaAsc = sortAlphaAsc;
var sortAlphaDesc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 7h-4c-0.184 0-0.354-0.101-0.441-0.264s-0.077-0.36 0.025-0.513l3.482-5.223h-3.066c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h4c0.184 0 0.354 0.102 0.441 0.264s0.077 0.36-0.025 0.513l-3.482 5.223h3.066c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.947 15.276l-3-6c-0.085-0.169-0.258-0.276-0.447-0.276s-0.363 0.107-0.447 0.276l-3 6c-0.123 0.247-0.023 0.547 0.224 0.671 0.072 0.036 0.148 0.053 0.223 0.053 0.183 0 0.36-0.101 0.448-0.277l0.862-1.724h3.382l0.862 1.724c0.123 0.247 0.424 0.347 0.671 0.224s0.347-0.424 0.224-0.671zM11.309 13l1.191-2.382 1.191 2.382h-2.382z"
    }
  }]
};
exports.sortAlphaDesc = sortAlphaDesc;
var sortNumericAsc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 7c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 9h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 10h2v2h-2v-2z"
    }
  }]
};
exports.sortNumericAsc = sortNumericAsc;
var sortNumbericDesc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 16c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-0.5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h1c0.276 0 0.5 0.224 0.5 0.5v6c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-3c-0.276 0-0.5 0.224-0.5 0.5v3c0 0.276 0.224 0.5 0.5 0.5h2.5v2h-2.5c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h3c0.276 0 0.5-0.224 0.5-0.5v-6c0-0.276-0.224-0.5-0.5-0.5zM12 1h2v2h-2v-2z"
    }
  }]
};
exports.sortNumbericDesc = sortNumbericDesc;
var sortAmountAsc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9h9v2h-9v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 6h7v2h-7v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 3h5v2h-5v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 0h3v2h-3v-2z"
    }
  }]
};
exports.sortAmountAsc = sortAmountAsc;
var sortAmountDesc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 12v-12h-2v12h-2.5l3.5 3.5 3.5-3.5h-2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 0h9v2h-9v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 3h7v2h-7v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 6h5v2h-5v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 9h3v2h-3v-2z"
    }
  }]
};
exports.sortAmountDesc = sortAmountDesc;
var command = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 14c-1.379 0-2.5-1.121-2.5-2.5v-1.5h-2v1.5c0 1.379-1.122 2.5-2.5 2.5s-2.5-1.121-2.5-2.5 1.122-2.5 2.5-2.5h1.5v-2h-1.5c-1.378 0-2.5-1.122-2.5-2.5s1.122-2.5 2.5-2.5 2.5 1.122 2.5 2.5v1.5h2v-1.5c0-1.378 1.121-2.5 2.5-2.5s2.5 1.122 2.5 2.5-1.121 2.5-2.5 2.5h-1.5v2h1.5c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5zM10 10v1.5c0 0.827 0.673 1.5 1.5 1.5s1.5-0.673 1.5-1.5-0.673-1.5-1.5-1.5h-1.5zM4.5 10c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5 1.5-0.673 1.5-1.5v-1.5h-1.5zM7 9h2v-2h-2v2zM10 6h1.5c0.827 0 1.5-0.673 1.5-1.5s-0.673-1.5-1.5-1.5-1.5 0.673-1.5 1.5v1.5zM4.5 3c-0.827 0-1.5 0.673-1.5 1.5s0.673 1.5 1.5 1.5h1.5v-1.5c0-0.827-0.673-1.5-1.5-1.5z"
    }
  }]
};
exports.command = command;
var shift = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.5 14h-5c-0.276 0-0.5-0.224-0.5-0.5v-5.5h-2c-0.202 0-0.385-0.122-0.462-0.309s-0.035-0.402 0.108-0.545l5-5c0.195-0.195 0.512-0.195 0.707 0l5 5c0.143 0.143 0.186 0.358 0.108 0.545s-0.26 0.309-0.462 0.309h-2v5.5c0 0.276-0.224 0.5-0.5 0.5zM6 13h4v-5.5c0-0.276 0.224-0.5 0.5-0.5h1.293l-3.793-3.793-3.793 3.793h1.293c0.276 0 0.5 0.224 0.5 0.5v5.5z"
    }
  }]
};
exports.shift = shift;
var ctrl = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 7c-0.139 0-0.278-0.058-0.377-0.171l-3.124-3.57-3.124 3.57c-0.182 0.208-0.498 0.229-0.706 0.047s-0.229-0.498-0.047-0.706l3.5-4c0.095-0.108 0.232-0.171 0.376-0.171s0.281 0.062 0.376 0.171l3.5 4c0.182 0.208 0.161 0.524-0.047 0.706-0.095 0.083-0.212 0.124-0.329 0.124z"
    }
  }]
};
exports.ctrl = ctrl;
var opt = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 13h-4c-0.198 0-0.377-0.116-0.457-0.297l-3.868-8.703h-4.675c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.198 0 0.377 0.116 0.457 0.297l3.868 8.703h3.675c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 4h-5c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h5c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.opt = opt;
var checkboxChecked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM7 12.414l-3.707-3.707 1.414-1.414 2.293 2.293 4.793-4.793 1.414 1.414-6.207 6.207z"
    }
  }]
};
exports.checkboxChecked = checkboxChecked;
var checkboxUnchecked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 0h-12c-1.1 0-2 0.9-2 2v12c0 1.1 0.9 2 2 2h12c1.1 0 2-0.9 2-2v-12c0-1.1-0.9-2-2-2zM14 14h-12v-12h12v12z"
    }
  }]
};
exports.checkboxUnchecked = checkboxUnchecked;
var radioChecked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6zM5 8c0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.657-1.343 3-3 3s-3-1.343-3-3z"
    }
  }]
};
exports.radioChecked = radioChecked;
var radioChecked2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 10c-1.105 0-2-0.895-2-2s0.895-2 2-2c1.105 0 2 0.895 2 2s-0.895 2-2 2z"
    }
  }]
};
exports.radioChecked2 = radioChecked2;
var radioUnchecked = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 14c-3.314 0-6-2.686-6-6s2.686-6 6-6c3.314 0 6 2.686 6 6s-2.686 6-6 6z"
    }
  }]
};
exports.radioUnchecked = radioUnchecked;
var crop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 4l3-3-1-1-3 3h-7v-3h-2v3h-3v2h3v8h8v3h2v-3h3v-2h-3v-7zM5 5h5l-5 5v-5zM6 11l5-5v5h-5z"
    }
  }]
};
exports.crop = crop;
var makeGroup = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 2h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 6h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1zM11 3h2v2h-2v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1zM5 13h-2v-2h2v2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 10h-2c-0.55 0-1 0.45-1 1v2c0 0.55 0.45 1 1 1h2c0.55 0 1-0.45 1-1v-2c0-0.55-0.45-1-1-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 8h-1c-1.336 0-2.591-0.52-3.536-1.464s-1.464-2.2-1.464-3.536v-1c0-1.1-0.9-2-2-2h-4c-1.1 0-2 0.9-2 2v4c0 1.1 0.9 2 2 2h1c1.336 0 2.591 0.52 3.536 1.464s1.464 2.2 1.464 3.536v1c0 1.1 0.9 2 2 2h4c1.1 0 2-0.9 2-2v-4c0-1.1-0.9-2-2-2zM15 14c0 0.265-0.105 0.515-0.295 0.705s-0.44 0.295-0.705 0.295h-4c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.44-0.295-0.705v-1c0-3.314-2.686-6-6-6h-1c-0.265 0-0.515-0.105-0.705-0.295s-0.295-0.441-0.295-0.705v-4c0-0.265 0.105-0.515 0.295-0.705s0.44-0.295 0.705-0.295h4c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v1c0 3.314 2.686 6 6 6h1c0.265 0 0.515 0.105 0.705 0.295s0.295 0.44 0.295 0.705v4z"
    }
  }]
};
exports.makeGroup = makeGroup;
var ungroup = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 7.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.413 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.337-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 12.25c0 0.412-0.338 0.75-0.75 0.75h-1.5c-0.412 0-0.75-0.338-0.75-0.75v-1.5c0-0.412 0.338-0.75 0.75-0.75h1.5c0.412 0 0.75 0.338 0.75 0.75v1.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.251 2.5l1.749-1.749v-0.751h-0.751l-1.749 1.749-1.749-1.749h-0.751v0.751l1.749 1.749-1.749 1.749v0.751h0.751l1.749-1.749 1.749 1.749h0.751v-0.751z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 12h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 9h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 7h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 13h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 10h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 6h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3h1v2h-1v-2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 2h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5 2h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 2h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 15h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10 15h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 15h2v1h-2v-1z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 15h2v1h-2v-1z"
    }
  }]
};
exports.ungroup = ungroup;
var scissors = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.279 10.62c-1.042-1.628-2.829-2.345-3.992-1.601-0.1 0.064-0.193 0.138-0.277 0.218l-1.241-1.942 2.867-4.5c0.235-0.433 0.321-0.949 0.207-1.468-0.109-0.496-0.383-0.913-0.752-1.207l-0.192-0.122-3.398 5.314-3.398-5.314-0.192 0.122c-0.369 0.294-0.643 0.711-0.752 1.207-0.114 0.519-0.027 1.035 0.207 1.468l2.867 4.5-1.241 1.942c-0.085-0.081-0.177-0.154-0.277-0.218-1.163-0.744-2.95-0.028-3.992 1.601s-0.944 3.551 0.219 4.296c1.163 0.744 2.95 0.028 3.992-1.601l2.567-4.029 2.567 4.029c1.042 1.628 2.829 2.345 3.992 1.601s1.261-2.667 0.219-4.296zM3.67 12.507c-0.469 0.733-1.071 1.089-1.478 1.179-0 0-0 0-0 0-0.133 0.029-0.317 0.047-0.443-0.033-0.139-0.089-0.231-0.324-0.247-0.629-0.025-0.494 0.151-1.076 0.483-1.594 0.469-0.733 1.071-1.089 1.478-1.179 0.133-0.029 0.317-0.047 0.443 0.033 0.139 0.089 0.231 0.324 0.247 0.629 0.025 0.495-0.151 1.076-0.483 1.594zM7.5 8c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5 0.5 0.224 0.5 0.5-0.224 0.5-0.5 0.5zM13.498 13.023c-0.016 0.305-0.108 0.54-0.247 0.629-0.125 0.080-0.31 0.062-0.443 0.033 0 0 0 0-0 0-0.407-0.089-1.009-0.446-1.478-1.179-0.332-0.519-0.508-1.1-0.483-1.594 0.016-0.305 0.108-0.54 0.247-0.629 0.125-0.080 0.31-0.062 0.443-0.033 0.407 0.089 1.009 0.446 1.478 1.179 0.332 0.519 0.508 1.1 0.483 1.594z"
    }
  }]
};
exports.scissors = scissors;
var filter = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 1.119-8 2.5v1.5l6 6v5c0 0.552 0.895 1 2 1s2-0.448 2-1v-5l6-6v-1.5c0-1.381-3.582-2.5-8-2.5zM1.475 2.169c0.374-0.213 0.9-0.416 1.52-0.586 1.374-0.376 3.152-0.583 5.005-0.583s3.631 0.207 5.005 0.583c0.62 0.17 1.146 0.372 1.52 0.586 0.247 0.141 0.38 0.26 0.442 0.331-0.062 0.071-0.195 0.19-0.442 0.331-0.374 0.213-0.9 0.416-1.52 0.586-1.374 0.376-3.152 0.583-5.005 0.583s-3.631-0.207-5.005-0.583c-0.62-0.17-1.146-0.372-1.52-0.586-0.247-0.141-0.38-0.26-0.442-0.331 0.062-0.071 0.195-0.19 0.442-0.331z"
    }
  }]
};
exports.filter = filter;
var font = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.494 0.253c-1.414 0-2.322-0.253-3.779-0.253-4.708 0-6.903 2.681-6.903 5.404 0 1.604 0.76 2.132 2.259 2.132-0.106-0.232-0.296-0.486-0.296-1.626 0-3.188 1.203-4.117 2.744-4.18 0 0-1.264 12.396-4.934 13.883v0.385h4.947l1.688-8h3.091l0.689-2h-3.358l0.812-3.847c0.929 0.19 1.837 0.38 2.618 0.38 0.971 0 1.858-0.296 2.343-2.533-0.591 0.19-1.224 0.253-1.921 0.253z"
    }
  }]
};
exports.font = font;
var ligature = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 13.622c0-0.001 0-0.001 0-0.002l-0.005-6.821-1.992 0.097h-3.936v-0.336c0-1.274 0.091-2.546 0.269-3.042 0.123-0.343 0.353-0.652 0.683-0.919 0.322-0.261 0.643-0.393 0.955-0.393 0.262 0 0.48 0.045 0.647 0.134 0.235 0.134 0.464 0.359 0.682 0.669 0.577 0.82 0.812 1.038 0.939 1.131 0.216 0.158 0.477 0.238 0.776 0.238 0.292 0 0.546-0.109 0.757-0.324 0.209-0.213 0.315-0.479 0.315-0.792 0-0.335-0.139-0.691-0.414-1.057-0.268-0.358-0.683-0.652-1.232-0.875-0.536-0.218-1.14-0.329-1.793-0.329-0.949 0-1.813 0.228-2.568 0.678-0.757 0.451-1.337 1.077-1.725 1.863-0.359 0.728-0.333 2.105-0.355 3.355h-1.965v1.116h1.962v5.073c0 1.12-0.342 1.422-0.472 1.583-0.179 0.222-0.509 0.455-0.944 0.455h-0.604v0.878h6.021v-0.878h-0.105c-1.424 0-1.828-0.154-1.828-1.888 0-0 0-0.001 0-0.001l-0.001-5.222h2.191c1.163 0 1.43 0.054 1.491 0.077 0.074 0.028 0.169 0.075 0.204 0.143 0.014 0.026 0.081 0.391 0.081 1.296v3.917c0 0.913-0.111 1.217-0.179 1.319-0.145 0.222-0.319 0.345-0.854 0.358v0.879h4.588v-0.873c-1.431 0-1.588-0.153-1.588-1.505z"
    }
  }]
};
exports.ligature = ligature;
var ligature2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.364 14.335c-0.183 0-1.307-0.206-1.375-0.458-0.161-0.619-0.183-1.284-0.183-2.040v-8.453c0-1.261 0.252-1.994 0.252-1.994-0.023-0.115-0.138-0.367-0.275-0.367h-0.069c-0.069 0-0.871 0.504-1.605 0.504-0.596-0-0.967-0.527-1.655-0.527-2.892 0-4.249 2.349-4.249 5.672v0.173c0 0.069-0.046 0.138-0.115 0.138h-0.94c-0.115 0-0.344 0.642-0.344 0.94 0 0.092 0.023 0.137 0.069 0.137h1.215c0.069 0 0.115 0.092 0.115 0.16 0 2.040-0.023 4.052-0.023 4.052 0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.138 0.046-0.665-0.069-0.665-0.183 0-1.307-0.206-1.375-0.458-0.16-0.619-0.16-1.284-0.183-2.040v-3.639c0-0.069 0.069-0.138 0.138-0.138h2.361c0.16-0.321 0.275-0.711 0.275-0.917 0-0.138 0-0.16-0.115-0.16h-2.544c-0.046 0-0.115-0.069-0.115-0.115v-0.825c0-2.040 0.836-3.837 2.234-3.837 0.99 0 1.854 0.642 1.854 3.093 0 0 0 0 0 0 0.003 0.063 0.005 0.114 0.005 0.148v6.825c0 0.321-0.023 1.031-0.16 1.605-0.069 0.252-1.123 0.458-1.398 0.458-0.115 0-0.115 0.55 0 0.665 0.94-0.046 1.559-0.115 2.499-0.115 0.871 0 1.536 0.069 2.453 0.115 0.046-0.137 0.046-0.665-0.069-0.665z"
    }
  }]
};
exports.ligature2 = ligature2;
var textHeight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 12h2l-2.5 3-2.5-3h2v-8h-2l2.5-3 2.5 3h-2zM10 1v4l-1-2h-3v11h2v1h-6v-1h2v-11h-3l-1 2v-4z"
    }
  }]
};
exports.textHeight = textHeight;
var textWidth = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 14v2l-3-2.5 3-2.5v2h8v-2l3 2.5-3 2.5v-2zM13 1v4l-1-2h-3v7h2v1h-6v-1h2v-7h-3l-1 2v-4z"
    }
  }]
};
exports.textWidth = textWidth;
var fontSize = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 8h6v2h-2v6h-2v-6h-2zM15 4h-3.934v12h-2.133v-12h-3.934v-2h10z"
    }
  }]
};
exports.fontSize = fontSize;
var bold = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.061 7.573c0.586-0.696 0.939-1.594 0.939-2.573 0-2.206-1.794-4-4-4h-5v14h6c2.206 0 4-1.794 4-4 0-1.452-0.778-2.726-1.939-3.427zM6 3h1.586c0.874 0 1.586 0.897 1.586 2s-0.711 2-1.586 2h-1.586v-4zM8.484 13h-2.484v-4h2.484c0.913 0 1.656 0.897 1.656 2s-0.743 2-1.656 2z"
    }
  }]
};
exports.bold = bold;
var underline = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 1h2v6.5c0 2.485-2.239 4.5-5 4.5s-5-2.015-5-4.5v-6.5h2v6.5c0 0.628 0.285 1.23 0.802 1.695 0.577 0.519 1.357 0.805 2.198 0.805s1.621-0.286 2.198-0.805c0.517-0.466 0.802-1.068 0.802-1.695v-6.5zM3 13h10v2h-10z"
    }
  }]
};
exports.underline = underline;
var italic = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 1v1h-2l-5 12h2v1h-7v-1h2l5-12h-2v-1z"
    }
  }]
};
exports.italic = italic;
var strikethrough = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8v1h-3.664c0.43 0.602 0.664 1.292 0.664 2 0 1.107-0.573 2.172-1.572 2.921-0.927 0.696-2.145 1.079-3.428 1.079s-2.501-0.383-3.428-1.079c-0.999-0.749-1.572-1.814-1.572-2.921h2c0 1.084 1.374 2 3 2s3-0.916 3-2c0-1.084-1.374-2-3-2h-8v-1h4.68c-0.037-0.026-0.073-0.052-0.108-0.079-0.999-0.749-1.572-1.814-1.572-2.921s0.573-2.172 1.572-2.921c0.927-0.696 2.145-1.079 3.428-1.079s2.501 0.383 3.428 1.079c0.999 0.749 1.572 1.814 1.572 2.921h-2c0-1.084-1.374-2-3-2s-3 0.916-3 2c0 1.084 1.374 2 3 2 1.234 0 2.407 0.354 3.32 1h4.68z"
    }
  }]
};
exports.strikethrough = strikethrough;
var omega = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 14h4l1-2v4h-6v-3.347c2.049-0.883 3.5-3.081 3.5-5.653 0-3.35-2.462-5.973-5.5-5.973s-5.5 2.622-5.5 5.973c0 2.572 1.451 4.77 3.5 5.653v3.347h-6v-4l1 2h4v-0.509c-2.932-1.038-5-3.553-5-6.491 0-3.866 3.582-7 8-7s8 3.134 8 7c0 2.938-2.068 5.452-5 6.491v0.509z"
    }
  }]
};
exports.omega = omega;
var sigma = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.713 11.48l0.694-1.48h0.594l-1 6h-15v-1.16l5.18-6.113-5.18-5.18v-3.547h15.313l0.688 4h-0.537l-0.293-0.607c-0.552-1.146-0.967-1.393-2.17-1.393h-10.344l5.517 5.516-4.647 5.483h8.474c1.813 0 2.291-0.65 2.713-1.52z"
    }
  }]
};
exports.sigma = sigma;
var pageBreak = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 8h2v1h-2zM3 8h3v1h-3zM7 8h2v1h-2zM10 8h3v1h-3zM14 8h2v1h-2zM13.75 0l0.25 7h-12l0.25-7h0.5l0.25 6h10l0.25-6zM2.25 16l-0.25-6h12l-0.25 6h-0.5l-0.25-5h-10l-0.25 5z"
    }
  }]
};
exports.pageBreak = pageBreak;
var superscript = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 3.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
    }
  }]
};
exports.superscript = superscript;
var subscript = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12 14.219v0.781h2v1h-3v-2.281l2-0.938v-0.781h-2v-1h3v2.281zM10.563 4h-2.125l-2.938 2.938-2.938-2.938h-2.125l4 4-4 4h2.125l2.938-2.938 2.938 2.938h2.125l-4-4z"
    }
  }]
};
exports.subscript = subscript;
var superscript2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM11 13l2.5-4 2.5 4h-5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 2h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
    }
  }]
};
exports.superscript2 = superscript2;
var subscript2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM5.432 5h1.137l0.9 3h-2.937l0.9-3zM16 3l-2.5 4-2.5-4h5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 13h-1c-0.276 0-0.5-0.224-0.5-0.5s0.224-0.5 0.5-0.5h2c0.276 0 0.5-0.224 0.5-0.5s-0.224-0.5-0.5-0.5h-2c-0.827 0-1.5 0.673-1.5 1.5 0 0.384 0.145 0.734 0.383 1 0.275 0.307 0.674 0.5 1.117 0.5h1c0.276 0 0.5 0.224 0.5 0.5s-0.224 0.5-0.5 0.5h-2c-0.276 0-0.5 0.224-0.5 0.5s0.224 0.5 0.5 0.5h2c0.827 0 1.5-0.673 1.5-1.5 0-0.384-0.145-0.734-0.383-1-0.275-0.307-0.674-0.5-1.117-0.5z"
    }
  }]
};
exports.subscript2 = subscript2;
var textColor = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.032 13l0.9-3h4.137l0.9 3h1.775l-3-10h-3.488l-3 10h1.776zM7.432 5h1.137l0.9 3h-2.937l0.9-3z"
    }
  }]
};
exports.textColor = textColor;
var pagebreak = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 6v-6h12v6h-1v-5h-10v5zM16 9v7h-12v-7h1v6h10v-6zM8 7h2v1h-2zM5 7h2v1h-2zM11 7h2v1h-2zM14 7h2v1h-2zM0 4.5l3 3-3 3z"
    }
  }]
};
exports.pagebreak = pagebreak;
var clearFormatting = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 14h9v2h-9zM14 2h-4.727l-2.871 11h-2.067l2.871-11h-4.205v-2h11zM14.528 16l-2.028-2.028-2.028 2.028-0.972-0.972 2.028-2.028-2.028-2.028 0.972-0.972 2.028 2.028 2.028-2.028 0.972 0.972-2.028 2.028 2.028 2.028z"
    }
  }]
};
exports.clearFormatting = clearFormatting;
var table = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 3v11h16v-11h-16zM6 10v-2h4v2h-4zM10 11v2h-4v-2h4zM10 5v2h-4v-2h4zM5 5v2h-4v-2h4zM1 8h4v2h-4v-2zM11 8h4v2h-4v-2zM11 7v-2h4v2h-4zM1 11h4v2h-4v-2zM11 13v-2h4v2h-4z"
    }
  }]
};
exports.table = table;
var table2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1v14h16v-14h-16zM6 10v-3h4v3h-4zM10 11v3h-4v-3h4zM10 3v3h-4v-3h4zM5 3v3h-4v-3h4zM1 7h4v3h-4v-3zM11 7h4v3h-4v-3zM11 6v-3h4v3h-4zM1 11h4v3h-4v-3zM11 14v-3h4v3h-4z"
    }
  }]
};
exports.table2 = table2;
var insertTemplate = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 3h2v1h-2zM9 3h2v1h-2zM14 3v4h-3v-1h2v-2h-1v-1zM5 6h2v1h-2zM8 6h2v1h-2zM3 4v2h1v1h-2v-4h3v1zM6 9h2v1h-2zM9 9h2v1h-2zM14 9v4h-3v-1h2v-2h-1v-1zM5 12h2v1h-2zM8 12h2v1h-2zM3 10v2h1v1h-2v-4h3v1zM15 1h-14v14h14v-14zM16 0v0 16h-16v-16h16z"
    }
  }]
};
exports.insertTemplate = insertTemplate;
var pilcrow = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 0h8v2h-2v14h-2v-14h-2v14h-2v-8c-2.209 0-4-1.791-4-4s1.791-4 4-4z"
    }
  }]
};
exports.pilcrow = pilcrow;
var ltr = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM0 11l4-4-4-4z"
    }
  }]
};
exports.ltr = ltr;
var rtl = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 0c-2.209 0-4 1.791-4 4s1.791 4 4 4v8h2v-14h2v14h2v-14h2v-2h-8zM16 3l-4 4 4 4z"
    }
  }]
};
exports.rtl = rtl;
var section = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.749 16c-0.771 0-1.424-0.225-1.939-0.669-0.519-0.447-0.782-0.969-0.782-1.552 0-0.283 0.103-0.527 0.307-0.726 0.207-0.202 0.465-0.309 0.748-0.309 0.281 0 0.534 0.1 0.732 0.29 0.195 0.187 0.294 0.435 0.294 0.736 0 0.177-0.029 0.372-0.086 0.58-0.056 0.206-0.068 0.312-0.068 0.364 0 0.058 0.014 0.126 0.121 0.199 0.199 0.138 0.439 0.204 0.732 0.204 0.353 0 0.667-0.123 0.962-0.375 0.29-0.249 0.431-0.505 0.431-0.782 0-0.308-0.082-0.575-0.252-0.816-0.287-0.402-0.826-0.874-1.603-1.401-1.248-0.835-2.079-1.559-2.54-2.211-0.358-0.511-0.539-1.061-0.539-1.636 0-0.579 0.19-1.155 0.564-1.713 0.32-0.477 0.794-0.908 1.41-1.283-0.33-0.355-0.577-0.689-0.736-0.995-0.201-0.387-0.303-0.787-0.303-1.189 0-0.747 0.295-1.393 0.878-1.92s1.31-0.795 2.161-0.795c0.783 0 1.441 0.22 1.956 0.654 0.521 0.439 0.785 0.952 0.785 1.524 0 0.292-0.109 0.553-0.324 0.776l-0.004 0.004c-0.125 0.124-0.353 0.271-0.735 0.271-0.299 0-0.561-0.098-0.758-0.283-0.196-0.184-0.296-0.405-0.296-0.656 0-0.108 0.027-0.272 0.084-0.515 0.028-0.115 0.042-0.221 0.042-0.316 0-0.162-0.058-0.285-0.183-0.39-0.129-0.108-0.314-0.161-0.565-0.161-0.389 0-0.708 0.118-0.975 0.361s-0.399 0.533-0.399 0.883c0 0.315 0.071 0.574 0.212 0.771 0.267 0.374 0.731 0.778 1.378 1.201 1.315 0.853 2.233 1.636 2.727 2.325 0.365 0.518 0.549 1.068 0.549 1.637 0 0.572-0.186 1.148-0.552 1.714-0.316 0.487-0.793 0.926-1.42 1.308 0.347 0.367 0.591 0.688 0.743 0.977 0.189 0.359 0.284 0.751 0.284 1.165 0 0.776-0.296 1.435-0.879 1.96s-1.31 0.79-2.161 0.79zM6.975 5.568c-0.753 0.452-1.12 0.972-1.12 1.583 0 0.356 0.102 0.674 0.31 0.973 0.311 0.436 0.926 0.97 1.825 1.583 0.381 0.259 0.724 0.511 1.025 0.751 0.767-0.461 1.14-0.974 1.14-1.565 0-0.322-0.127-0.668-0.378-1.030-0.263-0.378-0.826-0.872-1.674-1.467-0.443-0.306-0.821-0.583-1.128-0.827z"
    }
  }]
};
exports.section = section;
var paragraphLeft = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM0 4h10v2h-10zM0 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
    }
  }]
};
exports.paragraphLeft = paragraphLeft;
var paragraphCenter = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM3 4h10v2h-10zM3 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
    }
  }]
};
exports.paragraphCenter = paragraphCenter;
var paragraphRight = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 10h10v2h-10zM0 7h16v2h-16zM0 13h16v2h-16z"
    }
  }]
};
exports.paragraphRight = paragraphRight;
var paragraphJustify = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM0 4h16v2h-16zM0 7h16v2h-16zM0 10h16v2h-16zM0 13h16v2h-16z"
    }
  }]
};
exports.paragraphJustify = paragraphJustify;
var indentIncrease = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM0 11v-6l4 3z"
    }
  }]
};
exports.indentIncrease = indentIncrease;
var indentDecrease = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1h16v2h-16zM6 4h10v2h-10zM6 7h10v2h-10zM6 10h10v2h-10zM0 13h16v2h-16zM4 5v6l-4-3z"
    }
  }]
};
exports.indentDecrease = indentDecrease;
var share = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 10c0 0 0.919-3 6-3v3l6-4-6-4v3c-4 0-6 2.495-6 5zM11 12h-9v-6h1.967c0.158-0.186 0.327-0.365 0.508-0.534 0.687-0.644 1.509-1.135 2.439-1.466h-6.914v10h13v-4.197l-2 1.333v0.864z"
    }
  }]
};
exports.share = share;
var newTab = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3 1v12h12v-12h-12zM14 12h-10v-10h10v10zM2 14v-10.5l-1-1v12.5h12.5l-1-1h-10.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.5 4l2.5 2.5-3 3 1.5 1.5 3-3 2.5 2.5v-6.5z"
    }
  }]
};
exports.newTab = newTab;
var embed = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
    }
  }]
};
exports.embed = embed;
var embed2 = {
  "viewBox": "0 0 20 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13 11.5l1.5 1.5 5-5-5-5-1.5 1.5 3.5 3.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7 4.5l-1.5-1.5-5 5 5 5 1.5-1.5-3.5-3.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.958 2.352l1.085 0.296-3 11-1.085-0.296 3-11z"
    }
  }]
};
exports.embed2 = embed2;
var terminal = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 1v14h16v-14h-16zM15 14h-14v-12h14v12zM14 3h-12v10h12v-10zM7 8h-1v1h-1v1h-1v-1h1v-1h1v-1h-1v-1h-1v-1h1v1h1v1h1v1zM11 10h-3v-1h3v1z"
    }
  }]
};
exports.terminal = terminal;
var share2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.5 11c-0.706 0-1.342 0.293-1.797 0.763l-6.734-3.367c0.021-0.129 0.032-0.261 0.032-0.396s-0.011-0.267-0.032-0.396l6.734-3.367c0.455 0.47 1.091 0.763 1.797 0.763 1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5-2.5 1.119-2.5 2.5c0 0.135 0.011 0.267 0.031 0.396l-6.734 3.367c-0.455-0.47-1.091-0.763-1.797-0.763-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5c0.706 0 1.343-0.293 1.797-0.763l6.734 3.367c-0.021 0.129-0.031 0.261-0.031 0.396 0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5c0-1.381-1.119-2.5-2.5-2.5z"
    }
  }]
};
exports.share2 = share2;
var mail = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.467 1.2 2.667 2.667 2.667h10.666c1.468 0 2.667-1.2 2.667-2.667v-10.666c0-1.467-1.199-2.667-2.667-2.667zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
    }
  }]
};
exports.mail = mail;
var mail2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM13.333 2c0.125 0 0.243 0.036 0.344 0.099l-5.678 4.694-5.677-4.694c0.101-0.063 0.219-0.099 0.344-0.099h10.666zM2.667 14c-0.030 0-0.060-0.002-0.089-0.006l3.525-4.89-0.457-0.457-3.646 3.646v-9.549l6 7.256 6-7.256v9.549l-3.646-3.646-0.457 0.457 3.525 4.89c-0.029 0.004-0.059 0.006-0.088 0.006h-10.666z"
    }
  }]
};
exports.mail2 = mail2;
var mail3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.333 0h-10.666c-1.467 0-2.667 1.2-2.667 2.667v10.666c0 1.468 1.2 2.667 2.667 2.667h10.666c1.467 0 2.667-1.199 2.667-2.667v-10.666c0-1.467-1.2-2.667-2.667-2.667zM2.854 13.854l-1.207-1.207 4-4 0.457 0.457-3.25 4.75zM2.396 3.104l0.457-0.457 5.146 4.146 5.146-4.146 0.457 0.457-5.604 6.604-5.604-6.604zM13.146 13.854l-3.25-4.75 0.457-0.457 4 4-1.207 1.207z"
    }
  }]
};
exports.mail3 = mail3;
var mail4 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM4 4h8c0.143 0 0.281 0.031 0.409 0.088l-4.409 5.143-4.409-5.143c0.127-0.058 0.266-0.088 0.409-0.088zM3 11v-6c0-0.021 0.001-0.042 0.002-0.063l2.932 3.421-2.9 2.9c-0.023-0.083-0.034-0.17-0.034-0.258zM12 12h-8c-0.088 0-0.175-0.012-0.258-0.034l2.846-2.846 1.413 1.648 1.413-1.648 2.846 2.846c-0.083 0.023-0.17 0.034-0.258 0.034zM13 11c0 0.088-0.012 0.175-0.034 0.258l-2.9-2.9 2.932-3.421c0.001 0.021 0.002 0.042 0.002 0.063v6z"
    }
  }]
};
exports.mail4 = mail4;
var amazon = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.463 13.831c-1.753 1.294-4.291 1.981-6.478 1.981-3.066 0-5.825-1.131-7.912-3.019-0.163-0.147-0.019-0.35 0.178-0.234 2.253 1.313 5.041 2.1 7.919 2.1 1.941 0 4.075-0.403 6.041-1.238 0.294-0.125 0.544 0.197 0.253 0.409z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.191 13c-0.225-0.287-1.481-0.137-2.047-0.069-0.172 0.019-0.197-0.128-0.044-0.238 1.003-0.703 2.647-0.5 2.838-0.266 0.194 0.238-0.050 1.884-0.991 2.672-0.144 0.122-0.281 0.056-0.219-0.103 0.216-0.528 0.688-1.709 0.463-1.997z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.053 11.838l0.003 0.003c0.387-0.341 1.084-0.95 1.478-1.278 0.156-0.125 0.128-0.334 0.006-0.509-0.353-0.488-0.728-0.884-0.728-1.784v-3c0-1.272 0.088-2.438-0.847-3.313-0.738-0.706-1.963-0.956-2.9-0.956-1.831 0-3.875 0.684-4.303 2.947-0.047 0.241 0.131 0.369 0.287 0.403l1.866 0.203c0.175-0.009 0.3-0.181 0.334-0.356 0.159-0.778 0.813-1.156 1.547-1.156 0.397 0 0.847 0.144 1.081 0.5 0.269 0.397 0.234 0.938 0.234 1.397v0.25c-1.116 0.125-2.575 0.206-3.619 0.666-1.206 0.522-2.053 1.584-2.053 3.147 0 2 1.259 3 2.881 3 1.369 0 2.116-0.322 3.172-1.403 0.35 0.506 0.463 0.753 1.103 1.284 0.147 0.078 0.328 0.072 0.456-0.044zM9.113 7.144c0 0.75 0.019 1.375-0.359 2.041-0.306 0.544-0.791 0.875-1.331 0.875-0.737 0-1.169-0.563-1.169-1.394 0-1.641 1.472-1.938 2.863-1.938v0.416z"
    }
  }]
};
exports.amazon = amazon;
var google = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.159 6.856v2.744h4.537c-0.184 1.178-1.372 3.45-4.537 3.45-2.731 0-4.959-2.262-4.959-5.050s2.228-5.050 4.959-5.050c1.553 0 2.594 0.663 3.188 1.234l2.172-2.091c-1.394-1.306-3.2-2.094-5.359-2.094-4.422 0-8 3.578-8 8s3.578 8 8 8c4.616 0 7.681-3.247 7.681-7.816 0-0.525-0.056-0.925-0.125-1.325l-7.556-0.003z"
    }
  }]
};
exports.google = google;
var google2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
    }
  }]
};
exports.google2 = google2;
var google3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM8.119 14c-3.316 0-6-2.684-6-6s2.684-6 6-6c1.619 0 2.975 0.591 4.019 1.569l-1.628 1.569c-0.447-0.428-1.225-0.925-2.391-0.925-2.050 0-3.719 1.697-3.719 3.787s1.672 3.787 3.719 3.787c2.375 0 3.266-1.706 3.403-2.588h-3.403v-2.056h5.666c0.050 0.3 0.094 0.6 0.094 0.994 0.003 3.428-2.294 5.863-5.759 5.863z"
    }
  }]
};
exports.google3 = google3;
var googlePlus = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.091 7.147v1.747h2.888c-0.116 0.75-0.872 2.197-2.888 2.197-1.737 0-3.156-1.441-3.156-3.216s1.419-3.216 3.156-3.216c0.991 0 1.65 0.422 2.028 0.784l1.381-1.331c-0.888-0.828-2.037-1.331-3.409-1.331-2.816 0.003-5.091 2.278-5.091 5.094s2.275 5.091 5.091 5.091c2.937 0 4.888-2.066 4.888-4.975 0-0.334-0.037-0.591-0.081-0.844h-4.806z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 7h-1.5v-1.5h-1.5v1.5h-1.5v1.5h1.5v1.5h1.5v-1.5h1.5z"
    }
  }]
};
exports.googlePlus = googlePlus;
var googlePlus2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM14 8h-1v1h-1v-1h-1v-1h1v-1h1v1h1v1z"
    }
  }]
};
exports.googlePlus2 = googlePlus2;
var googlePlus3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM6 12c-2.212 0-4-1.787-4-4s1.788-4 4-4c1.081 0 1.984 0.394 2.681 1.047l-1.088 1.044c-0.297-0.284-0.816-0.616-1.594-0.616-1.366 0-2.481 1.131-2.481 2.525s1.116 2.525 2.481 2.525c1.584 0 2.178-1.137 2.269-1.725h-2.269v-1.372h3.778c0.034 0.2 0.063 0.4 0.063 0.663 0 2.287-1.531 3.909-3.841 3.909zM13 8v1h-1v-1h-1v-1h1v-1h1v1h1v1h-1z"
    }
  }]
};
exports.googlePlus3 = googlePlus3;
var hangouts = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.997 0c-3.816 0-6.909 3.094-6.909 6.909 0 3.616 3.294 6.547 6.909 6.547v2.544c4.197-2.128 6.916-5.556 6.916-9.091 0-3.816-3.1-6.909-6.916-6.909zM7 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3zM12 8c0 0.828-0.447 1.5-1 1.5v-1.5h-2v-3h3v3z"
    }
  }]
};
exports.hangouts = hangouts;
var googleDrive = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.844 10l-2.884 5h9.072l2.884-5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.506 9l-4.619-8h-5.775l4.619 8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.534 2l-4.534 7.856 2.888 5 4.534-7.856z"
    }
  }]
};
exports.googleDrive = googleDrive;
var facebook = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 3h2.5v-3h-2.5c-1.93 0-3.5 1.57-3.5 3.5v1.5h-2v3h2v8h3v-8h2.5l0.5-3h-3v-1.5c0-0.271 0.229-0.5 0.5-0.5z"
    }
  }]
};
exports.facebook = facebook;
var facebook2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h6.5v-7h-2v-2h2v-1c0-1.653 1.347-3 3-3h2v2h-2c-0.55 0-1 0.45-1 1v1h3l-0.5 2h-2.5v7h4.5c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5z"
    }
  }]
};
exports.facebook2 = facebook2;
var instagram = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11 2.5c0-0.275 0.225-0.5 0.5-0.5h2c0.275 0 0.5 0.225 0.5 0.5v2c0 0.275-0.225 0.5-0.5 0.5h-2c-0.275 0-0.5-0.225-0.5-0.5v-2zM8 5c1.656 0 3 1.344 3 3s-1.344 3-3 3c-1.656 0-3-1.344-3-3s1.344-3 3-3zM14 13.5v0c0 0.275-0.225 0.5-0.5 0.5h-11c-0.275 0-0.5-0.225-0.5-0.5v0-6.5h1.1c-0.066 0.322-0.1 0.656-0.1 1 0 2.762 2.237 5 5 5s5-2.238 5-5c0-0.344-0.034-0.678-0.1-1h1.1v6.5z"
    }
  }]
};
exports.instagram = instagram;
var whatsapp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.641 2.325c-1.497-1.5-3.488-2.325-5.609-2.325-4.369 0-7.925 3.556-7.925 7.928 0 1.397 0.366 2.763 1.059 3.963l-1.125 4.109 4.203-1.103c1.159 0.631 2.463 0.966 3.787 0.966h0.003c0 0 0 0 0 0 4.369 0 7.928-3.556 7.928-7.928 0-2.119-0.825-4.109-2.322-5.609zM8.034 14.525v0c-1.184 0-2.344-0.319-3.356-0.919l-0.241-0.144-2.494 0.653 0.666-2.431-0.156-0.25c-0.663-1.047-1.009-2.259-1.009-3.506 0-3.634 2.956-6.591 6.594-6.591 1.759 0 3.416 0.688 4.659 1.931 1.244 1.247 1.928 2.9 1.928 4.662-0.003 3.637-2.959 6.594-6.591 6.594zM11.647 9.588c-0.197-0.1-1.172-0.578-1.353-0.644s-0.313-0.1-0.447 0.1c-0.131 0.197-0.512 0.644-0.628 0.778-0.116 0.131-0.231 0.15-0.428 0.050s-0.838-0.309-1.594-0.984c-0.588-0.525-0.987-1.175-1.103-1.372s-0.013-0.306 0.088-0.403c0.091-0.088 0.197-0.231 0.297-0.347s0.131-0.197 0.197-0.331c0.066-0.131 0.034-0.247-0.016-0.347s-0.447-1.075-0.609-1.472c-0.159-0.388-0.325-0.334-0.447-0.341-0.116-0.006-0.247-0.006-0.378-0.006s-0.347 0.050-0.528 0.247c-0.181 0.197-0.694 0.678-0.694 1.653s0.709 1.916 0.809 2.050c0.1 0.131 1.397 2.134 3.384 2.991 0.472 0.203 0.841 0.325 1.128 0.419 0.475 0.15 0.906 0.128 1.247 0.078 0.381-0.056 1.172-0.478 1.338-0.941s0.166-0.859 0.116-0.941c-0.047-0.088-0.178-0.137-0.378-0.238z"
    }
  }]
};
exports.whatsapp = whatsapp;
var spotify = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8-3.559-8-8-8zM11.681 11.559c-0.159 0.241-0.441 0.319-0.681 0.159-1.881-1.159-4.241-1.4-7.041-0.759-0.281 0.081-0.519-0.119-0.6-0.359-0.081-0.281 0.119-0.519 0.359-0.6 3.041-0.681 5.681-0.4 7.759 0.881 0.281 0.119 0.322 0.438 0.203 0.678zM12.641 9.359c-0.2 0.281-0.559 0.4-0.841 0.2-2.159-1.319-5.441-1.719-7.959-0.919-0.319 0.081-0.681-0.081-0.759-0.4-0.081-0.319 0.081-0.681 0.4-0.759 2.919-0.881 6.519-0.441 9 1.081 0.238 0.119 0.359 0.519 0.159 0.797zM12.719 7.119c-2.559-1.519-6.841-1.681-9.281-0.919-0.4 0.119-0.8-0.119-0.919-0.481-0.119-0.4 0.119-0.8 0.481-0.919 2.841-0.841 7.519-0.681 10.481 1.081 0.359 0.2 0.481 0.681 0.281 1.041-0.203 0.278-0.681 0.397-1.044 0.197z"
    }
  }]
};
exports.spotify = spotify;
var telegram = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM11.931 5.484l-1.313 6.184c-0.091 0.441-0.356 0.544-0.725 0.341l-2-1.478-0.959 0.934c-0.112 0.109-0.2 0.2-0.4 0.2-0.259 0-0.216-0.097-0.303-0.344l-0.681-2.237-1.978-0.616c-0.428-0.131-0.431-0.425 0.097-0.634l7.706-2.975c0.35-0.159 0.691 0.084 0.556 0.625z"
    }
  }]
};
exports.telegram = telegram;
var twitter = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 3.538c-0.588 0.263-1.222 0.438-1.884 0.516 0.678-0.406 1.197-1.050 1.444-1.816-0.634 0.375-1.338 0.65-2.084 0.797-0.6-0.638-1.453-1.034-2.397-1.034-1.813 0-3.281 1.469-3.281 3.281 0 0.256 0.028 0.506 0.084 0.747-2.728-0.138-5.147-1.444-6.766-3.431-0.281 0.484-0.444 1.050-0.444 1.65 0 1.138 0.578 2.144 1.459 2.731-0.538-0.016-1.044-0.166-1.488-0.409 0 0.013 0 0.028 0 0.041 0 1.591 1.131 2.919 2.634 3.219-0.275 0.075-0.566 0.116-0.866 0.116-0.212 0-0.416-0.022-0.619-0.059 0.419 1.303 1.631 2.253 3.066 2.281-1.125 0.881-2.538 1.406-4.078 1.406-0.266 0-0.525-0.016-0.784-0.047 1.456 0.934 3.181 1.475 5.034 1.475 6.037 0 9.341-5.003 9.341-9.341 0-0.144-0.003-0.284-0.009-0.425 0.641-0.459 1.197-1.038 1.637-1.697z"
    }
  }]
};
exports.twitter = twitter;
var vine = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.012 7.953c-0.412 0.094-0.809 0.137-1.169 0.137-2.019 0-3.572-1.409-3.572-3.862 0-1.203 0.466-1.825 1.122-1.825 0.625 0 1.041 0.559 1.041 1.697 0 0.647-0.172 1.356-0.3 1.775 0 0 0.622 1.084 2.322 0.753 0.363-0.803 0.556-1.841 0.556-2.75 0-2.45-1.25-3.878-3.541-3.878-2.356 0-3.734 1.809-3.734 4.197 0 2.366 1.106 4.394 2.928 5.319-0.766 1.534-1.741 2.884-2.759 3.903-1.844-2.231-3.513-5.206-4.197-11.016h-2.722c1.259 9.675 5.006 12.756 6 13.347 0.559 0.337 1.044 0.322 1.556 0.031 0.806-0.456 3.222-2.875 4.563-5.703 0.563 0 1.238-0.066 1.909-0.219v-1.906z"
    }
  }]
};
exports.vine = vine;
var vk = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.959 11.2l-1.463 0.022c0 0-0.316 0.063-0.728-0.222-0.547-0.375-1.063-1.353-1.466-1.225-0.406 0.128-0.394 1.006-0.394 1.006s0.003 0.188-0.091 0.287c-0.1 0.109-0.3 0.131-0.3 0.131h-0.653c0 0-1.444 0.088-2.716-1.238-1.388-1.444-2.612-4.309-2.612-4.309s-0.072-0.188 0.006-0.278c0.087-0.103 0.322-0.109 0.322-0.109l1.566-0.009c0 0 0.147 0.025 0.253 0.103 0.088 0.063 0.134 0.184 0.134 0.184s0.253 0.641 0.588 1.219c0.653 1.128 0.959 1.375 1.181 1.256 0.322-0.175 0.225-1.597 0.225-1.597s0.006-0.516-0.162-0.744c-0.131-0.178-0.378-0.231-0.484-0.244-0.088-0.013 0.056-0.216 0.244-0.309 0.281-0.138 0.778-0.147 1.366-0.141 0.456 0.003 0.591 0.034 0.769 0.075 0.541 0.131 0.356 0.634 0.356 1.841 0 0.388-0.069 0.931 0.209 1.109 0.119 0.078 0.412 0.012 1.147-1.234 0.347-0.591 0.609-1.284 0.609-1.284s0.056-0.125 0.144-0.178c0.091-0.053 0.213-0.037 0.213-0.037l1.647-0.009c0 0 0.494-0.059 0.575 0.166 0.084 0.234-0.184 0.781-0.856 1.678-1.103 1.472-1.228 1.334-0.309 2.184 0.875 0.813 1.056 1.209 1.088 1.259 0.356 0.6-0.406 0.647-0.406 0.647z"
    }
  }]
};
exports.vk = vk;
var renren = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.644 0.166c-3.769 0.634-6.644 3.913-6.644 7.862 0 1.963 0.713 3.759 1.887 5.15 2.791-1.35 4.744-4.406 4.756-7.966v-5.047z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.356 0.166c3.769 0.634 6.644 3.913 6.644 7.862 0 1.963-0.713 3.759-1.887 5.15-2.791-1.35-4.744-4.406-4.756-7.966v-5.047z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.972 10.041c-0.497 2.056-1.981 3.813-3.828 4.981 1.138 0.622 2.441 0.978 3.828 0.978s2.691-0.356 3.828-0.978c-1.847-1.169-3.331-2.925-3.828-4.981z"
    }
  }]
};
exports.renren = renren;
var sinaWeibo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.722 14.031c-2.65 0.262-4.938-0.938-5.109-2.675-0.172-1.741 1.837-3.359 4.484-3.622 2.65-0.263 4.938 0.938 5.106 2.675 0.175 1.741-1.834 3.362-4.481 3.622zM12.019 8.259c-0.225-0.069-0.381-0.113-0.262-0.409 0.256-0.644 0.281-1.197 0.003-1.594-0.519-0.741-1.941-0.703-3.569-0.019 0 0-0.513 0.222-0.381-0.181 0.25-0.806 0.213-1.478-0.178-1.869-0.884-0.884-3.234 0.034-5.25 2.050-1.506 1.503-2.381 3.106-2.381 4.491 0 2.644 3.394 4.253 6.713 4.253 4.35 0 7.247-2.528 7.247-4.534 0-1.216-1.022-1.903-1.941-2.188z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.909 3.416c-1.050-1.166-2.6-1.609-4.031-1.306v0c-0.331 0.072-0.541 0.397-0.469 0.725 0.072 0.331 0.394 0.541 0.725 0.469 1.019-0.216 2.119 0.1 2.866 0.928s0.95 1.956 0.628 2.944v0c-0.103 0.322 0.072 0.666 0.394 0.772 0.322 0.103 0.666-0.072 0.772-0.394v-0.003c0.45-1.381 0.166-2.969-0.884-4.134z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.294 4.875c-0.512-0.569-1.269-0.784-1.963-0.634-0.284 0.059-0.466 0.344-0.406 0.628 0.063 0.284 0.344 0.466 0.625 0.403v0c0.341-0.072 0.709 0.034 0.959 0.309 0.25 0.278 0.319 0.656 0.209 0.987v0c-0.088 0.275 0.063 0.575 0.341 0.666 0.278 0.088 0.575-0.063 0.666-0.341 0.219-0.678 0.081-1.453-0.431-2.019z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.869 10.884c-0.094 0.159-0.297 0.234-0.456 0.169-0.159-0.063-0.206-0.244-0.116-0.397 0.094-0.153 0.291-0.228 0.447-0.169 0.156 0.056 0.213 0.234 0.125 0.397zM6.022 11.966c-0.256 0.409-0.806 0.588-1.219 0.4-0.406-0.184-0.528-0.659-0.272-1.059 0.253-0.397 0.784-0.575 1.194-0.403 0.416 0.178 0.55 0.65 0.297 1.063zM6.984 9.072c-1.259-0.328-2.684 0.3-3.231 1.409-0.559 1.131-0.019 2.391 1.253 2.803 1.319 0.425 2.875-0.228 3.416-1.447 0.534-1.197-0.131-2.425-1.438-2.766z"
    }
  }]
};
exports.sinaWeibo = sinaWeibo;
var rss = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.13 11.733c-1.175 0-2.13 0.958-2.13 2.126 0 1.174 0.955 2.122 2.13 2.122 1.179 0 2.133-0.948 2.133-2.122-0-1.168-0.954-2.126-2.133-2.126zM0.002 5.436v3.067c1.997 0 3.874 0.781 5.288 2.196 1.412 1.411 2.192 3.297 2.192 5.302h3.080c-0-5.825-4.739-10.564-10.56-10.564zM0.006 0v3.068c7.122 0 12.918 5.802 12.918 12.932h3.076c0-8.82-7.176-16-15.994-16z"
    }
  }]
};
exports.rss = rss;
var rss2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.359 12.988c-0.75 0-1.359-0.603-1.359-1.353 0-0.744 0.609-1.356 1.359-1.356 0.753 0 1.359 0.613 1.359 1.356 0 0.75-0.609 1.353-1.359 1.353zM7.772 13c0-1.278-0.497-2.481-1.397-3.381-0.903-0.903-2.1-1.4-3.375-1.4v-1.956c3.713 0 6.738 3.022 6.738 6.737h-1.966zM11.244 13c0-4.547-3.697-8.25-8.241-8.25v-1.956c5.625 0 10.203 4.581 10.203 10.206h-1.963z"
    }
  }]
};
exports.rss2 = rss2;
var youtube = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.841 4.8c0 0-0.156-1.103-0.637-1.587-0.609-0.637-1.291-0.641-1.603-0.678-2.237-0.163-5.597-0.163-5.597-0.163h-0.006c0 0-3.359 0-5.597 0.163-0.313 0.038-0.994 0.041-1.603 0.678-0.481 0.484-0.634 1.587-0.634 1.587s-0.159 1.294-0.159 2.591v1.213c0 1.294 0.159 2.591 0.159 2.591s0.156 1.103 0.634 1.588c0.609 0.637 1.409 0.616 1.766 0.684 1.281 0.122 5.441 0.159 5.441 0.159s3.363-0.006 5.6-0.166c0.313-0.037 0.994-0.041 1.603-0.678 0.481-0.484 0.637-1.588 0.637-1.588s0.159-1.294 0.159-2.591v-1.213c-0.003-1.294-0.162-2.591-0.162-2.591zM6.347 10.075v-4.497l4.322 2.256-4.322 2.241z"
    }
  }]
};
exports.youtube = youtube;
var youtube2 = {
  "viewBox": "0 0 40 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.375 2.647c0.003-0.014 0.005-0.023 0.006-0.028l0.016-0.118-0.74-0.004c-0.668-0.004-0.873 0-0.891 0.017-0.009 0.008-0.24 0.885-0.651 2.473-0.196 0.758-0.361 1.363-0.367 1.345s-0.24-0.883-0.522-1.922c-0.281-1.039-0.517-1.894-0.524-1.901-0.010-0.010-0.906-0.014-1.632-0.008-0.105 0.001-0.164-0.205 0.938 3.299 0.152 0.485 0.381 1.172 0.507 1.526 0.146 0.408 0.25 0.724 0.321 0.987 0.126 0.501 0.13 0.815 0.103 1.182-0.032 0.423-0.036 3.413-0.005 3.463 0.024 0.038 1.425 0.056 1.558 0.020 0.021-0.006 0.035-0.026 0.045-0.139 0.033-0.097 0.036-0.484 0.036-2.090v-2.051l0.090-0.283c0.059-0.185 0.206-0.672 0.328-1.082s0.269-0.9 0.327-1.090c0.529-1.724 1.033-3.419 1.047-3.516l0.011-0.079z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.221 5.135l-0 0.107-0.017 0-0.009 2.953-0.009 2.863-0.229 0.233c-0.257 0.261-0.462 0.361-0.648 0.314-0.203-0.051-0.197 0.028-0.214-3.356l-0.016-3.115h-1.474v0.107h-0.017v3.38c0 3.621-0 3.619 0.184 3.982 0.146 0.29 0.36 0.431 0.725 0.479h0c0.481 0.064 1-0.154 1.481-0.622l0.209-0.203v0.351c0 0.303 0.009 0.353 0.064 0.368 0.090 0.025 1.206 0.027 1.326 0.002l0.1-0.021v-0.104l0.017-0.003v-7.736l-1.472 0.020z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.483 6.661c-0.14-0.599-0.401-1.002-0.832-1.28-0.676-0.437-1.449-0.484-2.165-0.13-0.522 0.258-0.859 0.686-1.032 1.314-0.021 0.075-0.036 0.138-0.047 0.231-0.044 0.222-0.049 0.552-0.061 2.093-0.018 2.374 0.010 2.656 0.307 3.195 0.292 0.529 0.897 0.917 1.556 0.997 0.198 0.024 0.6-0.013 0.832-0.078 0.525-0.146 1.029-0.561 1.252-1.032 0.096-0.204 0.154-0.345 0.189-0.604 0.065-0.353 0.070-0.925 0.070-2.381-0-1.857-0.006-2.060-0.068-2.326zM7.802 11.5c-0.124 0.094-0.34 0.135-0.515 0.098-0.135-0.029-0.318-0.241-0.374-0.434-0.070-0.241-0.075-3.594-0.015-4.251 0.1-0.329 0.378-0.501 0.682-0.419 0.237 0.064 0.358 0.212 0.427 0.523 0.051 0.231 0.057 0.518 0.046 2.207-0.007 1.12-0.011 1.668-0.048 1.962-0.037 0.185-0.099 0.235-0.203 0.315z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M35.944 8.346h0.712l-0.011-0.645c-0.011-0.592-0.020-0.659-0.099-0.82-0.125-0.253-0.309-0.366-0.601-0.366-0.351 0-0.573 0.17-0.678 0.518-0.045 0.148-0.092 1.167-0.058 1.255 0.019 0.049 0.121 0.058 0.735 0.058z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M31.184 6.879c-0.095-0.191-0.272-0.286-0.477-0.278-0.16 0.006-0.337 0.073-0.508 0.203l-0.127 0.097v4.634l0.127 0.097c0.288 0.22 0.604 0.266 0.822 0.12 0.086-0.058 0.142-0.137 0.186-0.263 0.057-0.164 0.062-0.375 0.055-2.325-0.008-2.032-0.012-2.152-0.078-2.285z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M40.014 4.791c-0.142-1.701-0.255-2.253-0.605-2.962-0.465-0.939-1.136-1.434-2.092-1.543-0.739-0.084-3.521-0.203-6.094-0.26-4.456-0.099-11.782 0.092-12.718 0.331-0.432 0.111-0.757 0.299-1.094 0.634-0.591 0.588-0.944 1.432-1.085 2.6-0.323 2.666-0.33 5.886-0.019 8.649 0.134 1.188 0.41 1.96 0.928 2.596 0.323 0.397 0.881 0.734 1.379 0.835 0.35 0.071 2.1 0.169 4.65 0.26 0.38 0.014 1.385 0.037 2.235 0.052 1.77 0.031 5.025 0.013 6.886-0.039 1.252-0.035 3.534-0.128 3.961-0.161 0.12-0.009 0.398-0.027 0.618-0.039 0.739-0.042 1.209-0.196 1.65-0.543 0.571-0.449 1.013-1.278 1.2-2.251 0.177-0.92 0.295-2.559 0.319-4.42 0.020-1.555-0.007-2.393-0.119-3.741zM22.27 4.175l-0.828 0.010-0.036 8.83-0.718 0.009c-0.555 0.008-0.724-0.001-0.737-0.036-0.010-0.025-0.021-2.016-0.026-4.424l-0.009-4.379-1.617-0.020v-1.38l4.779 0.019 0.020 1.36-0.828 0.010zM27.347 9.236v3.797h-1.308v-0.4c0-0.301-0.011-0.4-0.047-0.4-0.026 0-0.144 0.099-0.263 0.22-0.259 0.263-0.565 0.474-0.827 0.572-0.542 0.203-1.056 0.084-1.275-0.293-0.201-0.345-0.204-0.423-0.204-4.005v-3.29h1.307l0.010 3.098c0.010 3.044 0.011 3.1 0.084 3.224 0.097 0.164 0.244 0.209 0.478 0.144 0.138-0.038 0.232-0.105 0.455-0.327l0.282-0.28v-5.859h1.308v3.797zM32.449 12.491c-0.115 0.257-0.372 0.508-0.583 0.57-0.549 0.162-0.99 0.030-1.499-0.449-0.158-0.149-0.305-0.269-0.327-0.269-0.027 0-0.041 0.116-0.041 0.345v0.345h-1.308v-10.248h1.308v1.672c0 0.919 0.012 1.672 0.027 1.672s0.153-0.122 0.307-0.27c0.354-0.341 0.649-0.491 1.024-0.519 0.669-0.051 1.068 0.294 1.25 1.080 0.057 0.245 0.062 0.525 0.062 2.798-0 2.768-0 2.78-0.221 3.273zM37.984 10.971c-0.012 0.285-0.046 0.612-0.077 0.727-0.182 0.674-0.666 1.152-1.366 1.348-0.942 0.264-1.98-0.168-2.394-0.997-0.232-0.465-0.241-0.558-0.241-2.831 0-1.853 0.007-2.081 0.066-2.334 0.168-0.715 0.584-1.178 1.289-1.435 0.204-0.074 0.417-0.113 0.63-0.117 0.761-0.016 1.515 0.393 1.832 1.059 0.213 0.449 0.24 0.642 0.261 1.908l0.019 1.136-2.789 0.019-0.010 0.763c-0.015 1.077 0.058 1.408 0.349 1.603 0.244 0.165 0.62 0.152 0.824-0.027 0.192-0.168 0.246-0.349 0.265-0.877l0.017-0.463h1.347l-0.022 0.518z"
    }
  }]
};
exports.youtube2 = youtube2;
var twitch = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.5 0l-1.5 2.5v11.5h4v2h2l2-2h2.5l4.5-4.5v-9.5h-13.5zM13 8.5l-2.5 2.5h-2.5l-2 2v-2h-3v-9h10v6.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.5 4h1.5v4h-1.5v-4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.5 4h1.5v4h-1.5v-4z"
    }
  }]
};
exports.twitch = twitch;
var vimeo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.994 4.281c-0.072 1.556-1.159 3.691-3.263 6.397-2.175 2.825-4.016 4.241-5.522 4.241-0.931 0-1.722-0.859-2.366-2.581-0.431-1.578-0.859-3.156-1.291-4.734-0.478-1.722-0.991-2.581-1.541-2.581-0.119 0-0.538 0.253-1.256 0.753l-0.753-0.969c0.791-0.694 1.569-1.388 2.334-2.081 1.053-0.909 1.844-1.387 2.372-1.438 1.244-0.119 2.013 0.731 2.3 2.553 0.309 1.966 0.525 3.188 0.647 3.666 0.359 1.631 0.753 2.447 1.184 2.447 0.334 0 0.838-0.528 1.509-1.588 0.669-1.056 1.028-1.862 1.078-2.416 0.097-0.912-0.262-1.372-1.078-1.372-0.384 0-0.778 0.088-1.184 0.263 0.787-2.575 2.287-3.825 4.506-3.753 1.641 0.044 2.416 1.109 2.322 3.194z"
    }
  }]
};
exports.vimeo = vimeo;
var vimeo2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM13.463 5.313c-0.050 1.125-0.838 2.666-2.359 4.622-1.572 2.044-2.903 3.066-3.991 3.066-0.675 0-1.244-0.622-1.709-1.866-0.313-1.141-0.622-2.281-0.934-3.422-0.344-1.244-0.716-1.866-1.112-1.866-0.087 0-0.391 0.181-0.906 0.544l-0.544-0.7c0.572-0.5 1.134-1.003 1.687-1.503 0.763-0.656 1.331-1.003 1.712-1.038 0.9-0.087 1.453 0.528 1.662 1.844 0.225 1.422 0.381 2.303 0.469 2.65 0.259 1.178 0.544 1.766 0.856 1.766 0.241 0 0.606-0.381 1.091-1.147s0.744-1.347 0.778-1.747c0.069-0.659-0.191-0.991-0.778-0.991-0.278 0-0.563 0.063-0.856 0.191 0.569-1.859 1.653-2.766 3.256-2.712 1.188 0.034 1.747 0.803 1.678 2.309z"
    }
  }]
};
exports.vimeo2 = vimeo2;
var lanyrd = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM12.85 12.012l-5.444 1.781c-1.244 0.406-1.369 0.341-1.931-1.4l-1.375-4.259c-0.328-1.009-1.328-3.728-1.497-4.25-0.313-0.969-0.313-1.022 1.516-1.616 1.431-0.469 1.491-0.453 2.009 1.163 0.419 1.3 0.688 2.35 1.119 3.678l1.172 3.625 3.744-1.225c0.738-0.244 0.984-0.231 1.194 0.678l0.15 0.688c0.175 0.797-0.228 1-0.656 1.137z"
    }
  }]
};
exports.lanyrd = lanyrd;
var flickr = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5zM9 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
    }
  }]
};
exports.flickr = flickr;
var flickr2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 6.5c-1.103 0-2 0.897-2 2s0.897 2 2 2c1.103 0 2-0.897 2-2s-0.897-2-2-2zM12.5 5v0c1.933 0 3.5 1.567 3.5 3.5s-1.567 3.5-3.5 3.5-3.5-1.567-3.5-3.5c0-1.933 1.567-3.5 3.5-3.5zM0 8.5c0-1.933 1.567-3.5 3.5-3.5s3.5 1.567 3.5 3.5c0 1.933-1.567 3.5-3.5 3.5s-3.5-1.567-3.5-3.5z"
    }
  }]
};
exports.flickr2 = flickr2;
var flickr3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5z"
    }
  }]
};
exports.flickr3 = flickr3;
var flickr4 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.606-8 8.055s3.582 8.055 8 8.055 8-3.606 8-8.055-3.582-8.055-8-8.055zM4.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5zM11.5 10.5c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5c0 1.381-1.119 2.5-2.5 2.5z"
    }
  }]
};
exports.flickr4 = flickr4;
var dribbble = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 16c-4.412 0-8-3.588-8-8s3.587-8 8-8c4.412 0 8 3.587 8 8s-3.588 8-8 8v0zM14.747 9.094c-0.234-0.075-2.116-0.634-4.256-0.291 0.894 2.456 1.256 4.456 1.328 4.872 1.531-1.037 2.625-2.678 2.928-4.581v0zM10.669 14.3c-0.103-0.6-0.497-2.688-1.456-5.181-0.016 0.006-0.031 0.009-0.044 0.016-3.856 1.344-5.241 4.016-5.362 4.266 1.159 0.903 2.616 1.444 4.194 1.444 0.947 0 1.85-0.194 2.669-0.544v0zM2.922 12.578c0.156-0.266 2.031-3.369 5.553-4.509 0.088-0.028 0.178-0.056 0.269-0.081-0.172-0.388-0.359-0.778-0.553-1.159-3.409 1.022-6.722 0.978-7.022 0.975-0.003 0.069-0.003 0.138-0.003 0.209 0 1.753 0.666 3.356 1.756 4.566v0zM1.313 6.609c0.306 0.003 3.122 0.016 6.319-0.831-1.131-2.013-2.353-3.706-2.534-3.953-1.913 0.903-3.344 2.666-3.784 4.784v0zM6.4 1.366c0.188 0.253 1.431 1.944 2.55 4 2.431-0.909 3.459-2.294 3.581-2.469-1.206-1.072-2.794-1.722-4.531-1.722-0.55 0.003-1.088 0.069-1.6 0.191v0zM13.291 3.691c-0.144 0.194-1.291 1.663-3.816 2.694 0.159 0.325 0.313 0.656 0.453 0.991 0.050 0.119 0.1 0.234 0.147 0.353 2.275-0.284 4.534 0.172 4.759 0.219-0.016-1.612-0.594-3.094-1.544-4.256v0z"
    }
  }]
};
exports.dribbble = dribbble;
var behance = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.641 3.206c0.472 0 0.897 0.041 1.284 0.125 0.388 0.081 0.716 0.219 0.994 0.406 0.275 0.188 0.487 0.438 0.644 0.75 0.15 0.309 0.225 0.697 0.225 1.156 0 0.497-0.112 0.909-0.338 1.241-0.228 0.331-0.559 0.6-1.003 0.813 0.606 0.175 1.053 0.481 1.353 0.916 0.3 0.438 0.444 0.963 0.444 1.581 0 0.5-0.097 0.928-0.287 1.291-0.194 0.366-0.456 0.662-0.778 0.891-0.325 0.231-0.7 0.4-1.119 0.509-0.416 0.109-0.844 0.166-1.287 0.166h-4.772v-9.844h4.641zM4.359 7.181c0.384 0 0.703-0.091 0.953-0.275 0.25-0.181 0.369-0.481 0.369-0.894 0-0.228-0.041-0.419-0.122-0.566-0.084-0.147-0.194-0.263-0.334-0.344-0.138-0.084-0.294-0.141-0.478-0.172-0.178-0.034-0.366-0.050-0.556-0.050h-2.025v2.3h2.194zM4.478 11.372c0.213 0 0.416-0.019 0.606-0.063 0.194-0.044 0.366-0.109 0.509-0.209 0.144-0.097 0.266-0.225 0.353-0.394 0.088-0.166 0.128-0.378 0.128-0.637 0-0.506-0.144-0.869-0.428-1.088-0.284-0.216-0.662-0.322-1.131-0.322h-2.35v2.709h2.313z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.331 11.338c0.294 0.287 0.716 0.431 1.266 0.431 0.394 0 0.738-0.1 1.022-0.3s0.456-0.412 0.522-0.631h1.725c-0.278 0.859-0.697 1.469-1.272 1.838-0.566 0.369-1.259 0.556-2.063 0.556-0.563 0-1.066-0.091-1.519-0.269-0.453-0.181-0.831-0.434-1.15-0.766-0.309-0.331-0.553-0.725-0.725-1.188-0.169-0.459-0.256-0.969-0.256-1.519 0-0.534 0.088-1.031 0.262-1.491 0.178-0.463 0.422-0.859 0.747-1.194s0.706-0.6 1.156-0.794c0.447-0.194 0.941-0.291 1.488-0.291 0.603 0 1.131 0.116 1.584 0.353 0.45 0.234 0.822 0.55 1.113 0.944s0.497 0.847 0.625 1.353c0.128 0.506 0.172 1.034 0.137 1.588h-5.147c0 0.559 0.188 1.094 0.484 1.378zM13.578 7.594c-0.231-0.256-0.628-0.397-1.106-0.397-0.313 0-0.572 0.053-0.778 0.159-0.203 0.106-0.369 0.237-0.497 0.394-0.125 0.156-0.213 0.325-0.262 0.503-0.050 0.172-0.081 0.331-0.091 0.469h3.188c-0.047-0.5-0.219-0.869-0.453-1.128z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.444 4h3.991v0.972h-3.991v-0.972z"
    }
  }]
};
exports.behance = behance;
var behance2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.316 7.009c0.203-0.147 0.3-0.391 0.3-0.728 0-0.188-0.031-0.341-0.097-0.459-0.069-0.119-0.156-0.213-0.272-0.278-0.112-0.069-0.241-0.116-0.388-0.141-0.144-0.028-0.297-0.041-0.453-0.041h-1.647v1.869h1.781c0.313 0.003 0.572-0.072 0.775-0.222z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.594 8.697c-0.231-0.175-0.537-0.262-0.919-0.262h-1.916v2.203h1.878c0.175 0 0.338-0.016 0.494-0.050s0.297-0.088 0.416-0.169c0.119-0.078 0.216-0.184 0.287-0.319s0.106-0.309 0.106-0.519c0-0.412-0.116-0.706-0.347-0.884z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM10.488 4.209h3.241v0.791h-3.241v-0.791zM8.463 10.725c-0.156 0.297-0.369 0.537-0.631 0.725-0.266 0.188-0.569 0.325-0.909 0.416-0.338 0.091-0.688 0.134-1.044 0.134h-3.878v-7.997h3.769c0.381 0 0.728 0.034 1.044 0.1 0.313 0.066 0.581 0.178 0.806 0.331 0.222 0.153 0.397 0.356 0.522 0.609 0.122 0.25 0.184 0.566 0.184 0.938 0 0.403-0.091 0.737-0.275 1.006s-0.453 0.487-0.816 0.659c0.494 0.141 0.856 0.391 1.097 0.744 0.244 0.356 0.363 0.784 0.363 1.284 0.003 0.409-0.075 0.759-0.231 1.050zM14.991 9.488h-4.178c0 0.456 0.156 0.891 0.394 1.125 0.238 0.231 0.581 0.35 1.028 0.35 0.322 0 0.597-0.081 0.831-0.244 0.231-0.162 0.372-0.334 0.425-0.512h1.4c-0.225 0.697-0.566 1.194-1.031 1.494-0.459 0.3-1.022 0.45-1.675 0.45-0.456 0-0.866-0.075-1.234-0.219-0.369-0.147-0.675-0.353-0.934-0.622-0.253-0.269-0.447-0.591-0.588-0.966-0.137-0.372-0.209-0.787-0.209-1.234 0-0.434 0.072-0.838 0.213-1.213 0.144-0.375 0.344-0.7 0.606-0.969 0.262-0.272 0.575-0.487 0.938-0.647 0.363-0.156 0.762-0.234 1.206-0.234 0.491 0 0.919 0.094 1.287 0.287 0.366 0.191 0.666 0.447 0.903 0.769s0.403 0.688 0.509 1.1c0.103 0.406 0.137 0.834 0.109 1.284z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.134 7.247c-0.253 0-0.466 0.044-0.631 0.131s-0.3 0.194-0.403 0.319c-0.103 0.128-0.172 0.263-0.213 0.409-0.041 0.141-0.066 0.269-0.072 0.381h2.588c-0.037-0.406-0.178-0.706-0.366-0.916-0.194-0.213-0.512-0.325-0.903-0.325z"
    }
  }]
};
exports.behance2 = behance2;
var deviantart = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.953 2.909v-2.909h-2.909l-0.291 0.294-1.375 2.616-0.431 0.291h-4.9v3.994h2.694l0.241 0.291-2.934 5.606v2.909h2.909l0.291-0.294 1.375-2.616 0.431-0.291h4.9v-3.994h-2.694l-0.241-0.294z"
    }
  }]
};
exports.deviantart = deviantart;
var fiveHundredPX = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M3.953 10.512c0.003 0.009 0.088 0.238 0.134 0.353 0.263 0.622 0.641 1.184 1.122 1.666s1.041 0.859 1.666 1.122c0.647 0.272 1.331 0.412 2.037 0.412s1.394-0.137 2.037-0.412c0.625-0.262 1.184-0.641 1.666-1.122s0.859-1.041 1.122-1.666c0.272-0.647 0.412-1.331 0.412-2.037s-0.137-1.394-0.412-2.037c-0.262-0.625-0.641-1.184-1.122-1.666s-1.041-0.859-1.666-1.122c-0.647-0.272-1.331-0.413-2.037-0.413-0.716 0-1.431 0.144-2.066 0.413-0.509 0.216-1.372 0.769-1.875 1.291l-0.003 0.003v-4.313h7.241c0.262-0.003 0.262-0.372 0.262-0.491 0-0.122 0-0.487-0.266-0.491h-7.828c-0.213 0-0.344 0.178-0.344 0.341v6.066c0 0.197 0.244 0.338 0.472 0.384 0.444 0.094 0.544-0.047 0.653-0.197l0.016-0.019c0.166-0.247 0.681-0.766 0.688-0.772 0.806-0.806 1.884-1.25 3.037-1.25 1.147 0 2.222 0.444 3.028 1.25 0.809 0.809 1.256 1.881 1.256 3.019 0 1.141-0.444 2.216-1.25 3.019-0.794 0.794-1.906 1.25-3.047 1.25-0.772 0-1.519-0.206-2.159-0.597l0.003-3.688c0-0.491 0.213-1.028 0.572-1.431 0.409-0.463 0.972-0.716 1.588-0.716 0.594 0 1.15 0.225 1.566 0.634 0.409 0.406 0.637 0.95 0.637 1.528 0 1.231-0.969 2.197-2.206 2.197-0.238 0-0.672-0.106-0.691-0.109-0.25-0.075-0.356 0.272-0.391 0.387-0.134 0.441 0.069 0.528 0.109 0.541 0.397 0.125 0.659 0.147 1.003 0.147 1.747 0 3.169-1.422 3.169-3.169 0-1.734-1.422-3.144-3.166-3.144-0.856 0-1.659 0.328-2.263 0.919-0.575 0.566-0.903 1.319-0.903 2.069v0.019c-0.003 0.094-0.003 2.306-0.006 3.031l-0.003-0.003c-0.328-0.363-0.653-0.919-0.869-1.488-0.084-0.222-0.275-0.184-0.534-0.103-0.125 0.034-0.469 0.141-0.391 0.394v0zM7.675 9.647c0 0.106 0.097 0.2 0.156 0.253l0.019 0.019c0.1 0.097 0.194 0.147 0.281 0.147 0.072 0 0.116-0.034 0.131-0.050 0.044-0.041 0.537-0.544 0.588-0.591l0.553 0.55c0.050 0.056 0.106 0.088 0.172 0.088 0.088 0 0.184-0.053 0.284-0.156 0.238-0.244 0.119-0.375 0.063-0.438l-0.559-0.559 0.584-0.588c0.128-0.137 0.016-0.284-0.097-0.397-0.162-0.162-0.322-0.206-0.422-0.112l-0.581 0.581-0.588-0.588c-0.031-0.031-0.072-0.047-0.113-0.047-0.078 0-0.172 0.053-0.275 0.156-0.181 0.181-0.219 0.306-0.125 0.406l0.588 0.584-0.584 0.584c-0.053 0.050-0.078 0.103-0.075 0.156zM8.953 1.716c-0.938 0-1.938 0.191-2.669 0.506-0.078 0.031-0.125 0.094-0.134 0.181-0.009 0.084 0.013 0.194 0.069 0.337 0.047 0.116 0.166 0.425 0.4 0.334 0.75-0.288 1.581-0.444 2.334-0.444 0.856 0 1.688 0.169 2.469 0.497 0.622 0.263 1.206 0.644 1.844 1.194 0.047 0.041 0.097 0.059 0.147 0.059 0.125 0 0.244-0.122 0.347-0.237 0.169-0.191 0.287-0.35 0.119-0.509-0.609-0.575-1.275-1.006-2.1-1.356-0.894-0.372-1.847-0.563-2.825-0.563zM14.006 13.3v0c-0.113-0.113-0.209-0.178-0.294-0.203s-0.162-0.006-0.222 0.053l-0.056 0.056c-0.581 0.581-1.259 1.037-2.012 1.356-0.781 0.331-1.609 0.497-2.463 0.497-0.856 0-1.684-0.169-2.463-0.497-0.753-0.319-1.431-0.775-2.013-1.356-0.606-0.606-1.063-1.284-1.356-2.012-0.288-0.713-0.381-1.247-0.413-1.422-0.003-0.016-0.006-0.028-0.006-0.037-0.041-0.206-0.231-0.222-0.503-0.178-0.112 0.019-0.459 0.072-0.428 0.319v0.006c0.091 0.578 0.253 1.144 0.481 1.681 0.366 0.866 0.891 1.644 1.559 2.313s1.447 1.191 2.313 1.559c0.897 0.378 1.85 0.572 2.831 0.572s1.934-0.194 2.831-0.572c0.866-0.366 1.644-0.891 2.313-1.559 0 0 0.037-0.037 0.059-0.059 0.069-0.084 0.134-0.225-0.159-0.516z"
    }
  }]
};
exports.fiveHundredPX = fiveHundredPX;
var steam = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5zM14.975 2.025c-1.367-1.367-3.583-1.367-4.95 0-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.43 0.022-0.856 0.132-1.249 0.328l-2.467-1.928c-0.571-0.446-1.396-0.345-1.842 0.226s-0.345 1.396 0.226 1.842l2.436 1.905c-0.265 1.043 0.010 2.196 0.827 3.012 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.891-3.484c0.723-0.104 1.419-0.434 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95zM6 14.105c-1.162 0-2.105-0.942-2.105-2.105 0-0.011 0.001-0.022 0.001-0.033l1.046 0.817c0.24 0.188 0.525 0.278 0.807 0.278 0.39 0 0.776-0.173 1.035-0.504 0.446-0.571 0.345-1.396-0.226-1.842l-0.992-0.776c0.14-0.029 0.285-0.045 0.434-0.045 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105zM12.5 7c-1.381 0-2.5-1.119-2.5-2.5s1.119-2.5 2.5-2.5 2.5 1.119 2.5 2.5-1.119 2.5-2.5 2.5z"
    }
  }]
};
exports.steam = steam;
var steam2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.749 13.063c0.424 0 0.84-0.205 1.093-0.585 0.402-0.603 0.239-1.418-0.364-1.82l-1.032-0.688c0.177-0.048 0.362-0.074 0.554-0.074 1.162 0 2.105 0.942 2.105 2.105s-0.942 2.105-2.105 2.105c-1.131 0-2.054-0.893-2.102-2.012l1.124 0.749c0.224 0.149 0.477 0.221 0.727 0.221zM13.333 0c1.467 0 2.667 1.2 2.667 2.667v10.666c0 1.468-1.2 2.667-2.667 2.667h-10.666c-1.467 0-2.667-1.199-2.667-2.667v-3.172l1.896 1.264c-0.182 0.987 0.108 2.044 0.872 2.808 1.233 1.233 3.232 1.233 4.465 0 0.757-0.757 1.049-1.804 0.876-2.784l3.892-3.484c0.723-0.104 1.419-0.433 1.975-0.989 1.367-1.367 1.367-3.583 0-4.95s-3.583-1.367-4.95 0c-0.556 0.556-0.886 1.252-0.989 1.975v0l-3.198 4.847c-0.498 0.025-0.99 0.168-1.433 0.428l-3.404-2.269v-4.339c0-1.467 1.2-2.667 2.667-2.667h10.666zM14 4.5c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5 1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5zM10 4.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5z"
    }
  }]
};
exports.steam2 = steam2;
var dropbox = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.5 0.5l-3.5 3 4.5 3 3.5-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 3.5l-3.5-3-4.5 3 3.5 3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 6.5l3.5 3-4.5 2.5-3.5-3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 9l-4.5-2.5-3.5 3 4.5 2.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.377 13.212l-3.377-2.895-3.377 2.895-2.123-1.179v1.467l5.5 2.5 5.5-2.5v-1.467z"
    }
  }]
};
exports.dropbox = dropbox;
var onedrive = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.482 12.944c-0.942-0.235-1.466-0.984-1.468-2.095-0-0.355 0.025-0.525 0.114-0.754 0.217-0.56 0.793-0.982 1.55-1.138 0.377-0.077 0.493-0.16 0.493-0.353 0-0.060 0.045-0.24 0.1-0.399 0.249-0.724 0.71-1.327 1.202-1.573 0.515-0.258 0.776-0.316 1.399-0.313 0.886 0.005 1.327 0.197 1.945 0.846l0.34 0.357 0.304-0.105c1.473-0.51 2.942 0.358 3.061 1.809l0.032 0.397 0.29 0.104c0.829 0.297 1.218 0.92 1.148 1.837-0.046 0.599-0.326 1.078-0.77 1.315l-0.209 0.112-4.638 0.009c-3.564 0.007-4.697-0.006-4.893-0.055v0zM1.613 12.281c-0.565-0.142-1.164-0.67-1.445-1.273-0.159-0.342-0.168-0.393-0.168-0.998 0-0.576 0.014-0.668 0.14-0.954 0.267-0.603 0.78-1.038 1.422-1.21 0.136-0.036 0.263-0.094 0.283-0.128s0.043-0.221 0.050-0.415c0.045-1.206 0.794-2.269 1.839-2.61 0.565-0.184 1.306-0.202 1.92 0.058 0.195 0.082 0.173 0.1 0.585-0.471 0.244-0.338 0.705-0.695 1.108-0.909 0.435-0.231 0.887-0.337 1.428-0.336 1.512 0.004 2.815 1.003 3.297 2.529 0.154 0.487 0.146 0.624-0.035 0.628-0.079 0.002-0.306 0.048-0.505 0.102l-0.361 0.099-0.329-0.348c-0.928-0.98-2.441-1.192-3.728-0.522-0.514 0.268-0.927 0.652-1.239 1.153-0.222 0.357-0.506 1.024-0.506 1.189 0 0.117-0.090 0.176-0.474 0.309-1.189 0.412-1.883 1.364-1.882 2.582 0 0.443 0.108 0.986 0.258 1.296 0.057 0.117 0.088 0.228 0.070 0.247-0.046 0.049-1.525 0.032-1.73-0.019v0z"
    }
  }]
};
exports.onedrive = onedrive;
var github = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0.198c-4.418 0-8 3.582-8 8 0 3.535 2.292 6.533 5.471 7.591 0.4 0.074 0.547-0.174 0.547-0.385 0-0.191-0.008-0.821-0.011-1.489-2.226 0.484-2.695-0.944-2.695-0.944-0.364-0.925-0.888-1.171-0.888-1.171-0.726-0.497 0.055-0.486 0.055-0.486 0.803 0.056 1.226 0.824 1.226 0.824 0.714 1.223 1.872 0.869 2.328 0.665 0.072-0.517 0.279-0.87 0.508-1.070-1.777-0.202-3.645-0.888-3.645-3.954 0-0.873 0.313-1.587 0.824-2.147-0.083-0.202-0.357-1.015 0.077-2.117 0 0 0.672-0.215 2.201 0.82 0.638-0.177 1.322-0.266 2.002-0.269 0.68 0.003 1.365 0.092 2.004 0.269 1.527-1.035 2.198-0.82 2.198-0.82 0.435 1.102 0.162 1.916 0.079 2.117 0.513 0.56 0.823 1.274 0.823 2.147 0 3.073-1.872 3.749-3.653 3.947 0.287 0.248 0.543 0.735 0.543 1.481 0 1.070-0.009 1.932-0.009 2.195 0 0.213 0.144 0.462 0.55 0.384 3.177-1.059 5.466-4.057 5.466-7.59 0-4.418-3.582-8-8-8z"
    }
  }]
};
exports.github = github;
var npm = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0v16h16v-16h-16zM13 13h-2v-8h-3v8h-5v-10h10v10z"
    }
  }]
};
exports.npm = npm;
var basecamp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1.666c-2.919 0-5.169 2.444-6.444 4.838-0.719 1.347-1.222 2.822-1.453 4.331-0.025 0.172-0.050 0.344-0.069 0.519-0.009 0.094-0.019 0.188-0.025 0.281-0.009 0.119-0.003 0.156 0.059 0.256 0.187 0.303 0.409 0.584 0.659 0.838 0.512 0.525 1.134 0.928 1.794 1.241 1.503 0.709 3.2 0.966 4.85 1.022 1.703 0.056 3.453-0.084 5.081-0.616 1.391-0.453 2.731-1.244 3.503-2.522 0.084-0.137 0.025-0.341 0.009-0.5-0.019-0.191-0.044-0.378-0.075-0.566-0.056-0.369-0.131-0.731-0.222-1.094-0.181-0.738-0.428-1.463-0.728-2.159-1.088-2.525-3.1-5.219-5.963-5.775-0.322-0.063-0.65-0.094-0.978-0.094zM8.1 13.909c-1.784 0-3.728-0.159-5.334-1.019-0.625-0.334-1.262-0.819-1.563-1.484-0.087-0.194-0.056-0.269-0.016-0.497 0.028-0.147 0.041-0.291 0.106-0.428 0.091-0.191 0.184-0.378 0.281-0.566 0.328-0.634 0.681-1.262 1.091-1.853 0.203-0.291 0.419-0.578 0.669-0.828 0.175-0.175 0.388-0.362 0.634-0.422 0.756-0.181 1.334 0.694 1.794 1.134 0.222 0.213 0.519 0.453 0.85 0.412 0.228-0.028 0.431-0.206 0.594-0.353 0.553-0.497 0.997-1.112 1.456-1.691 0.228-0.284 0.453-0.572 0.7-0.844 0.166-0.184 0.347-0.394 0.569-0.513 0.397-0.216 0.903 0.228 1.178 0.456 0.469 0.391 0.884 0.847 1.281 1.309 0.378 0.441 0.744 0.888 1.066 1.372 0.497 0.75 0.928 1.55 1.322 2.359 0.084 0.175 0.113 0.294 0.144 0.488 0.019 0.106 0.059 0.228 0.044 0.338-0.022 0.153-0.128 0.319-0.206 0.444-0.188 0.297-0.441 0.553-0.719 0.769-1.166 0.903-2.744 1.203-4.178 1.338-0.588 0.056-1.175 0.078-1.762 0.078z"
    }
  }]
};
exports.basecamp = basecamp;
var trello = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM7 12c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-8c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v8zM13 9c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v-5c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v5z"
    }
  }]
};
exports.trello = trello;
var wordpress = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2 8c0 2.313 1.38 4.312 3.382 5.259l-2.862-7.637c-0.333 0.727-0.52 1.531-0.52 2.378zM12.050 7.705c0-0.722-0.266-1.222-0.495-1.612-0.304-0.482-0.589-0.889-0.589-1.371 0-0.537 0.418-1.037 1.008-1.037 0.027 0 0.052 0.003 0.078 0.005-1.067-0.953-2.49-1.534-4.052-1.534-2.096 0-3.94 1.048-5.013 2.634 0.141 0.004 0.274 0.007 0.386 0.007 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.361 0.444 0.038 0.482 0 0-0.325 0.037-0.687 0.055l2.185 6.33 1.313-3.835-0.935-2.495c-0.323-0.019-0.629-0.055-0.629-0.055-0.323-0.019-0.285-0.5 0.038-0.482 0 0 0.991 0.074 1.58 0.074 0.627 0 1.599-0.074 1.599-0.074 0.323-0.018 0.362 0.444 0.038 0.482 0 0-0.326 0.037-0.687 0.055l2.168 6.282 0.599-1.947c0.259-0.809 0.457-1.389 0.457-1.889zM8.105 8.511l-1.8 5.095c0.538 0.154 1.106 0.238 1.695 0.238 0.699 0 1.369-0.117 1.992-0.331-0.016-0.025-0.031-0.052-0.043-0.081l-1.844-4.921zM13.265 5.196c0.026 0.186 0.040 0.386 0.040 0.601 0 0.593-0.114 1.259-0.456 2.093l-1.833 5.16c1.784-1.013 2.983-2.895 2.983-5.051 0-1.016-0.267-1.971-0.735-2.803zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM8 15c-3.866 0-7-3.134-7-7s3.134-7 7-7 7 3.134 7 7-3.134 7-7 7z"
    }
  }]
};
exports.wordpress = wordpress;
var joomla = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.156 4.323c0.513-0.513 1.344-0.513 1.856-0l0.122 0.123 1.58-1.581-0.123-0.123c-0.9-0.902-2.164-1.217-3.319-0.946-0.166-1.018-1.048-1.796-2.112-1.796-1.182 0-2.14 0.96-2.14 2.143 0 1.021 0.712 1.875 1.667 2.091-0.362 1.21-0.066 2.576 0.888 3.531l3.56 3.561 1.578-1.581-3.56-3.561c-0.511-0.511-0.512-1.346 0.003-1.861zM15.98 2.143c0-1.184-0.958-2.143-2.14-2.143-1.082 0-1.976 0.804-2.12 1.847-1.204-0.354-2.559-0.055-3.51 0.897l-3.56 3.561 1.58 1.581 3.559-3.56c0.515-0.515 1.344-0.514 1.854-0.003 0.512 0.513 0.512 1.346-0.001 1.859l-0.122 0.122 1.578 1.582 0.123-0.124c0.945-0.946 1.245-2.293 0.9-3.494 1.049-0.138 1.858-1.037 1.858-2.125zM14.16 11.735c0.283-1.163-0.031-2.443-0.939-3.352l-3.555-3.562-1.58 1.58 3.555 3.563c0.515 0.516 0.514 1.345 0.003 1.857-0.513 0.513-1.344 0.513-1.857-0l-0.121-0.122-1.578 1.582 0.121 0.121c0.961 0.962 2.338 1.257 3.553 0.883 0.197 0.979 1.061 1.716 2.098 1.716 1.181 0 2.14-0.959 2.14-2.143 0-1.081-0.8-1.976-1.84-2.122zM9.568 8.261l-3.555 3.562c-0.511 0.512-1.344 0.513-1.859-0.002-0.513-0.514-0.513-1.345-0.001-1.859l0.122-0.121-1.579-1.58-0.121 0.12c-0.918 0.919-1.228 2.216-0.929 3.39-0.944 0.223-1.646 1.072-1.646 2.086-0 1.184 0.958 2.143 2.14 2.143 1.017-0.001 1.869-0.71 2.087-1.662 1.167 0.29 2.453-0.020 3.365-0.934l3.555-3.562-1.578-1.582z"
    }
  }]
};
exports.joomla = joomla;
var ello = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zM12.885 9.212c-0.575 2.23-2.584 3.788-4.885 3.788s-4.31-1.558-4.885-3.788c-0.097-0.377 0.131-0.764 0.508-0.861 0.058-0.015 0.118-0.023 0.177-0.023 0.322 0 0.604 0.218 0.684 0.531 0.414 1.605 1.86 2.727 3.516 2.727s3.102-1.121 3.516-2.727c0.081-0.313 0.362-0.531 0.684-0.531 0.060 0 0.12 0.008 0.178 0.023 0.183 0.047 0.336 0.163 0.432 0.326s0.123 0.353 0.075 0.536z"
    }
  }]
};
exports.ello = ello;
var blogger = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.966 6h-0.897c-0.549 0-1.031-0.465-1.069-1v0c0-2.854-2.301-5-5.175-5h-2.622c-2.872 0-5.201 2.313-5.203 5.167v5.669c0 2.854 2.331 5.165 5.203 5.165h5.6c2.874 0 5.197-2.311 5.197-5.165v-3.662c0-0.57-0.46-1.173-1.034-1.173zM5 4h3c0.55 0 1 0.45 1 1s-0.45 1-1 1h-3c-0.55 0-1-0.45-1-1s0.45-1 1-1zM11 12h-6c-0.55 0-1-0.45-1-1s0.45-1 1-1h6c0.55 0 1 0.45 1 1s-0.45 1-1 1z"
    }
  }]
};
exports.blogger = blogger;
var blogger2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM14 10.125c0 2.141-1.741 3.875-3.897 3.875h-4.2c-2.156 0-3.903-1.734-3.903-3.875v-4.25c0-2.141 1.747-3.875 3.903-3.875h1.966c2.156 0 3.881 1.609 3.881 3.75 0.028 0.4 0.391 0.75 0.8 0.75h0.672c0.431 0 0.775 0.453 0.775 0.881v2.744z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11 10c0 0.55-0.45 1-1 1h-4c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h4c0.55 0 1 0.45 1 1v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9 6c0 0.55-0.45 1-1 1h-2c-0.55 0-1-0.45-1-1v0c0-0.55 0.45-1 1-1h2c0.55 0 1 0.45 1 1v0z"
    }
  }]
};
exports.blogger2 = blogger2;
var tumblr = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.001 7l-0 3.659c0 0.928-0.012 1.463 0.086 1.727 0.098 0.262 0.342 0.534 0.609 0.691 0.354 0.212 0.758 0.318 1.214 0.318 0.81 0 1.289-0.107 2.090-0.633v2.405c-0.683 0.321-1.279 0.509-1.833 0.639-0.555 0.129-1.154 0.194-1.798 0.194-0.732 0-1.163-0.092-1.725-0.276-0.562-0.185-1.042-0.45-1.438-0.79-0.398-0.343-0.672-0.706-0.826-1.091s-0.23-0.944-0.23-1.676v-5.611h-2.147v-2.266c0.628-0.204 1.331-0.497 1.778-0.877 0.449-0.382 0.809-0.839 1.080-1.374 0.272-0.534 0.459-1.214 0.561-2.039h2.579l-0 4h3.999v3h-3.999z"
    }
  }]
};
exports.tumblr = tumblr;
var tumblr2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.434 12.884c-0.472 0.222-0.9 0.378-1.281 0.469-0.381 0.088-0.797 0.134-1.241 0.134-0.506 0-0.803-0.063-1.191-0.191s-0.719-0.309-0.994-0.544c-0.275-0.238-0.463-0.488-0.569-0.753s-0.159-0.65-0.159-1.156v-3.872h-1.5v-1.563c0.434-0.141 0.938-0.344 1.244-0.606 0.309-0.263 0.559-0.578 0.744-0.947 0.188-0.369 0.316-0.837 0.388-1.406h1.569v2.55h2.556v1.972h-2.553v2.831c0 0.641-0.009 1.009 0.059 1.191s0.238 0.369 0.422 0.475c0.244 0.147 0.525 0.219 0.838 0.219 0.559 0 1.116-0.181 1.669-0.544v1.741z"
    }
  }]
};
exports.tumblr2 = tumblr2;
var yahoo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.878 9.203v0c1.759-3.088 4.666-8.125 5.463-9.203-0.35 0.234-0.887 0.353-1.381 0.466l-0.747-0.466c-0.6 1.119-2.813 4.734-4.222 7.050-1.428-2.366-3.119-5.097-4.222-7.050-0.875 0.188-1.237 0.197-2.109 0v0 0c0 0 0 0 0 0v0c1.731 2.606 4.503 7.572 5.447 9.203v0l-0.128 6.797 1.013-0.466v-0.012l1.012 0.478-0.125-6.797z"
    }
  }]
};
exports.yahoo = yahoo;
var yahoo2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.019 1.087c-2.828 0-5.5-0.372-8.019-1.087 0 5.653 0 14.581 0 16 2.522-0.716 5.194-1.088 8.019-1.088 2.794 0 5.459 0.363 7.981 1.088 0-5.444 0-10.153 0-16-2.522 0.725-5.184 1.087-7.981 1.087zM12.45 2.453l-0.097 0.153c-0.091 0.144-0.172 0.266-0.284 0.438-0.15 0.225-0.431 0.672-0.769 1.247-0.094 0.159-0.209 0.35-0.328 0.556-0.228 0.384-0.484 0.819-0.688 1.162-0.084 0.147-0.169 0.297-0.256 0.447-0.225 0.391-0.456 0.794-0.678 1.181-0.228 0.403-0.453 0.8-0.678 1.194v0.397c0 0.55 0.012 1.15 0.031 1.684 0.009 0.244 0.019 0.678 0.031 1.137 0.012 0.547 0.025 1.113 0.041 1.4l0.003 0.088v0.009l-0.094-0.025c-0.037-0.009-0.072-0.019-0.109-0.028-0.113-0.025-0.234-0.044-0.353-0.056-0.072-0.006-0.147-0.009-0.222-0.009 0 0 0 0 0 0s0 0 0 0c-0.075 0-0.15 0.003-0.222 0.009-0.119 0.012-0.241 0.031-0.353 0.056-0.037 0.009-0.075 0.019-0.109 0.028l-0.094 0.025v-0.009l0.003-0.088c0.013-0.284 0.028-0.853 0.041-1.4 0.009-0.459 0.022-0.894 0.031-1.137 0.022-0.537 0.031-1.134 0.031-1.684v-0.397c-0.225-0.397-0.45-0.791-0.678-1.194-0.222-0.391-0.453-0.791-0.675-1.181-0.088-0.15-0.172-0.3-0.256-0.447-0.2-0.347-0.459-0.781-0.688-1.162-0.122-0.203-0.237-0.397-0.328-0.556-0.338-0.575-0.619-1.019-0.769-1.247-0.112-0.172-0.194-0.294-0.284-0.438l-0.097-0.153 0.175 0.050c0.222 0.063 0.45 0.094 0.694 0.094s0.478-0.031 0.697-0.094l0.053-0.016 0.028 0.047c0.431 0.778 1.591 2.684 2.284 3.825 0.237 0.394 0.428 0.703 0.522 0.862 0 0 0 0 0-0.003 0 0 0 0 0 0.003 0.094-0.156 0.284-0.469 0.522-0.862 0.694-1.138 1.853-3.044 2.284-3.825l0.028-0.047 0.053 0.016c0.219 0.063 0.453 0.094 0.697 0.094s0.472-0.031 0.694-0.094l0.166-0.050z"
    }
  }]
};
exports.yahoo2 = yahoo2;
var tux = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.87 11.514c-1.28 0.596-2.471 0.589-3.271 0.532-0.954-0.069-1.721-0.33-2.058-0.558-0.208-0.141-0.49-0.086-0.631 0.122s-0.086 0.49 0.122 0.631c0.542 0.367 1.501 0.64 2.503 0.712 0.17 0.012 0.356 0.020 0.557 0.020 0.872 0 1.979-0.083 3.163-0.634 0.228-0.106 0.326-0.376 0.22-0.604s-0.376-0.326-0.604-0.22zM13.921 10.841c0.044-3.948 0.449-11.409-7.109-10.806-7.463 0.601-5.484 8.484-5.595 11.124-0.099 1.397-0.562 3.104-1.217 4.841h2.017c0.207-0.736 0.36-1.464 0.425-2.159 0.122 0.085 0.252 0.167 0.391 0.245 0.226 0.133 0.42 0.31 0.626 0.497 0.48 0.438 1.025 0.934 2.089 0.996 0.071 0.004 0.143 0.006 0.214 0.006 1.077 0 1.813-0.471 2.404-0.85 0.283-0.181 0.528-0.338 0.759-0.413 0.655-0.205 1.227-0.536 1.655-0.957 0.067-0.066 0.129-0.133 0.187-0.202 0.238 0.873 0.564 1.856 0.926 2.836h4.307c-1.034-1.597-2.101-3.162-2.079-5.159zM1.939 8.693c0-0 0-0-0-0.001-0.074-1.288 0.542-2.372 1.377-2.421s1.571 0.957 1.645 2.245c0 0 0 0 0 0.001 0.004 0.069 0.006 0.138 0.006 0.206-0.264 0.066-0.503 0.163-0.717 0.275-0.001-0.010-0.001-0.019-0.002-0.029 0-0 0-0 0-0-0.071-0.731-0.462-1.284-0.873-1.234s-0.686 0.684-0.614 1.415c0 0 0 0 0 0 0.031 0.319 0.123 0.604 0.251 0.819-0.032 0.025-0.122 0.091-0.225 0.166-0.078 0.057-0.172 0.126-0.286 0.21-0.311-0.408-0.524-0.993-0.562-1.655zM10.395 11.878c-0.030 0.681-0.92 1.322-1.743 1.579l-0.005 0.002c-0.342 0.111-0.647 0.306-0.97 0.513-0.543 0.347-1.104 0.706-1.914 0.706-0.053 0-0.108-0.002-0.161-0.005-0.742-0.043-1.090-0.36-1.529-0.761-0.232-0.211-0.472-0.43-0.781-0.611l-0.007-0.004c-0.667-0.377-1.081-0.845-1.108-1.253-0.013-0.203 0.077-0.378 0.268-0.522 0.416-0.312 0.695-0.516 0.879-0.651 0.205-0.15 0.267-0.195 0.313-0.239 0.033-0.031 0.068-0.065 0.106-0.103 0.382-0.371 1.021-0.993 2.002-0.993 0.6 0 1.264 0.231 1.971 0.686 0.333 0.217 0.623 0.317 0.99 0.444 0.252 0.087 0.539 0.186 0.922 0.35l0.006 0.003c0.357 0.147 0.78 0.415 0.76 0.858zM10.198 10.278c-0.069-0.035-0.14-0.068-0.215-0.098-0.345-0.148-0.622-0.248-0.852-0.328 0.127-0.248 0.206-0.558 0.213-0.894 0-0 0-0 0-0 0.018-0.818-0.395-1.483-0.922-1.484s-0.968 0.661-0.986 1.479c0 0 0 0 0 0-0.001 0.027-0.001 0.053-0 0.080-0.324-0.149-0.643-0.258-0.956-0.324-0.001-0.031-0.003-0.061-0.004-0.092 0-0 0-0.001 0-0.001-0.030-1.491 0.884-2.725 2.043-2.756s2.122 1.152 2.153 2.642c0 0 0 0.001 0 0.001 0.014 0.674-0.167 1.295-0.475 1.776z"
    }
  }]
};
exports.tux = tux;
var appleinc = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.367 8.501c-0.020-2.026 1.652-2.998 1.727-3.046-0.94-1.375-2.404-1.564-2.926-1.585-1.246-0.126-2.431 0.734-3.064 0.734-0.631 0-1.607-0.715-2.64-0.696-1.358 0.020-2.61 0.79-3.31 2.006-1.411 2.448-0.361 6.076 1.014 8.061 0.672 0.972 1.473 2.064 2.525 2.025 1.013-0.040 1.396-0.656 2.621-0.656s1.569 0.656 2.641 0.635c1.090-0.020 1.781-0.991 2.448-1.966 0.772-1.128 1.089-2.219 1.108-2.275-0.024-0.011-2.126-0.816-2.147-3.236zM10.353 2.555c0.558-0.677 0.935-1.617 0.832-2.555-0.804 0.033-1.779 0.536-2.356 1.212-0.518 0.6-0.971 1.557-0.85 2.476 0.898 0.070 1.815-0.456 2.373-1.132z"
    }
  }]
};
exports.appleinc = appleinc;
var finder = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.894 12.16c-0-0.001-0-0.001-0-0.002 0 0.001 0 0.001 0 0.002z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.916 12.727c-0-0.004-0-0.007-0.001-0.011 0 0.004 0 0.007 0.001 0.011z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.903 12.442c-0-0.003-0-0.006-0-0.008 0 0.003 0 0.006 0 0.008z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 0h-14c-0.55 0-1 0.45-1 1v14c0 0.55 0.45 1 1 1h7.716c0.001 0 0.001 0 0.002 0s0.001-0 0.002-0h6.28c0.55 0 1-0.45 1-1v-14c0-0.55-0.45-1-1-1zM3 3.5c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5s-0.5-0.224-0.5-0.5v-1zM15 15h-5.86c-0.105-0.658-0.17-1.336-0.209-1.994 0 0.002 0 0.004 0 0.005-0.308 0.034-0.618 0.051-0.931 0.051-2.088 0-4.1-0.76-5.664-2.141-0.233-0.206-0.255-0.561-0.050-0.794s0.561-0.255 0.794-0.050c1.358 1.199 3.105 1.859 4.919 1.859 0.298 0 0.595-0.018 0.888-0.053-0.034-1.847 0.107-3.311 0.11-3.334 0.014-0.141-0.032-0.28-0.127-0.385s-0.229-0.164-0.371-0.164h-1.487c0.022-0.541 0.079-1.466 0.234-2.503 0.295-1.981 0.812-3.528 1.502-4.497h6.251v14z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.5 5c-0.276 0-0.5-0.224-0.5-0.5v-1c0-0.276 0.224-0.5 0.5-0.5s0.5 0.224 0.5 0.5v1c0 0.276-0.224 0.5-0.5 0.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.445 13.050c-0.057 0.003-0.114 0.005-0.171 0.007 0.057-0.002 0.114-0.004 0.171-0.007z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 13.063c0.073 0 0.146-0.001 0.22-0.003-0.073 0.002-0.146 0.003-0.22 0.003z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.423 11.925c0.012-0.001 0.024-0.001 0.037-0.002-0.012 0.001-0.024 0.001-0.037 0.002z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.204 11.934c0.017-0 0.034-0.001 0.050-0.002-0.017 0.001-0.034 0.001-0.050 0.002z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.713 10.128c-0.206-0.233-0.561-0.255-0.794-0.050-1.135 1.002-2.542 1.627-4.032 1.806 0.007 0.364 0.020 0.742 0.043 1.127 1.749-0.191 3.403-0.916 4.733-2.090 0.233-0.206 0.255-0.561 0.050-0.794z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.93 13.012c-0.072 0.008-0.144 0.015-0.216 0.021 0.072-0.006 0.144-0.013 0.216-0.021z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.68 13.035c-0.061 0.005-0.122 0.009-0.183 0.013 0.061-0.004 0.122-0.008 0.183-0.013z"
    }
  }]
};
exports.finder = finder;
var android = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM2 6c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-0.55-0.45-1-1-1zM3.5 11.5c0 0.828 0.672 1.5 1.5 1.5v0 2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-2c0.828 0 1.5-0.672 1.5-1.5v-5.5h-9v5.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.472 5c-0.152-1.373-0.922-2.559-2.025-3.276l0.5-1.001c0.123-0.247 0.023-0.547-0.224-0.671s-0.547-0.023-0.671 0.224l-0.502 1.004-0.13-0.052c-0.446-0.148-0.924-0.229-1.42-0.229s-0.974 0.081-1.42 0.229l-0.13 0.052-0.502-1.004c-0.123-0.247-0.424-0.347-0.671-0.224s-0.347 0.424-0.224 0.671l0.5 1.001c-1.103 0.716-1.873 1.903-2.025 3.276v0.5h8.972v-0.5h-0.028zM6.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.001-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5zM9.5 4c-0.276 0-0.5-0.224-0.5-0.5s0.223-0.499 0.499-0.5c0 0 0.001 0 0.001 0s0.001-0 0.002-0c0.276 0.001 0.499 0.224 0.499 0.5s-0.224 0.5-0.5 0.5z"
    }
  }]
};
exports.android = android;
var windows = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.441 7.999c-0.745-0.383-1.47-0.577-2.154-0.577-0.093 0-0.187 0.003-0.28 0.011-0.873 0.072-1.671 0.303-2.184 0.482-0.136 0.050-0.276 0.103-0.419 0.161l-1.403 4.866c0.964-0.357 1.817-0.53 2.598-0.53 1.263 0 2.18 0.472 2.937 0.958 0.359-1.217 1.219-4.158 1.476-5.036-0.187-0.114-0.376-0.228-0.571-0.333zM8.255 9.235l-1.413 4.909c0.419 0.24 1.83 1.001 2.91 1.001 0.872 0 1.848-0.223 2.982-0.684l1.349-4.718c-0.916 0.296-1.795 0.446-2.617 0.446-1.499 0-2.549-0.486-3.211-0.952zM4.575 5.762c1.205 0.012 2.096 0.472 2.835 0.945l1.449-4.958c-0.305-0.175-1.106-0.611-1.685-0.759-0.381-0.089-0.782-0.135-1.206-0.135-0.809 0.015-1.694 0.218-2.701 0.622l-1.382 4.853c1.013-0.382 1.885-0.568 2.689-0.568 0.001 0 0.002 0 0.002 0zM16 3.096c-0.919 0.357-1.816 0.539-2.672 0.539-1.433 0-2.489-0.497-3.173-0.974l-1.437 4.972c0.965 0.62 2.005 0.936 3.096 0.936 0.89 0 1.812-0.214 2.742-0.636l-0.003-0.035 0.058-0.014 1.39-4.788z"
    }
  }]
};
exports.windows = windows;
var windows8 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.005 8l-0.005-4.876 6-0.815v5.691zM7 2.164l7.998-1.164v7h-7.998zM15 9l-0.002 7-7.998-1.125v-5.875zM6 14.747l-5.995-0.822-0-4.926h5.995z"
    }
  }]
};
exports.windows8 = windows8;
var soundcloud = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.937 8.034c-0.283 0-0.552 0.055-0.798 0.154-0.164-1.787-1.723-3.188-3.625-3.188-0.465 0-0.917 0.088-1.317 0.237-0.156 0.058-0.197 0.117-0.197 0.233v6.292c0 0.121 0.098 0.222 0.221 0.234 0.005 0.001 5.68 0.003 5.717 0.003 1.139 0 2.062-0.888 2.062-1.983s-0.924-1.983-2.063-1.983zM6.25 12h0.5l0.25-3.503-0.25-3.497h-0.5l-0.25 3.497zM4.75 12h-0.5l-0.25-2.543 0.25-2.457h0.5l0.25 2.5zM2.25 12h0.5l0.25-2-0.25-2h-0.5l-0.25 2zM0.25 11h0.5l0.25-1-0.25-1h-0.5l-0.25 1z"
    }
  }]
};
exports.soundcloud = soundcloud;
var soundcloud2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM2.75 11h-0.5l-0.25-1.5 0.25-1.5h0.5l0.25 1.5-0.25 1.5zM4.75 11h-0.5l-0.25-2 0.25-2h0.5l0.25 2-0.25 2zM6.75 11h-0.5l-0.25-3 0.25-3h0.5l0.25 3-0.25 3zM12.894 11c-0.031 0-4.706-0.003-4.709-0.003-0.1-0.009-0.181-0.097-0.184-0.2v-5.394c0-0.1 0.034-0.15 0.162-0.2 0.331-0.128 0.703-0.203 1.088-0.203 1.566 0 2.85 1.2 2.987 2.734 0.203-0.084 0.425-0.131 0.656-0.131 0.938 0 1.7 0.762 1.7 1.7s-0.762 1.697-1.7 1.697z"
    }
  }]
};
exports.soundcloud2 = soundcloud2;
var skype = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.65 0.584c-0.025-0.016-0.053-0.028-0.078-0.041-0.028 0.006-0.053 0.009-0.081 0.016l0.159 0.025z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.575 6.578c-0.006 0.028-0.009 0.056-0.012 0.081 0.016 0.025 0.025 0.050 0.041 0.075l-0.028-0.156z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.419 9.416c0.006-0.028 0.009-0.056 0.016-0.084-0.016-0.025-0.025-0.050-0.041-0.075l0.025 0.159z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.25 15.359c0.025 0.016 0.053 0.028 0.078 0.041 0.028-0.006 0.056-0.009 0.084-0.012l-0.162-0.028z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.434 9.331c-0.006 0.028-0.009 0.056-0.016 0.084l-0.028-0.162c0.016 0.028 0.028 0.053 0.044 0.078 0.081-0.45 0.125-0.909 0.125-1.369 0-1.019-0.2-2.009-0.594-2.941-0.381-0.9-0.925-1.709-1.619-2.403s-1.503-1.238-2.4-1.619c-0.931-0.394-1.922-0.594-2.941-0.594-0.481 0-0.963 0.044-1.431 0.134 0 0-0.003 0-0.003 0 0.025 0.012 0.053 0.025 0.078 0.041l-0.159-0.025c0.028-0.006 0.053-0.009 0.081-0.016-0.644-0.341-1.366-0.525-2.097-0.525-1.194 0-2.319 0.466-3.163 1.309s-1.309 1.969-1.309 3.163c0 0.759 0.197 1.509 0.563 2.169 0.006-0.028 0.009-0.056 0.012-0.081l0.028 0.159c-0.016-0.025-0.028-0.050-0.041-0.075-0.075 0.428-0.112 0.866-0.112 1.303 0 1.019 0.2 2.009 0.594 2.941 0.381 0.9 0.925 1.706 1.619 2.4s1.503 1.238 2.403 1.619c0.931 0.394 1.922 0.594 2.941 0.594 0.444 0 0.887-0.041 1.322-0.119-0.025-0.016-0.050-0.028-0.078-0.041l0.162 0.028c-0.028 0.006-0.056 0.009-0.084 0.012 0.669 0.378 1.428 0.581 2.2 0.581 1.194 0 2.319-0.466 3.162-1.309s1.309-1.969 1.309-3.162c-0.003-0.759-0.2-1.509-0.569-2.175zM8.034 12.591c-2.684 0-3.884-1.319-3.884-2.309 0-0.506 0.375-0.863 0.891-0.863 1.15 0 0.85 1.65 2.994 1.65 1.097 0 1.703-0.597 1.703-1.206 0-0.366-0.181-0.772-0.903-0.95l-2.388-0.597c-1.922-0.481-2.272-1.522-2.272-2.5 0-2.028 1.909-2.791 3.703-2.791 1.653 0 3.6 0.913 3.6 2.131 0 0.522-0.453 0.825-0.969 0.825-0.981 0-0.8-1.356-2.775-1.356-0.981 0-1.522 0.444-1.522 1.078s0.775 0.838 1.447 0.991l1.769 0.394c1.934 0.431 2.425 1.563 2.425 2.625 0 1.647-1.266 2.878-3.819 2.878z"
    }
  }]
};
exports.skype = skype;
var reddit = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10 10c0-0.552 0.448-1 1-1s1 0.448 1 1c0 0.552-0.448 1-1 1s-1-0.448-1-1zM10.049 12.137c0.258-0.203 0.631-0.159 0.834 0.099s0.159 0.631-0.099 0.834c-0.717 0.565-1.81 0.93-2.783 0.93s-2.066-0.365-2.784-0.93c-0.258-0.203-0.302-0.576-0.099-0.834s0.576-0.302 0.834-0.099c0.413 0.325 1.23 0.675 2.049 0.675s1.636-0.35 2.049-0.675zM16 8c0-1.105-0.895-2-2-2-0.752 0-1.406 0.415-1.748 1.028-1.028-0.562-2.28-0.926-3.645-1.010l1.193-2.68 2.284 0.659c0.206 0.583 0.761 1.002 1.415 1.002 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5c-0.571 0-1.068 0.319-1.321 0.789l-2.545-0.735c-0.285-0.082-0.587 0.058-0.707 0.329l-1.621 3.641c-1.33 0.094-2.551 0.453-3.557 1.004-0.342-0.613-0.996-1.028-1.748-1.028-1.105 0-2 0.895-2 2 0 0.817 0.491 1.52 1.193 1.83-0.126 0.375-0.193 0.767-0.193 1.17 0 2.761 3.134 5 7 5s7-2.239 7-5c0-0.403-0.067-0.795-0.193-1.17 0.703-0.31 1.193-1.013 1.193-1.83zM13.5 2.938c0.311 0 0.563 0.252 0.563 0.563s-0.252 0.563-0.563 0.563-0.563-0.252-0.563-0.563 0.252-0.563 0.563-0.563zM1 8c0-0.551 0.449-1 1-1 0.399 0 0.743 0.234 0.904 0.573-0.523 0.396-0.956 0.854-1.276 1.355-0.368-0.148-0.628-0.508-0.628-0.928zM8 14.813c-3.21 0-5.813-1.707-5.813-3.813s2.602-3.813 5.813-3.813c3.21 0 5.813 1.707 5.813 3.813s-2.602 3.813-5.813 3.813zM14.372 8.928c-0.32-0.502-0.753-0.959-1.276-1.355 0.161-0.338 0.505-0.573 0.904-0.573 0.551 0 1 0.449 1 1 0 0.42-0.26 0.78-0.628 0.928z"
    }
  }]
};
exports.reddit = reddit;
var hackernews = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0v16h16v-16h-16zM8.5 9.125v3.375h-1v-3.375l-2.734-5.125h1.134l2.1 3.938 2.1-3.938h1.134l-2.734 5.125z"
    }
  }]
};
exports.hackernews = hackernews;
var wikipedia = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.106 3.65c0 0.050-0.016 0.097-0.047 0.141-0.031 0.041-0.066 0.063-0.106 0.063-0.313 0.031-0.569 0.131-0.766 0.3-0.2 0.169-0.403 0.497-0.613 0.975l-3.225 7.272c-0.022 0.069-0.081 0.1-0.178 0.1-0.075 0-0.134-0.034-0.178-0.1l-1.809-3.781-2.081 3.781c-0.044 0.069-0.1 0.1-0.178 0.1-0.094 0-0.153-0.034-0.184-0.1l-3.166-7.269c-0.197-0.45-0.406-0.766-0.625-0.944s-0.525-0.291-0.916-0.331c-0.034 0-0.066-0.019-0.094-0.053-0.031-0.034-0.044-0.075-0.044-0.122 0-0.119 0.034-0.178 0.1-0.178 0.281 0 0.578 0.013 0.888 0.038 0.288 0.025 0.556 0.038 0.809 0.038 0.256 0 0.563-0.013 0.913-0.038 0.366-0.025 0.691-0.038 0.975-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.022 0.175-0.063 0.175c-0.281 0.022-0.506 0.094-0.669 0.216s-0.244 0.281-0.244 0.481c0 0.1 0.034 0.228 0.1 0.378l2.616 5.912 1.487-2.806-1.384-2.903c-0.25-0.519-0.453-0.853-0.612-1.003s-0.403-0.241-0.728-0.275c-0.031 0-0.056-0.019-0.084-0.053s-0.041-0.075-0.041-0.122c0-0.119 0.028-0.178 0.088-0.178 0.281 0 0.541 0.013 0.778 0.038 0.228 0.025 0.469 0.038 0.728 0.038 0.253 0 0.519-0.013 0.803-0.038 0.291-0.025 0.578-0.038 0.859-0.038 0.069 0 0.1 0.059 0.1 0.178s-0.019 0.175-0.063 0.175c-0.566 0.038-0.847 0.2-0.847 0.481 0 0.125 0.066 0.322 0.197 0.588l0.916 1.859 0.912-1.7c0.125-0.241 0.191-0.444 0.191-0.606 0-0.388-0.281-0.594-0.847-0.619-0.050 0-0.075-0.059-0.075-0.175 0-0.044 0.012-0.081 0.037-0.119s0.050-0.056 0.075-0.056c0.203 0 0.45 0.013 0.747 0.038 0.281 0.025 0.516 0.038 0.697 0.038 0.131 0 0.322-0.013 0.575-0.031 0.319-0.028 0.588-0.044 0.803-0.044 0.050 0 0.075 0.050 0.075 0.15 0 0.134-0.047 0.203-0.137 0.203-0.328 0.034-0.594 0.125-0.794 0.272s-0.45 0.481-0.75 1.006l-1.222 2.237 1.644 3.35 2.428-5.647c0.084-0.206 0.125-0.397 0.125-0.569 0-0.412-0.281-0.631-0.847-0.659-0.050 0-0.075-0.059-0.075-0.175 0-0.119 0.037-0.178 0.113-0.178 0.206 0 0.45 0.013 0.734 0.038 0.262 0.025 0.481 0.038 0.656 0.038 0.188 0 0.4-0.013 0.644-0.038 0.253-0.025 0.481-0.038 0.684-0.038 0.063 0 0.094 0.050 0.094 0.15z"
    }
  }]
};
exports.wikipedia = wikipedia;
var linkedin = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM6 13h-2v-7h2v7zM5 5c-0.553 0-1-0.447-1-1s0.447-1 1-1c0.553 0 1 0.447 1 1s-0.447 1-1 1zM13 13h-2v-4c0-0.553-0.447-1-1-1s-1 0.447-1 1v4h-2v-7h2v1.241c0.412-0.566 1.044-1.241 1.75-1.241 1.244 0 2.25 1.119 2.25 2.5v4.5z"
    }
  }]
};
exports.linkedin = linkedin;
var linkedin2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6 6h2.767v1.418h0.040c0.385-0.691 1.327-1.418 2.732-1.418 2.921 0 3.461 1.818 3.461 4.183v4.817h-2.885v-4.27c0-1.018-0.021-2.329-1.5-2.329-1.502 0-1.732 1.109-1.732 2.255v4.344h-2.883v-9z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1 6h3v9h-3v-9z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4 3.5c0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.828 0.672-1.5 1.5-1.5s1.5 0.672 1.5 1.5z"
    }
  }]
};
exports.linkedin2 = linkedin2;
var lastfm = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M7.056 11.972l-0.588-1.594c0 0-0.953 1.063-2.381 1.063-1.266 0-2.163-1.1-2.163-2.859 0-2.253 1.137-3.059 2.253-3.059 1.612 0 2.125 1.044 2.566 2.381l0.588 1.831c0.588 1.778 1.688 3.206 4.856 3.206 2.272 0 3.813-0.697 3.813-2.528 0-1.484-0.844-2.253-2.419-2.622l-1.172-0.256c-0.806-0.184-1.044-0.513-1.044-1.063 0-0.622 0.494-0.991 1.3-0.991 0.881 0 1.356 0.331 1.428 1.119l1.831-0.219c-0.147-1.65-1.284-2.328-3.153-2.328-1.65 0-3.262 0.622-3.262 2.622 0 1.247 0.606 2.034 2.125 2.4l1.247 0.294c0.934 0.219 1.247 0.606 1.247 1.137 0 0.678-0.659 0.953-1.906 0.953-1.85 0-2.622-0.972-3.059-2.309l-0.606-1.831c-0.766-2.384-1.994-3.263-4.431-3.263-2.694 0-4.125 1.703-4.125 4.6 0 2.784 1.428 4.287 3.997 4.287 2.069 0 3.059-0.972 3.059-0.972v0z"
    }
  }]
};
exports.lastfm = lastfm;
var lastfm2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM11.666 11.887c-2.775 0-3.737-1.25-4.25-2.806l-0.513-1.603c-0.384-1.172-0.834-2.084-2.244-2.084-0.978 0-1.972 0.706-1.972 2.678 0 1.541 0.784 2.503 1.894 2.503 1.25 0 2.084-0.931 2.084-0.931l0.513 1.394c0 0-0.866 0.85-2.678 0.85-2.25 0-3.5-1.313-3.5-3.75 0-2.534 1.25-4.025 3.609-4.025 2.134 0 3.206 0.769 3.881 2.853l0.528 1.603c0.384 1.172 1.059 2.022 2.678 2.022 1.091 0 1.669-0.241 1.669-0.834 0-0.466-0.272-0.803-1.091-0.994l-1.091-0.256c-1.331-0.322-1.859-1.009-1.859-2.1 0-1.747 1.412-2.294 2.853-2.294 1.634 0 2.631 0.594 2.759 2.038l-1.603 0.194c-0.066-0.691-0.481-0.978-1.25-0.978-0.706 0-1.137 0.322-1.137 0.866 0 0.481 0.209 0.769 0.912 0.931l1.025 0.225c1.378 0.322 2.116 0.994 2.116 2.294 0 1.597-1.347 2.206-3.334 2.206z"
    }
  }]
};
exports.lastfm2 = lastfm2;
var delicious = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0 0v16h16v-16h-16zM8 15v-7h-7v-7h7v7h7v7h-7z"
    }
  }]
};
exports.delicious = delicious;
var stumbleupon = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 5c-0.55 0-1 0.45-1 1v4c0 1.653-1.347 3-3 3s-3-1.347-3-3v-2h2v2c0 0.55 0.45 1 1 1s1-0.45 1-1v-4c0-1.653 1.347-3 3-3s3 1.347 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.331-0.45-0.781-1-0.781z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15 10c0 1.653-1.347 3-3 3s-3-1.347-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.769 0.45 1.219 1 1.219s1-0.45 1-1v-2h2v2z"
    }
  }]
};
exports.stumbleupon = stumbleupon;
var stumbleupon2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.313 0h-10.625c-1.478 0-2.688 1.209-2.688 2.688v10.625c0 1.478 1.209 2.688 2.688 2.688h10.625c1.478 0 2.688-1.209 2.688-2.688v-10.625c0-1.478-1.209-2.688-2.688-2.688zM8 5c-0.551 0-1 0.449-1 1v4c0 1.654-1.346 3-3 3s-3-1.346-3-3v-2h2v2c0 0.551 0.449 1 1 1s1-0.449 1-1v-4c0-1.654 1.346-3 3-3s3 1.346 3 2.781v0.969l-1.281 0.375-0.719-0.375v-0.969c0-0.333-0.449-0.781-1-0.781zM15 10c0 1.654-1.346 3-3 3s-3-1.346-3-3.219v-1.938l0.719 0.375 1.281-0.375v1.938c0 0.77 0.449 1.219 1 1.219s1-0.449 1-1v-2h2v2z"
    }
  }]
};
exports.stumbleupon2 = stumbleupon2;
var stackoverflow = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 10v6h-16v-6h2v4h12v-4zM3 11h10v2h-10zM3.237 8.835l0.433-1.953 9.763 2.164-0.433 1.953zM4.37 4.821l0.845-1.813 9.063 4.226-0.845 1.813zM15.496 5.648l-1.218 1.587-7.934-6.088 0.88-1.147h0.91z"
    }
  }]
};
exports.stackoverflow = stackoverflow;
var pinterest = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 1.069c-3.828 0-6.931 3.103-6.931 6.931 0 2.938 1.828 5.444 4.406 6.453-0.059-0.547-0.116-1.391 0.025-1.988 0.125-0.541 0.813-3.444 0.813-3.444s-0.206-0.416-0.206-1.028c0-0.963 0.559-1.684 1.253-1.684 0.591 0 0.878 0.444 0.878 0.975 0 0.594-0.378 1.484-0.575 2.306-0.166 0.691 0.344 1.253 1.025 1.253 1.231 0 2.178-1.3 2.178-3.175 0-1.659-1.194-2.819-2.894-2.819-1.972 0-3.128 1.478-3.128 3.009 0 0.597 0.228 1.234 0.516 1.581 0.056 0.069 0.066 0.128 0.047 0.2-0.053 0.219-0.169 0.691-0.194 0.787-0.031 0.128-0.1 0.153-0.231 0.094-0.866-0.403-1.406-1.669-1.406-2.684 0-2.188 1.587-4.194 4.578-4.194 2.403 0 4.272 1.712 4.272 4.003 0 2.388-1.506 4.313-3.597 4.313-0.703 0-1.362-0.366-1.588-0.797 0 0-0.347 1.322-0.431 1.647-0.156 0.603-0.578 1.356-0.862 1.816 0.65 0.2 1.337 0.309 2.053 0.309 3.828 0 6.931-3.103 6.931-6.931 0-3.831-3.103-6.934-6.931-6.934z"
    }
  }]
};
exports.pinterest = pinterest;
var pinterest2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.412 0-8 3.587-8 8s3.587 8 8 8 8-3.588 8-8-3.588-8-8-8zM8 14.931c-0.716 0-1.403-0.109-2.053-0.309 0.281-0.459 0.706-1.216 0.862-1.816 0.084-0.325 0.431-1.647 0.431-1.647 0.225 0.431 0.888 0.797 1.587 0.797 2.091 0 3.597-1.922 3.597-4.313 0-2.291-1.869-4.003-4.272-4.003-2.991 0-4.578 2.009-4.578 4.194 0 1.016 0.541 2.281 1.406 2.684 0.131 0.063 0.2 0.034 0.231-0.094 0.022-0.097 0.141-0.566 0.194-0.787 0.016-0.069 0.009-0.131-0.047-0.2-0.287-0.347-0.516-0.988-0.516-1.581 0-1.528 1.156-3.009 3.128-3.009 1.703 0 2.894 1.159 2.894 2.819 0 1.875-0.947 3.175-2.178 3.175-0.681 0-1.191-0.563-1.025-1.253 0.197-0.825 0.575-1.713 0.575-2.306 0-0.531-0.284-0.975-0.878-0.975-0.697 0-1.253 0.719-1.253 1.684 0 0.612 0.206 1.028 0.206 1.028s-0.688 2.903-0.813 3.444c-0.141 0.6-0.084 1.441-0.025 1.988-2.578-1.006-4.406-3.512-4.406-6.45 0-3.828 3.103-6.931 6.931-6.931s6.931 3.103 6.931 6.931c0 3.828-3.103 6.931-6.931 6.931z"
    }
  }]
};
exports.pinterest2 = pinterest2;
var xing = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 0h-13c-0.825 0-1.5 0.675-1.5 1.5v13c0 0.825 0.675 1.5 1.5 1.5h13c0.825 0 1.5-0.675 1.5-1.5v-13c0-0.825-0.675-1.5-1.5-1.5zM4.884 10.406h-1.728c-0.103 0-0.181-0.047-0.225-0.119-0.047-0.075-0.047-0.169 0-0.266l1.838-3.244c0.003-0.003 0.003-0.006 0-0.009l-1.169-2.025c-0.047-0.097-0.056-0.191-0.009-0.266 0.044-0.072 0.131-0.109 0.237-0.109h1.731c0.266 0 0.397 0.172 0.481 0.325 0 0 1.181 2.063 1.191 2.075-0.069 0.125-1.869 3.303-1.869 3.303-0.094 0.162-0.219 0.334-0.478 0.334zM13.069 2.378l-3.831 6.775c-0.003 0.003-0.003 0.009 0 0.012l2.441 4.456c0.047 0.097 0.050 0.194 0.003 0.269-0.044 0.072-0.125 0.109-0.231 0.109h-1.728c-0.266 0-0.397-0.175-0.484-0.328 0 0-2.453-4.5-2.459-4.512 0.122-0.216 3.85-6.828 3.85-6.828 0.094-0.166 0.206-0.328 0.463-0.328h1.753c0.103 0 0.188 0.041 0.231 0.109 0.044 0.072 0.044 0.169-0.006 0.266z"
    }
  }]
};
exports.xing = xing;
var xing2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.431 3.159c-0.138 0-0.256 0.050-0.316 0.144-0.059 0.1-0.050 0.225 0.013 0.353l1.559 2.7c0.003 0.006 0.003 0.009 0 0.013l-2.45 4.331c-0.063 0.128-0.059 0.256 0 0.353 0.059 0.094 0.163 0.156 0.3 0.156h2.306c0.344 0 0.513-0.234 0.628-0.447 0 0 2.397-4.241 2.491-4.406-0.009-0.016-1.588-2.766-1.588-2.766-0.116-0.203-0.287-0.431-0.644-0.431h-2.3z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.125 0c-0.344 0-0.494 0.216-0.619 0.441 0 0-4.972 8.816-5.134 9.106 0.009 0.016 3.278 6.016 3.278 6.016 0.116 0.203 0.291 0.441 0.644 0.441h2.306c0.137 0 0.247-0.053 0.306-0.147 0.063-0.1 0.059-0.228-0.006-0.356l-3.25-5.947c-0.003-0.006-0.003-0.009 0-0.016l5.109-9.034c0.063-0.128 0.066-0.256 0.006-0.356-0.059-0.094-0.169-0.147-0.306-0.147h-2.334z"
    }
  }]
};
exports.xing2 = xing2;
var flattr = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.743 0c-3.802 0-5.743 2.19-5.743 6.279v0 8.579l3.725-3.729v-4.358c0-1.694 0.449-2.772 1.955-3.014v0c0.526-0.103 1.621-0.067 2.317-0.067v0 2.587c0 0.024 0.003 0.066 0.009 0.087v0c0.029 0.105 0.124 0.181 0.236 0.182v0c0.063 0 0.123-0.033 0.184-0.093v0l6.455-6.453-9.139-0.001zM12.275 4.871v4.358c0 1.694-0.449 2.772-1.955 3.014v0c-0.526 0.103-1.621 0.067-2.317 0.067v0-2.587c0-0.023-0.003-0.066-0.009-0.087v0c-0.029-0.105-0.124-0.182-0.236-0.182v0c-0.064-0-0.123 0.033-0.184 0.093v0l-6.455 6.453 9.139 0.001c3.802 0 5.743-2.19 5.743-6.279v0-8.579l-3.725 3.729z"
    }
  }]
};
exports.flattr = flattr;
var foursquare = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.306 1.408c-0.188-0.256-0.488-0.408-0.806-0.408h-9.5c-0.552 0-1 0.448-1 1v12c0 0.404 0.244 0.769 0.617 0.924 0.124 0.051 0.254 0.076 0.382 0.076 0.26 0 0.516-0.102 0.707-0.293l3.707-3.707h2.586c0.437 0 0.824-0.284 0.954-0.702l2.5-8c0.095-0.304 0.040-0.634-0.149-0.891zM10.515 5h-3.515c-0.552 0-1 0.448-1 1s0.448 1 1 1h2.89l-0.625 2h-2.265c-0.265 0-0.52 0.105-0.707 0.293l-2.293 2.293v-8.586h7.14l-0.625 2z"
    }
  }]
};
exports.foursquare = foursquare;
var yelp = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.514 10.21c-0.27 0.272-0.042 0.768-0.042 0.768l2.033 3.394c0 0 0.334 0.447 0.623 0.447 0.29 0 0.577-0.239 0.577-0.239l1.607-2.297c0 0 0.162-0.29 0.166-0.544 0.006-0.361-0.538-0.46-0.538-0.46l-3.805-1.222c-0 0-0.373-0.099-0.621 0.152zM9.321 8.5c0.195 0.33 0.732 0.234 0.732 0.234l3.796-1.109c0 0 0.517-0.21 0.591-0.491 0.072-0.281-0.085-0.619-0.085-0.619l-1.814-2.137c0 0-0.157-0.27-0.483-0.297-0.36-0.031-0.581 0.405-0.581 0.405l-2.145 3.375c0 0-0.19 0.336-0.010 0.64zM7.527 7.184c0.447-0.11 0.518-0.759 0.518-0.759l-0.030-5.404c0 0-0.067-0.667-0.367-0.847-0.47-0.285-0.609-0.136-0.744-0.116l-3.151 1.171c0 0-0.309 0.102-0.469 0.36-0.23 0.365 0.233 0.899 0.233 0.899l3.276 4.465c0 0 0.323 0.334 0.735 0.233zM6.749 9.371c0.011-0.417-0.5-0.667-0.5-0.667l-3.387-1.711c0 0-0.502-0.207-0.746-0.063-0.187 0.11-0.352 0.31-0.368 0.486l-0.221 2.716c0 0-0.033 0.471 0.089 0.685 0.173 0.304 0.741 0.092 0.741 0.092l3.955-0.874c0.154-0.103 0.423-0.113 0.438-0.664zM7.732 10.837c-0.339-0.174-0.746 0.187-0.746 0.187l-2.648 2.915c0 0-0.33 0.446-0.246 0.72 0.079 0.257 0.21 0.384 0.396 0.474l2.659 0.839c0 0 0.322 0.067 0.567-0.004 0.347-0.1 0.283-0.643 0.283-0.643l0.060-3.947c-0 0-0.014-0.38-0.324-0.541z"
    }
  }]
};
exports.yelp = yelp;
var paypal = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.531 4.822c-0.747 3.316-3.053 5.066-6.688 5.066h-1.209l-0.841 5.338h-1.013l-0.053 0.344c-0.034 0.228 0.141 0.431 0.369 0.431h2.588c0.306 0 0.566-0.222 0.616-0.525l0.025-0.131 0.488-3.091 0.031-0.169c0.047-0.303 0.309-0.525 0.616-0.525h0.384c2.506 0 4.469-1.019 5.044-3.963 0.216-1.119 0.134-2.069-0.356-2.775z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M12.984 1.206c-0.741-0.844-2.081-1.206-3.794-1.206h-4.972c-0.35 0-0.65 0.253-0.703 0.6l-2.072 13.131c-0.041 0.259 0.159 0.494 0.422 0.494h3.072l0.772-4.891-0.025 0.153c0.053-0.347 0.35-0.6 0.7-0.6h1.459c2.866 0 5.109-1.162 5.766-4.531 0.019-0.1 0.037-0.197 0.050-0.291 0.194-1.244 0-2.094-0.675-2.859z"
    }
  }]
};
exports.paypal = paypal;
var chrome = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.036 6.977l-2.29-3.966c1.466-1.835 3.722-3.012 6.254-3.012 2.929 0 5.489 1.574 6.883 3.922h-6.528c-0.117-0.010-0.236-0.016-0.356-0.016-1.904 0-3.509 1.307-3.964 3.071zM10.864 5.078h4.585c0.355 0.905 0.551 1.891 0.551 2.922 0 4.388-3.533 7.95-7.909 7.999l3.272-5.667c0.461-0.662 0.731-1.466 0.731-2.332 0-1.143-0.471-2.178-1.23-2.922zM5.094 8c0-1.603 1.304-2.906 2.906-2.906s2.906 1.304 2.906 2.906c0 1.602-1.304 2.906-2.906 2.906s-2.906-1.304-2.906-2.906zM9.097 11.944l-2.29 3.967c-3.852-0.576-6.806-3.899-6.806-7.911 0-1.425 0.373-2.763 1.026-3.922l3.266 5.657c0.654 1.392 2.070 2.359 3.707 2.359 0.38 0 0.747-0.052 1.097-0.149z"
    }
  }]
};
exports.chrome = chrome;
var firefox = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.977 5.221l-0.185 1.189c0 0-0.265-2.201-0.59-3.024-0.498-1.261-0.719-1.251-0.72-1.249 0.333 0.847 0.273 1.302 0.273 1.302s-0.591-1.609-2.152-2.121c-1.729-0.567-2.665-0.412-2.773-0.383-0.016-0-0.032-0-0.047-0 0.013 0.001 0.025 0.002 0.038 0.003-0.001 0-0.001 0.001-0.001 0.001 0.007 0.009 1.911 0.333 2.249 0.797 0 0-0.809 0-1.614 0.232-0.036 0.010 2.961 0.374 3.574 3.37 0 0-0.329-0.686-0.735-0.802 0.267 0.813 0.199 2.356-0.056 3.123-0.033 0.099-0.066-0.426-0.568-0.652 0.161 1.151-0.010 2.976-0.808 3.479-0.062 0.039 0.5-1.802 0.113-1.090-2.23 3.419-4.866 1.578-6.051 0.767 0.607 0.132 1.76-0.021 2.271-0.4 0.001-0 0.001-0.001 0.002-0.001 0.554-0.379 0.882-0.656 1.177-0.59s0.491-0.23 0.262-0.493c-0.229-0.263-0.786-0.625-1.539-0.428-0.531 0.139-1.19 0.727-2.194 0.132-0.771-0.457-0.844-0.837-0.851-1.1 0.019-0.093 0.043-0.18 0.072-0.26 0.089-0.248 0.358-0.323 0.508-0.382 0.254 0.044 0.473 0.123 0.703 0.241 0.003-0.076 0.004-0.178-0-0.293 0.022-0.044 0.008-0.176-0.027-0.337-0.020-0.161-0.053-0.328-0.106-0.48 0-0 0-0 0-0s0.002-0.001 0.002-0.001c0.001-0.001 0.002-0.002 0.003-0.003s0-0.001 0.001-0.001c0.001-0.002 0.002-0.004 0.003-0.007 0.016-0.072 0.188-0.211 0.402-0.361 0.192-0.134 0.417-0.277 0.595-0.387 0.157-0.098 0.277-0.17 0.302-0.189 0.010-0.007 0.021-0.016 0.034-0.026 0.002-0.002 0.005-0.004 0.007-0.006s0.003-0.002 0.004-0.004c0.085-0.067 0.211-0.194 0.237-0.462 0-0.001 0-0.001 0-0.002 0.001-0.008 0.001-0.016 0.002-0.024 0-0.006 0.001-0.011 0.001-0.017 0-0.004 0-0.009 0.001-0.013 0-0.011 0.001-0.021 0.001-0.032 0-0.001 0-0.001 0-0.002 0-0.026-0-0.053-0.002-0.081-0.001-0.016-0.002-0.030-0.005-0.043-0-0.001-0-0.001-0-0.002s-0.001-0.003-0.001-0.004-0.001-0.005-0.002-0.007c-0-0-0-0-0-0.001-0.001-0.003-0.002-0.005-0.003-0.007-0-0-0-0-0-0-0.027-0.064-0.13-0.088-0.554-0.096-0-0-0.001-0-0.001-0v0c-0.173-0.003-0.399-0.003-0.695-0.002-0.52 0.002-0.807-0.508-0.898-0.705 0.126-0.695 0.489-1.19 1.085-1.525 0.011-0.006 0.009-0.012-0.004-0.015 0.117-0.071-1.41-0.002-2.112 0.891-0.623-0.155-1.166-0.144-1.635-0.035-0.090-0.003-0.202-0.014-0.335-0.041-0.311-0.282-0.757-0.803-0.781-1.425 0 0-0.001 0.001-0.004 0.003-0-0.006-0.001-0.012-0.001-0.018 0 0-0.949 0.729-0.807 2.717-0 0.032-0.001 0.062-0.002 0.092-0.257 0.348-0.384 0.641-0.394 0.706-0.228 0.463-0.458 1.16-0.646 2.218 0 0 0.131-0.417 0.395-0.889-0.194 0.594-0.346 1.518-0.257 2.904 0 0 0.024-0.307 0.107-0.75 0.065 0.86 0.352 1.921 1.076 3.169 1.39 2.396 3.526 3.605 5.887 3.791 0.419 0.035 0.845 0.035 1.272 0.003 0.039-0.003 0.079-0.006 0.118-0.009 0.484-0.034 0.971-0.107 1.457-0.224 6.643-1.606 5.921-9.628 5.921-9.628z"
    }
  }]
};
exports.firefox = firefox;
var IE = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.472 9.825h3.688c0.028-0.256 0.040-0.517 0.040-0.784 0-1.253-0.336-2.429-0.924-3.442 0.607-1.614 0.586-2.984-0.227-3.803-0.773-0.77-2.848-0.645-5.194 0.394-0.174-0.013-0.349-0.020-0.526-0.020-3.22 0-5.921 2.216-6.667 5.201 1.010-1.293 2.072-2.231 3.492-2.913-0.129 0.121-0.882 0.87-1.009 0.996-3.743 3.742-4.923 8.63-3.653 9.9 0.965 0.965 2.715 0.802 4.725-0.182 0.934 0.476 1.992 0.744 3.113 0.744 3.018 0 5.575-1.942 6.501-4.648h-3.717c-0.511 0.943-1.512 1.586-2.66 1.586s-2.148-0.642-2.66-1.586c-0.227-0.426-0.358-0.915-0.358-1.432v-0.011h6.035zM5.442 8.013c0.085-1.517 1.347-2.728 2.887-2.728s2.802 1.21 2.887 2.728h-5.774zM14.015 2.559c0.524 0.529 0.511 1.503 0.063 2.719-0.768-1.17-1.883-2.093-3.2-2.619 1.408-0.604 2.553-0.684 3.137-0.1zM1.461 15.113c-0.668-0.669-0.467-2.072 0.394-3.763 0.536 1.504 1.581 2.767 2.927 3.581-1.491 0.677-2.712 0.792-3.321 0.182z"
    }
  }]
};
exports.IE = IE;
var edge = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.241 7.103c0.469-3.7 2.994-7.056 7.519-7.103 2.731 0.053 4.978 1.291 6.316 3.65 0.672 1.231 0.881 2.525 0.925 3.953v1.678h-10.041c0.047 4.141 6.094 4 8.697 2.175v3.372c-1.525 0.916-4.984 1.734-7.662 0.681-2.281-0.856-3.906-3.244-3.897-5.541-0.075-2.978 1.481-4.95 3.897-6.072-0.513 0.634-0.903 1.334-1.106 2.547h5.669c0 0 0.331-3.388-3.209-3.388-3.338 0.116-5.744 2.056-7.106 4.047v0z"
    }
  }]
};
exports.edge = edge;
var safari = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8 0c-4.419 0-8 3.581-8 8s3.581 8 8 8 8-3.581 8-8-3.581-8-8-8zM14.975 7.388l-0.016-0.166c0.003 0.056 0.009 0.109 0.016 0.166zM13.881 4.2l-0.113-0.169c0.037 0.056 0.075 0.112 0.113 0.169zM13.447 3.603l-0.069-0.084c0.025 0.028 0.047 0.056 0.069 0.084zM12.478 2.619l-0.084-0.069c0.031 0.025 0.056 0.047 0.084 0.069zM11.969 2.231l-0.169-0.112c0.056 0.038 0.113 0.075 0.169 0.112zM8.778 1.044l-0.169-0.016c0.056 0.003 0.113 0.009 0.169 0.016zM7.388 1.025l-0.169 0.016c0.056-0.003 0.112-0.009 0.169-0.016zM4.2 2.119l-0.169 0.112c0.056-0.038 0.112-0.075 0.169-0.112zM3.603 2.553l-0.081 0.066c0.028-0.022 0.053-0.044 0.081-0.066zM2.619 3.522l-0.069 0.084c0.025-0.028 0.047-0.056 0.069-0.084zM2.231 4.031l-0.112 0.169c0.038-0.056 0.075-0.112 0.112-0.169zM1.044 7.222l-0.016 0.169c0.003-0.056 0.009-0.112 0.016-0.169zM1.025 8.613l0.016 0.169c-0.003-0.056-0.009-0.113-0.016-0.169zM2.119 11.797l0.112 0.169c-0.038-0.053-0.075-0.109-0.112-0.169zM2.25 11.994l1.247-0.834-0.138-0.209-1.247 0.834c-0.566-0.878-0.938-1.887-1.063-2.975l0.747-0.075-0.025-0.25-0.747 0.075c-0.012-0.144-0.019-0.291-0.022-0.438h1.5v-0.25h-1.5c0.003-0.147 0.009-0.291 0.022-0.438l0.747 0.072 0.025-0.25-0.747-0.072c0.125-1.088 0.5-2.097 1.066-2.975l1.247 0.834 0.138-0.209-1.25-0.828c0.084-0.119 0.169-0.237 0.259-0.35l0.578 0.475 0.159-0.194-0.578-0.475c0.094-0.112 0.194-0.219 0.294-0.325l1.059 1.059 0.178-0.178-1.059-1.059c0.106-0.1 0.212-0.2 0.322-0.294l0.475 0.581 0.194-0.159-0.475-0.578c0.116-0.091 0.231-0.178 0.35-0.263l0.834 1.247 0.209-0.138-0.834-1.247c0.878-0.566 1.888-0.938 2.975-1.063l0.075 0.747 0.25-0.025-0.075-0.747c0.144-0.012 0.291-0.019 0.438-0.022v1.5h0.25v-1.5c0.147 0.003 0.291 0.009 0.438 0.022l-0.072 0.747 0.25 0.025 0.072-0.747c1.088 0.125 2.097 0.5 2.975 1.066l-0.834 1.247 0.209 0.138 0.834-1.247c0.119 0.084 0.238 0.169 0.35 0.259l-0.475 0.578 0.194 0.159 0.475-0.578c0.113 0.094 0.219 0.194 0.325 0.294l-0.4 0.391-5.469 3.647-3.647 5.469-0.391 0.391c-0.1-0.106-0.2-0.213-0.294-0.322l0.578-0.475-0.159-0.194-0.578 0.475c-0.091-0.113-0.175-0.231-0.259-0.35zM2.619 12.478c-0.022-0.028-0.044-0.053-0.066-0.081l0.066 0.081zM3.522 13.381l0.081 0.066c-0.028-0.022-0.053-0.044-0.081-0.066zM4.031 13.766l0.169 0.113c-0.056-0.034-0.112-0.072-0.169-0.113zM7.222 14.956l0.169 0.016c-0.056-0.003-0.112-0.009-0.169-0.016zM8.613 14.975l0.166-0.016c-0.056 0.003-0.109 0.009-0.166 0.016zM11.8 13.881l0.169-0.113c-0.056 0.037-0.113 0.075-0.169 0.113zM12.397 13.447l0.084-0.069c-0.028 0.025-0.056 0.047-0.084 0.069zM12.944 12.956l0.012-0.012c-0.003 0.003-0.009 0.009-0.012 0.012zM13.381 12.478l0.069-0.084c-0.025 0.028-0.047 0.056-0.069 0.084zM13.491 12.344l-0.578-0.475-0.159 0.194 0.578 0.475c-0.094 0.113-0.194 0.219-0.294 0.325l-1.059-1.059-0.178 0.178 1.059 1.059c-0.106 0.1-0.213 0.2-0.322 0.294l-0.475-0.581-0.194 0.159 0.475 0.578c-0.116 0.091-0.231 0.178-0.35 0.262l-0.834-1.247-0.209 0.137 0.834 1.247c-0.878 0.566-1.887 0.938-2.975 1.063l-0.075-0.747-0.25 0.025 0.075 0.747c-0.144 0.012-0.291 0.019-0.438 0.022v-1.5h-0.25v1.5c-0.147-0.003-0.291-0.009-0.438-0.022l0.072-0.747-0.25-0.025-0.072 0.747c-1.088-0.125-2.097-0.5-2.975-1.066l0.834-1.247-0.209-0.137-0.828 1.247c-0.119-0.084-0.237-0.169-0.35-0.259l0.475-0.578-0.194-0.159-0.475 0.578c-0.112-0.094-0.219-0.194-0.325-0.294l0.394-0.391 5.469-3.647 3.647-5.469 0.391-0.391c0.1 0.106 0.2 0.212 0.294 0.322l-0.578 0.475 0.159 0.194 0.578-0.475c0.091 0.116 0.178 0.231 0.262 0.35l-1.247 0.834 0.137 0.209 1.247-0.834c0.566 0.878 0.938 1.888 1.063 2.975l-0.747 0.075 0.025 0.25 0.747-0.075c0.012 0.144 0.019 0.291 0.022 0.438h-1.5v0.25h1.5c-0.003 0.147-0.009 0.291-0.022 0.438l-0.747-0.072-0.025 0.25 0.747 0.072c-0.125 1.088-0.5 2.097-1.066 2.975l-1.247-0.834-0.137 0.209 1.247 0.834c-0.081 0.113-0.169 0.228-0.259 0.344zM14.975 8.609c-0.006 0.056-0.009 0.113-0.016 0.169l0.016-0.169zM13.881 11.8c-0.037 0.056-0.075 0.113-0.113 0.169l0.113-0.169z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.758 1.111l0.293 1.471-0.245 0.049-0.293-1.471 0.245-0.049z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.245 14.89l-0.293-1.471 0.245-0.049 0.293 1.471-0.245 0.049z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.088 1.264l0.218 0.718-0.239 0.073-0.218-0.718 0.239-0.073z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.913 14.733l-0.218-0.718 0.239-0.073 0.218 0.718-0.239 0.073z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.438 1.486l0.574 1.386-0.231 0.096-0.574-1.386 0.231-0.096z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.564 14.515l-0.574-1.386 0.231-0.096 0.574 1.386-0.231 0.096z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.588 1.885l0.22-0.118 0.354 0.661-0.22 0.118-0.354-0.661z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.408 14.114l-0.22 0.118-0.354-0.661 0.22-0.118 0.354 0.661z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.884 4.591l0.662 0.353-0.118 0.221-0.661-0.353 0.118-0.221z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.113 11.409l-0.662-0.353 0.118-0.22 0.662 0.353-0.118 0.22z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.872 6.010l-1.386-0.574 0.096-0.231 1.386 0.574-0.096 0.231z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.13 9.989l1.386 0.574-0.096 0.231-1.386-0.574 0.096-0.231z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.337 5.85l0.718 0.218-0.073 0.239-0.718-0.218 0.073-0.239z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.661 10.151l-0.718-0.218 0.073-0.239 0.718 0.218-0.073 0.239z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.157 6.512l1.471 0.293-0.049 0.245-1.471-0.293 0.049-0.245z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.84 9.488l-1.471-0.293 0.049-0.245 1.471 0.293-0.049 0.245z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.109 9.243l1.471-0.293 0.049 0.245-1.471 0.293-0.049-0.245z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.888 6.757l-1.471 0.293-0.049-0.245 1.471-0.293 0.049 0.245z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.265 9.914l0.718-0.218 0.073 0.239-0.718 0.218-0.073-0.239z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.734 6.089l-0.718 0.218-0.073-0.239 0.718-0.218 0.073 0.239z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.58 10.796l-0.096-0.231 1.386-0.574 0.096 0.231-1.386 0.574z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.419 5.207l0.096 0.231-1.386 0.574-0.096-0.231 1.386-0.574z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M1.888 11.41l-0.118-0.22 0.661-0.354 0.118 0.22-0.661 0.354z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.116 4.59l0.118 0.22-0.661 0.354-0.118-0.22 0.661-0.354z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.811 14.232l-0.22-0.118 0.354-0.661 0.22 0.118-0.354 0.661z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.189 1.767l0.22 0.118-0.353 0.661-0.22-0.118 0.353-0.661z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.207 14.419l0.574-1.386 0.231 0.096-0.574 1.386-0.231-0.096z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.795 1.58l-0.574 1.386-0.231-0.096 0.574-1.386 0.231 0.096z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.088 14.735l-0.239-0.073 0.218-0.718 0.239 0.073-0.218 0.718z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.912 1.264l0.239 0.073-0.218 0.718-0.239-0.073 0.218-0.718z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M6.757 14.888l-0.245-0.049 0.293-1.471 0.245 0.049-0.293 1.471z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.243 1.109l0.245 0.049-0.293 1.471-0.245-0.049 0.293-1.471z"
    }
  }]
};
exports.safari = safari;
var opera = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M16 8v0 0c0 2.369-1.031 4.5-2.669 5.963-2.053 1-3.966 0.3-4.597-0.137 2.016-0.441 3.537-2.878 3.537-5.825s-1.522-5.384-3.537-5.828c0.634-0.438 2.547-1.137 4.597-0.138 1.637 1.466 2.669 3.597 2.669 5.966v0 0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M5.366 3.491c-0.884 1.044-1.456 2.587-1.494 4.322 0 0.003 0 0.372 0 0.378 0.038 1.731 0.613 3.275 1.497 4.319 1.147 1.491 2.853 2.434 4.759 2.434 1.172 0 2.269-0.356 3.206-0.978-1.419 1.266-3.287 2.034-5.334 2.034-0.128 0-0.256-0.003-0.381-0.009-4.241-0.2-7.619-3.7-7.619-7.991 0-4.419 3.581-8 8-8 0.009 0 0.019 0 0.031 0 2.037 0.006 3.894 0.775 5.303 2.038-0.938-0.622-2.034-0.981-3.206-0.981-1.906 0-3.612 0.944-4.763 2.434z"
    }
  }]
};
exports.opera = opera;
var filePdf = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M13.156 9.211c-0.213-0.21-0.686-0.321-1.406-0.331-0.487-0.005-1.073 0.038-1.69 0.124-0.276-0.159-0.561-0.333-0.784-0.542-0.601-0.561-1.103-1.34-1.415-2.197 0.020-0.080 0.038-0.15 0.054-0.222 0 0 0.339-1.923 0.249-2.573-0.012-0.089-0.020-0.115-0.044-0.184l-0.029-0.076c-0.092-0.212-0.273-0.437-0.556-0.425l-0.171-0.005c-0.316 0-0.573 0.161-0.64 0.403-0.205 0.757 0.007 1.889 0.39 3.355l-0.098 0.239c-0.275 0.67-0.619 1.345-0.923 1.94l-0.040 0.077c-0.32 0.626-0.61 1.157-0.873 1.607l-0.271 0.144c-0.020 0.010-0.485 0.257-0.594 0.323-0.926 0.553-1.539 1.18-1.641 1.678-0.032 0.159-0.008 0.362 0.156 0.456l0.263 0.132c0.114 0.057 0.234 0.086 0.357 0.086 0.659 0 1.425-0.821 2.48-2.662 1.218-0.396 2.604-0.726 3.819-0.908 0.926 0.521 2.065 0.883 2.783 0.883 0.128 0 0.238-0.012 0.327-0.036 0.138-0.037 0.254-0.115 0.325-0.222 0.139-0.21 0.168-0.499 0.13-0.795-0.011-0.088-0.081-0.196-0.157-0.271zM3.307 12.72c0.12-0.329 0.596-0.979 1.3-1.556 0.044-0.036 0.153-0.138 0.253-0.233-0.736 1.174-1.229 1.642-1.553 1.788zM7.476 3.12c0.212 0 0.333 0.534 0.343 1.035s-0.107 0.853-0.252 1.113c-0.12-0.385-0.179-0.992-0.179-1.389 0 0-0.009-0.759 0.088-0.759v0zM6.232 9.961c0.148-0.264 0.301-0.543 0.458-0.839 0.383-0.724 0.624-1.29 0.804-1.755 0.358 0.651 0.804 1.205 1.328 1.649 0.065 0.055 0.135 0.111 0.207 0.166-1.066 0.211-1.987 0.467-2.798 0.779v0zM12.952 9.901c-0.065 0.041-0.251 0.064-0.37 0.064-0.386 0-0.864-0.176-1.533-0.464 0.257-0.019 0.493-0.029 0.705-0.029 0.387 0 0.502-0.002 0.88 0.095s0.383 0.293 0.318 0.333v0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.filePdf = filePdf;
var fileOpenoffice = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M10.785 7.37c-0.948-0.448-2.156-0.538-3.044 0.095 1.080-0.103 2.265 0.076 3.049 0.893 0.75-0.861 1.939-1.022 3.015-0.933-0.898-0.596-2.082-0.516-3.019-0.054v0zM10.401 9.465c-1.068-0.025-2.101 0.362-2.986 0.939-1.675-0.712-3.793-0.58-5.219 0.609 0.411-0.015 0.813-0.116 1.22-0.169 1.487-0.148 3.072 0.221 4.196 1.247 0.465-0.68 1.119-1.223 1.87-1.561 0.986-0.477 2.096-0.526 3.169-0.539-0.651-0.448-1.478-0.531-2.249-0.526z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.fileOpenoffice = fileOpenoffice;
var fileWord = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M9.997 7.436h0.691l-0.797 3.534-1.036-4.969h-1.665l-1.205 4.969-0.903-4.969h-1.741l1.767 7.998h1.701l1.192-4.73 1.066 4.73h1.568l2.025-7.998h-2.663v1.435z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.fileWord = fileWord;
var fileExcel = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M11.61 6h-2.114l-1.496 2.204-1.496-2.204h-2.114l2.534 3.788-2.859 4.212h3.935v-1.431h-0.784l0.784-1.172 1.741 2.603h2.194l-2.859-4.212 2.534-3.788z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.341 3.579c-0.347-0.473-0.831-1.027-1.362-1.558s-1.085-1.015-1.558-1.362c-0.806-0.591-1.197-0.659-1.421-0.659h-7.75c-0.689 0-1.25 0.561-1.25 1.25v13.5c0 0.689 0.561 1.25 1.25 1.25h11.5c0.689 0 1.25-0.561 1.25-1.25v-9.75c0-0.224-0.068-0.615-0.659-1.421v0zM12.271 2.729c0.48 0.48 0.856 0.912 1.134 1.271h-2.406v-2.405c0.359 0.278 0.792 0.654 1.271 1.134v0zM14 14.75c0 0.136-0.114 0.25-0.25 0.25h-11.5c-0.135 0-0.25-0.114-0.25-0.25v-13.5c0-0.135 0.115-0.25 0.25-0.25 0 0 7.749-0 7.75 0v3.5c0 0.276 0.224 0.5 0.5 0.5h3.5v9.75z"
    }
  }]
};
exports.fileExcel = fileExcel;
var libreoffice = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M8.354 0.354c-0.194-0.194-0.579-0.354-0.854-0.354h-6c-0.275 0-0.5 0.225-0.5 0.5v15c0 0.275 0.225 0.5 0.5 0.5h12c0.275 0 0.5-0.225 0.5-0.5v-9c0-0.275-0.159-0.659-0.354-0.854l-5.293-5.293zM13 15h-11v-14h5.487c0.046 0.008 0.131 0.043 0.169 0.070l5.274 5.274c0.027 0.038 0.062 0.123 0.070 0.169v8.487zM13.5 0h-3c-0.275 0-0.341 0.159-0.146 0.354l3.293 3.293c0.194 0.194 0.354 0.129 0.354-0.146v-3c0-0.275-0.225-0.5-0.5-0.5z"
    }
  }]
};
exports.libreoffice = libreoffice;
var htmlFive = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.26 4.71h-6.758l0.161 1.809h6.437l-0.485 5.422-3.623 1.004-3.618-1.004-0.247-2.774h1.773l0.126 1.41 1.967 0.53 0.004-0.001 1.968-0.531 0.204-2.29h-6.121l-0.476-5.341h8.847l-0.158 1.766z"
    }
  }]
};
exports.htmlFive = htmlFive;
var htmlFive2 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M0.946 0l1.284 14.4 5.762 1.6 5.777-1.602 1.286-14.398h-14.108zM12.668 13.482l-4.644 1.287v0.007l-0.012-0.004-0.012 0.004v-0.007l-4.644-1.287-1.098-12.304h11.508l-1.098 12.304zM10.168 8.284l-0.204 2.29-1.972 0.532-1.967-0.53-0.126-1.41h-1.773l0.247 2.774 3.626 1.003 3.615-1.003 0.485-5.422h-6.437l-0.161-1.809h6.758l0.158-1.766h-8.847l0.477 5.341z"
    }
  }]
};
exports.htmlFive2 = htmlFive2;
var css3 = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M2.381 0.758l-0.537 2.686h10.934l-0.342 1.735h-10.94l-0.53 2.686h10.933l-0.61 3.063-4.406 1.46-3.819-1.46 0.261-1.329h-2.686l-0.639 3.224 6.316 2.417 7.281-2.417 2.403-12.066z"
    }
  }]
};
exports.css3 = css3;
var git = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M15.698 7.287l-6.986-6.986c-0.402-0.402-1.055-0.402-1.457 0l-1.623 1.623 1.221 1.221c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5 0 0.232-0.053 0.451-0.146 0.647l2 2c0.196-0.094 0.415-0.146 0.647-0.146 0.828 0 1.5 0.672 1.5 1.5s-0.672 1.5-1.5 1.5-1.5-0.672-1.5-1.5c0-0.232 0.053-0.451 0.146-0.647l-2-2c-0.048 0.023-0.097 0.043-0.147 0.061v4.171c0.583 0.206 1 0.761 1 1.414 0 0.828-0.672 1.5-1.5 1.5s-1.5-0.672-1.5-1.5c0-0.653 0.417-1.208 1-1.414v-4.171c-0.583-0.206-1-0.761-1-1.414 0-0.232 0.053-0.451 0.146-0.647l-1.221-1.221-4.623 4.623c-0.402 0.403-0.402 1.055 0 1.458l6.986 6.986c0.402 0.402 1.054 0.402 1.457 0l6.953-6.953c0.402-0.403 0.402-1.055-0-1.458z"
    }
  }]
};
exports.git = git;
var codepen = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.777 5.751l-7-4.667c-0.168-0.112-0.387-0.112-0.555 0l-7 4.667c-0.139 0.093-0.223 0.249-0.223 0.416v4.667c0 0.167 0.084 0.323 0.223 0.416l7 4.667c0.084 0.056 0.181 0.084 0.277 0.084s0.193-0.028 0.277-0.084l7-4.667c0.139-0.093 0.223-0.249 0.223-0.416v-4.667c0-0.167-0.084-0.323-0.223-0.416zM7.5 10.232l-2.599-1.732 2.599-1.732 2.599 1.732-2.599 1.732zM8 5.899v-3.465l5.599 3.732-2.599 1.732-3-2zM7 5.899l-3 2-2.599-1.732 5.599-3.732v3.465zM3.099 8.5l-2.099 1.399v-2.798l2.099 1.399zM4 9.101l3 2v3.465l-5.599-3.732 2.599-1.732zM8 11.101l3-2 2.599 1.732-5.599 3.732v-3.465zM11.901 8.5l2.099-1.399v2.798l-2.099-1.399z"
    }
  }]
};
exports.codepen = codepen;
var svg = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M14.5 6.5c-0.444 0-0.843 0.193-1.118 0.5h-2.968l2.099-2.099c0.411 0.023 0.83-0.123 1.144-0.437 0.586-0.586 0.586-1.536 0-2.121s-1.536-0.586-2.121 0c-0.314 0.314-0.46 0.733-0.437 1.144l-2.099 2.099v-2.968c0.307-0.275 0.5-0.674 0.5-1.118 0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5c0 0.444 0.193 0.843 0.5 1.118v2.968l-2.099-2.099c0.023-0.411-0.123-0.83-0.437-1.144-0.586-0.586-1.536-0.586-2.121 0s-0.586 1.536 0 2.121c0.314 0.314 0.733 0.46 1.144 0.437l2.099 2.099h-2.968c-0.275-0.307-0.674-0.5-1.118-0.5-0.828 0-1.5 0.672-1.5 1.5s0.672 1.5 1.5 1.5c0.444 0 0.843-0.193 1.118-0.5h2.968l-2.099 2.099c-0.411-0.023-0.83 0.123-1.144 0.437-0.586 0.586-0.586 1.536 0 2.121s1.536 0.586 2.121 0c0.314-0.314 0.46-0.733 0.437-1.144l2.099-2.099v2.968c-0.307 0.275-0.5 0.674-0.5 1.118 0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5c0-0.444-0.193-0.843-0.5-1.118v-2.968l2.099 2.099c-0.023 0.411 0.123 0.83 0.437 1.144 0.586 0.586 1.536 0.586 2.121 0s0.586-1.536 0-2.121c-0.314-0.314-0.733-0.46-1.144-0.437l-2.099-2.099h2.968c0.275 0.307 0.674 0.5 1.118 0.5 0.828 0 1.5-0.672 1.5-1.5s-0.672-1.5-1.5-1.5z"
    }
  }]
};
exports.svg = svg;
var IcoMoon = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#000000",
      "d": "M4.055 8c0-1.022 0.829-1.851 1.851-1.851s1.851 0.829 1.851 1.851c0 1.022-0.829 1.851-1.851 1.851s-1.851-0.829-1.851-1.851zM8 0c-4.418 0-8 3.582-8 8s3.582 8 8 8c4.418 0 8-3.582 8-8s-3.582-8-8-8zM5.928 14.989c-2.406-1.4-4.023-4.005-4.023-6.989s1.617-5.589 4.023-6.989c2.406 1.399 4.025 4.005 4.025 6.989s-1.618 5.589-4.025 6.989z"
    }
  }]
};
exports.IcoMoon = IcoMoon;

/***/ }),
/* 1407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.crop=exports.credit_card=exports.copy_2=exports.copy_1=exports.computer_upload=exports.computer_remove=exports.computer_ok=exports.computer_download=exports.computer_delete=exports.computer_add=exports.compass=exports.command=exports.columns=exports.cog=exports.code=exports.cloud_upload=exports.cloud_ok=exports.cloud_fail=exports.cloud_download=exports.cloud=exports.close=exports.clip=exports.circle_up=exports.circle_stop=exports.circle_skip_previous=exports.circle_skip_next=exports.circle_right=exports.circle_rewind=exports.circle_plus=exports.circle_play=exports.circle_pause=exports.circle_ok=exports.circle_minus=exports.circle_left=exports.circle_fast_forward=exports.circle_down=exports.circle_delete=exports.circle=exports.chart_7_8=exports.chart_5_8=exports.chart_3_8=exports.chart_3_4=exports.chart_1_8=exports.chart_1_4=exports.chart_1_2=exports.chart=exports.cassette=exports.camera=exports.calendar_ok=exports.calendar_add=exports.calendar=exports.bullseye=exports.browser_remove=exports.browser_ok=exports.browser_layout_3=exports.browser_layout_2=exports.browser_layout_1=exports.browser_delete=exports.browser_add=exports.browser=exports.brightness_low=exports.brightness_high=exports.bookmark=exports.book_2=exports.book_1=exports.book=exports.bluetooth=exports.block=exports.bin=exports.bell=exports.behance=exports.battery_full=exports.battery_empty=exports.battery_2_3=exports.battery_1_3=exports.basket_remove=exports.basket_ok=exports.basket_delete=exports.basket_add=exports.basket=exports.bar_graph=exports.bar_chart_3=exports.bar_chart_2=exports.bar_chart_1=exports.arrows_vertical_2=exports.arrows_vertical=exports.arrows_horizontal_2=exports.arrows_horizontal=exports.arrows=exports.arrow_up=exports.arrow_right=exports.arrow_left=exports.arrow_down=exports.arrow_2=exports.arrow_1=exports.appstore=exports.apple=exports.android=exports.alt=exports.alarm=void 0;exports.play=exports.pinterest_2=exports.pinterest_1=exports.pin_zoom_out=exports.pin_zoom_in=exports.pin_2=exports.pin_1=exports.pill=exports.pie_chart=exports.picture=exports.pen_3=exports.pen_2=exports.pen_1=exports.paypal=exports.pause=exports.notepad_remove=exports.notepad_ok=exports.notepad_delete=exports.notepad_add=exports.notepad=exports.music=exports.moustache=exports.more_2=exports.more=exports.minus=exports.microsoft=exports.microphone_off=exports.microphone=exports.map_remove=exports.map_ok=exports.map_delete=exports.map_add=exports.map=exports.mail_outgoing=exports.mail_incoming=exports.mail=exports.magnifying_glass_remove=exports.magnifying_glass_add=exports.magnifying_glass=exports.macbook=exports.logout=exports.login=exports.lock=exports.location=exports.loading=exports.list_2=exports.list=exports.linkedin=exports.link=exports.line_graph_square=exports.line_graph=exports.layers=exports.iphone=exports.ipad=exports.instagram=exports.inbox_out=exports.inbox_in=exports.inbox=exports.image=exports.imac=exports.home=exports.heart=exports.hashtag=exports.grid_2=exports.grid_1=exports.graph_rise=exports.graph_fall=exports.google_plus=exports.globe=exports.frame=exports.foursquare=exports.forrst=exports.font_size_up=exports.font_size_down=exports.following=exports.followers=exports.folder_remove=exports.folder_ok=exports.folder_delete=exports.folder_add=exports.folder=exports.first_aid=exports.fast_forward=exports.facebook_2=exports.facebook_1=exports.equalizer=exports.eject=exports.dropbox=exports.drop=exports.dribbble=exports.download=exports.documents=exports.document_upload=exports.document_remove=exports.document_ok=exports.document_download=exports.document_delete=exports.document_add=exports.documentIcon=exports.diskette=void 0;exports.zoom_out=exports.zoom_in=exports.youtube=exports.windows=exports.wifi_3=exports.wifi_2=exports.wifi_1=exports.warning=exports.volume_up=exports.volume_off=exports.volume_mute=exports.volume_down=exports.volume_3=exports.volume_2=exports.volume_1=exports.voicemail=exports.vimeo=exports.view_off=exports.view=exports.users=exports.user_square=exports.user_remove=exports.user_ok=exports.user_delete=exports.user_circle=exports.user_add=exports.user=exports.upload=exports.unlock=exports.twitter=exports.tumblr=exports.timer=exports.time=exports.tick=exports.text_right=exports.text_left=exports.text_justify=exports.text_center=exports.terminal=exports.target=exports.tags=exports.tag=exports.suitcase=exports.stop=exports.star=exports.square_up=exports.square_right=exports.square_remove=exports.square_ok=exports.square_left=exports.square_down=exports.square_delete=exports.square_dashed=exports.square_add=exports.square=exports.spotify=exports.speech_bubbles=exports.speech_bubble_2=exports.speech_bubble_1=exports.speech_4=exports.speech_3=exports.speech_2=exports.speech_1=exports.slideshow=exports.skype=exports.skip_previous=exports.skip_next=exports.shuffle=exports.shopping_cart_remove=exports.shopping_cart_ok=exports.shopping_cart_delete=exports.shopping_cart_add=exports.shopping_cart=exports.shopping_bag=exports.shop=exports.share_2=exports.share=exports.screen_expand_3=exports.screen_expand_2=exports.screen_expand_1=exports.rss=exports.rewind=exports.resize_6=exports.resize_5=exports.resize_4=exports.resize_3=exports.resize_2=exports.resize_1=exports.repeat_2=exports.repeat_1=exports.repeat=exports.record=exports.progress=exports.printer=exports.presentation=exports.power=exports.polaroids=exports.polaroid=exports.plus=exports.plug=void 0;var alarm={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ALARM_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ALARM"},"children":[{"name":"g","attribs":{"id":"ALARM"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M44,31h-9V18c0-1.657-1.343-3-3-3s-3,1.343-3,3v16c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S45.657,31,44,31z\r\n\t\t\t\t M19.412,4.575C17.37,2.967,14.8,2,12,2C5.373,2,0,7.373,0,14c0,2.8,0.967,5.37,2.575,7.412\r\n\t\t\t\tC5.809,13.862,11.862,7.809,19.412,4.575z M52.251,2c-2.742,0-5.258,0.947-7.257,2.521c7.393,3.167,13.318,9.093,16.484,16.485\r\n\t\t\t\tc1.574-2,2.521-4.516,2.521-7.257C64,7.26,58.74,2,52.251,2z M32,5C15.984,5,3,17.984,3,34c0,7.691,3.015,14.664,7.902,19.855\r\n\t\t\t\tl-4.023,4.023C6.336,58.422,6,59.172,6,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l4.327-4.327\r\n\t\t\t\tC20.144,61.066,25.842,63,32,63c6.17,0,11.878-1.941,16.579-5.227l4.356,4.357C53.473,62.668,54.215,63,55.034,63\r\n\t\t\t\tC56.672,63,58,61.672,58,60.034c0-0.819-0.332-1.562-0.869-2.099l-4.056-4.056C57.977,48.688,61,41.704,61,34\r\n\t\t\t\tC61,17.984,48.016,5,32,5z M32,57C19.297,57,9,46.703,9,34s10.297-23,23-23c12.702,0,23,10.297,23,23S44.703,57,32,57z"},"children":[{"name":"path","attribs":{"d":"M44,31h-9V18c0-1.657-1.343-3-3-3s-3,1.343-3,3v16c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S45.657,31,44,31z\r\n\t\t\t\t M19.412,4.575C17.37,2.967,14.8,2,12,2C5.373,2,0,7.373,0,14c0,2.8,0.967,5.37,2.575,7.412\r\n\t\t\t\tC5.809,13.862,11.862,7.809,19.412,4.575z M52.251,2c-2.742,0-5.258,0.947-7.257,2.521c7.393,3.167,13.318,9.093,16.484,16.485\r\n\t\t\t\tc1.574-2,2.521-4.516,2.521-7.257C64,7.26,58.74,2,52.251,2z M32,5C15.984,5,3,17.984,3,34c0,7.691,3.015,14.664,7.902,19.855\r\n\t\t\t\tl-4.023,4.023C6.336,58.422,6,59.172,6,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l4.327-4.327\r\n\t\t\t\tC20.144,61.066,25.842,63,32,63c6.17,0,11.878-1.941,16.579-5.227l4.356,4.357C53.473,62.668,54.215,63,55.034,63\r\n\t\t\t\tC56.672,63,58,61.672,58,60.034c0-0.819-0.332-1.562-0.869-2.099l-4.056-4.056C57.977,48.688,61,41.704,61,34\r\n\t\t\t\tC61,17.984,48.016,5,32,5z M32,57C19.297,57,9,46.703,9,34s10.297-23,23-23c12.702,0,23,10.297,23,23S44.703,57,32,57z"},"children":[]}]}]}]}]}]}]}]};exports.alarm=alarm;var alt={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ALT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,20h30c1.657,0,3-1.343,3-3s-1.343-3-3-3H31c-1.657,0-3,1.343-3,3\r\n\t\t\tS29.343,20,31,20z M61,44H32.651L14.535,15.395l-0.006,0.004C13.997,14.56,13.066,14,12,14H3c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\th7.349l18.117,28.605l0.006-0.004C29.003,49.44,29.934,50,31,50h30c1.657,0,3-1.343,3-3C64,45.343,62.657,44,61,44z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,20h30c1.657,0,3-1.343,3-3s-1.343-3-3-3H31c-1.657,0-3,1.343-3,3\r\n\t\t\tS29.343,20,31,20z M61,44H32.651L14.535,15.395l-0.006,0.004C13.997,14.56,13.066,14,12,14H3c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\th7.349l18.117,28.605l0.006-0.004C29.003,49.44,29.934,50,31,50h30c1.657,0,3-1.343,3-3C64,45.343,62.657,44,61,44z"},"children":[]}]}]}]}]}]};exports.alt=alt;var android={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"android_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"android"},"children":[{"name":"g","attribs":{"id":"android"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M15.647,47.493c0,2.164,1.709,3.926,3.812,3.926h2.752c-0.092,0.327-0.144,0.673-0.144,1.031v7.848\r\n\t\t\t\tc0,2.052,1.618,3.718,3.612,3.718c1.995,0,3.613-1.666,3.613-3.718V52.45c0-0.358-0.053-0.704-0.144-1.031h6.708\r\n\t\t\t\tc-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.718,3.612,3.718s3.613-1.666,3.613-3.718V52.45\r\n\t\t\t\tc0-0.358-0.053-0.704-0.145-1.031h2.752c2.104,0,3.812-1.761,3.812-3.926v-27.26h-33.71V47.493z M9.626,20.233\r\n\t\t\t\tc-1.995,0-3.612,1.664-3.612,3.717v15.901c0,2.053,1.617,3.717,3.612,3.717c1.994,0,3.612-1.664,3.612-3.717v-15.9\r\n\t\t\t\tC13.238,21.897,11.62,20.233,9.626,20.233z M55.375,20.233c-1.995,0-3.611,1.664-3.611,3.717v15.901\r\n\t\t\t\tc0,2.053,1.616,3.717,3.611,3.717s3.611-1.664,3.611-3.717v-15.9C58.986,21.897,57.37,20.233,55.375,20.233z M40.789,5.355\r\n\t\t\t\tl0.678-1.047l0.668-1.032l1.502-2.318c0.184-0.285,0.108-0.669-0.166-0.859c-0.279-0.191-0.652-0.114-0.837,0.172l-1.608,2.485\r\n\t\t\t\tl-0.678,1.045L39.662,4.86c-2.176-0.868-4.602-1.355-7.162-1.355c-2.559,0-4.986,0.487-7.16,1.354L24.655,3.8l-0.676-1.045\r\n\t\t\t\tL22.367,0.27c-0.184-0.285-0.558-0.362-0.836-0.172c-0.275,0.19-0.351,0.574-0.166,0.859l1.5,2.318l0.669,1.032l0.678,1.047\r\n\t\t\t\tc-5.109,2.449-8.566,7.089-8.566,12.4h33.708C49.355,12.444,45.898,7.804,40.789,5.355z M25.278,12.799\r\n\t\t\t\tc-0.998,0-1.806-0.833-1.806-1.859s0.808-1.857,1.806-1.857c0.997,0,1.806,0.831,1.806,1.857S26.275,12.799,25.278,12.799z\r\n\t\t\t\t M39.725,12.799c-0.998,0-1.806-0.833-1.806-1.859s0.808-1.857,1.806-1.857s1.805,0.831,1.805,1.857S40.723,12.799,39.725,12.799\r\n\t\t\t\tz"},"children":[{"name":"path","attribs":{"d":"M15.647,47.493c0,2.164,1.709,3.926,3.812,3.926h2.752c-0.092,0.327-0.144,0.673-0.144,1.031v7.848\r\n\t\t\t\tc0,2.052,1.618,3.718,3.612,3.718c1.995,0,3.613-1.666,3.613-3.718V52.45c0-0.358-0.053-0.704-0.144-1.031h6.708\r\n\t\t\t\tc-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.718,3.612,3.718s3.613-1.666,3.613-3.718V52.45\r\n\t\t\t\tc0-0.358-0.053-0.704-0.145-1.031h2.752c2.104,0,3.812-1.761,3.812-3.926v-27.26h-33.71V47.493z M9.626,20.233\r\n\t\t\t\tc-1.995,0-3.612,1.664-3.612,3.717v15.901c0,2.053,1.617,3.717,3.612,3.717c1.994,0,3.612-1.664,3.612-3.717v-15.9\r\n\t\t\t\tC13.238,21.897,11.62,20.233,9.626,20.233z M55.375,20.233c-1.995,0-3.611,1.664-3.611,3.717v15.901\r\n\t\t\t\tc0,2.053,1.616,3.717,3.611,3.717s3.611-1.664,3.611-3.717v-15.9C58.986,21.897,57.37,20.233,55.375,20.233z M40.789,5.355\r\n\t\t\t\tl0.678-1.047l0.668-1.032l1.502-2.318c0.184-0.285,0.108-0.669-0.166-0.859c-0.279-0.191-0.652-0.114-0.837,0.172l-1.608,2.485\r\n\t\t\t\tl-0.678,1.045L39.662,4.86c-2.176-0.868-4.602-1.355-7.162-1.355c-2.559,0-4.986,0.487-7.16,1.354L24.655,3.8l-0.676-1.045\r\n\t\t\t\tL22.367,0.27c-0.184-0.285-0.558-0.362-0.836-0.172c-0.275,0.19-0.351,0.574-0.166,0.859l1.5,2.318l0.669,1.032l0.678,1.047\r\n\t\t\t\tc-5.109,2.449-8.566,7.089-8.566,12.4h33.708C49.355,12.444,45.898,7.804,40.789,5.355z M25.278,12.799\r\n\t\t\t\tc-0.998,0-1.806-0.833-1.806-1.859s0.808-1.857,1.806-1.857c0.997,0,1.806,0.831,1.806,1.857S26.275,12.799,25.278,12.799z\r\n\t\t\t\t M39.725,12.799c-0.998,0-1.806-0.833-1.806-1.859s0.808-1.857,1.806-1.857s1.805,0.831,1.805,1.857S40.723,12.799,39.725,12.799\r\n\t\t\t\tz"},"children":[]}]}]}]}]}]}]}]};exports.android=android;var apple={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"apple_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"apple"},"children":[{"name":"g","attribs":{"id":"apple"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M42.111,10.214c2.4-2.709,4.021-6.473,3.58-10.221c-3.459,0.13-7.647,2.14-10.131,4.846\r\n\t\t\t\tc-2.225,2.401-4.17,6.226-3.65,9.906C35.77,15.025,39.708,12.918,42.111,10.214z M50.771,34.008\r\n\t\t\t\tc-0.086-8.109,7.104-11.997,7.427-12.193c-4.041-5.499-10.337-6.254-12.576-6.34c-5.354-0.506-10.451,2.935-13.169,2.935\r\n\t\t\t\tc-2.711,0-6.906-2.861-11.346-2.788c-5.84,0.081-11.222,3.161-14.228,8.028c-6.065,9.793-1.552,24.307,4.359,32.256\r\n\t\t\t\tc2.89,3.886,6.335,8.257,10.855,8.097c4.357-0.16,6.002-2.622,11.267-2.622c5.269,0,6.746,2.622,11.354,2.541\r\n\t\t\t\tc4.685-0.079,7.655-3.959,10.522-7.859c3.318-4.514,4.683-8.886,4.765-9.106C59.896,46.91,50.865,43.689,50.771,34.008z"},"children":[{"name":"path","attribs":{"d":"M42.111,10.214c2.4-2.709,4.021-6.473,3.58-10.221c-3.459,0.13-7.647,2.14-10.131,4.846\r\n\t\t\t\tc-2.225,2.401-4.17,6.226-3.65,9.906C35.77,15.025,39.708,12.918,42.111,10.214z M50.771,34.008\r\n\t\t\t\tc-0.086-8.109,7.104-11.997,7.427-12.193c-4.041-5.499-10.337-6.254-12.576-6.34c-5.354-0.506-10.451,2.935-13.169,2.935\r\n\t\t\t\tc-2.711,0-6.906-2.861-11.346-2.788c-5.84,0.081-11.222,3.161-14.228,8.028c-6.065,9.793-1.552,24.307,4.359,32.256\r\n\t\t\t\tc2.89,3.886,6.335,8.257,10.855,8.097c4.357-0.16,6.002-2.622,11.267-2.622c5.269,0,6.746,2.622,11.354,2.541\r\n\t\t\t\tc4.685-0.079,7.655-3.959,10.522-7.859c3.318-4.514,4.683-8.886,4.765-9.106C59.896,46.91,50.865,43.689,50.771,34.008z"},"children":[]}]}]}]}]}]}]}]};exports.apple=apple;var appstore={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"appstore_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"appstore"},"children":[{"name":"g","attribs":{"id":"appstore"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31.03,28.052L24.522,39.43h17.662c-1.283-2.539-2.981-6.173-5.262-11.376H31.03V28.052z M31.735,21.424\r\n\t\t\t\tc0.405-0.708,0.16-1.618-0.546-2.03l-3.854-2.214c-0.704-0.41-1.615-0.163-2.019,0.545l-5.908,10.328L12.899,39.43l-5.433,9.5\r\n\t\t\t\tc-0.409,0.709-0.16,1.618,0.546,2.023l3.853,2.224c0.705,0.408,1.615,0.161,2.023-0.545l7.55-13.202l4.879-8.532L31.735,21.424z\r\n\t\t\t\t M10.606,54.878l-3.853-2.219c-0.706-0.408-1.358-0.074-1.452,0.735l-0.666,5.824c-0.093,0.811,0.382,1.102,1.054,0.643\r\n\t\t\t\tl4.977-3.406C11.341,55.999,11.312,55.286,10.606,54.878z M16.322,28.052H1.35c-0.74,0-1.339,0.601-1.339,1.343v8.692\r\n\t\t\t\tc0,0.741,0.599,1.343,1.339,1.343h8.464L16.322,28.052z M62.65,28.052H49.643c1.53,2.879,2.948,5.589,3.948,7.505\r\n\t\t\t\tc0.692,1.325,1.239,2.373,1.433,2.723c0.203,0.373,0.347,0.757,0.444,1.15h7.183c0.74,0,1.34-0.602,1.34-1.343v-8.692\r\n\t\t\t\tC63.988,28.654,63.389,28.052,62.65,28.052z M52.677,39.575c-0.022-0.038-0.051-0.093-0.079-0.146\r\n\t\t\t\tc-0.357-0.664-1.255-2.394-2.433-4.639c-0.015-0.031-0.028-0.057-0.043-0.087c-0.09-0.173-0.181-0.347-0.274-0.524\r\n\t\t\t\tc-0.068-0.128-0.135-0.258-0.205-0.388c-0.057-0.112-0.117-0.224-0.175-0.339c-0.104-0.199-0.211-0.396-0.317-0.602\r\n\t\t\t\tc-0.033-0.063-0.065-0.127-0.1-0.19c-0.119-0.229-0.24-0.459-0.363-0.693c-0.035-0.066-0.07-0.132-0.106-0.201\r\n\t\t\t\tc-2.714-5.151-6.123-11.492-8.228-14.827c-3.683-5.844-8.599-15.583-9.971-14.89C28.46,3.011,34.41,15.374,36.38,20.02\r\n\t\t\t\tc1.97,4.644,9.656,22.447,11.197,23.224c1.543,0.773,2.14,0.344,3.169-0.084C51.773,42.729,53.619,41.3,52.677,39.575z\r\n\t\t\t\t M56.504,53.867c-0.577,0.555-1.951,1.763-0.289,4.107c1.657,2.349,5.362,2.453,5.85,4.012\r\n\t\t\t\tC62.064,61.986,63.229,50.061,56.504,53.867z M57.07,48.749l-1.834-3.536c-0.416-0.8-1.393-1.126-2.172-0.727l-2.213,1.145\r\n\t\t\t\tc-0.778,0.405-1.024,1.354-0.545,2.117l2.321,3.682c0.479,0.758,1.491,1.008,2.242,0.553l1.58-0.953\r\n\t\t\t\tC57.205,50.575,57.484,49.549,57.07,48.749z"},"children":[{"name":"path","attribs":{"d":"M31.03,28.052L24.522,39.43h17.662c-1.283-2.539-2.981-6.173-5.262-11.376H31.03V28.052z M31.735,21.424\r\n\t\t\t\tc0.405-0.708,0.16-1.618-0.546-2.03l-3.854-2.214c-0.704-0.41-1.615-0.163-2.019,0.545l-5.908,10.328L12.899,39.43l-5.433,9.5\r\n\t\t\t\tc-0.409,0.709-0.16,1.618,0.546,2.023l3.853,2.224c0.705,0.408,1.615,0.161,2.023-0.545l7.55-13.202l4.879-8.532L31.735,21.424z\r\n\t\t\t\t M10.606,54.878l-3.853-2.219c-0.706-0.408-1.358-0.074-1.452,0.735l-0.666,5.824c-0.093,0.811,0.382,1.102,1.054,0.643\r\n\t\t\t\tl4.977-3.406C11.341,55.999,11.312,55.286,10.606,54.878z M16.322,28.052H1.35c-0.74,0-1.339,0.601-1.339,1.343v8.692\r\n\t\t\t\tc0,0.741,0.599,1.343,1.339,1.343h8.464L16.322,28.052z M62.65,28.052H49.643c1.53,2.879,2.948,5.589,3.948,7.505\r\n\t\t\t\tc0.692,1.325,1.239,2.373,1.433,2.723c0.203,0.373,0.347,0.757,0.444,1.15h7.183c0.74,0,1.34-0.602,1.34-1.343v-8.692\r\n\t\t\t\tC63.988,28.654,63.389,28.052,62.65,28.052z M52.677,39.575c-0.022-0.038-0.051-0.093-0.079-0.146\r\n\t\t\t\tc-0.357-0.664-1.255-2.394-2.433-4.639c-0.015-0.031-0.028-0.057-0.043-0.087c-0.09-0.173-0.181-0.347-0.274-0.524\r\n\t\t\t\tc-0.068-0.128-0.135-0.258-0.205-0.388c-0.057-0.112-0.117-0.224-0.175-0.339c-0.104-0.199-0.211-0.396-0.317-0.602\r\n\t\t\t\tc-0.033-0.063-0.065-0.127-0.1-0.19c-0.119-0.229-0.24-0.459-0.363-0.693c-0.035-0.066-0.07-0.132-0.106-0.201\r\n\t\t\t\tc-2.714-5.151-6.123-11.492-8.228-14.827c-3.683-5.844-8.599-15.583-9.971-14.89C28.46,3.011,34.41,15.374,36.38,20.02\r\n\t\t\t\tc1.97,4.644,9.656,22.447,11.197,23.224c1.543,0.773,2.14,0.344,3.169-0.084C51.773,42.729,53.619,41.3,52.677,39.575z\r\n\t\t\t\t M56.504,53.867c-0.577,0.555-1.951,1.763-0.289,4.107c1.657,2.349,5.362,2.453,5.85,4.012\r\n\t\t\t\tC62.064,61.986,63.229,50.061,56.504,53.867z M57.07,48.749l-1.834-3.536c-0.416-0.8-1.393-1.126-2.172-0.727l-2.213,1.145\r\n\t\t\t\tc-0.778,0.405-1.024,1.354-0.545,2.117l2.321,3.682c0.479,0.758,1.491,1.008,2.242,0.553l1.58-0.953\r\n\t\t\t\tC57.205,50.575,57.484,49.549,57.07,48.749z"},"children":[]}]}]}]}]}]}]}]};exports.appstore=appstore;var arrow_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW_1"},"children":[{"name":"g","attribs":{"id":"ARROW_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.122,42.878l-6.998-7.001c-0.543-0.543-1.293-0.879-2.121-0.879c-1.657,0-2.999,1.343-2.999,3\r\n\t\t\t\tc0,0.829,0.336,1.579,0.879,2.122l1.879,1.879h-1.773v0.005h-3l0,0h-2.756L15.118,10.879C14.575,10.336,13.825,10,12.997,10\r\n\t\t\t\tH2.999C1.343,10,0,11.343,0,13.001c0,1.657,1.343,3,2.999,3h8.755l31.114,31.126c0.543,0.543,1.293,0.879,2.12,0.879h8.767\r\n\t\t\t\tl-1.873,1.874c-0.543,0.543-0.879,1.293-0.879,2.122c0,1.657,1.343,3,2.999,3c0.828,0,1.578-0.336,2.121-0.879l6.998-7.001\r\n\t\t\t\tC63.664,46.578,64,45.828,64,45C64,44.171,63.664,43.421,63.122,42.878z"},"children":[{"name":"path","attribs":{"d":"M63.122,42.878l-6.998-7.001c-0.543-0.543-1.293-0.879-2.121-0.879c-1.657,0-2.999,1.343-2.999,3\r\n\t\t\t\tc0,0.829,0.336,1.579,0.879,2.122l1.879,1.879h-1.773v0.005h-3l0,0h-2.756L15.118,10.879C14.575,10.336,13.825,10,12.997,10\r\n\t\t\t\tH2.999C1.343,10,0,11.343,0,13.001c0,1.657,1.343,3,2.999,3h8.755l31.114,31.126c0.543,0.543,1.293,0.879,2.12,0.879h8.767\r\n\t\t\t\tl-1.873,1.874c-0.543,0.543-0.879,1.293-0.879,2.122c0,1.657,1.343,3,2.999,3c0.828,0,1.578-0.336,2.121-0.879l6.998-7.001\r\n\t\t\t\tC63.664,46.578,64,45.828,64,45C64,44.171,63.664,43.421,63.122,42.878z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_1=arrow_1;var arrow_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW_2"},"children":[{"name":"g","attribs":{"id":"ARROW_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.137,17.884l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879c-1.656,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.768,17H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,49H9l0,0H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h10\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L46.243,23H52v0.005h1.773l-1.879,1.879c-0.543,0.543-0.879,1.293-0.879,2.121\r\n\t\t\t\tc0,1.657,1.342,3,3,3c0.827,0,1.577-0.336,2.12-0.879l7-7c0.544-0.543,0.88-1.293,0.88-2.121S63.68,18.427,63.137,17.884z"},"children":[{"name":"path","attribs":{"d":"M63.137,17.884l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879c-1.656,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.768,17H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,49H9l0,0H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h10\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L46.243,23H52v0.005h1.773l-1.879,1.879c-0.543,0.543-0.879,1.293-0.879,2.121\r\n\t\t\t\tc0,1.657,1.342,3,3,3c0.827,0,1.577-0.336,2.12-0.879l7-7c0.544-0.543,0.88-1.293,0.88-2.121S63.68,18.427,63.137,17.884z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_2=arrow_2;var arrow_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW__x2F__DOWN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__DOWN"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__DOWN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M53,23c0-1.657-1.343-3-3-3c-0.809,0-1.542,0.321-2.082,0.841l-0.001-0.001L31.993,36.764L16.275,21.046\r\n\t\t\t\tC15.725,20.406,14.91,20,14,20c-1.657,0-3,1.343-3,3c0,0.805,0.318,1.536,0.835,2.075l-0.008,0.008l18,18l0.001-0.001\r\n\t\t\t\tC30.374,43.648,31.139,44,31.987,44c0.002,0,0.004,0,0.007,0c0.002,0,0.004,0,0.007,0c0.849,0,1.612-0.352,2.159-0.918\r\n\t\t\t\tl0.001,0.001l18-18l-0.001-0.001C52.68,24.543,53,23.809,53,23z"},"children":[{"name":"path","attribs":{"d":"M53,23c0-1.657-1.343-3-3-3c-0.809,0-1.542,0.321-2.082,0.841l-0.001-0.001L31.993,36.764L16.275,21.046\r\n\t\t\t\tC15.725,20.406,14.91,20,14,20c-1.657,0-3,1.343-3,3c0,0.805,0.318,1.536,0.835,2.075l-0.008,0.008l18,18l0.001-0.001\r\n\t\t\t\tC30.374,43.648,31.139,44,31.987,44c0.002,0,0.004,0,0.007,0c0.002,0,0.004,0,0.007,0c0.849,0,1.612-0.352,2.159-0.918\r\n\t\t\t\tl0.001,0.001l18-18l-0.001-0.001C52.68,24.543,53,23.809,53,23z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_down=arrow_down;var arrow_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW__x2F__LEFT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__LEFT"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__LEFT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43.16,47.917L27.236,31.994l15.718-15.718C43.594,15.725,44,14.91,44,14c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.807,0-1.536,0.318-2.075,0.835l-0.008-0.008l-18,18l0.001,0.001C20.352,30.374,20,31.139,20,31.987c0,0.002,0,0.004,0,0.007\r\n\t\t\t\tc0,0.002,0,0.004,0,0.007c0,0.849,0.352,1.613,0.918,2.159l-0.001,0.001l18,18l0.001-0.001C39.458,52.68,40.191,53,41,53\r\n\t\t\t\tc1.657,0,3-1.343,3-3C44,49.191,43.68,48.458,43.16,47.917L43.16,47.917z"},"children":[{"name":"path","attribs":{"d":"M43.16,47.917L27.236,31.994l15.718-15.718C43.594,15.725,44,14.91,44,14c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.807,0-1.536,0.318-2.075,0.835l-0.008-0.008l-18,18l0.001,0.001C20.352,30.374,20,31.139,20,31.987c0,0.002,0,0.004,0,0.007\r\n\t\t\t\tc0,0.002,0,0.004,0,0.007c0,0.849,0.352,1.613,0.918,2.159l-0.001,0.001l18,18l0.001-0.001C39.458,52.68,40.191,53,41,53\r\n\t\t\t\tc1.657,0,3-1.343,3-3C44,49.191,43.68,48.458,43.16,47.917L43.16,47.917z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_left=arrow_left;var arrow_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M44,31.994c0-0.002,0-0.005,0-0.007c0-0.848-0.352-1.613-0.918-2.159l0.001-0.001l-18-18l-0.008,0.008\r\n\t\t\t\tC24.536,11.318,23.806,11,23,11c-1.657,0-3,1.343-3,3c0,0.91,0.406,1.725,1.046,2.275l15.718,15.718L20.84,47.917l0.001,0.001\r\n\t\t\t\tC20.321,48.458,20,49.191,20,50c0,1.657,1.343,3,3,3c0.809,0,1.542-0.32,2.082-0.841l0.001,0.001l18-18l-0.001-0.001\r\n\t\t\t\tC43.648,33.613,44,32.848,44,32C44,31.998,44,31.996,44,31.994z"},"children":[{"name":"path","attribs":{"d":"M44,31.994c0-0.002,0-0.005,0-0.007c0-0.848-0.352-1.613-0.918-2.159l0.001-0.001l-18-18l-0.008,0.008\r\n\t\t\t\tC24.536,11.318,23.806,11,23,11c-1.657,0-3,1.343-3,3c0,0.91,0.406,1.725,1.046,2.275l15.718,15.718L20.84,47.917l0.001,0.001\r\n\t\t\t\tC20.321,48.458,20,49.191,20,50c0,1.657,1.343,3,3,3c0.809,0,1.542-0.32,2.082-0.841l0.001,0.001l18-18l-0.001-0.001\r\n\t\t\t\tC43.648,33.613,44,32.848,44,32C44,31.998,44,31.996,44,31.994z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_right=arrow_right;var arrow_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROW__x2F__UP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__UP"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__UP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52.159,38.918L52.159,38.918L34.16,20.917l-0.001,0.001C33.613,20.352,32.848,20,32,20c-0.002,0-0.004,0-0.007,0\r\n\t\t\t\ts-0.004,0-0.007,0c-0.848,0-1.613,0.352-2.159,0.918l-0.001-0.001l-18,18l0.008,0.008C11.318,39.464,11,40.195,11,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.91,0,1.725-0.406,2.275-1.046l15.718-15.718L47.917,43.16l0.001-0.001C48.458,43.68,49.191,44,50,44\r\n\t\t\t\tc1.657,0,3-1.343,3-3C53,40.191,52.68,39.458,52.159,38.918z"},"children":[{"name":"path","attribs":{"d":"M52.159,38.918L52.159,38.918L34.16,20.917l-0.001,0.001C33.613,20.352,32.848,20,32,20c-0.002,0-0.004,0-0.007,0\r\n\t\t\t\ts-0.004,0-0.007,0c-0.848,0-1.613,0.352-2.159,0.918l-0.001-0.001l-18,18l0.008,0.008C11.318,39.464,11,40.195,11,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.91,0,1.725-0.406,2.275-1.046l15.718-15.718L47.917,43.16l0.001-0.001C48.458,43.68,49.191,44,50,44\r\n\t\t\t\tc1.657,0,3-1.343,3-3C53,40.191,52.68,39.458,52.159,38.918z"},"children":[]}]}]}]}]}]}]}]};exports.arrow_up=arrow_up;var arrows={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROWS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS"},"children":[{"name":"g","attribs":{"id":"ARROWS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C52.475,20.292,51.771,20,51,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L53.182,29H35V10.818l3.77,4.189l0,0C39.318,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,0.384,32.885,0,32,0s-1.681,0.384-2.23,0.993l0,0l-9,10l0,0\r\n\t\t\t\tC20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3c0.885,0,1.68-0.384,2.23-0.993l0,0L29,10.818V29H10.818l4.189-3.77l0,0\r\n\t\t\t\tC15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3c-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32\r\n\t\t\t\ts0.384,1.68,0.993,2.23l0,0l10,9l0,0C11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.384-1.68-0.993-2.23l0,0\r\n\t\t\t\tL10.818,35H29v18.182l-3.77-4.188l0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.771,0.292,1.475,0.77,2.007l0,0\r\n\t\t\t\tl9,10l0,0C30.319,63.617,31.115,64,32,64s1.682-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.771,44,51\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,53.182V35h18.182l-4.188,3.77l0,0C48.384,39.32,48,40.115,48,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.682,64,32.885,64,32z"},"children":[{"name":"path","attribs":{"d":"M64,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C52.475,20.292,51.771,20,51,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L53.182,29H35V10.818l3.77,4.189l0,0C39.318,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,0.384,32.885,0,32,0s-1.681,0.384-2.23,0.993l0,0l-9,10l0,0\r\n\t\t\t\tC20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3c0.885,0,1.68-0.384,2.23-0.993l0,0L29,10.818V29H10.818l4.189-3.77l0,0\r\n\t\t\t\tC15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3c-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32\r\n\t\t\t\ts0.384,1.68,0.993,2.23l0,0l10,9l0,0C11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.384-1.68-0.993-2.23l0,0\r\n\t\t\t\tL10.818,35H29v18.182l-3.77-4.188l0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.771,0.292,1.475,0.77,2.007l0,0\r\n\t\t\t\tl9,10l0,0C30.319,63.617,31.115,64,32,64s1.682-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.771,44,51\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,53.182V35h18.182l-4.188,3.77l0,0C48.384,39.32,48,40.115,48,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.682,64,32.885,64,32z"},"children":[]}]}]}]}]}]}]}]};exports.arrows=arrows;var arrows_horizontal={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL"},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,22h32l0,0h18.182l-4.188,3.77L49,25.779c-0.609,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.771,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222c0.609-0.549,1-1.337,1-2.222s-0.391-1.673-1-2.222l0.007-0.008l-10-9\r\n\t\t\t\tL53,7.778C52.468,7.3,51.771,7,51,7c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39l0,0H26l0,0\r\n\t\t\t\tH10.818l0,0H3c-1.657,0-3,1.343-3,3S1.343,22,3,22z M61,42h-7.818l0,0H38l0,0H25l0,0H10.818l4.189-3.77L15,38.223\r\n\t\t\t\tc0.61-0.55,1-1.337,1-2.223c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.777l-0.007-0.008l-10,9L1,42.777\r\n\t\t\t\tC0.391,43.328,0,44.115,0,45s0.391,1.672,1,2.223L0.993,47.23l10,9L11,56.223C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.223l0.007-0.008L10.818,48H35l0,0h26c1.657,0,3-1.343,3-3S62.657,42,61,42z"},"children":[{"name":"path","attribs":{"d":"M3,22h32l0,0h18.182l-4.188,3.77L49,25.779c-0.609,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.771,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222c0.609-0.549,1-1.337,1-2.222s-0.391-1.673-1-2.222l0.007-0.008l-10-9\r\n\t\t\t\tL53,7.778C52.468,7.3,51.771,7,51,7c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39l0,0H26l0,0\r\n\t\t\t\tH10.818l0,0H3c-1.657,0-3,1.343-3,3S1.343,22,3,22z M61,42h-7.818l0,0H38l0,0H25l0,0H10.818l4.189-3.77L15,38.223\r\n\t\t\t\tc0.61-0.55,1-1.337,1-2.223c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.777l-0.007-0.008l-10,9L1,42.777\r\n\t\t\t\tC0.391,43.328,0,44.115,0,45s0.391,1.672,1,2.223L0.993,47.23l10,9L11,56.223C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.223l0.007-0.008L10.818,48H35l0,0h26c1.657,0,3-1.343,3-3S62.657,42,61,42z"},"children":[]}]}]}]}]}]}]}]};exports.arrows_horizontal=arrows_horizontal;var arrows_horizontal_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL"},"children":[{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,32c0-0.885-0.384-1.681-0.993-2.23l0,0l-10-9l0,0C52.475,20.292,51.771,20,51,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.383,1.681,0.993,2.23l0,0L53.182,29H10.818l4.189-3.77l0,0C15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32s0.383,1.68,0.993,2.23l0,0l10,9l0,0\r\n\t\t\t\tC11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.383-1.68-0.993-2.23l0,0L10.818,35h42.364l-4.188,3.77l0,0\r\n\t\t\t\tC48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.682,64,32.885,64,32z\r\n\t\t\t\t"},"children":[{"name":"path","attribs":{"d":"M64,32c0-0.885-0.384-1.681-0.993-2.23l0,0l-10-9l0,0C52.475,20.292,51.771,20,51,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.383,1.681,0.993,2.23l0,0L53.182,29H10.818l4.189-3.77l0,0C15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32s0.383,1.68,0.993,2.23l0,0l10,9l0,0\r\n\t\t\t\tC11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.383-1.68-0.993-2.23l0,0L10.818,35h42.364l-4.188,3.77l0,0\r\n\t\t\t\tC48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.682,64,32.885,64,32z\r\n\t\t\t\t"},"children":[]}]}]}]}]}]}]}]};exports.arrows_horizontal_2=arrows_horizontal_2;var arrows_vertical={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL"},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M57,51c0-1.657-1.343-3-3-3c-0.885,0-1.673,0.391-2.223,1l-0.008-0.007L48,53.182V29l0,0V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v7.818l0,0V26l0,0v13l0,0v14.182l-3.77-4.188L38.223,49c-0.55-0.609-1.338-1-2.223-1c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.771,0.3,1.468,0.777,2l-0.008,0.007l9,10L42.777,63c0.55,0.609,1.338,1,2.223,1s1.672-0.391,2.223-1l0.008,0.007l9-10\r\n\t\t\t\tL56.223,53C56.701,52.468,57,51.771,57,51z M30.23,10.993l-9-10L21.222,1C20.673,0.391,19.885,0,19,0s-1.673,0.391-2.222,1.001\r\n\t\t\t\tL16.77,0.993l-9,10L7.778,11C7.3,11.532,7,12.228,7,13c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L16,10.818\r\n\t\t\t\tV25l0,0v13l0,0v15.182l0,0V61c0,1.657,1.343,3,3,3s3-1.343,3-3V29l0,0V10.818l3.77,4.189L25.778,15c0.549,0.61,1.337,1,2.222,1\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.778-2L30.23,10.993z"},"children":[{"name":"path","attribs":{"d":"M57,51c0-1.657-1.343-3-3-3c-0.885,0-1.673,0.391-2.223,1l-0.008-0.007L48,53.182V29l0,0V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v7.818l0,0V26l0,0v13l0,0v14.182l-3.77-4.188L38.223,49c-0.55-0.609-1.338-1-2.223-1c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.771,0.3,1.468,0.777,2l-0.008,0.007l9,10L42.777,63c0.55,0.609,1.338,1,2.223,1s1.672-0.391,2.223-1l0.008,0.007l9-10\r\n\t\t\t\tL56.223,53C56.701,52.468,57,51.771,57,51z M30.23,10.993l-9-10L21.222,1C20.673,0.391,19.885,0,19,0s-1.673,0.391-2.222,1.001\r\n\t\t\t\tL16.77,0.993l-9,10L7.778,11C7.3,11.532,7,12.228,7,13c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L16,10.818\r\n\t\t\t\tV25l0,0v13l0,0v15.182l0,0V61c0,1.657,1.343,3,3,3s3-1.343,3-3V29l0,0V10.818l3.77,4.189L25.778,15c0.549,0.61,1.337,1,2.222,1\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.778-2L30.23,10.993z"},"children":[]}]}]}]}]}]}]}]};exports.arrows_vertical=arrows_vertical;var arrows_vertical_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ARROWS_VERTICAL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS_VERTICAL"},"children":[{"name":"g","attribs":{"id":"ARROWS_VERTICAL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,48c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,53.182V10.818l3.77,4.189l0,0C39.318,15.616,40.115,16,41,16\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,0.384,32.885,0,32,0s-1.681,0.384-2.23,0.993l0,0\r\n\t\t\t\tl-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3c0.885,0,1.681-0.384,2.23-0.993l0,0L29,10.818v42.364l-3.77-4.188\r\n\t\t\t\tl0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.771,0.292,1.475,0.77,2.007l0,0l9,10l0,0\r\n\t\t\t\tC30.319,63.617,31.115,64,32,64s1.682-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.771,44,51C44,49.343,42.657,48,41,48z"},"children":[{"name":"path","attribs":{"d":"M41,48c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,53.182V10.818l3.77,4.189l0,0C39.318,15.616,40.115,16,41,16\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,0.384,32.885,0,32,0s-1.681,0.384-2.23,0.993l0,0\r\n\t\t\t\tl-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3c0.885,0,1.681-0.384,2.23-0.993l0,0L29,10.818v42.364l-3.77-4.188\r\n\t\t\t\tl0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.771,0.292,1.475,0.77,2.007l0,0l9,10l0,0\r\n\t\t\t\tC30.319,63.617,31.115,64,32,64s1.682-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.771,44,51C44,49.343,42.657,48,41,48z"},"children":[]}]}]}]}]}]}]}]};exports.arrows_vertical_2=arrows_vertical_2;var bar_chart_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BAR_CHART_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29,50h6c1.657,0,3-1.343,3-3V22c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\tv25C26,48.657,27.343,50,29,50z M46,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v39\r\n\t\t\tC43,48.657,44.343,50,46,50z M12,50h6c1.657,0,3-1.343,3-3V36c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v11\r\n\t\t\tC9,48.657,10.343,50,12,50z M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59c1.381,0,2.5-1.119,2.5-2.5v-1\r\n\t\t\tC64,54.12,62.881,53,61.5,53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29,50h6c1.657,0,3-1.343,3-3V22c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\tv25C26,48.657,27.343,50,29,50z M46,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v39\r\n\t\t\tC43,48.657,44.343,50,46,50z M12,50h6c1.657,0,3-1.343,3-3V36c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v11\r\n\t\t\tC9,48.657,10.343,50,12,50z M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59c1.381,0,2.5-1.119,2.5-2.5v-1\r\n\t\t\tC64,54.12,62.881,53,61.5,53z"},"children":[]}]}]}]}]}]};exports.bar_chart_1=bar_chart_1;var bar_chart_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BAR_CHART_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59\r\n\t\t\tc1.381,0,2.5-1.119,2.5-2.5v-1C64,54.12,62.881,53,61.5,53z M46,50h6c1.657,0,3-1.343,3-3V20c0-1.657-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.343-3,3v27C43,48.657,44.343,50,46,50z M29,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.343-3,3v39C26,48.657,27.343,50,29,50z M12,50h6c1.657,0,3-1.343,3-3V35c0-1.656-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.344-3,3v12C9,48.657,10.343,50,12,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59\r\n\t\t\tc1.381,0,2.5-1.119,2.5-2.5v-1C64,54.12,62.881,53,61.5,53z M46,50h6c1.657,0,3-1.343,3-3V20c0-1.657-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.343-3,3v27C43,48.657,44.343,50,46,50z M29,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.343-3,3v39C26,48.657,27.343,50,29,50z M12,50h6c1.657,0,3-1.343,3-3V35c0-1.656-1.343-3-3-3h-6\r\n\t\t\tc-1.657,0-3,1.344-3,3v12C9,48.657,10.343,50,12,50z"},"children":[]}]}]}]}]}]};exports.bar_chart_2=bar_chart_2;var bar_chart_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BAR_CHART_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29,50h6c1.657,0,3-1.343,3-3V22c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\tv25C26,48.657,27.343,50,29,50z M46,50h6c1.657,0,3-1.343,3-3V36c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v11\r\n\t\t\tC43,48.657,44.343,50,46,50z M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59c1.381,0,2.5-1.119,2.5-2.5v-1\r\n\t\t\tC64,54.12,62.881,53,61.5,53z M12,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v39\r\n\t\t\tC9,48.657,10.343,50,12,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29,50h6c1.657,0,3-1.343,3-3V22c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\tv25C26,48.657,27.343,50,29,50z M46,50h6c1.657,0,3-1.343,3-3V36c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v11\r\n\t\t\tC43,48.657,44.343,50,46,50z M61.5,53h-59C1.119,53,0,54.12,0,55.5v1C0,57.881,1.119,59,2.5,59h59c1.381,0,2.5-1.119,2.5-2.5v-1\r\n\t\t\tC64,54.12,62.881,53,61.5,53z M12,50h6c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v39\r\n\t\t\tC9,48.657,10.343,50,12,50z"},"children":[]}]}]}]}]}]};exports.bar_chart_3=bar_chart_3;var bar_graph={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BAR_GRAPH_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BAR_GRAPH"},"children":[{"name":"g","attribs":{"id":"BAR_GRAPH"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48,50h6c1.657,0,3-1.343,3-3V26c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21C45,48.657,46.343,50,48,50z M31,50h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V14c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33C28,48.657,29.343,50,31,50z M61,53H6v-7l0,0V8\r\n\t\t\t\tc0-1.657-1.343-3-3-3S0,6.343,0,8v48c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,54.344,62.657,53,61,53z M14,50h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6C11,48.657,12.343,50,14,50z"},"children":[{"name":"path","attribs":{"d":"M48,50h6c1.657,0,3-1.343,3-3V26c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21C45,48.657,46.343,50,48,50z M31,50h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V14c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33C28,48.657,29.343,50,31,50z M61,53H6v-7l0,0V8\r\n\t\t\t\tc0-1.657-1.343-3-3-3S0,6.343,0,8v48c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,54.344,62.657,53,61,53z M14,50h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6C11,48.657,12.343,50,14,50z"},"children":[]}]}]}]}]}]}]}]};exports.bar_graph=bar_graph;var basket={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BASKET_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET"},"children":[{"name":"g","attribs":{"id":"BASKET"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,27.987c0-0.006-0.001-0.012-0.001-0.019c-0.001-0.074-0.005-0.148-0.011-0.221c-0.004-0.042-0.008-0.084-0.014-0.125\r\n\t\t\t\tc-0.004-0.04-0.011-0.08-0.017-0.12c-0.22-1.342-1.327-2.386-2.703-2.502H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.729\r\n\t\t\t\tl0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.404,0,2.576-0.971,2.9-2.275l0.01,0.002\r\n\t\t\t\tL58.342,31H61c1.657,0,3-1.343,3-3c0-0.002,0-0.003,0-0.005C64,27.992,64,27.99,64,27.987z M23,50c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\ts3,1.343,3,3V50z M47,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35.383,9.469L42.018,22\r\n\t\t\t\th6.789L40.686,6.662l-0.011,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469\r\n\t\t\t\tz M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662\r\n\t\t\t\tL15.2,22h6.789L28.623,9.469z"},"children":[{"name":"path","attribs":{"d":"M64,27.987c0-0.006-0.001-0.012-0.001-0.019c-0.001-0.074-0.005-0.148-0.011-0.221c-0.004-0.042-0.008-0.084-0.014-0.125\r\n\t\t\t\tc-0.004-0.04-0.011-0.08-0.017-0.12c-0.22-1.342-1.327-2.386-2.703-2.502H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.729\r\n\t\t\t\tl0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.404,0,2.576-0.971,2.9-2.275l0.01,0.002\r\n\t\t\t\tL58.342,31H61c1.657,0,3-1.343,3-3c0-0.002,0-0.003,0-0.005C64,27.992,64,27.99,64,27.987z M23,50c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\ts3,1.343,3,3V50z M47,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35.383,9.469L42.018,22\r\n\t\t\t\th6.789L40.686,6.662l-0.011,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469\r\n\t\t\t\tz M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662\r\n\t\t\t\tL15.2,22h6.789L28.623,9.469z"},"children":[]}]}]}]}]}]}]}]};exports.basket=basket;var basket_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BASKET__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M51,13\r\n\t\t\t\tc-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z M57,29h-3v3c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3c0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3\r\n\t\t\t\tS58.657,29,57,29z M47,41.477V50c0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26\r\n\t\t\t\tc0-0.338,0.029-0.668,0.051-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59\r\n\t\t\t\tl0,0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z"},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M51,13\r\n\t\t\t\tc-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z M57,29h-3v3c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3c0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3\r\n\t\t\t\tS58.657,29,57,29z M47,41.477V50c0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26\r\n\t\t\t\tc0-0.338,0.029-0.668,0.051-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59\r\n\t\t\t\tl0,0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z"},"children":[]}]}]}]}]}]}]}]};exports.basket_add=basket_add;var basket_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BASKET__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M57.121,27.879C57.664,28.422,58,29.172,58,30c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,30.243l-1.879,1.879\r\n\t\t\t\tC48.578,32.664,47.828,33,47,33c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L46.757,26l-1.879-1.879\r\n\t\t\t\tC44.336,23.578,44,22.828,44,22c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,21.757l1.879-1.879\r\n\t\t\t\tC53.422,19.336,54.172,19,55,19c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,26L57.121,27.879z"},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M57.121,27.879C57.664,28.422,58,29.172,58,30c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,30.243l-1.879,1.879\r\n\t\t\t\tC48.578,32.664,47.828,33,47,33c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L46.757,26l-1.879-1.879\r\n\t\t\t\tC44.336,23.578,44,22.828,44,22c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,21.757l1.879-1.879\r\n\t\t\t\tC53.422,19.336,54.172,19,55,19c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,26L57.121,27.879z"},"children":[]}]}]}]}]}]}]}]};exports.basket_delete=basket_delete;var basket_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BASKET__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__OK"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.012,0.006C40.184,5.683,39.176,5,38,5\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M59.121,25.122l-8,8C50.578,33.664,49.829,34,49,34c-0.828,0-1.578-0.336-2.121-0.879l-4-4C42.336,28.579,42,27.828,42,27\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L49,26.758l5.879-5.879C55.422,20.336,56.172,20,57,20c1.657,0,3,1.343,3,3\r\n\t\t\t\tC60,23.828,59.664,24.579,59.121,25.122z"},"children":[{"name":"path","attribs":{"d":"M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.012,0.006C40.184,5.683,39.176,5,38,5\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M59.121,25.122l-8,8C50.578,33.664,49.829,34,49,34c-0.828,0-1.578-0.336-2.121-0.879l-4-4C42.336,28.579,42,27.828,42,27\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L49,26.758l5.879-5.879C55.422,20.336,56.172,20,57,20c1.657,0,3,1.343,3,3\r\n\t\t\t\tC60,23.828,59.664,24.579,59.121,25.122z"},"children":[]}]}]}]}]}]}]}]};exports.basket_ok=basket_ok;var basket_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.673,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M57,29H45c-1.657,0-3-1.343-3-3s1.343-3,3-3h12c1.657,0,3,1.343,3,3S58.657,29,57,29z"},"children":[{"name":"path","attribs":{"d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.673,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.012,0.006C40.184,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.15,1.028,0.396,1.462L35.383,9.469z M47,41.477V50\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.029-0.668,0.05-1H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h2.658l6.432,25.729l0.009-0.002C12.424,58.029,13.595,59,15,59l0,0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.404,0,2.576-0.971,2.9-2.275l0.01,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.807,47,41.477z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13\r\n\t\t\t\tz M57,29H45c-1.657,0-3-1.343-3-3s1.343-3,3-3h12c1.657,0,3,1.343,3,3S58.657,29,57,29z"},"children":[]}]}]}]}]}]}]}]};exports.basket_remove=basket_remove;var battery_1_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M22,26H9v12h13V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"d":"M22,26H9v12h13V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]}]};exports.battery_1_3=battery_1_3;var battery_2_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M37,26H9v12h28V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"d":"M37,26H9v12h28V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]}]};exports.battery_2_3=battery_2_3;var battery_empty={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]}]};exports.battery_empty=battery_empty;var battery_full={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BATTERY_FULL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY_FULL"},"children":[{"name":"g","attribs":{"id":"BATTERY_FULL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z M52,26H9v12h43V26z"},"children":[{"name":"path","attribs":{"d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z M52,26H9v12h43V26z"},"children":[]}]}]}]}]}]}]}]};exports.battery_full=battery_full;var behance={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"behance_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"behance"},"children":[{"name":"g","attribs":{"id":"behance"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M25.989,30.502c3.455-1.68,5.402-4.417,5.402-8.338c0-7.438-5.12-10.15-12.686-10.15H0.001v40.192h19.255\r\n\t\t\t\tc7.179,0,14.027-3.472,14.027-11.584C33.284,35.646,30.836,31.901,25.989,30.502z M7.991,18.774h8.18\r\n\t\t\t\tc3.115,0,6.01,0.786,6.01,4.591c0,3.352-2.283,4.749-5.343,4.749H7.991V18.774z M17.338,45.062H7.991V34.098h9.513\r\n\t\t\t\tc3.73,0,6.288,1.625,6.288,5.707C23.792,43.947,20.789,45.062,17.338,45.062z M57.973,15.993H42.027v4.072h15.943v-4.072H57.973z\r\n\t\t\t\t M50.05,22.502c-8.735,0-14.692,6.601-14.692,15.273c0,8.947,5.621,15.211,14.692,15.211c6.515,0,10.62-1.965,12.843-8.789\r\n\t\t\t\th-6.328c-0.502,1.793-3.064,2.806-6.238,2.806c-4.395,0-6.844-1.854-7.064-6.892h20.756\r\n\t\t\t\tC64.574,31.219,59.843,22.502,50.05,22.502z M43.262,34.198c0.109-2.234,1.557-5.709,6.563-5.709\r\n\t\t\t\tc3.839,0,5.567,1.684,6.293,5.709H43.262z"},"children":[{"name":"path","attribs":{"d":"M25.989,30.502c3.455-1.68,5.402-4.417,5.402-8.338c0-7.438-5.12-10.15-12.686-10.15H0.001v40.192h19.255\r\n\t\t\t\tc7.179,0,14.027-3.472,14.027-11.584C33.284,35.646,30.836,31.901,25.989,30.502z M7.991,18.774h8.18\r\n\t\t\t\tc3.115,0,6.01,0.786,6.01,4.591c0,3.352-2.283,4.749-5.343,4.749H7.991V18.774z M17.338,45.062H7.991V34.098h9.513\r\n\t\t\t\tc3.73,0,6.288,1.625,6.288,5.707C23.792,43.947,20.789,45.062,17.338,45.062z M57.973,15.993H42.027v4.072h15.943v-4.072H57.973z\r\n\t\t\t\t M50.05,22.502c-8.735,0-14.692,6.601-14.692,15.273c0,8.947,5.621,15.211,14.692,15.211c6.515,0,10.62-1.965,12.843-8.789\r\n\t\t\t\th-6.328c-0.502,1.793-3.064,2.806-6.238,2.806c-4.395,0-6.844-1.854-7.064-6.892h20.756\r\n\t\t\t\tC64.574,31.219,59.843,22.502,50.05,22.502z M43.262,34.198c0.109-2.234,1.557-5.709,6.563-5.709\r\n\t\t\t\tc3.839,0,5.567,1.684,6.293,5.709H43.262z"},"children":[]}]}]}]}]}]}]}]};exports.behance=behance;var bell={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BELL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BELL"},"children":[{"name":"g","attribs":{"id":"BELL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52,45c-1.657,0-3-1.343-3-3V22c0-7.732-6.268-14-14-14c0-1.657-1.343-3-3-3s-3,1.343-3,3c-7.732,0-14,6.268-14,14v20\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S53.657,45,52,45z M32,60c3.314,0,6-2.686,6-6H26\r\n\t\t\t\tC26,57.314,28.686,60,32,60z"},"children":[{"name":"path","attribs":{"d":"M52,45c-1.657,0-3-1.343-3-3V22c0-7.732-6.268-14-14-14c0-1.657-1.343-3-3-3s-3,1.343-3,3c-7.732,0-14,6.268-14,14v20\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S53.657,45,52,45z M32,60c3.314,0,6-2.686,6-6H26\r\n\t\t\t\tC26,57.314,28.686,60,32,60z"},"children":[]}]}]}]}]}]}]}]};exports.bell=bell;var bin={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BIN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BIN"},"children":[{"name":"g","attribs":{"id":"BIN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M53,9H38V6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v3H11c-1.657,0-3,1.343-3,3v3h48v-3C56,10.343,54.657,9,53,9z\r\n\t\t\t\t M11,58c0,1.657,1.343,3,3,3h36c1.657,0,3-1.343,3-3V18H11V58z M41,27c0-1.657,1.343-3,3-3s3,1.343,3,3v25c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3V27z M29,27c0-1.657,1.343-3,3-3s3,1.343,3,3v25c0,1.657-1.343,3-3,3s-3-1.343-3-3V27z M17,27c0-1.657,1.343-3,3-3\r\n\t\t\t\ts3,1.343,3,3v25c0,1.657-1.343,3-3,3s-3-1.343-3-3V27z"},"children":[{"name":"path","attribs":{"d":"M53,9H38V6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v3H11c-1.657,0-3,1.343-3,3v3h48v-3C56,10.343,54.657,9,53,9z\r\n\t\t\t\t M11,58c0,1.657,1.343,3,3,3h36c1.657,0,3-1.343,3-3V18H11V58z M41,27c0-1.657,1.343-3,3-3s3,1.343,3,3v25c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3V27z M29,27c0-1.657,1.343-3,3-3s3,1.343,3,3v25c0,1.657-1.343,3-3,3s-3-1.343-3-3V27z M17,27c0-1.657,1.343-3,3-3\r\n\t\t\t\ts3,1.343,3,3v25c0,1.657-1.343,3-3,3s-3-1.343-3-3V27z"},"children":[]}]}]}]}]}]}]}]};exports.bin=bin;var block={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BLOCK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BLOCK"},"children":[{"name":"g","attribs":{"id":"BLOCK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tc0-6.098,2.115-11.694,5.63-16.128L48.128,52.37C43.693,55.886,38.098,58,32,58z M52.37,48.128L15.873,11.63\r\n\t\t\t\tC20.307,8.115,25.902,6,32,6c14.359,0,26,11.641,26,26C58,38.098,55.887,43.693,52.37,48.128z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tc0-6.098,2.115-11.694,5.63-16.128L48.128,52.37C43.693,55.886,38.098,58,32,58z M52.37,48.128L15.873,11.63\r\n\t\t\t\tC20.307,8.115,25.902,6,32,6c14.359,0,26,11.641,26,26C58,38.098,55.887,43.693,52.37,48.128z"},"children":[]}]}]}]}]}]}]}]};exports.block=block;var bluetooth={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BLUETOOTH"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.243,32l11.879-11.879C49.664,19.578,50,18.829,50,18\r\n\t\t\tc0-0.829-0.336-1.578-0.879-2.121l-15-15C33.578,0.336,32.828,0,32,0c-1.657,0-3,1.343-3,3v20.758l-9.879-9.879\r\n\t\t\tC18.579,13.336,17.828,13,17,13c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L28.758,32L14.879,45.879\r\n\t\t\tC14.336,46.422,14,47.172,14,48c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L29,40.243V61c0,1.657,1.343,3,3,3\r\n\t\t\tc0.828,0,1.578-0.336,2.121-0.879l15-15C49.664,47.579,50,46.829,50,46c0-0.828-0.336-1.578-0.879-2.121L37.243,32z M35,10.243\r\n\t\t\tL42.757,18L35,25.757V10.243z M35,53.757V38.243L42.757,46L35,53.757z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37.243,32l11.879-11.879C49.664,19.578,50,18.829,50,18\r\n\t\t\tc0-0.829-0.336-1.578-0.879-2.121l-15-15C33.578,0.336,32.828,0,32,0c-1.657,0-3,1.343-3,3v20.758l-9.879-9.879\r\n\t\t\tC18.579,13.336,17.828,13,17,13c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L28.758,32L14.879,45.879\r\n\t\t\tC14.336,46.422,14,47.172,14,48c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L29,40.243V61c0,1.657,1.343,3,3,3\r\n\t\t\tc0.828,0,1.578-0.336,2.121-0.879l15-15C49.664,47.579,50,46.829,50,46c0-0.828-0.336-1.578-0.879-2.121L37.243,32z M35,10.243\r\n\t\t\tL42.757,18L35,25.757V10.243z M35,53.757V38.243L42.757,46L35,53.757z"},"children":[]}]}]}]}]}]};exports.bluetooth=bluetooth;var book={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BOOK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK"},"children":[{"name":"g","attribs":{"id":"BOOK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M10,18h8c1.657,0,3-1.343,3-3s-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,18,10,18z M10,35h8c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,35,10,35z M54,3h-3v58h3c1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M13,6v3h5\r\n\t\t\t\tc3.314,0,6,2.686,6,6s-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6c0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6s-2.686,6-6,6h-5\r\n\t\t\t\tv3c0,1.657,1.343,3,3,3h32V3H16C14.343,3,13,4.343,13,6z M21,49c0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3s1.343,3,3,3h8\r\n\t\t\t\tC19.657,52,21,50.657,21,49z"},"children":[{"name":"path","attribs":{"d":"M10,18h8c1.657,0,3-1.343,3-3s-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,18,10,18z M10,35h8c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,35,10,35z M54,3h-3v58h3c1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M13,6v3h5\r\n\t\t\t\tc3.314,0,6,2.686,6,6s-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6c0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6s-2.686,6-6,6h-5\r\n\t\t\t\tv3c0,1.657,1.343,3,3,3h32V3H16C14.343,3,13,4.343,13,6z M21,49c0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3s1.343,3,3,3h8\r\n\t\t\t\tC19.657,52,21,50.657,21,49z"},"children":[]}]}]}]}]}]}]}]};exports.book=book;var book_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BOOK_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK_1"},"children":[{"name":"g","attribs":{"id":"BOOK_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,0c-0.406,0-0.794,0.082-1.146,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.779l28.942,11.977C31.177,63.913,31.578,64,32,64s0.823-0.087,1.188-0.245l28.941-11.976\r\n\t\t\t\tC63.227,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z"},"children":[{"name":"path","attribs":{"d":"M61,0c-0.406,0-0.794,0.082-1.146,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.779l28.942,11.977C31.177,63.913,31.578,64,32,64s0.823-0.087,1.188-0.245l28.941-11.976\r\n\t\t\t\tC63.227,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z"},"children":[]}]}]}]}]}]}]}]};exports.book_1=book_1;var book_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BOOK_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK_2"},"children":[{"name":"g","attribs":{"id":"BOOK_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M10.759,32.73L10.759,32.73l11,5l0,0C22.137,37.902,22.557,38,23,38c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5l0,0C12.863,27.097,12.443,27,12,27c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,31.214,9.721,32.259,10.759,32.73z M10.759,43.73L10.759,43.73l11,5l0,0C22.137,48.902,22.557,49,23,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.73l0,0l-11-5l0,0C12.863,38.098,12.443,38,12,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,42.214,9.721,43.259,10.759,43.73z M10.759,21.731L10.759,21.731l11,5l0,0C22.137,26.903,22.557,27,23,27c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5l0,0C12.863,16.097,12.443,16,12,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,20.214,9.721,21.259,10.759,21.731z M41,49c0.443,0,0.863-0.098,1.241-0.27l0,0l11-5l0,0C54.279,43.259,55,42.214,55,41\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.443,0-0.863,0.098-1.241,0.27l0,0l-11,5l0,0C38.721,43.741,38,44.786,38,46C38,47.657,39.343,49,41,49z\r\n\t\t\t\t M61,0c-0.406,0-0.794,0.082-1.146,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.779l28.942,11.977C31.177,63.913,31.578,64,32,64s0.823-0.087,1.188-0.245l28.941-11.976\r\n\t\t\t\tC63.227,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z M41,38c0.443,0,0.863-0.098,1.241-0.27l0,0l11-5C54.279,32.259,55,31.214,55,30c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5l0,0C38.721,32.741,38,33.786,38,35C38,36.657,39.343,38,41,38z M41,27\r\n\t\t\t\tc0.443,0,0.863-0.097,1.241-0.269l0,0l11-5l0,0C54.279,21.259,55,20.214,55,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5C38.721,21.741,38,22.786,38,24C38,25.657,39.343,27,41,27z"},"children":[{"name":"path","attribs":{"d":"M10.759,32.73L10.759,32.73l11,5l0,0C22.137,37.902,22.557,38,23,38c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5l0,0C12.863,27.097,12.443,27,12,27c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,31.214,9.721,32.259,10.759,32.73z M10.759,43.73L10.759,43.73l11,5l0,0C22.137,48.902,22.557,49,23,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.73l0,0l-11-5l0,0C12.863,38.098,12.443,38,12,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,42.214,9.721,43.259,10.759,43.73z M10.759,21.731L10.759,21.731l11,5l0,0C22.137,26.903,22.557,27,23,27c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5l0,0C12.863,16.097,12.443,16,12,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,20.214,9.721,21.259,10.759,21.731z M41,49c0.443,0,0.863-0.098,1.241-0.27l0,0l11-5l0,0C54.279,43.259,55,42.214,55,41\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.443,0-0.863,0.098-1.241,0.27l0,0l-11,5l0,0C38.721,43.741,38,44.786,38,46C38,47.657,39.343,49,41,49z\r\n\t\t\t\t M61,0c-0.406,0-0.794,0.082-1.146,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.779l28.942,11.977C31.177,63.913,31.578,64,32,64s0.823-0.087,1.188-0.245l28.941-11.976\r\n\t\t\t\tC63.227,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z M41,38c0.443,0,0.863-0.098,1.241-0.27l0,0l11-5C54.279,32.259,55,31.214,55,30c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5l0,0C38.721,32.741,38,33.786,38,35C38,36.657,39.343,38,41,38z M41,27\r\n\t\t\t\tc0.443,0,0.863-0.097,1.241-0.269l0,0l11-5l0,0C54.279,21.259,55,20.214,55,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5C38.721,21.741,38,22.786,38,24C38,25.657,39.343,27,41,27z"},"children":[]}]}]}]}]}]}]}]};exports.book_2=book_2;var bookmark={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BOOKMARK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOKMARK"},"children":[{"name":"g","attribs":{"id":"BOOKMARK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,5H23c-1.657,0-3,1.343-3,3v51l12-12l12,12V8C44,6.343,42.657,5,41,5z"},"children":[{"name":"path","attribs":{"d":"M41,5H23c-1.657,0-3,1.343-3,3v51l12-12l12,12V8C44,6.343,42.657,5,41,5z"},"children":[]}]}]}]}]}]}]}]};exports.bookmark=bookmark;var brightness_high={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH"},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M14.879,19.121l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.887-2.113\r\n\t\t\t\tl0.009-0.009l-1.556-1.556l-5.445-5.445C11.578,7.336,10.828,7,10,7c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL14.879,19.121z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l1.555-1.556l5.444-5.444C56.664,11.578,57,10.828,57,10\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-5.443,5.445l-1.557,1.556l0.01,0.009C44.342,15.427,44,16.17,44,17\r\n\t\t\t\tC44,18.657,45.343,20,47,20z M32,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C29,12.657,30.343,14,32,14z\r\n\t\t\t\t M14,32c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h8C12.657,35,14,33.657,14,32z M50.677,46.434l-1.555-1.556\r\n\t\t\t\tC48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.557,1.556l5.443,5.444\r\n\t\t\t\tC52.422,56.664,53.172,57,54,57c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L50.677,46.434z M17,44\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C7.336,52.422,7,53.172,7,54c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl5.445-5.444l1.556-1.556C19.664,48.579,20,47.828,20,47C20,45.343,18.657,44,17,44z M61,29h-8c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\th8c1.657,0,3-1.343,3-3S62.657,29,61,29z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M32,50c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-8C35,51.343,33.657,50,32,50z"},"children":[{"name":"path","attribs":{"d":"M14.879,19.121l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.887-2.113\r\n\t\t\t\tl0.009-0.009l-1.556-1.556l-5.445-5.445C11.578,7.336,10.828,7,10,7c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL14.879,19.121z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l1.555-1.556l5.444-5.444C56.664,11.578,57,10.828,57,10\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-5.443,5.445l-1.557,1.556l0.01,0.009C44.342,15.427,44,16.17,44,17\r\n\t\t\t\tC44,18.657,45.343,20,47,20z M32,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C29,12.657,30.343,14,32,14z\r\n\t\t\t\t M14,32c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h8C12.657,35,14,33.657,14,32z M50.677,46.434l-1.555-1.556\r\n\t\t\t\tC48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.557,1.556l5.443,5.444\r\n\t\t\t\tC52.422,56.664,53.172,57,54,57c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L50.677,46.434z M17,44\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C7.336,52.422,7,53.172,7,54c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl5.445-5.444l1.556-1.556C19.664,48.579,20,47.828,20,47C20,45.343,18.657,44,17,44z M61,29h-8c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\th8c1.657,0,3-1.343,3-3S62.657,29,61,29z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M32,50c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-8C35,51.343,33.657,50,32,50z"},"children":[]}]}]}]}]}]}]}]};exports.brightness_high=brightness_high;var brightness_low={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW"},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M12.879,17.122l2,2l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.888-2.113\r\n\t\t\t\tl0.009-0.009l-2-2l-0.009,0.009C16.573,12.341,15.83,12,15,12c-1.657,0-3,1.343-3,3c0,0.83,0.341,1.573,0.888,2.112\r\n\t\t\t\tL12.879,17.122z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l2-2l-0.009-0.009C51.659,16.573,52,15.83,52,15\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.83,0-1.573,0.341-2.113,0.888l-0.009-0.009l-2,2l0.009,0.009C44.342,15.427,44,16.17,44,17\r\n\t\t\t\tC44,18.657,45.343,20,47,20z M14,32c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3s1.343,3,3,3h2C12.657,35,14,33.657,14,32z\r\n\t\t\t\t M32,14c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3s-3,1.343-3,3v2C29,12.657,30.343,14,32,14z M32,20c-6.627,0-12,5.373-12,12\r\n\t\t\t\tc0,1.021,0.141,2.007,0.381,2.953l1.183,2.958C23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z\r\n\t\t\t\t M32,38c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M49.121,44.879\r\n\t\t\t\tC48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l2,2C47.422,51.664,48.172,52,49,52\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-2,2\r\n\t\t\t\tC12.336,47.422,12,48.172,12,49c0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879l2-2C19.664,48.579,20,47.828,20,47\r\n\t\t\t\tC20,45.343,18.657,44,17,44z M55,29h-2c-1.657,0-3,1.343-3,3s1.343,3,3,3h2c1.657,0,3-1.343,3-3S56.657,29,55,29z M32,50\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v2c0,1.657,1.343,3,3,3s3-1.343,3-3v-2C35,51.343,33.657,50,32,50z"},"children":[{"name":"path","attribs":{"d":"M12.879,17.122l2,2l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.888-2.113\r\n\t\t\t\tl0.009-0.009l-2-2l-0.009,0.009C16.573,12.341,15.83,12,15,12c-1.657,0-3,1.343-3,3c0,0.83,0.341,1.573,0.888,2.112\r\n\t\t\t\tL12.879,17.122z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l2-2l-0.009-0.009C51.659,16.573,52,15.83,52,15\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.83,0-1.573,0.341-2.113,0.888l-0.009-0.009l-2,2l0.009,0.009C44.342,15.427,44,16.17,44,17\r\n\t\t\t\tC44,18.657,45.343,20,47,20z M14,32c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3s1.343,3,3,3h2C12.657,35,14,33.657,14,32z\r\n\t\t\t\t M32,14c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3s-3,1.343-3,3v2C29,12.657,30.343,14,32,14z M32,20c-6.627,0-12,5.373-12,12\r\n\t\t\t\tc0,1.021,0.141,2.007,0.381,2.953l1.183,2.958C23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z\r\n\t\t\t\t M32,38c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M49.121,44.879\r\n\t\t\t\tC48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l2,2C47.422,51.664,48.172,52,49,52\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-2,2\r\n\t\t\t\tC12.336,47.422,12,48.172,12,49c0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879l2-2C19.664,48.579,20,47.828,20,47\r\n\t\t\t\tC20,45.343,18.657,44,17,44z M55,29h-2c-1.657,0-3,1.343-3,3s1.343,3,3,3h2c1.657,0,3-1.343,3-3S56.657,29,55,29z M32,50\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v2c0,1.657,1.343,3,3,3s3-1.343,3-3v-2C35,51.343,33.657,50,32,50z"},"children":[]}]}]}]}]}]}]}]};exports.brightness_low=brightness_low;var browser={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER"},"children":[{"name":"g","attribs":{"id":"BROWSER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]}]};exports.browser=browser;var browser_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z M22,40h7v7\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7v-7c0-1.657-1.343-3-3-3s-3,1.343-3,3v7h-7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3S20.343,40,22,40z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z M22,40h7v7\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7v-7c0-1.657-1.343-3-3-3s-3,1.343-3,3v7h-7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3S20.343,40,22,40z"},"children":[]}]}]}]}]}]}]}]};exports.browser_add=browser_add;var browser_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z M27.758,37l-4.95,4.95\r\n\t\t\t\tc-1.172,1.172-1.172,3.071,0,4.243s3.071,1.172,4.243,0l4.95-4.95l4.95,4.95c1.172,1.172,3.07,1.172,4.242,0\r\n\t\t\t\tc1.173-1.172,1.172-3.071,0-4.243L36.243,37l4.95-4.95c1.172-1.172,1.172-3.071,0-4.243c-1.172-1.172-3.071-1.172-4.243,0\r\n\t\t\t\tL32,32.758l-4.95-4.95c-1.171-1.171-3.071-1.172-4.243,0c-1.171,1.172-1.171,3.071,0,4.243L27.758,37z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z M27.758,37l-4.95,4.95\r\n\t\t\t\tc-1.172,1.172-1.172,3.071,0,4.243s3.071,1.172,4.243,0l4.95-4.95l4.95,4.95c1.172,1.172,3.07,1.172,4.242,0\r\n\t\t\t\tc1.173-1.172,1.172-3.071,0-4.243L36.243,37l4.95-4.95c1.172-1.172,1.172-3.071,0-4.243c-1.172-1.172-3.071-1.172-4.243,0\r\n\t\t\t\tL32,32.758l-4.95-4.95c-1.171-1.171-3.071-1.172-4.243,0c-1.171,1.172-1.171,3.071,0,4.243L27.758,37z"},"children":[]}]}]}]}]}]}]}]};exports.browser_delete=browser_delete;var browser_layout_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M61,57H18V31h43V57z\r\n\t\t\t\t M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M61,57H18V31h43V57z\r\n\t\t\t\t M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]}]};exports.browser_layout_1=browser_layout_1;var browser_layout_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M46,57H3V31h43V57z M61,57H49V31h12V57z\r\n\t\t\t\t M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M46,57H3V31h43V57z M61,57H49V31h12V57z\r\n\t\t\t\t M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]}]};exports.browser_layout_2=browser_layout_2;var browser_layout_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M46,57H18V31h28V57z\r\n\t\t\t\t M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3\r\n\t\t\t\tS13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M46,57H18V31h28V57z\r\n\t\t\t\t M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]}]};exports.browser_layout_3=browser_layout_3;var browser_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__OK"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26.879,45.121C27.422,45.664,28.172,46,29,46s1.578-0.336,2.121-0.879l12-12C43.664,32.579,44,31.828,44,31\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,38.757l-3.879-3.878C24.579,34.336,23.828,34,23,34\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,45.121z M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"d":"M26.879,45.121C27.422,45.664,28.172,46,29,46s1.578-0.336,2.121-0.879l12-12C43.664,32.579,44,31.828,44,31\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,38.757l-3.879-3.878C24.579,34.336,23.828,34,23,34\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,45.121z M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]}]};exports.browser_ok=browser_ok;var browser_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M22,40h4l0,0h16l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7l0,0h-6l0,0h-7c-1.657,0-3,1.343-3,3S20.343,40,22,40z M61,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"d":"M22,40h4l0,0h16l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7l0,0h-6l0,0h-7c-1.657,0-3,1.343-3,3S20.343,40,22,40z M61,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]}]};exports.browser_remove=browser_remove;var bullseye={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"BULLSEYE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6\r\n\t\t\tC38,28.687,35.314,26,32,26z M32,13c-10.493,0-19,8.506-19,19c0,10.493,8.507,19,19,19c10.493,0,19-8.507,19-19\r\n\t\t\tC51,21.507,42.493,13,32,13z M32,45c-7.18,0-13-5.821-13-13c0-7.18,5.82-13,13-13c7.18,0,13,5.82,13,13C45,39.18,39.18,45,32,45z\r\n\t\t\t M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58\r\n\t\t\tC17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6\r\n\t\t\tC38,28.687,35.314,26,32,26z M32,13c-10.493,0-19,8.506-19,19c0,10.493,8.507,19,19,19c10.493,0,19-8.507,19-19\r\n\t\t\tC51,21.507,42.493,13,32,13z M32,45c-7.18,0-13-5.821-13-13c0-7.18,5.82-13,13-13c7.18,0,13,5.82,13,13C45,39.18,39.18,45,32,45z\r\n\t\t\t M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58\r\n\t\t\tC17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[]}]}]}]}]}]};exports.bullseye=bullseye;var calendar={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CALENDAR_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR"},"children":[{"name":"g","attribs":{"id":"CALENDAR"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M61,8h-6v3\r\n\t\t\t\tc0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.361,39.632c-0.373,0.347-0.785,0.663-1.235,0.949\r\n\t\t\t\tc-0.451,0.286-0.875,0.567-1.274,0.845c-0.78,0.538-1.521,1.066-2.223,1.586c-0.702,0.521-1.313,1.088-1.833,1.703\r\n\t\t\t\ts-0.932,1.312-1.235,2.094c-0.304,0.779-0.455,1.698-0.455,2.756H31.47v-3.172h-8.606c0.451-0.625,0.97-1.17,1.56-1.639\r\n\t\t\t\tc0.589-0.468,1.196-0.904,1.82-1.312c0.624-0.407,1.244-0.819,1.859-1.235c0.615-0.416,1.166-0.88,1.651-1.392\r\n\t\t\t\tc0.485-0.51,0.875-1.096,1.17-1.754c0.294-0.66,0.442-1.447,0.442-2.367c0-0.883-0.169-1.68-0.507-2.392\r\n\t\t\t\tc-0.338-0.71-0.793-1.308-1.365-1.794c-0.572-0.485-1.235-0.858-1.989-1.118C26.751,31.13,25.958,31,25.126,31\r\n\t\t\t\tc-1.092,0-2.058,0.187-2.899,0.559c-0.841,0.373-1.539,0.893-2.093,1.56c-0.555,0.667-0.971,1.447-1.248,2.34\r\n\t\t\t\tc-0.277,0.893-0.399,1.859-0.364,2.898h3.536c0-0.484,0.048-0.975,0.143-1.469c0.095-0.494,0.255-0.945,0.481-1.352\r\n\t\t\t\tc0.225-0.407,0.524-0.737,0.897-0.988s0.828-0.377,1.365-0.377c0.797,0,1.452,0.247,1.963,0.741\r\n\t\t\t\tc0.511,0.494,0.767,1.183,0.767,2.067c0,0.555-0.126,1.049-0.377,1.481C27.045,38.895,26.733,39.285,26.361,39.632z\r\n\t\t\t\t M41.467,45.807c-0.269,0.321-0.598,0.582-0.988,0.78c-0.39,0.199-0.828,0.299-1.312,0.299c-0.832,0-1.518-0.247-2.055-0.741\r\n\t\t\t\tc-0.536-0.494-0.85-1.156-0.936-1.988h-3.692c0.017,0.953,0.211,1.789,0.584,2.509c0.373,0.719,0.871,1.321,1.496,1.808\r\n\t\t\t\tc0.623,0.484,1.338,0.844,2.145,1.078s1.65,0.352,2.535,0.352c0.919,0.017,1.785-0.135,2.6-0.455\r\n\t\t\t\tc0.815-0.321,1.529-0.776,2.145-1.365s1.105-1.287,1.47-2.094c0.364-0.805,0.546-1.676,0.546-2.612\r\n\t\t\t\tc0-0.849-0.126-1.651-0.377-2.405c-0.252-0.754-0.615-1.408-1.092-1.963s-1.062-0.997-1.756-1.326\r\n\t\t\t\tc-0.692-0.328-1.49-0.494-2.391-0.494c-0.729,0-1.379,0.109-1.951,0.326c-0.571,0.217-1.108,0.575-1.611,1.078l-0.053-0.052\r\n\t\t\t\tl0.729-4.134h7.514v-3.042H34.85l-1.793,10.062h3.327c0.364-0.503,0.755-0.871,1.171-1.105c0.416-0.233,0.952-0.35,1.611-0.35\r\n\t\t\t\tc0.503,0,0.945,0.086,1.326,0.26c0.381,0.172,0.711,0.416,0.988,0.728c0.276,0.312,0.484,0.676,0.623,1.092\r\n\t\t\t\tc0.14,0.416,0.209,0.858,0.209,1.326c0,0.451-0.074,0.89-0.222,1.313C41.943,45.114,41.734,45.486,41.467,45.807z"},"children":[{"name":"path","attribs":{"d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M61,8h-6v3\r\n\t\t\t\tc0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.361,39.632c-0.373,0.347-0.785,0.663-1.235,0.949\r\n\t\t\t\tc-0.451,0.286-0.875,0.567-1.274,0.845c-0.78,0.538-1.521,1.066-2.223,1.586c-0.702,0.521-1.313,1.088-1.833,1.703\r\n\t\t\t\ts-0.932,1.312-1.235,2.094c-0.304,0.779-0.455,1.698-0.455,2.756H31.47v-3.172h-8.606c0.451-0.625,0.97-1.17,1.56-1.639\r\n\t\t\t\tc0.589-0.468,1.196-0.904,1.82-1.312c0.624-0.407,1.244-0.819,1.859-1.235c0.615-0.416,1.166-0.88,1.651-1.392\r\n\t\t\t\tc0.485-0.51,0.875-1.096,1.17-1.754c0.294-0.66,0.442-1.447,0.442-2.367c0-0.883-0.169-1.68-0.507-2.392\r\n\t\t\t\tc-0.338-0.71-0.793-1.308-1.365-1.794c-0.572-0.485-1.235-0.858-1.989-1.118C26.751,31.13,25.958,31,25.126,31\r\n\t\t\t\tc-1.092,0-2.058,0.187-2.899,0.559c-0.841,0.373-1.539,0.893-2.093,1.56c-0.555,0.667-0.971,1.447-1.248,2.34\r\n\t\t\t\tc-0.277,0.893-0.399,1.859-0.364,2.898h3.536c0-0.484,0.048-0.975,0.143-1.469c0.095-0.494,0.255-0.945,0.481-1.352\r\n\t\t\t\tc0.225-0.407,0.524-0.737,0.897-0.988s0.828-0.377,1.365-0.377c0.797,0,1.452,0.247,1.963,0.741\r\n\t\t\t\tc0.511,0.494,0.767,1.183,0.767,2.067c0,0.555-0.126,1.049-0.377,1.481C27.045,38.895,26.733,39.285,26.361,39.632z\r\n\t\t\t\t M41.467,45.807c-0.269,0.321-0.598,0.582-0.988,0.78c-0.39,0.199-0.828,0.299-1.312,0.299c-0.832,0-1.518-0.247-2.055-0.741\r\n\t\t\t\tc-0.536-0.494-0.85-1.156-0.936-1.988h-3.692c0.017,0.953,0.211,1.789,0.584,2.509c0.373,0.719,0.871,1.321,1.496,1.808\r\n\t\t\t\tc0.623,0.484,1.338,0.844,2.145,1.078s1.65,0.352,2.535,0.352c0.919,0.017,1.785-0.135,2.6-0.455\r\n\t\t\t\tc0.815-0.321,1.529-0.776,2.145-1.365s1.105-1.287,1.47-2.094c0.364-0.805,0.546-1.676,0.546-2.612\r\n\t\t\t\tc0-0.849-0.126-1.651-0.377-2.405c-0.252-0.754-0.615-1.408-1.092-1.963s-1.062-0.997-1.756-1.326\r\n\t\t\t\tc-0.692-0.328-1.49-0.494-2.391-0.494c-0.729,0-1.379,0.109-1.951,0.326c-0.571,0.217-1.108,0.575-1.611,1.078l-0.053-0.052\r\n\t\t\t\tl0.729-4.134h7.514v-3.042H34.85l-1.793,10.062h3.327c0.364-0.503,0.755-0.871,1.171-1.105c0.416-0.233,0.952-0.35,1.611-0.35\r\n\t\t\t\tc0.503,0,0.945,0.086,1.326,0.26c0.381,0.172,0.711,0.416,0.988,0.728c0.276,0.312,0.484,0.676,0.623,1.092\r\n\t\t\t\tc0.14,0.416,0.209,0.858,0.209,1.326c0,0.451-0.074,0.89-0.222,1.313C41.943,45.114,41.734,45.486,41.467,45.807z"},"children":[]}]}]}]}]}]}]}]};exports.calendar=calendar;var calendar_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M25.126,31\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3s3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4v-4\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3S23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8\r\n\t\t\t\tH23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11\r\n\t\t\t\tC64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"},"children":[{"name":"path","attribs":{"d":"M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M25.126,31\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3s3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4v-4\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3S23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8\r\n\t\t\t\tH23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11\r\n\t\t\t\tC64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"},"children":[]}]}]}]}]}]}]}]};exports.calendar_add=calendar_add;var calendar_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__OK"},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M61,8h-6v3\r\n\t\t\t\tc0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.879,50.121C27.422,50.664,28.172,51,29,51s1.578-0.336,2.121-0.879l14-14\r\n\t\t\t\tC45.664,35.579,46,34.828,46,34c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,43.757l-4.879-4.879\r\n\t\t\t\tC23.578,38.336,22.828,38,22,38c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,50.121z"},"children":[{"name":"path","attribs":{"d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M61,8h-6v3\r\n\t\t\t\tc0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H3c-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.879,50.121C27.422,50.664,28.172,51,29,51s1.578-0.336,2.121-0.879l14-14\r\n\t\t\t\tC45.664,35.579,46,34.828,46,34c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,43.757l-4.879-4.879\r\n\t\t\t\tC23.578,38.336,22.828,38,22,38c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,50.121z"},"children":[]}]}]}]}]}]}]}]};exports.calendar_ok=calendar_ok;var camera={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CAMERA_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CAMERA"},"children":[{"name":"g","attribs":{"id":"CAMERA"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,22c-6.627,0-12,5.372-12,12c0,6.627,5.373,12,12,12s12-5.373,12-12S38.627,22,32,22z M61,12H48.243l-5.095-5.094\r\n\t\t\t\tl-0.002,0.003C42.602,6.35,41.843,6,41,6H23c-0.976,0-1.835,0.474-2.383,1.196L15.813,12H3c-1.657,0-3,1.343-3,3v40\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V15C64,13.343,62.657,12,61,12z M32,52c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C50,43.941,41.941,52,32,52z"},"children":[{"name":"path","attribs":{"d":"M32,22c-6.627,0-12,5.372-12,12c0,6.627,5.373,12,12,12s12-5.373,12-12S38.627,22,32,22z M61,12H48.243l-5.095-5.094\r\n\t\t\t\tl-0.002,0.003C42.602,6.35,41.843,6,41,6H23c-0.976,0-1.835,0.474-2.383,1.196L15.813,12H3c-1.657,0-3,1.343-3,3v40\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V15C64,13.343,62.657,12,61,12z M32,52c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C50,43.941,41.941,52,32,52z"},"children":[]}]}]}]}]}]}]}]};exports.camera=camera;var cassette={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CASSETTE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,9H3c-1.657,0-3,1.343-3,3v40c0,1.657,1.343,3,3,3h8.369l4.846-12.114\r\n\t\t\tl0.004,0.002C16.661,41.783,17.737,41,19,41h26c1.263,0,2.339,0.782,2.781,1.887l0.004-0.002L52.631,55H61c1.657,0,3-1.343,3-3V12\r\n\t\t\tC64,10.343,62.657,9,61,9z M16,32c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4c2.209,0,4,1.791,4,4C20,30.209,18.209,32,16,32z\r\n\t\t\t M40,32H24v-8h16V32z M48,32c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C52,30.209,50.209,32,48,32z M45.834,46.056\r\n\t\t\tC45.436,44.865,44.325,44,43,44H21c-1.296,0-2.391,0.827-2.81,1.978l-0.01-0.004L14.899,55h33.93l-2.983-8.949L45.834,46.056z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,9H3c-1.657,0-3,1.343-3,3v40c0,1.657,1.343,3,3,3h8.369l4.846-12.114\r\n\t\t\tl0.004,0.002C16.661,41.783,17.737,41,19,41h26c1.263,0,2.339,0.782,2.781,1.887l0.004-0.002L52.631,55H61c1.657,0,3-1.343,3-3V12\r\n\t\t\tC64,10.343,62.657,9,61,9z M16,32c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4c2.209,0,4,1.791,4,4C20,30.209,18.209,32,16,32z\r\n\t\t\t M40,32H24v-8h16V32z M48,32c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C52,30.209,50.209,32,48,32z M45.834,46.056\r\n\t\t\tC45.436,44.865,44.325,44,43,44H21c-1.296,0-2.391,0.827-2.81,1.978l-0.01-0.004L14.899,55h33.93l-2.983-8.949L45.834,46.056z"},"children":[]}]}]}]}]}]};exports.cassette=cassette;var chart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART"},"children":[{"name":"g","attribs":{"id":"CHART"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz M46,55h6c1.657,0,3-1.343,3-3V31c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21C43,53.657,44.343,55,46,55z M29,55h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33C26,53.657,27.343,55,29,55z M12,55h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6C9,53.657,10.343,55,12,55z"},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz M46,55h6c1.657,0,3-1.343,3-3V31c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21C43,53.657,44.343,55,46,55z M29,55h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33C26,53.657,27.343,55,29,55z M12,55h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6C9,53.657,10.343,55,12,55z"},"children":[]}]}]}]}]}]}]}]};exports.chart=chart;var chart_1_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6V58z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6V58z"},"children":[]}]}]}]}]}]}]}]};exports.chart_1_2=chart_1_2;var chart_1_4={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26h26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26h26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.chart_1_4=chart_1_4;var chart_1_8={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8"},"children":[{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26l18.385-18.385C55.09,18.32,58,24.82,58,32C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26l18.385-18.385C55.09,18.32,58,24.82,58,32C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.chart_1_8=chart_1_8;var chart_3_4={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32H6C6,17.641,17.641,6,32,6V32z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32H6C6,17.641,17.641,6,32,6V32z"},"children":[]}]}]}]}]}]}]}]};exports.chart_3_4=chart_3_4;var chart_3_8={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26l18.385,18.385C45.68,55.09,39.18,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6v26l18.385,18.385C45.68,55.09,39.18,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.chart_3_8=chart_3_8;var chart_5_8={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32L13.615,50.385\r\n\t\t\t\tC8.91,45.68,6,39.18,6,32C6,17.641,17.641,6,32,6V32z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32L13.615,50.385\r\n\t\t\t\tC8.91,45.68,6,39.18,6,32C6,17.641,17.641,6,32,6V32z"},"children":[]}]}]}]}]}]}]}]};exports.chart_5_8=chart_5_8;var chart_7_8={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32L13.615,13.615\r\n\t\t\t\tC18.32,8.91,24.82,6,32,6V32z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,32L13.615,13.615\r\n\t\t\t\tC18.32,8.91,24.82,6,32,6V32z"},"children":[]}]}]}]}]}]}]}]};exports.chart_7_8=chart_7_8;var circle={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE"},"children":[{"name":"g","attribs":{"id":"CIRCLE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle=circle;var circle_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M46,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879C22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879C18.336,41.422,18,42.172,18,43c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.579-0.336,2.121-0.879L32,36.243l8.879,8.879C41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878C45.664,22.578,46,21.829,46,21z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M46,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879C22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879C18.336,41.422,18,42.172,18,43c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.579-0.336,2.121-0.879L32,36.243l8.879,8.879C41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878C45.664,22.578,46,21.829,46,21z"},"children":[]}]}]}]}]}]}]}]};exports.circle_delete=circle_delete;var circle_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,32c-0.885,0-1.673,0.391-2.223,1l-0.008-0.007L35,37.182V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v18.182l-3.77-4.188\r\n\t\t\t\tL25.222,33c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3c0,0.771,0.299,1.468,0.778,2l-0.008,0.008l9,10L29.778,47\r\n\t\t\t\tc0.549,0.609,1.336,1,2.222,1c0.885,0,1.673-0.391,2.223-1l0.008,0.007l9-10L43.223,37C43.7,36.468,44,35.771,44,35\r\n\t\t\t\tC44,33.343,42.657,32,41,32z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M41,32c-0.885,0-1.673,0.391-2.223,1l-0.008-0.007L35,37.182V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v18.182l-3.77-4.188\r\n\t\t\t\tL25.222,33c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3c0,0.771,0.299,1.468,0.778,2l-0.008,0.008l9,10L29.778,47\r\n\t\t\t\tc0.549,0.609,1.336,1,2.222,1c0.885,0,1.673-0.391,2.223-1l0.008,0.007l9-10L43.223,37C43.7,36.468,44,35.771,44,35\r\n\t\t\t\tC44,33.343,42.657,32,41,32z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_down=circle_down;var circle_fast_forward={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M45.559,29.437l-9.699-6.789\r\n\t\t\t\tC35.35,22.243,34.703,22,34,22c-1.657,0-3,1.343-3,3c0,0.008,0.001,0.016,0.001,0.024h-0.005v4.018l-9.135-6.394\r\n\t\t\t\tC21.349,22.243,20.703,22,20,22c-1.657,0-3,1.343-3,3c0,0.008,0.001,0.016,0.001,0.024h-0.005v14h0.005\r\n\t\t\t\tC17.013,40.67,18.351,42,20,42c0.708,0,1.358-0.246,1.871-0.654l9.125-6.388v4.067h0.005C31.013,40.67,32.351,42,34,42\r\n\t\t\t\tc0.708,0,1.357-0.246,1.871-0.654l9.68-6.777C46.419,34.043,47,33.089,47,32C47,30.914,46.423,29.963,45.559,29.437z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M45.559,29.437l-9.699-6.789\r\n\t\t\t\tC35.35,22.243,34.703,22,34,22c-1.657,0-3,1.343-3,3c0,0.008,0.001,0.016,0.001,0.024h-0.005v4.018l-9.135-6.394\r\n\t\t\t\tC21.349,22.243,20.703,22,20,22c-1.657,0-3,1.343-3,3c0,0.008,0.001,0.016,0.001,0.024h-0.005v14h0.005\r\n\t\t\t\tC17.013,40.67,18.351,42,20,42c0.708,0,1.358-0.246,1.871-0.654l9.125-6.388v4.067h0.005C31.013,40.67,32.351,42,34,42\r\n\t\t\t\tc0.708,0,1.357-0.246,1.871-0.654l9.68-6.777C46.419,34.043,47,33.089,47,32C47,30.914,46.423,29.963,45.559,29.437z"},"children":[]}]}]}]}]}]}]}]};exports.circle_fast_forward=circle_fast_forward;var circle_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,29H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778\r\n\t\t\t\tl-0.007-0.008l-10,9L17,29.778c-0.61,0.549-1,1.336-1,2.222s0.391,1.673,1,2.223l-0.007,0.008l10,9L27,43.223\r\n\t\t\t\tC27.532,43.701,28.228,44,29,44c1.657,0,3-1.343,3-3c0-0.885-0.391-1.673-1-2.223l0.007-0.008L26.818,35H45c1.657,0,3-1.343,3-3\r\n\t\t\t\tS46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M45,29H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222c0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778\r\n\t\t\t\tl-0.007-0.008l-10,9L17,29.778c-0.61,0.549-1,1.336-1,2.222s0.391,1.673,1,2.223l-0.007,0.008l10,9L27,43.223\r\n\t\t\t\tC27.532,43.701,28.228,44,29,44c1.657,0,3-1.343,3-3c0-0.885-0.391-1.673-1-2.223l0.007-0.008L26.818,35H45c1.657,0,3-1.343,3-3\r\n\t\t\t\tS46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_left=circle_left;var circle_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\ts14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M45,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\ts14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_minus=circle_minus;var circle_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__OK"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,43.001L46,43.001C46,43,46,43,46,42.999V43.001z M46,20.999v0.002C46,21.001,46,21,46,20.999C46,21,46,21,46,20.999z\r\n\t\t\t\t M44,21c-0.828,0-1.578,0.336-2.121,0.879L28,35.758l-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l9,9C26.422,42.664,27.172,43,28,43s1.578-0.336,2.121-0.879l16-16\r\n\t\t\t\tC46.664,25.579,47,24.828,47,24C47,22.343,45.657,21,44,21z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tS49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M46,43.001L46,43.001C46,43,46,43,46,42.999V43.001z M46,20.999v0.002C46,21.001,46,21,46,20.999C46,21,46,21,46,20.999z\r\n\t\t\t\t M44,21c-0.828,0-1.578,0.336-2.121,0.879L28,35.758l-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l9,9C26.422,42.664,27.172,43,28,43s1.578-0.336,2.121-0.879l16-16\r\n\t\t\t\tC46.664,25.579,47,24.828,47,24C47,22.343,45.657,21,44,21z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tS49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_ok=circle_ok;var circle_pause={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M29,24c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.002,0,0.005,0,0.007h-0.002v16H23C23.004,41.661,24.346,43,26,43c1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07\r\n\t\t\t\tC28.999,24.047,29,24.024,29,24z M41,24c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H35\r\n\t\t\t\tC35.004,41.661,36.346,43,38,43c1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07C40.999,24.047,41,24.024,41,24z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z M29,24c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.002,0,0.005,0,0.007h-0.002v16H23C23.004,41.661,24.346,43,26,43c1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07\r\n\t\t\t\tC28.999,24.047,29,24.024,29,24z M41,24c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H35\r\n\t\t\t\tC35.004,41.661,36.346,43,38,43c1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07C40.999,24.047,41,24.024,41,24z"},"children":[]}]}]}]}]}]}]}]};exports.circle_pause=circle_pause;var circle_play={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41.492,29.398l-15.8-9.875C25.21,19.193,24.628,19,24,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.066,0,0.131-0.003,0.195-0.007c0.017-0.001,0.034-0.003,0.051-0.004c0.055-0.005,0.109-0.011,0.163-0.019\r\n\t\t\t\tc0.01,0,0.021-0.002,0.031-0.004c0.064-0.01,0.128-0.021,0.191-0.035c0.01-0.002,0.019-0.005,0.029-0.007\r\n\t\t\t\tc0.057-0.013,0.112-0.026,0.167-0.043c0.009-0.003,0.018-0.005,0.027-0.008c0.128-0.038,0.252-0.084,0.372-0.138\r\n\t\t\t\tc0.005-0.002,0.009-0.004,0.014-0.006c0.123-0.057,0.242-0.121,0.355-0.191l0.013,0.02l15.912-9.974\r\n\t\t\t\tC42.404,34.066,43,33.104,43,32C43,30.886,42.393,29.915,41.492,29.398z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32\r\n\t\t\t\ts32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M41.492,29.398l-15.8-9.875C25.21,19.193,24.628,19,24,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.066,0,0.131-0.003,0.195-0.007c0.017-0.001,0.034-0.003,0.051-0.004c0.055-0.005,0.109-0.011,0.163-0.019\r\n\t\t\t\tc0.01,0,0.021-0.002,0.031-0.004c0.064-0.01,0.128-0.021,0.191-0.035c0.01-0.002,0.019-0.005,0.029-0.007\r\n\t\t\t\tc0.057-0.013,0.112-0.026,0.167-0.043c0.009-0.003,0.018-0.005,0.027-0.008c0.128-0.038,0.252-0.084,0.372-0.138\r\n\t\t\t\tc0.005-0.002,0.009-0.004,0.014-0.006c0.123-0.057,0.242-0.121,0.355-0.191l0.013,0.02l15.912-9.974\r\n\t\t\t\tC42.404,34.066,43,33.104,43,32C43,30.886,42.393,29.915,41.492,29.398z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32\r\n\t\t\t\ts32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_play=circle_play;var circle_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,29H35V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h10v10c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V35h10c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tS49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M45,29H35V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h10v10c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V35h10c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tS49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_plus=circle_plus;var circle_rewind={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M47,25c0-1.657-1.343-3-3-3c-0.703,0-1.35,0.242-1.861,0.648l-9.135,6.394v-4.018h-0.006C32.999,25.016,33,25.008,33,25\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.699,6.789C17.577,29.963,17,30.914,17,32\r\n\t\t\t\tc0,1.089,0.581,2.043,1.449,2.568l9.68,6.777C28.642,41.754,29.292,42,30,42c1.649,0,2.986-1.33,2.999-2.977h0.005v-4.066\r\n\t\t\t\tl9.125,6.387C42.643,41.754,43.292,42,44,42c1.648,0,2.986-1.33,2.999-2.977h0.005v-14h-0.005C46.999,25.016,47,25.008,47,25z\r\n\t\t\t\t M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M47,25c0-1.657-1.343-3-3-3c-0.703,0-1.35,0.242-1.861,0.648l-9.135,6.394v-4.018h-0.006C32.999,25.016,33,25.008,33,25\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.699,6.789C17.577,29.963,17,30.914,17,32\r\n\t\t\t\tc0,1.089,0.581,2.043,1.449,2.568l9.68,6.777C28.642,41.754,29.292,42,30,42c1.649,0,2.986-1.33,2.999-2.977h0.005v-4.066\r\n\t\t\t\tl9.125,6.387C42.643,41.754,43.292,42,44,42c1.648,0,2.986-1.33,2.999-2.977h0.005v-14h-0.005C46.999,25.016,47,25.008,47,25z\r\n\t\t\t\t M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_rewind=circle_rewind;var circle_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M47,29.778l0.007-0.008l-10-9L37,20.778C36.468,20.3,35.771,20,35,20c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222\r\n\t\t\t\tl-0.007,0.008L37.182,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h18.182l-4.188,3.77L33,38.777c-0.61,0.55-1,1.338-1,2.223\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.771,0,1.468-0.299,2-0.777l0.007,0.008l10-9L47,34.223c0.609-0.55,1-1.337,1-2.223\r\n\t\t\t\tS47.609,30.328,47,29.778z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M47,29.778l0.007-0.008l-10-9L37,20.778C36.468,20.3,35.771,20,35,20c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222\r\n\t\t\t\tl-0.007,0.008L37.182,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h18.182l-4.188,3.77L33,38.777c-0.61,0.55-1,1.338-1,2.223\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.771,0,1.468-0.299,2-0.777l0.007,0.008l10-9L47,34.223c0.609-0.55,1-1.337,1-2.223\r\n\t\t\t\tS47.609,30.328,47,29.778z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_right=circle_right;var circle_skip_next={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M39,22c-1.657,0-3,1.343-3,3v4.29l-9.235-6.717L26.76,22.58C26.264,22.219,25.66,22,25,22c-1.657,0-3,1.343-3,3v14\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.66,0,1.264-0.219,1.76-0.58l0.005,0.007L36,34.71V39c0,1.657,1.343,3,3,3s3-1.343,3-3V25\r\n\t\t\t\tC42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M39,22c-1.657,0-3,1.343-3,3v4.29l-9.235-6.717L26.76,22.58C26.264,22.219,25.66,22,25,22c-1.657,0-3,1.343-3,3v14\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.66,0,1.264-0.219,1.76-0.58l0.005,0.007L36,34.71V39c0,1.657,1.343,3,3,3s3-1.343,3-3V25\r\n\t\t\t\tC42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_skip_next=circle_skip_next;var circle_skip_previous={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M39,22c-0.66,0-1.266,0.219-1.76,0.58l-0.006-0.007L28,29.291V25c0-1.657-1.343-3-3-3s-3,1.343-3,3v14\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-4.29l9.234,6.717l0.006-0.007C37.736,41.781,38.34,42,39,42c1.657,0,3-1.343,3-3V25\r\n\t\t\t\tC42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M39,22c-0.66,0-1.266,0.219-1.76,0.58l-0.006-0.007L28,29.291V25c0-1.657-1.343-3-3-3s-3,1.343-3,3v14\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-4.29l9.234,6.717l0.006-0.007C37.736,41.781,38.34,42,39,42c1.657,0,3-1.343,3-3V25\r\n\t\t\t\tC42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_skip_previous=circle_skip_previous;var circle_stop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M40,21H24c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3V24C43,22.343,41.657,21,40,21z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M40,21H24c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3V24C43,22.343,41.657,21,40,21z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_stop=circle_stop;var circle_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__UP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__UP"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__UP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43.23,26.993l-9-10L34.223,17c-0.55-0.61-1.336-1-2.223-1c-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10L20.778,27\r\n\t\t\t\tC20.3,27.532,20,28.229,20,29c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V26.818l3.77,4.189L38.777,31c0.55,0.61,1.338,1,2.223,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.777-2\r\n\t\t\t\tL43.23,26.993z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M43.23,26.993l-9-10L34.223,17c-0.55-0.61-1.336-1-2.223-1c-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10L20.778,27\r\n\t\t\t\tC20.3,27.532,20,28.229,20,29c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V26.818l3.77,4.189L38.777,31c0.55,0.61,1.338,1,2.223,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.777-2\r\n\t\t\t\tL43.23,26.993z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.64,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.circle_up=circle_up;var clip={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLIP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.628,11.373c-7.029-7.029-18.426-7.029-25.456,0L6.837,34.707\r\n\t\t\tc-5.077,5.077-5.077,13.308,0,18.385c5.077,5.077,13.308,5.077,18.385,0l21.92-21.92c3.124-3.124,3.124-8.189,0-11.314\r\n\t\t\tc-3.124-3.124-8.19-3.124-11.314,0L17.444,38.243c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0\r\n\t\t\tl18.385-18.385c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828l-21.92,21.92c-2.734,2.734-7.166,2.734-9.899,0\r\n\t\t\tc-2.734-2.734-2.734-7.166,0-9.9l23.334-23.334c4.686-4.686,12.284-4.686,16.971,0c4.686,4.686,4.686,12.284,0,16.971\r\n\t\t\tL31.586,52.385c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.171,3.071,1.171,4.243,0l19.799-19.799\r\n\t\t\tC62.657,29.799,62.657,18.402,55.628,11.373z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.628,11.373c-7.029-7.029-18.426-7.029-25.456,0L6.837,34.707\r\n\t\t\tc-5.077,5.077-5.077,13.308,0,18.385c5.077,5.077,13.308,5.077,18.385,0l21.92-21.92c3.124-3.124,3.124-8.189,0-11.314\r\n\t\t\tc-3.124-3.124-8.19-3.124-11.314,0L17.444,38.243c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0\r\n\t\t\tl18.385-18.385c0.781-0.781,2.047-0.781,2.828,0c0.781,0.781,0.781,2.047,0,2.828l-21.92,21.92c-2.734,2.734-7.166,2.734-9.899,0\r\n\t\t\tc-2.734-2.734-2.734-7.166,0-9.9l23.334-23.334c4.686-4.686,12.284-4.686,16.971,0c4.686,4.686,4.686,12.284,0,16.971\r\n\t\t\tL31.586,52.385c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.171,3.071,1.171,4.243,0l19.799-19.799\r\n\t\t\tC62.657,29.799,62.657,18.402,55.628,11.373z"},"children":[]}]}]}]}]}]};exports.clip=clip;var close={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOSE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOSE"},"children":[{"name":"g","attribs":{"id":"CLOSE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M36.243,32l11.879-11.879C48.664,19.579,49,18.828,49,18c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL32,27.757L20.121,15.879C19.578,15.336,18.828,15,18,15c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32\r\n\t\t\t\tL15.879,43.879C15.336,44.422,15,45.172,15,46c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243l11.879,11.879\r\n\t\t\t\tC44.422,48.664,45.172,49,46,49c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32z"},"children":[{"name":"path","attribs":{"d":"M36.243,32l11.879-11.879C48.664,19.579,49,18.828,49,18c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL32,27.757L20.121,15.879C19.578,15.336,18.828,15,18,15c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32\r\n\t\t\t\tL15.879,43.879C15.336,44.422,15,45.172,15,46c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243l11.879,11.879\r\n\t\t\t\tC44.422,48.664,45.172,49,46,49c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32z"},"children":[]}]}]}]}]}]}]}]};exports.close=close;var cloud={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOUD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD"},"children":[{"name":"g","attribs":{"id":"CLOUD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M53.387,24.656C50.048,16.086,41.753,10,32,10s-18.048,6.086-21.387,14.655C4.47,26.532,0,32.243,0,39\r\n\t\t\t\tc0,8.284,6.716,15,15,15h34c8.284,0,15-6.716,15-15C64,32.243,59.529,26.532,53.387,24.656z M49,48H15c-4.97,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,30.017,14.702,30,15,30\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,19.318,25.808,16,32,16\r\n\t\t\t\tc6.191,0,11.596,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,30.011,48.906,30,49,30\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,33.921,58,36.32,58,39C58,43.971,53.971,48,49,48z\r\n\t\t\t\t"},"children":[{"name":"path","attribs":{"d":"M53.387,24.656C50.048,16.086,41.753,10,32,10s-18.048,6.086-21.387,14.655C4.47,26.532,0,32.243,0,39\r\n\t\t\t\tc0,8.284,6.716,15,15,15h34c8.284,0,15-6.716,15-15C64,32.243,59.529,26.532,53.387,24.656z M49,48H15c-4.97,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,30.017,14.702,30,15,30\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,19.318,25.808,16,32,16\r\n\t\t\t\tc6.191,0,11.596,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,30.011,48.906,30,49,30\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,33.921,58,36.32,58,39C58,43.971,53.971,48,49,48z\r\n\t\t\t\t"},"children":[]}]}]}]}]}]}]}]};exports.cloud=cloud;var cloud_download={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,44c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,49.182V34c0-1.657-1.343-3-3-3s-3,1.343-3,3v15.182l-3.77-4.188l0,0\r\n\t\t\t\tC24.681,44.384,23.885,44,23,44c-1.657,0-3,1.343-3,3c0,0.096,0.005,0.191,0.014,0.286l0,0c0.062,0.659,0.337,1.256,0.756,1.721\r\n\t\t\t\tl0,0l9,10L29.778,59c0.549,0.609,1.337,1,2.222,1s1.673-0.391,2.223-1.001l0.008,0.007l9-10l0,0\r\n\t\t\t\tc0.418-0.465,0.693-1.061,0.756-1.719c0-0.002,0-0.004,0-0.006C43.995,47.189,44,47.096,44,47.001V47\r\n\t\t\t\tc0-0.104-0.005-0.206-0.016-0.307C43.831,45.182,42.553,44,41,44z M53.387,19.656C50.048,11.086,41.753,5,32,5\r\n\t\t\t\tc-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tc-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,14.318,25.808,11,32,11\r\n\t\t\t\tc6.191,0,11.596,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,25.011,48.906,25,49,25\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.396,0.21,0.589,0.326c0.032,0.019,0.063,0.039,0.097,0.058c0.205,0.128,0.405,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.026,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15C64,27.243,59.529,21.532,53.387,19.656z"},"children":[{"name":"path","attribs":{"d":"M41,44c-0.885,0-1.682,0.384-2.23,0.993l0,0L35,49.182V34c0-1.657-1.343-3-3-3s-3,1.343-3,3v15.182l-3.77-4.188l0,0\r\n\t\t\t\tC24.681,44.384,23.885,44,23,44c-1.657,0-3,1.343-3,3c0,0.096,0.005,0.191,0.014,0.286l0,0c0.062,0.659,0.337,1.256,0.756,1.721\r\n\t\t\t\tl0,0l9,10L29.778,59c0.549,0.609,1.337,1,2.222,1s1.673-0.391,2.223-1.001l0.008,0.007l9-10l0,0\r\n\t\t\t\tc0.418-0.465,0.693-1.061,0.756-1.719c0-0.002,0-0.004,0-0.006C43.995,47.189,44,47.096,44,47.001V47\r\n\t\t\t\tc0-0.104-0.005-0.206-0.016-0.307C43.831,45.182,42.553,44,41,44z M53.387,19.656C50.048,11.086,41.753,5,32,5\r\n\t\t\t\tc-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tc-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,14.318,25.808,11,32,11\r\n\t\t\t\tc6.191,0,11.596,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,25.011,48.906,25,49,25\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.396,0.21,0.589,0.326c0.032,0.019,0.063,0.039,0.097,0.058c0.205,0.128,0.405,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.026,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15C64,27.243,59.529,21.532,53.387,19.656z"},"children":[]}]}]}]}]}]}]}]};exports.cloud_download=cloud_download;var cloud_fail={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43,39c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,42.758l-5.879-5.879C25.578,36.336,24.829,36,24,36\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L27.757,47l-5.879,5.879C21.336,53.422,21,54.172,21,55\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.878L32,51.243l5.879,5.879C38.422,57.664,39.172,58,40,58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.829-0.336-1.579-0.879-2.121L36.243,47l5.879-5.879C42.664,40.579,43,39.829,43,39z M53.387,20.656\r\n\t\t\t\tC50.048,12.086,41.752,6,32,6s-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485\r\n\t\t\t\tc0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058\r\n\t\t\t\tc0.192-0.116,0.388-0.225,0.589-0.326c0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248\r\n\t\t\t\tc0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091\r\n\t\t\t\tc0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05\r\n\t\t\t\tC14.408,26.017,14.702,26,15,26c0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512\r\n\t\t\t\tc0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324\r\n\t\t\t\tc0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097\r\n\t\t\t\tC20.406,15.318,25.808,12,32,12c6.191,0,11.594,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097\r\n\t\t\t\tc0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324\r\n\t\t\t\tc0.137,0.363,0.252,0.737,0.363,1.112c0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512\r\n\t\t\t\tC48.814,26.011,48.906,26,49,26c0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05\r\n\t\t\t\tc0.164,0.023,0.33,0.043,0.492,0.075c0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091\r\n\t\t\t\tc0.176,0.052,0.349,0.113,0.519,0.175c0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248\r\n\t\t\t\tc0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058\r\n\t\t\t\tc0.207,0.128,0.406,0.263,0.602,0.406c0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485\r\n\t\t\t\tC56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15\r\n\t\t\t\tC64,28.243,59.529,22.532,53.387,20.656z"},"children":[{"name":"path","attribs":{"d":"M43,39c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,42.758l-5.879-5.879C25.578,36.336,24.829,36,24,36\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L27.757,47l-5.879,5.879C21.336,53.422,21,54.172,21,55\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.878L32,51.243l5.879,5.879C38.422,57.664,39.172,58,40,58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.829-0.336-1.579-0.879-2.121L36.243,47l5.879-5.879C42.664,40.579,43,39.829,43,39z M53.387,20.656\r\n\t\t\t\tC50.048,12.086,41.752,6,32,6s-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485\r\n\t\t\t\tc0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058\r\n\t\t\t\tc0.192-0.116,0.388-0.225,0.589-0.326c0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248\r\n\t\t\t\tc0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091\r\n\t\t\t\tc0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05\r\n\t\t\t\tC14.408,26.017,14.702,26,15,26c0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512\r\n\t\t\t\tc0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324\r\n\t\t\t\tc0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097\r\n\t\t\t\tC20.406,15.318,25.808,12,32,12c6.191,0,11.594,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097\r\n\t\t\t\tc0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324\r\n\t\t\t\tc0.137,0.363,0.252,0.737,0.363,1.112c0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512\r\n\t\t\t\tC48.814,26.011,48.906,26,49,26c0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05\r\n\t\t\t\tc0.164,0.023,0.33,0.043,0.492,0.075c0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091\r\n\t\t\t\tc0.176,0.052,0.349,0.113,0.519,0.175c0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248\r\n\t\t\t\tc0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058\r\n\t\t\t\tc0.207,0.128,0.406,0.263,0.602,0.406c0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485\r\n\t\t\t\tC56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15\r\n\t\t\t\tC64,28.243,59.529,22.532,53.387,20.656z"},"children":[]}]}]}]}]}]}]}]};exports.cloud_fail=cloud_fail;var cloud_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOUD__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__OK"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43,36c-1.039,0-1.954,0.527-2.493,1.33l-8.936,12.998l-5.45-5.45C25.578,44.336,24.828,44,24,44c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.829,0.336,1.579,0.879,2.121l8,8C30.422,57.664,31.172,58,32,58c1.039,0,1.954-0.527,2.493-1.33l10.969-15.954\r\n\t\t\t\tC45.801,40.23,46,39.639,46,39C46,37.343,44.657,36,43,36z M53.387,20.656C50.048,12.086,41.752,6,32,6\r\n\t\t\t\tc-9.753,0-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tc-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.041-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,15.318,25.808,12,32,12\r\n\t\t\t\tc6.191,0,11.594,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.172,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,26.011,48.906,26,49,26\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.2,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.529,22.532,53.387,20.656z"},"children":[{"name":"path","attribs":{"d":"M43,36c-1.039,0-1.954,0.527-2.493,1.33l-8.936,12.998l-5.45-5.45C25.578,44.336,24.828,44,24,44c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.829,0.336,1.579,0.879,2.121l8,8C30.422,57.664,31.172,58,32,58c1.039,0,1.954-0.527,2.493-1.33l10.969-15.954\r\n\t\t\t\tC45.801,40.23,46,39.639,46,39C46,37.343,44.657,36,43,36z M53.387,20.656C50.048,12.086,41.752,6,32,6\r\n\t\t\t\tc-9.753,0-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tc-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.041-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,15.318,25.808,12,32,12\r\n\t\t\t\tc6.191,0,11.594,3.318,14.562,8.266c0.213,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.172,0.356,0.325,0.724,0.474,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.363,1.112\r\n\t\t\t\tc0.036,0.12,0.082,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.343,1.512C48.814,26.011,48.906,26,49,26\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075\r\n\t\t\t\tc0.156,0.03,0.307,0.07,0.457,0.109c0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.17,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.2,0.101,0.396,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.529,22.532,53.387,20.656z"},"children":[]}]}]}]}]}]}]}]};exports.cloud_ok=cloud_ok;var cloud_upload={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43.986,43.719c0-0.002,0-0.004,0-0.006c-0.063-0.658-0.338-1.255-0.756-1.719l0,0l-0.008-0.01\r\n\t\t\t\tc-0.002,0-0.002-0.002-0.004-0.002l-8.99-9.989L34.221,32c-0.549-0.61-1.336-1-2.222-1c-0.885,0-1.673,0.391-2.222,1\r\n\t\t\t\tl-0.008-0.007l-8.988,9.987c-0.002,0.002-0.004,0.004-0.006,0.006l-0.006,0.007l0,0C20.292,42.525,20,43.229,20,44\r\n\t\t\t\tc0,0.518,0.131,1.005,0.362,1.43C20.87,46.365,21.861,47,23,47c0.033,0,0.066-0.002,0.099-0.003\r\n\t\t\t\tc0.019-0.001,0.038-0.001,0.057-0.002c0.022-0.001,0.043-0.003,0.065-0.005c0.033-0.002,0.066-0.006,0.098-0.008\r\n\t\t\t\tc0.012-0.002,0.024-0.004,0.036-0.006c0.044-0.004,0.087-0.011,0.13-0.018c0.001,0,0.003,0,0.004-0.001\r\n\t\t\t\tc0.686-0.112,1.294-0.458,1.74-0.953l0,0L29,41.818V57c0,1.657,1.343,3,3,3s3-1.343,3-3V41.818l3.77,4.188l0,0\r\n\t\t\t\tc0.446,0.495,1.056,0.841,1.742,0.953c0.002,0,0.002,0,0.002,0c0.045,0.007,0.088,0.013,0.133,0.019\r\n\t\t\t\tc0.011,0,0.022,0.002,0.033,0.004c0.033,0.002,0.067,0.006,0.1,0.008c0.021,0.002,0.043,0.004,0.063,0.005s0.04,0.001,0.06,0.002\r\n\t\t\t\tC40.936,46.999,40.967,47,41,47c1.657,0,3-1.343,3-3c0-0.001,0-0.001,0-0.002C44,43.904,43.995,43.811,43.986,43.719z\r\n\t\t\t\t M53.387,19.656C50.048,11.086,41.753,5,32,5c-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34\r\n\t\t\t\tc0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728\r\n\t\t\t\tc0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.6-0.406\r\n\t\t\t\tc0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08\r\n\t\t\t\tc0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175\r\n\t\t\t\tc0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075\r\n\t\t\t\tc0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25c0.094,0,0.185,0.011,0.278,0.014\r\n\t\t\t\tc0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112\r\n\t\t\t\tc0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253\r\n\t\t\t\tc0.188-0.372,0.384-0.741,0.599-1.097C20.406,14.318,25.808,11,32,11c6.191,0,11.596,3.318,14.562,8.266\r\n\t\t\t\tc0.213,0.357,0.41,0.725,0.598,1.097c0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.473,1.093\r\n\t\t\t\tc0.043,0.109,0.094,0.214,0.135,0.324c0.138,0.363,0.252,0.737,0.365,1.112c0.035,0.12,0.08,0.236,0.113,0.357\r\n\t\t\t\tc0.137,0.495,0.251,0.999,0.342,1.512C48.814,25.011,48.906,25,49,25c0.298,0,0.592,0.016,0.882,0.045\r\n\t\t\t\tc0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075c0.156,0.03,0.307,0.07,0.457,0.109\r\n\t\t\t\tc0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175c0.084,0.031,0.17,0.059,0.252,0.092\r\n\t\t\t\tc0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.396,0.21,0.588,0.326\r\n\t\t\t\tc0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406c0.013,0.01,0.027,0.02,0.04,0.03\r\n\t\t\t\tc0.206,0.154,0.405,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\tc8.284,0,15-6.716,15-15C64,27.243,59.529,21.532,53.387,19.656z"},"children":[{"name":"path","attribs":{"d":"M43.986,43.719c0-0.002,0-0.004,0-0.006c-0.063-0.658-0.338-1.255-0.756-1.719l0,0l-0.008-0.01\r\n\t\t\t\tc-0.002,0-0.002-0.002-0.004-0.002l-8.99-9.989L34.221,32c-0.549-0.61-1.336-1-2.222-1c-0.885,0-1.673,0.391-2.222,1\r\n\t\t\t\tl-0.008-0.007l-8.988,9.987c-0.002,0.002-0.004,0.004-0.006,0.006l-0.006,0.007l0,0C20.292,42.525,20,43.229,20,44\r\n\t\t\t\tc0,0.518,0.131,1.005,0.362,1.43C20.87,46.365,21.861,47,23,47c0.033,0,0.066-0.002,0.099-0.003\r\n\t\t\t\tc0.019-0.001,0.038-0.001,0.057-0.002c0.022-0.001,0.043-0.003,0.065-0.005c0.033-0.002,0.066-0.006,0.098-0.008\r\n\t\t\t\tc0.012-0.002,0.024-0.004,0.036-0.006c0.044-0.004,0.087-0.011,0.13-0.018c0.001,0,0.003,0,0.004-0.001\r\n\t\t\t\tc0.686-0.112,1.294-0.458,1.74-0.953l0,0L29,41.818V57c0,1.657,1.343,3,3,3s3-1.343,3-3V41.818l3.77,4.188l0,0\r\n\t\t\t\tc0.446,0.495,1.056,0.841,1.742,0.953c0.002,0,0.002,0,0.002,0c0.045,0.007,0.088,0.013,0.133,0.019\r\n\t\t\t\tc0.011,0,0.022,0.002,0.033,0.004c0.033,0.002,0.067,0.006,0.1,0.008c0.021,0.002,0.043,0.004,0.063,0.005s0.04,0.001,0.06,0.002\r\n\t\t\t\tC40.936,46.999,40.967,47,41,47c1.657,0,3-1.343,3-3c0-0.001,0-0.001,0-0.002C44,43.904,43.995,43.811,43.986,43.719z\r\n\t\t\t\t M53.387,19.656C50.048,11.086,41.753,5,32,5c-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34\r\n\t\t\t\tc0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3s-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728\r\n\t\t\t\tc0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.6-0.406\r\n\t\t\t\tc0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08\r\n\t\t\t\tc0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175\r\n\t\t\t\tc0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075\r\n\t\t\t\tc0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25c0.094,0,0.185,0.011,0.278,0.014\r\n\t\t\t\tc0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112\r\n\t\t\t\tc0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253\r\n\t\t\t\tc0.188-0.372,0.384-0.741,0.599-1.097C20.406,14.318,25.808,11,32,11c6.191,0,11.596,3.318,14.562,8.266\r\n\t\t\t\tc0.213,0.357,0.41,0.725,0.598,1.097c0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.473,1.093\r\n\t\t\t\tc0.043,0.109,0.094,0.214,0.135,0.324c0.138,0.363,0.252,0.737,0.365,1.112c0.035,0.12,0.08,0.236,0.113,0.357\r\n\t\t\t\tc0.137,0.495,0.251,0.999,0.342,1.512C48.814,25.011,48.906,25,49,25c0.298,0,0.592,0.016,0.882,0.045\r\n\t\t\t\tc0.12,0.012,0.237,0.034,0.356,0.05c0.164,0.023,0.33,0.043,0.492,0.075c0.156,0.03,0.307,0.07,0.457,0.109\r\n\t\t\t\tc0.119,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.349,0.113,0.519,0.175c0.084,0.031,0.17,0.059,0.252,0.092\r\n\t\t\t\tc0.191,0.076,0.377,0.16,0.562,0.248c0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.396,0.21,0.588,0.326\r\n\t\t\t\tc0.032,0.019,0.064,0.039,0.096,0.058c0.207,0.128,0.406,0.263,0.602,0.406c0.013,0.01,0.027,0.02,0.04,0.03\r\n\t\t\t\tc0.206,0.154,0.405,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\tc8.284,0,15-6.716,15-15C64,27.243,59.529,21.532,53.387,19.656z"},"children":[]}]}]}]}]}]}]}]};exports.cloud_upload=cloud_upload;var code={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CODE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CODE"},"children":[{"name":"g","attribs":{"id":"CODE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M15.031,17c-0.844,0-1.604,0.352-2.149,0.913l-0.003-0.003L1.053,29.735C0.413,30.285,0,31.091,0,32\r\n\t\t\t\tc0,0.844,0.351,1.604,0.912,2.148L0.91,34.152l12,12l0.003-0.004C13.453,46.674,14.187,47,15,47c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.812-0.326-1.547-0.851-2.087l0.003-0.003l-9.894-9.895l9.863-9.863l-0.003-0.003c0.561-0.545,0.913-1.305,0.913-2.149\r\n\t\t\t\tC18.031,18.343,16.688,17,15.031,17z M64.031,32c0-0.91-0.413-1.715-1.053-2.265L51.152,17.91l-0.002,0.003\r\n\t\t\t\tC50.604,17.352,49.844,17,49,17c-1.657,0-3,1.343-3,3c0,0.844,0.352,1.604,0.913,2.149l-0.003,0.003l9.863,9.863l-9.895,9.895\r\n\t\t\t\tl0.003,0.003c-0.524,0.54-0.851,1.274-0.851,2.087c0,1.657,1.343,3,3,3c0.812,0,1.547-0.326,2.088-0.852l0.003,0.004l12-12\r\n\t\t\t\tl-0.003-0.004C63.68,33.604,64.031,32.844,64.031,32z M40,8c-1.3,0-2.406,0.827-2.823,1.982L21.2,51.924\r\n\t\t\t\tC21.071,52.258,21,52.621,21,53c0,1.657,1.343,3,3,3c1.3,0,2.406-0.827,2.823-1.982L42.8,12.076C42.93,11.742,43,11.38,43,11\r\n\t\t\t\tC43,9.343,41.657,8,40,8z"},"children":[{"name":"path","attribs":{"d":"M15.031,17c-0.844,0-1.604,0.352-2.149,0.913l-0.003-0.003L1.053,29.735C0.413,30.285,0,31.091,0,32\r\n\t\t\t\tc0,0.844,0.351,1.604,0.912,2.148L0.91,34.152l12,12l0.003-0.004C13.453,46.674,14.187,47,15,47c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.812-0.326-1.547-0.851-2.087l0.003-0.003l-9.894-9.895l9.863-9.863l-0.003-0.003c0.561-0.545,0.913-1.305,0.913-2.149\r\n\t\t\t\tC18.031,18.343,16.688,17,15.031,17z M64.031,32c0-0.91-0.413-1.715-1.053-2.265L51.152,17.91l-0.002,0.003\r\n\t\t\t\tC50.604,17.352,49.844,17,49,17c-1.657,0-3,1.343-3,3c0,0.844,0.352,1.604,0.913,2.149l-0.003,0.003l9.863,9.863l-9.895,9.895\r\n\t\t\t\tl0.003,0.003c-0.524,0.54-0.851,1.274-0.851,2.087c0,1.657,1.343,3,3,3c0.812,0,1.547-0.326,2.088-0.852l0.003,0.004l12-12\r\n\t\t\t\tl-0.003-0.004C63.68,33.604,64.031,32.844,64.031,32z M40,8c-1.3,0-2.406,0.827-2.823,1.982L21.2,51.924\r\n\t\t\t\tC21.071,52.258,21,52.621,21,53c0,1.657,1.343,3,3,3c1.3,0,2.406-0.827,2.823-1.982L42.8,12.076C42.93,11.742,43,11.38,43,11\r\n\t\t\t\tC43,9.343,41.657,8,40,8z"},"children":[]}]}]}]}]}]}]}]};exports.code=code;var cog={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COG_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COG"},"children":[{"name":"g","attribs":{"id":"COG"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,20c-6.627,0-12,5.372-12,12c0,6.627,5.372,12,12,12s12-5.373,12-12S38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M55.518,25.462c-0.541-1.957-1.326-3.811-2.311-5.536\r\n\t\t\t\tc1.121-1.507,4.98-7.143,2.199-9.926l-1.428-1.507c-2.379-2.378-8.455,1.336-9.931,2.298c-1.745-0.989-3.62-1.774-5.6-2.31\r\n\t\t\t\tc-0.317-1.887-1.704-8.487-5.619-8.487h-1.567c-3.361,0-5.29,6.824-5.721,8.534c-1.952,0.545-3.801,1.334-5.522,2.32\r\n\t\t\t\tC18.661,9.839,12.841,5.816,10,8.656L8.493,9.924c-2.476,2.475,1.638,9.004,2.39,10.147c-0.952,1.698-1.715,3.517-2.241,5.435\r\n\t\t\t\tc-1.641,0.262-8.649,1.614-8.649,5.646v1.566c0,3.493,7.349,5.433,8.69,5.759c0.533,1.904,1.3,3.709,2.255,5.394\r\n\t\t\t\tc-0.791,1.239-4.745,7.739-2.292,10.194l1.427,1.188c3.229,3.229,9.974-2.075,9.974-2.075l-0.314-0.334\r\n\t\t\t\tc1.789,1.058,3.726,1.896,5.773,2.47c0.335,1.379,2.275,8.677,5.755,8.677h1.567c4.566,0,5.697-8.521,5.697-8.521l-0.418-0.013\r\n\t\t\t\tc2.069-0.529,4.031-1.325,5.851-2.345c1.426,0.949,7.401,4.688,9.786,2.304l1.587-1.588c3.183-3.183-1.997-9.696-2.142-9.877\r\n\t\t\t\tc0.984-1.722,1.773-3.571,2.316-5.525c1.78-0.452,8.483-2.374,8.483-5.707v-1.566C63.988,26.73,56.016,25.533,55.518,25.462z\r\n\t\t\t\t M32,50c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C50,41.941,41.941,50,32,50z"},"children":[{"name":"path","attribs":{"d":"M32,20c-6.627,0-12,5.372-12,12c0,6.627,5.372,12,12,12s12-5.373,12-12S38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M55.518,25.462c-0.541-1.957-1.326-3.811-2.311-5.536\r\n\t\t\t\tc1.121-1.507,4.98-7.143,2.199-9.926l-1.428-1.507c-2.379-2.378-8.455,1.336-9.931,2.298c-1.745-0.989-3.62-1.774-5.6-2.31\r\n\t\t\t\tc-0.317-1.887-1.704-8.487-5.619-8.487h-1.567c-3.361,0-5.29,6.824-5.721,8.534c-1.952,0.545-3.801,1.334-5.522,2.32\r\n\t\t\t\tC18.661,9.839,12.841,5.816,10,8.656L8.493,9.924c-2.476,2.475,1.638,9.004,2.39,10.147c-0.952,1.698-1.715,3.517-2.241,5.435\r\n\t\t\t\tc-1.641,0.262-8.649,1.614-8.649,5.646v1.566c0,3.493,7.349,5.433,8.69,5.759c0.533,1.904,1.3,3.709,2.255,5.394\r\n\t\t\t\tc-0.791,1.239-4.745,7.739-2.292,10.194l1.427,1.188c3.229,3.229,9.974-2.075,9.974-2.075l-0.314-0.334\r\n\t\t\t\tc1.789,1.058,3.726,1.896,5.773,2.47c0.335,1.379,2.275,8.677,5.755,8.677h1.567c4.566,0,5.697-8.521,5.697-8.521l-0.418-0.013\r\n\t\t\t\tc2.069-0.529,4.031-1.325,5.851-2.345c1.426,0.949,7.401,4.688,9.786,2.304l1.587-1.588c3.183-3.183-1.997-9.696-2.142-9.877\r\n\t\t\t\tc0.984-1.722,1.773-3.571,2.316-5.525c1.78-0.452,8.483-2.374,8.483-5.707v-1.566C63.988,26.73,56.016,25.533,55.518,25.462z\r\n\t\t\t\t M32,50c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C50,41.941,41.941,50,32,50z"},"children":[]}]}]}]}]}]}]}]};exports.cog=cog;var columns={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COLUMNS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COLUMNS"},"children":[{"name":"g","attribs":{"id":"COLUMNS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,6H3C1.343,6,0,7.343,0,9v46c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V9C64,7.343,62.657,6,61,6z M21,52H6V12h15\r\n\t\t\t\tV52z M40,52H24V12h16V52z M58,52H43V12h15V52z"},"children":[{"name":"path","attribs":{"d":"M61,6H3C1.343,6,0,7.343,0,9v46c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V9C64,7.343,62.657,6,61,6z M21,52H6V12h15\r\n\t\t\t\tV52z M40,52H24V12h16V52z M58,52H43V12h15V52z"},"children":[]}]}]}]}]}]}]}]};exports.columns=columns;var command={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMMAND"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,39h-6V25h6c6.627,0,12-5.372,12-12c0-6.628-5.372-12-12-12\r\n\t\t\tc-6.628,0-12,5.373-12,12v6H25v-6c0-6.628-5.373-12-12-12C6.373,1,1,6.373,1,13c0,6.627,5.373,12,12,12h6v14h-6\r\n\t\t\tC6.373,39,1,44.373,1,51c0,6.628,5.373,12,12,12c6.627,0,12-5.372,12-12v-6h14v6c0,6.628,5.372,12,12,12c6.627,0,12-5.372,12-12\r\n\t\t\tC63,44.373,57.627,39,51,39z M45,13c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6s-2.686,6-6,6h-6V13z M19,51c0,3.314-2.686,6-6,6\r\n\t\t\tc-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6h6V51z M19,19h-6c-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6V19z M39,39H25\r\n\t\t\tV25h14V39z M51,57c-3.314,0-6-2.686-6-6v-6h7v0.101c2.835,0.478,5,2.928,5,5.899C57,54.314,54.314,57,51,57z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,39h-6V25h6c6.627,0,12-5.372,12-12c0-6.628-5.372-12-12-12\r\n\t\t\tc-6.628,0-12,5.373-12,12v6H25v-6c0-6.628-5.373-12-12-12C6.373,1,1,6.373,1,13c0,6.627,5.373,12,12,12h6v14h-6\r\n\t\t\tC6.373,39,1,44.373,1,51c0,6.628,5.373,12,12,12c6.627,0,12-5.372,12-12v-6h14v6c0,6.628,5.372,12,12,12c6.627,0,12-5.372,12-12\r\n\t\t\tC63,44.373,57.627,39,51,39z M45,13c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6s-2.686,6-6,6h-6V13z M19,51c0,3.314-2.686,6-6,6\r\n\t\t\tc-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6h6V51z M19,19h-6c-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6V19z M39,39H25\r\n\t\t\tV25h14V39z M51,57c-3.314,0-6-2.686-6-6v-6h7v0.101c2.835,0.478,5,2.928,5,5.899C57,54.314,54.314,57,51,57z"},"children":[]}]}]}]}]}]};exports.command=command;var compass={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPASS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPASS"},"children":[{"name":"g","attribs":{"id":"COMPASS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M16,16l9,22l23,10l-9-23L16,16z M32,35c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S33.657,35,32,35z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M16,16l9,22l23,10l-9-23L16,16z M32,35c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S33.657,35,32,35z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.64,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.compass=compass;var computer_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,28h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3s-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3S24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26\r\n\t\t\t\tv-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"d":"M26,28h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3s-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3S24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26\r\n\t\t\t\tv-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]}]};exports.computer_add=computer_add;var computer_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC63,5.343,61.657,4,60,4z M59,42H5V8h54V42z M23,31c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,29.243l3.879,3.879\r\n\t\t\t\tC36.422,33.664,37.172,34,38,34c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,25l3.879-3.879\r\n\t\t\t\tC40.664,20.578,41,19.828,41,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,20.757l-3.879-3.879\r\n\t\t\t\tC27.578,16.336,26.828,16,26,16c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,25l-3.879,3.879\r\n\t\t\t\tC23.336,29.422,23,30.172,23,31z"},"children":[{"name":"path","attribs":{"d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC63,5.343,61.657,4,60,4z M59,42H5V8h54V42z M23,31c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,29.243l3.879,3.879\r\n\t\t\t\tC36.422,33.664,37.172,34,38,34c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,25l3.879-3.879\r\n\t\t\t\tC40.664,20.578,41,19.828,41,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,20.757l-3.879-3.879\r\n\t\t\t\tC27.578,16.336,26.828,16,26,16c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,25l-3.879,3.879\r\n\t\t\t\tC23.336,29.422,23,30.172,23,31z"},"children":[]}]}]}]}]}]}]}]};exports.computer_delete=computer_delete;var computer_download={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M22,19c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,28.664,31.172,29,32,29s1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tC41.664,20.579,42,19.828,42,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,18.758V5c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v13.757l-1.879-1.879C26.578,16.336,25.828,16,25,16C23.343,16,22,17.343,22,19z M60,6H38v4h21v34H5V10h21V6H4\r\n\t\t\t\tC2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9C63,7.343,61.657,6,60,6z"},"children":[{"name":"path","attribs":{"d":"M22,19c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,28.664,31.172,29,32,29s1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tC41.664,20.579,42,19.828,42,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,18.758V5c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v13.757l-1.879-1.879C26.578,16.336,25.828,16,25,16C23.343,16,22,17.343,22,19z M60,6H38v4h21v34H5V10h21V6H4\r\n\t\t\t\tC2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9C63,7.343,61.657,6,60,6z"},"children":[]}]}]}]}]}]}]}]};exports.computer_download=computer_download;var computer_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__OK"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M27.879,31.121C28.422,31.664,29.172,32,30,32c0.829,0,1.578-0.336,2.121-0.879l8-8C40.664,22.578,41,21.829,41,21\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L30,24.757l-1.879-1.879C27.578,22.336,26.828,22,26,22\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.879,31.121z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5\r\n\t\t\t\tl-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"d":"M27.879,31.121C28.422,31.664,29.172,32,30,32c0.829,0,1.578-0.336,2.121-0.879l8-8C40.664,22.578,41,21.829,41,21\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L30,24.757l-1.879-1.879C27.578,22.336,26.828,22,26,22\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.879,31.121z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5\r\n\t\t\t\tl-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]}]};exports.computer_ok=computer_ok;var computer_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,28h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H26c-1.657,0-3,1.343-3,3S24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40\r\n\t\t\t\tc0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"d":"M26,28h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H26c-1.657,0-3,1.343-3,3S24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40\r\n\t\t\t\tc0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]}]};exports.computer_remove=computer_remove;var computer_upload={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M25,15c0.829,0,1.579-0.336,2.121-0.879L29,12.243V26c0,1.657,1.343,3,3,3s3-1.343,3-3V12.243l1.879,1.879\r\n\t\t\t\tC37.422,14.664,38.172,15,39,15c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,2.336,32.829,2,32,2\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,10.422,22,11.172,22,12C22,13.657,23.343,15,25,15z M60,6H41.484l4,4H59v34H5V10\r\n\t\t\t\th13.515l4-4H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC63,7.343,61.657,6,60,6z"},"children":[{"name":"path","attribs":{"d":"M25,15c0.829,0,1.579-0.336,2.121-0.879L29,12.243V26c0,1.657,1.343,3,3,3s3-1.343,3-3V12.243l1.879,1.879\r\n\t\t\t\tC37.422,14.664,38.172,15,39,15c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,2.336,32.829,2,32,2\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,10.422,22,11.172,22,12C22,13.657,23.343,15,25,15z M60,6H41.484l4,4H59v34H5V10\r\n\t\t\t\th13.515l4-4H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC63,7.343,61.657,6,60,6z"},"children":[]}]}]}]}]}]}]}]};exports.computer_upload=computer_upload;var copy_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COPY_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38,58h-9v0H16v0H6V26h11v-6H3c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h10\r\n\t\t\tv0h17v0h11c1.657,0,3-1.343,3-3V47h-6V58z M61,0H23c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V3\r\n\t\t\tC64,1.343,62.657,0,61,0z M58,38h-9v0H36v0H26V6h32V38z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M38,58h-9v0H16v0H6V26h11v-6H3c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h10\r\n\t\t\tv0h17v0h11c1.657,0,3-1.343,3-3V47h-6V58z M61,0H23c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V3\r\n\t\t\tC64,1.343,62.657,0,61,0z M58,38h-9v0H36v0H26V6h32V38z"},"children":[]}]}]}]}]}]};exports.copy_1=copy_1;var copy_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"COPY"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,20H3c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3\r\n\t\t\tV23C44,21.343,42.657,20,41,20z M38,58H6V26h9v0h13v0h10V58z M61,0H23c-1.657,0-3,1.343-3,3v14h6V6h9v0h13v0h10v32H47v6h14\r\n\t\t\tc1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,20H3c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3\r\n\t\t\tV23C44,21.343,42.657,20,41,20z M38,58H6V26h9v0h13v0h10V58z M61,0H23c-1.657,0-3,1.343-3,3v14h6V6h9v0h13v0h10v32H47v6h14\r\n\t\t\tc1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z"},"children":[]}]}]}]}]}]};exports.copy_2=copy_2;var credit_card={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CREDIT_CARD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CREDIT_CARD"},"children":[{"name":"g","attribs":{"id":"CREDIT_CARD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,51c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V28H0V51z M6,39h30v3H6V39z M6,45h12v3H6V45z M61,10H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v9h64v-9C64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"d":"M0,51c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V28H0V51z M6,39h30v3H6V39z M6,45h12v3H6V45z M61,10H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v9h64v-9C64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]}]};exports.credit_card=credit_card;var crop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"CROP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,49h-6V13.243l8.121-8.121C63.664,4.579,64,3.828,64,3c0-1.657-1.343-3-3-3\r\n\t\t\tc-0.829,0-1.578,0.336-2.121,0.879L50.757,9H15V3c0-1.657-1.343-3-3-3S9,1.343,9,3v6H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3\r\n\t\t\th6v35.758l-0.121,0.121L9,51v1.5c0,1.381,1.119,2.5,2.5,2.5H13l0.121,0.121L13.243,55H49v6c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3v-6h6c1.657,0,3-1.343,3-3C64,50.343,62.657,49,61,49z M15,15h29.757L15,44.757V15z M49,49H19.243L49,19.243\r\n\t\t\tV49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,49h-6V13.243l8.121-8.121C63.664,4.579,64,3.828,64,3c0-1.657-1.343-3-3-3\r\n\t\t\tc-0.829,0-1.578,0.336-2.121,0.879L50.757,9H15V3c0-1.657-1.343-3-3-3S9,1.343,9,3v6H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3\r\n\t\t\th6v35.758l-0.121,0.121L9,51v1.5c0,1.381,1.119,2.5,2.5,2.5H13l0.121,0.121L13.243,55H49v6c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3v-6h6c1.657,0,3-1.343,3-3C64,50.343,62.657,49,61,49z M15,15h29.757L15,44.757V15z M49,49H19.243L49,19.243\r\n\t\t\tV49z"},"children":[]}]}]}]}]}]};exports.crop=crop;var diskette={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DISKETTE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,25.001c0,1.661,1.343,3.007,3,3.007h4V28h18v0.008h4\r\n\t\t\tc1.657,0,3-1.346,3-3.007V19h0V1H15v18h0V25.001z M32,5h9v19h-9V5z M63.121,10.879l-9-9C53.578,1.336,52.829,1,52,1h-2v15h0v9.001\r\n\t\t\tc0,3.272-2.61,5.92-5.856,5.999H17.856C14.611,30.922,12,28.273,12,25.001V16h0V1H3C1.343,1,0,2.343,0,4v56c0,1.657,1.343,3,3,3\r\n\t\t\th58c1.657,0,3-1.343,3-3V13C64,12.172,63.664,11.422,63.121,10.879z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,25.001c0,1.661,1.343,3.007,3,3.007h4V28h18v0.008h4\r\n\t\t\tc1.657,0,3-1.346,3-3.007V19h0V1H15v18h0V25.001z M32,5h9v19h-9V5z M63.121,10.879l-9-9C53.578,1.336,52.829,1,52,1h-2v15h0v9.001\r\n\t\t\tc0,3.272-2.61,5.92-5.856,5.999H17.856C14.611,30.922,12,28.273,12,25.001V16h0V1H3C1.343,1,0,2.343,0,4v56c0,1.657,1.343,3,3,3\r\n\t\t\th58c1.657,0,3-1.343,3-3V13C64,12.172,63.664,11.422,63.121,10.879z"},"children":[]}]}]}]}]}]};exports.diskette=diskette;var documentIcon={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT"},"children":[{"name":"g","attribs":{"id":"DOCUMENT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M35,23.008h19L32,2.964v17.037C32,21.662,33.343,23.008,35,23.008z M29,20.001V3H13c-1.657,0-3,1.343-3,3v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V26.014H35C31.686,26.014,29,23.322,29,20.001z"},"children":[{"name":"path","attribs":{"d":"M35,23.008h19L32,2.964v17.037C32,21.662,33.343,23.008,35,23.008z M29,20.001V3H13c-1.657,0-3,1.343-3,3v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V26.014H35C31.686,26.014,29,23.322,29,20.001z"},"children":[]}]}]}]}]}]}]}]};exports.documentIcon=documentIcon;var document_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,22.008h19L28,1.964v17.037C28,20.662,29.343,22.008,31,22.008z M56,51h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S57.657,51,56,51z M38,54\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6V25.014H31c-3.314,0-6-2.692-6-6.013V1.964h-9V2H9C7.343,2,6,3.343,6,5v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h35l0,0C40.686,60,38,57.314,38,54z"},"children":[{"name":"path","attribs":{"d":"M31,22.008h19L28,1.964v17.037C28,20.662,29.343,22.008,31,22.008z M56,51h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S57.657,51,56,51z M38,54\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6V25.014H31c-3.314,0-6-2.692-6-6.013V1.964h-9V2H9C7.343,2,6,3.343,6,5v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h35l0,0C40.686,60,38,57.314,38,54z"},"children":[]}]}]}]}]}]}]}]};exports.document_add=document_add;var document_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M30,22.008h19L27,1.964v17.037C27,20.662,28.343,22.008,30,22.008z M41.516,54l-1.758-1.757\r\n\t\t\t\tC38.672,51.157,38,49.657,38,48c0-3.314,2.686-6,6-6c1.657,0,3.152,0.675,4.238,1.762l0.005-0.005L49,44.516v-19.5H30\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V2H8C6.343,2,5,3.343,5,5v52c0,1.657,1.343,3,3,3h28l0,0h2c0-1.657,0.672-3.156,1.758-4.242\r\n\t\t\t\tl-0.001-0.001L41.516,54z M54.243,54l3.879-3.878C58.664,49.578,59,48.828,59,48c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L50,49.758l-3.879-3.879C45.578,45.336,44.829,45,44,45c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L45.757,54l-3.879,3.879C41.336,58.422,41,59.172,41,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L50,58.243l3.879,3.879C54.422,62.664,55.172,63,56,63c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L54.243,54z"},"children":[{"name":"path","attribs":{"d":"M30,22.008h19L27,1.964v17.037C27,20.662,28.343,22.008,30,22.008z M41.516,54l-1.758-1.757\r\n\t\t\t\tC38.672,51.157,38,49.657,38,48c0-3.314,2.686-6,6-6c1.657,0,3.152,0.675,4.238,1.762l0.005-0.005L49,44.516v-19.5H30\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V2H8C6.343,2,5,3.343,5,5v52c0,1.657,1.343,3,3,3h28l0,0h2c0-1.657,0.672-3.156,1.758-4.242\r\n\t\t\t\tl-0.001-0.001L41.516,54z M54.243,54l3.879-3.878C58.664,49.578,59,48.828,59,48c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L50,49.758l-3.879-3.879C45.578,45.336,44.829,45,44,45c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L45.757,54l-3.879,3.879C41.336,58.422,41,59.172,41,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L50,58.243l3.879,3.879C54.422,62.664,55.172,63,56,63c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L54.243,54z"},"children":[]}]}]}]}]}]}]}]};exports.document_delete=document_delete;var document_download={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,53c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0.343,0,0.673,0.046,1,0.102V39c0-3.314,2.686-6,6-6l0,0v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8C6.343,1,5,2.343,5,4v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h31.516l-1.758-1.757C36.672,56.157,36,54.657,36,53z M56,50c-0.828,0-1.578,0.336-2.121,0.879L52,52.757V39\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879C43.578,50.336,42.828,50,42,50c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l7,7C47.422,62.664,48.172,63,49,63s1.578-0.336,2.121-0.879l7-7C58.664,54.579,59,53.829,59,53\r\n\t\t\t\tC59,51.343,57.657,50,56,50z"},"children":[{"name":"path","attribs":{"d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,53c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0.343,0,0.673,0.046,1,0.102V39c0-3.314,2.686-6,6-6l0,0v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8C6.343,1,5,2.343,5,4v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h31.516l-1.758-1.757C36.672,56.157,36,54.657,36,53z M56,50c-0.828,0-1.578,0.336-2.121,0.879L52,52.757V39\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879C43.578,50.336,42.828,50,42,50c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l7,7C47.422,62.664,48.172,63,49,63s1.578-0.336,2.121-0.879l7-7C58.664,54.579,59,53.829,59,53\r\n\t\t\t\tC59,51.343,57.657,50,56,50z"},"children":[]}]}]}]}]}]}]}]};exports.document_download=document_download;var document_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M30,23.008h19L27,2.964v17.037C27,21.662,28.343,23.008,30,23.008z M56,48c-0.828,0-1.578,0.336-2.121,0.879L48,54.757\r\n\t\t\t\tl-1.879-1.879C45.578,52.336,44.828,52,44,52c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4\r\n\t\t\t\tC46.422,61.664,47.172,62,48,62s1.578-0.336,2.121-0.879l8-8C58.664,52.579,59,51.828,59,51C59,49.343,57.657,48,56,48z M38,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6c1.533,0,2.909,0.6,3.967,1.547L49,49.516v-23.5H30c-3.314,0-6-2.692-6-6.013V3H8C6.343,3,5,4.343,5,6v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h23l0,0h10.516l-1.758-1.757C38.672,58.157,38,56.657,38,55z"},"children":[{"name":"path","attribs":{"d":"M30,23.008h19L27,2.964v17.037C27,21.662,28.343,23.008,30,23.008z M56,48c-0.828,0-1.578,0.336-2.121,0.879L48,54.757\r\n\t\t\t\tl-1.879-1.879C45.578,52.336,44.828,52,44,52c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4\r\n\t\t\t\tC46.422,61.664,47.172,62,48,62s1.578-0.336,2.121-0.879l8-8C58.664,52.579,59,51.828,59,51C59,49.343,57.657,48,56,48z M38,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6c1.533,0,2.909,0.6,3.967,1.547L49,49.516v-23.5H30c-3.314,0-6-2.692-6-6.013V3H8C6.343,3,5,4.343,5,6v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h23l0,0h10.516l-1.758-1.757C38.672,58.157,38,56.657,38,55z"},"children":[]}]}]}]}]}]}]}]};exports.document_ok=document_ok;var document_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,23.008h19L28,2.964v17.037C28,21.662,29.343,23.008,31,23.008z M38,55c0-3.314,2.686-6,6-6h6V26.014H31\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V2.964h-9V3H9C7.343,3,6,4.343,6,6v52c0,1.657,1.343,3,3,3h35l0,0C40.686,61,38,58.314,38,55z M56,52\r\n\t\t\t\tH44c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S57.657,52,56,52z"},"children":[{"name":"path","attribs":{"d":"M31,23.008h19L28,2.964v17.037C28,21.662,29.343,23.008,31,23.008z M38,55c0-3.314,2.686-6,6-6h6V26.014H31\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V2.964h-9V3H9C7.343,3,6,4.343,6,6v52c0,1.657,1.343,3,3,3h35l0,0C40.686,61,38,58.314,38,55z M56,52\r\n\t\t\t\tH44c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S57.657,52,56,52z"},"children":[]}]}]}]}]}]}]}]};exports.document_remove=document_remove;var document_upload={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,46c0-1.657,0.672-3.157,1.757-4.243l7-7\r\n\t\t\t\tC45.843,33.672,47.343,33,49,33v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8C6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h35v-7.102\r\n\t\t\t\tC42.673,51.954,42.343,52,42,52C38.686,52,36,49.314,36,46z M58.121,43.879l-7-7C50.578,36.336,49.828,36,49,36\r\n\t\t\t\ts-1.578,0.336-2.121,0.879l-7,7C39.336,44.422,39,45.172,39,46c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L46,46.243\r\n\t\t\t\tV60c0,1.657,1.343,3,3,3s3-1.343,3-3V46.243l1.879,1.879C54.422,48.664,55.172,49,56,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tC59,45.172,58.664,44.422,58.121,43.879z"},"children":[{"name":"path","attribs":{"d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,46c0-1.657,0.672-3.157,1.757-4.243l7-7\r\n\t\t\t\tC45.843,33.672,47.343,33,49,33v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8C6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h35v-7.102\r\n\t\t\t\tC42.673,51.954,42.343,52,42,52C38.686,52,36,49.314,36,46z M58.121,43.879l-7-7C50.578,36.336,49.828,36,49,36\r\n\t\t\t\ts-1.578,0.336-2.121,0.879l-7,7C39.336,44.422,39,45.172,39,46c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L46,46.243\r\n\t\t\t\tV60c0,1.657,1.343,3,3,3s3-1.343,3-3V46.243l1.879,1.879C54.422,48.664,55.172,49,56,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tC59,45.172,58.664,44.422,58.121,43.879z"},"children":[]}]}]}]}]}]}]}]};exports.document_upload=document_upload;var documents={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOCUMENTS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENTS"},"children":[{"name":"g","attribs":{"id":"DOCUMENTS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,17.001V0H16c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V23.015H38\r\n\t\t\t\tC34.686,23.015,32,20.322,32,17.001z M38,20.008h19L35-0.036v17.037C35,18.662,36.343,20.008,38,20.008z M10,55V6\r\n\t\t\t\tC8.343,6,7,7.343,7,9v49c0,3.314,2.686,6,6,6h35c1.657,0,3-1.343,3-3H16C12.686,61,10,58.314,10,55z"},"children":[{"name":"path","attribs":{"d":"M32,17.001V0H16c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V23.015H38\r\n\t\t\t\tC34.686,23.015,32,20.322,32,17.001z M38,20.008h19L35-0.036v17.037C35,18.662,36.343,20.008,38,20.008z M10,55V6\r\n\t\t\t\tC8.343,6,7,7.343,7,9v49c0,3.314,2.686,6,6,6h35c1.657,0,3-1.343,3-3H16C12.686,61,10,58.314,10,55z"},"children":[]}]}]}]}]}]}]}]};exports.documents=documents;var download={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DOWNLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOWNLOAD"},"children":[{"name":"g","attribs":{"id":"DOWNLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M20.77,29.007l9,10l0,0C30.319,39.616,31.115,40,32,40s1.68-0.384,2.23-0.993l0,0l9-10l0,0\r\n\t\t\t\tC43.708,28.475,44,27.772,44,27c0-1.657-1.343-3-3-3c-0.885,0-1.682,0.383-2.23,0.993l0,0L35,29.182V11c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v18.182l-3.77-4.189l0,0C24.681,24.384,23.885,24,23,24c-1.657,0-3,1.343-3,3C20,27.772,20.292,28.475,20.77,29.007\r\n\t\t\t\tL20.77,29.007z M55,35c-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h22.997\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0s0.002,0,0.003,0H55c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[{"name":"path","attribs":{"d":"M20.77,29.007l9,10l0,0C30.319,39.616,31.115,40,32,40s1.68-0.384,2.23-0.993l0,0l9-10l0,0\r\n\t\t\t\tC43.708,28.475,44,27.772,44,27c0-1.657-1.343-3-3-3c-0.885,0-1.682,0.383-2.23,0.993l0,0L35,29.182V11c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v18.182l-3.77-4.189l0,0C24.681,24.384,23.885,24,23,24c-1.657,0-3,1.343-3,3C20,27.772,20.292,28.475,20.77,29.007\r\n\t\t\t\tL20.77,29.007z M55,35c-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h22.997\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0s0.002,0,0.003,0H55c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[]}]}]}]}]}]}]}]};exports.download=download;var dribbble={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"dribbble_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"dribbble"},"children":[{"name":"g","attribs":{"id":"dribbble"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.35,25.558c-0.42-2.056-1.049-4.081-1.865-6.015c-0.803-1.899-1.795-3.727-2.951-5.436\r\n\t\t\t\tc-1.145-1.694-2.459-3.287-3.905-4.733c-1.448-1.449-3.04-2.764-4.735-3.907c-1.709-1.158-3.539-2.149-5.436-2.953\r\n\t\t\t\tC42.523,1.7,40.5,1.068,38.443,0.651c-2.107-0.433-4.276-0.652-6.442-0.652c-2.169,0-4.338,0.22-6.446,0.652\r\n\t\t\t\tc-2.056,0.417-4.08,1.049-6.013,1.863c-1.896,0.804-3.727,1.795-5.437,2.953C12.411,6.61,10.818,7.924,9.37,9.373\r\n\t\t\t\tc-1.446,1.446-2.76,3.039-3.904,4.733c-1.156,1.709-2.149,3.537-2.951,5.436c-0.818,1.934-1.446,3.96-1.867,6.015\r\n\t\t\t\tc-0.431,2.103-0.65,4.273-0.65,6.44c0,2.172,0.219,4.342,0.65,6.448c0.421,2.056,1.049,4.08,1.867,6.013\r\n\t\t\t\tc0.802,1.896,1.795,3.729,2.951,5.438c1.144,1.694,2.458,3.285,3.904,4.733c1.447,1.446,3.04,2.759,4.734,3.904\r\n\t\t\t\tc1.711,1.155,3.541,2.149,5.437,2.95c1.933,0.82,3.957,1.445,6.013,1.867c2.109,0.435,4.277,0.651,6.446,0.651\r\n\t\t\t\tc2.167,0,4.335-0.217,6.441-0.651c2.058-0.422,4.082-1.047,6.015-1.867c1.896-0.801,3.728-1.795,5.437-2.95\r\n\t\t\t\tc1.693-1.146,3.287-2.458,4.734-3.904c1.446-1.448,2.762-3.039,3.905-4.733c1.155-1.709,2.149-3.541,2.95-5.438\r\n\t\t\t\tc0.817-1.933,1.447-3.957,1.867-6.013C63.781,36.339,64,34.17,64,31.997C64.001,29.831,63.783,27.661,63.35,25.558z M32.001,4.67\r\n\t\t\t\tc6.919,0,13.233,2.579,18.049,6.819c-0.067,0.106-3.96,6.03-14.276,9.896C31.104,12.802,25.971,5.982,25.56,5.441\r\n\t\t\t\tC27.626,4.941,29.78,4.67,32.001,4.67z M25.455,5.464c-0.001,0.003-0.005,0.005-0.005,0.005s-0.032,0.008-0.082,0.018\r\n\t\t\t\tC25.396,5.479,25.426,5.474,25.455,5.464z M20.34,7.282c0.363,0.488,5.417,7.34,10.148,15.747\r\n\t\t\t\tc-13.123,3.487-24.511,3.35-25.233,3.337C7.032,17.901,12.718,10.883,20.34,7.282z M11.673,50.264\r\n\t\t\t\tC7.321,45.421,4.672,39.02,4.672,31.997c0-0.291,0.013-0.576,0.023-0.862c0.481,0.01,13.986,0.316,28.057-3.894\r\n\t\t\t\tc0.784,1.532,1.532,3.09,2.219,4.645c-0.363,0.101-0.72,0.21-1.078,0.326c-14.75,4.767-22.23,18.038-22.23,18.038\r\n\t\t\t\tS11.671,50.258,11.673,50.264z M32.001,59.33c-6.338,0-12.157-2.176-16.793-5.795c-0.001,0.002-0.005,0.01-0.005,0.01\r\n\t\t\t\ts-0.252-0.188-0.612-0.479c0.199,0.164,0.413,0.31,0.617,0.469c0.1-0.217,5.39-11.471,21.442-17.062\r\n\t\t\t\tc0.06-0.022,0.121-0.041,0.182-0.058c3.846,9.993,5.434,18.362,5.838,20.751C39.393,58.559,35.785,59.33,32.001,59.33z\r\n\t\t\t\t M47.271,54.668c-0.277-1.65-1.733-9.671-5.319-19.521c8.823-1.412,16.468,1.008,17.032,1.192\r\n\t\t\t\tC57.768,43.955,53.408,50.523,47.271,54.668z M40.286,30.832c-0.192-0.468-0.388-0.938-0.589-1.411\r\n\t\t\t\tc-0.569-1.337-1.182-2.662-1.817-3.964c10.793-4.405,15.175-10.741,15.226-10.817c3.834,4.655,6.152,10.602,6.215,17.087\r\n\t\t\t\tC58.925,31.641,49.676,29.651,40.286,30.832z"},"children":[{"name":"path","attribs":{"d":"M63.35,25.558c-0.42-2.056-1.049-4.081-1.865-6.015c-0.803-1.899-1.795-3.727-2.951-5.436\r\n\t\t\t\tc-1.145-1.694-2.459-3.287-3.905-4.733c-1.448-1.449-3.04-2.764-4.735-3.907c-1.709-1.158-3.539-2.149-5.436-2.953\r\n\t\t\t\tC42.523,1.7,40.5,1.068,38.443,0.651c-2.107-0.433-4.276-0.652-6.442-0.652c-2.169,0-4.338,0.22-6.446,0.652\r\n\t\t\t\tc-2.056,0.417-4.08,1.049-6.013,1.863c-1.896,0.804-3.727,1.795-5.437,2.953C12.411,6.61,10.818,7.924,9.37,9.373\r\n\t\t\t\tc-1.446,1.446-2.76,3.039-3.904,4.733c-1.156,1.709-2.149,3.537-2.951,5.436c-0.818,1.934-1.446,3.96-1.867,6.015\r\n\t\t\t\tc-0.431,2.103-0.65,4.273-0.65,6.44c0,2.172,0.219,4.342,0.65,6.448c0.421,2.056,1.049,4.08,1.867,6.013\r\n\t\t\t\tc0.802,1.896,1.795,3.729,2.951,5.438c1.144,1.694,2.458,3.285,3.904,4.733c1.447,1.446,3.04,2.759,4.734,3.904\r\n\t\t\t\tc1.711,1.155,3.541,2.149,5.437,2.95c1.933,0.82,3.957,1.445,6.013,1.867c2.109,0.435,4.277,0.651,6.446,0.651\r\n\t\t\t\tc2.167,0,4.335-0.217,6.441-0.651c2.058-0.422,4.082-1.047,6.015-1.867c1.896-0.801,3.728-1.795,5.437-2.95\r\n\t\t\t\tc1.693-1.146,3.287-2.458,4.734-3.904c1.446-1.448,2.762-3.039,3.905-4.733c1.155-1.709,2.149-3.541,2.95-5.438\r\n\t\t\t\tc0.817-1.933,1.447-3.957,1.867-6.013C63.781,36.339,64,34.17,64,31.997C64.001,29.831,63.783,27.661,63.35,25.558z M32.001,4.67\r\n\t\t\t\tc6.919,0,13.233,2.579,18.049,6.819c-0.067,0.106-3.96,6.03-14.276,9.896C31.104,12.802,25.971,5.982,25.56,5.441\r\n\t\t\t\tC27.626,4.941,29.78,4.67,32.001,4.67z M25.455,5.464c-0.001,0.003-0.005,0.005-0.005,0.005s-0.032,0.008-0.082,0.018\r\n\t\t\t\tC25.396,5.479,25.426,5.474,25.455,5.464z M20.34,7.282c0.363,0.488,5.417,7.34,10.148,15.747\r\n\t\t\t\tc-13.123,3.487-24.511,3.35-25.233,3.337C7.032,17.901,12.718,10.883,20.34,7.282z M11.673,50.264\r\n\t\t\t\tC7.321,45.421,4.672,39.02,4.672,31.997c0-0.291,0.013-0.576,0.023-0.862c0.481,0.01,13.986,0.316,28.057-3.894\r\n\t\t\t\tc0.784,1.532,1.532,3.09,2.219,4.645c-0.363,0.101-0.72,0.21-1.078,0.326c-14.75,4.767-22.23,18.038-22.23,18.038\r\n\t\t\t\tS11.671,50.258,11.673,50.264z M32.001,59.33c-6.338,0-12.157-2.176-16.793-5.795c-0.001,0.002-0.005,0.01-0.005,0.01\r\n\t\t\t\ts-0.252-0.188-0.612-0.479c0.199,0.164,0.413,0.31,0.617,0.469c0.1-0.217,5.39-11.471,21.442-17.062\r\n\t\t\t\tc0.06-0.022,0.121-0.041,0.182-0.058c3.846,9.993,5.434,18.362,5.838,20.751C39.393,58.559,35.785,59.33,32.001,59.33z\r\n\t\t\t\t M47.271,54.668c-0.277-1.65-1.733-9.671-5.319-19.521c8.823-1.412,16.468,1.008,17.032,1.192\r\n\t\t\t\tC57.768,43.955,53.408,50.523,47.271,54.668z M40.286,30.832c-0.192-0.468-0.388-0.938-0.589-1.411\r\n\t\t\t\tc-0.569-1.337-1.182-2.662-1.817-3.964c10.793-4.405,15.175-10.741,15.226-10.817c3.834,4.655,6.152,10.602,6.215,17.087\r\n\t\t\t\tC58.925,31.641,49.676,29.651,40.286,30.832z"},"children":[]}]}]}]}]}]}]}]};exports.dribbble=dribbble;var drop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"DROP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.583,3.847c0,0-19.616,25.205-19.592,35.712\r\n\t\t\tc0.026,11.331,9.338,20.49,19.948,20.462c10.609-0.029,20.137-9.239,20.111-20.57C52.024,28.592,31.583,3.847,31.583,3.847z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.583,3.847c0,0-19.616,25.205-19.592,35.712\r\n\t\t\tc0.026,11.331,9.338,20.49,19.948,20.462c10.609-0.029,20.137-9.239,20.111-20.57C52.024,28.592,31.583,3.847,31.583,3.847z"},"children":[]}]}]}]}]}]};exports.drop=drop;var dropbox={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"dropbox_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"dropbox"},"children":[{"name":"g","attribs":{"id":"dropbox"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32.04,39.477L18.826,50.346l-5.654-3.662v4.105L32.04,62.003l18.864-11.215v-4.106l-5.652,3.662L32.04,39.477z\r\n\t\t\t\t M0.001,35.846l18.825,12.184L32,37.134L13.018,25.513L0.001,35.846z M32,37.134l13.174,10.896L64,35.846L50.982,25.513\r\n\t\t\t\tL32,37.134z M18.826,2.997L0.001,15.176l13.017,10.337L32,13.893L18.826,2.997z M63.999,15.176L45.174,2.997L32,13.893\r\n\t\t\t\tl18.982,11.619L63.999,15.176z"},"children":[{"name":"path","attribs":{"d":"M32.04,39.477L18.826,50.346l-5.654-3.662v4.105L32.04,62.003l18.864-11.215v-4.106l-5.652,3.662L32.04,39.477z\r\n\t\t\t\t M0.001,35.846l18.825,12.184L32,37.134L13.018,25.513L0.001,35.846z M32,37.134l13.174,10.896L64,35.846L50.982,25.513\r\n\t\t\t\tL32,37.134z M18.826,2.997L0.001,15.176l13.017,10.337L32,13.893L18.826,2.997z M63.999,15.176L45.174,2.997L32,13.893\r\n\t\t\t\tl18.982,11.619L63.999,15.176z"},"children":[]}]}]}]}]}]}]}]};exports.dropbox=dropbox;var eject={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"EJECT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"EJECT"},"children":[{"name":"g","attribs":{"id":"EJECT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M42,42H22c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3S43.657,42,42,42z M22,39h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.584-0.167-1.129-0.456-1.59l0,0l-9.976-15.962c-0.004-0.005-0.006-0.01-0.01-0.016l-0.015-0.022l0,0\r\n\t\t\t\tC34.014,17.563,33.073,17,32,17s-2.013,0.563-2.544,1.41l0,0l-0.014,0.022c-0.003,0.005-0.007,0.01-0.01,0.016L19.456,34.41l0,0\r\n\t\t\t\tC19.168,34.871,19,35.416,19,36C19,37.657,20.343,39,22,39z"},"children":[{"name":"path","attribs":{"d":"M42,42H22c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3S43.657,42,42,42z M22,39h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.584-0.167-1.129-0.456-1.59l0,0l-9.976-15.962c-0.004-0.005-0.006-0.01-0.01-0.016l-0.015-0.022l0,0\r\n\t\t\t\tC34.014,17.563,33.073,17,32,17s-2.013,0.563-2.544,1.41l0,0l-0.014,0.022c-0.003,0.005-0.007,0.01-0.01,0.016L19.456,34.41l0,0\r\n\t\t\t\tC19.168,34.871,19,35.416,19,36C19,37.657,20.343,39,22,39z"},"children":[]}]}]}]}]}]}]}]};exports.eject=eject;var equalizer={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"EQUALIZER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"EQUALIZER"},"children":[{"name":"g","attribs":{"id":"EQUALIZER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M13,23H7c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V26C16,24.343,14.657,23,13,23z M13,3\r\n\t\t\t\tc0-1.657-1.343-3-3-3S7,1.343,7,3v17h6V3z M35,3c0-1.657-1.343-3-3-3s-3,1.343-3,3v25h6V3z M57,3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v9h6V3z M7,61c0,1.657,1.343,3,3,3s3-1.343,3-3V44H7V61z M57,15h-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C60,16.343,58.657,15,57,15z M51,61c0,1.657,1.343,3,3,3s3-1.343,3-3V36h-6V61z M29,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-9h-6V61z M35,31h-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V34\r\n\t\t\t\tC38,32.343,36.657,31,35,31z"},"children":[{"name":"path","attribs":{"d":"M13,23H7c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V26C16,24.343,14.657,23,13,23z M13,3\r\n\t\t\t\tc0-1.657-1.343-3-3-3S7,1.343,7,3v17h6V3z M35,3c0-1.657-1.343-3-3-3s-3,1.343-3,3v25h6V3z M57,3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v9h6V3z M7,61c0,1.657,1.343,3,3,3s3-1.343,3-3V44H7V61z M57,15h-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C60,16.343,58.657,15,57,15z M51,61c0,1.657,1.343,3,3,3s3-1.343,3-3V36h-6V61z M29,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-9h-6V61z M35,31h-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V34\r\n\t\t\t\tC38,32.343,36.657,31,35,31z"},"children":[]}]}]}]}]}]}]}]};exports.equalizer=equalizer;var facebook_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"facebook_2_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"facebook_1_"},"children":[{"name":"g","attribs":{"id":"facebook_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M36.963,22.048c0.092-3.345-0.525-8.003,0.516-9.593c1.901-2.911,9.496-2.154,9.496-2.154s0-6.612,0-10.303\r\n\t\t\t\tc-11.982,0-15.904-0.501-20.016,3.675c-3.658,3.715-3.771,11.011-4.072,18.375h-5.872V32.12h5.938\r\n\t\t\t\tc-0.002,10.504,0.003,22.016,0,31.884c4.462,0,13.954,0,13.954,0v-32.01c0,0,5.173,0,8.042,0\r\n\t\t\t\tc0.626-3.385,1.236-6.036,2.088-9.947L36.963,22.048L36.963,22.048z"},"children":[{"name":"path","attribs":{"d":"M36.963,22.048c0.092-3.345-0.525-8.003,0.516-9.593c1.901-2.911,9.496-2.154,9.496-2.154s0-6.612,0-10.303\r\n\t\t\t\tc-11.982,0-15.904-0.501-20.016,3.675c-3.658,3.715-3.771,11.011-4.072,18.375h-5.872V32.12h5.938\r\n\t\t\t\tc-0.002,10.504,0.003,22.016,0,31.884c4.462,0,13.954,0,13.954,0v-32.01c0,0,5.173,0,8.042,0\r\n\t\t\t\tc0.626-3.385,1.236-6.036,2.088-9.947L36.963,22.048L36.963,22.048z"},"children":[]}]}]}]}]}]}]}]};exports.facebook_1=facebook_1;var facebook_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"facebook_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"facebook"},"children":[{"name":"g","attribs":{"id":"facebook"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M59.059-0.006H4.942c-2.722,0-4.929,2.208-4.929,4.932v54.354c0,2.725,2.207,4.728,4.929,4.728h54.117\r\n\t\t\t\tc2.721,0,4.928-2.002,4.928-4.728V4.926C63.986,2.202,61.781-0.006,59.059-0.006z M33.615,21.199\r\n\t\t\t\tc-1.562-0.912-2.803-1.634-4.351-1.634c-1.523,0-2.836,0.383-3.497,1.024c-0.661,0.64-0.992,1.872-0.992,3.692v2.691h8.148\r\n\t\t\t\tl-1.768,7.494h-6.381v24.894H14.545V34.465H9.759v-7.494h4.787v-2.859c0-3.012,0.355-4.817,1.067-6.301\r\n\t\t\t\tc0.711-1.483,2.089-3.134,3.998-4.066c1.909-0.932,4.741-1.399,7.661-1.399c2.995,0,5.337,0.994,8.208,1.803L33.615,21.199z"},"children":[{"name":"path","attribs":{"d":"M59.059-0.006H4.942c-2.722,0-4.929,2.208-4.929,4.932v54.354c0,2.725,2.207,4.728,4.929,4.728h54.117\r\n\t\t\t\tc2.721,0,4.928-2.002,4.928-4.728V4.926C63.986,2.202,61.781-0.006,59.059-0.006z M33.615,21.199\r\n\t\t\t\tc-1.562-0.912-2.803-1.634-4.351-1.634c-1.523,0-2.836,0.383-3.497,1.024c-0.661,0.64-0.992,1.872-0.992,3.692v2.691h8.148\r\n\t\t\t\tl-1.768,7.494h-6.381v24.894H14.545V34.465H9.759v-7.494h4.787v-2.859c0-3.012,0.355-4.817,1.067-6.301\r\n\t\t\t\tc0.711-1.483,2.089-3.134,3.998-4.066c1.909-0.932,4.741-1.399,7.661-1.399c2.995,0,5.337,0.994,8.208,1.803L33.615,21.199z"},"children":[]}]}]}]}]}]}]}]};exports.facebook_2=facebook_2;var fast_forward={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FAST_FORWARD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FAST_FORWARD"},"children":[{"name":"g","attribs":{"id":"FAST_FORWARD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M51,32c0-1.073-0.562-2.013-1.41-2.544l0,0l-0.021-0.014c-0.006-0.003-0.01-0.007-0.017-0.01L33.59,19.456l0,0\r\n\t\t\t\tC33.129,19.168,32.584,19,32,19c-1.657,0-3,1.343-3,3v4.587l-11.41-7.131l0,0C17.129,19.168,16.584,19,16,19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L29,37.413V42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.584,0,1.129-0.167,1.59-0.456l0,0l15.962-9.976c0.005-0.004,0.011-0.008,0.017-0.01l0.021-0.015l0,0\r\n\t\t\t\tC50.438,34.014,51,33.073,51,32z"},"children":[{"name":"path","attribs":{"d":"M51,32c0-1.073-0.562-2.013-1.41-2.544l0,0l-0.021-0.014c-0.006-0.003-0.01-0.007-0.017-0.01L33.59,19.456l0,0\r\n\t\t\t\tC33.129,19.168,32.584,19,32,19c-1.657,0-3,1.343-3,3v4.587l-11.41-7.131l0,0C17.129,19.168,16.584,19,16,19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L29,37.413V42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.584,0,1.129-0.167,1.59-0.456l0,0l15.962-9.976c0.005-0.004,0.011-0.008,0.017-0.01l0.021-0.015l0,0\r\n\t\t\t\tC50.438,34.014,51,33.073,51,32z"},"children":[]}]}]}]}]}]}]}]};exports.fast_forward=fast_forward;var first_aid={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FIRST_AID"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,18H47c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15H3\r\n\t\t\tc-1.657,0-3,1.343-3,3v37c0,1.657,1.343,3,3,3h5v0h3v0h42v0h3v0h5c1.657,0,3-1.343,3-3V21C64,19.343,62.657,18,61,18z M32,9\r\n\t\t\tc4.971,0,9,4.029,9,9H23C23,13.03,27.03,9,32,9z M43,42h-8v8c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-8h-8\r\n\t\t\tc-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h8v-8c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v8h8c1.657,0,3,1.343,3,3\r\n\t\t\tC46,40.657,44.657,42,43,42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,18H47c0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15H3\r\n\t\t\tc-1.657,0-3,1.343-3,3v37c0,1.657,1.343,3,3,3h5v0h3v0h42v0h3v0h5c1.657,0,3-1.343,3-3V21C64,19.343,62.657,18,61,18z M32,9\r\n\t\t\tc4.971,0,9,4.029,9,9H23C23,13.03,27.03,9,32,9z M43,42h-8v8c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-8h-8\r\n\t\t\tc-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h8v-8c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v8h8c1.657,0,3,1.343,3,3\r\n\t\t\tC46,40.657,44.657,42,43,42z"},"children":[]}]}]}]}]}]};exports.first_aid=first_aid;var folder={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLDER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER"},"children":[{"name":"g","attribs":{"id":"FOLDER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,54c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V22H0V54z M61,13H23.982L18,7H3c-1.657,0-3,1.343-3,3v9h64v-3\r\n\t\t\t\tC64,14.343,62.657,13,61,13z"},"children":[{"name":"path","attribs":{"d":"M0,54c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V22H0V54z M61,13H23.982L18,7H3c-1.657,0-3,1.343-3,3v9h64v-3\r\n\t\t\t\tC64,14.343,62.657,13,61,13z"},"children":[]}]}]}]}]}]}]}]};exports.folder=folder;var folder_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_2_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_1_"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M60,49h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S61.657,49,60,49z M0,51c0,1.657,1.343,3,3,3h39.367C42.145,53.372,42,52.705,42,52\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6c1.544,0,2.938,0.6,4,1.557V19H0V51z M61,10H23.982L18,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v9h64v-3C64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"d":"M60,49h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S61.657,49,60,49z M0,51c0,1.657,1.343,3,3,3h39.367C42.145,53.372,42,52.705,42,52\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6c1.544,0,2.938,0.6,4,1.557V19H0V51z M61,10H23.982L18,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v9h64v-3C64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]}]};exports.folder_add=folder_add;var folder_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,47.757l-3.879-3.879C50.578,43.336,49.828,43,49,43\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L50.757,52l-3.879,3.879C46.336,56.422,46,57.172,46,58\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,56.243l3.879,3.879C59.422,60.664,60.172,61,61,61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L59.243,52l3.879-3.879C63.664,47.578,64,46.829,64,46z M0,51c0,1.657,1.343,3,3,3h41l0,0h0.557\r\n\t\t\t\tc0.07-0.078,0.127-0.168,0.2-0.243L46.516,52l-1.758-1.758C43.672,49.157,43,47.657,43,46c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.657,0,3.157,0.672,4.243,1.757L55,43.516l1.757-1.758C57.843,40.672,59.343,40,61,40c1.098,0,2.113,0.316,3,0.832V19H0V51z\r\n\t\t\t\t M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3C64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"d":"M64,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,47.757l-3.879-3.879C50.578,43.336,49.828,43,49,43\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L50.757,52l-3.879,3.879C46.336,56.422,46,57.172,46,58\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,56.243l3.879,3.879C59.422,60.664,60.172,61,61,61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L59.243,52l3.879-3.879C63.664,47.578,64,46.829,64,46z M0,51c0,1.657,1.343,3,3,3h41l0,0h0.557\r\n\t\t\t\tc0.07-0.078,0.127-0.168,0.2-0.243L46.516,52l-1.758-1.758C43.672,49.157,43,47.657,43,46c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.657,0,3.157,0.672,4.243,1.757L55,43.516l1.757-1.758C57.843,40.672,59.343,40,61,40c1.098,0,2.113,0.316,3,0.832V19H0V51z\r\n\t\t\t\t M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3C64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]}]};exports.folder_delete=folder_delete;var folder_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,46c-0.828,0-1.578,0.336-2.121,0.879L53,52.758l-1.879-1.879C50.578,50.336,49.828,50,49,50c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l4,4C51.422,59.664,52.172,60,53,60s1.578-0.336,2.121-0.879l8-8C63.664,50.579,64,49.828,64,49\r\n\t\t\t\tC64,47.343,62.657,46,61,46z M61,11H23.982L18,5H3C1.343,5,0,6.343,0,8v9h64v-3C64,12.343,62.657,11,61,11z M0,52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h40.367l0,0C43.145,54.372,43,53.705,43,53c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538\r\n\t\t\t\tl3.781-3.781C57.843,43.672,59.343,43,61,43c1.1,0,2.113,0.316,3,0.832V20H0V52z"},"children":[{"name":"path","attribs":{"d":"M61,46c-0.828,0-1.578,0.336-2.121,0.879L53,52.758l-1.879-1.879C50.578,50.336,49.828,50,49,50c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l4,4C51.422,59.664,52.172,60,53,60s1.578-0.336,2.121-0.879l8-8C63.664,50.579,64,49.828,64,49\r\n\t\t\t\tC64,47.343,62.657,46,61,46z M61,11H23.982L18,5H3C1.343,5,0,6.343,0,8v9h64v-3C64,12.343,62.657,11,61,11z M0,52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h40.367l0,0C43.145,54.372,43,53.705,43,53c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538\r\n\t\t\t\tl3.781-3.781C57.843,43.672,59.343,43,61,43c1.1,0,2.113,0.316,3,0.832V20H0V52z"},"children":[]}]}]}]}]}]}]}]};exports.folder_ok=folder_ok;var folder_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,54c0,1.657,1.343,3,3,3h39.367C42.145,56.372,42,55.705,42,55c0-3.314,2.686-6,6-6h12c1.544,0,2.938,0.6,4,1.557V22H0\r\n\t\t\t\tV54z M60,52H48c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S61.657,52,60,52z M61,13H23.982L18,7H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z"},"children":[{"name":"path","attribs":{"d":"M0,54c0,1.657,1.343,3,3,3h39.367C42.145,56.372,42,55.705,42,55c0-3.314,2.686-6,6-6h12c1.544,0,2.938,0.6,4,1.557V22H0\r\n\t\t\t\tV54z M60,52H48c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S61.657,52,60,52z M61,13H23.982L18,7H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z"},"children":[]}]}]}]}]}]}]}]};exports.folder_remove=folder_remove;var followers={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLLOWERS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLLOWERS"},"children":[{"name":"g","attribs":{"id":"FOLLOWERS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M34,53c0-1.657,0.672-3.157,1.757-4.242l7-7l0.017,0.018c0.379-0.375,0.806-0.702,1.272-0.969\r\n\t\t\t\tc-3.979-1.701-5.021-2.293-5.021-2.293l-0.055-5.894c0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491c-0.444-4.576-3.608-9.355-11.595-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.925c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047C0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h38.516\r\n\t\t\t\tl-5.758-5.758C34.672,56.157,34,54.657,34,53z M52.898,47h5.828c-0.789-0.725-1.662-1.391-2.713-1.913\r\n\t\t\t\tc-1.854-0.923-2.765-1.246-3.482-1.415C52.833,44.387,53,45.174,53,46C53,46.343,52.954,46.673,52.898,47z M47.243,56H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H47.243l1.879-1.879C49.664,47.579,50,46.828,50,46c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C37.336,51.422,37,52.172,37,53c0,0.829,0.336,1.578,0.879,2.121l7,7\r\n\t\t\t\tC45.422,62.664,46.172,63,47,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L47.243,56z M64.001,59.993\r\n\t\t\t\tc0,0,0-0.679-0.124-1.759C63.02,58.707,62.049,59,61,59h-8.104C52.953,59.326,53,59.657,53,60c0,1.1-0.316,2.114-0.832,3H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"d":"M34,53c0-1.657,0.672-3.157,1.757-4.242l7-7l0.017,0.018c0.379-0.375,0.806-0.702,1.272-0.969\r\n\t\t\t\tc-3.979-1.701-5.021-2.293-5.021-2.293l-0.055-5.894c0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491c-0.444-4.576-3.608-9.355-11.595-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.925c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047C0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h38.516\r\n\t\t\t\tl-5.758-5.758C34.672,56.157,34,54.657,34,53z M52.898,47h5.828c-0.789-0.725-1.662-1.391-2.713-1.913\r\n\t\t\t\tc-1.854-0.923-2.765-1.246-3.482-1.415C52.833,44.387,53,45.174,53,46C53,46.343,52.954,46.673,52.898,47z M47.243,56H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H47.243l1.879-1.879C49.664,47.579,50,46.828,50,46c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C37.336,51.422,37,52.172,37,53c0,0.829,0.336,1.578,0.879,2.121l7,7\r\n\t\t\t\tC45.422,62.664,46.172,63,47,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L47.243,56z M64.001,59.993\r\n\t\t\t\tc0,0,0-0.679-0.124-1.759C63.02,58.707,62.049,59,61,59h-8.104C52.953,59.326,53,59.657,53,60c0,1.1-0.316,2.114-0.832,3H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]}]};exports.followers=followers;var following={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FOLLOWING_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLLOWING"},"children":[{"name":"g","attribs":{"id":"FOLLOWING"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0-0.007-0.552-0.092-1.417L59.484,63H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z\r\n\t\t\t\t M48.102,59H40c-3.314,0-6-2.686-6-6s2.686-6,6-6h8.102C48.046,46.673,48,46.343,48,46c0-1.186,0.355-2.282,0.947-3.212\r\n\t\t\t\tc-0.609-0.213-1.332-0.486-2.247-0.865c-6.205-2.569-7.675-3.409-7.675-3.409l-0.055-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491\r\n\t\t\t\tc-0.443-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.353,3.046,7.353l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047C0,49.062,0,59.994,0,59.994h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.316,62.115,48,61.1,48,60C48,59.657,48.046,59.327,48.102,59z M64,53\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121l-7-7C55.578,43.336,54.828,43,54,43c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.757,50H40c-1.657,0-3,1.343-3,3s1.343,3,3,3h13.757l-1.879,1.879C51.336,58.422,51,59.172,51,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C63.664,54.578,64,53.829,64,53z"},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0-0.007-0.552-0.092-1.417L59.484,63H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z\r\n\t\t\t\t M48.102,59H40c-3.314,0-6-2.686-6-6s2.686-6,6-6h8.102C48.046,46.673,48,46.343,48,46c0-1.186,0.355-2.282,0.947-3.212\r\n\t\t\t\tc-0.609-0.213-1.332-0.486-2.247-0.865c-6.205-2.569-7.675-3.409-7.675-3.409l-0.055-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491\r\n\t\t\t\tc-0.443-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.353,3.046,7.353l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047C0,49.062,0,59.994,0,59.994h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.316,62.115,48,61.1,48,60C48,59.657,48.046,59.327,48.102,59z M64,53\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121l-7-7C55.578,43.336,54.828,43,54,43c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.757,50H40c-1.657,0-3,1.343-3,3s1.343,3,3,3h13.757l-1.879,1.879C51.336,58.422,51,59.172,51,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C63.664,54.578,64,53.829,64,53z"},"children":[]}]}]}]}]}]}]}]};exports.following=following;var font_size_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FONT_SIZE_DOWN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.798,52.919l-17-44l-0.007,0.002C22.358,7.799,21.275,7,20,7\r\n\t\t\tc-1.275,0-2.358,0.799-2.792,1.921l-0.006-0.002l-17,44l0.007,0.003C0.078,53.257,0,53.619,0,54c0,1.657,1.343,3,3,3\r\n\t\t\tc1.275,0,2.358-0.799,2.792-1.921l0.007,0.002L9.694,45h20.613l3.895,10.081l0.006-0.002C34.642,56.201,35.725,57,37,57\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.382-0.078-0.743-0.208-1.079L39.798,52.919z M12.012,39L20,18.324L27.988,39H12.012z M61,29H43\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.798,52.919l-17-44l-0.007,0.002C22.358,7.799,21.275,7,20,7\r\n\t\t\tc-1.275,0-2.358,0.799-2.792,1.921l-0.006-0.002l-17,44l0.007,0.003C0.078,53.257,0,53.619,0,54c0,1.657,1.343,3,3,3\r\n\t\t\tc1.275,0,2.358-0.799,2.792-1.921l0.007,0.002L9.694,45h20.613l3.895,10.081l0.006-0.002C34.642,56.201,35.725,57,37,57\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.382-0.078-0.743-0.208-1.079L39.798,52.919z M12.012,39L20,18.324L27.988,39H12.012z M61,29H43\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z"},"children":[]}]}]}]}]}]};exports.font_size_down=font_size_down;var font_size_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FONT_SIZE_UP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.798,52.919l-17-44l-0.006,0.002C22.358,7.799,21.276,7,20,7\r\n\t\t\tc-1.275,0-2.358,0.799-2.792,1.921l-0.007-0.002l-17,44l0.007,0.003C0.078,53.257,0,53.619,0,54c0,1.657,1.343,3,3,3\r\n\t\t\tc1.275,0,2.358-0.799,2.792-1.921l0.007,0.002L9.693,45h20.613l3.895,10.081l0.007-0.002C34.642,56.201,35.725,57,37,57\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.382-0.078-0.743-0.208-1.079L39.798,52.919z M12.012,39L20,18.324L27.988,39H12.012z M61,29h-6v-6\r\n\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6h-6c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6v6c0,1.657,1.343,3,3,3s3-1.343,3-3v-6h6\r\n\t\t\tc1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.798,52.919l-17-44l-0.006,0.002C22.358,7.799,21.276,7,20,7\r\n\t\t\tc-1.275,0-2.358,0.799-2.792,1.921l-0.007-0.002l-17,44l0.007,0.003C0.078,53.257,0,53.619,0,54c0,1.657,1.343,3,3,3\r\n\t\t\tc1.275,0,2.358-0.799,2.792-1.921l0.007,0.002L9.693,45h20.613l3.895,10.081l0.007-0.002C34.642,56.201,35.725,57,37,57\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.382-0.078-0.743-0.208-1.079L39.798,52.919z M12.012,39L20,18.324L27.988,39H12.012z M61,29h-6v-6\r\n\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6h-6c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6v6c0,1.657,1.343,3,3,3s3-1.343,3-3v-6h6\r\n\t\t\tc1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z"},"children":[]}]}]}]}]}]};exports.font_size_up=font_size_up;var forrst={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"forrst_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"forrst"},"children":[{"name":"g","attribs":{"id":"forrst"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M59.873,61.947L33.865,0.88c-0.229-0.538-0.747-0.883-1.321-0.883c-0.574,0-1.093,0.345-1.32,0.88L5.127,61.943\r\n\t\t\t\tc-0.194,0.457-0.15,0.98,0.116,1.396c0.267,0.412,0.719,0.663,1.205,0.663h22.123V50.667L20.714,48c-1.085,0-1.964-0.895-1.964-2\r\n\t\t\t\ts0.879-2,1.964-2l7.857,2.667V34c0-1.104,0.879-2,1.964-2h3.929c1.085,0,1.964,0.896,1.964,2v3l5.893-3\r\n\t\t\t\tc1.086,0,1.965,0.895,1.965,2c0,1.104-0.879,2-1.965,2l-5.893,3v7l9.821-6c1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2\r\n\t\t\t\tl-9.821,6v12.003h22.123c0.487,0,0.938-0.248,1.205-0.663C60.021,62.928,60.066,62.4,59.873,61.947z"},"children":[{"name":"path","attribs":{"d":"M59.873,61.947L33.865,0.88c-0.229-0.538-0.747-0.883-1.321-0.883c-0.574,0-1.093,0.345-1.32,0.88L5.127,61.943\r\n\t\t\t\tc-0.194,0.457-0.15,0.98,0.116,1.396c0.267,0.412,0.719,0.663,1.205,0.663h22.123V50.667L20.714,48c-1.085,0-1.964-0.895-1.964-2\r\n\t\t\t\ts0.879-2,1.964-2l7.857,2.667V34c0-1.104,0.879-2,1.964-2h3.929c1.085,0,1.964,0.896,1.964,2v3l5.893-3\r\n\t\t\t\tc1.086,0,1.965,0.895,1.965,2c0,1.104-0.879,2-1.965,2l-5.893,3v7l9.821-6c1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2\r\n\t\t\t\tl-9.821,6v12.003h22.123c0.487,0,0.938-0.248,1.205-0.663C60.021,62.928,60.066,62.4,59.873,61.947z"},"children":[]}]}]}]}]}]}]}]};exports.forrst=forrst;var foursquare={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"foursquare_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"foursquare"},"children":[{"name":"g","attribs":{"id":"foursquare"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41.523,27.182l-8.099-8.285c-2.222-2.189-5.667-2.189-7.89,0l-2.201,2.245c-2.46-1.881-5.468-3.047-8.815-3.047\r\n\t\t\t\tc-8.013,0-14.513,6.42-14.513,14.313c0,7.891,6.529,14.311,14.543,14.311c0.623,0,1.222-0.104,1.825-0.181l13.387,12.458\r\n\t\t\t\tl34.24-30.692V5.018L41.523,27.182z M14.725,43.102c-0.057,0-0.109,0.017-0.166,0.017c-5.998,0-10.877-4.806-10.877-10.71\r\n\t\t\t\tc0-5.907,4.879-10.712,10.877-10.712c2.338,0,4.494,0.748,6.27,1.991c2.776,1.942,4.604,5.119,4.604,8.722\r\n\t\t\t\tC25.434,38.257,20.642,43.014,14.725,43.102z M59.8,27.491L48.426,37.908L30.158,54.157l-9.723-8.753\r\n\t\t\t\tc2.691-1.211,4.978-3.209,6.487-5.69l3.794,3.925l13.511-13.911L59.8,13.77V27.491z"},"children":[{"name":"path","attribs":{"d":"M41.523,27.182l-8.099-8.285c-2.222-2.189-5.667-2.189-7.89,0l-2.201,2.245c-2.46-1.881-5.468-3.047-8.815-3.047\r\n\t\t\t\tc-8.013,0-14.513,6.42-14.513,14.313c0,7.891,6.529,14.311,14.543,14.311c0.623,0,1.222-0.104,1.825-0.181l13.387,12.458\r\n\t\t\t\tl34.24-30.692V5.018L41.523,27.182z M14.725,43.102c-0.057,0-0.109,0.017-0.166,0.017c-5.998,0-10.877-4.806-10.877-10.71\r\n\t\t\t\tc0-5.907,4.879-10.712,10.877-10.712c2.338,0,4.494,0.748,6.27,1.991c2.776,1.942,4.604,5.119,4.604,8.722\r\n\t\t\t\tC25.434,38.257,20.642,43.014,14.725,43.102z M59.8,27.491L48.426,37.908L30.158,54.157l-9.723-8.753\r\n\t\t\t\tc2.691-1.211,4.978-3.209,6.487-5.69l3.794,3.925l13.511-13.911L59.8,13.77V27.491z"},"children":[]}]}]}]}]}]}]}]};exports.foursquare=foursquare;var frame={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"FRAME_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FRAME"},"children":[{"name":"g","attribs":{"id":"FRAME"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3c-1.305,0-2.402,0.838-2.816,2\r\n\t\t\t\th-3.367C52.402,2.838,51.305,2,50,2s-2.402,0.838-2.816,2h-3.367C43.402,2.838,42.305,2,41,2s-2.402,0.838-2.816,2h-3.367\r\n\t\t\t\tC34.402,2.838,33.305,2,32,2c-1.304,0-2.403,0.838-2.816,2h-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC16.403,2.838,15.304,2,14,2s-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,11.597,2,12.696,2,14s0.837,2.403,2,2.816v3.367C2.837,20.597,2,21.696,2,23\r\n\t\t\t\ts0.837,2.403,2,2.816v3.367C2.837,29.597,2,30.696,2,32c0,1.305,0.837,2.402,2,2.816v3.367C2.837,38.598,2,39.695,2,41\r\n\t\t\t\ts0.837,2.402,2,2.816v3.367C2.837,47.598,2,48.695,2,50s0.837,2.402,2,2.816v3.367C2.837,56.598,2,57.695,2,59\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.815-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.402-0.837,2.816-2h3.367c0.412,1.162,1.512,2,2.815,2s2.403-0.837,2.815-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.656,0,3-1.343,3-3c0-1.305-0.837-2.402-2-2.816v-3.367c1.162-0.412,2-1.512,2-2.815\r\n\t\t\t\ts-0.837-2.403-2-2.815v-3.367c1.162-0.414,2-1.512,2-2.816c0-1.304-0.837-2.402-2-2.816v-3.367c1.162-0.412,2-1.512,2-2.815\r\n\t\t\t\ts-0.837-2.403-2-2.816V25.82c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z\r\n\t\t\t\t M54,54H10V10h44V54z"},"children":[{"name":"path","attribs":{"d":"M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3c-1.305,0-2.402,0.838-2.816,2\r\n\t\t\t\th-3.367C52.402,2.838,51.305,2,50,2s-2.402,0.838-2.816,2h-3.367C43.402,2.838,42.305,2,41,2s-2.402,0.838-2.816,2h-3.367\r\n\t\t\t\tC34.402,2.838,33.305,2,32,2c-1.304,0-2.403,0.838-2.816,2h-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC16.403,2.838,15.304,2,14,2s-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,11.597,2,12.696,2,14s0.837,2.403,2,2.816v3.367C2.837,20.597,2,21.696,2,23\r\n\t\t\t\ts0.837,2.403,2,2.816v3.367C2.837,29.597,2,30.696,2,32c0,1.305,0.837,2.402,2,2.816v3.367C2.837,38.598,2,39.695,2,41\r\n\t\t\t\ts0.837,2.402,2,2.816v3.367C2.837,47.598,2,48.695,2,50s0.837,2.402,2,2.816v3.367C2.837,56.598,2,57.695,2,59\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.815-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.402-0.837,2.816-2h3.367c0.412,1.162,1.512,2,2.815,2s2.403-0.837,2.815-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.656,0,3-1.343,3-3c0-1.305-0.837-2.402-2-2.816v-3.367c1.162-0.412,2-1.512,2-2.815\r\n\t\t\t\ts-0.837-2.403-2-2.815v-3.367c1.162-0.414,2-1.512,2-2.816c0-1.304-0.837-2.402-2-2.816v-3.367c1.162-0.412,2-1.512,2-2.815\r\n\t\t\t\ts-0.837-2.403-2-2.816V25.82c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z\r\n\t\t\t\t M54,54H10V10h44V54z"},"children":[]}]}]}]}]}]}]}]};exports.frame=frame;var globe={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"GLOBE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GLOBE"},"children":[{"name":"g","attribs":{"id":"GLOBE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31.446,19.655c0.015,0.03,0.03,0.059,0.044,0.089c0.057-0.013,0.103-0.074,0.133-0.115c0.012-0.009,0.004,0,0.013-0.013\r\n\t\t\t\tc-0.023-0.013-0.047-0.026-0.07-0.038c-0.002-0.004-0.004-0.008-0.006-0.013c0.069-0.055,0.095-0.122,0.076-0.235\r\n\t\t\t\tc-0.03-0.002-0.059-0.004-0.089-0.006c-0.026,0.029-0.04,0.127-0.051,0.165c-0.058-0.027-0.089-0.049-0.108-0.114\r\n\t\t\t\tc-0.004-0.002-0.009-0.004-0.013-0.006c-0.078,0.099-0.18,0.095-0.076,0.267C31.324,19.671,31.398,19.659,31.446,19.655z\r\n\t\t\t\t M43.382,11.985c0.203,0.031,0.324,0.15,0.496,0.203c-0.004,0.021-0.009,0.042-0.013,0.064c-0.084,0.038-0.182,0.051-0.172,0.172\r\n\t\t\t\tc0.094,0.018,0.164,0.009,0.279,0.006c0.026,0.034,0.051,0.068,0.076,0.102c0.094,0.039,0.143-0.06,0.21-0.083\r\n\t\t\t\tc0.155,0.002,0.31,0.004,0.464,0.007c-0.006-0.127-0.177-0.162-0.254-0.223c-0.136-0.107-0.215-0.333-0.254-0.534\r\n\t\t\t\tc-0.085-0.43,0.254-0.283,0.292-0.597c-0.065-0.023-0.131-0.047-0.196-0.07c-0.172-0.022-0.357,0.059-0.478,0.089\r\n\t\t\t\tc-0.072,0.004-0.144,0.008-0.216,0.013c-0.088,0.044-0.135,0.159-0.235,0.203c-0.004,0.007-0.009,0.013-0.013,0.019\r\n\t\t\t\tc0.051,0.026,0.093,0.062,0.165,0.064c-0.037,0.109-0.134,0.278-0.241,0.311c-0.072,0.022-0.115-0.021-0.172-0.019\r\n\t\t\t\tc-0.049,0.061-0.104,0.114-0.07,0.229c0.02,0.025,0.038,0.051,0.057,0.076C43.251,12.115,43.275,11.969,43.382,11.985z\r\n\t\t\t\t M20.926,10.303c-0.046,0.008-0.091,0.016-0.137,0.024c-0.018,0.026-0.036,0.077-0.072,0.095\r\n\t\t\t\tc0.061,0.013,0.304-0.051,0.354-0.078C21.07,10.309,20.97,10.301,20.926,10.303z M31.37,7.524\r\n\t\t\t\tc0.061-0.032,0.123-0.064,0.184-0.095c0.036,0.055,0.072,0.11,0.108,0.165c-0.076,0.036-0.153,0.072-0.229,0.108\r\n\t\t\t\tc0.055,0.135,0.434,0.457,0.623,0.388c0.163-0.06,0.211-0.226,0.35-0.312c0.086,0.097,0.287,0.173,0.438,0.197v0.006\r\n\t\t\t\tc-0.178,0.189-0.512,0.185-0.769,0.299h-0.013c0.023,0.049,0.047,0.097,0.07,0.146c0.248-0.018,0.442-0.069,0.661-0.089\r\n\t\t\t\tc0.027,0.025,0.055,0.051,0.083,0.076c-0.103,0.131-0.323,0.152-0.559,0.146c-0.023,0.034-0.047,0.068-0.07,0.102\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.102,0.062,0.562,0.443,0.718,0.4c0.032-0.019,0.063-0.038,0.095-0.057\r\n\t\t\t\tc-0.001-0.177,0.066-0.321,0.159-0.407c0.028-0.029,0.124-0.04,0.172-0.044c0.038-0.081,0.076-0.161,0.114-0.242\r\n\t\t\t\tc0.058-0.144,0.054-0.343,0.178-0.419c0.094-0.021,0.188-0.043,0.28-0.064c0.053-0.026,0.106-0.051,0.159-0.076\r\n\t\t\t\tc-0.049-0.083-0.189-0.174-0.28-0.21c-0.082-0.032-0.163-0.021-0.229-0.063c-0.057-0.074-0.113-0.148-0.172-0.222\r\n\t\t\t\tc-0.078,0-0.117,0.083-0.172,0.127C33.238,7.389,33.219,7.38,33.2,7.372c-0.034-0.072,0.005-0.174,0.006-0.28\r\n\t\t\t\tc-0.021-0.015-0.042-0.03-0.063-0.045h-0.172c-0.066-0.021-0.113-0.079-0.211-0.089C32.725,7,32.688,7.043,32.652,7.085\r\n\t\t\t\tc-0.041,0.109,0.107,0.294,0.127,0.4c-0.02,0.017-0.038,0.034-0.057,0.051c-0.109-0.025-0.307-0.287-0.351-0.381\r\n\t\t\t\tc-0.075-0.059-0.101-0.039-0.191,0c-0.015,0.076-0.03,0.153-0.044,0.229v0.013c-0.074-0.015-0.148-0.03-0.222-0.045\r\n\t\t\t\tc-0.036-0.055-0.041-0.146-0.038-0.242c-0.077-0.016-0.176,0.02-0.235,0.032c-0.047-0.004-0.093-0.008-0.14-0.013\r\n\t\t\t\tc-0.146,0.013-0.218,0.074-0.305,0.14C31.219,7.367,31.286,7.485,31.37,7.524z M34.414,7.117v0.006\r\n\t\t\t\tc-0.066,0.146-0.102,0.233-0.28,0.267v0.114c0.275,0.013,0.552,0.025,0.826,0.038c0.06-0.04,0.119-0.081,0.179-0.121\r\n\t\t\t\tc0.077-0.033,0.161-0.016,0.254-0.045c0.078-0.04,0.156-0.08,0.234-0.121c0.104-0.078,0.208-0.157,0.311-0.235\r\n\t\t\t\tc0.002-0.004,0.004-0.008,0.006-0.013c-0.022-0.038-0.047-0.076-0.069-0.114c-0.062-0.017-0.123-0.034-0.185-0.051\r\n\t\t\t\tc-0.119-0.023-0.25,0.029-0.375,0.026c-0.024-0.051-0.051-0.102-0.075-0.153c-0.03-0.011-0.06-0.021-0.089-0.032\r\n\t\t\t\tc-0.133,0.016-0.224,0.14-0.286,0.229h-0.108c-0.027-0.1-0.003-0.248,0.025-0.343c-0.137,0.061-0.143,0.232-0.268,0.292\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.031,0.032c-0.168-0.256-0.328-0.017-0.496-0.134c-0.059-0.07-0.119-0.14-0.178-0.21\r\n\t\t\t\tc-0.082,0.106-0.162,0.212-0.242,0.318c-0.086,0.062-0.15,0.069-0.196,0.172c-0.004,0.004-0.009,0.008-0.013,0.013\r\n\t\t\t\tC33.594,7.203,34.035,7.121,34.414,7.117z M20.993,9.697c0.035,0.033,0.134,0.07,0.225,0.035c0.034-0.013,0.049-0.034,0.076-0.05\r\n\t\t\t\tc0.019-0.02,0.038-0.04,0.057-0.061C21.277,9.6,21.247,9.54,21.129,9.564C21.066,9.601,20.983,9.637,20.993,9.697z M21.388,8.988\r\n\t\t\t\tc-0.081,0.009-0.125-0.079-0.169-0.114c-0.024,0.041-0.114,0.079-0.126,0.107c0,0,0.086,0.119,0.094,0.127\r\n\t\t\t\tc0.011,0.01,0.028,0.019,0.044,0.023c0.039-0.003,0.22-0.108,0.242-0.129c0.013-0.013,0.03-0.035,0.009-0.052\r\n\t\t\t\tC21.451,8.925,21.406,8.976,21.388,8.988z M20.989,9.241c-0.031,0.049,0.059,0.128,0.12,0.118\r\n\t\t\t\tc0.061-0.054,0.045-0.074-0.037-0.096C21.044,9.256,21.017,9.248,20.989,9.241z M20.988,9.24L20.988,9.24\r\n\t\t\t\tc0.003-0.004-0.005-0.009-0.001-0.012C20.987,9.233,20.988,9.237,20.988,9.24z M30.588,18.905\r\n\t\t\t\tc0.119-0.015,0.252,0.008,0.413-0.006c0.016-0.051,0.02-0.072,0.064-0.095c-0.01-0.113-0.024-0.131,0.025-0.21\r\n\t\t\t\tc-0.011-0.004-0.021-0.008-0.032-0.013c-0.006,0.01-0.013,0.021-0.019,0.032c-0.055,0.015-0.11,0.03-0.165,0.044\r\n\t\t\t\tc-0.059,0.043-0.078,0.143-0.153,0.172c-0.076,0.008-0.153,0.017-0.229,0.025c-0.051,0.023-0.079,0.083-0.102,0.133\r\n\t\t\t\tc0.028,0.028,0.055,0.055,0.083,0.083C30.523,19.013,30.565,18.998,30.588,18.905z M10.002,26.709v0.006\r\n\t\t\t\tc0.013,0.019,0.025,0.038,0.038,0.057h0.027c-0.006-0.014-0.006-0.034-0.015-0.051C10.036,26.717,10.019,26.713,10.002,26.709z\r\n\t\t\t\t M42.956,34.189c-0.052-0.021-0.103-0.043-0.153-0.064c-0.119,0.085-0.214,0.171-0.388,0.21c-0.076,0.017-0.146-0.017-0.19-0.024\r\n\t\t\t\tc-0.086-0.018-0.14,0.054-0.197,0.069c-0.06-0.006-0.119-0.013-0.178-0.019h-0.014c-0.072,0.047-0.145,0.093-0.216,0.14\r\n\t\t\t\tc-0.099,0.036-0.13-0.06-0.242-0.038c-0.091,0.04-0.183,0.08-0.272,0.121h-0.179c-0.091-0.1-0.215-0.211-0.272-0.337\r\n\t\t\t\tc-0.055-0.015-0.129-0.003-0.191-0.013c-0.004-0.002-0.009-0.004-0.013-0.006v-0.014c0.069-0.033,0.208-0.09,0.261-0.146\r\n\t\t\t\tc-0.006-0.168-0.232-0.211-0.33-0.305c-0.018-0.016-0.033-0.139-0.089-0.19c-0.026-0.024-0.075-0.007-0.108-0.025\r\n\t\t\t\tc-0.088-0.098-0.178-0.194-0.267-0.292c-0.035-0.016-0.076-0.009-0.127-0.006c-0.039-0.055-0.074-0.139-0.133-0.172\r\n\t\t\t\tc-0.019,0.025-0.013,0.083-0.019,0.107c-0.005,0.002-0.009,0.004-0.014,0.008c-0.182-0.153-0.225-0.623-0.331-0.864\r\n\t\t\t\tc-0.049-0.112-0.295-0.163-0.362-0.254c-0.105-0.144-0.037-0.516-0.089-0.724c-0.032-0.135-0.153-0.35-0.254-0.426\r\n\t\t\t\tc-0.05-0.038-0.123-0.051-0.159-0.102c-0.045-0.062-0.051-0.162-0.076-0.242c0.023-0.021,0.047-0.042,0.07-0.064\r\n\t\t\t\tc-0.051-0.051-0.102-0.102-0.152-0.152c-0.14-0.209-0.24-0.462-0.369-0.667c-0.055-0.144-0.11-0.288-0.166-0.432\r\n\t\t\t\tc-0.094-0.171-0.256-0.287-0.299-0.521c0.033-0.045,0.039-0.066,0.096-0.089c0.08,0.245,0.223,0.49,0.4,0.642\r\n\t\t\t\tc0.019,0.021,0.047,0.019,0.075,0.013c0.08-0.159,0.058-0.398,0.185-0.508c-0.074-0.191-0.148-0.381-0.223-0.572\r\n\t\t\t\tc-0.121,0.015-0.164,0.113-0.337,0.019c-0.112,0.08-0.157,0.011-0.28,0.032c-0.041-0.043-0.076-0.051-0.095-0.121\r\n\t\t\t\tc-0.215-0.044-0.454,0.008-0.604,0.108c-0.039,0.032-0.08,0.063-0.12,0.095c-0.079,0.017-0.155-0.048-0.21-0.064\r\n\t\t\t\tc-0.061-0.006-0.123-0.013-0.184-0.019c-0.014-0.017-0.025-0.034-0.039-0.051c-0.147-0.032-0.297-0.064-0.444-0.095h-0.318\r\n\t\t\t\tc-0.058-0.026-0.045-0.125-0.108-0.146h-0.146c-0.077-0.012-0.25-0.041-0.324-0.07c-0.069-0.038-0.032-0.128-0.133-0.172\r\n\t\t\t\tc-0.258-0.113-0.681,0.039-0.782,0.21c-0.137,0.231,0.168,0.358-0.146,0.527c-0.038,0.02-0.089,0.07-0.146,0.064\r\n\t\t\t\tc-0.154-0.018-0.267-0.184-0.4-0.235c-0.133-0.05-0.434-0.054-0.541-0.114c-0.118-0.068-0.136-0.311-0.24-0.35\r\n\t\t\t\tc-0.058-0.021-0.105-0.003-0.152-0.025c-0.028-0.025-0.055-0.051-0.083-0.076c-0.066-0.013-0.131-0.025-0.197-0.038\r\n\t\t\t\tc-0.095,0.006-0.191,0.013-0.286,0.019c-0.129-0.055-0.258-0.11-0.388-0.165c-0.009-0.034-0.017-0.068-0.025-0.102\r\n\t\t\t\tc-0.061-0.005-0.069,0.013-0.121,0.025c-0.082-0.04-0.182-0.111-0.203-0.21c0.059-0.065,0.326-0.286,0.324-0.369\r\n\t\t\t\tc-0.011-0.042-0.021-0.085-0.032-0.127c-0.337-0.192,0.008-0.272,0.006-0.483c-0.064,0.038-0.127,0.076-0.191,0.115\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c-0.018-0.04-0.036-0.072-0.038-0.127c-0.047-0.021-0.093-0.042-0.14-0.064\r\n\t\t\t\tc-0.03,0.004-0.059,0.009-0.089,0.013c-0.095,0.036-0.266,0.212-0.432,0.165c-0.024-0.007-0.062-0.069-0.14-0.096\r\n\t\t\t\tc-0.063,0.009-0.084,0.051-0.133,0.076c-0.076-0.012-0.113-0.06-0.178-0.083c-0.078,0.055-0.155,0.115-0.267,0.14\r\n\t\t\t\tc-0.173,0.039-0.303-0.115-0.502-0.063c-0.038,0.021-0.076,0.042-0.114,0.063c-0.073,0.026-0.104-0.027-0.159-0.019\r\n\t\t\t\tc-0.047,0.021-0.093,0.042-0.14,0.064c-0.145,0.03-0.312-0.005-0.432,0.044c-0.114,0.047-0.181,0.142-0.267,0.216\r\n\t\t\t\tc-0.046-0.004-0.065-0.015-0.089-0.038c-0.039,0.007-0.209,0.066-0.242,0.089c-0.08,0.057-0.073,0.137-0.191,0.172\r\n\t\t\t\tc-0.13,0.038-0.283-0.002-0.318-0.089c-0.007-0.002-0.345,0.103-0.477,0.064c-0.138-0.041-0.19-0.153-0.28-0.242\r\n\t\t\t\tc-0.032,0.015-0.064,0.03-0.095,0.045c-0.071,0.054-0.17,0.43-0.248,0.534c-0.114,0.152-0.324,0.164-0.483,0.273\r\n\t\t\t\tc-0.054,0.037-0.227,0.186-0.248,0.241c-0.022,0.058,0.009,0.132-0.019,0.191c-0.035,0.073-0.121,0.127-0.153,0.21\r\n\t\t\t\tc-0.075,0.199,0.155,0.303-0.006,0.54c-0.101,0.149-0.406,0.41-0.578,0.483c-0.089,0.038-0.211,0.03-0.305,0.076\r\n\t\t\t\tc-0.108,0.053-0.13,0.288-0.203,0.381c-0.059,0.074-0.188,0.088-0.242,0.165c-0.056,0.081-0.105,0.204-0.127,0.311\r\n\t\t\t\tc-0.002,0.044-0.004,0.089-0.006,0.134c-0.04,0.101-0.18,0.151-0.242,0.235c-0.063,0.146-0.127,0.292-0.191,0.438\r\n\t\t\t\tc-0.047,0.051-0.093,0.102-0.14,0.153c-0.056,0.084-0.082,0.256-0.064,0.388c0.015-0.017,0.03-0.034,0.044-0.051\r\n\t\t\t\tc0.199,0.016,0.209,0.339,0.114,0.477c0.233,0.184,0.095,0.554,0.025,0.788c-0.008,0.067-0.017,0.136-0.025,0.203\r\n\t\t\t\tc-0.037,0.135-0.145,0.317-0.273,0.362c-0.002,0.004-0.004,0.008-0.006,0.013c0.181,0.075,0.181,0.271,0.267,0.311\r\n\t\t\t\tc0.01,0.021,0.013,0.041,0.013,0.076c-0.019,0.004-0.038,0.008-0.057,0.013c-0.049,0.069-0.01,0.178-0.032,0.262\r\n\t\t\t\tc0.08,0.135,0.04,0.035,0.14,0.102c0.004,0.016,0.008,0.03,0.013,0.044c0.042,0.024,0.085,0.052,0.127,0.076\r\n\t\t\t\tc0.063-0.013,0.153-0.052,0.203,0.006c-0.039,0.048-0.093,0.079-0.076,0.165c0.026,0.018,0.08,0.021,0.102,0.044\r\n\t\t\t\tc0.015,0.021,0.01,0.028,0.006,0.058c0.034,0.022,0.057,0.033,0.121,0.031c0.011,0.033,0.011,0.061,0,0.096\r\n\t\t\t\tc0.065,0.068,0.166,0.135,0.267,0.164c0.006,0.032,0.013,0.063,0.019,0.096c0.033,0.061,0.118,0.08,0.14,0.158v0.096\r\n\t\t\t\tc0.014,0.018,0.035,0.021,0.063,0.025c0.002,0.008,0.004,0.017,0.006,0.024c-0.023,0.019-0.047,0.038-0.07,0.058h-0.013\r\n\t\t\t\tc0.028,0.094,0.156,0.186,0.261,0.203c0.018,0.033,0.013,0.047,0.006,0.094c0.142,0.043,0.215,0.149,0.324,0.223\r\n\t\t\t\tc0.08,0.042,0.161,0.085,0.242,0.127c0.17,0.12,0.278,0.261,0.477,0.361c0.062,0.033,0.311,0.192,0.388,0.173\r\n\t\t\t\tc0.102-0.054,0.203-0.106,0.305-0.159c0.106-0.029,0.212-0.059,0.318-0.089c0.092-0.027,0.292-0.048,0.407-0.025\r\n\t\t\t\tc0.05,0.011,0.145,0.062,0.21,0.038c0.011-0.013,0.021-0.025,0.032-0.038c0.041,0.005,0.246,0.134,0.286,0.165\r\n\t\t\t\tc0.206-0.093,0.411-0.186,0.616-0.279c0.087-0.008,0.174-0.018,0.261-0.025c0.052-0.039,0.054-0.107,0.127-0.133\r\n\t\t\t\tc0.214-0.02,0.428-0.038,0.642-0.057c0.032-0.013,0.039-0.043,0.083-0.058c0.077,0.015,0.286,0.147,0.331,0.203\r\n\t\t\t\tc0.015,0.024,0.03,0.051,0.044,0.075c0.023,0.002,0.047,0.005,0.07,0.007c0.006,0.008,0.013,0.017,0.019,0.024\r\n\t\t\t\tc-0.013,0.032-0.025,0.064-0.038,0.096c0.025,0.209,0.348,0.363,0.534,0.197c0.101,0.017,0.232,0.039,0.343-0.007\r\n\t\t\t\tc0.002-0.026-0.002-0.036-0.013-0.062c0.025-0.017,0.147,0.013,0.178,0.051c0.069,0.124-0.004,0.172,0.222,0.165\r\n\t\t\t\tc0.008,0.013,0.017,0.025,0.025,0.038c0.004,0.004,0.008,0.008,0.013,0.013c-0.019,0.016-0.038,0.03-0.057,0.044\r\n\t\t\t\tc0.021,0.08,0.085,0.147,0.102,0.242c-0.011,0.042-0.021,0.085-0.032,0.127c0.009,0.032,0.017,0.063,0.025,0.095\r\n\t\t\t\tc-0.024,0.1-0.086,0.2-0.153,0.262c-0.002,0.006-0.004,0.013-0.006,0.019c0.025,0.004,0.051,0.008,0.076,0.013\r\n\t\t\t\tc0.003,0.084-0.012,0.146-0.076,0.166c0.049,0.041,0.097,0.084,0.146,0.127v0.006c-0.038-0.004-0.076-0.01-0.114-0.014\r\n\t\t\t\tc-0.031,0.139-0.072,0.242-0.191,0.292c0.013,0.028,0.052,0.116,0.076,0.14c0.036,0.035,0.074,0.016,0.114,0.07\r\n\t\t\t\tc-0.021,0.016-0.042,0.03-0.063,0.045c-0.002,0.004-0.004,0.008-0.006,0.014c0.042,0.062,0.085,0.123,0.127,0.184\r\n\t\t\t\tc0.053,0.027,0.074,0.003,0.108,0.045c-0.011,0.016-0.021,0.03-0.032,0.044c0.089,0.058,0.143,0.122,0.203,0.21\r\n\t\t\t\tc0.112,0.104,0.224,0.208,0.337,0.311c0.032,0.039,0.115,0.205,0.133,0.248c0.029,0.068-0.018,0.162,0.038,0.262\r\n\t\t\t\tc0.045,0.064,0.089,0.127,0.133,0.191c0.013,0.061,0.025,0.123,0.038,0.184c0.057,0.134,0.17,0.186,0.14,0.388\r\n\t\t\t\tc-0.243,0.109,0.046,0.36,0.089,0.489c0.008,0.1,0.017,0.199,0.025,0.299c-0.019,0.11-0.066,0.285-0.146,0.337\r\n\t\t\t\tc-0.03,0.011-0.059,0.021-0.089,0.032c-0.017,0.04-0.034,0.081-0.051,0.121c-0.03,0.031-0.059,0.064-0.089,0.096\r\n\t\t\t\tc-0.094,0.223-0.042,0.57-0.222,0.705c0,0.202-0.037,0.471,0.013,0.648c0.038,0.135,0.15,0.217,0.216,0.324\r\n\t\t\t\tc0.108,0.215,0.216,0.432,0.324,0.647c0.075,0.146,0.371,0.403,0.203,0.571c0.03,0.141,0.059,0.281,0.089,0.42\r\n\t\t\t\tc0.023,0.055,0.047,0.109,0.07,0.165c0.02,0.081-0.031,0.143-0.025,0.202c0.008,0.08,0.071,0.147,0.089,0.211\r\n\t\t\t\tc0.014,0.047-0.021,0.072-0.019,0.102c0.034,0.104,0.068,0.208,0.102,0.311c0.116,0.131,0.233,0.264,0.349,0.395\r\n\t\t\t\tc0.12,0.189,0.16,0.434,0.273,0.635c0.1,0.178,0.271,0.36,0.203,0.654c-0.033,0.008-0.078,0-0.096,0.025\r\n\t\t\t\tc-0.025,0.031,0.123,0.229,0.159,0.285c-0.017,0.049-0.034,0.099-0.051,0.146c0.011,0.011,0.021,0.021,0.032,0.031\r\n\t\t\t\tc0.006,0.003,0.013,0.005,0.019,0.007c0.006-0.015,0.013-0.03,0.019-0.045c0.018-0.009,0.022-0.011,0.052-0.013\r\n\t\t\t\tc0.013,0.022,0.024,0.047,0.038,0.069c0.027-0.001,0.052-0.007,0.102-0.006c0.021,0.028,0.021,0.056,0.038,0.095\r\n\t\t\t\tc0.024,0.043,0.115,0.075,0.165,0.09c0.061-0.047,0.096-0.123,0.178-0.146c0.115-0.035,0.252,0.044,0.356-0.006\r\n\t\t\t\tc0.032-0.03,0.063-0.059,0.095-0.09c0.15-0.07,0.214,0,0.331,0c0.034-0.019,0.067-0.037,0.103-0.057\r\n\t\t\t\tc0.121-0.035,0.233,0.073,0.317,0.102c0.04-0.03,0.07-0.055,0.095-0.102c0.058,0.014,0.114,0.025,0.172,0.038\r\n\t\t\t\tc0.018-0.019,0.021-0.053,0.033-0.075c0.049-0.049,0.321-0.018,0.399-0.07c0.083-0.072,0.165-0.145,0.248-0.217\r\n\t\t\t\tc0.416-0.326,0.721-0.688,1.017-1.138c0.074-0.112,0.264-0.19,0.305-0.299c0.021-0.052-0.027-0.122-0.019-0.146\r\n\t\t\t\tc0.017-0.045,0.065-0.033,0.089-0.064c0.071-0.091,0.109-0.35,0.09-0.496c-0.039-0.016-0.078-0.04-0.096-0.076\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.02-0.019c0.078-0.091,0.133-0.175,0.242-0.235c0.244-0.134,0.525-0.121,0.635-0.388\r\n\t\t\t\tc-0.008-0.062-0.051-0.036-0.063-0.07c0.002-0.006,0.005-0.013,0.007-0.019c0.012-0.032,0.024-0.064,0.037-0.096\r\n\t\t\t\tc0.03-0.123,0.023-0.264,0.02-0.388c-0.028,0.011-0.035,0.019-0.076,0.019c-0.039-0.123-0.087-0.273-0.044-0.375\r\n\t\t\t\tc-0.007-0.074-0.062-0.111-0.114-0.14v-0.202c0.119-0.088,0.237-0.175,0.355-0.262c0.146-0.122,0.233-0.305,0.4-0.406\r\n\t\t\t\tc0.203-0.123,0.451-0.162,0.643-0.293c0.137-0.094,0.224-0.268,0.33-0.394c0-0.028-0.008-0.039-0.019-0.07\r\n\t\t\t\tc0.036-0.047,0.068-0.081,0.095-0.14c-0.002-0.012-0.004-0.021-0.006-0.032c-0.023-0.011-0.047-0.021-0.07-0.032\r\n\t\t\t\tc-0.02-0.162,0.013-0.337-0.069-0.432c0.003-0.034,0.034-0.062,0.044-0.107c0.025-0.113-0.041-0.295-0.057-0.395\r\n\t\t\t\tc0.029-0.055,0.059-0.11,0.088-0.165c-0.064-0.14-0.182-0.157-0.266-0.267c-0.084-0.108-0.127-0.394-0.07-0.554\r\n\t\t\t\tc-0.019-0.028-0.043-0.032-0.064-0.057c0.029-0.062,0.083-0.148,0.089-0.216c-0.057-0.071-0.161-0.127-0.196-0.217\r\n\t\t\t\tc-0.037-0.095,0.061-0.406,0.102-0.451c0.023-0.025,0.068-0.021,0.089-0.051c0.047-0.067,0.006-0.104,0.024-0.164\r\n\t\t\t\tc0.043-0.138,0.173-0.144,0.185-0.369c0.097-0.053,0.187-0.051,0.19-0.203c0.086,0.017,0.125-0.021,0.191-0.051\r\n\t\t\t\tc0.024-0.035,0.026-0.054,0.006-0.095c0.209-0.235,0.416-0.47,0.623-0.704c0.229-0.186,0.516-0.326,0.744-0.509\r\n\t\t\t\tc0.086-0.104,0.17-0.208,0.254-0.312c0.168-0.215,0.42-0.422,0.527-0.686c0.011-0.049,0.021-0.098,0.032-0.146\r\n\t\t\t\tc0.073-0.118,0.147-0.236,0.222-0.355c-0.002-0.027-0.004-0.055-0.006-0.083c0.042-0.04,0.085-0.081,0.127-0.121\r\n\t\t\t\tc0.055-0.098,0.109-0.194,0.165-0.292c0.006-0.087,0.013-0.174,0.019-0.261c0.015-0.04,0.08-0.069,0.076-0.127\r\n\t\t\t\tc-0.002-0.045-0.037-0.108-0.019-0.172c0.017-0.04,0.034-0.081,0.051-0.121C42.96,34.201,42.958,34.195,42.956,34.189z\r\n\t\t\t\t M51.688,35.154c-0.031-0.184-0.127-0.277-0.279-0.375c0.018,0.078-0.004,0.113-0.025,0.191c-0.033,0.026-0.04,0.043-0.095,0.025\r\n\t\t\t\tc-0.004,0.015-0.009,0.029-0.013,0.044c0.015,0.017,0.029,0.034,0.043,0.051c-0.028,0.063-0.008,0.077,0.007,0.14v0.318\r\n\t\t\t\tc0.022,0.102,0.073,0.268,0.146,0.324c0.209,0.044,0.477-0.139,0.451-0.337c-0.011-0.089-0.093-0.163-0.127-0.235\r\n\t\t\t\tC51.76,35.227,51.768,35.186,51.688,35.154z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z\r\n\t\t\t\t M50.505,13.747c0.043,0.044,0.081,0.093,0.124,0.137c-0.003,0.02-0.006,0.039-0.008,0.059v0.006\r\n\t\t\t\tc0.027,0.007,0.053,0.01,0.08,0.013c0.048,0.049,0.092,0.103,0.139,0.153c-0.13,0.026-0.316,0.022-0.352-0.084\r\n\t\t\t\tC50.471,14.004,50.497,13.865,50.505,13.747z M48.568,14.508c0.037,0.017,0.076,0.034,0.113,0.051\r\n\t\t\t\tc0.07-0.025,0.141-0.051,0.211-0.076c-0.014-0.036-0.025-0.072-0.039-0.108c0.033-0.077,0.143-0.097,0.203-0.146\r\n\t\t\t\tc0.084-0.066,0.228-0.183,0.268-0.286c0.015-0.059,0.029-0.119,0.044-0.178c0.022-0.052,0.06-0.069,0.063-0.146\r\n\t\t\t\tc-0.099-0.13-0.201-0.041-0.254-0.292c0.002-0.127,0.004-0.254,0.006-0.381c-0.008-0.074-0.017-0.148-0.024-0.222\r\n\t\t\t\tc0.032-0.042,0.063-0.085,0.095-0.127c0.001-0.002-0.001-0.005,0-0.008c0.1,0.088,0.195,0.177,0.293,0.266\r\n\t\t\t\tc-0.012,0.031-0.036,0.06-0.038,0.092c-0.006,0.103,0.07,0.19,0.07,0.324c0.103-0.002,0.239,0.039,0.312,0.025\r\n\t\t\t\tc0.033-0.012,0.068-0.024,0.103-0.036c0.075,0.072,0.157,0.137,0.231,0.211c-0.214-0.04-0.47,0.008-0.5,0.206\r\n\t\t\t\tc0.057,0.099,0.113,0.168,0.108,0.318c-0.042,0.053-0.085,0.106-0.127,0.159c-0.034,0.021-0.067,0.042-0.103,0.064\r\n\t\t\t\tc-0.043,0.061-0.037,0.157-0.095,0.203c-0.14,0.113-0.327,0.134-0.407,0.311c-0.084,0.039-0.185,0.002-0.261-0.013\r\n\t\t\t\tc-0.053,0.002-0.106,0.004-0.159,0.006c-0.219-0.032-0.424-0.055-0.502-0.229C48.309,14.462,48.449,14.461,48.568,14.508z\r\n\t\t\t\t M14.404,12.899c-0.002,0.011-0.006,0.023,0.013,0.034c0.011,0.006,0.027,0.004,0.044,0.005c0.046,0.003,0.104,0.019,0.122,0.05\r\n\t\t\t\tc-0.03,0.071-0.177,0-0.221-0.006c0,0.003,0,0.006,0,0.008c-0.005,0-0.011,0-0.016,0c-0.003,0.077,0.276,0.05,0.304,0.123\r\n\t\t\t\tc-0.032,0.036-0.081,0.019-0.141,0.035c-0.004,0.062,0.16,0.026,0.146,0.083c0,0.002-0.001,0.003-0.001,0.005\r\n\t\t\t\tc-0.043,0.013-0.078-0.002-0.117,0.012c-0.004,0.003-0.007,0.006-0.01,0.009c0,0.003,0,0.006,0,0.008\r\n\t\t\t\tc0.031,0.019,0.072,0.042,0.132,0.023c0.017-0.006,0.036-0.014,0.054-0.012c0.006,0.002,0.012,0.003,0.017,0.005\r\n\t\t\t\tc0.003,0.02-0.019,0.062-0.05,0.071c-0.034,0.009-0.199-0.014-0.228-0.021c-0.059-0.015-0.101-0.05-0.147-0.078\r\n\t\t\t\tc-0.04-0.024-0.124-0.06-0.197-0.085C14.204,13.077,14.305,12.99,14.404,12.899z M13.524,13.715\r\n\t\t\t\tc0.019,0.012,0.039,0.022,0.052,0.039c-0.03-0.002-0.064,0.005-0.097,0.01C13.495,13.749,13.509,13.731,13.524,13.715z\r\n\t\t\t\t M7.943,27.904c0.017-0.004,0.034-0.008,0.051-0.013c-0.017,0.015-0.034,0.03-0.051,0.045\r\n\t\t\t\tC7.945,27.925,7.941,27.918,7.943,27.904z M7.499,23.367c-0.001,0.007,0,0.011-0.001,0.018c-0.002-0.002-0.002-0.004-0.004-0.006\r\n\t\t\t\tC7.496,23.376,7.497,23.372,7.499,23.367z M7.676,37.665c-0.049,0.065-0.234,0.104-0.337,0.051\r\n\t\t\t\tc-0.044,0.033-0.061,0.065-0.057,0.146c-0.015,0.014-0.03,0.025-0.044,0.039c-0.012-0.053-0.021-0.069-0.07-0.084\r\n\t\t\t\tc-0.033-0.006-0.066,0.023-0.095,0.039c-0.203,0.106-0.124,0.25-0.191,0.438c-0.026,0.005-0.052,0.01-0.079,0.016\r\n\t\t\t\tc-0.076-0.303-0.168-0.599-0.232-0.904c0.011,0,0.019,0.005,0.032,0.006c0.029,0.082,0.054,0.128,0.146,0.146\r\n\t\t\t\tc0.004-0.029,0.009-0.056,0.013-0.084h0.006c0.023,0.049,0.076,0.109,0.064,0.172c0.006,0.006,0.013,0.014,0.019,0.02\r\n\t\t\t\tc0.114,0.02,0.144-0.047,0.248-0.057c-0.01-0.111-0.095-0.121-0.133-0.203c0.039-0.059,0.138-0.1,0.21-0.121\r\n\t\t\t\tc-0.003-0.04-0.005-0.057,0.006-0.09c0.198-0.062,0.318-0.017,0.375,0.141c0.045,0.008,0.076-0.016,0.108-0.038\r\n\t\t\t\tc-0.001,0.05,0.005,0.067,0.038,0.083c0.002,0.004,0.004,0.01,0.006,0.014c-0.061-0.009-0.097-0.021-0.121,0.031\r\n\t\t\t\tC7.564,37.5,7.647,37.605,7.676,37.665z M32,58c-7.083,0-13.497-2.841-18.187-7.436c0.051-0.051,0.122-0.09,0.155-0.152\r\n\t\t\t\tc0.019-0.078,0.038-0.157,0.057-0.235v-0.013c0.049,0.021,0.108,0.044,0.172,0.02h0.006c0.013,0.191-0.204,0.291-0.248,0.482\r\n\t\t\t\tc0.103-0.092,0.237-0.221,0.299-0.35c0.051-0.121,0.102-0.241,0.153-0.361c0.174-0.277,0.481-0.299,0.394-0.852\r\n\t\t\t\tc-0.012-0.078-0.036-0.114-0.057-0.172c0.045-0.055,0.132-0.205,0.019-0.255v-0.038c0.146,0.014,0.159-0.072,0.235-0.14\r\n\t\t\t\tc0.08-0.069,0.491-0.363,0.585-0.381c0.051-0.011,0.091,0.021,0.127,0.032c0.03-0.036,0.059-0.072,0.089-0.108\r\n\t\t\t\tc0.086-0.051,0.144-0.034,0.165-0.153c0.094-0.012,0.207-0.008,0.28,0.006c0.161,0.031,0.334-0.013,0.483-0.024\r\n\t\t\t\tc-0.005-0.183,0.137-0.241,0.292-0.254c-0.009-0.052-0.017-0.103-0.025-0.153c0.017-0.123,0.117-0.202,0.172-0.292\r\n\t\t\t\tc0.034-0.069,0.068-0.14,0.102-0.21c0.032-0.046,0.105-0.072,0.121-0.133c-0.006-0.062-0.013-0.123-0.019-0.184\r\n\t\t\t\tc-0.03-0.17,0.065-0.289,0.184-0.332c0-0.047-0.035-0.138-0.019-0.222c0.021-0.106,0.097-0.243,0.076-0.368\r\n\t\t\t\tc-0.017-0.166-0.034-0.332-0.051-0.496c0.028-0.172,0.093-0.289,0.095-0.465c0.015,0.002,0.03,0.004,0.044,0.006\r\n\t\t\t\tc0.017,0.034,0.034,0.068,0.051,0.103h0.019c0.113-0.084,0.241-0.308,0.292-0.445c0.031-0.081,0.007-0.126,0.057-0.178\r\n\t\t\t\tc0.047-0.021,0.093-0.042,0.14-0.063c0.273-0.213,0.461-0.44,0.534-0.858c0.027-0.157-0.139-0.732-0.216-0.757\r\n\t\t\t\tc-0.161-0.049-0.338,0.009-0.458-0.069c-0.256-0.166-0.436-0.435-0.731-0.565c-0.171-0.076-0.287,0.017-0.451-0.014\r\n\t\t\t\tc-0.1-0.016-0.199-0.029-0.299-0.045c-0.086-0.023-0.18-0.133-0.286-0.121c-0.154,0.018-0.289,0.139-0.394,0.21\r\n\t\t\t\tc-0.049-0.2,0.024-0.122,0.044-0.241c0.013-0.078-0.114-0.195-0.184-0.203c-0.017,0.017-0.034,0.033-0.051,0.051h-0.025\r\n\t\t\t\tc-0.054-0.172-0.227-0.156-0.394-0.217c-0.065-0.022-0.106-0.067-0.159-0.102c-0.052,0.007-0.15,0.016-0.216,0.032\r\n\t\t\t\tc-0.072,0.028-0.08,0.13-0.121,0.19c-0.069,0.102-0.227,0.129-0.28,0.248c-0.004,0.002-0.008,0.004-0.013,0.006\r\n\t\t\t\tc0-0.069,0.012-0.1,0.032-0.146c-0.111,0.022-0.259,0.048-0.394,0.026c-0.032-0.076-0.064-0.153-0.095-0.229\r\n\t\t\t\tc-0.088,0.024-0.202,0.166-0.318,0.121c-0.006-0.004-0.013-0.008-0.019-0.013c0.085-0.065,0.102-0.2,0.159-0.293\r\n\t\t\t\tc0.065-0.104,0.205-0.137,0.28-0.229c0.067-0.082,0.092-0.211,0.197-0.254c0.034-0.054,0.016-0.107-0.006-0.165\r\n\t\t\t\tc-0.262-0.036-0.276-0.356-0.343-0.577c-0.021-0.068-0.016-0.144-0.076-0.173c-0.031-0.005-0.044,0.032-0.076,0.025\r\n\t\t\t\tc-0.015-0.003-0.319-0.315-0.4-0.356c-0.11-0.035-0.22-0.072-0.331-0.107c-0.09-0.035-0.342-0.112-0.489-0.051\r\n\t\t\t\tc-0.016,0.014-0.018,0.026-0.019,0.057c-0.095-0.021-0.191-0.042-0.286-0.064h-0.006c-0.015,0.016-0.03,0.03-0.044,0.045\r\n\t\t\t\tc-0.061-0.119-0.214-0.313-0.388-0.291c-0.011,0.021-0.021,0.041-0.032,0.062v0.013c-0.013-0.091-0.026-0.182-0.038-0.272\r\n\t\t\t\tc-0.074-0.125-0.313-0.283-0.47-0.318c-0.084-0.018-0.176,0.005-0.241,0.02c-0.066-0.004-0.131-0.009-0.197-0.014v-0.006\r\n\t\t\t\tc0.187-0.059,0.138-0.167,0.273-0.223c0.002-0.004,0.004-0.008,0.006-0.012c-0.051-0.035-0.122-0.046-0.178-0.084\r\n\t\t\t\tc-0.013-0.019-0.026-0.037-0.038-0.057c-0.045-0.029-0.132-0.021-0.172-0.045c-0.027,0.02-0.038,0.035-0.045,0.076\r\n\t\t\t\tc-0.004,0.002-0.008,0.004-0.013,0.006c-0.012-0.113-0.097-0.154-0.184-0.191v-0.039c0.059,0.002,0.119,0.004,0.178,0.006\r\n\t\t\t\tc0.011-0.006,0.021-0.014,0.032-0.02c0.004-0.009,0.008-0.018,0.013-0.025c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.129-0.028-0.42-0.039-0.54,0.019c-0.075,0.037-0.117,0.127-0.21,0.146c-0.261,0.059-0.335-0.148-0.496-0.159\r\n\t\t\t\tc-0.136-0.008-0.364,0.083-0.483,0.025c-0.058-0.029-0.044-0.058-0.07-0.121c-0.05-0.125-0.201-0.158-0.375-0.159\r\n\t\t\t\tc-0.033-0.051-0.073-0.137-0.089-0.197c-0.053-0.012-0.097,0.017-0.114,0.064c0.015,0.025,0.03,0.051,0.044,0.076\r\n\t\t\t\tc0.028-0.002,0.055-0.004,0.083-0.006c0.013,0.011,0.025,0.021,0.038,0.031c-0.016,0.063-0.425,0.178-0.515,0.211\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.012c-0.008,0.037-0.018,0.037-0.038,0.058c0.053,0.026,0.197,0.299,0.152,0.394\r\n\t\t\t\tc-0.025,0.045-0.094,0.072-0.152,0.084c-0.065-0.049-0.097-0.164-0.146-0.229c0.015-0.101,0.07-0.187,0.121-0.254\r\n\t\t\t\tc-0.012-0.103-0.056-0.167-0.089-0.254c0.041-0.062,0.144-0.086,0.241-0.089c0.011-0.014,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.013-0.064-0.059-0.101-0.114-0.121c-0.156-0.06-0.195,0.139-0.273,0.185c-0.04,0.012-0.081,0.024-0.121,0.037\r\n\t\t\t\tc0.019-0.035,0.046-0.051,0.032-0.102c0.027,0.011,0.029,0.016,0.038,0.045h0.006c0.052-0.033,0.079-0.079,0.121-0.121\r\n\t\t\t\tc-0.08-0.166-0.161-0.342-0.337-0.413c-0.058-0.022-0.134,0.003-0.203-0.026c-0.026-0.01-0.121-0.049-0.159-0.037\r\n\t\t\t\tc-0.047,0.031-0.093,0.063-0.14,0.095c-0.03,0.018-0.063,0.012-0.102,0.026c-0.12,0.043-0.172,0.127-0.331,0.094\r\n\t\t\t\tc-0.05-0.062-0.09-0.027-0.135-0.021c-0.26-1.288-0.395-2.619-0.457-3.968c0.016-0.002,0.033-0.001,0.046-0.007\r\n\t\t\t\tc0.167-0.078,0.167-0.194,0.47-0.121c0.006,0.011,0.013,0.021,0.019,0.031v0.007c-0.047,0.013-0.093,0.024-0.14,0.038\r\n\t\t\t\tc0.108,0.084,0.261,0.035,0.419,0.082c0.114,0.035,0.208,0.115,0.337,0.146c0.067,0.018,0.202-0.02,0.261,0.02\r\n\t\t\t\tc0.043,0.024,0.066,0.123,0.07,0.184c0.099,0.061,0.295,0.061,0.388,0.127c-0.006,0.064-0.053,0.105-0.102,0.127\r\n\t\t\t\tC7.811,33.859,7.792,33.88,7.773,33.9v0.007c0.141,0.006,0.266-0.058,0.394-0.038c0.097,0.011,0.195,0.021,0.292,0.031\r\n\t\t\t\tc0.105-0.019,0.2-0.058,0.324-0.069c0.002-0.004,0.004-0.008,0.006-0.013c-0.124-0.092-0.202-0.151-0.432-0.146\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.02c0.013-0.027,0.025-0.055,0.038-0.082c-0.079-0.081-0.36-0.09-0.483-0.141\r\n\t\t\t\tc-0.04-0.043-0.08-0.089-0.121-0.133c-0.131-0.09-0.318-0.074-0.477-0.146c-0.064-0.053-0.127-0.105-0.191-0.158H7.022\r\n\t\t\t\tc-0.163-0.037-0.338-0.074-0.559-0.07c-0.083,0.008-0.165,0.018-0.248,0.025c-0.059,0.014-0.109,0.043-0.163,0.068\r\n\t\t\t\tC6.038,32.677,6,32.344,6,32c0-0.404,0.042-0.798,0.06-1.198c0.069,0.073,0.127,0.176,0.179,0.209\r\n\t\t\t\tc0.057,0.035,0.12,0.025,0.133,0.102c-0.021,0.115-0.042,0.229-0.064,0.343c0.008,0.002,0.017,0.004,0.025,0.006\r\n\t\t\t\tc0.036,0.022,0.05-0.017,0.089-0.032c0.002,0.019,0.004,0.038,0.006,0.057c-0.025,0.035-0.04,0.043-0.083,0.063\r\n\t\t\t\tc0.038,0.07,0.076,0.14,0.115,0.21h0.06c0.006,0.032,0.013,0.064,0.019,0.095c0.019,0.013,0.038,0.025,0.057,0.038\r\n\t\t\t\tc0.051,0.105-0.017,0.164,0.133,0.172c0.035,0.058,0.068,0.193,0.108,0.242c0.047-0.022,0.112-0.023,0.178-0.032\r\n\t\t\t\tc-0.004,0.021-0.008,0.042-0.013,0.064h0.013c0.048-0.142,0.166-0.403,0.108-0.61c-0.023-0.081-0.082-0.166-0.108-0.261\r\n\t\t\t\tc-0.013-0.083-0.025-0.165-0.038-0.248c-0.062-0.179-0.316-0.446-0.267-0.699c0.032-0.1,0.064-0.199,0.095-0.299\r\n\t\t\t\tc0.053-0.085,0.131-0.155,0.165-0.26c0.15-0.028,0.305-0.087,0.369-0.197c0.047-0.082,0.048-0.15,0.127-0.197\r\n\t\t\t\tc0.074-0.044,0.216-0.039,0.28-0.076c0.064-0.08,0.127-0.161,0.191-0.242c0.07-0.011,0.14-0.021,0.21-0.032\r\n\t\t\t\tc0.025-0.021,0.051-0.042,0.076-0.063c0.002-0.004,0.004-0.009,0.006-0.013c-0.027-0.012-0.033-0.01-0.044-0.038\r\n\t\t\t\tc-0.025,0.019-0.067,0.035-0.095,0.051c-0.015-0.009-0.03-0.017-0.044-0.026c-0.019-0.013-0.023-0.028-0.032-0.051\r\n\t\t\t\tc0.025,0.019,0.035,0.04,0.07,0.051c0.054-0.032,0.047-0.06,0.089-0.083v-0.013c-0.03-0.031-0.081-0.057-0.14-0.057\r\n\t\t\t\tc-0.006-0.011-0.013-0.021-0.019-0.032c0.044,0.015,0.089,0.03,0.133,0.045c-0.006-0.011-0.013-0.021-0.019-0.032v-0.006\r\n\t\t\t\tc0.051,0.021,0.064,0.054,0.14,0.064c0.025-0.03,0.051-0.059,0.076-0.089c0.009-0.016,0.008-0.002,0.038,0\r\n\t\t\t\tc0.006-0.011,0.013-0.021,0.019-0.032c-0.001-0.047-0.012-0.063-0.038-0.083c-0.011-0.006-0.002-0.006-0.013,0\r\n\t\t\t\tc-0.028,0.017-0.029,0.052-0.044,0.081c0.002,0.005-0.004,0.01-0.001,0.014v-0.013c0-0.001,0-0.001,0.001-0.002\r\n\t\t\t\tc-0.01-0.027-0.001-0.054,0.005-0.087c-0.004-0.004-0.009-0.008-0.013-0.013c-0.06,0.01-0.113,0.02-0.191,0.019\r\n\t\t\t\tc0.008-0.038-0.02-0.071,0-0.108v-0.013c0.011,0.017-0.003,0.036,0.006,0.064c0.009,0.011,0.017,0.021,0.026,0.032\r\n\t\t\t\tc0.021-0.006,0.042-0.013,0.064-0.019c0-0.018-0.002-0.019-0.013-0.038c0.021,0.011,0.042,0.021,0.064,0.032\r\n\t\t\t\tc0.008-0.004,0.017-0.009,0.025-0.013c0.002-0.004,0.004-0.008,0.006-0.013c-0.011-0.015-0.021-0.029-0.032-0.044\r\n\t\t\t\tc0.034,0.019,0.057,0.04,0.089,0.025c0.004,0.015,0.008,0.03,0.013,0.045h0.019c-0.012-0.067-0.042-0.087-0.07-0.134h0.038\r\n\t\t\t\tc-0.004-0.026-0.004-0.02-0.017-0.036c0.004-0.008,0.008-0.015,0.011-0.023c-0.024-0.086-0.083-0.085-0.17-0.066\r\n\t\t\t\tc-0.004-0.07-0.06-0.101-0.121-0.114c-0.002-0.004-0.004-0.008-0.006-0.013c0.011-0.006,0.021-0.013,0.032-0.019\r\n\t\t\t\tc0.043,0.021,0.076,0.045,0.095,0.089c0.03,0.02,0.023,0.021,0.07,0.019c-0.002-0.021-0.004-0.042-0.006-0.064\r\n\t\t\t\tc-0.02-0.013-0.034-0.028-0.052-0.038H8.172c-0.021-0.017-0.042-0.034-0.064-0.051c0.018,0.026,0.045,0.037,0.069,0.051h0.02\r\n\t\t\t\tc-0.002-0.013-0.004-0.025-0.006-0.038c0.017,0.006,0.034,0.013,0.051,0.019h0.006c-0.002-0.043-0.004-0.052-0.038-0.064\r\n\t\t\t\tc0.009-0.004,0.017-0.009,0.026-0.013c-0.082-0.042-0.117-0.054-0.159-0.133c0.034,0.03,0.068,0.059,0.102,0.089\r\n\t\t\t\tc0.006,0.006,0.013,0.013,0.019,0.019c0.036-0.023,0.042-0.039,0.057-0.083c-0.034-0.047-0.238-0.13-0.311-0.159\r\n\t\t\t\tc-0.002-0.007,0.001-0.013,0-0.019c0.068-0.003,0.075,0.022,0.127,0.045c-0.002-0.013-0.004-0.025-0.006-0.038\r\n\t\t\t\tc0.042,0.042,0.099,0.078,0.153,0.108c-0.016-0.09-0.078-0.09-0.095-0.165h0.006c0.012,0.032,0.027,0.045,0.057,0.057\r\n\t\t\t\tc0.004,0.004,0.008,0.008,0.013,0.013h0.006c-0.015-0.036-0.03-0.072-0.044-0.108c-0.02-0.107,0.072-0.052-0.006-0.197\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.002-0.019,0.004-0.038,0.006-0.057c0.019,0.012,0.011,0.001,0.019,0.026h0.006\r\n\t\t\t\tc0.011-0.014,0.011-0.017,0.013-0.045c0.002,0.011,0.004,0.021,0.006,0.032c0.029-0.021,0.034-0.024,0.032-0.045\r\n\t\t\t\tc0.015-0.011,0.03-0.021,0.044-0.032c-0.006,0.017-0.013,0.034-0.019,0.051c0.013,0.006,0.025,0.013,0.038,0.019\r\n\t\t\t\tc-0.025,0.006-0.051,0.013-0.076,0.019c-0.011,0.017-0.021,0.034-0.032,0.051v0.006h0.051c-0.013,0.035-0.02,0.044-0.07,0.044\r\n\t\t\t\tc-0.004,0.006-0.009,0.013-0.013,0.019c0.016,0.017,0.027,0.021,0.057,0.025c0.002,0.004,0.004,0.008,0.006,0.013v0.026\r\n\t\t\t\tc-0.013-0.007-0.025-0.013-0.038-0.019c-0.004,0.002-0.009,0.004-0.013,0.006c-0.004,0.013-0.009,0.025-0.013,0.038v0.006\r\n\t\t\t\tc0.047-0.025,0.036-0.01,0.089,0.013c0.004,0.006,0.009,0.013,0.013,0.019c-0.03,0.011-0.059,0.021-0.089,0.032\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.011,0.015,0.021,0.03,0.032,0.044c0.017,0.011,0.034,0.021,0.051,0.032\r\n\t\t\t\tc0.021-0.013,0.042-0.025,0.064-0.038c-0.001,0.055-0.005,0.033-0.025,0.07c0.015,0.008,0.03,0.017,0.044,0.025\r\n\t\t\t\tc-0.006,0.013-0.013,0.026-0.019,0.038v0.006H8.37c0.026-0.01,0.031-0.014,0.051,0c-0.039,0.071-0.09,0.135-0.114,0.229\r\n\t\t\t\tc0.004,0.013,0.008,0.025,0.013,0.038c0.008-0.002,0.017-0.004,0.025-0.006c0.017-0.038,0.034-0.076,0.051-0.114\r\n\t\t\t\tc0.02,0,0.017,0.006,0.032-0.006c0.023-0.055,0.047-0.11,0.07-0.165c0.033-0.056,0.086-0.075,0.102-0.14\r\n\t\t\t\tc-0.004-0.04-0.008-0.081-0.013-0.121c-0.078-0.033-0.136-0.206-0.152-0.292c0.024-0.023,0.034-0.046,0.064-0.064\r\n\t\t\t\tc0.002,0.002,0.004,0.004,0.006,0.006c-0.017,0.031-0.037,0.044-0.057,0.07c0.054,0.073,0.068,0.144,0.184,0.14\r\n\t\t\t\tc0.005,0.037-0.005,0.046-0.013,0.083v0.006c0.004,0.002,0.008,0.004,0.013,0.006c0.055-0.041,0.152-0.125,0.152-0.216\r\n\t\t\t\tc0.013,0.004,0.026,0.008,0.038,0.013c0.032-0.093,0.078-0.196,0.095-0.305c-0.053-0.007-0.063-0.019-0.089-0.051\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019c0.029-0.023,0.034-0.034,0.064-0.026c0.019-0.053,0.038-0.106,0.057-0.159\r\n\t\t\t\tc-0.015,0.047-0.03,0.093-0.045,0.14c0.19-0.133,0.413-0.223,0.744-0.222c0.008-0.043,0.017-0.085,0.025-0.127\r\n\t\t\t\tc0.002-0.002,0.036,0,0.064-0.013c0.003,0.022-0.008,0.053-0.006,0.095c0.004,0.002,0.008,0.004,0.013,0.007\r\n\t\t\t\tc0.058-0.002,0.108-0.049,0.121-0.089h0.006c0.013,0.016,0.014,0.037,0.013,0.07c0.072-0.017,0.144-0.034,0.216-0.051\r\n\t\t\t\tc0-0.035-0.012-0.048-0.019-0.067v0.016c-0.03,0.013-0.059,0.025-0.089,0.038c-0.017-0.006-0.034-0.013-0.051-0.019\r\n\t\t\t\tc-0.017-0.095-0.061-0.182-0.165-0.191c0.011-0.069,0.067-0.083,0.127-0.102c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.052-0.015-0.053-0.008-0.083-0.057c0.045-0.073,0.096-0.241,0.184-0.267v-0.07c0.028-0.011,0.055-0.021,0.083-0.032\r\n\t\t\t\tc-0.002,0.011-0.004,0.021-0.006,0.032c0.013,0.006,0.025,0.013,0.038,0.019h0.006c0.028-0.036,0.033-0.028,0.025-0.076\r\n\t\t\t\tc0.011-0.009,0.021-0.017,0.032-0.025c-0.004,0.015-0.008,0.03-0.013,0.044c0.017,0.004,0.034,0.008,0.051,0.013\r\n\t\t\t\tc0.008-0.021,0.017-0.042,0.025-0.064c0.013,0.008,0.025,0.017,0.038,0.025c0.059-0.044,0.113-0.149,0.14-0.222h0.006\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c-0.008,0.021-0.017,0.042-0.025,0.064c0.002,0.004,0.004,0.008,0.006,0.013\r\n\t\t\t\tc0.027,0.008,0.055,0.017,0.083,0.025c-0.004-0.019-0.008-0.038-0.013-0.057c0.046,0.008,0.075-0.021,0.121-0.032\r\n\t\t\t\tc0.006,0.019,0.013,0.038,0.019,0.057c0.038-0.028,0.057-0.071,0.095-0.095c0.015,0.011,0.03,0.021,0.044,0.032\r\n\t\t\t\tc0.018-0.015,0.017-0.011,0.019-0.045c0.069,0.012,0.096-0.012,0.153-0.038c0.011-0.019,0.01-0.016,0.013-0.032h-0.051\r\n\t\t\t\tc0.011-0.015,0.021-0.03,0.032-0.045c-0.011-0.023-0.021-0.047-0.032-0.07c0.011,0.008,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.041-0.039,0.135-0.02,0.178,0.013c0.034-0.019,0.068-0.038,0.102-0.057c-0.006-0.013-0.013-0.026-0.019-0.038\r\n\t\t\t\tc0.023,0.013,0.047,0.025,0.07,0.038c0.139-0.017,0.194-0.143,0.343-0.146c0.013-0.023,0.025-0.047,0.038-0.07\r\n\t\t\t\tc-0.006-0.019-0.013-0.038-0.019-0.057c0.024,0.019,0.04,0.035,0.044,0.076c0.019-0.011,0.038-0.021,0.057-0.032h0.006\r\n\t\t\t\tc-0.025,0.065-0.104,0.124-0.172,0.146c-0.008,0.017-0.011,0.022-0.013,0.051c0.108-0.056,0.302-0.039,0.432-0.025\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.092-0.002-0.148,0.034-0.229,0.051v0.044c-0.023-0.018-0.019-0.021-0.044-0.025\r\n\t\t\t\tc0.002-0.023,0.004-0.047,0.006-0.07c-0.083-0.003-0.358,0.164-0.413,0.222h-0.013c0.011,0.006,0.021,0.013,0.032,0.019v0.006\r\n\t\t\t\tc-0.027,0.003-0.018,0.002-0.038-0.013c-0.04,0.023-0.08,0.047-0.121,0.07c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.03-0.019,0.059-0.038,0.089-0.057c-0.014,0.038-0.023,0.015-0.044,0.038\r\n\t\t\t\tc-0.076,0.082-0.026,0.172-0.006,0.26c0.015-0.005,0.009-0.003,0.025-0.019c0.019,0.032,0.038,0.064,0.057,0.095\r\n\t\t\t\tc0.048-0.01,0.046-0.012,0.076,0.019c0.009-0.023,0.017-0.047,0.026-0.07c0.035-0.016,0.053-0.017,0.108-0.013v-0.045\r\n\t\t\t\tc0.006,0.004,0.013,0.009,0.019,0.013c0.062-0.036,0.089-0.171,0.203-0.172c0.014-0.051-0.01-0.053-0.013-0.108h0.038\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032h0.006c0.023-0.015,0.034-0.023,0.045-0.051c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc-0.002,0.015-0.004,0.03-0.006,0.045c0.036,0.004,0.072,0.008,0.108,0.013c0.016-0.034,0.031-0.025,0.038-0.07\r\n\t\t\t\tc0.011,0.006,0.021,0.013,0.032,0.019c0.004-0.015,0.008-0.03,0.013-0.044c0.006-0.002,0.013-0.004,0.019-0.006\r\n\t\t\t\tc0.032,0.009,0.026,0.014,0.045,0.032c0.124-0.045,0.262-0.143,0.407-0.146c-0.002-0.009-0.004-0.017-0.006-0.025\r\n\t\t\t\tc0.032,0.002,0.064,0.004,0.095,0.006c-0.004-0.006-0.008-0.013-0.013-0.019c0.006-0.004,0.013-0.009,0.019-0.013\r\n\t\t\t\tc0.024-0.013,0.02-0.005,0.044,0.013c0.021-0.009,0.042-0.017,0.063-0.025c-0.027-0.034-0.068-0.036-0.133-0.032\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c0.013-0.007,0.025-0.013,0.038-0.019c0.006-0.008,0.013-0.017,0.019-0.025\r\n\t\t\t\tc-0.021-0.021-0.042-0.042-0.063-0.064c-0.075-0.027-0.112,0.044-0.133-0.064c-0.066,0.01-0.086,0.052-0.133,0.07\r\n\t\t\t\tc-0.032,0.012-0.073,0.004-0.095,0.013c0.006-0.013,0.013-0.025,0.019-0.038h-0.013c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.067-0.031-0.119,0.027-0.165,0.006c-0.019-0.013-0.038-0.025-0.057-0.038c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.028-0.013-0.04-0.048-0.083-0.057h-0.013v-0.006c0.025-0.009,0.051-0.017,0.076-0.025c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc-0.103-0.049-0.301-0.028-0.267-0.191c-0.021-0.028-0.018-0.025-0.044-0.019c-0.013-0.053-0.009-0.079,0.013-0.121\r\n\t\t\t\tc-0.03-0.032-0.094-0.029-0.159-0.025c0.088-0.089,0.103-0.048,0.133-0.178c0.021-0.021,0.042-0.042,0.064-0.064\r\n\t\t\t\tc-0.015-0.011-0.03-0.021-0.044-0.032c-0.019,0.008-0.038,0.017-0.057,0.025v-0.032c-0.055,0.025-0.11,0.051-0.165,0.076\r\n\t\t\t\tc-0.065-0.089-0.112-0.14-0.254-0.152v-0.007c0.049-0.015,0.115-0.056,0.191-0.038c0.034,0.015,0.068,0.03,0.102,0.045\r\n\t\t\t\tc0.079-0.006,0.346-0.155,0.375-0.216c-0.094-0.249-0.411-0.255-0.674-0.152c-0.282,0.11-0.595,0.189-0.82,0.356\r\n\t\t\t\tc-0.184,0.136-0.321,0.345-0.502,0.489c0.154-0.325,0.477-0.718,0.775-0.896c0.079-0.047,0.223-0.03,0.299-0.083\r\n\t\t\t\tc0.108-0.076,0.07-0.268,0.267-0.337c0.117-0.041,0.317-0.025,0.439-0.006c0.178,0.027,0.354-0.025,0.515-0.006\r\n\t\t\t\tc0.163,0.008,0.326,0.017,0.489,0.025c0.219-0.035,0.465-0.038,0.61-0.146c0.083-0.091,0.165-0.182,0.248-0.273\r\n\t\t\t\tc0.155-0.015,0.309-0.03,0.464-0.044c0.1-0.032,0.288-0.2,0.375-0.267v-0.013c-0.042-0.055-0.085-0.11-0.127-0.165\r\n\t\t\t\tc0.034-0.061,0.064-0.142,0.095-0.21c-0.007-0.1-0.158-0.181-0.248-0.197c-0.041-0.008-0.112,0.043-0.153,0.064\r\n\t\t\t\tc-0.013-0.019-0.025-0.038-0.038-0.057c0.008-0.044,0.031-0.064,0.051-0.095c-0.257-0.247-0.418,0.027-0.61,0.133\r\n\t\t\t\tc-0.089,0.05-0.218,0.06-0.305,0.095c0.012-0.069,0.034-0.173,0.083-0.21c0.053-0.004,0.106-0.008,0.159-0.013\r\n\t\t\t\tc0.109-0.031,0.157-0.136,0.28-0.165c0.122-0.029,0.24-0.033,0.292-0.127c-0.11-0.028-0.22-0.055-0.33-0.083\r\n\t\t\t\tc-0.106-0.044-0.191-0.133-0.324-0.153c-0.101-0.015-0.161,0.043-0.261,0.038c0.021-0.051,0.042-0.102,0.064-0.152\r\n\t\t\t\tc-0.007-0.092-0.237-0.273-0.311-0.299H12.48c-0.062-0.024-0.129-0.187-0.165-0.241c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.055-0.031,0.185,0.022,0.261,0c0.012-0.024,0.014-0.061,0.013-0.102c-0.084-0.062-0.178-0.095-0.242-0.178\r\n\t\t\t\tc0.027-0.025,0.057-0.044,0.102-0.051c-0.036-0.207-0.226-0.07-0.261-0.356c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.009-0.07,0.017-0.079,0.032-0.134c-0.122-0.141-0.365-0.561-0.508-0.629c-0.004-0.004-0.008-0.008-0.013-0.013\r\n\t\t\t\tc-0.021,0.042-0.042,0.085-0.064,0.127c-0.144,0.096-0.271,0.026-0.114,0.235c-0.096,0.122-0.182,0.158-0.184,0.388h-0.006\r\n\t\t\t\tc-0.051-0.051-0.057-0.152-0.153-0.159c-0.034,0.059-0.068,0.119-0.102,0.178c-0.077,0.058-0.266,0.055-0.349,0.095\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c0.014-0.022,0.019-0.03,0.019-0.07c-0.149-0.221-0.275-0.116-0.483-0.044h-0.006\r\n\t\t\t\tc-0.044-0.056-0.038-0.084-0.026-0.178c0.036,0.002,0.072,0.004,0.108,0.006c0.112-0.165-0.211-0.619,0.013-0.724\r\n\t\t\t\tc0.011-0.023,0.014-0.056,0.013-0.095c-0.011-0.017-0.021-0.034-0.032-0.051c-0.039-0.011-0.088,0.06-0.178,0.038\r\n\t\t\t\tc-0.162-0.039-0.31-0.129-0.458-0.159c-0.052-0.065-0.056-0.061-0.013-0.14c-0.022-0.016-0.052-0.042-0.077-0.062\r\n\t\t\t\tc0.109-0.188,0.225-0.372,0.338-0.557c0.01,0.006,0.021,0.007,0.031,0.015c0.006,0.003,0.064-0.003,0.102,0.013\r\n\t\t\t\tc0.028,0.017,0.055,0.034,0.083,0.051c0.049,0.006,0.097,0.013,0.146,0.019c0.04,0.047,0.081,0.093,0.121,0.14\r\n\t\t\t\tc0.094,0.057,0.203,0.032,0.331,0.064c0.203,0.072,0.407,0.144,0.61,0.216c-0.067-0.217-0.212-0.375-0.381-0.489\r\n\t\t\t\tc-0.155-0.104-0.443-0.179-0.47-0.4c0.186,0,0.218,0.082,0.343,0.127c-0.009-0.049-0.017-0.097-0.026-0.146\r\n\t\t\t\tc0.188,0.145,0.277,0.375,0.604,0.349c0.069,0.109,0.145,0.196,0.273,0.248c-0.038-0.078-0.076-0.157-0.114-0.235\r\n\t\t\t\tc0.04,0.008,0.08,0.017,0.121,0.025h0.006c-0.006-0.184-0.176-0.25-0.153-0.432c0.084,0.057,0.177,0.169,0.216,0.267\r\n\t\t\t\tc0.008,0.006,0.017,0.013,0.025,0.019c0.037-0.334-0.178-0.289-0.292-0.477c0.006-0.013,0.013-0.026,0.019-0.038\r\n\t\t\t\tc0.025-0.006,0.051-0.013,0.076-0.019h0.013c-0.061-0.03-0.123-0.059-0.184-0.089c-0.069-0.041-0.11-0.13-0.191-0.153\r\n\t\t\t\tc-0.019,0.015-0.038,0.03-0.057,0.044c-0.008,0.008-0.017,0.017-0.025,0.026c-0.071-0.122-0.147-0.253-0.21-0.388\r\n\t\t\t\tc-0.053-0.009-0.106-0.017-0.159-0.025c-0.006-0.014-0.012-0.027-0.019-0.04c0.024-0.035,0.051-0.067,0.076-0.101\r\n\t\t\t\tc0.001,0.003,0.005,0.005,0.006,0.008c0.04-0.004,0.081-0.009,0.121-0.013c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.022-0.025-0.045-0.05-0.067-0.075c0.044-0.062,0.092-0.121,0.137-0.183c0.134,0.06,0.208,0.164,0.343,0.226\r\n\t\t\t\tc0.072,0.033,0.155,0.015,0.21,0.051c-0.013,0.036-0.025,0.072-0.038,0.108c0.005,0.082,0.057,0.11,0.089,0.165\r\n\t\t\t\tc0.042-0.019,0.085-0.038,0.127-0.057c0.033,0.038,0.022,0.078,0.051,0.127c0.022,0.036,0.201,0.12,0.248,0.102h0.013\r\n\t\t\t\tc-0.015-0.064-0.03-0.127-0.045-0.191c0.011-0.076,0.021-0.153,0.032-0.229c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.036,0.05,0.089,0.124,0.159,0.14c0.035-0.09,0.113-0.136,0.222-0.152c-0.011-0.088-0.097-0.155-0.165-0.184\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.15-0.095,0.182,0.061,0.324,0c0.025-0.019,0.058-0.097,0.089-0.127\r\n\t\t\t\tc0.002-0.006,0.004-0.013,0.006-0.019c-0.087-0.061-0.174-0.123-0.261-0.184c-0.092,0.084-0.164,0.079-0.299,0.051\r\n\t\t\t\tc0.013-0.043,0.025-0.085,0.038-0.127c-0.147-0.013-0.29,0.025-0.47,0.026v-0.095c0.061-0.015,0.123-0.03,0.184-0.044h0.013\r\n\t\t\t\tc-0.051-0.098-0.165-0.231-0.267-0.273c-0.037-0.015-0.062-0.003-0.087,0.008c0.618-0.794,1.268-1.56,1.972-2.276\r\n\t\t\t\tc0.027,0.005,0.054,0.009,0.08,0.014c0.042,0.011,0.084,0.021,0.127,0.032c0.022-0.003,0.044-0.006,0.065-0.009\r\n\t\t\t\tc0.003,0,0.005,0,0.008,0c0.003,0.007,0.006,0.014,0.01,0.022c0.02,0.004,0.051,0.001,0.079-0.002\r\n\t\t\t\tc0.003,0.003,0.005,0.006,0.008,0.008c-0.045,0.019-0.061,0.016-0.102,0.01c-0.025,0.007-0.079,0.031-0.085,0.046\r\n\t\t\t\tc-0.01,0.04,0.124,0.116,0.183,0.098c0.044-0.017,0.087-0.034,0.131-0.051c0.058-0.019,0.1-0.003,0.157-0.022\r\n\t\t\t\tc0.096-0.031,0.196-0.098,0.229-0.154c0.053-0.088-0.124-0.137-0.191-0.155c-0.063-0.017-0.099-0.061-0.143-0.099\r\n\t\t\t\tc-0.051-0.044-0.123-0.071-0.209-0.083c0.015-0.015,0.032-0.028,0.047-0.043c0.017,0.003,0.035,0.009,0.05,0.01\r\n\t\t\t\tc0.011-0.005,0.009-0.006,0.015-0.011c0.018-0.001,0.036-0.001,0.055-0.002c0.098,0.013,0.166,0.087,0.242,0.125\r\n\t\t\t\tc0.058,0.029,0.126,0.035,0.206,0.042c0.022,0.002,0.033,0.013,0.057,0.012c0.021-0.022,0.037-0.048,0.097-0.049\r\n\t\t\t\tc0.002,0.002,0.005,0.004,0.007,0.005c0.001,0.001,0.003,0.003,0.004,0.004c-0.009,0.006-0.019,0.012-0.028,0.019\r\n\t\t\t\tc0.003,0.004,0.006,0.009,0.01,0.013c0.082-0.002,0.101-0.036,0.149-0.053c0.04-0.014,0.063,0.003,0.095-0.008\r\n\t\t\t\tc-0.012,0.025-0.046,0.04-0.061,0.063c-0.015,0.023-0.012,0.045-0.025,0.07c-0.007,0.014-0.031,0.02-0.038,0.036\r\n\t\t\t\tc0.01,0.019,0.049,0.027,0.043,0.05c-0.003,0.006-0.051,0.024-0.06,0.026c0,0.019-0.02,0.038-0.005,0.057\r\n\t\t\t\tc0.01,0.008,0.024,0.008,0.042,0.007c0.003,0.002,0.006,0.003,0.009,0.005c-0.017,0.009-0.038,0.017-0.052,0.026\r\n\t\t\t\tc-0.001,0.018,0.024,0.052,0.013,0.071c-0.012,0.019-0.048,0.03-0.06,0.051c0,0.001,0,0.001,0,0.002\r\n\t\t\t\tc0.084-0.011,0.07-0.036,0.138-0.055c0.04,0.003,0.027,0.022,0.052,0.038c0.012,0.003,0.025,0.006,0.037,0.01\r\n\t\t\t\tc0.001,0.001,0.002,0.002,0.004,0.003c0,0.002,0,0.005,0,0.007c-0.016,0.04-0.137,0.028-0.188,0.046\r\n\t\t\t\tc-0.007,0.004-0.065,0.071-0.067,0.078c0.003,0.008,0.005,0.016,0.008,0.024c-0.011,0.012-0.022,0.025-0.032,0.038\r\n\t\t\t\tc-0.019,0.031-0.038,0.062-0.057,0.092c0.074-0.015,0.084-0.049,0.159-0.064c0.061,0.021,0.023,0.086-0.02,0.107\r\n\t\t\t\tc-0.029,0.014-0.071,0.006-0.102,0.011c-0.063,0.01-0.105,0.042-0.185,0.049c-0.054,0.004-0.117-0.01-0.169,0.006\r\n\t\t\t\tc-0.118,0.035-0.158,0.131-0.289,0.172c0.034,0.002,0.095,0.005,0.125,0.003c0.039-0.009,0.078-0.018,0.118-0.027\r\n\t\t\t\tc0.023,0.004,0.047,0.008,0.07,0.012c0.05,0.008,0.104,0.007,0.161,0.008c0.03-0.031,0.065-0.027,0.119-0.048\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.006c0-0.015-0.011-0.025-0.03-0.026c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.021-0.031,0.098-0.036,0.127-0.016c0.007,0.042-0.069,0.055-0.07,0.092c-0.002,0.059,0.172,0.07,0.202,0.108\r\n\t\t\t\tc-0.014,0.005-0.016,0.007-0.013,0.017c-0.062-0.014-0.133-0.027-0.211-0.024c-0.053,0.005-0.106,0.01-0.159,0.015\r\n\t\t\t\tc-0.058,0-0.109-0.014-0.16-0.022c-0.067-0.011-0.133-0.021-0.2-0.032c-0.003,0.001-0.007,0.001-0.01,0.002\r\n\t\t\t\tc-0.003,0.006-0.007,0.012-0.01,0.018c0,0.026,0.154,0.053,0.194,0.053c0.012,0.005,0.034,0.016,0.012,0.028\r\n\t\t\t\tc-0.041,0.017-0.145-0.037-0.22-0.018c-0.111,0.028-0.099,0.092-0.137,0.146c-0.027,0.036-0.054,0.071-0.081,0.107\r\n\t\t\t\tc-0.003,0.008,0.004,0.014,0.009,0.02c0.107,0.021,0.169-0.081,0.21-0.108c0.029-0.009,0.058-0.018,0.086-0.026\r\n\t\t\t\tc0.066-0.032,0.111-0.067,0.214-0.086c-0.003,0.016-0.019,0.023-0.018,0.04c0.034,0.031,0.073,0.012,0.142,0.008\r\n\t\t\t\tc0.019,0,0.038-0.001,0.058-0.001c0.029-0.02,0.092-0.051,0.055-0.082c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.073-0.008,0.116-0.013,0.164,0.002c0.001,0.002,0.001,0.004,0.002,0.006c-0.029,0.03-0.094,0.055-0.093,0.094\r\n\t\t\t\tc0.024,0.013,0.055,0.015,0.064,0.043c-0.107,0.003-0.221,0.01-0.318,0.003c-0.048-0.004-0.097-0.025-0.149-0.02\r\n\t\t\t\tc-0.05,0.005-0.095,0.041-0.126,0.057c-0.053,0.028-0.107,0.056-0.16,0.084c-0.031,0.011-0.061,0.023-0.092,0.034\r\n\t\t\t\tc-0.026,0.023-0.052,0.046-0.077,0.07c0.097,0.037,0.343-0.041,0.494-0.055c0.031-0.005,0.062-0.01,0.093-0.014\r\n\t\t\t\tc0.025,0.006,0.05,0.012,0.074,0.017c0.027-0.002,0.053-0.004,0.08-0.005c0.071,0.006,0.103,0.061,0.143,0.099\r\n\t\t\t\tc-0.048-0.007-0.096-0.013-0.143-0.019c-0.175-0.014-0.382-0.023-0.599,0.048c-0.044,0.013-0.088,0.026-0.132,0.039\r\n\t\t\t\tc0.033,0.026,0.093,0.01,0.126,0.031c0.015,0.022,0.03,0.043,0.045,0.065c0.009,0.006,0.187,0.026,0.212,0.028\r\n\t\t\t\tc0.027-0.007,0.031-0.019,0.051-0.03c0.071-0.01,0.102,0.049,0.058,0.079c-0.07,0.047-0.247,0.037-0.329,0.081\r\n\t\t\t\tc-0.002,0-0.003,0.001-0.005,0.001c0.03,0.018,0.163,0.033,0.21,0.036c-0.003,0.003-0.155,0.049-0.161,0.049\r\n\t\t\t\tc-0.041,0.003-0.061-0.021-0.109,0.004c-0.042,0.022-0.094,0.081-0.039,0.115c0.01,0.006,0.061,0.009,0.061,0.018\r\n\t\t\t\tc0.001,0.014-0.046,0.027-0.052,0.042c-0.006,0.028,0.035,0.04,0.072,0.026c0.049-0.018,0.116-0.057,0.149-0.083\r\n\t\t\t\tc0.068-0.052,0.139-0.105,0.219-0.153c0.026-0.012,0.052-0.023,0.078-0.035c0.04-0.037,0.08-0.074,0.119-0.111\r\n\t\t\t\tc0.043-0.03,0.109-0.051,0.168-0.075c0.037-0.015,0.07-0.028,0.113-0.042c0.041-0.009,0.082-0.018,0.123-0.027\r\n\t\t\t\tc0.021-0.007,0.051-0.021,0.08-0.02c0.023,0.007,0.047,0.013,0.07,0.02c-0.022,0.019-0.042,0.053-0.07,0.067\r\n\t\t\t\tc-0.075,0.036-0.22,0.019-0.315,0.037c-0.025,0.043-0.11,0.069-0.158,0.098c-0.009,0.008-0.002,0.019-0.007,0.028\r\n\t\t\t\tc-0.013,0.026-0.056,0.051-0.112,0.061c0.003,0.009,0.006,0.018,0.009,0.026c-0.158,0.057-0.262,0.142-0.375,0.215\r\n\t\t\t\tc-0.03,0.019-0.109,0.042-0.12,0.068c-0.012,0.015,0.009,0.03,0.021,0.039c0.065,0.049,0.103,0.014,0.195-0.009\r\n\t\t\t\tc-0.019,0.04-0.065,0.091-0.144,0.109c-0.001,0.005-0.002,0.009-0.003,0.014c0.052,0.027,0.141,0.031,0.175-0.022\r\n\t\t\t\tc0.113-0.018,0.086,0.118,0.06,0.151c0.003,0.005,0.006,0.006,0.012,0.013c0.055-0.019,0.148-0.049,0.186-0.075\r\n\t\t\t\tc0.004-0.001,0.008-0.002,0.012-0.002c0.002,0.001,0.004,0.001,0.006,0.002c0.001,0.002,0.001,0.004,0.002,0.006\r\n\t\t\t\tc-0.05,0.055-0.176,0.082-0.215,0.141c0.012,0.026,0.047,0.037,0.078,0.043c0.037-0.003,0.063-0.022,0.086-0.035\r\n\t\t\t\tc0.013,0.011,0.023,0.019,0.028,0.038l-0.049,0.069c-0.008,0.002-0.017,0.003-0.025,0.005c0.026,0.048,0.092,0.004,0.15,0.016\r\n\t\t\t\tc0.032,0.007,0.037,0.052,0.057,0.069c-0.179,0.032-0.096,0.172-0.138,0.254c-0.009,0.019-0.043,0.094-0.017,0.116\r\n\t\t\t\tc0.006,0.006,0.01,0.008,0.021,0.009c0.036,0,0.069-0.044,0.086-0.058c0.047-0.038,0.105-0.089,0.124-0.137\r\n\t\t\t\tc-0.001-0.015-0.003-0.029-0.004-0.044c0.001-0.019,0.025-0.055,0.047-0.067c0.006-0.002,0.011-0.003,0.017-0.005\r\n\t\t\t\tc0.034,0.014,0.057,0.047,0.075,0.077c0.002,0,0.004,0,0.006,0.001c0.011-0.016,0.023-0.032,0.034-0.048\r\n\t\t\t\tc-0.003-0.046-0.006-0.093-0.009-0.14c0.001-0.041,0.018-0.075,0.027-0.11c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.023,0.013,0.046,0.027,0.069,0.04c0.012,0.015-0.004,0.03-0.005,0.042c-0.002,0.033,0.023,0.085,0.059,0.092\r\n\t\t\t\tc0.037,0.007,0.092-0.018,0.131-0.027c0.005,0.037,0.052,0.138,0.083,0.157c0.029,0.009,0.057,0.019,0.086,0.029\r\n\t\t\t\tc0.033,0.016,0.053,0.039,0.077,0.065c0.001,0.003,0.002,0.005,0.003,0.008c-0.08,0.005-0.209-0.043-0.25-0.08\r\n\t\t\t\tc-0.027-0.024-0.028-0.082-0.07-0.091c-0.061-0.014-0.142,0.044-0.163,0.066c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc0.02,0.01,0.078,0.031,0.064,0.059c-0.007,0.019-0.053,0.031-0.075,0.044c-0.062,0.036-0.11,0.071-0.19,0.104\r\n\t\t\t\tc-0.027,0.011-0.089,0.021-0.104,0.038c0.022,0.035,0.111,0.043,0.185,0.018c0.087-0.037,0.175-0.073,0.262-0.11\r\n\t\t\t\tc0.013-0.012,0.026-0.024,0.038-0.036c0.017,0.036,0.059,0.046,0.081,0.071c-0.024,0.009-0.063,0.011-0.098,0.022\r\n\t\t\t\tc-0.09,0.027-0.188,0.048-0.269,0.081c-0.035,0.015-0.092,0.041-0.134,0.034c0.005,0.043,0.049,0.052,0.057,0.092\r\n\t\t\t\tc0.009-0.001,0.019-0.001,0.028-0.002c0,0.002,0.001,0.003,0.001,0.005c-0.015,0.021-0.059,0.025-0.1,0.034\r\n\t\t\t\tc-0.001,0.003-0.002,0.006-0.002,0.009c0.071,0.035,0.051,0.061,0.071,0.126c0.078,0.018,0.126-0.035,0.181-0.058\r\n\t\t\t\tc0.036-0.015,0.083-0.023,0.132-0.032c-0.069,0.057-0.138,0.115-0.207,0.173c0.001,0.002,0.002,0.005,0.003,0.008\r\n\t\t\t\tc0.058,0.008,0.109-0.033,0.173-0.036c0.069-0.004,0.128,0.034,0.115,0.093c-0.012,0.053-0.138,0.066-0.08,0.133\r\n\t\t\t\tc0.048,0.01,0.079-0.016,0.127-0.014c0.002,0,0.003-0.001,0.005-0.001c-0.008,0.023-0.056,0.064-0.035,0.086\r\n\t\t\t\tc0,0.001,0.001,0.002,0.001,0.003c0.108-0.031,0.124-0.099,0.202-0.141c0.009,0.002,0.017,0.004,0.026,0.007\r\n\t\t\t\tc0.001,0.027-0.032,0.057-0.047,0.081c-0.042,0.065-0.084,0.13-0.126,0.195c-0.029,0.051,0.007,0.108,0.077,0.123\r\n\t\t\t\tc0.05,0,0.1,0,0.15,0c0.05,0.005,0.1,0.01,0.15,0.014c0.012,0.017,0.027,0.044,0.031,0.062c-0.019,0.015-0.049,0.031-0.085,0.039\r\n\t\t\t\tc0.002,0.01,0.001,0.012-0.009,0.02c0.009,0.017,0.026,0.022,0.046,0.028c0.037-0.01,0.093-0.026,0.121-0.041\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.007,0.012c-0.008,0.012-0.025,0.015-0.043,0.023c-0.061,0.029-0.098,0.044-0.103,0.095\r\n\t\t\t\tc0.112-0.018,0.147-0.073,0.235-0.096c0.023,0.072-0.093,0.095-0.116,0.152c0.011,0.023,0.039,0.022,0.053,0.041\r\n\t\t\t\tc-0.039,0.015-0.064,0.034-0.097,0.049c0.041,0.037,0.102,0.063,0.19,0.023c0.008-0.005,0.016-0.011,0.024-0.016\r\n\t\t\t\tc0.023-0.009,0.031,0.008,0.05,0c0.045-0.018,0.029-0.058,0.122-0.037c0,0.002,0.001,0.003,0.002,0.005\r\n\t\t\t\tc-0.013,0.033-0.073,0.046-0.136,0.061c0.058,0.029,0.233,0.015,0.271,0.055c0.036,0.037-0.063,0.081-0.014,0.117\r\n\t\t\t\tc0.006,0.002,0.012,0.001,0.023-0.001c0.028-0.024,0.047-0.046,0.101-0.061c0.008,0.002,0.015,0.004,0.023,0.006\r\n\t\t\t\tc0.006,0.033,0.035,0.061,0.034,0.088c-0.001,0.032-0.072,0.06-0.133,0.07c0.072,0.019,0.181,0.032,0.277,0\r\n\t\t\t\tc-0.001-0.01-0.006-0.026,0.007-0.035c0.001,0,0.002,0,0.003,0c0.025-0.008,0.049-0.015,0.074-0.023\r\n\t\t\t\tc0.018-0.009,0.018-0.024,0.048-0.029c0.001,0,0.002,0,0.003,0s0.002,0,0.002,0c0.001,0,0.002,0,0.003-0.001\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0c0.032-0.001,0.061,0.018,0.104,0.004c0.031-0.018,0.062-0.035,0.094-0.053\r\n\t\t\t\tc0.044-0.016,0.092,0.019,0.092-0.034c0.064,0.001,0.128-0.025,0.114-0.063c-0.096-0.034-0.03-0.068,0.043-0.095\r\n\t\t\t\tc0.035,0.012,0.033,0.039,0.06,0.062c0.009,0.008,0.023,0.008,0.03,0.019c-0.036,0.036-0.115,0.1-0.125,0.14\r\n\t\t\t\tc0.023-0.018,0.04-0.047,0.076-0.059c0.023-0.008,0.049-0.002,0.073-0.012c0.024-0.019,0.048-0.037,0.072-0.055\r\n\t\t\t\tc0.008,0.022,0.018,0.041,0.034,0.055c0.013,0.012,0.052,0.019,0.053,0.04c0.001,0.034-0.057,0.046-0.088,0.07\r\n\t\t\t\tc-0.018,0.014-0.016,0.041-0.034,0.057c-0.035,0.025-0.07,0.05-0.105,0.075c0,0,0,0.001,0.001,0.002\r\n\t\t\t\tc0.032-0.001,0.055-0.016,0.087-0.017c0.02,0.011,0.033,0.028,0.047,0.046c0.002,0.001,0.004,0.002,0.006,0.002\r\n\t\t\t\tc0.075-0.019,0.046-0.092,0.085-0.126c0.041-0.013,0.102-0.007,0.101,0.026c-0.001,0.043-0.072,0.076-0.03,0.132\r\n\t\t\t\tc0.056,0.007,0.091-0.071,0.108-0.096c0.011-0.016,0.04-0.031,0.063-0.042c-0.021,0.042-0.041,0.083-0.062,0.125\r\n\t\t\t\tc0.006-0.001,0.012-0.002,0.017-0.003c0.053,0.045-0.139,0.11-0.08,0.183c0.052,0.007,0.11-0.041,0.178-0.037\r\n\t\t\t\tc0.043,0.002,0.057,0.042,0.094,0.052c0.006-0.001,0.012-0.002,0.017-0.003c0.057-0.029,0.042-0.124,0.109-0.141\r\n\t\t\t\tc0.08-0.02,0.159,0.014,0.22,0.018c0.039-0.001,0.078-0.003,0.117-0.004c0.03,0.001,0.076,0.02,0.11-0.001\r\n\t\t\t\tc0.013-0.009,0.015-0.023,0.02-0.035c0.036-0.085-0.093-0.067-0.067-0.122c-0.041,0.011-0.059,0.029-0.089,0.042\r\n\t\t\t\tc-0.065,0.028-0.129-0.005-0.144-0.044c0.136-0.026,0.396-0.115,0.395-0.18c-0.021,0.001-0.042,0.001-0.063,0.002\r\n\t\t\t\tc-0.034,0.009-0.058,0.035-0.104,0.036c-0.051,0.002-0.124-0.029-0.138-0.067c0.064-0.012,0.128-0.025,0.185-0.032\r\n\t\t\t\tc-0.019-0.013-0.058-0.022-0.087-0.023c-0.003-0.002-0.006-0.003-0.01-0.005c0.031-0.01,0.075-0.019,0.101-0.029\r\n\t\t\t\tc0.034-0.059-0.048-0.07,0.054-0.117c0-0.003,0-0.005,0-0.008c-0.048-0.03-0.174,0.004-0.201-0.043\r\n\t\t\t\tc-0.008-0.014,0.003-0.029,0.009-0.038c0.034-0.053,0.14-0.038,0.185-0.014c0.017-0.003,0.026-0.005,0.033-0.011\r\n\t\t\t\tc0.019-0.014,0.036-0.1,0.012-0.124c0.044-0.024,0.037-0.052,0.056-0.086c0.01-0.01,0.02-0.02,0.03-0.031\r\n\t\t\t\tc-0.041,0.006-0.092,0.025-0.124,0.016l-0.008-0.015c0.097-0.014,0.14-0.081,0.167-0.127c-0.03-0.052-0.1-0.085-0.104-0.156\r\n\t\t\t\tc-0.112-0.018-0.212-0.043-0.286-0.1c0.086-0.011,0.213,0.059,0.274,0.031c0.002-0.001,0.005-0.002,0.007-0.003\r\n\t\t\t\tc-0.001-0.003-0.002-0.005-0.003-0.008c-0.042-0.016-0.114-0.015-0.143-0.042c-0.025-0.024-0.027-0.071-0.049-0.092\r\n\t\t\t\tc0.047-0.029,0.093-0.059,0.14-0.088c0.046-0.019,0.099-0.029,0.134-0.05c-0.008-0.009-0.016-0.018-0.025-0.027\r\n\t\t\t\tc-0.005-0.014-0.011-0.028-0.016-0.042c-0.03-0.035-0.107-0.073-0.064-0.124c0-0.001-0.001-0.002-0.001-0.003\r\n\t\t\t\tc0.036,0.017,0.147,0.055,0.204,0.044c-0.001-0.003-0.002-0.005-0.003-0.008c0.006-0.008,0.012-0.008,0.012-0.019\r\n\t\t\t\tc-0.034-0.018-0.117-0.048-0.111-0.082c0.001-0.001,0.003-0.002,0.004-0.003c0.046,0.004,0.07,0.02,0.12,0.02\r\n\t\t\t\tc0.021-0.009,0.035-0.019,0.033-0.036c-0.026-0.023-0.065-0.029-0.091-0.051c0.001-0.002,0.002-0.005,0.003-0.007\r\n\t\t\t\tc0.035-0.01,0.079,0.009,0.106-0.015c0.019-0.013,0.014-0.041,0.035-0.055c0.018-0.012,0.068-0.012,0.091-0.021\r\n\t\t\t\tc0.015-0.022,0.003-0.047-0.001-0.075c-0.068,0.036-0.136,0.006-0.192,0.002c-0.019,0-0.038,0.001-0.058,0.001\r\n\t\t\t\tc-0.021-0.005-0.042-0.024-0.057-0.036c0,0,0-0.001,0-0.002c0.047,0,0.084,0.013,0.126,0.016\r\n\t\t\t\tc0.044-0.001,0.088-0.001,0.131-0.002c0.028-0.001,0.09-0.009,0.1-0.024c0.026-0.037-0.037-0.077-0.065-0.092\r\n\t\t\t\tc-0.023-0.013-0.046-0.027-0.069-0.04c-0.012-0.013-0.024-0.025-0.036-0.038c-0.018-0.01-0.063-0.003-0.087-0.007\r\n\t\t\t\tc-0.051-0.015-0.102-0.031-0.152-0.046c0.035-0.013,0.071-0.026,0.106-0.039c0.054-0.022,0.094-0.056,0.147-0.073\r\n\t\t\t\tc0.065-0.021,0.098,0.007,0.147-0.018c-0.003-0.033-0.056-0.036-0.075-0.06c0.04-0.014,0.032-0.041,0.033-0.07\r\n\t\t\t\tC18.58,15.989,18.564,16,18.55,15.989c-0.01-0.017-0.02-0.034-0.03-0.051c-0.015-0.01-0.031-0.019-0.047-0.029\r\n\t\t\t\tc-0.088-0.043-0.195,0.005-0.197-0.102c-0.016-0.007-0.033-0.014-0.049-0.021c0.207-0.079,0.173-0.008,0.319,0\r\n\t\t\t\tc0.03-0.008,0.081-0.026,0.102-0.043c0.038-0.03,0.094-0.146,0.023-0.187c-0.046-0.027-0.126-0.019-0.183-0.035l-0.005,0.001\r\n\t\t\t\tc0,0,0-0.001-0.001-0.002c0.156-0.015,0.143-0.03,0.163-0.114c0.004-0.003,0.009-0.005,0.013-0.007c0.003,0,0.005,0,0.008,0\r\n\t\t\t\tc0.029,0.023,0.044,0.049,0.091,0.053c0.011,0.002,0.008-0.002,0.02-0.004c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.017-0.036-0.034-0.072-0.051-0.108c0.001-0.001,0.003-0.002,0.005-0.003c0.035,0.01,0.044,0.023,0.074,0.039\r\n\t\t\t\tc0.01,0.002,0.021,0.004,0.031,0.006c0.009,0.009,0.018,0.019,0.028,0.028c0.03,0.017,0.13,0.009,0.165-0.018\r\n\t\t\t\tc0.031-0.024,0.019-0.064,0.056-0.086c0.014-0.008,0.03-0.006,0.037,0.001c0.13-0.104-0.137-0.115-0.131-0.166\r\n\t\t\t\tc0.002-0.017,0.048-0.033,0.064-0.046c0.043-0.032,0.089-0.076,0.116-0.114c-0.009,0-0.018-0.001-0.027-0.001\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.004c0.05-0.023,0.021-0.065,0.001-0.1c0.055,0.009,0.141,0.024,0.224-0.01\r\n\t\t\t\tc-0.032,0.049-0.038,0.104-0.065,0.156c-0.017,0.033-0.065,0.069-0.066,0.104c0.008,0.011,0.016,0.021,0.024,0.032\r\n\t\t\t\tc0.015,0.03-0.047,0.071-0.007,0.098c0.021,0.016,0.068,0.009,0.106,0.008c0.001,0,0.002,0,0.002,0\r\n\t\t\t\tc-0.004-0.037,0.007-0.078-0.028-0.11c0.083-0.005,0.124-0.07,0.134-0.107c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.022,0.02,0.027,0.067,0.068,0.07c0.003,0,0.007,0,0.01,0c0.055-0.028,0.102-0.093,0.119-0.136\r\n\t\t\t\tc-0.006-0.004-0.012-0.009-0.018-0.013c0.001,0,0.002,0,0.003,0c0.045,0.009,0.167,0.05,0.2-0.008\r\n\t\t\t\tc0.002-0.031,0.004-0.063,0.006-0.094c0.012-0.023,0.053-0.042,0.051-0.069c0.004-0.047-0.125-0.031-0.121-0.087\r\n\t\t\t\tc0.012-0.034,0.201-0.025,0.247-0.027c0.022,0.013,0.039,0.036,0.067,0.044c0.065-0.002,0.086-0.04,0.101-0.069\r\n\t\t\t\tc0.032-0.059,0.046-0.123,0.077-0.184c0.014-0.028,0.029-0.056,0.043-0.085c0.008-0.021-0.001-0.073-0.025-0.093\r\n\t\t\t\tc-0.006-0.002-0.003-0.002-0.013-0.001c0.018-0.037,0.066-0.059,0.078-0.1c-0.014-0.01-0.028-0.02-0.042-0.03\r\n\t\t\t\tc-0.026-0.028-0.037-0.094-0.024-0.122c0.013-0.028,0.059-0.047,0.07-0.077c0.014-0.038-0.033-0.077-0.004-0.117\r\n\t\t\t\tc0.02-0.027,0.112-0.04,0.135-0.086c0.002-0.016,0.004-0.032,0.005-0.048c0.016-0.031,0.132-0.113,0.06-0.153\r\n\t\t\t\tc-0.023-0.013-0.064-0.006-0.096-0.01c-0.002,0-0.003,0.001-0.005,0.001c0.016-0.009,0.034-0.011,0.039-0.024\r\n\t\t\t\tc0.017-0.065-0.146-0.086-0.173-0.118c0.009-0.012,0.018-0.025,0.027-0.037c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.031,0.059,0.15,0.093,0.239,0.092c0.045,0,0.091-0.01,0.128-0.003c0.046,0.009,0.076,0.04,0.128,0.044\r\n\t\t\t\tc0.046,0.004,0.173-0.02,0.191-0.045c-0.003-0.044-0.086-0.053-0.114-0.083c0.091,0.005,0.077-0.035,0.134,0.031\r\n\t\t\t\tc0.041,0.007,0.101-0.012,0.116-0.034c0.001-0.052-0.066-0.084-0.058-0.137c0.005-0.005,0.011-0.01,0.016-0.015\r\n\t\t\t\tc0.03,0.025,0.076,0.076,0.147,0.053c0.075-0.023,0.014-0.08,0.073-0.109c0.046-0.014,0.093-0.029,0.139-0.043\r\n\t\t\t\tc0.048-0.025,0.083-0.063,0.134-0.089c0.033-0.013,0.065-0.027,0.098-0.04c0.023-0.014,0.024-0.037,0.052-0.051\r\n\t\t\t\tc0.052-0.027,0.165-0.104,0.16-0.147c0.013,0,0.026-0.001,0.039-0.001c0.009-0.007,0.007-0.015,0.014-0.021\r\n\t\t\t\tc0.024-0.02,0.098-0.01,0.069-0.046c-0.007-0.009-0.015-0.014-0.02-0.028c0.02-0.022,0.045-0.041,0.1-0.051\r\n\t\t\t\tc-0.003-0.01-0.007-0.02-0.01-0.03c0.004-0.01,0.018-0.015,0.036-0.02c0.005-0.043-0.016-0.072-0.045-0.098\r\n\t\t\t\tc0.008-0.035,0.079-0.049,0.107-0.077c0-0.029-0.031-0.052-0.063-0.055c0.037-0.037,0.131-0.031,0.146-0.078\r\n\t\t\t\tc-0.024-0.02-0.058-0.024-0.069-0.057c0.023-0.025,0.075-0.06,0.135-0.054c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.033-0.02-0.066-0.041-0.099-0.061c-0.089-0.081,0.158-0.142,0.204-0.197c-0.022,0.004-0.029,0-0.037-0.01\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.002c0,0,0-0.001-0.001-0.002c0.032-0.002,0.069,0.005,0.1-0.008\r\n\t\t\t\tc0.004-0.004,0.008-0.007,0.012-0.011c-0.001-0.024-0.034-0.036-0.057-0.044c-0.007-0.043,0.064-0.091,0.107-0.117\r\n\t\t\t\tc0.015,0.003,0.03,0.006,0.045,0.009c-0.008-0.04-0.016-0.08-0.024-0.12c-0.038,0.015-0.036,0.038-0.061,0.057\r\n\t\t\t\tc-0.04,0.031-0.1,0.067-0.155,0.09c-0.046,0.018-0.166,0.053-0.22,0.054c-0.055,0.001-0.099-0.006-0.169,0.007\r\n\t\t\t\tc-0.086,0.017-0.192,0.071-0.27,0.055c-0.009-0.018-0.019-0.035-0.028-0.053c-0.001,0-0.002,0-0.003,0.001\r\n\t\t\t\tc-0.072,0.055-0.152,0.123-0.2,0.186c-0.031,0.04-0.06,0.078-0.102,0.114c-0.038,0.032-0.043,0.082-0.099,0.107\r\n\t\t\t\tc-0.053,0.023-0.122,0.012-0.178,0.027c-0.003,0-0.006-0.001-0.008-0.002c-0.047-0.023-0.103,0.025-0.159,0.03\r\n\t\t\t\tc-0.014-0.012-0.007-0.021,0.003-0.032c0.022-0.023,0.056-0.047,0.12-0.051c0.022-0.001,0.054-0.002,0.075-0.013\r\n\t\t\t\tc0.068-0.034,0.046-0.111,0.096-0.141c0.031-0.019,0.151-0.057,0.162-0.078c0.014-0.025-0.022-0.049-0.044-0.053\r\n\t\t\t\tc-0.04,0.008-0.037,0.022-0.06,0.033l-0.116,0.034c-0.082,0.034-0.185,0.115-0.294,0.118c-0.015-0.011-0.018-0.03-0.038-0.036\r\n\t\t\t\tc-0.051,0.004-0.131,0.08-0.148,0.105c-0.006,0.001-0.012,0.001-0.018,0.002c-0.003,0-0.005,0-0.008,0\r\n\t\t\t\tc-0.046-0.074,0.259-0.214,0.154-0.309c-0.031-0.028-0.086-0.028-0.126-0.046c0.103-0.026,0.206-0.053,0.309-0.079\r\n\t\t\t\tc0.011-0.005,0.016-0.012,0.017-0.022c0.05-0.019,0.101-0.031,0.138-0.055c0.04-0.026,0.15-0.164,0.158-0.201\r\n\t\t\t\tc0.003-0.016-0.028-0.058-0.042-0.07c-0.016-0.014-0.044-0.019-0.068-0.024c-0.11-0.022-0.111,0.021-0.198,0.048\r\n\t\t\t\tc-0.092,0.028-0.168-0.001-0.196,0.069c-0.047,0.001-0.074-0.025-0.115-0.028c-0.045-0.003-0.093,0.034-0.122,0.047\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0c0,0,0-0.001-0.001-0.002c0.016-0.039,0.101-0.058,0.108-0.097c0.007-0.042-0.147-0.072-0.199-0.067\r\n\t\t\t\tc-0.027,0.007-0.053,0.015-0.08,0.022c-0.065,0.001-0.133-0.039-0.158-0.08c0.031-0.004,0.053,0.006,0.077,0.01\r\n\t\t\t\tc0.032,0.005,0.153,0.002,0.167-0.005c0.121,0.041,0.265,0.068,0.372,0.122c0.097-0.022,0.152-0.08,0.272-0.089\r\n\t\t\t\tc0.1-0.007,0.172,0.031,0.261,0.04c0.04-0.01,0.035-0.031,0.071-0.042c0.056,0.011,0.104,0.041,0.15,0.063\r\n\t\t\t\tc0.024,0.008,0.048,0.017,0.071,0.025c0.016,0.019,0.031,0.037,0.047,0.056c0.021,0.005,0.032-0.001,0.046,0.011\r\n\t\t\t\tc0.015,0.022,0.03,0.044,0.045,0.066c0.042,0.038,0.131,0.059,0.2,0.07c0.101,0.016,0.192,0.009,0.27-0.045\r\n\t\t\t\tc0.017-0.012,0.034-0.02,0.038-0.036c0.013-0.051-0.114-0.086-0.107-0.166c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.014,0.037,0.178,0.137,0.22,0.148c0.022,0.005,0.059,0.007,0.087-0.007c0.02-0.01,0.031-0.026,0.039-0.041\r\n\t\t\t\tc0.037-0.061-0.073-0.08-0.109-0.114c0.003-0.006,0.006-0.013,0.01-0.019c-0.026,0-0.033-0.018-0.043-0.033\r\n\t\t\t\tc-0.013-0.002-0.028,0-0.049,0.004c-0.004-0.04,0.038-0.112-0.07-0.076c0.009-0.016,0.01-0.032,0.012-0.052\r\n\t\t\t\tc-0.015,0.002-0.03,0.005-0.045,0.007c-0.002,0-0.004,0-0.005-0.001c-0.033-0.116-0.015-0.165-0.164-0.203\r\n\t\t\t\tc-0.003,0-0.005,0-0.008,0c-0.019,0.045-0.027,0.105-0.038,0.15c-0.001,0.001-0.003,0.002-0.004,0.003\r\n\t\t\t\tc-0.006-0.003-0.013-0.007-0.019-0.01c-0.004-0.025,0.002-0.056-0.014-0.084c-0.022-0.037-0.043-0.094-0.038-0.131\r\n\t\t\t\tc-0.051,0.012-0.061,0.058-0.095,0.08c-0.009-0.002-0.019-0.003-0.028-0.005c0-0.058-0.017-0.052-0.091-0.052\r\n\t\t\t\tc-0.013-0.02-0.001-0.032-0.007-0.054c-0.005-0.001-0.01-0.003-0.014-0.004c-0.012,0.001-0.02,0.003-0.029,0.007\r\n\t\t\t\tc-0.007-0.003-0.006-0.001-0.01-0.008c-0.053,0.01-0.081,0.001-0.126,0.003c-0.151,0.005-0.169,0.037-0.238-0.051\r\n\t\t\t\tc-0.041-0.009-0.201-0.016-0.26-0.004c-0.013,0.035-0.019,0.069-0.038,0.102c-0.018,0.027-0.037,0.054-0.055,0.08\r\n\t\t\t\tc-0.003,0.002-0.006,0.005-0.008,0.007c-0.027-0.016-0.116-0.06-0.103-0.103c0.009-0.015,0.038-0.018,0.056-0.029\r\n\t\t\t\tc0.021-0.013,0.084-0.093,0.073-0.115c-0.015-0.03-0.082-0.03-0.118-0.039c-0.039-0.01-0.067-0.043-0.116-0.041\r\n\t\t\t\tc-0.046,0.002-0.061,0.033-0.074,0.049c-0.018,0.016-0.035,0.032-0.053,0.048c-0.021,0.029-0.031,0.063-0.043,0.095\r\n\t\t\t\tc-0.007,0.002-0.013,0.004-0.019,0.005c-0.015-0.051-0.072-0.083-0.151-0.068c0,0,0-0.001-0.001-0.001\r\n\t\t\t\tc0.024-0.031,0.103-0.012,0.139-0.034c0.06-0.036,0.077-0.119,0.142-0.155c0.004-0.005,0.009-0.01,0.013-0.016\r\n\t\t\t\tc-0.078-0.016-0.155-0.032-0.243-0.04c-0.032,0.023-0.05,0.013-0.09,0.032c-0.021,0.015-0.043,0.03-0.064,0.045\r\n\t\t\t\tc-0.072,0.047-0.113,0.067-0.106,0.143c-0.023-0.003-0.035-0.007-0.05-0.017c-0.124-0.083,0.099-0.103,0.101-0.159\r\n\t\t\t\tc0.001-0.031-0.064-0.029-0.086-0.038c-0.002,0-0.004,0-0.005-0.001c0,0,0-0.001-0.001-0.002c0.065-0.02,0.17-0.047,0.208-0.018\r\n\t\t\t\tc0.055-0.015,0.091-0.086,0.101-0.119c0.002-0.012,0.004-0.024,0.007-0.036c0.019-0.029,0.096-0.064,0.136-0.084\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.005c-0.051-0.005-0.107-0.018-0.136-0.046c0.06,0.007,0.119,0.006,0.189,0.005\r\n\t\t\t\tc-0.007-0.017-0.02-0.023-0.032-0.034c-0.018-0.066,0.148-0.105,0.248-0.112c0.019-0.003,0.038-0.006,0.058-0.01\r\n\t\t\t\tc0.014,0.001,0.034,0.006,0.062-0.003c0.018-0.006,0.028-0.016,0.039-0.024c0.005,0.031-0.025,0.045-0.053,0.063\r\n\t\t\t\tc-0.039,0.004-0.2-0.007-0.232,0.033c0,0.003,0,0.005,0,0.008c0.038,0.019,0.086,0.056,0.135,0.064\r\n\t\t\t\tc0.063,0.01,0.146-0.01,0.22-0.012c0.032,0,0.063,0,0.095,0c0.05-0.056,0.09-0.128,0.108-0.194\r\n\t\t\t\tc0.015-0.005,0.03-0.001,0.047-0.002c0.036-0.002,0.135-0.04,0.152-0.052c0.047-0.035-0.09-0.189-0.128-0.197\r\n\t\t\t\tc-0.032-0.007-0.07-0.002-0.107-0.004c-0.059-0.004-0.24-0.04-0.269,0.031c0.007,0.018,0.019,0.023,0.032,0.034\r\n\t\t\t\tc0.001,0.002,0.001,0.003,0.002,0.005C21.061,9.85,21.006,9.85,20.952,9.85c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc-0.006-0.034,0.037-0.085,0.002-0.115c-0.013-0.007-0.061,0.002-0.077,0c-0.003-0.017,0.025-0.026,0.044-0.033\r\n\t\t\t\tc0.024-0.05-0.082-0.091-0.112-0.123c0,0,0-0.001-0.001-0.002c0.049,0.003,0.087,0.023,0.143,0.019\r\n\t\t\t\tc0.08-0.005,0.117-0.075,0.219-0.082c0.053-0.003,0.078,0.028,0.129,0.024c0.015-0.006,0.029-0.012,0.044-0.018\r\n\t\t\t\tc0.076-0.037,0.128-0.084,0.117-0.15c-0.006-0.035-0.112-0.077-0.174-0.057c-0.075,0.034-0.15,0.068-0.225,0.101\r\n\t\t\t\tc-0.023,0.015-0.039,0.033-0.066,0.048c0.001-0.026,0.017-0.077,0-0.103c-0.026-0.042-0.069-0.068-0.087-0.113\r\n\t\t\t\tc-0.144,0.026-0.093,0.074-0.143,0.127c-0.101,0.032-0.174-0.025-0.264-0.018c0.036-0.037,0.154-0.006,0.199-0.003\r\n\t\t\t\tc0.004-0.001,0.008-0.001,0.012-0.002c0.006-0.013,0.012-0.027,0.018-0.04c0.021-0.034,0.052-0.065,0.088-0.093\r\n\t\t\t\tc-0.001-0.001-0.003-0.003-0.004-0.004c-0.015-0.008-0.041-0.006-0.061-0.008c-0.037-0.005-0.076-0.012-0.118-0.013\r\n\t\t\t\tc-0.078,0-0.163,0.02-0.217-0.003c0.044-0.008,0.061-0.02,0.074-0.039c-0.012-0.023-0.076-0.028-0.104-0.037\r\n\t\t\t\tc-0.001-0.002-0.001-0.004-0.002-0.006c0.057-0.01,0.172,0.001,0.217,0.01c0.051,0.011,0.098,0.041,0.167,0.033\r\n\t\t\t\tc0.034-0.018,0.074-0.065,0.132-0.048c0.029,0.008,0.042,0.034,0.072,0.043c0.067-0.007,0.093-0.07,0.062-0.117\r\n\t\t\t\tc-0.04-0.061-0.125-0.079-0.182-0.12c-0.022-0.016-0.009-0.05-0.031-0.062c-0.042-0.024-0.124,0-0.196,0.004\r\n\t\t\t\tc-0.024-0.002-0.048-0.003-0.073-0.005c-0.041,0.002-0.072,0.028-0.098,0.039c-0.039,0.016-0.082,0.03-0.131,0.042\r\n\t\t\t\tc0-0.001-0.001-0.002-0.001-0.003c0.069-0.022,0.084-0.061,0.131-0.091c0.041-0.027,0.109-0.044,0.145-0.073\r\n\t\t\t\tc0.016-0.013,0.031-0.04,0.007-0.058c-0.01-0.007-0.041-0.008-0.068-0.013c0.057-0.028,0.115-0.055,0.172-0.083\r\n\t\t\t\tc0.024,0.008,0.048,0.016,0.072,0.024c0.029,0.02,0.058,0.041,0.086,0.062c0.003,0.001,0.006,0.001,0.008,0.002\r\n\t\t\t\tc0.003-0.003,0.005-0.005,0.008-0.008c-0.002-0.029-0.048-0.05-0.072-0.066c-0.018-0.012-0.036-0.025-0.053-0.037\r\n\t\t\t\tC24.16,6.946,27.965,6,32,6c4.818,0,9.316,1.335,13.186,3.62c-0.129,0.065-0.246,0.164-0.324,0.268\r\n\t\t\t\tc-0.047-0.001-0.131-0.022-0.152-0.019c-0.081,0.013-0.199,0.161-0.229,0.229c-0.014,0.013-0.025,0.025-0.039,0.038\r\n\t\t\t\tc0.039,0.028,0.076,0.062,0.103,0.102c-0.099,0.069-0.239,0.035-0.292,0.153c-0.004,0.004-0.008,0.008-0.014,0.013\r\n\t\t\t\tc0.033,0.03,0.064,0.059,0.096,0.089c-0.004,0.027-0.008,0.055-0.014,0.083c-0.383-0.001-0.321,0.111-0.547,0.216v0.006\r\n\t\t\t\tc0.209,0.251,0.238,0.04,0.521,0.089c0.13,0.023,0.227,0.096,0.344,0.121c0.108-0.061,0.16-0.161,0.248-0.241\r\n\t\t\t\tc-0.003-0.025-0.005-0.051-0.007-0.076c-0.034-0.021-0.067-0.042-0.103-0.064c-0.004-0.006-0.008-0.013-0.012-0.019\r\n\t\t\t\tc0.022-0.023,0.047-0.047,0.069-0.07c0.074,0.003,0.112,0.025,0.159,0.051c0.055-0.058,0.136-0.114,0.197-0.165v-0.013\r\n\t\t\t\tc-0.021-0.017-0.043-0.034-0.064-0.051c-0.014-0.017-0.002-0.045,0.006-0.076c0.016-0.013,0.03-0.026,0.044-0.038\r\n\t\t\t\tc0.107,0.001,0.271,0.047,0.356,0.006c0.035-0.028,0.072-0.055,0.107-0.083c0.021-0.023,0.043-0.047,0.063-0.07\r\n\t\t\t\tc-0.028-0.015-0.056-0.03-0.083-0.045c0.009-0.043,0.048-0.077,0.1-0.106c0.829,0.518,1.631,1.072,2.395,1.677\r\n\t\t\t\tc-0.006,0.025-0.012,0.05-0.016,0.075c-0.05,0.083-0.098,0.165-0.146,0.248c-0.135,0.174-0.528,0.182-0.465,0.489\r\n\t\t\t\tc0.054,0.004,0.107,0.008,0.16,0.013c0.135,0.378-0.104,0.29-0.146,0.515c0.07,0.108,0.28,0.064,0.369,0.153\r\n\t\t\t\tc0.029,0.036-0.002,0.112,0.013,0.165c0.035,0.124,0.136,0.168,0.286,0.146c-0.018,0.094-0.113,0.264-0.184,0.311\r\n\t\t\t\tc-0.016,0.013-0.038,0.014-0.07,0.013c-0.378-0.351-0.896-0.546-1.468-0.705c-0.123-0.034-0.46-0.13-0.636-0.089\r\n\t\t\t\tc-0.08,0.019-0.115,0.1-0.184,0.134c-0.002,0.004-0.004,0.008-0.006,0.013c0.061,0.078,0.123,0.157,0.184,0.235\r\n\t\t\t\tc-0.01,0.223-0.119,0.179-0.291,0.203c-0.021,0.033-0.037,0.114-0.052,0.146c-0.095,0.048-0.19-0.018-0.216-0.089\r\n\t\t\t\tc0.029-0.038,0.059-0.076,0.089-0.115c-0.178-0.082-0.286-0.093-0.45,0.032c-0.043,0.034-0.086,0.068-0.128,0.102\r\n\t\t\t\tc-0.1,0.03-0.176-0.034-0.235-0.051c-0.104-0.03-0.279-0.002-0.361,0.032c-0.092,0.037-0.088,0.172-0.172,0.222\r\n\t\t\t\tc-0.028-0.015-0.037-0.02-0.045-0.057c-0.182,0.003-0.223,0.07-0.375,0.019c0-0.05,0.008-0.062,0.025-0.089\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0-0.097,0.017-0.161,0.026-0.235c-0.381-0.002-0.168,0.2-0.42,0.248\r\n\t\t\t\tc-0.006-0.002-0.012-0.004-0.019-0.006c-0.011-0.034-0.021-0.068-0.032-0.102c-0.133,0.055-0.267,0.11-0.399,0.165\r\n\t\t\t\tc-0.226,0.09-0.453,0.187-0.661,0.273c-0.051,0.015-0.102,0.03-0.153,0.045c-0.087,0.07-0.049,0.285-0.14,0.349\r\n\t\t\t\tc-0.057,0.011-0.115,0.021-0.172,0.032c-0.342,0.069-0.428-0.091-0.629-0.248c0.041-0.201,0.281-0.195,0.508-0.203\r\n\t\t\t\tc-0.055-0.114-0.169-0.349-0.305-0.375c-0.098,0.009-0.195,0.017-0.293,0.025c-0.082-0.018-0.133-0.053-0.215-0.032\r\n\t\t\t\tc-0.018,0.148,0.158,0.164,0.12,0.337c-0.051,0.081-0.102,0.161-0.151,0.241c-0.004,0.004-0.01,0.009-0.014,0.013\r\n\t\t\t\tc0.034,0.051,0.079,0.078,0.153,0.089c0.079,0.238,0.028,0.214-0.032,0.407c-0.006,0.036-0.013,0.072-0.02,0.108v0.013\r\n\t\t\t\tc-0.165-0.008-0.334-0.211-0.565-0.184c-0.124,0.261-0.491,0.237-0.661,0.445c0.006,0.173,0.26,0.294,0.141,0.47\r\n\t\t\t\tc-0.034-0.011-0.068-0.021-0.103-0.032c-0.071,0.008-0.14,0.046-0.235,0.019c-0.217-0.062-0.433-0.161-0.604-0.267\r\n\t\t\t\tc-0.104,0-0.1,0.078-0.152,0.127c0.002,0.063,0.125,0.201,0.19,0.229c0.058,0.024,0.138-0.001,0.19,0.006\r\n\t\t\t\tc0.15,0.265-0.1,0.247-0.26,0.21c-0.072-0.016-0.158,0.001-0.211-0.032c-0.029-0.021-0.053-0.077-0.064-0.114\r\n\t\t\t\tc-0.075-0.038-0.206-0.014-0.291-0.057c-0.043-0.022-0.209-0.444-0.217-0.527c0.123-0.036,0.164-0.19,0.07-0.292\r\n\t\t\t\tc-0.066-0.072-0.223-0.087-0.305-0.14c-0.137-0.088-0.245-0.222-0.362-0.33c0.222-0.112,0.253,0.089,0.343,0.14\r\n\t\t\t\tc0.07,0.011,0.141,0.021,0.211,0.032c0.5,0.15,1.305,0.524,1.83,0.127c0.111-0.084,0.24-0.161,0.235-0.343\r\n\t\t\t\tc-0.069-0.069-0.081-0.106-0.076-0.242c-0.091-0.072-0.211-0.158-0.331-0.197c-0.127-0.038-0.254-0.076-0.381-0.115\r\n\t\t\t\tc-0.121-0.102-0.242-0.203-0.361-0.305c-0.068-0.021-0.137-0.042-0.203-0.063c-0.108-0.038-0.217-0.076-0.324-0.114\r\n\t\t\t\tc-0.18-0.013-0.36-0.025-0.54-0.038c-0.03,0.023-0.06,0.047-0.089,0.07c-0.004-0.046-0.008-0.093-0.014-0.14\r\n\t\t\t\tc-0.183-0.035-0.345-0.068-0.35-0.28c-0.061,0.036-0.123,0.072-0.184,0.108c-0.047,0.019-0.104,0.021-0.141,0.044\r\n\t\t\t\tc-0.113-0.074-0.219-0.036-0.369-0.025c-0.065-0.103-0.205-0.127-0.279-0.222c0.236,0.002,0.468,0.029,0.591-0.095\r\n\t\t\t\tc-0.002-0.023-0.005-0.047-0.007-0.07c-0.027-0.017-0.055-0.034-0.082-0.051c-0.065-0.023-0.141,0.003-0.191-0.019\r\n\t\t\t\tc-0.105-0.045-0.177-0.123-0.299-0.159c-0.07,0.062-0.137,0.151-0.152,0.267c-0.039-0.008-0.08-0.017-0.121-0.025\r\n\t\t\t\tc0.041-0.129,0.059-0.18,0.127-0.279c-0.05-0.066-0.162-0.027-0.242-0.013c-0.045,0.144-0.116,0.243-0.248,0.305\r\n\t\t\t\tc-0.004-0.093-0.008-0.187-0.012-0.28c-0.14,0.095-0.322,0.263-0.389,0.426c-0.018-0.002-0.034-0.004-0.051-0.006\r\n\t\t\t\tc-0.001-0.246,0.115-0.269,0.216-0.4c-0.28-0.021-0.326,0.061-0.47,0.203c-0.031,0.023-0.079-0.012-0.121,0.013\r\n\t\t\t\tc-0.073,0.044-0.145,0.185-0.172,0.273c-0.188-0.096-0.28-0.273-0.381,0.083c-0.043-0.036-0.086-0.072-0.127-0.108\r\n\t\t\t\tc-0.006-0.002-0.014-0.004-0.02-0.006c-0.048,0.076-0.089,0.121-0.203,0.134c-0.027,0.103-0.078,0.174-0.152,0.229\r\n\t\t\t\tc0.014-0.069,0.026-0.136,0.051-0.191c-0.004-0.011-0.008-0.021-0.014-0.032c-0.006-0.004-0.013-0.008-0.019-0.013\r\n\t\t\t\tc-0.084,0.046-0.147,0.229-0.197,0.311c-0.135-0.012-0.165-0.08-0.299-0.032c-0.024-0.021-0.051-0.042-0.076-0.063\r\n\t\t\t\tc-0.061,0.246-0.091,0.112-0.216,0.203c-0.066,0.048-0.033,0.116-0.146,0.153c-0.019,0.021-0.037,0.042-0.057,0.063\r\n\t\t\t\tc0.026,0.021,0.051,0.042,0.076,0.064v0.006c-0.036,0.051-0.105,0.052-0.172,0.038c0.011,0.047,0.021,0.093,0.031,0.14\r\n\t\t\t\tc-0.019,0.028-0.037,0.055-0.057,0.083c-0.006,0.004-0.013,0.009-0.019,0.013c-0.046-0.028-0.063-0.041-0.089-0.089h-0.006\r\n\t\t\t\tc-0.065,0.006-0.07,0.078-0.133,0.102c-0.01,0.027,0.014,0.055,0.043,0.076v0.038c-0.054,0.016-0.076,0.025-0.102,0.07\r\n\t\t\t\tc-0.041-0.01-0.074-0.026-0.127-0.032c-0.044,0.035-0.058,0.078-0.121,0.095c0.011,0.038,0.019,0.052,0.057,0.064\r\n\t\t\t\tc-0.034,0.075-0.199,0.095-0.273,0.134c-0.006,0.004-0.013,0.008-0.019,0.013c0.021,0.036,0.042,0.072,0.064,0.108v0.006\r\n\t\t\t\tc-0.065,0.004-0.112,0.01-0.178,0.006c-0.021,0.034-0.042,0.068-0.063,0.102c0.042,0.051,0.093,0.07,0.127,0.134v0.006\r\n\t\t\t\tc-0.042,0.006-0.085,0.013-0.127,0.019c-0.006,0.042-0.013,0.085-0.019,0.127c-0.163-0.038-0.167,0.098-0.229,0.21\r\n\t\t\t\tc0.021,0.006,0.042,0.013,0.064,0.019c0.002,0.044,0.004,0.089,0.006,0.133c-0.05,0.003-0.081,0.005-0.121-0.006\r\n\t\t\t\tc-0.075,0.075-0.123,0.164-0.203,0.235c0.006,0.019,0.013,0.038,0.019,0.057v0.006c-0.063,0.046-0.087,0.015-0.159,0\r\n\t\t\t\tc-0.094,0.045-0.266,0.185-0.311,0.28c-0.006,0.034-0.013,0.068-0.019,0.102c-0.039,0.065-0.125,0.084-0.159,0.165\r\n\t\t\t\tc-0.006,0.004-0.013,0.009-0.019,0.013c-0.019-0.013-0.038-0.026-0.057-0.038c-0.08-0.054-0.225,0.137-0.222,0.242\r\n\t\t\t\tc-0.085-0.036-0.205-0.032-0.337-0.032l-0.032,0.032c0.017,0.072,0.086,0.103,0.159,0.114c-0.063,0.075-0.159,0.014-0.267,0.006\r\n\t\t\t\tc-0.021,0.084-0.011,0.111-0.089,0.14c-0.1-0.04-0.144,0.042-0.248,0.076c-0.002,0.017-0.004,0.034-0.006,0.051\r\n\t\t\t\tc0.025,0.034,0.072,0.048,0.108,0.07v0.025c-0.066,0.004-0.131,0.008-0.197,0.013c-0.025,0.075-0.001,0.151-0.038,0.21\r\n\t\t\t\tc0.034,0.046,0.043,0.085,0.102,0.108c0.002,0.004,0.004,0.008,0.006,0.013c-0.056,0.046-0.091,0.058-0.114,0.14\r\n\t\t\t\tc0.004,0.011,0.008,0.021,0.013,0.032c0.041,0.028,0.07,0.034,0.121,0.013c0.011,0.013,0.021,0.025,0.032,0.038\r\n\t\t\t\tc-0.041,0.034-0.089,0.076-0.127,0.114c0.053,0.078,0.112,0.033,0.222,0.045c-0.007,0.055-0.021,0.092-0.07,0.108\r\n\t\t\t\tc-0.008,0.011-0.017,0.021-0.025,0.032c0.015,0.013,0.03,0.025,0.044,0.038c0.06-0.001,0.086-0.014,0.127-0.032\r\n\t\t\t\tc-0.027,0.037-0.064,0.055-0.127,0.057c0.001,0.016-0.001,0.007,0.006,0.025c-0.032,0.014-0.05,0.004-0.083-0.013v0.038h-0.006\r\n\t\t\t\tc-0.004-0.017-0.008-0.034-0.013-0.051c-0.002-0.004-0.004-0.008-0.006-0.013c-0.025,0.03-0.051,0.059-0.076,0.089\r\n\t\t\t\tc0.008,0.03,0.017,0.059,0.025,0.089c0.011,0.006,0.021,0.013,0.032,0.019c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032c0.051-0.002,0.06-0.014,0.095-0.026c-0.002-0.025-0.004-0.051-0.006-0.076\r\n\t\t\t\tc0.025,0.019,0.035,0.027,0.038,0.07h0.006c0.028-0.025,0.055-0.051,0.083-0.076c-0.018,0.039-0.04,0.052-0.064,0.083\r\n\t\t\t\tc0.032,0.02,0.042,0.024,0.089,0.019v0.007c-0.038,0.021-0.076,0.042-0.114,0.063c-0.009,0.028-0.004,0.013,0.006,0.045\r\n\t\t\t\tc0.046,0.033,0.031,0.018,0.102,0.013v0.006c-0.036,0.006-0.042,0.012-0.057,0.038c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.036-0.022-0.065-0.056-0.089-0.019c-0.006,0.004-0.013,0.008-0.019,0.013c-0.002-0.019-0.004-0.038-0.006-0.057\r\n\t\t\t\tc-0.017-0.002-0.034-0.004-0.051-0.006c0.015,0.05-0.003,0.072-0.025,0.114c0.019,0.038,0.038,0.076,0.057,0.114\r\n\t\t\t\tc0.123,0.036,0.19,0.086,0.305,0.115c-0.013,0.013-0.026,0.025-0.038,0.038c0.013,0.008,0.025,0.017,0.038,0.025\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.03,0.015,0.042,0.019,0.051,0.057c0.07,0.017,0.282-0.01,0.349-0.044\r\n\t\t\t\tc0.108-0.107,0.244-0.176,0.356-0.28c0.039-0.036,0.039-0.072,0.095-0.095c0.038-0.02,0.087,0.023,0.14-0.013\r\n\t\t\t\tc0.062-0.046,0.08-0.127,0.083-0.222c0.015-0.011,0.03-0.021,0.044-0.032c0.012,0.047,0.011,0.056-0.013,0.089\r\n\t\t\t\tc0.053,0.074,0.056,0.142,0.165,0.095c0.004,0.002,0.008,0.004,0.013,0.006c0.006,0.051-0.02,0.065-0.032,0.114\r\n\t\t\t\tc0.052,0.027,0.057,0.174,0.057,0.248c0.019-0.002,0.038-0.004,0.057-0.007c0.002,0.017,0.004,0.034,0.006,0.051\r\n\t\t\t\tc0.048-0.012,0.047-0.013,0.089,0c0.008,0.048-0.026,0.118-0.044,0.165c0.047,0.06,0.08,0.086,0.076,0.203\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.049,0.164,0.149,0.23,0.242,0.324c-0.004,0.017-0.009,0.034-0.013,0.051\r\n\t\t\t\tc-0.019-0.002-0.038-0.004-0.057-0.006c0.002,0.017,0.004,0.034,0.006,0.051c-0.021,0.011-0.042,0.021-0.064,0.032\r\n\t\t\t\tc0.042,0.083,0.088,0.169,0.159,0.222c-0.016,0.061-0.039,0.075-0.051,0.134c0.151,0.032,0.257-0.029,0.381,0\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.037-0.032,0.005-0.05-0.019-0.089c0.023-0.06,0.036-0.108,0.095-0.133\r\n\t\t\t\tc0.019-0.011,0.012-0.005,0.038,0.006c0.004-0.017,0.009-0.034,0.013-0.051c0.11,0.001,0.175-0.008,0.253-0.025\r\n\t\t\t\tc0.021,0.015,0.043,0.03,0.064,0.045c0.004,0.004,0.008,0.008,0.014,0.013c0.059-0.108,0.119-0.216,0.178-0.324\r\n\t\t\t\tc0.002-0.04,0.004-0.08,0.006-0.121c0.011-0.057,0.039-0.09,0.057-0.133c0.016-0.027-0.011-0.058,0.006-0.102\r\n\t\t\t\tc-0.015-0.006-0.029-0.013-0.045-0.019V18.53h0.064c0.095-0.071-0.057-0.253-0.07-0.318c0.059-0.002,0.119-0.004,0.178-0.006\r\n\t\t\t\tc0.002-0.013,0.004-0.025,0.006-0.038c0.177,0.031,0.106-0.133,0.191-0.165v0.095c0.002,0.002,0.004,0.004,0.006,0.006\r\n\t\t\t\tc0.02-0.002,0.039-0.004,0.058-0.006c0.014-0.068,0.052-0.091,0.114-0.108c-0.004-0.021-0.008-0.042-0.014-0.064\r\n\t\t\t\tc0.027-0.002,0.055-0.004,0.083-0.006c-0.002-0.011-0.004-0.021-0.006-0.032c-0.002-0.004-0.004-0.008-0.006-0.013h-0.032v0.032\r\n\t\t\t\tc-0.102-0.041-0.174,0.062-0.279,0.045c-0.111-0.019-0.164-0.137-0.3-0.095H32.8c0.009-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.036-0.04,0.304,0.049,0.368,0.083c0.082,0.043,0.287-0.119,0.312-0.153h0.058c-0.002-0.095-0.049-0.099-0.07-0.178\r\n\t\t\t\tc-0.126-0.018-0.206-0.104-0.248-0.203c-0.025,0.002-0.051,0.004-0.076,0.006c-0.038-0.015-0.062-0.043-0.133-0.045\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.046-0.039-0.053-0.296-0.025-0.4c0.023-0.006,0.047-0.013,0.07-0.019\r\n\t\t\t\tc0.055-0.173,0-0.204-0.02-0.356c0.038,0.013,0.076,0.025,0.114,0.038c0.021-0.028,0.042-0.055,0.063-0.083\r\n\t\t\t\tc0.017-0.027-0.004-0.073-0.012-0.115h0.127c0.079-0.112,0.116-0.111,0.221-0.191c0.051-0.038,0.051-0.096,0.115-0.127\r\n\t\t\t\tc0.022,0.015,0.047,0.03,0.069,0.044c0.099-0.068,0.199-0.136,0.299-0.203c0.071-0.087,0.077-0.196,0.185-0.248\r\n\t\t\t\tc0.004-0.006,0.008-0.013,0.013-0.019c-0.034-0.052-0.095-0.08-0.121-0.133c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.053-0.023,0.127-0.081,0.151-0.133c0.023-0.036-0.022-0.072-0.044-0.102c0.077-0.104,0.108-0.037,0.184-0.095\r\n\t\t\t\tc0.092-0.069,0.095-0.193,0.211-0.248c0.051,0.034,0.102,0.068,0.152,0.102c0.022,0.014,0.223-0.034,0.305-0.032\r\n\t\t\t\tc0.078,0.06,0.117,0.113,0.262,0.115c0.011,0.019,0.021,0.038,0.031,0.057c0.015,0.037-0.006,0.12-0.019,0.159\r\n\t\t\t\tc0.017,0.019,0.034,0.038,0.052,0.057c0.013,0.018,0.008,0.038,0.006,0.076c-0.041-0.002-0.082-0.004-0.121-0.006\r\n\t\t\t\tc-0.098,0.028-0.543,0.488-0.61,0.585h-0.032c-0.013-0.019-0.025-0.038-0.037-0.057v-0.013c-0.091,0.094-0.017,0.207-0.16,0.28\r\n\t\t\t\tc-0.059-0.024-0.1-0.032-0.158-0.013c0.004,0.027,0.008,0.055,0.013,0.083c-0.073,0.067-0.121,0.102-0.153,0.216\r\n\t\t\t\tc0.026,0.023,0.063,0.043,0.09,0.064c0,0.094-0.021,0.143-0.032,0.216c0.034,0.053,0.067,0.106,0.102,0.159\r\n\t\t\t\tc-0.008,0.04-0.017,0.08-0.024,0.121c-0.035,0.188-0.012,0.31,0.127,0.381c0.058,0.03,0.07,0.065,0.146,0.038l-0.006,0.076\r\n\t\t\t\tc0.054-0.018,0.094-0.039,0.172-0.038c-0.011,0.023-0.021,0.047-0.032,0.07c0.021,0.042,0.039,0.071,0.084,0.089\r\n\t\t\t\tc0.066,0.051,0.192-0.016,0.234-0.038v0.026c0.064-0.014,0.081-0.027,0.133,0c0.043-0.058,0.077-0.069,0.153-0.095\r\n\t\t\t\tc0.004,0.008,0.008,0.017,0.013,0.025c0.051-0.028,0.141-0.037,0.165-0.095c0.027,0.019,0.056,0.038,0.083,0.057h0.006\r\n\t\t\t\tc0.018-0.083,0.1-0.04,0.152-0.083c0.027-0.017,0.04-0.057,0.045-0.095v0.057c0.036,0.013,0.072,0.025,0.107,0.038\r\n\t\t\t\tc0.026-0.027,0.035-0.043,0.084-0.051c0.021,0.013,0.041,0.025,0.063,0.038c0.06-0.057,0.198-0.098,0.3-0.108\r\n\t\t\t\tc0.008-0.015,0.016-0.03,0.024-0.045c0.028-0.003-0.011,0.079-0.019,0.114c0.147,0.215,0.344-0.041,0.488,0.229\r\n\t\t\t\tc-0.015,0.011-0.029,0.021-0.045,0.032c-0.094-0.003-0.141-0.044-0.222-0.07c-0.076,0.006-0.101,0.066-0.14,0.108\r\n\t\t\t\tc-0.054-0.012-0.054-0.037-0.103-0.025c-0.017,0.027-0.015,0.015-0.006,0.045c-0.031,0.029-0.052,0.003-0.076-0.025\r\n\t\t\t\tc-0.013,0.002-0.024,0.004-0.038,0.006c-0.004,0.015-0.008,0.03-0.013,0.045c0.032,0.038,0.067,0.051,0.063,0.108\r\n\t\t\t\tc-0.008-0.008-0.017-0.017-0.025-0.025c-0.018-0.007-0.057,0.067-0.107,0.064c-0.163-0.011-0.296-0.042-0.451-0.07\r\n\t\t\t\tc-0.078-0.014-0.166,0.024-0.203-0.006c-0.017,0.015-0.033,0.03-0.051,0.044c-0.049-0.011-0.098-0.021-0.146-0.032\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.012,0.045c-0.045-0.007-0.062,0.006-0.103-0.006c-0.085,0.046-0.146,0.095-0.28,0.102\r\n\t\t\t\tc0.006,0.043,0.014,0.056-0.025,0.07c0.023,0.062,0.023,0.099,0.045,0.165c0.021,0,0.035-0.011,0.057-0.026\r\n\t\t\t\tc-0.002,0.057-0.004,0.115-0.006,0.172c0.057,0.016,0.08,0.031,0.121,0.051c0.025-0.023,0.051-0.047,0.076-0.07\r\n\t\t\t\tc0.013,0.009,0.024,0.017,0.037,0.025c-0.021,0.16-0.09,0.268-0.037,0.451c-0.041,0.106-0.223,0.17-0.324,0.076\r\n\t\t\t\tc-0.016-0.04-0.03-0.081-0.044-0.121c-0.048-0.034-0.093-0.068-0.14-0.102v-0.044c-0.113,0.004-0.154,0.056-0.268,0.057\r\n\t\t\t\tc-0.034,0.043-0.068,0.085-0.102,0.127c-0.002,0.044-0.004,0.089-0.006,0.133c-0.033,0.025-0.064,0.051-0.096,0.076\r\n\t\t\t\tc-0.068,0.143,0.034,0.501,0.064,0.578c-0.01,0.025,0,0,0.013,0.025c-0.011,0.002-0.021,0.004-0.032,0.006\r\n\t\t\t\tc0.012,0.035,0.018,0.047,0.014,0.089c-0.082,0.046-0.25,0.013-0.362,0.007c-0.017,0.05-0.021,0.111-0.025,0.165\r\n\t\t\t\tc-0.125,0.066-0.209,0.161-0.388,0.095c-0.01-0.053-0.025-0.086-0.051-0.121c0.005-0.087-0.213-0.034-0.28-0.013\r\n\t\t\t\tc-0.291,0.091-0.499,0.261-0.852,0.286c0.004,0.069,0.012,0.088,0.013,0.146c-0.08-0.028-0.139-0.055-0.21-0.083\r\n\t\t\t\tc-0.004-0.036-0.008-0.072-0.013-0.108c-0.081-0.042-0.175,0.016-0.222-0.121c-0.058-0.004-0.427,0.12-0.458,0.197h-0.07\r\n\t\t\t\tc-0.004-0.013-0.009-0.025-0.013-0.038h-0.006c-0.033,0.022-0.061,0.024-0.095,0.013c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.045-0.038,0.069-0.048,0.102-0.102c-0.006-0.013-0.013-0.025-0.019-0.038c-0.049,0.004-0.097,0.009-0.146,0.013\r\n\t\t\t\tc-0.057-0.013-0.065-0.053-0.121-0.025c-0.014-0.043-0.014-0.04-0.064-0.038c0.059-0.095-0.063-0.185-0.133-0.21\r\n\t\t\t\tc0.013-0.092,0.038-0.176,0.089-0.229c-0.006-0.011-0.013-0.021-0.019-0.032c0.028-0.002,0.055-0.004,0.083-0.006\r\n\t\t\t\tc0.023-0.081,0.102-0.094,0.064-0.191c0.021-0.011,0.042-0.021,0.064-0.032c0.013,0.017,0.025,0.034,0.038,0.051\r\n\t\t\t\tc0.019-0.007,0.038-0.013,0.057-0.019c0.011-0.02,0.068-0.131,0.038-0.159c-0.051-0.002-0.102-0.004-0.153-0.006\r\n\t\t\t\tc-0.032-0.019-0.031-0.102-0.032-0.153c-0.068-0.033-0.163-0.022-0.254-0.019c-0.006,0.053-0.013,0.106-0.019,0.159\r\n\t\t\t\tc-0.013,0.014-0.02,0.015-0.044,0.019c-0.013-0.03-0.025-0.059-0.038-0.089c-0.049,0.026-0.056,0.1-0.095,0.121\r\n\t\t\t\tc-0.035,0.019-0.1-0.034-0.133-0.032c-0.071,0.107,0.012,0.181,0.019,0.286c-0.031,0.04-0.055,0.066-0.076,0.121\r\n\t\t\t\tc0.017,0.008,0.034,0.017,0.051,0.025c0.008-0.011,0.017-0.021,0.025-0.032c0.03,0.025,0.028,0.047,0.083,0.051\r\n\t\t\t\tc0.009,0.061-0.008,0.193,0.006,0.242c0.015,0.052,0.078,0.085,0.095,0.146c-0.028,0.028-0.059,0.044-0.108,0.051\r\n\t\t\t\tc0.012,0.043,0.042,0.03,0.095,0.025c-0.011,0.017-0.017,0.019-0.032,0.032c0.015,0.015,0.03,0.03,0.045,0.044\r\n\t\t\t\tc-0.011,0.008-0.021,0.017-0.032,0.025c0.002,0.011,0.004,0.021,0.006,0.032c0.023,0.011,0.047,0.021,0.07,0.032\r\n\t\t\t\tc-0.046,0.024-0.104,0.005-0.159,0c-0.019,0.061-0.035,0.076-0.006,0.133c-0.032-0.011-0.063-0.021-0.095-0.032\r\n\t\t\t\tc0.008,0.019,0.017,0.038,0.025,0.057c-0.006,0.008-0.013,0.017-0.019,0.025c-0.006,0.002-0.013,0.004-0.019,0.006\r\n\t\t\t\tc-0.006-0.004-0.013-0.008-0.019-0.013c-0.005-0.039-0.011-0.061-0.025-0.108c-0.107-0.001-0.208,0.008-0.28,0.038\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.008,0.049,0.031,0.043,0.057,0.07c-0.002,0.006-0.004,0.013-0.006,0.019h-0.025\r\n\t\t\t\tc-0.023-0.022-0.063-0.046-0.076-0.076c-0.123-0.051-0.317,0.05-0.413,0.083c-0.013,0.055-0.013,0.076-0.013,0.146\r\n\t\t\t\tc0.027,0.002,0.055,0.004,0.083,0.006c-0.015,0.024-0.023,0.03-0.025,0.07c0.024,0.016,0.034,0.024,0.076,0.026\r\n\t\t\t\tc-0.013,0.071-0.047,0.063-0.076,0.108c-0.051,0.033-0.092-0.002-0.165-0.013c0.015-0.036,0.015-0.051,0.013-0.108\r\n\t\t\t\tc0.026,0.002,0.019,0.001,0.044-0.006c0.006-0.013,0.013-0.025,0.019-0.038c-0.018-0.035-0.039-0.055-0.07-0.076\r\n\t\t\t\tc-0.032,0.008-0.064,0.017-0.095,0.026c-0.038,0.095-0.076,0.191-0.114,0.286c-0.074,0.064-0.148,0.127-0.222,0.191\r\n\t\t\t\tc0.032,0.014,0.055,0.038,0.07,0.07c-0.053,0.064-0.14-0.005-0.216,0.025c-0.055,0.036-0.11,0.072-0.165,0.108\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.007c-0.047,0.023-0.093,0.047-0.14,0.07c-0.038,0.119,0.011,0.258-0.089,0.324\r\n\t\t\t\tc-0.114,0.075-0.266,0.05-0.349,0.153c-0.002,0.013-0.004,0.025-0.006,0.038c0.021,0.006,0.042,0.013,0.064,0.019\r\n\t\t\t\tc-0.12,0.118-0.282-0.026-0.426,0.044c-0.023-0.044-0.033-0.075-0.025-0.14c-0.075,0.012-0.121,0.009-0.203,0\r\n\t\t\t\tc0.011,0.077,0.049,0.161,0.108,0.191c-0.002,0.083-0.013,0.145,0.025,0.197c-0.024,0.019-0.065,0.026-0.108,0.025V22.17\r\n\t\t\t\tc-0.055,0.027-0.204,0.061-0.273,0.057c-0.028-0.036-0.055-0.072-0.083-0.108c-0.045,0.004-0.089,0.008-0.133,0.013\r\n\t\t\t\tc-0.006,0.015-0.013,0.03-0.019,0.044c-0.024,0.015-0.108,0.007-0.108,0.007c-0.004-0.004-0.009-0.009-0.013-0.013\r\n\t\t\t\tc-0.076,0.006-0.132,0.063-0.222,0.063c-0.002,0.028-0.004,0.055-0.006,0.083c0.038-0.014,0.077-0.021,0.133-0.019\r\n\t\t\t\tc-0.015,0.03-0.018,0.038-0.057,0.045c-0.01,0.017,0.037,0.021,0.057,0.025c0.002,0.009,0.004,0.017,0.006,0.025v0.006\r\n\t\t\t\tc-0.038,0.006-0.076,0.013-0.114,0.019c0.018,0.035,0.065,0.028,0.089,0.057c0.002,0.011,0.004,0.021,0.006,0.032\r\n\t\t\t\tc0.154-0.013,0.334,0.029,0.445,0.127c0.028-0.009,0.055-0.017,0.083-0.025c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc-0.011,0.021-0.021,0.043-0.032,0.064c0.036,0.046,0.118,0.075,0.165,0.108c-0.011,0.023-0.021,0.046-0.032,0.07\r\n\t\t\t\tc0.04,0.049,0.08,0.097,0.121,0.146c0.135,0.068,0.112,0,0.184,0.153c-0.021,0.04-0.045,0.073-0.051,0.127\r\n\t\t\t\tc0.051,0.067,0.112,0.106,0.133,0.203c-0.034-0.042-0.068-0.085-0.102-0.127h-0.006c-0.04,0.073-0.053,0.198-0.051,0.305\r\n\t\t\t\tc0.011-0.008,0.021-0.017,0.032-0.025c0.008,0.01,0.017,0.021,0.025,0.032c-0.017,0.008-0.034,0.017-0.051,0.025\r\n\t\t\t\tc-0.034,0.153-0.066,0.309-0.121,0.426c-0.162,0.027-0.245-0.039-0.375-0.076c-0.077,0.095-0.35,0.058-0.515,0.032\r\n\t\t\t\tc-0.075-0.012-0.339-0.086-0.356-0.083c-0.076,0.017-0.158,0.089-0.267,0.07c-0.137-0.023-0.23-0.099-0.369-0.044\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102h-0.083c-0.104,0.004-0.159,0.031-0.197,0.102c0.002,0.023,0.004,0.047,0.006,0.07\r\n\t\t\t\tc0.094,0.019,0.139,0.07,0.165,0.153c0.008,0.014-0.059,0.211-0.076,0.241c0.095,0.198,0.023,0.738-0.14,0.826\r\n\t\t\t\tc0.005,0.08-0.01,0.143-0.038,0.203c0.015,0.029,0.018,0.027,0.051,0.038c0.039-0.018,0.066-0.029,0.083-0.07\r\n\t\t\t\tc0.006-0.004,0.013-0.009,0.019-0.013c0.009,0.017,0.017,0.034,0.025,0.051c-0.024,0.033-0.05,0.045-0.108,0.045v0.006\r\n\t\t\t\tc0.004,0.017,0.009,0.034,0.013,0.051c0.035,0.008,0.086-0.006,0.121-0.019c0.004,0.004,0.008,0.008,0.013,0.013\r\n\t\t\t\tc-0.011,0.052-0.024,0.115-0.032,0.165c-0.002,0.004-0.004,0.008-0.006,0.013c0.016,0.028,0.041,0.09,0.025,0.152\r\n\t\t\t\tc-0.012,0.047-0.061,0.108-0.044,0.159v0.013c0.057-0.028,0.12-0.061,0.216-0.038c0.03,0.007,0.054,0.035,0.102,0.026\r\n\t\t\t\tc0.044-0.021,0.089-0.042,0.133-0.064c0.148-0.039,0.293,0.081,0.286,0.191c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.017,0.104,0.101,0.213,0.229,0.178c0.011-0.013,0.01-0.013,0.013-0.038h0.006c0.002,0.011,0.004,0.021,0.006,0.032h0.006\r\n\t\t\t\tc0.028-0.117,0.068-0.096,0.178-0.133c0.032-0.028,0.064-0.055,0.095-0.083c0.167,0.002,0.335,0.004,0.502,0.006\r\n\t\t\t\tc0.033-0.011,0.061-0.035,0.114-0.044c0.013,0.011,0.025,0.021,0.038,0.032c0.076-0.056,0.065-0.091,0.114-0.178\r\n\t\t\t\tc0.05-0.088,0.175-0.085,0.292-0.108c0.01-0.028-0.012-0.031-0.006-0.064c0.026-0.154,0.176-0.261,0.299-0.324v-0.019\r\n\t\t\t\tc-0.032-0.017-0.064-0.034-0.095-0.051c-0.023-0.053-0.047-0.106-0.07-0.159c0.031-0.147,0.225-0.389,0.356-0.438\r\n\t\t\t\tc0.002-0.004,0.004-0.009,0.006-0.013c-0.016-0.018-0.023-0.016-0.032-0.044c0.086-0.149,0.264-0.073,0.394-0.159\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.074-0.067,0.212-0.068,0.273-0.146c0.075-0.198-0.151-0.33,0.102-0.508\r\n\t\t\t\tc0.16-0.113,0.187,0.005,0.33,0.006c0.036,0,0.081-0.033,0.133-0.013c0.074,0.029,0.117,0.137,0.242,0.115\r\n\t\t\t\tc0.24-0.044,0.308-0.187,0.47-0.292c0.047-0.013,0.093-0.026,0.14-0.038c0.025-0.028,0.051-0.055,0.076-0.083\r\n\t\t\t\tc0.129-0.101,0.256-0.104,0.426-0.019c0.221,0.111,0.209,0.479,0.419,0.61c0.184,0.115,0.33,0.293,0.502,0.381\r\n\t\t\t\tc0.155,0.08,0.306,0.025,0.343,0.229c0.03-0.008,0.059-0.017,0.089-0.025H32.2c0.013,0.015,0.025,0.03,0.038,0.044\r\n\t\t\t\tc-0.011,0.004-0.021,0.009-0.032,0.013c-0.004,0.008-0.009,0.017-0.013,0.025c0.038-0.011,0.076-0.021,0.114-0.032\r\n\t\t\t\tc0.021,0.019,0.042,0.038,0.064,0.057c0.009,0.041,0.003,0.066-0.013,0.095c0.045,0.027,0.089,0.055,0.133,0.083\r\n\t\t\t\tc0.022,0.012,0.038-0.004,0.069-0.019c0.034,0.01,0.182,0.419,0.172,0.451v0.013c-0.022-0.002-0.047-0.004-0.069-0.006\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.02,0.067,0.004,0.11-0.064,0.14v0.076c0.014,0.009,0.025,0.017,0.039,0.025h0.082\r\n\t\t\t\tc0.039-0.064,0.067-0.14,0.146-0.165c0.016-0.034,0.005-0.062,0-0.108c0.045-0.043,0.062-0.067,0.159-0.064\r\n\t\t\t\tc0.011-0.013,0.021-0.026,0.032-0.038c-0.026-0.042-0.026-0.089-0.006-0.134c-0.062-0.034-0.123-0.068-0.185-0.102\r\n\t\t\t\tc0.002-0.111,0.086-0.282,0.197-0.267c-0.007,0.095,0.142,0.064,0.202,0.108c0.031,0.023,0.007,0.04,0.025,0.076\r\n\t\t\t\tc0.036,0.023,0.072,0.047,0.108,0.07c0.015-0.044,0.03-0.089,0.045-0.133c-0.196-0.193-0.437-0.359-0.744-0.438\r\n\t\t\t\tc-0.011-0.013-0.021-0.025-0.032-0.038c0.032-0.027,0.049-0.054,0.096-0.07c-0.002-0.011-0.004-0.021-0.006-0.032\r\n\t\t\t\tc-0.047-0.073-0.328,0.011-0.414-0.076c-0.08-0.081-0.209-0.198-0.254-0.305c-0.028-0.067-0.023-0.157-0.064-0.21\r\n\t\t\t\tc-0.031-0.04-0.088-0.05-0.133-0.076c-0.15-0.087-0.231-0.143-0.273-0.343c0.027-0.031,0.056-0.043,0.076-0.083\r\n\t\t\t\tc-0.031-0.037-0.057-0.035-0.057-0.108c-0.015-0.002-0.03-0.004-0.044-0.006c0.008-0.021,0.017-0.042,0.025-0.064\r\n\t\t\t\tc0.044-0.029,0.154-0.064,0.248-0.07c0.002-0.017,0.004-0.034,0.006-0.051c0.08,0.003,0.086,0.005,0.159,0\r\n\t\t\t\tc0.011,0.017,0.021,0.034,0.032,0.051c-0.019,0.025-0.035,0.035-0.076,0.038c0.021,0.098,0.071,0.175,0.102,0.254\r\n\t\t\t\tc0.033-0.017,0.055-0.041,0.083-0.064c0.017-0.047,0.034-0.093,0.051-0.14c0.256,0.103,0.086,0.31,0.343,0.388\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.006v0.006c0.075,0.108,0.184,0.165,0.266,0.267c0.025,0.026,0.06-0.025,0.109-0.013\r\n\t\t\t\tc0.006,0.001,0.152,0.061,0.164,0.07c0.049,0.035,0.09,0.097,0.141,0.133c0.133,0.095,0.271,0.155,0.406,0.248\r\n\t\t\t\tc0.03,0.036,0.06,0.072,0.09,0.108c0.041,0.021,0.084,0.042,0.127,0.064c0.002,0.051,0.002,0.06-0.039,0.07\r\n\t\t\t\tc-0.006,0.043,0.017,0.226,0.014,0.235c-0.018,0.032-0.034,0.064-0.051,0.095c0.021,0.032,0.037,0.045,0.037,0.102\r\n\t\t\t\tc-0.01-0.002-0.021-0.004-0.031-0.006c0.027,0.077,0.145,0.098,0.191,0.159c0.006,0.03,0.013,0.059,0.019,0.089\r\n\t\t\t\tc0.04,0.101,0.153,0.191,0.28,0.172c0.008,0.008,0.017,0.017,0.024,0.025v0.013c-0.026,0.034-0.065,0.029-0.108,0.038v0.006\r\n\t\t\t\tc0.037,0.055,0.072,0.11,0.108,0.165c0.103-0.009,0.228-0.061,0.349-0.025c0.078,0.022,0.119,0.081,0.224,0.089v0.006\r\n\t\t\t\tc-0.101,0.134-0.204-0.021-0.324-0.038c-0.039-0.005-0.082,0.035-0.159,0.032c-0.021,0.038-0.041,0.076-0.063,0.114\r\n\t\t\t\tc0.038,0.047,0.075,0.093,0.114,0.14c0.014,0.044-0.017,0.099-0.014,0.146c0.02,0.017,0.038,0.034,0.057,0.051\r\n\t\t\t\tc0.02-0.015,0.039-0.03,0.058-0.044c0.045-0.022,0.097,0.086,0.108,0.14c0.004,0.002,0.009,0.004,0.013,0.007\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.056-0.027,0.09-0.001,0.14,0.025c-0.005-0.136-0.056-0.195-0.095-0.292v-0.032\r\n\t\t\t\tc0.033,0.011,0.068,0.021,0.102,0.032h0.014c-0.006,0.013-0.014,0.025-0.02,0.038c0.018,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.02-0.035,0.029-0.044,0.083-0.045c-0.022-0.029-0.028-0.02-0.024-0.064c-0.021,0.004-0.043,0.009-0.064,0.013\r\n\t\t\t\tc-0.021-0.048-0.025-0.074-0.057-0.108c0.047-0.015,0.093-0.03,0.14-0.044c0.05,0.006,0.106,0.078,0.121,0.121\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.014-0.011,0.025-0.021,0.039-0.032c-0.014-0.04-0.025-0.081-0.039-0.121\r\n\t\t\t\tc0.008-0.002,0.018-0.004,0.025-0.006c-0.005-0.06-0.342-0.233-0.419-0.248v-0.006c0.044-0.01,0.071-0.023,0.103-0.044\r\n\t\t\t\tc-0.014-0.03-0.026-0.059-0.039-0.089v-0.007c0.031-0.019,0.043-0.017,0.084-0.006c0.014,0.026,0.015,0.037,0.013,0.07h0.006\r\n\t\t\t\tc0.006-0.002,0.013-0.004,0.019-0.006c0.008-0.011,0.018-0.021,0.025-0.032c-0.079-0.096-0.169-0.193-0.223-0.311\r\n\t\t\t\tc0.003-0.047,0.016-0.064,0.039-0.089c-0.012-0.013-0.021-0.025-0.032-0.038c0.034-0.015,0.06-0.023,0.075-0.057\r\n\t\t\t\tc0.009,0.002,0.018,0.004,0.025,0.006c0.002,0.009,0.004,0.017,0.006,0.025c-0.011,0.007-0.021,0.013-0.031,0.019\r\n\t\t\t\tc0.039,0.08,0.139,0.069,0.146,0.184c0.032,0.004,0.063,0.008,0.095,0.013h0.014c-0.035-0.042-0.079-0.056-0.108-0.108v-0.006\r\n\t\t\t\tc0.076,0.003,0.119,0.051,0.146,0.102c0.016-0.002,0.031-0.004,0.045-0.006c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.023-0.041-0.061-0.046-0.083-0.089c0.011-0.008,0.021-0.017,0.032-0.026c0.037,0.007,0.066,0.015,0.082,0.045\r\n\t\t\t\tc0.018,0.015,0.035,0.03,0.052,0.045c0.006-0.004,0.013-0.009,0.019-0.013v-0.006c-0.062-0.077-0.15-0.094-0.19-0.197v-0.006\r\n\t\t\t\tc0.134-0.026,0.108,0.02,0.21-0.07c0.039,0.003,0.033,0.001,0.044,0.032c0.079,0,0.103-0.025,0.153-0.051\r\n\t\t\t\tc0.043,0.102,0.271-0.012,0.285,0.121c0.008-0.009,0.018-0.017,0.025-0.025c0.034,0.021,0.105,0.031,0.146,0.044\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.032,0.019-0.064,0.038-0.096,0.057c-0.008,0.032-0.017,0.064-0.024,0.095\r\n\t\t\t\tc0.065-0.021,0.091-0.085,0.14-0.121c0.061-0.028,0.123-0.055,0.184-0.083c0.016-0.03,0.03-0.059,0.045-0.089\r\n\t\t\t\tc0.037-0.022,0.1,0.002,0.152-0.019c0.137-0.054,0.112,0.009,0.273,0.013c0.025-0.03,0.045-0.056,0.062-0.095\r\n\t\t\t\tc-0.045-0.06-0.142-0.051-0.209-0.089c-0.088-0.049-0.179-0.313-0.268-0.299v-0.051c0.035-0.035,0.047-0.056,0.102-0.076\r\n\t\t\t\tc0.016-0.084,0.038-0.153,0.051-0.222c0.025-0.013,0.108-0.018,0.121-0.038c0.004-0.04,0.008-0.08,0.014-0.121\r\n\t\t\t\tc0.035-0.199,0.06-0.377,0.285-0.388c0.023-0.049,0.047-0.097,0.07-0.146c-0.015-0.031-0.033-0.038-0.051-0.064\r\n\t\t\t\tc-0.031-0.104,0.094-0.097,0.152-0.133c0.199-0.119,0.104-0.321,0.51-0.311c0.008-0.015,0.018-0.03,0.025-0.045\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.021,0.025,0.042,0.051,0.063,0.076v0.013c-0.022,0.021-0.047,0.042-0.069,0.064v0.013\r\n\t\t\t\tc0.097,0.133,0.265,0.085,0.458,0.089c0.013,0.025,0.025,0.051,0.038,0.076c-0.067,0.074-0.25,0.106-0.331,0.184\r\n\t\t\t\tc0.004,0.008,0.009,0.017,0.013,0.025c0.2,0.038,0.367,0.002,0.254,0.267V23.7c0.285,0.052,0.158-0.026,0.337-0.089\r\n\t\t\t\tc0.051-0.004,0.103-0.009,0.153-0.013c0.034-0.028,0.067-0.055,0.103-0.083c0.06-0.018,0.088,0.017,0.133,0.025\r\n\t\t\t\tc0.037-0.006,0.076-0.013,0.113-0.019c0.023-0.032,0.053-0.072,0.064-0.114c-0.064-0.008-0.127-0.017-0.191-0.025\r\n\t\t\t\tc-0.072,0.007-0.141,0.064-0.234,0.038c-0.024-0.123-0.199-0.258-0.338-0.299c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.104-0.029,0.197-0.016,0.306-0.019c0.036-0.039,0.065-0.066,0.083-0.127c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc0.015,0.013,0.03,0.025,0.044,0.038c0.021,0.013,0.02,0.008,0.045,0c0.051-0.015,0.061-0.049,0.102-0.063\r\n\t\t\t\tc0.125-0.023,0.25-0.047,0.375-0.07c0.023-0.025,0.048-0.051,0.07-0.076c0.074-0.008,0.148-0.017,0.223-0.025\r\n\t\t\t\tc0.013-0.013,0.007-0.002,0.013-0.025c0.093-0.017,0.187-0.034,0.28-0.051c0.011,0.021,0.021,0.042,0.031,0.064\r\n\t\t\t\tc-0.099,0.079-0.25,0.146-0.412,0.152c-0.008,0.011-0.018,0.021-0.026,0.032c0.073,0.053,0.147,0.098,0.196,0.178\r\n\t\t\t\tc-0.033,0.026-0.076,0.034-0.139,0.032c-0.029,0.081-0.084,0.13-0.09,0.229c-0.049,0.026-0.154,0.037-0.21,0.051\r\n\t\t\t\tc0.044,0.059,0.104,0.147,0.159,0.197c0.043,0.008,0.057-0.002,0.089-0.019c0.041,0.027,0.058,0.069,0.095,0.095\r\n\t\t\t\tc0.045,0.013,0.09,0.025,0.133,0.038c0.105,0.049,0.192,0.14,0.281,0.21c0.047,0.038,0.115,0.138,0.178,0.133\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.014,0.057c0.102,0.075,0.311,0.102,0.381,0.21c0.016,0.053,0.03,0.106,0.045,0.159\r\n\t\t\t\tc0.08,0.289-0.088,0.388-0.324,0.445c-0.131,0.031-0.221-0.051-0.336-0.032c-0.053,0.017-0.106,0.034-0.159,0.051\r\n\t\t\t\tc-0.099,0.022-0.277-0.021-0.382-0.038c-0.125-0.021-0.15-0.13-0.291-0.076c-0.078-0.037-0.078-0.076-0.121-0.146\r\n\t\t\t\tc-0.029-0.021-0.103,0.03-0.172,0.013c-0.084-0.021-0.076-0.089-0.121-0.146c-0.174,0.111-0.323-0.021-0.541,0.032\r\n\t\t\t\tc-0.195,0.047-0.34,0.172-0.514,0.229c0.002,0.017,0.004,0.034,0.006,0.051c-0.139,0.074-0.203,0.007-0.318-0.013\r\n\t\t\t\tc-0.02,0.006-0.038,0.013-0.057,0.019c-0.094-0.008-0.187-0.017-0.28-0.025c-0.013,0.025-0.025,0.051-0.038,0.076\r\n\t\t\t\tc0.029,0.031,0.068,0.042,0.083,0.089c0.053-0.002,0.106-0.004,0.159-0.006v0.006c-0.072,0.023-0.189,0.032-0.28,0.032\r\n\t\t\t\tc-0.017,0.023-0.026,0.025-0.026,0.051c0.026,0.006,0.051,0.013,0.076,0.019c0.006,0.004,0.014,0.009,0.02,0.013\r\n\t\t\t\tc-0.006,0.008-0.014,0.017-0.02,0.025c-0.113-0.018-0.214-0.013-0.337-0.006c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.036-0.015-0.055-0.014-0.09-0.007c-0.002,0.004-0.004,0.009-0.006,0.013c0.014,0.006,0.026,0.013,0.039,0.019v0.019\r\n\t\t\t\tc-0.067,0.022-0.143,0.01-0.16-0.044c-0.09,0.011-0.202,0.041-0.254,0.095c-0.035,0.037,0.004,0.057-0.069,0.064\r\n\t\t\t\tc-0.011,0.071-0.028,0.13-0.032,0.191c0.087-0.013,0.174-0.025,0.262-0.038v0.006c-0.016,0.024-0.031,0.039-0.058,0.051\r\n\t\t\t\tc-0.015,0.017-0.03,0.034-0.045,0.051c0.035,0.006,0.049,0.02,0.063,0.045c0.015,0.023-0.006,0.02-0.013,0.064h0.058\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.025c-0.021,0.025-0.052,0.036-0.089,0.045c-0.008,0.025,0.01,0.054,0.038,0.076\r\n\t\t\t\tc0.034,0.045,0.026,0.031-0.019,0.063c-0.033-0.003-0.056-0.025-0.09-0.044c-0.011,0.023-0.021,0.047-0.031,0.07v0.045\r\n\t\t\t\tc0.104,0.013,0.133,0.046,0.221,0.07c0.004,0.06-0.021,0.124,0.007,0.165c0.034,0.021,0.067,0.042,0.103,0.064\r\n\t\t\t\tc0.002,0.008,0.004,0.017,0.006,0.025c-0.028,0.011-0.056,0.021-0.084,0.032c0.006,0.013,0.014,0.025,0.02,0.038\r\n\t\t\t\tc0.068,0.006,0.136,0.013,0.203,0.019c0.002,0.004,0.004,0.008,0.006,0.013c-0.018,0.019-0.023,0.019-0.032,0.051\r\n\t\t\t\tc0.007,0.015,0.013,0.03,0.019,0.045c0.004,0.002,0.01,0.004,0.014,0.006c0.021-0.021,0.042-0.042,0.064-0.063\r\n\t\t\t\tc0.084-0.003,0.086,0.023,0.146,0.051c0.028,0.014,0.049-0.015,0.076-0.038c0.024,0.059,0.051,0.119,0.075,0.178\r\n\t\t\t\tc0.1,0.031,0.23-0.025,0.3,0.019c0.013-0.002,0.026-0.004,0.038-0.006c0.015-0.072,0.029-0.144,0.044-0.216\r\n\t\t\t\tc0.142-0.018,0.288,0.018,0.388,0.083c0.073,0.048,0.107,0.143,0.203,0.172c0.136,0.041,0.301-0.026,0.381-0.045\r\n\t\t\t\tc0.042-0.082,0.104-0.102,0.159-0.165c0.138,0.001,0.177,0.055,0.286,0.07c0.037-0.038,0.085-0.067,0.121-0.114h0.025\r\n\t\t\t\tc0.012,0.017,0.024,0.034,0.037,0.051c0.002,0.013,0.004,0.025,0.006,0.038c-0.039,0.043-0.09,0.068-0.127,0.114\r\n\t\t\t\tc0.018,0.03,0.034,0.059,0.051,0.089c-0.011,0.057-0.037,0.107-0.063,0.153c0.087,0.115,0.021,0.195,0.076,0.33\r\n\t\t\t\tc-0.146,0.144-0.206,0.407-0.306,0.578c-0.008,0.042-0.017,0.085-0.024,0.127c-0.041,0.134-0.077,0.258-0.173,0.337\r\n\t\t\t\tc0.074,0.186,0.148,0.373,0.223,0.559c0.012,0.018,0.023,0.014,0.051,0.032c-0.023,0.137-0.084,0.285-0.095,0.407\r\n\t\t\t\tc0.036,0.002,0.071,0.004,0.108,0.006c0.047,0.059,0.093,0.119,0.14,0.178c0.104,0.17,0.188,0.32,0.299,0.477\r\n\t\t\t\tc0.084,0.118,0.206,0.226,0.165,0.413c0.085,0.117,0.223,0.149,0.324,0.248c0.066,0.119,0.131,0.237,0.197,0.356\r\n\t\t\t\tc0.065,0.127-0.002,0.313,0.051,0.457c0.051,0.072,0.102,0.144,0.152,0.216c0.069,0.096,0.225,0.114,0.299,0.203\r\n\t\t\t\tc0.089,0.182,0.178,0.364,0.267,0.546c0.034,0.026,0.067,0.051,0.103,0.076c0.086,0.071,0.194,0.232,0.234,0.344\r\n\t\t\t\tc0.012,0.067,0.021,0.135,0.032,0.202c-0.009,0.039-0.042,0.068-0.032,0.128c0.03,0.172,0.113,0.353,0.165,0.495v0.216\r\n\t\t\t\tc0.095,0.205,0.384,0.166,0.554,0.057c0.057-0.047,0.113-0.092,0.172-0.139c0.094-0.029,0.217,0.012,0.299-0.014\r\n\t\t\t\tc0.128-0.039,0.228-0.133,0.343-0.172c0.078-0.025,0.163,0.016,0.229-0.02c0.068-0.035,0.086-0.123,0.151-0.158\r\n\t\t\t\tc0.238-0.131,0.547-0.129,0.769-0.268c0.062-0.037,0.047-0.087,0.076-0.158c0.029-0.07,0.139-0.143,0.211-0.172\r\n\t\t\t\tc0.121-0.041,0.24-0.082,0.361-0.121c0.07,0.008,0.141,0.017,0.21,0.024c0.024-0.015,0.052-0.03,0.076-0.045\r\n\t\t\t\tc0.045-0.091,0.017-0.205,0.108-0.248c0.096-0.045,0.186,0.021,0.272-0.051c0.032-0.027,0.026-0.071,0.044-0.114\r\n\t\t\t\tc0.049-0.12,0.189-0.153,0.35-0.159c0.008-0.116-0.013-0.304,0.025-0.419c0.057-0.024,0.123,0.021,0.172-0.006\r\n\t\t\t\tc0.057-0.042,0.064-0.147,0.102-0.21c0.043-0.04,0.086-0.08,0.128-0.121c0.059-0.074,0.114-0.154,0.159-0.242\r\n\t\t\t\tc-0.012-0.066-0.116-0.088-0.159-0.127c-0.064-0.08-0.128-0.161-0.191-0.241c-0.048-0.033-0.104,0.008-0.165-0.006\r\n\t\t\t\tc-0.089-0.049-0.178-0.098-0.267-0.146c-0.071-0.049-0.183-0.161-0.21-0.248c-0.021-0.066,0.011-0.151-0.014-0.203\r\n\t\t\t\tc-0.015-0.018-0.023-0.019-0.057-0.019c0.044-0.068,0.068-0.116,0.057-0.229h-0.006c-0.045,0.057-0.089,0.115-0.133,0.172\r\n\t\t\t\tc-0.113,0.09-0.215,0.143-0.311,0.267c-0.023,0.045-0.047,0.089-0.07,0.134c-0.035,0.031-0.051,0.02-0.07,0.07\r\n\t\t\t\tc-0.041,0.011-0.062,0.014-0.095-0.006c-0.002,0.011-0.004,0.021-0.006,0.032c-0.074,0.026-0.394,0.021-0.478-0.019\r\n\t\t\t\tc-0.019,0.017-0.022,0.015-0.031,0.044c-0.073,0.007-0.131-0.005-0.203-0.006c0.013-0.058-0.016-0.063-0.064-0.076\r\n\t\t\t\tc-0.037-0.089,0.072-0.127,0.076-0.216c0.001-0.028-0.018-0.268-0.025-0.28c-0.018-0.025-0.035-0.018-0.051-0.057\r\n\t\t\t\tc-0.015-0.002-0.029-0.004-0.044-0.006c-0.083,0.059-0.118,0.288-0.069,0.407c0.006,0.07,0.01,0.094-0.051,0.089\r\n\t\t\t\tc-0.046-0.059-0.109-0.211-0.115-0.311c-0.033-0.027-0.035-0.039-0.076-0.032c-0.032-0.107-0.057-0.116-0.012-0.229\r\n\t\t\t\tc-0.014-0.021-0.026-0.042-0.039-0.064c0.021-0.031,0.039-0.029,0.045-0.076c-0.062-0.082-0.205-0.072-0.248-0.172\r\n\t\t\t\tc-0.035-0.028-0.025-0.027-0.006-0.064c-0.037-0.017-0.058-0.015-0.113-0.013c-0.07-0.185-0.159-0.356-0.211-0.553\r\n\t\t\t\tc-0.035,0.009-0.071,0.017-0.107,0.026c-0.013-0.006-0.025-0.013-0.038-0.019c0.021-0.026,0.042-0.051,0.063-0.076h0.044\r\n\t\t\t\tc-0.009-0.04-0.017-0.08-0.025-0.121c0.026-0.034,0.169-0.04,0.235-0.038c0.055-0.054,0.047-0.118,0.127-0.152h0.02\r\n\t\t\t\tc-0.002,0.041,0,0.074,0.019,0.095c0.038,0.072,0.165,0.061,0.241,0.032c0.043,0.069,0.144,0.143,0.172,0.21v0.102\r\n\t\t\t\tc0.031,0.082,0.137,0.259,0.191,0.337c0.064,0.091,0.221,0.082,0.312,0.146c0.047,0.057,0.093,0.115,0.14,0.172\r\n\t\t\t\tc0.105,0.063,0.211,0.06,0.337,0.102c0.07,0.023,0.11,0.086,0.197,0.095c0.042-0.036,0.187-0.121,0.196-0.172\r\n\t\t\t\tc0.099-0.035,0.203-0.075,0.324-0.044c0.051,0.012,0.039,0.034,0.09,0.038c0.015,0.043,0.01,0.1,0.031,0.159\r\n\t\t\t\tc0.026,0.069,0.096,0.113,0.096,0.21c0.067,0.011,0.135,0.056,0.184,0.076h0.254c0.025,0.023,0.051,0.047,0.076,0.07\r\n\t\t\t\tc0.143,0.002,0.284,0.004,0.426,0.007c0.075,0.02,0.118,0.067,0.217,0.083c0.131,0.021,0.254-0.027,0.355-0.044h0.286\r\n\t\t\t\tc0.057-0.021,0.1-0.057,0.19-0.07c0.08,0.167,0.549-0.018,0.687-0.025c0.073,0.053,0.075,0.102,0.069,0.223\r\n\t\t\t\tc0.047,0.011,0.094,0.021,0.141,0.032c0.023,0.068,0.047,0.136,0.07,0.203c0.05,0.067,0.113,0.032,0.19,0.076\r\n\t\t\t\tc0.03,0.042,0.06,0.085,0.089,0.127c0.104,0.123,0.381,0.229,0.598,0.153c0.002,0.052-0.021,0.064-0.051,0.095\r\n\t\t\t\tc-0.143,0.145-0.215,0.023-0.369,0.076h-0.014c0.049,0.113,0.434,0.501,0.572,0.508c0.04-0.015,0.081-0.03,0.121-0.044\r\n\t\t\t\tc0.145-0.047,0.383-0.127,0.254-0.299c0.008-0.03,0.018-0.059,0.025-0.089c0.031-0.019,0.082-0.021,0.14-0.019\r\n\t\t\t\tc-0.019,0.072-0.015,0.207,0.013,0.286c0.016,0.046,0.116,0.085,0.102,0.146c-0.014,0.062-0.094,0.113-0.102,0.191\r\n\t\t\t\tc0.027,0.146,0.055,0.292,0.083,0.438c0.034,0.205,0.068,0.411,0.103,0.616c0.07,0.251,0.209,0.444,0.305,0.655\r\n\t\t\t\tc0.064,0.143,0.116,0.299,0.165,0.457c0.021,0.078,0.042,0.156,0.063,0.234c0.039,0.055,0.076,0.11,0.114,0.165\r\n\t\t\t\tc0.074,0.163,0.148,0.326,0.222,0.489c0.033,0.111,0.064,0.225,0.096,0.337c0.059,0.063,0.119,0.127,0.178,0.19\r\n\t\t\t\tc0.09-0.002,0.219-0.063,0.248-0.127c0.025-0.054,0.004-0.105,0.038-0.146c0.083-0.028,0.165-0.056,0.248-0.083\r\n\t\t\t\tc-0.013-0.027-0.034-0.042-0.058-0.057c0.025-0.072,0.052-0.145,0.076-0.217c0.037-0.021,0.108-0.021,0.172-0.019\r\n\t\t\t\tc0.023-0.118-0.033-0.248-0.019-0.362c0.024-0.213,0.286-0.457,0.108-0.654c0.057-0.142-0.035-0.297,0-0.451\r\n\t\t\t\tc0.021-0.047,0.041-0.094,0.063-0.141c0.06-0.048,0.118-0.061,0.19-0.019c0.049-0.031,0.078-0.104,0.096-0.165\r\n\t\t\t\tc0.059-0.032,0.17-0.01,0.229-0.051c0.065-0.045,0.049-0.168,0.108-0.217c0.063-0.031,0.127-0.063,0.19-0.094\r\n\t\t\t\tc0.072-0.046,0.111-0.143,0.179-0.184c0.046-0.028,0.088-0.032,0.127-0.064c0.097-0.119,0.194-0.237,0.292-0.356\r\n\t\t\t\tc0.078-0.054,0.207-0.041,0.292-0.095c0.106-0.067,0.147-0.181,0.229-0.273c-0.014-0.045-0.025-0.089-0.039-0.134\r\n\t\t\t\tc0.072-0.072,0.18-0.083,0.268-0.14c0.032-0.034,0.064-0.068,0.096-0.102c0.028,0.022,0.049,0.059,0.057,0.102\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.037,0.013c0.018-0.03,0.035-0.059,0.052-0.089c0.002-0.004,0.004-0.008,0.006-0.013\r\n\t\t\t\tc0.034,0.02,0.042,0.065,0.051,0.108h0.089c-0.005-0.031-0.002-0.042,0.006-0.07c0.02,0.01,0.039,0.021,0.058,0.032\r\n\t\t\t\tc0.013-0.021,0.024-0.042,0.038-0.063c0.008-0.006,0.017-0.013,0.025-0.019c0.008,0.021,0.016,0.043,0.025,0.064h0.038\r\n\t\t\t\tc0.026-0.034,0.046-0.064,0.051-0.121c0.004-0.002,0.009-0.004,0.013-0.006c0.021,0.038,0.043,0.076,0.063,0.115h0.045\r\n\t\t\t\tc0.017-0.069,0.026-0.078,0.095-0.095c0.022-0.07-0.005-0.129-0.031-0.184c-0.002-0.034-0.004-0.067,0.013-0.083\r\n\t\t\t\tc0.004-0.004,0.009-0.009,0.013-0.013c0.032,0.042,0.064,0.085,0.096,0.127c0.069-0.001,0.1-0.022,0.146-0.044\r\n\t\t\t\tc0.175,0.137,0.122,0.639,0.362,0.705c0.021,0.006,0.054-0.002,0.076,0.006v0.083c0.053,0.035,0.082,0.001,0.127,0.025\r\n\t\t\t\tc0.067,0.037,0.106,0.146,0.133,0.229v0.006c-0.034,0.006-0.068,0.013-0.103,0.019c0.028,0.031,0.065,0.053,0.108,0.07\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.031-0.057c0.004-0.002,0.01-0.004,0.014-0.006c0.079,0.128,0.174,0.362,0.146,0.578\r\n\t\t\t\tc-0.018,0.129-0.099,0.221-0.103,0.361c0.015,0.012,0.03,0.021,0.044,0.033c0.047-0.039,0.073-0.066,0.152-0.076\r\n\t\t\t\tc-0.006,0.024-0.012,0.051-0.019,0.076c0.011,0.011,0.021,0.021,0.032,0.031h0.025c0.029-0.023,0.031-0.041,0.082-0.044v0.058\r\n\t\t\t\tc0.08,0.072,0.095-0.08,0.153-0.121c0.185-0.133,0.273-0.031,0.306-0.344H56.3c0.085,0.062,0.089,0.235,0.197,0.268\r\n\t\t\t\tc0.026,0.18,0.051,0.359,0.075,0.54c0.048,0.163,0.152,0.309,0.203,0.45c0.054,0.145,0.031,0.291,0.025,0.433\r\n\t\t\t\tc0.02,0.01,0.036,0.013,0.07,0.013c-0.033,0.078-0.145,0.34-0.114,0.413c0.017,0.013,0.034,0.025,0.052,0.038\r\n\t\t\t\tc-0.064,0.162-0.162,0.391-0.103,0.566c0.024-0.012,0.051-0.021,0.075-0.032c0.086,0.091,0.166,0.136,0.211,0.272\r\n\t\t\t\tc0.02,0.008,0.033,0.01,0.064,0c0.043,0.058,0.051,0.1,0.051,0.197c0.011,0.006,0.021,0.014,0.031,0.02\r\n\t\t\t\tc0.034,0.043,0.078,0.029,0.121,0.006c0.004,0.004,0.008,0.008,0.014,0.013c-0.019,0.14-0.008,0.3,0.043,0.445\r\n\t\t\t\tc0.025,0.047,0.052,0.093,0.076,0.14c0.01,0.069-0.023,0.131,0.014,0.191c0.039,0.033,0.08,0.068,0.121,0.102\r\n\t\t\t\tc0.016,0.021,0.021,0.057,0.031,0.088C55.357,48.795,44.764,58,32,58z M20.929,9.847c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.002,0.003,0.004,0.006,0.006,0.009c-0.001,0-0.002,0-0.003,0C20.933,9.853,20.931,9.85,20.929,9.847z M43.915,25.038\r\n\t\t\t\tc-0.028,0.012-0.031-0.019-0.069-0.013c-0.035,0.011-0.068,0.021-0.103,0.032c-0.005-0.002-0.009-0.004-0.013-0.006\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.014-0.004-0.026-0.008-0.039-0.013c-0.004,0.017-0.008,0.034-0.013,0.051\r\n\t\t\t\tc-0.048-0.011-0.054-0.013-0.108-0.006c-0.017-0.034-0.033-0.068-0.051-0.102c-0.066,0.075-0.078,0.271-0.043,0.369\r\n\t\t\t\tc0.038,0.021,0.133,0.008,0.215,0.006c-0.015,0.019-0.029,0.038-0.043,0.057c0.004,0.013,0.008,0.025,0.012,0.038\r\n\t\t\t\tc0.015,0.023,0.043,0.036,0.07,0.045v0.019c-0.045-0.004-0.088-0.008-0.133-0.013c-0.011,0.015-0.021,0.03-0.031,0.045v0.044\r\n\t\t\t\tc0.041-0.029,0.065-0.018,0.127-0.006c0.023,0.067,0.084,0.076,0.113,0.133c0.014,0.054-0.037,0.118-0.037,0.203\r\n\t\t\t\tc0,0.04-0.022,0.09-0.02,0.108c0.018,0.102,0.109,0.354,0.025,0.419c-0.062,0.047-0.192,0.025-0.281,0.045\r\n\t\t\t\tc-0.313,0.07-0.747,0.1-0.857-0.197c-0.119-0.032-0.251-0.062-0.35-0.095c-0.053-0.198,0.057-0.392,0.057-0.559\r\n\t\t\t\tc0.006-0.004,0.014-0.008,0.02-0.013c0.017,0.015,0.019,0.017,0.024,0.044c0.007,0.004,0.013,0.008,0.019,0.013\r\n\t\t\t\tc0.007-0.03,0.014-0.059,0.02-0.089c0.02-0.009,0.021-0.011,0.044-0.006c-0.012-0.168,0.011-0.45,0.28-0.337h0.006\r\n\t\t\t\tc-0.002-0.011-0.004-0.021-0.006-0.032c-0.057-0.128-0.189-0.036-0.242-0.108c-0.029-0.042-0.076-0.085-0.095-0.127\r\n\t\t\t\tc-0.023-0.049-0.009-0.096-0.038-0.133c-0.041-0.053-0.105-0.142-0.159-0.184c-0.019-0.006-0.038-0.013-0.058-0.019\r\n\t\t\t\tc-0.049-0.07-0.076-0.16-0.139-0.216c-0.016-0.004-0.031-0.009-0.045-0.013c-0.031-0.047,0.006-0.079-0.044-0.108\r\n\t\t\t\tc-0.057-0.081-0.018-0.217,0.019-0.311v-0.019H41.92c-0.011,0.038-0.021,0.076-0.031,0.114h-0.007\r\n\t\t\t\tc-0.001-0.113-0.014-0.227-0.114-0.286c-0.031-0.019-0.074-0.01-0.088-0.045v-0.032c0.004-0.075,0.082-0.081,0.113-0.127\r\n\t\t\t\tc0.062-0.092,0.092-0.195,0.121-0.286c0.004-0.006,0.008-0.013,0.013-0.019c0.105,0.051,0.2-0.03,0.28-0.076\r\n\t\t\t\tc0.016,0.008,0.029,0.017,0.044,0.025c0.017-0.02,0.021-0.029,0.019-0.07c0.103-0.023,0.135-0.121,0.217-0.153\r\n\t\t\t\tc0.039-0.002,0.08-0.004,0.121-0.006c0.129-0.041,0.242-0.21,0.412-0.197c0.097,0.007,0.138,0.073,0.211,0.089\r\n\t\t\t\tc0.076,0.017,0.097-0.038,0.133-0.051c0.057,0.013,0.113,0.025,0.172,0.038c0.015,0.025,0.029,0.051,0.045,0.076\r\n\t\t\t\tc-0.018,0.017-0.034,0.034-0.051,0.051c0.047,0.164,0.01,0.207-0.084,0.33c0.005,0.058,0.07,0.083,0.115,0.095\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.139-0.013-0.275-0.025-0.414-0.038c-0.037,0.007-0.047,0.027-0.102,0.026\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.037,0.102c-0.029,0.036-0.058,0.02-0.076,0.076c0.026,0.039,0.063,0.068,0.113,0.083\r\n\t\t\t\tc0.006,0.008,0.014,0.017,0.02,0.026c-0.062,0.044-0.215-0.025-0.338-0.019c-0.006,0.006-0.012,0.013-0.019,0.019v0.083\r\n\t\t\t\tc0.039,0.026,0.134,0.043,0.185,0.051c0.027,0.155,0.139,0.203,0.133,0.368h0.089c0.037,0.027,0.071,0.069,0.089,0.114\r\n\t\t\t\tc0.089,0.012,0.165-0.009,0.234,0.064c-0.033,0.064-0.069,0.143-0.094,0.203c0.022,0.038-0.002,0.077,0.019,0.121\r\n\t\t\t\tc0.013,0.006,0.026,0.013,0.038,0.019c-0.002,0.019-0.004,0.038-0.006,0.057c0.013,0.029,0.055,0.079,0.076,0.114v0.013\r\n\t\t\t\tc0.026-0.072,0.01-0.226,0.031-0.305c0.088-0.015,0.174-0.031,0.273-0.025c0.015,0.056,0.023,0.174,0.051,0.216\r\n\t\t\t\tc0.046,0.071,0.146,0.075,0.197,0.178c-0.016,0.031-0.026,0.037-0.057,0.051c-0.041-0.008-0.043-0.024-0.084-0.032\r\n\t\t\t\tC43.898,24.987,43.907,25.012,43.915,25.038z M35.799,24.777c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc-0.024-0.022-0.041-0.037-0.083-0.045c0.004-0.011,0.009-0.021,0.013-0.032c0.017,0.008,0.034,0.017,0.052,0.025\r\n\t\t\t\tC35.788,24.751,35.789,24.757,35.799,24.777z M57.643,35.618c-0.367,0.016-0.324-0.226-0.388-0.502\r\n\t\t\t\tc-0.013,0.004-0.024,0.008-0.038,0.013c-0.056-0.044-0.033-0.145-0.051-0.222c-0.062,0.004-0.119,0.022-0.178,0.013\r\n\t\t\t\tc-0.153-0.249,0.123-0.633,0.191-0.826c-0.005-0.053-0.01-0.105-0.014-0.158c0.02-0.082,0.062-0.115,0.025-0.217\r\n\t\t\t\tc0.092-0.07,0.145-0.061,0.291-0.051c-0.006,0.076-0.012,0.152-0.019,0.229c0.058,0.002,0.08,0.024,0.121,0.033\r\n\t\t\t\tc0.078,0.014,0.106-0.055,0.19-0.007c0.039,0.04,0.076,0.08,0.115,0.121c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc-0.043,0.556-0.11,1.104-0.188,1.649C57.688,35.667,57.663,35.645,57.643,35.618z M8.363,28.628\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.363z M8.35,28.59c-0.001-0.011-0.009-0.009-0.011-0.018\r\n\t\t\t\tc0.001,0.006,0.003,0.012,0.004,0.018H8.35z M42.555,41.414c-0.037-0.059-0.106-0.061-0.14-0.133\r\n\t\t\t\tc-0.067-0.055-0.062-0.042-0.127,0.013c0.009,0.101,0.008,0.235-0.07,0.299c-0.044,0.036-0.079,0.04-0.102,0.103\r\n\t\t\t\tc-0.039-0.014-0.048-0.034-0.063-0.07c-0.019-0.002-0.037-0.004-0.057-0.006c-0.003,0.068,0.016,0.109,0.038,0.165\r\n\t\t\t\tc-0.005,0.011-0.009,0.021-0.013,0.032c-0.024,0.016-0.041,0.024-0.084,0.024c-0.002,0.005-0.004,0.009-0.006,0.013\r\n\t\t\t\tc0.004,0.045,0.026,0.06,0.045,0.103c-0.022,0.024-0.047,0.051-0.069,0.076c-0.039-0.005-0.04-0.009-0.052-0.038H41.85\r\n\t\t\t\tc-0.031,0.027-0.062,0.055-0.095,0.083c0.009,0.034,0.022,0.045,0.038,0.069c-0.014,0.01-0.025,0.018-0.038,0.026\r\n\t\t\t\tc-0.024,0.011-0.026-0.009-0.063-0.019c-0.047,0.029-0.094,0.059-0.141,0.089c0.004,0.024,0.01,0.051,0.014,0.075\r\n\t\t\t\tc-0.071,0.018-0.121-0.053-0.211-0.012c-0.017,0.019-0.033,0.037-0.051,0.057c-0.039,0.02-0.074-0.014-0.107-0.014\r\n\t\t\t\tc-0.025,0.02-0.051,0.039-0.076,0.058c-0.044,0.002-0.09,0.004-0.133,0.006c0,0.213-0.084,0.245-0.141,0.381\r\n\t\t\t\tc-0.025,0.101,0.069,0.325,0.121,0.388c-0.015,0.032-0.029,0.064-0.044,0.096c0.032,0.039,0.063,0.076,0.095,0.115\r\n\t\t\t\tc0.03,0.114-0.166,0.512-0.216,0.559c-0.024,0.009-0.051,0.017-0.075,0.025c-0.045,0.031-0.103,0.232-0.09,0.311\r\n\t\t\t\tc0.053,0.097,0.106,0.195,0.159,0.292c-0.013,0.049-0.024,0.097-0.038,0.146c-0.031,0.145,0.061,0.157,0.083,0.229\r\n\t\t\t\tc0.017,0.051-0.006,0.092,0.019,0.127c0.084,0.119,0.263,0.084,0.344,0.21c0.137-0.008,0.17-0.09,0.285-0.121\r\n\t\t\t\tc0.07-0.009,0.141-0.018,0.211-0.025c0.132-0.082,0.205-0.498,0.261-0.674c0.149-0.486,0.302-0.971,0.451-1.455\r\n\t\t\t\tc0.028-0.096-0.011-0.189,0.019-0.3c0.026-0.093,0.125-0.146,0.146-0.254c-0.047-0.071-0.09-0.157-0.09-0.272\r\n\t\t\t\tc0.012-0.006,0.021-0.014,0.033-0.02c0.004-0.004,0.008-0.009,0.013-0.013c0.028,0.053,0.069,0.133,0.12,0.165\r\n\t\t\t\tc0.035-0.029,0.115-0.123,0.103-0.191c-0.026-0.053-0.055-0.105-0.083-0.158C42.622,41.831,42.634,41.518,42.555,41.414z\r\n\t\t\t\t M10.068,26.772c0.002,0.004,0.003,0.011,0.005,0.016v-0.016H10.068z M8.337,28.565c0,0.001-0.001,0.002-0.001,0.002\r\n\t\t\t\tc0.001,0.003,0.003,0.003,0.003,0.005C8.339,28.57,8.338,28.567,8.337,28.565z M8.356,28.609\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.356z M14.998,24.644c-0.002-0.004-0.004-0.009-0.006-0.013\r\n\t\t\t\tc-0.021-0.006-0.042-0.013-0.064-0.019c-0.026,0.019-0.046,0.037-0.057,0.07c-0.004,0.002-0.009,0.004-0.013,0.006\r\n\t\t\t\tc-0.032-0.041-0.059-0.112-0.076-0.165v-0.007c0.122-0.058,0.118-0.025,0.216-0.114V24.37c-0.015-0.006-0.03-0.013-0.045-0.019\r\n\t\t\t\tc-0.042,0.02-0.082,0.042-0.14,0.045c-0.035-0.024-0.077-0.055-0.095-0.095c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.049-0.04,0.097-0.081,0.146-0.121c0.013-0.015,0.026-0.03,0.038-0.045c-0.085-0.053-0.196-0.098-0.331-0.083\r\n\t\t\t\tc-0.013,0.023-0.025,0.047-0.038,0.07c-0.139,0.028-0.257-0.06-0.343-0.127v-0.019c0.036-0.036,0.072-0.072,0.108-0.108\r\n\t\t\t\tc-0.044-0.017-0.089-0.034-0.133-0.051c-0.111,0.022-0.1,0.134-0.21,0.159c-0.006-0.249,0.344-0.399,0.241-0.604\r\n\t\t\t\tc0.046-0.013,0.102-0.029,0.14-0.045c0.002-0.008,0.004-0.017,0.006-0.025c-0.004-0.011-0.009-0.021-0.013-0.032\r\n\t\t\t\tc-0.013-0.004-0.025-0.008-0.038-0.013c-0.078,0.021-0.157,0.042-0.235,0.064c-0.19,0.122-0.428,0.489-0.508,0.724\r\n\t\t\t\tc0.032,0.038,0.063,0.076,0.095,0.114c-0.085,0.09-0.178,0.003-0.235,0.165c-0.004,0.008-0.008,0.017-0.013,0.025\r\n\t\t\t\tc0.049,0.013,0.098,0.025,0.146,0.038c-0.09,0.09-0.264,0.111-0.324,0.229c-0.016,0.029,0.012,0.075,0.026,0.114\r\n\t\t\t\tc0.097-0.011,0.195-0.021,0.292-0.032c0.121,0.017,0.242,0.034,0.362,0.051c0.11,0.02,0.23-0.003,0.248-0.083\r\n\t\t\t\tc0.034-0.004,0.068-0.008,0.102-0.013v0.096c0.004,0.006,0.008,0.013,0.013,0.019c0.013-0.002,0.025-0.004,0.038-0.006\r\n\t\t\t\tc0.033-0.011,0.042-0.037,0.051-0.07c0.057,0.006,0.114,0.013,0.172,0.019v0.013c-0.121,0.055-0.153,0.168-0.305,0.21\r\n\t\t\t\tc-0.012,0.026-0.007,0.015,0,0.045c0.033,0.016,0.082,0.021,0.133,0.019c0.096-0.105,0.276-0.194,0.343-0.311\r\n\t\t\t\tc0.011,0.004,0.021,0.008,0.032,0.013c0.021,0.028,0.042,0.055,0.064,0.083c-0.002,0.068-0.031,0.109-0.064,0.146\r\n\t\t\t\tc0.002,0.017,0.004,0.034,0.006,0.051c0.017,0.002,0.034,0.004,0.051,0.006c0.025-0.021,0.051-0.042,0.076-0.063\r\n\t\t\t\tc0.004,0.036,0.008,0.072,0.013,0.108c0.053,0.015,0.106,0.03,0.159,0.045c0.031-0.093,0.108-0.194,0.095-0.299\r\n\t\t\t\tC14.985,24.767,14.974,24.733,14.998,24.644z M30.531,24.606c-0.011,0.008-0.021,0.017-0.032,0.025\r\n\t\t\t\tc0.014,0.032,0.014,0.022,0.057,0.019v0.006c-0.011,0.011-0.021,0.021-0.032,0.032c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.021,0.009,0.042,0.017,0.063,0.026c-0.011,0.015-0.021,0.03-0.032,0.044c0.011,0.009,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.019,0.002,0.038,0.004,0.057,0.006v0.032c0.013,0.002,0.025,0.004,0.038,0.006c0.109-0.111,0.08-0.372,0.076-0.559\r\n\t\t\t\tc-0.008-0.006-0.017-0.013-0.025-0.019c-0.004,0.002-0.008,0.004-0.013,0.006c-0.004,0.03-0.008,0.059-0.013,0.089\r\n\t\t\t\tc-0.002,0.003-0.171,0.074-0.21,0.114c0.001,0.025,0.001,0.024,0.019,0.044c-0.009,0.007-0.017,0.013-0.026,0.019\r\n\t\t\t\tC30.493,24.58,30.509,24.579,30.531,24.606z M35.215,27.014c0.143-0.008,0.284-0.017,0.426-0.025\r\n\t\t\t\tc0.018-0.028,0.025-0.06,0.032-0.102c-0.045,0.028-0.097,0.035-0.146,0.064c-0.008-0.004-0.018-0.009-0.025-0.013\r\n\t\t\t\tc0.004-0.017,0.01-0.034,0.014-0.051c-0.002-0.002-0.004-0.004-0.007-0.006c-0.098,0.011-0.135,0.002-0.21-0.032\r\n\t\t\t\tc-0.07,0.006-0.14,0.013-0.21,0.019c-0.021-0.019-0.014-0.025-0.051-0.032c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c-0.015,0.008-0.03,0.017-0.044,0.026c-0.034-0.012-0.057-0.014-0.076-0.038v-0.013\r\n\t\t\t\tc-0.011,0.013-0.01,0.012-0.013,0.038h-0.032c-0.006,0.032-0.013,0.063-0.02,0.095c0.088,0.039,0.261,0.031,0.356,0.07\r\n\t\t\t\tL35.215,27.014L35.215,27.014z M32.367,26.423c0.035-0.028,0.056-0.073,0.095-0.095c0.013-0.037-0.026-0.055-0.045-0.095\r\n\t\t\t\tc-0.036-0.095,0.072-0.224,0.103-0.292v-0.006c-0.059-0.014-0.121,0.013-0.172,0.025c-0.214,0.053-0.3,0.057-0.458-0.044\r\n\t\t\t\tc-0.091,0.081-0.209,0.007-0.254,0.152c0.043,0.085,0.104,0.06,0.191,0.102C32.004,26.254,32.172,26.367,32.367,26.423z\r\n\t\t\t\t M21.217,10.482c0.035-0.019,0.07-0.038,0.105-0.057c0.055-0.019,0.109-0.037,0.164-0.056c0.003-0.008,0.007-0.017,0.01-0.025\r\n\t\t\t\tc-0.104,0.008-0.218,0.043-0.302,0.036c-0.066,0.038-0.132,0.076-0.197,0.114c-0.025,0.014-0.069,0.026-0.071,0.048\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c0.045-0.002,0.096-0.023,0.138-0.036C21.123,10.502,21.17,10.492,21.217,10.482z\r\n\t\t\t\t M16.682,18.341c-0.01,0.031-0.094,0.043-0.109,0.087c0.001,0.002,0.001,0.003,0.002,0.005c0.076-0.011,0.12-0.032,0.157-0.06\r\n\t\t\t\tc0.001-0.015-0.005-0.022-0.016-0.032C16.705,18.339,16.7,18.338,16.682,18.341z M30.575,25.66\r\n\t\t\t\tc0.019-0.025,0.038-0.051,0.057-0.076c0.054-0.026,0.099,0,0.146,0.013c0.02-0.058,0.068-0.112,0.057-0.197\r\n\t\t\t\tc-0.006-0.047-0.013-0.093-0.019-0.14c0.006-0.036,0.036-0.069,0.044-0.095c0.031-0.095-0.097-0.241-0.153-0.26\r\n\t\t\t\tc-0.085,0.08-0.164,0.087-0.311,0.114c-0.004,0.004-0.008,0.008-0.013,0.013c0.017,0.081,0.077,0.106,0.095,0.197\r\n\t\t\t\tC30.517,25.416,30.356,25.615,30.575,25.66z M30.512,36.559c-0.028,0.032-0.044,0.092-0.089,0.108v0.058\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.012c0.082-0.01,0.066-0.094,0.127-0.127C30.57,36.578,30.553,36.568,30.512,36.559z\r\n\t\t\t\t M26.304,19.147c0.035-0.024,0.05-0.049,0.076-0.083c0.002-0.004,0.004-0.009,0.006-0.013c0.025,0.017,0.051,0.034,0.076,0.051\r\n\t\t\t\tc-0.033,0.09-0.136,0.211-0.089,0.305v0.013c0.082-0.047,0.165-0.094,0.235-0.152h0.025c0.006,0.028,0.013,0.055,0.019,0.083\r\n\t\t\t\tc-0.02,0.027-0.04,0.046-0.076,0.057c-0.009,0.057,0.008,0.105,0.051,0.127c0.034,0.062-0.106,0.181-0.121,0.28\r\n\t\t\t\tc0.051,0.013,0.102,0.025,0.153,0.038c0.024-0.018,0.033-0.026,0.038-0.064c0.038,0.011,0.076,0.021,0.114,0.032\r\n\t\t\t\tc0.138-0.008,0.086-0.079,0.267-0.032c-0.045,0.057-0.103,0.092-0.121,0.178c0.025,0.053,0.055,0.069,0.089,0.108\r\n\t\t\t\tc0.036-0.007,0.072-0.013,0.108-0.019h0.006c-0.005,0.156-0.076,0.23-0.013,0.356v0.006c-0.215,0.003-0.415,0.024-0.489,0.172\r\n\t\t\t\tv0.006h0.133v0.013c0.023,0.036,0.008,0.103,0.006,0.159c-0.078,0.113-0.267,0.119-0.299,0.178\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.025,0.021,0.051,0.042,0.076,0.064c0.085,0.002,0.169,0.004,0.254,0.006\r\n\t\t\t\tc0.061,0.03,0.123,0.059,0.184,0.089h0.013c0.09-0.005,0.137-0.049,0.203-0.076c-0.029,0.06-0.086,0.099-0.089,0.172\r\n\t\t\t\tc-0.131,0.033-0.232-0.046-0.343,0.006c-0.036,0.041-0.02,0.083-0.095,0.07c-0.013,0.136-0.232,0.282-0.35,0.318\r\n\t\t\t\tc-0.002,0.004-0.004,0.009-0.006,0.013c0.032,0.009,0.064,0.017,0.095,0.026c0.015,0.015,0.03,0.03,0.045,0.045\r\n\t\t\t\tc0.052-0.069,0.127-0.122,0.216-0.153c0.045,0.021,0.07,0.005,0.095-0.013c0.108,0.059,0.203,0.111,0.21-0.089\r\n\t\t\t\tc0.2-0.024,0.253-0.004,0.439,0.013c-0.004-0.015-0.009-0.03-0.013-0.044c0.085-0.013,0.17-0.025,0.254-0.038\r\n\t\t\t\tc0.048-0.007,0.063,0.026,0.095,0.032c0.042-0.011,0.085-0.021,0.127-0.032c0.061,0.009,0.123,0.017,0.184,0.025\r\n\t\t\t\tc0.074-0.014,0.1-0.073,0.203-0.064c0.004-0.059,0.085-0.077,0.133-0.089V21.17h-0.013c-0.014-0.009-0.237-0.029-0.299-0.032\r\n\t\t\t\tV21.13c0.107-0.031,0.369-0.204,0.4-0.299c-0.006-0.055-0.013-0.11-0.019-0.165c-0.087-0.068-0.271-0.169-0.369-0.032\r\n\t\t\t\tc-0.034-0.007-0.068-0.013-0.102-0.019c0.135-0.201,0.055-0.175-0.076-0.318c-0.002-0.002,0.009-0.153-0.025-0.203\r\n\t\t\t\tc-0.049-0.064-0.097-0.127-0.146-0.191c-0.055-0.03-0.115-0.006-0.153-0.051c-0.069-0.084-0.056-0.196-0.095-0.299\r\n\t\t\t\tc-0.031-0.053-0.237-0.227-0.318-0.222c-0.131,0.007-0.14,0.075-0.305,0.006c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.123,0.003,0.258-0.01,0.311-0.076c0.004-0.002,0.008-0.004,0.013-0.006c-0.034-0.019-0.068-0.038-0.102-0.057\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.198-0.003,0.277-0.285,0.331-0.426c0.013-0.025,0.001-0.021-0.013-0.051\r\n\t\t\t\tc-0.1-0.073-0.46-0.024-0.623-0.025c-0.006-0.009-0.013-0.017-0.019-0.025c0.017-0.197,0.253-0.175,0.324-0.311\r\n\t\t\t\tc0.035-0.032,0.013-0.032-0.006-0.07c-0.129-0.052-0.288,0.077-0.407,0.045c-0.038-0.023-0.076-0.047-0.114-0.07\r\n\t\t\t\tc-0.019,0.025-0.038,0.051-0.057,0.076c0.019,0.03,0.038,0.059,0.057,0.089c-0.04,0.013-0.08,0.025-0.121,0.038\r\n\t\t\t\tc0.025,0.051,0.051,0.102,0.076,0.152c-0.05,0.002-0.083-0.003-0.127-0.019c-0.039,0.01-0.054,0.039-0.07,0.07\r\n\t\t\t\tc0.027,0.032,0.055,0.064,0.083,0.095c-0.019,0.03-0.061,0.028-0.076,0.051c0.009,0.04,0.017,0.08,0.026,0.121\r\n\t\t\t\tc0,0-0.102,0.182-0.114,0.203C26.262,19.126,26.283,19.136,26.304,19.147z M23.552,15.69c0.122,0.059,0.229,0.003,0.261-0.114\r\n\t\t\t\tc0.002-0.025,0.004-0.051,0.006-0.076c0.061-0.015,0.123-0.03,0.184-0.045c0.041-0.073,0.083-0.252,0.019-0.337\r\n\t\t\t\tc-0.041-0.048-0.155-0.016-0.222-0.038c-0.027-0.017-0.055-0.034-0.083-0.051c-0.016-0.036-0.003-0.092,0.013-0.134\r\n\t\t\t\tc-0.008-0.015-0.017-0.03-0.025-0.045c-0.139-0.061-0.251-0.035-0.311-0.172c-0.039-0.024-0.106-0.033-0.172-0.032v0.159\r\n\t\t\t\tc-0.129,0.091-0.311,0.046-0.483,0.025c0.022,0.049,0.05,0.087,0.044,0.146c-0.091-0.002-0.162-0.057-0.191-0.121\r\n\t\t\t\tc-0.062-0.048-0.149-0.012-0.216,0.038c0.011,0.034,0.021,0.068,0.032,0.102v0.007c-0.017,0.006-0.034,0.013-0.051,0.019\r\n\t\t\t\tc-0.074-0.049-0.145-0.122-0.178-0.21h-0.006c-0.017,0.011-0.034,0.021-0.051,0.032c-0.031,0.052-0.008,0.145-0.006,0.229\r\n\t\t\t\tc-0.045,0.048-0.112,0.04-0.172,0.076c-0.032,0.029-0.064,0.059-0.095,0.089c-0.034-0.049-0.068-0.097-0.102-0.146\r\n\t\t\t\tc-0.02-0.043,0.074-0.098,0.057-0.178c-0.035-0.162-0.262-0.199-0.413-0.241c-0.015,0.017-0.03,0.034-0.044,0.051\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.042,0.031,0.085,0.071,0.102,0.127v0.006c-0.138,0.096-0.242-0.171-0.324,0.006\r\n\t\t\t\tc0.025,0.034,0.051,0.068,0.076,0.102c0.006,0.006,0.013,0.013,0.019,0.019c-0.08,0.017-0.198,0.021-0.261,0.051\r\n\t\t\t\tc-0.006,0.028-0.008,0.049,0.006,0.07c0.103,0.167,0.277-0.021,0.451,0.007c0.098,0.015,0.167,0.047,0.241,0.076\r\n\t\t\t\tc0.004,0.021,0.009,0.043,0.013,0.064c-0.006,0.019-0.013,0.038-0.019,0.057c-0.108,0.081-0.481,0.067-0.534,0.165\r\n\t\t\t\tc-0.002,0.006-0.004,0.013-0.006,0.019c0.008,0.013,0.017,0.025,0.025,0.038c0.081,0.034,0.262-0.022,0.349-0.038\r\n\t\t\t\tc0.073,0.086,0.103,0.124,0.254,0.14c-0.088,0.128-0.197,0.136-0.292,0.235c0.102,0.124,0.465,0.012,0.616,0.07\r\n\t\t\t\tc0.049,0.034,0.097,0.068,0.146,0.102c0.079,0.046,0.211,0.06,0.311,0.076c0.267,0.044,0.261-0.127,0.369-0.172\r\n\t\t\t\tc0.102-0.013,0.203-0.025,0.305-0.038C23.322,15.873,23.442,15.767,23.552,15.69z M25.078,20.894\r\n\t\t\t\tc-0.023,0.009-0.047,0.017-0.07,0.026c-0.007,0.033,0.006,0.053,0.013,0.089c0.036-0.004,0.072-0.008,0.108-0.013\r\n\t\t\t\tc0.017,0.048,0.015,0.085,0.013,0.146c0.12-0.007,0.193-0.047,0.273-0.07c0.034-0.002,0.068-0.004,0.102-0.006\r\n\t\t\t\tc0.076-0.055,0.153-0.11,0.229-0.165c0.074-0.007,0.148-0.013,0.222-0.019c0.008-0.013,0.017-0.025,0.025-0.038\r\n\t\t\t\tc0.049-0.002,0.097-0.004,0.146-0.006c0.016-0.107,0.079-0.154,0.102-0.229c0.037-0.123-0.067-0.364-0.121-0.439\r\n\t\t\t\tc0.126-0.037,0.169-0.056,0.229-0.159c-0.018-0.123-0.068-0.218-0.102-0.324c-0.094-0.067-0.283-0.037-0.4,0.013\r\n\t\t\t\tc-0.064-0.001-0.088-0.026-0.102-0.076c-0.149,0.013-0.194,0.075-0.229,0.203c-0.025,0.006-0.051,0.013-0.076,0.019\r\n\t\t\t\tc-0.006,0.009-0.013,0.017-0.019,0.025h0.184c-0.025,0.064-0.066,0.089-0.133,0.108c-0.001,0.021,0.008,0.04,0.019,0.063\r\n\t\t\t\tc-0.128-0.01-0.273-0.013-0.375-0.051c-0.045,0.036-0.065,0.068-0.083,0.134v0.038c0.057-0.015,0.088-0.022,0.127,0.013h0.013\r\n\t\t\t\tc-0.037,0.042-0.05,0.035-0.038,0.102c-0.03,0.006-0.059,0.013-0.089,0.019c0.008,0.009,0.017,0.017,0.025,0.025\r\n\t\t\t\tc-0.013,0.017-0.025,0.034-0.038,0.051c0.051,0.024,0.293,0.068,0.343,0.038c0.006,0.017,0.013,0.034,0.019,0.051\r\n\t\t\t\tc-0.083,0.035-0.129,0.014-0.165,0.095c-0.008,0.022-0.004,0.012,0.013,0.038c-0.013,0.019-0.025,0.038-0.038,0.057\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.047-0.006,0.093-0.013,0.14-0.019c-0.018,0.068-0.092,0.065-0.159,0.076\r\n\t\t\t\tc-0.021,0.026-0.02,0.078-0.044,0.102c-0.032,0.024-0.13,0.015-0.184,0.013c-0.002,0.015-0.004,0.03-0.006,0.044\r\n\t\t\t\tc0.047,0.002,0.093,0.004,0.14,0.006L25.078,20.894L25.078,20.894z M26.336,19.465c-0.008,0.048-0.009,0.074,0,0.121\r\n\t\t\t\tc0.011,0.002,0.021,0.004,0.032,0.006c0.011-0.013,0.021-0.025,0.032-0.038c-0.004-0.034-0.009-0.068-0.013-0.102\r\n\t\t\t\tC26.37,19.456,26.353,19.46,26.336,19.465z M37.611,27.116c0.022-0.013,0.016-0.005,0.019-0.038\r\n\t\t\t\tc0.146-0.004,0.169-0.092,0.292-0.102c-0.015-0.019-0.029-0.038-0.045-0.057c0.053-0.068,0.135-0.101,0.191-0.165\r\n\t\t\t\tc-0.101,0.036-0.199,0.072-0.299,0.108c-0.06-0.006-0.119-0.013-0.179-0.019c0.011,0.023,0.013,0.039,0,0.064\r\n\t\t\t\tc-0.006,0.006-0.171,0.045-0.184,0.045c0.012,0.053,0.028,0.071,0.045,0.114C37.497,27.08,37.576,27.089,37.611,27.116z\r\n\t\t\t\t M8.363,28.654h0.006c-0.002-0.006-0.004-0.013-0.006-0.019V28.654z M14.54,13.788c0.035-0.025,0.102-0.125,0.045-0.175\r\n\t\t\t\tc-0.059,0.063-0.171,0.08-0.068,0.171C14.525,13.786,14.532,13.787,14.54,13.788z M8.375,28.698h0.006\r\n\t\t\t\tc-0.004-0.015-0.008-0.029-0.013-0.044C8.371,28.668,8.373,28.683,8.375,28.698z M8.433,28.838\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.023-0.051-0.047-0.102-0.07-0.153C8.389,28.761,8.414,28.792,8.433,28.838z\r\n\t\t\t\t M21.4,11.563c-0.005,0-0.01,0.001-0.015,0.001c-0.058,0.053-0.117,0.105-0.175,0.158c-0.053,0.024-0.106,0.048-0.158,0.072\r\n\t\t\t\tc-0.038,0.029-0.035,0.1-0.05,0.136c-0.008,0.019-0.056,0.102-0.048,0.112c0.02,0.01,0.135-0.027,0.152-0.034\r\n\t\t\t\tc0.041-0.017,0.077-0.038,0.104-0.06c0.011-0.01,0.021-0.021,0.032-0.031c0.029-0.01,0.059-0.019,0.088-0.029\r\n\t\t\t\tc0.028-0.025,0.056-0.049,0.084-0.074c0.003-0.003,0.007-0.007,0.01-0.01c0.014,0.009,0.038,0.018,0.063,0.008\r\n\t\t\t\tc0.047-0.026,0.042-0.069,0.098-0.095C21.602,11.666,21.437,11.588,21.4,11.563z M21.72,10.584c0.002,0,0.003-0.001,0.005-0.001\r\n\t\t\t\tc-0.005-0.006-0.009-0.013-0.014-0.019c-0.016,0.002-0.032,0.005-0.048,0.007c-0.148-0.003-0.224-0.095-0.411-0.061\r\n\t\t\t\tc-0.054,0.025-0.235,0.062-0.254,0.094c-0.029,0.048,0.077,0.08,0.116,0.089c0.134,0.033,0.307,0.006,0.465,0.018\r\n\t\t\t\tc0.029,0.002,0.079,0.007,0.099,0.019c0.015,0.009,0.022,0.026,0.042,0.03c0.032,0.001,0.089-0.042,0.103-0.056\r\n\t\t\t\tc0.001-0.001,0.003-0.002,0.004-0.003c-0.082-0.021-0.2-0.02-0.258-0.064C21.619,10.62,21.669,10.602,21.72,10.584z\r\n\t\t\t\t M14.242,41.547c0.147,0.036,0.426-0.012,0.508-0.107c0.048-0.057,0.064-0.207,0.095-0.268c-0.057-0.054-0.445-0.061-0.591-0.057\r\n\t\t\t\tC14.175,41.239,14.197,41.443,14.242,41.547z M10.822,34.354c0.015,0.039,0.009,0.092,0.013,0.135\r\n\t\t\t\tc0.086,0.021,0.114-0.016,0.203-0.02c0.117-0.003,0.196,0.036,0.216-0.095c-0.077-0.062-0.285-0.049-0.4-0.051\r\n\t\t\t\tC10.843,34.333,10.833,34.343,10.822,34.354z M12.735,25.375c-0.017-0.011-0.034-0.021-0.051-0.032\r\n\t\t\t\tc-0.011-0.1,0.084-0.092,0.133-0.146c0.043-0.048,0.06-0.154,0.095-0.203c-0.04-0.027-0.081-0.055-0.121-0.083\r\n\t\t\t\tc-0.045,0.101-0.251,0.268-0.216,0.413c0.05,0.208,0.421,0.141,0.47-0.025C12.9,25.097,12.854,25.337,12.735,25.375z\r\n\t\t\t\t M10.93,37.912c-0.004,0.006-0.008,0.013-0.013,0.02c0.044,0.002,0.042,0.01,0.063,0.031c-0.012,0.031-0.012,0.051,0,0.083\r\n\t\t\t\tc-0.034,0.015-0.068,0.03-0.102,0.044c-0.004,0.006-0.009,0.014-0.013,0.02v0.007c0.085,0,0.174-0.005,0.242-0.013\r\n\t\t\t\tc0.02-0.082-0.008-0.158,0.032-0.217v-0.006h-0.038C11.059,37.904,10.99,37.913,10.93,37.912z M10.015,33.979\r\n\t\t\t\tc-0.092-0.017-0.212,0.006-0.261-0.082c-0.045,0.004-0.062,0.022-0.089,0.031c-0.04-0.004-0.081-0.008-0.121-0.013\r\n\t\t\t\tc-0.04,0.009-0.059,0.049-0.127,0.038c-0.109-0.018-0.194-0.057-0.324-0.057C9.066,33.9,9.038,33.904,9.01,33.909\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.026v0.024c0.064,0.033,0.195,0.03,0.229,0.095c0.046,0.078-0.076,0.146,0.095,0.211\r\n\t\t\t\tc0.004,0.006,0.008,0.012,0.013,0.019c-0.128,0.082-0.41,0.036-0.572-0.013c-0.013,0.015-0.025,0.029-0.038,0.045\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.034,0.065,0.099,0.077,0.152,0.121c0.05-0.013,0.053-0.048,0.102-0.058\r\n\t\t\t\tc0.076,0.012,0.153,0.021,0.229,0.032c0.078-0.006,0.157-0.013,0.235-0.019c0.048,0.048,0.109,0.15,0.178,0.172\r\n\t\t\t\tc0.044-0.114,0.093-0.196,0.203-0.248c0.021,0.023,0.042,0.047,0.064,0.07c0.075,0.033,0.112-0.061,0.178-0.076\r\n\t\t\t\tc0.044-0.012,0.074,0.012,0.095,0.019c0.129-0.06,0.183,0.046,0.248,0.083c0.039-0.029,0.062-0.074,0.089-0.113\r\n\t\t\t\tC10.38,34.159,10.076,34.16,10.015,33.979z M7.581,34.385c0.019,0.027,0.251,0.17,0.311,0.153\r\n\t\t\t\tc0.044-0.013,0.058-0.078,0.14-0.058c0.051,0.014,0.064,0.041,0.127,0.039c0.002-0.012,0.004-0.021,0.006-0.033\r\n\t\t\t\tc-0.073-0.109-0.33-0.157-0.515-0.152C7.628,34.352,7.604,34.368,7.581,34.385z"},"children":[{"name":"path","attribs":{"d":"M31.446,19.655c0.015,0.03,0.03,0.059,0.044,0.089c0.057-0.013,0.103-0.074,0.133-0.115c0.012-0.009,0.004,0,0.013-0.013\r\n\t\t\t\tc-0.023-0.013-0.047-0.026-0.07-0.038c-0.002-0.004-0.004-0.008-0.006-0.013c0.069-0.055,0.095-0.122,0.076-0.235\r\n\t\t\t\tc-0.03-0.002-0.059-0.004-0.089-0.006c-0.026,0.029-0.04,0.127-0.051,0.165c-0.058-0.027-0.089-0.049-0.108-0.114\r\n\t\t\t\tc-0.004-0.002-0.009-0.004-0.013-0.006c-0.078,0.099-0.18,0.095-0.076,0.267C31.324,19.671,31.398,19.659,31.446,19.655z\r\n\t\t\t\t M43.382,11.985c0.203,0.031,0.324,0.15,0.496,0.203c-0.004,0.021-0.009,0.042-0.013,0.064c-0.084,0.038-0.182,0.051-0.172,0.172\r\n\t\t\t\tc0.094,0.018,0.164,0.009,0.279,0.006c0.026,0.034,0.051,0.068,0.076,0.102c0.094,0.039,0.143-0.06,0.21-0.083\r\n\t\t\t\tc0.155,0.002,0.31,0.004,0.464,0.007c-0.006-0.127-0.177-0.162-0.254-0.223c-0.136-0.107-0.215-0.333-0.254-0.534\r\n\t\t\t\tc-0.085-0.43,0.254-0.283,0.292-0.597c-0.065-0.023-0.131-0.047-0.196-0.07c-0.172-0.022-0.357,0.059-0.478,0.089\r\n\t\t\t\tc-0.072,0.004-0.144,0.008-0.216,0.013c-0.088,0.044-0.135,0.159-0.235,0.203c-0.004,0.007-0.009,0.013-0.013,0.019\r\n\t\t\t\tc0.051,0.026,0.093,0.062,0.165,0.064c-0.037,0.109-0.134,0.278-0.241,0.311c-0.072,0.022-0.115-0.021-0.172-0.019\r\n\t\t\t\tc-0.049,0.061-0.104,0.114-0.07,0.229c0.02,0.025,0.038,0.051,0.057,0.076C43.251,12.115,43.275,11.969,43.382,11.985z\r\n\t\t\t\t M20.926,10.303c-0.046,0.008-0.091,0.016-0.137,0.024c-0.018,0.026-0.036,0.077-0.072,0.095\r\n\t\t\t\tc0.061,0.013,0.304-0.051,0.354-0.078C21.07,10.309,20.97,10.301,20.926,10.303z M31.37,7.524\r\n\t\t\t\tc0.061-0.032,0.123-0.064,0.184-0.095c0.036,0.055,0.072,0.11,0.108,0.165c-0.076,0.036-0.153,0.072-0.229,0.108\r\n\t\t\t\tc0.055,0.135,0.434,0.457,0.623,0.388c0.163-0.06,0.211-0.226,0.35-0.312c0.086,0.097,0.287,0.173,0.438,0.197v0.006\r\n\t\t\t\tc-0.178,0.189-0.512,0.185-0.769,0.299h-0.013c0.023,0.049,0.047,0.097,0.07,0.146c0.248-0.018,0.442-0.069,0.661-0.089\r\n\t\t\t\tc0.027,0.025,0.055,0.051,0.083,0.076c-0.103,0.131-0.323,0.152-0.559,0.146c-0.023,0.034-0.047,0.068-0.07,0.102\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.102,0.062,0.562,0.443,0.718,0.4c0.032-0.019,0.063-0.038,0.095-0.057\r\n\t\t\t\tc-0.001-0.177,0.066-0.321,0.159-0.407c0.028-0.029,0.124-0.04,0.172-0.044c0.038-0.081,0.076-0.161,0.114-0.242\r\n\t\t\t\tc0.058-0.144,0.054-0.343,0.178-0.419c0.094-0.021,0.188-0.043,0.28-0.064c0.053-0.026,0.106-0.051,0.159-0.076\r\n\t\t\t\tc-0.049-0.083-0.189-0.174-0.28-0.21c-0.082-0.032-0.163-0.021-0.229-0.063c-0.057-0.074-0.113-0.148-0.172-0.222\r\n\t\t\t\tc-0.078,0-0.117,0.083-0.172,0.127C33.238,7.389,33.219,7.38,33.2,7.372c-0.034-0.072,0.005-0.174,0.006-0.28\r\n\t\t\t\tc-0.021-0.015-0.042-0.03-0.063-0.045h-0.172c-0.066-0.021-0.113-0.079-0.211-0.089C32.725,7,32.688,7.043,32.652,7.085\r\n\t\t\t\tc-0.041,0.109,0.107,0.294,0.127,0.4c-0.02,0.017-0.038,0.034-0.057,0.051c-0.109-0.025-0.307-0.287-0.351-0.381\r\n\t\t\t\tc-0.075-0.059-0.101-0.039-0.191,0c-0.015,0.076-0.03,0.153-0.044,0.229v0.013c-0.074-0.015-0.148-0.03-0.222-0.045\r\n\t\t\t\tc-0.036-0.055-0.041-0.146-0.038-0.242c-0.077-0.016-0.176,0.02-0.235,0.032c-0.047-0.004-0.093-0.008-0.14-0.013\r\n\t\t\t\tc-0.146,0.013-0.218,0.074-0.305,0.14C31.219,7.367,31.286,7.485,31.37,7.524z M34.414,7.117v0.006\r\n\t\t\t\tc-0.066,0.146-0.102,0.233-0.28,0.267v0.114c0.275,0.013,0.552,0.025,0.826,0.038c0.06-0.04,0.119-0.081,0.179-0.121\r\n\t\t\t\tc0.077-0.033,0.161-0.016,0.254-0.045c0.078-0.04,0.156-0.08,0.234-0.121c0.104-0.078,0.208-0.157,0.311-0.235\r\n\t\t\t\tc0.002-0.004,0.004-0.008,0.006-0.013c-0.022-0.038-0.047-0.076-0.069-0.114c-0.062-0.017-0.123-0.034-0.185-0.051\r\n\t\t\t\tc-0.119-0.023-0.25,0.029-0.375,0.026c-0.024-0.051-0.051-0.102-0.075-0.153c-0.03-0.011-0.06-0.021-0.089-0.032\r\n\t\t\t\tc-0.133,0.016-0.224,0.14-0.286,0.229h-0.108c-0.027-0.1-0.003-0.248,0.025-0.343c-0.137,0.061-0.143,0.232-0.268,0.292\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.031,0.032c-0.168-0.256-0.328-0.017-0.496-0.134c-0.059-0.07-0.119-0.14-0.178-0.21\r\n\t\t\t\tc-0.082,0.106-0.162,0.212-0.242,0.318c-0.086,0.062-0.15,0.069-0.196,0.172c-0.004,0.004-0.009,0.008-0.013,0.013\r\n\t\t\t\tC33.594,7.203,34.035,7.121,34.414,7.117z M20.993,9.697c0.035,0.033,0.134,0.07,0.225,0.035c0.034-0.013,0.049-0.034,0.076-0.05\r\n\t\t\t\tc0.019-0.02,0.038-0.04,0.057-0.061C21.277,9.6,21.247,9.54,21.129,9.564C21.066,9.601,20.983,9.637,20.993,9.697z M21.388,8.988\r\n\t\t\t\tc-0.081,0.009-0.125-0.079-0.169-0.114c-0.024,0.041-0.114,0.079-0.126,0.107c0,0,0.086,0.119,0.094,0.127\r\n\t\t\t\tc0.011,0.01,0.028,0.019,0.044,0.023c0.039-0.003,0.22-0.108,0.242-0.129c0.013-0.013,0.03-0.035,0.009-0.052\r\n\t\t\t\tC21.451,8.925,21.406,8.976,21.388,8.988z M20.989,9.241c-0.031,0.049,0.059,0.128,0.12,0.118\r\n\t\t\t\tc0.061-0.054,0.045-0.074-0.037-0.096C21.044,9.256,21.017,9.248,20.989,9.241z M20.988,9.24L20.988,9.24\r\n\t\t\t\tc0.003-0.004-0.005-0.009-0.001-0.012C20.987,9.233,20.988,9.237,20.988,9.24z M30.588,18.905\r\n\t\t\t\tc0.119-0.015,0.252,0.008,0.413-0.006c0.016-0.051,0.02-0.072,0.064-0.095c-0.01-0.113-0.024-0.131,0.025-0.21\r\n\t\t\t\tc-0.011-0.004-0.021-0.008-0.032-0.013c-0.006,0.01-0.013,0.021-0.019,0.032c-0.055,0.015-0.11,0.03-0.165,0.044\r\n\t\t\t\tc-0.059,0.043-0.078,0.143-0.153,0.172c-0.076,0.008-0.153,0.017-0.229,0.025c-0.051,0.023-0.079,0.083-0.102,0.133\r\n\t\t\t\tc0.028,0.028,0.055,0.055,0.083,0.083C30.523,19.013,30.565,18.998,30.588,18.905z M10.002,26.709v0.006\r\n\t\t\t\tc0.013,0.019,0.025,0.038,0.038,0.057h0.027c-0.006-0.014-0.006-0.034-0.015-0.051C10.036,26.717,10.019,26.713,10.002,26.709z\r\n\t\t\t\t M42.956,34.189c-0.052-0.021-0.103-0.043-0.153-0.064c-0.119,0.085-0.214,0.171-0.388,0.21c-0.076,0.017-0.146-0.017-0.19-0.024\r\n\t\t\t\tc-0.086-0.018-0.14,0.054-0.197,0.069c-0.06-0.006-0.119-0.013-0.178-0.019h-0.014c-0.072,0.047-0.145,0.093-0.216,0.14\r\n\t\t\t\tc-0.099,0.036-0.13-0.06-0.242-0.038c-0.091,0.04-0.183,0.08-0.272,0.121h-0.179c-0.091-0.1-0.215-0.211-0.272-0.337\r\n\t\t\t\tc-0.055-0.015-0.129-0.003-0.191-0.013c-0.004-0.002-0.009-0.004-0.013-0.006v-0.014c0.069-0.033,0.208-0.09,0.261-0.146\r\n\t\t\t\tc-0.006-0.168-0.232-0.211-0.33-0.305c-0.018-0.016-0.033-0.139-0.089-0.19c-0.026-0.024-0.075-0.007-0.108-0.025\r\n\t\t\t\tc-0.088-0.098-0.178-0.194-0.267-0.292c-0.035-0.016-0.076-0.009-0.127-0.006c-0.039-0.055-0.074-0.139-0.133-0.172\r\n\t\t\t\tc-0.019,0.025-0.013,0.083-0.019,0.107c-0.005,0.002-0.009,0.004-0.014,0.008c-0.182-0.153-0.225-0.623-0.331-0.864\r\n\t\t\t\tc-0.049-0.112-0.295-0.163-0.362-0.254c-0.105-0.144-0.037-0.516-0.089-0.724c-0.032-0.135-0.153-0.35-0.254-0.426\r\n\t\t\t\tc-0.05-0.038-0.123-0.051-0.159-0.102c-0.045-0.062-0.051-0.162-0.076-0.242c0.023-0.021,0.047-0.042,0.07-0.064\r\n\t\t\t\tc-0.051-0.051-0.102-0.102-0.152-0.152c-0.14-0.209-0.24-0.462-0.369-0.667c-0.055-0.144-0.11-0.288-0.166-0.432\r\n\t\t\t\tc-0.094-0.171-0.256-0.287-0.299-0.521c0.033-0.045,0.039-0.066,0.096-0.089c0.08,0.245,0.223,0.49,0.4,0.642\r\n\t\t\t\tc0.019,0.021,0.047,0.019,0.075,0.013c0.08-0.159,0.058-0.398,0.185-0.508c-0.074-0.191-0.148-0.381-0.223-0.572\r\n\t\t\t\tc-0.121,0.015-0.164,0.113-0.337,0.019c-0.112,0.08-0.157,0.011-0.28,0.032c-0.041-0.043-0.076-0.051-0.095-0.121\r\n\t\t\t\tc-0.215-0.044-0.454,0.008-0.604,0.108c-0.039,0.032-0.08,0.063-0.12,0.095c-0.079,0.017-0.155-0.048-0.21-0.064\r\n\t\t\t\tc-0.061-0.006-0.123-0.013-0.184-0.019c-0.014-0.017-0.025-0.034-0.039-0.051c-0.147-0.032-0.297-0.064-0.444-0.095h-0.318\r\n\t\t\t\tc-0.058-0.026-0.045-0.125-0.108-0.146h-0.146c-0.077-0.012-0.25-0.041-0.324-0.07c-0.069-0.038-0.032-0.128-0.133-0.172\r\n\t\t\t\tc-0.258-0.113-0.681,0.039-0.782,0.21c-0.137,0.231,0.168,0.358-0.146,0.527c-0.038,0.02-0.089,0.07-0.146,0.064\r\n\t\t\t\tc-0.154-0.018-0.267-0.184-0.4-0.235c-0.133-0.05-0.434-0.054-0.541-0.114c-0.118-0.068-0.136-0.311-0.24-0.35\r\n\t\t\t\tc-0.058-0.021-0.105-0.003-0.152-0.025c-0.028-0.025-0.055-0.051-0.083-0.076c-0.066-0.013-0.131-0.025-0.197-0.038\r\n\t\t\t\tc-0.095,0.006-0.191,0.013-0.286,0.019c-0.129-0.055-0.258-0.11-0.388-0.165c-0.009-0.034-0.017-0.068-0.025-0.102\r\n\t\t\t\tc-0.061-0.005-0.069,0.013-0.121,0.025c-0.082-0.04-0.182-0.111-0.203-0.21c0.059-0.065,0.326-0.286,0.324-0.369\r\n\t\t\t\tc-0.011-0.042-0.021-0.085-0.032-0.127c-0.337-0.192,0.008-0.272,0.006-0.483c-0.064,0.038-0.127,0.076-0.191,0.115\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c-0.018-0.04-0.036-0.072-0.038-0.127c-0.047-0.021-0.093-0.042-0.14-0.064\r\n\t\t\t\tc-0.03,0.004-0.059,0.009-0.089,0.013c-0.095,0.036-0.266,0.212-0.432,0.165c-0.024-0.007-0.062-0.069-0.14-0.096\r\n\t\t\t\tc-0.063,0.009-0.084,0.051-0.133,0.076c-0.076-0.012-0.113-0.06-0.178-0.083c-0.078,0.055-0.155,0.115-0.267,0.14\r\n\t\t\t\tc-0.173,0.039-0.303-0.115-0.502-0.063c-0.038,0.021-0.076,0.042-0.114,0.063c-0.073,0.026-0.104-0.027-0.159-0.019\r\n\t\t\t\tc-0.047,0.021-0.093,0.042-0.14,0.064c-0.145,0.03-0.312-0.005-0.432,0.044c-0.114,0.047-0.181,0.142-0.267,0.216\r\n\t\t\t\tc-0.046-0.004-0.065-0.015-0.089-0.038c-0.039,0.007-0.209,0.066-0.242,0.089c-0.08,0.057-0.073,0.137-0.191,0.172\r\n\t\t\t\tc-0.13,0.038-0.283-0.002-0.318-0.089c-0.007-0.002-0.345,0.103-0.477,0.064c-0.138-0.041-0.19-0.153-0.28-0.242\r\n\t\t\t\tc-0.032,0.015-0.064,0.03-0.095,0.045c-0.071,0.054-0.17,0.43-0.248,0.534c-0.114,0.152-0.324,0.164-0.483,0.273\r\n\t\t\t\tc-0.054,0.037-0.227,0.186-0.248,0.241c-0.022,0.058,0.009,0.132-0.019,0.191c-0.035,0.073-0.121,0.127-0.153,0.21\r\n\t\t\t\tc-0.075,0.199,0.155,0.303-0.006,0.54c-0.101,0.149-0.406,0.41-0.578,0.483c-0.089,0.038-0.211,0.03-0.305,0.076\r\n\t\t\t\tc-0.108,0.053-0.13,0.288-0.203,0.381c-0.059,0.074-0.188,0.088-0.242,0.165c-0.056,0.081-0.105,0.204-0.127,0.311\r\n\t\t\t\tc-0.002,0.044-0.004,0.089-0.006,0.134c-0.04,0.101-0.18,0.151-0.242,0.235c-0.063,0.146-0.127,0.292-0.191,0.438\r\n\t\t\t\tc-0.047,0.051-0.093,0.102-0.14,0.153c-0.056,0.084-0.082,0.256-0.064,0.388c0.015-0.017,0.03-0.034,0.044-0.051\r\n\t\t\t\tc0.199,0.016,0.209,0.339,0.114,0.477c0.233,0.184,0.095,0.554,0.025,0.788c-0.008,0.067-0.017,0.136-0.025,0.203\r\n\t\t\t\tc-0.037,0.135-0.145,0.317-0.273,0.362c-0.002,0.004-0.004,0.008-0.006,0.013c0.181,0.075,0.181,0.271,0.267,0.311\r\n\t\t\t\tc0.01,0.021,0.013,0.041,0.013,0.076c-0.019,0.004-0.038,0.008-0.057,0.013c-0.049,0.069-0.01,0.178-0.032,0.262\r\n\t\t\t\tc0.08,0.135,0.04,0.035,0.14,0.102c0.004,0.016,0.008,0.03,0.013,0.044c0.042,0.024,0.085,0.052,0.127,0.076\r\n\t\t\t\tc0.063-0.013,0.153-0.052,0.203,0.006c-0.039,0.048-0.093,0.079-0.076,0.165c0.026,0.018,0.08,0.021,0.102,0.044\r\n\t\t\t\tc0.015,0.021,0.01,0.028,0.006,0.058c0.034,0.022,0.057,0.033,0.121,0.031c0.011,0.033,0.011,0.061,0,0.096\r\n\t\t\t\tc0.065,0.068,0.166,0.135,0.267,0.164c0.006,0.032,0.013,0.063,0.019,0.096c0.033,0.061,0.118,0.08,0.14,0.158v0.096\r\n\t\t\t\tc0.014,0.018,0.035,0.021,0.063,0.025c0.002,0.008,0.004,0.017,0.006,0.024c-0.023,0.019-0.047,0.038-0.07,0.058h-0.013\r\n\t\t\t\tc0.028,0.094,0.156,0.186,0.261,0.203c0.018,0.033,0.013,0.047,0.006,0.094c0.142,0.043,0.215,0.149,0.324,0.223\r\n\t\t\t\tc0.08,0.042,0.161,0.085,0.242,0.127c0.17,0.12,0.278,0.261,0.477,0.361c0.062,0.033,0.311,0.192,0.388,0.173\r\n\t\t\t\tc0.102-0.054,0.203-0.106,0.305-0.159c0.106-0.029,0.212-0.059,0.318-0.089c0.092-0.027,0.292-0.048,0.407-0.025\r\n\t\t\t\tc0.05,0.011,0.145,0.062,0.21,0.038c0.011-0.013,0.021-0.025,0.032-0.038c0.041,0.005,0.246,0.134,0.286,0.165\r\n\t\t\t\tc0.206-0.093,0.411-0.186,0.616-0.279c0.087-0.008,0.174-0.018,0.261-0.025c0.052-0.039,0.054-0.107,0.127-0.133\r\n\t\t\t\tc0.214-0.02,0.428-0.038,0.642-0.057c0.032-0.013,0.039-0.043,0.083-0.058c0.077,0.015,0.286,0.147,0.331,0.203\r\n\t\t\t\tc0.015,0.024,0.03,0.051,0.044,0.075c0.023,0.002,0.047,0.005,0.07,0.007c0.006,0.008,0.013,0.017,0.019,0.024\r\n\t\t\t\tc-0.013,0.032-0.025,0.064-0.038,0.096c0.025,0.209,0.348,0.363,0.534,0.197c0.101,0.017,0.232,0.039,0.343-0.007\r\n\t\t\t\tc0.002-0.026-0.002-0.036-0.013-0.062c0.025-0.017,0.147,0.013,0.178,0.051c0.069,0.124-0.004,0.172,0.222,0.165\r\n\t\t\t\tc0.008,0.013,0.017,0.025,0.025,0.038c0.004,0.004,0.008,0.008,0.013,0.013c-0.019,0.016-0.038,0.03-0.057,0.044\r\n\t\t\t\tc0.021,0.08,0.085,0.147,0.102,0.242c-0.011,0.042-0.021,0.085-0.032,0.127c0.009,0.032,0.017,0.063,0.025,0.095\r\n\t\t\t\tc-0.024,0.1-0.086,0.2-0.153,0.262c-0.002,0.006-0.004,0.013-0.006,0.019c0.025,0.004,0.051,0.008,0.076,0.013\r\n\t\t\t\tc0.003,0.084-0.012,0.146-0.076,0.166c0.049,0.041,0.097,0.084,0.146,0.127v0.006c-0.038-0.004-0.076-0.01-0.114-0.014\r\n\t\t\t\tc-0.031,0.139-0.072,0.242-0.191,0.292c0.013,0.028,0.052,0.116,0.076,0.14c0.036,0.035,0.074,0.016,0.114,0.07\r\n\t\t\t\tc-0.021,0.016-0.042,0.03-0.063,0.045c-0.002,0.004-0.004,0.008-0.006,0.014c0.042,0.062,0.085,0.123,0.127,0.184\r\n\t\t\t\tc0.053,0.027,0.074,0.003,0.108,0.045c-0.011,0.016-0.021,0.03-0.032,0.044c0.089,0.058,0.143,0.122,0.203,0.21\r\n\t\t\t\tc0.112,0.104,0.224,0.208,0.337,0.311c0.032,0.039,0.115,0.205,0.133,0.248c0.029,0.068-0.018,0.162,0.038,0.262\r\n\t\t\t\tc0.045,0.064,0.089,0.127,0.133,0.191c0.013,0.061,0.025,0.123,0.038,0.184c0.057,0.134,0.17,0.186,0.14,0.388\r\n\t\t\t\tc-0.243,0.109,0.046,0.36,0.089,0.489c0.008,0.1,0.017,0.199,0.025,0.299c-0.019,0.11-0.066,0.285-0.146,0.337\r\n\t\t\t\tc-0.03,0.011-0.059,0.021-0.089,0.032c-0.017,0.04-0.034,0.081-0.051,0.121c-0.03,0.031-0.059,0.064-0.089,0.096\r\n\t\t\t\tc-0.094,0.223-0.042,0.57-0.222,0.705c0,0.202-0.037,0.471,0.013,0.648c0.038,0.135,0.15,0.217,0.216,0.324\r\n\t\t\t\tc0.108,0.215,0.216,0.432,0.324,0.647c0.075,0.146,0.371,0.403,0.203,0.571c0.03,0.141,0.059,0.281,0.089,0.42\r\n\t\t\t\tc0.023,0.055,0.047,0.109,0.07,0.165c0.02,0.081-0.031,0.143-0.025,0.202c0.008,0.08,0.071,0.147,0.089,0.211\r\n\t\t\t\tc0.014,0.047-0.021,0.072-0.019,0.102c0.034,0.104,0.068,0.208,0.102,0.311c0.116,0.131,0.233,0.264,0.349,0.395\r\n\t\t\t\tc0.12,0.189,0.16,0.434,0.273,0.635c0.1,0.178,0.271,0.36,0.203,0.654c-0.033,0.008-0.078,0-0.096,0.025\r\n\t\t\t\tc-0.025,0.031,0.123,0.229,0.159,0.285c-0.017,0.049-0.034,0.099-0.051,0.146c0.011,0.011,0.021,0.021,0.032,0.031\r\n\t\t\t\tc0.006,0.003,0.013,0.005,0.019,0.007c0.006-0.015,0.013-0.03,0.019-0.045c0.018-0.009,0.022-0.011,0.052-0.013\r\n\t\t\t\tc0.013,0.022,0.024,0.047,0.038,0.069c0.027-0.001,0.052-0.007,0.102-0.006c0.021,0.028,0.021,0.056,0.038,0.095\r\n\t\t\t\tc0.024,0.043,0.115,0.075,0.165,0.09c0.061-0.047,0.096-0.123,0.178-0.146c0.115-0.035,0.252,0.044,0.356-0.006\r\n\t\t\t\tc0.032-0.03,0.063-0.059,0.095-0.09c0.15-0.07,0.214,0,0.331,0c0.034-0.019,0.067-0.037,0.103-0.057\r\n\t\t\t\tc0.121-0.035,0.233,0.073,0.317,0.102c0.04-0.03,0.07-0.055,0.095-0.102c0.058,0.014,0.114,0.025,0.172,0.038\r\n\t\t\t\tc0.018-0.019,0.021-0.053,0.033-0.075c0.049-0.049,0.321-0.018,0.399-0.07c0.083-0.072,0.165-0.145,0.248-0.217\r\n\t\t\t\tc0.416-0.326,0.721-0.688,1.017-1.138c0.074-0.112,0.264-0.19,0.305-0.299c0.021-0.052-0.027-0.122-0.019-0.146\r\n\t\t\t\tc0.017-0.045,0.065-0.033,0.089-0.064c0.071-0.091,0.109-0.35,0.09-0.496c-0.039-0.016-0.078-0.04-0.096-0.076\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.02-0.019c0.078-0.091,0.133-0.175,0.242-0.235c0.244-0.134,0.525-0.121,0.635-0.388\r\n\t\t\t\tc-0.008-0.062-0.051-0.036-0.063-0.07c0.002-0.006,0.005-0.013,0.007-0.019c0.012-0.032,0.024-0.064,0.037-0.096\r\n\t\t\t\tc0.03-0.123,0.023-0.264,0.02-0.388c-0.028,0.011-0.035,0.019-0.076,0.019c-0.039-0.123-0.087-0.273-0.044-0.375\r\n\t\t\t\tc-0.007-0.074-0.062-0.111-0.114-0.14v-0.202c0.119-0.088,0.237-0.175,0.355-0.262c0.146-0.122,0.233-0.305,0.4-0.406\r\n\t\t\t\tc0.203-0.123,0.451-0.162,0.643-0.293c0.137-0.094,0.224-0.268,0.33-0.394c0-0.028-0.008-0.039-0.019-0.07\r\n\t\t\t\tc0.036-0.047,0.068-0.081,0.095-0.14c-0.002-0.012-0.004-0.021-0.006-0.032c-0.023-0.011-0.047-0.021-0.07-0.032\r\n\t\t\t\tc-0.02-0.162,0.013-0.337-0.069-0.432c0.003-0.034,0.034-0.062,0.044-0.107c0.025-0.113-0.041-0.295-0.057-0.395\r\n\t\t\t\tc0.029-0.055,0.059-0.11,0.088-0.165c-0.064-0.14-0.182-0.157-0.266-0.267c-0.084-0.108-0.127-0.394-0.07-0.554\r\n\t\t\t\tc-0.019-0.028-0.043-0.032-0.064-0.057c0.029-0.062,0.083-0.148,0.089-0.216c-0.057-0.071-0.161-0.127-0.196-0.217\r\n\t\t\t\tc-0.037-0.095,0.061-0.406,0.102-0.451c0.023-0.025,0.068-0.021,0.089-0.051c0.047-0.067,0.006-0.104,0.024-0.164\r\n\t\t\t\tc0.043-0.138,0.173-0.144,0.185-0.369c0.097-0.053,0.187-0.051,0.19-0.203c0.086,0.017,0.125-0.021,0.191-0.051\r\n\t\t\t\tc0.024-0.035,0.026-0.054,0.006-0.095c0.209-0.235,0.416-0.47,0.623-0.704c0.229-0.186,0.516-0.326,0.744-0.509\r\n\t\t\t\tc0.086-0.104,0.17-0.208,0.254-0.312c0.168-0.215,0.42-0.422,0.527-0.686c0.011-0.049,0.021-0.098,0.032-0.146\r\n\t\t\t\tc0.073-0.118,0.147-0.236,0.222-0.355c-0.002-0.027-0.004-0.055-0.006-0.083c0.042-0.04,0.085-0.081,0.127-0.121\r\n\t\t\t\tc0.055-0.098,0.109-0.194,0.165-0.292c0.006-0.087,0.013-0.174,0.019-0.261c0.015-0.04,0.08-0.069,0.076-0.127\r\n\t\t\t\tc-0.002-0.045-0.037-0.108-0.019-0.172c0.017-0.04,0.034-0.081,0.051-0.121C42.96,34.201,42.958,34.195,42.956,34.189z\r\n\t\t\t\t M51.688,35.154c-0.031-0.184-0.127-0.277-0.279-0.375c0.018,0.078-0.004,0.113-0.025,0.191c-0.033,0.026-0.04,0.043-0.095,0.025\r\n\t\t\t\tc-0.004,0.015-0.009,0.029-0.013,0.044c0.015,0.017,0.029,0.034,0.043,0.051c-0.028,0.063-0.008,0.077,0.007,0.14v0.318\r\n\t\t\t\tc0.022,0.102,0.073,0.268,0.146,0.324c0.209,0.044,0.477-0.139,0.451-0.337c-0.011-0.089-0.093-0.163-0.127-0.235\r\n\t\t\t\tC51.76,35.227,51.768,35.186,51.688,35.154z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z\r\n\t\t\t\t M50.505,13.747c0.043,0.044,0.081,0.093,0.124,0.137c-0.003,0.02-0.006,0.039-0.008,0.059v0.006\r\n\t\t\t\tc0.027,0.007,0.053,0.01,0.08,0.013c0.048,0.049,0.092,0.103,0.139,0.153c-0.13,0.026-0.316,0.022-0.352-0.084\r\n\t\t\t\tC50.471,14.004,50.497,13.865,50.505,13.747z M48.568,14.508c0.037,0.017,0.076,0.034,0.113,0.051\r\n\t\t\t\tc0.07-0.025,0.141-0.051,0.211-0.076c-0.014-0.036-0.025-0.072-0.039-0.108c0.033-0.077,0.143-0.097,0.203-0.146\r\n\t\t\t\tc0.084-0.066,0.228-0.183,0.268-0.286c0.015-0.059,0.029-0.119,0.044-0.178c0.022-0.052,0.06-0.069,0.063-0.146\r\n\t\t\t\tc-0.099-0.13-0.201-0.041-0.254-0.292c0.002-0.127,0.004-0.254,0.006-0.381c-0.008-0.074-0.017-0.148-0.024-0.222\r\n\t\t\t\tc0.032-0.042,0.063-0.085,0.095-0.127c0.001-0.002-0.001-0.005,0-0.008c0.1,0.088,0.195,0.177,0.293,0.266\r\n\t\t\t\tc-0.012,0.031-0.036,0.06-0.038,0.092c-0.006,0.103,0.07,0.19,0.07,0.324c0.103-0.002,0.239,0.039,0.312,0.025\r\n\t\t\t\tc0.033-0.012,0.068-0.024,0.103-0.036c0.075,0.072,0.157,0.137,0.231,0.211c-0.214-0.04-0.47,0.008-0.5,0.206\r\n\t\t\t\tc0.057,0.099,0.113,0.168,0.108,0.318c-0.042,0.053-0.085,0.106-0.127,0.159c-0.034,0.021-0.067,0.042-0.103,0.064\r\n\t\t\t\tc-0.043,0.061-0.037,0.157-0.095,0.203c-0.14,0.113-0.327,0.134-0.407,0.311c-0.084,0.039-0.185,0.002-0.261-0.013\r\n\t\t\t\tc-0.053,0.002-0.106,0.004-0.159,0.006c-0.219-0.032-0.424-0.055-0.502-0.229C48.309,14.462,48.449,14.461,48.568,14.508z\r\n\t\t\t\t M14.404,12.899c-0.002,0.011-0.006,0.023,0.013,0.034c0.011,0.006,0.027,0.004,0.044,0.005c0.046,0.003,0.104,0.019,0.122,0.05\r\n\t\t\t\tc-0.03,0.071-0.177,0-0.221-0.006c0,0.003,0,0.006,0,0.008c-0.005,0-0.011,0-0.016,0c-0.003,0.077,0.276,0.05,0.304,0.123\r\n\t\t\t\tc-0.032,0.036-0.081,0.019-0.141,0.035c-0.004,0.062,0.16,0.026,0.146,0.083c0,0.002-0.001,0.003-0.001,0.005\r\n\t\t\t\tc-0.043,0.013-0.078-0.002-0.117,0.012c-0.004,0.003-0.007,0.006-0.01,0.009c0,0.003,0,0.006,0,0.008\r\n\t\t\t\tc0.031,0.019,0.072,0.042,0.132,0.023c0.017-0.006,0.036-0.014,0.054-0.012c0.006,0.002,0.012,0.003,0.017,0.005\r\n\t\t\t\tc0.003,0.02-0.019,0.062-0.05,0.071c-0.034,0.009-0.199-0.014-0.228-0.021c-0.059-0.015-0.101-0.05-0.147-0.078\r\n\t\t\t\tc-0.04-0.024-0.124-0.06-0.197-0.085C14.204,13.077,14.305,12.99,14.404,12.899z M13.524,13.715\r\n\t\t\t\tc0.019,0.012,0.039,0.022,0.052,0.039c-0.03-0.002-0.064,0.005-0.097,0.01C13.495,13.749,13.509,13.731,13.524,13.715z\r\n\t\t\t\t M7.943,27.904c0.017-0.004,0.034-0.008,0.051-0.013c-0.017,0.015-0.034,0.03-0.051,0.045\r\n\t\t\t\tC7.945,27.925,7.941,27.918,7.943,27.904z M7.499,23.367c-0.001,0.007,0,0.011-0.001,0.018c-0.002-0.002-0.002-0.004-0.004-0.006\r\n\t\t\t\tC7.496,23.376,7.497,23.372,7.499,23.367z M7.676,37.665c-0.049,0.065-0.234,0.104-0.337,0.051\r\n\t\t\t\tc-0.044,0.033-0.061,0.065-0.057,0.146c-0.015,0.014-0.03,0.025-0.044,0.039c-0.012-0.053-0.021-0.069-0.07-0.084\r\n\t\t\t\tc-0.033-0.006-0.066,0.023-0.095,0.039c-0.203,0.106-0.124,0.25-0.191,0.438c-0.026,0.005-0.052,0.01-0.079,0.016\r\n\t\t\t\tc-0.076-0.303-0.168-0.599-0.232-0.904c0.011,0,0.019,0.005,0.032,0.006c0.029,0.082,0.054,0.128,0.146,0.146\r\n\t\t\t\tc0.004-0.029,0.009-0.056,0.013-0.084h0.006c0.023,0.049,0.076,0.109,0.064,0.172c0.006,0.006,0.013,0.014,0.019,0.02\r\n\t\t\t\tc0.114,0.02,0.144-0.047,0.248-0.057c-0.01-0.111-0.095-0.121-0.133-0.203c0.039-0.059,0.138-0.1,0.21-0.121\r\n\t\t\t\tc-0.003-0.04-0.005-0.057,0.006-0.09c0.198-0.062,0.318-0.017,0.375,0.141c0.045,0.008,0.076-0.016,0.108-0.038\r\n\t\t\t\tc-0.001,0.05,0.005,0.067,0.038,0.083c0.002,0.004,0.004,0.01,0.006,0.014c-0.061-0.009-0.097-0.021-0.121,0.031\r\n\t\t\t\tC7.564,37.5,7.647,37.605,7.676,37.665z M32,58c-7.083,0-13.497-2.841-18.187-7.436c0.051-0.051,0.122-0.09,0.155-0.152\r\n\t\t\t\tc0.019-0.078,0.038-0.157,0.057-0.235v-0.013c0.049,0.021,0.108,0.044,0.172,0.02h0.006c0.013,0.191-0.204,0.291-0.248,0.482\r\n\t\t\t\tc0.103-0.092,0.237-0.221,0.299-0.35c0.051-0.121,0.102-0.241,0.153-0.361c0.174-0.277,0.481-0.299,0.394-0.852\r\n\t\t\t\tc-0.012-0.078-0.036-0.114-0.057-0.172c0.045-0.055,0.132-0.205,0.019-0.255v-0.038c0.146,0.014,0.159-0.072,0.235-0.14\r\n\t\t\t\tc0.08-0.069,0.491-0.363,0.585-0.381c0.051-0.011,0.091,0.021,0.127,0.032c0.03-0.036,0.059-0.072,0.089-0.108\r\n\t\t\t\tc0.086-0.051,0.144-0.034,0.165-0.153c0.094-0.012,0.207-0.008,0.28,0.006c0.161,0.031,0.334-0.013,0.483-0.024\r\n\t\t\t\tc-0.005-0.183,0.137-0.241,0.292-0.254c-0.009-0.052-0.017-0.103-0.025-0.153c0.017-0.123,0.117-0.202,0.172-0.292\r\n\t\t\t\tc0.034-0.069,0.068-0.14,0.102-0.21c0.032-0.046,0.105-0.072,0.121-0.133c-0.006-0.062-0.013-0.123-0.019-0.184\r\n\t\t\t\tc-0.03-0.17,0.065-0.289,0.184-0.332c0-0.047-0.035-0.138-0.019-0.222c0.021-0.106,0.097-0.243,0.076-0.368\r\n\t\t\t\tc-0.017-0.166-0.034-0.332-0.051-0.496c0.028-0.172,0.093-0.289,0.095-0.465c0.015,0.002,0.03,0.004,0.044,0.006\r\n\t\t\t\tc0.017,0.034,0.034,0.068,0.051,0.103h0.019c0.113-0.084,0.241-0.308,0.292-0.445c0.031-0.081,0.007-0.126,0.057-0.178\r\n\t\t\t\tc0.047-0.021,0.093-0.042,0.14-0.063c0.273-0.213,0.461-0.44,0.534-0.858c0.027-0.157-0.139-0.732-0.216-0.757\r\n\t\t\t\tc-0.161-0.049-0.338,0.009-0.458-0.069c-0.256-0.166-0.436-0.435-0.731-0.565c-0.171-0.076-0.287,0.017-0.451-0.014\r\n\t\t\t\tc-0.1-0.016-0.199-0.029-0.299-0.045c-0.086-0.023-0.18-0.133-0.286-0.121c-0.154,0.018-0.289,0.139-0.394,0.21\r\n\t\t\t\tc-0.049-0.2,0.024-0.122,0.044-0.241c0.013-0.078-0.114-0.195-0.184-0.203c-0.017,0.017-0.034,0.033-0.051,0.051h-0.025\r\n\t\t\t\tc-0.054-0.172-0.227-0.156-0.394-0.217c-0.065-0.022-0.106-0.067-0.159-0.102c-0.052,0.007-0.15,0.016-0.216,0.032\r\n\t\t\t\tc-0.072,0.028-0.08,0.13-0.121,0.19c-0.069,0.102-0.227,0.129-0.28,0.248c-0.004,0.002-0.008,0.004-0.013,0.006\r\n\t\t\t\tc0-0.069,0.012-0.1,0.032-0.146c-0.111,0.022-0.259,0.048-0.394,0.026c-0.032-0.076-0.064-0.153-0.095-0.229\r\n\t\t\t\tc-0.088,0.024-0.202,0.166-0.318,0.121c-0.006-0.004-0.013-0.008-0.019-0.013c0.085-0.065,0.102-0.2,0.159-0.293\r\n\t\t\t\tc0.065-0.104,0.205-0.137,0.28-0.229c0.067-0.082,0.092-0.211,0.197-0.254c0.034-0.054,0.016-0.107-0.006-0.165\r\n\t\t\t\tc-0.262-0.036-0.276-0.356-0.343-0.577c-0.021-0.068-0.016-0.144-0.076-0.173c-0.031-0.005-0.044,0.032-0.076,0.025\r\n\t\t\t\tc-0.015-0.003-0.319-0.315-0.4-0.356c-0.11-0.035-0.22-0.072-0.331-0.107c-0.09-0.035-0.342-0.112-0.489-0.051\r\n\t\t\t\tc-0.016,0.014-0.018,0.026-0.019,0.057c-0.095-0.021-0.191-0.042-0.286-0.064h-0.006c-0.015,0.016-0.03,0.03-0.044,0.045\r\n\t\t\t\tc-0.061-0.119-0.214-0.313-0.388-0.291c-0.011,0.021-0.021,0.041-0.032,0.062v0.013c-0.013-0.091-0.026-0.182-0.038-0.272\r\n\t\t\t\tc-0.074-0.125-0.313-0.283-0.47-0.318c-0.084-0.018-0.176,0.005-0.241,0.02c-0.066-0.004-0.131-0.009-0.197-0.014v-0.006\r\n\t\t\t\tc0.187-0.059,0.138-0.167,0.273-0.223c0.002-0.004,0.004-0.008,0.006-0.012c-0.051-0.035-0.122-0.046-0.178-0.084\r\n\t\t\t\tc-0.013-0.019-0.026-0.037-0.038-0.057c-0.045-0.029-0.132-0.021-0.172-0.045c-0.027,0.02-0.038,0.035-0.045,0.076\r\n\t\t\t\tc-0.004,0.002-0.008,0.004-0.013,0.006c-0.012-0.113-0.097-0.154-0.184-0.191v-0.039c0.059,0.002,0.119,0.004,0.178,0.006\r\n\t\t\t\tc0.011-0.006,0.021-0.014,0.032-0.02c0.004-0.009,0.008-0.018,0.013-0.025c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.129-0.028-0.42-0.039-0.54,0.019c-0.075,0.037-0.117,0.127-0.21,0.146c-0.261,0.059-0.335-0.148-0.496-0.159\r\n\t\t\t\tc-0.136-0.008-0.364,0.083-0.483,0.025c-0.058-0.029-0.044-0.058-0.07-0.121c-0.05-0.125-0.201-0.158-0.375-0.159\r\n\t\t\t\tc-0.033-0.051-0.073-0.137-0.089-0.197c-0.053-0.012-0.097,0.017-0.114,0.064c0.015,0.025,0.03,0.051,0.044,0.076\r\n\t\t\t\tc0.028-0.002,0.055-0.004,0.083-0.006c0.013,0.011,0.025,0.021,0.038,0.031c-0.016,0.063-0.425,0.178-0.515,0.211\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.012c-0.008,0.037-0.018,0.037-0.038,0.058c0.053,0.026,0.197,0.299,0.152,0.394\r\n\t\t\t\tc-0.025,0.045-0.094,0.072-0.152,0.084c-0.065-0.049-0.097-0.164-0.146-0.229c0.015-0.101,0.07-0.187,0.121-0.254\r\n\t\t\t\tc-0.012-0.103-0.056-0.167-0.089-0.254c0.041-0.062,0.144-0.086,0.241-0.089c0.011-0.014,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.013-0.064-0.059-0.101-0.114-0.121c-0.156-0.06-0.195,0.139-0.273,0.185c-0.04,0.012-0.081,0.024-0.121,0.037\r\n\t\t\t\tc0.019-0.035,0.046-0.051,0.032-0.102c0.027,0.011,0.029,0.016,0.038,0.045h0.006c0.052-0.033,0.079-0.079,0.121-0.121\r\n\t\t\t\tc-0.08-0.166-0.161-0.342-0.337-0.413c-0.058-0.022-0.134,0.003-0.203-0.026c-0.026-0.01-0.121-0.049-0.159-0.037\r\n\t\t\t\tc-0.047,0.031-0.093,0.063-0.14,0.095c-0.03,0.018-0.063,0.012-0.102,0.026c-0.12,0.043-0.172,0.127-0.331,0.094\r\n\t\t\t\tc-0.05-0.062-0.09-0.027-0.135-0.021c-0.26-1.288-0.395-2.619-0.457-3.968c0.016-0.002,0.033-0.001,0.046-0.007\r\n\t\t\t\tc0.167-0.078,0.167-0.194,0.47-0.121c0.006,0.011,0.013,0.021,0.019,0.031v0.007c-0.047,0.013-0.093,0.024-0.14,0.038\r\n\t\t\t\tc0.108,0.084,0.261,0.035,0.419,0.082c0.114,0.035,0.208,0.115,0.337,0.146c0.067,0.018,0.202-0.02,0.261,0.02\r\n\t\t\t\tc0.043,0.024,0.066,0.123,0.07,0.184c0.099,0.061,0.295,0.061,0.388,0.127c-0.006,0.064-0.053,0.105-0.102,0.127\r\n\t\t\t\tC7.811,33.859,7.792,33.88,7.773,33.9v0.007c0.141,0.006,0.266-0.058,0.394-0.038c0.097,0.011,0.195,0.021,0.292,0.031\r\n\t\t\t\tc0.105-0.019,0.2-0.058,0.324-0.069c0.002-0.004,0.004-0.008,0.006-0.013c-0.124-0.092-0.202-0.151-0.432-0.146\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.02c0.013-0.027,0.025-0.055,0.038-0.082c-0.079-0.081-0.36-0.09-0.483-0.141\r\n\t\t\t\tc-0.04-0.043-0.08-0.089-0.121-0.133c-0.131-0.09-0.318-0.074-0.477-0.146c-0.064-0.053-0.127-0.105-0.191-0.158H7.022\r\n\t\t\t\tc-0.163-0.037-0.338-0.074-0.559-0.07c-0.083,0.008-0.165,0.018-0.248,0.025c-0.059,0.014-0.109,0.043-0.163,0.068\r\n\t\t\t\tC6.038,32.677,6,32.344,6,32c0-0.404,0.042-0.798,0.06-1.198c0.069,0.073,0.127,0.176,0.179,0.209\r\n\t\t\t\tc0.057,0.035,0.12,0.025,0.133,0.102c-0.021,0.115-0.042,0.229-0.064,0.343c0.008,0.002,0.017,0.004,0.025,0.006\r\n\t\t\t\tc0.036,0.022,0.05-0.017,0.089-0.032c0.002,0.019,0.004,0.038,0.006,0.057c-0.025,0.035-0.04,0.043-0.083,0.063\r\n\t\t\t\tc0.038,0.07,0.076,0.14,0.115,0.21h0.06c0.006,0.032,0.013,0.064,0.019,0.095c0.019,0.013,0.038,0.025,0.057,0.038\r\n\t\t\t\tc0.051,0.105-0.017,0.164,0.133,0.172c0.035,0.058,0.068,0.193,0.108,0.242c0.047-0.022,0.112-0.023,0.178-0.032\r\n\t\t\t\tc-0.004,0.021-0.008,0.042-0.013,0.064h0.013c0.048-0.142,0.166-0.403,0.108-0.61c-0.023-0.081-0.082-0.166-0.108-0.261\r\n\t\t\t\tc-0.013-0.083-0.025-0.165-0.038-0.248c-0.062-0.179-0.316-0.446-0.267-0.699c0.032-0.1,0.064-0.199,0.095-0.299\r\n\t\t\t\tc0.053-0.085,0.131-0.155,0.165-0.26c0.15-0.028,0.305-0.087,0.369-0.197c0.047-0.082,0.048-0.15,0.127-0.197\r\n\t\t\t\tc0.074-0.044,0.216-0.039,0.28-0.076c0.064-0.08,0.127-0.161,0.191-0.242c0.07-0.011,0.14-0.021,0.21-0.032\r\n\t\t\t\tc0.025-0.021,0.051-0.042,0.076-0.063c0.002-0.004,0.004-0.009,0.006-0.013c-0.027-0.012-0.033-0.01-0.044-0.038\r\n\t\t\t\tc-0.025,0.019-0.067,0.035-0.095,0.051c-0.015-0.009-0.03-0.017-0.044-0.026c-0.019-0.013-0.023-0.028-0.032-0.051\r\n\t\t\t\tc0.025,0.019,0.035,0.04,0.07,0.051c0.054-0.032,0.047-0.06,0.089-0.083v-0.013c-0.03-0.031-0.081-0.057-0.14-0.057\r\n\t\t\t\tc-0.006-0.011-0.013-0.021-0.019-0.032c0.044,0.015,0.089,0.03,0.133,0.045c-0.006-0.011-0.013-0.021-0.019-0.032v-0.006\r\n\t\t\t\tc0.051,0.021,0.064,0.054,0.14,0.064c0.025-0.03,0.051-0.059,0.076-0.089c0.009-0.016,0.008-0.002,0.038,0\r\n\t\t\t\tc0.006-0.011,0.013-0.021,0.019-0.032c-0.001-0.047-0.012-0.063-0.038-0.083c-0.011-0.006-0.002-0.006-0.013,0\r\n\t\t\t\tc-0.028,0.017-0.029,0.052-0.044,0.081c0.002,0.005-0.004,0.01-0.001,0.014v-0.013c0-0.001,0-0.001,0.001-0.002\r\n\t\t\t\tc-0.01-0.027-0.001-0.054,0.005-0.087c-0.004-0.004-0.009-0.008-0.013-0.013c-0.06,0.01-0.113,0.02-0.191,0.019\r\n\t\t\t\tc0.008-0.038-0.02-0.071,0-0.108v-0.013c0.011,0.017-0.003,0.036,0.006,0.064c0.009,0.011,0.017,0.021,0.026,0.032\r\n\t\t\t\tc0.021-0.006,0.042-0.013,0.064-0.019c0-0.018-0.002-0.019-0.013-0.038c0.021,0.011,0.042,0.021,0.064,0.032\r\n\t\t\t\tc0.008-0.004,0.017-0.009,0.025-0.013c0.002-0.004,0.004-0.008,0.006-0.013c-0.011-0.015-0.021-0.029-0.032-0.044\r\n\t\t\t\tc0.034,0.019,0.057,0.04,0.089,0.025c0.004,0.015,0.008,0.03,0.013,0.045h0.019c-0.012-0.067-0.042-0.087-0.07-0.134h0.038\r\n\t\t\t\tc-0.004-0.026-0.004-0.02-0.017-0.036c0.004-0.008,0.008-0.015,0.011-0.023c-0.024-0.086-0.083-0.085-0.17-0.066\r\n\t\t\t\tc-0.004-0.07-0.06-0.101-0.121-0.114c-0.002-0.004-0.004-0.008-0.006-0.013c0.011-0.006,0.021-0.013,0.032-0.019\r\n\t\t\t\tc0.043,0.021,0.076,0.045,0.095,0.089c0.03,0.02,0.023,0.021,0.07,0.019c-0.002-0.021-0.004-0.042-0.006-0.064\r\n\t\t\t\tc-0.02-0.013-0.034-0.028-0.052-0.038H8.172c-0.021-0.017-0.042-0.034-0.064-0.051c0.018,0.026,0.045,0.037,0.069,0.051h0.02\r\n\t\t\t\tc-0.002-0.013-0.004-0.025-0.006-0.038c0.017,0.006,0.034,0.013,0.051,0.019h0.006c-0.002-0.043-0.004-0.052-0.038-0.064\r\n\t\t\t\tc0.009-0.004,0.017-0.009,0.026-0.013c-0.082-0.042-0.117-0.054-0.159-0.133c0.034,0.03,0.068,0.059,0.102,0.089\r\n\t\t\t\tc0.006,0.006,0.013,0.013,0.019,0.019c0.036-0.023,0.042-0.039,0.057-0.083c-0.034-0.047-0.238-0.13-0.311-0.159\r\n\t\t\t\tc-0.002-0.007,0.001-0.013,0-0.019c0.068-0.003,0.075,0.022,0.127,0.045c-0.002-0.013-0.004-0.025-0.006-0.038\r\n\t\t\t\tc0.042,0.042,0.099,0.078,0.153,0.108c-0.016-0.09-0.078-0.09-0.095-0.165h0.006c0.012,0.032,0.027,0.045,0.057,0.057\r\n\t\t\t\tc0.004,0.004,0.008,0.008,0.013,0.013h0.006c-0.015-0.036-0.03-0.072-0.044-0.108c-0.02-0.107,0.072-0.052-0.006-0.197\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.002-0.019,0.004-0.038,0.006-0.057c0.019,0.012,0.011,0.001,0.019,0.026h0.006\r\n\t\t\t\tc0.011-0.014,0.011-0.017,0.013-0.045c0.002,0.011,0.004,0.021,0.006,0.032c0.029-0.021,0.034-0.024,0.032-0.045\r\n\t\t\t\tc0.015-0.011,0.03-0.021,0.044-0.032c-0.006,0.017-0.013,0.034-0.019,0.051c0.013,0.006,0.025,0.013,0.038,0.019\r\n\t\t\t\tc-0.025,0.006-0.051,0.013-0.076,0.019c-0.011,0.017-0.021,0.034-0.032,0.051v0.006h0.051c-0.013,0.035-0.02,0.044-0.07,0.044\r\n\t\t\t\tc-0.004,0.006-0.009,0.013-0.013,0.019c0.016,0.017,0.027,0.021,0.057,0.025c0.002,0.004,0.004,0.008,0.006,0.013v0.026\r\n\t\t\t\tc-0.013-0.007-0.025-0.013-0.038-0.019c-0.004,0.002-0.009,0.004-0.013,0.006c-0.004,0.013-0.009,0.025-0.013,0.038v0.006\r\n\t\t\t\tc0.047-0.025,0.036-0.01,0.089,0.013c0.004,0.006,0.009,0.013,0.013,0.019c-0.03,0.011-0.059,0.021-0.089,0.032\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.011,0.015,0.021,0.03,0.032,0.044c0.017,0.011,0.034,0.021,0.051,0.032\r\n\t\t\t\tc0.021-0.013,0.042-0.025,0.064-0.038c-0.001,0.055-0.005,0.033-0.025,0.07c0.015,0.008,0.03,0.017,0.044,0.025\r\n\t\t\t\tc-0.006,0.013-0.013,0.026-0.019,0.038v0.006H8.37c0.026-0.01,0.031-0.014,0.051,0c-0.039,0.071-0.09,0.135-0.114,0.229\r\n\t\t\t\tc0.004,0.013,0.008,0.025,0.013,0.038c0.008-0.002,0.017-0.004,0.025-0.006c0.017-0.038,0.034-0.076,0.051-0.114\r\n\t\t\t\tc0.02,0,0.017,0.006,0.032-0.006c0.023-0.055,0.047-0.11,0.07-0.165c0.033-0.056,0.086-0.075,0.102-0.14\r\n\t\t\t\tc-0.004-0.04-0.008-0.081-0.013-0.121c-0.078-0.033-0.136-0.206-0.152-0.292c0.024-0.023,0.034-0.046,0.064-0.064\r\n\t\t\t\tc0.002,0.002,0.004,0.004,0.006,0.006c-0.017,0.031-0.037,0.044-0.057,0.07c0.054,0.073,0.068,0.144,0.184,0.14\r\n\t\t\t\tc0.005,0.037-0.005,0.046-0.013,0.083v0.006c0.004,0.002,0.008,0.004,0.013,0.006c0.055-0.041,0.152-0.125,0.152-0.216\r\n\t\t\t\tc0.013,0.004,0.026,0.008,0.038,0.013c0.032-0.093,0.078-0.196,0.095-0.305c-0.053-0.007-0.063-0.019-0.089-0.051\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019c0.029-0.023,0.034-0.034,0.064-0.026c0.019-0.053,0.038-0.106,0.057-0.159\r\n\t\t\t\tc-0.015,0.047-0.03,0.093-0.045,0.14c0.19-0.133,0.413-0.223,0.744-0.222c0.008-0.043,0.017-0.085,0.025-0.127\r\n\t\t\t\tc0.002-0.002,0.036,0,0.064-0.013c0.003,0.022-0.008,0.053-0.006,0.095c0.004,0.002,0.008,0.004,0.013,0.007\r\n\t\t\t\tc0.058-0.002,0.108-0.049,0.121-0.089h0.006c0.013,0.016,0.014,0.037,0.013,0.07c0.072-0.017,0.144-0.034,0.216-0.051\r\n\t\t\t\tc0-0.035-0.012-0.048-0.019-0.067v0.016c-0.03,0.013-0.059,0.025-0.089,0.038c-0.017-0.006-0.034-0.013-0.051-0.019\r\n\t\t\t\tc-0.017-0.095-0.061-0.182-0.165-0.191c0.011-0.069,0.067-0.083,0.127-0.102c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.052-0.015-0.053-0.008-0.083-0.057c0.045-0.073,0.096-0.241,0.184-0.267v-0.07c0.028-0.011,0.055-0.021,0.083-0.032\r\n\t\t\t\tc-0.002,0.011-0.004,0.021-0.006,0.032c0.013,0.006,0.025,0.013,0.038,0.019h0.006c0.028-0.036,0.033-0.028,0.025-0.076\r\n\t\t\t\tc0.011-0.009,0.021-0.017,0.032-0.025c-0.004,0.015-0.008,0.03-0.013,0.044c0.017,0.004,0.034,0.008,0.051,0.013\r\n\t\t\t\tc0.008-0.021,0.017-0.042,0.025-0.064c0.013,0.008,0.025,0.017,0.038,0.025c0.059-0.044,0.113-0.149,0.14-0.222h0.006\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c-0.008,0.021-0.017,0.042-0.025,0.064c0.002,0.004,0.004,0.008,0.006,0.013\r\n\t\t\t\tc0.027,0.008,0.055,0.017,0.083,0.025c-0.004-0.019-0.008-0.038-0.013-0.057c0.046,0.008,0.075-0.021,0.121-0.032\r\n\t\t\t\tc0.006,0.019,0.013,0.038,0.019,0.057c0.038-0.028,0.057-0.071,0.095-0.095c0.015,0.011,0.03,0.021,0.044,0.032\r\n\t\t\t\tc0.018-0.015,0.017-0.011,0.019-0.045c0.069,0.012,0.096-0.012,0.153-0.038c0.011-0.019,0.01-0.016,0.013-0.032h-0.051\r\n\t\t\t\tc0.011-0.015,0.021-0.03,0.032-0.045c-0.011-0.023-0.021-0.047-0.032-0.07c0.011,0.008,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.041-0.039,0.135-0.02,0.178,0.013c0.034-0.019,0.068-0.038,0.102-0.057c-0.006-0.013-0.013-0.026-0.019-0.038\r\n\t\t\t\tc0.023,0.013,0.047,0.025,0.07,0.038c0.139-0.017,0.194-0.143,0.343-0.146c0.013-0.023,0.025-0.047,0.038-0.07\r\n\t\t\t\tc-0.006-0.019-0.013-0.038-0.019-0.057c0.024,0.019,0.04,0.035,0.044,0.076c0.019-0.011,0.038-0.021,0.057-0.032h0.006\r\n\t\t\t\tc-0.025,0.065-0.104,0.124-0.172,0.146c-0.008,0.017-0.011,0.022-0.013,0.051c0.108-0.056,0.302-0.039,0.432-0.025\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.092-0.002-0.148,0.034-0.229,0.051v0.044c-0.023-0.018-0.019-0.021-0.044-0.025\r\n\t\t\t\tc0.002-0.023,0.004-0.047,0.006-0.07c-0.083-0.003-0.358,0.164-0.413,0.222h-0.013c0.011,0.006,0.021,0.013,0.032,0.019v0.006\r\n\t\t\t\tc-0.027,0.003-0.018,0.002-0.038-0.013c-0.04,0.023-0.08,0.047-0.121,0.07c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.03-0.019,0.059-0.038,0.089-0.057c-0.014,0.038-0.023,0.015-0.044,0.038\r\n\t\t\t\tc-0.076,0.082-0.026,0.172-0.006,0.26c0.015-0.005,0.009-0.003,0.025-0.019c0.019,0.032,0.038,0.064,0.057,0.095\r\n\t\t\t\tc0.048-0.01,0.046-0.012,0.076,0.019c0.009-0.023,0.017-0.047,0.026-0.07c0.035-0.016,0.053-0.017,0.108-0.013v-0.045\r\n\t\t\t\tc0.006,0.004,0.013,0.009,0.019,0.013c0.062-0.036,0.089-0.171,0.203-0.172c0.014-0.051-0.01-0.053-0.013-0.108h0.038\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032h0.006c0.023-0.015,0.034-0.023,0.045-0.051c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc-0.002,0.015-0.004,0.03-0.006,0.045c0.036,0.004,0.072,0.008,0.108,0.013c0.016-0.034,0.031-0.025,0.038-0.07\r\n\t\t\t\tc0.011,0.006,0.021,0.013,0.032,0.019c0.004-0.015,0.008-0.03,0.013-0.044c0.006-0.002,0.013-0.004,0.019-0.006\r\n\t\t\t\tc0.032,0.009,0.026,0.014,0.045,0.032c0.124-0.045,0.262-0.143,0.407-0.146c-0.002-0.009-0.004-0.017-0.006-0.025\r\n\t\t\t\tc0.032,0.002,0.064,0.004,0.095,0.006c-0.004-0.006-0.008-0.013-0.013-0.019c0.006-0.004,0.013-0.009,0.019-0.013\r\n\t\t\t\tc0.024-0.013,0.02-0.005,0.044,0.013c0.021-0.009,0.042-0.017,0.063-0.025c-0.027-0.034-0.068-0.036-0.133-0.032\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c0.013-0.007,0.025-0.013,0.038-0.019c0.006-0.008,0.013-0.017,0.019-0.025\r\n\t\t\t\tc-0.021-0.021-0.042-0.042-0.063-0.064c-0.075-0.027-0.112,0.044-0.133-0.064c-0.066,0.01-0.086,0.052-0.133,0.07\r\n\t\t\t\tc-0.032,0.012-0.073,0.004-0.095,0.013c0.006-0.013,0.013-0.025,0.019-0.038h-0.013c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.067-0.031-0.119,0.027-0.165,0.006c-0.019-0.013-0.038-0.025-0.057-0.038c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.028-0.013-0.04-0.048-0.083-0.057h-0.013v-0.006c0.025-0.009,0.051-0.017,0.076-0.025c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc-0.103-0.049-0.301-0.028-0.267-0.191c-0.021-0.028-0.018-0.025-0.044-0.019c-0.013-0.053-0.009-0.079,0.013-0.121\r\n\t\t\t\tc-0.03-0.032-0.094-0.029-0.159-0.025c0.088-0.089,0.103-0.048,0.133-0.178c0.021-0.021,0.042-0.042,0.064-0.064\r\n\t\t\t\tc-0.015-0.011-0.03-0.021-0.044-0.032c-0.019,0.008-0.038,0.017-0.057,0.025v-0.032c-0.055,0.025-0.11,0.051-0.165,0.076\r\n\t\t\t\tc-0.065-0.089-0.112-0.14-0.254-0.152v-0.007c0.049-0.015,0.115-0.056,0.191-0.038c0.034,0.015,0.068,0.03,0.102,0.045\r\n\t\t\t\tc0.079-0.006,0.346-0.155,0.375-0.216c-0.094-0.249-0.411-0.255-0.674-0.152c-0.282,0.11-0.595,0.189-0.82,0.356\r\n\t\t\t\tc-0.184,0.136-0.321,0.345-0.502,0.489c0.154-0.325,0.477-0.718,0.775-0.896c0.079-0.047,0.223-0.03,0.299-0.083\r\n\t\t\t\tc0.108-0.076,0.07-0.268,0.267-0.337c0.117-0.041,0.317-0.025,0.439-0.006c0.178,0.027,0.354-0.025,0.515-0.006\r\n\t\t\t\tc0.163,0.008,0.326,0.017,0.489,0.025c0.219-0.035,0.465-0.038,0.61-0.146c0.083-0.091,0.165-0.182,0.248-0.273\r\n\t\t\t\tc0.155-0.015,0.309-0.03,0.464-0.044c0.1-0.032,0.288-0.2,0.375-0.267v-0.013c-0.042-0.055-0.085-0.11-0.127-0.165\r\n\t\t\t\tc0.034-0.061,0.064-0.142,0.095-0.21c-0.007-0.1-0.158-0.181-0.248-0.197c-0.041-0.008-0.112,0.043-0.153,0.064\r\n\t\t\t\tc-0.013-0.019-0.025-0.038-0.038-0.057c0.008-0.044,0.031-0.064,0.051-0.095c-0.257-0.247-0.418,0.027-0.61,0.133\r\n\t\t\t\tc-0.089,0.05-0.218,0.06-0.305,0.095c0.012-0.069,0.034-0.173,0.083-0.21c0.053-0.004,0.106-0.008,0.159-0.013\r\n\t\t\t\tc0.109-0.031,0.157-0.136,0.28-0.165c0.122-0.029,0.24-0.033,0.292-0.127c-0.11-0.028-0.22-0.055-0.33-0.083\r\n\t\t\t\tc-0.106-0.044-0.191-0.133-0.324-0.153c-0.101-0.015-0.161,0.043-0.261,0.038c0.021-0.051,0.042-0.102,0.064-0.152\r\n\t\t\t\tc-0.007-0.092-0.237-0.273-0.311-0.299H12.48c-0.062-0.024-0.129-0.187-0.165-0.241c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.055-0.031,0.185,0.022,0.261,0c0.012-0.024,0.014-0.061,0.013-0.102c-0.084-0.062-0.178-0.095-0.242-0.178\r\n\t\t\t\tc0.027-0.025,0.057-0.044,0.102-0.051c-0.036-0.207-0.226-0.07-0.261-0.356c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.009-0.07,0.017-0.079,0.032-0.134c-0.122-0.141-0.365-0.561-0.508-0.629c-0.004-0.004-0.008-0.008-0.013-0.013\r\n\t\t\t\tc-0.021,0.042-0.042,0.085-0.064,0.127c-0.144,0.096-0.271,0.026-0.114,0.235c-0.096,0.122-0.182,0.158-0.184,0.388h-0.006\r\n\t\t\t\tc-0.051-0.051-0.057-0.152-0.153-0.159c-0.034,0.059-0.068,0.119-0.102,0.178c-0.077,0.058-0.266,0.055-0.349,0.095\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c0.014-0.022,0.019-0.03,0.019-0.07c-0.149-0.221-0.275-0.116-0.483-0.044h-0.006\r\n\t\t\t\tc-0.044-0.056-0.038-0.084-0.026-0.178c0.036,0.002,0.072,0.004,0.108,0.006c0.112-0.165-0.211-0.619,0.013-0.724\r\n\t\t\t\tc0.011-0.023,0.014-0.056,0.013-0.095c-0.011-0.017-0.021-0.034-0.032-0.051c-0.039-0.011-0.088,0.06-0.178,0.038\r\n\t\t\t\tc-0.162-0.039-0.31-0.129-0.458-0.159c-0.052-0.065-0.056-0.061-0.013-0.14c-0.022-0.016-0.052-0.042-0.077-0.062\r\n\t\t\t\tc0.109-0.188,0.225-0.372,0.338-0.557c0.01,0.006,0.021,0.007,0.031,0.015c0.006,0.003,0.064-0.003,0.102,0.013\r\n\t\t\t\tc0.028,0.017,0.055,0.034,0.083,0.051c0.049,0.006,0.097,0.013,0.146,0.019c0.04,0.047,0.081,0.093,0.121,0.14\r\n\t\t\t\tc0.094,0.057,0.203,0.032,0.331,0.064c0.203,0.072,0.407,0.144,0.61,0.216c-0.067-0.217-0.212-0.375-0.381-0.489\r\n\t\t\t\tc-0.155-0.104-0.443-0.179-0.47-0.4c0.186,0,0.218,0.082,0.343,0.127c-0.009-0.049-0.017-0.097-0.026-0.146\r\n\t\t\t\tc0.188,0.145,0.277,0.375,0.604,0.349c0.069,0.109,0.145,0.196,0.273,0.248c-0.038-0.078-0.076-0.157-0.114-0.235\r\n\t\t\t\tc0.04,0.008,0.08,0.017,0.121,0.025h0.006c-0.006-0.184-0.176-0.25-0.153-0.432c0.084,0.057,0.177,0.169,0.216,0.267\r\n\t\t\t\tc0.008,0.006,0.017,0.013,0.025,0.019c0.037-0.334-0.178-0.289-0.292-0.477c0.006-0.013,0.013-0.026,0.019-0.038\r\n\t\t\t\tc0.025-0.006,0.051-0.013,0.076-0.019h0.013c-0.061-0.03-0.123-0.059-0.184-0.089c-0.069-0.041-0.11-0.13-0.191-0.153\r\n\t\t\t\tc-0.019,0.015-0.038,0.03-0.057,0.044c-0.008,0.008-0.017,0.017-0.025,0.026c-0.071-0.122-0.147-0.253-0.21-0.388\r\n\t\t\t\tc-0.053-0.009-0.106-0.017-0.159-0.025c-0.006-0.014-0.012-0.027-0.019-0.04c0.024-0.035,0.051-0.067,0.076-0.101\r\n\t\t\t\tc0.001,0.003,0.005,0.005,0.006,0.008c0.04-0.004,0.081-0.009,0.121-0.013c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.022-0.025-0.045-0.05-0.067-0.075c0.044-0.062,0.092-0.121,0.137-0.183c0.134,0.06,0.208,0.164,0.343,0.226\r\n\t\t\t\tc0.072,0.033,0.155,0.015,0.21,0.051c-0.013,0.036-0.025,0.072-0.038,0.108c0.005,0.082,0.057,0.11,0.089,0.165\r\n\t\t\t\tc0.042-0.019,0.085-0.038,0.127-0.057c0.033,0.038,0.022,0.078,0.051,0.127c0.022,0.036,0.201,0.12,0.248,0.102h0.013\r\n\t\t\t\tc-0.015-0.064-0.03-0.127-0.045-0.191c0.011-0.076,0.021-0.153,0.032-0.229c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.036,0.05,0.089,0.124,0.159,0.14c0.035-0.09,0.113-0.136,0.222-0.152c-0.011-0.088-0.097-0.155-0.165-0.184\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.15-0.095,0.182,0.061,0.324,0c0.025-0.019,0.058-0.097,0.089-0.127\r\n\t\t\t\tc0.002-0.006,0.004-0.013,0.006-0.019c-0.087-0.061-0.174-0.123-0.261-0.184c-0.092,0.084-0.164,0.079-0.299,0.051\r\n\t\t\t\tc0.013-0.043,0.025-0.085,0.038-0.127c-0.147-0.013-0.29,0.025-0.47,0.026v-0.095c0.061-0.015,0.123-0.03,0.184-0.044h0.013\r\n\t\t\t\tc-0.051-0.098-0.165-0.231-0.267-0.273c-0.037-0.015-0.062-0.003-0.087,0.008c0.618-0.794,1.268-1.56,1.972-2.276\r\n\t\t\t\tc0.027,0.005,0.054,0.009,0.08,0.014c0.042,0.011,0.084,0.021,0.127,0.032c0.022-0.003,0.044-0.006,0.065-0.009\r\n\t\t\t\tc0.003,0,0.005,0,0.008,0c0.003,0.007,0.006,0.014,0.01,0.022c0.02,0.004,0.051,0.001,0.079-0.002\r\n\t\t\t\tc0.003,0.003,0.005,0.006,0.008,0.008c-0.045,0.019-0.061,0.016-0.102,0.01c-0.025,0.007-0.079,0.031-0.085,0.046\r\n\t\t\t\tc-0.01,0.04,0.124,0.116,0.183,0.098c0.044-0.017,0.087-0.034,0.131-0.051c0.058-0.019,0.1-0.003,0.157-0.022\r\n\t\t\t\tc0.096-0.031,0.196-0.098,0.229-0.154c0.053-0.088-0.124-0.137-0.191-0.155c-0.063-0.017-0.099-0.061-0.143-0.099\r\n\t\t\t\tc-0.051-0.044-0.123-0.071-0.209-0.083c0.015-0.015,0.032-0.028,0.047-0.043c0.017,0.003,0.035,0.009,0.05,0.01\r\n\t\t\t\tc0.011-0.005,0.009-0.006,0.015-0.011c0.018-0.001,0.036-0.001,0.055-0.002c0.098,0.013,0.166,0.087,0.242,0.125\r\n\t\t\t\tc0.058,0.029,0.126,0.035,0.206,0.042c0.022,0.002,0.033,0.013,0.057,0.012c0.021-0.022,0.037-0.048,0.097-0.049\r\n\t\t\t\tc0.002,0.002,0.005,0.004,0.007,0.005c0.001,0.001,0.003,0.003,0.004,0.004c-0.009,0.006-0.019,0.012-0.028,0.019\r\n\t\t\t\tc0.003,0.004,0.006,0.009,0.01,0.013c0.082-0.002,0.101-0.036,0.149-0.053c0.04-0.014,0.063,0.003,0.095-0.008\r\n\t\t\t\tc-0.012,0.025-0.046,0.04-0.061,0.063c-0.015,0.023-0.012,0.045-0.025,0.07c-0.007,0.014-0.031,0.02-0.038,0.036\r\n\t\t\t\tc0.01,0.019,0.049,0.027,0.043,0.05c-0.003,0.006-0.051,0.024-0.06,0.026c0,0.019-0.02,0.038-0.005,0.057\r\n\t\t\t\tc0.01,0.008,0.024,0.008,0.042,0.007c0.003,0.002,0.006,0.003,0.009,0.005c-0.017,0.009-0.038,0.017-0.052,0.026\r\n\t\t\t\tc-0.001,0.018,0.024,0.052,0.013,0.071c-0.012,0.019-0.048,0.03-0.06,0.051c0,0.001,0,0.001,0,0.002\r\n\t\t\t\tc0.084-0.011,0.07-0.036,0.138-0.055c0.04,0.003,0.027,0.022,0.052,0.038c0.012,0.003,0.025,0.006,0.037,0.01\r\n\t\t\t\tc0.001,0.001,0.002,0.002,0.004,0.003c0,0.002,0,0.005,0,0.007c-0.016,0.04-0.137,0.028-0.188,0.046\r\n\t\t\t\tc-0.007,0.004-0.065,0.071-0.067,0.078c0.003,0.008,0.005,0.016,0.008,0.024c-0.011,0.012-0.022,0.025-0.032,0.038\r\n\t\t\t\tc-0.019,0.031-0.038,0.062-0.057,0.092c0.074-0.015,0.084-0.049,0.159-0.064c0.061,0.021,0.023,0.086-0.02,0.107\r\n\t\t\t\tc-0.029,0.014-0.071,0.006-0.102,0.011c-0.063,0.01-0.105,0.042-0.185,0.049c-0.054,0.004-0.117-0.01-0.169,0.006\r\n\t\t\t\tc-0.118,0.035-0.158,0.131-0.289,0.172c0.034,0.002,0.095,0.005,0.125,0.003c0.039-0.009,0.078-0.018,0.118-0.027\r\n\t\t\t\tc0.023,0.004,0.047,0.008,0.07,0.012c0.05,0.008,0.104,0.007,0.161,0.008c0.03-0.031,0.065-0.027,0.119-0.048\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.006c0-0.015-0.011-0.025-0.03-0.026c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.021-0.031,0.098-0.036,0.127-0.016c0.007,0.042-0.069,0.055-0.07,0.092c-0.002,0.059,0.172,0.07,0.202,0.108\r\n\t\t\t\tc-0.014,0.005-0.016,0.007-0.013,0.017c-0.062-0.014-0.133-0.027-0.211-0.024c-0.053,0.005-0.106,0.01-0.159,0.015\r\n\t\t\t\tc-0.058,0-0.109-0.014-0.16-0.022c-0.067-0.011-0.133-0.021-0.2-0.032c-0.003,0.001-0.007,0.001-0.01,0.002\r\n\t\t\t\tc-0.003,0.006-0.007,0.012-0.01,0.018c0,0.026,0.154,0.053,0.194,0.053c0.012,0.005,0.034,0.016,0.012,0.028\r\n\t\t\t\tc-0.041,0.017-0.145-0.037-0.22-0.018c-0.111,0.028-0.099,0.092-0.137,0.146c-0.027,0.036-0.054,0.071-0.081,0.107\r\n\t\t\t\tc-0.003,0.008,0.004,0.014,0.009,0.02c0.107,0.021,0.169-0.081,0.21-0.108c0.029-0.009,0.058-0.018,0.086-0.026\r\n\t\t\t\tc0.066-0.032,0.111-0.067,0.214-0.086c-0.003,0.016-0.019,0.023-0.018,0.04c0.034,0.031,0.073,0.012,0.142,0.008\r\n\t\t\t\tc0.019,0,0.038-0.001,0.058-0.001c0.029-0.02,0.092-0.051,0.055-0.082c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.073-0.008,0.116-0.013,0.164,0.002c0.001,0.002,0.001,0.004,0.002,0.006c-0.029,0.03-0.094,0.055-0.093,0.094\r\n\t\t\t\tc0.024,0.013,0.055,0.015,0.064,0.043c-0.107,0.003-0.221,0.01-0.318,0.003c-0.048-0.004-0.097-0.025-0.149-0.02\r\n\t\t\t\tc-0.05,0.005-0.095,0.041-0.126,0.057c-0.053,0.028-0.107,0.056-0.16,0.084c-0.031,0.011-0.061,0.023-0.092,0.034\r\n\t\t\t\tc-0.026,0.023-0.052,0.046-0.077,0.07c0.097,0.037,0.343-0.041,0.494-0.055c0.031-0.005,0.062-0.01,0.093-0.014\r\n\t\t\t\tc0.025,0.006,0.05,0.012,0.074,0.017c0.027-0.002,0.053-0.004,0.08-0.005c0.071,0.006,0.103,0.061,0.143,0.099\r\n\t\t\t\tc-0.048-0.007-0.096-0.013-0.143-0.019c-0.175-0.014-0.382-0.023-0.599,0.048c-0.044,0.013-0.088,0.026-0.132,0.039\r\n\t\t\t\tc0.033,0.026,0.093,0.01,0.126,0.031c0.015,0.022,0.03,0.043,0.045,0.065c0.009,0.006,0.187,0.026,0.212,0.028\r\n\t\t\t\tc0.027-0.007,0.031-0.019,0.051-0.03c0.071-0.01,0.102,0.049,0.058,0.079c-0.07,0.047-0.247,0.037-0.329,0.081\r\n\t\t\t\tc-0.002,0-0.003,0.001-0.005,0.001c0.03,0.018,0.163,0.033,0.21,0.036c-0.003,0.003-0.155,0.049-0.161,0.049\r\n\t\t\t\tc-0.041,0.003-0.061-0.021-0.109,0.004c-0.042,0.022-0.094,0.081-0.039,0.115c0.01,0.006,0.061,0.009,0.061,0.018\r\n\t\t\t\tc0.001,0.014-0.046,0.027-0.052,0.042c-0.006,0.028,0.035,0.04,0.072,0.026c0.049-0.018,0.116-0.057,0.149-0.083\r\n\t\t\t\tc0.068-0.052,0.139-0.105,0.219-0.153c0.026-0.012,0.052-0.023,0.078-0.035c0.04-0.037,0.08-0.074,0.119-0.111\r\n\t\t\t\tc0.043-0.03,0.109-0.051,0.168-0.075c0.037-0.015,0.07-0.028,0.113-0.042c0.041-0.009,0.082-0.018,0.123-0.027\r\n\t\t\t\tc0.021-0.007,0.051-0.021,0.08-0.02c0.023,0.007,0.047,0.013,0.07,0.02c-0.022,0.019-0.042,0.053-0.07,0.067\r\n\t\t\t\tc-0.075,0.036-0.22,0.019-0.315,0.037c-0.025,0.043-0.11,0.069-0.158,0.098c-0.009,0.008-0.002,0.019-0.007,0.028\r\n\t\t\t\tc-0.013,0.026-0.056,0.051-0.112,0.061c0.003,0.009,0.006,0.018,0.009,0.026c-0.158,0.057-0.262,0.142-0.375,0.215\r\n\t\t\t\tc-0.03,0.019-0.109,0.042-0.12,0.068c-0.012,0.015,0.009,0.03,0.021,0.039c0.065,0.049,0.103,0.014,0.195-0.009\r\n\t\t\t\tc-0.019,0.04-0.065,0.091-0.144,0.109c-0.001,0.005-0.002,0.009-0.003,0.014c0.052,0.027,0.141,0.031,0.175-0.022\r\n\t\t\t\tc0.113-0.018,0.086,0.118,0.06,0.151c0.003,0.005,0.006,0.006,0.012,0.013c0.055-0.019,0.148-0.049,0.186-0.075\r\n\t\t\t\tc0.004-0.001,0.008-0.002,0.012-0.002c0.002,0.001,0.004,0.001,0.006,0.002c0.001,0.002,0.001,0.004,0.002,0.006\r\n\t\t\t\tc-0.05,0.055-0.176,0.082-0.215,0.141c0.012,0.026,0.047,0.037,0.078,0.043c0.037-0.003,0.063-0.022,0.086-0.035\r\n\t\t\t\tc0.013,0.011,0.023,0.019,0.028,0.038l-0.049,0.069c-0.008,0.002-0.017,0.003-0.025,0.005c0.026,0.048,0.092,0.004,0.15,0.016\r\n\t\t\t\tc0.032,0.007,0.037,0.052,0.057,0.069c-0.179,0.032-0.096,0.172-0.138,0.254c-0.009,0.019-0.043,0.094-0.017,0.116\r\n\t\t\t\tc0.006,0.006,0.01,0.008,0.021,0.009c0.036,0,0.069-0.044,0.086-0.058c0.047-0.038,0.105-0.089,0.124-0.137\r\n\t\t\t\tc-0.001-0.015-0.003-0.029-0.004-0.044c0.001-0.019,0.025-0.055,0.047-0.067c0.006-0.002,0.011-0.003,0.017-0.005\r\n\t\t\t\tc0.034,0.014,0.057,0.047,0.075,0.077c0.002,0,0.004,0,0.006,0.001c0.011-0.016,0.023-0.032,0.034-0.048\r\n\t\t\t\tc-0.003-0.046-0.006-0.093-0.009-0.14c0.001-0.041,0.018-0.075,0.027-0.11c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.023,0.013,0.046,0.027,0.069,0.04c0.012,0.015-0.004,0.03-0.005,0.042c-0.002,0.033,0.023,0.085,0.059,0.092\r\n\t\t\t\tc0.037,0.007,0.092-0.018,0.131-0.027c0.005,0.037,0.052,0.138,0.083,0.157c0.029,0.009,0.057,0.019,0.086,0.029\r\n\t\t\t\tc0.033,0.016,0.053,0.039,0.077,0.065c0.001,0.003,0.002,0.005,0.003,0.008c-0.08,0.005-0.209-0.043-0.25-0.08\r\n\t\t\t\tc-0.027-0.024-0.028-0.082-0.07-0.091c-0.061-0.014-0.142,0.044-0.163,0.066c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc0.02,0.01,0.078,0.031,0.064,0.059c-0.007,0.019-0.053,0.031-0.075,0.044c-0.062,0.036-0.11,0.071-0.19,0.104\r\n\t\t\t\tc-0.027,0.011-0.089,0.021-0.104,0.038c0.022,0.035,0.111,0.043,0.185,0.018c0.087-0.037,0.175-0.073,0.262-0.11\r\n\t\t\t\tc0.013-0.012,0.026-0.024,0.038-0.036c0.017,0.036,0.059,0.046,0.081,0.071c-0.024,0.009-0.063,0.011-0.098,0.022\r\n\t\t\t\tc-0.09,0.027-0.188,0.048-0.269,0.081c-0.035,0.015-0.092,0.041-0.134,0.034c0.005,0.043,0.049,0.052,0.057,0.092\r\n\t\t\t\tc0.009-0.001,0.019-0.001,0.028-0.002c0,0.002,0.001,0.003,0.001,0.005c-0.015,0.021-0.059,0.025-0.1,0.034\r\n\t\t\t\tc-0.001,0.003-0.002,0.006-0.002,0.009c0.071,0.035,0.051,0.061,0.071,0.126c0.078,0.018,0.126-0.035,0.181-0.058\r\n\t\t\t\tc0.036-0.015,0.083-0.023,0.132-0.032c-0.069,0.057-0.138,0.115-0.207,0.173c0.001,0.002,0.002,0.005,0.003,0.008\r\n\t\t\t\tc0.058,0.008,0.109-0.033,0.173-0.036c0.069-0.004,0.128,0.034,0.115,0.093c-0.012,0.053-0.138,0.066-0.08,0.133\r\n\t\t\t\tc0.048,0.01,0.079-0.016,0.127-0.014c0.002,0,0.003-0.001,0.005-0.001c-0.008,0.023-0.056,0.064-0.035,0.086\r\n\t\t\t\tc0,0.001,0.001,0.002,0.001,0.003c0.108-0.031,0.124-0.099,0.202-0.141c0.009,0.002,0.017,0.004,0.026,0.007\r\n\t\t\t\tc0.001,0.027-0.032,0.057-0.047,0.081c-0.042,0.065-0.084,0.13-0.126,0.195c-0.029,0.051,0.007,0.108,0.077,0.123\r\n\t\t\t\tc0.05,0,0.1,0,0.15,0c0.05,0.005,0.1,0.01,0.15,0.014c0.012,0.017,0.027,0.044,0.031,0.062c-0.019,0.015-0.049,0.031-0.085,0.039\r\n\t\t\t\tc0.002,0.01,0.001,0.012-0.009,0.02c0.009,0.017,0.026,0.022,0.046,0.028c0.037-0.01,0.093-0.026,0.121-0.041\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.007,0.012c-0.008,0.012-0.025,0.015-0.043,0.023c-0.061,0.029-0.098,0.044-0.103,0.095\r\n\t\t\t\tc0.112-0.018,0.147-0.073,0.235-0.096c0.023,0.072-0.093,0.095-0.116,0.152c0.011,0.023,0.039,0.022,0.053,0.041\r\n\t\t\t\tc-0.039,0.015-0.064,0.034-0.097,0.049c0.041,0.037,0.102,0.063,0.19,0.023c0.008-0.005,0.016-0.011,0.024-0.016\r\n\t\t\t\tc0.023-0.009,0.031,0.008,0.05,0c0.045-0.018,0.029-0.058,0.122-0.037c0,0.002,0.001,0.003,0.002,0.005\r\n\t\t\t\tc-0.013,0.033-0.073,0.046-0.136,0.061c0.058,0.029,0.233,0.015,0.271,0.055c0.036,0.037-0.063,0.081-0.014,0.117\r\n\t\t\t\tc0.006,0.002,0.012,0.001,0.023-0.001c0.028-0.024,0.047-0.046,0.101-0.061c0.008,0.002,0.015,0.004,0.023,0.006\r\n\t\t\t\tc0.006,0.033,0.035,0.061,0.034,0.088c-0.001,0.032-0.072,0.06-0.133,0.07c0.072,0.019,0.181,0.032,0.277,0\r\n\t\t\t\tc-0.001-0.01-0.006-0.026,0.007-0.035c0.001,0,0.002,0,0.003,0c0.025-0.008,0.049-0.015,0.074-0.023\r\n\t\t\t\tc0.018-0.009,0.018-0.024,0.048-0.029c0.001,0,0.002,0,0.003,0s0.002,0,0.002,0c0.001,0,0.002,0,0.003-0.001\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0c0.032-0.001,0.061,0.018,0.104,0.004c0.031-0.018,0.062-0.035,0.094-0.053\r\n\t\t\t\tc0.044-0.016,0.092,0.019,0.092-0.034c0.064,0.001,0.128-0.025,0.114-0.063c-0.096-0.034-0.03-0.068,0.043-0.095\r\n\t\t\t\tc0.035,0.012,0.033,0.039,0.06,0.062c0.009,0.008,0.023,0.008,0.03,0.019c-0.036,0.036-0.115,0.1-0.125,0.14\r\n\t\t\t\tc0.023-0.018,0.04-0.047,0.076-0.059c0.023-0.008,0.049-0.002,0.073-0.012c0.024-0.019,0.048-0.037,0.072-0.055\r\n\t\t\t\tc0.008,0.022,0.018,0.041,0.034,0.055c0.013,0.012,0.052,0.019,0.053,0.04c0.001,0.034-0.057,0.046-0.088,0.07\r\n\t\t\t\tc-0.018,0.014-0.016,0.041-0.034,0.057c-0.035,0.025-0.07,0.05-0.105,0.075c0,0,0,0.001,0.001,0.002\r\n\t\t\t\tc0.032-0.001,0.055-0.016,0.087-0.017c0.02,0.011,0.033,0.028,0.047,0.046c0.002,0.001,0.004,0.002,0.006,0.002\r\n\t\t\t\tc0.075-0.019,0.046-0.092,0.085-0.126c0.041-0.013,0.102-0.007,0.101,0.026c-0.001,0.043-0.072,0.076-0.03,0.132\r\n\t\t\t\tc0.056,0.007,0.091-0.071,0.108-0.096c0.011-0.016,0.04-0.031,0.063-0.042c-0.021,0.042-0.041,0.083-0.062,0.125\r\n\t\t\t\tc0.006-0.001,0.012-0.002,0.017-0.003c0.053,0.045-0.139,0.11-0.08,0.183c0.052,0.007,0.11-0.041,0.178-0.037\r\n\t\t\t\tc0.043,0.002,0.057,0.042,0.094,0.052c0.006-0.001,0.012-0.002,0.017-0.003c0.057-0.029,0.042-0.124,0.109-0.141\r\n\t\t\t\tc0.08-0.02,0.159,0.014,0.22,0.018c0.039-0.001,0.078-0.003,0.117-0.004c0.03,0.001,0.076,0.02,0.11-0.001\r\n\t\t\t\tc0.013-0.009,0.015-0.023,0.02-0.035c0.036-0.085-0.093-0.067-0.067-0.122c-0.041,0.011-0.059,0.029-0.089,0.042\r\n\t\t\t\tc-0.065,0.028-0.129-0.005-0.144-0.044c0.136-0.026,0.396-0.115,0.395-0.18c-0.021,0.001-0.042,0.001-0.063,0.002\r\n\t\t\t\tc-0.034,0.009-0.058,0.035-0.104,0.036c-0.051,0.002-0.124-0.029-0.138-0.067c0.064-0.012,0.128-0.025,0.185-0.032\r\n\t\t\t\tc-0.019-0.013-0.058-0.022-0.087-0.023c-0.003-0.002-0.006-0.003-0.01-0.005c0.031-0.01,0.075-0.019,0.101-0.029\r\n\t\t\t\tc0.034-0.059-0.048-0.07,0.054-0.117c0-0.003,0-0.005,0-0.008c-0.048-0.03-0.174,0.004-0.201-0.043\r\n\t\t\t\tc-0.008-0.014,0.003-0.029,0.009-0.038c0.034-0.053,0.14-0.038,0.185-0.014c0.017-0.003,0.026-0.005,0.033-0.011\r\n\t\t\t\tc0.019-0.014,0.036-0.1,0.012-0.124c0.044-0.024,0.037-0.052,0.056-0.086c0.01-0.01,0.02-0.02,0.03-0.031\r\n\t\t\t\tc-0.041,0.006-0.092,0.025-0.124,0.016l-0.008-0.015c0.097-0.014,0.14-0.081,0.167-0.127c-0.03-0.052-0.1-0.085-0.104-0.156\r\n\t\t\t\tc-0.112-0.018-0.212-0.043-0.286-0.1c0.086-0.011,0.213,0.059,0.274,0.031c0.002-0.001,0.005-0.002,0.007-0.003\r\n\t\t\t\tc-0.001-0.003-0.002-0.005-0.003-0.008c-0.042-0.016-0.114-0.015-0.143-0.042c-0.025-0.024-0.027-0.071-0.049-0.092\r\n\t\t\t\tc0.047-0.029,0.093-0.059,0.14-0.088c0.046-0.019,0.099-0.029,0.134-0.05c-0.008-0.009-0.016-0.018-0.025-0.027\r\n\t\t\t\tc-0.005-0.014-0.011-0.028-0.016-0.042c-0.03-0.035-0.107-0.073-0.064-0.124c0-0.001-0.001-0.002-0.001-0.003\r\n\t\t\t\tc0.036,0.017,0.147,0.055,0.204,0.044c-0.001-0.003-0.002-0.005-0.003-0.008c0.006-0.008,0.012-0.008,0.012-0.019\r\n\t\t\t\tc-0.034-0.018-0.117-0.048-0.111-0.082c0.001-0.001,0.003-0.002,0.004-0.003c0.046,0.004,0.07,0.02,0.12,0.02\r\n\t\t\t\tc0.021-0.009,0.035-0.019,0.033-0.036c-0.026-0.023-0.065-0.029-0.091-0.051c0.001-0.002,0.002-0.005,0.003-0.007\r\n\t\t\t\tc0.035-0.01,0.079,0.009,0.106-0.015c0.019-0.013,0.014-0.041,0.035-0.055c0.018-0.012,0.068-0.012,0.091-0.021\r\n\t\t\t\tc0.015-0.022,0.003-0.047-0.001-0.075c-0.068,0.036-0.136,0.006-0.192,0.002c-0.019,0-0.038,0.001-0.058,0.001\r\n\t\t\t\tc-0.021-0.005-0.042-0.024-0.057-0.036c0,0,0-0.001,0-0.002c0.047,0,0.084,0.013,0.126,0.016\r\n\t\t\t\tc0.044-0.001,0.088-0.001,0.131-0.002c0.028-0.001,0.09-0.009,0.1-0.024c0.026-0.037-0.037-0.077-0.065-0.092\r\n\t\t\t\tc-0.023-0.013-0.046-0.027-0.069-0.04c-0.012-0.013-0.024-0.025-0.036-0.038c-0.018-0.01-0.063-0.003-0.087-0.007\r\n\t\t\t\tc-0.051-0.015-0.102-0.031-0.152-0.046c0.035-0.013,0.071-0.026,0.106-0.039c0.054-0.022,0.094-0.056,0.147-0.073\r\n\t\t\t\tc0.065-0.021,0.098,0.007,0.147-0.018c-0.003-0.033-0.056-0.036-0.075-0.06c0.04-0.014,0.032-0.041,0.033-0.07\r\n\t\t\t\tC18.58,15.989,18.564,16,18.55,15.989c-0.01-0.017-0.02-0.034-0.03-0.051c-0.015-0.01-0.031-0.019-0.047-0.029\r\n\t\t\t\tc-0.088-0.043-0.195,0.005-0.197-0.102c-0.016-0.007-0.033-0.014-0.049-0.021c0.207-0.079,0.173-0.008,0.319,0\r\n\t\t\t\tc0.03-0.008,0.081-0.026,0.102-0.043c0.038-0.03,0.094-0.146,0.023-0.187c-0.046-0.027-0.126-0.019-0.183-0.035l-0.005,0.001\r\n\t\t\t\tc0,0,0-0.001-0.001-0.002c0.156-0.015,0.143-0.03,0.163-0.114c0.004-0.003,0.009-0.005,0.013-0.007c0.003,0,0.005,0,0.008,0\r\n\t\t\t\tc0.029,0.023,0.044,0.049,0.091,0.053c0.011,0.002,0.008-0.002,0.02-0.004c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.017-0.036-0.034-0.072-0.051-0.108c0.001-0.001,0.003-0.002,0.005-0.003c0.035,0.01,0.044,0.023,0.074,0.039\r\n\t\t\t\tc0.01,0.002,0.021,0.004,0.031,0.006c0.009,0.009,0.018,0.019,0.028,0.028c0.03,0.017,0.13,0.009,0.165-0.018\r\n\t\t\t\tc0.031-0.024,0.019-0.064,0.056-0.086c0.014-0.008,0.03-0.006,0.037,0.001c0.13-0.104-0.137-0.115-0.131-0.166\r\n\t\t\t\tc0.002-0.017,0.048-0.033,0.064-0.046c0.043-0.032,0.089-0.076,0.116-0.114c-0.009,0-0.018-0.001-0.027-0.001\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.004c0.05-0.023,0.021-0.065,0.001-0.1c0.055,0.009,0.141,0.024,0.224-0.01\r\n\t\t\t\tc-0.032,0.049-0.038,0.104-0.065,0.156c-0.017,0.033-0.065,0.069-0.066,0.104c0.008,0.011,0.016,0.021,0.024,0.032\r\n\t\t\t\tc0.015,0.03-0.047,0.071-0.007,0.098c0.021,0.016,0.068,0.009,0.106,0.008c0.001,0,0.002,0,0.002,0\r\n\t\t\t\tc-0.004-0.037,0.007-0.078-0.028-0.11c0.083-0.005,0.124-0.07,0.134-0.107c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.022,0.02,0.027,0.067,0.068,0.07c0.003,0,0.007,0,0.01,0c0.055-0.028,0.102-0.093,0.119-0.136\r\n\t\t\t\tc-0.006-0.004-0.012-0.009-0.018-0.013c0.001,0,0.002,0,0.003,0c0.045,0.009,0.167,0.05,0.2-0.008\r\n\t\t\t\tc0.002-0.031,0.004-0.063,0.006-0.094c0.012-0.023,0.053-0.042,0.051-0.069c0.004-0.047-0.125-0.031-0.121-0.087\r\n\t\t\t\tc0.012-0.034,0.201-0.025,0.247-0.027c0.022,0.013,0.039,0.036,0.067,0.044c0.065-0.002,0.086-0.04,0.101-0.069\r\n\t\t\t\tc0.032-0.059,0.046-0.123,0.077-0.184c0.014-0.028,0.029-0.056,0.043-0.085c0.008-0.021-0.001-0.073-0.025-0.093\r\n\t\t\t\tc-0.006-0.002-0.003-0.002-0.013-0.001c0.018-0.037,0.066-0.059,0.078-0.1c-0.014-0.01-0.028-0.02-0.042-0.03\r\n\t\t\t\tc-0.026-0.028-0.037-0.094-0.024-0.122c0.013-0.028,0.059-0.047,0.07-0.077c0.014-0.038-0.033-0.077-0.004-0.117\r\n\t\t\t\tc0.02-0.027,0.112-0.04,0.135-0.086c0.002-0.016,0.004-0.032,0.005-0.048c0.016-0.031,0.132-0.113,0.06-0.153\r\n\t\t\t\tc-0.023-0.013-0.064-0.006-0.096-0.01c-0.002,0-0.003,0.001-0.005,0.001c0.016-0.009,0.034-0.011,0.039-0.024\r\n\t\t\t\tc0.017-0.065-0.146-0.086-0.173-0.118c0.009-0.012,0.018-0.025,0.027-0.037c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.031,0.059,0.15,0.093,0.239,0.092c0.045,0,0.091-0.01,0.128-0.003c0.046,0.009,0.076,0.04,0.128,0.044\r\n\t\t\t\tc0.046,0.004,0.173-0.02,0.191-0.045c-0.003-0.044-0.086-0.053-0.114-0.083c0.091,0.005,0.077-0.035,0.134,0.031\r\n\t\t\t\tc0.041,0.007,0.101-0.012,0.116-0.034c0.001-0.052-0.066-0.084-0.058-0.137c0.005-0.005,0.011-0.01,0.016-0.015\r\n\t\t\t\tc0.03,0.025,0.076,0.076,0.147,0.053c0.075-0.023,0.014-0.08,0.073-0.109c0.046-0.014,0.093-0.029,0.139-0.043\r\n\t\t\t\tc0.048-0.025,0.083-0.063,0.134-0.089c0.033-0.013,0.065-0.027,0.098-0.04c0.023-0.014,0.024-0.037,0.052-0.051\r\n\t\t\t\tc0.052-0.027,0.165-0.104,0.16-0.147c0.013,0,0.026-0.001,0.039-0.001c0.009-0.007,0.007-0.015,0.014-0.021\r\n\t\t\t\tc0.024-0.02,0.098-0.01,0.069-0.046c-0.007-0.009-0.015-0.014-0.02-0.028c0.02-0.022,0.045-0.041,0.1-0.051\r\n\t\t\t\tc-0.003-0.01-0.007-0.02-0.01-0.03c0.004-0.01,0.018-0.015,0.036-0.02c0.005-0.043-0.016-0.072-0.045-0.098\r\n\t\t\t\tc0.008-0.035,0.079-0.049,0.107-0.077c0-0.029-0.031-0.052-0.063-0.055c0.037-0.037,0.131-0.031,0.146-0.078\r\n\t\t\t\tc-0.024-0.02-0.058-0.024-0.069-0.057c0.023-0.025,0.075-0.06,0.135-0.054c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.033-0.02-0.066-0.041-0.099-0.061c-0.089-0.081,0.158-0.142,0.204-0.197c-0.022,0.004-0.029,0-0.037-0.01\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.002c0,0,0-0.001-0.001-0.002c0.032-0.002,0.069,0.005,0.1-0.008\r\n\t\t\t\tc0.004-0.004,0.008-0.007,0.012-0.011c-0.001-0.024-0.034-0.036-0.057-0.044c-0.007-0.043,0.064-0.091,0.107-0.117\r\n\t\t\t\tc0.015,0.003,0.03,0.006,0.045,0.009c-0.008-0.04-0.016-0.08-0.024-0.12c-0.038,0.015-0.036,0.038-0.061,0.057\r\n\t\t\t\tc-0.04,0.031-0.1,0.067-0.155,0.09c-0.046,0.018-0.166,0.053-0.22,0.054c-0.055,0.001-0.099-0.006-0.169,0.007\r\n\t\t\t\tc-0.086,0.017-0.192,0.071-0.27,0.055c-0.009-0.018-0.019-0.035-0.028-0.053c-0.001,0-0.002,0-0.003,0.001\r\n\t\t\t\tc-0.072,0.055-0.152,0.123-0.2,0.186c-0.031,0.04-0.06,0.078-0.102,0.114c-0.038,0.032-0.043,0.082-0.099,0.107\r\n\t\t\t\tc-0.053,0.023-0.122,0.012-0.178,0.027c-0.003,0-0.006-0.001-0.008-0.002c-0.047-0.023-0.103,0.025-0.159,0.03\r\n\t\t\t\tc-0.014-0.012-0.007-0.021,0.003-0.032c0.022-0.023,0.056-0.047,0.12-0.051c0.022-0.001,0.054-0.002,0.075-0.013\r\n\t\t\t\tc0.068-0.034,0.046-0.111,0.096-0.141c0.031-0.019,0.151-0.057,0.162-0.078c0.014-0.025-0.022-0.049-0.044-0.053\r\n\t\t\t\tc-0.04,0.008-0.037,0.022-0.06,0.033l-0.116,0.034c-0.082,0.034-0.185,0.115-0.294,0.118c-0.015-0.011-0.018-0.03-0.038-0.036\r\n\t\t\t\tc-0.051,0.004-0.131,0.08-0.148,0.105c-0.006,0.001-0.012,0.001-0.018,0.002c-0.003,0-0.005,0-0.008,0\r\n\t\t\t\tc-0.046-0.074,0.259-0.214,0.154-0.309c-0.031-0.028-0.086-0.028-0.126-0.046c0.103-0.026,0.206-0.053,0.309-0.079\r\n\t\t\t\tc0.011-0.005,0.016-0.012,0.017-0.022c0.05-0.019,0.101-0.031,0.138-0.055c0.04-0.026,0.15-0.164,0.158-0.201\r\n\t\t\t\tc0.003-0.016-0.028-0.058-0.042-0.07c-0.016-0.014-0.044-0.019-0.068-0.024c-0.11-0.022-0.111,0.021-0.198,0.048\r\n\t\t\t\tc-0.092,0.028-0.168-0.001-0.196,0.069c-0.047,0.001-0.074-0.025-0.115-0.028c-0.045-0.003-0.093,0.034-0.122,0.047\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0c0,0,0-0.001-0.001-0.002c0.016-0.039,0.101-0.058,0.108-0.097c0.007-0.042-0.147-0.072-0.199-0.067\r\n\t\t\t\tc-0.027,0.007-0.053,0.015-0.08,0.022c-0.065,0.001-0.133-0.039-0.158-0.08c0.031-0.004,0.053,0.006,0.077,0.01\r\n\t\t\t\tc0.032,0.005,0.153,0.002,0.167-0.005c0.121,0.041,0.265,0.068,0.372,0.122c0.097-0.022,0.152-0.08,0.272-0.089\r\n\t\t\t\tc0.1-0.007,0.172,0.031,0.261,0.04c0.04-0.01,0.035-0.031,0.071-0.042c0.056,0.011,0.104,0.041,0.15,0.063\r\n\t\t\t\tc0.024,0.008,0.048,0.017,0.071,0.025c0.016,0.019,0.031,0.037,0.047,0.056c0.021,0.005,0.032-0.001,0.046,0.011\r\n\t\t\t\tc0.015,0.022,0.03,0.044,0.045,0.066c0.042,0.038,0.131,0.059,0.2,0.07c0.101,0.016,0.192,0.009,0.27-0.045\r\n\t\t\t\tc0.017-0.012,0.034-0.02,0.038-0.036c0.013-0.051-0.114-0.086-0.107-0.166c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.014,0.037,0.178,0.137,0.22,0.148c0.022,0.005,0.059,0.007,0.087-0.007c0.02-0.01,0.031-0.026,0.039-0.041\r\n\t\t\t\tc0.037-0.061-0.073-0.08-0.109-0.114c0.003-0.006,0.006-0.013,0.01-0.019c-0.026,0-0.033-0.018-0.043-0.033\r\n\t\t\t\tc-0.013-0.002-0.028,0-0.049,0.004c-0.004-0.04,0.038-0.112-0.07-0.076c0.009-0.016,0.01-0.032,0.012-0.052\r\n\t\t\t\tc-0.015,0.002-0.03,0.005-0.045,0.007c-0.002,0-0.004,0-0.005-0.001c-0.033-0.116-0.015-0.165-0.164-0.203\r\n\t\t\t\tc-0.003,0-0.005,0-0.008,0c-0.019,0.045-0.027,0.105-0.038,0.15c-0.001,0.001-0.003,0.002-0.004,0.003\r\n\t\t\t\tc-0.006-0.003-0.013-0.007-0.019-0.01c-0.004-0.025,0.002-0.056-0.014-0.084c-0.022-0.037-0.043-0.094-0.038-0.131\r\n\t\t\t\tc-0.051,0.012-0.061,0.058-0.095,0.08c-0.009-0.002-0.019-0.003-0.028-0.005c0-0.058-0.017-0.052-0.091-0.052\r\n\t\t\t\tc-0.013-0.02-0.001-0.032-0.007-0.054c-0.005-0.001-0.01-0.003-0.014-0.004c-0.012,0.001-0.02,0.003-0.029,0.007\r\n\t\t\t\tc-0.007-0.003-0.006-0.001-0.01-0.008c-0.053,0.01-0.081,0.001-0.126,0.003c-0.151,0.005-0.169,0.037-0.238-0.051\r\n\t\t\t\tc-0.041-0.009-0.201-0.016-0.26-0.004c-0.013,0.035-0.019,0.069-0.038,0.102c-0.018,0.027-0.037,0.054-0.055,0.08\r\n\t\t\t\tc-0.003,0.002-0.006,0.005-0.008,0.007c-0.027-0.016-0.116-0.06-0.103-0.103c0.009-0.015,0.038-0.018,0.056-0.029\r\n\t\t\t\tc0.021-0.013,0.084-0.093,0.073-0.115c-0.015-0.03-0.082-0.03-0.118-0.039c-0.039-0.01-0.067-0.043-0.116-0.041\r\n\t\t\t\tc-0.046,0.002-0.061,0.033-0.074,0.049c-0.018,0.016-0.035,0.032-0.053,0.048c-0.021,0.029-0.031,0.063-0.043,0.095\r\n\t\t\t\tc-0.007,0.002-0.013,0.004-0.019,0.005c-0.015-0.051-0.072-0.083-0.151-0.068c0,0,0-0.001-0.001-0.001\r\n\t\t\t\tc0.024-0.031,0.103-0.012,0.139-0.034c0.06-0.036,0.077-0.119,0.142-0.155c0.004-0.005,0.009-0.01,0.013-0.016\r\n\t\t\t\tc-0.078-0.016-0.155-0.032-0.243-0.04c-0.032,0.023-0.05,0.013-0.09,0.032c-0.021,0.015-0.043,0.03-0.064,0.045\r\n\t\t\t\tc-0.072,0.047-0.113,0.067-0.106,0.143c-0.023-0.003-0.035-0.007-0.05-0.017c-0.124-0.083,0.099-0.103,0.101-0.159\r\n\t\t\t\tc0.001-0.031-0.064-0.029-0.086-0.038c-0.002,0-0.004,0-0.005-0.001c0,0,0-0.001-0.001-0.002c0.065-0.02,0.17-0.047,0.208-0.018\r\n\t\t\t\tc0.055-0.015,0.091-0.086,0.101-0.119c0.002-0.012,0.004-0.024,0.007-0.036c0.019-0.029,0.096-0.064,0.136-0.084\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.005c-0.051-0.005-0.107-0.018-0.136-0.046c0.06,0.007,0.119,0.006,0.189,0.005\r\n\t\t\t\tc-0.007-0.017-0.02-0.023-0.032-0.034c-0.018-0.066,0.148-0.105,0.248-0.112c0.019-0.003,0.038-0.006,0.058-0.01\r\n\t\t\t\tc0.014,0.001,0.034,0.006,0.062-0.003c0.018-0.006,0.028-0.016,0.039-0.024c0.005,0.031-0.025,0.045-0.053,0.063\r\n\t\t\t\tc-0.039,0.004-0.2-0.007-0.232,0.033c0,0.003,0,0.005,0,0.008c0.038,0.019,0.086,0.056,0.135,0.064\r\n\t\t\t\tc0.063,0.01,0.146-0.01,0.22-0.012c0.032,0,0.063,0,0.095,0c0.05-0.056,0.09-0.128,0.108-0.194\r\n\t\t\t\tc0.015-0.005,0.03-0.001,0.047-0.002c0.036-0.002,0.135-0.04,0.152-0.052c0.047-0.035-0.09-0.189-0.128-0.197\r\n\t\t\t\tc-0.032-0.007-0.07-0.002-0.107-0.004c-0.059-0.004-0.24-0.04-0.269,0.031c0.007,0.018,0.019,0.023,0.032,0.034\r\n\t\t\t\tc0.001,0.002,0.001,0.003,0.002,0.005C21.061,9.85,21.006,9.85,20.952,9.85c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc-0.006-0.034,0.037-0.085,0.002-0.115c-0.013-0.007-0.061,0.002-0.077,0c-0.003-0.017,0.025-0.026,0.044-0.033\r\n\t\t\t\tc0.024-0.05-0.082-0.091-0.112-0.123c0,0,0-0.001-0.001-0.002c0.049,0.003,0.087,0.023,0.143,0.019\r\n\t\t\t\tc0.08-0.005,0.117-0.075,0.219-0.082c0.053-0.003,0.078,0.028,0.129,0.024c0.015-0.006,0.029-0.012,0.044-0.018\r\n\t\t\t\tc0.076-0.037,0.128-0.084,0.117-0.15c-0.006-0.035-0.112-0.077-0.174-0.057c-0.075,0.034-0.15,0.068-0.225,0.101\r\n\t\t\t\tc-0.023,0.015-0.039,0.033-0.066,0.048c0.001-0.026,0.017-0.077,0-0.103c-0.026-0.042-0.069-0.068-0.087-0.113\r\n\t\t\t\tc-0.144,0.026-0.093,0.074-0.143,0.127c-0.101,0.032-0.174-0.025-0.264-0.018c0.036-0.037,0.154-0.006,0.199-0.003\r\n\t\t\t\tc0.004-0.001,0.008-0.001,0.012-0.002c0.006-0.013,0.012-0.027,0.018-0.04c0.021-0.034,0.052-0.065,0.088-0.093\r\n\t\t\t\tc-0.001-0.001-0.003-0.003-0.004-0.004c-0.015-0.008-0.041-0.006-0.061-0.008c-0.037-0.005-0.076-0.012-0.118-0.013\r\n\t\t\t\tc-0.078,0-0.163,0.02-0.217-0.003c0.044-0.008,0.061-0.02,0.074-0.039c-0.012-0.023-0.076-0.028-0.104-0.037\r\n\t\t\t\tc-0.001-0.002-0.001-0.004-0.002-0.006c0.057-0.01,0.172,0.001,0.217,0.01c0.051,0.011,0.098,0.041,0.167,0.033\r\n\t\t\t\tc0.034-0.018,0.074-0.065,0.132-0.048c0.029,0.008,0.042,0.034,0.072,0.043c0.067-0.007,0.093-0.07,0.062-0.117\r\n\t\t\t\tc-0.04-0.061-0.125-0.079-0.182-0.12c-0.022-0.016-0.009-0.05-0.031-0.062c-0.042-0.024-0.124,0-0.196,0.004\r\n\t\t\t\tc-0.024-0.002-0.048-0.003-0.073-0.005c-0.041,0.002-0.072,0.028-0.098,0.039c-0.039,0.016-0.082,0.03-0.131,0.042\r\n\t\t\t\tc0-0.001-0.001-0.002-0.001-0.003c0.069-0.022,0.084-0.061,0.131-0.091c0.041-0.027,0.109-0.044,0.145-0.073\r\n\t\t\t\tc0.016-0.013,0.031-0.04,0.007-0.058c-0.01-0.007-0.041-0.008-0.068-0.013c0.057-0.028,0.115-0.055,0.172-0.083\r\n\t\t\t\tc0.024,0.008,0.048,0.016,0.072,0.024c0.029,0.02,0.058,0.041,0.086,0.062c0.003,0.001,0.006,0.001,0.008,0.002\r\n\t\t\t\tc0.003-0.003,0.005-0.005,0.008-0.008c-0.002-0.029-0.048-0.05-0.072-0.066c-0.018-0.012-0.036-0.025-0.053-0.037\r\n\t\t\t\tC24.16,6.946,27.965,6,32,6c4.818,0,9.316,1.335,13.186,3.62c-0.129,0.065-0.246,0.164-0.324,0.268\r\n\t\t\t\tc-0.047-0.001-0.131-0.022-0.152-0.019c-0.081,0.013-0.199,0.161-0.229,0.229c-0.014,0.013-0.025,0.025-0.039,0.038\r\n\t\t\t\tc0.039,0.028,0.076,0.062,0.103,0.102c-0.099,0.069-0.239,0.035-0.292,0.153c-0.004,0.004-0.008,0.008-0.014,0.013\r\n\t\t\t\tc0.033,0.03,0.064,0.059,0.096,0.089c-0.004,0.027-0.008,0.055-0.014,0.083c-0.383-0.001-0.321,0.111-0.547,0.216v0.006\r\n\t\t\t\tc0.209,0.251,0.238,0.04,0.521,0.089c0.13,0.023,0.227,0.096,0.344,0.121c0.108-0.061,0.16-0.161,0.248-0.241\r\n\t\t\t\tc-0.003-0.025-0.005-0.051-0.007-0.076c-0.034-0.021-0.067-0.042-0.103-0.064c-0.004-0.006-0.008-0.013-0.012-0.019\r\n\t\t\t\tc0.022-0.023,0.047-0.047,0.069-0.07c0.074,0.003,0.112,0.025,0.159,0.051c0.055-0.058,0.136-0.114,0.197-0.165v-0.013\r\n\t\t\t\tc-0.021-0.017-0.043-0.034-0.064-0.051c-0.014-0.017-0.002-0.045,0.006-0.076c0.016-0.013,0.03-0.026,0.044-0.038\r\n\t\t\t\tc0.107,0.001,0.271,0.047,0.356,0.006c0.035-0.028,0.072-0.055,0.107-0.083c0.021-0.023,0.043-0.047,0.063-0.07\r\n\t\t\t\tc-0.028-0.015-0.056-0.03-0.083-0.045c0.009-0.043,0.048-0.077,0.1-0.106c0.829,0.518,1.631,1.072,2.395,1.677\r\n\t\t\t\tc-0.006,0.025-0.012,0.05-0.016,0.075c-0.05,0.083-0.098,0.165-0.146,0.248c-0.135,0.174-0.528,0.182-0.465,0.489\r\n\t\t\t\tc0.054,0.004,0.107,0.008,0.16,0.013c0.135,0.378-0.104,0.29-0.146,0.515c0.07,0.108,0.28,0.064,0.369,0.153\r\n\t\t\t\tc0.029,0.036-0.002,0.112,0.013,0.165c0.035,0.124,0.136,0.168,0.286,0.146c-0.018,0.094-0.113,0.264-0.184,0.311\r\n\t\t\t\tc-0.016,0.013-0.038,0.014-0.07,0.013c-0.378-0.351-0.896-0.546-1.468-0.705c-0.123-0.034-0.46-0.13-0.636-0.089\r\n\t\t\t\tc-0.08,0.019-0.115,0.1-0.184,0.134c-0.002,0.004-0.004,0.008-0.006,0.013c0.061,0.078,0.123,0.157,0.184,0.235\r\n\t\t\t\tc-0.01,0.223-0.119,0.179-0.291,0.203c-0.021,0.033-0.037,0.114-0.052,0.146c-0.095,0.048-0.19-0.018-0.216-0.089\r\n\t\t\t\tc0.029-0.038,0.059-0.076,0.089-0.115c-0.178-0.082-0.286-0.093-0.45,0.032c-0.043,0.034-0.086,0.068-0.128,0.102\r\n\t\t\t\tc-0.1,0.03-0.176-0.034-0.235-0.051c-0.104-0.03-0.279-0.002-0.361,0.032c-0.092,0.037-0.088,0.172-0.172,0.222\r\n\t\t\t\tc-0.028-0.015-0.037-0.02-0.045-0.057c-0.182,0.003-0.223,0.07-0.375,0.019c0-0.05,0.008-0.062,0.025-0.089\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0-0.097,0.017-0.161,0.026-0.235c-0.381-0.002-0.168,0.2-0.42,0.248\r\n\t\t\t\tc-0.006-0.002-0.012-0.004-0.019-0.006c-0.011-0.034-0.021-0.068-0.032-0.102c-0.133,0.055-0.267,0.11-0.399,0.165\r\n\t\t\t\tc-0.226,0.09-0.453,0.187-0.661,0.273c-0.051,0.015-0.102,0.03-0.153,0.045c-0.087,0.07-0.049,0.285-0.14,0.349\r\n\t\t\t\tc-0.057,0.011-0.115,0.021-0.172,0.032c-0.342,0.069-0.428-0.091-0.629-0.248c0.041-0.201,0.281-0.195,0.508-0.203\r\n\t\t\t\tc-0.055-0.114-0.169-0.349-0.305-0.375c-0.098,0.009-0.195,0.017-0.293,0.025c-0.082-0.018-0.133-0.053-0.215-0.032\r\n\t\t\t\tc-0.018,0.148,0.158,0.164,0.12,0.337c-0.051,0.081-0.102,0.161-0.151,0.241c-0.004,0.004-0.01,0.009-0.014,0.013\r\n\t\t\t\tc0.034,0.051,0.079,0.078,0.153,0.089c0.079,0.238,0.028,0.214-0.032,0.407c-0.006,0.036-0.013,0.072-0.02,0.108v0.013\r\n\t\t\t\tc-0.165-0.008-0.334-0.211-0.565-0.184c-0.124,0.261-0.491,0.237-0.661,0.445c0.006,0.173,0.26,0.294,0.141,0.47\r\n\t\t\t\tc-0.034-0.011-0.068-0.021-0.103-0.032c-0.071,0.008-0.14,0.046-0.235,0.019c-0.217-0.062-0.433-0.161-0.604-0.267\r\n\t\t\t\tc-0.104,0-0.1,0.078-0.152,0.127c0.002,0.063,0.125,0.201,0.19,0.229c0.058,0.024,0.138-0.001,0.19,0.006\r\n\t\t\t\tc0.15,0.265-0.1,0.247-0.26,0.21c-0.072-0.016-0.158,0.001-0.211-0.032c-0.029-0.021-0.053-0.077-0.064-0.114\r\n\t\t\t\tc-0.075-0.038-0.206-0.014-0.291-0.057c-0.043-0.022-0.209-0.444-0.217-0.527c0.123-0.036,0.164-0.19,0.07-0.292\r\n\t\t\t\tc-0.066-0.072-0.223-0.087-0.305-0.14c-0.137-0.088-0.245-0.222-0.362-0.33c0.222-0.112,0.253,0.089,0.343,0.14\r\n\t\t\t\tc0.07,0.011,0.141,0.021,0.211,0.032c0.5,0.15,1.305,0.524,1.83,0.127c0.111-0.084,0.24-0.161,0.235-0.343\r\n\t\t\t\tc-0.069-0.069-0.081-0.106-0.076-0.242c-0.091-0.072-0.211-0.158-0.331-0.197c-0.127-0.038-0.254-0.076-0.381-0.115\r\n\t\t\t\tc-0.121-0.102-0.242-0.203-0.361-0.305c-0.068-0.021-0.137-0.042-0.203-0.063c-0.108-0.038-0.217-0.076-0.324-0.114\r\n\t\t\t\tc-0.18-0.013-0.36-0.025-0.54-0.038c-0.03,0.023-0.06,0.047-0.089,0.07c-0.004-0.046-0.008-0.093-0.014-0.14\r\n\t\t\t\tc-0.183-0.035-0.345-0.068-0.35-0.28c-0.061,0.036-0.123,0.072-0.184,0.108c-0.047,0.019-0.104,0.021-0.141,0.044\r\n\t\t\t\tc-0.113-0.074-0.219-0.036-0.369-0.025c-0.065-0.103-0.205-0.127-0.279-0.222c0.236,0.002,0.468,0.029,0.591-0.095\r\n\t\t\t\tc-0.002-0.023-0.005-0.047-0.007-0.07c-0.027-0.017-0.055-0.034-0.082-0.051c-0.065-0.023-0.141,0.003-0.191-0.019\r\n\t\t\t\tc-0.105-0.045-0.177-0.123-0.299-0.159c-0.07,0.062-0.137,0.151-0.152,0.267c-0.039-0.008-0.08-0.017-0.121-0.025\r\n\t\t\t\tc0.041-0.129,0.059-0.18,0.127-0.279c-0.05-0.066-0.162-0.027-0.242-0.013c-0.045,0.144-0.116,0.243-0.248,0.305\r\n\t\t\t\tc-0.004-0.093-0.008-0.187-0.012-0.28c-0.14,0.095-0.322,0.263-0.389,0.426c-0.018-0.002-0.034-0.004-0.051-0.006\r\n\t\t\t\tc-0.001-0.246,0.115-0.269,0.216-0.4c-0.28-0.021-0.326,0.061-0.47,0.203c-0.031,0.023-0.079-0.012-0.121,0.013\r\n\t\t\t\tc-0.073,0.044-0.145,0.185-0.172,0.273c-0.188-0.096-0.28-0.273-0.381,0.083c-0.043-0.036-0.086-0.072-0.127-0.108\r\n\t\t\t\tc-0.006-0.002-0.014-0.004-0.02-0.006c-0.048,0.076-0.089,0.121-0.203,0.134c-0.027,0.103-0.078,0.174-0.152,0.229\r\n\t\t\t\tc0.014-0.069,0.026-0.136,0.051-0.191c-0.004-0.011-0.008-0.021-0.014-0.032c-0.006-0.004-0.013-0.008-0.019-0.013\r\n\t\t\t\tc-0.084,0.046-0.147,0.229-0.197,0.311c-0.135-0.012-0.165-0.08-0.299-0.032c-0.024-0.021-0.051-0.042-0.076-0.063\r\n\t\t\t\tc-0.061,0.246-0.091,0.112-0.216,0.203c-0.066,0.048-0.033,0.116-0.146,0.153c-0.019,0.021-0.037,0.042-0.057,0.063\r\n\t\t\t\tc0.026,0.021,0.051,0.042,0.076,0.064v0.006c-0.036,0.051-0.105,0.052-0.172,0.038c0.011,0.047,0.021,0.093,0.031,0.14\r\n\t\t\t\tc-0.019,0.028-0.037,0.055-0.057,0.083c-0.006,0.004-0.013,0.009-0.019,0.013c-0.046-0.028-0.063-0.041-0.089-0.089h-0.006\r\n\t\t\t\tc-0.065,0.006-0.07,0.078-0.133,0.102c-0.01,0.027,0.014,0.055,0.043,0.076v0.038c-0.054,0.016-0.076,0.025-0.102,0.07\r\n\t\t\t\tc-0.041-0.01-0.074-0.026-0.127-0.032c-0.044,0.035-0.058,0.078-0.121,0.095c0.011,0.038,0.019,0.052,0.057,0.064\r\n\t\t\t\tc-0.034,0.075-0.199,0.095-0.273,0.134c-0.006,0.004-0.013,0.008-0.019,0.013c0.021,0.036,0.042,0.072,0.064,0.108v0.006\r\n\t\t\t\tc-0.065,0.004-0.112,0.01-0.178,0.006c-0.021,0.034-0.042,0.068-0.063,0.102c0.042,0.051,0.093,0.07,0.127,0.134v0.006\r\n\t\t\t\tc-0.042,0.006-0.085,0.013-0.127,0.019c-0.006,0.042-0.013,0.085-0.019,0.127c-0.163-0.038-0.167,0.098-0.229,0.21\r\n\t\t\t\tc0.021,0.006,0.042,0.013,0.064,0.019c0.002,0.044,0.004,0.089,0.006,0.133c-0.05,0.003-0.081,0.005-0.121-0.006\r\n\t\t\t\tc-0.075,0.075-0.123,0.164-0.203,0.235c0.006,0.019,0.013,0.038,0.019,0.057v0.006c-0.063,0.046-0.087,0.015-0.159,0\r\n\t\t\t\tc-0.094,0.045-0.266,0.185-0.311,0.28c-0.006,0.034-0.013,0.068-0.019,0.102c-0.039,0.065-0.125,0.084-0.159,0.165\r\n\t\t\t\tc-0.006,0.004-0.013,0.009-0.019,0.013c-0.019-0.013-0.038-0.026-0.057-0.038c-0.08-0.054-0.225,0.137-0.222,0.242\r\n\t\t\t\tc-0.085-0.036-0.205-0.032-0.337-0.032l-0.032,0.032c0.017,0.072,0.086,0.103,0.159,0.114c-0.063,0.075-0.159,0.014-0.267,0.006\r\n\t\t\t\tc-0.021,0.084-0.011,0.111-0.089,0.14c-0.1-0.04-0.144,0.042-0.248,0.076c-0.002,0.017-0.004,0.034-0.006,0.051\r\n\t\t\t\tc0.025,0.034,0.072,0.048,0.108,0.07v0.025c-0.066,0.004-0.131,0.008-0.197,0.013c-0.025,0.075-0.001,0.151-0.038,0.21\r\n\t\t\t\tc0.034,0.046,0.043,0.085,0.102,0.108c0.002,0.004,0.004,0.008,0.006,0.013c-0.056,0.046-0.091,0.058-0.114,0.14\r\n\t\t\t\tc0.004,0.011,0.008,0.021,0.013,0.032c0.041,0.028,0.07,0.034,0.121,0.013c0.011,0.013,0.021,0.025,0.032,0.038\r\n\t\t\t\tc-0.041,0.034-0.089,0.076-0.127,0.114c0.053,0.078,0.112,0.033,0.222,0.045c-0.007,0.055-0.021,0.092-0.07,0.108\r\n\t\t\t\tc-0.008,0.011-0.017,0.021-0.025,0.032c0.015,0.013,0.03,0.025,0.044,0.038c0.06-0.001,0.086-0.014,0.127-0.032\r\n\t\t\t\tc-0.027,0.037-0.064,0.055-0.127,0.057c0.001,0.016-0.001,0.007,0.006,0.025c-0.032,0.014-0.05,0.004-0.083-0.013v0.038h-0.006\r\n\t\t\t\tc-0.004-0.017-0.008-0.034-0.013-0.051c-0.002-0.004-0.004-0.008-0.006-0.013c-0.025,0.03-0.051,0.059-0.076,0.089\r\n\t\t\t\tc0.008,0.03,0.017,0.059,0.025,0.089c0.011,0.006,0.021,0.013,0.032,0.019c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032c0.051-0.002,0.06-0.014,0.095-0.026c-0.002-0.025-0.004-0.051-0.006-0.076\r\n\t\t\t\tc0.025,0.019,0.035,0.027,0.038,0.07h0.006c0.028-0.025,0.055-0.051,0.083-0.076c-0.018,0.039-0.04,0.052-0.064,0.083\r\n\t\t\t\tc0.032,0.02,0.042,0.024,0.089,0.019v0.007c-0.038,0.021-0.076,0.042-0.114,0.063c-0.009,0.028-0.004,0.013,0.006,0.045\r\n\t\t\t\tc0.046,0.033,0.031,0.018,0.102,0.013v0.006c-0.036,0.006-0.042,0.012-0.057,0.038c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.036-0.022-0.065-0.056-0.089-0.019c-0.006,0.004-0.013,0.008-0.019,0.013c-0.002-0.019-0.004-0.038-0.006-0.057\r\n\t\t\t\tc-0.017-0.002-0.034-0.004-0.051-0.006c0.015,0.05-0.003,0.072-0.025,0.114c0.019,0.038,0.038,0.076,0.057,0.114\r\n\t\t\t\tc0.123,0.036,0.19,0.086,0.305,0.115c-0.013,0.013-0.026,0.025-0.038,0.038c0.013,0.008,0.025,0.017,0.038,0.025\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.03,0.015,0.042,0.019,0.051,0.057c0.07,0.017,0.282-0.01,0.349-0.044\r\n\t\t\t\tc0.108-0.107,0.244-0.176,0.356-0.28c0.039-0.036,0.039-0.072,0.095-0.095c0.038-0.02,0.087,0.023,0.14-0.013\r\n\t\t\t\tc0.062-0.046,0.08-0.127,0.083-0.222c0.015-0.011,0.03-0.021,0.044-0.032c0.012,0.047,0.011,0.056-0.013,0.089\r\n\t\t\t\tc0.053,0.074,0.056,0.142,0.165,0.095c0.004,0.002,0.008,0.004,0.013,0.006c0.006,0.051-0.02,0.065-0.032,0.114\r\n\t\t\t\tc0.052,0.027,0.057,0.174,0.057,0.248c0.019-0.002,0.038-0.004,0.057-0.007c0.002,0.017,0.004,0.034,0.006,0.051\r\n\t\t\t\tc0.048-0.012,0.047-0.013,0.089,0c0.008,0.048-0.026,0.118-0.044,0.165c0.047,0.06,0.08,0.086,0.076,0.203\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.049,0.164,0.149,0.23,0.242,0.324c-0.004,0.017-0.009,0.034-0.013,0.051\r\n\t\t\t\tc-0.019-0.002-0.038-0.004-0.057-0.006c0.002,0.017,0.004,0.034,0.006,0.051c-0.021,0.011-0.042,0.021-0.064,0.032\r\n\t\t\t\tc0.042,0.083,0.088,0.169,0.159,0.222c-0.016,0.061-0.039,0.075-0.051,0.134c0.151,0.032,0.257-0.029,0.381,0\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.037-0.032,0.005-0.05-0.019-0.089c0.023-0.06,0.036-0.108,0.095-0.133\r\n\t\t\t\tc0.019-0.011,0.012-0.005,0.038,0.006c0.004-0.017,0.009-0.034,0.013-0.051c0.11,0.001,0.175-0.008,0.253-0.025\r\n\t\t\t\tc0.021,0.015,0.043,0.03,0.064,0.045c0.004,0.004,0.008,0.008,0.014,0.013c0.059-0.108,0.119-0.216,0.178-0.324\r\n\t\t\t\tc0.002-0.04,0.004-0.08,0.006-0.121c0.011-0.057,0.039-0.09,0.057-0.133c0.016-0.027-0.011-0.058,0.006-0.102\r\n\t\t\t\tc-0.015-0.006-0.029-0.013-0.045-0.019V18.53h0.064c0.095-0.071-0.057-0.253-0.07-0.318c0.059-0.002,0.119-0.004,0.178-0.006\r\n\t\t\t\tc0.002-0.013,0.004-0.025,0.006-0.038c0.177,0.031,0.106-0.133,0.191-0.165v0.095c0.002,0.002,0.004,0.004,0.006,0.006\r\n\t\t\t\tc0.02-0.002,0.039-0.004,0.058-0.006c0.014-0.068,0.052-0.091,0.114-0.108c-0.004-0.021-0.008-0.042-0.014-0.064\r\n\t\t\t\tc0.027-0.002,0.055-0.004,0.083-0.006c-0.002-0.011-0.004-0.021-0.006-0.032c-0.002-0.004-0.004-0.008-0.006-0.013h-0.032v0.032\r\n\t\t\t\tc-0.102-0.041-0.174,0.062-0.279,0.045c-0.111-0.019-0.164-0.137-0.3-0.095H32.8c0.009-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.036-0.04,0.304,0.049,0.368,0.083c0.082,0.043,0.287-0.119,0.312-0.153h0.058c-0.002-0.095-0.049-0.099-0.07-0.178\r\n\t\t\t\tc-0.126-0.018-0.206-0.104-0.248-0.203c-0.025,0.002-0.051,0.004-0.076,0.006c-0.038-0.015-0.062-0.043-0.133-0.045\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.046-0.039-0.053-0.296-0.025-0.4c0.023-0.006,0.047-0.013,0.07-0.019\r\n\t\t\t\tc0.055-0.173,0-0.204-0.02-0.356c0.038,0.013,0.076,0.025,0.114,0.038c0.021-0.028,0.042-0.055,0.063-0.083\r\n\t\t\t\tc0.017-0.027-0.004-0.073-0.012-0.115h0.127c0.079-0.112,0.116-0.111,0.221-0.191c0.051-0.038,0.051-0.096,0.115-0.127\r\n\t\t\t\tc0.022,0.015,0.047,0.03,0.069,0.044c0.099-0.068,0.199-0.136,0.299-0.203c0.071-0.087,0.077-0.196,0.185-0.248\r\n\t\t\t\tc0.004-0.006,0.008-0.013,0.013-0.019c-0.034-0.052-0.095-0.08-0.121-0.133c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.053-0.023,0.127-0.081,0.151-0.133c0.023-0.036-0.022-0.072-0.044-0.102c0.077-0.104,0.108-0.037,0.184-0.095\r\n\t\t\t\tc0.092-0.069,0.095-0.193,0.211-0.248c0.051,0.034,0.102,0.068,0.152,0.102c0.022,0.014,0.223-0.034,0.305-0.032\r\n\t\t\t\tc0.078,0.06,0.117,0.113,0.262,0.115c0.011,0.019,0.021,0.038,0.031,0.057c0.015,0.037-0.006,0.12-0.019,0.159\r\n\t\t\t\tc0.017,0.019,0.034,0.038,0.052,0.057c0.013,0.018,0.008,0.038,0.006,0.076c-0.041-0.002-0.082-0.004-0.121-0.006\r\n\t\t\t\tc-0.098,0.028-0.543,0.488-0.61,0.585h-0.032c-0.013-0.019-0.025-0.038-0.037-0.057v-0.013c-0.091,0.094-0.017,0.207-0.16,0.28\r\n\t\t\t\tc-0.059-0.024-0.1-0.032-0.158-0.013c0.004,0.027,0.008,0.055,0.013,0.083c-0.073,0.067-0.121,0.102-0.153,0.216\r\n\t\t\t\tc0.026,0.023,0.063,0.043,0.09,0.064c0,0.094-0.021,0.143-0.032,0.216c0.034,0.053,0.067,0.106,0.102,0.159\r\n\t\t\t\tc-0.008,0.04-0.017,0.08-0.024,0.121c-0.035,0.188-0.012,0.31,0.127,0.381c0.058,0.03,0.07,0.065,0.146,0.038l-0.006,0.076\r\n\t\t\t\tc0.054-0.018,0.094-0.039,0.172-0.038c-0.011,0.023-0.021,0.047-0.032,0.07c0.021,0.042,0.039,0.071,0.084,0.089\r\n\t\t\t\tc0.066,0.051,0.192-0.016,0.234-0.038v0.026c0.064-0.014,0.081-0.027,0.133,0c0.043-0.058,0.077-0.069,0.153-0.095\r\n\t\t\t\tc0.004,0.008,0.008,0.017,0.013,0.025c0.051-0.028,0.141-0.037,0.165-0.095c0.027,0.019,0.056,0.038,0.083,0.057h0.006\r\n\t\t\t\tc0.018-0.083,0.1-0.04,0.152-0.083c0.027-0.017,0.04-0.057,0.045-0.095v0.057c0.036,0.013,0.072,0.025,0.107,0.038\r\n\t\t\t\tc0.026-0.027,0.035-0.043,0.084-0.051c0.021,0.013,0.041,0.025,0.063,0.038c0.06-0.057,0.198-0.098,0.3-0.108\r\n\t\t\t\tc0.008-0.015,0.016-0.03,0.024-0.045c0.028-0.003-0.011,0.079-0.019,0.114c0.147,0.215,0.344-0.041,0.488,0.229\r\n\t\t\t\tc-0.015,0.011-0.029,0.021-0.045,0.032c-0.094-0.003-0.141-0.044-0.222-0.07c-0.076,0.006-0.101,0.066-0.14,0.108\r\n\t\t\t\tc-0.054-0.012-0.054-0.037-0.103-0.025c-0.017,0.027-0.015,0.015-0.006,0.045c-0.031,0.029-0.052,0.003-0.076-0.025\r\n\t\t\t\tc-0.013,0.002-0.024,0.004-0.038,0.006c-0.004,0.015-0.008,0.03-0.013,0.045c0.032,0.038,0.067,0.051,0.063,0.108\r\n\t\t\t\tc-0.008-0.008-0.017-0.017-0.025-0.025c-0.018-0.007-0.057,0.067-0.107,0.064c-0.163-0.011-0.296-0.042-0.451-0.07\r\n\t\t\t\tc-0.078-0.014-0.166,0.024-0.203-0.006c-0.017,0.015-0.033,0.03-0.051,0.044c-0.049-0.011-0.098-0.021-0.146-0.032\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.012,0.045c-0.045-0.007-0.062,0.006-0.103-0.006c-0.085,0.046-0.146,0.095-0.28,0.102\r\n\t\t\t\tc0.006,0.043,0.014,0.056-0.025,0.07c0.023,0.062,0.023,0.099,0.045,0.165c0.021,0,0.035-0.011,0.057-0.026\r\n\t\t\t\tc-0.002,0.057-0.004,0.115-0.006,0.172c0.057,0.016,0.08,0.031,0.121,0.051c0.025-0.023,0.051-0.047,0.076-0.07\r\n\t\t\t\tc0.013,0.009,0.024,0.017,0.037,0.025c-0.021,0.16-0.09,0.268-0.037,0.451c-0.041,0.106-0.223,0.17-0.324,0.076\r\n\t\t\t\tc-0.016-0.04-0.03-0.081-0.044-0.121c-0.048-0.034-0.093-0.068-0.14-0.102v-0.044c-0.113,0.004-0.154,0.056-0.268,0.057\r\n\t\t\t\tc-0.034,0.043-0.068,0.085-0.102,0.127c-0.002,0.044-0.004,0.089-0.006,0.133c-0.033,0.025-0.064,0.051-0.096,0.076\r\n\t\t\t\tc-0.068,0.143,0.034,0.501,0.064,0.578c-0.01,0.025,0,0,0.013,0.025c-0.011,0.002-0.021,0.004-0.032,0.006\r\n\t\t\t\tc0.012,0.035,0.018,0.047,0.014,0.089c-0.082,0.046-0.25,0.013-0.362,0.007c-0.017,0.05-0.021,0.111-0.025,0.165\r\n\t\t\t\tc-0.125,0.066-0.209,0.161-0.388,0.095c-0.01-0.053-0.025-0.086-0.051-0.121c0.005-0.087-0.213-0.034-0.28-0.013\r\n\t\t\t\tc-0.291,0.091-0.499,0.261-0.852,0.286c0.004,0.069,0.012,0.088,0.013,0.146c-0.08-0.028-0.139-0.055-0.21-0.083\r\n\t\t\t\tc-0.004-0.036-0.008-0.072-0.013-0.108c-0.081-0.042-0.175,0.016-0.222-0.121c-0.058-0.004-0.427,0.12-0.458,0.197h-0.07\r\n\t\t\t\tc-0.004-0.013-0.009-0.025-0.013-0.038h-0.006c-0.033,0.022-0.061,0.024-0.095,0.013c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.045-0.038,0.069-0.048,0.102-0.102c-0.006-0.013-0.013-0.025-0.019-0.038c-0.049,0.004-0.097,0.009-0.146,0.013\r\n\t\t\t\tc-0.057-0.013-0.065-0.053-0.121-0.025c-0.014-0.043-0.014-0.04-0.064-0.038c0.059-0.095-0.063-0.185-0.133-0.21\r\n\t\t\t\tc0.013-0.092,0.038-0.176,0.089-0.229c-0.006-0.011-0.013-0.021-0.019-0.032c0.028-0.002,0.055-0.004,0.083-0.006\r\n\t\t\t\tc0.023-0.081,0.102-0.094,0.064-0.191c0.021-0.011,0.042-0.021,0.064-0.032c0.013,0.017,0.025,0.034,0.038,0.051\r\n\t\t\t\tc0.019-0.007,0.038-0.013,0.057-0.019c0.011-0.02,0.068-0.131,0.038-0.159c-0.051-0.002-0.102-0.004-0.153-0.006\r\n\t\t\t\tc-0.032-0.019-0.031-0.102-0.032-0.153c-0.068-0.033-0.163-0.022-0.254-0.019c-0.006,0.053-0.013,0.106-0.019,0.159\r\n\t\t\t\tc-0.013,0.014-0.02,0.015-0.044,0.019c-0.013-0.03-0.025-0.059-0.038-0.089c-0.049,0.026-0.056,0.1-0.095,0.121\r\n\t\t\t\tc-0.035,0.019-0.1-0.034-0.133-0.032c-0.071,0.107,0.012,0.181,0.019,0.286c-0.031,0.04-0.055,0.066-0.076,0.121\r\n\t\t\t\tc0.017,0.008,0.034,0.017,0.051,0.025c0.008-0.011,0.017-0.021,0.025-0.032c0.03,0.025,0.028,0.047,0.083,0.051\r\n\t\t\t\tc0.009,0.061-0.008,0.193,0.006,0.242c0.015,0.052,0.078,0.085,0.095,0.146c-0.028,0.028-0.059,0.044-0.108,0.051\r\n\t\t\t\tc0.012,0.043,0.042,0.03,0.095,0.025c-0.011,0.017-0.017,0.019-0.032,0.032c0.015,0.015,0.03,0.03,0.045,0.044\r\n\t\t\t\tc-0.011,0.008-0.021,0.017-0.032,0.025c0.002,0.011,0.004,0.021,0.006,0.032c0.023,0.011,0.047,0.021,0.07,0.032\r\n\t\t\t\tc-0.046,0.024-0.104,0.005-0.159,0c-0.019,0.061-0.035,0.076-0.006,0.133c-0.032-0.011-0.063-0.021-0.095-0.032\r\n\t\t\t\tc0.008,0.019,0.017,0.038,0.025,0.057c-0.006,0.008-0.013,0.017-0.019,0.025c-0.006,0.002-0.013,0.004-0.019,0.006\r\n\t\t\t\tc-0.006-0.004-0.013-0.008-0.019-0.013c-0.005-0.039-0.011-0.061-0.025-0.108c-0.107-0.001-0.208,0.008-0.28,0.038\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.008,0.049,0.031,0.043,0.057,0.07c-0.002,0.006-0.004,0.013-0.006,0.019h-0.025\r\n\t\t\t\tc-0.023-0.022-0.063-0.046-0.076-0.076c-0.123-0.051-0.317,0.05-0.413,0.083c-0.013,0.055-0.013,0.076-0.013,0.146\r\n\t\t\t\tc0.027,0.002,0.055,0.004,0.083,0.006c-0.015,0.024-0.023,0.03-0.025,0.07c0.024,0.016,0.034,0.024,0.076,0.026\r\n\t\t\t\tc-0.013,0.071-0.047,0.063-0.076,0.108c-0.051,0.033-0.092-0.002-0.165-0.013c0.015-0.036,0.015-0.051,0.013-0.108\r\n\t\t\t\tc0.026,0.002,0.019,0.001,0.044-0.006c0.006-0.013,0.013-0.025,0.019-0.038c-0.018-0.035-0.039-0.055-0.07-0.076\r\n\t\t\t\tc-0.032,0.008-0.064,0.017-0.095,0.026c-0.038,0.095-0.076,0.191-0.114,0.286c-0.074,0.064-0.148,0.127-0.222,0.191\r\n\t\t\t\tc0.032,0.014,0.055,0.038,0.07,0.07c-0.053,0.064-0.14-0.005-0.216,0.025c-0.055,0.036-0.11,0.072-0.165,0.108\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.007c-0.047,0.023-0.093,0.047-0.14,0.07c-0.038,0.119,0.011,0.258-0.089,0.324\r\n\t\t\t\tc-0.114,0.075-0.266,0.05-0.349,0.153c-0.002,0.013-0.004,0.025-0.006,0.038c0.021,0.006,0.042,0.013,0.064,0.019\r\n\t\t\t\tc-0.12,0.118-0.282-0.026-0.426,0.044c-0.023-0.044-0.033-0.075-0.025-0.14c-0.075,0.012-0.121,0.009-0.203,0\r\n\t\t\t\tc0.011,0.077,0.049,0.161,0.108,0.191c-0.002,0.083-0.013,0.145,0.025,0.197c-0.024,0.019-0.065,0.026-0.108,0.025V22.17\r\n\t\t\t\tc-0.055,0.027-0.204,0.061-0.273,0.057c-0.028-0.036-0.055-0.072-0.083-0.108c-0.045,0.004-0.089,0.008-0.133,0.013\r\n\t\t\t\tc-0.006,0.015-0.013,0.03-0.019,0.044c-0.024,0.015-0.108,0.007-0.108,0.007c-0.004-0.004-0.009-0.009-0.013-0.013\r\n\t\t\t\tc-0.076,0.006-0.132,0.063-0.222,0.063c-0.002,0.028-0.004,0.055-0.006,0.083c0.038-0.014,0.077-0.021,0.133-0.019\r\n\t\t\t\tc-0.015,0.03-0.018,0.038-0.057,0.045c-0.01,0.017,0.037,0.021,0.057,0.025c0.002,0.009,0.004,0.017,0.006,0.025v0.006\r\n\t\t\t\tc-0.038,0.006-0.076,0.013-0.114,0.019c0.018,0.035,0.065,0.028,0.089,0.057c0.002,0.011,0.004,0.021,0.006,0.032\r\n\t\t\t\tc0.154-0.013,0.334,0.029,0.445,0.127c0.028-0.009,0.055-0.017,0.083-0.025c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc-0.011,0.021-0.021,0.043-0.032,0.064c0.036,0.046,0.118,0.075,0.165,0.108c-0.011,0.023-0.021,0.046-0.032,0.07\r\n\t\t\t\tc0.04,0.049,0.08,0.097,0.121,0.146c0.135,0.068,0.112,0,0.184,0.153c-0.021,0.04-0.045,0.073-0.051,0.127\r\n\t\t\t\tc0.051,0.067,0.112,0.106,0.133,0.203c-0.034-0.042-0.068-0.085-0.102-0.127h-0.006c-0.04,0.073-0.053,0.198-0.051,0.305\r\n\t\t\t\tc0.011-0.008,0.021-0.017,0.032-0.025c0.008,0.01,0.017,0.021,0.025,0.032c-0.017,0.008-0.034,0.017-0.051,0.025\r\n\t\t\t\tc-0.034,0.153-0.066,0.309-0.121,0.426c-0.162,0.027-0.245-0.039-0.375-0.076c-0.077,0.095-0.35,0.058-0.515,0.032\r\n\t\t\t\tc-0.075-0.012-0.339-0.086-0.356-0.083c-0.076,0.017-0.158,0.089-0.267,0.07c-0.137-0.023-0.23-0.099-0.369-0.044\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102h-0.083c-0.104,0.004-0.159,0.031-0.197,0.102c0.002,0.023,0.004,0.047,0.006,0.07\r\n\t\t\t\tc0.094,0.019,0.139,0.07,0.165,0.153c0.008,0.014-0.059,0.211-0.076,0.241c0.095,0.198,0.023,0.738-0.14,0.826\r\n\t\t\t\tc0.005,0.08-0.01,0.143-0.038,0.203c0.015,0.029,0.018,0.027,0.051,0.038c0.039-0.018,0.066-0.029,0.083-0.07\r\n\t\t\t\tc0.006-0.004,0.013-0.009,0.019-0.013c0.009,0.017,0.017,0.034,0.025,0.051c-0.024,0.033-0.05,0.045-0.108,0.045v0.006\r\n\t\t\t\tc0.004,0.017,0.009,0.034,0.013,0.051c0.035,0.008,0.086-0.006,0.121-0.019c0.004,0.004,0.008,0.008,0.013,0.013\r\n\t\t\t\tc-0.011,0.052-0.024,0.115-0.032,0.165c-0.002,0.004-0.004,0.008-0.006,0.013c0.016,0.028,0.041,0.09,0.025,0.152\r\n\t\t\t\tc-0.012,0.047-0.061,0.108-0.044,0.159v0.013c0.057-0.028,0.12-0.061,0.216-0.038c0.03,0.007,0.054,0.035,0.102,0.026\r\n\t\t\t\tc0.044-0.021,0.089-0.042,0.133-0.064c0.148-0.039,0.293,0.081,0.286,0.191c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.017,0.104,0.101,0.213,0.229,0.178c0.011-0.013,0.01-0.013,0.013-0.038h0.006c0.002,0.011,0.004,0.021,0.006,0.032h0.006\r\n\t\t\t\tc0.028-0.117,0.068-0.096,0.178-0.133c0.032-0.028,0.064-0.055,0.095-0.083c0.167,0.002,0.335,0.004,0.502,0.006\r\n\t\t\t\tc0.033-0.011,0.061-0.035,0.114-0.044c0.013,0.011,0.025,0.021,0.038,0.032c0.076-0.056,0.065-0.091,0.114-0.178\r\n\t\t\t\tc0.05-0.088,0.175-0.085,0.292-0.108c0.01-0.028-0.012-0.031-0.006-0.064c0.026-0.154,0.176-0.261,0.299-0.324v-0.019\r\n\t\t\t\tc-0.032-0.017-0.064-0.034-0.095-0.051c-0.023-0.053-0.047-0.106-0.07-0.159c0.031-0.147,0.225-0.389,0.356-0.438\r\n\t\t\t\tc0.002-0.004,0.004-0.009,0.006-0.013c-0.016-0.018-0.023-0.016-0.032-0.044c0.086-0.149,0.264-0.073,0.394-0.159\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.074-0.067,0.212-0.068,0.273-0.146c0.075-0.198-0.151-0.33,0.102-0.508\r\n\t\t\t\tc0.16-0.113,0.187,0.005,0.33,0.006c0.036,0,0.081-0.033,0.133-0.013c0.074,0.029,0.117,0.137,0.242,0.115\r\n\t\t\t\tc0.24-0.044,0.308-0.187,0.47-0.292c0.047-0.013,0.093-0.026,0.14-0.038c0.025-0.028,0.051-0.055,0.076-0.083\r\n\t\t\t\tc0.129-0.101,0.256-0.104,0.426-0.019c0.221,0.111,0.209,0.479,0.419,0.61c0.184,0.115,0.33,0.293,0.502,0.381\r\n\t\t\t\tc0.155,0.08,0.306,0.025,0.343,0.229c0.03-0.008,0.059-0.017,0.089-0.025H32.2c0.013,0.015,0.025,0.03,0.038,0.044\r\n\t\t\t\tc-0.011,0.004-0.021,0.009-0.032,0.013c-0.004,0.008-0.009,0.017-0.013,0.025c0.038-0.011,0.076-0.021,0.114-0.032\r\n\t\t\t\tc0.021,0.019,0.042,0.038,0.064,0.057c0.009,0.041,0.003,0.066-0.013,0.095c0.045,0.027,0.089,0.055,0.133,0.083\r\n\t\t\t\tc0.022,0.012,0.038-0.004,0.069-0.019c0.034,0.01,0.182,0.419,0.172,0.451v0.013c-0.022-0.002-0.047-0.004-0.069-0.006\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.02,0.067,0.004,0.11-0.064,0.14v0.076c0.014,0.009,0.025,0.017,0.039,0.025h0.082\r\n\t\t\t\tc0.039-0.064,0.067-0.14,0.146-0.165c0.016-0.034,0.005-0.062,0-0.108c0.045-0.043,0.062-0.067,0.159-0.064\r\n\t\t\t\tc0.011-0.013,0.021-0.026,0.032-0.038c-0.026-0.042-0.026-0.089-0.006-0.134c-0.062-0.034-0.123-0.068-0.185-0.102\r\n\t\t\t\tc0.002-0.111,0.086-0.282,0.197-0.267c-0.007,0.095,0.142,0.064,0.202,0.108c0.031,0.023,0.007,0.04,0.025,0.076\r\n\t\t\t\tc0.036,0.023,0.072,0.047,0.108,0.07c0.015-0.044,0.03-0.089,0.045-0.133c-0.196-0.193-0.437-0.359-0.744-0.438\r\n\t\t\t\tc-0.011-0.013-0.021-0.025-0.032-0.038c0.032-0.027,0.049-0.054,0.096-0.07c-0.002-0.011-0.004-0.021-0.006-0.032\r\n\t\t\t\tc-0.047-0.073-0.328,0.011-0.414-0.076c-0.08-0.081-0.209-0.198-0.254-0.305c-0.028-0.067-0.023-0.157-0.064-0.21\r\n\t\t\t\tc-0.031-0.04-0.088-0.05-0.133-0.076c-0.15-0.087-0.231-0.143-0.273-0.343c0.027-0.031,0.056-0.043,0.076-0.083\r\n\t\t\t\tc-0.031-0.037-0.057-0.035-0.057-0.108c-0.015-0.002-0.03-0.004-0.044-0.006c0.008-0.021,0.017-0.042,0.025-0.064\r\n\t\t\t\tc0.044-0.029,0.154-0.064,0.248-0.07c0.002-0.017,0.004-0.034,0.006-0.051c0.08,0.003,0.086,0.005,0.159,0\r\n\t\t\t\tc0.011,0.017,0.021,0.034,0.032,0.051c-0.019,0.025-0.035,0.035-0.076,0.038c0.021,0.098,0.071,0.175,0.102,0.254\r\n\t\t\t\tc0.033-0.017,0.055-0.041,0.083-0.064c0.017-0.047,0.034-0.093,0.051-0.14c0.256,0.103,0.086,0.31,0.343,0.388\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.006v0.006c0.075,0.108,0.184,0.165,0.266,0.267c0.025,0.026,0.06-0.025,0.109-0.013\r\n\t\t\t\tc0.006,0.001,0.152,0.061,0.164,0.07c0.049,0.035,0.09,0.097,0.141,0.133c0.133,0.095,0.271,0.155,0.406,0.248\r\n\t\t\t\tc0.03,0.036,0.06,0.072,0.09,0.108c0.041,0.021,0.084,0.042,0.127,0.064c0.002,0.051,0.002,0.06-0.039,0.07\r\n\t\t\t\tc-0.006,0.043,0.017,0.226,0.014,0.235c-0.018,0.032-0.034,0.064-0.051,0.095c0.021,0.032,0.037,0.045,0.037,0.102\r\n\t\t\t\tc-0.01-0.002-0.021-0.004-0.031-0.006c0.027,0.077,0.145,0.098,0.191,0.159c0.006,0.03,0.013,0.059,0.019,0.089\r\n\t\t\t\tc0.04,0.101,0.153,0.191,0.28,0.172c0.008,0.008,0.017,0.017,0.024,0.025v0.013c-0.026,0.034-0.065,0.029-0.108,0.038v0.006\r\n\t\t\t\tc0.037,0.055,0.072,0.11,0.108,0.165c0.103-0.009,0.228-0.061,0.349-0.025c0.078,0.022,0.119,0.081,0.224,0.089v0.006\r\n\t\t\t\tc-0.101,0.134-0.204-0.021-0.324-0.038c-0.039-0.005-0.082,0.035-0.159,0.032c-0.021,0.038-0.041,0.076-0.063,0.114\r\n\t\t\t\tc0.038,0.047,0.075,0.093,0.114,0.14c0.014,0.044-0.017,0.099-0.014,0.146c0.02,0.017,0.038,0.034,0.057,0.051\r\n\t\t\t\tc0.02-0.015,0.039-0.03,0.058-0.044c0.045-0.022,0.097,0.086,0.108,0.14c0.004,0.002,0.009,0.004,0.013,0.007\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.056-0.027,0.09-0.001,0.14,0.025c-0.005-0.136-0.056-0.195-0.095-0.292v-0.032\r\n\t\t\t\tc0.033,0.011,0.068,0.021,0.102,0.032h0.014c-0.006,0.013-0.014,0.025-0.02,0.038c0.018,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.02-0.035,0.029-0.044,0.083-0.045c-0.022-0.029-0.028-0.02-0.024-0.064c-0.021,0.004-0.043,0.009-0.064,0.013\r\n\t\t\t\tc-0.021-0.048-0.025-0.074-0.057-0.108c0.047-0.015,0.093-0.03,0.14-0.044c0.05,0.006,0.106,0.078,0.121,0.121\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.014-0.011,0.025-0.021,0.039-0.032c-0.014-0.04-0.025-0.081-0.039-0.121\r\n\t\t\t\tc0.008-0.002,0.018-0.004,0.025-0.006c-0.005-0.06-0.342-0.233-0.419-0.248v-0.006c0.044-0.01,0.071-0.023,0.103-0.044\r\n\t\t\t\tc-0.014-0.03-0.026-0.059-0.039-0.089v-0.007c0.031-0.019,0.043-0.017,0.084-0.006c0.014,0.026,0.015,0.037,0.013,0.07h0.006\r\n\t\t\t\tc0.006-0.002,0.013-0.004,0.019-0.006c0.008-0.011,0.018-0.021,0.025-0.032c-0.079-0.096-0.169-0.193-0.223-0.311\r\n\t\t\t\tc0.003-0.047,0.016-0.064,0.039-0.089c-0.012-0.013-0.021-0.025-0.032-0.038c0.034-0.015,0.06-0.023,0.075-0.057\r\n\t\t\t\tc0.009,0.002,0.018,0.004,0.025,0.006c0.002,0.009,0.004,0.017,0.006,0.025c-0.011,0.007-0.021,0.013-0.031,0.019\r\n\t\t\t\tc0.039,0.08,0.139,0.069,0.146,0.184c0.032,0.004,0.063,0.008,0.095,0.013h0.014c-0.035-0.042-0.079-0.056-0.108-0.108v-0.006\r\n\t\t\t\tc0.076,0.003,0.119,0.051,0.146,0.102c0.016-0.002,0.031-0.004,0.045-0.006c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.023-0.041-0.061-0.046-0.083-0.089c0.011-0.008,0.021-0.017,0.032-0.026c0.037,0.007,0.066,0.015,0.082,0.045\r\n\t\t\t\tc0.018,0.015,0.035,0.03,0.052,0.045c0.006-0.004,0.013-0.009,0.019-0.013v-0.006c-0.062-0.077-0.15-0.094-0.19-0.197v-0.006\r\n\t\t\t\tc0.134-0.026,0.108,0.02,0.21-0.07c0.039,0.003,0.033,0.001,0.044,0.032c0.079,0,0.103-0.025,0.153-0.051\r\n\t\t\t\tc0.043,0.102,0.271-0.012,0.285,0.121c0.008-0.009,0.018-0.017,0.025-0.025c0.034,0.021,0.105,0.031,0.146,0.044\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.032,0.019-0.064,0.038-0.096,0.057c-0.008,0.032-0.017,0.064-0.024,0.095\r\n\t\t\t\tc0.065-0.021,0.091-0.085,0.14-0.121c0.061-0.028,0.123-0.055,0.184-0.083c0.016-0.03,0.03-0.059,0.045-0.089\r\n\t\t\t\tc0.037-0.022,0.1,0.002,0.152-0.019c0.137-0.054,0.112,0.009,0.273,0.013c0.025-0.03,0.045-0.056,0.062-0.095\r\n\t\t\t\tc-0.045-0.06-0.142-0.051-0.209-0.089c-0.088-0.049-0.179-0.313-0.268-0.299v-0.051c0.035-0.035,0.047-0.056,0.102-0.076\r\n\t\t\t\tc0.016-0.084,0.038-0.153,0.051-0.222c0.025-0.013,0.108-0.018,0.121-0.038c0.004-0.04,0.008-0.08,0.014-0.121\r\n\t\t\t\tc0.035-0.199,0.06-0.377,0.285-0.388c0.023-0.049,0.047-0.097,0.07-0.146c-0.015-0.031-0.033-0.038-0.051-0.064\r\n\t\t\t\tc-0.031-0.104,0.094-0.097,0.152-0.133c0.199-0.119,0.104-0.321,0.51-0.311c0.008-0.015,0.018-0.03,0.025-0.045\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.021,0.025,0.042,0.051,0.063,0.076v0.013c-0.022,0.021-0.047,0.042-0.069,0.064v0.013\r\n\t\t\t\tc0.097,0.133,0.265,0.085,0.458,0.089c0.013,0.025,0.025,0.051,0.038,0.076c-0.067,0.074-0.25,0.106-0.331,0.184\r\n\t\t\t\tc0.004,0.008,0.009,0.017,0.013,0.025c0.2,0.038,0.367,0.002,0.254,0.267V23.7c0.285,0.052,0.158-0.026,0.337-0.089\r\n\t\t\t\tc0.051-0.004,0.103-0.009,0.153-0.013c0.034-0.028,0.067-0.055,0.103-0.083c0.06-0.018,0.088,0.017,0.133,0.025\r\n\t\t\t\tc0.037-0.006,0.076-0.013,0.113-0.019c0.023-0.032,0.053-0.072,0.064-0.114c-0.064-0.008-0.127-0.017-0.191-0.025\r\n\t\t\t\tc-0.072,0.007-0.141,0.064-0.234,0.038c-0.024-0.123-0.199-0.258-0.338-0.299c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.104-0.029,0.197-0.016,0.306-0.019c0.036-0.039,0.065-0.066,0.083-0.127c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc0.015,0.013,0.03,0.025,0.044,0.038c0.021,0.013,0.02,0.008,0.045,0c0.051-0.015,0.061-0.049,0.102-0.063\r\n\t\t\t\tc0.125-0.023,0.25-0.047,0.375-0.07c0.023-0.025,0.048-0.051,0.07-0.076c0.074-0.008,0.148-0.017,0.223-0.025\r\n\t\t\t\tc0.013-0.013,0.007-0.002,0.013-0.025c0.093-0.017,0.187-0.034,0.28-0.051c0.011,0.021,0.021,0.042,0.031,0.064\r\n\t\t\t\tc-0.099,0.079-0.25,0.146-0.412,0.152c-0.008,0.011-0.018,0.021-0.026,0.032c0.073,0.053,0.147,0.098,0.196,0.178\r\n\t\t\t\tc-0.033,0.026-0.076,0.034-0.139,0.032c-0.029,0.081-0.084,0.13-0.09,0.229c-0.049,0.026-0.154,0.037-0.21,0.051\r\n\t\t\t\tc0.044,0.059,0.104,0.147,0.159,0.197c0.043,0.008,0.057-0.002,0.089-0.019c0.041,0.027,0.058,0.069,0.095,0.095\r\n\t\t\t\tc0.045,0.013,0.09,0.025,0.133,0.038c0.105,0.049,0.192,0.14,0.281,0.21c0.047,0.038,0.115,0.138,0.178,0.133\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.014,0.057c0.102,0.075,0.311,0.102,0.381,0.21c0.016,0.053,0.03,0.106,0.045,0.159\r\n\t\t\t\tc0.08,0.289-0.088,0.388-0.324,0.445c-0.131,0.031-0.221-0.051-0.336-0.032c-0.053,0.017-0.106,0.034-0.159,0.051\r\n\t\t\t\tc-0.099,0.022-0.277-0.021-0.382-0.038c-0.125-0.021-0.15-0.13-0.291-0.076c-0.078-0.037-0.078-0.076-0.121-0.146\r\n\t\t\t\tc-0.029-0.021-0.103,0.03-0.172,0.013c-0.084-0.021-0.076-0.089-0.121-0.146c-0.174,0.111-0.323-0.021-0.541,0.032\r\n\t\t\t\tc-0.195,0.047-0.34,0.172-0.514,0.229c0.002,0.017,0.004,0.034,0.006,0.051c-0.139,0.074-0.203,0.007-0.318-0.013\r\n\t\t\t\tc-0.02,0.006-0.038,0.013-0.057,0.019c-0.094-0.008-0.187-0.017-0.28-0.025c-0.013,0.025-0.025,0.051-0.038,0.076\r\n\t\t\t\tc0.029,0.031,0.068,0.042,0.083,0.089c0.053-0.002,0.106-0.004,0.159-0.006v0.006c-0.072,0.023-0.189,0.032-0.28,0.032\r\n\t\t\t\tc-0.017,0.023-0.026,0.025-0.026,0.051c0.026,0.006,0.051,0.013,0.076,0.019c0.006,0.004,0.014,0.009,0.02,0.013\r\n\t\t\t\tc-0.006,0.008-0.014,0.017-0.02,0.025c-0.113-0.018-0.214-0.013-0.337-0.006c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.036-0.015-0.055-0.014-0.09-0.007c-0.002,0.004-0.004,0.009-0.006,0.013c0.014,0.006,0.026,0.013,0.039,0.019v0.019\r\n\t\t\t\tc-0.067,0.022-0.143,0.01-0.16-0.044c-0.09,0.011-0.202,0.041-0.254,0.095c-0.035,0.037,0.004,0.057-0.069,0.064\r\n\t\t\t\tc-0.011,0.071-0.028,0.13-0.032,0.191c0.087-0.013,0.174-0.025,0.262-0.038v0.006c-0.016,0.024-0.031,0.039-0.058,0.051\r\n\t\t\t\tc-0.015,0.017-0.03,0.034-0.045,0.051c0.035,0.006,0.049,0.02,0.063,0.045c0.015,0.023-0.006,0.02-0.013,0.064h0.058\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.025c-0.021,0.025-0.052,0.036-0.089,0.045c-0.008,0.025,0.01,0.054,0.038,0.076\r\n\t\t\t\tc0.034,0.045,0.026,0.031-0.019,0.063c-0.033-0.003-0.056-0.025-0.09-0.044c-0.011,0.023-0.021,0.047-0.031,0.07v0.045\r\n\t\t\t\tc0.104,0.013,0.133,0.046,0.221,0.07c0.004,0.06-0.021,0.124,0.007,0.165c0.034,0.021,0.067,0.042,0.103,0.064\r\n\t\t\t\tc0.002,0.008,0.004,0.017,0.006,0.025c-0.028,0.011-0.056,0.021-0.084,0.032c0.006,0.013,0.014,0.025,0.02,0.038\r\n\t\t\t\tc0.068,0.006,0.136,0.013,0.203,0.019c0.002,0.004,0.004,0.008,0.006,0.013c-0.018,0.019-0.023,0.019-0.032,0.051\r\n\t\t\t\tc0.007,0.015,0.013,0.03,0.019,0.045c0.004,0.002,0.01,0.004,0.014,0.006c0.021-0.021,0.042-0.042,0.064-0.063\r\n\t\t\t\tc0.084-0.003,0.086,0.023,0.146,0.051c0.028,0.014,0.049-0.015,0.076-0.038c0.024,0.059,0.051,0.119,0.075,0.178\r\n\t\t\t\tc0.1,0.031,0.23-0.025,0.3,0.019c0.013-0.002,0.026-0.004,0.038-0.006c0.015-0.072,0.029-0.144,0.044-0.216\r\n\t\t\t\tc0.142-0.018,0.288,0.018,0.388,0.083c0.073,0.048,0.107,0.143,0.203,0.172c0.136,0.041,0.301-0.026,0.381-0.045\r\n\t\t\t\tc0.042-0.082,0.104-0.102,0.159-0.165c0.138,0.001,0.177,0.055,0.286,0.07c0.037-0.038,0.085-0.067,0.121-0.114h0.025\r\n\t\t\t\tc0.012,0.017,0.024,0.034,0.037,0.051c0.002,0.013,0.004,0.025,0.006,0.038c-0.039,0.043-0.09,0.068-0.127,0.114\r\n\t\t\t\tc0.018,0.03,0.034,0.059,0.051,0.089c-0.011,0.057-0.037,0.107-0.063,0.153c0.087,0.115,0.021,0.195,0.076,0.33\r\n\t\t\t\tc-0.146,0.144-0.206,0.407-0.306,0.578c-0.008,0.042-0.017,0.085-0.024,0.127c-0.041,0.134-0.077,0.258-0.173,0.337\r\n\t\t\t\tc0.074,0.186,0.148,0.373,0.223,0.559c0.012,0.018,0.023,0.014,0.051,0.032c-0.023,0.137-0.084,0.285-0.095,0.407\r\n\t\t\t\tc0.036,0.002,0.071,0.004,0.108,0.006c0.047,0.059,0.093,0.119,0.14,0.178c0.104,0.17,0.188,0.32,0.299,0.477\r\n\t\t\t\tc0.084,0.118,0.206,0.226,0.165,0.413c0.085,0.117,0.223,0.149,0.324,0.248c0.066,0.119,0.131,0.237,0.197,0.356\r\n\t\t\t\tc0.065,0.127-0.002,0.313,0.051,0.457c0.051,0.072,0.102,0.144,0.152,0.216c0.069,0.096,0.225,0.114,0.299,0.203\r\n\t\t\t\tc0.089,0.182,0.178,0.364,0.267,0.546c0.034,0.026,0.067,0.051,0.103,0.076c0.086,0.071,0.194,0.232,0.234,0.344\r\n\t\t\t\tc0.012,0.067,0.021,0.135,0.032,0.202c-0.009,0.039-0.042,0.068-0.032,0.128c0.03,0.172,0.113,0.353,0.165,0.495v0.216\r\n\t\t\t\tc0.095,0.205,0.384,0.166,0.554,0.057c0.057-0.047,0.113-0.092,0.172-0.139c0.094-0.029,0.217,0.012,0.299-0.014\r\n\t\t\t\tc0.128-0.039,0.228-0.133,0.343-0.172c0.078-0.025,0.163,0.016,0.229-0.02c0.068-0.035,0.086-0.123,0.151-0.158\r\n\t\t\t\tc0.238-0.131,0.547-0.129,0.769-0.268c0.062-0.037,0.047-0.087,0.076-0.158c0.029-0.07,0.139-0.143,0.211-0.172\r\n\t\t\t\tc0.121-0.041,0.24-0.082,0.361-0.121c0.07,0.008,0.141,0.017,0.21,0.024c0.024-0.015,0.052-0.03,0.076-0.045\r\n\t\t\t\tc0.045-0.091,0.017-0.205,0.108-0.248c0.096-0.045,0.186,0.021,0.272-0.051c0.032-0.027,0.026-0.071,0.044-0.114\r\n\t\t\t\tc0.049-0.12,0.189-0.153,0.35-0.159c0.008-0.116-0.013-0.304,0.025-0.419c0.057-0.024,0.123,0.021,0.172-0.006\r\n\t\t\t\tc0.057-0.042,0.064-0.147,0.102-0.21c0.043-0.04,0.086-0.08,0.128-0.121c0.059-0.074,0.114-0.154,0.159-0.242\r\n\t\t\t\tc-0.012-0.066-0.116-0.088-0.159-0.127c-0.064-0.08-0.128-0.161-0.191-0.241c-0.048-0.033-0.104,0.008-0.165-0.006\r\n\t\t\t\tc-0.089-0.049-0.178-0.098-0.267-0.146c-0.071-0.049-0.183-0.161-0.21-0.248c-0.021-0.066,0.011-0.151-0.014-0.203\r\n\t\t\t\tc-0.015-0.018-0.023-0.019-0.057-0.019c0.044-0.068,0.068-0.116,0.057-0.229h-0.006c-0.045,0.057-0.089,0.115-0.133,0.172\r\n\t\t\t\tc-0.113,0.09-0.215,0.143-0.311,0.267c-0.023,0.045-0.047,0.089-0.07,0.134c-0.035,0.031-0.051,0.02-0.07,0.07\r\n\t\t\t\tc-0.041,0.011-0.062,0.014-0.095-0.006c-0.002,0.011-0.004,0.021-0.006,0.032c-0.074,0.026-0.394,0.021-0.478-0.019\r\n\t\t\t\tc-0.019,0.017-0.022,0.015-0.031,0.044c-0.073,0.007-0.131-0.005-0.203-0.006c0.013-0.058-0.016-0.063-0.064-0.076\r\n\t\t\t\tc-0.037-0.089,0.072-0.127,0.076-0.216c0.001-0.028-0.018-0.268-0.025-0.28c-0.018-0.025-0.035-0.018-0.051-0.057\r\n\t\t\t\tc-0.015-0.002-0.029-0.004-0.044-0.006c-0.083,0.059-0.118,0.288-0.069,0.407c0.006,0.07,0.01,0.094-0.051,0.089\r\n\t\t\t\tc-0.046-0.059-0.109-0.211-0.115-0.311c-0.033-0.027-0.035-0.039-0.076-0.032c-0.032-0.107-0.057-0.116-0.012-0.229\r\n\t\t\t\tc-0.014-0.021-0.026-0.042-0.039-0.064c0.021-0.031,0.039-0.029,0.045-0.076c-0.062-0.082-0.205-0.072-0.248-0.172\r\n\t\t\t\tc-0.035-0.028-0.025-0.027-0.006-0.064c-0.037-0.017-0.058-0.015-0.113-0.013c-0.07-0.185-0.159-0.356-0.211-0.553\r\n\t\t\t\tc-0.035,0.009-0.071,0.017-0.107,0.026c-0.013-0.006-0.025-0.013-0.038-0.019c0.021-0.026,0.042-0.051,0.063-0.076h0.044\r\n\t\t\t\tc-0.009-0.04-0.017-0.08-0.025-0.121c0.026-0.034,0.169-0.04,0.235-0.038c0.055-0.054,0.047-0.118,0.127-0.152h0.02\r\n\t\t\t\tc-0.002,0.041,0,0.074,0.019,0.095c0.038,0.072,0.165,0.061,0.241,0.032c0.043,0.069,0.144,0.143,0.172,0.21v0.102\r\n\t\t\t\tc0.031,0.082,0.137,0.259,0.191,0.337c0.064,0.091,0.221,0.082,0.312,0.146c0.047,0.057,0.093,0.115,0.14,0.172\r\n\t\t\t\tc0.105,0.063,0.211,0.06,0.337,0.102c0.07,0.023,0.11,0.086,0.197,0.095c0.042-0.036,0.187-0.121,0.196-0.172\r\n\t\t\t\tc0.099-0.035,0.203-0.075,0.324-0.044c0.051,0.012,0.039,0.034,0.09,0.038c0.015,0.043,0.01,0.1,0.031,0.159\r\n\t\t\t\tc0.026,0.069,0.096,0.113,0.096,0.21c0.067,0.011,0.135,0.056,0.184,0.076h0.254c0.025,0.023,0.051,0.047,0.076,0.07\r\n\t\t\t\tc0.143,0.002,0.284,0.004,0.426,0.007c0.075,0.02,0.118,0.067,0.217,0.083c0.131,0.021,0.254-0.027,0.355-0.044h0.286\r\n\t\t\t\tc0.057-0.021,0.1-0.057,0.19-0.07c0.08,0.167,0.549-0.018,0.687-0.025c0.073,0.053,0.075,0.102,0.069,0.223\r\n\t\t\t\tc0.047,0.011,0.094,0.021,0.141,0.032c0.023,0.068,0.047,0.136,0.07,0.203c0.05,0.067,0.113,0.032,0.19,0.076\r\n\t\t\t\tc0.03,0.042,0.06,0.085,0.089,0.127c0.104,0.123,0.381,0.229,0.598,0.153c0.002,0.052-0.021,0.064-0.051,0.095\r\n\t\t\t\tc-0.143,0.145-0.215,0.023-0.369,0.076h-0.014c0.049,0.113,0.434,0.501,0.572,0.508c0.04-0.015,0.081-0.03,0.121-0.044\r\n\t\t\t\tc0.145-0.047,0.383-0.127,0.254-0.299c0.008-0.03,0.018-0.059,0.025-0.089c0.031-0.019,0.082-0.021,0.14-0.019\r\n\t\t\t\tc-0.019,0.072-0.015,0.207,0.013,0.286c0.016,0.046,0.116,0.085,0.102,0.146c-0.014,0.062-0.094,0.113-0.102,0.191\r\n\t\t\t\tc0.027,0.146,0.055,0.292,0.083,0.438c0.034,0.205,0.068,0.411,0.103,0.616c0.07,0.251,0.209,0.444,0.305,0.655\r\n\t\t\t\tc0.064,0.143,0.116,0.299,0.165,0.457c0.021,0.078,0.042,0.156,0.063,0.234c0.039,0.055,0.076,0.11,0.114,0.165\r\n\t\t\t\tc0.074,0.163,0.148,0.326,0.222,0.489c0.033,0.111,0.064,0.225,0.096,0.337c0.059,0.063,0.119,0.127,0.178,0.19\r\n\t\t\t\tc0.09-0.002,0.219-0.063,0.248-0.127c0.025-0.054,0.004-0.105,0.038-0.146c0.083-0.028,0.165-0.056,0.248-0.083\r\n\t\t\t\tc-0.013-0.027-0.034-0.042-0.058-0.057c0.025-0.072,0.052-0.145,0.076-0.217c0.037-0.021,0.108-0.021,0.172-0.019\r\n\t\t\t\tc0.023-0.118-0.033-0.248-0.019-0.362c0.024-0.213,0.286-0.457,0.108-0.654c0.057-0.142-0.035-0.297,0-0.451\r\n\t\t\t\tc0.021-0.047,0.041-0.094,0.063-0.141c0.06-0.048,0.118-0.061,0.19-0.019c0.049-0.031,0.078-0.104,0.096-0.165\r\n\t\t\t\tc0.059-0.032,0.17-0.01,0.229-0.051c0.065-0.045,0.049-0.168,0.108-0.217c0.063-0.031,0.127-0.063,0.19-0.094\r\n\t\t\t\tc0.072-0.046,0.111-0.143,0.179-0.184c0.046-0.028,0.088-0.032,0.127-0.064c0.097-0.119,0.194-0.237,0.292-0.356\r\n\t\t\t\tc0.078-0.054,0.207-0.041,0.292-0.095c0.106-0.067,0.147-0.181,0.229-0.273c-0.014-0.045-0.025-0.089-0.039-0.134\r\n\t\t\t\tc0.072-0.072,0.18-0.083,0.268-0.14c0.032-0.034,0.064-0.068,0.096-0.102c0.028,0.022,0.049,0.059,0.057,0.102\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.037,0.013c0.018-0.03,0.035-0.059,0.052-0.089c0.002-0.004,0.004-0.008,0.006-0.013\r\n\t\t\t\tc0.034,0.02,0.042,0.065,0.051,0.108h0.089c-0.005-0.031-0.002-0.042,0.006-0.07c0.02,0.01,0.039,0.021,0.058,0.032\r\n\t\t\t\tc0.013-0.021,0.024-0.042,0.038-0.063c0.008-0.006,0.017-0.013,0.025-0.019c0.008,0.021,0.016,0.043,0.025,0.064h0.038\r\n\t\t\t\tc0.026-0.034,0.046-0.064,0.051-0.121c0.004-0.002,0.009-0.004,0.013-0.006c0.021,0.038,0.043,0.076,0.063,0.115h0.045\r\n\t\t\t\tc0.017-0.069,0.026-0.078,0.095-0.095c0.022-0.07-0.005-0.129-0.031-0.184c-0.002-0.034-0.004-0.067,0.013-0.083\r\n\t\t\t\tc0.004-0.004,0.009-0.009,0.013-0.013c0.032,0.042,0.064,0.085,0.096,0.127c0.069-0.001,0.1-0.022,0.146-0.044\r\n\t\t\t\tc0.175,0.137,0.122,0.639,0.362,0.705c0.021,0.006,0.054-0.002,0.076,0.006v0.083c0.053,0.035,0.082,0.001,0.127,0.025\r\n\t\t\t\tc0.067,0.037,0.106,0.146,0.133,0.229v0.006c-0.034,0.006-0.068,0.013-0.103,0.019c0.028,0.031,0.065,0.053,0.108,0.07\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.031-0.057c0.004-0.002,0.01-0.004,0.014-0.006c0.079,0.128,0.174,0.362,0.146,0.578\r\n\t\t\t\tc-0.018,0.129-0.099,0.221-0.103,0.361c0.015,0.012,0.03,0.021,0.044,0.033c0.047-0.039,0.073-0.066,0.152-0.076\r\n\t\t\t\tc-0.006,0.024-0.012,0.051-0.019,0.076c0.011,0.011,0.021,0.021,0.032,0.031h0.025c0.029-0.023,0.031-0.041,0.082-0.044v0.058\r\n\t\t\t\tc0.08,0.072,0.095-0.08,0.153-0.121c0.185-0.133,0.273-0.031,0.306-0.344H56.3c0.085,0.062,0.089,0.235,0.197,0.268\r\n\t\t\t\tc0.026,0.18,0.051,0.359,0.075,0.54c0.048,0.163,0.152,0.309,0.203,0.45c0.054,0.145,0.031,0.291,0.025,0.433\r\n\t\t\t\tc0.02,0.01,0.036,0.013,0.07,0.013c-0.033,0.078-0.145,0.34-0.114,0.413c0.017,0.013,0.034,0.025,0.052,0.038\r\n\t\t\t\tc-0.064,0.162-0.162,0.391-0.103,0.566c0.024-0.012,0.051-0.021,0.075-0.032c0.086,0.091,0.166,0.136,0.211,0.272\r\n\t\t\t\tc0.02,0.008,0.033,0.01,0.064,0c0.043,0.058,0.051,0.1,0.051,0.197c0.011,0.006,0.021,0.014,0.031,0.02\r\n\t\t\t\tc0.034,0.043,0.078,0.029,0.121,0.006c0.004,0.004,0.008,0.008,0.014,0.013c-0.019,0.14-0.008,0.3,0.043,0.445\r\n\t\t\t\tc0.025,0.047,0.052,0.093,0.076,0.14c0.01,0.069-0.023,0.131,0.014,0.191c0.039,0.033,0.08,0.068,0.121,0.102\r\n\t\t\t\tc0.016,0.021,0.021,0.057,0.031,0.088C55.357,48.795,44.764,58,32,58z M20.929,9.847c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.002,0.003,0.004,0.006,0.006,0.009c-0.001,0-0.002,0-0.003,0C20.933,9.853,20.931,9.85,20.929,9.847z M43.915,25.038\r\n\t\t\t\tc-0.028,0.012-0.031-0.019-0.069-0.013c-0.035,0.011-0.068,0.021-0.103,0.032c-0.005-0.002-0.009-0.004-0.013-0.006\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.014-0.004-0.026-0.008-0.039-0.013c-0.004,0.017-0.008,0.034-0.013,0.051\r\n\t\t\t\tc-0.048-0.011-0.054-0.013-0.108-0.006c-0.017-0.034-0.033-0.068-0.051-0.102c-0.066,0.075-0.078,0.271-0.043,0.369\r\n\t\t\t\tc0.038,0.021,0.133,0.008,0.215,0.006c-0.015,0.019-0.029,0.038-0.043,0.057c0.004,0.013,0.008,0.025,0.012,0.038\r\n\t\t\t\tc0.015,0.023,0.043,0.036,0.07,0.045v0.019c-0.045-0.004-0.088-0.008-0.133-0.013c-0.011,0.015-0.021,0.03-0.031,0.045v0.044\r\n\t\t\t\tc0.041-0.029,0.065-0.018,0.127-0.006c0.023,0.067,0.084,0.076,0.113,0.133c0.014,0.054-0.037,0.118-0.037,0.203\r\n\t\t\t\tc0,0.04-0.022,0.09-0.02,0.108c0.018,0.102,0.109,0.354,0.025,0.419c-0.062,0.047-0.192,0.025-0.281,0.045\r\n\t\t\t\tc-0.313,0.07-0.747,0.1-0.857-0.197c-0.119-0.032-0.251-0.062-0.35-0.095c-0.053-0.198,0.057-0.392,0.057-0.559\r\n\t\t\t\tc0.006-0.004,0.014-0.008,0.02-0.013c0.017,0.015,0.019,0.017,0.024,0.044c0.007,0.004,0.013,0.008,0.019,0.013\r\n\t\t\t\tc0.007-0.03,0.014-0.059,0.02-0.089c0.02-0.009,0.021-0.011,0.044-0.006c-0.012-0.168,0.011-0.45,0.28-0.337h0.006\r\n\t\t\t\tc-0.002-0.011-0.004-0.021-0.006-0.032c-0.057-0.128-0.189-0.036-0.242-0.108c-0.029-0.042-0.076-0.085-0.095-0.127\r\n\t\t\t\tc-0.023-0.049-0.009-0.096-0.038-0.133c-0.041-0.053-0.105-0.142-0.159-0.184c-0.019-0.006-0.038-0.013-0.058-0.019\r\n\t\t\t\tc-0.049-0.07-0.076-0.16-0.139-0.216c-0.016-0.004-0.031-0.009-0.045-0.013c-0.031-0.047,0.006-0.079-0.044-0.108\r\n\t\t\t\tc-0.057-0.081-0.018-0.217,0.019-0.311v-0.019H41.92c-0.011,0.038-0.021,0.076-0.031,0.114h-0.007\r\n\t\t\t\tc-0.001-0.113-0.014-0.227-0.114-0.286c-0.031-0.019-0.074-0.01-0.088-0.045v-0.032c0.004-0.075,0.082-0.081,0.113-0.127\r\n\t\t\t\tc0.062-0.092,0.092-0.195,0.121-0.286c0.004-0.006,0.008-0.013,0.013-0.019c0.105,0.051,0.2-0.03,0.28-0.076\r\n\t\t\t\tc0.016,0.008,0.029,0.017,0.044,0.025c0.017-0.02,0.021-0.029,0.019-0.07c0.103-0.023,0.135-0.121,0.217-0.153\r\n\t\t\t\tc0.039-0.002,0.08-0.004,0.121-0.006c0.129-0.041,0.242-0.21,0.412-0.197c0.097,0.007,0.138,0.073,0.211,0.089\r\n\t\t\t\tc0.076,0.017,0.097-0.038,0.133-0.051c0.057,0.013,0.113,0.025,0.172,0.038c0.015,0.025,0.029,0.051,0.045,0.076\r\n\t\t\t\tc-0.018,0.017-0.034,0.034-0.051,0.051c0.047,0.164,0.01,0.207-0.084,0.33c0.005,0.058,0.07,0.083,0.115,0.095\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.139-0.013-0.275-0.025-0.414-0.038c-0.037,0.007-0.047,0.027-0.102,0.026\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.037,0.102c-0.029,0.036-0.058,0.02-0.076,0.076c0.026,0.039,0.063,0.068,0.113,0.083\r\n\t\t\t\tc0.006,0.008,0.014,0.017,0.02,0.026c-0.062,0.044-0.215-0.025-0.338-0.019c-0.006,0.006-0.012,0.013-0.019,0.019v0.083\r\n\t\t\t\tc0.039,0.026,0.134,0.043,0.185,0.051c0.027,0.155,0.139,0.203,0.133,0.368h0.089c0.037,0.027,0.071,0.069,0.089,0.114\r\n\t\t\t\tc0.089,0.012,0.165-0.009,0.234,0.064c-0.033,0.064-0.069,0.143-0.094,0.203c0.022,0.038-0.002,0.077,0.019,0.121\r\n\t\t\t\tc0.013,0.006,0.026,0.013,0.038,0.019c-0.002,0.019-0.004,0.038-0.006,0.057c0.013,0.029,0.055,0.079,0.076,0.114v0.013\r\n\t\t\t\tc0.026-0.072,0.01-0.226,0.031-0.305c0.088-0.015,0.174-0.031,0.273-0.025c0.015,0.056,0.023,0.174,0.051,0.216\r\n\t\t\t\tc0.046,0.071,0.146,0.075,0.197,0.178c-0.016,0.031-0.026,0.037-0.057,0.051c-0.041-0.008-0.043-0.024-0.084-0.032\r\n\t\t\t\tC43.898,24.987,43.907,25.012,43.915,25.038z M35.799,24.777c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc-0.024-0.022-0.041-0.037-0.083-0.045c0.004-0.011,0.009-0.021,0.013-0.032c0.017,0.008,0.034,0.017,0.052,0.025\r\n\t\t\t\tC35.788,24.751,35.789,24.757,35.799,24.777z M57.643,35.618c-0.367,0.016-0.324-0.226-0.388-0.502\r\n\t\t\t\tc-0.013,0.004-0.024,0.008-0.038,0.013c-0.056-0.044-0.033-0.145-0.051-0.222c-0.062,0.004-0.119,0.022-0.178,0.013\r\n\t\t\t\tc-0.153-0.249,0.123-0.633,0.191-0.826c-0.005-0.053-0.01-0.105-0.014-0.158c0.02-0.082,0.062-0.115,0.025-0.217\r\n\t\t\t\tc0.092-0.07,0.145-0.061,0.291-0.051c-0.006,0.076-0.012,0.152-0.019,0.229c0.058,0.002,0.08,0.024,0.121,0.033\r\n\t\t\t\tc0.078,0.014,0.106-0.055,0.19-0.007c0.039,0.04,0.076,0.08,0.115,0.121c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc-0.043,0.556-0.11,1.104-0.188,1.649C57.688,35.667,57.663,35.645,57.643,35.618z M8.363,28.628\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.363z M8.35,28.59c-0.001-0.011-0.009-0.009-0.011-0.018\r\n\t\t\t\tc0.001,0.006,0.003,0.012,0.004,0.018H8.35z M42.555,41.414c-0.037-0.059-0.106-0.061-0.14-0.133\r\n\t\t\t\tc-0.067-0.055-0.062-0.042-0.127,0.013c0.009,0.101,0.008,0.235-0.07,0.299c-0.044,0.036-0.079,0.04-0.102,0.103\r\n\t\t\t\tc-0.039-0.014-0.048-0.034-0.063-0.07c-0.019-0.002-0.037-0.004-0.057-0.006c-0.003,0.068,0.016,0.109,0.038,0.165\r\n\t\t\t\tc-0.005,0.011-0.009,0.021-0.013,0.032c-0.024,0.016-0.041,0.024-0.084,0.024c-0.002,0.005-0.004,0.009-0.006,0.013\r\n\t\t\t\tc0.004,0.045,0.026,0.06,0.045,0.103c-0.022,0.024-0.047,0.051-0.069,0.076c-0.039-0.005-0.04-0.009-0.052-0.038H41.85\r\n\t\t\t\tc-0.031,0.027-0.062,0.055-0.095,0.083c0.009,0.034,0.022,0.045,0.038,0.069c-0.014,0.01-0.025,0.018-0.038,0.026\r\n\t\t\t\tc-0.024,0.011-0.026-0.009-0.063-0.019c-0.047,0.029-0.094,0.059-0.141,0.089c0.004,0.024,0.01,0.051,0.014,0.075\r\n\t\t\t\tc-0.071,0.018-0.121-0.053-0.211-0.012c-0.017,0.019-0.033,0.037-0.051,0.057c-0.039,0.02-0.074-0.014-0.107-0.014\r\n\t\t\t\tc-0.025,0.02-0.051,0.039-0.076,0.058c-0.044,0.002-0.09,0.004-0.133,0.006c0,0.213-0.084,0.245-0.141,0.381\r\n\t\t\t\tc-0.025,0.101,0.069,0.325,0.121,0.388c-0.015,0.032-0.029,0.064-0.044,0.096c0.032,0.039,0.063,0.076,0.095,0.115\r\n\t\t\t\tc0.03,0.114-0.166,0.512-0.216,0.559c-0.024,0.009-0.051,0.017-0.075,0.025c-0.045,0.031-0.103,0.232-0.09,0.311\r\n\t\t\t\tc0.053,0.097,0.106,0.195,0.159,0.292c-0.013,0.049-0.024,0.097-0.038,0.146c-0.031,0.145,0.061,0.157,0.083,0.229\r\n\t\t\t\tc0.017,0.051-0.006,0.092,0.019,0.127c0.084,0.119,0.263,0.084,0.344,0.21c0.137-0.008,0.17-0.09,0.285-0.121\r\n\t\t\t\tc0.07-0.009,0.141-0.018,0.211-0.025c0.132-0.082,0.205-0.498,0.261-0.674c0.149-0.486,0.302-0.971,0.451-1.455\r\n\t\t\t\tc0.028-0.096-0.011-0.189,0.019-0.3c0.026-0.093,0.125-0.146,0.146-0.254c-0.047-0.071-0.09-0.157-0.09-0.272\r\n\t\t\t\tc0.012-0.006,0.021-0.014,0.033-0.02c0.004-0.004,0.008-0.009,0.013-0.013c0.028,0.053,0.069,0.133,0.12,0.165\r\n\t\t\t\tc0.035-0.029,0.115-0.123,0.103-0.191c-0.026-0.053-0.055-0.105-0.083-0.158C42.622,41.831,42.634,41.518,42.555,41.414z\r\n\t\t\t\t M10.068,26.772c0.002,0.004,0.003,0.011,0.005,0.016v-0.016H10.068z M8.337,28.565c0,0.001-0.001,0.002-0.001,0.002\r\n\t\t\t\tc0.001,0.003,0.003,0.003,0.003,0.005C8.339,28.57,8.338,28.567,8.337,28.565z M8.356,28.609\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.356z M14.998,24.644c-0.002-0.004-0.004-0.009-0.006-0.013\r\n\t\t\t\tc-0.021-0.006-0.042-0.013-0.064-0.019c-0.026,0.019-0.046,0.037-0.057,0.07c-0.004,0.002-0.009,0.004-0.013,0.006\r\n\t\t\t\tc-0.032-0.041-0.059-0.112-0.076-0.165v-0.007c0.122-0.058,0.118-0.025,0.216-0.114V24.37c-0.015-0.006-0.03-0.013-0.045-0.019\r\n\t\t\t\tc-0.042,0.02-0.082,0.042-0.14,0.045c-0.035-0.024-0.077-0.055-0.095-0.095c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.049-0.04,0.097-0.081,0.146-0.121c0.013-0.015,0.026-0.03,0.038-0.045c-0.085-0.053-0.196-0.098-0.331-0.083\r\n\t\t\t\tc-0.013,0.023-0.025,0.047-0.038,0.07c-0.139,0.028-0.257-0.06-0.343-0.127v-0.019c0.036-0.036,0.072-0.072,0.108-0.108\r\n\t\t\t\tc-0.044-0.017-0.089-0.034-0.133-0.051c-0.111,0.022-0.1,0.134-0.21,0.159c-0.006-0.249,0.344-0.399,0.241-0.604\r\n\t\t\t\tc0.046-0.013,0.102-0.029,0.14-0.045c0.002-0.008,0.004-0.017,0.006-0.025c-0.004-0.011-0.009-0.021-0.013-0.032\r\n\t\t\t\tc-0.013-0.004-0.025-0.008-0.038-0.013c-0.078,0.021-0.157,0.042-0.235,0.064c-0.19,0.122-0.428,0.489-0.508,0.724\r\n\t\t\t\tc0.032,0.038,0.063,0.076,0.095,0.114c-0.085,0.09-0.178,0.003-0.235,0.165c-0.004,0.008-0.008,0.017-0.013,0.025\r\n\t\t\t\tc0.049,0.013,0.098,0.025,0.146,0.038c-0.09,0.09-0.264,0.111-0.324,0.229c-0.016,0.029,0.012,0.075,0.026,0.114\r\n\t\t\t\tc0.097-0.011,0.195-0.021,0.292-0.032c0.121,0.017,0.242,0.034,0.362,0.051c0.11,0.02,0.23-0.003,0.248-0.083\r\n\t\t\t\tc0.034-0.004,0.068-0.008,0.102-0.013v0.096c0.004,0.006,0.008,0.013,0.013,0.019c0.013-0.002,0.025-0.004,0.038-0.006\r\n\t\t\t\tc0.033-0.011,0.042-0.037,0.051-0.07c0.057,0.006,0.114,0.013,0.172,0.019v0.013c-0.121,0.055-0.153,0.168-0.305,0.21\r\n\t\t\t\tc-0.012,0.026-0.007,0.015,0,0.045c0.033,0.016,0.082,0.021,0.133,0.019c0.096-0.105,0.276-0.194,0.343-0.311\r\n\t\t\t\tc0.011,0.004,0.021,0.008,0.032,0.013c0.021,0.028,0.042,0.055,0.064,0.083c-0.002,0.068-0.031,0.109-0.064,0.146\r\n\t\t\t\tc0.002,0.017,0.004,0.034,0.006,0.051c0.017,0.002,0.034,0.004,0.051,0.006c0.025-0.021,0.051-0.042,0.076-0.063\r\n\t\t\t\tc0.004,0.036,0.008,0.072,0.013,0.108c0.053,0.015,0.106,0.03,0.159,0.045c0.031-0.093,0.108-0.194,0.095-0.299\r\n\t\t\t\tC14.985,24.767,14.974,24.733,14.998,24.644z M30.531,24.606c-0.011,0.008-0.021,0.017-0.032,0.025\r\n\t\t\t\tc0.014,0.032,0.014,0.022,0.057,0.019v0.006c-0.011,0.011-0.021,0.021-0.032,0.032c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.021,0.009,0.042,0.017,0.063,0.026c-0.011,0.015-0.021,0.03-0.032,0.044c0.011,0.009,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.019,0.002,0.038,0.004,0.057,0.006v0.032c0.013,0.002,0.025,0.004,0.038,0.006c0.109-0.111,0.08-0.372,0.076-0.559\r\n\t\t\t\tc-0.008-0.006-0.017-0.013-0.025-0.019c-0.004,0.002-0.008,0.004-0.013,0.006c-0.004,0.03-0.008,0.059-0.013,0.089\r\n\t\t\t\tc-0.002,0.003-0.171,0.074-0.21,0.114c0.001,0.025,0.001,0.024,0.019,0.044c-0.009,0.007-0.017,0.013-0.026,0.019\r\n\t\t\t\tC30.493,24.58,30.509,24.579,30.531,24.606z M35.215,27.014c0.143-0.008,0.284-0.017,0.426-0.025\r\n\t\t\t\tc0.018-0.028,0.025-0.06,0.032-0.102c-0.045,0.028-0.097,0.035-0.146,0.064c-0.008-0.004-0.018-0.009-0.025-0.013\r\n\t\t\t\tc0.004-0.017,0.01-0.034,0.014-0.051c-0.002-0.002-0.004-0.004-0.007-0.006c-0.098,0.011-0.135,0.002-0.21-0.032\r\n\t\t\t\tc-0.07,0.006-0.14,0.013-0.21,0.019c-0.021-0.019-0.014-0.025-0.051-0.032c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c-0.015,0.008-0.03,0.017-0.044,0.026c-0.034-0.012-0.057-0.014-0.076-0.038v-0.013\r\n\t\t\t\tc-0.011,0.013-0.01,0.012-0.013,0.038h-0.032c-0.006,0.032-0.013,0.063-0.02,0.095c0.088,0.039,0.261,0.031,0.356,0.07\r\n\t\t\t\tL35.215,27.014L35.215,27.014z M32.367,26.423c0.035-0.028,0.056-0.073,0.095-0.095c0.013-0.037-0.026-0.055-0.045-0.095\r\n\t\t\t\tc-0.036-0.095,0.072-0.224,0.103-0.292v-0.006c-0.059-0.014-0.121,0.013-0.172,0.025c-0.214,0.053-0.3,0.057-0.458-0.044\r\n\t\t\t\tc-0.091,0.081-0.209,0.007-0.254,0.152c0.043,0.085,0.104,0.06,0.191,0.102C32.004,26.254,32.172,26.367,32.367,26.423z\r\n\t\t\t\t M21.217,10.482c0.035-0.019,0.07-0.038,0.105-0.057c0.055-0.019,0.109-0.037,0.164-0.056c0.003-0.008,0.007-0.017,0.01-0.025\r\n\t\t\t\tc-0.104,0.008-0.218,0.043-0.302,0.036c-0.066,0.038-0.132,0.076-0.197,0.114c-0.025,0.014-0.069,0.026-0.071,0.048\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c0.045-0.002,0.096-0.023,0.138-0.036C21.123,10.502,21.17,10.492,21.217,10.482z\r\n\t\t\t\t M16.682,18.341c-0.01,0.031-0.094,0.043-0.109,0.087c0.001,0.002,0.001,0.003,0.002,0.005c0.076-0.011,0.12-0.032,0.157-0.06\r\n\t\t\t\tc0.001-0.015-0.005-0.022-0.016-0.032C16.705,18.339,16.7,18.338,16.682,18.341z M30.575,25.66\r\n\t\t\t\tc0.019-0.025,0.038-0.051,0.057-0.076c0.054-0.026,0.099,0,0.146,0.013c0.02-0.058,0.068-0.112,0.057-0.197\r\n\t\t\t\tc-0.006-0.047-0.013-0.093-0.019-0.14c0.006-0.036,0.036-0.069,0.044-0.095c0.031-0.095-0.097-0.241-0.153-0.26\r\n\t\t\t\tc-0.085,0.08-0.164,0.087-0.311,0.114c-0.004,0.004-0.008,0.008-0.013,0.013c0.017,0.081,0.077,0.106,0.095,0.197\r\n\t\t\t\tC30.517,25.416,30.356,25.615,30.575,25.66z M30.512,36.559c-0.028,0.032-0.044,0.092-0.089,0.108v0.058\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.012c0.082-0.01,0.066-0.094,0.127-0.127C30.57,36.578,30.553,36.568,30.512,36.559z\r\n\t\t\t\t M26.304,19.147c0.035-0.024,0.05-0.049,0.076-0.083c0.002-0.004,0.004-0.009,0.006-0.013c0.025,0.017,0.051,0.034,0.076,0.051\r\n\t\t\t\tc-0.033,0.09-0.136,0.211-0.089,0.305v0.013c0.082-0.047,0.165-0.094,0.235-0.152h0.025c0.006,0.028,0.013,0.055,0.019,0.083\r\n\t\t\t\tc-0.02,0.027-0.04,0.046-0.076,0.057c-0.009,0.057,0.008,0.105,0.051,0.127c0.034,0.062-0.106,0.181-0.121,0.28\r\n\t\t\t\tc0.051,0.013,0.102,0.025,0.153,0.038c0.024-0.018,0.033-0.026,0.038-0.064c0.038,0.011,0.076,0.021,0.114,0.032\r\n\t\t\t\tc0.138-0.008,0.086-0.079,0.267-0.032c-0.045,0.057-0.103,0.092-0.121,0.178c0.025,0.053,0.055,0.069,0.089,0.108\r\n\t\t\t\tc0.036-0.007,0.072-0.013,0.108-0.019h0.006c-0.005,0.156-0.076,0.23-0.013,0.356v0.006c-0.215,0.003-0.415,0.024-0.489,0.172\r\n\t\t\t\tv0.006h0.133v0.013c0.023,0.036,0.008,0.103,0.006,0.159c-0.078,0.113-0.267,0.119-0.299,0.178\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.025,0.021,0.051,0.042,0.076,0.064c0.085,0.002,0.169,0.004,0.254,0.006\r\n\t\t\t\tc0.061,0.03,0.123,0.059,0.184,0.089h0.013c0.09-0.005,0.137-0.049,0.203-0.076c-0.029,0.06-0.086,0.099-0.089,0.172\r\n\t\t\t\tc-0.131,0.033-0.232-0.046-0.343,0.006c-0.036,0.041-0.02,0.083-0.095,0.07c-0.013,0.136-0.232,0.282-0.35,0.318\r\n\t\t\t\tc-0.002,0.004-0.004,0.009-0.006,0.013c0.032,0.009,0.064,0.017,0.095,0.026c0.015,0.015,0.03,0.03,0.045,0.045\r\n\t\t\t\tc0.052-0.069,0.127-0.122,0.216-0.153c0.045,0.021,0.07,0.005,0.095-0.013c0.108,0.059,0.203,0.111,0.21-0.089\r\n\t\t\t\tc0.2-0.024,0.253-0.004,0.439,0.013c-0.004-0.015-0.009-0.03-0.013-0.044c0.085-0.013,0.17-0.025,0.254-0.038\r\n\t\t\t\tc0.048-0.007,0.063,0.026,0.095,0.032c0.042-0.011,0.085-0.021,0.127-0.032c0.061,0.009,0.123,0.017,0.184,0.025\r\n\t\t\t\tc0.074-0.014,0.1-0.073,0.203-0.064c0.004-0.059,0.085-0.077,0.133-0.089V21.17h-0.013c-0.014-0.009-0.237-0.029-0.299-0.032\r\n\t\t\t\tV21.13c0.107-0.031,0.369-0.204,0.4-0.299c-0.006-0.055-0.013-0.11-0.019-0.165c-0.087-0.068-0.271-0.169-0.369-0.032\r\n\t\t\t\tc-0.034-0.007-0.068-0.013-0.102-0.019c0.135-0.201,0.055-0.175-0.076-0.318c-0.002-0.002,0.009-0.153-0.025-0.203\r\n\t\t\t\tc-0.049-0.064-0.097-0.127-0.146-0.191c-0.055-0.03-0.115-0.006-0.153-0.051c-0.069-0.084-0.056-0.196-0.095-0.299\r\n\t\t\t\tc-0.031-0.053-0.237-0.227-0.318-0.222c-0.131,0.007-0.14,0.075-0.305,0.006c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.123,0.003,0.258-0.01,0.311-0.076c0.004-0.002,0.008-0.004,0.013-0.006c-0.034-0.019-0.068-0.038-0.102-0.057\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.198-0.003,0.277-0.285,0.331-0.426c0.013-0.025,0.001-0.021-0.013-0.051\r\n\t\t\t\tc-0.1-0.073-0.46-0.024-0.623-0.025c-0.006-0.009-0.013-0.017-0.019-0.025c0.017-0.197,0.253-0.175,0.324-0.311\r\n\t\t\t\tc0.035-0.032,0.013-0.032-0.006-0.07c-0.129-0.052-0.288,0.077-0.407,0.045c-0.038-0.023-0.076-0.047-0.114-0.07\r\n\t\t\t\tc-0.019,0.025-0.038,0.051-0.057,0.076c0.019,0.03,0.038,0.059,0.057,0.089c-0.04,0.013-0.08,0.025-0.121,0.038\r\n\t\t\t\tc0.025,0.051,0.051,0.102,0.076,0.152c-0.05,0.002-0.083-0.003-0.127-0.019c-0.039,0.01-0.054,0.039-0.07,0.07\r\n\t\t\t\tc0.027,0.032,0.055,0.064,0.083,0.095c-0.019,0.03-0.061,0.028-0.076,0.051c0.009,0.04,0.017,0.08,0.026,0.121\r\n\t\t\t\tc0,0-0.102,0.182-0.114,0.203C26.262,19.126,26.283,19.136,26.304,19.147z M23.552,15.69c0.122,0.059,0.229,0.003,0.261-0.114\r\n\t\t\t\tc0.002-0.025,0.004-0.051,0.006-0.076c0.061-0.015,0.123-0.03,0.184-0.045c0.041-0.073,0.083-0.252,0.019-0.337\r\n\t\t\t\tc-0.041-0.048-0.155-0.016-0.222-0.038c-0.027-0.017-0.055-0.034-0.083-0.051c-0.016-0.036-0.003-0.092,0.013-0.134\r\n\t\t\t\tc-0.008-0.015-0.017-0.03-0.025-0.045c-0.139-0.061-0.251-0.035-0.311-0.172c-0.039-0.024-0.106-0.033-0.172-0.032v0.159\r\n\t\t\t\tc-0.129,0.091-0.311,0.046-0.483,0.025c0.022,0.049,0.05,0.087,0.044,0.146c-0.091-0.002-0.162-0.057-0.191-0.121\r\n\t\t\t\tc-0.062-0.048-0.149-0.012-0.216,0.038c0.011,0.034,0.021,0.068,0.032,0.102v0.007c-0.017,0.006-0.034,0.013-0.051,0.019\r\n\t\t\t\tc-0.074-0.049-0.145-0.122-0.178-0.21h-0.006c-0.017,0.011-0.034,0.021-0.051,0.032c-0.031,0.052-0.008,0.145-0.006,0.229\r\n\t\t\t\tc-0.045,0.048-0.112,0.04-0.172,0.076c-0.032,0.029-0.064,0.059-0.095,0.089c-0.034-0.049-0.068-0.097-0.102-0.146\r\n\t\t\t\tc-0.02-0.043,0.074-0.098,0.057-0.178c-0.035-0.162-0.262-0.199-0.413-0.241c-0.015,0.017-0.03,0.034-0.044,0.051\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.042,0.031,0.085,0.071,0.102,0.127v0.006c-0.138,0.096-0.242-0.171-0.324,0.006\r\n\t\t\t\tc0.025,0.034,0.051,0.068,0.076,0.102c0.006,0.006,0.013,0.013,0.019,0.019c-0.08,0.017-0.198,0.021-0.261,0.051\r\n\t\t\t\tc-0.006,0.028-0.008,0.049,0.006,0.07c0.103,0.167,0.277-0.021,0.451,0.007c0.098,0.015,0.167,0.047,0.241,0.076\r\n\t\t\t\tc0.004,0.021,0.009,0.043,0.013,0.064c-0.006,0.019-0.013,0.038-0.019,0.057c-0.108,0.081-0.481,0.067-0.534,0.165\r\n\t\t\t\tc-0.002,0.006-0.004,0.013-0.006,0.019c0.008,0.013,0.017,0.025,0.025,0.038c0.081,0.034,0.262-0.022,0.349-0.038\r\n\t\t\t\tc0.073,0.086,0.103,0.124,0.254,0.14c-0.088,0.128-0.197,0.136-0.292,0.235c0.102,0.124,0.465,0.012,0.616,0.07\r\n\t\t\t\tc0.049,0.034,0.097,0.068,0.146,0.102c0.079,0.046,0.211,0.06,0.311,0.076c0.267,0.044,0.261-0.127,0.369-0.172\r\n\t\t\t\tc0.102-0.013,0.203-0.025,0.305-0.038C23.322,15.873,23.442,15.767,23.552,15.69z M25.078,20.894\r\n\t\t\t\tc-0.023,0.009-0.047,0.017-0.07,0.026c-0.007,0.033,0.006,0.053,0.013,0.089c0.036-0.004,0.072-0.008,0.108-0.013\r\n\t\t\t\tc0.017,0.048,0.015,0.085,0.013,0.146c0.12-0.007,0.193-0.047,0.273-0.07c0.034-0.002,0.068-0.004,0.102-0.006\r\n\t\t\t\tc0.076-0.055,0.153-0.11,0.229-0.165c0.074-0.007,0.148-0.013,0.222-0.019c0.008-0.013,0.017-0.025,0.025-0.038\r\n\t\t\t\tc0.049-0.002,0.097-0.004,0.146-0.006c0.016-0.107,0.079-0.154,0.102-0.229c0.037-0.123-0.067-0.364-0.121-0.439\r\n\t\t\t\tc0.126-0.037,0.169-0.056,0.229-0.159c-0.018-0.123-0.068-0.218-0.102-0.324c-0.094-0.067-0.283-0.037-0.4,0.013\r\n\t\t\t\tc-0.064-0.001-0.088-0.026-0.102-0.076c-0.149,0.013-0.194,0.075-0.229,0.203c-0.025,0.006-0.051,0.013-0.076,0.019\r\n\t\t\t\tc-0.006,0.009-0.013,0.017-0.019,0.025h0.184c-0.025,0.064-0.066,0.089-0.133,0.108c-0.001,0.021,0.008,0.04,0.019,0.063\r\n\t\t\t\tc-0.128-0.01-0.273-0.013-0.375-0.051c-0.045,0.036-0.065,0.068-0.083,0.134v0.038c0.057-0.015,0.088-0.022,0.127,0.013h0.013\r\n\t\t\t\tc-0.037,0.042-0.05,0.035-0.038,0.102c-0.03,0.006-0.059,0.013-0.089,0.019c0.008,0.009,0.017,0.017,0.025,0.025\r\n\t\t\t\tc-0.013,0.017-0.025,0.034-0.038,0.051c0.051,0.024,0.293,0.068,0.343,0.038c0.006,0.017,0.013,0.034,0.019,0.051\r\n\t\t\t\tc-0.083,0.035-0.129,0.014-0.165,0.095c-0.008,0.022-0.004,0.012,0.013,0.038c-0.013,0.019-0.025,0.038-0.038,0.057\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.047-0.006,0.093-0.013,0.14-0.019c-0.018,0.068-0.092,0.065-0.159,0.076\r\n\t\t\t\tc-0.021,0.026-0.02,0.078-0.044,0.102c-0.032,0.024-0.13,0.015-0.184,0.013c-0.002,0.015-0.004,0.03-0.006,0.044\r\n\t\t\t\tc0.047,0.002,0.093,0.004,0.14,0.006L25.078,20.894L25.078,20.894z M26.336,19.465c-0.008,0.048-0.009,0.074,0,0.121\r\n\t\t\t\tc0.011,0.002,0.021,0.004,0.032,0.006c0.011-0.013,0.021-0.025,0.032-0.038c-0.004-0.034-0.009-0.068-0.013-0.102\r\n\t\t\t\tC26.37,19.456,26.353,19.46,26.336,19.465z M37.611,27.116c0.022-0.013,0.016-0.005,0.019-0.038\r\n\t\t\t\tc0.146-0.004,0.169-0.092,0.292-0.102c-0.015-0.019-0.029-0.038-0.045-0.057c0.053-0.068,0.135-0.101,0.191-0.165\r\n\t\t\t\tc-0.101,0.036-0.199,0.072-0.299,0.108c-0.06-0.006-0.119-0.013-0.179-0.019c0.011,0.023,0.013,0.039,0,0.064\r\n\t\t\t\tc-0.006,0.006-0.171,0.045-0.184,0.045c0.012,0.053,0.028,0.071,0.045,0.114C37.497,27.08,37.576,27.089,37.611,27.116z\r\n\t\t\t\t M8.363,28.654h0.006c-0.002-0.006-0.004-0.013-0.006-0.019V28.654z M14.54,13.788c0.035-0.025,0.102-0.125,0.045-0.175\r\n\t\t\t\tc-0.059,0.063-0.171,0.08-0.068,0.171C14.525,13.786,14.532,13.787,14.54,13.788z M8.375,28.698h0.006\r\n\t\t\t\tc-0.004-0.015-0.008-0.029-0.013-0.044C8.371,28.668,8.373,28.683,8.375,28.698z M8.433,28.838\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.023-0.051-0.047-0.102-0.07-0.153C8.389,28.761,8.414,28.792,8.433,28.838z\r\n\t\t\t\t M21.4,11.563c-0.005,0-0.01,0.001-0.015,0.001c-0.058,0.053-0.117,0.105-0.175,0.158c-0.053,0.024-0.106,0.048-0.158,0.072\r\n\t\t\t\tc-0.038,0.029-0.035,0.1-0.05,0.136c-0.008,0.019-0.056,0.102-0.048,0.112c0.02,0.01,0.135-0.027,0.152-0.034\r\n\t\t\t\tc0.041-0.017,0.077-0.038,0.104-0.06c0.011-0.01,0.021-0.021,0.032-0.031c0.029-0.01,0.059-0.019,0.088-0.029\r\n\t\t\t\tc0.028-0.025,0.056-0.049,0.084-0.074c0.003-0.003,0.007-0.007,0.01-0.01c0.014,0.009,0.038,0.018,0.063,0.008\r\n\t\t\t\tc0.047-0.026,0.042-0.069,0.098-0.095C21.602,11.666,21.437,11.588,21.4,11.563z M21.72,10.584c0.002,0,0.003-0.001,0.005-0.001\r\n\t\t\t\tc-0.005-0.006-0.009-0.013-0.014-0.019c-0.016,0.002-0.032,0.005-0.048,0.007c-0.148-0.003-0.224-0.095-0.411-0.061\r\n\t\t\t\tc-0.054,0.025-0.235,0.062-0.254,0.094c-0.029,0.048,0.077,0.08,0.116,0.089c0.134,0.033,0.307,0.006,0.465,0.018\r\n\t\t\t\tc0.029,0.002,0.079,0.007,0.099,0.019c0.015,0.009,0.022,0.026,0.042,0.03c0.032,0.001,0.089-0.042,0.103-0.056\r\n\t\t\t\tc0.001-0.001,0.003-0.002,0.004-0.003c-0.082-0.021-0.2-0.02-0.258-0.064C21.619,10.62,21.669,10.602,21.72,10.584z\r\n\t\t\t\t M14.242,41.547c0.147,0.036,0.426-0.012,0.508-0.107c0.048-0.057,0.064-0.207,0.095-0.268c-0.057-0.054-0.445-0.061-0.591-0.057\r\n\t\t\t\tC14.175,41.239,14.197,41.443,14.242,41.547z M10.822,34.354c0.015,0.039,0.009,0.092,0.013,0.135\r\n\t\t\t\tc0.086,0.021,0.114-0.016,0.203-0.02c0.117-0.003,0.196,0.036,0.216-0.095c-0.077-0.062-0.285-0.049-0.4-0.051\r\n\t\t\t\tC10.843,34.333,10.833,34.343,10.822,34.354z M12.735,25.375c-0.017-0.011-0.034-0.021-0.051-0.032\r\n\t\t\t\tc-0.011-0.1,0.084-0.092,0.133-0.146c0.043-0.048,0.06-0.154,0.095-0.203c-0.04-0.027-0.081-0.055-0.121-0.083\r\n\t\t\t\tc-0.045,0.101-0.251,0.268-0.216,0.413c0.05,0.208,0.421,0.141,0.47-0.025C12.9,25.097,12.854,25.337,12.735,25.375z\r\n\t\t\t\t M10.93,37.912c-0.004,0.006-0.008,0.013-0.013,0.02c0.044,0.002,0.042,0.01,0.063,0.031c-0.012,0.031-0.012,0.051,0,0.083\r\n\t\t\t\tc-0.034,0.015-0.068,0.03-0.102,0.044c-0.004,0.006-0.009,0.014-0.013,0.02v0.007c0.085,0,0.174-0.005,0.242-0.013\r\n\t\t\t\tc0.02-0.082-0.008-0.158,0.032-0.217v-0.006h-0.038C11.059,37.904,10.99,37.913,10.93,37.912z M10.015,33.979\r\n\t\t\t\tc-0.092-0.017-0.212,0.006-0.261-0.082c-0.045,0.004-0.062,0.022-0.089,0.031c-0.04-0.004-0.081-0.008-0.121-0.013\r\n\t\t\t\tc-0.04,0.009-0.059,0.049-0.127,0.038c-0.109-0.018-0.194-0.057-0.324-0.057C9.066,33.9,9.038,33.904,9.01,33.909\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.026v0.024c0.064,0.033,0.195,0.03,0.229,0.095c0.046,0.078-0.076,0.146,0.095,0.211\r\n\t\t\t\tc0.004,0.006,0.008,0.012,0.013,0.019c-0.128,0.082-0.41,0.036-0.572-0.013c-0.013,0.015-0.025,0.029-0.038,0.045\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.034,0.065,0.099,0.077,0.152,0.121c0.05-0.013,0.053-0.048,0.102-0.058\r\n\t\t\t\tc0.076,0.012,0.153,0.021,0.229,0.032c0.078-0.006,0.157-0.013,0.235-0.019c0.048,0.048,0.109,0.15,0.178,0.172\r\n\t\t\t\tc0.044-0.114,0.093-0.196,0.203-0.248c0.021,0.023,0.042,0.047,0.064,0.07c0.075,0.033,0.112-0.061,0.178-0.076\r\n\t\t\t\tc0.044-0.012,0.074,0.012,0.095,0.019c0.129-0.06,0.183,0.046,0.248,0.083c0.039-0.029,0.062-0.074,0.089-0.113\r\n\t\t\t\tC10.38,34.159,10.076,34.16,10.015,33.979z M7.581,34.385c0.019,0.027,0.251,0.17,0.311,0.153\r\n\t\t\t\tc0.044-0.013,0.058-0.078,0.14-0.058c0.051,0.014,0.064,0.041,0.127,0.039c0.002-0.012,0.004-0.021,0.006-0.033\r\n\t\t\t\tc-0.073-0.109-0.33-0.157-0.515-0.152C7.628,34.352,7.604,34.368,7.581,34.385z"},"children":[]}]}]}]}]}]}]}]};exports.globe=globe;var google_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"google_plus_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"google_plus"},"children":[{"name":"g","attribs":{"id":"google_plus"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M35.471,4.995c0,0-12.66,0-16.879,0C11.023,4.995,3.9,10.999,3.9,17.522c0,6.666,5.158,12.23,12.857,12.23\r\n\t\t\t\tc0.535,0,1.055,0.083,1.565,0.046c-0.498,0.94-0.855,2.045-0.855,3.142c0,1.854,1.014,3.379,2.297,4.604\r\n\t\t\t\tc-0.969,0-1.904,0.04-2.926,0.04C7.465,37.584,0,43.452,0,49.533c0,5.986,8.158,10.472,17.533,10.472\r\n\t\t\t\tc10.686,0,16.463-6.688,16.463-12.678c0-4.8-1.318-7.675-5.777-10.772c-1.525-1.06-4.443-3.642-4.443-5.157\r\n\t\t\t\tc0-1.776,0.518-2.653,3.24-4.742c2.791-2.143,4.955-4.903,4.955-8.407c0-4.17-2.08-7.36-5.629-9.325h5.352L35.471,4.995z\r\n\t\t\t\t M29.574,46.295c0.133,0.557,0.207,1.128,0.207,1.711c0,4.838-3.176,8.128-12.283,8.128c-6.478,0-11.158-3.536-11.158-8.375\r\n\t\t\t\tc0-4.741,5.805-8.69,12.283-8.622c1.512,0.018,2.92,0.256,4.199,0.664C26.34,42.201,28.862,43.559,29.574,46.295z M19.201,28.248\r\n\t\t\t\tc-4.349-0.126-8.482-4.778-9.232-10.387c-0.752-5.609,2.164-9.9,6.512-9.773c4.349,0.127,8.67,4.629,9.422,10.236\r\n\t\t\t\tC26.652,23.934,23.547,28.377,19.201,28.248z M54,14.817v-9.76h-4v9.76H40v3.99h10v9.76h4v-9.76h10v-3.99H54L54,14.817z"},"children":[{"name":"path","attribs":{"d":"M35.471,4.995c0,0-12.66,0-16.879,0C11.023,4.995,3.9,10.999,3.9,17.522c0,6.666,5.158,12.23,12.857,12.23\r\n\t\t\t\tc0.535,0,1.055,0.083,1.565,0.046c-0.498,0.94-0.855,2.045-0.855,3.142c0,1.854,1.014,3.379,2.297,4.604\r\n\t\t\t\tc-0.969,0-1.904,0.04-2.926,0.04C7.465,37.584,0,43.452,0,49.533c0,5.986,8.158,10.472,17.533,10.472\r\n\t\t\t\tc10.686,0,16.463-6.688,16.463-12.678c0-4.8-1.318-7.675-5.777-10.772c-1.525-1.06-4.443-3.642-4.443-5.157\r\n\t\t\t\tc0-1.776,0.518-2.653,3.24-4.742c2.791-2.143,4.955-4.903,4.955-8.407c0-4.17-2.08-7.36-5.629-9.325h5.352L35.471,4.995z\r\n\t\t\t\t M29.574,46.295c0.133,0.557,0.207,1.128,0.207,1.711c0,4.838-3.176,8.128-12.283,8.128c-6.478,0-11.158-3.536-11.158-8.375\r\n\t\t\t\tc0-4.741,5.805-8.69,12.283-8.622c1.512,0.018,2.92,0.256,4.199,0.664C26.34,42.201,28.862,43.559,29.574,46.295z M19.201,28.248\r\n\t\t\t\tc-4.349-0.126-8.482-4.778-9.232-10.387c-0.752-5.609,2.164-9.9,6.512-9.773c4.349,0.127,8.67,4.629,9.422,10.236\r\n\t\t\t\tC26.652,23.934,23.547,28.377,19.201,28.248z M54,14.817v-9.76h-4v9.76H40v3.99h10v9.76h4v-9.76h10v-3.99H54L54,14.817z"},"children":[]}]}]}]}]}]}]}]};exports.google_plus=google_plus;var graph_fall={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"GRAPH_FALL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,30c-1.657,0-3,1.343-3,3v4.757L43.086,22.843v0l-5.965-5.965\r\n\t\t\tC36.578,16.336,35.828,16,35,16s-1.578,0.336-2.121,0.879L19,30.758L5.121,16.879C4.578,16.336,3.828,16,3,16\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.579,0.879,2.121l16,16C17.422,37.664,18.172,38,19,38c0.828,0,1.578-0.336,2.121-0.879\r\n\t\t\tL35,23.243l3.843,3.843l0.298,0.298l1.738,1.738L53.757,42H49c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\tV33C64,31.343,62.657,30,61,30z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,30c-1.657,0-3,1.343-3,3v4.757L43.086,22.843v0l-5.965-5.965\r\n\t\t\tC36.578,16.336,35.828,16,35,16s-1.578,0.336-2.121,0.879L19,30.758L5.121,16.879C4.578,16.336,3.828,16,3,16\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.579,0.879,2.121l16,16C17.422,37.664,18.172,38,19,38c0.828,0,1.578-0.336,2.121-0.879\r\n\t\t\tL35,23.243l3.843,3.843l0.298,0.298l1.738,1.738L53.757,42H49c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\tV33C64,31.343,62.657,30,61,30z"},"children":[]}]}]}]}]}]};exports.graph_fall=graph_fall;var graph_rise={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"GRAPH_RISE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,16H49c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L40.879,34.879\r\n\t\t\tl-1.738,1.738l-0.298,0.298L35,40.758L21.121,26.879C20.578,26.336,19.829,26,19,26c-0.828,0-1.578,0.336-2.121,0.879l-16,16\r\n\t\t\tC0.336,43.422,0,44.172,0,45c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L19,33.243l13.879,13.879\r\n\t\t\tC33.422,47.664,34.172,48,35,48c0.828,0,1.578-0.336,2.121-0.879l5.964-5.965h0L58,26.243V31c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V19C64,17.343,62.657,16,61,16z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,16H49c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L40.879,34.879\r\n\t\t\tl-1.738,1.738l-0.298,0.298L35,40.758L21.121,26.879C20.578,26.336,19.829,26,19,26c-0.828,0-1.578,0.336-2.121,0.879l-16,16\r\n\t\t\tC0.336,43.422,0,44.172,0,45c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L19,33.243l13.879,13.879\r\n\t\t\tC33.422,47.664,34.172,48,35,48c0.828,0,1.578-0.336,2.121-0.879l5.964-5.965h0L58,26.243V31c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V19C64,17.343,62.657,16,61,16z"},"children":[]}]}]}]}]}]};exports.graph_rise=graph_rise;var grid_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"GRID_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GRID_1"},"children":[{"name":"g","attribs":{"id":"GRID_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C61,36.343,59.657,35,58,35z M55,55H41\r\n\t\t\t\tV41h14V55z M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M23,55\r\n\t\t\t\tH9V41h14V55z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M55,23H41\r\n\t\t\t\tV9h14V23z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M23,23H9V9h14\r\n\t\t\t\tV23z"},"children":[{"name":"path","attribs":{"d":"M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C61,36.343,59.657,35,58,35z M55,55H41\r\n\t\t\t\tV41h14V55z M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M23,55\r\n\t\t\t\tH9V41h14V55z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M55,23H41\r\n\t\t\t\tV9h14V23z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M23,23H9V9h14\r\n\t\t\t\tV23z"},"children":[]}]}]}]}]}]}]}]};exports.grid_1=grid_1;var grid_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"GRID_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GRID_2"},"children":[{"name":"g","attribs":{"id":"GRID_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M26,3H6\r\n\t\t\t\tC4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M58,3H38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M58,35H38c-1.657,0-3,1.343-3,3v20\r\n\t\t\t\tc0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C61,36.343,59.657,35,58,35z"},"children":[{"name":"path","attribs":{"d":"M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M26,3H6\r\n\t\t\t\tC4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M58,3H38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M58,35H38c-1.657,0-3,1.343-3,3v20\r\n\t\t\t\tc0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38C61,36.343,59.657,35,58,35z"},"children":[]}]}]}]}]}]}]}]};exports.grid_2=grid_2;var hashtag={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"HASHTAG_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HASHTAG"},"children":[{"name":"g","attribs":{"id":"HASHTAG"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M58,18h-8.689l2.613-11.325l0,0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL43.152,18H27.31l2.614-11.325l0,0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL21.152,18H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h7.767l-3.692,16H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325l0,0\r\n\t\t\t\tC12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46h15.841l-2.613,11.325l0,0\r\n\t\t\t\tC34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-7.768l3.692-16H58c1.657,0,3-1.343,3-3S59.657,18,58,18z M38.075,40H22.233l3.692-16h15.843L38.075,40z"},"children":[{"name":"path","attribs":{"d":"M58,18h-8.689l2.613-11.325l0,0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL43.152,18H27.31l2.614-11.325l0,0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3c-1.425,0-2.617,0.994-2.923,2.326l0,0\r\n\t\t\t\tL21.152,18H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h7.767l-3.692,16H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325l0,0\r\n\t\t\t\tC12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46h15.841l-2.613,11.325l0,0\r\n\t\t\t\tC34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3c1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-7.768l3.692-16H58c1.657,0,3-1.343,3-3S59.657,18,58,18z M38.075,40H22.233l3.692-16h15.843L38.075,40z"},"children":[]}]}]}]}]}]}]}]};exports.hashtag=hashtag;var heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"HEART_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HEART"},"children":[{"name":"g","attribs":{"id":"HEART"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M58.729,9.272C55.328,5.873,50.809,4,46,4s-8.662,1.727-12.061,5.126c-0.002,0.002-0.004,0.003-0.006,0.005l-0.002,0.001\r\n\t\t\t\tL32,11.565l-1.932-2.286c-0.002-0.002-0.004-0.004-0.006-0.006c0,0-0.001,0-0.001-0.001C26.661,5.873,22.808,4,18,4\r\n\t\t\t\tS8.672,5.873,5.272,9.272C1.872,12.672,0,17.192,0,22c0,4.806,1.87,9.323,5.266,12.723L29.16,58.816\r\n\t\t\t\tC29.911,59.574,30.933,60,32,60c1.066,0,2.089-0.426,2.84-1.184l23.893-24.092C62.129,31.325,64,26.806,64,22\r\n\t\t\t\tC64,17.192,62.128,12.672,58.729,9.272z"},"children":[{"name":"path","attribs":{"d":"M58.729,9.272C55.328,5.873,50.809,4,46,4s-8.662,1.727-12.061,5.126c-0.002,0.002-0.004,0.003-0.006,0.005l-0.002,0.001\r\n\t\t\t\tL32,11.565l-1.932-2.286c-0.002-0.002-0.004-0.004-0.006-0.006c0,0-0.001,0-0.001-0.001C26.661,5.873,22.808,4,18,4\r\n\t\t\t\tS8.672,5.873,5.272,9.272C1.872,12.672,0,17.192,0,22c0,4.806,1.87,9.323,5.266,12.723L29.16,58.816\r\n\t\t\t\tC29.911,59.574,30.933,60,32,60c1.066,0,2.089-0.426,2.84-1.184l23.893-24.092C62.129,31.325,64,26.806,64,22\r\n\t\t\t\tC64,17.192,62.128,12.672,58.729,9.272z"},"children":[]}]}]}]}]}]}]}]};exports.heart=heart;var home={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"HOME_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HOME"},"children":[{"name":"g","attribs":{"id":"HOME"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M6,39v21c0,1.657,1.343,3,3,3h28V39h12v24h6c1.657,0,3-1.343,3-3V39L32,13L6,39z M27,51H15V39h12V51z M63.189,31.96\r\n\t\t\t\tl0.006-0.007L52,20.757V12c0-1.657-1.343-3-3-3s-3,1.343-3,3v2.757L34.195,2.953l-0.002,0.002\r\n\t\t\t\tc-0.478-0.512-1.131-0.857-1.865-0.937c-0.003,0-0.006-0.001-0.009-0.001c-0.045-0.005-0.09-0.008-0.135-0.011\r\n\t\t\t\tc-0.008,0-0.017-0.001-0.025-0.002C32.107,2.002,32.054,2,32.001,2H32c-0.85,0-1.616,0.354-2.162,0.922L0.922,31.838\r\n\t\t\t\tC0.354,32.384,0,33.15,0,34c0,1.657,1.343,3,3,3c0.821,0,1.565-0.33,2.106-0.864l0.001,0.001L32,9.245v0.001l0.077,0.072V9.32\r\n\t\t\t\tl26.877,26.877l0.007-0.008C59.496,36.688,60.21,37,61,37c1.657,0,3-1.343,3-3C64,33.21,63.688,32.496,63.189,31.96z"},"children":[{"name":"path","attribs":{"d":"M6,39v21c0,1.657,1.343,3,3,3h28V39h12v24h6c1.657,0,3-1.343,3-3V39L32,13L6,39z M27,51H15V39h12V51z M63.189,31.96\r\n\t\t\t\tl0.006-0.007L52,20.757V12c0-1.657-1.343-3-3-3s-3,1.343-3,3v2.757L34.195,2.953l-0.002,0.002\r\n\t\t\t\tc-0.478-0.512-1.131-0.857-1.865-0.937c-0.003,0-0.006-0.001-0.009-0.001c-0.045-0.005-0.09-0.008-0.135-0.011\r\n\t\t\t\tc-0.008,0-0.017-0.001-0.025-0.002C32.107,2.002,32.054,2,32.001,2H32c-0.85,0-1.616,0.354-2.162,0.922L0.922,31.838\r\n\t\t\t\tC0.354,32.384,0,33.15,0,34c0,1.657,1.343,3,3,3c0.821,0,1.565-0.33,2.106-0.864l0.001,0.001L32,9.245v0.001l0.077,0.072V9.32\r\n\t\t\t\tl26.877,26.877l0.007-0.008C59.496,36.688,60.21,37,61,37c1.657,0,3-1.343,3-3C64,33.21,63.688,32.496,63.189,31.96z"},"children":[]}]}]}]}]}]}]}]};exports.home=home;var imac={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"IMAC_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IMAC"},"children":[{"name":"g","attribs":{"id":"IMAC"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]}]};exports.imac=imac;var image={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"IMAGE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IMAGE"},"children":[{"name":"g","attribs":{"id":"IMAGE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M40,15L40,15h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3l0,0V13l0,0V9H40c-1.657,0-3,1.343-3,3S38.343,15,40,15z M40,55h15v-4\r\n\t\t\t\tl0,0V40l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3v9h-9l0,0c-1.657,0-3,1.343-3,3S38.343,55,40,55z M61,0H3C1.343,0,0,1.343,0,3v58\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M24,55c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3l0,0h-9v-9l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v11l0,0v4H24L24,55z M9,24c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tl0,0v-9h9l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3l0,0H9v4l0,0V24L9,24z"},"children":[{"name":"path","attribs":{"d":"M40,15L40,15h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3l0,0V13l0,0V9H40c-1.657,0-3,1.343-3,3S38.343,15,40,15z M40,55h15v-4\r\n\t\t\t\tl0,0V40l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3v9h-9l0,0c-1.657,0-3,1.343-3,3S38.343,55,40,55z M61,0H3C1.343,0,0,1.343,0,3v58\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M24,55c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3l0,0h-9v-9l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v11l0,0v4H24L24,55z M9,24c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tl0,0v-9h9l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3l0,0H9v4l0,0V24L9,24z"},"children":[]}]}]}]}]}]}]}]};exports.image=image;var inbox={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"INBOX_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX"},"children":[{"name":"g","attribs":{"id":"INBOX"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.796,31.935l0.007-0.003l-8-21l-0.007,0.003C55.366,9.806,54.279,9,53,9H11c-1.28,0-2.365,0.806-2.796,1.935\r\n\t\t\t\tl-0.007-0.003l-8,21l0.007,0.003C0.077,32.267,0,32.624,0,33v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V33\r\n\t\t\t\tC64,32.624,63.923,32.267,63.796,31.935z M47,30c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h37.865\r\n\t\t\t\tl5.715,15H47z"},"children":[{"name":"path","attribs":{"d":"M63.796,31.935l0.007-0.003l-8-21l-0.007,0.003C55.366,9.806,54.279,9,53,9H11c-1.28,0-2.365,0.806-2.796,1.935\r\n\t\t\t\tl-0.007-0.003l-8,21l0.007,0.003C0.077,32.267,0,32.624,0,33v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V33\r\n\t\t\t\tC64,32.624,63.923,32.267,63.796,31.935z M47,30c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h37.865\r\n\t\t\t\tl5.715,15H47z"},"children":[]}]}]}]}]}]}]}]};exports.inbox=inbox;var inbox_in={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"INBOX__x2F__IN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__IN"},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__IN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M22,27c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,36.664,31.172,37,32,37s1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tC41.664,28.579,42,27.828,42,27c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,26.758V8c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v18.757l-1.879-1.879C26.578,24.336,25.829,24,25,24C23.343,24,22,25.343,22,27z M63.8,36.924l-7.978-20.941\r\n\t\t\t\tC55.406,14.827,54.3,14,53,14H38v6h12.932l5.715,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15H26v-6\r\n\t\t\t\tH11c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38\r\n\t\t\t\tC64,37.621,63.93,37.258,63.8,36.924z"},"children":[{"name":"path","attribs":{"d":"M22,27c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,36.664,31.172,37,32,37s1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tC41.664,28.579,42,27.828,42,27c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,26.758V8c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v18.757l-1.879-1.879C26.578,24.336,25.829,24,25,24C23.343,24,22,25.343,22,27z M63.8,36.924l-7.978-20.941\r\n\t\t\t\tC55.406,14.827,54.3,14,53,14H38v6h12.932l5.715,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15H26v-6\r\n\t\t\t\tH11c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38\r\n\t\t\t\tC64,37.621,63.93,37.258,63.8,36.924z"},"children":[]}]}]}]}]}]}]}]};exports.inbox_in=inbox_in;var inbox_out={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"INBOX__x2F__OUT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__OUT"},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__OUT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M25,18c0.828,0,1.578-0.336,2.121-0.879L29,15.243V34c0,1.657,1.343,3,3,3s3-1.343,3-3V15.243l1.879,1.879\r\n\t\t\t\tC37.422,17.664,38.172,18,39,18c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,5.336,32.829,5,32,5\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,13.422,22,14.172,22,15C22,16.657,23.343,18,25,18z M63.8,36.924l-7.978-20.941\r\n\t\t\t\tC55.406,14.827,54.3,14,53,14h-8.102C44.954,14.327,45,14.658,45,15c0,2.09-1.07,3.926-2.691,5h8.623l5.715,15H47\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h8.623C20.071,18.926,19,17.09,19,15\r\n\t\t\t\tc0-0.342,0.046-0.673,0.101-1H11l0,0c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38C64,37.621,63.93,37.258,63.8,36.924z"},"children":[{"name":"path","attribs":{"d":"M25,18c0.828,0,1.578-0.336,2.121-0.879L29,15.243V34c0,1.657,1.343,3,3,3s3-1.343,3-3V15.243l1.879,1.879\r\n\t\t\t\tC37.422,17.664,38.172,18,39,18c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,5.336,32.829,5,32,5\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,13.422,22,14.172,22,15C22,16.657,23.343,18,25,18z M63.8,36.924l-7.978-20.941\r\n\t\t\t\tC55.406,14.827,54.3,14,53,14h-8.102C44.954,14.327,45,14.658,45,15c0,2.09-1.07,3.926-2.691,5h8.623l5.715,15H47\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h8.623C20.071,18.926,19,17.09,19,15\r\n\t\t\t\tc0-0.342,0.046-0.673,0.101-1H11l0,0c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38C64,37.621,63.93,37.258,63.8,36.924z"},"children":[]}]}]}]}]}]}]}]};exports.inbox_out=inbox_out;var instagram={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"instagram_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"instagram"},"children":[{"name":"g","attribs":{"id":"instagram"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56,0H8C3.582,0,0,3.582,0,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V8C64,3.582,60.418,0,56,0z M19.673,30.673\r\n\t\t\t\tc0.013-0.127,0.04-0.249,0.057-0.374c0.042-0.31,0.088-0.618,0.153-0.92c0.029-0.136,0.069-0.267,0.103-0.401\r\n\t\t\t\tc0.072-0.286,0.147-0.571,0.238-0.849c0.044-0.132,0.095-0.259,0.142-0.389c0.1-0.272,0.204-0.541,0.322-0.804\r\n\t\t\t\tc0.02-0.045,0.034-0.092,0.055-0.137h0.011c1.968-4.247,6.257-7.2,11.246-7.2c4.988,0,9.277,2.953,11.246,7.2h0.011\r\n\t\t\t\tc0.021,0.045,0.035,0.092,0.056,0.137c0.117,0.263,0.222,0.532,0.321,0.804c0.048,0.13,0.099,0.257,0.142,0.389\r\n\t\t\t\tc0.092,0.278,0.166,0.562,0.238,0.849c0.034,0.134,0.074,0.265,0.104,0.401c0.064,0.302,0.109,0.61,0.152,0.92\r\n\t\t\t\tc0.018,0.125,0.043,0.247,0.058,0.374C44.373,31.109,44.4,31.551,44.4,32c0,6.85-5.553,12.4-12.4,12.4\r\n\t\t\t\tc-6.848,0-12.4-5.553-12.4-12.4C19.6,31.551,19.627,31.109,19.673,30.673z M56.8,53.6c0,1.768-1.433,3.2-3.2,3.2H10.4\r\n\t\t\t\tc-1.767,0-3.2-1.433-3.2-3.2V26.8h5.899C12.644,28.456,12.4,30.2,12.4,32c0,10.825,8.775,19.6,19.6,19.6S51.6,42.825,51.6,32\r\n\t\t\t\tc0-1.8-0.244-3.544-0.699-5.2H56.8V53.6z M56.8,16.8c0,1.767-1.433,3.2-3.2,3.2H47.2c-1.767,0-3.2-1.433-3.2-3.2v-6.4\r\n\t\t\t\tc0-1.767,1.434-3.2,3.2-3.2H53.6c1.768,0,3.2,1.432,3.2,3.2V16.8z"},"children":[{"name":"path","attribs":{"d":"M56,0H8C3.582,0,0,3.582,0,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V8C64,3.582,60.418,0,56,0z M19.673,30.673\r\n\t\t\t\tc0.013-0.127,0.04-0.249,0.057-0.374c0.042-0.31,0.088-0.618,0.153-0.92c0.029-0.136,0.069-0.267,0.103-0.401\r\n\t\t\t\tc0.072-0.286,0.147-0.571,0.238-0.849c0.044-0.132,0.095-0.259,0.142-0.389c0.1-0.272,0.204-0.541,0.322-0.804\r\n\t\t\t\tc0.02-0.045,0.034-0.092,0.055-0.137h0.011c1.968-4.247,6.257-7.2,11.246-7.2c4.988,0,9.277,2.953,11.246,7.2h0.011\r\n\t\t\t\tc0.021,0.045,0.035,0.092,0.056,0.137c0.117,0.263,0.222,0.532,0.321,0.804c0.048,0.13,0.099,0.257,0.142,0.389\r\n\t\t\t\tc0.092,0.278,0.166,0.562,0.238,0.849c0.034,0.134,0.074,0.265,0.104,0.401c0.064,0.302,0.109,0.61,0.152,0.92\r\n\t\t\t\tc0.018,0.125,0.043,0.247,0.058,0.374C44.373,31.109,44.4,31.551,44.4,32c0,6.85-5.553,12.4-12.4,12.4\r\n\t\t\t\tc-6.848,0-12.4-5.553-12.4-12.4C19.6,31.551,19.627,31.109,19.673,30.673z M56.8,53.6c0,1.768-1.433,3.2-3.2,3.2H10.4\r\n\t\t\t\tc-1.767,0-3.2-1.433-3.2-3.2V26.8h5.899C12.644,28.456,12.4,30.2,12.4,32c0,10.825,8.775,19.6,19.6,19.6S51.6,42.825,51.6,32\r\n\t\t\t\tc0-1.8-0.244-3.544-0.699-5.2H56.8V53.6z M56.8,16.8c0,1.767-1.433,3.2-3.2,3.2H47.2c-1.767,0-3.2-1.433-3.2-3.2v-6.4\r\n\t\t\t\tc0-1.767,1.434-3.2,3.2-3.2H53.6c1.768,0,3.2,1.432,3.2,3.2V16.8z"},"children":[]}]}]}]}]}]}]}]};exports.instagram=instagram;var ipad={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"IPAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IPAD"},"children":[{"name":"g","attribs":{"id":"IPAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M54,3H10C8.343,3,7,4.343,7,6v52c0,1.657,1.343,3,3,3h44c1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M32,59\r\n\t\t\t\tc-1.105,0-2-0.896-2-2s0.895-2,2-2c1.105,0,2,0.896,2,2S33.105,59,32,59z M51,53H13V9h38V53z"},"children":[{"name":"path","attribs":{"d":"M54,3H10C8.343,3,7,4.343,7,6v52c0,1.657,1.343,3,3,3h44c1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M32,59\r\n\t\t\t\tc-1.105,0-2-0.896-2-2s0.895-2,2-2c1.105,0,2,0.896,2,2S33.105,59,32,59z M51,53H13V9h38V53z"},"children":[]}]}]}]}]}]}]}]};exports.ipad=ipad;var iphone={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"IPHONE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IPHONE"},"children":[{"name":"g","attribs":{"id":"IPHONE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,3H18c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h28c1.657,0,3-1.343,3-3V6C49,4.343,47.657,3,46,3z M32,58\r\n\t\t\t\tc-1.105,0-2-0.895-2-2s0.895-2,2-2c1.105,0,2,0.895,2,2S33.105,58,32,58z M46,51H18V9h28V51z"},"children":[{"name":"path","attribs":{"d":"M46,3H18c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h28c1.657,0,3-1.343,3-3V6C49,4.343,47.657,3,46,3z M32,58\r\n\t\t\t\tc-1.105,0-2-0.895-2-2s0.895-2,2-2c1.105,0,2,0.895,2,2S33.105,58,32,58z M46,51H18V9h28V51z"},"children":[]}]}]}]}]}]}]}]};exports.iphone=iphone;var layers={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LAYERS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,42c-0.406,0-0.793,0.083-1.147,0.229l0-0.001l-0.013,0.005\r\n\t\t\tc-0.004,0.002-0.009,0.003-0.013,0.005L32,53.753L4.174,42.239c-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.005l-0.001,0.001\r\n\t\t\tC3.793,42.083,3.406,42,3,42c-1.657,0-3,1.343-3,3c0,1.25,0.766,2.32,1.853,2.771l0,0.001l28.974,11.989\r\n\t\t\tc0.004,0.002,0.009,0.004,0.013,0.005l0.013,0.005l0.001-0.001C31.207,59.917,31.594,60,32,60c0.406,0,0.793-0.083,1.147-0.229\r\n\t\t\tl0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005l28.973-11.989l0-0.001C63.234,47.32,64,46.25,64,45\r\n\t\t\tC64,43.343,62.657,42,61,42z M1.854,21.771l0,0.001l28.974,11.989c0.004,0.002,0.009,0.003,0.013,0.005l0.013,0.005l0.001-0.001\r\n\t\t\tC31.207,33.917,31.594,34,32,34c0.406,0,0.793-0.083,1.147-0.229l0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005\r\n\t\t\tl28.973-11.989l0-0.001C63.234,21.32,64,20.25,64,19c0-1.25-0.766-2.32-1.853-2.771l0-0.001L33.174,4.239\r\n\t\t\tc-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.005l-0.001,0.001C32.793,4.083,32.406,4,32,4c-0.406,0-0.793,0.083-1.146,0.229\r\n\t\t\tl-0.001-0.001L30.84,4.233c-0.004,0.002-0.009,0.004-0.013,0.005L1.853,16.228l0,0.001C0.766,16.68,0,17.75,0,19\r\n\t\t\tC0,20.25,0.766,21.32,1.854,21.771z M61,29c-0.406,0-0.793,0.083-1.147,0.229l0-0.001l-0.013,0.006\r\n\t\t\tc-0.004,0.002-0.009,0.004-0.013,0.005L32,40.753L4.174,29.239c-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.006l-0.001,0.001\r\n\t\t\tC3.793,29.083,3.406,29,3,29c-1.657,0-3,1.343-3,3c0,1.251,0.766,2.32,1.853,2.771l0,0.001l28.974,11.989\r\n\t\t\tc0.004,0.002,0.009,0.003,0.013,0.005l0.013,0.005l0.001-0.001C31.207,46.917,31.594,47,32,47c0.406,0,0.793-0.083,1.147-0.229\r\n\t\t\tl0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005l28.973-11.989l0-0.001C63.234,34.32,64,33.251,64,32\r\n\t\t\tC64,30.343,62.657,29,61,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,42c-0.406,0-0.793,0.083-1.147,0.229l0-0.001l-0.013,0.005\r\n\t\t\tc-0.004,0.002-0.009,0.003-0.013,0.005L32,53.753L4.174,42.239c-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.005l-0.001,0.001\r\n\t\t\tC3.793,42.083,3.406,42,3,42c-1.657,0-3,1.343-3,3c0,1.25,0.766,2.32,1.853,2.771l0,0.001l28.974,11.989\r\n\t\t\tc0.004,0.002,0.009,0.004,0.013,0.005l0.013,0.005l0.001-0.001C31.207,59.917,31.594,60,32,60c0.406,0,0.793-0.083,1.147-0.229\r\n\t\t\tl0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005l28.973-11.989l0-0.001C63.234,47.32,64,46.25,64,45\r\n\t\t\tC64,43.343,62.657,42,61,42z M1.854,21.771l0,0.001l28.974,11.989c0.004,0.002,0.009,0.003,0.013,0.005l0.013,0.005l0.001-0.001\r\n\t\t\tC31.207,33.917,31.594,34,32,34c0.406,0,0.793-0.083,1.147-0.229l0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005\r\n\t\t\tl28.973-11.989l0-0.001C63.234,21.32,64,20.25,64,19c0-1.25-0.766-2.32-1.853-2.771l0-0.001L33.174,4.239\r\n\t\t\tc-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.005l-0.001,0.001C32.793,4.083,32.406,4,32,4c-0.406,0-0.793,0.083-1.146,0.229\r\n\t\t\tl-0.001-0.001L30.84,4.233c-0.004,0.002-0.009,0.004-0.013,0.005L1.853,16.228l0,0.001C0.766,16.68,0,17.75,0,19\r\n\t\t\tC0,20.25,0.766,21.32,1.854,21.771z M61,29c-0.406,0-0.793,0.083-1.147,0.229l0-0.001l-0.013,0.006\r\n\t\t\tc-0.004,0.002-0.009,0.004-0.013,0.005L32,40.753L4.174,29.239c-0.004-0.002-0.009-0.004-0.013-0.005l-0.013-0.006l-0.001,0.001\r\n\t\t\tC3.793,29.083,3.406,29,3,29c-1.657,0-3,1.343-3,3c0,1.251,0.766,2.32,1.853,2.771l0,0.001l28.974,11.989\r\n\t\t\tc0.004,0.002,0.009,0.003,0.013,0.005l0.013,0.005l0.001-0.001C31.207,46.917,31.594,47,32,47c0.406,0,0.793-0.083,1.147-0.229\r\n\t\t\tl0.001,0.001l0.013-0.005c0.004-0.002,0.009-0.004,0.013-0.005l28.973-11.989l0-0.001C63.234,34.32,64,33.251,64,32\r\n\t\t\tC64,30.343,62.657,29,61,29z"},"children":[]}]}]}]}]}]};exports.layers=layers;var line_graph={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LINE_GRAPH_2_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH_1_"},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,53H6V40.716l13.9-8.177l13.42,8.947c0.002,0,0.003,0.002,0.005,0.003l0.011,0.007l0.001-0.001\r\n\t\t\t\tC33.812,41.812,34.384,42,35,42c0.635,0,1.221-0.2,1.706-0.536l0.002,0.002l25.969-17.979c0,0,0.001,0,0.001-0.001l0.03-0.021\r\n\t\t\t\tl-0.002-0.003C63.486,22.923,64,22.022,64,21c0-1.657-1.343-3-3-3c-0.635,0-1.221,0.2-1.706,0.536l-0.002-0.003l-24.324,16.84\r\n\t\t\t\tl-13.289-8.859c-0.001-0.001-0.003-0.002-0.005-0.003l-0.011-0.007l-0.001,0.001C21.187,26.187,20.616,26,20,26\r\n\t\t\t\tc-0.555,0-1.069,0.161-1.515,0.424l-0.006-0.01L6,33.755V8c0-1.657-1.343-3-3-3S0,6.343,0,8v48c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,53,61,53z"},"children":[{"name":"path","attribs":{"d":"M61,53H6V40.716l13.9-8.177l13.42,8.947c0.002,0,0.003,0.002,0.005,0.003l0.011,0.007l0.001-0.001\r\n\t\t\t\tC33.812,41.812,34.384,42,35,42c0.635,0,1.221-0.2,1.706-0.536l0.002,0.002l25.969-17.979c0,0,0.001,0,0.001-0.001l0.03-0.021\r\n\t\t\t\tl-0.002-0.003C63.486,22.923,64,22.022,64,21c0-1.657-1.343-3-3-3c-0.635,0-1.221,0.2-1.706,0.536l-0.002-0.003l-24.324,16.84\r\n\t\t\t\tl-13.289-8.859c-0.001-0.001-0.003-0.002-0.005-0.003l-0.011-0.007l-0.001,0.001C21.187,26.187,20.616,26,20,26\r\n\t\t\t\tc-0.555,0-1.069,0.161-1.515,0.424l-0.006-0.01L6,33.755V8c0-1.657-1.343-3-3-3S0,6.343,0,8v48c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,53,61,53z"},"children":[]}]}]}]}]}]}]}]};exports.line_graph=line_graph;var line_graph_square={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LINE_GRAPH_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH"},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M12,38.035c0.628,0,1.212-0.194,1.694-0.524l6.271-3.919l13.312,8.875c0.488,0.344,1.082,0.545,1.724,0.545\r\n\t\t\t\tc0.656,0,1.263-0.211,1.757-0.568h0.001l17-12l-0.001-0.001C54.51,29.897,55,29.012,55,28.011c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.662,0-1.273,0.215-1.77,0.578L34.953,36.373l-13.261-8.841l-0.012,0.017c-0.479-0.325-1.058-0.514-1.68-0.514\r\n\t\t\t\tc-0.575,0-1.113,0.162-1.569,0.443l-0.002-0.002l-8,5l0.001,0.002C9.573,33.006,9,33.953,9,35.035\r\n\t\t\t\tC9,36.691,10.343,38.035,12,38.035z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"d":"M12,38.035c0.628,0,1.212-0.194,1.694-0.524l6.271-3.919l13.312,8.875c0.488,0.344,1.082,0.545,1.724,0.545\r\n\t\t\t\tc0.656,0,1.263-0.211,1.757-0.568h0.001l17-12l-0.001-0.001C54.51,29.897,55,29.012,55,28.011c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.662,0-1.273,0.215-1.77,0.578L34.953,36.373l-13.261-8.841l-0.012,0.017c-0.479-0.325-1.058-0.514-1.68-0.514\r\n\t\t\t\tc-0.575,0-1.113,0.162-1.569,0.443l-0.002-0.002l-8,5l0.001,0.002C9.573,33.006,9,33.953,9,35.035\r\n\t\t\t\tC9,36.691,10.343,38.035,12,38.035z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]}]};exports.line_graph_square=line_graph_square;var link={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LINK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINK"},"children":[{"name":"g","attribs":{"id":"LINK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26.461,45.766c-0.056,0.062-0.096,0.131-0.155,0.19l-8.349,8.37c-2.306,2.311-6.043,2.311-8.349,0\r\n\t\t\t\tc-2.305-2.311-2.305-6.059,0-8.37l8.349-8.37c0.018-0.018,0.041-0.029,0.059-0.049l7.187-7.187\r\n\t\t\t\tc-3.943-1.062-8.326-0.052-11.421,3.05L5.433,41.77c-4.611,4.623-4.611,12.119,0,16.74c4.611,4.623,12.087,4.623,16.697,0\r\n\t\t\t\tl8.349-8.369c3.091-3.101,4.1-7.49,3.044-11.44L26.461,45.766z M58.48,5.401c-4.61-4.623-12.086-4.623-16.696,0l-8.349,8.37\r\n\t\t\t\tc-3.083,3.09-4.094,7.462-3.055,11.403l7.221-7.221l0.006,0.006c0.002-0.001,0.002-0.002,0.002-0.002l8.35-8.37\r\n\t\t\t\tc2.305-2.311,6.043-2.311,8.35,0c2.305,2.311,2.305,6.059,0,8.37l-8.35,8.37c-0.098,0.098-0.211,0.167-0.312,0.256l-6.971,6.97\r\n\t\t\t\tc3.953,1.078,8.354,0.071,11.457-3.041l8.35-8.37C63.091,17.518,63.091,10.023,58.48,5.401z M42,19\r\n\t\t\t\tc-0.868,0-1.645,0.374-2.191,0.964L19.964,39.809C19.375,40.355,19,41.132,19,42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.836,0,1.591-0.344,2.135-0.896l0.009,0.01l20-20l-0.01-0.009C44.669,23.563,45,22.82,45,22C45,20.343,43.657,19,42,19z"},"children":[{"name":"path","attribs":{"d":"M26.461,45.766c-0.056,0.062-0.096,0.131-0.155,0.19l-8.349,8.37c-2.306,2.311-6.043,2.311-8.349,0\r\n\t\t\t\tc-2.305-2.311-2.305-6.059,0-8.37l8.349-8.37c0.018-0.018,0.041-0.029,0.059-0.049l7.187-7.187\r\n\t\t\t\tc-3.943-1.062-8.326-0.052-11.421,3.05L5.433,41.77c-4.611,4.623-4.611,12.119,0,16.74c4.611,4.623,12.087,4.623,16.697,0\r\n\t\t\t\tl8.349-8.369c3.091-3.101,4.1-7.49,3.044-11.44L26.461,45.766z M58.48,5.401c-4.61-4.623-12.086-4.623-16.696,0l-8.349,8.37\r\n\t\t\t\tc-3.083,3.09-4.094,7.462-3.055,11.403l7.221-7.221l0.006,0.006c0.002-0.001,0.002-0.002,0.002-0.002l8.35-8.37\r\n\t\t\t\tc2.305-2.311,6.043-2.311,8.35,0c2.305,2.311,2.305,6.059,0,8.37l-8.35,8.37c-0.098,0.098-0.211,0.167-0.312,0.256l-6.971,6.97\r\n\t\t\t\tc3.953,1.078,8.354,0.071,11.457-3.041l8.35-8.37C63.091,17.518,63.091,10.023,58.48,5.401z M42,19\r\n\t\t\t\tc-0.868,0-1.645,0.374-2.191,0.964L19.964,39.809C19.375,40.355,19,41.132,19,42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.836,0,1.591-0.344,2.135-0.896l0.009,0.01l20-20l-0.01-0.009C44.669,23.563,45,22.82,45,22C45,20.343,43.657,19,42,19z"},"children":[]}]}]}]}]}]}]}]};exports.link=link;var linkedin={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"linkedin_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"linkedin"},"children":[{"name":"g","attribs":{"id":"linkedin"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0.798,62.986h14.315V22.368H0.798V62.986z M48.434,21.087c-5.925,0-9.192,1.972-12.953,6.749v-5.469H21.189v40.619\r\n\t\t\t\tH35.48V40.914c0-4.658,2.24-9.214,7.596-9.214s6.673,4.555,6.673,9.103v22.184H64v-23.09C64,23.854,54.361,21.087,48.434,21.087z\r\n\t\t\t\t M7.982,2.013C3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"},"children":[{"name":"path","attribs":{"d":"M0.798,62.986h14.315V22.368H0.798V62.986z M48.434,21.087c-5.925,0-9.192,1.972-12.953,6.749v-5.469H21.189v40.619\r\n\t\t\t\tH35.48V40.914c0-4.658,2.24-9.214,7.596-9.214s6.673,4.555,6.673,9.103v22.184H64v-23.09C64,23.854,54.361,21.087,48.434,21.087z\r\n\t\t\t\t M7.982,2.013C3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"},"children":[]}]}]}]}]}]}]}]};exports.linkedin=linkedin;var list={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LIST_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LIST"},"children":[{"name":"g","attribs":{"id":"LIST"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,19h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3S1.343,19,3,19z M61,29H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,29,61,29z M61,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,45,61,45z"},"children":[{"name":"path","attribs":{"d":"M3,19h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3S1.343,19,3,19z M61,29H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,29,61,29z M61,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,45,61,45z"},"children":[]}]}]}]}]}]}]}]};exports.list=list;var list_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LIST_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LIST_2"},"children":[{"name":"g","attribs":{"id":"LIST_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M9,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3S10.657,45,9,45z M61,29H21c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3l0,0h40c1.657,0,3-1.343,3-3S62.657,29,61,29z M9,29H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tS10.657,29,9,29z M21,19h40c1.657,0,3-1.343,3-3s-1.343-3-3-3H21.001H21c-1.657,0-3,1.343-3,3S19.343,19,21,19z M9,13L9,13H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h6c1.657,0,3-1.343,3-3S10.657,13,9,13z M61,45H21c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h40\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,45,61,45z"},"children":[{"name":"path","attribs":{"d":"M9,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3S10.657,45,9,45z M61,29H21c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3l0,0h40c1.657,0,3-1.343,3-3S62.657,29,61,29z M9,29H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tS10.657,29,9,29z M21,19h40c1.657,0,3-1.343,3-3s-1.343-3-3-3H21.001H21c-1.657,0-3,1.343-3,3S19.343,19,21,19z M9,13L9,13H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h6c1.657,0,3-1.343,3-3S10.657,13,9,13z M61,45H21c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h40\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,45,61,45z"},"children":[]}]}]}]}]}]}]}]};exports.list_2=list_2;var loading={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LOADING"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17,44c-0.828,0-1.578,0.336-2.121,0.879l-6,6C8.336,51.422,8,52.172,8,53\r\n\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l6-6C19.664,48.578,20,47.828,20,47C20,45.343,18.657,44,17,44z M14,32\r\n\t\t\tc0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8C12.657,35,14,33.657,14,32z M13.121,8.879\r\n\t\t\tC12.578,8.336,11.828,8,11,8c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l6,6C15.422,19.664,16.172,20,17,20\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L13.121,8.879z M47,20c0.828,0,1.578-0.336,2.121-0.879l6-6\r\n\t\t\tC55.664,12.578,56,11.828,56,11c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-6,6C44.336,15.422,44,16.172,44,17\r\n\t\t\tC44,18.657,45.343,20,47,20z M49.121,44.879C48.579,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\tl6,6C51.422,55.664,52.172,56,53,56c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M32,50\r\n\t\t\tc-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C35,51.343,33.657,50,32,50z M61,29h-8c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h8c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z M32,0c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\ts3-1.343,3-3V3C35,1.343,33.657,0,32,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M17,44c-0.828,0-1.578,0.336-2.121,0.879l-6,6C8.336,51.422,8,52.172,8,53\r\n\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l6-6C19.664,48.578,20,47.828,20,47C20,45.343,18.657,44,17,44z M14,32\r\n\t\t\tc0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8C12.657,35,14,33.657,14,32z M13.121,8.879\r\n\t\t\tC12.578,8.336,11.828,8,11,8c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l6,6C15.422,19.664,16.172,20,17,20\r\n\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L13.121,8.879z M47,20c0.828,0,1.578-0.336,2.121-0.879l6-6\r\n\t\t\tC55.664,12.578,56,11.828,56,11c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-6,6C44.336,15.422,44,16.172,44,17\r\n\t\t\tC44,18.657,45.343,20,47,20z M49.121,44.879C48.579,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\tl6,6C51.422,55.664,52.172,56,53,56c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M32,50\r\n\t\t\tc-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C35,51.343,33.657,50,32,50z M61,29h-8c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h8c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z M32,0c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\ts3-1.343,3-3V3C35,1.343,33.657,0,32,0z"},"children":[]}]}]}]}]}]};exports.loading=loading;var location={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LOCATION"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,3c0-1.657-1.343-3-3-3c-0.375,0-0.73,0.077-1.061,0.202l-0.003-0.007l-58,22\r\n\t\t\tl0.003,0.008C0.808,22.632,0,23.718,0,25c0,1.414,0.981,2.592,2.298,2.909l-0.002,0.007l27.218,6.57l6.57,27.218l0.007-0.002\r\n\t\t\tC36.409,63.019,37.586,64,39,64c1.282,0,2.368-0.808,2.797-1.939l0.008,0.003l22-58l-0.019-0.007C63.913,3.726,64,3.376,64,3z\r\n\t\t\t M39.638,50.859l-4.722-19.562l-0.007,0.002c-0.263-1.09-1.119-1.941-2.207-2.205l0.002-0.01l-19.562-4.722L55.831,8.169\r\n\t\t\tL39.638,50.859z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,3c0-1.657-1.343-3-3-3c-0.375,0-0.73,0.077-1.061,0.202l-0.003-0.007l-58,22\r\n\t\t\tl0.003,0.008C0.808,22.632,0,23.718,0,25c0,1.414,0.981,2.592,2.298,2.909l-0.002,0.007l27.218,6.57l6.57,27.218l0.007-0.002\r\n\t\t\tC36.409,63.019,37.586,64,39,64c1.282,0,2.368-0.808,2.797-1.939l0.008,0.003l22-58l-0.019-0.007C63.913,3.726,64,3.376,64,3z\r\n\t\t\t M39.638,50.859l-4.722-19.562l-0.007,0.002c-0.263-1.09-1.119-1.941-2.207-2.205l0.002-0.01l-19.562-4.722L55.831,8.169\r\n\t\t\tL39.638,50.859z"},"children":[]}]}]}]}]}]};exports.location=location;var lock={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LOCK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOCK"},"children":[{"name":"g","attribs":{"id":"LOCK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M55,32h-5V18c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46\r\n\t\t\t\tc1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832\r\n\t\t\t\tc-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,46.215,36.786,48.129,35,49.168z M44,32H20V18\r\n\t\t\t\tc0-6.627,5.373-12,12-12s12,5.373,12,12V32z"},"children":[{"name":"path","attribs":{"d":"M55,32h-5V18c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46\r\n\t\t\t\tc1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832\r\n\t\t\t\tc-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,46.215,36.786,48.129,35,49.168z M44,32H20V18\r\n\t\t\t\tc0-6.627,5.373-12,12-12s12,5.373,12,12V32z"},"children":[]}]}]}]}]}]}]}]};exports.lock=lock;var login={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LOGIN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOGIN"},"children":[{"name":"g","attribs":{"id":"LOGIN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M39.007,34.23C39.617,33.682,40,32.885,40,32s-0.384-1.681-0.993-2.23l0,0l-10-9l0,0C28.475,20.292,27.772,20,27,20\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L29.182,29H11c-1.657,0-3,1.343-3,3s1.343,3,3,3h18.182l-4.189,3.77\r\n\t\t\t\tl0,0C24.384,39.32,24,40.115,24,41c0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0L39.007,34.23L39.007,34.23z\r\n\t\t\t\t M56,31.932V8.935c0-1.657-1.343-3-3-3H38c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12v40H38c-1.657,0-3,1.342-3,3\r\n\t\t\t\tc0,1.656,1.343,3,3,3h15c1.657,0,3-1.344,3-3V31.937c0-0.001,0-0.002,0-0.003C56,31.934,56,31.933,56,31.932z"},"children":[{"name":"path","attribs":{"d":"M39.007,34.23C39.617,33.682,40,32.885,40,32s-0.384-1.681-0.993-2.23l0,0l-10-9l0,0C28.475,20.292,27.772,20,27,20\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L29.182,29H11c-1.657,0-3,1.343-3,3s1.343,3,3,3h18.182l-4.189,3.77\r\n\t\t\t\tl0,0C24.384,39.32,24,40.115,24,41c0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0L39.007,34.23L39.007,34.23z\r\n\t\t\t\t M56,31.932V8.935c0-1.657-1.343-3-3-3H38c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12v40H38c-1.657,0-3,1.342-3,3\r\n\t\t\t\tc0,1.656,1.343,3,3,3h15c1.657,0,3-1.344,3-3V31.937c0-0.001,0-0.002,0-0.003C56,31.934,56,31.933,56,31.932z"},"children":[]}]}]}]}]}]}]}]};exports.login=login;var logout={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"LOGOUT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOGOUT"},"children":[{"name":"g","attribs":{"id":"LOGOUT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C44.475,20.292,43.771,20,43,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h18.182l-4.188,3.77l0,0\r\n\t\t\t\tC40.384,39.32,40,40.115,40,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.682,56,32.885,56,32z\r\n\t\t\t\t M26,52H14V12h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tS27.657,52,26,52z"},"children":[{"name":"path","attribs":{"d":"M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0C44.475,20.292,43.771,20,43,20c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h18.182l-4.188,3.77l0,0\r\n\t\t\t\tC40.384,39.32,40,40.115,40,41c0,1.657,1.343,3,3,3c0.771,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.682,56,32.885,56,32z\r\n\t\t\t\t M26,52H14V12h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tS27.657,52,26,52z"},"children":[]}]}]}]}]}]}]}]};exports.logout=logout;var macbook={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MACBOOK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MACBOOK"},"children":[{"name":"g","attribs":{"id":"MACBOOK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M58,44V15c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3v29H0v5c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3v-5H58z M39,49\r\n\t\t\t\tH25v-2h14V49z M54,42H10V16h44V42z"},"children":[{"name":"path","attribs":{"d":"M58,44V15c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3v29H0v5c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3v-5H58z M39,49\r\n\t\t\t\tH25v-2h14V49z M54,42H10V16h44V42z"},"children":[]}]}]}]}]}]}]}]};exports.macbook=macbook;var magnifying_glass={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.584,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z"},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.584,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z"},"children":[]}]}]}]}]}]}]}]};exports.magnifying_glass=magnifying_glass;var magnifying_glass_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.585,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z M34,21h-7v-7c0-1.657-1.343-3-3-3s-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3s1.343,3,3,3h7v7\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.585,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z M34,21h-7v-7c0-1.657-1.343-3-3-3s-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3s1.343,3,3,3h7v7\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[]}]}]}]}]}]}]}]};exports.magnifying_glass_add=magnifying_glass_add;var magnifying_glass_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.585,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z M34,21H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[{"name":"path","attribs":{"d":"M62.243,53.758L44.658,36.173C46.768,32.602,48,28.449,48,24C48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24\r\n\t\t\t\tc4.449,0,8.602-1.232,12.173-3.342l17.585,17.584C54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6\r\n\t\t\t\tC64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC42,33.941,33.941,42,24,42z M34,21H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[]}]}]}]}]}]}]}]};exports.magnifying_glass_remove=magnifying_glass_remove;var mail={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAIL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL"},"children":[{"name":"g","attribs":{"id":"MAIL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.002,10.78C62.471,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78L32,35L63.002,10.78z M0.894,10.866\r\n\t\t\t\tC0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z M32,41l-8.136-7.881L0.943,53.175\r\n\t\t\t\tC1.481,53.684,2.202,54,3,54h58c0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,41z M63.105,10.866L43.622,29.741\r\n\t\t\t\tl19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.105,10.866z"},"children":[{"name":"path","attribs":{"d":"M63.002,10.78C62.471,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78L32,35L63.002,10.78z M0.894,10.866\r\n\t\t\t\tC0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z M32,41l-8.136-7.881L0.943,53.175\r\n\t\t\t\tC1.481,53.684,2.202,54,3,54h58c0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,41z M63.105,10.866L43.622,29.741\r\n\t\t\t\tl19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.105,10.866z"},"children":[]}]}]}]}]}]}]}]};exports.mail=mail;var mail_incoming={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING"},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M29.879,29.122C30.422,29.664,31.172,30,32,30c0.829,0,1.578-0.336,2.121-0.879l7-7C41.664,21.579,42,20.829,42,20\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,19.757V6c0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879\r\n\t\t\t\tC26.578,17.336,25.828,17,25,17c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L29.879,29.122z M63.002,17.78\r\n\t\t\t\tC62.471,17.3,61.773,17,61,17H44.168C44.684,17.886,45,18.902,45,20c0,1.657-0.672,3.157-1.757,4.243l-7,7\r\n\t\t\t\tC35.157,32.328,33.657,33,32,33s-3.157-0.672-4.243-1.757l-7-7C19.672,23.157,19,21.657,19,20c0-1.098,0.317-2.114,0.832-3H3\r\n\t\t\t\tc-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.105,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58\r\n\t\t\t\tV20C64,19.165,63.657,18.41,63.105,17.866z M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037\r\n\t\t\t\tl19.569-23.296L0.894,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.684,2.202,61,3,61h58c0.798,0,1.52-0.316,2.057-0.825\r\n\t\t\t\tl-22.92-20.056L32,48z"},"children":[{"name":"path","attribs":{"d":"M29.879,29.122C30.422,29.664,31.172,30,32,30c0.829,0,1.578-0.336,2.121-0.879l7-7C41.664,21.579,42,20.829,42,20\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,19.757V6c0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879\r\n\t\t\t\tC26.578,17.336,25.828,17,25,17c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L29.879,29.122z M63.002,17.78\r\n\t\t\t\tC62.471,17.3,61.773,17,61,17H44.168C44.684,17.886,45,18.902,45,20c0,1.657-0.672,3.157-1.757,4.243l-7,7\r\n\t\t\t\tC35.157,32.328,33.657,33,32,33s-3.157-0.672-4.243-1.757l-7-7C19.672,23.157,19,21.657,19,20c0-1.098,0.317-2.114,0.832-3H3\r\n\t\t\t\tc-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.105,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58\r\n\t\t\t\tV20C64,19.165,63.657,18.41,63.105,17.866z M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037\r\n\t\t\t\tl19.569-23.296L0.894,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.684,2.202,61,3,61h58c0.798,0,1.52-0.316,2.057-0.825\r\n\t\t\t\tl-22.92-20.056L32,48z"},"children":[]}]}]}]}]}]}]}]};exports.mail_incoming=mail_incoming;var mail_outgoing={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING"},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,17.866z M25,16\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L29,13.243V27c0,1.657,1.343,3,3,3s3-1.343,3-3V13.243l1.879,1.879\r\n\t\t\t\tC37.422,15.664,38.172,16,39,16c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,3.336,32.828,3,32,3\r\n\t\t\t\ts-1.578,0.336-2.121,0.879l-7,7C22.336,11.422,22,12.172,22,13C22,14.657,23.343,16,25,16z M63.002,17.78\r\n\t\t\t\tC62.471,17.3,61.773,17,61,17H43.443c-1.098,1.219-2.674,2-4.443,2c-0.344,0-0.673-0.053-1-0.11V27c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6v-8.11C25.673,18.947,25.344,19,25,19c-1.77,0-3.345-0.781-4.443-2H3c-0.773,0-1.47,0.3-2.002,0.78L32,42\r\n\t\t\t\tL63.002,17.78z M63.105,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58V20\r\n\t\t\t\tC64,19.165,63.657,18.41,63.105,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.684,2.202,61,3,61h58\r\n\t\t\t\tc0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,48z"},"children":[{"name":"path","attribs":{"d":"M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,17.866z M25,16\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L29,13.243V27c0,1.657,1.343,3,3,3s3-1.343,3-3V13.243l1.879,1.879\r\n\t\t\t\tC37.422,15.664,38.172,16,39,16c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7C33.578,3.336,32.828,3,32,3\r\n\t\t\t\ts-1.578,0.336-2.121,0.879l-7,7C22.336,11.422,22,12.172,22,13C22,14.657,23.343,16,25,16z M63.002,17.78\r\n\t\t\t\tC62.471,17.3,61.773,17,61,17H43.443c-1.098,1.219-2.674,2-4.443,2c-0.344,0-0.673-0.053-1-0.11V27c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6v-8.11C25.673,18.947,25.344,19,25,19c-1.77,0-3.345-0.781-4.443-2H3c-0.773,0-1.47,0.3-2.002,0.78L32,42\r\n\t\t\t\tL63.002,17.78z M63.105,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58V20\r\n\t\t\t\tC64,19.165,63.657,18.41,63.105,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.684,2.202,61,3,61h58\r\n\t\t\t\tc0.798,0,1.52-0.316,2.057-0.825l-22.92-20.056L32,48z"},"children":[]}]}]}]}]}]}]}]};exports.mail_outgoing=mail_outgoing;var map={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP"},"children":[{"name":"g","attribs":{"id":"MAP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M60.866,15.668L60.866,15.668l-0.024-0.02c-0.072-0.058-0.145-0.117-0.224-0.168L44.867,3.667l-0.001,0.001\r\n\t\t\t\tC44.352,3.256,43.709,3,43,3c-0.495,0-0.956,0.131-1.367,0.344L41.63,3.339L21.251,14.455L6.867,3.667L6.866,3.668\r\n\t\t\t\tC6.352,3.256,5.709,3,5,3C3.343,3,2,4.343,2,6v40c0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C19.692,60.762,20.315,61,21,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.389l0.003,0.007l20.272-11.058l14.543,10.905l0.012-0.016C57.766,60.795,58.357,61,59,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C62,17.052,61.552,16.218,60.866,15.668z M18,51.986l-10-7.5V12.017l10,7.5V51.986z M40,44.212l-16,8.728\r\n\t\t\t\tV19.79l16-8.727V44.212z M56,52.018l-10-7.5v-32.5l10,7.5V52.018z"},"children":[{"name":"path","attribs":{"d":"M60.866,15.668L60.866,15.668l-0.024-0.02c-0.072-0.058-0.145-0.117-0.224-0.168L44.867,3.667l-0.001,0.001\r\n\t\t\t\tC44.352,3.256,43.709,3,43,3c-0.495,0-0.956,0.131-1.367,0.344L41.63,3.339L21.251,14.455L6.867,3.667L6.866,3.668\r\n\t\t\t\tC6.352,3.256,5.709,3,5,3C3.343,3,2,4.343,2,6v40c0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C19.692,60.762,20.315,61,21,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.389l0.003,0.007l20.272-11.058l14.543,10.905l0.012-0.016C57.766,60.795,58.357,61,59,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C62,17.052,61.552,16.218,60.866,15.668z M18,51.986l-10-7.5V12.017l10,7.5V51.986z M40,44.212l-16,8.728\r\n\t\t\t\tV19.79l16-8.727V44.212z M56,52.018l-10-7.5v-32.5l10,7.5V52.018z"},"children":[]}]}]}]}]}]}]}]};exports.map=map;var map_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAP__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56,51h-3v3c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3c0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3\r\n\t\t\t\tS57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017l10,7.5v13.292\r\n\t\t\t\tc2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.072-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56,51h-3v3c0,1.657-1.343,3-3,3\r\n\t\t\t\ts-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3c0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3\r\n\t\t\t\tS57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017l10,7.5v13.292\r\n\t\t\t\tc2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.072-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]}]};exports.map_add=map_add;var map_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAP__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017l10,7.5v13.292\r\n\t\t\t\tc2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.529,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z\r\n\t\t\t\t M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56.121,49.879C56.664,50.422,57,51.172,57,52\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L50,52.243l-1.879,1.879C47.578,54.664,46.828,55,46,55\r\n\t\t\t\tc-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L45.757,48l-1.879-1.879C43.336,45.578,43,44.829,43,44\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L50,43.757l1.879-1.879C52.422,41.336,53.172,41,54,41c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,0.828-0.336,1.578-0.879,2.121L54.243,48L56.121,49.879z"},"children":[{"name":"path","attribs":{"d":"M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017l10,7.5v13.292\r\n\t\t\t\tc2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.529,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z\r\n\t\t\t\t M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56.121,49.879C56.664,50.422,57,51.172,57,52\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L50,52.243l-1.879,1.879C47.578,54.664,46.828,55,46,55\r\n\t\t\t\tc-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L45.757,48l-1.879-1.879C43.336,45.578,43,44.829,43,44\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L50,43.757l1.879-1.879C52.422,41.336,53.172,41,54,41c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,0.828-0.336,1.578-0.879,2.121L54.243,48L56.121,49.879z"},"children":[]}]}]}]}]}]}]}]};exports.map_delete=map_delete;var map_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAP__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__OK"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M58.121,47.121l-8,8\r\n\t\t\t\tC49.578,55.664,48.828,56,48,56s-1.578-0.336-2.121-0.879l-4-4C41.336,50.578,41,49.828,41,49c0-1.657,1.343-3,3-3\r\n\t\t\t\tc0.828,0,1.578,0.336,2.121,0.879L48,48.757l5.879-5.879C54.422,42.336,55.172,42,56,42c1.657,0,3,1.343,3,3\r\n\t\t\t\tC59,45.829,58.664,46.578,58.121,47.121z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017\r\n\t\t\t\tl10,7.5v13.292c2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.955,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.004,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M58.121,47.121l-8,8\r\n\t\t\t\tC49.578,55.664,48.828,56,48,56s-1.578-0.336-2.121-0.879l-4-4C41.336,50.578,41,49.828,41,49c0-1.657,1.343-3,3-3\r\n\t\t\t\tc0.828,0,1.578,0.336,2.121,0.879L48,48.757l5.879-5.879C54.422,42.336,55.172,42,56,42c1.657,0,3,1.343,3,3\r\n\t\t\t\tC59,45.829,58.664,46.578,58.121,47.121z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017\r\n\t\t\t\tl10,7.5v13.292c2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.955,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.004,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]}]};exports.map_ok=map_ok;var map_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MAP__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56,51H44c-1.657,0-3-1.343-3-3s1.343-3,3-3\r\n\t\t\t\th12c1.657,0,3,1.343,3,3S57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017\r\n\t\t\t\tl10,7.5v13.292c2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"d":"M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13s13-5.82,13-13S57.18,35,50,35z M56,51H44c-1.657,0-3-1.343-3-3s1.343-3,3-3\r\n\t\t\t\th12c1.657,0,3,1.343,3,3S57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727V36.4c1.693-1.605,3.732-2.846,6-3.592V12.017\r\n\t\t\t\tl10,7.5v13.292c2.268,0.746,4.307,1.986,6,3.592V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.057,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.389l0.003,0.007\r\n\t\t\t\tl13.457-7.341C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]}]};exports.map_remove=map_remove;var microphone={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MICROPHONE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MICROPHONE"},"children":[{"name":"g","attribs":{"id":"MICROPHONE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,40c6.627,0,12-5.373,12-12V12c0-6.627-5.373-12-12-12S20,5.373,20,12v16C20,34.628,25.373,40,32,40z M54,29.023\r\n\t\t\t\tc0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0\r\n\t\t\t\tc-0.004,8.835-7.165,15.996-16,16c-8.835-0.004-15.996-7.165-16-16l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023c0,11.125,8.274,20.295,19,21.752V58H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h26c1.657,0,3-1.343,3-3s-1.343-3-3-3H35v-7.225C45.727,49.318,54,40.148,54,29.023z"},"children":[{"name":"path","attribs":{"d":"M32,40c6.627,0,12-5.373,12-12V12c0-6.627-5.373-12-12-12S20,5.373,20,12v16C20,34.628,25.373,40,32,40z M54,29.023\r\n\t\t\t\tc0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0\r\n\t\t\t\tc-0.004,8.835-7.165,15.996-16,16c-8.835-0.004-15.996-7.165-16-16l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023c0,11.125,8.274,20.295,19,21.752V58H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h26c1.657,0,3-1.343,3-3s-1.343-3-3-3H35v-7.225C45.727,49.318,54,40.148,54,29.023z"},"children":[]}]}]}]}]}]}]}]};exports.microphone=microphone;var microphone_off={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF"},"children":[{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M12.631,39.404l5.051-3.301C16.617,33.961,16.002,31.555,16,29l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023C10,32.785,10.964,36.312,12.631,39.404z M44,18.895V12\r\n\t\t\t\tc0-6.627-5.373-12-12-12S20,5.373,20,12v16c0,2.047,0.515,3.973,1.419,5.659L44,18.895z M59.5,15.1c0-0.829-0.672-1.5-1.5-1.5\r\n\t\t\t\tc-0.303,0-0.585,0.091-0.82,0.246v-0.001l-0.018,0.011l0,0L5.079,47.945l0,0C4.67,48.214,4.4,48.675,4.4,49.2\r\n\t\t\t\tc0,0.829,0.672,1.5,1.5,1.5c0.303,0,0.585-0.091,0.821-0.246v0.001l0.017-0.012l0,0L58.82,16.355v-0.001\r\n\t\t\t\tC59.23,16.087,59.5,15.625,59.5,15.1z M43.859,29.739l-15.025,9.825C29.844,39.841,30.902,40,32,40\r\n\t\t\t\tC38.035,40,43.016,35.54,43.859,29.739z M51,26c-1.657,0-3,1.343-3,3l0,0c-0.004,8.092-6.018,14.759-13.816,15.829\r\n\t\t\t\tc-0.24,0.034-0.48,0.062-0.723,0.086c-0.441,0.04-0.885,0.074-1.336,0.078v0.002c-0.04,0-0.078,0.005-0.118,0.005\r\n\t\t\t\tc-2.959,0-5.72-0.816-8.098-2.216l-5.431,3.551c2.987,2.326,6.586,3.906,10.521,4.44V58H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H35v-7.225c10.727-1.457,19-10.627,19-21.752c0-0.005,0-0.01-0.001-0.015\r\n\t\t\t\tC53.999,29.005,54,29.003,54,29C54,27.343,52.657,26,51,26z"},"children":[{"name":"path","attribs":{"d":"M12.631,39.404l5.051-3.301C16.617,33.961,16.002,31.555,16,29l0,0c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tc0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023C10,32.785,10.964,36.312,12.631,39.404z M44,18.895V12\r\n\t\t\t\tc0-6.627-5.373-12-12-12S20,5.373,20,12v16c0,2.047,0.515,3.973,1.419,5.659L44,18.895z M59.5,15.1c0-0.829-0.672-1.5-1.5-1.5\r\n\t\t\t\tc-0.303,0-0.585,0.091-0.82,0.246v-0.001l-0.018,0.011l0,0L5.079,47.945l0,0C4.67,48.214,4.4,48.675,4.4,49.2\r\n\t\t\t\tc0,0.829,0.672,1.5,1.5,1.5c0.303,0,0.585-0.091,0.821-0.246v0.001l0.017-0.012l0,0L58.82,16.355v-0.001\r\n\t\t\t\tC59.23,16.087,59.5,15.625,59.5,15.1z M43.859,29.739l-15.025,9.825C29.844,39.841,30.902,40,32,40\r\n\t\t\t\tC38.035,40,43.016,35.54,43.859,29.739z M51,26c-1.657,0-3,1.343-3,3l0,0c-0.004,8.092-6.018,14.759-13.816,15.829\r\n\t\t\t\tc-0.24,0.034-0.48,0.062-0.723,0.086c-0.441,0.04-0.885,0.074-1.336,0.078v0.002c-0.04,0-0.078,0.005-0.118,0.005\r\n\t\t\t\tc-2.959,0-5.72-0.816-8.098-2.216l-5.431,3.551c2.987,2.326,6.586,3.906,10.521,4.44V58H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H35v-7.225c10.727-1.457,19-10.627,19-21.752c0-0.005,0-0.01-0.001-0.015\r\n\t\t\t\tC53.999,29.005,54,29.003,54,29C54,27.343,52.657,26,51,26z"},"children":[]}]}]}]}]}]}]}]};exports.microphone_off=microphone_off;var microsoft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"microsoft_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"microsoft"},"children":[{"name":"g","attribs":{"id":"microsoft"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26.307,31.796c-2.208-1.219-5.281-2.486-8.648-2.486c-0.383,0-0.764,0.014-1.149,0.049\r\n\t\t\t\tc-3.377,0.302-6.453,1.232-8.613,2.052c-0.638,0.248-1.297,0.518-1.971,0.814L0.002,54.346c4.476-1.945,8.093-2.721,11.133-2.721\r\n\t\t\t\tc5.01,0,8.484,2.084,11.763,4.436c1.217-4.441,5.348-19.635,6.133-22.527C28.143,32.939,27.25,32.344,26.307,31.796z\r\n\t\t\t\t M18.765,23.98c4.802,0.054,8.205,2.119,11.372,4.382c1.213-4.427,4.814-17.723,6.03-22.209V6.136c0,0-4.244-2.737-7.197-3.548\r\n\t\t\t\tc-1.409-0.359-3.003-0.585-4.766-0.585h-0.069c-3.001,0.062-6.598,0.844-11.02,2.788L7.28,26.86\r\n\t\t\t\tc4.543-1.995,8.228-2.88,11.324-2.88H18.765z M52.561,13.559c-6.488,0-10.767-2.974-12.658-4.559l-5.985,22.306\r\n\t\t\t\tc0.017,0.019,0.043,0.035,0.063,0.048c3.291,2.371,7.572,4.287,12.732,4.287c3.412,0,7.204-0.836,11.348-2.94v-0.03\r\n\t\t\t\tc0.01,0,0.021-0.008,0.037-0.014l5.901-21.899C59.641,12.807,55.824,13.559,52.561,13.559z M32.568,36.329l-5.904,22.085\r\n\t\t\t\tc-0.009-0.005,6.904,4.584,12.089,4.584c3.281,0,7.205-0.865,12.114-3.047l5.691-21.43c-4.318,1.666-8.039,2.291-11.185,2.291\r\n\t\t\t\tC38.529,40.812,34.367,37.874,32.568,36.329z"},"children":[{"name":"path","attribs":{"d":"M26.307,31.796c-2.208-1.219-5.281-2.486-8.648-2.486c-0.383,0-0.764,0.014-1.149,0.049\r\n\t\t\t\tc-3.377,0.302-6.453,1.232-8.613,2.052c-0.638,0.248-1.297,0.518-1.971,0.814L0.002,54.346c4.476-1.945,8.093-2.721,11.133-2.721\r\n\t\t\t\tc5.01,0,8.484,2.084,11.763,4.436c1.217-4.441,5.348-19.635,6.133-22.527C28.143,32.939,27.25,32.344,26.307,31.796z\r\n\t\t\t\t M18.765,23.98c4.802,0.054,8.205,2.119,11.372,4.382c1.213-4.427,4.814-17.723,6.03-22.209V6.136c0,0-4.244-2.737-7.197-3.548\r\n\t\t\t\tc-1.409-0.359-3.003-0.585-4.766-0.585h-0.069c-3.001,0.062-6.598,0.844-11.02,2.788L7.28,26.86\r\n\t\t\t\tc4.543-1.995,8.228-2.88,11.324-2.88H18.765z M52.561,13.559c-6.488,0-10.767-2.974-12.658-4.559l-5.985,22.306\r\n\t\t\t\tc0.017,0.019,0.043,0.035,0.063,0.048c3.291,2.371,7.572,4.287,12.732,4.287c3.412,0,7.204-0.836,11.348-2.94v-0.03\r\n\t\t\t\tc0.01,0,0.021-0.008,0.037-0.014l5.901-21.899C59.641,12.807,55.824,13.559,52.561,13.559z M32.568,36.329l-5.904,22.085\r\n\t\t\t\tc-0.009-0.005,6.904,4.584,12.089,4.584c3.281,0,7.205-0.865,12.114-3.047l5.691-21.43c-4.318,1.666-8.039,2.291-11.185,2.291\r\n\t\t\t\tC38.529,40.812,34.367,37.874,32.568,36.329z"},"children":[]}]}]}]}]}]}]}]};exports.microsoft=microsoft;var minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MINUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MINUS"},"children":[{"name":"g","attribs":{"id":"MINUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52,29H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[{"name":"path","attribs":{"d":"M52,29H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[]}]}]}]}]}]}]}]};exports.minus=minus;var more={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MORE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MORE"},"children":[{"name":"g","attribs":{"id":"MORE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M13.001,26C9.687,26,7,28.687,7,32.002c0,3.314,2.687,6.001,6.001,6.001s6.001-2.687,6.001-6.001\r\n\t\t\t\tC19.001,28.687,16.315,26,13.001,26z M51.001,26C47.688,26,45,28.687,45,32.002c0,3.314,2.688,6.001,6.001,6.001\r\n\t\t\t\ts6.001-2.687,6.001-6.001C57.001,28.687,54.314,26,51.001,26z M32.001,26C28.687,26,26,28.687,26,32.002\r\n\t\t\t\tc0,3.314,2.686,6.001,6.001,6.001c3.315,0,6.001-2.687,6.001-6.001C38.001,28.687,35.314,26,32.001,26z"},"children":[{"name":"path","attribs":{"d":"M13.001,26C9.687,26,7,28.687,7,32.002c0,3.314,2.687,6.001,6.001,6.001s6.001-2.687,6.001-6.001\r\n\t\t\t\tC19.001,28.687,16.315,26,13.001,26z M51.001,26C47.688,26,45,28.687,45,32.002c0,3.314,2.688,6.001,6.001,6.001\r\n\t\t\t\ts6.001-2.687,6.001-6.001C57.001,28.687,54.314,26,51.001,26z M32.001,26C28.687,26,26,28.687,26,32.002\r\n\t\t\t\tc0,3.314,2.686,6.001,6.001,6.001c3.315,0,6.001-2.687,6.001-6.001C38.001,28.687,35.314,26,32.001,26z"},"children":[]}]}]}]}]}]}]}]};exports.more=more;var more_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MORE_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MORE_2"},"children":[{"name":"g","attribs":{"id":"MORE_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31.998,26c-3.314,0-6.001,2.687-6.001,6.001c0,3.313,2.687,6.001,6.001,6.001c3.314,0,6.002-2.688,6.002-6.001\r\n\t\t\t\tC38,28.687,35.312,26,31.998,26z M31.998,19.001C35.312,19.001,38,16.314,38,13c0-3.313-2.688-6-6.002-6\r\n\t\t\t\tc-3.314,0-6.001,2.686-6.001,6.001C25.997,16.315,28.684,19.001,31.998,19.001z M31.998,45c-3.314,0-6.001,2.688-6.001,6.001\r\n\t\t\t\ts2.687,6.001,6.001,6.001c3.314,0,6.002-2.688,6.002-6.001S35.312,45,31.998,45z"},"children":[{"name":"path","attribs":{"d":"M31.998,26c-3.314,0-6.001,2.687-6.001,6.001c0,3.313,2.687,6.001,6.001,6.001c3.314,0,6.002-2.688,6.002-6.001\r\n\t\t\t\tC38,28.687,35.312,26,31.998,26z M31.998,19.001C35.312,19.001,38,16.314,38,13c0-3.313-2.688-6-6.002-6\r\n\t\t\t\tc-3.314,0-6.001,2.686-6.001,6.001C25.997,16.315,28.684,19.001,31.998,19.001z M31.998,45c-3.314,0-6.001,2.688-6.001,6.001\r\n\t\t\t\ts2.687,6.001,6.001,6.001c3.314,0,6.002-2.688,6.002-6.001S35.312,45,31.998,45z"},"children":[]}]}]}]}]}]}]}]};exports.more_2=more_2;var moustache={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MOUSTACHE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MOUSTACHE"},"children":[{"name":"g","attribs":{"id":"MOUSTACHE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.827,26.719c-1.134-0.288-2.876,4.125-6.966,4.125c-5.254,0-7.725-8.839-15.935-8.839\r\n\t\t\t\tc-6.513,0-8.497,5.067-8.928,5.067s-2.415-5.067-8.927-5.067c-8.208,0-10.681,8.839-15.935,8.839c-4.09,0-5.83-4.413-6.964-4.125\r\n\t\t\t\tc-1.06,0.269,1.955,15.277,16.323,15.277c9.322,0,14.802-7.238,15.503-7.238c0.702,0,6.183,7.238,15.504,7.238\r\n\t\t\t\tC61.872,41.996,64.887,26.988,63.827,26.719z"},"children":[{"name":"path","attribs":{"d":"M63.827,26.719c-1.134-0.288-2.876,4.125-6.966,4.125c-5.254,0-7.725-8.839-15.935-8.839\r\n\t\t\t\tc-6.513,0-8.497,5.067-8.928,5.067s-2.415-5.067-8.927-5.067c-8.208,0-10.681,8.839-15.935,8.839c-4.09,0-5.83-4.413-6.964-4.125\r\n\t\t\t\tc-1.06,0.269,1.955,15.277,16.323,15.277c9.322,0,14.802-7.238,15.503-7.238c0.702,0,6.183,7.238,15.504,7.238\r\n\t\t\t\tC61.872,41.996,64.887,26.988,63.827,26.719z"},"children":[]}]}]}]}]}]}]}]};exports.moustache=moustache;var music={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"MUSIC_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MUSIC"},"children":[{"name":"g","attribs":{"id":"MUSIC"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M60,0L20,9c0,0-3,0.681-3,3v40.66C15.499,52.241,13.802,52,12,52c-6.075,0-11,2.686-11,6s4.925,6,11,6s11-2.686,11-6\r\n\t\t\t\tV26.123l34-7.415V43.66C55.499,43.241,53.802,43,52,43c-6.075,0-11,2.686-11,6s4.925,6,11,6s11-2.686,11-6V3\r\n\t\t\t\tC63,1.343,61.657,0,60,0z"},"children":[{"name":"path","attribs":{"d":"M60,0L20,9c0,0-3,0.681-3,3v40.66C15.499,52.241,13.802,52,12,52c-6.075,0-11,2.686-11,6s4.925,6,11,6s11-2.686,11-6\r\n\t\t\t\tV26.123l34-7.415V43.66C55.499,43.241,53.802,43,52,43c-6.075,0-11,2.686-11,6s4.925,6,11,6s11-2.686,11-6V3\r\n\t\t\t\tC63,1.343,61.657,0,60,0z"},"children":[]}]}]}]}]}]}]}]};exports.music=music;var notepad={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"NOTEPAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD"},"children":[{"name":"g","attribs":{"id":"NOTEPAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C29,10.657,30.343,12,32,12z M47,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5S51.881,54,50.5,54z M50,42H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,29,50,29z"},"children":[{"name":"path","attribs":{"d":"M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C29,10.657,30.343,12,32,12z M47,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5S51.881,54,50.5,54z M50,42H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,29,50,29z"},"children":[]}]}]}]}]}]}]}]};exports.notepad=notepad;var notepad_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M60,52h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tS61.657,52,60,52z M42,55c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6\r\n\t\t\t\ts-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5\r\n\t\t\t\tC3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h43v-3C44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S11.343,23,13,23z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h19\r\n\t\t\t\tc1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M39,42H13c-1.657,0-3-1.343-3-3s1.343-3,3-3h26c1.657,0,3,1.343,3,3\r\n\t\t\t\tS40.657,42,39,42z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z"},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M60,52h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tS61.657,52,60,52z M42,55c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6\r\n\t\t\t\ts-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5\r\n\t\t\t\tC3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h43v-3C44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S11.343,23,13,23z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5s1.119-2.5,2.5-2.5h19\r\n\t\t\t\tc1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M39,42H13c-1.657,0-3-1.343-3-3s1.343-3,3-3h26c1.657,0,3,1.343,3,3\r\n\t\t\t\tS40.657,42,39,42z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z"},"children":[]}]}]}]}]}]}]}]};exports.notepad_add=notepad_add;var notepad_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M58.243,55l3.879-3.879\r\n\t\t\t\tC62.664,50.579,63,49.828,63,49c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L54,50.757l-3.879-3.879\r\n\t\t\t\tC49.578,46.336,48.828,46,48,46c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L49.757,55l-3.879,3.879\r\n\t\t\t\tC45.336,59.422,45,60.172,45,61c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L54,59.243l3.879,3.879\r\n\t\t\t\tC58.422,63.664,59.172,64,60,64c1.657,0,3-1.343,3-3c0-0.829-0.336-1.578-0.879-2.121L58.243,55z M16,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M43.757,56.758L45.516,55l-1.758-1.757\r\n\t\t\t\tC42.672,52.157,42,50.657,42,49c0-3.314,2.686-6,6-6c1.657,0,3.157,0.672,4.243,1.757L54,46.516l1.757-1.759l0.015,0.017\r\n\t\t\t\tC56.854,43.682,58.341,43,60,43V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h37.832\r\n\t\t\t\tC42.316,63.114,42,62.1,42,61c0-1.659,0.682-3.146,1.773-4.227L43.757,56.758z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M37,42H13c-1.657,0-3-1.343-3-3s1.343-3,3-3h24\r\n\t\t\t\tc1.657,0,3,1.343,3,3S38.657,42,37,42z M13,29c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13z"},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M58.243,55l3.879-3.879\r\n\t\t\t\tC62.664,50.579,63,49.828,63,49c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L54,50.757l-3.879-3.879\r\n\t\t\t\tC49.578,46.336,48.828,46,48,46c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L49.757,55l-3.879,3.879\r\n\t\t\t\tC45.336,59.422,45,60.172,45,61c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L54,59.243l3.879,3.879\r\n\t\t\t\tC58.422,63.664,59.172,64,60,64c1.657,0,3-1.343,3-3c0-0.829-0.336-1.578-0.879-2.121L58.243,55z M16,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M43.757,56.758L45.516,55l-1.758-1.757\r\n\t\t\t\tC42.672,52.157,42,50.657,42,49c0-3.314,2.686-6,6-6c1.657,0,3.157,0.672,4.243,1.757L54,46.516l1.757-1.759l0.015,0.017\r\n\t\t\t\tC56.854,43.682,58.341,43,60,43V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h37.832\r\n\t\t\t\tC42.316,63.114,42,62.1,42,61c0-1.659,0.682-3.146,1.773-4.227L43.757,56.758z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M37,42H13c-1.657,0-3-1.343-3-3s1.343-3,3-3h24\r\n\t\t\t\tc1.657,0,3,1.343,3,3S38.657,42,37,42z M13,29c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13z"},"children":[]}]}]}]}]}]}]}]};exports.notepad_delete=notepad_delete;var notepad_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M46,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M16,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,50c-0.828,0-1.578,0.336-2.121,0.879L52,56.758\r\n\t\t\t\tl-1.879-1.879C49.578,54.336,48.829,54,48,54c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l4,4\r\n\t\t\t\tC50.422,63.664,51.172,64,52,64s1.578-0.336,2.121-0.879l8-8C62.664,54.578,63,53.828,63,53C63,51.343,61.657,50,60,50z\r\n\t\t\t\t M43.775,61.225C42.684,60.146,42,58.659,42,57c0-3.314,2.686-6,6-6c1.535,0,2.908,0.602,3.961,1.555l3.797-3.798\r\n\t\t\t\tC56.843,47.672,58.343,47,60,47V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h41.516\r\n\t\t\t\tl-2.758-2.757L43.775,61.225z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,23,13,23z M13,36h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z"},"children":[{"name":"path","attribs":{"d":"M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M46,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M16,12c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,50c-0.828,0-1.578,0.336-2.121,0.879L52,56.758\r\n\t\t\t\tl-1.879-1.879C49.578,54.336,48.829,54,48,54c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l4,4\r\n\t\t\t\tC50.422,63.664,51.172,64,52,64s1.578-0.336,2.121-0.879l8-8C62.664,54.578,63,53.828,63,53C63,51.343,61.657,50,60,50z\r\n\t\t\t\t M43.775,61.225C42.684,60.146,42,58.659,42,57c0-3.314,2.686-6,6-6c1.535,0,2.908,0.602,3.961,1.555l3.797-3.798\r\n\t\t\t\tC56.843,47.672,58.343,47,60,47V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\tc-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h41.516\r\n\t\t\t\tl-2.758-2.757L43.775,61.225z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,23,13,23z M13,36h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z"},"children":[]}]}]}]}]}]}]}]};exports.notepad_ok=notepad_ok;var notepad_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M42,55c0-3.314,2.686-6,6-6h12V9\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3H48\r\n\t\t\t\tC44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,23,13,23z M13,36h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,52H48c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S61.657,52,60,52\r\n\t\t\t\tz"},"children":[{"name":"path","attribs":{"d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z M31,12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z M42,55c0-3.314,2.686-6,6-6h12V9\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3H48\r\n\t\t\t\tC44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,23,13,23z M13,36h36\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5\r\n\t\t\t\ts1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5S32.881,54,31.5,54z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,52H48c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S61.657,52,60,52\r\n\t\t\t\tz"},"children":[]}]}]}]}]}]}]}]};exports.notepad_remove=notepad_remove;var pause={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PAUSE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PAUSE"},"children":[{"name":"g","attribs":{"id":"PAUSE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C29,20.343,27.657,19,26,19z M38,19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C41,20.343,39.657,19,38,19z"},"children":[{"name":"path","attribs":{"d":"M26,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C29,20.343,27.657,19,26,19z M38,19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C41,20.343,39.657,19,38,19z"},"children":[]}]}]}]}]}]}]}]};exports.pause=pause;var paypal={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"paypal_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"paypal"},"children":[{"name":"g","attribs":{"id":"paypal"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M34.878,24.706c0.474-0.299,0.925-0.635,1.335-1.018c1.145-1.061,2.006-2.423,2.369-3.916\r\n\t\t\t\tc0.633-2.24-0.102-4.184-1.617-5.26c-0.797-0.566-1.808-0.901-2.955-0.901h-6.65l-0.214,0.901L24.45,25.935h6.372\r\n\t\t\t\tC32.234,25.935,33.643,25.473,34.878,24.706z M30.925,18.05h3.087c0.159,0,0.254,0.026,0.301,0.043\r\n\t\t\t\tc0.011,0.067,0.019,0.22-0.057,0.48l-0.023,0.082l-0.018,0.082c-0.346,1.418-1.994,2.76-3.394,2.76h-0.712L30.925,18.05z\r\n\t\t\t\t M60.611,16.282c-1.295-1.592-2.928-2.913-4.782-3.928c-0.61-2.671-1.804-4.704-2.976-6.148C49.714,2.346,44.585,0.033,39.117,0\r\n\t\t\t\tH12.265l-0.787,3.458L1.224,48.52L0,53.9v0.031h10.042l-1.058,4.661L7.752,64h22.802l0.774-3.477l2.55-11.44h6.089\r\n\t\t\t\tc11.803,0,21.03-7.176,23.508-18.278c0.367-1.649,0.521-3.163,0.525-4.557v-0.456C63.904,21.396,62.234,18.281,60.611,16.282z\r\n\t\t\t\t M5.606,49.491L15.861,4.43H39c4.283,0,9.005,1.916,11.316,5.974c0.795,1.398,1.306,3.051,1.412,4.969\r\n\t\t\t\tc0.076,1.334-0.043,2.801-0.399,4.398c-0.812,3.64-2.499,6.678-4.796,9.048c-3.51,3.625-8.463,5.652-13.979,5.732\r\n\t\t\t\tc-0.117,0.004-0.229,0.014-0.344,0.014H22.51L19.186,49.49L5.606,49.491L5.606,49.491z M59.087,29.848\r\n\t\t\t\tc-2.077,9.316-9.837,14.796-19.12,14.796h-9.699L26.943,59.57H13.366l1.283-5.639h8.147l0.777-3.484l2.547-11.441h6.09\r\n\t\t\t\tc11.802,0,21.026-7.176,23.505-18.275c0.209-0.941,0.348-1.837,0.434-2.696C58.802,20.547,60.295,24.44,59.087,29.848z"},"children":[{"name":"path","attribs":{"d":"M34.878,24.706c0.474-0.299,0.925-0.635,1.335-1.018c1.145-1.061,2.006-2.423,2.369-3.916\r\n\t\t\t\tc0.633-2.24-0.102-4.184-1.617-5.26c-0.797-0.566-1.808-0.901-2.955-0.901h-6.65l-0.214,0.901L24.45,25.935h6.372\r\n\t\t\t\tC32.234,25.935,33.643,25.473,34.878,24.706z M30.925,18.05h3.087c0.159,0,0.254,0.026,0.301,0.043\r\n\t\t\t\tc0.011,0.067,0.019,0.22-0.057,0.48l-0.023,0.082l-0.018,0.082c-0.346,1.418-1.994,2.76-3.394,2.76h-0.712L30.925,18.05z\r\n\t\t\t\t M60.611,16.282c-1.295-1.592-2.928-2.913-4.782-3.928c-0.61-2.671-1.804-4.704-2.976-6.148C49.714,2.346,44.585,0.033,39.117,0\r\n\t\t\t\tH12.265l-0.787,3.458L1.224,48.52L0,53.9v0.031h10.042l-1.058,4.661L7.752,64h22.802l0.774-3.477l2.55-11.44h6.089\r\n\t\t\t\tc11.803,0,21.03-7.176,23.508-18.278c0.367-1.649,0.521-3.163,0.525-4.557v-0.456C63.904,21.396,62.234,18.281,60.611,16.282z\r\n\t\t\t\t M5.606,49.491L15.861,4.43H39c4.283,0,9.005,1.916,11.316,5.974c0.795,1.398,1.306,3.051,1.412,4.969\r\n\t\t\t\tc0.076,1.334-0.043,2.801-0.399,4.398c-0.812,3.64-2.499,6.678-4.796,9.048c-3.51,3.625-8.463,5.652-13.979,5.732\r\n\t\t\t\tc-0.117,0.004-0.229,0.014-0.344,0.014H22.51L19.186,49.49L5.606,49.491L5.606,49.491z M59.087,29.848\r\n\t\t\t\tc-2.077,9.316-9.837,14.796-19.12,14.796h-9.699L26.943,59.57H13.366l1.283-5.639h8.147l0.777-3.484l2.547-11.441h6.09\r\n\t\t\t\tc11.802,0,21.026-7.176,23.505-18.275c0.209-0.941,0.348-1.837,0.434-2.696C58.802,20.547,60.295,24.44,59.087,29.848z"},"children":[]}]}]}]}]}]}]}]};exports.paypal=paypal;var pen_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PEN_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_1"},"children":[{"name":"g","attribs":{"id":"PEN_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M12.938,42.498l8.446,8.429l25.339-25.288l-8.447-8.429L12.938,42.498z M7.998,55.84l11.258-2.806l-8.447-8.431\r\n\t\t\t\tL7.998,55.84z M55.167,12.996l-4.224-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429l6.334-6.322\r\n\t\t\t\tC56.333,16.046,56.333,14.159,55.167,12.996z"},"children":[{"name":"path","attribs":{"d":"M12.938,42.498l8.446,8.429l25.339-25.288l-8.447-8.429L12.938,42.498z M7.998,55.84l11.258-2.806l-8.447-8.431\r\n\t\t\t\tL7.998,55.84z M55.167,12.996l-4.224-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429l6.334-6.322\r\n\t\t\t\tC56.333,16.046,56.333,14.159,55.167,12.996z"},"children":[]}]}]}]}]}]}]}]};exports.pen_1=pen_1;var pen_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PEN_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_2"},"children":[{"name":"g","attribs":{"id":"PEN_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46.721,19.639l-8.445-8.429L12.938,36.498l8.446,8.429L46.721,19.639z M55.167,11.21c1.166-1.164,1.166-3.051,0-4.214\r\n\t\t\t\tl-4.224-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429L55.167,11.21z M61,56H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,56,61,56z M10.809,38.604L7.998,49.84l11.258-2.806L10.809,38.604z"},"children":[{"name":"path","attribs":{"d":"M46.721,19.639l-8.445-8.429L12.938,36.498l8.446,8.429L46.721,19.639z M55.167,11.21c1.166-1.164,1.166-3.051,0-4.214\r\n\t\t\t\tl-4.224-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429L55.167,11.21z M61,56H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,56,61,56z M10.809,38.604L7.998,49.84l11.258-2.806L10.809,38.604z"},"children":[]}]}]}]}]}]}]}]};exports.pen_2=pen_2;var pen_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PEN_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_3"},"children":[{"name":"g","attribs":{"id":"PEN_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61.167,6.995L56.943,2.78c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429l6.334-6.322\r\n\t\t\t\tC62.334,10.046,62.334,8.159,61.167,6.995z M53,57H7V11h33.357l6-6H4C2.343,5,1,6.343,1,8v52c0,1.657,1.343,3,3,3h52\r\n\t\t\t\tc1.657,0,3-1.343,3-3V17.813l-6,6V57z M52.721,19.639l-8.445-8.429L18.938,36.498l8.446,8.429L52.721,19.639z M13.998,49.84\r\n\t\t\t\tl11.258-2.806l-8.447-8.431L13.998,49.84z"},"children":[{"name":"path","attribs":{"d":"M61.167,6.995L56.943,2.78c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429l6.334-6.322\r\n\t\t\t\tC62.334,10.046,62.334,8.159,61.167,6.995z M53,57H7V11h33.357l6-6H4C2.343,5,1,6.343,1,8v52c0,1.657,1.343,3,3,3h52\r\n\t\t\t\tc1.657,0,3-1.343,3-3V17.813l-6,6V57z M52.721,19.639l-8.445-8.429L18.938,36.498l8.446,8.429L52.721,19.639z M13.998,49.84\r\n\t\t\t\tl11.258-2.806l-8.447-8.431L13.998,49.84z"},"children":[]}]}]}]}]}]}]}]};exports.pen_3=pen_3;var picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PICTURE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PICTURE"},"children":[{"name":"g","attribs":{"id":"PICTURE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M22,28c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S18.686,28,22,28z M62,14c0-1.304-0.837-2.403-2-2.816V7.816\r\n\t\t\t\tC61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3c-1.305,0-2.402,0.838-2.816,2h-3.367C52.402,2.838,51.305,2,50,2\r\n\t\t\t\ts-2.402,0.838-2.816,2h-3.367C43.402,2.838,42.305,2,41,2s-2.402,0.838-2.816,2h-3.367C34.402,2.838,33.305,2,32,2\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2h-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2\r\n\t\t\t\ts-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,11.597,2,12.696,2,14s0.837,2.403,2,2.816v3.367C2.838,20.597,2,21.696,2,23s0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,29.597,2,30.696,2,32c0,1.305,0.837,2.402,2,2.816v3.367C2.838,38.598,2,39.695,2,41s0.837,2.402,2,2.816v3.367\r\n\t\t\t\tC2.838,47.598,2,48.695,2,50s0.837,2.402,2,2.816v3.367C2.838,56.598,2,57.695,2,59c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.815-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.402-0.837,2.816-2h3.367c0.412,1.162,1.512,2,2.815,2s2.403-0.837,2.815-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.656,0,3-1.343,3-3c0-1.305-0.837-2.402-2-2.816v-3.367c1.163-0.412,2-1.512,2-2.815s-0.837-2.403-2-2.815v-3.367\r\n\t\t\t\tc1.163-0.414,2-1.512,2-2.816c0-1.304-0.837-2.402-2-2.816v-3.367c1.163-0.412,2-1.512,2-2.815s-0.837-2.403-2-2.816V25.82\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z M51,39\r\n\t\t\t\tl-9-14L28,42l-3-3L13,51h38V39z"},"children":[{"name":"path","attribs":{"d":"M22,28c3.314,0,6-2.686,6-6s-2.686-6-6-6s-6,2.686-6,6S18.686,28,22,28z M62,14c0-1.304-0.837-2.403-2-2.816V7.816\r\n\t\t\t\tC61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3c-1.305,0-2.402,0.838-2.816,2h-3.367C52.402,2.838,51.305,2,50,2\r\n\t\t\t\ts-2.402,0.838-2.816,2h-3.367C43.402,2.838,42.305,2,41,2s-2.402,0.838-2.816,2h-3.367C34.402,2.838,33.305,2,32,2\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2h-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2\r\n\t\t\t\ts-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,11.597,2,12.696,2,14s0.837,2.403,2,2.816v3.367C2.838,20.597,2,21.696,2,23s0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,29.597,2,30.696,2,32c0,1.305,0.837,2.402,2,2.816v3.367C2.838,38.598,2,39.695,2,41s0.837,2.402,2,2.816v3.367\r\n\t\t\t\tC2.838,47.598,2,48.695,2,50s0.837,2.402,2,2.816v3.367C2.838,56.598,2,57.695,2,59c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.815-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.402-0.837,2.816-2h3.367c0.412,1.162,1.512,2,2.815,2s2.403-0.837,2.815-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.656,0,3-1.343,3-3c0-1.305-0.837-2.402-2-2.816v-3.367c1.163-0.412,2-1.512,2-2.815s-0.837-2.403-2-2.815v-3.367\r\n\t\t\t\tc1.163-0.414,2-1.512,2-2.816c0-1.304-0.837-2.402-2-2.816v-3.367c1.163-0.412,2-1.512,2-2.815s-0.837-2.403-2-2.816V25.82\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z M51,39\r\n\t\t\t\tl-9-14L28,42l-3-3L13,51h38V39z"},"children":[]}]}]}]}]}]}]}]};exports.picture=picture;var pie_chart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PIE_CHART_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIE_CHART"},"children":[{"name":"g","attribs":{"id":"PIE_CHART"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M35,0v29h29C64,12.984,51.016,0,35,0z M29,6C12.984,6,0,18.984,0,35c0,16.018,12.984,29,29,29c16.016,0,29-12.984,29-29\r\n\t\t\t\tH29V6z"},"children":[{"name":"path","attribs":{"d":"M35,0v29h29C64,12.984,51.016,0,35,0z M29,6C12.984,6,0,18.984,0,35c0,16.018,12.984,29,29,29c16.016,0,29-12.984,29-29\r\n\t\t\t\tH29V6z"},"children":[]}]}]}]}]}]}]}]};exports.pie_chart=pie_chart;var pill={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PILL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.981,9.726l-0.707-0.707c-6.834-6.834-17.914-6.834-24.749,0L9.019,29.525\r\n\t\t\tc-6.834,6.834-6.834,17.914,0,24.748l0.707,0.707c6.834,6.834,17.914,6.834,24.749,0l20.506-20.506\r\n\t\t\tC61.815,27.641,61.815,16.56,54.981,9.726z M30.232,50.738c-4.491,4.491-11.772,4.491-16.263,0l-0.707-0.707\r\n\t\t\tc-4.491-4.491-4.491-11.772,0-16.263l10.253-10.253l16.971,16.97L30.232,50.738z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.981,9.726l-0.707-0.707c-6.834-6.834-17.914-6.834-24.749,0L9.019,29.525\r\n\t\t\tc-6.834,6.834-6.834,17.914,0,24.748l0.707,0.707c6.834,6.834,17.914,6.834,24.749,0l20.506-20.506\r\n\t\t\tC61.815,27.641,61.815,16.56,54.981,9.726z M30.232,50.738c-4.491,4.491-11.772,4.491-16.263,0l-0.707-0.707\r\n\t\t\tc-4.491-4.491-4.491-11.772,0-16.263l10.253-10.253l16.971,16.97L30.232,50.738z"},"children":[]}]}]}]}]}]};exports.pill=pill;var pin_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PIN_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN_1"},"children":[{"name":"g","attribs":{"id":"PIN_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40\r\n\t\t\t\tc-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16S40.836,40,32,40z"},"children":[{"name":"path","attribs":{"d":"M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40\r\n\t\t\t\tc-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16S40.836,40,32,40z"},"children":[]}]}]}]}]}]}]}]};exports.pin_1=pin_1;var pin_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PIN_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN_2"},"children":[{"name":"g","attribs":{"id":"PIN_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,16c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S36.418,16,32,16z M32,0C18.746,0,8,10.747,8,24\r\n\t\t\t\tc0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16\r\n\t\t\t\tS40.836,40,32,40z"},"children":[{"name":"path","attribs":{"d":"M32,16c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S36.418,16,32,16z M32,0C18.746,0,8,10.747,8,24\r\n\t\t\t\tc0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16\r\n\t\t\t\tS40.836,40,32,40z"},"children":[]}]}]}]}]}]}]}]};exports.pin_2=pin_2;var pin_zoom_in={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN"},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M40,21h-5v-5c0-1.657-1.343-3-3-3s-3,1.343-3,3v5h-5c-1.657,0-3,1.343-3,3s1.343,3,3,3h5v5c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-5h5c1.657,0,3-1.343,3-3S41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40\r\n\t\t\t\tC56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16S40.836,40,32,40z"},"children":[{"name":"path","attribs":{"d":"M40,21h-5v-5c0-1.657-1.343-3-3-3s-3,1.343-3,3v5h-5c-1.657,0-3,1.343-3,3s1.343,3,3,3h5v5c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-5h5c1.657,0,3-1.343,3-3S41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40\r\n\t\t\t\tC56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16S40.836,40,32,40z"},"children":[]}]}]}]}]}]}]}]};exports.pin_zoom_in=pin_zoom_in;var pin_zoom_out={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT"},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M40,21H24c-1.657,0-3,1.343-3,3s1.343,3,3,3h16c1.657,0,3-1.343,3-3S41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24\r\n\t\t\t\tc0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16\r\n\t\t\t\tS40.836,40,32,40z"},"children":[{"name":"path","attribs":{"d":"M40,21H24c-1.657,0-3,1.343-3,3s1.343,3,3,3h16c1.657,0,3-1.343,3-3S41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24\r\n\t\t\t\tc0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16S23.164,8,32,8s16,7.164,16,16\r\n\t\t\t\tS40.836,40,32,40z"},"children":[]}]}]}]}]}]}]}]};exports.pin_zoom_out=pin_zoom_out;var pinterest_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"pinterest_2_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"pinterest_1_"},"children":[{"name":"g","attribs":{"id":"pinterest_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M55.988,15.676c-0.967-3.324-2.491-5.987-4.586-8.274c-2.033-2.223-4.437-4.016-7.449-5.364\r\n\t\t\t\tC41.1,0.762,37.307-0.183,33.139,0.014c-1.428,0.067-2.742,0.144-4.013,0.329c-3.83,0.557-6.978,1.715-9.768,3.364\r\n\t\t\t\tc-3.63,2.146-6.612,5.15-8.647,8.906c-0.981,1.809-1.867,4.037-2.343,6.452c-0.493,2.498-0.494,5.513,0,8.096\r\n\t\t\t\tc0.812,4.253,2.794,7.532,6.055,9.336c0.436,0.241,1.082,0.617,1.595,0.606c1.241-0.024,1.27-1.492,1.545-2.555\r\n\t\t\t\tc0.228-0.882,0.761-2.096,0.299-2.91c-0.326-0.574-0.815-0.99-1.146-1.493c-1.046-1.586-1.695-3.622-1.695-6.249\r\n\t\t\t\tc0-3.408,0.833-6.145,2.093-8.526c2.406-4.545,6.493-7.838,12.285-8.831c3.188-0.546,6.777-0.264,9.371,0.582\r\n\t\t\t\tc2.613,0.853,4.763,2.371,6.279,4.276c1.594,2.002,2.598,4.583,2.816,7.793c0.117,1.739-0.006,3.502-0.174,5.035\r\n\t\t\t\tc-0.524,4.757-1.906,8.754-4.187,11.715c-1.426,1.852-3.56,3.813-6.629,3.922c-1.737,0.061-2.998-0.365-4.062-1.139\r\n\t\t\t\tc-1.027-0.748-1.779-1.744-2.12-3.188c-0.369-1.574,0.078-3.072,0.473-4.53c0.798-2.94,1.675-5.229,2.342-8.274\r\n\t\t\t\tc0.297-1.352,0.568-3.19,0.2-4.731c-0.347-1.445-1.087-2.467-2.168-3.112c-1.049-0.626-2.777-0.872-4.336-0.33\r\n\t\t\t\tc-2.453,0.855-4.045,3.201-4.735,5.845c-0.391,1.496-0.531,3.119-0.349,4.858c0.158,1.514,0.518,2.809,1.071,4.251\r\n\t\t\t\tc0.076,0.197-0.143,0.768-0.225,1.114c-1.222,5.192-2.377,10.25-3.588,15.408c-0.636,2.708-1.321,5.419-1.47,8.679\r\n\t\t\t\tc-0.131,2.86-0.371,5.803-0.019,8.35c0.065,0.469,0.094,0.791,0.424,0.86c0.433,0.089,0.127,0.755,1.564-0.911\r\n\t\t\t\tc2.163-2.506,3.811-5.6,5.109-8.805c0.783-1.934,1.256-4.068,1.794-6.173c0.546-2.134,1.072-4.318,1.595-6.401\r\n\t\t\t\tc0.804,1.414,1.939,2.35,3.29,3.112c1.362,0.769,2.979,1.306,4.959,1.442c2.037,0.142,3.94-0.223,5.606-0.709\r\n\t\t\t\tc1.682-0.49,3.162-1.226,4.387-2.024c5.046-3.29,8.408-9.072,9.594-16.142c0.316-1.889,0.77-3.777,0.77-5.921\r\n\t\t\t\tC56.982,19.258,56.492,17.406,55.988,15.676z"},"children":[{"name":"path","attribs":{"d":"M55.988,15.676c-0.967-3.324-2.491-5.987-4.586-8.274c-2.033-2.223-4.437-4.016-7.449-5.364\r\n\t\t\t\tC41.1,0.762,37.307-0.183,33.139,0.014c-1.428,0.067-2.742,0.144-4.013,0.329c-3.83,0.557-6.978,1.715-9.768,3.364\r\n\t\t\t\tc-3.63,2.146-6.612,5.15-8.647,8.906c-0.981,1.809-1.867,4.037-2.343,6.452c-0.493,2.498-0.494,5.513,0,8.096\r\n\t\t\t\tc0.812,4.253,2.794,7.532,6.055,9.336c0.436,0.241,1.082,0.617,1.595,0.606c1.241-0.024,1.27-1.492,1.545-2.555\r\n\t\t\t\tc0.228-0.882,0.761-2.096,0.299-2.91c-0.326-0.574-0.815-0.99-1.146-1.493c-1.046-1.586-1.695-3.622-1.695-6.249\r\n\t\t\t\tc0-3.408,0.833-6.145,2.093-8.526c2.406-4.545,6.493-7.838,12.285-8.831c3.188-0.546,6.777-0.264,9.371,0.582\r\n\t\t\t\tc2.613,0.853,4.763,2.371,6.279,4.276c1.594,2.002,2.598,4.583,2.816,7.793c0.117,1.739-0.006,3.502-0.174,5.035\r\n\t\t\t\tc-0.524,4.757-1.906,8.754-4.187,11.715c-1.426,1.852-3.56,3.813-6.629,3.922c-1.737,0.061-2.998-0.365-4.062-1.139\r\n\t\t\t\tc-1.027-0.748-1.779-1.744-2.12-3.188c-0.369-1.574,0.078-3.072,0.473-4.53c0.798-2.94,1.675-5.229,2.342-8.274\r\n\t\t\t\tc0.297-1.352,0.568-3.19,0.2-4.731c-0.347-1.445-1.087-2.467-2.168-3.112c-1.049-0.626-2.777-0.872-4.336-0.33\r\n\t\t\t\tc-2.453,0.855-4.045,3.201-4.735,5.845c-0.391,1.496-0.531,3.119-0.349,4.858c0.158,1.514,0.518,2.809,1.071,4.251\r\n\t\t\t\tc0.076,0.197-0.143,0.768-0.225,1.114c-1.222,5.192-2.377,10.25-3.588,15.408c-0.636,2.708-1.321,5.419-1.47,8.679\r\n\t\t\t\tc-0.131,2.86-0.371,5.803-0.019,8.35c0.065,0.469,0.094,0.791,0.424,0.86c0.433,0.089,0.127,0.755,1.564-0.911\r\n\t\t\t\tc2.163-2.506,3.811-5.6,5.109-8.805c0.783-1.934,1.256-4.068,1.794-6.173c0.546-2.134,1.072-4.318,1.595-6.401\r\n\t\t\t\tc0.804,1.414,1.939,2.35,3.29,3.112c1.362,0.769,2.979,1.306,4.959,1.442c2.037,0.142,3.94-0.223,5.606-0.709\r\n\t\t\t\tc1.682-0.49,3.162-1.226,4.387-2.024c5.046-3.29,8.408-9.072,9.594-16.142c0.316-1.889,0.77-3.777,0.77-5.921\r\n\t\t\t\tC56.982,19.258,56.492,17.406,55.988,15.676z"},"children":[]}]}]}]}]}]}]}]};exports.pinterest_1=pinterest_1;var pinterest_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"pinterest_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"pinterest"},"children":[{"name":"g","attribs":{"id":"pinterest"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.328,0,0,14.328,0,32c0,13.172,7.961,24.484,19.33,29.396c-0.082-2.23-0.002-4.892,0.562-7.303\r\n\t\t\t\tc0.621-2.604,4.137-17.5,4.137-17.5s-1.027-2.053-1.027-5.084c0-4.754,2.762-8.312,6.193-8.312c2.922,0,4.334,2.199,4.334,4.826\r\n\t\t\t\tc0,2.936-1.873,7.326-2.84,11.393c-0.801,3.406,1.715,6.188,5.075,6.188c6.079,0,10.176-7.815,10.176-17.079\r\n\t\t\t\tc0-7.035-4.734-12.307-13.359-12.307c-9.738,0-15.815,7.265-15.815,15.383c0,2.797,0.828,4.773,2.123,6.299\r\n\t\t\t\tc0.594,0.701,0.674,0.983,0.457,1.793c-0.156,0.588-0.502,2.01-0.65,2.578c-0.213,0.812-0.875,1.098-1.609,0.799\r\n\t\t\t\tc-4.484-1.828-6.578-6.742-6.578-12.266c0-9.125,7.695-20.064,22.953-20.064c12.266,0,20.334,8.875,20.334,18.395\r\n\t\t\t\tc0,12.605-7.006,22.013-17.328,22.013c-3.469,0-6.732-1.875-7.844-4c0,0-1.871,7.393-2.262,8.826\r\n\t\t\t\tc-0.674,2.439-1.973,4.877-3.176,6.797C25.982,63.57,28.94,64,32,64c17.672,0,32-14.328,32-32S49.672,0,32,0z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.328,0,0,14.328,0,32c0,13.172,7.961,24.484,19.33,29.396c-0.082-2.23-0.002-4.892,0.562-7.303\r\n\t\t\t\tc0.621-2.604,4.137-17.5,4.137-17.5s-1.027-2.053-1.027-5.084c0-4.754,2.762-8.312,6.193-8.312c2.922,0,4.334,2.199,4.334,4.826\r\n\t\t\t\tc0,2.936-1.873,7.326-2.84,11.393c-0.801,3.406,1.715,6.188,5.075,6.188c6.079,0,10.176-7.815,10.176-17.079\r\n\t\t\t\tc0-7.035-4.734-12.307-13.359-12.307c-9.738,0-15.815,7.265-15.815,15.383c0,2.797,0.828,4.773,2.123,6.299\r\n\t\t\t\tc0.594,0.701,0.674,0.983,0.457,1.793c-0.156,0.588-0.502,2.01-0.65,2.578c-0.213,0.812-0.875,1.098-1.609,0.799\r\n\t\t\t\tc-4.484-1.828-6.578-6.742-6.578-12.266c0-9.125,7.695-20.064,22.953-20.064c12.266,0,20.334,8.875,20.334,18.395\r\n\t\t\t\tc0,12.605-7.006,22.013-17.328,22.013c-3.469,0-6.732-1.875-7.844-4c0,0-1.871,7.393-2.262,8.826\r\n\t\t\t\tc-0.674,2.439-1.973,4.877-3.176,6.797C25.982,63.57,28.94,64,32,64c17.672,0,32-14.328,32-32S49.672,0,32,0z"},"children":[]}]}]}]}]}]}]}]};exports.pinterest_2=pinterest_2;var play={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PLAY_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PLAY"},"children":[{"name":"g","attribs":{"id":"PLAY"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,32c0-1.099-0.592-2.06-1.475-2.583l0,0L22.561,16.438c-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0\r\n\t\t\t\tC22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3c0.557,0,1.079-0.152,1.526-0.417l0,0l0.011-0.007\r\n\t\t\t\tc0.008-0.006,0.016-0.01,0.024-0.014l21.964-12.979l0,0C45.408,34.061,46,33.1,46,32z"},"children":[{"name":"path","attribs":{"d":"M46,32c0-1.099-0.592-2.06-1.475-2.583l0,0L22.561,16.438c-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0\r\n\t\t\t\tC22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3c0.557,0,1.079-0.152,1.526-0.417l0,0l0.011-0.007\r\n\t\t\t\tc0.008-0.006,0.016-0.01,0.024-0.014l21.964-12.979l0,0C45.408,34.061,46,33.1,46,32z"},"children":[]}]}]}]}]}]}]}]};exports.play=play;var plug={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PLUG"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.836,21.812c-1.164-1.164-3.052-1.164-4.216,0l-7.026,7.026l-8.432-8.432\r\n\t\t\tl7.026-7.026c1.164-1.164,1.164-3.052,0-4.216C41.024,8,39.137,8,37.973,9.164l-7.026,7.026l-4.216-4.216l-5.972,5.972\r\n\t\t\tc-6.193,6.193-6.719,15.885-1.617,22.696L9.164,50.62C8,51.784,8,53.672,9.164,54.836c1.164,1.164,3.052,1.164,4.216,0\r\n\t\t\tl9.977-9.977c6.811,5.102,16.503,4.576,22.696-1.617l5.972-5.973l-4.216-4.216l7.026-7.026C56,24.863,56,22.976,54.836,21.812z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.836,21.812c-1.164-1.164-3.052-1.164-4.216,0l-7.026,7.026l-8.432-8.432\r\n\t\t\tl7.026-7.026c1.164-1.164,1.164-3.052,0-4.216C41.024,8,39.137,8,37.973,9.164l-7.026,7.026l-4.216-4.216l-5.972,5.972\r\n\t\t\tc-6.193,6.193-6.719,15.885-1.617,22.696L9.164,50.62C8,51.784,8,53.672,9.164,54.836c1.164,1.164,3.052,1.164,4.216,0\r\n\t\t\tl9.977-9.977c6.811,5.102,16.503,4.576,22.696-1.617l5.972-5.973l-4.216-4.216l7.026-7.026C56,24.863,56,22.976,54.836,21.812z"},"children":[]}]}]}]}]}]};exports.plug=plug;var plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PLUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PLUS"},"children":[{"name":"g","attribs":{"id":"PLUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52,29H35V12c0-1.657-1.343-3-3-3s-3,1.343-3,3v17H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h17v17c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V35h17c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[{"name":"path","attribs":{"d":"M52,29H35V12c0-1.657-1.343-3-3-3s-3,1.343-3,3v17H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h17v17c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V35h17c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[]}]}]}]}]}]}]}]};exports.plus=plus;var polaroid={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"POLAROID_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POLAROID"},"children":[{"name":"g","attribs":{"id":"POLAROID"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M53,6H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V9C56,7.343,54.657,6,53,6z M50,43H14V12h36\r\n\t\t\t\tV43z"},"children":[{"name":"path","attribs":{"d":"M53,6H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V9C56,7.343,54.657,6,53,6z M50,43H14V12h36\r\n\t\t\t\tV43z"},"children":[]}]}]}]}]}]}]}]};exports.polaroid=polaroid;var polaroids={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"POLAROIDS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POLAROIDS"},"children":[{"name":"g","attribs":{"id":"POLAROIDS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,12H3c-1.657,0-3,1.343-3,3v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V15C48,13.343,46.657,12,45,12z M42,49H6\r\n\t\t\t\tV18h36V49z M61,0H19c-1.657,0-3,1.343-3,3v6h6V6h36v31h-7v15h10c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"d":"M45,12H3c-1.657,0-3,1.343-3,3v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V15C48,13.343,46.657,12,45,12z M42,49H6\r\n\t\t\t\tV18h36V49z M61,0H19c-1.657,0-3,1.343-3,3v6h6V6h36v31h-7v15h10c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]}]};exports.polaroids=polaroids;var power={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"POWER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POWER"},"children":[{"name":"g","attribs":{"id":"POWER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,33c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186l0,0V30C28,31.657,29.343,33,31,33z M42,8.162\r\n\t\t\t\tv0.009C41.688,8.061,41.352,8,41,8c-1.657,0-3,1.343-3,3c0,1.306,0.835,2.417,2,2.829v0.003C48.229,17.335,54,25.492,54,35\r\n\t\t\t\tc0,12.703-10.297,23-23,23S8,47.703,8,35c0-9.508,5.771-17.666,14-21.168v-0.003c1.165-0.412,2-1.523,2-2.829\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.351,0-0.687,0.061-1,0.171V8.162C9.439,12.495,2,22.878,2,35c0,16.016,12.984,29,29,29\r\n\t\t\t\tc16.016,0,29-12.984,29-29C60,22.878,52.561,12.495,42,8.162z"},"children":[{"name":"path","attribs":{"d":"M31,33c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186l0,0V30C28,31.657,29.343,33,31,33z M42,8.162\r\n\t\t\t\tv0.009C41.688,8.061,41.352,8,41,8c-1.657,0-3,1.343-3,3c0,1.306,0.835,2.417,2,2.829v0.003C48.229,17.335,54,25.492,54,35\r\n\t\t\t\tc0,12.703-10.297,23-23,23S8,47.703,8,35c0-9.508,5.771-17.666,14-21.168v-0.003c1.165-0.412,2-1.523,2-2.829\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.351,0-0.687,0.061-1,0.171V8.162C9.439,12.495,2,22.878,2,35c0,16.016,12.984,29,29,29\r\n\t\t\t\tc16.016,0,29-12.984,29-29C60,22.878,52.561,12.495,42,8.162z"},"children":[]}]}]}]}]}]}]}]};exports.power=power;var presentation={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PRESENTATION"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6H35V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3H3C1.343,6,0,7.343,0,9\r\n\t\t\tc0,1.657,1.343,3,3,3h3v34c0,1.657,1.343,3,3,3h15.757l-9.879,9.879C14.336,59.422,14,60.172,14,61c0,1.657,1.343,3,3,3\r\n\t\t\tc0.828,0,1.579-0.336,2.121-0.879L29,53.243V61c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7.757l9.879,9.879\r\n\t\t\tC45.422,63.664,46.172,64,47,64c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L39.243,49H55c1.657,0,3-1.343,3-3V12h3\r\n\t\t\tc1.657,0,3-1.343,3-3C64,7.343,62.657,6,61,6z M52,43H12V12h40V43z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6H35V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3H3C1.343,6,0,7.343,0,9\r\n\t\t\tc0,1.657,1.343,3,3,3h3v34c0,1.657,1.343,3,3,3h15.757l-9.879,9.879C14.336,59.422,14,60.172,14,61c0,1.657,1.343,3,3,3\r\n\t\t\tc0.828,0,1.579-0.336,2.121-0.879L29,53.243V61c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7.757l9.879,9.879\r\n\t\t\tC45.422,63.664,46.172,64,47,64c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L39.243,49H55c1.657,0,3-1.343,3-3V12h3\r\n\t\t\tc1.657,0,3-1.343,3-3C64,7.343,62.657,6,61,6z M52,43H12V12h40V43z"},"children":[]}]}]}]}]}]};exports.presentation=presentation;var printer={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PRINTER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PRINTER"},"children":[{"name":"g","attribs":{"id":"PRINTER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,15H3c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h10V34h38v15h10c1.657,0,3-1.343,3-3V18C64,16.343,62.657,15,61,15\r\n\t\t\t\tz M9,27c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S10.657,27,9,27z M48,2.969h-0.003c0-0.001,0-0.002,0-0.003\r\n\t\t\t\tC47.99,2.351,47.8,1.782,47.477,1.309c-0.004-0.007-0.012-0.013-0.017-0.02c-0.104-0.15-0.22-0.291-0.351-0.419l0,0\r\n\t\t\t\tc-0.002-0.002-0.004-0.004-0.008-0.006c-0.166-0.165-0.358-0.302-0.561-0.425c-0.002-0.001-0.005-0.002-0.007-0.004\r\n\t\t\t\tc0,0-0.001,0-0.001-0.001c-0.285-0.171-0.594-0.305-0.93-0.373l0,0c-0.139-0.028-0.283-0.034-0.427-0.043\r\n\t\t\t\tC45.117,0.014,45.061,0,45,0H19c-1.243,0-2.309,0.756-2.764,1.832C16.084,2.191,16,2.586,16,3v9h32V2.969z M16,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3V37H16V61z M22,43h20v3H22V43z M22,49h20v3H22V49z M22,55h20v3H22V55z"},"children":[{"name":"path","attribs":{"d":"M61,15H3c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h10V34h38v15h10c1.657,0,3-1.343,3-3V18C64,16.343,62.657,15,61,15\r\n\t\t\t\tz M9,27c-1.657,0-3-1.343-3-3s1.343-3,3-3s3,1.343,3,3S10.657,27,9,27z M48,2.969h-0.003c0-0.001,0-0.002,0-0.003\r\n\t\t\t\tC47.99,2.351,47.8,1.782,47.477,1.309c-0.004-0.007-0.012-0.013-0.017-0.02c-0.104-0.15-0.22-0.291-0.351-0.419l0,0\r\n\t\t\t\tc-0.002-0.002-0.004-0.004-0.008-0.006c-0.166-0.165-0.358-0.302-0.561-0.425c-0.002-0.001-0.005-0.002-0.007-0.004\r\n\t\t\t\tc0,0-0.001,0-0.001-0.001c-0.285-0.171-0.594-0.305-0.93-0.373l0,0c-0.139-0.028-0.283-0.034-0.427-0.043\r\n\t\t\t\tC45.117,0.014,45.061,0,45,0H19c-1.243,0-2.309,0.756-2.764,1.832C16.084,2.191,16,2.586,16,3v9h32V2.969z M16,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3V37H16V61z M22,43h20v3H22V43z M22,49h20v3H22V49z M22,55h20v3H22V55z"},"children":[]}]}]}]}]}]}]}]};exports.printer=printer;var progress={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"PROGRESS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PROGRESS"},"children":[{"name":"g","attribs":{"id":"PROGRESS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,29c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3s3-1.343,3-3V32C29,30.343,27.657,29,26,29z M14,37\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C17,38.343,15.657,37,14,37z M50,13c-1.657,0-3,1.343-3,3v32\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V16C53,14.343,51.657,13,50,13z M38,21c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V24C41,22.343,39.657,21,38,21z"},"children":[{"name":"path","attribs":{"d":"M26,29c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3s3-1.343,3-3V32C29,30.343,27.657,29,26,29z M14,37\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C17,38.343,15.657,37,14,37z M50,13c-1.657,0-3,1.343-3,3v32\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V16C53,14.343,51.657,13,50,13z M38,21c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V24C41,22.343,39.657,21,38,21z"},"children":[]}]}]}]}]}]}]}]};exports.progress=progress;var record={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RECORD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RECORD"},"children":[{"name":"g","attribs":{"id":"RECORD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"32","cy":"32","r":"14"},"children":[{"name":"circle","attribs":{"cx":"32","cy":"32","r":"14"},"children":[]}]}]}]}]}]}]}]};exports.record=record;var repeat={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"REPEAT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,22c-1.657,0-3,1.343-3,3v7c0,6.627-5.373,12-12,12H26v0.003h-2.987v-0.005\r\n\t\t\tH21.24l1.878-1.879c0.543-0.543,0.878-1.293,0.878-2.122c0-1.657-1.343-3-2.999-3c-0.828,0-1.578,0.336-2.121,0.879l-6.998,7.001\r\n\t\t\tC11.336,45.42,11,46.17,11,46.999c0,0.829,0.336,1.578,0.878,2.122l6.998,7.001C19.42,56.664,20.169,57,20.998,57\r\n\t\t\tc1.657,0,2.999-1.343,2.999-3c0-0.829-0.336-1.578-0.878-2.122l-1.873-1.874H27V50h19c9.941,0,18-8.059,18-18v-7\r\n\t\t\tC64,23.343,62.657,22,61,22z M38,20v-0.004h2.987v0.005h1.773l-1.878,1.879c-0.543,0.543-0.879,1.293-0.879,2.122\r\n\t\t\tc0,1.657,1.343,3,2.999,3c0.828,0,1.578-0.336,2.121-0.879l6.998-7.001C52.664,18.58,53,17.83,53,17.001\r\n\t\t\tc0-0.829-0.336-1.579-0.878-2.122l-6.998-7.001C44.581,7.336,43.831,7,43.003,7c-1.657,0-2.999,1.344-2.999,3.001\r\n\t\t\tc0,0.828,0.336,1.579,0.879,2.122l1.873,1.874H37V14H18C8.059,14,0,22.059,0,32v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7\r\n\t\t\tc0-6.627,5.373-12,12-12H38z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,22c-1.657,0-3,1.343-3,3v7c0,6.627-5.373,12-12,12H26v0.003h-2.987v-0.005\r\n\t\t\tH21.24l1.878-1.879c0.543-0.543,0.878-1.293,0.878-2.122c0-1.657-1.343-3-2.999-3c-0.828,0-1.578,0.336-2.121,0.879l-6.998,7.001\r\n\t\t\tC11.336,45.42,11,46.17,11,46.999c0,0.829,0.336,1.578,0.878,2.122l6.998,7.001C19.42,56.664,20.169,57,20.998,57\r\n\t\t\tc1.657,0,2.999-1.343,2.999-3c0-0.829-0.336-1.578-0.878-2.122l-1.873-1.874H27V50h19c9.941,0,18-8.059,18-18v-7\r\n\t\t\tC64,23.343,62.657,22,61,22z M38,20v-0.004h2.987v0.005h1.773l-1.878,1.879c-0.543,0.543-0.879,1.293-0.879,2.122\r\n\t\t\tc0,1.657,1.343,3,2.999,3c0.828,0,1.578-0.336,2.121-0.879l6.998-7.001C52.664,18.58,53,17.83,53,17.001\r\n\t\t\tc0-0.829-0.336-1.579-0.878-2.122l-6.998-7.001C44.581,7.336,43.831,7,43.003,7c-1.657,0-2.999,1.344-2.999,3.001\r\n\t\t\tc0,0.828,0.336,1.579,0.879,2.122l1.873,1.874H37V14H18C8.059,14,0,22.059,0,32v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7\r\n\t\t\tc0-6.627,5.373-12,12-12H38z"},"children":[]}]}]}]}]}]};exports.repeat=repeat;var repeat_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"REPEAT_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REPEAT_1"},"children":[{"name":"g","attribs":{"id":"REPEAT_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,20c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.39C52.199,5.288,42.725,0,32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,14.359-11.641,26-26,26\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c8.77,0,16.512,4.348,21.218,11H48C46.343,17,45,18.343,45,20z"},"children":[{"name":"path","attribs":{"d":"M45,20c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.39C52.199,5.288,42.725,0,32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32c0-1.657-1.343-3-3-3s-3,1.343-3,3c0,14.359-11.641,26-26,26\r\n\t\t\t\tC17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6c8.77,0,16.512,4.348,21.218,11H48C46.343,17,45,18.343,45,20z"},"children":[]}]}]}]}]}]}]}]};exports.repeat_1=repeat_1;var repeat_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"REPEAT_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REPEAT_2"},"children":[{"name":"g","attribs":{"id":"REPEAT_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,29c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26c-8.768,0-16.506-4.348-21.207-11H16c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.454C11.789,58.68,21.254,64,32,64\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,30.343,62.657,29,61,29z M61,5c-1.657,0-3,1.343-3,3v5.412C52.204,5.299,42.732,0,32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32c0,1.657,1.343,3,3,3s3-1.343,3-3C6,17.641,17.641,6,32,6c8.76,0,16.469,4.355,21.167,11H48\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h13c1.657,0,3-1.343,3-3V8C64,6.343,62.657,5,61,5z"},"children":[{"name":"path","attribs":{"d":"M61,29c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26c-8.768,0-16.506-4.348-21.207-11H16c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.454C11.789,58.68,21.254,64,32,64\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,30.343,62.657,29,61,29z M61,5c-1.657,0-3,1.343-3,3v5.412C52.204,5.299,42.732,0,32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32c0,1.657,1.343,3,3,3s3-1.343,3-3C6,17.641,17.641,6,32,6c8.76,0,16.469,4.355,21.167,11H48\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h13c1.657,0,3-1.343,3-3V8C64,6.343,62.657,5,61,5z"},"children":[]}]}]}]}]}]}]}]};exports.repeat_2=repeat_2;var resize_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_1_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1_2_"},"children":[{"name":"g","attribs":{"id":"RESIZE_1_2_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M28.157,23.914L13.243,9H18c1.657,0,3-1.343,3-3s-1.343-3-3-3H6C4.343,3,3,4.343,3,6v12c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tv-4.757l14.914,14.914l0.003-0.003C24.457,28.676,25.19,29,26,29c1.657,0,3-1.343,3-3c0-0.81-0.324-1.543-0.847-2.083\r\n\t\t\t\tL28.157,23.914z M26,35c-0.81,0-1.543,0.325-2.082,0.848l-0.003-0.004L9,50.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l14.914-14.914l-0.003-0.003C28.676,39.543,29,38.811,29,38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M58,43c-1.657,0-3,1.343-3,3v4.757L40.086,35.843l-0.003,0.003C39.543,35.325,38.811,35,38,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.811,0.324,1.543,0.848,2.083l-0.004,0.003L50.757,55H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C61,44.343,59.657,43,58,43z M58,3H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.843,23.914l0.003,0.003\r\n\t\t\t\tC35.325,24.457,35,25.19,35,26c0,1.657,1.343,3,3,3c0.811,0,1.543-0.325,2.083-0.847l0.003,0.003L55,13.243V18\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[{"name":"path","attribs":{"d":"M28.157,23.914L13.243,9H18c1.657,0,3-1.343,3-3s-1.343-3-3-3H6C4.343,3,3,4.343,3,6v12c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tv-4.757l14.914,14.914l0.003-0.003C24.457,28.676,25.19,29,26,29c1.657,0,3-1.343,3-3c0-0.81-0.324-1.543-0.847-2.083\r\n\t\t\t\tL28.157,23.914z M26,35c-0.81,0-1.543,0.325-2.082,0.848l-0.003-0.004L9,50.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l14.914-14.914l-0.003-0.003C28.676,39.543,29,38.811,29,38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M58,43c-1.657,0-3,1.343-3,3v4.757L40.086,35.843l-0.003,0.003C39.543,35.325,38.811,35,38,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.811,0.324,1.543,0.848,2.083l-0.004,0.003L50.757,55H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C61,44.343,59.657,43,58,43z M58,3H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.843,23.914l0.003,0.003\r\n\t\t\t\tC35.325,24.457,35,25.19,35,26c0,1.657,1.343,3,3,3c0.811,0,1.543-0.325,2.083-0.847l0.003,0.003L55,13.243V18\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[]}]}]}]}]}]}]}]};exports.resize_1=resize_1;var resize_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_2_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2_2_"},"children":[{"name":"g","attribs":{"id":"RESIZE_2_2_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,35H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.843,55.914l0.003,0.003C3.325,56.457,3,57.189,3,58\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.848l0.003,0.004L23,45.243V50c0,1.657,1.343,3,3,3s3-1.343,3-3V38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M38,29h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.157,8.086l-0.003-0.003\r\n\t\t\t\tC60.676,7.543,61,6.81,61,6c0-1.657-1.343-3-3-3c-0.811,0-1.543,0.325-2.083,0.847l-0.003-0.003L41,18.758V14\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v12C35,27.657,36.343,29,38,29z M60.157,55.914L45.243,41H50c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tH38c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003C56.457,60.676,57.189,61,58,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.811-0.325-1.543-0.848-2.083L60.157,55.914z M26,11c-1.657,0-3,1.343-3,3v4.757L8.086,3.843\r\n\t\t\t\tL8.083,3.847C7.543,3.325,6.81,3,6,3C4.343,3,3,4.343,3,6c0,0.81,0.325,1.543,0.847,2.082L3.843,8.086L18.757,23H14\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3V14C29,12.343,27.657,11,26,11z"},"children":[{"name":"path","attribs":{"d":"M26,35H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.843,55.914l0.003,0.003C3.325,56.457,3,57.189,3,58\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.848l0.003,0.004L23,45.243V50c0,1.657,1.343,3,3,3s3-1.343,3-3V38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M38,29h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.157,8.086l-0.003-0.003\r\n\t\t\t\tC60.676,7.543,61,6.81,61,6c0-1.657-1.343-3-3-3c-0.811,0-1.543,0.325-2.083,0.847l-0.003-0.003L41,18.758V14\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v12C35,27.657,36.343,29,38,29z M60.157,55.914L45.243,41H50c1.657,0,3-1.343,3-3s-1.343-3-3-3\r\n\t\t\t\tH38c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003C56.457,60.676,57.189,61,58,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.811-0.325-1.543-0.848-2.083L60.157,55.914z M26,11c-1.657,0-3,1.343-3,3v4.757L8.086,3.843\r\n\t\t\t\tL8.083,3.847C7.543,3.325,6.81,3,6,3C4.343,3,3,4.343,3,6c0,0.81,0.325,1.543,0.847,2.082L3.843,8.086L18.757,23H14\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3V14C29,12.343,27.657,11,26,11z"},"children":[]}]}]}]}]}]}]}]};exports.resize_2=resize_2;var resize_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_1_4_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1_1_"},"children":[{"name":"g","attribs":{"id":"RESIZE_1_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26,35c-0.828,0-1.579,0.336-2.121,0.879L9,50.758V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l14.879-14.879C28.664,39.579,29,38.828,29,38C29,36.343,27.657,35,26,35z M58,3H46\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.879,23.879C35.336,24.422,35,25.172,35,26c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L55,13.243V18c0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[{"name":"path","attribs":{"d":"M26,35c-0.828,0-1.579,0.336-2.121,0.879L9,50.758V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l14.879-14.879C28.664,39.579,29,38.828,29,38C29,36.343,27.657,35,26,35z M58,3H46\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.879,23.879C35.336,24.422,35,25.172,35,26c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L55,13.243V18c0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[]}]}]}]}]}]}]}]};exports.resize_3=resize_3;var resize_4={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_2_4_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2_1_"},"children":[{"name":"g","attribs":{"id":"RESIZE_2_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,6c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L41,18.757V14c0-1.657-1.343-3-3-3s-3,1.343-3,3v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.121,8.121C60.664,7.579,61,6.828,61,6z M26,35H14\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.879,55.879C3.336,56.422,3,57.172,3,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L23,45.243V50c0,1.657,1.343,3,3,3s3-1.343,3-3V38C29,36.343,27.657,35,26,35z"},"children":[{"name":"path","attribs":{"d":"M61,6c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L41,18.757V14c0-1.657-1.343-3-3-3s-3,1.343-3,3v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.121,8.121C60.664,7.579,61,6.828,61,6z M26,35H14\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.879,55.879C3.336,56.422,3,57.172,3,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L23,45.243V50c0,1.657,1.343,3,3,3s3-1.343,3-3V38C29,36.343,27.657,35,26,35z"},"children":[]}]}]}]}]}]}]}]};exports.resize_4=resize_4;var resize_5={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_1_5_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1"},"children":[{"name":"g","attribs":{"id":"RESIZE_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M18,43c-0.828,0-1.578,0.336-2.121,0.879L6,53.757V49c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l9.879-9.879C20.664,47.578,21,46.829,21,46C21,44.343,19.657,43,18,43z M61,0H49\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879C43.336,16.422,43,17.172,43,18c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L58,10.243V15c0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z M32,23\r\n\t\t\t\tc-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9C41,27.029,36.971,23,32,23z"},"children":[{"name":"path","attribs":{"d":"M18,43c-0.828,0-1.578,0.336-2.121,0.879L6,53.757V49c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757l9.879-9.879C20.664,47.578,21,46.829,21,46C21,44.343,19.657,43,18,43z M61,0H49\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879C43.336,16.422,43,17.172,43,18c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L58,10.243V15c0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z M32,23\r\n\t\t\t\tc-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9C41,27.029,36.971,23,32,23z"},"children":[]}]}]}]}]}]}]}]};exports.resize_5=resize_5;var resize_6={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RESIZE_2_5_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2"},"children":[{"name":"g","attribs":{"id":"RESIZE_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M18,43H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879C0.336,59.422,0,60.172,0,61c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L15,53.243V58c0,1.657,1.343,3,3,3s3-1.343,3-3V46C21,44.343,19.657,43,18,43z M32,23\r\n\t\t\t\tc-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9C41,27.029,36.971,23,32,23z M64,3c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,10.757V6c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-4.757l9.879-9.879C63.664,4.578,64,3.829,64,3z"},"children":[{"name":"path","attribs":{"d":"M18,43H6c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879C0.336,59.422,0,60.172,0,61c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L15,53.243V58c0,1.657,1.343,3,3,3s3-1.343,3-3V46C21,44.343,19.657,43,18,43z M32,23\r\n\t\t\t\tc-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9C41,27.029,36.971,23,32,23z M64,3c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,10.757V6c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3h-4.757l9.879-9.879C63.664,4.578,64,3.829,64,3z"},"children":[]}]}]}]}]}]}]}]};exports.resize_6=resize_6;var rewind={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"REWIND_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REWIND"},"children":[{"name":"g","attribs":{"id":"REWIND"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L35,26.587V22c0-1.657-1.343-3-3-3c-0.584,0-1.129,0.168-1.59,0.456l0,0\r\n\t\t\t\tl-15.962,9.976c-0.005,0.003-0.011,0.007-0.016,0.01l-0.023,0.014l0,0C13.564,29.987,13,30.927,13,32s0.564,2.014,1.41,2.544l0,0\r\n\t\t\t\tl0.023,0.015c0.005,0.002,0.01,0.006,0.016,0.01l15.962,9.976l0,0C30.871,44.833,31.416,45,32,45c1.657,0,3-1.343,3-3v-4.587\r\n\t\t\t\tl11.41,7.131l0,0C46.871,44.833,47.416,45,48,45c1.657,0,3-1.343,3-3V22C51,20.343,49.657,19,48,19z"},"children":[{"name":"path","attribs":{"d":"M48,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L35,26.587V22c0-1.657-1.343-3-3-3c-0.584,0-1.129,0.168-1.59,0.456l0,0\r\n\t\t\t\tl-15.962,9.976c-0.005,0.003-0.011,0.007-0.016,0.01l-0.023,0.014l0,0C13.564,29.987,13,30.927,13,32s0.564,2.014,1.41,2.544l0,0\r\n\t\t\t\tl0.023,0.015c0.005,0.002,0.01,0.006,0.016,0.01l15.962,9.976l0,0C30.871,44.833,31.416,45,32,45c1.657,0,3-1.343,3-3v-4.587\r\n\t\t\t\tl11.41,7.131l0,0C46.871,44.833,47.416,45,48,45c1.657,0,3-1.343,3-3V22C51,20.343,49.657,19,48,19z"},"children":[]}]}]}]}]}]}]}]};exports.rewind=rewind;var rss={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"RSS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RSS"},"children":[{"name":"g","attribs":{"id":"RSS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M8,48c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S12.418,48,8,48z M0,23v11c16.569,0,30,13.432,30,30h11\r\n\t\t\t\tC41,41.355,22.644,23,0,23z M0,0v11c29.271,0,53,23.729,53,53h11C64,28.654,35.346,0,0,0z"},"children":[{"name":"path","attribs":{"d":"M8,48c-4.418,0-8,3.582-8,8s3.582,8,8,8s8-3.582,8-8S12.418,48,8,48z M0,23v11c16.569,0,30,13.432,30,30h11\r\n\t\t\t\tC41,41.355,22.644,23,0,23z M0,0v11c29.271,0,53,23.729,53,53h11C64,28.654,35.346,0,0,0z"},"children":[]}]}]}]}]}]}]}]};exports.rss=rss;var screen_expand_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_1"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S16.657,58,15,58z M9,55h46\r\n\t\t\t\tV9H9V55z M15,15h34v34H15V15z M61,0H49l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"d":"M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S16.657,58,15,58z M9,55h46\r\n\t\t\t\tV9H9V55z M15,15h34v34H15V15z M61,0H49l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]}]};exports.screen_expand_1=screen_expand_1;var screen_expand_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_2"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M15,6c1.657,0,3-1.343,3-3s-1.343-3-3-3l0,0H3C1.343,0,0,1.343,0,3v12l0,0c0,1.657,1.343,3,3,3s3-1.343,3-3V6H15L15,6z\r\n\t\t\t\t M64,49c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v9h-9c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3V49L64,49z M55,9H9\r\n\t\t\t\tv46h46V9z M49,49H15V15h34V49z"},"children":[{"name":"path","attribs":{"d":"M15,6c1.657,0,3-1.343,3-3s-1.343-3-3-3l0,0H3C1.343,0,0,1.343,0,3v12l0,0c0,1.657,1.343,3,3,3s3-1.343,3-3V6H15L15,6z\r\n\t\t\t\t M64,49c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v9h-9c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3V49L64,49z M55,9H9\r\n\t\t\t\tv46h46V9z M49,49H15V15h34V49z"},"children":[]}]}]}]}]}]}]}]};exports.screen_expand_2=screen_expand_2;var screen_expand_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_3"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,18c1.657,0,3-1.343,3-3V6h9l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,0,0,1.343,0,3v12l0,0\r\n\t\t\t\tC0,16.657,1.343,18,3,18z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,46c-1.657,0-3,1.343-3,3l0,0v9h-9c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S16.657,58,15,58z M61,0H49l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h9v9l0,0\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"d":"M3,18c1.657,0,3-1.343,3-3V6h9l0,0c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,0,0,1.343,0,3v12l0,0\r\n\t\t\t\tC0,16.657,1.343,18,3,18z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,46c-1.657,0-3,1.343-3,3l0,0v9h-9c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3S16.657,58,15,58z M61,0H49l0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3l0,0h9v9l0,0\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]}]};exports.screen_expand_3=screen_expand_3;var share={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHARE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHARE"},"children":[{"name":"g","attribs":{"id":"SHARE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52,26.168V52H12V12h25.832C37.316,11.114,37,10.098,37,9c0-1.099,0.316-2.114,0.832-3H9C7.343,6,6,7.343,6,9v46\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V26.168C57.113,26.683,56.1,27,55,27C53.902,27,52.887,26.683,52,26.168z M55,6H43\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L32.843,26.914l0.003,0.003C32.325,27.457,32,28.19,32,29c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.811,0,1.543-0.325,2.082-0.847l0.003,0.003L52,16.243V21c0,1.657,1.343,3,2.999,3H55c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC58,7.343,56.657,6,55,6z"},"children":[{"name":"path","attribs":{"d":"M52,26.168V52H12V12h25.832C37.316,11.114,37,10.098,37,9c0-1.099,0.316-2.114,0.832-3H9C7.343,6,6,7.343,6,9v46\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V26.168C57.113,26.683,56.1,27,55,27C53.902,27,52.887,26.683,52,26.168z M55,6H43\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L32.843,26.914l0.003,0.003C32.325,27.457,32,28.19,32,29c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.811,0,1.543-0.325,2.082-0.847l0.003,0.003L52,16.243V21c0,1.657,1.343,3,2.999,3H55c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC58,7.343,56.657,6,55,6z"},"children":[]}]}]}]}]}]}]}]};exports.share=share;var share_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHARE_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHARE_2"},"children":[{"name":"g","attribs":{"id":"SHARE_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M23,16c0.885,0,1.673-0.39,2.222-1l0.008,0.007L29,10.818V29c0,1.657,1.343,3,3,3s3-1.343,3-3V10.818l3.77,4.189\r\n\t\t\t\tL38.777,15c0.55,0.61,1.338,1,2.223,1c1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.777-2l0.008-0.007l-9-10L34.223,1\r\n\t\t\t\tC33.673,0.391,32.885,0,32,0s-1.673,0.39-2.222,1L29.77,0.993l-9,10L20.778,11C20.3,11.532,20,12.228,20,13\r\n\t\t\t\tC20,14.657,21.343,16,23,16z M51,20H38v6h10v32H16V26h9v-6H13c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38\r\n\t\t\t\tc1.657,0,3-1.343,3-3V23C54,21.343,52.657,20,51,20z"},"children":[{"name":"path","attribs":{"d":"M23,16c0.885,0,1.673-0.39,2.222-1l0.008,0.007L29,10.818V29c0,1.657,1.343,3,3,3s3-1.343,3-3V10.818l3.77,4.189\r\n\t\t\t\tL38.777,15c0.55,0.61,1.338,1,2.223,1c1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.777-2l0.008-0.007l-9-10L34.223,1\r\n\t\t\t\tC33.673,0.391,32.885,0,32,0s-1.673,0.39-2.222,1L29.77,0.993l-9,10L20.778,11C20.3,11.532,20,12.228,20,13\r\n\t\t\t\tC20,14.657,21.343,16,23,16z M51,20H38v6h10v32H16V26h9v-6H13c-1.657,0-3,1.343-3,3v38c0,1.657,1.343,3,3,3h38\r\n\t\t\t\tc1.657,0,3-1.343,3-3V23C54,21.343,52.657,20,51,20z"},"children":[]}]}]}]}]}]}]}]};exports.share_2=share_2;var shop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOP"},"children":[{"name":"g","attribs":{"id":"SHOP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M10,9h44c1.657,0,3-1.343,3-3s-1.343-3-3-3H10C8.343,3,7,4.343,7,6S8.343,9,10,9z M58.375,12H5.625L0,27\r\n\t\t\t\tc0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8\r\n\t\t\t\ts8-3.582,8-8L58.375,12z M55,37.952V37.95c-0.287-0.026-0.57-0.069-0.85-0.117c-0.061-0.01-0.123-0.015-0.183-0.026\r\n\t\t\t\tc-0.13-0.023-0.256-0.061-0.384-0.09C53.042,37.593,52.51,37.439,52,37.24V52H12V37.239c-0.51,0.2-1.042,0.354-1.586,0.478\r\n\t\t\t\tc-0.128,0.029-0.253,0.065-0.382,0.09c-0.06,0.012-0.122,0.017-0.183,0.027C9.569,37.88,9.287,37.924,9,37.95v0.002\r\n\t\t\t\tC8.671,37.982,8.338,38,8,38c-0.684,0-1.351-0.07-2-0.189V58c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V37.811\r\n\t\t\t\tC57.352,37.93,56.684,38,56,38C55.663,38,55.329,37.982,55,37.952z"},"children":[{"name":"path","attribs":{"d":"M10,9h44c1.657,0,3-1.343,3-3s-1.343-3-3-3H10C8.343,3,7,4.343,7,6S8.343,9,10,9z M58.375,12H5.625L0,27\r\n\t\t\t\tc0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8s8-3.582,8-8c0,4.418,3.582,8,8,8\r\n\t\t\t\ts8-3.582,8-8L58.375,12z M55,37.952V37.95c-0.287-0.026-0.57-0.069-0.85-0.117c-0.061-0.01-0.123-0.015-0.183-0.026\r\n\t\t\t\tc-0.13-0.023-0.256-0.061-0.384-0.09C53.042,37.593,52.51,37.439,52,37.24V52H12V37.239c-0.51,0.2-1.042,0.354-1.586,0.478\r\n\t\t\t\tc-0.128,0.029-0.253,0.065-0.382,0.09c-0.06,0.012-0.122,0.017-0.183,0.027C9.569,37.88,9.287,37.924,9,37.95v0.002\r\n\t\t\t\tC8.671,37.982,8.338,38,8,38c-0.684,0-1.351-0.07-2-0.189V58c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V37.811\r\n\t\t\t\tC57.352,37.93,56.684,38,56,38C55.663,38,55.329,37.982,55,37.952z"},"children":[]}]}]}]}]}]}]}]};exports.shop=shop;var shopping_bag={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOPPING_BAG_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_BAG"},"children":[{"name":"g","attribs":{"id":"SHOPPING_BAG"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M6,61c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3v-3H6V61z M55,15h-8c0-8.284-6.716-15-15-15S17,6.716,17,15H9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v37h52V18C58,16.343,56.657,15,55,15z M23,15c0-4.971,4.029-9,9-9c4.971,0,9,4.03,9,9H23z"},"children":[{"name":"path","attribs":{"d":"M6,61c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3v-3H6V61z M55,15h-8c0-8.284-6.716-15-15-15S17,6.716,17,15H9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v37h52V18C58,16.343,56.657,15,55,15z M23,15c0-4.971,4.029-9,9-9c4.971,0,9,4.03,9,9H23z"},"children":[]}]}]}]}]}]}]}]};exports.shopping_bag=shopping_bag;var shopping_cart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOPPING_CART_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M52.2,39.993c1.132-0.074,2.092-0.776,2.536-1.763l0,0l9-20l-0.006-0.002C63.9,17.853,64,17.439,64,17\r\n\t\t\t\tc0-1.657-1.343-3-3-3H16.578l-1.747-4.991L14.82,9.013C14.411,7.844,13.309,7,12,7H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872\r\n\t\t\t\tl11.55,33H16c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6s-2.686-6-6-6H27.778\r\n\t\t\t\tl-1.497-4.279L52.2,39.993L52.2,39.993z M24.224,35.846L18.679,20h37.68l-6.356,14.127L24.224,35.846z"},"children":[{"name":"path","attribs":{"d":"M52.2,39.993c1.132-0.074,2.092-0.776,2.536-1.763l0,0l9-20l-0.006-0.002C63.9,17.853,64,17.439,64,17\r\n\t\t\t\tc0-1.657-1.343-3-3-3H16.578l-1.747-4.991L14.82,9.013C14.411,7.844,13.309,7,12,7H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872\r\n\t\t\t\tl11.55,33H16c-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6s-2.686-6-6-6H27.778\r\n\t\t\t\tl-1.497-4.279L52.2,39.993L52.2,39.993z M24.224,35.846L18.679,20h37.68l-6.356,14.127L24.224,35.846z"},"children":[]}]}]}]}]}]}]}]};exports.shopping_cart=shopping_cart;var shopping_cart_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"Background_xA0_Image_1_","display":"none"},"children":[{"name":"image","attribs":{"display":"inline","overflow":"visible","width":"64","height":"64","id":"Background_xA0_Image"},"children":[{"name":"image","attribs":{"display":"inline","overflow":"visible","width":"64","height":"64","id":"Background_xA0_Image"},"children":[]}]}]},{"name":"g","attribs":{"id":"paypal_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"paypal","display":"inline"},"children":[{"name":"g","attribs":{"id":"paypal","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.878,24.706c0.474-0.299,0.925-0.635,1.335-1.018\r\n\t\t\t\tc1.145-1.061,2.006-2.423,2.369-3.916c0.633-2.24-0.102-4.184-1.617-5.26c-0.797-0.566-1.808-0.901-2.955-0.901h-6.65\r\n\t\t\t\tl-0.214,0.901L24.45,25.935h6.372C32.234,25.935,33.643,25.473,34.878,24.706z M30.925,18.05h3.086\r\n\t\t\t\tc0.16,0,0.255,0.026,0.302,0.043c0.01,0.067,0.018,0.22-0.057,0.48l-0.023,0.082l-0.018,0.082\r\n\t\t\t\tc-0.346,1.418-1.994,2.76-3.394,2.76h-0.712L30.925,18.05z M60.612,16.282c-1.296-1.592-2.929-2.913-4.783-3.928\r\n\t\t\t\tc-0.61-2.671-1.803-4.704-2.976-6.148C49.714,2.346,44.585,0.033,39.117,0H12.265l-0.787,3.458L1.224,48.519L0,53.901v0.031\r\n\t\t\t\th10.042l-1.058,4.661L7.752,64h22.802l0.774-3.476l2.55-11.441h6.089c11.803,0,21.03-7.176,23.507-18.278\r\n\t\t\t\tc0.368-1.649,0.522-3.163,0.526-4.557v-0.456C63.904,21.396,62.235,18.281,60.612,16.282z M5.606,49.491L15.861,4.43H39\r\n\t\t\t\tc4.283,0,9.005,1.916,11.316,5.974c0.796,1.398,1.306,3.051,1.413,4.969c0.075,1.334-0.044,2.801-0.4,4.398\r\n\t\t\t\tc-0.812,3.64-2.499,6.678-4.796,9.048c-3.51,3.625-8.462,5.651-13.979,5.732c-0.116,0.003-0.228,0.013-0.343,0.013h-9.701\r\n\t\t\t\tl-3.324,14.926H5.606z M59.087,29.848c-2.077,9.316-9.837,14.796-19.12,14.796h-9.699L26.943,59.57H13.366l1.283-5.638h8.147\r\n\t\t\t\tl0.777-3.485l2.547-11.441h6.09c11.801,0,21.027-7.176,23.505-18.275c0.209-0.941,0.348-1.837,0.434-2.696\r\n\t\t\t\tC58.802,20.547,60.295,24.44,59.087,29.848z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.878,24.706c0.474-0.299,0.925-0.635,1.335-1.018\r\n\t\t\t\tc1.145-1.061,2.006-2.423,2.369-3.916c0.633-2.24-0.102-4.184-1.617-5.26c-0.797-0.566-1.808-0.901-2.955-0.901h-6.65\r\n\t\t\t\tl-0.214,0.901L24.45,25.935h6.372C32.234,25.935,33.643,25.473,34.878,24.706z M30.925,18.05h3.086\r\n\t\t\t\tc0.16,0,0.255,0.026,0.302,0.043c0.01,0.067,0.018,0.22-0.057,0.48l-0.023,0.082l-0.018,0.082\r\n\t\t\t\tc-0.346,1.418-1.994,2.76-3.394,2.76h-0.712L30.925,18.05z M60.612,16.282c-1.296-1.592-2.929-2.913-4.783-3.928\r\n\t\t\t\tc-0.61-2.671-1.803-4.704-2.976-6.148C49.714,2.346,44.585,0.033,39.117,0H12.265l-0.787,3.458L1.224,48.519L0,53.901v0.031\r\n\t\t\t\th10.042l-1.058,4.661L7.752,64h22.802l0.774-3.476l2.55-11.441h6.089c11.803,0,21.03-7.176,23.507-18.278\r\n\t\t\t\tc0.368-1.649,0.522-3.163,0.526-4.557v-0.456C63.904,21.396,62.235,18.281,60.612,16.282z M5.606,49.491L15.861,4.43H39\r\n\t\t\t\tc4.283,0,9.005,1.916,11.316,5.974c0.796,1.398,1.306,3.051,1.413,4.969c0.075,1.334-0.044,2.801-0.4,4.398\r\n\t\t\t\tc-0.812,3.64-2.499,6.678-4.796,9.048c-3.51,3.625-8.462,5.651-13.979,5.732c-0.116,0.003-0.228,0.013-0.343,0.013h-9.701\r\n\t\t\t\tl-3.324,14.926H5.606z M59.087,29.848c-2.077,9.316-9.837,14.796-19.12,14.796h-9.699L26.943,59.57H13.366l1.283-5.638h8.147\r\n\t\t\t\tl0.777-3.485l2.547-11.441h6.09c11.801,0,21.027-7.176,23.505-18.275c0.209-0.941,0.348-1.837,0.434-2.696\r\n\t\t\t\tC58.802,20.547,60.295,24.44,59.087,29.848z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"linkedin_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"linkedin","display":"inline"},"children":[{"name":"g","attribs":{"id":"linkedin","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.798,62.987h14.315V22.368H0.798V62.987z M48.433,21.087\r\n\t\t\t\tc-5.924,0-9.192,1.972-12.952,6.749v-5.469H21.189v40.619h14.291V40.914c0-4.658,2.24-9.214,7.596-9.214\r\n\t\t\t\tc5.356,0,6.673,4.555,6.673,9.103v22.184H64V39.896C64,23.854,54.362,21.087,48.433,21.087z M7.982,2.013\r\n\t\t\t\tC3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.798,62.987h14.315V22.368H0.798V62.987z M48.433,21.087\r\n\t\t\t\tc-5.924,0-9.192,1.972-12.952,6.749v-5.469H21.189v40.619h14.291V40.914c0-4.658,2.24-9.214,7.596-9.214\r\n\t\t\t\tc5.356,0,6.673,4.555,6.673,9.103v22.184H64V39.896C64,23.854,54.362,21.087,48.433,21.087z M7.982,2.013\r\n\t\t\t\tC3.572,2.013,0,5.222,0,9.183c0,3.958,3.572,7.162,7.982,7.162c4.406,0,7.978-3.205,7.978-7.162\r\n\t\t\t\tC15.96,5.222,12.388,2.013,7.982,2.013z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"spotify_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"spotify","display":"inline"},"children":[{"name":"g","attribs":{"id":"spotify","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.671,55.675c-4.217,0-7.496,1.355-10.156,4.239\r\n\t\t\t\tc4.795,2.869,9.491,4.079,15.486,4.079c3.087,0,4.405-0.132,7.23-0.948C36.949,58.528,32.591,55.675,26.671,55.675z\r\n\t\t\t\t M32.001,0.008c-17.67,0-31.993,14.323-31.993,31.993c0,8.223,3.103,15.72,8.202,21.387c4.778-4.399,11.291-7.104,18.462-7.104\r\n\t\t\t\tc9.749,0,18.284,4.995,22.892,12.458c8.691-5.72,14.43-15.56,14.43-26.742C63.992,14.331,49.669,0.008,32.001,0.008z\r\n\t\t\t\t M46.704,44.438c-1.112,0.906-2.201,0.064-2.201,0.064c-10.883-8.335-27.994-3.798-27.994-3.754l-0.256,0.072\r\n\t\t\t\tc-1.149,0-1.937-1.215-1.937-2.362c0,0-0.069-1.32,1.788-1.936c0.713-0.131,18.112-3.927,30.538,4.408\r\n\t\t\t\tc0.923,0.726,0.953,1.59,0.953,1.59C47.594,43.668,47.336,43.923,46.704,44.438z M49.37,35.657c-0.48,0-0.927-0.137-1.308-0.37\r\n\t\t\t\th-0.001c-13.9-8.339-29.991-4.409-32.002-3.857l-1.028,0.202c-1.388,0-2.403-1.126-2.403-2.515c0-1.163,0.824-2.138,1.91-2.426\r\n\t\t\t\tc1.087-0.24,19.256-6.003,35.915,3.523h0.008c0.912,0.428,1.419,1.6,1.419,2.593C51.88,34.196,50.758,35.657,49.37,35.657z\r\n\t\t\t\t M53.583,26.042c0,0-0.853-0.014-1.71-0.531c-15.635-9.777-37.295-4.184-37.513-4.126l-0.008-0.005\r\n\t\t\t\tc-0.244,0.064-0.511,0.101-0.774,0.101c-1.655,0-2.962-1.341-2.962-2.996c0-1.434,0.727-2.631,2.358-2.926\r\n\t\t\t\tc1.087-0.259,24.236-6.181,42.041,4.852c0.934,0.507,1.566,1.497,1.566,2.635C56.581,24.7,55.237,26.042,53.583,26.042z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.671,55.675c-4.217,0-7.496,1.355-10.156,4.239\r\n\t\t\t\tc4.795,2.869,9.491,4.079,15.486,4.079c3.087,0,4.405-0.132,7.23-0.948C36.949,58.528,32.591,55.675,26.671,55.675z\r\n\t\t\t\t M32.001,0.008c-17.67,0-31.993,14.323-31.993,31.993c0,8.223,3.103,15.72,8.202,21.387c4.778-4.399,11.291-7.104,18.462-7.104\r\n\t\t\t\tc9.749,0,18.284,4.995,22.892,12.458c8.691-5.72,14.43-15.56,14.43-26.742C63.992,14.331,49.669,0.008,32.001,0.008z\r\n\t\t\t\t M46.704,44.438c-1.112,0.906-2.201,0.064-2.201,0.064c-10.883-8.335-27.994-3.798-27.994-3.754l-0.256,0.072\r\n\t\t\t\tc-1.149,0-1.937-1.215-1.937-2.362c0,0-0.069-1.32,1.788-1.936c0.713-0.131,18.112-3.927,30.538,4.408\r\n\t\t\t\tc0.923,0.726,0.953,1.59,0.953,1.59C47.594,43.668,47.336,43.923,46.704,44.438z M49.37,35.657c-0.48,0-0.927-0.137-1.308-0.37\r\n\t\t\t\th-0.001c-13.9-8.339-29.991-4.409-32.002-3.857l-1.028,0.202c-1.388,0-2.403-1.126-2.403-2.515c0-1.163,0.824-2.138,1.91-2.426\r\n\t\t\t\tc1.087-0.24,19.256-6.003,35.915,3.523h0.008c0.912,0.428,1.419,1.6,1.419,2.593C51.88,34.196,50.758,35.657,49.37,35.657z\r\n\t\t\t\t M53.583,26.042c0,0-0.853-0.014-1.71-0.531c-15.635-9.777-37.295-4.184-37.513-4.126l-0.008-0.005\r\n\t\t\t\tc-0.244,0.064-0.511,0.101-0.774,0.101c-1.655,0-2.962-1.341-2.962-2.996c0-1.434,0.727-2.631,2.358-2.926\r\n\t\t\t\tc1.087-0.259,24.236-6.181,42.041,4.852c0.934,0.507,1.566,1.497,1.566,2.635C56.581,24.7,55.237,26.042,53.583,26.042z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"youtube_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"youtube","display":"inline"},"children":[{"name":"g","attribs":{"id":"youtube","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.15,10.031l-20.9-0.019l-21.718,0.019c-5.433,0-11.534,3.626-11.534,8.944\r\n\t\t\t\tv26.474c0,5.316,6.101,8.559,11.534,8.559H54.15c5.432,0,9.835-3.242,9.835-8.559V18.976\r\n\t\t\t\tC63.985,13.657,59.582,10.031,54.15,10.031z M27.856,42.205L27.73,22.044l14.03,10.168L27.856,42.205z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54.15,10.031l-20.9-0.019l-21.718,0.019c-5.433,0-11.534,3.626-11.534,8.944\r\n\t\t\t\tv26.474c0,5.316,6.101,8.559,11.534,8.559H54.15c5.432,0,9.835-3.242,9.835-8.559V18.976\r\n\t\t\t\tC63.985,13.657,59.582,10.031,54.15,10.031z M27.856,42.205L27.73,22.044l14.03,10.168L27.856,42.205z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"vimeo_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"vimeo","display":"inline"},"children":[{"name":"g","attribs":{"id":"vimeo","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.348,18.728c2.748-0.624,7.538-1.522,8.529,1.306\r\n\t\t\t\tc1.246,8.476-4.612,15.408-9.84,19.602C24.919,34.128,32.524,8.81,21.915,4.633c-5.448-2.145-10.31,2.79-14.434,6.255\r\n\t\t\t\tC4.788,13.151-0.013,16.758,0,19.531v0.073c0.023,0.633,0.301,1.221,0.921,1.738c2.13,3.51,3.998-2.43,7.872-1.306\r\n\t\t\t\tc8.471,6.948,5.793,37.749,18.37,39.856c4.882,0.818,11.08-3.648,14.433-6.534c4.625-3.981,9.924-10.722,13.777-16.335\r\n\t\t\t\tc0,0,9.677-12.741,8.529-23.521C61.789-4.107,36.207,5.801,36.348,18.728z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.348,18.728c2.748-0.624,7.538-1.522,8.529,1.306\r\n\t\t\t\tc1.246,8.476-4.612,15.408-9.84,19.602C24.919,34.128,32.524,8.81,21.915,4.633c-5.448-2.145-10.31,2.79-14.434,6.255\r\n\t\t\t\tC4.788,13.151-0.013,16.758,0,19.531v0.073c0.023,0.633,0.301,1.221,0.921,1.738c2.13,3.51,3.998-2.43,7.872-1.306\r\n\t\t\t\tc8.471,6.948,5.793,37.749,18.37,39.856c4.882,0.818,11.08-3.648,14.433-6.534c4.625-3.981,9.924-10.722,13.777-16.335\r\n\t\t\t\tc0,0,9.677-12.741,8.529-23.521C61.789-4.107,36.207,5.801,36.348,18.728z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"google_plus_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"google_plus","display":"inline"},"children":[{"name":"g","attribs":{"id":"google_plus","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.471,4.995c0,0-12.66,0-16.879,0C11.023,4.995,3.9,10.999,3.9,17.522\r\n\t\t\t\tc0,6.666,5.158,12.23,12.857,12.23c0.535,0,1.055,0.083,1.565,0.046c-0.498,0.94-0.855,2.045-0.855,3.142\r\n\t\t\t\tc0,1.853,1.014,3.378,2.297,4.604c-0.969,0-1.904,0.04-2.926,0.04C7.465,37.584,0,43.452,0,49.533\r\n\t\t\t\tc0,5.987,8.158,10.472,17.533,10.472c10.686,0,16.463-6.689,16.463-12.678c0-4.799-1.318-7.675-5.777-10.773\r\n\t\t\t\tc-1.525-1.059-4.443-3.641-4.443-5.156c0-1.776,0.518-2.653,3.24-4.742c2.791-2.143,4.955-4.903,4.955-8.407\r\n\t\t\t\tc0-4.17-2.08-7.36-5.629-9.325h5.352L35.471,4.995z M29.574,46.295c0.133,0.556,0.207,1.128,0.207,1.711\r\n\t\t\t\tc0,4.838-3.176,8.128-12.283,8.128c-6.478,0-11.158-3.537-11.158-8.375c0-4.742,5.805-8.69,12.283-8.622\r\n\t\t\t\tc1.512,0.017,2.92,0.255,4.199,0.664C26.34,42.201,28.862,43.558,29.574,46.295z M19.201,28.248\r\n\t\t\t\tc-4.349-0.126-8.482-4.778-9.232-10.387c-0.752-5.609,2.164-9.9,6.512-9.773c4.349,0.127,8.67,4.629,9.422,10.236\r\n\t\t\t\tC26.652,23.934,23.547,28.377,19.201,28.248z M54,14.817v-9.76h-4v9.76H40v3.99h10v9.76h4v-9.76h10v-3.99H54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.471,4.995c0,0-12.66,0-16.879,0C11.023,4.995,3.9,10.999,3.9,17.522\r\n\t\t\t\tc0,6.666,5.158,12.23,12.857,12.23c0.535,0,1.055,0.083,1.565,0.046c-0.498,0.94-0.855,2.045-0.855,3.142\r\n\t\t\t\tc0,1.853,1.014,3.378,2.297,4.604c-0.969,0-1.904,0.04-2.926,0.04C7.465,37.584,0,43.452,0,49.533\r\n\t\t\t\tc0,5.987,8.158,10.472,17.533,10.472c10.686,0,16.463-6.689,16.463-12.678c0-4.799-1.318-7.675-5.777-10.773\r\n\t\t\t\tc-1.525-1.059-4.443-3.641-4.443-5.156c0-1.776,0.518-2.653,3.24-4.742c2.791-2.143,4.955-4.903,4.955-8.407\r\n\t\t\t\tc0-4.17-2.08-7.36-5.629-9.325h5.352L35.471,4.995z M29.574,46.295c0.133,0.556,0.207,1.128,0.207,1.711\r\n\t\t\t\tc0,4.838-3.176,8.128-12.283,8.128c-6.478,0-11.158-3.537-11.158-8.375c0-4.742,5.805-8.69,12.283-8.622\r\n\t\t\t\tc1.512,0.017,2.92,0.255,4.199,0.664C26.34,42.201,28.862,43.558,29.574,46.295z M19.201,28.248\r\n\t\t\t\tc-4.349-0.126-8.482-4.778-9.232-10.387c-0.752-5.609,2.164-9.9,6.512-9.773c4.349,0.127,8.67,4.629,9.422,10.236\r\n\t\t\t\tC26.652,23.934,23.547,28.377,19.201,28.248z M54,14.817v-9.76h-4v9.76H40v3.99h10v9.76h4v-9.76h10v-3.99H54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"skype_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"skype","display":"inline"},"children":[{"name":"g","attribs":{"id":"skype","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.539,36.935C59.825,35.33,60,33.687,60,32C60,16.536,47.464,4,32,4\r\n\t\t\t\tc-1.687,0-3.33,0.175-4.934,0.461C24.191,1.704,20.298,0,16,0C7.164,0,0,7.164,0,16c0,4.298,1.703,8.191,4.461,11.066\r\n\t\t\t\tC4.175,28.67,4,30.313,4,32c0,15.464,12.536,28,28,28c1.687,0,3.33-0.175,4.935-0.461C39.809,62.297,43.702,64,48,64\r\n\t\t\t\tc8.837,0,16-7.163,16-16C64,43.703,62.297,39.809,59.539,36.935z M44.331,43.208c-1.105,1.506-2.74,2.7-4.857,3.548\r\n\t\t\t\tc-2.095,0.838-4.608,1.265-7.468,1.265c-3.433,0-6.312-0.582-8.558-1.73c-1.606-0.834-2.93-1.963-3.936-3.363\r\n\t\t\t\tc-1.014-1.408-1.529-2.807-1.529-4.158c0-0.842,0.335-1.573,0.995-2.171c0.655-0.594,1.494-0.894,2.495-0.894\r\n\t\t\t\tc0.822,0,1.531,0.236,2.106,0.703c0.55,0.451,1.022,1.115,1.401,1.973c0.425,0.936,0.885,1.724,1.372,2.342\r\n\t\t\t\tc0.471,0.6,1.144,1.101,2.006,1.494c0.866,0.395,2.035,0.596,3.472,0.596c1.975,0,3.596-0.407,4.814-1.208\r\n\t\t\t\tc1.191-0.781,1.768-1.721,1.768-2.871c0-0.908-0.302-1.621-0.922-2.183c-0.652-0.586-1.509-1.039-2.55-1.355\r\n\t\t\t\tc-1.087-0.324-2.562-0.679-4.386-1.047c-2.48-0.509-4.587-1.118-6.264-1.802c-1.715-0.703-3.096-1.677-4.106-2.894\r\n\t\t\t\tc-1.026-1.238-1.546-2.787-1.546-4.613c0-1.738,0.546-3.306,1.623-4.656c1.069-1.343,2.63-2.388,4.64-3.101\r\n\t\t\t\tc1.984-0.707,4.343-1.065,7.013-1.065c2.134,0,4.01,0.24,5.577,0.707c1.577,0.471,2.904,1.109,3.948,1.895\r\n\t\t\t\tc1.051,0.791,1.833,1.635,2.324,2.515c0.494,0.886,0.747,1.77,0.747,2.624c0,0.823-0.33,1.571-0.981,2.223\r\n\t\t\t\tc-0.655,0.655-1.481,0.987-2.454,0.987c-0.885,0-1.578-0.209-2.059-0.616c-0.448-0.383-0.912-0.977-1.426-1.83\r\n\t\t\t\tc-0.596-1.09-1.318-1.949-2.145-2.556c-0.804-0.59-2.147-0.886-3.991-0.886c-1.713,0-3.107,0.33-4.141,0.985\r\n\t\t\t\tc-0.998,0.628-1.483,1.349-1.483,2.205c0,0.525,0.157,0.963,0.479,1.339c0.339,0.403,0.819,0.749,1.424,1.043\r\n\t\t\t\tc0.627,0.304,1.276,0.546,1.923,0.717c0.664,0.179,1.779,0.441,3.308,0.781c1.935,0.401,3.712,0.848,5.284,1.333\r\n\t\t\t\tc1.593,0.491,2.967,1.093,4.09,1.798c1.144,0.717,2.05,1.637,2.694,2.738c0.646,1.105,0.972,2.469,0.972,4.053\r\n\t\t\t\tC46.003,39.968,45.439,41.698,44.331,43.208z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.539,36.935C59.825,35.33,60,33.687,60,32C60,16.536,47.464,4,32,4\r\n\t\t\t\tc-1.687,0-3.33,0.175-4.934,0.461C24.191,1.704,20.298,0,16,0C7.164,0,0,7.164,0,16c0,4.298,1.703,8.191,4.461,11.066\r\n\t\t\t\tC4.175,28.67,4,30.313,4,32c0,15.464,12.536,28,28,28c1.687,0,3.33-0.175,4.935-0.461C39.809,62.297,43.702,64,48,64\r\n\t\t\t\tc8.837,0,16-7.163,16-16C64,43.703,62.297,39.809,59.539,36.935z M44.331,43.208c-1.105,1.506-2.74,2.7-4.857,3.548\r\n\t\t\t\tc-2.095,0.838-4.608,1.265-7.468,1.265c-3.433,0-6.312-0.582-8.558-1.73c-1.606-0.834-2.93-1.963-3.936-3.363\r\n\t\t\t\tc-1.014-1.408-1.529-2.807-1.529-4.158c0-0.842,0.335-1.573,0.995-2.171c0.655-0.594,1.494-0.894,2.495-0.894\r\n\t\t\t\tc0.822,0,1.531,0.236,2.106,0.703c0.55,0.451,1.022,1.115,1.401,1.973c0.425,0.936,0.885,1.724,1.372,2.342\r\n\t\t\t\tc0.471,0.6,1.144,1.101,2.006,1.494c0.866,0.395,2.035,0.596,3.472,0.596c1.975,0,3.596-0.407,4.814-1.208\r\n\t\t\t\tc1.191-0.781,1.768-1.721,1.768-2.871c0-0.908-0.302-1.621-0.922-2.183c-0.652-0.586-1.509-1.039-2.55-1.355\r\n\t\t\t\tc-1.087-0.324-2.562-0.679-4.386-1.047c-2.48-0.509-4.587-1.118-6.264-1.802c-1.715-0.703-3.096-1.677-4.106-2.894\r\n\t\t\t\tc-1.026-1.238-1.546-2.787-1.546-4.613c0-1.738,0.546-3.306,1.623-4.656c1.069-1.343,2.63-2.388,4.64-3.101\r\n\t\t\t\tc1.984-0.707,4.343-1.065,7.013-1.065c2.134,0,4.01,0.24,5.577,0.707c1.577,0.471,2.904,1.109,3.948,1.895\r\n\t\t\t\tc1.051,0.791,1.833,1.635,2.324,2.515c0.494,0.886,0.747,1.77,0.747,2.624c0,0.823-0.33,1.571-0.981,2.223\r\n\t\t\t\tc-0.655,0.655-1.481,0.987-2.454,0.987c-0.885,0-1.578-0.209-2.059-0.616c-0.448-0.383-0.912-0.977-1.426-1.83\r\n\t\t\t\tc-0.596-1.09-1.318-1.949-2.145-2.556c-0.804-0.59-2.147-0.886-3.991-0.886c-1.713,0-3.107,0.33-4.141,0.985\r\n\t\t\t\tc-0.998,0.628-1.483,1.349-1.483,2.205c0,0.525,0.157,0.963,0.479,1.339c0.339,0.403,0.819,0.749,1.424,1.043\r\n\t\t\t\tc0.627,0.304,1.276,0.546,1.923,0.717c0.664,0.179,1.779,0.441,3.308,0.781c1.935,0.401,3.712,0.848,5.284,1.333\r\n\t\t\t\tc1.593,0.491,2.967,1.093,4.09,1.798c1.144,0.717,2.05,1.637,2.694,2.738c0.646,1.105,0.972,2.469,0.972,4.053\r\n\t\t\t\tC46.003,39.968,45.439,41.698,44.331,43.208z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"foursquare_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"foursquare","display":"inline"},"children":[{"name":"g","attribs":{"id":"foursquare","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.524,27.182l-8.099-8.285c-2.222-2.189-5.667-2.189-7.89,0l-2.201,2.245\r\n\t\t\t\tc-2.46-1.881-5.468-3.047-8.815-3.047c-8.013,0-14.513,6.42-14.513,14.313c0,7.891,6.529,14.311,14.543,14.311\r\n\t\t\t\tc0.623,0,1.222-0.105,1.825-0.181l13.387,12.458l34.24-30.692V5.018L41.524,27.182z M14.725,43.102\r\n\t\t\t\tc-0.057,0-0.109,0.016-0.166,0.016c-5.998,0-10.877-4.805-10.877-10.71c0-5.907,4.879-10.712,10.877-10.712\r\n\t\t\t\tc2.338,0,4.494,0.748,6.27,1.991c2.776,1.942,4.604,5.119,4.604,8.722C25.434,38.257,20.642,43.013,14.725,43.102z M59.8,27.491\r\n\t\t\t\tL48.426,37.908L30.158,54.157l-9.723-8.753c2.691-1.21,4.978-3.209,6.487-5.69l3.794,3.924l13.511-13.91L59.8,13.77V27.491z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.524,27.182l-8.099-8.285c-2.222-2.189-5.667-2.189-7.89,0l-2.201,2.245\r\n\t\t\t\tc-2.46-1.881-5.468-3.047-8.815-3.047c-8.013,0-14.513,6.42-14.513,14.313c0,7.891,6.529,14.311,14.543,14.311\r\n\t\t\t\tc0.623,0,1.222-0.105,1.825-0.181l13.387,12.458l34.24-30.692V5.018L41.524,27.182z M14.725,43.102\r\n\t\t\t\tc-0.057,0-0.109,0.016-0.166,0.016c-5.998,0-10.877-4.805-10.877-10.71c0-5.907,4.879-10.712,10.877-10.712\r\n\t\t\t\tc2.338,0,4.494,0.748,6.27,1.991c2.776,1.942,4.604,5.119,4.604,8.722C25.434,38.257,20.642,43.013,14.725,43.102z M59.8,27.491\r\n\t\t\t\tL48.426,37.908L30.158,54.157l-9.723-8.753c2.691-1.21,4.978-3.209,6.487-5.69l3.794,3.924l13.511-13.91L59.8,13.77V27.491z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"dropbox_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"dropbox","display":"inline"},"children":[{"name":"g","attribs":{"id":"dropbox","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.04,39.477L18.826,50.345l-5.654-3.662v4.106L32.04,62.003l18.865-11.215\r\n\t\t\t\tv-4.106l-5.653,3.662L32.04,39.477z M0.001,35.846L18.826,48.03L32,37.134L13.018,25.513L0.001,35.846z M32,37.134L45.174,48.03\r\n\t\t\t\tl18.826-12.184L50.982,25.513L32,37.134z M18.826,2.997L0.001,15.176l13.017,10.337L32,13.893L18.826,2.997z M63.999,15.176\r\n\t\t\t\tL45.174,2.997L32,13.893l18.982,11.619L63.999,15.176z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.04,39.477L18.826,50.345l-5.654-3.662v4.106L32.04,62.003l18.865-11.215\r\n\t\t\t\tv-4.106l-5.653,3.662L32.04,39.477z M0.001,35.846L18.826,48.03L32,37.134L13.018,25.513L0.001,35.846z M32,37.134L45.174,48.03\r\n\t\t\t\tl18.826-12.184L50.982,25.513L32,37.134z M18.826,2.997L0.001,15.176l13.017,10.337L32,13.893L18.826,2.997z M63.999,15.176\r\n\t\t\t\tL45.174,2.997L32,13.893l18.982,11.619L63.999,15.176z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"tumblr_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"tumblr","display":"inline"},"children":[{"name":"g","attribs":{"id":"tumblr","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.41,53.584c-1.816,0-3.423-0.428-4.834-1.275\r\n\t\t\t\tc-1.063-0.629-2.039-1.718-2.428-2.767c-0.391-1.049-0.343-3.19-0.343-6.905V26.215h14.728V14.788H34.806V-0.028h-9.062\r\n\t\t\t\tc-0.405,3.308-1.15,6.026-2.231,8.16c-1.08,2.142-2.508,3.973-4.3,5.502c-1.78,1.525-4.681,2.699-7.184,3.513v9.068h8.654v22.455\r\n\t\t\t\tc0,2.933,0.305,5.167,0.915,6.708c0.614,1.537,1.706,2.997,3.291,4.368c1.577,1.36,3.487,2.42,5.725,3.162\r\n\t\t\t\tc2.237,0.734,3.955,1.101,6.869,1.101c2.565,0,4.95-0.258,7.16-0.779c2.207-0.52,4.673-1.428,7.394-2.711v-10.1\r\n\t\t\t\tC48.844,52.527,45.637,53.584,42.41,53.584z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.41,53.584c-1.816,0-3.423-0.428-4.834-1.275\r\n\t\t\t\tc-1.063-0.629-2.039-1.718-2.428-2.767c-0.391-1.049-0.343-3.19-0.343-6.905V26.215h14.728V14.788H34.806V-0.028h-9.062\r\n\t\t\t\tc-0.405,3.308-1.15,6.026-2.231,8.16c-1.08,2.142-2.508,3.973-4.3,5.502c-1.78,1.525-4.681,2.699-7.184,3.513v9.068h8.654v22.455\r\n\t\t\t\tc0,2.933,0.305,5.167,0.915,6.708c0.614,1.537,1.706,2.997,3.291,4.368c1.577,1.36,3.487,2.42,5.725,3.162\r\n\t\t\t\tc2.237,0.734,3.955,1.101,6.869,1.101c2.565,0,4.95-0.258,7.16-0.779c2.207-0.52,4.673-1.428,7.394-2.711v-10.1\r\n\t\t\t\tC48.844,52.527,45.637,53.584,42.41,53.584z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"instagram_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"instagram","display":"inline"},"children":[{"name":"g","attribs":{"id":"instagram","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,0H8C3.582,0,0,3.582,0,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V8\r\n\t\t\t\tC64,3.582,60.418,0,56,0z M19.673,30.673c0.013-0.127,0.04-0.249,0.057-0.374c0.042-0.31,0.088-0.618,0.153-0.92\r\n\t\t\t\tc0.029-0.136,0.069-0.267,0.103-0.401c0.072-0.286,0.147-0.571,0.238-0.849c0.044-0.132,0.095-0.259,0.142-0.389\r\n\t\t\t\tc0.1-0.272,0.204-0.541,0.322-0.804c0.02-0.045,0.034-0.092,0.055-0.137h0.011c1.968-4.247,6.257-7.2,11.246-7.2\r\n\t\t\t\tc4.989,0,9.278,2.953,11.246,7.2h0.011c0.021,0.045,0.035,0.092,0.055,0.137c0.118,0.263,0.222,0.532,0.322,0.804\r\n\t\t\t\tc0.048,0.13,0.099,0.257,0.142,0.389c0.091,0.278,0.166,0.562,0.238,0.849c0.034,0.134,0.074,0.265,0.103,0.401\r\n\t\t\t\tc0.065,0.302,0.11,0.61,0.153,0.92c0.017,0.125,0.043,0.247,0.057,0.374C44.373,31.109,44.4,31.551,44.4,32\r\n\t\t\t\tc0,6.849-5.552,12.4-12.4,12.4c-6.848,0-12.4-5.552-12.4-12.4C19.6,31.551,19.627,31.109,19.673,30.673z M56.8,53.6\r\n\t\t\t\tc0,1.767-1.433,3.2-3.2,3.2H10.4c-1.767,0-3.2-1.433-3.2-3.2V26.8h5.899C12.644,28.456,12.4,30.2,12.4,32\r\n\t\t\t\tc0,10.825,8.775,19.6,19.6,19.6c10.825,0,19.6-8.775,19.6-19.6c0-1.8-0.244-3.544-0.699-5.2H56.8V53.6z M56.8,16.8\r\n\t\t\t\tc0,1.767-1.433,3.2-3.2,3.2h-6.4c-1.767,0-3.2-1.433-3.2-3.2v-6.4c0-1.767,1.433-3.2,3.2-3.2h6.4c1.767,0,3.2,1.432,3.2,3.2V16.8\r\n\t\t\t\tz"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,0H8C3.582,0,0,3.582,0,8v48c0,4.418,3.582,8,8,8h48c4.418,0,8-3.582,8-8V8\r\n\t\t\t\tC64,3.582,60.418,0,56,0z M19.673,30.673c0.013-0.127,0.04-0.249,0.057-0.374c0.042-0.31,0.088-0.618,0.153-0.92\r\n\t\t\t\tc0.029-0.136,0.069-0.267,0.103-0.401c0.072-0.286,0.147-0.571,0.238-0.849c0.044-0.132,0.095-0.259,0.142-0.389\r\n\t\t\t\tc0.1-0.272,0.204-0.541,0.322-0.804c0.02-0.045,0.034-0.092,0.055-0.137h0.011c1.968-4.247,6.257-7.2,11.246-7.2\r\n\t\t\t\tc4.989,0,9.278,2.953,11.246,7.2h0.011c0.021,0.045,0.035,0.092,0.055,0.137c0.118,0.263,0.222,0.532,0.322,0.804\r\n\t\t\t\tc0.048,0.13,0.099,0.257,0.142,0.389c0.091,0.278,0.166,0.562,0.238,0.849c0.034,0.134,0.074,0.265,0.103,0.401\r\n\t\t\t\tc0.065,0.302,0.11,0.61,0.153,0.92c0.017,0.125,0.043,0.247,0.057,0.374C44.373,31.109,44.4,31.551,44.4,32\r\n\t\t\t\tc0,6.849-5.552,12.4-12.4,12.4c-6.848,0-12.4-5.552-12.4-12.4C19.6,31.551,19.627,31.109,19.673,30.673z M56.8,53.6\r\n\t\t\t\tc0,1.767-1.433,3.2-3.2,3.2H10.4c-1.767,0-3.2-1.433-3.2-3.2V26.8h5.899C12.644,28.456,12.4,30.2,12.4,32\r\n\t\t\t\tc0,10.825,8.775,19.6,19.6,19.6c10.825,0,19.6-8.775,19.6-19.6c0-1.8-0.244-3.544-0.699-5.2H56.8V53.6z M56.8,16.8\r\n\t\t\t\tc0,1.767-1.433,3.2-3.2,3.2h-6.4c-1.767,0-3.2-1.433-3.2-3.2v-6.4c0-1.767,1.433-3.2,3.2-3.2h6.4c1.767,0,3.2,1.432,3.2,3.2V16.8\r\n\t\t\t\tz"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"twitter_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"twitter","display":"inline"},"children":[{"name":"g","attribs":{"id":"twitter","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56.569,14.179v-0.032c0.557-0.218,0.997-0.68,1.441-1.022\r\n\t\t\t\tc2-1.541,3.301-3.57,4.26-6.164c-0.544,0.298-1.089,0.596-1.634,0.894c-1.68,0.853-4.532,2.079-6.727,2.267\r\n\t\t\t\tc-2.586-2.356-5.292-4.209-10.378-4.12c-0.534,0.064-1.068,0.128-1.602,0.192c-1.037,0.227-2.024,0.508-2.915,0.894\r\n\t\t\t\tc-3.724,1.616-6.263,4.631-7.431,8.814c-0.465,1.664-0.654,4.445-0.064,6.164c-2.101-0.003-4.135-0.334-5.894-0.767\r\n\t\t\t\tC18.69,19.594,14.372,17.29,9.578,13.54C8.17,12.439,6.789,11.191,5.67,9.804C5.309,9.357,4.74,8.965,4.485,8.43\r\n\t\t\t\tC4.463,8.42,4.442,8.409,4.421,8.398c-0.557,1.032-1.08,2.15-1.409,3.417c-1.3,4.994,0.755,9.188,2.947,11.912\r\n\t\t\t\tc0.664,0.826,1.741,1.338,2.402,2.108h0.064c-0.497,0.184-1.361-0.071-1.794-0.16c-1.024-0.211-1.897-0.405-2.755-0.766\r\n\t\t\t\tc-0.448-0.213-0.897-0.426-1.345-0.639c-0.021,5.517,2.766,9.103,6.182,11.241c1.114,0.697,2.672,1.635,4.292,1.724\r\n\t\t\t\tc-0.867,0.732-4.575,0.396-5.862,0.255c1.609,4.142,4.081,6.9,8.328,8.399c1.096,0.387,2.433,0.729,3.908,0.703\r\n\t\t\t\tc-0.783,0.93-2.454,1.687-3.556,2.331c-2.272,1.329-4.91,2.191-7.88,2.842c-1.191,0.261-2.457,0.207-3.748,0.415\r\n\t\t\t\tc-1.427,0.23-2.92-0.122-4.196-0.16c0.384,0.234,0.769,0.469,1.153,0.703c1.171,0.713,2.394,1.338,3.716,1.916\r\n\t\t\t\tc2.379,1.04,4.914,1.826,7.72,2.523c5.658,1.405,13.64,0.773,18.579-0.766c13.754-4.286,22.443-14.292,25.722-29.03\r\n\t\t\t\tc0.564-2.535,0.646-5.414,0.609-8.431c0.683-0.543,1.367-1.086,2.05-1.629c1.693-1.356,3.28-3.246,4.452-5.11v-0.032\r\n\t\t\t\tC61.768,12.864,59.418,14.149,56.569,14.179z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56.569,14.179v-0.032c0.557-0.218,0.997-0.68,1.441-1.022\r\n\t\t\t\tc2-1.541,3.301-3.57,4.26-6.164c-0.544,0.298-1.089,0.596-1.634,0.894c-1.68,0.853-4.532,2.079-6.727,2.267\r\n\t\t\t\tc-2.586-2.356-5.292-4.209-10.378-4.12c-0.534,0.064-1.068,0.128-1.602,0.192c-1.037,0.227-2.024,0.508-2.915,0.894\r\n\t\t\t\tc-3.724,1.616-6.263,4.631-7.431,8.814c-0.465,1.664-0.654,4.445-0.064,6.164c-2.101-0.003-4.135-0.334-5.894-0.767\r\n\t\t\t\tC18.69,19.594,14.372,17.29,9.578,13.54C8.17,12.439,6.789,11.191,5.67,9.804C5.309,9.357,4.74,8.965,4.485,8.43\r\n\t\t\t\tC4.463,8.42,4.442,8.409,4.421,8.398c-0.557,1.032-1.08,2.15-1.409,3.417c-1.3,4.994,0.755,9.188,2.947,11.912\r\n\t\t\t\tc0.664,0.826,1.741,1.338,2.402,2.108h0.064c-0.497,0.184-1.361-0.071-1.794-0.16c-1.024-0.211-1.897-0.405-2.755-0.766\r\n\t\t\t\tc-0.448-0.213-0.897-0.426-1.345-0.639c-0.021,5.517,2.766,9.103,6.182,11.241c1.114,0.697,2.672,1.635,4.292,1.724\r\n\t\t\t\tc-0.867,0.732-4.575,0.396-5.862,0.255c1.609,4.142,4.081,6.9,8.328,8.399c1.096,0.387,2.433,0.729,3.908,0.703\r\n\t\t\t\tc-0.783,0.93-2.454,1.687-3.556,2.331c-2.272,1.329-4.91,2.191-7.88,2.842c-1.191,0.261-2.457,0.207-3.748,0.415\r\n\t\t\t\tc-1.427,0.23-2.92-0.122-4.196-0.16c0.384,0.234,0.769,0.469,1.153,0.703c1.171,0.713,2.394,1.338,3.716,1.916\r\n\t\t\t\tc2.379,1.04,4.914,1.826,7.72,2.523c5.658,1.405,13.64,0.773,18.579-0.766c13.754-4.286,22.443-14.292,25.722-29.03\r\n\t\t\t\tc0.564-2.535,0.646-5.414,0.609-8.431c0.683-0.543,1.367-1.086,2.05-1.629c1.693-1.356,3.28-3.246,4.452-5.11v-0.032\r\n\t\t\t\tC61.768,12.864,59.418,14.149,56.569,14.179z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"facebook_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"facebook","display":"inline"},"children":[{"name":"g","attribs":{"id":"facebook","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.058-0.006H4.942c-2.722,0-4.929,2.208-4.929,4.932V59.28\r\n\t\t\t\tc0,2.724,2.207,4.727,4.929,4.727h54.116c2.722,0,4.929-2.002,4.929-4.727V4.926C63.987,2.202,61.781-0.006,59.058-0.006z\r\n\t\t\t\t M33.615,21.199c-1.562-0.912-2.803-1.634-4.351-1.634c-1.523,0-2.836,0.383-3.497,1.024c-0.661,0.64-0.992,1.872-0.992,3.692\r\n\t\t\t\tv2.691h8.148l-1.768,7.494h-6.381v24.894H14.545V34.465H9.759v-7.494h4.787v-2.859c0-3.012,0.355-4.817,1.067-6.301\r\n\t\t\t\tc0.711-1.483,2.089-3.134,3.998-4.066c1.909-0.932,4.741-1.399,7.661-1.399c2.995,0,5.338,0.994,8.208,1.803L33.615,21.199z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.058-0.006H4.942c-2.722,0-4.929,2.208-4.929,4.932V59.28\r\n\t\t\t\tc0,2.724,2.207,4.727,4.929,4.727h54.116c2.722,0,4.929-2.002,4.929-4.727V4.926C63.987,2.202,61.781-0.006,59.058-0.006z\r\n\t\t\t\t M33.615,21.199c-1.562-0.912-2.803-1.634-4.351-1.634c-1.523,0-2.836,0.383-3.497,1.024c-0.661,0.64-0.992,1.872-0.992,3.692\r\n\t\t\t\tv2.691h8.148l-1.768,7.494h-6.381v24.894H14.545V34.465H9.759v-7.494h4.787v-2.859c0-3.012,0.355-4.817,1.067-6.301\r\n\t\t\t\tc0.711-1.483,2.089-3.134,3.998-4.066c1.909-0.932,4.741-1.399,7.661-1.399c2.995,0,5.338,0.994,8.208,1.803L33.615,21.199z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"facebook_2_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"facebook_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"facebook_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.963,22.048c0.092-3.345-0.525-8.003,0.515-9.593\r\n\t\t\t\tc1.902-2.911,9.496-2.154,9.496-2.154s0-6.612,0-10.303c-11.982,0-15.903-0.501-20.015,3.675\r\n\t\t\t\tc-3.658,3.715-3.771,11.011-4.072,18.375h-5.872V32.12h5.938c-0.002,10.504,0.003,22.016,0,31.884c4.462,0,13.954,0,13.954,0\r\n\t\t\t\tv-32.01c0,0,5.173,0,8.042,0c0.626-3.385,1.236-6.036,2.088-9.947H36.963z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.963,22.048c0.092-3.345-0.525-8.003,0.515-9.593\r\n\t\t\t\tc1.902-2.911,9.496-2.154,9.496-2.154s0-6.612,0-10.303c-11.982,0-15.903-0.501-20.015,3.675\r\n\t\t\t\tc-3.658,3.715-3.771,11.011-4.072,18.375h-5.872V32.12h5.938c-0.002,10.504,0.003,22.016,0,31.884c4.462,0,13.954,0,13.954,0\r\n\t\t\t\tv-32.01c0,0,5.173,0,8.042,0c0.626-3.385,1.236-6.036,2.088-9.947H36.963z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"pinterest_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"pinterest","display":"inline"},"children":[{"name":"g","attribs":{"id":"pinterest","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.328,0,0,14.328,0,32c0,13.172,7.961,24.484,19.33,29.396\r\n\t\t\t\tc-0.082-2.23-0.002-4.891,0.562-7.302c0.621-2.604,4.137-17.5,4.137-17.5s-1.027-2.053-1.027-5.084\r\n\t\t\t\tc0-4.754,2.762-8.312,6.193-8.312c2.922,0,4.334,2.199,4.334,4.826c0,2.936-1.873,7.326-2.84,11.393\r\n\t\t\t\tc-0.801,3.406,1.715,6.188,5.074,6.188c6.08,0,10.176-7.815,10.176-17.078c0-7.035-4.734-12.307-13.359-12.307\r\n\t\t\t\tc-9.738,0-15.815,7.265-15.815,15.383c0,2.797,0.828,4.773,2.123,6.299c0.594,0.701,0.674,0.984,0.457,1.793\r\n\t\t\t\tc-0.156,0.588-0.502,2.01-0.65,2.578c-0.213,0.813-0.875,1.098-1.609,0.799c-4.484-1.828-6.578-6.742-6.578-12.266\r\n\t\t\t\tc0-9.125,7.695-20.064,22.953-20.064c12.266,0,20.334,8.875,20.334,18.395c0,12.605-7.006,22.014-17.328,22.014\r\n\t\t\t\tc-3.469,0-6.732-1.875-7.844-4c0,0-1.871,7.392-2.262,8.826c-0.674,2.439-1.973,4.877-3.176,6.797C25.982,63.571,28.94,64,32,64\r\n\t\t\t\tc17.672,0,32-14.328,32-32C64,14.328,49.672,0,32,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.328,0,0,14.328,0,32c0,13.172,7.961,24.484,19.33,29.396\r\n\t\t\t\tc-0.082-2.23-0.002-4.891,0.562-7.302c0.621-2.604,4.137-17.5,4.137-17.5s-1.027-2.053-1.027-5.084\r\n\t\t\t\tc0-4.754,2.762-8.312,6.193-8.312c2.922,0,4.334,2.199,4.334,4.826c0,2.936-1.873,7.326-2.84,11.393\r\n\t\t\t\tc-0.801,3.406,1.715,6.188,5.074,6.188c6.08,0,10.176-7.815,10.176-17.078c0-7.035-4.734-12.307-13.359-12.307\r\n\t\t\t\tc-9.738,0-15.815,7.265-15.815,15.383c0,2.797,0.828,4.773,2.123,6.299c0.594,0.701,0.674,0.984,0.457,1.793\r\n\t\t\t\tc-0.156,0.588-0.502,2.01-0.65,2.578c-0.213,0.813-0.875,1.098-1.609,0.799c-4.484-1.828-6.578-6.742-6.578-12.266\r\n\t\t\t\tc0-9.125,7.695-20.064,22.953-20.064c12.266,0,20.334,8.875,20.334,18.395c0,12.605-7.006,22.014-17.328,22.014\r\n\t\t\t\tc-3.469,0-6.732-1.875-7.844-4c0,0-1.871,7.392-2.262,8.826c-0.674,2.439-1.973,4.877-3.176,6.797C25.982,63.571,28.94,64,32,64\r\n\t\t\t\tc17.672,0,32-14.328,32-32C64,14.328,49.672,0,32,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"pinterest_2_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"pinterest_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"pinterest_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.989,15.676c-0.967-3.324-2.492-5.987-4.586-8.274\r\n\t\t\t\tc-2.034-2.223-4.437-4.016-7.45-5.364c-2.854-1.276-6.646-2.221-10.815-2.024c-1.427,0.067-2.741,0.144-4.012,0.329\r\n\t\t\t\tc-3.83,0.557-6.978,1.715-9.768,3.364c-3.63,2.146-6.612,5.15-8.647,8.906c-0.981,1.809-1.867,4.037-2.343,6.452\r\n\t\t\t\tc-0.493,2.498-0.494,5.513,0,8.096c0.812,4.253,2.794,7.533,6.055,9.336c0.436,0.241,1.082,0.617,1.595,0.607\r\n\t\t\t\tc1.241-0.025,1.27-1.492,1.545-2.555c0.228-0.882,0.761-2.096,0.299-2.91c-0.326-0.574-0.815-0.99-1.146-1.493\r\n\t\t\t\tc-1.046-1.586-1.695-3.622-1.695-6.249c0-3.408,0.833-6.145,2.093-8.526c2.406-4.545,6.493-7.838,12.285-8.831\r\n\t\t\t\tc3.188-0.546,6.777-0.264,9.37,0.582c2.614,0.853,4.763,2.371,6.28,4.276c1.593,2.002,2.598,4.583,2.816,7.793\r\n\t\t\t\tc0.118,1.739-0.006,3.502-0.174,5.035c-0.524,4.757-1.906,8.754-4.186,11.715c-1.426,1.852-3.56,3.814-6.629,3.922\r\n\t\t\t\tc-1.738,0.061-2.998-0.365-4.062-1.139c-1.027-0.748-1.779-1.743-2.119-3.187c-0.369-1.574,0.078-3.072,0.473-4.53\r\n\t\t\t\tc0.798-2.94,1.675-5.229,2.342-8.274c0.297-1.352,0.568-3.19,0.2-4.731c-0.346-1.445-1.087-2.467-2.168-3.112\r\n\t\t\t\tc-1.049-0.626-2.777-0.872-4.336-0.33c-2.453,0.855-4.045,3.201-4.735,5.845c-0.391,1.496-0.531,3.119-0.349,4.858\r\n\t\t\t\tc0.158,1.514,0.518,2.809,1.071,4.251c0.076,0.197-0.143,0.768-0.225,1.114c-1.222,5.192-2.377,10.25-3.588,15.408\r\n\t\t\t\tc-0.636,2.708-1.321,5.419-1.47,8.679c-0.131,2.86-0.371,5.802-0.019,8.349c0.065,0.469,0.094,0.792,0.424,0.861\r\n\t\t\t\tc0.433,0.089,0.127,0.755,1.564-0.911c2.163-2.506,3.811-5.6,5.109-8.805c0.783-1.933,1.256-4.069,1.794-6.173\r\n\t\t\t\tc0.546-2.134,1.072-4.318,1.595-6.401c0.804,1.414,1.939,2.349,3.29,3.112c1.362,0.769,2.98,1.306,4.959,1.442\r\n\t\t\t\tc2.037,0.142,3.94-0.222,5.607-0.709c1.681-0.49,3.162-1.225,4.386-2.024c5.046-3.29,8.409-9.072,9.594-16.142\r\n\t\t\t\tc0.317-1.889,0.77-3.777,0.77-5.921C56.982,19.258,56.492,17.406,55.989,15.676z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55.989,15.676c-0.967-3.324-2.492-5.987-4.586-8.274\r\n\t\t\t\tc-2.034-2.223-4.437-4.016-7.45-5.364c-2.854-1.276-6.646-2.221-10.815-2.024c-1.427,0.067-2.741,0.144-4.012,0.329\r\n\t\t\t\tc-3.83,0.557-6.978,1.715-9.768,3.364c-3.63,2.146-6.612,5.15-8.647,8.906c-0.981,1.809-1.867,4.037-2.343,6.452\r\n\t\t\t\tc-0.493,2.498-0.494,5.513,0,8.096c0.812,4.253,2.794,7.533,6.055,9.336c0.436,0.241,1.082,0.617,1.595,0.607\r\n\t\t\t\tc1.241-0.025,1.27-1.492,1.545-2.555c0.228-0.882,0.761-2.096,0.299-2.91c-0.326-0.574-0.815-0.99-1.146-1.493\r\n\t\t\t\tc-1.046-1.586-1.695-3.622-1.695-6.249c0-3.408,0.833-6.145,2.093-8.526c2.406-4.545,6.493-7.838,12.285-8.831\r\n\t\t\t\tc3.188-0.546,6.777-0.264,9.37,0.582c2.614,0.853,4.763,2.371,6.28,4.276c1.593,2.002,2.598,4.583,2.816,7.793\r\n\t\t\t\tc0.118,1.739-0.006,3.502-0.174,5.035c-0.524,4.757-1.906,8.754-4.186,11.715c-1.426,1.852-3.56,3.814-6.629,3.922\r\n\t\t\t\tc-1.738,0.061-2.998-0.365-4.062-1.139c-1.027-0.748-1.779-1.743-2.119-3.187c-0.369-1.574,0.078-3.072,0.473-4.53\r\n\t\t\t\tc0.798-2.94,1.675-5.229,2.342-8.274c0.297-1.352,0.568-3.19,0.2-4.731c-0.346-1.445-1.087-2.467-2.168-3.112\r\n\t\t\t\tc-1.049-0.626-2.777-0.872-4.336-0.33c-2.453,0.855-4.045,3.201-4.735,5.845c-0.391,1.496-0.531,3.119-0.349,4.858\r\n\t\t\t\tc0.158,1.514,0.518,2.809,1.071,4.251c0.076,0.197-0.143,0.768-0.225,1.114c-1.222,5.192-2.377,10.25-3.588,15.408\r\n\t\t\t\tc-0.636,2.708-1.321,5.419-1.47,8.679c-0.131,2.86-0.371,5.802-0.019,8.349c0.065,0.469,0.094,0.792,0.424,0.861\r\n\t\t\t\tc0.433,0.089,0.127,0.755,1.564-0.911c2.163-2.506,3.811-5.6,5.109-8.805c0.783-1.933,1.256-4.069,1.794-6.173\r\n\t\t\t\tc0.546-2.134,1.072-4.318,1.595-6.401c0.804,1.414,1.939,2.349,3.29,3.112c1.362,0.769,2.98,1.306,4.959,1.442\r\n\t\t\t\tc2.037,0.142,3.94-0.222,5.607-0.709c1.681-0.49,3.162-1.225,4.386-2.024c5.046-3.29,8.409-9.072,9.594-16.142\r\n\t\t\t\tc0.317-1.889,0.77-3.777,0.77-5.921C56.982,19.258,56.492,17.406,55.989,15.676z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"forrst_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"forrst","display":"inline"},"children":[{"name":"g","attribs":{"id":"forrst","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.873,61.947L33.865,0.88c-0.228-0.538-0.747-0.883-1.321-0.883\r\n\t\t\t\ts-1.093,0.345-1.32,0.88L5.127,61.944c-0.194,0.457-0.15,0.98,0.116,1.396c0.267,0.412,0.719,0.663,1.205,0.663h22.123V50.667\r\n\t\t\t\tL20.714,48c-1.085,0-1.964-0.895-1.964-2c0-1.105,0.879-2,1.964-2l7.857,2.667V34c0-1.104,0.879-2,1.964-2h3.929\r\n\t\t\t\tc1.085,0,1.964,0.896,1.964,2v3l5.893-3c1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2l-5.893,3v7l9.821-6\r\n\t\t\t\tc1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2l-9.821,6v12.003h22.123c0.487,0,0.938-0.248,1.205-0.663\r\n\t\t\t\tC60.022,62.928,60.066,62.401,59.873,61.947z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M59.873,61.947L33.865,0.88c-0.228-0.538-0.747-0.883-1.321-0.883\r\n\t\t\t\ts-1.093,0.345-1.32,0.88L5.127,61.944c-0.194,0.457-0.15,0.98,0.116,1.396c0.267,0.412,0.719,0.663,1.205,0.663h22.123V50.667\r\n\t\t\t\tL20.714,48c-1.085,0-1.964-0.895-1.964-2c0-1.105,0.879-2,1.964-2l7.857,2.667V34c0-1.104,0.879-2,1.964-2h3.929\r\n\t\t\t\tc1.085,0,1.964,0.896,1.964,2v3l5.893-3c1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2l-5.893,3v7l9.821-6\r\n\t\t\t\tc1.085,0,1.964,0.895,1.964,2c0,1.104-0.879,2-1.964,2l-9.821,6v12.003h22.123c0.487,0,0.938-0.248,1.205-0.663\r\n\t\t\t\tC60.022,62.928,60.066,62.401,59.873,61.947z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"dribbble_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"dribbble","display":"inline"},"children":[{"name":"g","attribs":{"id":"dribbble","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.35,25.558c-0.42-2.056-1.049-4.081-1.866-6.015\r\n\t\t\t\tc-0.802-1.899-1.795-3.727-2.951-5.436c-1.144-1.694-2.459-3.287-3.905-4.733c-1.448-1.449-3.04-2.764-4.735-3.907\r\n\t\t\t\tc-1.709-1.158-3.54-2.149-5.436-2.953c-1.933-0.814-3.957-1.446-6.014-1.863c-2.107-0.433-4.276-0.652-6.442-0.652\r\n\t\t\t\tc-2.169,0-4.338,0.22-6.446,0.652c-2.056,0.417-4.08,1.049-6.013,1.863c-1.896,0.804-3.727,1.795-5.437,2.953\r\n\t\t\t\tC12.411,6.61,10.818,7.924,9.37,9.373c-1.446,1.446-2.76,3.039-3.904,4.733c-1.156,1.709-2.149,3.537-2.951,5.436\r\n\t\t\t\tc-0.818,1.934-1.446,3.96-1.867,6.015c-0.431,2.103-0.65,4.273-0.65,6.44c0,2.172,0.219,4.342,0.65,6.448\r\n\t\t\t\tc0.421,2.056,1.049,4.081,1.867,6.013c0.802,1.896,1.795,3.73,2.951,5.439c1.144,1.694,2.458,3.284,3.904,4.733\r\n\t\t\t\tc1.447,1.446,3.04,2.759,4.734,3.904c1.711,1.155,3.541,2.149,5.437,2.951c1.933,0.819,3.957,1.444,6.013,1.866\r\n\t\t\t\tc2.109,0.435,4.277,0.652,6.446,0.652c2.167,0,4.335-0.217,6.442-0.652c2.057-0.422,4.081-1.047,6.014-1.866\r\n\t\t\t\tc1.896-0.802,3.727-1.795,5.436-2.951c1.694-1.146,3.287-2.458,4.735-3.904c1.446-1.449,2.761-3.039,3.905-4.733\r\n\t\t\t\tc1.155-1.709,2.149-3.542,2.951-5.439c0.817-1.932,1.446-3.957,1.866-6.013c0.432-2.106,0.651-4.275,0.651-6.448\r\n\t\t\t\tC64.001,29.831,63.783,27.661,63.35,25.558z M32.001,4.67c6.919,0,13.234,2.579,18.049,6.819\r\n\t\t\t\tc-0.067,0.106-3.96,6.03-14.276,9.897C31.104,12.802,25.971,5.982,25.56,5.441C27.626,4.941,29.78,4.67,32.001,4.67z\r\n\t\t\t\t M25.455,5.464c-0.001,0.003-0.005,0.005-0.005,0.005s-0.032,0.008-0.082,0.018C25.396,5.479,25.426,5.474,25.455,5.464z\r\n\t\t\t\t M20.34,7.282c0.363,0.488,5.417,7.34,10.148,15.747c-13.123,3.487-24.511,3.35-25.233,3.337\r\n\t\t\t\tC7.032,17.901,12.718,10.883,20.34,7.282z M11.673,50.263c-4.352-4.842-7.001-11.244-7.001-18.266\r\n\t\t\t\tc0-0.291,0.013-0.576,0.023-0.862c0.481,0.01,13.986,0.316,28.057-3.894c0.784,1.532,1.532,3.09,2.218,4.645\r\n\t\t\t\tc-0.362,0.101-0.719,0.21-1.077,0.326C19.143,36.979,11.662,50.25,11.662,50.25S11.671,50.258,11.673,50.263z M32.001,59.33\r\n\t\t\t\tc-6.338,0-12.157-2.175-16.793-5.795c-0.001,0.002-0.005,0.01-0.005,0.01s-0.252-0.187-0.612-0.478\r\n\t\t\t\tc0.199,0.164,0.413,0.309,0.617,0.468c0.1-0.216,5.39-11.47,21.443-17.062c0.059-0.023,0.12-0.041,0.181-0.058\r\n\t\t\t\tc3.846,9.993,5.434,18.362,5.838,20.751C39.392,58.559,35.785,59.33,32.001,59.33z M47.272,54.668\r\n\t\t\t\tc-0.278-1.651-1.734-9.671-5.32-19.522c8.823-1.411,16.468,1.009,17.032,1.193C57.767,43.955,53.408,50.523,47.272,54.668z\r\n\t\t\t\t M40.286,30.832c-0.192-0.468-0.387-0.938-0.589-1.411c-0.569-1.337-1.181-2.662-1.817-3.964\r\n\t\t\t\tc10.793-4.405,15.174-10.741,15.226-10.817c3.833,4.655,6.152,10.602,6.215,17.087C58.925,31.641,49.676,29.651,40.286,30.832z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.35,25.558c-0.42-2.056-1.049-4.081-1.866-6.015\r\n\t\t\t\tc-0.802-1.899-1.795-3.727-2.951-5.436c-1.144-1.694-2.459-3.287-3.905-4.733c-1.448-1.449-3.04-2.764-4.735-3.907\r\n\t\t\t\tc-1.709-1.158-3.54-2.149-5.436-2.953c-1.933-0.814-3.957-1.446-6.014-1.863c-2.107-0.433-4.276-0.652-6.442-0.652\r\n\t\t\t\tc-2.169,0-4.338,0.22-6.446,0.652c-2.056,0.417-4.08,1.049-6.013,1.863c-1.896,0.804-3.727,1.795-5.437,2.953\r\n\t\t\t\tC12.411,6.61,10.818,7.924,9.37,9.373c-1.446,1.446-2.76,3.039-3.904,4.733c-1.156,1.709-2.149,3.537-2.951,5.436\r\n\t\t\t\tc-0.818,1.934-1.446,3.96-1.867,6.015c-0.431,2.103-0.65,4.273-0.65,6.44c0,2.172,0.219,4.342,0.65,6.448\r\n\t\t\t\tc0.421,2.056,1.049,4.081,1.867,6.013c0.802,1.896,1.795,3.73,2.951,5.439c1.144,1.694,2.458,3.284,3.904,4.733\r\n\t\t\t\tc1.447,1.446,3.04,2.759,4.734,3.904c1.711,1.155,3.541,2.149,5.437,2.951c1.933,0.819,3.957,1.444,6.013,1.866\r\n\t\t\t\tc2.109,0.435,4.277,0.652,6.446,0.652c2.167,0,4.335-0.217,6.442-0.652c2.057-0.422,4.081-1.047,6.014-1.866\r\n\t\t\t\tc1.896-0.802,3.727-1.795,5.436-2.951c1.694-1.146,3.287-2.458,4.735-3.904c1.446-1.449,2.761-3.039,3.905-4.733\r\n\t\t\t\tc1.155-1.709,2.149-3.542,2.951-5.439c0.817-1.932,1.446-3.957,1.866-6.013c0.432-2.106,0.651-4.275,0.651-6.448\r\n\t\t\t\tC64.001,29.831,63.783,27.661,63.35,25.558z M32.001,4.67c6.919,0,13.234,2.579,18.049,6.819\r\n\t\t\t\tc-0.067,0.106-3.96,6.03-14.276,9.897C31.104,12.802,25.971,5.982,25.56,5.441C27.626,4.941,29.78,4.67,32.001,4.67z\r\n\t\t\t\t M25.455,5.464c-0.001,0.003-0.005,0.005-0.005,0.005s-0.032,0.008-0.082,0.018C25.396,5.479,25.426,5.474,25.455,5.464z\r\n\t\t\t\t M20.34,7.282c0.363,0.488,5.417,7.34,10.148,15.747c-13.123,3.487-24.511,3.35-25.233,3.337\r\n\t\t\t\tC7.032,17.901,12.718,10.883,20.34,7.282z M11.673,50.263c-4.352-4.842-7.001-11.244-7.001-18.266\r\n\t\t\t\tc0-0.291,0.013-0.576,0.023-0.862c0.481,0.01,13.986,0.316,28.057-3.894c0.784,1.532,1.532,3.09,2.218,4.645\r\n\t\t\t\tc-0.362,0.101-0.719,0.21-1.077,0.326C19.143,36.979,11.662,50.25,11.662,50.25S11.671,50.258,11.673,50.263z M32.001,59.33\r\n\t\t\t\tc-6.338,0-12.157-2.175-16.793-5.795c-0.001,0.002-0.005,0.01-0.005,0.01s-0.252-0.187-0.612-0.478\r\n\t\t\t\tc0.199,0.164,0.413,0.309,0.617,0.468c0.1-0.216,5.39-11.47,21.443-17.062c0.059-0.023,0.12-0.041,0.181-0.058\r\n\t\t\t\tc3.846,9.993,5.434,18.362,5.838,20.751C39.392,58.559,35.785,59.33,32.001,59.33z M47.272,54.668\r\n\t\t\t\tc-0.278-1.651-1.734-9.671-5.32-19.522c8.823-1.411,16.468,1.009,17.032,1.193C57.767,43.955,53.408,50.523,47.272,54.668z\r\n\t\t\t\t M40.286,30.832c-0.192-0.468-0.387-0.938-0.589-1.411c-0.569-1.337-1.181-2.662-1.817-3.964\r\n\t\t\t\tc10.793-4.405,15.174-10.741,15.226-10.817c3.833,4.655,6.152,10.602,6.215,17.087C58.925,31.641,49.676,29.651,40.286,30.832z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"behance_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"behance","display":"inline"},"children":[{"name":"g","attribs":{"id":"behance","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.989,30.502c3.455-1.68,5.402-4.417,5.402-8.338\r\n\t\t\t\tc0-7.438-5.12-10.15-12.686-10.15H0.001v40.192h19.255c7.179,0,14.027-3.472,14.027-11.584\r\n\t\t\t\tC33.284,35.646,30.836,31.901,25.989,30.502z M7.991,18.774h8.18c3.115,0,6.01,0.786,6.01,4.591c0,3.352-2.283,4.749-5.343,4.749\r\n\t\t\t\tH7.991V18.774z M17.338,45.063H7.991V34.098h9.513c3.73,0,6.288,1.625,6.288,5.707C23.792,43.947,20.789,45.063,17.338,45.063z\r\n\t\t\t\t M57.972,15.993H42.028v4.072h15.943V15.993z M50.05,22.502c-8.735,0-14.692,6.601-14.692,15.273\r\n\t\t\t\tc0,8.947,5.621,15.212,14.692,15.212c6.514,0,10.62-1.965,12.842-8.79h-6.328c-0.501,1.793-3.064,2.806-6.238,2.806\r\n\t\t\t\tc-4.395,0-6.843-1.855-7.064-6.891h20.756C64.574,31.219,59.843,22.502,50.05,22.502z M43.262,34.198\r\n\t\t\t\tc0.109-2.234,1.556-5.709,6.563-5.709c3.839,0,5.568,1.684,6.293,5.709H43.262z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25.989,30.502c3.455-1.68,5.402-4.417,5.402-8.338\r\n\t\t\t\tc0-7.438-5.12-10.15-12.686-10.15H0.001v40.192h19.255c7.179,0,14.027-3.472,14.027-11.584\r\n\t\t\t\tC33.284,35.646,30.836,31.901,25.989,30.502z M7.991,18.774h8.18c3.115,0,6.01,0.786,6.01,4.591c0,3.352-2.283,4.749-5.343,4.749\r\n\t\t\t\tH7.991V18.774z M17.338,45.063H7.991V34.098h9.513c3.73,0,6.288,1.625,6.288,5.707C23.792,43.947,20.789,45.063,17.338,45.063z\r\n\t\t\t\t M57.972,15.993H42.028v4.072h15.943V15.993z M50.05,22.502c-8.735,0-14.692,6.601-14.692,15.273\r\n\t\t\t\tc0,8.947,5.621,15.212,14.692,15.212c6.514,0,10.62-1.965,12.842-8.79h-6.328c-0.501,1.793-3.064,2.806-6.238,2.806\r\n\t\t\t\tc-4.395,0-6.843-1.855-7.064-6.891h20.756C64.574,31.219,59.843,22.502,50.05,22.502z M43.262,34.198\r\n\t\t\t\tc0.109-2.234,1.556-5.709,6.563-5.709c3.839,0,5.568,1.684,6.293,5.709H43.262z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"windows_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"windows","display":"inline"},"children":[{"name":"g","attribs":{"id":"windows","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.015,30.236h25.809V5.541L0.015,9.28V30.236z M29.353,5.029v25.207h34.632\r\n\t\t\t\tV0.015L29.353,5.029z M0.015,54.721l25.809,3.738V33.765H0.015V54.721z M29.353,58.97l34.632,5.015v-30.22H29.353V58.97z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.015,30.236h25.809V5.541L0.015,9.28V30.236z M29.353,5.029v25.207h34.632\r\n\t\t\t\tV0.015L29.353,5.029z M0.015,54.721l25.809,3.738V33.765H0.015V54.721z M29.353,58.97l34.632,5.015v-30.22H29.353V58.97z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"microsoft_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"microsoft","display":"inline"},"children":[{"name":"g","attribs":{"id":"microsoft","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.307,31.796c-2.208-1.219-5.281-2.486-8.648-2.486\r\n\t\t\t\tc-0.383,0-0.764,0.014-1.149,0.049c-3.377,0.302-6.453,1.232-8.613,2.052c-0.638,0.248-1.297,0.518-1.971,0.814l-5.924,22.12\r\n\t\t\t\tc4.476-1.944,8.093-2.72,11.133-2.72c5.01,0,8.484,2.084,11.763,4.435c1.217-4.441,5.348-19.634,6.133-22.527\r\n\t\t\t\tC28.143,32.94,27.25,32.344,26.307,31.796z M18.765,23.98c4.802,0.054,8.205,2.119,11.372,4.382\r\n\t\t\t\tc1.213-4.427,4.814-17.723,6.03-22.209V6.136c0,0-4.244-2.737-7.197-3.548c-1.409-0.359-3.003-0.585-4.766-0.585h-0.069\r\n\t\t\t\tc-3.001,0.062-6.598,0.844-11.02,2.788L7.28,26.86c4.543-1.995,8.228-2.88,11.324-2.88H18.765z M52.56,13.559\r\n\t\t\t\tc-6.488,0-10.766-2.974-12.658-4.559l-5.985,22.306c0.016,0.019,0.043,0.035,0.063,0.048c3.292,2.37,7.573,4.287,12.733,4.287\r\n\t\t\t\tc3.412,0,7.204-0.836,11.348-2.941v-0.03c0.009,0,0.021-0.008,0.036-0.014l5.902-21.899\r\n\t\t\t\tC59.641,12.807,55.824,13.559,52.56,13.559z M32.569,36.329l-5.905,22.085c-0.009-0.005,6.904,4.584,12.089,4.584\r\n\t\t\t\tc3.281,0,7.205-0.865,12.114-3.047l5.691-21.43c-4.318,1.666-8.039,2.292-11.184,2.292\r\n\t\t\t\tC38.529,40.813,34.367,37.874,32.569,36.329z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.307,31.796c-2.208-1.219-5.281-2.486-8.648-2.486\r\n\t\t\t\tc-0.383,0-0.764,0.014-1.149,0.049c-3.377,0.302-6.453,1.232-8.613,2.052c-0.638,0.248-1.297,0.518-1.971,0.814l-5.924,22.12\r\n\t\t\t\tc4.476-1.944,8.093-2.72,11.133-2.72c5.01,0,8.484,2.084,11.763,4.435c1.217-4.441,5.348-19.634,6.133-22.527\r\n\t\t\t\tC28.143,32.94,27.25,32.344,26.307,31.796z M18.765,23.98c4.802,0.054,8.205,2.119,11.372,4.382\r\n\t\t\t\tc1.213-4.427,4.814-17.723,6.03-22.209V6.136c0,0-4.244-2.737-7.197-3.548c-1.409-0.359-3.003-0.585-4.766-0.585h-0.069\r\n\t\t\t\tc-3.001,0.062-6.598,0.844-11.02,2.788L7.28,26.86c4.543-1.995,8.228-2.88,11.324-2.88H18.765z M52.56,13.559\r\n\t\t\t\tc-6.488,0-10.766-2.974-12.658-4.559l-5.985,22.306c0.016,0.019,0.043,0.035,0.063,0.048c3.292,2.37,7.573,4.287,12.733,4.287\r\n\t\t\t\tc3.412,0,7.204-0.836,11.348-2.941v-0.03c0.009,0,0.021-0.008,0.036-0.014l5.902-21.899\r\n\t\t\t\tC59.641,12.807,55.824,13.559,52.56,13.559z M32.569,36.329l-5.905,22.085c-0.009-0.005,6.904,4.584,12.089,4.584\r\n\t\t\t\tc3.281,0,7.205-0.865,12.114-3.047l5.691-21.43c-4.318,1.666-8.039,2.292-11.184,2.292\r\n\t\t\t\tC38.529,40.813,34.367,37.874,32.569,36.329z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"appstore_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"appstore","display":"inline"},"children":[{"name":"g","attribs":{"id":"appstore","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.03,28.052L24.522,39.43h17.661c-1.283-2.54-2.981-6.173-5.261-11.377H31.03\r\n\t\t\t\tz M31.735,21.424c0.405-0.708,0.16-1.618-0.546-2.03l-3.854-2.214c-0.704-0.41-1.615-0.163-2.019,0.545l-5.908,10.328\r\n\t\t\t\tL12.899,39.43l-5.433,9.5c-0.409,0.708-0.16,1.618,0.546,2.023l3.853,2.224c0.705,0.408,1.615,0.161,2.023-0.545l7.55-13.202\r\n\t\t\t\tl4.879-8.532L31.735,21.424z M10.606,54.878l-3.853-2.219c-0.706-0.408-1.358-0.074-1.452,0.736l-0.666,5.824\r\n\t\t\t\tc-0.093,0.81,0.382,1.101,1.054,0.642l4.977-3.406C11.341,55.999,11.312,55.286,10.606,54.878z M16.322,28.052H1.35\r\n\t\t\t\tc-0.74,0-1.339,0.601-1.339,1.343v8.692c0,0.741,0.599,1.342,1.339,1.342h8.464L16.322,28.052z M62.65,28.052H49.643\r\n\t\t\t\tc1.53,2.879,2.948,5.589,3.948,7.505c0.692,1.325,1.239,2.372,1.433,2.723c0.202,0.372,0.346,0.756,0.444,1.149h7.183\r\n\t\t\t\tc0.739,0,1.339-0.601,1.339-1.342v-8.692C63.989,28.654,63.389,28.052,62.65,28.052z M52.677,39.575\r\n\t\t\t\tc-0.022-0.038-0.051-0.092-0.079-0.145c-0.358-0.665-1.255-2.394-2.433-4.639c-0.014-0.031-0.029-0.056-0.043-0.087\r\n\t\t\t\tc-0.09-0.173-0.181-0.346-0.275-0.525c-0.067-0.127-0.134-0.257-0.204-0.387c-0.057-0.112-0.117-0.224-0.175-0.339\r\n\t\t\t\tc-0.105-0.199-0.211-0.397-0.317-0.601c-0.034-0.064-0.066-0.127-0.1-0.191c-0.119-0.229-0.241-0.459-0.364-0.693\r\n\t\t\t\tc-0.035-0.066-0.07-0.132-0.106-0.201c-2.714-5.151-6.123-11.492-8.227-14.827c-3.683-5.844-8.599-15.583-9.971-14.89\r\n\t\t\t\tc-1.923,0.961,4.027,13.324,5.997,17.97c1.97,4.644,9.656,22.447,11.197,23.224c1.543,0.774,2.14,0.344,3.169-0.084\r\n\t\t\t\tC51.774,42.729,53.619,41.3,52.677,39.575z M56.504,53.867c-0.577,0.555-1.951,1.763-0.289,4.107\r\n\t\t\t\tc1.657,2.349,5.362,2.454,5.85,4.013C62.065,61.986,63.229,50.061,56.504,53.867z M57.071,48.749l-1.835-3.536\r\n\t\t\t\tc-0.416-0.8-1.392-1.126-2.171-0.726l-2.213,1.144c-0.779,0.405-1.025,1.353-0.546,2.117l2.322,3.681\r\n\t\t\t\tc0.48,0.759,1.491,1.009,2.242,0.553l1.58-0.953C57.205,50.575,57.484,49.549,57.071,48.749z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.03,28.052L24.522,39.43h17.661c-1.283-2.54-2.981-6.173-5.261-11.377H31.03\r\n\t\t\t\tz M31.735,21.424c0.405-0.708,0.16-1.618-0.546-2.03l-3.854-2.214c-0.704-0.41-1.615-0.163-2.019,0.545l-5.908,10.328\r\n\t\t\t\tL12.899,39.43l-5.433,9.5c-0.409,0.708-0.16,1.618,0.546,2.023l3.853,2.224c0.705,0.408,1.615,0.161,2.023-0.545l7.55-13.202\r\n\t\t\t\tl4.879-8.532L31.735,21.424z M10.606,54.878l-3.853-2.219c-0.706-0.408-1.358-0.074-1.452,0.736l-0.666,5.824\r\n\t\t\t\tc-0.093,0.81,0.382,1.101,1.054,0.642l4.977-3.406C11.341,55.999,11.312,55.286,10.606,54.878z M16.322,28.052H1.35\r\n\t\t\t\tc-0.74,0-1.339,0.601-1.339,1.343v8.692c0,0.741,0.599,1.342,1.339,1.342h8.464L16.322,28.052z M62.65,28.052H49.643\r\n\t\t\t\tc1.53,2.879,2.948,5.589,3.948,7.505c0.692,1.325,1.239,2.372,1.433,2.723c0.202,0.372,0.346,0.756,0.444,1.149h7.183\r\n\t\t\t\tc0.739,0,1.339-0.601,1.339-1.342v-8.692C63.989,28.654,63.389,28.052,62.65,28.052z M52.677,39.575\r\n\t\t\t\tc-0.022-0.038-0.051-0.092-0.079-0.145c-0.358-0.665-1.255-2.394-2.433-4.639c-0.014-0.031-0.029-0.056-0.043-0.087\r\n\t\t\t\tc-0.09-0.173-0.181-0.346-0.275-0.525c-0.067-0.127-0.134-0.257-0.204-0.387c-0.057-0.112-0.117-0.224-0.175-0.339\r\n\t\t\t\tc-0.105-0.199-0.211-0.397-0.317-0.601c-0.034-0.064-0.066-0.127-0.1-0.191c-0.119-0.229-0.241-0.459-0.364-0.693\r\n\t\t\t\tc-0.035-0.066-0.07-0.132-0.106-0.201c-2.714-5.151-6.123-11.492-8.227-14.827c-3.683-5.844-8.599-15.583-9.971-14.89\r\n\t\t\t\tc-1.923,0.961,4.027,13.324,5.997,17.97c1.97,4.644,9.656,22.447,11.197,23.224c1.543,0.774,2.14,0.344,3.169-0.084\r\n\t\t\t\tC51.774,42.729,53.619,41.3,52.677,39.575z M56.504,53.867c-0.577,0.555-1.951,1.763-0.289,4.107\r\n\t\t\t\tc1.657,2.349,5.362,2.454,5.85,4.013C62.065,61.986,63.229,50.061,56.504,53.867z M57.071,48.749l-1.835-3.536\r\n\t\t\t\tc-0.416-0.8-1.392-1.126-2.171-0.726l-2.213,1.144c-0.779,0.405-1.025,1.353-0.546,2.117l2.322,3.681\r\n\t\t\t\tc0.48,0.759,1.491,1.009,2.242,0.553l1.58-0.953C57.205,50.575,57.484,49.549,57.071,48.749z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"apple_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"apple","display":"inline"},"children":[{"name":"g","attribs":{"id":"apple","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.112,10.214c2.399-2.709,4.021-6.473,3.579-10.221\r\n\t\t\t\tc-3.459,0.13-7.647,2.14-10.131,4.846c-2.224,2.401-4.17,6.226-3.65,9.906C35.77,15.025,39.708,12.918,42.112,10.214z\r\n\t\t\t\t M50.772,34.008c-0.087-8.109,7.104-11.997,7.426-12.193c-4.041-5.499-10.336-6.254-12.576-6.34\r\n\t\t\t\tc-5.355-0.506-10.451,2.935-13.169,2.935c-2.711,0-6.906-2.861-11.346-2.788c-5.84,0.081-11.222,3.161-14.228,8.028\r\n\t\t\t\tc-6.065,9.794-1.552,24.307,4.359,32.256c2.89,3.886,6.335,8.257,10.855,8.097c4.357-0.16,6.002-2.622,11.267-2.622\r\n\t\t\t\tc5.268,0,6.746,2.622,11.354,2.541c4.685-0.079,7.655-3.959,10.522-7.86c3.318-4.513,4.683-8.885,4.765-9.106\r\n\t\t\t\tC59.896,46.91,50.865,43.69,50.772,34.008z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42.112,10.214c2.399-2.709,4.021-6.473,3.579-10.221\r\n\t\t\t\tc-3.459,0.13-7.647,2.14-10.131,4.846c-2.224,2.401-4.17,6.226-3.65,9.906C35.77,15.025,39.708,12.918,42.112,10.214z\r\n\t\t\t\t M50.772,34.008c-0.087-8.109,7.104-11.997,7.426-12.193c-4.041-5.499-10.336-6.254-12.576-6.34\r\n\t\t\t\tc-5.355-0.506-10.451,2.935-13.169,2.935c-2.711,0-6.906-2.861-11.346-2.788c-5.84,0.081-11.222,3.161-14.228,8.028\r\n\t\t\t\tc-6.065,9.794-1.552,24.307,4.359,32.256c2.89,3.886,6.335,8.257,10.855,8.097c4.357-0.16,6.002-2.622,11.267-2.622\r\n\t\t\t\tc5.268,0,6.746,2.622,11.354,2.541c4.685-0.079,7.655-3.959,10.522-7.86c3.318-4.513,4.683-8.885,4.765-9.106\r\n\t\t\t\tC59.896,46.91,50.865,43.69,50.772,34.008z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"android_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"android","display":"inline"},"children":[{"name":"g","attribs":{"id":"android","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.647,47.493c0,2.164,1.709,3.926,3.812,3.926h2.752\r\n\t\t\t\tc-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.717,3.612,3.717c1.995,0,3.613-1.665,3.613-3.717V52.45\r\n\t\t\t\tc0-0.358-0.053-0.704-0.144-1.031h6.708c-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.717,3.612,3.717\r\n\t\t\t\tc1.995,0,3.613-1.665,3.613-3.717V52.45c0-0.358-0.052-0.704-0.144-1.031h2.752c2.103,0,3.812-1.761,3.812-3.926v-27.26H15.647\r\n\t\t\t\tV47.493z M9.626,20.233c-1.995,0-3.612,1.664-3.612,3.717v15.902c0,2.052,1.617,3.717,3.612,3.717\r\n\t\t\t\tc1.994,0,3.612-1.665,3.612-3.717V23.951C13.238,21.897,11.62,20.233,9.626,20.233z M55.375,20.233\r\n\t\t\t\tc-1.995,0-3.612,1.664-3.612,3.717v15.902c0,2.052,1.617,3.717,3.612,3.717c1.995,0,3.611-1.665,3.611-3.717V23.951\r\n\t\t\t\tC58.986,21.897,57.37,20.233,55.375,20.233z M40.789,5.355l0.678-1.047l0.668-1.032l1.501-2.318\r\n\t\t\t\tc0.184-0.285,0.109-0.669-0.166-0.859c-0.278-0.191-0.651-0.114-0.836,0.172l-1.609,2.485l-0.677,1.045L39.662,4.86\r\n\t\t\t\tC37.487,3.992,35.06,3.505,32.5,3.505c-2.559,0-4.986,0.487-7.16,1.354l-0.685-1.059l-0.676-1.045l-1.612-2.485\r\n\t\t\t\tc-0.184-0.285-0.558-0.362-0.836-0.172c-0.275,0.19-0.351,0.574-0.166,0.859l1.5,2.318l0.669,1.032l0.678,1.047\r\n\t\t\t\tc-5.109,2.449-8.566,7.089-8.566,12.4h33.708C49.355,12.444,45.898,7.804,40.789,5.355z M25.278,12.799\r\n\t\t\t\tc-0.998,0-1.806-0.833-1.806-1.859c0-1.026,0.808-1.857,1.806-1.857c0.997,0,1.806,0.831,1.806,1.857\r\n\t\t\t\tC27.084,11.966,26.275,12.799,25.278,12.799z M39.724,12.799c-0.997,0-1.805-0.833-1.805-1.859c0-1.026,0.808-1.857,1.805-1.857\r\n\t\t\t\tc0.998,0,1.806,0.831,1.806,1.857C41.529,11.966,40.722,12.799,39.724,12.799z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.647,47.493c0,2.164,1.709,3.926,3.812,3.926h2.752\r\n\t\t\t\tc-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.717,3.612,3.717c1.995,0,3.613-1.665,3.613-3.717V52.45\r\n\t\t\t\tc0-0.358-0.053-0.704-0.144-1.031h6.708c-0.092,0.327-0.144,0.673-0.144,1.031v7.848c0,2.052,1.618,3.717,3.612,3.717\r\n\t\t\t\tc1.995,0,3.613-1.665,3.613-3.717V52.45c0-0.358-0.052-0.704-0.144-1.031h2.752c2.103,0,3.812-1.761,3.812-3.926v-27.26H15.647\r\n\t\t\t\tV47.493z M9.626,20.233c-1.995,0-3.612,1.664-3.612,3.717v15.902c0,2.052,1.617,3.717,3.612,3.717\r\n\t\t\t\tc1.994,0,3.612-1.665,3.612-3.717V23.951C13.238,21.897,11.62,20.233,9.626,20.233z M55.375,20.233\r\n\t\t\t\tc-1.995,0-3.612,1.664-3.612,3.717v15.902c0,2.052,1.617,3.717,3.612,3.717c1.995,0,3.611-1.665,3.611-3.717V23.951\r\n\t\t\t\tC58.986,21.897,57.37,20.233,55.375,20.233z M40.789,5.355l0.678-1.047l0.668-1.032l1.501-2.318\r\n\t\t\t\tc0.184-0.285,0.109-0.669-0.166-0.859c-0.278-0.191-0.651-0.114-0.836,0.172l-1.609,2.485l-0.677,1.045L39.662,4.86\r\n\t\t\t\tC37.487,3.992,35.06,3.505,32.5,3.505c-2.559,0-4.986,0.487-7.16,1.354l-0.685-1.059l-0.676-1.045l-1.612-2.485\r\n\t\t\t\tc-0.184-0.285-0.558-0.362-0.836-0.172c-0.275,0.19-0.351,0.574-0.166,0.859l1.5,2.318l0.669,1.032l0.678,1.047\r\n\t\t\t\tc-5.109,2.449-8.566,7.089-8.566,12.4h33.708C49.355,12.444,45.898,7.804,40.789,5.355z M25.278,12.799\r\n\t\t\t\tc-0.998,0-1.806-0.833-1.806-1.859c0-1.026,0.808-1.857,1.806-1.857c0.997,0,1.806,0.831,1.806,1.857\r\n\t\t\t\tC27.084,11.966,26.275,12.799,25.278,12.799z M39.724,12.799c-0.997,0-1.805-0.833-1.805-1.859c0-1.026,0.808-1.857,1.805-1.857\r\n\t\t\t\tc0.998,0,1.806,0.831,1.806,1.857C41.529,11.966,40.722,12.799,39.724,12.799z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RSS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RSS","display":"inline"},"children":[{"name":"g","attribs":{"id":"RSS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8,48c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tC16,51.582,12.418,48,8,48z M0,23v11c16.569,0,30,13.431,30,30h11C41,41.356,22.644,23,0,23z M0,0v11c29.271,0,53,23.729,53,53\r\n\t\t\t\th11C64,28.654,35.346,0,0,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8,48c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tC16,51.582,12.418,48,8,48z M0,23v11c16.569,0,30,13.431,30,30h11C41,41.356,22.644,23,0,23z M0,0v11c29.271,0,53,23.729,53,53\r\n\t\t\t\th11C64,28.654,35.346,0,0,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"HASHTAG_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HASHTAG","display":"inline"},"children":[{"name":"g","attribs":{"id":"HASHTAG","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,18h-8.69l2.614-11.325h0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.425,0-2.617,0.994-2.923,2.326l0,0L43.152,18H27.31l2.614-11.325h0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.425,0-2.617,0.994-2.923,2.326l0,0L21.152,18H12c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h7.767l-3.692,16H6\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325h0C12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46H36.69l-2.614,11.325h0C34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7.767l3.692-16H58c1.657,0,3-1.343,3-3\r\n\t\t\t\tC61,19.343,59.657,18,58,18z M38.075,40H22.233l3.692-16h15.842L38.075,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,18h-8.69l2.614-11.325h0C51.973,6.458,52,6.232,52,6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.425,0-2.617,0.994-2.923,2.326l0,0L43.152,18H27.31l2.614-11.325h0C29.973,6.458,30,6.232,30,6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.425,0-2.617,0.994-2.923,2.326l0,0L21.152,18H12c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h7.767l-3.692,16H6\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h8.69l-2.613,11.325h0C12.027,57.542,12,57.768,12,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.425,0,2.617-0.994,2.923-2.326l0,0L20.848,46H36.69l-2.614,11.325h0C34.027,57.542,34,57.768,34,58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.425,0,2.617-0.994,2.923-2.326l0,0L42.848,46H52c1.657,0,3-1.343,3-3s-1.343-3-3-3h-7.767l3.692-16H58c1.657,0,3-1.343,3-3\r\n\t\t\t\tC61,19.343,59.657,18,58,18z M38.075,40H22.233l3.692-16h15.842L38.075,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COLUMNS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COLUMNS","display":"inline"},"children":[{"name":"g","attribs":{"id":"COLUMNS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6H3C1.343,6,0,7.343,0,9v46c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC64,7.343,62.657,6,61,6z M21,52H6V12h15V52z M40,52H24V12h16V52z M58,52H43V12h15V52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6H3C1.343,6,0,7.343,0,9v46c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC64,7.343,62.657,6,61,6z M21,52H6V12h15V52z M40,52H24V12h16V52z M58,52H43V12h15V52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PEN_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"PEN_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61.167,6.995l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322\r\n\t\t\t\tl8.446,8.429l6.334-6.322C62.334,10.046,62.334,8.159,61.167,6.995z M53,57H7V11h33.357l6-6H4C2.343,5,1,6.343,1,8v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V17.813l-6,6V57z M52.721,19.639l-8.446-8.429L18.938,36.498l8.446,8.429\r\n\t\t\t\tL52.721,19.639z M13.998,49.84l11.258-2.806l-8.447-8.431L13.998,49.84z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61.167,6.995l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322\r\n\t\t\t\tl8.446,8.429l6.334-6.322C62.334,10.046,62.334,8.159,61.167,6.995z M53,57H7V11h33.357l6-6H4C2.343,5,1,6.343,1,8v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V17.813l-6,6V57z M52.721,19.639l-8.446-8.429L18.938,36.498l8.446,8.429\r\n\t\t\t\tL52.721,19.639z M13.998,49.84l11.258-2.806l-8.447-8.431L13.998,49.84z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PEN_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"PEN_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.721,19.639l-8.446-8.429L12.938,36.498l8.446,8.429L46.721,19.639z\r\n\t\t\t\t M55.167,11.21c1.166-1.164,1.166-3.051,0-4.214l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429\r\n\t\t\t\tL55.167,11.21z M61,56H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,57.343,62.657,56,61,56z\r\n\t\t\t\t M10.809,38.604L7.998,49.84l11.258-2.806L10.809,38.604z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.721,19.639l-8.446-8.429L12.938,36.498l8.446,8.429L46.721,19.639z\r\n\t\t\t\t M55.167,11.21c1.166-1.164,1.166-3.051,0-4.214l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0l-6.334,6.322l8.446,8.429\r\n\t\t\t\tL55.167,11.21z M61,56H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,57.343,62.657,56,61,56z\r\n\t\t\t\t M10.809,38.604L7.998,49.84l11.258-2.806L10.809,38.604z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PEN_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PEN_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"PEN_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.938,42.498l8.446,8.429l25.338-25.288l-8.446-8.429L12.938,42.498z\r\n\t\t\t\t M7.998,55.84l11.258-2.806l-8.447-8.431L7.998,55.84z M55.167,12.996l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0\r\n\t\t\t\tl-6.334,6.322l8.446,8.429l6.334-6.322C56.333,16.046,56.333,14.159,55.167,12.996z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.938,42.498l8.446,8.429l25.338-25.288l-8.446-8.429L12.938,42.498z\r\n\t\t\t\t M7.998,55.84l11.258-2.806l-8.447-8.431L7.998,55.84z M55.167,12.996l-4.223-4.215c-1.166-1.164-3.057-1.164-4.223,0\r\n\t\t\t\tl-6.334,6.322l8.446,8.429l6.334-6.322C56.333,16.046,56.333,14.159,55.167,12.996z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_2_5_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43H6c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757l-9.879,9.879\r\n\t\t\t\tC0.336,59.422,0,60.172,0,61c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L15,53.243V58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C21,44.343,19.657,43,18,43z M32,23c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9\r\n\t\t\t\tC41,27.029,36.971,23,32,23z M64,3c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L49,10.757V6c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l9.879-9.879\r\n\t\t\t\tC63.664,4.578,64,3.829,64,3z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43H6c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757l-9.879,9.879\r\n\t\t\t\tC0.336,59.422,0,60.172,0,61c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L15,53.243V58c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C21,44.343,19.657,43,18,43z M32,23c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9\r\n\t\t\t\tC41,27.029,36.971,23,32,23z M64,3c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L49,10.757V6c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l9.879-9.879\r\n\t\t\t\tC63.664,4.578,64,3.829,64,3z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_1_5_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43c-0.828,0-1.578,0.336-2.121,0.879L6,53.757V49c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l9.879-9.879\r\n\t\t\t\tC20.664,47.578,21,46.829,21,46C21,44.343,19.657,43,18,43z M61,0H49c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879\r\n\t\t\t\tC43.336,16.422,43,17.172,43,18c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L58,10.243V15c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M32,23c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9\r\n\t\t\t\tC41,27.029,36.971,23,32,23z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43c-0.828,0-1.578,0.336-2.121,0.879L6,53.757V49c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l9.879-9.879\r\n\t\t\t\tC20.664,47.578,21,46.829,21,46C21,44.343,19.657,43,18,43z M61,0H49c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757l-9.879,9.879\r\n\t\t\t\tC43.336,16.422,43,17.172,43,18c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L58,10.243V15c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M32,23c-4.971,0-9,4.029-9,9c0,4.971,4.029,9,9,9c4.971,0,9-4.029,9-9\r\n\t\t\t\tC41,27.029,36.971,23,32,23z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_2_4_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_2_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L41,18.757V14\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757\r\n\t\t\t\tL60.121,8.121C60.664,7.579,61,6.828,61,6z M26,35H14c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L3.879,55.879\r\n\t\t\t\tC3.336,56.422,3,57.172,3,58c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L23,45.243V50c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,6c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L41,18.757V14\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757\r\n\t\t\t\tL60.121,8.121C60.664,7.579,61,6.828,61,6z M26,35H14c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L3.879,55.879\r\n\t\t\t\tC3.336,56.422,3,57.172,3,58c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L23,45.243V50c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_1_4_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_1_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35c-0.828,0-1.579,0.336-2.121,0.879L9,50.758V46c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l14.879-14.879\r\n\t\t\t\tC28.664,39.579,29,38.828,29,38C29,36.343,27.657,35,26,35z M58,3H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.879,23.879\r\n\t\t\t\tC35.336,24.422,35,25.172,35,26c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,13.243V18c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35c-0.828,0-1.579,0.336-2.121,0.879L9,50.758V46c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l14.879-14.879\r\n\t\t\t\tC28.664,39.579,29,38.828,29,38C29,36.343,27.657,35,26,35z M58,3H46c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L35.879,23.879\r\n\t\t\t\tC35.336,24.422,35,25.172,35,26c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,13.243V18c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COG_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COG","display":"inline"},"children":[{"name":"g","attribs":{"id":"COG","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,20c-6.627,0-12,5.372-12,12c0,6.627,5.372,12,12,12s12-5.373,12-12\r\n\t\t\t\tC44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C38,35.314,35.314,38,32,38z\r\n\t\t\t\t M55.517,25.462c-0.54-1.957-1.326-3.811-2.31-5.536c1.121-1.507,4.981-7.143,2.199-9.926l-1.428-1.507\r\n\t\t\t\tc-2.379-2.378-8.455,1.336-9.93,2.298c-1.745-0.989-3.62-1.774-5.6-2.31c-0.317-1.887-1.704-8.487-5.619-8.487h-1.567\r\n\t\t\t\tc-3.361,0-5.29,6.824-5.721,8.534c-1.952,0.545-3.801,1.334-5.522,2.32C18.661,9.839,12.841,5.816,10,8.656L8.493,9.924\r\n\t\t\t\tc-2.476,2.475,1.638,9.004,2.39,10.147c-0.952,1.698-1.715,3.517-2.241,5.435c-1.641,0.262-8.649,1.614-8.649,5.646v1.566\r\n\t\t\t\tc0,3.493,7.349,5.433,8.69,5.759c0.533,1.904,1.3,3.708,2.255,5.393c-0.791,1.24-4.745,7.74-2.292,10.194l1.427,1.188\r\n\t\t\t\tc3.229,3.229,9.974-2.075,9.974-2.075l-0.314-0.334c1.789,1.058,3.726,1.895,5.773,2.47c0.335,1.378,2.275,8.676,5.755,8.676\r\n\t\t\t\th1.567c4.566,0,5.698-8.52,5.698-8.52l-0.419-0.013c2.07-0.529,4.032-1.325,5.851-2.345c1.426,0.95,7.401,4.689,9.786,2.304\r\n\t\t\t\tl1.587-1.588c3.183-3.183-1.997-9.696-2.142-9.877c0.985-1.722,1.774-3.571,2.317-5.525c1.78-0.452,8.483-2.374,8.483-5.707\r\n\t\t\t\tv-1.566C63.989,26.73,56.015,25.533,55.517,25.462z M32,50c-9.941,0-18-8.059-18-18s8.059-18,18-18s18,8.059,18,18\r\n\t\t\t\tS41.941,50,32,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,20c-6.627,0-12,5.372-12,12c0,6.627,5.372,12,12,12s12-5.373,12-12\r\n\t\t\t\tC44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C38,35.314,35.314,38,32,38z\r\n\t\t\t\t M55.517,25.462c-0.54-1.957-1.326-3.811-2.31-5.536c1.121-1.507,4.981-7.143,2.199-9.926l-1.428-1.507\r\n\t\t\t\tc-2.379-2.378-8.455,1.336-9.93,2.298c-1.745-0.989-3.62-1.774-5.6-2.31c-0.317-1.887-1.704-8.487-5.619-8.487h-1.567\r\n\t\t\t\tc-3.361,0-5.29,6.824-5.721,8.534c-1.952,0.545-3.801,1.334-5.522,2.32C18.661,9.839,12.841,5.816,10,8.656L8.493,9.924\r\n\t\t\t\tc-2.476,2.475,1.638,9.004,2.39,10.147c-0.952,1.698-1.715,3.517-2.241,5.435c-1.641,0.262-8.649,1.614-8.649,5.646v1.566\r\n\t\t\t\tc0,3.493,7.349,5.433,8.69,5.759c0.533,1.904,1.3,3.708,2.255,5.393c-0.791,1.24-4.745,7.74-2.292,10.194l1.427,1.188\r\n\t\t\t\tc3.229,3.229,9.974-2.075,9.974-2.075l-0.314-0.334c1.789,1.058,3.726,1.895,5.773,2.47c0.335,1.378,2.275,8.676,5.755,8.676\r\n\t\t\t\th1.567c4.566,0,5.698-8.52,5.698-8.52l-0.419-0.013c2.07-0.529,4.032-1.325,5.851-2.345c1.426,0.95,7.401,4.689,9.786,2.304\r\n\t\t\t\tl1.587-1.588c3.183-3.183-1.997-9.696-2.142-9.877c0.985-1.722,1.774-3.571,2.317-5.525c1.78-0.452,8.483-2.374,8.483-5.707\r\n\t\t\t\tv-1.566C63.989,26.73,56.015,25.533,55.517,25.462z M32,50c-9.941,0-18-8.059-18-18s8.059-18,18-18s18,8.059,18,18\r\n\t\t\t\tS41.941,50,32,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"WARNING_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WARNING","display":"inline"},"children":[{"name":"g","attribs":{"id":"WARNING","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.563,53.463l0.017-0.011l-29-47l-0.017,0.01C34.039,5.59,33.092,5,32,5\r\n\t\t\t\tc-1.052,0-1.973,0.543-2.509,1.362l-0.017-0.01l-29,47l0.017,0.01C0.183,53.834,0,54.395,0,55c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.009,0,0.018-0.003,0.027-0.003v0.03h58v-0.03C62.671,57.982,64,56.648,64,55C64,54.435,63.835,53.914,63.563,53.463z M32,52\r\n\t\t\t\tc-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C36,50.209,34.209,52,32,52z M36,37c0,2.209-1.791,4-4,4s-4-1.791-4-4V22\r\n\t\t\t\tc0-2.209,1.791-4,4-4s4,1.791,4,4V37z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.563,53.463l0.017-0.011l-29-47l-0.017,0.01C34.039,5.59,33.092,5,32,5\r\n\t\t\t\tc-1.052,0-1.973,0.543-2.509,1.362l-0.017-0.01l-29,47l0.017,0.01C0.183,53.834,0,54.395,0,55c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.009,0,0.018-0.003,0.027-0.003v0.03h58v-0.03C62.671,57.982,64,56.648,64,55C64,54.435,63.835,53.914,63.563,53.463z M32,52\r\n\t\t\t\tc-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C36,50.209,34.209,52,32,52z M36,37c0,2.209-1.791,4-4,4s-4-1.791-4-4V22\r\n\t\t\t\tc0-2.209,1.791-4,4-4s4,1.791,4,4V37z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"REPEAT_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REPEAT_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"REPEAT_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,29c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26\r\n\t\t\t\tc-8.768,0-16.506-4.347-21.207-11H16c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-5.454C11.789,58.679,21.254,64,32,64c17.673,0,32-14.327,32-32C64,30.343,62.657,29,61,29z M61,5\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v5.412C52.204,5.299,42.733,0,32,0C14.327,0,0,14.327,0,32c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3\r\n\t\t\t\tC6,17.641,17.641,6,32,6c8.76,0,16.469,4.355,21.167,11H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8\r\n\t\t\t\tC64,6.343,62.657,5,61,5z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,29c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26\r\n\t\t\t\tc-8.768,0-16.506-4.347-21.207-11H16c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-5.454C11.789,58.679,21.254,64,32,64c17.673,0,32-14.327,32-32C64,30.343,62.657,29,61,29z M61,5\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v5.412C52.204,5.299,42.733,0,32,0C14.327,0,0,14.327,0,32c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3\r\n\t\t\t\tC6,17.641,17.641,6,32,6c8.76,0,16.469,4.355,21.167,11H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8\r\n\t\t\t\tC64,6.343,62.657,5,61,5z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"REPEAT_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REPEAT_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"REPEAT_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,20c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v5.39C52.199,5.288,42.725,0,32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c8.769,0,16.512,4.348,21.218,11H48C46.343,17,45,18.343,45,20z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,20c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3V8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v5.39C52.199,5.288,42.725,0,32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,14.359-11.641,26-26,26C17.641,58,6,46.359,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6c8.769,0,16.512,4.348,21.218,11H48C46.343,17,45,18.343,45,20z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.137,17.884l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,17H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,49H9v0H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,23H52v0.005h1.773l-1.879,1.879\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121C64.016,19.177,63.68,18.427,63.137,17.884z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.137,17.884l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,17H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,49H9v0H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,23H52v0.005h1.773l-1.879,1.879\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121C64.016,19.177,63.68,18.427,63.137,17.884z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.122,42.878l-6.998-7.001c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-2.999,1.343-2.999,3c0,0.829,0.336,1.579,0.879,2.122l1.878,1.879h-1.773v0.005h-2.999v0h-2.757L15.118,10.879\r\n\t\t\t\tC14.575,10.336,13.825,10,12.997,10H2.999C1.343,10,0,11.343,0,13.001c0,1.657,1.343,3,2.999,3h8.755l31.114,31.126\r\n\t\t\t\tc0.543,0.543,1.293,0.879,2.121,0.879h8.766l-1.873,1.874c-0.543,0.543-0.879,1.293-0.879,2.122c0,1.657,1.343,3,2.999,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l6.998-7.001C63.664,46.578,64,45.828,64,45C64,44.171,63.664,43.421,63.122,42.878z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.122,42.878l-6.998-7.001c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-2.999,1.343-2.999,3c0,0.829,0.336,1.579,0.879,2.122l1.878,1.879h-1.773v0.005h-2.999v0h-2.757L15.118,10.879\r\n\t\t\t\tC14.575,10.336,13.825,10,12.997,10H2.999C1.343,10,0,11.343,0,13.001c0,1.657,1.343,3,2.999,3h8.755l31.114,31.126\r\n\t\t\t\tc0.543,0.543,1.293,0.879,2.121,0.879h8.766l-1.873,1.874c-0.543,0.543-0.879,1.293-0.879,2.122c0,1.657,1.343,3,2.999,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l6.998-7.001C63.664,46.578,64,45.828,64,45C64,44.171,63.664,43.421,63.122,42.878z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHUFFLE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHUFFLE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHUFFLE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,19h8.757l10.879,10.879l4.243-4.243L15.121,13.879\r\n\t\t\t\tC14.578,13.336,13.828,13,13,13H3c-1.657,0-3,1.343-3,3S1.343,19,3,19z M52,19v0.005h1.773l-1.879,1.879\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121c0-0.828-0.336-1.578-0.879-2.121l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,13H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,45H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,19H52z M56.137,38.874\r\n\t\t\t\tc-0.543-0.543-1.293-0.879-2.121-0.879c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.879,1.879H52V45h-5.757\r\n\t\t\t\tL35.364,34.121l-4.243,4.242l11.757,11.758C43.422,50.664,44.172,51,45,51h8.768l-1.873,1.874\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121s-0.336-1.578-0.879-2.121L56.137,38.874z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,19h8.757l10.879,10.879l4.243-4.243L15.121,13.879\r\n\t\t\t\tC14.578,13.336,13.828,13,13,13H3c-1.657,0-3,1.343-3,3S1.343,19,3,19z M52,19v0.005h1.773l-1.879,1.879\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121c0-0.828-0.336-1.578-0.879-2.121l-7-7c-0.543-0.543-1.293-0.879-2.121-0.879\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,13H45c-0.828,0-1.578,0.336-2.121,0.879L11.757,45H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,19H52z M56.137,38.874\r\n\t\t\t\tc-0.543-0.543-1.293-0.879-2.121-0.879c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.879,1.879H52V45h-5.757\r\n\t\t\t\tL35.364,34.121l-4.243,4.242l11.757,11.758C43.422,50.664,44.172,51,45,51h8.768l-1.873,1.874\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121s-0.336-1.578-0.879-2.121L56.137,38.874z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_2_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_2_2_","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_2_2_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.843,55.914l0.003,0.003\r\n\t\t\t\tC3.325,56.457,3,57.19,3,58c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.847l0.003,0.003L23,45.243V50c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V38C29,36.343,27.657,35,26,35z M38,29h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.157,8.086l-0.003-0.003\r\n\t\t\t\tC60.676,7.543,61,6.81,61,6c0-1.657-1.343-3-3-3c-0.81,0-1.543,0.325-2.083,0.847l-0.003-0.003L41,18.758V14c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12C35,27.657,36.343,29,38,29z M60.157,55.914L45.243,41H50c1.657,0,3-1.343,3-3s-1.343-3-3-3H38\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003C56.457,60.676,57.19,61,58,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.81-0.325-1.543-0.847-2.083L60.157,55.914z M26,11c-1.657,0-3,1.343-3,3v4.757L8.086,3.843L8.083,3.847\r\n\t\t\t\tC7.543,3.325,6.81,3,6,3C4.343,3,3,4.343,3,6c0,0.81,0.325,1.543,0.847,2.082L3.843,8.086L18.757,23H14c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h12c1.657,0,3-1.343,3-3V14C29,12.343,27.657,11,26,11z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35H14c-1.657,0-3,1.343-3,3s1.343,3,3,3h4.757L3.843,55.914l0.003,0.003\r\n\t\t\t\tC3.325,56.457,3,57.19,3,58c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.847l0.003,0.003L23,45.243V50c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V38C29,36.343,27.657,35,26,35z M38,29h12c1.657,0,3-1.343,3-3s-1.343-3-3-3h-4.757L60.157,8.086l-0.003-0.003\r\n\t\t\t\tC60.676,7.543,61,6.81,61,6c0-1.657-1.343-3-3-3c-0.81,0-1.543,0.325-2.083,0.847l-0.003-0.003L41,18.758V14c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v12C35,27.657,36.343,29,38,29z M60.157,55.914L45.243,41H50c1.657,0,3-1.343,3-3s-1.343-3-3-3H38\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3s3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003C56.457,60.676,57.19,61,58,61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.81-0.325-1.543-0.847-2.083L60.157,55.914z M26,11c-1.657,0-3,1.343-3,3v4.757L8.086,3.843L8.083,3.847\r\n\t\t\t\tC7.543,3.325,6.81,3,6,3C4.343,3,3,4.343,3,6c0,0.81,0.325,1.543,0.847,2.082L3.843,8.086L18.757,23H14c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h12c1.657,0,3-1.343,3-3V14C29,12.343,27.657,11,26,11z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RESIZE_1_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RESIZE_1_2_","display":"inline"},"children":[{"name":"g","attribs":{"id":"RESIZE_1_2_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.157,23.914L13.243,9H18c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H6\r\n\t\t\t\tC4.343,3,3,4.343,3,6v12c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003\r\n\t\t\t\tC24.457,28.676,25.19,29,26,29c1.657,0,3-1.343,3-3c0-0.81-0.324-1.543-0.847-2.083L28.157,23.914z M26,35\r\n\t\t\t\tc-0.81,0-1.543,0.325-2.082,0.847l-0.003-0.003L9,50.757V46c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l14.914-14.914l-0.003-0.003C28.676,39.543,29,38.81,29,38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M58,43c-1.657,0-3,1.343-3,3v4.757L40.086,35.843l-0.003,0.003C39.543,35.325,38.81,35,38,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.81,0.324,1.543,0.847,2.083l-0.003,0.003L50.757,55H46c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C61,44.343,59.657,43,58,43z M58,3H46c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L35.843,23.914\r\n\t\t\t\tl0.003,0.003C35.325,24.457,35,25.19,35,26c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.083-0.847l0.003,0.003L55,13.243V18\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.157,23.914L13.243,9H18c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H6\r\n\t\t\t\tC4.343,3,3,4.343,3,6v12c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-4.757l14.914,14.914l0.003-0.003\r\n\t\t\t\tC24.457,28.676,25.19,29,26,29c1.657,0,3-1.343,3-3c0-0.81-0.324-1.543-0.847-2.083L28.157,23.914z M26,35\r\n\t\t\t\tc-0.81,0-1.543,0.325-2.082,0.847l-0.003-0.003L9,50.757V46c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4.757l14.914-14.914l-0.003-0.003C28.676,39.543,29,38.81,29,38\r\n\t\t\t\tC29,36.343,27.657,35,26,35z M58,43c-1.657,0-3,1.343-3,3v4.757L40.086,35.843l-0.003,0.003C39.543,35.325,38.81,35,38,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.81,0.324,1.543,0.847,2.083l-0.003,0.003L50.757,55H46c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3V46C61,44.343,59.657,43,58,43z M58,3H46c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757L35.843,23.914\r\n\t\t\t\tl0.003,0.003C35.325,24.457,35,25.19,35,26c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.083-0.847l0.003,0.003L55,13.243V18\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V6C61,4.343,59.657,3,58,3z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROWS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROWS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC52.475,20.292,51.772,20,51,20c-1.657,0-3,1.343-3,3c0,0.885,0.384,1.681,0.993,2.23l0,0L53.182,29H35V10.818l3.77,4.189l0,0\r\n\t\t\t\tC39.319,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,0.384,32.885,0,32,0\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.68-0.384,2.23-0.993l0,0L29,10.818V29H10.818l4.189-3.77l0,0C15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32c0,0.885,0.384,1.68,0.993,2.23l0,0l10,9l0,0\r\n\t\t\t\tC11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.384-1.68-0.993-2.23l0,0L10.818,35H29v18.182l-3.77-4.189l0,0\r\n\t\t\t\tC24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.772,0.292,1.475,0.77,2.007l0,0l9,10l0,0\r\n\t\t\t\tC30.319,63.617,31.115,64,32,64c0.885,0,1.681-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.772,44,51c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0L35,53.182V35h18.182l-4.189,3.77l0,0C48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.772,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.681,64,32.885,64,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC52.475,20.292,51.772,20,51,20c-1.657,0-3,1.343-3,3c0,0.885,0.384,1.681,0.993,2.23l0,0L53.182,29H35V10.818l3.77,4.189l0,0\r\n\t\t\t\tC39.319,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,0.384,32.885,0,32,0\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.68-0.384,2.23-0.993l0,0L29,10.818V29H10.818l4.189-3.77l0,0C15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32c0,0.885,0.384,1.68,0.993,2.23l0,0l10,9l0,0\r\n\t\t\t\tC11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.384-1.68-0.993-2.23l0,0L10.818,35H29v18.182l-3.77-4.189l0,0\r\n\t\t\t\tC24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3c0,0.772,0.292,1.475,0.77,2.007l0,0l9,10l0,0\r\n\t\t\t\tC30.319,63.617,31.115,64,32,64c0.885,0,1.681-0.383,2.23-0.993l0,0l9-10l0,0C43.708,52.475,44,51.772,44,51c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0L35,53.182V35h18.182l-4.189,3.77l0,0C48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.772,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C63.617,33.681,64,32.885,64,32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROWS_HORIZONTAL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,32c0-0.885-0.384-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC52.475,20.292,51.772,20,51,20c-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L53.182,29H10.818l4.189-3.77l0,0\r\n\t\t\t\tC15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3c-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32\r\n\t\t\t\tc0,0.885,0.383,1.68,0.993,2.23l0,0l10,9l0,0C11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.383-1.68-0.993-2.23\r\n\t\t\t\tl0,0L10.818,35h42.364l-4.189,3.77l0,0C48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0\r\n\t\t\t\tl10-9l0,0C63.617,33.681,64,32.885,64,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,32c0-0.885-0.384-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC52.475,20.292,51.772,20,51,20c-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L53.182,29H10.818l4.189-3.77l0,0\r\n\t\t\t\tC15.617,24.681,16,23.885,16,23c0-1.657-1.343-3-3-3c-0.772,0-1.475,0.292-2.007,0.77l0,0l-10,9l0,0C0.384,30.319,0,31.115,0,32\r\n\t\t\t\tc0,0.885,0.383,1.68,0.993,2.23l0,0l10,9l0,0C11.525,43.709,12.228,44,13,44c1.657,0,3-1.343,3-3c0-0.885-0.383-1.68-0.993-2.23\r\n\t\t\t\tl0,0L10.818,35h42.364l-4.189,3.77l0,0C48.384,39.32,48,40.115,48,41c0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0\r\n\t\t\t\tl10-9l0,0C63.617,33.681,64,32.885,64,32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROWS_VERTICAL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS_VERTICAL","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROWS_VERTICAL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,48c-0.885,0-1.681,0.384-2.23,0.993l0,0L35,53.182V10.818l3.77,4.189l0,0\r\n\t\t\t\tC39.319,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,0.384,32.885,0,32,0\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.681-0.384,2.23-0.993l0,0L29,10.818v42.364l-3.77-4.189l0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.772,0.292,1.475,0.77,2.007l0,0l9,10l0,0C30.319,63.617,31.115,64,32,64c0.885,0,1.681-0.383,2.23-0.993l0,0l9-10l0,0\r\n\t\t\t\tC43.708,52.475,44,51.772,44,51C44,49.343,42.657,48,41,48z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,48c-0.885,0-1.681,0.384-2.23,0.993l0,0L35,53.182V10.818l3.77,4.189l0,0\r\n\t\t\t\tC39.319,15.616,40.115,16,41,16c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,0.384,32.885,0,32,0\r\n\t\t\t\tc-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,11.525,20,12.228,20,13c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.681-0.384,2.23-0.993l0,0L29,10.818v42.364l-3.77-4.189l0,0C24.681,48.384,23.885,48,23,48c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.772,0.292,1.475,0.77,2.007l0,0l9,10l0,0C30.319,63.617,31.115,64,32,64c0.885,0,1.681-0.383,2.23-0.993l0,0l9-10l0,0\r\n\t\t\t\tC43.708,52.475,44,51.772,44,51C44,49.343,42.657,48,41,48z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__VERTICAL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M57,51c0-1.657-1.343-3-3-3c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007\r\n\t\t\t\tL48,53.182V29c0,0,0,0,0,0V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v7.818l0,0V26h0v13h0v14.182l-3.77-4.189L38.222,49\r\n\t\t\t\tc-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3c0,0.772,0.3,1.468,0.778,2l-0.008,0.007l9,10L42.778,63\r\n\t\t\t\tc0.549,0.61,1.337,1,2.222,1c0.885,0,1.672-0.391,2.222-1l0.008,0.007l9-10L56.222,53C56.701,52.468,57,51.772,57,51z\r\n\t\t\t\t M30.23,10.993l-9-10l-0.008,0.007C20.673,0.391,19.885,0,19,0c-0.885,0-1.673,0.391-2.222,1.001L16.77,0.993l-9,10l0.008,0.007\r\n\t\t\t\tC7.3,11.532,7,12.228,7,13c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L16,10.818V25h0v13h0v15.182h0V61\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V29c0,0,0,0,0,0V10.818l3.77,4.189L25.778,15c0.549,0.61,1.337,1,2.222,1\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.778-2L30.23,10.993z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M57,51c0-1.657-1.343-3-3-3c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007\r\n\t\t\t\tL48,53.182V29c0,0,0,0,0,0V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v7.818l0,0V26h0v13h0v14.182l-3.77-4.189L38.222,49\r\n\t\t\t\tc-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3c0,0.772,0.3,1.468,0.778,2l-0.008,0.007l9,10L42.778,63\r\n\t\t\t\tc0.549,0.61,1.337,1,2.222,1c0.885,0,1.672-0.391,2.222-1l0.008,0.007l9-10L56.222,53C56.701,52.468,57,51.772,57,51z\r\n\t\t\t\t M30.23,10.993l-9-10l-0.008,0.007C20.673,0.391,19.885,0,19,0c-0.885,0-1.673,0.391-2.222,1.001L16.77,0.993l-9,10l0.008,0.007\r\n\t\t\t\tC7.3,11.532,7,12.228,7,13c0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L16,10.818V25h0v13h0v15.182h0V61\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V29c0,0,0,0,0,0V10.818l3.77,4.189L25.778,15c0.549,0.61,1.337,1,2.222,1\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.772-0.299-1.468-0.778-2L30.23,10.993z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROWS__x2F__HORIZONTAL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,22h32c0,0,0,0,0,0h18.182l-4.189,3.77L49,25.779\r\n\t\t\t\tc-0.61,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3c0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222\r\n\t\t\t\tc0.61-0.549,1-1.337,1-2.222c0-0.885-0.391-1.673-1-2.222l0.007-0.008l-10-9L53,7.778C52.468,7.3,51.772,7,51,7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39v0H26v0H10.818l0,0H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC0,20.657,1.343,22,3,22z M61,42h-7.818l0,0H38v0H25v0H10.818l4.189-3.77L15,38.222c0.61-0.549,1-1.336,1-2.222\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L1,42.778C0.391,43.328,0,44.115,0,45\r\n\t\t\t\tc0,0.885,0.391,1.672,1,2.222L0.993,47.23l10,9L11,56.222C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.222l0.007-0.008L10.818,48H35c0,0,0,0,0,0h26c1.657,0,3-1.343,3-3C64,43.343,62.657,42,61,42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,22h32c0,0,0,0,0,0h18.182l-4.189,3.77L49,25.779\r\n\t\t\t\tc-0.61,0.549-1,1.336-1,2.222c0,1.657,1.343,3,3,3c0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9L63,21.222\r\n\t\t\t\tc0.61-0.549,1-1.337,1-2.222c0-0.885-0.391-1.673-1-2.222l0.007-0.008l-10-9L53,7.778C52.468,7.3,51.772,7,51,7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L53.182,16H39v0H26v0H10.818l0,0H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC0,20.657,1.343,22,3,22z M61,42h-7.818l0,0H38v0H25v0H10.818l4.189-3.77L15,38.222c0.61-0.549,1-1.336,1-2.222\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L1,42.778C0.391,43.328,0,44.115,0,45\r\n\t\t\t\tc0,0.885,0.391,1.672,1,2.222L0.993,47.23l10,9L11,56.222C11.532,56.701,12.229,57,13,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.885-0.391-1.673-1-2.222l0.007-0.008L10.818,48H35c0,0,0,0,0,0h26c1.657,0,3-1.343,3-3C64,43.343,62.657,42,61,42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHARE_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHARE_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHARE_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23,16c0.885,0,1.673-0.39,2.222-1l0.008,0.007L29,10.818V29\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V10.818l3.77,4.189L38.778,15c0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.299-1.468-0.778-2l0.008-0.007l-9-10L34.222,1C33.673,0.391,32.885,0,32,0c-0.885,0-1.673,0.39-2.222,1L29.77,0.993\r\n\t\t\t\tl-9,10L20.778,11C20.3,11.532,20,12.228,20,13C20,14.657,21.343,16,23,16z M51,20H38v6h10v32H16V26h9v-6H13c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V23C54,21.343,52.657,20,51,20z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23,16c0.885,0,1.673-0.39,2.222-1l0.008,0.007L29,10.818V29\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V10.818l3.77,4.189L38.778,15c0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.299-1.468-0.778-2l0.008-0.007l-9-10L34.222,1C33.673,0.391,32.885,0,32,0c-0.885,0-1.673,0.39-2.222,1L29.77,0.993\r\n\t\t\t\tl-9,10L20.778,11C20.3,11.532,20,12.228,20,13C20,14.657,21.343,16,23,16z M51,20H38v6h10v32H16V26h9v-6H13c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv38c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V23C54,21.343,52.657,20,51,20z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHARE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHARE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHARE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,26.168V52H12V12h25.832C37.317,11.114,37,10.098,37,9\r\n\t\t\t\tc0-1.099,0.317-2.114,0.832-3H9C7.343,6,6,7.343,6,9v46c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V26.168\r\n\t\t\t\tC57.114,26.683,56.099,27,55,27C53.902,27,52.886,26.683,52,26.168z M55,6H43c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757\r\n\t\t\t\tL32.843,26.914l0.003,0.003C32.325,27.457,32,28.19,32,29c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.847l0.003,0.003\r\n\t\t\t\tL52,16.243V21c0,1.657,1.343,3,2.999,3h0.001C56.657,24,58,22.657,58,21V9C58,7.343,56.657,6,55,6z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,26.168V52H12V12h25.832C37.317,11.114,37,10.098,37,9\r\n\t\t\t\tc0-1.099,0.317-2.114,0.832-3H9C7.343,6,6,7.343,6,9v46c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V26.168\r\n\t\t\t\tC57.114,26.683,56.099,27,55,27C53.902,27,52.886,26.683,52,26.168z M55,6H43c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h4.757\r\n\t\t\t\tL32.843,26.914l0.003,0.003C32.325,27.457,32,28.19,32,29c0,1.657,1.343,3,3,3c0.81,0,1.543-0.325,2.082-0.847l0.003,0.003\r\n\t\t\t\tL52,16.243V21c0,1.657,1.343,3,2.999,3h0.001C56.657,24,58,22.657,58,21V9C58,7.343,56.657,6,55,6z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SCREEN_EXPAND_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3s-1.343-3-3-3H3\r\n\t\t\t\tC1.343,0,0,1.343,0,3v12c0,0,0,0,0,0C0,16.657,1.343,18,3,18z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,46c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M15,58H6v-9\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M61,0H49\r\n\t\t\t\tc0,0,0,0,0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3v0h9v9c0,0,0,0,0,0c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3s-1.343-3-3-3H3\r\n\t\t\t\tC1.343,0,0,1.343,0,3v12c0,0,0,0,0,0C0,16.657,1.343,18,3,18z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,46c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M15,58H6v-9\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M61,0H49\r\n\t\t\t\tc0,0,0,0,0,0c-1.657,0-3,1.343-3,3s1.343,3,3,3v0h9v9c0,0,0,0,0,0c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SCREEN_EXPAND_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,6c1.657,0,3-1.343,3-3s-1.343-3-3-3c0,0,0,0,0,0H3C1.343,0,0,1.343,0,3v12\r\n\t\t\t\tc0,0,0,0,0,0c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V6L15,6L15,6z M64,49c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3L64,49L64,49z M55,9H9v46h46V9z M49,49H15V15\r\n\t\t\t\th34V49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,6c1.657,0,3-1.343,3-3s-1.343-3-3-3c0,0,0,0,0,0H3C1.343,0,0,1.343,0,3v12\r\n\t\t\t\tc0,0,0,0,0,0c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V6L15,6L15,6z M64,49c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3L64,49L64,49z M55,9H9v46h46V9z M49,49H15V15\r\n\t\t\t\th34V49z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SCREEN_EXPAND_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"SCREEN_EXPAND_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3\r\n\t\t\t\th12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,0H49c0,0,0,0,0,0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3v0h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3\r\n\t\t\t\th12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M9,55h46V9H9V55z M15,15h34v34H15V15z M61,0H49c0,0,0,0,0,0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3v0h9v9c0,1.657,1.343,3,3,3s3-1.343,3-3V3C64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"IMAGE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IMAGE","display":"inline"},"children":[{"name":"g","attribs":{"id":"IMAGE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,15L40,15l9,0v9c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3c0,0,0,0,0,0V13h0\r\n\t\t\t\tV9H40c-1.657,0-3,1.343-3,3S38.343,15,40,15z M40,55h15v-4h0V40c0,0,0,0,0,0c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v9h-9v0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C37,53.657,38.343,55,40,55z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M24,55c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3v0h-9v-9h0c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3c0,0,0,0,0,0v11h0v4H24C24,55,24,55,24,55z M9,24c0,1.657,1.343,3,3,3s3-1.343,3-3h0v-9h9v0c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3c0,0,0,0,0,0H9v4h0L9,24C9,24,9,24,9,24z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,15L40,15l9,0v9c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3c0,0,0,0,0,0V13h0\r\n\t\t\t\tV9H40c-1.657,0-3,1.343-3,3S38.343,15,40,15z M40,55h15v-4h0V40c0,0,0,0,0,0c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v9h-9v0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C37,53.657,38.343,55,40,55z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M24,55c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3v0h-9v-9h0c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3c0,0,0,0,0,0v11h0v4H24C24,55,24,55,24,55z M9,24c0,1.657,1.343,3,3,3s3-1.343,3-3h0v-9h9v0c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3c0,0,0,0,0,0H9v4h0L9,24C9,24,9,24,9,24z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243\r\n\t\t\t\tl8.879,8.879C41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878\r\n\t\t\t\tC45.664,22.579,46,21.829,46,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879\r\n\t\t\t\tC22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879\r\n\t\t\t\tC18.336,41.422,18,42.172,18,43z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M18,43c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243\r\n\t\t\t\tl8.879,8.879C41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878\r\n\t\t\t\tC45.664,22.579,46,21.829,46,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879\r\n\t\t\t\tC22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879\r\n\t\t\t\tC18.336,41.422,18,42.172,18,43z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SQUARE__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,20.999v0.002C46,21.001,46,21.001,46,20.999C46,21,46,21,46,20.999z\r\n\t\t\t\t M46,43.001C46,43.001,46,43,46,43.001C46,43,46,43,46,42.999V43.001z M25.879,42.121C26.422,42.664,27.172,43,28,43\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l16-16C46.664,25.579,47,24.828,47,24c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL28,35.757l-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L25.879,42.121z\r\n\t\t\t\t M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,20.999v0.002C46,21.001,46,21.001,46,20.999C46,21,46,21,46,20.999z\r\n\t\t\t\t M46,43.001C46,43.001,46,43,46,43.001C46,43,46,43,46,42.999V43.001z M25.879,42.121C26.422,42.664,27.172,43,28,43\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l16-16C46.664,25.579,47,24.828,47,24c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL28,35.757l-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L25.879,42.121z\r\n\t\t\t\t M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M19,35h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC16,33.657,17.343,35,19,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M19,35h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC16,33.657,17.343,35,19,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SQUARE__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19,35h10v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h10\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35V19c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC16,33.657,17.343,35,19,35z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M19,35h10v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h10\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35V19c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC16,33.657,17.343,35,19,35z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"GRID_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GRID_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"GRID_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tV38C29,36.343,27.657,35,26,35z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC29,4.343,27.657,3,26,3z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC61,4.343,59.657,3,58,3z M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38\r\n\t\t\t\tC61,36.343,59.657,35,58,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tV38C29,36.343,27.657,35,26,35z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC29,4.343,27.657,3,26,3z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC61,4.343,59.657,3,58,3z M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3V38\r\n\t\t\t\tC61,36.343,59.657,35,58,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"GRID_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GRID_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"GRID_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tV38C61,36.343,59.657,35,58,35z M55,55H41V41h14V55z M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M23,55H9V41h14V55z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\th20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M55,23H41V9h14V23z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M23,23H9V9h14V23z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,35H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tV38C61,36.343,59.657,35,58,35z M55,55H41V41h14V55z M26,35H6c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C29,36.343,27.657,35,26,35z M23,55H9V41h14V55z M58,3H38c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\th20c1.657,0,3-1.343,3-3V6C61,4.343,59.657,3,58,3z M55,23H41V9h14V23z M26,3H6C4.343,3,3,4.343,3,6v20c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C29,4.343,27.657,3,26,3z M23,23H9V9h14V23z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"UNLOCK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"UNLOCK","display":"inline"},"children":[{"name":"g","attribs":{"id":"UNLOCK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,32H20V18c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6\r\n\t\t\t\tC38,46.215,36.786,48.129,35,49.168z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,32H20V18c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6\r\n\t\t\t\tC38,46.215,36.786,48.129,35,49.168z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LOCK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOCK","display":"inline"},"children":[{"name":"g","attribs":{"id":"LOCK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,32h-5V18c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tC38,46.215,36.786,48.129,35,49.168z M44,32H20V18c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12V32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,32h-5V18c0-9.941-8.059-18-18-18c-9.941,0-18,8.059-18,18v14H9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35C58,33.343,56.657,32,55,32z M35,49.168V55\r\n\t\t\t\tc0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tC38,46.215,36.786,48.129,35,49.168z M44,32H20V18c0-6.627,5.373-12,12-12c6.627,0,12,5.373,12,12V32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"INBOX__x2F__OUT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__OUT","display":"inline"},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__OUT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,18c0.828,0,1.578-0.336,2.121-0.879L29,15.243V34c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V15.243l1.879,1.879C37.422,17.664,38.172,18,39,18c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121\r\n\t\t\t\tl-7-7C33.578,5.336,32.829,5,32,5c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,13.422,22,14.172,22,15\r\n\t\t\t\tC22,16.657,23.343,18,25,18z M63.8,36.924l-7.978-20.941C55.406,14.827,54.3,14,53,14h-8.101C44.954,14.327,45,14.658,45,15\r\n\t\t\t\tc0,2.09-1.071,3.926-2.691,5h8.623l5.714,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h8.623\r\n\t\t\t\tC20.071,18.926,19,17.09,19,15c0-0.342,0.046-0.673,0.101-1H11c0,0,0,0,0,0c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924\r\n\t\t\t\tC0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38C64,37.621,63.929,37.258,63.8,36.924z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,18c0.828,0,1.578-0.336,2.121-0.879L29,15.243V34c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V15.243l1.879,1.879C37.422,17.664,38.172,18,39,18c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121\r\n\t\t\t\tl-7-7C33.578,5.336,32.829,5,32,5c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,13.422,22,14.172,22,15\r\n\t\t\t\tC22,16.657,23.343,18,25,18z M63.8,36.924l-7.978-20.941C55.406,14.827,54.3,14,53,14h-8.101C44.954,14.327,45,14.658,45,15\r\n\t\t\t\tc0,2.09-1.071,3.926-2.691,5h8.623l5.714,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353l5.714-15h8.623\r\n\t\t\t\tC20.071,18.926,19,17.09,19,15c0-0.342,0.046-0.673,0.101-1H11c0,0,0,0,0,0c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924\r\n\t\t\t\tC0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V38C64,37.621,63.929,37.258,63.8,36.924z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"INBOX__x2F__IN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__IN","display":"inline"},"children":[{"name":"g","attribs":{"id":"INBOX__x2F__IN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,27c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,36.664,31.172,37,32,37\r\n\t\t\t\ts1.578-0.336,2.121-0.879l7-7C41.664,28.579,42,27.828,42,27c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,26.758V8\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v18.757l-1.879-1.879C26.578,24.336,25.829,24,25,24C23.343,24,22,25.343,22,27z M63.8,36.924\r\n\t\t\t\tl-7.978-20.941C55.406,14.827,54.3,14,53,14H38v6h12.932l5.714,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353\r\n\t\t\t\tl5.714-15H26v-6H11c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C64,37.621,63.929,37.258,63.8,36.924z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,27c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,36.664,31.172,37,32,37\r\n\t\t\t\ts1.578-0.336,2.121-0.879l7-7C41.664,28.579,42,27.828,42,27c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,26.758V8\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v18.757l-1.879-1.879C26.578,24.336,25.829,24,25,24C23.343,24,22,25.343,22,27z M63.8,36.924\r\n\t\t\t\tl-7.978-20.941C55.406,14.827,54.3,14,53,14H38v6h12.932l5.714,15H47c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353\r\n\t\t\t\tl5.714-15H26v-6H11c-1.3,0-2.406,0.827-2.823,1.982L0.2,36.924C0.071,37.258,0,37.621,0,38v19c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V38C64,37.621,63.929,37.258,63.8,36.924z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"INBOX_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"INBOX","display":"inline"},"children":[{"name":"g","attribs":{"id":"INBOX","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.796,31.935l0.007-0.003l-8-21l-0.007,0.003C55.366,9.806,54.28,9,53,9H11\r\n\t\t\t\tc-1.28,0-2.365,0.806-2.796,1.935l-0.007-0.003l-8,21l0.007,0.003C0.077,32.267,0,32.624,0,33v19c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V33C64,32.624,63.923,32.267,63.796,31.935z M47,30c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353\r\n\t\t\t\tl5.714-15h37.865l5.714,15H47z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.796,31.935l0.007-0.003l-8-21l-0.007,0.003C55.366,9.806,54.28,9,53,9H11\r\n\t\t\t\tc-1.28,0-2.365,0.806-2.796,1.935l-0.007-0.003l-8,21l0.007,0.003C0.077,32.267,0,32.624,0,33v19c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V33C64,32.624,63.923,32.267,63.796,31.935z M47,30c-1.657,0-3,1.343-3,3v3H20v-3c0-1.657-1.343-3-3-3H7.353\r\n\t\t\t\tl5.714-15h37.865l5.714,15H47z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SLIDESHOW_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SLIDESHOW","display":"inline"},"children":[{"name":"g","attribs":{"id":"SLIDESHOW","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC15,19.343,13.657,18,12,18z M3,12c-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V15C6,13.343,4.657,12,3,12z\r\n\t\t\t\t M52,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V21C55,19.343,53.657,18,52,18z M61,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V15C64,13.343,62.657,12,61,12z M43,18H21\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21C46,19.343,44.657,18,43,18z M40,40H24V24h16V40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC15,19.343,13.657,18,12,18z M3,12c-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V15C6,13.343,4.657,12,3,12z\r\n\t\t\t\t M52,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V21C55,19.343,53.657,18,52,18z M61,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V15C64,13.343,62.657,12,61,12z M43,18H21\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21C46,19.343,44.657,18,43,18z M40,40H24V24h16V40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOICEMAIL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOICEMAIL","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOICEMAIL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,18c-7.732,0-14,6.268-14,14c0,2.977,0.936,5.731,2.52,8H25.48\r\n\t\t\t\tc1.584-2.269,2.52-5.023,2.52-8c0-7.732-6.268-14-14-14S0,24.268,0,32s6.268,14,14,14h36c7.732,0,14-6.268,14-14S57.732,18,50,18\r\n\t\t\t\tz M14,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S18.418,40,14,40z M50,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8\r\n\t\t\t\tS54.418,40,50,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,18c-7.732,0-14,6.268-14,14c0,2.977,0.936,5.731,2.52,8H25.48\r\n\t\t\t\tc1.584-2.269,2.52-5.023,2.52-8c0-7.732-6.268-14-14-14S0,24.268,0,32s6.268,14,14,14h36c7.732,0,14-6.268,14-14S57.732,18,50,18\r\n\t\t\t\tz M14,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S18.418,40,14,40z M50,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8\r\n\t\t\t\tS54.418,40,50,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CREDIT_CARD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CREDIT_CARD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CREDIT_CARD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,51c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V28H0V51z M6,39h30v3H6V39z\r\n\t\t\t\t M6,45h12v3H6V45z M61,10H3c-1.657,0-3,1.343-3,3v9h64v-9C64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,51c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V28H0V51z M6,39h30v3H6V39z\r\n\t\t\t\t M6,45h12v3H6V45z M61,10H3c-1.657,0-3,1.343-3,3v9h64v-9C64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"HOME_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HOME","display":"inline"},"children":[{"name":"g","attribs":{"id":"HOME","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6,39v21c0,1.657,1.343,3,3,3h28V39h12v24h6c1.657,0,3-1.343,3-3V39L32,13L6,39\r\n\t\t\t\tz M27,51H15V39h12V51z M63.189,31.96l0.007-0.007L52,20.757V12c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v2.757L34.196,2.953\r\n\t\t\t\tl-0.002,0.002c-0.478-0.512-1.132-0.857-1.866-0.937c-0.003,0-0.006-0.001-0.009-0.001c-0.045-0.005-0.09-0.008-0.135-0.011\r\n\t\t\t\tc-0.008,0-0.017-0.001-0.025-0.002C32.107,2.002,32.054,2,32.001,2C32.001,2,32,2,32,2c-0.85,0-1.616,0.354-2.162,0.922\r\n\t\t\t\tL0.922,31.838C0.354,32.384,0,33.15,0,34c0,1.657,1.343,3,3,3c0.821,0,1.565-0.33,2.106-0.864l0.001,0.001L32,9.245v0.001\r\n\t\t\t\tl0.077,0.072l0,0.002l26.877,26.877l0.007-0.007C59.496,36.688,60.21,37,61,37c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,33.21,63.688,32.496,63.189,31.96z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6,39v21c0,1.657,1.343,3,3,3h28V39h12v24h6c1.657,0,3-1.343,3-3V39L32,13L6,39\r\n\t\t\t\tz M27,51H15V39h12V51z M63.189,31.96l0.007-0.007L52,20.757V12c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v2.757L34.196,2.953\r\n\t\t\t\tl-0.002,0.002c-0.478-0.512-1.132-0.857-1.866-0.937c-0.003,0-0.006-0.001-0.009-0.001c-0.045-0.005-0.09-0.008-0.135-0.011\r\n\t\t\t\tc-0.008,0-0.017-0.001-0.025-0.002C32.107,2.002,32.054,2,32.001,2C32.001,2,32,2,32,2c-0.85,0-1.616,0.354-2.162,0.922\r\n\t\t\t\tL0.922,31.838C0.354,32.384,0,33.15,0,34c0,1.657,1.343,3,3,3c0.821,0,1.565-0.33,2.106-0.864l0.001,0.001L32,9.245v0.001\r\n\t\t\t\tl0.077,0.072l0,0.002l26.877,26.877l0.007-0.007C59.496,36.688,60.21,37,61,37c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,33.21,63.688,32.496,63.189,31.96z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SUITCASE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SUITCASE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SUITCASE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,21v37c0,1.657,1.343,3,3,3h5V18H3C1.343,18,0,19.343,0,21z M32,3\r\n\t\t\t\tc-8.284,0-15,6.716-15,15h-6v43h42V18h-6C47,9.716,40.284,3,32,3z M23,18c0-4.971,4.029-9,9-9c4.971,0,9,4.029,9,9H23z M61,18h-5\r\n\t\t\t\tv43h5c1.657,0,3-1.343,3-3V21C64,19.343,62.657,18,61,18z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,21v37c0,1.657,1.343,3,3,3h5V18H3C1.343,18,0,19.343,0,21z M32,3\r\n\t\t\t\tc-8.284,0-15,6.716-15,15h-6v43h42V18h-6C47,9.716,40.284,3,32,3z M23,18c0-4.971,4.029-9,9-9c4.971,0,9,4.029,9,9H23z M61,18h-5\r\n\t\t\t\tv43h5c1.657,0,3-1.343,3-3V21C64,19.343,62.657,18,61,18z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TAGS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TAGS","display":"inline"},"children":[{"name":"g","attribs":{"id":"TAGS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56.113,26.872l-5.133-4.91c-0.005,0.009-0.011,0.019-0.016,0.028L34.126,5.884\r\n\t\t\t\tC33.582,5.338,32.831,5,32,5c-0.003,0-0.005,0.001-0.008,0.001V4.993H13V5c-1.657,0-3,1.343-3,3h22l24.081,23.155L56.3,30.9\r\n\t\t\t\tl0.002,0.001C56.731,30.383,57,29.726,57,29C57,28.168,56.66,27.415,56.113,26.872z M54.997,35.951\r\n\t\t\t\tc-0.001-0.087-0.004-0.174-0.013-0.259c-0.002-0.016-0.005-0.031-0.007-0.046c-0.01-0.085-0.022-0.17-0.039-0.253\r\n\t\t\t\tc0-0.002-0.001-0.003-0.001-0.004c-0.123-0.594-0.422-1.123-0.84-1.531L31.126,11.884C30.582,11.338,29.831,11,29,11\r\n\t\t\t\tc-0.003,0-0.005,0.001-0.008,0.001v-0.008H10V11c-1.657,0-3,1.343-3,3H6.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196\r\n\t\t\t\tl-0.011,0.012l25,23l0.005-0.005c0.395,0.347,0.88,0.593,1.418,0.694c0.022,0.004,0.046,0.007,0.068,0.01\r\n\t\t\t\tc0.067,0.011,0.134,0.022,0.202,0.029C34.806,58.995,34.902,59,35,59c0.916,0,1.734-0.411,2.284-1.058l0.001,0.001l17-20\r\n\t\t\t\tl-0.001-0.001C54.73,37.418,55,36.741,55,36C55,35.984,54.998,35.968,54.997,35.951z M15,23c-2.209,0-4-1.791-4-4\r\n\t\t\t\tc0-2.209,1.791-4,4-4c2.209,0,4,1.791,4,4C19,21.209,17.209,23,15,23z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56.113,26.872l-5.133-4.91c-0.005,0.009-0.011,0.019-0.016,0.028L34.126,5.884\r\n\t\t\t\tC33.582,5.338,32.831,5,32,5c-0.003,0-0.005,0.001-0.008,0.001V4.993H13V5c-1.657,0-3,1.343-3,3h22l24.081,23.155L56.3,30.9\r\n\t\t\t\tl0.002,0.001C56.731,30.383,57,29.726,57,29C57,28.168,56.66,27.415,56.113,26.872z M54.997,35.951\r\n\t\t\t\tc-0.001-0.087-0.004-0.174-0.013-0.259c-0.002-0.016-0.005-0.031-0.007-0.046c-0.01-0.085-0.022-0.17-0.039-0.253\r\n\t\t\t\tc0-0.002-0.001-0.003-0.001-0.004c-0.123-0.594-0.422-1.123-0.84-1.531L31.126,11.884C30.582,11.338,29.831,11,29,11\r\n\t\t\t\tc-0.003,0-0.005,0.001-0.008,0.001v-0.008H10V11c-1.657,0-3,1.343-3,3H6.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196\r\n\t\t\t\tl-0.011,0.012l25,23l0.005-0.005c0.395,0.347,0.88,0.593,1.418,0.694c0.022,0.004,0.046,0.007,0.068,0.01\r\n\t\t\t\tc0.067,0.011,0.134,0.022,0.202,0.029C34.806,58.995,34.902,59,35,59c0.916,0,1.734-0.411,2.284-1.058l0.001,0.001l17-20\r\n\t\t\t\tl-0.001-0.001C54.73,37.418,55,36.741,55,36C55,35.984,54.998,35.968,54.997,35.951z M15,23c-2.209,0-4-1.791-4-4\r\n\t\t\t\tc0-2.209,1.791-4,4-4c2.209,0,4,1.791,4,4C19,21.209,17.209,23,15,23z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TAG_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TAG","display":"inline"},"children":[{"name":"g","attribs":{"id":"TAG","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,33c0-0.017-0.002-0.033-0.003-0.049c-0.001-0.087-0.004-0.174-0.013-0.258\r\n\t\t\t\tc-0.001-0.016-0.005-0.031-0.007-0.046c-0.01-0.085-0.022-0.17-0.039-0.253c0-0.002-0.001-0.003-0.001-0.005\r\n\t\t\t\tc-0.123-0.594-0.422-1.123-0.84-1.531L32.126,8.884C31.582,8.338,30.831,8,30,8c-0.003,0-0.005,0.001-0.008,0.001V7.993H11V8\r\n\t\t\t\tc-1.657,0-3,1.343-3,3H7.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.005-0.005\r\n\t\t\t\tc0.395,0.347,0.88,0.592,1.418,0.694c0.022,0.004,0.046,0.007,0.068,0.01c0.067,0.011,0.134,0.022,0.202,0.029\r\n\t\t\t\tC35.806,55.995,35.902,56,36,56c0.916,0,1.734-0.411,2.284-1.058l0.001,0.001l17-20l-0.001-0.001C55.73,34.418,56,33.741,56,33z\r\n\t\t\t\t M16,20c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C20,18.209,18.209,20,16,20z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,33c0-0.017-0.002-0.033-0.003-0.049c-0.001-0.087-0.004-0.174-0.013-0.258\r\n\t\t\t\tc-0.001-0.016-0.005-0.031-0.007-0.046c-0.01-0.085-0.022-0.17-0.039-0.253c0-0.002-0.001-0.003-0.001-0.005\r\n\t\t\t\tc-0.123-0.594-0.422-1.123-0.84-1.531L32.126,8.884C31.582,8.338,30.831,8,30,8c-0.003,0-0.005,0.001-0.008,0.001V7.993H11V8\r\n\t\t\t\tc-1.657,0-3,1.343-3,3H7.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.005-0.005\r\n\t\t\t\tc0.395,0.347,0.88,0.592,1.418,0.694c0.022,0.004,0.046,0.007,0.068,0.01c0.067,0.011,0.134,0.022,0.202,0.029\r\n\t\t\t\tC35.806,55.995,35.902,56,36,56c0.916,0,1.734-0.411,2.284-1.058l0.001,0.001l17-20l-0.001-0.001C55.73,34.418,56,33.741,56,33z\r\n\t\t\t\t M16,20c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4s4,1.791,4,4C20,18.209,18.209,20,16,20z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BASKET__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M47,41.476V50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V38.479\r\n\t\t\t\tC37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z\r\n\t\t\t\t M57.121,27.879C57.664,28.422,58,29.172,58,30c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,30.243l-1.879,1.879\r\n\t\t\t\tC48.578,32.664,47.828,33,47,33c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L46.757,26l-1.879-1.879\r\n\t\t\t\tC44.336,23.578,44,22.828,44,22c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,21.757l1.879-1.879\r\n\t\t\t\tC53.422,19.336,54.172,19,55,19c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,26L57.121,27.879z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M47,41.476V50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V38.479\r\n\t\t\t\tC37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z\r\n\t\t\t\t M57.121,27.879C57.664,28.422,58,29.172,58,30c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,30.243l-1.879,1.879\r\n\t\t\t\tC48.578,32.664,47.828,33,47,33c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L46.757,26l-1.879-1.879\r\n\t\t\t\tC44.336,23.578,44,22.828,44,22c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,21.757l1.879-1.879\r\n\t\t\t\tC53.422,19.336,54.172,19,55,19c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,26L57.121,27.879z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BASKET__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M28.623,9.469\r\n\t\t\t\tL28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789\r\n\t\t\t\tL28.623,9.469z M47,41.476V50c0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1\r\n\t\t\t\tH3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002C12.424,58.03,13.595,59,15,59h0\r\n\t\t\t\tc0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42\r\n\t\t\t\tC49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tc0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13C64,18.82,58.18,13,51,13z M59.121,25.122l-8,8C50.578,33.664,49.829,34,49,34\r\n\t\t\t\tc-0.828,0-1.578-0.336-2.121-0.879l-4-4C42.336,28.579,42,27.828,42,27c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL49,26.758l5.879-5.879C55.422,20.336,56.172,20,57,20c1.657,0,3,1.343,3,3C60,23.828,59.664,24.579,59.121,25.122z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35.383,9.469l3.329,6.289c1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23\r\n\t\t\t\tl-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M28.623,9.469\r\n\t\t\t\tL28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789\r\n\t\t\t\tL28.623,9.469z M47,41.476V50c0,1.657-1.343,3-3,3s-3-1.343-3-3V38.479C37.346,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1\r\n\t\t\t\tH3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002C12.424,58.03,13.595,59,15,59h0\r\n\t\t\t\tc0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42\r\n\t\t\t\tC49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3V50z M51,13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tc0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13C64,18.82,58.18,13,51,13z M59.121,25.122l-8,8C50.578,33.664,49.829,34,49,34\r\n\t\t\t\tc-0.828,0-1.578-0.336-2.121-0.879l-4-4C42.336,28.579,42,27.828,42,27c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL49,26.758l5.879-5.879C55.422,20.336,56.172,20,57,20c1.657,0,3,1.343,3,3C60,23.828,59.664,24.579,59.121,25.122z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.673,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M47,41.476V50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V38.479\r\n\t\t\t\tC37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z\r\n\t\t\t\t M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z M57,29H45c-1.657,0-3-1.343-3-3\r\n\t\t\t\ts1.343-3,3-3h12c1.657,0,3,1.343,3,3S58.657,29,57,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.673,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M47,41.476V50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V38.479\r\n\t\t\t\tC37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.05-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453\r\n\t\t\t\tC54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z M23,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z\r\n\t\t\t\t M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13s13-5.82,13-13C64,18.82,58.18,13,51,13z M57,29H45c-1.657,0-3-1.343-3-3\r\n\t\t\t\ts1.343-3,3-3h12c1.657,0,3,1.343,3,3S58.657,29,57,29z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BASKET__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"BASKET__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC64,18.82,58.18,13,51,13z M57,29h-3v3c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v3h3c1.657,0,3,1.343,3,3S58.657,29,57,29z M47,41.476V50c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3V38.479C37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.051-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\th2.658l6.432,25.728l0.009-0.002C12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.175,0-2.181,0.682-2.674,1.665L23.32,6.662L15.2,22h6.789L28.623,9.469z M35.383,9.469l3.329,6.289\r\n\t\t\t\tc1.313-1.574,2.922-2.89,4.742-3.866l-2.769-5.23l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.534,0.151,1.028,0.396,1.462L35.383,9.469z M51,13c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC64,18.82,58.18,13,51,13z M57,29h-3v3c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3s1.343-3,3-3h3v-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v3h3c1.657,0,3,1.343,3,3S58.657,29,57,29z M47,41.476V50c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3V38.479C37.345,35.547,35,31.05,35,26c0-0.338,0.03-0.668,0.051-1H3c-1.657,0-3,1.343-3,3s1.343,3,3,3\r\n\t\t\t\th2.658l6.432,25.728l0.009-0.002C12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49\r\n\t\t\t\tc1.405,0,2.576-0.97,2.901-2.275l0.009,0.002l3.863-15.453C54.266,41.746,52.663,42,51,42C49.616,42,48.281,41.806,47,41.476z\r\n\t\t\t\t M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BASKET_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BASKET","display":"inline"},"children":[{"name":"g","attribs":{"id":"BASKET","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,27.987c0-0.006-0.001-0.012-0.001-0.019\r\n\t\t\t\tc-0.001-0.074-0.005-0.148-0.011-0.221c-0.003-0.042-0.008-0.084-0.013-0.125c-0.005-0.04-0.011-0.08-0.017-0.12\r\n\t\t\t\tc-0.219-1.342-1.327-2.386-2.703-2.502H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002L58.342,31H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.002,0-0.003,0-0.005C64,27.992,64,27.99,64,27.987z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3V50z M47,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35.383,9.469\r\n\t\t\t\tL42.017,22h6.789l-8.12-15.338l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.151,1.028,0.396,1.462\r\n\t\t\t\tL35.383,9.469z M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,27.987c0-0.006-0.001-0.012-0.001-0.019\r\n\t\t\t\tc-0.001-0.074-0.005-0.148-0.011-0.221c-0.003-0.042-0.008-0.084-0.013-0.125c-0.005-0.04-0.011-0.08-0.017-0.12\r\n\t\t\t\tc-0.219-1.342-1.327-2.386-2.703-2.502H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h2.658l6.432,25.728l0.009-0.002\r\n\t\t\t\tC12.424,58.03,13.595,59,15,59h0c0.005,0,0.01-0.001,0.016-0.001V59H49c1.405,0,2.576-0.97,2.901-2.275l0.009,0.002L58.342,31H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.002,0-0.003,0-0.005C64,27.992,64,27.99,64,27.987z M23,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35,50c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V34c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3V50z M47,50c0,1.657-1.343,3-3,3s-3-1.343-3-3V34c0-1.657,1.343-3,3-3s3,1.343,3,3V50z M35.383,9.469\r\n\t\t\t\tL42.017,22h6.789l-8.12-15.338l-0.011,0.006C40.183,5.683,39.176,5,38,5c-1.657,0-3,1.343-3,3c0,0.534,0.151,1.028,0.396,1.462\r\n\t\t\t\tL35.383,9.469z M28.623,9.469L28.606,9.46C28.849,9.026,29,8.533,29,8c0-1.657-1.343-3-3-3c-1.175,0-2.181,0.682-2.674,1.665\r\n\t\t\t\tL23.32,6.662L15.2,22h6.789L28.623,9.469z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_BAG_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_BAG","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOPPING_BAG","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6,61c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3v-3H6V61z M55,15h-8\r\n\t\t\t\tc0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15H9c-1.657,0-3,1.343-3,3v37h52V18C58,16.343,56.657,15,55,15z M23,15\r\n\t\t\t\tc0-4.971,4.029-9,9-9s9,4.03,9,9H23z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6,61c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3v-3H6V61z M55,15h-8\r\n\t\t\t\tc0-8.284-6.716-15-15-15c-8.284,0-15,6.716-15,15H9c-1.657,0-3,1.343-3,3v37h52V18C58,16.343,56.657,15,55,15z M23,15\r\n\t\t\t\tc0-4.971,4.029-9,9-9s9,4.03,9,9H23z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOP","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10,9h44c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H10C8.343,3,7,4.343,7,6\r\n\t\t\t\tC7,7.657,8.343,9,10,9z M58.375,12H5.625L0,27c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tc0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8L58.375,12z M55,37.952V37.95\r\n\t\t\t\tc-0.287-0.026-0.57-0.069-0.85-0.117c-0.06-0.01-0.122-0.015-0.182-0.026c-0.13-0.024-0.256-0.061-0.384-0.09\r\n\t\t\t\tc-0.542-0.124-1.074-0.278-1.584-0.477V52H12V37.239c-0.51,0.2-1.042,0.354-1.586,0.478c-0.128,0.029-0.253,0.065-0.382,0.09\r\n\t\t\t\tc-0.06,0.011-0.122,0.016-0.183,0.027C9.569,37.88,9.287,37.924,9,37.95v0.002C8.671,37.982,8.338,38,8,38\r\n\t\t\t\tc-0.684,0-1.351-0.071-2-0.19V58c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V37.81C57.351,37.929,56.684,38,56,38\r\n\t\t\t\tC55.663,38,55.329,37.982,55,37.952z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10,9h44c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H10C8.343,3,7,4.343,7,6\r\n\t\t\t\tC7,7.657,8.343,9,10,9z M58.375,12H5.625L0,27c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tc0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8L58.375,12z M55,37.952V37.95\r\n\t\t\t\tc-0.287-0.026-0.57-0.069-0.85-0.117c-0.06-0.01-0.122-0.015-0.182-0.026c-0.13-0.024-0.256-0.061-0.384-0.09\r\n\t\t\t\tc-0.542-0.124-1.074-0.278-1.584-0.477V52H12V37.239c-0.51,0.2-1.042,0.354-1.586,0.478c-0.128,0.029-0.253,0.065-0.382,0.09\r\n\t\t\t\tc-0.06,0.011-0.122,0.016-0.183,0.027C9.569,37.88,9.287,37.924,9,37.95v0.002C8.671,37.982,8.338,38,8,38\r\n\t\t\t\tc-0.684,0-1.351-0.071-2-0.19V58c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V37.81C57.351,37.929,56.684,38,56,38\r\n\t\t\t\tC55.663,38,55.329,37.982,55,37.952z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,49H27.779l-1.498-4.279L52.2,42.993v-0.001\r\n\t\t\t\tc1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719L18.679,23\r\n\t\t\t\th17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6\r\n\t\t\t\tc3.314,0,6-2.686,6-6C62,51.686,59.314,49,56,49z M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M44.879,15.121C44.336,14.578,44,13.828,44,13c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL51,12.757l1.879-1.879C53.422,10.336,54.172,10,55,10c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,17\r\n\t\t\t\tl1.879,1.879C57.664,19.422,58,20.172,58,21c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,21.243l-1.879,1.879\r\n\t\t\t\tC48.579,23.664,47.828,24,47,24c-1.657,0-3-1.343-3-3c0-0.828,0.336-1.578,0.879-2.121L46.757,17L44.879,15.121z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,49H27.779l-1.498-4.279L52.2,42.993v-0.001\r\n\t\t\t\tc1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719L18.679,23\r\n\t\t\t\th17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6\r\n\t\t\t\tc3.314,0,6-2.686,6-6C62,51.686,59.314,49,56,49z M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M44.879,15.121C44.336,14.578,44,13.828,44,13c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL51,12.757l1.879-1.879C53.422,10.336,54.172,10,55,10c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L55.243,17\r\n\t\t\t\tl1.879,1.879C57.664,19.422,58,20.172,58,21c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L51,21.243l-1.879,1.879\r\n\t\t\t\tC48.579,23.664,47.828,24,47,24c-1.657,0-3-1.343-3-3c0-0.828,0.336-1.578,0.879-2.121L46.757,17L44.879,15.121z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,15c0.828,0,1.578,0.336,2.121,0.879L49,17.757l5.879-5.879C55.422,11.336,56.172,11,57,11\r\n\t\t\t\tc1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121l-8,8C50.578,24.664,49.828,25,49,25s-1.578-0.336-2.121-0.879l-4-4\r\n\t\t\t\tC42.336,19.578,42,18.828,42,18C42,16.343,43.343,15,45,15z M56,49H27.778l-1.497-4.279L52.2,42.993v-0.001\r\n\t\t\t\tc1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719L18.679,23\r\n\t\t\t\th17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6\r\n\t\t\t\ts6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,15c0.828,0,1.578,0.336,2.121,0.879L49,17.757l5.879-5.879C55.422,11.336,56.172,11,57,11\r\n\t\t\t\tc1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121l-8,8C50.578,24.664,49.828,25,49,25s-1.578-0.336-2.121-0.879l-4-4\r\n\t\t\t\tC42.336,19.578,42,18.828,42,18C42,16.343,43.343,15,45,15z M56,49H27.778l-1.497-4.279L52.2,42.993v-0.001\r\n\t\t\t\tc1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719L18.679,23\r\n\t\t\t\th17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6\r\n\t\t\t\ts6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13S38,9.82,38,17\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,14h12c1.657,0,3,1.343,3,3s-1.343,3-3,3H45c-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.778\r\n\t\t\t\tl-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457\r\n\t\t\t\tl-1.877,4.171l-25.779,1.719L18.678,23h17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004\r\n\t\t\t\tC14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13S38,9.82,38,17\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,14h12c1.657,0,3,1.343,3,3s-1.343,3-3,3H45c-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.778\r\n\t\t\t\tl-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457\r\n\t\t\t\tl-1.877,4.171l-25.779,1.719L18.678,23h17.495C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004\r\n\t\t\t\tC14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,14h3v-3c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v3h3c1.657,0,3,1.343,3,3s-1.343,3-3,3h-3v3\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.779l-1.498-4.279L52.2,42.993\r\n\t\t\t\tv-0.001c1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719\r\n\t\t\t\tL18.678,23h17.496C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,30c7.18,0,13-5.82,13-13c0-7.18-5.82-13-13-13c-7.18,0-13,5.82-13,13\r\n\t\t\t\tC38,24.18,43.82,30,51,30z M45,14h3v-3c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v3h3c1.657,0,3,1.343,3,3s-1.343,3-3,3h-3v3\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.779l-1.498-4.279L52.2,42.993\r\n\t\t\t\tv-0.001c1.132-0.074,2.092-0.776,2.536-1.762h0l4.83-10.733c-2.245,1.427-4.866,2.303-7.685,2.457l-1.877,4.171l-25.779,1.719\r\n\t\t\t\tL18.678,23h17.496C35.423,21.146,35,19.124,35,17H16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6C62,51.686,59.314,49,56,49z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SHOPPING_CART_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART","display":"inline"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.2,39.993c1.132-0.074,2.092-0.776,2.536-1.762h0l9-20l-0.005-0.002\r\n\t\t\t\tC63.901,17.853,64,17.439,64,17c0-1.657-1.343-3-3-3H16.578l-1.747-4.991L14.82,9.013C14.411,7.844,13.309,7,12,7H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6c0-3.314-2.686-6-6-6H27.778l-1.497-4.279L52.2,39.993L52.2,39.993z M24.224,35.845L18.679,20\r\n\t\t\t\tH56.36l-6.357,14.127L24.224,35.845z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.2,39.993c1.132-0.074,2.092-0.776,2.536-1.762h0l9-20l-0.005-0.002\r\n\t\t\t\tC63.901,17.853,64,17.439,64,17c0-1.657-1.343-3-3-3H16.578l-1.747-4.991L14.82,9.013C14.411,7.844,13.309,7,12,7H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6.872l11.55,33H16c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6h28\r\n\t\t\t\tc0,3.314,2.686,6,6,6s6-2.686,6-6c0-3.314-2.686-6-6-6H27.778l-1.497-4.279L52.2,39.993L52.2,39.993z M24.224,35.845L18.679,20\r\n\t\t\t\tH56.36l-6.357,14.127L24.224,35.845z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CAMERA_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CAMERA","display":"inline"},"children":[{"name":"g","attribs":{"id":"CAMERA","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,22c-6.627,0-12,5.372-12,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12\r\n\t\t\t\tC44,27.373,38.627,22,32,22z M61,12H48.243l-5.094-5.094l-0.003,0.003C42.602,6.35,41.843,6,41,6H23\r\n\t\t\t\tc-0.976,0-1.835,0.474-2.383,1.196L15.813,12H3c-1.657,0-3,1.343-3,3v40c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V15\r\n\t\t\t\tC64,13.343,62.657,12,61,12z M32,52c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC50,43.941,41.941,52,32,52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,22c-6.627,0-12,5.372-12,12c0,6.627,5.373,12,12,12c6.627,0,12-5.373,12-12\r\n\t\t\t\tC44,27.373,38.627,22,32,22z M61,12H48.243l-5.094-5.094l-0.003,0.003C42.602,6.35,41.843,6,41,6H23\r\n\t\t\t\tc-0.976,0-1.835,0.474-2.383,1.196L15.813,12H3c-1.657,0-3,1.343-3,3v40c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V15\r\n\t\t\t\tC64,13.343,62.657,12,61,12z M32,52c-9.941,0-18-8.059-18-18c0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18\r\n\t\t\t\tC50,43.941,41.941,52,32,52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MUSIC_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MUSIC","display":"inline"},"children":[{"name":"g","attribs":{"id":"MUSIC","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,0L20,9c0,0-3,0.681-3,3v40.66C15.499,52.241,13.802,52,12,52\r\n\t\t\t\tc-6.075,0-11,2.686-11,6c0,3.314,4.925,6,11,6c6.075,0,11-2.686,11-6V26.123l34-7.415V43.66C55.499,43.241,53.802,43,52,43\r\n\t\t\t\tc-6.075,0-11,2.686-11,6c0,3.314,4.925,6,11,6c6.075,0,11-2.686,11-6V3C63,1.343,61.657,0,60,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,0L20,9c0,0-3,0.681-3,3v40.66C15.499,52.241,13.802,52,12,52\r\n\t\t\t\tc-6.075,0-11,2.686-11,6c0,3.314,4.925,6,11,6c6.075,0,11-2.686,11-6V26.123l34-7.415V43.66C55.499,43.241,53.802,43,52,43\r\n\t\t\t\tc-6.075,0-11,2.686-11,6c0,3.314,4.925,6,11,6c6.075,0,11-2.686,11-6V3C63,1.343,61.657,0,60,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PROGRESS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PROGRESS","display":"inline"},"children":[{"name":"g","attribs":{"id":"PROGRESS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,29c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3s3-1.343,3-3V32\r\n\t\t\t\tC29,30.343,27.657,29,26,29z M14,37c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C17,38.343,15.657,37,14,37z\r\n\t\t\t\t M50,13c-1.657,0-3,1.343-3,3v32c0,1.657,1.343,3,3,3s3-1.343,3-3V16C53,14.343,51.657,13,50,13z M38,21c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V24C41,22.343,39.657,21,38,21z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,29c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3s3-1.343,3-3V32\r\n\t\t\t\tC29,30.343,27.657,29,26,29z M14,37c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3s3-1.343,3-3v-8C17,38.343,15.657,37,14,37z\r\n\t\t\t\t M50,13c-1.657,0-3,1.343-3,3v32c0,1.657,1.343,3,3,3s3-1.343,3-3V16C53,14.343,51.657,13,50,13z M38,21c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V24C41,22.343,39.657,21,38,21z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CODE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CODE","display":"inline"},"children":[{"name":"g","attribs":{"id":"CODE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.031,17c-0.844,0-1.604,0.352-2.149,0.913l-0.003-0.003L1.053,29.735\r\n\t\t\t\tC0.413,30.285,0,31.091,0,32c0,0.844,0.351,1.604,0.912,2.149L0.91,34.152l12,12l0.003-0.003C13.453,46.674,14.187,47,15,47\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.812-0.326-1.547-0.851-2.087l0.003-0.003l-9.894-9.895l9.863-9.863l-0.003-0.003\r\n\t\t\t\tc0.561-0.545,0.913-1.305,0.913-2.149C18.031,18.343,16.688,17,15.031,17z M64.031,32c0-0.91-0.413-1.715-1.053-2.265\r\n\t\t\t\tL51.153,17.91l-0.003,0.003C50.604,17.352,49.844,17,49,17c-1.657,0-3,1.343-3,3c0,0.844,0.351,1.604,0.913,2.149l-0.003,0.003\r\n\t\t\t\tl9.863,9.863l-9.894,9.895l0.003,0.003c-0.525,0.54-0.851,1.275-0.851,2.087c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.813,0,1.547-0.326,2.088-0.851l0.003,0.003l12-12l-0.003-0.003C63.68,33.604,64.031,32.844,64.031,32z M40,8\r\n\t\t\t\tc-1.3,0-2.406,0.827-2.823,1.982L21.2,51.924C21.071,52.258,21,52.621,21,53c0,1.657,1.343,3,3,3c1.3,0,2.406-0.827,2.823-1.983\r\n\t\t\t\tL42.8,12.076C42.929,11.742,43,11.38,43,11C43,9.343,41.657,8,40,8z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.031,17c-0.844,0-1.604,0.352-2.149,0.913l-0.003-0.003L1.053,29.735\r\n\t\t\t\tC0.413,30.285,0,31.091,0,32c0,0.844,0.351,1.604,0.912,2.149L0.91,34.152l12,12l0.003-0.003C13.453,46.674,14.187,47,15,47\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.812-0.326-1.547-0.851-2.087l0.003-0.003l-9.894-9.895l9.863-9.863l-0.003-0.003\r\n\t\t\t\tc0.561-0.545,0.913-1.305,0.913-2.149C18.031,18.343,16.688,17,15.031,17z M64.031,32c0-0.91-0.413-1.715-1.053-2.265\r\n\t\t\t\tL51.153,17.91l-0.003,0.003C50.604,17.352,49.844,17,49,17c-1.657,0-3,1.343-3,3c0,0.844,0.351,1.604,0.913,2.149l-0.003,0.003\r\n\t\t\t\tl9.863,9.863l-9.894,9.895l0.003,0.003c-0.525,0.54-0.851,1.275-0.851,2.087c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.813,0,1.547-0.326,2.088-0.851l0.003,0.003l12-12l-0.003-0.003C63.68,33.604,64.031,32.844,64.031,32z M40,8\r\n\t\t\t\tc-1.3,0-2.406,0.827-2.823,1.982L21.2,51.924C21.071,52.258,21,52.621,21,53c0,1.657,1.343,3,3,3c1.3,0,2.406-0.827,2.823-1.983\r\n\t\t\t\tL42.8,12.076C42.929,11.742,43,11.38,43,11C43,9.343,41.657,8,40,8z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LINK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINK","display":"inline"},"children":[{"name":"g","attribs":{"id":"LINK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.461,45.766c-0.056,0.061-0.096,0.131-0.155,0.19l-8.349,8.37\r\n\t\t\t\tc-2.306,2.311-6.043,2.311-8.349,0c-2.305-2.311-2.305-6.059,0-8.37l8.349-8.37c0.018-0.018,0.041-0.03,0.059-0.049l7.187-7.187\r\n\t\t\t\tc-3.943-1.062-8.326-0.052-11.421,3.05l-8.349,8.37c-4.611,4.623-4.611,12.118,0,16.74c4.611,4.623,12.087,4.623,16.697,0\r\n\t\t\t\tl8.349-8.37c3.092-3.1,4.1-7.489,3.045-11.44L26.461,45.766z M58.481,5.401c-4.611-4.623-12.086-4.623-16.697,0l-8.349,8.37\r\n\t\t\t\tc-3.082,3.09-4.093,7.462-3.054,11.403l7.221-7.221l0.006,0.006c0.001-0.001,0.001-0.002,0.002-0.002l8.349-8.37\r\n\t\t\t\tc2.305-2.311,6.043-2.311,8.349,0c2.305,2.311,2.305,6.059,0,8.37l-8.349,8.37c-0.097,0.098-0.211,0.167-0.313,0.256l-6.97,6.97\r\n\t\t\t\tc3.953,1.078,8.353,0.071,11.457-3.041l8.349-8.37C63.091,17.518,63.091,10.023,58.481,5.401z M42,19\r\n\t\t\t\tc-0.868,0-1.644,0.374-2.192,0.964L19.964,39.808C19.375,40.356,19,41.132,19,42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.836,0,1.591-0.344,2.135-0.896l0.009,0.009l20-20l-0.009-0.009C44.669,23.563,45,22.82,45,22C45,20.343,43.657,19,42,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.461,45.766c-0.056,0.061-0.096,0.131-0.155,0.19l-8.349,8.37\r\n\t\t\t\tc-2.306,2.311-6.043,2.311-8.349,0c-2.305-2.311-2.305-6.059,0-8.37l8.349-8.37c0.018-0.018,0.041-0.03,0.059-0.049l7.187-7.187\r\n\t\t\t\tc-3.943-1.062-8.326-0.052-11.421,3.05l-8.349,8.37c-4.611,4.623-4.611,12.118,0,16.74c4.611,4.623,12.087,4.623,16.697,0\r\n\t\t\t\tl8.349-8.37c3.092-3.1,4.1-7.489,3.045-11.44L26.461,45.766z M58.481,5.401c-4.611-4.623-12.086-4.623-16.697,0l-8.349,8.37\r\n\t\t\t\tc-3.082,3.09-4.093,7.462-3.054,11.403l7.221-7.221l0.006,0.006c0.001-0.001,0.001-0.002,0.002-0.002l8.349-8.37\r\n\t\t\t\tc2.305-2.311,6.043-2.311,8.349,0c2.305,2.311,2.305,6.059,0,8.37l-8.349,8.37c-0.097,0.098-0.211,0.167-0.313,0.256l-6.97,6.97\r\n\t\t\t\tc3.953,1.078,8.353,0.071,11.457-3.041l8.349-8.37C63.091,17.518,63.091,10.023,58.481,5.401z M42,19\r\n\t\t\t\tc-0.868,0-1.644,0.374-2.192,0.964L19.964,39.808C19.375,40.356,19,41.132,19,42c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.836,0,1.591-0.344,2.135-0.896l0.009,0.009l20-20l-0.009-0.009C44.669,23.563,45,22.82,45,22C45,20.343,43.657,19,42,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BIN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BIN","display":"inline"},"children":[{"name":"g","attribs":{"id":"BIN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,9H38V6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v3H11\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3h48v-3C56,10.343,54.657,9,53,9z M11,58c0,1.657,1.343,3,3,3h36c1.657,0,3-1.343,3-3V18H11V58z M41,27\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v25c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z M29,27c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3v25c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z M17,27c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v25\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,9H38V6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v3H11\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3h48v-3C56,10.343,54.657,9,53,9z M11,58c0,1.657,1.343,3,3,3h36c1.657,0,3-1.343,3-3V18H11V58z M41,27\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v25c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z M29,27c0-1.657,1.343-3,3-3\r\n\t\t\t\tc1.657,0,3,1.343,3,3v25c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z M17,27c0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3v25\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3V27z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"EQUALIZER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"EQUALIZER","display":"inline"},"children":[{"name":"g","attribs":{"id":"EQUALIZER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13,23H7c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3\r\n\t\t\t\tV26C16,24.343,14.657,23,13,23z M13,3c0-1.657-1.343-3-3-3C8.343,0,7,1.343,7,3v17h6V3z M35,3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv25h6V3z M57,3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v9h6V3z M7,61c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V44H7V61z M57,15\r\n\t\t\t\th-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V18C60,16.343,58.657,15,57,15z M51,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V36h-6V61z M29,61c0,1.657,1.343,3,3,3s3-1.343,3-3v-9h-6V61z M35,31h-6\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V34C38,32.343,36.657,31,35,31z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13,23H7c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3\r\n\t\t\t\tV26C16,24.343,14.657,23,13,23z M13,3c0-1.657-1.343-3-3-3C8.343,0,7,1.343,7,3v17h6V3z M35,3c0-1.657-1.343-3-3-3s-3,1.343-3,3\r\n\t\t\t\tv25h6V3z M57,3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v9h6V3z M7,61c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V44H7V61z M57,15\r\n\t\t\t\th-6c-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V18C60,16.343,58.657,15,57,15z M51,61\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V36h-6V61z M29,61c0,1.657,1.343,3,3,3s3-1.343,3-3v-9h-6V61z M35,31h-6\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3V34C38,32.343,36.657,31,35,31z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MORE_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MORE_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"MORE_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.998,26c-3.314,0-6.001,2.687-6.001,6.001c0,3.314,2.687,6.001,6.001,6.001\r\n\t\t\t\tc3.315,0,6.002-2.687,6.002-6.001C38,28.687,35.313,26,31.998,26z M31.998,19.001c3.315,0,6.002-2.687,6.002-6.001\r\n\t\t\t\tC38,9.687,35.313,7,31.998,7c-3.314,0-6.001,2.686-6.001,6.001C25.997,16.315,28.684,19.001,31.998,19.001z M31.998,45\r\n\t\t\t\tc-3.314,0-6.001,2.687-6.001,6.001c0,3.314,2.687,6.001,6.001,6.001c3.315,0,6.002-2.687,6.002-6.001\r\n\t\t\t\tC38,47.687,35.313,45,31.998,45z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.998,26c-3.314,0-6.001,2.687-6.001,6.001c0,3.314,2.687,6.001,6.001,6.001\r\n\t\t\t\tc3.315,0,6.002-2.687,6.002-6.001C38,28.687,35.313,26,31.998,26z M31.998,19.001c3.315,0,6.002-2.687,6.002-6.001\r\n\t\t\t\tC38,9.687,35.313,7,31.998,7c-3.314,0-6.001,2.686-6.001,6.001C25.997,16.315,28.684,19.001,31.998,19.001z M31.998,45\r\n\t\t\t\tc-3.314,0-6.001,2.687-6.001,6.001c0,3.314,2.687,6.001,6.001,6.001c3.315,0,6.002-2.687,6.002-6.001\r\n\t\t\t\tC38,47.687,35.313,45,31.998,45z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,53,61,53z M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M61,21H15c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h5.999c0,0,0,0,0.001,0h40c1.657,0,3-1.343,3-3C64,22.343,62.657,21,61,21z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,53,61,53z M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M61,21H15c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h5.999c0,0,0,0,0.001,0h40c1.657,0,3-1.343,3-3C64,22.343,62.657,21,61,21z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TEXT__x2F__CENTER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__CENTER","display":"inline"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__CENTER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8\r\n\t\t\t\tS1.343,11,3,11z M15,21c-1.657,0-3,1.343-3,3s1.343,3,3,3h5.999c0,0,0,0,0.001,0h22c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H15z M61,37H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M43,53\r\n\t\t\t\tH21c-1.657,0-3,1.343-3,3s1.343,3,3,3h22c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8\r\n\t\t\t\tS1.343,11,3,11z M15,21c-1.657,0-3,1.343-3,3s1.343,3,3,3h5.999c0,0,0,0,0.001,0h22c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H15z M61,37H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M43,53\r\n\t\t\t\tH21c-1.657,0-3,1.343-3,3s1.343,3,3,3h22c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TEXT__x2F__LEFT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,27h40c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C0,25.657,1.343,27,3,27z M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z\r\n\t\t\t\t M61,37H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M43,53H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,27h40c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C0,25.657,1.343,27,3,27z M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z\r\n\t\t\t\t M61,37H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z M43,53H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY","display":"inline"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8\r\n\t\t\t\tS1.343,11,3,11z M61,53H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,53,61,53z M61,21H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,22.343,62.657,21,61,21z M61,37H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8\r\n\t\t\t\tS1.343,11,3,11z M61,53H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,53,61,53z M61,21H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,22.343,62.657,21,61,21z M61,37H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,38.343,62.657,37,61,37z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BATTERY_FULL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY_FULL","display":"inline"},"children":[{"name":"g","attribs":{"id":"BATTERY_FULL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\th55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z M52,26H9v12h43V26z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\th55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z M52,26H9v12h43V26z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__2_x2F_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37,26H9v12h28V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37,26H9v12h28V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__1_x2F_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,26H9v12h13V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,26H9v12h13V26z M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24\r\n\t\t\t\tc0,1.657,1.343,3,3,3h55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY","display":"inline"},"children":[{"name":"g","attribs":{"id":"BATTERY__x2F__EMPTY","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\th55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,26v-6c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3v24c0,1.657,1.343,3,3,3\r\n\t\t\t\th55c1.657,0,3-1.343,3-3v-6c1.657,0,3-1.343,3-3v-6C64,27.343,62.657,26,61,26z M55,41H6V23h49V41z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"STAR_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"STAR","display":"inline"},"children":[{"name":"g","attribs":{"id":"STAR","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,26c0-1.657-1.343-3-3-3H41.047L34.869,4.12C34.492,2.893,33.351,2,32,2\r\n\t\t\t\tc-1.35,0-2.492,0.892-2.868,2.12L22.953,23H3c-1.657,0-3,1.343-3,3c0,1,0.49,1.885,1.242,2.43l0,0l16.118,11.66l-6.209,18.971\r\n\t\t\t\tC11.053,59.357,11,59.672,11,60c0,1.657,1.343,3,3,3c0.657,0,1.263-0.213,1.758-0.571l0.001,0.001L32,50.681l16.242,11.749\r\n\t\t\t\tl0.001-0.001C48.737,62.788,49.343,63,50,63c1.657,0,3-1.343,3-3c0-0.328-0.053-0.643-0.151-0.938L46.641,40.09l16.118-11.66l0,0\r\n\t\t\t\tC63.51,27.885,64,27,64,26z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,26c0-1.657-1.343-3-3-3H41.047L34.869,4.12C34.492,2.893,33.351,2,32,2\r\n\t\t\t\tc-1.35,0-2.492,0.892-2.868,2.12L22.953,23H3c-1.657,0-3,1.343-3,3c0,1,0.49,1.885,1.242,2.43l0,0l16.118,11.66l-6.209,18.971\r\n\t\t\t\tC11.053,59.357,11,59.672,11,60c0,1.657,1.343,3,3,3c0.657,0,1.263-0.213,1.758-0.571l0.001,0.001L32,50.681l16.242,11.749\r\n\t\t\t\tl0.001-0.001C48.737,62.788,49.343,63,50,63c1.657,0,3-1.343,3-3c0-0.328-0.053-0.643-0.151-0.938L46.641,40.09l16.118-11.66l0,0\r\n\t\t\t\tC63.51,27.885,64,27,64,26z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_4_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_4","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_4","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.841,47.327L45.515,41H19c-3.314,0-6-2.686-6-6V14H4c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv34c0,1.656,1.341,2.998,2.996,3H7.5v0H8v6c0,0.207,0.021,0.409,0.061,0.605c0.028,0.136,0.076,0.264,0.122,0.393\r\n\t\t\t\tc0.02,0.056,0.03,0.116,0.053,0.17c0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184\r\n\t\t\t\tc0.098,0.145,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04c0.534,0.535,1.271,0.865,2.084,0.875\r\n\t\t\t\tC10.976,62.996,10.987,63,11,63c0.828,0,1.578-0.336,2.121-0.879L21.243,54H22v0h3v0h6.9v0H53v0c1.657,0,3-1.343,3-3v-2\r\n\t\t\t\tc-1.614,0-3.072-0.645-4.151-1.681L51.841,47.327z M61,2H19c-1.657,0-3,1.343-3,3v30c0,1.657,1.343,3,3,3h27.757l7.121,7.121\r\n\t\t\t\tC54.422,45.664,55.172,46,56,46c0.013,0,0.025-0.004,0.037-0.004c0.813-0.01,1.55-0.34,2.084-0.875\r\n\t\t\t\tc0.012-0.012,0.021-0.028,0.033-0.04c0.121-0.126,0.235-0.259,0.333-0.404c0.039-0.057,0.065-0.123,0.1-0.184\r\n\t\t\t\tc0.062-0.107,0.128-0.211,0.177-0.326c0.023-0.054,0.033-0.114,0.053-0.17c0.046-0.129,0.094-0.257,0.122-0.393\r\n\t\t\t\tC58.979,43.409,59,43.207,59,43v-5h2c1.657,0,3-1.343,3-3V5C64,3.343,62.657,2,61,2z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51.841,47.327L45.515,41H19c-3.314,0-6-2.686-6-6V14H4c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv34c0,1.656,1.341,2.998,2.996,3H7.5v0H8v6c0,0.207,0.021,0.409,0.061,0.605c0.028,0.136,0.076,0.264,0.122,0.393\r\n\t\t\t\tc0.02,0.056,0.03,0.116,0.053,0.17c0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184\r\n\t\t\t\tc0.098,0.145,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04c0.534,0.535,1.271,0.865,2.084,0.875\r\n\t\t\t\tC10.976,62.996,10.987,63,11,63c0.828,0,1.578-0.336,2.121-0.879L21.243,54H22v0h3v0h6.9v0H53v0c1.657,0,3-1.343,3-3v-2\r\n\t\t\t\tc-1.614,0-3.072-0.645-4.151-1.681L51.841,47.327z M61,2H19c-1.657,0-3,1.343-3,3v30c0,1.657,1.343,3,3,3h27.757l7.121,7.121\r\n\t\t\t\tC54.422,45.664,55.172,46,56,46c0.013,0,0.025-0.004,0.037-0.004c0.813-0.01,1.55-0.34,2.084-0.875\r\n\t\t\t\tc0.012-0.012,0.021-0.028,0.033-0.04c0.121-0.126,0.235-0.259,0.333-0.404c0.039-0.057,0.065-0.123,0.1-0.184\r\n\t\t\t\tc0.062-0.107,0.128-0.211,0.177-0.326c0.023-0.054,0.033-0.114,0.053-0.17c0.046-0.129,0.094-0.257,0.122-0.393\r\n\t\t\t\tC58.979,43.409,59,43.207,59,43v-5h2c1.657,0,3-1.343,3-3V5C64,3.343,62.657,2,61,2z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,2.999,2.999,3H7v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.049,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.535,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M17,34c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6s6,2.686,6,6C23,31.314,20.314,34,17,34z M32,34c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tC38,31.314,35.314,34,32,34z M47,34c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C53,31.314,50.314,34,47,34z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,2.999,2.999,3H7v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.049,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.535,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M17,34c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6s6,2.686,6,6C23,31.314,20.314,34,17,34z M32,34c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tC38,31.314,35.314,34,32,34z M47,34c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C53,31.314,50.314,34,47,34z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,2.999,3H7v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.049,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.535,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,2.999,3H7v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.049,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.535,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,3,3h4v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.534,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M58,46H17.757L13,50.757V46H6V9\r\n\t\t\t\th52V46z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,3,3h4v6\r\n\t\t\t\tc0,0.207,0.021,0.409,0.061,0.604c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.056,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.145,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.028,0.033,0.04c0.534,0.534,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L20.243,52H61c1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M58,46H17.757L13,50.757V46H6V9\r\n\t\t\t\th52V46z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_BUBBLES_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLES","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLES","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.568,34.581c0,0.005,0,0.01,0,0.015c-1.301,0.2-2.629,0.53-3.984,0.477\r\n\t\t\t\tc-12.036-0.75-19.873-8.212-20.379-17.122c-0.068-2.09,0.307-4.107,1.045-5.986C9.787,14.332-0.04,23.094-0.04,33.571\r\n\t\t\t\tc0,6.961,4.177,13.176,11.123,17.257c1.573,0.924,1.752,7.862-7.097,12.05c0,0,12.529,1.976,20.473-8.067\r\n\t\t\t\tc1.964,0.282,3.996,0.883,6.075,0.883c14.557,0,24.238-7.163,26.777-16.896c-2.531-0.059-6.918-0.737-10.39-4.308L46.568,34.581z\r\n\t\t\t\t M56.72,27.814c4.55-2.673,7.286-6.744,7.286-11.304c0-8.052-8.85-14.579-20.028-14.579c-11.178,0-17.992,6.527-17.992,14.579\r\n\t\t\t\tc0,8.052,6.813,14.492,17.992,14.492c1.362,0,2.693-0.394,3.979-0.579c5.204,6.578,13.411,5.284,13.411,5.284\r\n\t\t\t\tC55.573,32.964,55.69,28.419,56.72,27.814z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.568,34.581c0,0.005,0,0.01,0,0.015c-1.301,0.2-2.629,0.53-3.984,0.477\r\n\t\t\t\tc-12.036-0.75-19.873-8.212-20.379-17.122c-0.068-2.09,0.307-4.107,1.045-5.986C9.787,14.332-0.04,23.094-0.04,33.571\r\n\t\t\t\tc0,6.961,4.177,13.176,11.123,17.257c1.573,0.924,1.752,7.862-7.097,12.05c0,0,12.529,1.976,20.473-8.067\r\n\t\t\t\tc1.964,0.282,3.996,0.883,6.075,0.883c14.557,0,24.238-7.163,26.777-16.896c-2.531-0.059-6.918-0.737-10.39-4.308L46.568,34.581z\r\n\t\t\t\t M56.72,27.814c4.55-2.673,7.286-6.744,7.286-11.304c0-8.052-8.85-14.579-20.028-14.579c-11.178,0-17.992,6.527-17.992,14.579\r\n\t\t\t\tc0,8.052,6.813,14.492,17.992,14.492c1.362,0,2.693-0.394,3.979-0.579c5.204,6.578,13.411,5.284,13.411,5.284\r\n\t\t\t\tC55.573,32.964,55.69,28.419,56.72,27.814z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56\r\n\t\t\t\tc0,7.681,4.609,14.539,12.274,19.043c1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902\r\n\t\t\t\tc2.167,0.311,4.409,0.975,6.704,0.975c18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z M17,35\r\n\t\t\t\tc-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C23,32.314,20.314,35,17,35z M32,35c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,32.314,35.314,35,32,35z M47,35c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6\r\n\t\t\t\tc3.314,0,6,2.686,6,6C53,32.314,50.314,35,47,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56\r\n\t\t\t\tc0,7.681,4.609,14.539,12.274,19.043c1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902\r\n\t\t\t\tc2.167,0.311,4.409,0.975,6.704,0.975c18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z M17,35\r\n\t\t\t\tc-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6s6,2.686,6,6C23,32.314,20.314,35,17,35z M32,35c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,32.314,35.314,35,32,35z M47,35c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6\r\n\t\t\t\tc3.314,0,6,2.686,6,6C53,32.314,50.314,35,47,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56\r\n\t\t\t\tc0,7.681,4.609,14.539,12.274,19.043c1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902\r\n\t\t\t\tc2.167,0.311,4.409,0.975,6.704,0.975c18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56\r\n\t\t\t\tc0,7.681,4.609,14.539,12.274,19.043c1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902\r\n\t\t\t\tc2.167,0.311,4.409,0.975,6.704,0.975c18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"WIFI_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"WIFI_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,49c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6\r\n\t\t\t\tC38,51.686,35.314,49,32,49z M32,34c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,41.938,28.029,40,32,40\r\n\t\t\t\tc3.971,0,7.482,1.937,9.666,4.91l3.302-4.256C42.062,36.629,37.343,34,32,34z M32,4C19.747,4,8.622,8.8,0.378,16.61l3.696,4.764\r\n\t\t\t\tC11.283,14.34,21.132,10,32,10c10.868,0,20.717,4.34,27.926,11.374l3.696-4.764C55.378,8.8,44.253,4,32,4z M9.637,28.544\r\n\t\t\t\tl3.739,4.819C17.954,28.242,24.59,25,32,25c7.41,0,14.046,3.242,18.624,8.364l3.739-4.819C48.721,22.666,40.791,19,32,19\r\n\t\t\t\tC23.209,19,15.279,22.666,9.637,28.544z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,49c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6\r\n\t\t\t\tC38,51.686,35.314,49,32,49z M32,34c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,41.938,28.029,40,32,40\r\n\t\t\t\tc3.971,0,7.482,1.937,9.666,4.91l3.302-4.256C42.062,36.629,37.343,34,32,34z M32,4C19.747,4,8.622,8.8,0.378,16.61l3.696,4.764\r\n\t\t\t\tC11.283,14.34,21.132,10,32,10c10.868,0,20.717,4.34,27.926,11.374l3.696-4.764C55.378,8.8,44.253,4,32,4z M9.637,28.544\r\n\t\t\t\tl3.739,4.819C17.954,28.242,24.59,25,32,25c7.41,0,14.046,3.242,18.624,8.364l3.739-4.819C48.721,22.666,40.791,19,32,19\r\n\t\t\t\tC23.209,19,15.279,22.666,9.637,28.544z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"WIFI_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"WIFI_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,41c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,43.686,35.314,41,32,41z M32,26c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,33.938,28.029,32,32,32\r\n\t\t\t\tc3.971,0,7.482,1.937,9.666,4.91l3.302-4.256C42.062,28.629,37.343,26,32,26z M32,11c-8.791,0-16.721,3.665-22.363,9.544\r\n\t\t\t\tl3.739,4.819C17.954,20.242,24.59,17,32,17c7.41,0,14.046,3.242,18.624,8.364l3.739-4.819C48.721,14.666,40.791,11,32,11z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,41c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,43.686,35.314,41,32,41z M32,26c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,33.938,28.029,32,32,32\r\n\t\t\t\tc3.971,0,7.482,1.937,9.666,4.91l3.302-4.256C42.062,28.629,37.343,26,32,26z M32,11c-8.791,0-16.721,3.665-22.363,9.544\r\n\t\t\t\tl3.739,4.819C17.954,20.242,24.59,17,32,17c7.41,0,14.046,3.242,18.624,8.364l3.739-4.819C48.721,14.666,40.791,11,32,11z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"WIFI_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"WIFI_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,34c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,36.686,35.314,34,32,34z M32,19c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,26.938,28.029,25,32,25\r\n\t\t\t\ts7.482,1.937,9.666,4.91l3.302-4.256C42.062,21.629,37.343,19,32,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,34c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,36.686,35.314,34,32,34z M32,19c-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,26.938,28.029,25,32,25\r\n\t\t\t\ts7.482,1.937,9.666,4.91l3.302-4.256C42.062,21.629,37.343,19,32,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VIEW__x2F__OFF_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VIEW__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{"id":"VIEW__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.044,31.304l7.604-5.069C33.124,26.085,32.572,26,32,26\r\n\t\t\t\tC28.922,26,26.389,28.319,26.044,31.304z M58.32,16.755C58.729,16.487,59,16.025,59,15.5c0-0.828-0.672-1.5-1.5-1.5\r\n\t\t\t\tc-0.303,0-0.585,0.091-0.82,0.245l0-0.001l-0.018,0.012L4.679,48.245l0,0C4.271,48.513,4,48.975,4,49.5C4,50.328,4.672,51,5.5,51\r\n\t\t\t\tc0.303,0,0.585-0.091,0.82-0.245l0,0.001l0.018-0.012L58.32,16.755L58.32,16.755z M9.455,42.364L10,42l10.409-6.939\r\n\t\t\t\tC20.151,34.082,20,33.06,20,32c0-6.628,5.373-12,12-12c2.742,0,5.262,0.93,7.283,2.478L46,18l0.552-0.345\r\n\t\t\t\tc-2.648-1.317-5.415-2.367-8.308-2.996c-3.881-0.844-7.786-0.879-11.687-0.165c-3.549,0.649-6.969,2-10.17,3.674\r\n\t\t\t\tc-5.011,2.62-9.586,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328c-0.893,1.083-0.893,2.366,0,3.45\r\n\t\t\t\tc2.042,2.476,4.47,4.679,6.94,6.692C8.214,41.41,8.831,41.891,9.455,42.364z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.004-0.041c-0.001-0.02-0.005-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.005-0.046-0.009-0.068c-0.001-0.003-0.001-0.006-0.001-0.009c-0.079-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-0.677-0.552-1.367-1.092-2.069-1.618l-10.576,6.958C43.898,30.255,44,31.115,44,32\r\n\t\t\t\tc0,6.627-5.373,12-12,12c-2.615,0-5.026-0.845-6.997-2.265L17,47l-0.09,0.09c2.8,1.44,5.739,2.581,8.818,3.25\r\n\t\t\t\tc3.881,0.844,7.787,0.88,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.01-2.621,9.586-6.232,13.574-10.28\r\n\t\t\t\tc0.738-0.75,1.471-1.514,2.143-2.329c0.357-0.366,0.59-0.84,0.669-1.347c0-0.003,0.001-0.006,0.001-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.009-0.068c0.003-0.019,0.006-0.039,0.008-0.058c0.001-0.014,0.003-0.027,0.004-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z\r\n\t\t\t\t M37.861,33.276l-7.01,4.612C31.223,37.96,31.607,38,32,38C34.876,38,37.276,35.976,37.861,33.276z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.044,31.304l7.604-5.069C33.124,26.085,32.572,26,32,26\r\n\t\t\t\tC28.922,26,26.389,28.319,26.044,31.304z M58.32,16.755C58.729,16.487,59,16.025,59,15.5c0-0.828-0.672-1.5-1.5-1.5\r\n\t\t\t\tc-0.303,0-0.585,0.091-0.82,0.245l0-0.001l-0.018,0.012L4.679,48.245l0,0C4.271,48.513,4,48.975,4,49.5C4,50.328,4.672,51,5.5,51\r\n\t\t\t\tc0.303,0,0.585-0.091,0.82-0.245l0,0.001l0.018-0.012L58.32,16.755L58.32,16.755z M9.455,42.364L10,42l10.409-6.939\r\n\t\t\t\tC20.151,34.082,20,33.06,20,32c0-6.628,5.373-12,12-12c2.742,0,5.262,0.93,7.283,2.478L46,18l0.552-0.345\r\n\t\t\t\tc-2.648-1.317-5.415-2.367-8.308-2.996c-3.881-0.844-7.786-0.879-11.687-0.165c-3.549,0.649-6.969,2-10.17,3.674\r\n\t\t\t\tc-5.011,2.62-9.586,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328c-0.893,1.083-0.893,2.366,0,3.45\r\n\t\t\t\tc2.042,2.476,4.47,4.679,6.94,6.692C8.214,41.41,8.831,41.891,9.455,42.364z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.004-0.041c-0.001-0.02-0.005-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.005-0.046-0.009-0.068c-0.001-0.003-0.001-0.006-0.001-0.009c-0.079-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-0.677-0.552-1.367-1.092-2.069-1.618l-10.576,6.958C43.898,30.255,44,31.115,44,32\r\n\t\t\t\tc0,6.627-5.373,12-12,12c-2.615,0-5.026-0.845-6.997-2.265L17,47l-0.09,0.09c2.8,1.44,5.739,2.581,8.818,3.25\r\n\t\t\t\tc3.881,0.844,7.787,0.88,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.01-2.621,9.586-6.232,13.574-10.28\r\n\t\t\t\tc0.738-0.75,1.471-1.514,2.143-2.329c0.357-0.366,0.59-0.84,0.669-1.347c0-0.003,0.001-0.006,0.001-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.009-0.068c0.003-0.019,0.006-0.039,0.008-0.058c0.001-0.014,0.003-0.027,0.004-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z\r\n\t\t\t\t M37.861,33.276l-7.01,4.612C31.223,37.96,31.607,38,32,38C34.876,38,37.276,35.976,37.861,33.276z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VIEW_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VIEW","display":"inline"},"children":[{"name":"g","attribs":{"id":"VIEW","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,28.686,35.314,26,32,26z M63.997,32.379c-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.002-0.028-0.004-0.041\r\n\t\t\t\tc-0.001-0.02-0.005-0.039-0.008-0.058c-0.003-0.023-0.005-0.046-0.009-0.068c-0.001-0.003-0.001-0.006-0.001-0.009\r\n\t\t\t\tc-0.079-0.506-0.312-0.981-0.669-1.346c-2.042-2.476-4.471-4.68-6.94-6.692c-5.319-4.337-11.403-7.964-18.117-9.425\r\n\t\t\t\tc-3.881-0.844-7.786-0.879-11.688-0.165c-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.587,6.231-13.574,10.28\r\n\t\t\t\tc-0.738,0.749-1.472,1.514-2.143,2.328c-0.893,1.083-0.893,2.366,0,3.45c2.042,2.476,4.47,4.679,6.94,6.692\r\n\t\t\t\tc5.32,4.337,11.403,7.963,18.118,9.424c3.881,0.844,7.787,0.88,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673\r\n\t\t\t\tc5.01-2.621,9.586-6.232,13.574-10.28c0.738-0.75,1.471-1.514,2.143-2.329c0.357-0.366,0.59-0.84,0.669-1.347\r\n\t\t\t\tc0-0.003,0.001-0.006,0.001-0.008c0.004-0.023,0.006-0.045,0.009-0.068c0.003-0.019,0.006-0.039,0.008-0.058\r\n\t\t\t\tc0.001-0.014,0.002-0.027,0.004-0.041c0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122\r\n\t\t\t\tC64.001,32.459,63.998,32.419,63.997,32.379z M32,44c-6.627,0-12-5.372-12-12c0-6.628,5.372-12,12-12s12,5.373,12,12\r\n\t\t\t\tC44,38.628,38.627,44,32,44z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6s6-2.686,6-6\r\n\t\t\t\tC38,28.686,35.314,26,32,26z M63.997,32.379c-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.002-0.028-0.004-0.041\r\n\t\t\t\tc-0.001-0.02-0.005-0.039-0.008-0.058c-0.003-0.023-0.005-0.046-0.009-0.068c-0.001-0.003-0.001-0.006-0.001-0.009\r\n\t\t\t\tc-0.079-0.506-0.312-0.981-0.669-1.346c-2.042-2.476-4.471-4.68-6.94-6.692c-5.319-4.337-11.403-7.964-18.117-9.425\r\n\t\t\t\tc-3.881-0.844-7.786-0.879-11.688-0.165c-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.587,6.231-13.574,10.28\r\n\t\t\t\tc-0.738,0.749-1.472,1.514-2.143,2.328c-0.893,1.083-0.893,2.366,0,3.45c2.042,2.476,4.47,4.679,6.94,6.692\r\n\t\t\t\tc5.32,4.337,11.403,7.963,18.118,9.424c3.881,0.844,7.787,0.88,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673\r\n\t\t\t\tc5.01-2.621,9.586-6.232,13.574-10.28c0.738-0.75,1.471-1.514,2.143-2.329c0.357-0.366,0.59-0.84,0.669-1.347\r\n\t\t\t\tc0-0.003,0.001-0.006,0.001-0.008c0.004-0.023,0.006-0.045,0.009-0.068c0.003-0.019,0.006-0.039,0.008-0.058\r\n\t\t\t\tc0.001-0.014,0.002-0.027,0.004-0.041c0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122\r\n\t\t\t\tC64.001,32.459,63.998,32.419,63.997,32.379z M32,44c-6.627,0-12-5.372-12-12c0-6.628,5.372-12,12-12s12,5.373,12,12\r\n\t\t\t\tC44,38.628,38.627,44,32,44z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,15c-0.721,0-1.374,0.265-1.891,0.689L23.1,15.678l-10.162,8.315H2.992\r\n\t\t\t\tv0.008C1.339,24.006,0,25.346,0,27v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C23.736,47.781,24.34,48,25,48\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C28,16.343,26.657,15,25,15z M36.903,17.926l-2.847,2.847C36.519,23.852,38,27.75,38,32\r\n\t\t\t\tc0,4.25-1.481,8.148-3.944,11.227l2.847,2.847C40.083,42.26,42,37.355,42,32C42,26.645,40.083,21.74,36.903,17.926z\r\n\t\t\t\t M44.701,10.128l-2.848,2.848C46.292,18.07,49,24.712,49,32c0,7.288-2.708,13.93-7.147,19.024l2.848,2.848\r\n\t\t\t\tC49.861,48.049,53,40.393,53,32C53,23.607,49.861,15.951,44.701,10.128z M52.493,2.336l-2.831,2.831\r\n\t\t\t\tC56.086,12.263,60,21.674,60,32c0,10.326-3.914,19.737-10.338,26.833l2.831,2.831C59.639,53.842,64,43.431,64,32\r\n\t\t\t\tC64,20.569,59.639,10.159,52.493,2.336z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,15c-0.721,0-1.374,0.265-1.891,0.689L23.1,15.678l-10.162,8.315H2.992\r\n\t\t\t\tv0.008C1.339,24.006,0,25.346,0,27v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C23.736,47.781,24.34,48,25,48\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C28,16.343,26.657,15,25,15z M36.903,17.926l-2.847,2.847C36.519,23.852,38,27.75,38,32\r\n\t\t\t\tc0,4.25-1.481,8.148-3.944,11.227l2.847,2.847C40.083,42.26,42,37.355,42,32C42,26.645,40.083,21.74,36.903,17.926z\r\n\t\t\t\t M44.701,10.128l-2.848,2.848C46.292,18.07,49,24.712,49,32c0,7.288-2.708,13.93-7.147,19.024l2.848,2.848\r\n\t\t\t\tC49.861,48.049,53,40.393,53,32C53,23.607,49.861,15.951,44.701,10.128z M52.493,2.336l-2.831,2.831\r\n\t\t\t\tC56.086,12.263,60,21.674,60,32c0,10.326-3.914,19.737-10.338,26.833l2.831,2.831C59.639,53.842,64,43.431,64,32\r\n\t\t\t\tC64,20.569,59.639,10.159,52.493,2.336z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.701,10.128l-2.848,2.848C52.292,18.07,55,24.712,55,32\r\n\t\t\t\tc0,7.288-2.708,13.93-7.147,19.024l2.848,2.848C55.861,48.049,59,40.393,59,32C59,23.607,55.861,15.951,50.701,10.128z M31,15\r\n\t\t\t\tc-0.721,0-1.374,0.265-1.891,0.689L29.1,15.678l-10.162,8.315H8.992v0.008C7.339,24.006,6,25.346,6,27v10c0,1.657,1.343,3,3,3\r\n\t\t\t\th10.024l10.211,7.426l0.005-0.007C29.736,47.781,30.34,48,31,48c1.657,0,3-1.343,3-3V18C34,16.343,32.657,15,31,15z\r\n\t\t\t\t M42.903,17.926l-2.847,2.847C42.519,23.852,44,27.75,44,32c0,4.25-1.481,8.148-3.944,11.227l2.847,2.847\r\n\t\t\t\tC46.083,42.26,48,37.355,48,32C48,26.645,46.083,21.74,42.903,17.926z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50.701,10.128l-2.848,2.848C52.292,18.07,55,24.712,55,32\r\n\t\t\t\tc0,7.288-2.708,13.93-7.147,19.024l2.848,2.848C55.861,48.049,59,40.393,59,32C59,23.607,55.861,15.951,50.701,10.128z M31,15\r\n\t\t\t\tc-0.721,0-1.374,0.265-1.891,0.689L29.1,15.678l-10.162,8.315H8.992v0.008C7.339,24.006,6,25.346,6,27v10c0,1.657,1.343,3,3,3\r\n\t\t\t\th10.024l10.211,7.426l0.005-0.007C29.736,47.781,30.34,48,31,48c1.657,0,3-1.343,3-3V18C34,16.343,32.657,15,31,15z\r\n\t\t\t\t M42.903,17.926l-2.847,2.847C42.519,23.852,44,27.75,44,32c0,4.25-1.481,8.148-3.944,11.227l2.847,2.847\r\n\t\t\t\tC46.083,42.26,48,37.355,48,32C48,26.645,46.083,21.74,42.903,17.926z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36,16c-0.721,0-1.374,0.265-1.891,0.689L34.1,16.678l-10.162,8.315h-9.946\r\n\t\t\t\tv0.008C12.339,25.006,11,26.346,11,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C34.736,48.781,35.34,49,36,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C39,17.343,37.657,16,36,16z M47.903,18.926l-2.847,2.847C47.519,24.852,49,28.75,49,33\r\n\t\t\t\tc0,4.25-1.481,8.148-3.944,11.227l2.847,2.847C51.083,43.26,53,38.355,53,33C53,27.645,51.083,22.74,47.903,18.926z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36,16c-0.721,0-1.374,0.265-1.891,0.689L34.1,16.678l-10.162,8.315h-9.946\r\n\t\t\t\tv0.008C12.339,25.006,11,26.346,11,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C34.736,48.781,35.34,49,36,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C39,17.343,37.657,16,36,16z M47.903,18.926l-2.847,2.847C47.519,24.852,49,28.75,49,33\r\n\t\t\t\tc0,4.25-1.481,8.148-3.944,11.227l2.847,2.847C51.083,43.26,53,38.355,53,33C53,27.645,51.083,22.74,47.903,18.926z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992\r\n\t\t\t\tv0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z M53.243,33l3.879-3.879C57.664,28.579,58,27.829,58,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,28.758l-3.879-3.879C44.578,24.336,43.828,24,43,24c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L44.757,33l-3.879,3.879C40.336,37.422,40,38.172,40,39c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L49,37.243l3.879,3.879C53.422,41.664,54.172,42,55,42c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L53.243,33z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992\r\n\t\t\t\tv0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z M53.243,33l3.879-3.879C57.664,28.579,58,27.829,58,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,28.758l-3.879-3.879C44.578,24.336,43.828,24,43,24c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L44.757,33l-3.879,3.879C40.336,37.422,40,38.172,40,39c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L49,37.243l3.879,3.879C53.422,41.664,54.172,42,55,42c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L53.243,33z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,30H43c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\t\tS56.657,30,55,30z M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28\r\n\t\t\t\tv10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M55,30H43c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\t\tS56.657,30,55,30z M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28\r\n\t\t\t\tv10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME__x2F__UP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992\r\n\t\t\t\tv0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z M55,30h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S56.657,30,55,30z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992\r\n\t\t\t\tv0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z M55,30h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S56.657,30,55,30z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"VOLUME__x2F__OFF_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42,16c-0.721,0-1.374,0.265-1.891,0.689L40.1,16.678l-10.162,8.315h-9.946\r\n\t\t\t\tv0.008C18.339,25.006,17,26.346,17,28v9.627l27.972-18.9C44.832,17.2,43.563,16,42,16z M30.024,41l10.211,7.426l0.005-0.007\r\n\t\t\t\tC40.736,48.781,41.34,49,42,49c1.657,0,3-1.343,3-3V29.57L28.083,41H30.024z M51,18.6c-0.312,0-0.601,0.095-0.841,0.258\r\n\t\t\t\tL13.064,43.955c-0.4,0.269-0.664,0.727-0.664,1.245c0,0.828,0.672,1.5,1.5,1.5c0.312,0,0.601-0.095,0.841-0.258l37.095-25.097\r\n\t\t\t\tc0.4-0.269,0.664-0.727,0.664-1.245C52.5,19.272,51.828,18.6,51,18.6z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42,16c-0.721,0-1.374,0.265-1.891,0.689L40.1,16.678l-10.162,8.315h-9.946\r\n\t\t\t\tv0.008C18.339,25.006,17,26.346,17,28v9.627l27.972-18.9C44.832,17.2,43.563,16,42,16z M30.024,41l10.211,7.426l0.005-0.007\r\n\t\t\t\tC40.736,48.781,41.34,49,42,49c1.657,0,3-1.343,3-3V29.57L28.083,41H30.024z M51,18.6c-0.312,0-0.601,0.095-0.841,0.258\r\n\t\t\t\tL13.064,43.955c-0.4,0.269-0.664,0.727-0.664,1.245c0,0.828,0.672,1.5,1.5,1.5c0.312,0,0.601-0.095,0.841-0.258l37.095-25.097\r\n\t\t\t\tc0.4-0.269,0.664-0.727,0.664-1.245C52.5,19.272,51.828,18.6,51,18.6z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PRINTER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PRINTER","display":"inline"},"children":[{"name":"g","attribs":{"id":"PRINTER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,15H3c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h10V34h38v15h10\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C64,16.343,62.657,15,61,15z M9,27c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3s3,1.343,3,3\r\n\t\t\t\tC12,25.657,10.657,27,9,27z M48,2.969h-0.003c0-0.001,0-0.002,0-0.003c-0.007-0.615-0.197-1.184-0.52-1.657\r\n\t\t\t\tc-0.005-0.007-0.012-0.013-0.017-0.02c-0.104-0.15-0.22-0.291-0.35-0.419c0,0,0,0,0,0c-0.002-0.002-0.005-0.004-0.008-0.006\r\n\t\t\t\tc-0.167-0.165-0.359-0.302-0.561-0.425c-0.002-0.001-0.005-0.002-0.007-0.004c0,0-0.001,0-0.001-0.001\r\n\t\t\t\tc-0.285-0.171-0.594-0.305-0.93-0.373c0,0,0,0,0,0c-0.138-0.028-0.282-0.034-0.426-0.043C45.117,0.014,45.06,0,45,0H19\r\n\t\t\t\tc-1.243,0-2.309,0.756-2.764,1.832C16.084,2.191,16,2.586,16,3v9h32V2.969z M16,61c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3\r\n\t\t\t\tV37H16V61z M22,43h20v3H22V43z M22,49h20v3H22V49z M22,55h20v3H22V55z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,15H3c-1.657,0-3,1.343-3,3v28c0,1.657,1.343,3,3,3h10V34h38v15h10\r\n\t\t\t\tc1.657,0,3-1.343,3-3V18C64,16.343,62.657,15,61,15z M9,27c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3s3,1.343,3,3\r\n\t\t\t\tC12,25.657,10.657,27,9,27z M48,2.969h-0.003c0-0.001,0-0.002,0-0.003c-0.007-0.615-0.197-1.184-0.52-1.657\r\n\t\t\t\tc-0.005-0.007-0.012-0.013-0.017-0.02c-0.104-0.15-0.22-0.291-0.35-0.419c0,0,0,0,0,0c-0.002-0.002-0.005-0.004-0.008-0.006\r\n\t\t\t\tc-0.167-0.165-0.359-0.302-0.561-0.425c-0.002-0.001-0.005-0.002-0.007-0.004c0,0-0.001,0-0.001-0.001\r\n\t\t\t\tc-0.285-0.171-0.594-0.305-0.93-0.373c0,0,0,0,0,0c-0.138-0.028-0.282-0.034-0.426-0.043C45.117,0.014,45.06,0,45,0H19\r\n\t\t\t\tc-1.243,0-2.309,0.756-2.764,1.832C16.084,2.191,16,2.586,16,3v9h32V2.969z M16,61c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3\r\n\t\t\t\tV37H16V61z M22,43h20v3H22V43z M22,49h20v3H22V49z M22,55h20v3H22V55z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__OUTGOING","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037\r\n\t\t\t\tl19.569-23.296L0.894,17.866z M25,16c0.828,0,1.578-0.336,2.121-0.879L29,13.243V27c0,1.657,1.343,3,3,3s3-1.343,3-3V13.243\r\n\t\t\t\tl1.879,1.879C37.422,15.664,38.172,16,39,16c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7\r\n\t\t\t\tC33.578,3.336,32.828,3,32,3c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,11.422,22,12.172,22,13C22,14.657,23.343,16,25,16z\r\n\t\t\t\t M63.002,17.78C62.47,17.3,61.773,17,61,17H43.443c-1.098,1.219-2.673,2-4.443,2c-0.344,0-0.673-0.053-1-0.11V27\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6v-8.11C25.673,18.947,25.344,19,25,19c-1.77,0-3.345-0.781-4.443-2H3\r\n\t\t\t\tc-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.106,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58\r\n\t\t\t\tV20C64,19.165,63.657,18.41,63.106,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.683,2.202,61,3,61h58\r\n\t\t\t\tc0.798,0,1.519-0.317,2.057-0.825L40.136,40.119L32,48z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0.894,17.866C0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037\r\n\t\t\t\tl19.569-23.296L0.894,17.866z M25,16c0.828,0,1.578-0.336,2.121-0.879L29,13.243V27c0,1.657,1.343,3,3,3s3-1.343,3-3V13.243\r\n\t\t\t\tl1.879,1.879C37.422,15.664,38.172,16,39,16c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7\r\n\t\t\t\tC33.578,3.336,32.828,3,32,3c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,11.422,22,12.172,22,13C22,14.657,23.343,16,25,16z\r\n\t\t\t\t M63.002,17.78C62.47,17.3,61.773,17,61,17H43.443c-1.098,1.219-2.673,2-4.443,2c-0.344,0-0.673-0.053-1-0.11V27\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6v-8.11C25.673,18.947,25.344,19,25,19c-1.77,0-3.345-0.781-4.443-2H3\r\n\t\t\t\tc-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.106,17.866L43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58\r\n\t\t\t\tV20C64,19.165,63.657,18.41,63.106,17.866z M32,48l-8.136-7.881L0.943,60.175C1.481,60.683,2.202,61,3,61h58\r\n\t\t\t\tc0.798,0,1.519-0.317,2.057-0.825L40.136,40.119L32,48z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAIL__x2F__INCOMING","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.879,29.122C30.422,29.664,31.172,30,32,30c0.829,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl7-7C41.664,21.579,42,20.829,42,20c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,19.757V6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v13.757l-1.879-1.879C26.578,17.336,25.828,17,25,17c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL29.879,29.122z M63.002,17.78C62.47,17.3,61.773,17,61,17H44.168C44.683,17.886,45,18.902,45,20\r\n\t\t\t\tc0,1.657-0.672,3.157-1.757,4.243l-7,7C35.157,32.328,33.657,33,32,33c-1.657,0-3.157-0.672-4.243-1.757l-7-7\r\n\t\t\t\tC19.672,23.157,19,21.657,19,20c0-1.098,0.317-2.114,0.832-3H3c-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.106,17.866\r\n\t\t\t\tL43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58V20C64,19.165,63.657,18.41,63.106,17.866z M0.894,17.866\r\n\t\t\t\tC0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,17.866z M32,48l-8.136-7.881L0.943,60.175\r\n\t\t\t\tC1.481,60.683,2.202,61,3,61h58c0.798,0,1.519-0.317,2.057-0.825L40.136,40.119L32,48z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M29.879,29.122C30.422,29.664,31.172,30,32,30c0.829,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl7-7C41.664,21.579,42,20.829,42,20c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L35,19.757V6c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v13.757l-1.879-1.879C26.578,17.336,25.828,17,25,17c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL29.879,29.122z M63.002,17.78C62.47,17.3,61.773,17,61,17H44.168C44.683,17.886,45,18.902,45,20\r\n\t\t\t\tc0,1.657-0.672,3.157-1.757,4.243l-7,7C35.157,32.328,33.657,33,32,33c-1.657,0-3.157-0.672-4.243-1.757l-7-7\r\n\t\t\t\tC19.672,23.157,19,21.657,19,20c0-1.098,0.317-2.114,0.832-3H3c-0.773,0-1.47,0.3-2.002,0.78L32,42L63.002,17.78z M63.106,17.866\r\n\t\t\t\tL43.622,36.741l19.569,23.296C63.689,59.502,64,58.789,64,58V20C64,19.165,63.657,18.41,63.106,17.866z M0.894,17.866\r\n\t\t\t\tC0.343,18.41,0,19.165,0,20v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,17.866z M32,48l-8.136-7.881L0.943,60.175\r\n\t\t\t\tC1.481,60.683,2.202,61,3,61h58c0.798,0,1.519-0.317,2.057-0.825L40.136,40.119L32,48z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAIL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAIL","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAIL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.002,10.78C62.47,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78\r\n\t\t\t\tL32,35L63.002,10.78z M0.894,10.866C0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z\r\n\t\t\t\t M32,41l-8.136-7.881L0.943,53.175C1.481,53.683,2.202,54,3,54h58c0.798,0,1.519-0.317,2.057-0.825L40.136,33.119L32,41z\r\n\t\t\t\t M63.106,10.866L43.622,29.741l19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.106,10.866z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.002,10.78C62.47,10.3,61.773,10,61,10H3c-0.773,0-1.47,0.3-2.002,0.78\r\n\t\t\t\tL32,35L63.002,10.78z M0.894,10.866C0.343,11.41,0,12.165,0,13v38c0,0.789,0.311,1.501,0.809,2.037l19.569-23.296L0.894,10.866z\r\n\t\t\t\t M32,41l-8.136-7.881L0.943,53.175C1.481,53.683,2.202,54,3,54h58c0.798,0,1.519-0.317,2.057-0.825L40.136,33.119L32,41z\r\n\t\t\t\t M63.106,10.866L43.622,29.741l19.569,23.296C63.689,52.502,64,51.789,64,51V13C64,12.165,63.657,11.41,63.106,10.866z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S4.343,7,6,7z\r\n\t\t\t\t M61,57H3V16h58V57z M27.758,37l-4.95,4.95c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0l4.95-4.95\r\n\t\t\t\tl4.95,4.95c1.172,1.172,3.071,1.172,4.243,0c1.172-1.172,1.171-3.071,0-4.243L36.243,37l4.95-4.95\r\n\t\t\t\tc1.172-1.172,1.172-3.071,0-4.243c-1.172-1.172-3.071-1.172-4.243,0L32,32.758l-4.95-4.95c-1.171-1.171-3.071-1.172-4.243,0\r\n\t\t\t\tc-1.171,1.172-1.171,3.071,0,4.243L27.758,37z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S4.343,7,6,7z\r\n\t\t\t\t M61,57H3V16h58V57z M27.758,37l-4.95,4.95c-1.172,1.172-1.172,3.071,0,4.243c1.172,1.172,3.071,1.172,4.243,0l4.95-4.95\r\n\t\t\t\tl4.95,4.95c1.172,1.172,3.071,1.172,4.243,0c1.172-1.172,1.171-3.071,0-4.243L36.243,37l4.95-4.95\r\n\t\t\t\tc1.172-1.172,1.172-3.071,0-4.243c-1.172-1.172-3.071-1.172-4.243,0L32,32.758l-4.95-4.95c-1.171-1.171-3.071-1.172-4.243,0\r\n\t\t\t\tc-1.171,1.172-1.171,3.071,0,4.243L27.758,37z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.879,45.121C27.422,45.664,28.172,46,29,46s1.578-0.336,2.121-0.879l12-12\r\n\t\t\t\tC43.664,32.579,44,31.828,44,31c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,38.757l-3.879-3.878\r\n\t\t\t\tC24.579,34.336,23.828,34,23,34c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,45.121z M61,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26.879,45.121C27.422,45.664,28.172,46,29,46s1.578-0.336,2.121-0.879l12-12\r\n\t\t\t\tC43.664,32.579,44,31.828,44,31c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L29,38.757l-3.879-3.878\r\n\t\t\t\tC24.579,34.336,23.828,34,23,34c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L26.879,45.121z M61,4H3\r\n\t\t\t\tC1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7C64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,40h4v0h16v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-7v0h-6v0h-7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C19,38.657,20.343,40,22,40z M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,40h4v0h16v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-7v0h-6v0h-7\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C19,38.657,20.343,40,22,40z M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3\r\n\t\t\t\tS4.343,7,6,7z M61,57H3V16h58V57z M22,40h7v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-7v-7c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3C19,38.657,20.343,40,22,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3\r\n\t\t\t\tS4.343,7,6,7z M61,57H3V16h58V57z M22,40h7v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7h7c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-7v-7c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3C19,38.657,20.343,40,22,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_3","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M15,57H3V31h12V57z M46,57H18V31h28V57z M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7\r\n\t\t\t\tz M15,57H3V31h12V57z M46,57H18V31h28V57z M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M46,57H3\r\n\t\t\t\tV31h43V57z M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S22.343,7,24,7z M15,7c1.657,0,3,1.343,3,3\r\n\t\t\t\ts-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3s-3-1.343-3-3S4.343,7,6,7z M46,57H3\r\n\t\t\t\tV31h43V57z M61,57H49V31h12V57z M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER_LAYOUT_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M61,57H18V31h43V57z M61,28H3V16h58V28z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3s-1.343,3-3,3c-1.657,0-3-1.343-3-3S13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3s-1.343,3-3,3\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S4.343,7,6,7z M15,57H3V31h12V57z M61,57H18V31h43V57z M61,28H3V16h58V28z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BROWSER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BROWSER","display":"inline"},"children":[{"name":"g","attribs":{"id":"BROWSER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3s-3-1.343-3-3C21,8.343,22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3C12,8.343,13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3C3,8.343,4.343,7,6,7z M61,57H3V16h58V57z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,4H3C1.343,4,0,5.343,0,7v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V7\r\n\t\t\t\tC64,5.343,62.657,4,61,4z M24,7c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3s-3-1.343-3-3C21,8.343,22.343,7,24,7z M15,7\r\n\t\t\t\tc1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3C12,8.343,13.343,7,15,7z M6,7c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,1.657-1.343,3-3,3c-1.657,0-3-1.343-3-3C3,8.343,4.343,7,6,7z M61,57H3V16h58V57z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MOUSTACHE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MOUSTACHE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MOUSTACHE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.827,26.719c-1.134-0.288-2.876,4.125-6.966,4.125\r\n\t\t\t\tc-5.253,0-7.725-8.839-15.934-8.839c-6.513,0-8.497,5.067-8.928,5.067c-0.431,0-2.415-5.067-8.927-5.067\r\n\t\t\t\tc-8.208,0-10.681,8.839-15.935,8.839c-4.09,0-5.83-4.413-6.964-4.125c-1.06,0.269,1.955,15.277,16.323,15.277\r\n\t\t\t\tc9.322,0,14.802-7.238,15.503-7.238c0.702,0,6.182,7.238,15.504,7.238C61.872,41.996,64.887,26.988,63.827,26.719z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M63.827,26.719c-1.134-0.288-2.876,4.125-6.966,4.125\r\n\t\t\t\tc-5.253,0-7.725-8.839-15.934-8.839c-6.513,0-8.497,5.067-8.928,5.067c-0.431,0-2.415-5.067-8.927-5.067\r\n\t\t\t\tc-8.208,0-10.681,8.839-15.935,8.839c-4.09,0-5.83-4.413-6.964-4.125c-1.06,0.269,1.955,15.277,16.323,15.277\r\n\t\t\t\tc9.322,0,14.802-7.238,15.503-7.238c0.702,0,6.182,7.238,15.504,7.238C61.872,41.996,64.887,26.988,63.827,26.719z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LIST_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LIST_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"LIST_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9,45H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tC12,46.343,10.657,45,9,45z M61,29H21c-1.657,0-3,1.343-3,3s1.343,3,3,3c0,0,0,0,0,0h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M9,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6c0,0,0,0,0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tS10.657,29,9,29z M21,19h40c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H21.001c0,0-0.001,0-0.001,0c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC18,17.657,19.343,19,21,19z M9,13C9,13,8.999,13,8.999,13H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3\r\n\t\t\t\tC12,14.343,10.657,13,9,13z M61,45H21c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3l0,0h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,46.343,62.657,45,61,45z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9,45H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6l0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tC12,46.343,10.657,45,9,45z M61,29H21c-1.657,0-3,1.343-3,3s1.343,3,3,3c0,0,0,0,0,0h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M9,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6c0,0,0,0,0,0c1.657,0,3-1.343,3-3\r\n\t\t\t\tS10.657,29,9,29z M21,19h40c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H21.001c0,0-0.001,0-0.001,0c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC18,17.657,19.343,19,21,19z M9,13C9,13,8.999,13,8.999,13H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h6c1.657,0,3-1.343,3-3\r\n\t\t\t\tC12,14.343,10.657,13,9,13z M61,45H21c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3l0,0h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,46.343,62.657,45,61,45z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LIST_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LIST","display":"inline"},"children":[{"name":"g","attribs":{"id":"LIST","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,19h58c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC0,17.657,1.343,19,3,19z M61,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z\r\n\t\t\t\t M61,45H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,46.343,62.657,45,61,45z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,19h58c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC0,17.657,1.343,19,3,19z M61,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,30.343,62.657,29,61,29z\r\n\t\t\t\t M61,45H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,46.343,62.657,45,61,45z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MORE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MORE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MORE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.001,26C9.687,26,7,28.687,7,32.002c0,3.315,2.687,6.001,6.001,6.001\r\n\t\t\t\tc3.314,0,6.001-2.687,6.001-6.001C19.001,28.687,16.315,26,13.001,26z M51.001,26C47.687,26,45,28.687,45,32.002\r\n\t\t\t\tc0,3.315,2.687,6.001,6.001,6.001c3.314,0,6.001-2.687,6.001-6.001C57.001,28.687,54.315,26,51.001,26z M32.001,26\r\n\t\t\t\tC28.687,26,26,28.687,26,32.002c0,3.315,2.686,6.001,6.001,6.001s6.001-2.687,6.001-6.001C38.001,28.687,35.315,26,32.001,26z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.001,26C9.687,26,7,28.687,7,32.002c0,3.315,2.687,6.001,6.001,6.001\r\n\t\t\t\tc3.314,0,6.001-2.687,6.001-6.001C19.001,28.687,16.315,26,13.001,26z M51.001,26C47.687,26,45,28.687,45,32.002\r\n\t\t\t\tc0,3.315,2.687,6.001,6.001,6.001c3.314,0,6.001-2.687,6.001-6.001C57.001,28.687,54.315,26,51.001,26z M32.001,26\r\n\t\t\t\tC28.687,26,26,28.687,26,32.002c0,3.315,2.686,6.001,6.001,6.001s6.001-2.687,6.001-6.001C38.001,28.687,35.315,26,32.001,26z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44,31.994c0-0.002,0-0.005,0-0.007c0-0.848-0.352-1.613-0.918-2.159\r\n\t\t\t\tl0.001-0.001l-18-18l-0.008,0.008C24.536,11.318,23.806,11,23,11c-1.657,0-3,1.343-3,3c0,0.91,0.406,1.725,1.046,2.275\r\n\t\t\t\tl15.718,15.718L20.84,47.917l0.001,0.001C20.321,48.458,20,49.191,20,50c0,1.657,1.343,3,3,3c0.809,0,1.542-0.321,2.082-0.841\r\n\t\t\t\tl0.001,0.001l18-18l-0.001-0.001C43.648,33.613,44,32.848,44,32C44,31.998,44,31.996,44,31.994z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44,31.994c0-0.002,0-0.005,0-0.007c0-0.848-0.352-1.613-0.918-2.159\r\n\t\t\t\tl0.001-0.001l-18-18l-0.008,0.008C24.536,11.318,23.806,11,23,11c-1.657,0-3,1.343-3,3c0,0.91,0.406,1.725,1.046,2.275\r\n\t\t\t\tl15.718,15.718L20.84,47.917l0.001,0.001C20.321,48.458,20,49.191,20,50c0,1.657,1.343,3,3,3c0.809,0,1.542-0.321,2.082-0.841\r\n\t\t\t\tl0.001,0.001l18-18l-0.001-0.001C43.648,33.613,44,32.848,44,32C44,31.998,44,31.996,44,31.994z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW__x2F__LEFT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.16,47.917L27.236,31.994l15.718-15.718C43.594,15.725,44,14.91,44,14\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.806,0-1.536,0.318-2.075,0.835l-0.008-0.008l-18,18l0.001,0.001C20.352,30.374,20,31.139,20,31.987\r\n\t\t\t\tc0,0.002,0,0.004,0,0.007c0,0.002,0,0.004,0,0.007c0,0.848,0.352,1.613,0.918,2.159l-0.001,0.001l18,18l0.001-0.001\r\n\t\t\t\tC39.458,52.679,40.191,53,41,53c1.657,0,3-1.343,3-3C44,49.191,43.679,48.458,43.16,47.917L43.16,47.917z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.16,47.917L27.236,31.994l15.718-15.718C43.594,15.725,44,14.91,44,14\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.806,0-1.536,0.318-2.075,0.835l-0.008-0.008l-18,18l0.001,0.001C20.352,30.374,20,31.139,20,31.987\r\n\t\t\t\tc0,0.002,0,0.004,0,0.007c0,0.002,0,0.004,0,0.007c0,0.848,0.352,1.613,0.918,2.159l-0.001,0.001l18,18l0.001-0.001\r\n\t\t\t\tC39.458,52.679,40.191,53,41,53c1.657,0,3-1.343,3-3C44,49.191,43.679,48.458,43.16,47.917L43.16,47.917z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW__x2F__UP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.159,38.918L52.159,38.918L34.16,20.917l-0.001,0.001\r\n\t\t\t\tC33.613,20.352,32.848,20,32,20c-0.002,0-0.004,0-0.007,0s-0.004,0-0.007,0c-0.848,0-1.613,0.352-2.159,0.918l-0.001-0.001\r\n\t\t\t\tl-18,18l0.008,0.008C11.318,39.464,11,40.195,11,41c0,1.657,1.343,3,3,3c0.91,0,1.725-0.406,2.275-1.046l15.718-15.718\r\n\t\t\t\tL47.917,43.16l0.001-0.001C48.458,43.679,49.191,44,50,44c1.657,0,3-1.343,3-3C53,40.191,52.679,39.458,52.159,38.918z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52.159,38.918L52.159,38.918L34.16,20.917l-0.001,0.001\r\n\t\t\t\tC33.613,20.352,32.848,20,32,20c-0.002,0-0.004,0-0.007,0s-0.004,0-0.007,0c-0.848,0-1.613,0.352-2.159,0.918l-0.001-0.001\r\n\t\t\t\tl-18,18l0.008,0.008C11.318,39.464,11,40.195,11,41c0,1.657,1.343,3,3,3c0.91,0,1.725-0.406,2.275-1.046l15.718-15.718\r\n\t\t\t\tL47.917,43.16l0.001-0.001C48.458,43.679,49.191,44,50,44c1.657,0,3-1.343,3-3C53,40.191,52.679,39.458,52.159,38.918z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ARROW__x2F__DOWN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{"id":"ARROW__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,23c0-1.657-1.343-3-3-3c-0.809,0-1.542,0.321-2.082,0.841l-0.001-0.001\r\n\t\t\t\tL31.993,36.764L16.275,21.046C15.725,20.406,14.91,20,14,20c-1.657,0-3,1.343-3,3c0,0.805,0.318,1.536,0.835,2.075l-0.008,0.008\r\n\t\t\t\tl18,18l0.001-0.001C30.374,43.648,31.139,44,31.987,44c0.002,0,0.004,0,0.007,0c0.002,0,0.004,0,0.007,0\r\n\t\t\t\tc0.848,0,1.613-0.352,2.159-0.918l0.001,0.001l18-18l-0.001-0.001C52.679,24.543,53,23.809,53,23z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,23c0-1.657-1.343-3-3-3c-0.809,0-1.542,0.321-2.082,0.841l-0.001-0.001\r\n\t\t\t\tL31.993,36.764L16.275,21.046C15.725,20.406,14.91,20,14,20c-1.657,0-3,1.343-3,3c0,0.805,0.318,1.536,0.835,2.075l-0.008,0.008\r\n\t\t\t\tl18,18l0.001-0.001C30.374,43.648,31.139,44,31.987,44c0.002,0,0.004,0,0.007,0c0.002,0,0.004,0,0.007,0\r\n\t\t\t\tc0.848,0,1.613-0.352,2.159-0.918l0.001,0.001l18-18l-0.001-0.001C52.679,24.543,53,23.809,53,23z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOSE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOSE","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOSE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.243,32l11.879-11.879C48.664,19.579,49,18.828,49,18c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.757L20.121,15.879C19.578,15.336,18.828,15,18,15c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32L15.879,43.879C15.336,44.422,15,45.172,15,46c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L32,36.243l11.879,11.879C44.422,48.664,45.172,49,46,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M36.243,32l11.879-11.879C48.664,19.579,49,18.828,49,18c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.757L20.121,15.879C19.578,15.336,18.828,15,18,15c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32L15.879,43.879C15.336,44.422,15,45.172,15,46c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L32,36.243l11.879,11.879C44.422,48.664,45.172,49,46,49c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TICK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TICK","display":"inline"},"children":[{"name":"g","attribs":{"id":"TICK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,18c-0.828,0-1.578,0.336-2.121,0.879L27,39.757L16.121,28.879\r\n\t\t\t\tC15.578,28.336,14.828,28,14,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l13,13C25.422,46.664,26.172,47,27,47\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l23-23C52.664,22.579,53,21.828,53,21C53,19.343,51.657,18,50,18z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,18c-0.828,0-1.578,0.336-2.121,0.879L27,39.757L16.121,28.879\r\n\t\t\t\tC15.578,28.336,14.828,28,14,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l13,13C25.422,46.664,26.172,47,27,47\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l23-23C52.664,22.579,53,21.828,53,21C53,19.343,51.657,18,50,18z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MINUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MINUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"MINUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,29H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tS53.657,29,52,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,29H12c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tS53.657,29,52,29z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PLUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PLUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"PLUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,29H35V12c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v17H12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h17v17c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h17c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,29H35V12c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v17H12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h17v17c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h17c1.657,0,3-1.343,3-3S53.657,29,52,29z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BOOKMARK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOKMARK","display":"inline"},"children":[{"name":"g","attribs":{"id":"BOOKMARK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,5H23c-1.657,0-3,1.343-3,3v51l12-12l12,12V8C44,6.343,42.657,5,41,5z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,5H23c-1.657,0-3,1.343-3,3v51l12-12l12,12V8C44,6.343,42.657,5,41,5z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BOOK_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"BOOK_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.759,32.731L10.759,32.731l11,5l0,0C22.137,37.903,22.557,38,23,38\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5v0C12.863,27.097,12.443,27,12,27c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,31.214,9.721,32.259,10.759,32.731z M10.759,43.731L10.759,43.731l11,5l0,0C22.137,48.903,22.557,49,23,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5v0C12.863,38.097,12.443,38,12,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,42.214,9.721,43.259,10.759,43.731z M10.759,21.731L10.759,21.731l11,5l0,0C22.137,26.903,22.557,27,23,27\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731h0l-11-5v0C12.863,16.097,12.443,16,12,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,20.214,9.721,21.259,10.759,21.731z M41,49c0.443,0,0.863-0.097,1.241-0.269l0,0l11-5v0C54.279,43.259,55,42.214,55,41\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5v0C38.721,43.741,38,44.786,38,46C38,47.657,39.343,49,41,49z\r\n\t\t\t\t M61,0c-0.406,0-0.794,0.082-1.147,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.78l28.942,11.976C31.177,63.913,31.578,64,32,64c0.422,0,0.823-0.087,1.187-0.245L62.129,51.78\r\n\t\t\t\tC63.226,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z M41,38c0.443,0,0.863-0.097,1.241-0.269l0,0l11-5C54.279,32.259,55,31.214,55,30c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5v0C38.721,32.741,38,33.786,38,35C38,36.657,39.343,38,41,38z M41,27\r\n\t\t\t\tc0.443,0,0.863-0.097,1.241-0.269l0,0l11-5v0C54.279,21.259,55,20.214,55,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5C38.721,21.741,38,22.786,38,24C38,25.657,39.343,27,41,27z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.759,32.731L10.759,32.731l11,5l0,0C22.137,37.903,22.557,38,23,38\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5v0C12.863,27.097,12.443,27,12,27c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,31.214,9.721,32.259,10.759,32.731z M10.759,43.731L10.759,43.731l11,5l0,0C22.137,48.903,22.557,49,23,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731l0,0l-11-5v0C12.863,38.097,12.443,38,12,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,42.214,9.721,43.259,10.759,43.731z M10.759,21.731L10.759,21.731l11,5l0,0C22.137,26.903,22.557,27,23,27\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.214-0.721-2.259-1.759-2.731h0l-11-5v0C12.863,16.097,12.443,16,12,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC9,20.214,9.721,21.259,10.759,21.731z M41,49c0.443,0,0.863-0.097,1.241-0.269l0,0l11-5v0C54.279,43.259,55,42.214,55,41\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5v0C38.721,43.741,38,44.786,38,46C38,47.657,39.343,49,41,49z\r\n\t\t\t\t M61,0c-0.406,0-0.794,0.082-1.147,0.228l0,0L59.848,0.23c-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241\r\n\t\t\t\tC4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228l0,0C3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46\r\n\t\t\t\tc0,1.257,0.774,2.333,1.871,2.78l28.942,11.976C31.177,63.913,31.578,64,32,64c0.422,0,0.823-0.087,1.187-0.245L62.129,51.78\r\n\t\t\t\tC63.226,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995V7.488l23,9.517V56.512z M58,46.995l-23,9.517\r\n\t\t\t\tV17.005l23-9.517V46.995z M41,38c0.443,0,0.863-0.097,1.241-0.269l0,0l11-5C54.279,32.259,55,31.214,55,30c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5v0C38.721,32.741,38,33.786,38,35C38,36.657,39.343,38,41,38z M41,27\r\n\t\t\t\tc0.443,0,0.863-0.097,1.241-0.269l0,0l11-5v0C54.279,21.259,55,20.214,55,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.443,0-0.863,0.097-1.241,0.269l0,0l-11,5C38.721,21.741,38,22.786,38,24C38,25.657,39.343,27,41,27z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BOOK_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"BOOK_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0c-0.406,0-0.794,0.082-1.147,0.228l0,0L59.848,0.23\r\n\t\t\t\tc-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241C4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228v0\r\n\t\t\t\tC3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46c0,1.257,0.774,2.333,1.871,2.78l28.942,11.976C31.177,63.913,31.578,64,32,64\r\n\t\t\t\tc0.422,0,0.823-0.087,1.187-0.245L62.129,51.78C63.226,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995\r\n\t\t\t\tV7.488l23,9.517V56.512z M58,46.995l-23,9.517V17.005l23-9.517V46.995z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0c-0.406,0-0.794,0.082-1.147,0.228l0,0L59.848,0.23\r\n\t\t\t\tc-0.009,0.004-0.018,0.007-0.027,0.011L32,11.753L4.179,0.241C4.17,0.237,4.161,0.234,4.152,0.23L4.147,0.228v0\r\n\t\t\t\tC3.794,0.082,3.406,0,3,0C1.343,0,0,1.343,0,3v46c0,1.257,0.774,2.333,1.871,2.78l28.942,11.976C31.177,63.913,31.578,64,32,64\r\n\t\t\t\tc0.422,0,0.823-0.087,1.187-0.245L62.129,51.78C63.226,51.333,64,50.257,64,49V3C64,1.343,62.657,0,61,0z M29,56.512L6,46.995\r\n\t\t\t\tV7.488l23,9.517V56.512z M58,46.995l-23,9.517V17.005l23-9.517V46.995z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BOOK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BOOK","display":"inline"},"children":[{"name":"g","attribs":{"id":"BOOK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10,18h8c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC7,16.657,8.343,18,10,18z M10,35h8c1.657,0,3-1.343,3-3s-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,35,10,35z M54,3h-3v58h3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M13,6v3h5c3.314,0,6,2.686,6,6c0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6\r\n\t\t\t\tc0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6s-2.686,6-6,6h-5v3c0,1.657,1.343,3,3,3h32V3H16C14.343,3,13,4.343,13,6z M21,49\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8C19.657,52,21,50.657,21,49z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10,18h8c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC7,16.657,8.343,18,10,18z M10,35h8c1.657,0,3-1.343,3-3s-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3S8.343,35,10,35z M54,3h-3v58h3\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C57,4.343,55.657,3,54,3z M13,6v3h5c3.314,0,6,2.686,6,6c0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6\r\n\t\t\t\tc0,3.314-2.686,6-6,6h-5v5h5c3.314,0,6,2.686,6,6s-2.686,6-6,6h-5v3c0,1.657,1.343,3,3,3h32V3H16C14.343,3,13,4.343,13,6z M21,49\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-8c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8C19.657,52,21,50.657,21,49z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,46\r\n\t\t\t\tc0-1.657,0.672-3.157,1.757-4.243l7-7C45.843,33.672,47.343,33,49,33v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8\r\n\t\t\t\tC6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h35v-7.101C42.673,51.954,42.343,52,42,52C38.686,52,36,49.314,36,46z\r\n\t\t\t\t M58.121,43.879l-7-7C50.578,36.336,49.828,36,49,36c-0.828,0-1.578,0.336-2.121,0.879l-7,7C39.336,44.422,39,45.172,39,46\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L46,46.243V60c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V46.243l1.879,1.879\r\n\t\t\t\tC54.422,48.664,55.172,49,56,49c1.657,0,3-1.343,3-3C59,45.172,58.664,44.422,58.121,43.879z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,46\r\n\t\t\t\tc0-1.657,0.672-3.157,1.757-4.243l7-7C45.843,33.672,47.343,33,49,33v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8\r\n\t\t\t\tC6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h35v-7.101C42.673,51.954,42.343,52,42,52C38.686,52,36,49.314,36,46z\r\n\t\t\t\t M58.121,43.879l-7-7C50.578,36.336,49.828,36,49,36c-0.828,0-1.578,0.336-2.121,0.879l-7,7C39.336,44.422,39,45.172,39,46\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L46,46.243V60c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V46.243l1.879,1.879\r\n\t\t\t\tC54.422,48.664,55.172,49,56,49c1.657,0,3-1.343,3-3C59,45.172,58.664,44.422,58.121,43.879z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,53\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0.343,0,0.673,0.046,1,0.101V39c0-3.314,2.686-6,6-6c0,0,0,0,0,0v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8\r\n\t\t\t\tC6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h31.515l-1.757-1.757C36.672,56.157,36,54.657,36,53z M56,50\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L52,52.757V39c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v13.757l-1.879-1.879\r\n\t\t\t\tC43.578,50.336,42.828,50,42,50c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l7,7C47.422,62.664,48.172,63,49,63\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C58.664,54.579,59,53.829,59,53C59,51.343,57.657,50,56,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,21.008h19L27.039,1H27v17.001C27,19.662,28.343,21.008,30,21.008z M36,53\r\n\t\t\t\tc0-3.314,2.686-6,6-6c0.343,0,0.673,0.046,1,0.101V39c0-3.314,2.686-6,6-6c0,0,0,0,0,0v-8.986H30c-3.314,0-6-2.692-6-6.013V1H8\r\n\t\t\t\tC6.343,1,5,2.343,5,4v52c0,1.657,1.343,3,3,3h31.515l-1.757-1.757C36.672,56.157,36,54.657,36,53z M56,50\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L52,52.757V39c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v13.757l-1.879-1.879\r\n\t\t\t\tC43.578,50.336,42.828,50,42,50c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l7,7C47.422,62.664,48.172,63,49,63\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C58.664,54.579,59,53.829,59,53C59,51.343,57.657,50,56,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,22.008h19L27,1.964v17.037C27,20.662,28.343,22.008,30,22.008z M41.515,54\r\n\t\t\t\tl-1.757-1.757C38.672,51.157,38,49.657,38,48c0-3.314,2.686-6,6-6c1.657,0,3.153,0.675,4.238,1.762l0.005-0.005L49,44.515v-19.5\r\n\t\t\t\tH30c-3.314,0-6-2.692-6-6.013V2H8C6.343,2,5,3.343,5,5v52c0,1.657,1.343,3,3,3h28v0h2c0-1.657,0.672-3.156,1.758-4.242\r\n\t\t\t\tl-0.001-0.001L41.515,54z M54.243,54l3.879-3.878C58.664,49.578,59,48.828,59,48c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L50,49.758l-3.879-3.879C45.578,45.336,44.829,45,44,45c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L45.757,54l-3.879,3.879C41.336,58.422,41,59.172,41,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L50,58.243l3.879,3.879C54.422,62.664,55.172,63,56,63c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L54.243,54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,22.008h19L27,1.964v17.037C27,20.662,28.343,22.008,30,22.008z M41.515,54\r\n\t\t\t\tl-1.757-1.757C38.672,51.157,38,49.657,38,48c0-3.314,2.686-6,6-6c1.657,0,3.153,0.675,4.238,1.762l0.005-0.005L49,44.515v-19.5\r\n\t\t\t\tH30c-3.314,0-6-2.692-6-6.013V2H8C6.343,2,5,3.343,5,5v52c0,1.657,1.343,3,3,3h28v0h2c0-1.657,0.672-3.156,1.758-4.242\r\n\t\t\t\tl-0.001-0.001L41.515,54z M54.243,54l3.879-3.878C58.664,49.578,59,48.828,59,48c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L50,49.758l-3.879-3.879C45.578,45.336,44.829,45,44,45c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L45.757,54l-3.879,3.879C41.336,58.422,41,59.172,41,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L50,58.243l3.879,3.879C54.422,62.664,55.172,63,56,63c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L54.243,54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,23.008h19L27,2.964v17.037C27,21.662,28.343,23.008,30,23.008z M56,48\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L48,54.757l-1.879-1.879C45.578,52.336,44.828,52,44,52c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.829,0.336,1.578,0.879,2.121l4,4C46.422,61.664,47.172,62,48,62s1.578-0.336,2.121-0.879l8-8C58.664,52.579,59,51.828,59,51\r\n\t\t\t\tC59,49.343,57.657,48,56,48z M38,55c0-3.314,2.686-6,6-6c1.533,0,2.909,0.599,3.967,1.547L49,49.515v-23.5H30\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V3H8C6.343,3,5,4.343,5,6v52c0,1.657,1.343,3,3,3h23v0h10.515l-1.757-1.757\r\n\t\t\t\tC38.672,58.157,38,56.657,38,55z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,23.008h19L27,2.964v17.037C27,21.662,28.343,23.008,30,23.008z M56,48\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L48,54.757l-1.879-1.879C45.578,52.336,44.828,52,44,52c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.829,0.336,1.578,0.879,2.121l4,4C46.422,61.664,47.172,62,48,62s1.578-0.336,2.121-0.879l8-8C58.664,52.579,59,51.828,59,51\r\n\t\t\t\tC59,49.343,57.657,48,56,48z M38,55c0-3.314,2.686-6,6-6c1.533,0,2.909,0.599,3.967,1.547L49,49.515v-23.5H30\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V3H8C6.343,3,5,4.343,5,6v52c0,1.657,1.343,3,3,3h23v0h10.515l-1.757-1.757\r\n\t\t\t\tC38.672,58.157,38,56.657,38,55z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,23.008h19L28,2.964v17.037C28,21.662,29.343,23.008,31,23.008z M38,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6h6V26.014H31c-3.314,0-6-2.692-6-6.013V2.964h-9V3H9C7.343,3,6,4.343,6,6v52c0,1.657,1.343,3,3,3h35\r\n\t\t\t\tc0,0,0,0,0,0C40.686,61,38,58.314,38,55z M56,52H44c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S57.657,52,56,52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,23.008h19L28,2.964v17.037C28,21.662,29.343,23.008,31,23.008z M38,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6h6V26.014H31c-3.314,0-6-2.692-6-6.013V2.964h-9V3H9C7.343,3,6,4.343,6,6v52c0,1.657,1.343,3,3,3h35\r\n\t\t\t\tc0,0,0,0,0,0C40.686,61,38,58.314,38,55z M56,52H44c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S57.657,52,56,52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,22.008h19L28,1.964v17.037C28,20.662,29.343,22.008,31,22.008z M56,51h-3\r\n\t\t\t\tv-3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S57.657,51,56,51z M38,54c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6V25.014H31\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V1.964h-9V2H9C7.343,2,6,3.343,6,5v52c0,1.657,1.343,3,3,3h35c0,0,0,0,0,0C40.686,60,38,57.314,38,54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,22.008h19L28,1.964v17.037C28,20.662,29.343,22.008,31,22.008z M56,51h-3\r\n\t\t\t\tv-3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.657,0,3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S57.657,51,56,51z M38,54c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6V25.014H31\r\n\t\t\t\tc-3.314,0-6-2.692-6-6.013V1.964h-9V2H9C7.343,2,6,3.343,6,5v52c0,1.657,1.343,3,3,3h35c0,0,0,0,0,0C40.686,60,38,57.314,38,54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENTS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENTS","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENTS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,17.001V0H16c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38\r\n\t\t\t\tc1.657,0,3-1.343,3-3V23.015H38C34.686,23.015,32,20.322,32,17.001z M38,20.008h19L35-0.036v17.037\r\n\t\t\t\tC35,18.662,36.343,20.008,38,20.008z M10,55V6C8.343,6,7,7.343,7,9v49c0,3.314,2.686,6,6,6h35c1.657,0,3-1.343,3-3H16\r\n\t\t\t\tC12.686,61,10,58.314,10,55z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,17.001V0H16c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38\r\n\t\t\t\tc1.657,0,3-1.343,3-3V23.015H38C34.686,23.015,32,20.322,32,17.001z M38,20.008h19L35-0.036v17.037\r\n\t\t\t\tC35,18.662,36.343,20.008,38,20.008z M10,55V6C8.343,6,7,7.343,7,9v49c0,3.314,2.686,6,6,6h35c1.657,0,3-1.343,3-3H16\r\n\t\t\t\tC12.686,61,10,58.314,10,55z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOCUMENT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOCUMENT","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOCUMENT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35,23.008h19L32,2.964v17.037C32,21.662,33.343,23.008,35,23.008z M29,20.001\r\n\t\t\t\tV3H13c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V26.014H35C31.686,26.014,29,23.322,29,20.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35,23.008h19L32,2.964v17.037C32,21.662,33.343,23.008,35,23.008z M29,20.001\r\n\t\t\t\tV3H13c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h38c1.657,0,3-1.343,3-3V26.014H35C31.686,26.014,29,23.322,29,20.001z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,47.757\r\n\t\t\t\tl-3.879-3.879C50.578,43.336,49.828,43,49,43c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L50.757,52l-3.879,3.879\r\n\t\t\t\tC46.336,56.422,46,57.172,46,58c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,56.243l3.879,3.879\r\n\t\t\t\tC59.422,60.664,60.172,61,61,61c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,52l3.879-3.879\r\n\t\t\t\tC63.664,47.578,64,46.829,64,46z M0,51c0,1.657,1.343,3,3,3h41v0h0.557c0.07-0.078,0.126-0.168,0.2-0.243L46.515,52l-1.757-1.758\r\n\t\t\t\tC43.672,49.157,43,47.657,43,46c0-3.314,2.686-6,6-6c1.657,0,3.157,0.672,4.243,1.757L55,43.515l1.757-1.757\r\n\t\t\t\tC57.843,40.672,59.343,40,61,40c1.098,0,2.114,0.317,3,0.832V19H0V51z M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3\r\n\t\t\t\tC64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,47.757\r\n\t\t\t\tl-3.879-3.879C50.578,43.336,49.828,43,49,43c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L50.757,52l-3.879,3.879\r\n\t\t\t\tC46.336,56.422,46,57.172,46,58c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,56.243l3.879,3.879\r\n\t\t\t\tC59.422,60.664,60.172,61,61,61c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,52l3.879-3.879\r\n\t\t\t\tC63.664,47.578,64,46.829,64,46z M0,51c0,1.657,1.343,3,3,3h41v0h0.557c0.07-0.078,0.126-0.168,0.2-0.243L46.515,52l-1.757-1.758\r\n\t\t\t\tC43.672,49.157,43,47.657,43,46c0-3.314,2.686-6,6-6c1.657,0,3.157,0.672,4.243,1.757L55,43.515l1.757-1.757\r\n\t\t\t\tC57.843,40.672,59.343,40,61,40c1.098,0,2.114,0.317,3,0.832V19H0V51z M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3\r\n\t\t\t\tC64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLDER__x2F__OK_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,46c-0.828,0-1.578,0.336-2.121,0.879L53,52.758l-1.879-1.879\r\n\t\t\t\tC50.578,50.336,49.828,50,49,50c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l4,4C51.422,59.664,52.172,60,53,60\r\n\t\t\t\ts1.578-0.336,2.121-0.879l8-8C63.664,50.579,64,49.828,64,49C64,47.343,62.657,46,61,46z M61,11H23.982L18,5H3\r\n\t\t\t\tC1.343,5,0,6.343,0,8v9h64v-3C64,12.343,62.657,11,61,11z M0,52c0,1.657,1.343,3,3,3h40.367c0,0,0,0,0,0\r\n\t\t\t\tC43.144,54.372,43,53.705,43,53c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538l3.781-3.781C57.843,43.672,59.343,43,61,43\r\n\t\t\t\tc1.099,0,2.114,0.317,3,0.832V20H0V52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,46c-0.828,0-1.578,0.336-2.121,0.879L53,52.758l-1.879-1.879\r\n\t\t\t\tC50.578,50.336,49.828,50,49,50c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l4,4C51.422,59.664,52.172,60,53,60\r\n\t\t\t\ts1.578-0.336,2.121-0.879l8-8C63.664,50.579,64,49.828,64,49C64,47.343,62.657,46,61,46z M61,11H23.982L18,5H3\r\n\t\t\t\tC1.343,5,0,6.343,0,8v9h64v-3C64,12.343,62.657,11,61,11z M0,52c0,1.657,1.343,3,3,3h40.367c0,0,0,0,0,0\r\n\t\t\t\tC43.144,54.372,43,53.705,43,53c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538l3.781-3.781C57.843,43.672,59.343,43,61,43\r\n\t\t\t\tc1.099,0,2.114,0.317,3,0.832V20H0V52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,54c0,1.657,1.343,3,3,3h39.367C42.144,56.372,42,55.705,42,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6h12c1.544,0,2.937,0.599,4,1.557V22H0V54z M60,52H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z M61,13H23.982L18,7H3c-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z\r\n\t\t\t\t"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,54c0,1.657,1.343,3,3,3h39.367C42.144,56.372,42,55.705,42,55\r\n\t\t\t\tc0-3.314,2.686-6,6-6h12c1.544,0,2.937,0.599,4,1.557V22H0V54z M60,52H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z M61,13H23.982L18,7H3c-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z\r\n\t\t\t\t"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLDER__x2F__OK_2_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLDER__x2F__OK_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,49h-3v-3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3h-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tC63,50.343,61.657,49,60,49z M0,51c0,1.657,1.343,3,3,3h39.367C42.144,53.372,42,52.705,42,52c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6s6,2.686,6,6c1.544,0,2.937,0.599,4,1.557V19H0V51z M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3\r\n\t\t\t\tC64,11.343,62.657,10,61,10z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,49h-3v-3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3h-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tC63,50.343,61.657,49,60,49z M0,51c0,1.657,1.343,3,3,3h39.367C42.144,53.372,42,52.705,42,52c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6s6,2.686,6,6c1.544,0,2.937,0.599,4,1.557V19H0V51z M61,10H23.982L18,4H3C1.343,4,0,5.343,0,7v9h64v-3\r\n\t\t\t\tC64,11.343,62.657,10,61,10z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLDER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLDER","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLDER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,54c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V22H0V54z M61,13H23.982L18,7\r\n\t\t\t\tH3c-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,54c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V22H0V54z M61,13H23.982L18,7\r\n\t\t\t\tH3c-1.657,0-3,1.343-3,3v9h64v-3C64,14.343,62.657,13,61,13z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_NEXT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39,22c-1.657,0-3,1.343-3,3v4.29l-9.235-6.717L26.76,22.58\r\n\t\t\t\tC26.264,22.219,25.66,22,25,22c-1.657,0-3,1.343-3,3v14c0,1.657,1.343,3,3,3c0.66,0,1.264-0.219,1.76-0.58l0.005,0.007L36,34.71\r\n\t\t\t\tV39c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V25C42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39,22c-1.657,0-3,1.343-3,3v4.29l-9.235-6.717L26.76,22.58\r\n\t\t\t\tC26.264,22.219,25.66,22,25,22c-1.657,0-3,1.343-3,3v14c0,1.657,1.343,3,3,3c0.66,0,1.264-0.219,1.76-0.58l0.005,0.007L36,34.71\r\n\t\t\t\tV39c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V25C42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__SKIP_PREVIOUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39,22c-0.66,0-1.265,0.219-1.76,0.58l-0.005-0.007L28,29.291V25\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v14c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-4.29l9.235,6.717l0.005-0.007\r\n\t\t\t\tC37.736,41.781,38.34,42,39,42c1.657,0,3-1.343,3-3V25C42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6s26,11.64,26,26C58,46.36,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39,22c-0.66,0-1.265,0.219-1.76,0.58l-0.005-0.007L28,29.291V25\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v14c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-4.29l9.235,6.717l0.005-0.007\r\n\t\t\t\tC37.736,41.781,38.34,42,39,42c1.657,0,3-1.343,3-3V25C42,23.343,40.657,22,39,22z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32\r\n\t\t\t\tC6,17.641,17.641,6,32,6s26,11.64,26,26C58,46.36,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__FAST_FORWARD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z M45.559,29.437l-9.699-6.789C35.349,22.243,34.703,22,34,22c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.008,0.001,0.016,0.001,0.024h-0.005v4.018l-9.135-6.394C21.349,22.243,20.703,22,20,22c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.008,0.001,0.016,0.001,0.024h-0.005v14h0.005C17.013,40.67,18.351,42,20,42c0.708,0,1.358-0.246,1.871-0.655l9.125-6.387\r\n\t\t\t\tv4.067h0.005C31.013,40.67,32.351,42,34,42c0.708,0,1.358-0.246,1.871-0.655l9.68-6.776C46.419,34.043,47,33.089,47,32\r\n\t\t\t\tC47,30.914,46.423,29.963,45.559,29.437z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z M45.559,29.437l-9.699-6.789C35.349,22.243,34.703,22,34,22c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.008,0.001,0.016,0.001,0.024h-0.005v4.018l-9.135-6.394C21.349,22.243,20.703,22,20,22c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.008,0.001,0.016,0.001,0.024h-0.005v14h0.005C17.013,40.67,18.351,42,20,42c0.708,0,1.358-0.246,1.871-0.655l9.125-6.387\r\n\t\t\t\tv4.067h0.005C31.013,40.67,32.351,42,34,42c0.708,0,1.358-0.246,1.871-0.655l9.68-6.776C46.419,34.043,47,33.089,47,32\r\n\t\t\t\tC47,30.914,46.423,29.963,45.559,29.437z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__REWIND","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47,25c0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.135,6.394\r\n\t\t\t\tv-4.018h-0.006C32.999,25.016,33,25.008,33,25c0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.699,6.789\r\n\t\t\t\tC17.577,29.963,17,30.914,17,32c0,1.089,0.581,2.043,1.449,2.569l9.68,6.776C28.642,41.754,29.292,42,30,42\r\n\t\t\t\tc1.649,0,2.987-1.33,2.999-2.976h0.005v-4.067l9.125,6.387C42.642,41.754,43.292,42,44,42c1.649,0,2.987-1.33,2.999-2.976h0.005\r\n\t\t\t\tv-14h-0.005C46.999,25.016,47,25.008,47,25z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47,25c0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.135,6.394\r\n\t\t\t\tv-4.018h-0.006C32.999,25.016,33,25.008,33,25c0-1.657-1.343-3-3-3c-0.703,0-1.349,0.242-1.861,0.648l-9.699,6.789\r\n\t\t\t\tC17.577,29.963,17,30.914,17,32c0,1.089,0.581,2.043,1.449,2.569l9.68,6.776C28.642,41.754,29.292,42,30,42\r\n\t\t\t\tc1.649,0,2.987-1.33,2.999-2.976h0.005v-4.067l9.125,6.387C42.642,41.754,43.292,42,44,42c1.649,0,2.987-1.33,2.999-2.976h0.005\r\n\t\t\t\tv-14h-0.005C46.999,25.016,47,25.008,47,25z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PAUSE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6s26,11.64,26,26C58,46.36,46.359,58,32,58z\r\n\t\t\t\t M29,24c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H23C23.004,41.661,24.346,43,26,43\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07C28.999,24.047,29,24.024,29,24z M41,24c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H35C35.004,41.661,36.346,43,38,43c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.023-0.001-0.047-0.002-0.07V24.07C40.999,24.047,41,24.024,41,24z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6s26,11.64,26,26C58,46.36,46.359,58,32,58z\r\n\t\t\t\t M29,24c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H23C23.004,41.661,24.346,43,26,43\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.023-0.001-0.047-0.002-0.07V24.07C28.999,24.047,29,24.024,29,24z M41,24c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.002,0,0.005,0,0.007h-0.002v16H35C35.004,41.661,36.346,43,38,43c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.023-0.001-0.047-0.002-0.07V24.07C40.999,24.047,41,24.024,41,24z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__STOP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21H24c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3\r\n\t\t\t\tV24C43,22.343,41.657,21,40,21z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21H24c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3\r\n\t\t\t\tV24C43,22.343,41.657,21,40,21z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLAY","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.492,29.398l-15.8-9.875C25.21,19.193,24.628,19,24,19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv20c0,1.657,1.343,3,3,3c0.066,0,0.131-0.003,0.195-0.007c0.017-0.001,0.034-0.003,0.051-0.004\r\n\t\t\t\tc0.055-0.005,0.109-0.01,0.163-0.018c0.01-0.001,0.021-0.002,0.031-0.004c0.064-0.01,0.128-0.021,0.191-0.035\r\n\t\t\t\tc0.01-0.002,0.019-0.005,0.029-0.007c0.057-0.013,0.112-0.027,0.167-0.043c0.009-0.003,0.018-0.005,0.027-0.008\r\n\t\t\t\tc0.128-0.038,0.252-0.084,0.372-0.138c0.005-0.002,0.009-0.004,0.014-0.006c0.123-0.056,0.242-0.12,0.355-0.191l0.013,0.02\r\n\t\t\t\tl15.911-9.974C42.405,34.066,43,33.103,43,32C43,30.886,42.393,29.915,41.492,29.398z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.36,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41.492,29.398l-15.8-9.875C25.21,19.193,24.628,19,24,19c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv20c0,1.657,1.343,3,3,3c0.066,0,0.131-0.003,0.195-0.007c0.017-0.001,0.034-0.003,0.051-0.004\r\n\t\t\t\tc0.055-0.005,0.109-0.01,0.163-0.018c0.01-0.001,0.021-0.002,0.031-0.004c0.064-0.01,0.128-0.021,0.191-0.035\r\n\t\t\t\tc0.01-0.002,0.019-0.005,0.029-0.007c0.057-0.013,0.112-0.027,0.167-0.043c0.009-0.003,0.018-0.005,0.027-0.008\r\n\t\t\t\tc0.128-0.038,0.252-0.084,0.372-0.138c0.005-0.002,0.009-0.004,0.014-0.006c0.123-0.056,0.242-0.12,0.355-0.191l0.013,0.02\r\n\t\t\t\tl15.911-9.974C42.405,34.066,43,33.103,43,32C43,30.886,42.393,29.915,41.492,29.398z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.36,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SQUARE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE","display":"inline"},"children":[{"name":"g","attribs":{"id":"SQUARE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,15c0.829,0,1.579-0.336,2.121-0.879L29,12.243V26c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V12.243l1.879,1.879C37.422,14.664,38.172,15,39,15c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7\r\n\t\t\t\tC33.578,2.336,32.829,2,32,2c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,10.422,22,11.172,22,12C22,13.657,23.343,15,25,15z\r\n\t\t\t\t M60,6H41.485l4,4H59v34H5V10h13.515l4-4H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19\r\n\t\t\t\tc1.657,0,3-1.343,3-3V9C63,7.343,61.657,6,60,6z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M25,15c0.829,0,1.579-0.336,2.121-0.879L29,12.243V26c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V12.243l1.879,1.879C37.422,14.664,38.172,15,39,15c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121l-7-7\r\n\t\t\t\tC33.578,2.336,32.829,2,32,2c-0.828,0-1.578,0.336-2.121,0.879l-7,7C22.336,10.422,22,11.172,22,12C22,13.657,23.343,15,25,15z\r\n\t\t\t\t M60,6H41.485l4,4H59v34H5V10h13.515l4-4H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19\r\n\t\t\t\tc1.657,0,3-1.343,3-3V9C63,7.343,61.657,6,60,6z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,19c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,28.664,31.172,29,32,29\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C41.664,20.579,42,19.828,42,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL35,18.758V5c0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879C26.578,16.336,25.828,16,25,16C23.343,16,22,17.343,22,19z\r\n\t\t\t\t M60,6H38v4h21v34H5V10h21V6H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC63,7.343,61.657,6,60,6z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,19c0,0.828,0.336,1.578,0.879,2.121l7,7C30.422,28.664,31.172,29,32,29\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C41.664,20.579,42,19.828,42,19c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879\r\n\t\t\t\tL35,18.758V5c0-1.657-1.343-3-3-3s-3,1.343-3,3v13.757l-1.879-1.879C26.578,16.336,25.828,16,25,16C23.343,16,22,17.343,22,19z\r\n\t\t\t\t M60,6H38v4h21v34H5V10h21V6H4C2.343,6,1,7.343,1,9v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC63,7.343,61.657,6,60,6z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5\r\n\t\t\t\th19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z M23,31c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L32,29.243l3.879,3.879C36.422,33.664,37.172,34,38,34c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,25l3.879-3.879C40.664,20.578,41,19.828,41,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,20.757l-3.879-3.879C27.578,16.336,26.828,16,26,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,25l-3.879,3.879C23.336,29.422,23,30.172,23,31z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5\r\n\t\t\t\th19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z M23,31c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L32,29.243l3.879,3.879C36.422,33.664,37.172,34,38,34c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L36.243,25l3.879-3.879C40.664,20.578,41,19.828,41,19c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,20.757l-3.879-3.879C27.578,16.336,26.828,16,26,16c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,25l-3.879,3.879C23.336,29.422,23,30.172,23,31z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.879,31.121C28.422,31.664,29.172,32,30,32c0.829,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl8-8C40.664,22.578,41,21.829,41,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L30,24.757l-1.879-1.879\r\n\t\t\t\tC27.578,22.336,26.828,22,26,22c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.879,31.121z M60,4H4\r\n\t\t\t\tC2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z\r\n\t\t\t\t M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M27.879,31.121C28.422,31.664,29.172,32,30,32c0.829,0,1.578-0.336,2.121-0.879\r\n\t\t\t\tl8-8C40.664,22.578,41,21.829,41,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L30,24.757l-1.879-1.879\r\n\t\t\t\tC27.578,22.336,26.828,22,26,22c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.879,31.121z M60,4H4\r\n\t\t\t\tC2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z\r\n\t\t\t\t M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,28h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H26c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC23,26.657,24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19\r\n\t\t\t\tc1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,28h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H26c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC23,26.657,24.343,28,26,28z M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19\r\n\t\t\t\tc1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPUTER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,28h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3C23,26.657,24.343,28,26,28z M60,4H4\r\n\t\t\t\tC2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z\r\n\t\t\t\t M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,28h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3C23,26.657,24.343,28,26,28z M60,4H4\r\n\t\t\t\tC2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5h19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z\r\n\t\t\t\t M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"IMAC_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IMAC","display":"inline"},"children":[{"name":"g","attribs":{"id":"IMAC","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5\r\n\t\t\t\th19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60,4H4C2.343,4,1,5.343,1,7v40c0,1.657,1.343,3,3,3h19v5l-4,4v1h26v-1l-4-4v-5\r\n\t\t\t\th19c1.657,0,3-1.343,3-3V7C63,5.343,61.657,4,60,4z M59,42H5V8h54V42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MACBOOK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MACBOOK","display":"inline"},"children":[{"name":"g","attribs":{"id":"MACBOOK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,44V15c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3v29H0v5\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3v-5H58z M39,49H25v-2h14V49z M54,42H10V16h44V42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58,44V15c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3v29H0v5\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3v-5H58z M39,49H25v-2h14V49z M54,42H10V16h44V42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"IPAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IPAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"IPAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54,3H10C8.343,3,7,4.343,7,6v52c0,1.657,1.343,3,3,3h44c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC57,4.343,55.657,3,54,3z M32,59c-1.105,0-2-0.896-2-2s0.895-2,2-2s2,0.896,2,2S33.105,59,32,59z M51,53H13V9h38V53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M54,3H10C8.343,3,7,4.343,7,6v52c0,1.657,1.343,3,3,3h44c1.657,0,3-1.343,3-3V6\r\n\t\t\t\tC57,4.343,55.657,3,54,3z M32,59c-1.105,0-2-0.896-2-2s0.895-2,2-2s2,0.896,2,2S33.105,59,32,59z M51,53H13V9h38V53z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"IPHONE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"IPHONE","display":"inline"},"children":[{"name":"g","attribs":{"id":"IPHONE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,3H18c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h28c1.657,0,3-1.343,3-3\r\n\t\t\t\tV6C49,4.343,47.657,3,46,3z M32,58c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C34,57.105,33.105,58,32,58z M46,51H18\r\n\t\t\t\tV9h28V51z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,3H18c-1.657,0-3,1.343-3,3v52c0,1.657,1.343,3,3,3h28c1.657,0,3-1.343,3-3\r\n\t\t\t\tV6C49,4.343,47.657,3,46,3z M32,58c-1.105,0-2-0.895-2-2c0-1.105,0.895-2,2-2s2,0.895,2,2C34,57.105,33.105,58,32,58z M46,51H18\r\n\t\t\t\tV9h28V51z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LOGOUT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOGOUT","display":"inline"},"children":[{"name":"g","attribs":{"id":"LOGOUT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC44.475,20.292,43.772,20,43,20c-1.657,0-3,1.343-3,3c0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27c0,0,0,0,0,0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c0,0,0,0,0,0h18.182l-4.189,3.77l0,0C40.384,39.32,40,40.115,40,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.681,56,32.885,56,32z M26,52H14V12h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tC29,53.343,27.657,52,26,52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M56,32c0-0.885-0.383-1.681-0.993-2.23l0,0l-10-9l0,0\r\n\t\t\t\tC44.475,20.292,43.772,20,43,20c-1.657,0-3,1.343-3,3c0,0.885,0.384,1.681,0.993,2.23l0,0L45.182,29H27c0,0,0,0,0,0\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c0,0,0,0,0,0h18.182l-4.189,3.77l0,0C40.384,39.32,40,40.115,40,41\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.772,0,1.475-0.292,2.007-0.77l0,0l10-9l0,0C55.617,33.681,56,32.885,56,32z M26,52H14V12h12\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3\r\n\t\t\t\tC29,53.343,27.657,52,26,52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LOGIN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LOGIN","display":"inline"},"children":[{"name":"g","attribs":{"id":"LOGIN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.007,34.23C39.617,33.681,40,32.885,40,32c0-0.885-0.384-1.681-0.993-2.23\r\n\t\t\t\tl0,0l-10-9l0,0C28.475,20.292,27.772,20,27,20c-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L29.182,29H11\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182l-4.189,3.77l0,0C24.384,39.32,24,40.115,24,41c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.772,0,1.475-0.292,2.007-0.77l0,0L39.007,34.23L39.007,34.23z M56,31.932V8.935c0-1.657-1.343-3-3-3H38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12v40H38c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3V31.937c0-0.001,0-0.002,0-0.003\r\n\t\t\t\tC56,31.934,56,31.933,56,31.932z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M39.007,34.23C39.617,33.681,40,32.885,40,32c0-0.885-0.384-1.681-0.993-2.23\r\n\t\t\t\tl0,0l-10-9l0,0C28.475,20.292,27.772,20,27,20c-1.657,0-3,1.343-3,3c0,0.885,0.383,1.681,0.993,2.23l0,0L29.182,29H11\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182l-4.189,3.77l0,0C24.384,39.32,24,40.115,24,41c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.772,0,1.475-0.292,2.007-0.77l0,0L39.007,34.23L39.007,34.23z M56,31.932V8.935c0-1.657-1.343-3-3-3H38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h12v40H38c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h15c1.657,0,3-1.343,3-3V31.937c0-0.001,0-0.002,0-0.003\r\n\t\t\t\tC56,31.934,56,31.933,56,31.932z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"UPLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23,24c0.885,0,1.681-0.384,2.23-0.993l0,0L29,18.818V37c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3c0,0,0,0,0,0V18.818l3.77,4.189l0,0C39.319,23.617,40.115,24,41,24c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,8.384,32.885,8,32,8c-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0\r\n\t\t\t\tC20.292,19.525,20,20.228,20,21C20,22.657,21.343,24,23,24z M55,35c-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v15c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M23,24c0.885,0,1.681-0.384,2.23-0.993l0,0L29,18.818V37c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3c0,0,0,0,0,0V18.818l3.77,4.189l0,0C39.319,23.617,40.115,24,41,24c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.681,8.384,32.885,8,32,8c-0.885,0-1.681,0.384-2.23,0.993l0,0l-9,10l0,0\r\n\t\t\t\tC20.292,19.525,20,20.228,20,21C20,22.657,21.343,24,23,24z M55,35c-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v15c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"DOWNLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.77,29.007l9,10l0,0C30.319,39.616,31.115,40,32,40\r\n\t\t\t\tc0.885,0,1.68-0.384,2.23-0.993l0,0l9-10l0,0C43.708,28.475,44,27.772,44,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.885,0-1.681,0.383-2.23,0.993l0,0L35,29.182V11c0-1.657-1.343-3-3-3s-3,1.343-3,3v18.182l-3.77-4.189l0,0\r\n\t\t\t\tC24.681,24.384,23.885,24,23,24c-1.657,0-3,1.343-3,3C20,27.772,20.292,28.475,20.77,29.007L20.77,29.007z M55,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h22.997c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0H55c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M20.77,29.007l9,10l0,0C30.319,39.616,31.115,40,32,40\r\n\t\t\t\tc0.885,0,1.68-0.384,2.23-0.993l0,0l9-10l0,0C43.708,28.475,44,27.772,44,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.885,0-1.681,0.383-2.23,0.993l0,0L35,29.182V11c0-1.657-1.343-3-3-3s-3,1.343-3,3v18.182l-3.77-4.189l0,0\r\n\t\t\t\tC24.681,24.384,23.885,24,23,24c-1.657,0-3,1.343-3,3C20,27.772,20.292,28.475,20.77,29.007L20.77,29.007z M55,35\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h22.997c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0H55c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CALENDAR_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR","display":"inline"},"children":[{"name":"g","attribs":{"id":"CALENDAR","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC45,12.657,46.343,14,48,14z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.361,39.632\r\n\t\t\t\tc-0.373,0.347-0.785,0.663-1.235,0.949c-0.451,0.286-0.875,0.568-1.274,0.845c-0.78,0.538-1.521,1.066-2.223,1.586\r\n\t\t\t\tc-0.702,0.52-1.313,1.088-1.833,1.703c-0.52,0.615-0.932,1.313-1.235,2.093c-0.304,0.78-0.455,1.699-0.455,2.756H31.47v-3.172\r\n\t\t\t\th-8.606c0.451-0.624,0.97-1.17,1.56-1.638c0.589-0.468,1.196-0.905,1.82-1.313c0.624-0.407,1.244-0.819,1.859-1.235\r\n\t\t\t\tc0.615-0.416,1.166-0.88,1.651-1.391c0.485-0.511,0.875-1.096,1.17-1.755c0.294-0.659,0.442-1.447,0.442-2.366\r\n\t\t\t\tc0-0.884-0.169-1.681-0.507-2.392c-0.338-0.71-0.793-1.308-1.365-1.794c-0.572-0.485-1.235-0.858-1.989-1.118\r\n\t\t\t\tC26.751,31.13,25.958,31,25.126,31c-1.092,0-2.058,0.187-2.899,0.559c-0.841,0.373-1.539,0.893-2.093,1.56\r\n\t\t\t\tc-0.555,0.667-0.971,1.447-1.248,2.34c-0.277,0.893-0.399,1.859-0.364,2.899h3.536c0-0.485,0.048-0.975,0.143-1.469\r\n\t\t\t\tc0.095-0.494,0.255-0.945,0.481-1.352c0.225-0.407,0.524-0.737,0.897-0.988c0.373-0.251,0.828-0.377,1.365-0.377\r\n\t\t\t\tc0.797,0,1.452,0.247,1.963,0.741c0.511,0.494,0.767,1.183,0.767,2.067c0,0.555-0.126,1.049-0.377,1.482\r\n\t\t\t\tC27.045,38.895,26.733,39.285,26.361,39.632z M41.467,45.807c-0.269,0.321-0.598,0.581-0.988,0.78\r\n\t\t\t\tc-0.39,0.199-0.828,0.299-1.313,0.299c-0.832,0-1.517-0.247-2.054-0.741c-0.537-0.494-0.85-1.157-0.936-1.989h-3.692\r\n\t\t\t\tc0.017,0.953,0.212,1.79,0.585,2.509c0.373,0.719,0.871,1.322,1.495,1.807c0.624,0.485,1.339,0.845,2.145,1.079\r\n\t\t\t\tc0.806,0.234,1.651,0.351,2.535,0.351c0.919,0.017,1.785-0.134,2.6-0.455c0.815-0.321,1.529-0.776,2.145-1.365\r\n\t\t\t\tc0.615-0.589,1.105-1.287,1.469-2.093c0.364-0.806,0.546-1.677,0.546-2.613c0-0.849-0.126-1.651-0.377-2.405\r\n\t\t\t\tc-0.252-0.754-0.616-1.408-1.092-1.963c-0.477-0.555-1.062-0.997-1.755-1.326c-0.693-0.329-1.491-0.494-2.392-0.494\r\n\t\t\t\tc-0.728,0-1.378,0.109-1.95,0.325c-0.572,0.217-1.109,0.576-1.612,1.079l-0.052-0.052l0.728-4.134h7.514v-3.042H34.85\r\n\t\t\t\tl-1.794,10.062h3.328c0.364-0.503,0.754-0.871,1.17-1.105c0.416-0.234,0.953-0.351,1.612-0.351c0.503,0,0.945,0.087,1.326,0.26\r\n\t\t\t\tc0.381,0.173,0.711,0.416,0.988,0.728c0.277,0.312,0.485,0.676,0.624,1.092c0.139,0.416,0.208,0.858,0.208,1.326\r\n\t\t\t\tc0,0.451-0.074,0.889-0.221,1.313C41.943,45.114,41.735,45.486,41.467,45.807z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC45,12.657,46.343,14,48,14z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.361,39.632\r\n\t\t\t\tc-0.373,0.347-0.785,0.663-1.235,0.949c-0.451,0.286-0.875,0.568-1.274,0.845c-0.78,0.538-1.521,1.066-2.223,1.586\r\n\t\t\t\tc-0.702,0.52-1.313,1.088-1.833,1.703c-0.52,0.615-0.932,1.313-1.235,2.093c-0.304,0.78-0.455,1.699-0.455,2.756H31.47v-3.172\r\n\t\t\t\th-8.606c0.451-0.624,0.97-1.17,1.56-1.638c0.589-0.468,1.196-0.905,1.82-1.313c0.624-0.407,1.244-0.819,1.859-1.235\r\n\t\t\t\tc0.615-0.416,1.166-0.88,1.651-1.391c0.485-0.511,0.875-1.096,1.17-1.755c0.294-0.659,0.442-1.447,0.442-2.366\r\n\t\t\t\tc0-0.884-0.169-1.681-0.507-2.392c-0.338-0.71-0.793-1.308-1.365-1.794c-0.572-0.485-1.235-0.858-1.989-1.118\r\n\t\t\t\tC26.751,31.13,25.958,31,25.126,31c-1.092,0-2.058,0.187-2.899,0.559c-0.841,0.373-1.539,0.893-2.093,1.56\r\n\t\t\t\tc-0.555,0.667-0.971,1.447-1.248,2.34c-0.277,0.893-0.399,1.859-0.364,2.899h3.536c0-0.485,0.048-0.975,0.143-1.469\r\n\t\t\t\tc0.095-0.494,0.255-0.945,0.481-1.352c0.225-0.407,0.524-0.737,0.897-0.988c0.373-0.251,0.828-0.377,1.365-0.377\r\n\t\t\t\tc0.797,0,1.452,0.247,1.963,0.741c0.511,0.494,0.767,1.183,0.767,2.067c0,0.555-0.126,1.049-0.377,1.482\r\n\t\t\t\tC27.045,38.895,26.733,39.285,26.361,39.632z M41.467,45.807c-0.269,0.321-0.598,0.581-0.988,0.78\r\n\t\t\t\tc-0.39,0.199-0.828,0.299-1.313,0.299c-0.832,0-1.517-0.247-2.054-0.741c-0.537-0.494-0.85-1.157-0.936-1.989h-3.692\r\n\t\t\t\tc0.017,0.953,0.212,1.79,0.585,2.509c0.373,0.719,0.871,1.322,1.495,1.807c0.624,0.485,1.339,0.845,2.145,1.079\r\n\t\t\t\tc0.806,0.234,1.651,0.351,2.535,0.351c0.919,0.017,1.785-0.134,2.6-0.455c0.815-0.321,1.529-0.776,2.145-1.365\r\n\t\t\t\tc0.615-0.589,1.105-1.287,1.469-2.093c0.364-0.806,0.546-1.677,0.546-2.613c0-0.849-0.126-1.651-0.377-2.405\r\n\t\t\t\tc-0.252-0.754-0.616-1.408-1.092-1.963c-0.477-0.555-1.062-0.997-1.755-1.326c-0.693-0.329-1.491-0.494-2.392-0.494\r\n\t\t\t\tc-0.728,0-1.378,0.109-1.95,0.325c-0.572,0.217-1.109,0.576-1.612,1.079l-0.052-0.052l0.728-4.134h7.514v-3.042H34.85\r\n\t\t\t\tl-1.794,10.062h3.328c0.364-0.503,0.754-0.871,1.17-1.105c0.416-0.234,0.953-0.351,1.612-0.351c0.503,0,0.945,0.087,1.326,0.26\r\n\t\t\t\tc0.381,0.173,0.711,0.416,0.988,0.728c0.277,0.312,0.485,0.676,0.624,1.092c0.139,0.416,0.208,0.858,0.208,1.326\r\n\t\t\t\tc0,0.451-0.074,0.889-0.221,1.313C41.943,45.114,41.735,45.486,41.467,45.807z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC13,12.657,14.343,14,16,14z M25.126,31c-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4v-4c0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC22,42.657,23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC13,12.657,14.343,14,16,14z M25.126,31c-0.001,0-0.002,0-0.003,0h0.007C25.128,31,25.127,31,25.126,31z M48,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8C45,12.657,46.343,14,48,14z M25,44h4v4c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-4h4c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-4v-4c0-1.657-1.343-3-3-3s-3,1.343-3,3v4h-4c-1.657,0-3,1.343-3,3\r\n\t\t\t\tC22,42.657,23.343,44,25,44z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CALENDAR__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"CALENDAR__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v8\r\n\t\t\t\tC45,12.657,46.343,14,48,14z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.879,50.121\r\n\t\t\t\tC27.422,50.664,28.172,51,29,51c0.828,0,1.578-0.336,2.121-0.879l14-14C45.664,35.579,46,34.828,46,34c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L29,43.757l-4.879-4.879C23.578,38.336,22.828,38,22,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L26.879,50.121z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v8\r\n\t\t\t\tC45,12.657,46.343,14,48,14z M61,8h-6v3c0,3.866-3.134,7-7,7s-7-3.134-7-7V8H23v3c0,3.866-3.134,7-7,7c-3.866,0-7-3.134-7-7V8H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v50c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V11C64,9.343,62.657,8,61,8z M58,58H6V24h52V58z M16,14\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v8C13,12.657,14.343,14,16,14z M26.879,50.121\r\n\t\t\t\tC27.422,50.664,28.172,51,29,51c0.828,0,1.578-0.336,2.121-0.879l14-14C45.664,35.579,46,34.828,46,34c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L29,43.757l-4.879-4.879C23.578,38.336,22.828,38,22,38c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L26.879,50.121z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M42,55c0-3.314,2.686-6,6-6h12V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3H48C44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3\r\n\t\t\t\tH13c-1.657,0-3-1.343-3-3C10,24.343,11.343,23,13,23z M13,36h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3\r\n\t\t\t\tS11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5\r\n\t\t\t\tC34,52.881,32.881,54,31.5,54z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z\r\n\t\t\t\t M60,52H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M42,55c0-3.314,2.686-6,6-6h12V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52\r\n\t\t\t\tc0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3H48C44.686,61,42,58.314,42,55z M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3\r\n\t\t\t\tH13c-1.657,0-3-1.343-3-3C10,24.343,11.343,23,13,23z M13,36h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3\r\n\t\t\t\tS11.343,36,13,36z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5\r\n\t\t\t\tC34,52.881,32.881,54,31.5,54z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C13,10.657,14.343,12,16,12z\r\n\t\t\t\t M60,52H48c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z\r\n\t\t\t\t M60,52h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z M42,55c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tV9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h43v-3C44.686,61,42,58.314,42,55z\r\n\t\t\t\t M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3H13c-1.657,0-3-1.343-3-3C10,24.343,11.343,23,13,23z M31.5,54h-19\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5C34,52.881,32.881,54,31.5,54z M39,42H13\r\n\t\t\t\tc-1.657,0-3-1.343-3-3s1.343-3,3-3h26c1.657,0,3,1.343,3,3S40.657,42,39,42z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v6C13,10.657,14.343,12,16,12z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C28,10.657,29.343,12,31,12z\r\n\t\t\t\t M60,52h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3C63,53.343,61.657,52,60,52z M42,55c0-3.314,2.686-6,6-6c0-3.314,2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tV9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h43v-3C44.686,61,42,58.314,42,55z\r\n\t\t\t\t M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3H13c-1.657,0-3-1.343-3-3C10,24.343,11.343,23,13,23z M31.5,54h-19\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5C34,52.881,32.881,54,31.5,54z M39,42H13\r\n\t\t\t\tc-1.657,0-3-1.343-3-3s1.343-3,3-3h26c1.657,0,3,1.343,3,3S40.657,42,39,42z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v6C13,10.657,14.343,12,16,12z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M58.243,55l3.879-3.879C62.664,50.579,63,49.828,63,49c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L54,50.757l-3.879-3.879C49.578,46.336,48.828,46,48,46c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L49.757,55l-3.879,3.879C45.336,59.422,45,60.172,45,61c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L54,59.243l3.879,3.879C58.422,63.664,59.172,64,60,64c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.829-0.336-1.578-0.879-2.121L58.243,55z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC13,10.657,14.343,12,16,12z M43.757,56.758L45.515,55l-1.757-1.757C42.672,52.157,42,50.657,42,49c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.657,0,3.157,0.672,4.243,1.757L54,46.515l1.757-1.758l0.015,0.016C56.854,43.682,58.341,43,60,43V9c0-1.657-1.343-3-3-3h-5v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6\r\n\t\t\t\tH5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h37.832C42.317,63.114,42,62.099,42,61c0-1.659,0.682-3.146,1.773-4.227\r\n\t\t\t\tL43.757,56.758z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5\r\n\t\t\t\tC34,52.881,32.881,54,31.5,54z M37,42H13c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h24c1.657,0,3,1.343,3,3\r\n\t\t\t\tC40,40.657,38.657,42,37,42z M13,29c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6\r\n\t\t\t\tC43,10.657,44.343,12,46,12z M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M58.243,55l3.879-3.879C62.664,50.579,63,49.828,63,49c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L54,50.757l-3.879-3.879C49.578,46.336,48.828,46,48,46c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L49.757,55l-3.879,3.879C45.336,59.422,45,60.172,45,61c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L54,59.243l3.879,3.879C58.422,63.664,59.172,64,60,64c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.829-0.336-1.578-0.879-2.121L58.243,55z M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC13,10.657,14.343,12,16,12z M43.757,56.758L45.515,55l-1.757-1.757C42.672,52.157,42,50.657,42,49c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.657,0,3.157,0.672,4.243,1.757L54,46.515l1.757-1.758l0.015,0.016C56.854,43.682,58.341,43,60,43V9c0-1.657-1.343-3-3-3h-5v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6\r\n\t\t\t\tH5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3h37.832C42.317,63.114,42,62.099,42,61c0-1.659,0.682-3.146,1.773-4.227\r\n\t\t\t\tL43.757,56.758z M31.5,54h-19c-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5\r\n\t\t\t\tC34,52.881,32.881,54,31.5,54z M37,42H13c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h24c1.657,0,3,1.343,3,3\r\n\t\t\t\tC40,40.657,38.657,42,37,42z M13,29c-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"NOTEPAD__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z\r\n\t\t\t\t M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,50\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L52,56.758l-1.879-1.879C49.578,54.336,48.829,54,48,54c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l4,4C50.422,63.664,51.172,64,52,64s1.578-0.336,2.121-0.879l8-8C62.664,54.578,63,53.828,63,53\r\n\t\t\t\tC63,51.343,61.657,50,60,50z M43.775,61.225C42.683,60.147,42,58.659,42,57c0-3.314,2.686-6,6-6c1.535,0,2.908,0.602,3.961,1.554\r\n\t\t\t\tl3.797-3.797C56.843,47.672,58.343,47,60,47V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3\r\n\t\t\t\th41.515l-2.757-2.757L43.775,61.225z M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3H13c-1.657,0-3-1.343-3-3\r\n\t\t\t\tC10,24.343,11.343,23,13,23z M13,36h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5C34,52.881,32.881,54,31.5,54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC28,10.657,29.343,12,31,12z M46,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C43,10.657,44.343,12,46,12z\r\n\t\t\t\t M16,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6C13,10.657,14.343,12,16,12z M60,50\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L52,56.758l-1.879-1.879C49.578,54.336,48.829,54,48,54c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l4,4C50.422,63.664,51.172,64,52,64s1.578-0.336,2.121-0.879l8-8C62.664,54.578,63,53.828,63,53\r\n\t\t\t\tC63,51.343,61.657,50,60,50z M43.775,61.225C42.683,60.147,42,58.659,42,57c0-3.314,2.686-6,6-6c1.535,0,2.908,0.602,3.961,1.554\r\n\t\t\t\tl3.797-3.797C56.843,47.672,58.343,47,60,47V9c0-1.657-1.343-3-3-3h-5v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3\r\n\t\t\t\tc0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6H5C3.343,6,2,7.343,2,9v52c0,1.657,1.343,3,3,3\r\n\t\t\t\th41.515l-2.757-2.757L43.775,61.225z M13,23h36c1.657,0,3,1.343,3,3c0,1.657-1.343,3-3,3H13c-1.657,0-3-1.343-3-3\r\n\t\t\t\tC10,24.343,11.343,23,13,23z M13,36h36c1.657,0,3,1.343,3,3s-1.343,3-3,3H13c-1.657,0-3-1.343-3-3S11.343,36,13,36z M31.5,54h-19\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h19c1.381,0,2.5,1.119,2.5,2.5C34,52.881,32.881,54,31.5,54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"NOTEPAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"NOTEPAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"NOTEPAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC29,10.657,30.343,12,32,12z M47,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6\r\n\t\t\t\th-5v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\ts-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52c0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5C53,52.881,51.881,54,50.5,54z M50,42H14\r\n\t\t\t\tc-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3\r\n\t\t\t\th36c1.657,0,3,1.343,3,3C53,27.657,51.657,29,50,29z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC29,10.657,30.343,12,32,12z M47,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC44,10.657,45.343,12,47,12z M17,12c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v6C14,10.657,15.343,12,17,12z M58,6\r\n\t\t\t\th-5v3c0,3.314-2.686,6-6,6c-3.314,0-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6s-6-2.686-6-6V6h-3v3c0,3.314-2.686,6-6,6\r\n\t\t\t\ts-6-2.686-6-6V6H6C4.343,6,3,7.343,3,9v52c0,1.657,1.343,3,3,3h52c1.657,0,3-1.343,3-3V9C61,7.343,59.657,6,58,6z M50.5,54h-37\r\n\t\t\t\tc-1.381,0-2.5-1.119-2.5-2.5c0-1.381,1.119-2.5,2.5-2.5h37c1.381,0,2.5,1.119,2.5,2.5C53,52.881,51.881,54,50.5,54z M50,42H14\r\n\t\t\t\tc-1.657,0-3-1.343-3-3s1.343-3,3-3h36c1.657,0,3,1.343,3,3S51.657,42,50,42z M50,29H14c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3\r\n\t\t\t\th36c1.657,0,3,1.343,3,3C53,27.657,51.657,29,50,29z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MICROPHONE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MICROPHONE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MICROPHONE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,40c6.627,0,12-5.373,12-12V12c0-6.627-5.373-12-12-12\r\n\t\t\t\tc-6.627,0-12,5.373-12,12v16C20,34.628,25.373,40,32,40z M54,29.023c0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3h0c-0.004,8.835-7.165,15.996-16,16c-8.835-0.004-15.996-7.165-16-16h0c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023c0,11.125,8.274,20.296,19,21.752V58H19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35v-7.225\r\n\t\t\t\tC45.726,49.319,54,40.148,54,29.023z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,40c6.627,0,12-5.373,12-12V12c0-6.627-5.373-12-12-12\r\n\t\t\t\tc-6.627,0-12,5.373-12,12v16C20,34.628,25.373,40,32,40z M54,29.023c0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3h0c-0.004,8.835-7.165,15.996-16,16c-8.835-0.004-15.996-7.165-16-16h0c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023c0,11.125,8.274,20.296,19,21.752V58H19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35v-7.225\r\n\t\t\t\tC45.726,49.319,54,40.148,54,29.023z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{"id":"MICROPHONE__x2F__OFF","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.631,39.405l5.051-3.302C16.617,33.961,16.002,31.555,16,29h0\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023\r\n\t\t\t\tC10,32.785,10.964,36.313,12.631,39.405z M44,18.895V12c0-6.627-5.373-12-12-12c-6.627,0-12,5.373-12,12v16\r\n\t\t\t\tc0,2.047,0.515,3.973,1.419,5.659L44,18.895z M59.5,15.1c0-0.829-0.672-1.5-1.5-1.5c-0.303,0-0.585,0.091-0.821,0.246l0-0.001\r\n\t\t\t\tl-0.017,0.011c0,0,0,0,0,0L5.079,47.945l0,0.001C4.67,48.214,4.4,48.675,4.4,49.2c0,0.829,0.672,1.5,1.5,1.5\r\n\t\t\t\tc0.303,0,0.585-0.091,0.821-0.246l0,0.001l0.017-0.011c0,0,0,0,0,0l52.083-34.089l0-0.001C59.23,16.087,59.5,15.625,59.5,15.1z\r\n\t\t\t\t M43.86,29.739l-15.026,9.825C29.844,39.841,30.902,40,32,40C38.035,40,43.015,35.54,43.86,29.739z M51,26c-1.657,0-3,1.343-3,3\r\n\t\t\t\th0c-0.004,8.092-6.017,14.759-13.816,15.829c-0.24,0.034-0.481,0.062-0.723,0.086c-0.441,0.04-0.885,0.074-1.336,0.078l0,0.002\r\n\t\t\t\tc-0.04,0-0.078,0.005-0.118,0.005c-2.959,0-5.72-0.817-8.098-2.216l-5.431,3.551c2.987,2.326,6.586,3.906,10.521,4.441V58H19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35v-7.225\r\n\t\t\t\tc10.726-1.456,19-10.627,19-21.752c0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29C54,27.343,52.657,26,51,26z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.631,39.405l5.051-3.302C16.617,33.961,16.002,31.555,16,29h0\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3c0,0.003,0.001,0.005,0.001,0.008C10,29.013,10,29.018,10,29.023\r\n\t\t\t\tC10,32.785,10.964,36.313,12.631,39.405z M44,18.895V12c0-6.627-5.373-12-12-12c-6.627,0-12,5.373-12,12v16\r\n\t\t\t\tc0,2.047,0.515,3.973,1.419,5.659L44,18.895z M59.5,15.1c0-0.829-0.672-1.5-1.5-1.5c-0.303,0-0.585,0.091-0.821,0.246l0-0.001\r\n\t\t\t\tl-0.017,0.011c0,0,0,0,0,0L5.079,47.945l0,0.001C4.67,48.214,4.4,48.675,4.4,49.2c0,0.829,0.672,1.5,1.5,1.5\r\n\t\t\t\tc0.303,0,0.585-0.091,0.821-0.246l0,0.001l0.017-0.011c0,0,0,0,0,0l52.083-34.089l0-0.001C59.23,16.087,59.5,15.625,59.5,15.1z\r\n\t\t\t\t M43.86,29.739l-15.026,9.825C29.844,39.841,30.902,40,32,40C38.035,40,43.015,35.54,43.86,29.739z M51,26c-1.657,0-3,1.343-3,3\r\n\t\t\t\th0c-0.004,8.092-6.017,14.759-13.816,15.829c-0.24,0.034-0.481,0.062-0.723,0.086c-0.441,0.04-0.885,0.074-1.336,0.078l0,0.002\r\n\t\t\t\tc-0.04,0-0.078,0.005-0.118,0.005c-2.959,0-5.72-0.817-8.098-2.216l-5.431,3.551c2.987,2.326,6.586,3.906,10.521,4.441V58H19\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h26c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H35v-7.225\r\n\t\t\t\tc10.726-1.456,19-10.627,19-21.752c0-0.005,0-0.01-0.001-0.015C53.999,29.005,54,29.003,54,29C54,27.343,52.657,26,51,26z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BELL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BELL","display":"inline"},"children":[{"name":"g","attribs":{"id":"BELL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,45c-1.657,0-3-1.343-3-3V22c0-7.732-6.268-14-14-14c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3c-7.732,0-14,6.268-14,14v20c0,1.657-1.343,3-3,3s-3,1.343-3,3c0,1.657,1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC55,46.343,53.657,45,52,45z M32,60c3.314,0,6-2.686,6-6H26C26,57.314,28.686,60,32,60z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M52,45c-1.657,0-3-1.343-3-3V22c0-7.732-6.268-14-14-14c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3c-7.732,0-14,6.268-14,14v20c0,1.657-1.343,3-3,3s-3,1.343-3,3c0,1.657,1.343,3,3,3h40c1.657,0,3-1.343,3-3\r\n\t\t\t\tC55,46.343,53.657,45,52,45z M32,60c3.314,0,6-2.686,6-6H26C26,57.314,28.686,60,32,60z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"EJECT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"EJECT","display":"inline"},"children":[{"name":"g","attribs":{"id":"EJECT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42,42H22c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tS43.657,42,42,42z M22,39h20c1.657,0,3-1.343,3-3c0-0.584-0.167-1.129-0.456-1.59l0,0l-9.976-15.962\r\n\t\t\t\tc-0.003-0.005-0.006-0.01-0.01-0.016l-0.014-0.022l0,0C34.013,17.563,33.073,17,32,17c-1.073,0-2.013,0.563-2.544,1.41l0,0\r\n\t\t\t\tl-0.014,0.022c-0.003,0.005-0.007,0.01-0.01,0.016L19.456,34.41l0,0C19.168,34.871,19,35.416,19,36C19,37.657,20.343,39,22,39z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M42,42H22c-1.657,0-3,1.343-3,3s1.343,3,3,3h20c1.657,0,3-1.343,3-3\r\n\t\t\t\tS43.657,42,42,42z M22,39h20c1.657,0,3-1.343,3-3c0-0.584-0.167-1.129-0.456-1.59l0,0l-9.976-15.962\r\n\t\t\t\tc-0.003-0.005-0.006-0.01-0.01-0.016l-0.014-0.022l0,0C34.013,17.563,33.073,17,32,17c-1.073,0-2.013,0.563-2.544,1.41l0,0\r\n\t\t\t\tl-0.014,0.022c-0.003,0.005-0.007,0.01-0.01,0.016L19.456,34.41l0,0C19.168,34.871,19,35.416,19,36C19,37.657,20.343,39,22,39z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SKIP__x2F__NEXT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__NEXT","display":"inline"},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__NEXT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,19c-1.657,0-3,1.343-3,3v5.837l-13.41-8.381l0,0\r\n\t\t\t\tC24.129,19.168,23.584,19,23,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L38,36.163V42\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V22C44,20.343,42.657,19,41,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,19c-1.657,0-3,1.343-3,3v5.837l-13.41-8.381l0,0\r\n\t\t\t\tC24.129,19.168,23.584,19,23,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L38,36.163V42\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V22C44,20.343,42.657,19,41,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L26,27.837V22c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.837l13.41,8.381l0,0C39.871,44.833,40.416,45,41,45c1.657,0,3-1.343,3-3V22\r\n\t\t\t\tC44,20.343,42.657,19,41,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L26,27.837V22c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.837l13.41,8.381l0,0C39.871,44.833,40.416,45,41,45c1.657,0,3-1.343,3-3V22\r\n\t\t\t\tC44,20.343,42.657,19,41,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FAST_FORWARD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FAST_FORWARD","display":"inline"},"children":[{"name":"g","attribs":{"id":"FAST_FORWARD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,32c0-1.073-0.563-2.013-1.41-2.544l0,0l-0.022-0.014\r\n\t\t\t\tc-0.005-0.003-0.01-0.007-0.016-0.01L33.59,19.456l0,0C33.129,19.168,32.584,19,32,19c-1.657,0-3,1.343-3,3v4.587l-11.41-7.131\r\n\t\t\t\tl0,0C17.129,19.168,16.584,19,16,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L29,37.413\r\n\t\t\t\tV42c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0l15.962-9.976c0.005-0.003,0.01-0.007,0.016-0.01l0.022-0.014l0,0\r\n\t\t\t\tC50.437,34.013,51,33.073,51,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M51,32c0-1.073-0.563-2.013-1.41-2.544l0,0l-0.022-0.014\r\n\t\t\t\tc-0.005-0.003-0.01-0.007-0.016-0.01L33.59,19.456l0,0C33.129,19.168,32.584,19,32,19c-1.657,0-3,1.343-3,3v4.587l-11.41-7.131\r\n\t\t\t\tl0,0C17.129,19.168,16.584,19,16,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L29,37.413\r\n\t\t\t\tV42c0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0l15.962-9.976c0.005-0.003,0.01-0.007,0.016-0.01l0.022-0.014l0,0\r\n\t\t\t\tC50.437,34.013,51,33.073,51,32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"REWIND_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"REWIND","display":"inline"},"children":[{"name":"g","attribs":{"id":"REWIND","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L35,26.587V22c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.584,0-1.129,0.168-1.59,0.456l0,0l-15.962,9.976c-0.005,0.003-0.011,0.007-0.016,0.01l-0.023,0.014l0,0\r\n\t\t\t\tC13.564,29.987,13,30.927,13,32c0,1.073,0.564,2.013,1.41,2.544l0,0l0.023,0.014c0.005,0.003,0.01,0.007,0.016,0.01l15.962,9.976\r\n\t\t\t\tl0,0C30.871,44.833,31.416,45,32,45c1.657,0,3-1.343,3-3v-4.587l11.41,7.131l0,0C46.871,44.833,47.416,45,48,45\r\n\t\t\t\tc1.657,0,3-1.343,3-3V22C51,20.343,49.657,19,48,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L35,26.587V22c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.584,0-1.129,0.168-1.59,0.456l0,0l-15.962,9.976c-0.005,0.003-0.011,0.007-0.016,0.01l-0.023,0.014l0,0\r\n\t\t\t\tC13.564,29.987,13,30.927,13,32c0,1.073,0.564,2.013,1.41,2.544l0,0l0.023,0.014c0.005,0.003,0.01,0.007,0.016,0.01l15.962,9.976\r\n\t\t\t\tl0,0C30.871,44.833,31.416,45,32,45c1.657,0,3-1.343,3-3v-4.587l11.41,7.131l0,0C46.871,44.833,47.416,45,48,45\r\n\t\t\t\tc1.657,0,3-1.343,3-3V22C51,20.343,49.657,19,48,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PAUSE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PAUSE","display":"inline"},"children":[{"name":"g","attribs":{"id":"PAUSE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V22\r\n\t\t\t\tC29,20.343,27.657,19,26,19z M38,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C41,20.343,39.657,19,38,19z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M26,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V22\r\n\t\t\t\tC29,20.343,27.657,19,26,19z M38,19c-1.657,0-3,1.343-3,3v20c0,1.657,1.343,3,3,3s3-1.343,3-3V22C41,20.343,39.657,19,38,19z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"STOP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"STOP","display":"inline"},"children":[{"name":"g","attribs":{"id":"STOP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3\r\n\t\t\t\tV21C46,19.343,44.657,18,43,18z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3\r\n\t\t\t\tV21C46,19.343,44.657,18,43,18z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"RECORD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"RECORD","display":"inline"},"children":[{"name":"g","attribs":{"id":"RECORD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","cx":"32","cy":"32","r":"14"},"children":[{"name":"circle","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","cx":"32","cy":"32","r":"14"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PLAY_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PLAY","display":"inline"},"children":[{"name":"g","attribs":{"id":"PLAY","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,32c0-1.099-0.592-2.06-1.474-2.583l0,0L22.561,16.438\r\n\t\t\t\tc-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0C22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.557,0,1.079-0.153,1.526-0.417l0,0l0.011-0.007c0.008-0.005,0.016-0.009,0.024-0.014l21.965-12.979l0,0\r\n\t\t\t\tC45.408,34.06,46,33.1,46,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,32c0-1.099-0.592-2.06-1.474-2.583l0,0L22.561,16.438\r\n\t\t\t\tc-0.008-0.005-0.016-0.009-0.024-0.014l-0.011-0.007l0,0C22.079,16.153,21.557,16,21,16c-1.657,0-3,1.343-3,3v26\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.557,0,1.079-0.153,1.526-0.417l0,0l0.011-0.007c0.008-0.005,0.016-0.009,0.024-0.014l21.965-12.979l0,0\r\n\t\t\t\tC45.408,34.06,46,33.1,46,32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M46,55h6c1.657,0,3-1.343,3-3V31c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21\r\n\t\t\t\tC43,53.657,44.343,55,46,55z M29,55h6c1.657,0,3-1.343,3-3V19c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33\r\n\t\t\t\tC26,53.657,27.343,55,29,55z M12,55h6c1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC9,53.657,10.343,55,12,55z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z M58,58H6V6h52V58z M46,55h6c1.657,0,3-1.343,3-3V31c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v21\r\n\t\t\t\tC43,53.657,44.343,55,46,55z M29,55h6c1.657,0,3-1.343,3-3V19c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33\r\n\t\t\t\tC26,53.657,27.343,55,29,55z M12,55h6c1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v6\r\n\t\t\t\tC9,53.657,10.343,55,12,55z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LINE_GRAPH_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH","display":"inline"},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,38.035c0.628,0,1.212-0.194,1.694-0.524l6.271-3.919l13.313,8.875\r\n\t\t\t\tc0.488,0.343,1.081,0.545,1.723,0.545c0.656,0,1.263-0.211,1.757-0.569l0.001,0.001l17-12l-0.001-0.001\r\n\t\t\t\tC54.51,29.897,55,29.012,55,28.011c0-1.657-1.343-3-3-3c-0.662,0-1.274,0.215-1.77,0.578L34.953,36.373l-13.261-8.841\r\n\t\t\t\tl-0.012,0.017c-0.479-0.325-1.058-0.514-1.68-0.514c-0.575,0-1.113,0.162-1.569,0.443l-0.002-0.002l-8,5l0.001,0.002\r\n\t\t\t\tC9.573,33.006,9,33.953,9,35.035C9,36.692,10.343,38.035,12,38.035z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12,38.035c0.628,0,1.212-0.194,1.694-0.524l6.271-3.919l13.313,8.875\r\n\t\t\t\tc0.488,0.343,1.081,0.545,1.723,0.545c0.656,0,1.263-0.211,1.757-0.569l0.001,0.001l17-12l-0.001-0.001\r\n\t\t\t\tC54.51,29.897,55,29.012,55,28.011c0-1.657-1.343-3-3-3c-0.662,0-1.274,0.215-1.77,0.578L34.953,36.373l-13.261-8.841\r\n\t\t\t\tl-0.012,0.017c-0.479-0.325-1.058-0.514-1.68-0.514c-0.575,0-1.113,0.162-1.569,0.443l-0.002-0.002l-8,5l0.001,0.002\r\n\t\t\t\tC9.573,33.006,9,33.953,9,35.035C9,36.692,10.343,38.035,12,38.035z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BAR_GRAPH_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BAR_GRAPH","display":"inline"},"children":[{"name":"g","attribs":{"id":"BAR_GRAPH","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,50h6c1.657,0,3-1.343,3-3V26c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv21C45,48.657,46.343,50,48,50z M31,50h6c1.657,0,3-1.343,3-3V14c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33\r\n\t\t\t\tC28,48.657,29.343,50,31,50z M61,53H6v-7h0V8c0-1.657-1.343-3-3-3C1.343,5,0,6.343,0,8v48c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3C64,54.344,62.657,53,61,53z M14,50h6c1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv6C11,48.657,12.343,50,14,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M48,50h6c1.657,0,3-1.343,3-3V26c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv21C45,48.657,46.343,50,48,50z M31,50h6c1.657,0,3-1.343,3-3V14c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3v33\r\n\t\t\t\tC28,48.657,29.343,50,31,50z M61,53H6v-7h0V8c0-1.657-1.343-3-3-3C1.343,5,0,6.343,0,8v48c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3C64,54.344,62.657,53,61,53z M14,50h6c1.657,0,3-1.343,3-3v-6c0-1.657-1.343-3-3-3h-6c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv6C11,48.657,12.343,50,14,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"LINE_GRAPH_2_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"LINE_GRAPH_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,53H6V40.716l13.9-8.177l13.42,8.947c0.002,0.001,0.003,0.002,0.005,0.003\r\n\t\t\t\tl0.011,0.007l0.001-0.001C33.813,41.813,34.384,42,35,42c0.635,0,1.221-0.2,1.706-0.536l0.002,0.002l25.969-17.979\r\n\t\t\t\tc0,0,0.001,0,0.001-0.001l0.03-0.021l-0.002-0.003C63.487,22.923,64,22.022,64,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.635,0-1.221,0.2-1.706,0.536l-0.002-0.003l-24.324,16.84l-13.289-8.859c-0.001-0.001-0.003-0.002-0.005-0.003l-0.011-0.007\r\n\t\t\t\tl-0.001,0.001C21.187,26.187,20.616,26,20,26c-0.555,0-1.069,0.161-1.515,0.424l-0.006-0.01L6,33.755V8c0-1.657-1.343-3-3-3\r\n\t\t\t\tS0,6.343,0,8v48c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,54.343,62.657,53,61,53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,53H6V40.716l13.9-8.177l13.42,8.947c0.002,0.001,0.003,0.002,0.005,0.003\r\n\t\t\t\tl0.011,0.007l0.001-0.001C33.813,41.813,34.384,42,35,42c0.635,0,1.221-0.2,1.706-0.536l0.002,0.002l25.969-17.979\r\n\t\t\t\tc0,0,0.001,0,0.001-0.001l0.03-0.021l-0.002-0.003C63.487,22.923,64,22.022,64,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.635,0-1.221,0.2-1.706,0.536l-0.002-0.003l-24.324,16.84l-13.289-8.859c-0.001-0.001-0.003-0.002-0.005-0.003l-0.011-0.007\r\n\t\t\t\tl-0.001,0.001C21.187,26.187,20.616,26,20,26c-0.555,0-1.069,0.161-1.515,0.424l-0.006-0.01L6,33.755V8c0-1.657-1.343-3-3-3\r\n\t\t\t\tS0,6.343,0,8v48c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3C64,54.343,62.657,53,61,53z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__7_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,32L13.615,13.615C18.32,8.91,24.82,6,32,6V32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,32L13.615,13.615C18.32,8.91,24.82,6,32,6V32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_4","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,32H6C6,17.641,17.641,6,32,6V32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,32H6C6,17.641,17.641,6,32,6V32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__5_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,32L13.615,50.385C8.91,45.68,6,39.18,6,32C6,17.641,17.641,6,32,6V32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,32L13.615,50.385C8.91,45.68,6,39.18,6,32C6,17.641,17.641,6,32,6V32z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6V58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6V58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__3_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26l18.385,18.385\r\n\t\t\t\tC45.68,55.09,39.18,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26l18.385,18.385\r\n\t\t\t\tC45.68,55.09,39.18,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4","display":"inline"},"children":[{"name":"g","attribs":{"id":"CHART__x2F__1_x2F_4","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26h26\r\n\t\t\t\tC58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26h26\r\n\t\t\t\tC58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{"id":"CART__x2F__1_x2F_8","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26l18.385-18.385\r\n\t\t\t\tC55.09,18.32,58,24.82,58,32C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6v26l18.385-18.385\r\n\t\t\t\tC55.09,18.32,58,24.82,58,32C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PIE_CHART_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIE_CHART","display":"inline"},"children":[{"name":"g","attribs":{"id":"PIE_CHART","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35,0v29h29C64,12.984,51.016,0,35,0z M29,6C12.984,6,0,18.984,0,35\r\n\t\t\t\tc0,16.017,12.984,29,29,29c16.016,0,29-12.984,29-29H29V6z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M35,0v29h29C64,12.984,51.016,0,35,0z M29,6C12.984,6,0,18.984,0,35\r\n\t\t\t\tc0,16.017,12.984,29,29,29c16.016,0,29-12.984,29-29H29V6z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"POWER_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POWER","display":"inline"},"children":[{"name":"g","attribs":{"id":"POWER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,33c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3.186\r\n\t\t\t\tc0,0,0,0,0,0V30C28,31.657,29.343,33,31,33z M42,8.162v0.009C41.687,8.061,41.351,8,41,8c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.306,0.835,2.417,2,2.829v0.003C48.229,17.335,54,25.492,54,35c0,12.703-10.297,23-23,23S8,47.703,8,35\r\n\t\t\t\tc0-9.508,5.771-17.666,14-21.168v-0.003c1.165-0.412,2-1.523,2-2.829c0-1.657-1.343-3-3-3c-0.351,0-0.687,0.061-1,0.171V8.162\r\n\t\t\t\tC9.439,12.495,2,22.878,2,35c0,16.016,12.984,29,29,29c16.016,0,29-12.984,29-29C60,22.878,52.561,12.495,42,8.162z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31,33c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v3.186\r\n\t\t\t\tc0,0,0,0,0,0V30C28,31.657,29.343,33,31,33z M42,8.162v0.009C41.687,8.061,41.351,8,41,8c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.306,0.835,2.417,2,2.829v0.003C48.229,17.335,54,25.492,54,35c0,12.703-10.297,23-23,23S8,47.703,8,35\r\n\t\t\t\tc0-9.508,5.771-17.666,14-21.168v-0.003c1.165-0.412,2-1.523,2-2.829c0-1.657-1.343-3-3-3c-0.351,0-0.687,0.061-1,0.171V8.162\r\n\t\t\t\tC9.439,12.495,2,22.878,2,35c0,16.016,12.984,29,29,29c16.016,0,29-12.984,29-29C60,22.878,52.561,12.495,42,8.162z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"ALARM_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"ALARM","display":"inline"},"children":[{"name":"g","attribs":{"id":"ALARM","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44,31h-9V18c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3\r\n\t\t\t\th12c1.657,0,3-1.343,3-3C47,32.343,45.657,31,44,31z M19.412,4.575C17.37,2.967,14.8,2,12,2C5.373,2,0,7.373,0,14\r\n\t\t\t\tc0,2.8,0.967,5.37,2.575,7.412C5.809,13.862,11.862,7.809,19.412,4.575z M52.251,2c-2.742,0-5.258,0.947-7.257,2.521\r\n\t\t\t\tc7.392,3.167,13.318,9.093,16.485,16.485C63.053,19.006,64,16.49,64,13.749C64,7.26,58.74,2,52.251,2z M32,5\r\n\t\t\t\tC15.984,5,3,17.984,3,34c0,7.692,3.015,14.664,7.902,19.855l-4.023,4.024C6.336,58.422,6,59.172,6,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l4.327-4.327C20.144,61.067,25.842,63,32,63c6.17,0,11.878-1.941,16.579-5.226l4.357,4.357\r\n\t\t\t\tC53.473,62.668,54.215,63,55.034,63C56.672,63,58,61.672,58,60.034c0-0.819-0.332-1.561-0.869-2.098l-4.056-4.056\r\n\t\t\t\tC57.976,48.687,61,41.704,61,34C61,17.984,48.016,5,32,5z M32,57C19.297,57,9,46.703,9,34s10.297-23,23-23\r\n\t\t\t\tc12.702,0,23,10.297,23,23S44.703,57,32,57z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44,31h-9V18c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v16c0,1.657,1.343,3,3,3\r\n\t\t\t\th12c1.657,0,3-1.343,3-3C47,32.343,45.657,31,44,31z M19.412,4.575C17.37,2.967,14.8,2,12,2C5.373,2,0,7.373,0,14\r\n\t\t\t\tc0,2.8,0.967,5.37,2.575,7.412C5.809,13.862,11.862,7.809,19.412,4.575z M52.251,2c-2.742,0-5.258,0.947-7.257,2.521\r\n\t\t\t\tc7.392,3.167,13.318,9.093,16.485,16.485C63.053,19.006,64,16.49,64,13.749C64,7.26,58.74,2,52.251,2z M32,5\r\n\t\t\t\tC15.984,5,3,17.984,3,34c0,7.692,3.015,14.664,7.902,19.855l-4.023,4.024C6.336,58.422,6,59.172,6,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l4.327-4.327C20.144,61.067,25.842,63,32,63c6.17,0,11.878-1.941,16.579-5.226l4.357,4.357\r\n\t\t\t\tC53.473,62.668,54.215,63,55.034,63C56.672,63,58,61.672,58,60.034c0-0.819-0.332-1.561-0.869-2.098l-4.056-4.056\r\n\t\t\t\tC57.976,48.687,61,41.704,61,34C61,17.984,48.016,5,32,5z M32,57C19.297,57,9,46.703,9,34s10.297-23,23-23\r\n\t\t\t\tc12.702,0,23,10.297,23,23S44.703,57,32,57z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TIME_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TIME","display":"inline"},"children":[{"name":"g","attribs":{"id":"TIME","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V14c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v18c0,1.657,1.343,3,3,3\r\n\t\t\t\th13c1.657,0,3-1.343,3-3C48,30.343,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V14c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v18c0,1.657,1.343,3,3,3\r\n\t\t\t\th13c1.657,0,3-1.343,3-3C48,30.343,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tC58,46.36,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER_3_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M51.253,49.43c-3.766-1.826-2.382-0.399-7.309-2.427\r\n\t\t\t\tc-5.042-2.073-6.236-2.749-6.236-2.749L37.664,39.5c0,0,1.888-1.422,2.477-5.917c1.178,0.338,1.578-1.372,1.641-2.464\r\n\t\t\t\tc0.07-1.055,0.697-4.346-0.745-4.052c0.295-2.197,0.527-4.183,0.421-5.235c-0.36-3.691-2.931-7.544-9.42-7.826\r\n\t\t\t\tc-5.517,0.282-9.098,4.138-9.46,7.829c-0.104,1.052,0.108,3.036,0.403,5.236c-1.441-0.297-0.821,2.999-0.758,4.054\r\n\t\t\t\tc0.07,1.092,0.46,2.808,1.641,2.469c0.587,4.495,2.475,5.929,2.475,5.929L26.293,44.3c0,0-1.195,0.723-6.236,2.795\r\n\t\t\t\tc-4.927,2.028-3.544,0.512-7.31,2.334C8.568,44.816,6,38.715,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tC58,38.716,55.432,44.816,51.253,49.43z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M51.253,49.43c-3.766-1.826-2.382-0.399-7.309-2.427\r\n\t\t\t\tc-5.042-2.073-6.236-2.749-6.236-2.749L37.664,39.5c0,0,1.888-1.422,2.477-5.917c1.178,0.338,1.578-1.372,1.641-2.464\r\n\t\t\t\tc0.07-1.055,0.697-4.346-0.745-4.052c0.295-2.197,0.527-4.183,0.421-5.235c-0.36-3.691-2.931-7.544-9.42-7.826\r\n\t\t\t\tc-5.517,0.282-9.098,4.138-9.46,7.829c-0.104,1.052,0.108,3.036,0.403,5.236c-1.441-0.297-0.821,2.999-0.758,4.054\r\n\t\t\t\tc0.07,1.092,0.46,2.808,1.641,2.469c0.587,4.495,2.475,5.929,2.475,5.929L26.293,44.3c0,0-1.195,0.723-6.236,2.795\r\n\t\t\t\tc-4.927,2.028-3.544,0.512-7.31,2.334C8.568,44.816,6,38.715,6,32C6,17.641,17.641,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tC58,38.716,55.432,44.816,51.253,49.43z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USERS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USERS","display":"inline"},"children":[{"name":"g","attribs":{"id":"USERS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.837,41.984c-3.685-1.828-2.266-0.429-6.79-2.299\r\n\t\t\t\tc-4.524-1.867-5.595-2.477-5.595-2.477l-0.04-4.282c0,0,1.694-1.282,2.223-5.332c1.057,0.305,1.416-1.236,1.473-2.22\r\n\t\t\t\tc0.063-0.951,0.626-3.916-0.669-3.651c0.265-1.979,0.472-3.769,0.378-4.716c-0.323-3.325-2.63-6.798-8.453-7.051\r\n\t\t\t\tc-4.95,0.254-8.164,3.728-8.488,7.054c-0.093,0.947,0.097,2.735,0.361,4.718c-1.293-0.268-0.737,2.702-0.68,3.652\r\n\t\t\t\tc0.062,0.984,0.412,2.53,1.473,2.225c0.526,4.05,2.221,5.342,2.221,5.342l-0.042,4.304c0,0-1.072,0.652-5.596,2.519\r\n\t\t\t\tc-4.524,1.87-3.105,0.387-6.79,2.214c-5.824,2.889-5.824,10.832-5.824,10.832h0.002C0.001,52.817,0,52.818,0,52.82\r\n\t\t\t\tC0,54.024,0.979,55,2.187,55h42.285c1.208,0,2.187-0.976,2.187-2.18c0-0.002,0-0.003,0-0.005h0.001\r\n\t\t\t\tC46.66,52.815,46.66,44.872,40.837,41.984z M63.901,53.012c0,0,0-7.226-5.298-9.854c-3.353-1.663-2.062-0.391-6.178-2.092\r\n\t\t\t\tc-4.116-1.699-5.09-2.254-5.09-2.254l-0.036-3.896c0,0,1.541-1.166,2.022-4.85c0.962,0.277,1.288-1.124,1.34-2.02\r\n\t\t\t\tc0.057-0.865,0.569-3.562-0.608-3.322c0.241-1.801,0.43-3.429,0.344-4.291c-0.294-3.025-2.393-6.184-7.69-6.415\r\n\t\t\t\tc-4.504,0.231-7.427,3.392-7.722,6.417c-0.085,0.862,0.088,2.489,0.329,4.293c-1.177-0.244-0.67,2.458-0.618,3.323\r\n\t\t\t\tc0.057,0.896,0.375,2.302,1.34,2.024c0.479,3.685,2.02,4.86,2.02,4.86l-0.039,3.902c1.401,0.331,1.588,0.064,4.411,1.464\r\n\t\t\t\tc6.603,3.275,6.603,12.282,6.603,12.282h-0.002c0,0.002,0.001,0.004,0.001,0.006c0,1.181-0.832,2.165-1.943,2.41H61.91\r\n\t\t\t\tc1.099,0,1.99-0.888,1.99-1.983c0-0.002,0-0.003,0-0.005H63.901z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40.837,41.984c-3.685-1.828-2.266-0.429-6.79-2.299\r\n\t\t\t\tc-4.524-1.867-5.595-2.477-5.595-2.477l-0.04-4.282c0,0,1.694-1.282,2.223-5.332c1.057,0.305,1.416-1.236,1.473-2.22\r\n\t\t\t\tc0.063-0.951,0.626-3.916-0.669-3.651c0.265-1.979,0.472-3.769,0.378-4.716c-0.323-3.325-2.63-6.798-8.453-7.051\r\n\t\t\t\tc-4.95,0.254-8.164,3.728-8.488,7.054c-0.093,0.947,0.097,2.735,0.361,4.718c-1.293-0.268-0.737,2.702-0.68,3.652\r\n\t\t\t\tc0.062,0.984,0.412,2.53,1.473,2.225c0.526,4.05,2.221,5.342,2.221,5.342l-0.042,4.304c0,0-1.072,0.652-5.596,2.519\r\n\t\t\t\tc-4.524,1.87-3.105,0.387-6.79,2.214c-5.824,2.889-5.824,10.832-5.824,10.832h0.002C0.001,52.817,0,52.818,0,52.82\r\n\t\t\t\tC0,54.024,0.979,55,2.187,55h42.285c1.208,0,2.187-0.976,2.187-2.18c0-0.002,0-0.003,0-0.005h0.001\r\n\t\t\t\tC46.66,52.815,46.66,44.872,40.837,41.984z M63.901,53.012c0,0,0-7.226-5.298-9.854c-3.353-1.663-2.062-0.391-6.178-2.092\r\n\t\t\t\tc-4.116-1.699-5.09-2.254-5.09-2.254l-0.036-3.896c0,0,1.541-1.166,2.022-4.85c0.962,0.277,1.288-1.124,1.34-2.02\r\n\t\t\t\tc0.057-0.865,0.569-3.562-0.608-3.322c0.241-1.801,0.43-3.429,0.344-4.291c-0.294-3.025-2.393-6.184-7.69-6.415\r\n\t\t\t\tc-4.504,0.231-7.427,3.392-7.722,6.417c-0.085,0.862,0.088,2.489,0.329,4.293c-1.177-0.244-0.67,2.458-0.618,3.323\r\n\t\t\t\tc0.057,0.896,0.375,2.302,1.34,2.024c0.479,3.685,2.02,4.86,2.02,4.86l-0.039,3.902c1.401,0.331,1.588,0.064,4.411,1.464\r\n\t\t\t\tc6.603,3.275,6.603,12.282,6.603,12.282h-0.002c0,0.002,0.001,0.004,0.001,0.006c0,1.181-0.832,2.165-1.943,2.41H61.91\r\n\t\t\t\tc1.099,0,1.99-0.888,1.99-1.983c0-0.002,0-0.003,0-0.005H63.901z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLLOWING_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLLOWING","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLLOWING","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0-0.007-0.552-0.092-1.417L59.485,63H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z M48.101,59H40c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6h8.101\r\n\t\t\t\tC48.046,46.673,48,46.343,48,46c0-1.185,0.355-2.282,0.947-3.212c-0.609-0.213-1.332-0.486-2.247-0.865\r\n\t\t\t\tc-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491c-0.443-4.576-3.608-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.317,62.115,48,61.099,48,60C48,59.657,48.046,59.327,48.101,59z M64,53\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121l-7-7C55.578,43.336,54.828,43,54,43c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.757,50H40c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h13.757l-1.879,1.879C51.336,58.422,51,59.172,51,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C63.664,54.578,64,53.829,64,53z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0-0.007-0.552-0.092-1.417L59.485,63H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z M48.101,59H40c-3.314,0-6-2.686-6-6c0-3.314,2.686-6,6-6h8.101\r\n\t\t\t\tC48.046,46.673,48,46.343,48,46c0-1.185,0.355-2.282,0.947-3.212c-0.609-0.213-1.332-0.486-2.247-0.865\r\n\t\t\t\tc-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491c-0.443-4.576-3.608-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.317,62.115,48,61.099,48,60C48,59.657,48.046,59.327,48.101,59z M64,53\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121l-7-7C55.578,43.336,54.828,43,54,43c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121\r\n\t\t\t\tL53.757,50H40c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h13.757l-1.879,1.879C51.336,58.422,51,59.172,51,60c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l7-7C63.664,54.578,64,53.829,64,53z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FOLLOWERS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FOLLOWERS","display":"inline"},"children":[{"name":"g","attribs":{"id":"FOLLOWERS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34,53c0-1.657,0.672-3.157,1.757-4.242l7-7l0.017,0.017\r\n\t\t\t\tc0.379-0.375,0.805-0.702,1.272-0.968c-3.979-1.701-5.021-2.294-5.021-2.294l-0.054-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h38.515l-5.757-5.758C34.672,56.157,34,54.657,34,53z M52.899,47h5.827\r\n\t\t\t\tc-0.788-0.724-1.662-1.391-2.712-1.913c-1.855-0.923-2.765-1.246-3.483-1.415C52.833,44.387,53,45.174,53,46\r\n\t\t\t\tC53,46.343,52.954,46.673,52.899,47z M47.243,56H61c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H47.243l1.879-1.879\r\n\t\t\t\tC49.664,47.579,50,46.828,50,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-7,7C37.336,51.422,37,52.172,37,53\r\n\t\t\t\tc0,0.829,0.336,1.578,0.879,2.121l7,7C45.422,62.664,46.172,63,47,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121\r\n\t\t\t\tL47.243,56z M64.001,59.993c0,0,0-0.679-0.124-1.759C63.02,58.707,62.049,59,61,59h-8.103C52.953,59.326,53,59.657,53,60\r\n\t\t\t\tc0,1.099-0.317,2.114-0.832,3H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34,53c0-1.657,0.672-3.157,1.757-4.242l7-7l0.017,0.017\r\n\t\t\t\tc0.379-0.375,0.805-0.702,1.272-0.968c-3.979-1.701-5.021-2.294-5.021-2.294l-0.054-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.708c-0.128,1.304,0.133,3.764,0.496,6.493\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h38.515l-5.757-5.758C34.672,56.157,34,54.657,34,53z M52.899,47h5.827\r\n\t\t\t\tc-0.788-0.724-1.662-1.391-2.712-1.913c-1.855-0.923-2.765-1.246-3.483-1.415C52.833,44.387,53,45.174,53,46\r\n\t\t\t\tC53,46.343,52.954,46.673,52.899,47z M47.243,56H61c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H47.243l1.879-1.879\r\n\t\t\t\tC49.664,47.579,50,46.828,50,46c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-7,7C37.336,51.422,37,52.172,37,53\r\n\t\t\t\tc0,0.829,0.336,1.578,0.879,2.121l7,7C45.422,62.664,46.172,63,47,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121\r\n\t\t\t\tL47.243,56z M64.001,59.993c0,0,0-0.679-0.124-1.759C63.02,58.707,62.049,59,61,59h-8.103C52.953,59.326,53,59.657,53,60\r\n\t\t\t\tc0,1.099-0.317,2.114-0.832,3H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.515,54l-1.757-1.757l0.015-0.016C43.682,51.147,43,49.659,43,48\r\n\t\t\t\tc0-2.776,1.894-5.088,4.454-5.774c-0.243-0.096-0.481-0.191-0.754-0.304c-6.205-2.57-7.675-3.409-7.675-3.409l-0.055-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.519-6.491c-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tc-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h40.832\r\n\t\t\t\tC43.317,62.115,43,61.099,43,60c0-1.657,0.672-3.157,1.757-4.243L46.515,54z M59.243,54l3.879-3.878\r\n\t\t\t\tC63.664,49.578,64,48.828,64,48c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,49.758l-3.879-3.879\r\n\t\t\t\tC50.578,45.336,49.828,45,49,45c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L50.757,54l-3.879,3.879\r\n\t\t\t\tC46.336,58.422,46,59.172,46,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,58.243l3.879,3.879\r\n\t\t\t\tC59.422,62.664,60.172,63,61,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46.515,54l-1.757-1.757l0.015-0.016C43.682,51.147,43,49.659,43,48\r\n\t\t\t\tc0-2.776,1.894-5.088,4.454-5.774c-0.243-0.096-0.481-0.191-0.754-0.304c-6.205-2.57-7.675-3.409-7.675-3.409l-0.055-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.519-6.491c-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tc-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h40.832\r\n\t\t\t\tC43.317,62.115,43,61.099,43,60c0-1.657,0.672-3.157,1.757-4.243L46.515,54z M59.243,54l3.879-3.878\r\n\t\t\t\tC63.664,49.578,64,48.828,64,48c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,49.758l-3.879-3.879\r\n\t\t\t\tC50.578,45.336,49.828,45,49,45c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L50.757,54l-3.879,3.879\r\n\t\t\t\tC46.336,58.422,46,59.172,46,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,58.243l3.879,3.879\r\n\t\t\t\tC59.422,62.664,60.172,63,61,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.757,58.243C43.672,57.157,43,55.657,43,54c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.533,0,2.916,0.592,3.977,1.538l3.781-3.781c0.046-0.046,0.103-0.08,0.15-0.124c-0.298-0.183-0.57-0.386-0.894-0.547\r\n\t\t\t\tc-5.055-2.515-3.108-0.591-9.314-3.164c-6.205-2.57-7.675-3.409-7.675-3.409l-0.055-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.941-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.443-4.576-3.607-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h46.691c-0.335-0.222-0.65-0.474-0.933-0.757L44.757,58.243z M64.001,59.993\r\n\t\t\t\tc0,0-0.008-1.709-0.498-4.011l-6.261,6.261c-0.284,0.283-0.598,0.535-0.933,0.757H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z M64,50c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L53,53.757l-1.879-1.879\r\n\t\t\t\tC50.578,51.336,49.828,51,49,51c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4C51.422,60.664,52.172,61,53,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l8-8C63.664,51.579,64,50.828,64,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M44.757,58.243C43.672,57.157,43,55.657,43,54c0-3.314,2.686-6,6-6\r\n\t\t\t\tc1.533,0,2.916,0.592,3.977,1.538l3.781-3.781c0.046-0.046,0.103-0.08,0.15-0.124c-0.298-0.183-0.57-0.386-0.894-0.547\r\n\t\t\t\tc-5.055-2.515-3.108-0.591-9.314-3.164c-6.205-2.57-7.675-3.409-7.675-3.409l-0.055-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.941-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.443-4.576-3.607-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h46.691c-0.335-0.222-0.65-0.474-0.933-0.757L44.757,58.243z M64.001,59.993\r\n\t\t\t\tc0,0-0.008-1.709-0.498-4.011l-6.261,6.261c-0.284,0.283-0.598,0.535-0.933,0.757H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z M64,50c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L53,53.757l-1.879-1.879\r\n\t\t\t\tC50.578,51.336,49.828,51,49,51c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4C51.422,60.664,52.172,61,53,61\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879l8-8C63.664,51.579,64,50.828,64,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,54c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H48\r\n\t\t\t\tC46.343,51,45,52.343,45,54z M64.001,59.993c0,0-0.005-0.571-0.096-1.472C62.854,59.43,61.5,60,60,60H48c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6h11.763c-0.998-1.141-2.225-2.155-3.749-2.913c-5.055-2.515-3.108-0.591-9.314-3.164\r\n\t\t\t\tc-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491c-0.443-4.576-3.608-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,54c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H48\r\n\t\t\t\tC46.343,51,45,52.343,45,54z M64.001,59.993c0,0-0.005-0.571-0.096-1.472C62.854,59.43,61.5,60,60,60H48c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6h11.763c-0.998-1.141-2.225-2.155-3.749-2.913c-5.055-2.515-3.108-0.591-9.314-3.164\r\n\t\t\t\tc-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491c-0.443-4.576-3.608-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466\r\n\t\t\t\tc-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0-0.005-0.567-0.098-1.47C62.852,59.431,61.499,60,60,60\r\n\t\t\t\tc0,1.098-0.317,2.114-0.832,3H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M42,54c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0-1.952,0.946-3.668,2.389-4.764c-0.797-0.208-1.898-0.571-3.689-1.314c-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.519-6.491c-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tc-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h45.832\r\n\t\t\t\tC48.317,62.115,48,61.099,48,60C44.686,60,42,57.314,42,54z M63,54c0-1.657-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-3h3\r\n\t\t\t\tC61.657,57,63,55.657,63,54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0-0.005-0.567-0.098-1.47C62.852,59.431,61.499,60,60,60\r\n\t\t\t\tc0,1.098-0.317,2.114-0.832,3H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M42,54c0-3.314,2.686-6,6-6\r\n\t\t\t\tc0-1.952,0.946-3.668,2.389-4.764c-0.797-0.208-1.898-0.571-3.689-1.314c-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.519-6.491c-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tc-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h45.832\r\n\t\t\t\tC48.317,62.115,48,61.099,48,60C44.686,60,42,57.314,42,54z M63,54c0-1.657-1.343-3-3-3h-3v-3c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3v3c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-3h3\r\n\t\t\t\tC61.657,57,63,55.657,63,54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"USER_2_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER_1_","display":"inline"},"children":[{"name":"g","attribs":{"id":"USER_1_","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0,0-10.932-7.987-14.906\r\n\t\t\t\tc-5.055-2.515-3.108-0.591-9.314-3.164c-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M64.001,59.993c0,0,0-10.932-7.987-14.906\r\n\t\t\t\tc-5.055-2.515-3.108-0.591-9.314-3.164c-6.205-2.57-7.675-3.409-7.675-3.409l-0.054-5.893c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.45,0.42,1.942-1.701,2.02-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.519-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"HEART_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"HEART","display":"inline"},"children":[{"name":"g","attribs":{"id":"HEART","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.728,9.272C55.328,5.873,50.808,4,46,4c-4.808,0-8.662,1.727-12.061,5.126\r\n\t\t\t\tc-0.002,0.002-0.004,0.003-0.006,0.005c0,0-0.001,0.001-0.001,0.001L32,11.565l-1.932-2.286\r\n\t\t\t\tc-0.002-0.002-0.004-0.004-0.006-0.006c0,0-0.001,0-0.001-0.001C26.661,5.873,22.808,4,18,4C13.192,4,8.672,5.873,5.272,9.272\r\n\t\t\t\tC1.872,12.672,0,17.192,0,22c0,4.806,1.87,9.323,5.266,12.723L29.16,58.817C29.911,59.574,30.933,60,32,60\r\n\t\t\t\tc1.066,0,2.089-0.426,2.84-1.183l23.892-24.093C62.129,31.325,64,26.806,64,22C64,17.192,62.128,12.672,58.728,9.272z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M58.728,9.272C55.328,5.873,50.808,4,46,4c-4.808,0-8.662,1.727-12.061,5.126\r\n\t\t\t\tc-0.002,0.002-0.004,0.003-0.006,0.005c0,0-0.001,0.001-0.001,0.001L32,11.565l-1.932-2.286\r\n\t\t\t\tc-0.002-0.002-0.004-0.004-0.006-0.006c0,0-0.001,0-0.001-0.001C26.661,5.873,22.808,4,18,4C13.192,4,8.672,5.873,5.272,9.272\r\n\t\t\t\tC1.872,12.672,0,17.192,0,22c0,4.806,1.87,9.323,5.266,12.723L29.16,58.817C29.911,59.574,30.933,60,32,60\r\n\t\t\t\tc1.066,0,2.089-0.426,2.84-1.183l23.892-24.093C62.129,31.325,64,26.806,64,22C64,17.192,62.128,12.672,58.728,9.272z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAP__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.055,46.909L23,52.939V19.79l16-8.727v25.338\r\n\t\t\t\tc1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18c0-0.948-0.448-1.782-1.134-2.332\r\n\t\t\t\tl0.001-0.001l-0.025-0.019c-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3\r\n\t\t\t\tc-0.495,0-0.956,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3\r\n\t\t\t\tC2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.529,0,1.018-0.148,1.449-0.388l0.003,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13c7.18,0,13-5.82,13-13S57.18,35,50,35z\r\n\t\t\t\t M56.121,49.879C56.664,50.422,57,51.172,57,52c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L50,52.243l-1.879,1.879\r\n\t\t\t\tC47.578,54.664,46.828,55,46,55c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L45.757,48l-1.879-1.879\r\n\t\t\t\tC43.336,45.578,43,44.829,43,44c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L50,43.757l1.879-1.879\r\n\t\t\t\tC52.422,41.336,53.172,41,54,41c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L54.243,48L56.121,49.879z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M34.055,46.909L23,52.939V19.79l16-8.727v25.338\r\n\t\t\t\tc1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18c0-0.948-0.448-1.782-1.134-2.332\r\n\t\t\t\tl0.001-0.001l-0.025-0.019c-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3\r\n\t\t\t\tc-0.495,0-0.956,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3\r\n\t\t\t\tC2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.529,0,1.018-0.148,1.449-0.388l0.003,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z M50,35c-7.18,0-13,5.82-13,13s5.82,13,13,13c7.18,0,13-5.82,13-13S57.18,35,50,35z\r\n\t\t\t\t M56.121,49.879C56.664,50.422,57,51.172,57,52c0,1.657-1.343,3-3,3c-0.828,0-1.578-0.336-2.121-0.879L50,52.243l-1.879,1.879\r\n\t\t\t\tC47.578,54.664,46.828,55,46,55c-1.657,0-3-1.343-3-3c0-0.829,0.336-1.578,0.879-2.121L45.757,48l-1.879-1.879\r\n\t\t\t\tC43.336,45.578,43,44.829,43,44c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L50,43.757l1.879-1.879\r\n\t\t\t\tC52.422,41.336,53.172,41,54,41c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121L54.243,48L56.121,49.879z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAP__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M58.121,47.121l-8,8C49.578,55.664,48.828,56,48,56c-0.828,0-1.578-0.336-2.121-0.879l-4-4\r\n\t\t\t\tC41.336,50.578,41,49.828,41,49c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L48,48.757l5.879-5.879\r\n\t\t\t\tC54.422,42.336,55.172,42,56,42c1.657,0,3,1.343,3,3C59,45.829,58.664,46.578,58.121,47.121z M34.055,46.909L23,52.939V19.79\r\n\t\t\t\tl16-8.727v25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18\r\n\t\t\t\tc0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019c-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001\r\n\t\t\t\tC43.352,3.256,42.709,3,42,3c-0.495,0-0.955,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668\r\n\t\t\t\tC5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.388l0.004,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M58.121,47.121l-8,8C49.578,55.664,48.828,56,48,56c-0.828,0-1.578-0.336-2.121-0.879l-4-4\r\n\t\t\t\tC41.336,50.578,41,49.828,41,49c0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L48,48.757l5.879-5.879\r\n\t\t\t\tC54.422,42.336,55.172,42,56,42c1.657,0,3,1.343,3,3C59,45.829,58.664,46.578,58.121,47.121z M34.055,46.909L23,52.939V19.79\r\n\t\t\t\tl16-8.727v25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18\r\n\t\t\t\tc0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019c-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001\r\n\t\t\t\tC43.352,3.256,42.709,3,42,3c-0.495,0-0.955,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668\r\n\t\t\t\tC5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.388l0.004,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAP__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M56,51H44c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h12c1.657,0,3,1.343,3,3\r\n\t\t\t\tC59,49.657,57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727v25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5\r\n\t\t\t\tv13.291c2.268,0.746,4.307,1.987,6,3.593V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.388l0.003,0.006\r\n\t\t\t\tl13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M56,51H44c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h12c1.657,0,3,1.343,3,3\r\n\t\t\t\tC59,49.657,57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727v25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5\r\n\t\t\t\tv13.291c2.268,0.746,4.307,1.987,6,3.593V18c0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019\r\n\t\t\t\tc-0.074-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001C43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344\r\n\t\t\t\tL40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668C5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40\r\n\t\t\t\tc0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61c0.528,0,1.018-0.148,1.449-0.388l0.003,0.006\r\n\t\t\t\tl13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909z M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAP__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAP__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M56,51h-3v3c0,1.657-1.343,3-3,3s-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h3v-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3C59,49.657,57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727\r\n\t\t\t\tv25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18\r\n\t\t\t\tc0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019c-0.073-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001\r\n\t\t\t\tC43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668\r\n\t\t\t\tC5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.388l0.003,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M50,35c-7.18,0-13,5.82-13,13c0,7.18,5.82,13,13,13c7.18,0,13-5.82,13-13\r\n\t\t\t\tC63,40.82,57.18,35,50,35z M56,51h-3v3c0,1.657-1.343,3-3,3s-3-1.343-3-3v-3h-3c-1.657,0-3-1.343-3-3c0-1.657,1.343-3,3-3h3v-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3s3,1.343,3,3v3h3c1.657,0,3,1.343,3,3C59,49.657,57.657,51,56,51z M34.055,46.909L23,52.939V19.79l16-8.727\r\n\t\t\t\tv25.338c1.693-1.606,3.732-2.847,6-3.593V12.017l10,7.5v13.291c2.268,0.746,4.307,1.987,6,3.593V18\r\n\t\t\t\tc0-0.948-0.448-1.782-1.134-2.332l0.001-0.001l-0.025-0.019c-0.073-0.058-0.145-0.117-0.224-0.168L43.867,3.667l-0.001,0.001\r\n\t\t\t\tC43.352,3.256,42.709,3,42,3c-0.495,0-0.956,0.131-1.367,0.344L40.63,3.339L20.251,14.455L5.867,3.667L5.866,3.668\r\n\t\t\t\tC5.352,3.256,4.709,3,4,3C2.343,3,1,4.343,1,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861C18.692,60.762,19.315,61,20,61\r\n\t\t\t\tc0.528,0,1.018-0.148,1.449-0.388l0.003,0.006l13.457-7.34C34.331,51.623,34,49.852,34,48C34,47.632,34.031,47.271,34.055,46.909\r\n\t\t\t\tz M17,51.986l-10-7.5V12.017l10,7.5V51.986z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAP","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.866,15.668l0.001-0.001l-0.025-0.019c-0.073-0.058-0.145-0.117-0.224-0.168\r\n\t\t\t\tL44.867,3.667l-0.001,0.001C44.352,3.256,43.709,3,43,3c-0.495,0-0.956,0.131-1.367,0.344L41.63,3.339L21.251,14.455L6.867,3.667\r\n\t\t\t\tL6.866,3.668C6.352,3.256,5.709,3,5,3C3.343,3,2,4.343,2,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861\r\n\t\t\t\tC19.692,60.762,20.315,61,21,61c0.528,0,1.018-0.148,1.449-0.388l0.003,0.006L42.725,49.56l14.542,10.906l0.012-0.016\r\n\t\t\t\tC57.766,60.795,58.358,61,59,61c1.657,0,3-1.343,3-3V18C62,17.052,61.552,16.218,60.866,15.668z M18,51.986l-10-7.5V12.017\r\n\t\t\t\tl10,7.5V51.986z M40,44.212l-16,8.727V19.79l16-8.727V44.212z M56,52.017l-10-7.5v-32.5l10,7.5V52.017z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M60.866,15.668l0.001-0.001l-0.025-0.019c-0.073-0.058-0.145-0.117-0.224-0.168\r\n\t\t\t\tL44.867,3.667l-0.001,0.001C44.352,3.256,43.709,3,43,3c-0.495,0-0.956,0.131-1.367,0.344L41.63,3.339L21.251,14.455L6.867,3.667\r\n\t\t\t\tL6.866,3.668C6.352,3.256,5.709,3,5,3C3.343,3,2,4.343,2,6v40c0,1.056,0.548,1.98,1.372,2.514l15.815,11.861\r\n\t\t\t\tC19.692,60.762,20.315,61,21,61c0.528,0,1.018-0.148,1.449-0.388l0.003,0.006L42.725,49.56l14.542,10.906l0.012-0.016\r\n\t\t\t\tC57.766,60.795,58.358,61,59,61c1.657,0,3-1.343,3-3V18C62,17.052,61.552,16.218,60.866,15.668z M18,51.986l-10-7.5V12.017\r\n\t\t\t\tl10,7.5V51.986z M40,44.212l-16,8.727V19.79l16-8.727V44.212z M56,52.017l-10-7.5v-32.5l10,7.5V52.017z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH","display":"inline"},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__HIGH","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.879,19.121l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.83-0.341-1.573-0.887-2.113l0.009-0.009l-1.556-1.556l-5.445-5.445C11.578,7.336,10.828,7,10,7c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L14.879,19.121z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l1.555-1.556l5.444-5.444\r\n\t\t\t\tC56.664,11.578,57,10.828,57,10c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-5.444,5.445l-1.556,1.556l0.009,0.009\r\n\t\t\t\tC44.342,15.427,44,16.17,44,17C44,18.657,45.343,20,47,20z M32,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC29,12.657,30.343,14,32,14z M14,32c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8\r\n\t\t\t\tC12.657,35,14,33.657,14,32z M50.677,46.434l-1.555-1.556C48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l1.556,1.556l5.444,5.444C52.422,56.664,53.172,57,54,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L50.677,46.434z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-7,7C7.336,52.422,7,53.172,7,54\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l5.445-5.444l1.556-1.556C19.664,48.579,20,47.828,20,47\r\n\t\t\t\tC20,45.343,18.657,44,17,44z M61,29h-8c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M32,50c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-8C35,51.343,33.657,50,32,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M14.879,19.121l0.009-0.009C15.427,19.659,16.17,20,17,20c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.83-0.341-1.573-0.887-2.113l0.009-0.009l-1.556-1.556l-5.445-5.445C11.578,7.336,10.828,7,10,7c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L14.879,19.121z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l1.555-1.556l5.444-5.444\r\n\t\t\t\tC56.664,11.578,57,10.828,57,10c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879l-5.444,5.445l-1.556,1.556l0.009,0.009\r\n\t\t\t\tC44.342,15.427,44,16.17,44,17C44,18.657,45.343,20,47,20z M32,14c1.657,0,3-1.343,3-3V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v8\r\n\t\t\t\tC29,12.657,30.343,14,32,14z M14,32c0-1.657-1.343-3-3-3H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8\r\n\t\t\t\tC12.657,35,14,33.657,14,32z M50.677,46.434l-1.555-1.556C48.578,44.336,47.828,44,47,44c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l1.556,1.556l5.444,5.444C52.422,56.664,53.172,57,54,57c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L50.677,46.434z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-7,7C7.336,52.422,7,53.172,7,54\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879l5.445-5.444l1.556-1.556C19.664,48.579,20,47.828,20,47\r\n\t\t\t\tC20,45.343,18.657,44,17,44z M61,29h-8c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h8c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M32,50c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-8C35,51.343,33.657,50,32,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW","display":"inline"},"children":[{"name":"g","attribs":{"id":"BRIGHTNESS__x2F__LOW","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.879,17.122l2,2l0.009-0.009C15.427,19.659,16.17,20,17,20\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.888-2.113l0.009-0.009l-2-2l-0.009,0.009C16.573,12.341,15.83,12,15,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.83,0.341,1.573,0.888,2.112L12.879,17.122z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l2-2\r\n\t\t\t\tl-0.009-0.009C51.659,16.573,52,15.83,52,15c0-1.657-1.343-3-3-3c-0.83,0-1.573,0.341-2.113,0.888l-0.009-0.009l-2,2l0.009,0.009\r\n\t\t\t\tC44.342,15.427,44,16.17,44,17C44,18.657,45.343,20,47,20z M14,32c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h2C12.657,35,14,33.657,14,32z M32,14c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v2\r\n\t\t\t\tC29,12.657,30.343,14,32,14z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M49.121,44.879C48.578,44.336,47.828,44,47,44\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l2,2C47.422,51.664,48.172,52,49,52c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-2,2C12.336,47.422,12,48.172,12,49\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879l2-2C19.664,48.579,20,47.828,20,47C20,45.343,18.657,44,17,44z M55,29h-2\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h2c1.657,0,3-1.343,3-3C58,30.343,56.657,29,55,29z M32,50c-1.657,0-3,1.343-3,3v2\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-2C35,51.343,33.657,50,32,50z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.879,17.122l2,2l0.009-0.009C15.427,19.659,16.17,20,17,20\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.83-0.341-1.573-0.888-2.113l0.009-0.009l-2-2l-0.009,0.009C16.573,12.341,15.83,12,15,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.83,0.341,1.573,0.888,2.112L12.879,17.122z M47,20c0.83,0,1.573-0.342,2.113-0.888l0.009,0.009l2-2\r\n\t\t\t\tl-0.009-0.009C51.659,16.573,52,15.83,52,15c0-1.657-1.343-3-3-3c-0.83,0-1.573,0.341-2.113,0.888l-0.009-0.009l-2,2l0.009,0.009\r\n\t\t\t\tC44.342,15.427,44,16.17,44,17C44,18.657,45.343,20,47,20z M14,32c0-1.657-1.343-3-3-3H9c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h2C12.657,35,14,33.657,14,32z M32,14c1.657,0,3-1.343,3-3V9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v2\r\n\t\t\t\tC29,12.657,30.343,14,32,14z M32,20c-6.627,0-12,5.373-12,12c0,1.021,0.141,2.007,0.381,2.953l1.183,2.958\r\n\t\t\t\tC23.627,41.544,27.524,44,32,44c6.627,0,12-5.372,12-12C44,25.373,38.627,20,32,20z M32,38c-3.314,0-6-2.686-6-6\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,35.314,35.314,38,32,38z M49.121,44.879C48.578,44.336,47.828,44,47,44\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l2,2C47.422,51.664,48.172,52,49,52c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L49.121,44.879z M17,44c-0.828,0-1.578,0.336-2.121,0.879l-2,2C12.336,47.422,12,48.172,12,49\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879l2-2C19.664,48.579,20,47.828,20,47C20,45.343,18.657,44,17,44z M55,29h-2\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h2c1.657,0,3-1.343,3-3C58,30.343,56.657,29,55,29z M32,50c-1.657,0-3,1.343-3,3v2\r\n\t\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-2C35,51.343,33.657,50,32,50z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"POLAROIDS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POLAROIDS","display":"inline"},"children":[{"name":"g","attribs":{"id":"POLAROIDS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,12H3c-1.657,0-3,1.343-3,3v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3\r\n\t\t\t\tV15C48,13.343,46.657,12,45,12z M42,49H6V18h36V49z M61,0H19c-1.657,0-3,1.343-3,3v6h6V6h36v31h-7v15h10c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,12H3c-1.657,0-3,1.343-3,3v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3\r\n\t\t\t\tV15C48,13.343,46.657,12,45,12z M42,49H6V18h36V49z M61,0H19c-1.657,0-3,1.343-3,3v6h6V6h36v31h-7v15h10c1.657,0,3-1.343,3-3V3\r\n\t\t\t\tC64,1.343,62.657,0,61,0z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"POLAROID_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"POLAROID","display":"inline"},"children":[{"name":"g","attribs":{"id":"POLAROID","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,6H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC56,7.343,54.657,6,53,6z M50,43H14V12h36V43z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53,6H11C9.343,6,8,7.343,8,9v46c0,1.657,1.343,3,3,3h42c1.657,0,3-1.343,3-3V9\r\n\t\t\t\tC56,7.343,54.657,6,53,6z M50,43H14V12h36V43z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PICTURE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PICTURE","display":"inline"},"children":[{"name":"g","attribs":{"id":"PICTURE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,28c3.314,0,6-2.686,6-6c0-3.314-2.686-6-6-6s-6,2.686-6,6\r\n\t\t\t\tC16,25.314,18.686,28,22,28z M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2h-3.367C52.403,2.838,51.304,2,50,2c-1.304,0-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC43.403,2.838,42.304,2,41,2c-1.304,0-2.403,0.838-2.816,2h-3.367C34.403,2.838,33.304,2,32,2c-1.304,0-2.403,0.838-2.816,2\r\n\t\t\t\th-3.367C25.403,2.838,24.304,2,23,2c-1.304,0-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,11.597,2,12.696,2,14c0,1.304,0.837,2.403,2,2.816v3.367C2.838,20.597,2,21.696,2,23c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,29.597,2,30.696,2,32c0,1.304,0.837,2.403,2,2.816v3.367C2.838,38.597,2,39.696,2,41s0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,47.597,2,48.696,2,50c0,1.304,0.837,2.403,2,2.816v3.367C2.838,56.597,2,57.696,2,59c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.304-0.837-2.403-2-2.816v-3.367c1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816s-0.837-2.403-2-2.816v-3.367c1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z M51,39\r\n\t\t\t\tl-9-14L28,42l-3-3L13,51h38V39z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M22,28c3.314,0,6-2.686,6-6c0-3.314-2.686-6-6-6s-6,2.686-6,6\r\n\t\t\t\tC16,25.314,18.686,28,22,28z M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2h-3.367C52.403,2.838,51.304,2,50,2c-1.304,0-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC43.403,2.838,42.304,2,41,2c-1.304,0-2.403,0.838-2.816,2h-3.367C34.403,2.838,33.304,2,32,2c-1.304,0-2.403,0.838-2.816,2\r\n\t\t\t\th-3.367C25.403,2.838,24.304,2,23,2c-1.304,0-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2\r\n\t\t\t\tc-1.304,0-2.403,0.838-2.816,2H7.816C7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,11.597,2,12.696,2,14c0,1.304,0.837,2.403,2,2.816v3.367C2.838,20.597,2,21.696,2,23c0,1.304,0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,29.597,2,30.696,2,32c0,1.304,0.837,2.403,2,2.816v3.367C2.838,38.597,2,39.696,2,41s0.837,2.403,2,2.816v3.367\r\n\t\t\t\tC2.838,47.597,2,48.696,2,50c0,1.304,0.837,2.403,2,2.816v3.367C2.838,56.597,2,57.696,2,59c0,1.657,1.343,3,3,3\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.304-0.837-2.403-2-2.816v-3.367c1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816s-0.837-2.403-2-2.816v-3.367c1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.163-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z M51,39\r\n\t\t\t\tl-9-14L28,42l-3-3L13,51h38V39z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"FRAME_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"FRAME","display":"inline"},"children":[{"name":"g","attribs":{"id":"FRAME","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.304,0-2.403,0.838-2.816,2h-3.367C52.403,2.838,51.304,2,50,2c-1.304,0-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC43.403,2.838,42.304,2,41,2c-1.304,0-2.403,0.838-2.816,2h-3.367C34.403,2.838,33.304,2,32,2c-1.304,0-2.403,0.838-2.816,2\r\n\t\t\t\th-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2s-2.403,0.838-2.816,2H7.816\r\n\t\t\t\tC7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367C2.837,11.597,2,12.696,2,14\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,20.597,2,21.696,2,23c0,1.304,0.837,2.403,2,2.816v3.367C2.837,29.597,2,30.696,2,32\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,38.597,2,39.696,2,41s0.837,2.403,2,2.816v3.367C2.837,47.597,2,48.696,2,50\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,56.597,2,57.696,2,59c0,1.657,1.343,3,3,3c1.304,0,2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.304-0.837-2.403-2-2.816v-3.367c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.162-0.413,2-1.512,2-2.816s-0.837-2.403-2-2.816v-3.367c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62,14c0-1.304-0.837-2.403-2-2.816V7.816C61.163,7.403,62,6.305,62,5\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.304,0-2.403,0.838-2.816,2h-3.367C52.403,2.838,51.304,2,50,2c-1.304,0-2.403,0.838-2.816,2h-3.367\r\n\t\t\t\tC43.403,2.838,42.304,2,41,2c-1.304,0-2.403,0.838-2.816,2h-3.367C34.403,2.838,33.304,2,32,2c-1.304,0-2.403,0.838-2.816,2\r\n\t\t\t\th-3.367C25.403,2.838,24.304,2,23,2s-2.403,0.838-2.816,2h-3.367C16.403,2.838,15.304,2,14,2s-2.403,0.838-2.816,2H7.816\r\n\t\t\t\tC7.403,2.838,6.304,2,5,2C3.343,2,2,3.343,2,5c0,1.304,0.837,2.403,2,2.816v3.367C2.837,11.597,2,12.696,2,14\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,20.597,2,21.696,2,23c0,1.304,0.837,2.403,2,2.816v3.367C2.837,29.597,2,30.696,2,32\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,38.597,2,39.696,2,41s0.837,2.403,2,2.816v3.367C2.837,47.597,2,48.696,2,50\r\n\t\t\t\tc0,1.304,0.837,2.403,2,2.816v3.367C2.837,56.597,2,57.696,2,59c0,1.657,1.343,3,3,3c1.304,0,2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2s2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367\r\n\t\t\t\tc0.413,1.162,1.512,2,2.816,2c1.304,0,2.403-0.837,2.816-2h3.367c0.413,1.162,1.512,2,2.816,2c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.304-0.837-2.403-2-2.816v-3.367c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.162-0.413,2-1.512,2-2.816s-0.837-2.403-2-2.816v-3.367c1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367\r\n\t\t\t\tc1.162-0.413,2-1.512,2-2.816c0-1.304-0.837-2.403-2-2.816v-3.367C61.163,16.403,62,15.304,62,14z M54,54H10V10h44V54z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__REMOVE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.585,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18s18,8.059,18,18C42,33.941,33.941,42,24,42z M34,21H14c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0S0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.585,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18s18,8.059,18,18C42,33.941,33.941,42,24,42z M34,21H14c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h20\r\n\t\t\t\tc1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS__x2F__ADD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0C10.745,0,0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.585,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C42,33.941,33.941,42,24,42z M34,21h-7v-7c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h7v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7h7\r\n\t\t\t\tc1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0C10.745,0,0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.585,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18c9.941,0,18,8.059,18,18C42,33.941,33.941,42,24,42z M34,21h-7v-7c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v7h-7c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h7v7c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3v-7h7\r\n\t\t\t\tc1.657,0,3-1.343,3-3C37,22.344,35.657,21,34,21z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"MAGNIFYING_GLASS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS","display":"inline"},"children":[{"name":"g","attribs":{"id":"MAGNIFYING_GLASS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0C10.745,0,0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.584,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18s18,8.059,18,18C42,33.941,33.941,42,24,42z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M62.243,53.758L44.658,36.173C46.768,32.601,48,28.449,48,24\r\n\t\t\t\tC48,10.745,37.255,0,24,0C10.745,0,0,10.745,0,24s10.745,24,24,24c4.449,0,8.601-1.232,12.173-3.342l17.584,17.584\r\n\t\t\t\tC54.843,63.329,56.343,64,58,64c3.314,0,6-2.686,6-6C64,56.343,63.328,54.843,62.243,53.758z M24,42c-9.941,0-18-8.059-18-18\r\n\t\t\t\tc0-9.941,8.059-18,18-18s18,8.059,18,18C42,33.941,33.941,42,24,42z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__RIGHT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47,29.778l0.007-0.008l-10-9L37,20.778C36.468,20.3,35.772,20,35,20\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L37.182,29H19c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182\r\n\t\t\t\tl-4.189,3.77L33,38.778c-0.61,0.549-1,1.337-1,2.222c0,1.657,1.343,3,3,3c0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9\r\n\t\t\t\tL47,34.222c0.61-0.549,1-1.336,1-2.222S47.609,30.328,47,29.778z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M47,29.778l0.007-0.008l-10-9L37,20.778C36.468,20.3,35.772,20,35,20\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L37.182,29H19c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182\r\n\t\t\t\tl-4.189,3.77L33,38.778c-0.61,0.549-1,1.337-1,2.222c0,1.657,1.343,3,3,3c0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9\r\n\t\t\t\tL47,34.222c0.61-0.549,1-1.336,1-2.222S47.609,30.328,47,29.778z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__LEFT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L17,29.778c-0.61,0.549-1,1.336-1,2.222s0.391,1.673,1,2.222\r\n\t\t\t\tl-0.007,0.008l10,9L27,43.222C27.532,43.701,28.228,44,29,44c1.657,0,3-1.343,3-3c0-0.885-0.391-1.673-1-2.222l0.007-0.008\r\n\t\t\t\tL26.818,35H45c1.657,0,3-1.343,3-3C48,30.343,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.36,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L17,29.778c-0.61,0.549-1,1.336-1,2.222s0.391,1.673,1,2.222\r\n\t\t\t\tl-0.007,0.008l10,9L27,43.222C27.532,43.701,28.228,44,29,44c1.657,0,3-1.343,3-3c0-0.885-0.391-1.673-1-2.222l0.007-0.008\r\n\t\t\t\tL26.818,35H45c1.657,0,3-1.343,3-3C48,30.343,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.36,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__UP_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__UP","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.23,26.993l-9-10l-0.008,0.007c-0.549-0.61-1.336-1-2.222-1\r\n\t\t\t\tc-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10l0.008,0.007C20.3,27.532,20,28.229,20,29c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V26.818l3.77,4.189L38.778,31\r\n\t\t\t\tc0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.778-2L43.23,26.993z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6\r\n\t\t\t\tc14.36,0,26,11.64,26,26S46.36,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.23,26.993l-9-10l-0.008,0.007c-0.549-0.61-1.336-1-2.222-1\r\n\t\t\t\tc-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10l0.008,0.007C20.3,27.532,20,28.229,20,29c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V26.818l3.77,4.189L38.778,31\r\n\t\t\t\tc0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.778-2L43.23,26.993z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\tc0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6\r\n\t\t\t\tc14.36,0,26,11.64,26,26S46.36,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DOWN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,32c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007L35,37.182V19\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v18.182l-3.77-4.189l-0.008,0.007c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.772,0.299,1.468,0.778,2l-0.008,0.008l9,10L29.778,47c0.549,0.61,1.336,1,2.222,1c0.885,0,1.673-0.391,2.222-1l0.008,0.007\r\n\t\t\t\tl9-10L43.222,37C43.7,36.468,44,35.772,44,35C44,33.343,42.657,32,41,32z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\ts32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6s26,11.64,26,26S46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,32c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007L35,37.182V19\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v18.182l-3.77-4.189l-0.008,0.007c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.772,0.299,1.468,0.778,2l-0.008,0.008l9,10L29.778,47c0.549,0.61,1.336,1,2.222,1c0.885,0,1.673-0.391,2.222-1l0.008,0.007\r\n\t\t\t\tl9-10L43.222,37C43.7,36.468,44,35.772,44,35C44,33.343,42.657,32,41,32z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\ts32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6s26,11.64,26,26S46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"BLOCK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"BLOCK","display":"inline"},"children":[{"name":"g","attribs":{"id":"BLOCK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32c0-6.098,2.115-11.694,5.63-16.128\r\n\t\t\t\tL48.128,52.37C43.694,55.886,38.098,58,32,58z M52.37,48.128L15.873,11.63C20.307,8.115,25.902,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tC58,38.098,55.886,43.694,52.37,48.128z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32c0-6.098,2.115-11.694,5.63-16.128\r\n\t\t\t\tL48.128,52.37C43.694,55.886,38.098,58,32,58z M52.37,48.128L15.873,11.63C20.307,8.115,25.902,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tC58,38.098,55.886,43.694,52.37,48.128z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__DELETE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z M46,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879\r\n\t\t\t\tC22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879\r\n\t\t\t\tC18.336,41.422,18,42.172,18,43c0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879L32,36.243l8.879,8.879\r\n\t\t\t\tC41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878\r\n\t\t\t\tC45.664,22.578,46,21.829,46,21z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26\r\n\t\t\t\tS46.359,58,32,58z M46,21c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879\r\n\t\t\t\tC22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879\r\n\t\t\t\tC18.336,41.422,18,42.172,18,43c0,1.657,1.343,3,3,3c0.828,0,1.579-0.336,2.121-0.879L32,36.243l8.879,8.879\r\n\t\t\t\tC41.422,45.664,42.172,46,43,46c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878\r\n\t\t\t\tC45.664,22.578,46,21.829,46,21z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,43.001C46,43.001,46,43.001,46,43.001C46,43,46,43,46,42.999V43.001z\r\n\t\t\t\t M46,20.999v0.002C46,21.001,46,21,46,20.999C46,21,46,21,46,20.999z M44,21c-0.828,0-1.578,0.336-2.121,0.879L28,35.758\r\n\t\t\t\tl-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l9,9\r\n\t\t\t\tC26.422,42.664,27.172,43,28,43c0.828,0,1.578-0.336,2.121-0.879l16-16C46.664,25.579,47,24.828,47,24C47,22.343,45.657,21,44,21\r\n\t\t\t\tz M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26S46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M46,43.001C46,43.001,46,43.001,46,43.001C46,43,46,43,46,42.999V43.001z\r\n\t\t\t\t M46,20.999v0.002C46,21.001,46,21,46,20.999C46,21,46,21,46,20.999z M44,21c-0.828,0-1.578,0.336-2.121,0.879L28,35.758\r\n\t\t\t\tl-6.879-6.879C20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l9,9\r\n\t\t\t\tC26.422,42.664,27.172,43,28,43c0.828,0,1.578-0.336,2.121-0.879l16-16C46.664,25.579,47,24.828,47,24C47,22.343,45.657,21,44,21\r\n\t\t\t\tz M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32s32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.64,26,26S46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__MINUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26c1.657,0,3-1.343,3-3\r\n\t\t\t\tS46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32c17.673,0,32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.641,26,26S46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H19c-1.657,0-3,1.343-3,3s1.343,3,3,3h26c1.657,0,3-1.343,3-3\r\n\t\t\t\tS46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32c17.673,0,32-14.327,32-32S49.673,0,32,0z M32,58\r\n\t\t\t\tC17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.641,26,26S46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS","display":"inline"},"children":[{"name":"g","attribs":{"id":"CIRCLE__x2F__PLUS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h10v10c0,1.657,1.343,3,3,3s3-1.343,3-3V35h10c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\ts14.327,32,32,32c17.673,0,32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26S46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V19c0-1.657-1.343-3-3-3s-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h10v10c0,1.657,1.343,3,3,3s3-1.343,3-3V35h10c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32\r\n\t\t\t\ts14.327,32,32,32c17.673,0,32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26S46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"GLOBE_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"GLOBE","display":"inline"},"children":[{"name":"g","attribs":{"id":"GLOBE","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.446,19.655c0.015,0.03,0.03,0.059,0.044,0.089\r\n\t\t\t\tc0.057-0.013,0.103-0.074,0.133-0.115c0.012-0.009,0.004,0,0.013-0.013c-0.023-0.013-0.047-0.026-0.07-0.038\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.069-0.055,0.095-0.122,0.076-0.235c-0.03-0.002-0.059-0.004-0.089-0.006\r\n\t\t\t\tc-0.026,0.029-0.04,0.127-0.051,0.165c-0.058-0.027-0.089-0.049-0.108-0.114c-0.004-0.002-0.009-0.004-0.013-0.006\r\n\t\t\t\tc-0.078,0.099-0.18,0.095-0.076,0.267C31.324,19.671,31.398,19.659,31.446,19.655z M43.382,11.985\r\n\t\t\t\tc0.203,0.031,0.324,0.15,0.496,0.203c-0.004,0.021-0.009,0.042-0.013,0.064c-0.084,0.038-0.182,0.051-0.172,0.172\r\n\t\t\t\tc0.094,0.018,0.165,0.009,0.28,0.006c0.026,0.034,0.051,0.068,0.076,0.102c0.094,0.039,0.143-0.06,0.21-0.083\r\n\t\t\t\tc0.155,0.002,0.309,0.004,0.464,0.007c-0.006-0.127-0.177-0.162-0.254-0.223c-0.136-0.107-0.215-0.333-0.254-0.534\r\n\t\t\t\tc-0.085-0.43,0.254-0.283,0.292-0.597c-0.066-0.023-0.131-0.047-0.197-0.07c-0.172-0.022-0.357,0.059-0.477,0.089\r\n\t\t\t\tc-0.072,0.004-0.144,0.008-0.216,0.013c-0.088,0.044-0.135,0.159-0.235,0.203c-0.004,0.007-0.009,0.013-0.013,0.019\r\n\t\t\t\tc0.051,0.026,0.093,0.062,0.165,0.064c-0.037,0.109-0.134,0.278-0.241,0.311c-0.072,0.022-0.115-0.021-0.172-0.019\r\n\t\t\t\tc-0.049,0.061-0.104,0.114-0.07,0.229c0.019,0.025,0.038,0.051,0.057,0.076C43.251,12.115,43.276,11.969,43.382,11.985z\r\n\t\t\t\t M20.926,10.303c-0.046,0.008-0.091,0.016-0.137,0.024c-0.018,0.026-0.036,0.077-0.072,0.095\r\n\t\t\t\tc0.061,0.013,0.304-0.051,0.354-0.078C21.07,10.309,20.97,10.301,20.926,10.303z M31.37,7.524\r\n\t\t\t\tc0.061-0.032,0.123-0.064,0.184-0.095c0.036,0.055,0.072,0.11,0.108,0.165c-0.076,0.036-0.153,0.072-0.229,0.108\r\n\t\t\t\tc0.055,0.135,0.434,0.457,0.623,0.388c0.163-0.06,0.211-0.226,0.35-0.312c0.086,0.097,0.288,0.173,0.438,0.197v0.006\r\n\t\t\t\tc-0.178,0.189-0.512,0.185-0.769,0.299h-0.013c0.023,0.049,0.047,0.097,0.07,0.146c0.248-0.018,0.442-0.069,0.661-0.089\r\n\t\t\t\tc0.027,0.025,0.055,0.051,0.083,0.076c-0.102,0.131-0.323,0.152-0.559,0.146c-0.023,0.034-0.047,0.068-0.07,0.102\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.102,0.062,0.562,0.443,0.718,0.4c0.032-0.019,0.063-0.038,0.095-0.057\r\n\t\t\t\tc-0.001-0.177,0.066-0.321,0.159-0.407c0.028-0.029,0.124-0.04,0.172-0.044c0.038-0.081,0.076-0.161,0.114-0.242\r\n\t\t\t\tc0.058-0.144,0.054-0.343,0.178-0.419c0.093-0.021,0.187-0.043,0.28-0.064c0.053-0.026,0.106-0.051,0.159-0.076\r\n\t\t\t\tc-0.048-0.083-0.189-0.174-0.28-0.21c-0.082-0.032-0.163-0.021-0.229-0.063c-0.057-0.074-0.114-0.148-0.172-0.222\r\n\t\t\t\tc-0.078,0-0.117,0.083-0.172,0.127C33.238,7.389,33.219,7.38,33.2,7.372c-0.034-0.072,0.005-0.174,0.006-0.28\r\n\t\t\t\tc-0.021-0.015-0.042-0.03-0.064-0.045h-0.172c-0.066-0.021-0.112-0.079-0.21-0.089c-0.036,0.042-0.072,0.085-0.108,0.127\r\n\t\t\t\tc-0.04,0.109,0.108,0.294,0.127,0.4c-0.019,0.017-0.038,0.034-0.057,0.051c-0.108-0.025-0.306-0.287-0.35-0.381\r\n\t\t\t\tc-0.075-0.059-0.101-0.039-0.191,0c-0.015,0.076-0.03,0.153-0.044,0.229v0.013c-0.074-0.015-0.148-0.03-0.222-0.045\r\n\t\t\t\tc-0.036-0.055-0.041-0.146-0.038-0.242c-0.077-0.016-0.176,0.02-0.235,0.032c-0.047-0.004-0.093-0.008-0.14-0.013\r\n\t\t\t\tc-0.146,0.013-0.218,0.074-0.305,0.14C31.219,7.367,31.286,7.485,31.37,7.524z M34.414,7.117v0.006\r\n\t\t\t\tc-0.066,0.146-0.101,0.233-0.28,0.267v0.114c0.275,0.013,0.551,0.025,0.826,0.038c0.059-0.04,0.119-0.081,0.178-0.121\r\n\t\t\t\tc0.078-0.033,0.162-0.016,0.254-0.045c0.078-0.04,0.157-0.08,0.235-0.121c0.104-0.078,0.208-0.157,0.311-0.235\r\n\t\t\t\tc0.002-0.004,0.004-0.008,0.006-0.013c-0.023-0.038-0.047-0.076-0.07-0.114c-0.061-0.017-0.123-0.034-0.184-0.051\r\n\t\t\t\tc-0.119-0.023-0.251,0.029-0.375,0.026c-0.025-0.051-0.051-0.102-0.076-0.153c-0.03-0.011-0.059-0.021-0.089-0.032\r\n\t\t\t\tc-0.132,0.016-0.223,0.14-0.286,0.229h-0.108c-0.028-0.1-0.003-0.248,0.025-0.343c-0.136,0.061-0.143,0.232-0.267,0.292\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c-0.167-0.256-0.328-0.017-0.496-0.134c-0.059-0.07-0.119-0.14-0.178-0.21\r\n\t\t\t\tc-0.081,0.106-0.161,0.212-0.241,0.318c-0.087,0.062-0.151,0.069-0.197,0.172c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tC33.594,7.203,34.035,7.121,34.414,7.117z M20.993,9.697c0.035,0.033,0.134,0.07,0.225,0.035c0.034-0.013,0.049-0.034,0.076-0.05\r\n\t\t\t\tc0.019-0.02,0.038-0.04,0.057-0.061c-0.074-0.021-0.104-0.081-0.222-0.057C21.066,9.601,20.983,9.637,20.993,9.697z\r\n\t\t\t\t M21.388,8.988c-0.081,0.009-0.125-0.079-0.169-0.114c-0.024,0.041-0.114,0.079-0.126,0.107c0,0,0.086,0.119,0.094,0.127\r\n\t\t\t\tc0.011,0.01,0.028,0.019,0.044,0.023c0.039-0.003,0.22-0.108,0.242-0.129c0.013-0.013,0.03-0.035,0.009-0.052\r\n\t\t\t\tC21.451,8.925,21.406,8.976,21.388,8.988z M20.989,9.241c-0.031,0.049,0.059,0.128,0.12,0.118\r\n\t\t\t\tc0.061-0.054,0.045-0.074-0.037-0.096C21.044,9.256,21.017,9.248,20.989,9.241z M20.988,9.24c0,0,0.001,0,0.001,0\r\n\t\t\t\tc0.002-0.004-0.006-0.009-0.002-0.012C20.987,9.233,20.988,9.237,20.988,9.24z M30.588,18.905\r\n\t\t\t\tc0.119-0.015,0.252,0.008,0.413-0.006c0.016-0.051,0.02-0.072,0.064-0.095c-0.01-0.113-0.024-0.131,0.025-0.21\r\n\t\t\t\tc-0.011-0.004-0.021-0.008-0.032-0.013c-0.006,0.01-0.013,0.021-0.019,0.032c-0.055,0.015-0.11,0.03-0.165,0.044\r\n\t\t\t\tc-0.059,0.043-0.078,0.143-0.153,0.172c-0.076,0.008-0.153,0.017-0.229,0.025c-0.051,0.023-0.079,0.083-0.102,0.133\r\n\t\t\t\tc0.028,0.028,0.055,0.055,0.083,0.083C30.523,19.013,30.565,18.998,30.588,18.905z M10.002,26.709v0.006\r\n\t\t\t\tc0.013,0.019,0.025,0.038,0.038,0.057h0.027c-0.006-0.014-0.006-0.034-0.015-0.051C10.036,26.717,10.019,26.713,10.002,26.709z\r\n\t\t\t\t M42.956,34.189c-0.051-0.021-0.102-0.042-0.153-0.064c-0.12,0.085-0.214,0.171-0.388,0.21c-0.076,0.017-0.145-0.016-0.191-0.025\r\n\t\t\t\tc-0.086-0.017-0.139,0.054-0.197,0.07c-0.059-0.006-0.119-0.013-0.178-0.019h-0.013c-0.072,0.047-0.144,0.093-0.216,0.14\r\n\t\t\t\tc-0.099,0.036-0.13-0.059-0.242-0.038c-0.091,0.04-0.182,0.08-0.273,0.121h-0.178c-0.091-0.099-0.215-0.211-0.273-0.337\r\n\t\t\t\tc-0.054-0.014-0.128-0.003-0.191-0.013c-0.004-0.002-0.009-0.004-0.013-0.006v-0.013c0.069-0.033,0.208-0.09,0.261-0.146\r\n\t\t\t\tc-0.006-0.169-0.233-0.211-0.33-0.305c-0.017-0.016-0.033-0.139-0.089-0.191c-0.026-0.024-0.075-0.007-0.108-0.025\r\n\t\t\t\tc-0.089-0.098-0.178-0.195-0.267-0.292c-0.035-0.016-0.076-0.009-0.127-0.006c-0.039-0.054-0.074-0.138-0.133-0.172\r\n\t\t\t\tc-0.019,0.025-0.013,0.083-0.019,0.108c-0.004,0.002-0.008,0.004-0.013,0.007c-0.182-0.153-0.224-0.622-0.331-0.864\r\n\t\t\t\tc-0.049-0.112-0.295-0.163-0.362-0.254c-0.106-0.144-0.038-0.516-0.089-0.724c-0.033-0.135-0.153-0.35-0.254-0.426\r\n\t\t\t\tc-0.05-0.038-0.123-0.051-0.159-0.102c-0.045-0.062-0.051-0.162-0.076-0.242c0.023-0.021,0.047-0.042,0.07-0.064\r\n\t\t\t\tc-0.051-0.051-0.102-0.102-0.153-0.152c-0.139-0.209-0.24-0.462-0.369-0.667c-0.055-0.144-0.11-0.288-0.165-0.432\r\n\t\t\t\tc-0.095-0.171-0.257-0.287-0.299-0.521c0.033-0.045,0.038-0.066,0.095-0.089c0.08,0.245,0.223,0.49,0.4,0.642\r\n\t\t\t\tc0.019,0.021,0.047,0.019,0.076,0.013c0.08-0.159,0.057-0.398,0.184-0.508c-0.074-0.191-0.148-0.381-0.222-0.572\r\n\t\t\t\tc-0.122,0.015-0.164,0.113-0.337,0.019c-0.112,0.08-0.158,0.011-0.28,0.032c-0.042-0.043-0.076-0.051-0.095-0.121\r\n\t\t\t\tc-0.215-0.044-0.454,0.008-0.604,0.108c-0.04,0.032-0.081,0.063-0.121,0.095c-0.079,0.017-0.155-0.048-0.21-0.064\r\n\t\t\t\tc-0.061-0.006-0.123-0.013-0.184-0.019c-0.013-0.017-0.025-0.034-0.038-0.051c-0.148-0.032-0.297-0.064-0.445-0.095h-0.318\r\n\t\t\t\tc-0.058-0.026-0.045-0.125-0.108-0.146h-0.146c-0.077-0.012-0.25-0.041-0.324-0.07c-0.07-0.038-0.033-0.128-0.133-0.172\r\n\t\t\t\tc-0.258-0.113-0.681,0.039-0.782,0.21c-0.137,0.231,0.167,0.358-0.146,0.527c-0.038,0.02-0.088,0.07-0.146,0.064\r\n\t\t\t\tc-0.153-0.018-0.266-0.184-0.4-0.235c-0.132-0.05-0.433-0.054-0.54-0.114c-0.119-0.068-0.137-0.311-0.241-0.35\r\n\t\t\t\tc-0.058-0.021-0.105-0.003-0.152-0.025c-0.028-0.025-0.055-0.051-0.083-0.076c-0.066-0.013-0.131-0.025-0.197-0.038\r\n\t\t\t\tc-0.095,0.006-0.191,0.013-0.286,0.019c-0.129-0.055-0.258-0.11-0.388-0.165c-0.009-0.034-0.017-0.068-0.025-0.102\r\n\t\t\t\tc-0.061-0.005-0.069,0.013-0.121,0.025c-0.082-0.04-0.182-0.111-0.203-0.21c0.059-0.065,0.326-0.286,0.324-0.369\r\n\t\t\t\tc-0.011-0.042-0.021-0.085-0.032-0.127c-0.337-0.192,0.008-0.272,0.006-0.483c-0.064,0.038-0.127,0.076-0.191,0.115\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c-0.018-0.04-0.036-0.072-0.038-0.127c-0.047-0.021-0.093-0.042-0.14-0.064\r\n\t\t\t\tc-0.03,0.004-0.059,0.009-0.089,0.013c-0.095,0.036-0.266,0.212-0.432,0.165c-0.024-0.007-0.062-0.069-0.14-0.096\r\n\t\t\t\tc-0.063,0.009-0.084,0.051-0.133,0.076c-0.076-0.012-0.113-0.06-0.178-0.083c-0.078,0.055-0.155,0.115-0.267,0.14\r\n\t\t\t\tc-0.173,0.039-0.303-0.115-0.502-0.063c-0.038,0.021-0.076,0.042-0.114,0.063c-0.073,0.026-0.104-0.027-0.159-0.019\r\n\t\t\t\tc-0.047,0.021-0.093,0.042-0.14,0.064c-0.145,0.03-0.312-0.005-0.432,0.044c-0.114,0.047-0.181,0.142-0.267,0.216\r\n\t\t\t\tc-0.046-0.004-0.065-0.015-0.089-0.038c-0.039,0.007-0.209,0.066-0.242,0.089c-0.08,0.057-0.073,0.137-0.191,0.172\r\n\t\t\t\tc-0.13,0.038-0.283-0.002-0.318-0.089c-0.007-0.002-0.345,0.103-0.477,0.064c-0.138-0.041-0.19-0.153-0.28-0.242\r\n\t\t\t\tc-0.032,0.015-0.064,0.03-0.095,0.045c-0.071,0.054-0.17,0.43-0.248,0.534c-0.114,0.152-0.324,0.164-0.483,0.273\r\n\t\t\t\tc-0.054,0.037-0.227,0.186-0.248,0.241c-0.022,0.058,0.009,0.132-0.019,0.191c-0.035,0.073-0.121,0.127-0.153,0.21\r\n\t\t\t\tc-0.075,0.199,0.155,0.303-0.006,0.54c-0.101,0.149-0.406,0.41-0.578,0.483c-0.089,0.038-0.211,0.03-0.305,0.076\r\n\t\t\t\tc-0.108,0.053-0.13,0.288-0.203,0.381c-0.059,0.074-0.188,0.088-0.242,0.165c-0.056,0.081-0.105,0.204-0.127,0.311\r\n\t\t\t\tc-0.002,0.044-0.004,0.089-0.006,0.134c-0.04,0.101-0.18,0.151-0.242,0.235c-0.063,0.146-0.127,0.292-0.191,0.438\r\n\t\t\t\tc-0.047,0.051-0.093,0.102-0.14,0.153c-0.056,0.084-0.082,0.256-0.064,0.388c0.015-0.017,0.03-0.034,0.044-0.051\r\n\t\t\t\tc0.199,0.016,0.209,0.339,0.114,0.477c0.233,0.184,0.095,0.554,0.025,0.788c-0.008,0.068-0.017,0.136-0.025,0.203\r\n\t\t\t\tc-0.037,0.135-0.145,0.317-0.273,0.362c-0.002,0.004-0.004,0.008-0.006,0.013c0.181,0.076,0.181,0.271,0.267,0.311\r\n\t\t\t\tc0.01,0.02,0.013,0.041,0.013,0.076c-0.019,0.004-0.038,0.008-0.057,0.013c-0.049,0.069-0.01,0.177-0.032,0.261\r\n\t\t\t\tc0.08,0.135,0.04,0.036,0.14,0.102c0.004,0.015,0.008,0.03,0.013,0.044c0.042,0.025,0.085,0.051,0.127,0.076\r\n\t\t\t\tc0.063-0.012,0.153-0.052,0.203,0.006c-0.039,0.048-0.093,0.079-0.076,0.165c0.026,0.017,0.08,0.022,0.102,0.044\r\n\t\t\t\tc0.015,0.02,0.01,0.028,0.006,0.057c0.034,0.023,0.057,0.034,0.121,0.032c0.011,0.033,0.011,0.06,0,0.095\r\n\t\t\t\tc0.065,0.069,0.166,0.135,0.267,0.165c0.006,0.032,0.013,0.063,0.019,0.095c0.033,0.061,0.118,0.081,0.14,0.159v0.095\r\n\t\t\t\tc0.014,0.018,0.035,0.022,0.063,0.025c0.002,0.008,0.004,0.017,0.006,0.025c-0.023,0.019-0.047,0.038-0.07,0.057h-0.013\r\n\t\t\t\tc0.028,0.094,0.156,0.186,0.261,0.203c0.018,0.034,0.013,0.047,0.006,0.095c0.142,0.043,0.215,0.149,0.324,0.222\r\n\t\t\t\tc0.08,0.042,0.161,0.085,0.242,0.127c0.17,0.12,0.278,0.261,0.477,0.362c0.062,0.032,0.311,0.192,0.388,0.172\r\n\t\t\t\tc0.102-0.053,0.203-0.106,0.305-0.159c0.106-0.029,0.212-0.059,0.318-0.089c0.092-0.027,0.292-0.048,0.407-0.025\r\n\t\t\t\tc0.05,0.01,0.145,0.061,0.21,0.038c0.011-0.013,0.021-0.025,0.032-0.038c0.041,0.005,0.246,0.134,0.286,0.165\r\n\t\t\t\tc0.206-0.093,0.411-0.186,0.616-0.28c0.087-0.008,0.174-0.017,0.261-0.025c0.052-0.039,0.054-0.108,0.127-0.133\r\n\t\t\t\tc0.214-0.019,0.428-0.038,0.642-0.057c0.032-0.012,0.039-0.042,0.083-0.057c0.077,0.015,0.286,0.147,0.331,0.203\r\n\t\t\t\tc0.015,0.025,0.03,0.051,0.044,0.076c0.023,0.002,0.047,0.004,0.07,0.006c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.013,0.032-0.025,0.064-0.038,0.095c0.025,0.209,0.348,0.363,0.534,0.197c0.101,0.017,0.232,0.039,0.343-0.006\r\n\t\t\t\tc0.002-0.027-0.002-0.037-0.013-0.063c0.025-0.016,0.147,0.013,0.178,0.051c0.069,0.124-0.004,0.172,0.222,0.165\r\n\t\t\t\tc0.008,0.013,0.017,0.026,0.025,0.038c0.004,0.004,0.008,0.008,0.013,0.013c-0.019,0.015-0.038,0.03-0.057,0.044\r\n\t\t\t\tc0.021,0.08,0.085,0.147,0.102,0.242c-0.011,0.042-0.021,0.085-0.032,0.127c0.009,0.032,0.017,0.064,0.025,0.095\r\n\t\t\t\tc-0.024,0.1-0.086,0.2-0.153,0.261c-0.002,0.006-0.004,0.013-0.006,0.019c0.025,0.004,0.051,0.008,0.076,0.013\r\n\t\t\t\tc0.003,0.084-0.012,0.146-0.076,0.165c0.049,0.042,0.097,0.085,0.146,0.127v0.006c-0.038-0.004-0.076-0.009-0.114-0.013\r\n\t\t\t\tc-0.031,0.138-0.072,0.242-0.191,0.292c0.013,0.028,0.052,0.116,0.076,0.14c0.036,0.035,0.074,0.015,0.114,0.07\r\n\t\t\t\tc-0.021,0.015-0.042,0.03-0.063,0.045c-0.002,0.004-0.004,0.008-0.006,0.013c0.042,0.062,0.085,0.123,0.127,0.184\r\n\t\t\t\tc0.053,0.027,0.074,0.003,0.108,0.045c-0.011,0.015-0.021,0.03-0.032,0.044c0.089,0.058,0.143,0.122,0.203,0.21\r\n\t\t\t\tc0.112,0.104,0.224,0.208,0.337,0.311c0.032,0.039,0.115,0.204,0.133,0.248c0.029,0.068-0.018,0.161,0.038,0.261\r\n\t\t\t\tc0.045,0.064,0.089,0.127,0.133,0.191c0.013,0.061,0.025,0.123,0.038,0.184c0.057,0.134,0.17,0.186,0.14,0.388\r\n\t\t\t\tc-0.243,0.109,0.046,0.36,0.089,0.489c0.008,0.1,0.017,0.199,0.025,0.299c-0.019,0.11-0.066,0.285-0.146,0.337\r\n\t\t\t\tc-0.03,0.01-0.059,0.021-0.089,0.032c-0.017,0.04-0.034,0.081-0.051,0.121c-0.03,0.032-0.059,0.064-0.089,0.096\r\n\t\t\t\tc-0.094,0.222-0.042,0.57-0.222,0.705c0,0.202-0.037,0.471,0.013,0.648c0.038,0.135,0.15,0.217,0.216,0.324\r\n\t\t\t\tc0.108,0.216,0.216,0.432,0.324,0.648c0.075,0.146,0.371,0.404,0.203,0.572c0.03,0.14,0.059,0.28,0.089,0.419\r\n\t\t\t\tc0.023,0.055,0.047,0.11,0.07,0.165c0.02,0.082-0.031,0.143-0.025,0.203c0.008,0.08,0.071,0.147,0.089,0.21\r\n\t\t\t\tc0.014,0.047-0.021,0.073-0.019,0.102c0.034,0.104,0.068,0.208,0.102,0.311c0.117,0.131,0.233,0.263,0.349,0.394\r\n\t\t\t\tc0.12,0.189,0.16,0.433,0.273,0.635c0.1,0.178,0.271,0.36,0.203,0.654c-0.033,0.008-0.077,0-0.095,0.025\r\n\t\t\t\tc-0.025,0.032,0.123,0.23,0.159,0.286c-0.017,0.049-0.034,0.098-0.051,0.146c0.011,0.011,0.021,0.021,0.032,0.032\r\n\t\t\t\tc0.006,0.002,0.013,0.004,0.019,0.006c0.006-0.015,0.013-0.03,0.019-0.045c0.017-0.008,0.022-0.011,0.051-0.013\r\n\t\t\t\tc0.013,0.023,0.025,0.047,0.038,0.07c0.027-0.001,0.052-0.007,0.102-0.006c0.021,0.029,0.022,0.055,0.038,0.095\r\n\t\t\t\tc0.024,0.042,0.115,0.075,0.165,0.089c0.06-0.046,0.096-0.122,0.178-0.146c0.115-0.035,0.251,0.044,0.356-0.006\r\n\t\t\t\tc0.032-0.03,0.063-0.059,0.095-0.089c0.15-0.071,0.214,0,0.331,0c0.034-0.019,0.068-0.038,0.102-0.057\r\n\t\t\t\tc0.122-0.035,0.234,0.073,0.318,0.102c0.04-0.031,0.07-0.055,0.095-0.102c0.057,0.013,0.114,0.025,0.172,0.038\r\n\t\t\t\tc0.017-0.018,0.02-0.053,0.032-0.076c0.05-0.048,0.322-0.017,0.4-0.07c0.083-0.072,0.165-0.144,0.248-0.216\r\n\t\t\t\tc0.416-0.327,0.721-0.688,1.017-1.138c0.074-0.113,0.264-0.191,0.305-0.299c0.02-0.052-0.028-0.122-0.019-0.146\r\n\t\t\t\tc0.016-0.044,0.065-0.032,0.089-0.064c0.071-0.091,0.109-0.35,0.089-0.496c-0.038-0.015-0.078-0.04-0.095-0.076\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.019c0.078-0.091,0.132-0.175,0.242-0.235c0.244-0.134,0.525-0.121,0.635-0.388\r\n\t\t\t\tc-0.009-0.061-0.052-0.036-0.064-0.07c0.002-0.006,0.004-0.013,0.006-0.019c0.013-0.032,0.025-0.064,0.038-0.095\r\n\t\t\t\tc0.03-0.123,0.023-0.264,0.019-0.388c-0.028,0.01-0.035,0.018-0.076,0.019c-0.039-0.124-0.087-0.274-0.044-0.375\r\n\t\t\t\tc-0.006-0.075-0.062-0.112-0.114-0.14v-0.203c0.119-0.087,0.237-0.174,0.356-0.261c0.145-0.122,0.233-0.305,0.4-0.407\r\n\t\t\t\tc0.203-0.123,0.451-0.162,0.642-0.292c0.137-0.094,0.224-0.268,0.331-0.394c0-0.028-0.009-0.039-0.019-0.07\r\n\t\t\t\tc0.036-0.047,0.068-0.081,0.095-0.14c-0.002-0.011-0.004-0.021-0.006-0.032c-0.023-0.011-0.047-0.021-0.07-0.032\r\n\t\t\t\tc-0.02-0.163,0.012-0.337-0.07-0.432c0.003-0.034,0.034-0.063,0.044-0.108c0.026-0.113-0.041-0.294-0.057-0.394\r\n\t\t\t\tc0.03-0.055,0.059-0.11,0.089-0.165c-0.065-0.14-0.183-0.157-0.267-0.267c-0.083-0.108-0.127-0.393-0.07-0.553\r\n\t\t\t\tc-0.018-0.028-0.043-0.033-0.064-0.057c0.029-0.062,0.083-0.148,0.089-0.216c-0.057-0.071-0.161-0.126-0.197-0.216\r\n\t\t\t\tc-0.037-0.095,0.061-0.407,0.102-0.451c0.024-0.026,0.068-0.021,0.089-0.051c0.047-0.068,0.006-0.104,0.025-0.165\r\n\t\t\t\tc0.042-0.137,0.172-0.143,0.184-0.368c0.096-0.053,0.187-0.052,0.191-0.203c0.085,0.016,0.124-0.022,0.191-0.051\r\n\t\t\t\tc0.024-0.036,0.026-0.054,0.006-0.095c0.208-0.235,0.415-0.47,0.623-0.705c0.229-0.185,0.515-0.325,0.744-0.508\r\n\t\t\t\tc0.085-0.104,0.169-0.208,0.254-0.311c0.168-0.215,0.419-0.422,0.527-0.686c0.011-0.049,0.021-0.098,0.032-0.146\r\n\t\t\t\tc0.074-0.119,0.148-0.237,0.222-0.356c-0.002-0.028-0.004-0.055-0.006-0.083c0.042-0.04,0.085-0.081,0.127-0.121\r\n\t\t\t\tc0.055-0.098,0.11-0.195,0.165-0.292c0.006-0.087,0.013-0.174,0.019-0.261c0.014-0.04,0.079-0.07,0.076-0.127\r\n\t\t\t\tc-0.002-0.045-0.037-0.108-0.019-0.172c0.017-0.04,0.034-0.081,0.051-0.121C42.96,34.201,42.958,34.195,42.956,34.189z\r\n\t\t\t\t M51.688,35.155c-0.032-0.185-0.128-0.278-0.28-0.375c0.018,0.077-0.003,0.113-0.025,0.191c-0.034,0.026-0.04,0.042-0.095,0.025\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.013,0.044c0.015,0.017,0.03,0.034,0.044,0.051c-0.029,0.063-0.008,0.077,0.006,0.14v0.318\r\n\t\t\t\tc0.023,0.101,0.073,0.267,0.146,0.324c0.208,0.044,0.476-0.139,0.451-0.337c-0.011-0.089-0.093-0.163-0.127-0.235\r\n\t\t\t\tC51.76,35.226,51.767,35.185,51.688,35.155z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M50.505,13.747c0.043,0.044,0.081,0.093,0.124,0.137c-0.003,0.02-0.006,0.039-0.008,0.059v0.006\r\n\t\t\t\tc0.027,0.007,0.053,0.01,0.08,0.013c0.048,0.049,0.092,0.103,0.139,0.153c-0.13,0.026-0.317,0.022-0.352-0.084\r\n\t\t\t\tC50.47,14.004,50.497,13.865,50.505,13.747z M48.568,14.508c0.038,0.017,0.076,0.034,0.114,0.051\r\n\t\t\t\tc0.07-0.025,0.14-0.051,0.21-0.076c-0.013-0.036-0.025-0.072-0.038-0.108c0.033-0.077,0.142-0.097,0.203-0.146\r\n\t\t\t\tc0.083-0.066,0.227-0.183,0.267-0.286c0.015-0.059,0.03-0.119,0.044-0.178c0.022-0.052,0.06-0.069,0.064-0.146\r\n\t\t\t\tc-0.099-0.13-0.202-0.041-0.254-0.292c0.002-0.127,0.004-0.254,0.006-0.381c-0.008-0.074-0.017-0.148-0.025-0.222\r\n\t\t\t\tc0.032-0.042,0.064-0.085,0.095-0.127c0.001-0.002-0.001-0.005,0-0.008c0.099,0.088,0.195,0.177,0.293,0.266\r\n\t\t\t\tc-0.012,0.031-0.036,0.06-0.038,0.092c-0.006,0.103,0.07,0.19,0.07,0.324c0.102-0.002,0.239,0.039,0.311,0.025\r\n\t\t\t\tc0.034-0.012,0.069-0.024,0.103-0.036c0.075,0.072,0.157,0.137,0.232,0.211c-0.214-0.04-0.47,0.008-0.5,0.206\r\n\t\t\t\tc0.056,0.099,0.113,0.168,0.108,0.318c-0.042,0.053-0.085,0.106-0.127,0.159c-0.034,0.021-0.068,0.042-0.102,0.064\r\n\t\t\t\tc-0.044,0.061-0.038,0.157-0.095,0.203c-0.14,0.113-0.327,0.134-0.407,0.311c-0.085,0.039-0.185,0.002-0.261-0.013\r\n\t\t\t\tc-0.053,0.002-0.106,0.004-0.159,0.006c-0.219-0.032-0.424-0.055-0.502-0.229C48.308,14.462,48.449,14.461,48.568,14.508z\r\n\t\t\t\t M14.404,12.899c-0.002,0.011-0.006,0.023,0.013,0.034c0.011,0.006,0.027,0.004,0.044,0.005c0.046,0.003,0.104,0.019,0.122,0.05\r\n\t\t\t\tc-0.03,0.071-0.177,0-0.221-0.006c0,0.003,0,0.006,0,0.008c-0.005,0-0.011,0-0.016,0c-0.003,0.077,0.276,0.05,0.304,0.123\r\n\t\t\t\tc-0.032,0.036-0.081,0.019-0.141,0.035c-0.004,0.062,0.16,0.026,0.146,0.083c0,0.002-0.001,0.003-0.001,0.005\r\n\t\t\t\tc-0.043,0.013-0.078-0.002-0.117,0.012c-0.004,0.003-0.007,0.006-0.01,0.009c0,0.003,0,0.006,0,0.008\r\n\t\t\t\tc0.031,0.019,0.072,0.042,0.132,0.023c0.017-0.006,0.036-0.014,0.054-0.012c0.006,0.002,0.012,0.003,0.017,0.005\r\n\t\t\t\tc0.003,0.02-0.019,0.063-0.05,0.071c-0.034,0.009-0.199-0.014-0.228-0.021c-0.059-0.015-0.101-0.05-0.147-0.078\r\n\t\t\t\tc-0.04-0.024-0.124-0.06-0.197-0.085C14.204,13.077,14.305,12.99,14.404,12.899z M13.524,13.715\r\n\t\t\t\tc0.019,0.012,0.039,0.022,0.052,0.039c-0.03-0.002-0.064,0.005-0.097,0.01C13.495,13.749,13.509,13.731,13.524,13.715z\r\n\t\t\t\t M7.943,27.904c0.017-0.004,0.034-0.008,0.051-0.013c-0.017,0.015-0.034,0.03-0.051,0.045\r\n\t\t\t\tC7.945,27.925,7.941,27.918,7.943,27.904z M7.499,23.367c-0.001,0.007,0,0.011-0.001,0.018c-0.002-0.002-0.002-0.004-0.004-0.006\r\n\t\t\t\tC7.496,23.376,7.497,23.372,7.499,23.367z M7.676,37.665c-0.049,0.065-0.234,0.104-0.337,0.051\r\n\t\t\t\tc-0.044,0.033-0.061,0.065-0.057,0.146c-0.015,0.013-0.03,0.025-0.044,0.038c-0.012-0.052-0.021-0.069-0.07-0.083\r\n\t\t\t\tc-0.033-0.007-0.066,0.023-0.095,0.038c-0.203,0.107-0.124,0.25-0.191,0.438c-0.026,0.005-0.052,0.01-0.079,0.015\r\n\t\t\t\tc-0.076-0.302-0.168-0.598-0.232-0.904c0.011,0.001,0.019,0.005,0.032,0.006c0.029,0.082,0.054,0.128,0.146,0.146\r\n\t\t\t\tc0.004-0.028,0.009-0.055,0.013-0.083h0.006c0.023,0.048,0.076,0.109,0.064,0.172c0.006,0.006,0.013,0.013,0.019,0.019\r\n\t\t\t\tc0.114,0.02,0.144-0.047,0.248-0.057c-0.01-0.111-0.095-0.121-0.133-0.203c0.039-0.058,0.138-0.099,0.21-0.121\r\n\t\t\t\tc-0.003-0.04-0.005-0.057,0.006-0.089c0.198-0.063,0.318-0.017,0.375,0.14c0.045,0.008,0.076-0.016,0.108-0.038\r\n\t\t\t\tc-0.001,0.049,0.005,0.067,0.038,0.083c0.002,0.004,0.004,0.009,0.006,0.013c-0.061-0.008-0.097-0.021-0.121,0.032\r\n\t\t\t\tC7.564,37.5,7.647,37.606,7.676,37.665z M32,58c-7.083,0-13.497-2.841-18.187-7.435c0.051-0.052,0.122-0.09,0.155-0.153\r\n\t\t\t\tc0.019-0.078,0.038-0.157,0.057-0.235v-0.013c0.049,0.022,0.108,0.044,0.172,0.019h0.006c0.013,0.192-0.204,0.292-0.248,0.483\r\n\t\t\t\tc0.103-0.092,0.237-0.221,0.299-0.349c0.051-0.121,0.102-0.242,0.153-0.362c0.174-0.277,0.481-0.299,0.394-0.852\r\n\t\t\t\tc-0.012-0.077-0.036-0.114-0.057-0.172c0.045-0.054,0.132-0.205,0.019-0.254v-0.038c0.146,0.013,0.159-0.073,0.235-0.14\r\n\t\t\t\tc0.08-0.07,0.491-0.363,0.585-0.381c0.051-0.01,0.091,0.021,0.127,0.032c0.03-0.036,0.059-0.072,0.089-0.108\r\n\t\t\t\tc0.086-0.051,0.144-0.034,0.165-0.153c0.094-0.012,0.207-0.008,0.28,0.006c0.161,0.031,0.334-0.013,0.483-0.025\r\n\t\t\t\tc-0.005-0.182,0.137-0.241,0.292-0.254c-0.009-0.051-0.017-0.102-0.025-0.153c0.017-0.123,0.117-0.202,0.172-0.292\r\n\t\t\t\tc0.034-0.07,0.068-0.14,0.102-0.21c0.032-0.046,0.105-0.072,0.121-0.133c-0.006-0.062-0.013-0.123-0.019-0.184\r\n\t\t\t\tc-0.03-0.169,0.065-0.288,0.184-0.331c0-0.048-0.035-0.138-0.019-0.222c0.021-0.107,0.097-0.243,0.076-0.369\r\n\t\t\t\tc-0.017-0.165-0.034-0.331-0.051-0.496c0.028-0.172,0.093-0.289,0.095-0.464c0.015,0.002,0.03,0.004,0.044,0.006\r\n\t\t\t\tc0.017,0.034,0.034,0.068,0.051,0.102h0.019c0.113-0.084,0.241-0.308,0.292-0.445c0.031-0.081,0.007-0.126,0.057-0.178\r\n\t\t\t\tc0.047-0.021,0.093-0.042,0.14-0.064c0.273-0.213,0.461-0.44,0.534-0.858c0.027-0.157-0.139-0.732-0.216-0.756\r\n\t\t\t\tc-0.161-0.05-0.338,0.008-0.458-0.07c-0.256-0.166-0.436-0.435-0.731-0.566c-0.171-0.076-0.287,0.017-0.451-0.013\r\n\t\t\t\tc-0.1-0.015-0.199-0.03-0.299-0.045c-0.086-0.023-0.18-0.133-0.286-0.121c-0.154,0.018-0.289,0.139-0.394,0.21\r\n\t\t\t\tc-0.049-0.2,0.024-0.122,0.044-0.242c0.013-0.077-0.114-0.195-0.184-0.203c-0.017,0.017-0.034,0.034-0.051,0.051h-0.025\r\n\t\t\t\tc-0.054-0.172-0.227-0.156-0.394-0.216c-0.065-0.023-0.106-0.068-0.159-0.102c-0.052,0.007-0.15,0.015-0.216,0.032\r\n\t\t\t\tc-0.072,0.028-0.08,0.13-0.121,0.191c-0.069,0.101-0.227,0.129-0.28,0.248c-0.004,0.002-0.008,0.004-0.013,0.006\r\n\t\t\t\tc0-0.07,0.012-0.1,0.032-0.146c-0.111,0.023-0.259,0.048-0.394,0.026c-0.032-0.076-0.064-0.153-0.095-0.229\r\n\t\t\t\tc-0.088,0.024-0.202,0.166-0.318,0.121c-0.006-0.004-0.013-0.008-0.019-0.013c0.085-0.065,0.102-0.2,0.159-0.292\r\n\t\t\t\tc0.065-0.105,0.205-0.137,0.28-0.229c0.067-0.082,0.092-0.211,0.197-0.254c0.034-0.054,0.016-0.107-0.006-0.165\r\n\t\t\t\tc-0.262-0.036-0.276-0.356-0.343-0.578c-0.021-0.068-0.016-0.143-0.076-0.172c-0.031-0.005-0.044,0.032-0.076,0.025\r\n\t\t\t\tc-0.015-0.003-0.319-0.315-0.4-0.356c-0.11-0.036-0.22-0.072-0.331-0.108c-0.09-0.035-0.342-0.112-0.489-0.051\r\n\t\t\t\tc-0.016,0.014-0.018,0.027-0.019,0.057c-0.095-0.021-0.191-0.042-0.286-0.064h-0.006c-0.015,0.015-0.03,0.03-0.044,0.045\r\n\t\t\t\tc-0.061-0.12-0.214-0.314-0.388-0.292c-0.011,0.021-0.021,0.042-0.032,0.063v0.013c-0.013-0.091-0.026-0.182-0.038-0.273\r\n\t\t\t\tc-0.074-0.125-0.313-0.283-0.47-0.318c-0.084-0.018-0.176,0.005-0.241,0.019c-0.066-0.004-0.131-0.008-0.197-0.013v-0.006\r\n\t\t\t\tc0.187-0.058,0.138-0.167,0.273-0.222c0.002-0.004,0.004-0.008,0.006-0.013c-0.051-0.035-0.122-0.045-0.178-0.083\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c-0.045-0.029-0.132-0.021-0.172-0.045c-0.027,0.019-0.038,0.036-0.045,0.076\r\n\t\t\t\tc-0.004,0.002-0.008,0.004-0.013,0.006c-0.012-0.113-0.097-0.154-0.184-0.191V37.97c0.059,0.002,0.119,0.004,0.178,0.006\r\n\t\t\t\tc0.011-0.006,0.021-0.013,0.032-0.019c0.004-0.009,0.008-0.017,0.013-0.025c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.129-0.028-0.42-0.039-0.54,0.019c-0.075,0.037-0.117,0.126-0.21,0.146c-0.261,0.058-0.335-0.149-0.496-0.159\r\n\t\t\t\tc-0.136-0.008-0.364,0.083-0.483,0.025c-0.058-0.029-0.044-0.057-0.07-0.121c-0.05-0.125-0.201-0.158-0.375-0.159\r\n\t\t\t\tc-0.033-0.051-0.073-0.137-0.089-0.197c-0.053-0.012-0.097,0.016-0.114,0.064c0.015,0.025,0.03,0.051,0.044,0.076\r\n\t\t\t\tc0.028-0.002,0.055-0.004,0.083-0.006c0.013,0.011,0.025,0.021,0.038,0.032c-0.016,0.063-0.425,0.178-0.515,0.21\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.008,0.036-0.018,0.036-0.038,0.057c0.053,0.026,0.197,0.299,0.152,0.394\r\n\t\t\t\tc-0.025,0.044-0.094,0.072-0.152,0.083c-0.065-0.049-0.097-0.164-0.146-0.229c0.015-0.1,0.07-0.186,0.121-0.254\r\n\t\t\t\tc-0.012-0.102-0.056-0.167-0.089-0.254c0.041-0.061,0.144-0.086,0.241-0.089c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.013-0.064-0.059-0.101-0.114-0.121c-0.156-0.06-0.195,0.139-0.273,0.184c-0.04,0.013-0.081,0.025-0.121,0.038\r\n\t\t\t\tc0.019-0.036,0.046-0.051,0.032-0.102c0.027,0.011,0.029,0.016,0.038,0.045h0.006c0.052-0.033,0.079-0.079,0.121-0.121\r\n\t\t\t\tc-0.08-0.166-0.161-0.342-0.337-0.413c-0.058-0.023-0.134,0.003-0.203-0.026c-0.026-0.01-0.121-0.049-0.159-0.038\r\n\t\t\t\tc-0.047,0.032-0.093,0.064-0.14,0.095c-0.03,0.018-0.063,0.012-0.102,0.026c-0.12,0.043-0.172,0.128-0.331,0.095\r\n\t\t\t\tc-0.05-0.063-0.09-0.028-0.135-0.022c-0.26-1.288-0.395-2.619-0.457-3.968c0.016-0.002,0.033-0.001,0.046-0.007\r\n\t\t\t\tc0.167-0.078,0.167-0.194,0.47-0.121c0.006,0.011,0.013,0.021,0.019,0.032v0.006c-0.047,0.013-0.093,0.025-0.14,0.038\r\n\t\t\t\tc0.108,0.084,0.261,0.035,0.419,0.083c0.114,0.034,0.208,0.114,0.337,0.146c0.067,0.017,0.202-0.02,0.261,0.019\r\n\t\t\t\tc0.043,0.025,0.066,0.123,0.07,0.184c0.099,0.06,0.295,0.06,0.388,0.127c-0.006,0.065-0.053,0.106-0.102,0.127\r\n\t\t\t\tc-0.019,0.021-0.038,0.042-0.057,0.063v0.006c0.141,0.006,0.266-0.057,0.394-0.038c0.097,0.011,0.195,0.021,0.292,0.032\r\n\t\t\t\tc0.105-0.019,0.2-0.058,0.324-0.07c0.002-0.004,0.004-0.008,0.006-0.013c-0.124-0.092-0.202-0.151-0.432-0.146\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.019c0.013-0.028,0.025-0.055,0.038-0.083c-0.079-0.081-0.36-0.089-0.483-0.14\r\n\t\t\t\tc-0.04-0.044-0.08-0.089-0.121-0.133c-0.131-0.09-0.318-0.074-0.477-0.146c-0.064-0.053-0.127-0.106-0.191-0.159H7.022\r\n\t\t\t\tc-0.163-0.037-0.338-0.074-0.559-0.07c-0.083,0.008-0.165,0.017-0.248,0.025c-0.059,0.014-0.109,0.043-0.163,0.068\r\n\t\t\t\tC6.038,32.677,6,32.344,6,32c0-0.404,0.042-0.798,0.06-1.198c0.069,0.073,0.127,0.176,0.179,0.209\r\n\t\t\t\tc0.057,0.035,0.12,0.025,0.133,0.102c-0.021,0.115-0.042,0.229-0.064,0.343c0.008,0.002,0.017,0.004,0.025,0.006\r\n\t\t\t\tc0.036,0.022,0.05-0.017,0.089-0.032c0.002,0.019,0.004,0.038,0.006,0.057c-0.025,0.035-0.04,0.043-0.083,0.063\r\n\t\t\t\tc0.038,0.07,0.076,0.14,0.115,0.21H6.52c0.006,0.032,0.013,0.064,0.019,0.095c0.019,0.013,0.038,0.025,0.057,0.038\r\n\t\t\t\tc0.051,0.105-0.017,0.164,0.133,0.172c0.035,0.058,0.068,0.193,0.108,0.242c0.047-0.022,0.112-0.023,0.178-0.032\r\n\t\t\t\tc-0.004,0.021-0.008,0.042-0.013,0.064h0.013c0.048-0.142,0.166-0.403,0.108-0.61c-0.023-0.081-0.082-0.166-0.108-0.261\r\n\t\t\t\tc-0.013-0.083-0.025-0.165-0.038-0.248c-0.062-0.179-0.316-0.446-0.267-0.699c0.032-0.1,0.064-0.199,0.095-0.299\r\n\t\t\t\tc0.053-0.085,0.131-0.155,0.165-0.26c0.15-0.028,0.305-0.087,0.369-0.197c0.047-0.082,0.048-0.15,0.127-0.197\r\n\t\t\t\tc0.074-0.044,0.216-0.039,0.28-0.076c0.064-0.08,0.127-0.161,0.191-0.242c0.07-0.011,0.14-0.021,0.21-0.032\r\n\t\t\t\tc0.025-0.021,0.051-0.042,0.076-0.063c0.002-0.004,0.004-0.009,0.006-0.013c-0.027-0.012-0.033-0.01-0.044-0.038\r\n\t\t\t\tc-0.025,0.019-0.067,0.035-0.095,0.051c-0.015-0.009-0.03-0.017-0.044-0.026c-0.019-0.013-0.023-0.028-0.032-0.051\r\n\t\t\t\tc0.025,0.019,0.035,0.04,0.07,0.051c0.054-0.032,0.047-0.06,0.089-0.083v-0.013c-0.03-0.031-0.081-0.057-0.14-0.057\r\n\t\t\t\tc-0.006-0.011-0.013-0.021-0.019-0.032c0.044,0.015,0.089,0.03,0.133,0.045c-0.006-0.011-0.013-0.021-0.019-0.032v-0.006\r\n\t\t\t\tc0.051,0.021,0.064,0.054,0.14,0.064c0.025-0.03,0.051-0.059,0.076-0.089c0.009-0.016,0.008-0.002,0.038,0\r\n\t\t\t\tc0.006-0.011,0.013-0.021,0.019-0.032c-0.001-0.047-0.012-0.063-0.038-0.083c-0.011-0.006-0.002-0.006-0.013,0\r\n\t\t\t\tc-0.028,0.017-0.029,0.052-0.044,0.081c0.002,0.005-0.004,0.01-0.001,0.014v-0.013c0-0.001,0-0.001,0.001-0.002\r\n\t\t\t\tc-0.01-0.027-0.001-0.054,0.005-0.087c-0.004-0.004-0.009-0.008-0.013-0.013c-0.06,0.01-0.113,0.02-0.191,0.019\r\n\t\t\t\tc0.008-0.038-0.02-0.071,0-0.108v-0.013c0.011,0.017-0.003,0.036,0.006,0.064c0.009,0.011,0.017,0.021,0.026,0.032\r\n\t\t\t\tc0.021-0.006,0.042-0.013,0.064-0.019c0-0.018-0.002-0.019-0.013-0.038c0.021,0.011,0.042,0.021,0.064,0.032\r\n\t\t\t\tc0.008-0.004,0.017-0.009,0.025-0.013c0.002-0.004,0.004-0.008,0.006-0.013c-0.011-0.015-0.021-0.029-0.032-0.044\r\n\t\t\t\tc0.034,0.019,0.057,0.04,0.089,0.025c0.004,0.015,0.008,0.03,0.013,0.045h0.019c-0.012-0.067-0.042-0.087-0.07-0.134h0.038\r\n\t\t\t\tC8.338,28.6,8.338,28.606,8.325,28.59c0.004-0.008,0.008-0.015,0.011-0.023c-0.024-0.086-0.083-0.085-0.17-0.066\r\n\t\t\t\tc-0.004-0.07-0.06-0.101-0.121-0.114c-0.002-0.004-0.004-0.008-0.006-0.013c0.011-0.006,0.021-0.013,0.032-0.019\r\n\t\t\t\tc0.043,0.021,0.076,0.045,0.095,0.089c0.03,0.02,0.023,0.021,0.07,0.019c-0.002-0.021-0.004-0.042-0.006-0.064\r\n\t\t\t\tc-0.02-0.013-0.034-0.028-0.052-0.038H8.172c-0.021-0.017-0.042-0.034-0.064-0.051c0.018,0.026,0.045,0.037,0.069,0.051h0.02\r\n\t\t\t\tc-0.002-0.013-0.004-0.025-0.006-0.038c0.017,0.006,0.034,0.013,0.051,0.019h0.006c-0.002-0.043-0.004-0.052-0.038-0.064\r\n\t\t\t\tc0.009-0.004,0.017-0.009,0.026-0.013c-0.082-0.042-0.117-0.054-0.159-0.133c0.034,0.03,0.068,0.059,0.102,0.089\r\n\t\t\t\tc0.006,0.006,0.013,0.013,0.019,0.019c0.036-0.023,0.042-0.039,0.057-0.083c-0.034-0.047-0.238-0.13-0.311-0.159\r\n\t\t\t\tc-0.002-0.007,0.001-0.013,0-0.019c0.068-0.003,0.075,0.022,0.127,0.045c-0.002-0.013-0.004-0.025-0.006-0.038\r\n\t\t\t\tc0.042,0.042,0.099,0.078,0.153,0.108c-0.016-0.09-0.078-0.09-0.095-0.165h0.006c0.012,0.032,0.027,0.045,0.057,0.057\r\n\t\t\t\tc0.004,0.004,0.008,0.008,0.013,0.013h0.006c-0.015-0.036-0.03-0.072-0.044-0.108c-0.02-0.107,0.072-0.052-0.006-0.197\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.002-0.019,0.004-0.038,0.006-0.057c0.019,0.012,0.011,0.001,0.019,0.026h0.006\r\n\t\t\t\tc0.011-0.014,0.011-0.017,0.013-0.045c0.002,0.011,0.004,0.021,0.006,0.032c0.029-0.02,0.034-0.024,0.032-0.045\r\n\t\t\t\tc0.015-0.011,0.03-0.021,0.044-0.032c-0.006,0.017-0.013,0.034-0.019,0.051c0.013,0.006,0.025,0.013,0.038,0.019\r\n\t\t\t\tc-0.025,0.006-0.051,0.013-0.076,0.019c-0.011,0.017-0.021,0.034-0.032,0.051v0.006h0.051c-0.013,0.035-0.02,0.044-0.07,0.044\r\n\t\t\t\tc-0.004,0.006-0.009,0.013-0.013,0.019c0.016,0.017,0.027,0.021,0.057,0.025c0.002,0.004,0.004,0.008,0.006,0.013v0.026\r\n\t\t\t\tc-0.013-0.007-0.025-0.013-0.038-0.019c-0.004,0.002-0.009,0.004-0.013,0.006c-0.004,0.013-0.009,0.025-0.013,0.038v0.006\r\n\t\t\t\tc0.047-0.025,0.036-0.01,0.089,0.013c0.004,0.006,0.009,0.013,0.013,0.019c-0.03,0.011-0.059,0.021-0.089,0.032\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.011,0.015,0.021,0.03,0.032,0.044c0.017,0.011,0.034,0.021,0.051,0.032\r\n\t\t\t\tc0.021-0.013,0.042-0.025,0.064-0.038c-0.001,0.055-0.005,0.033-0.025,0.07c0.015,0.008,0.03,0.017,0.044,0.025\r\n\t\t\t\tc-0.006,0.013-0.013,0.026-0.019,0.038v0.006h0.006c0.026-0.01,0.031-0.014,0.051,0c-0.039,0.071-0.09,0.135-0.114,0.229\r\n\t\t\t\tc0.004,0.013,0.008,0.025,0.013,0.038c0.008-0.002,0.017-0.004,0.025-0.006c0.017-0.038,0.034-0.076,0.051-0.114\r\n\t\t\t\tc0.02,0,0.017,0.006,0.032-0.006c0.023-0.055,0.047-0.11,0.07-0.165c0.033-0.056,0.086-0.075,0.102-0.14\r\n\t\t\t\tc-0.004-0.04-0.008-0.081-0.013-0.121c-0.078-0.033-0.136-0.206-0.152-0.292c0.024-0.023,0.034-0.046,0.064-0.064\r\n\t\t\t\tc0.002,0.002,0.004,0.004,0.006,0.006c-0.017,0.031-0.037,0.044-0.057,0.07c0.054,0.073,0.068,0.144,0.184,0.14\r\n\t\t\t\tc0.005,0.037-0.005,0.046-0.013,0.083v0.006c0.004,0.002,0.008,0.004,0.013,0.006c0.055-0.041,0.152-0.125,0.152-0.216\r\n\t\t\t\tc0.013,0.004,0.026,0.008,0.038,0.013c0.032-0.093,0.078-0.196,0.095-0.305c-0.053-0.007-0.063-0.019-0.089-0.051\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019c0.029-0.023,0.034-0.034,0.064-0.026c0.019-0.053,0.038-0.106,0.057-0.159\r\n\t\t\t\tc-0.015,0.047-0.03,0.093-0.045,0.14c0.19-0.133,0.413-0.223,0.744-0.222c0.008-0.043,0.017-0.085,0.025-0.127\r\n\t\t\t\tc0.002-0.002,0.036,0,0.064-0.013c0.003,0.022-0.008,0.053-0.006,0.095c0.004,0.002,0.008,0.004,0.013,0.007\r\n\t\t\t\tc0.058-0.002,0.108-0.049,0.121-0.089h0.006c0.013,0.016,0.014,0.037,0.013,0.07c0.072-0.017,0.144-0.034,0.216-0.051\r\n\t\t\t\tc0-0.035-0.012-0.048-0.019-0.067v0.016c-0.03,0.013-0.059,0.025-0.089,0.038c-0.017-0.006-0.034-0.013-0.051-0.019\r\n\t\t\t\tc-0.017-0.095-0.061-0.182-0.165-0.191c0.011-0.069,0.067-0.083,0.127-0.102c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.052-0.015-0.053-0.008-0.083-0.057c0.045-0.073,0.096-0.241,0.184-0.267v-0.07c0.028-0.011,0.055-0.021,0.083-0.032\r\n\t\t\t\tc-0.002,0.011-0.004,0.021-0.006,0.032c0.013,0.006,0.025,0.013,0.038,0.019h0.006c0.028-0.036,0.033-0.028,0.025-0.076\r\n\t\t\t\tc0.011-0.009,0.021-0.017,0.032-0.025c-0.004,0.015-0.008,0.03-0.013,0.044c0.017,0.004,0.034,0.008,0.051,0.013\r\n\t\t\t\tc0.008-0.021,0.017-0.042,0.025-0.064c0.013,0.008,0.025,0.017,0.038,0.025c0.059-0.044,0.113-0.149,0.14-0.222h0.006\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c-0.008,0.021-0.017,0.042-0.025,0.064c0.002,0.004,0.004,0.008,0.006,0.013\r\n\t\t\t\tc0.027,0.008,0.055,0.017,0.083,0.025c-0.004-0.019-0.008-0.038-0.013-0.057c0.046,0.008,0.075-0.021,0.121-0.032\r\n\t\t\t\tc0.006,0.019,0.013,0.038,0.019,0.057c0.038-0.028,0.057-0.071,0.095-0.095c0.015,0.011,0.03,0.021,0.044,0.032\r\n\t\t\t\tc0.018-0.015,0.017-0.011,0.019-0.045c0.069,0.012,0.096-0.012,0.153-0.038c0.011-0.019,0.01-0.016,0.013-0.032h-0.051\r\n\t\t\t\tc0.011-0.015,0.021-0.03,0.032-0.045c-0.011-0.023-0.021-0.047-0.032-0.07c0.011,0.008,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.041-0.039,0.135-0.02,0.178,0.013c0.034-0.019,0.068-0.038,0.102-0.057c-0.006-0.013-0.013-0.026-0.019-0.038\r\n\t\t\t\tc0.023,0.013,0.047,0.025,0.07,0.038c0.139-0.017,0.194-0.143,0.343-0.146c0.013-0.023,0.025-0.047,0.038-0.07\r\n\t\t\t\tc-0.006-0.019-0.013-0.038-0.019-0.057c0.024,0.019,0.04,0.035,0.044,0.076c0.019-0.011,0.038-0.021,0.057-0.032h0.006\r\n\t\t\t\tc-0.025,0.065-0.104,0.124-0.172,0.146c-0.008,0.017-0.011,0.022-0.013,0.051c0.108-0.056,0.302-0.039,0.432-0.025\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.092-0.002-0.148,0.034-0.229,0.051v0.044c-0.023-0.018-0.019-0.021-0.044-0.025\r\n\t\t\t\tc0.002-0.023,0.004-0.047,0.006-0.07c-0.083-0.003-0.358,0.164-0.413,0.222h-0.013c0.011,0.006,0.021,0.013,0.032,0.019v0.006\r\n\t\t\t\tc-0.027,0.003-0.018,0.002-0.038-0.013c-0.04,0.023-0.08,0.047-0.121,0.07c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.03-0.019,0.059-0.038,0.089-0.057c-0.014,0.038-0.023,0.015-0.044,0.038\r\n\t\t\t\tc-0.076,0.082-0.026,0.172-0.006,0.26c0.015-0.005,0.009-0.003,0.025-0.019c0.019,0.032,0.038,0.064,0.057,0.095\r\n\t\t\t\tc0.048-0.01,0.046-0.012,0.076,0.019c0.009-0.023,0.017-0.047,0.026-0.07c0.035-0.016,0.053-0.017,0.108-0.013v-0.045\r\n\t\t\t\tc0.006,0.004,0.013,0.009,0.019,0.013c0.062-0.036,0.089-0.171,0.203-0.172c0.014-0.051-0.01-0.053-0.013-0.108h0.038\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032h0.006c0.023-0.015,0.034-0.023,0.045-0.051c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc-0.002,0.015-0.004,0.03-0.006,0.045c0.036,0.004,0.072,0.008,0.108,0.013c0.016-0.034,0.031-0.025,0.038-0.07\r\n\t\t\t\tc0.011,0.006,0.021,0.013,0.032,0.019c0.004-0.015,0.008-0.03,0.013-0.044c0.006-0.002,0.013-0.004,0.019-0.006\r\n\t\t\t\tc0.032,0.009,0.026,0.014,0.045,0.032c0.124-0.045,0.262-0.143,0.407-0.146c-0.002-0.009-0.004-0.017-0.006-0.025\r\n\t\t\t\tc0.032,0.002,0.064,0.004,0.095,0.006c-0.004-0.006-0.008-0.013-0.013-0.019c0.006-0.004,0.013-0.009,0.019-0.013\r\n\t\t\t\tc0.024-0.013,0.02-0.005,0.044,0.013c0.021-0.009,0.042-0.017,0.063-0.025c-0.027-0.034-0.068-0.036-0.133-0.032\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c0.013-0.007,0.025-0.013,0.038-0.019c0.006-0.008,0.013-0.017,0.019-0.025\r\n\t\t\t\tc-0.021-0.021-0.042-0.042-0.063-0.064c-0.075-0.027-0.112,0.044-0.133-0.064c-0.066,0.01-0.086,0.052-0.133,0.07\r\n\t\t\t\tc-0.032,0.012-0.073,0.004-0.095,0.013c0.006-0.013,0.013-0.025,0.019-0.038h-0.013c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.067-0.031-0.119,0.027-0.165,0.006c-0.019-0.013-0.038-0.025-0.057-0.038c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.028-0.013-0.04-0.048-0.083-0.057h-0.013v-0.006c0.025-0.009,0.051-0.017,0.076-0.025c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc-0.103-0.049-0.301-0.028-0.267-0.191c-0.021-0.028-0.018-0.025-0.044-0.019c-0.013-0.053-0.009-0.079,0.013-0.121\r\n\t\t\t\tc-0.03-0.032-0.094-0.029-0.159-0.025c0.088-0.089,0.103-0.048,0.133-0.178c0.021-0.021,0.042-0.042,0.064-0.064\r\n\t\t\t\tc-0.015-0.011-0.03-0.021-0.044-0.032c-0.019,0.008-0.038,0.017-0.057,0.025v-0.032c-0.055,0.025-0.11,0.051-0.165,0.076\r\n\t\t\t\tc-0.065-0.089-0.112-0.14-0.254-0.152v-0.007c0.049-0.015,0.115-0.056,0.191-0.038c0.034,0.015,0.068,0.03,0.102,0.045\r\n\t\t\t\tc0.079-0.006,0.346-0.155,0.375-0.216c-0.094-0.249-0.411-0.255-0.674-0.152c-0.282,0.11-0.595,0.189-0.82,0.356\r\n\t\t\t\tc-0.184,0.136-0.321,0.345-0.502,0.489c0.154-0.325,0.477-0.718,0.775-0.896c0.079-0.047,0.223-0.03,0.299-0.083\r\n\t\t\t\tc0.108-0.076,0.07-0.268,0.267-0.337c0.117-0.041,0.317-0.025,0.439-0.006c0.178,0.027,0.354-0.025,0.515-0.006\r\n\t\t\t\tc0.163,0.008,0.326,0.017,0.489,0.025c0.219-0.035,0.465-0.038,0.61-0.146c0.083-0.091,0.165-0.182,0.248-0.273\r\n\t\t\t\tc0.155-0.015,0.309-0.03,0.464-0.044c0.1-0.032,0.288-0.2,0.375-0.267v-0.013c-0.042-0.055-0.085-0.11-0.127-0.165\r\n\t\t\t\tc0.034-0.061,0.064-0.142,0.095-0.21c-0.007-0.1-0.158-0.181-0.248-0.197c-0.041-0.008-0.112,0.043-0.153,0.064\r\n\t\t\t\tc-0.013-0.019-0.025-0.038-0.038-0.057c0.008-0.044,0.031-0.064,0.051-0.095c-0.257-0.247-0.418,0.027-0.61,0.133\r\n\t\t\t\tc-0.089,0.05-0.218,0.06-0.305,0.095c0.012-0.069,0.034-0.173,0.083-0.21c0.053-0.004,0.106-0.008,0.159-0.013\r\n\t\t\t\tc0.109-0.031,0.157-0.136,0.28-0.165c0.122-0.029,0.24-0.033,0.292-0.127c-0.11-0.028-0.22-0.055-0.33-0.083\r\n\t\t\t\tc-0.106-0.044-0.191-0.133-0.324-0.153c-0.101-0.015-0.161,0.043-0.261,0.038c0.021-0.051,0.042-0.102,0.064-0.152\r\n\t\t\t\tc-0.007-0.092-0.237-0.273-0.311-0.299h-0.095c-0.062-0.024-0.129-0.187-0.165-0.241c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.055-0.031,0.185,0.022,0.261,0c0.012-0.024,0.014-0.061,0.013-0.102c-0.084-0.062-0.178-0.095-0.242-0.178\r\n\t\t\t\tc0.027-0.025,0.057-0.044,0.102-0.051c-0.036-0.207-0.226-0.07-0.261-0.356c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.009-0.07,0.017-0.079,0.032-0.134c-0.122-0.141-0.365-0.561-0.508-0.629c-0.004-0.004-0.008-0.008-0.013-0.013\r\n\t\t\t\tc-0.021,0.042-0.042,0.085-0.064,0.127c-0.144,0.096-0.271,0.026-0.114,0.235c-0.096,0.122-0.182,0.158-0.184,0.388h-0.006\r\n\t\t\t\tc-0.051-0.051-0.057-0.152-0.153-0.159c-0.034,0.059-0.068,0.119-0.102,0.178c-0.077,0.058-0.266,0.055-0.349,0.095\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c0.014-0.022,0.019-0.03,0.019-0.07c-0.149-0.221-0.275-0.116-0.483-0.044h-0.006\r\n\t\t\t\tc-0.044-0.056-0.038-0.084-0.026-0.178c0.036,0.002,0.072,0.004,0.108,0.006c0.112-0.165-0.211-0.619,0.013-0.724\r\n\t\t\t\tc0.011-0.023,0.014-0.056,0.013-0.095c-0.011-0.017-0.021-0.034-0.032-0.051c-0.039-0.011-0.088,0.06-0.178,0.038\r\n\t\t\t\tc-0.162-0.039-0.31-0.129-0.458-0.159c-0.052-0.065-0.056-0.061-0.013-0.14c-0.022-0.016-0.052-0.042-0.077-0.062\r\n\t\t\t\tc0.109-0.188,0.225-0.372,0.338-0.557c0.01,0.006,0.021,0.007,0.031,0.015c0.006,0.003,0.064-0.003,0.102,0.013\r\n\t\t\t\tc0.028,0.017,0.055,0.034,0.083,0.051c0.049,0.006,0.097,0.013,0.146,0.019c0.04,0.047,0.081,0.093,0.121,0.14\r\n\t\t\t\tc0.094,0.057,0.203,0.032,0.331,0.064c0.203,0.072,0.407,0.144,0.61,0.216c-0.067-0.217-0.212-0.375-0.381-0.489\r\n\t\t\t\tc-0.155-0.104-0.443-0.179-0.47-0.4c0.186,0,0.218,0.082,0.343,0.127c-0.009-0.049-0.017-0.097-0.026-0.146\r\n\t\t\t\tc0.188,0.145,0.277,0.375,0.604,0.349c0.069,0.109,0.145,0.196,0.273,0.248c-0.038-0.078-0.076-0.157-0.114-0.235\r\n\t\t\t\tc0.04,0.008,0.08,0.017,0.121,0.025h0.006c-0.006-0.184-0.176-0.25-0.153-0.432c0.084,0.057,0.177,0.169,0.216,0.267\r\n\t\t\t\tc0.008,0.006,0.017,0.013,0.025,0.019c0.037-0.334-0.178-0.289-0.292-0.477c0.006-0.013,0.013-0.026,0.019-0.038\r\n\t\t\t\tc0.025-0.006,0.051-0.013,0.076-0.019h0.013c-0.061-0.03-0.123-0.059-0.184-0.089c-0.069-0.041-0.11-0.13-0.191-0.153\r\n\t\t\t\tc-0.019,0.015-0.038,0.03-0.057,0.044c-0.008,0.008-0.017,0.017-0.025,0.026c-0.071-0.122-0.147-0.253-0.21-0.388\r\n\t\t\t\tc-0.053-0.009-0.106-0.017-0.159-0.025c-0.006-0.014-0.012-0.027-0.019-0.04c0.024-0.035,0.051-0.067,0.076-0.101\r\n\t\t\t\tc0.001,0.003,0.005,0.005,0.006,0.008c0.04-0.004,0.081-0.009,0.121-0.013c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.022-0.025-0.045-0.05-0.067-0.075c0.044-0.062,0.092-0.121,0.137-0.183c0.134,0.06,0.208,0.164,0.343,0.226\r\n\t\t\t\tc0.072,0.033,0.155,0.015,0.21,0.051c-0.013,0.036-0.025,0.072-0.038,0.108c0.005,0.082,0.057,0.11,0.089,0.165\r\n\t\t\t\tc0.042-0.019,0.085-0.038,0.127-0.057c0.033,0.038,0.022,0.078,0.051,0.127c0.022,0.036,0.201,0.12,0.248,0.102h0.013\r\n\t\t\t\tc-0.015-0.064-0.03-0.127-0.045-0.191c0.011-0.076,0.021-0.153,0.032-0.229c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.036,0.05,0.089,0.124,0.159,0.14c0.035-0.09,0.113-0.136,0.222-0.152c-0.011-0.088-0.097-0.155-0.165-0.184\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.15-0.095,0.182,0.061,0.324,0c0.025-0.019,0.058-0.097,0.089-0.127\r\n\t\t\t\tc0.002-0.006,0.004-0.013,0.006-0.019c-0.087-0.061-0.174-0.123-0.261-0.184c-0.092,0.084-0.164,0.079-0.299,0.051\r\n\t\t\t\tc0.013-0.043,0.025-0.085,0.038-0.127c-0.147-0.013-0.29,0.025-0.47,0.026v-0.095c0.061-0.015,0.123-0.03,0.184-0.044h0.013\r\n\t\t\t\tc-0.051-0.098-0.165-0.231-0.267-0.273c-0.037-0.015-0.062-0.003-0.087,0.008c0.618-0.794,1.268-1.56,1.972-2.276\r\n\t\t\t\tc0.027,0.005,0.054,0.009,0.08,0.014c0.042,0.011,0.084,0.021,0.127,0.032c0.022-0.003,0.044-0.006,0.065-0.009\r\n\t\t\t\tc0.003,0,0.005,0,0.008,0c0.003,0.007,0.006,0.014,0.01,0.022c0.02,0.004,0.051,0.001,0.079-0.002\r\n\t\t\t\tc0.003,0.003,0.005,0.006,0.008,0.008c-0.045,0.019-0.061,0.016-0.102,0.01c-0.025,0.007-0.079,0.031-0.085,0.046\r\n\t\t\t\tc-0.01,0.04,0.124,0.116,0.183,0.098c0.044-0.017,0.087-0.034,0.131-0.051c0.058-0.019,0.1-0.003,0.157-0.022\r\n\t\t\t\tc0.096-0.031,0.196-0.098,0.229-0.154c0.053-0.088-0.124-0.137-0.191-0.155c-0.063-0.017-0.099-0.061-0.143-0.099\r\n\t\t\t\tc-0.051-0.044-0.123-0.071-0.209-0.083c0.015-0.015,0.032-0.028,0.047-0.043c0.017,0.003,0.035,0.009,0.05,0.01\r\n\t\t\t\tc0.011-0.005,0.009-0.006,0.015-0.011c0.018-0.001,0.036-0.001,0.055-0.002c0.098,0.013,0.166,0.087,0.242,0.125\r\n\t\t\t\tc0.058,0.029,0.126,0.035,0.206,0.042c0.022,0.002,0.033,0.013,0.057,0.012c0.021-0.022,0.037-0.048,0.097-0.049\r\n\t\t\t\tc0.002,0.002,0.005,0.004,0.007,0.005c0.001,0.001,0.003,0.003,0.004,0.004c-0.009,0.006-0.019,0.012-0.028,0.019\r\n\t\t\t\tc0.003,0.004,0.006,0.009,0.01,0.013c0.082-0.002,0.101-0.036,0.149-0.053c0.04-0.014,0.063,0.003,0.095-0.008\r\n\t\t\t\tc-0.012,0.025-0.046,0.04-0.061,0.063c-0.015,0.023-0.012,0.045-0.025,0.07c-0.007,0.014-0.031,0.02-0.038,0.036\r\n\t\t\t\tc0.01,0.019,0.049,0.027,0.043,0.05c-0.003,0.006-0.051,0.024-0.06,0.026c0,0.019-0.02,0.038-0.005,0.057\r\n\t\t\t\tc0.01,0.008,0.024,0.008,0.042,0.007c0.003,0.002,0.006,0.003,0.009,0.005c-0.017,0.009-0.038,0.017-0.052,0.026\r\n\t\t\t\tc-0.001,0.018,0.024,0.052,0.013,0.071c-0.012,0.019-0.048,0.03-0.06,0.051c0,0.001,0,0.001,0,0.002\r\n\t\t\t\tc0.084-0.011,0.07-0.036,0.138-0.055c0.04,0.003,0.027,0.022,0.052,0.038c0.012,0.003,0.025,0.006,0.037,0.01\r\n\t\t\t\tc0.001,0.001,0.002,0.002,0.004,0.003c0,0.002,0,0.005,0,0.007c-0.016,0.04-0.137,0.028-0.188,0.046\r\n\t\t\t\tc-0.007,0.004-0.065,0.071-0.067,0.078c0.003,0.008,0.005,0.016,0.008,0.024c-0.011,0.012-0.022,0.025-0.032,0.038\r\n\t\t\t\tc-0.019,0.031-0.038,0.062-0.057,0.092c0.074-0.015,0.084-0.049,0.159-0.064c0.061,0.021,0.023,0.086-0.02,0.107\r\n\t\t\t\tc-0.029,0.014-0.071,0.006-0.102,0.011c-0.063,0.01-0.105,0.042-0.185,0.049c-0.054,0.004-0.117-0.01-0.169,0.006\r\n\t\t\t\tc-0.118,0.035-0.158,0.131-0.289,0.172c0.034,0.002,0.095,0.005,0.125,0.003c0.039-0.009,0.078-0.018,0.118-0.027\r\n\t\t\t\tc0.023,0.004,0.047,0.008,0.07,0.012c0.05,0.008,0.104,0.007,0.161,0.008c0.03-0.031,0.065-0.027,0.119-0.048\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.006c0-0.015-0.011-0.025-0.03-0.026c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.021-0.031,0.098-0.036,0.127-0.016c0.007,0.042-0.069,0.055-0.07,0.092c-0.002,0.059,0.172,0.07,0.202,0.108\r\n\t\t\t\tc-0.014,0.005-0.016,0.007-0.013,0.017c-0.062-0.014-0.133-0.027-0.211-0.024c-0.053,0.005-0.106,0.01-0.159,0.015\r\n\t\t\t\tc-0.058,0-0.109-0.014-0.16-0.022c-0.067-0.011-0.133-0.021-0.2-0.032c-0.003,0.001-0.007,0.001-0.01,0.002\r\n\t\t\t\tc-0.003,0.006-0.007,0.012-0.01,0.018c0,0.026,0.154,0.053,0.194,0.053c0.012,0.005,0.034,0.016,0.012,0.028\r\n\t\t\t\tc-0.041,0.017-0.145-0.037-0.22-0.018c-0.111,0.028-0.099,0.092-0.137,0.146c-0.027,0.036-0.054,0.071-0.081,0.107\r\n\t\t\t\tc-0.003,0.008,0.004,0.014,0.009,0.02c0.107,0.021,0.169-0.081,0.21-0.108c0.029-0.009,0.058-0.018,0.086-0.026\r\n\t\t\t\tc0.066-0.032,0.111-0.067,0.214-0.086c-0.003,0.016-0.019,0.023-0.018,0.04c0.034,0.031,0.073,0.012,0.142,0.008\r\n\t\t\t\tc0.019,0,0.038-0.001,0.058-0.001c0.029-0.02,0.092-0.051,0.055-0.082c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.073-0.008,0.116-0.013,0.164,0.002c0.001,0.002,0.001,0.004,0.002,0.006c-0.029,0.03-0.094,0.055-0.093,0.094\r\n\t\t\t\tc0.024,0.013,0.055,0.015,0.064,0.043c-0.107,0.003-0.221,0.01-0.318,0.003c-0.048-0.004-0.097-0.025-0.149-0.02\r\n\t\t\t\tc-0.05,0.005-0.095,0.041-0.126,0.057c-0.053,0.028-0.107,0.056-0.16,0.084c-0.031,0.011-0.061,0.023-0.092,0.034\r\n\t\t\t\tc-0.026,0.023-0.052,0.046-0.077,0.07c0.097,0.037,0.343-0.041,0.494-0.055c0.031-0.005,0.062-0.01,0.093-0.014\r\n\t\t\t\tc0.025,0.006,0.05,0.012,0.074,0.017c0.027-0.002,0.053-0.004,0.08-0.005c0.071,0.006,0.103,0.061,0.143,0.099\r\n\t\t\t\tc-0.048-0.007-0.096-0.013-0.143-0.019c-0.175-0.014-0.382-0.023-0.599,0.048c-0.044,0.013-0.088,0.026-0.132,0.039\r\n\t\t\t\tc0.033,0.026,0.093,0.01,0.126,0.031c0.015,0.022,0.03,0.043,0.045,0.065c0.009,0.006,0.187,0.026,0.212,0.028\r\n\t\t\t\tc0.027-0.007,0.031-0.019,0.051-0.03c0.071-0.01,0.102,0.049,0.058,0.079c-0.07,0.047-0.247,0.037-0.329,0.081\r\n\t\t\t\tc-0.002,0-0.003,0.001-0.005,0.001c0.03,0.018,0.163,0.033,0.21,0.036c-0.003,0.003-0.155,0.049-0.161,0.049\r\n\t\t\t\tc-0.041,0.003-0.061-0.021-0.109,0.004c-0.042,0.022-0.094,0.081-0.039,0.115c0.01,0.006,0.061,0.009,0.061,0.018\r\n\t\t\t\tc0.001,0.014-0.046,0.027-0.052,0.042c-0.006,0.028,0.035,0.04,0.072,0.026c0.049-0.018,0.116-0.057,0.149-0.083\r\n\t\t\t\tc0.068-0.052,0.139-0.105,0.219-0.153c0.026-0.012,0.052-0.023,0.078-0.035c0.04-0.037,0.08-0.074,0.119-0.111\r\n\t\t\t\tc0.043-0.03,0.109-0.051,0.168-0.075c0.037-0.015,0.07-0.028,0.113-0.042c0.041-0.009,0.082-0.018,0.123-0.027\r\n\t\t\t\tc0.021-0.007,0.051-0.021,0.08-0.02c0.023,0.007,0.047,0.013,0.07,0.02c-0.022,0.019-0.042,0.053-0.07,0.067\r\n\t\t\t\tc-0.075,0.036-0.22,0.019-0.315,0.037c-0.025,0.043-0.11,0.069-0.158,0.098c-0.009,0.008-0.002,0.019-0.007,0.028\r\n\t\t\t\tc-0.013,0.026-0.056,0.051-0.112,0.061c0.003,0.009,0.006,0.018,0.009,0.026c-0.158,0.057-0.262,0.142-0.375,0.215\r\n\t\t\t\tc-0.03,0.019-0.109,0.042-0.12,0.068c-0.012,0.015,0.009,0.03,0.021,0.039c0.065,0.049,0.103,0.014,0.195-0.009\r\n\t\t\t\tc-0.019,0.04-0.065,0.091-0.144,0.109c-0.001,0.005-0.002,0.009-0.003,0.014c0.052,0.027,0.141,0.031,0.175-0.022\r\n\t\t\t\tc0.113-0.018,0.086,0.118,0.06,0.151c0.003,0.005,0.006,0.006,0.012,0.013c0.055-0.019,0.148-0.049,0.186-0.075\r\n\t\t\t\tc0.004-0.001,0.008-0.002,0.012-0.002c0.002,0.001,0.004,0.001,0.006,0.002c0.001,0.002,0.001,0.004,0.002,0.006\r\n\t\t\t\tc-0.05,0.055-0.176,0.082-0.215,0.141c0.012,0.026,0.047,0.037,0.078,0.043c0.037-0.003,0.063-0.022,0.086-0.035\r\n\t\t\t\tc0.013,0.011,0.023,0.019,0.028,0.038l-0.049,0.069c-0.008,0.002-0.017,0.003-0.025,0.005c0.026,0.048,0.092,0.004,0.15,0.016\r\n\t\t\t\tc0.032,0.007,0.037,0.052,0.057,0.069c-0.179,0.032-0.096,0.172-0.138,0.254c-0.009,0.019-0.043,0.094-0.017,0.116\r\n\t\t\t\tc0.006,0.006,0.01,0.008,0.021,0.009c0.036,0,0.069-0.044,0.086-0.058c0.047-0.038,0.105-0.089,0.124-0.137\r\n\t\t\t\tc-0.001-0.015-0.003-0.029-0.004-0.044c0.001-0.019,0.025-0.055,0.047-0.067c0.006-0.002,0.011-0.003,0.017-0.005\r\n\t\t\t\tc0.034,0.014,0.057,0.047,0.075,0.077c0.002,0,0.004,0,0.006,0.001c0.011-0.016,0.023-0.032,0.034-0.048\r\n\t\t\t\tc-0.003-0.046-0.006-0.093-0.009-0.14c0.001-0.041,0.018-0.075,0.027-0.11c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.023,0.013,0.046,0.027,0.069,0.04c0.012,0.015-0.004,0.03-0.005,0.042c-0.002,0.033,0.023,0.085,0.059,0.092\r\n\t\t\t\tc0.037,0.007,0.092-0.018,0.131-0.027c0.005,0.037,0.052,0.138,0.083,0.157c0.029,0.009,0.057,0.019,0.086,0.029\r\n\t\t\t\tc0.033,0.016,0.053,0.039,0.077,0.065c0.001,0.003,0.002,0.005,0.003,0.008c-0.08,0.005-0.209-0.043-0.25-0.08\r\n\t\t\t\tc-0.027-0.024-0.028-0.082-0.07-0.091c-0.061-0.014-0.142,0.044-0.163,0.066c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc0.02,0.01,0.078,0.031,0.064,0.059c-0.007,0.019-0.053,0.031-0.075,0.044c-0.062,0.036-0.11,0.071-0.19,0.104\r\n\t\t\t\tc-0.027,0.011-0.089,0.021-0.104,0.038c0.022,0.035,0.111,0.043,0.185,0.018c0.087-0.037,0.175-0.073,0.262-0.11\r\n\t\t\t\tc0.013-0.012,0.026-0.024,0.038-0.036c0.017,0.036,0.059,0.046,0.081,0.071c-0.024,0.009-0.063,0.011-0.098,0.022\r\n\t\t\t\tc-0.09,0.027-0.188,0.048-0.269,0.081c-0.035,0.015-0.092,0.041-0.134,0.034c0.005,0.043,0.049,0.052,0.057,0.092\r\n\t\t\t\tc0.009-0.001,0.019-0.001,0.028-0.002c0,0.002,0.001,0.003,0.001,0.005c-0.015,0.021-0.059,0.025-0.1,0.034\r\n\t\t\t\tc-0.001,0.003-0.002,0.006-0.002,0.009c0.071,0.035,0.051,0.061,0.071,0.126c0.078,0.018,0.126-0.035,0.181-0.058\r\n\t\t\t\tc0.036-0.015,0.083-0.023,0.132-0.032c-0.069,0.057-0.138,0.115-0.207,0.173c0.001,0.002,0.002,0.005,0.003,0.008\r\n\t\t\t\tc0.058,0.008,0.109-0.033,0.173-0.036c0.069-0.004,0.128,0.034,0.115,0.093c-0.012,0.053-0.138,0.066-0.08,0.133\r\n\t\t\t\tc0.048,0.01,0.079-0.016,0.127-0.014c0.002,0,0.003-0.001,0.005-0.001c-0.008,0.023-0.056,0.064-0.035,0.086\r\n\t\t\t\tc0,0.001,0.001,0.002,0.001,0.003c0.108-0.031,0.124-0.099,0.202-0.141c0.009,0.002,0.017,0.004,0.026,0.007\r\n\t\t\t\tc0.001,0.027-0.032,0.057-0.047,0.081c-0.042,0.065-0.084,0.13-0.126,0.195c-0.029,0.051,0.007,0.108,0.077,0.123\r\n\t\t\t\tc0.05,0,0.1,0,0.15,0c0.05,0.005,0.1,0.01,0.15,0.014c0.012,0.017,0.027,0.044,0.031,0.062c-0.019,0.015-0.049,0.031-0.085,0.039\r\n\t\t\t\tc0.002,0.01,0.001,0.012-0.009,0.02c0.009,0.017,0.026,0.022,0.046,0.028c0.037-0.01,0.093-0.026,0.121-0.041\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.007,0.012c-0.008,0.012-0.025,0.015-0.043,0.023c-0.061,0.029-0.098,0.044-0.103,0.095\r\n\t\t\t\tc0.112-0.018,0.147-0.073,0.235-0.096c0.023,0.072-0.093,0.095-0.116,0.152c0.011,0.023,0.039,0.022,0.053,0.041\r\n\t\t\t\tc-0.039,0.015-0.064,0.034-0.097,0.049c0.041,0.037,0.102,0.063,0.19,0.023c0.008-0.005,0.016-0.011,0.024-0.016\r\n\t\t\t\tc0.023-0.009,0.031,0.008,0.05,0c0.045-0.018,0.029-0.058,0.122-0.037c0,0.002,0.001,0.003,0.002,0.005\r\n\t\t\t\tc-0.013,0.033-0.073,0.046-0.136,0.061c0.058,0.029,0.233,0.015,0.271,0.055c0.036,0.037-0.063,0.081-0.014,0.117\r\n\t\t\t\tc0.006,0.002,0.012,0.001,0.023-0.001c0.028-0.024,0.047-0.046,0.101-0.061c0.008,0.002,0.015,0.004,0.023,0.006\r\n\t\t\t\tc0.006,0.033,0.035,0.061,0.034,0.088c-0.001,0.032-0.072,0.06-0.133,0.07c0.072,0.019,0.181,0.032,0.277,0\r\n\t\t\t\tc-0.001-0.01-0.006-0.026,0.007-0.035c0.001,0,0.002,0,0.003,0c0.025-0.008,0.049-0.015,0.074-0.023\r\n\t\t\t\tc0.018-0.009,0.018-0.024,0.048-0.029c0.001,0,0.002,0,0.003,0c0.001,0,0.002,0,0.002,0c0.001,0,0.002,0,0.003-0.001\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0c0.032-0.001,0.061,0.018,0.104,0.004c0.031-0.018,0.062-0.035,0.094-0.053\r\n\t\t\t\tc0.044-0.016,0.092,0.019,0.092-0.034c0.064,0.001,0.128-0.025,0.114-0.063c-0.096-0.034-0.03-0.068,0.043-0.095\r\n\t\t\t\tc0.035,0.012,0.033,0.039,0.06,0.062c0.009,0.008,0.023,0.008,0.03,0.019c-0.036,0.036-0.115,0.1-0.125,0.14\r\n\t\t\t\tc0.023-0.018,0.04-0.047,0.076-0.059c0.023-0.008,0.049-0.002,0.073-0.012c0.024-0.019,0.048-0.037,0.072-0.055\r\n\t\t\t\tc0.008,0.022,0.018,0.041,0.034,0.055c0.013,0.012,0.052,0.019,0.053,0.04c0.001,0.034-0.057,0.046-0.088,0.07\r\n\t\t\t\tc-0.018,0.014-0.016,0.041-0.034,0.057c-0.035,0.025-0.07,0.05-0.105,0.075c0,0,0,0.001,0.001,0.002\r\n\t\t\t\tc0.032-0.001,0.055-0.016,0.087-0.017c0.02,0.011,0.033,0.028,0.047,0.046c0.002,0.001,0.004,0.002,0.006,0.002\r\n\t\t\t\tc0.075-0.019,0.046-0.092,0.085-0.126c0.041-0.013,0.102-0.007,0.101,0.026c-0.001,0.043-0.072,0.076-0.03,0.132\r\n\t\t\t\tc0.056,0.007,0.091-0.071,0.108-0.096c0.011-0.016,0.04-0.031,0.063-0.042c-0.021,0.042-0.041,0.083-0.062,0.125\r\n\t\t\t\tc0.006-0.001,0.012-0.002,0.017-0.003c0.053,0.045-0.139,0.11-0.08,0.183c0.052,0.007,0.11-0.041,0.178-0.037\r\n\t\t\t\tc0.043,0.002,0.057,0.042,0.094,0.052c0.006-0.001,0.012-0.002,0.017-0.003c0.057-0.029,0.042-0.124,0.109-0.141\r\n\t\t\t\tc0.08-0.02,0.159,0.014,0.22,0.018c0.039-0.001,0.078-0.003,0.117-0.004c0.03,0.001,0.076,0.02,0.11-0.001\r\n\t\t\t\tc0.013-0.009,0.015-0.023,0.02-0.035c0.036-0.085-0.093-0.067-0.067-0.122c-0.041,0.011-0.059,0.029-0.089,0.042\r\n\t\t\t\tc-0.065,0.028-0.129-0.005-0.144-0.044c0.136-0.026,0.396-0.115,0.395-0.18c-0.021,0.001-0.042,0.001-0.063,0.002\r\n\t\t\t\tc-0.034,0.009-0.058,0.035-0.104,0.036c-0.051,0.002-0.124-0.029-0.138-0.067c0.064-0.012,0.128-0.025,0.185-0.032\r\n\t\t\t\tc-0.019-0.013-0.058-0.022-0.087-0.023c-0.003-0.002-0.006-0.003-0.01-0.005c0.031-0.01,0.075-0.019,0.101-0.029\r\n\t\t\t\tc0.034-0.059-0.048-0.07,0.054-0.117c0-0.003,0-0.005,0-0.008c-0.048-0.03-0.174,0.004-0.201-0.043\r\n\t\t\t\tc-0.008-0.014,0.003-0.029,0.009-0.038c0.034-0.053,0.14-0.038,0.185-0.014c0.017-0.003,0.026-0.005,0.033-0.011\r\n\t\t\t\tc0.019-0.014,0.036-0.1,0.012-0.124c0.044-0.024,0.037-0.052,0.056-0.086c0.01-0.01,0.02-0.02,0.03-0.031\r\n\t\t\t\tc-0.041,0.006-0.092,0.025-0.124,0.016l-0.008-0.015c0.097-0.014,0.14-0.081,0.167-0.127c-0.03-0.052-0.1-0.085-0.104-0.156\r\n\t\t\t\tc-0.112-0.018-0.212-0.043-0.286-0.1c0.086-0.011,0.213,0.059,0.274,0.031c0.002-0.001,0.005-0.002,0.007-0.003\r\n\t\t\t\tc-0.001-0.003-0.002-0.005-0.003-0.008c-0.042-0.016-0.114-0.015-0.143-0.042c-0.025-0.024-0.027-0.071-0.049-0.092\r\n\t\t\t\tc0.047-0.029,0.093-0.059,0.14-0.088c0.046-0.019,0.099-0.029,0.134-0.05c-0.008-0.009-0.016-0.018-0.025-0.027\r\n\t\t\t\tc-0.005-0.014-0.011-0.028-0.016-0.042c-0.03-0.035-0.107-0.073-0.064-0.124c0-0.001-0.001-0.002-0.001-0.003\r\n\t\t\t\tc0.036,0.017,0.147,0.055,0.204,0.044c-0.001-0.003-0.002-0.005-0.003-0.008c0.006-0.008,0.012-0.008,0.012-0.019\r\n\t\t\t\tc-0.034-0.018-0.117-0.048-0.111-0.082c0.001-0.001,0.003-0.002,0.004-0.003c0.046,0.004,0.07,0.02,0.12,0.02\r\n\t\t\t\tc0.021-0.009,0.035-0.019,0.033-0.036c-0.026-0.023-0.065-0.029-0.091-0.051c0.001-0.002,0.002-0.005,0.003-0.007\r\n\t\t\t\tc0.035-0.01,0.079,0.009,0.106-0.015c0.019-0.013,0.014-0.041,0.035-0.055c0.018-0.012,0.068-0.012,0.091-0.021\r\n\t\t\t\tc0.015-0.022,0.003-0.047-0.001-0.075c-0.068,0.036-0.136,0.006-0.192,0.002c-0.019,0-0.038,0.001-0.058,0.001\r\n\t\t\t\tc-0.021-0.005-0.042-0.024-0.057-0.036c0,0,0-0.001,0-0.002c0.047,0,0.084,0.013,0.126,0.016\r\n\t\t\t\tc0.044-0.001,0.088-0.001,0.131-0.002c0.028-0.001,0.09-0.009,0.1-0.024c0.026-0.037-0.037-0.077-0.065-0.092\r\n\t\t\t\tc-0.023-0.013-0.046-0.027-0.069-0.04c-0.012-0.013-0.024-0.025-0.036-0.038c-0.018-0.01-0.063-0.003-0.087-0.007\r\n\t\t\t\tc-0.051-0.015-0.102-0.031-0.152-0.046c0.035-0.013,0.071-0.026,0.106-0.039c0.054-0.022,0.094-0.056,0.147-0.073\r\n\t\t\t\tc0.065-0.021,0.098,0.007,0.147-0.018c-0.003-0.033-0.056-0.036-0.075-0.06c0.04-0.014,0.032-0.041,0.033-0.07\r\n\t\t\t\tc-0.008-0.018-0.024-0.007-0.038-0.018c-0.01-0.017-0.02-0.034-0.03-0.051c-0.015-0.01-0.031-0.019-0.047-0.029\r\n\t\t\t\tc-0.088-0.043-0.195,0.005-0.197-0.102c-0.016-0.007-0.033-0.014-0.049-0.021c0.207-0.079,0.173-0.008,0.319,0\r\n\t\t\t\tc0.03-0.008,0.081-0.026,0.102-0.043c0.038-0.03,0.094-0.146,0.023-0.187c-0.046-0.027-0.126-0.019-0.183-0.035l-0.005,0.001\r\n\t\t\t\tc0,0,0-0.001-0.001-0.002c0.156-0.015,0.143-0.03,0.163-0.114c0.004-0.003,0.009-0.005,0.013-0.007c0.003,0,0.005,0,0.008,0\r\n\t\t\t\tc0.029,0.023,0.044,0.049,0.091,0.053c0.011,0.002,0.008-0.002,0.02-0.004c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.017-0.036-0.034-0.072-0.051-0.108c0.001-0.001,0.003-0.002,0.005-0.003c0.035,0.01,0.044,0.023,0.074,0.039\r\n\t\t\t\tc0.01,0.002,0.021,0.004,0.031,0.006c0.009,0.009,0.018,0.019,0.028,0.028c0.03,0.017,0.13,0.009,0.165-0.018\r\n\t\t\t\tc0.031-0.024,0.019-0.064,0.056-0.086c0.014-0.008,0.03-0.006,0.037,0.001c0.13-0.104-0.137-0.115-0.131-0.166\r\n\t\t\t\tc0.002-0.017,0.048-0.033,0.064-0.046c0.043-0.032,0.089-0.076,0.116-0.114c-0.009,0-0.018-0.001-0.027-0.001\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.004c0.05-0.023,0.021-0.065,0.001-0.1c0.055,0.009,0.141,0.024,0.224-0.01\r\n\t\t\t\tc-0.032,0.049-0.038,0.104-0.065,0.156c-0.017,0.033-0.065,0.069-0.066,0.104c0.008,0.011,0.016,0.021,0.024,0.032\r\n\t\t\t\tc0.015,0.03-0.047,0.071-0.007,0.098c0.021,0.016,0.068,0.009,0.106,0.008c0.001,0,0.002,0,0.002,0\r\n\t\t\t\tc-0.004-0.037,0.007-0.078-0.028-0.11c0.083-0.005,0.124-0.07,0.134-0.107c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.022,0.02,0.027,0.067,0.068,0.07c0.003,0,0.007,0,0.01,0c0.055-0.028,0.102-0.093,0.119-0.136\r\n\t\t\t\tc-0.006-0.004-0.012-0.009-0.018-0.013c0.001,0,0.002,0,0.003,0c0.045,0.009,0.167,0.05,0.2-0.008\r\n\t\t\t\tc0.002-0.031,0.004-0.063,0.006-0.094c0.012-0.023,0.053-0.042,0.051-0.069c0.004-0.047-0.125-0.031-0.121-0.087\r\n\t\t\t\tc0.012-0.034,0.201-0.025,0.247-0.027c0.022,0.013,0.039,0.036,0.067,0.044c0.065-0.002,0.086-0.04,0.101-0.069\r\n\t\t\t\tc0.032-0.059,0.046-0.123,0.077-0.184c0.014-0.028,0.029-0.056,0.043-0.085c0.008-0.022-0.001-0.073-0.025-0.093\r\n\t\t\t\tc-0.006-0.002-0.003-0.002-0.013-0.001c0.018-0.037,0.066-0.059,0.078-0.1c-0.014-0.01-0.028-0.02-0.042-0.03\r\n\t\t\t\tc-0.026-0.028-0.037-0.094-0.024-0.122c0.013-0.028,0.059-0.047,0.07-0.077c0.014-0.038-0.033-0.077-0.004-0.117\r\n\t\t\t\tc0.02-0.027,0.112-0.04,0.135-0.086c0.002-0.016,0.004-0.032,0.005-0.048c0.016-0.031,0.132-0.113,0.06-0.153\r\n\t\t\t\tc-0.023-0.013-0.064-0.006-0.096-0.01c-0.002,0-0.003,0.001-0.005,0.001c0.016-0.009,0.034-0.011,0.039-0.024\r\n\t\t\t\tc0.017-0.065-0.146-0.086-0.173-0.118c0.009-0.012,0.018-0.025,0.027-0.037c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.031,0.059,0.15,0.093,0.239,0.092c0.045,0,0.091-0.01,0.128-0.003c0.046,0.009,0.076,0.04,0.128,0.044\r\n\t\t\t\tc0.046,0.004,0.173-0.02,0.191-0.045c-0.003-0.044-0.086-0.053-0.114-0.083c0.091,0.005,0.077-0.035,0.134,0.031\r\n\t\t\t\tc0.041,0.007,0.101-0.012,0.116-0.034c0.001-0.052-0.066-0.084-0.058-0.137c0.005-0.005,0.011-0.01,0.016-0.015\r\n\t\t\t\tc0.03,0.025,0.076,0.076,0.147,0.053c0.075-0.023,0.014-0.08,0.073-0.109c0.046-0.014,0.093-0.029,0.139-0.043\r\n\t\t\t\tc0.048-0.025,0.083-0.063,0.134-0.089c0.033-0.013,0.065-0.027,0.098-0.04c0.023-0.014,0.024-0.037,0.052-0.051\r\n\t\t\t\tc0.052-0.027,0.165-0.104,0.16-0.147c0.013,0,0.026-0.001,0.039-0.001c0.009-0.007,0.007-0.015,0.014-0.021\r\n\t\t\t\tc0.024-0.02,0.098-0.01,0.069-0.046c-0.007-0.009-0.015-0.014-0.02-0.028c0.02-0.022,0.045-0.041,0.1-0.051\r\n\t\t\t\tc-0.003-0.01-0.007-0.02-0.01-0.03c0.004-0.01,0.018-0.015,0.036-0.02c0.005-0.043-0.016-0.072-0.045-0.098\r\n\t\t\t\tc0.008-0.035,0.079-0.049,0.107-0.077c0-0.029-0.031-0.052-0.063-0.055c0.037-0.037,0.131-0.031,0.146-0.078\r\n\t\t\t\tc-0.024-0.02-0.058-0.024-0.069-0.057c0.023-0.025,0.075-0.06,0.135-0.054c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.033-0.02-0.066-0.041-0.099-0.061c-0.089-0.081,0.158-0.142,0.204-0.197c-0.022,0.004-0.029,0-0.037-0.01\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.002c0,0,0-0.001-0.001-0.002c0.032-0.002,0.069,0.005,0.1-0.008\r\n\t\t\t\tc0.004-0.004,0.008-0.007,0.012-0.011c-0.001-0.024-0.034-0.036-0.057-0.044c-0.007-0.043,0.064-0.091,0.107-0.117\r\n\t\t\t\tc0.015,0.003,0.03,0.006,0.045,0.009c-0.008-0.04-0.016-0.08-0.024-0.12c-0.038,0.015-0.036,0.038-0.061,0.057\r\n\t\t\t\tc-0.04,0.031-0.1,0.067-0.155,0.09c-0.046,0.018-0.166,0.053-0.22,0.054c-0.055,0.001-0.099-0.006-0.169,0.007\r\n\t\t\t\tc-0.086,0.017-0.192,0.071-0.27,0.055c-0.009-0.018-0.019-0.035-0.028-0.053c-0.001,0-0.002,0-0.003,0.001\r\n\t\t\t\tc-0.072,0.055-0.152,0.123-0.2,0.186c-0.031,0.04-0.06,0.078-0.102,0.114c-0.038,0.032-0.043,0.082-0.099,0.107\r\n\t\t\t\tc-0.053,0.023-0.122,0.012-0.178,0.027c-0.003,0-0.006-0.001-0.008-0.002c-0.047-0.023-0.103,0.025-0.159,0.03\r\n\t\t\t\tc-0.014-0.012-0.007-0.021,0.003-0.032c0.022-0.023,0.056-0.047,0.12-0.051c0.022-0.001,0.054-0.002,0.075-0.013\r\n\t\t\t\tc0.068-0.034,0.046-0.111,0.096-0.141c0.031-0.019,0.151-0.057,0.162-0.078c0.014-0.025-0.022-0.049-0.044-0.053\r\n\t\t\t\tc-0.04,0.008-0.037,0.022-0.06,0.033l-0.116,0.034c-0.082,0.034-0.185,0.115-0.294,0.118c-0.015-0.011-0.018-0.03-0.038-0.036\r\n\t\t\t\tc-0.051,0.004-0.131,0.08-0.148,0.105c-0.006,0.001-0.012,0.001-0.018,0.002c-0.003,0-0.005,0-0.008,0\r\n\t\t\t\tc-0.046-0.074,0.259-0.214,0.154-0.309c-0.031-0.028-0.086-0.028-0.126-0.046c0.103-0.026,0.206-0.053,0.309-0.079\r\n\t\t\t\tc0.011-0.005,0.016-0.012,0.017-0.022c0.05-0.019,0.101-0.031,0.138-0.055c0.04-0.026,0.15-0.164,0.158-0.201\r\n\t\t\t\tc0.003-0.016-0.028-0.058-0.042-0.07c-0.016-0.014-0.044-0.019-0.068-0.024c-0.11-0.022-0.111,0.021-0.198,0.048\r\n\t\t\t\tc-0.092,0.028-0.168-0.001-0.196,0.069c-0.047,0.001-0.074-0.025-0.115-0.028c-0.045-0.003-0.093,0.034-0.122,0.047\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0c0,0,0-0.001-0.001-0.002c0.016-0.039,0.101-0.058,0.108-0.097c0.007-0.042-0.147-0.072-0.199-0.067\r\n\t\t\t\tc-0.027,0.007-0.053,0.015-0.08,0.022c-0.065,0.001-0.133-0.039-0.158-0.08c0.031-0.004,0.053,0.006,0.077,0.01\r\n\t\t\t\tc0.032,0.005,0.153,0.002,0.167-0.005c0.121,0.041,0.265,0.068,0.372,0.122c0.097-0.022,0.152-0.08,0.272-0.089\r\n\t\t\t\tc0.1-0.007,0.172,0.031,0.261,0.04c0.04-0.01,0.035-0.031,0.071-0.042c0.056,0.011,0.104,0.041,0.15,0.063\r\n\t\t\t\tc0.024,0.008,0.048,0.017,0.071,0.025c0.016,0.019,0.031,0.037,0.047,0.056c0.021,0.005,0.032-0.001,0.046,0.011\r\n\t\t\t\tc0.015,0.022,0.03,0.044,0.045,0.066c0.042,0.038,0.131,0.059,0.2,0.07c0.101,0.016,0.192,0.009,0.27-0.045\r\n\t\t\t\tc0.017-0.012,0.034-0.02,0.038-0.036c0.013-0.051-0.114-0.086-0.107-0.166c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.014,0.037,0.178,0.137,0.22,0.148c0.022,0.005,0.059,0.007,0.087-0.007c0.02-0.01,0.031-0.026,0.039-0.041\r\n\t\t\t\tc0.037-0.061-0.073-0.08-0.109-0.114c0.003-0.006,0.006-0.013,0.01-0.019c-0.026,0-0.033-0.018-0.043-0.033\r\n\t\t\t\tc-0.013-0.002-0.028,0-0.049,0.004c-0.004-0.04,0.038-0.112-0.07-0.076c0.009-0.016,0.01-0.032,0.012-0.052\r\n\t\t\t\tc-0.015,0.002-0.03,0.005-0.045,0.007c-0.002,0-0.004,0-0.005-0.001c-0.033-0.116-0.015-0.165-0.164-0.203\r\n\t\t\t\tc-0.003,0-0.005,0-0.008,0c-0.019,0.045-0.027,0.105-0.038,0.15c-0.001,0.001-0.003,0.002-0.004,0.003\r\n\t\t\t\tc-0.006-0.003-0.013-0.007-0.019-0.01c-0.004-0.025,0.002-0.056-0.014-0.084c-0.022-0.037-0.043-0.094-0.038-0.131\r\n\t\t\t\tc-0.051,0.012-0.061,0.058-0.095,0.08c-0.009-0.002-0.019-0.003-0.028-0.005c0-0.058-0.017-0.052-0.091-0.052\r\n\t\t\t\tc-0.013-0.02-0.001-0.032-0.007-0.054c-0.005-0.001-0.01-0.003-0.014-0.004c-0.012,0.001-0.02,0.003-0.029,0.007\r\n\t\t\t\tc-0.007-0.003-0.006-0.001-0.01-0.008c-0.053,0.01-0.081,0.001-0.126,0.003c-0.151,0.005-0.169,0.037-0.238-0.051\r\n\t\t\t\tc-0.041-0.009-0.201-0.016-0.26-0.004c-0.013,0.035-0.019,0.069-0.038,0.102c-0.018,0.027-0.037,0.054-0.055,0.08\r\n\t\t\t\tc-0.003,0.002-0.006,0.005-0.008,0.007c-0.027-0.016-0.116-0.06-0.103-0.103c0.009-0.015,0.038-0.018,0.056-0.029\r\n\t\t\t\tc0.021-0.013,0.084-0.093,0.073-0.115c-0.015-0.03-0.082-0.03-0.118-0.039c-0.039-0.01-0.067-0.043-0.116-0.041\r\n\t\t\t\tc-0.046,0.002-0.061,0.033-0.074,0.049c-0.018,0.016-0.035,0.032-0.053,0.048c-0.021,0.029-0.031,0.063-0.043,0.095\r\n\t\t\t\tc-0.007,0.002-0.013,0.004-0.019,0.005c-0.015-0.051-0.072-0.083-0.151-0.068c0,0,0-0.001-0.001-0.001\r\n\t\t\t\tc0.024-0.031,0.103-0.012,0.139-0.034c0.06-0.036,0.077-0.119,0.142-0.155c0.004-0.005,0.009-0.01,0.013-0.016\r\n\t\t\t\tc-0.078-0.016-0.155-0.032-0.243-0.04c-0.032,0.023-0.05,0.013-0.09,0.032c-0.021,0.015-0.043,0.03-0.064,0.045\r\n\t\t\t\tc-0.072,0.047-0.113,0.067-0.106,0.143c-0.023-0.003-0.035-0.007-0.05-0.017c-0.124-0.083,0.099-0.103,0.101-0.159\r\n\t\t\t\tc0.001-0.031-0.064-0.029-0.086-0.038c-0.002,0-0.004,0-0.005-0.001c0,0,0-0.001-0.001-0.002c0.065-0.02,0.17-0.047,0.208-0.018\r\n\t\t\t\tc0.055-0.015,0.091-0.086,0.101-0.119c0.002-0.012,0.004-0.024,0.007-0.036c0.019-0.029,0.096-0.064,0.136-0.084\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.005c-0.051-0.005-0.107-0.018-0.136-0.046c0.06,0.007,0.119,0.006,0.189,0.005\r\n\t\t\t\tc-0.007-0.017-0.02-0.023-0.032-0.034c-0.018-0.066,0.148-0.105,0.248-0.112c0.019-0.003,0.038-0.006,0.058-0.01\r\n\t\t\t\tc0.014,0.001,0.034,0.006,0.062-0.003c0.018-0.006,0.028-0.016,0.039-0.024c0.005,0.031-0.025,0.045-0.053,0.063\r\n\t\t\t\tc-0.039,0.004-0.2-0.007-0.232,0.033c0,0.003,0,0.005,0,0.008c0.038,0.019,0.086,0.056,0.135,0.064\r\n\t\t\t\tc0.063,0.01,0.146-0.01,0.22-0.012c0.032,0,0.063,0,0.095,0c0.05-0.056,0.09-0.128,0.108-0.194\r\n\t\t\t\tc0.015-0.005,0.03-0.001,0.047-0.002c0.036-0.002,0.135-0.04,0.152-0.052c0.047-0.035-0.09-0.189-0.128-0.197\r\n\t\t\t\tc-0.032-0.007-0.07-0.002-0.107-0.004c-0.059-0.004-0.24-0.04-0.269,0.031c0.007,0.018,0.019,0.023,0.032,0.034\r\n\t\t\t\tc0.001,0.002,0.001,0.003,0.002,0.005c-0.054,0.001-0.109,0.001-0.163,0.001c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc-0.006-0.034,0.037-0.085,0.002-0.115c-0.013-0.007-0.061,0.002-0.077,0c-0.003-0.017,0.025-0.026,0.044-0.033\r\n\t\t\t\tc0.024-0.05-0.082-0.091-0.112-0.123c0,0,0-0.001-0.001-0.002c0.049,0.003,0.087,0.023,0.143,0.019\r\n\t\t\t\tc0.08-0.005,0.117-0.075,0.219-0.082c0.053-0.003,0.078,0.028,0.129,0.024c0.015-0.006,0.029-0.012,0.044-0.018\r\n\t\t\t\tc0.076-0.037,0.128-0.084,0.117-0.15c-0.006-0.035-0.112-0.077-0.174-0.057c-0.075,0.034-0.15,0.068-0.225,0.101\r\n\t\t\t\tc-0.023,0.015-0.039,0.033-0.066,0.048c0.001-0.026,0.017-0.077,0-0.103c-0.026-0.042-0.069-0.068-0.087-0.113\r\n\t\t\t\tc-0.144,0.026-0.093,0.074-0.143,0.127c-0.101,0.032-0.174-0.025-0.264-0.018c0.036-0.037,0.154-0.006,0.199-0.003\r\n\t\t\t\tc0.004-0.001,0.008-0.001,0.012-0.002c0.006-0.013,0.012-0.027,0.018-0.04c0.021-0.034,0.052-0.065,0.088-0.093\r\n\t\t\t\tc-0.001-0.001-0.003-0.003-0.004-0.004c-0.015-0.008-0.041-0.006-0.061-0.008c-0.037-0.005-0.076-0.012-0.118-0.013\r\n\t\t\t\tc-0.078,0-0.163,0.02-0.217-0.003c0.044-0.008,0.061-0.02,0.074-0.039c-0.012-0.023-0.076-0.028-0.104-0.037\r\n\t\t\t\tc-0.001-0.002-0.001-0.004-0.002-0.006c0.057-0.01,0.172,0.001,0.217,0.01c0.051,0.011,0.098,0.041,0.167,0.033\r\n\t\t\t\tc0.034-0.018,0.074-0.065,0.132-0.048c0.029,0.008,0.042,0.034,0.072,0.043c0.067-0.007,0.093-0.07,0.062-0.117\r\n\t\t\t\tc-0.04-0.061-0.125-0.079-0.182-0.12c-0.022-0.016-0.009-0.05-0.031-0.062c-0.042-0.024-0.124,0-0.196,0.004\r\n\t\t\t\tc-0.024-0.002-0.048-0.003-0.073-0.005c-0.041,0.002-0.072,0.028-0.098,0.039c-0.039,0.016-0.082,0.03-0.131,0.042\r\n\t\t\t\tc0-0.001-0.001-0.002-0.001-0.003c0.069-0.022,0.084-0.061,0.131-0.091c0.041-0.027,0.109-0.044,0.145-0.073\r\n\t\t\t\tc0.016-0.013,0.031-0.04,0.007-0.058c-0.01-0.007-0.041-0.008-0.068-0.013c0.057-0.028,0.115-0.055,0.172-0.083\r\n\t\t\t\tc0.024,0.008,0.048,0.016,0.072,0.024c0.029,0.02,0.058,0.041,0.086,0.062c0.003,0.001,0.006,0.001,0.008,0.002\r\n\t\t\t\tc0.003-0.003,0.005-0.005,0.008-0.008c-0.002-0.029-0.048-0.05-0.072-0.066c-0.018-0.012-0.036-0.025-0.053-0.037\r\n\t\t\t\tC24.16,6.946,27.965,6,32,6c4.819,0,9.317,1.335,13.186,3.62c-0.129,0.065-0.246,0.164-0.324,0.268\r\n\t\t\t\tc-0.048-0.001-0.132-0.022-0.153-0.019c-0.081,0.013-0.199,0.161-0.229,0.229c-0.013,0.013-0.025,0.025-0.038,0.038\r\n\t\t\t\tc0.039,0.028,0.075,0.062,0.102,0.102c-0.098,0.069-0.24,0.035-0.292,0.153c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc0.032,0.03,0.064,0.059,0.095,0.089c-0.004,0.027-0.008,0.055-0.013,0.083c-0.383-0.001-0.322,0.111-0.547,0.216v0.006\r\n\t\t\t\tc0.208,0.251,0.238,0.04,0.521,0.089c0.13,0.023,0.226,0.096,0.343,0.121c0.109-0.061,0.161-0.161,0.248-0.241\r\n\t\t\t\tc-0.002-0.025-0.004-0.051-0.006-0.076c-0.034-0.021-0.068-0.042-0.102-0.064c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.023-0.023,0.047-0.047,0.07-0.07c0.074,0.003,0.112,0.025,0.159,0.051c0.055-0.058,0.136-0.114,0.197-0.165v-0.013\r\n\t\t\t\tc-0.021-0.017-0.042-0.034-0.064-0.051c-0.013-0.017-0.002-0.045,0.006-0.076c0.015-0.013,0.03-0.026,0.044-0.038\r\n\t\t\t\tc0.107,0.001,0.27,0.047,0.356,0.006c0.036-0.028,0.072-0.055,0.108-0.083c0.021-0.023,0.042-0.047,0.063-0.07\r\n\t\t\t\tc-0.028-0.015-0.055-0.03-0.083-0.045c0.009-0.043,0.048-0.077,0.099-0.106c0.83,0.518,1.632,1.072,2.395,1.677\r\n\t\t\t\tc-0.005,0.025-0.011,0.05-0.016,0.075c-0.049,0.083-0.097,0.165-0.146,0.248c-0.135,0.174-0.528,0.182-0.464,0.489\r\n\t\t\t\tc0.053,0.004,0.106,0.008,0.159,0.013c0.135,0.378-0.104,0.29-0.146,0.515c0.07,0.108,0.28,0.064,0.369,0.153\r\n\t\t\t\tc0.03,0.036-0.002,0.112,0.013,0.165c0.035,0.124,0.135,0.168,0.286,0.146c-0.018,0.094-0.114,0.264-0.184,0.311\r\n\t\t\t\tc-0.016,0.013-0.038,0.014-0.07,0.013c-0.378-0.351-0.896-0.546-1.468-0.705c-0.123-0.034-0.46-0.13-0.635-0.089\r\n\t\t\t\tc-0.081,0.019-0.116,0.1-0.184,0.134c-0.002,0.004-0.004,0.008-0.006,0.013c0.061,0.078,0.123,0.157,0.184,0.235\r\n\t\t\t\tc-0.01,0.223-0.12,0.179-0.292,0.203c-0.021,0.033-0.037,0.114-0.051,0.146c-0.095,0.048-0.191-0.018-0.216-0.089\r\n\t\t\t\tc0.03-0.038,0.059-0.076,0.089-0.115c-0.178-0.082-0.286-0.093-0.451,0.032c-0.042,0.034-0.085,0.068-0.127,0.102\r\n\t\t\t\tc-0.1,0.03-0.176-0.034-0.235-0.051c-0.105-0.03-0.28-0.002-0.362,0.032c-0.091,0.037-0.088,0.172-0.172,0.222\r\n\t\t\t\tc-0.028-0.015-0.037-0.02-0.044-0.057c-0.182,0.003-0.224,0.07-0.375,0.019c0-0.05,0.007-0.062,0.025-0.089\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0-0.097,0.017-0.161,0.026-0.235c-0.381-0.002-0.167,0.2-0.419,0.248\r\n\t\t\t\tc-0.006-0.002-0.013-0.004-0.019-0.006c-0.011-0.034-0.021-0.068-0.032-0.102c-0.133,0.055-0.267,0.11-0.4,0.165\r\n\t\t\t\tc-0.226,0.09-0.453,0.187-0.661,0.273c-0.051,0.015-0.102,0.03-0.153,0.045c-0.087,0.07-0.049,0.285-0.14,0.349\r\n\t\t\t\tc-0.057,0.011-0.115,0.021-0.172,0.032c-0.341,0.069-0.427-0.091-0.629-0.248c0.041-0.201,0.281-0.195,0.508-0.203\r\n\t\t\t\tc-0.055-0.114-0.169-0.349-0.305-0.375c-0.097,0.009-0.195,0.017-0.292,0.025c-0.082-0.018-0.133-0.053-0.216-0.032\r\n\t\t\t\tc-0.017,0.148,0.159,0.164,0.121,0.337c-0.051,0.081-0.102,0.161-0.152,0.241c-0.004,0.004-0.009,0.009-0.013,0.013\r\n\t\t\t\tc0.034,0.051,0.079,0.078,0.153,0.089c0.079,0.238,0.029,0.214-0.032,0.407c-0.006,0.036-0.013,0.072-0.019,0.108v0.013\r\n\t\t\t\tc-0.166-0.008-0.335-0.211-0.566-0.184c-0.124,0.261-0.492,0.237-0.661,0.445c0.005,0.173,0.26,0.294,0.14,0.47\r\n\t\t\t\tc-0.034-0.011-0.068-0.021-0.102-0.032c-0.071,0.008-0.14,0.046-0.235,0.019c-0.217-0.062-0.433-0.161-0.604-0.267\r\n\t\t\t\tc-0.103,0-0.1,0.078-0.153,0.127c0.003,0.063,0.126,0.201,0.191,0.229c0.057,0.024,0.137-0.001,0.191,0.006\r\n\t\t\t\tc0.15,0.265-0.1,0.247-0.261,0.21c-0.072-0.016-0.157,0.001-0.21-0.032c-0.029-0.021-0.053-0.077-0.064-0.114\r\n\t\t\t\tc-0.076-0.038-0.207-0.014-0.292-0.057c-0.043-0.022-0.208-0.444-0.216-0.527c0.122-0.036,0.163-0.19,0.07-0.292\r\n\t\t\t\tc-0.066-0.072-0.223-0.087-0.305-0.14c-0.136-0.088-0.245-0.222-0.362-0.33c0.221-0.112,0.253,0.089,0.343,0.14\r\n\t\t\t\tc0.07,0.011,0.14,0.021,0.21,0.032c0.5,0.15,1.305,0.524,1.831,0.127c0.111-0.084,0.24-0.161,0.235-0.343\r\n\t\t\t\tc-0.069-0.069-0.081-0.106-0.076-0.242c-0.091-0.072-0.211-0.158-0.331-0.197c-0.127-0.038-0.254-0.076-0.381-0.115\r\n\t\t\t\tc-0.121-0.102-0.242-0.203-0.362-0.305c-0.068-0.021-0.136-0.042-0.203-0.063c-0.108-0.038-0.216-0.076-0.324-0.114\r\n\t\t\t\tc-0.18-0.013-0.36-0.025-0.54-0.038c-0.03,0.023-0.059,0.047-0.089,0.07c-0.004-0.046-0.008-0.093-0.013-0.14\r\n\t\t\t\tc-0.183-0.035-0.345-0.068-0.35-0.28c-0.061,0.036-0.123,0.072-0.184,0.108c-0.046,0.019-0.103,0.021-0.14,0.044\r\n\t\t\t\tc-0.114-0.074-0.219-0.036-0.369-0.025c-0.066-0.103-0.205-0.127-0.28-0.222c0.237,0.002,0.468,0.029,0.591-0.095\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.028-0.017-0.055-0.034-0.083-0.051c-0.065-0.023-0.14,0.003-0.191-0.019\r\n\t\t\t\tc-0.106-0.045-0.177-0.123-0.299-0.159c-0.07,0.062-0.137,0.151-0.152,0.267c-0.04-0.008-0.081-0.017-0.121-0.025\r\n\t\t\t\tc0.041-0.129,0.058-0.18,0.127-0.279c-0.05-0.066-0.162-0.027-0.242-0.013c-0.045,0.144-0.117,0.243-0.248,0.305\r\n\t\t\t\tc-0.004-0.093-0.008-0.187-0.013-0.28c-0.139,0.095-0.322,0.263-0.388,0.426c-0.017-0.002-0.034-0.004-0.051-0.006\r\n\t\t\t\tc-0.001-0.246,0.115-0.269,0.216-0.4c-0.281-0.021-0.326,0.061-0.47,0.203c-0.031,0.023-0.079-0.012-0.121,0.013\r\n\t\t\t\tc-0.073,0.044-0.144,0.185-0.172,0.273c-0.187-0.096-0.28-0.273-0.381,0.083c-0.042-0.036-0.085-0.072-0.127-0.108\r\n\t\t\t\tc-0.006-0.002-0.013-0.004-0.019-0.006c-0.048,0.076-0.089,0.121-0.203,0.134c-0.027,0.103-0.078,0.174-0.153,0.229\r\n\t\t\t\tc0.014-0.069,0.027-0.136,0.051-0.191c-0.004-0.011-0.008-0.021-0.013-0.032c-0.006-0.004-0.013-0.008-0.019-0.013\r\n\t\t\t\tc-0.084,0.046-0.148,0.229-0.197,0.311c-0.135-0.012-0.165-0.08-0.299-0.032c-0.025-0.021-0.051-0.042-0.076-0.063\r\n\t\t\t\tc-0.061,0.246-0.091,0.112-0.216,0.203c-0.066,0.048-0.033,0.116-0.146,0.153c-0.019,0.021-0.038,0.042-0.057,0.063\r\n\t\t\t\tc0.026,0.021,0.051,0.042,0.076,0.064v0.006c-0.036,0.051-0.106,0.052-0.172,0.038c0.011,0.047,0.021,0.093,0.032,0.14\r\n\t\t\t\tc-0.019,0.028-0.038,0.055-0.057,0.083c-0.006,0.004-0.013,0.009-0.019,0.013c-0.046-0.028-0.064-0.041-0.089-0.089h-0.006\r\n\t\t\t\tc-0.065,0.006-0.07,0.078-0.133,0.102c-0.009,0.027,0.014,0.055,0.044,0.076v0.038c-0.054,0.016-0.077,0.025-0.102,0.07\r\n\t\t\t\tc-0.041-0.01-0.074-0.026-0.127-0.032c-0.044,0.035-0.058,0.078-0.121,0.095c0.011,0.038,0.019,0.052,0.057,0.064\r\n\t\t\t\tc-0.034,0.075-0.199,0.095-0.273,0.134c-0.006,0.004-0.013,0.008-0.019,0.013c0.021,0.036,0.042,0.072,0.064,0.108v0.006\r\n\t\t\t\tc-0.065,0.004-0.112,0.01-0.178,0.006c-0.021,0.034-0.042,0.068-0.063,0.102c0.042,0.051,0.093,0.07,0.127,0.134v0.006\r\n\t\t\t\tc-0.042,0.006-0.085,0.013-0.127,0.019c-0.006,0.042-0.013,0.085-0.019,0.127c-0.163-0.038-0.167,0.098-0.229,0.21\r\n\t\t\t\tc0.021,0.006,0.042,0.013,0.064,0.019c0.002,0.044,0.004,0.089,0.006,0.133c-0.05,0.003-0.081,0.005-0.121-0.006\r\n\t\t\t\tc-0.075,0.075-0.123,0.164-0.203,0.235c0.006,0.019,0.013,0.038,0.019,0.057v0.006c-0.063,0.046-0.087,0.015-0.159,0\r\n\t\t\t\tc-0.094,0.045-0.266,0.185-0.311,0.28c-0.006,0.034-0.013,0.068-0.019,0.102c-0.039,0.065-0.125,0.084-0.159,0.165\r\n\t\t\t\tc-0.006,0.004-0.013,0.009-0.019,0.013c-0.019-0.013-0.038-0.026-0.057-0.038c-0.08-0.054-0.225,0.137-0.222,0.242\r\n\t\t\t\tc-0.085-0.036-0.205-0.032-0.337-0.032l-0.032,0.032c0.017,0.072,0.086,0.103,0.159,0.114c-0.063,0.075-0.159,0.014-0.267,0.006\r\n\t\t\t\tc-0.021,0.084-0.011,0.111-0.089,0.14c-0.1-0.04-0.144,0.042-0.248,0.076c-0.002,0.017-0.004,0.034-0.006,0.051\r\n\t\t\t\tc0.025,0.034,0.072,0.048,0.108,0.07v0.025c-0.066,0.004-0.131,0.008-0.197,0.013c-0.025,0.075-0.001,0.151-0.038,0.21\r\n\t\t\t\tc0.034,0.046,0.043,0.085,0.102,0.108c0.002,0.004,0.004,0.008,0.006,0.013c-0.056,0.046-0.091,0.058-0.114,0.14\r\n\t\t\t\tc0.004,0.011,0.008,0.021,0.013,0.032c0.041,0.028,0.07,0.034,0.121,0.013c0.011,0.013,0.021,0.025,0.032,0.038\r\n\t\t\t\tc-0.041,0.034-0.089,0.076-0.127,0.114c0.053,0.078,0.112,0.033,0.222,0.045c-0.007,0.055-0.021,0.092-0.07,0.108\r\n\t\t\t\tc-0.008,0.011-0.017,0.021-0.025,0.032c0.015,0.013,0.03,0.025,0.044,0.038c0.06-0.001,0.086-0.014,0.127-0.032\r\n\t\t\t\tc-0.027,0.037-0.064,0.055-0.127,0.057c0.001,0.016-0.001,0.007,0.006,0.025c-0.032,0.014-0.05,0.004-0.083-0.013v0.038h-0.006\r\n\t\t\t\tc-0.004-0.017-0.008-0.034-0.013-0.051c-0.002-0.004-0.004-0.008-0.006-0.013c-0.025,0.03-0.051,0.059-0.076,0.089\r\n\t\t\t\tc0.008,0.03,0.017,0.059,0.025,0.089c0.011,0.006,0.021,0.013,0.032,0.019c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032c0.051-0.002,0.06-0.014,0.095-0.026c-0.002-0.025-0.004-0.051-0.006-0.076\r\n\t\t\t\tc0.025,0.019,0.035,0.027,0.038,0.07h0.006c0.028-0.025,0.055-0.051,0.083-0.076c-0.018,0.039-0.04,0.052-0.064,0.083\r\n\t\t\t\tc0.032,0.02,0.042,0.024,0.089,0.019v0.007c-0.038,0.021-0.076,0.042-0.114,0.063c-0.009,0.028-0.004,0.013,0.006,0.045\r\n\t\t\t\tc0.046,0.033,0.031,0.018,0.102,0.013v0.006c-0.036,0.006-0.042,0.012-0.057,0.038c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.036-0.022-0.065-0.056-0.089-0.019c-0.006,0.004-0.013,0.008-0.019,0.013c-0.002-0.019-0.004-0.038-0.006-0.057\r\n\t\t\t\tc-0.017-0.002-0.034-0.004-0.051-0.006c0.015,0.05-0.003,0.072-0.025,0.114c0.019,0.038,0.038,0.076,0.057,0.114\r\n\t\t\t\tc0.123,0.036,0.19,0.086,0.305,0.115c-0.013,0.013-0.026,0.025-0.038,0.038c0.013,0.008,0.025,0.017,0.038,0.025\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.03,0.015,0.042,0.019,0.051,0.057c0.07,0.017,0.282-0.01,0.349-0.044\r\n\t\t\t\tc0.108-0.107,0.244-0.176,0.356-0.28c0.039-0.036,0.039-0.072,0.095-0.095c0.038-0.02,0.087,0.023,0.14-0.013\r\n\t\t\t\tc0.062-0.046,0.08-0.127,0.083-0.222c0.015-0.011,0.03-0.021,0.044-0.032c0.012,0.047,0.011,0.056-0.013,0.089\r\n\t\t\t\tc0.053,0.074,0.056,0.142,0.165,0.095c0.004,0.002,0.008,0.004,0.013,0.006c0.006,0.051-0.02,0.065-0.032,0.114\r\n\t\t\t\tc0.052,0.027,0.057,0.174,0.057,0.248c0.019-0.002,0.038-0.004,0.057-0.007c0.002,0.017,0.004,0.034,0.006,0.051\r\n\t\t\t\tc0.048-0.012,0.047-0.013,0.089,0c0.008,0.048-0.026,0.118-0.044,0.165c0.047,0.06,0.08,0.086,0.076,0.203\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.049,0.164,0.149,0.23,0.242,0.324c-0.004,0.017-0.009,0.034-0.013,0.051\r\n\t\t\t\tc-0.019-0.002-0.038-0.004-0.057-0.006c0.002,0.017,0.004,0.034,0.006,0.051c-0.021,0.011-0.042,0.021-0.064,0.032\r\n\t\t\t\tc0.042,0.083,0.088,0.169,0.159,0.222c-0.016,0.061-0.039,0.075-0.051,0.134c0.151,0.032,0.257-0.029,0.381,0\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.037-0.032,0.005-0.05-0.019-0.089c0.023-0.06,0.036-0.108,0.095-0.133\r\n\t\t\t\tc0.019-0.011,0.012-0.005,0.038,0.006c0.004-0.017,0.009-0.034,0.013-0.051c0.11,0.001,0.175-0.008,0.254-0.025\r\n\t\t\t\tc0.021,0.015,0.042,0.03,0.064,0.045c0.004,0.004,0.008,0.008,0.013,0.013c0.059-0.108,0.119-0.216,0.178-0.324\r\n\t\t\t\tc0.002-0.04,0.004-0.08,0.006-0.121c0.011-0.057,0.039-0.09,0.057-0.133c0.016-0.027-0.011-0.058,0.006-0.102\r\n\t\t\t\tc-0.015-0.006-0.03-0.013-0.045-0.019V18.53h0.064c0.095-0.071-0.057-0.253-0.07-0.318c0.059-0.002,0.119-0.004,0.178-0.006\r\n\t\t\t\tc0.002-0.013,0.004-0.025,0.006-0.038c0.176,0.031,0.106-0.133,0.191-0.165v0.095c0.002,0.002,0.004,0.004,0.006,0.006\r\n\t\t\t\tc0.019-0.002,0.038-0.004,0.057-0.006c0.014-0.068,0.052-0.091,0.114-0.108c-0.004-0.021-0.008-0.042-0.013-0.064\r\n\t\t\t\tc0.027-0.002,0.055-0.004,0.083-0.006c-0.002-0.011-0.004-0.021-0.006-0.032c-0.002-0.004-0.004-0.008-0.006-0.013h-0.032v0.032\r\n\t\t\t\tc-0.102-0.041-0.174,0.062-0.28,0.045c-0.111-0.019-0.163-0.137-0.299-0.095H32.8c0.009-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.037-0.04,0.304,0.049,0.369,0.083c0.082,0.043,0.287-0.119,0.311-0.153h0.057c-0.002-0.095-0.048-0.099-0.07-0.178\r\n\t\t\t\tc-0.126-0.018-0.206-0.104-0.248-0.203c-0.025,0.002-0.051,0.004-0.076,0.006c-0.038-0.015-0.062-0.043-0.133-0.045\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.046-0.039-0.052-0.296-0.025-0.4c0.023-0.006,0.047-0.013,0.07-0.019\r\n\t\t\t\tc0.055-0.173,0-0.204-0.019-0.356c0.038,0.013,0.076,0.025,0.114,0.038c0.021-0.028,0.042-0.055,0.064-0.083\r\n\t\t\t\tc0.016-0.027-0.004-0.073-0.013-0.115h0.127c0.08-0.112,0.117-0.111,0.222-0.191c0.05-0.038,0.05-0.096,0.114-0.127\r\n\t\t\t\tc0.023,0.015,0.047,0.03,0.07,0.044c0.099-0.068,0.199-0.136,0.299-0.203c0.071-0.087,0.077-0.196,0.184-0.248\r\n\t\t\t\tc0.004-0.006,0.008-0.013,0.013-0.019c-0.034-0.052-0.095-0.08-0.121-0.133c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.053-0.023,0.128-0.081,0.152-0.133c0.023-0.036-0.022-0.072-0.044-0.102c0.077-0.104,0.108-0.037,0.184-0.095\r\n\t\t\t\tc0.091-0.069,0.094-0.193,0.21-0.248c0.051,0.034,0.102,0.068,0.153,0.102c0.022,0.014,0.223-0.034,0.305-0.032\r\n\t\t\t\tc0.078,0.06,0.117,0.113,0.261,0.115c0.011,0.019,0.021,0.038,0.032,0.057c0.014,0.037-0.006,0.12-0.019,0.159\r\n\t\t\t\tc0.017,0.019,0.034,0.038,0.051,0.057c0.013,0.018,0.009,0.038,0.006,0.076c-0.04-0.002-0.081-0.004-0.121-0.006\r\n\t\t\t\tc-0.098,0.028-0.543,0.488-0.61,0.585h-0.032c-0.013-0.019-0.025-0.038-0.038-0.057v-0.013c-0.09,0.094-0.016,0.207-0.159,0.28\r\n\t\t\t\tc-0.059-0.024-0.1-0.032-0.159-0.013c0.004,0.027,0.008,0.055,0.013,0.083c-0.073,0.067-0.121,0.102-0.153,0.216\r\n\t\t\t\tc0.026,0.023,0.063,0.043,0.089,0.064c0,0.094-0.02,0.143-0.032,0.216c0.034,0.053,0.068,0.106,0.102,0.159\r\n\t\t\t\tc-0.008,0.04-0.017,0.08-0.025,0.121c-0.035,0.188-0.011,0.31,0.127,0.381c0.058,0.03,0.07,0.065,0.146,0.038l-0.006,0.076\r\n\t\t\t\tc0.053-0.018,0.094-0.039,0.172-0.038c-0.011,0.023-0.021,0.047-0.032,0.07c0.02,0.042,0.039,0.071,0.083,0.089\r\n\t\t\t\tc0.067,0.051,0.193-0.016,0.235-0.038v0.026c0.065-0.014,0.081-0.027,0.133,0c0.043-0.058,0.077-0.069,0.153-0.095\r\n\t\t\t\tc0.004,0.008,0.008,0.017,0.013,0.025c0.051-0.028,0.141-0.037,0.165-0.095c0.027,0.019,0.055,0.038,0.083,0.057h0.006\r\n\t\t\t\tc0.017-0.083,0.1-0.04,0.152-0.083c0.028-0.017,0.04-0.057,0.045-0.095v0.057c0.036,0.013,0.072,0.025,0.108,0.038\r\n\t\t\t\tc0.026-0.027,0.034-0.043,0.083-0.051c0.021,0.013,0.042,0.025,0.064,0.038c0.059-0.057,0.198-0.098,0.299-0.108\r\n\t\t\t\tc0.008-0.015,0.017-0.03,0.025-0.045c0.029-0.003-0.01,0.079-0.019,0.114c0.148,0.215,0.345-0.041,0.489,0.229\r\n\t\t\t\tc-0.015,0.011-0.03,0.021-0.045,0.032c-0.094-0.003-0.14-0.044-0.222-0.07c-0.076,0.006-0.1,0.066-0.14,0.108\r\n\t\t\t\tc-0.053-0.012-0.053-0.037-0.102-0.025c-0.016,0.027-0.014,0.015-0.006,0.045c-0.031,0.029-0.052,0.003-0.076-0.025\r\n\t\t\t\tc-0.013,0.002-0.025,0.004-0.038,0.006c-0.004,0.015-0.008,0.03-0.013,0.045c0.032,0.038,0.067,0.051,0.064,0.108\r\n\t\t\t\tc-0.008-0.008-0.017-0.017-0.025-0.025c-0.018-0.007-0.058,0.067-0.108,0.064c-0.163-0.011-0.296-0.042-0.451-0.07\r\n\t\t\t\tc-0.078-0.014-0.166,0.024-0.203-0.006c-0.017,0.015-0.034,0.03-0.051,0.044c-0.049-0.011-0.098-0.021-0.146-0.032\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.013,0.045c-0.044-0.007-0.062,0.006-0.102-0.006c-0.085,0.046-0.145,0.095-0.28,0.102\r\n\t\t\t\tc0.006,0.043,0.013,0.056-0.025,0.07c0.023,0.062,0.023,0.099,0.044,0.165c0.022,0,0.035-0.011,0.057-0.026\r\n\t\t\t\tc-0.002,0.057-0.004,0.115-0.006,0.172c0.057,0.016,0.08,0.031,0.121,0.051c0.025-0.023,0.051-0.047,0.076-0.07\r\n\t\t\t\tc0.013,0.009,0.025,0.017,0.038,0.025c-0.021,0.16-0.09,0.268-0.038,0.451c-0.041,0.106-0.222,0.17-0.324,0.076\r\n\t\t\t\tc-0.015-0.04-0.03-0.081-0.044-0.121c-0.047-0.034-0.093-0.068-0.14-0.102v-0.044c-0.113,0.004-0.154,0.056-0.267,0.057\r\n\t\t\t\tc-0.034,0.043-0.068,0.085-0.102,0.127c-0.002,0.044-0.004,0.089-0.006,0.133c-0.032,0.025-0.064,0.051-0.095,0.076\r\n\t\t\t\tc-0.068,0.143,0.034,0.501,0.064,0.578c-0.009,0.025,0,0,0.013,0.025c-0.011,0.002-0.021,0.004-0.032,0.006\r\n\t\t\t\tc0.011,0.035,0.018,0.047,0.013,0.089c-0.081,0.046-0.249,0.013-0.362,0.007c-0.016,0.05-0.021,0.111-0.025,0.165\r\n\t\t\t\tc-0.125,0.066-0.209,0.161-0.388,0.095c-0.009-0.053-0.026-0.086-0.051-0.121c0.005-0.087-0.213-0.034-0.28-0.013\r\n\t\t\t\tc-0.291,0.091-0.499,0.261-0.852,0.286c0.004,0.069,0.012,0.088,0.013,0.146c-0.08-0.028-0.139-0.055-0.21-0.083\r\n\t\t\t\tc-0.004-0.036-0.008-0.072-0.013-0.108c-0.081-0.042-0.175,0.016-0.222-0.121c-0.058-0.004-0.427,0.12-0.458,0.197h-0.07\r\n\t\t\t\tc-0.004-0.013-0.009-0.025-0.013-0.038h-0.006c-0.033,0.022-0.061,0.024-0.095,0.013c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.045-0.038,0.069-0.048,0.102-0.102c-0.006-0.013-0.013-0.025-0.019-0.038c-0.049,0.004-0.097,0.009-0.146,0.013\r\n\t\t\t\tc-0.057-0.013-0.065-0.053-0.121-0.025c-0.014-0.043-0.014-0.04-0.064-0.038c0.059-0.095-0.063-0.185-0.133-0.21\r\n\t\t\t\tc0.013-0.092,0.038-0.176,0.089-0.229c-0.006-0.011-0.013-0.021-0.019-0.032c0.028-0.002,0.055-0.004,0.083-0.006\r\n\t\t\t\tc0.023-0.081,0.102-0.094,0.064-0.191c0.021-0.011,0.042-0.021,0.064-0.032c0.013,0.017,0.025,0.034,0.038,0.051\r\n\t\t\t\tc0.019-0.007,0.038-0.013,0.057-0.019c0.011-0.02,0.068-0.131,0.038-0.159c-0.051-0.002-0.102-0.004-0.153-0.006\r\n\t\t\t\tc-0.032-0.019-0.031-0.102-0.032-0.153c-0.068-0.033-0.163-0.022-0.254-0.019c-0.006,0.053-0.013,0.106-0.019,0.159\r\n\t\t\t\tc-0.013,0.014-0.02,0.015-0.044,0.019c-0.013-0.03-0.025-0.059-0.038-0.089c-0.049,0.026-0.056,0.1-0.095,0.121\r\n\t\t\t\tc-0.035,0.019-0.1-0.034-0.133-0.032c-0.071,0.107,0.012,0.181,0.019,0.286c-0.031,0.04-0.055,0.066-0.076,0.121\r\n\t\t\t\tc0.017,0.008,0.034,0.017,0.051,0.025c0.008-0.011,0.017-0.021,0.025-0.032c0.03,0.025,0.028,0.047,0.083,0.051\r\n\t\t\t\tc0.009,0.061-0.008,0.193,0.006,0.242c0.015,0.052,0.078,0.085,0.095,0.146c-0.028,0.028-0.059,0.044-0.108,0.051\r\n\t\t\t\tc0.012,0.043,0.042,0.03,0.095,0.025c-0.011,0.017-0.017,0.019-0.032,0.032c0.015,0.015,0.03,0.03,0.045,0.044\r\n\t\t\t\tc-0.011,0.008-0.021,0.017-0.032,0.025c0.002,0.011,0.004,0.021,0.006,0.032c0.023,0.011,0.047,0.021,0.07,0.032\r\n\t\t\t\tc-0.046,0.024-0.104,0.005-0.159,0c-0.019,0.061-0.035,0.076-0.006,0.133c-0.032-0.011-0.063-0.021-0.095-0.032\r\n\t\t\t\tc0.008,0.019,0.017,0.038,0.025,0.057c-0.006,0.008-0.013,0.017-0.019,0.025c-0.006,0.002-0.013,0.004-0.019,0.006\r\n\t\t\t\tc-0.006-0.004-0.013-0.008-0.019-0.013c-0.005-0.039-0.011-0.061-0.025-0.108c-0.107-0.001-0.208,0.008-0.28,0.038\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.008,0.049,0.031,0.043,0.057,0.07c-0.002,0.006-0.004,0.013-0.006,0.019h-0.025\r\n\t\t\t\tc-0.023-0.022-0.063-0.046-0.076-0.076c-0.123-0.051-0.317,0.05-0.413,0.083c-0.013,0.055-0.013,0.076-0.013,0.146\r\n\t\t\t\tc0.027,0.002,0.055,0.004,0.083,0.006c-0.015,0.024-0.023,0.03-0.025,0.07c0.024,0.016,0.034,0.024,0.076,0.026\r\n\t\t\t\tc-0.013,0.071-0.047,0.063-0.076,0.108c-0.051,0.033-0.092-0.002-0.165-0.013c0.015-0.036,0.015-0.051,0.013-0.108\r\n\t\t\t\tc0.026,0.002,0.019,0.001,0.044-0.006c0.006-0.013,0.013-0.025,0.019-0.038c-0.018-0.035-0.039-0.055-0.07-0.076\r\n\t\t\t\tc-0.032,0.008-0.064,0.017-0.095,0.026c-0.038,0.095-0.076,0.191-0.114,0.286c-0.074,0.064-0.148,0.127-0.222,0.191\r\n\t\t\t\tc0.032,0.014,0.055,0.038,0.07,0.07c-0.053,0.064-0.14-0.005-0.216,0.025c-0.055,0.036-0.11,0.072-0.165,0.108\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.007c-0.047,0.023-0.093,0.047-0.14,0.07c-0.038,0.119,0.011,0.258-0.089,0.324\r\n\t\t\t\tc-0.114,0.075-0.266,0.05-0.349,0.153c-0.002,0.013-0.004,0.025-0.006,0.038c0.021,0.006,0.042,0.013,0.064,0.019\r\n\t\t\t\tc-0.12,0.118-0.282-0.026-0.426,0.044c-0.023-0.044-0.033-0.075-0.025-0.14c-0.075,0.012-0.121,0.009-0.203,0\r\n\t\t\t\tc0.011,0.077,0.049,0.161,0.108,0.191c-0.002,0.083-0.013,0.145,0.025,0.197c-0.024,0.019-0.065,0.026-0.108,0.025v-0.044\r\n\t\t\t\tc-0.055,0.027-0.204,0.061-0.273,0.057c-0.028-0.036-0.055-0.072-0.083-0.108c-0.045,0.004-0.089,0.008-0.133,0.013\r\n\t\t\t\tc-0.006,0.015-0.013,0.03-0.019,0.044c-0.024,0.015-0.108,0.007-0.108,0.007c-0.004-0.004-0.009-0.009-0.013-0.013\r\n\t\t\t\tc-0.076,0.006-0.132,0.063-0.222,0.063c-0.002,0.028-0.004,0.055-0.006,0.083c0.038-0.014,0.077-0.021,0.133-0.019\r\n\t\t\t\tc-0.015,0.03-0.018,0.038-0.057,0.045c-0.01,0.017,0.037,0.021,0.057,0.025c0.002,0.009,0.004,0.017,0.006,0.025v0.006\r\n\t\t\t\tc-0.038,0.006-0.076,0.013-0.114,0.019c0.018,0.035,0.065,0.028,0.089,0.057c0.002,0.011,0.004,0.021,0.006,0.032\r\n\t\t\t\tc0.154-0.013,0.334,0.029,0.445,0.127c0.028-0.009,0.055-0.017,0.083-0.025c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc-0.011,0.021-0.021,0.043-0.032,0.064c0.036,0.046,0.118,0.075,0.165,0.108c-0.011,0.023-0.021,0.046-0.032,0.07\r\n\t\t\t\tc0.04,0.049,0.08,0.097,0.121,0.146c0.135,0.068,0.112,0,0.184,0.153c-0.021,0.04-0.045,0.073-0.051,0.127\r\n\t\t\t\tc0.051,0.067,0.112,0.106,0.133,0.203c-0.034-0.042-0.068-0.085-0.102-0.127h-0.006c-0.04,0.073-0.053,0.198-0.051,0.305\r\n\t\t\t\tc0.011-0.008,0.021-0.017,0.032-0.025c0.008,0.01,0.017,0.021,0.025,0.032c-0.017,0.008-0.034,0.017-0.051,0.025\r\n\t\t\t\tc-0.034,0.153-0.066,0.309-0.121,0.426c-0.162,0.027-0.245-0.039-0.375-0.076c-0.077,0.095-0.35,0.058-0.515,0.032\r\n\t\t\t\tc-0.075-0.012-0.339-0.086-0.356-0.083c-0.076,0.017-0.158,0.089-0.267,0.07c-0.137-0.023-0.23-0.099-0.369-0.044\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102h-0.083c-0.104,0.004-0.159,0.031-0.197,0.102c0.002,0.023,0.004,0.047,0.006,0.07\r\n\t\t\t\tc0.094,0.019,0.139,0.07,0.165,0.153c0.008,0.014-0.059,0.211-0.076,0.241c0.095,0.198,0.023,0.738-0.14,0.826\r\n\t\t\t\tc0.005,0.08-0.01,0.143-0.038,0.203c0.015,0.029,0.018,0.027,0.051,0.038c0.039-0.018,0.066-0.029,0.083-0.07\r\n\t\t\t\tc0.006-0.004,0.013-0.009,0.019-0.013c0.009,0.017,0.017,0.034,0.025,0.051c-0.024,0.033-0.05,0.045-0.108,0.045v0.006\r\n\t\t\t\tc0.004,0.017,0.009,0.034,0.013,0.051c0.035,0.008,0.086-0.006,0.121-0.019c0.004,0.004,0.008,0.008,0.013,0.013\r\n\t\t\t\tc-0.011,0.052-0.024,0.115-0.032,0.165c-0.002,0.004-0.004,0.008-0.006,0.013c0.016,0.028,0.041,0.09,0.025,0.152\r\n\t\t\t\tc-0.012,0.047-0.061,0.108-0.044,0.159v0.013c0.057-0.028,0.12-0.061,0.216-0.038c0.03,0.007,0.054,0.035,0.102,0.026\r\n\t\t\t\tc0.044-0.021,0.089-0.042,0.133-0.064c0.148-0.039,0.293,0.081,0.286,0.191c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.017,0.104,0.101,0.213,0.229,0.178c0.011-0.013,0.01-0.013,0.013-0.038h0.006c0.002,0.011,0.004,0.021,0.006,0.032h0.006\r\n\t\t\t\tc0.028-0.117,0.068-0.096,0.178-0.133c0.032-0.028,0.064-0.055,0.095-0.083c0.167,0.002,0.335,0.004,0.502,0.006\r\n\t\t\t\tc0.033-0.011,0.061-0.035,0.114-0.044c0.013,0.011,0.025,0.021,0.038,0.032c0.076-0.056,0.065-0.091,0.114-0.178\r\n\t\t\t\tc0.05-0.088,0.175-0.085,0.292-0.108c0.01-0.028-0.012-0.031-0.006-0.064c0.026-0.154,0.176-0.261,0.299-0.324v-0.019\r\n\t\t\t\tc-0.032-0.017-0.064-0.034-0.095-0.051c-0.023-0.053-0.047-0.106-0.07-0.159c0.031-0.147,0.225-0.389,0.356-0.438\r\n\t\t\t\tc0.002-0.004,0.004-0.009,0.006-0.013c-0.016-0.018-0.023-0.016-0.032-0.044c0.086-0.149,0.264-0.073,0.394-0.159\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.074-0.067,0.212-0.068,0.273-0.146c0.075-0.198-0.151-0.33,0.102-0.508\r\n\t\t\t\tc0.16-0.113,0.187,0.005,0.33,0.006c0.036,0,0.081-0.033,0.133-0.013c0.074,0.029,0.117,0.137,0.242,0.115\r\n\t\t\t\tc0.24-0.044,0.308-0.187,0.47-0.292c0.047-0.013,0.093-0.026,0.14-0.038c0.025-0.028,0.051-0.055,0.076-0.083\r\n\t\t\t\tc0.129-0.101,0.256-0.104,0.426-0.019c0.221,0.111,0.209,0.479,0.419,0.61c0.184,0.115,0.33,0.293,0.502,0.381\r\n\t\t\t\tc0.155,0.08,0.306,0.025,0.343,0.229c0.03-0.008,0.059-0.017,0.089-0.025h0.006c0.013,0.015,0.025,0.03,0.038,0.044\r\n\t\t\t\tc-0.011,0.004-0.021,0.009-0.032,0.013c-0.004,0.008-0.009,0.017-0.013,0.025c0.038-0.011,0.076-0.021,0.114-0.032\r\n\t\t\t\tc0.021,0.019,0.042,0.038,0.064,0.057c0.009,0.041,0.003,0.066-0.013,0.095c0.045,0.027,0.089,0.055,0.133,0.083\r\n\t\t\t\tc0.023,0.012,0.039-0.004,0.07-0.019c0.034,0.01,0.181,0.419,0.172,0.451v0.013c-0.023-0.002-0.047-0.004-0.07-0.006\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.02,0.067,0.004,0.11-0.064,0.14v0.076c0.013,0.009,0.025,0.017,0.038,0.025h0.083\r\n\t\t\t\tc0.039-0.064,0.067-0.14,0.146-0.165c0.016-0.034,0.005-0.062,0-0.108c0.045-0.043,0.063-0.067,0.159-0.064\r\n\t\t\t\tc0.011-0.013,0.021-0.026,0.032-0.038c-0.026-0.042-0.026-0.089-0.006-0.134c-0.061-0.034-0.123-0.068-0.184-0.102\r\n\t\t\t\tc0.002-0.111,0.086-0.282,0.197-0.267c-0.006,0.095,0.142,0.064,0.203,0.108c0.03,0.023,0.006,0.04,0.025,0.076\r\n\t\t\t\tc0.036,0.023,0.072,0.047,0.108,0.07c0.015-0.044,0.03-0.089,0.045-0.133c-0.196-0.193-0.436-0.359-0.744-0.438\r\n\t\t\t\tc-0.011-0.013-0.021-0.025-0.032-0.038c0.032-0.027,0.049-0.054,0.095-0.07c-0.002-0.011-0.004-0.021-0.006-0.032\r\n\t\t\t\tc-0.047-0.073-0.327,0.011-0.413-0.076c-0.08-0.081-0.209-0.198-0.254-0.305c-0.028-0.067-0.023-0.157-0.064-0.21\r\n\t\t\t\tc-0.031-0.04-0.088-0.05-0.133-0.076c-0.15-0.087-0.231-0.143-0.273-0.343c0.027-0.031,0.056-0.043,0.076-0.083\r\n\t\t\t\tc-0.031-0.037-0.057-0.035-0.057-0.108c-0.015-0.002-0.03-0.004-0.044-0.006c0.008-0.021,0.017-0.042,0.025-0.064\r\n\t\t\t\tc0.044-0.029,0.154-0.064,0.248-0.07c0.002-0.017,0.004-0.034,0.006-0.051c0.08,0.003,0.086,0.005,0.159,0\r\n\t\t\t\tc0.011,0.017,0.021,0.034,0.032,0.051c-0.019,0.025-0.035,0.035-0.076,0.038c0.021,0.098,0.071,0.175,0.102,0.254\r\n\t\t\t\tc0.033-0.017,0.055-0.041,0.083-0.064c0.017-0.047,0.034-0.093,0.051-0.14c0.256,0.103,0.086,0.31,0.343,0.388\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.006v0.006c0.075,0.108,0.185,0.165,0.267,0.267c0.025,0.026,0.059-0.025,0.108-0.013\r\n\t\t\t\tc0.006,0.001,0.153,0.061,0.165,0.07c0.049,0.035,0.089,0.097,0.14,0.133c0.133,0.095,0.272,0.155,0.407,0.248\r\n\t\t\t\tc0.03,0.036,0.059,0.072,0.089,0.108c0.042,0.021,0.085,0.042,0.127,0.064c0.003,0.051,0.002,0.06-0.038,0.07\r\n\t\t\t\tc-0.006,0.043,0.016,0.226,0.013,0.235c-0.017,0.032-0.034,0.064-0.051,0.095c0.022,0.032,0.038,0.045,0.038,0.102\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c0.027,0.077,0.144,0.098,0.191,0.159c0.006,0.03,0.013,0.059,0.019,0.089\r\n\t\t\t\tc0.04,0.101,0.153,0.191,0.28,0.172c0.008,0.008,0.017,0.017,0.025,0.025v0.013c-0.027,0.034-0.065,0.029-0.108,0.038v0.006\r\n\t\t\t\tc0.036,0.055,0.072,0.11,0.108,0.165c0.103-0.009,0.227-0.061,0.349-0.025c0.077,0.022,0.119,0.081,0.223,0.089v0.006\r\n\t\t\t\tc-0.101,0.134-0.204-0.021-0.324-0.038c-0.039-0.005-0.082,0.035-0.159,0.032c-0.021,0.038-0.042,0.076-0.064,0.114\r\n\t\t\t\tc0.038,0.047,0.076,0.093,0.114,0.14c0.014,0.044-0.016,0.099-0.013,0.146c0.019,0.017,0.038,0.034,0.057,0.051\r\n\t\t\t\tc0.019-0.015,0.038-0.03,0.057-0.044c0.045-0.022,0.097,0.086,0.108,0.14c0.004,0.002,0.009,0.004,0.013,0.007\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.056-0.027,0.09-0.001,0.14,0.025c-0.005-0.136-0.055-0.195-0.095-0.292v-0.032\r\n\t\t\t\tc0.034,0.011,0.068,0.021,0.102,0.032h0.013c-0.006,0.013-0.013,0.025-0.019,0.038c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.019-0.035,0.029-0.044,0.083-0.045c-0.023-0.029-0.028-0.02-0.025-0.064c-0.021,0.004-0.042,0.009-0.064,0.013\r\n\t\t\t\tc-0.022-0.048-0.026-0.074-0.057-0.108c0.047-0.015,0.093-0.03,0.14-0.044c0.05,0.006,0.107,0.078,0.121,0.121\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.013-0.011,0.025-0.021,0.038-0.032c-0.013-0.04-0.025-0.081-0.038-0.121\r\n\t\t\t\tc0.008-0.002,0.017-0.004,0.025-0.006c-0.005-0.06-0.342-0.233-0.419-0.248v-0.006c0.044-0.01,0.071-0.023,0.102-0.044\r\n\t\t\t\tc-0.013-0.03-0.026-0.059-0.038-0.089v-0.007c0.03-0.019,0.042-0.017,0.083-0.006c0.014,0.026,0.015,0.037,0.013,0.07h0.006\r\n\t\t\t\tc0.006-0.002,0.013-0.004,0.019-0.006c0.008-0.011,0.017-0.021,0.025-0.032c-0.079-0.096-0.169-0.193-0.222-0.311\r\n\t\t\t\tc0.002-0.047,0.015-0.064,0.038-0.089c-0.011-0.013-0.021-0.025-0.032-0.038c0.035-0.015,0.06-0.023,0.076-0.057\r\n\t\t\t\tc0.008,0.002,0.017,0.004,0.025,0.006c0.002,0.009,0.004,0.017,0.006,0.025c-0.011,0.007-0.021,0.013-0.032,0.019\r\n\t\t\t\tc0.04,0.08,0.139,0.069,0.146,0.184c0.032,0.004,0.064,0.008,0.095,0.013h0.013c-0.035-0.042-0.079-0.056-0.108-0.108v-0.006\r\n\t\t\t\tc0.076,0.003,0.119,0.051,0.146,0.102c0.015-0.002,0.03-0.004,0.044-0.006c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.024-0.041-0.06-0.046-0.083-0.089c0.011-0.008,0.021-0.017,0.032-0.026c0.037,0.007,0.067,0.015,0.083,0.045\r\n\t\t\t\tc0.017,0.015,0.034,0.03,0.051,0.045c0.006-0.004,0.013-0.009,0.019-0.013v-0.006c-0.062-0.077-0.15-0.094-0.191-0.197v-0.006\r\n\t\t\t\tc0.134-0.026,0.108,0.02,0.21-0.07c0.039,0.003,0.034,0.001,0.044,0.032c0.079,0,0.103-0.025,0.153-0.051\r\n\t\t\t\tc0.043,0.102,0.272-0.012,0.286,0.121c0.008-0.009,0.017-0.017,0.025-0.025c0.034,0.021,0.105,0.031,0.146,0.044\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.032,0.019-0.064,0.038-0.095,0.057c-0.008,0.032-0.017,0.064-0.025,0.095\r\n\t\t\t\tc0.066-0.021,0.091-0.085,0.14-0.121c0.061-0.028,0.123-0.055,0.184-0.083c0.015-0.03,0.03-0.059,0.044-0.089\r\n\t\t\t\tc0.038-0.022,0.1,0.002,0.153-0.019c0.136-0.054,0.112,0.009,0.273,0.013c0.026-0.03,0.045-0.056,0.063-0.095\r\n\t\t\t\tc-0.045-0.06-0.142-0.051-0.21-0.089c-0.087-0.049-0.178-0.313-0.267-0.299v-0.051c0.036-0.035,0.047-0.056,0.102-0.076\r\n\t\t\t\tc0.016-0.084,0.038-0.153,0.051-0.222c0.025-0.013,0.108-0.018,0.121-0.038c0.004-0.04,0.008-0.08,0.013-0.121\r\n\t\t\t\tc0.036-0.199,0.06-0.377,0.286-0.388c0.023-0.049,0.047-0.097,0.07-0.146c-0.015-0.031-0.034-0.038-0.051-0.064\r\n\t\t\t\tc-0.032-0.104,0.093-0.097,0.153-0.133c0.199-0.119,0.104-0.321,0.509-0.311c0.008-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.021,0.025,0.042,0.051,0.064,0.076v0.013c-0.023,0.021-0.047,0.042-0.07,0.064v0.013\r\n\t\t\t\tc0.097,0.133,0.265,0.085,0.458,0.089c0.013,0.025,0.026,0.051,0.038,0.076c-0.067,0.074-0.25,0.106-0.331,0.184\r\n\t\t\t\tc0.004,0.008,0.009,0.017,0.013,0.025c0.2,0.038,0.367,0.002,0.254,0.267v0.019c0.285,0.052,0.158-0.026,0.337-0.089\r\n\t\t\t\tc0.051-0.004,0.102-0.009,0.153-0.013c0.034-0.028,0.068-0.055,0.102-0.083c0.06-0.018,0.089,0.017,0.133,0.025\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0.023-0.032,0.052-0.072,0.064-0.114c-0.064-0.008-0.127-0.017-0.191-0.025\r\n\t\t\t\tc-0.072,0.007-0.141,0.064-0.235,0.038c-0.024-0.123-0.199-0.258-0.337-0.299c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.103-0.029,0.197-0.016,0.305-0.019c0.037-0.039,0.065-0.066,0.083-0.127c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc0.015,0.013,0.03,0.025,0.044,0.038c0.022,0.013,0.019,0.008,0.045,0c0.05-0.015,0.061-0.049,0.102-0.063\r\n\t\t\t\tc0.125-0.023,0.25-0.047,0.375-0.07c0.023-0.025,0.047-0.051,0.07-0.076c0.074-0.008,0.148-0.017,0.222-0.025\r\n\t\t\t\tc0.013-0.013,0.007-0.002,0.013-0.025c0.093-0.017,0.186-0.034,0.28-0.051c0.011,0.021,0.021,0.042,0.032,0.064\r\n\t\t\t\tc-0.099,0.079-0.25,0.146-0.413,0.152c-0.008,0.011-0.017,0.021-0.026,0.032c0.074,0.053,0.148,0.098,0.197,0.178\r\n\t\t\t\tc-0.034,0.026-0.077,0.034-0.14,0.032c-0.028,0.081-0.083,0.13-0.089,0.229c-0.049,0.026-0.154,0.037-0.21,0.051\r\n\t\t\t\tc0.044,0.059,0.104,0.147,0.159,0.197c0.043,0.008,0.057-0.002,0.089-0.019c0.041,0.027,0.058,0.069,0.095,0.095\r\n\t\t\t\tc0.044,0.013,0.089,0.025,0.133,0.038c0.105,0.049,0.192,0.14,0.28,0.21c0.047,0.038,0.116,0.138,0.178,0.133\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.102,0.075,0.311,0.102,0.381,0.21c0.015,0.053,0.03,0.106,0.045,0.159\r\n\t\t\t\tc0.079,0.289-0.089,0.388-0.324,0.445c-0.131,0.031-0.222-0.051-0.337-0.032c-0.053,0.017-0.106,0.034-0.159,0.051\r\n\t\t\t\tc-0.098,0.022-0.277-0.021-0.381-0.038c-0.126-0.021-0.151-0.13-0.292-0.076c-0.078-0.037-0.078-0.076-0.121-0.146\r\n\t\t\t\tc-0.029-0.021-0.102,0.03-0.172,0.013c-0.083-0.021-0.076-0.089-0.121-0.146c-0.173,0.111-0.323-0.021-0.54,0.032\r\n\t\t\t\tc-0.196,0.047-0.34,0.172-0.515,0.229c0.002,0.017,0.004,0.034,0.006,0.051c-0.138,0.074-0.202,0.007-0.318-0.013\r\n\t\t\t\tc-0.019,0.006-0.038,0.013-0.057,0.019c-0.093-0.008-0.186-0.017-0.28-0.025c-0.013,0.025-0.025,0.051-0.038,0.076\r\n\t\t\t\tc0.029,0.031,0.069,0.042,0.083,0.089c0.053-0.002,0.106-0.004,0.159-0.006v0.006c-0.072,0.023-0.189,0.032-0.28,0.032\r\n\t\t\t\tc-0.017,0.023-0.026,0.025-0.026,0.051c0.026,0.006,0.051,0.013,0.076,0.019c0.006,0.004,0.013,0.009,0.019,0.013\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.025c-0.114-0.018-0.214-0.013-0.337-0.006c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.036-0.015-0.055-0.014-0.089-0.007c-0.002,0.004-0.004,0.009-0.006,0.013c0.013,0.006,0.026,0.013,0.038,0.019v0.019\r\n\t\t\t\tc-0.067,0.022-0.142,0.01-0.159-0.044c-0.091,0.011-0.203,0.041-0.254,0.095c-0.035,0.037,0.004,0.057-0.07,0.064\r\n\t\t\t\tc-0.01,0.071-0.028,0.13-0.032,0.191c0.087-0.013,0.174-0.025,0.261-0.038v0.006c-0.015,0.024-0.03,0.039-0.057,0.051\r\n\t\t\t\tc-0.015,0.017-0.03,0.034-0.045,0.051c0.035,0.006,0.049,0.02,0.064,0.045c0.014,0.023-0.007,0.02-0.013,0.064h0.057\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.025c-0.021,0.025-0.052,0.036-0.089,0.045c-0.007,0.025,0.01,0.054,0.038,0.076\r\n\t\t\t\tc0.034,0.045,0.026,0.031-0.019,0.063c-0.032-0.003-0.055-0.025-0.089-0.044c-0.011,0.023-0.021,0.047-0.032,0.07v0.045\r\n\t\t\t\tc0.105,0.013,0.133,0.046,0.222,0.07c0.003,0.06-0.021,0.124,0.006,0.165c0.034,0.021,0.068,0.042,0.102,0.064\r\n\t\t\t\tc0.002,0.008,0.004,0.017,0.006,0.025c-0.028,0.011-0.055,0.021-0.083,0.032c0.006,0.013,0.013,0.025,0.019,0.038\r\n\t\t\t\tc0.068,0.006,0.136,0.013,0.203,0.019c0.002,0.004,0.004,0.008,0.006,0.013c-0.017,0.019-0.024,0.019-0.032,0.051\r\n\t\t\t\tc0.006,0.015,0.013,0.03,0.019,0.045c0.004,0.002,0.009,0.004,0.013,0.006c0.021-0.021,0.042-0.042,0.064-0.063\r\n\t\t\t\tc0.085-0.003,0.086,0.023,0.146,0.051c0.029,0.014,0.049-0.015,0.076-0.038c0.025,0.059,0.051,0.119,0.076,0.178\r\n\t\t\t\tc0.099,0.031,0.23-0.025,0.299,0.019c0.013-0.002,0.026-0.004,0.038-0.006c0.015-0.072,0.03-0.144,0.044-0.216\r\n\t\t\t\tc0.142-0.018,0.288,0.018,0.388,0.083c0.073,0.048,0.108,0.143,0.203,0.172c0.136,0.041,0.301-0.026,0.381-0.045\r\n\t\t\t\tc0.042-0.082,0.104-0.102,0.159-0.165c0.138,0.001,0.177,0.055,0.286,0.07c0.037-0.038,0.085-0.067,0.121-0.114h0.025\r\n\t\t\t\tc0.013,0.017,0.025,0.034,0.038,0.051c0.002,0.013,0.004,0.025,0.006,0.038c-0.039,0.043-0.09,0.068-0.127,0.114\r\n\t\t\t\tc0.017,0.03,0.034,0.059,0.051,0.089c-0.011,0.057-0.038,0.107-0.064,0.153c0.087,0.115,0.021,0.195,0.076,0.33\r\n\t\t\t\tc-0.146,0.144-0.206,0.407-0.305,0.578c-0.008,0.042-0.017,0.085-0.025,0.127c-0.041,0.134-0.077,0.258-0.172,0.337\r\n\t\t\t\tc0.074,0.186,0.148,0.373,0.222,0.559c0.012,0.018,0.023,0.014,0.051,0.032c-0.023,0.137-0.084,0.285-0.095,0.407\r\n\t\t\t\tc0.036,0.002,0.072,0.004,0.108,0.006c0.047,0.059,0.093,0.119,0.14,0.178c0.104,0.17,0.188,0.32,0.299,0.477\r\n\t\t\t\tc0.084,0.118,0.206,0.226,0.165,0.413c0.085,0.117,0.223,0.149,0.324,0.248c0.066,0.119,0.131,0.237,0.197,0.356\r\n\t\t\t\tc0.066,0.127-0.002,0.313,0.051,0.457c0.051,0.072,0.102,0.144,0.152,0.216c0.07,0.096,0.225,0.114,0.299,0.203\r\n\t\t\t\tc0.089,0.182,0.178,0.364,0.267,0.546c0.034,0.026,0.068,0.051,0.102,0.076c0.086,0.071,0.195,0.232,0.235,0.343\r\n\t\t\t\tc0.011,0.068,0.021,0.136,0.032,0.203c-0.008,0.039-0.042,0.068-0.032,0.127c0.03,0.172,0.113,0.353,0.165,0.496v0.216\r\n\t\t\t\tc0.095,0.205,0.383,0.166,0.553,0.057c0.057-0.047,0.114-0.093,0.172-0.14c0.094-0.028,0.217,0.012,0.299-0.013\r\n\t\t\t\tc0.128-0.039,0.228-0.133,0.343-0.172c0.078-0.026,0.163,0.016,0.229-0.019c0.069-0.036,0.087-0.124,0.152-0.159\r\n\t\t\t\tc0.238-0.13,0.547-0.129,0.769-0.267c0.062-0.038,0.046-0.087,0.076-0.159c0.029-0.07,0.139-0.142,0.21-0.172\r\n\t\t\t\tc0.121-0.04,0.241-0.081,0.362-0.121c0.07,0.008,0.14,0.017,0.21,0.025c0.025-0.015,0.051-0.03,0.076-0.045\r\n\t\t\t\tc0.045-0.091,0.016-0.205,0.108-0.248c0.096-0.045,0.186,0.021,0.273-0.051c0.032-0.027,0.027-0.071,0.044-0.114\r\n\t\t\t\tc0.048-0.12,0.19-0.153,0.349-0.159c0.009-0.116-0.012-0.304,0.026-0.419c0.056-0.024,0.123,0.021,0.172-0.006\r\n\t\t\t\tc0.057-0.042,0.064-0.147,0.102-0.21c0.042-0.04,0.085-0.08,0.127-0.121c0.059-0.074,0.114-0.154,0.159-0.242\r\n\t\t\t\tc-0.012-0.066-0.116-0.088-0.159-0.127c-0.064-0.08-0.127-0.161-0.191-0.241c-0.048-0.033-0.104,0.008-0.165-0.006\r\n\t\t\t\tc-0.089-0.049-0.178-0.098-0.267-0.146c-0.071-0.049-0.182-0.161-0.21-0.248c-0.021-0.066,0.011-0.151-0.013-0.203\r\n\t\t\t\tc-0.015-0.018-0.024-0.019-0.057-0.019c0.044-0.068,0.068-0.116,0.057-0.229h-0.006c-0.045,0.057-0.089,0.115-0.133,0.172\r\n\t\t\t\tc-0.113,0.09-0.215,0.143-0.311,0.267c-0.023,0.045-0.047,0.089-0.07,0.134c-0.035,0.031-0.051,0.02-0.07,0.07\r\n\t\t\t\tc-0.042,0.011-0.063,0.014-0.095-0.006c-0.002,0.011-0.004,0.021-0.006,0.032c-0.074,0.026-0.394,0.021-0.477-0.019\r\n\t\t\t\tc-0.019,0.017-0.023,0.015-0.032,0.044c-0.073,0.007-0.13-0.005-0.203-0.006c0.013-0.058-0.015-0.063-0.064-0.076\r\n\t\t\t\tc-0.037-0.089,0.072-0.127,0.076-0.216c0.001-0.028-0.017-0.268-0.025-0.28c-0.018-0.025-0.035-0.018-0.051-0.057\r\n\t\t\t\tc-0.015-0.002-0.03-0.004-0.044-0.006c-0.083,0.059-0.119,0.288-0.07,0.407c0.007,0.07,0.01,0.094-0.051,0.089\r\n\t\t\t\tc-0.045-0.059-0.108-0.211-0.114-0.311c-0.034-0.027-0.036-0.039-0.076-0.032c-0.033-0.107-0.058-0.116-0.013-0.229\r\n\t\t\t\tc-0.013-0.021-0.026-0.042-0.038-0.064c0.02-0.031,0.039-0.029,0.045-0.076c-0.062-0.082-0.205-0.072-0.248-0.172\r\n\t\t\t\tc-0.036-0.028-0.026-0.027-0.006-0.064c-0.037-0.017-0.058-0.015-0.114-0.013c-0.07-0.185-0.159-0.356-0.21-0.553\r\n\t\t\t\tc-0.036,0.009-0.072,0.017-0.108,0.026c-0.013-0.006-0.026-0.013-0.038-0.019c0.021-0.026,0.042-0.051,0.063-0.076h0.044\r\n\t\t\t\tc-0.008-0.04-0.017-0.08-0.025-0.121c0.026-0.034,0.169-0.04,0.235-0.038c0.055-0.054,0.047-0.118,0.127-0.152h0.019\r\n\t\t\t\tc-0.001,0.041,0.001,0.074,0.019,0.095c0.038,0.072,0.165,0.061,0.242,0.032c0.043,0.069,0.143,0.143,0.172,0.21v0.102\r\n\t\t\t\tc0.031,0.082,0.136,0.259,0.191,0.337c0.064,0.091,0.221,0.082,0.311,0.146c0.047,0.057,0.093,0.115,0.14,0.172\r\n\t\t\t\tc0.106,0.063,0.211,0.06,0.337,0.102c0.07,0.023,0.11,0.086,0.197,0.095c0.042-0.036,0.186-0.121,0.197-0.172\r\n\t\t\t\tc0.098-0.035,0.203-0.075,0.324-0.044c0.05,0.012,0.038,0.034,0.089,0.038c0.015,0.043,0.01,0.1,0.032,0.159\r\n\t\t\t\tc0.026,0.069,0.095,0.113,0.095,0.21c0.068,0.011,0.135,0.056,0.184,0.076h0.254c0.025,0.023,0.051,0.047,0.076,0.07\r\n\t\t\t\tc0.142,0.002,0.284,0.004,0.426,0.007c0.075,0.02,0.118,0.067,0.216,0.083c0.131,0.021,0.254-0.027,0.356-0.044h0.286\r\n\t\t\t\tc0.057-0.021,0.1-0.057,0.191-0.07c0.08,0.167,0.549-0.018,0.686-0.025c0.074,0.053,0.075,0.102,0.07,0.223\r\n\t\t\t\tc0.047,0.011,0.093,0.021,0.14,0.032c0.023,0.068,0.047,0.136,0.07,0.203c0.05,0.067,0.114,0.032,0.191,0.076\r\n\t\t\t\tc0.03,0.042,0.059,0.085,0.089,0.127c0.103,0.123,0.38,0.229,0.597,0.153c0.003,0.052-0.02,0.064-0.051,0.095\r\n\t\t\t\tc-0.142,0.145-0.214,0.023-0.369,0.076h-0.013c0.049,0.113,0.433,0.501,0.572,0.508c0.04-0.015,0.081-0.03,0.121-0.044\r\n\t\t\t\tc0.145-0.047,0.383-0.127,0.254-0.299c0.008-0.03,0.017-0.059,0.025-0.089c0.032-0.019,0.083-0.021,0.14-0.019\r\n\t\t\t\tc-0.019,0.072-0.014,0.207,0.013,0.286c0.016,0.046,0.116,0.085,0.102,0.146c-0.015,0.062-0.095,0.113-0.102,0.191\r\n\t\t\t\tc0.027,0.146,0.055,0.292,0.083,0.438c0.034,0.205,0.068,0.411,0.102,0.616c0.07,0.251,0.21,0.444,0.305,0.655\r\n\t\t\t\tc0.065,0.143,0.116,0.299,0.165,0.457c0.021,0.079,0.042,0.157,0.064,0.235c0.038,0.055,0.076,0.11,0.114,0.165\r\n\t\t\t\tc0.074,0.163,0.148,0.326,0.222,0.489c0.032,0.112,0.064,0.225,0.095,0.337c0.059,0.064,0.119,0.127,0.178,0.191\r\n\t\t\t\tc0.09-0.003,0.218-0.064,0.248-0.127c0.026-0.054,0.004-0.106,0.038-0.146c0.083-0.028,0.165-0.055,0.248-0.083\r\n\t\t\t\tc-0.013-0.027-0.034-0.042-0.057-0.057c0.025-0.072,0.051-0.144,0.076-0.216c0.037-0.022,0.108-0.021,0.172-0.019\r\n\t\t\t\tc0.023-0.118-0.033-0.248-0.019-0.362c0.025-0.213,0.286-0.458,0.108-0.655c0.057-0.141-0.035-0.296,0-0.451\r\n\t\t\t\tc0.021-0.047,0.042-0.093,0.064-0.14c0.06-0.048,0.118-0.061,0.191-0.019c0.048-0.031,0.078-0.105,0.095-0.165\r\n\t\t\t\tc0.058-0.032,0.17-0.01,0.229-0.051c0.065-0.045,0.048-0.168,0.108-0.216c0.063-0.032,0.127-0.064,0.191-0.095\r\n\t\t\t\tc0.072-0.046,0.111-0.143,0.178-0.184c0.046-0.028,0.088-0.032,0.127-0.064c0.097-0.119,0.195-0.237,0.292-0.356\r\n\t\t\t\tc0.078-0.054,0.207-0.041,0.292-0.095c0.106-0.067,0.148-0.181,0.229-0.273c-0.013-0.045-0.025-0.089-0.038-0.134\r\n\t\t\t\tc0.071-0.072,0.179-0.083,0.267-0.14c0.032-0.034,0.064-0.068,0.095-0.102c0.029,0.022,0.05,0.059,0.057,0.102\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.013c0.017-0.03,0.034-0.059,0.051-0.089c0.002-0.004,0.004-0.008,0.006-0.013\r\n\t\t\t\tc0.034,0.02,0.042,0.065,0.051,0.108h0.089c-0.005-0.031-0.002-0.042,0.006-0.07c0.019,0.01,0.038,0.021,0.057,0.032\r\n\t\t\t\tc0.013-0.021,0.025-0.042,0.038-0.063c0.008-0.006,0.017-0.013,0.025-0.019c0.009,0.021,0.017,0.043,0.026,0.064h0.038\r\n\t\t\t\tc0.026-0.034,0.046-0.064,0.051-0.121c0.004-0.002,0.008-0.004,0.013-0.006c0.021,0.038,0.042,0.076,0.063,0.115h0.045\r\n\t\t\t\tc0.016-0.069,0.027-0.078,0.095-0.095c0.022-0.07-0.005-0.129-0.032-0.184c-0.002-0.034-0.003-0.067,0.013-0.083\r\n\t\t\t\tc0.004-0.004,0.009-0.009,0.013-0.013c0.032,0.042,0.064,0.085,0.095,0.127c0.07-0.001,0.1-0.022,0.146-0.044\r\n\t\t\t\tc0.175,0.137,0.122,0.639,0.362,0.705c0.022,0.006,0.054-0.002,0.076,0.006v0.083c0.053,0.035,0.082,0.001,0.127,0.025\r\n\t\t\t\tc0.068,0.037,0.107,0.146,0.133,0.229v0.006c-0.034,0.006-0.068,0.013-0.102,0.019c0.028,0.031,0.065,0.053,0.108,0.07\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.004-0.002,0.009-0.004,0.013-0.006c0.079,0.128,0.174,0.362,0.146,0.578\r\n\t\t\t\tc-0.017,0.129-0.098,0.22-0.102,0.362c0.015,0.011,0.03,0.021,0.044,0.032c0.047-0.038,0.073-0.066,0.153-0.076\r\n\t\t\t\tc-0.006,0.025-0.013,0.051-0.019,0.076c0.011,0.011,0.021,0.021,0.032,0.032h0.025c0.029-0.023,0.031-0.041,0.083-0.044v0.057\r\n\t\t\t\tc0.08,0.073,0.094-0.079,0.153-0.121c0.184-0.132,0.273-0.031,0.305-0.343h0.025c0.085,0.062,0.089,0.235,0.197,0.267\r\n\t\t\t\tc0.026,0.18,0.051,0.36,0.076,0.54c0.047,0.164,0.151,0.309,0.203,0.451c0.053,0.144,0.03,0.29,0.025,0.432\r\n\t\t\t\tc0.019,0.01,0.036,0.013,0.07,0.013c-0.033,0.078-0.145,0.34-0.114,0.413c0.017,0.013,0.034,0.025,0.051,0.038\r\n\t\t\t\tc-0.064,0.162-0.161,0.391-0.102,0.566c0.025-0.011,0.051-0.021,0.076-0.032c0.085,0.091,0.166,0.136,0.21,0.273\r\n\t\t\t\tc0.02,0.008,0.034,0.009,0.064,0c0.043,0.057,0.051,0.099,0.051,0.197c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc0.034,0.043,0.078,0.03,0.121,0.006c0.004,0.004,0.008,0.008,0.013,0.013c-0.018,0.139-0.008,0.3,0.044,0.445\r\n\t\t\t\tc0.025,0.047,0.051,0.093,0.076,0.14c0.009,0.069-0.024,0.13,0.013,0.191c0.04,0.034,0.08,0.068,0.121,0.102\r\n\t\t\t\tc0.016,0.022,0.022,0.056,0.031,0.088C55.358,48.795,44.764,58,32,58z M20.929,9.847c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.002,0.003,0.004,0.006,0.006,0.009c-0.001,0-0.002,0-0.003,0C20.933,9.853,20.931,9.85,20.929,9.847z M43.915,25.038\r\n\t\t\t\tc-0.028,0.012-0.031-0.019-0.07-0.013c-0.034,0.011-0.068,0.021-0.102,0.032c-0.004-0.002-0.008-0.004-0.013-0.006\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.013-0.004-0.026-0.008-0.038-0.013c-0.004,0.017-0.008,0.034-0.013,0.051\r\n\t\t\t\tc-0.048-0.011-0.054-0.013-0.108-0.006c-0.017-0.034-0.034-0.068-0.051-0.102c-0.067,0.075-0.078,0.271-0.044,0.369\r\n\t\t\t\tc0.039,0.021,0.133,0.008,0.216,0.006c-0.015,0.019-0.03,0.038-0.044,0.057c0.004,0.013,0.008,0.025,0.013,0.038\r\n\t\t\t\tc0.014,0.023,0.042,0.036,0.07,0.045v0.019c-0.045-0.004-0.089-0.008-0.133-0.013c-0.011,0.015-0.021,0.03-0.032,0.045v0.044\r\n\t\t\t\tc0.042-0.029,0.066-0.018,0.127-0.006c0.024,0.067,0.085,0.076,0.114,0.133c0.014,0.054-0.038,0.118-0.038,0.203\r\n\t\t\t\tc0,0.04-0.022,0.09-0.019,0.108c0.018,0.102,0.109,0.354,0.025,0.419c-0.061,0.047-0.192,0.025-0.28,0.045\r\n\t\t\t\tc-0.314,0.07-0.748,0.1-0.858-0.197c-0.119-0.032-0.251-0.062-0.35-0.095c-0.052-0.198,0.057-0.392,0.057-0.559\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.017,0.015,0.019,0.017,0.025,0.044c0.006,0.004,0.013,0.008,0.019,0.013\r\n\t\t\t\tc0.006-0.03,0.013-0.059,0.019-0.089c0.02-0.009,0.021-0.011,0.044-0.006c-0.012-0.168,0.011-0.45,0.28-0.337h0.006\r\n\t\t\t\tc-0.002-0.011-0.004-0.021-0.006-0.032c-0.056-0.128-0.19-0.036-0.242-0.108c-0.03-0.042-0.076-0.085-0.095-0.127\r\n\t\t\t\tc-0.023-0.049-0.009-0.096-0.038-0.133c-0.041-0.053-0.106-0.142-0.159-0.184c-0.019-0.006-0.038-0.013-0.057-0.019\r\n\t\t\t\tc-0.05-0.07-0.077-0.16-0.14-0.216c-0.015-0.004-0.03-0.009-0.044-0.013c-0.031-0.047,0.006-0.079-0.044-0.108\r\n\t\t\t\tc-0.057-0.081-0.018-0.217,0.019-0.311v-0.019H41.92c-0.011,0.038-0.021,0.076-0.032,0.114h-0.006\r\n\t\t\t\tc-0.001-0.113-0.014-0.227-0.114-0.286c-0.032-0.019-0.075-0.01-0.089-0.045v-0.032c0.004-0.075,0.083-0.081,0.114-0.127\r\n\t\t\t\tc0.062-0.092,0.092-0.195,0.121-0.286c0.004-0.006,0.008-0.013,0.013-0.019c0.105,0.051,0.2-0.03,0.28-0.076\r\n\t\t\t\tc0.015,0.008,0.03,0.017,0.044,0.025c0.016-0.02,0.02-0.029,0.019-0.07c0.102-0.023,0.134-0.121,0.216-0.153\r\n\t\t\t\tc0.04-0.002,0.081-0.004,0.121-0.006c0.13-0.041,0.242-0.21,0.413-0.197c0.096,0.007,0.137,0.073,0.21,0.089\r\n\t\t\t\tc0.077,0.017,0.097-0.038,0.133-0.051c0.057,0.013,0.114,0.025,0.172,0.038c0.015,0.025,0.03,0.051,0.045,0.076\r\n\t\t\t\tc-0.017,0.017-0.034,0.034-0.051,0.051c0.047,0.164,0.01,0.207-0.083,0.33c0.004,0.058,0.07,0.083,0.114,0.095\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.138-0.013-0.275-0.025-0.413-0.038c-0.038,0.007-0.047,0.027-0.102,0.026\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102c-0.029,0.036-0.057,0.02-0.076,0.076c0.027,0.039,0.064,0.068,0.114,0.083\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.026c-0.061,0.044-0.214-0.025-0.337-0.019c-0.006,0.006-0.013,0.013-0.019,0.019v0.083\r\n\t\t\t\tc0.039,0.026,0.133,0.043,0.184,0.051c0.028,0.155,0.139,0.203,0.133,0.368h0.089c0.037,0.027,0.071,0.069,0.089,0.114\r\n\t\t\t\tc0.089,0.012,0.165-0.009,0.235,0.064c-0.034,0.064-0.07,0.143-0.095,0.203c0.023,0.038-0.002,0.077,0.019,0.121\r\n\t\t\t\tc0.013,0.006,0.026,0.013,0.038,0.019c-0.002,0.019-0.004,0.038-0.006,0.057c0.013,0.029,0.055,0.079,0.076,0.114v0.013\r\n\t\t\t\tc0.027-0.072,0.011-0.226,0.032-0.305c0.087-0.015,0.173-0.031,0.273-0.025c0.015,0.056,0.023,0.174,0.051,0.216\r\n\t\t\t\tc0.046,0.071,0.146,0.075,0.197,0.178c-0.015,0.031-0.026,0.037-0.057,0.051c-0.041-0.008-0.042-0.024-0.083-0.032\r\n\t\t\t\tC43.898,24.987,43.907,25.012,43.915,25.038z M35.799,24.777c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc-0.025-0.022-0.041-0.037-0.083-0.045c0.004-0.011,0.009-0.021,0.013-0.032c0.017,0.008,0.034,0.017,0.051,0.025\r\n\t\t\t\tC35.788,24.751,35.789,24.757,35.799,24.777z M57.643,35.618c-0.368,0.016-0.324-0.225-0.388-0.502\r\n\t\t\t\tc-0.013,0.004-0.025,0.008-0.038,0.013c-0.056-0.044-0.033-0.145-0.051-0.222c-0.063,0.004-0.119,0.023-0.178,0.013\r\n\t\t\t\tc-0.153-0.249,0.124-0.633,0.191-0.826c-0.004-0.053-0.009-0.106-0.013-0.159c0.02-0.082,0.062-0.114,0.025-0.216\r\n\t\t\t\tc0.092-0.071,0.145-0.061,0.292-0.051c-0.006,0.076-0.013,0.152-0.019,0.229c0.058,0.001,0.08,0.024,0.121,0.032\r\n\t\t\t\tc0.078,0.014,0.107-0.054,0.191-0.006c0.038,0.04,0.076,0.08,0.115,0.121c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc-0.043,0.556-0.111,1.104-0.189,1.65C57.688,35.667,57.663,35.644,57.643,35.618z M8.363,28.628\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.363z M8.35,28.59c-0.001-0.011-0.009-0.009-0.011-0.018\r\n\t\t\t\tc0.001,0.006,0.003,0.012,0.004,0.018H8.35z M42.555,41.414c-0.037-0.058-0.107-0.06-0.14-0.133\r\n\t\t\t\tc-0.068-0.054-0.061-0.042-0.127,0.013c0.009,0.1,0.008,0.236-0.07,0.299c-0.044,0.036-0.08,0.04-0.102,0.102\r\n\t\t\t\tc-0.039-0.014-0.048-0.034-0.063-0.07c-0.019-0.002-0.038-0.004-0.057-0.006c-0.003,0.068,0.015,0.109,0.038,0.165\r\n\t\t\t\tc-0.004,0.011-0.008,0.021-0.013,0.032c-0.024,0.016-0.04,0.025-0.083,0.025c-0.002,0.004-0.004,0.009-0.006,0.013\r\n\t\t\t\tc0.003,0.044,0.026,0.059,0.045,0.102c-0.023,0.025-0.047,0.051-0.07,0.076c-0.039-0.004-0.04-0.009-0.051-0.038H41.85\r\n\t\t\t\tc-0.032,0.028-0.063,0.055-0.095,0.083c0.008,0.034,0.022,0.045,0.038,0.07c-0.013,0.009-0.025,0.017-0.038,0.026\r\n\t\t\t\tc-0.024,0.01-0.027-0.009-0.064-0.019c-0.047,0.029-0.093,0.059-0.14,0.089c0.004,0.025,0.009,0.051,0.013,0.076\r\n\t\t\t\tc-0.071,0.017-0.121-0.054-0.21-0.013c-0.017,0.019-0.034,0.038-0.051,0.057c-0.04,0.02-0.074-0.013-0.108-0.013\r\n\t\t\t\tc-0.025,0.019-0.051,0.038-0.076,0.057c-0.044,0.002-0.089,0.004-0.133,0.006c0,0.213-0.083,0.245-0.14,0.381\r\n\t\t\t\tc-0.025,0.1,0.069,0.325,0.121,0.388c-0.015,0.032-0.03,0.064-0.044,0.096c0.032,0.038,0.064,0.076,0.095,0.114\r\n\t\t\t\tc0.03,0.115-0.166,0.512-0.216,0.559c-0.025,0.009-0.051,0.017-0.076,0.025c-0.045,0.032-0.102,0.233-0.089,0.311\r\n\t\t\t\tc0.053,0.097,0.106,0.195,0.159,0.292c-0.013,0.049-0.025,0.097-0.038,0.146c-0.031,0.144,0.06,0.157,0.083,0.229\r\n\t\t\t\tc0.016,0.051-0.006,0.092,0.019,0.127c0.083,0.119,0.262,0.084,0.343,0.21c0.137-0.008,0.17-0.09,0.286-0.121\r\n\t\t\t\tc0.07-0.009,0.14-0.017,0.21-0.026c0.132-0.081,0.205-0.497,0.261-0.674c0.15-0.485,0.301-0.97,0.451-1.455\r\n\t\t\t\tc0.028-0.095-0.011-0.189,0.019-0.299c0.026-0.093,0.124-0.146,0.146-0.254c-0.047-0.072-0.09-0.157-0.089-0.273\r\n\t\t\t\tc0.011-0.006,0.021-0.013,0.032-0.019c0.004-0.004,0.008-0.009,0.013-0.013c0.029,0.053,0.07,0.133,0.121,0.165\r\n\t\t\t\tc0.035-0.029,0.114-0.123,0.102-0.191c-0.027-0.053-0.055-0.106-0.083-0.159C42.622,41.831,42.634,41.517,42.555,41.414z\r\n\t\t\t\t M10.068,26.772c0.002,0.004,0.003,0.011,0.005,0.016v-0.016H10.068z M8.337,28.565c0,0.001-0.001,0.002-0.001,0.002\r\n\t\t\t\tc0.001,0.003,0.003,0.003,0.003,0.005C8.339,28.57,8.338,28.567,8.337,28.565z M8.356,28.609\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.356z M14.998,24.644c-0.002-0.004-0.004-0.009-0.006-0.013\r\n\t\t\t\tc-0.021-0.006-0.042-0.013-0.064-0.019c-0.026,0.019-0.046,0.037-0.057,0.07c-0.004,0.002-0.009,0.004-0.013,0.006\r\n\t\t\t\tc-0.032-0.041-0.059-0.112-0.076-0.165v-0.007c0.122-0.058,0.118-0.025,0.216-0.114V24.37c-0.015-0.006-0.03-0.013-0.045-0.019\r\n\t\t\t\tc-0.042,0.02-0.082,0.042-0.14,0.045c-0.035-0.024-0.077-0.055-0.095-0.095c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.049-0.04,0.097-0.081,0.146-0.121c0.013-0.015,0.026-0.03,0.038-0.045c-0.085-0.053-0.196-0.098-0.331-0.083\r\n\t\t\t\tc-0.013,0.023-0.025,0.047-0.038,0.07c-0.139,0.028-0.257-0.06-0.343-0.127v-0.019c0.036-0.036,0.072-0.072,0.108-0.108\r\n\t\t\t\tc-0.044-0.017-0.089-0.034-0.133-0.051c-0.111,0.022-0.1,0.134-0.21,0.159c-0.006-0.249,0.344-0.399,0.241-0.604\r\n\t\t\t\tc0.046-0.013,0.102-0.029,0.14-0.045c0.002-0.008,0.004-0.017,0.006-0.025c-0.004-0.011-0.009-0.021-0.013-0.032\r\n\t\t\t\tc-0.013-0.004-0.025-0.008-0.038-0.013c-0.078,0.021-0.157,0.042-0.235,0.064c-0.19,0.122-0.428,0.489-0.508,0.724\r\n\t\t\t\tc0.032,0.038,0.063,0.076,0.095,0.114c-0.085,0.09-0.178,0.003-0.235,0.165c-0.004,0.008-0.008,0.017-0.013,0.025\r\n\t\t\t\tc0.049,0.013,0.098,0.025,0.146,0.038c-0.09,0.09-0.264,0.111-0.324,0.229c-0.016,0.029,0.012,0.075,0.026,0.114\r\n\t\t\t\tc0.097-0.011,0.195-0.021,0.292-0.032c0.121,0.017,0.242,0.034,0.362,0.051c0.11,0.02,0.23-0.003,0.248-0.083\r\n\t\t\t\tc0.034-0.004,0.068-0.008,0.102-0.013v0.096c0.004,0.006,0.008,0.013,0.013,0.019c0.013-0.002,0.025-0.004,0.038-0.006\r\n\t\t\t\tc0.033-0.011,0.042-0.037,0.051-0.07c0.057,0.006,0.114,0.013,0.172,0.019v0.013c-0.121,0.055-0.153,0.168-0.305,0.21\r\n\t\t\t\tc-0.012,0.026-0.007,0.015,0,0.045c0.033,0.016,0.082,0.021,0.133,0.019c0.096-0.105,0.276-0.194,0.343-0.311\r\n\t\t\t\tc0.011,0.004,0.021,0.008,0.032,0.013c0.021,0.028,0.042,0.055,0.064,0.083c-0.002,0.068-0.031,0.109-0.064,0.146\r\n\t\t\t\tc0.002,0.017,0.004,0.034,0.006,0.051c0.017,0.002,0.034,0.004,0.051,0.006c0.025-0.021,0.051-0.042,0.076-0.063\r\n\t\t\t\tc0.004,0.036,0.008,0.072,0.013,0.108c0.053,0.015,0.106,0.03,0.159,0.045c0.031-0.093,0.108-0.194,0.095-0.299\r\n\t\t\t\tC14.985,24.767,14.974,24.733,14.998,24.644z M30.531,24.606c-0.011,0.008-0.021,0.017-0.032,0.025\r\n\t\t\t\tc0.014,0.032,0.014,0.022,0.057,0.019v0.006c-0.011,0.011-0.021,0.021-0.032,0.032c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.021,0.009,0.042,0.017,0.063,0.026c-0.011,0.015-0.021,0.03-0.032,0.044c0.011,0.009,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.019,0.002,0.038,0.004,0.057,0.006v0.032c0.013,0.002,0.025,0.004,0.038,0.006c0.109-0.111,0.08-0.372,0.076-0.559\r\n\t\t\t\tc-0.008-0.006-0.017-0.013-0.025-0.019c-0.004,0.002-0.008,0.004-0.013,0.006c-0.004,0.03-0.008,0.059-0.013,0.089\r\n\t\t\t\tc-0.002,0.003-0.171,0.074-0.21,0.114c0.001,0.025,0.001,0.024,0.019,0.044c-0.009,0.007-0.017,0.013-0.026,0.019\r\n\t\t\t\tC30.493,24.58,30.509,24.579,30.531,24.606z M35.215,27.014c0.142-0.008,0.284-0.017,0.426-0.025\r\n\t\t\t\tc0.017-0.028,0.025-0.06,0.032-0.102c-0.045,0.028-0.097,0.035-0.146,0.064c-0.008-0.004-0.017-0.009-0.025-0.013\r\n\t\t\t\tc0.004-0.017,0.009-0.034,0.013-0.051c-0.002-0.002-0.004-0.004-0.006-0.006c-0.098,0.011-0.135,0.002-0.21-0.032\r\n\t\t\t\tc-0.07,0.006-0.14,0.013-0.21,0.019c-0.02-0.019-0.014-0.025-0.051-0.032c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c-0.015,0.008-0.03,0.017-0.044,0.026c-0.034-0.012-0.056-0.014-0.076-0.038v-0.013\r\n\t\t\t\tc-0.011,0.013-0.01,0.012-0.013,0.038h-0.032c-0.006,0.032-0.013,0.063-0.019,0.095c0.087,0.039,0.26,0.031,0.356,0.07V27.014z\r\n\t\t\t\t M32.367,26.423c0.035-0.028,0.056-0.073,0.095-0.095c0.013-0.037-0.026-0.055-0.045-0.095c-0.036-0.095,0.072-0.224,0.102-0.292\r\n\t\t\t\tv-0.006c-0.058-0.014-0.12,0.013-0.172,0.025c-0.214,0.053-0.3,0.057-0.458-0.044c-0.091,0.081-0.209,0.007-0.254,0.152\r\n\t\t\t\tc0.043,0.085,0.104,0.06,0.191,0.102C32.004,26.254,32.172,26.367,32.367,26.423z M21.217,10.482\r\n\t\t\t\tc0.035-0.019,0.07-0.038,0.105-0.057c0.055-0.019,0.109-0.037,0.164-0.056c0.003-0.008,0.007-0.017,0.01-0.025\r\n\t\t\t\tc-0.104,0.008-0.218,0.043-0.302,0.036c-0.066,0.038-0.132,0.076-0.197,0.114c-0.025,0.014-0.069,0.026-0.071,0.048\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c0.045-0.002,0.096-0.023,0.138-0.036C21.123,10.502,21.17,10.492,21.217,10.482z\r\n\t\t\t\t M16.682,18.341c-0.01,0.031-0.094,0.043-0.109,0.087c0.001,0.002,0.001,0.003,0.002,0.005c0.076-0.011,0.12-0.032,0.157-0.06\r\n\t\t\t\tc0.001-0.015-0.005-0.022-0.016-0.032C16.705,18.339,16.7,18.338,16.682,18.341z M30.575,25.66\r\n\t\t\t\tc0.019-0.025,0.038-0.051,0.057-0.076c0.054-0.026,0.099,0,0.146,0.013c0.02-0.058,0.068-0.112,0.057-0.197\r\n\t\t\t\tc-0.006-0.047-0.013-0.093-0.019-0.14c0.006-0.036,0.036-0.069,0.044-0.095c0.031-0.095-0.097-0.241-0.153-0.26\r\n\t\t\t\tc-0.085,0.08-0.164,0.087-0.311,0.114c-0.004,0.004-0.008,0.008-0.013,0.013c0.017,0.081,0.077,0.106,0.095,0.197\r\n\t\t\t\tC30.517,25.416,30.356,25.615,30.575,25.66z M30.512,36.559c-0.028,0.032-0.044,0.092-0.089,0.108v0.057\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.013c0.082-0.01,0.066-0.094,0.127-0.127C30.57,36.578,30.553,36.568,30.512,36.559z\r\n\t\t\t\t M26.304,19.147c0.035-0.024,0.05-0.049,0.076-0.083c0.002-0.004,0.004-0.009,0.006-0.013c0.025,0.017,0.051,0.034,0.076,0.051\r\n\t\t\t\tc-0.033,0.09-0.136,0.211-0.089,0.305v0.013c0.082-0.047,0.165-0.094,0.235-0.152h0.025c0.006,0.028,0.013,0.055,0.019,0.083\r\n\t\t\t\tc-0.02,0.027-0.04,0.046-0.076,0.057c-0.009,0.057,0.008,0.105,0.051,0.127c0.034,0.062-0.106,0.181-0.121,0.28\r\n\t\t\t\tc0.051,0.013,0.102,0.025,0.153,0.038c0.024-0.018,0.033-0.026,0.038-0.064c0.038,0.011,0.076,0.021,0.114,0.032\r\n\t\t\t\tc0.138-0.008,0.086-0.079,0.267-0.032c-0.045,0.057-0.103,0.092-0.121,0.178c0.025,0.053,0.055,0.069,0.089,0.108\r\n\t\t\t\tc0.036-0.007,0.072-0.013,0.108-0.019h0.006c-0.005,0.156-0.076,0.23-0.013,0.356v0.006c-0.215,0.003-0.415,0.024-0.489,0.172\r\n\t\t\t\tv0.006h0.133v0.013c0.023,0.036,0.008,0.103,0.006,0.159c-0.078,0.113-0.267,0.119-0.299,0.178\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.025,0.021,0.051,0.042,0.076,0.064c0.085,0.002,0.169,0.004,0.254,0.006\r\n\t\t\t\tc0.061,0.03,0.123,0.059,0.184,0.089h0.013c0.09-0.005,0.137-0.049,0.203-0.076c-0.029,0.06-0.086,0.099-0.089,0.172\r\n\t\t\t\tc-0.131,0.033-0.232-0.046-0.343,0.006c-0.036,0.041-0.02,0.083-0.095,0.07c-0.013,0.136-0.232,0.282-0.35,0.318\r\n\t\t\t\tc-0.002,0.004-0.004,0.009-0.006,0.013c0.032,0.009,0.064,0.017,0.095,0.026c0.015,0.015,0.03,0.03,0.045,0.045\r\n\t\t\t\tc0.052-0.069,0.127-0.122,0.216-0.153c0.045,0.021,0.07,0.005,0.095-0.013c0.108,0.059,0.203,0.111,0.21-0.089\r\n\t\t\t\tc0.2-0.024,0.253-0.004,0.439,0.013c-0.004-0.015-0.009-0.03-0.013-0.044c0.085-0.013,0.17-0.025,0.254-0.038\r\n\t\t\t\tc0.048-0.007,0.063,0.026,0.095,0.032c0.042-0.011,0.085-0.021,0.127-0.032c0.061,0.009,0.123,0.017,0.184,0.025\r\n\t\t\t\tc0.074-0.014,0.1-0.073,0.203-0.064c0.004-0.059,0.085-0.077,0.133-0.089v-0.089h-0.013c-0.014-0.009-0.237-0.029-0.299-0.032\r\n\t\t\t\tV21.13c0.107-0.031,0.369-0.204,0.4-0.299c-0.006-0.055-0.013-0.11-0.019-0.165c-0.087-0.068-0.271-0.169-0.369-0.032\r\n\t\t\t\tc-0.034-0.007-0.068-0.013-0.102-0.019c0.135-0.201,0.055-0.175-0.076-0.318c-0.002-0.002,0.009-0.153-0.025-0.203\r\n\t\t\t\tc-0.049-0.064-0.097-0.127-0.146-0.191c-0.055-0.03-0.115-0.006-0.153-0.051c-0.069-0.084-0.056-0.196-0.095-0.299\r\n\t\t\t\tc-0.031-0.053-0.237-0.227-0.318-0.222c-0.131,0.007-0.14,0.075-0.305,0.006c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.123,0.003,0.258-0.01,0.311-0.076c0.004-0.002,0.008-0.004,0.013-0.006c-0.034-0.019-0.068-0.038-0.102-0.057\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.198-0.003,0.277-0.285,0.331-0.426c0.013-0.025,0.001-0.021-0.013-0.051\r\n\t\t\t\tc-0.1-0.073-0.46-0.024-0.623-0.025c-0.006-0.009-0.013-0.017-0.019-0.025c0.017-0.197,0.253-0.175,0.324-0.311\r\n\t\t\t\tc0.035-0.032,0.013-0.032-0.006-0.07c-0.129-0.052-0.288,0.077-0.407,0.045c-0.038-0.023-0.076-0.047-0.114-0.07\r\n\t\t\t\tc-0.019,0.025-0.038,0.051-0.057,0.076c0.019,0.03,0.038,0.059,0.057,0.089c-0.04,0.013-0.08,0.025-0.121,0.038\r\n\t\t\t\tc0.025,0.051,0.051,0.102,0.076,0.152c-0.05,0.002-0.083-0.003-0.127-0.019c-0.039,0.01-0.054,0.039-0.07,0.07\r\n\t\t\t\tc0.027,0.032,0.055,0.064,0.083,0.095c-0.019,0.03-0.061,0.028-0.076,0.051c0.009,0.04,0.017,0.08,0.026,0.121\r\n\t\t\t\tc0,0-0.102,0.182-0.114,0.203C26.262,19.126,26.283,19.136,26.304,19.147z M23.552,15.69c0.122,0.059,0.229,0.003,0.261-0.114\r\n\t\t\t\tc0.002-0.025,0.004-0.051,0.006-0.076c0.061-0.015,0.123-0.03,0.184-0.045c0.041-0.073,0.083-0.252,0.019-0.337\r\n\t\t\t\tc-0.041-0.048-0.155-0.016-0.222-0.038c-0.027-0.017-0.055-0.034-0.083-0.051c-0.016-0.036-0.003-0.092,0.013-0.134\r\n\t\t\t\tc-0.008-0.015-0.017-0.03-0.025-0.045c-0.139-0.061-0.251-0.035-0.311-0.172c-0.039-0.024-0.106-0.033-0.172-0.032v0.159\r\n\t\t\t\tc-0.129,0.091-0.311,0.046-0.483,0.025c0.022,0.049,0.05,0.087,0.044,0.146c-0.091-0.002-0.162-0.057-0.191-0.121\r\n\t\t\t\tc-0.062-0.048-0.149-0.012-0.216,0.038c0.011,0.034,0.021,0.068,0.032,0.102v0.007c-0.017,0.006-0.034,0.013-0.051,0.019\r\n\t\t\t\tc-0.074-0.049-0.145-0.122-0.178-0.21h-0.006c-0.017,0.011-0.034,0.021-0.051,0.032c-0.031,0.052-0.008,0.145-0.006,0.229\r\n\t\t\t\tc-0.045,0.048-0.112,0.04-0.172,0.076c-0.032,0.029-0.064,0.059-0.095,0.089c-0.034-0.049-0.068-0.097-0.102-0.146\r\n\t\t\t\tc-0.02-0.043,0.074-0.098,0.057-0.178c-0.035-0.162-0.262-0.199-0.413-0.241c-0.015,0.017-0.03,0.034-0.044,0.051\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.042,0.031,0.085,0.071,0.102,0.127v0.006c-0.138,0.096-0.242-0.171-0.324,0.006\r\n\t\t\t\tc0.025,0.034,0.051,0.068,0.076,0.102c0.006,0.006,0.013,0.013,0.019,0.019c-0.08,0.017-0.198,0.021-0.261,0.051\r\n\t\t\t\tc-0.006,0.028-0.008,0.049,0.006,0.07c0.103,0.167,0.277-0.021,0.451,0.007c0.098,0.015,0.167,0.047,0.241,0.076\r\n\t\t\t\tc0.004,0.021,0.009,0.043,0.013,0.064c-0.006,0.019-0.013,0.038-0.019,0.057c-0.108,0.081-0.481,0.067-0.534,0.165\r\n\t\t\t\tc-0.002,0.006-0.004,0.013-0.006,0.019c0.008,0.013,0.017,0.025,0.025,0.038c0.081,0.034,0.262-0.022,0.349-0.038\r\n\t\t\t\tc0.073,0.086,0.103,0.124,0.254,0.14c-0.088,0.128-0.197,0.136-0.292,0.235c0.102,0.124,0.465,0.012,0.616,0.07\r\n\t\t\t\tc0.049,0.034,0.097,0.068,0.146,0.102c0.079,0.046,0.211,0.06,0.311,0.076c0.267,0.044,0.261-0.127,0.369-0.172\r\n\t\t\t\tc0.102-0.013,0.203-0.025,0.305-0.038C23.322,15.873,23.442,15.767,23.552,15.69z M25.078,20.894\r\n\t\t\t\tc-0.023,0.009-0.047,0.017-0.07,0.026c-0.007,0.033,0.006,0.053,0.013,0.089c0.036-0.004,0.072-0.008,0.108-0.013\r\n\t\t\t\tc0.017,0.048,0.015,0.085,0.013,0.146c0.12-0.007,0.193-0.047,0.273-0.07c0.034-0.002,0.068-0.004,0.102-0.006\r\n\t\t\t\tc0.076-0.055,0.153-0.11,0.229-0.165c0.074-0.007,0.148-0.013,0.222-0.019c0.008-0.013,0.017-0.025,0.025-0.038\r\n\t\t\t\tc0.049-0.002,0.097-0.004,0.146-0.006c0.016-0.107,0.079-0.154,0.102-0.229c0.037-0.123-0.067-0.364-0.121-0.439\r\n\t\t\t\tc0.126-0.037,0.169-0.056,0.229-0.159c-0.018-0.123-0.068-0.218-0.102-0.324c-0.094-0.067-0.283-0.037-0.4,0.013\r\n\t\t\t\tc-0.064-0.001-0.088-0.026-0.102-0.076c-0.149,0.013-0.194,0.075-0.229,0.203c-0.025,0.006-0.051,0.013-0.076,0.019\r\n\t\t\t\tc-0.006,0.009-0.013,0.017-0.019,0.025h0.184c-0.025,0.064-0.066,0.089-0.133,0.108c-0.001,0.021,0.008,0.04,0.019,0.063\r\n\t\t\t\tc-0.128-0.01-0.273-0.013-0.375-0.051c-0.045,0.036-0.065,0.068-0.083,0.134v0.038c0.057-0.015,0.088-0.022,0.127,0.013h0.013\r\n\t\t\t\tc-0.037,0.042-0.05,0.035-0.038,0.102c-0.03,0.006-0.059,0.013-0.089,0.019c0.008,0.009,0.017,0.017,0.025,0.025\r\n\t\t\t\tc-0.013,0.017-0.025,0.034-0.038,0.051c0.051,0.024,0.293,0.068,0.343,0.038c0.006,0.017,0.013,0.034,0.019,0.051\r\n\t\t\t\tc-0.083,0.035-0.129,0.014-0.165,0.095c-0.008,0.022-0.004,0.012,0.013,0.038c-0.013,0.019-0.025,0.038-0.038,0.057\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.047-0.006,0.093-0.013,0.14-0.019c-0.018,0.068-0.092,0.065-0.159,0.076\r\n\t\t\t\tc-0.021,0.026-0.02,0.078-0.044,0.102c-0.032,0.024-0.13,0.015-0.184,0.013c-0.002,0.015-0.004,0.03-0.006,0.044\r\n\t\t\t\tc0.047,0.002,0.093,0.004,0.14,0.006V20.894z M26.336,19.465c-0.008,0.048-0.009,0.074,0,0.121\r\n\t\t\t\tc0.011,0.002,0.021,0.004,0.032,0.006c0.011-0.013,0.021-0.025,0.032-0.038c-0.004-0.034-0.009-0.068-0.013-0.102\r\n\t\t\t\tC26.37,19.456,26.353,19.46,26.336,19.465z M37.611,27.116c0.023-0.013,0.016-0.005,0.019-0.038\r\n\t\t\t\tc0.145-0.004,0.169-0.092,0.292-0.102c-0.015-0.019-0.03-0.038-0.045-0.057c0.053-0.068,0.135-0.101,0.191-0.165\r\n\t\t\t\tc-0.1,0.036-0.199,0.072-0.299,0.108c-0.059-0.006-0.119-0.013-0.178-0.019c0.011,0.023,0.012,0.039,0,0.064\r\n\t\t\t\tc-0.006,0.006-0.171,0.045-0.184,0.045c0.012,0.053,0.028,0.071,0.045,0.114C37.497,27.08,37.576,27.089,37.611,27.116z\r\n\t\t\t\t M8.363,28.654h0.006c-0.002-0.006-0.004-0.013-0.006-0.019V28.654z M14.54,13.788c0.035-0.025,0.102-0.125,0.045-0.175\r\n\t\t\t\tc-0.059,0.063-0.171,0.08-0.068,0.171C14.525,13.786,14.532,13.787,14.54,13.788z M8.375,28.698h0.006\r\n\t\t\t\tc-0.004-0.015-0.008-0.029-0.013-0.044C8.371,28.668,8.373,28.683,8.375,28.698z M8.433,28.838\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.023-0.051-0.047-0.102-0.07-0.153C8.389,28.761,8.414,28.792,8.433,28.838z\r\n\t\t\t\t M21.4,11.563c-0.005,0-0.01,0.001-0.015,0.001c-0.058,0.053-0.117,0.105-0.175,0.158c-0.053,0.024-0.106,0.048-0.158,0.072\r\n\t\t\t\tc-0.038,0.029-0.035,0.1-0.05,0.136c-0.008,0.019-0.056,0.102-0.048,0.112c0.02,0.01,0.135-0.027,0.152-0.034\r\n\t\t\t\tc0.041-0.017,0.077-0.038,0.104-0.06c0.011-0.01,0.021-0.021,0.032-0.031c0.029-0.01,0.059-0.019,0.088-0.029\r\n\t\t\t\tc0.028-0.025,0.056-0.049,0.084-0.074c0.003-0.003,0.007-0.007,0.01-0.01c0.014,0.009,0.038,0.018,0.063,0.008\r\n\t\t\t\tc0.047-0.026,0.042-0.069,0.098-0.095C21.602,11.666,21.437,11.588,21.4,11.563z M21.72,10.584c0.002,0,0.003-0.001,0.005-0.001\r\n\t\t\t\tc-0.005-0.006-0.009-0.013-0.014-0.019c-0.016,0.002-0.032,0.005-0.048,0.007c-0.148-0.003-0.224-0.095-0.411-0.061\r\n\t\t\t\tc-0.054,0.025-0.235,0.062-0.254,0.094c-0.029,0.048,0.077,0.08,0.116,0.089c0.134,0.033,0.307,0.006,0.465,0.018\r\n\t\t\t\tc0.029,0.002,0.079,0.007,0.099,0.019c0.015,0.009,0.022,0.026,0.042,0.03c0.032,0.001,0.089-0.042,0.103-0.056\r\n\t\t\t\tc0.001-0.001,0.003-0.002,0.004-0.003c-0.082-0.021-0.2-0.02-0.258-0.064C21.619,10.62,21.669,10.602,21.72,10.584z\r\n\t\t\t\t M14.242,41.547c0.147,0.036,0.426-0.012,0.508-0.108c0.048-0.056,0.064-0.206,0.095-0.267c-0.057-0.054-0.445-0.06-0.591-0.057\r\n\t\t\t\tC14.175,41.239,14.197,41.443,14.242,41.547z M10.822,34.354c0.015,0.038,0.009,0.091,0.013,0.134\r\n\t\t\t\tc0.086,0.022,0.114-0.016,0.203-0.019c0.117-0.003,0.196,0.036,0.216-0.095c-0.077-0.061-0.285-0.049-0.4-0.051\r\n\t\t\t\tC10.843,34.333,10.833,34.343,10.822,34.354z M12.735,25.375c-0.017-0.011-0.034-0.021-0.051-0.032\r\n\t\t\t\tc-0.011-0.1,0.084-0.092,0.133-0.146c0.043-0.048,0.06-0.154,0.095-0.203c-0.04-0.027-0.081-0.055-0.121-0.083\r\n\t\t\t\tc-0.045,0.101-0.251,0.268-0.216,0.413c0.05,0.208,0.421,0.141,0.47-0.025C12.9,25.097,12.854,25.337,12.735,25.375z\r\n\t\t\t\t M10.93,37.912c-0.004,0.006-0.008,0.013-0.013,0.019c0.044,0.003,0.042,0.01,0.063,0.032c-0.012,0.031-0.012,0.05,0,0.083\r\n\t\t\t\tc-0.034,0.015-0.068,0.03-0.102,0.044c-0.004,0.006-0.009,0.013-0.013,0.019v0.007c0.085,0,0.174-0.005,0.242-0.013\r\n\t\t\t\tc0.02-0.081-0.008-0.157,0.032-0.216v-0.006h-0.038C11.059,37.905,10.99,37.913,10.93,37.912z M10.015,33.979\r\n\t\t\t\tc-0.092-0.017-0.212,0.006-0.261-0.083c-0.045,0.004-0.062,0.023-0.089,0.032c-0.04-0.004-0.081-0.008-0.121-0.013\r\n\t\t\t\tc-0.04,0.009-0.059,0.049-0.127,0.038c-0.109-0.017-0.194-0.056-0.324-0.057c-0.027,0.004-0.055,0.008-0.083,0.013\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.026v0.025c0.064,0.033,0.195,0.03,0.229,0.095c0.046,0.078-0.076,0.145,0.095,0.21\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.128,0.082-0.41,0.037-0.572-0.013c-0.013,0.015-0.025,0.03-0.038,0.045\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.034,0.065,0.099,0.077,0.152,0.121c0.05-0.012,0.053-0.047,0.102-0.057\r\n\t\t\t\tc0.076,0.011,0.153,0.021,0.229,0.032c0.078-0.006,0.157-0.013,0.235-0.019c0.048,0.048,0.109,0.151,0.178,0.172\r\n\t\t\t\tc0.044-0.114,0.093-0.196,0.203-0.248c0.021,0.023,0.042,0.047,0.064,0.07c0.075,0.033,0.112-0.06,0.178-0.076\r\n\t\t\t\tc0.044-0.011,0.074,0.012,0.095,0.019c0.129-0.06,0.183,0.045,0.248,0.083c0.039-0.029,0.062-0.074,0.089-0.114\r\n\t\t\t\tC10.38,34.159,10.076,34.16,10.015,33.979z M7.581,34.385c0.019,0.027,0.251,0.169,0.311,0.153\r\n\t\t\t\tc0.044-0.012,0.058-0.078,0.14-0.057c0.051,0.013,0.064,0.04,0.127,0.038c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc-0.073-0.11-0.33-0.158-0.515-0.153C7.628,34.352,7.604,34.368,7.581,34.385z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M31.446,19.655c0.015,0.03,0.03,0.059,0.044,0.089\r\n\t\t\t\tc0.057-0.013,0.103-0.074,0.133-0.115c0.012-0.009,0.004,0,0.013-0.013c-0.023-0.013-0.047-0.026-0.07-0.038\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.069-0.055,0.095-0.122,0.076-0.235c-0.03-0.002-0.059-0.004-0.089-0.006\r\n\t\t\t\tc-0.026,0.029-0.04,0.127-0.051,0.165c-0.058-0.027-0.089-0.049-0.108-0.114c-0.004-0.002-0.009-0.004-0.013-0.006\r\n\t\t\t\tc-0.078,0.099-0.18,0.095-0.076,0.267C31.324,19.671,31.398,19.659,31.446,19.655z M43.382,11.985\r\n\t\t\t\tc0.203,0.031,0.324,0.15,0.496,0.203c-0.004,0.021-0.009,0.042-0.013,0.064c-0.084,0.038-0.182,0.051-0.172,0.172\r\n\t\t\t\tc0.094,0.018,0.165,0.009,0.28,0.006c0.026,0.034,0.051,0.068,0.076,0.102c0.094,0.039,0.143-0.06,0.21-0.083\r\n\t\t\t\tc0.155,0.002,0.309,0.004,0.464,0.007c-0.006-0.127-0.177-0.162-0.254-0.223c-0.136-0.107-0.215-0.333-0.254-0.534\r\n\t\t\t\tc-0.085-0.43,0.254-0.283,0.292-0.597c-0.066-0.023-0.131-0.047-0.197-0.07c-0.172-0.022-0.357,0.059-0.477,0.089\r\n\t\t\t\tc-0.072,0.004-0.144,0.008-0.216,0.013c-0.088,0.044-0.135,0.159-0.235,0.203c-0.004,0.007-0.009,0.013-0.013,0.019\r\n\t\t\t\tc0.051,0.026,0.093,0.062,0.165,0.064c-0.037,0.109-0.134,0.278-0.241,0.311c-0.072,0.022-0.115-0.021-0.172-0.019\r\n\t\t\t\tc-0.049,0.061-0.104,0.114-0.07,0.229c0.019,0.025,0.038,0.051,0.057,0.076C43.251,12.115,43.276,11.969,43.382,11.985z\r\n\t\t\t\t M20.926,10.303c-0.046,0.008-0.091,0.016-0.137,0.024c-0.018,0.026-0.036,0.077-0.072,0.095\r\n\t\t\t\tc0.061,0.013,0.304-0.051,0.354-0.078C21.07,10.309,20.97,10.301,20.926,10.303z M31.37,7.524\r\n\t\t\t\tc0.061-0.032,0.123-0.064,0.184-0.095c0.036,0.055,0.072,0.11,0.108,0.165c-0.076,0.036-0.153,0.072-0.229,0.108\r\n\t\t\t\tc0.055,0.135,0.434,0.457,0.623,0.388c0.163-0.06,0.211-0.226,0.35-0.312c0.086,0.097,0.288,0.173,0.438,0.197v0.006\r\n\t\t\t\tc-0.178,0.189-0.512,0.185-0.769,0.299h-0.013c0.023,0.049,0.047,0.097,0.07,0.146c0.248-0.018,0.442-0.069,0.661-0.089\r\n\t\t\t\tc0.027,0.025,0.055,0.051,0.083,0.076c-0.102,0.131-0.323,0.152-0.559,0.146c-0.023,0.034-0.047,0.068-0.07,0.102\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.102,0.062,0.562,0.443,0.718,0.4c0.032-0.019,0.063-0.038,0.095-0.057\r\n\t\t\t\tc-0.001-0.177,0.066-0.321,0.159-0.407c0.028-0.029,0.124-0.04,0.172-0.044c0.038-0.081,0.076-0.161,0.114-0.242\r\n\t\t\t\tc0.058-0.144,0.054-0.343,0.178-0.419c0.093-0.021,0.187-0.043,0.28-0.064c0.053-0.026,0.106-0.051,0.159-0.076\r\n\t\t\t\tc-0.048-0.083-0.189-0.174-0.28-0.21c-0.082-0.032-0.163-0.021-0.229-0.063c-0.057-0.074-0.114-0.148-0.172-0.222\r\n\t\t\t\tc-0.078,0-0.117,0.083-0.172,0.127C33.238,7.389,33.219,7.38,33.2,7.372c-0.034-0.072,0.005-0.174,0.006-0.28\r\n\t\t\t\tc-0.021-0.015-0.042-0.03-0.064-0.045h-0.172c-0.066-0.021-0.112-0.079-0.21-0.089c-0.036,0.042-0.072,0.085-0.108,0.127\r\n\t\t\t\tc-0.04,0.109,0.108,0.294,0.127,0.4c-0.019,0.017-0.038,0.034-0.057,0.051c-0.108-0.025-0.306-0.287-0.35-0.381\r\n\t\t\t\tc-0.075-0.059-0.101-0.039-0.191,0c-0.015,0.076-0.03,0.153-0.044,0.229v0.013c-0.074-0.015-0.148-0.03-0.222-0.045\r\n\t\t\t\tc-0.036-0.055-0.041-0.146-0.038-0.242c-0.077-0.016-0.176,0.02-0.235,0.032c-0.047-0.004-0.093-0.008-0.14-0.013\r\n\t\t\t\tc-0.146,0.013-0.218,0.074-0.305,0.14C31.219,7.367,31.286,7.485,31.37,7.524z M34.414,7.117v0.006\r\n\t\t\t\tc-0.066,0.146-0.101,0.233-0.28,0.267v0.114c0.275,0.013,0.551,0.025,0.826,0.038c0.059-0.04,0.119-0.081,0.178-0.121\r\n\t\t\t\tc0.078-0.033,0.162-0.016,0.254-0.045c0.078-0.04,0.157-0.08,0.235-0.121c0.104-0.078,0.208-0.157,0.311-0.235\r\n\t\t\t\tc0.002-0.004,0.004-0.008,0.006-0.013c-0.023-0.038-0.047-0.076-0.07-0.114c-0.061-0.017-0.123-0.034-0.184-0.051\r\n\t\t\t\tc-0.119-0.023-0.251,0.029-0.375,0.026c-0.025-0.051-0.051-0.102-0.076-0.153c-0.03-0.011-0.059-0.021-0.089-0.032\r\n\t\t\t\tc-0.132,0.016-0.223,0.14-0.286,0.229h-0.108c-0.028-0.1-0.003-0.248,0.025-0.343c-0.136,0.061-0.143,0.232-0.267,0.292\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c-0.167-0.256-0.328-0.017-0.496-0.134c-0.059-0.07-0.119-0.14-0.178-0.21\r\n\t\t\t\tc-0.081,0.106-0.161,0.212-0.241,0.318c-0.087,0.062-0.151,0.069-0.197,0.172c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tC33.594,7.203,34.035,7.121,34.414,7.117z M20.993,9.697c0.035,0.033,0.134,0.07,0.225,0.035c0.034-0.013,0.049-0.034,0.076-0.05\r\n\t\t\t\tc0.019-0.02,0.038-0.04,0.057-0.061c-0.074-0.021-0.104-0.081-0.222-0.057C21.066,9.601,20.983,9.637,20.993,9.697z\r\n\t\t\t\t M21.388,8.988c-0.081,0.009-0.125-0.079-0.169-0.114c-0.024,0.041-0.114,0.079-0.126,0.107c0,0,0.086,0.119,0.094,0.127\r\n\t\t\t\tc0.011,0.01,0.028,0.019,0.044,0.023c0.039-0.003,0.22-0.108,0.242-0.129c0.013-0.013,0.03-0.035,0.009-0.052\r\n\t\t\t\tC21.451,8.925,21.406,8.976,21.388,8.988z M20.989,9.241c-0.031,0.049,0.059,0.128,0.12,0.118\r\n\t\t\t\tc0.061-0.054,0.045-0.074-0.037-0.096C21.044,9.256,21.017,9.248,20.989,9.241z M20.988,9.24c0,0,0.001,0,0.001,0\r\n\t\t\t\tc0.002-0.004-0.006-0.009-0.002-0.012C20.987,9.233,20.988,9.237,20.988,9.24z M30.588,18.905\r\n\t\t\t\tc0.119-0.015,0.252,0.008,0.413-0.006c0.016-0.051,0.02-0.072,0.064-0.095c-0.01-0.113-0.024-0.131,0.025-0.21\r\n\t\t\t\tc-0.011-0.004-0.021-0.008-0.032-0.013c-0.006,0.01-0.013,0.021-0.019,0.032c-0.055,0.015-0.11,0.03-0.165,0.044\r\n\t\t\t\tc-0.059,0.043-0.078,0.143-0.153,0.172c-0.076,0.008-0.153,0.017-0.229,0.025c-0.051,0.023-0.079,0.083-0.102,0.133\r\n\t\t\t\tc0.028,0.028,0.055,0.055,0.083,0.083C30.523,19.013,30.565,18.998,30.588,18.905z M10.002,26.709v0.006\r\n\t\t\t\tc0.013,0.019,0.025,0.038,0.038,0.057h0.027c-0.006-0.014-0.006-0.034-0.015-0.051C10.036,26.717,10.019,26.713,10.002,26.709z\r\n\t\t\t\t M42.956,34.189c-0.051-0.021-0.102-0.042-0.153-0.064c-0.12,0.085-0.214,0.171-0.388,0.21c-0.076,0.017-0.145-0.016-0.191-0.025\r\n\t\t\t\tc-0.086-0.017-0.139,0.054-0.197,0.07c-0.059-0.006-0.119-0.013-0.178-0.019h-0.013c-0.072,0.047-0.144,0.093-0.216,0.14\r\n\t\t\t\tc-0.099,0.036-0.13-0.059-0.242-0.038c-0.091,0.04-0.182,0.08-0.273,0.121h-0.178c-0.091-0.099-0.215-0.211-0.273-0.337\r\n\t\t\t\tc-0.054-0.014-0.128-0.003-0.191-0.013c-0.004-0.002-0.009-0.004-0.013-0.006v-0.013c0.069-0.033,0.208-0.09,0.261-0.146\r\n\t\t\t\tc-0.006-0.169-0.233-0.211-0.33-0.305c-0.017-0.016-0.033-0.139-0.089-0.191c-0.026-0.024-0.075-0.007-0.108-0.025\r\n\t\t\t\tc-0.089-0.098-0.178-0.195-0.267-0.292c-0.035-0.016-0.076-0.009-0.127-0.006c-0.039-0.054-0.074-0.138-0.133-0.172\r\n\t\t\t\tc-0.019,0.025-0.013,0.083-0.019,0.108c-0.004,0.002-0.008,0.004-0.013,0.007c-0.182-0.153-0.224-0.622-0.331-0.864\r\n\t\t\t\tc-0.049-0.112-0.295-0.163-0.362-0.254c-0.106-0.144-0.038-0.516-0.089-0.724c-0.033-0.135-0.153-0.35-0.254-0.426\r\n\t\t\t\tc-0.05-0.038-0.123-0.051-0.159-0.102c-0.045-0.062-0.051-0.162-0.076-0.242c0.023-0.021,0.047-0.042,0.07-0.064\r\n\t\t\t\tc-0.051-0.051-0.102-0.102-0.153-0.152c-0.139-0.209-0.24-0.462-0.369-0.667c-0.055-0.144-0.11-0.288-0.165-0.432\r\n\t\t\t\tc-0.095-0.171-0.257-0.287-0.299-0.521c0.033-0.045,0.038-0.066,0.095-0.089c0.08,0.245,0.223,0.49,0.4,0.642\r\n\t\t\t\tc0.019,0.021,0.047,0.019,0.076,0.013c0.08-0.159,0.057-0.398,0.184-0.508c-0.074-0.191-0.148-0.381-0.222-0.572\r\n\t\t\t\tc-0.122,0.015-0.164,0.113-0.337,0.019c-0.112,0.08-0.158,0.011-0.28,0.032c-0.042-0.043-0.076-0.051-0.095-0.121\r\n\t\t\t\tc-0.215-0.044-0.454,0.008-0.604,0.108c-0.04,0.032-0.081,0.063-0.121,0.095c-0.079,0.017-0.155-0.048-0.21-0.064\r\n\t\t\t\tc-0.061-0.006-0.123-0.013-0.184-0.019c-0.013-0.017-0.025-0.034-0.038-0.051c-0.148-0.032-0.297-0.064-0.445-0.095h-0.318\r\n\t\t\t\tc-0.058-0.026-0.045-0.125-0.108-0.146h-0.146c-0.077-0.012-0.25-0.041-0.324-0.07c-0.07-0.038-0.033-0.128-0.133-0.172\r\n\t\t\t\tc-0.258-0.113-0.681,0.039-0.782,0.21c-0.137,0.231,0.167,0.358-0.146,0.527c-0.038,0.02-0.088,0.07-0.146,0.064\r\n\t\t\t\tc-0.153-0.018-0.266-0.184-0.4-0.235c-0.132-0.05-0.433-0.054-0.54-0.114c-0.119-0.068-0.137-0.311-0.241-0.35\r\n\t\t\t\tc-0.058-0.021-0.105-0.003-0.152-0.025c-0.028-0.025-0.055-0.051-0.083-0.076c-0.066-0.013-0.131-0.025-0.197-0.038\r\n\t\t\t\tc-0.095,0.006-0.191,0.013-0.286,0.019c-0.129-0.055-0.258-0.11-0.388-0.165c-0.009-0.034-0.017-0.068-0.025-0.102\r\n\t\t\t\tc-0.061-0.005-0.069,0.013-0.121,0.025c-0.082-0.04-0.182-0.111-0.203-0.21c0.059-0.065,0.326-0.286,0.324-0.369\r\n\t\t\t\tc-0.011-0.042-0.021-0.085-0.032-0.127c-0.337-0.192,0.008-0.272,0.006-0.483c-0.064,0.038-0.127,0.076-0.191,0.115\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c-0.018-0.04-0.036-0.072-0.038-0.127c-0.047-0.021-0.093-0.042-0.14-0.064\r\n\t\t\t\tc-0.03,0.004-0.059,0.009-0.089,0.013c-0.095,0.036-0.266,0.212-0.432,0.165c-0.024-0.007-0.062-0.069-0.14-0.096\r\n\t\t\t\tc-0.063,0.009-0.084,0.051-0.133,0.076c-0.076-0.012-0.113-0.06-0.178-0.083c-0.078,0.055-0.155,0.115-0.267,0.14\r\n\t\t\t\tc-0.173,0.039-0.303-0.115-0.502-0.063c-0.038,0.021-0.076,0.042-0.114,0.063c-0.073,0.026-0.104-0.027-0.159-0.019\r\n\t\t\t\tc-0.047,0.021-0.093,0.042-0.14,0.064c-0.145,0.03-0.312-0.005-0.432,0.044c-0.114,0.047-0.181,0.142-0.267,0.216\r\n\t\t\t\tc-0.046-0.004-0.065-0.015-0.089-0.038c-0.039,0.007-0.209,0.066-0.242,0.089c-0.08,0.057-0.073,0.137-0.191,0.172\r\n\t\t\t\tc-0.13,0.038-0.283-0.002-0.318-0.089c-0.007-0.002-0.345,0.103-0.477,0.064c-0.138-0.041-0.19-0.153-0.28-0.242\r\n\t\t\t\tc-0.032,0.015-0.064,0.03-0.095,0.045c-0.071,0.054-0.17,0.43-0.248,0.534c-0.114,0.152-0.324,0.164-0.483,0.273\r\n\t\t\t\tc-0.054,0.037-0.227,0.186-0.248,0.241c-0.022,0.058,0.009,0.132-0.019,0.191c-0.035,0.073-0.121,0.127-0.153,0.21\r\n\t\t\t\tc-0.075,0.199,0.155,0.303-0.006,0.54c-0.101,0.149-0.406,0.41-0.578,0.483c-0.089,0.038-0.211,0.03-0.305,0.076\r\n\t\t\t\tc-0.108,0.053-0.13,0.288-0.203,0.381c-0.059,0.074-0.188,0.088-0.242,0.165c-0.056,0.081-0.105,0.204-0.127,0.311\r\n\t\t\t\tc-0.002,0.044-0.004,0.089-0.006,0.134c-0.04,0.101-0.18,0.151-0.242,0.235c-0.063,0.146-0.127,0.292-0.191,0.438\r\n\t\t\t\tc-0.047,0.051-0.093,0.102-0.14,0.153c-0.056,0.084-0.082,0.256-0.064,0.388c0.015-0.017,0.03-0.034,0.044-0.051\r\n\t\t\t\tc0.199,0.016,0.209,0.339,0.114,0.477c0.233,0.184,0.095,0.554,0.025,0.788c-0.008,0.068-0.017,0.136-0.025,0.203\r\n\t\t\t\tc-0.037,0.135-0.145,0.317-0.273,0.362c-0.002,0.004-0.004,0.008-0.006,0.013c0.181,0.076,0.181,0.271,0.267,0.311\r\n\t\t\t\tc0.01,0.02,0.013,0.041,0.013,0.076c-0.019,0.004-0.038,0.008-0.057,0.013c-0.049,0.069-0.01,0.177-0.032,0.261\r\n\t\t\t\tc0.08,0.135,0.04,0.036,0.14,0.102c0.004,0.015,0.008,0.03,0.013,0.044c0.042,0.025,0.085,0.051,0.127,0.076\r\n\t\t\t\tc0.063-0.012,0.153-0.052,0.203,0.006c-0.039,0.048-0.093,0.079-0.076,0.165c0.026,0.017,0.08,0.022,0.102,0.044\r\n\t\t\t\tc0.015,0.02,0.01,0.028,0.006,0.057c0.034,0.023,0.057,0.034,0.121,0.032c0.011,0.033,0.011,0.06,0,0.095\r\n\t\t\t\tc0.065,0.069,0.166,0.135,0.267,0.165c0.006,0.032,0.013,0.063,0.019,0.095c0.033,0.061,0.118,0.081,0.14,0.159v0.095\r\n\t\t\t\tc0.014,0.018,0.035,0.022,0.063,0.025c0.002,0.008,0.004,0.017,0.006,0.025c-0.023,0.019-0.047,0.038-0.07,0.057h-0.013\r\n\t\t\t\tc0.028,0.094,0.156,0.186,0.261,0.203c0.018,0.034,0.013,0.047,0.006,0.095c0.142,0.043,0.215,0.149,0.324,0.222\r\n\t\t\t\tc0.08,0.042,0.161,0.085,0.242,0.127c0.17,0.12,0.278,0.261,0.477,0.362c0.062,0.032,0.311,0.192,0.388,0.172\r\n\t\t\t\tc0.102-0.053,0.203-0.106,0.305-0.159c0.106-0.029,0.212-0.059,0.318-0.089c0.092-0.027,0.292-0.048,0.407-0.025\r\n\t\t\t\tc0.05,0.01,0.145,0.061,0.21,0.038c0.011-0.013,0.021-0.025,0.032-0.038c0.041,0.005,0.246,0.134,0.286,0.165\r\n\t\t\t\tc0.206-0.093,0.411-0.186,0.616-0.28c0.087-0.008,0.174-0.017,0.261-0.025c0.052-0.039,0.054-0.108,0.127-0.133\r\n\t\t\t\tc0.214-0.019,0.428-0.038,0.642-0.057c0.032-0.012,0.039-0.042,0.083-0.057c0.077,0.015,0.286,0.147,0.331,0.203\r\n\t\t\t\tc0.015,0.025,0.03,0.051,0.044,0.076c0.023,0.002,0.047,0.004,0.07,0.006c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.013,0.032-0.025,0.064-0.038,0.095c0.025,0.209,0.348,0.363,0.534,0.197c0.101,0.017,0.232,0.039,0.343-0.006\r\n\t\t\t\tc0.002-0.027-0.002-0.037-0.013-0.063c0.025-0.016,0.147,0.013,0.178,0.051c0.069,0.124-0.004,0.172,0.222,0.165\r\n\t\t\t\tc0.008,0.013,0.017,0.026,0.025,0.038c0.004,0.004,0.008,0.008,0.013,0.013c-0.019,0.015-0.038,0.03-0.057,0.044\r\n\t\t\t\tc0.021,0.08,0.085,0.147,0.102,0.242c-0.011,0.042-0.021,0.085-0.032,0.127c0.009,0.032,0.017,0.064,0.025,0.095\r\n\t\t\t\tc-0.024,0.1-0.086,0.2-0.153,0.261c-0.002,0.006-0.004,0.013-0.006,0.019c0.025,0.004,0.051,0.008,0.076,0.013\r\n\t\t\t\tc0.003,0.084-0.012,0.146-0.076,0.165c0.049,0.042,0.097,0.085,0.146,0.127v0.006c-0.038-0.004-0.076-0.009-0.114-0.013\r\n\t\t\t\tc-0.031,0.138-0.072,0.242-0.191,0.292c0.013,0.028,0.052,0.116,0.076,0.14c0.036,0.035,0.074,0.015,0.114,0.07\r\n\t\t\t\tc-0.021,0.015-0.042,0.03-0.063,0.045c-0.002,0.004-0.004,0.008-0.006,0.013c0.042,0.062,0.085,0.123,0.127,0.184\r\n\t\t\t\tc0.053,0.027,0.074,0.003,0.108,0.045c-0.011,0.015-0.021,0.03-0.032,0.044c0.089,0.058,0.143,0.122,0.203,0.21\r\n\t\t\t\tc0.112,0.104,0.224,0.208,0.337,0.311c0.032,0.039,0.115,0.204,0.133,0.248c0.029,0.068-0.018,0.161,0.038,0.261\r\n\t\t\t\tc0.045,0.064,0.089,0.127,0.133,0.191c0.013,0.061,0.025,0.123,0.038,0.184c0.057,0.134,0.17,0.186,0.14,0.388\r\n\t\t\t\tc-0.243,0.109,0.046,0.36,0.089,0.489c0.008,0.1,0.017,0.199,0.025,0.299c-0.019,0.11-0.066,0.285-0.146,0.337\r\n\t\t\t\tc-0.03,0.01-0.059,0.021-0.089,0.032c-0.017,0.04-0.034,0.081-0.051,0.121c-0.03,0.032-0.059,0.064-0.089,0.096\r\n\t\t\t\tc-0.094,0.222-0.042,0.57-0.222,0.705c0,0.202-0.037,0.471,0.013,0.648c0.038,0.135,0.15,0.217,0.216,0.324\r\n\t\t\t\tc0.108,0.216,0.216,0.432,0.324,0.648c0.075,0.146,0.371,0.404,0.203,0.572c0.03,0.14,0.059,0.28,0.089,0.419\r\n\t\t\t\tc0.023,0.055,0.047,0.11,0.07,0.165c0.02,0.082-0.031,0.143-0.025,0.203c0.008,0.08,0.071,0.147,0.089,0.21\r\n\t\t\t\tc0.014,0.047-0.021,0.073-0.019,0.102c0.034,0.104,0.068,0.208,0.102,0.311c0.117,0.131,0.233,0.263,0.349,0.394\r\n\t\t\t\tc0.12,0.189,0.16,0.433,0.273,0.635c0.1,0.178,0.271,0.36,0.203,0.654c-0.033,0.008-0.077,0-0.095,0.025\r\n\t\t\t\tc-0.025,0.032,0.123,0.23,0.159,0.286c-0.017,0.049-0.034,0.098-0.051,0.146c0.011,0.011,0.021,0.021,0.032,0.032\r\n\t\t\t\tc0.006,0.002,0.013,0.004,0.019,0.006c0.006-0.015,0.013-0.03,0.019-0.045c0.017-0.008,0.022-0.011,0.051-0.013\r\n\t\t\t\tc0.013,0.023,0.025,0.047,0.038,0.07c0.027-0.001,0.052-0.007,0.102-0.006c0.021,0.029,0.022,0.055,0.038,0.095\r\n\t\t\t\tc0.024,0.042,0.115,0.075,0.165,0.089c0.06-0.046,0.096-0.122,0.178-0.146c0.115-0.035,0.251,0.044,0.356-0.006\r\n\t\t\t\tc0.032-0.03,0.063-0.059,0.095-0.089c0.15-0.071,0.214,0,0.331,0c0.034-0.019,0.068-0.038,0.102-0.057\r\n\t\t\t\tc0.122-0.035,0.234,0.073,0.318,0.102c0.04-0.031,0.07-0.055,0.095-0.102c0.057,0.013,0.114,0.025,0.172,0.038\r\n\t\t\t\tc0.017-0.018,0.02-0.053,0.032-0.076c0.05-0.048,0.322-0.017,0.4-0.07c0.083-0.072,0.165-0.144,0.248-0.216\r\n\t\t\t\tc0.416-0.327,0.721-0.688,1.017-1.138c0.074-0.113,0.264-0.191,0.305-0.299c0.02-0.052-0.028-0.122-0.019-0.146\r\n\t\t\t\tc0.016-0.044,0.065-0.032,0.089-0.064c0.071-0.091,0.109-0.35,0.089-0.496c-0.038-0.015-0.078-0.04-0.095-0.076\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.019c0.078-0.091,0.132-0.175,0.242-0.235c0.244-0.134,0.525-0.121,0.635-0.388\r\n\t\t\t\tc-0.009-0.061-0.052-0.036-0.064-0.07c0.002-0.006,0.004-0.013,0.006-0.019c0.013-0.032,0.025-0.064,0.038-0.095\r\n\t\t\t\tc0.03-0.123,0.023-0.264,0.019-0.388c-0.028,0.01-0.035,0.018-0.076,0.019c-0.039-0.124-0.087-0.274-0.044-0.375\r\n\t\t\t\tc-0.006-0.075-0.062-0.112-0.114-0.14v-0.203c0.119-0.087,0.237-0.174,0.356-0.261c0.145-0.122,0.233-0.305,0.4-0.407\r\n\t\t\t\tc0.203-0.123,0.451-0.162,0.642-0.292c0.137-0.094,0.224-0.268,0.331-0.394c0-0.028-0.009-0.039-0.019-0.07\r\n\t\t\t\tc0.036-0.047,0.068-0.081,0.095-0.14c-0.002-0.011-0.004-0.021-0.006-0.032c-0.023-0.011-0.047-0.021-0.07-0.032\r\n\t\t\t\tc-0.02-0.163,0.012-0.337-0.07-0.432c0.003-0.034,0.034-0.063,0.044-0.108c0.026-0.113-0.041-0.294-0.057-0.394\r\n\t\t\t\tc0.03-0.055,0.059-0.11,0.089-0.165c-0.065-0.14-0.183-0.157-0.267-0.267c-0.083-0.108-0.127-0.393-0.07-0.553\r\n\t\t\t\tc-0.018-0.028-0.043-0.033-0.064-0.057c0.029-0.062,0.083-0.148,0.089-0.216c-0.057-0.071-0.161-0.126-0.197-0.216\r\n\t\t\t\tc-0.037-0.095,0.061-0.407,0.102-0.451c0.024-0.026,0.068-0.021,0.089-0.051c0.047-0.068,0.006-0.104,0.025-0.165\r\n\t\t\t\tc0.042-0.137,0.172-0.143,0.184-0.368c0.096-0.053,0.187-0.052,0.191-0.203c0.085,0.016,0.124-0.022,0.191-0.051\r\n\t\t\t\tc0.024-0.036,0.026-0.054,0.006-0.095c0.208-0.235,0.415-0.47,0.623-0.705c0.229-0.185,0.515-0.325,0.744-0.508\r\n\t\t\t\tc0.085-0.104,0.169-0.208,0.254-0.311c0.168-0.215,0.419-0.422,0.527-0.686c0.011-0.049,0.021-0.098,0.032-0.146\r\n\t\t\t\tc0.074-0.119,0.148-0.237,0.222-0.356c-0.002-0.028-0.004-0.055-0.006-0.083c0.042-0.04,0.085-0.081,0.127-0.121\r\n\t\t\t\tc0.055-0.098,0.11-0.195,0.165-0.292c0.006-0.087,0.013-0.174,0.019-0.261c0.014-0.04,0.079-0.07,0.076-0.127\r\n\t\t\t\tc-0.002-0.045-0.037-0.108-0.019-0.172c0.017-0.04,0.034-0.081,0.051-0.121C42.96,34.201,42.958,34.195,42.956,34.189z\r\n\t\t\t\t M51.688,35.155c-0.032-0.185-0.128-0.278-0.28-0.375c0.018,0.077-0.003,0.113-0.025,0.191c-0.034,0.026-0.04,0.042-0.095,0.025\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.013,0.044c0.015,0.017,0.03,0.034,0.044,0.051c-0.029,0.063-0.008,0.077,0.006,0.14v0.318\r\n\t\t\t\tc0.023,0.101,0.073,0.267,0.146,0.324c0.208,0.044,0.476-0.139,0.451-0.337c-0.011-0.089-0.093-0.163-0.127-0.235\r\n\t\t\t\tC51.76,35.226,51.767,35.185,51.688,35.155z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c17.673,0,32-14.327,32-32\r\n\t\t\t\tC64,14.327,49.673,0,32,0z M50.505,13.747c0.043,0.044,0.081,0.093,0.124,0.137c-0.003,0.02-0.006,0.039-0.008,0.059v0.006\r\n\t\t\t\tc0.027,0.007,0.053,0.01,0.08,0.013c0.048,0.049,0.092,0.103,0.139,0.153c-0.13,0.026-0.317,0.022-0.352-0.084\r\n\t\t\t\tC50.47,14.004,50.497,13.865,50.505,13.747z M48.568,14.508c0.038,0.017,0.076,0.034,0.114,0.051\r\n\t\t\t\tc0.07-0.025,0.14-0.051,0.21-0.076c-0.013-0.036-0.025-0.072-0.038-0.108c0.033-0.077,0.142-0.097,0.203-0.146\r\n\t\t\t\tc0.083-0.066,0.227-0.183,0.267-0.286c0.015-0.059,0.03-0.119,0.044-0.178c0.022-0.052,0.06-0.069,0.064-0.146\r\n\t\t\t\tc-0.099-0.13-0.202-0.041-0.254-0.292c0.002-0.127,0.004-0.254,0.006-0.381c-0.008-0.074-0.017-0.148-0.025-0.222\r\n\t\t\t\tc0.032-0.042,0.064-0.085,0.095-0.127c0.001-0.002-0.001-0.005,0-0.008c0.099,0.088,0.195,0.177,0.293,0.266\r\n\t\t\t\tc-0.012,0.031-0.036,0.06-0.038,0.092c-0.006,0.103,0.07,0.19,0.07,0.324c0.102-0.002,0.239,0.039,0.311,0.025\r\n\t\t\t\tc0.034-0.012,0.069-0.024,0.103-0.036c0.075,0.072,0.157,0.137,0.232,0.211c-0.214-0.04-0.47,0.008-0.5,0.206\r\n\t\t\t\tc0.056,0.099,0.113,0.168,0.108,0.318c-0.042,0.053-0.085,0.106-0.127,0.159c-0.034,0.021-0.068,0.042-0.102,0.064\r\n\t\t\t\tc-0.044,0.061-0.038,0.157-0.095,0.203c-0.14,0.113-0.327,0.134-0.407,0.311c-0.085,0.039-0.185,0.002-0.261-0.013\r\n\t\t\t\tc-0.053,0.002-0.106,0.004-0.159,0.006c-0.219-0.032-0.424-0.055-0.502-0.229C48.308,14.462,48.449,14.461,48.568,14.508z\r\n\t\t\t\t M14.404,12.899c-0.002,0.011-0.006,0.023,0.013,0.034c0.011,0.006,0.027,0.004,0.044,0.005c0.046,0.003,0.104,0.019,0.122,0.05\r\n\t\t\t\tc-0.03,0.071-0.177,0-0.221-0.006c0,0.003,0,0.006,0,0.008c-0.005,0-0.011,0-0.016,0c-0.003,0.077,0.276,0.05,0.304,0.123\r\n\t\t\t\tc-0.032,0.036-0.081,0.019-0.141,0.035c-0.004,0.062,0.16,0.026,0.146,0.083c0,0.002-0.001,0.003-0.001,0.005\r\n\t\t\t\tc-0.043,0.013-0.078-0.002-0.117,0.012c-0.004,0.003-0.007,0.006-0.01,0.009c0,0.003,0,0.006,0,0.008\r\n\t\t\t\tc0.031,0.019,0.072,0.042,0.132,0.023c0.017-0.006,0.036-0.014,0.054-0.012c0.006,0.002,0.012,0.003,0.017,0.005\r\n\t\t\t\tc0.003,0.02-0.019,0.063-0.05,0.071c-0.034,0.009-0.199-0.014-0.228-0.021c-0.059-0.015-0.101-0.05-0.147-0.078\r\n\t\t\t\tc-0.04-0.024-0.124-0.06-0.197-0.085C14.204,13.077,14.305,12.99,14.404,12.899z M13.524,13.715\r\n\t\t\t\tc0.019,0.012,0.039,0.022,0.052,0.039c-0.03-0.002-0.064,0.005-0.097,0.01C13.495,13.749,13.509,13.731,13.524,13.715z\r\n\t\t\t\t M7.943,27.904c0.017-0.004,0.034-0.008,0.051-0.013c-0.017,0.015-0.034,0.03-0.051,0.045\r\n\t\t\t\tC7.945,27.925,7.941,27.918,7.943,27.904z M7.499,23.367c-0.001,0.007,0,0.011-0.001,0.018c-0.002-0.002-0.002-0.004-0.004-0.006\r\n\t\t\t\tC7.496,23.376,7.497,23.372,7.499,23.367z M7.676,37.665c-0.049,0.065-0.234,0.104-0.337,0.051\r\n\t\t\t\tc-0.044,0.033-0.061,0.065-0.057,0.146c-0.015,0.013-0.03,0.025-0.044,0.038c-0.012-0.052-0.021-0.069-0.07-0.083\r\n\t\t\t\tc-0.033-0.007-0.066,0.023-0.095,0.038c-0.203,0.107-0.124,0.25-0.191,0.438c-0.026,0.005-0.052,0.01-0.079,0.015\r\n\t\t\t\tc-0.076-0.302-0.168-0.598-0.232-0.904c0.011,0.001,0.019,0.005,0.032,0.006c0.029,0.082,0.054,0.128,0.146,0.146\r\n\t\t\t\tc0.004-0.028,0.009-0.055,0.013-0.083h0.006c0.023,0.048,0.076,0.109,0.064,0.172c0.006,0.006,0.013,0.013,0.019,0.019\r\n\t\t\t\tc0.114,0.02,0.144-0.047,0.248-0.057c-0.01-0.111-0.095-0.121-0.133-0.203c0.039-0.058,0.138-0.099,0.21-0.121\r\n\t\t\t\tc-0.003-0.04-0.005-0.057,0.006-0.089c0.198-0.063,0.318-0.017,0.375,0.14c0.045,0.008,0.076-0.016,0.108-0.038\r\n\t\t\t\tc-0.001,0.049,0.005,0.067,0.038,0.083c0.002,0.004,0.004,0.009,0.006,0.013c-0.061-0.008-0.097-0.021-0.121,0.032\r\n\t\t\t\tC7.564,37.5,7.647,37.606,7.676,37.665z M32,58c-7.083,0-13.497-2.841-18.187-7.435c0.051-0.052,0.122-0.09,0.155-0.153\r\n\t\t\t\tc0.019-0.078,0.038-0.157,0.057-0.235v-0.013c0.049,0.022,0.108,0.044,0.172,0.019h0.006c0.013,0.192-0.204,0.292-0.248,0.483\r\n\t\t\t\tc0.103-0.092,0.237-0.221,0.299-0.349c0.051-0.121,0.102-0.242,0.153-0.362c0.174-0.277,0.481-0.299,0.394-0.852\r\n\t\t\t\tc-0.012-0.077-0.036-0.114-0.057-0.172c0.045-0.054,0.132-0.205,0.019-0.254v-0.038c0.146,0.013,0.159-0.073,0.235-0.14\r\n\t\t\t\tc0.08-0.07,0.491-0.363,0.585-0.381c0.051-0.01,0.091,0.021,0.127,0.032c0.03-0.036,0.059-0.072,0.089-0.108\r\n\t\t\t\tc0.086-0.051,0.144-0.034,0.165-0.153c0.094-0.012,0.207-0.008,0.28,0.006c0.161,0.031,0.334-0.013,0.483-0.025\r\n\t\t\t\tc-0.005-0.182,0.137-0.241,0.292-0.254c-0.009-0.051-0.017-0.102-0.025-0.153c0.017-0.123,0.117-0.202,0.172-0.292\r\n\t\t\t\tc0.034-0.07,0.068-0.14,0.102-0.21c0.032-0.046,0.105-0.072,0.121-0.133c-0.006-0.062-0.013-0.123-0.019-0.184\r\n\t\t\t\tc-0.03-0.169,0.065-0.288,0.184-0.331c0-0.048-0.035-0.138-0.019-0.222c0.021-0.107,0.097-0.243,0.076-0.369\r\n\t\t\t\tc-0.017-0.165-0.034-0.331-0.051-0.496c0.028-0.172,0.093-0.289,0.095-0.464c0.015,0.002,0.03,0.004,0.044,0.006\r\n\t\t\t\tc0.017,0.034,0.034,0.068,0.051,0.102h0.019c0.113-0.084,0.241-0.308,0.292-0.445c0.031-0.081,0.007-0.126,0.057-0.178\r\n\t\t\t\tc0.047-0.021,0.093-0.042,0.14-0.064c0.273-0.213,0.461-0.44,0.534-0.858c0.027-0.157-0.139-0.732-0.216-0.756\r\n\t\t\t\tc-0.161-0.05-0.338,0.008-0.458-0.07c-0.256-0.166-0.436-0.435-0.731-0.566c-0.171-0.076-0.287,0.017-0.451-0.013\r\n\t\t\t\tc-0.1-0.015-0.199-0.03-0.299-0.045c-0.086-0.023-0.18-0.133-0.286-0.121c-0.154,0.018-0.289,0.139-0.394,0.21\r\n\t\t\t\tc-0.049-0.2,0.024-0.122,0.044-0.242c0.013-0.077-0.114-0.195-0.184-0.203c-0.017,0.017-0.034,0.034-0.051,0.051h-0.025\r\n\t\t\t\tc-0.054-0.172-0.227-0.156-0.394-0.216c-0.065-0.023-0.106-0.068-0.159-0.102c-0.052,0.007-0.15,0.015-0.216,0.032\r\n\t\t\t\tc-0.072,0.028-0.08,0.13-0.121,0.191c-0.069,0.101-0.227,0.129-0.28,0.248c-0.004,0.002-0.008,0.004-0.013,0.006\r\n\t\t\t\tc0-0.07,0.012-0.1,0.032-0.146c-0.111,0.023-0.259,0.048-0.394,0.026c-0.032-0.076-0.064-0.153-0.095-0.229\r\n\t\t\t\tc-0.088,0.024-0.202,0.166-0.318,0.121c-0.006-0.004-0.013-0.008-0.019-0.013c0.085-0.065,0.102-0.2,0.159-0.292\r\n\t\t\t\tc0.065-0.105,0.205-0.137,0.28-0.229c0.067-0.082,0.092-0.211,0.197-0.254c0.034-0.054,0.016-0.107-0.006-0.165\r\n\t\t\t\tc-0.262-0.036-0.276-0.356-0.343-0.578c-0.021-0.068-0.016-0.143-0.076-0.172c-0.031-0.005-0.044,0.032-0.076,0.025\r\n\t\t\t\tc-0.015-0.003-0.319-0.315-0.4-0.356c-0.11-0.036-0.22-0.072-0.331-0.108c-0.09-0.035-0.342-0.112-0.489-0.051\r\n\t\t\t\tc-0.016,0.014-0.018,0.027-0.019,0.057c-0.095-0.021-0.191-0.042-0.286-0.064h-0.006c-0.015,0.015-0.03,0.03-0.044,0.045\r\n\t\t\t\tc-0.061-0.12-0.214-0.314-0.388-0.292c-0.011,0.021-0.021,0.042-0.032,0.063v0.013c-0.013-0.091-0.026-0.182-0.038-0.273\r\n\t\t\t\tc-0.074-0.125-0.313-0.283-0.47-0.318c-0.084-0.018-0.176,0.005-0.241,0.019c-0.066-0.004-0.131-0.008-0.197-0.013v-0.006\r\n\t\t\t\tc0.187-0.058,0.138-0.167,0.273-0.222c0.002-0.004,0.004-0.008,0.006-0.013c-0.051-0.035-0.122-0.045-0.178-0.083\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c-0.045-0.029-0.132-0.021-0.172-0.045c-0.027,0.019-0.038,0.036-0.045,0.076\r\n\t\t\t\tc-0.004,0.002-0.008,0.004-0.013,0.006c-0.012-0.113-0.097-0.154-0.184-0.191V37.97c0.059,0.002,0.119,0.004,0.178,0.006\r\n\t\t\t\tc0.011-0.006,0.021-0.013,0.032-0.019c0.004-0.009,0.008-0.017,0.013-0.025c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.129-0.028-0.42-0.039-0.54,0.019c-0.075,0.037-0.117,0.126-0.21,0.146c-0.261,0.058-0.335-0.149-0.496-0.159\r\n\t\t\t\tc-0.136-0.008-0.364,0.083-0.483,0.025c-0.058-0.029-0.044-0.057-0.07-0.121c-0.05-0.125-0.201-0.158-0.375-0.159\r\n\t\t\t\tc-0.033-0.051-0.073-0.137-0.089-0.197c-0.053-0.012-0.097,0.016-0.114,0.064c0.015,0.025,0.03,0.051,0.044,0.076\r\n\t\t\t\tc0.028-0.002,0.055-0.004,0.083-0.006c0.013,0.011,0.025,0.021,0.038,0.032c-0.016,0.063-0.425,0.178-0.515,0.21\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.008,0.036-0.018,0.036-0.038,0.057c0.053,0.026,0.197,0.299,0.152,0.394\r\n\t\t\t\tc-0.025,0.044-0.094,0.072-0.152,0.083c-0.065-0.049-0.097-0.164-0.146-0.229c0.015-0.1,0.07-0.186,0.121-0.254\r\n\t\t\t\tc-0.012-0.102-0.056-0.167-0.089-0.254c0.041-0.061,0.144-0.086,0.241-0.089c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.013-0.064-0.059-0.101-0.114-0.121c-0.156-0.06-0.195,0.139-0.273,0.184c-0.04,0.013-0.081,0.025-0.121,0.038\r\n\t\t\t\tc0.019-0.036,0.046-0.051,0.032-0.102c0.027,0.011,0.029,0.016,0.038,0.045h0.006c0.052-0.033,0.079-0.079,0.121-0.121\r\n\t\t\t\tc-0.08-0.166-0.161-0.342-0.337-0.413c-0.058-0.023-0.134,0.003-0.203-0.026c-0.026-0.01-0.121-0.049-0.159-0.038\r\n\t\t\t\tc-0.047,0.032-0.093,0.064-0.14,0.095c-0.03,0.018-0.063,0.012-0.102,0.026c-0.12,0.043-0.172,0.128-0.331,0.095\r\n\t\t\t\tc-0.05-0.063-0.09-0.028-0.135-0.022c-0.26-1.288-0.395-2.619-0.457-3.968c0.016-0.002,0.033-0.001,0.046-0.007\r\n\t\t\t\tc0.167-0.078,0.167-0.194,0.47-0.121c0.006,0.011,0.013,0.021,0.019,0.032v0.006c-0.047,0.013-0.093,0.025-0.14,0.038\r\n\t\t\t\tc0.108,0.084,0.261,0.035,0.419,0.083c0.114,0.034,0.208,0.114,0.337,0.146c0.067,0.017,0.202-0.02,0.261,0.019\r\n\t\t\t\tc0.043,0.025,0.066,0.123,0.07,0.184c0.099,0.06,0.295,0.06,0.388,0.127c-0.006,0.065-0.053,0.106-0.102,0.127\r\n\t\t\t\tc-0.019,0.021-0.038,0.042-0.057,0.063v0.006c0.141,0.006,0.266-0.057,0.394-0.038c0.097,0.011,0.195,0.021,0.292,0.032\r\n\t\t\t\tc0.105-0.019,0.2-0.058,0.324-0.07c0.002-0.004,0.004-0.008,0.006-0.013c-0.124-0.092-0.202-0.151-0.432-0.146\r\n\t\t\t\tc-0.006-0.006-0.013-0.013-0.019-0.019c0.013-0.028,0.025-0.055,0.038-0.083c-0.079-0.081-0.36-0.089-0.483-0.14\r\n\t\t\t\tc-0.04-0.044-0.08-0.089-0.121-0.133c-0.131-0.09-0.318-0.074-0.477-0.146c-0.064-0.053-0.127-0.106-0.191-0.159H7.022\r\n\t\t\t\tc-0.163-0.037-0.338-0.074-0.559-0.07c-0.083,0.008-0.165,0.017-0.248,0.025c-0.059,0.014-0.109,0.043-0.163,0.068\r\n\t\t\t\tC6.038,32.677,6,32.344,6,32c0-0.404,0.042-0.798,0.06-1.198c0.069,0.073,0.127,0.176,0.179,0.209\r\n\t\t\t\tc0.057,0.035,0.12,0.025,0.133,0.102c-0.021,0.115-0.042,0.229-0.064,0.343c0.008,0.002,0.017,0.004,0.025,0.006\r\n\t\t\t\tc0.036,0.022,0.05-0.017,0.089-0.032c0.002,0.019,0.004,0.038,0.006,0.057c-0.025,0.035-0.04,0.043-0.083,0.063\r\n\t\t\t\tc0.038,0.07,0.076,0.14,0.115,0.21H6.52c0.006,0.032,0.013,0.064,0.019,0.095c0.019,0.013,0.038,0.025,0.057,0.038\r\n\t\t\t\tc0.051,0.105-0.017,0.164,0.133,0.172c0.035,0.058,0.068,0.193,0.108,0.242c0.047-0.022,0.112-0.023,0.178-0.032\r\n\t\t\t\tc-0.004,0.021-0.008,0.042-0.013,0.064h0.013c0.048-0.142,0.166-0.403,0.108-0.61c-0.023-0.081-0.082-0.166-0.108-0.261\r\n\t\t\t\tc-0.013-0.083-0.025-0.165-0.038-0.248c-0.062-0.179-0.316-0.446-0.267-0.699c0.032-0.1,0.064-0.199,0.095-0.299\r\n\t\t\t\tc0.053-0.085,0.131-0.155,0.165-0.26c0.15-0.028,0.305-0.087,0.369-0.197c0.047-0.082,0.048-0.15,0.127-0.197\r\n\t\t\t\tc0.074-0.044,0.216-0.039,0.28-0.076c0.064-0.08,0.127-0.161,0.191-0.242c0.07-0.011,0.14-0.021,0.21-0.032\r\n\t\t\t\tc0.025-0.021,0.051-0.042,0.076-0.063c0.002-0.004,0.004-0.009,0.006-0.013c-0.027-0.012-0.033-0.01-0.044-0.038\r\n\t\t\t\tc-0.025,0.019-0.067,0.035-0.095,0.051c-0.015-0.009-0.03-0.017-0.044-0.026c-0.019-0.013-0.023-0.028-0.032-0.051\r\n\t\t\t\tc0.025,0.019,0.035,0.04,0.07,0.051c0.054-0.032,0.047-0.06,0.089-0.083v-0.013c-0.03-0.031-0.081-0.057-0.14-0.057\r\n\t\t\t\tc-0.006-0.011-0.013-0.021-0.019-0.032c0.044,0.015,0.089,0.03,0.133,0.045c-0.006-0.011-0.013-0.021-0.019-0.032v-0.006\r\n\t\t\t\tc0.051,0.021,0.064,0.054,0.14,0.064c0.025-0.03,0.051-0.059,0.076-0.089c0.009-0.016,0.008-0.002,0.038,0\r\n\t\t\t\tc0.006-0.011,0.013-0.021,0.019-0.032c-0.001-0.047-0.012-0.063-0.038-0.083c-0.011-0.006-0.002-0.006-0.013,0\r\n\t\t\t\tc-0.028,0.017-0.029,0.052-0.044,0.081c0.002,0.005-0.004,0.01-0.001,0.014v-0.013c0-0.001,0-0.001,0.001-0.002\r\n\t\t\t\tc-0.01-0.027-0.001-0.054,0.005-0.087c-0.004-0.004-0.009-0.008-0.013-0.013c-0.06,0.01-0.113,0.02-0.191,0.019\r\n\t\t\t\tc0.008-0.038-0.02-0.071,0-0.108v-0.013c0.011,0.017-0.003,0.036,0.006,0.064c0.009,0.011,0.017,0.021,0.026,0.032\r\n\t\t\t\tc0.021-0.006,0.042-0.013,0.064-0.019c0-0.018-0.002-0.019-0.013-0.038c0.021,0.011,0.042,0.021,0.064,0.032\r\n\t\t\t\tc0.008-0.004,0.017-0.009,0.025-0.013c0.002-0.004,0.004-0.008,0.006-0.013c-0.011-0.015-0.021-0.029-0.032-0.044\r\n\t\t\t\tc0.034,0.019,0.057,0.04,0.089,0.025c0.004,0.015,0.008,0.03,0.013,0.045h0.019c-0.012-0.067-0.042-0.087-0.07-0.134h0.038\r\n\t\t\t\tC8.338,28.6,8.338,28.606,8.325,28.59c0.004-0.008,0.008-0.015,0.011-0.023c-0.024-0.086-0.083-0.085-0.17-0.066\r\n\t\t\t\tc-0.004-0.07-0.06-0.101-0.121-0.114c-0.002-0.004-0.004-0.008-0.006-0.013c0.011-0.006,0.021-0.013,0.032-0.019\r\n\t\t\t\tc0.043,0.021,0.076,0.045,0.095,0.089c0.03,0.02,0.023,0.021,0.07,0.019c-0.002-0.021-0.004-0.042-0.006-0.064\r\n\t\t\t\tc-0.02-0.013-0.034-0.028-0.052-0.038H8.172c-0.021-0.017-0.042-0.034-0.064-0.051c0.018,0.026,0.045,0.037,0.069,0.051h0.02\r\n\t\t\t\tc-0.002-0.013-0.004-0.025-0.006-0.038c0.017,0.006,0.034,0.013,0.051,0.019h0.006c-0.002-0.043-0.004-0.052-0.038-0.064\r\n\t\t\t\tc0.009-0.004,0.017-0.009,0.026-0.013c-0.082-0.042-0.117-0.054-0.159-0.133c0.034,0.03,0.068,0.059,0.102,0.089\r\n\t\t\t\tc0.006,0.006,0.013,0.013,0.019,0.019c0.036-0.023,0.042-0.039,0.057-0.083c-0.034-0.047-0.238-0.13-0.311-0.159\r\n\t\t\t\tc-0.002-0.007,0.001-0.013,0-0.019c0.068-0.003,0.075,0.022,0.127,0.045c-0.002-0.013-0.004-0.025-0.006-0.038\r\n\t\t\t\tc0.042,0.042,0.099,0.078,0.153,0.108c-0.016-0.09-0.078-0.09-0.095-0.165h0.006c0.012,0.032,0.027,0.045,0.057,0.057\r\n\t\t\t\tc0.004,0.004,0.008,0.008,0.013,0.013h0.006c-0.015-0.036-0.03-0.072-0.044-0.108c-0.02-0.107,0.072-0.052-0.006-0.197\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.002-0.019,0.004-0.038,0.006-0.057c0.019,0.012,0.011,0.001,0.019,0.026h0.006\r\n\t\t\t\tc0.011-0.014,0.011-0.017,0.013-0.045c0.002,0.011,0.004,0.021,0.006,0.032c0.029-0.02,0.034-0.024,0.032-0.045\r\n\t\t\t\tc0.015-0.011,0.03-0.021,0.044-0.032c-0.006,0.017-0.013,0.034-0.019,0.051c0.013,0.006,0.025,0.013,0.038,0.019\r\n\t\t\t\tc-0.025,0.006-0.051,0.013-0.076,0.019c-0.011,0.017-0.021,0.034-0.032,0.051v0.006h0.051c-0.013,0.035-0.02,0.044-0.07,0.044\r\n\t\t\t\tc-0.004,0.006-0.009,0.013-0.013,0.019c0.016,0.017,0.027,0.021,0.057,0.025c0.002,0.004,0.004,0.008,0.006,0.013v0.026\r\n\t\t\t\tc-0.013-0.007-0.025-0.013-0.038-0.019c-0.004,0.002-0.009,0.004-0.013,0.006c-0.004,0.013-0.009,0.025-0.013,0.038v0.006\r\n\t\t\t\tc0.047-0.025,0.036-0.01,0.089,0.013c0.004,0.006,0.009,0.013,0.013,0.019c-0.03,0.011-0.059,0.021-0.089,0.032\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.011,0.015,0.021,0.03,0.032,0.044c0.017,0.011,0.034,0.021,0.051,0.032\r\n\t\t\t\tc0.021-0.013,0.042-0.025,0.064-0.038c-0.001,0.055-0.005,0.033-0.025,0.07c0.015,0.008,0.03,0.017,0.044,0.025\r\n\t\t\t\tc-0.006,0.013-0.013,0.026-0.019,0.038v0.006h0.006c0.026-0.01,0.031-0.014,0.051,0c-0.039,0.071-0.09,0.135-0.114,0.229\r\n\t\t\t\tc0.004,0.013,0.008,0.025,0.013,0.038c0.008-0.002,0.017-0.004,0.025-0.006c0.017-0.038,0.034-0.076,0.051-0.114\r\n\t\t\t\tc0.02,0,0.017,0.006,0.032-0.006c0.023-0.055,0.047-0.11,0.07-0.165c0.033-0.056,0.086-0.075,0.102-0.14\r\n\t\t\t\tc-0.004-0.04-0.008-0.081-0.013-0.121c-0.078-0.033-0.136-0.206-0.152-0.292c0.024-0.023,0.034-0.046,0.064-0.064\r\n\t\t\t\tc0.002,0.002,0.004,0.004,0.006,0.006c-0.017,0.031-0.037,0.044-0.057,0.07c0.054,0.073,0.068,0.144,0.184,0.14\r\n\t\t\t\tc0.005,0.037-0.005,0.046-0.013,0.083v0.006c0.004,0.002,0.008,0.004,0.013,0.006c0.055-0.041,0.152-0.125,0.152-0.216\r\n\t\t\t\tc0.013,0.004,0.026,0.008,0.038,0.013c0.032-0.093,0.078-0.196,0.095-0.305c-0.053-0.007-0.063-0.019-0.089-0.051\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019c0.029-0.023,0.034-0.034,0.064-0.026c0.019-0.053,0.038-0.106,0.057-0.159\r\n\t\t\t\tc-0.015,0.047-0.03,0.093-0.045,0.14c0.19-0.133,0.413-0.223,0.744-0.222c0.008-0.043,0.017-0.085,0.025-0.127\r\n\t\t\t\tc0.002-0.002,0.036,0,0.064-0.013c0.003,0.022-0.008,0.053-0.006,0.095c0.004,0.002,0.008,0.004,0.013,0.007\r\n\t\t\t\tc0.058-0.002,0.108-0.049,0.121-0.089h0.006c0.013,0.016,0.014,0.037,0.013,0.07c0.072-0.017,0.144-0.034,0.216-0.051\r\n\t\t\t\tc0-0.035-0.012-0.048-0.019-0.067v0.016c-0.03,0.013-0.059,0.025-0.089,0.038c-0.017-0.006-0.034-0.013-0.051-0.019\r\n\t\t\t\tc-0.017-0.095-0.061-0.182-0.165-0.191c0.011-0.069,0.067-0.083,0.127-0.102c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.052-0.015-0.053-0.008-0.083-0.057c0.045-0.073,0.096-0.241,0.184-0.267v-0.07c0.028-0.011,0.055-0.021,0.083-0.032\r\n\t\t\t\tc-0.002,0.011-0.004,0.021-0.006,0.032c0.013,0.006,0.025,0.013,0.038,0.019h0.006c0.028-0.036,0.033-0.028,0.025-0.076\r\n\t\t\t\tc0.011-0.009,0.021-0.017,0.032-0.025c-0.004,0.015-0.008,0.03-0.013,0.044c0.017,0.004,0.034,0.008,0.051,0.013\r\n\t\t\t\tc0.008-0.021,0.017-0.042,0.025-0.064c0.013,0.008,0.025,0.017,0.038,0.025c0.059-0.044,0.113-0.149,0.14-0.222h0.006\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c-0.008,0.021-0.017,0.042-0.025,0.064c0.002,0.004,0.004,0.008,0.006,0.013\r\n\t\t\t\tc0.027,0.008,0.055,0.017,0.083,0.025c-0.004-0.019-0.008-0.038-0.013-0.057c0.046,0.008,0.075-0.021,0.121-0.032\r\n\t\t\t\tc0.006,0.019,0.013,0.038,0.019,0.057c0.038-0.028,0.057-0.071,0.095-0.095c0.015,0.011,0.03,0.021,0.044,0.032\r\n\t\t\t\tc0.018-0.015,0.017-0.011,0.019-0.045c0.069,0.012,0.096-0.012,0.153-0.038c0.011-0.019,0.01-0.016,0.013-0.032h-0.051\r\n\t\t\t\tc0.011-0.015,0.021-0.03,0.032-0.045c-0.011-0.023-0.021-0.047-0.032-0.07c0.011,0.008,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.041-0.039,0.135-0.02,0.178,0.013c0.034-0.019,0.068-0.038,0.102-0.057c-0.006-0.013-0.013-0.026-0.019-0.038\r\n\t\t\t\tc0.023,0.013,0.047,0.025,0.07,0.038c0.139-0.017,0.194-0.143,0.343-0.146c0.013-0.023,0.025-0.047,0.038-0.07\r\n\t\t\t\tc-0.006-0.019-0.013-0.038-0.019-0.057c0.024,0.019,0.04,0.035,0.044,0.076c0.019-0.011,0.038-0.021,0.057-0.032h0.006\r\n\t\t\t\tc-0.025,0.065-0.104,0.124-0.172,0.146c-0.008,0.017-0.011,0.022-0.013,0.051c0.108-0.056,0.302-0.039,0.432-0.025\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.092-0.002-0.148,0.034-0.229,0.051v0.044c-0.023-0.018-0.019-0.021-0.044-0.025\r\n\t\t\t\tc0.002-0.023,0.004-0.047,0.006-0.07c-0.083-0.003-0.358,0.164-0.413,0.222h-0.013c0.011,0.006,0.021,0.013,0.032,0.019v0.006\r\n\t\t\t\tc-0.027,0.003-0.018,0.002-0.038-0.013c-0.04,0.023-0.08,0.047-0.121,0.07c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.03-0.019,0.059-0.038,0.089-0.057c-0.014,0.038-0.023,0.015-0.044,0.038\r\n\t\t\t\tc-0.076,0.082-0.026,0.172-0.006,0.26c0.015-0.005,0.009-0.003,0.025-0.019c0.019,0.032,0.038,0.064,0.057,0.095\r\n\t\t\t\tc0.048-0.01,0.046-0.012,0.076,0.019c0.009-0.023,0.017-0.047,0.026-0.07c0.035-0.016,0.053-0.017,0.108-0.013v-0.045\r\n\t\t\t\tc0.006,0.004,0.013,0.009,0.019,0.013c0.062-0.036,0.089-0.171,0.203-0.172c0.014-0.051-0.01-0.053-0.013-0.108h0.038\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032h0.006c0.023-0.015,0.034-0.023,0.045-0.051c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc-0.002,0.015-0.004,0.03-0.006,0.045c0.036,0.004,0.072,0.008,0.108,0.013c0.016-0.034,0.031-0.025,0.038-0.07\r\n\t\t\t\tc0.011,0.006,0.021,0.013,0.032,0.019c0.004-0.015,0.008-0.03,0.013-0.044c0.006-0.002,0.013-0.004,0.019-0.006\r\n\t\t\t\tc0.032,0.009,0.026,0.014,0.045,0.032c0.124-0.045,0.262-0.143,0.407-0.146c-0.002-0.009-0.004-0.017-0.006-0.025\r\n\t\t\t\tc0.032,0.002,0.064,0.004,0.095,0.006c-0.004-0.006-0.008-0.013-0.013-0.019c0.006-0.004,0.013-0.009,0.019-0.013\r\n\t\t\t\tc0.024-0.013,0.02-0.005,0.044,0.013c0.021-0.009,0.042-0.017,0.063-0.025c-0.027-0.034-0.068-0.036-0.133-0.032\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c0.013-0.007,0.025-0.013,0.038-0.019c0.006-0.008,0.013-0.017,0.019-0.025\r\n\t\t\t\tc-0.021-0.021-0.042-0.042-0.063-0.064c-0.075-0.027-0.112,0.044-0.133-0.064c-0.066,0.01-0.086,0.052-0.133,0.07\r\n\t\t\t\tc-0.032,0.012-0.073,0.004-0.095,0.013c0.006-0.013,0.013-0.025,0.019-0.038h-0.013c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc-0.067-0.031-0.119,0.027-0.165,0.006c-0.019-0.013-0.038-0.025-0.057-0.038c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.028-0.013-0.04-0.048-0.083-0.057h-0.013v-0.006c0.025-0.009,0.051-0.017,0.076-0.025c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc-0.103-0.049-0.301-0.028-0.267-0.191c-0.021-0.028-0.018-0.025-0.044-0.019c-0.013-0.053-0.009-0.079,0.013-0.121\r\n\t\t\t\tc-0.03-0.032-0.094-0.029-0.159-0.025c0.088-0.089,0.103-0.048,0.133-0.178c0.021-0.021,0.042-0.042,0.064-0.064\r\n\t\t\t\tc-0.015-0.011-0.03-0.021-0.044-0.032c-0.019,0.008-0.038,0.017-0.057,0.025v-0.032c-0.055,0.025-0.11,0.051-0.165,0.076\r\n\t\t\t\tc-0.065-0.089-0.112-0.14-0.254-0.152v-0.007c0.049-0.015,0.115-0.056,0.191-0.038c0.034,0.015,0.068,0.03,0.102,0.045\r\n\t\t\t\tc0.079-0.006,0.346-0.155,0.375-0.216c-0.094-0.249-0.411-0.255-0.674-0.152c-0.282,0.11-0.595,0.189-0.82,0.356\r\n\t\t\t\tc-0.184,0.136-0.321,0.345-0.502,0.489c0.154-0.325,0.477-0.718,0.775-0.896c0.079-0.047,0.223-0.03,0.299-0.083\r\n\t\t\t\tc0.108-0.076,0.07-0.268,0.267-0.337c0.117-0.041,0.317-0.025,0.439-0.006c0.178,0.027,0.354-0.025,0.515-0.006\r\n\t\t\t\tc0.163,0.008,0.326,0.017,0.489,0.025c0.219-0.035,0.465-0.038,0.61-0.146c0.083-0.091,0.165-0.182,0.248-0.273\r\n\t\t\t\tc0.155-0.015,0.309-0.03,0.464-0.044c0.1-0.032,0.288-0.2,0.375-0.267v-0.013c-0.042-0.055-0.085-0.11-0.127-0.165\r\n\t\t\t\tc0.034-0.061,0.064-0.142,0.095-0.21c-0.007-0.1-0.158-0.181-0.248-0.197c-0.041-0.008-0.112,0.043-0.153,0.064\r\n\t\t\t\tc-0.013-0.019-0.025-0.038-0.038-0.057c0.008-0.044,0.031-0.064,0.051-0.095c-0.257-0.247-0.418,0.027-0.61,0.133\r\n\t\t\t\tc-0.089,0.05-0.218,0.06-0.305,0.095c0.012-0.069,0.034-0.173,0.083-0.21c0.053-0.004,0.106-0.008,0.159-0.013\r\n\t\t\t\tc0.109-0.031,0.157-0.136,0.28-0.165c0.122-0.029,0.24-0.033,0.292-0.127c-0.11-0.028-0.22-0.055-0.33-0.083\r\n\t\t\t\tc-0.106-0.044-0.191-0.133-0.324-0.153c-0.101-0.015-0.161,0.043-0.261,0.038c0.021-0.051,0.042-0.102,0.064-0.152\r\n\t\t\t\tc-0.007-0.092-0.237-0.273-0.311-0.299h-0.095c-0.062-0.024-0.129-0.187-0.165-0.241c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.055-0.031,0.185,0.022,0.261,0c0.012-0.024,0.014-0.061,0.013-0.102c-0.084-0.062-0.178-0.095-0.242-0.178\r\n\t\t\t\tc0.027-0.025,0.057-0.044,0.102-0.051c-0.036-0.207-0.226-0.07-0.261-0.356c-0.028,0.002-0.055,0.004-0.083,0.006\r\n\t\t\t\tc-0.009-0.07,0.017-0.079,0.032-0.134c-0.122-0.141-0.365-0.561-0.508-0.629c-0.004-0.004-0.008-0.008-0.013-0.013\r\n\t\t\t\tc-0.021,0.042-0.042,0.085-0.064,0.127c-0.144,0.096-0.271,0.026-0.114,0.235c-0.096,0.122-0.182,0.158-0.184,0.388h-0.006\r\n\t\t\t\tc-0.051-0.051-0.057-0.152-0.153-0.159c-0.034,0.059-0.068,0.119-0.102,0.178c-0.077,0.058-0.266,0.055-0.349,0.095\r\n\t\t\t\tc-0.013-0.019-0.026-0.038-0.038-0.057c0.014-0.022,0.019-0.03,0.019-0.07c-0.149-0.221-0.275-0.116-0.483-0.044h-0.006\r\n\t\t\t\tc-0.044-0.056-0.038-0.084-0.026-0.178c0.036,0.002,0.072,0.004,0.108,0.006c0.112-0.165-0.211-0.619,0.013-0.724\r\n\t\t\t\tc0.011-0.023,0.014-0.056,0.013-0.095c-0.011-0.017-0.021-0.034-0.032-0.051c-0.039-0.011-0.088,0.06-0.178,0.038\r\n\t\t\t\tc-0.162-0.039-0.31-0.129-0.458-0.159c-0.052-0.065-0.056-0.061-0.013-0.14c-0.022-0.016-0.052-0.042-0.077-0.062\r\n\t\t\t\tc0.109-0.188,0.225-0.372,0.338-0.557c0.01,0.006,0.021,0.007,0.031,0.015c0.006,0.003,0.064-0.003,0.102,0.013\r\n\t\t\t\tc0.028,0.017,0.055,0.034,0.083,0.051c0.049,0.006,0.097,0.013,0.146,0.019c0.04,0.047,0.081,0.093,0.121,0.14\r\n\t\t\t\tc0.094,0.057,0.203,0.032,0.331,0.064c0.203,0.072,0.407,0.144,0.61,0.216c-0.067-0.217-0.212-0.375-0.381-0.489\r\n\t\t\t\tc-0.155-0.104-0.443-0.179-0.47-0.4c0.186,0,0.218,0.082,0.343,0.127c-0.009-0.049-0.017-0.097-0.026-0.146\r\n\t\t\t\tc0.188,0.145,0.277,0.375,0.604,0.349c0.069,0.109,0.145,0.196,0.273,0.248c-0.038-0.078-0.076-0.157-0.114-0.235\r\n\t\t\t\tc0.04,0.008,0.08,0.017,0.121,0.025h0.006c-0.006-0.184-0.176-0.25-0.153-0.432c0.084,0.057,0.177,0.169,0.216,0.267\r\n\t\t\t\tc0.008,0.006,0.017,0.013,0.025,0.019c0.037-0.334-0.178-0.289-0.292-0.477c0.006-0.013,0.013-0.026,0.019-0.038\r\n\t\t\t\tc0.025-0.006,0.051-0.013,0.076-0.019h0.013c-0.061-0.03-0.123-0.059-0.184-0.089c-0.069-0.041-0.11-0.13-0.191-0.153\r\n\t\t\t\tc-0.019,0.015-0.038,0.03-0.057,0.044c-0.008,0.008-0.017,0.017-0.025,0.026c-0.071-0.122-0.147-0.253-0.21-0.388\r\n\t\t\t\tc-0.053-0.009-0.106-0.017-0.159-0.025c-0.006-0.014-0.012-0.027-0.019-0.04c0.024-0.035,0.051-0.067,0.076-0.101\r\n\t\t\t\tc0.001,0.003,0.005,0.005,0.006,0.008c0.04-0.004,0.081-0.009,0.121-0.013c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.022-0.025-0.045-0.05-0.067-0.075c0.044-0.062,0.092-0.121,0.137-0.183c0.134,0.06,0.208,0.164,0.343,0.226\r\n\t\t\t\tc0.072,0.033,0.155,0.015,0.21,0.051c-0.013,0.036-0.025,0.072-0.038,0.108c0.005,0.082,0.057,0.11,0.089,0.165\r\n\t\t\t\tc0.042-0.019,0.085-0.038,0.127-0.057c0.033,0.038,0.022,0.078,0.051,0.127c0.022,0.036,0.201,0.12,0.248,0.102h0.013\r\n\t\t\t\tc-0.015-0.064-0.03-0.127-0.045-0.191c0.011-0.076,0.021-0.153,0.032-0.229c0.004-0.002,0.008-0.004,0.013-0.006\r\n\t\t\t\tc0.036,0.05,0.089,0.124,0.159,0.14c0.035-0.09,0.113-0.136,0.222-0.152c-0.011-0.088-0.097-0.155-0.165-0.184\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.15-0.095,0.182,0.061,0.324,0c0.025-0.019,0.058-0.097,0.089-0.127\r\n\t\t\t\tc0.002-0.006,0.004-0.013,0.006-0.019c-0.087-0.061-0.174-0.123-0.261-0.184c-0.092,0.084-0.164,0.079-0.299,0.051\r\n\t\t\t\tc0.013-0.043,0.025-0.085,0.038-0.127c-0.147-0.013-0.29,0.025-0.47,0.026v-0.095c0.061-0.015,0.123-0.03,0.184-0.044h0.013\r\n\t\t\t\tc-0.051-0.098-0.165-0.231-0.267-0.273c-0.037-0.015-0.062-0.003-0.087,0.008c0.618-0.794,1.268-1.56,1.972-2.276\r\n\t\t\t\tc0.027,0.005,0.054,0.009,0.08,0.014c0.042,0.011,0.084,0.021,0.127,0.032c0.022-0.003,0.044-0.006,0.065-0.009\r\n\t\t\t\tc0.003,0,0.005,0,0.008,0c0.003,0.007,0.006,0.014,0.01,0.022c0.02,0.004,0.051,0.001,0.079-0.002\r\n\t\t\t\tc0.003,0.003,0.005,0.006,0.008,0.008c-0.045,0.019-0.061,0.016-0.102,0.01c-0.025,0.007-0.079,0.031-0.085,0.046\r\n\t\t\t\tc-0.01,0.04,0.124,0.116,0.183,0.098c0.044-0.017,0.087-0.034,0.131-0.051c0.058-0.019,0.1-0.003,0.157-0.022\r\n\t\t\t\tc0.096-0.031,0.196-0.098,0.229-0.154c0.053-0.088-0.124-0.137-0.191-0.155c-0.063-0.017-0.099-0.061-0.143-0.099\r\n\t\t\t\tc-0.051-0.044-0.123-0.071-0.209-0.083c0.015-0.015,0.032-0.028,0.047-0.043c0.017,0.003,0.035,0.009,0.05,0.01\r\n\t\t\t\tc0.011-0.005,0.009-0.006,0.015-0.011c0.018-0.001,0.036-0.001,0.055-0.002c0.098,0.013,0.166,0.087,0.242,0.125\r\n\t\t\t\tc0.058,0.029,0.126,0.035,0.206,0.042c0.022,0.002,0.033,0.013,0.057,0.012c0.021-0.022,0.037-0.048,0.097-0.049\r\n\t\t\t\tc0.002,0.002,0.005,0.004,0.007,0.005c0.001,0.001,0.003,0.003,0.004,0.004c-0.009,0.006-0.019,0.012-0.028,0.019\r\n\t\t\t\tc0.003,0.004,0.006,0.009,0.01,0.013c0.082-0.002,0.101-0.036,0.149-0.053c0.04-0.014,0.063,0.003,0.095-0.008\r\n\t\t\t\tc-0.012,0.025-0.046,0.04-0.061,0.063c-0.015,0.023-0.012,0.045-0.025,0.07c-0.007,0.014-0.031,0.02-0.038,0.036\r\n\t\t\t\tc0.01,0.019,0.049,0.027,0.043,0.05c-0.003,0.006-0.051,0.024-0.06,0.026c0,0.019-0.02,0.038-0.005,0.057\r\n\t\t\t\tc0.01,0.008,0.024,0.008,0.042,0.007c0.003,0.002,0.006,0.003,0.009,0.005c-0.017,0.009-0.038,0.017-0.052,0.026\r\n\t\t\t\tc-0.001,0.018,0.024,0.052,0.013,0.071c-0.012,0.019-0.048,0.03-0.06,0.051c0,0.001,0,0.001,0,0.002\r\n\t\t\t\tc0.084-0.011,0.07-0.036,0.138-0.055c0.04,0.003,0.027,0.022,0.052,0.038c0.012,0.003,0.025,0.006,0.037,0.01\r\n\t\t\t\tc0.001,0.001,0.002,0.002,0.004,0.003c0,0.002,0,0.005,0,0.007c-0.016,0.04-0.137,0.028-0.188,0.046\r\n\t\t\t\tc-0.007,0.004-0.065,0.071-0.067,0.078c0.003,0.008,0.005,0.016,0.008,0.024c-0.011,0.012-0.022,0.025-0.032,0.038\r\n\t\t\t\tc-0.019,0.031-0.038,0.062-0.057,0.092c0.074-0.015,0.084-0.049,0.159-0.064c0.061,0.021,0.023,0.086-0.02,0.107\r\n\t\t\t\tc-0.029,0.014-0.071,0.006-0.102,0.011c-0.063,0.01-0.105,0.042-0.185,0.049c-0.054,0.004-0.117-0.01-0.169,0.006\r\n\t\t\t\tc-0.118,0.035-0.158,0.131-0.289,0.172c0.034,0.002,0.095,0.005,0.125,0.003c0.039-0.009,0.078-0.018,0.118-0.027\r\n\t\t\t\tc0.023,0.004,0.047,0.008,0.07,0.012c0.05,0.008,0.104,0.007,0.161,0.008c0.03-0.031,0.065-0.027,0.119-0.048\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.006c0-0.015-0.011-0.025-0.03-0.026c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.021-0.031,0.098-0.036,0.127-0.016c0.007,0.042-0.069,0.055-0.07,0.092c-0.002,0.059,0.172,0.07,0.202,0.108\r\n\t\t\t\tc-0.014,0.005-0.016,0.007-0.013,0.017c-0.062-0.014-0.133-0.027-0.211-0.024c-0.053,0.005-0.106,0.01-0.159,0.015\r\n\t\t\t\tc-0.058,0-0.109-0.014-0.16-0.022c-0.067-0.011-0.133-0.021-0.2-0.032c-0.003,0.001-0.007,0.001-0.01,0.002\r\n\t\t\t\tc-0.003,0.006-0.007,0.012-0.01,0.018c0,0.026,0.154,0.053,0.194,0.053c0.012,0.005,0.034,0.016,0.012,0.028\r\n\t\t\t\tc-0.041,0.017-0.145-0.037-0.22-0.018c-0.111,0.028-0.099,0.092-0.137,0.146c-0.027,0.036-0.054,0.071-0.081,0.107\r\n\t\t\t\tc-0.003,0.008,0.004,0.014,0.009,0.02c0.107,0.021,0.169-0.081,0.21-0.108c0.029-0.009,0.058-0.018,0.086-0.026\r\n\t\t\t\tc0.066-0.032,0.111-0.067,0.214-0.086c-0.003,0.016-0.019,0.023-0.018,0.04c0.034,0.031,0.073,0.012,0.142,0.008\r\n\t\t\t\tc0.019,0,0.038-0.001,0.058-0.001c0.029-0.02,0.092-0.051,0.055-0.082c0,0,0-0.001-0.001-0.002\r\n\t\t\t\tc0.073-0.008,0.116-0.013,0.164,0.002c0.001,0.002,0.001,0.004,0.002,0.006c-0.029,0.03-0.094,0.055-0.093,0.094\r\n\t\t\t\tc0.024,0.013,0.055,0.015,0.064,0.043c-0.107,0.003-0.221,0.01-0.318,0.003c-0.048-0.004-0.097-0.025-0.149-0.02\r\n\t\t\t\tc-0.05,0.005-0.095,0.041-0.126,0.057c-0.053,0.028-0.107,0.056-0.16,0.084c-0.031,0.011-0.061,0.023-0.092,0.034\r\n\t\t\t\tc-0.026,0.023-0.052,0.046-0.077,0.07c0.097,0.037,0.343-0.041,0.494-0.055c0.031-0.005,0.062-0.01,0.093-0.014\r\n\t\t\t\tc0.025,0.006,0.05,0.012,0.074,0.017c0.027-0.002,0.053-0.004,0.08-0.005c0.071,0.006,0.103,0.061,0.143,0.099\r\n\t\t\t\tc-0.048-0.007-0.096-0.013-0.143-0.019c-0.175-0.014-0.382-0.023-0.599,0.048c-0.044,0.013-0.088,0.026-0.132,0.039\r\n\t\t\t\tc0.033,0.026,0.093,0.01,0.126,0.031c0.015,0.022,0.03,0.043,0.045,0.065c0.009,0.006,0.187,0.026,0.212,0.028\r\n\t\t\t\tc0.027-0.007,0.031-0.019,0.051-0.03c0.071-0.01,0.102,0.049,0.058,0.079c-0.07,0.047-0.247,0.037-0.329,0.081\r\n\t\t\t\tc-0.002,0-0.003,0.001-0.005,0.001c0.03,0.018,0.163,0.033,0.21,0.036c-0.003,0.003-0.155,0.049-0.161,0.049\r\n\t\t\t\tc-0.041,0.003-0.061-0.021-0.109,0.004c-0.042,0.022-0.094,0.081-0.039,0.115c0.01,0.006,0.061,0.009,0.061,0.018\r\n\t\t\t\tc0.001,0.014-0.046,0.027-0.052,0.042c-0.006,0.028,0.035,0.04,0.072,0.026c0.049-0.018,0.116-0.057,0.149-0.083\r\n\t\t\t\tc0.068-0.052,0.139-0.105,0.219-0.153c0.026-0.012,0.052-0.023,0.078-0.035c0.04-0.037,0.08-0.074,0.119-0.111\r\n\t\t\t\tc0.043-0.03,0.109-0.051,0.168-0.075c0.037-0.015,0.07-0.028,0.113-0.042c0.041-0.009,0.082-0.018,0.123-0.027\r\n\t\t\t\tc0.021-0.007,0.051-0.021,0.08-0.02c0.023,0.007,0.047,0.013,0.07,0.02c-0.022,0.019-0.042,0.053-0.07,0.067\r\n\t\t\t\tc-0.075,0.036-0.22,0.019-0.315,0.037c-0.025,0.043-0.11,0.069-0.158,0.098c-0.009,0.008-0.002,0.019-0.007,0.028\r\n\t\t\t\tc-0.013,0.026-0.056,0.051-0.112,0.061c0.003,0.009,0.006,0.018,0.009,0.026c-0.158,0.057-0.262,0.142-0.375,0.215\r\n\t\t\t\tc-0.03,0.019-0.109,0.042-0.12,0.068c-0.012,0.015,0.009,0.03,0.021,0.039c0.065,0.049,0.103,0.014,0.195-0.009\r\n\t\t\t\tc-0.019,0.04-0.065,0.091-0.144,0.109c-0.001,0.005-0.002,0.009-0.003,0.014c0.052,0.027,0.141,0.031,0.175-0.022\r\n\t\t\t\tc0.113-0.018,0.086,0.118,0.06,0.151c0.003,0.005,0.006,0.006,0.012,0.013c0.055-0.019,0.148-0.049,0.186-0.075\r\n\t\t\t\tc0.004-0.001,0.008-0.002,0.012-0.002c0.002,0.001,0.004,0.001,0.006,0.002c0.001,0.002,0.001,0.004,0.002,0.006\r\n\t\t\t\tc-0.05,0.055-0.176,0.082-0.215,0.141c0.012,0.026,0.047,0.037,0.078,0.043c0.037-0.003,0.063-0.022,0.086-0.035\r\n\t\t\t\tc0.013,0.011,0.023,0.019,0.028,0.038l-0.049,0.069c-0.008,0.002-0.017,0.003-0.025,0.005c0.026,0.048,0.092,0.004,0.15,0.016\r\n\t\t\t\tc0.032,0.007,0.037,0.052,0.057,0.069c-0.179,0.032-0.096,0.172-0.138,0.254c-0.009,0.019-0.043,0.094-0.017,0.116\r\n\t\t\t\tc0.006,0.006,0.01,0.008,0.021,0.009c0.036,0,0.069-0.044,0.086-0.058c0.047-0.038,0.105-0.089,0.124-0.137\r\n\t\t\t\tc-0.001-0.015-0.003-0.029-0.004-0.044c0.001-0.019,0.025-0.055,0.047-0.067c0.006-0.002,0.011-0.003,0.017-0.005\r\n\t\t\t\tc0.034,0.014,0.057,0.047,0.075,0.077c0.002,0,0.004,0,0.006,0.001c0.011-0.016,0.023-0.032,0.034-0.048\r\n\t\t\t\tc-0.003-0.046-0.006-0.093-0.009-0.14c0.001-0.041,0.018-0.075,0.027-0.11c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.023,0.013,0.046,0.027,0.069,0.04c0.012,0.015-0.004,0.03-0.005,0.042c-0.002,0.033,0.023,0.085,0.059,0.092\r\n\t\t\t\tc0.037,0.007,0.092-0.018,0.131-0.027c0.005,0.037,0.052,0.138,0.083,0.157c0.029,0.009,0.057,0.019,0.086,0.029\r\n\t\t\t\tc0.033,0.016,0.053,0.039,0.077,0.065c0.001,0.003,0.002,0.005,0.003,0.008c-0.08,0.005-0.209-0.043-0.25-0.08\r\n\t\t\t\tc-0.027-0.024-0.028-0.082-0.07-0.091c-0.061-0.014-0.142,0.044-0.163,0.066c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc0.02,0.01,0.078,0.031,0.064,0.059c-0.007,0.019-0.053,0.031-0.075,0.044c-0.062,0.036-0.11,0.071-0.19,0.104\r\n\t\t\t\tc-0.027,0.011-0.089,0.021-0.104,0.038c0.022,0.035,0.111,0.043,0.185,0.018c0.087-0.037,0.175-0.073,0.262-0.11\r\n\t\t\t\tc0.013-0.012,0.026-0.024,0.038-0.036c0.017,0.036,0.059,0.046,0.081,0.071c-0.024,0.009-0.063,0.011-0.098,0.022\r\n\t\t\t\tc-0.09,0.027-0.188,0.048-0.269,0.081c-0.035,0.015-0.092,0.041-0.134,0.034c0.005,0.043,0.049,0.052,0.057,0.092\r\n\t\t\t\tc0.009-0.001,0.019-0.001,0.028-0.002c0,0.002,0.001,0.003,0.001,0.005c-0.015,0.021-0.059,0.025-0.1,0.034\r\n\t\t\t\tc-0.001,0.003-0.002,0.006-0.002,0.009c0.071,0.035,0.051,0.061,0.071,0.126c0.078,0.018,0.126-0.035,0.181-0.058\r\n\t\t\t\tc0.036-0.015,0.083-0.023,0.132-0.032c-0.069,0.057-0.138,0.115-0.207,0.173c0.001,0.002,0.002,0.005,0.003,0.008\r\n\t\t\t\tc0.058,0.008,0.109-0.033,0.173-0.036c0.069-0.004,0.128,0.034,0.115,0.093c-0.012,0.053-0.138,0.066-0.08,0.133\r\n\t\t\t\tc0.048,0.01,0.079-0.016,0.127-0.014c0.002,0,0.003-0.001,0.005-0.001c-0.008,0.023-0.056,0.064-0.035,0.086\r\n\t\t\t\tc0,0.001,0.001,0.002,0.001,0.003c0.108-0.031,0.124-0.099,0.202-0.141c0.009,0.002,0.017,0.004,0.026,0.007\r\n\t\t\t\tc0.001,0.027-0.032,0.057-0.047,0.081c-0.042,0.065-0.084,0.13-0.126,0.195c-0.029,0.051,0.007,0.108,0.077,0.123\r\n\t\t\t\tc0.05,0,0.1,0,0.15,0c0.05,0.005,0.1,0.01,0.15,0.014c0.012,0.017,0.027,0.044,0.031,0.062c-0.019,0.015-0.049,0.031-0.085,0.039\r\n\t\t\t\tc0.002,0.01,0.001,0.012-0.009,0.02c0.009,0.017,0.026,0.022,0.046,0.028c0.037-0.01,0.093-0.026,0.121-0.041\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.007,0.012c-0.008,0.012-0.025,0.015-0.043,0.023c-0.061,0.029-0.098,0.044-0.103,0.095\r\n\t\t\t\tc0.112-0.018,0.147-0.073,0.235-0.096c0.023,0.072-0.093,0.095-0.116,0.152c0.011,0.023,0.039,0.022,0.053,0.041\r\n\t\t\t\tc-0.039,0.015-0.064,0.034-0.097,0.049c0.041,0.037,0.102,0.063,0.19,0.023c0.008-0.005,0.016-0.011,0.024-0.016\r\n\t\t\t\tc0.023-0.009,0.031,0.008,0.05,0c0.045-0.018,0.029-0.058,0.122-0.037c0,0.002,0.001,0.003,0.002,0.005\r\n\t\t\t\tc-0.013,0.033-0.073,0.046-0.136,0.061c0.058,0.029,0.233,0.015,0.271,0.055c0.036,0.037-0.063,0.081-0.014,0.117\r\n\t\t\t\tc0.006,0.002,0.012,0.001,0.023-0.001c0.028-0.024,0.047-0.046,0.101-0.061c0.008,0.002,0.015,0.004,0.023,0.006\r\n\t\t\t\tc0.006,0.033,0.035,0.061,0.034,0.088c-0.001,0.032-0.072,0.06-0.133,0.07c0.072,0.019,0.181,0.032,0.277,0\r\n\t\t\t\tc-0.001-0.01-0.006-0.026,0.007-0.035c0.001,0,0.002,0,0.003,0c0.025-0.008,0.049-0.015,0.074-0.023\r\n\t\t\t\tc0.018-0.009,0.018-0.024,0.048-0.029c0.001,0,0.002,0,0.003,0c0.001,0,0.002,0,0.002,0c0.001,0,0.002,0,0.003-0.001\r\n\t\t\t\tc0.001,0,0.002,0,0.003,0c0.032-0.001,0.061,0.018,0.104,0.004c0.031-0.018,0.062-0.035,0.094-0.053\r\n\t\t\t\tc0.044-0.016,0.092,0.019,0.092-0.034c0.064,0.001,0.128-0.025,0.114-0.063c-0.096-0.034-0.03-0.068,0.043-0.095\r\n\t\t\t\tc0.035,0.012,0.033,0.039,0.06,0.062c0.009,0.008,0.023,0.008,0.03,0.019c-0.036,0.036-0.115,0.1-0.125,0.14\r\n\t\t\t\tc0.023-0.018,0.04-0.047,0.076-0.059c0.023-0.008,0.049-0.002,0.073-0.012c0.024-0.019,0.048-0.037,0.072-0.055\r\n\t\t\t\tc0.008,0.022,0.018,0.041,0.034,0.055c0.013,0.012,0.052,0.019,0.053,0.04c0.001,0.034-0.057,0.046-0.088,0.07\r\n\t\t\t\tc-0.018,0.014-0.016,0.041-0.034,0.057c-0.035,0.025-0.07,0.05-0.105,0.075c0,0,0,0.001,0.001,0.002\r\n\t\t\t\tc0.032-0.001,0.055-0.016,0.087-0.017c0.02,0.011,0.033,0.028,0.047,0.046c0.002,0.001,0.004,0.002,0.006,0.002\r\n\t\t\t\tc0.075-0.019,0.046-0.092,0.085-0.126c0.041-0.013,0.102-0.007,0.101,0.026c-0.001,0.043-0.072,0.076-0.03,0.132\r\n\t\t\t\tc0.056,0.007,0.091-0.071,0.108-0.096c0.011-0.016,0.04-0.031,0.063-0.042c-0.021,0.042-0.041,0.083-0.062,0.125\r\n\t\t\t\tc0.006-0.001,0.012-0.002,0.017-0.003c0.053,0.045-0.139,0.11-0.08,0.183c0.052,0.007,0.11-0.041,0.178-0.037\r\n\t\t\t\tc0.043,0.002,0.057,0.042,0.094,0.052c0.006-0.001,0.012-0.002,0.017-0.003c0.057-0.029,0.042-0.124,0.109-0.141\r\n\t\t\t\tc0.08-0.02,0.159,0.014,0.22,0.018c0.039-0.001,0.078-0.003,0.117-0.004c0.03,0.001,0.076,0.02,0.11-0.001\r\n\t\t\t\tc0.013-0.009,0.015-0.023,0.02-0.035c0.036-0.085-0.093-0.067-0.067-0.122c-0.041,0.011-0.059,0.029-0.089,0.042\r\n\t\t\t\tc-0.065,0.028-0.129-0.005-0.144-0.044c0.136-0.026,0.396-0.115,0.395-0.18c-0.021,0.001-0.042,0.001-0.063,0.002\r\n\t\t\t\tc-0.034,0.009-0.058,0.035-0.104,0.036c-0.051,0.002-0.124-0.029-0.138-0.067c0.064-0.012,0.128-0.025,0.185-0.032\r\n\t\t\t\tc-0.019-0.013-0.058-0.022-0.087-0.023c-0.003-0.002-0.006-0.003-0.01-0.005c0.031-0.01,0.075-0.019,0.101-0.029\r\n\t\t\t\tc0.034-0.059-0.048-0.07,0.054-0.117c0-0.003,0-0.005,0-0.008c-0.048-0.03-0.174,0.004-0.201-0.043\r\n\t\t\t\tc-0.008-0.014,0.003-0.029,0.009-0.038c0.034-0.053,0.14-0.038,0.185-0.014c0.017-0.003,0.026-0.005,0.033-0.011\r\n\t\t\t\tc0.019-0.014,0.036-0.1,0.012-0.124c0.044-0.024,0.037-0.052,0.056-0.086c0.01-0.01,0.02-0.02,0.03-0.031\r\n\t\t\t\tc-0.041,0.006-0.092,0.025-0.124,0.016l-0.008-0.015c0.097-0.014,0.14-0.081,0.167-0.127c-0.03-0.052-0.1-0.085-0.104-0.156\r\n\t\t\t\tc-0.112-0.018-0.212-0.043-0.286-0.1c0.086-0.011,0.213,0.059,0.274,0.031c0.002-0.001,0.005-0.002,0.007-0.003\r\n\t\t\t\tc-0.001-0.003-0.002-0.005-0.003-0.008c-0.042-0.016-0.114-0.015-0.143-0.042c-0.025-0.024-0.027-0.071-0.049-0.092\r\n\t\t\t\tc0.047-0.029,0.093-0.059,0.14-0.088c0.046-0.019,0.099-0.029,0.134-0.05c-0.008-0.009-0.016-0.018-0.025-0.027\r\n\t\t\t\tc-0.005-0.014-0.011-0.028-0.016-0.042c-0.03-0.035-0.107-0.073-0.064-0.124c0-0.001-0.001-0.002-0.001-0.003\r\n\t\t\t\tc0.036,0.017,0.147,0.055,0.204,0.044c-0.001-0.003-0.002-0.005-0.003-0.008c0.006-0.008,0.012-0.008,0.012-0.019\r\n\t\t\t\tc-0.034-0.018-0.117-0.048-0.111-0.082c0.001-0.001,0.003-0.002,0.004-0.003c0.046,0.004,0.07,0.02,0.12,0.02\r\n\t\t\t\tc0.021-0.009,0.035-0.019,0.033-0.036c-0.026-0.023-0.065-0.029-0.091-0.051c0.001-0.002,0.002-0.005,0.003-0.007\r\n\t\t\t\tc0.035-0.01,0.079,0.009,0.106-0.015c0.019-0.013,0.014-0.041,0.035-0.055c0.018-0.012,0.068-0.012,0.091-0.021\r\n\t\t\t\tc0.015-0.022,0.003-0.047-0.001-0.075c-0.068,0.036-0.136,0.006-0.192,0.002c-0.019,0-0.038,0.001-0.058,0.001\r\n\t\t\t\tc-0.021-0.005-0.042-0.024-0.057-0.036c0,0,0-0.001,0-0.002c0.047,0,0.084,0.013,0.126,0.016\r\n\t\t\t\tc0.044-0.001,0.088-0.001,0.131-0.002c0.028-0.001,0.09-0.009,0.1-0.024c0.026-0.037-0.037-0.077-0.065-0.092\r\n\t\t\t\tc-0.023-0.013-0.046-0.027-0.069-0.04c-0.012-0.013-0.024-0.025-0.036-0.038c-0.018-0.01-0.063-0.003-0.087-0.007\r\n\t\t\t\tc-0.051-0.015-0.102-0.031-0.152-0.046c0.035-0.013,0.071-0.026,0.106-0.039c0.054-0.022,0.094-0.056,0.147-0.073\r\n\t\t\t\tc0.065-0.021,0.098,0.007,0.147-0.018c-0.003-0.033-0.056-0.036-0.075-0.06c0.04-0.014,0.032-0.041,0.033-0.07\r\n\t\t\t\tc-0.008-0.018-0.024-0.007-0.038-0.018c-0.01-0.017-0.02-0.034-0.03-0.051c-0.015-0.01-0.031-0.019-0.047-0.029\r\n\t\t\t\tc-0.088-0.043-0.195,0.005-0.197-0.102c-0.016-0.007-0.033-0.014-0.049-0.021c0.207-0.079,0.173-0.008,0.319,0\r\n\t\t\t\tc0.03-0.008,0.081-0.026,0.102-0.043c0.038-0.03,0.094-0.146,0.023-0.187c-0.046-0.027-0.126-0.019-0.183-0.035l-0.005,0.001\r\n\t\t\t\tc0,0,0-0.001-0.001-0.002c0.156-0.015,0.143-0.03,0.163-0.114c0.004-0.003,0.009-0.005,0.013-0.007c0.003,0,0.005,0,0.008,0\r\n\t\t\t\tc0.029,0.023,0.044,0.049,0.091,0.053c0.011,0.002,0.008-0.002,0.02-0.004c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.017-0.036-0.034-0.072-0.051-0.108c0.001-0.001,0.003-0.002,0.005-0.003c0.035,0.01,0.044,0.023,0.074,0.039\r\n\t\t\t\tc0.01,0.002,0.021,0.004,0.031,0.006c0.009,0.009,0.018,0.019,0.028,0.028c0.03,0.017,0.13,0.009,0.165-0.018\r\n\t\t\t\tc0.031-0.024,0.019-0.064,0.056-0.086c0.014-0.008,0.03-0.006,0.037,0.001c0.13-0.104-0.137-0.115-0.131-0.166\r\n\t\t\t\tc0.002-0.017,0.048-0.033,0.064-0.046c0.043-0.032,0.089-0.076,0.116-0.114c-0.009,0-0.018-0.001-0.027-0.001\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.004c0.05-0.023,0.021-0.065,0.001-0.1c0.055,0.009,0.141,0.024,0.224-0.01\r\n\t\t\t\tc-0.032,0.049-0.038,0.104-0.065,0.156c-0.017,0.033-0.065,0.069-0.066,0.104c0.008,0.011,0.016,0.021,0.024,0.032\r\n\t\t\t\tc0.015,0.03-0.047,0.071-0.007,0.098c0.021,0.016,0.068,0.009,0.106,0.008c0.001,0,0.002,0,0.002,0\r\n\t\t\t\tc-0.004-0.037,0.007-0.078-0.028-0.11c0.083-0.005,0.124-0.07,0.134-0.107c0.002-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.022,0.02,0.027,0.067,0.068,0.07c0.003,0,0.007,0,0.01,0c0.055-0.028,0.102-0.093,0.119-0.136\r\n\t\t\t\tc-0.006-0.004-0.012-0.009-0.018-0.013c0.001,0,0.002,0,0.003,0c0.045,0.009,0.167,0.05,0.2-0.008\r\n\t\t\t\tc0.002-0.031,0.004-0.063,0.006-0.094c0.012-0.023,0.053-0.042,0.051-0.069c0.004-0.047-0.125-0.031-0.121-0.087\r\n\t\t\t\tc0.012-0.034,0.201-0.025,0.247-0.027c0.022,0.013,0.039,0.036,0.067,0.044c0.065-0.002,0.086-0.04,0.101-0.069\r\n\t\t\t\tc0.032-0.059,0.046-0.123,0.077-0.184c0.014-0.028,0.029-0.056,0.043-0.085c0.008-0.022-0.001-0.073-0.025-0.093\r\n\t\t\t\tc-0.006-0.002-0.003-0.002-0.013-0.001c0.018-0.037,0.066-0.059,0.078-0.1c-0.014-0.01-0.028-0.02-0.042-0.03\r\n\t\t\t\tc-0.026-0.028-0.037-0.094-0.024-0.122c0.013-0.028,0.059-0.047,0.07-0.077c0.014-0.038-0.033-0.077-0.004-0.117\r\n\t\t\t\tc0.02-0.027,0.112-0.04,0.135-0.086c0.002-0.016,0.004-0.032,0.005-0.048c0.016-0.031,0.132-0.113,0.06-0.153\r\n\t\t\t\tc-0.023-0.013-0.064-0.006-0.096-0.01c-0.002,0-0.003,0.001-0.005,0.001c0.016-0.009,0.034-0.011,0.039-0.024\r\n\t\t\t\tc0.017-0.065-0.146-0.086-0.173-0.118c0.009-0.012,0.018-0.025,0.027-0.037c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.031,0.059,0.15,0.093,0.239,0.092c0.045,0,0.091-0.01,0.128-0.003c0.046,0.009,0.076,0.04,0.128,0.044\r\n\t\t\t\tc0.046,0.004,0.173-0.02,0.191-0.045c-0.003-0.044-0.086-0.053-0.114-0.083c0.091,0.005,0.077-0.035,0.134,0.031\r\n\t\t\t\tc0.041,0.007,0.101-0.012,0.116-0.034c0.001-0.052-0.066-0.084-0.058-0.137c0.005-0.005,0.011-0.01,0.016-0.015\r\n\t\t\t\tc0.03,0.025,0.076,0.076,0.147,0.053c0.075-0.023,0.014-0.08,0.073-0.109c0.046-0.014,0.093-0.029,0.139-0.043\r\n\t\t\t\tc0.048-0.025,0.083-0.063,0.134-0.089c0.033-0.013,0.065-0.027,0.098-0.04c0.023-0.014,0.024-0.037,0.052-0.051\r\n\t\t\t\tc0.052-0.027,0.165-0.104,0.16-0.147c0.013,0,0.026-0.001,0.039-0.001c0.009-0.007,0.007-0.015,0.014-0.021\r\n\t\t\t\tc0.024-0.02,0.098-0.01,0.069-0.046c-0.007-0.009-0.015-0.014-0.02-0.028c0.02-0.022,0.045-0.041,0.1-0.051\r\n\t\t\t\tc-0.003-0.01-0.007-0.02-0.01-0.03c0.004-0.01,0.018-0.015,0.036-0.02c0.005-0.043-0.016-0.072-0.045-0.098\r\n\t\t\t\tc0.008-0.035,0.079-0.049,0.107-0.077c0-0.029-0.031-0.052-0.063-0.055c0.037-0.037,0.131-0.031,0.146-0.078\r\n\t\t\t\tc-0.024-0.02-0.058-0.024-0.069-0.057c0.023-0.025,0.075-0.06,0.135-0.054c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc-0.033-0.02-0.066-0.041-0.099-0.061c-0.089-0.081,0.158-0.142,0.204-0.197c-0.022,0.004-0.029,0-0.037-0.01\r\n\t\t\t\tc-0.002-0.001-0.004-0.002-0.006-0.002c0,0,0-0.001-0.001-0.002c0.032-0.002,0.069,0.005,0.1-0.008\r\n\t\t\t\tc0.004-0.004,0.008-0.007,0.012-0.011c-0.001-0.024-0.034-0.036-0.057-0.044c-0.007-0.043,0.064-0.091,0.107-0.117\r\n\t\t\t\tc0.015,0.003,0.03,0.006,0.045,0.009c-0.008-0.04-0.016-0.08-0.024-0.12c-0.038,0.015-0.036,0.038-0.061,0.057\r\n\t\t\t\tc-0.04,0.031-0.1,0.067-0.155,0.09c-0.046,0.018-0.166,0.053-0.22,0.054c-0.055,0.001-0.099-0.006-0.169,0.007\r\n\t\t\t\tc-0.086,0.017-0.192,0.071-0.27,0.055c-0.009-0.018-0.019-0.035-0.028-0.053c-0.001,0-0.002,0-0.003,0.001\r\n\t\t\t\tc-0.072,0.055-0.152,0.123-0.2,0.186c-0.031,0.04-0.06,0.078-0.102,0.114c-0.038,0.032-0.043,0.082-0.099,0.107\r\n\t\t\t\tc-0.053,0.023-0.122,0.012-0.178,0.027c-0.003,0-0.006-0.001-0.008-0.002c-0.047-0.023-0.103,0.025-0.159,0.03\r\n\t\t\t\tc-0.014-0.012-0.007-0.021,0.003-0.032c0.022-0.023,0.056-0.047,0.12-0.051c0.022-0.001,0.054-0.002,0.075-0.013\r\n\t\t\t\tc0.068-0.034,0.046-0.111,0.096-0.141c0.031-0.019,0.151-0.057,0.162-0.078c0.014-0.025-0.022-0.049-0.044-0.053\r\n\t\t\t\tc-0.04,0.008-0.037,0.022-0.06,0.033l-0.116,0.034c-0.082,0.034-0.185,0.115-0.294,0.118c-0.015-0.011-0.018-0.03-0.038-0.036\r\n\t\t\t\tc-0.051,0.004-0.131,0.08-0.148,0.105c-0.006,0.001-0.012,0.001-0.018,0.002c-0.003,0-0.005,0-0.008,0\r\n\t\t\t\tc-0.046-0.074,0.259-0.214,0.154-0.309c-0.031-0.028-0.086-0.028-0.126-0.046c0.103-0.026,0.206-0.053,0.309-0.079\r\n\t\t\t\tc0.011-0.005,0.016-0.012,0.017-0.022c0.05-0.019,0.101-0.031,0.138-0.055c0.04-0.026,0.15-0.164,0.158-0.201\r\n\t\t\t\tc0.003-0.016-0.028-0.058-0.042-0.07c-0.016-0.014-0.044-0.019-0.068-0.024c-0.11-0.022-0.111,0.021-0.198,0.048\r\n\t\t\t\tc-0.092,0.028-0.168-0.001-0.196,0.069c-0.047,0.001-0.074-0.025-0.115-0.028c-0.045-0.003-0.093,0.034-0.122,0.047\r\n\t\t\t\tc-0.001,0-0.002,0-0.003,0c0,0,0-0.001-0.001-0.002c0.016-0.039,0.101-0.058,0.108-0.097c0.007-0.042-0.147-0.072-0.199-0.067\r\n\t\t\t\tc-0.027,0.007-0.053,0.015-0.08,0.022c-0.065,0.001-0.133-0.039-0.158-0.08c0.031-0.004,0.053,0.006,0.077,0.01\r\n\t\t\t\tc0.032,0.005,0.153,0.002,0.167-0.005c0.121,0.041,0.265,0.068,0.372,0.122c0.097-0.022,0.152-0.08,0.272-0.089\r\n\t\t\t\tc0.1-0.007,0.172,0.031,0.261,0.04c0.04-0.01,0.035-0.031,0.071-0.042c0.056,0.011,0.104,0.041,0.15,0.063\r\n\t\t\t\tc0.024,0.008,0.048,0.017,0.071,0.025c0.016,0.019,0.031,0.037,0.047,0.056c0.021,0.005,0.032-0.001,0.046,0.011\r\n\t\t\t\tc0.015,0.022,0.03,0.044,0.045,0.066c0.042,0.038,0.131,0.059,0.2,0.07c0.101,0.016,0.192,0.009,0.27-0.045\r\n\t\t\t\tc0.017-0.012,0.034-0.02,0.038-0.036c0.013-0.051-0.114-0.086-0.107-0.166c0.001-0.001,0.003-0.002,0.004-0.003\r\n\t\t\t\tc0.014,0.037,0.178,0.137,0.22,0.148c0.022,0.005,0.059,0.007,0.087-0.007c0.02-0.01,0.031-0.026,0.039-0.041\r\n\t\t\t\tc0.037-0.061-0.073-0.08-0.109-0.114c0.003-0.006,0.006-0.013,0.01-0.019c-0.026,0-0.033-0.018-0.043-0.033\r\n\t\t\t\tc-0.013-0.002-0.028,0-0.049,0.004c-0.004-0.04,0.038-0.112-0.07-0.076c0.009-0.016,0.01-0.032,0.012-0.052\r\n\t\t\t\tc-0.015,0.002-0.03,0.005-0.045,0.007c-0.002,0-0.004,0-0.005-0.001c-0.033-0.116-0.015-0.165-0.164-0.203\r\n\t\t\t\tc-0.003,0-0.005,0-0.008,0c-0.019,0.045-0.027,0.105-0.038,0.15c-0.001,0.001-0.003,0.002-0.004,0.003\r\n\t\t\t\tc-0.006-0.003-0.013-0.007-0.019-0.01c-0.004-0.025,0.002-0.056-0.014-0.084c-0.022-0.037-0.043-0.094-0.038-0.131\r\n\t\t\t\tc-0.051,0.012-0.061,0.058-0.095,0.08c-0.009-0.002-0.019-0.003-0.028-0.005c0-0.058-0.017-0.052-0.091-0.052\r\n\t\t\t\tc-0.013-0.02-0.001-0.032-0.007-0.054c-0.005-0.001-0.01-0.003-0.014-0.004c-0.012,0.001-0.02,0.003-0.029,0.007\r\n\t\t\t\tc-0.007-0.003-0.006-0.001-0.01-0.008c-0.053,0.01-0.081,0.001-0.126,0.003c-0.151,0.005-0.169,0.037-0.238-0.051\r\n\t\t\t\tc-0.041-0.009-0.201-0.016-0.26-0.004c-0.013,0.035-0.019,0.069-0.038,0.102c-0.018,0.027-0.037,0.054-0.055,0.08\r\n\t\t\t\tc-0.003,0.002-0.006,0.005-0.008,0.007c-0.027-0.016-0.116-0.06-0.103-0.103c0.009-0.015,0.038-0.018,0.056-0.029\r\n\t\t\t\tc0.021-0.013,0.084-0.093,0.073-0.115c-0.015-0.03-0.082-0.03-0.118-0.039c-0.039-0.01-0.067-0.043-0.116-0.041\r\n\t\t\t\tc-0.046,0.002-0.061,0.033-0.074,0.049c-0.018,0.016-0.035,0.032-0.053,0.048c-0.021,0.029-0.031,0.063-0.043,0.095\r\n\t\t\t\tc-0.007,0.002-0.013,0.004-0.019,0.005c-0.015-0.051-0.072-0.083-0.151-0.068c0,0,0-0.001-0.001-0.001\r\n\t\t\t\tc0.024-0.031,0.103-0.012,0.139-0.034c0.06-0.036,0.077-0.119,0.142-0.155c0.004-0.005,0.009-0.01,0.013-0.016\r\n\t\t\t\tc-0.078-0.016-0.155-0.032-0.243-0.04c-0.032,0.023-0.05,0.013-0.09,0.032c-0.021,0.015-0.043,0.03-0.064,0.045\r\n\t\t\t\tc-0.072,0.047-0.113,0.067-0.106,0.143c-0.023-0.003-0.035-0.007-0.05-0.017c-0.124-0.083,0.099-0.103,0.101-0.159\r\n\t\t\t\tc0.001-0.031-0.064-0.029-0.086-0.038c-0.002,0-0.004,0-0.005-0.001c0,0,0-0.001-0.001-0.002c0.065-0.02,0.17-0.047,0.208-0.018\r\n\t\t\t\tc0.055-0.015,0.091-0.086,0.101-0.119c0.002-0.012,0.004-0.024,0.007-0.036c0.019-0.029,0.096-0.064,0.136-0.084\r\n\t\t\t\tc0.001-0.002,0.002-0.004,0.003-0.005c-0.051-0.005-0.107-0.018-0.136-0.046c0.06,0.007,0.119,0.006,0.189,0.005\r\n\t\t\t\tc-0.007-0.017-0.02-0.023-0.032-0.034c-0.018-0.066,0.148-0.105,0.248-0.112c0.019-0.003,0.038-0.006,0.058-0.01\r\n\t\t\t\tc0.014,0.001,0.034,0.006,0.062-0.003c0.018-0.006,0.028-0.016,0.039-0.024c0.005,0.031-0.025,0.045-0.053,0.063\r\n\t\t\t\tc-0.039,0.004-0.2-0.007-0.232,0.033c0,0.003,0,0.005,0,0.008c0.038,0.019,0.086,0.056,0.135,0.064\r\n\t\t\t\tc0.063,0.01,0.146-0.01,0.22-0.012c0.032,0,0.063,0,0.095,0c0.05-0.056,0.09-0.128,0.108-0.194\r\n\t\t\t\tc0.015-0.005,0.03-0.001,0.047-0.002c0.036-0.002,0.135-0.04,0.152-0.052c0.047-0.035-0.09-0.189-0.128-0.197\r\n\t\t\t\tc-0.032-0.007-0.07-0.002-0.107-0.004c-0.059-0.004-0.24-0.04-0.269,0.031c0.007,0.018,0.019,0.023,0.032,0.034\r\n\t\t\t\tc0.001,0.002,0.001,0.003,0.002,0.005c-0.054,0.001-0.109,0.001-0.163,0.001c-0.002,0-0.003,0.001-0.005,0.001\r\n\t\t\t\tc-0.006-0.034,0.037-0.085,0.002-0.115c-0.013-0.007-0.061,0.002-0.077,0c-0.003-0.017,0.025-0.026,0.044-0.033\r\n\t\t\t\tc0.024-0.05-0.082-0.091-0.112-0.123c0,0,0-0.001-0.001-0.002c0.049,0.003,0.087,0.023,0.143,0.019\r\n\t\t\t\tc0.08-0.005,0.117-0.075,0.219-0.082c0.053-0.003,0.078,0.028,0.129,0.024c0.015-0.006,0.029-0.012,0.044-0.018\r\n\t\t\t\tc0.076-0.037,0.128-0.084,0.117-0.15c-0.006-0.035-0.112-0.077-0.174-0.057c-0.075,0.034-0.15,0.068-0.225,0.101\r\n\t\t\t\tc-0.023,0.015-0.039,0.033-0.066,0.048c0.001-0.026,0.017-0.077,0-0.103c-0.026-0.042-0.069-0.068-0.087-0.113\r\n\t\t\t\tc-0.144,0.026-0.093,0.074-0.143,0.127c-0.101,0.032-0.174-0.025-0.264-0.018c0.036-0.037,0.154-0.006,0.199-0.003\r\n\t\t\t\tc0.004-0.001,0.008-0.001,0.012-0.002c0.006-0.013,0.012-0.027,0.018-0.04c0.021-0.034,0.052-0.065,0.088-0.093\r\n\t\t\t\tc-0.001-0.001-0.003-0.003-0.004-0.004c-0.015-0.008-0.041-0.006-0.061-0.008c-0.037-0.005-0.076-0.012-0.118-0.013\r\n\t\t\t\tc-0.078,0-0.163,0.02-0.217-0.003c0.044-0.008,0.061-0.02,0.074-0.039c-0.012-0.023-0.076-0.028-0.104-0.037\r\n\t\t\t\tc-0.001-0.002-0.001-0.004-0.002-0.006c0.057-0.01,0.172,0.001,0.217,0.01c0.051,0.011,0.098,0.041,0.167,0.033\r\n\t\t\t\tc0.034-0.018,0.074-0.065,0.132-0.048c0.029,0.008,0.042,0.034,0.072,0.043c0.067-0.007,0.093-0.07,0.062-0.117\r\n\t\t\t\tc-0.04-0.061-0.125-0.079-0.182-0.12c-0.022-0.016-0.009-0.05-0.031-0.062c-0.042-0.024-0.124,0-0.196,0.004\r\n\t\t\t\tc-0.024-0.002-0.048-0.003-0.073-0.005c-0.041,0.002-0.072,0.028-0.098,0.039c-0.039,0.016-0.082,0.03-0.131,0.042\r\n\t\t\t\tc0-0.001-0.001-0.002-0.001-0.003c0.069-0.022,0.084-0.061,0.131-0.091c0.041-0.027,0.109-0.044,0.145-0.073\r\n\t\t\t\tc0.016-0.013,0.031-0.04,0.007-0.058c-0.01-0.007-0.041-0.008-0.068-0.013c0.057-0.028,0.115-0.055,0.172-0.083\r\n\t\t\t\tc0.024,0.008,0.048,0.016,0.072,0.024c0.029,0.02,0.058,0.041,0.086,0.062c0.003,0.001,0.006,0.001,0.008,0.002\r\n\t\t\t\tc0.003-0.003,0.005-0.005,0.008-0.008c-0.002-0.029-0.048-0.05-0.072-0.066c-0.018-0.012-0.036-0.025-0.053-0.037\r\n\t\t\t\tC24.16,6.946,27.965,6,32,6c4.819,0,9.317,1.335,13.186,3.62c-0.129,0.065-0.246,0.164-0.324,0.268\r\n\t\t\t\tc-0.048-0.001-0.132-0.022-0.153-0.019c-0.081,0.013-0.199,0.161-0.229,0.229c-0.013,0.013-0.025,0.025-0.038,0.038\r\n\t\t\t\tc0.039,0.028,0.075,0.062,0.102,0.102c-0.098,0.069-0.24,0.035-0.292,0.153c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc0.032,0.03,0.064,0.059,0.095,0.089c-0.004,0.027-0.008,0.055-0.013,0.083c-0.383-0.001-0.322,0.111-0.547,0.216v0.006\r\n\t\t\t\tc0.208,0.251,0.238,0.04,0.521,0.089c0.13,0.023,0.226,0.096,0.343,0.121c0.109-0.061,0.161-0.161,0.248-0.241\r\n\t\t\t\tc-0.002-0.025-0.004-0.051-0.006-0.076c-0.034-0.021-0.068-0.042-0.102-0.064c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.023-0.023,0.047-0.047,0.07-0.07c0.074,0.003,0.112,0.025,0.159,0.051c0.055-0.058,0.136-0.114,0.197-0.165v-0.013\r\n\t\t\t\tc-0.021-0.017-0.042-0.034-0.064-0.051c-0.013-0.017-0.002-0.045,0.006-0.076c0.015-0.013,0.03-0.026,0.044-0.038\r\n\t\t\t\tc0.107,0.001,0.27,0.047,0.356,0.006c0.036-0.028,0.072-0.055,0.108-0.083c0.021-0.023,0.042-0.047,0.063-0.07\r\n\t\t\t\tc-0.028-0.015-0.055-0.03-0.083-0.045c0.009-0.043,0.048-0.077,0.099-0.106c0.83,0.518,1.632,1.072,2.395,1.677\r\n\t\t\t\tc-0.005,0.025-0.011,0.05-0.016,0.075c-0.049,0.083-0.097,0.165-0.146,0.248c-0.135,0.174-0.528,0.182-0.464,0.489\r\n\t\t\t\tc0.053,0.004,0.106,0.008,0.159,0.013c0.135,0.378-0.104,0.29-0.146,0.515c0.07,0.108,0.28,0.064,0.369,0.153\r\n\t\t\t\tc0.03,0.036-0.002,0.112,0.013,0.165c0.035,0.124,0.135,0.168,0.286,0.146c-0.018,0.094-0.114,0.264-0.184,0.311\r\n\t\t\t\tc-0.016,0.013-0.038,0.014-0.07,0.013c-0.378-0.351-0.896-0.546-1.468-0.705c-0.123-0.034-0.46-0.13-0.635-0.089\r\n\t\t\t\tc-0.081,0.019-0.116,0.1-0.184,0.134c-0.002,0.004-0.004,0.008-0.006,0.013c0.061,0.078,0.123,0.157,0.184,0.235\r\n\t\t\t\tc-0.01,0.223-0.12,0.179-0.292,0.203c-0.021,0.033-0.037,0.114-0.051,0.146c-0.095,0.048-0.191-0.018-0.216-0.089\r\n\t\t\t\tc0.03-0.038,0.059-0.076,0.089-0.115c-0.178-0.082-0.286-0.093-0.451,0.032c-0.042,0.034-0.085,0.068-0.127,0.102\r\n\t\t\t\tc-0.1,0.03-0.176-0.034-0.235-0.051c-0.105-0.03-0.28-0.002-0.362,0.032c-0.091,0.037-0.088,0.172-0.172,0.222\r\n\t\t\t\tc-0.028-0.015-0.037-0.02-0.044-0.057c-0.182,0.003-0.224,0.07-0.375,0.019c0-0.05,0.007-0.062,0.025-0.089\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0-0.097,0.017-0.161,0.026-0.235c-0.381-0.002-0.167,0.2-0.419,0.248\r\n\t\t\t\tc-0.006-0.002-0.013-0.004-0.019-0.006c-0.011-0.034-0.021-0.068-0.032-0.102c-0.133,0.055-0.267,0.11-0.4,0.165\r\n\t\t\t\tc-0.226,0.09-0.453,0.187-0.661,0.273c-0.051,0.015-0.102,0.03-0.153,0.045c-0.087,0.07-0.049,0.285-0.14,0.349\r\n\t\t\t\tc-0.057,0.011-0.115,0.021-0.172,0.032c-0.341,0.069-0.427-0.091-0.629-0.248c0.041-0.201,0.281-0.195,0.508-0.203\r\n\t\t\t\tc-0.055-0.114-0.169-0.349-0.305-0.375c-0.097,0.009-0.195,0.017-0.292,0.025c-0.082-0.018-0.133-0.053-0.216-0.032\r\n\t\t\t\tc-0.017,0.148,0.159,0.164,0.121,0.337c-0.051,0.081-0.102,0.161-0.152,0.241c-0.004,0.004-0.009,0.009-0.013,0.013\r\n\t\t\t\tc0.034,0.051,0.079,0.078,0.153,0.089c0.079,0.238,0.029,0.214-0.032,0.407c-0.006,0.036-0.013,0.072-0.019,0.108v0.013\r\n\t\t\t\tc-0.166-0.008-0.335-0.211-0.566-0.184c-0.124,0.261-0.492,0.237-0.661,0.445c0.005,0.173,0.26,0.294,0.14,0.47\r\n\t\t\t\tc-0.034-0.011-0.068-0.021-0.102-0.032c-0.071,0.008-0.14,0.046-0.235,0.019c-0.217-0.062-0.433-0.161-0.604-0.267\r\n\t\t\t\tc-0.103,0-0.1,0.078-0.153,0.127c0.003,0.063,0.126,0.201,0.191,0.229c0.057,0.024,0.137-0.001,0.191,0.006\r\n\t\t\t\tc0.15,0.265-0.1,0.247-0.261,0.21c-0.072-0.016-0.157,0.001-0.21-0.032c-0.029-0.021-0.053-0.077-0.064-0.114\r\n\t\t\t\tc-0.076-0.038-0.207-0.014-0.292-0.057c-0.043-0.022-0.208-0.444-0.216-0.527c0.122-0.036,0.163-0.19,0.07-0.292\r\n\t\t\t\tc-0.066-0.072-0.223-0.087-0.305-0.14c-0.136-0.088-0.245-0.222-0.362-0.33c0.221-0.112,0.253,0.089,0.343,0.14\r\n\t\t\t\tc0.07,0.011,0.14,0.021,0.21,0.032c0.5,0.15,1.305,0.524,1.831,0.127c0.111-0.084,0.24-0.161,0.235-0.343\r\n\t\t\t\tc-0.069-0.069-0.081-0.106-0.076-0.242c-0.091-0.072-0.211-0.158-0.331-0.197c-0.127-0.038-0.254-0.076-0.381-0.115\r\n\t\t\t\tc-0.121-0.102-0.242-0.203-0.362-0.305c-0.068-0.021-0.136-0.042-0.203-0.063c-0.108-0.038-0.216-0.076-0.324-0.114\r\n\t\t\t\tc-0.18-0.013-0.36-0.025-0.54-0.038c-0.03,0.023-0.059,0.047-0.089,0.07c-0.004-0.046-0.008-0.093-0.013-0.14\r\n\t\t\t\tc-0.183-0.035-0.345-0.068-0.35-0.28c-0.061,0.036-0.123,0.072-0.184,0.108c-0.046,0.019-0.103,0.021-0.14,0.044\r\n\t\t\t\tc-0.114-0.074-0.219-0.036-0.369-0.025c-0.066-0.103-0.205-0.127-0.28-0.222c0.237,0.002,0.468,0.029,0.591-0.095\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.028-0.017-0.055-0.034-0.083-0.051c-0.065-0.023-0.14,0.003-0.191-0.019\r\n\t\t\t\tc-0.106-0.045-0.177-0.123-0.299-0.159c-0.07,0.062-0.137,0.151-0.152,0.267c-0.04-0.008-0.081-0.017-0.121-0.025\r\n\t\t\t\tc0.041-0.129,0.058-0.18,0.127-0.279c-0.05-0.066-0.162-0.027-0.242-0.013c-0.045,0.144-0.117,0.243-0.248,0.305\r\n\t\t\t\tc-0.004-0.093-0.008-0.187-0.013-0.28c-0.139,0.095-0.322,0.263-0.388,0.426c-0.017-0.002-0.034-0.004-0.051-0.006\r\n\t\t\t\tc-0.001-0.246,0.115-0.269,0.216-0.4c-0.281-0.021-0.326,0.061-0.47,0.203c-0.031,0.023-0.079-0.012-0.121,0.013\r\n\t\t\t\tc-0.073,0.044-0.144,0.185-0.172,0.273c-0.187-0.096-0.28-0.273-0.381,0.083c-0.042-0.036-0.085-0.072-0.127-0.108\r\n\t\t\t\tc-0.006-0.002-0.013-0.004-0.019-0.006c-0.048,0.076-0.089,0.121-0.203,0.134c-0.027,0.103-0.078,0.174-0.153,0.229\r\n\t\t\t\tc0.014-0.069,0.027-0.136,0.051-0.191c-0.004-0.011-0.008-0.021-0.013-0.032c-0.006-0.004-0.013-0.008-0.019-0.013\r\n\t\t\t\tc-0.084,0.046-0.148,0.229-0.197,0.311c-0.135-0.012-0.165-0.08-0.299-0.032c-0.025-0.021-0.051-0.042-0.076-0.063\r\n\t\t\t\tc-0.061,0.246-0.091,0.112-0.216,0.203c-0.066,0.048-0.033,0.116-0.146,0.153c-0.019,0.021-0.038,0.042-0.057,0.063\r\n\t\t\t\tc0.026,0.021,0.051,0.042,0.076,0.064v0.006c-0.036,0.051-0.106,0.052-0.172,0.038c0.011,0.047,0.021,0.093,0.032,0.14\r\n\t\t\t\tc-0.019,0.028-0.038,0.055-0.057,0.083c-0.006,0.004-0.013,0.009-0.019,0.013c-0.046-0.028-0.064-0.041-0.089-0.089h-0.006\r\n\t\t\t\tc-0.065,0.006-0.07,0.078-0.133,0.102c-0.009,0.027,0.014,0.055,0.044,0.076v0.038c-0.054,0.016-0.077,0.025-0.102,0.07\r\n\t\t\t\tc-0.041-0.01-0.074-0.026-0.127-0.032c-0.044,0.035-0.058,0.078-0.121,0.095c0.011,0.038,0.019,0.052,0.057,0.064\r\n\t\t\t\tc-0.034,0.075-0.199,0.095-0.273,0.134c-0.006,0.004-0.013,0.008-0.019,0.013c0.021,0.036,0.042,0.072,0.064,0.108v0.006\r\n\t\t\t\tc-0.065,0.004-0.112,0.01-0.178,0.006c-0.021,0.034-0.042,0.068-0.063,0.102c0.042,0.051,0.093,0.07,0.127,0.134v0.006\r\n\t\t\t\tc-0.042,0.006-0.085,0.013-0.127,0.019c-0.006,0.042-0.013,0.085-0.019,0.127c-0.163-0.038-0.167,0.098-0.229,0.21\r\n\t\t\t\tc0.021,0.006,0.042,0.013,0.064,0.019c0.002,0.044,0.004,0.089,0.006,0.133c-0.05,0.003-0.081,0.005-0.121-0.006\r\n\t\t\t\tc-0.075,0.075-0.123,0.164-0.203,0.235c0.006,0.019,0.013,0.038,0.019,0.057v0.006c-0.063,0.046-0.087,0.015-0.159,0\r\n\t\t\t\tc-0.094,0.045-0.266,0.185-0.311,0.28c-0.006,0.034-0.013,0.068-0.019,0.102c-0.039,0.065-0.125,0.084-0.159,0.165\r\n\t\t\t\tc-0.006,0.004-0.013,0.009-0.019,0.013c-0.019-0.013-0.038-0.026-0.057-0.038c-0.08-0.054-0.225,0.137-0.222,0.242\r\n\t\t\t\tc-0.085-0.036-0.205-0.032-0.337-0.032l-0.032,0.032c0.017,0.072,0.086,0.103,0.159,0.114c-0.063,0.075-0.159,0.014-0.267,0.006\r\n\t\t\t\tc-0.021,0.084-0.011,0.111-0.089,0.14c-0.1-0.04-0.144,0.042-0.248,0.076c-0.002,0.017-0.004,0.034-0.006,0.051\r\n\t\t\t\tc0.025,0.034,0.072,0.048,0.108,0.07v0.025c-0.066,0.004-0.131,0.008-0.197,0.013c-0.025,0.075-0.001,0.151-0.038,0.21\r\n\t\t\t\tc0.034,0.046,0.043,0.085,0.102,0.108c0.002,0.004,0.004,0.008,0.006,0.013c-0.056,0.046-0.091,0.058-0.114,0.14\r\n\t\t\t\tc0.004,0.011,0.008,0.021,0.013,0.032c0.041,0.028,0.07,0.034,0.121,0.013c0.011,0.013,0.021,0.025,0.032,0.038\r\n\t\t\t\tc-0.041,0.034-0.089,0.076-0.127,0.114c0.053,0.078,0.112,0.033,0.222,0.045c-0.007,0.055-0.021,0.092-0.07,0.108\r\n\t\t\t\tc-0.008,0.011-0.017,0.021-0.025,0.032c0.015,0.013,0.03,0.025,0.044,0.038c0.06-0.001,0.086-0.014,0.127-0.032\r\n\t\t\t\tc-0.027,0.037-0.064,0.055-0.127,0.057c0.001,0.016-0.001,0.007,0.006,0.025c-0.032,0.014-0.05,0.004-0.083-0.013v0.038h-0.006\r\n\t\t\t\tc-0.004-0.017-0.008-0.034-0.013-0.051c-0.002-0.004-0.004-0.008-0.006-0.013c-0.025,0.03-0.051,0.059-0.076,0.089\r\n\t\t\t\tc0.008,0.03,0.017,0.059,0.025,0.089c0.011,0.006,0.021,0.013,0.032,0.019c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc0.006,0.011,0.013,0.021,0.019,0.032c0.051-0.002,0.06-0.014,0.095-0.026c-0.002-0.025-0.004-0.051-0.006-0.076\r\n\t\t\t\tc0.025,0.019,0.035,0.027,0.038,0.07h0.006c0.028-0.025,0.055-0.051,0.083-0.076c-0.018,0.039-0.04,0.052-0.064,0.083\r\n\t\t\t\tc0.032,0.02,0.042,0.024,0.089,0.019v0.007c-0.038,0.021-0.076,0.042-0.114,0.063c-0.009,0.028-0.004,0.013,0.006,0.045\r\n\t\t\t\tc0.046,0.033,0.031,0.018,0.102,0.013v0.006c-0.036,0.006-0.042,0.012-0.057,0.038c0.006,0.008,0.013,0.017,0.019,0.025\r\n\t\t\t\tc-0.036-0.022-0.065-0.056-0.089-0.019c-0.006,0.004-0.013,0.008-0.019,0.013c-0.002-0.019-0.004-0.038-0.006-0.057\r\n\t\t\t\tc-0.017-0.002-0.034-0.004-0.051-0.006c0.015,0.05-0.003,0.072-0.025,0.114c0.019,0.038,0.038,0.076,0.057,0.114\r\n\t\t\t\tc0.123,0.036,0.19,0.086,0.305,0.115c-0.013,0.013-0.026,0.025-0.038,0.038c0.013,0.008,0.025,0.017,0.038,0.025\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.03,0.015,0.042,0.019,0.051,0.057c0.07,0.017,0.282-0.01,0.349-0.044\r\n\t\t\t\tc0.108-0.107,0.244-0.176,0.356-0.28c0.039-0.036,0.039-0.072,0.095-0.095c0.038-0.02,0.087,0.023,0.14-0.013\r\n\t\t\t\tc0.062-0.046,0.08-0.127,0.083-0.222c0.015-0.011,0.03-0.021,0.044-0.032c0.012,0.047,0.011,0.056-0.013,0.089\r\n\t\t\t\tc0.053,0.074,0.056,0.142,0.165,0.095c0.004,0.002,0.008,0.004,0.013,0.006c0.006,0.051-0.02,0.065-0.032,0.114\r\n\t\t\t\tc0.052,0.027,0.057,0.174,0.057,0.248c0.019-0.002,0.038-0.004,0.057-0.007c0.002,0.017,0.004,0.034,0.006,0.051\r\n\t\t\t\tc0.048-0.012,0.047-0.013,0.089,0c0.008,0.048-0.026,0.118-0.044,0.165c0.047,0.06,0.08,0.086,0.076,0.203\r\n\t\t\t\tc0.017,0.002,0.034,0.004,0.051,0.006c0.049,0.164,0.149,0.23,0.242,0.324c-0.004,0.017-0.009,0.034-0.013,0.051\r\n\t\t\t\tc-0.019-0.002-0.038-0.004-0.057-0.006c0.002,0.017,0.004,0.034,0.006,0.051c-0.021,0.011-0.042,0.021-0.064,0.032\r\n\t\t\t\tc0.042,0.083,0.088,0.169,0.159,0.222c-0.016,0.061-0.039,0.075-0.051,0.134c0.151,0.032,0.257-0.029,0.381,0\r\n\t\t\t\tc0.011-0.013,0.021-0.025,0.032-0.038c0.037-0.032,0.005-0.05-0.019-0.089c0.023-0.06,0.036-0.108,0.095-0.133\r\n\t\t\t\tc0.019-0.011,0.012-0.005,0.038,0.006c0.004-0.017,0.009-0.034,0.013-0.051c0.11,0.001,0.175-0.008,0.254-0.025\r\n\t\t\t\tc0.021,0.015,0.042,0.03,0.064,0.045c0.004,0.004,0.008,0.008,0.013,0.013c0.059-0.108,0.119-0.216,0.178-0.324\r\n\t\t\t\tc0.002-0.04,0.004-0.08,0.006-0.121c0.011-0.057,0.039-0.09,0.057-0.133c0.016-0.027-0.011-0.058,0.006-0.102\r\n\t\t\t\tc-0.015-0.006-0.03-0.013-0.045-0.019V18.53h0.064c0.095-0.071-0.057-0.253-0.07-0.318c0.059-0.002,0.119-0.004,0.178-0.006\r\n\t\t\t\tc0.002-0.013,0.004-0.025,0.006-0.038c0.176,0.031,0.106-0.133,0.191-0.165v0.095c0.002,0.002,0.004,0.004,0.006,0.006\r\n\t\t\t\tc0.019-0.002,0.038-0.004,0.057-0.006c0.014-0.068,0.052-0.091,0.114-0.108c-0.004-0.021-0.008-0.042-0.013-0.064\r\n\t\t\t\tc0.027-0.002,0.055-0.004,0.083-0.006c-0.002-0.011-0.004-0.021-0.006-0.032c-0.002-0.004-0.004-0.008-0.006-0.013h-0.032v0.032\r\n\t\t\t\tc-0.102-0.041-0.174,0.062-0.28,0.045c-0.111-0.019-0.163-0.137-0.299-0.095H32.8c0.009-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.037-0.04,0.304,0.049,0.369,0.083c0.082,0.043,0.287-0.119,0.311-0.153h0.057c-0.002-0.095-0.048-0.099-0.07-0.178\r\n\t\t\t\tc-0.126-0.018-0.206-0.104-0.248-0.203c-0.025,0.002-0.051,0.004-0.076,0.006c-0.038-0.015-0.062-0.043-0.133-0.045\r\n\t\t\t\tc-0.002-0.004-0.004-0.008-0.006-0.013c0.046-0.039-0.052-0.296-0.025-0.4c0.023-0.006,0.047-0.013,0.07-0.019\r\n\t\t\t\tc0.055-0.173,0-0.204-0.019-0.356c0.038,0.013,0.076,0.025,0.114,0.038c0.021-0.028,0.042-0.055,0.064-0.083\r\n\t\t\t\tc0.016-0.027-0.004-0.073-0.013-0.115h0.127c0.08-0.112,0.117-0.111,0.222-0.191c0.05-0.038,0.05-0.096,0.114-0.127\r\n\t\t\t\tc0.023,0.015,0.047,0.03,0.07,0.044c0.099-0.068,0.199-0.136,0.299-0.203c0.071-0.087,0.077-0.196,0.184-0.248\r\n\t\t\t\tc0.004-0.006,0.008-0.013,0.013-0.019c-0.034-0.052-0.095-0.08-0.121-0.133c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.053-0.023,0.128-0.081,0.152-0.133c0.023-0.036-0.022-0.072-0.044-0.102c0.077-0.104,0.108-0.037,0.184-0.095\r\n\t\t\t\tc0.091-0.069,0.094-0.193,0.21-0.248c0.051,0.034,0.102,0.068,0.153,0.102c0.022,0.014,0.223-0.034,0.305-0.032\r\n\t\t\t\tc0.078,0.06,0.117,0.113,0.261,0.115c0.011,0.019,0.021,0.038,0.032,0.057c0.014,0.037-0.006,0.12-0.019,0.159\r\n\t\t\t\tc0.017,0.019,0.034,0.038,0.051,0.057c0.013,0.018,0.009,0.038,0.006,0.076c-0.04-0.002-0.081-0.004-0.121-0.006\r\n\t\t\t\tc-0.098,0.028-0.543,0.488-0.61,0.585h-0.032c-0.013-0.019-0.025-0.038-0.038-0.057v-0.013c-0.09,0.094-0.016,0.207-0.159,0.28\r\n\t\t\t\tc-0.059-0.024-0.1-0.032-0.159-0.013c0.004,0.027,0.008,0.055,0.013,0.083c-0.073,0.067-0.121,0.102-0.153,0.216\r\n\t\t\t\tc0.026,0.023,0.063,0.043,0.089,0.064c0,0.094-0.02,0.143-0.032,0.216c0.034,0.053,0.068,0.106,0.102,0.159\r\n\t\t\t\tc-0.008,0.04-0.017,0.08-0.025,0.121c-0.035,0.188-0.011,0.31,0.127,0.381c0.058,0.03,0.07,0.065,0.146,0.038l-0.006,0.076\r\n\t\t\t\tc0.053-0.018,0.094-0.039,0.172-0.038c-0.011,0.023-0.021,0.047-0.032,0.07c0.02,0.042,0.039,0.071,0.083,0.089\r\n\t\t\t\tc0.067,0.051,0.193-0.016,0.235-0.038v0.026c0.065-0.014,0.081-0.027,0.133,0c0.043-0.058,0.077-0.069,0.153-0.095\r\n\t\t\t\tc0.004,0.008,0.008,0.017,0.013,0.025c0.051-0.028,0.141-0.037,0.165-0.095c0.027,0.019,0.055,0.038,0.083,0.057h0.006\r\n\t\t\t\tc0.017-0.083,0.1-0.04,0.152-0.083c0.028-0.017,0.04-0.057,0.045-0.095v0.057c0.036,0.013,0.072,0.025,0.108,0.038\r\n\t\t\t\tc0.026-0.027,0.034-0.043,0.083-0.051c0.021,0.013,0.042,0.025,0.064,0.038c0.059-0.057,0.198-0.098,0.299-0.108\r\n\t\t\t\tc0.008-0.015,0.017-0.03,0.025-0.045c0.029-0.003-0.01,0.079-0.019,0.114c0.148,0.215,0.345-0.041,0.489,0.229\r\n\t\t\t\tc-0.015,0.011-0.03,0.021-0.045,0.032c-0.094-0.003-0.14-0.044-0.222-0.07c-0.076,0.006-0.1,0.066-0.14,0.108\r\n\t\t\t\tc-0.053-0.012-0.053-0.037-0.102-0.025c-0.016,0.027-0.014,0.015-0.006,0.045c-0.031,0.029-0.052,0.003-0.076-0.025\r\n\t\t\t\tc-0.013,0.002-0.025,0.004-0.038,0.006c-0.004,0.015-0.008,0.03-0.013,0.045c0.032,0.038,0.067,0.051,0.064,0.108\r\n\t\t\t\tc-0.008-0.008-0.017-0.017-0.025-0.025c-0.018-0.007-0.058,0.067-0.108,0.064c-0.163-0.011-0.296-0.042-0.451-0.07\r\n\t\t\t\tc-0.078-0.014-0.166,0.024-0.203-0.006c-0.017,0.015-0.034,0.03-0.051,0.044c-0.049-0.011-0.098-0.021-0.146-0.032\r\n\t\t\t\tc-0.004,0.015-0.008,0.03-0.013,0.045c-0.044-0.007-0.062,0.006-0.102-0.006c-0.085,0.046-0.145,0.095-0.28,0.102\r\n\t\t\t\tc0.006,0.043,0.013,0.056-0.025,0.07c0.023,0.062,0.023,0.099,0.044,0.165c0.022,0,0.035-0.011,0.057-0.026\r\n\t\t\t\tc-0.002,0.057-0.004,0.115-0.006,0.172c0.057,0.016,0.08,0.031,0.121,0.051c0.025-0.023,0.051-0.047,0.076-0.07\r\n\t\t\t\tc0.013,0.009,0.025,0.017,0.038,0.025c-0.021,0.16-0.09,0.268-0.038,0.451c-0.041,0.106-0.222,0.17-0.324,0.076\r\n\t\t\t\tc-0.015-0.04-0.03-0.081-0.044-0.121c-0.047-0.034-0.093-0.068-0.14-0.102v-0.044c-0.113,0.004-0.154,0.056-0.267,0.057\r\n\t\t\t\tc-0.034,0.043-0.068,0.085-0.102,0.127c-0.002,0.044-0.004,0.089-0.006,0.133c-0.032,0.025-0.064,0.051-0.095,0.076\r\n\t\t\t\tc-0.068,0.143,0.034,0.501,0.064,0.578c-0.009,0.025,0,0,0.013,0.025c-0.011,0.002-0.021,0.004-0.032,0.006\r\n\t\t\t\tc0.011,0.035,0.018,0.047,0.013,0.089c-0.081,0.046-0.249,0.013-0.362,0.007c-0.016,0.05-0.021,0.111-0.025,0.165\r\n\t\t\t\tc-0.125,0.066-0.209,0.161-0.388,0.095c-0.009-0.053-0.026-0.086-0.051-0.121c0.005-0.087-0.213-0.034-0.28-0.013\r\n\t\t\t\tc-0.291,0.091-0.499,0.261-0.852,0.286c0.004,0.069,0.012,0.088,0.013,0.146c-0.08-0.028-0.139-0.055-0.21-0.083\r\n\t\t\t\tc-0.004-0.036-0.008-0.072-0.013-0.108c-0.081-0.042-0.175,0.016-0.222-0.121c-0.058-0.004-0.427,0.12-0.458,0.197h-0.07\r\n\t\t\t\tc-0.004-0.013-0.009-0.025-0.013-0.038h-0.006c-0.033,0.022-0.061,0.024-0.095,0.013c-0.004-0.006-0.008-0.013-0.013-0.019\r\n\t\t\t\tc0.045-0.038,0.069-0.048,0.102-0.102c-0.006-0.013-0.013-0.025-0.019-0.038c-0.049,0.004-0.097,0.009-0.146,0.013\r\n\t\t\t\tc-0.057-0.013-0.065-0.053-0.121-0.025c-0.014-0.043-0.014-0.04-0.064-0.038c0.059-0.095-0.063-0.185-0.133-0.21\r\n\t\t\t\tc0.013-0.092,0.038-0.176,0.089-0.229c-0.006-0.011-0.013-0.021-0.019-0.032c0.028-0.002,0.055-0.004,0.083-0.006\r\n\t\t\t\tc0.023-0.081,0.102-0.094,0.064-0.191c0.021-0.011,0.042-0.021,0.064-0.032c0.013,0.017,0.025,0.034,0.038,0.051\r\n\t\t\t\tc0.019-0.007,0.038-0.013,0.057-0.019c0.011-0.02,0.068-0.131,0.038-0.159c-0.051-0.002-0.102-0.004-0.153-0.006\r\n\t\t\t\tc-0.032-0.019-0.031-0.102-0.032-0.153c-0.068-0.033-0.163-0.022-0.254-0.019c-0.006,0.053-0.013,0.106-0.019,0.159\r\n\t\t\t\tc-0.013,0.014-0.02,0.015-0.044,0.019c-0.013-0.03-0.025-0.059-0.038-0.089c-0.049,0.026-0.056,0.1-0.095,0.121\r\n\t\t\t\tc-0.035,0.019-0.1-0.034-0.133-0.032c-0.071,0.107,0.012,0.181,0.019,0.286c-0.031,0.04-0.055,0.066-0.076,0.121\r\n\t\t\t\tc0.017,0.008,0.034,0.017,0.051,0.025c0.008-0.011,0.017-0.021,0.025-0.032c0.03,0.025,0.028,0.047,0.083,0.051\r\n\t\t\t\tc0.009,0.061-0.008,0.193,0.006,0.242c0.015,0.052,0.078,0.085,0.095,0.146c-0.028,0.028-0.059,0.044-0.108,0.051\r\n\t\t\t\tc0.012,0.043,0.042,0.03,0.095,0.025c-0.011,0.017-0.017,0.019-0.032,0.032c0.015,0.015,0.03,0.03,0.045,0.044\r\n\t\t\t\tc-0.011,0.008-0.021,0.017-0.032,0.025c0.002,0.011,0.004,0.021,0.006,0.032c0.023,0.011,0.047,0.021,0.07,0.032\r\n\t\t\t\tc-0.046,0.024-0.104,0.005-0.159,0c-0.019,0.061-0.035,0.076-0.006,0.133c-0.032-0.011-0.063-0.021-0.095-0.032\r\n\t\t\t\tc0.008,0.019,0.017,0.038,0.025,0.057c-0.006,0.008-0.013,0.017-0.019,0.025c-0.006,0.002-0.013,0.004-0.019,0.006\r\n\t\t\t\tc-0.006-0.004-0.013-0.008-0.019-0.013c-0.005-0.039-0.011-0.061-0.025-0.108c-0.107-0.001-0.208,0.008-0.28,0.038\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.008,0.049,0.031,0.043,0.057,0.07c-0.002,0.006-0.004,0.013-0.006,0.019h-0.025\r\n\t\t\t\tc-0.023-0.022-0.063-0.046-0.076-0.076c-0.123-0.051-0.317,0.05-0.413,0.083c-0.013,0.055-0.013,0.076-0.013,0.146\r\n\t\t\t\tc0.027,0.002,0.055,0.004,0.083,0.006c-0.015,0.024-0.023,0.03-0.025,0.07c0.024,0.016,0.034,0.024,0.076,0.026\r\n\t\t\t\tc-0.013,0.071-0.047,0.063-0.076,0.108c-0.051,0.033-0.092-0.002-0.165-0.013c0.015-0.036,0.015-0.051,0.013-0.108\r\n\t\t\t\tc0.026,0.002,0.019,0.001,0.044-0.006c0.006-0.013,0.013-0.025,0.019-0.038c-0.018-0.035-0.039-0.055-0.07-0.076\r\n\t\t\t\tc-0.032,0.008-0.064,0.017-0.095,0.026c-0.038,0.095-0.076,0.191-0.114,0.286c-0.074,0.064-0.148,0.127-0.222,0.191\r\n\t\t\t\tc0.032,0.014,0.055,0.038,0.07,0.07c-0.053,0.064-0.14-0.005-0.216,0.025c-0.055,0.036-0.11,0.072-0.165,0.108\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.007c-0.047,0.023-0.093,0.047-0.14,0.07c-0.038,0.119,0.011,0.258-0.089,0.324\r\n\t\t\t\tc-0.114,0.075-0.266,0.05-0.349,0.153c-0.002,0.013-0.004,0.025-0.006,0.038c0.021,0.006,0.042,0.013,0.064,0.019\r\n\t\t\t\tc-0.12,0.118-0.282-0.026-0.426,0.044c-0.023-0.044-0.033-0.075-0.025-0.14c-0.075,0.012-0.121,0.009-0.203,0\r\n\t\t\t\tc0.011,0.077,0.049,0.161,0.108,0.191c-0.002,0.083-0.013,0.145,0.025,0.197c-0.024,0.019-0.065,0.026-0.108,0.025v-0.044\r\n\t\t\t\tc-0.055,0.027-0.204,0.061-0.273,0.057c-0.028-0.036-0.055-0.072-0.083-0.108c-0.045,0.004-0.089,0.008-0.133,0.013\r\n\t\t\t\tc-0.006,0.015-0.013,0.03-0.019,0.044c-0.024,0.015-0.108,0.007-0.108,0.007c-0.004-0.004-0.009-0.009-0.013-0.013\r\n\t\t\t\tc-0.076,0.006-0.132,0.063-0.222,0.063c-0.002,0.028-0.004,0.055-0.006,0.083c0.038-0.014,0.077-0.021,0.133-0.019\r\n\t\t\t\tc-0.015,0.03-0.018,0.038-0.057,0.045c-0.01,0.017,0.037,0.021,0.057,0.025c0.002,0.009,0.004,0.017,0.006,0.025v0.006\r\n\t\t\t\tc-0.038,0.006-0.076,0.013-0.114,0.019c0.018,0.035,0.065,0.028,0.089,0.057c0.002,0.011,0.004,0.021,0.006,0.032\r\n\t\t\t\tc0.154-0.013,0.334,0.029,0.445,0.127c0.028-0.009,0.055-0.017,0.083-0.025c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc-0.011,0.021-0.021,0.043-0.032,0.064c0.036,0.046,0.118,0.075,0.165,0.108c-0.011,0.023-0.021,0.046-0.032,0.07\r\n\t\t\t\tc0.04,0.049,0.08,0.097,0.121,0.146c0.135,0.068,0.112,0,0.184,0.153c-0.021,0.04-0.045,0.073-0.051,0.127\r\n\t\t\t\tc0.051,0.067,0.112,0.106,0.133,0.203c-0.034-0.042-0.068-0.085-0.102-0.127h-0.006c-0.04,0.073-0.053,0.198-0.051,0.305\r\n\t\t\t\tc0.011-0.008,0.021-0.017,0.032-0.025c0.008,0.01,0.017,0.021,0.025,0.032c-0.017,0.008-0.034,0.017-0.051,0.025\r\n\t\t\t\tc-0.034,0.153-0.066,0.309-0.121,0.426c-0.162,0.027-0.245-0.039-0.375-0.076c-0.077,0.095-0.35,0.058-0.515,0.032\r\n\t\t\t\tc-0.075-0.012-0.339-0.086-0.356-0.083c-0.076,0.017-0.158,0.089-0.267,0.07c-0.137-0.023-0.23-0.099-0.369-0.044\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102h-0.083c-0.104,0.004-0.159,0.031-0.197,0.102c0.002,0.023,0.004,0.047,0.006,0.07\r\n\t\t\t\tc0.094,0.019,0.139,0.07,0.165,0.153c0.008,0.014-0.059,0.211-0.076,0.241c0.095,0.198,0.023,0.738-0.14,0.826\r\n\t\t\t\tc0.005,0.08-0.01,0.143-0.038,0.203c0.015,0.029,0.018,0.027,0.051,0.038c0.039-0.018,0.066-0.029,0.083-0.07\r\n\t\t\t\tc0.006-0.004,0.013-0.009,0.019-0.013c0.009,0.017,0.017,0.034,0.025,0.051c-0.024,0.033-0.05,0.045-0.108,0.045v0.006\r\n\t\t\t\tc0.004,0.017,0.009,0.034,0.013,0.051c0.035,0.008,0.086-0.006,0.121-0.019c0.004,0.004,0.008,0.008,0.013,0.013\r\n\t\t\t\tc-0.011,0.052-0.024,0.115-0.032,0.165c-0.002,0.004-0.004,0.008-0.006,0.013c0.016,0.028,0.041,0.09,0.025,0.152\r\n\t\t\t\tc-0.012,0.047-0.061,0.108-0.044,0.159v0.013c0.057-0.028,0.12-0.061,0.216-0.038c0.03,0.007,0.054,0.035,0.102,0.026\r\n\t\t\t\tc0.044-0.021,0.089-0.042,0.133-0.064c0.148-0.039,0.293,0.081,0.286,0.191c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.017,0.104,0.101,0.213,0.229,0.178c0.011-0.013,0.01-0.013,0.013-0.038h0.006c0.002,0.011,0.004,0.021,0.006,0.032h0.006\r\n\t\t\t\tc0.028-0.117,0.068-0.096,0.178-0.133c0.032-0.028,0.064-0.055,0.095-0.083c0.167,0.002,0.335,0.004,0.502,0.006\r\n\t\t\t\tc0.033-0.011,0.061-0.035,0.114-0.044c0.013,0.011,0.025,0.021,0.038,0.032c0.076-0.056,0.065-0.091,0.114-0.178\r\n\t\t\t\tc0.05-0.088,0.175-0.085,0.292-0.108c0.01-0.028-0.012-0.031-0.006-0.064c0.026-0.154,0.176-0.261,0.299-0.324v-0.019\r\n\t\t\t\tc-0.032-0.017-0.064-0.034-0.095-0.051c-0.023-0.053-0.047-0.106-0.07-0.159c0.031-0.147,0.225-0.389,0.356-0.438\r\n\t\t\t\tc0.002-0.004,0.004-0.009,0.006-0.013c-0.016-0.018-0.023-0.016-0.032-0.044c0.086-0.149,0.264-0.073,0.394-0.159\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.074-0.067,0.212-0.068,0.273-0.146c0.075-0.198-0.151-0.33,0.102-0.508\r\n\t\t\t\tc0.16-0.113,0.187,0.005,0.33,0.006c0.036,0,0.081-0.033,0.133-0.013c0.074,0.029,0.117,0.137,0.242,0.115\r\n\t\t\t\tc0.24-0.044,0.308-0.187,0.47-0.292c0.047-0.013,0.093-0.026,0.14-0.038c0.025-0.028,0.051-0.055,0.076-0.083\r\n\t\t\t\tc0.129-0.101,0.256-0.104,0.426-0.019c0.221,0.111,0.209,0.479,0.419,0.61c0.184,0.115,0.33,0.293,0.502,0.381\r\n\t\t\t\tc0.155,0.08,0.306,0.025,0.343,0.229c0.03-0.008,0.059-0.017,0.089-0.025h0.006c0.013,0.015,0.025,0.03,0.038,0.044\r\n\t\t\t\tc-0.011,0.004-0.021,0.009-0.032,0.013c-0.004,0.008-0.009,0.017-0.013,0.025c0.038-0.011,0.076-0.021,0.114-0.032\r\n\t\t\t\tc0.021,0.019,0.042,0.038,0.064,0.057c0.009,0.041,0.003,0.066-0.013,0.095c0.045,0.027,0.089,0.055,0.133,0.083\r\n\t\t\t\tc0.023,0.012,0.039-0.004,0.07-0.019c0.034,0.01,0.181,0.419,0.172,0.451v0.013c-0.023-0.002-0.047-0.004-0.07-0.006\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.02,0.067,0.004,0.11-0.064,0.14v0.076c0.013,0.009,0.025,0.017,0.038,0.025h0.083\r\n\t\t\t\tc0.039-0.064,0.067-0.14,0.146-0.165c0.016-0.034,0.005-0.062,0-0.108c0.045-0.043,0.063-0.067,0.159-0.064\r\n\t\t\t\tc0.011-0.013,0.021-0.026,0.032-0.038c-0.026-0.042-0.026-0.089-0.006-0.134c-0.061-0.034-0.123-0.068-0.184-0.102\r\n\t\t\t\tc0.002-0.111,0.086-0.282,0.197-0.267c-0.006,0.095,0.142,0.064,0.203,0.108c0.03,0.023,0.006,0.04,0.025,0.076\r\n\t\t\t\tc0.036,0.023,0.072,0.047,0.108,0.07c0.015-0.044,0.03-0.089,0.045-0.133c-0.196-0.193-0.436-0.359-0.744-0.438\r\n\t\t\t\tc-0.011-0.013-0.021-0.025-0.032-0.038c0.032-0.027,0.049-0.054,0.095-0.07c-0.002-0.011-0.004-0.021-0.006-0.032\r\n\t\t\t\tc-0.047-0.073-0.327,0.011-0.413-0.076c-0.08-0.081-0.209-0.198-0.254-0.305c-0.028-0.067-0.023-0.157-0.064-0.21\r\n\t\t\t\tc-0.031-0.04-0.088-0.05-0.133-0.076c-0.15-0.087-0.231-0.143-0.273-0.343c0.027-0.031,0.056-0.043,0.076-0.083\r\n\t\t\t\tc-0.031-0.037-0.057-0.035-0.057-0.108c-0.015-0.002-0.03-0.004-0.044-0.006c0.008-0.021,0.017-0.042,0.025-0.064\r\n\t\t\t\tc0.044-0.029,0.154-0.064,0.248-0.07c0.002-0.017,0.004-0.034,0.006-0.051c0.08,0.003,0.086,0.005,0.159,0\r\n\t\t\t\tc0.011,0.017,0.021,0.034,0.032,0.051c-0.019,0.025-0.035,0.035-0.076,0.038c0.021,0.098,0.071,0.175,0.102,0.254\r\n\t\t\t\tc0.033-0.017,0.055-0.041,0.083-0.064c0.017-0.047,0.034-0.093,0.051-0.14c0.256,0.103,0.086,0.31,0.343,0.388\r\n\t\t\t\tc-0.036,0.002-0.072,0.004-0.108,0.006v0.006c0.075,0.108,0.185,0.165,0.267,0.267c0.025,0.026,0.059-0.025,0.108-0.013\r\n\t\t\t\tc0.006,0.001,0.153,0.061,0.165,0.07c0.049,0.035,0.089,0.097,0.14,0.133c0.133,0.095,0.272,0.155,0.407,0.248\r\n\t\t\t\tc0.03,0.036,0.059,0.072,0.089,0.108c0.042,0.021,0.085,0.042,0.127,0.064c0.003,0.051,0.002,0.06-0.038,0.07\r\n\t\t\t\tc-0.006,0.043,0.016,0.226,0.013,0.235c-0.017,0.032-0.034,0.064-0.051,0.095c0.022,0.032,0.038,0.045,0.038,0.102\r\n\t\t\t\tc-0.011-0.002-0.021-0.004-0.032-0.006c0.027,0.077,0.144,0.098,0.191,0.159c0.006,0.03,0.013,0.059,0.019,0.089\r\n\t\t\t\tc0.04,0.101,0.153,0.191,0.28,0.172c0.008,0.008,0.017,0.017,0.025,0.025v0.013c-0.027,0.034-0.065,0.029-0.108,0.038v0.006\r\n\t\t\t\tc0.036,0.055,0.072,0.11,0.108,0.165c0.103-0.009,0.227-0.061,0.349-0.025c0.077,0.022,0.119,0.081,0.223,0.089v0.006\r\n\t\t\t\tc-0.101,0.134-0.204-0.021-0.324-0.038c-0.039-0.005-0.082,0.035-0.159,0.032c-0.021,0.038-0.042,0.076-0.064,0.114\r\n\t\t\t\tc0.038,0.047,0.076,0.093,0.114,0.14c0.014,0.044-0.016,0.099-0.013,0.146c0.019,0.017,0.038,0.034,0.057,0.051\r\n\t\t\t\tc0.019-0.015,0.038-0.03,0.057-0.044c0.045-0.022,0.097,0.086,0.108,0.14c0.004,0.002,0.009,0.004,0.013,0.007\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.056-0.027,0.09-0.001,0.14,0.025c-0.005-0.136-0.055-0.195-0.095-0.292v-0.032\r\n\t\t\t\tc0.034,0.011,0.068,0.021,0.102,0.032h0.013c-0.006,0.013-0.013,0.025-0.019,0.038c0.017,0.006,0.034,0.013,0.051,0.019\r\n\t\t\t\tc0.019-0.035,0.029-0.044,0.083-0.045c-0.023-0.029-0.028-0.02-0.025-0.064c-0.021,0.004-0.042,0.009-0.064,0.013\r\n\t\t\t\tc-0.022-0.048-0.026-0.074-0.057-0.108c0.047-0.015,0.093-0.03,0.14-0.044c0.05,0.006,0.107,0.078,0.121,0.121\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c0.013-0.011,0.025-0.021,0.038-0.032c-0.013-0.04-0.025-0.081-0.038-0.121\r\n\t\t\t\tc0.008-0.002,0.017-0.004,0.025-0.006c-0.005-0.06-0.342-0.233-0.419-0.248v-0.006c0.044-0.01,0.071-0.023,0.102-0.044\r\n\t\t\t\tc-0.013-0.03-0.026-0.059-0.038-0.089v-0.007c0.03-0.019,0.042-0.017,0.083-0.006c0.014,0.026,0.015,0.037,0.013,0.07h0.006\r\n\t\t\t\tc0.006-0.002,0.013-0.004,0.019-0.006c0.008-0.011,0.017-0.021,0.025-0.032c-0.079-0.096-0.169-0.193-0.222-0.311\r\n\t\t\t\tc0.002-0.047,0.015-0.064,0.038-0.089c-0.011-0.013-0.021-0.025-0.032-0.038c0.035-0.015,0.06-0.023,0.076-0.057\r\n\t\t\t\tc0.008,0.002,0.017,0.004,0.025,0.006c0.002,0.009,0.004,0.017,0.006,0.025c-0.011,0.007-0.021,0.013-0.032,0.019\r\n\t\t\t\tc0.04,0.08,0.139,0.069,0.146,0.184c0.032,0.004,0.064,0.008,0.095,0.013h0.013c-0.035-0.042-0.079-0.056-0.108-0.108v-0.006\r\n\t\t\t\tc0.076,0.003,0.119,0.051,0.146,0.102c0.015-0.002,0.03-0.004,0.044-0.006c0.002-0.006,0.004-0.013,0.006-0.019\r\n\t\t\t\tc-0.024-0.041-0.06-0.046-0.083-0.089c0.011-0.008,0.021-0.017,0.032-0.026c0.037,0.007,0.067,0.015,0.083,0.045\r\n\t\t\t\tc0.017,0.015,0.034,0.03,0.051,0.045c0.006-0.004,0.013-0.009,0.019-0.013v-0.006c-0.062-0.077-0.15-0.094-0.191-0.197v-0.006\r\n\t\t\t\tc0.134-0.026,0.108,0.02,0.21-0.07c0.039,0.003,0.034,0.001,0.044,0.032c0.079,0,0.103-0.025,0.153-0.051\r\n\t\t\t\tc0.043,0.102,0.272-0.012,0.286,0.121c0.008-0.009,0.017-0.017,0.025-0.025c0.034,0.021,0.105,0.031,0.146,0.044\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.032,0.019-0.064,0.038-0.095,0.057c-0.008,0.032-0.017,0.064-0.025,0.095\r\n\t\t\t\tc0.066-0.021,0.091-0.085,0.14-0.121c0.061-0.028,0.123-0.055,0.184-0.083c0.015-0.03,0.03-0.059,0.044-0.089\r\n\t\t\t\tc0.038-0.022,0.1,0.002,0.153-0.019c0.136-0.054,0.112,0.009,0.273,0.013c0.026-0.03,0.045-0.056,0.063-0.095\r\n\t\t\t\tc-0.045-0.06-0.142-0.051-0.21-0.089c-0.087-0.049-0.178-0.313-0.267-0.299v-0.051c0.036-0.035,0.047-0.056,0.102-0.076\r\n\t\t\t\tc0.016-0.084,0.038-0.153,0.051-0.222c0.025-0.013,0.108-0.018,0.121-0.038c0.004-0.04,0.008-0.08,0.013-0.121\r\n\t\t\t\tc0.036-0.199,0.06-0.377,0.286-0.388c0.023-0.049,0.047-0.097,0.07-0.146c-0.015-0.031-0.034-0.038-0.051-0.064\r\n\t\t\t\tc-0.032-0.104,0.093-0.097,0.153-0.133c0.199-0.119,0.104-0.321,0.509-0.311c0.008-0.015,0.017-0.03,0.025-0.045\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.021,0.025,0.042,0.051,0.064,0.076v0.013c-0.023,0.021-0.047,0.042-0.07,0.064v0.013\r\n\t\t\t\tc0.097,0.133,0.265,0.085,0.458,0.089c0.013,0.025,0.026,0.051,0.038,0.076c-0.067,0.074-0.25,0.106-0.331,0.184\r\n\t\t\t\tc0.004,0.008,0.009,0.017,0.013,0.025c0.2,0.038,0.367,0.002,0.254,0.267v0.019c0.285,0.052,0.158-0.026,0.337-0.089\r\n\t\t\t\tc0.051-0.004,0.102-0.009,0.153-0.013c0.034-0.028,0.068-0.055,0.102-0.083c0.06-0.018,0.089,0.017,0.133,0.025\r\n\t\t\t\tc0.038-0.006,0.076-0.013,0.114-0.019c0.023-0.032,0.052-0.072,0.064-0.114c-0.064-0.008-0.127-0.017-0.191-0.025\r\n\t\t\t\tc-0.072,0.007-0.141,0.064-0.235,0.038c-0.024-0.123-0.199-0.258-0.337-0.299c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.103-0.029,0.197-0.016,0.305-0.019c0.037-0.039,0.065-0.066,0.083-0.127c0.004-0.002,0.009-0.004,0.013-0.006\r\n\t\t\t\tc0.015,0.013,0.03,0.025,0.044,0.038c0.022,0.013,0.019,0.008,0.045,0c0.05-0.015,0.061-0.049,0.102-0.063\r\n\t\t\t\tc0.125-0.023,0.25-0.047,0.375-0.07c0.023-0.025,0.047-0.051,0.07-0.076c0.074-0.008,0.148-0.017,0.222-0.025\r\n\t\t\t\tc0.013-0.013,0.007-0.002,0.013-0.025c0.093-0.017,0.186-0.034,0.28-0.051c0.011,0.021,0.021,0.042,0.032,0.064\r\n\t\t\t\tc-0.099,0.079-0.25,0.146-0.413,0.152c-0.008,0.011-0.017,0.021-0.026,0.032c0.074,0.053,0.148,0.098,0.197,0.178\r\n\t\t\t\tc-0.034,0.026-0.077,0.034-0.14,0.032c-0.028,0.081-0.083,0.13-0.089,0.229c-0.049,0.026-0.154,0.037-0.21,0.051\r\n\t\t\t\tc0.044,0.059,0.104,0.147,0.159,0.197c0.043,0.008,0.057-0.002,0.089-0.019c0.041,0.027,0.058,0.069,0.095,0.095\r\n\t\t\t\tc0.044,0.013,0.089,0.025,0.133,0.038c0.105,0.049,0.192,0.14,0.28,0.21c0.047,0.038,0.116,0.138,0.178,0.133\r\n\t\t\t\tc-0.004,0.019-0.008,0.038-0.013,0.057c0.102,0.075,0.311,0.102,0.381,0.21c0.015,0.053,0.03,0.106,0.045,0.159\r\n\t\t\t\tc0.079,0.289-0.089,0.388-0.324,0.445c-0.131,0.031-0.222-0.051-0.337-0.032c-0.053,0.017-0.106,0.034-0.159,0.051\r\n\t\t\t\tc-0.098,0.022-0.277-0.021-0.381-0.038c-0.126-0.021-0.151-0.13-0.292-0.076c-0.078-0.037-0.078-0.076-0.121-0.146\r\n\t\t\t\tc-0.029-0.021-0.102,0.03-0.172,0.013c-0.083-0.021-0.076-0.089-0.121-0.146c-0.173,0.111-0.323-0.021-0.54,0.032\r\n\t\t\t\tc-0.196,0.047-0.34,0.172-0.515,0.229c0.002,0.017,0.004,0.034,0.006,0.051c-0.138,0.074-0.202,0.007-0.318-0.013\r\n\t\t\t\tc-0.019,0.006-0.038,0.013-0.057,0.019c-0.093-0.008-0.186-0.017-0.28-0.025c-0.013,0.025-0.025,0.051-0.038,0.076\r\n\t\t\t\tc0.029,0.031,0.069,0.042,0.083,0.089c0.053-0.002,0.106-0.004,0.159-0.006v0.006c-0.072,0.023-0.189,0.032-0.28,0.032\r\n\t\t\t\tc-0.017,0.023-0.026,0.025-0.026,0.051c0.026,0.006,0.051,0.013,0.076,0.019c0.006,0.004,0.013,0.009,0.019,0.013\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.025c-0.114-0.018-0.214-0.013-0.337-0.006c0.011-0.013,0.021-0.025,0.032-0.038\r\n\t\t\t\tc-0.036-0.015-0.055-0.014-0.089-0.007c-0.002,0.004-0.004,0.009-0.006,0.013c0.013,0.006,0.026,0.013,0.038,0.019v0.019\r\n\t\t\t\tc-0.067,0.022-0.142,0.01-0.159-0.044c-0.091,0.011-0.203,0.041-0.254,0.095c-0.035,0.037,0.004,0.057-0.07,0.064\r\n\t\t\t\tc-0.01,0.071-0.028,0.13-0.032,0.191c0.087-0.013,0.174-0.025,0.261-0.038v0.006c-0.015,0.024-0.03,0.039-0.057,0.051\r\n\t\t\t\tc-0.015,0.017-0.03,0.034-0.045,0.051c0.035,0.006,0.049,0.02,0.064,0.045c0.014,0.023-0.007,0.02-0.013,0.064h0.057\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.025c-0.021,0.025-0.052,0.036-0.089,0.045c-0.007,0.025,0.01,0.054,0.038,0.076\r\n\t\t\t\tc0.034,0.045,0.026,0.031-0.019,0.063c-0.032-0.003-0.055-0.025-0.089-0.044c-0.011,0.023-0.021,0.047-0.032,0.07v0.045\r\n\t\t\t\tc0.105,0.013,0.133,0.046,0.222,0.07c0.003,0.06-0.021,0.124,0.006,0.165c0.034,0.021,0.068,0.042,0.102,0.064\r\n\t\t\t\tc0.002,0.008,0.004,0.017,0.006,0.025c-0.028,0.011-0.055,0.021-0.083,0.032c0.006,0.013,0.013,0.025,0.019,0.038\r\n\t\t\t\tc0.068,0.006,0.136,0.013,0.203,0.019c0.002,0.004,0.004,0.008,0.006,0.013c-0.017,0.019-0.024,0.019-0.032,0.051\r\n\t\t\t\tc0.006,0.015,0.013,0.03,0.019,0.045c0.004,0.002,0.009,0.004,0.013,0.006c0.021-0.021,0.042-0.042,0.064-0.063\r\n\t\t\t\tc0.085-0.003,0.086,0.023,0.146,0.051c0.029,0.014,0.049-0.015,0.076-0.038c0.025,0.059,0.051,0.119,0.076,0.178\r\n\t\t\t\tc0.099,0.031,0.23-0.025,0.299,0.019c0.013-0.002,0.026-0.004,0.038-0.006c0.015-0.072,0.03-0.144,0.044-0.216\r\n\t\t\t\tc0.142-0.018,0.288,0.018,0.388,0.083c0.073,0.048,0.108,0.143,0.203,0.172c0.136,0.041,0.301-0.026,0.381-0.045\r\n\t\t\t\tc0.042-0.082,0.104-0.102,0.159-0.165c0.138,0.001,0.177,0.055,0.286,0.07c0.037-0.038,0.085-0.067,0.121-0.114h0.025\r\n\t\t\t\tc0.013,0.017,0.025,0.034,0.038,0.051c0.002,0.013,0.004,0.025,0.006,0.038c-0.039,0.043-0.09,0.068-0.127,0.114\r\n\t\t\t\tc0.017,0.03,0.034,0.059,0.051,0.089c-0.011,0.057-0.038,0.107-0.064,0.153c0.087,0.115,0.021,0.195,0.076,0.33\r\n\t\t\t\tc-0.146,0.144-0.206,0.407-0.305,0.578c-0.008,0.042-0.017,0.085-0.025,0.127c-0.041,0.134-0.077,0.258-0.172,0.337\r\n\t\t\t\tc0.074,0.186,0.148,0.373,0.222,0.559c0.012,0.018,0.023,0.014,0.051,0.032c-0.023,0.137-0.084,0.285-0.095,0.407\r\n\t\t\t\tc0.036,0.002,0.072,0.004,0.108,0.006c0.047,0.059,0.093,0.119,0.14,0.178c0.104,0.17,0.188,0.32,0.299,0.477\r\n\t\t\t\tc0.084,0.118,0.206,0.226,0.165,0.413c0.085,0.117,0.223,0.149,0.324,0.248c0.066,0.119,0.131,0.237,0.197,0.356\r\n\t\t\t\tc0.066,0.127-0.002,0.313,0.051,0.457c0.051,0.072,0.102,0.144,0.152,0.216c0.07,0.096,0.225,0.114,0.299,0.203\r\n\t\t\t\tc0.089,0.182,0.178,0.364,0.267,0.546c0.034,0.026,0.068,0.051,0.102,0.076c0.086,0.071,0.195,0.232,0.235,0.343\r\n\t\t\t\tc0.011,0.068,0.021,0.136,0.032,0.203c-0.008,0.039-0.042,0.068-0.032,0.127c0.03,0.172,0.113,0.353,0.165,0.496v0.216\r\n\t\t\t\tc0.095,0.205,0.383,0.166,0.553,0.057c0.057-0.047,0.114-0.093,0.172-0.14c0.094-0.028,0.217,0.012,0.299-0.013\r\n\t\t\t\tc0.128-0.039,0.228-0.133,0.343-0.172c0.078-0.026,0.163,0.016,0.229-0.019c0.069-0.036,0.087-0.124,0.152-0.159\r\n\t\t\t\tc0.238-0.13,0.547-0.129,0.769-0.267c0.062-0.038,0.046-0.087,0.076-0.159c0.029-0.07,0.139-0.142,0.21-0.172\r\n\t\t\t\tc0.121-0.04,0.241-0.081,0.362-0.121c0.07,0.008,0.14,0.017,0.21,0.025c0.025-0.015,0.051-0.03,0.076-0.045\r\n\t\t\t\tc0.045-0.091,0.016-0.205,0.108-0.248c0.096-0.045,0.186,0.021,0.273-0.051c0.032-0.027,0.027-0.071,0.044-0.114\r\n\t\t\t\tc0.048-0.12,0.19-0.153,0.349-0.159c0.009-0.116-0.012-0.304,0.026-0.419c0.056-0.024,0.123,0.021,0.172-0.006\r\n\t\t\t\tc0.057-0.042,0.064-0.147,0.102-0.21c0.042-0.04,0.085-0.08,0.127-0.121c0.059-0.074,0.114-0.154,0.159-0.242\r\n\t\t\t\tc-0.012-0.066-0.116-0.088-0.159-0.127c-0.064-0.08-0.127-0.161-0.191-0.241c-0.048-0.033-0.104,0.008-0.165-0.006\r\n\t\t\t\tc-0.089-0.049-0.178-0.098-0.267-0.146c-0.071-0.049-0.182-0.161-0.21-0.248c-0.021-0.066,0.011-0.151-0.013-0.203\r\n\t\t\t\tc-0.015-0.018-0.024-0.019-0.057-0.019c0.044-0.068,0.068-0.116,0.057-0.229h-0.006c-0.045,0.057-0.089,0.115-0.133,0.172\r\n\t\t\t\tc-0.113,0.09-0.215,0.143-0.311,0.267c-0.023,0.045-0.047,0.089-0.07,0.134c-0.035,0.031-0.051,0.02-0.07,0.07\r\n\t\t\t\tc-0.042,0.011-0.063,0.014-0.095-0.006c-0.002,0.011-0.004,0.021-0.006,0.032c-0.074,0.026-0.394,0.021-0.477-0.019\r\n\t\t\t\tc-0.019,0.017-0.023,0.015-0.032,0.044c-0.073,0.007-0.13-0.005-0.203-0.006c0.013-0.058-0.015-0.063-0.064-0.076\r\n\t\t\t\tc-0.037-0.089,0.072-0.127,0.076-0.216c0.001-0.028-0.017-0.268-0.025-0.28c-0.018-0.025-0.035-0.018-0.051-0.057\r\n\t\t\t\tc-0.015-0.002-0.03-0.004-0.044-0.006c-0.083,0.059-0.119,0.288-0.07,0.407c0.007,0.07,0.01,0.094-0.051,0.089\r\n\t\t\t\tc-0.045-0.059-0.108-0.211-0.114-0.311c-0.034-0.027-0.036-0.039-0.076-0.032c-0.033-0.107-0.058-0.116-0.013-0.229\r\n\t\t\t\tc-0.013-0.021-0.026-0.042-0.038-0.064c0.02-0.031,0.039-0.029,0.045-0.076c-0.062-0.082-0.205-0.072-0.248-0.172\r\n\t\t\t\tc-0.036-0.028-0.026-0.027-0.006-0.064c-0.037-0.017-0.058-0.015-0.114-0.013c-0.07-0.185-0.159-0.356-0.21-0.553\r\n\t\t\t\tc-0.036,0.009-0.072,0.017-0.108,0.026c-0.013-0.006-0.026-0.013-0.038-0.019c0.021-0.026,0.042-0.051,0.063-0.076h0.044\r\n\t\t\t\tc-0.008-0.04-0.017-0.08-0.025-0.121c0.026-0.034,0.169-0.04,0.235-0.038c0.055-0.054,0.047-0.118,0.127-0.152h0.019\r\n\t\t\t\tc-0.001,0.041,0.001,0.074,0.019,0.095c0.038,0.072,0.165,0.061,0.242,0.032c0.043,0.069,0.143,0.143,0.172,0.21v0.102\r\n\t\t\t\tc0.031,0.082,0.136,0.259,0.191,0.337c0.064,0.091,0.221,0.082,0.311,0.146c0.047,0.057,0.093,0.115,0.14,0.172\r\n\t\t\t\tc0.106,0.063,0.211,0.06,0.337,0.102c0.07,0.023,0.11,0.086,0.197,0.095c0.042-0.036,0.186-0.121,0.197-0.172\r\n\t\t\t\tc0.098-0.035,0.203-0.075,0.324-0.044c0.05,0.012,0.038,0.034,0.089,0.038c0.015,0.043,0.01,0.1,0.032,0.159\r\n\t\t\t\tc0.026,0.069,0.095,0.113,0.095,0.21c0.068,0.011,0.135,0.056,0.184,0.076h0.254c0.025,0.023,0.051,0.047,0.076,0.07\r\n\t\t\t\tc0.142,0.002,0.284,0.004,0.426,0.007c0.075,0.02,0.118,0.067,0.216,0.083c0.131,0.021,0.254-0.027,0.356-0.044h0.286\r\n\t\t\t\tc0.057-0.021,0.1-0.057,0.191-0.07c0.08,0.167,0.549-0.018,0.686-0.025c0.074,0.053,0.075,0.102,0.07,0.223\r\n\t\t\t\tc0.047,0.011,0.093,0.021,0.14,0.032c0.023,0.068,0.047,0.136,0.07,0.203c0.05,0.067,0.114,0.032,0.191,0.076\r\n\t\t\t\tc0.03,0.042,0.059,0.085,0.089,0.127c0.103,0.123,0.38,0.229,0.597,0.153c0.003,0.052-0.02,0.064-0.051,0.095\r\n\t\t\t\tc-0.142,0.145-0.214,0.023-0.369,0.076h-0.013c0.049,0.113,0.433,0.501,0.572,0.508c0.04-0.015,0.081-0.03,0.121-0.044\r\n\t\t\t\tc0.145-0.047,0.383-0.127,0.254-0.299c0.008-0.03,0.017-0.059,0.025-0.089c0.032-0.019,0.083-0.021,0.14-0.019\r\n\t\t\t\tc-0.019,0.072-0.014,0.207,0.013,0.286c0.016,0.046,0.116,0.085,0.102,0.146c-0.015,0.062-0.095,0.113-0.102,0.191\r\n\t\t\t\tc0.027,0.146,0.055,0.292,0.083,0.438c0.034,0.205,0.068,0.411,0.102,0.616c0.07,0.251,0.21,0.444,0.305,0.655\r\n\t\t\t\tc0.065,0.143,0.116,0.299,0.165,0.457c0.021,0.079,0.042,0.157,0.064,0.235c0.038,0.055,0.076,0.11,0.114,0.165\r\n\t\t\t\tc0.074,0.163,0.148,0.326,0.222,0.489c0.032,0.112,0.064,0.225,0.095,0.337c0.059,0.064,0.119,0.127,0.178,0.191\r\n\t\t\t\tc0.09-0.003,0.218-0.064,0.248-0.127c0.026-0.054,0.004-0.106,0.038-0.146c0.083-0.028,0.165-0.055,0.248-0.083\r\n\t\t\t\tc-0.013-0.027-0.034-0.042-0.057-0.057c0.025-0.072,0.051-0.144,0.076-0.216c0.037-0.022,0.108-0.021,0.172-0.019\r\n\t\t\t\tc0.023-0.118-0.033-0.248-0.019-0.362c0.025-0.213,0.286-0.458,0.108-0.655c0.057-0.141-0.035-0.296,0-0.451\r\n\t\t\t\tc0.021-0.047,0.042-0.093,0.064-0.14c0.06-0.048,0.118-0.061,0.191-0.019c0.048-0.031,0.078-0.105,0.095-0.165\r\n\t\t\t\tc0.058-0.032,0.17-0.01,0.229-0.051c0.065-0.045,0.048-0.168,0.108-0.216c0.063-0.032,0.127-0.064,0.191-0.095\r\n\t\t\t\tc0.072-0.046,0.111-0.143,0.178-0.184c0.046-0.028,0.088-0.032,0.127-0.064c0.097-0.119,0.195-0.237,0.292-0.356\r\n\t\t\t\tc0.078-0.054,0.207-0.041,0.292-0.095c0.106-0.067,0.148-0.181,0.229-0.273c-0.013-0.045-0.025-0.089-0.038-0.134\r\n\t\t\t\tc0.071-0.072,0.179-0.083,0.267-0.14c0.032-0.034,0.064-0.068,0.095-0.102c0.029,0.022,0.05,0.059,0.057,0.102\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.013c0.017-0.03,0.034-0.059,0.051-0.089c0.002-0.004,0.004-0.008,0.006-0.013\r\n\t\t\t\tc0.034,0.02,0.042,0.065,0.051,0.108h0.089c-0.005-0.031-0.002-0.042,0.006-0.07c0.019,0.01,0.038,0.021,0.057,0.032\r\n\t\t\t\tc0.013-0.021,0.025-0.042,0.038-0.063c0.008-0.006,0.017-0.013,0.025-0.019c0.009,0.021,0.017,0.043,0.026,0.064h0.038\r\n\t\t\t\tc0.026-0.034,0.046-0.064,0.051-0.121c0.004-0.002,0.008-0.004,0.013-0.006c0.021,0.038,0.042,0.076,0.063,0.115h0.045\r\n\t\t\t\tc0.016-0.069,0.027-0.078,0.095-0.095c0.022-0.07-0.005-0.129-0.032-0.184c-0.002-0.034-0.003-0.067,0.013-0.083\r\n\t\t\t\tc0.004-0.004,0.009-0.009,0.013-0.013c0.032,0.042,0.064,0.085,0.095,0.127c0.07-0.001,0.1-0.022,0.146-0.044\r\n\t\t\t\tc0.175,0.137,0.122,0.639,0.362,0.705c0.022,0.006,0.054-0.002,0.076,0.006v0.083c0.053,0.035,0.082,0.001,0.127,0.025\r\n\t\t\t\tc0.068,0.037,0.107,0.146,0.133,0.229v0.006c-0.034,0.006-0.068,0.013-0.102,0.019c0.028,0.031,0.065,0.053,0.108,0.07\r\n\t\t\t\tc0.011-0.019,0.021-0.038,0.032-0.057c0.004-0.002,0.009-0.004,0.013-0.006c0.079,0.128,0.174,0.362,0.146,0.578\r\n\t\t\t\tc-0.017,0.129-0.098,0.22-0.102,0.362c0.015,0.011,0.03,0.021,0.044,0.032c0.047-0.038,0.073-0.066,0.153-0.076\r\n\t\t\t\tc-0.006,0.025-0.013,0.051-0.019,0.076c0.011,0.011,0.021,0.021,0.032,0.032h0.025c0.029-0.023,0.031-0.041,0.083-0.044v0.057\r\n\t\t\t\tc0.08,0.073,0.094-0.079,0.153-0.121c0.184-0.132,0.273-0.031,0.305-0.343h0.025c0.085,0.062,0.089,0.235,0.197,0.267\r\n\t\t\t\tc0.026,0.18,0.051,0.36,0.076,0.54c0.047,0.164,0.151,0.309,0.203,0.451c0.053,0.144,0.03,0.29,0.025,0.432\r\n\t\t\t\tc0.019,0.01,0.036,0.013,0.07,0.013c-0.033,0.078-0.145,0.34-0.114,0.413c0.017,0.013,0.034,0.025,0.051,0.038\r\n\t\t\t\tc-0.064,0.162-0.161,0.391-0.102,0.566c0.025-0.011,0.051-0.021,0.076-0.032c0.085,0.091,0.166,0.136,0.21,0.273\r\n\t\t\t\tc0.02,0.008,0.034,0.009,0.064,0c0.043,0.057,0.051,0.099,0.051,0.197c0.011,0.006,0.021,0.013,0.032,0.019\r\n\t\t\t\tc0.034,0.043,0.078,0.03,0.121,0.006c0.004,0.004,0.008,0.008,0.013,0.013c-0.018,0.139-0.008,0.3,0.044,0.445\r\n\t\t\t\tc0.025,0.047,0.051,0.093,0.076,0.14c0.009,0.069-0.024,0.13,0.013,0.191c0.04,0.034,0.08,0.068,0.121,0.102\r\n\t\t\t\tc0.016,0.022,0.022,0.056,0.031,0.088C55.358,48.795,44.764,58,32,58z M20.929,9.847c0.001,0,0.002,0,0.003,0\r\n\t\t\t\tc0.002,0.003,0.004,0.006,0.006,0.009c-0.001,0-0.002,0-0.003,0C20.933,9.853,20.931,9.85,20.929,9.847z M43.915,25.038\r\n\t\t\t\tc-0.028,0.012-0.031-0.019-0.07-0.013c-0.034,0.011-0.068,0.021-0.102,0.032c-0.004-0.002-0.008-0.004-0.013-0.006\r\n\t\t\t\tc-0.002-0.023-0.004-0.047-0.006-0.07c-0.013-0.004-0.026-0.008-0.038-0.013c-0.004,0.017-0.008,0.034-0.013,0.051\r\n\t\t\t\tc-0.048-0.011-0.054-0.013-0.108-0.006c-0.017-0.034-0.034-0.068-0.051-0.102c-0.067,0.075-0.078,0.271-0.044,0.369\r\n\t\t\t\tc0.039,0.021,0.133,0.008,0.216,0.006c-0.015,0.019-0.03,0.038-0.044,0.057c0.004,0.013,0.008,0.025,0.013,0.038\r\n\t\t\t\tc0.014,0.023,0.042,0.036,0.07,0.045v0.019c-0.045-0.004-0.089-0.008-0.133-0.013c-0.011,0.015-0.021,0.03-0.032,0.045v0.044\r\n\t\t\t\tc0.042-0.029,0.066-0.018,0.127-0.006c0.024,0.067,0.085,0.076,0.114,0.133c0.014,0.054-0.038,0.118-0.038,0.203\r\n\t\t\t\tc0,0.04-0.022,0.09-0.019,0.108c0.018,0.102,0.109,0.354,0.025,0.419c-0.061,0.047-0.192,0.025-0.28,0.045\r\n\t\t\t\tc-0.314,0.07-0.748,0.1-0.858-0.197c-0.119-0.032-0.251-0.062-0.35-0.095c-0.052-0.198,0.057-0.392,0.057-0.559\r\n\t\t\t\tc0.006-0.004,0.013-0.008,0.019-0.013c0.017,0.015,0.019,0.017,0.025,0.044c0.006,0.004,0.013,0.008,0.019,0.013\r\n\t\t\t\tc0.006-0.03,0.013-0.059,0.019-0.089c0.02-0.009,0.021-0.011,0.044-0.006c-0.012-0.168,0.011-0.45,0.28-0.337h0.006\r\n\t\t\t\tc-0.002-0.011-0.004-0.021-0.006-0.032c-0.056-0.128-0.19-0.036-0.242-0.108c-0.03-0.042-0.076-0.085-0.095-0.127\r\n\t\t\t\tc-0.023-0.049-0.009-0.096-0.038-0.133c-0.041-0.053-0.106-0.142-0.159-0.184c-0.019-0.006-0.038-0.013-0.057-0.019\r\n\t\t\t\tc-0.05-0.07-0.077-0.16-0.14-0.216c-0.015-0.004-0.03-0.009-0.044-0.013c-0.031-0.047,0.006-0.079-0.044-0.108\r\n\t\t\t\tc-0.057-0.081-0.018-0.217,0.019-0.311v-0.019H41.92c-0.011,0.038-0.021,0.076-0.032,0.114h-0.006\r\n\t\t\t\tc-0.001-0.113-0.014-0.227-0.114-0.286c-0.032-0.019-0.075-0.01-0.089-0.045v-0.032c0.004-0.075,0.083-0.081,0.114-0.127\r\n\t\t\t\tc0.062-0.092,0.092-0.195,0.121-0.286c0.004-0.006,0.008-0.013,0.013-0.019c0.105,0.051,0.2-0.03,0.28-0.076\r\n\t\t\t\tc0.015,0.008,0.03,0.017,0.044,0.025c0.016-0.02,0.02-0.029,0.019-0.07c0.102-0.023,0.134-0.121,0.216-0.153\r\n\t\t\t\tc0.04-0.002,0.081-0.004,0.121-0.006c0.13-0.041,0.242-0.21,0.413-0.197c0.096,0.007,0.137,0.073,0.21,0.089\r\n\t\t\t\tc0.077,0.017,0.097-0.038,0.133-0.051c0.057,0.013,0.114,0.025,0.172,0.038c0.015,0.025,0.03,0.051,0.045,0.076\r\n\t\t\t\tc-0.017,0.017-0.034,0.034-0.051,0.051c0.047,0.164,0.01,0.207-0.083,0.33c0.004,0.058,0.07,0.083,0.114,0.095\r\n\t\t\t\tc0.002,0.004,0.004,0.008,0.006,0.013c-0.138-0.013-0.275-0.025-0.413-0.038c-0.038,0.007-0.047,0.027-0.102,0.026\r\n\t\t\t\tc-0.013,0.034-0.025,0.068-0.038,0.102c-0.029,0.036-0.057,0.02-0.076,0.076c0.027,0.039,0.064,0.068,0.114,0.083\r\n\t\t\t\tc0.006,0.008,0.013,0.017,0.019,0.026c-0.061,0.044-0.214-0.025-0.337-0.019c-0.006,0.006-0.013,0.013-0.019,0.019v0.083\r\n\t\t\t\tc0.039,0.026,0.133,0.043,0.184,0.051c0.028,0.155,0.139,0.203,0.133,0.368h0.089c0.037,0.027,0.071,0.069,0.089,0.114\r\n\t\t\t\tc0.089,0.012,0.165-0.009,0.235,0.064c-0.034,0.064-0.07,0.143-0.095,0.203c0.023,0.038-0.002,0.077,0.019,0.121\r\n\t\t\t\tc0.013,0.006,0.026,0.013,0.038,0.019c-0.002,0.019-0.004,0.038-0.006,0.057c0.013,0.029,0.055,0.079,0.076,0.114v0.013\r\n\t\t\t\tc0.027-0.072,0.011-0.226,0.032-0.305c0.087-0.015,0.173-0.031,0.273-0.025c0.015,0.056,0.023,0.174,0.051,0.216\r\n\t\t\t\tc0.046,0.071,0.146,0.075,0.197,0.178c-0.015,0.031-0.026,0.037-0.057,0.051c-0.041-0.008-0.042-0.024-0.083-0.032\r\n\t\t\t\tC43.898,24.987,43.907,25.012,43.915,25.038z M35.799,24.777c-0.004,0.004-0.008,0.008-0.013,0.013\r\n\t\t\t\tc-0.025-0.022-0.041-0.037-0.083-0.045c0.004-0.011,0.009-0.021,0.013-0.032c0.017,0.008,0.034,0.017,0.051,0.025\r\n\t\t\t\tC35.788,24.751,35.789,24.757,35.799,24.777z M57.643,35.618c-0.368,0.016-0.324-0.225-0.388-0.502\r\n\t\t\t\tc-0.013,0.004-0.025,0.008-0.038,0.013c-0.056-0.044-0.033-0.145-0.051-0.222c-0.063,0.004-0.119,0.023-0.178,0.013\r\n\t\t\t\tc-0.153-0.249,0.124-0.633,0.191-0.826c-0.004-0.053-0.009-0.106-0.013-0.159c0.02-0.082,0.062-0.114,0.025-0.216\r\n\t\t\t\tc0.092-0.071,0.145-0.061,0.292-0.051c-0.006,0.076-0.013,0.152-0.019,0.229c0.058,0.001,0.08,0.024,0.121,0.032\r\n\t\t\t\tc0.078,0.014,0.107-0.054,0.191-0.006c0.038,0.04,0.076,0.08,0.115,0.121c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc-0.043,0.556-0.111,1.104-0.189,1.65C57.688,35.667,57.663,35.644,57.643,35.618z M8.363,28.628\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.363z M8.35,28.59c-0.001-0.011-0.009-0.009-0.011-0.018\r\n\t\t\t\tc0.001,0.006,0.003,0.012,0.004,0.018H8.35z M42.555,41.414c-0.037-0.058-0.107-0.06-0.14-0.133\r\n\t\t\t\tc-0.068-0.054-0.061-0.042-0.127,0.013c0.009,0.1,0.008,0.236-0.07,0.299c-0.044,0.036-0.08,0.04-0.102,0.102\r\n\t\t\t\tc-0.039-0.014-0.048-0.034-0.063-0.07c-0.019-0.002-0.038-0.004-0.057-0.006c-0.003,0.068,0.015,0.109,0.038,0.165\r\n\t\t\t\tc-0.004,0.011-0.008,0.021-0.013,0.032c-0.024,0.016-0.04,0.025-0.083,0.025c-0.002,0.004-0.004,0.009-0.006,0.013\r\n\t\t\t\tc0.003,0.044,0.026,0.059,0.045,0.102c-0.023,0.025-0.047,0.051-0.07,0.076c-0.039-0.004-0.04-0.009-0.051-0.038H41.85\r\n\t\t\t\tc-0.032,0.028-0.063,0.055-0.095,0.083c0.008,0.034,0.022,0.045,0.038,0.07c-0.013,0.009-0.025,0.017-0.038,0.026\r\n\t\t\t\tc-0.024,0.01-0.027-0.009-0.064-0.019c-0.047,0.029-0.093,0.059-0.14,0.089c0.004,0.025,0.009,0.051,0.013,0.076\r\n\t\t\t\tc-0.071,0.017-0.121-0.054-0.21-0.013c-0.017,0.019-0.034,0.038-0.051,0.057c-0.04,0.02-0.074-0.013-0.108-0.013\r\n\t\t\t\tc-0.025,0.019-0.051,0.038-0.076,0.057c-0.044,0.002-0.089,0.004-0.133,0.006c0,0.213-0.083,0.245-0.14,0.381\r\n\t\t\t\tc-0.025,0.1,0.069,0.325,0.121,0.388c-0.015,0.032-0.03,0.064-0.044,0.096c0.032,0.038,0.064,0.076,0.095,0.114\r\n\t\t\t\tc0.03,0.115-0.166,0.512-0.216,0.559c-0.025,0.009-0.051,0.017-0.076,0.025c-0.045,0.032-0.102,0.233-0.089,0.311\r\n\t\t\t\tc0.053,0.097,0.106,0.195,0.159,0.292c-0.013,0.049-0.025,0.097-0.038,0.146c-0.031,0.144,0.06,0.157,0.083,0.229\r\n\t\t\t\tc0.016,0.051-0.006,0.092,0.019,0.127c0.083,0.119,0.262,0.084,0.343,0.21c0.137-0.008,0.17-0.09,0.286-0.121\r\n\t\t\t\tc0.07-0.009,0.14-0.017,0.21-0.026c0.132-0.081,0.205-0.497,0.261-0.674c0.15-0.485,0.301-0.97,0.451-1.455\r\n\t\t\t\tc0.028-0.095-0.011-0.189,0.019-0.299c0.026-0.093,0.124-0.146,0.146-0.254c-0.047-0.072-0.09-0.157-0.089-0.273\r\n\t\t\t\tc0.011-0.006,0.021-0.013,0.032-0.019c0.004-0.004,0.008-0.009,0.013-0.013c0.029,0.053,0.07,0.133,0.121,0.165\r\n\t\t\t\tc0.035-0.029,0.114-0.123,0.102-0.191c-0.027-0.053-0.055-0.106-0.083-0.159C42.622,41.831,42.634,41.517,42.555,41.414z\r\n\t\t\t\t M10.068,26.772c0.002,0.004,0.003,0.011,0.005,0.016v-0.016H10.068z M8.337,28.565c0,0.001-0.001,0.002-0.001,0.002\r\n\t\t\t\tc0.001,0.003,0.003,0.003,0.003,0.005C8.339,28.57,8.338,28.567,8.337,28.565z M8.356,28.609\r\n\t\t\t\tc-0.002-0.006-0.004-0.013-0.006-0.019v0.019H8.356z M14.998,24.644c-0.002-0.004-0.004-0.009-0.006-0.013\r\n\t\t\t\tc-0.021-0.006-0.042-0.013-0.064-0.019c-0.026,0.019-0.046,0.037-0.057,0.07c-0.004,0.002-0.009,0.004-0.013,0.006\r\n\t\t\t\tc-0.032-0.041-0.059-0.112-0.076-0.165v-0.007c0.122-0.058,0.118-0.025,0.216-0.114V24.37c-0.015-0.006-0.03-0.013-0.045-0.019\r\n\t\t\t\tc-0.042,0.02-0.082,0.042-0.14,0.045c-0.035-0.024-0.077-0.055-0.095-0.095c-0.006-0.006-0.013-0.013-0.019-0.019\r\n\t\t\t\tc0.049-0.04,0.097-0.081,0.146-0.121c0.013-0.015,0.026-0.03,0.038-0.045c-0.085-0.053-0.196-0.098-0.331-0.083\r\n\t\t\t\tc-0.013,0.023-0.025,0.047-0.038,0.07c-0.139,0.028-0.257-0.06-0.343-0.127v-0.019c0.036-0.036,0.072-0.072,0.108-0.108\r\n\t\t\t\tc-0.044-0.017-0.089-0.034-0.133-0.051c-0.111,0.022-0.1,0.134-0.21,0.159c-0.006-0.249,0.344-0.399,0.241-0.604\r\n\t\t\t\tc0.046-0.013,0.102-0.029,0.14-0.045c0.002-0.008,0.004-0.017,0.006-0.025c-0.004-0.011-0.009-0.021-0.013-0.032\r\n\t\t\t\tc-0.013-0.004-0.025-0.008-0.038-0.013c-0.078,0.021-0.157,0.042-0.235,0.064c-0.19,0.122-0.428,0.489-0.508,0.724\r\n\t\t\t\tc0.032,0.038,0.063,0.076,0.095,0.114c-0.085,0.09-0.178,0.003-0.235,0.165c-0.004,0.008-0.008,0.017-0.013,0.025\r\n\t\t\t\tc0.049,0.013,0.098,0.025,0.146,0.038c-0.09,0.09-0.264,0.111-0.324,0.229c-0.016,0.029,0.012,0.075,0.026,0.114\r\n\t\t\t\tc0.097-0.011,0.195-0.021,0.292-0.032c0.121,0.017,0.242,0.034,0.362,0.051c0.11,0.02,0.23-0.003,0.248-0.083\r\n\t\t\t\tc0.034-0.004,0.068-0.008,0.102-0.013v0.096c0.004,0.006,0.008,0.013,0.013,0.019c0.013-0.002,0.025-0.004,0.038-0.006\r\n\t\t\t\tc0.033-0.011,0.042-0.037,0.051-0.07c0.057,0.006,0.114,0.013,0.172,0.019v0.013c-0.121,0.055-0.153,0.168-0.305,0.21\r\n\t\t\t\tc-0.012,0.026-0.007,0.015,0,0.045c0.033,0.016,0.082,0.021,0.133,0.019c0.096-0.105,0.276-0.194,0.343-0.311\r\n\t\t\t\tc0.011,0.004,0.021,0.008,0.032,0.013c0.021,0.028,0.042,0.055,0.064,0.083c-0.002,0.068-0.031,0.109-0.064,0.146\r\n\t\t\t\tc0.002,0.017,0.004,0.034,0.006,0.051c0.017,0.002,0.034,0.004,0.051,0.006c0.025-0.021,0.051-0.042,0.076-0.063\r\n\t\t\t\tc0.004,0.036,0.008,0.072,0.013,0.108c0.053,0.015,0.106,0.03,0.159,0.045c0.031-0.093,0.108-0.194,0.095-0.299\r\n\t\t\t\tC14.985,24.767,14.974,24.733,14.998,24.644z M30.531,24.606c-0.011,0.008-0.021,0.017-0.032,0.025\r\n\t\t\t\tc0.014,0.032,0.014,0.022,0.057,0.019v0.006c-0.011,0.011-0.021,0.021-0.032,0.032c-0.002,0.004-0.004,0.008-0.006,0.013\r\n\t\t\t\tc0.021,0.009,0.042,0.017,0.063,0.026c-0.011,0.015-0.021,0.03-0.032,0.044c0.011,0.009,0.021,0.017,0.032,0.025\r\n\t\t\t\tc0.019,0.002,0.038,0.004,0.057,0.006v0.032c0.013,0.002,0.025,0.004,0.038,0.006c0.109-0.111,0.08-0.372,0.076-0.559\r\n\t\t\t\tc-0.008-0.006-0.017-0.013-0.025-0.019c-0.004,0.002-0.008,0.004-0.013,0.006c-0.004,0.03-0.008,0.059-0.013,0.089\r\n\t\t\t\tc-0.002,0.003-0.171,0.074-0.21,0.114c0.001,0.025,0.001,0.024,0.019,0.044c-0.009,0.007-0.017,0.013-0.026,0.019\r\n\t\t\t\tC30.493,24.58,30.509,24.579,30.531,24.606z M35.215,27.014c0.142-0.008,0.284-0.017,0.426-0.025\r\n\t\t\t\tc0.017-0.028,0.025-0.06,0.032-0.102c-0.045,0.028-0.097,0.035-0.146,0.064c-0.008-0.004-0.017-0.009-0.025-0.013\r\n\t\t\t\tc0.004-0.017,0.009-0.034,0.013-0.051c-0.002-0.002-0.004-0.004-0.006-0.006c-0.098,0.011-0.135,0.002-0.21-0.032\r\n\t\t\t\tc-0.07,0.006-0.14,0.013-0.21,0.019c-0.02-0.019-0.014-0.025-0.051-0.032c0.006-0.009,0.013-0.017,0.019-0.026\r\n\t\t\t\tc-0.004-0.006-0.008-0.013-0.013-0.019c-0.015,0.008-0.03,0.017-0.044,0.026c-0.034-0.012-0.056-0.014-0.076-0.038v-0.013\r\n\t\t\t\tc-0.011,0.013-0.01,0.012-0.013,0.038h-0.032c-0.006,0.032-0.013,0.063-0.019,0.095c0.087,0.039,0.26,0.031,0.356,0.07V27.014z\r\n\t\t\t\t M32.367,26.423c0.035-0.028,0.056-0.073,0.095-0.095c0.013-0.037-0.026-0.055-0.045-0.095c-0.036-0.095,0.072-0.224,0.102-0.292\r\n\t\t\t\tv-0.006c-0.058-0.014-0.12,0.013-0.172,0.025c-0.214,0.053-0.3,0.057-0.458-0.044c-0.091,0.081-0.209,0.007-0.254,0.152\r\n\t\t\t\tc0.043,0.085,0.104,0.06,0.191,0.102C32.004,26.254,32.172,26.367,32.367,26.423z M21.217,10.482\r\n\t\t\t\tc0.035-0.019,0.07-0.038,0.105-0.057c0.055-0.019,0.109-0.037,0.164-0.056c0.003-0.008,0.007-0.017,0.01-0.025\r\n\t\t\t\tc-0.104,0.008-0.218,0.043-0.302,0.036c-0.066,0.038-0.132,0.076-0.197,0.114c-0.025,0.014-0.069,0.026-0.071,0.048\r\n\t\t\t\tc0.004,0.002,0.008,0.004,0.013,0.006c0.045-0.002,0.096-0.023,0.138-0.036C21.123,10.502,21.17,10.492,21.217,10.482z\r\n\t\t\t\t M16.682,18.341c-0.01,0.031-0.094,0.043-0.109,0.087c0.001,0.002,0.001,0.003,0.002,0.005c0.076-0.011,0.12-0.032,0.157-0.06\r\n\t\t\t\tc0.001-0.015-0.005-0.022-0.016-0.032C16.705,18.339,16.7,18.338,16.682,18.341z M30.575,25.66\r\n\t\t\t\tc0.019-0.025,0.038-0.051,0.057-0.076c0.054-0.026,0.099,0,0.146,0.013c0.02-0.058,0.068-0.112,0.057-0.197\r\n\t\t\t\tc-0.006-0.047-0.013-0.093-0.019-0.14c0.006-0.036,0.036-0.069,0.044-0.095c0.031-0.095-0.097-0.241-0.153-0.26\r\n\t\t\t\tc-0.085,0.08-0.164,0.087-0.311,0.114c-0.004,0.004-0.008,0.008-0.013,0.013c0.017,0.081,0.077,0.106,0.095,0.197\r\n\t\t\t\tC30.517,25.416,30.356,25.615,30.575,25.66z M30.512,36.559c-0.028,0.032-0.044,0.092-0.089,0.108v0.057\r\n\t\t\t\tc0.013,0.004,0.025,0.008,0.038,0.013c0.082-0.01,0.066-0.094,0.127-0.127C30.57,36.578,30.553,36.568,30.512,36.559z\r\n\t\t\t\t M26.304,19.147c0.035-0.024,0.05-0.049,0.076-0.083c0.002-0.004,0.004-0.009,0.006-0.013c0.025,0.017,0.051,0.034,0.076,0.051\r\n\t\t\t\tc-0.033,0.09-0.136,0.211-0.089,0.305v0.013c0.082-0.047,0.165-0.094,0.235-0.152h0.025c0.006,0.028,0.013,0.055,0.019,0.083\r\n\t\t\t\tc-0.02,0.027-0.04,0.046-0.076,0.057c-0.009,0.057,0.008,0.105,0.051,0.127c0.034,0.062-0.106,0.181-0.121,0.28\r\n\t\t\t\tc0.051,0.013,0.102,0.025,0.153,0.038c0.024-0.018,0.033-0.026,0.038-0.064c0.038,0.011,0.076,0.021,0.114,0.032\r\n\t\t\t\tc0.138-0.008,0.086-0.079,0.267-0.032c-0.045,0.057-0.103,0.092-0.121,0.178c0.025,0.053,0.055,0.069,0.089,0.108\r\n\t\t\t\tc0.036-0.007,0.072-0.013,0.108-0.019h0.006c-0.005,0.156-0.076,0.23-0.013,0.356v0.006c-0.215,0.003-0.415,0.024-0.489,0.172\r\n\t\t\t\tv0.006h0.133v0.013c0.023,0.036,0.008,0.103,0.006,0.159c-0.078,0.113-0.267,0.119-0.299,0.178\r\n\t\t\t\tc-0.011,0.011-0.021,0.021-0.032,0.032c0.025,0.021,0.051,0.042,0.076,0.064c0.085,0.002,0.169,0.004,0.254,0.006\r\n\t\t\t\tc0.061,0.03,0.123,0.059,0.184,0.089h0.013c0.09-0.005,0.137-0.049,0.203-0.076c-0.029,0.06-0.086,0.099-0.089,0.172\r\n\t\t\t\tc-0.131,0.033-0.232-0.046-0.343,0.006c-0.036,0.041-0.02,0.083-0.095,0.07c-0.013,0.136-0.232,0.282-0.35,0.318\r\n\t\t\t\tc-0.002,0.004-0.004,0.009-0.006,0.013c0.032,0.009,0.064,0.017,0.095,0.026c0.015,0.015,0.03,0.03,0.045,0.045\r\n\t\t\t\tc0.052-0.069,0.127-0.122,0.216-0.153c0.045,0.021,0.07,0.005,0.095-0.013c0.108,0.059,0.203,0.111,0.21-0.089\r\n\t\t\t\tc0.2-0.024,0.253-0.004,0.439,0.013c-0.004-0.015-0.009-0.03-0.013-0.044c0.085-0.013,0.17-0.025,0.254-0.038\r\n\t\t\t\tc0.048-0.007,0.063,0.026,0.095,0.032c0.042-0.011,0.085-0.021,0.127-0.032c0.061,0.009,0.123,0.017,0.184,0.025\r\n\t\t\t\tc0.074-0.014,0.1-0.073,0.203-0.064c0.004-0.059,0.085-0.077,0.133-0.089v-0.089h-0.013c-0.014-0.009-0.237-0.029-0.299-0.032\r\n\t\t\t\tV21.13c0.107-0.031,0.369-0.204,0.4-0.299c-0.006-0.055-0.013-0.11-0.019-0.165c-0.087-0.068-0.271-0.169-0.369-0.032\r\n\t\t\t\tc-0.034-0.007-0.068-0.013-0.102-0.019c0.135-0.201,0.055-0.175-0.076-0.318c-0.002-0.002,0.009-0.153-0.025-0.203\r\n\t\t\t\tc-0.049-0.064-0.097-0.127-0.146-0.191c-0.055-0.03-0.115-0.006-0.153-0.051c-0.069-0.084-0.056-0.196-0.095-0.299\r\n\t\t\t\tc-0.031-0.053-0.237-0.227-0.318-0.222c-0.131,0.007-0.14,0.075-0.305,0.006c-0.002-0.004-0.004-0.008-0.006-0.013\r\n\t\t\t\tc0.123,0.003,0.258-0.01,0.311-0.076c0.004-0.002,0.008-0.004,0.013-0.006c-0.034-0.019-0.068-0.038-0.102-0.057\r\n\t\t\t\tc-0.002-0.004-0.004-0.009-0.006-0.013c0.198-0.003,0.277-0.285,0.331-0.426c0.013-0.025,0.001-0.021-0.013-0.051\r\n\t\t\t\tc-0.1-0.073-0.46-0.024-0.623-0.025c-0.006-0.009-0.013-0.017-0.019-0.025c0.017-0.197,0.253-0.175,0.324-0.311\r\n\t\t\t\tc0.035-0.032,0.013-0.032-0.006-0.07c-0.129-0.052-0.288,0.077-0.407,0.045c-0.038-0.023-0.076-0.047-0.114-0.07\r\n\t\t\t\tc-0.019,0.025-0.038,0.051-0.057,0.076c0.019,0.03,0.038,0.059,0.057,0.089c-0.04,0.013-0.08,0.025-0.121,0.038\r\n\t\t\t\tc0.025,0.051,0.051,0.102,0.076,0.152c-0.05,0.002-0.083-0.003-0.127-0.019c-0.039,0.01-0.054,0.039-0.07,0.07\r\n\t\t\t\tc0.027,0.032,0.055,0.064,0.083,0.095c-0.019,0.03-0.061,0.028-0.076,0.051c0.009,0.04,0.017,0.08,0.026,0.121\r\n\t\t\t\tc0,0-0.102,0.182-0.114,0.203C26.262,19.126,26.283,19.136,26.304,19.147z M23.552,15.69c0.122,0.059,0.229,0.003,0.261-0.114\r\n\t\t\t\tc0.002-0.025,0.004-0.051,0.006-0.076c0.061-0.015,0.123-0.03,0.184-0.045c0.041-0.073,0.083-0.252,0.019-0.337\r\n\t\t\t\tc-0.041-0.048-0.155-0.016-0.222-0.038c-0.027-0.017-0.055-0.034-0.083-0.051c-0.016-0.036-0.003-0.092,0.013-0.134\r\n\t\t\t\tc-0.008-0.015-0.017-0.03-0.025-0.045c-0.139-0.061-0.251-0.035-0.311-0.172c-0.039-0.024-0.106-0.033-0.172-0.032v0.159\r\n\t\t\t\tc-0.129,0.091-0.311,0.046-0.483,0.025c0.022,0.049,0.05,0.087,0.044,0.146c-0.091-0.002-0.162-0.057-0.191-0.121\r\n\t\t\t\tc-0.062-0.048-0.149-0.012-0.216,0.038c0.011,0.034,0.021,0.068,0.032,0.102v0.007c-0.017,0.006-0.034,0.013-0.051,0.019\r\n\t\t\t\tc-0.074-0.049-0.145-0.122-0.178-0.21h-0.006c-0.017,0.011-0.034,0.021-0.051,0.032c-0.031,0.052-0.008,0.145-0.006,0.229\r\n\t\t\t\tc-0.045,0.048-0.112,0.04-0.172,0.076c-0.032,0.029-0.064,0.059-0.095,0.089c-0.034-0.049-0.068-0.097-0.102-0.146\r\n\t\t\t\tc-0.02-0.043,0.074-0.098,0.057-0.178c-0.035-0.162-0.262-0.199-0.413-0.241c-0.015,0.017-0.03,0.034-0.044,0.051\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.042,0.031,0.085,0.071,0.102,0.127v0.006c-0.138,0.096-0.242-0.171-0.324,0.006\r\n\t\t\t\tc0.025,0.034,0.051,0.068,0.076,0.102c0.006,0.006,0.013,0.013,0.019,0.019c-0.08,0.017-0.198,0.021-0.261,0.051\r\n\t\t\t\tc-0.006,0.028-0.008,0.049,0.006,0.07c0.103,0.167,0.277-0.021,0.451,0.007c0.098,0.015,0.167,0.047,0.241,0.076\r\n\t\t\t\tc0.004,0.021,0.009,0.043,0.013,0.064c-0.006,0.019-0.013,0.038-0.019,0.057c-0.108,0.081-0.481,0.067-0.534,0.165\r\n\t\t\t\tc-0.002,0.006-0.004,0.013-0.006,0.019c0.008,0.013,0.017,0.025,0.025,0.038c0.081,0.034,0.262-0.022,0.349-0.038\r\n\t\t\t\tc0.073,0.086,0.103,0.124,0.254,0.14c-0.088,0.128-0.197,0.136-0.292,0.235c0.102,0.124,0.465,0.012,0.616,0.07\r\n\t\t\t\tc0.049,0.034,0.097,0.068,0.146,0.102c0.079,0.046,0.211,0.06,0.311,0.076c0.267,0.044,0.261-0.127,0.369-0.172\r\n\t\t\t\tc0.102-0.013,0.203-0.025,0.305-0.038C23.322,15.873,23.442,15.767,23.552,15.69z M25.078,20.894\r\n\t\t\t\tc-0.023,0.009-0.047,0.017-0.07,0.026c-0.007,0.033,0.006,0.053,0.013,0.089c0.036-0.004,0.072-0.008,0.108-0.013\r\n\t\t\t\tc0.017,0.048,0.015,0.085,0.013,0.146c0.12-0.007,0.193-0.047,0.273-0.07c0.034-0.002,0.068-0.004,0.102-0.006\r\n\t\t\t\tc0.076-0.055,0.153-0.11,0.229-0.165c0.074-0.007,0.148-0.013,0.222-0.019c0.008-0.013,0.017-0.025,0.025-0.038\r\n\t\t\t\tc0.049-0.002,0.097-0.004,0.146-0.006c0.016-0.107,0.079-0.154,0.102-0.229c0.037-0.123-0.067-0.364-0.121-0.439\r\n\t\t\t\tc0.126-0.037,0.169-0.056,0.229-0.159c-0.018-0.123-0.068-0.218-0.102-0.324c-0.094-0.067-0.283-0.037-0.4,0.013\r\n\t\t\t\tc-0.064-0.001-0.088-0.026-0.102-0.076c-0.149,0.013-0.194,0.075-0.229,0.203c-0.025,0.006-0.051,0.013-0.076,0.019\r\n\t\t\t\tc-0.006,0.009-0.013,0.017-0.019,0.025h0.184c-0.025,0.064-0.066,0.089-0.133,0.108c-0.001,0.021,0.008,0.04,0.019,0.063\r\n\t\t\t\tc-0.128-0.01-0.273-0.013-0.375-0.051c-0.045,0.036-0.065,0.068-0.083,0.134v0.038c0.057-0.015,0.088-0.022,0.127,0.013h0.013\r\n\t\t\t\tc-0.037,0.042-0.05,0.035-0.038,0.102c-0.03,0.006-0.059,0.013-0.089,0.019c0.008,0.009,0.017,0.017,0.025,0.025\r\n\t\t\t\tc-0.013,0.017-0.025,0.034-0.038,0.051c0.051,0.024,0.293,0.068,0.343,0.038c0.006,0.017,0.013,0.034,0.019,0.051\r\n\t\t\t\tc-0.083,0.035-0.129,0.014-0.165,0.095c-0.008,0.022-0.004,0.012,0.013,0.038c-0.013,0.019-0.025,0.038-0.038,0.057\r\n\t\t\t\tc-0.004,0.004-0.008,0.008-0.013,0.013c0.047-0.006,0.093-0.013,0.14-0.019c-0.018,0.068-0.092,0.065-0.159,0.076\r\n\t\t\t\tc-0.021,0.026-0.02,0.078-0.044,0.102c-0.032,0.024-0.13,0.015-0.184,0.013c-0.002,0.015-0.004,0.03-0.006,0.044\r\n\t\t\t\tc0.047,0.002,0.093,0.004,0.14,0.006V20.894z M26.336,19.465c-0.008,0.048-0.009,0.074,0,0.121\r\n\t\t\t\tc0.011,0.002,0.021,0.004,0.032,0.006c0.011-0.013,0.021-0.025,0.032-0.038c-0.004-0.034-0.009-0.068-0.013-0.102\r\n\t\t\t\tC26.37,19.456,26.353,19.46,26.336,19.465z M37.611,27.116c0.023-0.013,0.016-0.005,0.019-0.038\r\n\t\t\t\tc0.145-0.004,0.169-0.092,0.292-0.102c-0.015-0.019-0.03-0.038-0.045-0.057c0.053-0.068,0.135-0.101,0.191-0.165\r\n\t\t\t\tc-0.1,0.036-0.199,0.072-0.299,0.108c-0.059-0.006-0.119-0.013-0.178-0.019c0.011,0.023,0.012,0.039,0,0.064\r\n\t\t\t\tc-0.006,0.006-0.171,0.045-0.184,0.045c0.012,0.053,0.028,0.071,0.045,0.114C37.497,27.08,37.576,27.089,37.611,27.116z\r\n\t\t\t\t M8.363,28.654h0.006c-0.002-0.006-0.004-0.013-0.006-0.019V28.654z M14.54,13.788c0.035-0.025,0.102-0.125,0.045-0.175\r\n\t\t\t\tc-0.059,0.063-0.171,0.08-0.068,0.171C14.525,13.786,14.532,13.787,14.54,13.788z M8.375,28.698h0.006\r\n\t\t\t\tc-0.004-0.015-0.008-0.029-0.013-0.044C8.371,28.668,8.373,28.683,8.375,28.698z M8.433,28.838\r\n\t\t\t\tc0.006,0.004,0.013,0.008,0.019,0.013c-0.023-0.051-0.047-0.102-0.07-0.153C8.389,28.761,8.414,28.792,8.433,28.838z\r\n\t\t\t\t M21.4,11.563c-0.005,0-0.01,0.001-0.015,0.001c-0.058,0.053-0.117,0.105-0.175,0.158c-0.053,0.024-0.106,0.048-0.158,0.072\r\n\t\t\t\tc-0.038,0.029-0.035,0.1-0.05,0.136c-0.008,0.019-0.056,0.102-0.048,0.112c0.02,0.01,0.135-0.027,0.152-0.034\r\n\t\t\t\tc0.041-0.017,0.077-0.038,0.104-0.06c0.011-0.01,0.021-0.021,0.032-0.031c0.029-0.01,0.059-0.019,0.088-0.029\r\n\t\t\t\tc0.028-0.025,0.056-0.049,0.084-0.074c0.003-0.003,0.007-0.007,0.01-0.01c0.014,0.009,0.038,0.018,0.063,0.008\r\n\t\t\t\tc0.047-0.026,0.042-0.069,0.098-0.095C21.602,11.666,21.437,11.588,21.4,11.563z M21.72,10.584c0.002,0,0.003-0.001,0.005-0.001\r\n\t\t\t\tc-0.005-0.006-0.009-0.013-0.014-0.019c-0.016,0.002-0.032,0.005-0.048,0.007c-0.148-0.003-0.224-0.095-0.411-0.061\r\n\t\t\t\tc-0.054,0.025-0.235,0.062-0.254,0.094c-0.029,0.048,0.077,0.08,0.116,0.089c0.134,0.033,0.307,0.006,0.465,0.018\r\n\t\t\t\tc0.029,0.002,0.079,0.007,0.099,0.019c0.015,0.009,0.022,0.026,0.042,0.03c0.032,0.001,0.089-0.042,0.103-0.056\r\n\t\t\t\tc0.001-0.001,0.003-0.002,0.004-0.003c-0.082-0.021-0.2-0.02-0.258-0.064C21.619,10.62,21.669,10.602,21.72,10.584z\r\n\t\t\t\t M14.242,41.547c0.147,0.036,0.426-0.012,0.508-0.108c0.048-0.056,0.064-0.206,0.095-0.267c-0.057-0.054-0.445-0.06-0.591-0.057\r\n\t\t\t\tC14.175,41.239,14.197,41.443,14.242,41.547z M10.822,34.354c0.015,0.038,0.009,0.091,0.013,0.134\r\n\t\t\t\tc0.086,0.022,0.114-0.016,0.203-0.019c0.117-0.003,0.196,0.036,0.216-0.095c-0.077-0.061-0.285-0.049-0.4-0.051\r\n\t\t\t\tC10.843,34.333,10.833,34.343,10.822,34.354z M12.735,25.375c-0.017-0.011-0.034-0.021-0.051-0.032\r\n\t\t\t\tc-0.011-0.1,0.084-0.092,0.133-0.146c0.043-0.048,0.06-0.154,0.095-0.203c-0.04-0.027-0.081-0.055-0.121-0.083\r\n\t\t\t\tc-0.045,0.101-0.251,0.268-0.216,0.413c0.05,0.208,0.421,0.141,0.47-0.025C12.9,25.097,12.854,25.337,12.735,25.375z\r\n\t\t\t\t M10.93,37.912c-0.004,0.006-0.008,0.013-0.013,0.019c0.044,0.003,0.042,0.01,0.063,0.032c-0.012,0.031-0.012,0.05,0,0.083\r\n\t\t\t\tc-0.034,0.015-0.068,0.03-0.102,0.044c-0.004,0.006-0.009,0.013-0.013,0.019v0.007c0.085,0,0.174-0.005,0.242-0.013\r\n\t\t\t\tc0.02-0.081-0.008-0.157,0.032-0.216v-0.006h-0.038C11.059,37.905,10.99,37.913,10.93,37.912z M10.015,33.979\r\n\t\t\t\tc-0.092-0.017-0.212,0.006-0.261-0.083c-0.045,0.004-0.062,0.023-0.089,0.032c-0.04-0.004-0.081-0.008-0.121-0.013\r\n\t\t\t\tc-0.04,0.009-0.059,0.049-0.127,0.038c-0.109-0.017-0.194-0.056-0.324-0.057c-0.027,0.004-0.055,0.008-0.083,0.013\r\n\t\t\t\tc-0.006,0.008-0.013,0.017-0.019,0.026v0.025c0.064,0.033,0.195,0.03,0.229,0.095c0.046,0.078-0.076,0.145,0.095,0.21\r\n\t\t\t\tc0.004,0.006,0.008,0.013,0.013,0.019c-0.128,0.082-0.41,0.037-0.572-0.013c-0.013,0.015-0.025,0.03-0.038,0.045\r\n\t\t\t\tc-0.002,0.004-0.004,0.008-0.006,0.013c0.034,0.065,0.099,0.077,0.152,0.121c0.05-0.012,0.053-0.047,0.102-0.057\r\n\t\t\t\tc0.076,0.011,0.153,0.021,0.229,0.032c0.078-0.006,0.157-0.013,0.235-0.019c0.048,0.048,0.109,0.151,0.178,0.172\r\n\t\t\t\tc0.044-0.114,0.093-0.196,0.203-0.248c0.021,0.023,0.042,0.047,0.064,0.07c0.075,0.033,0.112-0.06,0.178-0.076\r\n\t\t\t\tc0.044-0.011,0.074,0.012,0.095,0.019c0.129-0.06,0.183,0.045,0.248,0.083c0.039-0.029,0.062-0.074,0.089-0.114\r\n\t\t\t\tC10.38,34.159,10.076,34.16,10.015,33.979z M7.581,34.385c0.019,0.027,0.251,0.169,0.311,0.153\r\n\t\t\t\tc0.044-0.012,0.058-0.078,0.14-0.057c0.051,0.013,0.064,0.04,0.127,0.038c0.002-0.011,0.004-0.021,0.006-0.032\r\n\t\t\t\tc-0.073-0.11-0.33-0.158-0.515-0.153C7.628,34.352,7.604,34.368,7.581,34.385z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"COMPASS_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"COMPASS","display":"inline"},"children":[{"name":"g","attribs":{"id":"COMPASS","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16,16l9,22l23,10l-9-23L16,16z M32,35c-1.657,0-3-1.343-3-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3C35,33.657,33.657,35,32,35z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M16,16l9,22l23,10l-9-23L16,16z M32,35c-1.657,0-3-1.343-3-3\r\n\t\t\t\tc0-1.657,1.343-3,3-3c1.657,0,3,1.343,3,3C35,33.657,33.657,35,32,35z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32\r\n\t\t\t\tc17.673,0,32-14.327,32-32C64,14.327,49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32S17.641,6,32,6c14.359,0,26,11.641,26,26\r\n\t\t\t\tS46.359,58,32,58z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"TARGET_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TARGET","display":"inline"},"children":[{"name":"g","attribs":{"id":"TARGET","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,29c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tC35,30.343,33.657,29,32,29z M61,29h-3.186C56.438,17.042,46.956,7.569,35,6.191V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186\r\n\t\t\t\tC17.042,7.562,7.568,17.044,6.191,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3.186C7.562,46.958,17.044,56.432,29,57.809V61\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-3.191C46.956,56.432,56.438,46.958,57.814,35H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M46,35h5.751C50.448,43.638,43.634,50.453,35,51.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.756\r\n\t\t\t\tC20.366,50.453,13.552,43.638,12.249,35H18c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-5.756\r\n\t\t\t\tC13.547,20.366,20.362,13.552,29,12.249V18c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.756C43.634,13.547,50.448,20.362,51.751,29H46\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C43,33.657,44.343,35,46,35z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,29c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3s3-1.343,3-3\r\n\t\t\t\tC35,30.343,33.657,29,32,29z M61,29h-3.186C56.438,17.042,46.956,7.569,35,6.191V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186\r\n\t\t\t\tC17.042,7.562,7.568,17.044,6.191,29H3c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h3.186C7.562,46.958,17.044,56.432,29,57.809V61\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-3.191C46.956,56.432,56.438,46.958,57.814,35H61c1.657,0,3-1.343,3-3\r\n\t\t\t\tC64,30.343,62.657,29,61,29z M46,35h5.751C50.448,43.638,43.634,50.453,35,51.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.756\r\n\t\t\t\tC20.366,50.453,13.552,43.638,12.249,35H18c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3h-5.756\r\n\t\t\t\tC13.547,20.366,20.362,13.552,29,12.249V18c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.756C43.634,13.547,50.448,20.362,51.751,29H46\r\n\t\t\t\tc-1.657,0-3,1.343-3,3C43,33.657,44.343,35,46,35z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT","display":"inline"},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_OUT","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21H24c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3\r\n\t\t\t\tC43,22.343,41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z\r\n\t\t\t\t M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21H24c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h16c1.657,0,3-1.343,3-3\r\n\t\t\t\tC43,22.343,41.657,21,40,21z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z\r\n\t\t\t\t M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN","display":"inline"},"children":[{"name":"g","attribs":{"id":"PIN__x2F__ZOOM_IN","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21h-5v-5c0-1.657-1.343-3-3-3s-3,1.343-3,3v5h-5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h5v5c0,1.657,1.343,3,3,3s3-1.343,3-3v-5h5c1.657,0,3-1.343,3-3C43,22.343,41.657,21,40,21z M32,0\r\n\t\t\t\tC18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16\r\n\t\t\t\tc0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M40,21h-5v-5c0-1.657-1.343-3-3-3s-3,1.343-3,3v5h-5c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3h5v5c0,1.657,1.343,3,3,3s3-1.343,3-3v-5h5c1.657,0,3-1.343,3-3C43,22.343,41.657,21,40,21z M32,0\r\n\t\t\t\tC18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16\r\n\t\t\t\tc0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PIN_2_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN_2","display":"inline"},"children":[{"name":"g","attribs":{"id":"PIN_2","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,16c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tC40,19.582,36.418,16,32,16z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z\r\n\t\t\t\t M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,16c-4.418,0-8,3.582-8,8c0,4.418,3.582,8,8,8c4.418,0,8-3.582,8-8\r\n\t\t\t\tC40,19.582,36.418,16,32,16z M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40C56,10.747,45.254,0,32,0z\r\n\t\t\t\t M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16C48,32.836,40.836,40,32,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"PIN_1_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"PIN_1","display":"inline"},"children":[{"name":"g","attribs":{"id":"PIN_1","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40\r\n\t\t\t\tC56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16\r\n\t\t\t\tC48,32.836,40.836,40,32,40z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32,0C18.746,0,8,10.747,8,24c0,13.254,24,40,24,40s24-26.746,24-40\r\n\t\t\t\tC56,10.747,45.254,0,32,0z M32,40c-8.836,0-16-7.164-16-16c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16\r\n\t\t\t\tC48,32.836,40.836,40,32,40z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__UPLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.986,43.719c0-0.002,0-0.004,0-0.006c-0.063-0.658-0.338-1.255-0.756-1.719\r\n\t\t\t\tl0,0l-0.008-0.009c-0.001-0.001-0.002-0.002-0.003-0.003l-8.99-9.989l-0.008,0.007c-0.549-0.61-1.336-1-2.222-1\r\n\t\t\t\tc-0.885,0-1.673,0.391-2.222,1l-0.008-0.007l-8.988,9.987c-0.002,0.002-0.004,0.005-0.006,0.007l-0.006,0.006l0,0\r\n\t\t\t\tC20.292,42.525,20,43.228,20,44c0,0.518,0.131,1.005,0.362,1.43C20.87,46.365,21.861,47,23,47c0.033,0,0.066-0.002,0.099-0.003\r\n\t\t\t\tc0.019-0.001,0.038-0.001,0.057-0.002c0.022-0.001,0.043-0.003,0.065-0.005c0.033-0.002,0.066-0.005,0.098-0.008\r\n\t\t\t\tc0.012-0.001,0.024-0.003,0.036-0.005c0.044-0.005,0.087-0.011,0.13-0.018c0.001,0,0.003,0,0.004-0.001\r\n\t\t\t\tc0.686-0.113,1.294-0.458,1.74-0.953l0,0L29,41.818V57c0,1.657,1.343,3,3,3s3-1.343,3-3V41.818l3.77,4.189l0,0\r\n\t\t\t\tc0.446,0.495,1.055,0.841,1.742,0.953c0.001,0,0.001,0,0.002,0c0.044,0.007,0.088,0.013,0.132,0.018\r\n\t\t\t\tc0.011,0.001,0.023,0.003,0.034,0.004c0.033,0.003,0.067,0.006,0.1,0.008c0.021,0.002,0.042,0.004,0.063,0.005\r\n\t\t\t\tc0.02,0.001,0.04,0.001,0.06,0.002C40.935,46.999,40.967,47,41,47c1.657,0,3-1.343,3-3c0-0.001,0-0.001,0-0.002\r\n\t\t\t\tC44,43.904,43.995,43.811,43.986,43.719z M53.387,19.656C50.048,11.086,41.753,5,32,5c-9.752,0-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097C20.406,14.318,25.808,11,32,11\r\n\t\t\t\tc6.192,0,11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.598,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,25.011,48.906,25,49,25\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,27.243,59.53,21.532,53.387,19.656z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43.986,43.719c0-0.002,0-0.004,0-0.006c-0.063-0.658-0.338-1.255-0.756-1.719\r\n\t\t\t\tl0,0l-0.008-0.009c-0.001-0.001-0.002-0.002-0.003-0.003l-8.99-9.989l-0.008,0.007c-0.549-0.61-1.336-1-2.222-1\r\n\t\t\t\tc-0.885,0-1.673,0.391-2.222,1l-0.008-0.007l-8.988,9.987c-0.002,0.002-0.004,0.005-0.006,0.007l-0.006,0.006l0,0\r\n\t\t\t\tC20.292,42.525,20,43.228,20,44c0,0.518,0.131,1.005,0.362,1.43C20.87,46.365,21.861,47,23,47c0.033,0,0.066-0.002,0.099-0.003\r\n\t\t\t\tc0.019-0.001,0.038-0.001,0.057-0.002c0.022-0.001,0.043-0.003,0.065-0.005c0.033-0.002,0.066-0.005,0.098-0.008\r\n\t\t\t\tc0.012-0.001,0.024-0.003,0.036-0.005c0.044-0.005,0.087-0.011,0.13-0.018c0.001,0,0.003,0,0.004-0.001\r\n\t\t\t\tc0.686-0.113,1.294-0.458,1.74-0.953l0,0L29,41.818V57c0,1.657,1.343,3,3,3s3-1.343,3-3V41.818l3.77,4.189l0,0\r\n\t\t\t\tc0.446,0.495,1.055,0.841,1.742,0.953c0.001,0,0.001,0,0.002,0c0.044,0.007,0.088,0.013,0.132,0.018\r\n\t\t\t\tc0.011,0.001,0.023,0.003,0.034,0.004c0.033,0.003,0.067,0.006,0.1,0.008c0.021,0.002,0.042,0.004,0.063,0.005\r\n\t\t\t\tc0.02,0.001,0.04,0.001,0.06,0.002C40.935,46.999,40.967,47,41,47c1.657,0,3-1.343,3-3c0-0.001,0-0.001,0-0.002\r\n\t\t\t\tC44,43.904,43.995,43.811,43.986,43.719z M53.387,19.656C50.048,11.086,41.753,5,32,5c-9.752,0-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,25.017,14.702,25,15,25\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097C20.406,14.318,25.808,11,32,11\r\n\t\t\t\tc6.192,0,11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.598,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,25.011,48.906,25,49,25\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.405,0.315,0.597,0.485C56.822,28.921,58,31.32,58,34c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,27.243,59.53,21.532,53.387,19.656z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__DOWNLOAD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,44c-0.885,0-1.681,0.384-2.23,0.993h0L35,49.182V34c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v15.182l-3.77-4.189l0,0C24.681,44.384,23.885,44,23,44c-1.657,0-3,1.343-3,3c0,0.096,0.005,0.192,0.014,0.286\r\n\t\t\t\tc0,0,0,0,0,0c0.062,0.659,0.337,1.256,0.756,1.721l0,0l9,10L29.778,59C30.327,59.609,31.115,60,32,60s1.673-0.391,2.222-1.001\r\n\t\t\t\tl0.008,0.007l9-10l0,0c0.419-0.465,0.694-1.061,0.756-1.719c0-0.002,0-0.004,0-0.006C43.995,47.189,44,47.096,44,47.001V47\r\n\t\t\t\tc0-0.104-0.005-0.206-0.015-0.307C43.831,45.181,42.553,44,41,44z M53.387,19.656C50.048,11.086,41.753,5,32,5\r\n\t\t\t\tc-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485\r\n\t\t\t\tc0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058\r\n\t\t\t\tc0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248\r\n\t\t\t\tc0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091\r\n\t\t\t\tc0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05\r\n\t\t\t\tC14.408,25.017,14.702,25,15,25c0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512\r\n\t\t\t\tc0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324\r\n\t\t\t\tc0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097\r\n\t\t\t\tC20.406,14.318,25.808,11,32,11s11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097\r\n\t\t\t\tc0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324\r\n\t\t\t\tc0.137,0.363,0.252,0.737,0.364,1.112c0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512\r\n\t\t\t\tC48.815,25.011,48.906,25,49,25c0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05\r\n\t\t\t\tc0.165,0.023,0.331,0.043,0.493,0.075c0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091\r\n\t\t\t\tc0.176,0.052,0.348,0.113,0.519,0.175c0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248\r\n\t\t\t\tc0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.397,0.21,0.589,0.326c0.032,0.019,0.064,0.039,0.096,0.058\r\n\t\t\t\tc0.206,0.128,0.406,0.263,0.601,0.406c0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485\r\n\t\t\t\tC56.822,28.921,58,31.32,58,34c0,4.971-4.03,9-9,9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15\r\n\t\t\t\tC64,27.243,59.53,21.532,53.387,19.656z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M41,44c-0.885,0-1.681,0.384-2.23,0.993h0L35,49.182V34c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v15.182l-3.77-4.189l0,0C24.681,44.384,23.885,44,23,44c-1.657,0-3,1.343-3,3c0,0.096,0.005,0.192,0.014,0.286\r\n\t\t\t\tc0,0,0,0,0,0c0.062,0.659,0.337,1.256,0.756,1.721l0,0l9,10L29.778,59C30.327,59.609,31.115,60,32,60s1.673-0.391,2.222-1.001\r\n\t\t\t\tl0.008,0.007l9-10l0,0c0.419-0.465,0.694-1.061,0.756-1.719c0-0.002,0-0.004,0-0.006C43.995,47.189,44,47.096,44,47.001V47\r\n\t\t\t\tc0-0.104-0.005-0.206-0.015-0.307C43.831,45.181,42.553,44,41,44z M53.387,19.656C50.048,11.086,41.753,5,32,5\r\n\t\t\t\tc-9.752,0-18.048,6.086-21.387,14.655C4.47,21.532,0,27.243,0,34c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485\r\n\t\t\t\tc0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058\r\n\t\t\t\tc0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248\r\n\t\t\t\tc0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091\r\n\t\t\t\tc0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05\r\n\t\t\t\tC14.408,25.017,14.702,25,15,25c0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512\r\n\t\t\t\tc0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324\r\n\t\t\t\tc0.148-0.37,0.3-0.737,0.473-1.093c0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097\r\n\t\t\t\tC20.406,14.318,25.808,11,32,11s11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097\r\n\t\t\t\tc0.043,0.085,0.091,0.167,0.133,0.253c0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324\r\n\t\t\t\tc0.137,0.363,0.252,0.737,0.364,1.112c0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512\r\n\t\t\t\tC48.815,25.011,48.906,25,49,25c0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05\r\n\t\t\t\tc0.165,0.023,0.331,0.043,0.493,0.075c0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091\r\n\t\t\t\tc0.176,0.052,0.348,0.113,0.519,0.175c0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248\r\n\t\t\t\tc0.056,0.026,0.112,0.053,0.167,0.08c0.201,0.101,0.397,0.21,0.589,0.326c0.032,0.019,0.064,0.039,0.096,0.058\r\n\t\t\t\tc0.206,0.128,0.406,0.263,0.601,0.406c0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485\r\n\t\t\t\tC56.822,28.921,58,31.32,58,34c0,4.971-4.03,9-9,9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15\r\n\t\t\t\tC64,27.243,59.53,21.532,53.387,19.656z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__FAIL","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,39c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,42.758\r\n\t\t\t\tl-5.879-5.879C25.578,36.336,24.829,36,24,36c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L27.757,47l-5.879,5.879\r\n\t\t\t\tC21.336,53.422,21,54.172,21,55c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.878L32,51.243l5.879,5.879\r\n\t\t\t\tC38.422,57.664,39.172,58,40,58c1.657,0,3-1.343,3-3c0-0.829-0.336-1.579-0.879-2.121L36.243,47l5.879-5.879\r\n\t\t\t\tC42.664,40.579,43,39.829,43,39z M53.387,20.656C50.048,12.086,41.752,6,32,6c-9.752,0-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.589-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097C20.406,15.318,25.808,12,32,12\r\n\t\t\t\tc6.192,0,11.594,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,26.011,48.906,26,49,26\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.53,22.532,53.387,20.656z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,39c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L32,42.758\r\n\t\t\t\tl-5.879-5.879C25.578,36.336,24.829,36,24,36c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121L27.757,47l-5.879,5.879\r\n\t\t\t\tC21.336,53.422,21,54.172,21,55c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.878L32,51.243l5.879,5.879\r\n\t\t\t\tC38.422,57.664,39.172,58,40,58c1.657,0,3-1.343,3-3c0-0.829-0.336-1.579-0.879-2.121L36.243,47l5.879-5.879\r\n\t\t\t\tC42.664,40.579,43,39.829,43,39z M53.387,20.656C50.048,12.086,41.752,6,32,6c-9.752,0-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9\r\n\t\t\t\tc0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.6-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.589-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.599-1.097C20.406,15.318,25.808,12,32,12\r\n\t\t\t\tc6.192,0,11.594,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,26.011,48.906,26,49,26\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.53,22.532,53.387,20.656z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOUD__x2F__OK_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOUD__x2F__OK","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,36c-1.039,0-1.954,0.528-2.493,1.33l-8.936,12.998l-5.45-5.45\r\n\t\t\t\tC25.578,44.336,24.828,44,24,44c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.579,0.879,2.121l8,8C30.422,57.664,31.172,58,32,58\r\n\t\t\t\tc1.039,0,1.954-0.528,2.493-1.33l10.969-15.954C45.801,40.23,46,39.638,46,39C46,37.343,44.657,36,43,36z M53.387,20.656\r\n\t\t\t\tC50.048,12.086,41.752,6,32,6c-9.753,0-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728\r\n\t\t\t\tc0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.601-0.406\r\n\t\t\t\tc0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08\r\n\t\t\t\tc0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175\r\n\t\t\t\tc0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075\r\n\t\t\t\tc0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26c0.094,0,0.185,0.011,0.278,0.014\r\n\t\t\t\tc0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112\r\n\t\t\t\tc0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093c0.041-0.086,0.09-0.168,0.133-0.253\r\n\t\t\t\tc0.188-0.372,0.384-0.741,0.598-1.097C20.406,15.318,25.808,12,32,12c6.192,0,11.594,3.318,14.562,8.266\r\n\t\t\t\tc0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253c0.172,0.356,0.325,0.724,0.473,1.093\r\n\t\t\t\tc0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112c0.036,0.12,0.081,0.236,0.114,0.357\r\n\t\t\t\tc0.136,0.495,0.251,0.999,0.342,1.512C48.815,26.011,48.906,26,49,26c0.298,0,0.592,0.016,0.882,0.045\r\n\t\t\t\tc0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075c0.155,0.03,0.306,0.07,0.457,0.109\r\n\t\t\t\tc0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175c0.084,0.031,0.169,0.059,0.252,0.092\r\n\t\t\t\tc0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08c0.2,0.101,0.397,0.21,0.588,0.326\r\n\t\t\t\tc0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406c0.013,0.01,0.027,0.02,0.04,0.03\r\n\t\t\t\tc0.206,0.154,0.405,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.53,22.532,53.387,20.656z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M43,36c-1.039,0-1.954,0.528-2.493,1.33l-8.936,12.998l-5.45-5.45\r\n\t\t\t\tC25.578,44.336,24.828,44,24,44c-1.657,0-3,1.343-3,3c0,0.829,0.336,1.579,0.879,2.121l8,8C30.422,57.664,31.172,58,32,58\r\n\t\t\t\tc1.039,0,1.954-0.528,2.493-1.33l10.969-15.954C45.801,40.23,46,39.638,46,39C46,37.343,44.657,36,43,36z M53.387,20.656\r\n\t\t\t\tC50.048,12.086,41.752,6,32,6c-9.753,0-18.048,6.086-21.387,14.655C4.47,22.532,0,28.243,0,35c0,8.284,6.716,15,15,15\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3c-4.971,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728\r\n\t\t\t\tc0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03c0.194-0.144,0.395-0.278,0.601-0.406\r\n\t\t\t\tc0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326c0.055-0.028,0.111-0.054,0.167-0.08\r\n\t\t\t\tc0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092c0.171-0.062,0.343-0.123,0.519-0.175\r\n\t\t\t\tc0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109c0.162-0.032,0.328-0.053,0.493-0.075\r\n\t\t\t\tc0.119-0.016,0.236-0.039,0.356-0.05C14.408,26.017,14.702,26,15,26c0.094,0,0.185,0.011,0.278,0.014\r\n\t\t\t\tc0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357c0.112-0.375,0.227-0.749,0.364-1.112\r\n\t\t\t\tc0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093c0.041-0.086,0.09-0.168,0.133-0.253\r\n\t\t\t\tc0.188-0.372,0.384-0.741,0.598-1.097C20.406,15.318,25.808,12,32,12c6.192,0,11.594,3.318,14.562,8.266\r\n\t\t\t\tc0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253c0.172,0.356,0.325,0.724,0.473,1.093\r\n\t\t\t\tc0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112c0.036,0.12,0.081,0.236,0.114,0.357\r\n\t\t\t\tc0.136,0.495,0.251,0.999,0.342,1.512C48.815,26.011,48.906,26,49,26c0.298,0,0.592,0.016,0.882,0.045\r\n\t\t\t\tc0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075c0.155,0.03,0.306,0.07,0.457,0.109\r\n\t\t\t\tc0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175c0.084,0.031,0.169,0.059,0.252,0.092\r\n\t\t\t\tc0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08c0.2,0.101,0.397,0.21,0.588,0.326\r\n\t\t\t\tc0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406c0.013,0.01,0.027,0.02,0.04,0.03\r\n\t\t\t\tc0.206,0.154,0.405,0.315,0.597,0.485C56.822,29.921,58,32.32,58,35c0,4.971-4.029,9-9,9c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,1.657,1.343,3,3,3c8.284,0,15-6.716,15-15C64,28.243,59.53,22.532,53.387,20.656z"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{"id":"CLOUD_1_","display":"none","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"CLOUD","display":"inline"},"children":[{"name":"g","attribs":{"id":"CLOUD","display":"inline"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.387,24.656C50.048,16.086,41.753,10,32,10s-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,26.532,0,32.243,0,39c0,8.284,6.716,15,15,15h34c8.284,0,15-6.716,15-15C64,32.243,59.53,26.532,53.387,24.656z M49,48H15\r\n\t\t\t\tc-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,30.017,14.702,30,15,30\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,19.318,25.808,16,32,16\r\n\t\t\t\ts11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,30.011,48.906,30,49,30\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,33.921,58,36.32,58,39C58,43.971,53.971,48,49,48z\r\n\t\t\t\t"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M53.387,24.656C50.048,16.086,41.753,10,32,10s-18.048,6.086-21.387,14.655\r\n\t\t\t\tC4.47,26.532,0,32.243,0,39c0,8.284,6.716,15,15,15h34c8.284,0,15-6.716,15-15C64,32.243,59.53,26.532,53.387,24.656z M49,48H15\r\n\t\t\t\tc-4.97,0-9-4.029-9-9c0-2.68,1.178-5.08,3.037-6.728c0.192-0.17,0.392-0.331,0.597-0.485c0.013-0.01,0.027-0.02,0.04-0.03\r\n\t\t\t\tc0.194-0.144,0.395-0.278,0.601-0.406c0.032-0.02,0.064-0.039,0.096-0.058c0.192-0.116,0.388-0.225,0.588-0.326\r\n\t\t\t\tc0.055-0.028,0.111-0.054,0.167-0.08c0.184-0.089,0.371-0.172,0.561-0.248c0.083-0.033,0.168-0.062,0.252-0.092\r\n\t\t\t\tc0.171-0.062,0.343-0.123,0.519-0.175c0.116-0.034,0.236-0.062,0.354-0.091c0.152-0.038,0.303-0.079,0.457-0.109\r\n\t\t\t\tc0.162-0.032,0.328-0.053,0.493-0.075c0.119-0.016,0.236-0.039,0.356-0.05C14.408,30.017,14.702,30,15,30\r\n\t\t\t\tc0.094,0,0.185,0.011,0.278,0.014c0.091-0.513,0.206-1.017,0.342-1.512c0.033-0.121,0.078-0.237,0.114-0.357\r\n\t\t\t\tc0.112-0.375,0.227-0.749,0.364-1.112c0.041-0.11,0.092-0.215,0.135-0.324c0.148-0.37,0.3-0.737,0.473-1.093\r\n\t\t\t\tc0.042-0.086,0.09-0.168,0.133-0.253c0.188-0.372,0.384-0.741,0.598-1.097C20.406,19.318,25.808,16,32,16\r\n\t\t\t\ts11.595,3.318,14.562,8.266c0.214,0.357,0.41,0.725,0.599,1.097c0.043,0.085,0.091,0.167,0.133,0.253\r\n\t\t\t\tc0.173,0.356,0.325,0.724,0.473,1.093c0.043,0.109,0.094,0.214,0.135,0.324c0.137,0.363,0.252,0.737,0.364,1.112\r\n\t\t\t\tc0.036,0.12,0.081,0.236,0.114,0.357c0.136,0.495,0.251,0.999,0.342,1.512C48.815,30.011,48.906,30,49,30\r\n\t\t\t\tc0.298,0,0.592,0.016,0.882,0.045c0.12,0.012,0.237,0.034,0.356,0.05c0.165,0.023,0.331,0.043,0.493,0.075\r\n\t\t\t\tc0.155,0.03,0.306,0.07,0.457,0.109c0.118,0.029,0.238,0.057,0.354,0.091c0.176,0.052,0.348,0.113,0.519,0.175\r\n\t\t\t\tc0.084,0.031,0.169,0.059,0.252,0.092c0.191,0.076,0.377,0.16,0.561,0.248c0.056,0.026,0.112,0.053,0.167,0.08\r\n\t\t\t\tc0.201,0.101,0.397,0.21,0.588,0.326c0.032,0.019,0.064,0.039,0.096,0.058c0.206,0.128,0.406,0.263,0.601,0.406\r\n\t\t\t\tc0.013,0.01,0.027,0.02,0.04,0.03c0.206,0.154,0.406,0.315,0.597,0.485C56.822,33.921,58,36.32,58,39C58,43.971,53.971,48,49,48z\r\n\t\t\t\t"},"children":[]}]}]}]}]}]}]}]};exports.shopping_cart_add=shopping_cart_add;var shopping_cart_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56,49H27.779l-1.498-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0l4.83-10.733\r\n\t\t\t\tc-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.679,23h17.495C35.423,21.146,35,19.124,35,17H16.578\r\n\t\t\t\tl-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z M51,30\r\n\t\t\t\tc7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M44.879,15.121C44.336,14.578,44,13.828,44,13\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,12.757l1.879-1.879C53.422,10.336,54.172,10,55,10c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,0.828-0.336,1.578-0.879,2.121L55.243,17l1.879,1.879C57.664,19.422,58,20.172,58,21c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-0.828,0-1.578-0.336-2.121-0.879L51,21.243l-1.879,1.879C48.579,23.664,47.828,24,47,24c-1.657,0-3-1.343-3-3\r\n\t\t\t\tc0-0.828,0.336-1.578,0.879-2.121L46.757,17L44.879,15.121z"},"children":[{"name":"path","attribs":{"d":"M56,49H27.779l-1.498-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0l4.83-10.733\r\n\t\t\t\tc-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.679,23h17.495C35.423,21.146,35,19.124,35,17H16.578\r\n\t\t\t\tl-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z M51,30\r\n\t\t\t\tc7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M44.879,15.121C44.336,14.578,44,13.828,44,13\r\n\t\t\t\tc0-1.657,1.343-3,3-3c0.828,0,1.578,0.336,2.121,0.879L51,12.757l1.879-1.879C53.422,10.336,54.172,10,55,10c1.657,0,3,1.343,3,3\r\n\t\t\t\tc0,0.828-0.336,1.578-0.879,2.121L55.243,17l1.879,1.879C57.664,19.422,58,20.172,58,21c0,1.657-1.343,3-3,3\r\n\t\t\t\tc-0.828,0-1.578-0.336-2.121-0.879L51,21.243l-1.879,1.879C48.579,23.664,47.828,24,47,24c-1.657,0-3-1.343-3-3\r\n\t\t\t\tc0-0.828,0.336-1.578,0.879-2.121L46.757,17L44.879,15.121z"},"children":[]}]}]}]}]}]}]}]};exports.shopping_cart_delete=shopping_cart_delete;var shopping_cart_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M51,30c7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M45,15c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL49,17.757l5.879-5.879C55.422,11.336,56.172,11,57,11c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121l-8,8\r\n\t\t\t\tC50.578,24.664,49.828,25,49,25s-1.578-0.336-2.121-0.879l-4-4C42.336,19.578,42,18.828,42,18C42,16.343,43.343,15,45,15z M56,49\r\n\t\t\t\tH27.778l-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0l4.83-10.733\r\n\t\t\t\tc-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.679,23h17.495C35.423,21.146,35,19.124,35,17H16.578\r\n\t\t\t\tl-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z"},"children":[{"name":"path","attribs":{"d":"M51,30c7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M45,15c0.828,0,1.578,0.336,2.121,0.879\r\n\t\t\t\tL49,17.757l5.879-5.879C55.422,11.336,56.172,11,57,11c1.657,0,3,1.343,3,3c0,0.828-0.336,1.578-0.879,2.121l-8,8\r\n\t\t\t\tC50.578,24.664,49.828,25,49,25s-1.578-0.336-2.121-0.879l-4-4C42.336,19.578,42,18.828,42,18C42,16.343,43.343,15,45,15z M56,49\r\n\t\t\t\tH27.778l-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0l4.83-10.733\r\n\t\t\t\tc-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.679,23h17.495C35.423,21.146,35,19.124,35,17H16.578\r\n\t\t\t\tl-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z"},"children":[]}]}]}]}]}]}]}]};exports.shopping_cart_ok=shopping_cart_ok;var shopping_cart_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"SHOPPING_CART__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M51,30c7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M45,14h12c1.657,0,3,1.343,3,3s-1.343,3-3,3H45\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.778l-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0\r\n\t\t\t\tl4.83-10.733c-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.678,23h17.495C35.423,21.146,35,19.124,35,17\r\n\t\t\t\tH16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z"},"children":[{"name":"path","attribs":{"d":"M51,30c7.18,0,13-5.82,13-13S58.18,4,51,4S38,9.82,38,17S43.82,30,51,30z M45,14h12c1.657,0,3,1.343,3,3s-1.343,3-3,3H45\r\n\t\t\t\tc-1.657,0-3-1.343-3-3S43.343,14,45,14z M56,49H27.778l-1.497-4.279L52.2,42.993v-0.001c1.132-0.074,2.092-0.776,2.536-1.762l0,0\r\n\t\t\t\tl4.83-10.733c-2.246,1.427-4.866,2.303-7.686,2.457l-1.877,4.171l-25.779,1.719L18.678,23h17.495C35.423,21.146,35,19.124,35,17\r\n\t\t\t\tH16.578l-1.747-4.991l-0.011,0.004C14.411,10.844,13.309,10,12,10H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h6.872l11.55,33H16\r\n\t\t\t\tc-3.314,0-6,2.686-6,6s2.686,6,6,6s6-2.686,6-6h28c0,3.314,2.686,6,6,6s6-2.686,6-6S59.314,49,56,49z"},"children":[]}]}]}]}]}]}]}]};exports.shopping_cart_remove=shopping_cart_remove;var shuffle={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SHUFFLE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SHUFFLE"},"children":[{"name":"g","attribs":{"id":"SHUFFLE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,19h8.757l10.879,10.879l4.243-4.243L15.121,13.879C14.578,13.336,13.828,13,13,13H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tS1.343,19,3,19z M52,19v0.005h1.773l-1.879,1.879c-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.342,3,3,3\r\n\t\t\t\tc0.827,0,1.577-0.336,2.12-0.879l7-7c0.544-0.543,0.88-1.293,0.88-2.121s-0.336-1.578-0.88-2.121l-7-7\r\n\t\t\t\tc-0.543-0.543-1.293-0.879-2.12-0.879c-1.658,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,13H45\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L11.757,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,19\r\n\t\t\t\tH52z M56.137,38.874c-0.543-0.543-1.293-0.879-2.121-0.879c-1.656,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.879,1.879H52\r\n\t\t\t\tV45h-5.757l-10.88-10.879l-4.242,4.242l11.757,11.758C43.422,50.664,44.172,51,45,51h8.768l-1.873,1.874\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.344,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121s-0.336-1.578-0.879-2.121L56.137,38.874z"},"children":[{"name":"path","attribs":{"d":"M3,19h8.757l10.879,10.879l4.243-4.243L15.121,13.879C14.578,13.336,13.828,13,13,13H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\tS1.343,19,3,19z M52,19v0.005h1.773l-1.879,1.879c-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.342,3,3,3\r\n\t\t\t\tc0.827,0,1.577-0.336,2.12-0.879l7-7c0.544-0.543,0.88-1.293,0.88-2.121s-0.336-1.578-0.88-2.121l-7-7\r\n\t\t\t\tc-0.543-0.543-1.293-0.879-2.12-0.879c-1.658,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L53.768,13H45\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L11.757,45H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h10c0.828,0,1.578-0.336,2.121-0.879L46.243,19\r\n\t\t\t\tH52z M56.137,38.874c-0.543-0.543-1.293-0.879-2.121-0.879c-1.656,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121l1.879,1.879H52\r\n\t\t\t\tV45h-5.757l-10.88-10.879l-4.242,4.242l11.757,11.758C43.422,50.664,44.172,51,45,51h8.768l-1.873,1.874\r\n\t\t\t\tc-0.543,0.543-0.879,1.293-0.879,2.121c0,1.657,1.344,3,3,3c0.828,0,1.578-0.336,2.121-0.879l7-7\r\n\t\t\t\tc0.543-0.543,0.879-1.293,0.879-2.121s-0.336-1.578-0.879-2.121L56.137,38.874z"},"children":[]}]}]}]}]}]}]}]};exports.shuffle=shuffle;var skip_next={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SKIP__x2F__NEXT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__NEXT"},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__NEXT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,19c-1.657,0-3,1.343-3,3v5.837l-13.41-8.381l0,0C24.129,19.168,23.584,19,23,19c-1.657,0-3,1.343-3,3v20\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L38,36.163V42c0,1.657,1.343,3,3,3s3-1.343,3-3V22\r\n\t\t\t\tC44,20.343,42.657,19,41,19z"},"children":[{"name":"path","attribs":{"d":"M41,19c-1.657,0-3,1.343-3,3v5.837l-13.41-8.381l0,0C24.129,19.168,23.584,19,23,19c-1.657,0-3,1.343-3,3v20\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.584,0,1.129-0.167,1.59-0.456l0,0L38,36.163V42c0,1.657,1.343,3,3,3s3-1.343,3-3V22\r\n\t\t\t\tC44,20.343,42.657,19,41,19z"},"children":[]}]}]}]}]}]}]}]};exports.skip_next=skip_next;var skip_previous={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS"},"children":[{"name":"g","attribs":{"id":"SKIP__x2F__PREVIOUS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M41,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L26,27.837V22c0-1.657-1.343-3-3-3s-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-5.837l13.41,8.381l0,0C39.871,44.833,40.416,45,41,45c1.657,0,3-1.343,3-3V22C44,20.343,42.657,19,41,19z"},"children":[{"name":"path","attribs":{"d":"M41,19c-0.584,0-1.129,0.168-1.59,0.456l0,0L26,27.837V22c0-1.657-1.343-3-3-3s-3,1.343-3,3v20c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3v-5.837l13.41,8.381l0,0C39.871,44.833,40.416,45,41,45c1.657,0,3-1.343,3-3V22C44,20.343,42.657,19,41,19z"},"children":[]}]}]}]}]}]}]}]};exports.skip_previous=skip_previous;var skype={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"skype_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"skype"},"children":[{"name":"g","attribs":{"id":"skype"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M59.539,36.936C59.825,35.33,60,33.688,60,32C60,16.536,47.464,4,32,4c-1.687,0-3.33,0.175-4.934,0.461\r\n\t\t\t\tC24.191,1.704,20.298,0,16,0C7.164,0,0,7.164,0,16c0,4.298,1.703,8.191,4.461,11.066C4.175,28.67,4,30.313,4,32\r\n\t\t\t\tc0,15.464,12.536,28,28,28c1.688,0,3.33-0.175,4.936-0.461C39.809,62.297,43.702,64,48,64c8.837,0,16-7.163,16-16\r\n\t\t\t\tC64,43.703,62.297,39.809,59.539,36.936z M44.331,43.208c-1.104,1.506-2.74,2.7-4.856,3.548\r\n\t\t\t\tc-2.096,0.838-4.608,1.266-7.469,1.266c-3.433,0-6.312-0.582-8.558-1.73c-1.606-0.834-2.93-1.963-3.936-3.363\r\n\t\t\t\tc-1.014-1.408-1.529-2.807-1.529-4.158c0-0.842,0.335-1.572,0.995-2.17c0.655-0.595,1.494-0.895,2.495-0.895\r\n\t\t\t\tc0.822,0,1.531,0.236,2.106,0.703c0.55,0.451,1.022,1.115,1.401,1.973c0.425,0.936,0.885,1.725,1.372,2.342\r\n\t\t\t\tc0.471,0.601,1.144,1.102,2.006,1.494c0.866,0.395,2.035,0.596,3.472,0.596c1.975,0,3.596-0.406,4.814-1.207\r\n\t\t\t\tc1.19-0.781,1.768-1.722,1.768-2.871c0-0.908-0.303-1.621-0.922-2.184c-0.652-0.586-1.51-1.039-2.551-1.355\r\n\t\t\t\tc-1.086-0.323-2.562-0.678-4.385-1.047c-2.48-0.508-4.587-1.117-6.264-1.801c-1.715-0.703-3.096-1.677-4.106-2.894\r\n\t\t\t\tc-1.026-1.238-1.546-2.787-1.546-4.613c0-1.738,0.546-3.306,1.623-4.656c1.069-1.343,2.63-2.388,4.64-3.101\r\n\t\t\t\tc1.984-0.707,4.343-1.065,7.013-1.065c2.134,0,4.01,0.24,5.577,0.707c1.577,0.471,2.903,1.109,3.948,1.895\r\n\t\t\t\tc1.051,0.791,1.832,1.635,2.324,2.515c0.493,0.886,0.746,1.77,0.746,2.624c0,0.823-0.33,1.571-0.98,2.223\r\n\t\t\t\tc-0.655,0.655-1.481,0.987-2.454,0.987c-0.886,0-1.578-0.209-2.06-0.616c-0.447-0.383-0.912-0.977-1.426-1.83\r\n\t\t\t\tc-0.596-1.09-1.318-1.949-2.145-2.556c-0.805-0.59-2.147-0.886-3.991-0.886c-1.713,0-3.107,0.33-4.141,0.985\r\n\t\t\t\tc-0.998,0.628-1.483,1.349-1.483,2.205c0,0.525,0.157,0.963,0.479,1.339c0.339,0.403,0.819,0.749,1.424,1.043\r\n\t\t\t\tc0.627,0.304,1.276,0.546,1.923,0.717c0.664,0.179,1.779,0.441,3.308,0.781c1.935,0.401,3.712,0.848,5.284,1.333\r\n\t\t\t\tc1.593,0.491,2.967,1.093,4.09,1.798c1.145,0.717,2.051,1.637,2.694,2.737c0.646,1.105,0.972,2.47,0.972,4.054\r\n\t\t\t\tC46.003,39.968,45.439,41.698,44.331,43.208z"},"children":[{"name":"path","attribs":{"d":"M59.539,36.936C59.825,35.33,60,33.688,60,32C60,16.536,47.464,4,32,4c-1.687,0-3.33,0.175-4.934,0.461\r\n\t\t\t\tC24.191,1.704,20.298,0,16,0C7.164,0,0,7.164,0,16c0,4.298,1.703,8.191,4.461,11.066C4.175,28.67,4,30.313,4,32\r\n\t\t\t\tc0,15.464,12.536,28,28,28c1.688,0,3.33-0.175,4.936-0.461C39.809,62.297,43.702,64,48,64c8.837,0,16-7.163,16-16\r\n\t\t\t\tC64,43.703,62.297,39.809,59.539,36.936z M44.331,43.208c-1.104,1.506-2.74,2.7-4.856,3.548\r\n\t\t\t\tc-2.096,0.838-4.608,1.266-7.469,1.266c-3.433,0-6.312-0.582-8.558-1.73c-1.606-0.834-2.93-1.963-3.936-3.363\r\n\t\t\t\tc-1.014-1.408-1.529-2.807-1.529-4.158c0-0.842,0.335-1.572,0.995-2.17c0.655-0.595,1.494-0.895,2.495-0.895\r\n\t\t\t\tc0.822,0,1.531,0.236,2.106,0.703c0.55,0.451,1.022,1.115,1.401,1.973c0.425,0.936,0.885,1.725,1.372,2.342\r\n\t\t\t\tc0.471,0.601,1.144,1.102,2.006,1.494c0.866,0.395,2.035,0.596,3.472,0.596c1.975,0,3.596-0.406,4.814-1.207\r\n\t\t\t\tc1.19-0.781,1.768-1.722,1.768-2.871c0-0.908-0.303-1.621-0.922-2.184c-0.652-0.586-1.51-1.039-2.551-1.355\r\n\t\t\t\tc-1.086-0.323-2.562-0.678-4.385-1.047c-2.48-0.508-4.587-1.117-6.264-1.801c-1.715-0.703-3.096-1.677-4.106-2.894\r\n\t\t\t\tc-1.026-1.238-1.546-2.787-1.546-4.613c0-1.738,0.546-3.306,1.623-4.656c1.069-1.343,2.63-2.388,4.64-3.101\r\n\t\t\t\tc1.984-0.707,4.343-1.065,7.013-1.065c2.134,0,4.01,0.24,5.577,0.707c1.577,0.471,2.903,1.109,3.948,1.895\r\n\t\t\t\tc1.051,0.791,1.832,1.635,2.324,2.515c0.493,0.886,0.746,1.77,0.746,2.624c0,0.823-0.33,1.571-0.98,2.223\r\n\t\t\t\tc-0.655,0.655-1.481,0.987-2.454,0.987c-0.886,0-1.578-0.209-2.06-0.616c-0.447-0.383-0.912-0.977-1.426-1.83\r\n\t\t\t\tc-0.596-1.09-1.318-1.949-2.145-2.556c-0.805-0.59-2.147-0.886-3.991-0.886c-1.713,0-3.107,0.33-4.141,0.985\r\n\t\t\t\tc-0.998,0.628-1.483,1.349-1.483,2.205c0,0.525,0.157,0.963,0.479,1.339c0.339,0.403,0.819,0.749,1.424,1.043\r\n\t\t\t\tc0.627,0.304,1.276,0.546,1.923,0.717c0.664,0.179,1.779,0.441,3.308,0.781c1.935,0.401,3.712,0.848,5.284,1.333\r\n\t\t\t\tc1.593,0.491,2.967,1.093,4.09,1.798c1.145,0.717,2.051,1.637,2.694,2.737c0.646,1.105,0.972,2.47,0.972,4.054\r\n\t\t\t\tC46.003,39.968,45.439,41.698,44.331,43.208z"},"children":[]}]}]}]}]}]}]}]};exports.skype=skype;var slideshow={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SLIDESHOW_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SLIDESHOW"},"children":[{"name":"g","attribs":{"id":"SLIDESHOW"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M12,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3s3-1.343,3-3V21C15,19.343,13.657,18,12,18z M3,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3s3-1.343,3-3V15C6,13.343,4.657,12,3,12z M52,18c-1.657,0-3,1.343-3,3v22\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V21C55,19.343,53.657,18,52,18z M61,12c-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V15C64,13.343,62.657,12,61,12z M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC46,19.343,44.657,18,43,18z M40,40H24V24h16V40z"},"children":[{"name":"path","attribs":{"d":"M12,18c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3s3-1.343,3-3V21C15,19.343,13.657,18,12,18z M3,12\r\n\t\t\t\tc-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3s3-1.343,3-3V15C6,13.343,4.657,12,3,12z M52,18c-1.657,0-3,1.343-3,3v22\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3V21C55,19.343,53.657,18,52,18z M61,12c-1.657,0-3,1.343-3,3v34c0,1.657,1.343,3,3,3\r\n\t\t\t\ts3-1.343,3-3V15C64,13.343,62.657,12,61,12z M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC46,19.343,44.657,18,43,18z M40,40H24V24h16V40z"},"children":[]}]}]}]}]}]}]}]};exports.slideshow=slideshow;var speech_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_1"},"children":[{"name":"g","attribs":{"id":"SPEECH_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,3,3h4v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.048,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.534,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M58,46H17.757L13,50.757V46H6V9h52V46z"},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,3,3h4v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.048,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.534,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M58,46H17.757L13,50.757V46H6V9h52V46z"},"children":[]}]}]}]}]}]}]}]};exports.speech_1=speech_1;var speech_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_2"},"children":[{"name":"g","attribs":{"id":"SPEECH_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,2.999,3H7v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.049,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.535,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z"},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,3,2.999,3H7v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.049,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.535,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z"},"children":[]}]}]}]}]}]}]}]};exports.speech_2=speech_2;var speech_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_3"},"children":[{"name":"g","attribs":{"id":"SPEECH_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,2.999,2.999,3H7v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.049,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.535,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M17,34c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S20.314,34,17,34z M32,34\r\n\t\t\t\tc-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6S35.314,34,32,34z M47,34c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tS50.314,34,47,34z"},"children":[{"name":"path","attribs":{"d":"M61,3H3C1.343,3,0,4.343,0,6v43c0,1.657,1.343,2.999,2.999,3H7v6c0,0.207,0.021,0.409,0.061,0.604\r\n\t\t\t\tc0.028,0.137,0.076,0.265,0.122,0.394c0.02,0.056,0.03,0.116,0.053,0.17c0.049,0.115,0.115,0.219,0.177,0.326\r\n\t\t\t\tc0.035,0.06,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404c0.012,0.012,0.021,0.028,0.033,0.04\r\n\t\t\t\tc0.535,0.533,1.271,0.865,2.084,0.875C9.976,60.997,9.987,61,10,61c0.828,0,1.578-0.336,2.121-0.879L20.243,52H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3V6C64,4.343,62.657,3,61,3z M17,34c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S20.314,34,17,34z M32,34\r\n\t\t\t\tc-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6S35.314,34,32,34z M47,34c-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6\r\n\t\t\t\tS50.314,34,47,34z"},"children":[]}]}]}]}]}]}]}]};exports.speech_3=speech_3;var speech_4={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_4_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_4"},"children":[{"name":"g","attribs":{"id":"SPEECH_4"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M51.841,47.327L45.516,41H19c-3.314,0-6-2.686-6-6V14H4c-1.657,0-3,1.343-3,3v34c0,1.656,1.341,2.998,2.996,3H7.5l0,0H8\r\n\t\t\t\tv6c0,0.207,0.021,0.409,0.061,0.605c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.057,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.061,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.027,0.033,0.04c0.534,0.535,1.271,0.864,2.084,0.875C10.976,62.996,10.987,63,11,63\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L21.243,54H22l0,0h3l0,0h6.9l0,0H53l0,0c1.657,0,3-1.343,3-3v-2\r\n\t\t\t\tc-1.613,0-3.072-0.645-4.15-1.682L51.841,47.327z M61,2H19c-1.657,0-3,1.343-3,3v30c0,1.657,1.343,3,3,3h27.757l7.121,7.121\r\n\t\t\t\tC54.422,45.664,55.172,46,56,46c0.014,0,0.025-0.004,0.037-0.004c0.812-0.01,1.55-0.34,2.084-0.875\r\n\t\t\t\tc0.012-0.012,0.021-0.028,0.033-0.04c0.121-0.126,0.234-0.259,0.332-0.404c0.039-0.057,0.065-0.122,0.101-0.184\r\n\t\t\t\tc0.062-0.107,0.128-0.211,0.177-0.326c0.023-0.054,0.033-0.114,0.053-0.17c0.047-0.129,0.095-0.257,0.123-0.394\r\n\t\t\t\tC58.979,43.409,59,43.207,59,43v-5h2c1.657,0,3-1.343,3-3V5C64,3.343,62.657,2,61,2z"},"children":[{"name":"path","attribs":{"d":"M51.841,47.327L45.516,41H19c-3.314,0-6-2.686-6-6V14H4c-1.657,0-3,1.343-3,3v34c0,1.656,1.341,2.998,2.996,3H7.5l0,0H8\r\n\t\t\t\tv6c0,0.207,0.021,0.409,0.061,0.605c0.028,0.136,0.076,0.264,0.122,0.393c0.02,0.057,0.03,0.116,0.053,0.17\r\n\t\t\t\tc0.048,0.115,0.115,0.219,0.177,0.326c0.035,0.061,0.061,0.126,0.1,0.184c0.098,0.146,0.212,0.278,0.333,0.404\r\n\t\t\t\tc0.012,0.012,0.021,0.027,0.033,0.04c0.534,0.535,1.271,0.864,2.084,0.875C10.976,62.996,10.987,63,11,63\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L21.243,54H22l0,0h3l0,0h6.9l0,0H53l0,0c1.657,0,3-1.343,3-3v-2\r\n\t\t\t\tc-1.613,0-3.072-0.645-4.15-1.682L51.841,47.327z M61,2H19c-1.657,0-3,1.343-3,3v30c0,1.657,1.343,3,3,3h27.757l7.121,7.121\r\n\t\t\t\tC54.422,45.664,55.172,46,56,46c0.014,0,0.025-0.004,0.037-0.004c0.812-0.01,1.55-0.34,2.084-0.875\r\n\t\t\t\tc0.012-0.012,0.021-0.028,0.033-0.04c0.121-0.126,0.234-0.259,0.332-0.404c0.039-0.057,0.065-0.122,0.101-0.184\r\n\t\t\t\tc0.062-0.107,0.128-0.211,0.177-0.326c0.023-0.054,0.033-0.114,0.053-0.17c0.047-0.129,0.095-0.257,0.123-0.394\r\n\t\t\t\tC58.979,43.409,59,43.207,59,43v-5h2c1.657,0,3-1.343,3-3V5C64,3.343,62.657,2,61,2z"},"children":[]}]}]}]}]}]}]}]};exports.speech_4=speech_4;var speech_bubble_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56c0,7.681,4.609,14.54,12.274,19.043\r\n\t\t\t\tc1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902c2.167,0.311,4.409,0.975,6.704,0.975\r\n\t\t\t\tc18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z"},"children":[{"name":"path","attribs":{"d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56c0,7.681,4.609,14.54,12.274,19.043\r\n\t\t\t\tc1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902c2.167,0.311,4.409,0.975,6.704,0.975\r\n\t\t\t\tc18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z"},"children":[]}]}]}]}]}]}]}]};exports.speech_bubble_1=speech_bubble_1;var speech_bubble_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLE_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56c0,7.681,4.609,14.54,12.274,19.043\r\n\t\t\t\tc1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902c2.167,0.311,4.409,0.975,6.704,0.975\r\n\t\t\t\tc18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z M17,35c-3.314,0-6-2.686-6-6s2.686-6,6-6\r\n\t\t\t\ts6,2.686,6,6S20.314,35,17,35z M32,35c-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6S35.314,35,32,35z M47,35\r\n\t\t\t\tc-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S50.314,35,47,35z"},"children":[{"name":"path","attribs":{"d":"M33.697,3.963c-18.83,0-33.738,10.996-33.738,24.56c0,7.681,4.609,14.54,12.274,19.043\r\n\t\t\t\tc1.736,1.02,1.934,8.675-7.831,13.297c0,0,13.825,2.18,22.591-8.902c2.167,0.311,4.409,0.975,6.704,0.975\r\n\t\t\t\tc18.83,0,30.307-10.848,30.307-24.412C64.004,14.959,52.527,3.963,33.697,3.963z M17,35c-3.314,0-6-2.686-6-6s2.686-6,6-6\r\n\t\t\t\ts6,2.686,6,6S20.314,35,17,35z M32,35c-3.314,0-6-2.686-6-6s2.686-6,6-6c3.314,0,6,2.686,6,6S35.314,35,32,35z M47,35\r\n\t\t\t\tc-3.314,0-6-2.686-6-6s2.686-6,6-6s6,2.686,6,6S50.314,35,47,35z"},"children":[]}]}]}]}]}]}]}]};exports.speech_bubble_2=speech_bubble_2;var speech_bubbles={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLES_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLES"},"children":[{"name":"g","attribs":{"id":"SPEECH_BUBBLES"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46.568,34.581c0,0.005,0,0.01,0,0.015c-1.301,0.2-2.629,0.53-3.984,0.478c-12.036-0.75-19.873-8.212-20.379-17.122\r\n\t\t\t\tc-0.068-2.09,0.307-4.107,1.045-5.986C9.787,14.332-0.04,23.094-0.04,33.57c0,6.962,4.177,13.177,11.123,17.258\r\n\t\t\t\tc1.573,0.924,1.752,7.861-7.097,12.05c0,0,12.529,1.976,20.473-8.067c1.964,0.282,3.996,0.883,6.075,0.883\r\n\t\t\t\tc14.557,0,24.237-7.162,26.776-16.896c-2.531-0.059-6.918-0.737-10.39-4.308L46.568,34.581z M56.721,27.814\r\n\t\t\t\tc4.549-2.673,7.285-6.744,7.285-11.304c0-8.052-8.85-14.579-20.027-14.579c-11.179,0-17.993,6.527-17.993,14.579\r\n\t\t\t\tc0,8.052,6.813,14.492,17.993,14.492c1.361,0,2.692-0.394,3.979-0.579c5.204,6.578,13.411,5.284,13.411,5.284\r\n\t\t\t\tC55.573,32.964,55.689,28.419,56.721,27.814z"},"children":[{"name":"path","attribs":{"d":"M46.568,34.581c0,0.005,0,0.01,0,0.015c-1.301,0.2-2.629,0.53-3.984,0.478c-12.036-0.75-19.873-8.212-20.379-17.122\r\n\t\t\t\tc-0.068-2.09,0.307-4.107,1.045-5.986C9.787,14.332-0.04,23.094-0.04,33.57c0,6.962,4.177,13.177,11.123,17.258\r\n\t\t\t\tc1.573,0.924,1.752,7.861-7.097,12.05c0,0,12.529,1.976,20.473-8.067c1.964,0.282,3.996,0.883,6.075,0.883\r\n\t\t\t\tc14.557,0,24.237-7.162,26.776-16.896c-2.531-0.059-6.918-0.737-10.39-4.308L46.568,34.581z M56.721,27.814\r\n\t\t\t\tc4.549-2.673,7.285-6.744,7.285-11.304c0-8.052-8.85-14.579-20.027-14.579c-11.179,0-17.993,6.527-17.993,14.579\r\n\t\t\t\tc0,8.052,6.813,14.492,17.993,14.492c1.361,0,2.692-0.394,3.979-0.579c5.204,6.578,13.411,5.284,13.411,5.284\r\n\t\t\t\tC55.573,32.964,55.689,28.419,56.721,27.814z"},"children":[]}]}]}]}]}]}]}]};exports.speech_bubbles=speech_bubbles;var spotify={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"spotify_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"spotify"},"children":[{"name":"g","attribs":{"id":"spotify"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26.671,55.675c-4.217,0-7.496,1.354-10.156,4.239c4.795,2.869,9.491,4.079,15.486,4.079\r\n\t\t\t\tc3.087,0,4.405-0.132,7.229-0.948C36.949,58.527,32.591,55.675,26.671,55.675z M32.001,0.008\r\n\t\t\t\tc-17.67,0-31.993,14.323-31.993,31.993c0,8.224,3.103,15.72,8.202,21.388c4.778-4.399,11.291-7.104,18.462-7.104\r\n\t\t\t\tc9.749,0,18.284,4.995,22.893,12.458c8.69-5.721,14.43-15.561,14.43-26.742C63.992,14.331,49.669,0.008,32.001,0.008z\r\n\t\t\t\t M46.704,44.438c-1.112,0.906-2.201,0.064-2.201,0.064c-10.883-8.335-27.994-3.798-27.994-3.754l-0.256,0.072\r\n\t\t\t\tc-1.149,0-1.937-1.215-1.937-2.362c0,0-0.069-1.319,1.788-1.937c0.713-0.131,18.112-3.926,30.539,4.408\r\n\t\t\t\tc0.922,0.727,0.953,1.59,0.953,1.59C47.594,43.668,47.336,43.923,46.704,44.438z M49.37,35.657c-0.479,0-0.927-0.138-1.308-0.37\r\n\t\t\t\th-0.002c-13.899-8.339-29.991-4.409-32.001-3.857l-1.028,0.202c-1.388,0-2.403-1.126-2.403-2.515c0-1.163,0.824-2.138,1.91-2.426\r\n\t\t\t\tc1.087-0.24,19.256-6.003,35.915,3.523h0.008c0.912,0.428,1.419,1.6,1.419,2.593C51.88,34.195,50.758,35.657,49.37,35.657z\r\n\t\t\t\t M53.583,26.042c0,0-0.853-0.014-1.71-0.531c-15.635-9.777-37.295-4.184-37.513-4.126l-0.008-0.005\r\n\t\t\t\tc-0.244,0.064-0.511,0.101-0.774,0.101c-1.655,0-2.962-1.341-2.962-2.996c0-1.434,0.727-2.631,2.358-2.926\r\n\t\t\t\tc1.087-0.259,24.236-6.181,42.042,4.852c0.934,0.507,1.565,1.497,1.565,2.635C56.581,24.7,55.236,26.042,53.583,26.042z"},"children":[{"name":"path","attribs":{"d":"M26.671,55.675c-4.217,0-7.496,1.354-10.156,4.239c4.795,2.869,9.491,4.079,15.486,4.079\r\n\t\t\t\tc3.087,0,4.405-0.132,7.229-0.948C36.949,58.527,32.591,55.675,26.671,55.675z M32.001,0.008\r\n\t\t\t\tc-17.67,0-31.993,14.323-31.993,31.993c0,8.224,3.103,15.72,8.202,21.388c4.778-4.399,11.291-7.104,18.462-7.104\r\n\t\t\t\tc9.749,0,18.284,4.995,22.893,12.458c8.69-5.721,14.43-15.561,14.43-26.742C63.992,14.331,49.669,0.008,32.001,0.008z\r\n\t\t\t\t M46.704,44.438c-1.112,0.906-2.201,0.064-2.201,0.064c-10.883-8.335-27.994-3.798-27.994-3.754l-0.256,0.072\r\n\t\t\t\tc-1.149,0-1.937-1.215-1.937-2.362c0,0-0.069-1.319,1.788-1.937c0.713-0.131,18.112-3.926,30.539,4.408\r\n\t\t\t\tc0.922,0.727,0.953,1.59,0.953,1.59C47.594,43.668,47.336,43.923,46.704,44.438z M49.37,35.657c-0.479,0-0.927-0.138-1.308-0.37\r\n\t\t\t\th-0.002c-13.899-8.339-29.991-4.409-32.001-3.857l-1.028,0.202c-1.388,0-2.403-1.126-2.403-2.515c0-1.163,0.824-2.138,1.91-2.426\r\n\t\t\t\tc1.087-0.24,19.256-6.003,35.915,3.523h0.008c0.912,0.428,1.419,1.6,1.419,2.593C51.88,34.195,50.758,35.657,49.37,35.657z\r\n\t\t\t\t M53.583,26.042c0,0-0.853-0.014-1.71-0.531c-15.635-9.777-37.295-4.184-37.513-4.126l-0.008-0.005\r\n\t\t\t\tc-0.244,0.064-0.511,0.101-0.774,0.101c-1.655,0-2.962-1.341-2.962-2.996c0-1.434,0.727-2.631,2.358-2.926\r\n\t\t\t\tc1.087-0.259,24.236-6.181,42.042,4.852c0.934,0.507,1.565,1.497,1.565,2.635C56.581,24.7,55.236,26.042,53.583,26.042z"},"children":[]}]}]}]}]}]}]}]};exports.spotify=spotify;var square={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE"},"children":[{"name":"g","attribs":{"id":"SQUARE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz"},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz"},"children":[]}]}]}]}]}]}]}]};exports.square=square;var square_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M19,35h10v10c0,1.657,1.343,3,3,3s3-1.343,3-3V35h10c1.657,0,3-1.343,3-3s-1.343-3-3-3H35V19c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3S17.343,35,19,35z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"d":"M19,35h10v10c0,1.657,1.343,3,3,3s3-1.343,3-3V35h10c1.657,0,3-1.343,3-3s-1.343-3-3-3H35V19c0-1.657-1.343-3-3-3\r\n\t\t\t\ts-3,1.343-3,3v10H19c-1.657,0-3,1.343-3,3S17.343,35,19,35z M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]}]};exports.square_add=square_add;var square_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DASHED"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,59.343,38.657,58,37,58z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001\r\n\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0\r\n\t\t\tv12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v10C0,38.657,1.343,40,3,40z M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M64,37V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3C62.657,40,64,38.657,64,37z M37,0H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,1.344,38.657,0,37,0z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,59.343,38.657,58,37,58z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001\r\n\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0\r\n\t\t\tv12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v10C0,38.657,1.343,40,3,40z M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M64,37V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3C62.657,40,64,38.657,64,37z M37,0H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,1.344,38.657,0,37,0z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[]}]}]}]}]}]};exports.square_dashed=square_dashed;var square_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M18,43c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243l8.879,8.879C41.422,45.664,42.172,46,43,46\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878C45.664,22.579,46,21.829,46,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879C22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879C18.336,41.422,18,42.172,18,43z M61,0H3C1.343,0,0,1.343,0,3v58\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"d":"M18,43c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L32,36.243l8.879,8.879C41.422,45.664,42.172,46,43,46\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L36.243,32l8.879-8.878C45.664,22.579,46,21.829,46,21c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L32,27.758l-8.879-8.879C22.579,18.336,21.828,18,21,18c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L27.757,32l-8.879,8.879C18.336,41.422,18,42.172,18,43z M61,0H3C1.343,0,0,1.343,0,3v58\r\n\t\t\t\tc0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]}]};exports.square_delete=square_delete;var square_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__DOWN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3\r\n\t\t\tl0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M27,6h10c1.657,0,3-1.343,3-3\r\n\t\t\tc0-1.657-1.343-3-3-3H27c-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10\r\n\t\t\tc1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M41,32c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007L35,37.182V19c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v18.182l-3.77-4.189l-0.008,0.007c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0.772,0.3,1.468,0.778,2l-0.008,0.007l9,10L29.778,47c0.549,0.61,1.336,1,2.222,1s1.673-0.391,2.222-1l0.008,0.007l9-10\r\n\t\t\tL43.222,37C43.701,36.468,44,35.772,44,35C44,33.344,42.657,32,41,32z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M61,40\r\n\t\t\tc1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10C58,38.657,59.343,40,61,40z M61,46c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3\r\n\t\t\tl0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M27,6h10c1.657,0,3-1.343,3-3\r\n\t\t\tc0-1.657-1.343-3-3-3H27c-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10\r\n\t\t\tc1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M41,32c-0.885,0-1.673,0.391-2.222,1l-0.008-0.007L35,37.182V19c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v18.182l-3.77-4.189l-0.008,0.007c-0.549-0.61-1.337-1-2.222-1c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0.772,0.3,1.468,0.778,2l-0.008,0.007l9,10L29.778,47c0.549,0.61,1.336,1,2.222,1s1.673-0.391,2.222-1l0.008,0.007l9-10\r\n\t\t\tL43.222,37C43.701,36.468,44,35.772,44,35C44,33.344,42.657,32,41,32z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M61,40\r\n\t\t\tc1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10C58,38.657,59.343,40,61,40z M61,46c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[]}]}]}]}]}]};exports.square_down=square_down;var square_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__LEFT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27c-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z\r\n\t\t\t M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0\r\n\t\t\tC0,16.657,1.343,18,3,18z M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\tC18,59.343,16.657,58,15,58z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15\r\n\t\t\tc0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M37,58H27c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M64,37V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3S64,38.657,64,37z M48,32c0-1.657-1.343-3-3-3H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222\r\n\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L17,29.779c-0.61,0.549-1,1.337-1,2.222\r\n\t\t\tc0,0.885,0.391,1.673,1,2.222l-0.007,0.008l10,9L27,43.222C27.532,43.701,28.229,44,29,44c1.657,0,3-1.343,3-3\r\n\t\t\tc0-0.885-0.391-1.673-1-2.222l0.007-0.008L26.818,35H45C46.657,35,48,33.657,48,32z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27c-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z\r\n\t\t\t M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0\r\n\t\t\tC0,16.657,1.343,18,3,18z M15,58H6v-9c0-1.657-1.343-3-3-3s-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3\r\n\t\t\tC18,59.343,16.657,58,15,58z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15\r\n\t\t\tc0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M37,58H27c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M64,37V27c0-1.657-1.343-3-3-3s-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3S64,38.657,64,37z M48,32c0-1.657-1.343-3-3-3H26.818l4.189-3.77L31,25.222c0.61-0.549,1-1.337,1-2.222\r\n\t\t\tc0-1.657-1.343-3-3-3c-0.772,0-1.468,0.3-2,0.778l-0.007-0.008l-10,9L17,29.779c-0.61,0.549-1,1.337-1,2.222\r\n\t\t\tc0,0.885,0.391,1.673,1,2.222l-0.007,0.008l10,9L27,43.222C27.532,43.701,28.229,44,29,44c1.657,0,3-1.343,3-3\r\n\t\t\tc0-0.885-0.391-1.673-1-2.222l0.007-0.008L26.818,35H45C46.657,35,48,33.657,48,32z"},"children":[]}]}]}]}]}]};exports.square_left=square_left;var square_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__OK"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46,20.999v0.002C46,21.001,46,21.001,46,20.999C46,21,46,21,46,20.999z M46,43.001C46,43.001,46,43,46,43.001\r\n\t\t\t\tC46,43,46,43,46,42.999V43.001z M25.879,42.121C26.422,42.664,27.172,43,28,43s1.578-0.336,2.121-0.879l16-16\r\n\t\t\t\tC46.664,25.579,47,24.828,47,24c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L28,35.757l-6.879-6.879\r\n\t\t\t\tC20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L25.879,42.121z M61,0H3\r\n\t\t\t\tC1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[{"name":"path","attribs":{"d":"M46,20.999v0.002C46,21.001,46,21.001,46,20.999C46,21,46,21,46,20.999z M46,43.001C46,43.001,46,43,46,43.001\r\n\t\t\t\tC46,43,46,43,46,42.999V43.001z M25.879,42.121C26.422,42.664,27.172,43,28,43s1.578-0.336,2.121-0.879l16-16\r\n\t\t\t\tC46.664,25.579,47,24.828,47,24c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L28,35.757l-6.879-6.879\r\n\t\t\t\tC20.578,28.336,19.828,28,19,28c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L25.879,42.121z M61,0H3\r\n\t\t\t\tC1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58z"},"children":[]}]}]}]}]}]}]}]};exports.square_ok=square_ok;var square_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"SQUARE__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz M19,35h26c1.657,0,3-1.343,3-3s-1.343-3-3-3H19c-1.657,0-3,1.343-3,3S17.343,35,19,35z"},"children":[{"name":"path","attribs":{"d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3C64,1.343,62.657,0,61,0z M58,58H6V6h52V58\r\n\t\t\t\tz M19,35h26c1.657,0,3-1.343,3-3s-1.343-3-3-3H19c-1.657,0-3,1.343-3,3S17.343,35,19,35z"},"children":[]}]}]}]}]}]}]}]};exports.square_remove=square_remove;var square_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__RIGHT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3\r\n\t\t\tC1.343,0,0,1.344,0,3v12c0,0,0,0,0,0C0,16.657,1.343,18,3,18z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27\r\n\t\t\tc-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M32.993,38.771l0.007,0.008c-0.61,0.549-1,1.337-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\tc0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9L47,34.222c0.61-0.549,1-1.337,1-2.222c0-0.885-0.391-1.672-1-2.222l0.007-0.008\r\n\t\t\tl-10-9L37,20.779C36.468,20.3,35.772,20,35,20c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L37.182,29H19\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182L32.993,38.771z M64,37V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3C62.657,40,64,38.657,64,37z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15\r\n\t\t\tc0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M37,58H27c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tC0,38.657,1.343,40,3,40z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0v12c0,1.657,1.343,3,3,3h12\r\n\t\t\tc1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M3,18c1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H3\r\n\t\t\tC1.343,0,0,1.344,0,3v12c0,0,0,0,0,0C0,16.657,1.343,18,3,18z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27\r\n\t\t\tc-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M32.993,38.771l0.007,0.008c-0.61,0.549-1,1.337-1,2.222c0,1.657,1.343,3,3,3\r\n\t\t\tc0.772,0,1.468-0.299,2-0.778l0.007,0.008l10-9L47,34.222c0.61-0.549,1-1.337,1-2.222c0-0.885-0.391-1.672-1-2.222l0.007-0.008\r\n\t\t\tl-10-9L37,20.779C36.468,20.3,35.772,20,35,20c-1.657,0-3,1.343-3,3c0,0.885,0.391,1.673,1,2.222l-0.007,0.008L37.182,29H19\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h18.182L32.993,38.771z M64,37V27c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10\r\n\t\t\tc0,1.657,1.343,3,3,3C62.657,40,64,38.657,64,37z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15\r\n\t\t\tc0,0,0,0,0,0.001c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M37,58H27c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3C40,59.343,38.657,58,37,58z M61,46c-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49C64,47.343,62.657,46,61,46z"},"children":[]}]}]}]}]}]};exports.square_right=square_right;var square_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SQUARE__x2F__UP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v10C0,38.657,1.343,40,3,40z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0v12\r\n\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27\r\n\t\t\tc-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,59.343,38.657,58,37,58z M61,24c-1.657,0-3,1.343-3,3v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V27\r\n\t\t\tC64,25.343,62.657,24,61,24z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001\r\n\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M43.23,26.994l-9-10l-0.008,0.007\r\n\t\t\tc-0.549-0.61-1.336-1-2.222-1c-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10l0.008,0.007C20.3,27.532,20,28.229,20,29\r\n\t\t\tc0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V26.818\r\n\t\t\tl3.77,4.189L38.778,31c0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.778-2L43.23,26.994z M61,46\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49\r\n\t\t\tC64,47.343,62.657,46,61,46z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15,0H3C1.343,0,0,1.344,0,3v12c0,0,0,0,0,0c0,1.657,1.343,3,3,3\r\n\t\t\tc1.657,0,3-1.343,3-3V6h9v0c1.657,0,3-1.343,3-3C18,1.344,16.657,0,15,0z M3,40c1.657,0,3-1.343,3-3V27c0-1.657-1.343-3-3-3\r\n\t\t\tc-1.657,0-3,1.343-3,3v10C0,38.657,1.343,40,3,40z M15,58H6v-9c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3l0,0v12\r\n\t\t\tc0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3C18,59.343,16.657,58,15,58z M27,6h10c1.657,0,3-1.343,3-3c0-1.657-1.343-3-3-3H27\r\n\t\t\tc-1.657,0-3,1.343-3,3C24,4.657,25.343,6,27,6z M37,58H27c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10c1.657,0,3-1.343,3-3\r\n\t\t\tC40,59.343,38.657,58,37,58z M61,24c-1.657,0-3,1.343-3,3v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V27\r\n\t\t\tC64,25.343,62.657,24,61,24z M61,0H49c0,0,0,0,0,0c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3v0h9V15c0,0,0,0,0,0.001\r\n\t\t\tc0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V3C64,1.344,62.657,0,61,0z M43.23,26.994l-9-10l-0.008,0.007\r\n\t\t\tc-0.549-0.61-1.336-1-2.222-1c-0.885,0-1.672,0.391-2.222,1l-0.008-0.007l-9,10l0.008,0.007C20.3,27.532,20,28.229,20,29\r\n\t\t\tc0,1.657,1.343,3,3,3c0.885,0,1.673-0.391,2.222-1l0.008,0.007L29,26.818V45c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V26.818\r\n\t\t\tl3.77,4.189L38.778,31c0.549,0.61,1.337,1,2.222,1c1.657,0,3-1.343,3-3c0-0.772-0.3-1.468-0.778-2L43.23,26.994z M61,46\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,0,0,0,0,0v9h-9c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3V49\r\n\t\t\tC64,47.343,62.657,46,61,46z"},"children":[]}]}]}]}]}]};exports.square_up=square_up;var star={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"STAR_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"STAR"},"children":[{"name":"g","attribs":{"id":"STAR"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,26c0-1.657-1.343-3-3-3H41.047L34.869,4.12C34.492,2.893,33.352,2,32,2c-1.35,0-2.492,0.892-2.868,2.12L22.953,23H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1,0.49,1.885,1.242,2.43l0,0L17.36,40.09l-6.209,18.971C11.053,59.357,11,59.672,11,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.657,0,1.263-0.213,1.758-0.57h0.001L32,50.682L48.242,62.43h0.001C48.736,62.788,49.343,63,50,63\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.328-0.053-0.643-0.15-0.938L46.641,40.09l16.118-11.66l0,0C63.51,27.885,64,27,64,26z"},"children":[{"name":"path","attribs":{"d":"M64,26c0-1.657-1.343-3-3-3H41.047L34.869,4.12C34.492,2.893,33.352,2,32,2c-1.35,0-2.492,0.892-2.868,2.12L22.953,23H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,1,0.49,1.885,1.242,2.43l0,0L17.36,40.09l-6.209,18.971C11.053,59.357,11,59.672,11,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3c0.657,0,1.263-0.213,1.758-0.57h0.001L32,50.682L48.242,62.43h0.001C48.736,62.788,49.343,63,50,63\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.328-0.053-0.643-0.15-0.938L46.641,40.09l16.118-11.66l0,0C63.51,27.885,64,27,64,26z"},"children":[]}]}]}]}]}]}]}]};exports.star=star;var stop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"STOP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"STOP"},"children":[{"name":"g","attribs":{"id":"STOP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21C46,19.343,44.657,18,43,18z"},"children":[{"name":"path","attribs":{"d":"M43,18H21c-1.657,0-3,1.343-3,3v22c0,1.657,1.343,3,3,3h22c1.657,0,3-1.343,3-3V21C46,19.343,44.657,18,43,18z"},"children":[]}]}]}]}]}]}]}]};exports.stop=stop;var suitcase={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"SUITCASE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"SUITCASE"},"children":[{"name":"g","attribs":{"id":"SUITCASE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,21v37c0,1.657,1.343,3,3,3h5V18H3C1.343,18,0,19.343,0,21z M32,3c-8.284,0-15,6.716-15,15h-6v43h42V18h-6\r\n\t\t\t\tC47,9.716,40.284,3,32,3z M23,18c0-4.971,4.029-9,9-9c4.971,0,9,4.029,9,9H23z M61,18h-5v43h5c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC64,19.343,62.657,18,61,18z"},"children":[{"name":"path","attribs":{"d":"M0,21v37c0,1.657,1.343,3,3,3h5V18H3C1.343,18,0,19.343,0,21z M32,3c-8.284,0-15,6.716-15,15h-6v43h42V18h-6\r\n\t\t\t\tC47,9.716,40.284,3,32,3z M23,18c0-4.971,4.029-9,9-9c4.971,0,9,4.029,9,9H23z M61,18h-5v43h5c1.657,0,3-1.343,3-3V21\r\n\t\t\t\tC64,19.343,62.657,18,61,18z"},"children":[]}]}]}]}]}]}]}]};exports.suitcase=suitcase;var tag={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TAG_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TAG"},"children":[{"name":"g","attribs":{"id":"TAG"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56,33c0-0.018-0.002-0.033-0.003-0.049c-0.001-0.087-0.004-0.174-0.013-0.258c-0.002-0.017-0.006-0.031-0.008-0.047\r\n\t\t\t\tc-0.01-0.084-0.021-0.169-0.039-0.252c0-0.002,0-0.003,0-0.005c-0.123-0.594-0.422-1.123-0.84-1.531L32.126,8.884\r\n\t\t\t\tC31.582,8.338,30.831,8,30,8c-0.003,0-0.005,0.001-0.008,0.001V7.993H11V8c-1.657,0-3,1.343-3,3H7.993v19.049h0.013\r\n\t\t\t\tc0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.006-0.005c0.395,0.348,0.879,0.592,1.418,0.693\r\n\t\t\t\tc0.021,0.005,0.045,0.008,0.067,0.011c0.067,0.011,0.134,0.022,0.202,0.028C35.807,55.995,35.902,56,36,56\r\n\t\t\t\tc0.916,0,1.734-0.411,2.284-1.059l0.001,0.002l17-20l-0.001-0.002C55.73,34.418,56,33.741,56,33z M16,20c-2.209,0-4-1.791-4-4\r\n\t\t\t\ts1.791-4,4-4s4,1.791,4,4S18.209,20,16,20z"},"children":[{"name":"path","attribs":{"d":"M56,33c0-0.018-0.002-0.033-0.003-0.049c-0.001-0.087-0.004-0.174-0.013-0.258c-0.002-0.017-0.006-0.031-0.008-0.047\r\n\t\t\t\tc-0.01-0.084-0.021-0.169-0.039-0.252c0-0.002,0-0.003,0-0.005c-0.123-0.594-0.422-1.123-0.84-1.531L32.126,8.884\r\n\t\t\t\tC31.582,8.338,30.831,8,30,8c-0.003,0-0.005,0.001-0.008,0.001V7.993H11V8c-1.657,0-3,1.343-3,3H7.993v19.049h0.013\r\n\t\t\t\tc0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.006-0.005c0.395,0.348,0.879,0.592,1.418,0.693\r\n\t\t\t\tc0.021,0.005,0.045,0.008,0.067,0.011c0.067,0.011,0.134,0.022,0.202,0.028C35.807,55.995,35.902,56,36,56\r\n\t\t\t\tc0.916,0,1.734-0.411,2.284-1.059l0.001,0.002l17-20l-0.001-0.002C55.73,34.418,56,33.741,56,33z M16,20c-2.209,0-4-1.791-4-4\r\n\t\t\t\ts1.791-4,4-4s4,1.791,4,4S18.209,20,16,20z"},"children":[]}]}]}]}]}]}]}]};exports.tag=tag;var tags={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TAGS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TAGS"},"children":[{"name":"g","attribs":{"id":"TAGS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56.113,26.872l-5.133-4.91c-0.006,0.009-0.012,0.019-0.017,0.028L34.126,5.884C33.582,5.338,32.831,5,32,5\r\n\t\t\t\tc-0.003,0-0.005,0.001-0.008,0.001V4.993H13V5c-1.657,0-3,1.343-3,3h22l24.081,23.155L56.3,30.9l0.002,0.001\r\n\t\t\t\tC56.73,30.383,57,29.726,57,29C57,28.168,56.66,27.415,56.113,26.872z M54.997,35.951c-0.001-0.087-0.004-0.174-0.013-0.26\r\n\t\t\t\tc-0.002-0.016-0.006-0.03-0.008-0.045c-0.01-0.086-0.021-0.17-0.039-0.254c0-0.002,0-0.002,0-0.004\r\n\t\t\t\tc-0.123-0.594-0.422-1.123-0.84-1.531L31.126,11.884C30.582,11.338,29.831,11,29,11c-0.003,0-0.005,0.001-0.008,0.001v-0.008H10\r\n\t\t\t\tV11c-1.657,0-3,1.343-3,3H6.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.006-0.005\r\n\t\t\t\tc0.395,0.348,0.879,0.594,1.418,0.693c0.021,0.005,0.045,0.008,0.067,0.011c0.067,0.011,0.134,0.022,0.202,0.028\r\n\t\t\t\tC34.807,58.995,34.902,59,35,59c0.916,0,1.734-0.411,2.284-1.059l0.001,0.002l17-20l-0.001-0.002C54.73,37.418,55,36.741,55,36\r\n\t\t\t\tC55,35.984,54.998,35.968,54.997,35.951z M15,23c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S17.209,23,15,23z"},"children":[{"name":"path","attribs":{"d":"M56.113,26.872l-5.133-4.91c-0.006,0.009-0.012,0.019-0.017,0.028L34.126,5.884C33.582,5.338,32.831,5,32,5\r\n\t\t\t\tc-0.003,0-0.005,0.001-0.008,0.001V4.993H13V5c-1.657,0-3,1.343-3,3h22l24.081,23.155L56.3,30.9l0.002,0.001\r\n\t\t\t\tC56.73,30.383,57,29.726,57,29C57,28.168,56.66,27.415,56.113,26.872z M54.997,35.951c-0.001-0.087-0.004-0.174-0.013-0.26\r\n\t\t\t\tc-0.002-0.016-0.006-0.03-0.008-0.045c-0.01-0.086-0.021-0.17-0.039-0.254c0-0.002,0-0.002,0-0.004\r\n\t\t\t\tc-0.123-0.594-0.422-1.123-0.84-1.531L31.126,11.884C30.582,11.338,29.831,11,29,11c-0.003,0-0.005,0.001-0.008,0.001v-0.008H10\r\n\t\t\t\tV11c-1.657,0-3,1.343-3,3H6.993v19.049h0.013c0.015,0.878,0.409,1.657,1.023,2.196l-0.011,0.012l25,23l0.006-0.005\r\n\t\t\t\tc0.395,0.348,0.879,0.594,1.418,0.693c0.021,0.005,0.045,0.008,0.067,0.011c0.067,0.011,0.134,0.022,0.202,0.028\r\n\t\t\t\tC34.807,58.995,34.902,59,35,59c0.916,0,1.734-0.411,2.284-1.059l0.001,0.002l17-20l-0.001-0.002C54.73,37.418,55,36.741,55,36\r\n\t\t\t\tC55,35.984,54.998,35.968,54.997,35.951z M15,23c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4S17.209,23,15,23z"},"children":[]}]}]}]}]}]}]}]};exports.tags=tags;var target={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TARGET_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TARGET"},"children":[{"name":"g","attribs":{"id":"TARGET"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,29c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S33.657,29,32,29z M61,29h-3.186\r\n\t\t\t\tC56.438,17.042,46.956,7.569,35,6.191V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186C17.042,7.562,7.568,17.044,6.191,29H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h3.186C7.562,46.958,17.044,56.432,29,57.809V61c0,1.657,1.343,3,3,3s3-1.343,3-3v-3.191\r\n\t\t\t\tC46.956,56.432,56.438,46.958,57.814,35H61c1.657,0,3-1.343,3-3S62.657,29,61,29z M46,35h5.751\r\n\t\t\t\tC50.448,43.639,43.634,50.453,35,51.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.756C20.366,50.453,13.552,43.639,12.249,35H18\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-5.756C13.547,20.366,20.362,13.552,29,12.249V18c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.756\r\n\t\t\t\tC43.634,13.547,50.448,20.362,51.751,29H46c-1.657,0-3,1.343-3,3S44.343,35,46,35z"},"children":[{"name":"path","attribs":{"d":"M32,29c-1.657,0-3,1.343-3,3s1.343,3,3,3s3-1.343,3-3S33.657,29,32,29z M61,29h-3.186\r\n\t\t\t\tC56.438,17.042,46.956,7.569,35,6.191V3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3.186C17.042,7.562,7.568,17.044,6.191,29H3\r\n\t\t\t\tc-1.657,0-3,1.343-3,3s1.343,3,3,3h3.186C7.562,46.958,17.044,56.432,29,57.809V61c0,1.657,1.343,3,3,3s3-1.343,3-3v-3.191\r\n\t\t\t\tC46.956,56.432,56.438,46.958,57.814,35H61c1.657,0,3-1.343,3-3S62.657,29,61,29z M46,35h5.751\r\n\t\t\t\tC50.448,43.639,43.634,50.453,35,51.757V46c0-1.657-1.343-3-3-3s-3,1.343-3,3v5.756C20.366,50.453,13.552,43.639,12.249,35H18\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3h-5.756C13.547,20.366,20.362,13.552,29,12.249V18c0,1.657,1.343,3,3,3s3-1.343,3-3v-5.756\r\n\t\t\t\tC43.634,13.547,50.448,20.362,51.751,29H46c-1.657,0-3,1.343-3,3S44.343,35,46,35z"},"children":[]}]}]}]}]}]}]}]};exports.target=target;var terminal={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TERMINAL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,32c0-0.002,0-0.005,0-0.007c0-0.002,0-0.005,0-0.007\r\n\t\t\tc0-0.848-0.352-1.613-0.918-2.159l0.001-0.001l-18-18l-0.008,0.008C10.536,11.318,9.806,11,9,11c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0.91,0.406,1.725,1.046,2.275l15.718,15.718L6.84,47.917l0.001,0.001C6.321,48.458,6,49.191,6,50c0,1.657,1.343,3,3,3\r\n\t\t\tc0.809,0,1.543-0.321,2.082-0.841l0.001,0.001l18-18l-0.001-0.001C29.648,33.613,30,32.848,30,32z M55.5,47h-23\r\n\t\t\tc-1.381,0-2.5,1.119-2.5,2.5v1c0,1.381,1.119,2.5,2.5,2.5h23c1.381,0,2.5-1.119,2.5-2.5v-1C58,48.119,56.881,47,55.5,47z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M30,32c0-0.002,0-0.005,0-0.007c0-0.002,0-0.005,0-0.007\r\n\t\t\tc0-0.848-0.352-1.613-0.918-2.159l0.001-0.001l-18-18l-0.008,0.008C10.536,11.318,9.806,11,9,11c-1.657,0-3,1.343-3,3\r\n\t\t\tc0,0.91,0.406,1.725,1.046,2.275l15.718,15.718L6.84,47.917l0.001,0.001C6.321,48.458,6,49.191,6,50c0,1.657,1.343,3,3,3\r\n\t\t\tc0.809,0,1.543-0.321,2.082-0.841l0.001,0.001l18-18l-0.001-0.001C29.648,33.613,30,32.848,30,32z M55.5,47h-23\r\n\t\t\tc-1.381,0-2.5,1.119-2.5,2.5v1c0,1.381,1.119,2.5,2.5,2.5h23c1.381,0,2.5-1.119,2.5-2.5v-1C58,48.119,56.881,47,55.5,47z"},"children":[]}]}]}]}]}]};exports.terminal=terminal;var text_center={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TEXT__x2F__CENTER_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__CENTER"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__CENTER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M15,21c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h5.999c0,0,0,0,0.001,0h22c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H15z M61,37H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,37,61,37z M43,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h22c1.657,0,3-1.343,3-3\r\n\t\t\t\tS44.657,53,43,53z"},"children":[{"name":"path","attribs":{"d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M15,21c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h5.999c0,0,0,0,0.001,0h22c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H15z M61,37H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,37,61,37z M43,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h22c1.657,0,3-1.343,3-3\r\n\t\t\t\tS44.657,53,43,53z"},"children":[]}]}]}]}]}]}]}]};exports.text_center=text_center;var text_justify={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__JUSTIFY"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,53H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,53,61,53z M61,21H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,21,61,21z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,37,61,37z"},"children":[{"name":"path","attribs":{"d":"M3,11h58c1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,53H3c-1.657,0-3,1.343-3,3\r\n\t\t\t\ts1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,53,61,53z M61,21H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,21,61,21z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3S62.657,37,61,37z"},"children":[]}]}]}]}]}]}]}]};exports.text_justify=text_justify;var text_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TEXT__x2F__LEFT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__LEFT"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__LEFT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M3,27h40c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3S1.343,27,3,27z M3,11h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,37,61,37z M43,53H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[{"name":"path","attribs":{"d":"M3,27h40c0,0,0,0,0.001,0H49c1.657,0,3-1.343,3-3s-1.343-3-3-3H3c-1.657,0-3,1.343-3,3S1.343,27,3,27z M3,11h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3s-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58\r\n\t\t\t\tc1.657,0,3-1.343,3-3S62.657,37,61,37z M43,53H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S44.657,53,43,53z"},"children":[]}]}]}]}]}]}]}]};exports.text_left=text_left;var text_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT"},"children":[{"name":"g","attribs":{"id":"TEXT__x2F__RIGHT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M61,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S62.657,53,61,53z M3,11h58c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,37,61,37z M61,21H15c-1.657,0-3,1.343-3,3s1.343,3,3,3h5.999c0,0,0,0,0.001,0h40c1.657,0,3-1.343,3-3S62.657,21,61,21z"},"children":[{"name":"path","attribs":{"d":"M61,53H21c-1.657,0-3,1.343-3,3s1.343,3,3,3h40c1.657,0,3-1.343,3-3S62.657,53,61,53z M3,11h58c1.657,0,3-1.343,3-3\r\n\t\t\t\ts-1.343-3-3-3H3C1.343,5,0,6.343,0,8S1.343,11,3,11z M61,37H3c-1.657,0-3,1.343-3,3s1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tS62.657,37,61,37z M61,21H15c-1.657,0-3,1.343-3,3s1.343,3,3,3h5.999c0,0,0,0,0.001,0h40c1.657,0,3-1.343,3-3S62.657,21,61,21z"},"children":[]}]}]}]}]}]}]}]};exports.text_right=text_right;var tick={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TICK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TICK"},"children":[{"name":"g","attribs":{"id":"TICK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50,18c-0.828,0-1.578,0.336-2.121,0.879L27,39.757L16.121,28.879C15.578,28.336,14.828,28,14,28c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l13,13C25.422,46.664,26.172,47,27,47s1.578-0.336,2.121-0.879l23-23\r\n\t\t\t\tC52.664,22.579,53,21.828,53,21C53,19.343,51.657,18,50,18z"},"children":[{"name":"path","attribs":{"d":"M50,18c-0.828,0-1.578,0.336-2.121,0.879L27,39.757L16.121,28.879C15.578,28.336,14.828,28,14,28c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121l13,13C25.422,46.664,26.172,47,27,47s1.578-0.336,2.121-0.879l23-23\r\n\t\t\t\tC52.664,22.579,53,21.828,53,21C53,19.343,51.657,18,50,18z"},"children":[]}]}]}]}]}]}]}]};exports.tick=tick;var time={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TIME_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"TIME"},"children":[{"name":"g","attribs":{"id":"TIME"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,29H35V14c0-1.657-1.343-3-3-3s-3,1.343-3,3v18c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[{"name":"path","attribs":{"d":"M45,29H35V14c0-1.657-1.343-3-3-3s-3,1.343-3,3v18c0,1.657,1.343,3,3,3h13c1.657,0,3-1.343,3-3S46.657,29,45,29z M32,0\r\n\t\t\t\tC14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.359,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.64,26,26C58,46.359,46.359,58,32,58z"},"children":[]}]}]}]}]}]}]}]};exports.time=time;var timer={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"TIMER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.129,16l-5.534,21.23c0,0-2.594,8.77,5.391,8.77c0,0,8.015-0.125,5.479-8.685\r\n\t\t\tL32.129,16z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32\r\n\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M32.129,16l-5.534,21.23c0,0-2.594,8.77,5.391,8.77c0,0,8.015-0.125,5.479-8.685\r\n\t\t\tL32.129,16z M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M32,58C17.641,58,6,46.36,6,32\r\n\t\t\tC6,17.641,17.641,6,32,6c14.359,0,26,11.64,26,26C58,46.36,46.36,58,32,58z"},"children":[]}]}]}]}]}]};exports.timer=timer;var tumblr={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"tumblr_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"tumblr"},"children":[{"name":"g","attribs":{"id":"tumblr"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M42.41,53.584c-1.816,0-3.424-0.428-4.834-1.275c-1.062-0.629-2.039-1.718-2.428-2.767\r\n\t\t\t\tc-0.392-1.049-0.344-3.19-0.344-6.905V26.215h14.729V14.788H34.807V-0.028h-9.062c-0.405,3.308-1.15,6.026-2.231,8.16\r\n\t\t\t\tc-1.08,2.142-2.508,3.973-4.3,5.502c-1.78,1.525-4.681,2.699-7.184,3.513v9.068h8.654V48.67c0,2.934,0.305,5.167,0.915,6.708\r\n\t\t\t\tc0.614,1.537,1.706,2.997,3.291,4.368c1.577,1.359,3.487,2.42,5.725,3.162c2.238,0.734,3.955,1.101,6.869,1.101\r\n\t\t\t\tc2.565,0,4.951-0.258,7.16-0.778c2.207-0.521,4.674-1.429,7.395-2.711V50.419C48.844,52.527,45.637,53.584,42.41,53.584z"},"children":[{"name":"path","attribs":{"d":"M42.41,53.584c-1.816,0-3.424-0.428-4.834-1.275c-1.062-0.629-2.039-1.718-2.428-2.767\r\n\t\t\t\tc-0.392-1.049-0.344-3.19-0.344-6.905V26.215h14.729V14.788H34.807V-0.028h-9.062c-0.405,3.308-1.15,6.026-2.231,8.16\r\n\t\t\t\tc-1.08,2.142-2.508,3.973-4.3,5.502c-1.78,1.525-4.681,2.699-7.184,3.513v9.068h8.654V48.67c0,2.934,0.305,5.167,0.915,6.708\r\n\t\t\t\tc0.614,1.537,1.706,2.997,3.291,4.368c1.577,1.359,3.487,2.42,5.725,3.162c2.238,0.734,3.955,1.101,6.869,1.101\r\n\t\t\t\tc2.565,0,4.951-0.258,7.16-0.778c2.207-0.521,4.674-1.429,7.395-2.711V50.419C48.844,52.527,45.637,53.584,42.41,53.584z"},"children":[]}]}]}]}]}]}]}]};exports.tumblr=tumblr;var twitter={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"twitter_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"twitter"},"children":[{"name":"g","attribs":{"id":"twitter"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56.568,14.179v-0.032c0.558-0.218,0.998-0.68,1.441-1.022c2-1.541,3.301-3.57,4.26-6.164\r\n\t\t\t\tc-0.543,0.298-1.088,0.596-1.633,0.894c-1.681,0.853-4.533,2.079-6.728,2.267c-2.586-2.356-5.292-4.209-10.378-4.12\r\n\t\t\t\tc-0.534,0.064-1.068,0.128-1.602,0.192c-1.037,0.227-2.025,0.508-2.916,0.894c-3.724,1.616-6.263,4.631-7.431,8.814\r\n\t\t\t\tc-0.465,1.664-0.654,4.445-0.064,6.164c-2.101-0.003-4.135-0.334-5.894-0.767C18.69,19.594,14.372,17.29,9.578,13.54\r\n\t\t\t\tC8.17,12.439,6.789,11.191,5.67,9.804C5.309,9.357,4.74,8.965,4.485,8.43C4.463,8.42,4.442,8.409,4.421,8.398\r\n\t\t\t\tc-0.557,1.032-1.08,2.15-1.409,3.417c-1.3,4.994,0.755,9.188,2.947,11.912c0.664,0.826,1.741,1.338,2.402,2.108h0.064\r\n\t\t\t\tc-0.497,0.184-1.361-0.071-1.794-0.16c-1.024-0.211-1.897-0.405-2.755-0.766c-0.448-0.213-0.897-0.426-1.345-0.639\r\n\t\t\t\tc-0.021,5.517,2.766,9.103,6.182,11.241c1.114,0.697,2.672,1.636,4.292,1.724c-0.867,0.732-4.575,0.396-5.862,0.256\r\n\t\t\t\tc1.609,4.142,4.081,6.9,8.328,8.398c1.096,0.387,2.433,0.729,3.908,0.703c-0.783,0.93-2.454,1.688-3.556,2.331\r\n\t\t\t\tc-2.272,1.329-4.91,2.191-7.88,2.843c-1.191,0.26-2.457,0.207-3.748,0.414c-1.427,0.23-2.92-0.121-4.196-0.16\r\n\t\t\t\tc0.384,0.234,0.769,0.47,1.153,0.703c1.171,0.713,2.394,1.338,3.716,1.916c2.379,1.041,4.914,1.826,7.72,2.523\r\n\t\t\t\tc5.658,1.404,13.64,0.773,18.579-0.766c13.754-4.287,22.442-14.293,25.722-29.03c0.564-2.535,0.646-5.414,0.609-8.431\r\n\t\t\t\tc0.684-0.543,1.367-1.086,2.05-1.629c1.693-1.356,3.28-3.246,4.452-5.11v-0.032C61.768,12.864,59.418,14.149,56.568,14.179z"},"children":[{"name":"path","attribs":{"d":"M56.568,14.179v-0.032c0.558-0.218,0.998-0.68,1.441-1.022c2-1.541,3.301-3.57,4.26-6.164\r\n\t\t\t\tc-0.543,0.298-1.088,0.596-1.633,0.894c-1.681,0.853-4.533,2.079-6.728,2.267c-2.586-2.356-5.292-4.209-10.378-4.12\r\n\t\t\t\tc-0.534,0.064-1.068,0.128-1.602,0.192c-1.037,0.227-2.025,0.508-2.916,0.894c-3.724,1.616-6.263,4.631-7.431,8.814\r\n\t\t\t\tc-0.465,1.664-0.654,4.445-0.064,6.164c-2.101-0.003-4.135-0.334-5.894-0.767C18.69,19.594,14.372,17.29,9.578,13.54\r\n\t\t\t\tC8.17,12.439,6.789,11.191,5.67,9.804C5.309,9.357,4.74,8.965,4.485,8.43C4.463,8.42,4.442,8.409,4.421,8.398\r\n\t\t\t\tc-0.557,1.032-1.08,2.15-1.409,3.417c-1.3,4.994,0.755,9.188,2.947,11.912c0.664,0.826,1.741,1.338,2.402,2.108h0.064\r\n\t\t\t\tc-0.497,0.184-1.361-0.071-1.794-0.16c-1.024-0.211-1.897-0.405-2.755-0.766c-0.448-0.213-0.897-0.426-1.345-0.639\r\n\t\t\t\tc-0.021,5.517,2.766,9.103,6.182,11.241c1.114,0.697,2.672,1.636,4.292,1.724c-0.867,0.732-4.575,0.396-5.862,0.256\r\n\t\t\t\tc1.609,4.142,4.081,6.9,8.328,8.398c1.096,0.387,2.433,0.729,3.908,0.703c-0.783,0.93-2.454,1.688-3.556,2.331\r\n\t\t\t\tc-2.272,1.329-4.91,2.191-7.88,2.843c-1.191,0.26-2.457,0.207-3.748,0.414c-1.427,0.23-2.92-0.121-4.196-0.16\r\n\t\t\t\tc0.384,0.234,0.769,0.47,1.153,0.703c1.171,0.713,2.394,1.338,3.716,1.916c2.379,1.041,4.914,1.826,7.72,2.523\r\n\t\t\t\tc5.658,1.404,13.64,0.773,18.579-0.766c13.754-4.287,22.442-14.293,25.722-29.03c0.564-2.535,0.646-5.414,0.609-8.431\r\n\t\t\t\tc0.684-0.543,1.367-1.086,2.05-1.629c1.693-1.356,3.28-3.246,4.452-5.11v-0.032C61.768,12.864,59.418,14.149,56.568,14.179z"},"children":[]}]}]}]}]}]}]}]};exports.twitter=twitter;var unlock={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"UNLOCK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"UNLOCK"},"children":[{"name":"g","attribs":{"id":"UNLOCK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M55,32H20V18c0-6.627,5.373-12,12-12s12,5.373,12,12c0,1.657,1.343,3,3,3s3-1.343,3-3c0-9.941-8.059-18-18-18\r\n\t\t\t\tc-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35\r\n\t\t\t\tC58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,46.215,36.786,48.129,35,49.168z"},"children":[{"name":"path","attribs":{"d":"M55,32H20V18c0-6.627,5.373-12,12-12s12,5.373,12,12c0,1.657,1.343,3,3,3s3-1.343,3-3c0-9.941-8.059-18-18-18\r\n\t\t\t\tc-9.941,0-18,8.059-18,18v14H9c-1.657,0-3,1.343-3,3v26c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V35\r\n\t\t\t\tC58,33.343,56.657,32,55,32z M35,49.168V55c0,1.657-1.343,3-3,3s-3-1.343-3-3v-5.832c-1.786-1.039-3-2.953-3-5.168\r\n\t\t\t\tc0-3.314,2.686-6,6-6c3.314,0,6,2.686,6,6C38,46.215,36.786,48.129,35,49.168z"},"children":[]}]}]}]}]}]}]}]};exports.unlock=unlock;var upload={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"UPLOAD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"UPLOAD"},"children":[{"name":"g","attribs":{"id":"UPLOAD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M23,24c0.885,0,1.681-0.384,2.23-0.993l0,0L29,18.818V37c0,1.657,1.343,3,3,3s3-1.343,3-3l0,0V18.818l3.77,4.189l0,0\r\n\t\t\t\tC39.318,23.617,40.115,24,41,24c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,8.384,32.885,8,32,8\r\n\t\t\t\ts-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,19.525,20,20.228,20,21C20,22.657,21.343,24,23,24z M55,35c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[{"name":"path","attribs":{"d":"M23,24c0.885,0,1.681-0.384,2.23-0.993l0,0L29,18.818V37c0,1.657,1.343,3,3,3s3-1.343,3-3l0,0V18.818l3.77,4.189l0,0\r\n\t\t\t\tC39.318,23.617,40.115,24,41,24c1.657,0,3-1.343,3-3c0-0.772-0.292-1.475-0.77-2.007l0,0l-9-10l0,0C33.682,8.384,32.885,8,32,8\r\n\t\t\t\ts-1.681,0.384-2.23,0.993l0,0l-9,10l0,0C20.292,19.525,20,20.228,20,21C20,22.657,21.343,24,23,24z M55,35c-1.657,0-3,1.343-3,3\r\n\t\t\t\tv12H12V38c0-1.657-1.343-3-3-3s-3,1.343-3,3v15c0,1.657,1.343,3,3,3h46c1.657,0,3-1.343,3-3V38C58,36.343,56.657,35,55,35z"},"children":[]}]}]}]}]}]}]}]};exports.upload=upload;var user={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER_2_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER_1_"},"children":[{"name":"g","attribs":{"id":"USER_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0,0-10.933-7.987-14.906c-5.055-2.515-3.107-0.591-9.313-3.164c-6.205-2.569-7.675-3.409-7.675-3.409\r\n\t\t\t\tl-0.055-5.893c0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.52-6.491c-0.444-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.925c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tC0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0,0-10.933-7.987-14.906c-5.055-2.515-3.107-0.591-9.313-3.164c-6.205-2.569-7.675-3.409-7.675-3.409\r\n\t\t\t\tl-0.055-5.893c0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.52-6.491c-0.444-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.925c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tC0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]}]};exports.user=user;var user_add={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER__x2F__ADD_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__ADD"},"children":[{"name":"g","attribs":{"id":"USER__x2F__ADD"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0-0.005-0.567-0.099-1.47C62.852,59.432,61.499,60,60,60c0,1.098-0.316,2.114-0.832,3H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M42,54c0-3.314,2.686-6,6-6c0-1.952,0.945-3.668,2.389-4.764\r\n\t\t\t\tc-0.797-0.209-1.897-0.571-3.688-1.314c-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.573-4.259,0.532-9.314,3.047C0,49.061,0,59.992,0,59.992h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.316,62.115,48,61.1,48,60C44.686,60,42,57.314,42,54z M63,54c0-1.657-1.343-3-3-3h-3v-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3\r\n\t\t\t\tC61.657,57,63,55.657,63,54z"},"children":[{"name":"path","attribs":{"d":"M64.001,59.993c0,0-0.005-0.567-0.099-1.47C62.852,59.432,61.499,60,60,60c0,1.098-0.316,2.114-0.832,3H61\r\n\t\t\t\tc1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M42,54c0-3.314,2.686-6,6-6c0-1.952,0.945-3.668,2.389-4.764\r\n\t\t\t\tc-0.797-0.209-1.897-0.571-3.688-1.314c-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.324-1.764,3.049-7.337\r\n\t\t\t\tc1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025c0.363-2.724,0.648-5.187,0.52-6.491\r\n\t\t\t\tc-0.444-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.573-4.259,0.532-9.314,3.047C0,49.061,0,59.992,0,59.992h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h45.832C48.316,62.115,48,61.1,48,60C44.686,60,42,57.314,42,54z M63,54c0-1.657-1.343-3-3-3h-3v-3\r\n\t\t\t\tc0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3c0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3\r\n\t\t\t\tC61.657,57,63,55.657,63,54z"},"children":[]}]}]}]}]}]}]}]};exports.user_add=user_add;var user_circle={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER_3_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER"},"children":[{"name":"g","attribs":{"id":"USER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M51.253,49.43\r\n\t\t\t\tc-3.767-1.826-2.382-0.398-7.31-2.427c-5.041-2.073-6.235-2.749-6.235-2.749L37.664,39.5c0,0,1.888-1.422,2.477-5.917\r\n\t\t\t\tc1.178,0.338,1.578-1.372,1.642-2.464c0.069-1.055,0.696-4.346-0.745-4.052c0.295-2.197,0.527-4.183,0.421-5.235\r\n\t\t\t\tc-0.36-3.691-2.931-7.544-9.42-7.826c-5.517,0.282-9.098,4.138-9.46,7.829c-0.104,1.052,0.108,3.036,0.403,5.236\r\n\t\t\t\tc-1.441-0.297-0.821,2.999-0.758,4.054c0.07,1.092,0.46,2.809,1.641,2.469c0.587,4.495,2.475,5.93,2.475,5.93L26.293,44.3\r\n\t\t\t\tc0,0-1.195,0.724-6.236,2.796c-4.927,2.027-3.544,0.512-7.31,2.334C8.568,44.816,6,38.715,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,38.716,55.432,44.816,51.253,49.43z"},"children":[{"name":"path","attribs":{"d":"M32,0C14.327,0,0,14.327,0,32s14.327,32,32,32s32-14.327,32-32S49.673,0,32,0z M51.253,49.43\r\n\t\t\t\tc-3.767-1.826-2.382-0.398-7.31-2.427c-5.041-2.073-6.235-2.749-6.235-2.749L37.664,39.5c0,0,1.888-1.422,2.477-5.917\r\n\t\t\t\tc1.178,0.338,1.578-1.372,1.642-2.464c0.069-1.055,0.696-4.346-0.745-4.052c0.295-2.197,0.527-4.183,0.421-5.235\r\n\t\t\t\tc-0.36-3.691-2.931-7.544-9.42-7.826c-5.517,0.282-9.098,4.138-9.46,7.829c-0.104,1.052,0.108,3.036,0.403,5.236\r\n\t\t\t\tc-1.441-0.297-0.821,2.999-0.758,4.054c0.07,1.092,0.46,2.809,1.641,2.469c0.587,4.495,2.475,5.93,2.475,5.93L26.293,44.3\r\n\t\t\t\tc0,0-1.195,0.724-6.236,2.796c-4.927,2.027-3.544,0.512-7.31,2.334C8.568,44.816,6,38.715,6,32C6,17.641,17.641,6,32,6\r\n\t\t\t\tc14.359,0,26,11.641,26,26C58,38.716,55.432,44.816,51.253,49.43z"},"children":[]}]}]}]}]}]}]}]};exports.user_circle=user_circle;var user_delete={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER__x2F__DELETE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__DELETE"},"children":[{"name":"g","attribs":{"id":"USER__x2F__DELETE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M46.516,54l-1.758-1.757l0.016-0.017C43.682,51.146,43,49.659,43,48c0-2.775,1.895-5.088,4.454-5.773\r\n\t\t\t\tc-0.243-0.097-0.481-0.191-0.754-0.305c-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.323-1.764,3.049-7.337\r\n\t\t\t\tc1.449,0.42,1.941-1.701,2.02-3.056c0.086-1.309,0.857-5.389-0.917-5.025c0.362-2.724,0.647-5.187,0.519-6.491\r\n\t\t\t\tc-0.443-4.576-3.607-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.573-4.259,0.532-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h40.832C43.316,62.115,43,61.1,43,60c0-1.657,0.672-3.157,1.757-4.243L46.516,54\r\n\t\t\t\tz M59.243,54l3.879-3.878C63.664,49.578,64,48.828,64,48c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,49.758\r\n\t\t\t\tl-3.879-3.879C50.578,45.336,49.828,45,49,45c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L50.757,54l-3.879,3.879\r\n\t\t\t\tC46.336,58.422,46,59.172,46,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,58.243l3.879,3.879\r\n\t\t\t\tC59.422,62.664,60.172,63,61,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,54z"},"children":[{"name":"path","attribs":{"d":"M46.516,54l-1.758-1.757l0.016-0.017C43.682,51.146,43,49.659,43,48c0-2.775,1.895-5.088,4.454-5.773\r\n\t\t\t\tc-0.243-0.097-0.481-0.191-0.754-0.305c-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.323-1.764,3.049-7.337\r\n\t\t\t\tc1.449,0.42,1.941-1.701,2.02-3.056c0.086-1.309,0.857-5.389-0.917-5.025c0.362-2.724,0.647-5.187,0.519-6.491\r\n\t\t\t\tc-0.443-4.576-3.607-9.355-11.594-9.704c-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494\r\n\t\t\t\tc-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924\r\n\t\t\t\tc0,0-1.47,0.896-7.675,3.466c-6.205,2.573-4.259,0.532-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002\r\n\t\t\t\tC0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h40.832C43.316,62.115,43,61.1,43,60c0-1.657,0.672-3.157,1.757-4.243L46.516,54\r\n\t\t\t\tz M59.243,54l3.879-3.878C63.664,49.578,64,48.828,64,48c0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L55,49.758\r\n\t\t\t\tl-3.879-3.879C50.578,45.336,49.828,45,49,45c-1.657,0-3,1.343-3,3c0,0.828,0.336,1.578,0.879,2.121L50.757,54l-3.879,3.879\r\n\t\t\t\tC46.336,58.422,46,59.172,46,60c0,1.657,1.343,3,3,3c0.828,0,1.578-0.336,2.121-0.879L55,58.243l3.879,3.879\r\n\t\t\t\tC59.422,62.664,60.172,63,61,63c1.657,0,3-1.343,3-3c0-0.828-0.336-1.578-0.879-2.121L59.243,54z"},"children":[]}]}]}]}]}]}]}]};exports.user_delete=user_delete;var user_ok={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER__x2F__OK_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__OK"},"children":[{"name":"g","attribs":{"id":"USER__x2F__OK"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M44.757,58.243C43.672,57.157,43,55.657,43,54c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538l3.781-3.781\r\n\t\t\t\tc0.047-0.046,0.104-0.08,0.15-0.124c-0.299-0.183-0.57-0.386-0.895-0.547c-5.055-2.516-3.107-0.591-9.313-3.164\r\n\t\t\t\tc-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.323-1.764,3.049-7.337c1.449,0.42,1.94-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.857-5.389-0.917-5.025c0.362-2.724,0.647-5.187,0.519-6.491c-0.442-4.576-3.606-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924c0,0-1.47,0.896-7.675,3.466\r\n\t\t\t\tc-6.205,2.573-4.259,0.532-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46.691c-0.336-0.223-0.65-0.475-0.934-0.757L44.757,58.243z M64.001,59.993c0,0-0.008-1.709-0.498-4.011\r\n\t\t\t\tl-6.261,6.261c-0.284,0.282-0.598,0.534-0.934,0.757H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M64,50\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L53,53.757l-1.879-1.879C50.578,51.336,49.828,51,49,51\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4C51.422,60.664,52.172,61,53,61s1.578-0.336,2.121-0.879l8-8\r\n\t\t\t\tC63.664,51.579,64,50.828,64,50z"},"children":[{"name":"path","attribs":{"d":"M44.757,58.243C43.672,57.157,43,55.657,43,54c0-3.314,2.686-6,6-6c1.533,0,2.916,0.592,3.977,1.538l3.781-3.781\r\n\t\t\t\tc0.047-0.046,0.104-0.08,0.15-0.124c-0.299-0.183-0.57-0.386-0.895-0.547c-5.055-2.516-3.107-0.591-9.313-3.164\r\n\t\t\t\tc-6.205-2.57-7.675-3.408-7.675-3.408l-0.055-5.894c0,0,2.323-1.764,3.049-7.337c1.449,0.42,1.94-1.701,2.02-3.056\r\n\t\t\t\tc0.086-1.309,0.857-5.389-0.917-5.025c0.362-2.724,0.647-5.187,0.519-6.491c-0.442-4.576-3.606-9.355-11.594-9.704\r\n\t\t\t\tc-6.79,0.349-11.198,5.131-11.643,9.707c-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027\r\n\t\t\t\tc0.086,1.355,0.566,3.482,2.02,3.062c0.722,5.574,3.046,7.352,3.046,7.352l-0.058,5.924c0,0-1.47,0.896-7.675,3.466\r\n\t\t\t\tc-6.205,2.573-4.259,0.532-9.314,3.047c-7.988,3.976-7.988,14.907-7.988,14.907h0.002C0.001,59.995,0,59.998,0,60\r\n\t\t\t\tc0,1.657,1.343,3,3,3h46.691c-0.336-0.223-0.65-0.475-0.934-0.757L44.757,58.243z M64.001,59.993c0,0-0.008-1.709-0.498-4.011\r\n\t\t\t\tl-6.261,6.261c-0.284,0.282-0.598,0.534-0.934,0.757H61c1.657,0,3-1.343,3-3c0-0.003-0.001-0.005-0.001-0.007H64.001z M64,50\r\n\t\t\t\tc0-1.657-1.343-3-3-3c-0.828,0-1.578,0.336-2.121,0.879L53,53.757l-1.879-1.879C50.578,51.336,49.828,51,49,51\r\n\t\t\t\tc-1.657,0-3,1.343-3,3c0,0.829,0.336,1.578,0.879,2.121l4,4C51.422,60.664,52.172,61,53,61s1.578-0.336,2.121-0.879l8-8\r\n\t\t\t\tC63.664,51.579,64,50.828,64,50z"},"children":[]}]}]}]}]}]}]}]};exports.user_ok=user_ok;var user_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER__x2F__REMOVE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USER__x2F__REMOVE"},"children":[{"name":"g","attribs":{"id":"USER__x2F__REMOVE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M45,54c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H48C46.343,51,45,52.343,45,54z M64.001,59.993\r\n\t\t\t\tc0,0-0.005-0.571-0.097-1.472C62.854,59.43,61.5,60,60,60H48c-3.314,0-6-2.686-6-6s2.686-6,6-6h11.764\r\n\t\t\t\tc-0.998-1.141-2.226-2.154-3.75-2.913c-5.055-2.515-3.107-0.591-9.313-3.164c-6.205-2.569-7.675-3.409-7.675-3.409l-0.055-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.52-6.491c-0.443-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.925c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tC0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[{"name":"path","attribs":{"d":"M45,54c0,1.657,1.343,3,3,3h12c1.657,0,3-1.343,3-3s-1.343-3-3-3H48C46.343,51,45,52.343,45,54z M64.001,59.993\r\n\t\t\t\tc0,0-0.005-0.571-0.097-1.472C62.854,59.43,61.5,60,60,60H48c-3.314,0-6-2.686-6-6s2.686-6,6-6h11.764\r\n\t\t\t\tc-0.998-1.141-2.226-2.154-3.75-2.913c-5.055-2.515-3.107-0.591-9.313-3.164c-6.205-2.569-7.675-3.409-7.675-3.409l-0.055-5.893\r\n\t\t\t\tc0,0,2.324-1.764,3.049-7.337c1.451,0.42,1.942-1.701,2.021-3.056c0.086-1.309,0.858-5.389-0.917-5.025\r\n\t\t\t\tc0.363-2.724,0.648-5.187,0.52-6.491c-0.443-4.576-3.608-9.355-11.595-9.704c-6.79,0.349-11.198,5.131-11.643,9.707\r\n\t\t\t\tc-0.128,1.304,0.133,3.765,0.496,6.494c-1.774-0.369-1.01,3.719-0.932,5.027c0.086,1.355,0.566,3.482,2.02,3.062\r\n\t\t\t\tc0.722,5.574,3.046,7.351,3.046,7.351l-0.058,5.925c0,0-1.47,0.897-7.675,3.466c-6.205,2.574-4.259,0.533-9.314,3.047\r\n\t\t\t\tC0,49.062,0,59.993,0,59.993h0.002C0.001,59.995,0,59.998,0,60c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.003-0.001-0.005-0.001-0.007H64.001z"},"children":[]}]}]}]}]}]}]}]};exports.user_remove=user_remove;var user_square={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USER"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\tC64,1.343,62.657,0,61,0z M58,56.843c-0.888-2.64-2.564-5.557-5.739-7.157c-4.265-2.15-2.623-0.505-7.858-2.705\r\n\t\t\tc-5.235-2.197-6.475-2.915-6.475-2.915l-0.046-5.039c0,0,1.961-1.508,2.573-6.273c1.224,0.359,1.638-1.454,1.704-2.612\r\n\t\t\tc0.073-1.119,0.724-4.607-0.774-4.296c0.306-2.329,0.547-4.434,0.438-5.549c-0.374-3.912-3.044-7.998-9.782-8.296\r\n\t\t\tc-5.729,0.299-9.448,4.386-9.823,8.299c-0.108,1.115,0.112,3.218,0.418,5.551c-1.497-0.315-0.852,3.179-0.787,4.297\r\n\t\t\tc0.072,1.158,0.477,2.977,1.705,2.618c0.609,4.765,2.57,6.285,2.57,6.285l-0.049,5.065c0,0-1.24,0.767-6.476,2.963\r\n\t\t\tc-5.235,2.201-3.594,0.455-7.858,2.605C8.565,51.285,6.888,54.203,6,56.843V6h52V56.843z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M61,0H3C1.343,0,0,1.343,0,3v58c0,1.657,1.343,3,3,3h58c1.657,0,3-1.343,3-3V3\r\n\t\t\tC64,1.343,62.657,0,61,0z M58,56.843c-0.888-2.64-2.564-5.557-5.739-7.157c-4.265-2.15-2.623-0.505-7.858-2.705\r\n\t\t\tc-5.235-2.197-6.475-2.915-6.475-2.915l-0.046-5.039c0,0,1.961-1.508,2.573-6.273c1.224,0.359,1.638-1.454,1.704-2.612\r\n\t\t\tc0.073-1.119,0.724-4.607-0.774-4.296c0.306-2.329,0.547-4.434,0.438-5.549c-0.374-3.912-3.044-7.998-9.782-8.296\r\n\t\t\tc-5.729,0.299-9.448,4.386-9.823,8.299c-0.108,1.115,0.112,3.218,0.418,5.551c-1.497-0.315-0.852,3.179-0.787,4.297\r\n\t\t\tc0.072,1.158,0.477,2.977,1.705,2.618c0.609,4.765,2.57,6.285,2.57,6.285l-0.049,5.065c0,0-1.24,0.767-6.476,2.963\r\n\t\t\tc-5.235,2.201-3.594,0.455-7.858,2.605C8.565,51.285,6.888,54.203,6,56.843V6h52V56.843z"},"children":[]}]}]}]}]}]};exports.user_square=user_square;var users={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"USERS_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"USERS"},"children":[{"name":"g","attribs":{"id":"USERS"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M40.837,41.984c-3.685-1.828-2.267-0.43-6.79-2.299c-4.524-1.867-5.595-2.478-5.595-2.478l-0.04-4.282\r\n\t\t\t\tc0,0,1.694-1.282,2.223-5.332c1.057,0.305,1.416-1.236,1.473-2.22c0.063-0.951,0.626-3.916-0.669-3.651\r\n\t\t\t\tc0.265-1.979,0.472-3.769,0.378-4.716c-0.323-3.325-2.63-6.798-8.453-7.051c-4.95,0.254-8.164,3.728-8.488,7.054\r\n\t\t\t\tc-0.093,0.947,0.097,2.735,0.361,4.718c-1.293-0.268-0.737,2.702-0.68,3.652c0.062,0.984,0.412,2.53,1.473,2.225\r\n\t\t\t\tc0.526,4.05,2.221,5.342,2.221,5.342l-0.042,4.304c0,0-1.072,0.651-5.596,2.519c-4.524,1.871-3.105,0.388-6.79,2.215\r\n\t\t\t\tc-5.824,2.889-5.824,10.832-5.824,10.832h0.002c0,0-0.001,0.002-0.001,0.004C0,54.023,0.979,55,2.187,55h42.286\r\n\t\t\t\tc1.207,0,2.187-0.977,2.187-2.18c0-0.002,0-0.004,0-0.006h0.001C46.66,52.814,46.66,44.872,40.837,41.984z M63.9,53.012\r\n\t\t\t\tc0,0,0-7.226-5.297-9.854c-3.354-1.663-2.062-0.391-6.179-2.092c-4.116-1.699-5.09-2.254-5.09-2.254l-0.036-3.896\r\n\t\t\t\tc0,0,1.541-1.166,2.021-4.85c0.963,0.277,1.289-1.124,1.341-2.02c0.057-0.865,0.569-3.562-0.608-3.322\r\n\t\t\t\tc0.241-1.801,0.43-3.429,0.344-4.291c-0.293-3.025-2.393-6.184-7.689-6.415c-4.504,0.231-7.428,3.392-7.723,6.417\r\n\t\t\t\tc-0.084,0.862,0.089,2.489,0.33,4.293c-1.178-0.244-0.67,2.458-0.619,3.323c0.058,0.896,0.375,2.302,1.341,2.024\r\n\t\t\t\tc0.479,3.685,2.021,4.86,2.021,4.86l-0.039,3.901c1.4,0.331,1.588,0.063,4.41,1.464c6.604,3.275,6.604,12.282,6.604,12.282\r\n\t\t\t\th-0.002c0,0.002,0,0.004,0,0.006c0,1.181-0.831,2.165-1.942,2.41H61.91c1.099,0,1.99-0.888,1.99-1.983\r\n\t\t\t\tC63.9,53.014,63.9,53.014,63.9,53.012L63.9,53.012L63.9,53.012z"},"children":[{"name":"path","attribs":{"d":"M40.837,41.984c-3.685-1.828-2.267-0.43-6.79-2.299c-4.524-1.867-5.595-2.478-5.595-2.478l-0.04-4.282\r\n\t\t\t\tc0,0,1.694-1.282,2.223-5.332c1.057,0.305,1.416-1.236,1.473-2.22c0.063-0.951,0.626-3.916-0.669-3.651\r\n\t\t\t\tc0.265-1.979,0.472-3.769,0.378-4.716c-0.323-3.325-2.63-6.798-8.453-7.051c-4.95,0.254-8.164,3.728-8.488,7.054\r\n\t\t\t\tc-0.093,0.947,0.097,2.735,0.361,4.718c-1.293-0.268-0.737,2.702-0.68,3.652c0.062,0.984,0.412,2.53,1.473,2.225\r\n\t\t\t\tc0.526,4.05,2.221,5.342,2.221,5.342l-0.042,4.304c0,0-1.072,0.651-5.596,2.519c-4.524,1.871-3.105,0.388-6.79,2.215\r\n\t\t\t\tc-5.824,2.889-5.824,10.832-5.824,10.832h0.002c0,0-0.001,0.002-0.001,0.004C0,54.023,0.979,55,2.187,55h42.286\r\n\t\t\t\tc1.207,0,2.187-0.977,2.187-2.18c0-0.002,0-0.004,0-0.006h0.001C46.66,52.814,46.66,44.872,40.837,41.984z M63.9,53.012\r\n\t\t\t\tc0,0,0-7.226-5.297-9.854c-3.354-1.663-2.062-0.391-6.179-2.092c-4.116-1.699-5.09-2.254-5.09-2.254l-0.036-3.896\r\n\t\t\t\tc0,0,1.541-1.166,2.021-4.85c0.963,0.277,1.289-1.124,1.341-2.02c0.057-0.865,0.569-3.562-0.608-3.322\r\n\t\t\t\tc0.241-1.801,0.43-3.429,0.344-4.291c-0.293-3.025-2.393-6.184-7.689-6.415c-4.504,0.231-7.428,3.392-7.723,6.417\r\n\t\t\t\tc-0.084,0.862,0.089,2.489,0.33,4.293c-1.178-0.244-0.67,2.458-0.619,3.323c0.058,0.896,0.375,2.302,1.341,2.024\r\n\t\t\t\tc0.479,3.685,2.021,4.86,2.021,4.86l-0.039,3.901c1.4,0.331,1.588,0.063,4.41,1.464c6.604,3.275,6.604,12.282,6.604,12.282\r\n\t\t\t\th-0.002c0,0.002,0,0.004,0,0.006c0,1.181-0.831,2.165-1.942,2.41H61.91c1.099,0,1.99-0.888,1.99-1.983\r\n\t\t\t\tC63.9,53.014,63.9,53.014,63.9,53.012L63.9,53.012L63.9,53.012z"},"children":[]}]}]}]}]}]}]}]};exports.users=users;var view={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VIEW_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VIEW"},"children":[{"name":"g","attribs":{"id":"VIEW"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6C38,28.686,35.314,26,32,26z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.005-0.041c0-0.02-0.004-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.004-0.046-0.008-0.068c-0.002-0.003-0.002-0.006-0.002-0.009c-0.078-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-5.318-4.337-11.402-7.964-18.116-9.425c-3.882-0.844-7.786-0.879-11.688-0.165\r\n\t\t\t\tc-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.587,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328\r\n\t\t\t\tc-0.893,1.083-0.893,2.367,0,3.451c2.042,2.476,4.47,4.678,6.94,6.691c5.32,4.337,11.403,7.963,18.118,9.424\r\n\t\t\t\tc3.881,0.844,7.788,0.881,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.011-2.621,9.586-6.231,13.574-10.28\r\n\t\t\t\tc0.737-0.75,1.471-1.514,2.143-2.328c0.357-0.367,0.591-0.84,0.669-1.348c0-0.003,0.002-0.006,0.002-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.008-0.068c0.004-0.019,0.006-0.039,0.008-0.058c0.002-0.015,0.003-0.027,0.005-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z M32,44\r\n\t\t\t\tc-6.627,0-12-5.372-12-12s5.372-12,12-12s12,5.373,12,12C44,38.628,38.627,44,32,44z"},"children":[{"name":"path","attribs":{"d":"M32,26c-3.314,0-6,2.686-6,6c0,3.314,2.686,6,6,6c3.314,0,6-2.686,6-6C38,28.686,35.314,26,32,26z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.005-0.041c0-0.02-0.004-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.004-0.046-0.008-0.068c-0.002-0.003-0.002-0.006-0.002-0.009c-0.078-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-5.318-4.337-11.402-7.964-18.116-9.425c-3.882-0.844-7.786-0.879-11.688-0.165\r\n\t\t\t\tc-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.587,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328\r\n\t\t\t\tc-0.893,1.083-0.893,2.367,0,3.451c2.042,2.476,4.47,4.678,6.94,6.691c5.32,4.337,11.403,7.963,18.118,9.424\r\n\t\t\t\tc3.881,0.844,7.788,0.881,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.011-2.621,9.586-6.231,13.574-10.28\r\n\t\t\t\tc0.737-0.75,1.471-1.514,2.143-2.328c0.357-0.367,0.591-0.84,0.669-1.348c0-0.003,0.002-0.006,0.002-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.008-0.068c0.004-0.019,0.006-0.039,0.008-0.058c0.002-0.015,0.003-0.027,0.005-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z M32,44\r\n\t\t\t\tc-6.627,0-12-5.372-12-12s5.372-12,12-12s12,5.373,12,12C44,38.628,38.627,44,32,44z"},"children":[]}]}]}]}]}]}]}]};exports.view=view;var view_off={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VIEW__x2F__OFF_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VIEW__x2F__OFF"},"children":[{"name":"g","attribs":{"id":"VIEW__x2F__OFF"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M26.044,31.304l7.604-5.069C33.124,26.085,32.572,26,32,26C28.922,26,26.389,28.319,26.044,31.304z M58.32,16.755\r\n\t\t\t\tC58.729,16.487,59,16.025,59,15.5c0-0.828-0.672-1.5-1.5-1.5c-0.303,0-0.585,0.091-0.82,0.245v-0.001l-0.018,0.012L4.679,48.245\r\n\t\t\t\tl0,0C4.271,48.514,4,48.975,4,49.5C4,50.328,4.672,51,5.5,51c0.303,0,0.585-0.091,0.82-0.245v0.001l0.018-0.012L58.32,16.755\r\n\t\t\t\tL58.32,16.755z M9.455,42.364L10,42l10.409-6.939C20.151,34.082,20,33.061,20,32c0-6.628,5.373-12,12-12\r\n\t\t\t\tc2.742,0,5.262,0.93,7.283,2.478L46,18l0.552-0.345c-2.647-1.317-5.415-2.367-8.308-2.996c-3.881-0.844-7.786-0.879-11.687-0.165\r\n\t\t\t\tc-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.586,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328\r\n\t\t\t\tc-0.893,1.083-0.893,2.367,0,3.451c2.042,2.476,4.47,4.678,6.94,6.691C8.214,41.41,8.831,41.891,9.455,42.364z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.005-0.041c0-0.02-0.004-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.004-0.046-0.008-0.068c-0.002-0.003-0.002-0.006-0.002-0.009c-0.078-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-0.676-0.552-1.366-1.092-2.068-1.618l-10.576,6.958C43.898,30.255,44,31.115,44,32\r\n\t\t\t\tc0,6.627-5.373,12-12,12c-2.615,0-5.026-0.846-6.997-2.266L17,47l-0.09,0.09c2.8,1.439,5.739,2.581,8.818,3.25\r\n\t\t\t\tc3.881,0.844,7.788,0.881,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.011-2.621,9.586-6.231,13.574-10.28\r\n\t\t\t\tc0.737-0.75,1.471-1.514,2.144-2.328c0.356-0.367,0.59-0.841,0.668-1.348c0-0.003,0.002-0.006,0.002-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.008-0.068c0.004-0.019,0.006-0.039,0.009-0.058c0.001-0.015,0.003-0.027,0.004-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z\r\n\t\t\t\t M37.861,33.275l-7.01,4.613C31.223,37.96,31.607,38,32,38C34.876,38,37.275,35.977,37.861,33.275z"},"children":[{"name":"path","attribs":{"d":"M26.044,31.304l7.604-5.069C33.124,26.085,32.572,26,32,26C28.922,26,26.389,28.319,26.044,31.304z M58.32,16.755\r\n\t\t\t\tC58.729,16.487,59,16.025,59,15.5c0-0.828-0.672-1.5-1.5-1.5c-0.303,0-0.585,0.091-0.82,0.245v-0.001l-0.018,0.012L4.679,48.245\r\n\t\t\t\tl0,0C4.271,48.514,4,48.975,4,49.5C4,50.328,4.672,51,5.5,51c0.303,0,0.585-0.091,0.82-0.245v0.001l0.018-0.012L58.32,16.755\r\n\t\t\t\tL58.32,16.755z M9.455,42.364L10,42l10.409-6.939C20.151,34.082,20,33.061,20,32c0-6.628,5.373-12,12-12\r\n\t\t\t\tc2.742,0,5.262,0.93,7.283,2.478L46,18l0.552-0.345c-2.647-1.317-5.415-2.367-8.308-2.996c-3.881-0.844-7.786-0.879-11.687-0.165\r\n\t\t\t\tc-3.549,0.649-6.969,2-10.17,3.674c-5.011,2.62-9.586,6.231-13.574,10.28c-0.738,0.749-1.472,1.514-2.143,2.328\r\n\t\t\t\tc-0.893,1.083-0.893,2.367,0,3.451c2.042,2.476,4.47,4.678,6.94,6.691C8.214,41.41,8.831,41.891,9.455,42.364z M63.997,32.379\r\n\t\t\t\tc-0.001-0.028-0.004-0.054-0.006-0.081c-0.001-0.014-0.003-0.028-0.005-0.041c0-0.02-0.004-0.039-0.008-0.058\r\n\t\t\t\tc-0.002-0.023-0.004-0.046-0.008-0.068c-0.002-0.003-0.002-0.006-0.002-0.009c-0.078-0.506-0.312-0.981-0.669-1.346\r\n\t\t\t\tc-2.042-2.476-4.471-4.68-6.94-6.692c-0.676-0.552-1.366-1.092-2.068-1.618l-10.576,6.958C43.898,30.255,44,31.115,44,32\r\n\t\t\t\tc0,6.627-5.373,12-12,12c-2.615,0-5.026-0.846-6.997-2.266L17,47l-0.09,0.09c2.8,1.439,5.739,2.581,8.818,3.25\r\n\t\t\t\tc3.881,0.844,7.788,0.881,11.688,0.166c3.548-0.65,6.968-2,10.171-3.673c5.011-2.621,9.586-6.231,13.574-10.28\r\n\t\t\t\tc0.737-0.75,1.471-1.514,2.144-2.328c0.356-0.367,0.59-0.841,0.668-1.348c0-0.003,0.002-0.006,0.002-0.008\r\n\t\t\t\tc0.004-0.023,0.006-0.045,0.008-0.068c0.004-0.019,0.006-0.039,0.009-0.058c0.001-0.015,0.003-0.027,0.004-0.041\r\n\t\t\t\tc0.002-0.026,0.004-0.052,0.006-0.08c0.002-0.041,0.003-0.081,0.003-0.122C64.001,32.459,63.998,32.419,63.997,32.379z\r\n\t\t\t\t M37.861,33.275l-7.01,4.613C31.223,37.96,31.607,38,32,38C34.876,38,37.275,35.977,37.861,33.275z"},"children":[]}]}]}]}]}]}]}]};exports.view_off=view_off;var vimeo={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"vimeo_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"vimeo"},"children":[{"name":"g","attribs":{"id":"vimeo"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M36.348,18.728c2.748-0.624,7.539-1.522,8.529,1.306c1.246,8.476-4.611,15.407-9.84,19.602\r\n\t\t\t\tC24.919,34.128,32.523,8.81,21.915,4.633c-5.448-2.145-10.31,2.79-14.434,6.255C4.788,13.151-0.013,16.758,0,19.531v0.073\r\n\t\t\t\tc0.023,0.633,0.301,1.221,0.921,1.738c2.13,3.51,3.998-2.43,7.872-1.306c8.471,6.948,5.793,37.749,18.37,39.856\r\n\t\t\t\tc4.882,0.817,11.08-3.648,14.433-6.535c4.625-3.98,9.924-10.722,13.777-16.334c0,0,9.677-12.741,8.529-23.521\r\n\t\t\t\tC61.789-4.107,36.207,5.801,36.348,18.728z"},"children":[{"name":"path","attribs":{"d":"M36.348,18.728c2.748-0.624,7.539-1.522,8.529,1.306c1.246,8.476-4.611,15.407-9.84,19.602\r\n\t\t\t\tC24.919,34.128,32.523,8.81,21.915,4.633c-5.448-2.145-10.31,2.79-14.434,6.255C4.788,13.151-0.013,16.758,0,19.531v0.073\r\n\t\t\t\tc0.023,0.633,0.301,1.221,0.921,1.738c2.13,3.51,3.998-2.43,7.872-1.306c8.471,6.948,5.793,37.749,18.37,39.856\r\n\t\t\t\tc4.882,0.817,11.08-3.648,14.433-6.535c4.625-3.98,9.924-10.722,13.777-16.334c0,0,9.677-12.741,8.529-23.521\r\n\t\t\t\tC61.789-4.107,36.207,5.801,36.348,18.728z"},"children":[]}]}]}]}]}]}]}]};exports.vimeo=vimeo;var voicemail={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOICEMAIL_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOICEMAIL"},"children":[{"name":"g","attribs":{"id":"VOICEMAIL"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50,18c-7.732,0-14,6.268-14,14c0,2.977,0.936,5.73,2.52,8H25.48c1.584-2.27,2.52-5.023,2.52-8c0-7.732-6.268-14-14-14\r\n\t\t\t\tS0,24.268,0,32c0,7.732,6.268,14,14,14h36c7.732,0,14-6.268,14-14C64,24.268,57.732,18,50,18z M14,40c-4.418,0-8-3.582-8-8\r\n\t\t\t\ts3.582-8,8-8s8,3.582,8,8S18.418,40,14,40z M50,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S54.418,40,50,40z"},"children":[{"name":"path","attribs":{"d":"M50,18c-7.732,0-14,6.268-14,14c0,2.977,0.936,5.73,2.52,8H25.48c1.584-2.27,2.52-5.023,2.52-8c0-7.732-6.268-14-14-14\r\n\t\t\t\tS0,24.268,0,32c0,7.732,6.268,14,14,14h36c7.732,0,14-6.268,14-14C64,24.268,57.732,18,50,18z M14,40c-4.418,0-8-3.582-8-8\r\n\t\t\t\ts3.582-8,8-8s8,3.582,8,8S18.418,40,14,40z M50,40c-4.418,0-8-3.582-8-8s3.582-8,8-8s8,3.582,8,8S54.418,40,50,40z"},"children":[]}]}]}]}]}]}]}]};exports.voicemail=voicemail;var volume_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_1"},"children":[{"name":"g","attribs":{"id":"VOLUME_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M36,16c-0.721,0-1.374,0.265-1.891,0.689l-0.01-0.011l-10.162,8.315h-9.946v0.008C12.339,25.006,11,26.346,11,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.21,7.426l0.006-0.007C34.736,48.781,35.34,49,36,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC39,17.343,37.657,16,36,16z M47.902,18.926l-2.846,2.847C47.52,24.852,49,28.75,49,33s-1.48,8.148-3.943,11.227l2.846,2.848\r\n\t\t\t\tC51.083,43.26,53,38.355,53,33C53,27.645,51.083,22.74,47.902,18.926z"},"children":[{"name":"path","attribs":{"d":"M36,16c-0.721,0-1.374,0.265-1.891,0.689l-0.01-0.011l-10.162,8.315h-9.946v0.008C12.339,25.006,11,26.346,11,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.21,7.426l0.006-0.007C34.736,48.781,35.34,49,36,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC39,17.343,37.657,16,36,16z M47.902,18.926l-2.846,2.847C47.52,24.852,49,28.75,49,33s-1.48,8.148-3.943,11.227l2.846,2.848\r\n\t\t\t\tC51.083,43.26,53,38.355,53,33C53,27.645,51.083,22.74,47.902,18.926z"},"children":[]}]}]}]}]}]}]}]};exports.volume_1=volume_1;var volume_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_2"},"children":[{"name":"g","attribs":{"id":"VOLUME_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M50.701,10.128l-2.848,2.848C52.292,18.07,55,24.712,55,32s-2.708,13.93-7.146,19.023l2.848,2.849\r\n\t\t\t\tC55.861,48.049,59,40.393,59,32C59,23.607,55.861,15.951,50.701,10.128z M31,15c-0.721,0-1.374,0.265-1.891,0.689L29.1,15.678\r\n\t\t\t\tl-10.162,8.315H8.992v0.008C7.339,24.006,6,25.346,6,27v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007\r\n\t\t\t\tC29.736,47.781,30.34,48,31,48c1.657,0,3-1.343,3-3V18C34,16.343,32.657,15,31,15z M42.902,17.926l-2.846,2.847\r\n\t\t\t\tC42.52,23.852,44,27.75,44,32s-1.48,8.148-3.943,11.227l2.846,2.848C46.083,42.26,48,37.355,48,32\r\n\t\t\t\tC48,26.645,46.083,21.74,42.902,17.926z"},"children":[{"name":"path","attribs":{"d":"M50.701,10.128l-2.848,2.848C52.292,18.07,55,24.712,55,32s-2.708,13.93-7.146,19.023l2.848,2.849\r\n\t\t\t\tC55.861,48.049,59,40.393,59,32C59,23.607,55.861,15.951,50.701,10.128z M31,15c-0.721,0-1.374,0.265-1.891,0.689L29.1,15.678\r\n\t\t\t\tl-10.162,8.315H8.992v0.008C7.339,24.006,6,25.346,6,27v10c0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007\r\n\t\t\t\tC29.736,47.781,30.34,48,31,48c1.657,0,3-1.343,3-3V18C34,16.343,32.657,15,31,15z M42.902,17.926l-2.846,2.847\r\n\t\t\t\tC42.52,23.852,44,27.75,44,32s-1.48,8.148-3.943,11.227l2.846,2.848C46.083,42.26,48,37.355,48,32\r\n\t\t\t\tC48,26.645,46.083,21.74,42.902,17.926z"},"children":[]}]}]}]}]}]}]}]};exports.volume_2=volume_2;var volume_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME_3"},"children":[{"name":"g","attribs":{"id":"VOLUME_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M25,15c-0.721,0-1.374,0.265-1.891,0.689L23.1,15.678l-10.162,8.315H2.992v0.008C1.339,24.006,0,25.346,0,27v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C23.736,47.781,24.34,48,25,48c1.657,0,3-1.343,3-3V18\r\n\t\t\t\tC28,16.343,26.657,15,25,15z M36.902,17.926l-2.846,2.847C36.52,23.852,38,27.75,38,32s-1.48,8.148-3.943,11.227l2.846,2.848\r\n\t\t\t\tC40.083,42.26,42,37.355,42,32C42,26.645,40.083,21.74,36.902,17.926z M44.701,10.128l-2.848,2.848C46.292,18.07,49,24.712,49,32\r\n\t\t\t\ts-2.708,13.93-7.146,19.023l2.848,2.849C49.861,48.049,53,40.393,53,32C53,23.607,49.861,15.951,44.701,10.128z M52.493,2.336\r\n\t\t\t\tl-2.831,2.831C56.086,12.263,60,21.674,60,32s-3.914,19.736-10.338,26.833l2.831,2.831C59.639,53.842,64,43.432,64,32\r\n\t\t\t\tC64,20.569,59.639,10.159,52.493,2.336z"},"children":[{"name":"path","attribs":{"d":"M25,15c-0.721,0-1.374,0.265-1.891,0.689L23.1,15.678l-10.162,8.315H2.992v0.008C1.339,24.006,0,25.346,0,27v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C23.736,47.781,24.34,48,25,48c1.657,0,3-1.343,3-3V18\r\n\t\t\t\tC28,16.343,26.657,15,25,15z M36.902,17.926l-2.846,2.847C36.52,23.852,38,27.75,38,32s-1.48,8.148-3.943,11.227l2.846,2.848\r\n\t\t\t\tC40.083,42.26,42,37.355,42,32C42,26.645,40.083,21.74,36.902,17.926z M44.701,10.128l-2.848,2.848C46.292,18.07,49,24.712,49,32\r\n\t\t\t\ts-2.708,13.93-7.146,19.023l2.848,2.849C49.861,48.049,53,40.393,53,32C53,23.607,49.861,15.951,44.701,10.128z M52.493,2.336\r\n\t\t\t\tl-2.831,2.831C56.086,12.263,60,21.674,60,32s-3.914,19.736-10.338,26.833l2.831,2.831C59.639,53.842,64,43.432,64,32\r\n\t\t\t\tC64,20.569,59.639,10.159,52.493,2.336z"},"children":[]}]}]}]}]}]}]}]};exports.volume_3=volume_3;var volume_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__DOWN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M55,30H43c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S56.657,30,55,30z M31,16\r\n\t\t\t\tc-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3\r\n\t\t\t\th10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z"},"children":[{"name":"path","attribs":{"d":"M55,30H43c-1.657,0-3,1.343-3,3s1.343,3,3,3h12c1.657,0,3-1.343,3-3S56.657,30,55,30z M31,16\r\n\t\t\t\tc-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10c0,1.657,1.343,3,3,3\r\n\t\t\t\th10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19C34,17.343,32.657,16,31,16z"},"children":[]}]}]}]}]}]}]}]};exports.volume_down=volume_down;var volume_mute={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__MUTE"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z M53.243,33l3.879-3.879C57.664,28.579,58,27.829,58,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,28.758l-3.879-3.879C44.578,24.336,43.828,24,43,24c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L44.757,33l-3.879,3.879C40.336,37.422,40,38.172,40,39c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L49,37.243l3.879,3.879C53.422,41.664,54.172,42,55,42c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L53.243,33z"},"children":[{"name":"path","attribs":{"d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z M53.243,33l3.879-3.879C57.664,28.579,58,27.829,58,27c0-1.657-1.343-3-3-3\r\n\t\t\t\tc-0.828,0-1.578,0.336-2.121,0.879L49,28.758l-3.879-3.879C44.578,24.336,43.828,24,43,24c-1.657,0-3,1.343-3,3\r\n\t\t\t\tc0,0.828,0.336,1.578,0.879,2.121L44.757,33l-3.879,3.879C40.336,37.422,40,38.172,40,39c0,1.657,1.343,3,3,3\r\n\t\t\t\tc0.828,0,1.578-0.336,2.121-0.879L49,37.243l3.879,3.879C53.422,41.664,54.172,42,55,42c1.657,0,3-1.343,3-3\r\n\t\t\t\tc0-0.828-0.336-1.578-0.879-2.121L53.243,33z"},"children":[]}]}]}]}]}]}]}]};exports.volume_mute=volume_mute;var volume_off={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME__x2F__OFF_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__OFF"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__OFF"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M42,16c-0.721,0-1.374,0.265-1.891,0.689l-0.01-0.011l-10.162,8.315h-9.946v0.008C18.339,25.006,17,26.346,17,28v9.627\r\n\t\t\t\tl27.973-18.9C44.832,17.2,43.562,16,42,16z M30.024,41l10.21,7.426l0.006-0.007C40.736,48.781,41.34,49,42,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V29.57L28.083,41H30.024z M51,18.6c-0.312,0-0.602,0.095-0.841,0.258L13.064,43.955\r\n\t\t\t\tc-0.4,0.27-0.664,0.727-0.664,1.245c0,0.827,0.672,1.5,1.5,1.5c0.312,0,0.601-0.095,0.841-0.259l37.095-25.096\r\n\t\t\t\tc0.4-0.269,0.664-0.727,0.664-1.245C52.5,19.272,51.828,18.6,51,18.6z"},"children":[{"name":"path","attribs":{"d":"M42,16c-0.721,0-1.374,0.265-1.891,0.689l-0.01-0.011l-10.162,8.315h-9.946v0.008C18.339,25.006,17,26.346,17,28v9.627\r\n\t\t\t\tl27.973-18.9C44.832,17.2,43.562,16,42,16z M30.024,41l10.21,7.426l0.006-0.007C40.736,48.781,41.34,49,42,49\r\n\t\t\t\tc1.657,0,3-1.343,3-3V29.57L28.083,41H30.024z M51,18.6c-0.312,0-0.602,0.095-0.841,0.258L13.064,43.955\r\n\t\t\t\tc-0.4,0.27-0.664,0.727-0.664,1.245c0,0.827,0.672,1.5,1.5,1.5c0.312,0,0.601-0.095,0.841-0.259l37.095-25.096\r\n\t\t\t\tc0.4-0.269,0.664-0.727,0.664-1.245C52.5,19.272,51.828,18.6,51,18.6z"},"children":[]}]}]}]}]}]}]}]};exports.volume_off=volume_off;var volume_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"VOLUME__x2F__UP_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__UP"},"children":[{"name":"g","attribs":{"id":"VOLUME__x2F__UP"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z M55,30h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S56.657,30,55,30z"},"children":[{"name":"path","attribs":{"d":"M31,16c-0.721,0-1.374,0.265-1.891,0.689L29.1,16.678l-10.162,8.315H8.992v0.008C7.339,25.006,6,26.346,6,28v10\r\n\t\t\t\tc0,1.657,1.343,3,3,3h10.024l10.211,7.426l0.005-0.007C29.736,48.781,30.34,49,31,49c1.657,0,3-1.343,3-3V19\r\n\t\t\t\tC34,17.343,32.657,16,31,16z M55,30h-3v-3c0-1.657-1.343-3-3-3s-3,1.343-3,3v3h-3c-1.657,0-3,1.343-3,3s1.343,3,3,3h3v3\r\n\t\t\t\tc0,1.657,1.343,3,3,3s3-1.343,3-3v-3h3c1.657,0,3-1.343,3-3S56.657,30,55,30z"},"children":[]}]}]}]}]}]}]}]};exports.volume_up=volume_up;var warning={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"WARNING_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WARNING"},"children":[{"name":"g","attribs":{"id":"WARNING"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M63.562,53.463l0.018-0.011l-29-47l-0.018,0.01C34.039,5.59,33.092,5,32,5c-1.052,0-1.973,0.543-2.509,1.362l-0.017-0.01\r\n\t\t\t\tl-29,47l0.017,0.01C0.183,53.834,0,54.395,0,55c0,1.657,1.343,3,3,3c0.009,0,0.018-0.003,0.027-0.003v0.03h58v-0.03\r\n\t\t\t\tC62.671,57.982,64,56.648,64,55C64,54.436,63.835,53.914,63.562,53.463z M32,52c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4\r\n\t\t\t\tS34.209,52,32,52z M36,37c0,2.209-1.791,4-4,4s-4-1.791-4-4V22c0-2.209,1.791-4,4-4s4,1.791,4,4V37z"},"children":[{"name":"path","attribs":{"d":"M63.562,53.463l0.018-0.011l-29-47l-0.018,0.01C34.039,5.59,33.092,5,32,5c-1.052,0-1.973,0.543-2.509,1.362l-0.017-0.01\r\n\t\t\t\tl-29,47l0.017,0.01C0.183,53.834,0,54.395,0,55c0,1.657,1.343,3,3,3c0.009,0,0.018-0.003,0.027-0.003v0.03h58v-0.03\r\n\t\t\t\tC62.671,57.982,64,56.648,64,55C64,54.436,63.835,53.914,63.562,53.463z M32,52c-2.209,0-4-1.791-4-4s1.791-4,4-4s4,1.791,4,4\r\n\t\t\t\tS34.209,52,32,52z M36,37c0,2.209-1.791,4-4,4s-4-1.791-4-4V22c0-2.209,1.791-4,4-4s4,1.791,4,4V37z"},"children":[]}]}]}]}]}]}]}]};exports.warning=warning;var wifi_1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"WIFI_1_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_1"},"children":[{"name":"g","attribs":{"id":"WIFI_1"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,34c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,34,32,34z M32,19\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,26.938,28.029,25,32,25c3.971,0,7.482,1.937,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,21.629,37.343,19,32,19z"},"children":[{"name":"path","attribs":{"d":"M32,34c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,34,32,34z M32,19\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,26.938,28.029,25,32,25c3.971,0,7.482,1.937,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,21.629,37.343,19,32,19z"},"children":[]}]}]}]}]}]}]}]};exports.wifi_1=wifi_1;var wifi_2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"WIFI_2_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_2"},"children":[{"name":"g","attribs":{"id":"WIFI_2"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,41c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,41,32,41z M32,26\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,33.938,28.029,32,32,32c3.971,0,7.482,1.938,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,28.629,37.343,26,32,26z M32,11c-8.791,0-16.721,3.665-22.363,9.544l3.739,4.819C17.954,20.242,24.59,17,32,17\r\n\t\t\t\ts14.046,3.242,18.624,8.364l3.739-4.819C48.721,14.666,40.791,11,32,11z"},"children":[{"name":"path","attribs":{"d":"M32,41c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,41,32,41z M32,26\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,33.938,28.029,32,32,32c3.971,0,7.482,1.938,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,28.629,37.343,26,32,26z M32,11c-8.791,0-16.721,3.665-22.363,9.544l3.739,4.819C17.954,20.242,24.59,17,32,17\r\n\t\t\t\ts14.046,3.242,18.624,8.364l3.739-4.819C48.721,14.666,40.791,11,32,11z"},"children":[]}]}]}]}]}]}]}]};exports.wifi_2=wifi_2;var wifi_3={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"WIFI_3_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"WIFI_3"},"children":[{"name":"g","attribs":{"id":"WIFI_3"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,49c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,49,32,49z M32,34\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,41.938,28.029,40,32,40c3.971,0,7.482,1.938,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,36.629,37.343,34,32,34z M32,4C19.747,4,8.622,8.8,0.378,16.61l3.696,4.764C11.283,14.34,21.132,10,32,10\r\n\t\t\t\ts20.717,4.34,27.926,11.374l3.696-4.764C55.378,8.8,44.253,4,32,4z M9.637,28.544l3.739,4.819C17.954,28.242,24.59,25,32,25\r\n\t\t\t\ts14.046,3.242,18.624,8.364l3.739-4.819C48.721,22.666,40.791,19,32,19S15.279,22.666,9.637,28.544z"},"children":[{"name":"path","attribs":{"d":"M32,49c-3.314,0-6,2.686-6,6s2.686,6,6,6c3.314,0,6-2.686,6-6S35.314,49,32,49z M32,34\r\n\t\t\t\tc-5.343,0-10.062,2.629-12.968,6.654l3.302,4.256C24.519,41.938,28.029,40,32,40c3.971,0,7.482,1.938,9.666,4.91l3.302-4.256\r\n\t\t\t\tC42.062,36.629,37.343,34,32,34z M32,4C19.747,4,8.622,8.8,0.378,16.61l3.696,4.764C11.283,14.34,21.132,10,32,10\r\n\t\t\t\ts20.717,4.34,27.926,11.374l3.696-4.764C55.378,8.8,44.253,4,32,4z M9.637,28.544l3.739,4.819C17.954,28.242,24.59,25,32,25\r\n\t\t\t\ts14.046,3.242,18.624,8.364l3.739-4.819C48.721,22.666,40.791,19,32,19S15.279,22.666,9.637,28.544z"},"children":[]}]}]}]}]}]}]}]};exports.wifi_3=wifi_3;var windows={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"windows_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"windows"},"children":[{"name":"g","attribs":{"id":"windows"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0.015,30.236h25.809V5.541L0.015,9.28V30.236z M29.353,5.029v25.207h34.631V0.015L29.353,5.029z M0.015,54.721\r\n\t\t\t\tl25.809,3.738V33.766H0.015V54.721z M29.353,58.971l34.631,5.014V33.766H29.353V58.971z"},"children":[{"name":"path","attribs":{"d":"M0.015,30.236h25.809V5.541L0.015,9.28V30.236z M29.353,5.029v25.207h34.631V0.015L29.353,5.029z M0.015,54.721\r\n\t\t\t\tl25.809,3.738V33.766H0.015V54.721z M29.353,58.971l34.631,5.014V33.766H29.353V58.971z"},"children":[]}]}]}]}]}]}]}]};exports.windows=windows;var youtube={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"youtube_1_","enable-background":"new    "},"children":[{"name":"g","attribs":{"id":"youtube"},"children":[{"name":"g","attribs":{"id":"youtube"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M54.15,10.031l-20.9-0.019l-21.718,0.019c-5.433,0-11.534,3.626-11.534,8.944v26.474c0,5.316,6.101,8.559,11.534,8.559\r\n\t\t\t\tH54.15c5.432,0,9.834-3.242,9.834-8.559V18.976C63.984,13.657,59.582,10.031,54.15,10.031z M27.856,42.205L27.73,22.044\r\n\t\t\t\tl14.03,10.168L27.856,42.205z"},"children":[{"name":"path","attribs":{"d":"M54.15,10.031l-20.9-0.019l-21.718,0.019c-5.433,0-11.534,3.626-11.534,8.944v26.474c0,5.316,6.101,8.559,11.534,8.559\r\n\t\t\t\tH54.15c5.432,0,9.834-3.242,9.834-8.559V18.976C63.984,13.657,59.582,10.031,54.15,10.031z M27.856,42.205L27.73,22.044\r\n\t\t\t\tl14.03,10.168L27.856,42.205z"},"children":[]}]}]}]}]}]}]}]};exports.youtube=youtube;var zoom_in={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ZOOM_IN"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V19c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10H19\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h10c1.657,0,3-1.343,3-3\r\n\t\t\tC48,30.344,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c0.003,0,0.005,0,0.008,0H61\r\n\t\t\tc1.657,0,3-1.343,3-3V32.002c0-0.001,0-0.001,0-0.002C64,14.327,49.673,0,32,0z M58,32.001C58,46.359,46.361,57.998,32.004,58H32\r\n\t\t\tv0C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6S58,17.641,58,32.001L58,32.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35V19c0-1.657-1.343-3-3-3c-1.657,0-3,1.343-3,3v10H19\r\n\t\t\tc-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h10v10c0,1.657,1.343,3,3,3c1.657,0,3-1.343,3-3V35h10c1.657,0,3-1.343,3-3\r\n\t\t\tC48,30.344,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c0.003,0,0.005,0,0.008,0H61\r\n\t\t\tc1.657,0,3-1.343,3-3V32.002c0-0.001,0-0.001,0-0.002C64,14.327,49.673,0,32,0z M58,32.001C58,46.359,46.361,57.998,32.004,58H32\r\n\t\t\tv0C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6S58,17.641,58,32.001L58,32.001z"},"children":[]}]}]}]}]}]};exports.zoom_in=zoom_in;var zoom_out={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{"id":"ZOOM_OUT"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35v0h-6v0H19c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h5v0h19v0h2\r\n\t\t\tc1.657,0,3-1.343,3-3C48,30.344,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c0.003,0,0.005,0,0.007,0\r\n\t\t\tH61c1.657,0,3-1.343,3-3V32.002c0-0.001,0-0.001,0-0.002C64,14.327,49.673,0,32,0z M58,32.001C58,46.359,46.361,57.998,32.004,58\r\n\t\t\tH32v0C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6C46.36,6,58,17.641,58,32.001L58,32.001z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M45,29H35v0h-6v0H19c-1.657,0-3,1.343-3,3c0,1.657,1.343,3,3,3h5v0h19v0h2\r\n\t\t\tc1.657,0,3-1.343,3-3C48,30.344,46.657,29,45,29z M32,0C14.327,0,0,14.327,0,32c0,17.673,14.327,32,32,32c0.003,0,0.005,0,0.007,0\r\n\t\t\tH61c1.657,0,3-1.343,3-3V32.002c0-0.001,0-0.001,0-0.002C64,14.327,49.673,0,32,0z M58,32.001C58,46.359,46.361,57.998,32.004,58\r\n\t\t\tH32v0C17.641,58,6,46.36,6,32C6,17.641,17.641,6,32,6C46.36,6,58,17.641,58,32.001L58,32.001z"},"children":[]}]}]}]}]}]};exports.zoom_out=zoom_out;

/***/ }),
/* 1408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.androidRadioButtonOn=exports.androidRadioButtonOff=exports.androidPrint=exports.androidPlaystore=exports.androidPlane=exports.androidPin=exports.androidPhonePortrait=exports.androidPhoneLandscape=exports.androidPerson=exports.androidPersonAdd=exports.androidPeople=exports.androidOptions=exports.androidOpen=exports.androidNotifications=exports.androidNotificationsOff=exports.androidNotificationsNone=exports.androidNavigate=exports.androidMoreVertical=exports.androidMoreHorizontal=exports.androidMicrophone=exports.androidMicrophoneOff=exports.androidMenu=exports.androidMap=exports.androidMail=exports.androidLock=exports.androidLocate=exports.androidList=exports.androidLaptop=exports.androidImage=exports.androidHome=exports.androidHappy=exports.androidHangout=exports.androidHand=exports.androidGlobe=exports.androidFunnel=exports.androidFolder=exports.androidFolderOpen=exports.androidFilm=exports.androidFavorite=exports.androidFavoriteOutline=exports.androidExpand=exports.androidExit=exports.androidDrafts=exports.androidDownload=exports.androidDone=exports.androidDoneAll=exports.androidDocument=exports.androidDesktop=exports.androidDelete=exports.androidCreate=exports.androidContract=exports.androidContacts=exports.androidContact=exports.androidCompass=exports.androidColorPalette=exports.androidCloud=exports.androidCloudOutline=exports.androidCloudDone=exports.androidCloudCircle=exports.androidClose=exports.androidClipboard=exports.androidCheckmarkCircle=exports.androidCheckbox=exports.androidCheckboxOutline=exports.androidCheckboxOutlineBlank=exports.androidCheckboxBlank=exports.androidChat=exports.androidCart=exports.androidCar=exports.androidCancel=exports.androidCamera=exports.androidCall=exports.androidCalendar=exports.androidBus=exports.androidBulb=exports.androidBookmark=exports.androidBoat=exports.androidBicycle=exports.androidBar=exports.androidAttach=exports.androidArrowUp=exports.androidArrowForward=exports.androidArrowDropup=exports.androidArrowDropupCircle=exports.androidArrowDropright=exports.androidArrowDroprightCircle=exports.androidArrowDropleft=exports.androidArrowDropleftCircle=exports.androidArrowDropdown=exports.androidArrowDropdownCircle=exports.androidArrowDown=exports.androidArrowBack=exports.androidArchive=exports.androidApps=exports.androidAlert=exports.androidAlarmClock=exports.androidAdd=exports.androidAddCircle=exports.alert=exports.alertCircled=void 0;exports.codeWorking=exports.codeDownload=exports.cloud=exports.closedCaptioning=exports.close=exports.closeRound=exports.closeCircled=exports.clock=exports.clipboard=exports.chevronUp=exports.chevronRight=exports.chevronLeft=exports.chevronDown=exports.checkmark=exports.checkmarkRound=exports.checkmarkCircled=exports.chatbubbles=exports.chatbubble=exports.chatbubbleWorking=exports.chatboxes=exports.chatbox=exports.chatboxWorking=exports.cash=exports.card=exports.camera=exports.calendar=exports.calculator=exports.bug=exports.briefcase=exports.bowtie=exports.bookmark=exports.bonfire=exports.bluetooth=exports.beer=exports.beaker=exports.batteryLow=exports.batteryHalf=exports.batteryFull=exports.batteryEmpty=exports.batteryCharging=exports.bag=exports.backspace=exports.backspaceOutline=exports.at=exports.asterisk=exports.arrowUpC=exports.arrowUpB=exports.arrowUpA=exports.arrowSwap=exports.arrowShrink=exports.arrowRightC=exports.arrowRightB=exports.arrowRightA=exports.arrowReturnRight=exports.arrowReturnLeft=exports.arrowResize=exports.arrowMove=exports.arrowLeftC=exports.arrowLeftB=exports.arrowLeftA=exports.arrowGraphUpRight=exports.arrowGraphUpLeft=exports.arrowGraphDownRight=exports.arrowGraphDownLeft=exports.arrowExpand=exports.arrowDownC=exports.arrowDownB=exports.arrowDownA=exports.archive=exports.aperture=exports.androidWifi=exports.androidWatch=exports.androidWarning=exports.androidWalk=exports.androidVolumeUp=exports.androidVolumeOff=exports.androidVolumeMute=exports.androidVolumeDown=exports.androidUpload=exports.androidUnlock=exports.androidTrain=exports.androidTime=exports.androidTextsms=exports.androidSync=exports.androidSunny=exports.androidSubway=exports.androidStopwatch=exports.androidStar=exports.androidStarOutline=exports.androidStarHalf=exports.androidShare=exports.androidShareAlt=exports.androidSettings=exports.androidSend=exports.androidSearch=exports.androidSad=exports.androidRestaurant=exports.androidRemove=exports.androidRemoveCircle=exports.androidRefresh=void 0;exports.iosCalendarOutline=exports.iosCalculator=exports.iosCalculatorOutline=exports.iosBrowsers=exports.iosBrowsersOutline=exports.iosBriefcase=exports.iosBriefcaseOutline=exports.iosBox=exports.iosBoxOutline=exports.iosBookmarks=exports.iosBookmarksOutline=exports.iosBook=exports.iosBookOutline=exports.iosBolt=exports.iosBoltOutline=exports.iosBody=exports.iosBodyOutline=exports.iosBell=exports.iosBellOutline=exports.iosBasketball=exports.iosBasketballOutline=exports.iosBaseball=exports.iosBaseballOutline=exports.iosBarcode=exports.iosBarcodeOutline=exports.iosAt=exports.iosAtOutline=exports.iosArrowUp=exports.iosArrowThinUp=exports.iosArrowThinRight=exports.iosArrowThinLeft=exports.iosArrowThinDown=exports.iosArrowRight=exports.iosArrowLeft=exports.iosArrowForward=exports.iosArrowDown=exports.iosArrowBack=exports.iosAnalytics=exports.iosAnalyticsOutline=exports.iosAmericanfootball=exports.iosAmericanfootballOutline=exports.iosAlbums=exports.iosAlbumsOutline=exports.iosAlarm=exports.iosAlarmOutline=exports.ionic=exports.information=exports.informationCircled=exports.images=exports.image=exports.icecream=exports.home=exports.help=exports.helpCircled=exports.helpBuoy=exports.heart=exports.heartBroken=exports.headphone=exports.happy=exports.happyOutline=exports.hammer=exports.grid=exports.gearB=exports.gearA=exports.funnel=exports.forward=exports.fork=exports.forkRepo=exports.folder=exports.flash=exports.flashOff=exports.flame=exports.flag=exports.fireball=exports.filmMarker=exports.filing=exports.female=exports.eye=exports.eyeDisabled=exports.erlenmeyerFlask=exports.erlenmeyerFlaskBubbles=exports.email=exports.emailUnread=exports.eject=exports.egg=exports.edit=exports.easel=exports.earth=exports.drag=exports.documentIcon=exports.documentText=exports.disc=exports.cube=exports.crop=exports.contrast=exports.connectionBars=exports.compose=exports.compass=exports.coffee=exports.code=void 0;exports.iosLockedOutline=exports.iosLocation=exports.iosLocationOutline=exports.iosList=exports.iosListOutline=exports.iosLightbulb=exports.iosLightbulbOutline=exports.iosKeypad=exports.iosKeypadOutline=exports.iosIonicOutline=exports.iosInformation=exports.iosInformationOutline=exports.iosInformationEmpty=exports.iosInfinite=exports.iosInfiniteOutline=exports.iosHome=exports.iosHomeOutline=exports.iosHelp=exports.iosHelpOutline=exports.iosHelpEmpty=exports.iosHeart=exports.iosHeartOutline=exports.iosGridView=exports.iosGridViewOutline=exports.iosGlasses=exports.iosGlassesOutline=exports.iosGear=exports.iosGearOutline=exports.iosGameControllerB=exports.iosGameControllerBOutline=exports.iosGameControllerA=exports.iosGameControllerAOutline=exports.iosFootball=exports.iosFootballOutline=exports.iosFolder=exports.iosFolderOutline=exports.iosFlower=exports.iosFlowerOutline=exports.iosFlask=exports.iosFlaskOutline=exports.iosFlame=exports.iosFlameOutline=exports.iosFlag=exports.iosFlagOutline=exports.iosFilm=exports.iosFilmOutline=exports.iosFiling=exports.iosFilingOutline=exports.iosFastforward=exports.iosFastforwardOutline=exports.iosEye=exports.iosEyeOutline=exports.iosEmail=exports.iosEmailOutline=exports.iosDrag=exports.iosDownload=exports.iosDownloadOutline=exports.iosCrop=exports.iosCropStrong=exports.iosCopy=exports.iosCopyOutline=exports.iosContact=exports.iosContactOutline=exports.iosCompose=exports.iosComposeOutline=exports.iosColorWand=exports.iosColorWandOutline=exports.iosColorFilter=exports.iosColorFilterOutline=exports.iosCog=exports.iosCogOutline=exports.iosCloudy=exports.iosCloudyOutline=exports.iosCloudyNight=exports.iosCloudyNightOutline=exports.iosCloud=exports.iosCloudUpload=exports.iosCloudUploadOutline=exports.iosCloudOutline=exports.iosCloudDownload=exports.iosCloudDownloadOutline=exports.iosClose=exports.iosCloseOutline=exports.iosCloseEmpty=exports.iosClock=exports.iosClockOutline=exports.iosCircleOutline=exports.iosCircleFilled=exports.iosCheckmark=exports.iosCheckmarkOutline=exports.iosCheckmarkEmpty=exports.iosChatbubble=exports.iosChatbubbleOutline=exports.iosChatboxes=exports.iosChatboxesOutline=exports.iosCart=exports.iosCartOutline=exports.iosCamera=exports.iosCameraOutline=exports.iosCalendar=void 0;exports.iosTennisball=exports.iosTennisballOutline=exports.iosTelephone=exports.iosTelephoneOutline=exports.iosSunny=exports.iosSunnyOutline=exports.iosStopwatch=exports.iosStopwatchOutline=exports.iosStar=exports.iosStarOutline=exports.iosStarHalf=exports.iosSpeedometer=exports.iosSpeedometerOutline=exports.iosSnowy=exports.iosSkipforward=exports.iosSkipforwardOutline=exports.iosSkipbackward=exports.iosSkipbackwardOutline=exports.iosShuffle=exports.iosShuffleStrong=exports.iosSettings=exports.iosSettingsStrong=exports.iosSearch=exports.iosSearchStrong=exports.iosRose=exports.iosRoseOutline=exports.iosRewind=exports.iosRewindOutline=exports.iosReverseCamera=exports.iosReverseCameraOutline=exports.iosReload=exports.iosRefresh=exports.iosRefreshOutline=exports.iosRefreshEmpty=exports.iosRedo=exports.iosRedoOutline=exports.iosRecording=exports.iosRecordingOutline=exports.iosRainy=exports.iosRainyOutline=exports.iosPulse=exports.iosPulseStrong=exports.iosPrinter=exports.iosPrinterOutline=exports.iosPricetags=exports.iosPricetagsOutline=exports.iosPricetag=exports.iosPricetagOutline=exports.iosPlus=exports.iosPlusOutline=exports.iosPlusEmpty=exports.iosPlay=exports.iosPlayOutline=exports.iosPint=exports.iosPintOutline=exports.iosPie=exports.iosPieOutline=exports.iosPhotos=exports.iosPhotosOutline=exports.iosPersonadd=exports.iosPersonaddOutline=exports.iosPerson=exports.iosPersonOutline=exports.iosPeople=exports.iosPeopleOutline=exports.iosPaw=exports.iosPawOutline=exports.iosPause=exports.iosPauseOutline=exports.iosPartlysunny=exports.iosPartlysunnyOutline=exports.iosPaperplane=exports.iosPaperplaneOutline=exports.iosPaper=exports.iosPaperOutline=exports.iosNutrition=exports.iosNutritionOutline=exports.iosNavigate=exports.iosNavigateOutline=exports.iosMusicalNotes=exports.iosMusicalNote=exports.iosMore=exports.iosMoreOutline=exports.iosMoon=exports.iosMoonOutline=exports.iosMonitor=exports.iosMonitorOutline=exports.iosMinus=exports.iosMinusOutline=exports.iosMinusEmpty=exports.iosMic=exports.iosMicOutline=exports.iosMicOff=exports.iosMedkit=exports.iosMedkitOutline=exports.iosMedical=exports.iosMedicalOutline=exports.iosLoop=exports.iosLoopStrong=exports.iosLocked=void 0;exports.refresh=exports.record=exports.radioWaves=exports.quote=exports.qrScanner=exports.pullRequest=exports.printer=exports.pricetags=exports.pricetag=exports.power=exports.pound=exports.podium=exports.plus=exports.plusRound=exports.plusCircled=exports.playstation=exports.play=exports.planet=exports.plane=exports.pizza=exports.pinpoint=exports.pin=exports.pieGraph=exports.person=exports.personStalker=exports.personAdd=exports.pause=exports.paperclip=exports.paperAirplane=exports.paintbucket=exports.paintbrush=exports.outlet=exports.nuclear=exports.noSmoking=exports.network=exports.navigate=exports.navicon=exports.naviconRound=exports.musicNote=exports.mouse=exports.more=exports.monitor=exports.modelS=exports.minus=exports.minusRound=exports.minusCircled=exports.micC=exports.micB=exports.micA=exports.merge=exports.medkit=exports.map=exports.man=exports.male=exports.magnet=exports.loop=exports.logOut=exports.logIn=exports.locked=exports.lockCombination=exports.location=exports.loadD=exports.loadC=exports.loadB=exports.loadA=exports.link=exports.lightbulb=exports.levels=exports.leaf=exports.laptop=exports.knife=exports.key=exports.jet=exports.ipod=exports.iphone=exports.ipad=exports.iosWorld=exports.iosWorldOutline=exports.iosWineglass=exports.iosWineglassOutline=exports.iosVolumeLow=exports.iosVolumeHigh=exports.iosVideocam=exports.iosVideocamOutline=exports.iosUpload=exports.iosUploadOutline=exports.iosUnlocked=exports.iosUnlockedOutline=exports.iosUndo=exports.iosUndoOutline=exports.iosTrash=exports.iosTrashOutline=exports.iosToggle=exports.iosToggleOutline=exports.iosTimer=exports.iosTimerOutline=exports.iosTime=exports.iosTimeOutline=exports.iosThunderstorm=exports.iosThunderstormOutline=void 0;exports.speedometer=exports.speakerphone=exports.soupCan=exports.soupCanOutline=exports.socialYoutube=exports.socialYoutubeOutline=exports.socialYen=exports.socialYenOutline=exports.socialYahoo=exports.socialYahooOutline=exports.socialWordpress=exports.socialWordpressOutline=exports.socialWindows=exports.socialWindowsOutline=exports.socialWhatsapp=exports.socialWhatsappOutline=exports.socialVimeo=exports.socialVimeoOutline=exports.socialUsd=exports.socialUsdOutline=exports.socialTwitter=exports.socialTwitterOutline=exports.socialTwitch=exports.socialTwitchOutline=exports.socialTux=exports.socialTumblr=exports.socialTumblrOutline=exports.socialSnapchat=exports.socialSnapchatOutline=exports.socialSkype=exports.socialSkypeOutline=exports.socialSass=exports.socialRss=exports.socialRssOutline=exports.socialReddit=exports.socialRedditOutline=exports.socialPython=exports.socialPinterest=exports.socialPinterestOutline=exports.socialOctocat=exports.socialNodejs=exports.socialMarkdown=exports.socialLinkedin=exports.socialLinkedinOutline=exports.socialJavascript=exports.socialJavascriptOutline=exports.socialInstagram=exports.socialInstagramOutline=exports.socialHtml5=exports.socialHtml5Outline=exports.socialHackernews=exports.socialHackernewsOutline=exports.socialGoogleplus=exports.socialGoogleplusOutline=exports.socialGoogle=exports.socialGoogleOutline=exports.socialGithub=exports.socialGithubOutline=exports.socialFreebsdDevil=exports.socialFoursquare=exports.socialFoursquareOutline=exports.socialFacebook=exports.socialFacebookOutline=exports.socialEuro=exports.socialEuroOutline=exports.socialDropbox=exports.socialDropboxOutline=exports.socialDribbble=exports.socialDribbbleOutline=exports.socialDesignernews=exports.socialDesignernewsOutline=exports.socialCss3=exports.socialCss3Outline=exports.socialCodepen=exports.socialCodepenOutline=exports.socialChrome=exports.socialChromeOutline=exports.socialBuffer=exports.socialBufferOutline=exports.socialBitcoin=exports.socialBitcoinOutline=exports.socialApple=exports.socialAppleOutline=exports.socialAngular=exports.socialAngularOutline=exports.socialAndroid=exports.socialAndroidOutline=exports.skipForward=exports.skipBackward=exports.shuffle=exports.share=exports.settings=exports.search=exports.scissors=exports.sad=exports.sadOutline=exports.ribbonB=exports.ribbonA=exports.reply=exports.replyAll=void 0;exports.xbox=exports.wrench=exports.woman=exports.wineglass=exports.wifi=exports.waterdrop=exports.wand=exports.volumeMute=exports.volumeMedium=exports.volumeLow=exports.volumeHigh=exports.videocamera=exports.usb=exports.upload=exports.unlocked=exports.university=exports.umbrella=exports.tshirt=exports.tshirtOutline=exports.trophy=exports.trashB=exports.trashA=exports.transgender=exports.toggle=exports.toggleFilled=exports.thumbsup=exports.thumbsdown=exports.thermometer=exports.stop=exports.steam=exports.statsBars=exports.star=exports.spoon=void 0;var alertCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M476.7,422.2L270.1,72.7c-2.9-5-8.3-8.7-14.1-8.7c-5.9,0-11.3,3.7-14.1,8.7L35.3,422.2c-2.8,5-4.8,13-1.9,17.9\r\n\t\tc2.9,4.9,8.2,7.9,14,7.9h417.1c5.8,0,11.1-3,14-7.9C481.5,435.2,479.5,427.1,476.7,422.2z M288,400h-64v-48h64V400z M288,320h-64\r\n\t\tV176h64V320z"},"children":[{"name":"path","attribs":{"d":"M476.7,422.2L270.1,72.7c-2.9-5-8.3-8.7-14.1-8.7c-5.9,0-11.3,3.7-14.1,8.7L35.3,422.2c-2.8,5-4.8,13-1.9,17.9\r\n\t\tc2.9,4.9,8.2,7.9,14,7.9h417.1c5.8,0,11.1-3,14-7.9C481.5,435.2,479.5,427.1,476.7,422.2z M288,400h-64v-48h64V400z M288,320h-64\r\n\t\tV176h64V320z"},"children":[]}]}]}]};exports.alertCircled=alertCircled;var alert={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M320,480H192v-96h128V480z M304,320h-96L192,32h128L304,320z"},"children":[{"name":"path","attribs":{"d":"M320,480H192v-96h128V480z M304,320h-96L192,32h128L304,320z"},"children":[]}]}]}]};exports.alert=alert;var androidAddCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M363,277h-86v86h-42v-86\r\n\t\t\th-86v-42h86v-86h42v86h86V277z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M363,277h-86v86h-42v-86\r\n\t\t\th-86v-42h86v-86h42v86h86V277z"},"children":[]}]}]}]}]}]};exports.androidAddCircle=androidAddCircle;var androidAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_7_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416V277.333z"},"children":[{"name":"path","attribs":{"d":"M416,277.333H277.333V416h-42.666V277.333H96v-42.666h138.667V96h42.666v138.667H416V277.333z"},"children":[]}]}]}]}]}]};exports.androidAdd=androidAdd;var androidAlarmClock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_2_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M470,124.837l-98.443-81.78l-27.814,32.931l98.442,81.769L470,124.837z M167.192,74.919L139.366,42L42,124.837\r\n\t\t\tl27.814,32.919L167.192,74.919z M266.701,172.628h-32.101v127.446l101.649,60.539l16.051-26.553l-85.6-49.917V172.628z\r\n\t\t\t M256,87.665c-107,0-192.601,86.021-192.601,191.166C63.399,383.98,149,470,256,470c105.936,0,192.601-86.02,192.601-191.169\r\n\t\t\tC448.601,173.687,361.936,87.665,256,87.665z M256,427.52c-82.393,0-149.8-66.906-149.8-148.688\r\n\t\t\tc0-81.777,67.407-148.684,149.8-148.684c82.394,0,149.8,66.906,149.8,148.684C405.8,361.671,338.394,427.52,256,427.52z"},"children":[{"name":"path","attribs":{"d":"M470,124.837l-98.443-81.78l-27.814,32.931l98.442,81.769L470,124.837z M167.192,74.919L139.366,42L42,124.837\r\n\t\t\tl27.814,32.919L167.192,74.919z M266.701,172.628h-32.101v127.446l101.649,60.539l16.051-26.553l-85.6-49.917V172.628z\r\n\t\t\t M256,87.665c-107,0-192.601,86.021-192.601,191.166C63.399,383.98,149,470,256,470c105.936,0,192.601-86.02,192.601-191.169\r\n\t\t\tC448.601,173.687,361.936,87.665,256,87.665z M256,427.52c-82.393,0-149.8-66.906-149.8-148.688\r\n\t\t\tc0-81.777,67.407-148.684,149.8-148.684c82.394,0,149.8,66.906,149.8,148.684C405.8,361.671,338.394,427.52,256,427.52z"},"children":[]}]}]}]}]}]};exports.androidAlarmClock=androidAlarmClock;var androidAlert={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_30_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.6,48,48,141.601,48,256s93.6,208,208,208c114.4,0,208-93.601,208-208S370.4,48,256,48z M280,360h-48v-40h48\r\n\t\t\tV360z M280,272h-48V144h48V272z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.6,48,48,141.601,48,256s93.6,208,208,208c114.4,0,208-93.601,208-208S370.4,48,256,48z M280,360h-48v-40h48\r\n\t\t\tV360z M280,272h-48V144h48V272z"},"children":[]}]}]}]}]}]};exports.androidAlert=androidAlert;var androidApps={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M96,176h80V96H96V176z M216,416h80v-80h-80V416z M96,416h80v-80H96V416z M96,296h80v-80H96V296z M216,296h80v-80h-80V296z\r\n\t\t\t M336,96v80h80V96H336z M216,176h80V96h-80V176z M336,296h80v-80h-80V296z M336,416h80v-80h-80V416z"},"children":[{"name":"path","attribs":{"d":"M96,176h80V96H96V176z M216,416h80v-80h-80V416z M96,416h80v-80H96V416z M96,296h80v-80H96V296z M216,296h80v-80h-80V296z\r\n\t\t\t M336,96v80h80V96H336z M216,176h80V96h-80V176z M336,296h80v-80h-80V296z M336,416h80v-80h-80V416z"},"children":[]}]}]}]}]}]};exports.androidApps=androidApps;var androidArchive={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M453.594,100.001l-32.353-39.299C415.469,52.627,405.083,48,394.664,48H117.335c-10.416,0-20.801,4.627-26.576,12.702\r\n\t\tl-32.351,39.299C51.468,106.923,48,117.335,48,128.886v288.89C48,443.2,68.8,464,94.225,464h323.553\r\n\t\tC443.202,464,464,443.2,464,417.775v-288.89C464,117.335,460.537,106.923,453.594,100.001z M256,383.109L128.89,256h80.89v-46.224\r\n\t\th92.443V256h80.89L256,383.109z M96.534,94.221l18.486-23.111h277.331l21.965,23.111H96.534z"},"children":[{"name":"path","attribs":{"d":"M453.594,100.001l-32.353-39.299C415.469,52.627,405.083,48,394.664,48H117.335c-10.416,0-20.801,4.627-26.576,12.702\r\n\t\tl-32.351,39.299C51.468,106.923,48,117.335,48,128.886v288.89C48,443.2,68.8,464,94.225,464h323.553\r\n\t\tC443.202,464,464,443.2,464,417.775v-288.89C464,117.335,460.537,106.923,453.594,100.001z M256,383.109L128.89,256h80.89v-46.224\r\n\t\th92.443V256h80.89L256,383.109z M96.534,94.221l18.486-23.111h277.331l21.965,23.111H96.534z"},"children":[]}]}]}]};exports.androidArchive=androidArchive;var androidArrowBack={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_8_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M427,234.625H167.296l119.702-119.702L256,85L85,256l171,171l29.922-29.924L167.296,277.375H427V234.625z"},"children":[{"name":"path","attribs":{"d":"M427,234.625H167.296l119.702-119.702L256,85L85,256l171,171l29.922-29.924L167.296,277.375H427V234.625z"},"children":[]}]}]}]}]}]};exports.androidArrowBack=androidArrowBack;var androidArrowDown={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_8_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M277.375,85v259.704l119.702-119.702L427,256L256,427L85,256l29.924-29.922l119.701,118.626V85H277.375z"},"children":[{"name":"path","attribs":{"d":"M277.375,85v259.704l119.702-119.702L427,256L256,427L85,256l29.924-29.922l119.701,118.626V85H277.375z"},"children":[]}]}]}]}]}]};exports.androidArrowDown=androidArrowDown;var androidArrowDropdownCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M256,320l-96-96h192\r\n\t\tL256,320z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M256,320l-96-96h192\r\n\t\tL256,320z"},"children":[]}]}]}]};exports.androidArrowDropdownCircle=androidArrowDropdownCircle;var androidArrowDropdown={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"128,192 256,320 384,192 \t"},"children":[{"name":"polygon","attribs":{"points":"128,192 256,320 384,192 \t"},"children":[]}]}]}]};exports.androidArrowDropdown=androidArrowDropdown;var androidArrowDropleftCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M464,256c0-114.875-93.125-208-208-208S48,141.125,48,256s93.125,208,208,208S464,370.875,464,256z M192,256l96-96v192\r\n\t\tL192,256z"},"children":[{"name":"path","attribs":{"d":"M464,256c0-114.875-93.125-208-208-208S48,141.125,48,256s93.125,208,208,208S464,370.875,464,256z M192,256l96-96v192\r\n\t\tL192,256z"},"children":[]}]}]}]};exports.androidArrowDropleftCircle=androidArrowDropleftCircle;var androidArrowDropleft={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"320,128 192,256 320,384 \t"},"children":[{"name":"polygon","attribs":{"points":"320,128 192,256 320,384 \t"},"children":[]}]}]}]};exports.androidArrowDropleft=androidArrowDropleft;var androidArrowDroprightCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,464c114.875,0,208-93.125,208-208S370.875,48,256,48S48,141.125,48,256S141.125,464,256,464z M224,352V160l96,96\r\n\t\tL224,352z"},"children":[{"name":"path","attribs":{"d":"M256,464c114.875,0,208-93.125,208-208S370.875,48,256,48S48,141.125,48,256S141.125,464,256,464z M224,352V160l96,96\r\n\t\tL224,352z"},"children":[]}]}]}]};exports.androidArrowDroprightCircle=androidArrowDroprightCircle;var androidArrowDropright={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"192,128 320,256 192,384 \t"},"children":[{"name":"polygon","attribs":{"points":"192,128 320,256 192,384 \t"},"children":[]}]}]}]};exports.androidArrowDropright=androidArrowDropright;var androidArrowDropupCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M464,256c0-114.875-93.125-208-208-208S48,141.125,48,256s93.125,208,208,208S464,370.875,464,256z M352,288H160l96-96\r\n\t\tL352,288z"},"children":[{"name":"path","attribs":{"d":"M464,256c0-114.875-93.125-208-208-208S48,141.125,48,256s93.125,208,208,208S464,370.875,464,256z M352,288H160l96-96\r\n\t\tL352,288z"},"children":[]}]}]}]};exports.androidArrowDropupCircle=androidArrowDropupCircle;var androidArrowDropup={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"128,320 256,192 384,320 \t"},"children":[{"name":"polygon","attribs":{"points":"128,320 256,192 384,320 \t"},"children":[]}]}]}]};exports.androidArrowDropup=androidArrowDropup;var androidArrowForward={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_8_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M85,277.375h259.704L225.002,397.077L256,427l171-171L256,85l-29.922,29.924l118.626,119.701H85V277.375z"},"children":[{"name":"path","attribs":{"d":"M85,277.375h259.704L225.002,397.077L256,427l171-171L256,85l-29.922,29.924l118.626,119.701H85V277.375z"},"children":[]}]}]}]}]}]};exports.androidArrowForward=androidArrowForward;var androidArrowUp={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_8_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M277.375,427V167.296l119.702,119.702L427,256L256,85L85,256l29.924,29.922l119.701-118.626V427H277.375z"},"children":[{"name":"path","attribs":{"d":"M277.375,427V167.296l119.702,119.702L427,256L256,85L85,256l29.924,29.922l119.701-118.626V427H277.375z"},"children":[]}]}]}]}]}]};exports.androidArrowUp=androidArrowUp;var androidAttach={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_3_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M341.334,128v234.666C341.334,409.604,302.938,448,256,448c-46.937,0-85.333-38.396-85.333-85.334V117.334\r\n\t\t\tC170.667,87.469,194.135,64,224,64c29.864,0,53.333,23.469,53.333,53.334v245.333c0,11.729-9.605,21.333-21.334,21.333\r\n\t\t\tc-11.729,0-21.333-9.604-21.333-21.333V160h-32v202.667C202.667,392.531,226.135,416,256,416\r\n\t\t\tc29.865,0,53.334-23.469,53.334-53.333V117.334C309.334,70.401,270.938,32,224,32c-46.938,0-85.334,38.401-85.334,85.334v245.332\r\n\t\t\tC138.667,427.729,190.938,480,256,480c65.062,0,117.334-52.271,117.334-117.334V128H341.334z"},"children":[{"name":"path","attribs":{"d":"M341.334,128v234.666C341.334,409.604,302.938,448,256,448c-46.937,0-85.333-38.396-85.333-85.334V117.334\r\n\t\t\tC170.667,87.469,194.135,64,224,64c29.864,0,53.333,23.469,53.333,53.334v245.333c0,11.729-9.605,21.333-21.334,21.333\r\n\t\t\tc-11.729,0-21.333-9.604-21.333-21.333V160h-32v202.667C202.667,392.531,226.135,416,256,416\r\n\t\t\tc29.865,0,53.334-23.469,53.334-53.333V117.334C309.334,70.401,270.938,32,224,32c-46.938,0-85.334,38.401-85.334,85.334v245.332\r\n\t\t\tC138.667,427.729,190.938,480,256,480c65.062,0,117.334-52.271,117.334-117.334V128H341.334z"},"children":[]}]}]}]}]}]};exports.androidAttach=androidAttach;var androidBar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_37_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M234.667,277.333V408H128v40h256v-40H277.333V277.333L448,106.667V64H64v42.667L234.667,277.333z M160,149.333\r\n\t\t\tl-42.667-42.666h277.334L352,149.333H160z"},"children":[{"name":"path","attribs":{"d":"M234.667,277.333V408H128v40h256v-40H277.333V277.333L448,106.667V64H64v42.667L234.667,277.333z M160,149.333\r\n\t\t\tl-42.667-42.666h277.334L352,149.333H160z"},"children":[]}]}]}]}]}]};exports.androidBar=androidBar;var androidBicycle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_13_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M330.666,131.202c18.668,0,33.598-14.935,33.598-33.601S349.334,64,330.666,64C312,64,297.07,78.935,297.07,97.601\r\n\t\t\tS312,131.202,330.666,131.202z M386.666,261.334c-51.332,0-93.332,42-93.332,93.333s42,93.333,93.332,93.333\r\n\t\t\tC438,448,480,406,480,354.667S438,261.334,386.666,261.334z M386.666,420c-36.402,0-65.332-28.93-65.332-65.333\r\n\t\t\ts28.93-65.333,65.332-65.333c36.404,0,65.334,28.93,65.334,65.333S423.07,420,386.666,420z M305.597,224H384v-32h-58.845\r\n\t\t\tl-34.62-60.134c-5.605-9.333-15.869-15.864-27.07-15.864c-8.399,0-16.798,3.732-22.399,9.333l-71.732,69.065\r\n\t\t\tc-5.601,5.601-9.333,14-9.333,22.399c0,12.131,9.202,21.465,18.535,27.065L240,282.134V368h32V256l-39.333-32l42.929-44.533\r\n\t\t\tL305.597,224z M125.333,261.334C74,261.334,32,303.334,32,354.667S74,448,125.333,448c51.333,0,93.333-42,93.333-93.333\r\n\t\t\tS176.667,261.334,125.333,261.334z M125.333,420C88.934,420,60,391.07,60,354.667s28.934-65.333,65.333-65.333\r\n\t\t\tc36.399,0,65.333,28.93,65.333,65.333S161.732,420,125.333,420z"},"children":[{"name":"path","attribs":{"d":"M330.666,131.202c18.668,0,33.598-14.935,33.598-33.601S349.334,64,330.666,64C312,64,297.07,78.935,297.07,97.601\r\n\t\t\tS312,131.202,330.666,131.202z M386.666,261.334c-51.332,0-93.332,42-93.332,93.333s42,93.333,93.332,93.333\r\n\t\t\tC438,448,480,406,480,354.667S438,261.334,386.666,261.334z M386.666,420c-36.402,0-65.332-28.93-65.332-65.333\r\n\t\t\ts28.93-65.333,65.332-65.333c36.404,0,65.334,28.93,65.334,65.333S423.07,420,386.666,420z M305.597,224H384v-32h-58.845\r\n\t\t\tl-34.62-60.134c-5.605-9.333-15.869-15.864-27.07-15.864c-8.399,0-16.798,3.732-22.399,9.333l-71.732,69.065\r\n\t\t\tc-5.601,5.601-9.333,14-9.333,22.399c0,12.131,9.202,21.465,18.535,27.065L240,282.134V368h32V256l-39.333-32l42.929-44.533\r\n\t\t\tL305.597,224z M125.333,261.334C74,261.334,32,303.334,32,354.667S74,448,125.333,448c51.333,0,93.333-42,93.333-93.333\r\n\t\t\tS176.667,261.334,125.333,261.334z M125.333,420C88.934,420,60,391.07,60,354.667s28.934-65.333,65.333-65.333\r\n\t\t\tc36.399,0,65.333,28.93,65.333,65.333S161.732,420,125.333,420z"},"children":[]}]}]}]}]}]};exports.androidBicycle=androidBicycle;var androidBoat={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M84.255,413h1.063c34.123,0,63.977-19.021,85.305-42.494c21.325,23.473,51.18,42.762,85.304,42.762\r\n\t\ts63.979-19.334,85.305-42.806C362.559,393.934,392.412,413,426.535,413h1.062l51.253-138.78c2.126-5.329,1.063-11.641-1.07-16.976\r\n\t\tc-2.136-5.333-7.237-8.487-12.567-10.623L427,234.133v-98.15C427,112.51,407.344,93,383.884,93h-63.979l-15.993-53h-95.969\r\n\t\tl-15.995,53h-63.979C104.511,93,85,112.51,85,135.982v98.15l-38.074,12.533c-5.33,2.136-10.582,5.334-12.718,10.667\r\n\t\tc-2.135,5.335-3.158,10.49-1.031,16.887L84.255,413z M128,136h256v84.261l-128-41.605l-128,41.605V136z"},"children":[{"name":"path","attribs":{"d":"M84.255,413h1.063c34.123,0,63.977-19.021,85.305-42.494c21.325,23.473,51.18,42.762,85.304,42.762\r\n\t\ts63.979-19.334,85.305-42.806C362.559,393.934,392.412,413,426.535,413h1.062l51.253-138.78c2.126-5.329,1.063-11.641-1.07-16.976\r\n\t\tc-2.136-5.333-7.237-8.487-12.567-10.623L427,234.133v-98.15C427,112.51,407.344,93,383.884,93h-63.979l-15.993-53h-95.969\r\n\t\tl-15.995,53h-63.979C104.511,93,85,112.51,85,135.982v98.15l-38.074,12.533c-5.33,2.136-10.582,5.334-12.718,10.667\r\n\t\tc-2.135,5.335-3.158,10.49-1.031,16.887L84.255,413z M128,136h256v84.261l-128-41.605l-128,41.605V136z"},"children":[]}]},{"name":"path","attribs":{"d":"M341.231,408.007c-52.253,36.267-118.356,36.258-170.608-0.009c0,0-57.638,64.002-106.632,64.002h21.327\r\n\t\tc29.854,0,58.646-11.726,85.305-25.594c53.315,27.734,117.293,27.728,170.608-0.007C367.89,460.268,396.681,472,426.535,472h21.328\r\n\t\tC400.212,472,341.231,408.007,341.231,408.007z"},"children":[{"name":"path","attribs":{"d":"M341.231,408.007c-52.253,36.267-118.356,36.258-170.608-0.009c0,0-57.638,64.002-106.632,64.002h21.327\r\n\t\tc29.854,0,58.646-11.726,85.305-25.594c53.315,27.734,117.293,27.728,170.608-0.007C367.89,460.268,396.681,472,426.535,472h21.328\r\n\t\tC400.212,472,341.231,408.007,341.231,408.007z"},"children":[]}]}]}]};exports.androidBoat=androidBoat;var androidBookmark={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M360,64H152c-22.002,0-40,17.998-40,40v344l144-64l144,64V104C400,81.998,382.002,64,360,64z"},"children":[]}]};exports.androidBookmark=androidBookmark;var androidBulb={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_26_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,170.136c25.499,0,49.567,10.025,67.771,28.229C341.975,216.568,352,240.637,352,266.136\r\n\t\t\tc0,17.621-4.422,34.031-13.144,48.773c-8.339,14.098-20.437,26.036-34.985,34.526L288,358.697v18.376V448h-64v-70.927v-18.376\r\n\t\t\tl-15.871-9.262C178.442,332.111,160,300.192,160,266.136c0-25.499,10.025-49.567,28.229-67.771\r\n\t\t\tC206.433,180.161,230.501,170.136,256,170.136 M277.333,32c-6.396,0-42.666,0-42.666,0v64h42.666V32L277.333,32z M406.396,85.864\r\n\t\t\tL368,124.271l29.864,29.865l38.406-38.396L406.396,85.864L406.396,85.864z M105.604,85.864l-29.875,29.875l38.406,38.396\r\n\t\t\tL144,124.271L105.604,85.864L105.604,85.864z M256,138.136c-70.396,0-128,57.604-128,128c0,46.938,25.604,88.531,64,110.938V480\r\n\t\t\th128V377.073c38.396-22.406,64-62.938,64-110.938C384,195.739,326.396,138.136,256,138.136L256,138.136z M480,244.802h-64v42.667\r\n\t\t\th64V244.802L480,244.802z M96,244.802H32v42.667h64V244.802L96,244.802z"},"children":[{"name":"path","attribs":{"d":"M256,170.136c25.499,0,49.567,10.025,67.771,28.229C341.975,216.568,352,240.637,352,266.136\r\n\t\t\tc0,17.621-4.422,34.031-13.144,48.773c-8.339,14.098-20.437,26.036-34.985,34.526L288,358.697v18.376V448h-64v-70.927v-18.376\r\n\t\t\tl-15.871-9.262C178.442,332.111,160,300.192,160,266.136c0-25.499,10.025-49.567,28.229-67.771\r\n\t\t\tC206.433,180.161,230.501,170.136,256,170.136 M277.333,32c-6.396,0-42.666,0-42.666,0v64h42.666V32L277.333,32z M406.396,85.864\r\n\t\t\tL368,124.271l29.864,29.865l38.406-38.396L406.396,85.864L406.396,85.864z M105.604,85.864l-29.875,29.875l38.406,38.396\r\n\t\t\tL144,124.271L105.604,85.864L105.604,85.864z M256,138.136c-70.396,0-128,57.604-128,128c0,46.938,25.604,88.531,64,110.938V480\r\n\t\t\th128V377.073c38.396-22.406,64-62.938,64-110.938C384,195.739,326.396,138.136,256,138.136L256,138.136z M480,244.802h-64v42.667\r\n\t\t\th64V244.802L480,244.802z M96,244.802H32v42.667h64V244.802L96,244.802z"},"children":[]}]}]}]}]}]};exports.androidBulb=androidBulb;var androidBus={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_14_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M80,352c0,19.198,13.864,24.531,26.667,36.271v38.396c0,11.729,9.599,21.334,21.333,21.334h21.333\r\n\t\t\t\tc11.734,0,21.334-9.604,21.334-21.334v-21.333h170.666v21.333c0,11.729,9.604,21.334,21.334,21.334H384\r\n\t\t\t\tc11.729,0,21.333-9.604,21.333-21.334v-38.396C418.136,376.531,432,370.136,432,352V148.334C432,73.667,349.864,64,256,64\r\n\t\t\t\tS80,73.667,80,148.334V352z M160,367.989c-18.136,0-32-13.864-32-32c0-18.135,13.864-32,32-32s32,13.865,32,32\r\n\t\t\t\tC192,354.125,178.136,367.989,160,367.989z M352,367.989c-18.136,0-32-13.864-32-32c0-18.135,13.864-32,32-32s32,13.865,32,32\r\n\t\t\t\tC384,354.125,370.136,367.989,352,367.989z M384,245.333H128V138.667h256V245.333z"},"children":[{"name":"path","attribs":{"d":"M80,352c0,19.198,13.864,24.531,26.667,36.271v38.396c0,11.729,9.599,21.334,21.333,21.334h21.333\r\n\t\t\t\tc11.734,0,21.334-9.604,21.334-21.334v-21.333h170.666v21.333c0,11.729,9.604,21.334,21.334,21.334H384\r\n\t\t\t\tc11.729,0,21.333-9.604,21.333-21.334v-38.396C418.136,376.531,432,370.136,432,352V148.334C432,73.667,349.864,64,256,64\r\n\t\t\t\tS80,73.667,80,148.334V352z M160,367.989c-18.136,0-32-13.864-32-32c0-18.135,13.864-32,32-32s32,13.865,32,32\r\n\t\t\t\tC192,354.125,178.136,367.989,160,367.989z M352,367.989c-18.136,0-32-13.864-32-32c0-18.135,13.864-32,32-32s32,13.865,32,32\r\n\t\t\t\tC384,354.125,370.136,367.989,352,367.989z M384,245.333H128V138.667h256V245.333z"},"children":[]}]}]}]}]}]}]}]};exports.androidBus=androidBus;var androidCalendar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368.005,272h-96v96h96V272z M336.005,64v32h-160V64h-48v32h-24.01c-22.002,0-40,17.998-40,40v272\r\n\t\tc0,22.002,17.998,40,40,40h304.01c22.002,0,40-17.998,40-40V136c0-22.002-17.998-40-40-40h-24V64H336.005z M408.005,408h-304.01\r\n\t\tV196h304.01V408z"},"children":[{"name":"path","attribs":{"d":"M368.005,272h-96v96h96V272z M336.005,64v32h-160V64h-48v32h-24.01c-22.002,0-40,17.998-40,40v272\r\n\t\tc0,22.002,17.998,40,40,40h304.01c22.002,0,40-17.998,40-40V136c0-22.002-17.998-40-40-40h-24V64H336.005z M408.005,408h-304.01\r\n\t\tV196h304.01V408z"},"children":[]}]}]}]};exports.androidCalendar=androidCalendar;var androidCall={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M426.666,330.667c-26.666,0-52.271-4.271-75.729-11.729c-7.469-2.136-16-1.073-21.332,5.333l-46.939,46.928\r\n\tc-60.802-30.928-109.864-80-140.802-140.803l46.939-46.927c5.332-5.333,7.462-13.864,5.332-21.333\r\n\tc-8.537-24.531-12.802-50.136-12.802-76.803C181.333,73.604,171.734,64,160,64H85.333C73.599,64,64,73.604,64,85.333\r\n\tC64,285.864,226.136,448,426.666,448c11.73,0,21.334-9.604,21.334-21.333V352C448,340.271,438.396,330.667,426.666,330.667z"},"children":[]}]};exports.androidCall=androidCall;var androidCamera={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"280","r":"63"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"280","r":"63"},"children":[]}]},{"name":"path","attribs":{"d":"M440,96h-88l-32-32H192l-32,32H72c-22.092,0-40,17.908-40,40v272c0,22.092,17.908,40,40,40h368c22.092,0,40-17.908,40-40\r\n\t\tV136C480,113.908,462.092,96,440,96z M256,392c-61.855,0-112-50.145-112-112s50.145-112,112-112s112,50.145,112,112\r\n\t\tS317.855,392,256,392z"},"children":[{"name":"path","attribs":{"d":"M440,96h-88l-32-32H192l-32,32H72c-22.092,0-40,17.908-40,40v272c0,22.092,17.908,40,40,40h368c22.092,0,40-17.908,40-40\r\n\t\tV136C480,113.908,462.092,96,440,96z M256,392c-61.855,0-112-50.145-112-112s50.145-112,112-112s112,50.145,112,112\r\n\t\tS317.855,392,256,392z"},"children":[]}]}]}]};exports.androidCamera=androidCamera;var androidCancel={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C140.559,48,48,140.559,48,256c0,115.436,92.559,208,208,208c115.435,0,208-92.564,208-208\r\n\t\tC464,140.559,371.436,48,256,48z M360.002,330.881l-29.12,29.117L256,285.117l-74.881,74.881l-29.121-29.117L226.881,256\r\n\t\tl-74.883-74.881l29.121-29.116L256,226.881l74.881-74.878l29.12,29.116L285.119,256L360.002,330.881z"},"children":[{"name":"path","attribs":{"d":"M256,48C140.559,48,48,140.559,48,256c0,115.436,92.559,208,208,208c115.435,0,208-92.564,208-208\r\n\t\tC464,140.559,371.436,48,256,48z M360.002,330.881l-29.12,29.117L256,285.117l-74.881,74.881l-29.121-29.117L226.881,256\r\n\t\tl-74.883-74.881l29.121-29.116L256,226.881l74.881-74.878l29.12,29.116L285.119,256L360.002,330.881z"},"children":[]}]}]}]};exports.androidCancel=androidCancel;var androidCar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_15_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M403.208,117.333c-4.271-12.802-16-21.333-29.875-21.333H138.667c-13.875,0-25.604,8.531-29.875,21.333L64,234.667v160\r\n\t\t\tC64,406.396,73.604,416,85.333,416h21.334c11.729,0,21.333-9.604,21.333-21.333V384h256v10.667\r\n\t\t\tc0,11.729,9.604,21.333,21.333,21.333h21.334c11.729,0,21.333-9.604,21.333-21.333v-160L403.208,117.333z M138.667,320\r\n\t\t\tc-18.125,0-32-13.865-32-32s13.875-32,32-32s32,13.866,32,32S156.792,320,138.667,320z M373.333,320c-18.125,0-32-13.865-32-32\r\n\t\t\ts13.875-32,32-32s32,13.866,32,32S391.458,320,373.333,320z M106.667,213.333l32-85.333h234.666l32,85.333H106.667z"},"children":[{"name":"path","attribs":{"d":"M403.208,117.333c-4.271-12.802-16-21.333-29.875-21.333H138.667c-13.875,0-25.604,8.531-29.875,21.333L64,234.667v160\r\n\t\t\tC64,406.396,73.604,416,85.333,416h21.334c11.729,0,21.333-9.604,21.333-21.333V384h256v10.667\r\n\t\t\tc0,11.729,9.604,21.333,21.333,21.333h21.334c11.729,0,21.333-9.604,21.333-21.333v-160L403.208,117.333z M138.667,320\r\n\t\t\tc-18.125,0-32-13.865-32-32s13.875-32,32-32s32,13.866,32,32S156.792,320,138.667,320z M373.333,320c-18.125,0-32-13.865-32-32\r\n\t\t\ts13.875-32,32-32s32,13.866,32,32S391.458,320,373.333,320z M106.667,213.333l32-85.333h234.666l32,85.333H106.667z"},"children":[]}]}]}]}]}]};exports.androidCar=androidCar;var androidCart={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M169.6,377.6c-22.882,0-41.6,18.718-41.6,41.601c0,22.882,18.718,41.6,41.6,41.6s41.601-18.718,41.601-41.6\r\n\t\tC211.2,396.317,192.481,377.6,169.6,377.6z M48,51.2v41.6h41.6l74.883,151.682l-31.308,50.954c-3.118,5.2-5.2,12.482-5.2,19.765\r\n\t\tc0,27.85,19.025,41.6,44.825,41.6H416v-40H177.893c-3.118,0-5.2-2.082-5.2-5.2c0-1.036,2.207-5.2,2.207-5.2l20.782-32.8h154.954\r\n\t\tc15.601,0,29.128-8.317,36.4-21.836l74.882-128.8c1.237-2.461,2.082-6.246,2.082-10.399c0-11.446-9.364-19.765-20.8-19.765H135.364\r\n\t\tL115.6,51.2H48z M374.399,377.6c-22.882,0-41.6,18.718-41.6,41.601c0,22.882,18.718,41.6,41.6,41.6S416,442.082,416,419.2\r\n\t\tC416,396.317,397.281,377.6,374.399,377.6z"},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M169.6,377.6c-22.882,0-41.6,18.718-41.6,41.601c0,22.882,18.718,41.6,41.6,41.6s41.601-18.718,41.601-41.6\r\n\t\tC211.2,396.317,192.481,377.6,169.6,377.6z M48,51.2v41.6h41.6l74.883,151.682l-31.308,50.954c-3.118,5.2-5.2,12.482-5.2,19.765\r\n\t\tc0,27.85,19.025,41.6,44.825,41.6H416v-40H177.893c-3.118,0-5.2-2.082-5.2-5.2c0-1.036,2.207-5.2,2.207-5.2l20.782-32.8h154.954\r\n\t\tc15.601,0,29.128-8.317,36.4-21.836l74.882-128.8c1.237-2.461,2.082-6.246,2.082-10.399c0-11.446-9.364-19.765-20.8-19.765H135.364\r\n\t\tL115.6,51.2H48z M374.399,377.6c-22.882,0-41.6,18.718-41.6,41.601c0,22.882,18.718,41.6,41.6,41.6S416,442.082,416,419.2\r\n\t\tC416,396.317,397.281,377.6,374.399,377.6z"},"children":[]}]}]}]};exports.androidCart=androidCart;var androidChat={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M391.553,64H57.607C53.131,64,48,67.745,48,72.159v214.217c0,4.413,5.131,8.624,9.607,8.624H115v88.894L205.128,295\r\n\t\th186.425c4.477,0,7.447-4.211,7.447-8.624V72.159C399,67.745,396.029,64,391.553,64z"},"children":[{"name":"path","attribs":{"d":"M391.553,64H57.607C53.131,64,48,67.745,48,72.159v214.217c0,4.413,5.131,8.624,9.607,8.624H115v88.894L205.128,295\r\n\t\th186.425c4.477,0,7.447-4.211,7.447-8.624V72.159C399,67.745,396.029,64,391.553,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M456.396,127H424v166.57c0,15.987-6.915,26.43-25.152,26.43H218.096l-38.905,39h129.688L399,448v-89h57.396\r\n\t\tc4.478,0,7.604-4.262,7.604-8.682V136.103C464,131.689,460.874,127,456.396,127z"},"children":[{"name":"path","attribs":{"d":"M456.396,127H424v166.57c0,15.987-6.915,26.43-25.152,26.43H218.096l-38.905,39h129.688L399,448v-89h57.396\r\n\t\tc4.478,0,7.604-4.262,7.604-8.682V136.103C464,131.689,460.874,127,456.396,127z"},"children":[]}]}]}]};exports.androidChat=androidChat;var androidCheckboxBlank={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_23_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64z"},"children":[{"name":"path","attribs":{"d":"M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64z"},"children":[]}]}]}]}]}]};exports.androidCheckboxBlank=androidCheckboxBlank;var androidCheckboxOutlineBlank={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_25_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M405.333,106.667v298.666H106.667V106.667H405.333 M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666\r\n\t\t\tC64,428.802,83.198,448,106.667,448h298.666C428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64\r\n\t\t\tL405.333,64z"},"children":[{"name":"path","attribs":{"d":"M405.333,106.667v298.666H106.667V106.667H405.333 M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666\r\n\t\t\tC64,428.802,83.198,448,106.667,448h298.666C428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64\r\n\t\t\tL405.333,64z"},"children":[]}]}]}]}]}]};exports.androidCheckboxOutlineBlank=androidCheckboxOutlineBlank;var androidCheckboxOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_24_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M168.531,215.469l-29.864,29.864l96,96L448,128l-29.864-29.864L234.667,280.531L168.531,215.469z M405.333,405.333\r\n\t\t\tH106.667V106.667H320V64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V234.667h-42.667V405.333z"},"children":[{"name":"path","attribs":{"d":"M168.531,215.469l-29.864,29.864l96,96L448,128l-29.864-29.864L234.667,280.531L168.531,215.469z M405.333,405.333\r\n\t\t\tH106.667V106.667H320V64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V234.667h-42.667V405.333z"},"children":[]}]}]}]}]}]};exports.androidCheckboxOutline=androidCheckboxOutline;var androidCheckbox={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_22_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64z M213.333,362.667L106.667,256l29.864-29.864\r\n\t\t\tl76.802,76.802l162.136-162.136l29.864,29.865L213.333,362.667z"},"children":[{"name":"path","attribs":{"d":"M405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666C64,428.802,83.198,448,106.667,448h298.666\r\n\t\t\tC428.802,448,448,428.802,448,405.333V106.667C448,83.198,428.802,64,405.333,64z M213.333,362.667L106.667,256l29.864-29.864\r\n\t\t\tl76.802,76.802l162.136-162.136l29.864,29.865L213.333,362.667z"},"children":[]}]}]}]}]}]};exports.androidCheckbox=androidCheckbox;var androidCheckmarkCircle={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M170.718,216.482L141.6,245.6L235.2,339.2l208-208l-29.118-29.118L235.2,279.918L170.718,216.482z M422.4,256\r\n\tc0,91.518-74.883,166.4-166.4,166.4S89.6,347.518,89.6,256S164.482,89.6,256,89.6c15.6,0,31.2,2.082,45.764,6.241L334,63.6\r\n\tC310.082,53.2,284.082,48,256,48C141.6,48,48,141.6,48,256s93.6,208,208,208s208-93.6,208-208H422.4z"},"children":[]}]};exports.androidCheckmarkCircle=androidCheckmarkCircle;var androidClipboard={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M405.333,80h-87.35C310.879,52.396,285.821,32,256,32s-54.879,20.396-61.983,48h-87.35C83.198,80,64,99.198,64,122.667\r\n\tv314.665C64,460.801,83.198,480,106.667,480h298.666C428.802,480,448,460.801,448,437.332V122.667C448,99.198,428.802,80,405.333,80\r\n\tz M256,80c11.729,0,21.333,9.599,21.333,21.333s-9.604,21.334-21.333,21.334s-21.333-9.6-21.333-21.334S244.271,80,256,80z M408,440\r\n\tH104V120h40v72h224v-72h40V440z"},"children":[]}]};exports.androidClipboard=androidClipboard;var androidClose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_5_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798 \r\n\t\t\t375.202,405 405,375.202 285.798,256 \t\t"},"children":[{"name":"polygon","attribs":{"points":"405,136.798 375.202,107 256,226.202 136.798,107 107,136.798 226.202,256 107,375.202 136.798,405 256,285.798 \r\n\t\t\t375.202,405 405,375.202 285.798,256 \t\t"},"children":[]}]}]}]}]}]};exports.androidClose=androidClose;var androidCloudCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_32_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.6,48,48,141.6,48,256s93.6,208,208,208c114.4,0,208-93.6,208-208S370.4,48,256,48z M349.6,339.2\r\n\t\t\t\tc0,0-175.759,0-176.799,0c-34.318,0-62.4-28.082-62.4-62.399c0-34.319,28.082-62.4,62.4-62.4c1.041,0,2.082,0,3.117,0\r\n\t\t\t\tc9.364-36.4,41.601-62.399,80.083-62.399c45.764,0,83.199,37.435,83.199,83.198h10.4c29.118,0,52,22.882,52,52.001\r\n\t\t\t\tC401.6,316.318,378.718,339.2,349.6,339.2z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.6,48,48,141.6,48,256s93.6,208,208,208c114.4,0,208-93.6,208-208S370.4,48,256,48z M349.6,339.2\r\n\t\t\t\tc0,0-175.759,0-176.799,0c-34.318,0-62.4-28.082-62.4-62.399c0-34.319,28.082-62.4,62.4-62.4c1.041,0,2.082,0,3.117,0\r\n\t\t\t\tc9.364-36.4,41.601-62.399,80.083-62.399c45.764,0,83.199,37.435,83.199,83.198h10.4c29.118,0,52,22.882,52,52.001\r\n\t\t\t\tC401.6,316.318,378.718,339.2,349.6,339.2z"},"children":[]}]}]}]}]}]}]}]};exports.androidCloudCircle=androidCloudCircle;var androidCloudDone={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M403.002,217.001C388.998,148.002,328.998,96,256,96c-57.998,0-107.998,32.998-132.998,81.001\r\n\t\tC63.002,183.002,16,233.998,16,296c0,65.996,53.999,120,120,120h260c55,0,100-45,100-100\r\n\t\tC496,263.002,455.004,219.999,403.002,217.001z M213.333,362.667L138.667,288l29.864-29.864l44.802,44.802L324.271,192\r\n\t\tl29.865,29.864L213.333,362.667z"},"children":[{"name":"path","attribs":{"d":"M403.002,217.001C388.998,148.002,328.998,96,256,96c-57.998,0-107.998,32.998-132.998,81.001\r\n\t\tC63.002,183.002,16,233.998,16,296c0,65.996,53.999,120,120,120h260c55,0,100-45,100-100\r\n\t\tC496,263.002,455.004,219.999,403.002,217.001z M213.333,362.667L138.667,288l29.864-29.864l44.802,44.802L324.271,192\r\n\t\tl29.865,29.864L213.333,362.667z"},"children":[]}]}]}]};exports.androidCloudDone=androidCloudDone;var androidCloudOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_9_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M403.001,217.001C388.997,148.002,328.998,96,256,96c-57.998,0-107.999,32.998-132.997,81\r\n\t\t\t\tC63.002,183.002,16,233.998,16,296c0,65.996,54.004,120,120,120h260c55,0,100-45,100-100.001\r\n\t\t\t\tC496,263.002,455.003,220,403.001,217.001z M396,376H136c-44.004,0-80-35.996-80-80c0-44,35.996-80,80-80h14.004\r\n\t\t\t\tc12.998-46,55-80,105.996-80c60.996,0,110,49,110,110v10h30c32.998,0,60,27.003,60,60C456,348.998,428.998,376,396,376z"},"children":[{"name":"path","attribs":{"d":"M403.001,217.001C388.997,148.002,328.998,96,256,96c-57.998,0-107.999,32.998-132.997,81\r\n\t\t\t\tC63.002,183.002,16,233.998,16,296c0,65.996,54.004,120,120,120h260c55,0,100-45,100-100.001\r\n\t\t\t\tC496,263.002,455.003,220,403.001,217.001z M396,376H136c-44.004,0-80-35.996-80-80c0-44,35.996-80,80-80h14.004\r\n\t\t\t\tc12.998-46,55-80,105.996-80c60.996,0,110,49,110,110v10h30c32.998,0,60,27.003,60,60C456,348.998,428.998,376,396,376z"},"children":[]}]}]}]}]}]}]}]};exports.androidCloudOutline=androidCloudOutline;var androidCloud={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M403.002,217.001C388.998,148.002,328.998,96,256,96c-57.998,0-107.998,32.998-132.998,81.001\r\n\tC63.002,183.002,16,233.998,16,296c0,65.996,53.999,120,120,120h260c55,0,100-45,100-100\r\n\tC496,263.002,455.004,219.999,403.002,217.001z"},"children":[]}]};exports.androidCloud=androidCloud;var androidColorPalette={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_12_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,64C150.401,64,64,150.401,64,256c0,105.604,86.401,192,192,192c18.136,0,32-13.864,32-32\r\n\t\t\tc0-8.531-3.198-16-8.531-21.333c-5.333-5.334-8.531-12.803-8.531-21.334c0-18.135,13.864-32,32-32h38.396\r\n\t\t\tc58.667,0,106.667-48,106.667-106.666C448,140.802,361.604,64,256,64z M138.667,256c-18.136,0-32-13.864-32-32s13.864-32,32-32\r\n\t\t\tc18.135,0,32,13.864,32,32S156.802,256,138.667,256z M202.667,170.667c-18.136,0-32-13.865-32-32c0-18.136,13.864-32,32-32\r\n\t\t\tc18.135,0,32,13.864,32,32C234.667,156.802,220.802,170.667,202.667,170.667z M309.333,170.667c-18.135,0-32-13.865-32-32\r\n\t\t\tc0-18.136,13.865-32,32-32c18.136,0,32,13.864,32,32C341.333,156.802,327.469,170.667,309.333,170.667z M373.333,256\r\n\t\t\tc-18.135,0-32-13.864-32-32s13.865-32,32-32c18.136,0,32,13.864,32,32S391.469,256,373.333,256z"},"children":[{"name":"path","attribs":{"d":"M256,64C150.401,64,64,150.401,64,256c0,105.604,86.401,192,192,192c18.136,0,32-13.864,32-32\r\n\t\t\tc0-8.531-3.198-16-8.531-21.333c-5.333-5.334-8.531-12.803-8.531-21.334c0-18.135,13.864-32,32-32h38.396\r\n\t\t\tc58.667,0,106.667-48,106.667-106.666C448,140.802,361.604,64,256,64z M138.667,256c-18.136,0-32-13.864-32-32s13.864-32,32-32\r\n\t\t\tc18.135,0,32,13.864,32,32S156.802,256,138.667,256z M202.667,170.667c-18.136,0-32-13.865-32-32c0-18.136,13.864-32,32-32\r\n\t\t\tc18.135,0,32,13.864,32,32C234.667,156.802,220.802,170.667,202.667,170.667z M309.333,170.667c-18.135,0-32-13.865-32-32\r\n\t\t\tc0-18.136,13.865-32,32-32c18.136,0,32,13.864,32,32C341.333,156.802,327.469,170.667,309.333,170.667z M373.333,256\r\n\t\t\tc-18.135,0-32-13.864-32-32s13.865-32,32-32c18.136,0,32,13.864,32,32S391.469,256,373.333,256z"},"children":[]}]}]}]}]}]};exports.androidColorPalette=androidColorPalette;var androidCompass={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,231.358c-13.442,0-24.643,11.2-24.643,24.642s11.2,24.643,24.643,24.643s24.643-11.2,24.643-24.643\r\n\tS269.442,231.358,256,231.358z M256,32C132.8,32,32,132.8,32,256s100.8,224,224,224s224-100.8,224-224S379.2,32,256,32z\r\n\t M305.284,305.284L121.6,390.4l85.116-183.679L390.4,121.6L305.284,305.284z"},"children":[]}]};exports.androidCompass=androidCompass;var androidContact={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M331.08,338.205c-22.156,12.594-47.777,19.783-75.084,19.783c-27.302,0-52.919-7.182-75.073-19.771\r\n\t\tC122.153,356.152,77.262,396,64,448h384C434.745,396,389.854,356.131,331.08,338.205z"},"children":[{"name":"path","attribs":{"d":"M331.08,338.205c-22.156,12.594-47.777,19.783-75.084,19.783c-27.302,0-52.919-7.182-75.073-19.771\r\n\t\tC122.153,356.152,77.262,396,64,448h384C434.745,396,389.854,356.131,331.08,338.205z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255.996,64c-72.871,0-131.945,59.127-131.945,132.013c0,72.887,59.074,131.972,131.945,131.972\r\n\t\t\ts131.945-59.085,131.945-131.972C387.941,123.127,328.867,64,255.996,64z M255.996,294.986c-41.958,0-77.813-25.986-92.209-62.986\r\n\t\t\th184.418C333.809,269,297.953,294.986,255.996,294.986z"},"children":[{"name":"path","attribs":{"d":"M255.996,64c-72.871,0-131.945,59.127-131.945,132.013c0,72.887,59.074,131.972,131.945,131.972\r\n\t\t\ts131.945-59.085,131.945-131.972C387.941,123.127,328.867,64,255.996,64z M255.996,294.986c-41.958,0-77.813-25.986-92.209-62.986\r\n\t\t\th184.418C333.809,269,297.953,294.986,255.996,294.986z"},"children":[]}]}]}]}]}]};exports.androidContact=androidContact;var androidContacts={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M239.208,343.937c-17.78,10.103-38.342,15.876-60.255,15.876c-21.909,0-42.467-5.771-60.246-15.87\r\n\t\t\tC71.544,358.331,42.643,406,32,448h293.912C315.273,406,286.375,358.317,239.208,343.937z"},"children":[{"name":"path","attribs":{"d":"M239.208,343.937c-17.78,10.103-38.342,15.876-60.255,15.876c-21.909,0-42.467-5.771-60.246-15.87\r\n\t\t\tC71.544,358.331,42.643,406,32,448h293.912C315.273,406,286.375,358.317,239.208,343.937z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M178.953,120.035c-58.479,0-105.886,47.394-105.886,105.858c0,58.464,47.407,105.857,105.886,105.857\r\n\t\t\t\tc58.479,0,105.886-47.394,105.886-105.857C284.839,167.429,237.431,120.035,178.953,120.035z M178.953,306.523\r\n\t\t\t\tc-33.671,0-62.445-22.513-73.997-50.523H252.95C241.396,284.011,212.624,306.523,178.953,306.523z"},"children":[{"name":"path","attribs":{"d":"M178.953,120.035c-58.479,0-105.886,47.394-105.886,105.858c0,58.464,47.407,105.857,105.886,105.857\r\n\t\t\t\tc58.479,0,105.886-47.394,105.886-105.857C284.839,167.429,237.431,120.035,178.953,120.035z M178.953,306.523\r\n\t\t\t\tc-33.671,0-62.445-22.513-73.997-50.523H252.95C241.396,284.011,212.624,306.523,178.953,306.523z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M322.602,384H480c-10.638-42-39.537-81.691-86.703-96.072c-17.781,10.104-38.343,15.873-60.256,15.873\r\n\t\t\t\tc-14.823,0-29.024-2.654-42.168-7.49c-7.445,12.47-16.927,25.592-27.974,34.906C289.245,341.354,309.146,364,322.602,384z"},"children":[{"name":"path","attribs":{"d":"M322.602,384H480c-10.638-42-39.537-81.691-86.703-96.072c-17.781,10.104-38.343,15.873-60.256,15.873\r\n\t\t\t\tc-14.823,0-29.024-2.654-42.168-7.49c-7.445,12.47-16.927,25.592-27.974,34.906C289.245,341.354,309.146,364,322.602,384z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M306.545,200h100.493c-11.554,28-40.327,50.293-73.997,50.293c-8.875,0-17.404-1.692-25.375-4.51\r\n\t\t\tc-1.338,8.709-3.543,17.07-6.52,25.118c10.066,3.174,20.779,4.862,31.895,4.862c58.479,0,105.886-47.41,105.886-105.872\r\n\t\t\tc0-58.465-47.407-105.866-105.886-105.866c-37.49,0-70.427,19.703-89.243,49.09C275.607,131.383,298.961,163,306.545,200z"},"children":[{"name":"path","attribs":{"d":"M306.545,200h100.493c-11.554,28-40.327,50.293-73.997,50.293c-8.875,0-17.404-1.692-25.375-4.51\r\n\t\t\tc-1.338,8.709-3.543,17.07-6.52,25.118c10.066,3.174,20.779,4.862,31.895,4.862c58.479,0,105.886-47.41,105.886-105.872\r\n\t\t\tc0-58.465-47.407-105.866-105.886-105.866c-37.49,0-70.427,19.703-89.243,49.09C275.607,131.383,298.961,163,306.545,200z"},"children":[]}]}]}]}]}]};exports.androidContacts=androidContacts;var androidContract={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_2_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,371.2h76.795V448H192V320H64V371.2z M140.795,140.8H64V192h128V64h-51.205V140.8z M320,448h51.2v-76.8H448V320H320\r\n\t\t\tV448z M371.2,140.8V64H320v128h128v-51.2H371.2z"},"children":[{"name":"path","attribs":{"d":"M64,371.2h76.795V448H192V320H64V371.2z M140.795,140.8H64V192h128V64h-51.205V140.8z M320,448h51.2v-76.8H448V320H320\r\n\t\t\tV448z M371.2,140.8V64H320v128h128v-51.2H371.2z"},"children":[]}]}]}]}]}]};exports.androidContract=androidContract;var androidCreate={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_6_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M64,368v80h80l235.727-235.729l-79.999-79.998L64,368z M441.602,150.398\r\n\t\t\tc8.531-8.531,8.531-21.334,0-29.865l-50.135-50.135c-8.531-8.531-21.334-8.531-29.865,0l-39.468,39.469l79.999,79.998\r\n\t\t\tL441.602,150.398z"},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M64,368v80h80l235.727-235.729l-79.999-79.998L64,368z M441.602,150.398\r\n\t\t\tc8.531-8.531,8.531-21.334,0-29.865l-50.135-50.135c-8.531-8.531-21.334-8.531-29.865,0l-39.468,39.469l79.999,79.998\r\n\t\t\tL441.602,150.398z"},"children":[]}]}]}]}]}]};exports.androidCreate=androidCreate;var androidDelete={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,405.429C128,428.846,147.198,448,170.667,448h170.667C364.802,448,384,428.846,384,405.429V160H128V405.429z M416,96\r\n\t\th-80l-26.785-32H202.786L176,96H96v32h320V96z"},"children":[{"name":"path","attribs":{"d":"M128,405.429C128,428.846,147.198,448,170.667,448h170.667C364.802,448,384,428.846,384,405.429V160H128V405.429z M416,96\r\n\t\th-80l-26.785-32H202.786L176,96H96v32h320V96z"},"children":[]}]}]}]};exports.androidDelete=androidDelete;var androidDesktop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_28_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M437.333,32H74.667C51.198,32,32,51.197,32,74.666v282.667C32,380.802,51.198,400,74.667,400h138.666l-42.666,48v32\r\n\t\t\th170.666v-32l-42.666-48h138.666C460.802,400,480,380.802,480,357.333V74.666C480,51.197,460.802,32,437.333,32z M437.333,320\r\n\t\t\tH74.667V74.666h362.666V320z"},"children":[{"name":"path","attribs":{"d":"M437.333,32H74.667C51.198,32,32,51.197,32,74.666v282.667C32,380.802,51.198,400,74.667,400h138.666l-42.666,48v32\r\n\t\t\th170.666v-32l-42.666-48h138.666C460.802,400,480,380.802,480,357.333V74.666C480,51.197,460.802,32,437.333,32z M437.333,320\r\n\t\t\tH74.667V74.666h362.666V320z"},"children":[]}]}]}]}]}]};exports.androidDesktop=androidDesktop;var androidDocument={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,48H136c-22.092,0-40,17.908-40,40v336c0,22.092,17.908,40,40,40h240c22.092,0,40-17.908,40-40V176L288,48z M272,192\r\n\t\tV80l112,112H272z"},"children":[{"name":"path","attribs":{"d":"M288,48H136c-22.092,0-40,17.908-40,40v336c0,22.092,17.908,40,40,40h240c22.092,0,40-17.908,40-40V176L288,48z M272,192\r\n\t\tV80l112,112H272z"},"children":[]}]}]}]};exports.androidDocument=androidDocument;var androidDoneAll={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_4_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M387.581,139.712L356.755,109L216.913,248.319l30.831,30.719L387.581,139.712z M481.172,109L247.744,340.469\r\n\t\t\tl-91.39-91.051l-30.827,30.715L247.744,403L512,139.712L481.172,109z M0,280.133L123.321,403l30.829-30.713L31.934,249.418\r\n\t\t\tL0,280.133z"},"children":[{"name":"path","attribs":{"d":"M387.581,139.712L356.755,109L216.913,248.319l30.831,30.719L387.581,139.712z M481.172,109L247.744,340.469\r\n\t\t\tl-91.39-91.051l-30.827,30.715L247.744,403L512,139.712L481.172,109z M0,280.133L123.321,403l30.829-30.713L31.934,249.418\r\n\t\t\tL0,280.133z"},"children":[]}]}]}]}]}]};exports.androidDoneAll=androidDoneAll;var androidDone={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"186.301,339.893 96,249.461 64,279.968 186.301,402 448,140.506 416,110 \t\t\t"},"children":[{"name":"polygon","attribs":{"points":"186.301,339.893 96,249.461 64,279.968 186.301,402 448,140.506 416,110 \t\t\t"},"children":[]}]}]}]}]}]}]}]};exports.androidDone=androidDone;var androidDownload={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M403.002,217.001C388.998,148.002,328.998,96,256,96c-57.998,0-107.998,32.998-132.998,81.001\r\n\tC63.002,183.002,16,233.998,16,296c0,65.996,53.999,120,120,120h260c55,0,100-45,100-100\r\n\tC496,263.002,455.004,219.999,403.002,217.001z M224,268v-76h64v76h68L256,368L156,268H224z"},"children":[]}]};exports.androidDownload=androidDownload;var androidDrafts={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_18_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,201.667c0-14.933-7.469-28.803-20.271-36.266L256,64L52.271,165.401C40.531,172.864,32,186.734,32,201.667v203.666\r\n\t\t\t\tC32,428.802,51.197,448,74.666,448h362.668C460.803,448,480,428.802,480,405.333V201.667z M256,304L84.631,192L256,106.667\r\n\t\t\t\tL427.369,192L256,304z"},"children":[{"name":"path","attribs":{"d":"M480,201.667c0-14.933-7.469-28.803-20.271-36.266L256,64L52.271,165.401C40.531,172.864,32,186.734,32,201.667v203.666\r\n\t\t\t\tC32,428.802,51.197,448,74.666,448h362.668C460.803,448,480,428.802,480,405.333V201.667z M256,304L84.631,192L256,106.667\r\n\t\t\t\tL427.369,192L256,304z"},"children":[]}]}]}]}]}]}]}]};exports.androidDrafts=androidDrafts;var androidExit={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M215.469,332.802l29.863,29.864L352,256L245.332,149.333l-29.863,29.865l55.469,55.469H64v42.666h205.864L215.469,332.802z\r\n\t M405.334,64H106.666C83.198,64,64,83.198,64,106.666V192h42.666v-85.333h298.668v298.668H106.666V320H64v85.334\r\n\tC64,428.802,83.198,448,106.666,448h298.668C428.802,448,448,428.802,448,405.334V106.666C448,83.198,428.802,64,405.334,64z"},"children":[]}]};exports.androidExit=androidExit;var androidExpand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"396.795,396.8 320,396.8 320,448 448,448 448,320 396.795,320 \t"},"children":[{"name":"polygon","attribs":{"points":"396.795,396.8 320,396.8 320,448 448,448 448,320 396.795,320 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"396.8,115.205 396.8,192 448,192 448,64 320,64 320,115.205 \t"},"children":[{"name":"polygon","attribs":{"points":"396.8,115.205 396.8,192 448,192 448,64 320,64 320,115.205 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"115.205,115.2 192,115.2 192,64 64,64 64,192 115.205,192 \t"},"children":[{"name":"polygon","attribs":{"points":"115.205,115.2 192,115.2 192,64 64,64 64,192 115.205,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"115.2,396.795 115.2,320 64,320 64,448 192,448 192,396.795 \t"},"children":[{"name":"polygon","attribs":{"points":"115.2,396.795 115.2,320 64,320 64,448 192,448 192,396.795 \t"},"children":[]}]}]}]};exports.androidExpand=androidExpand;var androidFavoriteOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M349.6,64c-36.4,0-70.718,16.742-93.6,43.947C233.117,80.742,198.8,64,162.4,64C97.918,64,48,114.221,48,179.095\r\n\tc0,79.516,70.718,143.348,177.836,241.694L256,448l30.164-27.211C393.281,322.442,464,258.61,464,179.095\r\n\tC464,114.221,414.082,64,349.6,64z M268.836,393.257l-4.219,3.873L256,404.903l-8.616-7.772l-4.214-3.869\r\n\tc-50.418-46.282-93.961-86.254-122.746-121.994C92.467,236.555,80,208.128,80,179.095c0-22.865,8.422-43.931,23.715-59.316\r\n\tC118.957,104.445,139.798,96,162.4,96c26.134,0,51.97,12.167,69.11,32.545L256,157.661l24.489-29.116\r\n\tC297.63,108.167,323.465,96,349.6,96c22.603,0,43.443,8.445,58.686,23.778C423.578,135.164,432,156.229,432,179.095\r\n\tc0,29.033-12.467,57.459-40.422,92.171C362.794,307.006,319.253,346.975,268.836,393.257z"},"children":[]}]};exports.androidFavoriteOutline=androidFavoriteOutline;var androidFavorite={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,448l-30.164-27.211C118.718,322.442,48,258.61,48,179.095C48,114.221,97.918,64,162.4,64\r\n\t\tc36.399,0,70.717,16.742,93.6,43.947C278.882,80.742,313.199,64,349.6,64C414.082,64,464,114.221,464,179.095\r\n\t\tc0,79.516-70.719,143.348-177.836,241.694L256,448z"},"children":[{"name":"path","attribs":{"d":"M256,448l-30.164-27.211C118.718,322.442,48,258.61,48,179.095C48,114.221,97.918,64,162.4,64\r\n\t\tc36.399,0,70.717,16.742,93.6,43.947C278.882,80.742,313.199,64,349.6,64C414.082,64,464,114.221,464,179.095\r\n\t\tc0,79.516-70.719,143.348-177.836,241.694L256,448z"},"children":[]}]}]}]};exports.androidFavorite=androidFavorite;var androidFilm={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill":"#010101","d":"M376,64v42.667h-40V64H176v42.667h-40V64H96v384h40v-42.666h40V448h160v-42.666h40V448h40V64H376z\r\n\t M176,362.667h-40V320h40V362.667z M176,277.334h-40v-42.667h40V277.334z M176,192h-40v-42.666h40V192z M376,362.667h-40V320h40\r\n\tV362.667z M376,277.334h-40v-42.667h40V277.334z M376,192h-40v-42.666h40V192z"},"children":[]}]};exports.androidFilm=androidFilm;var androidFolderOpen={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M437.334,144H256.006l-42.668-48H74.666C51.197,96,32,115.198,32,138.667v234.666C32,396.802,51.197,416,74.666,416h362.668\r\n\tC460.803,416,480,396.802,480,373.333V186.667C480,163.198,460.803,144,437.334,144z M448,373.333\r\n\tc0,5.782-4.885,10.667-10.666,10.667H74.666C68.884,384,64,379.115,64,373.333V176h373.334c5.781,0,10.666,4.885,10.666,10.667\r\n\tV373.333z"},"children":[]}]};exports.androidFolderOpen=androidFolderOpen;var androidFolder={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_10_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M213.338,96H74.666C51.197,96,32,115.198,32,138.667v234.666C32,396.802,51.197,416,74.666,416h362.668\r\n\t\t\t\tC460.803,416,480,396.802,480,373.333V186.667C480,163.198,460.803,144,437.334,144H256.006L213.338,96z"},"children":[{"name":"path","attribs":{"d":"M213.338,96H74.666C51.197,96,32,115.198,32,138.667v234.666C32,396.802,51.197,416,74.666,416h362.668\r\n\t\t\t\tC460.803,416,480,396.802,480,373.333V186.667C480,163.198,460.803,144,437.334,144H256.006L213.338,96z"},"children":[]}]}]}]}]}]}]}]};exports.androidFolder=androidFolder;var androidFunnel={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M208,400h96v-47.994h-96V400z M32,112v47.994h448V112H32z M112,280.783h288v-49.555H112V280.783z"},"children":[]}]};exports.androidFunnel=androidFunnel;var androidGlobe={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.124,48,48,141.125,48,256c0,114.875,93.124,208,208,208c114.875,0,208-93.125,208-208\r\n\tC464,141.125,370.875,48,256,48z M234.451,432.999c-39.464-4.726-75.978-22.392-104.519-50.932\r\n\tC96.258,348.393,77.714,303.622,77.714,256c0-42.87,15.036-83.424,42.601-115.659c0.71,8.517,2.463,17.648,2.014,24.175\r\n\tc-1.64,23.795-3.988,38.687,9.94,58.762c5.426,7.819,6.759,19.028,9.4,28.078c2.583,8.854,12.902,13.498,20.019,18.953\r\n\tc14.359,11.009,28.096,23.805,43.322,33.494c10.049,6.395,16.326,9.576,13.383,21.839c-2.367,9.862-3.028,15.937-8.13,24.723\r\n\tc-1.557,2.681,5.877,19.918,8.351,22.392c7.498,7.497,14.938,14.375,23.111,21.125C254.396,404.351,240.494,417.954,234.451,432.999\r\n\tz M382.067,382.067c-25.633,25.633-57.699,42.486-92.556,49.081c4.94-12.216,13.736-23.07,21.895-29.362\r\n\tc7.097-5.476,15.986-16.009,19.693-24.352c3.704-8.332,8.611-15.555,13.577-23.217c7.065-10.899-17.419-27.336-25.353-30.781\r\n\tc-17.854-7.751-31.294-18.21-47.161-29.375c-11.305-7.954-34.257,4.154-47.02-1.417c-17.481-7.633-31.883-20.896-47.078-32.339\r\n\tc-15.68-11.809-14.922-25.576-14.922-42.997c12.282,0.453,29.754-3.399,37.908,6.478c2.573,3.117,11.42,17.042,17.342,12.094\r\n\tc4.838-4.043-3.585-20.249-5.212-24.059c-5.005-11.715,11.404-16.284,19.803-24.228c10.96-10.364,34.47-26.618,32.612-34.047\r\n\ts-23.524-28.477-36.249-25.193c-1.907,0.492-18.697,18.097-21.941,20.859c0.086-5.746,0.172-11.491,0.26-17.237\r\n\tc0.055-3.628-6.768-7.352-6.451-9.692c0.8-5.914,17.262-16.647,21.357-21.357c-2.869-1.793-12.659-10.202-15.622-8.968\r\n\tc-7.174,2.99-15.276,5.05-22.45,8.039c0-2.488-0.302-4.825-0.662-7.133c14.376-6.365,29.587-10.791,45.31-13.152l14.084,5.66\r\n\tl9.944,11.801l9.924,10.233l8.675,2.795l13.779-12.995L282,87.929v-8.339c27.25,3.958,52.984,14.124,75.522,29.8\r\n\tc-4.032,0.361-8.463,0.954-13.462,1.59c-2.065-1.22-4.714-1.774-6.965-2.623c6.531,14.042,13.343,27.89,20.264,41.746\r\n\tc7.393,14.801,23.793,30.677,26.673,46.301c3.394,18.416,1.039,35.144,2.896,56.811c1.788,20.865,23.524,44.572,23.524,44.572\r\n\ts10.037,3.419,18.384,2.228C421.055,330.798,405.103,359.029,382.067,382.067z"},"children":[]}]};exports.androidGlobe=androidGlobe;var androidHand={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M450.679,273.5c-14.585-14.577-36.054-15.89-50.639-1.312l-41.687,41.664c-10.852,10.836-23.93,10.859-31.564,1.852\r\n\tc-5.057-5.968-3.061-24.374-1.644-36.049l20.907-171.849c1.867-15.353-9.07-30.185-24.43-32.051\r\n\tc-15.358-1.867-29.322,9.939-31.191,25.289L267.37,236.021c-1.205,3.358-3.79,3.938-4.081-0.582L255.44,60\r\n\tc0-15.465-12.542-28-28.014-28c-15.473,0-28.015,12.535-28.015,28l-0.552,176.752c0.146,2.04-1.604,2.624-1.92,0.294L172.016,99.077\r\n\tc-2.75-15.219-17.323-26.203-32.548-23.453c-15.227,2.748-25.339,18.187-22.591,33.403l22.193,161.455\r\n\tc0.023,2.872-0.941,4.513-2.308,0.831l-33.109-88.517c-5.18-14.572-21.196-23.065-35.776-17.889\r\n\tc-14.579,5.177-22.201,22.061-17.023,36.631l58.042,189.625c0.303,1.046,0.624,2.085,0.953,3.118l0.121,0.39\r\n\tc0.011,0.031,0.025,0.058,0.035,0.088C126.079,444.233,172.57,480,227.427,480c35.116,0,71.591-12.378,99.357-33.672\r\n\tc0.001,0,0.003-0.002,0.003-0.002c29.99-18.051,126.071-121.347,126.071-121.347C467.445,310.402,465.266,288.08,450.679,273.5z"},"children":[]}]};exports.androidHand=androidHand;var androidHangout={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48c-97.321,0-176,77.114-176,172.487c0,95.38,78.679,172.487,176,172.487V464c100.425-47.689,176-152.195,176-243.513\r\n\tC432,125.114,353.321,48,256,48z M246,230.633L224.943,271H193.88l20.712-40H184v-61h62V230.633z M328,230.633L307.768,271h-31.063\r\n\tl20.704-40H266v-61h62V230.633z"},"children":[]}]};exports.androidHangout=androidHangout;var androidHappy={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C140.563,48,48,141.6,48,256c0,114.4,92.563,208,208,208s208-93.6,208-208C464,141.6,370.401,48,256,48z M256,422.4\r\n\tc-91.518,0-166.404-74.883-166.404-166.4c0-91.518,74.887-166.4,166.404-166.4S422.404,164.482,422.404,256\r\n\tC422.404,347.518,347.518,422.4,256,422.4z M328.8,235.2c17.683,0,31.201-13.518,31.201-31.2s-13.519-31.2-31.201-31.2\r\n\tc-17.682,0-31.2,13.518-31.2,31.2S311.118,235.2,328.8,235.2z M183.2,235.2c17.682,0,31.2-13.518,31.2-31.2s-13.519-31.2-31.2-31.2\r\n\tc-17.683,0-31.201,13.518-31.201,31.2S165.518,235.2,183.2,235.2z M256,370.4c48.883,0,89.436-30.164,106.081-72.801H149.919\r\n\tC166.564,340.236,207.117,370.4,256,370.4z"},"children":[]}]};exports.androidHappy=androidHappy;var androidHome={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"208,448 208,320 304,320 304,448 401.6,448 401.6,256 464,256 256,64 48,256 110.4,256 110.4,448 \t"},"children":[{"name":"polygon","attribs":{"points":"208,448 208,320 304,320 304,448 401.6,448 401.6,256 464,256 256,64 48,256 110.4,256 110.4,448 \t"},"children":[]}]}]}]};exports.androidHome=androidHome;var androidImage={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_8_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,405.333V106.667C448,83.198,428.802,64,405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666\r\n\t\t\tC64,428.802,83.198,448,106.667,448h298.666C428.802,448,448,428.802,448,405.333z M181.333,288l53.334,64l74.666-96l96,128\r\n\t\t\tH106.667L181.333,288z"},"children":[{"name":"path","attribs":{"d":"M448,405.333V106.667C448,83.198,428.802,64,405.333,64H106.667C83.198,64,64,83.198,64,106.667v298.666\r\n\t\t\tC64,428.802,83.198,448,106.667,448h298.666C428.802,448,448,428.802,448,405.333z M181.333,288l53.334,64l74.666-96l96,128\r\n\t\t\tH106.667L181.333,288z"},"children":[]}]}]}]}]}]};exports.androidImage=androidImage;var androidLaptop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_29_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M437.334,416C460.803,416,480,396.803,480,373.334V106.668C480,83.199,460.803,64,437.334,64H74.666\r\n\t\t\tC51.197,64,32,83.199,32,106.668v266.666C32,396.803,51.197,416,74.666,416H0c0,23.469,64,32,96,32h320c32,0,96-8.531,96-32\r\n\t\t\tH437.334z M74.666,106.668h362.668v271.998H74.666V106.668z M256,434.666c-11.729,0-21.333-9.604-21.333-21.334\r\n\t\t\tc0-11.729,9.604-21.332,21.333-21.332s21.333,9.604,21.333,21.332C277.333,425.062,267.729,434.666,256,434.666z"},"children":[{"name":"path","attribs":{"d":"M437.334,416C460.803,416,480,396.803,480,373.334V106.668C480,83.199,460.803,64,437.334,64H74.666\r\n\t\t\tC51.197,64,32,83.199,32,106.668v266.666C32,396.803,51.197,416,74.666,416H0c0,23.469,64,32,96,32h320c32,0,96-8.531,96-32\r\n\t\t\tH437.334z M74.666,106.668h362.668v271.998H74.666V106.668z M256,434.666c-11.729,0-21.333-9.604-21.333-21.334\r\n\t\t\tc0-11.729,9.604-21.332,21.333-21.332s21.333,9.604,21.333,21.332C277.333,425.062,267.729,434.666,256,434.666z"},"children":[]}]}]}]}]}]};exports.androidLaptop=androidLaptop;var androidList={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M408,64H104c-22.091,0-40,17.908-40,40v304c0,22.092,17.909,40,40,40h304c22.092,0,40-17.908,40-40V104\r\n\t\tC448,81.908,430.092,64,408,64z M304,368H144v-48h160V368z M368,280H144v-48h224V280z M368,192H144v-48h224V192z"},"children":[{"name":"path","attribs":{"d":"M408,64H104c-22.091,0-40,17.908-40,40v304c0,22.092,17.909,40,40,40h304c22.092,0,40-17.908,40-40V104\r\n\t\tC448,81.908,430.092,64,408,64z M304,368H144v-48h160V368z M368,280H144v-48h224V280z M368,192H144v-48h224V192z"},"children":[]}]}]}]};exports.androidList=androidList;var androidLocate={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,176c-44.004,0-80.001,36-80.001,80c0,44.004,35.997,80,80.001,80c44.005,0,79.999-35.996,79.999-80\r\n\t\t\tC335.999,212,300.005,176,256,176z M446.938,234.667c-9.605-88.531-81.074-160-169.605-169.599V32h-42.666v33.067\r\n\t\t\tc-88.531,9.599-160,81.068-169.604,169.599H32v42.667h33.062c9.604,88.531,81.072,160,169.604,169.604V480h42.666v-33.062\r\n\t\t\tc88.531-9.604,160-81.073,169.605-169.604H480v-42.667H446.938z M256,405.333c-82.137,0-149.334-67.198-149.334-149.333\r\n\t\t\tc0-82.136,67.197-149.333,149.334-149.333c82.135,0,149.332,67.198,149.332,149.333C405.332,338.135,338.135,405.333,256,405.333z\r\n\t\t\t"},"children":[{"name":"path","attribs":{"d":"M256,176c-44.004,0-80.001,36-80.001,80c0,44.004,35.997,80,80.001,80c44.005,0,79.999-35.996,79.999-80\r\n\t\t\tC335.999,212,300.005,176,256,176z M446.938,234.667c-9.605-88.531-81.074-160-169.605-169.599V32h-42.666v33.067\r\n\t\t\tc-88.531,9.599-160,81.068-169.604,169.599H32v42.667h33.062c9.604,88.531,81.072,160,169.604,169.604V480h42.666v-33.062\r\n\t\t\tc88.531-9.604,160-81.073,169.605-169.604H480v-42.667H446.938z M256,405.333c-82.137,0-149.334-67.198-149.334-149.333\r\n\t\t\tc0-82.136,67.197-149.333,149.334-149.333c82.135,0,149.332,67.198,149.332,149.333C405.332,338.135,338.135,405.333,256,405.333z\r\n\t\t\t"},"children":[]}]}]}]}]}]};exports.androidLocate=androidLocate;var androidLock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M376,186h-20v-40c0-55-45-100-100-100S156,91,156,146v40h-20c-22.002,0-40,17.998-40,40v200c0,22.002,17.998,40,40,40h240\r\n\t\t\tc22.002,0,40-17.998,40-40V226C416,203.998,398.002,186,376,186z M256,368c-22.002,0-40-17.998-40-40s17.998-40,40-40\r\n\t\t\ts40,17.998,40,40S278.002,368,256,368z M318.002,186H193.998v-40c0-34.004,28.003-62.002,62.002-62.002\r\n\t\t\tc34.004,0,62.002,27.998,62.002,62.002V186z"},"children":[{"name":"path","attribs":{"d":"M376,186h-20v-40c0-55-45-100-100-100S156,91,156,146v40h-20c-22.002,0-40,17.998-40,40v200c0,22.002,17.998,40,40,40h240\r\n\t\t\tc22.002,0,40-17.998,40-40V226C416,203.998,398.002,186,376,186z M256,368c-22.002,0-40-17.998-40-40s17.998-40,40-40\r\n\t\t\ts40,17.998,40,40S278.002,368,256,368z M318.002,186H193.998v-40c0-34.004,28.003-62.002,62.002-62.002\r\n\t\t\tc34.004,0,62.002,27.998,62.002,62.002V186z"},"children":[]}]}]}]}]}]};exports.androidLock=androidLock;var androidMail={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_19_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M437.332,80H74.668C51.199,80,32,99.198,32,122.667v266.666C32,412.802,51.199,432,74.668,432h362.664\r\n\t\t\tC460.801,432,480,412.802,480,389.333V122.667C480,99.198,460.801,80,437.332,80z M432,170.667L256,288L80,170.667V128\r\n\t\t\tl176,117.333L432,128V170.667z"},"children":[{"name":"path","attribs":{"d":"M437.332,80H74.668C51.199,80,32,99.198,32,122.667v266.666C32,412.802,51.199,432,74.668,432h362.664\r\n\t\t\tC460.801,432,480,412.802,480,389.333V122.667C480,99.198,460.801,80,437.332,80z M432,170.667L256,288L80,170.667V128\r\n\t\t\tl176,117.333L432,128V170.667z"},"children":[]}]}]}]}]}]};exports.androidMail=androidMail;var androidMap={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_34_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M437.333,64c-2.176,0-4.396,1.369-9.176,3.207S320,108.802,320,108.802L192,64L71.469,104.531\r\n\t\t\t\tC67.197,105.604,64,109.864,64,115.197v322.136C64,443.729,68.271,448,74.666,448c1.828,0,6.505-2.33,9.087-3.319\r\n\t\t\t\tS192,403.197,192,403.197L320,448l120.531-40.531c4.271-1.073,7.469-5.334,7.469-10.667V74.666C448,68.271,443.729,64,437.333,64\r\n\t\t\t\tz M320,405.333l-128-44.802V106.666l128,44.803V405.333z"},"children":[{"name":"path","attribs":{"d":"M437.333,64c-2.176,0-4.396,1.369-9.176,3.207S320,108.802,320,108.802L192,64L71.469,104.531\r\n\t\t\t\tC67.197,105.604,64,109.864,64,115.197v322.136C64,443.729,68.271,448,74.666,448c1.828,0,6.505-2.33,9.087-3.319\r\n\t\t\t\tS192,403.197,192,403.197L320,448l120.531-40.531c4.271-1.073,7.469-5.334,7.469-10.667V74.666C448,68.271,443.729,64,437.333,64\r\n\t\t\t\tz M320,405.333l-128-44.802V106.666l128,44.803V405.333z"},"children":[]}]}]}]}]}]}]}]};exports.androidMap=androidMap;var androidMenu={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_3_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,384h384v-42.666H64V384z M64,277.334h384v-42.667H64V277.334z M64,128v42.665h384V128H64z"},"children":[{"name":"path","attribs":{"d":"M64,384h384v-42.666H64V384z M64,277.334h384v-42.667H64V277.334z M64,128v42.665h384V128H64z"},"children":[]}]}]}]}]}]};exports.androidMenu=androidMenu;var androidMicrophoneOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M367.951,354.654l-26.616-26.562l-9.568-9.548l-4.698-4.706L187,174.041v0.346L76.112,63.531L51.921,87.572L187,222.47\r\n\t\tv28.816c0,37.79,31.121,68.714,68.91,68.714c8.61,0,16.952-1.62,24.565-4.545l32.389,32.274\r\n\t\tc-17.333,8.793-36.812,13.86-56.782,13.86c-62.986,0-121.365-48.59-121.365-116.59H95.773C95.773,322,158,387.701,233,398.013V480\r\n\t\th46v-81.987c22-3.352,43.066-11.222,61.627-22.622l95.278,95.078l24.033-24l-33.847-33.785l-58.216-57.959l58.224,57.959\r\n\t\tL367.951,354.654z"},"children":[{"name":"path","attribs":{"d":"M367.951,354.654l-26.616-26.562l-9.568-9.548l-4.698-4.706L187,174.041v0.346L76.112,63.531L51.921,87.572L187,222.47\r\n\t\tv28.816c0,37.79,31.121,68.714,68.91,68.714c8.61,0,16.952-1.62,24.565-4.545l32.389,32.274\r\n\t\tc-17.333,8.793-36.812,13.86-56.782,13.86c-62.986,0-121.365-48.59-121.365-116.59H95.773C95.773,322,158,387.701,233,398.013V480\r\n\t\th46v-81.987c22-3.352,43.066-11.222,61.627-22.622l95.278,95.078l24.033-24l-33.847-33.785l-58.216-57.959l58.224,57.959\r\n\t\tL367.951,354.654z"},"children":[]}]},{"name":"path","attribs":{"d":"M325,251.286V100.714C325,62.924,293.791,32,256,32s-69,30.924-69,68.714v25.244l137.109,136.968\r\n\t\tC324.779,259.135,325,255.247,325,251.286z"},"children":[{"name":"path","attribs":{"d":"M325,251.286V100.714C325,62.924,293.791,32,256,32s-69,30.924-69,68.714v25.244l137.109,136.968\r\n\t\tC324.779,259.135,325,255.247,325,251.286z"},"children":[]}]},{"name":"path","attribs":{"d":"M416.439,245h-38.941c0,20.496-5.498,39.676-14.931,56.197l27.572,27.516C406.662,304.603,416.439,275.926,416.439,245z"},"children":[{"name":"path","attribs":{"d":"M416.439,245h-38.941c0,20.496-5.498,39.676-14.931,56.197l27.572,27.516C406.662,304.603,416.439,275.926,416.439,245z"},"children":[]}]},{"name":"polygon","attribs":{"points":"459.999,446.427 426.102,412.684 459.957,446.469 \t"},"children":[{"name":"polygon","attribs":{"points":"459.999,446.427 426.102,412.684 459.957,446.469 \t"},"children":[]}]}]}]};exports.androidMicrophoneOff=androidMicrophoneOff;var androidMicrophone={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,320c37.712,0,68.571-30.924,68.571-68.714V100.714C324.571,62.924,293.712,32,256,32s-68.571,30.924-68.571,68.714\r\n\t\tv150.572C187.429,289.076,218.288,320,256,320z M377.139,244.548c0,68.714-58.282,116.815-121.139,116.815\r\n\t\ts-121.139-48.102-121.139-116.815H96c0,77.873,61.719,143.153,137.144,153.465V480h45.713v-81.987\r\n\t\tC354.281,386.561,416,322.421,416,244.548H377.139z"},"children":[{"name":"path","attribs":{"d":"M256,320c37.712,0,68.571-30.924,68.571-68.714V100.714C324.571,62.924,293.712,32,256,32s-68.571,30.924-68.571,68.714\r\n\t\tv150.572C187.429,289.076,218.288,320,256,320z M377.139,244.548c0,68.714-58.282,116.815-121.139,116.815\r\n\t\ts-121.139-48.102-121.139-116.815H96c0,77.873,61.719,143.153,137.144,153.465V480h45.713v-81.987\r\n\t\tC354.281,386.561,416,322.421,416,244.548H377.139z"},"children":[]}]}]}]};exports.androidMicrophone=androidMicrophone;var androidMoreHorizontal={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M136,216c-22.002,0-40,17.998-40,40s17.998,40,40,40s40-17.998,40-40S158.002,216,136,216z M376,216\r\n\tc-22.002,0-40,17.998-40,40s17.998,40,40,40s40-17.998,40-40S398.002,216,376,216z M256,216c-22.002,0-40,17.998-40,40\r\n\ts17.998,40,40,40s40-17.998,40-40S278.002,216,256,216z"},"children":[]}]};exports.androidMoreHorizontal=androidMoreHorizontal;var androidMoreVertical={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M296,136c0-22.002-17.998-40-40-40s-40,17.998-40,40s17.998,40,40,40S296,158.002,296,136z M296,376\r\n\tc0-22.002-17.998-40-40-40s-40,17.998-40,40s17.998,40,40,40S296,398.002,296,376z M296,256c0-22.002-17.998-40-40-40\r\n\ts-40,17.998-40,40s17.998,40,40,40S296,278.002,296,256z"},"children":[]}]};exports.androidMoreVertical=androidMoreVertical;var androidNavigate={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_5_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,64 96,433.062 110.938,448 256,384 401.062,448 416,433.062 \t\t"},"children":[{"name":"polygon","attribs":{"points":"256,64 96,433.062 110.938,448 256,384 401.062,448 416,433.062 \t\t"},"children":[]}]}]}]}]}]};exports.androidNavigate=androidNavigate;var androidNotificationsNone={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M257,120.471c7.083,0,23.911,4.479,23.911,4.479c45.589,10.447,77.678,52.439,77.678,99.85v114.4v13.212l9.321,9.364\r\n\tl7.788,7.823H136.302l7.788-7.823l9.321-9.364V339.2V224.8c0-47.41,32.089-89.403,77.678-99.85c0,0,18.043-4.479,23.911-4.479\r\n\t M256,48c-17.602,0-31.059,13.518-31.059,31.2v14.559c-59.015,13.523-103.53,67.601-103.53,131.041v114.4L80,380.8v20.8h352v-20.8\r\n\tl-41.411-41.6V224.8c0-63.44-44.516-117.518-103.53-131.041V79.2C287.059,61.518,273.602,48,256,48L256,48z M297.411,422.4h-82.823\r\n\tc0,22.881,18.633,41.6,41.412,41.6S297.411,445.281,297.411,422.4L297.411,422.4z"},"children":[]}]};exports.androidNotificationsNone=androidNotificationsNone;var androidNotificationsOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,463.656c22.814,0,41.475-18.656,41.475-41.656h-82.95C214.525,445,233.186,463.656,256,463.656z"},"children":[{"name":"path","attribs":{"d":"M256,463.656c22.814,0,41.475-18.656,41.475-41.656h-82.95C214.525,445,233.186,463.656,256,463.656z"},"children":[]}]},{"name":"path","attribs":{"d":"M131.083,107.172l0.053,0.074L98.09,74.277L74.004,98.383l63.042,63.153C126.888,180.521,121,202.196,121,225.07v114.555\r\n\t\tl-41,41.656V402h297.743l36.182,36.33l24.079-24.301L425.9,402h0.316L131.083,107.172z"},"children":[{"name":"path","attribs":{"d":"M131.083,107.172l0.053,0.074L98.09,74.277L74.004,98.383l63.042,63.153C126.888,180.521,121,202.196,121,225.07v114.555\r\n\t\tl-41,41.656V402h297.743l36.182,36.33l24.079-24.301L425.9,402h0.316L131.083,107.172z"},"children":[]}]},{"name":"path","attribs":{"d":"M391,225.07c0-63.526-45-117.677-104-131.218V79.274c0-17.706-13.371-31.243-31-31.243c-17.628,0-31,13.537-31,31.243\r\n\t\tv14.578c-15,3.438-29.048,9.501-41.75,17.663L391,319.355V225.07z"},"children":[{"name":"path","attribs":{"d":"M391,225.07c0-63.526-45-117.677-104-131.218V79.274c0-17.706-13.371-31.243-31-31.243c-17.628,0-31,13.537-31,31.243\r\n\t\tv14.578c-15,3.438-29.048,9.501-41.75,17.663L391,319.355V225.07z"},"children":[]}]}]}]};exports.androidNotificationsOff=androidNotificationsOff;var androidNotifications={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,464c22.779,0,41.411-18.719,41.411-41.6h-82.823C214.588,445.281,233.221,464,256,464z M390.589,339.2V224.8\r\n\tc0-63.44-44.516-117.518-103.53-131.041V79.2c0-17.682-13.457-31.2-31.059-31.2s-31.059,13.518-31.059,31.2v14.559\r\n\tc-59.015,13.523-103.53,67.601-103.53,131.041v114.4L80,380.8v20.8h352v-20.8L390.589,339.2z"},"children":[]}]};exports.androidNotifications=androidNotifications;var androidOpen={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M405.34,405.332H106.66V106.668H240V64H106.66C83.191,64,64,83.197,64,106.668v298.664C64,428.803,83.191,448,106.66,448\r\n\th298.68c23.469,0,42.66-19.197,42.66-42.668V272h-42.66V405.332z M288,64v42.668h87.474L159.999,322.133l29.866,29.866\r\n\tl215.476-215.47V224H448V64H288z"},"children":[]}]};exports.androidOpen=androidOpen;var androidOptions={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"32","y":"384","width":"272","height":"32"},"children":[{"name":"rect","attribs":{"x":"32","y":"384","width":"272","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"400","y":"384","width":"80","height":"32"},"children":[{"name":"rect","attribs":{"x":"400","y":"384","width":"80","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M384,447.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V447.5z"},"children":[{"name":"path","attribs":{"d":"M384,447.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V447.5z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"32","y":"240","width":"80","height":"32"},"children":[{"name":"rect","attribs":{"x":"32","y":"240","width":"80","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"240","width":"272","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"240","width":"272","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M192,303.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V303.5z"},"children":[{"name":"path","attribs":{"d":"M192,303.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V303.5z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"32","y":"96","width":"272","height":"32"},"children":[{"name":"rect","attribs":{"x":"32","y":"96","width":"272","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"400","y":"96","width":"80","height":"32"},"children":[{"name":"rect","attribs":{"x":"400","y":"96","width":"80","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M384,159.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V159.5z"},"children":[{"name":"path","attribs":{"d":"M384,159.5c0,17.949-14.327,32.5-32,32.5l0,0c-17.673,0-32-14.551-32-32.5v-95c0-17.949,14.327-32.5,32-32.5l0,0\r\n\t\t\tc17.673,0,32,14.551,32,32.5V159.5z"},"children":[]}]}]}]}]}]};exports.androidOptions=androidOptions;var androidPeople={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M337.454,232c33.599,0,61.092-27.002,61.092-60c0-32.997-27.493-60-61.092-60s-61.09,27.003-61.09,60\r\n\tC276.364,204.998,303.855,232,337.454,232z M174.546,232c33.599,0,61.09-27.002,61.09-60c0-32.997-27.491-60-61.09-60\r\n\ts-61.092,27.003-61.092,60C113.454,204.998,140.947,232,174.546,232z M174.546,276C126.688,276,32,298.998,32,346v54h288v-54\r\n\tC320,298.998,222.401,276,174.546,276z M337.454,287.003c-6.105,0-10.325,0-17.454,0.997c23.426,17.002,32,28,32,58v54h128v-54\r\n\tC480,298.998,385.312,287.003,337.454,287.003z"},"children":[]}]};exports.androidPeople=androidPeople;var androidPersonAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M304,256c52.805,0,96-43.201,96-96s-43.195-96-96-96s-96,43.201-96,96S251.195,256,304,256z M304,304\r\n\t\t\tc-63.598,0-192,32.402-192,96v48h384v-48C496,336.402,367.598,304,304,304z"},"children":[{"name":"path","attribs":{"d":"M304,256c52.805,0,96-43.201,96-96s-43.195-96-96-96s-96,43.201-96,96S251.195,256,304,256z M304,304\r\n\t\t\tc-63.598,0-192,32.402-192,96v48h384v-48C496,336.402,367.598,304,304,304z"},"children":[]}]}]}]},{"name":"g","attribs":{"id":"Icon_16_"},"children":[{"name":"g","attribs":{"id":"Icon_16_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M112,224v-64H80v64H16v32h64v64h32v-64h64v-32H112z"},"children":[{"name":"path","attribs":{"d":"M112,224v-64H80v64H16v32h64v64h32v-64h64v-32H112z"},"children":[]}]}]}]}]}]}]}]};exports.androidPersonAdd=androidPersonAdd;var androidPerson={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,256c52.805,0,96-43.201,96-96s-43.195-96-96-96s-96,43.201-96,96S203.195,256,256,256z M256,304\r\n\t\tc-63.598,0-192,32.402-192,96v48h384v-48C448,336.402,319.598,304,256,304z"},"children":[{"name":"path","attribs":{"d":"M256,256c52.805,0,96-43.201,96-96s-43.195-96-96-96s-96,43.201-96,96S203.195,256,256,256z M256,304\r\n\t\tc-63.598,0-192,32.402-192,96v48h384v-48C448,336.402,319.598,304,256,304z"},"children":[]}]}]}]};exports.androidPerson=androidPerson;var androidPhoneLandscape={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_6_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,358.856V153.143C480,130.512,461.674,112,439.272,112H72.728C50.326,112,32,130.512,32,153.143v205.713\r\n\t\t\tC32,381.488,50.326,400,72.728,400h366.545C461.674,400,480,381.488,480,358.856z M112,364V148h288v216H112z"},"children":[{"name":"path","attribs":{"d":"M480,358.856V153.143C480,130.512,461.674,112,439.272,112H72.728C50.326,112,32,130.512,32,153.143v205.713\r\n\t\t\tC32,381.488,50.326,400,72.728,400h366.545C461.674,400,480,381.488,480,358.856z M112,364V148h288v216H112z"},"children":[]}]}]}]}]}]};exports.androidPhoneLandscape=androidPhoneLandscape;var androidPhonePortrait={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_6_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M358.856,32H153.143C130.512,32,112,50.326,112,72.728v366.545C112,461.674,130.512,480,153.143,480h205.713\r\n\t\t\tC381.488,480,400,461.674,400,439.272V72.728C400,50.326,381.488,32,358.856,32z M364,400H148V112h216V400z"},"children":[{"name":"path","attribs":{"d":"M358.856,32H153.143C130.512,32,112,50.326,112,72.728v366.545C112,461.674,130.512,480,153.143,480h205.713\r\n\t\t\tC381.488,480,400,461.674,400,439.272V72.728C400,50.326,381.488,32,358.856,32z M364,400H148V112h216V400z"},"children":[]}]}]}]}]}]};exports.androidPhonePortrait=androidPhonePortrait;var androidPin={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32c-88.004,0-160,70.557-160,156.801C96,306.4,256,480,256,480s160-173.6,160-291.199C416,102.557,344.004,32,256,32z\r\n\t\t M256,244.801c-31.996,0-57.144-24.645-57.144-56c0-31.357,25.147-56,57.144-56s57.144,24.643,57.144,56\r\n\t\tC313.144,220.156,287.996,244.801,256,244.801z"},"children":[{"name":"path","attribs":{"d":"M256,32c-88.004,0-160,70.557-160,156.801C96,306.4,256,480,256,480s160-173.6,160-291.199C416,102.557,344.004,32,256,32z\r\n\t\t M256,244.801c-31.996,0-57.144-24.645-57.144-56c0-31.357,25.147-56,57.144-56s57.144,24.643,57.144,56\r\n\t\tC313.144,220.156,287.996,244.801,256,244.801z"},"children":[]}]}]}]};exports.androidPin=androidPin;var androidPlane={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_36_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,336v-40L288,192V79.2c0-17.683-14.82-31.2-32-31.2c-17.179,0-32,13.518-32,31.2V192L64,296v40l160-48v113.602\r\n\t\t\tl-48,31.199V464l80-16l80,16v-31.199l-48-31.199V288L448,336z"},"children":[{"name":"path","attribs":{"d":"M448,336v-40L288,192V79.2c0-17.683-14.82-31.2-32-31.2c-17.179,0-32,13.518-32,31.2V192L64,296v40l160-48v113.602\r\n\t\t\tl-48,31.199V464l80-16l80,16v-31.199l-48-31.199V288L448,336z"},"children":[]}]}]}]}]}]};exports.androidPlane=androidPlane;var androidPlaystore={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M464,152H360c0-57-46.562-103.859-104-103.859C198.562,48.141,152,95,152,152H48C66.688,368,61,464,61,464h389.999\r\n\t\tC450.998,464,445.311,366,464,152z M256,74.105c43.008,0,77.999,34.895,77.999,77.895H178C178,109,212.991,74.105,256,74.105z\r\n\t\t M204,397.64V228.867l142.999,84.387L204,397.64z"},"children":[{"name":"path","attribs":{"d":"M464,152H360c0-57-46.562-103.859-104-103.859C198.562,48.141,152,95,152,152H48C66.688,368,61,464,61,464h389.999\r\n\t\tC450.998,464,445.311,366,464,152z M256,74.105c43.008,0,77.999,34.895,77.999,77.895H178C178,109,212.991,74.105,256,74.105z\r\n\t\t M204,397.64V228.867l142.999,84.387L204,397.64z"},"children":[]}]}]}]};exports.androidPlaystore=androidPlaystore;var androidPrint={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M399.95,160h-287.9C76.824,160,48,188.803,48,224v138.667h79.899V448h256.201v-85.333H464V224\r\n\t\tC464,188.803,435.175,160,399.95,160z M352,416H160V288h192V416z M384.101,64H127.899v80h256.201V64z"},"children":[{"name":"path","attribs":{"d":"M399.95,160h-287.9C76.824,160,48,188.803,48,224v138.667h79.899V448h256.201v-85.333H464V224\r\n\t\tC464,188.803,435.175,160,399.95,160z M352,416H160V288h192V416z M384.101,64H127.899v80h256.201V64z"},"children":[]}]}]}]};exports.androidPrint=androidPrint;var androidRadioButtonOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_20_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.601,48,48,141.601,48,256s93.601,208,208,208s208-93.601,208-208S370.399,48,256,48z M256,422.399\r\n\t\t\tc-91.518,0-166.399-74.882-166.399-166.399S164.482,89.6,256,89.6S422.4,164.482,422.4,256S347.518,422.399,256,422.399z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.601,48,48,141.601,48,256s93.601,208,208,208s208-93.601,208-208S370.399,48,256,48z M256,422.399\r\n\t\t\tc-91.518,0-166.399-74.882-166.399-166.399S164.482,89.6,256,89.6S422.4,164.482,422.4,256S347.518,422.399,256,422.399z"},"children":[]}]}]}]}]}]};exports.androidRadioButtonOff=androidRadioButtonOff;var androidRadioButtonOn={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_21_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,152c-57.2,0-104,46.8-104,104s46.8,104,104,104s104-46.8,104-104S313.2,152,256,152z M256,48\r\n\t\t\tC141.601,48,48,141.601,48,256s93.601,208,208,208s208-93.601,208-208S370.399,48,256,48z M256,422.4\r\n\t\t\tc-91.518,0-166.4-74.883-166.4-166.4S164.482,89.6,256,89.6S422.4,164.482,422.4,256S347.518,422.4,256,422.4z"},"children":[{"name":"path","attribs":{"d":"M256,152c-57.2,0-104,46.8-104,104s46.8,104,104,104s104-46.8,104-104S313.2,152,256,152z M256,48\r\n\t\t\tC141.601,48,48,141.601,48,256s93.601,208,208,208s208-93.601,208-208S370.399,48,256,48z M256,422.4\r\n\t\t\tc-91.518,0-166.4-74.883-166.4-166.4S164.482,89.6,256,89.6S422.4,164.482,422.4,256S347.518,422.4,256,422.4z"},"children":[]}]}]}]}]}]};exports.androidRadioButtonOn=androidRadioButtonOn;var androidRefresh={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,388c-72.597,0-132-59.405-132-132c0-72.601,59.403-132,132-132c36.3,0,69.299,15.4,92.406,39.601L278,234h154V80\r\n\t\tl-51.698,51.702C348.406,99.798,304.406,80,256,80c-96.797,0-176,79.203-176,176s78.094,176,176,176\r\n\t\tc81.045,0,148.287-54.134,169.401-128H378.85C360.105,353.561,311.712,388,256,388z"},"children":[{"name":"path","attribs":{"d":"M256,388c-72.597,0-132-59.405-132-132c0-72.601,59.403-132,132-132c36.3,0,69.299,15.4,92.406,39.601L278,234h154V80\r\n\t\tl-51.698,51.702C348.406,99.798,304.406,80,256,80c-96.797,0-176,79.203-176,176s78.094,176,176,176\r\n\t\tc81.045,0,148.287-54.134,169.401-128H378.85C360.105,353.561,311.712,388,256,388z"},"children":[]}]}]}]};exports.androidRefresh=androidRefresh;var androidRemoveCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M363,277H149v-42h214V277\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M256,48C141.125,48,48,141.125,48,256s93.125,208,208,208s208-93.125,208-208S370.875,48,256,48z M363,277H149v-42h214V277\r\n\t\tz"},"children":[]}]}]}]};exports.androidRemoveCircle=androidRemoveCircle;var androidRemove={"viewBox":"0 0 512 512","children":[{"name":"rect","attribs":{"x":"96","y":"235","width":"320","height":"42"},"children":[]}]};exports.androidRemove=androidRemove;var androidRestaurant={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_38_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M164.852,279.939l61.834-60.251L73.72,71.706c-33.626,32.764-33.626,86.677,0,119.44L164.852,279.939z"},"children":[{"name":"path","attribs":{"d":"M164.852,279.939l61.834-60.251L73.72,71.706c-33.626,32.764-33.626,86.677,0,119.44L164.852,279.939z"},"children":[]}]},{"name":"path","attribs":{"d":"M312.389,241.88c33.636,14.802,80.283,4.232,113.91-29.593c41.222-40.165,49.909-98.303,17.363-128.96\r\n\t\t\t\tc-31.465-31.71-91.131-23.245-132.354,16.921c-34.718,33.825-45.566,79.276-30.374,110.986\r\n\t\t\t\tC233.195,258.802,69.382,418.407,69.382,418.407L99.759,448l149.71-145.866L399.177,448l30.374-29.593L279.842,272.538\r\n\t\t\t\tL312.389,241.88z"},"children":[{"name":"path","attribs":{"d":"M312.389,241.88c33.636,14.802,80.283,4.232,113.91-29.593c41.222-40.165,49.909-98.303,17.363-128.96\r\n\t\t\t\tc-31.465-31.71-91.131-23.245-132.354,16.921c-34.718,33.825-45.566,79.276-30.374,110.986\r\n\t\t\t\tC233.195,258.802,69.382,418.407,69.382,418.407L99.759,448l149.71-145.866L399.177,448l30.374-29.593L279.842,272.538\r\n\t\t\t\tL312.389,241.88z"},"children":[]}]}]}]}]}]}]}]};exports.androidRestaurant=androidRestaurant;var androidSad={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,288c-45.443,0-83.675,26.076-102.205,64h204.41C339.675,314.076,301.443,288,256,288z"},"children":[{"name":"path","attribs":{"d":"M256,288c-45.443,0-83.675,26.076-102.205,64h204.41C339.675,314.076,301.443,288,256,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,48C140.563,48,48,141.6,48,256c0,114.4,92.563,208,208,208s208-93.6,208-208C464,141.6,370.401,48,256,48z M256,422.4\r\n\t\tc-91.518,0-166.404-74.883-166.404-166.4c0-91.518,74.887-166.4,166.404-166.4S422.404,164.482,422.404,256\r\n\t\tC422.404,347.518,347.518,422.4,256,422.4z"},"children":[{"name":"path","attribs":{"d":"M256,48C140.563,48,48,141.6,48,256c0,114.4,92.563,208,208,208s208-93.6,208-208C464,141.6,370.401,48,256,48z M256,422.4\r\n\t\tc-91.518,0-166.404-74.883-166.404-166.4c0-91.518,74.887-166.4,166.404-166.4S422.404,164.482,422.404,256\r\n\t\tC422.404,347.518,347.518,422.4,256,422.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M328.8,235.2c17.683,0,31.201-13.518,31.201-31.2s-13.519-31.2-31.201-31.2c-17.682,0-31.2,13.518-31.2,31.2\r\n\t\tS311.118,235.2,328.8,235.2z"},"children":[{"name":"path","attribs":{"d":"M328.8,235.2c17.683,0,31.201-13.518,31.201-31.2s-13.519-31.2-31.201-31.2c-17.682,0-31.2,13.518-31.2,31.2\r\n\t\tS311.118,235.2,328.8,235.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M183.2,235.2c17.682,0,31.2-13.518,31.2-31.2s-13.519-31.2-31.2-31.2c-17.683,0-31.201,13.518-31.201,31.2\r\n\t\tS165.518,235.2,183.2,235.2z"},"children":[{"name":"path","attribs":{"d":"M183.2,235.2c17.682,0,31.2-13.518,31.2-31.2s-13.519-31.2-31.2-31.2c-17.683,0-31.201,13.518-31.201,31.2\r\n\t\tS165.518,235.2,183.2,235.2z"},"children":[]}]}]}]};exports.androidSad=androidSad;var androidSearch={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_4_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M337.509,305.372h-17.501l-6.571-5.486c20.791-25.232,33.922-57.054,33.922-93.257\r\n\t\t\t\t\tC347.358,127.632,283.896,64,205.135,64C127.452,64,64,127.632,64,206.629s63.452,142.628,142.225,142.628\r\n\t\t\t\t\tc35.011,0,67.831-13.167,92.991-34.008l6.561,5.487v17.551L415.18,448L448,415.086L337.509,305.372z M206.225,305.372\r\n\t\t\t\t\tc-54.702,0-98.463-43.887-98.463-98.743c0-54.858,43.761-98.742,98.463-98.742c54.7,0,98.462,43.884,98.462,98.742\r\n\t\t\t\t\tC304.687,261.485,260.925,305.372,206.225,305.372z"},"children":[{"name":"path","attribs":{"d":"M337.509,305.372h-17.501l-6.571-5.486c20.791-25.232,33.922-57.054,33.922-93.257\r\n\t\t\t\t\tC347.358,127.632,283.896,64,205.135,64C127.452,64,64,127.632,64,206.629s63.452,142.628,142.225,142.628\r\n\t\t\t\t\tc35.011,0,67.831-13.167,92.991-34.008l6.561,5.487v17.551L415.18,448L448,415.086L337.509,305.372z M206.225,305.372\r\n\t\t\t\t\tc-54.702,0-98.463-43.887-98.463-98.743c0-54.858,43.761-98.742,98.463-98.742c54.7,0,98.462,43.884,98.462,98.742\r\n\t\t\t\t\tC304.687,261.485,260.925,305.372,206.225,305.372z"},"children":[]}]}]}]}]}]}]}]}]}]};exports.androidSearch=androidSearch;var androidSend={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"48,448 464,256 48,64 48,213.333 346,256 48,298.667 "},"children":[]}]};exports.androidSend=androidSend;var androidSettings={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M413.967,276.8c1.06-6.235,1.06-13.518,1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318\r\n\t\tc4.26-3.118,5.319-8.317,2.13-13.518L418.215,115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186,20.801\r\n\t\tc-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098\r\n\t\tc-5.318,0-9.577,4.164-10.637,8.318l-8.508,55.117c-12.767,5.2-24.464,12.482-36.171,20.801l-53.186-20.801\r\n\t\tc-5.319-2.071-10.638,0-12.767,4.164l-42.549,71.765c-2.119,4.153-1.061,10.399,2.129,13.518L96.97,235.2\r\n\t\tc0,7.282-1.06,13.518-1.06,20.8s1.06,13.518,1.06,20.8l-44.668,34.318c-4.26,3.118-5.318,8.317-2.13,13.518L92.721,396.4\r\n\t\tc2.13,4.164,8.508,6.235,12.767,4.164l53.187-20.801c10.637,8.318,23.394,15.601,36.16,20.801l8.508,55.117\r\n\t\tc1.069,5.2,5.318,8.318,10.637,8.318h85.098c5.319,0,9.578-4.164,10.638-8.318l8.518-55.117c12.757-5.2,24.464-12.482,36.16-20.801\r\n\t\tl53.187,20.801c5.318,2.071,10.637,0,12.767-4.164l42.549-71.765c2.129-4.153,1.06-10.399-2.13-13.518L413.967,276.8z\r\n\t\t M255.468,328.8c-41.489,0-74.46-32.235-74.46-72.8s32.971-72.8,74.46-72.8s74.461,32.235,74.461,72.8S296.957,328.8,255.468,328.8\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M413.967,276.8c1.06-6.235,1.06-13.518,1.06-20.8s-1.06-13.518-1.06-20.8l44.667-34.318\r\n\t\tc4.26-3.118,5.319-8.317,2.13-13.518L418.215,115.6c-2.129-4.164-8.507-6.235-12.767-4.164l-53.186,20.801\r\n\t\tc-10.638-8.318-23.394-15.601-36.16-20.801l-7.448-55.117c-1.06-4.154-5.319-8.318-10.638-8.318h-85.098\r\n\t\tc-5.318,0-9.577,4.164-10.637,8.318l-8.508,55.117c-12.767,5.2-24.464,12.482-36.171,20.801l-53.186-20.801\r\n\t\tc-5.319-2.071-10.638,0-12.767,4.164l-42.549,71.765c-2.119,4.153-1.061,10.399,2.129,13.518L96.97,235.2\r\n\t\tc0,7.282-1.06,13.518-1.06,20.8s1.06,13.518,1.06,20.8l-44.668,34.318c-4.26,3.118-5.318,8.317-2.13,13.518L92.721,396.4\r\n\t\tc2.13,4.164,8.508,6.235,12.767,4.164l53.187-20.801c10.637,8.318,23.394,15.601,36.16,20.801l8.508,55.117\r\n\t\tc1.069,5.2,5.318,8.318,10.637,8.318h85.098c5.319,0,9.578-4.164,10.638-8.318l8.518-55.117c12.757-5.2,24.464-12.482,36.16-20.801\r\n\t\tl53.187,20.801c5.318,2.071,10.637,0,12.767-4.164l42.549-71.765c2.129-4.153,1.06-10.399-2.13-13.518L413.967,276.8z\r\n\t\t M255.468,328.8c-41.489,0-74.46-32.235-74.46-72.8s32.971-72.8,74.46-72.8s74.461,32.235,74.461,72.8S296.957,328.8,255.468,328.8\r\n\t\tz"},"children":[]}]}]}]};exports.androidSettings=androidSettings;var androidShareAlt={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_33_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M383.822,344.427c-16.045,0-31.024,5.326-41.721,15.979l-152.957-88.42c1.071-5.328,2.142-9.593,2.142-14.919\r\n\t\t\tc0-5.328-1.071-9.593-2.142-14.919l150.826-87.35c11.762,10.653,26.741,17.041,43.852,17.041c35.295,0,64.178-28.766,64.178-63.92\r\n\t\t\tC448,72.767,419.117,44,383.822,44c-35.297,0-64.179,28.767-64.179,63.92c0,5.327,1.065,9.593,2.142,14.919l-150.821,87.35\r\n\t\t\tc-11.767-10.654-26.741-17.041-43.856-17.041c-35.296,0-63.108,28.766-63.108,63.92c0,35.153,28.877,63.92,64.178,63.92\r\n\t\t\tc17.115,0,32.089-6.389,43.856-17.042l151.891,88.421c-1.076,4.255-2.141,8.521-2.141,13.847\r\n\t\t\tc0,34.094,27.806,61.787,62.037,61.787c34.229,0,62.036-27.693,62.036-61.787C445.858,372.12,418.052,344.427,383.822,344.427z"},"children":[{"name":"path","attribs":{"d":"M383.822,344.427c-16.045,0-31.024,5.326-41.721,15.979l-152.957-88.42c1.071-5.328,2.142-9.593,2.142-14.919\r\n\t\t\tc0-5.328-1.071-9.593-2.142-14.919l150.826-87.35c11.762,10.653,26.741,17.041,43.852,17.041c35.295,0,64.178-28.766,64.178-63.92\r\n\t\t\tC448,72.767,419.117,44,383.822,44c-35.297,0-64.179,28.767-64.179,63.92c0,5.327,1.065,9.593,2.142,14.919l-150.821,87.35\r\n\t\t\tc-11.767-10.654-26.741-17.041-43.856-17.041c-35.296,0-63.108,28.766-63.108,63.92c0,35.153,28.877,63.92,64.178,63.92\r\n\t\t\tc17.115,0,32.089-6.389,43.856-17.042l151.891,88.421c-1.076,4.255-2.141,8.521-2.141,13.847\r\n\t\t\tc0,34.094,27.806,61.787,62.037,61.787c34.229,0,62.036-27.693,62.036-61.787C445.858,372.12,418.052,344.427,383.822,344.427z"},"children":[]}]}]}]}]}]};exports.androidShareAlt=androidShareAlt;var androidShare={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_17_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,248L288,96v85.334C138.666,202.667,85.333,309.334,64,416c53.333-74.666,117.333-108.802,224-108.802v87.469L448,248\r\n\t\t\tz"},"children":[{"name":"path","attribs":{"d":"M448,248L288,96v85.334C138.666,202.667,85.333,309.334,64,416c53.333-74.666,117.333-108.802,224-108.802v87.469L448,248\r\n\t\t\tz"},"children":[]}]}]}]}]}]};exports.androidShare=androidShare;var androidStarHalf={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M458,210.409l-145.267-12.476L256,64l-56.743,133.934L54,210.409l110.192,95.524L131.161,448L256,372.686L380.83,448\r\n\tl-33.021-142.066L458,210.409z M272.531,345.287L256,335.313l-0.002-189.277l27.27,64.379l7.52,17.751l19.208,1.65l69.846,5.998\r\n\tl-52.993,45.939l-14.576,12.636l4.367,18.788l15.875,68.299L272.531,345.287z"},"children":[]}]};exports.androidStarHalf=androidStarHalf;var androidStarOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M458,210.409l-145.267-12.476L256,64l-56.743,133.934L54,210.409l110.192,95.524L131.161,448L256,372.686L380.83,448\r\n\tl-33.021-142.066L458,210.409z M272.531,345.286L256,335.312l-16.53,9.973l-59.988,36.191l15.879-68.296l4.369-18.79l-14.577-12.637\r\n\tl-52.994-45.939l69.836-5.998l19.206-1.65l7.521-17.75l27.276-64.381l27.27,64.379l7.52,17.751l19.208,1.65l69.846,5.998\r\n\tl-52.993,45.939l-14.576,12.636l4.367,18.788l15.875,68.299L272.531,345.286z"},"children":[]}]};exports.androidStarOutline=androidStarOutline;var androidStar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,372.686 380.83,448 347.809,305.934 458,210.409 312.733,197.934 256,64 199.257,197.934 54,210.409 \r\n\t\t164.192,305.934 131.161,448 \t"},"children":[{"name":"polygon","attribs":{"points":"256,372.686 380.83,448 347.809,305.934 458,210.409 312.733,197.934 256,64 199.257,197.934 54,210.409 \r\n\t\t164.192,305.934 131.161,448 \t"},"children":[]}]}]}]};exports.androidStar=androidStar;var androidStopwatch={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{"id":"Icon_7_"},"children":[{"name":"g","attribs":{"id":"Icon_7_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M232,306.667h48V176h-48V306.667z"},"children":[{"name":"path","attribs":{"d":"M232,306.667h48V176h-48V306.667z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M407.67,170.271l30.786-30.786l-33.942-33.941l-30.785,30.786C341.217,111.057,300.369,96,256,96\r\n\t\t\tC149.961,96,64,181.961,64,288s85.961,192,192,192s192-85.961,192-192C448,243.631,432.943,202.783,407.67,170.271z\r\n\t\t\t M362.066,394.066C333.734,422.398,296.066,438,256,438s-77.735-15.602-106.066-43.934C121.602,365.735,106,328.066,106,288\r\n\t\t\ts15.602-77.735,43.934-106.066C178.265,153.602,215.934,138,256,138s77.734,15.602,106.066,43.934\r\n\t\t\tC390.398,210.265,406,247.934,406,288S390.398,365.735,362.066,394.066z"},"children":[{"name":"path","attribs":{"d":"M407.67,170.271l30.786-30.786l-33.942-33.941l-30.785,30.786C341.217,111.057,300.369,96,256,96\r\n\t\t\tC149.961,96,64,181.961,64,288s85.961,192,192,192s192-85.961,192-192C448,243.631,432.943,202.783,407.67,170.271z\r\n\t\t\t M362.066,394.066C333.734,422.398,296.066,438,256,438s-77.735-15.602-106.066-43.934C121.602,365.735,106,328.066,106,288\r\n\t\t\ts15.602-77.735,43.934-106.066C178.265,153.602,215.934,138,256,138s77.734,15.602,106.066,43.934\r\n\t\t\tC390.398,210.265,406,247.934,406,288S390.398,365.735,362.066,394.066z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"32","width":"128","height":"48"},"children":[{"name":"rect","attribs":{"x":"192","y":"32","width":"128","height":"48"},"children":[]}]}]}]}]}]};exports.androidStopwatch=androidStopwatch;var androidSubway={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48c-93.864,0-176,10.668-176,85.334v213.332c0,41.604,33.062,74.666,74.667,74.666L128,448v16h256v-16l-26.667-26.668\r\n\t\tc41.604,0,74.667-33.062,74.667-74.666V133.334C432,58.668,349.864,48,256,48z M160,384c-18.136,0-32-13.865-32-32\r\n\t\tc0-18.137,13.864-32,32-32s32,13.863,32,32C192,370.135,178.136,384,160,384z M240,240H128v-96h112V240z M352,384\r\n\t\tc-18.136,0-32-13.865-32-32c0-18.137,13.864-32,32-32s32,13.863,32,32C384,370.135,370.136,384,352,384z M384,240H272v-96h112V240z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M256,48c-93.864,0-176,10.668-176,85.334v213.332c0,41.604,33.062,74.666,74.667,74.666L128,448v16h256v-16l-26.667-26.668\r\n\t\tc41.604,0,74.667-33.062,74.667-74.666V133.334C432,58.668,349.864,48,256,48z M160,384c-18.136,0-32-13.865-32-32\r\n\t\tc0-18.137,13.864-32,32-32s32,13.863,32,32C192,370.135,178.136,384,160,384z M240,240H128v-96h112V240z M352,384\r\n\t\tc-18.136,0-32-13.865-32-32c0-18.137,13.864-32,32-32s32,13.863,32,32C384,370.135,370.136,384,352,384z M384,240H272v-96h112V240z\r\n\t\t"},"children":[]}]}]}]};exports.androidSubway=androidSubway;var androidSunny={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_27_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,160c25.499,0,49.567,10.025,67.771,28.229C341.975,206.433,352,230.501,352,256s-10.025,49.567-28.229,67.771\r\n\t\t\tC305.567,341.975,281.499,352,256,352s-49.567-10.025-67.771-28.229C170.025,305.567,160,281.499,160,256\r\n\t\t\ts10.025-49.567,28.229-67.771C206.433,170.025,230.501,160,256,160 M277.333,32h-42.666v64h42.666V32L277.333,32z M406.396,75.729\r\n\t\t\tL368,114.135L397.864,144l38.406-38.396L406.396,75.729L406.396,75.729z M105.604,75.729l-29.875,29.875L114.136,144L144,114.135\r\n\t\t\tL105.604,75.729L105.604,75.729z M256,128c-70.396,0-128,57.604-128,128s57.604,128,128,128s128-57.604,128-128\r\n\t\t\tS326.396,128,256,128L256,128z M480,234.666h-64v42.668h64V234.666L480,234.666z M96,234.666H32v42.668h64V234.666L96,234.666z\r\n\t\t\t M397.864,368L368,397.865l38.396,38.406l29.875-29.875L397.864,368L397.864,368z M114.136,368l-38.406,38.396l29.875,29.875\r\n\t\t\tL144,397.865L114.136,368L114.136,368z M277.333,416h-42.666v64c6.396,0,42.666,0,42.666,0V416L277.333,416z"},"children":[{"name":"path","attribs":{"d":"M256,160c25.499,0,49.567,10.025,67.771,28.229C341.975,206.433,352,230.501,352,256s-10.025,49.567-28.229,67.771\r\n\t\t\tC305.567,341.975,281.499,352,256,352s-49.567-10.025-67.771-28.229C170.025,305.567,160,281.499,160,256\r\n\t\t\ts10.025-49.567,28.229-67.771C206.433,170.025,230.501,160,256,160 M277.333,32h-42.666v64h42.666V32L277.333,32z M406.396,75.729\r\n\t\t\tL368,114.135L397.864,144l38.406-38.396L406.396,75.729L406.396,75.729z M105.604,75.729l-29.875,29.875L114.136,144L144,114.135\r\n\t\t\tL105.604,75.729L105.604,75.729z M256,128c-70.396,0-128,57.604-128,128s57.604,128,128,128s128-57.604,128-128\r\n\t\t\tS326.396,128,256,128L256,128z M480,234.666h-64v42.668h64V234.666L480,234.666z M96,234.666H32v42.668h64V234.666L96,234.666z\r\n\t\t\t M397.864,368L368,397.865l38.396,38.406l29.875-29.875L397.864,368L397.864,368z M114.136,368l-38.406,38.396l29.875,29.875\r\n\t\t\tL144,397.865L114.136,368L114.136,368z M277.333,416h-42.666v64c6.396,0,42.666,0,42.666,0V416L277.333,416z"},"children":[]}]}]}]}]}]};exports.androidSunny=androidSunny;var androidSync={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,93.09V32l-80,81.454l80,81.456v-61.093c65.996,0,120,54.982,120,122.183c0,20.363-5,39.714-14.004,57.016L391,342.547\r\n\tc15.996-25.457,25-54.988,25-86.547C416,166.401,343.998,93.09,256,93.09z M256,378.184c-66.001,0-120-54.988-120-122.184\r\n\tc0-20.363,5-39.709,13.999-57.02L121,169.454C104.999,193.89,96,224.436,96,256c0,89.599,72.002,162.91,160,162.91V480l80-81.453\r\n\tl-80-81.457V378.184z"},"children":[]}]};exports.androidSync=androidSync;var androidTextsms={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M408,64H96c-22.002,0-32,17.998-32,40v344l64-64h280c22.002,0,40-17.998,40-40V104C448,81.998,430.002,64,408,64z\r\n\t\t M198.4,242H160v-40h38.4V242z M275.2,242h-38.4v-40h38.4V242z M352,242h-38.4v-40H352V242z"},"children":[{"name":"path","attribs":{"d":"M408,64H96c-22.002,0-32,17.998-32,40v344l64-64h280c22.002,0,40-17.998,40-40V104C448,81.998,430.002,64,408,64z\r\n\t\t M198.4,242H160v-40h38.4V242z M275.2,242h-38.4v-40h38.4V242z M352,242h-38.4v-40H352V242z"},"children":[]}]}]}]};exports.androidTextsms=androidTextsms;var androidTime={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_1_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-opacity":"0.9","d":"M256,43C137.789,43,43,138.851,43,256s94.789,213,213,213s213-95.851,213-213S373.149,43,256,43z\r\n\t\t\t\t M256,426.4c-93.718,0-170.4-76.683-170.4-170.4S162.282,85.6,256,85.6S426.4,162.282,426.4,256S349.718,426.4,256,426.4z"},"children":[{"name":"path","attribs":{"fill-opacity":"0.9","d":"M256,43C137.789,43,43,138.851,43,256s94.789,213,213,213s213-95.851,213-213S373.149,43,256,43z\r\n\t\t\t\t M256,426.4c-93.718,0-170.4-76.683-170.4-170.4S162.282,85.6,256,85.6S426.4,162.282,426.4,256S349.718,426.4,256,426.4z"},"children":[]}]}]}]},{"name":"polygon","attribs":{"fill-opacity":"0.9","points":"266.65,149.5 234.7,149.5 234.7,277.3 346.525,344.393 362.5,317.768 266.65,261.324 \t\t"},"children":[{"name":"polygon","attribs":{"fill-opacity":"0.9","points":"266.65,149.5 234.7,149.5 234.7,277.3 346.525,344.393 362.5,317.768 266.65,261.324 \t\t"},"children":[]}]}]}]}]}]};exports.androidTime=androidTime;var androidTrain={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_35_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M80,346.666c0,41.604,33.062,74.666,74.667,74.666L128,448v16h256v-16l-26.667-26.668\r\n\t\t\t\tc41.604,0,74.667-33.062,74.667-74.666V133.334C432,58.668,349.864,48,256,48S80,58.668,80,133.334V346.666z M256,376\r\n\t\t\t\tc-22.002,0-40-17.997-40-39.999S233.998,296,256,296s40,17.999,40,40.001S278.002,376,256,376z M384,224H128v-96h256V224z"},"children":[{"name":"path","attribs":{"d":"M80,346.666c0,41.604,33.062,74.666,74.667,74.666L128,448v16h256v-16l-26.667-26.668\r\n\t\t\t\tc41.604,0,74.667-33.062,74.667-74.666V133.334C432,58.668,349.864,48,256,48S80,58.668,80,133.334V346.666z M256,376\r\n\t\t\t\tc-22.002,0-40-17.997-40-39.999S233.998,296,256,296s40,17.999,40,40.001S278.002,376,256,376z M384,224H128v-96h256V224z"},"children":[]}]}]}]}]}]}]}]};exports.androidTrain=androidTrain;var androidUnlock={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M376,186h-20v-40c0-55-45-100-100-100S156,91,156,146h37.998c0-34.004,28.003-62.002,62.002-62.002\r\n\tc34.004,0,62.002,27.998,62.002,62.002H318v40H136c-22.002,0-40,17.998-40,40v200c0,22.002,17.998,40,40,40h240\r\n\tc22.002,0,40-17.998,40-40V226C416,203.998,398.002,186,376,186z M256,368c-22.002,0-40-17.998-40-40s17.998-40,40-40\r\n\ts40,17.998,40,40S278.002,368,256,368z"},"children":[]}]};exports.androidUnlock=androidUnlock;var androidUpload={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M403.002,217.001C388.998,148.002,328.998,96,256,96c-57.998,0-107.998,32.998-132.998,81.001\r\n\tC63.002,183.002,16,233.998,16,296c0,65.996,53.999,120,120,120h260c55,0,100-45,100-100\r\n\tC496,263.002,455.004,219.999,403.002,217.001z M288,276v76h-64v-76h-68l100-100l100,100H288z"},"children":[]}]};exports.androidUpload=androidUpload;var androidVolumeDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M64,192v128h85.334L256,431.543V80.458L149.334,192H64z M352,256c0-38.399-21.333-72.407-53.333-88.863v176.636\r\n\tC330.667,328.408,352,294.4,352,256z"},"children":[]}]};exports.androidVolumeDown=androidVolumeDown;var androidVolumeMute={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M64,192v128h85.334L256,431.543V80.458L149.334,192H64z"},"children":[]}]};exports.androidVolumeMute=androidVolumeMute;var androidVolumeOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M405.5,256c0,22.717-4.883,44.362-13.603,63.855l31.88,31.88C439.283,323.33,448,290.653,448,256\r\n\t\tc0-93.256-64-172.254-149-192v44.978C361,127.632,405.5,186.882,405.5,256z"},"children":[{"name":"path","attribs":{"d":"M405.5,256c0,22.717-4.883,44.362-13.603,63.855l31.88,31.88C439.283,323.33,448,290.653,448,256\r\n\t\tc0-93.256-64-172.254-149-192v44.978C361,127.632,405.5,186.882,405.5,256z"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,80.458 204.979,132.938 256,183.957 \t"},"children":[{"name":"polygon","attribs":{"points":"256,80.458 204.979,132.938 256,183.957 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M420.842,396.885L91.116,67.157l-24,24l90.499,90.413l-8.28,10.43H64v128h85.334L256,431.543V280l94.915,94.686\r\n\t\tC335.795,387.443,318,397.213,299,403.022V448c31-7.172,58.996-22.163,82.315-42.809l39.61,39.693l24-24.043l-24.002-24.039\r\n\t\tL420.842,396.885z"},"children":[{"name":"path","attribs":{"d":"M420.842,396.885L91.116,67.157l-24,24l90.499,90.413l-8.28,10.43H64v128h85.334L256,431.543V280l94.915,94.686\r\n\t\tC335.795,387.443,318,397.213,299,403.022V448c31-7.172,58.996-22.163,82.315-42.809l39.61,39.693l24-24.043l-24.002-24.039\r\n\t\tL420.842,396.885z"},"children":[]}]},{"name":"path","attribs":{"d":"M352.188,256c0-38.399-21.188-72.407-53.188-88.863v59.82l50.801,50.801C351.355,270.739,352.188,263.454,352.188,256z"},"children":[{"name":"path","attribs":{"d":"M352.188,256c0-38.399-21.188-72.407-53.188-88.863v59.82l50.801,50.801C351.355,270.739,352.188,263.454,352.188,256z"},"children":[]}]}]}]};exports.androidVolumeOff=androidVolumeOff;var androidVolumeUp={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M64,192v128h85.334L256,431.543V80.458L149.334,192H64z M352,256c0-38.399-21.333-72.407-53.333-88.863v176.636\r\n\tC330.667,328.408,352,294.4,352,256z M298.667,64v44.978C360.531,127.632,405.334,186.882,405.334,256\r\n\tc0,69.119-44.803,128.369-106.667,147.022V448C384,428.254,448,349.257,448,256C448,162.744,384,83.746,298.667,64z"},"children":[]}]};exports.androidVolumeUp=androidVolumeUp;var androidWalk={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,112c22.223,0,39.997-17.776,39.997-40c0-22.225-17.774-40-39.997-40s-40.003,17.775-40.003,40\r\n\t\tC247.997,94.224,265.777,112,288,112z"},"children":[{"name":"path","attribs":{"d":"M288,112c22.223,0,39.997-17.776,39.997-40c0-22.225-17.774-40-39.997-40s-40.003,17.775-40.003,40\r\n\t\tC247.997,94.224,265.777,112,288,112z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,232h104v-40h-72l-44.802-69.333c-7.698-11.667-18.136-18.136-30.933-18.136c-3.198,0-8.828,0.531-12.799,1.747\r\n\t\tL120,144v112h40v-80l40.531-16L120,480h40l56.698-164.271L267,384v96h38V352l-57.031-96l19.745-61.864L288,232z"},"children":[{"name":"path","attribs":{"d":"M288,232h104v-40h-72l-44.802-69.333c-7.698-11.667-18.136-18.136-30.933-18.136c-3.198,0-8.828,0.531-12.799,1.747\r\n\t\tL120,144v112h40v-80l40.531-16L120,480h40l56.698-164.271L267,384v96h38V352l-57.031-96l19.745-61.864L288,232z"},"children":[]}]}]}]};exports.androidWalk=androidWalk;var androidWarning={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_31_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,464h448L256,48L32,464z M280,400h-48v-48h48V400z M280,320h-48v-96h48V320z"},"children":[{"name":"path","attribs":{"d":"M32,464h448L256,48L32,464z M280,400h-48v-48h48V400z M280,320h-48v-96h48V320z"},"children":[]}]}]}]}]}]};exports.androidWarning=androidWarning;var androidWatch={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon_11_"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,256c0-51.001-24.004-96.001-60.996-125L336,16H176l-19.004,115C120.004,159.999,96,204.999,96,256\r\n\t\t\t\tc0,50.996,24.004,95.996,60.996,125L176,496h160l19.004-115C391.996,351.996,416,306.996,416,256z M136,256\r\n\t\t\t\tc0-66.001,54.004-120,120-120s120,53.999,120,120c0,65.996-54.004,120-120,120S136,321.996,136,256z"},"children":[{"name":"path","attribs":{"d":"M416,256c0-51.001-24.004-96.001-60.996-125L336,16H176l-19.004,115C120.004,159.999,96,204.999,96,256\r\n\t\t\t\tc0,50.996,24.004,95.996,60.996,125L176,496h160l19.004-115C391.996,351.996,416,306.996,416,256z M136,256\r\n\t\t\t\tc0-66.001,54.004-120,120-120s120,53.999,120,120c0,65.996-54.004,120-120,120S136,321.996,136,256z"},"children":[]}]}]}]}]}]}]}]};exports.androidWatch=androidWatch;var androidWifi={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,228.719c-22.879,0-41.597,18.529-41.597,41.18c0,22.652,18.718,41.182,41.597,41.182\r\n\tc22.878,0,41.597-18.529,41.597-41.182C297.597,247.248,278.878,228.719,256,228.719z M380.8,269.898\r\n\tc0-67.946-56.163-123.539-124.8-123.539s-124.8,55.593-124.8,123.539c0,45.303,24.961,85.447,62.396,107.072l20.807-36.032\r\n\tc-24.972-14.417-41.604-40.153-41.604-71.04c0-45.295,37.433-82.358,83.201-82.358c45.771,0,83.201,37.063,83.201,82.358\r\n\tc0,30.887-16.633,56.623-41.604,71.04l20.807,36.032C355.837,355.346,380.8,315.201,380.8,269.898z M256,64\r\n\tC141.597,64,48,156.654,48,269.898C48,346.085,89.592,411.968,152,448l20.799-36.032c-49.919-28.824-83.207-81.324-83.207-142.069\r\n\tc0-90.593,74.891-164.718,166.408-164.718c91.517,0,166.406,74.125,166.406,164.718c0,60.745-33.284,114.271-83.205,142.069L360,448\r\n\tc62.406-36.032,104-101.915,104-178.102C464,156.654,370.403,64,256,64z"},"children":[]}]};exports.androidWifi=androidWifi;var aperture={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M200.043,106.067c-40.631,15.171-73.434,46.382-90.717,85.933H256L200.043,106.067z"},"children":[{"name":"path","attribs":{"d":"M200.043,106.067c-40.631,15.171-73.434,46.382-90.717,85.933H256L200.043,106.067z"},"children":[]}]},{"name":"path","attribs":{"d":"M412.797,288c2.099-10.34,3.203-21.041,3.203-32c0-36.624-12.314-70.367-33.016-97.334L311,288H412.797z"},"children":[{"name":"path","attribs":{"d":"M412.797,288c2.099-10.34,3.203-21.041,3.203-32c0-36.624-12.314-70.367-33.016-97.334L311,288H412.797z"},"children":[]}]},{"name":"path","attribs":{"d":"M359.973,134.395C332.007,110.461,295.694,96,256,96c-7.966,0-15.794,0.591-23.448,1.715L310.852,224L359.973,134.395z"},"children":[{"name":"path","attribs":{"d":"M359.973,134.395C332.007,110.461,295.694,96,256,96c-7.966,0-15.794,0.591-23.448,1.715L310.852,224L359.973,134.395z"},"children":[]}]},{"name":"path","attribs":{"d":"M99.204,224C97.104,234.34,96,245.041,96,256c0,36.639,12.324,70.394,33.041,97.366L201,224H99.204z"},"children":[{"name":"path","attribs":{"d":"M99.204,224C97.104,234.34,96,245.041,96,256c0,36.639,12.324,70.394,33.041,97.366L201,224H99.204z"},"children":[]}]},{"name":"path","attribs":{"d":"M311.959,405.932c40.631-15.171,73.433-46.382,90.715-85.932H256L311.959,405.932z"},"children":[{"name":"path","attribs":{"d":"M311.959,405.932c40.631-15.171,73.433-46.382,90.715-85.932H256L311.959,405.932z"},"children":[]}]},{"name":"path","attribs":{"d":"M152.046,377.621C180.009,401.545,216.314,416,256,416c7.969,0,15.799-0.592,23.456-1.716L201.164,288L152.046,377.621z"},"children":[{"name":"path","attribs":{"d":"M152.046,377.621C180.009,401.545,216.314,416,256,416c7.969,0,15.799-0.592,23.456-1.716L201.164,288L152.046,377.621z"},"children":[]}]}]}]}]}]};exports.aperture=aperture;var archive={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,307.7 384,192 304,192 304,96 207.6,96 207.6,192 128,192 \t"},"children":[{"name":"polygon","attribs":{"points":"256,307.7 384,192 304,192 304,96 207.6,96 207.6,192 128,192 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M465.4,297.2l-71.4-55h-42l62,61.8h-50.6c-2.3,0-4.3,1.2-5.4,2.9l-18.4,45.5H172.1l-18.4-45.5c-1-1.8-3.1-2.9-5.4-2.9H97.8\r\n\t\tl62.2-61.8h-42.2l-71.4,55c-10.6,6.2-15.8,19-14.1,31.6l8.7,66.9c2.3,13.1,9.7,20.3,28.1,20.3h373.8c19.1,0,25.8-7.6,28.1-20.3\r\n\t\tl8.7-66.9C481.4,315.9,476,303.4,465.4,297.2z"},"children":[{"name":"path","attribs":{"d":"M465.4,297.2l-71.4-55h-42l62,61.8h-50.6c-2.3,0-4.3,1.2-5.4,2.9l-18.4,45.5H172.1l-18.4-45.5c-1-1.8-3.1-2.9-5.4-2.9H97.8\r\n\t\tl62.2-61.8h-42.2l-71.4,55c-10.6,6.2-15.8,19-14.1,31.6l8.7,66.9c2.3,13.1,9.7,20.3,28.1,20.3h373.8c19.1,0,25.8-7.6,28.1-20.3\r\n\t\tl8.7-66.9C481.4,315.9,476,303.4,465.4,297.2z"},"children":[]}]}]}]};exports.archive=archive;var arrowDownA={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"256.5,448.5 448.5,256.5 336.5,256.5 336.5,64.5 176.5,64.5 176.5,256.5 64.5,256.5 "},"children":[]}]};exports.arrowDownA=arrowDownA;var arrowDownB={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M98.9,184.7l1.8,2.1l136,156.5c4.6,5.3,11.5,8.6,19.2,8.6c7.7,0,14.6-3.4,19.2-8.6L411,187.1l2.3-2.6\r\n\tc1.7-2.5,2.7-5.5,2.7-8.7c0-8.7-7.4-15.8-16.6-15.8v0H112.6v0c-9.2,0-16.6,7.1-16.6,15.8C96,179.1,97.1,182.2,98.9,184.7z"},"children":[]}]};exports.arrowDownB=arrowDownB;var arrowDownC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M383.6,322.7L278.6,423c-5.8,6-13.7,9-22.4,9c-8.7,0-16.5-3-22.4-9L128.4,322.7c-12.5-11.9-12.5-31.3,0-43.2\r\n\tc12.5-11.9,32.7-11.9,45.2,0l50.4,48.2v-217c0-16.9,14.3-30.6,32-30.6c17.7,0,32,13.7,32,30.6v217l50.4-48.2\r\n\tc12.5-11.9,32.7-11.9,45.2,0C396.1,291.4,396.1,310.7,383.6,322.7z"},"children":[]}]};exports.arrowDownC=arrowDownC;var arrowExpand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"274,209.7 337.9,145.9 288,96 416,96 416,224 366.1,174.1 302.3,238 \t"},"children":[{"name":"polygon","attribs":{"points":"274,209.7 337.9,145.9 288,96 416,96 416,224 366.1,174.1 302.3,238 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"274,302.3 337.9,366.1 288,416 416,416 416,288 366.1,337.9 302.3,274 \t"},"children":[{"name":"polygon","attribs":{"points":"274,302.3 337.9,366.1 288,416 416,416 416,288 366.1,337.9 302.3,274 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"238,302.3 174.1,366.1 224,416 96,416 96,288 145.9,337.9 209.7,274 \t"},"children":[{"name":"polygon","attribs":{"points":"238,302.3 174.1,366.1 224,416 96,416 96,288 145.9,337.9 209.7,274 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"238,209.7 174.1,145.9 224,96 96,96 96,224 145.9,174.1 209.7,238 \t"},"children":[{"name":"polygon","attribs":{"points":"238,209.7 174.1,145.9 224,96 96,96 96,224 145.9,174.1 209.7,238 \t"},"children":[]}]}]}]};exports.arrowExpand=arrowExpand;var arrowGraphDownLeft={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"32,384 32,224 92.8,284.8 223.7,144 330.7,256 480,128 330.7,330.7 223.7,224 130.2,322.2 192,384 "},"children":[]}]};exports.arrowGraphDownLeft=arrowGraphDownLeft;var arrowGraphDownRight={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"320,384 381.8,322.2 288.3,224 181.3,330.7 32,128 181.3,256 288.3,144 419.2,284.8 480,224 480,384 "},"children":[]}]};exports.arrowGraphDownRight=arrowGraphDownRight;var arrowGraphUpLeft={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"192,128 130.2,189.8 223.7,288 330.7,181.3 480,384 330.7,256 223.7,368 92.8,227.2 32,288 32,128 "},"children":[]}]};exports.arrowGraphUpLeft=arrowGraphUpLeft;var arrowGraphUpRight={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"320,128 381.8,189.8 288.3,288 181.3,181.3 32,384 181.3,256 288.3,368 419.2,227.2 480,288 480,128 "},"children":[]}]};exports.arrowGraphUpRight=arrowGraphUpRight;var arrowLeftA={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"64.5,256.5 256.5,448.5 256.5,336.5 448.5,336.5 448.5,176.5 256.5,176.5 256.5,64.5 "},"children":[]}]};exports.arrowLeftA=arrowLeftA;var arrowLeftB={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M327.3,98.9l-2.1,1.8l-156.5,136c-5.3,4.6-8.6,11.5-8.6,19.2c0,7.7,3.4,14.6,8.6,19.2L324.9,411l2.6,2.3\r\n\tc2.5,1.7,5.5,2.7,8.7,2.7c8.7,0,15.8-7.4,15.8-16.6h0V112.6h0c0-9.2-7.1-16.6-15.8-16.6C332.9,96,329.8,97.1,327.3,98.9z"},"children":[]}]};exports.arrowLeftB=arrowLeftB;var arrowLeftC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M189.3,128.4L89,233.4c-6,5.8-9,13.7-9,22.4c0,8.7,3,16.5,9,22.4l100.3,105.4c11.9,12.5,31.3,12.5,43.2,0\r\n\tc11.9-12.5,11.9-32.7,0-45.2L184.4,288h217c16.9,0,30.6-14.3,30.6-32c0-17.7-13.7-32-30.6-32h-217l48.2-50.4\r\n\tc11.9-12.5,11.9-32.7,0-45.2C220.6,115.9,201.3,115.9,189.3,128.4z"},"children":[]}]};exports.arrowLeftC=arrowLeftC;var arrowMove={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"480,256 384,160 384,236 276,236 276,128 352,128 256,32 160,128 236,128 236,236 128,236 128,160 32,256 128,352 \r\n\t128,276 236,276 236,384 160,384 256,480 352,384 275.8,384 275.4,275.5 384,275.8 384,352 "},"children":[]}]};exports.arrowMove=arrowMove;var arrowResize={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"288,96 337.9,145.9 274,209.7 274,209.7 145.9,337.9 96,288 96,416 224,416 174.1,366.1 357.4,182.9 366.1,174.1 \r\n\t416,224 416,96 "},"children":[]}]};exports.arrowResize=arrowResize;var arrowReturnLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M192,96v64h248c4.4,0,8,3.6,8,8v240c0,4.4-3.6,8-8,8H136c-4.4,0-8-3.6-8-8v-48c0-4.4,3.6-8,8-8h248V224H192v64L64,192\r\n\tL192,96z"},"children":[]}]};exports.arrowReturnLeft=arrowReturnLeft;var arrowReturnRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,192l-128,96v-64H128v128h248c4.4,0,8,3.6,8,8v48c0,4.4-3.6,8-8,8H72c-4.4,0-8-3.6-8-8V168c0-4.4,3.6-8,8-8h248V96\r\n\tL448,192z"},"children":[]}]};exports.arrowReturnRight=arrowReturnRight;var arrowRightA={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"448.5,256.5 256.5,64.5 256.5,176.5 64.5,176.5 64.5,336.5 256.5,336.5 256.5,448.5 "},"children":[]}]};exports.arrowRightA=arrowRightA;var arrowRightB={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M184.7,413.1l2.1-1.8l156.5-136c5.3-4.6,8.6-11.5,8.6-19.2c0-7.7-3.4-14.6-8.6-19.2L187.1,101l-2.6-2.3\r\n\tC182,97,179,96,175.8,96c-8.7,0-15.8,7.4-15.8,16.6h0v286.8h0c0,9.2,7.1,16.6,15.8,16.6C179.1,416,182.2,414.9,184.7,413.1z"},"children":[]}]};exports.arrowRightB=arrowRightB;var arrowRightC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M322.7,128.4L423,233.4c6,5.8,9,13.7,9,22.4c0,8.7-3,16.5-9,22.4L322.7,383.6c-11.9,12.5-31.3,12.5-43.2,0\r\n\tc-11.9-12.5-11.9-32.7,0-45.2l48.2-50.4h-217C93.7,288,80,273.7,80,256c0-17.7,13.7-32,30.6-32h217l-48.2-50.4\r\n\tc-11.9-12.5-11.9-32.7,0-45.2C291.4,115.9,310.7,115.9,322.7,128.4z"},"children":[]}]};exports.arrowRightC=arrowRightC;var arrowShrink={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"448,92.3 366.1,174.1 416,224 288,224 288,96 337.9,145.9 419.7,64 \t"},"children":[{"name":"polygon","attribs":{"points":"448,92.3 366.1,174.1 416,224 288,224 288,96 337.9,145.9 419.7,64 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"448,419.7 366.1,337.9 416,288 288,288 288,416 337.9,366.1 419.7,448 \t"},"children":[{"name":"polygon","attribs":{"points":"448,419.7 366.1,337.9 416,288 288,288 288,416 337.9,366.1 419.7,448 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"64,419.7 145.9,337.9 96,288 224,288 224,416 174.1,366.1 92.3,448 \t"},"children":[{"name":"polygon","attribs":{"points":"64,419.7 145.9,337.9 96,288 224,288 224,416 174.1,366.1 92.3,448 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"64,92.3 145.9,174.1 96,224 224,224 224,96 174.1,145.9 92.3,64 \t"},"children":[{"name":"polygon","attribs":{"points":"64,92.3 145.9,174.1 96,224 224,224 224,96 174.1,145.9 92.3,64 \t"},"children":[]}]}]}]};exports.arrowShrink=arrowShrink;var arrowSwap={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,328v48c0,4.4,3.6,8,8,8h248v64l128-96l-128-96v64H72C67.6,320,64,323.6,64,328z"},"children":[{"name":"path","attribs":{"d":"M64,328v48c0,4.4,3.6,8,8,8h248v64l128-96l-128-96v64H72C67.6,320,64,323.6,64,328z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,184v-48c0-4.4-3.6-8-8-8H192V64L64,160l128,96v-64h248C444.4,192,448,188.4,448,184z"},"children":[{"name":"path","attribs":{"d":"M448,184v-48c0-4.4-3.6-8-8-8H192V64L64,160l128,96v-64h248C444.4,192,448,188.4,448,184z"},"children":[]}]}]}]};exports.arrowSwap=arrowSwap;var arrowUpA={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"256.5,64.5 64.5,256.5 176.5,256.5 176.5,448.5 336.5,448.5 336.5,256.5 448.5,256.5 "},"children":[]}]};exports.arrowUpA=arrowUpA;var arrowUpB={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M413.1,327.3l-1.8-2.1l-136-156.5c-4.6-5.3-11.5-8.6-19.2-8.6c-7.7,0-14.6,3.4-19.2,8.6L101,324.9l-2.3,2.6\r\n\tC97,330,96,333,96,336.2c0,8.7,7.4,15.8,16.6,15.8v0h286.8v0c9.2,0,16.6-7.1,16.6-15.8C416,332.9,414.9,329.8,413.1,327.3z"},"children":[]}]};exports.arrowUpB=arrowUpB;var arrowUpC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M128.4,189.3L233.4,89c5.8-6,13.7-9,22.4-9c8.7,0,16.5,3,22.4,9l105.4,100.3c12.5,11.9,12.5,31.3,0,43.2\r\n\tc-12.5,11.9-32.7,11.9-45.2,0L288,184.4v217c0,16.9-14.3,30.6-32,30.6c-17.7,0-32-13.7-32-30.6v-217l-50.4,48.2\r\n\tc-12.5,11.9-32.7,11.9-45.2,0C115.9,220.6,115.9,201.3,128.4,189.3z"},"children":[]}]};exports.arrowUpC=arrowUpC;var asterisk={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"480,224 293.172,231.487 401.688,64 342.441,32 256,208 169.824,32 110.328,64 218.828,231.487 32,224 32,288 \r\n\t217.537,277.934 113.65,448 169.619,480 256,304 342.381,480 398.33,448 294.463,277.934 480,288 "},"children":[]}]};exports.asterisk=asterisk;var at={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M453.8,407.1c-23.9,25.3-52.3,43.8-85.2,55.4C335.7,474.2,301,480,264.5,480c-34.9,0-66.7-5.5-95.3-16.6\r\n\t\tc-28.6-11-53.1-26.4-73.3-46.1c-20.3-19.7-36-43.3-47.2-70.8c-11.2-27.5-16.7-57.5-16.7-90c0-32.1,6.1-61.8,18.3-89.1\r\n\t\tc12.2-27.3,28.8-51,49.9-71.1c21.1-20.1,45.7-35.8,74-47.3C202.3,37.7,232.5,32,264.5,32c27.6,0,54.4,4,80.3,12\r\n\t\tc26,8,49,20.1,69.1,36.1c20.1,16.1,36.1,36.1,48.1,60.2c12,24.1,18,52.4,18,84.9c0,24.1-3.3,45.4-10,63.8\r\n\t\tc-6.7,18.5-15.6,33.9-26.8,46.4c-11.2,12.5-23.9,21.8-38.3,28c-14.4,6.2-29.5,9.3-45.3,9.3c-16.2,0-29.2-3.8-39-11.4\r\n\t\tc-9.7-7.6-14.6-17.3-14.6-28.9h-3c-6.1,9.6-15.4,18.8-28,27.4c-12.6,8.6-28,13-46.3,13c-27.6,0-48.9-9-63.9-27.1\r\n\t\tc-15-18.1-22.5-41.5-22.5-70.5c0-16.9,2.8-33.5,8.5-50c5.7-16.5,13.8-31.1,24.3-44c10.5-12.8,23.1-23.2,37.7-31\r\n\t\tc14.6-7.8,30.8-11.7,48.7-11.7c15.4,0,28.4,3.2,39,9.6c10.5,6.4,17.4,14.3,20.7,23.5h0.6l4.9-24.1h54.2L357,261.4\r\n\t\tc-0.8,5.6-1.9,11.8-3.3,18.7c-1.4,6.8-2.1,13.2-2.1,19.3c0,6.8,1.3,12.5,4,17.2c2.6,4.6,7.8,6.9,15.5,6.9\r\n\t\tc15.8,0,28.9-8.4,39.3-25.3c10.3-16.9,15.5-39.5,15.5-68c0-24.1-4.1-45.5-12.2-64.1c-8.1-18.7-19.4-34.3-33.8-47\r\n\t\tc-14.4-12.6-31.6-22.2-51.4-28.6c-19.9-6.4-41.6-9.6-65.1-9.6c-25.6,0-49,4.5-70.3,13.5s-39.5,21.5-54.5,37.3\r\n\t\tc-15,15.9-26.7,34.5-35,56C95.2,209.1,91,232.3,91,257.2c0,26.5,4.4,50.4,13.1,71.7c8.7,21.3,21,39.4,36.8,54.5\r\n\t\tc15.8,15.1,34.7,26.6,56.6,34.6c21.9,8,46.1,12,72.4,12c32.9,0,61.2-5.2,84.9-15.7c23.7-10.4,45.5-24.9,65.4-43.4L453.8,407.1z\r\n\t\t M263.3,188c-9.7,0-18.3,2.8-25.6,8.4c-7.3,5.6-13.5,12.7-18.6,21.4c-5.1,8.6-8.9,18.2-11.6,28.6c-2.6,10.4-4,20.5-4,30.1\r\n\t\tc0,4.8,0.5,9.9,1.5,15.4c1,5.4,3,10.4,6.1,15.1c3,4.6,7,8.4,11.9,11.4c4.9,3,11.4,4.5,19.5,4.5c11,0,20.3-2.7,28-8.1\r\n\t\tc7.7-5.4,14-12.2,18.9-20.5c4.9-8.2,8.4-17.2,10.7-26.8c2.2-9.6,3.3-18.5,3.3-26.5c0-6.4-0.6-12.7-1.8-19\r\n\t\tc-1.2-6.2-3.3-11.8-6.4-16.9c-3-5-7.2-9.1-12.5-12.3C277.5,189.6,271,188,263.3,188z"},"children":[{"name":"path","attribs":{"d":"M453.8,407.1c-23.9,25.3-52.3,43.8-85.2,55.4C335.7,474.2,301,480,264.5,480c-34.9,0-66.7-5.5-95.3-16.6\r\n\t\tc-28.6-11-53.1-26.4-73.3-46.1c-20.3-19.7-36-43.3-47.2-70.8c-11.2-27.5-16.7-57.5-16.7-90c0-32.1,6.1-61.8,18.3-89.1\r\n\t\tc12.2-27.3,28.8-51,49.9-71.1c21.1-20.1,45.7-35.8,74-47.3C202.3,37.7,232.5,32,264.5,32c27.6,0,54.4,4,80.3,12\r\n\t\tc26,8,49,20.1,69.1,36.1c20.1,16.1,36.1,36.1,48.1,60.2c12,24.1,18,52.4,18,84.9c0,24.1-3.3,45.4-10,63.8\r\n\t\tc-6.7,18.5-15.6,33.9-26.8,46.4c-11.2,12.5-23.9,21.8-38.3,28c-14.4,6.2-29.5,9.3-45.3,9.3c-16.2,0-29.2-3.8-39-11.4\r\n\t\tc-9.7-7.6-14.6-17.3-14.6-28.9h-3c-6.1,9.6-15.4,18.8-28,27.4c-12.6,8.6-28,13-46.3,13c-27.6,0-48.9-9-63.9-27.1\r\n\t\tc-15-18.1-22.5-41.5-22.5-70.5c0-16.9,2.8-33.5,8.5-50c5.7-16.5,13.8-31.1,24.3-44c10.5-12.8,23.1-23.2,37.7-31\r\n\t\tc14.6-7.8,30.8-11.7,48.7-11.7c15.4,0,28.4,3.2,39,9.6c10.5,6.4,17.4,14.3,20.7,23.5h0.6l4.9-24.1h54.2L357,261.4\r\n\t\tc-0.8,5.6-1.9,11.8-3.3,18.7c-1.4,6.8-2.1,13.2-2.1,19.3c0,6.8,1.3,12.5,4,17.2c2.6,4.6,7.8,6.9,15.5,6.9\r\n\t\tc15.8,0,28.9-8.4,39.3-25.3c10.3-16.9,15.5-39.5,15.5-68c0-24.1-4.1-45.5-12.2-64.1c-8.1-18.7-19.4-34.3-33.8-47\r\n\t\tc-14.4-12.6-31.6-22.2-51.4-28.6c-19.9-6.4-41.6-9.6-65.1-9.6c-25.6,0-49,4.5-70.3,13.5s-39.5,21.5-54.5,37.3\r\n\t\tc-15,15.9-26.7,34.5-35,56C95.2,209.1,91,232.3,91,257.2c0,26.5,4.4,50.4,13.1,71.7c8.7,21.3,21,39.4,36.8,54.5\r\n\t\tc15.8,15.1,34.7,26.6,56.6,34.6c21.9,8,46.1,12,72.4,12c32.9,0,61.2-5.2,84.9-15.7c23.7-10.4,45.5-24.9,65.4-43.4L453.8,407.1z\r\n\t\t M263.3,188c-9.7,0-18.3,2.8-25.6,8.4c-7.3,5.6-13.5,12.7-18.6,21.4c-5.1,8.6-8.9,18.2-11.6,28.6c-2.6,10.4-4,20.5-4,30.1\r\n\t\tc0,4.8,0.5,9.9,1.5,15.4c1,5.4,3,10.4,6.1,15.1c3,4.6,7,8.4,11.9,11.4c4.9,3,11.4,4.5,19.5,4.5c11,0,20.3-2.7,28-8.1\r\n\t\tc7.7-5.4,14-12.2,18.9-20.5c4.9-8.2,8.4-17.2,10.7-26.8c2.2-9.6,3.3-18.5,3.3-26.5c0-6.4-0.6-12.7-1.8-19\r\n\t\tc-1.2-6.2-3.3-11.8-6.4-16.9c-3-5-7.2-9.1-12.5-12.3C277.5,189.6,271,188,263.3,188z"},"children":[]}]}]}]};exports.at=at;var backspaceOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M413.442,332.307c1.528,1.51,2.372,3.562,2.372,5.71c0,2.151-0.844,4.203-2.372,5.707l-21.823,21.905\r\n\t\t\tc-1.575,1.586-3.625,2.371-5.691,2.371c-2.071,0-4.138-0.785-5.695-2.371l-76.23-76.461l-76.23,76.461\r\n\t\t\tc-1.558,1.586-3.625,2.371-5.695,2.371c-2.066,0-4.117-0.785-5.692-2.371l-21.824-21.905c-1.527-1.504-2.373-3.556-2.373-5.707\r\n\t\t\tc0-2.148,0.846-4.2,2.373-5.71L271.098,256l-76.738-76.297c-3.146-3.153-3.146-8.273,0-11.427l21.807-21.919\r\n\t\t\tc1.516-1.511,3.552-2.357,5.696-2.357c2.152,0,4.189,0.847,5.691,2.357l76.448,75.533l76.447-75.533\r\n\t\t\tc1.504-1.511,3.541-2.357,5.693-2.357c2.143,0,4.179,0.847,5.695,2.357l21.807,21.919c3.146,3.153,3.146,8.273,0,11.427\r\n\t\t\tL336.904,256L413.442,332.307z"},"children":[{"name":"path","attribs":{"d":"M413.442,332.307c1.528,1.51,2.372,3.562,2.372,5.71c0,2.151-0.844,4.203-2.372,5.707l-21.823,21.905\r\n\t\t\tc-1.575,1.586-3.625,2.371-5.691,2.371c-2.071,0-4.138-0.785-5.695-2.371l-76.23-76.461l-76.23,76.461\r\n\t\t\tc-1.558,1.586-3.625,2.371-5.695,2.371c-2.066,0-4.117-0.785-5.692-2.371l-21.824-21.905c-1.527-1.504-2.373-3.556-2.373-5.707\r\n\t\t\tc0-2.148,0.846-4.2,2.373-5.71L271.098,256l-76.738-76.297c-3.146-3.153-3.146-8.273,0-11.427l21.807-21.919\r\n\t\t\tc1.516-1.511,3.552-2.357,5.696-2.357c2.152,0,4.189,0.847,5.691,2.357l76.448,75.533l76.447-75.533\r\n\t\t\tc1.504-1.511,3.541-2.357,5.693-2.357c2.143,0,4.179,0.847,5.695,2.357l21.807,21.919c3.146,3.153,3.146,8.273,0,11.427\r\n\t\t\tL336.904,256L413.442,332.307z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M498.941,93.559C490.037,84.654,478.696,80,465.875,80H168c-24.303,0-43.717,9.402-57.706,28.441L0,255.938l110.4,146.528\r\n\t\tl0.18,0.231l0.184,0.232c6.904,8.855,14.424,15.701,22.99,20.417C143.883,428.924,155.405,432,168,432h298\r\n\t\tc26.191,0,46-22.257,46-49V127C512,114.179,507.846,102.463,498.941,93.559z M480,383c0,8.837-5.163,17-14,17H168\r\n\t\tc-15.167,0-24.333-6.666-32-16.5L40,256l96-128.438c9.5-13,21.167-15.562,32-15.562h297.5c8.837,0,14.5,6.163,14.5,15V383z"},"children":[{"name":"path","attribs":{"d":"M498.941,93.559C490.037,84.654,478.696,80,465.875,80H168c-24.303,0-43.717,9.402-57.706,28.441L0,255.938l110.4,146.528\r\n\t\tl0.18,0.231l0.184,0.232c6.904,8.855,14.424,15.701,22.99,20.417C143.883,428.924,155.405,432,168,432h298\r\n\t\tc26.191,0,46-22.257,46-49V127C512,114.179,507.846,102.463,498.941,93.559z M480,383c0,8.837-5.163,17-14,17H168\r\n\t\tc-15.167,0-24.333-6.666-32-16.5L40,256l96-128.438c9.5-13,21.167-15.562,32-15.562h297.5c8.837,0,14.5,6.163,14.5,15V383z"},"children":[]}]}]}]};exports.backspaceOutline=backspaceOutline;var backspace={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M498.941,93.559C490.037,84.654,478.696,80,465.875,80H168c-24.303,0-43.717,9.402-57.706,28.441L0,255.938l110.4,146.528\r\n\t\tl0.18,0.231l0.184,0.232c6.904,8.855,14.424,15.701,22.99,20.417C143.883,428.924,155.405,432,168,432h298\r\n\t\tc26.191,0,46-22.257,46-49V127C512,114.179,507.846,102.463,498.941,93.559z M413.442,332.307c1.528,1.51,2.372,3.562,2.372,5.71\r\n\t\tc0,2.151-0.844,4.203-2.372,5.707l-21.823,21.905c-1.575,1.586-3.625,2.371-5.691,2.371c-2.071,0-4.138-0.785-5.695-2.371\r\n\t\tl-76.23-76.461l-76.23,76.461c-1.558,1.586-3.625,2.371-5.695,2.371c-2.066,0-4.117-0.785-5.692-2.371l-21.824-21.905\r\n\t\tc-1.527-1.504-2.373-3.556-2.373-5.707c0-2.148,0.846-4.2,2.373-5.71L271.098,256l-76.738-76.297\r\n\t\tc-3.146-3.153-3.146-8.273,0-11.427l21.807-21.919c1.516-1.511,3.552-2.357,5.696-2.357c2.152,0,4.189,0.847,5.691,2.357\r\n\t\tl76.448,75.533l76.447-75.533c1.504-1.511,3.541-2.357,5.693-2.357c2.143,0,4.179,0.847,5.695,2.357l21.807,21.919\r\n\t\tc3.146,3.153,3.146,8.273,0,11.427L336.904,256L413.442,332.307z"},"children":[{"name":"path","attribs":{"d":"M498.941,93.559C490.037,84.654,478.696,80,465.875,80H168c-24.303,0-43.717,9.402-57.706,28.441L0,255.938l110.4,146.528\r\n\t\tl0.18,0.231l0.184,0.232c6.904,8.855,14.424,15.701,22.99,20.417C143.883,428.924,155.405,432,168,432h298\r\n\t\tc26.191,0,46-22.257,46-49V127C512,114.179,507.846,102.463,498.941,93.559z M413.442,332.307c1.528,1.51,2.372,3.562,2.372,5.71\r\n\t\tc0,2.151-0.844,4.203-2.372,5.707l-21.823,21.905c-1.575,1.586-3.625,2.371-5.691,2.371c-2.071,0-4.138-0.785-5.695-2.371\r\n\t\tl-76.23-76.461l-76.23,76.461c-1.558,1.586-3.625,2.371-5.695,2.371c-2.066,0-4.117-0.785-5.692-2.371l-21.824-21.905\r\n\t\tc-1.527-1.504-2.373-3.556-2.373-5.707c0-2.148,0.846-4.2,2.373-5.71L271.098,256l-76.738-76.297\r\n\t\tc-3.146-3.153-3.146-8.273,0-11.427l21.807-21.919c1.516-1.511,3.552-2.357,5.696-2.357c2.152,0,4.189,0.847,5.691,2.357\r\n\t\tl76.448,75.533l76.447-75.533c1.504-1.511,3.541-2.357,5.693-2.357c2.143,0,4.179,0.847,5.695,2.357l21.807,21.919\r\n\t\tc3.146,3.153,3.146,8.273,0,11.427L336.904,256L413.442,332.307z"},"children":[]}]}]}]};exports.backspace=backspace;var bag={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,160h-64v-4.5C384,87,329,32,260.5,32h-8C184,32,128,87,128,155.5v4.5H64L32,480h448L448,160z M160,155.5\r\n\tc0-50.7,41.8-91.5,92.5-91.5h7.5h0.5c50.7,0,91.5,40.8,91.5,91.5v4.5H160V155.5z M67.8,448l24.9-256H128v36.3\r\n\tc-9.6,5.5-16,15.9-16,27.7c0,17.7,14.3,32,32,32s32-14.3,32-32c0-11.8-6.4-22.2-16-27.7V192h192v36.3c-9.6,5.5-16,15.9-16,27.7\r\n\tc0,17.7,14.3,32,32,32s32-14.3,32-32c0-11.8-6.4-22.2-16-27.7V192h35.4l24.9,256H67.8z"},"children":[]}]};exports.bag=bag;var batteryCharging={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M42.1,384h381.1c5.5,0,9.9-4.5,9.9-10v-54h36.9c5.6,0,10.1-4.5,10.1-10V202c0-5.5-4.5-10-10.1-10H433v-54\r\n\tc0-5.5-4.3-10-9.9-10H42.1c-5.6,0-10.1,4.5-10.1,10v236C32,379.5,36.5,384,42.1,384z M257.4,160l-27.9,81H291L190.6,352l27.9-81H157\r\n\tL257.4,160z"},"children":[]}]};exports.batteryCharging=batteryCharging;var batteryEmpty={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M469.9,192H433v-54c0-5.5-4.3-10-9.9-10H42.1c-5.6,0-10.1,4.5-10.1,10v236c0,5.5,4.5,10,10.1,10h381.1c5.5,0,9.9-4.5,9.9-10\r\n\tv-54h36.9c5.6,0,10.1-4.5,10.1-10V202C480,196.5,475.5,192,469.9,192z M448,288h-14.8H401v32v32H64V160h337v32v32h32.2H448V288z"},"children":[]}]};exports.batteryEmpty=batteryEmpty;var batteryFull={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M469.9,192H433v-54c0-5.5-4.3-10-9.9-10H42.1c-5.6,0-10.1,4.5-10.1,10v236c0,5.5,4.5,10,10.1,10h381.1c5.5,0,9.9-4.5,9.9-10\r\n\tv-54h36.9c5.6,0,10.1-4.5,10.1-10V202C480,196.5,475.5,192,469.9,192z"},"children":[]}]};exports.batteryFull=batteryFull;var batteryHalf={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M469.9,192H433v-54c0-5.5-4.3-10-9.9-10H42.1c-5.6,0-10.1,4.5-10.1,10v236c0,5.5,4.5,10,10.1,10h381.1c5.5,0,9.9-4.5,9.9-10\r\n\tv-54h36.9c5.6,0,10.1-4.5,10.1-10V202C480,196.5,475.5,192,469.9,192z M448,288h-14.8H401v32v32h-49l-32-192h81v32v32h32.2H448V288z\r\n\t"},"children":[]}]};exports.batteryHalf=batteryHalf;var batteryLow={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M42.1,384h381.1c5.5,0,9.9-4.5,9.9-10v-54h36.9c5.6,0,10.1-4.5,10.1-10V202c0-5.5-4.5-10-10.1-10H433v-54\r\n\tc0-5.5-4.3-10-9.9-10H42.1c-5.6,0-10.1,4.5-10.1,10v236C32,379.5,36.5,384,42.1,384z M401,160v32v32h32.2H448v64h-14.8H401v32v32\r\n\tH224l-32-192H401z"},"children":[]}]};exports.batteryLow=batteryLow;var beaker={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M143.5,192.5V416c0,8.836,7.851,16.5,16.688,16.5h208c8.836,0,15.312-7.664,15.312-16.5V192.5H143.5z M359.5,344\r\n\t\t\tc0,4.418-3.582,8-8,8s-8-3.582-8-8v-48c0-4.418,3.582-8,8-8s8,3.582,8,8V344z M352.188,272c-4.418,0-8-3.581-8-8s3.582-8,8-8\r\n\t\t\ts8,3.581,8,8S356.605,272,352.188,272z"},"children":[{"name":"path","attribs":{"d":"M143.5,192.5V416c0,8.836,7.851,16.5,16.688,16.5h208c8.836,0,15.312-7.664,15.312-16.5V192.5H143.5z M359.5,344\r\n\t\t\tc0,4.418-3.582,8-8,8s-8-3.582-8-8v-48c0-4.418,3.582-8,8-8s8,3.582,8,8V344z M352.188,272c-4.418,0-8-3.581-8-8s3.582-8,8-8\r\n\t\t\ts8,3.581,8,8S356.605,272,352.188,272z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M445.078,32.5H128.438c-54.345,0-64.594,27.426-64.594,39.75C94.094,76.5,95.5,77,95.5,109c0,16,0,307,0,307\r\n\t\t\tc0,35.346,29.341,64.5,64.688,64.5h207.75c35.346,0,63.562-29.154,63.562-64.5c0,0,0-316.75,0-335.5\r\n\t\t\tc0-20.349,12.298-38.276,13.516-40.183c1.219-1.906,3-3.798,3-4.958C448.016,34.188,447.6,32.5,445.078,32.5z M399.5,80.5V416\r\n\t\t\tc0,17.92-12.443,32.5-29.812,32.5h-209.5c-17.617,0-32.688-14.883-32.688-32.5V109c0-11.812,1.094-37.25-3.828-43.957\r\n\t\t\tc0.921-0.793,3.114-0.543,4.516-0.543h272.66C400.112,64.5,399.5,75.299,399.5,80.5z"},"children":[{"name":"path","attribs":{"d":"M445.078,32.5H128.438c-54.345,0-64.594,27.426-64.594,39.75C94.094,76.5,95.5,77,95.5,109c0,16,0,307,0,307\r\n\t\t\tc0,35.346,29.341,64.5,64.688,64.5h207.75c35.346,0,63.562-29.154,63.562-64.5c0,0,0-316.75,0-335.5\r\n\t\t\tc0-20.349,12.298-38.276,13.516-40.183c1.219-1.906,3-3.798,3-4.958C448.016,34.188,447.6,32.5,445.078,32.5z M399.5,80.5V416\r\n\t\t\tc0,17.92-12.443,32.5-29.812,32.5h-209.5c-17.617,0-32.688-14.883-32.688-32.5V109c0-11.812,1.094-37.25-3.828-43.957\r\n\t\t\tc0.921-0.793,3.114-0.543,4.516-0.543h272.66C400.112,64.5,399.5,75.299,399.5,80.5z"},"children":[]}]}]}]}]}]};exports.beaker=beaker;var beer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,160h-32v-16c14.5-3.5,32-24.3,32-48c0-35.3-28.7-64-64-64c-16.3,0-31.1,6.1-42.4,16.1C297.2,38,281.4,32,264.2,32\r\n\t\tc-15.8,0-30.4,5.1-42.3,13.7c-9.9-8.5-22.9-13.7-37-13.7c-17.1,0-32.4,7.6-42.8,19.5C130.4,39.5,114.1,32,96,32\r\n\t\tc-35.3,0-64,28.7-64,64c0,16.2,6.1,31,16,42.3c0,0.2,0,0.4,0,0.7v54c0,26.5,21.5,48,48,48v223c0,8.8,7.2,16,16,16h256\r\n\t\tc8.8,0,16-7.2,16-16v-80h32c35.3,0,64-28.7,64-64v-96C480,188.7,451.3,160,416,160z M327.8,304c-1.6,0-3-0.6-4.3-1.4\r\n\t\tc-2.2-1.4-3.5-4-3.5-6.8V248c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v48.1l0,0C336,301.1,332.2,304,327.8,304z M335,228.4\r\n\t\tc-1.2,1.8-3,3-5.1,3.5c-2.1,0.4-4.3,0-6-1.1c-1.8-1.2-3-3-3.5-5.1c-0.4-2.1,0-4.3,1.1-6c1.2-1.8,3-3,5.1-3.5c2.1-0.4,4.3,0,6,1.1\r\n\t\tc1.8,1.2,3,3,3.5,5.1C336.6,224.4,336.2,226.6,335,228.4z M352,160v32H224.2c-0.1-4.3-3.6-7.8-8-7.8c-4.4,0-7.9,3.5-8,7.8H128v-9\r\n\t\tv-31.6c6.5-3.8,12.3-8.6,17-14.3c1.2-1.5,2.4-3,3.5-4.6c1.5,1.2,3,2.4,4.6,3.4c9.1,6.1,20,9.7,31.7,9.7c6.4,0,12.6-1.1,18.3-3\r\n\t\tc12.8,20.2,35.3,33.7,61,33.7c22,0,41.7-9.9,54.9-25.4c5.7-6.7,10.2-14.4,13.1-22.9H352V160z M382.6,105.2\r\n\t\tc-2.5-5.5-8.1-9.2-14.6-9.2h-48h-7c0,0-8.7-0.7-8.7,8.2s-2.9,17.1-7.8,23.7c-7.3,9.9-19.1,16.4-32.4,16.4\r\n\t\tc-14.9,0-27.9-8.1-34.8-20.2c-1.6-2.7-2.8-5.6-3.7-8.6c-0.1-0.6-0.3-1.1-0.4-1.6c-2-5.9-7.5-10.2-14.1-10.2c-3.9,0-7.5,1.5-10.2,4\r\n\t\tc0,0,0,0-0.1,0.1c-2.4,2.1-5.3,3.7-8.4,4.7c-2.4,0.8-5,1.2-7.7,1.2c-7.5,0-14.7-4-18.8-8.6c-10-11.4-23.7-6.8-29.7-5.5\r\n\t\ts-12.2,11.7-12.2,11.7c-1.1,2.1-2.5,4-4,5.8c-5.9,6.7-14.5,11-24.1,11v32v23v26c-8.8,0-16-7.2-16-16v-35v-34.3\r\n\t\tc-7.7-4.5-13.4-12.1-15.3-21c-0.5-2.1-0.7-4.4-0.7-6.7c0-17.6,14.4-32,32-32c11.8,0,23.3,7.7,30.1,15.4s26.7,7.7,33.9,0\r\n\t\tc6.8-7.3,14.3-15.4,24.8-15.4c6,0,11.6,2.2,15.9,5.8c1.9,1.6,3.6,3.5,4.9,5.6c1.1,1.8,2,4.2,3.1,5.8c2.7,3.4,6.5,5.5,11.2,5.5\r\n\t\tc4.4,0,8.3-1.9,11-5c0.6-0.7,1.2-1.5,1.7-2.3c2-2.5,4.2-4.8,6.7-6.8c6.8-5.4,15.5-8.6,24.8-8.6c10.6,0,20.2,4.1,27.4,10.9\r\n\t\tc1.7,1.6,6.7,4.5,13.2,5.1c4.5,0.4,6.1,0.3,8.2,0c10.3-1.3,14.4-4.7,16.4-6.6c5.8-5.8,13.8-9.4,22.6-9.4c17.6,0,32,14.4,32,32\r\n\t\tC384,99.2,383.5,102.3,382.6,105.2z M448,320c0,17.7-14.3,32-32,32h-32V192h32c17.7,0,32,14.3,32,32V320z"},"children":[{"name":"path","attribs":{"d":"M416,160h-32v-16c14.5-3.5,32-24.3,32-48c0-35.3-28.7-64-64-64c-16.3,0-31.1,6.1-42.4,16.1C297.2,38,281.4,32,264.2,32\r\n\t\tc-15.8,0-30.4,5.1-42.3,13.7c-9.9-8.5-22.9-13.7-37-13.7c-17.1,0-32.4,7.6-42.8,19.5C130.4,39.5,114.1,32,96,32\r\n\t\tc-35.3,0-64,28.7-64,64c0,16.2,6.1,31,16,42.3c0,0.2,0,0.4,0,0.7v54c0,26.5,21.5,48,48,48v223c0,8.8,7.2,16,16,16h256\r\n\t\tc8.8,0,16-7.2,16-16v-80h32c35.3,0,64-28.7,64-64v-96C480,188.7,451.3,160,416,160z M327.8,304c-1.6,0-3-0.6-4.3-1.4\r\n\t\tc-2.2-1.4-3.5-4-3.5-6.8V248c0-4.4,3.6-8,8-8c4.4,0,8,3.6,8,8v48.1l0,0C336,301.1,332.2,304,327.8,304z M335,228.4\r\n\t\tc-1.2,1.8-3,3-5.1,3.5c-2.1,0.4-4.3,0-6-1.1c-1.8-1.2-3-3-3.5-5.1c-0.4-2.1,0-4.3,1.1-6c1.2-1.8,3-3,5.1-3.5c2.1-0.4,4.3,0,6,1.1\r\n\t\tc1.8,1.2,3,3,3.5,5.1C336.6,224.4,336.2,226.6,335,228.4z M352,160v32H224.2c-0.1-4.3-3.6-7.8-8-7.8c-4.4,0-7.9,3.5-8,7.8H128v-9\r\n\t\tv-31.6c6.5-3.8,12.3-8.6,17-14.3c1.2-1.5,2.4-3,3.5-4.6c1.5,1.2,3,2.4,4.6,3.4c9.1,6.1,20,9.7,31.7,9.7c6.4,0,12.6-1.1,18.3-3\r\n\t\tc12.8,20.2,35.3,33.7,61,33.7c22,0,41.7-9.9,54.9-25.4c5.7-6.7,10.2-14.4,13.1-22.9H352V160z M382.6,105.2\r\n\t\tc-2.5-5.5-8.1-9.2-14.6-9.2h-48h-7c0,0-8.7-0.7-8.7,8.2s-2.9,17.1-7.8,23.7c-7.3,9.9-19.1,16.4-32.4,16.4\r\n\t\tc-14.9,0-27.9-8.1-34.8-20.2c-1.6-2.7-2.8-5.6-3.7-8.6c-0.1-0.6-0.3-1.1-0.4-1.6c-2-5.9-7.5-10.2-14.1-10.2c-3.9,0-7.5,1.5-10.2,4\r\n\t\tc0,0,0,0-0.1,0.1c-2.4,2.1-5.3,3.7-8.4,4.7c-2.4,0.8-5,1.2-7.7,1.2c-7.5,0-14.7-4-18.8-8.6c-10-11.4-23.7-6.8-29.7-5.5\r\n\t\ts-12.2,11.7-12.2,11.7c-1.1,2.1-2.5,4-4,5.8c-5.9,6.7-14.5,11-24.1,11v32v23v26c-8.8,0-16-7.2-16-16v-35v-34.3\r\n\t\tc-7.7-4.5-13.4-12.1-15.3-21c-0.5-2.1-0.7-4.4-0.7-6.7c0-17.6,14.4-32,32-32c11.8,0,23.3,7.7,30.1,15.4s26.7,7.7,33.9,0\r\n\t\tc6.8-7.3,14.3-15.4,24.8-15.4c6,0,11.6,2.2,15.9,5.8c1.9,1.6,3.6,3.5,4.9,5.6c1.1,1.8,2,4.2,3.1,5.8c2.7,3.4,6.5,5.5,11.2,5.5\r\n\t\tc4.4,0,8.3-1.9,11-5c0.6-0.7,1.2-1.5,1.7-2.3c2-2.5,4.2-4.8,6.7-6.8c6.8-5.4,15.5-8.6,24.8-8.6c10.6,0,20.2,4.1,27.4,10.9\r\n\t\tc1.7,1.6,6.7,4.5,13.2,5.1c4.5,0.4,6.1,0.3,8.2,0c10.3-1.3,14.4-4.7,16.4-6.6c5.8-5.8,13.8-9.4,22.6-9.4c17.6,0,32,14.4,32,32\r\n\t\tC384,99.2,383.5,102.3,382.6,105.2z M448,320c0,17.7-14.3,32-32,32h-32V192h32c17.7,0,32,14.3,32,32V320z"},"children":[]}]},{"name":"circle","attribs":{"cx":"168.2","cy":"168.2","r":"8"},"children":[{"name":"circle","attribs":{"cx":"168.2","cy":"168.2","r":"8"},"children":[]}]},{"name":"circle","attribs":{"cx":"328.2","cy":"168.2","r":"8"},"children":[{"name":"circle","attribs":{"cx":"328.2","cy":"168.2","r":"8"},"children":[]}]}]}]};exports.beer=beer;var bluetooth={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M140,143.6c-15.9,15.9-11.7,17.3-10.6,18.4c1.1,1.1,89.8,85.6,89.8,85.6s3.9,3.4,3.9,8.4h0c0,5-3.9,8.4-3.9,8.4\r\n\t\ts-88.7,84.5-89.8,85.6c-1.1,1.1-5.3,2.5,10.6,18.4c15.9,15.9,18.4,12.2,19.2,11.4l67.4-64.3c0.1-0.1,0.2-0.2,0.3-0.3\r\n\t\tc0.1-0.1,0.3-0.2,0.4-0.3c2.3-1.9,9.8-10.6,9.8-3.2c0,7.3,0,151.8,0,156.4v0.1v1.7c0,5.5,5.2,10.1,11.6,10.1c3.5,0,6.7-1.3,8.9-3.5\r\n\t\tl0,0c0,0,118.2-112.8,122.8-117.2c4.6-4.4,5-10.7,1-14.7l-83.9-80.3c0,0-4.4-4.3-4.4-8.3s4.4-8.3,4.4-8.3l83.9-80.3\r\n\t\tc4-4,3.6-10.4-1-14.7c-4.6-4.4-122.8-117.2-122.8-117.2l0,0c-2.1-2.1-5.3-3.5-8.8-3.5c-6.4,0-11.6,4.6-11.6,10.1v1.7V44\r\n\t\tc0,4.6,0,149.1,0,156.4c0,7.4-7.5-1.3-9.8-3.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l-67.4-64.3\r\n\t\tC158.3,131.4,155.9,127.7,140,143.6z M280,119.9c0-6.6,7.5,2.3,9.8,4.4l30.5,29.2c2.1,2,2.9,4.7,2.9,7.2c0,2.5-1,5.6-2.8,7.3\r\n\t\tc-1.8,1.7-30.8,29.5-30.8,29.5c-2.3,1.8-9.6,9.8-9.6,1.7C280,199.2,280,126.5,280,119.9z M280,312.8c0-8.2,7.2-0.2,9.6,1.7\r\n\t\tc0,0,29.1,27.8,30.9,29.5c1.8,1.7,2.8,4.9,2.8,7.3s-0.8,5.2-2.9,7.2l-30.5,29.2c-2.3,2.1-9.8,11-9.8,4.4\r\n\t\tC280,385.5,280,312.8,280,312.8z"},"children":[{"name":"path","attribs":{"d":"M140,143.6c-15.9,15.9-11.7,17.3-10.6,18.4c1.1,1.1,89.8,85.6,89.8,85.6s3.9,3.4,3.9,8.4h0c0,5-3.9,8.4-3.9,8.4\r\n\t\ts-88.7,84.5-89.8,85.6c-1.1,1.1-5.3,2.5,10.6,18.4c15.9,15.9,18.4,12.2,19.2,11.4l67.4-64.3c0.1-0.1,0.2-0.2,0.3-0.3\r\n\t\tc0.1-0.1,0.3-0.2,0.4-0.3c2.3-1.9,9.8-10.6,9.8-3.2c0,7.3,0,151.8,0,156.4v0.1v1.7c0,5.5,5.2,10.1,11.6,10.1c3.5,0,6.7-1.3,8.9-3.5\r\n\t\tl0,0c0,0,118.2-112.8,122.8-117.2c4.6-4.4,5-10.7,1-14.7l-83.9-80.3c0,0-4.4-4.3-4.4-8.3s4.4-8.3,4.4-8.3l83.9-80.3\r\n\t\tc4-4,3.6-10.4-1-14.7c-4.6-4.4-122.8-117.2-122.8-117.2l0,0c-2.1-2.1-5.3-3.5-8.8-3.5c-6.4,0-11.6,4.6-11.6,10.1v1.7V44\r\n\t\tc0,4.6,0,149.1,0,156.4c0,7.4-7.5-1.3-9.8-3.2c-0.1-0.1-0.3-0.2-0.4-0.3c-0.1-0.1-0.2-0.2-0.3-0.3l-67.4-64.3\r\n\t\tC158.3,131.4,155.9,127.7,140,143.6z M280,119.9c0-6.6,7.5,2.3,9.8,4.4l30.5,29.2c2.1,2,2.9,4.7,2.9,7.2c0,2.5-1,5.6-2.8,7.3\r\n\t\tc-1.8,1.7-30.8,29.5-30.8,29.5c-2.3,1.8-9.6,9.8-9.6,1.7C280,199.2,280,126.5,280,119.9z M280,312.8c0-8.2,7.2-0.2,9.6,1.7\r\n\t\tc0,0,29.1,27.8,30.9,29.5c1.8,1.7,2.8,4.9,2.8,7.3s-0.8,5.2-2.9,7.2l-30.5,29.2c-2.3,2.1-9.8,11-9.8,4.4\r\n\t\tC280,385.5,280,312.8,280,312.8z"},"children":[]}]}]}]};exports.bluetooth=bluetooth;var bonfire={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M270.93,350.601C270.219,342.42,263.364,336,255,336c-7.635,0-14.01,5.352-15.605,12.506l-0.007-0.002l-15.612,92.502\r\n\t\tC223.273,443.258,223,445.597,223,448c0,17.673,14.327,32,32,32s32-14.327,32-32c0-2.899-0.393-5.705-1.115-8.377L270.93,350.601z"},"children":[{"name":"path","attribs":{"d":"M270.93,350.601C270.219,342.42,263.364,336,255,336c-7.635,0-14.01,5.352-15.605,12.506l-0.007-0.002l-15.612,92.502\r\n\t\tC223.273,443.258,223,445.597,223,448c0,17.673,14.327,32,32,32s32-14.327,32-32c0-2.899-0.393-5.705-1.115-8.377L270.93,350.601z"},"children":[]}]},{"name":"polygon","attribs":{"points":"305.904,355.046 305.903,355.044 305.9,355.046 \t"},"children":[{"name":"polygon","attribs":{"points":"305.904,355.046 305.903,355.044 305.9,355.046 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M392.875,390.261c-1.718-1.407-3.3-2.881-5.138-3.94l-63.629-47.507c-5.775-3.796-11.997-3.689-16.527,0.85\r\n\t\tc-4.131,4.143-4.686,10.369-1.678,15.381l48.959,65.763c0.946,1.494,2.166,2.799,3.366,4.195c7.802,9.071,25.08,9.588,34.646-0.007\r\n\t\tC402.445,415.409,402.305,397.986,392.875,390.261z"},"children":[{"name":"path","attribs":{"d":"M392.875,390.261c-1.718-1.407-3.3-2.881-5.138-3.94l-63.629-47.507c-5.775-3.796-11.997-3.689-16.527,0.85\r\n\t\tc-4.131,4.143-4.686,10.369-1.678,15.381l48.959,65.763c0.946,1.494,2.166,2.799,3.366,4.195c7.802,9.071,25.08,9.588,34.646-0.007\r\n\t\tC402.445,415.409,402.305,397.986,392.875,390.261z"},"children":[]}]},{"name":"polygon","attribs":{"points":"372.511,335.018 372.509,335.018 372.509,335.02 \t"},"children":[{"name":"polygon","attribs":{"points":"372.511,335.018 372.509,335.018 372.509,335.02 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M435.428,322.475l-59.521-2.284c-3.891-0.558-7.4,2.053-8.065,6.011c-0.604,3.611,1.347,7.138,4.668,8.816l0.013-0.039\r\n\t\tc0.041,0.019,0.062,0.006,0.105,0.025l57.717,17.756c8.289,1.93,17.656-2.343,17.656-11.648\r\n\t\tC448,329.328,444.917,323.667,435.428,322.475z"},"children":[{"name":"path","attribs":{"d":"M435.428,322.475l-59.521-2.284c-3.891-0.558-7.4,2.053-8.065,6.011c-0.604,3.611,1.347,7.138,4.668,8.816l0.013-0.039\r\n\t\tc0.041,0.019,0.062,0.006,0.105,0.025l57.717,17.756c8.289,1.93,17.656-2.343,17.656-11.648\r\n\t\tC448,329.328,444.917,323.667,435.428,322.475z"},"children":[]}]},{"name":"polygon","attribs":{"points":"139.222,335.02 139.222,335.018 139.22,335.018 \t"},"children":[{"name":"polygon","attribs":{"points":"139.222,335.02 139.222,335.018 139.22,335.018 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M139.209,334.979l0.013,0.039c3.321-1.679,5.272-5.205,4.668-8.816c-0.665-3.958-4.175-6.568-8.065-6.011l-59.521,2.284\r\n\t\tC66.813,323.667,64,329.328,64,341.111c0,9.306,9.098,13.578,17.387,11.648l57.717-17.756\r\n\t\tC139.146,334.984,139.168,334.997,139.209,334.979z"},"children":[{"name":"path","attribs":{"d":"M139.209,334.979l0.013,0.039c3.321-1.679,5.272-5.205,4.668-8.816c-0.665-3.958-4.175-6.568-8.065-6.011l-59.521,2.284\r\n\t\tC66.813,323.667,64,329.328,64,341.111c0,9.306,9.098,13.578,17.387,11.648l57.717-17.756\r\n\t\tC139.146,334.984,139.168,334.997,139.209,334.979z"},"children":[]}]},{"name":"path","attribs":{"d":"M187.903,338.807l-63.597,47.431c-1.838,1.057-3.569,2.362-5.137,3.931c-9.563,9.567-9.566,25.088-0.004,34.65\r\n\t\tc9.561,9.571,25.055,9.578,34.618,0.007c1.3-1.299,2.405-2.694,3.352-4.185L206.097,355c3.007-5,2.452-11.213-1.677-15.346\r\n\t\tC199.893,335.126,192.712,334.762,187.903,338.807z"},"children":[{"name":"path","attribs":{"d":"M187.903,338.807l-63.597,47.431c-1.838,1.057-3.569,2.362-5.137,3.931c-9.563,9.567-9.566,25.088-0.004,34.65\r\n\t\tc9.561,9.571,25.055,9.578,34.618,0.007c1.3-1.299,2.405-2.694,3.352-4.185L206.097,355c3.007-5,2.452-11.213-1.677-15.346\r\n\t\tC199.893,335.126,192.712,334.762,187.903,338.807z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,128c0-61-72.35-96-96-96c12.017,85.553-101.667,119.667-112,192s48,96,48,96\r\n\t\tc16.333-59.896,72.386-79.997,109.667-105.667C342.333,186.333,352,160.061,352,128z"},"children":[{"name":"path","attribs":{"d":"M352,128c0-61-72.35-96-96-96c12.017,85.553-101.667,119.667-112,192s48,96,48,96\r\n\t\tc16.333-59.896,72.386-79.997,109.667-105.667C342.333,186.333,352,160.061,352,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,256c5.03-15.613,4.91-49,0-64c-8.999,18.5-26.287,34.3-47.186,48.689c-8.584,5.911-19.859,11.443-28.83,16.797\r\n\t\tc-18.714,11.165-34.984,21.848-47.329,36.4C240.001,311.25,256.973,320,272,320C307.999,320,336,305.662,352,256z"},"children":[{"name":"path","attribs":{"d":"M352,256c5.03-15.613,4.91-49,0-64c-8.999,18.5-26.287,34.3-47.186,48.689c-8.584,5.911-19.859,11.443-28.83,16.797\r\n\t\tc-18.714,11.165-34.984,21.848-47.329,36.4C240.001,311.25,256.973,320,272,320C307.999,320,336,305.662,352,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M152.037,160c11.722-15.952,24.856-25.209,38.19-38.362c13.436-13.254,22.077-22.471,27.464-33.173\r\n\t\tC207.025,67.134,189.842,61.857,176,64c2.333,30.334-29.97,46.567-32,68.657C142.773,146,146.5,156,152.037,160z"},"children":[{"name":"path","attribs":{"d":"M152.037,160c11.722-15.952,24.856-25.209,38.19-38.362c13.436-13.254,22.077-22.471,27.464-33.173\r\n\t\tC207.025,67.134,189.842,61.857,176,64c2.333,30.334-29.97,46.567-32,68.657C142.773,146,146.5,156,152.037,160z"},"children":[]}]}]}]};exports.bonfire=bonfire;var bookmark={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,64H168c-4.4,0-8,3.6-8,8v56h192V72C352,67.6,348.4,64,344,64z"},"children":[{"name":"path","attribs":{"d":"M344,64H168c-4.4,0-8,3.6-8,8v56h192V72C352,67.6,348.4,64,344,64z"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,448 256,352 352,448 352,144 160,144 \t"},"children":[{"name":"polygon","attribs":{"points":"160,448 256,352 352,448 352,144 160,144 \t"},"children":[]}]}]}]};exports.bookmark=bookmark;var bowtie={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M223.955,212.011c0,0,8.054-4.679,19.985-7.011c21.318-4.166,39.472-5.5,47.466,8.5c9.777,17.124,18.402,53.417,16.488,85.5\r\n\tc-1,16.75-4.622,22.125-4.622,22.125s-15.333,9.525-47.341,6.875c-34.725-2.875-39.971-15.004-39.971-15.004\r\n\ts4.497-11.305,7.995-42.499C227.452,239.303,223.955,212.011,223.955,212.011z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M183.984,285c12.546-3.323,23.03-7.189,27.659-8.985c0.693-4.707,1.28-9.718,1.694-15.015\r\n\t\tc0.271-3.461,0.465-6.754,0.602-9.896c-6.854-2.333-13.534-4.851-28.769-10.104c-38.66-13.333-57.146-17-57.146-17\r\n\t\ts14.24-2.5,42.219,3c19.986,3.929,34.392,9.5,43.947,14.333c0.771-15.999-2.477-32.583-2.477-32.583\r\n\t\tC189.729,168.5,119.53,112,84.368,112C57.888,112,32,180.5,32,256s23.03,144,51.51,144c33.356,0,116.463-80,116.463-80\r\n\t\ts5.738-12.578,9.879-33.572c-18.788,5.198-63.84,8.572-63.84,8.572S166.996,289.5,183.984,285z"},"children":[{"name":"path","attribs":{"d":"M183.984,285c12.546-3.323,23.03-7.189,27.659-8.985c0.693-4.707,1.28-9.718,1.694-15.015\r\n\t\tc0.271-3.461,0.465-6.754,0.602-9.896c-6.854-2.333-13.534-4.851-28.769-10.104c-38.66-13.333-57.146-17-57.146-17\r\n\t\ts14.24-2.5,42.219,3c19.986,3.929,34.392,9.5,43.947,14.333c0.771-15.999-2.477-32.583-2.477-32.583\r\n\t\tC189.729,168.5,119.53,112,84.368,112C57.888,112,32,180.5,32,256s23.03,144,51.51,144c33.356,0,116.463-80,116.463-80\r\n\t\ts5.738-12.578,9.879-33.572c-18.788,5.198-63.84,8.572-63.84,8.572S166.996,289.5,183.984,285z"},"children":[]}]},{"name":"path","attribs":{"d":"M427.632,112c-36.37,0-102.363,56.5-124.348,96.75l-0.761,1.375c0,0,1.389,2.527,1.873,3.375\r\n\t\tc3.424,5.996,6.704,14.348,9.442,24.041c8.115-2.805,23.599-8.164,37.523-13.041c19.985-7,34.975-9.5,34.975-9.5\r\n\t\ts-52.982,23.741-69.605,34.264c2.169,10.159,3.693,21.199,4.218,32.242c5.423,2.216,16.551,6.475,29.914,9.994\r\n\t\tc18.986,5,40.398,11.5,40.398,11.5s-54.202-5.27-70.114-12.522c-0.013,2.862-0.095,5.709-0.263,8.522\r\n\t\tc-0.997,16.719-4.608,22.104-4.622,22.124C323.883,331.667,391.262,400,428.49,400C456.97,400,480,331.5,480,256\r\n\t\tS454.112,112,427.632,112z"},"children":[{"name":"path","attribs":{"d":"M427.632,112c-36.37,0-102.363,56.5-124.348,96.75l-0.761,1.375c0,0,1.389,2.527,1.873,3.375\r\n\t\tc3.424,5.996,6.704,14.348,9.442,24.041c8.115-2.805,23.599-8.164,37.523-13.041c19.985-7,34.975-9.5,34.975-9.5\r\n\t\ts-52.982,23.741-69.605,34.264c2.169,10.159,3.693,21.199,4.218,32.242c5.423,2.216,16.551,6.475,29.914,9.994\r\n\t\tc18.986,5,40.398,11.5,40.398,11.5s-54.202-5.27-70.114-12.522c-0.013,2.862-0.095,5.709-0.263,8.522\r\n\t\tc-0.997,16.719-4.608,22.104-4.622,22.124C323.883,331.667,391.262,400,428.49,400C456.97,400,480,331.5,480,256\r\n\t\tS454.112,112,427.632,112z"},"children":[]}]}]}]};exports.bowtie=bowtie;var briefcase={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M272,272h-32v-8H32v176c0,4.4,3.3,8,7.8,8h432.5c4.4,0,7.7-3.6,7.7-8V264H272V272z"},"children":[{"name":"path","attribs":{"d":"M272,272h-32v-8H32v176c0,4.4,3.3,8,7.8,8h432.5c4.4,0,7.7-3.6,7.7-8V264H272V272z"},"children":[]}]},{"name":"path","attribs":{"d":"M472.2,144H352v-30.7C351,85.1,330.3,64,300.8,64h-89.6c-29.4,0-50.2,21.1-51.2,49.3V144H39.8c-4.4,0-7.8,3.6-7.8,8v96h208\r\n\t\tv-8h32v8h208v-96C480,147.6,476.7,144,472.2,144z M320,116.2c0,0.3,0,0.6,0,1V144H192v-26.8c0-0.4,0-0.7,0-1c0-0.3,0-0.6,0-1\r\n\t\tc0-9.7,8.6-19.2,18.8-19.2h90.4c10.1,0,18.8,9.4,18.8,19.2C320,115.6,320,115.9,320,116.2z"},"children":[{"name":"path","attribs":{"d":"M472.2,144H352v-30.7C351,85.1,330.3,64,300.8,64h-89.6c-29.4,0-50.2,21.1-51.2,49.3V144H39.8c-4.4,0-7.8,3.6-7.8,8v96h208\r\n\t\tv-8h32v8h208v-96C480,147.6,476.7,144,472.2,144z M320,116.2c0,0.3,0,0.6,0,1V144H192v-26.8c0-0.4,0-0.7,0-1c0-0.3,0-0.6,0-1\r\n\t\tc0-9.7,8.6-19.2,18.8-19.2h90.4c10.1,0,18.8,9.4,18.8,19.2C320,115.6,320,115.9,320,116.2z"},"children":[]}]}]}]};exports.briefcase=briefcase;var bug={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M374.64,127.327C345.365,88.512,303.062,64,256,64s-89.365,24.512-118.64,63.327c6.354,15.64,15.833,30,28.13,42.297\r\n\t\tc24.176,24.176,56.319,37.49,90.51,37.49s66.334-13.314,90.51-37.49C358.807,157.327,368.286,142.966,374.64,127.327z"},"children":[{"name":"path","attribs":{"d":"M374.64,127.327C345.365,88.512,303.062,64,256,64s-89.365,24.512-118.64,63.327c6.354,15.64,15.833,30,28.13,42.297\r\n\t\tc24.176,24.176,56.319,37.49,90.51,37.49s66.334-13.314,90.51-37.49C358.807,157.327,368.286,142.966,374.64,127.327z"},"children":[]}]},{"name":"path","attribs":{"d":"M126.836,142.824c-1.725,2.827-3.396,5.703-4.992,8.644c-2.926-1.84-5.319-3.74-7.745-5.773\r\n\t\tc-1.171-0.981-2.954-3.949-4.546-7.35c5.41-11.314,1.181-25.037-9.914-31.261c-11.561-6.484-26.188-2.372-32.674,9.189\r\n\t\tc-6.485,11.56-2.371,26.188,9.187,32.673c1.251,0.702,2.539,1.272,3.847,1.729c2.816,6.269,7.32,14.331,13.548,19.547\r\n\t\tc4.184,3.507,8.792,7.117,15.204,10.674c-7.195,20.259-11.576,42.303-12.545,65.427c-11.026,0.207-18.619,2.1-25.474,4.122\r\n\t\tc-4.16,1.227-8.192,3.395-11.823,5.852c-0.954-0.115-1.923-0.182-2.908-0.182c-13.255,0-24,10.745-24,24s10.745,24,24,24\r\n\t\tc12.93,0,23.467-10.227,23.976-23.032c5.046-1.482,9.888-2.659,17.095-2.774c3.167,33.015,13.304,63.483,28.613,89.224\r\n\t\tc-14.166,11.006-22.882,23.016-26.605,36.317c0,0-0.75,0.438-1.873,1.366c-0.982,0.794-1.932,1.65-2.804,2.619\r\n\t\tc-8.865,9.855-8.062,25.031,1.793,33.895c9.854,8.865,25.028,8.062,33.893-1.793c8.087-8.988,8.095-22.381,0.558-31.395\r\n\t\tc3.074-5.562,6.236-9.014,13.67-14.961C171.368,425.235,207.723,445.619,248,448V222.872\r\n\t\tC194.764,219.954,149.229,188.138,126.836,142.824z"},"children":[{"name":"path","attribs":{"d":"M126.836,142.824c-1.725,2.827-3.396,5.703-4.992,8.644c-2.926-1.84-5.319-3.74-7.745-5.773\r\n\t\tc-1.171-0.981-2.954-3.949-4.546-7.35c5.41-11.314,1.181-25.037-9.914-31.261c-11.561-6.484-26.188-2.372-32.674,9.189\r\n\t\tc-6.485,11.56-2.371,26.188,9.187,32.673c1.251,0.702,2.539,1.272,3.847,1.729c2.816,6.269,7.32,14.331,13.548,19.547\r\n\t\tc4.184,3.507,8.792,7.117,15.204,10.674c-7.195,20.259-11.576,42.303-12.545,65.427c-11.026,0.207-18.619,2.1-25.474,4.122\r\n\t\tc-4.16,1.227-8.192,3.395-11.823,5.852c-0.954-0.115-1.923-0.182-2.908-0.182c-13.255,0-24,10.745-24,24s10.745,24,24,24\r\n\t\tc12.93,0,23.467-10.227,23.976-23.032c5.046-1.482,9.888-2.659,17.095-2.774c3.167,33.015,13.304,63.483,28.613,89.224\r\n\t\tc-14.166,11.006-22.882,23.016-26.605,36.317c0,0-0.75,0.438-1.873,1.366c-0.982,0.794-1.932,1.65-2.804,2.619\r\n\t\tc-8.865,9.855-8.062,25.031,1.793,33.895c9.854,8.865,25.028,8.062,33.893-1.793c8.087-8.988,8.095-22.381,0.558-31.395\r\n\t\tc3.074-5.562,6.236-9.014,13.67-14.961C171.368,425.235,207.723,445.619,248,448V222.872\r\n\t\tC194.764,219.954,149.229,188.138,126.836,142.824z"},"children":[]}]},{"name":"path","attribs":{"d":"M456,256.114c-0.985,0-1.954,0.066-2.908,0.182c-3.631-2.457-7.663-4.625-11.823-5.852\r\n\t\tc-6.854-2.021-14.447-3.915-25.474-4.122c-0.969-23.125-5.35-45.168-12.545-65.427c6.412-3.557,11.021-7.167,15.204-10.674\r\n\t\tc6.228-5.216,10.731-13.278,13.548-19.547c1.308-0.458,2.596-1.028,3.847-1.729c11.558-6.485,15.672-21.114,9.187-32.673\r\n\t\tc-6.485-11.561-21.113-15.673-32.674-9.189c-11.095,6.225-15.324,19.947-9.914,31.261c-1.592,3.401-3.375,6.369-4.546,7.35\r\n\t\tc-2.426,2.033-4.819,3.933-7.745,5.773c-1.596-2.941-3.268-5.817-4.992-8.644c-22.393,45.314-67.928,77.13-121.164,80.048V448\r\n\t\tc40.277-2.381,76.632-22.765,103.686-54.42c7.434,5.947,10.596,9.399,13.67,14.961c-7.537,9.014-7.529,22.406,0.558,31.395\r\n\t\tc8.864,9.855,24.038,10.658,33.893,1.793c9.854-8.863,10.658-24.039,1.793-33.895c-0.872-0.969-1.821-1.825-2.804-2.619\r\n\t\tc-1.123-0.929-1.873-1.366-1.873-1.366c-3.724-13.302-12.439-25.312-26.605-36.317c15.31-25.74,25.446-56.209,28.613-89.224\r\n\t\tc7.207,0.115,12.049,1.292,17.095,2.774c0.509,12.806,11.046,23.032,23.976,23.032c13.255,0,24-10.745,24-24\r\n\t\tS469.255,256.114,456,256.114z"},"children":[{"name":"path","attribs":{"d":"M456,256.114c-0.985,0-1.954,0.066-2.908,0.182c-3.631-2.457-7.663-4.625-11.823-5.852\r\n\t\tc-6.854-2.021-14.447-3.915-25.474-4.122c-0.969-23.125-5.35-45.168-12.545-65.427c6.412-3.557,11.021-7.167,15.204-10.674\r\n\t\tc6.228-5.216,10.731-13.278,13.548-19.547c1.308-0.458,2.596-1.028,3.847-1.729c11.558-6.485,15.672-21.114,9.187-32.673\r\n\t\tc-6.485-11.561-21.113-15.673-32.674-9.189c-11.095,6.225-15.324,19.947-9.914,31.261c-1.592,3.401-3.375,6.369-4.546,7.35\r\n\t\tc-2.426,2.033-4.819,3.933-7.745,5.773c-1.596-2.941-3.268-5.817-4.992-8.644c-22.393,45.314-67.928,77.13-121.164,80.048V448\r\n\t\tc40.277-2.381,76.632-22.765,103.686-54.42c7.434,5.947,10.596,9.399,13.67,14.961c-7.537,9.014-7.529,22.406,0.558,31.395\r\n\t\tc8.864,9.855,24.038,10.658,33.893,1.793c9.854-8.863,10.658-24.039,1.793-33.895c-0.872-0.969-1.821-1.825-2.804-2.619\r\n\t\tc-1.123-0.929-1.873-1.366-1.873-1.366c-3.724-13.302-12.439-25.312-26.605-36.317c15.31-25.74,25.446-56.209,28.613-89.224\r\n\t\tc7.207,0.115,12.049,1.292,17.095,2.774c0.509,12.806,11.046,23.032,23.976,23.032c13.255,0,24-10.745,24-24\r\n\t\tS469.255,256.114,456,256.114z"},"children":[]}]}]}]};exports.bug=bug;var calculator={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M400,32H112c-8.8,0-16,7.2-16,16v416c0,8.8,7.2,16,16,16h288c8.8,0,16-7.2,16-16V48C416,39.2,408.8,32,400,32z M144,208h32\r\n\tv32h-32V208z M144,272h32v32h-32V272z M144,336h32v32h-32V336z M240,432h-96v-32h96V432z M240,368h-32v-32h32V368z M240,304h-32v-32\r\n\th32V304z M240,240h-32v-32h32V240z M304,432h-32v-32h32V432z M304,368h-32v-32h32V368z M304,304h-32v-32h32V304z M304,240h-32v-32\r\n\th32V240z M368,432h-32v-96h32V432z M368,304h-32v-32h32V304z M368,240h-32v-32h32V240z M368,160H144V80h224V160z"},"children":[]}]};exports.calculator=calculator;var calendar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C112,113.7,126.3,128,144,128z"},"children":[{"name":"path","attribs":{"d":"M144,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C112,113.7,126.3,128,144,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C336,113.7,350.3,128,368,128z"},"children":[{"name":"path","attribs":{"d":"M368,128c17.7,0,32-14.3,32-32V64c0-17.7-14.3-32-32-32s-32,14.3-32,32v32C336,113.7,350.3,128,368,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M472,64h-56v40.7c0,22.5-23.2,39.3-47.2,39.3S320,127.2,320,104.7V64H192v40.7c0,22.5-24,39.3-48,39.3s-48-16.8-48-39.3V64\r\n\t\tH40c-4.4,0-8,3.6-8,8v400c0,4.4,3.6,8,8,8h432c4.4,0,8-3.6,8-8V72C480,67.6,476.4,64,472,64z M432,432H80V176h352V432z"},"children":[{"name":"path","attribs":{"d":"M472,64h-56v40.7c0,22.5-23.2,39.3-47.2,39.3S320,127.2,320,104.7V64H192v40.7c0,22.5-24,39.3-48,39.3s-48-16.8-48-39.3V64\r\n\t\tH40c-4.4,0-8,3.6-8,8v400c0,4.4,3.6,8,8,8h432c4.4,0,8-3.6,8-8V72C480,67.6,476.4,64,472,64z M432,432H80V176h352V432z"},"children":[]}]}]}]};exports.calendar=calendar;var camera={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M430.4,147h-67.5l-40.4-40.8c0,0-0.2-0.2-0.3-0.2l-0.2-0.2v0c-6-6-14.1-9.8-23.3-9.8h-84c-9.8,0-18.5,4.2-24.6,10.9l0,0.1\r\n\t\tl-39.5,40H81.6C63,147,48,161.6,48,180.2v202.1c0,18.6,15,33.7,33.6,33.7h348.8c18.5,0,33.6-15.1,33.6-33.7V180.2\r\n\t\tC464,161.6,448.9,147,430.4,147z M256,365.5c-50.9,0-92.4-41.6-92.4-92.6c0-51.1,41.5-92.6,92.4-92.6c51,0,92.4,41.5,92.4,92.6\r\n\t\tC348.4,323.9,307,365.5,256,365.5z M424.1,200.5c-7.7,0-14-6.3-14-14.1s6.3-14.1,14-14.1c7.7,0,14,6.3,14,14.1\r\n\t\tS431.8,200.5,424.1,200.5z"},"children":[{"name":"path","attribs":{"d":"M430.4,147h-67.5l-40.4-40.8c0,0-0.2-0.2-0.3-0.2l-0.2-0.2v0c-6-6-14.1-9.8-23.3-9.8h-84c-9.8,0-18.5,4.2-24.6,10.9l0,0.1\r\n\t\tl-39.5,40H81.6C63,147,48,161.6,48,180.2v202.1c0,18.6,15,33.7,33.6,33.7h348.8c18.5,0,33.6-15.1,33.6-33.7V180.2\r\n\t\tC464,161.6,448.9,147,430.4,147z M256,365.5c-50.9,0-92.4-41.6-92.4-92.6c0-51.1,41.5-92.6,92.4-92.6c51,0,92.4,41.5,92.4,92.6\r\n\t\tC348.4,323.9,307,365.5,256,365.5z M424.1,200.5c-7.7,0-14-6.3-14-14.1s6.3-14.1,14-14.1c7.7,0,14,6.3,14,14.1\r\n\t\tS431.8,200.5,424.1,200.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,202.9c-38.6,0-69.8,31.3-69.8,70c0,38.6,31.2,70,69.8,70c38.5,0,69.8-31.3,69.8-70C325.8,234.2,294.5,202.9,256,202.9\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M256,202.9c-38.6,0-69.8,31.3-69.8,70c0,38.6,31.2,70,69.8,70c38.5,0,69.8-31.3,69.8-70C325.8,234.2,294.5,202.9,256,202.9\r\n\t\tz"},"children":[]}]}]}]};exports.camera=camera;var card={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M452,96H60c-15.5,0-27.9,12.5-28,28l0,0v0.3v263.4v0.3l0,0c0.2,15.5,12.5,28,28,28h392c15.6,0,28-12.7,28-28.3v0V124.3v0\r\n\t\tC480,108.7,467.6,96,452,96z M77.1,128h357.7c6.9,0,12.1,5.1,13.1,12v20H64v-20.3C65,132.9,70.3,128,77.1,128z M434.9,384H77.1\r\n\t\tc-6.9,0-12.1-4.9-13.1-11.7V256h384v116C447,378.9,441.7,384,434.9,384z"},"children":[{"name":"path","attribs":{"d":"M452,96H60c-15.5,0-27.9,12.5-28,28l0,0v0.3v263.4v0.3l0,0c0.2,15.5,12.5,28,28,28h392c15.6,0,28-12.7,28-28.3v0V124.3v0\r\n\t\tC480,108.7,467.6,96,452,96z M77.1,128h357.7c6.9,0,12.1,5.1,13.1,12v20H64v-20.3C65,132.9,70.3,128,77.1,128z M434.9,384H77.1\r\n\t\tc-6.9,0-12.1-4.9-13.1-11.7V256h384v116C447,378.9,441.7,384,434.9,384z"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"304","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"96","y":"304","width":"192","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"336","width":"96","height":"16"},"children":[{"name":"rect","attribs":{"x":"96","y":"336","width":"96","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"304","width":"64","height":"48"},"children":[{"name":"rect","attribs":{"x":"352","y":"304","width":"64","height":"48"},"children":[]}]}]}]};exports.card=card;var cash={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,96v256h512V96H0z M192.508,320H80.129c0-26.582-21.549-48.129-48.129-48.129V192c35.346,0,64-28.653,64-64h96.509\r\n\t\tC172.576,151.455,160,185.767,160,224S172.576,296.545,192.508,320z M298.089,261.248c-2.582,4.182-5.978,7.602-10.189,10.257\r\n\t\tc-4.214,2.655-9.004,4.607-14.375,5.835c-2.812,0.644-5.654,1.119-8.524,1.432V288h-18v-9.43c-2.768-0.357-5.461-0.863-8.072-1.541\r\n\t\tc-5.688-1.475-10.641-3.659-14.851-6.709c-4.214-3.047-7.584-6.803-10.11-11.573C211.548,254.186,210.24,248,210.04,243h19.735\r\n\t\tc0.096,3,0.828,6.532,2.201,9.184c1.473,2.853,3.526,4.883,6.16,6.7c2.572,1.78,5.532,3.082,8.863,3.919v-34.358\r\n\t\tc-2.436-0.601-5.016-1.245-7.758-1.938c-4.846-1.18-8.873-2.729-12.085-4.646c-3.214-1.918-5.766-4.057-7.661-6.417\r\n\t\tc-1.896-2.359-3.238-4.867-4.028-7.522c-0.791-2.656-1.186-5.358-1.186-8.113c0-5.31,1.186-9.905,3.556-13.791\r\n\t\tc2.368-3.883,5.502-7.104,9.398-9.662c3.895-2.556,8.319-4.448,13.27-5.679c2.154-0.534,4.319-0.945,6.494-1.248V160h18v9.499\r\n\t\tc2.46,0.353,4.856,0.838,7.18,1.473c5.215,1.427,9.796,3.563,13.744,6.414c3.95,2.854,7.083,6.364,9.4,10.542\r\n\t\tc2.109,3.811,3.258,8.072,3.445,13.072h-19.866c-0.753-6-3.175-10.326-7.274-12.923c-1.966-1.246-4.186-2.196-6.629-2.887v30.368\r\n\t\tc2.589,0.639,5.15,1.268,7.654,1.878c3.421,0.836,5.87,1.453,7.346,1.844c3.686,1.083,6.897,2.558,9.637,4.425\r\n\t\tc2.737,1.869,5.028,4.008,6.873,6.417c1.841,2.411,3.21,4.992,4.107,7.744c0.893,2.753,1.343,5.51,1.343,8.262\r\n\t\tC301.96,252.027,300.668,257.07,298.089,261.248z M480,271.871c-26,0-48,21.547-48,48.129H319.491\r\n\t\tC339.424,296.545,352,262.233,352,224s-12.576-72.545-32.51-96H416c0,35.347,28.653,64,64,64V271.871z"},"children":[{"name":"path","attribs":{"d":"M0,96v256h512V96H0z M192.508,320H80.129c0-26.582-21.549-48.129-48.129-48.129V192c35.346,0,64-28.653,64-64h96.509\r\n\t\tC172.576,151.455,160,185.767,160,224S172.576,296.545,192.508,320z M298.089,261.248c-2.582,4.182-5.978,7.602-10.189,10.257\r\n\t\tc-4.214,2.655-9.004,4.607-14.375,5.835c-2.812,0.644-5.654,1.119-8.524,1.432V288h-18v-9.43c-2.768-0.357-5.461-0.863-8.072-1.541\r\n\t\tc-5.688-1.475-10.641-3.659-14.851-6.709c-4.214-3.047-7.584-6.803-10.11-11.573C211.548,254.186,210.24,248,210.04,243h19.735\r\n\t\tc0.096,3,0.828,6.532,2.201,9.184c1.473,2.853,3.526,4.883,6.16,6.7c2.572,1.78,5.532,3.082,8.863,3.919v-34.358\r\n\t\tc-2.436-0.601-5.016-1.245-7.758-1.938c-4.846-1.18-8.873-2.729-12.085-4.646c-3.214-1.918-5.766-4.057-7.661-6.417\r\n\t\tc-1.896-2.359-3.238-4.867-4.028-7.522c-0.791-2.656-1.186-5.358-1.186-8.113c0-5.31,1.186-9.905,3.556-13.791\r\n\t\tc2.368-3.883,5.502-7.104,9.398-9.662c3.895-2.556,8.319-4.448,13.27-5.679c2.154-0.534,4.319-0.945,6.494-1.248V160h18v9.499\r\n\t\tc2.46,0.353,4.856,0.838,7.18,1.473c5.215,1.427,9.796,3.563,13.744,6.414c3.95,2.854,7.083,6.364,9.4,10.542\r\n\t\tc2.109,3.811,3.258,8.072,3.445,13.072h-19.866c-0.753-6-3.175-10.326-7.274-12.923c-1.966-1.246-4.186-2.196-6.629-2.887v30.368\r\n\t\tc2.589,0.639,5.15,1.268,7.654,1.878c3.421,0.836,5.87,1.453,7.346,1.844c3.686,1.083,6.897,2.558,9.637,4.425\r\n\t\tc2.737,1.869,5.028,4.008,6.873,6.417c1.841,2.411,3.21,4.992,4.107,7.744c0.893,2.753,1.343,5.51,1.343,8.262\r\n\t\tC301.96,252.027,300.668,257.07,298.089,261.248z M480,271.871c-26,0-48,21.547-48,48.129H319.491\r\n\t\tC339.424,296.545,352,262.233,352,224s-12.576-72.545-32.51-96H416c0,35.347,28.653,64,64,64V271.871z"},"children":[]}]},{"name":"circle","attribs":{"cx":"96","cy":"224","r":"32"},"children":[{"name":"circle","attribs":{"cx":"96","cy":"224","r":"32"},"children":[]}]},{"name":"circle","attribs":{"cx":"416","cy":"224","r":"32"},"children":[{"name":"circle","attribs":{"cx":"416","cy":"224","r":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M272.893,235.21c-2.395-0.823-5.029-1.618-7.893-2.389v30.856c1.592-0.23,3.069-0.547,4.416-0.959\r\n\t\tc3.053-0.934,5.529-2.139,7.425-3.613s3.264-3.171,4.107-5.089c0.842-1.917,1.263-3.858,1.263-5.827\r\n\t\tc0-4.031-0.975-7.006-2.921-8.924C277.34,237.349,275.206,235.999,272.893,235.21z"},"children":[{"name":"path","attribs":{"d":"M272.893,235.21c-2.395-0.823-5.029-1.618-7.893-2.389v30.856c1.592-0.23,3.069-0.547,4.416-0.959\r\n\t\tc3.053-0.934,5.529-2.139,7.425-3.613s3.264-3.171,4.107-5.089c0.842-1.917,1.263-3.858,1.263-5.827\r\n\t\tc0-4.031-0.975-7.006-2.921-8.924C277.34,237.349,275.206,235.999,272.893,235.21z"},"children":[]}]},{"name":"path","attribs":{"d":"M236.004,190.959c-1.318,1.771-1.975,3.982-1.975,6.638c0,3.738,1.236,6.663,3.712,8.776\r\n\t\tc2.377,2.034,5.468,3.583,9.259,4.661v-26.356c-2.18,0.45-4.192,1.135-6.02,2.078C238.979,187.788,237.32,189.189,236.004,190.959z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M236.004,190.959c-1.318,1.771-1.975,3.982-1.975,6.638c0,3.738,1.236,6.663,3.712,8.776\r\n\t\tc2.377,2.034,5.468,3.583,9.259,4.661v-26.356c-2.18,0.45-4.192,1.135-6.02,2.078C238.979,187.788,237.32,189.189,236.004,190.959z\r\n\t\t"},"children":[]}]},{"name":"rect","attribs":{"y":"384","width":"512","height":"32"},"children":[{"name":"rect","attribs":{"y":"384","width":"512","height":"32"},"children":[]}]}]}]};exports.cash=cash;var chatboxWorking={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M124.3,400H277c14.4,0,14.4,0.1,21.3,5.2S384,464,384,464v-64h3.7c42.2,0,76.3-31.8,76.3-71.4V119.7\r\n\tc0-39.6-34.2-71.7-76.3-71.7H124.3C82.2,48,48,80.1,48,119.7v208.9C48,368.2,82.2,400,124.3,400z M352.1,192c17.7,0,32,14.3,32,32\r\n\tc0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C320.1,206.3,334.4,192,352.1,192z M256.1,192c17.7,0,32,14.3,32,32\r\n\tc0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C224.1,206.3,238.4,192,256.1,192z M160.1,192c17.7,0,32,14.3,32,32\r\n\tc0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C128.1,206.3,142.4,192,160.1,192z"},"children":[]}]};exports.chatboxWorking=chatboxWorking;var chatbox={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M124.3,400H277c14.4,0,14.4,0.1,21.3,5.2S384,464,384,464v-64h3.7c42.2,0,76.3-31.8,76.3-71.4V119.7\r\n\tc0-39.6-34.2-71.7-76.3-71.7H124.3C82.2,48,48,80.1,48,119.7v208.9C48,368.2,82.2,400,124.3,400z"},"children":[]}]};exports.chatbox=chatbox;var chatboxes={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M294.1,365.5c-2.6-1.8-7.2-4.5-17.5-4.5H160.5c-34.7,0-64.5-26.1-64.5-59.2V201h-1.8C67.9,201,48,221.5,48,246.5v128.9\r\n\t\tc0,25,21.4,40.6,47.7,40.6H112v48l53.1-45c1.9-1.4,5.3-3,13.2-3h89.8c23,0,47.4-11.4,51.9-32L294.1,365.5z"},"children":[{"name":"path","attribs":{"d":"M294.1,365.5c-2.6-1.8-7.2-4.5-17.5-4.5H160.5c-34.7,0-64.5-26.1-64.5-59.2V201h-1.8C67.9,201,48,221.5,48,246.5v128.9\r\n\t\tc0,25,21.4,40.6,47.7,40.6H112v48l53.1-45c1.9-1.4,5.3-3,13.2-3h89.8c23,0,47.4-11.4,51.9-32L294.1,365.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M401,48H183.7C149,48,128,74.8,128,107.8v69.7V276c0,33.1,28,60,62.7,60h101.1c10.4,0,15,2.3,17.5,4.2L384,400v-64h17\r\n\t\tc34.8,0,63-26.9,63-59.9V107.8C464,74.8,435.8,48,401,48z"},"children":[{"name":"path","attribs":{"d":"M401,48H183.7C149,48,128,74.8,128,107.8v69.7V276c0,33.1,28,60,62.7,60h101.1c10.4,0,15,2.3,17.5,4.2L384,400v-64h17\r\n\t\tc34.8,0,63-26.9,63-59.9V107.8C464,74.8,435.8,48,401,48z"},"children":[]}]}]}]};exports.chatboxes=chatboxes;var chatbubbleWorking={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,449.4c28.9,0,56.4-5.7,81.3-15.9c0.6-0.3,1.1-0.5,1.7-0.7c0.1,0,0.2,0,0.2-0.1c3.5-1.3,7.3-2,11.2-2\r\n\tc4.3,0,8.4,0.8,12.1,2.4l84,30.9l-22.1-88.4c0-5.3,1.5-10.3,3.9-14.6c0,0,0,0,0,0c0.8-1.3,1.6-2.6,2.5-3.7\r\n\tc20.9-31.3,33-68.5,33-108.4C464,137.9,370.9,48,256,48C141.1,48,48,137.9,48,248.7C48,359.6,141.1,449.4,256,449.4z M352,224\r\n\tc17.7,0,32,14.3,32,32c0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C320,238.3,334.3,224,352,224z M256,224c17.7,0,32,14.3,32,32\r\n\tc0,17.7-14.3,32-32,32c-17.7,0-32-14.3-32-32C224,238.3,238.3,224,256,224z M160,224c17.7,0,32,14.3,32,32c0,17.7-14.3,32-32,32\r\n\tc-17.7,0-32-14.3-32-32C128,238.3,142.3,224,160,224z"},"children":[]}]};exports.chatbubbleWorking=chatbubbleWorking;var chatbubble={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,449.4c28.9,0,56.4-5.7,81.3-15.9c0.6-0.3,1.1-0.5,1.7-0.7c0.1,0,0.2,0,0.2-0.1c3.5-1.3,7.3-2,11.2-2\r\n\tc4.3,0,8.4,0.8,12.1,2.4l84,30.9l-22.1-88.4c0-5.3,1.5-10.3,3.9-14.6c0,0,0,0,0,0c0.8-1.3,1.6-2.6,2.5-3.7\r\n\tc20.9-31.3,33-68.5,33-108.4C464,137.9,370.9,48,256,48C141.1,48,48,137.9,48,248.7C48,359.6,141.1,449.4,256,449.4z"},"children":[]}]};exports.chatbubble=chatbubble;var chatbubbles={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M73.3,391C73.3,391,73.3,391,73.3,391c1.8,3,2.8,6.4,2.8,10.2L64,464l56.2-22.1c2.7-1.1,5.6-1.7,8.7-1.7\r\n\t\tc2.8,0,5.5,0.5,8,1.4c0,0,0.1,0,0.2,0c0.4,0.2,0.8,0.3,1.2,0.5c17.8,7.3,37.4,11.4,57.9,11.4c46.3,0,87.6-20.5,114.8-52.6\r\n\t\tc-14.1,3.6-28.9,5.7-44.1,5.7c-95.9,0-173.7-75-173.7-167.5c0-11.8,1.3-23.2,3.7-34.3C66.9,230.9,48,268.6,48,310.6\r\n\t\tc0,28.4,8.6,55.2,23.5,77.5C72.1,388.9,72.7,390,73.3,391z"},"children":[{"name":"path","attribs":{"d":"M73.3,391C73.3,391,73.3,391,73.3,391c1.8,3,2.8,6.4,2.8,10.2L64,464l56.2-22.1c2.7-1.1,5.6-1.7,8.7-1.7\r\n\t\tc2.8,0,5.5,0.5,8,1.4c0,0,0.1,0,0.2,0c0.4,0.2,0.8,0.3,1.2,0.5c17.8,7.3,37.4,11.4,57.9,11.4c46.3,0,87.6-20.5,114.8-52.6\r\n\t\tc-14.1,3.6-28.9,5.7-44.1,5.7c-95.9,0-173.7-75-173.7-167.5c0-11.8,1.3-23.2,3.7-34.3C66.9,230.9,48,268.6,48,310.6\r\n\t\tc0,28.4,8.6,55.2,23.5,77.5C72.1,388.9,72.7,390,73.3,391z"},"children":[]}]},{"name":"path","attribs":{"d":"M290.3,48c-83.7,0-153.6,57.2-170,133.2c-2.4,11.1-3.7,22.5-3.7,34.3c0,92.5,77.7,167.5,173.7,167.5\r\n\t\tc15.3,0,30-2.1,44.1-5.7c8.1-2.1,16.1-4.5,23.8-7.6c0.5-0.2,0.9-0.4,1.4-0.6c0.1,0,0.2,0,0.2-0.1c2.9-1.1,6.1-1.7,9.3-1.7\r\n\t\tc3.6,0,7,0.7,10.1,2l68.6,25.8l-17-73.8c0-4.4,1.2-8.6,3.3-12.2c0,0,0,0,0,0c0.6-1.1,1.4-2.1,2.1-3.1\r\n\t\tc17.4-26.1,27.5-57.2,27.5-90.5C464,123,386.3,48,290.3,48z"},"children":[{"name":"path","attribs":{"d":"M290.3,48c-83.7,0-153.6,57.2-170,133.2c-2.4,11.1-3.7,22.5-3.7,34.3c0,92.5,77.7,167.5,173.7,167.5\r\n\t\tc15.3,0,30-2.1,44.1-5.7c8.1-2.1,16.1-4.5,23.8-7.6c0.5-0.2,0.9-0.4,1.4-0.6c0.1,0,0.2,0,0.2-0.1c2.9-1.1,6.1-1.7,9.3-1.7\r\n\t\tc3.6,0,7,0.7,10.1,2l68.6,25.8l-17-73.8c0-4.4,1.2-8.6,3.3-12.2c0,0,0,0,0,0c0.6-1.1,1.4-2.1,2.1-3.1\r\n\t\tc17.4-26.1,27.5-57.2,27.5-90.5C464,123,386.3,48,290.3,48z"},"children":[]}]}]}]};exports.chatbubbles=chatbubbles;var checkmarkCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z\r\n\t\t M370.9,181.1L231.8,359.6c-1.1,1.1-2.9,3.5-5.1,3.5c-2.3,0-3.8-1.6-5.1-2.9c-1.3-1.3-78.9-75.9-78.9-75.9l-1.5-1.5\r\n\t\tc-0.6-0.9-1.1-2-1.1-3.2c0-1.2,0.5-2.3,1.1-3.2c0.4-0.4,0.7-0.7,1.1-1.2c7.7-8.1,23.3-24.5,24.3-25.5c1.3-1.3,2.4-3,4.8-3\r\n\t\tc2.5,0,4.1,2.1,5.3,3.3c1.2,1.2,45,43.3,45,43.3l111.3-143c1-0.8,2.2-1.4,3.5-1.4c1.3,0,2.5,0.5,3.5,1.3l30.6,24.1\r\n\t\tc0.8,1,1.3,2.2,1.3,3.5C372,179.1,371.5,180.2,370.9,181.1z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z\r\n\t\t M370.9,181.1L231.8,359.6c-1.1,1.1-2.9,3.5-5.1,3.5c-2.3,0-3.8-1.6-5.1-2.9c-1.3-1.3-78.9-75.9-78.9-75.9l-1.5-1.5\r\n\t\tc-0.6-0.9-1.1-2-1.1-3.2c0-1.2,0.5-2.3,1.1-3.2c0.4-0.4,0.7-0.7,1.1-1.2c7.7-8.1,23.3-24.5,24.3-25.5c1.3-1.3,2.4-3,4.8-3\r\n\t\tc2.5,0,4.1,2.1,5.3,3.3c1.2,1.2,45,43.3,45,43.3l111.3-143c1-0.8,2.2-1.4,3.5-1.4c1.3,0,2.5,0.5,3.5,1.3l30.6,24.1\r\n\t\tc0.8,1,1.3,2.2,1.3,3.5C372,179.1,371.5,180.2,370.9,181.1z"},"children":[]}]}]}]};exports.checkmarkCircled=checkmarkCircled;var checkmarkRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,71.9c-17.3-13.4-41.5-9.3-54.1,9.1L214,344.2l-99.1-107.3c-14.6-16.6-39.1-17.4-54.7-1.8\r\n\tc-15.6,15.5-16.4,41.6-1.7,58.1c0,0,120.4,133.6,137.7,147c17.3,13.4,41.5,9.3,54.1-9.1l206.3-301.7\r\n\tC469.2,110.9,465.3,85.2,448,71.9z"},"children":[]}]};exports.checkmarkRound=checkmarkRound;var checkmark={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M461.6,109.6l-54.9-43.3c-1.7-1.4-3.8-2.4-6.2-2.4c-2.4,0-4.6,1-6.3,2.5L194.5,323c0,0-78.5-75.5-80.7-77.7\r\n\tc-2.2-2.2-5.1-5.9-9.5-5.9c-4.4,0-6.4,3.1-8.7,5.4c-1.7,1.8-29.7,31.2-43.5,45.8c-0.8,0.9-1.3,1.4-2,2.1c-1.2,1.7-2,3.6-2,5.7\r\n\tc0,2.2,0.8,4,2,5.7l2.8,2.6c0,0,139.3,133.8,141.6,136.1c2.3,2.3,5.1,5.2,9.2,5.2c4,0,7.3-4.3,9.2-6.2L462,121.8\r\n\tc1.2-1.7,2-3.6,2-5.8C464,113.5,463,111.4,461.6,109.6z"},"children":[]}]};exports.checkmark=checkmark;var chevronDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,298.3L256,298.3L256,298.3l174.2-167.2c4.3-4.2,11.4-4.1,15.8,0.2l30.6,29.9c4.4,4.3,4.5,11.3,0.2,15.5L264.1,380.9\r\n\tc-2.2,2.2-5.2,3.2-8.1,3c-3,0.1-5.9-0.9-8.1-3L35.2,176.7c-4.3-4.2-4.2-11.2,0.2-15.5L66,131.3c4.4-4.3,11.5-4.4,15.8-0.2L256,298.3\r\n\tz"},"children":[]}]};exports.chevronDown=chevronDown;var chevronLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M213.7,256L213.7,256L213.7,256L380.9,81.9c4.2-4.3,4.1-11.4-0.2-15.8l-29.9-30.6c-4.3-4.4-11.3-4.5-15.5-0.2L131.1,247.9\r\n\tc-2.2,2.2-3.2,5.2-3,8.1c-0.1,3,0.9,5.9,3,8.1l204.2,212.7c4.2,4.3,11.2,4.2,15.5-0.2l29.9-30.6c4.3-4.4,4.4-11.5,0.2-15.8\r\n\tL213.7,256z"},"children":[]}]};exports.chevronLeft=chevronLeft;var chevronRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M298.3,256L298.3,256L298.3,256L131.1,81.9c-4.2-4.3-4.1-11.4,0.2-15.8l29.9-30.6c4.3-4.4,11.3-4.5,15.5-0.2l204.2,212.7\r\n\tc2.2,2.2,3.2,5.2,3,8.1c0.1,3-0.9,5.9-3,8.1L176.7,476.8c-4.2,4.3-11.2,4.2-15.5-0.2L131.3,446c-4.3-4.4-4.4-11.5-0.2-15.8\r\n\tL298.3,256z"},"children":[]}]};exports.chevronRight=chevronRight;var chevronUp={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,213.7L256,213.7L256,213.7l174.2,167.2c4.3,4.2,11.4,4.1,15.8-0.2l30.6-29.9c4.4-4.3,4.5-11.3,0.2-15.5L264.1,131.1\r\n\tc-2.2-2.2-5.2-3.2-8.1-3c-3-0.1-5.9,0.9-8.1,3L35.2,335.3c-4.3,4.2-4.2,11.2,0.2,15.5L66,380.7c4.4,4.3,11.5,4.4,15.8,0.2L256,213.7\r\n\tz"},"children":[]}]};exports.chevronUp=chevronUp;var clipboard={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M161,160.5h192c-1.688-20-9.729-35.45-27.921-40.356c-0.446-0.119-1.12-0.424-1.567-0.541\r\n\t\tc-12.004-3.424-21.012-7.653-21.012-20.781V78.227C302.5,52.691,281.976,32,256.49,32c-25.466,0-45.99,20.691-45.99,46.227v20.595\r\n\t\tc0,13.128-8.592,17.169-20.597,20.593c-0.447,0.117-0.8,0.61-1.266,0.729C170.446,125.05,162.927,140.5,161,160.5z M256.99,64.395\r\n\t\tc7.615,0,13.791,6.195,13.791,13.832c0,7.654-6.176,13.85-13.791,13.85c-7.614,0-13.772-6.195-13.772-13.85\r\n\t\tC243.218,70.59,249.376,64.395,256.99,64.395z"},"children":[{"name":"path","attribs":{"d":"M161,160.5h192c-1.688-20-9.729-35.45-27.921-40.356c-0.446-0.119-1.12-0.424-1.567-0.541\r\n\t\tc-12.004-3.424-21.012-7.653-21.012-20.781V78.227C302.5,52.691,281.976,32,256.49,32c-25.466,0-45.99,20.691-45.99,46.227v20.595\r\n\t\tc0,13.128-8.592,17.169-20.597,20.593c-0.447,0.117-0.8,0.61-1.266,0.729C170.446,125.05,162.927,140.5,161,160.5z M256.99,64.395\r\n\t\tc7.615,0,13.791,6.195,13.791,13.832c0,7.654-6.176,13.85-13.791,13.85c-7.614,0-13.772-6.195-13.772-13.85\r\n\t\tC243.218,70.59,249.376,64.395,256.99,64.395z"},"children":[]}]},{"name":"path","attribs":{"d":"M405.611,63.5H331.5v13.988c0,10.583,9.193,19.012,19.507,19.012h37.212c6.667,0,12.099,5.435,12.44,12.195l0.085,327.1\r\n\t\tc-0.322,6.432-5.303,11.546-11.514,12.017l-264.418,0.031c-6.211-0.471-11.149-5.695-11.472-12.126l-0.085-327.014\r\n\t\tc0.322-6.761,5.858-12.203,12.506-12.203h37.231c10.313,0,18.507-8.429,18.507-19.012V63.5h-73.131\r\n\t\tC93.25,63.5,80.5,76.058,80.5,91.575v360.38c0,15.502,12.75,28.545,27.869,28.545H256.99h148.621\r\n\t\tc15.138,0,26.889-13.043,26.889-28.545V91.575C432.5,76.058,420.749,63.5,405.611,63.5z"},"children":[{"name":"path","attribs":{"d":"M405.611,63.5H331.5v13.988c0,10.583,9.193,19.012,19.507,19.012h37.212c6.667,0,12.099,5.435,12.44,12.195l0.085,327.1\r\n\t\tc-0.322,6.432-5.303,11.546-11.514,12.017l-264.418,0.031c-6.211-0.471-11.149-5.695-11.472-12.126l-0.085-327.014\r\n\t\tc0.322-6.761,5.858-12.203,12.506-12.203h37.231c10.313,0,18.507-8.429,18.507-19.012V63.5h-73.131\r\n\t\tC93.25,63.5,80.5,76.058,80.5,91.575v360.38c0,15.502,12.75,28.545,27.869,28.545H256.99h148.621\r\n\t\tc15.138,0,26.889-13.043,26.889-28.545V91.575C432.5,76.058,420.749,63.5,405.611,63.5z"},"children":[]}]},{"name":"rect","attribs":{"x":"144.5","y":"192.5","width":"112","height":"32"},"children":[{"name":"rect","attribs":{"x":"144.5","y":"192.5","width":"112","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144.5","y":"384.5","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"144.5","y":"384.5","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144.5","y":"320.5","width":"129","height":"32"},"children":[{"name":"rect","attribs":{"x":"144.5","y":"320.5","width":"129","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144.5","y":"256.5","width":"208","height":"32"},"children":[{"name":"rect","attribs":{"x":"144.5","y":"256.5","width":"208","height":"32"},"children":[]}]}]}]};exports.clipboard=clipboard;var clock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255.988,32C132.285,32,32,132.298,32,256c0,123.715,100.285,224,223.988,224C379.703,480,480,379.715,480,256\r\n\t\tC480,132.298,379.703,32,255.988,32z M391.761,391.765c-10.099,10.098-21.126,18.928-32.886,26.42l-15.946-27.62l-13.856,8\r\n\t\tl15.955,27.636c-24.838,13.03-52.372,20.455-81.027,21.624V416h-16v31.825c-28.656-1.166-56.191-8.59-81.03-21.62l15.958-27.641\r\n\t\tl-13.856-8l-15.949,27.625c-11.761-7.492-22.79-16.324-32.889-26.424c-10.099-10.099-18.93-21.127-26.422-32.889l27.624-15.949\r\n\t\tl-8-13.855L85.796,345.03c-13.03-24.839-20.454-52.374-21.621-81.03H96v-16H64.175c1.167-28.655,8.592-56.19,21.623-81.029\r\n\t\tl27.638,15.958l8-13.856l-27.623-15.948c7.492-11.76,16.322-22.787,26.419-32.885c10.1-10.101,21.129-18.933,32.89-26.426\r\n\t\tl15.949,27.624l13.856-8l-15.958-27.64C191.81,72.765,219.345,65.34,248,64.175V96h16V64.176\r\n\t\tc28.654,1.169,56.188,8.595,81.026,21.626l-15.954,27.634l13.856,8l15.945-27.618c11.76,7.492,22.787,16.323,32.886,26.421\r\n\t\tc10.1,10.099,18.931,21.126,26.424,32.887l-27.619,15.946l8,13.856l27.636-15.956c13.031,24.839,20.457,52.373,21.624,81.027H416\r\n\t\tv16h31.824c-1.167,28.655-8.592,56.189-21.622,81.028l-27.637-15.957l-8,13.856l27.621,15.947\r\n\t\tC410.693,370.637,401.861,381.665,391.761,391.765z"},"children":[{"name":"path","attribs":{"d":"M255.988,32C132.285,32,32,132.298,32,256c0,123.715,100.285,224,223.988,224C379.703,480,480,379.715,480,256\r\n\t\tC480,132.298,379.703,32,255.988,32z M391.761,391.765c-10.099,10.098-21.126,18.928-32.886,26.42l-15.946-27.62l-13.856,8\r\n\t\tl15.955,27.636c-24.838,13.03-52.372,20.455-81.027,21.624V416h-16v31.825c-28.656-1.166-56.191-8.59-81.03-21.62l15.958-27.641\r\n\t\tl-13.856-8l-15.949,27.625c-11.761-7.492-22.79-16.324-32.889-26.424c-10.099-10.099-18.93-21.127-26.422-32.889l27.624-15.949\r\n\t\tl-8-13.855L85.796,345.03c-13.03-24.839-20.454-52.374-21.621-81.03H96v-16H64.175c1.167-28.655,8.592-56.19,21.623-81.029\r\n\t\tl27.638,15.958l8-13.856l-27.623-15.948c7.492-11.76,16.322-22.787,26.419-32.885c10.1-10.101,21.129-18.933,32.89-26.426\r\n\t\tl15.949,27.624l13.856-8l-15.958-27.64C191.81,72.765,219.345,65.34,248,64.175V96h16V64.176\r\n\t\tc28.654,1.169,56.188,8.595,81.026,21.626l-15.954,27.634l13.856,8l15.945-27.618c11.76,7.492,22.787,16.323,32.886,26.421\r\n\t\tc10.1,10.099,18.931,21.126,26.424,32.887l-27.619,15.946l8,13.856l27.636-15.956c13.031,24.839,20.457,52.373,21.624,81.027H416\r\n\t\tv16h31.824c-1.167,28.655-8.592,56.189-21.622,81.028l-27.637-15.957l-8,13.856l27.621,15.947\r\n\t\tC410.693,370.637,401.861,381.665,391.761,391.765z"},"children":[]}]},{"name":"path","attribs":{"d":"M400,241H284.268c-2.818-5.299-7.083-9.708-12.268-12.708V160h-32v68.292c-9.562,5.534-16,15.866-16,27.708\r\n\t\tc0,17.673,14.327,32,32,32c11.425,0,21.444-5.992,27.106-15H400V241z"},"children":[{"name":"path","attribs":{"d":"M400,241H284.268c-2.818-5.299-7.083-9.708-12.268-12.708V160h-32v68.292c-9.562,5.534-16,15.866-16,27.708\r\n\t\tc0,17.673,14.327,32,32,32c11.425,0,21.444-5.992,27.106-15H400V241z"},"children":[]}]}]}]};exports.clock=clock;var closeCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,33C132.3,33,32,133.3,32,257c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,133.3,379.7,33,256,33z\r\n\t\t M364.3,332.5c1.5,1.5,2.3,3.5,2.3,5.6c0,2.1-0.8,4.2-2.3,5.6l-21.6,21.7c-1.6,1.6-3.6,2.3-5.6,2.3c-2,0-4.1-0.8-5.6-2.3L256,289.8\r\n\t\tl-75.4,75.7c-1.5,1.6-3.6,2.3-5.6,2.3c-2,0-4.1-0.8-5.6-2.3l-21.6-21.7c-1.5-1.5-2.3-3.5-2.3-5.6c0-2.1,0.8-4.2,2.3-5.6l75.7-76\r\n\t\tl-75.9-75c-3.1-3.1-3.1-8.2,0-11.3l21.6-21.7c1.5-1.5,3.5-2.3,5.6-2.3c2.1,0,4.1,0.8,5.6,2.3l75.7,74.7l75.7-74.7\r\n\t\tc1.5-1.5,3.5-2.3,5.6-2.3c2.1,0,4.1,0.8,5.6,2.3l21.6,21.7c3.1,3.1,3.1,8.2,0,11.3l-75.9,75L364.3,332.5z"},"children":[{"name":"path","attribs":{"d":"M256,33C132.3,33,32,133.3,32,257c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,133.3,379.7,33,256,33z\r\n\t\t M364.3,332.5c1.5,1.5,2.3,3.5,2.3,5.6c0,2.1-0.8,4.2-2.3,5.6l-21.6,21.7c-1.6,1.6-3.6,2.3-5.6,2.3c-2,0-4.1-0.8-5.6-2.3L256,289.8\r\n\t\tl-75.4,75.7c-1.5,1.6-3.6,2.3-5.6,2.3c-2,0-4.1-0.8-5.6-2.3l-21.6-21.7c-1.5-1.5-2.3-3.5-2.3-5.6c0-2.1,0.8-4.2,2.3-5.6l75.7-76\r\n\t\tl-75.9-75c-3.1-3.1-3.1-8.2,0-11.3l21.6-21.7c1.5-1.5,3.5-2.3,5.6-2.3c2.1,0,4.1,0.8,5.6,2.3l75.7,74.7l75.7-74.7\r\n\t\tc1.5-1.5,3.5-2.3,5.6-2.3c2.1,0,4.1,0.8,5.6,2.3l21.6,21.7c3.1,3.1,3.1,8.2,0,11.3l-75.9,75L364.3,332.5z"},"children":[]}]}]}]};exports.closeCircled=closeCircled;var closeRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M437.5,386.6L306.9,256l130.6-130.6c14.1-14.1,14.1-36.8,0-50.9c-14.1-14.1-36.8-14.1-50.9,0L256,205.1L125.4,74.5\r\n\tc-14.1-14.1-36.8-14.1-50.9,0c-14.1,14.1-14.1,36.8,0,50.9L205.1,256L74.5,386.6c-14.1,14.1-14.1,36.8,0,50.9\r\n\tc14.1,14.1,36.8,14.1,50.9,0L256,306.9l130.6,130.6c14.1,14.1,36.8,14.1,50.9,0C451.5,423.4,451.5,400.6,437.5,386.6z"},"children":[]}]};exports.closeRound=closeRound;var close={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M443.6,387.1L312.4,255.4l131.5-130c5.4-5.4,5.4-14.2,0-19.6l-37.4-37.6c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4\r\n\tL256,197.8L124.9,68.3c-2.6-2.6-6.1-4-9.8-4c-3.7,0-7.2,1.5-9.8,4L68,105.9c-5.4,5.4-5.4,14.2,0,19.6l131.5,130L68.4,387.1\r\n\tc-2.6,2.6-4.1,6.1-4.1,9.8c0,3.7,1.4,7.2,4.1,9.8l37.4,37.6c2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1L256,313.1l130.7,131.1\r\n\tc2.7,2.7,6.2,4.1,9.8,4.1c3.5,0,7.1-1.3,9.8-4.1l37.4-37.6c2.6-2.6,4.1-6.1,4.1-9.8C447.7,393.2,446.2,389.7,443.6,387.1z"},"children":[]}]};exports.close=close;var closedCaptioning={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M0,64v384h512V64H0z M464,255.825c0.045,26.724-1.547,47.143-3.797,80.223S441,392.5,401.097,396.168\r\n\t\t\tC361.201,399.835,305.369,400.12,256,400c-49,0.12-105.198-0.165-145.094-3.832c-39.903-3.668-56.855-27.04-59.105-60.12\r\n\t\t\ts-3.841-53.499-3.796-80.223c-0.045-26.725,0.095-44.124,3.798-80.224s23.01-56.267,59.106-59.934S201.842,112,248.704,112\r\n\t\t\tc2.431,0,5.296,0,7.296,0c2.437,0,4.871,0,7.302,0c46.862,0,101.698,0,137.795,3.667s55.403,23.833,59.106,59.934\r\n\t\t\tS464.045,229.1,464,255.825z"},"children":[{"name":"path","attribs":{"d":"M0,64v384h512V64H0z M464,255.825c0.045,26.724-1.547,47.143-3.797,80.223S441,392.5,401.097,396.168\r\n\t\t\tC361.201,399.835,305.369,400.12,256,400c-49,0.12-105.198-0.165-145.094-3.832c-39.903-3.668-56.855-27.04-59.105-60.12\r\n\t\t\ts-3.841-53.499-3.796-80.223c-0.045-26.725,0.095-44.124,3.798-80.224s23.01-56.267,59.106-59.934S201.842,112,248.704,112\r\n\t\t\tc2.431,0,5.296,0,7.296,0c2.437,0,4.871,0,7.302,0c46.862,0,101.698,0,137.795,3.667s55.403,23.833,59.106,59.934\r\n\t\t\tS464.045,229.1,464,255.825z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M372,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566\r\n\t\t\tc0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566\r\n\t\t\tc15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746\r\n\t\t\tc-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291\r\n\t\t\tc-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488\r\n\t\t\tc3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748\r\n\t\t\tc28.604,0,49.089-7.258,61.443-21.318C418.486,327.537,424.666,307,424.666,280H372C372,280,372,282.876,372,283.846z"},"children":[{"name":"path","attribs":{"d":"M372,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566\r\n\t\t\tc0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566\r\n\t\t\tc15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746\r\n\t\t\tc-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291\r\n\t\t\tc-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488\r\n\t\t\tc3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748\r\n\t\t\tc28.604,0,49.089-7.258,61.443-21.318C418.486,327.537,424.666,307,424.666,280H372C372,280,372,282.876,372,283.846z"},"children":[]}]},{"name":"path","attribs":{"d":"M195,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566\r\n\t\t\tc0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566\r\n\t\t\tc15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746\r\n\t\t\tc-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291\r\n\t\t\tc-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488\r\n\t\t\tc3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748\r\n\t\t\tc28.604,0,49.089-7.258,61.443-21.318C241.486,327.537,247.666,307,247.666,280H195C195,280,195,282.876,195,283.846z"},"children":[{"name":"path","attribs":{"d":"M195,283.846v0.766c0,18.639-11.581,29.566-27.003,29.566c-15.418,0-25.808-12.309-27.284-29.566\r\n\t\t\tc0,0-1.335-9.078-1.335-27.298s1.546-29.759,1.546-29.759c2.711-19.473,12.188-29.566,27.607-29.566\r\n\t\t\tc15.367,0,27.584,13.262,27.584,33.388c0.023,0.086,0.01,0.624,0.01,0.624h51.541c0-25-6.309-47.556-18.92-61.746\r\n\t\t\tc-12.617-14.183-31.403-21.273-56.369-21.273c-12.483,0-23.93,1.654-34.33,4.942c-10.404,3.295-19.376,9.062-26.916,17.291\r\n\t\t\tc-7.545,8.234-13.397,19.254-17.555,33.059c-4.162,13.809-6.242,31.224-6.242,52.247c0,20.52,1.688,37.684,5.072,51.488\r\n\t\t\tc3.377,13.811,8.388,24.83,15.018,33.059c6.632,8.234,14.953,13.935,24.967,17.1c10.01,3.163,21.779,4.748,35.304,4.748\r\n\t\t\tc28.604,0,49.089-7.258,61.443-21.318C241.486,327.537,247.666,307,247.666,280H195C195,280,195,282.876,195,283.846z"},"children":[]}]}]}]}]}]};exports.closedCaptioning=closedCaptioning;var cloud={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M398.1,233.2c0-1.2,0.2-2.4,0.2-3.6c0-65-51.8-117.6-115.7-117.6c-46.1,0-85.7,27.4-104.3,67c-8.1-4.1-17.2-6.5-26.8-6.5\r\n\tc-29.5,0-54.1,21.9-58.8,50.5C57.3,235.2,32,269.1,32,309c0,50.2,40.1,90.9,89.5,91h276.7l0,0c45.2-0.2,81.7-37.5,81.7-83.4\r\n\tC480,270.6,443.3,233.3,398.1,233.2z"},"children":[]}]};exports.cloud=cloud;var codeDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M330.967,284.104c6.48-6.467,6.48-16.951,0-23.422c-6.48-6.467-17.342-6.467-23.823,0L272,295.432V176.58\r\n\t\t\t\tc0-9.151-6.839-16.56-15.999-16.56c-9.162,0-16.001,7.408-16.001,16.56v118.852l-35.005-34.75\r\n\t\t\t\tc-6.481-6.467-17.095-6.467-23.573,0c-6.482,6.471-6.539,16.955-0.057,23.422l63.07,63.023c0.02,0.02,0.028,0.037,0.05,0.057\r\n\t\t\t\tc0.725,0.716,1.513,1.367,2.368,1.945c0.102,0.067,0.2,0.134,0.302,0.2c0.322,0.206,0.651,0.403,0.99,0.587\r\n\t\t\t\tc0.117,0.064,0.231,0.133,0.35,0.193c0.421,0.218,0.849,0.423,1.292,0.605c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc0.405,0.167,0.817,0.308,1.233,0.442c0.112,0.037,0.222,0.085,0.335,0.118c0.151,0.047,0.307,0.074,0.461,0.115\r\n\t\t\t\tc1.424,0.385,2.872,0.588,4.315,0.588c1.442,0,2.89-0.203,4.312-0.588c0.153-0.041,0.312-0.068,0.464-0.115\r\n\t\t\t\tc0.113-0.033,0.224-0.081,0.335-0.118c0.416-0.135,0.829-0.275,1.233-0.442c0.002-0.001,0.004-0.001,0.007-0.002\r\n\t\t\t\tc0.441-0.183,0.87-0.387,1.289-0.604c0.122-0.064,0.24-0.133,0.36-0.198c0.332-0.185,0.658-0.376,0.975-0.579\r\n\t\t\t\tc0.109-0.069,0.217-0.14,0.323-0.212c0.408-0.274,0.806-0.562,1.184-0.872c0.004-0.002,0.007-0.004,0.011-0.006\r\n\t\t\t\tc0.406-0.332,0.791-0.684,1.162-1.051c0.024-0.022,0.051-0.043,0.074-0.066L330.967,284.104z"},"children":[{"name":"path","attribs":{"d":"M330.967,284.104c6.48-6.467,6.48-16.951,0-23.422c-6.48-6.467-17.342-6.467-23.823,0L272,295.432V176.58\r\n\t\t\t\tc0-9.151-6.839-16.56-15.999-16.56c-9.162,0-16.001,7.408-16.001,16.56v118.852l-35.005-34.75\r\n\t\t\t\tc-6.481-6.467-17.095-6.467-23.573,0c-6.482,6.471-6.539,16.955-0.057,23.422l63.07,63.023c0.02,0.02,0.028,0.037,0.05,0.057\r\n\t\t\t\tc0.725,0.716,1.513,1.367,2.368,1.945c0.102,0.067,0.2,0.134,0.302,0.2c0.322,0.206,0.651,0.403,0.99,0.587\r\n\t\t\t\tc0.117,0.064,0.231,0.133,0.35,0.193c0.421,0.218,0.849,0.423,1.292,0.605c0.002,0.001,0.004,0.001,0.006,0.002\r\n\t\t\t\tc0.405,0.167,0.817,0.308,1.233,0.442c0.112,0.037,0.222,0.085,0.335,0.118c0.151,0.047,0.307,0.074,0.461,0.115\r\n\t\t\t\tc1.424,0.385,2.872,0.588,4.315,0.588c1.442,0,2.89-0.203,4.312-0.588c0.153-0.041,0.312-0.068,0.464-0.115\r\n\t\t\t\tc0.113-0.033,0.224-0.081,0.335-0.118c0.416-0.135,0.829-0.275,1.233-0.442c0.002-0.001,0.004-0.001,0.007-0.002\r\n\t\t\t\tc0.441-0.183,0.87-0.387,1.289-0.604c0.122-0.064,0.24-0.133,0.36-0.198c0.332-0.185,0.658-0.376,0.975-0.579\r\n\t\t\t\tc0.109-0.069,0.217-0.14,0.323-0.212c0.408-0.274,0.806-0.562,1.184-0.872c0.004-0.002,0.007-0.004,0.011-0.006\r\n\t\t\t\tc0.406-0.332,0.791-0.684,1.162-1.051c0.024-0.022,0.051-0.043,0.074-0.066L330.967,284.104z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\t\tc9.371,9.372,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\t\tc9.371,9.372,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[]}]},{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\t\tc-9.371,9.372-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\t\tc-9.371,9.372-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[]}]}]}]}]}]};exports.codeDownload=codeDownload;var codeWorking={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"184.166","cy":"256.166","r":"24"},"children":[{"name":"circle","attribs":{"cx":"184.166","cy":"256.166","r":"24"},"children":[]}]},{"name":"circle","attribs":{"cx":"256.166","cy":"256.166","r":"24"},"children":[{"name":"circle","attribs":{"cx":"256.166","cy":"256.166","r":"24"},"children":[]}]},{"name":"circle","attribs":{"cx":"328.166","cy":"256.166","r":"24"},"children":[{"name":"circle","attribs":{"cx":"328.166","cy":"256.166","r":"24"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\t\tc9.371,9.372,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\t\tc9.371,9.372,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[]}]},{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\t\tc-9.371,9.372-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\t\tc-9.371,9.372-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[]}]}]}]}]}]};exports.codeWorking=codeWorking;var code={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\tc9.371,9.373,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[{"name":"path","attribs":{"d":"M168,392c-6.143,0-12.285-2.344-16.971-7.029l-112-112c-9.373-9.373-9.373-24.569,0-33.941l112-112\r\n\t\tc9.373-9.372,24.568-9.372,33.941,0c9.371,9.372,9.371,24.568,0,33.941L89.941,256l95.029,95.029\r\n\t\tc9.371,9.373,9.371,24.568,0,33.941C180.283,389.656,174.143,392,168,392z"},"children":[]}]},{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\tc-9.371,9.373-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[{"name":"path","attribs":{"d":"M344,392c6.143,0,12.285-2.344,16.971-7.029l112-112c9.373-9.373,9.373-24.569,0-33.941l-112-112\r\n\t\tc-9.373-9.372-24.568-9.372-33.941,0c-9.371,9.372-9.371,24.568,0,33.941L422.059,256l-95.029,95.029\r\n\t\tc-9.371,9.373-9.371,24.568,0,33.941C331.717,389.656,337.857,392,344,392z"},"children":[]}]}]}]};exports.code=code;var coffee={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M383.1,257.4c0.6-5.4,0.9-10,0.9-13.8c0-19.6-3.3-19.7-16-19.7h-75.5c7.3-12,11.5-24.4,11.5-37c0-37.9-57.3-56.4-57.3-88\r\n\tc0-11.7,5.1-21.3,9.3-34.9c-26.5,7-47.4,33.5-47.4,61.6c0,48.3,56.3,48.7,56.3,84.8c0,4.5-1.4,8.5-2.1,13.5h-55.9\r\n\tc0.8-3,1.3-6.2,1.3-9.3c0-22.8-39.1-33.9-39.1-52.8c0-7,1-12.8,3.2-21c-12.9,5.1-28.3,20-28.3,36.8c0,26.7,31.9,29.3,36.8,46.3H80\r\n\tc-12.7,0-16,0.1-16,19.7c0,19.6,7.7,61.3,28.3,111c20.6,49.7,44.4,71.6,61.2,86.2l0.1-0.2c5.1,4.6,11.8,7.3,19.2,7.3h102.4\r\n\tc7.4,0,14.1-2.7,19.2-7.3l0.1,0.2c9-7.8,20-17.8,31.4-32.9c4.7,2,9.8,3.7,15.4,5c8.4,2,16.8,3,24.8,3c24,0,45.6-9.2,60.8-25.8\r\n\tc13.4-14.6,21.1-34.4,21.1-54.2C448,297,420,264.5,383.1,257.4z M366.1,384.2c-8.6,0-15.6-1.2-22.1-4.2c4-8,7.9-15.9,11.7-25.1\r\n\tc10.1-24.4,17.1-47,21.6-65.8c22,4.3,38.7,23.8,38.7,47.1C416,358.9,398.8,384.2,366.1,384.2z"},"children":[]}]};exports.coffee=coffee;var compass={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32c-39,0-75.6,10-107.5,27.4C136.9,42.9,117.7,32,96,32c-35.3,0-64,28.7-64,64c0,21.7,10.9,40.9,27.4,52.5\r\n\t\t\tC42,180.4,32,217,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z M64,96\r\n\t\t\tc0-17.7,14.3-32,32-32c10.5,0,19.8,5,25.6,12.8c-17,12.7-32.1,27.8-44.8,44.8C69,115.8,64,106.5,64,96z M391.8,391.8\r\n\t\t\tC355.5,428,307.3,448,256,448c-51.3,0-99.5-20-135.8-56.2C84,355.5,64,307.3,64,256c0-51.3,20-99.5,56.2-135.8\r\n\t\t\tC156.5,84,204.7,64,256,64c51.3,0,99.5,20,135.8,56.2C428,156.5,448,204.7,448,256C448,307.3,428,355.5,391.8,391.8z"},"children":[{"name":"path","attribs":{"d":"M256,32c-39,0-75.6,10-107.5,27.4C136.9,42.9,117.7,32,96,32c-35.3,0-64,28.7-64,64c0,21.7,10.9,40.9,27.4,52.5\r\n\t\t\tC42,180.4,32,217,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z M64,96\r\n\t\t\tc0-17.7,14.3-32,32-32c10.5,0,19.8,5,25.6,12.8c-17,12.7-32.1,27.8-44.8,44.8C69,115.8,64,106.5,64,96z M391.8,391.8\r\n\t\t\tC355.5,428,307.3,448,256,448c-51.3,0-99.5-20-135.8-56.2C84,355.5,64,307.3,64,256c0-51.3,20-99.5,56.2-135.8\r\n\t\t\tC156.5,84,204.7,64,256,64c51.3,0,99.5,20,135.8,56.2C428,156.5,448,204.7,448,256C448,307.3,428,355.5,391.8,391.8z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M352,128c0,0-101.6,83.7-120,104s-72,152-72,152s102.4-82.3,120-104S352,128,352,128z"},"children":[{"name":"path","attribs":{"d":"M352,128c0,0-101.6,83.7-120,104s-72,152-72,152s102.4-82.3,120-104S352,128,352,128z"},"children":[]}]}]}]};exports.compass=compass;var compose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M442.8,99.6l-30.4-30.4c-7-6.9-18.2-6.9-25.1,0L355.5,101l55.5,55.5l31.8-31.7C449.7,117.7,449.7,106.5,442.8,99.6z"},"children":[{"name":"path","attribs":{"d":"M442.8,99.6l-30.4-30.4c-7-6.9-18.2-6.9-25.1,0L355.5,101l55.5,55.5l31.8-31.7C449.7,117.7,449.7,106.5,442.8,99.6z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"346.1,110.5 174.1,288 160,352 224,337.9 400.6,164.9 \t\t"},"children":[{"name":"polygon","attribs":{"points":"346.1,110.5 174.1,288 160,352 224,337.9 400.6,164.9 \t\t"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M384,256v150c0,5.1-3.9,10.1-9.2,10.1s-269-0.1-269-0.1c-5.6,0-9.8-5.4-9.8-10s0-268,0-268c0-5,4.7-10,10.6-10H256l32-32\r\n\t\tH87.4c-13,0-23.4,10.3-23.4,23.3v305.3c0,12.9,10.5,23.4,23.4,23.4h305.3c12.9,0,23.3-10.5,23.3-23.4V224L384,256z"},"children":[{"name":"path","attribs":{"d":"M384,256v150c0,5.1-3.9,10.1-9.2,10.1s-269-0.1-269-0.1c-5.6,0-9.8-5.4-9.8-10s0-268,0-268c0-5,4.7-10,10.6-10H256l32-32\r\n\t\tH87.4c-13,0-23.4,10.3-23.4,23.3v305.3c0,12.9,10.5,23.4,23.4,23.4h305.3c12.9,0,23.3-10.5,23.3-23.4V224L384,256z"},"children":[]}]}]}]};exports.compose=compose;var connectionBars={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"80","y":"352","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"80","y":"352","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"288","width":"64","height":"128"},"children":[{"name":"rect","attribs":{"x":"176","y":"288","width":"64","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"192","width":"64","height":"224"},"children":[{"name":"rect","attribs":{"x":"272","y":"192","width":"64","height":"224"},"children":[]}]},{"name":"rect","attribs":{"x":"368","y":"96","width":"64","height":"320"},"children":[{"name":"rect","attribs":{"x":"368","y":"96","width":"64","height":"320"},"children":[]}]}]}]};exports.connectionBars=connectionBars;var contrast={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z\r\n\t M391.8,391.8C355.5,428,307,448,256,448V64c51,0,99.5,20,135.8,56.2C428,156.5,448,204.7,448,256C448,307.3,428,355.5,391.8,391.8z\r\n\t"},"children":[]}]};exports.contrast=contrast;var crop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"352","y":"432","width":"64","height":"48"},"children":[{"name":"rect","attribs":{"x":"352","y":"432","width":"64","height":"48"},"children":[]}]},{"name":"polygon","attribs":{"points":"416,352 416,96 176,96 176,160 352,160 352,352 160,352 160,32 96,32 96,96 32,96 32,160 96,160 96,416 480,416 \r\n\t\t480,352 \t"},"children":[{"name":"polygon","attribs":{"points":"416,352 416,96 176,96 176,160 352,160 352,352 160,352 160,32 96,32 96,96 32,96 32,160 96,160 96,416 480,416 \r\n\t\t480,352 \t"},"children":[]}]}]}]};exports.crop=crop;var cube={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M467.301,168.084c-1.805,0-3.516,0.329-5.07,0.962l-2.281,1.15l-171.475,88.938l-3.888,1.996c0,0-0.052,0.023-0.052,0.047\r\n\t\tc-7.56,4.668-12.535,12.506-12.535,21.425v185.854c0,6.382,5.649,11.544,12.69,11.544c2.178,0,4.251-0.513,6.065-1.404\r\n\t\tc0.155-0.095,0.363-0.188,0.519-0.282l174.731-92.694l0.259-0.141c8.241-4.504,13.735-12.742,13.735-22.105V179.582\r\n\t\tC480,173.223,474.299,168.084,467.301,168.084z"},"children":[{"name":"path","attribs":{"d":"M467.301,168.084c-1.805,0-3.516,0.329-5.07,0.962l-2.281,1.15l-171.475,88.938l-3.888,1.996c0,0-0.052,0.023-0.052,0.047\r\n\t\tc-7.56,4.668-12.535,12.506-12.535,21.425v185.854c0,6.382,5.649,11.544,12.69,11.544c2.178,0,4.251-0.513,6.065-1.404\r\n\t\tc0.155-0.095,0.363-0.188,0.519-0.282l174.731-92.694l0.259-0.141c8.241-4.504,13.735-12.742,13.735-22.105V179.582\r\n\t\tC480,173.223,474.299,168.084,467.301,168.084z"},"children":[]}]},{"name":"path","attribs":{"d":"M454.273,118.521l-181.7-81.731c0,0-10.659-4.79-16.577-4.79s-16.526,4.79-16.526,4.79L57.614,118.521\r\n\t\tc0,0-7.989,3.292-7.989,9.479c0,6.562,8.3,11.5,8.3,11.5l182.582,96.371l2.902,1.479c3.784,1.687,8.077,2.649,12.587,2.649\r\n\t\tc4.561,0,8.915-0.963,12.742-2.696l2.539-1.315l182.893-96.536c0,0,7.508-4.036,7.508-11.453\r\n\t\tC461.678,121.5,454.273,118.521,454.273,118.521z"},"children":[{"name":"path","attribs":{"d":"M454.273,118.521l-181.7-81.731c0,0-10.659-4.79-16.577-4.79s-16.526,4.79-16.526,4.79L57.614,118.521\r\n\t\tc0,0-7.989,3.292-7.989,9.479c0,6.562,8.3,11.5,8.3,11.5l182.582,96.371l2.902,1.479c3.784,1.687,8.077,2.649,12.587,2.649\r\n\t\tc4.561,0,8.915-0.963,12.742-2.696l2.539-1.315l182.893-96.536c0,0,7.508-4.036,7.508-11.453\r\n\t\tC461.678,121.5,454.273,118.521,454.273,118.521z"},"children":[]}]},{"name":"path","attribs":{"d":"M227.466,261.178l-3.992-2.043L52.042,170.197l-2.28-1.15c-1.495-0.634-3.258-0.962-5.071-0.962\r\n\t\tc-6.997,0-12.69,5.138-12.69,11.497v183.792c0,9.388,5.485,17.602,13.727,22.105l0.208,0.141l174.739,92.694l0,0\r\n\t\tc1.918,1.08,4.199,1.687,6.636,1.687c6.989,0,12.69-5.162,12.69-11.544V282.603C240,273.684,235.024,265.846,227.466,261.178z"},"children":[{"name":"path","attribs":{"d":"M227.466,261.178l-3.992-2.043L52.042,170.197l-2.28-1.15c-1.495-0.634-3.258-0.962-5.071-0.962\r\n\t\tc-6.997,0-12.69,5.138-12.69,11.497v183.792c0,9.388,5.485,17.602,13.727,22.105l0.208,0.141l174.739,92.694l0,0\r\n\t\tc1.918,1.08,4.199,1.687,6.636,1.687c6.989,0,12.69-5.162,12.69-11.544V282.603C240,273.684,235.024,265.846,227.466,261.178z"},"children":[]}]}]}]};exports.cube=cube;var disc={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,158.9c-53.7,0-97.2,43.5-97.2,97.2c0,53.7,43.5,97.1,97.2,97.1c53.7,0,97.2-43.5,97.2-97.1\r\n\t\tC353.2,202.4,309.7,158.9,256,158.9z M256,299.5c-24,0-43.5-19.5-43.5-43.5c0-24,19.5-43.5,43.5-43.5c24,0,43.5,19.5,43.5,43.5\r\n\t\tC299.5,280,280,299.5,256,299.5z"},"children":[{"name":"path","attribs":{"d":"M256,158.9c-53.7,0-97.2,43.5-97.2,97.2c0,53.7,43.5,97.1,97.2,97.1c53.7,0,97.2-43.5,97.2-97.1\r\n\t\tC353.2,202.4,309.7,158.9,256,158.9z M256,299.5c-24,0-43.5-19.5-43.5-43.5c0-24,19.5-43.5,43.5-43.5c24,0,43.5,19.5,43.5,43.5\r\n\t\tC299.5,280,280,299.5,256,299.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224s224-100.3,224-224C480,132.3,379.7,32,256,32z M256,378.8\r\n\t\tc-67.8,0-122.8-55-122.8-122.8c0-67.8,55-122.8,122.8-122.8c67.8,0,122.8,55,122.8,122.8C378.8,323.8,323.8,378.8,256,378.8z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224s224-100.3,224-224C480,132.3,379.7,32,256,32z M256,378.8\r\n\t\tc-67.8,0-122.8-55-122.8-122.8c0-67.8,55-122.8,122.8-122.8c67.8,0,122.8,55,122.8,122.8C378.8,323.8,323.8,378.8,256,378.8z"},"children":[]}]}]}]};exports.disc=disc;var documentText={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M398.6,169.2c-0.9-2.2-2-4.3-3.5-6.1l-83.8-91.7c-1.9-2.1-4.2-3.6-6.7-4.9c-2.9-1.5-6.1-2.1-9.5-2.1H135.2\r\n\t\tc-12.4,0-22.7,10.6-22.7,23.9v335.2c0,13.4,10.3,24.9,22.7,24.9h243.1c12.4,0,22.2-11.5,22.2-24.9V179.4\r\n\t\tC400.5,175.8,400,172.3,398.6,169.2z M160.5,178.6c0-1.5,1.8-2.1,3.4-2.1h70.8c1.6,0,2.8,0.6,2.8,2.1v10.8c0,1.4-1.1,3.1-2.8,3.1\r\n\t\th-70.8c-1.6,0-3.4-1.7-3.4-3.1V178.6z M160.5,306.6c0-1.5,1.8-2.1,3.4-2.1h122.2c1.6,0,2.4,0.6,2.4,2.1v10.8c0,1.4-0.7,3.1-2.4,3.1\r\n\t\tH163.9c-1.6,0-3.4-1.7-3.4-3.1V306.6z M320.5,381.4c0,1.4-0.7,3.1-2.4,3.1H163.9c-1.6,0-3.4-1.7-3.4-3.1v-10.8\r\n\t\tc0-1.5,1.8-2.1,3.4-2.1h154.2c1.6,0,2.4,0.6,2.4,2.1V381.4z M352.5,253.4c0,1.4-0.7,3.1-2.4,3.1H163.9c-1.6,0-3.4-1.7-3.4-3.1\r\n\t\tv-10.8c0-1.5,1.8-2.1,3.4-2.1h186.2c1.6,0,2.4,0.6,2.4,2.1V253.4z M305.6,177.5c-5.6,0-11.1-5.2-11.1-11.3v-66l71.2,77.3H305.6z"},"children":[{"name":"path","attribs":{"d":"M398.6,169.2c-0.9-2.2-2-4.3-3.5-6.1l-83.8-91.7c-1.9-2.1-4.2-3.6-6.7-4.9c-2.9-1.5-6.1-2.1-9.5-2.1H135.2\r\n\t\tc-12.4,0-22.7,10.6-22.7,23.9v335.2c0,13.4,10.3,24.9,22.7,24.9h243.1c12.4,0,22.2-11.5,22.2-24.9V179.4\r\n\t\tC400.5,175.8,400,172.3,398.6,169.2z M160.5,178.6c0-1.5,1.8-2.1,3.4-2.1h70.8c1.6,0,2.8,0.6,2.8,2.1v10.8c0,1.4-1.1,3.1-2.8,3.1\r\n\t\th-70.8c-1.6,0-3.4-1.7-3.4-3.1V178.6z M160.5,306.6c0-1.5,1.8-2.1,3.4-2.1h122.2c1.6,0,2.4,0.6,2.4,2.1v10.8c0,1.4-0.7,3.1-2.4,3.1\r\n\t\tH163.9c-1.6,0-3.4-1.7-3.4-3.1V306.6z M320.5,381.4c0,1.4-0.7,3.1-2.4,3.1H163.9c-1.6,0-3.4-1.7-3.4-3.1v-10.8\r\n\t\tc0-1.5,1.8-2.1,3.4-2.1h154.2c1.6,0,2.4,0.6,2.4,2.1V381.4z M352.5,253.4c0,1.4-0.7,3.1-2.4,3.1H163.9c-1.6,0-3.4-1.7-3.4-3.1\r\n\t\tv-10.8c0-1.5,1.8-2.1,3.4-2.1h186.2c1.6,0,2.4,0.6,2.4,2.1V253.4z M305.6,177.5c-5.6,0-11.1-5.2-11.1-11.3v-66l71.2,77.3H305.6z"},"children":[]}]}]}]};exports.documentText=documentText;var documentIcon={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M399.3,168.9c-0.7-2.9-2-5-3.5-6.8l-83.7-91.7c-1.9-2.1-4.1-3.1-6.6-4.4c-2.9-1.5-6.1-1.6-9.4-1.6H136.2\r\n\tc-12.4,0-23.7,9.6-23.7,22.9v335.2c0,13.4,11.3,25.9,23.7,25.9h243.1c12.4,0,21.2-12.5,21.2-25.9V178.4\r\n\tC400.5,174.8,400.1,172.2,399.3,168.9z M305.5,111l58,63.5h-58V111z M144.5,416.5v-320h129v81.7c0,14.8,13.4,28.3,28.1,28.3h66.9\r\n\tv210H144.5z"},"children":[]}]};exports.documentIcon=documentIcon;var drag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"y":"144","width":"512","height":"32"},"children":[{"name":"rect","attribs":{"y":"144","width":"512","height":"32"},"children":[]}]},{"name":"rect","attribs":{"y":"240","width":"512","height":"32"},"children":[{"name":"rect","attribs":{"y":"240","width":"512","height":"32"},"children":[]}]},{"name":"rect","attribs":{"y":"336","width":"512","height":"32"},"children":[{"name":"rect","attribs":{"y":"336","width":"512","height":"32"},"children":[]}]}]}]};exports.drag=drag;var earth={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M357.275,125.525c-2.209-3.986-9.498-11.837-13.977-13.325c-5.979-0.921-2.398,4.413-2.398,6.7\r\n\t\tc-1.543,1.157-3.941,2.454-5.102,4c-0.699,0.6,1.704,6.103,6.337,4.335s1.964,1.799,5.164,8.865s9.607,7.207,12.49,5.067\r\n\t\tC363.444,138.455,359.286,129.155,357.275,125.525z"},"children":[{"name":"path","attribs":{"d":"M357.275,125.525c-2.209-3.986-9.498-11.837-13.977-13.325c-5.979-0.921-2.398,4.413-2.398,6.7\r\n\t\tc-1.543,1.157-3.941,2.454-5.102,4c-0.699,0.6,1.704,6.103,6.337,4.335s1.964,1.799,5.164,8.865s9.607,7.207,12.49,5.067\r\n\t\tC363.444,138.455,359.286,129.155,357.275,125.525z"},"children":[]}]},{"name":"path","attribs":{"d":"M375.8,170.6c-0.001,0.006-0.004,0.011-0.005,0.017C375.795,170.629,375.797,170.629,375.8,170.6z"},"children":[{"name":"path","attribs":{"d":"M375.8,170.6c-0.001,0.006-0.004,0.011-0.005,0.017C375.795,170.629,375.797,170.629,375.8,170.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M434.6,197.1C435,197.1,432.8,196.7,434.6,197.1L434.6,197.1z"},"children":[{"name":"path","attribs":{"d":"M434.6,197.1C435,197.1,432.8,196.7,434.6,197.1L434.6,197.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.701,100.3,224,224,224c123.701,0,224-100.299,224-224C480,132.3,379.701,32,256,32\r\n\t\tz M173.399,429.424c-5.515-3.133-9.374-7.56-10.961-15.929c-3.947-20.808-0.303-32.067,17.962-44.245\r\n\t\tc8.604-5.736,10.022-12.672,16.9-19.55c1.685-2.14,6.211-10.374,9.2-10.8c3.637-0.779,13.709-2.527,15.7-6.5\r\n\t\tc3.79-5.146,12.127-27.398,15.8-29.602c5.997-3.925,14.419-15.96,8.3-23.1c-7.021-8.643-16.799-8.766-25.9-13.301\r\n\t\tc-8.015-4.008-11.574-22.281-17.7-28.601c-11.912-12.136-29.999-19.199-45-26.7c-8.116-3.25-7.344-4.256-13.7,2.1\r\n\t\tc-8.162,8.162-20.093-2.067-21.3-10.5c-0.09-2.802-3.296-18.216-1.4-19.4c17.956-11.225-8.328-8.64-10.5-13.8\r\n\t\tc-5.355-14.993,13.008-26.86,25.4-28.1c13.885-1.738,16.784,21.895,22.1,19.9c2.556-1.276,2.566-12.394,2.9-14.8\r\n\t\tc1.267-8.029,3.588-9.273,11.4-12.175c9.098-3.379,16.063-7.617,25.7-9.225c11.006-3.195,20.317-1.533,28.8-8.6\r\n\t\tc3.888-2.915,6.704,1.58,10.4,2.4c7.999,1.599,9.7-11.1,9.7-15.9c-0.034-4.665,1.265-8.63-4.7-13.6\r\n\t\tc-7.806-6.069-19.029-0.869-25.3,5.4c-7.574,7.035-16.357,6.55-13.8-5.6c0.634-4.433,10.209-9.587,14-12\r\n\t\tc3.7-2.222,5.904,2.522,10.4,1.4c6.579-1.463,9.034,4.735,16.8,4.8c3.233-0.731,14.796-6.881,8.614-19.366\r\n\t\tC254.143,64.021,255.07,64,256,64c1.855,0,3.707,0.034,5.555,0.086c2.805,8.881-5.965,16.443-1.555,27.614\r\n\t\tc8.79,21.475,15.992,3.014,24.7-7c2.849-2.849,4.633-2.211,9.3-3.1c2.896-0.483,7.055-9.27,8.393-11.982\r\n\t\tc20.058,4.956,39.121,13.127,56.567,24.255c-7.447,0.792-9.348-1.396-9.234,7.377c0.042,3.317,0.297,13.319,5.274,14.15\r\n\t\tc8.277,0.975,6.781,6.832,14.551,7.85c7.443,0.976,2.816,7.553,5.851,14.05c3.393,10.227-19.806,13.302-24.302,14.8\r\n\t\tc-13.64,4.554,6.34,24.41,15.2,22.3c2.817-0.704,12.215-1.902,12.867-5.067c-0.011-0.323-1.836-11.012-0.867-12.233\r\n\t\tc1.533-1.934,5.123-2.946,10.776,0.255c13.374,7.573,20.146,25.7,35.897,29.295c2.146,0.489,5.86-0.15,8.494,2.033\r\n\t\tc2.231,3.015,7.92,8.416,1.131,8.416c-9.017-2.003-13.78,0.859-21.198-4.874c-7.733-5.977-12.543-10.891-22.75-11.076\r\n\t\tc-8.79-0.159-16.68-3.819-25.738-2.35c-5.05,0.819-10.038,2.811-14.912,4.3c-4.617,1.538-5.51,9.765-10.2,10.7\r\n\t\tc-19.467,4.581-15.261,23.169-18.773,37.913c-1.351,5.662-6.025,21.003-0.926,26.087c9.12,8.854,19.783,21.035,33.176,22.963\r\n\t\tc7.206,1.037,22.954-4.576,27.823,2.737c2.062,4.104,7.447-3.03,8.9,0.601c3.663,10.988-4.263,18.186-4.337,28.551\r\n\t\tc-0.11,15.203,9.178,20.57-3.263,34.148c-13.642,13.607-4.333,30.788-11.9,47c-4.042,8.337-4.808,19.894-10.872,23.777\r\n\t\tc-13.321,8.532-27.7,15.399-42.714,20.384c-26.627,8.838-55.155,11.672-83.017,8.456c-14.619-1.688-29.041-5.057-42.88-10.065\r\n\t\tc-3.769-1.363-7.28-2.505-10.472-3.704C178.143,431.619,175.759,430.55,173.399,429.424z M131.699,402.329\r\n\t\tc-0.468-0.397-0.935-0.796-1.399-1.198c-3.444-2.992-6.802-6.113-10.06-9.371c-3.388-3.388-6.634-6.881-9.734-10.471\r\n\t\tc-0.035-0.041-0.07-0.082-0.105-0.123c-0.637-0.738-1.257-1.486-1.882-2.234C56.834,316.471,49.259,225.004,92.6,155.1\r\n\t\tc6.078,6.078-4.101,18.024,7.5,26c5.124,3.606,10.021,2.159,9,8.8c-0.993,6.449,5.355,6.335,6.3,12\r\n\t\tc2.842,12.429,19.207,18.642,9.9,32.6c-9.118,12.625-16.992,26.729-10.1,42.8c2.254,5.86,7.919,11.858,12.222,16.244\r\n\t\tc7.813,7.966,7.377,3.188,7.377,13.256c-0.156,4.373,5.261,8.897,4.7,11.7c-1.001,8.011-2.904,15.93-3.9,23.9\r\n\t\tc-1.792,28.638-0.129,56.662,21.3,78.1c-7.969-4.806-15.636-10.249-22.968-16.29C133.183,403.591,132.44,402.961,131.699,402.329z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.701,100.3,224,224,224c123.701,0,224-100.299,224-224C480,132.3,379.701,32,256,32\r\n\t\tz M173.399,429.424c-5.515-3.133-9.374-7.56-10.961-15.929c-3.947-20.808-0.303-32.067,17.962-44.245\r\n\t\tc8.604-5.736,10.022-12.672,16.9-19.55c1.685-2.14,6.211-10.374,9.2-10.8c3.637-0.779,13.709-2.527,15.7-6.5\r\n\t\tc3.79-5.146,12.127-27.398,15.8-29.602c5.997-3.925,14.419-15.96,8.3-23.1c-7.021-8.643-16.799-8.766-25.9-13.301\r\n\t\tc-8.015-4.008-11.574-22.281-17.7-28.601c-11.912-12.136-29.999-19.199-45-26.7c-8.116-3.25-7.344-4.256-13.7,2.1\r\n\t\tc-8.162,8.162-20.093-2.067-21.3-10.5c-0.09-2.802-3.296-18.216-1.4-19.4c17.956-11.225-8.328-8.64-10.5-13.8\r\n\t\tc-5.355-14.993,13.008-26.86,25.4-28.1c13.885-1.738,16.784,21.895,22.1,19.9c2.556-1.276,2.566-12.394,2.9-14.8\r\n\t\tc1.267-8.029,3.588-9.273,11.4-12.175c9.098-3.379,16.063-7.617,25.7-9.225c11.006-3.195,20.317-1.533,28.8-8.6\r\n\t\tc3.888-2.915,6.704,1.58,10.4,2.4c7.999,1.599,9.7-11.1,9.7-15.9c-0.034-4.665,1.265-8.63-4.7-13.6\r\n\t\tc-7.806-6.069-19.029-0.869-25.3,5.4c-7.574,7.035-16.357,6.55-13.8-5.6c0.634-4.433,10.209-9.587,14-12\r\n\t\tc3.7-2.222,5.904,2.522,10.4,1.4c6.579-1.463,9.034,4.735,16.8,4.8c3.233-0.731,14.796-6.881,8.614-19.366\r\n\t\tC254.143,64.021,255.07,64,256,64c1.855,0,3.707,0.034,5.555,0.086c2.805,8.881-5.965,16.443-1.555,27.614\r\n\t\tc8.79,21.475,15.992,3.014,24.7-7c2.849-2.849,4.633-2.211,9.3-3.1c2.896-0.483,7.055-9.27,8.393-11.982\r\n\t\tc20.058,4.956,39.121,13.127,56.567,24.255c-7.447,0.792-9.348-1.396-9.234,7.377c0.042,3.317,0.297,13.319,5.274,14.15\r\n\t\tc8.277,0.975,6.781,6.832,14.551,7.85c7.443,0.976,2.816,7.553,5.851,14.05c3.393,10.227-19.806,13.302-24.302,14.8\r\n\t\tc-13.64,4.554,6.34,24.41,15.2,22.3c2.817-0.704,12.215-1.902,12.867-5.067c-0.011-0.323-1.836-11.012-0.867-12.233\r\n\t\tc1.533-1.934,5.123-2.946,10.776,0.255c13.374,7.573,20.146,25.7,35.897,29.295c2.146,0.489,5.86-0.15,8.494,2.033\r\n\t\tc2.231,3.015,7.92,8.416,1.131,8.416c-9.017-2.003-13.78,0.859-21.198-4.874c-7.733-5.977-12.543-10.891-22.75-11.076\r\n\t\tc-8.79-0.159-16.68-3.819-25.738-2.35c-5.05,0.819-10.038,2.811-14.912,4.3c-4.617,1.538-5.51,9.765-10.2,10.7\r\n\t\tc-19.467,4.581-15.261,23.169-18.773,37.913c-1.351,5.662-6.025,21.003-0.926,26.087c9.12,8.854,19.783,21.035,33.176,22.963\r\n\t\tc7.206,1.037,22.954-4.576,27.823,2.737c2.062,4.104,7.447-3.03,8.9,0.601c3.663,10.988-4.263,18.186-4.337,28.551\r\n\t\tc-0.11,15.203,9.178,20.57-3.263,34.148c-13.642,13.607-4.333,30.788-11.9,47c-4.042,8.337-4.808,19.894-10.872,23.777\r\n\t\tc-13.321,8.532-27.7,15.399-42.714,20.384c-26.627,8.838-55.155,11.672-83.017,8.456c-14.619-1.688-29.041-5.057-42.88-10.065\r\n\t\tc-3.769-1.363-7.28-2.505-10.472-3.704C178.143,431.619,175.759,430.55,173.399,429.424z M131.699,402.329\r\n\t\tc-0.468-0.397-0.935-0.796-1.399-1.198c-3.444-2.992-6.802-6.113-10.06-9.371c-3.388-3.388-6.634-6.881-9.734-10.471\r\n\t\tc-0.035-0.041-0.07-0.082-0.105-0.123c-0.637-0.738-1.257-1.486-1.882-2.234C56.834,316.471,49.259,225.004,92.6,155.1\r\n\t\tc6.078,6.078-4.101,18.024,7.5,26c5.124,3.606,10.021,2.159,9,8.8c-0.993,6.449,5.355,6.335,6.3,12\r\n\t\tc2.842,12.429,19.207,18.642,9.9,32.6c-9.118,12.625-16.992,26.729-10.1,42.8c2.254,5.86,7.919,11.858,12.222,16.244\r\n\t\tc7.813,7.966,7.377,3.188,7.377,13.256c-0.156,4.373,5.261,8.897,4.7,11.7c-1.001,8.011-2.904,15.93-3.9,23.9\r\n\t\tc-1.792,28.638-0.129,56.662,21.3,78.1c-7.969-4.806-15.636-10.249-22.968-16.29C133.183,403.591,132.44,402.961,131.699,402.329z"},"children":[]}]}]}]};exports.earth=earth;var easel={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"80","y":"144","width":"352","height":"192"},"children":[{"name":"rect","attribs":{"x":"80","y":"144","width":"352","height":"192"},"children":[]}]},{"name":"path","attribs":{"d":"M464,96H48c-8.837,0-16,7.163-16,16v256c0,8.837,6.932,16,15.768,16H464c8.837,0,16-7.163,16-16V112\r\n\t\tC480,103.163,472.837,96,464,96z M448,352H64V128h384V352z"},"children":[{"name":"path","attribs":{"d":"M464,96H48c-8.837,0-16,7.163-16,16v256c0,8.837,6.932,16,15.768,16H464c8.837,0,16-7.163,16-16V112\r\n\t\tC480,103.163,472.837,96,464,96z M448,352H64V128h384V352z"},"children":[]}]},{"name":"polygon","attribs":{"points":"80,480 112,480 140.147,400 108.835,400 \t"},"children":[{"name":"polygon","attribs":{"points":"80,480 112,480 140.147,400 108.835,400 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"270.83,32 241.472,32 224.171,80 288.099,80 \t"},"children":[{"name":"polygon","attribs":{"points":"270.83,32 241.472,32 224.171,80 288.099,80 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"371.853,400 400,480 432,480 403.22,400 \t"},"children":[{"name":"polygon","attribs":{"points":"371.853,400 400,480 432,480 403.22,400 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"240","y":"400","width":"32","height":"48"},"children":[{"name":"rect","attribs":{"x":"240","y":"400","width":"32","height":"48"},"children":[]}]}]}]};exports.easel=easel;var edit={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"178.846","y":"92.087","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 224.3476 631.1498)","width":"128.085","height":"354.049"},"children":[{"name":"rect","attribs":{"x":"178.846","y":"92.087","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 224.3476 631.1498)","width":"128.085","height":"354.049"},"children":[]}]},{"name":"path","attribs":{"d":"M471.723,88.393l-48.115-48.114c-11.723-11.724-31.558-10.896-44.304,1.85l-45.202,45.203l90.569,90.568l45.202-45.202\r\n\t\tC482.616,119.952,483.445,100.116,471.723,88.393z"},"children":[{"name":"path","attribs":{"d":"M471.723,88.393l-48.115-48.114c-11.723-11.724-31.558-10.896-44.304,1.85l-45.202,45.203l90.569,90.568l45.202-45.202\r\n\t\tC482.616,119.952,483.445,100.116,471.723,88.393z"},"children":[]}]},{"name":"polygon","attribs":{"points":"64.021,363.252 32,480 148.737,447.979 \t"},"children":[{"name":"polygon","attribs":{"points":"64.021,363.252 32,480 148.737,447.979 \t"},"children":[]}]}]}]};exports.edit=edit;var egg={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C192,32,96,165.2,96,288.9C96,412.6,160,480,256,480s160-67.4,160-191.1C416,165.2,320,32,256,32z"},"children":[]}]};exports.egg=egg;var eject={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M399,320L399,320c10,0,16.8-7.1,16.8-15.9c0-3.3-1.1-6.1-2.8-9L275.3,104.7c-4.6-5.3-11.5-8.7-19.3-8.7\r\n\t\tc-7.7,0-14.6,3.4-19.2,8.7l-138,190.8c-1.7,2.6-2.6,5.5-2.6,8.7c0,8.7,6.8,15.8,16.8,15.8v0H399z"},"children":[{"name":"path","attribs":{"d":"M399,320L399,320c10,0,16.8-7.1,16.8-15.9c0-3.3-1.1-6.1-2.8-9L275.3,104.7c-4.6-5.3-11.5-8.7-19.3-8.7\r\n\t\tc-7.7,0-14.6,3.4-19.2,8.7l-138,190.8c-1.7,2.6-2.6,5.5-2.6,8.7c0,8.7,6.8,15.8,16.8,15.8v0H399z"},"children":[]}]},{"name":"path","attribs":{"d":"M403.7,352H108.4c-6.8,0-12.4,5.4-12.4,12.2v39.6c0,6.7,5.5,12.2,12.4,12.2h295.3c6.8,0,12.3-5.5,12.3-12.2v-39.6\r\n\t\tC416,357.4,410.5,352,403.7,352z"},"children":[{"name":"path","attribs":{"d":"M403.7,352H108.4c-6.8,0-12.4,5.4-12.4,12.2v39.6c0,6.7,5.5,12.2,12.4,12.2h295.3c6.8,0,12.3-5.5,12.3-12.2v-39.6\r\n\t\tC416,357.4,410.5,352,403.7,352z"},"children":[]}]}]}]};exports.eject=eject;var emailUnread={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"432","cy":"160","r":"64"},"children":[{"name":"circle","attribs":{"cx":"432","cy":"160","r":"64"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M225,160H33.799c-11.1,0-13.898,3-11.299,10.5c1.5,4.4,8.4,8.1,12.5,10.2c11,5.8,163.799,89.1,169.5,92.1\r\n\t\t\tc5.699,3,11.5,4.4,20.5,4.4s14.799-1.4,20.5-4.4c3.79-1.995,72.625-39.497,121.559-66.107C357.594,193.551,352,177.433,352,160\r\n\t\t\tH225z"},"children":[{"name":"path","attribs":{"d":"M225,160H33.799c-11.1,0-13.898,3-11.299,10.5c1.5,4.4,8.4,8.1,12.5,10.2c11,5.8,163.799,89.1,169.5,92.1\r\n\t\t\tc5.699,3,11.5,4.4,20.5,4.4s14.799-1.4,20.5-4.4c3.79-1.995,72.625-39.497,121.559-66.107C357.594,193.551,352,177.433,352,160\r\n\t\t\tH225z"},"children":[]}]},{"name":"path","attribs":{"d":"M293.199,273.3l82.201,92.5c2,2,2.898,4.4,1.799,5.601c-1.199,1.1-3.799,0.5-5.9-1.4l-98.6-83.2\r\n\t\t\tc-14.9,9.601-25.4,16.2-27.199,17.2c-7.701,3.9-13.1,4.4-20.5,4.4s-12.801-0.5-20.5-4.4c-1.9-1-12.301-7.6-27.201-17.2l-98.6,83.2\r\n\t\t\tc-2,2-4.699,2.6-5.9,1.4C71.6,370.3,72.5,367.8,74.5,365.8l82.1-92.5C107.9,241.8,33.5,189.4,25.299,185.2\r\n\t\t\tC16.5,180.7,16,186,16,190.1c0,4.101,0,205,0,205C16,404.4,29.699,416,39.5,416H225h185.5c9.799,0,21.5-11.7,21.5-20.9\r\n\t\t\tc0,0,0-94.398,0-155.1c-21.726,0-41.416-8.673-55.832-22.729C350.167,235.173,318.36,257.025,293.199,273.3z"},"children":[{"name":"path","attribs":{"d":"M293.199,273.3l82.201,92.5c2,2,2.898,4.4,1.799,5.601c-1.199,1.1-3.799,0.5-5.9-1.4l-98.6-83.2\r\n\t\t\tc-14.9,9.601-25.4,16.2-27.199,17.2c-7.701,3.9-13.1,4.4-20.5,4.4s-12.801-0.5-20.5-4.4c-1.9-1-12.301-7.6-27.201-17.2l-98.6,83.2\r\n\t\t\tc-2,2-4.699,2.6-5.9,1.4C71.6,370.3,72.5,367.8,74.5,365.8l82.1-92.5C107.9,241.8,33.5,189.4,25.299,185.2\r\n\t\t\tC16.5,180.7,16,186,16,190.1c0,4.101,0,205,0,205C16,404.4,29.699,416,39.5,416H225h185.5c9.799,0,21.5-11.7,21.5-20.9\r\n\t\t\tc0,0,0-94.398,0-155.1c-21.726,0-41.416-8.673-55.832-22.729C350.167,235.173,318.36,257.025,293.199,273.3z"},"children":[]}]}]}]}]}]};exports.emailUnread=emailUnread;var email={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M67,148.7c11,5.8,163.8,89.1,169.5,92.1c5.7,3,11.5,4.4,20.5,4.4c9,0,14.8-1.4,20.5-4.4c5.7-3,158.5-86.3,169.5-92.1\r\n\t\tc4.1-2.1,11-5.9,12.5-10.2c2.6-7.6-0.2-10.5-11.3-10.5H257H65.8c-11.1,0-13.9,3-11.3,10.5C56,142.9,62.9,146.6,67,148.7z"},"children":[{"name":"path","attribs":{"d":"M67,148.7c11,5.8,163.8,89.1,169.5,92.1c5.7,3,11.5,4.4,20.5,4.4c9,0,14.8-1.4,20.5-4.4c5.7-3,158.5-86.3,169.5-92.1\r\n\t\tc4.1-2.1,11-5.9,12.5-10.2c2.6-7.6-0.2-10.5-11.3-10.5H257H65.8c-11.1,0-13.9,3-11.3,10.5C56,142.9,62.9,146.6,67,148.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M455.7,153.2c-8.2,4.2-81.8,56.6-130.5,88.1l82.2,92.5c2,2,2.9,4.4,1.8,5.6c-1.2,1.1-3.8,0.5-5.9-1.4l-98.6-83.2\r\n\t\tc-14.9,9.6-25.4,16.2-27.2,17.2c-7.7,3.9-13.1,4.4-20.5,4.4c-7.4,0-12.8-0.5-20.5-4.4c-1.9-1-12.3-7.6-27.2-17.2l-98.6,83.2\r\n\t\tc-2,2-4.7,2.6-5.9,1.4c-1.2-1.1-0.3-3.6,1.7-5.6l82.1-92.5c-48.7-31.5-123.1-83.9-131.3-88.1c-8.8-4.5-9.3,0.8-9.3,4.9\r\n\t\tc0,4.1,0,205,0,205c0,9.3,13.7,20.9,23.5,20.9H257h185.5c9.8,0,21.5-11.7,21.5-20.9c0,0,0-201,0-205\r\n\t\tC464,153.9,464.6,148.7,455.7,153.2z"},"children":[{"name":"path","attribs":{"d":"M455.7,153.2c-8.2,4.2-81.8,56.6-130.5,88.1l82.2,92.5c2,2,2.9,4.4,1.8,5.6c-1.2,1.1-3.8,0.5-5.9-1.4l-98.6-83.2\r\n\t\tc-14.9,9.6-25.4,16.2-27.2,17.2c-7.7,3.9-13.1,4.4-20.5,4.4c-7.4,0-12.8-0.5-20.5-4.4c-1.9-1-12.3-7.6-27.2-17.2l-98.6,83.2\r\n\t\tc-2,2-4.7,2.6-5.9,1.4c-1.2-1.1-0.3-3.6,1.7-5.6l82.1-92.5c-48.7-31.5-123.1-83.9-131.3-88.1c-8.8-4.5-9.3,0.8-9.3,4.9\r\n\t\tc0,4.1,0,205,0,205c0,9.3,13.7,20.9,23.5,20.9H257h185.5c9.8,0,21.5-11.7,21.5-20.9c0,0,0-201,0-205\r\n\t\tC464,153.9,464.6,148.7,455.7,153.2z"},"children":[]}]}]}]};exports.email=email;var erlenmeyerFlaskBubbles={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M445.9,427.1L328,227.9V78c0-7.7-6.5-14-14.5-14c-8,0-14.5,6.2-14.5,14v153.6c0,1.8,0.6,3.6,1.3,5.3\r\n\t\tc-7.6-11.1-20.6-18.4-35.4-18.4c-23.5,0-42.5,18.3-42.5,41c0,16.8,10.5,31.5,25.4,37.5h-72l35-58.5c1.2-2.1,2.1-4.5,2.1-6.9v-30.4\r\n\t\tc4,3.2,10,5.1,16.1,5.1c15.3,0,27.5-11.9,27.5-26.6c0-14.7-12.2-26.6-27.5-26.6c-6.1,0-12.1,1.9-16.1,5.1V78c0-7.7-6.5-14-14.5-14\r\n\t\tc-8,0-14.5,6.2-14.5,14v149.9L66.1,427.1c-2.5,4.3-2.6,9.6,0,13.9c2.6,4.3,7.2,7,12.4,7H256h177.5c5.1,0,9.8-2.6,12.4-7\r\n\t\tC448.5,436.8,448.4,431.4,445.9,427.1z M282.2,297c14.9-6,25.4-20.8,25.4-37.5c0-5.7-1.2-11.2-3.4-16.1l31,53.6H282.2z"},"children":[{"name":"path","attribs":{"d":"M445.9,427.1L328,227.9V78c0-7.7-6.5-14-14.5-14c-8,0-14.5,6.2-14.5,14v153.6c0,1.8,0.6,3.6,1.3,5.3\r\n\t\tc-7.6-11.1-20.6-18.4-35.4-18.4c-23.5,0-42.5,18.3-42.5,41c0,16.8,10.5,31.5,25.4,37.5h-72l35-58.5c1.2-2.1,2.1-4.5,2.1-6.9v-30.4\r\n\t\tc4,3.2,10,5.1,16.1,5.1c15.3,0,27.5-11.9,27.5-26.6c0-14.7-12.2-26.6-27.5-26.6c-6.1,0-12.1,1.9-16.1,5.1V78c0-7.7-6.5-14-14.5-14\r\n\t\tc-8,0-14.5,6.2-14.5,14v149.9L66.1,427.1c-2.5,4.3-2.6,9.6,0,13.9c2.6,4.3,7.2,7,12.4,7H256h177.5c5.1,0,9.8-2.6,12.4-7\r\n\t\tC448.5,436.8,448.4,431.4,445.9,427.1z M282.2,297c14.9-6,25.4-20.8,25.4-37.5c0-5.7-1.2-11.2-3.4-16.1l31,53.6H282.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M265.1,128.6c12,0,21.7-9.4,21.7-20.9c0-11.6-9.7-20.9-21.7-20.9c-12,0-21.7,9.4-21.7,20.9\r\n\t\tC243.3,119.2,253.1,128.6,265.1,128.6z"},"children":[{"name":"path","attribs":{"d":"M265.1,128.6c12,0,21.7-9.4,21.7-20.9c0-11.6-9.7-20.9-21.7-20.9c-12,0-21.7,9.4-21.7,20.9\r\n\t\tC243.3,119.2,253.1,128.6,265.1,128.6z"},"children":[]}]}]}]};exports.erlenmeyerFlaskBubbles=erlenmeyerFlaskBubbles;var erlenmeyerFlask={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M438.815,395.7L338.509,246.2c-12.8-20.3-19.009-44.4-19.009-70.2c0,0,0-73.5,0-93s12.592-33.25,15.009-42.083\r\n\t\tc2.296-8.392,0.512-8.417-15.188-8.417H192.526c-15.999,0-18.548,0.009-16.311,8.416C178.633,50,191.5,64.3,191.5,83.5\r\n\t\ts0,92.5,0,92.5c0,25.8-7.285,49.8-20.085,70.2l-49.279,76.5L73.035,395.6c-5.8,9-9.051,20.7-9.051,32.2\r\n\t\tc0,28,16.347,52.7,63.246,52.7h257.589c46.998,0,63.197-24.7,63.197-52.7C447.916,416.3,444.615,404.7,438.815,395.7z M409.218,441\r\n\t\tc-4.4,4.2-11.602,7.5-24.499,7.5h-257.59c-12.8,0-20.8-3.5-25.199-7.7c-2.7-2.6-6-7.05-6-13.35c0-5,1.4-10.125,3.9-14.125\r\n\t\tl99.039-150.392c15.699-25.199,24.632-55.231,24.632-86.932V64.5h64v111.4c0,31.199,7.761,61.3,23.859,87l100.523,150\r\n\t\tc2.499,4,3.968,9.25,3.968,14.25C415.85,433.55,411.918,438.4,409.218,441z"},"children":[{"name":"path","attribs":{"d":"M438.815,395.7L338.509,246.2c-12.8-20.3-19.009-44.4-19.009-70.2c0,0,0-73.5,0-93s12.592-33.25,15.009-42.083\r\n\t\tc2.296-8.392,0.512-8.417-15.188-8.417H192.526c-15.999,0-18.548,0.009-16.311,8.416C178.633,50,191.5,64.3,191.5,83.5\r\n\t\ts0,92.5,0,92.5c0,25.8-7.285,49.8-20.085,70.2l-49.279,76.5L73.035,395.6c-5.8,9-9.051,20.7-9.051,32.2\r\n\t\tc0,28,16.347,52.7,63.246,52.7h257.589c46.998,0,63.197-24.7,63.197-52.7C447.916,416.3,444.615,404.7,438.815,395.7z M409.218,441\r\n\t\tc-4.4,4.2-11.602,7.5-24.499,7.5h-257.59c-12.8,0-20.8-3.5-25.199-7.7c-2.7-2.6-6-7.05-6-13.35c0-5,1.4-10.125,3.9-14.125\r\n\t\tl99.039-150.392c15.699-25.199,24.632-55.231,24.632-86.932V64.5h64v111.4c0,31.199,7.761,61.3,23.859,87l100.523,150\r\n\t\tc2.499,4,3.968,9.25,3.968,14.25C415.85,433.55,411.918,438.4,409.218,441z"},"children":[]}]},{"name":"path","attribs":{"d":"M389.217,411.301c0.051,0.075,0.1,0.397,0,0.249L307.345,288.5H203.698l-81.069,123.151c-1.5,2.1-2.3,5.175-2.3,7.974\r\n\t\tc0,7.5,6.288,13.875,13.687,13.875h244c7.5,0,13.599-6.725,13.599-14.125C391.614,416.875,390.516,413.301,389.217,411.301z\r\n\t\t M302.021,341.7c-1.5-1.5-2.3-3.601-2.3-5.7s0.899-4.2,2.3-5.7c1.5-1.5,3.6-2.3,5.6-2.3c2.102,0,4.2,0.8,5.602,2.3\r\n\t\tc1.5,1.5,2.299,3.601,2.299,5.7s-0.899,4.2-2.299,5.7c-1.5,1.5-3.5,2.3-5.602,2.3C305.621,344,303.521,343.1,302.021,341.7z\r\n\t\t M348.92,400.7c-1.4,0.898-2.9,1.3-4.302,1.3c-2.499,0-5.099-1.3-6.598-3.6l-23.499-35.9c-2.4-3.7-1.4-8.7,2.299-11.1\r\n\t\tc1.4-0.9,2.9-1.301,4.4-1.301c2.6,0,5.1,1.301,6.5,3.601L351.22,389.6C353.618,393.299,352.618,398.299,348.92,400.7z"},"children":[{"name":"path","attribs":{"d":"M389.217,411.301c0.051,0.075,0.1,0.397,0,0.249L307.345,288.5H203.698l-81.069,123.151c-1.5,2.1-2.3,5.175-2.3,7.974\r\n\t\tc0,7.5,6.288,13.875,13.687,13.875h244c7.5,0,13.599-6.725,13.599-14.125C391.614,416.875,390.516,413.301,389.217,411.301z\r\n\t\t M302.021,341.7c-1.5-1.5-2.3-3.601-2.3-5.7s0.899-4.2,2.3-5.7c1.5-1.5,3.6-2.3,5.6-2.3c2.102,0,4.2,0.8,5.602,2.3\r\n\t\tc1.5,1.5,2.299,3.601,2.299,5.7s-0.899,4.2-2.299,5.7c-1.5,1.5-3.5,2.3-5.602,2.3C305.621,344,303.521,343.1,302.021,341.7z\r\n\t\t M348.92,400.7c-1.4,0.898-2.9,1.3-4.302,1.3c-2.499,0-5.099-1.3-6.598-3.6l-23.499-35.9c-2.4-3.7-1.4-8.7,2.299-11.1\r\n\t\tc1.4-0.9,2.9-1.301,4.4-1.301c2.6,0,5.1,1.301,6.5,3.601L351.22,389.6C353.618,393.299,352.618,398.299,348.92,400.7z"},"children":[]}]}]}]};exports.erlenmeyerFlask=erlenmeyerFlask;var eyeDisabled={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M376.4,158.3L448,86.6L425.4,64l-77.6,77.6C320,127.7,289.5,119,256,119c-81.9,0-145.7,52.2-224,137\r\n\tc34.8,37.4,66.8,72.7,103.3,98.1L64,425.4L86.6,448l76.9-76.9c27,13.7,57,21.9,92.5,21.9c99.9,0,173.4-81.8,224-135.5\r\n\tC452,223.4,417.6,185.7,376.4,158.3z M166.4,256c0-50.4,40.2-91.3,89.6-91.3c19.3,0,37.2,6.2,51.8,16.9l-50.7,50.7\r\n\tc-0.7-2.6-1.1-5.4-1.1-8.3c0-7.9,2.9-15.1,7.6-20.7c-2.5-0.4-5-0.6-7.6-0.6c-28.8,0-52.3,23.9-52.3,53.3c0,8.6,2,16.8,5.6,24\r\n\tL182,307.4C172.2,292.7,166.4,275,166.4,256z M256,347.3c-19.3,0-37.2-6.2-51.8-16.9l27.4-27.4c7.3,4,15.6,6.2,24.4,6.2\r\n\tc28.8,0,52.3-23.9,52.3-53.3c0-2.3-0.2-4.6-0.4-6.9c-5.5,4.3-12.3,6.9-19.8,6.9c-2.9,0-5.6-0.4-8.3-1.1l50.3-50.3\r\n\tc9.8,14.6,15.6,32.3,15.6,51.4C345.6,306.4,305.4,347.3,256,347.3z"},"children":[]}]};exports.eyeDisabled=eyeDisabled;var eye={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-81.9,0-145.7,48.8-224,128c67.4,67.7,124,128,224,128c99.9,0,173.4-76.4,224-126.6\r\n\t\tC428.2,198.6,354.8,128,256,128z M256,347.3c-49.4,0-89.6-41-89.6-91.3c0-50.4,40.2-91.3,89.6-91.3s89.6,41,89.6,91.3\r\n\t\tC345.6,306.4,305.4,347.3,256,347.3z"},"children":[{"name":"path","attribs":{"d":"M256,128c-81.9,0-145.7,48.8-224,128c67.4,67.7,124,128,224,128c99.9,0,173.4-76.4,224-126.6\r\n\t\tC428.2,198.6,354.8,128,256,128z M256,347.3c-49.4,0-89.6-41-89.6-91.3c0-50.4,40.2-91.3,89.6-91.3s89.6,41,89.6,91.3\r\n\t\tC345.6,306.4,305.4,347.3,256,347.3z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,224c0-7.9,2.9-15.1,7.6-20.7c-2.5-0.4-5-0.6-7.6-0.6c-28.8,0-52.3,23.9-52.3,53.3c0,29.4,23.5,53.3,52.3,53.3\r\n\t\t\ts52.3-23.9,52.3-53.3c0-2.3-0.2-4.6-0.4-6.9c-5.5,4.3-12.3,6.9-19.8,6.9C270.3,256,256,241.7,256,224z"},"children":[{"name":"path","attribs":{"d":"M256,224c0-7.9,2.9-15.1,7.6-20.7c-2.5-0.4-5-0.6-7.6-0.6c-28.8,0-52.3,23.9-52.3,53.3c0,29.4,23.5,53.3,52.3,53.3\r\n\t\t\ts52.3-23.9,52.3-53.3c0-2.3-0.2-4.6-0.4-6.9c-5.5,4.3-12.3,6.9-19.8,6.9C270.3,256,256,241.7,256,224z"},"children":[]}]}]}]}]}]};exports.eye=eye;var female={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M288,284c55.2-14.2,96-64.3,96-124c0-70.7-57.3-128-128-128S128,89.3,128,160c0,59.6,40.8,109.7,96,124v68h-64v64h64v64h64\r\n\tv-64h64v-64h-64V284z M256,240c-44.1,0-80-35.9-80-80s35.9-80,80-80s80,35.9,80,80S300.1,240,256,240z"},"children":[]}]};exports.female=female;var filing={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M381,128.6H132.1c-12.1,0-19.5,0-19.5,20.4v28.1h288V149C400.6,128.6,393.2,128.6,381,128.6z"},"children":[{"name":"path","attribs":{"d":"M381,128.6H132.1c-12.1,0-19.5,0-19.5,20.4v28.1h288V149C400.6,128.6,393.2,128.6,381,128.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M333,96.5H180c-13.1,0-19.5,0.3-19.5,18.7h192C352.4,96.8,346.1,96.5,333,96.5z"},"children":[{"name":"path","attribs":{"d":"M333,96.5H180c-13.1,0-19.5,0.3-19.5,18.7h192C352.4,96.8,346.1,96.5,333,96.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M432.4,169.6l-15.9-9.4v32.3h-321v-32.3l-15.2,9.4c-14.3,8.9-17.8,15.3-15,40.9l17.5,184.8c3.7,20.7,15.9,21.2,24,21.2\r\n\t\th299.9c8.1,0,20.2-0.5,23.9-21.2l17.2-184.4C450.1,186.5,445.8,178.1,432.4,169.6z"},"children":[{"name":"path","attribs":{"d":"M432.4,169.6l-15.9-9.4v32.3h-321v-32.3l-15.2,9.4c-14.3,8.9-17.8,15.3-15,40.9l17.5,184.8c3.7,20.7,15.9,21.2,24,21.2\r\n\t\th299.9c8.1,0,20.2-0.5,23.9-21.2l17.2-184.4C450.1,186.5,445.8,178.1,432.4,169.6z"},"children":[]}]}]}]};exports.filing=filing;var filmMarker={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448.4,208h-344l341.2-68c8.5-1.6,14-9.7,12.4-18.1l-8.9-45.4c-1.6-8.4-9.8-13.8-18.3-12.2L60.7,137.9\r\n\tc-8.5,1.6-14,9.7-12.4,18l8.9,45.4c0.6,2.8,2.1,5.2,3.9,7.2c-7.4,1.2-13.1,7.2-13.1,14.9v209.2c0,8.5,7,15.4,15.6,15.4h384.8\r\n\tc8.6,0,15.6-6.9,15.6-15.4V223.4C464,214.9,457,208,448.4,208z M305,402.4l-50.7-36.3l-50.7,36.3l19.5-58.4l-50.8-36H235l19.2-58.4\r\n\tl19.3,58.4h62.7l-50.8,36L305,402.4z"},"children":[]}]};exports.filmMarker=filmMarker;var fireball={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M393.267,238.088l-0.231,10.404c-0.814,11.65-3.797,31.912-14.102,54.736c3.251-15.208,4.978-30.982,4.978-47.164\r\n\t\tc0-12.096-0.958-23.968-2.799-35.544c-15.091-94.901-89.626-169.923-184.138-185.518C185.706,32.285,179.048,32,179.048,32\r\n\t\tc0.238,0.281,0.465,0.562,0.7,0.844c39.458,47.181,44.1,96.656,37.744,131.85c-2.281,12.629-5.978,23.421-9.991,31.605\r\n\t\tc0,0,3.359-13.911,3.035-29.72c-0.293-14.234-3.572-30.006-14.986-38.552c3.497,18.378-0.752,33.501-9.121,47.729\r\n\t\tC161.69,217.808,101,249.386,96,327.408v3.836c0,53.692,25.624,98.979,68.719,125.012c-6.85-12.344-14.964-35.207-8.733-60.151\r\n\t\tc3.998,23.669,9.951,36.045,20.879,51.756c8.153,11.721,19.104,19.269,33.095,24.934S238.995,480,255.889,480\r\n\t\tc55.809,0,105.228-28.567,133.845-71.952l0.267,0.061v-0.007c16-25.254,26.1-55.5,26.1-88.019\r\n\t\tC416.1,290.112,407.596,262.071,393.267,238.088z"},"children":[{"name":"path","attribs":{"d":"M393.267,238.088l-0.231,10.404c-0.814,11.65-3.797,31.912-14.102,54.736c3.251-15.208,4.978-30.982,4.978-47.164\r\n\t\tc0-12.096-0.958-23.968-2.799-35.544c-15.091-94.901-89.626-169.923-184.138-185.518C185.706,32.285,179.048,32,179.048,32\r\n\t\tc0.238,0.281,0.465,0.562,0.7,0.844c39.458,47.181,44.1,96.656,37.744,131.85c-2.281,12.629-5.978,23.421-9.991,31.605\r\n\t\tc0,0,3.359-13.911,3.035-29.72c-0.293-14.234-3.572-30.006-14.986-38.552c3.497,18.378-0.752,33.501-9.121,47.729\r\n\t\tC161.69,217.808,101,249.386,96,327.408v3.836c0,53.692,25.624,98.979,68.719,125.012c-6.85-12.344-14.964-35.207-8.733-60.151\r\n\t\tc3.998,23.669,9.951,36.045,20.879,51.756c8.153,11.721,19.104,19.269,33.095,24.934S238.995,480,255.889,480\r\n\t\tc55.809,0,105.228-28.567,133.845-71.952l0.267,0.061v-0.007c16-25.254,26.1-55.5,26.1-88.019\r\n\t\tC416.1,290.112,407.596,262.071,393.267,238.088z"},"children":[]}]}]}]};exports.fireball=fireball;var flag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M426.4,182.5c-35.8,5.9-94.2,7.5-133-66.1c-41.6-79.1-108.8-81.5-148.1-74.3c-19.1,3.5-33.4,19.5-33.4,35v196.6\r\n\t\tc11.3,4.3,23.4-0.2,26.5-0.8c0.8-0.2,1.5-0.3,2.4-0.5c25-5.5,51.4-8.1,116.8,23.3c82,39.3,153.8-33.1,181.6-83.5\r\n\t\tc2-3.5,8.7-20.2,8.7-36.2C438.2,180,426.4,182.5,426.4,182.5z"},"children":[{"name":"path","attribs":{"d":"M426.4,182.5c-35.8,5.9-94.2,7.5-133-66.1c-41.6-79.1-108.8-81.5-148.1-74.3c-19.1,3.5-33.4,19.5-33.4,35v196.6\r\n\t\tc11.3,4.3,23.4-0.2,26.5-0.8c0.8-0.2,1.5-0.3,2.4-0.5c25-5.5,51.4-8.1,116.8,23.3c82,39.3,153.8-33.1,181.6-83.5\r\n\t\tc2-3.5,8.7-20.2,8.7-36.2C438.2,180,426.4,182.5,426.4,182.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M88,32H72c-4.4,0-8,3.6-8,8v432c0,4.4,3.6,8,8,8h16c4.4,0,8-3.6,8-8V40C96,35.6,92.4,32,88,32z"},"children":[{"name":"path","attribs":{"d":"M88,32H72c-4.4,0-8,3.6-8,8v432c0,4.4,3.6,8,8,8h16c4.4,0,8-3.6,8-8V40C96,35.6,92.4,32,88,32z"},"children":[]}]}]}]};exports.flag=flag;var flame={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128.922,320c13.05,134,103.764,160,126.932,160c23.168,0,127.457-40.49,128.142-160c0.836-146-121.586-143-95.895-288\r\n\t\tC201.427,96,118.289,210.816,128.922,320z M215.667,368c0-44.183,40.187-80,40.187-80s40.701,35.817,40.701,80\r\n\t\tc0,44.184-40.701,80-40.701,80S215.667,412.184,215.667,368z"},"children":[{"name":"path","attribs":{"d":"M128.922,320c13.05,134,103.764,160,126.932,160c23.168,0,127.457-40.49,128.142-160c0.836-146-121.586-143-95.895-288\r\n\t\tC201.427,96,118.289,210.816,128.922,320z M215.667,368c0-44.183,40.187-80,40.187-80s40.701,35.817,40.701,80\r\n\t\tc0,44.184-40.701,80-40.701,80S215.667,412.184,215.667,368z"},"children":[]}]}]}]};exports.flame=flame;var flashOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M147.4,451.9c0.4,0.2,0.7,0.5,1.1,0.7c10.9,6,22.5,10.7,34.4,14.8c1.8,0.6,3.6,1.2,5.4,1.8c21.4,6.8,44,10.9,67.7,10.9\r\n\t\tc123.7,0,224-100.3,224-224c0-84.3-46.6-157.7-115.5-195.9c-0.4-0.2-0.7-0.4-1-0.6c-10.9-6-22.5-10.7-34.4-14.8\r\n\t\tc-1.8-0.6-3.6-1.2-5.4-1.8C302.3,36.1,279.6,32,256,32C132.3,32,32,132.3,32,256C32,340.3,78.6,413.6,147.4,451.9z M118.2,156.6\r\n\t\tl54.4,54.4l36.3-40.5l-52.4-52.4c28-20.2,62.1-32.6,99.4-32.6c9.3,0,18.3,0.9,27.2,2.4c9.8,1.6,19.3,4.1,28.5,7.3\r\n\t\tc1.8,0.6,3.7,1.2,5.6,1.9c6.2,2.4,12.2,5,18,8.1c54.2,28.5,91.2,85.3,91.2,150.8c0,37.2-12.4,71.3-32.7,99.4l-54.4-54.4L303,341.4\r\n\t\tl52.4,52.4c-28,20.3-62.2,32.7-99.4,32.7c-9.3,0-18.4-0.9-27.2-2.4c-9.8-1.6-19.3-4.1-28.5-7.3c-1.9-0.6-3.8-1.2-5.6-1.9\r\n\t\tc-6.5-2.5-12.9-5.3-19-8.6c-53.6-28.7-90.1-85.2-90.1-150.3C85.6,218.8,98,184.7,118.2,156.6z"},"children":[{"name":"path","attribs":{"d":"M147.4,451.9c0.4,0.2,0.7,0.5,1.1,0.7c10.9,6,22.5,10.7,34.4,14.8c1.8,0.6,3.6,1.2,5.4,1.8c21.4,6.8,44,10.9,67.7,10.9\r\n\t\tc123.7,0,224-100.3,224-224c0-84.3-46.6-157.7-115.5-195.9c-0.4-0.2-0.7-0.4-1-0.6c-10.9-6-22.5-10.7-34.4-14.8\r\n\t\tc-1.8-0.6-3.6-1.2-5.4-1.8C302.3,36.1,279.6,32,256,32C132.3,32,32,132.3,32,256C32,340.3,78.6,413.6,147.4,451.9z M118.2,156.6\r\n\t\tl54.4,54.4l36.3-40.5l-52.4-52.4c28-20.2,62.1-32.6,99.4-32.6c9.3,0,18.3,0.9,27.2,2.4c9.8,1.6,19.3,4.1,28.5,7.3\r\n\t\tc1.8,0.6,3.7,1.2,5.6,1.9c6.2,2.4,12.2,5,18,8.1c54.2,28.5,91.2,85.3,91.2,150.8c0,37.2-12.4,71.3-32.7,99.4l-54.4-54.4L303,341.4\r\n\t\tl52.4,52.4c-28,20.3-62.2,32.7-99.4,32.7c-9.3,0-18.4-0.9-27.2-2.4c-9.8-1.6-19.3-4.1-28.5-7.3c-1.9-0.6-3.8-1.2-5.6-1.9\r\n\t\tc-6.5-2.5-12.9-5.3-19-8.6c-53.6-28.7-90.1-85.2-90.1-150.3C85.6,218.8,98,184.7,118.2,156.6z"},"children":[]}]},{"name":"polygon","attribs":{"points":"209.7,389.8 348.9,235 263.6,235 302.2,122.2 163.1,277 248.4,277 \t"},"children":[{"name":"polygon","attribs":{"points":"209.7,389.8 348.9,235 263.6,235 302.2,122.2 163.1,277 248.4,277 \t"},"children":[]}]}]}]};exports.flashOff=flashOff;var flash={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"96,288 243,288 191.9,480 416,224 269,224 320,32 "},"children":[]}]};exports.flash=flash;var folder={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M430.1,192H81.9c-17.7,0-18.6,9.2-17.6,20.5l13,183c0.9,11.2,3.5,20.5,21.1,20.5h316.2c18,0,20.1-9.2,21.1-20.5l12.1-185.3\r\n\t\tC448.7,199,447.8,192,430.1,192z"},"children":[{"name":"path","attribs":{"d":"M430.1,192H81.9c-17.7,0-18.6,9.2-17.6,20.5l13,183c0.9,11.2,3.5,20.5,21.1,20.5h316.2c18,0,20.1-9.2,21.1-20.5l12.1-185.3\r\n\t\tC448.7,199,447.8,192,430.1,192z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M426.2,143.3c-0.5-12.4-4.5-15.3-15.1-15.3c0,0-121.4,0-143.2,0c-21.8,0-24.4,0.3-40.9-17.4C213.3,95.8,218.7,96,190.4,96\r\n\t\t\tc-22.6,0-75.3,0-75.3,0c-17.4,0-23.6-1.5-25.2,16.6c-1.5,16.7-5,57.2-5.5,63.4h343.4L426.2,143.3z"},"children":[{"name":"path","attribs":{"d":"M426.2,143.3c-0.5-12.4-4.5-15.3-15.1-15.3c0,0-121.4,0-143.2,0c-21.8,0-24.4,0.3-40.9-17.4C213.3,95.8,218.7,96,190.4,96\r\n\t\t\tc-22.6,0-75.3,0-75.3,0c-17.4,0-23.6-1.5-25.2,16.6c-1.5,16.7-5,57.2-5.5,63.4h343.4L426.2,143.3z"},"children":[]}]}]}]}]}]};exports.folder=folder;var forkRepo={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"class":"st0","points":"416,80 368,80 368,32 304,32 304,80 256,80 256,144 304,144 304,192 368,192 368,144 416,144 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"416,80 368,80 368,32 304,32 304,80 256,80 256,144 304,144 304,192 368,192 368,144 416,144 \t"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M304,240c0,38.6-4.5,42.3-14.4,50.3c-7.4,6-22.2,7.1-39.4,8.3c-9.5,0.7-20.4,1.5-31.4,3.3\r\n\t\tc-9.4,1.5-18.4,4.7-26.8,8.8V151.4c19.1-11.1,32-31.7,32-55.4c0-35.3-28.7-64-64-64S96,60.7,96,96c0,23.7,12.9,44.3,32,55.4v209.2\r\n\t\tc-19.1,11.1-32,31.7-32,55.4c0,35.3,28.7,64,64,64s64-28.7,64-64c0-15.7-5.7-30.1-15-41.2c6.7-4.8,13.9-8.7,20.2-9.7\r\n\t\tc8.1-1.3,16.6-1.9,25.6-2.6c24.4-1.7,52.1-3.7,75.2-22.5c30.9-25.1,37.5-52.1,38-94.9l0,0V240H304z M160,64c17.6,0,32,14.4,32,32\r\n\t\ts-14.4,32-32,32s-32-14.4-32-32S142.4,64,160,64z M160,448c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S177.6,448,160,448z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M304,240c0,38.6-4.5,42.3-14.4,50.3c-7.4,6-22.2,7.1-39.4,8.3c-9.5,0.7-20.4,1.5-31.4,3.3\r\n\t\tc-9.4,1.5-18.4,4.7-26.8,8.8V151.4c19.1-11.1,32-31.7,32-55.4c0-35.3-28.7-64-64-64S96,60.7,96,96c0,23.7,12.9,44.3,32,55.4v209.2\r\n\t\tc-19.1,11.1-32,31.7-32,55.4c0,35.3,28.7,64,64,64s64-28.7,64-64c0-15.7-5.7-30.1-15-41.2c6.7-4.8,13.9-8.7,20.2-9.7\r\n\t\tc8.1-1.3,16.6-1.9,25.6-2.6c24.4-1.7,52.1-3.7,75.2-22.5c30.9-25.1,37.5-52.1,38-94.9l0,0V240H304z M160,64c17.6,0,32,14.4,32,32\r\n\t\ts-14.4,32-32,32s-32-14.4-32-32S142.4,64,160,64z M160,448c-17.6,0-32-14.4-32-32s14.4-32,32-32s32,14.4,32,32S177.6,448,160,448z"},"children":[]}]}]}]};exports.forkRepo=forkRepo;var fork={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M270.2,148.9C270.2,149,270.1,149,270.2,148.9v0.1V148.9z"},"children":[{"name":"path","attribs":{"d":"M270.2,148.9C270.2,149,270.1,149,270.2,148.9v0.1V148.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M320,166c0-43.2-15-93.2-24-133.7V32h-8l-0.2,116.9c0,6.1-2.9,11.1-9,11.1c-5.7,0-8-4.3-8.6-9.9c-0.1-0.4,0-0.8,0-1.2\r\n\t\tL259.9,32h-8l-9,117l-0.1,1.1c-0.6,5.6-3.7,9.9-9.5,9.9c-6.1,0-9.1-5-9.1-11.1L223.8,32h-8C207,73,192,122.9,192,166.1\r\n\t\tc0,25.7,14.6,48.1,36.7,58.2c11.2,5.1,11.3,10.3,11.3,10.3s-16,201.7-16,213.1c0,11.4,4,18.5,9.5,24s14.2,8.2,22.4,8.2\r\n\t\tc0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c8.2,0,16.8-2.7,22.4-8.2c5.5-5.5,9.3-10.9,9.3-24c0-13.1-16-213.1-16-213.1s-1-5,11.4-10.6\r\n\t\tC305,214.2,320,191.8,320,166z"},"children":[{"name":"path","attribs":{"d":"M320,166c0-43.2-15-93.2-24-133.7V32h-8l-0.2,116.9c0,6.1-2.9,11.1-9,11.1c-5.7,0-8-4.3-8.6-9.9c-0.1-0.4,0-0.8,0-1.2\r\n\t\tL259.9,32h-8l-9,117l-0.1,1.1c-0.6,5.6-3.7,9.9-9.5,9.9c-6.1,0-9.1-5-9.1-11.1L223.8,32h-8C207,73,192,122.9,192,166.1\r\n\t\tc0,25.7,14.6,48.1,36.7,58.2c11.2,5.1,11.3,10.3,11.3,10.3s-16,201.7-16,213.1c0,11.4,4,18.5,9.5,24s14.2,8.2,22.4,8.2\r\n\t\tc0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c8.2,0,16.8-2.7,22.4-8.2c5.5-5.5,9.3-10.9,9.3-24c0-13.1-16-213.1-16-213.1s-1-5,11.4-10.6\r\n\t\tC305,214.2,320,191.8,320,166z"},"children":[]}]}]}]};exports.fork=fork;var forward={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,298.1v92.3L448,256L288,112v80C100.8,192,64,400,64,400C117,307,186.4,298.1,288,298.1z"},"children":[{"name":"path","attribs":{"d":"M288,298.1v92.3L448,256L288,112v80C100.8,192,64,400,64,400C117,307,186.4,298.1,288,298.1z"},"children":[]}]}]}]};exports.forward=forward;var funnel={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.085,32c-123.79,0-224.096,35.817-224.096,80c0,8.476,3.729,16.642,10.573,24.309l-0.061,0.008\r\n\t\tC74.408,175.213,192,313,192,352v87l0,0c0,22.688,28.891,41,64,41s64-18.312,64-41l0,0v-83.088c0-1.241,0.008-2.54,0.008-3.912\r\n\t\tC320.008,313,436,177.432,471,134.062v-0.002c6-7.007,8.977-14.408,8.977-22.06C479.977,67.817,379.875,32,256.085,32z\r\n\t\t M256.178,160c-92.058,0-176.112-22-176.112-48s83.053-48,176.112-48c93.06,0,176.111,22.413,176.111,48S348.236,160,256.178,160z"},"children":[{"name":"path","attribs":{"d":"M256.085,32c-123.79,0-224.096,35.817-224.096,80c0,8.476,3.729,16.642,10.573,24.309l-0.061,0.008\r\n\t\tC74.408,175.213,192,313,192,352v87l0,0c0,22.688,28.891,41,64,41s64-18.312,64-41l0,0v-83.088c0-1.241,0.008-2.54,0.008-3.912\r\n\t\tC320.008,313,436,177.432,471,134.062v-0.002c6-7.007,8.977-14.408,8.977-22.06C479.977,67.817,379.875,32,256.085,32z\r\n\t\t M256.178,160c-92.058,0-176.112-22-176.112-48s83.053-48,176.112-48c93.06,0,176.111,22.413,176.111,48S348.236,160,256.178,160z"},"children":[]}]}]}]};exports.funnel=funnel;var gearA={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M411.1,256c0-23.9,14.8-42.8,36.9-55.8c-4-13.3-9.3-26.2-15.8-38.2c-24.9,6.5-45-3.2-62-20.2c-16.9-16.9-22.1-37.1-15.6-62\r\n\t\tC342.6,73.3,329.8,68,316.4,64c-13,22.2-36.4,36.9-60.4,36.9c-23.9,0-47.4-14.7-60.4-36.9c-13.4,4-26.2,9.3-38.2,15.8\r\n\t\tc6.5,24.9,1.3,45-15.6,62c-16.9,16.9-37.1,26.7-61.9,20.2C73.3,174,68,186.8,64,200.2c22.2,13,37,31.9,37,55.8\r\n\t\tc0,23.9-14.8,47.4-37,60.4c4,13.4,9.3,26.2,15.8,38.2c24.9-6.5,45-1.3,61.9,15.6c17,16.9,22.1,37.1,15.6,62\r\n\t\tc12.1,6.5,24.8,11.8,38.2,15.8c13-22.2,36.5-36.9,60.4-36.9c23.9,0,47.4,14.7,60.4,36.9c13.4-4,26.2-9.3,38.2-15.8\r\n\t\tc-6.5-24.9-1.3-45,15.6-62c16.9-16.9,37.1-26.7,62-20.2c6.5-12.1,11.8-24.9,15.8-38.2C425.8,298.8,411.1,279.9,411.1,256z\r\n\t\t M256,354.3c-54.2,0-98.3-44-98.3-98.3c0-54.3,44-98.3,98.3-98.3c54.3,0,98.3,44,98.3,98.3C354.3,310.3,310.3,354.3,256,354.3z"},"children":[{"name":"path","attribs":{"d":"M411.1,256c0-23.9,14.8-42.8,36.9-55.8c-4-13.3-9.3-26.2-15.8-38.2c-24.9,6.5-45-3.2-62-20.2c-16.9-16.9-22.1-37.1-15.6-62\r\n\t\tC342.6,73.3,329.8,68,316.4,64c-13,22.2-36.4,36.9-60.4,36.9c-23.9,0-47.4-14.7-60.4-36.9c-13.4,4-26.2,9.3-38.2,15.8\r\n\t\tc6.5,24.9,1.3,45-15.6,62c-16.9,16.9-37.1,26.7-61.9,20.2C73.3,174,68,186.8,64,200.2c22.2,13,37,31.9,37,55.8\r\n\t\tc0,23.9-14.8,47.4-37,60.4c4,13.4,9.3,26.2,15.8,38.2c24.9-6.5,45-1.3,61.9,15.6c17,16.9,22.1,37.1,15.6,62\r\n\t\tc12.1,6.5,24.8,11.8,38.2,15.8c13-22.2,36.5-36.9,60.4-36.9c23.9,0,47.4,14.7,60.4,36.9c13.4-4,26.2-9.3,38.2-15.8\r\n\t\tc-6.5-24.9-1.3-45,15.6-62c16.9-16.9,37.1-26.7,62-20.2c6.5-12.1,11.8-24.9,15.8-38.2C425.8,298.8,411.1,279.9,411.1,256z\r\n\t\t M256,354.3c-54.2,0-98.3-44-98.3-98.3c0-54.3,44-98.3,98.3-98.3c54.3,0,98.3,44,98.3,98.3C354.3,310.3,310.3,354.3,256,354.3z"},"children":[]}]}]}]};exports.gearA=gearA;var gearB={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,294.4v-76.8h-42.8c-3.4-14.4-8.9-28-16.1-40.5l29.8-29.7l-54.3-54.3l-29.1,29.1c-12.6-7.7-26.4-13.5-41.1-17.3V64\r\n\th-76.8v40.9c-14.7,3.8-28.5,9.7-41.1,17.3l-29.1-29.1l-54.3,54.3l29.8,29.7c-7.2,12.5-12.6,26.1-16.1,40.5H64v76.8h44.1\r\n\tc3.8,13.7,9.5,26.6,16.7,38.6l-31.7,31.7l54.3,54.3l32.3-32.3c11.7,6.8,24.5,11.9,37.9,15.4v46h76.8v-46\r\n\tc13.5-3.5,26.2-8.6,37.9-15.4l32.3,32.3l54.3-54.3L387.3,333c7.2-11.9,12.9-24.8,16.7-38.6H448z M256,309.8\r\n\tc-29.7,0-53.7-24.1-53.7-53.8s24-53.8,53.7-53.8s53.8,24.1,53.8,53.8S285.7,309.8,256,309.8z"},"children":[]}]};exports.gearB=gearB;var grid={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[{"name":"path","attribs":{"d":"M160,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[{"name":"path","attribs":{"d":"M288,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M416,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[{"name":"path","attribs":{"d":"M416,153.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V153.3z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[{"name":"path","attribs":{"d":"M160,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[{"name":"path","attribs":{"d":"M288,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M416,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[{"name":"path","attribs":{"d":"M416,281.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V281.3z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[{"name":"path","attribs":{"d":"M160,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[{"name":"path","attribs":{"d":"M288,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M416,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[{"name":"path","attribs":{"d":"M416,409.3c0,3.7-3,6.7-6.7,6.7h-50.5c-3.7,0-6.7-3-6.7-6.7v-50.5c0-3.7,3-6.7,6.7-6.7h50.5c3.7,0,6.7,3,6.7,6.7V409.3z"},"children":[]}]}]}]}]}]};exports.grid=grid;var hammer={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M410,32h-52c-3.3,0-6,2.7-6,6v5.6c-4,4-10.9,9.8-17.8,9.8c-10.5,0-14.8-16.4-26.1-18.4s-27.2-3-37.9-3s-52,0.7-102,21.5\r\n\tc-50,20.8-71.7,64.9-72.3,81.4c-0.3,8.7,2.7,21.1,10,11.1c7.3-10,35.3-42.3,57.7-44.7c22.3-2.3,45.7,0.8,63.7,17.2\r\n\tc17.3,15.7,21.3,30.8,21.3,73.5l-6.6,2c-4.3,1.3-7,5.7-7,9c0,0-0.2,6.5-0.2,70.4C234.8,368,224,474,224,474c0,3.3,2.7,6,6,6h84\r\n\tc3.3,0,6-2.7,6-6c0,0-10.8-106-10.8-200.6c0-63.9-0.2-70.4-0.2-70.4c0-3.3-2.3-7.8-7-9l-8-2c0-38.2-0.4-54,6.3-65.9\r\n\tc7-12.4,22.3-22.9,29.7-25.1c5.9-1.8,16,1.3,22,6.5V122c0,3.3,2.7,6,6,6h52c3.3,0,6-2.7,6-6V38C416,34.7,413.3,32,410,32z"},"children":[]}]};exports.hammer=hammer;var happyOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M387.469,289.593c-2.248-1.175-4.775-1.796-7.308-1.796c-5.956,0-11.358,3.287-14.104,8.588\r\n\t\tC347.804,331.731,304.605,352,256.004,352c-49.734,0-93.84-20.562-109.757-54.997c-2.589-5.589-8.244-9.199-14.407-9.199\r\n\t\tc-2.294,0-4.521,0.485-6.658,1.463c-7.926,3.674-11.397,13.117-7.734,21.057C138.454,355.765,194.135,384,256.004,384\r\n\t\tc60.34,0,114.604-27.281,138.241-73.055C398.254,303.184,395.201,293.598,387.469,289.593z"},"children":[{"name":"path","attribs":{"d":"M387.469,289.593c-2.248-1.175-4.775-1.796-7.308-1.796c-5.956,0-11.358,3.287-14.104,8.588\r\n\t\tC347.804,331.731,304.605,352,256.004,352c-49.734,0-93.84-20.562-109.757-54.997c-2.589-5.589-8.244-9.199-14.407-9.199\r\n\t\tc-2.294,0-4.521,0.485-6.658,1.463c-7.926,3.674-11.397,13.117-7.734,21.057C138.454,355.765,194.135,384,256.004,384\r\n\t\tc60.34,0,114.604-27.281,138.241-73.055C398.254,303.184,395.201,293.598,387.469,289.593z"},"children":[]}]},{"name":"path","attribs":{"d":"M412.793,231.174C402.312,217.593,389.024,208,368.137,208c-20.887,0-34.062,9.573-44.611,23.117\r\n\t\tc-5.502,7.062-4.525,16.633,3.746,22.207c2.914,1.963,6.347,2.676,9.928,2.676c5.395-0.001,10.507-2.109,13.67-6.179\r\n\t\tc3.45-4.435,7.707-9.821,17.268-9.821c9.61,0,13.832,5.361,17.23,9.777c3.178,4.104,8.305,6.223,13.717,6.223\r\n\t\tc3.581,0,7.007-0.708,9.922-2.683C416.558,248.185,418.257,238.25,412.793,231.174z"},"children":[{"name":"path","attribs":{"d":"M412.793,231.174C402.312,217.593,389.024,208,368.137,208c-20.887,0-34.062,9.573-44.611,23.117\r\n\t\tc-5.502,7.062-4.525,16.633,3.746,22.207c2.914,1.963,6.347,2.676,9.928,2.676c5.395-0.001,10.507-2.109,13.67-6.179\r\n\t\tc3.45-4.435,7.707-9.821,17.268-9.821c9.61,0,13.832,5.361,17.23,9.777c3.178,4.104,8.305,6.223,13.717,6.223\r\n\t\tc3.581,0,7.007-0.708,9.922-2.683C416.558,248.185,418.257,238.25,412.793,231.174z"},"children":[]}]},{"name":"path","attribs":{"d":"M188.792,231.174C178.312,217.593,165.024,208,144.137,208s-34.063,9.573-44.612,23.117\r\n\t\tc-5.501,7.062-4.525,16.633,3.747,22.207c2.914,1.963,6.346,2.676,9.927,2.676c5.395-0.001,10.507-2.109,13.669-6.179\r\n\t\tc3.451-4.435,7.708-9.821,17.269-9.821c9.61,0,13.832,5.361,17.23,9.777c3.177,4.104,8.304,6.223,13.716,6.223\r\n\t\tc3.582,0,7.007-0.708,9.922-2.683C192.558,248.185,194.257,238.25,188.792,231.174z"},"children":[{"name":"path","attribs":{"d":"M188.792,231.174C178.312,217.593,165.024,208,144.137,208s-34.063,9.573-44.612,23.117\r\n\t\tc-5.501,7.062-4.525,16.633,3.747,22.207c2.914,1.963,6.346,2.676,9.927,2.676c5.395-0.001,10.507-2.109,13.669-6.179\r\n\t\tc3.451-4.435,7.708-9.821,17.269-9.821c9.61,0,13.832,5.361,17.23,9.777c3.177,4.104,8.304,6.223,13.716,6.223\r\n\t\tc3.582,0,7.007-0.708,9.922-2.683C192.558,248.185,194.257,238.25,188.792,231.174z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[]}]}]}]};exports.happyOutline=happyOutline;var happy={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M103.272,253.324\r\n\t\tc-8.272-5.574-9.249-15.145-3.747-22.207C110.074,217.573,123.25,208,144.137,208s34.174,9.593,44.655,23.174\r\n\t\tc5.464,7.076,3.765,17.011-3.787,22.144c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.716-6.223\r\n\t\tc-3.398-4.416-7.621-9.777-17.23-9.777c-9.561,0-13.818,5.387-17.269,9.821c-3.163,4.069-8.274,6.178-13.669,6.179\r\n\t\tC109.618,256,106.186,255.287,103.272,253.324z M394.245,310.945C370.607,356.719,316.344,384,256.004,384\r\n\t\tc-61.869,0-117.55-28.235-138.556-73.677c-3.663-7.939-0.191-17.383,7.734-21.057c2.137-0.978,4.363-1.463,6.658-1.463\r\n\t\tc6.163,0,11.818,3.61,14.407,9.199C162.164,331.438,206.27,352,256.004,352c48.602,0,91.8-20.269,110.053-55.615\r\n\t\tc2.746-5.301,8.148-8.588,14.104-8.588c2.532,0,5.06,0.621,7.308,1.796C395.201,293.598,398.254,303.184,394.245,310.945z\r\n\t\t M409.006,253.317c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.717-6.223c-3.398-4.416-7.62-9.777-17.23-9.777\r\n\t\tc-9.561,0-13.817,5.387-17.268,9.821c-3.163,4.069-8.275,6.178-13.67,6.179c-3.581,0-7.014-0.713-9.928-2.676\r\n\t\tc-8.271-5.574-9.248-15.145-3.746-22.207C334.074,217.573,347.25,208,368.137,208c20.888,0,34.175,9.593,44.656,23.174\r\n\t\tC418.257,238.25,416.558,248.185,409.006,253.317z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M103.272,253.324\r\n\t\tc-8.272-5.574-9.249-15.145-3.747-22.207C110.074,217.573,123.25,208,144.137,208s34.174,9.593,44.655,23.174\r\n\t\tc5.464,7.076,3.765,17.011-3.787,22.144c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.716-6.223\r\n\t\tc-3.398-4.416-7.621-9.777-17.23-9.777c-9.561,0-13.818,5.387-17.269,9.821c-3.163,4.069-8.274,6.178-13.669,6.179\r\n\t\tC109.618,256,106.186,255.287,103.272,253.324z M394.245,310.945C370.607,356.719,316.344,384,256.004,384\r\n\t\tc-61.869,0-117.55-28.235-138.556-73.677c-3.663-7.939-0.191-17.383,7.734-21.057c2.137-0.978,4.363-1.463,6.658-1.463\r\n\t\tc6.163,0,11.818,3.61,14.407,9.199C162.164,331.438,206.27,352,256.004,352c48.602,0,91.8-20.269,110.053-55.615\r\n\t\tc2.746-5.301,8.148-8.588,14.104-8.588c2.532,0,5.06,0.621,7.308,1.796C395.201,293.598,398.254,303.184,394.245,310.945z\r\n\t\t M409.006,253.317c-2.915,1.975-6.341,2.683-9.922,2.683c-5.412,0-10.539-2.119-13.717-6.223c-3.398-4.416-7.62-9.777-17.23-9.777\r\n\t\tc-9.561,0-13.817,5.387-17.268,9.821c-3.163,4.069-8.275,6.178-13.67,6.179c-3.581,0-7.014-0.713-9.928-2.676\r\n\t\tc-8.271-5.574-9.248-15.145-3.746-22.207C334.074,217.573,347.25,208,368.137,208c20.888,0,34.175,9.593,44.656,23.174\r\n\t\tC418.257,238.25,416.558,248.185,409.006,253.317z"},"children":[]}]}]}]};exports.happy=happy;var headphone={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M447.4,238.2c-3.2-59.8-21.9-108.6-56-145.2c-0.1-0.1-0.1-0.1-0.2-0.2c-7.7-8.4-16.1-15.9-24.8-22.6\r\n\tc-9-6.9-18.6-13-28.5-18.1c-25.3-13.1-53-20-82.1-20c-29,0-56.6,6.9-81.9,20c-9.9,5.1-19.4,11.2-28.4,18.1\r\n\tc-8.7,6.7-17,14.2-24.7,22.6c-0.1,0.1-0.1,0.1-0.2,0.2c-34,36.6-52.7,85.5-55.9,145.2C61.9,288.9,68,368,77.7,400\r\n\tc20.3,67,40.4,80,72.1,80s58.2-26.4,58.2-58.9V315.1c0-32.5-23.3-59-53.3-59c-18,0-34,9.7-43.8,24.4c0,0-11.1-8.1-13.1-23\r\n\tc-2.1-14.9-3.1-32.4,5.6-63c8.7-30.5,20.8-20.2,35.6-39c2.5-3.3,5.2-6.4,8-9.5c3.2-3.4,6.4-6.7,9.8-9.7c1.6-1.5,3.2-2.8,4.8-4.2\r\n\tc11-9.3,21-17,33.7-22.8c18.9-8.6,39.4-13.3,60.5-13.3c21,0,41.7,4.7,60.7,13.3c12.7,5.8,22.9,13.5,33.9,22.8\r\n\tc1.6,1.4,3.2,2.7,4.8,4.2c3.4,3,6.6,6.3,9.8,9.7c2.8,3.1,5.5,6.2,8,9.5c14.8,18.8,26.9,8.5,35.6,39c8.7,30.5,7.6,48.1,5.6,63\r\n\tc-2.1,14.9-13.1,23-13.1,23c-9.8-14.7-25.7-24.4-43.8-24.4c-30,0-53.3,26.4-53.3,59v106.1c0,32.4,26.5,58.9,58.2,58.9\r\n\tc31.7,0,51.8-13,72.1-80C444,368,450.1,288.9,447.4,238.2z"},"children":[]}]};exports.headphone=headphone;var heartBroken={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M229,288c1-18,0-38,8-55c2-5,1-10,1-15c-4-21-14-40-15-60c0-1.39,1.004-4.771,1.005-6.157\r\n\t\tc-3.216,2.234-7.607,4.024-11.005,5.157c-20,6-17.51,2.573-34.51,13.573l-11.933,7.228c16.343-17.939,38.528-24.781,56.525-38.714\r\n\t\tc0.194-15.438,0.858-30.677,3.137-45.84C185.61,53.496,121.785,54.268,82.123,95.57c-45.497,47.344-45.497,124.101,0,171.445\r\n\t\tl152.849,159.096c-0.085-10.656-0.443-21.176-1.972-31.111C227,359,229,324,229,288z"},"children":[{"name":"path","attribs":{"d":"M229,288c1-18,0-38,8-55c2-5,1-10,1-15c-4-21-14-40-15-60c0-1.39,1.004-4.771,1.005-6.157\r\n\t\tc-3.216,2.234-7.607,4.024-11.005,5.157c-20,6-17.51,2.573-34.51,13.573l-11.933,7.228c16.343-17.939,38.528-24.781,56.525-38.714\r\n\t\tc0.194-15.438,0.858-30.677,3.137-45.84C185.61,53.496,121.785,54.268,82.123,95.57c-45.497,47.344-45.497,124.101,0,171.445\r\n\t\tl152.849,159.096c-0.085-10.656-0.443-21.176-1.972-31.111C227,359,229,324,229,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M322,301c-11-26-33-44-63-50c-0.85,0-1.879-0.543-2.936-1.319c-0.023,0.107-0.041,0.213-0.064,0.319c-11,48-23,94-21,142\r\n\t\tc0,12.227,3.983,25.117,3.833,38.131L256,448l104-108.25C345.153,329.271,330.428,318.621,322,301z"},"children":[{"name":"path","attribs":{"d":"M322,301c-11-26-33-44-63-50c-0.85,0-1.879-0.543-2.936-1.319c-0.023,0.107-0.041,0.213-0.064,0.319c-11,48-23,94-21,142\r\n\t\tc0,12.227,3.983,25.117,3.833,38.131L256,448l104-108.25C345.153,329.271,330.428,318.621,322,301z"},"children":[]}]},{"name":"path","attribs":{"d":"M429.874,95.57c-40.426-42.094-105.989-42.094-146.408,0L264,115.403c0.075,13.175,0.213,26.202-3,38.597\r\n\t\tc-2,10-19,19-16,31c3.003,13.213,8.166,25.705,10.732,38.559C271.014,232.084,284.771,242.896,297,256\r\n\t\tc22.801,26.766,37.747,57.459,65.283,81.371l67.591-70.355C475.375,219.671,475.375,142.914,429.874,95.57z"},"children":[{"name":"path","attribs":{"d":"M429.874,95.57c-40.426-42.094-105.989-42.094-146.408,0L264,115.403c0.075,13.175,0.213,26.202-3,38.597\r\n\t\tc-2,10-19,19-16,31c3.003,13.213,8.166,25.705,10.732,38.559C271.014,232.084,284.771,242.896,297,256\r\n\t\tc22.801,26.766,37.747,57.459,65.283,81.371l67.591-70.355C475.375,219.671,475.375,142.914,429.874,95.57z"},"children":[]}]}]}]};exports.heartBroken=heartBroken;var heart={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M429.9,95.6c-40.4-42.1-106-42.1-146.4,0L256,124.1l-27.5-28.6c-40.5-42.1-106-42.1-146.4,0c-45.5,47.3-45.5,124.1,0,171.4\r\n\t\tL256,448l173.9-181C475.4,219.7,475.4,142.9,429.9,95.6z"},"children":[{"name":"path","attribs":{"d":"M429.9,95.6c-40.4-42.1-106-42.1-146.4,0L256,124.1l-27.5-28.6c-40.5-42.1-106-42.1-146.4,0c-45.5,47.3-45.5,124.1,0,171.4\r\n\t\tL256,448l173.9-181C475.4,219.7,475.4,142.9,429.9,95.6z"},"children":[]}]}]}]};exports.heart=heart;var helpBuoy={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M434.3,184.5l-61.5,18.9\r\n\tc-6.3-14-15.1-26.8-26.3-38c-11.2-11.2-24-20-38-26.3l18.9-61.5c23.8,9.5,45.6,23.9,64.3,42.5C410.4,138.9,424.8,160.7,434.3,184.5z\r\n\t M256,352c-53,0-96-43-96-96c0-53,43-96,96-96s96,43,96,96C352,309,309,352,256,352z M120.2,120.2c18.7-18.7,40.5-33,64.3-42.5\r\n\tl18.9,61.5c-14,6.3-26.8,15.1-38,26.3c-11.2,11.2-20,24-26.3,38l-61.5-18.9C87.2,160.7,101.6,138.9,120.2,120.2z M77.7,327.5\r\n\tl61.5-18.9c6.3,14,15.1,26.8,26.3,38s24,20,38,26.3l-18.9,61.5c-23.8-9.5-45.6-23.9-64.3-42.5C101.6,373.1,87.2,351.3,77.7,327.5z\r\n\t M391.8,391.8c-18.7,18.7-40.5,33-64.3,42.5l-18.9-61.5c14-6.3,26.8-15.1,38-26.3s20-24,26.3-38l61.5,18.9\r\n\tC424.8,351.3,410.4,373.1,391.8,391.8z"},"children":[]}]};exports.helpBuoy=helpBuoy;var helpCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224c123.7,0,224-100.3,224-224S379.7,32,256,32z M276.2,358.7\r\n\t\tc-0.5,17.8-13.7,28.8-30.8,28.3c-16.4-0.5-29.3-12.2-28.8-30.1c0.5-17.8,14.1-29.1,30.5-28.6C264.3,328.8,276.8,340.9,276.2,358.7z\r\n\t\t M324.9,231.4c-4.2,5.9-13.6,13.5-25.4,22.7l-13.1,9c-6.4,4.9-10.4,10.7-12.5,17.3c-1.1,3.5-1.9,12.6-2.1,18.7\r\n\t\tc-0.1,1.2-0.8,3.9-4.5,3.9c-3.7,0-35,0-39.1,0c-4.1,0-4.6-2.4-4.5-3.6c0.6-16.6,3-30.3,9.9-41.3c9.3-14.8,35.5-30.4,35.5-30.4\r\n\t\tc4-3,7.1-6.2,9.5-9.7c4.4-6,8-12.7,8-19.9c0-8.3-2-16.2-7.3-22.8c-6.2-7.7-12.9-11.4-25.8-11.4c-12.7,0-20.1,6.4-25.4,14.8\r\n\t\tc-5.3,8.4-4.4,18.3-4.4,27.3H175c0-34,8.9-55.7,27.7-68.5c12.7-8.7,28.9-12.5,47.8-12.5c24.8,0,44.5,4.6,61.9,17.8\r\n\t\tc16.1,12.2,24.6,29.4,24.6,52.6C337,209.7,332,221.7,324.9,231.4z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224c123.7,0,224-100.3,224-224S379.7,32,256,32z M276.2,358.7\r\n\t\tc-0.5,17.8-13.7,28.8-30.8,28.3c-16.4-0.5-29.3-12.2-28.8-30.1c0.5-17.8,14.1-29.1,30.5-28.6C264.3,328.8,276.8,340.9,276.2,358.7z\r\n\t\t M324.9,231.4c-4.2,5.9-13.6,13.5-25.4,22.7l-13.1,9c-6.4,4.9-10.4,10.7-12.5,17.3c-1.1,3.5-1.9,12.6-2.1,18.7\r\n\t\tc-0.1,1.2-0.8,3.9-4.5,3.9c-3.7,0-35,0-39.1,0c-4.1,0-4.6-2.4-4.5-3.6c0.6-16.6,3-30.3,9.9-41.3c9.3-14.8,35.5-30.4,35.5-30.4\r\n\t\tc4-3,7.1-6.2,9.5-9.7c4.4-6,8-12.7,8-19.9c0-8.3-2-16.2-7.3-22.8c-6.2-7.7-12.9-11.4-25.8-11.4c-12.7,0-20.1,6.4-25.4,14.8\r\n\t\tc-5.3,8.4-4.4,18.3-4.4,27.3H175c0-34,8.9-55.7,27.7-68.5c12.7-8.7,28.9-12.5,47.8-12.5c24.8,0,44.5,4.6,61.9,17.8\r\n\t\tc16.1,12.2,24.6,29.4,24.6,52.6C337,209.7,332,221.7,324.9,231.4z"},"children":[]}]}]}]};exports.helpCircled=helpCircled;var help={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M345.1,77.1C317.6,56.2,286.6,49,247.3,49c-29.8,0-55.3,6.1-75.5,19.7C142,89,128,123.1,128,177h76.8\r\n\t\tc0-14.4-1.4-29.9,7-43.2c8.4-13.3,20.1-23.5,40.2-23.5c20.4,0,30.9,5.9,40.8,18.1c8.4,10.4,11.6,22.8,11.6,36\r\n\t\tc0,11.4-5.8,21.9-12.7,31.4c-3.8,5.6-8.8,10.6-15.1,15.4c0,0-41.5,24.7-56.1,48.1c-10.9,17.4-14.8,39.2-15.7,65.3\r\n\t\tc-0.1,1.9,0.6,5.8,7.2,5.8c6.5,0,56,0,61.8,0c5.8,0,7-4.4,7.1-6.2c0.4-9.5,1.6-24.1,3.3-29.6c3.3-10.4,9.7-19.5,19.7-27.3\r\n\t\tl20.7-14.3c18.7-14.6,33.6-26.5,40.2-35.9c11.3-15.4,19.2-34.4,19.2-56.9C384,123.5,370.5,96.4,345.1,77.1z M242,370.2\r\n\t\tc-25.9-0.8-47.3,17.2-48.2,45.3c-0.8,28.2,19.5,46.7,45.5,47.5c27,0.8,47.9-16.6,48.7-44.7C288.8,390.2,269,371,242,370.2z"},"children":[{"name":"path","attribs":{"d":"M345.1,77.1C317.6,56.2,286.6,49,247.3,49c-29.8,0-55.3,6.1-75.5,19.7C142,89,128,123.1,128,177h76.8\r\n\t\tc0-14.4-1.4-29.9,7-43.2c8.4-13.3,20.1-23.5,40.2-23.5c20.4,0,30.9,5.9,40.8,18.1c8.4,10.4,11.6,22.8,11.6,36\r\n\t\tc0,11.4-5.8,21.9-12.7,31.4c-3.8,5.6-8.8,10.6-15.1,15.4c0,0-41.5,24.7-56.1,48.1c-10.9,17.4-14.8,39.2-15.7,65.3\r\n\t\tc-0.1,1.9,0.6,5.8,7.2,5.8c6.5,0,56,0,61.8,0c5.8,0,7-4.4,7.1-6.2c0.4-9.5,1.6-24.1,3.3-29.6c3.3-10.4,9.7-19.5,19.7-27.3\r\n\t\tl20.7-14.3c18.7-14.6,33.6-26.5,40.2-35.9c11.3-15.4,19.2-34.4,19.2-56.9C384,123.5,370.5,96.4,345.1,77.1z M242,370.2\r\n\t\tc-25.9-0.8-47.3,17.2-48.2,45.3c-0.8,28.2,19.5,46.7,45.5,47.5c27,0.8,47.9-16.6,48.7-44.7C288.8,390.2,269,371,242,370.2z"},"children":[]}]}]}]};exports.help=help;var home={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"448,288 256,64 64,288 112,288 112,448 208,448 208,320 304,320 304,448 400,448 400,288 \t"},"children":[{"name":"polygon","attribs":{"points":"448,288 256,64 64,288 112,288 112,448 208,448 208,320 304,320 304,448 400,448 400,288 \t"},"children":[]}]}]}]};exports.home=home;var icecream={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"128,256 256,480 384,256 \t"},"children":[{"name":"polygon","attribs":{"points":"128,256 256,480 384,256 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M402.5,172.6c-0.8-0.4-1.5-0.8-2.3-1.3c-4.4-2.8-8.4-8.5-8.7-12.7l0.1-0.7c3.2-9,5-19.2,5-29.8c0-53.1-43-96.1-96.1-96.1\r\n\t\t\tc-31.4,0-59.2,15-76.8,38.3c0,0-9.1,14-10.8,29c0,0,1.1-19.4,4.2-31.5c-7.4-2.5-15.4-3.8-23.6-3.8c-41.7,0-75.6,33.8-75.6,75.6\r\n\t\t\tc0,6.4,0.8,12.6,2.3,18.5c0,0.4-0.1,0.7-0.2,1c-0.9,5.1-4,9.5-8.4,12.3c-0.7,0.5-1.5,0.9-2.2,1.3c-8.2,5-13.5,13.6-13.5,23.4\r\n\t\t\tc0,15.4,13.5,28,29.9,28h4.1h252h4.1c16.4,0,29.8-12.5,29.8-28C416,186.3,410.6,177.6,402.5,172.6z"},"children":[{"name":"path","attribs":{"d":"M402.5,172.6c-0.8-0.4-1.5-0.8-2.3-1.3c-4.4-2.8-8.4-8.5-8.7-12.7l0.1-0.7c3.2-9,5-19.2,5-29.8c0-53.1-43-96.1-96.1-96.1\r\n\t\t\tc-31.4,0-59.2,15-76.8,38.3c0,0-9.1,14-10.8,29c0,0,1.1-19.4,4.2-31.5c-7.4-2.5-15.4-3.8-23.6-3.8c-41.7,0-75.6,33.8-75.6,75.6\r\n\t\t\tc0,6.4,0.8,12.6,2.3,18.5c0,0.4-0.1,0.7-0.2,1c-0.9,5.1-4,9.5-8.4,12.3c-0.7,0.5-1.5,0.9-2.2,1.3c-8.2,5-13.5,13.6-13.5,23.4\r\n\t\t\tc0,15.4,13.5,28,29.9,28h4.1h252h4.1c16.4,0,29.8-12.5,29.8-28C416,186.3,410.6,177.6,402.5,172.6z"},"children":[]}]}]}]}]}]};exports.icecream=icecream;var image={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,224c26.5,0,48-21.5,48-48c0-26.5-21.5-48-48-48c-26.5,0-48,21.5-48,48C320,202.5,341.5,224,368,224z"},"children":[{"name":"path","attribs":{"d":"M368,224c26.5,0,48-21.5,48-48c0-26.5-21.5-48-48-48c-26.5,0-48,21.5-48,48C320,202.5,341.5,224,368,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M452,64H60c-15.6,0-28,12.7-28,28.3v327.4c0,15.6,12.4,28.3,28,28.3h392c15.6,0,28-12.7,28-28.3V92.3\r\n\t\tC480,76.7,467.6,64,452,64z M348.9,261.7c-3-3.5-7.6-6.2-12.8-6.2c-5.1,0-8.7,2.4-12.8,5.7l-18.7,15.8c-3.9,2.8-7,4.7-11.5,4.7\r\n\t\tc-4.3,0-8.2-1.6-11-4.1c-1-0.9-2.8-2.6-4.3-4.1L224,215.3c-4-4.6-10-7.5-16.7-7.5c-6.7,0-12.9,3.3-16.8,7.8L64,368.2V107.7\r\n\t\tc1-6.8,6.3-11.7,13.1-11.7h357.7c6.9,0,12.5,5.1,12.9,12l0.3,260.4L348.9,261.7z"},"children":[{"name":"path","attribs":{"d":"M452,64H60c-15.6,0-28,12.7-28,28.3v327.4c0,15.6,12.4,28.3,28,28.3h392c15.6,0,28-12.7,28-28.3V92.3\r\n\t\tC480,76.7,467.6,64,452,64z M348.9,261.7c-3-3.5-7.6-6.2-12.8-6.2c-5.1,0-8.7,2.4-12.8,5.7l-18.7,15.8c-3.9,2.8-7,4.7-11.5,4.7\r\n\t\tc-4.3,0-8.2-1.6-11-4.1c-1-0.9-2.8-2.6-4.3-4.1L224,215.3c-4-4.6-10-7.5-16.7-7.5c-6.7,0-12.9,3.3-16.8,7.8L64,368.2V107.7\r\n\t\tc1-6.8,6.3-11.7,13.1-11.7h357.7c6.9,0,12.5,5.1,12.9,12l0.3,260.4L348.9,261.7z"},"children":[]}]}]}]};exports.image=image;var images={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M457.6,140.2l-82.5-4l-4.8-53.8c-1-11.3-11.1-19.2-22.9-18.3L51.4,88.4c-11.8,1-20.3,10.5-19.4,21.7l21.2,235.8\r\n\t\t\tc1,11.3,11.2,19.2,22.9,18.3l15-1.2l-2.4,45.8c-0.6,12.6,9.2,22.8,22.4,23.5L441.3,448c13.2,0.6,24.1-8.6,24.8-21.2L480,163.5\r\n\t\t\tC480.6,151,470.7,140.8,457.6,140.2z M102.6,145.5l-7.1,134.8L78.1,305l-16-178c0-0.2,0-0.3,0-0.5s0-0.3,0-0.5\r\n\t\t\tc0.5-5,4.3-9,9.5-9.4l261-21.4c5.2-0.4,9.7,3,10.5,7.9c0,0.2,0.3,0.2,0.3,0.4c0,0.1,0.3,0.2,0.3,0.4l2.7,30.8l-219-10.5\r\n\t\t\tC114.2,123.8,103.2,133,102.6,145.5z M436.7,382.4l-46.7-55.3l-27.5-32.7c-2.4-2.9-6.3-5.3-10.6-5.5c-4.3-0.2-7.5,1.5-11.1,4.1\r\n\t\t\tl-16.4,11.9c-3.5,2.1-6.2,3.5-9.9,3.3c-3.6-0.2-6.8-1.6-9.1-3.8c-0.8-0.8-2.3-2.2-3.5-3.4l-42.8-48.9c-3.1-3.9-8.2-6.4-13.8-6.7\r\n\t\t\tc-5.7-0.3-11.2,2.1-14.8,5.6L129.4,359.8l-6.8,7.4l0.3-6.8l6.8-128.9l3.3-62.9c0-0.2,0-0.4,0-0.5c0-0.2,0-0.4,0-0.5\r\n\t\t\tc1.4-5.4,6.2-9.3,11.9-9l204.2,9.8l28.7,1.4l58.3,2.8c5.8,0.3,10.3,4.7,10.4,10.2c0,0.2,0.3,0.3,0.3,0.5c0,0.2,0.3,0.3,0.3,0.5\r\n\t\t\tL436.7,382.4z"},"children":[{"name":"path","attribs":{"d":"M457.6,140.2l-82.5-4l-4.8-53.8c-1-11.3-11.1-19.2-22.9-18.3L51.4,88.4c-11.8,1-20.3,10.5-19.4,21.7l21.2,235.8\r\n\t\t\tc1,11.3,11.2,19.2,22.9,18.3l15-1.2l-2.4,45.8c-0.6,12.6,9.2,22.8,22.4,23.5L441.3,448c13.2,0.6,24.1-8.6,24.8-21.2L480,163.5\r\n\t\t\tC480.6,151,470.7,140.8,457.6,140.2z M102.6,145.5l-7.1,134.8L78.1,305l-16-178c0-0.2,0-0.3,0-0.5s0-0.3,0-0.5\r\n\t\t\tc0.5-5,4.3-9,9.5-9.4l261-21.4c5.2-0.4,9.7,3,10.5,7.9c0,0.2,0.3,0.2,0.3,0.4c0,0.1,0.3,0.2,0.3,0.4l2.7,30.8l-219-10.5\r\n\t\t\tC114.2,123.8,103.2,133,102.6,145.5z M436.7,382.4l-46.7-55.3l-27.5-32.7c-2.4-2.9-6.3-5.3-10.6-5.5c-4.3-0.2-7.5,1.5-11.1,4.1\r\n\t\t\tl-16.4,11.9c-3.5,2.1-6.2,3.5-9.9,3.3c-3.6-0.2-6.8-1.6-9.1-3.8c-0.8-0.8-2.3-2.2-3.5-3.4l-42.8-48.9c-3.1-3.9-8.2-6.4-13.8-6.7\r\n\t\t\tc-5.7-0.3-11.2,2.1-14.8,5.6L129.4,359.8l-6.8,7.4l0.3-6.8l6.8-128.9l3.3-62.9c0-0.2,0-0.4,0-0.5c0-0.2,0-0.4,0-0.5\r\n\t\t\tc1.4-5.4,6.2-9.3,11.9-9l204.2,9.8l28.7,1.4l58.3,2.8c5.8,0.3,10.3,4.7,10.4,10.2c0,0.2,0.3,0.3,0.3,0.5c0,0.2,0.3,0.3,0.3,0.5\r\n\t\t\tL436.7,382.4z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M373.2,262.3c19.4,0,35.2-15.8,35.2-35.2s-15.7-35.2-35.2-35.2c-19.4,0-35.2,15.7-35.2,35.2S353.7,262.3,373.2,262.3z"},"children":[{"name":"path","attribs":{"d":"M373.2,262.3c19.4,0,35.2-15.8,35.2-35.2s-15.7-35.2-35.2-35.2c-19.4,0-35.2,15.7-35.2,35.2S353.7,262.3,373.2,262.3z"},"children":[]}]}]}]};exports.images=images;var informationCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,253C478.3,129.3,376.7,30.4,253,32S30.4,135.3,32,259c1.7,123.7,103.3,222.6,227,221C382.7,478.3,481.7,376.7,480,253\r\n\t\tz M256,111.9c17.7,0,32,14.3,32,32s-14.3,32-32,32c-17.7,0-32-14.3-32-32S238.3,111.9,256,111.9z M300,395h-88v-11h22V224h-22v-12\r\n\t\th66v172h22V395z"},"children":[{"name":"path","attribs":{"d":"M480,253C478.3,129.3,376.7,30.4,253,32S30.4,135.3,32,259c1.7,123.7,103.3,222.6,227,221C382.7,478.3,481.7,376.7,480,253\r\n\t\tz M256,111.9c17.7,0,32,14.3,32,32s-14.3,32-32,32c-17.7,0-32-14.3-32-32S238.3,111.9,256,111.9z M300,395h-88v-11h22V224h-22v-12\r\n\t\th66v172h22V395z"},"children":[]}]}]}]};exports.informationCircled=informationCircled;var information={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"288,448 288,192 192,192 192,208 224,208 224,448 192,448 192,464 320,464 320,448 \t"},"children":[{"name":"polygon","attribs":{"points":"288,448 288,192 192,192 192,208 224,208 224,448 192,448 192,464 320,464 320,448 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M255.8,144.5c26.6,0,48.2-21.6,48.2-48.2s-21.6-48.2-48.2-48.2c-26.6,0-48.2,21.6-48.2,48.2S229.2,144.5,255.8,144.5z"},"children":[{"name":"path","attribs":{"d":"M255.8,144.5c26.6,0,48.2-21.6,48.2-48.2s-21.6-48.2-48.2-48.2c-26.6,0-48.2,21.6-48.2,48.2S229.2,144.5,255.8,144.5z"},"children":[]}]}]}]};exports.information=information;var ionic={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M423.592,132.804C427.006,127.714,429,121.59,429,115c0-17.675-14.33-32-32-32c-6.59,0-12.714,1.994-17.805,5.409\r\n\t\tC344.709,63.015,302.11,48,256,48C141.125,48,48,141.125,48,256c0,114.877,93.125,208,208,208c114.873,0,208-93.123,208-208\r\n\t\tC464,209.889,448.984,167.29,423.592,132.804z M391.83,391.832c-17.646,17.646-38.191,31.499-61.064,41.174\r\n\t\tc-23.672,10.012-48.826,15.089-74.766,15.089c-25.94,0-51.095-5.077-74.767-15.089c-22.873-9.675-43.417-23.527-61.064-41.174\r\n\t\ts-31.5-38.191-41.174-61.064C68.982,307.096,63.905,281.94,63.905,256c0-25.94,5.077-51.095,15.089-74.767\r\n\t\tc9.674-22.873,23.527-43.417,41.174-61.064s38.191-31.5,61.064-41.174C204.905,68.982,230.06,63.905,256,63.905\r\n\t\tc25.939,0,51.094,5.077,74.766,15.089c13.446,5.687,26.08,12.83,37.802,21.327C366.293,104.719,365,109.707,365,115\r\n\t\tc0,17.675,14.327,32,32,32c5.293,0,10.28-1.293,14.678-3.568c8.498,11.721,15.641,24.355,21.327,37.801\r\n\t\tc10.013,23.672,15.09,48.827,15.09,74.767c0,25.939-5.077,51.096-15.09,74.768C423.33,353.641,409.478,374.186,391.83,391.832z"},"children":[{"name":"path","attribs":{"d":"M423.592,132.804C427.006,127.714,429,121.59,429,115c0-17.675-14.33-32-32-32c-6.59,0-12.714,1.994-17.805,5.409\r\n\t\tC344.709,63.015,302.11,48,256,48C141.125,48,48,141.125,48,256c0,114.877,93.125,208,208,208c114.873,0,208-93.123,208-208\r\n\t\tC464,209.889,448.984,167.29,423.592,132.804z M391.83,391.832c-17.646,17.646-38.191,31.499-61.064,41.174\r\n\t\tc-23.672,10.012-48.826,15.089-74.766,15.089c-25.94,0-51.095-5.077-74.767-15.089c-22.873-9.675-43.417-23.527-61.064-41.174\r\n\t\ts-31.5-38.191-41.174-61.064C68.982,307.096,63.905,281.94,63.905,256c0-25.94,5.077-51.095,15.089-74.767\r\n\t\tc9.674-22.873,23.527-43.417,41.174-61.064s38.191-31.5,61.064-41.174C204.905,68.982,230.06,63.905,256,63.905\r\n\t\tc25.939,0,51.094,5.077,74.766,15.089c13.446,5.687,26.08,12.83,37.802,21.327C366.293,104.719,365,109.707,365,115\r\n\t\tc0,17.675,14.327,32,32,32c5.293,0,10.28-1.293,14.678-3.568c8.498,11.721,15.641,24.355,21.327,37.801\r\n\t\tc10.013,23.672,15.09,48.827,15.09,74.767c0,25.939-5.077,51.096-15.09,74.768C423.33,353.641,409.478,374.186,391.83,391.832z"},"children":[]}]},{"name":"circle","attribs":{"cx":"256.003","cy":"256","r":"96"},"children":[{"name":"circle","attribs":{"cx":"256.003","cy":"256","r":"96"},"children":[]}]}]}]};exports.ionic=ionic;var iosAlarmOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M438.4,192.4c12.2-14.2,19.6-32.3,19.6-52.2c0.1-43.8-35.5-79.6-80.4-82.1c-1.6-0.1-3.1-0.1-4.8-0.1\r\n\t\t\tc-20.4-0.1-39.1,6.8-53.8,18.1l53.8,52.4l-10.5,10.4c-25.7-19.4-57-32-91-34.9v-0.1c0-8.5-7-15.5-15.5-15.5\r\n\t\t\tc-8.5,0-15.5,7-15.5,15.5v0.1c-33.9,2.9-65.1,15.5-90.7,34.9l-10.4-10.4l53.8-52.4c-14.7-11.4-33.4-18.2-53.7-18.1\r\n\t\t\tc-1.6,0-3.2,0.1-4.8,0.1c-45,2.5-80.6,38.3-80.4,82.1c0,19.8,7.4,38,19.6,52.2l54-52.6l9.5,9.5c-35.1,31.9-57.1,78-57.1,129.2\r\n\t\t\tc0,43.9,16.2,84,43,114.7l-36.4,44.6L99,448l35.2-42.9c31.6,30.2,74.4,48.9,121.6,48.9h0.1c0,0,0.2,0,0.3,0\r\n\t\t\tc47.2,0,90.2-18.7,121.8-48.9l35.2,43l12.3-10.1L389,393.3c26.8-30.8,43-70.9,43-114.7c0-51.1-22-97.3-57.2-129.3l9.5-9.5\r\n\t\t\tL438.4,192.4z M76.2,167.8c-4.2-8.6-6.4-18.4-6.5-28c-0.1-35.1,28.4-64.6,65.5-66.8c12.7-0.7,23.1,1.4,32.1,6.1L76.2,167.8z\r\n\t\t\t M415.9,276.5c0,87.7-72,157.1-160.1,157.1C167.8,433.6,96,364.2,96,276.5c0-87.7,71.8-158.7,159.9-158.7\r\n\t\t\tC344,117.8,415.9,188.7,415.9,276.5z M344.7,79.2c8.8-4.8,19.3-6.8,32.1-6.1c37.2,2,65.6,31.5,65.5,66.8c0,9.6-2.3,19.4-6.5,28.1\r\n\t\t\tL344.7,79.2z"},"children":[{"name":"path","attribs":{"d":"M438.4,192.4c12.2-14.2,19.6-32.3,19.6-52.2c0.1-43.8-35.5-79.6-80.4-82.1c-1.6-0.1-3.1-0.1-4.8-0.1\r\n\t\t\tc-20.4-0.1-39.1,6.8-53.8,18.1l53.8,52.4l-10.5,10.4c-25.7-19.4-57-32-91-34.9v-0.1c0-8.5-7-15.5-15.5-15.5\r\n\t\t\tc-8.5,0-15.5,7-15.5,15.5v0.1c-33.9,2.9-65.1,15.5-90.7,34.9l-10.4-10.4l53.8-52.4c-14.7-11.4-33.4-18.2-53.7-18.1\r\n\t\t\tc-1.6,0-3.2,0.1-4.8,0.1c-45,2.5-80.6,38.3-80.4,82.1c0,19.8,7.4,38,19.6,52.2l54-52.6l9.5,9.5c-35.1,31.9-57.1,78-57.1,129.2\r\n\t\t\tc0,43.9,16.2,84,43,114.7l-36.4,44.6L99,448l35.2-42.9c31.6,30.2,74.4,48.9,121.6,48.9h0.1c0,0,0.2,0,0.3,0\r\n\t\t\tc47.2,0,90.2-18.7,121.8-48.9l35.2,43l12.3-10.1L389,393.3c26.8-30.8,43-70.9,43-114.7c0-51.1-22-97.3-57.2-129.3l9.5-9.5\r\n\t\t\tL438.4,192.4z M76.2,167.8c-4.2-8.6-6.4-18.4-6.5-28c-0.1-35.1,28.4-64.6,65.5-66.8c12.7-0.7,23.1,1.4,32.1,6.1L76.2,167.8z\r\n\t\t\t M415.9,276.5c0,87.7-72,157.1-160.1,157.1C167.8,433.6,96,364.2,96,276.5c0-87.7,71.8-158.7,159.9-158.7\r\n\t\t\tC344,117.8,415.9,188.7,415.9,276.5z M344.7,79.2c8.8-4.8,19.3-6.8,32.1-6.1c37.2,2,65.6,31.5,65.5,66.8c0,9.6-2.3,19.4-6.5,28.1\r\n\t\t\tL344.7,79.2z"},"children":[]}]}]}]},{"name":"polygon","attribs":{"points":"256,160 256,288 160,288 160,304 272,304 272,160 \t"},"children":[{"name":"polygon","attribs":{"points":"256,160 256,288 160,288 160,304 272,304 272,160 \t"},"children":[]}]}]}]};exports.iosAlarmOutline=iosAlarmOutline;var iosAlarm={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M438.4,192.4c12.2-14.2,19.6-32.3,19.6-52.2c0.1-43.8-35.5-79.6-80.4-82.1c-1.6-0.1-3.1-0.1-4.8-0.1\r\n\t\tc-20.4-0.1-39.1,6.8-53.8,18.1l53.8,52.4l-10.6,10.4c-25.7-19.4-57.2-32-91.2-34.9v-0.1c0-8.5-7-15.5-15.5-15.5s-15.5,7-15.5,15.5\r\n\t\tv0.1c-34,2.9-65,15.5-90.6,34.9L139,128.6l53.8-52.4c-14.7-11.4-33.4-18.2-53.7-18.1c-1.6,0-3.2,0.1-4.8,0.1\r\n\t\tc-45,2.5-80.6,38.3-80.4,82.1c0,19.8,7.4,38,19.6,52.2l54-52.6l9.5,9.5c-35.1,31.9-57.1,78-57.1,129.2c0,43.9,16.2,84,43,114.7\r\n\t\tl-36.4,44.6L99,448l35.2-42.9c31.6,30.2,74.4,48.9,121.6,48.9h0.1c0,0,0.2,0,0.3,0c47.2,0,90.2-18.7,121.8-48.9l35.2,43l12.3-10.1\r\n\t\tL389,393.3c26.8-30.8,43-70.9,43-114.7c0-51.1-22-97.3-57.2-129.3l9.5-9.5L438.4,192.4z M272,304H160v-16h96V160h16V304z"},"children":[{"name":"path","attribs":{"d":"M438.4,192.4c12.2-14.2,19.6-32.3,19.6-52.2c0.1-43.8-35.5-79.6-80.4-82.1c-1.6-0.1-3.1-0.1-4.8-0.1\r\n\t\tc-20.4-0.1-39.1,6.8-53.8,18.1l53.8,52.4l-10.6,10.4c-25.7-19.4-57.2-32-91.2-34.9v-0.1c0-8.5-7-15.5-15.5-15.5s-15.5,7-15.5,15.5\r\n\t\tv0.1c-34,2.9-65,15.5-90.6,34.9L139,128.6l53.8-52.4c-14.7-11.4-33.4-18.2-53.7-18.1c-1.6,0-3.2,0.1-4.8,0.1\r\n\t\tc-45,2.5-80.6,38.3-80.4,82.1c0,19.8,7.4,38,19.6,52.2l54-52.6l9.5,9.5c-35.1,31.9-57.1,78-57.1,129.2c0,43.9,16.2,84,43,114.7\r\n\t\tl-36.4,44.6L99,448l35.2-42.9c31.6,30.2,74.4,48.9,121.6,48.9h0.1c0,0,0.2,0,0.3,0c47.2,0,90.2-18.7,121.8-48.9l35.2,43l12.3-10.1\r\n\t\tL389,393.3c26.8-30.8,43-70.9,43-114.7c0-51.1-22-97.3-57.2-129.3l9.5-9.5L438.4,192.4z M272,304H160v-16h96V160h16V304z"},"children":[]}]}]}]};exports.iosAlarm=iosAlarm;var iosAlbumsOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M464,144v288H48V144H464 M480,128H32v320h448V128L480,128z"},"children":[{"name":"path","attribs":{"d":"M464,144v288H48V144H464 M480,128H32v320h448V128L480,128z"},"children":[]}]},{"name":"rect","attribs":{"x":"72","y":"96","width":"368","height":"16"},"children":[{"name":"rect","attribs":{"x":"72","y":"96","width":"368","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"104","y":"64","width":"304","height":"16"},"children":[{"name":"rect","attribs":{"x":"104","y":"64","width":"304","height":"16"},"children":[]}]}]}]};exports.iosAlbumsOutline=iosAlbumsOutline;var iosAlbums={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,128H32v320h448V128L480,128z"},"children":[{"name":"path","attribs":{"d":"M480,128H32v320h448V128L480,128z"},"children":[]}]},{"name":"rect","attribs":{"x":"72","y":"96","width":"368","height":"16"},"children":[{"name":"rect","attribs":{"x":"72","y":"96","width":"368","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"104","y":"64","width":"304","height":"16"},"children":[{"name":"rect","attribs":{"x":"104","y":"64","width":"304","height":"16"},"children":[]}]}]}]};exports.iosAlbums=iosAlbums;var iosAmericanfootballOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M378.605,133.395C305.902,60.691,189.38,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658\r\n\t\ts-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.149,464c38.926,0,65.192-3.658,65.192-3.658\r\n\t\tS490.326,245.116,378.605,133.395z M65.142,65.208C76.137,64.194,94.374,63,116.856,63H117l-0.068-0.071\r\n\t\tc27.167,0,53.167,1.754,77.792,5.22l-126.6,126.581c-1.025-7.283-1.91-14.697-2.64-22.246\r\n\t\tC60.898,125.049,63.398,84.256,65.142,65.208z M143.9,368.102c-23.85-23.852-42.793-54.938-56.304-92.396\r\n\t\tc-6.973-19.332-12.51-40.373-16.57-62.866L212.838,71.05c10.672,1.929,21.064,4.191,31.141,6.804\r\n\t\tc52.027,13.492,93.783,35.708,124.139,66.064c23.851,23.85,42.786,54.928,56.297,92.386c6.974,19.333,12.509,40.375,16.567,62.871\r\n\t\tL299.17,440.986c-10.66-1.93-21.041-4.191-31.104-6.801C216.036,420.696,174.26,398.459,143.9,368.102z M446.861,446.868\r\n\t\tc-10.994,1.012-29.23,2.275-51.71,2.275c-27.192,0-53.225-1.77-77.876-5.25l126.607-126.607c1.024,7.279,1.908,14.688,2.638,22.233\r\n\t\tC451.108,386.956,448.606,427.817,446.861,446.868z"},"children":[{"name":"path","attribs":{"d":"M378.605,133.395C305.902,60.691,189.38,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658\r\n\t\ts-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.149,464c38.926,0,65.192-3.658,65.192-3.658\r\n\t\tS490.326,245.116,378.605,133.395z M65.142,65.208C76.137,64.194,94.374,63,116.856,63H117l-0.068-0.071\r\n\t\tc27.167,0,53.167,1.754,77.792,5.22l-126.6,126.581c-1.025-7.283-1.91-14.697-2.64-22.246\r\n\t\tC60.898,125.049,63.398,84.256,65.142,65.208z M143.9,368.102c-23.85-23.852-42.793-54.938-56.304-92.396\r\n\t\tc-6.973-19.332-12.51-40.373-16.57-62.866L212.838,71.05c10.672,1.929,21.064,4.191,31.141,6.804\r\n\t\tc52.027,13.492,93.783,35.708,124.139,66.064c23.851,23.85,42.786,54.928,56.297,92.386c6.974,19.333,12.509,40.375,16.567,62.871\r\n\t\tL299.17,440.986c-10.66-1.93-21.041-4.191-31.104-6.801C216.036,420.696,174.26,398.459,143.9,368.102z M446.861,446.868\r\n\t\tc-10.994,1.012-29.23,2.275-51.71,2.275c-27.192,0-53.225-1.77-77.876-5.25l126.607-126.607c1.024,7.279,1.908,14.688,2.638,22.233\r\n\t\tC451.108,386.956,448.606,427.817,446.861,446.868z"},"children":[]}]},{"name":"polygon","attribs":{"points":"307.304,317.847 329.929,340.479 301.275,369.131 312.59,380.445 380.471,312.564 369.157,301.25 340.436,329.971 \r\n\t\t317.811,307.34 346.527,278.623 335.214,267.31 306.499,296.024 283.866,273.386 312.568,244.684 301.255,233.37 272.555,262.07 \r\n\t\t249.929,239.439 278.626,210.742 267.312,199.429 238.618,228.124 215.987,205.487 244.674,176.8 233.361,165.487 204.676,194.172 \r\n\t\t182.052,171.542 210.734,142.86 199.421,131.547 131.538,199.429 142.852,210.743 171.545,182.049 194.169,204.679 165.478,233.37 \r\n\t\t176.791,244.683 205.48,215.994 228.11,238.631 199.432,267.31 210.745,278.623 239.422,249.946 262.048,272.577 233.374,301.251 \r\n\t\t244.688,312.564 273.359,283.893 295.992,306.531 267.332,335.191 278.646,346.505 \t"},"children":[{"name":"polygon","attribs":{"points":"307.304,317.847 329.929,340.479 301.275,369.131 312.59,380.445 380.471,312.564 369.157,301.25 340.436,329.971 \r\n\t\t317.811,307.34 346.527,278.623 335.214,267.31 306.499,296.024 283.866,273.386 312.568,244.684 301.255,233.37 272.555,262.07 \r\n\t\t249.929,239.439 278.626,210.742 267.312,199.429 238.618,228.124 215.987,205.487 244.674,176.8 233.361,165.487 204.676,194.172 \r\n\t\t182.052,171.542 210.734,142.86 199.421,131.547 131.538,199.429 142.852,210.743 171.545,182.049 194.169,204.679 165.478,233.37 \r\n\t\t176.791,244.683 205.48,215.994 228.11,238.631 199.432,267.31 210.745,278.623 239.422,249.946 262.048,272.577 233.374,301.251 \r\n\t\t244.688,312.564 273.359,283.893 295.992,306.531 267.332,335.191 278.646,346.505 \t"},"children":[]}]}]}]};exports.iosAmericanfootballOutline=iosAmericanfootballOutline;var iosAmericanfootball={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M378.605,133.395C305.902,60.691,189.381,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658\r\n\t\t\ts-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.148,464c38.927,0,65.193-3.658,65.193-3.658\r\n\t\t\tS490.327,245.116,378.605,133.395z M68.124,194.728L194.707,68.146c6.123,0.861,12.164,1.825,18.112,2.899L71.025,212.838\r\n\t\t\tC69.955,206.901,68.987,200.862,68.124,194.728z M267.312,335.195l28.688-28.688l-22.627-22.628l-28.688,28.688l-11.313-11.312\r\n\t\t\tl28.688-28.688l-22.627-22.627l-28.688,28.688l-11.313-11.312l28.688-28.688l-22.628-22.628l-28.688,28.688l-11.313-11.312\r\n\t\t\tl28.689-28.689l-22.628-22.627l-28.688,28.688l-11.314-11.313l67.884-67.883l11.313,11.314l-28.688,28.688l22.628,22.627\r\n\t\t\tl28.688-28.688l11.313,11.313l-28.688,28.688l22.628,22.628l28.688-28.688l11.314,11.313l-28.688,28.688l22.627,22.627\r\n\t\t\tl28.688-28.688l11.313,11.312l-28.688,28.688l22.628,22.628l28.688-28.688l11.312,11.313l-28.688,28.688l22.627,22.627\r\n\t\t\tl28.688-28.688l11.314,11.312l-67.883,67.884l-11.313-11.313l28.688-28.688l-22.628-22.628l-28.688,28.688L267.312,335.195z\r\n\t\t\t M317.259,443.891c-6.121-0.863-12.159-1.83-18.104-2.906L440.979,299.16c1.071,5.938,2.038,11.977,2.901,18.111L317.259,443.891z\r\n\t\t\t"},"children":[{"name":"path","attribs":{"d":"M378.605,133.395C305.902,60.691,189.381,47.998,116.85,48c-38.926,0.001-65.191,3.658-65.191,3.658\r\n\t\t\ts-29.984,215.227,81.736,326.947C206.099,451.309,322.617,464,395.148,464c38.927,0,65.193-3.658,65.193-3.658\r\n\t\t\tS490.327,245.116,378.605,133.395z M68.124,194.728L194.707,68.146c6.123,0.861,12.164,1.825,18.112,2.899L71.025,212.838\r\n\t\t\tC69.955,206.901,68.987,200.862,68.124,194.728z M267.312,335.195l28.688-28.688l-22.627-22.628l-28.688,28.688l-11.313-11.312\r\n\t\t\tl28.688-28.688l-22.627-22.627l-28.688,28.688l-11.313-11.312l28.688-28.688l-22.628-22.628l-28.688,28.688l-11.313-11.312\r\n\t\t\tl28.689-28.689l-22.628-22.627l-28.688,28.688l-11.314-11.313l67.884-67.883l11.313,11.314l-28.688,28.688l22.628,22.627\r\n\t\t\tl28.688-28.688l11.313,11.313l-28.688,28.688l22.628,22.628l28.688-28.688l11.314,11.313l-28.688,28.688l22.627,22.627\r\n\t\t\tl28.688-28.688l11.313,11.312l-28.688,28.688l22.628,22.628l28.688-28.688l11.312,11.313l-28.688,28.688l22.627,22.627\r\n\t\t\tl28.688-28.688l11.314,11.312l-67.883,67.884l-11.313-11.313l28.688-28.688l-22.628-22.628l-28.688,28.688L267.312,335.195z\r\n\t\t\t M317.259,443.891c-6.121-0.863-12.159-1.83-18.104-2.906L440.979,299.16c1.071,5.938,2.038,11.977,2.901,18.111L317.259,443.891z\r\n\t\t\t"},"children":[]}]}]}]}]}]};exports.iosAmericanfootball=iosAmericanfootball;var iosAnalyticsOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48c28.087,0,55.325,5.497,80.958,16.339c24.767,10.476,47.013,25.476,66.12,44.583s34.107,41.354,44.583,66.12\r\n\t\tC458.503,200.675,464,227.913,464,256s-5.497,55.325-16.339,80.958c-10.476,24.767-25.476,47.013-44.583,66.12\r\n\t\ts-41.354,34.107-66.12,44.583C311.325,458.503,284.087,464,256,464s-55.325-5.497-80.958-16.339\r\n\t\tc-24.767-10.476-47.013-25.476-66.12-44.583s-34.107-41.354-44.583-66.12C53.497,311.325,48,284.087,48,256\r\n\t\ts5.497-55.325,16.339-80.958c10.476-24.767,25.476-47.013,44.583-66.12s41.354-34.107,66.12-44.583\r\n\t\tC200.675,53.497,227.913,48,256,48 M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224\r\n\t\tS379.712,32,256,32L256,32z"},"children":[{"name":"path","attribs":{"d":"M256,48c28.087,0,55.325,5.497,80.958,16.339c24.767,10.476,47.013,25.476,66.12,44.583s34.107,41.354,44.583,66.12\r\n\t\tC458.503,200.675,464,227.913,464,256s-5.497,55.325-16.339,80.958c-10.476,24.767-25.476,47.013-44.583,66.12\r\n\t\ts-41.354,34.107-66.12,44.583C311.325,458.503,284.087,464,256,464s-55.325-5.497-80.958-16.339\r\n\t\tc-24.767-10.476-47.013-25.476-66.12-44.583s-34.107-41.354-44.583-66.12C53.497,311.325,48,284.087,48,256\r\n\t\ts5.497-55.325,16.339-80.958c10.476-24.767,25.476-47.013,44.583-66.12s41.354-34.107,66.12-44.583\r\n\t\tC200.675,53.497,227.913,48,256,48 M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224\r\n\t\tS379.712,32,256,32L256,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M107.776,320c-25.252,0-41.168-18.448-41.902-19.317c-2.841-3.359-2.401-8.371,0.982-11.192\r\n\t\tc3.374-2.813,8.401-2.388,11.248,0.948c0.604,0.701,14.606,16.597,35.606,13.186c12.104-1.964,28.08-25.681,38.652-41.376\r\n\t\tc4.251-6.311,7.922-11.761,11.215-15.856c16.773-20.865,33.899-23.333,45.325-21.726c24.139,3.394,44.358,27.498,53.689,49.882\r\n\t\tc7.454,17.884,19.042,28.256,32.628,29.208c15.408,1.061,31.539-9.885,43.105-29.336c1.228-2.064,2.562-4.496,3.978-7.07\r\n\t\tc9.482-17.262,23.814-43.35,51.75-43.35c31.146,0,51.957,34.286,52.828,35.746c2.252,3.774,0.996,8.648-2.806,10.885\r\n\t\tc-3.8,2.237-8.708,0.988-10.96-2.786c-0.037-0.062-4.493-7.413-11.859-14.568c-6.286-6.107-16.108-13.387-27.203-13.387\r\n\t\tc-18.438,0-29.121,19.445-37.705,35.07c-1.48,2.696-2.88,5.243-4.245,7.538c-14.718,24.751-36.4,38.635-58.01,37.108\r\n\t\tc-19.951-1.398-36.389-15.242-46.284-38.98c-10.013-24.02-28.279-38.417-41.149-40.228c-10.6-1.494-20.895,3.861-30.578,15.906\r\n\t\tc-2.872,3.573-6.539,9.017-10.421,14.779c-13.549,20.114-30.411,45.146-49.37,48.223C113.349,319.784,110.507,320,107.776,320z"},"children":[{"name":"path","attribs":{"d":"M107.776,320c-25.252,0-41.168-18.448-41.902-19.317c-2.841-3.359-2.401-8.371,0.982-11.192\r\n\t\tc3.374-2.813,8.401-2.388,11.248,0.948c0.604,0.701,14.606,16.597,35.606,13.186c12.104-1.964,28.08-25.681,38.652-41.376\r\n\t\tc4.251-6.311,7.922-11.761,11.215-15.856c16.773-20.865,33.899-23.333,45.325-21.726c24.139,3.394,44.358,27.498,53.689,49.882\r\n\t\tc7.454,17.884,19.042,28.256,32.628,29.208c15.408,1.061,31.539-9.885,43.105-29.336c1.228-2.064,2.562-4.496,3.978-7.07\r\n\t\tc9.482-17.262,23.814-43.35,51.75-43.35c31.146,0,51.957,34.286,52.828,35.746c2.252,3.774,0.996,8.648-2.806,10.885\r\n\t\tc-3.8,2.237-8.708,0.988-10.96-2.786c-0.037-0.062-4.493-7.413-11.859-14.568c-6.286-6.107-16.108-13.387-27.203-13.387\r\n\t\tc-18.438,0-29.121,19.445-37.705,35.07c-1.48,2.696-2.88,5.243-4.245,7.538c-14.718,24.751-36.4,38.635-58.01,37.108\r\n\t\tc-19.951-1.398-36.389-15.242-46.284-38.98c-10.013-24.02-28.279-38.417-41.149-40.228c-10.6-1.494-20.895,3.861-30.578,15.906\r\n\t\tc-2.872,3.573-6.539,9.017-10.421,14.779c-13.549,20.114-30.411,45.146-49.37,48.223C113.349,319.784,110.507,320,107.776,320z"},"children":[]}]}]}]};exports.iosAnalyticsOutline=iosAnalyticsOutline;var iosAnalytics={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C141.174,32,46.544,118.404,33.54,229.739C32.534,238.354,32,247.114,32,256c0,1.783,0.026,3.561,0.067,5.333\r\n\tC34.901,382.581,134.071,480,256,480c105.255,0,193.537-72.602,217.542-170.454c1.337-5.451,2.474-10.979,3.404-16.579\r\n\tC478.943,280.939,480,268.594,480,256C480,132.288,379.712,32,256,32z M462.585,280.352c-7.265-7.807-13.064-16.09-15.702-20.429\r\n\tc-0.871-1.47-21.682-35.994-52.828-35.994c-27.937,0-42.269,26.269-51.751,43.65c-1.415,2.593-2.75,5.041-3.978,7.118\r\n\tc-11.566,19.587-27.693,30.608-43.105,29.541c-13.586-0.959-25.174-11.403-32.628-29.41c-9.331-22.54-29.551-46.812-53.689-50.229\r\n\tc-11.428-1.619-28.553,0.866-45.325,21.876c-3.293,4.124-6.964,9.612-11.215,15.967c-10.572,15.804-26.549,39.686-38.653,41.663\r\n\tc-21.02,3.438-35.021-12.596-35.583-13.249l-0.487-0.58l-0.587-0.479c-0.208-0.17-15.041-12.417-29.047-33.334\r\n\tc0-0.155-0.006-0.31-0.006-0.464c0-28.087,5.497-55.325,16.339-80.958c10.476-24.767,25.476-47.013,44.583-66.12\r\n\ts41.354-34.107,66.12-44.583C200.675,53.497,227.913,48,256,48s55.325,5.497,80.958,16.339\r\n\tc24.767,10.476,47.013,25.476,66.12,44.583s34.107,41.354,44.583,66.12C458.503,200.675,464,227.913,464,256\r\n\tC464,264.197,463.518,272.318,462.585,280.352z"},"children":[]}]};exports.iosAnalytics=iosAnalytics;var iosArrowBack={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"352,128.4 319.7,96 160,256 160,256 160,256 319.7,416 352,383.6 224.7,256 "},"children":[]}]};exports.iosArrowBack=iosArrowBack;var iosArrowDown={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"396.6,160 416,180.7 256,352 96,180.7 115.3,160 256,310.5 "},"children":[]}]};exports.iosArrowDown=iosArrowDown;var iosArrowForward={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"160,128.4 192.3,96 352,256 352,256 352,256 192.3,416 160,383.6 287.3,256 "},"children":[]}]};exports.iosArrowForward=iosArrowForward;var iosArrowLeft={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"352,115.4 331.3,96 160,256 331.3,416 352,396.7 201.5,256 "},"children":[]}]};exports.iosArrowLeft=iosArrowLeft;var iosArrowRight={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"160,115.4 180.7,96 352,256 180.7,416 160,396.7 310.5,256 "},"children":[]}]};exports.iosArrowRight=iosArrowRight;var iosArrowThinDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M349.7,322.2c-3.1-3.1-8-3-11.3,0L264,388.6V104c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8v284.6l-74.4-66.3\r\n\tc-3.4-2.9-8.1-3.2-11.2-0.1c-3.1,3.1-3.3,8.5-0.1,11.4c0,0,87,79.2,88,80s2.8,2.4,5.7,2.4s4.9-1.6,5.7-2.4s88-80,88-80\r\n\tc1.5-1.5,2.3-3.6,2.3-5.7C352,325.8,351.2,323.8,349.7,322.2z"},"children":[]}]};exports.iosArrowThinDown=iosArrowThinDown;var iosArrowThinLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M189.8,349.7c3.1-3.1,3-8,0-11.3L123.4,264H408c4.4,0,8-3.6,8-8c0-4.4-3.6-8-8-8H123.4l66.3-74.4c2.9-3.4,3.2-8.1,0.1-11.2\r\n\tc-3.1-3.1-8.5-3.3-11.4-0.1c0,0-79.2,87-80,88S96,253.1,96,256s1.6,4.9,2.4,5.7s80,88,80,88c1.5,1.5,3.6,2.3,5.7,2.3\r\n\tC186.2,352,188.2,351.2,189.8,349.7z"},"children":[]}]};exports.iosArrowThinLeft=iosArrowThinLeft;var iosArrowThinRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M322.2,349.7c-3.1-3.1-3-8,0-11.3l66.4-74.4H104c-4.4,0-8-3.6-8-8c0-4.4,3.6-8,8-8h284.6l-66.3-74.4\r\n\tc-2.9-3.4-3.2-8.1-0.1-11.2c3.1-3.1,8.5-3.3,11.4-0.1c0,0,79.2,87,80,88s2.4,2.8,2.4,5.7s-1.6,4.9-2.4,5.7s-80,88-80,88\r\n\tc-1.5,1.5-3.6,2.3-5.7,2.3C325.8,352,323.8,351.2,322.2,349.7z"},"children":[]}]};exports.iosArrowThinRight=iosArrowThinRight;var iosArrowThinUp={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M349.7,189.8c-3.1,3.1-8,3-11.3,0L264,123.4V408c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8V123.4l-74.4,66.3\r\n\tc-3.4,2.9-8.1,3.2-11.2,0.1c-3.1-3.1-3.3-8.5-0.1-11.4c0,0,87-79.2,88-80s2.8-2.4,5.7-2.4s4.9,1.6,5.7,2.4s88,80,88,80\r\n\tc1.5,1.5,2.3,3.6,2.3,5.7C352,186.2,351.2,188.2,349.7,189.8z"},"children":[]}]};exports.iosArrowThinUp=iosArrowThinUp;var iosArrowUp={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"396.6,352 416,331.3 256,160 96,331.3 115.3,352 256,201.5 "},"children":[]}]};exports.iosArrowUp=iosArrowUp;var iosAtOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M364.4,320.9c-5.3,7.5-11.6,14.7-18.8,21.4c-7.1,6.6-15.1,12.5-23.7,17.4c-8.6,4.9-17.9,8.8-27.5,11.5s-19.8,4.1-30.3,4.1\r\n\t\tc-15.9,0-31.2-2.6-45.5-7.6c-14.2-5-26.8-12.5-37.5-22.4c-10.7-9.8-21.7-25.9-28.2-41c-5.8-13.4-8.1-27.8-8.1-49.5\r\n\t\tc0-15.6,3.6-33,9.8-47.6c6-14,14.3-26.4,24.9-36.9c10.4-10.3,23-18.6,37.6-24.8c13.1-5.5,28.5-8.2,47.1-8.2c14.9,0,29,2.4,41.9,7\r\n\t\tc12.8,4.6,23.9,11.2,33.1,19.6c8.7,7.9,14,17.4,19.7,30.2c5,11.2,6.8,20.9,6.8,35.9c0,12.4-2.2,24.1-6.5,34.9\r\n\t\tc-4.3,10.6-7.5,17-14,25c-6.6,7.9-10.6,12.7-18.1,17.1c-8.6,5-15.3,7.4-21,7.4c-3.6,0-6.3-0.7-7.8-2c-1.5-1.3-2.4-3-2.7-5.4\r\n\t\tc-0.4-2.8-0.1-6.3,1-10.4c1.1-4.4,2.8-8.6,4.9-13.7L339.4,181h-17.8l-6.2,16.5c-3.8-6.1-9.1-11.5-15.9-15.5\r\n\t\tc-10.5-6.1-19.5-8.8-31.2-8.8c-13.5,0-26,3.5-37.2,10.4c-11,6.8-20.5,15.6-28.2,26.3c-7.5,10.3-9.3,15.7-12.9,26.4l-0.6,1.7\r\n\t\tc-4.2,12.4-6.3,24.6-6.3,36.2c0,7.7,1.4,15,4.1,21.8c2.7,6.8,6.4,12.8,11.1,17.8c4.7,5.1,10.4,9.1,16.9,12.1s13.7,4.5,21.3,4.5\r\n\t\tc8.5,0,16.6-1.4,26.1-4.7c6.3-2.2,11.9-5.8,17.4-11.4c1,3.2,2.7,6,5.3,8.5c5,5,11.7,7.6,19.9,7.6c8.6,0,17.8-3,29-9.3\r\n\t\tc9.9-5.6,15.7-12,23.3-21.1c8.2-9.8,12.3-18,16.9-29.7c5-12.5,7.5-26,7.5-40.3c0-18-2.4-30.2-8.5-43.6c-6.6-14.3-13.2-25.8-24-35.4\r\n\t\tc-10.9-9.6-23.9-17.1-38.5-22.3c-14.5-5.1-30.3-7.7-46.7-7.7c-20.1,0-37.2,3-52.2,9.1c-16.5,6.7-30.9,16-43,27.6\r\n\t\tc-12.2,11.8-22,25.9-29,41.9c-7.3,16.6-11.4,36.7-11.4,55.1c0,25.1,3.1,42.6,10.3,58.4c8,17.3,21,35.4,33.3,46\r\n\t\tc12.6,10.9,27.1,19.1,43.2,24.2c15.9,5.1,32.3,7.7,48.8,7.7c11.4,0,22.8-1.6,34-4.6c11.2-3.1,22-7.4,32.1-13.1\r\n\t\tc10.1-5.6,19.5-12.5,28.2-20.6c8.6-8.1,18.6-20.8,22-26.9c1.3-2.4,2.2-4.3,2.9-5.8h-18.5L364.4,320.9z M275.8,294.4\r\n\t\tc-4.4,5.6-7.7,9.5-11.8,12.2c-4.4,3-7.9,4.9-12.4,5.9c-4.6,1.2-9.3,1.7-13.7,1.7c-5.6,0-10.8-1-15.4-3c-4.7-2-8.7-4.8-12.1-8.4\r\n\t\tc-3.4-3.6-6.1-7.9-8.1-12.7c-1.9-4.8-2.9-10.2-2.9-16c0-9.5,1.8-19.7,5.3-30.3c0.4-1.2,0.8-2.4,1.1-3.4c2.8-8.6,4.3-11.5,9.5-20\r\n\t\tc5.7-9.4,14.1-16.6,23-22.5c8.6-5.8,18.2-8.7,28.5-8.7c4.2,0,8.6,0.5,13.2,1.5c3.6,0.8,5.6,1.9,9,3.9c0.6,0.3,1.1,0.6,1.7,1\r\n\t\tc3.9,2.2,7.4,5.1,10.4,8.7c2.7,3.2,4.8,7.4,6.3,12.3l-20.6,57.8C283.6,282.5,279.9,289.2,275.8,294.4z"},"children":[{"name":"path","attribs":{"d":"M364.4,320.9c-5.3,7.5-11.6,14.7-18.8,21.4c-7.1,6.6-15.1,12.5-23.7,17.4c-8.6,4.9-17.9,8.8-27.5,11.5s-19.8,4.1-30.3,4.1\r\n\t\tc-15.9,0-31.2-2.6-45.5-7.6c-14.2-5-26.8-12.5-37.5-22.4c-10.7-9.8-21.7-25.9-28.2-41c-5.8-13.4-8.1-27.8-8.1-49.5\r\n\t\tc0-15.6,3.6-33,9.8-47.6c6-14,14.3-26.4,24.9-36.9c10.4-10.3,23-18.6,37.6-24.8c13.1-5.5,28.5-8.2,47.1-8.2c14.9,0,29,2.4,41.9,7\r\n\t\tc12.8,4.6,23.9,11.2,33.1,19.6c8.7,7.9,14,17.4,19.7,30.2c5,11.2,6.8,20.9,6.8,35.9c0,12.4-2.2,24.1-6.5,34.9\r\n\t\tc-4.3,10.6-7.5,17-14,25c-6.6,7.9-10.6,12.7-18.1,17.1c-8.6,5-15.3,7.4-21,7.4c-3.6,0-6.3-0.7-7.8-2c-1.5-1.3-2.4-3-2.7-5.4\r\n\t\tc-0.4-2.8-0.1-6.3,1-10.4c1.1-4.4,2.8-8.6,4.9-13.7L339.4,181h-17.8l-6.2,16.5c-3.8-6.1-9.1-11.5-15.9-15.5\r\n\t\tc-10.5-6.1-19.5-8.8-31.2-8.8c-13.5,0-26,3.5-37.2,10.4c-11,6.8-20.5,15.6-28.2,26.3c-7.5,10.3-9.3,15.7-12.9,26.4l-0.6,1.7\r\n\t\tc-4.2,12.4-6.3,24.6-6.3,36.2c0,7.7,1.4,15,4.1,21.8c2.7,6.8,6.4,12.8,11.1,17.8c4.7,5.1,10.4,9.1,16.9,12.1s13.7,4.5,21.3,4.5\r\n\t\tc8.5,0,16.6-1.4,26.1-4.7c6.3-2.2,11.9-5.8,17.4-11.4c1,3.2,2.7,6,5.3,8.5c5,5,11.7,7.6,19.9,7.6c8.6,0,17.8-3,29-9.3\r\n\t\tc9.9-5.6,15.7-12,23.3-21.1c8.2-9.8,12.3-18,16.9-29.7c5-12.5,7.5-26,7.5-40.3c0-18-2.4-30.2-8.5-43.6c-6.6-14.3-13.2-25.8-24-35.4\r\n\t\tc-10.9-9.6-23.9-17.1-38.5-22.3c-14.5-5.1-30.3-7.7-46.7-7.7c-20.1,0-37.2,3-52.2,9.1c-16.5,6.7-30.9,16-43,27.6\r\n\t\tc-12.2,11.8-22,25.9-29,41.9c-7.3,16.6-11.4,36.7-11.4,55.1c0,25.1,3.1,42.6,10.3,58.4c8,17.3,21,35.4,33.3,46\r\n\t\tc12.6,10.9,27.1,19.1,43.2,24.2c15.9,5.1,32.3,7.7,48.8,7.7c11.4,0,22.8-1.6,34-4.6c11.2-3.1,22-7.4,32.1-13.1\r\n\t\tc10.1-5.6,19.5-12.5,28.2-20.6c8.6-8.1,18.6-20.8,22-26.9c1.3-2.4,2.2-4.3,2.9-5.8h-18.5L364.4,320.9z M275.8,294.4\r\n\t\tc-4.4,5.6-7.7,9.5-11.8,12.2c-4.4,3-7.9,4.9-12.4,5.9c-4.6,1.2-9.3,1.7-13.7,1.7c-5.6,0-10.8-1-15.4-3c-4.7-2-8.7-4.8-12.1-8.4\r\n\t\tc-3.4-3.6-6.1-7.9-8.1-12.7c-1.9-4.8-2.9-10.2-2.9-16c0-9.5,1.8-19.7,5.3-30.3c0.4-1.2,0.8-2.4,1.1-3.4c2.8-8.6,4.3-11.5,9.5-20\r\n\t\tc5.7-9.4,14.1-16.6,23-22.5c8.6-5.8,18.2-8.7,28.5-8.7c4.2,0,8.6,0.5,13.2,1.5c3.6,0.8,5.6,1.9,9,3.9c0.6,0.3,1.1,0.6,1.7,1\r\n\t\tc3.9,2.2,7.4,5.1,10.4,8.7c2.7,3.2,4.8,7.4,6.3,12.3l-20.6,57.8C283.6,282.5,279.9,289.2,275.8,294.4z"},"children":[]}]}]}]};exports.iosAtOutline=iosAtOutline;var iosAt={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M356,320c-9.7,13.3-29.9,28.5-38.1,33.1s-16.9,8.3-26,10.8c-9,2.5-18.6,3.9-28.4,3.9c-14.9,0-29.4-2.4-43-7.2\r\n\tc-13.3-4.7-25.2-11.8-35.1-21c-9.9-9-20.3-24.2-26.5-38.5c-5.3-12.4-7.6-25.8-7.6-46.5c0-14.7,3.4-30.9,9.2-44.7\r\n\tc5.6-13.2,13.5-24.9,23.3-34.6c9.7-9.6,21.6-17.5,35.3-23.3c12.3-5.1,26.7-7.7,44.4-7.7c13.9,0,27.2,2.2,39.4,6.6\r\n\tc11.9,4.3,22.3,10.4,30.9,18.3c8,7.3,12.9,16.1,18.2,28.1c4.6,10.2,6.3,19.2,6.3,33.3c0,11.5-2,22.4-6,32.4c-4,9.8-7,15.8-13,23.3\r\n\tc-6.3,7.6-9.8,11.8-16.5,15.6c-7.8,4.6-13.7,6.7-18.5,6.7c-3.8,0-5-0.9-5.1-1c-0.6-0.5-1.1-1.2-1.4-2.8c-0.3-2.2,0-5.2,0.9-8.6\r\n\tc1-3.9,2.4-7.7,4.6-12.9L342.3,179h-25.6l-4.5,12c-3.5-4.1-7.7-7.5-12.4-10.2c-11.1-6.4-20.4-9-32.3-9c-13.8,0-26.7,3.6-38.2,10.7\r\n\tc-11.2,6.9-20.8,15.8-28.5,26.5c-7.6,10.5-9.5,16.1-13,26.5l-0.6,1.8c-4.2,12.4-6.3,24.7-6.3,36.4c0,7.9,1.5,15.5,4.3,22.6\r\n\tc2.8,7.2,6.7,13.4,11.6,18.5c4.8,5.2,10.7,9.4,17.7,12.6c6.8,3.1,14.3,4.8,22.4,4.8c8.9,0,17.1-1.5,26.7-4.8\r\n\tc5.3-1.8,9.9-4.5,14.4-8.3c1,1.7,2.2,3.1,3.7,4.5c5.6,5.6,13.1,8.5,22.1,8.5c8.9,0,18.6-3,30.2-9.5c10.3-5.8,16.3-12.5,23.7-21.4\r\n\tc8.4-10,12.5-18.6,17-29.9c5.1-12.5,7.6-26.2,7.6-40.6c0-18.1-2.4-30.4-8.7-44c-6.6-14.4-13.3-25.9-24.3-35.6\r\n\tc-10.9-9.7-23.9-17.2-38.7-22.4c-14.6-5.1-30.3-7.7-46.7-7.7c-20,0-37.2,3-52.2,9.1c-16.3,6.6-30.8,15.9-43.1,27.6\r\n\tc-12.3,11.8-22.1,26-29.1,42c-7.3,16.5-11.4,36.5-11.4,55.1c0,25,3.1,42.4,10.4,58.4c8.1,17.5,21.2,35.5,33.4,45.9\r\n\tc12.7,11.1,27.3,19.2,43.4,24.3c15.9,5.1,32.3,7.7,48.6,7.7c11.2,0,22.7-1.6,34.1-4.6c11.6-3.2,22.4-7.6,32.1-13.1\r\n\tc9.9-5.5,19.5-12.4,28.2-20.6c8.8-8.2,19.4-20.9,22.9-27.1c1.2-2.3,2.2-4.2,2.8-5.6H356z M271.9,290.6c-4.4,5.5-7.2,8.9-10.6,11.2\r\n\tc-3.8,2.6-6.8,4.2-10.7,5.2h-0.1c-3.9,1-8.1,1.5-12.4,1.5c-5,0-9.4-0.9-13.4-2.7c-4.1-1.7-7.5-4.1-10.5-7.3\r\n\tc-2.9-3.1-5.4-6.8-7.1-11.1c-1.7-4.3-2.5-9-2.5-14.1c0-8.7,1.7-18.3,5-28.2c0.4-1.2,0.8-2.4,1.1-3.3c2.6-8.1,4-10.6,8.9-18.6\r\n\tc4.5-7.4,11.5-14.2,21.2-20.7c7.7-5.1,16.2-7.8,25.6-7.8c3.8,0,7.8,0.5,12,1.4c3,0.7,4.6,1.6,7.6,3.3l0.2,0.1\r\n\tc0.4,0.2,0.8,0.4,1.3,0.7l0.3,0.2c3.4,1.9,6.4,4.5,9,7.6c2,2.4,3.7,5.5,5,9.4L282,272.2C279,279.6,275.6,285.8,271.9,290.6z"},"children":[]}]};exports.iosAt=iosAt;var iosBarcodeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"48,384 128,384 128,368 64,368 64,144 128,144 128,128 48,128 \t"},"children":[{"name":"polygon","attribs":{"points":"48,384 128,384 128,368 64,368 64,144 128,144 128,128 48,128 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"384,128 384,144 448,144 448,368 384,368 384,384 464,384 464,128 \t"},"children":[{"name":"polygon","attribs":{"points":"384,128 384,144 448,144 448,368 384,368 384,384 464,384 464,128 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"112","y":"192","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"112","y":"192","width":"16","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"384","y":"192","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"384","y":"192","width":"16","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"320","y":"160","width":"16","height":"192"},"children":[{"name":"rect","attribs":{"x":"320","y":"160","width":"16","height":"192"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"160","width":"16","height":"192"},"children":[{"name":"rect","attribs":{"x":"176","y":"160","width":"16","height":"192"},"children":[]}]},{"name":"rect","attribs":{"x":"247","y":"176","width":"16","height":"160"},"children":[{"name":"rect","attribs":{"x":"247","y":"176","width":"16","height":"160"},"children":[]}]}]}]};exports.iosBarcodeOutline=iosBarcodeOutline;var iosBarcode={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48,128v256h416V128H48z M128,320h-16V192h16V320z M192,352h-16V160h16V352z M263,336h-16V176h16V336z M336,352h-16V160h16\r\n\t\tV352z M400,320h-16V192h16V320z"},"children":[{"name":"path","attribs":{"d":"M48,128v256h416V128H48z M128,320h-16V192h16V320z M192,352h-16V160h16V352z M263,336h-16V176h16V336z M336,352h-16V160h16\r\n\t\tV352z M400,320h-16V192h16V320z"},"children":[]}]}]}]};exports.iosBarcode=iosBarcode;var iosBaseballOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M462.686,279.369c0.132-1.182,0.257-2.365,0.369-3.554c0.004-0.038,0.007-0.078,0.011-0.117\r\n\tC463.675,269.213,464,262.645,464,256c0-114.863-93.13-208-208-208c-7.951,0-15.792,0.462-23.512,1.331\r\n\tc-0.089,0.01-0.18,0.018-0.27,0.028c0,0.001,0,0.002,0,0.003C135.207,60.409,58.442,138.199,48.989,235.687\r\n\tc-0.001,0-0.003,0-0.004,0c-0.072,0.748-0.131,1.497-0.195,2.246c-0.136,1.576-0.253,3.157-0.353,4.743\r\n\tc-0.026,0.418-0.056,0.835-0.08,1.254c-0.064,1.121-0.116,2.245-0.163,3.371c-0.011,0.281-0.021,0.562-0.032,0.843\r\n\tC48.065,250.751,48,253.368,48,256c0,114.863,93.137,208,208,208c2.627,0,5.239-0.065,7.843-0.162\r\n\tc0.293-0.011,0.586-0.021,0.878-0.033c1.11-0.046,2.219-0.098,3.324-0.16c0.454-0.025,0.906-0.058,1.359-0.086\r\n\tc1.604-0.103,3.201-0.222,4.795-0.36c0.704-0.061,1.41-0.115,2.113-0.184c0-0.001,0-0.003,0-0.004\r\n\tc97.494-9.452,175.279-86.216,186.326-183.229c0.001,0,0.002,0,0.004,0C462.658,279.645,462.67,279.507,462.686,279.369z\r\n\t M446.665,256c0,2.568-0.066,5.122-0.167,7.666c-10.334-0.468-20.552-1.69-30.614-3.664l6.11-19.056l-15.232-4.884l-6.488,20.235\r\n\tc-7.591-2.112-15.08-4.651-22.442-7.638c-4.976-2.018-9.851-4.223-14.625-6.604l11.518-17.003l-13.247-8.974l-12.359,18.246\r\n\tc-12.241-7.35-23.703-15.977-34.305-25.812l14.73-14.73l-11.313-11.313l-14.73,14.73c-9.555-10.297-17.964-21.408-25.175-33.254\r\n\tl18.487-12.522l-8.972-13.246l-17.324,11.735c-2.597-5.131-4.998-10.375-7.174-15.74c-2.843-7.009-5.276-14.134-7.327-21.352\r\n\tl20.812-6.673l-4.885-15.234l-19.711,6.32c-2.104-10.423-3.41-21.014-3.896-31.729c2.544-0.101,5.097-0.167,7.665-0.167\r\n\tC361.132,65.335,446.665,150.869,446.665,256z M65.337,256c0-1.317,0.023-2.629,0.05-3.939c9.064,0.559,18.039,1.687,26.891,3.409\r\n\tl-7.115,22.191l15.235,4.885l7.5-23.391c7.692,2.128,15.28,4.696,22.738,7.721c5.175,2.099,10.239,4.404,15.197,6.896l-13.405,19.79\r\n\tl13.246,8.973l14.219-20.992c12.038,7.279,23.32,15.793,33.765,25.483l-16.853,16.853l11.313,11.314l16.854-16.854\r\n\tc9.968,10.744,18.7,22.369,26.114,34.796l-20.753,14.058l8.972,13.246l19.473-13.19c2.283,4.611,4.4,9.317,6.347,14.116\r\n\tc3.161,7.795,5.834,15.729,8.016,23.778l-22.832,7.32l4.884,15.233l21.531-6.903c1.608,8.506,2.679,17.122,3.215,25.822\r\n\tc-1.311,0.026-2.622,0.05-3.939,0.05C150.87,446.664,65.336,361.13,65.337,256z M275.893,445.629\r\n\tc-0.621-9.974-1.911-19.911-3.859-29.746l24.1-7.727l-4.884-15.232l-22.896,7.341c-3.946-14.415-9.356-28.51-16.234-42.054\r\n\tl20.172-13.664l-8.973-13.246l-18.988,12.862c-7.888-13.094-17.233-25.552-28.04-37.145l17.081-17.081l-11.313-11.313\r\n\tl-17.082,17.081c-11.288-10.521-23.393-19.66-36.108-27.414l12.696-18.743l-13.246-8.972l-13.446,19.85\r\n\tc-13.548-6.974-27.659-12.467-42.094-16.494l7.158-22.325l-15.235-4.885l-7.52,23.452c-10.181-2.068-20.477-3.424-30.81-4.067\r\n\tc9.168-88.037,78.492-158.454,166.023-169.311c0.574,11.858,2.095,23.676,4.543,35.339l-25.935,8.316l4.885,15.234l24.903-7.985\r\n\tc4.045,14.144,9.504,27.967,16.386,41.246l-22.322,15.121l8.973,13.246l21.236-14.385c7.688,12.528,16.735,24.455,27.116,35.59\r\n\tl-19.204,19.204l11.313,11.314l19.204-19.205c11.447,10.669,23.735,19.921,36.647,27.745l-14.555,21.486l13.248,8.974l15.328-22.628\r\n\tc13.28,6.789,27.1,12.155,41.229,16.118l-8.168,25.477l15.232,4.884l8.525-26.59c11.301,2.312,22.744,3.754,34.224,4.31\r\n\tC434.347,367.137,363.93,436.46,275.893,445.629z"},"children":[]}]};exports.iosBaseballOutline=iosBaseballOutline;var iosBaseball={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48c-8.044,0-15.975,0.473-23.782,1.361l0,0l0,0C128.555,61.166,48,149.18,48,256c0,114.863,93.137,208,208,208\r\n\tc106.827,0,194.833-80.553,206.638-184.218l0,0l0,0C463.527,271.977,464,264.045,464,256C464,141.137,370.87,48,256,48z\r\n\t M259.939,446.614c-0.539-8.693-1.605-17.305-3.209-25.804l-21.511,6.896l-4.885-15.234l22.812-7.314\r\n\tc-2.183-8.056-4.856-15.994-8.02-23.794c-1.943-4.794-4.061-9.497-6.341-14.105l-19.464,13.186l-8.972-13.247l20.744-14.054\r\n\tc-7.416-12.429-16.149-24.057-26.119-34.803l-16.852,16.853l-11.313-11.313l16.852-16.852c-10.442-9.689-21.721-18.202-33.757-25.48\r\n\tl-14.216,20.988l-13.247-8.973l13.403-19.788c-4.96-2.491-10.027-4.799-15.206-6.9c-7.455-3.021-15.038-5.59-22.725-7.717\r\n\tl-7.5,23.392l-15.236-4.885l7.115-22.192c-8.856-1.723-17.835-2.853-26.904-3.412c0.109-5.373,0.438-10.695,0.984-15.953\r\n\tc10.339,0.647,20.639,1.998,30.827,4.068l7.518-23.454l15.237,4.886l-7.159,22.328c14.433,4.027,28.542,9.521,42.09,16.494\r\n\tl13.449-19.854l13.248,8.973l-12.7,18.748c12.712,7.754,24.815,16.892,36.1,27.411l17.082-17.082l11.314,11.314l-17.083,17.082\r\n\tc10.809,11.595,20.156,24.055,28.044,37.151l18.999-12.869l8.973,13.248l-20.183,13.67c6.878,13.546,12.289,27.642,16.232,42.058\r\n\tl22.919-7.349l4.885,15.236l-24.122,7.734c1.947,9.828,3.231,19.761,3.854,29.727C270.637,446.177,265.314,446.504,259.939,446.614z\r\n\t M410.961,275.293l-8.529,26.604l-15.236-4.885l8.174-25.493c-14.124-3.964-27.94-9.329-41.218-16.116l-15.335,22.641l-13.248-8.973\r\n\tl14.564-21.499c-12.912-7.826-25.199-17.077-36.644-27.746l-19.205,19.204l-11.312-11.314l19.202-19.203\r\n\tc-10.381-11.135-19.427-23.062-27.114-35.59l-21.248,14.393l-8.974-13.248l22.335-15.127c-6.881-13.278-12.339-27.099-16.384-41.241\r\n\tl-24.918,7.99l-4.885-15.237l25.951-8.321c-2.447-11.663-3.943-23.482-4.522-35.337c5.189-0.644,10.446-1.068,15.754-1.284\r\n\tc0.507,10.743,1.859,21.334,3.972,31.807l19.744-6.359l4.907,15.212l-20.789,6.658c2.051,7.218,4.491,14.338,7.333,21.348\r\n\tc2.176,5.363,4.578,10.603,7.174,15.731l17.315-11.729l8.973,13.246l-18.477,12.516c7.209,11.846,15.619,22.957,25.174,33.254\r\n\tl14.729-14.731l11.314,11.313l-14.732,14.731c10.602,9.836,22.062,18.463,34.302,25.813l12.352-18.235l13.248,8.973l-11.512,16.994\r\n\tc4.777,2.383,9.656,4.589,14.635,6.608c7.354,2.982,14.837,5.521,22.421,7.631l6.484-20.22l15.233,4.885l-6.104,19.043\r\n\tc10.116,1.984,20.286,3.311,30.626,3.824c-0.215,5.312-0.643,10.572-1.285,15.768C433.72,279.028,422.269,277.607,410.961,275.293z"},"children":[]}]};exports.iosBaseball=iosBaseball;var iosBasketballOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.137,48,48,141.136,48,256s93.137,208,208,208c114.871,0,208-93.138,208-208S370.871,48,256,48z M446.664,256\r\n\tc0,0.048-0.002,0.097-0.002,0.145c-22.315-1.721-43.989-6.972-64.62-15.699c-17.888-7.566-34.453-17.505-49.479-29.634\r\n\tc20.69-29.501,38.442-61.212,52.824-94.715C423.045,150.95,446.664,200.766,446.664,256z M372.606,105.261\r\n\tc-0.28,0.676-0.55,1.354-0.835,2.028c-13.908,32.883-31.062,63.956-51.286,92.987c-1.538-1.449-3.063-2.914-4.563-4.413\r\n\tc-19.107-19.107-34.107-41.354-44.583-66.12c-8.697-20.563-13.933-42.163-15.671-64.401c0.111,0,0.221-0.004,0.332-0.004\r\n\tC299.884,65.337,340.347,80.249,372.606,105.261z M239.675,66.044c4.431,58.126,31.044,110.041,71.391,147.312\r\n\tc-9.495,12.749-19.609,25.076-30.319,36.965c-47.554-50.032-104.815-90.746-168.767-119.132\r\n\tC143.616,94.733,188.833,70.375,239.675,66.044z M280.687,273.84c36.229,40.67,65.48,86.438,87.185,136.453\r\n\tc-25.4,18.467-55.51,30.829-88.162,34.898c-2.272-47.816-19.521-91.707-47.179-127.071\r\n\tC249.483,304.357,265.568,289.567,280.687,273.84z M262.039,270.039c-12.704,12.703-25.977,24.662-39.778,35.87\r\n\tc-38.737-42.885-93.831-70.706-155.45-73.635c4.07-32.646,16.432-62.75,34.896-88.146c59.195,25.688,112.445,61.947,158.332,107.833\r\n\tc3.323,3.323,6.59,6.689,9.812,10.089C267.277,264.736,264.677,267.401,262.039,270.039z M65.508,248.23\r\n\tc25.238,1.145,49.436,6.797,71.45,16.109c24.767,10.476,47.013,25.476,66.12,44.583c2.254,2.254,4.445,4.555,6.584,6.895\r\n\tc-31.414,23.915-65.427,44.049-101.708,60.182C81.322,343.205,65.336,301.437,65.336,256\r\n\tC65.336,253.396,65.404,250.809,65.508,248.23z M119.067,388.526c35.988-16.434,69.81-36.787,100.914-60.521\r\n\tc11.249,14.372,20.522,30.115,27.68,47.037c9.614,22.729,15.013,46.724,16.114,71.45c-2.58,0.104-5.17,0.172-7.775,0.172\r\n\tC202.317,446.664,153.751,424.353,119.067,388.526z M380.81,400.021c-22.489-50.671-52.72-97.14-89.191-137.909\r\n\tc11.101-12.269,21.634-25.061,31.556-38.336c34.171,27.342,76.521,44.885,122.801,48.363\r\n\tC441.686,323.058,417.311,368.347,380.81,400.021z"},"children":[]}]};exports.iosBasketballOutline=iosBasketballOutline;var iosBasketball={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.137,48,48,141.136,48,256s93.137,208,208,208c114.871,0,208-93.138,208-208S370.871,48,256,48z\r\n\t M380.797,400.032c-4.158,3.608-8.48,7.029-12.942,10.272c-21.704-50.015-50.938-95.795-87.168-136.465\r\n\tc-15.118,15.728-31.203,30.518-48.156,44.28c27.659,35.364,44.916,79.254,47.189,127.069c-5.252,0.655-10.571,1.086-15.944,1.303\r\n\tc-1.103-24.727-6.5-48.721-16.114-71.45c-7.158-16.922-16.431-32.665-27.68-47.037c-31.104,23.733-64.923,44.093-100.91,60.526\r\n\tc-3.883-4.011-7.592-8.191-11.115-12.529c36.28-16.134,70.291-36.271,101.705-60.186c-2.139-2.34-4.33-4.641-6.584-6.895\r\n\tc-19.107-19.107-41.354-34.107-66.12-44.583c-22.015-9.312-46.212-14.964-71.45-16.108c0.217-5.379,0.648-10.703,1.303-15.959\r\n\tc61.62,2.929,116.713,30.753,155.45,73.638c13.802-11.208,27.075-23.167,39.778-35.87c2.638-2.638,5.238-5.303,7.812-7.988\r\n\tc-3.223-3.4-6.489-6.767-9.812-10.09c-45.887-45.886-99.137-82.145-158.332-107.832c3.243-4.461,6.665-8.782,10.272-12.939\r\n\tc63.951,28.387,121.212,69.101,168.767,119.132c10.711-11.889,20.824-24.216,30.319-36.965\r\n\tc-40.347-37.271-66.956-89.188-71.388-147.312c5.273-0.449,10.604-0.692,15.99-0.702c1.738,22.238,6.974,43.838,15.671,64.401\r\n\tc10.476,24.767,25.476,47.013,44.583,66.12c1.5,1.5,3.025,2.965,4.562,4.413c20.226-29.031,37.379-60.104,51.287-92.987\r\n\tc0.285-0.674,0.555-1.353,0.835-2.028c4.419,3.426,8.681,7.042,12.779,10.835c-14.383,33.502-32.132,65.215-52.822,94.716\r\n\tc15.026,12.13,31.591,22.068,49.479,29.635c20.631,8.727,42.305,13.978,64.62,15.698c-0.004,5.387-0.243,10.717-0.688,15.991\r\n\tc-46.278-3.479-88.631-21.018-122.801-48.359c-9.922,13.275-20.455,26.067-31.556,38.336\r\n\tC328.091,302.883,358.307,349.36,380.797,400.032z"},"children":[]}]};exports.iosBasketball=iosBasketball;var iosBellOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M381.7,225.9c0-97.6-52.5-130.8-101.6-138.2c0-0.5,0.1-1,0.1-1.6c0-12.3-10.9-22.1-24.2-22.1c-13.3,0-23.8,9.8-23.8,22.1\r\n\t\tc0,0.6,0,1.1,0.1,1.6c-49.2,7.5-102,40.8-102,138.4c0,113.8-28.3,126-66.3,158h384C410.2,352,381.7,339.7,381.7,225.9z M107.2,368\r\n\t\tc8.6-9,16.4-18.4,22.7-31.8c12-25.3,17.4-59.2,17.4-110.2c0-46.4,12.5-80.4,37.1-101.2c22.9-19.3,51.7-23.3,71.8-23.3\r\n\t\tc20.1,0,48.9,4,71.6,23.3c24.5,20.7,37,54.5,37,100.9c0,83.8,14.9,117.3,40.3,142.3H107.2z"},"children":[{"name":"path","attribs":{"d":"M381.7,225.9c0-97.6-52.5-130.8-101.6-138.2c0-0.5,0.1-1,0.1-1.6c0-12.3-10.9-22.1-24.2-22.1c-13.3,0-23.8,9.8-23.8,22.1\r\n\t\tc0,0.6,0,1.1,0.1,1.6c-49.2,7.5-102,40.8-102,138.4c0,113.8-28.3,126-66.3,158h384C410.2,352,381.7,339.7,381.7,225.9z M107.2,368\r\n\t\tc8.6-9,16.4-18.4,22.7-31.8c12-25.3,17.4-59.2,17.4-110.2c0-46.4,12.5-80.4,37.1-101.2c22.9-19.3,51.7-23.3,71.8-23.3\r\n\t\tc20.1,0,48.9,4,71.6,23.3c24.5,20.7,37,54.5,37,100.9c0,83.8,14.9,117.3,40.3,142.3H107.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.2,448c26.8,0,48.8-19.9,51.7-43H204.5C207.3,428.1,229.4,448,256.2,448z"},"children":[{"name":"path","attribs":{"d":"M256.2,448c26.8,0,48.8-19.9,51.7-43H204.5C207.3,428.1,229.4,448,256.2,448z"},"children":[]}]}]}]};exports.iosBellOutline=iosBellOutline;var iosBell={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M381.7,225.9c0-97.6-52.5-130.8-101.6-138.2c0-0.5,0.1-1,0.1-1.6c0-12.3-10.9-22.1-24.2-22.1c-13.3,0-23.8,9.8-23.8,22.1\r\n\t\tc0,0.6,0,1.1,0.1,1.6c-49.2,7.5-102,40.8-102,138.4c0,113.8-28.3,126-66.3,158h384C410.2,352,381.7,339.7,381.7,225.9z"},"children":[{"name":"path","attribs":{"d":"M381.7,225.9c0-97.6-52.5-130.8-101.6-138.2c0-0.5,0.1-1,0.1-1.6c0-12.3-10.9-22.1-24.2-22.1c-13.3,0-23.8,9.8-23.8,22.1\r\n\t\tc0,0.6,0,1.1,0.1,1.6c-49.2,7.5-102,40.8-102,138.4c0,113.8-28.3,126-66.3,158h384C410.2,352,381.7,339.7,381.7,225.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.2,448c26.8,0,48.8-19.9,51.7-43H204.5C207.3,428.1,229.4,448,256.2,448z"},"children":[{"name":"path","attribs":{"d":"M256.2,448c26.8,0,48.8-19.9,51.7-43H204.5C207.3,428.1,229.4,448,256.2,448z"},"children":[]}]}]}]};exports.iosBell=iosBell;var iosBodyOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,47.959c17.645,0,32,14.351,32,31.991c0,17.64-14.355,31.99-32,31.99s-32-14.351-32-31.99\r\n\t\tC224,62.31,238.355,47.959,256,47.959 M256,31.964c-26.51,0-48,21.483-48,47.986c0,26.502,21.49,47.985,48,47.985\r\n\t\ts48-21.483,48-47.985C304,53.447,282.51,31.964,256,31.964L256,31.964z"},"children":[{"name":"path","attribs":{"d":"M256,47.959c17.645,0,32,14.351,32,31.991c0,17.64-14.355,31.99-32,31.99s-32-14.351-32-31.99\r\n\t\tC224,62.31,238.355,47.959,256,47.959 M256,31.964c-26.51,0-48,21.483-48,47.986c0,26.502,21.49,47.985,48,47.985\r\n\t\ts48-21.483,48-47.985C304,53.447,282.51,31.964,256,31.964L256,31.964z"},"children":[]}]},{"name":"path","attribs":{"d":"M424,144H88c-13.255,0-24,10.747-24,24s10.745,24,24,24h100.451c5.549,0,13.197,4.295,17.216,14.708\r\n\t\tc4.651,12.055,2.37,33.33-0.539,51.444l-3.923,21.26c-0.019,0.104-0.205,0.1-0.205,0.203l-32.229,172.238\r\n\t\tc-2.303,13.051,6.487,25.494,19.54,27.797c1.408,0.248,2.844,0.367,4.218,0.367c11.357,0,20.917-8.19,22.97-19.836L236,340.242\r\n\t\tv0.166c0,0,7.25-31.408,19.452-31.408h1.096C269,309,274,340.408,274,340.408v-0.082l21.483,119.895\r\n\t\tc2.052,11.642,12.331,19.815,23.763,19.815c1.387,0,2.855-0.121,4.268-0.368c13.053-2.303,21.821-14.76,19.519-27.811\r\n\t\tl-32.349-172.251c-0.002-0.008,0.011-0.02,0.009-0.027c-0.019-0.104-0.032-0.217-0.052-0.322l-3.771-21.411\r\n\t\tc-2.909-18.119-5.188-39.083-0.538-51.137C310.351,196.295,318.5,192,323.549,192H424c13.255,0,24-10.747,24-24\r\n\t\tS437.255,144,424,144z M88,176.113c-4.411,0-8-3.646-8-8.057c0-4.411,3.589-8.057,8-8.057h336c4.411,0,8,3.59,8,8s-3.589,8-8,8\r\n\t\tH322.5c-15.538,0-27.438,14.738-30.982,23.922c-4.846,12.557-5.004,31.942-0.388,60.688l-0.009,0.104l0.006,0.11l3.367,19.138\r\n\t\tl0.562,3.241l32.252,171.628c0.5,2.834-0.62,4.961-1.332,5.977c-0.713,1.017-2.335,2.799-5.179,3.301\r\n\t\tc-0.476,0.083-0.955,0.126-1.427,0.126c-3.893,0-7.207-2.639-7.883-6.472L290.255,338h-0.015c-0.271-2-1.828-10.05-5.022-18.771\r\n\t\tc-2.278-6.217-4.844-11.034-7.844-15.005C270.283,294.836,262.135,293,256.548,293h-1.096c-5.47,0-13.503,1.731-20.71,10.938\r\n\t\tc-3.05,3.896-5.729,8.671-8.19,14.802c-3.628,9.037-5.505,17.654-5.708,18.613l-0.11,0.369l-20.728,119.9\r\n\t\tc-0.693,3.886-3.75,6.596-7.441,6.596c-0.459,0-0.932-0.043-1.403-0.127c-2.84-0.5-4.455-2.275-5.165-3.288\r\n\t\tc-0.709-1.013-1.824-3.136-1.323-5.975l32.257-171.562l0.004-0.019l0.174-0.927l3.775-21.33l0.022-0.125l0.021-0.126\r\n\t\tc4.629-28.829,4.527-48.3-0.332-60.891c-3.543-9.181-13.576-23.737-31.76-23.737"},"children":[{"name":"path","attribs":{"d":"M424,144H88c-13.255,0-24,10.747-24,24s10.745,24,24,24h100.451c5.549,0,13.197,4.295,17.216,14.708\r\n\t\tc4.651,12.055,2.37,33.33-0.539,51.444l-3.923,21.26c-0.019,0.104-0.205,0.1-0.205,0.203l-32.229,172.238\r\n\t\tc-2.303,13.051,6.487,25.494,19.54,27.797c1.408,0.248,2.844,0.367,4.218,0.367c11.357,0,20.917-8.19,22.97-19.836L236,340.242\r\n\t\tv0.166c0,0,7.25-31.408,19.452-31.408h1.096C269,309,274,340.408,274,340.408v-0.082l21.483,119.895\r\n\t\tc2.052,11.642,12.331,19.815,23.763,19.815c1.387,0,2.855-0.121,4.268-0.368c13.053-2.303,21.821-14.76,19.519-27.811\r\n\t\tl-32.349-172.251c-0.002-0.008,0.011-0.02,0.009-0.027c-0.019-0.104-0.032-0.217-0.052-0.322l-3.771-21.411\r\n\t\tc-2.909-18.119-5.188-39.083-0.538-51.137C310.351,196.295,318.5,192,323.549,192H424c13.255,0,24-10.747,24-24\r\n\t\tS437.255,144,424,144z M88,176.113c-4.411,0-8-3.646-8-8.057c0-4.411,3.589-8.057,8-8.057h336c4.411,0,8,3.59,8,8s-3.589,8-8,8\r\n\t\tH322.5c-15.538,0-27.438,14.738-30.982,23.922c-4.846,12.557-5.004,31.942-0.388,60.688l-0.009,0.104l0.006,0.11l3.367,19.138\r\n\t\tl0.562,3.241l32.252,171.628c0.5,2.834-0.62,4.961-1.332,5.977c-0.713,1.017-2.335,2.799-5.179,3.301\r\n\t\tc-0.476,0.083-0.955,0.126-1.427,0.126c-3.893,0-7.207-2.639-7.883-6.472L290.255,338h-0.015c-0.271-2-1.828-10.05-5.022-18.771\r\n\t\tc-2.278-6.217-4.844-11.034-7.844-15.005C270.283,294.836,262.135,293,256.548,293h-1.096c-5.47,0-13.503,1.731-20.71,10.938\r\n\t\tc-3.05,3.896-5.729,8.671-8.19,14.802c-3.628,9.037-5.505,17.654-5.708,18.613l-0.11,0.369l-20.728,119.9\r\n\t\tc-0.693,3.886-3.75,6.596-7.441,6.596c-0.459,0-0.932-0.043-1.403-0.127c-2.84-0.5-4.455-2.275-5.165-3.288\r\n\t\tc-0.709-1.013-1.824-3.136-1.323-5.975l32.257-171.562l0.004-0.019l0.174-0.927l3.775-21.33l0.022-0.125l0.021-0.126\r\n\t\tc4.629-28.829,4.527-48.3-0.332-60.891c-3.543-9.181-13.576-23.737-31.76-23.737"},"children":[]}]}]}]};exports.iosBodyOutline=iosBodyOutline;var iosBody={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"79.838","r":"48"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"79.838","r":"48"},"children":[]}]},{"name":"path","attribs":{"d":"M424,144H88c-13.255,0-24,10.745-24,24s10.745,24,24,24h98.451c5.579,1,13.197,3.837,17.216,14.252\r\n\t\tc4.651,12.056,2.37,33.606-0.539,51.727l-3.775,21.395c-0.019,0.104-0.039,0.207-0.058,0.311c-0.002,0.008-0.002,0.012-0.004,0.02\r\n\t\tl-30.375,172.268c-2.303,13.053,6.414,25.5,19.467,27.803c13.055,2.301,25.333-6.416,27.634-19.471L237,340.348v0.167\r\n\t\tc0,0,6.25-32.515,18.452-32.515h1.096C269,308,275,340.515,275,340.515v-0.083l20.983,119.913\r\n\t\tc2.301,13.055,14.663,21.749,27.718,19.448c13.053-2.303,21.728-14.762,19.425-27.814L312.73,279.703\r\n\t\tc-0.002-0.008-0.013-0.02-0.015-0.027c-0.019-0.104-0.044-0.217-0.063-0.322l-3.777-21.414\r\n\t\tc-2.909-18.121-5.191-39.631-0.541-51.688C312.354,195.838,319.97,193,325.549,192H424c13.255,0,24-10.745,24-24\r\n\t\tS437.255,144,424,144z"},"children":[{"name":"path","attribs":{"d":"M424,144H88c-13.255,0-24,10.745-24,24s10.745,24,24,24h98.451c5.579,1,13.197,3.837,17.216,14.252\r\n\t\tc4.651,12.056,2.37,33.606-0.539,51.727l-3.775,21.395c-0.019,0.104-0.039,0.207-0.058,0.311c-0.002,0.008-0.002,0.012-0.004,0.02\r\n\t\tl-30.375,172.268c-2.303,13.053,6.414,25.5,19.467,27.803c13.055,2.301,25.333-6.416,27.634-19.471L237,340.348v0.167\r\n\t\tc0,0,6.25-32.515,18.452-32.515h1.096C269,308,275,340.515,275,340.515v-0.083l20.983,119.913\r\n\t\tc2.301,13.055,14.663,21.749,27.718,19.448c13.053-2.303,21.728-14.762,19.425-27.814L312.73,279.703\r\n\t\tc-0.002-0.008-0.013-0.02-0.015-0.027c-0.019-0.104-0.044-0.217-0.063-0.322l-3.777-21.414\r\n\t\tc-2.909-18.121-5.191-39.631-0.541-51.688C312.354,195.838,319.97,193,325.549,192H424c13.255,0,24-10.745,24-24\r\n\t\tS437.255,144,424,144z"},"children":[]}]}]}]};exports.iosBody=iosBody;var iosBoltOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M273.9,132l-16.5,89.1L254,240h19.2h64.8l-99.8,140l16.5-89.1L258,272h-19.2h-64.7L273.9,132 M302.7,64L143,288h95.8\r\n\tl-29.5,160L369,224h-95.8L302.7,64L302.7,64z"},"children":[]}]};exports.iosBoltOutline=iosBoltOutline;var iosBolt={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M302.7,64L143,288h95.8l-29.5,160L369,224h-95.8L302.7,64L302.7,64z"},"children":[]}]};exports.iosBolt=iosBolt;var iosBookOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M347.621,64c-40.941,0-79.121,14-91.578,44.495C242.5,78,205.408,64,164.466,64C109.265,64,64,89.98,64,143v1v8.995V417v9\r\n\th6.215h10.958h4.967c12.86-26.334,44.238-42,78.325-42c40.224,0,73.877,27.528,81.617,64h19.714c7.739-36.472,41.495-64,81.722-64\r\n\tc34.085,0,61.149,11.666,78.429,42h4.967h10.959H448v-17V148v-4v-1C448,89.98,402.823,64,347.621,64z M248,410.926\r\n\tC230,385.055,199.27,368,164.5,368c-34.769,0-64.5,10.055-83.5,35.926l-1,0.537V142l0,0v-1c3-41.825,40.089-61,84.293-61\r\n\tc45.162,0,82.145,18.708,83.363,61.808c-0.017,0.729,0.016,1.459,0.016,2.192L248,157.103V410.926z M432,148v255.926\r\n\tC414,378.055,382.269,368,347.5,368c-34.77,0-65.5,17.055-83.5,42.926V145v-1c0-44.112,37.659-64,83.587-64\r\n\tC391.79,80,429,91.175,432,133v1V148z"},"children":[]}]};exports.iosBookOutline=iosBookOutline;var iosBook={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M164.466,64C109.266,64,64,89.98,64,143v1v8.994V417v9h6.215h10.959h4.967c12.86-26.334,44.238-42,78.325-42\r\n\t\tc40.224,0,73.877,27.528,81.616,64H248V95.346C230.76,73.951,198.981,64,164.466,64z"},"children":[{"name":"path","attribs":{"d":"M164.466,64C109.266,64,64,89.98,64,143v1v8.994V417v9h6.215h10.959h4.967c12.86-26.334,44.238-42,78.325-42\r\n\t\tc40.224,0,73.877,27.528,81.616,64H248V95.346C230.76,73.951,198.981,64,164.466,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M347.621,64c-34.332,0-66.713,9.851-83.621,31.011V448h1.797c7.739-36.472,41.495-64,81.722-64\r\n\t\tc34.085,0,61.149,11.666,78.429,42h4.967h10.959H448v-17V148v-4v-1C448,89.98,402.823,64,347.621,64z"},"children":[{"name":"path","attribs":{"d":"M347.621,64c-34.332,0-66.713,9.851-83.621,31.011V448h1.797c7.739-36.472,41.495-64,81.722-64\r\n\t\tc34.085,0,61.149,11.666,78.429,42h4.967h10.959H448v-17V148v-4v-1C448,89.98,402.823,64,347.621,64z"},"children":[]}]}]}]};exports.iosBook=iosBook;var iosBookmarksOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M432,64H281.6c-10.3,0-19.3,4.6-25.6,11.7l0,0l0,0c-6.2-7.2-15.3-11.7-25.6-11.7H80c-18.8,0-33,13.3-33,32v286.1\r\n\tc0,18.8,14.2,33.9,33,33.9c0,0,129.5,0,143.3,0c13.8,0,24.7,4.2,24.7,19.4c0,9.1,0,12.6,0,12.6h8h8c0,0,0-3.4,0-12.6\r\n\tc0-15.3,10.9-19.4,24.7-19.4s143.3,0,143.3,0c18.8,0,33-15.1,33-33.9V96C465,77.3,450.8,64,432,64z M248,411.1\r\n\tc-4.7-7.8-13.5-11.1-23.8-11.1H80c-9.4,0-16-8.5-16-17.9V96c0-9.4,6.6-16,16-16c0,0,130.6,0,143.3,0c12.8,0,24.7,12.8,24.7,22.2\r\n\tV411.1z M320,80c18.8,0,43,0,64,0v100.4l-22.9-14.5l-9.1-6.4l-9.1,6.4L320,180.4V80z M448,382.1c0,9.4-6.6,17.9-16,17.9H287.8\r\n\tc-10.3,0-19.1,2.3-23.8,11.1V102.2c0-9.4,11.9-22.2,24.7-22.2c2.2,0,7.7,0,15.3,0v131l48-32l48,32V80c18.6,0,32,0,32,0\r\n\tc9.4,0,16,6.7,16,16V382.1z"},"children":[]}]};exports.iosBookmarksOutline=iosBookmarksOutline;var iosBookmarks={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M342.9,165.4l9.1-6.4l9.1,6.4l22.9,14.5V64c-20.7,0-44.5,0-64,0v115.9L342.9,165.4z"},"children":[{"name":"path","attribs":{"d":"M342.9,165.4l9.1-6.4l9.1,6.4l22.9,14.5V64c-20.7,0-44.5,0-64,0v115.9L342.9,165.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M432,64c0,0-13.3,0-32,0v146.5l-48-32l-48,32V64c-12.1,0-20.6,0-22.4,0c-8.1,0-17.6,7.2-17.6,15s0,329,0,329l-8,5.5l-8-5.5\r\n\t\tc0,0,0-322,0-329s-9.2-15-17.6-15S80,64,80,64c-18.8,0-33,13.3-33,32v286.1c0,18.8,14.2,33.9,33,33.9c0,0,129.5,0,143.3,0\r\n\t\tc13.8,0,24.7,4.2,24.7,19.4c0,9.1,0,12.6,0,12.6h8h8c0,0,0-3.4,0-12.6c0-15.3,10.9-19.4,24.7-19.4s143.3,0,143.3,0\r\n\t\tc18.8,0,33-15.1,33-33.9V96C465,77.3,450.8,64,432,64z"},"children":[{"name":"path","attribs":{"d":"M432,64c0,0-13.3,0-32,0v146.5l-48-32l-48,32V64c-12.1,0-20.6,0-22.4,0c-8.1,0-17.6,7.2-17.6,15s0,329,0,329l-8,5.5l-8-5.5\r\n\t\tc0,0,0-322,0-329s-9.2-15-17.6-15S80,64,80,64c-18.8,0-33,13.3-33,32v286.1c0,18.8,14.2,33.9,33,33.9c0,0,129.5,0,143.3,0\r\n\t\tc13.8,0,24.7,4.2,24.7,19.4c0,9.1,0,12.6,0,12.6h8h8c0,0,0-3.4,0-12.6c0-15.3,10.9-19.4,24.7-19.4s143.3,0,143.3,0\r\n\t\tc18.8,0,33-15.1,33-33.9V96C465,77.3,450.8,64,432,64z"},"children":[]}]}]}]};exports.iosBookmarks=iosBookmarks;var iosBoxOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M287.8,240c8.8,0,16.1,7.2,16.1,16s-7,16-15.9,16h-64c-8.8,0-16-7.2-16-16s7.2-16,16-16h63 M288,224h-64\r\n\t\tc-17.6,0-32,14.4-32,32s14.4,32,32,32h64c17.6,0,32-14.4,32-32S305.6,224,288,224L288,224z"},"children":[{"name":"path","attribs":{"d":"M287.8,240c8.8,0,16.1,7.2,16.1,16s-7,16-15.9,16h-64c-8.8,0-16-7.2-16-16s7.2-16,16-16h63 M288,224h-64\r\n\t\tc-17.6,0-32,14.4-32,32s14.4,32,32,32h64c17.6,0,32-14.4,32-32S305.6,224,288,224L288,224z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,112H96v80h16v208h288V192h16V112z M384,384H128V192h256V384z M400,176H112v-48h288V176z"},"children":[{"name":"path","attribs":{"d":"M416,112H96v80h16v208h288V192h16V112z M384,384H128V192h256V384z M400,176H112v-48h288V176z"},"children":[]}]}]}]}]}]};exports.iosBoxOutline=iosBoxOutline;var iosBox={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M112,400h288V208H112V400z M224,240h64c8.8,0,16,7.2,16,16s-7.2,16-16,16h-64c-8.8,0-16-7.2-16-16S215.2,240,224,240z"},"children":[{"name":"path","attribs":{"d":"M112,400h288V208H112V400z M224,240h64c8.8,0,16,7.2,16,16s-7.2,16-16,16h-64c-8.8,0-16-7.2-16-16S215.2,240,224,240z"},"children":[]}]},{"name":"polygon","attribs":{"points":"96,112 96,192 112,192 400,192 416,192 416,112 \t"},"children":[{"name":"polygon","attribs":{"points":"96,112 96,192 112,192 400,192 416,192 416,112 \t"},"children":[]}]}]}]};exports.iosBox=iosBox;var iosBriefcaseOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,128v-16h-32v16h-48V98.1V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v2.1V128h-48v-16H96v16H48v320\r\n\t\th416V128H416z M192,127.5V98.1c0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1v29.4v0.5H192V127.5z M448,432H64V208h384\r\n\t\tV432z M448,192H64v-48h32v16h32v-16h256v16h32v-16h32V192z"},"children":[{"name":"path","attribs":{"d":"M416,128v-16h-32v16h-48V98.1V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v2.1V128h-48v-16H96v16H48v320\r\n\t\th416V128H416z M192,127.5V98.1c0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1v29.4v0.5H192V127.5z M448,432H64V208h384\r\n\t\tV432z M448,192H64v-48h32v16h32v-16h256v16h32v-16h32V192z"},"children":[]}]}]}]};exports.iosBriefcaseOutline=iosBriefcaseOutline;var iosBriefcase={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"96","y":"112","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"96","y":"112","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"48","y":"208","width":"416","height":"240"},"children":[{"name":"rect","attribs":{"x":"48","y":"208","width":"416","height":"240"},"children":[]}]},{"name":"rect","attribs":{"x":"384","y":"112","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"384","y":"112","width":"32","height":"16"},"children":[]}]},{"name":"path","attribs":{"d":"M416,128v32h-32v-32h-48V98.1V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v2.1V128h-48v32H96v-32H48v64\r\n\t\th416v-64H416z M320,127.5v0.5H192v-0.5V98.1c0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V127.5z"},"children":[{"name":"path","attribs":{"d":"M416,128v32h-32v-32h-48V98.1V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v2.1V128h-48v32H96v-32H48v64\r\n\t\th416v-64H416z M320,127.5v0.5H192v-0.5V98.1c0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V127.5z"},"children":[]}]}]}]};exports.iosBriefcase=iosBriefcase;var iosBrowsersOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,144v304h303.9V144H64z M351.9,432H80V160h271.9V432z"},"children":[{"name":"path","attribs":{"d":"M64,144v304h303.9V144H64z M351.9,432H80V160h271.9V432z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"448,64 144,64 144,128 160,128 160,80 432,80 432,352 384,352 384,368 448,368 \t\t"},"children":[{"name":"polygon","attribs":{"points":"448,64 144,64 144,128 160,128 160,80 432,80 432,352 384,352 384,368 448,368 \t\t"},"children":[]}]}]}]}]}]};exports.iosBrowsersOutline=iosBrowsersOutline;var iosBrowsers={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,144v304h303.9V144H64z"},"children":[{"name":"path","attribs":{"d":"M64,144v304h303.9V144H64z"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,64 144,128 384,128 384,368 448,368 448,64 \t"},"children":[{"name":"polygon","attribs":{"points":"144,64 144,128 384,128 384,368 448,368 448,64 \t"},"children":[]}]}]}]};exports.iosBrowsers=iosBrowsers;var iosCalculatorOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,160h224V96H144V160z M160,112h192v32H160V112z"},"children":[{"name":"path","attribs":{"d":"M144,160h224V96H144V160z M160,112h192v32H160V112z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,64H144c-17.7,0-32,14.3-32,32v320c0,17.7,14.3,32,32,32h224c17.7,0,32-14.3,32-32V96C400,78.3,385.7,64,368,64z\r\n\t\t M384,416c0,8.8-7.2,16-16,16H144c-8.8,0-16-7.2-16-16V96c0-8.8,7.2-16,16-16h224c8.8,0,16,7.2,16,16V416z"},"children":[{"name":"path","attribs":{"d":"M368,64H144c-17.7,0-32,14.3-32,32v320c0,17.7,14.3,32,32,32h224c17.7,0,32-14.3,32-32V96C400,78.3,385.7,64,368,64z\r\n\t\t M384,416c0,8.8-7.2,16-16,16H144c-8.8,0-16-7.2-16-16V96c0-8.8,7.2-16,16-16h224c8.8,0,16,7.2,16,16V416z"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,240 160,208 160,192 144,192 144,256 208,256 208,240 192,240 \t"},"children":[{"name":"polygon","attribs":{"points":"160,240 160,208 160,192 144,192 144,256 208,256 208,240 192,240 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,320 160,288 160,272 144,272 144,336 208,336 208,320 192,320 \t"},"children":[{"name":"polygon","attribs":{"points":"160,320 160,288 160,272 144,272 144,336 208,336 208,320 192,320 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,400 160,368 160,352 144,352 144,416 208,416 208,400 192,400 \t"},"children":[{"name":"polygon","attribs":{"points":"160,400 160,368 160,352 144,352 144,416 208,416 208,400 192,400 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,240 240,208 240,192 224,192 224,256 288,256 288,240 272,240 \t"},"children":[{"name":"polygon","attribs":{"points":"240,240 240,208 240,192 224,192 224,256 288,256 288,240 272,240 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"320,240 320,208 320,192 304,192 304,256 368,256 368,240 352,240 \t"},"children":[{"name":"polygon","attribs":{"points":"320,240 320,208 320,192 304,192 304,256 368,256 368,240 352,240 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,320 240,288 240,272 224,272 224,336 288,336 288,320 272,320 \t"},"children":[{"name":"polygon","attribs":{"points":"240,320 240,288 240,272 224,272 224,336 288,336 288,320 272,320 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,400 240,368 240,352 224,352 224,416 288,416 288,400 272,400 \t"},"children":[{"name":"polygon","attribs":{"points":"240,400 240,368 240,352 224,352 224,416 288,416 288,400 272,400 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"320,400 320,368 320,272 304,272 304,416 368,416 368,400 352,400 \t"},"children":[{"name":"polygon","attribs":{"points":"320,400 320,368 320,272 304,272 304,416 368,416 368,400 352,400 \t"},"children":[]}]}]}]};exports.iosCalculatorOutline=iosCalculatorOutline;var iosCalculator={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M368,64H144c-17.7,0-32,14.3-32,32v320c0,17.7,14.3,32,32,32h224c17.7,0,32-14.3,32-32V96C400,78.3,385.7,64,368,64z\r\n\t M360,280v128h-48V280H360z M360,200v48h-48v-48H360z M280,360v48h-48v-48H280z M280,280v48h-48v-48H280z M280,200v48h-48v-48H280z\r\n\t M200,360v48h-48v-48H200z M200,280v48h-48v-48H200z M200,200v48h-48v-48H200z M152,152v-48h208v48H152z"},"children":[]}]};exports.iosCalculator=iosCalculator;var iosCalendarOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"polyline","attribs":{"class":"st0","points":"80,112 80,176 432,176 432,112 "},"children":[]},{"name":"path","attribs":{"d":"M352,96V64h-16v32H176V64h-16v32H64v352h384V96H352z M432,432H80V192h352V432z M432,176H80v-64h80v32h16v-32h160v32h16v-32\r\n\th80V176z"},"children":[]}]};exports.iosCalendarOutline=iosCalendarOutline;var iosCalendar={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"64","y":"192","width":"384","height":"256"},"children":[{"name":"rect","attribs":{"x":"64","y":"192","width":"384","height":"256"},"children":[]}]},{"name":"polygon","attribs":{"points":"448,96 352,96 352,144 336,144 336,96 176,96 176,144 160,144 160,96 64,96 64,176 448,176 \t"},"children":[{"name":"polygon","attribs":{"points":"448,96 352,96 352,144 336,144 336,96 176,96 176,144 160,144 160,96 64,96 64,176 448,176 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"64","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"160","y":"64","width":"16","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"64","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"336","y":"64","width":"16","height":"32"},"children":[]}]}]}]};exports.iosCalendar=iosCalendar;var iosCameraOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.7c-32.1-36-42.2-48-54.5-48h-88.5c-12.3,0-22.2,12-54.5,48H145v-16h-34v16H97.5C79.9,160,64,173.2,64,190.7\r\n\t\tv176c0,17.5,15.9,33.3,33.5,33.3h320c17.6,0,30.5-15.8,30.5-33.3v-176C448,173.2,435.1,160,417.5,160z M432,366.7\r\n\t\tc0,9.3-6.2,17.3-14.5,17.3h-320c-8.7,0-17.5-8.7-17.5-17.3v-176c0-8.2,8.1-14.7,17.5-14.7h60.7h7.1l4.8-3.2c4-4.5,7.7-10,11.1-13.8\r\n\t\tc11.3-12.7,19.5-21.7,25.3-26.9c4.7-4.2,6.2-4.1,6.2-4.1h88.5c0,0,1.6-0.1,6.7,4.5c6.1,5.5,14.7,16.5,26.6,29.8\r\n\t\tc2.9,3.3,6,6.8,9.3,10.5l4.8,3.2h7.2h61.7c8.8,0,14.5,6,14.5,14.7V366.7z"},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.7c-32.1-36-42.2-48-54.5-48h-88.5c-12.3,0-22.2,12-54.5,48H145v-16h-34v16H97.5C79.9,160,64,173.2,64,190.7\r\n\t\tv176c0,17.5,15.9,33.3,33.5,33.3h320c17.6,0,30.5-15.8,30.5-33.3v-176C448,173.2,435.1,160,417.5,160z M432,366.7\r\n\t\tc0,9.3-6.2,17.3-14.5,17.3h-320c-8.7,0-17.5-8.7-17.5-17.3v-176c0-8.2,8.1-14.7,17.5-14.7h60.7h7.1l4.8-3.2c4-4.5,7.7-10,11.1-13.8\r\n\t\tc11.3-12.7,19.5-21.7,25.3-26.9c4.7-4.2,6.2-4.1,6.2-4.1h88.5c0,0,1.6-0.1,6.7,4.5c6.1,5.5,14.7,16.5,26.6,29.8\r\n\t\tc2.9,3.3,6,6.8,9.3,10.5l4.8,3.2h7.2h61.7c8.8,0,14.5,6,14.5,14.7V366.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,189.5c-47.1,0-85.5,38.4-85.5,85.5s38.4,85.5,85.5,85.5s85.5-38.4,85.5-85.5S303.1,189.5,256,189.5z M256,344.5\r\n\t\tc-38.4,0-69.5-31.1-69.5-69.5s31.1-69.5,69.5-69.5s69.5,31.1,69.5,69.5S294.4,344.5,256,344.5z"},"children":[{"name":"path","attribs":{"d":"M256,189.5c-47.1,0-85.5,38.4-85.5,85.5s38.4,85.5,85.5,85.5s85.5-38.4,85.5-85.5S303.1,189.5,256,189.5z M256,344.5\r\n\t\tc-38.4,0-69.5-31.1-69.5-69.5s31.1-69.5,69.5-69.5s69.5,31.1,69.5,69.5S294.4,344.5,256,344.5z"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"192","width":"17","height":"17"},"children":[{"name":"rect","attribs":{"x":"352","y":"192","width":"17","height":"17"},"children":[]}]},{"name":"circle","attribs":{"cx":"256","cy":"275","r":"32"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"275","r":"32"},"children":[]}]}]}]};exports.iosCameraOutline=iosCameraOutline;var iosCamera={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.7c-32.1-36-42.2-48-54.5-48h-88.5c-12.3,0-22.2,12-54.5,48H145v-16h-34v16H97.5C79.9,160,64,173.2,64,190.7\r\n\t\tv176c0,17.5,15.9,33.3,33.5,33.3h320c17.6,0,30.5-15.8,30.5-33.3v-176C448,173.2,435.1,160,417.5,160z M256,360.5\r\n\t\tc-47.1,0-85.5-38.4-85.5-85.5s38.4-85.5,85.5-85.5s85.5,38.4,85.5,85.5S303.1,360.5,256,360.5z M369,209h-17v-17h17V209z"},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.7c-32.1-36-42.2-48-54.5-48h-88.5c-12.3,0-22.2,12-54.5,48H145v-16h-34v16H97.5C79.9,160,64,173.2,64,190.7\r\n\t\tv176c0,17.5,15.9,33.3,33.5,33.3h320c17.6,0,30.5-15.8,30.5-33.3v-176C448,173.2,435.1,160,417.5,160z M256,360.5\r\n\t\tc-47.1,0-85.5-38.4-85.5-85.5s38.4-85.5,85.5-85.5s85.5,38.4,85.5,85.5S303.1,360.5,256,360.5z M369,209h-17v-17h17V209z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,205.5c-38.4,0-69.5,31.1-69.5,69.5s31.1,69.5,69.5,69.5s69.5-31.1,69.5-69.5S294.4,205.5,256,205.5z M256,307\r\n\t\tc-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,307,256,307z"},"children":[{"name":"path","attribs":{"d":"M256,205.5c-38.4,0-69.5,31.1-69.5,69.5s31.1,69.5,69.5,69.5s69.5-31.1,69.5-69.5S294.4,205.5,256,205.5z M256,307\r\n\t\tc-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,307,256,307z"},"children":[]}]}]}]};exports.iosCamera=iosCamera;var iosCartOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S173.248,400,160,400z M160,432c-4.411,0-8-3.589-8-8\r\n\t\ts3.589-8,8-8s8,3.589,8,8S164.411,432,160,432z"},"children":[{"name":"path","attribs":{"d":"M160,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S173.248,400,160,400z M160,432c-4.411,0-8-3.589-8-8\r\n\t\ts3.589-8,8-8s8,3.589,8,8S164.411,432,160,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M384.5,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S397.748,400,384.5,400z M384.5,432\r\n\t\tc-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S388.911,432,384.5,432z"},"children":[{"name":"path","attribs":{"d":"M384.5,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S397.748,400,384.5,400z M384.5,432\r\n\t\tc-4.411,0-8-3.589-8-8s3.589-8,8-8s8,3.589,8,8S388.911,432,384.5,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,128L123.177,95.646c-1.628-6.972-4.369-14.66-11.838-20.667C102.025,67.489,86.982,64,64,64v16.001\r\n\t\tc18.614,0,31.167,2.506,37.312,7.447c4.458,3.585,5.644,8.423,7.165,15.989l-0.024,0.004l42.052,233.638\r\n\t\tc2.413,14.422,7.194,25.209,13.291,32.986C171.043,379.312,180.533,384,192,384h240v-16H192c-4.727,0-19.136,0.123-25.749-33.755\r\n\t\tl-5.429-30.16L432,256L448,128z M418.59,242.348l-260.601,45.99l-31.732-176.3l303.869,30.608L418.59,242.348z"},"children":[{"name":"path","attribs":{"d":"M448,128L123.177,95.646c-1.628-6.972-4.369-14.66-11.838-20.667C102.025,67.489,86.982,64,64,64v16.001\r\n\t\tc18.614,0,31.167,2.506,37.312,7.447c4.458,3.585,5.644,8.423,7.165,15.989l-0.024,0.004l42.052,233.638\r\n\t\tc2.413,14.422,7.194,25.209,13.291,32.986C171.043,379.312,180.533,384,192,384h240v-16H192c-4.727,0-19.136,0.123-25.749-33.755\r\n\t\tl-5.429-30.16L432,256L448,128z M418.59,242.348l-260.601,45.99l-31.732-176.3l303.869,30.608L418.59,242.348z"},"children":[]}]}]}]};exports.iosCartOutline=iosCartOutline;var iosCart={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S173.248,400,160,400z"},"children":[{"name":"path","attribs":{"d":"M160,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S173.248,400,160,400z"},"children":[]}]},{"name":"path","attribs":{"d":"M384.5,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S397.748,400,384.5,400z"},"children":[{"name":"path","attribs":{"d":"M384.5,400c-13.248,0-24,10.752-24,24s10.752,24,24,24s24-10.752,24-24S397.748,400,384.5,400z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,128L123.177,95.646c-1.628-6.972-4.369-14.66-11.838-20.667C102.025,67.489,86.982,64,64,64v16.001\r\n\t\tc18.614,0,31.167,2.506,37.312,7.447c4.458,3.585,5.644,8.423,7.165,15.989l-0.024,0.004l42.052,233.638\r\n\t\tc2.413,14.422,7.194,25.209,13.291,32.986C171.043,379.312,180.533,384,192,384h240v-16H192c-4.727,0-19.136,0.123-25.749-33.755\r\n\t\tl-5.429-30.16L432,256L448,128z"},"children":[{"name":"path","attribs":{"d":"M448,128L123.177,95.646c-1.628-6.972-4.369-14.66-11.838-20.667C102.025,67.489,86.982,64,64,64v16.001\r\n\t\tc18.614,0,31.167,2.506,37.312,7.447c4.458,3.585,5.644,8.423,7.165,15.989l-0.024,0.004l42.052,233.638\r\n\t\tc2.413,14.422,7.194,25.209,13.291,32.986C171.043,379.312,180.533,384,192,384h240v-16H192c-4.727,0-19.136,0.123-25.749-33.755\r\n\t\tl-5.429-30.16L432,256L448,128z"},"children":[]}]}]}]};exports.iosCart=iosCart;var iosChatboxesOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"64,64 320,64 320,160 336,160 336,48 48,48 48,272 160,272 160,256 64,256 \t"},"children":[{"name":"polygon","attribs":{"points":"64,64 320,64 320,160 336,160 336,48 48,48 48,272 160,272 160,256 64,256 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M176,176v224h162.6l64,64H416v-64h48V176H176z M448,384h-48v54.6L345,384H192V192h256V384z"},"children":[{"name":"path","attribs":{"d":"M176,176v224h162.6l64,64H416v-64h48V176H176z M448,384h-48v54.6L345,384H192V192h256V384z"},"children":[]}]}]}]};exports.iosChatboxesOutline=iosChatboxesOutline;var iosChatboxes={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"336,48 48,48 48,272 160,272 160,160 336,160 \t"},"children":[{"name":"polygon","attribs":{"points":"336,48 48,48 48,272 160,272 160,160 336,160 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M176,176v224h162.6l64,64H416v-64h48V176H176z"},"children":[{"name":"path","attribs":{"d":"M176,176v224h162.6l64,64H416v-64h48V176H176z"},"children":[]}]}]}]};exports.iosChatboxes=iosChatboxes;var iosChatbubbleOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,112c97,0,176,62,176,138.3c0,35.9-17.6,69.2-49.5,93.9c-32.8,25.4-77.4,39.3-125.5,39.3c-28.9,0-51-3-69.7-9.3\r\n\tc-0.6-0.2-1.3-0.5-2-0.7c-0.3-0.1-0.6-0.2-0.8-0.2c-4.7-1.4-9.7-2.1-14.7-2.1c-5.6,0-11.1,0.9-16.3,2.6l0,0l-0.3,0.1\r\n\tc-0.6,0.2-8.9,3.3-11,4.3l0,0l-39.6,17.2c13.8-43.9,13.8-44.8,13.8-47.6c0-7.1-2.2-14.1-6.3-20.2c-0.5-0.7-1-1.4-1.6-2.1\r\n\tc-0.7-0.9-1.3-1.7-1.8-2.3c-17.4-21.9-26.6-47.1-26.6-73C80,174,159,112,256,112 M256,96C149.9,96,64,165.1,64,250.3\r\n\tc0,30.7,11.2,59.3,30.4,83.3c0.9,0.9,2.9,3.8,3.6,4.9c0,0-1-1.6-1.1-1.9c0,0,0,0,0,0l0,0c0,0,0,0,0,0c2.3,3.3,3.6,7.1,3.6,11.2\r\n\tc0,1.4-17.9,58-17.9,58l0,0c-1.3,4.4,2.1,8.9,7.6,10c0.8,0.2,1.6,0.2,2.4,0.2c1.3,0,2.5-0.2,3.7-0.5l1.6-0.6l50.6-22\r\n\tc0.9-0.4,9-3.5,10-3.9c0,0,0.6-0.2,0.6-0.2c0,0-0.1,0-0.6,0.2c3.4-1.2,7.2-1.8,11.2-1.8c3.6,0,7.1,0.5,10.3,1.5c0.1,0,0.2,0,0.2,0.1\r\n\tc0.5,0.2,1,0.3,1.5,0.5c23.1,7.9,48.4,10.3,75.1,10.3c106,0,191-64.1,191-149.3C448,165.1,362,96,256,96L256,96z"},"children":[]}]};exports.iosChatbubbleOutline=iosChatbubbleOutline;var iosChatbubble={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,96C149.9,96,64,165.1,64,250.3c0,30.7,11.2,59.3,30.4,83.3c0.9,0.9,2.9,3.8,3.6,4.9c0,0-1-1.6-1.1-1.9c0,0,0,0,0,0l0,0\r\n\tc0,0,0,0,0,0c2.3,3.3,3.6,7.1,3.6,11.2c0,1.4-17.9,58-17.9,58l0,0c-1.3,4.4,2.1,8.9,7.6,10c0.8,0.2,1.6,0.2,2.4,0.2\r\n\tc1.3,0,2.5-0.2,3.7-0.5l1.6-0.6l50.6-22c0.9-0.4,9-3.5,10-3.9c0,0,0.6-0.2,0.6-0.2c0,0-0.1,0-0.6,0.2c3.4-1.2,7.2-1.8,11.2-1.8\r\n\tc3.6,0,7.1,0.5,10.3,1.5c0.1,0,0.2,0,0.2,0.1c0.5,0.2,1,0.3,1.5,0.5c23.1,7.9,48.4,10.3,75.1,10.3c106,0,191-64.1,191-149.3\r\n\tC448,165.1,362,96,256,96L256,96z"},"children":[]}]};exports.iosChatbubble=iosChatbubble;var iosCheckmarkEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M223.9,329.7c-2.4,2.4-5.8,4.4-8.8,4.4s-6.4-2.1-8.9-4.5l-56-56l17.8-17.8l47.2,47.2l124.8-125.7l17.5,18.1L223.9,329.7z"},"children":[{"name":"path","attribs":{"d":"M223.9,329.7c-2.4,2.4-5.8,4.4-8.8,4.4s-6.4-2.1-8.9-4.5l-56-56l17.8-17.8l47.2,47.2l124.8-125.7l17.5,18.1L223.9,329.7z"},"children":[]}]}]}]};exports.iosCheckmarkEmpty=iosCheckmarkEmpty;var iosCheckmarkOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M340.1,177.3L215.3,303l-47.2-47.2l-17.8,17.8l56,56c2.5,2.5,5.9,4.5,8.9,4.5s6.3-2,8.8-4.4l133.7-134.4L340.1,177.3z"},"children":[{"name":"path","attribs":{"d":"M340.1,177.3L215.3,303l-47.2-47.2l-17.8,17.8l56,56c2.5,2.5,5.9,4.5,8.9,4.5s6.3-2,8.8-4.4l133.7-134.4L340.1,177.3z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]};exports.iosCheckmarkOutline=iosCheckmarkOutline;var iosCheckmark={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M223.9,329.7\r\n\t\tc-2.4,2.4-5.8,4.4-8.8,4.4s-6.4-2.1-8.9-4.5l-56-56l17.8-17.8l47.2,47.2l124.8-125.7l17.5,18.1L223.9,329.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M223.9,329.7\r\n\t\tc-2.4,2.4-5.8,4.4-8.8,4.4s-6.4-2.1-8.9-4.5l-56-56l17.8-17.8l47.2,47.2l124.8-125.7l17.5,18.1L223.9,329.7z"},"children":[]}]}]}]};exports.iosCheckmark=iosCheckmark;var iosCircleFilled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,96c-88.4,0-160,71.6-160,160c0,88.4,71.6,160,160,160c88.4,0,160-71.6,160-160C416,167.6,344.4,96,256,96z"},"children":[{"name":"path","attribs":{"d":"M256,96c-88.4,0-160,71.6-160,160c0,88.4,71.6,160,160,160c88.4,0,160-71.6,160-160C416,167.6,344.4,96,256,96z"},"children":[]}]}]}]}]}]};exports.iosCircleFilled=iosCircleFilled;var iosCircleOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]};exports.iosCircleOutline=iosCircleOutline;var iosClockOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,256 160,256 160,273.3 273.3,273.3 273.3,128 256,128 \t"},"children":[{"name":"polygon","attribs":{"points":"256,256 160,256 160,273.3 273.3,273.3 273.3,128 256,128 \t"},"children":[]}]}]}]};exports.iosClockOutline=iosClockOutline;var iosClock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M273,273H160v-17h96V128h17\r\n\t\tV273z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M273,273H160v-17h96V128h17\r\n\t\tV273z"},"children":[]}]}]}]};exports.iosClock=iosClock;var iosCloseEmpty={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"polygon","attribs":{"class":"st0","points":"340.2,160 255.8,244.3 171.8,160.4 160,172.2 244,256 160,339.9 171.8,351.6 255.8,267.8 340.2,352 \r\n\t352,340.3 267.6,256 352,171.8 "},"children":[]}]};exports.iosCloseEmpty=iosCloseEmpty;var iosCloseOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M403.1,108.9c-81.2-81.2-212.9-81.2-294.2,0s-81.2,212.9,0,294.2c81.2,81.2,212.9,81.2,294.2,0\r\n\t\t\tS484.3,190.1,403.1,108.9z M390.8,390.8c-74.3,74.3-195.3,74.3-269.6,0c-74.3-74.3-74.3-195.3,0-269.6s195.3-74.3,269.6,0\r\n\t\t\tC465.2,195.5,465.2,316.5,390.8,390.8z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M403.1,108.9c-81.2-81.2-212.9-81.2-294.2,0s-81.2,212.9,0,294.2c81.2,81.2,212.9,81.2,294.2,0\r\n\t\t\tS484.3,190.1,403.1,108.9z M390.8,390.8c-74.3,74.3-195.3,74.3-269.6,0c-74.3-74.3-74.3-195.3,0-269.6s195.3-74.3,269.6,0\r\n\t\t\tC465.2,195.5,465.2,316.5,390.8,390.8z"},"children":[]}]}]}]},{"name":"polygon","attribs":{"class":"st0","points":"340.2,160 255.8,244.2 171.8,160.4 160,172.2 244,256 160,339.8 171.8,351.6 255.8,267.8 340.2,352 \r\n\t\t352,340.2 267.6,256 352,171.8 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"340.2,160 255.8,244.2 171.8,160.4 160,172.2 244,256 160,339.8 171.8,351.6 255.8,267.8 340.2,352 \r\n\t\t352,340.2 267.6,256 352,171.8 \t"},"children":[]}]}]}]};exports.iosCloseOutline=iosCloseOutline;var iosClose={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M403.1,108.9c-81.2-81.2-212.9-81.2-294.2,0s-81.2,212.9,0,294.2c81.2,81.2,212.9,81.2,294.2,0\r\n\t\tS484.3,190.1,403.1,108.9z M352,340.2L340.2,352l-84.4-84.2l-84,83.8L160,339.8l84-83.8l-84-83.8l11.8-11.8l84,83.8l84.4-84.2\r\n\t\tl11.8,11.8L267.6,256L352,340.2z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M403.1,108.9c-81.2-81.2-212.9-81.2-294.2,0s-81.2,212.9,0,294.2c81.2,81.2,212.9,81.2,294.2,0\r\n\t\tS484.3,190.1,403.1,108.9z M352,340.2L340.2,352l-84.4-84.2l-84,83.8L160,339.8l84-83.8l-84-83.8l11.8-11.8l84,83.8l84.4-84.2\r\n\t\tl11.8,11.8L267.6,256L352,340.2z"},"children":[]}]}]}]};exports.iosClose=iosClose;var iosCloudDownloadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"193.2,381.2 181.6,392.6 256.1,466 330.6,392.6 319,381.2 264.3,435 264.3,192.9 247.9,192.9 247.9,435 \t\t"},"children":[{"name":"polygon","attribs":{"points":"193.2,381.2 181.6,392.6 256.1,466 330.6,392.6 319,381.2 264.3,435 264.3,192.9 247.9,192.9 247.9,435 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M399.2,164.4c0-1.2,0.2-2.3,0.2-3.5C399.4,97.4,346.5,46,282.6,46c-46.1,0-85.8,26.8-104.4,65.4c-8.1-4-17.1-6.3-26.8-6.3\r\n\t\t\tc-29.6,0-54.1,23.3-58.9,51.3c-35.2,12-60.6,43.4-60.6,82.4c0,49.1,40.1,89.2,89.6,89.2H213v-16h-90.7\r\n\t\t\tc-40.9,0-74.2-33.2-74.2-73.7c0-31.4,20.2-57.5,50.2-67.7l8.4-2.8l1.5-8.7c3.6-21.3,22.1-38.8,43.9-38.8c6.9,0,13.7,1.6,19.9,4.7\r\n\t\t\tl13.5,6.7l6.5-13.6c16.6-34.4,52.1-56.6,90.4-56.6c55.3,0,100.9,42.8,100.9,97.6c0,13.1-0.2,20.1-0.2,20.1l15.2,0.1\r\n\t\t\tc36.7,0.5,65.6,30,65.6,66.4c0,36.3-29.8,66.1-66.5,66.3l-3.2,0.1H297v16h101h0c45,0,81.9-37.2,81.9-82.1\r\n\t\t\tC479.9,201,444.5,164.5,399.2,164.4z"},"children":[{"name":"path","attribs":{"d":"M399.2,164.4c0-1.2,0.2-2.3,0.2-3.5C399.4,97.4,346.5,46,282.6,46c-46.1,0-85.8,26.8-104.4,65.4c-8.1-4-17.1-6.3-26.8-6.3\r\n\t\t\tc-29.6,0-54.1,23.3-58.9,51.3c-35.2,12-60.6,43.4-60.6,82.4c0,49.1,40.1,89.2,89.6,89.2H213v-16h-90.7\r\n\t\t\tc-40.9,0-74.2-33.2-74.2-73.7c0-31.4,20.2-57.5,50.2-67.7l8.4-2.8l1.5-8.7c3.6-21.3,22.1-38.8,43.9-38.8c6.9,0,13.7,1.6,19.9,4.7\r\n\t\t\tl13.5,6.7l6.5-13.6c16.6-34.4,52.1-56.6,90.4-56.6c55.3,0,100.9,42.8,100.9,97.6c0,13.1-0.2,20.1-0.2,20.1l15.2,0.1\r\n\t\t\tc36.7,0.5,65.6,30,65.6,66.4c0,36.3-29.8,66.1-66.5,66.3l-3.2,0.1H297v16h101h0c45,0,81.9-37.2,81.9-82.1\r\n\t\t\tC479.9,201,444.5,164.5,399.2,164.4z"},"children":[]}]}]}]}]}]};exports.iosCloudDownloadOutline=iosCloudDownloadOutline;var iosCloudDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"248,435 193.3,381.2 181.6,392.6 256.1,466 330.6,392.6 318.8,381.2 264,435 264,328 248,328 \t"},"children":[{"name":"polygon","attribs":{"points":"248,435 193.3,381.2 181.6,392.6 256.1,466 330.6,392.6 318.8,381.2 264,435 264,328 248,328 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M399.2,164.4c0-1.2,0.2-2.3,0.2-3.5C399.4,97.4,346.5,46,282.6,46c-46.1,0-85.8,26.8-104.4,65.4c-8.1-4-17.1-6.3-26.8-6.3\r\n\t\tc-29.6,0-54.1,23.3-58.9,51.3c-35.2,12-60.6,43.4-60.6,82.4c0,49.1,40.1,89.2,89.6,89.2H192h21h35V193h16v135h134\r\n\t\tc45,0,81.9-37.2,81.9-82.1C479.9,201,444.5,164.5,399.2,164.4z"},"children":[{"name":"path","attribs":{"d":"M399.2,164.4c0-1.2,0.2-2.3,0.2-3.5C399.4,97.4,346.5,46,282.6,46c-46.1,0-85.8,26.8-104.4,65.4c-8.1-4-17.1-6.3-26.8-6.3\r\n\t\tc-29.6,0-54.1,23.3-58.9,51.3c-35.2,12-60.6,43.4-60.6,82.4c0,49.1,40.1,89.2,89.6,89.2H192h21h35V193h16v135h134\r\n\t\tc45,0,81.9-37.2,81.9-82.1C479.9,201,444.5,164.5,399.2,164.4z"},"children":[]}]}]}]};exports.iosCloudDownload=iosCloudDownload;var iosCloudOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M399.3,232.8c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-117.2-116.8-117.2c-46.1,0-85.8,27.9-104.4,67c-8.1-4.1-17.1-6.4-26.8-6.4\r\n\tc-29.6,0-54.1,23.7-58.9,52C57.4,236.8,32,268.8,32,308.4c0,49.8,40.1,91.6,89.6,91.6H398c45,0,82-38.9,82-84.3\r\n\tC480,270.1,444.6,232.9,399.3,232.8z M397.5,383.6l-3.2,0.4H122.4c-40.9,0-74.2-34.9-74.2-76.1c0-31.9,20.2-58.4,50.2-68.8l8.4-3\r\n\tl1.5-8.8c3.6-21.6,22.1-39.3,43.9-39.3c6.9,0,13.7,1.6,19.9,4.8l13.5,6.8l6.5-13.7c16.6-34.9,52.1-58.2,90.4-58.2\r\n\tc55.3,0,100.9,44.1,100.9,99.7c0,13.3-0.2,20.3-0.2,20.3l15.2,0.1c36.7,0.5,65.6,30.5,65.6,67.4C464,352.1,434.2,383.4,397.5,383.6z\r\n\t"},"children":[]}]};exports.iosCloudOutline=iosCloudOutline;var iosCloudUploadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"193.3,260.4 181.7,248.8 256.2,174.5 330.7,248.8 319,260.4 264.4,205.8 264.4,447.6 247.9,447.6 247.9,205.8 \t\t\r\n\t\t\t"},"children":[{"name":"polygon","attribs":{"points":"193.3,260.4 181.7,248.8 256.2,174.5 330.7,248.8 319,260.4 264.4,205.8 264.4,447.6 247.9,447.6 247.9,205.8 \t\t\r\n\t\t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M399.3,183.6c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-116.4-116.8-116.4c-46.1,0-85.8,27.1-104.4,66.3\r\n\t\t\tc-8.1-4.1-17.1-6.4-26.8-6.4c-29.6,0-54.1,23.6-58.9,52C57.4,187.6,32,222.2,32,261.8c0,49.7,40.1,90.2,89.6,90.2H213v-16h-90.6\r\n\t\t\tc-40.9,0-74.2-33.5-74.2-74.6c0-31.8,20.2-61.2,50.2-71.6l8.4-2.9l1.5-8.8c3.6-21.6,22.1-39.3,43.9-39.3c6.9,0,13.7,1.6,19.9,4.8\r\n\t\t\tl13.5,6.8l6.5-13.7c16.6-34.9,52.1-57.4,90.4-57.4c55.3,0,100.9,43.3,100.9,98.9c0,13.3-0.2,20.3-0.2,20.3l15.2,0.1\r\n\t\t\tC435,199.1,464,232,464,268.9c0,36.8-29.8,66.9-66.5,67.1l-3.2,0H297v16h101h0c45,0,82-37.3,82-82.8\r\n\t\t\tC480,223.7,444.5,183.7,399.3,183.6z"},"children":[{"name":"path","attribs":{"d":"M399.3,183.6c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-116.4-116.8-116.4c-46.1,0-85.8,27.1-104.4,66.3\r\n\t\t\tc-8.1-4.1-17.1-6.4-26.8-6.4c-29.6,0-54.1,23.6-58.9,52C57.4,187.6,32,222.2,32,261.8c0,49.7,40.1,90.2,89.6,90.2H213v-16h-90.6\r\n\t\t\tc-40.9,0-74.2-33.5-74.2-74.6c0-31.8,20.2-61.2,50.2-71.6l8.4-2.9l1.5-8.8c3.6-21.6,22.1-39.3,43.9-39.3c6.9,0,13.7,1.6,19.9,4.8\r\n\t\t\tl13.5,6.8l6.5-13.7c16.6-34.9,52.1-57.4,90.4-57.4c55.3,0,100.9,43.3,100.9,98.9c0,13.3-0.2,20.3-0.2,20.3l15.2,0.1\r\n\t\t\tC435,199.1,464,232,464,268.9c0,36.8-29.8,66.9-66.5,67.1l-3.2,0H297v16h101h0c45,0,82-37.3,82-82.8\r\n\t\t\tC480,223.7,444.5,183.7,399.3,183.6z"},"children":[]}]}]}]}]}]};exports.iosCloudUploadOutline=iosCloudUploadOutline;var iosCloudUpload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"248","y":"352","width":"16","height":"96"},"children":[{"name":"rect","attribs":{"x":"248","y":"352","width":"16","height":"96"},"children":[]}]},{"name":"path","attribs":{"d":"M399.3,183.6c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-116.4-116.8-116.4c-46.1,0-85.8,27.1-104.4,66.3\r\n\t\tc-8.1-4.1-17.1-6.4-26.8-6.4c-29.6,0-54.1,23.6-58.9,52C57.4,187.6,32,222.2,32,261.8c0,49.7,40.1,90.2,89.6,90.2H182h31h35V205.8\r\n\t\tl-54.7,54.5l-11.6-11.6l74.5-74.3l74.5,74.3l-11.8,11.6L264,205.8V352h134c45,0,82-37.3,82-82.8C480,223.7,444.5,183.7,399.3,183.6\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M399.3,183.6c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-116.4-116.8-116.4c-46.1,0-85.8,27.1-104.4,66.3\r\n\t\tc-8.1-4.1-17.1-6.4-26.8-6.4c-29.6,0-54.1,23.6-58.9,52C57.4,187.6,32,222.2,32,261.8c0,49.7,40.1,90.2,89.6,90.2H182h31h35V205.8\r\n\t\tl-54.7,54.5l-11.6-11.6l74.5-74.3l74.5,74.3l-11.8,11.6L264,205.8V352h134c45,0,82-37.3,82-82.8C480,223.7,444.5,183.7,399.3,183.6\r\n\t\tz"},"children":[]}]}]}]};exports.iosCloudUpload=iosCloudUpload;var iosCloud={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M399.3,232.8c0-1.2,0.2-2.4,0.2-3.6c0-64.3-52.8-117.2-116.8-117.2c-46.1,0-85.8,27.9-104.4,67c-8.1-4.1-17.1-6.4-26.8-6.4\r\n\tc-29.6,0-54.1,23.7-58.9,52C57.4,236.8,32,268.8,32,308.4c0,49.8,40.1,91.6,89.6,91.6H398c45,0,82-38.9,82-84.3\r\n\tC480,270.1,444.6,232.9,399.3,232.8z"},"children":[]}]};exports.iosCloud=iosCloud;var iosCloudyNightOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M189,223.8c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\tc26.9,0,48.8,22.1,48.8,49.2c0,27.1-21.9,49.2-48.8,49.2H115.7c-9.5,0-18.5-3.9-25.4-10.8c-6.8-7-10.6-16.2-10.6-25.9\r\n\t\tc0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.2,14.2-1.7c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\tC126.5,252,154.5,223.8,189,223.8 M189,208c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8C84.7,296.7,64,319.8,64,346.9\r\n\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\tC257.5,234.3,226.3,208,189,208L189,208z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M189,223.8c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\tc26.9,0,48.8,22.1,48.8,49.2c0,27.1-21.9,49.2-48.8,49.2H115.7c-9.5,0-18.5-3.9-25.4-10.8c-6.8-7-10.6-16.2-10.6-25.9\r\n\t\tc0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.2,14.2-1.7c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\tC126.5,252,154.5,223.8,189,223.8 M189,208c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8C84.7,296.7,64,319.8,64,346.9\r\n\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\tC257.5,234.3,226.3,208,189,208L189,208z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M424.6,305.6c-2,0.1-3.9,0.1-5.9,0.1c-32.3,0-62.7-12.6-85.5-35.5c-22.8-22.9-35.4-53.3-35.4-85.7\r\n\t\tc0-18.4,4.1-36.2,11.8-52.4c3.4-7.1,7.5-13.9,12.3-20.2c-8.4,0.9-16.6,2.7-24.4,5.1c-37.2,11.8-67.1,40.2-81,76.5\r\n\t\tc5.9,1.2,11.6,3,17,5.4c10.1-25.5,29.4-46.4,53.8-58.6c-4.6,13.9-7.1,28.7-7.1,44.1c0,27.3,7.9,52.8,21.4,74.2\r\n\t\tc13.8,21.8,33.5,39.5,56.8,50.9c15.3,7.4,32.2,12.1,50,13.5c-14,12.2-31.2,20.9-50,24.8c-1.9,6.9-4.9,13.4-8.6,19.3\r\n\t\tc33.6-3.6,63.3-20.1,84-44.6c5.4-6.3,10.2-13.2,14.2-20.5C440.4,304.1,432.6,305.2,424.6,305.6z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M424.6,305.6c-2,0.1-3.9,0.1-5.9,0.1c-32.3,0-62.7-12.6-85.5-35.5c-22.8-22.9-35.4-53.3-35.4-85.7\r\n\t\tc0-18.4,4.1-36.2,11.8-52.4c3.4-7.1,7.5-13.9,12.3-20.2c-8.4,0.9-16.6,2.7-24.4,5.1c-37.2,11.8-67.1,40.2-81,76.5\r\n\t\tc5.9,1.2,11.6,3,17,5.4c10.1-25.5,29.4-46.4,53.8-58.6c-4.6,13.9-7.1,28.7-7.1,44.1c0,27.3,7.9,52.8,21.4,74.2\r\n\t\tc13.8,21.8,33.5,39.5,56.8,50.9c15.3,7.4,32.2,12.1,50,13.5c-14,12.2-31.2,20.9-50,24.8c-1.9,6.9-4.9,13.4-8.6,19.3\r\n\t\tc33.6-3.6,63.3-20.1,84-44.6c5.4-6.3,10.2-13.2,14.2-20.5C440.4,304.1,432.6,305.2,424.6,305.6z"},"children":[]}]}]}]};exports.iosCloudyNightOutline=iosCloudyNightOutline;var iosCloudyNight={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M424.6,305.6c-2,0.1-3.9,0.1-5.9,0.1c-32.3,0-62.7-12.6-85.5-35.5c-22.8-22.9-35.4-53.3-35.4-85.7\r\n\t\tc0-18.4,4.1-36.2,11.8-52.4c3.4-7.1,7.5-13.9,12.3-20.2c-8.4,0.9-16.6,2.7-24.4,5.1c-37.2,11.8-67.1,40.2-81,76.5\r\n\t\tc-0.3,0.8-0.6,1.5-0.9,2.3c11.9,3.5,23.1,9.4,32.8,17.3c13,10.6,22.9,24.5,28.8,40.1c20.1,0.9,38.9,9.4,53.3,24\r\n\t\tc15.2,15.4,23.5,35.9,23.5,57.4c0,11.4-2.4,22.5-6.8,32.8c0.8-0.1,1.6-0.1,2.5-0.2c33.6-3.6,63.3-20.1,84-44.6\r\n\t\tc5.4-6.3,10.2-13.2,14.2-20.5C440.4,304.1,432.6,305.2,424.6,305.6z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M424.6,305.6c-2,0.1-3.9,0.1-5.9,0.1c-32.3,0-62.7-12.6-85.5-35.5c-22.8-22.9-35.4-53.3-35.4-85.7\r\n\t\tc0-18.4,4.1-36.2,11.8-52.4c3.4-7.1,7.5-13.9,12.3-20.2c-8.4,0.9-16.6,2.7-24.4,5.1c-37.2,11.8-67.1,40.2-81,76.5\r\n\t\tc-0.3,0.8-0.6,1.5-0.9,2.3c11.9,3.5,23.1,9.4,32.8,17.3c13,10.6,22.9,24.5,28.8,40.1c20.1,0.9,38.9,9.4,53.3,24\r\n\t\tc15.2,15.4,23.5,35.9,23.5,57.4c0,11.4-2.4,22.5-6.8,32.8c0.8-0.1,1.6-0.1,2.5-0.2c33.6-3.6,63.3-20.1,84-44.6\r\n\t\tc5.4-6.3,10.2-13.2,14.2-20.5C440.4,304.1,432.6,305.2,424.6,305.6z"},"children":[]}]}]},{"name":"path","attribs":{"class":"st0","d":"M189,209c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8C84.7,297.7,64,320.8,64,347.9\r\n\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\tC257.5,235.3,226.3,209,189,209L189,209z"},"children":[]}]};exports.iosCloudyNight=iosCloudyNight;var iosCloudyOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M244,175.8c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\tc26.9,0,48.8,22.1,48.8,49.2c0,27.1-21.9,49.2-48.8,49.2H170.7c-9.5,0-18.5-3.9-25.4-10.8c-6.8-7-10.6-16.2-10.6-25.9\r\n\tc0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.7-1.2,14.2-1.7c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\tC181.5,204,209.5,175.8,244,175.8 M244,160c-43,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7S364.1,221,328.4,221c-2.7,0-5.4,0-8,0.3C312.5,186.3,281,160,244,160\r\n\tL244,160z"},"children":[]}]};exports.iosCloudyOutline=iosCloudyOutline;var iosCloudy={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M244,160c-43,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7S364.1,221,328.4,221c-2.7,0-5.4,0-8,0.3C312.5,186.3,281,160,244,160\r\n\tL244,160z"},"children":[]}]};exports.iosCloudy=iosCloudy;var iosCogOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,272.754v-32.008l-33.291-8.703l-2.601-13.204l27.594-20.905l-12.197-29.608l-34.392,4.802l-7.498-10.603\r\n\t\tl17.696-29.708l-22.594-22.605l-30.192,17.404l-10.697-7.302l5.298-35.009l-29.492-12.303L294.04,101.31l-12.297-2.601L273.045,64\r\n\t\th-31.991l-9.197,34.909l-12.098,2.4l-21.494-29.008l-29.592,12.304l4.799,35.709l-11.697,7.202l-31.292-18.705l-22.594,22.606\r\n\t\tl18.795,31.508l-6.698,10.502l-35.49-5.001l-12.197,29.608l28.893,21.706l-2.399,12.203L64,240.846v32.008l34.69,8.903l2.4,12.503\r\n\t\tl-28.394,21.306l12.297,29.508l34.991-5.002l7.099,11.303l-17.896,30.608l22.595,22.605l30.192-18.204l11.196,7.302l-4.498,34.31\r\n\t\tl29.592,12.202l20.595-27.807l13.396,2.5L241.054,448h31.991l8.298-33.109l13.597-2.601l20.694,27.107l29.593-12.204l-4.998-33.708\r\n\t\tl10.196-7.401l28.992,16.904l22.595-22.606l-16.795-28.907l7.896-11.403l33.791,4.802l12.298-29.508l-27.193-20.506l2.7-13.503\r\n\t\tL448,272.754z M419.707,320.767l-2.8,6.702l-31.891-4.501l-18.896,27.807l15.695,27.106l-5.198,5.202l-27.293-15.904\r\n\t\tl-26.593,18.204l4.799,31.809l-6.698,2.802l-19.595-25.607l-32.892,6.501l-7.798,31.209h-7.198l-8.397-31.309l-32.592-6.501\r\n\t\tl-19.495,26.406l-6.698-2.801l4.399-32.509l-27.493-18.304l-28.793,17.504l-5.099-5.101l16.996-29.108l-18.096-27.606\r\n\t\tl-33.191,4.701l-2.699-6.603l26.894-20.205l-6.199-31.809l-32.991-8.502v-7.202l32.991-8.402l6.299-31.608l-27.293-20.505\r\n\t\tl2.699-6.602l33.691,4.801l17.796-26.807l-17.996-30.008l4.999-5.001l20.595,12.303l9.197,5.501l27.893-18.205l-4.499-33.809\r\n\t\tl6.699-2.8l20.294,27.407l31.492-6.102l8.798-33.208h7.198l8.298,33.008l31.691,6.301l20.095-26.807l6.598,2.801l-4.999,33.108\r\n\t\tl27.193,18.105l28.292-16.205l5.1,5.102l-16.695,28.007l18.396,27.007l32.491-4.601l2.799,6.702l-26.193,19.705l6.498,32.508\r\n\t\tl31.292,8.102v7.202l-31.391,8.103l-6.499,32.709L419.707,320.767z"},"children":[{"name":"path","attribs":{"d":"M448,272.754v-32.008l-33.291-8.703l-2.601-13.204l27.594-20.905l-12.197-29.608l-34.392,4.802l-7.498-10.603\r\n\t\tl17.696-29.708l-22.594-22.605l-30.192,17.404l-10.697-7.302l5.298-35.009l-29.492-12.303L294.04,101.31l-12.297-2.601L273.045,64\r\n\t\th-31.991l-9.197,34.909l-12.098,2.4l-21.494-29.008l-29.592,12.304l4.799,35.709l-11.697,7.202l-31.292-18.705l-22.594,22.606\r\n\t\tl18.795,31.508l-6.698,10.502l-35.49-5.001l-12.197,29.608l28.893,21.706l-2.399,12.203L64,240.846v32.008l34.69,8.903l2.4,12.503\r\n\t\tl-28.394,21.306l12.297,29.508l34.991-5.002l7.099,11.303l-17.896,30.608l22.595,22.605l30.192-18.204l11.196,7.302l-4.498,34.31\r\n\t\tl29.592,12.202l20.595-27.807l13.396,2.5L241.054,448h31.991l8.298-33.109l13.597-2.601l20.694,27.107l29.593-12.204l-4.998-33.708\r\n\t\tl10.196-7.401l28.992,16.904l22.595-22.606l-16.795-28.907l7.896-11.403l33.791,4.802l12.298-29.508l-27.193-20.506l2.7-13.503\r\n\t\tL448,272.754z M419.707,320.767l-2.8,6.702l-31.891-4.501l-18.896,27.807l15.695,27.106l-5.198,5.202l-27.293-15.904\r\n\t\tl-26.593,18.204l4.799,31.809l-6.698,2.802l-19.595-25.607l-32.892,6.501l-7.798,31.209h-7.198l-8.397-31.309l-32.592-6.501\r\n\t\tl-19.495,26.406l-6.698-2.801l4.399-32.509l-27.493-18.304l-28.793,17.504l-5.099-5.101l16.996-29.108l-18.096-27.606\r\n\t\tl-33.191,4.701l-2.699-6.603l26.894-20.205l-6.199-31.809l-32.991-8.502v-7.202l32.991-8.402l6.299-31.608l-27.293-20.505\r\n\t\tl2.699-6.602l33.691,4.801l17.796-26.807l-17.996-30.008l4.999-5.001l20.595,12.303l9.197,5.501l27.893-18.205l-4.499-33.809\r\n\t\tl6.699-2.8l20.294,27.407l31.492-6.102l8.798-33.208h7.198l8.298,33.008l31.691,6.301l20.095-26.807l6.598,2.801l-4.999,33.108\r\n\t\tl27.193,18.105l28.292-16.205l5.1,5.102l-16.695,28.007l18.396,27.007l32.491-4.601l2.799,6.702l-26.193,19.705l6.498,32.508\r\n\t\tl31.292,8.102v7.202l-31.391,8.103l-6.499,32.709L419.707,320.767z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128c-70.692,0-128,57.308-128,128c0,70.693,57.308,128,128,128s128-57.307,128-128C384,185.308,326.692,128,256,128z\r\n\t\t M144,256c0-29.916,11.65-58.042,32.804-79.195C197.958,155.65,226.084,144,256,144c7.496,0,14.88,0.732,22.069,2.161L250.3,250.1\r\n\t\tl-104.155,27.888C144.727,270.824,144,263.468,144,256z M256,368c-29.917,0-58.042-11.65-79.196-32.804\r\n\t\tc-11.927-11.926-20.831-26.069-26.331-41.499L253.9,266.2l74.935,74.889C308.558,358.501,283.009,368,256,368z M340.154,329.901\r\n\t\tL265.2,254.9l28.05-104.58c15.604,5.487,29.904,14.443,41.945,26.484C356.35,197.958,368,226.084,368,256\r\n\t\tC368,283.486,358.159,309.457,340.154,329.901z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.692,0-128,57.308-128,128c0,70.693,57.308,128,128,128s128-57.307,128-128C384,185.308,326.692,128,256,128z\r\n\t\t M144,256c0-29.916,11.65-58.042,32.804-79.195C197.958,155.65,226.084,144,256,144c7.496,0,14.88,0.732,22.069,2.161L250.3,250.1\r\n\t\tl-104.155,27.888C144.727,270.824,144,263.468,144,256z M256,368c-29.917,0-58.042-11.65-79.196-32.804\r\n\t\tc-11.927-11.926-20.831-26.069-26.331-41.499L253.9,266.2l74.935,74.889C308.558,358.501,283.009,368,256,368z M340.154,329.901\r\n\t\tL265.2,254.9l28.05-104.58c15.604,5.487,29.904,14.443,41.945,26.484C356.35,197.958,368,226.084,368,256\r\n\t\tC368,283.486,358.159,309.457,340.154,329.901z"},"children":[]}]}]}]};exports.iosCogOutline=iosCogOutline;var iosCog={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M293.25,150.32L265.2,254.9l74.954,75C358.159,309.457,368,283.486,368,256c0-29.916-11.65-58.042-32.805-79.196\r\n\t\tC323.154,164.763,308.854,155.807,293.25,150.32z"},"children":[{"name":"path","attribs":{"d":"M293.25,150.32L265.2,254.9l74.954,75C358.159,309.457,368,283.486,368,256c0-29.916-11.65-58.042-32.805-79.196\r\n\t\tC323.154,164.763,308.854,155.807,293.25,150.32z"},"children":[]}]},{"name":"path","attribs":{"d":"M278.068,146.161C270.88,144.732,263.496,144,256,144c-29.916,0-58.042,11.65-79.196,32.805\r\n\t\tC155.65,197.958,144,226.084,144,256c0,7.468,0.727,14.824,2.145,21.988L250.3,250.1L278.068,146.161z"},"children":[{"name":"path","attribs":{"d":"M278.068,146.161C270.88,144.732,263.496,144,256,144c-29.916,0-58.042,11.65-79.196,32.805\r\n\t\tC155.65,197.958,144,226.084,144,256c0,7.468,0.727,14.824,2.145,21.988L250.3,250.1L278.068,146.161z"},"children":[]}]},{"name":"path","attribs":{"d":"M150.473,293.697c5.5,15.43,14.404,29.572,26.331,41.498C197.958,356.35,226.083,368,256,368\r\n\t\tc27.009,0,52.558-9.499,72.835-26.911L253.9,266.2L150.473,293.697z"},"children":[{"name":"path","attribs":{"d":"M150.473,293.697c5.5,15.43,14.404,29.572,26.331,41.498C197.958,356.35,226.083,368,256,368\r\n\t\tc27.009,0,52.558-9.499,72.835-26.911L253.9,266.2L150.473,293.697z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,272.754v-32.008l-33.291-8.703l-2.601-13.204l27.594-20.905l-12.197-29.608l-34.392,4.802l-7.498-10.603\r\n\t\tl17.695-29.708l-22.594-22.605l-30.191,17.404l-10.697-7.302l5.298-35.009l-29.492-12.303L294.04,101.31l-12.297-2.601L273.045,64\r\n\t\th-31.991l-9.197,34.909l-12.098,2.4l-21.494-29.008l-29.592,12.304l4.799,35.709l-11.697,7.202l-31.292-18.705l-22.594,22.606\r\n\t\tl18.795,31.508l-6.698,10.502l-35.49-5.001l-12.197,29.608l28.893,21.706l-2.399,12.203L64,240.846v32.007l34.69,8.903l2.4,12.503\r\n\t\tl-28.394,21.307l12.297,29.508l34.991-5.002l7.099,11.303l-17.896,30.607l22.595,22.605l30.192-18.204l11.196,7.302l-4.498,34.311\r\n\t\tl29.592,12.202l20.595-27.808l13.396,2.5L241.054,448h31.991l8.298-33.109l13.597-2.601l20.694,27.106l29.593-12.203l-4.998-33.709\r\n\t\tl10.196-7.4l28.992,16.904l22.595-22.606l-16.795-28.907l7.896-11.402l33.791,4.802l12.298-29.508l-27.193-20.507l2.7-13.502\r\n\t\tL448,272.754z M256,384c-70.692,0-128-57.307-128-128c0-70.692,57.308-128,128-128c70.692,0,128,57.308,128,128\r\n\t\tC384,326.693,326.692,384,256,384z"},"children":[{"name":"path","attribs":{"d":"M448,272.754v-32.008l-33.291-8.703l-2.601-13.204l27.594-20.905l-12.197-29.608l-34.392,4.802l-7.498-10.603\r\n\t\tl17.695-29.708l-22.594-22.605l-30.191,17.404l-10.697-7.302l5.298-35.009l-29.492-12.303L294.04,101.31l-12.297-2.601L273.045,64\r\n\t\th-31.991l-9.197,34.909l-12.098,2.4l-21.494-29.008l-29.592,12.304l4.799,35.709l-11.697,7.202l-31.292-18.705l-22.594,22.606\r\n\t\tl18.795,31.508l-6.698,10.502l-35.49-5.001l-12.197,29.608l28.893,21.706l-2.399,12.203L64,240.846v32.007l34.69,8.903l2.4,12.503\r\n\t\tl-28.394,21.307l12.297,29.508l34.991-5.002l7.099,11.303l-17.896,30.607l22.595,22.605l30.192-18.204l11.196,7.302l-4.498,34.311\r\n\t\tl29.592,12.202l20.595-27.808l13.396,2.5L241.054,448h31.991l8.298-33.109l13.597-2.601l20.694,27.106l29.593-12.203l-4.998-33.709\r\n\t\tl10.196-7.4l28.992,16.904l22.595-22.606l-16.795-28.907l7.896-11.402l33.791,4.802l12.298-29.508l-27.193-20.507l2.7-13.502\r\n\t\tL448,272.754z M256,384c-70.692,0-128-57.307-128-128c0-70.692,57.308-128,128-128c70.692,0,128,57.308,128,128\r\n\t\tC384,326.693,326.692,384,256,384z"},"children":[]}]}]}]};exports.iosCog=iosCog;var iosColorFilterOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M366.195,212.122c1.185-6.528,1.806-13.252,1.806-20.122c0-61.856-50.145-112.001-112.001-112.001\r\n\tS143.999,130.144,143.999,192c0,6.87,0.621,13.594,1.806,20.122C98.616,225.302,63.999,268.606,63.999,320\r\n\tc0,61.856,50.145,112.001,112.001,112.001c31.342,0,59.671-12.879,80-33.627c20.329,20.748,48.658,33.627,80,33.627\r\n\tc61.856,0,112.001-50.145,112.001-112.001C448.001,268.606,413.384,225.303,366.195,212.122z M159.999,192\r\n\tc0-52.935,43.065-96.001,96.001-96.001s96.001,43.066,96.001,96.001c0,5.776-0.513,11.435-1.495,16.933\r\n\tc-4.749-0.614-9.59-0.934-14.506-0.934c-31.342,0-59.671,12.879-80,33.627c-20.329-20.748-48.658-33.627-80-33.627\r\n\tc-4.916,0-9.757,0.319-14.506,0.934C160.512,203.435,159.999,197.776,159.999,192z M272.001,320c0,19.58-5.896,37.806-16.001,53.006\r\n\tc-10.104-15.2-16.001-33.426-16.001-53.006c0-5.776,0.513-11.435,1.495-16.933c4.749,0.614,9.59,0.934,14.506,0.934\r\n\ts9.757-0.319,14.506-0.934C271.488,308.565,272.001,314.224,272.001,320z M256,288.001c-3.484,0-6.925-0.191-10.314-0.556\r\n\tc2.626-7.262,6.105-14.119,10.314-20.451c4.21,6.332,7.688,13.189,10.314,20.451C262.925,287.81,259.484,288.001,256,288.001z\r\n\t M229.791,284.364c-29.756-8.455-53.666-30.937-64.105-59.81c3.39-0.364,6.83-0.556,10.314-0.556\r\n\tc27.353,0,52.069,11.5,69.572,29.917C238.847,263.104,233.484,273.351,229.791,284.364z M266.428,253.917\r\n\tc17.503-18.418,42.219-29.918,69.572-29.918c3.484,0,6.925,0.191,10.314,0.556c-10.439,28.873-34.35,51.354-64.105,59.81\r\n\tC278.516,273.351,273.153,263.104,266.428,253.917z M176,416.001c-52.936,0-96.001-43.065-96.001-96.001\r\n\tc0-43.852,29.555-80.931,69.792-92.364c11.732,34.983,40.265,62.257,76.014,72.243c-1.185,6.527-1.806,13.252-1.806,20.121\r\n\tc0,24.717,8.013,47.559,21.573,66.084C228.069,404.501,203.353,416.001,176,416.001z M336,416.001\r\n\tc-27.354,0-52.069-11.5-69.572-29.918c13.561-18.524,21.573-41.366,21.573-66.083c0-6.869-0.621-13.594-1.806-20.121\r\n\tc35.749-9.986,64.281-37.26,76.014-72.243c40.237,11.434,69.792,48.513,69.792,92.364C432.001,372.936,388.936,416.001,336,416.001z\r\n\t"},"children":[]}]};exports.iosColorFilterOutline=iosColorFilterOutline;var iosColorFilter={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M366.194,212.122c1.185-6.528,1.807-13.252,1.807-20.122c0-61.856-50.146-112-112.001-112\r\n\t\tc-61.857,0-112.001,50.144-112.001,112c0,6.87,0.622,13.594,1.806,20.122C98.618,225.302,64,268.606,64,320\r\n\t\tc0,61.855,50.144,112,112,112c31.341,0,59.67-12.879,80-33.627C276.328,419.121,304.658,432,335.999,432\r\n\t\tC397.854,432,448,381.855,448,320C448,268.606,413.381,225.303,366.194,212.122z M255.998,395.373\r\n\t\tc-0.484,0.495-0.979,0.982-1.475,1.469c-3.201-3.394-6.189-6.987-8.951-10.759c-13.561-18.525-21.574-41.366-21.574-66.083\r\n\t\tc0-6.869,0.622-13.594,1.807-20.121c-35.749-9.986-64.281-37.26-76.014-72.243c-1.594-4.752-2.872-9.647-3.822-14.659\r\n\t\tc0.942-0.29,1.882-0.589,2.835-0.854c-0.046-0.252-0.085-0.507-0.129-0.759c4.186-1.049,8.463-1.867,12.82-2.43\r\n\t\tC166.243,208.319,171.084,208,176,208c31.341,0,59.67,12.878,80,33.626C276.328,220.878,304.658,208,335.999,208\r\n\t\tc4.916,0,9.757,0.319,14.506,0.934c4.355,0.563,8.633,1.38,12.816,2.429c-0.043,0.253-0.082,0.507-0.129,0.76\r\n\t\tc0.955,0.267,1.895,0.564,2.838,0.855c-0.949,5.012-2.229,9.907-3.822,14.658c-11.732,34.983-40.266,62.257-76.013,72.242\r\n\t\tc1.185,6.528,1.807,13.253,1.807,20.122c0,24.717-8.014,47.558-21.574,66.083c-2.762,3.772-5.752,7.367-8.953,10.76\r\n\t\tC256.979,396.356,256.484,395.869,255.998,395.373z"},"children":[{"name":"path","attribs":{"d":"M366.194,212.122c1.185-6.528,1.807-13.252,1.807-20.122c0-61.856-50.146-112-112.001-112\r\n\t\tc-61.857,0-112.001,50.144-112.001,112c0,6.87,0.622,13.594,1.806,20.122C98.618,225.302,64,268.606,64,320\r\n\t\tc0,61.855,50.144,112,112,112c31.341,0,59.67-12.879,80-33.627C276.328,419.121,304.658,432,335.999,432\r\n\t\tC397.854,432,448,381.855,448,320C448,268.606,413.381,225.303,366.194,212.122z M255.998,395.373\r\n\t\tc-0.484,0.495-0.979,0.982-1.475,1.469c-3.201-3.394-6.189-6.987-8.951-10.759c-13.561-18.525-21.574-41.366-21.574-66.083\r\n\t\tc0-6.869,0.622-13.594,1.807-20.121c-35.749-9.986-64.281-37.26-76.014-72.243c-1.594-4.752-2.872-9.647-3.822-14.659\r\n\t\tc0.942-0.29,1.882-0.589,2.835-0.854c-0.046-0.252-0.085-0.507-0.129-0.759c4.186-1.049,8.463-1.867,12.82-2.43\r\n\t\tC166.243,208.319,171.084,208,176,208c31.341,0,59.67,12.878,80,33.626C276.328,220.878,304.658,208,335.999,208\r\n\t\tc4.916,0,9.757,0.319,14.506,0.934c4.355,0.563,8.633,1.38,12.816,2.429c-0.043,0.253-0.082,0.507-0.129,0.76\r\n\t\tc0.955,0.267,1.895,0.564,2.838,0.855c-0.949,5.012-2.229,9.907-3.822,14.658c-11.732,34.983-40.266,62.257-76.013,72.242\r\n\t\tc1.185,6.528,1.807,13.253,1.807,20.122c0,24.717-8.014,47.558-21.574,66.083c-2.762,3.772-5.752,7.367-8.953,10.76\r\n\t\tC256.979,396.356,256.484,395.869,255.998,395.373z"},"children":[]}]},{"name":"path","attribs":{"d":"M270.506,303.067c-4.749,0.614-9.59,0.934-14.506,0.934s-9.758-0.319-14.506-0.934c-0.982,5.498-1.496,11.156-1.496,16.933\r\n\t\tc0,19.58,5.898,37.806,16.002,53.005c10.104-15.199,16.002-33.425,16.002-53.005C272.002,314.224,271.488,308.565,270.506,303.067z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M270.506,303.067c-4.749,0.614-9.59,0.934-14.506,0.934s-9.758-0.319-14.506-0.934c-0.982,5.498-1.496,11.156-1.496,16.933\r\n\t\tc0,19.58,5.898,37.806,16.002,53.005c10.104-15.199,16.002-33.425,16.002-53.005C272.002,314.224,271.488,308.565,270.506,303.067z\r\n\t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M346.313,224.555c-3.39-0.364-6.83-0.556-10.314-0.556c-27.354,0-52.069,11.5-69.571,29.917\r\n\t\tc6.725,9.188,12.088,19.434,15.781,30.448C311.964,275.909,335.874,253.428,346.313,224.555z"},"children":[{"name":"path","attribs":{"d":"M346.313,224.555c-3.39-0.364-6.83-0.556-10.314-0.556c-27.354,0-52.069,11.5-69.571,29.917\r\n\t\tc6.725,9.188,12.088,19.434,15.781,30.448C311.964,275.909,335.874,253.428,346.313,224.555z"},"children":[]}]},{"name":"path","attribs":{"d":"M266.314,287.445c-2.625-7.262-6.105-14.119-10.314-20.451c-4.209,6.332-7.689,13.189-10.314,20.451\r\n\t\tc3.389,0.364,6.83,0.556,10.314,0.556S262.925,287.81,266.314,287.445z"},"children":[{"name":"path","attribs":{"d":"M266.314,287.445c-2.625-7.262-6.105-14.119-10.314-20.451c-4.209,6.332-7.689,13.189-10.314,20.451\r\n\t\tc3.389,0.364,6.83,0.556,10.314,0.556S262.925,287.81,266.314,287.445z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,223.999c-3.484,0-6.925,0.191-10.314,0.556c10.439,28.873,34.349,51.354,64.106,59.81\r\n\t\tc3.693-11.015,9.055-21.261,15.781-30.448C228.07,235.499,203.353,223.999,176,223.999z"},"children":[{"name":"path","attribs":{"d":"M176,223.999c-3.484,0-6.925,0.191-10.314,0.556c10.439,28.873,34.349,51.354,64.106,59.81\r\n\t\tc3.693-11.015,9.055-21.261,15.781-30.448C228.07,235.499,203.353,223.999,176,223.999z"},"children":[]}]}]}]};exports.iosColorFilter=iosColorFilter;var iosColorWandOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M192.011,149.661l-34.043,34.041l256.097,256.096L448,405.757L192.011,149.661z M212.596,215.702l11.415-11.414\r\n\t\tl201.468,201.469l-11.414,11.414L212.596,215.702z"},"children":[{"name":"path","attribs":{"d":"M192.011,149.661l-34.043,34.041l256.097,256.096L448,405.757L192.011,149.661z M212.596,215.702l11.415-11.414\r\n\t\tl201.468,201.469l-11.414,11.414L212.596,215.702z"},"children":[]}]},{"name":"rect","attribs":{"x":"184","y":"64","width":"16","height":"40"},"children":[{"name":"rect","attribs":{"x":"184","y":"64","width":"16","height":"40"},"children":[]}]},{"name":"rect","attribs":{"x":"184","y":"268","width":"16","height":"40"},"children":[{"name":"rect","attribs":{"x":"184","y":"268","width":"16","height":"40"},"children":[]}]},{"name":"rect","attribs":{"x":"280","y":"176","width":"40","height":"16"},"children":[{"name":"rect","attribs":{"x":"280","y":"176","width":"40","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"64","y":"176","width":"40","height":"16"},"children":[{"name":"rect","attribs":{"x":"64","y":"176","width":"40","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"111.875","y":"94.077","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 285.3039 109.9734)","width":"16","height":"40"},"children":[{"name":"rect","attribs":{"x":"111.875","y":"94.077","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 285.3039 109.9734)","width":"16","height":"40"},"children":[]}]},{"name":"rect","attribs":{"x":"111.877","y":"238.327","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 21.9762 525.7571)","width":"15.998","height":"40"},"children":[{"name":"rect","attribs":{"x":"111.877","y":"238.327","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 21.9762 525.7571)","width":"15.998","height":"40"},"children":[]}]},{"name":"rect","attribs":{"x":"256.126","y":"94.077","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 370.226 381.506)","width":"16","height":"39.999"},"children":[{"name":"rect","attribs":{"x":"256.126","y":"94.077","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 370.226 381.506)","width":"16","height":"39.999"},"children":[]}]}]}]};exports.iosColorWandOutline=iosColorWandOutline;var iosColorWand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"198.011,159.22 163.968,193.337 420.064,450 454,415.883 \t"},"children":[{"name":"polygon","attribs":{"points":"198.011,159.22 163.968,193.337 420.064,450 454,415.883 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"182","y":"62","width":"32","height":"64"},"children":[{"name":"rect","attribs":{"x":"182","y":"62","width":"32","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"182","y":"266","width":"32","height":"64"},"children":[{"name":"rect","attribs":{"x":"182","y":"266","width":"32","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"274","y":"178","width":"64","height":"32"},"children":[{"name":"rect","attribs":{"x":"274","y":"178","width":"64","height":"32"},"children":[]}]},{"name":"polygon","attribs":{"points":"303.941,112.143 281.314,89.465 236.06,134.82 258.687,157.498 \t"},"children":[{"name":"polygon","attribs":{"points":"303.941,112.143 281.314,89.465 236.06,134.82 258.687,157.498 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"92.06,112.143 137.314,157.498 159.941,134.82 114.687,89.465 \t"},"children":[{"name":"polygon","attribs":{"points":"92.06,112.143 137.314,157.498 159.941,134.82 114.687,89.465 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"92.06,279.141 114.687,301.816 159.941,256.462 137.314,233.784 \t"},"children":[{"name":"polygon","attribs":{"points":"92.06,279.141 114.687,301.816 159.941,256.462 137.314,233.784 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"58","y":"178","width":"64","height":"32"},"children":[{"name":"rect","attribs":{"x":"58","y":"178","width":"64","height":"32"},"children":[]}]}]}]};exports.iosColorWand=iosColorWand;var iosComposeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"368,416 80,416 80,144 304.117,144 320.117,128 64,128 64,432 384,432 384,191.883 368,207.883 \t"},"children":[{"name":"polygon","attribs":{"points":"368,416 80,416 80,144 304.117,144 320.117,128 64,128 64,432 384,432 384,191.883 368,207.883 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"237.623,284.084 227.917,274.377 399.24,103.054 387.927,91.74 208,271.651 208,304 240.216,304 420.261,124.016 \r\n\t\t408.947,112.73 \t"},"children":[{"name":"polygon","attribs":{"points":"237.623,284.084 227.917,274.377 399.24,103.054 387.927,91.74 208,271.651 208,304 240.216,304 420.261,124.016 \r\n\t\t408.947,112.73 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M444.213,80.312l-12.465-12.466C429.084,65.467,425.556,64,421.746,64c-3.812,0-7.304,1.468-9.929,3.85L399.666,80\r\n\t\tl0.08,0.08l11.293,11.293l21.02,21.02l12.15-12.15c2.383-2.625,3.791-6.117,3.791-9.929C448,86.504,446.592,82.975,444.213,80.312z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M444.213,80.312l-12.465-12.466C429.084,65.467,425.556,64,421.746,64c-3.812,0-7.304,1.468-9.929,3.85L399.666,80\r\n\t\tl0.08,0.08l11.293,11.293l21.02,21.02l12.15-12.15c2.383-2.625,3.791-6.117,3.791-9.929C448,86.504,446.592,82.975,444.213,80.312z\r\n\t\t"},"children":[]}]}]}]};exports.iosComposeOutline=iosComposeOutline;var iosCompose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,320 192,320 192,256 320,128 64,128 64,432 384,432 384,192 \t"},"children":[{"name":"polygon","attribs":{"points":"256,320 192,320 192,256 320,128 64,128 64,432 384,432 384,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"387.927,91.74 208,271.651 208,304 240.216,304 420.261,124.016 \t"},"children":[{"name":"polygon","attribs":{"points":"387.927,91.74 208,271.651 208,304 240.216,304 420.261,124.016 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M444.213,80.312l-12.465-12.466C429.084,65.467,425.556,64,421.746,64c-3.812,0-7.304,1.468-9.929,3.85L399.666,80\r\n\t\tl0.08,0.08l11.293,11.293l21.02,21.02l12.15-12.15c2.383-2.625,3.791-6.117,3.791-9.929C448,86.504,446.592,82.975,444.213,80.312z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M444.213,80.312l-12.465-12.466C429.084,65.467,425.556,64,421.746,64c-3.812,0-7.304,1.468-9.929,3.85L399.666,80\r\n\t\tl0.08,0.08l11.293,11.293l21.02,21.02l12.15-12.15c2.383-2.625,3.791-6.117,3.791-9.929C448,86.504,446.592,82.975,444.213,80.312z\r\n\t\t"},"children":[]}]}]}]};exports.iosCompose=iosCompose;var iosContactOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M256,65.3\r\n\tc105.1,0,190.7,85.5,190.7,190.7c0,46.5-16.7,89.1-44.4,122.2c-20-8.2-65.9-24.1-92.9-32.1c-2.4-0.7-2.7-0.9-2.7-10.7\r\n\tc0-8.1,3.3-16.3,6.6-23.3c3.6-7.5,7.7-20.2,9.2-31.6c4.2-4.9,10-14.5,13.6-32.9c3.2-16.2,1.7-22.1-0.4-27.6\r\n\tc-0.2-0.6-0.5-1.2-0.6-1.7c-0.8-3.8,0.3-23.5,3.1-38.8c1.9-10.5-0.5-32.8-14.9-51.3c-9.1-11.7-26.6-26-58.5-28l-17.5,0\r\n\tc-31.4,2-48.8,16.3-58,28c-14.5,18.5-16.9,40.8-15,51.3c2.8,15.3,3.9,35,3.1,38.8c-0.2,0.7-0.4,1.2-0.6,1.8\r\n\tc-2.1,5.5-3.7,11.4-0.4,27.6c3.7,18.4,9.4,28,13.6,32.9c1.5,11.4,5.7,24,9.2,31.6c2.6,5.5,3.8,13,3.8,23.6c0,9.9-0.4,10-2.6,10.7\r\n\tc-28.1,8.3-72.6,24.3-90.4,32C82.1,345.3,65.3,302.6,65.3,256C65.3,150.9,150.9,65.3,256,65.3z"},"children":[]}]};exports.iosContactOutline=iosContactOutline;var iosContact={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t M256,446.7c-58.6,0-111.1-26.6-146.1-68.3c17.8-7.7,62.2-23.7,90.3-31.9c2.2-0.7,2.6-0.8,2.6-10.7c0-10.6-1.2-18.1-3.8-23.6\r\n\tc-3.5-7.5-7.7-20.2-9.2-31.6c-4.2-4.9-9.9-14.5-13.6-32.9c-3.2-16.2-1.7-22.1,0.4-27.6c0.2-0.6,0.5-1.2,0.6-1.8\r\n\tc0.8-3.7-0.3-23.5-3.1-38.8c-1.9-10.5,0.5-32.8,15-51.3c9.1-11.7,26.6-26,58-28l17.5,0c31.9,2,49.4,16.3,58.5,28\r\n\tc14.5,18.5,16.9,40.8,14.9,51.3c-2.8,15.3-3.9,35-3.1,38.8c0.1,0.6,0.4,1.2,0.6,1.7c2.1,5.5,3.7,11.4,0.4,27.6\r\n\tc-3.7,18.4-9.4,28-13.6,32.9c-1.5,11.4-5.7,24-9.2,31.6c-3.3,6.9-6.6,15.1-6.6,23.3c0,9.9,0.4,10,2.7,10.7\r\n\tc26.7,7.9,72.7,23.8,93,32.1C367.2,420,314.7,446.7,256,446.7z"},"children":[]}]};exports.iosContact=iosContact;var iosCopyOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"304,96 288,96 288,176 368,176 368,160 304,160 \t"},"children":[{"name":"polygon","attribs":{"points":"304,96 288,96 288,176 368,176 368,160 304,160 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M325.3,64H160v48h-48v336h240v-48h48V139L325.3,64z M336,432H128V128h32v272h176V432z M384,384H176V80h142.7l65.3,65.6V384\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M325.3,64H160v48h-48v336h240v-48h48V139L325.3,64z M336,432H128V128h32v272h176V432z M384,384H176V80h142.7l65.3,65.6V384\r\n\t\tz"},"children":[]}]}]}]};exports.iosCopyOutline=iosCopyOutline;var iosCopy={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"144,416 144,400 144,112 112,112 112,448 352,448 352,416 160,416 \t"},"children":[{"name":"polygon","attribs":{"points":"144,416 144,400 144,112 112,112 112,448 352,448 352,416 160,416 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M325.3,64H160v48v288h192h48V139L325.3,64z M368,176h-80V96h16v64h64V176z"},"children":[{"name":"path","attribs":{"d":"M325.3,64H160v48v288h192h48V139L325.3,64z M368,176h-80V96h16v64h64V176z"},"children":[]}]}]}]}]}]};exports.iosCopy=iosCopy;var iosCropStrong={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"64","width":"32","height":"48"},"children":[{"name":"rect","attribs":{"x":"128","y":"64","width":"32","height":"48"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,352 160,176 128,176 128,384 336,384 336,352 \t"},"children":[{"name":"polygon","attribs":{"points":"160,352 160,176 128,176 128,384 336,384 336,352 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"400","y":"352","width":"48","height":"32"},"children":[{"name":"rect","attribs":{"x":"400","y":"352","width":"48","height":"32"},"children":[]}]},{"name":"polygon","attribs":{"points":"64,128 64,160 352,160 352,448 384,448 384,128 \t"},"children":[{"name":"polygon","attribs":{"points":"64,128 64,160 352,160 352,448 384,448 384,128 \t"},"children":[]}]}]}]};exports.iosCropStrong=iosCropStrong;var iosCrop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"64","width":"16","height":"48"},"children":[{"name":"rect","attribs":{"x":"128","y":"64","width":"16","height":"48"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,368 144,160 128,160 128,384 352,384 352,368 \t"},"children":[{"name":"polygon","attribs":{"points":"144,368 144,160 128,160 128,384 352,384 352,368 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"400","y":"368","width":"48","height":"16"},"children":[{"name":"rect","attribs":{"x":"400","y":"368","width":"48","height":"16"},"children":[]}]},{"name":"polygon","attribs":{"points":"64,128 64,144 368,144 368,448 384,448 384,128 \t"},"children":[{"name":"polygon","attribs":{"points":"64,128 64,144 368,144 368,448 384,448 384,128 \t"},"children":[]}]}]}]};exports.iosCrop=iosCrop;var iosDownloadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"288,144 288,160 400,160 400,432 112,432 112,160 224,160 224,144 96,144 96,448 416,448 416,144 \t\t"},"children":[{"name":"polygon","attribs":{"points":"288,144 288,160 400,160 400,432 112,432 112,160 224,160 224,144 96,144 96,448 416,448 416,144 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"193.1,252.3 181.5,263.9 256,338.4 330.5,263.9 318.9,252.3 264.2,307 264.2,64 247.8,64 247.8,307 \t\t"},"children":[{"name":"polygon","attribs":{"points":"193.1,252.3 181.5,263.9 256,338.4 330.5,263.9 318.9,252.3 264.2,307 264.2,64 247.8,64 247.8,307 \t\t"},"children":[]}]}]}]}]}]};exports.iosDownloadOutline=iosDownloadOutline;var iosDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"264,144 264,307 318.8,252.3 330.4,263.9 256,338.4 181.5,263.9 193.2,252.3 248,307 248,144 96,144 96,448 \r\n\t\t416,448 416,144 \t"},"children":[{"name":"polygon","attribs":{"points":"264,144 264,307 318.8,252.3 330.4,263.9 256,338.4 181.5,263.9 193.2,252.3 248,307 248,144 96,144 96,448 \r\n\t\t416,448 416,144 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"248","y":"64","width":"16","height":"80"},"children":[{"name":"rect","attribs":{"x":"248","y":"64","width":"16","height":"80"},"children":[]}]}]}]};exports.iosDownload=iosDownload;var iosDrag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"80","y":"304","width":"352","height":"16"},"children":[{"name":"rect","attribs":{"x":"80","y":"304","width":"352","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"80","y":"248","width":"352","height":"16"},"children":[{"name":"rect","attribs":{"x":"80","y":"248","width":"352","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"80","y":"192","width":"352","height":"16"},"children":[{"name":"rect","attribs":{"x":"80","y":"192","width":"352","height":"16"},"children":[]}]}]}]};exports.iosDrag=iosDrag;var iosEmailOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M64,128v256h384V128H64z M256,267.9L93.2,144h325.6L256,267.9z M80,368V154.1l115.1,87.6L127,319l2,2l78.9-69.6L256,288\r\n\tl48.1-36.6L383,321l2-2l-68.1-77.4L432,154.1V368H80z"},"children":[]}]};exports.iosEmailOutline=iosEmailOutline;var iosEmail={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"448,384 448,141.8 316.9,241.6 385,319 383,321 304.1,251.4 256,288 207.9,251.4 129,321 127,319 195,241.6 \r\n\t\t64,142 64,384 \t"},"children":[{"name":"polygon","attribs":{"points":"448,384 448,141.8 316.9,241.6 385,319 383,321 304.1,251.4 256,288 207.9,251.4 129,321 127,319 195,241.6 \r\n\t\t64,142 64,384 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"439.7,128 72,128 256,267.9 \t"},"children":[{"name":"polygon","attribs":{"points":"439.7,128 72,128 256,267.9 \t"},"children":[]}]}]}]};exports.iosEmail=iosEmail;var iosEyeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M447.1,256.2C401.8,204,339.2,144,256,144c-33.6,0-64.4,9.5-96.9,29.8C131.7,191,103.6,215.2,65,255l-1,1l6.7,6.9\r\n\t\t\tC125.8,319.3,173.4,368,256,368c36.5,0,71.9-11.9,108.2-36.4c30.9-20.9,57.2-47.4,78.3-68.8l5.5-5.5L447.1,256.2z M256,160\r\n\t\t\tc33.1,0,64.9,9.5,97.2,30.6c23.9,15.6,47.4,36.7,73.7,66.1C388.6,295.4,331.1,352,256,352c-34.2,0-64.2-8.4-94.2-28.2\r\n\t\t\tc-27.5-18.1-52.3-43.3-76.2-67.8C144.7,196.3,194,160,256,160z"},"children":[{"name":"path","attribs":{"d":"M447.1,256.2C401.8,204,339.2,144,256,144c-33.6,0-64.4,9.5-96.9,29.8C131.7,191,103.6,215.2,65,255l-1,1l6.7,6.9\r\n\t\t\tC125.8,319.3,173.4,368,256,368c36.5,0,71.9-11.9,108.2-36.4c30.9-20.9,57.2-47.4,78.3-68.8l5.5-5.5L447.1,256.2z M256,160\r\n\t\t\tc33.1,0,64.9,9.5,97.2,30.6c23.9,15.6,47.4,36.7,73.7,66.1C388.6,295.4,331.1,352,256,352c-34.2,0-64.2-8.4-94.2-28.2\r\n\t\t\tc-27.5-18.1-52.3-43.3-76.2-67.8C144.7,196.3,194,160,256,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,336c44.1,0,80-35.9,80-80c0-44.1-35.9-80-80-80c-44.1,0-80,35.9-80,80C176,300.1,211.9,336,256,336z M256,192.3\r\n\t\t\tc35.2,0,64,28.6,64,63.7c0,35.1-28.8,63.7-64,63.7c-35.2,0-63.9-28.6-63.9-63.7C192.1,220.9,220.8,192.3,256,192.3z"},"children":[{"name":"path","attribs":{"d":"M256,336c44.1,0,80-35.9,80-80c0-44.1-35.9-80-80-80c-44.1,0-80,35.9-80,80C176,300.1,211.9,336,256,336z M256,192.3\r\n\t\t\tc35.2,0,64,28.6,64,63.7c0,35.1-28.8,63.7-64,63.7c-35.2,0-63.9-28.6-63.9-63.7C192.1,220.9,220.8,192.3,256,192.3z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M288,256L288,256c0,17.5-14.4,32-31.8,32S224,272.8,224,255.3s15.8-31.3,32-31.3l0-16c-26.5,0-47.9,21.6-47.9,48.2\r\n\t\tc0,26.6,21.5,48.1,47.9,48.1s48-21.6,48-48.1V256H288z"},"children":[{"name":"path","attribs":{"d":"M288,256L288,256c0,17.5-14.4,32-31.8,32S224,272.8,224,255.3s15.8-31.3,32-31.3l0-16c-26.5,0-47.9,21.6-47.9,48.2\r\n\t\tc0,26.6,21.5,48.1,47.9,48.1s48-21.6,48-48.1V256H288z"},"children":[]}]}]}]};exports.iosEyeOutline=iosEyeOutline;var iosEye={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M447.1,256.2C401.8,204,339.2,144,256,144c-33.6,0-64.4,9.5-96.9,29.8C131.7,191,103.6,215.2,65,255l-1,1l6.7,6.9\r\n\t\tC125.8,319.3,173.4,368,256,368c36.5,0,71.9-11.9,108.2-36.4c30.9-20.9,57.2-47.4,78.3-68.8l5.5-5.5L447.1,256.2z M256,336\r\n\t\tc-44.1,0-80-35.9-80-80c0-44.1,35.9-80,80-80c44.1,0,80,35.9,80,80C336,300.1,300.1,336,256,336z"},"children":[{"name":"path","attribs":{"d":"M447.1,256.2C401.8,204,339.2,144,256,144c-33.6,0-64.4,9.5-96.9,29.8C131.7,191,103.6,215.2,65,255l-1,1l6.7,6.9\r\n\t\tC125.8,319.3,173.4,368,256,368c36.5,0,71.9-11.9,108.2-36.4c30.9-20.9,57.2-47.4,78.3-68.8l5.5-5.5L447.1,256.2z M256,336\r\n\t\tc-44.1,0-80-35.9-80-80c0-44.1,35.9-80,80-80c44.1,0,80,35.9,80,80C336,300.1,300.1,336,256,336z"},"children":[]}]},{"name":"path","attribs":{"d":"M250.4,226.8c0-6.9,2-13.4,5.5-18.8c-26.5,0-47.9,21.6-47.9,48.2c0,26.6,21.5,48.1,47.9,48.1s48-21.5,48-48.1v0\r\n\t\tc-5.4,3.5-11.9,5.5-18.8,5.5C266,261.6,250.4,246,250.4,226.8z"},"children":[{"name":"path","attribs":{"d":"M250.4,226.8c0-6.9,2-13.4,5.5-18.8c-26.5,0-47.9,21.6-47.9,48.2c0,26.6,21.5,48.1,47.9,48.1s48-21.5,48-48.1v0\r\n\t\tc-5.4,3.5-11.9,5.5-18.8,5.5C266,261.6,250.4,246,250.4,226.8z"},"children":[]}]}]}]};exports.iosEye=iosEye;var iosFastforwardOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M48,155l183.5,101L48,356.9V155 M272,155.8L448,256L272,356.4v-95.6v-27.1V156 M256,128v123.2L32,128v256l224-123.2V384\r\n\tl224-128L256,128L256,128z"},"children":[]}]};exports.iosFastforwardOutline=iosFastforwardOutline;var iosFastforward={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,128v123.2L32,128v256l224-123.2V384l224-128L256,128L256,128z"},"children":[]}]};exports.iosFastforward=iosFastforward;var iosFilingOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M368.5,128h-225L80,224v160h176h176V224L368.5,128z M413.4,224H368v-68L413.4,224z M160,144h192v80h-48\r\n\tc0,26.5-21.5,48-48,48s-48-21.5-48-48h-48V144z M144,156v68H98.6L144,156z M416,368H256H96V240h98c7.1,27.6,32.2,48,62,48\r\n\ts54.9-20.4,62-48h98V368z"},"children":[]}]};exports.iosFilingOutline=iosFilingOutline;var iosFiling={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,288c-29.8,0-54.9-20.4-62-48H80v144h176h176V240H318C310.9,267.6,285.8,288,256,288z"},"children":[{"name":"path","attribs":{"d":"M256,288c-29.8,0-54.9-20.4-62-48H80v144h176h176V240H318C310.9,267.6,285.8,288,256,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M144,224h16h9h39c0,26.5,21.5,48,48,48s48-21.5,48-48h40h8h16h8h56l-63.5-96H368v80h-16v-80H160v80h-16v-80h-0.5L80,224h57\r\n\t\tH144z"},"children":[{"name":"path","attribs":{"d":"M144,224h16h9h39c0,26.5,21.5,48,48,48s48-21.5,48-48h40h8h16h8h56l-63.5-96H368v80h-16v-80H160v80h-16v-80h-0.5L80,224h57\r\n\t\tH144z"},"children":[]}]}]}]};exports.iosFiling=iosFiling;var iosFilmOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M56,88v336h400V88H56z M128,408H72v-48h56V408z M128,344H72v-48h56V344z M128,280H72v-48h56V280z M128,216H72v-48h56V216z\r\n\t M128,152H72v-48h56V152z M368,408H144V264h224V408z M368,248H144V104h224V248z M440,408h-56v-48h56V408z M440,344h-56v-48h56V344z\r\n\t M440,280h-56v-48h56V280z M440,216h-56v-48h56V216z M440,152h-56v-48h56V152z"},"children":[]}]};exports.iosFilmOutline=iosFilmOutline;var iosFilm={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M56,88v336h400V88H56z M128,408H72v-48h56V408z M128,344H72v-48h56V344z M128,280H72v-48h56V280z M128,216H72v-48h56V216z\r\n\t\t M128,152H72v-48h56V152z M368,264H144v-16h224V264z M440,408h-56v-48h56V408z M440,344h-56v-48h56V344z M440,280h-56v-48h56V280z\r\n\t\t M440,216h-56v-48h56V216z M440,152h-56v-48h56V152z"},"children":[{"name":"path","attribs":{"d":"M56,88v336h400V88H56z M128,408H72v-48h56V408z M128,344H72v-48h56V344z M128,280H72v-48h56V280z M128,216H72v-48h56V216z\r\n\t\t M128,152H72v-48h56V152z M368,264H144v-16h224V264z M440,408h-56v-48h56V408z M440,344h-56v-48h56V344z M440,280h-56v-48h56V280z\r\n\t\t M440,216h-56v-48h56V216z M440,152h-56v-48h56V152z"},"children":[]}]}]}]};exports.iosFilm=iosFilm;var iosFlagOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2\r\n\t\tl-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6\r\n\t\tc14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z M368,269c-11,1.4-23.9,3.5-38.7,3.5\r\n\t\tc-23.1,0-45-4.7-66.2-9.2c-21.5-4.6-43.6-13.3-67.1-13.3c-25.7,0-41.9,3-51.9,6V118.7c6-2.5,21.9-6.8,51.9-6.8\r\n\t\tc21.8,0,42.2,4.3,63.9,9c22,4.7,43.8,10.6,68.5,10.6c14.7,0,28.7-2,39.7-3.3L368,269L368,269z"},"children":[{"name":"path","attribs":{"d":"M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2\r\n\t\tl-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6\r\n\t\tc14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z M368,269c-11,1.4-23.9,3.5-38.7,3.5\r\n\t\tc-23.1,0-45-4.7-66.2-9.2c-21.5-4.6-43.6-13.3-67.1-13.3c-25.7,0-41.9,3-51.9,6V118.7c6-2.5,21.9-6.8,51.9-6.8\r\n\t\tc21.8,0,42.2,4.3,63.9,9c22,4.7,43.8,10.6,68.5,10.6c14.7,0,28.7-2,39.7-3.3L368,269L368,269z"},"children":[]}]}]}]};exports.iosFlagOutline=iosFlagOutline;var iosFlag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2\r\n\t\tl-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6\r\n\t\tc14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"},"children":[{"name":"path","attribs":{"d":"M368,112c-11,1.4-24.9,3.5-39.7,3.5c-23.1,0-44-5.7-65.2-10.2c-21.5-4.6-43.7-9.3-67.2-9.3c-46.9,0-62.8,10.1-64.4,11.2\r\n\t\tl-3.4,2.4v2.6v161.7V416h16V272.7c6-2.5,21.8-6.9,51.9-6.9c21.8,0,42.2,8.3,63.9,13c22,4.7,44.8,9.6,69.5,9.6\r\n\t\tc14.7,0,27.7-2,38.7-3.3c6-0.7,11.3-1.4,16-2.2V126v-16.5C379.4,110.4,374,111.2,368,112z"},"children":[]}]}]}]};exports.iosFlag=iosFlag;var iosFlameOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M223.899,32c25.691,145-96.732,142-95.895,288c0.686,119.51,104.975,160,128.143,160c23.166,0,113.88-26,126.931-160\r\n\tC393.711,210.816,310.572,96,223.899,32z M256.147,472c0,0-40.701-35.816-40.701-80c0-44.183,40.555-80,40.555-80\r\n\ts40.332,35.817,40.332,80C296.332,436.184,256.147,472,256.147,472z M367.153,318.449c-2.823,28.988-9.704,54.523-20.45,75.894\r\n\tc-8.749,17.397-20.084,32.114-33.692,43.743c-6.522,5.575-13.255,10.115-19.771,13.749c10.039-15.938,19.093-36.72,19.093-59.835\r\n\tc0-50.788-43.842-90.307-45.708-91.963l-10.594-9.41l-10.621,9.381c-1.877,1.657-45.963,41.178-45.963,91.992\r\n\tc0,21.842,8.168,41.594,17.636,57.152c-7.381-4.326-15.215-9.748-22.986-16.451c-14.688-12.67-26.365-27.608-34.708-44.402\r\n\tc-10.063-20.255-15.239-43.265-15.383-68.391c-0.367-63.986,24.09-95.746,49.983-129.369c24.568-31.903,49.829-64.7,49.458-122.113\r\n\tc32.513,28.827,61.257,63.03,82.822,98.877C357.576,219.35,371.715,271.615,367.153,318.449z"},"children":[]}]};exports.iosFlameOutline=iosFlameOutline;var iosFlame={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M223.899,32c25.691,145-96.732,142-95.895,288c0.686,119.51,104.975,160,128.143,160c23.166,0,113.88-26,126.931-160\r\n\t\tC393.711,210.816,310.572,96,223.899,32z M256.147,472c0,0-40.701-35.816-40.701-80c0-44.183,40.555-80,40.555-80\r\n\t\ts40.332,35.817,40.332,80C296.332,436.184,256.147,472,256.147,472z"},"children":[{"name":"path","attribs":{"d":"M223.899,32c25.691,145-96.732,142-95.895,288c0.686,119.51,104.975,160,128.143,160c23.166,0,113.88-26,126.931-160\r\n\t\tC393.711,210.816,310.572,96,223.899,32z M256.147,472c0,0-40.701-35.816-40.701-80c0-44.183,40.555-80,40.555-80\r\n\t\ts40.332,35.817,40.332,80C296.332,436.184,256.147,472,256.147,472z"},"children":[]}]}]}]};exports.iosFlame=iosFlame;var iosFlaskOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M436.912,370.441L320,175V48h16V32h-16.009H304v16v131.418l2.514,3.791l116.575,194.834\r\n\t\tc6.75,12.818,9.314,25.95,9.001,37.957c-0.243,9.339-1.958,17.938-6.545,25.569C417.076,455.666,402.33,464,384.981,464H129.093\r\n\t\tc-17.504,0-32.461-8.435-41.035-22.705c-11.897-19.801-10.889-38.145,2.275-63.139L181.821,224H240v-16h-48.683l14.687-24.756\r\n\t\tL208,179.4V176h48v-16h-48v-32h32v-16h-32V80h48V64h-48V48V32h-15.989H176v16h16v127L76.126,370.441\r\n\t\tC67.714,386.268,63.615,401.814,64.027,416c1.061,36.511,28.702,64,65.065,64h255.889c36.291,0,62.131-27.598,62.992-64\r\n\t\tC448.311,401.756,445.367,386.349,436.912,370.441z"},"children":[{"name":"path","attribs":{"d":"M436.912,370.441L320,175V48h16V32h-16.009H304v16v131.418l2.514,3.791l116.575,194.834\r\n\t\tc6.75,12.818,9.314,25.95,9.001,37.957c-0.243,9.339-1.958,17.938-6.545,25.569C417.076,455.666,402.33,464,384.981,464H129.093\r\n\t\tc-17.504,0-32.461-8.435-41.035-22.705c-11.897-19.801-10.889-38.145,2.275-63.139L181.821,224H240v-16h-48.683l14.687-24.756\r\n\t\tL208,179.4V176h48v-16h-48v-32h32v-16h-32V80h48V64h-48V48V32h-15.989H176v16h16v127L76.126,370.441\r\n\t\tC67.714,386.268,63.615,401.814,64.027,416c1.061,36.511,28.702,64,65.065,64h255.889c36.291,0,62.131-27.598,62.992-64\r\n\t\tC448.311,401.756,445.367,386.349,436.912,370.441z"},"children":[]}]},{"name":"path","attribs":{"d":"M108.292,374.616c-6.907,10.542-10.936,24.095-10.936,33.55c0,27.584,15.82,39.834,45.682,39.834h225.932\r\n\t\tc29.804,0,44.975-15.711,45.681-39.959c0.277-9.488-3.143-22.729-10.086-33.324L332.729,256H179.5L108.292,374.616z M323.705,272\r\n\t\tl67.168,110.87l0.151,0.124l0.159,0.182c5.382,8.212,7.647,18.275,7.476,24.18c-0.229,7.839-2.477,13.98-6.683,17.795\r\n\t\tc-4.774,4.328-12.729,6.85-23.008,6.85H143.037c-11.064,0-19.27-2.236-23.73-5.996c-1.472-1.24-5.954-5.143-5.954-18.088\r\n\t\tc0-5.943,2.857-16.383,8.319-24.717l0.177-0.302l0.166-0.042L188.564,272H323.705z"},"children":[{"name":"path","attribs":{"d":"M108.292,374.616c-6.907,10.542-10.936,24.095-10.936,33.55c0,27.584,15.82,39.834,45.682,39.834h225.932\r\n\t\tc29.804,0,44.975-15.711,45.681-39.959c0.277-9.488-3.143-22.729-10.086-33.324L332.729,256H179.5L108.292,374.616z M323.705,272\r\n\t\tl67.168,110.87l0.151,0.124l0.159,0.182c5.382,8.212,7.647,18.275,7.476,24.18c-0.229,7.839-2.477,13.98-6.683,17.795\r\n\t\tc-4.774,4.328-12.729,6.85-23.008,6.85H143.037c-11.064,0-19.27-2.236-23.73-5.996c-1.472-1.24-5.954-5.143-5.954-18.088\r\n\t\tc0-5.943,2.857-16.383,8.319-24.717l0.177-0.302l0.166-0.042L188.564,272H323.705z"},"children":[]}]}]}]};exports.iosFlaskOutline=iosFlaskOutline;var iosFlask={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M391.016,382.994l-0.15-0.124L323.7,272H188.554l-66.549,110.855l-0.166,0.042l-0.177,0.302\r\n\t\tc-5.461,8.334-8.319,18.773-8.319,24.717c0,12.945,4.481,16.848,5.954,18.088c4.46,3.76,12.667,5.996,23.731,5.996H368.96\r\n\t\tc10.278,0,18.232-2.521,23.007-6.85c4.205-3.814,6.454-9.956,6.683-17.795c0.172-5.904-2.093-15.968-7.476-24.18L391.016,382.994z"},"children":[{"name":"path","attribs":{"d":"M391.016,382.994l-0.15-0.124L323.7,272H188.554l-66.549,110.855l-0.166,0.042l-0.177,0.302\r\n\t\tc-5.461,8.334-8.319,18.773-8.319,24.717c0,12.945,4.481,16.848,5.954,18.088c4.46,3.76,12.667,5.996,23.731,5.996H368.96\r\n\t\tc10.278,0,18.232-2.521,23.007-6.85c4.205-3.814,6.454-9.956,6.683-17.795c0.172-5.904-2.093-15.968-7.476-24.18L391.016,382.994z"},"children":[]}]},{"name":"path","attribs":{"d":"M436.912,370.441L320,175V48h16V32H176v16h16v127L76.125,370.441C67.715,386.268,63.616,401.814,64.028,416\r\n\t\tc1.061,36.511,28.701,64,65.065,64h255.888c36.292,0,62.132-27.598,62.993-64C448.312,401.756,445.367,386.349,436.912,370.441z\r\n\t\t M208,64h48v16h-48V64z M208,112h32v16h-32V112z M208,160h48v16h-48V160z M191.261,208H240v16h-58.179L191.261,208z\r\n\t\t M414.64,408.041C413.934,432.289,398.763,448,368.96,448H143.027c-29.862,0-45.682-12.25-45.682-39.834\r\n\t\tc0-9.455,4.029-23.008,10.937-33.55L179.49,256h153.228l71.836,118.717C411.497,385.312,414.916,398.553,414.64,408.041z"},"children":[{"name":"path","attribs":{"d":"M436.912,370.441L320,175V48h16V32H176v16h16v127L76.125,370.441C67.715,386.268,63.616,401.814,64.028,416\r\n\t\tc1.061,36.511,28.701,64,65.065,64h255.888c36.292,0,62.132-27.598,62.993-64C448.312,401.756,445.367,386.349,436.912,370.441z\r\n\t\t M208,64h48v16h-48V64z M208,112h32v16h-32V112z M208,160h48v16h-48V160z M191.261,208H240v16h-58.179L191.261,208z\r\n\t\t M414.64,408.041C413.934,432.289,398.763,448,368.96,448H143.027c-29.862,0-45.682-12.25-45.682-39.834\r\n\t\tc0-9.455,4.029-23.008,10.937-33.55L179.49,256h153.228l71.836,118.717C411.497,385.312,414.916,398.553,414.64,408.041z"},"children":[]}]}]}]};exports.iosFlask=iosFlask;var iosFlowerOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M395.057,284.252c55.929,0,84.943-11.62,84.943-28.002s-29.016-28.003-84.943-28.003c-28.732,0-64.708,7.391-92.902,14.578\r\n\t\tc-0.975-3.419-2.305-6.688-3.973-9.75c25.009-14.852,55.645-35.05,75.947-55.353c39.547-39.547,52.023-68.458,40.44-80.042\r\n\t\tc-2.747-2.748-6.472-4.142-11.079-4.142c-14.818,0-38.796,14.415-68.963,44.582c-20.282,20.282-40.459,50.873-55.307,75.869\r\n\t\tc-3.062-1.696-6.33-3.062-9.755-4.062c7.175-28.17,14.535-64.059,14.535-92.735C284.002,61.266,272.382,32,256,32\r\n\t\ts-28.002,29.266-28.002,85.194c0,28.676,7.362,64.565,14.536,92.735c-3.425,1-6.693,2.365-9.755,4.062\r\n\t\tc-14.847-24.996-35.023-55.587-55.305-75.869C147.309,107.957,123.33,93.54,108.51,93.54c-4.609,0-8.331,1.394-11.079,4.142\r\n\t\tc-11.584,11.583,0.894,40.494,40.44,80.041c20.303,20.303,50.938,40.501,75.947,55.353c-1.668,3.062-2.999,6.331-3.974,9.75\r\n\t\tc-28.194-7.188-64.169-14.578-92.901-14.578C61.016,228.247,32,239.618,32,256s29.016,28.252,84.944,28.252\r\n\t\tc28.777,0,64.82-7.413,93.034-14.611c1.003,3.392,2.368,6.625,4.055,9.656c-25.048,14.863-55.801,35.119-76.161,55.479\r\n\t\tc-39.547,39.548-52.023,68.459-40.44,80.043c2.748,2.748,6.471,4.142,11.078,4.142c14.819,0,38.796-14.415,68.963-44.583\r\n\t\tc20.382-20.381,40.659-51.177,55.526-76.238c3.032,1.657,6.267,2.988,9.651,3.967c-7.211,28.238-14.654,64.367-14.654,93.201\r\n\t\tC227.998,451.234,239.618,480,256,480s28.002-28.766,28.002-84.693c0-28.834-7.441-64.963-14.652-93.201\r\n\t\tc3.385-0.979,6.618-2.31,9.65-3.967c14.867,25.062,35.145,55.857,55.527,76.239c30.164,30.165,54.144,44.582,68.963,44.582\r\n\t\tc4.608,0,8.33-1.394,11.078-4.142c11.584-11.584-0.894-40.495-40.439-80.043c-20.361-20.359-51.114-40.615-76.162-55.479\r\n\t\tc1.688-3.031,3.053-6.266,4.055-9.656C330.237,276.839,366.28,284.252,395.057,284.252z M319.992,254.941\r\n\t\tc30.144-7.014,55.893-10.694,75.064-10.694c21.329,0,39.453,1.806,52.41,5.222c9.705,2.559,14.005,5.317,15.736,6.781\r\n\t\tc-1.731,1.463-6.031,4.221-15.736,6.779c-12.958,3.416-31.081,5.223-52.41,5.223c-19.176,0-44.927-3.68-75.075-10.695\r\n\t\tL319.992,254.941z M345.841,149.436c35.382-35.383,52.682-39.412,56.818-39.846c-0.211,2.305-1.343,7.326-6.404,15.991\r\n\t\tc-6.786,11.62-18.35,25.738-33.439,40.828c-13.533,13.534-34.3,29.111-60.513,45.438c-0.619-0.648-1.25-1.283-1.895-1.904\r\n\t\tC316.732,183.729,332.309,162.968,345.841,149.436z M209.698,211.846c-26.213-16.326-46.979-31.904-60.512-45.437\r\n\t\tc-15.09-15.091-26.653-29.208-33.439-40.828c-5.061-8.665-6.194-13.687-6.404-15.992c4.138,0.435,21.436,4.463,56.818,39.845\r\n\t\tc13.533,13.533,29.108,34.295,45.433,60.507C210.948,210.563,210.316,211.198,209.698,211.846z M116.944,268.252\r\n\t\tc-21.339,0-39.483-1.845-52.471-5.335c-9.689-2.604-13.961-5.394-15.675-6.87c1.75-1.451,6.077-4.177,15.796-6.689\r\n\t\tc12.927-3.343,31.029-5.11,52.351-5.11c19.172,0,44.922,3.68,75.064,10.694l0.01,2.615\r\n\t\tC161.87,264.572,136.12,268.252,116.944,268.252z M166.16,363.064c-35.383,35.382-52.68,39.41-56.818,39.846\r\n\t\tc0.21-2.305,1.343-7.326,6.404-15.992c6.786-11.619,18.349-25.736,33.439-40.828c13.587-13.586,34.457-29.229,60.815-45.625\r\n\t\tc0.584,0.604,1.181,1.197,1.789,1.779C195.394,328.604,179.749,349.475,166.16,363.064z M302,300.465\r\n\t\tc26.356,16.395,47.227,32.037,60.814,45.625c15.091,15.092,26.653,29.209,33.439,40.828c5.062,8.666,6.193,13.688,6.403,15.992\r\n\t\tc-4.138-0.436-21.436-4.464-56.817-39.846c-13.589-13.59-29.234-34.463-45.63-60.82C300.818,301.663,301.415,301.068,302,300.465z\r\n\t\t M249.222,64.678c2.548-9.703,5.297-14.055,6.778-15.834c1.48,1.78,4.23,6.131,6.777,15.834\r\n\t\tc3.418,13.015,5.225,31.174,5.225,52.516c0,19.117-3.66,44.781-10.637,74.821h-2.73c-6.977-30.04-10.638-55.704-10.638-74.821\r\n\t\tC243.998,95.853,245.804,77.693,249.222,64.678z M262.782,447.612c-2.569,9.707-5.339,13.954-6.782,15.636\r\n\t\tc-1.444-1.682-4.212-5.929-6.782-15.636c-3.415-12.901-5.22-30.988-5.22-52.308c0-19.228,3.701-45.066,10.752-75.316h2.5\r\n\t\tc7.052,30.25,10.752,56.089,10.752,75.316C268.002,416.624,266.197,434.711,262.782,447.612z M256,288c-17.673,0-32-14.327-32-32\r\n\t\ts14.327-32,32-32s32,14.327,32,32S273.673,288,256,288z"},"children":[{"name":"path","attribs":{"d":"M395.057,284.252c55.929,0,84.943-11.62,84.943-28.002s-29.016-28.003-84.943-28.003c-28.732,0-64.708,7.391-92.902,14.578\r\n\t\tc-0.975-3.419-2.305-6.688-3.973-9.75c25.009-14.852,55.645-35.05,75.947-55.353c39.547-39.547,52.023-68.458,40.44-80.042\r\n\t\tc-2.747-2.748-6.472-4.142-11.079-4.142c-14.818,0-38.796,14.415-68.963,44.582c-20.282,20.282-40.459,50.873-55.307,75.869\r\n\t\tc-3.062-1.696-6.33-3.062-9.755-4.062c7.175-28.17,14.535-64.059,14.535-92.735C284.002,61.266,272.382,32,256,32\r\n\t\ts-28.002,29.266-28.002,85.194c0,28.676,7.362,64.565,14.536,92.735c-3.425,1-6.693,2.365-9.755,4.062\r\n\t\tc-14.847-24.996-35.023-55.587-55.305-75.869C147.309,107.957,123.33,93.54,108.51,93.54c-4.609,0-8.331,1.394-11.079,4.142\r\n\t\tc-11.584,11.583,0.894,40.494,40.44,80.041c20.303,20.303,50.938,40.501,75.947,55.353c-1.668,3.062-2.999,6.331-3.974,9.75\r\n\t\tc-28.194-7.188-64.169-14.578-92.901-14.578C61.016,228.247,32,239.618,32,256s29.016,28.252,84.944,28.252\r\n\t\tc28.777,0,64.82-7.413,93.034-14.611c1.003,3.392,2.368,6.625,4.055,9.656c-25.048,14.863-55.801,35.119-76.161,55.479\r\n\t\tc-39.547,39.548-52.023,68.459-40.44,80.043c2.748,2.748,6.471,4.142,11.078,4.142c14.819,0,38.796-14.415,68.963-44.583\r\n\t\tc20.382-20.381,40.659-51.177,55.526-76.238c3.032,1.657,6.267,2.988,9.651,3.967c-7.211,28.238-14.654,64.367-14.654,93.201\r\n\t\tC227.998,451.234,239.618,480,256,480s28.002-28.766,28.002-84.693c0-28.834-7.441-64.963-14.652-93.201\r\n\t\tc3.385-0.979,6.618-2.31,9.65-3.967c14.867,25.062,35.145,55.857,55.527,76.239c30.164,30.165,54.144,44.582,68.963,44.582\r\n\t\tc4.608,0,8.33-1.394,11.078-4.142c11.584-11.584-0.894-40.495-40.439-80.043c-20.361-20.359-51.114-40.615-76.162-55.479\r\n\t\tc1.688-3.031,3.053-6.266,4.055-9.656C330.237,276.839,366.28,284.252,395.057,284.252z M319.992,254.941\r\n\t\tc30.144-7.014,55.893-10.694,75.064-10.694c21.329,0,39.453,1.806,52.41,5.222c9.705,2.559,14.005,5.317,15.736,6.781\r\n\t\tc-1.731,1.463-6.031,4.221-15.736,6.779c-12.958,3.416-31.081,5.223-52.41,5.223c-19.176,0-44.927-3.68-75.075-10.695\r\n\t\tL319.992,254.941z M345.841,149.436c35.382-35.383,52.682-39.412,56.818-39.846c-0.211,2.305-1.343,7.326-6.404,15.991\r\n\t\tc-6.786,11.62-18.35,25.738-33.439,40.828c-13.533,13.534-34.3,29.111-60.513,45.438c-0.619-0.648-1.25-1.283-1.895-1.904\r\n\t\tC316.732,183.729,332.309,162.968,345.841,149.436z M209.698,211.846c-26.213-16.326-46.979-31.904-60.512-45.437\r\n\t\tc-15.09-15.091-26.653-29.208-33.439-40.828c-5.061-8.665-6.194-13.687-6.404-15.992c4.138,0.435,21.436,4.463,56.818,39.845\r\n\t\tc13.533,13.533,29.108,34.295,45.433,60.507C210.948,210.563,210.316,211.198,209.698,211.846z M116.944,268.252\r\n\t\tc-21.339,0-39.483-1.845-52.471-5.335c-9.689-2.604-13.961-5.394-15.675-6.87c1.75-1.451,6.077-4.177,15.796-6.689\r\n\t\tc12.927-3.343,31.029-5.11,52.351-5.11c19.172,0,44.922,3.68,75.064,10.694l0.01,2.615\r\n\t\tC161.87,264.572,136.12,268.252,116.944,268.252z M166.16,363.064c-35.383,35.382-52.68,39.41-56.818,39.846\r\n\t\tc0.21-2.305,1.343-7.326,6.404-15.992c6.786-11.619,18.349-25.736,33.439-40.828c13.587-13.586,34.457-29.229,60.815-45.625\r\n\t\tc0.584,0.604,1.181,1.197,1.789,1.779C195.394,328.604,179.749,349.475,166.16,363.064z M302,300.465\r\n\t\tc26.356,16.395,47.227,32.037,60.814,45.625c15.091,15.092,26.653,29.209,33.439,40.828c5.062,8.666,6.193,13.688,6.403,15.992\r\n\t\tc-4.138-0.436-21.436-4.464-56.817-39.846c-13.589-13.59-29.234-34.463-45.63-60.82C300.818,301.663,301.415,301.068,302,300.465z\r\n\t\t M249.222,64.678c2.548-9.703,5.297-14.055,6.778-15.834c1.48,1.78,4.23,6.131,6.777,15.834\r\n\t\tc3.418,13.015,5.225,31.174,5.225,52.516c0,19.117-3.66,44.781-10.637,74.821h-2.73c-6.977-30.04-10.638-55.704-10.638-74.821\r\n\t\tC243.998,95.853,245.804,77.693,249.222,64.678z M262.782,447.612c-2.569,9.707-5.339,13.954-6.782,15.636\r\n\t\tc-1.444-1.682-4.212-5.929-6.782-15.636c-3.415-12.901-5.22-30.988-5.22-52.308c0-19.228,3.701-45.066,10.752-75.316h2.5\r\n\t\tc7.052,30.25,10.752,56.089,10.752,75.316C268.002,416.624,266.197,434.711,262.782,447.612z M256,288c-17.673,0-32-14.327-32-32\r\n\t\ts14.327-32,32-32s32,14.327,32,32S273.673,288,256,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M344.86,405.678c-24.529-17.674-48.394-51.732-48.394-51.732s7.031,41.059,1.854,75.946\r\n\t\tc11.678,21.779,26.139,35.253,36.643,35.253c1.749,0,3.432-0.324,5.042-0.976C351.879,459.372,354.39,439.185,344.86,405.678z\r\n\t\t M333.738,448.566c-2.738-1.46-9.407-6.369-18.992-22.27c0.688-7.872,1.098-16.337,1.219-25.282\r\n\t\tc5.012,4.88,9.947,9.437,14.747,13.613C335.816,434.408,334.954,444.779,333.738,448.566z"},"children":[{"name":"path","attribs":{"d":"M344.86,405.678c-24.529-17.674-48.394-51.732-48.394-51.732s7.031,41.059,1.854,75.946\r\n\t\tc11.678,21.779,26.139,35.253,36.643,35.253c1.749,0,3.432-0.324,5.042-0.976C351.879,459.372,354.39,439.185,344.86,405.678z\r\n\t\t M333.738,448.566c-2.738-1.46-9.407-6.369-18.992-22.27c0.688-7.872,1.098-16.337,1.219-25.282\r\n\t\tc5.012,4.88,9.947,9.437,14.747,13.613C335.816,434.408,334.954,444.779,333.738,448.566z"},"children":[]}]},{"name":"path","attribs":{"d":"M213.679,82.608c-13.292-23.51-26.139-35.255-36.644-35.255c-1.749,0-3.431,0.325-5.042,0.976\r\n\t\tc-11.868,4.795-14.497,23.211-4.87,58.441c21.252,15.98,48.374,51.55,48.374,51.55S207.75,117.5,213.679,82.608z M196.038,111.369\r\n\t\tc-5.001-4.856-9.943-9.398-14.769-13.574c-5.084-19.731-4.223-30.082-3.008-33.863c2.737,1.459,9.407,6.369,18.994,22.27\r\n\t\tC196.568,94.04,196.161,102.466,196.038,111.369z"},"children":[{"name":"path","attribs":{"d":"M213.679,82.608c-13.292-23.51-26.139-35.255-36.644-35.255c-1.749,0-3.431,0.325-5.042,0.976\r\n\t\tc-11.868,4.795-14.497,23.211-4.87,58.441c21.252,15.98,48.374,51.55,48.374,51.55S207.75,117.5,213.679,82.608z M196.038,111.369\r\n\t\tc-5.001-4.856-9.943-9.398-14.769-13.574c-5.084-19.731-4.223-30.082-3.008-33.863c2.737,1.459,9.407,6.369,18.994,22.27\r\n\t\tC196.568,94.04,196.161,102.466,196.038,111.369z"},"children":[]}]},{"name":"path","attribs":{"d":"M82.357,298.568c-27.422,15.505-38.836,30.402-34.277,41.687c2.806,6.944,10.913,10.675,23.842,10.675\r\n\t\tc9.182,0,22.434-1.559,34.672-5.826c17.405-23.934,51.712-48.387,51.712-48.387S116.999,302.836,82.357,298.568z M97.637,330.956\r\n\t\tc-10.088,2.606-18.909,3.974-25.716,3.974c-4.092,0-6.733-0.502-8.223-0.97c1.477-2.755,6.407-9.411,22.253-18.966\r\n\t\tc7.872,0.689,16.338,1.099,25.284,1.22C106.365,321.218,101.815,326.15,97.637,330.956z"},"children":[{"name":"path","attribs":{"d":"M82.357,298.568c-27.422,15.505-38.836,30.402-34.277,41.687c2.806,6.944,10.913,10.675,23.842,10.675\r\n\t\tc9.182,0,22.434-1.559,34.672-5.826c17.405-23.934,51.712-48.387,51.712-48.387S116.999,302.836,82.357,298.568z M97.637,330.956\r\n\t\tc-10.088,2.606-18.909,3.974-25.716,3.974c-4.092,0-6.733-0.502-8.223-0.97c1.477-2.755,6.407-9.411,22.253-18.966\r\n\t\tc7.872,0.689,16.338,1.099,25.284,1.22C106.365,321.218,101.815,326.15,97.637,330.956z"},"children":[]}]},{"name":"path","attribs":{"d":"M463.92,172.245c-2.806-6.945-10.914-10.675-23.844-10.675c-9.178,0-21.4,1.715-34.654,5.822\r\n\t\tc-18.088,23.774-51.699,48.387-51.699,48.387s40.778-7.28,75.918-1.849C457.064,198.426,468.479,183.528,463.92,172.245z\r\n\t\t M426.047,197.504c-7.867-0.689-16.327-1.097-25.267-1.218c4.869-5.004,9.42-9.939,13.6-14.749\r\n\t\tc10.081-2.602,18.895-3.968,25.697-3.968c4.093,0,6.733,0.502,8.225,0.97C446.824,181.294,441.893,187.951,426.047,197.504z"},"children":[{"name":"path","attribs":{"d":"M463.92,172.245c-2.806-6.945-10.914-10.675-23.844-10.675c-9.178,0-21.4,1.715-34.654,5.822\r\n\t\tc-18.088,23.774-51.699,48.387-51.699,48.387s40.778-7.28,75.918-1.849C457.064,198.426,468.479,183.528,463.92,172.245z\r\n\t\t M426.047,197.504c-7.867-0.689-16.327-1.097-25.267-1.218c4.869-5.004,9.42-9.939,13.6-14.749\r\n\t\tc10.081-2.602,18.895-3.968,25.697-3.968c4.093,0,6.733,0.502,8.225,0.97C446.824,181.294,441.893,187.951,426.047,197.504z"},"children":[]}]},{"name":"path","attribs":{"d":"M163.135,408.98c-8.42,30.34-5.956,48.938,5.244,53.69c1.674,0.711,3.437,1.066,5.275,1.066\r\n\t\tc11.107,0,24.698-13.124,39.528-39.015c-4.184-32.22,2.351-70.779,2.351-70.779S193.999,385.336,163.135,408.98z M174.981,447.207\r\n\t\tc-0.904-2.966-2.147-11.15,2.312-29.159c6.048-5.079,12.323-10.782,18.743-17.032c0.095,6.979,0.366,13.687,0.81,20.039\r\n\t\tC186.466,438.66,178.52,445.39,174.981,447.207z"},"children":[{"name":"path","attribs":{"d":"M163.135,408.98c-8.42,30.34-5.956,48.938,5.244,53.69c1.674,0.711,3.437,1.066,5.275,1.066\r\n\t\tc11.107,0,24.698-13.124,39.528-39.015c-4.184-32.22,2.351-70.779,2.351-70.779S193.999,385.336,163.135,408.98z M174.981,447.207\r\n\t\tc-0.904-2.966-2.147-11.15,2.312-29.159c6.048-5.079,12.323-10.782,18.743-17.032c0.095,6.979,0.366,13.687,0.81,20.039\r\n\t\tC186.466,438.66,178.52,445.39,174.981,447.207z"},"children":[]}]},{"name":"path","attribs":{"d":"M343.622,49.826c-1.674-0.71-3.438-1.066-5.274-1.066c-11.105,0-26.207,14.287-39.527,39.013\r\n\t\tc4.514,22.894-2.393,71.053-2.393,71.053s23.239-34.326,52.342-54.956C357.167,72,354.865,54.599,343.622,49.826z M334.627,94.781\r\n\t\tc-6.029,5.051-12.277,10.72-18.66,16.931c-0.092-7.062-0.364-13.846-0.812-20.269c10.379-17.607,18.327-24.336,21.864-26.153\r\n\t\tC337.93,68.274,339.186,76.541,334.627,94.781z"},"children":[{"name":"path","attribs":{"d":"M343.622,49.826c-1.674-0.71-3.438-1.066-5.274-1.066c-11.105,0-26.207,14.287-39.527,39.013\r\n\t\tc4.514,22.894-2.393,71.053-2.393,71.053s23.239-34.326,52.342-54.956C357.167,72,354.865,54.599,343.622,49.826z M334.627,94.781\r\n\t\tc-6.029,5.051-12.277,10.72-18.66,16.931c-0.092-7.062-0.364-13.846-0.812-20.269c10.379-17.607,18.327-24.336,21.864-26.153\r\n\t\tC337.93,68.274,339.186,76.541,334.627,94.781z"},"children":[]}]},{"name":"path","attribs":{"d":"M103.209,163.367C93,159.5,80.717,158.366,72.457,158.366c-12.267,0-20.042,3.573-22.881,10.261\r\n\t\tc-5.004,11.792,9.97,29.985,37.948,44.805c29.726-3.932,70.688,2.336,70.688,2.336S121,187.067,103.209,163.367z M65.034,175.215\r\n\t\tc1.381-0.414,3.775-0.848,7.424-0.848c5.815,0,13.242,1.088,21.687,3.165c5.077,6.049,10.781,12.33,17.034,18.754\r\n\t\tc-6.959,0.096-13.648,0.367-19.984,0.81C73.563,186.7,66.84,178.745,65.034,175.215z"},"children":[{"name":"path","attribs":{"d":"M103.209,163.367C93,159.5,80.717,158.366,72.457,158.366c-12.267,0-20.042,3.573-22.881,10.261\r\n\t\tc-5.004,11.792,9.97,29.985,37.948,44.805c29.726-3.932,70.688,2.336,70.688,2.336S121,187.067,103.209,163.367z M65.034,175.215\r\n\t\tc1.381-0.414,3.775-0.848,7.424-0.848c5.815,0,13.242,1.088,21.687,3.165c5.077,6.049,10.781,12.33,17.034,18.754\r\n\t\tc-6.959,0.096-13.648,0.367-19.984,0.81C73.563,186.7,66.84,178.745,65.034,175.215z"},"children":[]}]},{"name":"path","attribs":{"d":"M424.477,299.066c-25.307,5.6-70.78-2.35-70.78-2.35s34.638,25.615,55.014,52.393c11.959,4.223,22.555,5.022,30.833,5.022\r\n\t\tc12.266,0,20.041-3.573,22.88-10.261C467.428,332.08,454.283,315.801,424.477,299.066z M439.542,338.132\r\n\t\tc-5.833,0-13.287-1.095-21.765-3.185c-5.078-6.053-10.774-12.326-17.013-18.734c6.98-0.095,13.688-0.365,20.041-0.811\r\n\t\tc17.631,10.396,24.354,18.352,26.158,21.882C445.585,337.697,443.19,338.132,439.542,338.132z"},"children":[{"name":"path","attribs":{"d":"M424.477,299.066c-25.307,5.6-70.78-2.35-70.78-2.35s34.638,25.615,55.014,52.393c11.959,4.223,22.555,5.022,30.833,5.022\r\n\t\tc12.266,0,20.041-3.573,22.88-10.261C467.428,332.08,454.283,315.801,424.477,299.066z M439.542,338.132\r\n\t\tc-5.833,0-13.287-1.095-21.765-3.185c-5.078-6.053-10.774-12.326-17.013-18.734c6.98-0.095,13.688-0.365,20.041-0.811\r\n\t\tc17.631,10.396,24.354,18.352,26.158,21.882C445.585,337.697,443.19,338.132,439.542,338.132z"},"children":[]}]}]}]};exports.iosFlowerOutline=iosFlowerOutline;var iosFlower={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M395.057,228.247c-28.651,0-64.502,7.35-92.66,14.518c-0.98-3.443-2.321-6.734-4.001-9.817\r\n\t\tc24.97-14.84,55.487-34.98,75.733-55.224c39.547-39.547,52.023-68.458,40.44-80.042c-11.584-11.583-40.495,0.893-80.042,40.44\r\n\t\tc-20.225,20.225-40.343,50.698-55.178,75.654c-3.082-1.708-6.373-3.083-9.822-4.089c7.156-28.133,14.475-63.897,14.475-92.492\r\n\t\tC284.002,61.266,272.382,32,256,32s-28.002,29.266-28.002,85.194c0,28.595,7.319,64.359,14.475,92.492\r\n\t\tc-3.449,1.006-6.74,2.381-9.822,4.089c-14.835-24.956-34.953-55.43-55.176-75.653c-39.548-39.547-68.458-52.024-80.042-40.44\r\n\t\tc-11.584,11.583,0.894,40.494,40.44,80.041c20.246,20.244,50.762,40.384,75.732,55.224c-1.68,3.083-3.021,6.374-4.001,9.817\r\n\t\tc-28.158-7.168-64.008-14.518-92.659-14.518C61.016,228.247,32,239.618,32,256s29.016,28.252,84.944,28.252\r\n\t\tc28.697,0,64.613-7.371,92.792-14.551c1.01,3.414,2.384,6.671,4.083,9.724c-25.009,14.852-55.645,35.049-75.946,55.351\r\n\t\tc-39.547,39.548-52.023,68.459-40.44,80.043c11.584,11.584,40.495-0.895,80.042-40.441c20.323-20.323,40.542-51.001,55.398-76.024\r\n\t\tc3.053,1.671,6.31,3.01,9.718,3.995c-7.192,28.203-14.592,64.207-14.592,92.959c0,55.929,11.62,84.693,28.002,84.693\r\n\t\ts28.002-28.766,28.002-84.693c0-28.752-7.4-64.756-14.592-92.959c3.408-0.985,6.665-2.324,9.718-3.995\r\n\t\tc14.855,25.023,35.073,55.701,55.399,76.025c39.547,39.547,68.457,52.024,80.041,40.44s-0.894-40.495-40.439-80.043\r\n\t\tc-20.304-20.302-50.938-40.499-75.947-55.351c1.699-3.053,3.073-6.31,4.083-9.724c28.18,7.18,64.096,14.551,92.792,14.551\r\n\t\tc55.929,0,84.943-11.62,84.943-28.002S450.984,228.247,395.057,228.247z"},"children":[{"name":"path","attribs":{"d":"M395.057,228.247c-28.651,0-64.502,7.35-92.66,14.518c-0.98-3.443-2.321-6.734-4.001-9.817\r\n\t\tc24.97-14.84,55.487-34.98,75.733-55.224c39.547-39.547,52.023-68.458,40.44-80.042c-11.584-11.583-40.495,0.893-80.042,40.44\r\n\t\tc-20.225,20.225-40.343,50.698-55.178,75.654c-3.082-1.708-6.373-3.083-9.822-4.089c7.156-28.133,14.475-63.897,14.475-92.492\r\n\t\tC284.002,61.266,272.382,32,256,32s-28.002,29.266-28.002,85.194c0,28.595,7.319,64.359,14.475,92.492\r\n\t\tc-3.449,1.006-6.74,2.381-9.822,4.089c-14.835-24.956-34.953-55.43-55.176-75.653c-39.548-39.547-68.458-52.024-80.042-40.44\r\n\t\tc-11.584,11.583,0.894,40.494,40.44,80.041c20.246,20.244,50.762,40.384,75.732,55.224c-1.68,3.083-3.021,6.374-4.001,9.817\r\n\t\tc-28.158-7.168-64.008-14.518-92.659-14.518C61.016,228.247,32,239.618,32,256s29.016,28.252,84.944,28.252\r\n\t\tc28.697,0,64.613-7.371,92.792-14.551c1.01,3.414,2.384,6.671,4.083,9.724c-25.009,14.852-55.645,35.049-75.946,55.351\r\n\t\tc-39.547,39.548-52.023,68.459-40.44,80.043c11.584,11.584,40.495-0.895,80.042-40.441c20.323-20.323,40.542-51.001,55.398-76.024\r\n\t\tc3.053,1.671,6.31,3.01,9.718,3.995c-7.192,28.203-14.592,64.207-14.592,92.959c0,55.929,11.62,84.693,28.002,84.693\r\n\t\ts28.002-28.766,28.002-84.693c0-28.752-7.4-64.756-14.592-92.959c3.408-0.985,6.665-2.324,9.718-3.995\r\n\t\tc14.855,25.023,35.073,55.701,55.399,76.025c39.547,39.547,68.457,52.024,80.041,40.44s-0.894-40.495-40.439-80.043\r\n\t\tc-20.304-20.302-50.938-40.499-75.947-55.351c1.699-3.053,3.073-6.31,4.083-9.724c28.18,7.18,64.096,14.551,92.792,14.551\r\n\t\tc55.929,0,84.943-11.62,84.943-28.002S450.984,228.247,395.057,228.247z"},"children":[]}]},{"name":"path","attribs":{"d":"M296.467,353.945c0,0,7.031,41.059,1.854,75.946c11.678,21.779,26.139,35.253,36.643,35.253\r\n\t\tc1.749,0,3.432-0.324,5.042-0.976c11.874-4.797,14.385-24.984,4.855-58.491C320.331,388.004,296.467,353.945,296.467,353.945z"},"children":[{"name":"path","attribs":{"d":"M296.467,353.945c0,0,7.031,41.059,1.854,75.946c11.678,21.779,26.139,35.253,36.643,35.253\r\n\t\tc1.749,0,3.432-0.324,5.042-0.976c11.874-4.797,14.385-24.984,4.855-58.491C320.331,388.004,296.467,353.945,296.467,353.945z"},"children":[]}]},{"name":"path","attribs":{"d":"M215.497,158.32c0,0-7.747-40.82-1.818-75.712c-13.292-23.51-26.139-35.255-36.644-35.255\r\n\t\tc-1.749,0-3.431,0.325-5.042,0.976c-11.868,4.795-14.497,23.211-4.87,58.441C188.375,122.75,215.497,158.32,215.497,158.32z"},"children":[{"name":"path","attribs":{"d":"M215.497,158.32c0,0-7.747-40.82-1.818-75.712c-13.292-23.51-26.139-35.255-36.644-35.255\r\n\t\tc-1.749,0-3.431,0.325-5.042,0.976c-11.868,4.795-14.497,23.211-4.87,58.441C188.375,122.75,215.497,158.32,215.497,158.32z"},"children":[]}]},{"name":"path","attribs":{"d":"M158.306,296.717c0,0-41.308,6.119-75.949,1.852c-27.422,15.505-38.836,30.402-34.277,41.687\r\n\t\tc2.806,6.944,10.913,10.675,23.842,10.675c9.182,0,22.434-1.559,34.672-5.826C123.999,321.17,158.306,296.717,158.306,296.717z"},"children":[{"name":"path","attribs":{"d":"M158.306,296.717c0,0-41.308,6.119-75.949,1.852c-27.422,15.505-38.836,30.402-34.277,41.687\r\n\t\tc2.806,6.944,10.913,10.675,23.842,10.675c9.182,0,22.434-1.559,34.672-5.826C123.999,321.17,158.306,296.717,158.306,296.717z"},"children":[]}]},{"name":"path","attribs":{"d":"M353.723,215.779c0,0,40.778-7.28,75.918-1.849c27.424-15.504,38.838-30.402,34.279-41.685\r\n\t\tc-2.806-6.945-10.914-10.675-23.844-10.675c-9.178,0-21.4,1.715-34.654,5.822C387.334,191.166,353.723,215.779,353.723,215.779z"},"children":[{"name":"path","attribs":{"d":"M353.723,215.779c0,0,40.778-7.28,75.918-1.849c27.424-15.504,38.838-30.402,34.279-41.685\r\n\t\tc-2.806-6.945-10.914-10.675-23.844-10.675c-9.178,0-21.4,1.715-34.654,5.822C387.334,191.166,353.723,215.779,353.723,215.779z"},"children":[]}]},{"name":"path","attribs":{"d":"M163.135,408.98c-8.42,30.34-5.956,48.938,5.244,53.69c1.674,0.711,3.437,1.066,5.275,1.066\r\n\t\tc11.107,0,24.698-13.124,39.528-39.015c-4.184-32.22,2.351-70.779,2.351-70.779S193.999,385.336,163.135,408.98z"},"children":[{"name":"path","attribs":{"d":"M163.135,408.98c-8.42,30.34-5.956,48.938,5.244,53.69c1.674,0.711,3.437,1.066,5.275,1.066\r\n\t\tc11.107,0,24.698-13.124,39.528-39.015c-4.184-32.22,2.351-70.779,2.351-70.779S193.999,385.336,163.135,408.98z"},"children":[]}]},{"name":"path","attribs":{"d":"M348.77,103.87c8.397-31.87,6.096-49.271-5.147-54.044c-1.674-0.71-3.438-1.066-5.274-1.066\r\n\t\tc-11.105,0-26.207,14.287-39.527,39.013c4.514,22.894-2.393,71.053-2.393,71.053S319.667,124.5,348.77,103.87z"},"children":[{"name":"path","attribs":{"d":"M348.77,103.87c8.397-31.87,6.096-49.271-5.147-54.044c-1.674-0.71-3.438-1.066-5.274-1.066\r\n\t\tc-11.105,0-26.207,14.287-39.527,39.013c4.514,22.894-2.393,71.053-2.393,71.053S319.667,124.5,348.77,103.87z"},"children":[]}]},{"name":"path","attribs":{"d":"M87.524,213.432c29.726-3.932,70.688,2.336,70.688,2.336S121,187.067,103.209,163.367\r\n\t\tC93,159.5,80.717,158.366,72.457,158.366c-12.267,0-20.042,3.573-22.881,10.261C44.572,180.419,59.546,198.612,87.524,213.432z"},"children":[{"name":"path","attribs":{"d":"M87.524,213.432c29.726-3.932,70.688,2.336,70.688,2.336S121,187.067,103.209,163.367\r\n\t\tC93,159.5,80.717,158.366,72.457,158.366c-12.267,0-20.042,3.573-22.881,10.261C44.572,180.419,59.546,198.612,87.524,213.432z"},"children":[]}]},{"name":"path","attribs":{"d":"M424.477,299.066c-25.307,5.6-70.78-2.35-70.78-2.35s34.638,25.615,55.014,52.393c11.959,4.223,22.555,5.022,30.833,5.022\r\n\t\tc12.266,0,20.041-3.573,22.88-10.261C467.428,332.08,454.283,315.801,424.477,299.066z"},"children":[{"name":"path","attribs":{"d":"M424.477,299.066c-25.307,5.6-70.78-2.35-70.78-2.35s34.638,25.615,55.014,52.393c11.959,4.223,22.555,5.022,30.833,5.022\r\n\t\tc12.266,0,20.041-3.573,22.88-10.261C467.428,332.08,454.283,315.801,424.477,299.066z"},"children":[]}]}]}]};exports.iosFlower=iosFlower;var iosFolderOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M457,96H215c-2.791,0-4.271-0.585-6.094-2.408l-22.501-22.501l-0.168-0.162C181.365,66.333,177.361,64,169,64H57\r\n\tc-13.785,0-25,10.317-25,23v336c0,13.317,11.683,25,25,25h400c12.683,0,23-11.215,23-25V119C480,105.673,470.327,96,457,96z M57,80\r\n\th112c3.497,0,3.737,0.189,6.175,2.488l22.417,22.418c4.84,4.84,10.372,7.094,17.408,7.094h242c4.448,0,7,2.552,7,7v42.376\r\n\tc-2.504-0.888-5.195-1.376-8-1.376H56c-2.805,0-5.496,0.488-8,1.376V87C48,82.677,52.672,80,57,80z M464,423c0,4.328-2.677,9-7,9H57\r\n\tc-4.458,0-9-4.542-9-9V184c0-4.411,3.589-8,8-8h400c4.411,0,8,3.589,8,8V423z"},"children":[]}]};exports.iosFolderOutline=iosFolderOutline;var iosFolder={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M472,176H40c-4.411,0-8,3.589-8,8v239c0,13.317,11.683,25,25,25h400c12.683,0,23-11.215,23-25V184\r\n\t\tC480,179.589,476.411,176,472,176z"},"children":[{"name":"path","attribs":{"d":"M472,176H40c-4.411,0-8,3.589-8,8v239c0,13.317,11.683,25,25,25h400c12.683,0,23-11.215,23-25V184\r\n\t\tC480,179.589,476.411,176,472,176z"},"children":[]}]},{"name":"path","attribs":{"d":"M457,96H215c-2.791,0-4.271-0.585-6.094-2.408l-22.501-22.501l-0.168-0.162C181.365,66.333,177.361,64,169,64H57\r\n\t\tc-13.785,0-25,10.317-25,23v74.376c2.504-0.888,5.195-1.376,8-1.376h432c2.805,0,5.496,0.488,8,1.376V119\r\n\t\tC480,105.673,470.327,96,457,96z"},"children":[{"name":"path","attribs":{"d":"M457,96H215c-2.791,0-4.271-0.585-6.094-2.408l-22.501-22.501l-0.168-0.162C181.365,66.333,177.361,64,169,64H57\r\n\t\tc-13.785,0-25,10.317-25,23v74.376c2.504-0.888,5.195-1.376,8-1.376h432c2.805,0,5.496,0.488,8,1.376V119\r\n\t\tC480,105.673,470.327,96,457,96z"},"children":[]}]}]}]};exports.iosFolder=iosFolder;var iosFootballOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.137,48,48,141.136,48,256c0,114.864,93.137,208,208,208c114.872,0,208-93.138,208-208\r\n\tC464,141.138,370.87,48,256,48z M297.151,442.179c-13.514,2.657-30.327,4.187-44,4.45c-13.198-0.195-26.074-1.735-38.5-4.493\r\n\tc-2.144-0.549-4.383-1.138-6.805-1.777l-24.417-65.435L203.074,336h105.854l0.57,1.076l19.34,38.852L305.22,440.21\r\n\tC302.553,440.924,299.862,441.579,297.151,442.179z M89.317,163.522l18.188,52.284l0.175,0.504L65.376,252.92\r\n\tC65.892,220.535,74.52,190.088,89.317,163.522z M189.578,77.28L247,116.576v58.147l-70.997,60.067L126.6,212.28l-4.167-1.899\r\n\tl-22.332-64.019C122.11,115.158,153.239,90.83,189.578,77.28z M325.025,247.206l0.921,0.765L307.569,320H204.431l-18.485-72.453\r\n\tl0.445-0.376l68.873-58.27L325.025,247.206z M446.626,252.921l-42.454-36.738l0.127-0.364l18.298-52.451\r\n\tC437.447,189.972,446.109,220.473,446.626,252.921z M411.564,146.067l-22.432,64.483l-53.992,24.388L264,174.723v-58.147\r\n\tl57.596-39.415C357.958,90.644,389.501,114.913,411.564,146.067z M66.144,273.414l53.756-46.518l49.539,22.599l0.559,0.255\r\n\tl19.718,77.287l-20.433,38.529l-69.86-0.915C81.075,338.291,69.209,307.105,66.144,273.414z M342.719,365.565l-20.434-38.529\r\n\tl19.752-77.416l49.997-22.781l53.822,46.575c-3.065,33.691-14.932,64.877-33.277,91.236L342.719,365.565z M255.257,102.67\r\n\tl-46.126-31.498c15-3.806,30.701-5.836,46.869-5.835c15.961,0,31.466,1.982,46.293,5.694L255.257,102.67z M166.423,381.529\r\n\tl0.848,2.511l19.946,49.781c-29.239-11.351-55.011-29.704-75.232-53.006L166.423,381.529z M324.563,433.904l17.934-48.608\r\n\tl1.627-3.748l55.892-0.732C379.744,404.175,353.893,422.562,324.563,433.904z"},"children":[]}]};exports.iosFootballOutline=iosFootballOutline;var iosFootball={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.137,48,48,141.136,48,256c0,114.864,93.137,208,208,208c114.872,0,208-93.138,208-208\r\n\tC464,141.138,370.87,48,256,48z M297.151,442.179c-13.514,2.657-30.327,4.187-44,4.45c-13.198-0.195-26.074-1.735-38.5-4.493\r\n\tc-2.144-0.549-4.383-1.138-6.805-1.777l-24.417-65.435L203.074,336h105.854l0.57,1.076l19.34,38.852L305.22,440.21\r\n\tC302.553,440.924,299.862,441.579,297.151,442.179z M189.578,77.28L247,116.576v58.147l-70.997,60.067L126.6,212.28l-4.167-1.899\r\n\tl-22.332-64.019C122.11,115.158,153.239,90.83,189.578,77.28z M411.564,146.067l-22.432,64.483l-53.992,24.388L264,174.723v-58.147\r\n\tl57.596-39.415C357.958,90.644,389.501,114.913,411.564,146.067z M66.144,273.414l53.756-46.518l49.539,22.599l0.559,0.255\r\n\tl19.718,77.287l-20.433,38.529l-69.86-0.915C81.075,338.291,69.209,307.105,66.144,273.414z M342.719,365.565l-20.434-38.529\r\n\tl19.752-77.416l49.997-22.781l53.822,46.575c-3.065,33.691-14.932,64.877-33.277,91.236L342.719,365.565z"},"children":[]}]};exports.iosFootball=iosFootball;var iosGameControllerAOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M194.822,240H160v-34.762c0-2.817-2.604-5.238-5.303-5.238h-22.145c-2.698,0-4.552,2.372-4.552,5.178V240H92.533\r\n\t\t\tc-2.615,0-4.533,2.143-4.533,4.771v21.427c0,2.698,2.031,5.803,4.861,5.803H128v35.467c0,2.615,2.143,4.533,4.771,4.533h21.427\r\n\t\t\tc2.698,0,5.803-2.031,5.803-4.861V272h34.762c2.817,0,5.238-2.604,5.238-5.303v-22.145C200,241.854,197.628,240,194.822,240z"},"children":[{"name":"path","attribs":{"d":"M194.822,240H160v-34.762c0-2.817-2.604-5.238-5.303-5.238h-22.145c-2.698,0-4.552,2.372-4.552,5.178V240H92.533\r\n\t\t\tc-2.615,0-4.533,2.143-4.533,4.771v21.427c0,2.698,2.031,5.803,4.861,5.803H128v35.467c0,2.615,2.143,4.533,4.771,4.533h21.427\r\n\t\t\tc2.698,0,5.803-2.031,5.803-4.861V272h34.762c2.817,0,5.238-2.604,5.238-5.303v-22.145C200,241.854,197.628,240,194.822,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M362.314,279.063c-10.736,0-19.451,8.515-19.451,19.153c0,10.555,8.715,19.084,19.451,19.084\r\n\t\t\tc10.783,0,19.498-8.529,19.498-19.084C381.812,287.578,373.098,279.063,362.314,279.063z"},"children":[{"name":"path","attribs":{"d":"M362.314,279.063c-10.736,0-19.451,8.515-19.451,19.153c0,10.555,8.715,19.084,19.451,19.084\r\n\t\t\tc10.783,0,19.498-8.529,19.498-19.084C381.812,287.578,373.098,279.063,362.314,279.063z"},"children":[]}]},{"name":"path","attribs":{"d":"M319.766,237.165c-10.736,0-19.451,8.603-19.451,19.168c0,10.566,8.715,19.153,19.451,19.153\r\n\t\t\tc10.783,0,19.498-8.587,19.498-19.153C339.264,245.768,330.549,237.165,319.766,237.165z"},"children":[{"name":"path","attribs":{"d":"M319.766,237.165c-10.736,0-19.451,8.603-19.451,19.168c0,10.566,8.715,19.153,19.451,19.153\r\n\t\t\tc10.783,0,19.498-8.587,19.498-19.153C339.264,245.768,330.549,237.165,319.766,237.165z"},"children":[]}]},{"name":"path","attribs":{"d":"M404.862,237.165c-10.729,0-19.442,8.603-19.442,19.168c0,10.566,8.714,19.153,19.442,19.153\r\n\t\t\tc10.737,0,19.452-8.587,19.452-19.153C424.314,245.768,415.6,237.165,404.862,237.165z"},"children":[{"name":"path","attribs":{"d":"M404.862,237.165c-10.729,0-19.442,8.603-19.442,19.168c0,10.566,8.714,19.153,19.442,19.153\r\n\t\t\tc10.737,0,19.452-8.587,19.452-19.153C424.314,245.768,415.6,237.165,404.862,237.165z"},"children":[]}]},{"name":"path","attribs":{"d":"M362.314,195.301c-10.736,0-19.451,8.602-19.451,19.169c0,10.566,8.715,19.146,19.451,19.146\r\n\t\t\tc10.783,0,19.498-8.579,19.498-19.146C381.812,203.902,373.098,195.301,362.314,195.301z"},"children":[{"name":"path","attribs":{"d":"M362.314,195.301c-10.736,0-19.451,8.602-19.451,19.169c0,10.566,8.715,19.146,19.451,19.146\r\n\t\t\tc10.783,0,19.498-8.579,19.498-19.146C381.812,203.902,373.098,195.301,362.314,195.301z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M369.269,162c25.838,0,49.704,9.314,67.204,26.229C454.225,205.386,464,229.247,464,255.418\r\n\t\tc0,26.303-9.806,50.405-27.611,67.869c-17.563,17.226-41.4,26.713-67.12,26.713H142.739c-25.712,0-49.548-9.487-67.117-26.715\r\n\t\tC57.81,305.818,48,281.717,48,255.418c0-26.167,9.78-50.028,27.539-67.188C93.043,171.315,116.909,162,142.739,162H369.269\r\n\t\t M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529\r\n\t\tC430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146L369.269,146z"},"children":[{"name":"path","attribs":{"d":"M369.269,162c25.838,0,49.704,9.314,67.204,26.229C454.225,205.386,464,229.247,464,255.418\r\n\t\tc0,26.303-9.806,50.405-27.611,67.869c-17.563,17.226-41.4,26.713-67.12,26.713H142.739c-25.712,0-49.548-9.487-67.117-26.715\r\n\t\tC57.81,305.818,48,281.717,48,255.418c0-26.167,9.78-50.028,27.539-67.188C93.043,171.315,116.909,162,142.739,162H369.269\r\n\t\t M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529\r\n\t\tC430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146L369.269,146z"},"children":[]}]}]}]};exports.iosGameControllerAOutline=iosGameControllerAOutline;var iosGameControllerA={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529\r\n\t\tC430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146z M200,266.697c0,2.698-2.421,5.303-5.238,5.303H160\r\n\t\tv35.139c0,2.83-3.104,4.861-5.803,4.861h-21.427c-2.628,0-4.771-1.918-4.771-4.533V272H92.861c-2.83,0-4.861-3.104-4.861-5.803\r\n\t\tv-21.427c0-2.628,1.918-4.771,4.533-4.771H128v-34.822c0-2.806,1.854-5.178,4.553-5.178h22.145c2.698,0,5.303,2.421,5.303,5.238\r\n\t\tV240h34.822c2.806,0,5.178,1.854,5.178,4.553V266.697z M319.766,275.486c-10.736,0-19.451-8.587-19.451-19.153\r\n\t\tc0-10.565,8.715-19.168,19.451-19.168c10.783,0,19.498,8.603,19.498,19.168C339.264,266.899,330.549,275.486,319.766,275.486z\r\n\t\t M362.314,317.301c-10.736,0-19.451-8.529-19.451-19.084c0-10.639,8.715-19.153,19.451-19.153c10.783,0,19.498,8.515,19.498,19.153\r\n\t\tC381.812,308.771,373.098,317.301,362.314,317.301z M362.314,233.615c-10.736,0-19.451-8.579-19.451-19.146\r\n\t\tc0-10.567,8.715-19.169,19.451-19.169c10.783,0,19.498,8.602,19.498,19.169C381.812,225.036,373.098,233.615,362.314,233.615z\r\n\t\t M404.862,275.486c-10.729,0-19.442-8.587-19.442-19.153c0-10.565,8.714-19.168,19.442-19.168c10.737,0,19.452,8.603,19.452,19.168\r\n\t\tC424.314,266.899,415.6,275.486,404.862,275.486z"},"children":[{"name":"path","attribs":{"d":"M369.269,146H142.739C81.541,146,32,191.458,32,255.418C32,319.419,81.541,366,142.739,366h226.529\r\n\t\tC430.49,366,480,319.419,480,255.418C480,191.458,430.49,146,369.269,146z M200,266.697c0,2.698-2.421,5.303-5.238,5.303H160\r\n\t\tv35.139c0,2.83-3.104,4.861-5.803,4.861h-21.427c-2.628,0-4.771-1.918-4.771-4.533V272H92.861c-2.83,0-4.861-3.104-4.861-5.803\r\n\t\tv-21.427c0-2.628,1.918-4.771,4.533-4.771H128v-34.822c0-2.806,1.854-5.178,4.553-5.178h22.145c2.698,0,5.303,2.421,5.303,5.238\r\n\t\tV240h34.822c2.806,0,5.178,1.854,5.178,4.553V266.697z M319.766,275.486c-10.736,0-19.451-8.587-19.451-19.153\r\n\t\tc0-10.565,8.715-19.168,19.451-19.168c10.783,0,19.498,8.603,19.498,19.168C339.264,266.899,330.549,275.486,319.766,275.486z\r\n\t\t M362.314,317.301c-10.736,0-19.451-8.529-19.451-19.084c0-10.639,8.715-19.153,19.451-19.153c10.783,0,19.498,8.515,19.498,19.153\r\n\t\tC381.812,308.771,373.098,317.301,362.314,317.301z M362.314,233.615c-10.736,0-19.451-8.579-19.451-19.146\r\n\t\tc0-10.567,8.715-19.169,19.451-19.169c10.783,0,19.498,8.602,19.498,19.169C381.812,225.036,373.098,233.615,362.314,233.615z\r\n\t\t M404.862,275.486c-10.729,0-19.442-8.587-19.442-19.153c0-10.565,8.714-19.168,19.442-19.168c10.737,0,19.452,8.603,19.452,19.168\r\n\t\tC424.314,266.899,415.6,275.486,404.862,275.486z"},"children":[]}]}]}]};exports.iosGameControllerA=iosGameControllerA;var iosGameControllerBOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M308.076,203.929c-11.058,0-20.076,9.014-20.076,20.104c0,11.089,9.019,20.107,20.076,20.107\r\n\t\t\tc11.131,0,20.148-9.019,20.148-20.107C328.225,212.942,319.207,203.929,308.076,203.929z"},"children":[{"name":"path","attribs":{"d":"M308.076,203.929c-11.058,0-20.076,9.014-20.076,20.104c0,11.089,9.019,20.107,20.076,20.107\r\n\t\t\tc11.131,0,20.148-9.019,20.148-20.107C328.225,212.942,319.207,203.929,308.076,203.929z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.988,247.878c-11.058,0-20.053,8.949-20.053,20.106c0,11.064,8.995,20.016,20.053,20.016\r\n\t\t\tc11.146,0,20.148-8.951,20.148-20.016C372.137,256.827,363.134,247.878,351.988,247.878z"},"children":[{"name":"path","attribs":{"d":"M351.988,247.878c-11.058,0-20.053,8.949-20.053,20.106c0,11.064,8.995,20.016,20.053,20.016\r\n\t\t\tc11.146,0,20.148-8.951,20.148-20.016C372.137,256.827,363.134,247.878,351.988,247.878z"},"children":[]}]},{"name":"path","attribs":{"d":"M135.234,184.367C113.594,184.367,96,202.17,96,224.01c0,21.865,17.594,39.623,39.234,39.623\r\n\t\t\tc21.655,0,39.249-17.758,39.249-39.623C174.483,202.17,156.89,184.367,135.234,184.367z M135.123,243.457\r\n\t\t\tc-10.688,0-19.343-8.721-19.343-19.447c0-10.725,8.655-19.441,19.343-19.441c10.641,0,19.297,8.717,19.297,19.441\r\n\t\t\tC154.42,234.736,145.764,243.457,135.123,243.457z"},"children":[{"name":"path","attribs":{"d":"M135.234,184.367C113.594,184.367,96,202.17,96,224.01c0,21.865,17.594,39.623,39.234,39.623\r\n\t\t\tc21.655,0,39.249-17.758,39.249-39.623C174.483,202.17,156.89,184.367,135.234,184.367z M135.123,243.457\r\n\t\t\tc-10.688,0-19.343-8.721-19.343-19.447c0-10.725,8.655-19.441,19.343-19.441c10.641,0,19.297,8.717,19.297,19.441\r\n\t\t\tC154.42,234.736,145.764,243.457,135.123,243.457z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.988,160c-11.058,0-20.053,9.014-20.053,20.107c0,11.09,8.995,20.083,20.053,20.083\r\n\t\t\tc11.146,0,20.148-8.993,20.148-20.083C372.137,169.014,363.134,160,351.988,160z"},"children":[{"name":"path","attribs":{"d":"M351.988,160c-11.058,0-20.053,9.014-20.053,20.107c0,11.09,8.995,20.083,20.053,20.083\r\n\t\t\tc11.146,0,20.148-8.993,20.148-20.083C372.137,169.014,363.134,160,351.988,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M395.947,203.929c-11.105,0-20.101,9.014-20.101,20.104c0,11.089,8.995,20.107,20.101,20.107\r\n\t\t\tc11.059,0,20.053-9.019,20.053-20.107C416,212.942,407.006,203.929,395.947,203.929z"},"children":[{"name":"path","attribs":{"d":"M395.947,203.929c-11.105,0-20.101,9.014-20.101,20.104c0,11.089,8.995,20.107,20.101,20.107\r\n\t\t\tc11.059,0,20.053-9.019,20.053-20.107C416,212.942,407.006,203.929,395.947,203.929z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M466.279,248.866c-21.157-88.471-43.631-135.489-88.454-148.83C368.06,97.135,359.748,96,352.076,96\r\n\t\tc-27.598,0-46.938,14.683-96.08,14.683c-49.174,0-68.502-14.681-96.062-14.683c-7.665,0-15.963,1.135-25.721,4.036\r\n\t\tc-44.869,13.341-67.342,60.359-88.461,148.83c-21.181,88.473-17.334,152.363,7.679,164.289C57.502,415.1,61.662,416,65.885,416\r\n\t\tc21.694,0,45.139-23.838,67.659-52.047C159.198,331.848,165.658,331,243.822,331h24.343c78.147,0,84.628,0.846,110.282,32.953\r\n\t\tc22.526,28.207,45.97,52.004,67.665,52.004c4.226,0,8.384-0.879,12.457-2.823C483.574,401.208,487.421,337.339,466.279,248.866z\r\n\t\t M451.677,398.716c-1.835,0.876-3.604,1.284-5.564,1.284c-6.022,0-14.077-4.049-23.295-11.708\r\n\t\tc-9.181-7.63-19.307-18.509-31.87-34.239c-12.959-16.22-23.667-28.229-43.528-33.949c-16.647-4.793-38.624-5.104-79.254-5.104\r\n\t\th-24.343c-40.633,0-62.611,0.311-79.259,5.105c-19.853,5.719-30.56,17.685-43.523,33.908\r\n\t\tc-12.556,15.727-22.68,26.627-31.862,34.258c-9.216,7.658-17.27,11.718-23.293,11.718c-1.932,0-3.751-0.415-5.568-1.282\r\n\t\tc-9.556-4.557-22.572-47.673,0.998-146.129c21.387-89.591,42.381-126.777,77.459-137.207c7.633-2.27,14.554-3.372,21.159-3.372\r\n\t\tc9.742,0,18.599,2.317,29.812,5.249c16.07,4.203,36.072,9.435,66.252,9.435c30.148,0,50.146-5.228,66.215-9.429\r\n\t\tc11.229-2.936,20.1-5.254,29.865-5.254c6.618,0,13.551,1.104,21.185,3.371c35.037,10.428,56.03,47.617,77.456,137.214\r\n\t\tC474.244,351.041,461.23,394.16,451.677,398.716z"},"children":[{"name":"path","attribs":{"d":"M466.279,248.866c-21.157-88.471-43.631-135.489-88.454-148.83C368.06,97.135,359.748,96,352.076,96\r\n\t\tc-27.598,0-46.938,14.683-96.08,14.683c-49.174,0-68.502-14.681-96.062-14.683c-7.665,0-15.963,1.135-25.721,4.036\r\n\t\tc-44.869,13.341-67.342,60.359-88.461,148.83c-21.181,88.473-17.334,152.363,7.679,164.289C57.502,415.1,61.662,416,65.885,416\r\n\t\tc21.694,0,45.139-23.838,67.659-52.047C159.198,331.848,165.658,331,243.822,331h24.343c78.147,0,84.628,0.846,110.282,32.953\r\n\t\tc22.526,28.207,45.97,52.004,67.665,52.004c4.226,0,8.384-0.879,12.457-2.823C483.574,401.208,487.421,337.339,466.279,248.866z\r\n\t\t M451.677,398.716c-1.835,0.876-3.604,1.284-5.564,1.284c-6.022,0-14.077-4.049-23.295-11.708\r\n\t\tc-9.181-7.63-19.307-18.509-31.87-34.239c-12.959-16.22-23.667-28.229-43.528-33.949c-16.647-4.793-38.624-5.104-79.254-5.104\r\n\t\th-24.343c-40.633,0-62.611,0.311-79.259,5.105c-19.853,5.719-30.56,17.685-43.523,33.908\r\n\t\tc-12.556,15.727-22.68,26.627-31.862,34.258c-9.216,7.658-17.27,11.718-23.293,11.718c-1.932,0-3.751-0.415-5.568-1.282\r\n\t\tc-9.556-4.557-22.572-47.673,0.998-146.129c21.387-89.591,42.381-126.777,77.459-137.207c7.633-2.27,14.554-3.372,21.159-3.372\r\n\t\tc9.742,0,18.599,2.317,29.812,5.249c16.07,4.203,36.072,9.435,66.252,9.435c30.148,0,50.146-5.228,66.215-9.429\r\n\t\tc11.229-2.936,20.1-5.254,29.865-5.254c6.618,0,13.551,1.104,21.185,3.371c35.037,10.428,56.03,47.617,77.456,137.214\r\n\t\tC474.244,351.041,461.23,394.16,451.677,398.716z"},"children":[]}]}]}]};exports.iosGameControllerBOutline=iosGameControllerBOutline;var iosGameControllerB={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M135.123,204.568c-10.688,0-19.343,8.717-19.343,19.441c0,10.727,8.655,19.447,19.343,19.447\r\n\t\tc10.641,0,19.297-8.721,19.297-19.447C154.42,213.285,145.764,204.568,135.123,204.568z"},"children":[{"name":"path","attribs":{"d":"M135.123,204.568c-10.688,0-19.343,8.717-19.343,19.441c0,10.727,8.655,19.447,19.343,19.447\r\n\t\tc10.641,0,19.297-8.721,19.297-19.447C154.42,213.285,145.764,204.568,135.123,204.568z"},"children":[]}]},{"name":"path","attribs":{"d":"M466.279,248.866c-21.157-88.471-43.631-135.489-88.454-148.83C368.06,97.135,359.748,96,352.076,96\r\n\t\tc-27.598,0-46.938,14.683-96.08,14.683c-49.174,0-68.502-14.681-96.062-14.683c-7.665,0-15.963,1.135-25.721,4.036\r\n\t\tc-44.869,13.341-67.342,60.359-88.461,148.83c-21.181,88.473-17.334,152.363,7.679,164.289C57.502,415.1,61.662,416,65.885,416\r\n\t\tc21.694,0,45.139-23.838,67.659-52.047C159.198,331.848,165.658,331,243.822,331h24.343c78.147,0,84.628,0.846,110.282,32.953\r\n\t\tc22.526,28.207,45.97,52.004,67.665,52.004c4.226,0,8.384-0.879,12.457-2.823C483.574,401.208,487.421,337.339,466.279,248.866z\r\n\t\t M135.234,263.633C113.594,263.633,96,245.875,96,224.01c0-21.84,17.594-39.643,39.234-39.643\r\n\t\tc21.655,0,39.249,17.803,39.249,39.643C174.483,245.875,156.89,263.633,135.234,263.633z M308.076,244.14\r\n\t\tc-11.058,0-20.076-9.019-20.076-20.107c0-11.09,9.019-20.104,20.076-20.104c11.131,0,20.148,9.014,20.148,20.104\r\n\t\tC328.225,235.121,319.207,244.14,308.076,244.14z M351.988,288c-11.058,0-20.053-8.951-20.053-20.016\r\n\t\tc0-11.157,8.995-20.106,20.053-20.106c11.146,0,20.148,8.949,20.148,20.106C372.137,279.049,363.134,288,351.988,288z\r\n\t\t M351.988,200.19c-11.058,0-20.053-8.993-20.053-20.083c0-11.094,8.995-20.107,20.053-20.107c11.146,0,20.148,9.014,20.148,20.107\r\n\t\tC372.137,191.197,363.134,200.19,351.988,200.19z M395.947,244.14c-11.105,0-20.101-9.019-20.101-20.107\r\n\t\tc0-11.09,8.995-20.104,20.101-20.104c11.059,0,20.053,9.014,20.053,20.104C416,235.121,407.006,244.14,395.947,244.14z"},"children":[{"name":"path","attribs":{"d":"M466.279,248.866c-21.157-88.471-43.631-135.489-88.454-148.83C368.06,97.135,359.748,96,352.076,96\r\n\t\tc-27.598,0-46.938,14.683-96.08,14.683c-49.174,0-68.502-14.681-96.062-14.683c-7.665,0-15.963,1.135-25.721,4.036\r\n\t\tc-44.869,13.341-67.342,60.359-88.461,148.83c-21.181,88.473-17.334,152.363,7.679,164.289C57.502,415.1,61.662,416,65.885,416\r\n\t\tc21.694,0,45.139-23.838,67.659-52.047C159.198,331.848,165.658,331,243.822,331h24.343c78.147,0,84.628,0.846,110.282,32.953\r\n\t\tc22.526,28.207,45.97,52.004,67.665,52.004c4.226,0,8.384-0.879,12.457-2.823C483.574,401.208,487.421,337.339,466.279,248.866z\r\n\t\t M135.234,263.633C113.594,263.633,96,245.875,96,224.01c0-21.84,17.594-39.643,39.234-39.643\r\n\t\tc21.655,0,39.249,17.803,39.249,39.643C174.483,245.875,156.89,263.633,135.234,263.633z M308.076,244.14\r\n\t\tc-11.058,0-20.076-9.019-20.076-20.107c0-11.09,9.019-20.104,20.076-20.104c11.131,0,20.148,9.014,20.148,20.104\r\n\t\tC328.225,235.121,319.207,244.14,308.076,244.14z M351.988,288c-11.058,0-20.053-8.951-20.053-20.016\r\n\t\tc0-11.157,8.995-20.106,20.053-20.106c11.146,0,20.148,8.949,20.148,20.106C372.137,279.049,363.134,288,351.988,288z\r\n\t\t M351.988,200.19c-11.058,0-20.053-8.993-20.053-20.083c0-11.094,8.995-20.107,20.053-20.107c11.146,0,20.148,9.014,20.148,20.107\r\n\t\tC372.137,191.197,363.134,200.19,351.988,200.19z M395.947,244.14c-11.105,0-20.101-9.019-20.101-20.107\r\n\t\tc0-11.09,8.995-20.104,20.101-20.104c11.059,0,20.053,9.014,20.053,20.104C416,235.121,407.006,244.14,395.947,244.14z"},"children":[]}]}]}]};exports.iosGameControllerB=iosGameControllerB;var iosGearOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.9,159.9c-25.701,0-49.801,10-67.9,28.1s-28.1,42.199-28.1,67.9c0,25.699,10,49.699,28.1,67.9\r\n\t\t\tc18.1,18.1,42.301,28.1,67.9,28.1c25.699,0,49.799-10,67.9-28.1c18.1-18.102,28.1-42.201,28.1-67.9c0-25.701-10-49.701-28.1-67.9\r\n\t\t\tC306.699,169.9,282.6,159.9,256.9,159.9z M256.9,335.9c-44.301,0-80-35.9-80-80c0-44.101,35.699-80,80-80\r\n\t\t\tc44.299,0,80,35.899,80,80C336.9,300,301.199,335.9,256.9,335.9z"},"children":[{"name":"path","attribs":{"d":"M256.9,159.9c-25.701,0-49.801,10-67.9,28.1s-28.1,42.199-28.1,67.9c0,25.699,10,49.699,28.1,67.9\r\n\t\t\tc18.1,18.1,42.301,28.1,67.9,28.1c25.699,0,49.799-10,67.9-28.1c18.1-18.102,28.1-42.201,28.1-67.9c0-25.701-10-49.701-28.1-67.9\r\n\t\t\tC306.699,169.9,282.6,159.9,256.9,159.9z M256.9,335.9c-44.301,0-80-35.9-80-80c0-44.101,35.699-80,80-80\r\n\t\t\tc44.299,0,80,35.899,80,80C336.9,300,301.199,335.9,256.9,335.9z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M201.787,82.828c4.458,6.628,10.119,12.406,16.775,17.069c11.012,7.715,23.957,11.793,37.438,11.793\r\n\t\t\tc13.481,0,26.428-4.078,37.439-11.793c6.654-4.663,12.316-10.441,16.773-17.068c10.326,3.228,20.334,7.378,29.927,12.411\r\n\t\t\tc-1.532,7.84-1.614,15.93-0.203,23.933c2.333,13.235,8.604,25.269,18.133,34.798c12.335,12.336,28.737,19.129,46.185,19.129\r\n\t\t\tc4.242,0,8.424-0.399,12.52-1.195c5.032,9.6,9.181,19.613,12.405,29.947c-6.622,4.46-12.396,10.121-17.054,16.776\r\n\t\t\tc-7.705,11.008-11.777,23.946-11.776,37.418c0,13.467,4.069,26.401,11.768,37.406c4.653,6.651,10.421,12.312,17.036,16.771\r\n\t\t\tc-3.232,10.34-7.387,20.354-12.428,29.957c-4.081-0.789-8.246-1.187-12.472-1.187c-17.448,0-33.85,6.795-46.183,19.131\r\n\t\t\tc-9.515,9.514-15.781,21.527-18.123,34.74c-1.415,7.988-1.343,16.065,0.176,23.895c-9.607,5.04-19.627,9.192-29.967,12.421\r\n\t\t\tc-4.461-6.61-10.121-12.374-16.771-17.022c-11-7.689-23.928-11.754-37.386-11.754c-13.457,0-26.385,4.064-37.385,11.755\r\n\t\t\tc-6.649,4.648-12.31,10.412-16.771,17.021c-10.339-3.228-20.359-7.381-29.966-12.42c1.519-7.829,1.591-15.906,0.176-23.895\r\n\t\t\tc-2.342-13.214-8.608-25.228-18.123-34.741c-12.335-12.336-28.737-19.13-46.185-19.13c-4.226,0-8.39,0.396-12.471,1.187\r\n\t\t\tc-5.04-9.602-9.195-19.618-12.428-29.958c6.615-4.46,12.383-10.119,17.036-16.771c7.699-11.004,11.769-23.939,11.769-37.408\r\n\t\t\tc0-13.471-4.072-26.41-11.777-37.418c-4.658-6.654-10.432-12.316-17.054-16.776c3.225-10.333,7.372-20.346,12.405-29.946\r\n\t\t\tc4.096,0.796,8.277,1.196,12.521,1.196c17.446,0,33.849-6.794,46.185-19.13c9.529-9.53,15.799-21.563,18.133-34.799\r\n\t\t\tc1.411-8.003,1.33-16.093-0.203-23.932C181.455,90.207,191.461,86.057,201.787,82.828 M302.074,64\r\n\t\t\tC294.971,82.529,277.027,95.69,256,95.69c-21.025,0-38.969-13.161-46.073-31.69c-20.466,4.895-39.692,12.973-57.128,23.688\r\n\t\t\tc8.068,18.122,4.682,40.104-10.182,54.97c-9.631,9.631-22.25,14.443-34.87,14.443c-6.854,0-13.706-1.419-20.083-4.255\r\n\t\t\tC76.958,170.284,68.887,189.517,64,209.984c18.51,7.112,31.652,25.049,31.652,46.062c0,21.008-13.133,38.936-31.631,46.054\r\n\t\t\tc4.898,20.466,12.977,39.692,23.693,57.128c6.36-2.821,13.197-4.232,20.031-4.232c12.621,0,25.238,4.812,34.871,14.443\r\n\t\t\tc14.841,14.841,18.238,36.781,10.215,54.889c17.438,10.71,36.664,18.783,57.131,23.673c7.127-18.479,25.046-31.596,46.037-31.596\r\n\t\t\tc20.992,0,38.91,13.115,46.037,31.596c20.468-4.89,39.693-12.964,57.132-23.675c-8.023-18.106-4.626-40.046,10.216-54.887\r\n\t\t\tc9.629-9.632,22.248-14.444,34.868-14.444c6.836,0,13.67,1.411,20.033,4.233c10.716-17.436,18.794-36.662,23.692-57.128\r\n\t\t\tc-18.498-7.118-31.63-25.048-31.63-46.054c-0.001-21.013,13.143-38.948,31.651-46.062c-4.887-20.466-12.957-39.7-23.664-57.139\r\n\t\t\tc-6.375,2.836-13.23,4.254-20.082,4.254c-12.621,0-25.238-4.811-34.871-14.442c-14.863-14.863-18.248-36.846-10.18-54.97\r\n\t\t\tC341.768,76.973,322.54,68.895,302.074,64L302.074,64z"},"children":[{"name":"path","attribs":{"d":"M201.787,82.828c4.458,6.628,10.119,12.406,16.775,17.069c11.012,7.715,23.957,11.793,37.438,11.793\r\n\t\t\tc13.481,0,26.428-4.078,37.439-11.793c6.654-4.663,12.316-10.441,16.773-17.068c10.326,3.228,20.334,7.378,29.927,12.411\r\n\t\t\tc-1.532,7.84-1.614,15.93-0.203,23.933c2.333,13.235,8.604,25.269,18.133,34.798c12.335,12.336,28.737,19.129,46.185,19.129\r\n\t\t\tc4.242,0,8.424-0.399,12.52-1.195c5.032,9.6,9.181,19.613,12.405,29.947c-6.622,4.46-12.396,10.121-17.054,16.776\r\n\t\t\tc-7.705,11.008-11.777,23.946-11.776,37.418c0,13.467,4.069,26.401,11.768,37.406c4.653,6.651,10.421,12.312,17.036,16.771\r\n\t\t\tc-3.232,10.34-7.387,20.354-12.428,29.957c-4.081-0.789-8.246-1.187-12.472-1.187c-17.448,0-33.85,6.795-46.183,19.131\r\n\t\t\tc-9.515,9.514-15.781,21.527-18.123,34.74c-1.415,7.988-1.343,16.065,0.176,23.895c-9.607,5.04-19.627,9.192-29.967,12.421\r\n\t\t\tc-4.461-6.61-10.121-12.374-16.771-17.022c-11-7.689-23.928-11.754-37.386-11.754c-13.457,0-26.385,4.064-37.385,11.755\r\n\t\t\tc-6.649,4.648-12.31,10.412-16.771,17.021c-10.339-3.228-20.359-7.381-29.966-12.42c1.519-7.829,1.591-15.906,0.176-23.895\r\n\t\t\tc-2.342-13.214-8.608-25.228-18.123-34.741c-12.335-12.336-28.737-19.13-46.185-19.13c-4.226,0-8.39,0.396-12.471,1.187\r\n\t\t\tc-5.04-9.602-9.195-19.618-12.428-29.958c6.615-4.46,12.383-10.119,17.036-16.771c7.699-11.004,11.769-23.939,11.769-37.408\r\n\t\t\tc0-13.471-4.072-26.41-11.777-37.418c-4.658-6.654-10.432-12.316-17.054-16.776c3.225-10.333,7.372-20.346,12.405-29.946\r\n\t\t\tc4.096,0.796,8.277,1.196,12.521,1.196c17.446,0,33.849-6.794,46.185-19.13c9.529-9.53,15.799-21.563,18.133-34.799\r\n\t\t\tc1.411-8.003,1.33-16.093-0.203-23.932C181.455,90.207,191.461,86.057,201.787,82.828 M302.074,64\r\n\t\t\tC294.971,82.529,277.027,95.69,256,95.69c-21.025,0-38.969-13.161-46.073-31.69c-20.466,4.895-39.692,12.973-57.128,23.688\r\n\t\t\tc8.068,18.122,4.682,40.104-10.182,54.97c-9.631,9.631-22.25,14.443-34.87,14.443c-6.854,0-13.706-1.419-20.083-4.255\r\n\t\t\tC76.958,170.284,68.887,189.517,64,209.984c18.51,7.112,31.652,25.049,31.652,46.062c0,21.008-13.133,38.936-31.631,46.054\r\n\t\t\tc4.898,20.466,12.977,39.692,23.693,57.128c6.36-2.821,13.197-4.232,20.031-4.232c12.621,0,25.238,4.812,34.871,14.443\r\n\t\t\tc14.841,14.841,18.238,36.781,10.215,54.889c17.438,10.71,36.664,18.783,57.131,23.673c7.127-18.479,25.046-31.596,46.037-31.596\r\n\t\t\tc20.992,0,38.91,13.115,46.037,31.596c20.468-4.89,39.693-12.964,57.132-23.675c-8.023-18.106-4.626-40.046,10.216-54.887\r\n\t\t\tc9.629-9.632,22.248-14.444,34.868-14.444c6.836,0,13.67,1.411,20.033,4.233c10.716-17.436,18.794-36.662,23.692-57.128\r\n\t\t\tc-18.498-7.118-31.63-25.048-31.63-46.054c-0.001-21.013,13.143-38.948,31.651-46.062c-4.887-20.466-12.957-39.7-23.664-57.139\r\n\t\t\tc-6.375,2.836-13.23,4.254-20.082,4.254c-12.621,0-25.238-4.811-34.871-14.442c-14.863-14.863-18.248-36.846-10.18-54.97\r\n\t\t\tC341.768,76.973,322.54,68.895,302.074,64L302.074,64z"},"children":[]}]}]}]}]}]};exports.iosGearOutline=iosGearOutline;var iosGear={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M416.349,256.046c-0.001-21.013,13.143-38.948,31.651-46.062c-4.887-20.466-12.957-39.7-23.664-57.139\r\n\tc-6.375,2.836-13.23,4.254-20.082,4.254c-12.621,0-25.238-4.811-34.871-14.442c-14.863-14.863-18.248-36.846-10.18-54.97\r\n\tC341.768,76.973,322.54,68.895,302.074,64C294.971,82.529,277.027,95.69,256,95.69c-21.025,0-38.969-13.161-46.073-31.69\r\n\tc-20.466,4.895-39.693,12.973-57.128,23.688c8.068,18.122,4.683,40.104-10.181,54.97c-9.631,9.631-22.25,14.443-34.871,14.443\r\n\tc-6.854,0-13.706-1.419-20.083-4.255C76.958,170.284,68.886,189.517,64,209.984c18.509,7.112,31.652,25.049,31.652,46.062\r\n\tc0,21.008-13.132,38.936-31.63,46.054c4.898,20.466,12.976,39.692,23.692,57.128c6.361-2.821,13.198-4.232,20.032-4.232\r\n\tc12.622,0,25.239,4.812,34.871,14.443c14.841,14.841,18.239,36.781,10.215,54.889c17.438,10.71,36.664,18.783,57.13,23.673\r\n\tc7.128-18.479,25.046-31.596,46.038-31.596c20.992,0,38.91,13.115,46.037,31.596c20.468-4.89,39.693-12.964,57.132-23.675\r\n\tc-8.023-18.106-4.626-40.046,10.216-54.887c9.629-9.632,22.248-14.444,34.868-14.444c6.836,0,13.67,1.411,20.033,4.233\r\n\tc10.716-17.436,18.794-36.662,23.692-57.128C429.48,294.981,416.349,277.052,416.349,256.046z M256.9,335.9c-44.3,0-80-35.9-80-80\r\n\tc0-44.101,35.7-80,80-80c44.299,0,80,35.899,80,80C336.9,300,301.199,335.9,256.9,335.9z"},"children":[]}]};exports.iosGear=iosGear;var iosGlassesOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M465.4,247c-2.2-22-12.4-43-28.9-58.4c-17.1-15.9-39.3-24.7-62.7-24.7c-41.5,0-77.3,27.4-88.5,67c-7-7-18.5-11.7-29.3-11.7\r\n\tc-10.8,0-22.3,4.7-29.3,11.7c-11.2-39.6-47-67-88.5-67c-23.3,0-45.6,8.7-62.7,24.6C59,204,48.8,225,46.6,247H32v18h14.6\r\n\tc2.2,22,12.4,43,28.9,58.4c17.1,15.9,39.3,24.7,62.7,24.7c50.8,0,92.1-41.2,92.1-92c0-0.1,0-0.1,0-0.1h0c0-9.9,11.5-21.6,25.7-21.6\r\n\ts25.7,11.7,25.7,21.6h0c0,0,0,0,0,0.1c0,50.8,41.3,92,92.1,92c23.3,0,45.6-8.7,62.7-24.7c16.5-15.4,26.7-36.5,28.9-58.5H480v-18\r\n\tH465.4z M373.8,333c-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C450.8,298.5,416.3,333,373.8,333z M138.2,333\r\n\tc-42.5,0-77-34.6-77-77c0-42.5,34.6-77,77-77c42.5,0,77,34.6,77,77C215.2,298.5,180.7,333,138.2,333z"},"children":[]}]};exports.iosGlassesOutline=iosGlassesOutline;var iosGlasses={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M465.4,247c-2.2-22-12.4-43-28.9-58.4c-17.1-15.9-39.3-24.7-62.7-24.7c-41.5,0-77.3,27.4-88.5,67c-7-7-18.5-11.7-29.3-11.7\r\n\tc-10.8,0-22.3,4.7-29.3,11.7c-11.2-39.6-47-67-88.5-67c-23.3,0-45.6,8.7-62.7,24.6C59,204,48.8,225,46.6,247H32v18h14.6\r\n\tc2.2,22,12.4,43,28.9,58.4c17.1,15.9,39.3,24.7,62.7,24.7c50.8,0,92.1-41.2,92.1-92c0-0.1,0-0.1,0-0.1h0c0-9.9,11.5-21.6,25.7-21.6\r\n\ts25.7,11.7,25.7,21.6h0c0,0,0,0,0,0.1c0,50.8,41.3,92,92.1,92c23.3,0,45.6-8.7,62.7-24.7c16.5-15.4,26.7-36.5,28.9-58.5H480v-18\r\n\tH465.4z"},"children":[]}]};exports.iosGlasses=iosGlasses;var iosGridViewOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,192v-16H336V64h-16v112H192V64h-16v112H64v16h112v128H64v16h112v112h16V336h128v112h16V336h112v-16H336V192H448z\r\n\t M320,320H192V192h128V320z"},"children":[]}]};exports.iosGridViewOutline=iosGridViewOutline;var iosGridView={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"192","y":"192","width":"128","height":"128"},"children":[{"name":"rect","attribs":{"x":"192","y":"192","width":"128","height":"128"},"children":[]}]},{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M416,192h-80v128h80v16h-80v80h-16v-80H192v80h-16v-80H96v-16h80V192H96v-16h80V96h16v80h128V96h16\r\n\t\tv80h80V192z"},"children":[{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M416,192h-80v128h80v16h-80v80h-16v-80H192v80h-16v-80H96v-16h80V192H96v-16h80V96h16v80h128V96h16\r\n\t\tv80h80V192z"},"children":[]}]}]}]};exports.iosGridView=iosGridView;var iosHeartOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M359.385,80C319.966,80,277.171,97.599,256,132.8C234.83,97.599,192.034,80,152.615,80C83.647,80,32,123.238,32,195.779\r\n\tc0,31.288,12.562,71.924,40.923,105.657c28.359,33.735,45.229,51.7,100.153,88C228,425.738,256,432,256,432s28-6.262,82.924-42.564\r\n\tc54.923-36.3,71.794-54.265,100.153-88C467.438,267.703,480,227.067,480,195.779C480,123.238,428.353,80,359.385,80z\r\n\t M426.83,291.141c-26.852,31.94-42.18,48.895-96.729,84.947c-40.237,26.596-65.252,36.301-74.102,39.233\r\n\tc-8.85-2.933-33.864-12.639-74.102-39.233c-54.548-36.052-69.876-53.006-96.729-84.948c-12.065-14.351-21.857-31.274-28.316-48.943\r\n\tC51.062,226.355,48,210.304,48,195.779c0-30.284,10.131-55.643,29.297-73.335c9.14-8.437,20.158-14.992,32.752-19.484\r\n\tC122.994,98.341,137.315,96,152.615,96c38.018,0,73.217,17.682,89.674,45.046L256,163.844l13.711-22.798\r\n\tC286.169,113.682,321.368,96,359.385,96c15.3,0,29.621,2.341,42.566,6.959c12.594,4.493,23.612,11.048,32.752,19.484\r\n\tC453.869,140.136,464,165.495,464,195.779c0,14.525-3.062,30.576-8.854,46.418C448.688,259.865,438.896,276.789,426.83,291.141z"},"children":[]}]};exports.iosHeartOutline=iosHeartOutline;var iosHeart={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M359.385,80C319.966,80,277.171,97.599,256,132.8C234.83,97.599,192.034,80,152.615,80C83.647,80,32,123.238,32,195.779\r\n\tc0,31.288,12.562,71.924,40.923,105.657c28.359,33.735,45.229,51.7,100.153,88C228,425.738,256,432,256,432s28-6.262,82.924-42.564\r\n\tc54.923-36.3,71.794-54.265,100.153-88C467.438,267.703,480,227.067,480,195.779C480,123.238,428.353,80,359.385,80z"},"children":[]}]};exports.iosHeart=iosHeart;var iosHelpEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M260.3,366c-9.4,0-17-7.5-17-16.9c0-9.3,7.6-16.8,17-16.8c9.4,0,17,7.5,17,16.8C277.3,358.5,269.7,366,260.3,366z\r\n\t\t M294.1,250.7c-22.8,22.5-22.2,27.4-23.3,53.3h-19c1.1-28.5,7.5-43.7,30.1-64.5c11-10.3,19.4-22.7,19.4-38.1\r\n\t\tc0-23.6-19.4-39.9-42.6-39.9c-32.4,0-48.5,16.4-47.9,46.4H192c0.3-42,24.4-62.1,67.6-62.1c33,0,60.4,20.4,60.4,54.6\r\n\t\tC320,222.3,309.3,236.6,294.1,250.7z"},"children":[{"name":"path","attribs":{"d":"M260.3,366c-9.4,0-17-7.5-17-16.9c0-9.3,7.6-16.8,17-16.8c9.4,0,17,7.5,17,16.8C277.3,358.5,269.7,366,260.3,366z\r\n\t\t M294.1,250.7c-22.8,22.5-22.2,27.4-23.3,53.3h-19c1.1-28.5,7.5-43.7,30.1-64.5c11-10.3,19.4-22.7,19.4-38.1\r\n\t\tc0-23.6-19.4-39.9-42.6-39.9c-32.4,0-48.5,16.4-47.9,46.4H192c0.3-42,24.4-62.1,67.6-62.1c33,0,60.4,20.4,60.4,54.6\r\n\t\tC320,222.3,309.3,236.6,294.1,250.7z"},"children":[]}]}]}]};exports.iosHelpEmpty=iosHelpEmpty;var iosHelpOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t\t\t M256,446.7c-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t\t\t M256,446.7c-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M259.6,146c-43.2,0-67.3,20.3-67.6,62.2h18.8c-0.6-30.4,15.5-46.5,47.9-46.5c23.2,0,42.6,16.2,42.6,39.8\r\n\t\t\tc0,15.3-8.3,27.7-19.4,38.1c-22.6,20.8-29,36-30.1,64.5h19c1.1-25.8,0.5-30.7,23.3-53.3c15.2-14.2,25.9-28.3,25.9-50.2\r\n\t\t\tC320,166.4,292.6,146,259.6,146z"},"children":[{"name":"path","attribs":{"d":"M259.6,146c-43.2,0-67.3,20.3-67.6,62.2h18.8c-0.6-30.4,15.5-46.5,47.9-46.5c23.2,0,42.6,16.2,42.6,39.8\r\n\t\t\tc0,15.3-8.3,27.7-19.4,38.1c-22.6,20.8-29,36-30.1,64.5h19c1.1-25.8,0.5-30.7,23.3-53.3c15.2-14.2,25.9-28.3,25.9-50.2\r\n\t\t\tC320,166.4,292.6,146,259.6,146z"},"children":[]}]},{"name":"path","attribs":{"d":"M260.3,332.3c-9.4,0-17,7.5-17,16.8c0,9.3,7.6,16.9,17,16.9c9.4,0,17-7.5,17-16.9C277.3,339.8,269.7,332.3,260.3,332.3z"},"children":[{"name":"path","attribs":{"d":"M260.3,332.3c-9.4,0-17,7.5-17,16.8c0,9.3,7.6,16.9,17,16.9c9.4,0,17-7.5,17-16.9C277.3,339.8,269.7,332.3,260.3,332.3z"},"children":[]}]}]}]}]}]};exports.iosHelpOutline=iosHelpOutline;var iosHelp={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t M260.3,366c-9.4,0-17-7.5-17-16.9c0-9.3,7.6-16.8,17-16.8c9.4,0,17,7.5,17,16.8C277.3,358.5,269.7,366,260.3,366z M294.1,250.7\r\n\t\tc-22.8,22.5-22.2,27.4-23.3,53.3h-19c1.1-28.5,7.5-43.7,30.1-64.5c11-10.3,19.4-22.7,19.4-38.1c0-23.6-19.4-39.9-42.6-39.9\r\n\t\tc-32.4,0-48.5,16.4-47.9,46.4H192c0.3-42,24.4-62.1,67.6-62.1c33,0,60.4,20.4,60.4,54.6C320,222.3,309.3,236.6,294.1,250.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t M260.3,366c-9.4,0-17-7.5-17-16.9c0-9.3,7.6-16.8,17-16.8c9.4,0,17,7.5,17,16.8C277.3,358.5,269.7,366,260.3,366z M294.1,250.7\r\n\t\tc-22.8,22.5-22.2,27.4-23.3,53.3h-19c1.1-28.5,7.5-43.7,30.1-64.5c11-10.3,19.4-22.7,19.4-38.1c0-23.6-19.4-39.9-42.6-39.9\r\n\t\tc-32.4,0-48.5,16.4-47.9,46.4H192c0.3-42,24.4-62.1,67.6-62.1c33,0,60.4,20.4,60.4,54.6C320,222.3,309.3,236.6,294.1,250.7z"},"children":[]}]}]}]};exports.iosHelp=iosHelp;var iosHomeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,112L96,240v208h112V320h96v128h112V240L256,112z M400,432h-80V304H192v128h-80V247.69l144-115.2l144,115.2V432z"},"children":[{"name":"path","attribs":{"d":"M256,112L96,240v208h112V320h96v128h112V240L256,112z M400,432h-80V304H192v128h-80V247.69l144-115.2l144,115.2V432z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64l-96,76.8V96H96v95.999l-32,25.499l11.51,11.384L256,84.49l180.49,144.393L448,217.498L256,64z M144,153.599\r\n\t\tl-32,25.6V112h32V153.599z"},"children":[{"name":"path","attribs":{"d":"M256,64l-96,76.8V96H96v95.999l-32,25.499l11.51,11.384L256,84.49l180.49,144.393L448,217.498L256,64z M144,153.599\r\n\t\tl-32,25.6V112h32V153.599z"},"children":[]}]}]}]};exports.iosHomeOutline=iosHomeOutline;var iosHome={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,112L96,240v208h112V320h96v128h112V240L256,112z"},"children":[{"name":"path","attribs":{"d":"M256,112L96,240v208h112V320h96v128h112V240L256,112z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64l-96,76.8V96H96v95.999l-32,25.499l11.51,11.384L256,84.49l180.49,144.393L448,217.498L256,64z"},"children":[{"name":"path","attribs":{"d":"M256,64l-96,76.8V96H96v95.999l-32,25.499l11.51,11.384L256,84.49l180.49,144.393L448,217.498L256,64z"},"children":[]}]}]}]};exports.iosHome=iosHome;var iosInfiniteOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M451.229,188.098C432.682,169.967,407.95,160,381.585,160c-26.363,0-51.095,9.967-69.642,28.098l-42.229,41.187\r\n\t\tl13.649,13.447l42.229-41.306c14.933-14.529,34.764-22.573,55.878-22.573c21.113,0,40.946,8.044,55.878,22.573\r\n\t\tc30.797,30.139,30.797,79.13,0,109.148c-14.932,14.529-34.765,22.573-55.878,22.573c-21.114,0-40.945-8.044-55.878-22.573\r\n\t\tL200.071,188.098C181.406,169.967,156.675,160,130.427,160c-26.363,0-51.095,9.967-69.643,28.098\r\n\t\tC41.615,206.809,32.021,231.441,32,256c-0.021,24.611,9.573,49.149,28.784,67.902C79.332,342.032,104.063,352,130.427,352\r\n\t\tc26.365,0,51.095-9.968,69.645-28.098l42.111-41.186l-13.647-13.329l-42.229,41.187c-14.932,14.529-34.764,22.573-55.879,22.573\r\n\t\tc-21.113,0-40.944-8.044-55.876-22.573c-30.799-30.14-30.799-79.13,0-109.148c14.932-14.529,34.763-22.573,55.876-22.573\r\n\t\tc21.115,0,40.947,8.044,55.879,22.573l125.52,122.477C330.49,342.032,355.222,352,381.47,352c26.363,0,51.095-9.968,69.643-28.098\r\n\t\tC470.361,305.23,479.985,280.6,480,256C480.015,231.399,470.42,206.83,451.229,188.098z"},"children":[{"name":"path","attribs":{"d":"M451.229,188.098C432.682,169.967,407.95,160,381.585,160c-26.363,0-51.095,9.967-69.642,28.098l-42.229,41.187\r\n\t\tl13.649,13.447l42.229-41.306c14.933-14.529,34.764-22.573,55.878-22.573c21.113,0,40.946,8.044,55.878,22.573\r\n\t\tc30.797,30.139,30.797,79.13,0,109.148c-14.932,14.529-34.765,22.573-55.878,22.573c-21.114,0-40.945-8.044-55.878-22.573\r\n\t\tL200.071,188.098C181.406,169.967,156.675,160,130.427,160c-26.363,0-51.095,9.967-69.643,28.098\r\n\t\tC41.615,206.809,32.021,231.441,32,256c-0.021,24.611,9.573,49.149,28.784,67.902C79.332,342.032,104.063,352,130.427,352\r\n\t\tc26.365,0,51.095-9.968,69.645-28.098l42.111-41.186l-13.647-13.329l-42.229,41.187c-14.932,14.529-34.764,22.573-55.879,22.573\r\n\t\tc-21.113,0-40.944-8.044-55.876-22.573c-30.799-30.14-30.799-79.13,0-109.148c14.932-14.529,34.763-22.573,55.876-22.573\r\n\t\tc21.115,0,40.947,8.044,55.879,22.573l125.52,122.477C330.49,342.032,355.222,352,381.47,352c26.363,0,51.095-9.968,69.643-28.098\r\n\t\tC470.361,305.23,479.985,280.6,480,256C480.015,231.399,470.42,206.83,451.229,188.098z"},"children":[]}]}]}]};exports.iosInfiniteOutline=iosInfiniteOutline;var iosInfinite={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M456.821,182.377C436.782,162.788,410.062,152,381.585,152c-28.477,0-55.195,10.788-75.21,30.354l-39.106,37.885\r\n\tl25.06,24.689l38.843-37.769c13.458-13.095,31.321-20.307,50.299-20.307c18.979,0,36.841,7.212,50.282,20.291\r\n\tc13.363,13.077,20.712,30.468,20.693,48.97c-0.019,18.443-7.363,35.75-20.677,48.728c-13.458,13.095-31.32,20.307-50.299,20.307\r\n\tc-18.978,0-36.841-7.212-50.291-20.299L205.646,182.359C185.491,162.782,158.778,152,130.427,152\r\n\tc-28.477,0-55.195,10.788-75.23,30.373C35.103,201.986,24.023,228.132,24,255.993c-0.024,27.822,11.055,53.973,31.192,73.63\r\n\tC75.232,349.212,101.951,360,130.427,360c28.475,0,55.194-10.788,75.223-30.363l38.994-37.909l-25.088-24.502l-38.829,37.615\r\n\tc-13.458,13.095-31.321,20.307-50.3,20.307c-18.977,0-36.839-7.212-50.28-20.291c-13.364-13.077-20.714-30.469-20.694-48.971\r\n\tc0.019-18.443,7.363-35.749,20.678-48.727c13.458-13.095,31.32-20.307,50.297-20.307c18.979,0,36.842,7.212,50.292,20.299\r\n\tl125.532,122.489C326.406,349.218,353.119,360,381.47,360c28.476,0,55.194-10.788,75.213-30.355\r\n\tc20.179-19.573,31.301-45.727,31.317-73.64C488.017,228.167,476.942,202.018,456.821,182.377z"},"children":[]}]};exports.iosInfinite=iosInfinite;var iosInformationEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"251.5","cy":"172","r":"20"},"children":[{"name":"circle","attribs":{"cx":"251.5","cy":"172","r":"20"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,344 272,216 224,216 224,224 240,224 240,344 224,344 224,352 288,352 288,344 \t\t"},"children":[{"name":"polygon","attribs":{"points":"272,344 272,216 224,216 224,224 240,224 240,344 224,344 224,352 288,352 288,344 \t\t"},"children":[]}]}]}]}]}]};exports.iosInformationEmpty=iosInformationEmpty;var iosInformationOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"251.5","cy":"172","r":"20"},"children":[{"name":"circle","attribs":{"cx":"251.5","cy":"172","r":"20"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,344 272,216 224,216 224,224 240,224 240,344 224,344 224,352 288,352 288,344 \t\t"},"children":[{"name":"polygon","attribs":{"points":"272,344 272,216 224,216 224,224 240,224 240,344 224,344 224,352 288,352 288,344 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t\t M256,446.7c-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t\t M256,446.7c-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]};exports.iosInformationOutline=iosInformationOutline;var iosInformation={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t M251.5,152c11.1,0,20,9,20,20s-9,20-20,20c-11,0-20-9-20-20S240.4,152,251.5,152z M288,352h-64v-8h16V224h-16v-8h48v128h16V352z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t\t M251.5,152c11.1,0,20,9,20,20s-9,20-20,20c-11,0-20-9-20-20S240.4,152,251.5,152z M288,352h-64v-8h16V224h-16v-8h48v128h16V352z"},"children":[]}]}]}]};exports.iosInformation=iosInformation;var iosIonicOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M425.5,134.8c4.7-5.9,7.5-13.5,7.5-21.6c0-19.2-15.6-34.9-34.8-34.9c-8.2,0-15.7,2.8-21.6,7.5c-34-24.2-75-37.8-119.9-37.8\r\n\t\tC141.8,48,48,140.5,48,255.6C48,370.7,141.7,464,256.6,464C371.5,464,464,370.7,464,255.6C464,210.6,449.7,168.9,425.5,134.8z\r\n\t\t M398,91.3c12.2,0,22,9.9,22,22c0,12.2-9.9,22-22,22c-12.2,0-22-9.9-22-22C376,101.2,385.8,91.3,398,91.3z M391.8,391.7\r\n\t\tc-17.6,17.6-38.2,31.6-61.1,41.3c-23.7,10-48.2,15.2-74.2,15.2c-25.9,0-51.7-5.1-75.4-15.2c-22.9-9.7-43.4-23.5-61.1-41.3\r\n\t\tc-17.6-17.6-31.5-38.3-41.2-61.2c-10-23.7-15.1-48.9-15.1-74.9c0-25.9,5.1-51.2,15.1-74.9c9.7-22.9,23.5-43.5,41.2-61.2\r\n\t\ts38.2-31.6,61.1-41.3c23.7-10,49.4-14.1,75.4-14.1c25.9,0,50.5,4,74.2,14.1c12.7,5.4,24.7,12.1,35.9,20c-2.1,4.5-3.3,9.5-3.3,14.9\r\n\t\tc0,19.2,15.6,34.9,34.8,34.9c5.3,0,10.3-1.2,14.9-3.3c7.9,11.2,14.6,23.2,20,36c10,23.7,15.1,48.9,15.1,74.9\r\n\t\tc0,25.9-5.1,51.2-15.1,74.9C423.3,353.4,409.5,374,391.8,391.7z"},"children":[{"name":"path","attribs":{"d":"M425.5,134.8c4.7-5.9,7.5-13.5,7.5-21.6c0-19.2-15.6-34.9-34.8-34.9c-8.2,0-15.7,2.8-21.6,7.5c-34-24.2-75-37.8-119.9-37.8\r\n\t\tC141.8,48,48,140.5,48,255.6C48,370.7,141.7,464,256.6,464C371.5,464,464,370.7,464,255.6C464,210.6,449.7,168.9,425.5,134.8z\r\n\t\t M398,91.3c12.2,0,22,9.9,22,22c0,12.2-9.9,22-22,22c-12.2,0-22-9.9-22-22C376,101.2,385.8,91.3,398,91.3z M391.8,391.7\r\n\t\tc-17.6,17.6-38.2,31.6-61.1,41.3c-23.7,10-48.2,15.2-74.2,15.2c-25.9,0-51.7-5.1-75.4-15.2c-22.9-9.7-43.4-23.5-61.1-41.3\r\n\t\tc-17.6-17.6-31.5-38.3-41.2-61.2c-10-23.7-15.1-48.9-15.1-74.9c0-25.9,5.1-51.2,15.1-74.9c9.7-22.9,23.5-43.5,41.2-61.2\r\n\t\ts38.2-31.6,61.1-41.3c23.7-10,49.4-14.1,75.4-14.1c25.9,0,50.5,4,74.2,14.1c12.7,5.4,24.7,12.1,35.9,20c-2.1,4.5-3.3,9.5-3.3,14.9\r\n\t\tc0,19.2,15.6,34.9,34.8,34.9c5.3,0,10.3-1.2,14.9-3.3c7.9,11.2,14.6,23.2,20,36c10,23.7,15.1,48.9,15.1,74.9\r\n\t\tc0,25.9-5.1,51.2-15.1,74.9C423.3,353.4,409.5,374,391.8,391.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.5,160.1c-53,0-96,42.8-96,95.9s42.9,96.1,96,96.1c53,0,96-43,96-96.1S309.5,160.1,256.5,160.1z M256.5,335.8\r\n\t\tc-44.1,0-79.7-35.8-79.7-79.8c0-44.1,35.6-79.6,79.7-79.6s79.7,35.6,79.7,79.6C336.2,300.1,300.5,335.8,256.5,335.8z"},"children":[{"name":"path","attribs":{"d":"M256.5,160.1c-53,0-96,42.8-96,95.9s42.9,96.1,96,96.1c53,0,96-43,96-96.1S309.5,160.1,256.5,160.1z M256.5,335.8\r\n\t\tc-44.1,0-79.7-35.8-79.7-79.8c0-44.1,35.6-79.6,79.7-79.6s79.7,35.6,79.7,79.6C336.2,300.1,300.5,335.8,256.5,335.8z"},"children":[]}]}]}]};exports.iosIonicOutline=iosIonicOutline;var iosKeypadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M394.6,341.2c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,341.2,394.6,341.2z\r\n\t\t M394.6,432c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C432,415.2,415.2,432,394.6,432z"},"children":[{"name":"path","attribs":{"d":"M394.6,341.2c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,341.2,394.6,341.2z\r\n\t\t M394.6,432c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C432,415.2,415.2,432,394.6,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,341.2c-29.5,0-53.4,23.9-53.4,53.4S226.5,448,256,448c29.5,0,53.4-23.9,53.4-53.4S285.5,341.2,256,341.2z M256,432\r\n\t\tc-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,415.2,276.6,432,256,432z"},"children":[{"name":"path","attribs":{"d":"M256,341.2c-29.5,0-53.4,23.9-53.4,53.4S226.5,448,256,448c29.5,0,53.4-23.9,53.4-53.4S285.5,341.2,256,341.2z M256,432\r\n\t\tc-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,415.2,276.6,432,256,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,341.2c-29.5,0-53.4,23.9-53.4,53.4S87.9,448,117.4,448c29.5,0,53.4-23.9,53.4-53.4S146.9,341.2,117.4,341.2z\r\n\t\t M117.4,432C96.8,432,80,415.2,80,394.6c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C154.8,415.2,138.1,432,117.4,432z"},"children":[{"name":"path","attribs":{"d":"M117.4,341.2c-29.5,0-53.4,23.9-53.4,53.4S87.9,448,117.4,448c29.5,0,53.4-23.9,53.4-53.4S146.9,341.2,117.4,341.2z\r\n\t\t M117.4,432C96.8,432,80,415.2,80,394.6c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C154.8,415.2,138.1,432,117.4,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M394.6,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,202.6,394.6,202.6z\r\n\t\t M394.6,293.4c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4S432,235.4,432,256C432,276.6,415.2,293.4,394.6,293.4z"},"children":[{"name":"path","attribs":{"d":"M394.6,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,202.6,394.6,202.6z\r\n\t\t M394.6,293.4c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4S432,235.4,432,256C432,276.6,415.2,293.4,394.6,293.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S285.5,202.6,256,202.6z\r\n\t\t M256,293.4c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,276.6,276.6,293.4,256,293.4z"},"children":[{"name":"path","attribs":{"d":"M256,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S285.5,202.6,256,202.6z\r\n\t\t M256,293.4c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,276.6,276.6,293.4,256,293.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,202.6C87.9,202.6,64,226.5,64,256s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S146.9,202.6,117.4,202.6z\r\n\t\t M117.4,293.4C96.8,293.4,80,276.6,80,256c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C154.8,276.6,138.1,293.4,117.4,293.4z"},"children":[{"name":"path","attribs":{"d":"M117.4,202.6C87.9,202.6,64,226.5,64,256s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S146.9,202.6,117.4,202.6z\r\n\t\t M117.4,293.4C96.8,293.4,80,276.6,80,256c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C154.8,276.6,138.1,293.4,117.4,293.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M394.6,170.8c29.5,0,53.4-23.9,53.4-53.4c0-29.5-23.9-53.4-53.4-53.4c-29.5,0-53.4,23.9-53.4,53.4\r\n\t\tC341.2,146.9,365.1,170.8,394.6,170.8z M394.6,80c20.6,0,37.4,16.8,37.4,37.4c0,20.6-16.8,37.4-37.4,37.4s-37.4-16.8-37.4-37.4\r\n\t\tC357.2,96.8,373.9,80,394.6,80z"},"children":[{"name":"path","attribs":{"d":"M394.6,170.8c29.5,0,53.4-23.9,53.4-53.4c0-29.5-23.9-53.4-53.4-53.4c-29.5,0-53.4,23.9-53.4,53.4\r\n\t\tC341.2,146.9,365.1,170.8,394.6,170.8z M394.6,80c20.6,0,37.4,16.8,37.4,37.4c0,20.6-16.8,37.4-37.4,37.4s-37.4-16.8-37.4-37.4\r\n\t\tC357.2,96.8,373.9,80,394.6,80z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64c-29.5,0-53.4,23.9-53.4,53.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C309.4,87.9,285.5,64,256,64z\r\n\t\t M256,154.8c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,138,276.6,154.8,256,154.8z"},"children":[{"name":"path","attribs":{"d":"M256,64c-29.5,0-53.4,23.9-53.4,53.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C309.4,87.9,285.5,64,256,64z\r\n\t\t M256,154.8c-20.6,0-37.4-16.8-37.4-37.4c0-20.6,16.8-37.4,37.4-37.4s37.4,16.8,37.4,37.4C293.4,138,276.6,154.8,256,154.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,64C87.9,64,64,87.9,64,117.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C170.8,87.9,146.9,64,117.4,64z\r\n\t\t M117.4,154.8C96.8,154.8,80,138,80,117.4C80,96.8,96.8,80,117.4,80s37.4,16.8,37.4,37.4C154.8,138,138.1,154.8,117.4,154.8z"},"children":[{"name":"path","attribs":{"d":"M117.4,64C87.9,64,64,87.9,64,117.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C170.8,87.9,146.9,64,117.4,64z\r\n\t\t M117.4,154.8C96.8,154.8,80,138,80,117.4C80,96.8,96.8,80,117.4,80s37.4,16.8,37.4,37.4C154.8,138,138.1,154.8,117.4,154.8z"},"children":[]}]}]}]};exports.iosKeypadOutline=iosKeypadOutline;var iosKeypad={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M394.6,341.2c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,341.2,394.6,341.2z"},"children":[{"name":"path","attribs":{"d":"M394.6,341.2c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,341.2,394.6,341.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,341.2c-29.5,0-53.4,23.9-53.4,53.4S226.5,448,256,448c29.5,0,53.4-23.9,53.4-53.4S285.5,341.2,256,341.2z"},"children":[{"name":"path","attribs":{"d":"M256,341.2c-29.5,0-53.4,23.9-53.4,53.4S226.5,448,256,448c29.5,0,53.4-23.9,53.4-53.4S285.5,341.2,256,341.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,341.2c-29.5,0-53.4,23.9-53.4,53.4S87.9,448,117.4,448c29.5,0,53.4-23.9,53.4-53.4S146.9,341.2,117.4,341.2z"},"children":[{"name":"path","attribs":{"d":"M117.4,341.2c-29.5,0-53.4,23.9-53.4,53.4S87.9,448,117.4,448c29.5,0,53.4-23.9,53.4-53.4S146.9,341.2,117.4,341.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M394.6,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,202.6,394.6,202.6z"},"children":[{"name":"path","attribs":{"d":"M394.6,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S424.1,202.6,394.6,202.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S285.5,202.6,256,202.6z"},"children":[{"name":"path","attribs":{"d":"M256,202.6c-29.5,0-53.4,23.9-53.4,53.4s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S285.5,202.6,256,202.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,202.6C87.9,202.6,64,226.5,64,256s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S146.9,202.6,117.4,202.6z"},"children":[{"name":"path","attribs":{"d":"M117.4,202.6C87.9,202.6,64,226.5,64,256s23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4S146.9,202.6,117.4,202.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M394.6,170.8c29.5,0,53.4-23.9,53.4-53.4c0-29.5-23.9-53.4-53.4-53.4c-29.5,0-53.4,23.9-53.4,53.4\r\n\t\tC341.2,146.9,365.1,170.8,394.6,170.8z"},"children":[{"name":"path","attribs":{"d":"M394.6,170.8c29.5,0,53.4-23.9,53.4-53.4c0-29.5-23.9-53.4-53.4-53.4c-29.5,0-53.4,23.9-53.4,53.4\r\n\t\tC341.2,146.9,365.1,170.8,394.6,170.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64c-29.5,0-53.4,23.9-53.4,53.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C309.4,87.9,285.5,64,256,64z"},"children":[{"name":"path","attribs":{"d":"M256,64c-29.5,0-53.4,23.9-53.4,53.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C309.4,87.9,285.5,64,256,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M117.4,64C87.9,64,64,87.9,64,117.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C170.8,87.9,146.9,64,117.4,64z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M117.4,64C87.9,64,64,87.9,64,117.4c0,29.5,23.9,53.4,53.4,53.4c29.5,0,53.4-23.9,53.4-53.4C170.8,87.9,146.9,64,117.4,64z\r\n\t\t"},"children":[]}]}]}]};exports.iosKeypad=iosKeypad;var iosLightbulbOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M400,172.9C400,95.1,333.9,32,256,32c-77.9,0-144,63.1-144,141c0,31,13.2,59,30.2,83h-0.3c10.9,15,21.4,27.7,31.5,45\r\n\t\tc22,37.8,18.6,74.3,18.7,81.6v1.4h128v-1.4c0-8.9-3.6-43.8,18.4-81.6c10.1-17.3,20.6-30,31.5-45h-0.1C386.8,232,400,204,400,172.9z\r\n\t\t M351,254.4c-0.6,0.8-1.1,1.5-1.7,2.3c-8.1,10.9-16.5,22.2-24.7,36.1c-17.3,29.7-20.4,57.9-20.8,75.1H288V256l32-64h-16.6L272,256\r\n\t\tv112h-32V256l-31.4-64H192l32,64v112h-15.9c-0.5-17.2-3.9-45.7-20.9-75c-4.5-7.7-9.1-15-13.7-21h0.2l-18.6-25.6\r\n\t\tc-15.8-21.6-27.1-47.1-27.1-73.6c0-33.4,16-64.8,39.6-88.4s55-36.7,88.4-36.7c33.4,0,64.8,13.1,88.4,36.7\r\n\t\tc23.6,23.6,39.6,55,39.6,88.4c0,26.5-11.3,51.9-27.1,73.5L351,254.4z"},"children":[{"name":"path","attribs":{"d":"M400,172.9C400,95.1,333.9,32,256,32c-77.9,0-144,63.1-144,141c0,31,13.2,59,30.2,83h-0.3c10.9,15,21.4,27.7,31.5,45\r\n\t\tc22,37.8,18.6,74.3,18.7,81.6v1.4h128v-1.4c0-8.9-3.6-43.8,18.4-81.6c10.1-17.3,20.6-30,31.5-45h-0.1C386.8,232,400,204,400,172.9z\r\n\t\t M351,254.4c-0.6,0.8-1.1,1.5-1.7,2.3c-8.1,10.9-16.5,22.2-24.7,36.1c-17.3,29.7-20.4,57.9-20.8,75.1H288V256l32-64h-16.6L272,256\r\n\t\tv112h-32V256l-31.4-64H192l32,64v112h-15.9c-0.5-17.2-3.9-45.7-20.9-75c-4.5-7.7-9.1-15-13.7-21h0.2l-18.6-25.6\r\n\t\tc-15.8-21.6-27.1-47.1-27.1-73.6c0-33.4,16-64.8,39.6-88.4s55-36.7,88.4-36.7c33.4,0,64.8,13.1,88.4,36.7\r\n\t\tc23.6,23.6,39.6,55,39.6,88.4c0,26.5-11.3,51.9-27.1,73.5L351,254.4z"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"464","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"224","y":"464","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"432","width":"96","height":"16"},"children":[{"name":"rect","attribs":{"x":"208","y":"432","width":"96","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"400","width":"96","height":"16"},"children":[{"name":"rect","attribs":{"x":"208","y":"400","width":"96","height":"16"},"children":[]}]}]}]};exports.iosLightbulbOutline=iosLightbulbOutline;var iosLightbulb={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M400,172.9C400,95.1,333.9,32,256,32c-77.9,0-144,63.1-144,141c0,31,13.2,59,30.2,83h-0.3c10.9,15,21.4,27.7,31.5,45\r\n\t\t\tc22,37.8,18.6,74.3,18.7,81.6v1.4h32V256l-32-64h16.6l31.4,64v128h32V256l31.4-64H320l-32,64v128h32v-1.4\r\n\t\t\tc0-8.9-3.6-43.8,18.4-81.6c10.1-17.3,20.6-30,31.5-45h-0.1C386.8,232,400,204,400,172.9z"},"children":[{"name":"path","attribs":{"d":"M400,172.9C400,95.1,333.9,32,256,32c-77.9,0-144,63.1-144,141c0,31,13.2,59,30.2,83h-0.3c10.9,15,21.4,27.7,31.5,45\r\n\t\t\tc22,37.8,18.6,74.3,18.7,81.6v1.4h32V256l-32-64h16.6l31.4,64v128h32V256l31.4-64H320l-32,64v128h32v-1.4\r\n\t\t\tc0-8.9-3.6-43.8,18.4-81.6c10.1-17.3,20.6-30,31.5-45h-0.1C386.8,232,400,204,400,172.9z"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"224","y":"464","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"224","y":"464","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"432","width":"96","height":"16"},"children":[{"name":"rect","attribs":{"x":"208","y":"432","width":"96","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"400","width":"96","height":"16"},"children":[{"name":"rect","attribs":{"x":"208","y":"400","width":"96","height":"16"},"children":[]}]}]}]};exports.iosLightbulb=iosLightbulb;var iosListOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M432,80v352H80V80H432 M448,64H64v384h384V64L448,64z"},"children":[{"name":"path","attribs":{"d":"M432,80v352H80V80H432 M448,64H64v384h384V64L448,64z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"192","y":"152","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"152","width":"192","height":"16"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"192","y":"248","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"248","width":"192","height":"16"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"192","y":"344","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"344","width":"192","height":"16"},"children":[]}]}]}]}]}]},{"name":"circle","attribs":{"cx":"144","cy":"160","r":"16"},"children":[{"name":"circle","attribs":{"cx":"144","cy":"160","r":"16"},"children":[]}]},{"name":"circle","attribs":{"cx":"144","cy":"256","r":"16"},"children":[{"name":"circle","attribs":{"cx":"144","cy":"256","r":"16"},"children":[]}]},{"name":"circle","attribs":{"cx":"144","cy":"352","r":"16"},"children":[{"name":"circle","attribs":{"cx":"144","cy":"352","r":"16"},"children":[]}]}]}]};exports.iosListOutline=iosListOutline;var iosList={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M144,368c-8.836,0-16-7.164-16-16s7.164-16,16-16s16,7.164,16,16S152.836,368,144,368z M144,272\r\n\t\tc-8.836,0-16-7.164-16-16s7.164-16,16-16s16,7.164,16,16S152.836,272,144,272z M144,176c-8.836,0-16-7.164-16-16s7.164-16,16-16\r\n\t\ts16,7.164,16,16S152.836,176,144,176z M384,360H192v-16h192V360z M384,264H192v-16h192V264z M384,168H192v-16h192V168z"},"children":[{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M144,368c-8.836,0-16-7.164-16-16s7.164-16,16-16s16,7.164,16,16S152.836,368,144,368z M144,272\r\n\t\tc-8.836,0-16-7.164-16-16s7.164-16,16-16s16,7.164,16,16S152.836,272,144,272z M144,176c-8.836,0-16-7.164-16-16s7.164-16,16-16\r\n\t\ts16,7.164,16,16S152.836,176,144,176z M384,360H192v-16h192V360z M384,264H192v-16h192V264z M384,168H192v-16h192V168z"},"children":[]}]}]}]};exports.iosList=iosList;var iosLocationOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48c34.19,0,66.334,13.314,90.51,37.49S384,141.81,384,176c0,42.92-24.092,107.127-69.67,185.68\r\n\t\tc-22.279,38.396-44.771,71.634-58.332,90.931c-13.518-19.232-35.912-52.327-58.161-90.645C152.149,283.281,128,218.976,128,176\r\n\t\tc0-34.19,13.314-66.334,37.49-90.51S221.81,48,256,48 M256,32c-79.529,0-144,64.471-144,144c0,112,144,304,144,304s144-192,144-304\r\n\t\tC400,96.471,335.529,32,256,32L256,32z"},"children":[{"name":"path","attribs":{"d":"M256,48c34.19,0,66.334,13.314,90.51,37.49S384,141.81,384,176c0,42.92-24.092,107.127-69.67,185.68\r\n\t\tc-22.279,38.396-44.771,71.634-58.332,90.931c-13.518-19.232-35.912-52.327-58.161-90.645C152.149,283.281,128,218.976,128,176\r\n\t\tc0-34.19,13.314-66.334,37.49-90.51S221.81,48,256,48 M256,32c-79.529,0-144,64.471-144,144c0,112,144,304,144,304s144-192,144-304\r\n\t\tC400,96.471,335.529,32,256,32L256,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,112c-35.3,0-64,28.7-64,64s28.7,64,64,64s64-28.7,64-64S291.3,112,256,112z M256,222.9c-25.9,0-46.9-21-46.9-46.9\r\n\t\ts21-46.9,46.9-46.9s46.9,21,46.9,46.9S281.9,222.9,256,222.9z"},"children":[{"name":"path","attribs":{"d":"M256,112c-35.3,0-64,28.7-64,64s28.7,64,64,64s64-28.7,64-64S291.3,112,256,112z M256,222.9c-25.9,0-46.9-21-46.9-46.9\r\n\t\ts21-46.9,46.9-46.9s46.9,21,46.9,46.9S281.9,222.9,256,222.9z"},"children":[]}]}]}]};exports.iosLocationOutline=iosLocationOutline;var iosLocation={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32c-79.529,0-144,64.471-144,144c0,112,144,304,144,304s144-192,144-304C400,96.471,335.529,32,256,32z M256,222.9\r\n\tc-25.9,0-46.9-21-46.9-46.9s21-46.9,46.9-46.9s46.9,21,46.9,46.9S281.9,222.9,256,222.9z"},"children":[]}]};exports.iosLocation=iosLocation;var iosLockedOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M360,224v-72c0-57.43-46.562-104-103.984-104C198.562,48,152,94.57,152,152v72H96v240h320V224H360z M168,152\r\n\t\t\tc0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v72H168V152z M400,448H112V240h288V448z"},"children":[{"name":"path","attribs":{"d":"M360,224v-72c0-57.43-46.562-104-103.984-104C198.562,48,152,94.57,152,152v72H96v240h320V224H360z M168,152\r\n\t\t\tc0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v72H168V152z M400,448H112V240h288V448z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M256,288c-17.673,0-32,14.327-32,32c0,14.91,10.198,27.439,24,30.992V384h16v-33.008c13.802-3.553,24-16.082,24-30.992\r\n\t\tC288,302.327,273.673,288,256,288z M256,336c-8.822,0-16-7.178-16-16s7.178-16,16-16s16,7.178,16,16S264.822,336,256,336z"},"children":[{"name":"path","attribs":{"d":"M256,288c-17.673,0-32,14.327-32,32c0,14.91,10.198,27.439,24,30.992V384h16v-33.008c13.802-3.553,24-16.082,24-30.992\r\n\t\tC288,302.327,273.673,288,256,288z M256,336c-8.822,0-16-7.178-16-16s7.178-16,16-16s16,7.178,16,16S264.822,336,256,336z"},"children":[]}]}]}]};exports.iosLockedOutline=iosLockedOutline;var iosLocked={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M360,224v-72c0-57.43-46.562-104-103.984-104C198.562,48,152,94.57,152,152v72H96v240h320V224H360z M264,350.992V384h-16\r\n\t\tv-33.008c-13.802-3.553-24-16.082-24-30.992c0-17.673,14.327-32,32-32s32,14.327,32,32C288,334.91,277.802,347.439,264,350.992z\r\n\t\t M344,224H168v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152V224z"},"children":[{"name":"path","attribs":{"d":"M360,224v-72c0-57.43-46.562-104-103.984-104C198.562,48,152,94.57,152,152v72H96v240h320V224H360z M264,350.992V384h-16\r\n\t\tv-33.008c-13.802-3.553-24-16.082-24-30.992c0-17.673,14.327-32,32-32s32,14.327,32,32C288,334.91,277.802,347.439,264,350.992z\r\n\t\t M344,224H168v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152V224z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,304c-8.822,0-16,7.178-16,16s7.178,16,16,16s16-7.178,16-16S264.822,304,256,304z"},"children":[{"name":"path","attribs":{"d":"M256,304c-8.822,0-16,7.178-16,16s7.178,16,16,16s16-7.178,16-16S264.822,304,256,304z"},"children":[]}]}]}]};exports.iosLocked=iosLocked;var iosLoopStrong={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48c-75.033,0-144.531,40.658-181.373,106.107l-1.963,3.485l20.915,11.771l1.962-3.485\r\n\t\t\tC128.138,107.973,189.621,72,256,72c101.458,0,184,82.542,184,184c0,12.509-1.262,25.007-3.749,37.147l-0.803,3.918l23.511,4.819\r\n\t\t\tl0.804-3.919C462.574,284.244,464,270.125,464,256C464,141.309,370.691,48,256,48z"},"children":[{"name":"path","attribs":{"d":"M256,48c-75.033,0-144.531,40.658-181.373,106.107l-1.963,3.485l20.915,11.771l1.962-3.485\r\n\t\t\tC128.138,107.973,189.621,72,256,72c101.458,0,184,82.542,184,184c0,12.509-1.262,25.007-3.749,37.147l-0.803,3.918l23.511,4.819\r\n\t\t\tl0.804-3.919C462.574,284.244,464,270.125,464,256C464,141.309,370.691,48,256,48z"},"children":[]}]},{"name":"path","attribs":{"d":"M416.459,346.119C383.862,404.027,322.379,440,256,440c-101.458,0-184-82.542-184-184c0-12.512,1.262-25.011,3.75-37.15\r\n\t\t\tl0.803-3.918l-23.511-4.819l-0.804,3.918C49.426,227.75,48,241.87,48,256c0,114.691,93.309,208,208,208\r\n\t\t\tc75.033,0,144.531-40.658,181.373-106.109l1.963-3.485l-20.915-11.771L416.459,346.119z"},"children":[{"name":"path","attribs":{"d":"M416.459,346.119C383.862,404.027,322.379,440,256,440c-101.458,0-184-82.542-184-184c0-12.512,1.262-25.011,3.75-37.15\r\n\t\t\tl0.803-3.918l-23.511-4.819l-0.804,3.918C49.426,227.75,48,241.87,48,256c0,114.691,93.309,208,208,208\r\n\t\t\tc75.033,0,144.531-40.658,181.373-106.109l1.963-3.485l-20.915-11.771L416.459,346.119z"},"children":[]}]}]}]},{"name":"polygon","attribs":{"points":"384,256 448,320 512,256 \t"},"children":[{"name":"polygon","attribs":{"points":"384,256 448,320 512,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"0,256 64,192 128,256 \t"},"children":[{"name":"polygon","attribs":{"points":"0,256 64,192 128,256 \t"},"children":[]}]}]}]};exports.iosLoopStrong=iosLoopStrong;var iosLoop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"489.373,256 448,297.373 405.627,256 394.813,266.813 448,320 500.687,267.313 \t"},"children":[{"name":"polygon","attribs":{"points":"489.373,256 448,297.373 405.627,256 394.813,266.813 448,320 500.687,267.313 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M459.994,255.509c-0.002-0.577,0.013-1.157,0.007-1.733l-0.029-0.003C458.771,142.311,367.742,52,256,52\r\n\t\t\tc-73.59,0-141.753,39.878-177.888,104.071l13.943,7.848C125.359,104.754,188.18,68,256,68\r\n\t\t\tc103.273,0,187.355,83.708,187.985,186.836c0.038,6.882-0.281,13.83-1.017,20.831l15.912,1.674\r\n\t\t\tc0.755-7.168,1.105-14.286,1.111-21.341H460C460,255.836,459.994,255.673,459.994,255.509z"},"children":[{"name":"path","attribs":{"d":"M459.994,255.509c-0.002-0.577,0.013-1.157,0.007-1.733l-0.029-0.003C458.771,142.311,367.742,52,256,52\r\n\t\t\tc-73.59,0-141.753,39.878-177.888,104.071l13.943,7.848C125.359,104.754,188.18,68,256,68\r\n\t\t\tc103.273,0,187.355,83.708,187.985,186.836c0.038,6.882-0.281,13.83-1.017,20.831l15.912,1.674\r\n\t\t\tc0.755-7.168,1.105-14.286,1.111-21.341H460C460,255.836,459.994,255.673,459.994,255.509z"},"children":[]}]},{"name":"path","attribs":{"d":"M419.944,348.081C386.641,407.246,323.82,444,256,444c-103.475,0-187.688-84.032-187.993-187.437\r\n\t\t\tc-0.015-6.686,0.31-13.434,1.024-20.23l-15.912-1.674c-0.754,7.168-1.104,14.286-1.108,21.341H52c0,0.472,0.015,0.939,0.018,1.41\r\n\t\t\tc0.006,0.975-0.006,1.952,0.015,2.924l0.022-0.003C54.369,370.825,144.962,460,256,460c73.59,0,141.753-39.878,177.888-104.071\r\n\t\t\tL419.944,348.081z"},"children":[{"name":"path","attribs":{"d":"M419.944,348.081C386.641,407.246,323.82,444,256,444c-103.475,0-187.688-84.032-187.993-187.437\r\n\t\t\tc-0.015-6.686,0.31-13.434,1.024-20.23l-15.912-1.674c-0.754,7.168-1.104,14.286-1.108,21.341H52c0,0.472,0.015,0.939,0.018,1.41\r\n\t\t\tc0.006,0.975-0.006,1.952,0.015,2.924l0.022-0.003C54.369,370.825,144.962,460,256,460c73.59,0,141.753-39.878,177.888-104.071\r\n\t\t\tL419.944,348.081z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"64,192 11.313,244.687 22.627,256 64,214.627 105.373,256 116.687,244.687 \t\t\t"},"children":[{"name":"polygon","attribs":{"points":"64,192 11.313,244.687 22.627,256 64,214.627 105.373,256 116.687,244.687 \t\t\t"},"children":[]}]}]}]}]}]}]}]};exports.iosLoop=iosLoop;var iosMedicalOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M438,187.713l-31.927-55.426L288,200.574V64h-64v136.574l-118.073-68.287l-31.938,55.426L192.092,256L73.998,324.287\r\n\tl31.928,55.426L224,311.426V448h64V311.426l118.072,68.287l31.939-55.426L319.908,256L438,187.713z M416.176,330.125l-15.963,27.866\r\n\tL272,284v148h-32V284l-128.213,74l-15.969-27.785l128.228-74.197L95.822,181.861l15.964-27.859L240,228V80h32v148l128.213-74\r\n\tl15.969,27.785l-128.228,74.179L416.176,330.125z"},"children":[]}]};exports.iosMedicalOutline=iosMedicalOutline;var iosMedical={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M438,187.713l-31.927-55.426L288,200.574V64h-64v136.574l-118.073-68.287l-31.938,55.426L192.092,256L73.998,324.287\r\n\tl31.928,55.426L224,311.426V448h64V311.426l118.072,68.287l31.939-55.426L319.908,256L438,187.713z"},"children":[]}]};exports.iosMedical=iosMedical;var iosMedkitOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M272,208v48v16h16h48v32h-48h-16v16v48h-32v-48v-16h-16h-48v-32h48h16v-16v-48H272 M288,192h-64v64h-64v64h64v64h64v-64\r\n\t\t\th64v-64h-64V192L288,192z"},"children":[{"name":"path","attribs":{"d":"M272,208v48v16h16h48v32h-48h-16v16v48h-32v-48v-16h-16h-48v-32h48h16v-16v-48H272 M288,192h-64v64h-64v64h64v64h64v-64\r\n\t\t\th64v-64h-64V192L288,192z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M336,128V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v32H48v320h416V128H336z M192,98.1\r\n\t\tc0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V128H192V98.1z M448,432H64V144h384V432z"},"children":[{"name":"path","attribs":{"d":"M336,128V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v32H48v320h416V128H336z M192,98.1\r\n\t\tc0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V128H192V98.1z M448,432H64V144h384V432z"},"children":[]}]}]}]};exports.iosMedkitOutline=iosMedkitOutline;var iosMedkit={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"272,272 272,256 272,208 240,208 240,256 240,272 224,272 176,272 176,304 224,304 240,304 240,320 240,368 \r\n\t\t272,368 272,320 272,304 288,304 336,304 336,272 288,272 \t"},"children":[{"name":"polygon","attribs":{"points":"272,272 272,256 272,208 240,208 240,256 240,272 224,272 176,272 176,304 224,304 240,304 240,320 240,368 \r\n\t\t272,368 272,320 272,304 288,304 336,304 336,272 288,272 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M336,128V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v32H48v320h416V128H336z M192,98.1\r\n\t\tc0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V128H192V98.1z M352,320h-64v64h-64v-64h-64v-64h64v-64h64v64h64V320z"},"children":[{"name":"path","attribs":{"d":"M336,128V96c-0.5-18.2-13.6-32-32.2-32h-99.1C186.1,64,176,77.7,176,96v32H48v320h416V128H336z M192,98.1\r\n\t\tc0-10.2,2.9-18.1,13.7-18.1h97.1c10.4,0,17.2,7.7,17.2,18.1V128H192V98.1z M352,320h-64v64h-64v-64h-64v-64h64v-64h64v64h64V320z"},"children":[]}]}]}]};exports.iosMedkit=iosMedkit;var iosMicOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"264.2","y":"1.1","transform":"matrix(0.8629 -0.5053 0.5053 0.8629 -92.0515 172.66)","width":"16","height":"509.8"},"children":[{"name":"rect","attribs":{"x":"264.2","y":"1.1","transform":"matrix(0.8629 -0.5053 0.5053 0.8629 -92.0515 172.66)","width":"16","height":"509.8"},"children":[]}]},{"name":"path","attribs":{"d":"M256.2,353.4c12.3,0,23.8-2.9,34.2-8.2L177,152.4V270C177,316,212.4,353.4,256.2,353.4z"},"children":[{"name":"path","attribs":{"d":"M256.2,353.4c12.3,0,23.8-2.9,34.2-8.2L177,152.4V270C177,316,212.4,353.4,256.2,353.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M335,270V115.5c0-46-35.2-83.5-79-83.5c-25.4,0-47.8,12.6-62.3,32.2l136.9,233.3C333.5,288.9,335,279.6,335,270z"},"children":[{"name":"path","attribs":{"d":"M335,270V115.5c0-46-35.2-83.5-79-83.5c-25.4,0-47.8,12.6-62.3,32.2l136.9,233.3C333.5,288.9,335,279.6,335,270z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,271.7V192h-17v79.7c0,21.5-6.2,41.6-17.1,58.5l9.9,17C375.1,326,384,299.9,384,271.7z"},"children":[{"name":"path","attribs":{"d":"M384,271.7V192h-17v79.7c0,21.5-6.2,41.6-17.1,58.5l9.9,17C375.1,326,384,299.9,384,271.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M267,399.2c17-1.2,33-5.8,47.3-13l-9.4-16.1c-14.5,7-30.7,10.9-47.7,10.9c-60.3,0-110.1-49-110.1-109.1V192h-19v79.7\r\n\t\tc0,67.2,53,122.6,120,127.4V462h-73v18h161v-18h-69V399.2z"},"children":[{"name":"path","attribs":{"d":"M267,399.2c17-1.2,33-5.8,47.3-13l-9.4-16.1c-14.5,7-30.7,10.9-47.7,10.9c-60.3,0-110.1-49-110.1-109.1V192h-19v79.7\r\n\t\tc0,67.2,53,122.6,120,127.4V462h-73v18h161v-18h-69V399.2z"},"children":[]}]}]}]};exports.iosMicOff=iosMicOff;var iosMicOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32c-43.7,0-79,37.5-79,83.5V270c0,46,35.3,83.5,79,83.5c43.7,0,79-37.5,79-83.5V115.5C335,69.5,299.7,32,256,32z\r\n\t\t M319,270c0,37.2-28.3,67.5-63,67.5c-34.7,0-63-30.3-63-67.5V115.5c0-37.2,28.3-67.5,63-67.5c34.7,0,63,30.3,63,67.5V270z"},"children":[{"name":"path","attribs":{"d":"M256,32c-43.7,0-79,37.5-79,83.5V270c0,46,35.3,83.5,79,83.5c43.7,0,79-37.5,79-83.5V115.5C335,69.5,299.7,32,256,32z\r\n\t\t M319,270c0,37.2-28.3,67.5-63,67.5c-34.7,0-63-30.3-63-67.5V115.5c0-37.2,28.3-67.5,63-67.5c34.7,0,63,30.3,63,67.5V270z"},"children":[]}]},{"name":"path","attribs":{"d":"M367,192v79.7c0,60.2-49.8,109.2-110,109.2c-60.2,0-110-49-110-109.2V192h-19v79.7c0,67.2,53,122.6,120,127.5V462h-73v18\r\n\t\th161v-18h-69v-62.8c66-4.9,117-60.3,117-127.5V192H367z"},"children":[{"name":"path","attribs":{"d":"M367,192v79.7c0,60.2-49.8,109.2-110,109.2c-60.2,0-110-49-110-109.2V192h-19v79.7c0,67.2,53,122.6,120,127.5V462h-73v18\r\n\t\th161v-18h-69v-62.8c66-4.9,117-60.3,117-127.5V192H367z"},"children":[]}]}]}]};exports.iosMicOutline=iosMicOutline;var iosMic={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,353.5c43.7,0,79-37.5,79-83.5V115.5c0-46-35.3-83.5-79-83.5c-43.7,0-79,37.5-79,83.5V270\r\n\t\tC177,316,212.3,353.5,256,353.5z"},"children":[{"name":"path","attribs":{"d":"M256,353.5c43.7,0,79-37.5,79-83.5V115.5c0-46-35.3-83.5-79-83.5c-43.7,0-79,37.5-79,83.5V270\r\n\t\tC177,316,212.3,353.5,256,353.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M367,192v79.7c0,60.2-49.8,109.2-110,109.2c-60.2,0-110-49-110-109.2V192h-19v79.7c0,67.2,53,122.6,120,127.5V462h-73v18\r\n\t\th161v-18h-69v-62.8c66-4.9,117-60.3,117-127.5V192H367z"},"children":[{"name":"path","attribs":{"d":"M367,192v79.7c0,60.2-49.8,109.2-110,109.2c-60.2,0-110-49-110-109.2V192h-19v79.7c0,67.2,53,122.6,120,127.5V462h-73v18\r\n\t\th161v-18h-69v-62.8c66-4.9,117-60.3,117-127.5V192H367z"},"children":[]}]}]}]};exports.iosMic=iosMic;var iosMinusEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,265H128v-17h256V265z"},"children":[{"name":"path","attribs":{"d":"M384,265H128v-17h256V265z"},"children":[]}]}]}]};exports.iosMinusEmpty=iosMinusEmpty;var iosMinusOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]},{"name":"rect","attribs":{"x":"128","y":"248","width":"256","height":"17"},"children":[{"name":"rect","attribs":{"x":"128","y":"248","width":"256","height":"17"},"children":[]}]}]}]};exports.iosMinusOutline=iosMinusOutline;var iosMinus={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M384,265H128v-17h256V265z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M384,265H128v-17h256V265z"},"children":[]}]}]}]};exports.iosMinus=iosMinus;var iosMonitorOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M496,384V96H16v288h175v16h-64v16h257v-16h-64v-16H496z M32,112h448v256H32V112z"},"children":[]}]};exports.iosMonitorOutline=iosMonitorOutline;var iosMonitor={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M496,384V96H16v288h175v16h-64v16h257v-16h-64v-16H496z M32,112h448v256H32V112z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"48","y":"128","width":"416","height":"224"},"children":[{"name":"rect","attribs":{"x":"48","y":"128","width":"416","height":"224"},"children":[]}]}]}]};exports.iosMonitor=iosMonitor;var iosMoonOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M343.1,315c-1.8,0.1-3.5,0.1-5.3,0.1c-29.1,0-56.5-11.3-77.1-31.9c-20.6-20.6-31.9-48-31.9-77.1\r\n\t\t\tc0-16.6,3.7-32.6,10.6-47.1c3.1-6.4,6.8-12.5,11.1-18.2c-7.6,0.8-14.9,2.4-22,4.6c-46.8,14.8-80.7,58.5-80.7,110.2\r\n\t\t\tc0,63.8,51.7,115.5,115.5,115.5c35.3,0,66.8-15.8,88-40.7c4.8-5.7,9.2-11.9,12.8-18.5C357.3,313.6,350.3,314.7,343.1,315z\r\n\t\t\t M263.3,355.1c-54.9,0-99.5-44.6-99.5-99.5c0-39.1,22.6-72.9,55.4-89.2c-4.2,12.5-6.4,25.8-6.4,39.7c0,65.9,51,119.9,115.6,124.7\r\n\t\t\tC311,346,288.2,355.1,263.3,355.1z"},"children":[{"name":"path","attribs":{"d":"M343.1,315c-1.8,0.1-3.5,0.1-5.3,0.1c-29.1,0-56.5-11.3-77.1-31.9c-20.6-20.6-31.9-48-31.9-77.1\r\n\t\t\tc0-16.6,3.7-32.6,10.6-47.1c3.1-6.4,6.8-12.5,11.1-18.2c-7.6,0.8-14.9,2.4-22,4.6c-46.8,14.8-80.7,58.5-80.7,110.2\r\n\t\t\tc0,63.8,51.7,115.5,115.5,115.5c35.3,0,66.8-15.8,88-40.7c4.8-5.7,9.2-11.9,12.8-18.5C357.3,313.6,350.3,314.7,343.1,315z\r\n\t\t\t M263.3,355.1c-54.9,0-99.5-44.6-99.5-99.5c0-39.1,22.6-72.9,55.4-89.2c-4.2,12.5-6.4,25.8-6.4,39.7c0,65.9,51,119.9,115.6,124.7\r\n\t\t\tC311,346,288.2,355.1,263.3,355.1z"},"children":[]}]}]}]}]}]};exports.iosMoonOutline=iosMoonOutline;var iosMoon={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M343.1,315c-1.8,0.1-3.5,0.1-5.3,0.1c-29.1,0-56.5-11.3-77.1-31.9c-20.6-20.6-31.9-48-31.9-77.1\r\n\t\t\tc0-16.6,3.7-32.6,10.6-47.1c3.1-6.4,6.8-12.5,11.1-18.2c-7.6,0.8-14.9,2.4-22,4.6c-46.8,14.8-80.7,58.5-80.7,110.2\r\n\t\t\tc0,63.8,51.7,115.5,115.5,115.5c35.3,0,66.8-15.8,88-40.7c4.8-5.7,9.2-11.9,12.8-18.5C357.3,313.6,350.3,314.7,343.1,315z"},"children":[{"name":"path","attribs":{"d":"M343.1,315c-1.8,0.1-3.5,0.1-5.3,0.1c-29.1,0-56.5-11.3-77.1-31.9c-20.6-20.6-31.9-48-31.9-77.1\r\n\t\t\tc0-16.6,3.7-32.6,10.6-47.1c3.1-6.4,6.8-12.5,11.1-18.2c-7.6,0.8-14.9,2.4-22,4.6c-46.8,14.8-80.7,58.5-80.7,110.2\r\n\t\t\tc0,63.8,51.7,115.5,115.5,115.5c35.3,0,66.8-15.8,88-40.7c4.8-5.7,9.2-11.9,12.8-18.5C357.3,313.6,350.3,314.7,343.1,315z"},"children":[]}]}]}]}]}]};exports.iosMoon=iosMoon;var iosMoreOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,238c9.9,0,18,8.1,18,18s-8.1,18-18,18s-18-8.1-18-18S246.1,238,256,238 M256,224c-17.7,0-32,14.3-32,32s14.3,32,32,32\r\n\t\tc17.7,0,32-14.3,32-32S273.7,224,256,224L256,224z"},"children":[{"name":"path","attribs":{"d":"M256,238c9.9,0,18,8.1,18,18s-8.1,18-18,18s-18-8.1-18-18S246.1,238,256,238 M256,224c-17.7,0-32,14.3-32,32s14.3,32,32,32\r\n\t\tc17.7,0,32-14.3,32-32S273.7,224,256,224L256,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M128.4,238c9.9,0,18,8.1,18,18s-8.1,18-18,18c-9.9,0-18-8.1-18-18S118.5,238,128.4,238 M128.4,224c-17.7,0-32,14.3-32,32\r\n\t\ts14.3,32,32,32c17.7,0,32-14.3,32-32S146,224,128.4,224L128.4,224z"},"children":[{"name":"path","attribs":{"d":"M128.4,238c9.9,0,18,8.1,18,18s-8.1,18-18,18c-9.9,0-18-8.1-18-18S118.5,238,128.4,238 M128.4,224c-17.7,0-32,14.3-32,32\r\n\t\ts14.3,32,32,32c17.7,0,32-14.3,32-32S146,224,128.4,224L128.4,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,238c9.9,0,18,8.1,18,18s-8.1,18-18,18s-18-8.1-18-18S374.1,238,384,238 M384,224c-17.7,0-32,14.3-32,32s14.3,32,32,32\r\n\t\ts32-14.3,32-32S401.7,224,384,224L384,224z"},"children":[{"name":"path","attribs":{"d":"M384,238c9.9,0,18,8.1,18,18s-8.1,18-18,18s-18-8.1-18-18S374.1,238,384,238 M384,224c-17.7,0-32,14.3-32,32s14.3,32,32,32\r\n\t\ts32-14.3,32-32S401.7,224,384,224L384,224z"},"children":[]}]}]}]};exports.iosMoreOutline=iosMoreOutline;var iosMore={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,224c-17.7,0-32,14.3-32,32s14.3,32,32,32c17.7,0,32-14.3,32-32S273.7,224,256,224L256,224z"},"children":[{"name":"path","attribs":{"d":"M256,224c-17.7,0-32,14.3-32,32s14.3,32,32,32c17.7,0,32-14.3,32-32S273.7,224,256,224L256,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M128.4,224c-17.7,0-32,14.3-32,32s14.3,32,32,32c17.7,0,32-14.3,32-32S146,224,128.4,224L128.4,224z"},"children":[{"name":"path","attribs":{"d":"M128.4,224c-17.7,0-32,14.3-32,32s14.3,32,32,32c17.7,0,32-14.3,32-32S146,224,128.4,224L128.4,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,224c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S401.7,224,384,224L384,224z"},"children":[{"name":"path","attribs":{"d":"M384,224c-17.7,0-32,14.3-32,32s14.3,32,32,32s32-14.3,32-32S401.7,224,384,224L384,224z"},"children":[]}]}]}]};exports.iosMore=iosMore;var iosMusicalNote={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M352.1,102.3c0-0.1,0-0.2,0-0.2c-0.1-0.3-0.1-0.5-0.2-0.8c0,0,0-0.1,0-0.1c-0.6-1.5-1.8-3-3.5-3.4l-2-0.4L256,78v272.6\r\n\tc-8,0-22.4,0.4-44.5,1.3c-41.8,1.6-51.4,21.6-51.4,40.9c0,24.6,13.2,43.1,61.5,41c51.8-2.3,51.4-48.5,51.4-81.7V159.6l73.6,13.5l0,0\r\n\tc3,0.6,5.4-2.3,5.4-5.3v-64.4C352,103,352.1,102.6,352.1,102.3z"},"children":[]}]};exports.iosMusicalNote=iosMusicalNote;var iosMusicalNotes={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M416,319.9V78l-224,34.6v237.2c-9,0-20.9,0.4-43.5,1.3c-42.6,1.6-52.5,21.8-52.5,41.3c0,24.9,13.5,43.5,62.6,41.4\r\n\tc52.8-2.3,50.3-49,50.3-82.5V189.8l191-32v160.6c-9,0-19.9,0.4-42.6,1.3c-42.6,1.6-52.5,21.8-52.5,41.3c0,24.9,13,43.5,62.2,41.4\r\n\tC420,400.1,416,353.4,416,319.9z"},"children":[]}]};exports.iosMusicalNotes=iosMusicalNotes;var iosNavigateOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,64.5c51.1,0,99.2,19.9,135.4,56.1s56.1,84.2,56.1,135.4s-19.9,99.2-56.1,135.4s-84.2,56.1-135.4,56.1\r\n\t\ts-99.2-19.9-135.4-56.1C84.5,355.2,64.5,307.1,64.5,256s19.9-99.2,56.1-135.4C156.8,84.5,204.9,64.5,256,64.5 M256,48\r\n\t\tC141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48L256,48z"},"children":[{"name":"path","attribs":{"d":"M256,64.5c51.1,0,99.2,19.9,135.4,56.1s56.1,84.2,56.1,135.4s-19.9,99.2-56.1,135.4s-84.2,56.1-135.4,56.1\r\n\t\ts-99.2-19.9-135.4-56.1C84.5,355.2,64.5,307.1,64.5,256s19.9-99.2,56.1-135.4C156.8,84.5,204.9,64.5,256,64.5 M256,48\r\n\t\tC141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48L256,48z"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,160 128.3,256 256,256 256,384 \t"},"children":[{"name":"polygon","attribs":{"points":"352,160 128.3,256 256,256 256,384 \t"},"children":[]}]}]}]};exports.iosNavigateOutline=iosNavigateOutline;var iosNavigate={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M256,384\r\n\t\tV256H128.3L352,160L256,384z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M256,384\r\n\t\tV256H128.3L352,160L256,384z"},"children":[]}]}]}]};exports.iosNavigate=iosNavigate;var iosNutritionOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M358,233.855l0.413-0.039c-0.137-0.137-0.046-0.101-0.185-0.237L279.798,155h-0.004c-5.833-6-14.193-10.154-23.485-10.154\r\n\t\tc-11.811,0-22.115,6.154-27.635,16.154h-0.007c0,0-7.09,10.994-18.27,28.874l32.531,39.637c2.939,3.769,3.296,7.801,1.411,9.689\r\n\t\tl-0.114,0.071c-0.909,0.909-2.021,1.33-3.274,1.33c-1.908,0-4.142-0.99-6.485-2.768l-35.872-29.418\r\n\t\tc-23.546,37.655-56.677,90.634-83.45,133.451l19.072,23.337c2.939,3.77,3.296,7.884,1.41,9.772l-0.114,0.114\r\n\t\tc-0.911,0.913-2.028,1.342-3.287,1.342c-1.905,0-4.136-0.981-6.472-2.755l-21.067-16.533C84.734,389.051,70,412.464,68,414.366\r\n\t\tv0.003c-3,5.062-4.085,11.132-4.085,17.664c0,17.655,14.657,31.967,32.285,31.967c7.821,0,14.57-3.395,20.799-7.5l114.651-84.109\r\n\t\tl-28.838-35.358c-2.94-3.769-3.268-7.887-1.382-9.775l0.128-0.114c0.912-0.912,2.034-1.341,3.294-1.341\r\n\t\tc1.905,0,4.14,0.981,6.476,2.755l37.864,31.59C304.03,319.902,355.082,283,355.082,283h0.005c7.839-6,12.473-15.711,12.473-26.238\r\n\t\tc0-8.704-3.56-17.14-9.56-22.904V233.855z M345.531,269.834c-2.664,1.934-46.692,33.932-95.764,69.899l-28.272-23.483l-0.26-0.223\r\n\t\tl-0.274-0.211c-5.245-3.981-10.663-5.998-16.108-5.998c-5.465,0-10.592,2.097-14.458,5.909l-0.064,0.062l-0.083,0.082l-0.083,0.083\r\n\t\tc-7.808,7.821-7.761,20.823,0.111,30.917l0.11,0.143l0.113,0.138l18.223,22.312l-100.656,73.896\r\n\t\tc-5.066,3.304-8.427,4.657-11.542,4.657c-8.822,0-16-7.171-16-15.983c0-3.086,0.694-6.045,2.017-8.623\r\n\t\tc2.391-3.161,6.6-9.876,18.655-29.351c2.543-4.108,5.252-8.487,8.134-13.129l6.39,5.176l0.195,0.156l0.2,0.152\r\n\t\tc5.245,3.981,10.665,6,16.111,6c5.517,0,10.692-2.139,14.571-6.023l0.114-0.113c7.806-7.817,7.756-20.82-0.118-30.916l-0.113-0.144\r\n\t\tl-0.115-0.142l-11.814-14.455l43.693-69.872l24.059-38.474l21.855,17.922l0.231,0.19l0.24,0.181\r\n\t\tc5.254,3.988,10.678,6.01,16.123,6.01c4.954,0,9.631-1.725,13.339-4.89l0.461-0.337l0.871-0.874\r\n\t\tc7.79-7.803,7.74-20.778-0.118-30.854l-0.12-0.153l-0.124-0.15l-25.239-30.539c2.957-4.703,5.457-8.491,7.405-11.488l5.209-8.494\r\n\t\tc2.777-5.025,7.761-8.157,13.673-8.157c4.367,0,8.76,2.042,12.057,5.43l4.701,4.928h0.122L342,240.286v0.376l5.186,4.716\r\n\t\tc2.793,2.69,4.539,6.782,4.539,11.227C351.725,261.801,349.467,266.728,345.531,269.834z"},"children":[{"name":"path","attribs":{"d":"M358,233.855l0.413-0.039c-0.137-0.137-0.046-0.101-0.185-0.237L279.798,155h-0.004c-5.833-6-14.193-10.154-23.485-10.154\r\n\t\tc-11.811,0-22.115,6.154-27.635,16.154h-0.007c0,0-7.09,10.994-18.27,28.874l32.531,39.637c2.939,3.769,3.296,7.801,1.411,9.689\r\n\t\tl-0.114,0.071c-0.909,0.909-2.021,1.33-3.274,1.33c-1.908,0-4.142-0.99-6.485-2.768l-35.872-29.418\r\n\t\tc-23.546,37.655-56.677,90.634-83.45,133.451l19.072,23.337c2.939,3.77,3.296,7.884,1.41,9.772l-0.114,0.114\r\n\t\tc-0.911,0.913-2.028,1.342-3.287,1.342c-1.905,0-4.136-0.981-6.472-2.755l-21.067-16.533C84.734,389.051,70,412.464,68,414.366\r\n\t\tv0.003c-3,5.062-4.085,11.132-4.085,17.664c0,17.655,14.657,31.967,32.285,31.967c7.821,0,14.57-3.395,20.799-7.5l114.651-84.109\r\n\t\tl-28.838-35.358c-2.94-3.769-3.268-7.887-1.382-9.775l0.128-0.114c0.912-0.912,2.034-1.341,3.294-1.341\r\n\t\tc1.905,0,4.14,0.981,6.476,2.755l37.864,31.59C304.03,319.902,355.082,283,355.082,283h0.005c7.839-6,12.473-15.711,12.473-26.238\r\n\t\tc0-8.704-3.56-17.14-9.56-22.904V233.855z M345.531,269.834c-2.664,1.934-46.692,33.932-95.764,69.899l-28.272-23.483l-0.26-0.223\r\n\t\tl-0.274-0.211c-5.245-3.981-10.663-5.998-16.108-5.998c-5.465,0-10.592,2.097-14.458,5.909l-0.064,0.062l-0.083,0.082l-0.083,0.083\r\n\t\tc-7.808,7.821-7.761,20.823,0.111,30.917l0.11,0.143l0.113,0.138l18.223,22.312l-100.656,73.896\r\n\t\tc-5.066,3.304-8.427,4.657-11.542,4.657c-8.822,0-16-7.171-16-15.983c0-3.086,0.694-6.045,2.017-8.623\r\n\t\tc2.391-3.161,6.6-9.876,18.655-29.351c2.543-4.108,5.252-8.487,8.134-13.129l6.39,5.176l0.195,0.156l0.2,0.152\r\n\t\tc5.245,3.981,10.665,6,16.111,6c5.517,0,10.692-2.139,14.571-6.023l0.114-0.113c7.806-7.817,7.756-20.82-0.118-30.916l-0.113-0.144\r\n\t\tl-0.115-0.142l-11.814-14.455l43.693-69.872l24.059-38.474l21.855,17.922l0.231,0.19l0.24,0.181\r\n\t\tc5.254,3.988,10.678,6.01,16.123,6.01c4.954,0,9.631-1.725,13.339-4.89l0.461-0.337l0.871-0.874\r\n\t\tc7.79-7.803,7.74-20.778-0.118-30.854l-0.12-0.153l-0.124-0.15l-25.239-30.539c2.957-4.703,5.457-8.491,7.405-11.488l5.209-8.494\r\n\t\tc2.777-5.025,7.761-8.157,13.673-8.157c4.367,0,8.76,2.042,12.057,5.43l4.701,4.928h0.122L342,240.286v0.376l5.186,4.716\r\n\t\tc2.793,2.69,4.539,6.782,4.539,11.227C351.725,261.801,349.467,266.728,345.531,269.834z"},"children":[]}]},{"name":"polygon","attribs":{"points":"439.994,115.175 435.216,117.938 343.578,170.93 407.313,60.358 409.83,55.992 396.011,48 393.523,52.313 \r\n\t\t322.748,175.098 339.418,191.794 443.38,131.674 447.974,129.018 \t"},"children":[{"name":"polygon","attribs":{"points":"439.994,115.175 435.216,117.938 343.578,170.93 407.313,60.358 409.83,55.992 396.011,48 393.523,52.313 \r\n\t\t322.748,175.098 339.418,191.794 443.38,131.674 447.974,129.018 \t"},"children":[]}]}]}]};exports.iosNutritionOutline=iosNutritionOutline;var iosNutrition={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M359,233.62l-0.106-0.039c-0.136-0.138-0.306-0.443-0.444-0.579L279.551,154h-0.004c-5.848-6-14.23-10.168-23.547-10.168\r\n\t\tc-11.842,0-22.174,6.168-27.708,16.168h-0.007c0,0-7.109,11.351-18.318,29.249l32.617,39.85c2.947,3.772,3.305,7.895,1.414,9.785\r\n\t\tl-0.114,0.114c-2.296,2.296-5.894,1.535-9.785-1.414l-35.967-29.439c-23.608,37.693-56.827,90.731-83.671,133.592l19.123,23.362\r\n\t\tc2.947,3.772,3.305,7.895,1.414,9.785l-0.114,0.114c-2.296,2.296-5.894,1.535-9.785-1.414l-20.22-16.55\r\n\t\tC84.874,388.974,70.194,412.411,69,414.315v0.003c-3,5.066-5,11.144-5,17.682c0,17.674,14.244,32,31.918,32\r\n\t\tc7.842,0,14.383-3.398,20.628-7.508l114.842-84.195l-28.971-35.395c-2.947-3.772-3.305-7.895-1.414-9.785l0.114-0.114\r\n\t\tc2.296-2.296,5.894-1.534,9.785,1.415l37.963,31.215C303.85,319.348,355.035,282,355.035,282h0.005\r\n\t\tc7.859-6,13.024-15.319,13.024-25.857c0-8.713-3.064-16.75-9.064-22.521V233.62z"},"children":[{"name":"path","attribs":{"d":"M359,233.62l-0.106-0.039c-0.136-0.138-0.306-0.443-0.444-0.579L279.551,154h-0.004c-5.848-6-14.23-10.168-23.547-10.168\r\n\t\tc-11.842,0-22.174,6.168-27.708,16.168h-0.007c0,0-7.109,11.351-18.318,29.249l32.617,39.85c2.947,3.772,3.305,7.895,1.414,9.785\r\n\t\tl-0.114,0.114c-2.296,2.296-5.894,1.535-9.785-1.414l-35.967-29.439c-23.608,37.693-56.827,90.731-83.671,133.592l19.123,23.362\r\n\t\tc2.947,3.772,3.305,7.895,1.414,9.785l-0.114,0.114c-2.296,2.296-5.894,1.535-9.785-1.414l-20.22-16.55\r\n\t\tC84.874,388.974,70.194,412.411,69,414.315v0.003c-3,5.066-5,11.144-5,17.682c0,17.674,14.244,32,31.918,32\r\n\t\tc7.842,0,14.383-3.398,20.628-7.508l114.842-84.195l-28.971-35.395c-2.947-3.772-3.305-7.895-1.414-9.785l0.114-0.114\r\n\t\tc2.296-2.296,5.894-1.534,9.785,1.415l37.963,31.215C303.85,319.348,355.035,282,355.035,282h0.005\r\n\t\tc7.859-6,13.024-15.319,13.024-25.857c0-8.713-3.064-16.75-9.064-22.521V233.62z"},"children":[]}]},{"name":"polygon","attribs":{"points":"448,138.781 431.514,111.087 365.284,149.299 414.515,64.086 386.896,48 316.897,169.084 345.485,197.672 \t"},"children":[{"name":"polygon","attribs":{"points":"448,138.781 431.514,111.087 365.284,149.299 414.515,64.086 386.896,48 316.897,169.084 345.485,197.672 \t"},"children":[]}]}]}]};exports.iosNutrition=iosNutrition;var iosPaperOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M112,64v16v320h16V80h304v337.143c0,8.205-6.652,14.857-14.857,14.857H94.857C86.652,432,80,425.348,80,417.143V128h16v-16\r\n\t\tH64v305.143C64,434.157,77.843,448,94.857,448h322.285C434.157,448,448,434.157,448,417.143V64H112z"},"children":[{"name":"path","attribs":{"d":"M112,64v16v320h16V80h304v337.143c0,8.205-6.652,14.857-14.857,14.857H94.857C86.652,432,80,425.348,80,417.143V128h16v-16\r\n\t\tH64v305.143C64,434.157,77.843,448,94.857,448h322.285C434.157,448,448,434.157,448,417.143V64H112z"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"112","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"112","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"192","width":"240","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"192","width":"240","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"272","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"272","width":"192","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"352","width":"240","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"352","width":"240","height":"16"},"children":[]}]}]}]};exports.iosPaperOutline=iosPaperOutline;var iosPaper={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M112,64v16v32v288H96V112H64v305.143C64,434.157,77.843,448,94.857,448h322.285C434.157,448,448,434.157,448,417.143V64H112\r\n\tz M160,112h128v16H160V112z M160,272h192v16H160V272z M400,368H160v-16h240V368z M400,208H160v-16h240V208z"},"children":[]}]};exports.iosPaper=iosPaper;var iosPaperplaneOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M96,249.6l116.6,51.3L269.8,416L416,96L96,249.6z M228.1,296.5l155.7-166.2L269.2,379.2L228.1,296.5z M381.8,128.3\r\n\tL216.8,285.4L134,249L381.8,128.3z"},"children":[]}]};exports.iosPaperplaneOutline=iosPaperplaneOutline;var iosPaperplane={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"96,249.6 202,296.3 416,96 \t"},"children":[{"name":"polygon","attribs":{"points":"96,249.6 202,296.3 416,96 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"416,96 217.9,311.7 269.8,416 \t"},"children":[{"name":"polygon","attribs":{"points":"416,96 217.9,311.7 269.8,416 \t"},"children":[]}]}]}]};exports.iosPaperplane=iosPaperplane;var iosPartlysunnyOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"208","y":"96","class":"st0","width":"16","height":"54"},"children":[{"name":"rect","attribs":{"x":"208","y":"96","class":"st0","width":"16","height":"54"},"children":[]}]},{"name":"rect","attribs":{"x":"64","y":"240","class":"st0","width":"55","height":"16"},"children":[{"name":"rect","attribs":{"x":"64","y":"240","class":"st0","width":"55","height":"16"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"107.5,149.1 118.5,138 149.9,169.6 138.9,180.7 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"107.5,149.1 118.5,138 149.9,169.6 138.9,180.7 \t\t\t"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"287.4,179.7 276.4,168.6 307.7,137 318.8,148.1 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"287.4,179.7 276.4,168.6 307.7,137 318.8,148.1 \t\t\t"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"120.5,352.5 109.5,341.4 140.9,309.8 151.9,320.9 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"120.5,352.5 109.5,341.4 140.9,309.8 151.9,320.9 \t\t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M192.6,294.9c-20.2-8.1-34.6-27.9-34.6-51.1c0-30.3,24.5-55,54.7-55c15.6,0,29.7,6.6,39.6,17.2\r\n\t\t\t\tc4.8-3.5,9.5-6.2,13.6-8.2c-12.9-15.1-32-24.7-53.3-24.7c-38.7,0-70.3,31.7-70.3,70.7c0,27.4,15.6,51.2,38.3,62.9\r\n\t\t\t\tC184.3,301.5,188.5,297.7,192.6,294.9z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M192.6,294.9c-20.2-8.1-34.6-27.9-34.6-51.1c0-30.3,24.5-55,54.7-55c15.6,0,29.7,6.6,39.6,17.2\r\n\t\t\t\tc4.8-3.5,9.5-6.2,13.6-8.2c-12.9-15.1-32-24.7-53.3-24.7c-38.7,0-70.3,31.7-70.3,70.7c0,27.4,15.6,51.2,38.3,62.9\r\n\t\t\t\tC184.3,301.5,188.5,297.7,192.6,294.9z"},"children":[]}]}]}]}]}]},{"name":"path","attribs":{"class":"st0","d":"M299,239.8c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\tc26.9,0,48.8,22.1,48.8,49.2c0,27.1-21.9,49.2-48.8,49.2H225.7c-9.5,0-18.5-3.9-25.4-10.8c-6.8-7-10.6-16.2-10.6-25.9\r\n\t\tc0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.2,14.2-1.7c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\tC236.5,268,264.5,239.8,299,239.8 M299,224c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\tC367.5,250.3,336.3,224,299,224L299,224z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M299,239.8c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\tc26.9,0,48.8,22.1,48.8,49.2c0,27.1-21.9,49.2-48.8,49.2H225.7c-9.5,0-18.5-3.9-25.4-10.8c-6.8-7-10.6-16.2-10.6-25.9\r\n\t\tc0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.2,14.2-1.7c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\tC236.5,268,264.5,239.8,299,239.8 M299,224c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\tC367.5,250.3,336.3,224,299,224L299,224z"},"children":[]}]}]}]};exports.iosPartlysunnyOutline=iosPartlysunnyOutline;var iosPartlysunny={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"208","y":"96","class":"st0","width":"16","height":"54"},"children":[{"name":"rect","attribs":{"x":"208","y":"96","class":"st0","width":"16","height":"54"},"children":[]}]},{"name":"rect","attribs":{"x":"64","y":"240","class":"st0","width":"55","height":"16"},"children":[{"name":"rect","attribs":{"x":"64","y":"240","class":"st0","width":"55","height":"16"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"107.5,149.1 118.5,138 149.9,169.6 138.9,180.7 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"107.5,149.1 118.5,138 149.9,169.6 138.9,180.7 \t\t\t"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"287.4,179.7 276.4,168.6 307.7,137 318.8,148.1 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"287.4,179.7 276.4,168.6 307.7,137 318.8,148.1 \t\t\t"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"120.5,352.5 109.5,341.4 140.9,309.8 151.9,320.9 \t\t\t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"120.5,352.5 109.5,341.4 140.9,309.8 151.9,320.9 \t\t\t"},"children":[]}]}]}]},{"name":"path","attribs":{"class":"st0","d":"M299,224c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\t\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\t\tC367.5,250.3,336.3,224,299,224L299,224z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M299,224c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.5-47.1,52.6\r\n\t\t\tc0,28.6,23.2,53.1,51.7,53.1h157.7c35.7,0,64.6-29.9,64.6-65.7c0-35.8-28.9-65.3-64.6-65.3c-2.7,0-5.4,0-8,0.3\r\n\t\t\tC367.5,250.3,336.3,224,299,224L299,224z"},"children":[]}]}]}]},{"name":"path","attribs":{"class":"st0","d":"M264.7,196.3c-12.9-14.3-31.4-23.3-52-23.3c-38.7,0-70.3,31.7-70.3,70.7c0,27.4,15.6,51.2,38.3,62.9\r\n\t\tc0,0,0-0.1,0-0.1c0,0,0.1,0.1,0.1,0.1c4.5-12.1,11.4-19.8,22.6-25.6c0.2-0.1,0.4-0.2,0.7-0.4c0.2-0.1,0.5-0.2,0.7-0.3\r\n\t\tc-0.2-2.3-0.3-4.7-0.3-7c-0.3-31.9,30.2-70.5,61-75.4c0.1-0.1,0.3-0.1,0.4-0.2C265.5,197.3,265.1,196.8,264.7,196.3z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M264.7,196.3c-12.9-14.3-31.4-23.3-52-23.3c-38.7,0-70.3,31.7-70.3,70.7c0,27.4,15.6,51.2,38.3,62.9\r\n\t\tc0,0,0-0.1,0-0.1c0,0,0.1,0.1,0.1,0.1c4.5-12.1,11.4-19.8,22.6-25.6c0.2-0.1,0.4-0.2,0.7-0.4c0.2-0.1,0.5-0.2,0.7-0.3\r\n\t\tc-0.2-2.3-0.3-4.7-0.3-7c-0.3-31.9,30.2-70.5,61-75.4c0.1-0.1,0.3-0.1,0.4-0.2C265.5,197.3,265.1,196.8,264.7,196.3z"},"children":[]}]}]}]};exports.iosPartlysunny=iosPartlysunny;var iosPauseOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M191,112v288h-47V112H191 M207,96h-79v320h79V96L207,96z"},"children":[{"name":"path","attribs":{"d":"M191,112v288h-47V112H191 M207,96h-79v320h79V96L207,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,112v288h-47V112H368 M384,96h-79v320h79V96L384,96z"},"children":[{"name":"path","attribs":{"d":"M368,112v288h-47V112H368 M384,96h-79v320h79V96L384,96z"},"children":[]}]}]}]};exports.iosPauseOutline=iosPauseOutline;var iosPause={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"96","width":"79","height":"320"},"children":[{"name":"rect","attribs":{"x":"128","y":"96","width":"79","height":"320"},"children":[]}]},{"name":"rect","attribs":{"x":"305","y":"96","width":"79","height":"320"},"children":[{"name":"rect","attribs":{"x":"305","y":"96","width":"79","height":"320"},"children":[]}]}]}]};exports.iosPause=iosPause;var iosPawOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976\r\n\t\tc-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123\r\n\t\tc20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z M426.214,246.295\r\n\t\tc-7.836,18.898-22.994,32.098-36.862,32.098c-2.809,0-5.488-0.569-7.968-1.694c-14.121-6.394-17.862-31.059-8.518-56.152\r\n\t\tc7.775-20.817,22.448-35.355,35.683-35.355c2.51,0,4.979,0.533,7.34,1.588c6.88,3.067,10.622,9.712,12.551,14.745\r\n\t\tC433.35,214.332,432.518,231.068,426.214,246.295z"},"children":[{"name":"path","attribs":{"d":"M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976\r\n\t\tc-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123\r\n\t\tc20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z M426.214,246.295\r\n\t\tc-7.836,18.898-22.994,32.098-36.862,32.098c-2.809,0-5.488-0.569-7.968-1.694c-14.121-6.394-17.862-31.059-8.518-56.152\r\n\t\tc7.775-20.817,22.448-35.355,35.683-35.355c2.51,0,4.979,0.533,7.34,1.588c6.88,3.067,10.622,9.712,12.551,14.745\r\n\t\tC433.35,214.332,432.518,231.068,426.214,246.295z"},"children":[]}]},{"name":"path","attribs":{"d":"M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976\r\n\t\tc-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296\r\n\t\tc5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z M130.616,276.698\r\n\t\tc-2.479,1.125-5.16,1.694-7.968,1.694c-13.868,0-29.026-13.199-36.862-32.098c-6.304-15.227-7.136-31.963-2.226-44.771\r\n\t\tc1.929-5.033,5.671-11.678,12.551-14.745c2.361-1.055,4.83-1.588,7.34-1.588c13.234,0,27.907,14.538,35.683,35.355\r\n\t\tC148.479,245.64,144.737,270.305,130.616,276.698z"},"children":[{"name":"path","attribs":{"d":"M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976\r\n\t\tc-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296\r\n\t\tc5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z M130.616,276.698\r\n\t\tc-2.479,1.125-5.16,1.694-7.968,1.694c-13.868,0-29.026-13.199-36.862-32.098c-6.304-15.227-7.136-31.963-2.226-44.771\r\n\t\tc1.929-5.033,5.671-11.678,12.551-14.745c2.361-1.055,4.83-1.588,7.34-1.588c13.234,0,27.907,14.538,35.683,35.355\r\n\t\tC148.479,245.64,144.737,270.305,130.616,276.698z"},"children":[]}]},{"name":"path","attribs":{"d":"M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008\r\n\t\tc12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193\r\n\t\tc-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104\r\n\t\tC146.202,179.269,170.836,209.404,198.347,210.601z M171.047,91.831c3.923-4.739,10.51-10.577,19.62-11.476\r\n\t\tc1.143-0.113,2.288-0.146,3.404-0.098c18.207,0.792,31.859,23.271,34.936,52.428c2.146,20.15-0.148,40.055-9.845,51.779\r\n\t\tc-4.874,5.898-10.556,9.204-16.881,9.825c-1.081,0.104-2.167,0.133-3.229,0.087c-19.257-0.838-37.414-25.091-40.473-54.067\r\n\t\tC156.611,121.779,161.273,103.656,171.047,91.831z"},"children":[{"name":"path","attribs":{"d":"M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008\r\n\t\tc12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193\r\n\t\tc-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104\r\n\t\tC146.202,179.269,170.836,209.404,198.347,210.601z M171.047,91.831c3.923-4.739,10.51-10.577,19.62-11.476\r\n\t\tc1.143-0.113,2.288-0.146,3.404-0.098c18.207,0.792,31.859,23.271,34.936,52.428c2.146,20.15-0.148,40.055-9.845,51.779\r\n\t\tc-4.874,5.898-10.556,9.204-16.881,9.825c-1.081,0.104-2.167,0.133-3.229,0.087c-19.257-0.838-37.414-25.091-40.473-54.067\r\n\t\tC156.611,121.779,161.273,103.656,171.047,91.831z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448\r\n\t\tc23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605\r\n\t\tC290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128\r\n\t\tC384,316.074,320,240,256,240z M353.963,420.776c-10.964,7.337-17.366,9.778-33.666,9.778c-14.225,0-18.624-3.201-25.911-8.51\r\n\t\tc-1.848-1.344-3.759-2.736-5.946-4.177c-8.619-5.682-18.39-12.123-32.439-12.123s-23.82,6.441-32.438,12.121\r\n\t\tc-2.189,1.442-4.1,2.835-5.947,4.179c-7.287,5.309-11.686,8.51-25.911,8.51c-16.3,0-22.703-2.441-33.667-9.778\r\n\t\tC152.395,417,144,405.456,144,389.128c0-30.277,13.377-64.231,35.783-90.823c10.886-12.921,23.517-23.6,36.526-30.885\r\n\t\tC229.713,259.917,243.067,256,256,256c12.934,0,26.287,3.917,39.691,11.42c13.01,7.285,25.64,17.964,36.525,30.885\r\n\t\tC354.623,324.896,368,358.851,368,389.128C368,405.456,359.605,417,353.963,420.776z"},"children":[{"name":"path","attribs":{"d":"M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448\r\n\t\tc23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605\r\n\t\tC290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128\r\n\t\tC384,316.074,320,240,256,240z M353.963,420.776c-10.964,7.337-17.366,9.778-33.666,9.778c-14.225,0-18.624-3.201-25.911-8.51\r\n\t\tc-1.848-1.344-3.759-2.736-5.946-4.177c-8.619-5.682-18.39-12.123-32.439-12.123s-23.82,6.441-32.438,12.121\r\n\t\tc-2.189,1.442-4.1,2.835-5.947,4.179c-7.287,5.309-11.686,8.51-25.911,8.51c-16.3,0-22.703-2.441-33.667-9.778\r\n\t\tC152.395,417,144,405.456,144,389.128c0-30.277,13.377-64.231,35.783-90.823c10.886-12.921,23.517-23.6,36.526-30.885\r\n\t\tC229.713,259.917,243.067,256,256,256c12.934,0,26.287,3.917,39.691,11.42c13.01,7.285,25.64,17.964,36.525,30.885\r\n\t\tC354.623,324.896,368,358.851,368,389.128C368,405.456,359.605,417,353.963,420.776z"},"children":[]}]},{"name":"path","attribs":{"d":"M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607\r\n\t\tc2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312\r\n\t\tc-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439\r\n\t\tC287.741,203.671,297.494,209.206,308.281,210.265z M283.186,132.501c3.076-29.156,16.729-51.636,34.936-52.428\r\n\t\tc1.115-0.048,2.261-0.016,3.404,0.098c9.109,0.898,15.696,6.736,19.619,11.476c9.774,11.825,14.436,29.948,12.468,48.479\r\n\t\tc-3.06,28.977-21.216,53.229-40.474,54.067c-1.061,0.046-2.146,0.017-3.229-0.087c-6.324-0.621-12.007-3.927-16.881-9.825\r\n\t\tC283.334,172.556,281.039,152.651,283.186,132.501z"},"children":[{"name":"path","attribs":{"d":"M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607\r\n\t\tc2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312\r\n\t\tc-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439\r\n\t\tC287.741,203.671,297.494,209.206,308.281,210.265z M283.186,132.501c3.076-29.156,16.729-51.636,34.936-52.428\r\n\t\tc1.115-0.048,2.261-0.016,3.404,0.098c9.109,0.898,15.696,6.736,19.619,11.476c9.774,11.825,14.436,29.948,12.468,48.479\r\n\t\tc-3.06,28.977-21.216,53.229-40.474,54.067c-1.061,0.046-2.146,0.017-3.229-0.087c-6.324-0.621-12.007-3.927-16.881-9.825\r\n\t\tC283.334,172.556,281.039,152.651,283.186,132.501z"},"children":[]}]}]}]};exports.iosPawOutline=iosPawOutline;var iosPaw={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976\r\n\t\tc-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123\r\n\t\tc20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z"},"children":[{"name":"path","attribs":{"d":"M443.827,195.5c-4.383-11.73-11.753-20.212-21.317-24.524c-4.389-1.975-8.995-2.976-13.688-2.976\r\n\t\tc-20.025,0-40.372,18.667-50.632,46.454c-12.698,34.42-5.315,68.135,17.173,78.423c4.522,2.071,9.365,3.123,14.394,3.123\r\n\t\tc20.396,0,41.126-17.119,51.581-42.596C449.238,234.121,450.168,212.477,443.827,195.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976\r\n\t\tc-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296\r\n\t\tc5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z"},"children":[{"name":"path","attribs":{"d":"M153.811,214.454C143.551,186.667,123.204,168,103.179,168c-4.693,0-9.3,1.001-13.689,2.976\r\n\t\tc-9.565,4.312-16.934,12.794-21.317,24.524c-6.341,16.977-5.411,38.621,2.49,57.904C81.118,278.881,101.848,296,122.244,296\r\n\t\tc5.028,0,9.871-1.052,14.394-3.123C159.126,282.589,166.509,248.874,153.811,214.454z"},"children":[]}]},{"name":"path","attribs":{"d":"M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008\r\n\t\tc12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193\r\n\t\tc-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104\r\n\t\tC146.202,179.269,170.836,209.404,198.347,210.601z"},"children":[{"name":"path","attribs":{"d":"M198.347,210.601c1.855,0.081,3.727,0.03,5.563-0.151c10.787-1.059,20.54-6.594,28.207-16.008\r\n\t\tc12.371-15.191,15.806-38.974,13.201-63.439C241.336,93.3,221.469,65.161,194.776,64c0,0-3.811,0.008-5.75,0.193\r\n\t\tc-11.776,1.164-22.481,7.283-30.957,17.695c-12.291,15.101-18.198,37.57-15.803,60.104\r\n\t\tC146.202,179.269,170.836,209.404,198.347,210.601z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448\r\n\t\tc23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605\r\n\t\tC290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128\r\n\t\tC384,316.074,320,240,256,240z"},"children":[{"name":"path","attribs":{"d":"M256,240c-64,0-128,76.074-128,149.128c0,21.798,10.932,39.331,21.667,46.517C162.925,444.516,172.269,448,191.704,448\r\n\t\tc23.093,0,29.325-8.078,40.136-15.205c7.819-5.152,14.572-9.605,24.161-9.605s16.342,4.453,24.16,9.605\r\n\t\tC290.972,439.922,297.203,448,320.297,448c19.434,0,28.778-3.484,42.036-12.355C373.068,428.459,384,410.926,384,389.128\r\n\t\tC384,316.074,320,240,256,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607\r\n\t\tc2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312\r\n\t\tc-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439\r\n\t\tC287.741,203.671,297.494,209.206,308.281,210.265z"},"children":[{"name":"path","attribs":{"d":"M308.281,210.265c1.836,0.182,3.709,0.232,5.563,0.151c27.511-1.196,52.146-31.332,56.081-68.607\r\n\t\tc2.395-22.534-3.514-45.004-15.804-60.104c-8.476-10.412-18.783-16.228-30.56-17.392c-1.939-0.186-6.146-0.312-6.146-0.312\r\n\t\tc-26.693,1.161-46.561,29.115-50.542,66.817c-2.604,24.466,0.83,48.248,13.2,63.439\r\n\t\tC287.741,203.671,297.494,209.206,308.281,210.265z"},"children":[]}]}]}]};exports.iosPaw=iosPaw;var iosPeopleOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,112L256,112L256,112z"},"children":[{"name":"path","attribs":{"d":"M256,112L256,112L256,112z"},"children":[]}]},{"name":"path","attribs":{"d":"M349.2,334.8c-13.5-4.7-28.1-5-41.6-9.7c-4.1-1.4-12.2-3.1-13.9-7.8c-1.6-4.6-1.6-10-1.9-14.8c-0.2-3.8-0.3-7.6-0.3-11.4\r\n\t\t\tc0-2.5,6.4-7.8,7.8-10.1c5.4-9,5.9-21.1,6.9-31.3c8.7,2.4,9.8-13.7,11.3-18.6c1.1-3.4,7.8-26.8-2.6-23.6c2.5-4.4,3.5-9.8,4.2-14.7\r\n\t\t\tc2-12.8,2.8-26.8-1.1-39.3c-8.1-26-33-40.6-59.3-41.4c-26.7-0.9-53.5,11.9-63.5,37.8c-4.8,12.6-4.4,26.3-2.8,39.5\r\n\t\t\tc0.7,6,1.7,12.7,4.7,18.1c-9.7-2.9-4.5,17.7-3.4,21.3c1.6,5.1,3,23.4,12.1,20.9c0.8,8.1,1.7,16.4,3.9,24.3\r\n\t\t\tc1.5,5.3,4.6,9.8,8.2,13.9c1.8,2,2.7,2.2,2.6,4.8c-0.1,7.8,0.1,16.2-1.9,23.8c-2,7.6-18.7,10.8-25.4,12.2\r\n\t\t\tc-18,3.7-34.6,5.4-49.6,16.6C126.1,358.2,117,378.3,117,400c83.3,0,166.6,0,249.9,0c9.4,0,18.7,0,28.1,0\r\n\t\t\tC395,370.5,377.2,344.5,349.2,334.8C338,330.9,360.5,338.7,349.2,334.8z M147.1,363.6c5.6-5.9,12.7-11.1,20.4-14\r\n\t\t\tc10.5-4,22.4-3.8,33.3-6.6c9-2.3,20.2-5.9,27.2-12.4c6.4-6,7.1-15.2,7.7-23.5c0.5-7,0.4-13.9,0.4-20.9c0-4.9-5.7-7.7-8.5-11.6\r\n\t\t\tc-4.5-6.1-4.7-15.2-5.6-22.5c-0.4-3.2-0.5-7.3-3.2-9.5c-3-2.4-5.2-3.7-6.7-7.5c-2-5.2-2.7-10.8-4.3-16.2c-1-3.5,2.5-6.8,3.9-9.7\r\n\t\t\tc2.6-5.3-1.9-13.5-2.8-19c-2.8-16.4-2.7-34.3,9.1-47.3c23.7-26.2,78-17.9,85.8,18.9c2.4,11.5,0.9,24.9-2.3,36.1\r\n\t\t\tc-1.4,4.8-3,8.3-0.2,13c4.2,6.8,2.4,11.2,0.4,18.8c-1.6,6.3-3.6,9.1-8.4,13c-4,3.2-3.4,11.2-4.1,15.8c-0.8,5.6-1.3,11.5-4.7,16.2\r\n\t\t\tc-1.3,1.8-8.4,7.4-8.4,9.3c0,11-0.5,22.2,1.4,33.1c2.6,15.5,15.6,19.2,28.6,24.5c13.2,5.1,28.5,3.2,41.3,9.5\r\n\t\t\tc13.2,6.5,25.9,18.4,29.7,33.1c-79.3,0-158.6,0-237.9,0c-1.4,0-2.8,0-4.2,0C136.9,375.9,141.5,369.6,147.1,363.6\r\n\t\t\tC156.3,353.9,141.2,369.9,147.1,363.6z"},"children":[{"name":"path","attribs":{"d":"M349.2,334.8c-13.5-4.7-28.1-5-41.6-9.7c-4.1-1.4-12.2-3.1-13.9-7.8c-1.6-4.6-1.6-10-1.9-14.8c-0.2-3.8-0.3-7.6-0.3-11.4\r\n\t\t\tc0-2.5,6.4-7.8,7.8-10.1c5.4-9,5.9-21.1,6.9-31.3c8.7,2.4,9.8-13.7,11.3-18.6c1.1-3.4,7.8-26.8-2.6-23.6c2.5-4.4,3.5-9.8,4.2-14.7\r\n\t\t\tc2-12.8,2.8-26.8-1.1-39.3c-8.1-26-33-40.6-59.3-41.4c-26.7-0.9-53.5,11.9-63.5,37.8c-4.8,12.6-4.4,26.3-2.8,39.5\r\n\t\t\tc0.7,6,1.7,12.7,4.7,18.1c-9.7-2.9-4.5,17.7-3.4,21.3c1.6,5.1,3,23.4,12.1,20.9c0.8,8.1,1.7,16.4,3.9,24.3\r\n\t\t\tc1.5,5.3,4.6,9.8,8.2,13.9c1.8,2,2.7,2.2,2.6,4.8c-0.1,7.8,0.1,16.2-1.9,23.8c-2,7.6-18.7,10.8-25.4,12.2\r\n\t\t\tc-18,3.7-34.6,5.4-49.6,16.6C126.1,358.2,117,378.3,117,400c83.3,0,166.6,0,249.9,0c9.4,0,18.7,0,28.1,0\r\n\t\t\tC395,370.5,377.2,344.5,349.2,334.8C338,330.9,360.5,338.7,349.2,334.8z M147.1,363.6c5.6-5.9,12.7-11.1,20.4-14\r\n\t\t\tc10.5-4,22.4-3.8,33.3-6.6c9-2.3,20.2-5.9,27.2-12.4c6.4-6,7.1-15.2,7.7-23.5c0.5-7,0.4-13.9,0.4-20.9c0-4.9-5.7-7.7-8.5-11.6\r\n\t\t\tc-4.5-6.1-4.7-15.2-5.6-22.5c-0.4-3.2-0.5-7.3-3.2-9.5c-3-2.4-5.2-3.7-6.7-7.5c-2-5.2-2.7-10.8-4.3-16.2c-1-3.5,2.5-6.8,3.9-9.7\r\n\t\t\tc2.6-5.3-1.9-13.5-2.8-19c-2.8-16.4-2.7-34.3,9.1-47.3c23.7-26.2,78-17.9,85.8,18.9c2.4,11.5,0.9,24.9-2.3,36.1\r\n\t\t\tc-1.4,4.8-3,8.3-0.2,13c4.2,6.8,2.4,11.2,0.4,18.8c-1.6,6.3-3.6,9.1-8.4,13c-4,3.2-3.4,11.2-4.1,15.8c-0.8,5.6-1.3,11.5-4.7,16.2\r\n\t\t\tc-1.3,1.8-8.4,7.4-8.4,9.3c0,11-0.5,22.2,1.4,33.1c2.6,15.5,15.6,19.2,28.6,24.5c13.2,5.1,28.5,3.2,41.3,9.5\r\n\t\t\tc13.2,6.5,25.9,18.4,29.7,33.1c-79.3,0-158.6,0-237.9,0c-1.4,0-2.8,0-4.2,0C136.9,375.9,141.5,369.6,147.1,363.6\r\n\t\t\tC156.3,353.9,141.2,369.9,147.1,363.6z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M144.1,322c7-3.5,14.6-4.3,22.3-5.1c2.8-0.3,4.1-2.2,2-4.9c-4-5.1-17.8-6.1-23.6-8.4c-3.6-1.4-4.6-2.7-4.9-6.7\r\n\t\tc-0.1-1.8-1.1-9.8,0.3-11.1c1-1,7.3-0.6,8.7-0.8c5.7-0.7,11.5-1.9,16.9-4c2.3-0.9,4.5-2,6.5-3.4c2.4-1.8-1.8-6.2-2.9-8.6\r\n\t\tc-3.4-7.5-4.9-15.7-5.4-23.9c-1-16.1,1.5-32.3-1.5-48.3c-4.5-24.5-23.4-36.8-47.5-36.8c-14.9,0-29.6,5.1-37.9,18.1\r\n\t\tc-9.2,14.3-8.7,32.1-8.2,48.4c0.3,9.3,0.7,18.7-0.6,28c-0.6,4-1.5,7.9-2.9,11.7c-1.1,2.9-6.7,10.1-4.5,11.6\r\n\t\tc8.3,5.9,22.3,7.9,32.3,7.1c0.3,4.9,1.2,11.2-0.6,15.8c-2.8,7.2-23.7,9.1-30,11.2C45,317.8,32,332.5,32,352c18.3,0,36.5,0,54.8,0\r\n\t\tc8.2,0,16.4,0,24.7,0c1.3,0,6.3-9.3,7.7-10.8C126.2,333.4,134.8,326.7,144.1,322C153.1,317.5,129.5,329.4,144.1,322z M102.8,336\r\n\t\tc-16.3,0-32.6,0-48.9,0c7.1-11.8,24.9-11,36.6-15.2c10.8-3.9,17.7-10.5,18.8-22c0.1-1.3,0.2-29.2-0.9-29.2\r\n\t\tc-8.7-0.3-17.8-0.1-26.5-1.4c6.9-22.3,0.3-45.3,4-67.8c2.7-16.3,13.1-25.3,29.7-25.3c15.9,0,27.7,7.4,31.1,23.4\r\n\t\tc4.8,23.2-2,46.9,5.4,69.9c-5.5,1.4-11.3,1.6-17,1.8c-2.8,0.1-5.7,0.2-8.5,0.3c-1.8,0.1-1.2,3.2-1.3,4.7c-1,10.9-5,28.1,3.7,36.9\r\n\t\tC119.4,318.1,109,326.4,102.8,336z"},"children":[{"name":"path","attribs":{"d":"M144.1,322c7-3.5,14.6-4.3,22.3-5.1c2.8-0.3,4.1-2.2,2-4.9c-4-5.1-17.8-6.1-23.6-8.4c-3.6-1.4-4.6-2.7-4.9-6.7\r\n\t\tc-0.1-1.8-1.1-9.8,0.3-11.1c1-1,7.3-0.6,8.7-0.8c5.7-0.7,11.5-1.9,16.9-4c2.3-0.9,4.5-2,6.5-3.4c2.4-1.8-1.8-6.2-2.9-8.6\r\n\t\tc-3.4-7.5-4.9-15.7-5.4-23.9c-1-16.1,1.5-32.3-1.5-48.3c-4.5-24.5-23.4-36.8-47.5-36.8c-14.9,0-29.6,5.1-37.9,18.1\r\n\t\tc-9.2,14.3-8.7,32.1-8.2,48.4c0.3,9.3,0.7,18.7-0.6,28c-0.6,4-1.5,7.9-2.9,11.7c-1.1,2.9-6.7,10.1-4.5,11.6\r\n\t\tc8.3,5.9,22.3,7.9,32.3,7.1c0.3,4.9,1.2,11.2-0.6,15.8c-2.8,7.2-23.7,9.1-30,11.2C45,317.8,32,332.5,32,352c18.3,0,36.5,0,54.8,0\r\n\t\tc8.2,0,16.4,0,24.7,0c1.3,0,6.3-9.3,7.7-10.8C126.2,333.4,134.8,326.7,144.1,322C153.1,317.5,129.5,329.4,144.1,322z M102.8,336\r\n\t\tc-16.3,0-32.6,0-48.9,0c7.1-11.8,24.9-11,36.6-15.2c10.8-3.9,17.7-10.5,18.8-22c0.1-1.3,0.2-29.2-0.9-29.2\r\n\t\tc-8.7-0.3-17.8-0.1-26.5-1.4c6.9-22.3,0.3-45.3,4-67.8c2.7-16.3,13.1-25.3,29.7-25.3c15.9,0,27.7,7.4,31.1,23.4\r\n\t\tc4.8,23.2-2,46.9,5.4,69.9c-5.5,1.4-11.3,1.6-17,1.8c-2.8,0.1-5.7,0.2-8.5,0.3c-1.8,0.1-1.2,3.2-1.3,4.7c-1,10.9-5,28.1,3.7,36.9\r\n\t\tC119.4,318.1,109,326.4,102.8,336z"},"children":[]}]},{"name":"path","attribs":{"d":"M399.8,352c26.7,0,53.5,0,80.2,0c0-19.5-13.1-34.3-30.7-40.1c-8.1-2.6-23.7-3.4-29.5-10.4c-2.9-3.5-1.3-12.4-1-16.6\r\n\t\tc4.4,0.4,9.2-0.3,13.7-0.9c4.1-0.6,8.1-1.4,12-2.8c1.8-0.7,3.6-1.4,5.3-2.4c3.9-2.3,2.1-2.7,0.1-6.1c-10.9-18.3-6-41.5-6.5-61.6\r\n\t\tc-0.4-16.7-4.8-35-20-44.4c-13.7-8.5-34-8.8-48.7-2.8c-42.4,17-17.4,73.2-31.9,105.4c-2.5,5.4-6.1,7.3,0.2,10.5\r\n\t\tc3.5,1.8,7.3,3,11.1,3.9c5.8,1.4,11.8,2.2,17.8,2.4c1,0,0.3,12.6,0,13.9c-1.1,4.9-11.8,6.3-15.8,7.4c-4.1,1.1-10.9,1.4-12.9,5.7\r\n\t\tc-3,6.4,9.9,4.8,13.1,5.4c10.3,1.9,19.4,7.6,27.4,14.1C389.6,337.4,397.6,344.2,399.8,352z M399.4,324.9c-5.1-4.7-10.4-9.3-16.3-13\r\n\t\tc8.8-8.8,4.7-25.9,3.7-36.9c-0.6-6.3-2-4.7-8.3-4.9c-6-0.2-12.8,0.1-18.5-1.8c7.2-22.3,1.3-45.2,5-67.9\r\n\t\tc2.8-17.1,14.5-25.5,31.5-25.5c15.4,0,26,7.7,29.2,23c4.9,23.1-2.6,47,4.5,70c-8.5,1.3-17.3,1-25.9,1.3c-2.1,0.1-1.9,25.1-1.7,27.3\r\n\t\tc0.7,11.7,6.1,18.8,17.2,23.3c12.1,4.9,31,3.6,38.4,15.9c-9.3,0-18.5,0-27.8,0c-5.6,0-11.2,0-16.9,0\r\n\t\tC406.4,335.8,404.6,329.6,399.4,324.9C394.4,320.3,403.4,328.5,399.4,324.9z"},"children":[{"name":"path","attribs":{"d":"M399.8,352c26.7,0,53.5,0,80.2,0c0-19.5-13.1-34.3-30.7-40.1c-8.1-2.6-23.7-3.4-29.5-10.4c-2.9-3.5-1.3-12.4-1-16.6\r\n\t\tc4.4,0.4,9.2-0.3,13.7-0.9c4.1-0.6,8.1-1.4,12-2.8c1.8-0.7,3.6-1.4,5.3-2.4c3.9-2.3,2.1-2.7,0.1-6.1c-10.9-18.3-6-41.5-6.5-61.6\r\n\t\tc-0.4-16.7-4.8-35-20-44.4c-13.7-8.5-34-8.8-48.7-2.8c-42.4,17-17.4,73.2-31.9,105.4c-2.5,5.4-6.1,7.3,0.2,10.5\r\n\t\tc3.5,1.8,7.3,3,11.1,3.9c5.8,1.4,11.8,2.2,17.8,2.4c1,0,0.3,12.6,0,13.9c-1.1,4.9-11.8,6.3-15.8,7.4c-4.1,1.1-10.9,1.4-12.9,5.7\r\n\t\tc-3,6.4,9.9,4.8,13.1,5.4c10.3,1.9,19.4,7.6,27.4,14.1C389.6,337.4,397.6,344.2,399.8,352z M399.4,324.9c-5.1-4.7-10.4-9.3-16.3-13\r\n\t\tc8.8-8.8,4.7-25.9,3.7-36.9c-0.6-6.3-2-4.7-8.3-4.9c-6-0.2-12.8,0.1-18.5-1.8c7.2-22.3,1.3-45.2,5-67.9\r\n\t\tc2.8-17.1,14.5-25.5,31.5-25.5c15.4,0,26,7.7,29.2,23c4.9,23.1-2.6,47,4.5,70c-8.5,1.3-17.3,1-25.9,1.3c-2.1,0.1-1.9,25.1-1.7,27.3\r\n\t\tc0.7,11.7,6.1,18.8,17.2,23.3c12.1,4.9,31,3.6,38.4,15.9c-9.3,0-18.5,0-27.8,0c-5.6,0-11.2,0-16.9,0\r\n\t\tC406.4,335.8,404.6,329.6,399.4,324.9C394.4,320.3,403.4,328.5,399.4,324.9z"},"children":[]}]}]}]};exports.iosPeopleOutline=iosPeopleOutline;var iosPeople={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M349.2,334.8C360.5,338.7,338,330.9,349.2,334.8L349.2,334.8z"},"children":[{"name":"path","attribs":{"d":"M349.2,334.8C360.5,338.7,338,330.9,349.2,334.8L349.2,334.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M349.2,334.8c-13.5-4.7-28.1-5-41.6-9.7c-4.1-1.4-12.2-3.1-13.9-7.8c-1.6-4.6-1.6-10-1.9-14.8c-0.2-3.8-0.3-7.6-0.3-11.4\r\n\t\tc0-2.5,6.4-7.8,7.8-10.1c5.4-9,5.9-21.1,6.9-31.3c8.7,2.4,9.8-13.7,11.3-18.6c1.1-3.4,7.8-26.8-2.6-23.6c2.5-4.4,3.5-9.8,4.2-14.7\r\n\t\tc2-12.8,2.8-26.8-1.1-39.3c-8.1-26-33-40.6-59.3-41.4c-26.7-0.9-53.5,11.9-63.5,37.8c-4.8,12.6-4.4,26.3-2.8,39.5\r\n\t\tc0.7,6,1.7,12.7,4.7,18.1c-9.7-2.9-4.5,17.7-3.4,21.3c1.6,5.1,3,23.4,12.1,20.9c0.8,8.1,1.7,16.4,3.9,24.3\r\n\t\tc1.5,5.3,4.6,9.8,8.2,13.9c1.8,2,2.7,2.2,2.6,4.8c-0.1,7.8,0.1,16.2-1.9,23.8c-2,7.6-18.7,10.8-25.4,12.2\r\n\t\tc-18,3.7-34.6,5.4-49.6,16.6C126.1,358.2,117,378.3,117,400c83.3,0,166.6,0,249.9,0c9.4,0,18.7,0,28.1,0\r\n\t\tC395,370.5,377.2,344.5,349.2,334.8z"},"children":[{"name":"path","attribs":{"d":"M349.2,334.8c-13.5-4.7-28.1-5-41.6-9.7c-4.1-1.4-12.2-3.1-13.9-7.8c-1.6-4.6-1.6-10-1.9-14.8c-0.2-3.8-0.3-7.6-0.3-11.4\r\n\t\tc0-2.5,6.4-7.8,7.8-10.1c5.4-9,5.9-21.1,6.9-31.3c8.7,2.4,9.8-13.7,11.3-18.6c1.1-3.4,7.8-26.8-2.6-23.6c2.5-4.4,3.5-9.8,4.2-14.7\r\n\t\tc2-12.8,2.8-26.8-1.1-39.3c-8.1-26-33-40.6-59.3-41.4c-26.7-0.9-53.5,11.9-63.5,37.8c-4.8,12.6-4.4,26.3-2.8,39.5\r\n\t\tc0.7,6,1.7,12.7,4.7,18.1c-9.7-2.9-4.5,17.7-3.4,21.3c1.6,5.1,3,23.4,12.1,20.9c0.8,8.1,1.7,16.4,3.9,24.3\r\n\t\tc1.5,5.3,4.6,9.8,8.2,13.9c1.8,2,2.7,2.2,2.6,4.8c-0.1,7.8,0.1,16.2-1.9,23.8c-2,7.6-18.7,10.8-25.4,12.2\r\n\t\tc-18,3.7-34.6,5.4-49.6,16.6C126.1,358.2,117,378.3,117,400c83.3,0,166.6,0,249.9,0c9.4,0,18.7,0,28.1,0\r\n\t\tC395,370.5,377.2,344.5,349.2,334.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M143.3,322.5c0.6-0.3,1.2-0.6,1.6-0.8c-0.3,0.1-0.6,0.3-0.8,0.4C143.8,322.2,143.6,322.3,143.3,322.5z"},"children":[{"name":"path","attribs":{"d":"M143.3,322.5c0.6-0.3,1.2-0.6,1.6-0.8c-0.3,0.1-0.6,0.3-0.8,0.4C143.8,322.2,143.6,322.3,143.3,322.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M143.3,322.5c-3.4,1.7-7.5,3.8,0.8-0.4c3-1.5,2.4-1.2,0.8-0.4c6.8-3.2,14.1-4,21.4-4.7c2.8-0.3,4.1-2.2,2-4.9\r\n\t\tc-4-5.1-17.8-6.1-23.6-8.4c-3.6-1.4-4.6-2.7-4.9-6.7c-0.1-1.8-1.1-9.8,0.3-11.1c1-1,7.3-0.6,8.7-0.8c5.7-0.7,11.5-1.9,16.9-4\r\n\t\tc2.3-0.9,4.5-2,6.5-3.4c2.4-1.8-1.8-6.2-2.9-8.6c-3.4-7.5-4.9-15.7-5.4-23.9c-1-16.1,1.5-32.3-1.5-48.3\r\n\t\tc-4.5-24.5-23.4-36.8-47.5-36.8c-14.9,0-29.6,5.1-37.9,18.1c-9.2,14.3-8.7,32.1-8.2,48.4c0.3,9.3,0.7,18.7-0.6,28\r\n\t\tc-0.6,4-1.5,7.9-2.9,11.7c-1.1,2.9-6.7,10.1-4.5,11.6c8.3,5.9,22.3,7.9,32.3,7.1c0.3,4.9,1.2,11.2-0.6,15.8\r\n\t\tc-2.8,7.2-23.7,9.1-30,11.2C45,317.8,32,332,32,352c18.3,0,36.5,0,54.8,0c8.2,0,16.4,0,24.7,0c1.3,0,6.3-9.3,7.7-10.8\r\n\t\tC126,333.7,134.3,327.2,143.3,322.5z"},"children":[{"name":"path","attribs":{"d":"M143.3,322.5c-3.4,1.7-7.5,3.8,0.8-0.4c3-1.5,2.4-1.2,0.8-0.4c6.8-3.2,14.1-4,21.4-4.7c2.8-0.3,4.1-2.2,2-4.9\r\n\t\tc-4-5.1-17.8-6.1-23.6-8.4c-3.6-1.4-4.6-2.7-4.9-6.7c-0.1-1.8-1.1-9.8,0.3-11.1c1-1,7.3-0.6,8.7-0.8c5.7-0.7,11.5-1.9,16.9-4\r\n\t\tc2.3-0.9,4.5-2,6.5-3.4c2.4-1.8-1.8-6.2-2.9-8.6c-3.4-7.5-4.9-15.7-5.4-23.9c-1-16.1,1.5-32.3-1.5-48.3\r\n\t\tc-4.5-24.5-23.4-36.8-47.5-36.8c-14.9,0-29.6,5.1-37.9,18.1c-9.2,14.3-8.7,32.1-8.2,48.4c0.3,9.3,0.7,18.7-0.6,28\r\n\t\tc-0.6,4-1.5,7.9-2.9,11.7c-1.1,2.9-6.7,10.1-4.5,11.6c8.3,5.9,22.3,7.9,32.3,7.1c0.3,4.9,1.2,11.2-0.6,15.8\r\n\t\tc-2.8,7.2-23.7,9.1-30,11.2C45,317.8,32,332,32,352c18.3,0,36.5,0,54.8,0c8.2,0,16.4,0,24.7,0c1.3,0,6.3-9.3,7.7-10.8\r\n\t\tC126,333.7,134.3,327.2,143.3,322.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M449.3,311.9c-8.1-2.6-23.7-3.4-29.5-10.4c-2.9-3.5-1.3-12.4-1-16.6c4.4,0.4,9.2-0.3,13.7-0.9c4.1-0.6,8.1-1.4,12-2.8\r\n\t\tc1.8-0.7,3.6-1.4,5.3-2.4c3.9-2.3,2.1-2.7,0.1-6.1c-10.9-18.3-6-41.5-6.5-61.6c-0.4-16.7-4.8-35-20-44.4c-13.7-8.5-34-8.8-48.7-2.8\r\n\t\tc-42.4,17-17.4,73.2-31.9,105.4c-2.5,5.4-6.1,7.3,0.2,10.5c3.5,1.8,7.3,3,11.1,3.9c5.8,1.4,11.8,2.2,17.8,2.4c1,0,0.3,12.6,0,13.9\r\n\t\tc-1.1,4.9-11.8,6.3-15.8,7.4c-4.1,1.1-10.9,1.4-12.9,5.7c-3,6.4,9.9,4.8,13.1,5.4c10.3,1.9,19.4,7.6,27.4,14.1\r\n\t\tc6,4.9,14.1,11.5,16.3,19.5c26.7,0,53.5,0,80.2,0C480,332,466.9,317.7,449.3,311.9z"},"children":[{"name":"path","attribs":{"d":"M449.3,311.9c-8.1-2.6-23.7-3.4-29.5-10.4c-2.9-3.5-1.3-12.4-1-16.6c4.4,0.4,9.2-0.3,13.7-0.9c4.1-0.6,8.1-1.4,12-2.8\r\n\t\tc1.8-0.7,3.6-1.4,5.3-2.4c3.9-2.3,2.1-2.7,0.1-6.1c-10.9-18.3-6-41.5-6.5-61.6c-0.4-16.7-4.8-35-20-44.4c-13.7-8.5-34-8.8-48.7-2.8\r\n\t\tc-42.4,17-17.4,73.2-31.9,105.4c-2.5,5.4-6.1,7.3,0.2,10.5c3.5,1.8,7.3,3,11.1,3.9c5.8,1.4,11.8,2.2,17.8,2.4c1,0,0.3,12.6,0,13.9\r\n\t\tc-1.1,4.9-11.8,6.3-15.8,7.4c-4.1,1.1-10.9,1.4-12.9,5.7c-3,6.4,9.9,4.8,13.1,5.4c10.3,1.9,19.4,7.6,27.4,14.1\r\n\t\tc6,4.9,14.1,11.5,16.3,19.5c26.7,0,53.5,0,80.2,0C480,332,466.9,317.7,449.3,311.9z"},"children":[]}]}]}]};exports.iosPeople=iosPeople;var iosPersonOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M202.4,201.7L202.4,201.7L202.4,201.7z"},"children":[{"name":"path","attribs":{"d":"M202.4,201.7L202.4,201.7L202.4,201.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\ts6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5l0,0c0,0,4.9-13.6,5.6-42.4\r\n\t\tC331.1,129.6,305,96,256,96s-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4l0,0c-0.5,0-5.2,0.5-5.7,9.5c-0.5,9.7,3.6,14.9,6.1,27.9\r\n\t\tc2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9c-3.3,4-13.2,7.7-20,9.2\r\n\t\tc-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z M256,400H118.7\r\n\t\tc2-3,4.7-5.1,8.2-7.6c7-5.1,16.1-9.8,27.1-13.6c6.8-2.4,16.7-4,25.4-5.3c5.7-0.9,11.1-1.7,15.9-2.8c3.4-0.8,20.8-5,28.8-14.6\r\n\t\tc4.5-5.4,5.8-12.7,5.6-32.3c-0.1-10-0.6-19.3-0.6-19.7l-0.2-4.2l-2.3-3.5c-1.5-2.3-5.8-9.5-8-15.3c-1.8-4.7-4.6-19.2-6-28.1\r\n\t\tc0,0,0.4,1-0.5-3.7c-0.9-4.7-8.4-4.3-9.4-8c-0.9-3.6-1.8-6.9-4.3-18.2c-2.5-11.3,2.8-11.2,3.9-16.2c0.6-3.1,0-5.7,0-5.8l0,0\r\n\t\tc-0.3-1-4.1-13.4-4.7-37.7c-0.3-13.2,4.6-25.6,13.8-34.9c10.6-10.8,26-16.5,44.5-16.5c19,0,34,5.7,44.6,16.5\r\n\t\tc9.2,9.3,14.1,21.7,13.8,34.9c-0.5,24.2-4.3,36.6-4.7,37.7l0,0c0,0.1-0.6,1.7-0.4,5.2c0.2,5.4,6.8,5.5,4.3,16.8\r\n\t\tc-2.5,11.3-3.4,14.6-4.3,18.2c-0.9,3.6-8.5,3.3-9.4,8c-0.9,4.7-0.5,3.7-0.5,3.7c-1.4,8.9-4.2,23.4-6,28.1c-2.3,5.8-6.6,13-8,15.3\r\n\t\tl-2.3,3.5l-0.2,4.2c0,0.4-0.5,9.7-0.6,19.7c-0.2,19.6,1.1,26.9,5.6,32.3c8,9.5,25.4,13.8,28.8,14.6c4.8,1.1,10.2,1.9,15.9,2.8\r\n\t\tc8.7,1.3,18.6,2.9,25.4,5.3c11,3.9,20.2,8.6,27.1,13.7c3.5,2.5,6.2,4.6,8.2,7.6L256,400L256,400z"},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\ts6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5l0,0c0,0,4.9-13.6,5.6-42.4\r\n\t\tC331.1,129.6,305,96,256,96s-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4l0,0c-0.5,0-5.2,0.5-5.7,9.5c-0.5,9.7,3.6,14.9,6.1,27.9\r\n\t\tc2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9c-3.3,4-13.2,7.7-20,9.2\r\n\t\tc-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z M256,400H118.7\r\n\t\tc2-3,4.7-5.1,8.2-7.6c7-5.1,16.1-9.8,27.1-13.6c6.8-2.4,16.7-4,25.4-5.3c5.7-0.9,11.1-1.7,15.9-2.8c3.4-0.8,20.8-5,28.8-14.6\r\n\t\tc4.5-5.4,5.8-12.7,5.6-32.3c-0.1-10-0.6-19.3-0.6-19.7l-0.2-4.2l-2.3-3.5c-1.5-2.3-5.8-9.5-8-15.3c-1.8-4.7-4.6-19.2-6-28.1\r\n\t\tc0,0,0.4,1-0.5-3.7c-0.9-4.7-8.4-4.3-9.4-8c-0.9-3.6-1.8-6.9-4.3-18.2c-2.5-11.3,2.8-11.2,3.9-16.2c0.6-3.1,0-5.7,0-5.8l0,0\r\n\t\tc-0.3-1-4.1-13.4-4.7-37.7c-0.3-13.2,4.6-25.6,13.8-34.9c10.6-10.8,26-16.5,44.5-16.5c19,0,34,5.7,44.6,16.5\r\n\t\tc9.2,9.3,14.1,21.7,13.8,34.9c-0.5,24.2-4.3,36.6-4.7,37.7l0,0c0,0.1-0.6,1.7-0.4,5.2c0.2,5.4,6.8,5.5,4.3,16.8\r\n\t\tc-2.5,11.3-3.4,14.6-4.3,18.2c-0.9,3.6-8.5,3.3-9.4,8c-0.9,4.7-0.5,3.7-0.5,3.7c-1.4,8.9-4.2,23.4-6,28.1c-2.3,5.8-6.6,13-8,15.3\r\n\t\tl-2.3,3.5l-0.2,4.2c0,0.4-0.5,9.7-0.6,19.7c-0.2,19.6,1.1,26.9,5.6,32.3c8,9.5,25.4,13.8,28.8,14.6c4.8,1.1,10.2,1.9,15.9,2.8\r\n\t\tc8.7,1.3,18.6,2.9,25.4,5.3c11,3.9,20.2,8.6,27.1,13.7c3.5,2.5,6.2,4.6,8.2,7.6L256,400L256,400z"},"children":[]}]}]}]};exports.iosPersonOutline=iosPersonOutline;var iosPerson={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\ts6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5l0,0c0,0,4.9-13.6,5.6-42.4\r\n\t\tC331.1,129.6,305,96,256,96s-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4l0,0c-0.5,0-5.2,0.5-5.7,9.5c-0.5,9.7,3.6,14.9,6.1,27.9\r\n\t\tc2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9c-3.3,4-13.2,7.7-20,9.2\r\n\t\tc-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z"},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\ts6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5l0,0c0,0,4.9-13.6,5.6-42.4\r\n\t\tC331.1,129.6,305,96,256,96s-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4l0,0c-0.5,0-5.2,0.5-5.7,9.5c-0.5,9.7,3.6,14.9,6.1,27.9\r\n\t\tc2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9c-3.3,4-13.2,7.7-20,9.2\r\n\t\tc-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z"},"children":[]}]}]}]};exports.iosPerson=iosPerson;var iosPersonaddOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"416,153 391,153 391,128 377,128 377,153 352,153 352,167 377,167 377,192 391,192 391,167 416,167 \t"},"children":[{"name":"polygon","attribs":{"points":"416,153 391,153 391,128 377,128 377,153 352,153 352,167 377,167 377,192 391,192 391,167 416,167 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M202.4,201.7C202.4,201.7,202.4,201.7,202.4,201.7L202.4,201.7z"},"children":[{"name":"path","attribs":{"d":"M202.4,201.7C202.4,201.7,202.4,201.7,202.4,201.7L202.4,201.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\t\tc3.3-8.4,6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5c0,0,0,0,0,0s4.9-13.6,5.6-42.4\r\n\t\t\tC331.1,129.6,305,96,256,96c-49,0-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4s0,0,0,0c-0.5,0-5.2,0.5-5.7,9.5\r\n\t\t\tc-0.5,9.7,3.6,14.9,6.1,27.9c2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9\r\n\t\t\tc-3.3,4-13.2,7.7-20,9.2c-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z\r\n\t\t\t M256,400H118.7c2-3,4.7-5.1,8.2-7.6c7-5.1,16.1-9.8,27.1-13.6c6.8-2.4,16.7-4,25.4-5.3c5.7-0.9,11.1-1.7,15.9-2.8\r\n\t\t\tc3.4-0.8,20.8-5,28.8-14.6c4.5-5.4,5.8-12.7,5.6-32.3c-0.1-10-0.6-19.3-0.6-19.7l-0.2-4.2l-2.3-3.5c-1.5-2.3-5.8-9.5-8-15.3\r\n\t\t\tc-1.8-4.7-4.6-19.2-6-28.1c0,0,0.4,1-0.5-3.7c-0.9-4.7-8.4-4.3-9.4-8c-0.9-3.6-1.8-6.9-4.3-18.2c-2.5-11.3,2.8-11.2,3.9-16.2\r\n\t\t\tc0.6-3.1,0-5.7,0-5.8c0,0,0,0,0,0c-0.3-1-4.1-13.4-4.7-37.7c-0.3-13.2,4.6-25.6,13.8-34.9c10.6-10.8,26-16.5,44.5-16.5\r\n\t\t\tc19,0,34,5.7,44.6,16.5c9.2,9.3,14.1,21.7,13.8,34.9c-0.5,24.2-4.3,36.6-4.7,37.7c0,0,0,0,0,0c0,0.1-0.6,1.7-0.4,5.2\r\n\t\t\tc0.2,5.4,6.8,5.5,4.3,16.8c-2.5,11.3-3.4,14.6-4.3,18.2c-0.9,3.6-8.5,3.3-9.4,8s-0.5,3.7-0.5,3.7c-1.4,8.9-4.2,23.4-6,28.1\r\n\t\t\tc-2.3,5.8-6.6,13-8,15.3l-2.3,3.5l-0.2,4.2c0,0.4-0.5,9.7-0.6,19.7c-0.2,19.6,1.1,26.9,5.6,32.3c8,9.5,25.4,13.8,28.8,14.6\r\n\t\t\tc4.8,1.1,10.2,1.9,15.9,2.8c8.7,1.3,18.6,2.9,25.4,5.3c11,3.9,20.2,8.6,27.1,13.7c3.5,2.5,6.2,4.6,8.2,7.6H256z"},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\t\tc3.3-8.4,6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5c0,0,0,0,0,0s4.9-13.6,5.6-42.4\r\n\t\t\tC331.1,129.6,305,96,256,96c-49,0-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4s0,0,0,0c-0.5,0-5.2,0.5-5.7,9.5\r\n\t\t\tc-0.5,9.7,3.6,14.9,6.1,27.9c2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9\r\n\t\t\tc-3.3,4-13.2,7.7-20,9.2c-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z\r\n\t\t\t M256,400H118.7c2-3,4.7-5.1,8.2-7.6c7-5.1,16.1-9.8,27.1-13.6c6.8-2.4,16.7-4,25.4-5.3c5.7-0.9,11.1-1.7,15.9-2.8\r\n\t\t\tc3.4-0.8,20.8-5,28.8-14.6c4.5-5.4,5.8-12.7,5.6-32.3c-0.1-10-0.6-19.3-0.6-19.7l-0.2-4.2l-2.3-3.5c-1.5-2.3-5.8-9.5-8-15.3\r\n\t\t\tc-1.8-4.7-4.6-19.2-6-28.1c0,0,0.4,1-0.5-3.7c-0.9-4.7-8.4-4.3-9.4-8c-0.9-3.6-1.8-6.9-4.3-18.2c-2.5-11.3,2.8-11.2,3.9-16.2\r\n\t\t\tc0.6-3.1,0-5.7,0-5.8c0,0,0,0,0,0c-0.3-1-4.1-13.4-4.7-37.7c-0.3-13.2,4.6-25.6,13.8-34.9c10.6-10.8,26-16.5,44.5-16.5\r\n\t\t\tc19,0,34,5.7,44.6,16.5c9.2,9.3,14.1,21.7,13.8,34.9c-0.5,24.2-4.3,36.6-4.7,37.7c0,0,0,0,0,0c0,0.1-0.6,1.7-0.4,5.2\r\n\t\t\tc0.2,5.4,6.8,5.5,4.3,16.8c-2.5,11.3-3.4,14.6-4.3,18.2c-0.9,3.6-8.5,3.3-9.4,8s-0.5,3.7-0.5,3.7c-1.4,8.9-4.2,23.4-6,28.1\r\n\t\t\tc-2.3,5.8-6.6,13-8,15.3l-2.3,3.5l-0.2,4.2c0,0.4-0.5,9.7-0.6,19.7c-0.2,19.6,1.1,26.9,5.6,32.3c8,9.5,25.4,13.8,28.8,14.6\r\n\t\t\tc4.8,1.1,10.2,1.9,15.9,2.8c8.7,1.3,18.6,2.9,25.4,5.3c11,3.9,20.2,8.6,27.1,13.7c3.5,2.5,6.2,4.6,8.2,7.6H256z"},"children":[]}]}]}]}]}]};exports.iosPersonaddOutline=iosPersonaddOutline;var iosPersonadd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"416,153 391,153 391,128 377,128 377,153 352,153 352,167 377,167 377,192 391,192 391,167 416,167 \t"},"children":[{"name":"polygon","attribs":{"points":"416,153 391,153 391,128 377,128 377,153 352,153 352,167 377,167 377,192 391,192 391,167 416,167 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\t\tc3.3-8.4,6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5c0,0,0,0,0,0s4.9-13.6,5.6-42.4\r\n\t\t\tC331.1,129.6,305,96,256,96c-49,0-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4s0,0,0,0c-0.5,0-5.2,0.5-5.7,9.5\r\n\t\t\tc-0.5,9.7,3.6,14.9,6.1,27.9c2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9\r\n\t\t\tc-3.3,4-13.2,7.7-20,9.2c-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z"},"children":[{"name":"path","attribs":{"d":"M363.3,363.9c-12.9-4.6-31.4-6.2-43.2-8.8c-6.8-1.5-16.7-5.3-20-9.2c-3.3-4-1.3-40.9-1.3-40.9s6.1-9.6,9.4-18\r\n\t\t\tc3.3-8.4,6.9-31.4,6.9-31.4s6.8,0,9.2-11.9c2.6-13,6.6-18.4,6.1-28.1c-0.5-9-5.2-9.5-5.7-9.5c0,0,0,0,0,0s4.9-13.6,5.6-42.4\r\n\t\t\tC331.1,129.6,305,96,256,96c-49,0-75,33.5-74.3,67.6c0.6,28.7,5.6,42.4,5.6,42.4s0,0,0,0c-0.5,0-5.2,0.5-5.7,9.5\r\n\t\t\tc-0.5,9.7,3.6,14.9,6.1,27.9c2.4,11.9,9.2,12,9.2,12s3.6,23.1,6.9,31.5c3.3,8.5,9.4,18,9.4,18s2,36.9-1.3,40.9\r\n\t\t\tc-3.3,4-13.2,7.7-20,9.2c-11.9,2.6-30.3,4.3-43.2,8.9C135.8,368.5,96,384,96,416h160h160C416,384,376.2,368.5,363.3,363.9z"},"children":[]}]}]}]}]}]};exports.iosPersonadd=iosPersonadd;var iosPhotosOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M96,128v320h384V128H96z M464,432H112V144h352V432z"},"children":[{"name":"path","attribs":{"d":"M96,128v320h384V128H96z M464,432H112V144h352V432z"},"children":[]}]},{"name":"polygon","attribs":{"points":"32,64 32,384 80,384 80,368 48,368 48,80 400,80 400,112 416,112 416,64 \t"},"children":[{"name":"polygon","attribs":{"points":"32,64 32,384 80,384 80,368 48,368 48,80 400,80 400,112 416,112 416,64 \t"},"children":[]}]}]}]};exports.iosPhotosOutline=iosPhotosOutline;var iosPhotos={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M96,128v320h384V128H96z"},"children":[{"name":"path","attribs":{"d":"M96,128v320h384V128H96z"},"children":[]}]},{"name":"polygon","attribs":{"points":"416,64 32,64 32,384 80,384 80,112 416,112 \t"},"children":[{"name":"polygon","attribs":{"points":"416,64 32,64 32,384 80,384 80,112 416,112 \t"},"children":[]}]}]}]};exports.iosPhotos=iosPhotos;var iosPieOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,80.826c45.293,3.705,87.354,23.024,119.809,55.494C444.044,172.57,464,220.744,464,272.043\r\n\t\tc0,25.924-5.08,51.042-15.099,74.703c-9.68,22.859-23.54,43.384-41.194,61.024c-17.654,17.639-38.204,31.481-61.08,41.151\r\n\t\tc-23.673,10.01-48.823,15.081-74.752,15.081c-41.193,0-80.47-12.847-113.584-37.146c-15.95-11.705-29.957-25.733-41.633-41.692\r\n\t\tc-8.378-11.453-15.422-23.724-21.041-36.634l180.259-45.008L288,300.496V288V81 M272,64v224L74.245,337.376\r\n\t\tC101.653,420.221,179.841,480,271.875,480C386.75,480,480,386.875,480,272S387,64,272,64L272,64z"},"children":[{"name":"path","attribs":{"d":"M288,80.826c45.293,3.705,87.354,23.024,119.809,55.494C444.044,172.57,464,220.744,464,272.043\r\n\t\tc0,25.924-5.08,51.042-15.099,74.703c-9.68,22.859-23.54,43.384-41.194,61.024c-17.654,17.639-38.204,31.481-61.08,41.151\r\n\t\tc-23.673,10.01-48.823,15.081-74.752,15.081c-41.193,0-80.47-12.847-113.584-37.146c-15.95-11.705-29.957-25.733-41.633-41.692\r\n\t\tc-8.378-11.453-15.422-23.724-21.041-36.634l180.259-45.008L288,300.496V288V81 M272,64v224L74.245,337.376\r\n\t\tC101.653,420.221,179.841,480,271.875,480C386.75,480,480,386.875,480,272S387,64,272,64L272,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M240,48.181v214.943L59.658,308.854c-9.117-23.568-11.197-56.973-11.158-69.496v-0.036v-0.035\r\n\t\tc0-47.311,16.465-93.746,45.173-127.398c16.735-19.618,37.502-34.981,61.721-45.663C180.099,55.331,208.519,49.274,240,48.181\r\n\t\t M256,32h-5.5C90.5,32,32,148.25,32,239.287c0,0,0.25,56.666,18.91,88.291L256,275.573V32L256,32z"},"children":[{"name":"path","attribs":{"d":"M240,48.181v214.943L59.658,308.854c-9.117-23.568-11.197-56.973-11.158-69.496v-0.036v-0.035\r\n\t\tc0-47.311,16.465-93.746,45.173-127.398c16.735-19.618,37.502-34.981,61.721-45.663C180.099,55.331,208.519,49.274,240,48.181\r\n\t\t M256,32h-5.5C90.5,32,32,148.25,32,239.287c0,0,0.25,56.666,18.91,88.291L256,275.573V32L256,32z"},"children":[]}]}]}]};exports.iosPieOutline=iosPieOutline;var iosPie={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M272,64v224L74.245,337.376C101.653,420.221,179.841,480,271.875,480C386.75,480,480,386.875,480,272S387,64,272,64L272,64\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M272,64v224L74.245,337.376C101.653,420.221,179.841,480,271.875,480C386.75,480,480,386.875,480,272S387,64,272,64L272,64\r\n\t\tz"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32h-5.5C90.5,32,32,148.25,32,239.287c0,0,0.25,56.666,18.91,88.291L256,275.573V32L256,32z"},"children":[{"name":"path","attribs":{"d":"M256,32h-5.5C90.5,32,32,148.25,32,239.287c0,0,0.25,56.666,18.91,88.291L256,275.573V32L256,32z"},"children":[]}]}]}]};exports.iosPie=iosPie;var iosPintOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M368,170.085c0-21.022-0.973-88.554-19.308-125.013C344.244,36.228,336.25,32,316.999,32H195.001\r\n\tc-19.25,0-27.246,4.197-31.693,13.041C144.973,81.5,144,149.25,144,170.272c0,98,32,100.353,32,180.853c0,39.5-16,71.402-16,99.402\r\n\tc0,27,9,29.473,32,29.473h128c23,0,32-2.535,32-29.535c0-28-16-59.715-16-99.215C336,270.75,368,268.085,368,170.085z\r\n\t M177.602,51.983c0.778-1.546,1.339-1.763,2.53-2.295c1.977-0.884,6.161-1.688,14.869-1.688h121.998\r\n\tc8.708,0,12.893,0.803,14.869,1.687c1.19,0.532,1.752,0.872,2.53,2.418c8.029,15.967,13.601,42.611,16.105,75.896H161.496\r\n\tC164.001,94.653,169.572,67.951,177.602,51.983z M334.631,462.636C332.76,463.377,327.844,464,320,464H192\r\n\tc-7.844,0-12.761-0.623-14.639-1.359c-0.394-0.93-1.361-4.166-1.361-12.27c0-10.856,3.016-23.16,6.508-37.334\r\n\tc4.449-18.059,9.492-38.557,9.492-61.943c0-40.997-7.993-63.802-15.724-85.842C168.274,242.438,160,218.838,160,170.155\r\n\tc0-9.025,0.191-17.756,0.558-26.155h190.886c0.365,8.376,0.557,17.083,0.557,26.085c0,48.688-8.276,72.302-16.28,95.169\r\n\tc-7.728,22.079-15.72,44.895-15.72,85.887c0,23.39,5.043,43.822,9.493,61.856c3.491,14.15,6.507,26.368,6.507,37.222\r\n\tC336,458.355,335.024,461.713,334.631,462.636z"},"children":[]}]};exports.iosPintOutline=iosPintOutline;var iosPint={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M368,170.085c0-21.022-0.973-88.554-19.308-125.013C344.244,36.228,336.25,32,316.999,32H195.001\r\n\tc-19.25,0-27.246,4.197-31.693,13.041C144.973,81.5,144,149.25,144,170.272c0,98,32,100.353,32,180.853c0,39.5-16,71.402-16,99.402\r\n\tc0,27,9,29.473,32,29.473h128c23,0,32-2.535,32-29.535c0-28-16-59.715-16-99.215C336,270.75,368,268.085,368,170.085z\r\n\t M177.602,51.983c0.778-1.546,1.339-1.763,2.53-2.295c1.977-0.884,6.161-1.688,14.869-1.688h121.998\r\n\tc8.708,0,12.893,0.803,14.869,1.687c1.19,0.532,1.752,0.872,2.53,2.418c8.029,15.967,13.601,42.611,16.105,75.896H161.496\r\n\tC164.001,94.653,169.572,67.951,177.602,51.983z"},"children":[]}]};exports.iosPint=iosPint;var iosPlayOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,124.9L353.8,256L144,387.1V124.9 M128,96v320l256-160L128,96L128,96z"},"children":[{"name":"path","attribs":{"d":"M144,124.9L353.8,256L144,387.1V124.9 M128,96v320l256-160L128,96L128,96z"},"children":[]}]}]}]};exports.iosPlayOutline=iosPlayOutline;var iosPlay={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,96v320l256-160L128,96L128,96z"},"children":[{"name":"path","attribs":{"d":"M128,96v320l256-160L128,96L128,96z"},"children":[]}]}]}]};exports.iosPlay=iosPlay;var iosPlusEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,265H264v119h-17V265H128v-17h119V128h17v120h120V265z"},"children":[{"name":"path","attribs":{"d":"M384,265H264v119h-17V265H128v-17h119V128h17v120h120V265z"},"children":[]}]}]}]};exports.iosPlusEmpty=iosPlusEmpty;var iosPlusOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\t\tc-105.1,0-190.7-85.5-190.7-190.7S150.9,65.3,256,65.3S446.7,150.9,446.7,256S361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\t\tc-105.1,0-190.7-85.5-190.7-190.7S150.9,65.3,256,65.3S446.7,150.9,446.7,256S361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"264.1,128 247.3,128 247.3,247.9 128,247.9 128,264.7 247.3,264.7 247.3,384 264.1,384 264.1,264.7 384,264.7 \r\n\t\t\t384,247.9 264.1,247.9 \t\t"},"children":[{"name":"polygon","attribs":{"points":"264.1,128 247.3,128 247.3,247.9 128,247.9 128,264.7 247.3,264.7 247.3,384 264.1,384 264.1,264.7 384,264.7 \r\n\t\t\t384,247.9 264.1,247.9 \t\t"},"children":[]}]}]}]}]}]};exports.iosPlusOutline=iosPlusOutline;var iosPlus={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M384,265H264v119h-17V265\r\n\t\tH128v-17h119V128h17v120h120V265z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M384,265H264v119h-17V265\r\n\t\tH128v-17h119V128h17v120h120V265z"},"children":[]}]}]}]};exports.iosPlus=iosPlus;var iosPricetagOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M464,32H304L48,320l160,160l256-288V32z M448,184L208.125,456L72.062,320L311.587,48H448V184z"},"children":[{"name":"path","attribs":{"d":"M464,32H304L48,320l160,160l256-288V32z M448,184L208.125,456L72.062,320L311.587,48H448V184z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,160c17.645,0,32-14.355,32-32s-14.355-32-32-32s-32,14.355-32,32S350.355,160,368,160z M368,112\r\n\t\tc8.836,0,16,7.163,16,16s-7.164,16-16,16s-16-7.163-16-16S359.164,112,368,112z"},"children":[{"name":"path","attribs":{"d":"M368,160c17.645,0,32-14.355,32-32s-14.355-32-32-32s-32,14.355-32,32S350.355,160,368,160z M368,112\r\n\t\tc8.836,0,16,7.163,16,16s-7.164,16-16,16s-16-7.163-16-16S359.164,112,368,112z"},"children":[]}]}]}]};exports.iosPricetagOutline=iosPricetagOutline;var iosPricetag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"368","cy":"128","r":"16"},"children":[{"name":"circle","attribs":{"cx":"368","cy":"128","r":"16"},"children":[]}]},{"name":"path","attribs":{"d":"M304,32L48,320l160,160l256-288V32H304z M368,160c-17.645,0-32-14.355-32-32s14.355-32,32-32s32,14.355,32,32\r\n\t\tS385.645,160,368,160z"},"children":[{"name":"path","attribs":{"d":"M304,32L48,320l160,160l256-288V32H304z M368,160c-17.645,0-32-14.355-32-32s14.355-32,32-32s32,14.355,32,32\r\n\t\tS385.645,160,368,160z"},"children":[]}]}]}]};exports.iosPricetag=iosPricetag;var iosPricetagsOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,64V32H288L32,320l160,160l23.471-23.904L240,480l240-272V64H448z M192,457.371L54.39,320L294.621,48H432v16v16\r\n\t\tv105.377l-216.555,247.99l-11.34,11.363L192,457.371z M464,201.377L240,457.371l-13.182-12.65L448,192V80h16V201.377z"},"children":[{"name":"path","attribs":{"d":"M448,64V32H288L32,320l160,160l23.471-23.904L240,480l240-272V64H448z M192,457.371L54.39,320L294.621,48H432v16v16\r\n\t\tv105.377l-216.555,247.99l-11.34,11.363L192,457.371z M464,201.377L240,457.371l-13.182-12.65L448,192V80h16V201.377z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,160c17.645,0,32-14.355,32-32s-14.355-32-32-32s-32,14.355-32,32S334.355,160,352,160z M352,112\r\n\t\tc8.836,0,16,7.163,16,16s-7.164,16-16,16s-16-7.163-16-16S343.164,112,352,112z"},"children":[{"name":"path","attribs":{"d":"M352,160c17.645,0,32-14.355,32-32s-14.355-32-32-32s-32,14.355-32,32S334.355,160,352,160z M352,112\r\n\t\tc8.836,0,16,7.163,16,16s-7.164,16-16,16s-16-7.163-16-16S343.164,112,352,112z"},"children":[]}]}]}]};exports.iosPricetagsOutline=iosPricetagsOutline;var iosPricetags={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"464,64 464,201.377 227.153,467.48 240,480 480,208 480,64 \t\t"},"children":[{"name":"polygon","attribs":{"points":"464,64 464,201.377 227.153,467.48 240,480 480,208 480,64 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,32L32,320l160,160l23.471-23.904l11.348-11.375L448,192V80V64V32H288z M352,160c-17.645,0-32-14.355-32-32\r\n\t\t\ts14.355-32,32-32s32,14.355,32,32S369.645,160,352,160z"},"children":[{"name":"path","attribs":{"d":"M288,32L32,320l160,160l23.471-23.904l11.348-11.375L448,192V80V64V32H288z M352,160c-17.645,0-32-14.355-32-32\r\n\t\t\ts14.355-32,32-32s32,14.355,32,32S369.645,160,352,160z"},"children":[]}]},{"name":"circle","attribs":{"cx":"352","cy":"128","r":"16"},"children":[{"name":"circle","attribs":{"cx":"352","cy":"128","r":"16"},"children":[]}]}]}]}]}]};exports.iosPricetags=iosPricetags;var iosPrinterOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M432.5,112H400V64H112v48H80.5C62.9,112,48,125.8,48,143.3v158.4c0,17.5,14.9,32.3,32.5,32.3H128v114h256V334h48.5\r\n\t\tc17.6,0,31.5-14.8,31.5-32.3V143.3C464,125.8,450.1,112,432.5,112z M128,80h256v32H128V80z M368,432H144V240h224V432z M448,301.7\r\n\t\tc0,8.7-6.7,16.3-15.5,16.3H384v-94H128v94H80.5c-8.8,0-16.5-7.6-16.5-16.3V143.3c0-8.7,7.7-15.3,16.5-15.3H432h0.5\r\n\t\tc8.8,0,15.5,6.6,15.5,15.3V301.7z"},"children":[{"name":"path","attribs":{"d":"M432.5,112H400V64H112v48H80.5C62.9,112,48,125.8,48,143.3v158.4c0,17.5,14.9,32.3,32.5,32.3H128v114h256V334h48.5\r\n\t\tc17.6,0,31.5-14.8,31.5-32.3V143.3C464,125.8,450.1,112,432.5,112z M128,80h256v32H128V80z M368,432H144V240h224V432z M448,301.7\r\n\t\tc0,8.7-6.7,16.3-15.5,16.3H384v-94H128v94H80.5c-8.8,0-16.5-7.6-16.5-16.3V143.3c0-8.7,7.7-15.3,16.5-15.3H432h0.5\r\n\t\tc8.8,0,15.5,6.6,15.5,15.3V301.7z"},"children":[]}]}]}]};exports.iosPrinterOutline=iosPrinterOutline;var iosPrinter={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"224","width":"256","height":"224"},"children":[{"name":"rect","attribs":{"x":"128","y":"224","width":"256","height":"224"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"127.5","y":"224.5","width":"256","height":"224"},"children":[{"name":"rect","attribs":{"x":"127.5","y":"224.5","width":"256","height":"224"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"111.5","y":"64.5","width":"288","height":"32"},"children":[{"name":"rect","attribs":{"x":"111.5","y":"64.5","width":"288","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M432.5,112.5h-352c-17.645,0-33,12.842-33,30.309v158.393c0,17.468,15.355,33.299,33,33.299h31v-126h288v126h33\r\n\t\t\tc17.645,0,31-15.831,31-33.299V142.809C463.5,125.342,450.145,112.5,432.5,112.5z"},"children":[{"name":"path","attribs":{"d":"M432.5,112.5h-352c-17.645,0-33,12.842-33,30.309v158.393c0,17.468,15.355,33.299,33,33.299h31v-126h288v126h33\r\n\t\t\tc17.645,0,31-15.831,31-33.299V142.809C463.5,125.342,450.145,112.5,432.5,112.5z"},"children":[]}]}]}]}]}]};exports.iosPrinter=iosPrinter;var iosPulseStrong={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,273.001c-21.27,0-39.296,13.999-45.596,32.999h-38.857l-28.361-85.417c-2.176-6.553-8.303-10.956-15.183-10.956\r\n\tc-0.112,0-0.224,0-0.335,0.004c-7.016,0.145-13.117,4.844-15.049,11.588l-44.484,155.262L207.782,62.373\r\n\tC206.535,54.893,200.333,48,192,48s-13.693,5.776-15.525,13.135L115.496,306H16v31.999h112c7.348,0,13.75-5.003,15.525-12.134\r\n\tl45.368-182.177l51.324,307.94c1.229,7.377,7.397,11.92,14.864,12.344C255.389,463.99,255.695,464,256,464\r\n\tc7.097,0,13.406-3.701,15.381-10.594l49.744-173.617l15.689,47.252c2.173,6.543,8.292,10.958,15.186,10.958h51.108\r\n\tC409.973,355.999,427.477,369,448,369c26.511,0,48-22.492,48-49C496,293.491,474.511,273.001,448,273.001z"},"children":[]}]};exports.iosPulseStrong=iosPulseStrong;var iosPulse={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,288c-15.268,0-28.029,10.695-31.223,25h-59.004l-30.181-90.896c-1.105-3.329-4.246-5.543-7.759-5.478\r\n\tc-3.508,0.072-6.559,2.422-7.524,5.795L258.067,411.74L199.892,62.685c-0.624-3.74-3.787-6.528-7.576-6.679\r\n\tc-3.809-0.139-7.161,2.382-8.078,6.061L121.748,313H32v16h96c3.674,0,6.875-2.502,7.763-6.066l54.685-219.591l57.661,345.973\r\n\tc0.615,3.688,3.703,6.459,7.437,6.672c0.153,0.009,0.307,0.013,0.459,0.013c3.549,0,6.699-2.35,7.687-5.797l56.872-198.496\r\n\tl23.845,71.813c1.087,3.271,4.146,5.479,7.593,5.479h65.292c3.89,13.289,16.161,23,30.708,23c17.674,0,32-14.327,32-32\r\n\tS465.674,288,448,288z"},"children":[]}]};exports.iosPulse=iosPulse;var iosRainyOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M332.1,179.4c-2.8,0-5.7-0.1-8.4,0.3c-8.3-36.8-35.2-67.6-80.3-67.6c-50.9,0-82.3,38-82.3,83.6\r\n\tc0,2.8,0.1,5.5,0.4,8.2c-27.7,2.5-49.5,31.3-49.5,59.8c0,29.2,22.9,54.6,51.6,56.2l-24.5,34.4c-1.1,1.6-2,3.4-2,5.5\r\n\tc0,4.6,3.7,8.3,8.3,8.3c3,0,5.6-1.6,7.1-4l31-43.8h36.1l-46.1,65.8c-1.2,1.6-2.1,3.6-2.1,5.6c0,4.6,3.7,8.3,8.3,8.3\r\n\tc3,0,5.6-1.8,7.2-4.3l52.6-75.5h37.9l-24.9,34.4c-1.2,1.6-2.2,3.8-2.2,5.6c0,4.6,3.7,8.3,8.3,8.3c3.1,0,5.4-1.7,7.2-4.1l31.6-44.3\r\n\th34.7c0.1,0,0.3-0.1,0.4-0.1l-46.1,65.9c-1.3,1.7-2.3,3.6-2.3,5.8c0,4.6,3.7,8.3,8.3,8.3c3.2,0,5.5-2,7.4-4.5l55.5-79.8\r\n\tc26-9.9,44.6-35.8,44.6-65.2C400,212.8,369.6,179.4,332.1,179.4z M332.1,302.1H290l-0.1-0.1l-0.1,0.1H166.4\r\n\tc-10,0-19.5-4.6-26.7-11.9c-7.2-7.3-11.1-17.2-11.1-27.4c0-19.6,15.2-39.8,34.9-43c1.7-0.3,9.2-1.4,15-1.9c0,0-0.5-5.6-0.7-10.2\r\n\tc-0.1-4.6-0.1-9.9-0.1-12.1c0-36.4,29.5-66.9,65.8-66.9c15.2,0,29.5,5.1,41.3,14.7c11.5,9.3,19.6,25.4,22.8,39.7l3.3,14.7l14.9-1.9\r\n\tc2.2-0.3,4.3-0.4,6.4-0.4c28.3,0,51.3,25.9,51.3,54.4C383.4,278.3,360.4,302.1,332.1,302.1z"},"children":[]}]};exports.iosRainyOutline=iosRainyOutline;var iosRainy={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M332.1,179.4c-2.8,0-5.7-0.1-8.4,0.3c-8.3-36.8-35.2-67.6-80.3-67.6c-50.9,0-82.3,38-82.3,83.6\r\n\tc0,2.8,0.1,5.5,0.4,8.2c-27.7,2.5-49.5,31.3-49.5,59.8c0,29.2,22.9,54.6,51.6,56.2l-24.5,34.4c-1.1,1.6-2,3.4-2,5.5\r\n\tc0,4.6,3.7,8.3,8.3,8.3c3,0,5.6-1.6,7.1-4l31-43.8h36.1l-46.1,65.8c-1.2,1.6-2.1,3.6-2.1,5.6c0,4.6,3.7,8.3,8.3,8.3\r\n\tc3,0,5.6-1.8,7.2-4.3l52.6-75.5h37.9l-24.9,34.4c-1.2,1.6-2.2,3.8-2.2,5.6c0,4.6,3.7,8.3,8.3,8.3c3.1,0,5.4-1.7,7.2-4.1l31.6-44.3\r\n\th34.7c0.1,0,0.3-0.1,0.4-0.1l-46.1,65.9c-1.3,1.7-2.3,3.6-2.3,5.8c0,4.6,3.7,8.3,8.3,8.3c3.2,0,5.5-2,7.4-4.5l55.5-79.8\r\n\tc26-9.9,44.6-35.8,44.6-65.2C400,212.8,369.6,179.4,332.1,179.4z"},"children":[]}]};exports.iosRainy=iosRainy;var iosRecordingOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M386.2,144c-60.6,0-109.8,50.1-109.8,112c0,40.4,21,75.7,52.5,95.4H183.1c31.5-19.7,52.5-55,52.5-95.4\r\n\tc0-61.9-49.2-112-109.8-112C65.2,144,16,194.1,16,256c0,61.9,49.2,112,109.8,112h260.4c60.6,0,109.8-50.1,109.8-112\r\n\tC496,194.1,446.8,144,386.2,144z M32.3,256c0-52.6,42-95.4,93.5-95.4c51.6,0,93.5,42.8,93.5,95.4s-42,95.4-93.5,95.4\r\n\tC74.2,351.4,32.3,308.6,32.3,256z M386.2,351.4c-51.6,0-93.5-42.8-93.5-95.4s42-95.4,93.5-95.4s93.5,42.8,93.5,95.4\r\n\tS437.8,351.4,386.2,351.4z"},"children":[]},{"name":"path","attribs":{"d":"M384,208c26.5,0,48,21.5,48,48c0,26.5-21.5,48-48,48s-48-21.5-48-48C336,229.5,357.5,208,384,208 M384,192\r\n\tc-35.3,0-64,28.7-64,64c0,35.3,28.7,64,64,64s64-28.7,64-64C448,220.7,419.3,192,384,192L384,192z"},"children":[]},{"name":"path","attribs":{"d":"M128,208c26.5,0,48,21.5,48,48c0,26.5-21.5,48-48,48s-48-21.5-48-48C80,229.5,101.5,208,128,208 M128,192\r\n\tc-35.3,0-64,28.7-64,64c0,35.3,28.7,64,64,64s64-28.7,64-64C192,220.7,163.3,192,128,192L128,192z"},"children":[]}]};exports.iosRecordingOutline=iosRecordingOutline;var iosRecording={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M386.2,144c-60.6,0-109.8,49.9-109.8,111.8c0,40.4,21,76.2,52.5,95.2H183.1c31.5-19,52.5-54.8,52.5-95.2\r\n\t\tc0-61.9-49.2-111.9-109.8-111.9C65.2,143.9,16,194.1,16,255.9C16,317.8,65.2,368,125.8,368h260.4c60.6,0,109.8-50.1,109.8-112\r\n\t\tC496,194.1,446.8,144,386.2,144z M128,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C192,291.3,163.3,320,128,320z\r\n\t\t M384,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C448,291.3,419.3,320,384,320z"},"children":[{"name":"path","attribs":{"d":"M386.2,144c-60.6,0-109.8,49.9-109.8,111.8c0,40.4,21,76.2,52.5,95.2H183.1c31.5-19,52.5-54.8,52.5-95.2\r\n\t\tc0-61.9-49.2-111.9-109.8-111.9C65.2,143.9,16,194.1,16,255.9C16,317.8,65.2,368,125.8,368h260.4c60.6,0,109.8-50.1,109.8-112\r\n\t\tC496,194.1,446.8,144,386.2,144z M128,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C192,291.3,163.3,320,128,320z\r\n\t\t M384,320c-35.3,0-64-28.7-64-64c0-35.3,28.7-64,64-64s64,28.7,64,64C448,291.3,419.3,320,384,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C432,229.5,410.5,208,384,208z"},"children":[{"name":"path","attribs":{"d":"M384,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C432,229.5,410.5,208,384,208z"},"children":[]}]},{"name":"path","attribs":{"d":"M128,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C176,229.5,154.5,208,128,208z"},"children":[{"name":"path","attribs":{"d":"M128,208c-26.5,0-48,21.5-48,48c0,26.5,21.5,48,48,48s48-21.5,48-48C176,229.5,154.5,208,128,208z"},"children":[]}]}]}]};exports.iosRecording=iosRecording;var iosRedoOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,400h10.3l19.2-31.2c20.5-32.7,44.9-62.8,75.8-76.6c24.4-10.9,46.7-18.9,86.7-20V352l192-128L256,96v80.3\r\n\t\tc-63,2.8-108.1,20.7-143.3,56.2c-52.3,52.7-48.7,119-48.7,135.7C64.1,377.1,64,389.9,64,400z M272,192v-64.7l148.1,96.8L272,320.8\r\n\t\tV256c-91,0-144.6,24.6-192.2,105.4C79.8,361.4,71,192,272,192z"},"children":[{"name":"path","attribs":{"d":"M64,400h10.3l19.2-31.2c20.5-32.7,44.9-62.8,75.8-76.6c24.4-10.9,46.7-18.9,86.7-20V352l192-128L256,96v80.3\r\n\t\tc-63,2.8-108.1,20.7-143.3,56.2c-52.3,52.7-48.7,119-48.7,135.7C64.1,377.1,64,389.9,64,400z M272,192v-64.7l148.1,96.8L272,320.8\r\n\t\tV256c-91,0-144.6,24.6-192.2,105.4C79.8,361.4,71,192,272,192z"},"children":[]}]}]}]};exports.iosRedoOutline=iosRedoOutline;var iosRedo={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,400h10.3l19.2-31.2c20.5-32.7,44.9-62.8,75.8-76.6c24.4-10.9,46.7-18.9,86.7-20V352l192-128L256,96v80.3\r\n\t\tc-63,2.8-108.1,20.7-143.3,56.2c-52.3,52.7-48.7,119-48.7,135.7C64.1,377.1,64,389.9,64,400z"},"children":[{"name":"path","attribs":{"d":"M64,400h10.3l19.2-31.2c20.5-32.7,44.9-62.8,75.8-76.6c24.4-10.9,46.7-18.9,86.7-20V352l192-128L256,96v80.3\r\n\t\tc-63,2.8-108.1,20.7-143.3,56.2c-52.3,52.7-48.7,119-48.7,135.7C64.1,377.1,64,389.9,64,400z"},"children":[]}]}]}]};exports.iosRedo=iosRedo;var iosRefreshEmpty={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,384.1c-70.7,0-128-57.3-128-128.1c0-70.8,57.3-128.1,128-128.1V84l96,64l-96,55.7v-55.8\r\n\t\tc-59.6,0-108.1,48.5-108.1,108.1c0,59.6,48.5,108.1,108.1,108.1S364.1,316,364.1,256H384C384,327,326.7,384.1,256,384.1z"},"children":[{"name":"path","attribs":{"d":"M256,384.1c-70.7,0-128-57.3-128-128.1c0-70.8,57.3-128.1,128-128.1V84l96,64l-96,55.7v-55.8\r\n\t\tc-59.6,0-108.1,48.5-108.1,108.1c0,59.6,48.5,108.1,108.1,108.1S364.1,316,364.1,256H384C384,327,326.7,384.1,256,384.1z"},"children":[]}]}]}]};exports.iosRefreshEmpty=iosRefreshEmpty;var iosRefreshOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M364.1,256c0,60-48.5,108.2-108.1,108.2S147.9,315.7,147.9,256c0-59.6,48.5-108.1,108.1-108.1v55.8l96-55.7l-96-64v44\r\n\tc-70.7,0-128,57.4-128,128.1c0,70.8,57.3,128.1,128,128.1c70.7,0,128-57.1,128-128.1H364.1z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,446.7\r\n\t\t\tc-105.1,0-190.7-85.5-190.7-190.7c0-105.1,85.5-190.7,190.7-190.7c105.1,0,190.7,85.5,190.7,190.7\r\n\t\t\tC446.7,361.1,361.1,446.7,256,446.7z"},"children":[]}]}]}]}]}]};exports.iosRefreshOutline=iosRefreshOutline;var iosRefresh={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,384.1\r\n\t\tc-70.7,0-128-57.3-128-128.1c0-70.8,57.3-128.1,128-128.1V84l96,64l-96,55.7v-55.8c-59.6,0-108.1,48.5-108.1,108.1\r\n\t\tc0,59.6,48.5,108.1,108.1,108.1S364.1,316,364.1,256H384C384,327,326.7,384.1,256,384.1z"},"children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256s93.1,208,208,208c114.9,0,208-93.1,208-208S370.9,48,256,48z M256,384.1\r\n\t\tc-70.7,0-128-57.3-128-128.1c0-70.8,57.3-128.1,128-128.1V84l96,64l-96,55.7v-55.8c-59.6,0-108.1,48.5-108.1,108.1\r\n\t\tc0,59.6,48.5,108.1,108.1,108.1S364.1,316,364.1,256H384C384,327,326.7,384.1,256,384.1z"},"children":[]}]}]}]};exports.iosRefresh=iosRefresh;var iosReload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"PL_x5F_Reset_1_"},"children":[{"name":"path","attribs":{"d":"M256,64c105.9,0,191.7,85.7,191.9,191.5l55-52.5l9,9.1L441.6,280L375,212.1l9-9.1l51.1,52.4\r\n\t\tC434.8,156.9,354.6,76.8,256,76.8c-98.8,0-179.2,80.4-179.2,179.2c0,98.8,80.4,179.2,179.2,179.2c78.6,0,145.5-51,169.5-121.6\r\n\t\tl12.4,3.5C412.3,393.2,340.6,448,256,448c-106,0-192-86-192-192S150,64,256,64z"},"children":[{"name":"path","attribs":{"d":"M256,64c105.9,0,191.7,85.7,191.9,191.5l55-52.5l9,9.1L441.6,280L375,212.1l9-9.1l51.1,52.4\r\n\t\tC434.8,156.9,354.6,76.8,256,76.8c-98.8,0-179.2,80.4-179.2,179.2c0,98.8,80.4,179.2,179.2,179.2c78.6,0,145.5-51,169.5-121.6\r\n\t\tl12.4,3.5C412.3,393.2,340.6,448,256,448c-106,0-192-86-192-192S150,64,256,64z"},"children":[]}]}]}]};exports.iosReload=iosReload;var iosReverseCameraOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M301.815,318.608c-13.114,11.029-28.956,17.356-45.815,17.356c-36.36,0-66.286-28.965-70.89-61.965h30.61l-38.87-50\r\n\t\tl-37.534,50h29.479c4.696,42,41.717,78,87.205,78c20.9,0,41.17-7.566,57.076-21.218l2.37-2.159l-11.599-11.662L301.815,318.608z"},"children":[{"name":"path","attribs":{"d":"M301.815,318.608c-13.114,11.029-28.956,17.356-45.815,17.356c-36.36,0-66.286-28.965-70.89-61.965h30.61l-38.87-50\r\n\t\tl-37.534,50h29.479c4.696,42,41.717,78,87.205,78c20.9,0,41.17-7.566,57.076-21.218l2.37-2.159l-11.599-11.662L301.815,318.608z"},"children":[]}]},{"name":"path","attribs":{"d":"M315.736,198.885c-16.188-14.775-37.402-22.839-59.736-22.839c-20.9,0-41.169,7.556-57.075,21.206l-2.371,2.052\r\n\t\tl11.599,11.61l2.033-1.706c12.927-10.872,29.197-17.005,45.814-17.005c36.343,0,66.274,28.797,70.891,63.797h-30.644l38.846,51.225\r\n\t\tL372.719,256h-29.512C340.966,236,331.275,213.064,315.736,198.885z"},"children":[{"name":"path","attribs":{"d":"M315.736,198.885c-16.188-14.775-37.402-22.839-59.736-22.839c-20.9,0-41.169,7.556-57.075,21.206l-2.371,2.052\r\n\t\tl11.599,11.61l2.033-1.706c12.927-10.872,29.197-17.005,45.814-17.005c36.343,0,66.274,28.797,70.891,63.797h-30.644l38.846,51.225\r\n\t\tL372.719,256h-29.512C340.966,236,331.275,213.064,315.736,198.885z"},"children":[]}]},{"name":"path","attribs":{"d":"M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5\r\n\t\tC79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684\r\n\t\tC448,173.217,435.145,160,417.5,160z M432,366.701c0,9.263-6.229,17.299-14.5,17.299h-320c-8.738,0-17.5-8.664-17.5-17.299V190.684\r\n\t\tC80,182.518,88.126,176,97.5,176h60.729c0,0,4.124,0,6.133,0s3.225-0.199,5.768-3.2s7.702-10.008,11.08-13.795\r\n\t\tc11.296-12.666,19.457-21.915,25.316-27.132c4.746-4.225,6.211-3.873,6.225-3.873h88.5c0.016,0,1.611-0.363,6.709,4.219\r\n\t\tc6.141,5.521,14.705,16.84,26.558,30.198c2.888,3.255,7.214,8.11,9.317,10.44s4.252,3.143,5.771,3.143s6.17,0,6.17,0H417.5\r\n\t\tc8.832,0,14.5,5.965,14.5,14.684V366.701z"},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5\r\n\t\tC79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684\r\n\t\tC448,173.217,435.145,160,417.5,160z M432,366.701c0,9.263-6.229,17.299-14.5,17.299h-320c-8.738,0-17.5-8.664-17.5-17.299V190.684\r\n\t\tC80,182.518,88.126,176,97.5,176h60.729c0,0,4.124,0,6.133,0s3.225-0.199,5.768-3.2s7.702-10.008,11.08-13.795\r\n\t\tc11.296-12.666,19.457-21.915,25.316-27.132c4.746-4.225,6.211-3.873,6.225-3.873h88.5c0.016,0,1.611-0.363,6.709,4.219\r\n\t\tc6.141,5.521,14.705,16.84,26.558,30.198c2.888,3.255,7.214,8.11,9.317,10.44s4.252,3.143,5.771,3.143s6.17,0,6.17,0H417.5\r\n\t\tc8.832,0,14.5,5.965,14.5,14.684V366.701z"},"children":[]}]}]}]};exports.iosReverseCameraOutline=iosReverseCameraOutline;var iosReverseCamera={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5\r\n\t\tC79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684\r\n\t\tC448,173.217,435.145,160,417.5,160z M313.076,330.782C297.17,344.434,276.9,352,256,352c-45.487,0-82.509-36-87.205-78h-29.479\r\n\t\tl37.534-50l38.87,50h-30.61c4.604,33,34.53,61.965,70.89,61.965c16.859,0,32.701-6.327,45.815-17.356l2.032-1.647l11.599,11.662\r\n\t\tL313.076,330.782z M335.094,307.225L296.248,256h30.644c-4.617-35-34.548-63.797-70.891-63.797\r\n\t\tc-16.618,0-32.888,6.133-45.814,17.005l-2.033,1.706l-11.599-11.61l2.371-2.052c15.905-13.65,36.175-21.206,57.075-21.206\r\n\t\tc22.333,0,43.548,8.063,59.736,22.839C331.275,213.064,340.966,236,343.207,256h29.512L335.094,307.225z"},"children":[{"name":"path","attribs":{"d":"M417.5,160h-61.725c-32.105-36-42.219-48-54.525-48h-88.5c-12.314,0-22.167,12-54.521,48H145v-16h-34v16H97.5\r\n\t\tC79.855,160,64,173.217,64,190.684v176.018C64,384.169,79.855,400,97.5,400h320c17.645,0,30.5-15.831,30.5-33.299V190.684\r\n\t\tC448,173.217,435.145,160,417.5,160z M313.076,330.782C297.17,344.434,276.9,352,256,352c-45.487,0-82.509-36-87.205-78h-29.479\r\n\t\tl37.534-50l38.87,50h-30.61c4.604,33,34.53,61.965,70.89,61.965c16.859,0,32.701-6.327,45.815-17.356l2.032-1.647l11.599,11.662\r\n\t\tL313.076,330.782z M335.094,307.225L296.248,256h30.644c-4.617-35-34.548-63.797-70.891-63.797\r\n\t\tc-16.618,0-32.888,6.133-45.814,17.005l-2.033,1.706l-11.599-11.61l2.371-2.052c15.905-13.65,36.175-21.206,57.075-21.206\r\n\t\tc22.333,0,43.548,8.063,59.736,22.839C331.275,213.064,340.966,236,343.207,256h29.512L335.094,307.225z"},"children":[]}]}]}]};exports.iosReverseCamera=iosReverseCamera;var iosRewindOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M464,155v201.9L280.5,256L464,155 M240,156v77.7v27.1v95.6L64,256l176-100.2 M256,128L32,256l224,128V260.8L480,384V128\r\n\tL256,251.2V128L256,128z"},"children":[]}]};exports.iosRewindOutline=iosRewindOutline;var iosRewind={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,128L32,256l224,128V260.8L480,384V128L256,251.2V128L256,128z"},"children":[]}]};exports.iosRewind=iosRewind;var iosRoseOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M379.769,153.431c-29.777,55.586-17.604,99.504-6.645,139.039C378.717,312.648,384,331.708,384,351.889\r\n\t\tc0,15.897-2.956,30.873-8.785,44.51c-5.727,13.396-14.104,25.212-24.898,35.12C327.169,452.768,294.555,464,256,464\r\n\t\ts-71.169-11.232-94.316-32.481c-10.795-9.908-19.172-21.725-24.898-35.12c-5.829-13.637-8.785-28.612-8.785-44.51\r\n\t\tc0-31.65,6.92-55.999,21.775-76.626c13.061-18.134,32.646-34.094,63.505-51.749l6.506-3.725\r\n\t\tc20.197-11.57,27.001-15.467,43.976-23.588c31.845-15.234,66.513-28.387,103.041-39.094\r\n\t\tC371.088,155.851,375.412,154.625,379.769,153.431 M416,128c-18.863,4.163-36.75,8.786-53.697,13.753\r\n\t\tc-40.457,11.858-75.509,25.693-105.445,40.015c-19.271,9.219-26.236,13.393-51.522,27.859C147.001,243,112,278.926,112,351.889\r\n\t\tS167.635,480,256,480s144-55.148,144-128.111S338.999,224,416,128L416,128z"},"children":[{"name":"path","attribs":{"d":"M379.769,153.431c-29.777,55.586-17.604,99.504-6.645,139.039C378.717,312.648,384,331.708,384,351.889\r\n\t\tc0,15.897-2.956,30.873-8.785,44.51c-5.727,13.396-14.104,25.212-24.898,35.12C327.169,452.768,294.555,464,256,464\r\n\t\ts-71.169-11.232-94.316-32.481c-10.795-9.908-19.172-21.725-24.898-35.12c-5.829-13.637-8.785-28.612-8.785-44.51\r\n\t\tc0-31.65,6.92-55.999,21.775-76.626c13.061-18.134,32.646-34.094,63.505-51.749l6.506-3.725\r\n\t\tc20.197-11.57,27.001-15.467,43.976-23.588c31.845-15.234,66.513-28.387,103.041-39.094\r\n\t\tC371.088,155.851,375.412,154.625,379.769,153.431 M416,128c-18.863,4.163-36.75,8.786-53.697,13.753\r\n\t\tc-40.457,11.858-75.509,25.693-105.445,40.015c-19.271,9.219-26.236,13.393-51.522,27.859C147.001,243,112,278.926,112,351.889\r\n\t\tS167.635,480,256,480s144-55.148,144-128.111S338.999,224,416,128L416,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M133.516,123.147c21.432,6.955,47.724,16.977,69.799,29.846c6.385,3.723,12.092,7.493,17.092,11.291\r\n\t\tc-5.504,2.905-10.895,5.855-16.138,8.833c-7.212,4.096-14.359,8.362-21.243,12.679c-10.484,6.574-20.435,13.308-29.789,20.156\r\n\t\tC152.637,180.034,147.555,151.15,133.516,123.147 M96,96c41.475,47.079,44.624,103.891,39.382,144.741\r\n\t\tc12.772-11.274,31.177-25.734,56.144-41.389c6.442-4.041,13.312-8.158,20.645-12.322c11.578-6.575,23.538-12.822,35.834-18.765\r\n\t\tc-9.113-10.898-22.07-20.606-36.631-29.095C162.631,110.756,96,96,96,96L96,96z"},"children":[{"name":"path","attribs":{"d":"M133.516,123.147c21.432,6.955,47.724,16.977,69.799,29.846c6.385,3.723,12.092,7.493,17.092,11.291\r\n\t\tc-5.504,2.905-10.895,5.855-16.138,8.833c-7.212,4.096-14.359,8.362-21.243,12.679c-10.484,6.574-20.435,13.308-29.789,20.156\r\n\t\tC152.637,180.034,147.555,151.15,133.516,123.147 M96,96c41.475,47.079,44.624,103.891,39.382,144.741\r\n\t\tc12.772-11.274,31.177-25.734,56.144-41.389c6.442-4.041,13.312-8.158,20.645-12.322c11.578-6.575,23.538-12.822,35.834-18.765\r\n\t\tc-9.113-10.898-22.07-20.606-36.631-29.095C162.631,110.756,96,96,96,96L96,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M344.629,80.697c5.309,7.227,12.393,17.661,17.66,27.726c-29.863,8.433-65.994,21.145-94.967,33.476\r\n\t\tc-5.963-6.235-12.982-12.294-21.006-18.135c17.437-15.757,38.773-27.668,63.652-35.506\r\n\t\tC324.518,83.675,337.016,81.612,344.629,80.697 M352,64c0,0-78.623,2.321-130.681,62.469c16.629,9.903,29.735,20.503,38.959,31.533\r\n\t\tl2.724,3.257c37.152-16.794,88.131-34.085,120.998-42.009C377.617,95.827,352,64,352,64L352,64z"},"children":[{"name":"path","attribs":{"d":"M344.629,80.697c5.309,7.227,12.393,17.661,17.66,27.726c-29.863,8.433-65.994,21.145-94.967,33.476\r\n\t\tc-5.963-6.235-12.982-12.294-21.006-18.135c17.437-15.757,38.773-27.668,63.652-35.506\r\n\t\tC324.518,83.675,337.016,81.612,344.629,80.697 M352,64c0,0-78.623,2.321-130.681,62.469c16.629,9.903,29.735,20.503,38.959,31.533\r\n\t\tl2.724,3.257c37.152-16.794,88.131-34.085,120.998-42.009C377.617,95.827,352,64,352,64L352,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M181.229,53.532c9.241,6.122,22.68,16.481,35.999,31.924c-4.851,4.201-9.487,8.623-13.888,13.247\r\n\t\tc-14.024-7.088-24.951-12.192-36.826-16.602C170.174,73.63,175.095,63.788,181.229,53.532 M176,32\r\n\t\tc-15.256,22.406-25.684,45.299-30.336,59.997c21.111,6.355,35.475,13.215,61.389,26.574c9.505-11.4,20.415-21.626,32.605-30.543\r\n\t\tC210.342,47.655,176,32,176,32L176,32z"},"children":[{"name":"path","attribs":{"d":"M181.229,53.532c9.241,6.122,22.68,16.481,35.999,31.924c-4.851,4.201-9.487,8.623-13.888,13.247\r\n\t\tc-14.024-7.088-24.951-12.192-36.826-16.602C170.174,73.63,175.095,63.788,181.229,53.532 M176,32\r\n\t\tc-15.256,22.406-25.684,45.299-30.336,59.997c21.111,6.355,35.475,13.215,61.389,26.574c9.505-11.4,20.415-21.626,32.605-30.543\r\n\t\tC210.342,47.655,176,32,176,32L176,32z"},"children":[]}]}]}]};exports.iosRoseOutline=iosRoseOutline;var iosRose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,128c-18.863,4.163-36.75,8.786-53.697,13.753c-40.457,11.858-75.509,25.693-105.445,40.015\r\n\t\tc-19.271,9.219-26.236,13.393-51.522,27.859C147.001,243,112,278.926,112,351.889S167.635,480,256,480s144-55.148,144-128.111\r\n\t\tS338.999,224,416,128L416,128z"},"children":[{"name":"path","attribs":{"d":"M416,128c-18.863,4.163-36.75,8.786-53.697,13.753c-40.457,11.858-75.509,25.693-105.445,40.015\r\n\t\tc-19.271,9.219-26.236,13.393-51.522,27.859C147.001,243,112,278.926,112,351.889S167.635,480,256,480s144-55.148,144-128.111\r\n\t\tS338.999,224,416,128L416,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M96,96c41.475,47.079,44.624,103.891,39.382,144.741c12.772-11.274,31.177-25.734,56.144-41.389\r\n\t\tc6.442-4.041,13.312-8.158,20.645-12.322c11.578-6.575,23.538-12.822,35.834-18.765c-9.113-10.898-22.07-20.606-36.631-29.095\r\n\t\tC162.631,110.756,96,96,96,96L96,96z"},"children":[{"name":"path","attribs":{"d":"M96,96c41.475,47.079,44.624,103.891,39.382,144.741c12.772-11.274,31.177-25.734,56.144-41.389\r\n\t\tc6.442-4.041,13.312-8.158,20.645-12.322c11.578-6.575,23.538-12.822,35.834-18.765c-9.113-10.898-22.07-20.606-36.631-29.095\r\n\t\tC162.631,110.756,96,96,96,96L96,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,64c0,0-78.623,2.321-130.681,62.469c16.629,9.903,29.735,20.503,38.959,31.533l2.724,3.257\r\n\t\tc37.152-16.794,88.131-34.085,120.998-42.009C377.617,95.827,352,64,352,64L352,64z"},"children":[{"name":"path","attribs":{"d":"M352,64c0,0-78.623,2.321-130.681,62.469c16.629,9.903,29.735,20.503,38.959,31.533l2.724,3.257\r\n\t\tc37.152-16.794,88.131-34.085,120.998-42.009C377.617,95.827,352,64,352,64L352,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,32c-15.256,22.406-25.684,45.299-30.336,59.997c21.111,6.355,35.475,13.215,61.389,26.574\r\n\t\tc9.505-11.4,20.415-21.626,32.605-30.543C210.342,47.655,176,32,176,32L176,32z"},"children":[{"name":"path","attribs":{"d":"M176,32c-15.256,22.406-25.684,45.299-30.336,59.997c21.111,6.355,35.475,13.215,61.389,26.574\r\n\t\tc9.505-11.4,20.415-21.626,32.605-30.543C210.342,47.655,176,32,176,32L176,32z"},"children":[]}]}]}]};exports.iosRose=iosRose;var iosSearchStrong={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M344.5,298c15-23.6,23.8-51.6,23.8-81.7c0-84.1-68.1-152.3-152.1-152.3C132.1,64,64,132.2,64,216.3\r\n\tc0,84.1,68.1,152.3,152.1,152.3c30.5,0,58.9-9,82.7-24.4l6.9-4.8L414.3,448l33.7-34.3L339.5,305.1L344.5,298z M301.4,131.2\r\n\tc22.7,22.7,35.2,52.9,35.2,85c0,32.1-12.5,62.3-35.2,85c-22.7,22.7-52.9,35.2-85,35.2c-32.1,0-62.3-12.5-85-35.2\r\n\tc-22.7-22.7-35.2-52.9-35.2-85c0-32.1,12.5-62.3,35.2-85c22.7-22.7,52.9-35.2,85-35.2C248.5,96,278.7,108.5,301.4,131.2z"},"children":[]}]};exports.iosSearchStrong=iosSearchStrong;var iosSearch={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448.3,424.7L335,311.3c20.8-26,33.3-59.1,33.3-95.1c0-84.1-68.1-152.2-152-152.2c-84,0-152,68.2-152,152.2\r\n\ts68.1,152.2,152,152.2c36.2,0,69.4-12.7,95.5-33.8L425,448L448.3,424.7z M120.1,312.6c-25.7-25.7-39.8-59.9-39.8-96.3\r\n\ts14.2-70.6,39.8-96.3S180,80,216.3,80c36.3,0,70.5,14.2,96.2,39.9s39.8,59.9,39.8,96.3s-14.2,70.6-39.8,96.3\r\n\tc-25.7,25.7-59.9,39.9-96.2,39.9C180,352.5,145.8,338.3,120.1,312.6z"},"children":[]}]};exports.iosSearch=iosSearch;var iosSettingsStrong={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32,376h283.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32h-91.35c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[{"name":"path","attribs":{"d":"M32,376h283.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32h-91.35c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[]}]},{"name":"path","attribs":{"d":"M32,240h91.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32H196.65c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[{"name":"path","attribs":{"d":"M32,240h91.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32H196.65c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[]}]},{"name":"path","attribs":{"d":"M32,104h283.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32h-91.35c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[{"name":"path","attribs":{"d":"M32,104h283.35c6.186-14.112,20.281-24,36.65-24s30.465,9.888,36.65,24H480v32h-91.35c-6.186,14.112-20.281,24-36.65,24\r\n\t\ts-30.465-9.888-36.65-24H32"},"children":[]}]}]}]};exports.iosSettingsStrong=iosSettingsStrong;var iosSettings={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,104c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S343.163,104,352,104 M352,88c-17.645,0-32,14.355-32,32\r\n\t\ts14.355,32,32,32s32-14.355,32-32S369.645,88,352,88L352,88z"},"children":[{"name":"path","attribs":{"d":"M352,104c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S343.163,104,352,104 M352,88c-17.645,0-32,14.355-32,32\r\n\t\ts14.355,32,32,32s32-14.355,32-32S369.645,88,352,88L352,88z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,376c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S343.163,376,352,376 M352,360c-17.645,0-32,14.355-32,32\r\n\t\ts14.355,32,32,32s32-14.355,32-32S369.645,360,352,360L352,360z"},"children":[{"name":"path","attribs":{"d":"M352,376c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S343.163,376,352,376 M352,360c-17.645,0-32,14.355-32,32\r\n\t\ts14.355,32,32,32s32-14.355,32-32S369.645,360,352,360L352,360z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M160,240c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S151.163,240,160,240 M160,224\r\n\t\t\tc-17.645,0-32,14.355-32,32s14.355,32,32,32s32-14.355,32-32S177.645,224,160,224L160,224z"},"children":[{"name":"path","attribs":{"d":"M160,240c8.837,0,16,7.163,16,16s-7.163,16-16,16s-16-7.163-16-16S151.163,240,160,240 M160,224\r\n\t\t\tc-17.645,0-32,14.355-32,32s14.355,32,32,32s32-14.355,32-32S177.645,224,160,224L160,224z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M207.32,248H480v16H207.32c0.439-2.604,0.68-5.273,0.68-8S207.76,250.604,207.32,248z"},"children":[{"name":"path","attribs":{"d":"M207.32,248H480v16H207.32c0.439-2.604,0.68-5.273,0.68-8S207.76,250.604,207.32,248z"},"children":[]}]},{"name":"path","attribs":{"d":"M112,256c0,2.727,0.24,5.396,0.68,8H32v-16h80.68C112.24,250.604,112,253.273,112,256z"},"children":[{"name":"path","attribs":{"d":"M112,256c0,2.727,0.24,5.396,0.68,8H32v-16h80.68C112.24,250.604,112,253.273,112,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M399.32,384H480v16h-80.68c0.439-2.604,0.68-5.273,0.68-8S399.76,386.604,399.32,384z"},"children":[{"name":"path","attribs":{"d":"M399.32,384H480v16h-80.68c0.439-2.604,0.68-5.273,0.68-8S399.76,386.604,399.32,384z"},"children":[]}]},{"name":"path","attribs":{"d":"M304,392c0,2.727,0.24,5.396,0.68,8H32v-16h272.68C304.24,386.604,304,389.273,304,392z"},"children":[{"name":"path","attribs":{"d":"M304,392c0,2.727,0.24,5.396,0.68,8H32v-16h272.68C304.24,386.604,304,389.273,304,392z"},"children":[]}]},{"name":"path","attribs":{"d":"M399.32,112H480v16h-80.68c0.439-2.604,0.68-5.273,0.68-8S399.76,114.604,399.32,112z"},"children":[{"name":"path","attribs":{"d":"M399.32,112H480v16h-80.68c0.439-2.604,0.68-5.273,0.68-8S399.76,114.604,399.32,112z"},"children":[]}]},{"name":"path","attribs":{"d":"M304.68,112c-0.439,2.604-0.68,5.273-0.68,8s0.24,5.396,0.68,8H32v-16H304.68z"},"children":[{"name":"path","attribs":{"d":"M304.68,112c-0.439,2.604-0.68,5.273-0.68,8s0.24,5.396,0.68,8H32v-16H304.68z"},"children":[]}]}]}]}]}]}]}]};exports.iosSettings=iosSettings;var iosShuffleStrong={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M365.419,152h13.81l-50.738,41.584l20.308,24.572L448,136l-99.136-84l-20.368,24.978L379.679,120h-14.26\r\n\t\tc-103.727,0-146.494,79.62-180.857,143.727c-1.362,2.542-2.715,4.99-4.06,7.488l-0.059,0.095c-1.591,2.953-3.176,6.114-4.76,9.038\r\n\t\tc-35.562,65.63-66.893,83.214-111.684,83.641V396c37.625,0,57.563-9.451,72.236-18.178c24.935-14.831,47.042-44.559,67.583-82.467\r\n\t\tc1.541-2.844,3.083-5.752,4.632-8.626l0.225-0.438c1.459-2.711,2.922-5.273,4.39-8.014C246.369,216.113,280.808,152,365.419,152z"},"children":[{"name":"path","attribs":{"d":"M365.419,152h13.81l-50.738,41.584l20.308,24.572L448,136l-99.136-84l-20.368,24.978L379.679,120h-14.26\r\n\t\tc-103.727,0-146.494,79.62-180.857,143.727c-1.362,2.542-2.715,4.99-4.06,7.488l-0.059,0.095c-1.591,2.953-3.176,6.114-4.76,9.038\r\n\t\tc-35.562,65.63-66.893,83.214-111.684,83.641V396c37.625,0,57.563-9.451,72.236-18.178c24.935-14.831,47.042-44.559,67.583-82.467\r\n\t\tc1.541-2.844,3.083-5.752,4.632-8.626l0.225-0.438c1.459-2.711,2.922-5.273,4.39-8.014C246.369,216.113,280.808,152,365.419,152z"},"children":[]}]},{"name":"path","attribs":{"d":"M348.798,293.844l-20.308,24.572L379.229,360h-13.81c-70.728,0-106.396-44.801-135.649-95.812l-17.648,32.618\r\n\t\tC243.556,346.626,287.116,392,365.419,392h14.26l-51.183,43.022L348.864,460L448,376L348.798,293.844z"},"children":[{"name":"path","attribs":{"d":"M348.798,293.844l-20.308,24.572L379.229,360h-13.81c-70.728,0-106.396-44.801-135.649-95.812l-17.648,32.618\r\n\t\tC243.556,346.626,287.116,392,365.419,392h14.26l-51.183,43.022L348.864,460L448,376L348.798,293.844z"},"children":[]}]},{"name":"path","attribs":{"d":"M175.684,231.652c1.584,2.924,3.169,6.085,4.76,9.038l0.059,0.095c1.218,2.262,2.442,4.49,3.675,6.777\r\n\t\tc5.82-10.73,11.98-21.748,18.695-32.649c-20.273-37.079-42.083-66.132-66.636-80.735C121.563,125.451,101.625,116,64,116v32.011\r\n\t\tC108.791,148.438,140.122,166.022,175.684,231.652z"},"children":[{"name":"path","attribs":{"d":"M175.684,231.652c1.584,2.924,3.169,6.085,4.76,9.038l0.059,0.095c1.218,2.262,2.442,4.49,3.675,6.777\r\n\t\tc5.82-10.73,11.98-21.748,18.695-32.649c-20.273-37.079-42.083-66.132-66.636-80.735C121.563,125.451,101.625,116,64,116v32.011\r\n\t\tC108.791,148.438,140.122,166.022,175.684,231.652z"},"children":[]}]}]}]};exports.iosShuffleStrong=iosShuffleStrong;var iosShuffle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M362.121,207.146L352,194.854L413.784,144h-46.117c-93.327,0-129.147,74.511-163.787,138.832\r\n\t\tc-1.62,3.008-3.233,6.004-4.846,8.979c-19.836,36.607-40.979,61.242-64.64,75.314C120.573,375.346,101.401,384,64,384v-16.25\r\n\t\tc47.937,0,83.098-13.673,120.966-83.561c1.606-2.965,3.214-5.949,4.827-8.944C224.943,209.977,264.784,128,367.667,128h46.28\r\n\t\tL352,76.146L362.121,64L448,136L362.121,207.146z"},"children":[{"name":"path","attribs":{"d":"M362.121,207.146L352,194.854L413.784,144h-46.117c-93.327,0-129.147,74.511-163.787,138.832\r\n\t\tc-1.62,3.008-3.233,6.004-4.846,8.979c-19.836,36.607-40.979,61.242-64.64,75.314C120.573,375.346,101.401,384,64,384v-16.25\r\n\t\tc47.937,0,83.098-13.673,120.966-83.561c1.606-2.965,3.214-5.949,4.827-8.944C224.943,209.977,264.784,128,367.667,128h46.28\r\n\t\tL352,76.146L362.121,64L448,136L362.121,207.146z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M199.034,220.189c-19.836-36.607-40.979-61.242-64.64-75.314C120.573,136.654,101.401,128,64,128v16.25\r\n\t\t\tc47.937,0,83.098,13.673,120.966,83.561c1.606,2.964,3.214,5.948,4.827,8.944c0.438,0.812,0.875,1.627,1.314,2.444\r\n\t\t\tc3.01-5.438,6.107-10.917,9.339-16.394C199.977,221.935,199.504,221.056,199.034,220.189z"},"children":[{"name":"path","attribs":{"d":"M199.034,220.189c-19.836-36.607-40.979-61.242-64.64-75.314C120.573,136.654,101.401,128,64,128v16.25\r\n\t\t\tc47.937,0,83.098,13.673,120.966,83.561c1.606,2.964,3.214,5.948,4.827,8.944c0.438,0.812,0.875,1.627,1.314,2.444\r\n\t\t\tc3.01-5.438,6.107-10.917,9.339-16.394C199.977,221.935,199.504,221.056,199.034,220.189z"},"children":[]}]},{"name":"path","attribs":{"d":"M362.121,304.854L352,317.146L413.784,368h-46.117c-72.693,0-110.496-45.207-140.028-95.592\r\n\t\t\tc-1.768,3.275-3.525,6.551-5.273,9.814c-1.175,2.192-2.344,4.37-3.513,6.545C249.621,338.777,291.254,384,367.667,384h46.28\r\n\t\t\tL352,435.854L362.121,448L448,376L362.121,304.854z"},"children":[{"name":"path","attribs":{"d":"M362.121,304.854L352,317.146L413.784,368h-46.117c-72.693,0-110.496-45.207-140.028-95.592\r\n\t\t\tc-1.768,3.275-3.525,6.551-5.273,9.814c-1.175,2.192-2.344,4.37-3.513,6.545C249.621,338.777,291.254,384,367.667,384h46.28\r\n\t\t\tL352,435.854L362.121,448L448,376L362.121,304.854z"},"children":[]}]}]}]}]}]};exports.iosShuffle=iosShuffle;var iosSkipbackwardOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M96,96v320h79V274.2L416,416V96L175,237.8V96H96z M175.6,256l7.6-4.4L400,124v0v264L183.1,260.4L175.6,256z M112,112h47\r\n\tv125.8v28v8.5V400h-47V112z"},"children":[]}]};exports.iosSkipbackwardOutline=iosSkipbackwardOutline;var iosSkipbackward={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M96,96v320h79V274.2L416,416V96L175,237.8V96H96z"},"children":[]}]};exports.iosSkipbackward=iosSkipbackward;var iosSkipforwardOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M337,96v141.8L96,96v320l241-141.8V416h79V96H337z M328.9,260.4L112,388V124v0l216.9,127.6l7.6,4.4L328.9,260.4z M400,400\r\n\th-47V274.2v-8.5v-28V112h47V400z"},"children":[]}]};exports.iosSkipforwardOutline=iosSkipforwardOutline;var iosSkipforward={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M337,96v141.8L96,96v320l241-141.8V416h79V96H337z"},"children":[]}]};exports.iosSkipforward=iosSkipforward;var iosSnowy={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M379.9,317l-28.7-16.3c6.1-5.8,13-9.7,20.7-12.3c4.3-1.4,6.5-5.9,5.1-10.1c-1.4-4.2-6-6.5-10.3-5.1\r\n\tc-11.6,3.8-22.2,11-30.1,19.2L272.3,256l64.2-36.4c8.4,9.1,18.6,15.4,30.2,19.2c4.3,1.4,8.9-0.8,10.3-5c1.4-4.2-0.8-8.7-5.1-10.1\r\n\tc-7.8-2.6-14.8-6.5-20.9-12.3l28.8-16.3c3.9-2.2,5.2-7.1,3-10.9s-7.2-5.1-11.1-2.9L343,197.3c-2-8.1-2.1-15.9-0.5-23.8\r\n\tc0.9-4.3-2-8.5-6.4-9.4c-4.4-0.9-8.7,1.9-9.6,6.2c-2.4,11.8-1.4,24.4,1.8,35.2L264,242.2v-73c11-2.7,22.4-8.1,31.5-16.1\r\n\tc3.3-2.9,3.6-8,0.7-11.3c-2.9-3.3-7.9-3.6-11.3-0.7c-6,5.3-12.9,9.2-20.9,11.5V120c0-4.4-3.6-8-8-8c-4.4,0-8,3.6-8,8v32.7\r\n\tc-8-2.3-14.8-6.2-20.9-11.6c-3.3-2.9-8.4-2.6-11.3,0.7c-2.9,3.3-2.6,8.4,0.7,11.3c9.1,8,19.5,13.5,31.5,16.1v73l-64.5-36.6\r\n\tc3.2-10.9,4.2-23.5,1.9-35.2c-0.9-4.3-5.2-7.1-9.6-6.2c-4.4,0.9-7.2,5-6.4,9.4c1.6,7.9,1.6,15.7-0.5,23.8L140.3,181\r\n\tc-3.9-2.2-8.9-0.9-11.1,2.9c-2.2,3.8-0.9,8.7,3,10.9l28.8,16.3c-6.1,5.8-13,9.7-20.8,12.3c-4.3,1.4-6.5,6-5.1,10.1\r\n\tc1.4,4.2,6.1,6.4,10.3,5c11.6-3.9,21.8-10.1,30.2-19.2l64.3,36.5l-64.4,36.5c-7.9-8.2-18.6-15.3-30.1-19.2\r\n\tc-4.3-1.4-8.8,0.9-10.3,5.1c-1.4,4.2,0.8,8.7,5.1,10.1c7.7,2.6,14.6,6.5,20.7,12.3l-28.7,16.3c-3.9,2.2-5.2,7.1-3,10.9\r\n\ts7.2,5.1,11.1,2.9l28.8-16.3c2.1,8.1,2.1,15.9,0.4,23.9c-0.9,4.3,2,8.5,6.4,9.4c4.4,0.9,8.7-1.9,9.6-6.3c2.4-11.8,1.9-23.6-1.9-35.3\r\n\tl64.5-36.6v73.1c-12,2.6-22.4,8.1-31.5,16.1c-3.3,2.9-3.6,8-0.7,11.3c2.9,3.3,7.9,3.6,11.3,0.7c6.1-5.4,12.9-9.3,20.9-11.6V392\r\n\tc0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8v-32.6c8,2.3,14.8,6.2,20.9,11.5c3.3,2.9,8.3,2.6,11.3-0.7c2.9-3.3,2.6-8.4-0.7-11.3\r\n\tc-9-7.9-20.4-13.4-31.4-16.1v-73.1l64.4,36.5c-3.8,11.7-4.2,23.5-1.8,35.3c0.9,4.3,5.2,7.1,9.6,6.3c4.4-0.9,7.3-5.1,6.4-9.4\r\n\tc-1.6-8-1.6-15.8,0.4-23.9l28.8,16.3c3.9,2.2,8.9,0.9,11.1-2.9C385.2,324.1,383.8,319.2,379.9,317z"},"children":[]}]};exports.iosSnowy=iosSnowy;var iosSpeedometerOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,64C132.288,64,32,164.226,32,287.938c0,56.975,21.283,108.97,56.316,148.5c3.551,4.006,7.241,7.82,11.066,11.562\r\n\t\tc3.059-3.49,6.232-6.834,9.539-10.141c0.48-0.48,0.972-0.947,1.456-1.422c18.78-18.426,40.521-32.949,64.664-43.161\r\n\t\tc25.633-10.842,52.871-16.339,80.958-16.339s55.325,5.497,80.958,16.339c24.144,10.212,45.884,24.735,64.664,43.161\r\n\t\tc0.484,0.475,0.976,0.941,1.456,1.422c3.307,3.307,6.48,6.65,9.539,10.141c3.825-3.742,7.516-7.557,11.066-11.562\r\n\t\tc35.033-39.53,56.316-91.525,56.316-148.5C480,164.226,379.712,64,256,64z M447.661,369.177\r\n\t\tc-8.663,20.481-20.429,39.092-35.044,55.776c-40.39-39.51-95.653-63.945-156.617-63.945s-116.228,24.33-156.617,63.84\r\n\t\tc-14.615-16.685-26.381-35.172-35.044-55.653c-9.81-23.19-15.228-47.694-16.173-72.694H79.5v-16H48.166\r\n\t\tc0.945-25,6.363-50.048,16.173-73.239c9.372-22.157,22.376-42.431,38.692-60.11l26.932,26.893l5.496-5.538l5.277-5.264l-0.02-0.027\r\n\t\tl0.547-0.552l-26.951-26.984c17.862-16.647,38.004-29.894,60.479-39.4c23.191-9.81,47.708-15.229,72.708-16.174V117.5h16V80.104\r\n\t\tc26,0.945,50.017,6.363,73.208,16.173c22.437,9.49,42.921,22.706,60.762,39.312l-26.975,27.069l0.577,0.547l-0.004,0.019\r\n\t\tl5.285,5.246l5.5,5.503l27.026-27.057c16.356,17.703,29.392,38.148,38.78,60.345c9.81,23.191,15.229,48.239,16.174,73.239H431.5v16\r\n\t\th32.334C462.889,321.5,457.471,345.986,447.661,369.177z"},"children":[{"name":"path","attribs":{"d":"M256,64C132.288,64,32,164.226,32,287.938c0,56.975,21.283,108.97,56.316,148.5c3.551,4.006,7.241,7.82,11.066,11.562\r\n\t\tc3.059-3.49,6.232-6.834,9.539-10.141c0.48-0.48,0.972-0.947,1.456-1.422c18.78-18.426,40.521-32.949,64.664-43.161\r\n\t\tc25.633-10.842,52.871-16.339,80.958-16.339s55.325,5.497,80.958,16.339c24.144,10.212,45.884,24.735,64.664,43.161\r\n\t\tc0.484,0.475,0.976,0.941,1.456,1.422c3.307,3.307,6.48,6.65,9.539,10.141c3.825-3.742,7.516-7.557,11.066-11.562\r\n\t\tc35.033-39.53,56.316-91.525,56.316-148.5C480,164.226,379.712,64,256,64z M447.661,369.177\r\n\t\tc-8.663,20.481-20.429,39.092-35.044,55.776c-40.39-39.51-95.653-63.945-156.617-63.945s-116.228,24.33-156.617,63.84\r\n\t\tc-14.615-16.685-26.381-35.172-35.044-55.653c-9.81-23.19-15.228-47.694-16.173-72.694H79.5v-16H48.166\r\n\t\tc0.945-25,6.363-50.048,16.173-73.239c9.372-22.157,22.376-42.431,38.692-60.11l26.932,26.893l5.496-5.538l5.277-5.264l-0.02-0.027\r\n\t\tl0.547-0.552l-26.951-26.984c17.862-16.647,38.004-29.894,60.479-39.4c23.191-9.81,47.708-15.229,72.708-16.174V117.5h16V80.104\r\n\t\tc26,0.945,50.017,6.363,73.208,16.173c22.437,9.49,42.921,22.706,60.762,39.312l-26.975,27.069l0.577,0.547l-0.004,0.019\r\n\t\tl5.285,5.246l5.5,5.503l27.026-27.057c16.356,17.703,29.392,38.148,38.78,60.345c9.81,23.191,15.229,48.239,16.174,73.239H431.5v16\r\n\t\th32.334C462.889,321.5,457.471,345.986,447.661,369.177z"},"children":[]}]},{"name":"path","attribs":{"d":"M368.479,174.545l-85.484,73.727c-7.697-5.255-16.992-8.334-26.994-8.334c-26.467,0-48,21.533-48,48\r\n\t\tc0,10.479,3.385,20.178,9.106,28.08l-11.948,11.948l11.312,11.313l12.033-12.033c7.795,5.469,17.273,8.691,27.496,8.691\r\n\t\tc26.467,0,48-21.533,48-48c0-10.387-3.327-20.005-8.956-27.868l74.849-84.11L368.479,174.545z M256,319.938\r\n\t\tc-17.673,0-32-14.326-32-32c0-17.673,14.327-32,32-32s32,14.327,32,32C288,305.611,273.673,319.938,256,319.938z"},"children":[{"name":"path","attribs":{"d":"M368.479,174.545l-85.484,73.727c-7.697-5.255-16.992-8.334-26.994-8.334c-26.467,0-48,21.533-48,48\r\n\t\tc0,10.479,3.385,20.178,9.106,28.08l-11.948,11.948l11.312,11.313l12.033-12.033c7.795,5.469,17.273,8.691,27.496,8.691\r\n\t\tc26.467,0,48-21.533,48-48c0-10.387-3.327-20.005-8.956-27.868l74.849-84.11L368.479,174.545z M256,319.938\r\n\t\tc-17.673,0-32-14.326-32-32c0-17.673,14.327-32,32-32s32,14.327,32,32C288,305.611,273.673,319.938,256,319.938z"},"children":[]}]}]}]};exports.iosSpeedometerOutline=iosSpeedometerOutline;var iosSpeedometer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417,278.742V278h29.814c-0.931-23-6.056-45.609-14.831-66.151c-8.643-20.228-20.503-38.665-35.257-54.562l-24.867,24.646\r\n\t\tl-11.229-10.992l24.788-24.679c-16.187-14.836-34.86-26.742-55.515-35.392C308.479,101.897,286,97.092,263,96.186V130h-1.008H248\r\n\t\tV96.186c-23,0.894-44.95,5.699-66.404,14.685c-20.353,8.523-38.958,20.457-55.315,35.471l24.796,24.583l-0.549,0.549l0.001,0.006\r\n\t\tl-0.29,0.335l-10.27,10.203l-24.779-24.479c-14.77,15.932-26.604,34.243-35.176,54.309C71.241,232.388,66.117,255,65.187,278H94v16\r\n\t\th-0.776H65.187c0.926,22,5.915,44.432,14.829,65.297c7.689,18.001,18.398,34.664,31.831,49.926\r\n\t\tc38.785-37.377,89.958-57.928,144.154-57.928c54.113,0,105.286,20.676,144.154,58.135c13.354-15.175,24.061-31.979,31.83-50.166\r\n\t\tC440.9,338.396,445.889,316,446.814,294H417V278.742z M304,287.938c0,26.467-21.533,48-48,48c-10.223,0-19.701-3.223-27.496-8.691\r\n\t\tl-12.033,12.033l-11.312-11.313l11.948-11.948c-5.722-7.902-9.106-17.602-9.106-28.08c0-26.467,21.533-48,48-48\r\n\t\tc10.002,0,19.297,3.079,26.994,8.334l73.484-65.727l1.414,1.414l-62.849,76.11C300.673,267.933,304,277.551,304,287.938z"},"children":[{"name":"path","attribs":{"d":"M417,278.742V278h29.814c-0.931-23-6.056-45.609-14.831-66.151c-8.643-20.228-20.503-38.665-35.257-54.562l-24.867,24.646\r\n\t\tl-11.229-10.992l24.788-24.679c-16.187-14.836-34.86-26.742-55.515-35.392C308.479,101.897,286,97.092,263,96.186V130h-1.008H248\r\n\t\tV96.186c-23,0.894-44.95,5.699-66.404,14.685c-20.353,8.523-38.958,20.457-55.315,35.471l24.796,24.583l-0.549,0.549l0.001,0.006\r\n\t\tl-0.29,0.335l-10.27,10.203l-24.779-24.479c-14.77,15.932-26.604,34.243-35.176,54.309C71.241,232.388,66.117,255,65.187,278H94v16\r\n\t\th-0.776H65.187c0.926,22,5.915,44.432,14.829,65.297c7.689,18.001,18.398,34.664,31.831,49.926\r\n\t\tc38.785-37.377,89.958-57.928,144.154-57.928c54.113,0,105.286,20.676,144.154,58.135c13.354-15.175,24.061-31.979,31.83-50.166\r\n\t\tC440.9,338.396,445.889,316,446.814,294H417V278.742z M304,287.938c0,26.467-21.533,48-48,48c-10.223,0-19.701-3.223-27.496-8.691\r\n\t\tl-12.033,12.033l-11.312-11.313l11.948-11.948c-5.722-7.902-9.106-17.602-9.106-28.08c0-26.467,21.533-48,48-48\r\n\t\tc10.002,0,19.297,3.079,26.994,8.334l73.484-65.727l1.414,1.414l-62.849,76.11C300.673,267.933,304,277.551,304,287.938z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64C132.288,64,32,164.226,32,287.938c0,56.975,21.283,108.97,56.316,148.5c3.551,4.006,7.241,7.82,11.066,11.562\r\n\t\th22.193c31.713-39.103,80.144-64.096,134.424-64.096S358.711,408.897,390.424,448h22.193c3.825-3.742,7.516-7.557,11.066-11.562\r\n\t\tc35.033-39.53,56.316-91.525,56.316-148.5C480,164.226,379.712,64,256,64z M410.744,420.797\r\n\t\tc-3.051,3.408-6.392,6.863-10.213,10.564l-0.376,0.365l-0.348-0.393c-2.629-2.97-5.493-5.985-8.759-9.22\r\n\t\tc-0.275-0.271-0.555-0.539-0.834-0.807l-0.504-0.485c-17.258-16.766-37.234-29.967-59.375-39.238\r\n\t\tc-23.535-9.856-48.545-14.854-74.336-14.854c-25.791,0-50.801,4.998-74.336,14.854c-22.14,9.271-42.117,22.473-59.375,39.238\r\n\t\tl-0.504,0.485c-0.279,0.268-0.558,0.535-0.833,0.807c-3.266,3.234-6.13,6.25-8.759,9.22l-0.348,0.393l-0.377-0.365\r\n\t\tc-3.821-3.701-7.162-7.156-10.212-10.564c-33.514-37.441-51.971-85.629-51.971-135.685c0-54.666,21.502-106.053,60.545-144.694\r\n\t\tC148.87,101.779,200.781,80.5,256,80.5c55.22,0,107.13,21.279,146.17,59.918c39.043,38.642,60.545,90.029,60.545,144.694\r\n\t\tC462.715,335.168,444.259,383.355,410.744,420.797z"},"children":[{"name":"path","attribs":{"d":"M256,64C132.288,64,32,164.226,32,287.938c0,56.975,21.283,108.97,56.316,148.5c3.551,4.006,7.241,7.82,11.066,11.562\r\n\t\th22.193c31.713-39.103,80.144-64.096,134.424-64.096S358.711,408.897,390.424,448h22.193c3.825-3.742,7.516-7.557,11.066-11.562\r\n\t\tc35.033-39.53,56.316-91.525,56.316-148.5C480,164.226,379.712,64,256,64z M410.744,420.797\r\n\t\tc-3.051,3.408-6.392,6.863-10.213,10.564l-0.376,0.365l-0.348-0.393c-2.629-2.97-5.493-5.985-8.759-9.22\r\n\t\tc-0.275-0.271-0.555-0.539-0.834-0.807l-0.504-0.485c-17.258-16.766-37.234-29.967-59.375-39.238\r\n\t\tc-23.535-9.856-48.545-14.854-74.336-14.854c-25.791,0-50.801,4.998-74.336,14.854c-22.14,9.271-42.117,22.473-59.375,39.238\r\n\t\tl-0.504,0.485c-0.279,0.268-0.558,0.535-0.833,0.807c-3.266,3.234-6.13,6.25-8.759,9.22l-0.348,0.393l-0.377-0.365\r\n\t\tc-3.821-3.701-7.162-7.156-10.212-10.564c-33.514-37.441-51.971-85.629-51.971-135.685c0-54.666,21.502-106.053,60.545-144.694\r\n\t\tC148.87,101.779,200.781,80.5,256,80.5c55.22,0,107.13,21.279,146.17,59.918c39.043,38.642,60.545,90.029,60.545,144.694\r\n\t\tC462.715,335.168,444.259,383.355,410.744,420.797z"},"children":[]}]},{"name":"circle","attribs":{"cx":"256","cy":"287.938","r":"32"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"287.938","r":"32"},"children":[]}]}]}]};exports.iosSpeedometer=iosSpeedometer;var iosStarHalf={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M172.248,304.931l-54.677,159.073L256,365.37l138.445,98.634L339.76,304.937L480,207H308.613L256,48.005L203.402,207H32\r\n\tL172.248,304.931z M256,100.75L297,224h131l-108,74.711l42.623,122.481L256,345.257V100.75z"},"children":[]}]};exports.iosStarHalf=iosStarHalf;var iosStarOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M480,207H308.6L256,47.9L203.4,207H32l140.2,97.9L117.6,464L256,365.4L394.4,464l-54.7-159.1L480,207z M362.6,421.2\r\n\tl-106.6-76l-106.6,76L192,298.7L84,224h131l41-123.3L297,224h131l-108,74.6L362.6,421.2z"},"children":[]}]};exports.iosStarOutline=iosStarOutline;var iosStar={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M480,207H308.6L256,47.9L203.4,207H32l140.2,97.9L117.6,464L256,365.4L394.4,464l-54.7-159.1L480,207z"},"children":[]}]};exports.iosStar=iosStar;var iosStopwatchOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M397.6,146.7l-1.8-1.7h18.4l8.5,7.8l22.5-22.8l-40.8-40.3L381.2,112l8.8,9.2v18.6l-5-4.7c-31.3-28.3-70-45.2-113-48.9V48\r\n\t\th-32v38h-2c-43.7,3-85,22.5-116,53v-17.8l8.9-9.2L108,89.8L67.2,130l22.5,22.8l8.5-7.8H116c-0.3,0-0.7,0.7-1,1.1\r\n\t\tC82.2,181.2,64,227,64,274.6C64,379,150.1,464,256.1,464C361.9,464,448,379.1,448,274.7C448,227.1,430,181.6,397.6,146.7z\r\n\t\t M256.3,445.7c-95.5,0-173.1-76.7-173.1-170.9c0-94.3,77.7-170.9,173.1-170.9c95.5,0,173.1,76.7,173.1,170.9\r\n\t\tC429.5,369,351.8,445.7,256.3,445.7z"},"children":[{"name":"path","attribs":{"d":"M397.6,146.7l-1.8-1.7h18.4l8.5,7.8l22.5-22.8l-40.8-40.3L381.2,112l8.8,9.2v18.6l-5-4.7c-31.3-28.3-70-45.2-113-48.9V48\r\n\t\th-32v38h-2c-43.7,3-85,22.5-116,53v-17.8l8.9-9.2L108,89.8L67.2,130l22.5,22.8l8.5-7.8H116c-0.3,0-0.7,0.7-1,1.1\r\n\t\tC82.2,181.2,64,227,64,274.6C64,379,150.1,464,256.1,464C361.9,464,448,379.1,448,274.7C448,227.1,430,181.6,397.6,146.7z\r\n\t\t M256.3,445.7c-95.5,0-173.1-76.7-173.1-170.9c0-94.3,77.7-170.9,173.1-170.9c95.5,0,173.1,76.7,173.1,170.9\r\n\t\tC429.5,369,351.8,445.7,256.3,445.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M264,257.3V128h-16v129.4c-12.5,4.3-24,16.5-24,30.3c0,14.7,10,27,24,30.5l8,17.8l0,0l8-17.8c14-3.5,24-15.8,24-30.5\r\n\t\tC288,273.2,277.5,261,264,257.3z"},"children":[{"name":"path","attribs":{"d":"M264,257.3V128h-16v129.4c-12.5,4.3-24,16.5-24,30.3c0,14.7,10,27,24,30.5l8,17.8l0,0l8-17.8c14-3.5,24-15.8,24-30.5\r\n\t\tC288,273.2,277.5,261,264,257.3z"},"children":[]}]}]}]};exports.iosStopwatchOutline=iosStopwatchOutline;var iosStopwatch={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M397.6,146.7l-1.8-1.7h18.4l8.5,7.8l22.5-22.8l-40.8-40.3L381.2,112l8.8,9.2v18.6l-5-4.7c-31.3-28.3-70-45.2-113-48.9V48\r\n\t\th-32v38h-2c-43.7,3-85,22.5-116,53v-17.8l8.9-9.2L108,89.8L67.2,130l22.5,22.8l8.5-7.8H116c-0.3,0-0.7,0.7-1,1.1\r\n\t\tC82.2,181.2,64,227,64,274.6C64,379,150.1,464,256.1,464C361.9,464,448,379.1,448,274.7C448,227.1,430,181.6,397.6,146.7z\r\n\t\t M264,318.2l-8,17.8l-8-17.8c-14-3.5-24-15.8-24-30.5c0-13.8,11.5-26,24-30.3V128h16v129.3c13.5,3.7,24,15.9,24,30.4\r\n\t\tC288,302.4,278,314.7,264,318.2z"},"children":[{"name":"path","attribs":{"d":"M397.6,146.7l-1.8-1.7h18.4l8.5,7.8l22.5-22.8l-40.8-40.3L381.2,112l8.8,9.2v18.6l-5-4.7c-31.3-28.3-70-45.2-113-48.9V48\r\n\t\th-32v38h-2c-43.7,3-85,22.5-116,53v-17.8l8.9-9.2L108,89.8L67.2,130l22.5,22.8l8.5-7.8H116c-0.3,0-0.7,0.7-1,1.1\r\n\t\tC82.2,181.2,64,227,64,274.6C64,379,150.1,464,256.1,464C361.9,464,448,379.1,448,274.7C448,227.1,430,181.6,397.6,146.7z\r\n\t\t M264,318.2l-8,17.8l-8-17.8c-14-3.5-24-15.8-24-30.5c0-13.8,11.5-26,24-30.3V128h16v129.3c13.5,3.7,24,15.9,24,30.4\r\n\t\tC288,302.4,278,314.7,264,318.2z"},"children":[]}]}]}]};exports.iosStopwatch=iosStopwatch;var iosSunnyOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"247","y":"96","class":"st0","width":"18","height":"56"},"children":[{"name":"rect","attribs":{"x":"247","y":"96","class":"st0","width":"18","height":"56"},"children":[]}]},{"name":"rect","attribs":{"x":"247","y":"356","class":"st0","width":"18","height":"60"},"children":[{"name":"rect","attribs":{"x":"247","y":"356","class":"st0","width":"18","height":"60"},"children":[]}]},{"name":"rect","attribs":{"x":"360","y":"247","class":"st0","width":"56","height":"18"},"children":[{"name":"rect","attribs":{"x":"360","y":"247","class":"st0","width":"56","height":"18"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"247","class":"st0","width":"60","height":"18"},"children":[{"name":"rect","attribs":{"x":"96","y":"247","class":"st0","width":"60","height":"18"},"children":[]}]},{"name":"rect","attribs":{"x":"339","y":"317.4","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 834.4009 337.0126)","class":"st0","width":"16.8","height":"47.8"},"children":[{"name":"rect","attribs":{"x":"339","y":"317.4","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 834.4009 337.0126)","class":"st0","width":"16.8","height":"47.8"},"children":[]}]},{"name":"rect","attribs":{"x":"162.2","y":"140.7","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 407.7248 160.277)","class":"st0","width":"16.8","height":"47.9"},"children":[{"name":"rect","attribs":{"x":"162.2","y":"140.7","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 407.7248 160.277)","class":"st0","width":"16.8","height":"47.9"},"children":[]}]},{"name":"rect","attribs":{"x":"339","y":"140.7","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 218.1171 -197.4504)","class":"st0","width":"16.8","height":"47.8"},"children":[{"name":"rect","attribs":{"x":"339","y":"140.7","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 218.1171 -197.4504)","class":"st0","width":"16.8","height":"47.8"},"children":[]}]},{"name":"rect","attribs":{"x":"162.2","y":"317.4","transform":"matrix(0.707 0.7072 -0.7072 0.707 291.3531 -20.7056)","class":"st0","width":"16.8","height":"47.9"},"children":[{"name":"rect","attribs":{"x":"162.2","y":"317.4","transform":"matrix(0.707 0.7072 -0.7072 0.707 291.3531 -20.7056)","class":"st0","width":"16.8","height":"47.9"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M256,331.8c-41.8,0-75.8-34-75.8-75.8s34-75.8,75.8-75.8c41.8,0,75.8,34,75.8,75.8S297.8,331.8,256,331.8z\r\n\t\t M256,197.1c-32.5,0-58.9,26.4-58.9,58.9s26.4,58.9,58.9,58.9c32.5,0,58.9-26.4,58.9-58.9S288.5,197.1,256,197.1z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,331.8c-41.8,0-75.8-34-75.8-75.8s34-75.8,75.8-75.8c41.8,0,75.8,34,75.8,75.8S297.8,331.8,256,331.8z\r\n\t\t M256,197.1c-32.5,0-58.9,26.4-58.9,58.9s26.4,58.9,58.9,58.9c32.5,0,58.9-26.4,58.9-58.9S288.5,197.1,256,197.1z"},"children":[]}]}]}]};exports.iosSunnyOutline=iosSunnyOutline;var iosSunny={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"247","y":"96","class":"st0","width":"18","height":"56"},"children":[{"name":"rect","attribs":{"x":"247","y":"96","class":"st0","width":"18","height":"56"},"children":[]}]},{"name":"rect","attribs":{"x":"247","y":"356","class":"st0","width":"18","height":"60"},"children":[{"name":"rect","attribs":{"x":"247","y":"356","class":"st0","width":"18","height":"60"},"children":[]}]},{"name":"rect","attribs":{"x":"360","y":"247","class":"st0","width":"56","height":"18"},"children":[{"name":"rect","attribs":{"x":"360","y":"247","class":"st0","width":"56","height":"18"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"247","class":"st0","width":"60","height":"18"},"children":[{"name":"rect","attribs":{"x":"96","y":"247","class":"st0","width":"60","height":"18"},"children":[]}]},{"name":"rect","attribs":{"x":"339","y":"317.4","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 834.4009 337.0126)","class":"st0","width":"16.8","height":"47.8"},"children":[{"name":"rect","attribs":{"x":"339","y":"317.4","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 834.4009 337.0126)","class":"st0","width":"16.8","height":"47.8"},"children":[]}]},{"name":"rect","attribs":{"x":"162.2","y":"140.7","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 407.7248 160.277)","class":"st0","width":"16.8","height":"47.9"},"children":[{"name":"rect","attribs":{"x":"162.2","y":"140.7","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 407.7248 160.277)","class":"st0","width":"16.8","height":"47.9"},"children":[]}]},{"name":"rect","attribs":{"x":"339","y":"140.7","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 218.1171 -197.4504)","class":"st0","width":"16.8","height":"47.8"},"children":[{"name":"rect","attribs":{"x":"339","y":"140.7","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 218.1171 -197.4504)","class":"st0","width":"16.8","height":"47.8"},"children":[]}]},{"name":"rect","attribs":{"x":"162.2","y":"317.4","transform":"matrix(0.707 0.7072 -0.7072 0.707 291.3531 -20.7056)","class":"st0","width":"16.8","height":"47.9"},"children":[{"name":"rect","attribs":{"x":"162.2","y":"317.4","transform":"matrix(0.707 0.7072 -0.7072 0.707 291.3531 -20.7056)","class":"st0","width":"16.8","height":"47.9"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M256,331.8c-41.8,0-75.8-34-75.8-75.8s34-75.8,75.8-75.8c41.8,0,75.8,34,75.8,75.8S297.8,331.8,256,331.8z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,331.8c-41.8,0-75.8-34-75.8-75.8s34-75.8,75.8-75.8c41.8,0,75.8,34,75.8,75.8S297.8,331.8,256,331.8z"},"children":[]}]}]}]};exports.iosSunny=iosSunny;var iosTelephoneOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M415.9,335.5c-14.6-15-56.1-43.1-83.3-43.1c-6.3,0-11.8,1.4-16.3,4.3c-13.3,8.5-23.9,15.1-29,15.1c-2.8,0-5.8-2.5-12.4-8.2\r\n\tl-1.1-1c-18.3-15.9-22.2-20-29.3-27.4l-1.8-1.9c-1.3-1.3-2.4-2.5-3.5-3.6c-6.2-6.4-10.7-11-26.6-29l-0.7-0.8\r\n\tc-7.6-8.6-12.6-14.2-12.9-18.3c-0.3-4,3.2-10.5,12.1-22.6c10.8-14.6,11.2-32.6,1.3-53.5c-7.9-16.5-20.8-32.3-32.2-46.2l-1-1.2\r\n\tc-9.8-12-21.2-18-33.9-18c-14.1,0-25.8,7.6-32,11.6c-0.5,0.3-1,0.7-1.5,1c-13.9,8.8-24,20.9-27.8,33.2c-5.7,18.5-9.5,42.5,17.8,92.4\r\n\tc23.6,43.2,45,72.2,79,107.1c32,32.8,46.2,43.4,78,66.4c35.4,25.6,69.4,40.3,93.2,40.3c22.1,0,39.5,0,64.3-29.9\r\n\tC442.3,370.8,431.5,351.6,415.9,335.5z M404.4,391.4c-20,24.2-31.5,24.2-52.3,24.2c-20.3,0-51.8-14-84.2-37.3\r\n\tc-31-22.4-44.8-32.7-75.9-64.6c-32.9-33.7-53.6-61.8-76.4-103.5c-24.1-44.1-21.4-63.4-16.5-79.3c2.6-8.5,10.4-17.6,21-24.2\r\n\tc0.5-0.3,1-0.7,1.6-1c5.3-3.4,14.1-9.1,23.7-9.1c8,0,15.1,4,21.9,12.3l1,1.2c25.5,31.2,45.4,58.8,30.4,79.2\r\n\tc-10.6,14.3-16.2,24-15.3,34c0.8,9.7,7.3,17,17.1,28l0.7,0.8c16.1,18.2,20.7,23,27.1,29.5c1.1,1.1,2.2,2.3,3.5,3.6l1.8,1.9\r\n\tc7.4,7.7,11.5,11.9,30.3,28.4l1.1,1c8,7,13.9,12.1,22.5,12.1c8.9,0,18.7-5.6,37.3-17.5c1.9-1.2,4.6-1.9,8-1.9\r\n\tc21.7,0,59.1,24.8,72.2,38.3C417,359.7,423,368.9,404.4,391.4z"},"children":[]}]};exports.iosTelephoneOutline=iosTelephoneOutline;var iosTelephone={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M415.9,335.5c-14.6-15-56.1-43.1-83.3-43.1c-6.3,0-11.8,1.4-16.3,4.3c-13.3,8.5-23.9,15.1-29,15.1c-2.8,0-5.8-2.5-12.4-8.2\r\n\tl-1.1-1c-18.3-15.9-22.2-20-29.3-27.4l-1.8-1.9c-1.3-1.3-2.4-2.5-3.5-3.6c-6.2-6.4-10.7-11-26.6-29l-0.7-0.8\r\n\tc-7.6-8.6-12.6-14.2-12.9-18.3c-0.3-4,3.2-10.5,12.1-22.6c10.8-14.6,11.2-32.6,1.3-53.5c-7.9-16.5-20.8-32.3-32.2-46.2l-1-1.2\r\n\tc-9.8-12-21.2-18-33.9-18c-14.1,0-25.8,7.6-32,11.6c-0.5,0.3-1,0.7-1.5,1c-13.9,8.8-24,20.9-27.8,33.2c-5.7,18.5-9.5,42.5,17.8,92.4\r\n\tc23.6,43.2,45,72.2,79,107.1c32,32.8,46.2,43.4,78,66.4c35.4,25.6,69.4,40.3,93.2,40.3c22.1,0,39.5,0,64.3-29.9\r\n\tC442.3,370.8,431.5,351.6,415.9,335.5z"},"children":[]}]};exports.iosTelephone=iosTelephone;var iosTennisballOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M464,256c0-114.863-93.13-208-208-208C141.137,48,48,141.136,48,256c0,114.863,93.137,208,208,208\r\n\tc2.541,0,5.068-0.062,7.587-0.152c0.479-0.017,0.957-0.034,1.435-0.055c0.942-0.04,1.884-0.083,2.823-0.136\r\n\tc0.85-0.047,1.698-0.104,2.547-0.161c0.639-0.044,1.279-0.08,1.917-0.13c1.354-0.104,2.705-0.221,4.055-0.352\r\n\tc0-0.003,0-0.006,0-0.009c97.47-9.474,175.229-86.229,186.274-183.223c0.02-0.001,0.038,0,0.057-0.001\r\n\tc0.604-5.315,1.002-10.667,1.196-16.05c-0.016,0.001-0.032,0.001-0.049,0.001C463.937,261.166,464,258.591,464,256z M446.665,256\r\n\tc0,2.568-0.066,5.121-0.167,7.664c-23.639-1.076-46.677-6.106-68.616-15.005c-25.791-10.458-48.938-25.831-68.797-45.691\r\n\tc-19.86-19.86-35.233-43.007-45.692-68.797c-8.903-21.956-13.935-45.014-15.006-68.67c2.527-0.1,5.063-0.165,7.614-0.165\r\n\tC361.13,65.335,446.665,150.869,446.665,256z M65.337,256c0-1.318,0.023-2.631,0.05-3.942c22.476,1.379,44.388,6.337,65.3,14.817\r\n\tc25.791,10.458,48.938,25.831,68.798,45.691c19.86,19.859,35.232,43.007,45.691,68.798c8.474,20.896,13.43,42.792,14.814,65.249\r\n\tc-1.328,0.027-2.656,0.051-3.99,0.051C150.87,446.664,65.336,361.13,65.337,256z M275.943,445.623\r\n\tc-3.273-52.566-24.974-104.198-65.145-144.369c-40.186-40.186-91.84-61.889-144.427-65.15\r\n\tc9.172-88.053,78.52-158.478,166.074-169.313c2.595,53.64,24.36,106.525,65.326,147.49c40.949,40.952,93.811,62.713,147.433,65.322\r\n\tC434.351,367.118,363.957,436.432,275.943,445.623z"},"children":[]}]};exports.iosTennisballOutline=iosTennisballOutline;var iosTennisball={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M48.05,251.556c-0.001,0.039-0.003,0.077-0.004,0.116c0,0,0.002,0,0.003,0C48.049,251.634,48.049,251.595,48.05,251.556z"},"children":[{"name":"path","attribs":{"d":"M48.05,251.556c-0.001,0.039-0.003,0.077-0.004,0.116c0,0,0.002,0,0.003,0C48.049,251.634,48.049,251.595,48.05,251.556z"},"children":[]}]},{"name":"path","attribs":{"d":"M260.311,463.915c0.066-0.002,0.133-0.006,0.199-0.007c-0.066,0.001-0.133,0.001-0.199,0.004\r\n\t\tC260.311,463.912,260.311,463.913,260.311,463.915z"},"children":[{"name":"path","attribs":{"d":"M260.311,463.915c0.066-0.002,0.133-0.006,0.199-0.007c-0.066,0.001-0.133,0.001-0.199,0.004\r\n\t\tC260.311,463.912,260.311,463.913,260.311,463.915z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,48.001c-2.586,0-5.29,0.064-7.852,0.158L248,48.153c0,0.003,0,0.004,0,0.006c-5,0.199-10,0.602-16,1.205\r\n\t\tc0-0.002,0-0.004,0-0.008c0,0.005,0.083,0.008,0.072,0.012c-96.974,11.061-173.654,88.975-183.13,186.41\r\n\t\tc-0.004,0.018,0.045,0.222,0.042,0.222c0.003,0,0.004,0,0.007,0c-0.513,5-0.826,10-0.936,16c-0.001,0-0.003,0-0.004,0l0.003-0.152\r\n\t\tc-0.028,1.43-0.054,2.777-0.054,4.215c0,114.852,92.977,207.938,207.841,207.938c6.856,0,14.159-0.383,20.159-1.031\r\n\t\tc0,0.002,0,0.006,0,0.006c0-0.004,0.213-0.008,0.24-0.014c97.436-9.486,175.247-86.086,186.312-183.036\r\n\t\tc0.004-0.014,0.088,0.074,0.092,0.074c-0.002,0-0.006,0-0.008,0c0.889-8,1.363-15.859,1.363-23.904\r\n\t\tC464,141.245,370.87,48.001,256,48.001z M130.63,266.853c-20.895-8.474-42.788-13.43-65.244-14.816\r\n\t\tc0.11-5.374,0.438-10.695,0.986-15.952c52.568,3.275,104.203,24.977,144.375,65.146c40.172,40.169,61.876,91.797,65.152,144.359\r\n\t\tc-5.257,0.548-10.579,0.876-15.954,0.985c-1.385-22.453-6.342-44.344-14.816-65.236c-10.459-25.79-25.834-48.937-45.696-68.795\r\n\t\tC179.572,292.684,156.423,277.311,130.63,266.853z M297.722,214.265c-40.964-40.959-62.731-93.835-65.332-147.467\r\n\t\tc5.25-0.652,10.568-1.08,15.941-1.293c1.073,23.65,6.105,46.702,15.007,68.654c10.461,25.79,25.835,48.936,45.696,68.795\r\n\t\tc19.862,19.859,43.01,35.232,68.803,45.691c21.954,8.901,45.008,13.933,68.66,15.007c-0.213,5.37-0.643,10.689-1.293,15.939\r\n\t\tC391.564,276.989,338.686,255.225,297.722,214.265z"},"children":[{"name":"path","attribs":{"d":"M256,48.001c-2.586,0-5.29,0.064-7.852,0.158L248,48.153c0,0.003,0,0.004,0,0.006c-5,0.199-10,0.602-16,1.205\r\n\t\tc0-0.002,0-0.004,0-0.008c0,0.005,0.083,0.008,0.072,0.012c-96.974,11.061-173.654,88.975-183.13,186.41\r\n\t\tc-0.004,0.018,0.045,0.222,0.042,0.222c0.003,0,0.004,0,0.007,0c-0.513,5-0.826,10-0.936,16c-0.001,0-0.003,0-0.004,0l0.003-0.152\r\n\t\tc-0.028,1.43-0.054,2.777-0.054,4.215c0,114.852,92.977,207.938,207.841,207.938c6.856,0,14.159-0.383,20.159-1.031\r\n\t\tc0,0.002,0,0.006,0,0.006c0-0.004,0.213-0.008,0.24-0.014c97.436-9.486,175.247-86.086,186.312-183.036\r\n\t\tc0.004-0.014,0.088,0.074,0.092,0.074c-0.002,0-0.006,0-0.008,0c0.889-8,1.363-15.859,1.363-23.904\r\n\t\tC464,141.245,370.87,48.001,256,48.001z M130.63,266.853c-20.895-8.474-42.788-13.43-65.244-14.816\r\n\t\tc0.11-5.374,0.438-10.695,0.986-15.952c52.568,3.275,104.203,24.977,144.375,65.146c40.172,40.169,61.876,91.797,65.152,144.359\r\n\t\tc-5.257,0.548-10.579,0.876-15.954,0.985c-1.385-22.453-6.342-44.344-14.816-65.236c-10.459-25.79-25.834-48.937-45.696-68.795\r\n\t\tC179.572,292.684,156.423,277.311,130.63,266.853z M297.722,214.265c-40.964-40.959-62.731-93.835-65.332-147.467\r\n\t\tc5.25-0.652,10.568-1.08,15.941-1.293c1.073,23.65,6.105,46.702,15.007,68.654c10.461,25.79,25.835,48.936,45.696,68.795\r\n\t\tc19.862,19.859,43.01,35.232,68.803,45.691c21.954,8.901,45.008,13.933,68.66,15.007c-0.213,5.37-0.643,10.689-1.293,15.939\r\n\t\tC391.564,276.989,338.686,255.225,297.722,214.265z"},"children":[]}]}]}]};exports.iosTennisball=iosTennisball;var iosThunderstormOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"class":"st0","points":"312,272 272,272 288,224 216,224 201,304 253.3,304 224,400 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"312,272 272,272 288,224 216,224 201,304 253.3,304 224,400 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M328.4,172.7c-2.7,0-5.4,0-8,0.3c-7.9-35-39.1-61.4-76.4-61.4c-43.3,0-78.3,35.2-78.3,78.5\r\n\t\t\tc0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.7-47.1,52.8c0,28.6,23.2,53.3,51.7,53.3H182v-17h-11.3c-9.5,0-18.5-4.1-25.4-11\r\n\t\t\tc-6.8-7-10.6-16.3-10.6-26c0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.3,14.2-1.8c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\t\tc0-34.6,28.1-62.7,62.6-62.7c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\t\tc26.9,0,48.8,22.3,48.8,49.4c0,27.1-21.9,49.4-48.8,49.4H320v17h8.4c35.7,0,64.6-30.1,64.6-65.9\r\n\t\t\tC393,202.4,364.1,172.7,328.4,172.7z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M328.4,172.7c-2.7,0-5.4,0-8,0.3c-7.9-35-39.1-61.4-76.4-61.4c-43.3,0-78.3,35.2-78.3,78.5\r\n\t\t\tc0,2.6,0.1,5.2,0.4,7.8c-26.4,2.3-47.1,25.7-47.1,52.8c0,28.6,23.2,53.3,51.7,53.3H182v-17h-11.3c-9.5,0-18.5-4.1-25.4-11\r\n\t\t\tc-6.8-7-10.6-16.3-10.6-26c0-18.6,14.5-33.8,33.2-36.9c1.6-0.3,8.8-1.3,14.2-1.8c0,0-0.5-5.3-0.6-9.6c-0.1-4.3-0.1-9.4-0.1-11.5\r\n\t\t\tc0-34.6,28.1-62.7,62.6-62.7c14.5,0,28.1,4.8,39.3,13.9c10.9,8.9,18.6,21.3,21.7,34.9l3.1,14l14.2-1.8c2.1-0.3,4.1-0.4,6.1-0.4\r\n\t\t\tc26.9,0,48.8,22.3,48.8,49.4c0,27.1-21.9,49.4-48.8,49.4H320v17h8.4c35.7,0,64.6-30.1,64.6-65.9\r\n\t\t\tC393,202.4,364.1,172.7,328.4,172.7z"},"children":[]}]}]}]}]}]};exports.iosThunderstormOutline=iosThunderstormOutline;var iosThunderstorm={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"class":"st0","points":"272,272 288,224 216,224 201,304 253.3,304 224,400 290,304 312,272 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"272,272 288,224 216,224 201,304 253.3,304 224,400 290,304 312,272 \t"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M202.7,208l107.5,0l-16,48H312h30.4l-33,48h19c35.7,0,64.6-30.1,64.6-65.9c0-35.8-28.9-65.5-64.6-65.5\r\n\t\tc-2.7,0-5.4,0-8,0.3c-7.9-35-39.1-61.4-76.4-61.4c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8\r\n\t\tc-26.4,2.3-47.1,25.7-47.1,52.8c0,28.6,23.2,53.3,51.7,53.3h14"},"children":[{"name":"path","attribs":{"class":"st0","d":"M202.7,208l107.5,0l-16,48H312h30.4l-33,48h19c35.7,0,64.6-30.1,64.6-65.9c0-35.8-28.9-65.5-64.6-65.5\r\n\t\tc-2.7,0-5.4,0-8,0.3c-7.9-35-39.1-61.4-76.4-61.4c-43.3,0-78.3,35.2-78.3,78.5c0,2.6,0.1,5.2,0.4,7.8\r\n\t\tc-26.4,2.3-47.1,25.7-47.1,52.8c0,28.6,23.2,53.3,51.7,53.3h14"},"children":[]}]}]}]};exports.iosThunderstorm=iosThunderstorm;var iosTimeOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\t\tC480,132.3,379.7,32,256,32z M403.1,403.1c-19.1,19.1-41.4,34.1-66.1,44.6c-25.6,10.8-52.9,16.3-81,16.3c-28.1,0-55.3-5.5-81-16.3\r\n\t\t\tc-24.8-10.5-47-25.5-66.1-44.6C89.8,384,74.8,361.7,64.3,337C53.5,311.3,48,284.1,48,256c0-28.1,5.5-55.3,16.3-81\r\n\t\t\tc10.5-24.8,25.5-47,44.6-66.1C128,89.8,150.3,74.8,175,64.3C200.7,53.5,227.9,48,256,48c28.1,0,55.3,5.5,81,16.3\r\n\t\t\tc24.8,10.5,47,25.5,66.1,44.6c19.1,19.1,34.1,41.4,44.6,66.1c10.8,25.6,16.3,52.9,16.3,81c0,28.1-5.5,55.3-16.3,81\r\n\t\t\tC437.2,361.7,422.2,384,403.1,403.1z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\t\tC480,132.3,379.7,32,256,32z M403.1,403.1c-19.1,19.1-41.4,34.1-66.1,44.6c-25.6,10.8-52.9,16.3-81,16.3c-28.1,0-55.3-5.5-81-16.3\r\n\t\t\tc-24.8-10.5-47-25.5-66.1-44.6C89.8,384,74.8,361.7,64.3,337C53.5,311.3,48,284.1,48,256c0-28.1,5.5-55.3,16.3-81\r\n\t\t\tc10.5-24.8,25.5-47,44.6-66.1C128,89.8,150.3,74.8,175,64.3C200.7,53.5,227.9,48,256,48c28.1,0,55.3,5.5,81,16.3\r\n\t\t\tc24.8,10.5,47,25.5,66.1,44.6c19.1,19.1,34.1,41.4,44.6,66.1c10.8,25.6,16.3,52.9,16.3,81c0,28.1-5.5,55.3-16.3,81\r\n\t\t\tC437.2,361.7,422.2,384,403.1,403.1z"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"256","cy":"80","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"256","cy":"80","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"256","cy":"432","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"256","cy":"432","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"432","cy":"256","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"432","cy":"256","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"80","cy":"256","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"80","cy":"256","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"168","cy":"103.6","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"168","cy":"103.6","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"344","cy":"408.4","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"344","cy":"408.4","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"408.4","cy":"168","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"408.4","cy":"168","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"103.6","cy":"344","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"103.6","cy":"344","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"103.6","cy":"168","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"103.6","cy":"168","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"408.4","cy":"344","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"408.4","cy":"344","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"344","cy":"103.6","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"344","cy":"103.6","r":"8"},"children":[]}]},{"name":"circle","attribs":{"class":"st0","cx":"168","cy":"408.4","r":"8"},"children":[{"name":"circle","attribs":{"class":"st0","cx":"168","cy":"408.4","r":"8"},"children":[]}]}]}]},{"name":"path","attribs":{"class":"st0","d":"M269.9,248c-2.9-5-8.1-7.8-13.4-8l-38-63.4c-2.3-3.8-7.2-5-11-2.7c-3.8,2.3-5,7.2-2.7,11l37.6,62.9\r\n\t\tc-2.9,4.8-3.2,11.1-0.2,16.3c1.5,2.5,3.5,4.5,5.9,5.8V392c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8V269.9\r\n\t\tC271.7,265.4,274.3,255.7,269.9,248z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M269.9,248c-2.9-5-8.1-7.8-13.4-8l-38-63.4c-2.3-3.8-7.2-5-11-2.7c-3.8,2.3-5,7.2-2.7,11l37.6,62.9\r\n\t\tc-2.9,4.8-3.2,11.1-0.2,16.3c1.5,2.5,3.5,4.5,5.9,5.8V392c0,4.4,3.6,8,8,8c4.4,0,8-3.6,8-8V269.9\r\n\t\tC271.7,265.4,274.3,255.7,269.9,248z"},"children":[]}]}]}]};exports.iosTimeOutline=iosTimeOutline;var iosTime={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\tC480,132.3,379.7,32,256,32z M256,72c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S251.6,72,256,72z M80,264c-4.4,0-8-3.6-8-8\r\n\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8C88,260.4,84.4,264,80,264z M107.6,350.9c-3.8,2.2-8.7,0.9-10.9-2.9c-2.2-3.8-0.9-8.7,2.9-10.9\r\n\t\tc3.8-2.2,8.7-0.9,10.9,2.9C112.7,343.8,111.4,348.7,107.6,350.9z M110.5,172c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9\r\n\t\ts7.1-5.1,10.9-2.9C111.4,163.3,112.7,168.2,110.5,172z M164,96.7c3.8-2.2,8.7-0.9,10.9,2.9c2.2,3.8,0.9,8.7-2.9,10.9\r\n\t\tc-3.8,2.2-8.7,0.9-10.9-2.9C158.9,103.8,160.2,98.9,164,96.7z M174.9,412.4c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9\r\n\t\tc2.2-3.8,7.1-5.1,10.9-2.9S177.1,408.6,174.9,412.4z M256,440c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S260.4,440,256,440z M264,269.9\r\n\t\tV392c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8V269.8c-2.4-1.4-4.4-3.3-5.9-5.8c-3-5.2-2.7-11.5,0.2-16.3l-37.6-62.9c-2.3-3.8-1-8.7,2.7-11\r\n\t\tc3.8-2.3,8.7-1,11,2.7l38,63.4c5.4,0.1,10.6,3,13.4,8C274.3,255.7,271.7,265.4,264,269.9z M348,415.3c-3.8,2.2-8.7,0.9-10.9-2.9\r\n\t\tc-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C353.1,408.2,351.8,413.1,348,415.3z M350.9,107.6c-2.2,3.8-7.1,5.1-10.9,2.9\r\n\t\tc-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C351.8,98.9,353.1,103.8,350.9,107.6z M415.3,348c-2.2,3.8-7.1,5.1-10.9,2.9\r\n\t\tc-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C416.2,339.3,417.6,344.2,415.3,348z M412.4,174.9c-3.8,2.2-8.7,0.9-10.9-2.9\r\n\t\tc-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C417.6,167.8,416.2,172.7,412.4,174.9z M432,264c-4.4,0-8-3.6-8-8\r\n\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8C440,260.4,436.4,264,432,264z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\tC480,132.3,379.7,32,256,32z M256,72c4.4,0,8,3.6,8,8s-3.6,8-8,8s-8-3.6-8-8S251.6,72,256,72z M80,264c-4.4,0-8-3.6-8-8\r\n\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8C88,260.4,84.4,264,80,264z M107.6,350.9c-3.8,2.2-8.7,0.9-10.9-2.9c-2.2-3.8-0.9-8.7,2.9-10.9\r\n\t\tc3.8-2.2,8.7-0.9,10.9,2.9C112.7,343.8,111.4,348.7,107.6,350.9z M110.5,172c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9\r\n\t\ts7.1-5.1,10.9-2.9C111.4,163.3,112.7,168.2,110.5,172z M164,96.7c3.8-2.2,8.7-0.9,10.9,2.9c2.2,3.8,0.9,8.7-2.9,10.9\r\n\t\tc-3.8,2.2-8.7,0.9-10.9-2.9C158.9,103.8,160.2,98.9,164,96.7z M174.9,412.4c-2.2,3.8-7.1,5.1-10.9,2.9c-3.8-2.2-5.1-7.1-2.9-10.9\r\n\t\tc2.2-3.8,7.1-5.1,10.9-2.9S177.1,408.6,174.9,412.4z M256,440c-4.4,0-8-3.6-8-8s3.6-8,8-8s8,3.6,8,8S260.4,440,256,440z M264,269.9\r\n\t\tV392c0,4.4-3.6,8-8,8c-4.4,0-8-3.6-8-8V269.8c-2.4-1.4-4.4-3.3-5.9-5.8c-3-5.2-2.7-11.5,0.2-16.3l-37.6-62.9c-2.3-3.8-1-8.7,2.7-11\r\n\t\tc3.8-2.3,8.7-1,11,2.7l38,63.4c5.4,0.1,10.6,3,13.4,8C274.3,255.7,271.7,265.4,264,269.9z M348,415.3c-3.8,2.2-8.7,0.9-10.9-2.9\r\n\t\tc-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C353.1,408.2,351.8,413.1,348,415.3z M350.9,107.6c-2.2,3.8-7.1,5.1-10.9,2.9\r\n\t\tc-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C351.8,98.9,353.1,103.8,350.9,107.6z M415.3,348c-2.2,3.8-7.1,5.1-10.9,2.9\r\n\t\tc-3.8-2.2-5.1-7.1-2.9-10.9c2.2-3.8,7.1-5.1,10.9-2.9C416.2,339.3,417.6,344.2,415.3,348z M412.4,174.9c-3.8,2.2-8.7,0.9-10.9-2.9\r\n\t\tc-2.2-3.8-0.9-8.7,2.9-10.9c3.8-2.2,8.7-0.9,10.9,2.9C417.6,167.8,416.2,172.7,412.4,174.9z M432,264c-4.4,0-8-3.6-8-8\r\n\t\tc0-4.4,3.6-8,8-8s8,3.6,8,8C440,260.4,436.4,264,432,264z"},"children":[]}]}]}]};exports.iosTime=iosTime;var iosTimerOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M236.6,271.6c4.6,5.7,11.5,9.4,19.4,9.4c13.8,0,25-11.2,25-25c0-7.3-3.2-13.8-8.2-18.4c-0.6-0.7-1.3-1.5-2.2-2.2\r\n\tc0,0-117.7-87.5-120.3-85.2c-2.6,2.3,85.3,120.2,85.3,120.2C235.8,270.8,236.3,271.2,236.6,271.6z"},"children":[]},{"name":"path","attribs":{"d":"M256.2,48L256.2,48H256v112h16V65.3c97.8,8.3,175.3,90.5,175.3,190.5c0,105.5-85.7,191.4-191.2,191.4\r\n\tc-105.5,0-191.3-85.8-191.3-191.3c0-52.8,21.5-100.6,56.1-135.2L109,108.9C71.3,146.6,48,198.6,48,256c0,114.9,93.1,208,208,208\r\n\tc114.9,0,208-93.1,208-208C464,141.1,371,48,256.2,48z"},"children":[]}]};exports.iosTimerOutline=iosTimerOutline;var iosTimer={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48C141.1,48,48,141.1,48,256c0,114.9,93.1,208,208,208c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z\r\n\t M150.5,150.5c2.6-2.3,119.9,84.9,119.9,84.9c1,0.7,1.6,1.5,2.2,2.2c5,4.6,8.2,11,8.2,18.3c0,13.7-11.1,24.9-24.9,24.9\r\n\tc-7.8,0-14.7-3.7-19.3-9.4c-0.4-0.4-0.8-0.7-1.1-1.1C235.6,270.4,148,152.9,150.5,150.5z M256.1,447.2\r\n\tc-105.7,0-191.4-85.7-191.4-191.4c0-52.8,21.4-100.7,56-135.3l11.8,11.8c-31.6,31.6-51.2,75.3-51.2,123.5\r\n\tc0,96.3,78.4,174.7,174.7,174.7s174.5-78.4,174.5-174.7c0-90.3-70.5-165.1-158.5-174V160h-16V64.4c105.7,0,191.5,85.7,191.5,191.4\r\n\tC447.5,361.5,361.7,447.2,256.1,447.2z"},"children":[]}]};exports.iosTimer=iosTimer;var iosToggleOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,320c26.467,0,48,21.533,48,48s-21.533,48-48,48s-48-21.533-48-48S101.533,320,128,320 M128,304\r\n\t\t\tc-35.346,0-64,28.654-64,64c0,35.347,28.654,64,64,64s64-28.653,64-64C192,332.654,163.346,304,128,304L128,304z"},"children":[{"name":"path","attribs":{"d":"M128,320c26.467,0,48,21.533,48,48s-21.533,48-48,48s-48-21.533-48-48S101.533,320,128,320 M128,304\r\n\t\t\tc-35.346,0-64,28.654-64,64c0,35.347,28.654,64,64,64s64-28.653,64-64C192,332.654,163.346,304,128,304L128,304z"},"children":[]}]},{"name":"path","attribs":{"d":"M383.25,288c44.388,0,80.625,36.112,80.625,80.5S427.888,448,383.5,448h-255C84.112,448,48,412.888,48,368.5\r\n\t\t\tS84.112,288,128.5,288H383 M383.5,272h-255C75.205,272,32,315.205,32,368.5S75.205,464,128.5,464h255\r\n\t\t\tc53.295,0,96.5-42.205,96.5-95.5S436.795,272,383.5,272L383.5,272z"},"children":[{"name":"path","attribs":{"d":"M383.25,288c44.388,0,80.625,36.112,80.625,80.5S427.888,448,383.5,448h-255C84.112,448,48,412.888,48,368.5\r\n\t\t\tS84.112,288,128.5,288H383 M383.5,272h-255C75.205,272,32,315.205,32,368.5S75.205,464,128.5,464h255\r\n\t\t\tc53.295,0,96.5-42.205,96.5-95.5S436.795,272,383.5,272L383.5,272z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,96c26.467,0,48,21.533,48,48s-21.533,48-48,48s-48-21.533-48-48S357.533,96,384,96 M384,80\r\n\t\t\tc-35.346,0-64,28.654-64,64c0,35.347,28.654,64,64,64s64-28.653,64-64C448,108.654,419.346,80,384,80L384,80z"},"children":[{"name":"path","attribs":{"d":"M384,96c26.467,0,48,21.533,48,48s-21.533,48-48,48s-48-21.533-48-48S357.533,96,384,96 M384,80\r\n\t\t\tc-35.346,0-64,28.654-64,64c0,35.347,28.654,64,64,64s64-28.653,64-64C448,108.654,419.346,80,384,80L384,80z"},"children":[]}]},{"name":"path","attribs":{"d":"M129,64h254.5c44.388,0,80.5,36.112,80.5,80.5S427.888,224,383.5,224h-255c-44.388,0-80.375-35.112-80.375-79.5\r\n\t\t\tS84.362,64,128.75,64 M128.5,48C75.205,48,32,91.205,32,144.5S75.205,240,128.5,240h255c53.295,0,96.5-42.205,96.5-95.5\r\n\t\t\tS436.795,48,383.5,48H128.5L128.5,48z"},"children":[{"name":"path","attribs":{"d":"M129,64h254.5c44.388,0,80.5,36.112,80.5,80.5S427.888,224,383.5,224h-255c-44.388,0-80.375-35.112-80.375-79.5\r\n\t\t\tS84.362,64,128.75,64 M128.5,48C75.205,48,32,91.205,32,144.5S75.205,240,128.5,240h255c53.295,0,96.5-42.205,96.5-95.5\r\n\t\t\tS436.795,48,383.5,48H128.5L128.5,48z"},"children":[]}]}]}]}]}]};exports.iosToggleOutline=iosToggleOutline;var iosToggle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,320c-26.467,0-48,21.533-48,48s21.533,48,48,48s48-21.533,48-48S154.467,320,128,320z"},"children":[{"name":"path","attribs":{"d":"M128,320c-26.467,0-48,21.533-48,48s21.533,48,48,48s48-21.533,48-48S154.467,320,128,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M383.5,272h-255C75.205,272,32,315.205,32,368.5S75.205,464,128.5,464h255c53.295,0,96.5-42.205,96.5-95.5\r\n\t\tS436.795,272,383.5,272z M128,432c-35.346,0-64-28.653-64-64c0-35.346,28.654-64,64-64s64,28.654,64,64\r\n\t\tC192,403.347,163.346,432,128,432z"},"children":[{"name":"path","attribs":{"d":"M383.5,272h-255C75.205,272,32,315.205,32,368.5S75.205,464,128.5,464h255c53.295,0,96.5-42.205,96.5-95.5\r\n\t\tS436.795,272,383.5,272z M128,432c-35.346,0-64-28.653-64-64c0-35.346,28.654-64,64-64s64,28.654,64,64\r\n\t\tC192,403.347,163.346,432,128,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,192c26.467,0,48-21.533,48-48s-21.533-48-48-48s-48,21.533-48,48S357.533,192,384,192z"},"children":[{"name":"path","attribs":{"d":"M384,192c26.467,0,48-21.533,48-48s-21.533-48-48-48s-48,21.533-48,48S357.533,192,384,192z"},"children":[]}]},{"name":"path","attribs":{"d":"M128.5,240h255c53.295,0,96.5-42.205,96.5-95.5S436.795,48,383.5,48h-255C75.205,48,32,91.205,32,144.5\r\n\t\tS75.205,240,128.5,240z M384,80c35.346,0,64,28.654,64,64c0,35.347-28.654,64-64,64s-64-28.653-64-64\r\n\t\tC320,108.654,348.654,80,384,80z"},"children":[{"name":"path","attribs":{"d":"M128.5,240h255c53.295,0,96.5-42.205,96.5-95.5S436.795,48,383.5,48h-255C75.205,48,32,91.205,32,144.5\r\n\t\tS75.205,240,128.5,240z M384,80c35.346,0,64,28.654,64,64c0,35.347-28.654,64-64,64s-64-28.653-64-64\r\n\t\tC320,108.654,348.654,80,384,80z"},"children":[]}]}]}]};exports.iosToggle=iosToggle;var iosTrashOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M400,113.3h-80v-20c0-16.2-13.1-29.3-29.3-29.3h-69.5C205.1,64,192,77.1,192,93.3v20h-80V128h21.1l23.6,290.7\r\n\t\tc0,16.2,13.1,29.3,29.3,29.3h141c16.2,0,29.3-13.1,29.3-29.3L379.6,128H400V113.3z M206.6,93.3c0-8.1,6.6-14.7,14.6-14.7h69.5\r\n\t\tc8.1,0,14.6,6.6,14.6,14.7v20h-98.7V93.3z M341.6,417.9l0,0.4v0.4c0,8.1-6.6,14.7-14.6,14.7H186c-8.1,0-14.6-6.6-14.6-14.7v-0.4\r\n\t\tl0-0.4L147.7,128h217.2L341.6,417.9z"},"children":[{"name":"path","attribs":{"d":"M400,113.3h-80v-20c0-16.2-13.1-29.3-29.3-29.3h-69.5C205.1,64,192,77.1,192,93.3v20h-80V128h21.1l23.6,290.7\r\n\t\tc0,16.2,13.1,29.3,29.3,29.3h141c16.2,0,29.3-13.1,29.3-29.3L379.6,128H400V113.3z M206.6,93.3c0-8.1,6.6-14.7,14.6-14.7h69.5\r\n\t\tc8.1,0,14.6,6.6,14.6,14.7v20h-98.7V93.3z M341.6,417.9l0,0.4v0.4c0,8.1-6.6,14.7-14.6,14.7H186c-8.1,0-14.6-6.6-14.6-14.7v-0.4\r\n\t\tl0-0.4L147.7,128h217.2L341.6,417.9z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"249","y":"160","width":"14","height":"241"},"children":[{"name":"rect","attribs":{"x":"249","y":"160","width":"14","height":"241"},"children":[]}]},{"name":"polygon","attribs":{"points":"320,160 305.4,160 294.7,401 309.3,401 \t\t"},"children":[{"name":"polygon","attribs":{"points":"320,160 305.4,160 294.7,401 309.3,401 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"206.5,160 192,160 202.7,401 217.3,401 \t\t"},"children":[{"name":"polygon","attribs":{"points":"206.5,160 192,160 202.7,401 217.3,401 \t\t"},"children":[]}]}]}]}]}]};exports.iosTrashOutline=iosTrashOutline;var iosTrash={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M320,113V93.3c0-16.2-13.1-29.3-29.3-29.3h-69.5C205.1,64,192,77.1,192,93.3V113h-80v15h21.1l23.6,290.7\r\n\t\tc0,16.2,13.1,29.3,29.3,29.3h141c16.2,0,29.3-13.1,29.3-29.3L379.6,128H400v-15H320z M207,93.3c0-8.1,6.2-14.3,14.3-14.3h69.5\r\n\t\tc8.1,0,14.3,6.2,14.3,14.3V113h-98V93.3H207z M202.7,401L192,160h14.5l10.9,241H202.7z M263,401h-14V160h14V401z M309.3,401h-14.6\r\n\t\tl10.8-241H320L309.3,401z"},"children":[{"name":"path","attribs":{"d":"M320,113V93.3c0-16.2-13.1-29.3-29.3-29.3h-69.5C205.1,64,192,77.1,192,93.3V113h-80v15h21.1l23.6,290.7\r\n\t\tc0,16.2,13.1,29.3,29.3,29.3h141c16.2,0,29.3-13.1,29.3-29.3L379.6,128H400v-15H320z M207,93.3c0-8.1,6.2-14.3,14.3-14.3h69.5\r\n\t\tc8.1,0,14.3,6.2,14.3,14.3V113h-98V93.3H207z M202.7,401L192,160h14.5l10.9,241H202.7z M263,401h-14V160h14V401z M309.3,401h-14.6\r\n\t\tl10.8-241H320L309.3,401z"},"children":[]}]}]}]};exports.iosTrash=iosTrash;var iosUndoOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M447.9,368.2c0-16.8,3.6-83.1-48.7-135.7c-35.2-35.4-80.3-53.4-143.3-56.2V96L64,224l192,128v-79.8\r\n\t\tc40,1.1,62.4,9.1,86.7,20c30.9,13.8,55.3,44,75.8,76.6l19.2,31.2H448C448,389.9,447.9,377.1,447.9,368.2z M432.2,361.4\r\n\t\tC384.6,280.6,331,256,240,256v64.8L91.9,224.1L240,127.3V192C441,192,432.2,361.4,432.2,361.4z"},"children":[{"name":"path","attribs":{"d":"M447.9,368.2c0-16.8,3.6-83.1-48.7-135.7c-35.2-35.4-80.3-53.4-143.3-56.2V96L64,224l192,128v-79.8\r\n\t\tc40,1.1,62.4,9.1,86.7,20c30.9,13.8,55.3,44,75.8,76.6l19.2,31.2H448C448,389.9,447.9,377.1,447.9,368.2z M432.2,361.4\r\n\t\tC384.6,280.6,331,256,240,256v64.8L91.9,224.1L240,127.3V192C441,192,432.2,361.4,432.2,361.4z"},"children":[]}]}]}]};exports.iosUndoOutline=iosUndoOutline;var iosUndo={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M447.9,368.2c0-16.8,3.6-83.1-48.7-135.7c-35.2-35.4-80.3-53.4-143.3-56.2V96L64,224l192,128v-79.8\r\n\t\tc40,1.1,62.4,9.1,86.7,20c30.9,13.8,55.3,44,75.8,76.6l19.2,31.2H448C448,389.9,447.9,377.1,447.9,368.2z"},"children":[{"name":"path","attribs":{"d":"M447.9,368.2c0-16.8,3.6-83.1-48.7-135.7c-35.2-35.4-80.3-53.4-143.3-56.2V96L64,224l192,128v-79.8\r\n\t\tc40,1.1,62.4,9.1,86.7,20c30.9,13.8,55.3,44,75.8,76.6l19.2,31.2H448C448,389.9,447.9,377.1,447.9,368.2z"},"children":[]}]}]}]};exports.iosUndo=iosUndo;var iosUnlockedOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,288c-17.673,0-32,14.327-32,32c0,14.91,10.198,27.439,24,30.992V384h16v-33.008c13.802-3.553,24-16.082,24-30.992\r\n\t\tC288,302.327,273.673,288,256,288z M256,336c-8.822,0-16-7.178-16-16s7.178-16,16-16s16,7.178,16,16S264.822,336,256,336z"},"children":[{"name":"path","attribs":{"d":"M256,288c-17.673,0-32,14.327-32,32c0,14.91,10.198,27.439,24,30.992V384h16v-33.008c13.802-3.553,24-16.082,24-30.992\r\n\t\tC288,302.327,273.673,288,256,288z M256,336c-8.822,0-16-7.178-16-16s7.178-16,16-16s16,7.178,16,16S264.822,336,256,336z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M168,224v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v8h16v-8c0-57.43-46.562-104-103.984-104\r\n\t\t\tC198.562,48,152,94.57,152,152v72H96v240h320V224H168z M400,448H112V240h288V448z"},"children":[{"name":"path","attribs":{"d":"M168,224v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v8h16v-8c0-57.43-46.562-104-103.984-104\r\n\t\t\tC198.562,48,152,94.57,152,152v72H96v240h320V224H168z M400,448H112V240h288V448z"},"children":[]}]}]}]}]}]};exports.iosUnlockedOutline=iosUnlockedOutline;var iosUnlocked={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,304c-8.822,0-16,7.178-16,16s7.178,16,16,16s16-7.178,16-16S264.822,304,256,304z"},"children":[{"name":"path","attribs":{"d":"M256,304c-8.822,0-16,7.178-16,16s7.178,16,16,16s16-7.178,16-16S264.822,304,256,304z"},"children":[]}]},{"name":"path","attribs":{"d":"M168,224v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v8h16v-8c0-57.43-46.562-104-103.984-104\r\n\t\tC198.562,48,152,94.57,152,152v72H96v240h320V224H168z M264,350.992V384h-16v-33.008c-13.802-3.553-24-16.082-24-30.992\r\n\t\tc0-17.673,14.327-32,32-32s32,14.327,32,32C288,334.91,277.802,347.439,264,350.992z"},"children":[{"name":"path","attribs":{"d":"M168,224v-72c0-48.523,39.484-88,88.016-88C304.531,64,344,103.477,344,152v8h16v-8c0-57.43-46.562-104-103.984-104\r\n\t\tC198.562,48,152,94.57,152,152v72H96v240h320V224H168z M264,350.992V384h-16v-33.008c-13.802-3.553-24-16.082-24-30.992\r\n\t\tc0-17.673,14.327-32,32-32s32,14.327,32,32C288,334.91,277.802,347.439,264,350.992z"},"children":[]}]}]}]};exports.iosUnlocked=iosUnlocked;var iosUploadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"288,144 288,160 400,160 400,432 112,432 112,160 224,160 224,144 96,144 96,448 416,448 416,144 \t\t"},"children":[{"name":"polygon","attribs":{"points":"288,144 288,160 400,160 400,432 112,432 112,160 224,160 224,144 96,144 96,448 416,448 416,144 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"193.1,118.1 181.5,106.5 256,32 330.5,106.5 318.9,118.1 264.2,63.4 264.2,306.4 247.8,306.4 247.8,63.4 \t\t"},"children":[{"name":"polygon","attribs":{"points":"193.1,118.1 181.5,106.5 256,32 330.5,106.5 318.9,118.1 264.2,63.4 264.2,306.4 247.8,306.4 247.8,63.4 \t\t"},"children":[]}]}]}]}]}]};exports.iosUploadOutline=iosUploadOutline;var iosUpload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"264,144 264,306 248,306 248,144 96,144 96,448 416,448 416,144 \t"},"children":[{"name":"polygon","attribs":{"points":"264,144 264,306 248,306 248,144 96,144 96,448 416,448 416,144 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"264,63.4 318.8,118.1 330.4,106.5 256,32 181.5,106.5 193.2,118.1 248,63.4 248,144 264,144 \t"},"children":[{"name":"polygon","attribs":{"points":"264,63.4 318.8,118.1 330.4,106.5 256,32 181.5,106.5 193.2,118.1 248,63.4 248,144 264,144 \t"},"children":[]}]}]}]};exports.iosUpload=iosUpload;var iosVideocamOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M303.7,128h-221C63.9,128,47,142.1,47,160.7v187.9c0,18.6,16.9,35.4,35.7,35.4h221c18.8,0,33.3-16.8,33.3-35.4V160.7\r\n\t\tC337,142.1,322.5,128,303.7,128z M320,348.6c0,9.3-6.9,18.4-16.3,18.4h-221c-9.4,0-18.7-9.1-18.7-18.4V160.7\r\n\t\tc0-9.3,9-15.5,18.4-15.5l221,0.1c9.4,0,16.6,6.1,16.6,15.4V348.6z"},"children":[{"name":"path","attribs":{"d":"M303.7,128h-221C63.9,128,47,142.1,47,160.7v187.9c0,18.6,16.9,35.4,35.7,35.4h221c18.8,0,33.3-16.8,33.3-35.4V160.7\r\n\t\tC337,142.1,322.5,128,303.7,128z M320,348.6c0,9.3-6.9,18.4-16.3,18.4h-221c-9.4,0-18.7-9.1-18.7-18.4V160.7\r\n\t\tc0-9.3,9-15.5,18.4-15.5l221,0.1c9.4,0,16.6,6.1,16.6,15.4V348.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M367,213v85.6l98,53.4V160L367,213z M448,190v132.3l-64-33.5v-65.6l64.1-33.6L448,190z"},"children":[{"name":"path","attribs":{"d":"M367,213v85.6l98,53.4V160L367,213z M448,190v132.3l-64-33.5v-65.6l64.1-33.6L448,190z"},"children":[]}]}]}]};exports.iosVideocamOutline=iosVideocamOutline;var iosVideocam={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M303.7,128h-221C63.9,128,47,142.1,47,160.7v187.9c0,18.6,16.9,35.4,35.7,35.4h221c18.8,0,33.3-16.8,33.3-35.4V160.7\r\n\t\tC337,142.1,322.5,128,303.7,128z"},"children":[{"name":"path","attribs":{"d":"M303.7,128h-221C63.9,128,47,142.1,47,160.7v187.9c0,18.6,16.9,35.4,35.7,35.4h221c18.8,0,33.3-16.8,33.3-35.4V160.7\r\n\t\tC337,142.1,322.5,128,303.7,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M367,213v85.6l98,53.4V160L367,213z"},"children":[{"name":"path","attribs":{"d":"M367,213v85.6l98,53.4V160L367,213z"},"children":[]}]}]}]};exports.iosVideocam=iosVideocam;var iosVolumeHigh={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M374.1,128l-13.6,10.3C384.6,171.2,399,211.9,399,256c0,44.1-14.4,84.8-38.6,117.7l13.6,10.3c26.3-35.7,41.9-80,41.9-128\r\n\t\t\t\tC415.9,208,400.4,163.7,374.1,128z"},"children":[{"name":"path","attribs":{"d":"M374.1,128l-13.6,10.3C384.6,171.2,399,211.9,399,256c0,44.1-14.4,84.8-38.6,117.7l13.6,10.3c26.3-35.7,41.9-80,41.9-128\r\n\t\t\t\tC415.9,208,400.4,163.7,374.1,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M320,351.8c20-26.8,32-59.9,32-95.8s-12-69-32-95.8l-13.6,10.1c17.9,24,28.6,53.6,28.6,85.7s-10.7,61.7-28.6,85.7\r\n\t\t\t\tL320,351.8z"},"children":[{"name":"path","attribs":{"d":"M320,351.8c20-26.8,32-59.9,32-95.8s-12-69-32-95.8l-13.6,10.1c17.9,24,28.6,53.6,28.6,85.7s-10.7,61.7-28.6,85.7\r\n\t\t\t\tL320,351.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M273.1,319.9c13.7-17.9,21.9-39.9,21.9-63.9c0-24-8.2-46-21.9-63.9l-13.5,9.8c11.6,15.1,18.5,33.8,18.5,54.1\r\n\t\t\t\ts-6.9,38.9-18.5,54.1L273.1,319.9z"},"children":[{"name":"path","attribs":{"d":"M273.1,319.9c13.7-17.9,21.9-39.9,21.9-63.9c0-24-8.2-46-21.9-63.9l-13.5,9.8c11.6,15.1,18.5,33.8,18.5,54.1\r\n\t\t\t\ts-6.9,38.9-18.5,54.1L273.1,319.9z"},"children":[]}]}]}]}]}]},{"name":"polygon","attribs":{"points":"153.9,216 96,216 96,296 153.9,296 224,352 224,160 \t"},"children":[{"name":"polygon","attribs":{"points":"153.9,216 96,216 96,296 153.9,296 224,352 224,160 \t"},"children":[]}]}]}]};exports.iosVolumeHigh=iosVolumeHigh;var iosVolumeLow={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"249.9,216 192,216 192,296 249.9,296 320,352 320,160 "},"children":[]}]};exports.iosVolumeLow=iosVolumeLow;var iosWineglassOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M264,308.988c0-21.975,20.458-38.674,40.247-54.824c7.907-6.453,15.37-12.547,21.519-18.962\r\n\tC352.313,207.505,352,183.458,352,164.144V160c0-44.25-30.816-124.558-32.02-128H256h-64c-1.203,3.442-32,83.5-32,128v4.144\r\n\tc0,19.273-0.323,43.361,26.225,71.059c6.148,6.415,13.617,12.509,21.523,18.962c19.789,16.15,40.252,32.85,40.252,54.824V464h-72v16\r\n\th80h80v-16h-72V308.988z M202.729,48H256h53.251c5.359,15.99,19.509,62.712,24.836,96H177.894\r\n\tC183.221,110.712,197.37,63.99,202.729,48z M256,273.416c-2.968,0-5.248-0.92-7.17-2.754c0.001,0.009,0.003,0.018,0.005,0.026\r\n\tc-8.804-10.807-20.234-20.158-30.971-28.92c-7.517-6.135-14.617-11.929-20.089-17.637c-22.054-23.008-21.928-40.916-21.795-59.875\r\n\tc0.01-1.428-0.068-2.849,0.02-4.255h159.98c0.088,1.406,0.01,2.828,0.021,4.255c0.133,18.959,0.259,36.867-21.795,59.875\r\n\tc-5.472,5.708-12.57,11.502-20.087,17.637c-10.737,8.762-22.165,18.114-30.969,28.92c0.002-0.009,0.009-0.018,0.01-0.026\r\n\tC261.238,272.496,259,273.416,256,273.416z"},"children":[]}]};exports.iosWineglassOutline=iosWineglassOutline;var iosWineglass={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M264,308.988c0-21.975,20.458-38.674,40.247-54.824c7.907-6.453,15.37-12.547,21.519-18.962\r\n\tC352.313,207.505,352,183.458,352,164.144V160c0-44.25-30.816-124.558-32.02-128H256h-64c-1.203,3.442-32,83.5-32,128v4.144\r\n\tc0,19.273-0.323,43.361,26.225,71.059c6.148,6.415,13.617,12.509,21.523,18.962c19.789,16.15,40.252,32.85,40.252,54.824V464h-72v16\r\n\th80h80v-16h-72V308.988z M202.729,48H256h53.251c5.359,15.99,19.509,62.712,24.836,96H177.894\r\n\tC183.221,110.712,197.37,63.99,202.729,48z"},"children":[]}]};exports.iosWineglass=iosWineglass;var iosWorldOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,48c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0C140.8,48.3,48,141.3,48,256c0,114.7,92.8,207.7,207.5,208\r\n\tc0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M264.3,172.5\r\n\tc22.1-0.6,43.5-3.5,64.2-8.5c6.2,24.5,10.1,52.8,10.7,83.8h-74.9V172.5z M264.3,155.8V66c22.4,6.2,45.2,36.1,59.6,82\r\n\tC304.7,152.6,284.8,155.2,264.3,155.8z M247.7,65.8v90.1c-20.7-0.6-40.8-3.3-60.1-8C202.2,101.7,225.1,71.6,247.7,65.8z\r\n\t M247.7,172.5v75.2h-75.4c0.6-31,4.5-59.3,10.7-83.8C203.8,168.9,225.5,171.9,247.7,172.5z M155.5,247.7H64.9\r\n\tc1.8-42.8,17.8-82,43.3-113c18.5,10.2,38.2,18.6,58.8,24.8C160.2,186,156.2,215.9,155.5,247.7z M155.5,264.3\r\n\tc0.6,31.7,4.6,61.7,11.4,88.2c-20.6,6.3-40.2,14.6-58.8,24.8c-25.5-31-41.4-70.2-43.3-113H155.5z M172.3,264.3h75.4v75.1\r\n\tc-22.2,0.6-43.9,3.6-64.7,8.7C176.8,323.6,172.9,295.3,172.3,264.3z M247.7,356.1v90.2c-22.6-5.9-45.5-35.9-60.1-82.1\r\n\tC206.9,359.4,227,356.7,247.7,356.1z M264.3,446v-90c20.5,0.6,40.4,3.3,59.7,7.9C309.5,409.9,286.8,439.8,264.3,446z M264.3,339.4\r\n\tv-75.1h74.9c-0.6,30.9-4.5,59.2-10.7,83.7C307.8,343,286.4,340,264.3,339.4z M355.9,264.3h91.2c-1.8,42.8-17.8,81.9-43.3,113\r\n\tc-18.7-10.3-38.5-18.7-59.3-25C351.3,325.8,355.3,296,355.9,264.3z M355.9,247.7c-0.6-31.7-4.6-61.6-11.3-88.1\r\n\tc20.8-6.3,40.6-14.7,59.2-24.9c25.5,31,41.5,70.2,43.3,113.1H355.9z M392.4,121.9c-16.6,8.8-34,16.1-52.3,21.6\r\n\tc-9.7-31.3-23.4-56.8-39.5-73.6C336,78.4,367.6,96.8,392.4,121.9z M210.8,70.1c-16.1,16.7-29.7,42.2-39.3,73.3\r\n\tc-18.1-5.5-35.4-12.7-51.8-21.5C144.2,96.9,175.6,78.6,210.8,70.1z M119.6,390c16.4-8.8,33.8-16,51.8-21.5\r\n\tc9.7,31.2,23.3,56.6,39.4,73.4C175.6,433.4,144.2,415.1,119.6,390z M300.6,442.1c16.2-16.8,29.8-42.3,39.6-73.7\r\n\tc18.3,5.5,35.7,12.8,52.3,21.6C367.7,415.2,336,433.6,300.6,442.1z"},"children":[]}]};exports.iosWorldOutline=iosWorldOutline;var iosWorld={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,48c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0C140.8,48.3,48,141.3,48,256c0,114.7,92.8,207.7,207.5,208\r\n\t\tc0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M256,447.4\r\n\t\tc-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0C150.1,447.1,64.6,361.5,64.6,256c0-105.5,85.4-191.1,190.9-191.3\r\n\t\tc0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c105.7,0,191.4,85.7,191.4,191.4C447.4,361.7,361.7,447.4,256,447.4z"},"children":[{"name":"path","attribs":{"d":"M256,48c-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0C140.8,48.3,48,141.3,48,256c0,114.7,92.8,207.7,207.5,208\r\n\t\tc0.1,0,0.2,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c114.9,0,208-93.1,208-208C464,141.1,370.9,48,256,48z M256,447.4\r\n\t\tc-0.1,0-0.1,0-0.2,0c0,0,0,0-0.1,0c-0.1,0-0.2,0-0.2,0C150.1,447.1,64.6,361.5,64.6,256c0-105.5,85.4-191.1,190.9-191.3\r\n\t\tc0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.1,0c0.1,0,0.1,0,0.2,0c105.7,0,191.4,85.7,191.4,191.4C447.4,361.7,361.7,447.4,256,447.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M322.3,171.8c-18.7,4.5-38,7.2-57.9,7.8v68.1H332C331.4,219.6,327.9,194.1,322.3,171.8z"},"children":[{"name":"path","attribs":{"d":"M322.3,171.8c-18.7,4.5-38,7.2-57.9,7.8v68.1H332C331.4,219.6,327.9,194.1,322.3,171.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M264.3,82.5v81.9c18.5-0.6,36.5-3,53.8-7.2C305,115.8,284.6,88.6,264.3,82.5z"},"children":[{"name":"path","attribs":{"d":"M264.3,82.5v81.9c18.5-0.6,36.5-3,53.8-7.2C305,115.8,284.6,88.6,264.3,82.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M193.4,157.1c17.5,4.2,35.6,6.7,54.2,7.3V82.3C227.3,88.2,206.6,115.4,193.4,157.1z"},"children":[{"name":"path","attribs":{"d":"M193.4,157.1c17.5,4.2,35.6,6.7,54.2,7.3V82.3C227.3,88.2,206.6,115.4,193.4,157.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M380.6,133.4c-22.6-23-51.5-39.8-83.9-47.5c14.8,15.3,27.2,38.7,36.1,67.3C349.5,148.1,365.5,141.5,380.6,133.4z"},"children":[{"name":"path","attribs":{"d":"M380.6,133.4c-22.6-23-51.5-39.8-83.9-47.5c14.8,15.3,27.2,38.7,36.1,67.3C349.5,148.1,365.5,141.5,380.6,133.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M347.3,247.7h83.3c-1.8-38.8-16.3-74.4-39.5-102.6c-17.1,9.4-35.2,17.1-54.1,22.8C343.1,191.9,346.7,219,347.3,247.7z"},"children":[{"name":"path","attribs":{"d":"M347.3,247.7h83.3c-1.8-38.8-16.3-74.4-39.5-102.6c-17.1,9.4-35.2,17.1-54.1,22.8C343.1,191.9,346.7,219,347.3,247.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M179.5,247.7h68.2v-68.1c-20.1-0.6-39.6-3.3-58.4-7.9C183.6,194,180.1,219.6,179.5,247.7z"},"children":[{"name":"path","attribs":{"d":"M179.5,247.7h68.2v-68.1c-20.1-0.6-39.6-3.3-58.4-7.9C183.6,194,180.1,219.6,179.5,247.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M332,264.3h-67.7v68c19.9,0.6,39.3,3.2,58,7.8C327.9,317.9,331.4,292.3,332,264.3z"},"children":[{"name":"path","attribs":{"d":"M332,264.3h-67.7v68c19.9,0.6,39.3,3.2,58,7.8C327.9,317.9,331.4,292.3,332,264.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M189.3,340.2c18.8-4.6,38.3-7.3,58.4-7.9v-68h-68.2C180.1,292.4,183.6,318,189.3,340.2z"},"children":[{"name":"path","attribs":{"d":"M189.3,340.2c18.8-4.6,38.3-7.3,58.4-7.9v-68h-68.2C180.1,292.4,183.6,318,189.3,340.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M247.7,429.6v-82.1c-18.6,0.6-36.8,3.1-54.3,7.3C206.6,396.5,227.3,423.8,247.7,429.6z"},"children":[{"name":"path","attribs":{"d":"M247.7,429.6v-82.1c-18.6,0.6-36.8,3.1-54.3,7.3C206.6,396.5,227.3,423.8,247.7,429.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M296.7,426.1c32.4-7.8,61.3-24.5,84-47.6c-15.1-8.1-31.1-14.7-47.8-19.8C324,387.4,311.5,410.7,296.7,426.1z"},"children":[{"name":"path","attribs":{"d":"M296.7,426.1c32.4-7.8,61.3-24.5,84-47.6c-15.1-8.1-31.1-14.7-47.8-19.8C324,387.4,311.5,410.7,296.7,426.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M214.7,86.1c-32.1,7.8-60.8,24.5-83.3,47.4c15,8,30.8,14.6,47.3,19.6C187.6,124.6,200,101.4,214.7,86.1z"},"children":[{"name":"path","attribs":{"d":"M214.7,86.1c-32.1,7.8-60.8,24.5-83.3,47.4c15,8,30.8,14.6,47.3,19.6C187.6,124.6,200,101.4,214.7,86.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M337,344.1c19,5.7,37.1,13.4,54.2,22.8c23.2-28.2,37.7-63.8,39.5-102.6h-83.3C346.7,293,343.1,320,337,344.1z"},"children":[{"name":"path","attribs":{"d":"M337,344.1c19,5.7,37.1,13.4,54.2,22.8c23.2-28.2,37.7-63.8,39.5-102.6h-83.3C346.7,293,343.1,320,337,344.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M264.3,347.5v82c20.3-6.1,40.7-33.3,53.8-74.8C300.8,350.5,282.8,348.1,264.3,347.5z"},"children":[{"name":"path","attribs":{"d":"M264.3,347.5v82c20.3-6.1,40.7-33.3,53.8-74.8C300.8,350.5,282.8,348.1,264.3,347.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M174.6,167.8c-18.8-5.7-36.8-13.3-53.7-22.7c-23.2,28.2-37.7,63.8-39.5,102.6h82.9C164.8,218.9,168.5,191.8,174.6,167.8z"},"children":[{"name":"path","attribs":{"d":"M174.6,167.8c-18.8-5.7-36.8-13.3-53.7-22.7c-23.2,28.2-37.7,63.8-39.5,102.6h82.9C164.8,218.9,168.5,191.8,174.6,167.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M164.2,264.3H81.3c1.8,38.8,16.3,74.4,39.5,102.6c16.9-9.3,34.9-17,53.7-22.7C168.5,320.2,164.8,293.1,164.2,264.3z"},"children":[{"name":"path","attribs":{"d":"M164.2,264.3H81.3c1.8,38.8,16.3,74.4,39.5,102.6c16.9-9.3,34.9-17,53.7-22.7C168.5,320.2,164.8,293.1,164.2,264.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M131.3,378.5c22.5,22.9,51.2,39.6,83.4,47.4c-14.7-15.3-27.1-38.6-36-67.1C162.2,363.9,146.3,370.5,131.3,378.5z"},"children":[{"name":"path","attribs":{"d":"M131.3,378.5c22.5,22.9,51.2,39.6,83.4,47.4c-14.7-15.3-27.1-38.6-36-67.1C162.2,363.9,146.3,370.5,131.3,378.5z"},"children":[]}]}]}]};exports.iosWorld=iosWorld;var ipad={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M112,72.8v366.4c0,4.9,3.9,8.8,8.8,8.8h270.4c4.9,0,8.8-3.9,8.8-8.8V72.8c0-4.9-3.9-8.8-8.8-8.8H120.8\r\n\tC115.9,64,112,67.9,112,72.8z M256,437.6c-7.5,0-13.6-6-13.6-13.5c0-7.5,6.1-13.6,13.6-13.6c7.4,0,13.5,6.1,13.5,13.6\r\n\tC269.6,431.6,263.5,437.6,256,437.6z M144,118.6c0-3.5,2.7-6.6,6-6.6h211.2c3.4,0,6.8,3.1,6.8,6.6v275.2c0,3.5-3.4,6.3-6.8,6.3H150\r\n\tc-3.4,0-6-2.8-6-6.3V118.6z"},"children":[]}]};exports.ipad=ipad;var iphone={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M328.2,64H183.8C170.7,64,160,74.7,160,87.9v336.3c0,13.1,10.7,23.8,23.8,23.8h144.3c13.1,0,23.8-10.7,23.8-23.8V87.9\r\n\t\tC352,74.7,341.3,64,328.2,64z M240,99.9c0-2.1,1.7-3.9,3.9-3.9h24.3c2.1,0,3.9,1.7,3.9,3.9v0.3c0,2.1-1.7,3.9-3.9,3.9h-24.3\r\n\t\tc-2.1,0-3.9-1.7-3.9-3.9V99.9z M228,96c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4s-4-1.8-4-4C224,97.8,225.8,96,228,96z M256,432.1\r\n\t\tc-8.9,0-16.1-7.2-16.1-16.1c0-8.9,7.2-16.1,16.1-16.1c8.9,0,16.1,7.2,16.1,16.1C272.1,424.9,264.8,432.1,256,432.1z M336,384H176\r\n\t\tV128h160V384z"},"children":[{"name":"path","attribs":{"d":"M328.2,64H183.8C170.7,64,160,74.7,160,87.9v336.3c0,13.1,10.7,23.8,23.8,23.8h144.3c13.1,0,23.8-10.7,23.8-23.8V87.9\r\n\t\tC352,74.7,341.3,64,328.2,64z M240,99.9c0-2.1,1.7-3.9,3.9-3.9h24.3c2.1,0,3.9,1.7,3.9,3.9v0.3c0,2.1-1.7,3.9-3.9,3.9h-24.3\r\n\t\tc-2.1,0-3.9-1.7-3.9-3.9V99.9z M228,96c2.2,0,4,1.8,4,4c0,2.2-1.8,4-4,4s-4-1.8-4-4C224,97.8,225.8,96,228,96z M256,432.1\r\n\t\tc-8.9,0-16.1-7.2-16.1-16.1c0-8.9,7.2-16.1,16.1-16.1c8.9,0,16.1,7.2,16.1,16.1C272.1,424.9,264.8,432.1,256,432.1z M336,384H176\r\n\t\tV128h160V384z"},"children":[]}]}]}]};exports.iphone=iphone;var ipod={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,311c-17.7,0-32,14.3-32,32c0,17.6,14.3,32,32,32c17.6,0,32-14.3,32-32C288,325.3,273.7,311,256,311z"},"children":[{"name":"path","attribs":{"d":"M256,311c-17.7,0-32,14.3-32,32c0,17.6,14.3,32,32,32c17.6,0,32-14.3,32-32C288,325.3,273.7,311,256,311z"},"children":[]}]},{"name":"path","attribs":{"d":"M340.4,64H171.6C156.4,64,144,76.2,144,91.7v328.7c0,15.5,12.4,27.7,27.6,27.7h168.8c15.2,0,27.6-12.2,27.6-27.7V91.7\r\n\t\tC368,76.2,355.6,64,340.4,64z M256.1,416.1c-39.8,0-72.1-32.2-72.1-72c0-39.7,32.3-72,72.1-72c39.7,0,71.9,32.3,71.9,72\r\n\t\tC328,383.9,295.8,416.1,256.1,416.1z M335.9,226.8c-0.8,7.6-7,13.2-14.7,13.2h-131c-8.2,0-14.2-6.2-14.2-14.6V110.9\r\n\t\tc0-7.5,5-13.7,12-14.9l135.8,0c6.5,1.2,11.5,6.6,12.2,13.3L335.9,226.8z"},"children":[{"name":"path","attribs":{"d":"M340.4,64H171.6C156.4,64,144,76.2,144,91.7v328.7c0,15.5,12.4,27.7,27.6,27.7h168.8c15.2,0,27.6-12.2,27.6-27.7V91.7\r\n\t\tC368,76.2,355.6,64,340.4,64z M256.1,416.1c-39.8,0-72.1-32.2-72.1-72c0-39.7,32.3-72,72.1-72c39.7,0,71.9,32.3,71.9,72\r\n\t\tC328,383.9,295.8,416.1,256.1,416.1z M335.9,226.8c-0.8,7.6-7,13.2-14.7,13.2h-131c-8.2,0-14.2-6.2-14.2-14.6V110.9\r\n\t\tc0-7.5,5-13.7,12-14.9l135.8,0c6.5,1.2,11.5,6.6,12.2,13.3L335.9,226.8z"},"children":[]}]}]}]};exports.ipod=ipod;var jet={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M314.8,368.5L419,403l-3-52.7L302,247c0,0-25.9-173.7-28.2-192.3C268.5,14.4,255.9,0,255.9,0\r\n\ts-12.5,14.4-17.6,54.6C235.9,73.3,210,247,210,247L96,350.3L93,403l104.2-34.5l1.4,12.3l-52.7,58.3l18.3,27.4l73.3-9.1l18.3,54.6\r\n\tl18.5-54.6l73.4,9.1l18.3-27.4l-52.7-58.3L314.8,368.5z"},"children":[]}]};exports.jet=jet;var key={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M304.3,301c0,0-5.4-28-7.3-90c-1.9-62-9-142.5-9-142.5c-2.5-28-11.8-36.5-32-36.5c-9.4,0-20.5,2.3-23.3,3.3\r\n\tc-9.4,3.6-8.7,11.6-8.7,22.5l0,17.8c0,3.2,1.2,6,3.2,8.2l0.8,0.8l4.1,4.1c0.4,0.3,0.1,0.7,0.4,1c1.9,2.2,3.1,5,3.1,8.1l0,24.5\r\n\tc0,3.2-1.2,3.2-3.2,5.3c-0.2,0.3-0.5,0.6-0.8,0.8l-4.4,4.4c-0.1,0.1-0.3,0.3-0.4,0.4c-2.1,2.2-3.4,5.2-3.4,8.4l0,7.2\r\n\tc0,3.1,1.1,5.9,3.1,8.1c0,0,0.1,0.1,0.1,0.1l0.8,0.8c0,0,0.1,0.1,0.1,0.1l4,4c0.4,0.3,0.7,0.7,1,1c1.9,2.2,3.1,5,3.1,8.1\r\n\tc0,0.7-0.1,8.1-0.2,8.8c-0.4,2.3-1.5,4.4-3,6.1c-0.2,0.3-0.5,0.6-0.8,0.8l-3.9,3.9l-1.4,1.5c-0.5,0.6-0.7,1.3-1.1,2.1\r\n\tc-0.9,1.7-1.2,3.7-1.2,5.9v7.8c0,2.9-0.1,5.7-0.2,8.6c0.2,2.4,7.2,5.7,7.2,10.5v20.4c0,6.2-10.5,7-11,11.3\r\n\tc-4.7,25.4-11.9,41.8-11.9,41.8c-28.7,16.6-48,47.6-48,83.2c0,53,43,96,96,96s96-43,96-96C352,348.6,332.8,317.7,304.3,301z\r\n\t M256,448c-17.7,0-32-14.3-32-32s14.3-32,32-32s32,14.3,32,32S273.7,448,256,448z"},"children":[]}]};exports.key=key;var knife={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M285.7,32c-3.3,0-6,1.4-8,3.8C259,58.7,224,116.1,224,250.1c0,39.2,33,39.2,32,69.4c0,0.1,0,0.3,0,0.4\r\n\tc-2,47.1-14.9,111.1-16,130.3c-0.4,15.2,9.7,29.8,24.1,29.8c0.1,0,0.1,0,0.2,0c0,0,0.1,0,0.2,0c14.4,0,23.5-14.4,23.5-29.6V38.3\r\n\tC288,33.3,287.5,32,285.7,32z"},"children":[]}]};exports.knife=knife;var laptop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,106.3c0-5.6-4.1-10.3-9.6-10.3H42.2c-5.5,0-10.2,4.6-10.2,10.3V368h448V106.3z M448,336H64V128h384V336z"},"children":[{"name":"path","attribs":{"d":"M480,106.3c0-5.6-4.1-10.3-9.6-10.3H42.2c-5.5,0-10.2,4.6-10.2,10.3V368h448V106.3z M448,336H64V128h384V336z"},"children":[]}]},{"name":"path","attribs":{"d":"M0,388.7C70.2,408.6,115.8,416,256,416c140.2,0,185.8-7.3,256-27.3V384H0V388.7z"},"children":[{"name":"path","attribs":{"d":"M0,388.7C70.2,408.6,115.8,416,256,416c140.2,0,185.8-7.3,256-27.3V384H0V388.7z"},"children":[]}]}]}]};exports.laptop=laptop;var leaf={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M456.7,378.7c-52.5-8-56.5-15.7-56.5-15.7c10.8-64.9-22.7-147.1-77.4-191.6c-72.8-59.2-183.5-16.2-269.7-106.2\r\n\t\tc-20.1-21-8.4,235.5,99.5,332.7c78.9,71,171.8,49.2,197.3,37.6c23.1-10.6,39.3-29.9,39.3-29.9c42.1,13,62.9,12.2,62.9,12.2\r\n\t\tC466.9,419.6,474.4,381.4,456.7,378.7z M360.6,383.1c-138.2-40.9-242.1-184.5-242.1-184.5s91.2,107.7,252,160.2\r\n\t\tC370.7,366.9,365.9,378.5,360.6,383.1z"},"children":[{"name":"path","attribs":{"d":"M456.7,378.7c-52.5-8-56.5-15.7-56.5-15.7c10.8-64.9-22.7-147.1-77.4-191.6c-72.8-59.2-183.5-16.2-269.7-106.2\r\n\t\tc-20.1-21-8.4,235.5,99.5,332.7c78.9,71,171.8,49.2,197.3,37.6c23.1-10.6,39.3-29.9,39.3-29.9c42.1,13,62.9,12.2,62.9,12.2\r\n\t\tC466.9,419.6,474.4,381.4,456.7,378.7z M360.6,383.1c-138.2-40.9-242.1-184.5-242.1-184.5s91.2,107.7,252,160.2\r\n\t\tC370.7,366.9,365.9,378.5,360.6,383.1z"},"children":[]}]}]}]};exports.leaf=leaf;var levels={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M127,99.2V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v21.5c-8.5,5.8-14,15.5-14,26.5s5.5,20.7,14,26.5V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16V156.8c10.7-5.2,18-16.1,18-28.8S137.7,104.4,127,99.2z"},"children":[{"name":"path","attribs":{"d":"M127,99.2V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v21.5c-8.5,5.8-14,15.5-14,26.5s5.5,20.7,14,26.5V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16V156.8c10.7-5.2,18-16.1,18-28.8S137.7,104.4,127,99.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M223,292.9V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v211.7c-10.1,5.4-17,16-17,28.3s6.9,22.9,17,28.3V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16v-84.9c9-5.7,15-15.7,15-27.1S232,298.6,223,292.9z"},"children":[{"name":"path","attribs":{"d":"M223,292.9V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v211.7c-10.1,5.4-17,16-17,28.3s6.9,22.9,17,28.3V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16v-84.9c9-5.7,15-15.7,15-27.1S232,298.6,223,292.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M319,163.3V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v83.3c-9.6,5.5-16,15.9-16,27.7s6.4,22.2,16,27.7V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16V218.7c9.6-5.5,16-15.9,16-27.7S328.6,168.8,319,163.3z"},"children":[{"name":"path","attribs":{"d":"M319,163.3V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v83.3c-9.6,5.5-16,15.9-16,27.7s6.4,22.2,16,27.7V432c0,8.8,7.2,16,16,16\r\n\t\ts16-7.2,16-16V218.7c9.6-5.5,16-15.9,16-27.7S328.6,168.8,319,163.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M431,383c0-11.8-6.4-22.2-16-27.7V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v275.3c-9.6,5.5-16,15.9-16,27.7s6.4,22.2,16,27.7\r\n\t\tV432c0,8.8,7.2,16,16,16s16-7.2,16-16v-21.3C424.6,405.2,431,394.8,431,383z"},"children":[{"name":"path","attribs":{"d":"M431,383c0-11.8-6.4-22.2-16-27.7V80c0-8.8-7.2-16-16-16s-16,7.2-16,16v275.3c-9.6,5.5-16,15.9-16,27.7s6.4,22.2,16,27.7\r\n\t\tV432c0,8.8,7.2,16,16,16s16-7.2,16-16v-21.3C424.6,405.2,431,394.8,431,383z"},"children":[]}]}]}]};exports.levels=levels;var lightbulb={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32c-70.7,0-128,55.4-128,123.8c0,4.9,0.3,9.7,0.9,14.5c0.6,5.4,1.6,10.6,3,15.7c0.1,0.5,0.3,1.1,0.4,1.6\r\n\t\tc16.6,62.8,45.3,71.5,58.9,167.6c0,0.2,0.1,0.4,0.1,0.5c1.5,9.2,9.8,12.3,19.8,12.3H301c10,0,18.2-3.1,19.7-12.3\r\n\t\tc0-0.2,0.1-0.4,0.1-0.5c13.6-96.1,42.3-104.7,58.9-167.6c0.2-0.5,0.3-1,0.4-1.6c1.3-5.1,2.3-10.4,3-15.7c0.6-4.7,0.9-9.6,0.9-14.5\r\n\t\tC384,87.4,326.7,32,256,32z"},"children":[{"name":"path","attribs":{"d":"M256,32c-70.7,0-128,55.4-128,123.8c0,4.9,0.3,9.7,0.9,14.5c0.6,5.4,1.6,10.6,3,15.7c0.1,0.5,0.3,1.1,0.4,1.6\r\n\t\tc16.6,62.8,45.3,71.5,58.9,167.6c0,0.2,0.1,0.4,0.1,0.5c1.5,9.2,9.8,12.3,19.8,12.3H301c10,0,18.2-3.1,19.7-12.3\r\n\t\tc0-0.2,0.1-0.4,0.1-0.5c13.6-96.1,42.3-104.7,58.9-167.6c0.2-0.5,0.3-1,0.4-1.6c1.3-5.1,2.3-10.4,3-15.7c0.6-4.7,0.9-9.6,0.9-14.5\r\n\t\tC384,87.4,326.7,32,256,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M317.8,396.5c0.1-0.2,0.3-0.4,0.4-0.6c1.1-1.7,1.7-3.6,1.7-5.7c0-3.5,1.6-6.2-6.5-6.2H198.6c-8.1,0-6.5,2.1-6.5,6.2\r\n\t\tc0,2.1,0.6,4,1.7,5.7c0.1,0.2,0.3,0.4,0.5,0.6c0,0.1,0.1,0.1,0.1,0.2c1.7,2.6,2.7,4.4,2.7,7.6c0,3.1-0.9,4.9-2.6,7.5\r\n\t\tc-0.3,0.4-0.5,0.7-0.7,1c-1,1.7-1.6,3.6-1.6,5.6c0,2.1,0.6,4,1.7,5.8c0.1,0.2,0.3,0.4,0.4,0.6c1.8,2.7,2.8,4.5,2.8,7.8\r\n\t\tc0,3.1-0.9,4.9-2.6,7.4c-0.2,0.4-0.5,0.7-0.8,1.1c-1,1.7-1.6,3.6-1.6,5.6c0,5.4,4.3,10.1,10.2,11.6c0.3,0.1,0.6,0.1,0.9,0.2\r\n\t\tc6,1.4,12.2,1.6,18.5,2.5c0.7,0.1,1.4,0.2,2.2,0.3c5.6,1,10.3,3.9,13.4,7.7l0,0c3.8,5.3,10.8,11,18.8,11c7.6,0,14.3-5.4,18.2-10.4\r\n\t\th0c3-4.2,8-7.3,13.9-8.4c0.7-0.1,1.4-0.3,2.2-0.3c6.3-0.9,12.5-1.1,18.5-2.5c0.3-0.1,0.6-0.1,0.9-0.2c5.9-1.6,10.2-6.2,10.2-11.6\r\n\t\tc0-2-0.6-3.9-1.6-5.6c-0.3-0.4-0.5-0.7-0.8-1.1c-1.6-2.6-2.6-4.3-2.6-7.4c0-3.2,1-5.1,2.8-7.8c0.1-0.2,0.3-0.4,0.4-0.6\r\n\t\tc1.1-1.7,1.7-3.7,1.7-5.8c0-2-0.6-3.9-1.6-5.6c-0.3-0.3-0.5-0.7-0.7-1c-1.6-2.6-2.6-4.3-2.6-7.5c0-3.2,1-5,2.7-7.6\r\n\t\tC317.7,396.7,317.7,396.6,317.8,396.5z"},"children":[{"name":"path","attribs":{"d":"M317.8,396.5c0.1-0.2,0.3-0.4,0.4-0.6c1.1-1.7,1.7-3.6,1.7-5.7c0-3.5,1.6-6.2-6.5-6.2H198.6c-8.1,0-6.5,2.1-6.5,6.2\r\n\t\tc0,2.1,0.6,4,1.7,5.7c0.1,0.2,0.3,0.4,0.5,0.6c0,0.1,0.1,0.1,0.1,0.2c1.7,2.6,2.7,4.4,2.7,7.6c0,3.1-0.9,4.9-2.6,7.5\r\n\t\tc-0.3,0.4-0.5,0.7-0.7,1c-1,1.7-1.6,3.6-1.6,5.6c0,2.1,0.6,4,1.7,5.8c0.1,0.2,0.3,0.4,0.4,0.6c1.8,2.7,2.8,4.5,2.8,7.8\r\n\t\tc0,3.1-0.9,4.9-2.6,7.4c-0.2,0.4-0.5,0.7-0.8,1.1c-1,1.7-1.6,3.6-1.6,5.6c0,5.4,4.3,10.1,10.2,11.6c0.3,0.1,0.6,0.1,0.9,0.2\r\n\t\tc6,1.4,12.2,1.6,18.5,2.5c0.7,0.1,1.4,0.2,2.2,0.3c5.6,1,10.3,3.9,13.4,7.7l0,0c3.8,5.3,10.8,11,18.8,11c7.6,0,14.3-5.4,18.2-10.4\r\n\t\th0c3-4.2,8-7.3,13.9-8.4c0.7-0.1,1.4-0.3,2.2-0.3c6.3-0.9,12.5-1.1,18.5-2.5c0.3-0.1,0.6-0.1,0.9-0.2c5.9-1.6,10.2-6.2,10.2-11.6\r\n\t\tc0-2-0.6-3.9-1.6-5.6c-0.3-0.4-0.5-0.7-0.8-1.1c-1.6-2.6-2.6-4.3-2.6-7.4c0-3.2,1-5.1,2.8-7.8c0.1-0.2,0.3-0.4,0.4-0.6\r\n\t\tc1.1-1.7,1.7-3.7,1.7-5.8c0-2-0.6-3.9-1.6-5.6c-0.3-0.3-0.5-0.7-0.7-1c-1.6-2.6-2.6-4.3-2.6-7.5c0-3.2,1-5,2.7-7.6\r\n\t\tC317.7,396.7,317.7,396.6,317.8,396.5z"},"children":[]}]}]}]};exports.lightbulb=lightbulb;var link={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.5,208H256v0C256.2,208,256.3,208,256.5,208z"},"children":[{"name":"path","attribs":{"d":"M256.5,208H256v0C256.2,208,256.3,208,256.5,208z"},"children":[]}]},{"name":"path","attribs":{"d":"M368.5,160H320c0,0,26,17,31.6,48H368h0.5c17.6,0,31.5,13.9,31.5,31.5v32c0,17.6-13.9,32.5-31.5,32.5h-112\r\n\t\tc-17.6,0-32.5-14.9-32.5-32.5V240h-48v31.5c0,11.5,2.5,22.5,6.9,32.5c12.6,28.2,40.9,48,73.6,48h112c44.2,0,79.5-36.3,79.5-80.5\r\n\t\tv-32C448,195.3,412.7,160,368.5,160z"},"children":[{"name":"path","attribs":{"d":"M368.5,160H320c0,0,26,17,31.6,48H368h0.5c17.6,0,31.5,13.9,31.5,31.5v32c0,17.6-13.9,32.5-31.5,32.5h-112\r\n\t\tc-17.6,0-32.5-14.9-32.5-32.5V240h-48v31.5c0,11.5,2.5,22.5,6.9,32.5c12.6,28.2,40.9,48,73.6,48h112c44.2,0,79.5-36.3,79.5-80.5\r\n\t\tv-32C448,195.3,412.7,160,368.5,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M329.6,208c-12.1-28.3-40.1-48-73.1-48h-112c-44.2,0-80.5,35.3-80.5,79.5v32c0,44.2,36.3,80.5,80.5,80.5H192\r\n\t\tc0,0-25.8-17-32.1-48h-15.4c-17.6,0-32.5-14.9-32.5-32.5v-32c0-17.6,14.9-31.5,32.5-31.5H256h0.5c17.6,0,31.5,13.9,31.5,31.5v32\r\n\t\tc0,0.2,0,0.3,0,0.5h48c0-0.2,0-0.3,0-0.5v-32C336,228.3,333.7,217.6,329.6,208z"},"children":[{"name":"path","attribs":{"d":"M329.6,208c-12.1-28.3-40.1-48-73.1-48h-112c-44.2,0-80.5,35.3-80.5,79.5v32c0,44.2,36.3,80.5,80.5,80.5H192\r\n\t\tc0,0-25.8-17-32.1-48h-15.4c-17.6,0-32.5-14.9-32.5-32.5v-32c0-17.6,14.9-31.5,32.5-31.5H256h0.5c17.6,0,31.5,13.9,31.5,31.5v32\r\n\t\tc0,0.2,0,0.3,0,0.5h48c0-0.2,0-0.3,0-0.5v-32C336,228.3,333.7,217.6,329.6,208z"},"children":[]}]}]}]};exports.link=link;var loadA={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"96","r":"64"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"96","r":"64"},"children":[]}]},{"name":"circle","attribs":{"cx":"96","cy":"256","r":"48"},"children":[{"name":"circle","attribs":{"cx":"96","cy":"256","r":"48"},"children":[]}]},{"name":"circle","attribs":{"cx":"368","cy":"144","r":"8"},"children":[{"name":"circle","attribs":{"cx":"368","cy":"144","r":"8"},"children":[]}]},{"name":"path","attribs":{"d":"M180.1,107.6c-19.9-20.1-52.2-20.1-72.1,0c-19.9,20.1-19.9,52.7,0,72.8c19.9,20.1,52.2,20.1,72.1,0\r\n\t\tC200,160.3,200,127.7,180.1,107.6z"},"children":[{"name":"path","attribs":{"d":"M180.1,107.6c-19.9-20.1-52.2-20.1-72.1,0c-19.9,20.1-19.9,52.7,0,72.8c19.9,20.1,52.2,20.1,72.1,0\r\n\t\tC200,160.3,200,127.7,180.1,107.6z"},"children":[]}]},{"name":"circle","attribs":{"cx":"416","cy":"256","r":"16"},"children":[{"name":"circle","attribs":{"cx":"416","cy":"256","r":"16"},"children":[]}]},{"name":"circle","attribs":{"cx":"369","cy":"369","r":"24"},"children":[{"name":"circle","attribs":{"cx":"369","cy":"369","r":"24"},"children":[]}]},{"name":"circle","attribs":{"cx":"256","cy":"416","r":"32"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"416","r":"32"},"children":[]}]},{"name":"circle","attribs":{"cx":"144","cy":"368","r":"40"},"children":[{"name":"circle","attribs":{"cx":"144","cy":"368","r":"40"},"children":[]}]}]}]};exports.loadA=loadA;var loadB={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,160c0,17.7-14.3,32-32,32l0,0c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32l0,0c17.7,0,32,14.3,32,32V160z"},"children":[{"name":"path","attribs":{"d":"M288,160c0,17.7-14.3,32-32,32l0,0c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32l0,0c17.7,0,32,14.3,32,32V160z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,320c-17.7,0-32,14.3-32,32v96c0,17.7,14.3,32,32,32s32-14.3,32-32v-96C288,334.3,273.7,320,256,320L256,320z"},"children":[{"name":"path","attribs":{"d":"M256,320c-17.7,0-32,14.3-32,32v96c0,17.7,14.3,32,32,32s32-14.3,32-32v-96C288,334.3,273.7,320,256,320L256,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,224h-96c-17.7,0-32,14.3-32,32s14.3,32,32,32h96c17.7,0,32-14.3,32-32S465.7,224,448,224L448,224z"},"children":[{"name":"path","attribs":{"d":"M448,224h-96c-17.7,0-32,14.3-32,32s14.3,32,32,32h96c17.7,0,32-14.3,32-32S465.7,224,448,224L448,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,224H64c-17.7,0-32,14.3-32,32s14.3,32,32,32h96c17.7,0,32-14.3,32-32S177.7,224,160,224L160,224z"},"children":[{"name":"path","attribs":{"d":"M160,224H64c-17.7,0-32,14.3-32,32s14.3,32,32,32h96c17.7,0,32-14.3,32-32S177.7,224,160,224L160,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M346.5,210.7c-12.5,12.5-32.8,12.5-45.3,0l0,0c-12.5-12.5-12.5-32.8,0-45.3l67.9-67.9c12.5-12.5,32.8-12.5,45.3,0l0,0\r\n\t\tc12.5,12.5,12.5,32.8,0,45.3L346.5,210.7z"},"children":[{"name":"path","attribs":{"d":"M346.5,210.7c-12.5,12.5-32.8,12.5-45.3,0l0,0c-12.5-12.5-12.5-32.8,0-45.3l67.9-67.9c12.5-12.5,32.8-12.5,45.3,0l0,0\r\n\t\tc12.5,12.5,12.5,32.8,0,45.3L346.5,210.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M210.7,301.3c-12.5-12.5-32.8-12.5-45.3,0l-67.9,67.9c-12.5,12.5-12.5,32.8,0,45.3c12.5,12.5,32.8,12.5,45.3,0l67.9-67.9\r\n\t\tC223.2,334,223.2,313.8,210.7,301.3L210.7,301.3z"},"children":[{"name":"path","attribs":{"d":"M210.7,301.3c-12.5-12.5-32.8-12.5-45.3,0l-67.9,67.9c-12.5,12.5-12.5,32.8,0,45.3c12.5,12.5,32.8,12.5,45.3,0l67.9-67.9\r\n\t\tC223.2,334,223.2,313.8,210.7,301.3L210.7,301.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M414.4,369.1l-67.9-67.9c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3l67.9,67.9c12.5,12.5,32.8,12.5,45.3,0\r\n\t\tC426.9,401.9,426.9,381.6,414.4,369.1L414.4,369.1z"},"children":[{"name":"path","attribs":{"d":"M414.4,369.1l-67.9-67.9c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3l67.9,67.9c12.5,12.5,32.8,12.5,45.3,0\r\n\t\tC426.9,401.9,426.9,381.6,414.4,369.1L414.4,369.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M210.7,165.5l-67.9-67.9c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3l67.9,67.9c12.5,12.5,32.8,12.5,45.3,0\r\n\t\tS223.2,178,210.7,165.5L210.7,165.5z"},"children":[{"name":"path","attribs":{"d":"M210.7,165.5l-67.9-67.9c-12.5-12.5-32.8-12.5-45.3,0c-12.5,12.5-12.5,32.8,0,45.3l67.9,67.9c12.5,12.5,32.8,12.5,45.3,0\r\n\t\tS223.2,178,210.7,165.5L210.7,165.5z"},"children":[]}]}]}]};exports.loadB=loadB;var loadC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M479.8,226.1c-1.4-8.7-3.1-17.3-5.3-25.8c-2.8-10.8-6.4-21.5-10.8-31.8c-8.9-21.2-21.1-41-35.9-58.6\r\n\tc-16-18.9-35.3-35.2-56.7-47.7C350,49.8,327,41,303,36.1c-12.4-2.5-24.9-4-37.6-4.1c-9.9-0.1-19.8,0.3-29.6,1.2\r\n\tc-25.5,2.5-50.7,9.6-73.9,20.5c-19.9,9.4-38.4,21.6-54.8,36.2c-16.4,14.6-30.7,31.6-42.2,50.3c-12.7,20.8-22.2,43.5-27.4,67.3\r\n\tc-4.2,19-6.2,38.6-5.2,58.1c0.9,18.9,3.8,37.8,9.5,55.9c3.6,11.5,7.9,22.7,13.3,33.6c5.3,10.7,11.5,21,18.4,30.7\r\n\tc13.8,19.3,30.6,36.4,49.8,50.5c19.6,14.5,41.7,25.7,64.9,33.1c24.2,7.7,49.9,11.3,75.3,10.4c24.8-0.8,49.4-5.6,72.6-14.5\r\n\tc22.3-8.6,43.2-20.9,61.5-36.3c9.2-7.8,17.4-16.6,25.1-25.9c7.8-9.4,14.8-19.3,20.6-30c5-9.2,9.2-18.8,12.8-28.5\r\n\tc1.8-4.8,3.5-9.6,4.9-14.6c1.5-5.3,2.6-10.8,3.6-16.2c1.5-8.5,2.1-17.3,1.3-25.9c-0.7,3.8-1.3,7.5-2.2,11.2\r\n\tc-1.1,4.3-2.5,8.5-4.1,12.6c-3.2,8.7-7.2,17.1-11,25.5c-4.9,10.7-10.6,20.9-16.8,30.8c-3.2,5.1-6.5,10.1-10.1,14.9\r\n\tc-3.6,4.8-7.7,9.4-11.8,13.9c-8.2,9.1-17.1,17.2-27,24.4c-10.1,7.4-20.8,13.9-32.1,19.3c-22.6,11-47.3,17.6-72.3,19.8\r\n\tc-25.6,2.2-51.7-0.3-76.3-7.6c-23.4-6.9-45.6-18.1-65.1-32.8c-18.9-14.3-35.3-31.9-48.2-51.8C75.4,347.8,66.1,324.9,61,301\r\n\tc-1.3-6.2-2.3-12.6-3-18.9c-0.6-5.4-1.1-10.9-1.3-16.4c-0.3-11.3,0.4-23,2.1-34.2c3.7-24.6,11.7-48.3,24.1-69.9\r\n\tc11-19.3,25.3-36.7,42.1-51.4c16.8-14.8,36-26.7,56.8-35.1c12-4.9,24.6-8.5,37.4-10.9c6.5-1.2,13-2.2,19.5-2.7\r\n\tc3.2-0.3,6.3-0.3,9.5-0.6c1.3,0,2.6,0.1,3.9,0.1c21.7-0.4,43.5,2.4,64.2,8.9c22.3,7,43.3,18.3,61.5,33c19.1,15.4,35,34.4,47,55.8\r\n\tc10.2,18.2,17.5,37.8,21.9,58.2c1,4.7,1.8,9.4,2.6,14.1c0.7,4.3,3.1,8.3,6.8,10.7c7.8,5.2,18.7,1.7,22.5-6.7\r\n\tC479.9,232.1,480.3,229,479.8,226.1z"},"children":[]}]};exports.loadC=loadC;var loadD={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M432,240h-80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80c8.8,0,16-7.2,16-16S440.8,240,432,240z"},"children":[{"name":"path","attribs":{"d":"M432,240h-80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80c8.8,0,16-7.2,16-16S440.8,240,432,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,256c0-8.8-7.2-16-16-16H80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80C168.8,272,176,264.8,176,256z"},"children":[{"name":"path","attribs":{"d":"M176,256c0-8.8-7.2-16-16-16H80c-8.8,0-16,7.2-16,16s7.2,16,16,16h80C168.8,272,176,264.8,176,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,336c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16v-80C272,343.2,264.8,336,256,336z"},"children":[{"name":"path","attribs":{"d":"M256,336c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16v-80C272,343.2,264.8,336,256,336z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16V80C272,71.2,264.8,64,256,64z"},"children":[{"name":"path","attribs":{"d":"M256,64c-8.8,0-16,7.2-16,16v80c0,8.8,7.2,16,16,16s16-7.2,16-16V80C272,71.2,264.8,64,256,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M325.3,216c4.4,7.7,14.2,10.3,21.9,5.9l69.3-40c7.7-4.4,10.3-14.2,5.9-21.9s-14.2-10.3-21.9-5.9l-69.3,40\r\n\t\tC323.5,198.6,320.9,208.3,325.3,216z"},"children":[{"name":"path","attribs":{"d":"M325.3,216c4.4,7.7,14.2,10.3,21.9,5.9l69.3-40c7.7-4.4,10.3-14.2,5.9-21.9s-14.2-10.3-21.9-5.9l-69.3,40\r\n\t\tC323.5,198.6,320.9,208.3,325.3,216z"},"children":[]}]},{"name":"path","attribs":{"d":"M186.7,296c-4.4-7.7-14.2-10.3-21.9-5.9l-69.3,40c-7.7,4.4-10.3,14.2-5.9,21.9s14.2,10.3,21.9,5.9l69.3-40\r\n\t\tC188.5,313.4,191.1,303.7,186.7,296z"},"children":[{"name":"path","attribs":{"d":"M186.7,296c-4.4-7.7-14.2-10.3-21.9-5.9l-69.3,40c-7.7,4.4-10.3,14.2-5.9,21.9s14.2,10.3,21.9,5.9l69.3-40\r\n\t\tC188.5,313.4,191.1,303.7,186.7,296z"},"children":[]}]},{"name":"path","attribs":{"d":"M317.9,331.1c-4.4-7.7-14.2-10.3-21.9-5.9s-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9\r\n\t\tc7.7-4.4,10.3-14.2,5.9-21.9L317.9,331.1z"},"children":[{"name":"path","attribs":{"d":"M317.9,331.1c-4.4-7.7-14.2-10.3-21.9-5.9s-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9\r\n\t\tc7.7-4.4,10.3-14.2,5.9-21.9L317.9,331.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M181.9,95.6c-4.4-7.7-14.2-10.3-21.9-5.9c-7.7,4.4-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9\r\n\t\ts10.3-14.2,5.9-21.9L181.9,95.6z"},"children":[{"name":"path","attribs":{"d":"M181.9,95.6c-4.4-7.7-14.2-10.3-21.9-5.9c-7.7,4.4-10.3,14.2-5.9,21.9l40,69.3c4.4,7.7,14.2,10.3,21.9,5.9\r\n\t\ts10.3-14.2,5.9-21.9L181.9,95.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M296,186.7c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3c4.4-7.7,1.8-17.4-5.9-21.9c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3\r\n\t\tC285.7,172.5,288.3,182.3,296,186.7z"},"children":[{"name":"path","attribs":{"d":"M296,186.7c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3c4.4-7.7,1.8-17.4-5.9-21.9c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3\r\n\t\tC285.7,172.5,288.3,182.3,296,186.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M216,325.3c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3c-4.4,7.7-1.8,17.4,5.9,21.9c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3\r\n\t\tC226.3,339.5,223.7,329.7,216,325.3z"},"children":[{"name":"path","attribs":{"d":"M216,325.3c-7.7-4.4-17.4-1.8-21.9,5.9l-40,69.3c-4.4,7.7-1.8,17.4,5.9,21.9c7.7,4.4,17.4,1.8,21.9-5.9l40-69.3\r\n\t\tC226.3,339.5,223.7,329.7,216,325.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M416.4,330.1l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9c-4.4,7.7-1.8,17.4,5.9,21.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9\r\n\t\tC426.7,344.3,424.1,334.6,416.4,330.1z"},"children":[{"name":"path","attribs":{"d":"M416.4,330.1l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9c-4.4,7.7-1.8,17.4,5.9,21.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9\r\n\t\tC426.7,344.3,424.1,334.6,416.4,330.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M95.6,181.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9s1.8-17.4-5.9-21.9l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9\r\n\t\tC85.3,167.7,87.9,177.4,95.6,181.9z"},"children":[{"name":"path","attribs":{"d":"M95.6,181.9l69.3,40c7.7,4.4,17.4,1.8,21.9-5.9s1.8-17.4-5.9-21.9l-69.3-40c-7.7-4.4-17.4-1.8-21.9,5.9\r\n\t\tC85.3,167.7,87.9,177.4,95.6,181.9z"},"children":[]}]}]}]};exports.loadD=loadD;var location={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,64c-65.9,0-119.3,53.7-119.3,120c0,114.6,119.3,264,119.3,264s119.3-149.4,119.3-264C375.3,117.7,321.9,64,256,64z\r\n\t\t M256,242.2c-31.2,0-56.4-25.4-56.4-56.7c0-31.3,25.3-56.8,56.4-56.8c31.2,0,56.4,25.4,56.4,56.8\r\n\t\tC312.4,216.8,287.2,242.2,256,242.2z"},"children":[{"name":"path","attribs":{"d":"M256,64c-65.9,0-119.3,53.7-119.3,120c0,114.6,119.3,264,119.3,264s119.3-149.4,119.3-264C375.3,117.7,321.9,64,256,64z\r\n\t\t M256,242.2c-31.2,0-56.4-25.4-56.4-56.7c0-31.3,25.3-56.8,56.4-56.8c31.2,0,56.4,25.4,56.4,56.8\r\n\t\tC312.4,216.8,287.2,242.2,256,242.2z"},"children":[]}]}]}]};exports.location=location;var lockCombination={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,176.905V128C384,57.308,326.692,0,256,0S128,57.308,128,128v48.906C88.725,212.062,64,263.141,64,320\r\n\t\tc0,106.039,85.962,192,192,192c106.039,0,192-85.961,192-192C448,263.141,423.275,212.062,384,176.905z M160,128\r\n\t\tc0-52.935,43.065-96,96-96s96,43.065,96,96v25.692C323.759,137.355,290.973,128,256,128s-67.759,9.355-96,25.693V128z M256,480\r\n\t\tc-88.366,0-160-71.634-160-160s71.634-160,160-160s160,71.634,160,160S344.366,480,256,480z"},"children":[{"name":"path","attribs":{"d":"M384,176.905V128C384,57.308,326.692,0,256,0S128,57.308,128,128v48.906C88.725,212.062,64,263.141,64,320\r\n\t\tc0,106.039,85.962,192,192,192c106.039,0,192-85.961,192-192C448,263.141,423.275,212.062,384,176.905z M160,128\r\n\t\tc0-52.935,43.065-96,96-96s96,43.065,96,96v25.692C323.759,137.355,290.973,128,256,128s-67.759,9.355-96,25.693V128z M256,480\r\n\t\tc-88.366,0-160-71.634-160-160s71.634-160,160-160s160,71.634,160,160S344.366,480,256,480z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,176c-79.529,0-144,64.472-144,144s64.471,144,144,144s144-64.472,144-144S335.529,176,256,176z M378.533,353.487\r\n\t\tl-24.12-7.896l-3.926,12.19l24.161,7.912c-3.661,9.776-8.462,18.965-14.252,27.409l-10.56-7.737l-3.74,5.184l10.555,7.734\r\n\t\tc-6.129,8.047-13.189,15.324-21.028,21.682l-14.982-20.787l-10.284,7.532l14.976,20.776c-8.479,5.556-17.657,10.12-27.398,13.532\r\n\t\tl-3.96-12.294l-6.049,1.982l4.924,12.262C283.335,445.77,273,447.497,264,448v-12.659V429h-16v6.341V448\r\n\t\tc-11-0.506-19.705-2.244-29.243-5.065l3.948-11.206l-6.25-2.106l-3.539,11.224c-9.557-3.393-18.531-7.895-26.864-13.359\r\n\t\tl14.997-20.774l-10.27-7.534l-14.977,20.787c-7.809-6.333-14.841-13.575-20.953-21.583l9.556-6.998l-3.971-5.507l-9.562,7\r\n\t\tc-5.718-8.381-10.469-17.497-14.093-27.186l24.162-7.914l-3.926-12.188l-24.121,7.897c-2.49-9.431-3.954-18.488-4.258-29.487H134\r\n\t\tv-6.805l-5.993-0.002c0.223-10.606,0.672-20.88,3.266-30.682l24.921,7.9l4.347-12.188l-23.966-7.914\r\n\t\tc3.585-9.57,8.36-18.583,13.985-26.879l10.339,7.533l3.759-5.184l-10.292-7.545c6.221-8.253,13.424-15.707,21.434-22.197\r\n\t\tl14.984,20.787l10.284-7.536l-14.975-20.774c8.405-5.514,17.512-10.05,27.16-13.449l3.955,12.247l6.044-1.98l-4.62-12.231\r\n\t\tC228.21,194.258,237,192.508,248,192v12.66V211h16v-6.34V192c9,0.498,19.159,2.198,28.585,4.951l-4.761,13.28l6.182,2.106\r\n\t\tl4.174-13.312c9.696,3.408,18.778,7.957,27.208,13.491l-15.002,20.775l10.267,7.535l14.975-20.787\r\n\t\tc7.935,6.432,15.069,13.812,21.255,21.977l-11.299,8.268l3.975,5.512l11.276-8.26c5.595,8.271,10.247,17.243,13.816,26.775\r\n\t\tl-24.165,7.914l3.928,12.188l24.12-7.9c2.586,9.802,5.251,20.075,5.47,30.683L376,317.192V324h6.789\r\n\t\tC382.486,334.999,381.02,344.057,378.533,353.487z"},"children":[{"name":"path","attribs":{"d":"M256,176c-79.529,0-144,64.472-144,144s64.471,144,144,144s144-64.472,144-144S335.529,176,256,176z M378.533,353.487\r\n\t\tl-24.12-7.896l-3.926,12.19l24.161,7.912c-3.661,9.776-8.462,18.965-14.252,27.409l-10.56-7.737l-3.74,5.184l10.555,7.734\r\n\t\tc-6.129,8.047-13.189,15.324-21.028,21.682l-14.982-20.787l-10.284,7.532l14.976,20.776c-8.479,5.556-17.657,10.12-27.398,13.532\r\n\t\tl-3.96-12.294l-6.049,1.982l4.924,12.262C283.335,445.77,273,447.497,264,448v-12.659V429h-16v6.341V448\r\n\t\tc-11-0.506-19.705-2.244-29.243-5.065l3.948-11.206l-6.25-2.106l-3.539,11.224c-9.557-3.393-18.531-7.895-26.864-13.359\r\n\t\tl14.997-20.774l-10.27-7.534l-14.977,20.787c-7.809-6.333-14.841-13.575-20.953-21.583l9.556-6.998l-3.971-5.507l-9.562,7\r\n\t\tc-5.718-8.381-10.469-17.497-14.093-27.186l24.162-7.914l-3.926-12.188l-24.121,7.897c-2.49-9.431-3.954-18.488-4.258-29.487H134\r\n\t\tv-6.805l-5.993-0.002c0.223-10.606,0.672-20.88,3.266-30.682l24.921,7.9l4.347-12.188l-23.966-7.914\r\n\t\tc3.585-9.57,8.36-18.583,13.985-26.879l10.339,7.533l3.759-5.184l-10.292-7.545c6.221-8.253,13.424-15.707,21.434-22.197\r\n\t\tl14.984,20.787l10.284-7.536l-14.975-20.774c8.405-5.514,17.512-10.05,27.16-13.449l3.955,12.247l6.044-1.98l-4.62-12.231\r\n\t\tC228.21,194.258,237,192.508,248,192v12.66V211h16v-6.34V192c9,0.498,19.159,2.198,28.585,4.951l-4.761,13.28l6.182,2.106\r\n\t\tl4.174-13.312c9.696,3.408,18.778,7.957,27.208,13.491l-15.002,20.775l10.267,7.535l14.975-20.787\r\n\t\tc7.935,6.432,15.069,13.812,21.255,21.977l-11.299,8.268l3.975,5.512l11.276-8.26c5.595,8.271,10.247,17.243,13.816,26.775\r\n\t\tl-24.165,7.914l3.928,12.188l24.12-7.9c2.586,9.802,5.251,20.075,5.47,30.683L376,317.192V324h6.789\r\n\t\tC382.486,334.999,381.02,344.057,378.533,353.487z"},"children":[]}]},{"name":"circle","attribs":{"cx":"256","cy":"320","r":"81"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"320","r":"81"},"children":[]}]}]}]};exports.lockCombination=lockCombination;var locked={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M86.4,480h339.2c12.3,0,22.4-9.9,22.4-22.1V246c0-12.2-10-22-22.4-22H404v-30.9c0-41.5-16.2-87.6-42.6-115.4\r\n\tC335.1,49.9,297.4,32,256.1,32c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-41.3,0-79,17.9-105.3,45.6c-26.4,27.8-42.6,73.9-42.6,115.4V224\r\n\tH89h-2.6C74,224,64,233.9,64,246v211.9C64,470.1,74,480,86.4,480z M161,193.1c0-27.3,9.9-61.1,28.1-80.3l0,0l0-0.3\r\n\tC206.7,93.9,231,83,255.9,83h0.1h0.1c24.9,0,49.2,10.9,66.8,29.5l0,0.2l-0.1,0.1c18.3,19.2,28.1,53,28.1,80.3V224h-17.5h-155H161\r\n\tV193.1z"},"children":[]}]};exports.locked=locked;var logIn={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255.988,32C160.473,32,78.934,91.804,46.727,176h34.639c9.396-20.484,22.457-39.35,38.868-55.762\r\n\t\tC156.497,83.973,204.709,64,255.988,64c51.286,0,99.504,19.973,135.771,56.239C428.027,156.505,448,204.719,448,256\r\n\t\tc0,51.285-19.973,99.501-56.239,135.765C355.494,428.029,307.275,448,255.988,448c-51.281,0-99.493-19.971-135.755-56.234\r\n\t\tC103.821,375.354,90.76,356.486,81.362,336H46.725c32.206,84.201,113.746,144,209.264,144C379.703,480,480,379.715,480,256\r\n\t\tC480,132.298,379.703,32,255.988,32z"},"children":[{"name":"path","attribs":{"d":"M255.988,32C160.473,32,78.934,91.804,46.727,176h34.639c9.396-20.484,22.457-39.35,38.868-55.762\r\n\t\tC156.497,83.973,204.709,64,255.988,64c51.286,0,99.504,19.973,135.771,56.239C428.027,156.505,448,204.719,448,256\r\n\t\tc0,51.285-19.973,99.501-56.239,135.765C355.494,428.029,307.275,448,255.988,448c-51.281,0-99.493-19.971-135.755-56.234\r\n\t\tC103.821,375.354,90.76,356.486,81.362,336H46.725c32.206,84.201,113.746,144,209.264,144C379.703,480,480,379.715,480,256\r\n\t\tC480,132.298,379.703,32,255.988,32z"},"children":[]}]},{"name":"polygon","attribs":{"points":"206.863,323.883 229.49,346.51 320,256 229.49,165.49 206.862,188.118 258.745,240 32,240 32,272 258.745,272 \t"},"children":[{"name":"polygon","attribs":{"points":"206.863,323.883 229.49,346.51 320,256 229.49,165.49 206.862,188.118 258.745,240 32,240 32,272 258.745,272 \t"},"children":[]}]}]}]};exports.logIn=logIn;var logOut={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"366.863,323.883 389.49,346.51 480,256 389.49,165.49 366.862,188.118 418.745,240 192,240 192,272 418.745,272 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"366.863,323.883 389.49,346.51 480,256 389.49,165.49 366.862,188.118 418.745,240 192,240 192,272 418.745,272 \t\r\n\t\t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M391.491,391.766C355.229,428.029,307.018,448,255.736,448c-51.287,0-99.506-19.971-135.772-56.235\r\n\t\t\tC83.697,355.501,64,307.285,64,256c0-51.281,19.697-99.495,55.965-135.761C156.232,83.973,204.45,64,255.736,64\r\n\t\t\tc51.279,0,99.491,19.973,135.755,56.238c2.527,2.528,4.966,5.121,7.333,7.762h40.731c-40.474-58.028-107.709-96-183.819-96\r\n\t\t\tC132.021,32,32,132.298,32,256c0,123.715,100.021,224,223.736,224c76.112,0,143.35-37.97,183.822-96h-40.73\r\n\t\t\tC396.46,386.643,394.021,389.236,391.491,391.766z"},"children":[{"name":"path","attribs":{"d":"M391.491,391.766C355.229,428.029,307.018,448,255.736,448c-51.287,0-99.506-19.971-135.772-56.235\r\n\t\t\tC83.697,355.501,64,307.285,64,256c0-51.281,19.697-99.495,55.965-135.761C156.232,83.973,204.45,64,255.736,64\r\n\t\t\tc51.279,0,99.491,19.973,135.755,56.238c2.527,2.528,4.966,5.121,7.333,7.762h40.731c-40.474-58.028-107.709-96-183.819-96\r\n\t\t\tC132.021,32,32,132.298,32,256c0,123.715,100.021,224,223.736,224c76.112,0,143.35-37.97,183.822-96h-40.73\r\n\t\t\tC396.46,386.643,394.021,389.236,391.491,391.766z"},"children":[]}]}]}]}]}]};exports.logOut=logOut;var loop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M273.4,300.5l-0.3,58c48.9-8.2,86.3-51,86.3-102.5c0-15.9-3.6-31-10-44.5c-2.8-5.8-6-11.3-9.8-16.5l47.1-43.5\r\n\t\tc1.1,1.3,2.1,2.7,3.1,4c20.9,28,33.2,62.8,33.2,100.5c0,1.2,0,2.5,0,3.7c-1.5,71.5-47.6,132-111.4,154.6\r\n\t\tc-12.3,4.3-25.2,7.3-38.5,8.7l-0.1,57l-76.2-67L170.6,390l44.4-38.7L273.4,300.5z"},"children":[{"name":"path","attribs":{"d":"M273.4,300.5l-0.3,58c48.9-8.2,86.3-51,86.3-102.5c0-15.9-3.6-31-10-44.5c-2.8-5.8-6-11.3-9.8-16.5l47.1-43.5\r\n\t\tc1.1,1.3,2.1,2.7,3.1,4c20.9,28,33.2,62.8,33.2,100.5c0,1.2,0,2.5,0,3.7c-1.5,71.5-47.6,132-111.4,154.6\r\n\t\tc-12.3,4.3-25.2,7.3-38.5,8.7l-0.1,57l-76.2-67L170.6,390l44.4-38.7L273.4,300.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M89,252.3c1.6-72.1,48.3-133,112.9-155.2c11.7-4,24-6.8,36.8-8.1l0.1-57l76.1,66.9l26.2,23.1l-44.3,38.6l-58.4,50.9\r\n\t\tl0.2-57.9c-48.8,8.3-86,51.1-86,102.4c0,16,3.6,31.1,10.1,44.7c2.7,5.8,6,11.2,9.7,16.3l-47,43.6c-1.3-1.6-2.6-3.3-3.8-5\r\n\t\tC101.1,327.7,89,293.3,89,256C89,254.8,89,253.5,89,252.3z"},"children":[{"name":"path","attribs":{"d":"M89,252.3c1.6-72.1,48.3-133,112.9-155.2c11.7-4,24-6.8,36.8-8.1l0.1-57l76.1,66.9l26.2,23.1l-44.3,38.6l-58.4,50.9\r\n\t\tl0.2-57.9c-48.8,8.3-86,51.1-86,102.4c0,16,3.6,31.1,10.1,44.7c2.7,5.8,6,11.2,9.7,16.3l-47,43.6c-1.3-1.6-2.6-3.3-3.8-5\r\n\t\tC101.1,327.7,89,293.3,89,256C89,254.8,89,253.5,89,252.3z"},"children":[]}]}]}]};exports.loop=loop;var magnet={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C141,32.5,64,109.6,64,231.8c0,48.8,2.1,76.8,14.5,127.8c15.9,65.7,39.1,113.3,39.1,113.3l0.6,1.3\r\n\tc1.9,3.4,5.5,5.8,9.8,5.8c1.4,0,2.7-0.2,4-0.7l1.7-0.8l50.3-20.7l1.8-0.8c3.3-1.9,5.5-5.3,5.5-9.3c-0.2-1.4-0.4-2.8-1-4\r\n\tc-0.1-0.1-0.1-0.2-0.2-0.4c-7-16-27.2-59.2-37-101.1c-9.9-41.9-13.5-62.4-13.5-107.7C139.6,163.4,192,112,256,112\r\n\tc64,0,116.4,51.4,116.4,122.5c0,45.3-3.7,65.8-13.6,107.7c-9.9,41.9-30,85.2-37,101.1c-0.1,0.2-0.1,0.3-0.2,0.4\r\n\tc-0.6,1.2-0.8,2.6-1,4c0,4,2.2,7.4,5.5,9.3l1.8,0.8l50.3,20.7l1.7,0.8c1.3,0.5,2.6,0.7,4,0.7c4.3,0,7.9-2.4,9.8-5.8l0.6-1.3\r\n\tc0,0,23.2-47.6,39.1-113.3c12.4-51,14.5-79,14.5-127.8C448,109.6,371,32.5,256,32z M173,444.2c0.1,0.2,0.2,0.5,0.3,0.7l-42.8,17.6\r\n\tc-5.4-11.8-22.7-51-35.7-104.4l42.5-12.3C146.5,385,164.4,425,173,444.2z M381.4,462.5l-42.8-17.6c0.1-0.2,0.2-0.4,0.3-0.7\r\n\tc8.6-19.2,26.4-59.2,35.6-98.4l42.5,12.3C404.1,411.5,386.8,450.7,381.4,462.5z"},"children":[]}]};exports.magnet=magnet;var male={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M480,192V32H320l63,63l-68.7,68.7C284.8,141.3,247.9,128,208,128c-97.2,0-176,78.8-176,176s78.8,176,176,176\r\n\ts176-78.8,176-176c0-39.9-13.3-76.8-35.7-106.3L417,129L480,192z M298.5,394.5C274.3,418.7,242.2,432,208,432s-66.3-13.3-90.5-37.5\r\n\tC93.3,370.3,80,338.2,80,304s13.3-66.3,37.5-90.5c24.2-24.2,56.3-37.5,90.5-37.5s66.3,13.3,90.5,37.5S336,269.8,336,304\r\n\tS322.7,370.3,298.5,394.5z"},"children":[]}]};exports.male=male;var man={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,106.6c20.6,0.1,37.3-16.6,37.3-37.3c0-20.6-16.7-37.3-37.3-37.3c-20.6,0-37.3,16.7-37.3,37.3\r\n\tC218.7,89.9,235.4,106.6,256,106.6z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M293.4,115H256h-37.4c-28.2,0-46.6,24.8-46.6,48.4V277c0,22,31,22,31,0V172h6v285.6c0,30.4,42,29.4,43,0V293h7h1v164.7\r\n\t\tc1.7,31.2,43,28.2,43-0.1V172h5v105c0,22,32,22,32,0V163.4C340,139.9,321.5,115,293.4,115z"},"children":[{"name":"path","attribs":{"d":"M293.4,115H256h-37.4c-28.2,0-46.6,24.8-46.6,48.4V277c0,22,31,22,31,0V172h6v285.6c0,30.4,42,29.4,43,0V293h7h1v164.7\r\n\t\tc1.7,31.2,43,28.2,43-0.1V172h5v105c0,22,32,22,32,0V163.4C340,139.9,321.5,115,293.4,115z"},"children":[]}]}]}]};exports.man=man;var map={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M473.152,136.58L368.594,66.307c-4.644-3.076-10.365-3.076-15.031,0l-97.094,65.195l-97.109-65.195\r\n\t\tc-4.643-3.076-10.444-3.076-15.062,0L39.344,136.58c-4.399,2.949-7.344,8.272-7.344,14.05V431.6c0,5.904,3.07,11.347,7.663,14.271\r\n\t\tc4.62,2.877,10.382,2.829,14.904-0.223l97.188-65.197l97.181,65.197c4.666,3.1,10.44,3.1,15.084,0l97.158-65.197l97.151,65.197\r\n\t\tc2.311,1.55,4.912,2.353,7.538,2.353c2.455,0,4.709-0.747,6.969-2.13c4.594-2.924,7.165-8.366,7.165-14.271v-280.97\r\n\t\tC480,144.852,477.575,139.529,473.152,136.58z M135,353.248l-71,49.404v-241.75l71-49.428V353.248z M167,352.766v-122.7\r\n\t\tc1.167,0.756,2.31,1.526,3.389,2.301l9.333-12.996c-3.904-2.804-8.292-5.501-12.722-7.705V110.992l73,48.992v108.574\r\n\t\tc-5.372-1.855-10.586-4.37-15.893-7.682l-8.471,13.574c6.848,4.273,13.621,7.467,20.704,9.765l3.66-11.286v128.806L167,352.766z\r\n\t\t M272,401.734V288.369c0.349-0.021,0.693-0.03,1.043-0.054c2.91-0.198,5.777-0.517,8.518-0.946l-2.479-15.807\r\n\t\tc-2.268,0.355-4.65,0.619-7.082,0.786V159.984l73-48.992V229.78l-4.844-4.372c-2.997,3.319-5.833,6.575-8.575,9.725\r\n\t\tc-1.806,2.073-3.578,4.108-5.339,6.095l11.974,10.613c1.791-2.021,3.595-4.091,5.431-6.2c0.443-0.509,0.905-1.035,1.354-1.549\r\n\t\tv108.675L272,401.734z M448,401.652l-71-48.438v-136.91c3.785-1.715,7.679-2.992,11.639-3.792l-3.166-15.683\r\n\t\tc-2.858,0.577-5.687,1.339-8.473,2.281v-87.671l71,48.461V401.652z"},"children":[{"name":"path","attribs":{"d":"M473.152,136.58L368.594,66.307c-4.644-3.076-10.365-3.076-15.031,0l-97.094,65.195l-97.109-65.195\r\n\t\tc-4.643-3.076-10.444-3.076-15.062,0L39.344,136.58c-4.399,2.949-7.344,8.272-7.344,14.05V431.6c0,5.904,3.07,11.347,7.663,14.271\r\n\t\tc4.62,2.877,10.382,2.829,14.904-0.223l97.188-65.197l97.181,65.197c4.666,3.1,10.44,3.1,15.084,0l97.158-65.197l97.151,65.197\r\n\t\tc2.311,1.55,4.912,2.353,7.538,2.353c2.455,0,4.709-0.747,6.969-2.13c4.594-2.924,7.165-8.366,7.165-14.271v-280.97\r\n\t\tC480,144.852,477.575,139.529,473.152,136.58z M135,353.248l-71,49.404v-241.75l71-49.428V353.248z M167,352.766v-122.7\r\n\t\tc1.167,0.756,2.31,1.526,3.389,2.301l9.333-12.996c-3.904-2.804-8.292-5.501-12.722-7.705V110.992l73,48.992v108.574\r\n\t\tc-5.372-1.855-10.586-4.37-15.893-7.682l-8.471,13.574c6.848,4.273,13.621,7.467,20.704,9.765l3.66-11.286v128.806L167,352.766z\r\n\t\t M272,401.734V288.369c0.349-0.021,0.693-0.03,1.043-0.054c2.91-0.198,5.777-0.517,8.518-0.946l-2.479-15.807\r\n\t\tc-2.268,0.355-4.65,0.619-7.082,0.786V159.984l73-48.992V229.78l-4.844-4.372c-2.997,3.319-5.833,6.575-8.575,9.725\r\n\t\tc-1.806,2.073-3.578,4.108-5.339,6.095l11.974,10.613c1.791-2.021,3.595-4.091,5.431-6.2c0.443-0.509,0.905-1.035,1.354-1.549\r\n\t\tv108.675L272,401.734z M448,401.652l-71-48.438v-136.91c3.785-1.715,7.679-2.992,11.639-3.792l-3.166-15.683\r\n\t\tc-2.858,0.577-5.687,1.339-8.473,2.281v-87.671l71,48.461V401.652z"},"children":[]}]},{"name":"path","attribs":{"d":"M129.285,221.111c2.218-1.195-1.353-1.071,1.012-1.837l-4.928-15.222c-3.282,1.062-6.502,2.439-9.571,4.093\r\n\t\tc-3.824,2.062-7.745,4.916-11.339,8.253l10.888,11.724C117.963,225.694,126.639,222.538,129.285,221.111z"},"children":[{"name":"path","attribs":{"d":"M129.285,221.111c2.218-1.195-1.353-1.071,1.012-1.837l-4.928-15.222c-3.282,1.062-6.502,2.439-9.571,4.093\r\n\t\tc-3.824,2.062-7.745,4.916-11.339,8.253l10.888,11.724C117.963,225.694,126.639,222.538,129.285,221.111z"},"children":[]}]},{"name":"path","attribs":{"d":"M296.802,266.127l6.985,14.395c6.596-3.201,12.842-7.445,19.095-12.974l-10.599-11.987\r\n\t\tC307.135,260.113,302.071,263.569,296.802,266.127z"},"children":[{"name":"path","attribs":{"d":"M296.802,266.127l6.985,14.395c6.596-3.201,12.842-7.445,19.095-12.974l-10.599-11.987\r\n\t\tC307.135,260.113,302.071,263.569,296.802,266.127z"},"children":[]}]},{"name":"path","attribs":{"d":"M99.364,256.006c1.893-5.926,3.528-11.044,7.129-16.304l-13.204-9.037c-4.924,7.194-7.081,13.944-9.167,20.471\r\n\t\tl-0.242,0.758l15.238,4.879L99.364,256.006z"},"children":[{"name":"path","attribs":{"d":"M99.364,256.006c1.893-5.926,3.528-11.044,7.129-16.304l-13.204-9.037c-4.924,7.194-7.081,13.944-9.167,20.471\r\n\t\tl-0.242,0.758l15.238,4.879L99.364,256.006z"},"children":[]}]},{"name":"path","attribs":{"d":"M198.311,237.753c-1.007-1.204-2.014-2.408-3.032-3.603l-12.178,10.379c0.986,1.156,1.961,2.322,2.936,3.488\r\n\t\tc3.593,4.296,7.308,8.739,11.61,12.809l10.996-11.624C205.02,245.775,201.761,241.878,198.311,237.753z"},"children":[{"name":"path","attribs":{"d":"M198.311,237.753c-1.007-1.204-2.014-2.408-3.032-3.603l-12.178,10.379c0.986,1.156,1.961,2.322,2.936,3.488\r\n\t\tc3.593,4.296,7.308,8.739,11.61,12.809l10.996-11.624C205.02,245.775,201.761,241.878,198.311,237.753z"},"children":[]}]},{"name":"polygon","attribs":{"points":"408.156,229.657 418.5,219.314 428.844,229.657 440.156,218.342 429.814,208 440.156,197.657 428.844,186.342 \r\n\t\t418.5,196.685 408.156,186.342 396.844,197.657 407.186,208 396.844,218.342 \t"},"children":[{"name":"polygon","attribs":{"points":"408.156,229.657 418.5,219.314 428.844,229.657 440.156,218.342 429.814,208 440.156,197.657 428.844,186.342 \r\n\t\t418.5,196.685 408.156,186.342 396.844,197.657 407.186,208 396.844,218.342 \t"},"children":[]}]}]}]};exports.map=map;var medkit={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M472.2,144H352v-30.7C351,85.1,330.3,64,300.8,64H256h-44.8c-29.4,0-50.2,21.1-51.2,49.3V144H39.8c-4.4,0-7.8,3.6-7.8,8\r\n\t\tv288c0,4.4,3.3,8,7.8,8h432.5c4.4,0,7.8-3.6,7.8-8V152C480,147.6,476.7,144,472.2,144z M192,117.2c0-0.4,0-0.7,0-1s0-0.6,0-1\r\n\t\tc0-9.7,8.6-19.3,18.8-19.3H256h45.2c10.1,0,18.8,9.5,18.8,19.3c0,0.3,0,0.6,0,1s0,0.6,0,1V144H192V117.2z M352,320h-64v64h-64v-64\r\n\t\th-64v-64h64v-64h64v64h64V320z"},"children":[{"name":"path","attribs":{"d":"M472.2,144H352v-30.7C351,85.1,330.3,64,300.8,64H256h-44.8c-29.4,0-50.2,21.1-51.2,49.3V144H39.8c-4.4,0-7.8,3.6-7.8,8\r\n\t\tv288c0,4.4,3.3,8,7.8,8h432.5c4.4,0,7.8-3.6,7.8-8V152C480,147.6,476.7,144,472.2,144z M192,117.2c0-0.4,0-0.7,0-1s0-0.6,0-1\r\n\t\tc0-9.7,8.6-19.3,18.8-19.3H256h45.2c10.1,0,18.8,9.5,18.8,19.3c0,0.3,0,0.6,0,1s0,0.6,0,1V144H192V117.2z M352,320h-64v64h-64v-64\r\n\t\th-64v-64h64v-64h64v64h64V320z"},"children":[]}]}]}]};exports.medkit=medkit;var merge={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M384,224c-23.637,0-44.307,12.89-55.391,32H319c-42.464,0-79.99-17.904-111.535-53.214\r\n\tc-20.356-22.787-33.493-48.869-37.856-58.218C183.301,132.822,192,115.413,192,96c0-35.29-28.71-64-64-64S64,60.71,64,96\r\n\tc0,23.637,12.89,44.307,32,55.391v209.219C76.89,371.693,64,392.363,64,416c0,35.29,28.71,64,64,64s64-28.71,64-64\r\n\tc0-23.637-12.89-44.307-32-55.391V245.692C203.553,294.307,258.468,320,319,320h9.609c11.084,19.11,31.754,32,55.391,32\r\n\tc35.29,0,64-28.71,64-64S419.29,224,384,224z M128,64c17.673,0,32,14.327,32,32s-14.327,32-32,32s-32-14.327-32-32\r\n\tS110.327,64,128,64z M128,448c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,448,128,448z M384,320\r\n\tc-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S401.673,320,384,320z"},"children":[]}]};exports.merge=merge;var micA={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M112.1,238.1l-0.1,13.6c0.1,65.6,46,120.6,108.1,136.2c1.3,0.1,2.6,0.5,3.8,0.9c5.9,2,10.1,6.9,12.1,12.8v58.7\r\n\t\tc0,10.9,8.9,19.7,20,19.7h0.1c11.1,0,19.9-8.8,19.9-19.7v-58.8c2-5.9,6.1-10.7,12-12.7c1.2-0.4,2.5-0.8,3.9-0.9\r\n\t\tC354,372.3,400,317.3,400,251.7v-13.6c0-10.4-8.9-18.9-19.5-18.9c-10.6,0-19.5,8.4-19.5,18.9v13.6c0,28.5-11.5,54.1-30.6,72.8\r\n\t\tc-19.2,18.6-45.3,30.2-74.5,30.2c-29.2,0-55.1-11.5-74.2-30.2c-19.1-18.7-30.7-44.4-30.7-72.8v-13.6c0-10.4-8.8-18.9-19.5-18.9\r\n\t\tC120.9,219.2,112.1,227.7,112.1,238.1z"},"children":[{"name":"path","attribs":{"d":"M112.1,238.1l-0.1,13.6c0.1,65.6,46,120.6,108.1,136.2c1.3,0.1,2.6,0.5,3.8,0.9c5.9,2,10.1,6.9,12.1,12.8v58.7\r\n\t\tc0,10.9,8.9,19.7,20,19.7h0.1c11.1,0,19.9-8.8,19.9-19.7v-58.8c2-5.9,6.1-10.7,12-12.7c1.2-0.4,2.5-0.8,3.9-0.9\r\n\t\tC354,372.3,400,317.3,400,251.7v-13.6c0-10.4-8.9-18.9-19.5-18.9c-10.6,0-19.5,8.4-19.5,18.9v13.6c0,28.5-11.5,54.1-30.6,72.8\r\n\t\tc-19.2,18.6-45.3,30.2-74.5,30.2c-29.2,0-55.1-11.5-74.2-30.2c-19.1-18.7-30.7-44.4-30.7-72.8v-13.6c0-10.4-8.8-18.9-19.5-18.9\r\n\t\tC120.9,219.2,112.1,227.7,112.1,238.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M179,107.7v143.8c0,41.8,34.7,75.7,77.5,75.7c42.8,0,77.5-33.9,77.5-75.7V107.7c0-41.8-34.7-75.7-77.5-75.7\r\n\t\tC213.7,32,179,65.9,179,107.7z"},"children":[{"name":"path","attribs":{"d":"M179,107.7v143.8c0,41.8,34.7,75.7,77.5,75.7c42.8,0,77.5-33.9,77.5-75.7V107.7c0-41.8-34.7-75.7-77.5-75.7\r\n\t\tC213.7,32,179,65.9,179,107.7z"},"children":[]}]}]}]};exports.micA=micA;var micB={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.4,32c-35.1,0.1-65.8,23.2-76.8,59.3c-5.6,18.5-3.5,44.8-1.2,54.5c2.3,9.7,7.3,19.9,13.2,28.3\r\n\t\tc2.8,4.2,6.7,7.4,11.2,9.2c0.6,0.3,1.3,0.5,2,0.8c3.3,1.1,6.5,2.2,10.1,3.1c11.8,3,27.1,4.7,41.1,4.8v0c0,0,0.6,0,0.7,0\r\n\t\tc0.3,0,0.3,0,1.3,0v-0.1c14-0.1,27.3-1.7,39.1-4.8c3.6-0.9,6.9-2,10.2-3.1c0.7-0.2,1.3-0.5,1.9-0.8c4.5-1.8,8.4-5,11.2-9.2\r\n\t\tc5.9-8.4,10.8-18.6,13.2-28.3c2.3-9.7,4.4-36-1.2-54.5C321.4,55.2,291.6,32.1,256.4,32z"},"children":[{"name":"path","attribs":{"d":"M256.4,32c-35.1,0.1-65.8,23.2-76.8,59.3c-5.6,18.5-3.5,44.8-1.2,54.5c2.3,9.7,7.3,19.9,13.2,28.3\r\n\t\tc2.8,4.2,6.7,7.4,11.2,9.2c0.6,0.3,1.3,0.5,2,0.8c3.3,1.1,6.5,2.2,10.1,3.1c11.8,3,27.1,4.7,41.1,4.8v0c0,0,0.6,0,0.7,0\r\n\t\tc0.3,0,0.3,0,1.3,0v-0.1c14-0.1,27.3-1.7,39.1-4.8c3.6-0.9,6.9-2,10.2-3.1c0.7-0.2,1.3-0.5,1.9-0.8c4.5-1.8,8.4-5,11.2-9.2\r\n\t\tc5.9-8.4,10.8-18.6,13.2-28.3c2.3-9.7,4.4-36-1.2-54.5C321.4,55.2,291.6,32.1,256.4,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M295.3,201.1c-0.4,0-0.7,0-1.1,0.1c-0.6,0.1-1.3,0.3-1.9,0.4c-2,0.4-4.1,0.8-6.1,1.2c-9.2,1.5-18.9,2.3-29,2.4\r\n\t\tc-10.1-0.1-22.3-0.9-31-2.4c-2.1-0.4-4.2-0.8-6.2-1.2c-0.6-0.1-1.3-0.3-1.9-0.4c-0.4-0.1-0.8-0.1-1.1-0.1c-6.1,0-11,5.3-11.2,11.9\r\n\t\tc0.1,0.8,0.2,1.6,0.2,2.4c4.8,67.2,16.8,240.7,18.2,252c0,0,2.8,12.7,32.1,12.6c0,0,0,0,0,0c29.2,0.1,32.1-12.6,32.1-12.6\r\n\t\tc1.4-11.3,13.4-184.8,18.2-252c0-0.8,0.1-1.6,0.2-2.4C306.3,206.4,301.4,201.1,295.3,201.1z M266,281.7c0,6-4.5,10.9-10,10.9\r\n\t\tc-5.5,0-10-4.9-10-10.9V249c0-6,4.5-10.9,10-10.9c5.5,0,10,4.9,10,10.9V281.7z"},"children":[{"name":"path","attribs":{"d":"M295.3,201.1c-0.4,0-0.7,0-1.1,0.1c-0.6,0.1-1.3,0.3-1.9,0.4c-2,0.4-4.1,0.8-6.1,1.2c-9.2,1.5-18.9,2.3-29,2.4\r\n\t\tc-10.1-0.1-22.3-0.9-31-2.4c-2.1-0.4-4.2-0.8-6.2-1.2c-0.6-0.1-1.3-0.3-1.9-0.4c-0.4-0.1-0.8-0.1-1.1-0.1c-6.1,0-11,5.3-11.2,11.9\r\n\t\tc0.1,0.8,0.2,1.6,0.2,2.4c4.8,67.2,16.8,240.7,18.2,252c0,0,2.8,12.7,32.1,12.6c0,0,0,0,0,0c29.2,0.1,32.1-12.6,32.1-12.6\r\n\t\tc1.4-11.3,13.4-184.8,18.2-252c0-0.8,0.1-1.6,0.2-2.4C306.3,206.4,301.4,201.1,295.3,201.1z M266,281.7c0,6-4.5,10.9-10,10.9\r\n\t\tc-5.5,0-10-4.9-10-10.9V249c0-6,4.5-10.9,10-10.9c5.5,0,10,4.9,10,10.9V281.7z"},"children":[]}]}]}]};exports.micB=micB;var micC={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M329.2,32H182.9C152.5,32,128,55.4,128,84.4V112h152v37H128v43h152v37H128v43h152v37H128v41.8c0,29,24.5,52.2,54.9,52.2H213\r\n\tv77h86v-77h30.2c30.3,0,54.8-23.2,54.8-52.2V309h-59v-37h59v-43h-59v-37h59v-43h-59v-37h59V84.4C384,55.4,359.5,32,329.2,32z"},"children":[]}]};exports.micC=micC;var minusCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M384,272H128v-32h256V272z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M384,272H128v-32h256V272z"},"children":[]}]}]}]};exports.minusCircled=minusCircled;var minusRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\tC448,238.3,434.3,224,417.4,224z"},"children":[]}]};exports.minusRound=minusRound;var minus={"viewBox":"0 0 512 512","children":[{"name":"rect","attribs":{"x":"64","y":"224","width":"384","height":"64"},"children":[]}]};exports.minus=minus;var modelS={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M508.8,390.9c-0.6,4.1-1.6,8.1-3.1,11.2c-2.7,5.5-5.3,6-15.5,5.5c-13.2-0.6-32.1,0-52.1,0.8c0,5.5,0.2,8.1,0.2,8.1\r\n\t\tc1.3,15.1,8.1,15.6,10.8,15.6c3,0,39.2,0,43,0s7.3,0,10-1.8c3.5-2.3,5-9,6.3-20.7c0.2-1.7,0.3-3.9,0.4-6.5c0,0,0-0.1,0-0.1\r\n\t\tc0-0.8,0.1-1.8,0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C508.9,396.3,508.9,393.3,508.8,390.9z"},"children":[{"name":"path","attribs":{"d":"M508.8,390.9c-0.6,4.1-1.6,8.1-3.1,11.2c-2.7,5.5-5.3,6-15.5,5.5c-13.2-0.6-32.1,0-52.1,0.8c0,5.5,0.2,8.1,0.2,8.1\r\n\t\tc1.3,15.1,8.1,15.6,10.8,15.6c3,0,39.2,0,43,0s7.3,0,10-1.8c3.5-2.3,5-9,6.3-20.7c0.2-1.7,0.3-3.9,0.4-6.5c0,0,0-0.1,0-0.1\r\n\t\tc0-0.8,0.1-1.8,0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C508.9,396.3,508.9,393.3,508.8,390.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M3,390.9c0.6,4.1,1.6,8.1,3.1,11.2c2.7,5.5,5.3,6,15.5,5.5c13.2-0.6,32.1,0,52.1,0.8c0,5.5-0.2,8.1-0.2,8.1\r\n\t\tc-1.3,15.1-8.1,15.6-10.8,15.6c-3,0-39.2,0-43,0s-7,0-10-1.8c-3.6-2.1-5-9-6.3-20.7c-0.2-1.7-0.3-3.9-0.4-6.5c0,0,0-0.1,0-0.1\r\n\t\tc0-0.8-0.1-1.8-0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C3,396.3,3,393.3,3,390.9z"},"children":[{"name":"path","attribs":{"d":"M3,390.9c0.6,4.1,1.6,8.1,3.1,11.2c2.7,5.5,5.3,6,15.5,5.5c13.2-0.6,32.1,0,52.1,0.8c0,5.5-0.2,8.1-0.2,8.1\r\n\t\tc-1.3,15.1-8.1,15.6-10.8,15.6c-3,0-39.2,0-43,0s-7,0-10-1.8c-3.6-2.1-5-9-6.3-20.7c-0.2-1.7-0.3-3.9-0.4-6.5c0,0,0-0.1,0-0.1\r\n\t\tc0-0.8-0.1-1.8-0.1-2.9c0-0.4,0-0.8,0-1.1c0,0,0,0,0,0C3,396.3,3,393.3,3,390.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M512,296.6c0-30.7-4-60.7-5.6-64c-1.2-2.4-8.9-8.7-26.4-20.6c-17.7-12.1-17.3-10.3-20.5-18.2c2.9-0.9,5.7-2.6,7.4-2.8\r\n\t\tc3.8-0.4,4,3.2,11.9,3.2s25-2.1,28.5-5.6c3.5-3.5,4.6-4.7,4.6-7.8s-1.8-9.5-5.2-13.3s-17.9-5.7-26.4-6.8s-9.7,0-11.9,1.4\r\n\t\tc-3.5,2.2-3.7,22.3-3.7,22.3l-8.3,0.2c-5.4-13.3-12.9-40.1-24.6-61.2c-12.8-23-26.2-30.2-31.8-32c-5.5-1.7-10.5-2.9-48-6.7\r\n\t\tc-38.3-4-68.8-4.5-96-4.5s-57.7,0.6-96,4.5c-37.5,3.9-42.5,5-48,6.7c-5.5,1.7-19,9-31.8,32c-11.7,21.1-19.2,47.9-24.6,61.2\r\n\t\tl-8.3-0.2c0,0-0.1-20.1-3.7-22.3c-2.2-1.4-3.4-2.6-11.9-1.4s-23,3-26.4,6.8s-5.2,10.2-5.2,13.3s1.1,4.4,4.6,7.8\r\n\t\tc3.5,3.5,20.6,5.6,28.5,5.6s8.1-3.6,11.9-3.2c1.7,0.2,4.6,1.9,7.4,2.8c-3.3,7.9-2.8,6.1-20.5,18.2c-17.5,12-25.3,18.2-26.4,20.6\r\n\t\tC4,235.9,0,265.9,0,296.6s2.2,58.3,2.2,68.1c0,4.1,0,11.3,0.9,18.2c0.6,4.1,1.5,8.1,3.1,11.2c2.7,5.5,5.2,6,15.5,5.5\r\n\t\tc13.2-0.6,32.3,0,52,0.8c13.2,0.5,26.7,1,38.7,1.3c30,0.6,21.2-4.4,34-4.2c12.8,0.2,63.3,2.3,109.5,2.3s96.8-2.1,109.5-2.3\r\n\t\tc12.8-0.2,4,4.8,34,4.2c12-0.2,25.5-0.8,38.7-1.3c19.7-0.7,38.9-1.4,52-0.8c10.3,0.5,12.8,0,15.5-5.5c1.5-3.1,2.5-7.1,3.1-11.2\r\n\t\tc1-6.9,0.9-14.1,0.9-18.2C509.8,355,512,327.3,512,296.6z M86.2,145.2c4.8-11.2,19.2-33.7,26.2-37.7c1.7-1,16.6-5.7,53.9-8.2\r\n\t\tc34.3-2.3,72.2-3.2,89.8-3.2s55.5,0.9,89.8,3.2c37.2,2.5,52.3,7.1,53.9,8.2c9,6.2,21.4,26.5,26.2,37.7c4.8,11.2,11.2,33.2,10,36.2\r\n\t\tc-1.2,3,1.2,4.5-15,3.2c-16.1-1.2-117.2-2.5-164.8-2.5c-47.5,0-148.6,1.3-164.8,2.5c-16.2,1.2-13.8-0.2-15-3.2\r\n\t\tC75,178.4,81.4,156.5,86.2,145.2z M123,270.4c-7.2,1.8-11.5,5.7-20.5,5.6c-9,0-33.3-4.1-38.5-4.3c-5.2-0.2-9.8,3.5-12.5,4.2\r\n\t\ts-8-1.2-16-3.7s-12.7-1.8-15.3-12.7c-2.7-10.8,0-26.3,0-26.3c17.3-0.8,34,0.8,65.3,9.6c31.3,8.8,48.7,25.7,48.7,25.7\r\n\t\tS130.2,268.6,123,270.4z M358.2,349.2c-14.3,1.9-74.2,2.4-102.2,2.4c-28,0-87.9-0.6-102.2-2.4c-14.6-1.9-33.6-19.4-20.5-33.3\r\n\t\tc17.7-18.9,14.4-18.3,54.6-23.5c34.8-4.5,61.2-4.7,68.1-4.7c6.8,0,33.3,0.3,68.1,4.7c40.2,5.2,36.9,4.6,54.6,23.5\r\n\t\tC391.8,329.8,372.8,347.3,358.2,349.2z M491.8,259.6c-2.7,10.8-7.3,10.2-15.3,12.7s-13.3,4.3-16,3.7s-7.3-4.3-12.5-4.2\r\n\t\tc-5.2,0.2-29.5,4.3-38.5,4.3c-9,0-13.3-3.8-20.5-5.6c-7.2-1.8-11.2-1.8-11.2-1.8s17.3-17,48.7-25.7c31.3-8.8,48-10.4,65.3-9.6\r\n\t\tC491.8,233.2,494.5,248.7,491.8,259.6z"},"children":[{"name":"path","attribs":{"d":"M512,296.6c0-30.7-4-60.7-5.6-64c-1.2-2.4-8.9-8.7-26.4-20.6c-17.7-12.1-17.3-10.3-20.5-18.2c2.9-0.9,5.7-2.6,7.4-2.8\r\n\t\tc3.8-0.4,4,3.2,11.9,3.2s25-2.1,28.5-5.6c3.5-3.5,4.6-4.7,4.6-7.8s-1.8-9.5-5.2-13.3s-17.9-5.7-26.4-6.8s-9.7,0-11.9,1.4\r\n\t\tc-3.5,2.2-3.7,22.3-3.7,22.3l-8.3,0.2c-5.4-13.3-12.9-40.1-24.6-61.2c-12.8-23-26.2-30.2-31.8-32c-5.5-1.7-10.5-2.9-48-6.7\r\n\t\tc-38.3-4-68.8-4.5-96-4.5s-57.7,0.6-96,4.5c-37.5,3.9-42.5,5-48,6.7c-5.5,1.7-19,9-31.8,32c-11.7,21.1-19.2,47.9-24.6,61.2\r\n\t\tl-8.3-0.2c0,0-0.1-20.1-3.7-22.3c-2.2-1.4-3.4-2.6-11.9-1.4s-23,3-26.4,6.8s-5.2,10.2-5.2,13.3s1.1,4.4,4.6,7.8\r\n\t\tc3.5,3.5,20.6,5.6,28.5,5.6s8.1-3.6,11.9-3.2c1.7,0.2,4.6,1.9,7.4,2.8c-3.3,7.9-2.8,6.1-20.5,18.2c-17.5,12-25.3,18.2-26.4,20.6\r\n\t\tC4,235.9,0,265.9,0,296.6s2.2,58.3,2.2,68.1c0,4.1,0,11.3,0.9,18.2c0.6,4.1,1.5,8.1,3.1,11.2c2.7,5.5,5.2,6,15.5,5.5\r\n\t\tc13.2-0.6,32.3,0,52,0.8c13.2,0.5,26.7,1,38.7,1.3c30,0.6,21.2-4.4,34-4.2c12.8,0.2,63.3,2.3,109.5,2.3s96.8-2.1,109.5-2.3\r\n\t\tc12.8-0.2,4,4.8,34,4.2c12-0.2,25.5-0.8,38.7-1.3c19.7-0.7,38.9-1.4,52-0.8c10.3,0.5,12.8,0,15.5-5.5c1.5-3.1,2.5-7.1,3.1-11.2\r\n\t\tc1-6.9,0.9-14.1,0.9-18.2C509.8,355,512,327.3,512,296.6z M86.2,145.2c4.8-11.2,19.2-33.7,26.2-37.7c1.7-1,16.6-5.7,53.9-8.2\r\n\t\tc34.3-2.3,72.2-3.2,89.8-3.2s55.5,0.9,89.8,3.2c37.2,2.5,52.3,7.1,53.9,8.2c9,6.2,21.4,26.5,26.2,37.7c4.8,11.2,11.2,33.2,10,36.2\r\n\t\tc-1.2,3,1.2,4.5-15,3.2c-16.1-1.2-117.2-2.5-164.8-2.5c-47.5,0-148.6,1.3-164.8,2.5c-16.2,1.2-13.8-0.2-15-3.2\r\n\t\tC75,178.4,81.4,156.5,86.2,145.2z M123,270.4c-7.2,1.8-11.5,5.7-20.5,5.6c-9,0-33.3-4.1-38.5-4.3c-5.2-0.2-9.8,3.5-12.5,4.2\r\n\t\ts-8-1.2-16-3.7s-12.7-1.8-15.3-12.7c-2.7-10.8,0-26.3,0-26.3c17.3-0.8,34,0.8,65.3,9.6c31.3,8.8,48.7,25.7,48.7,25.7\r\n\t\tS130.2,268.6,123,270.4z M358.2,349.2c-14.3,1.9-74.2,2.4-102.2,2.4c-28,0-87.9-0.6-102.2-2.4c-14.6-1.9-33.6-19.4-20.5-33.3\r\n\t\tc17.7-18.9,14.4-18.3,54.6-23.5c34.8-4.5,61.2-4.7,68.1-4.7c6.8,0,33.3,0.3,68.1,4.7c40.2,5.2,36.9,4.6,54.6,23.5\r\n\t\tC391.8,329.8,372.8,347.3,358.2,349.2z M491.8,259.6c-2.7,10.8-7.3,10.2-15.3,12.7s-13.3,4.3-16,3.7s-7.3-4.3-12.5-4.2\r\n\t\tc-5.2,0.2-29.5,4.3-38.5,4.3c-9,0-13.3-3.8-20.5-5.6c-7.2-1.8-11.2-1.8-11.2-1.8s17.3-17,48.7-25.7c31.3-8.8,48-10.4,65.3-9.6\r\n\t\tC491.8,233.2,494.5,248.7,491.8,259.6z"},"children":[]}]}]}]};exports.modelS=modelS;var monitor={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M468.7,64H43.3c-6,0-11.3,5-11.3,11.1v265.7c0,6.2,5.2,11.1,11.3,11.1h425.4c6,0,11.3-5,11.3-11.1V75.1\r\n\t\tC480,69,474.8,64,468.7,64z M448,320H64V96h384V320z"},"children":[{"name":"path","attribs":{"d":"M468.7,64H43.3c-6,0-11.3,5-11.3,11.1v265.7c0,6.2,5.2,11.1,11.3,11.1h425.4c6,0,11.3-5,11.3-11.1V75.1\r\n\t\tC480,69,474.8,64,468.7,64z M448,320H64V96h384V320z"},"children":[]}]},{"name":"path","attribs":{"d":"M302.5,448c28-0.5,41.5-3.9,29-12.5c-12.5-8.7-28.5-15.3-29-22.5c-0.3-3.7-1.7-45-1.7-45H256h-44.8c0,0-1.5,41.3-1.7,45\r\n\t\tc-0.5,7.1-16.5,13.8-29,22.5c-12.5,8.7,1,12,29,12.5H302.5z"},"children":[{"name":"path","attribs":{"d":"M302.5,448c28-0.5,41.5-3.9,29-12.5c-12.5-8.7-28.5-15.3-29-22.5c-0.3-3.7-1.7-45-1.7-45H256h-44.8c0,0-1.5,41.3-1.7,45\r\n\t\tc-0.5,7.1-16.5,13.8-29,22.5c-12.5,8.7,1,12,29,12.5H302.5z"},"children":[]}]}]}]};exports.monitor=monitor;var more={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M113.7,304C86.2,304,64,282.6,64,256c0-26.5,22.2-48,49.7-48c27.6,0,49.8,21.5,49.8,48C163.5,282.6,141.3,304,113.7,304z"},"children":[{"name":"path","attribs":{"d":"M113.7,304C86.2,304,64,282.6,64,256c0-26.5,22.2-48,49.7-48c27.6,0,49.8,21.5,49.8,48C163.5,282.6,141.3,304,113.7,304z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,304c-27.5,0-49.8-21.4-49.8-48c0-26.5,22.3-48,49.8-48c27.5,0,49.7,21.5,49.7,48C305.7,282.6,283.5,304,256,304z"},"children":[{"name":"path","attribs":{"d":"M256,304c-27.5,0-49.8-21.4-49.8-48c0-26.5,22.3-48,49.8-48c27.5,0,49.7,21.5,49.7,48C305.7,282.6,283.5,304,256,304z"},"children":[]}]},{"name":"path","attribs":{"d":"M398.2,304c-27.5,0-49.8-21.4-49.8-48c0-26.5,22.2-48,49.8-48c27.5,0,49.8,21.5,49.8,48C448,282.6,425.8,304,398.2,304z"},"children":[{"name":"path","attribs":{"d":"M398.2,304c-27.5,0-49.8-21.4-49.8-48c0-26.5,22.2-48,49.8-48c27.5,0,49.8,21.5,49.8,48C448,282.6,425.8,304,398.2,304z"},"children":[]}]}]}]};exports.more=more;var mouse={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32c-0.46,0-0.917,0.011-1.376,0.015l5.747,0.057C258.92,32.029,257.464,32,256,32z"},"children":[{"name":"path","attribs":{"d":"M256,32c-0.46,0-0.917,0.011-1.376,0.015l5.747,0.057C258.92,32.029,257.464,32,256,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M378.553,193.211c-0.195,0.064-0.414,0.16-0.619,0.269c-34.234,13.289-76.337,22.52-121.886,22.475\r\n\t\tc-45.52-0.076-87.626-9.398-121.81-22.772c-0.19-0.104-0.429-0.192-0.647-0.265c-1.531-0.554-3.146-0.897-4.841-0.917\r\n\t\tc-0.254-0.001-0.5-0.013-0.75,0v176.012C128,429.892,185.308,480,256,480c21.992,0,42.687-4.803,60.766-13.355\r\n\t\tc0.095-0.045,0.191-0.087,0.286-0.133c0.026-0.013,0.054-0.026,0.08-0.039c4.87-2.344,9.581-4.963,14.122-7.828\r\n\t\tC363.219,438.275,384,405.271,384,368.012V192c-0.191-0.008-0.496,0-0.689,0C381.584,192.014,380.092,192.651,378.553,193.211z\r\n\t\t M317.132,466.424c-0.026,0.013-0.054,0.026-0.08,0.039c-0.095,0.045-0.191,0.088-0.286,0.133c0.095-0.045,0.191-0.088,0.286-0.133\r\n\t\tC317.078,466.45,317.105,466.437,317.132,466.424c4.87-2.342,9.581-4.961,14.122-7.825\r\n\t\tC326.758,461.463,322.044,464.083,317.132,466.424z"},"children":[{"name":"path","attribs":{"d":"M378.553,193.211c-0.195,0.064-0.414,0.16-0.619,0.269c-34.234,13.289-76.337,22.52-121.886,22.475\r\n\t\tc-45.52-0.076-87.626-9.398-121.81-22.772c-0.19-0.104-0.429-0.192-0.647-0.265c-1.531-0.554-3.146-0.897-4.841-0.917\r\n\t\tc-0.254-0.001-0.5-0.013-0.75,0v176.012C128,429.892,185.308,480,256,480c21.992,0,42.687-4.803,60.766-13.355\r\n\t\tc0.095-0.045,0.191-0.087,0.286-0.133c0.026-0.013,0.054-0.026,0.08-0.039c4.87-2.344,9.581-4.963,14.122-7.828\r\n\t\tC363.219,438.275,384,405.271,384,368.012V192c-0.191-0.008-0.496,0-0.689,0C381.584,192.014,380.092,192.651,378.553,193.211z\r\n\t\t M317.132,466.424c-0.026,0.013-0.054,0.026-0.08,0.039c-0.095,0.045-0.191,0.088-0.286,0.133c0.095-0.045,0.191-0.088,0.286-0.133\r\n\t\tC317.078,466.45,317.105,466.437,317.132,466.424c4.87-2.342,9.581-4.961,14.122-7.825\r\n\t\tC326.758,461.463,322.044,464.083,317.132,466.424z"},"children":[]}]},{"name":"path","attribs":{"d":"M331.254,458.599c-4.541,2.864-9.252,5.483-14.122,7.825C322.044,464.083,326.758,461.463,331.254,458.599z"},"children":[{"name":"path","attribs":{"d":"M331.254,458.599c-4.541,2.864-9.252,5.483-14.122,7.825C322.044,464.083,326.758,461.463,331.254,458.599z"},"children":[]}]},{"name":"path","attribs":{"d":"M260.371,32.072l-5.747-0.057C184.566,32.662,128,82.547,128,144v22.708c2.158,2.024,4.593,3.755,7.251,5.115\r\n\t\tc0.673,0.337,1.386,0.659,2.059,0.996c0.032,0.027,0.077,0.01,0.109,0.036c22.757,10.35,51.429,15.801,83.415,19.006\r\n\t\tc0.694,0.078,1.397,0.107,2.148,0.12C234.24,191.997,239.996,192,240,181.411V96c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16\r\n\t\tv86.328c-0.088,9.672,5.926,9.72,17.2,9.749c0.717-0.016,1.415-0.045,2.081-0.105c0.062-0.003,0.141,0.005,0.244-0.02\r\n\t\tc31.682-3.119,60.143-8.405,82.808-18.59c1.162-0.545,2.291-1.056,3.407-1.581c2.271-1.232,4.365-2.743,6.26-4.466V144\r\n\t\tC384,83.425,329.039,34.09,260.371,32.072z"},"children":[{"name":"path","attribs":{"d":"M260.371,32.072l-5.747-0.057C184.566,32.662,128,82.547,128,144v22.708c2.158,2.024,4.593,3.755,7.251,5.115\r\n\t\tc0.673,0.337,1.386,0.659,2.059,0.996c0.032,0.027,0.077,0.01,0.109,0.036c22.757,10.35,51.429,15.801,83.415,19.006\r\n\t\tc0.694,0.078,1.397,0.107,2.148,0.12C234.24,191.997,239.996,192,240,181.411V96c0-8.836,7.164-16,16-16c8.836,0,16,7.164,16,16\r\n\t\tv86.328c-0.088,9.672,5.926,9.72,17.2,9.749c0.717-0.016,1.415-0.045,2.081-0.105c0.062-0.003,0.141,0.005,0.244-0.02\r\n\t\tc31.682-3.119,60.143-8.405,82.808-18.59c1.162-0.545,2.291-1.056,3.407-1.581c2.271-1.232,4.365-2.743,6.26-4.466V144\r\n\t\tC384,83.425,329.039,34.09,260.371,32.072z"},"children":[]}]}]}]};exports.mouse=mouse;var musicNote={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M426,32.1c-2.2,0-5.1,0.6-5.1,0.6L203.3,65.9C189.5,69.6,177,83,176,97.5V384h-61v-0.1c-28,0-51.1,20-51.1,48\r\n\ts23.1,48,51.3,48h36.2c15.3,0,28.9-6.9,38.3-17.5c0.1-0.1,0.3-0.1,0.4-0.2c0.6-0.6,1-1.5,1.5-2.1c1.3-1.6,2.4-3.2,3.4-5\r\n\tC204.6,441,208,422.3,208,414V182l208-38c0,0,0,136,0,192h-60.5c-28.3,0-51.2,19.9-51.2,48s22.9,48,51.2,48h37.2\r\n\tc18.2,0,34.1-6,43.2-21c0,0,0.1,0,0.2,0c9-12,12-30.2,12-54.9c0-24.8,0-302.8,0-302.8C448,41.6,438.1,32.1,426,32.1z"},"children":[]}]};exports.musicNote=musicNote;var naviconRound={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,238.3,434.3,224,417.4,224z"},"children":[{"name":"path","attribs":{"d":"M417.4,224H94.6C77.7,224,64,238.3,64,256c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,238.3,434.3,224,417.4,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,110.3,434.3,96,417.4,96z"},"children":[{"name":"path","attribs":{"d":"M417.4,96H94.6C77.7,96,64,110.3,64,128c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,110.3,434.3,96,417.4,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,366.3,434.3,352,417.4,352z"},"children":[{"name":"path","attribs":{"d":"M417.4,352H94.6C77.7,352,64,366.3,64,384c0,17.7,13.7,32,30.6,32h322.8c16.9,0,30.6-14.3,30.6-32\r\n\t\tC448,366.3,434.3,352,417.4,352z"},"children":[]}]}]}]};exports.naviconRound=naviconRound;var navicon={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"96","y":"241","width":"320","height":"32"},"children":[{"name":"rect","attribs":{"x":"96","y":"241","width":"320","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"145","width":"320","height":"32"},"children":[{"name":"rect","attribs":{"x":"96","y":"145","width":"320","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"96","y":"337","width":"320","height":"32"},"children":[{"name":"rect","attribs":{"x":"96","y":"337","width":"320","height":"32"},"children":[]}]}]}]};exports.navicon=navicon;var navigate={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"480,32 32,224 288,224 288,480 "},"children":[]}]};exports.navigate=navigate;var network={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,96c0-35.29-28.71-64-64-64s-64,28.71-64,64c0,23.637,12.89,44.307,32,55.391v52.832l-96,48l-96-48v-52.832\r\n\tc19.11-11.084,32-31.754,32-55.391c0-35.29-28.71-64-64-64S64,60.71,64,96c0,23.637,12.89,44.307,32,55.391v92.387l128,64v52.832\r\n\tc-19.11,11.084-32,31.754-32,55.391c0,35.29,28.71,64,64,64s64-28.71,64-64c0-23.637-12.89-44.307-32-55.391v-52.832l128-64v-92.387\r\n\tC435.11,140.307,448,119.637,448,96z M128,64c17.673,0,32,14.327,32,32s-14.327,32-32,32s-32-14.327-32-32S110.327,64,128,64z\r\n\t M256,448c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S273.673,448,256,448z M384,128c-17.673,0-32-14.327-32-32\r\n\ts14.327-32,32-32s32,14.327,32,32S401.673,128,384,128z"},"children":[]}]};exports.network=network;var noSmoking={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"360","y":"256","class":"st0","width":"16","height":"48"},"children":[{"name":"rect","attribs":{"x":"360","y":"256","class":"st0","width":"16","height":"48"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"112,304 249.6,304 201.6,256 112,256 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"112,304 249.6,304 201.6,256 112,256 \t"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M364.5,60.1c-0.4-0.2-0.7-0.4-1-0.6c-10.9-6-22.5-10.7-34.4-14.8c-1.8-0.6-3.6-1.2-5.4-1.8\r\n\t\tC302.3,36.1,279.6,32,256,32C132.3,32,32,132.3,32,256c0,84.3,46.6,157.6,115.4,195.8c0.4,0.2,0.7,0.5,1.1,0.7\r\n\t\tc10.9,6,22.5,10.7,34.4,14.8c1.8,0.6,3.6,1.2,5.4,1.8c21.4,6.8,44,10.9,67.7,10.9c123.7,0,224-100.3,224-224\r\n\t\tC480,171.7,433.4,98.3,364.5,60.1z M256,426.4c-9.3,0-18.4-0.9-27.2-2.4c-9.8-1.6-19.3-4.1-28.5-7.3c-1.9-0.6-3.8-1.2-5.6-1.9\r\n\t\tc-6.5-2.5-12.9-5.3-19-8.6c-53.6-28.7-90.1-85.2-90.1-150.3c0-37.2,12.4-71.4,32.7-99.4l237.2,237.2\r\n\t\tC327.4,414,293.2,426.4,256,426.4z M393.8,355.4L156.6,118.2c28-20.2,62.1-32.6,99.4-32.6c9.3,0,18.3,0.9,27.2,2.4\r\n\t\tc9.8,1.6,19.3,4.1,28.5,7.3c1.8,0.6,3.7,1.2,5.6,1.9c6.2,2.4,12.2,5,18,8.1c54.2,28.5,91.2,85.3,91.2,150.8\r\n\t\tC426.4,293.3,414,327.4,393.8,355.4z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M364.5,60.1c-0.4-0.2-0.7-0.4-1-0.6c-10.9-6-22.5-10.7-34.4-14.8c-1.8-0.6-3.6-1.2-5.4-1.8\r\n\t\tC302.3,36.1,279.6,32,256,32C132.3,32,32,132.3,32,256c0,84.3,46.6,157.6,115.4,195.8c0.4,0.2,0.7,0.5,1.1,0.7\r\n\t\tc10.9,6,22.5,10.7,34.4,14.8c1.8,0.6,3.6,1.2,5.4,1.8c21.4,6.8,44,10.9,67.7,10.9c123.7,0,224-100.3,224-224\r\n\t\tC480,171.7,433.4,98.3,364.5,60.1z M256,426.4c-9.3,0-18.4-0.9-27.2-2.4c-9.8-1.6-19.3-4.1-28.5-7.3c-1.9-0.6-3.8-1.2-5.6-1.9\r\n\t\tc-6.5-2.5-12.9-5.3-19-8.6c-53.6-28.7-90.1-85.2-90.1-150.3c0-37.2,12.4-71.4,32.7-99.4l237.2,237.2\r\n\t\tC327.4,414,293.2,426.4,256,426.4z M393.8,355.4L156.6,118.2c28-20.2,62.1-32.6,99.4-32.6c9.3,0,18.3,0.9,27.2,2.4\r\n\t\tc9.8,1.6,19.3,4.1,28.5,7.3c1.8,0.6,3.7,1.2,5.6,1.9c6.2,2.4,12.2,5,18,8.1c54.2,28.5,91.2,85.3,91.2,150.8\r\n\t\tC426.4,293.3,414,327.4,393.8,355.4z"},"children":[]}]},{"name":"polygon","attribs":{"class":"st0","points":"352,298 352,256 310,256 \t"},"children":[{"name":"polygon","attribs":{"class":"st0","points":"352,298 352,256 310,256 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"384","y":"256","class":"st0","width":"16","height":"48"},"children":[{"name":"rect","attribs":{"x":"384","y":"256","class":"st0","width":"16","height":"48"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M360.1,212.7c-8.8-4.1-22-5.7-45.6-5.7c-1.2,0-2.4,0-3.6,0c-12.7,0.1-15.9-0.1-20-6.1\r\n\t\tc-2.8-4.2-1-14.8,3.7-21.9c1.6-2.4,1.8-5.6,0.4-8.2c-1.4-2.6-4.1-4.2-7-4.3c-0.1,0-9.4-0.1-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1\r\n\t\tc0-25.8,21.8-27.7,22.8-27.7v-16c-12,0-38.8,11-38.8,43.7c0,17.5,9,31,25.7,38c4.2,1.7,8.4,2.9,12,3.6c-3.3,9.8-3.6,20.9,1.7,28.7\r\n\t\tc9,13.3,20.3,13.2,33.3,13.1c1.1,0,2.3,0,3.5,0c26.3,0,34.6,2.3,38.9,4.3c5.7,2.6,6.8,11.5,6.6,19.7c0,0.7,0,0.4,0,1h16\r\n\t\tc0-0.4,0-0.4,0-1C375.8,239.8,376.1,220.1,360.1,212.7z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M360.1,212.7c-8.8-4.1-22-5.7-45.6-5.7c-1.2,0-2.4,0-3.6,0c-12.7,0.1-15.9-0.1-20-6.1\r\n\t\tc-2.8-4.2-1-14.8,3.7-21.9c1.6-2.4,1.8-5.6,0.4-8.2c-1.4-2.6-4.1-4.2-7-4.3c-0.1,0-9.4-0.1-18.3-3.9c-10.6-4.5-15.6-12.1-15.6-23.1\r\n\t\tc0-25.8,21.8-27.7,22.8-27.7v-16c-12,0-38.8,11-38.8,43.7c0,17.5,9,31,25.7,38c4.2,1.7,8.4,2.9,12,3.6c-3.3,9.8-3.6,20.9,1.7,28.7\r\n\t\tc9,13.3,20.3,13.2,33.3,13.1c1.1,0,2.3,0,3.5,0c26.3,0,34.6,2.3,38.9,4.3c5.7,2.6,6.8,11.5,6.6,19.7c0,0.7,0,0.4,0,1h16\r\n\t\tc0-0.4,0-0.4,0-1C375.8,239.8,376.1,220.1,360.1,212.7z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M400,248c0-25.7-3-43.2-9.1-53.6C382.3,180,368.5,172,352,172h-17.4c2.9-8.3,5.4-19.8,3.5-30.9\r\n\t\tc-3.2-18.8-19.1-30-43.1-30v16c21,0,26.1,9.1,27.4,16.7c2.5,14.5-6.8,32.1-6.9,32.3c-1.4,2.5-1.3,5.5,0.1,7.9\r\n\t\tc1.4,2.4,4.1,3.9,6.9,3.9H352c10.9,0,19.4,4.9,25.1,14.6c3.1,5.3,6.9,17.5,6.9,45.4H400z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M400,248c0-25.7-3-43.2-9.1-53.6C382.3,180,368.5,172,352,172h-17.4c2.9-8.3,5.4-19.8,3.5-30.9\r\n\t\tc-3.2-18.8-19.1-30-43.1-30v16c21,0,26.1,9.1,27.4,16.7c2.5,14.5-6.8,32.1-6.9,32.3c-1.4,2.5-1.3,5.5,0.1,7.9\r\n\t\tc1.4,2.4,4.1,3.9,6.9,3.9H352c10.9,0,19.4,4.9,25.1,14.6c3.1,5.3,6.9,17.5,6.9,45.4H400z"},"children":[]}]}]}]};exports.noSmoking=noSmoking;var nuclear={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"272","r":"48"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"272","r":"48"},"children":[]}]},{"name":"circle","attribs":{"cx":"256","cy":"272","r":"48"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"272","r":"48"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480,272H320c0,23.9-13.1,44.7-32.6,55.7L365.6,464C433.1,425.4,480,355.3,480,272z"},"children":[{"name":"path","attribs":{"d":"M480,272H320c0,23.9-13.1,44.7-32.6,55.7L365.6,464C433.1,425.4,480,355.3,480,272z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,208c11.7,0,22.7,3.2,32.1,8.7l80.6-138.3C335.6,59.1,297.1,48,256,48c-41.2,0-79.9,11.2-113.1,30.6l79.8,138.8\r\n\t\t\tC232.4,211.4,243.8,208,256,208z"},"children":[{"name":"path","attribs":{"d":"M256,208c11.7,0,22.7,3.2,32.1,8.7l80.6-138.3C335.6,59.1,297.1,48,256,48c-41.2,0-79.9,11.2-113.1,30.6l79.8,138.8\r\n\t\t\tC232.4,211.4,243.8,208,256,208z"},"children":[]}]},{"name":"path","attribs":{"d":"M192,272H32c0,83.3,46.9,153.4,114.4,192l78.2-136.3C205.1,316.7,192,295.9,192,272z"},"children":[{"name":"path","attribs":{"d":"M192,272H32c0,83.3,46.9,153.4,114.4,192l78.2-136.3C205.1,316.7,192,295.9,192,272z"},"children":[]}]}]}]}]}]};exports.nuclear=nuclear;var outlet={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M369.541,32H142.359C81.521,32,32,82.574,32,144.604v222.79C32,429.426,81.521,480,142.359,480h227.182\r\n\t\tC430.479,480,480,429.426,480,367.395v-222.79C480,82.574,430.479,32,369.541,32z M175,250.954v0.67\r\n\t\tc0,10.882-9.09,20.376-19.875,20.376h-23.27C121.073,272,112,262.506,112,251.624v-0.67V149.512v-1.351\r\n\t\tc1-10.768,9.193-20.161,19.855-20.161h23.27c10.886,0,19.875,9.847,19.875,20.831V250.954z M297,395.74v2.68\r\n\t\tc0,11.439-8.872,17.58-20.1,17.58H256h-20.898C223.872,416,215,407.859,215,396.42v-0.68v-28.637\r\n\t\tc0-23.33,18.118-42.287,40.999-42.287c22.883,0,41.001,18.957,41.001,42.287V395.74z M400,250.954v0.67\r\n\t\tc0,10.882-9.071,20.376-19.855,20.376h-24.27C345.093,272,336,262.506,336,251.624v-0.67V149.512v-1.351\r\n\t\tc1-10.768,9.215-20.161,19.875-20.161h24.27c10.784,0,19.855,9.847,19.855,20.831V250.954z"},"children":[{"name":"path","attribs":{"d":"M369.541,32H142.359C81.521,32,32,82.574,32,144.604v222.79C32,429.426,81.521,480,142.359,480h227.182\r\n\t\tC430.479,480,480,429.426,480,367.395v-222.79C480,82.574,430.479,32,369.541,32z M175,250.954v0.67\r\n\t\tc0,10.882-9.09,20.376-19.875,20.376h-23.27C121.073,272,112,262.506,112,251.624v-0.67V149.512v-1.351\r\n\t\tc1-10.768,9.193-20.161,19.855-20.161h23.27c10.886,0,19.875,9.847,19.875,20.831V250.954z M297,395.74v2.68\r\n\t\tc0,11.439-8.872,17.58-20.1,17.58H256h-20.898C223.872,416,215,407.859,215,396.42v-0.68v-28.637\r\n\t\tc0-23.33,18.118-42.287,40.999-42.287c22.883,0,41.001,18.957,41.001,42.287V395.74z M400,250.954v0.67\r\n\t\tc0,10.882-9.071,20.376-19.855,20.376h-24.27C345.093,272,336,262.506,336,251.624v-0.67V149.512v-1.351\r\n\t\tc1-10.768,9.215-20.161,19.875-20.161h24.27c10.784,0,19.855,9.847,19.855,20.831V250.954z"},"children":[]}]}]}]};exports.outlet=outlet;var paintbrush={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M149.515,283.349c-51.921,0-83.939,45.661-83.939,95.085c0,22.691-10.071,39.153-33.575,48.104\r\n\t\tc17.907,34.678,87.777,41.157,117.515,35.797c35.642-6.426,80.077-24.873,90.654-76.969\r\n\t\tC252.48,324.739,201.434,283.349,149.515,283.349z"},"children":[{"name":"path","attribs":{"d":"M149.515,283.349c-51.921,0-83.939,45.661-83.939,95.085c0,22.691-10.071,39.153-33.575,48.104\r\n\t\tc17.907,34.678,87.777,41.157,117.515,35.797c35.642-6.426,80.077-24.873,90.654-76.969\r\n\t\tC252.48,324.739,201.434,283.349,149.515,283.349z"},"children":[]}]},{"name":"path","attribs":{"d":"M467.638,60.356c-12.955-12.948-29.964-17.292-44.92-5.35L247.598,209.1c-8.648-2.371-16.525-1.869-22.909,2.346\r\n\t\tL165.896,260.4c-1.611,1.611-1.545,4.304,0.066,5.914c0.499,0.501,1.064,0.79,1.697,0.98c0.642,0.034,1.264,0.059,1.899,0.103\r\n\t\tc0.019-0.002,0.036-0.01,0.054-0.014c47.938,3.432,91.034,36.754,89.3,89.506c-0.016,0.505-0.029,1.007-0.054,1.516\r\n\t\tc0.123,0.848,0.5,1.664,1.149,2.315c1.595,1.593,4.168,1.605,5.781,0.044c0.018-0.018,0.037-0.027,0.055-0.044\r\n\t\tc0.063-0.063,0.106-0.137,0.164-0.2l50.457-57.342c4.216-6.374,4.72-14.24,2.355-22.875l154.169-175.047\r\n\t\tC484.939,90.308,480.592,73.308,467.638,60.356z"},"children":[{"name":"path","attribs":{"d":"M467.638,60.356c-12.955-12.948-29.964-17.292-44.92-5.35L247.598,209.1c-8.648-2.371-16.525-1.869-22.909,2.346\r\n\t\tL165.896,260.4c-1.611,1.611-1.545,4.304,0.066,5.914c0.499,0.501,1.064,0.79,1.697,0.98c0.642,0.034,1.264,0.059,1.899,0.103\r\n\t\tc0.019-0.002,0.036-0.01,0.054-0.014c47.938,3.432,91.034,36.754,89.3,89.506c-0.016,0.505-0.029,1.007-0.054,1.516\r\n\t\tc0.123,0.848,0.5,1.664,1.149,2.315c1.595,1.593,4.168,1.605,5.781,0.044c0.018-0.018,0.037-0.027,0.055-0.044\r\n\t\tc0.063-0.063,0.106-0.137,0.164-0.2l50.457-57.342c4.216-6.374,4.72-14.24,2.355-22.875l154.169-175.047\r\n\t\tC484.939,90.308,480.592,73.308,467.638,60.356z"},"children":[]}]},{"name":"polygon","attribs":{"points":"165.887,260.409 165.896,260.4 165.888,260.407 \t"},"children":[{"name":"polygon","attribs":{"points":"165.887,260.409 165.896,260.4 165.888,260.407 \t"},"children":[]}]}]}]};exports.paintbrush=paintbrush;var paintbucket={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,64l39.667,72.102L16,288l197.604,192l163.328-160l58.33-12.307L160,32L128,64z M325.131,288H104.857L215,177.863\r\n\t\tL325.131,288z"},"children":[{"name":"path","attribs":{"d":"M128,64l39.667,72.102L16,288l197.604,192l163.328-160l58.33-12.307L160,32L128,64z M325.131,288H104.857L215,177.863\r\n\t\tL325.131,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M435.262,307.693c0,0-60.734,66.179-60.732,99.207c0,33.028,27.192,59.803,60.731,59.801\r\n\t\tc33.548,0.002,60.74-26.772,60.739-59.801C496.001,373.872,435.262,307.693,435.262,307.693z"},"children":[{"name":"path","attribs":{"d":"M435.262,307.693c0,0-60.734,66.179-60.732,99.207c0,33.028,27.192,59.803,60.731,59.801\r\n\t\tc33.548,0.002,60.74-26.772,60.739-59.801C496.001,373.872,435.262,307.693,435.262,307.693z"},"children":[]}]}]}]};exports.paintbucket=paintbucket;var paperAirplane={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M32,272l128,48l16,160l80-112l112,112L480,32L32,272z M350.7,417.4L256,320l128-176L192,297.8l-82.6-31\r\n\tl322-172.5L350.7,417.4z"},"children":[]}]};exports.paperAirplane=paperAirplane;var paperclip={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M324.6,154.9c-6.3-0.1-11.4,5.1-11.4,11.6L313,361.3c-0.1,43.8-29.7,63.4-57.2,63.2c-27.5-0.3-57.1-20.4-57-64.1\r\n\tc0-33.5,0.2-167.7,0.3-234.8c0-15.4,6-27.4,16.8-33.7c10.6-6.2,24.4-6.1,35,0.3c10.8,6.5,16.7,18.6,16.7,34l-0.3,224.5\r\n\tc0,7.3-1.7,13.3-4.7,17.1c-1.9,2.4-4.4,3.8-6.9,3.8c-5.6-0.1-11.4-7.3-11.3-20.8c0,0,0.2-166.3,0.3-172.7c0-6.5-5.1-11.8-11.4-11.8\r\n\tc-6.3,0-11.4,5.2-11.4,11.7l-0.3,172.7c0,29,17.2,44.3,34.2,44.5c9.4,0.1,18.3-4.4,24.6-12.4c6.3-8,9.7-19,9.7-31.8l0.3-224.5\r\n\tc0-23.8-10.2-43.6-28.1-54.3c-17.5-10.6-40.3-10.8-57.9-0.5c-17.9,10.5-28.2,30.1-28.3,53.9c-0.1,67-0.2,201.2-0.3,234.8\r\n\tc-0.1,57.2,40.1,87.4,79.8,87.8c20.5,0.2,41.1-7.7,56.3-23.1c14.2-14.5,23.7-35.7,23.7-63.4l0.1-194.9\r\n\tC336,160.2,330.9,154.9,324.6,154.9z"},"children":[]}]};exports.paperclip=paperclip;var pause={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M224,435.8V76.1c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6\r\n\t\tC218.6,448,224,442.6,224,435.8z"},"children":[{"name":"path","attribs":{"d":"M224,435.8V76.1c0-6.7-5.4-12.1-12.2-12.1h-71.6c-6.8,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6\r\n\t\tC218.6,448,224,442.6,224,435.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M371.8,64h-71.6c-6.7,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6c6.7,0,12.2-5.4,12.2-12.2V76.1\r\n\t\tC384,69.4,378.6,64,371.8,64z"},"children":[{"name":"path","attribs":{"d":"M371.8,64h-71.6c-6.7,0-12.2,5.4-12.2,12.1v359.7c0,6.7,5.4,12.2,12.2,12.2h71.6c6.7,0,12.2-5.4,12.2-12.2V76.1\r\n\t\tC384,69.4,378.6,64,371.8,64z"},"children":[]}]}]}]};exports.pause=pause;var personAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"429,328 429,277 480,277 480,235 429,235 429,184 387,184 387,235 336,235 336,277 387,277 387,328 \t"},"children":[{"name":"polygon","attribs":{"points":"429,328 429,277 480,277 480,235 429,235 429,184 387,184 387,235 336,235 336,277 387,277 387,328 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M416,448c0,0,0-26.4-2.2-40.2c-1.8-10.9-16.9-25.3-81.1-48.9c-63.2-23.2-59.3-11.9-59.3-54.6c0-27.7,14.1-11.6,23.1-64.2\r\n\t\tc3.5-20.7,6.3-6.9,13.9-40.1c4-17.4-2.7-18.7-1.9-27c0.8-8.3,1.6-15.7,3.1-32.7C313.4,119.3,293.9,64,224,64\r\n\t\tc-69.9,0-89.4,55.3-87.5,76.4c1.5,16.9,2.3,24.4,3.1,32.7c0.8,8.3-5.9,9.6-1.9,27c7.6,33.1,10.4,19.3,13.9,40.1\r\n\t\tc9,52.6,23.1,36.5,23.1,64.2c0,42.8,3.9,31.5-59.3,54.6c-64.2,23.5-79.4,38-81.1,48.9C32,421.6,32,448,32,448h192H416z"},"children":[{"name":"path","attribs":{"d":"M416,448c0,0,0-26.4-2.2-40.2c-1.8-10.9-16.9-25.3-81.1-48.9c-63.2-23.2-59.3-11.9-59.3-54.6c0-27.7,14.1-11.6,23.1-64.2\r\n\t\tc3.5-20.7,6.3-6.9,13.9-40.1c4-17.4-2.7-18.7-1.9-27c0.8-8.3,1.6-15.7,3.1-32.7C313.4,119.3,293.9,64,224,64\r\n\t\tc-69.9,0-89.4,55.3-87.5,76.4c1.5,16.9,2.3,24.4,3.1,32.7c0.8,8.3-5.9,9.6-1.9,27c7.6,33.1,10.4,19.3,13.9,40.1\r\n\t\tc9,52.6,23.1,36.5,23.1,64.2c0,42.8,3.9,31.5-59.3,54.6c-64.2,23.5-79.4,38-81.1,48.9C32,421.6,32,448,32,448h192H416z"},"children":[]}]}]}]};exports.personAdd=personAdd;var personStalker={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M425.3,324.8c-41.4-15.7-38.9-9.4-38.9-38.5c0-18.8,9.3-11.9,15.2-47.7c2.3-14.1,4.2-4.7,9.1-27.3\r\n\t\tc2.6-11.8-1.8-12.7-1.2-18.3c0.5-5.6,1-10.7,2-22.2c1.2-14.4-11.6-52-57.4-52c-45.8,0-58.6,37.6-57.4,52c0.9,11.6,1.5,16.6,2,22.2\r\n\t\tc0.5,5.6-3.8,6.5-1.2,18.3c4.9,22.6,6.8,13.1,9.1,27.3c5.9,35.8,15.1,29,15.1,47.7c0,13.4,3.1,19-14.9,27.5\r\n\t\tc5.4,1.9,11.7,4.2,19.3,7.1c54.4,20.7,53.1,40.8,54.5,50.3c1,6.5,1.5,58.3,1.7,76.8H480c0,0,0-80.5-1.5-89.9\r\n\t\tC477.4,350.7,467.5,340.9,425.3,324.8z"},"children":[{"name":"path","attribs":{"d":"M425.3,324.8c-41.4-15.7-38.9-9.4-38.9-38.5c0-18.8,9.3-11.9,15.2-47.7c2.3-14.1,4.2-4.7,9.1-27.3\r\n\t\tc2.6-11.8-1.8-12.7-1.2-18.3c0.5-5.6,1-10.7,2-22.2c1.2-14.4-11.6-52-57.4-52c-45.8,0-58.6,37.6-57.4,52c0.9,11.6,1.5,16.6,2,22.2\r\n\t\tc0.5,5.6-3.8,6.5-1.2,18.3c4.9,22.6,6.8,13.1,9.1,27.3c5.9,35.8,15.1,29,15.1,47.7c0,13.4,3.1,19-14.9,27.5\r\n\t\tc5.4,1.9,11.7,4.2,19.3,7.1c54.4,20.7,53.1,40.8,54.5,50.3c1,6.5,1.5,58.3,1.7,76.8H480c0,0,0-80.5-1.5-89.9\r\n\t\tC477.4,350.7,467.5,340.9,425.3,324.8z"},"children":[]}]},{"name":"path","attribs":{"d":"M357,448c0,0,0-14.1-0.2-30.4c-0.2-18.6-0.7-40-1.7-46.4c-1.5-9.5-14.3-22.2-68.6-42.9c-7.5-2.8-13.8-5.1-19.3-7.1\r\n\t\tc-33.3-11.8-30.9-15.7-30.9-48c0-24.3,12-8.5,19.6-54.6c3-18.2,5.4-6.1,11.7-35.2c3.4-15.2-2.3-16.4-1.6-23.7\r\n\t\tc0.7-7.3,1.4-13.8,2.6-28.7c1.6-18.5-14.9-67.1-74.1-67.1c-59.2,0-75.6,48.5-74.1,67.1c1.2,14.9,1.9,21.4,2.7,28.7\r\n\t\tc0.7,7.3-5,8.4-1.6,23.7c6.4,29.1,8.8,17,11.8,35.2c7.6,46.1,19.5,30.3,19.5,54.6c0,37.6,3.3,34.8-50.2,55.1\r\n\t\tc-54.3,20.7-67.1,33.4-68.6,42.9C32,383.3,32,448,32,448h162.5H357z"},"children":[{"name":"path","attribs":{"d":"M357,448c0,0,0-14.1-0.2-30.4c-0.2-18.6-0.7-40-1.7-46.4c-1.5-9.5-14.3-22.2-68.6-42.9c-7.5-2.8-13.8-5.1-19.3-7.1\r\n\t\tc-33.3-11.8-30.9-15.7-30.9-48c0-24.3,12-8.5,19.6-54.6c3-18.2,5.4-6.1,11.7-35.2c3.4-15.2-2.3-16.4-1.6-23.7\r\n\t\tc0.7-7.3,1.4-13.8,2.6-28.7c1.6-18.5-14.9-67.1-74.1-67.1c-59.2,0-75.6,48.5-74.1,67.1c1.2,14.9,1.9,21.4,2.7,28.7\r\n\t\tc0.7,7.3-5,8.4-1.6,23.7c6.4,29.1,8.8,17,11.8,35.2c7.6,46.1,19.5,30.3,19.5,54.6c0,37.6,3.3,34.8-50.2,55.1\r\n\t\tc-54.3,20.7-67.1,33.4-68.6,42.9C32,383.3,32,448,32,448h162.5H357z"},"children":[]}]}]}]};exports.personStalker=personStalker;var person={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,448c0,0,0-26.4-2.2-40.2c-1.8-10.9-16.9-25.3-81.1-48.9c-63.2-23.2-59.3-11.9-59.3-54.6c0-27.7,14.1-11.6,23.1-64.2\r\n\tc3.5-20.7,6.3-6.9,13.9-40.1c4-17.4-2.7-18.7-1.9-27c0.8-8.3,1.6-15.7,3.1-32.7C345.4,119.3,325.9,64,256,64\r\n\tc-69.9,0-89.4,55.3-87.5,76.4c1.5,16.9,2.3,24.4,3.1,32.7c0.8,8.3-5.9,9.6-1.9,27c7.6,33.1,10.4,19.3,13.9,40.1\r\n\tc9,52.6,23.1,36.5,23.1,64.2c0,42.8,3.9,31.5-59.3,54.6c-64.2,23.5-79.4,38-81.1,48.9C64,421.6,64,448,64,448h192H448z"},"children":[]}]};exports.person=person;var pieGraph={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32.6,256h32H256V64.6v-32c-5-0.4-10.6-0.6-16-0.6C125.1,32,32,125.1,32,240C32,245.4,32.2,251,32.6,256z"},"children":[{"name":"path","attribs":{"d":"M32.6,256h32H256V64.6v-32c-5-0.4-10.6-0.6-16-0.6C125.1,32,32,125.1,32,240C32,245.4,32.2,251,32.6,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M109.8,402.2C147.9,449.6,206.4,480,272,480c114.9,0,208-93.1,208-208c0-65.6-30.4-124.1-77.8-162.2\r\n\t\tC370.5,84.3,331,67.9,288,64.6V288H64.6C67.9,331,84.3,370.5,109.8,402.2z"},"children":[{"name":"path","attribs":{"d":"M109.8,402.2C147.9,449.6,206.4,480,272,480c114.9,0,208-93.1,208-208c0-65.6-30.4-124.1-77.8-162.2\r\n\t\tC370.5,84.3,331,67.9,288,64.6V288H64.6C67.9,331,84.3,370.5,109.8,402.2z"},"children":[]}]}]}]};exports.pieGraph=pieGraph;var pin={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M331.8,228C331.8,228,331.8,228,331.8,228c-1.2-0.5-2.4-1-3.5-1.7c-7-4-12.2-10.9-13.9-19.2L295.9,89.4l-0.2-5.8\r\n\tc0-7.1,4.1-10.2,10-13l0,0c0.7-0.3,1.4-0.6,2.1-0.9c7.2-3.4,12.1-7.8,12.1-16.3c0-20.1-6.5-21.4-18.2-21.4h-91.3\r\n\tc-11.7,0-18.2,1.2-18.2,21.4c0,8.5,4.9,12.9,12.1,16.3c0.7,0.3,1.4,0.5,2.1,0.9c0,0,0,0,0,0c5.9,2.9,10,6,10,13l-0.2,5.8\r\n\tl-18.5,117.7c-1.7,8.3-6.9,15.2-13.9,19.2c-1.1,0.7-2.3,1.2-3.5,1.7c0,0,0,0,0,0c-19.7,10.2-36.2,30.8-36.2,54.7\r\n\tc0,15.9,3.5,21.3,15.2,21.3H240l12,176h8l12-176h80.8c11.7,0,15.2-4.7,15.2-21.3C368,258.8,351.5,238.2,331.8,228z"},"children":[]}]};exports.pin=pin;var pinpoint={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z\r\n\t M391.8,391.8c-32.5,32.5-74.6,51.9-119.8,55.6L264,384h-16l-7.9,63.3c-45.3-3.7-87.4-23.1-119.8-55.6\r\n\tc-32.5-32.5-51.9-74.6-55.6-119.8L128,264v-16l-63.3-7.9c3.7-45.3,23.1-87.4,55.6-119.8c32.5-32.5,74.6-51.9,119.8-55.6L248,128h16\r\n\tl7.9-63.3c45.3,3.7,87.4,23.1,119.8,55.6c32.5,32.5,51.9,74.6,55.6,119.8L384,248v16l63.3,7.9C443.6,317.2,424.2,359.3,391.8,391.8z\r\n\t"},"children":[]}]};exports.pinpoint=pinpoint;var pizza={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M394.619,130.445c-42.658-18.924-89.266-28.472-138.649-28.425c-49.373-0.047-99.27,10.262-138.641,27.979\r\n\t\tc-7.396,3.312-14.004,8.957-9.296,19.479S255.941,480,255.941,480l147.621-329.874C406.452,143.25,404.318,134.748,394.619,130.445\r\n\t\tz M191.983,192.015c-17.67,0-31.995-14.323-31.995-31.993c0-17.669,14.325-31.992,31.995-31.992\r\n\t\tc17.671,0,31.996,14.323,31.996,31.992C223.979,177.691,209.654,192.015,191.983,192.015z M255.975,338.981\r\n\t\tc-17.671,0-31.995-14.323-31.995-31.993s14.324-31.992,31.995-31.992c17.67,0,31.995,14.322,31.995,31.992\r\n\t\tS273.645,338.981,255.975,338.981z M319.965,224.007c-17.67,0-31.995-14.322-31.995-31.992s14.325-31.993,31.995-31.993\r\n\t\tc17.671,0,31.996,14.323,31.996,31.993S337.636,224.007,319.965,224.007z"},"children":[{"name":"path","attribs":{"d":"M394.619,130.445c-42.658-18.924-89.266-28.472-138.649-28.425c-49.373-0.047-99.27,10.262-138.641,27.979\r\n\t\tc-7.396,3.312-14.004,8.957-9.296,19.479S255.941,480,255.941,480l147.621-329.874C406.452,143.25,404.318,134.748,394.619,130.445\r\n\t\tz M191.983,192.015c-17.67,0-31.995-14.323-31.995-31.993c0-17.669,14.325-31.992,31.995-31.992\r\n\t\tc17.671,0,31.996,14.323,31.996,31.992C223.979,177.691,209.654,192.015,191.983,192.015z M255.975,338.981\r\n\t\tc-17.671,0-31.995-14.323-31.995-31.993s14.324-31.992,31.995-31.992c17.67,0,31.995,14.322,31.995,31.992\r\n\t\tS273.645,338.981,255.975,338.981z M319.965,224.007c-17.67,0-31.995-14.322-31.995-31.992s14.325-31.993,31.995-31.993\r\n\t\tc17.671,0,31.996,14.323,31.996,31.993S337.636,224.007,319.965,224.007z"},"children":[]}]},{"name":"path","attribs":{"d":"M421.79,66c-47.808-20.603-106.867-33.977-165.811-34c-58.931,0-116.944,12.136-165.82,33.446\r\n\t\tC85.83,67.334,80,71.016,80,79.227c0,2.523,0.907,4.922,0.907,4.922l7.98,19.194c2.531,4.865,7.944,8.18,13.798,8.18\r\n\t\tc1.645,0,3.936-0.331,6.65-1.476c44.9-18.929,94.471-29.588,146.644-29.564c52.175-0.023,105.63,11.64,146.634,29.561\r\n\t\tc3.296,1.44,5.173,1.472,6.663,1.472c6.009,0,11.158-3.274,13.727-8.053l8.04-19.342c0.577-1.558,0.957-3.287,0.957-4.768\r\n\t\tC432,72,427.614,68.51,421.79,66z"},"children":[{"name":"path","attribs":{"d":"M421.79,66c-47.808-20.603-106.867-33.977-165.811-34c-58.931,0-116.944,12.136-165.82,33.446\r\n\t\tC85.83,67.334,80,71.016,80,79.227c0,2.523,0.907,4.922,0.907,4.922l7.98,19.194c2.531,4.865,7.944,8.18,13.798,8.18\r\n\t\tc1.645,0,3.936-0.331,6.65-1.476c44.9-18.929,94.471-29.588,146.644-29.564c52.175-0.023,105.63,11.64,146.634,29.561\r\n\t\tc3.296,1.44,5.173,1.472,6.663,1.472c6.009,0,11.158-3.274,13.727-8.053l8.04-19.342c0.577-1.558,0.957-3.287,0.957-4.768\r\n\t\tC432,72,427.614,68.51,421.79,66z"},"children":[]}]}]}]};exports.pizza=pizza;var plane={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M281.7,311.9c0.4-6.9,8.3-4.5,8.3-4.5l62,12.6l128,48.7c0-24-3.8-26.5-9.4-30.7L288,207c0,0-4.9-60-4.9-112.9\r\n\tc0-24.5-11.8-78.1-27.1-78.1s-27.1,54.4-27.1,78.1c0,50.2-4.9,112.9-4.9,112.9L41.4,338c-7.1,5-9.4,7.7-9.4,30.7L160,320l61.9-12.6\r\n\tc0,0,7.9-2.4,8.3,4.5c0.4,6.9-1.2,69.1,5.9,102.1c0.9,4.4-2.5,4.7-4.8,7.4l-51.9,32.8c-1.7,1.9-2.5,7.3-2.5,7.3l-1,18.5l68-16l12,32\r\n\tl12-32l68,16l-1-18.5c0.1,0-0.7-5.4-2.4-7.3l-51.9-32.8c-2.3-2.7-5.7-3-4.8-7.4C282.7,381,281.3,318.8,281.7,311.9z"},"children":[]}]};exports.plane=plane;var planet={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M96.298,265.705C101.315,349.55,170.887,416,255.988,416c37.957,0,72.818-13.227,100.25-35.311\r\n\t\tC317.23,369.554,274,353.922,229.562,334.617C180.731,313.404,134.957,289.677,96.298,265.705z"},"children":[{"name":"path","attribs":{"d":"M96.298,265.705C101.315,349.55,170.887,416,255.988,416c37.957,0,72.818-13.227,100.25-35.311\r\n\t\tC317.23,369.554,274,353.922,229.562,334.617C180.731,313.404,134.957,289.677,96.298,265.705z"},"children":[]}]},{"name":"path","attribs":{"d":"M107.381,196.629c39.911,27.11,92.07,55.13,147.679,79.287c43.591,18.938,87.113,34.555,125.859,45.164\r\n\t\tc6.496,1.779,12.834,3.406,18.988,4.883c1.685-3.462,3.249-6.994,4.688-10.591c7.341-18.358,11.386-38.393,11.386-59.372\r\n\t\tc0-3.26-0.109-6.493-0.301-9.705C410.661,162.45,341.09,96,255.988,96c-37.956,0-72.817,13.227-100.248,35.311\r\n\t\tc-18.296,14.729-33.284,33.398-43.67,54.726C110.383,189.499,108.819,193.032,107.381,196.629z"},"children":[{"name":"path","attribs":{"d":"M107.381,196.629c39.911,27.11,92.07,55.13,147.679,79.287c43.591,18.938,87.113,34.555,125.859,45.164\r\n\t\tc6.496,1.779,12.834,3.406,18.988,4.883c1.685-3.462,3.249-6.994,4.688-10.591c7.341-18.358,11.386-38.393,11.386-59.372\r\n\t\tc0-3.26-0.109-6.493-0.301-9.705C410.661,162.45,341.09,96,255.988,96c-37.956,0-72.817,13.227-100.248,35.311\r\n\t\tc-18.296,14.729-33.284,33.398-43.67,54.726C110.383,189.499,108.819,193.032,107.381,196.629z"},"children":[]}]},{"name":"path","attribs":{"d":"M429.667,284.531c-1.256,11.562-2.377,13.627-5.891,24.695c16.878,12.039,31.032,23.706,41.137,33.938\r\n\t\tc3.285,3.328,5.875,6.225,7.912,8.702c-1.684,0.084-3.557,0.133-5.631,0.133c-21.886,0-54.026-5.5-90.501-15.488\r\n\t\tc-39.467-10.806-83.73-26.685-128.008-45.92c-58.931-25.6-114.158-55.541-155.51-84.307c-19.081-13.275-35.027-26.226-46.113-37.45\r\n\t\tc-3.285-3.328-5.875-6.225-7.912-8.702c1.683-0.084,3.556-0.133,5.632-0.133c15.308,0,35.637,2.694,58.952,7.729\r\n\t\tc5.825-10.004,6.979-12.701,14.663-21.409C92.663,137,66.625,130.522,44.784,128c-24.403-2.818-40.34,5.521-43.984,17.14\r\n\t\tC-10.274,180.457,95,258.718,235.936,319.942C330.498,361.022,417.104,384,467.194,384c24.565,0,40.338-5.521,43.982-17.141\r\n\t\tC517.516,346.643,486.965,320,429.667,284.531z"},"children":[{"name":"path","attribs":{"d":"M429.667,284.531c-1.256,11.562-2.377,13.627-5.891,24.695c16.878,12.039,31.032,23.706,41.137,33.938\r\n\t\tc3.285,3.328,5.875,6.225,7.912,8.702c-1.684,0.084-3.557,0.133-5.631,0.133c-21.886,0-54.026-5.5-90.501-15.488\r\n\t\tc-39.467-10.806-83.73-26.685-128.008-45.92c-58.931-25.6-114.158-55.541-155.51-84.307c-19.081-13.275-35.027-26.226-46.113-37.45\r\n\t\tc-3.285-3.328-5.875-6.225-7.912-8.702c1.683-0.084,3.556-0.133,5.632-0.133c15.308,0,35.637,2.694,58.952,7.729\r\n\t\tc5.825-10.004,6.979-12.701,14.663-21.409C92.663,137,66.625,130.522,44.784,128c-24.403-2.818-40.34,5.521-43.984,17.14\r\n\t\tC-10.274,180.457,95,258.718,235.936,319.942C330.498,361.022,417.104,384,467.194,384c24.565,0,40.338-5.521,43.982-17.141\r\n\t\tC517.516,346.643,486.965,320,429.667,284.531z"},"children":[]}]}]}]};exports.planet=planet;var play={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M405.2,232.9L126.8,67.2c-3.4-2-6.9-3.2-10.9-3.2c-10.9,0-19.8,9-19.8,20H96v344h0.1c0,11,8.9,20,19.8,20\r\n\tc4.1,0,7.5-1.4,11.2-3.4l278.1-165.5c6.6-5.5,10.8-13.8,10.8-23.1C416,246.7,411.8,238.5,405.2,232.9z"},"children":[]}]};exports.play=play;var playstation={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M399.8,203c-0.8-17.1-3.3-34.5-10.8-50.1c-4.1-8.6-9.7-16.5-16.5-23.2c-6.3-6.4-13.6-11.7-21.3-16.3\r\n\t\tc-17.1-10.2-37.5-17-84.4-31S192,64,192,64v358.3l79.9,25.7c0,0,0.1-198.8,0.1-299.5v-3.8c0-9.3,7.5-16.8,16.1-16.8h0.5\r\n\t\tc8.5,0,15.5,7.5,15.5,16.8v2.2v131.1c11,5.3,29.2,9.3,41.8,9.1c8.3,0.2,16.7-1.7,24-5.7c7.6-4.1,13.9-10.4,18.4-17.8\r\n\t\tc5.1-8.3,8.2-17.8,9.9-27.3C400.1,225.5,400.2,214.2,399.8,203z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M399.8,203c-0.8-17.1-3.3-34.5-10.8-50.1c-4.1-8.6-9.7-16.5-16.5-23.2c-6.3-6.4-13.6-11.7-21.3-16.3\r\n\t\tc-17.1-10.2-37.5-17-84.4-31S192,64,192,64v358.3l79.9,25.7c0,0,0.1-198.8,0.1-299.5v-3.8c0-9.3,7.5-16.8,16.1-16.8h0.5\r\n\t\tc8.5,0,15.5,7.5,15.5,16.8v2.2v131.1c11,5.3,29.2,9.3,41.8,9.1c8.3,0.2,16.7-1.7,24-5.7c7.6-4.1,13.9-10.4,18.4-17.8\r\n\t\tc5.1-8.3,8.2-17.8,9.9-27.3C400.1,225.5,400.2,214.2,399.8,203z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M86.7,357.8c27.4-9.8,89.3-29.5,89.3-29.5v-47.2c0,0-76.5,24.8-111.3,37.1c-8.6,3.1-17.3,5.9-25.7,9.5\r\n\t\tc-9.8,4.1-19.4,8.7-28.1,14.8c-3.8,2.6-7.2,5.9-9.2,10.1c-2,4.2-2.2,9.2-0.5,13.6c2,5.1,5.8,9.3,10.1,12.6\r\n\t\tc7.8,5.9,17.1,9.5,26.4,12.2c28.4,9.4,58.4,14,88.4,13.3c14.5-0.2,36-1.9,50-4.4v-42c0,0-11,2.5-41.3,12.5c-4.6,1.5-9.2,3.3-14,4.3\r\n\t\tc-7.1,1.6-14.4,2.1-21.6,2.2c-6.5-0.3-13.2-0.7-19.3-3.1c-2.2-1-4.6-2.2-5.5-4.6c-0.8-2,0.3-4,1.7-5.4\r\n\t\tC78.9,360.9,82.9,359.3,86.7,357.8z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M86.7,357.8c27.4-9.8,89.3-29.5,89.3-29.5v-47.2c0,0-76.5,24.8-111.3,37.1c-8.6,3.1-17.3,5.9-25.7,9.5\r\n\t\tc-9.8,4.1-19.4,8.7-28.1,14.8c-3.8,2.6-7.2,5.9-9.2,10.1c-2,4.2-2.2,9.2-0.5,13.6c2,5.1,5.8,9.3,10.1,12.6\r\n\t\tc7.8,5.9,17.1,9.5,26.4,12.2c28.4,9.4,58.4,14,88.4,13.3c14.5-0.2,36-1.9,50-4.4v-42c0,0-11,2.5-41.3,12.5c-4.6,1.5-9.2,3.3-14,4.3\r\n\t\tc-7.1,1.6-14.4,2.1-21.6,2.2c-6.5-0.3-13.2-0.7-19.3-3.1c-2.2-1-4.6-2.2-5.5-4.6c-0.8-2,0.3-4,1.7-5.4\r\n\t\tC78.9,360.9,82.9,359.3,86.7,357.8z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M512,345.9c-0.1-6-3.7-11.2-7.9-15c-7.1-6.3-15.9-10.3-24.7-13.5c-5.5-1.9-9.3-3.3-14.7-5\r\n\t\tc-25.2-8.2-51.9-11.2-78.3-11.3c-8,0.3-23.1,0.5-31,1.4c-21.9,2.5-67.3,15.4-67.3,15.4v48.8c0,0,67.5-21.6,96.5-31.8\r\n\t\tc9.7-3.3,20.1-4.6,30.3-4.6c6.5,0.2,13.2,0.7,19.4,3.1c2.2,0.9,4.5,2.2,5.5,4.5c0.9,2.6-0.9,5-2.9,6.5c-4.7,3.8-10.7,5.3-16.2,7.4\r\n\t\tC379.7,366.3,288,396.5,288,396.5v47c0,0,117.2-39.6,170.8-58.8c8.9-3.3,17.9-6.1,26.4-10.4c7.9-4,15.8-8.6,21.8-15.3\r\n\t\tC510.1,355.4,512,351,512,345.9z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M512,345.9c-0.1-6-3.7-11.2-7.9-15c-7.1-6.3-15.9-10.3-24.7-13.5c-5.5-1.9-9.3-3.3-14.7-5\r\n\t\tc-25.2-8.2-51.9-11.2-78.3-11.3c-8,0.3-23.1,0.5-31,1.4c-21.9,2.5-67.3,15.4-67.3,15.4v48.8c0,0,67.5-21.6,96.5-31.8\r\n\t\tc9.7-3.3,20.1-4.6,30.3-4.6c6.5,0.2,13.2,0.7,19.4,3.1c2.2,0.9,4.5,2.2,5.5,4.5c0.9,2.6-0.9,5-2.9,6.5c-4.7,3.8-10.7,5.3-16.2,7.4\r\n\t\tC379.7,366.3,288,396.5,288,396.5v47c0,0,117.2-39.6,170.8-58.8c8.9-3.3,17.9-6.1,26.4-10.4c7.9-4,15.8-8.6,21.8-15.3\r\n\t\tC510.1,355.4,512,351,512,345.9z"},"children":[]}]}]}]};exports.playstation=playstation;var plusCircled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M384,272H272v112h-32V272H128v-32\r\n\t\th112V128h32v112h112V272z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M384,272H272v112h-32V272H128v-32\r\n\t\th112V128h32v112h112V272z"},"children":[]}]}]}]};exports.plusCircled=plusCircled;var plusRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M417.4,224H288V94.6c0-16.9-14.3-30.6-32-30.6c-17.7,0-32,13.7-32,30.6V224H94.6C77.7,224,64,238.3,64,256\r\n\tc0,17.7,13.7,32,30.6,32H224v129.4c0,16.9,14.3,30.6,32,30.6c17.7,0,32-13.7,32-30.6V288h129.4c16.9,0,30.6-14.3,30.6-32\r\n\tC448,238.3,434.3,224,417.4,224z"},"children":[]}]};exports.plusRound=plusRound;var plus={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"448,224 288,224 288,64 224,64 224,224 64,224 64,288 224,288 224,448 288,448 288,288 448,288 "},"children":[]}]};exports.plus=plus;var podium={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"32","y":"256","width":"128","height":"192"},"children":[{"name":"rect","attribs":{"x":"32","y":"256","width":"128","height":"192"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"160","width":"128","height":"288"},"children":[{"name":"rect","attribs":{"x":"192","y":"160","width":"128","height":"288"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"320","width":"128","height":"128"},"children":[{"name":"rect","attribs":{"x":"352","y":"320","width":"128","height":"128"},"children":[]}]}]}]};exports.podium=podium;var pound={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M125.2,352.3H32v-54.6h101.2l13.1-83.3H47v-54.6h107.2L176,32h63.9l-21.8,127.7h105.6L345.5,32h63.1l-21.8,127.7H480v54.6\r\n\t\tH378.1l-12.3,83.3H465v54.6H358.5L336,480h-63.1l21.8-127.7H188.3L166.5,480h-63.1L125.2,352.3z M209.4,214.3L197,297.7h105.6\r\n\t\tl12.3-83.3H209.4z"},"children":[{"name":"path","attribs":{"d":"M125.2,352.3H32v-54.6h101.2l13.1-83.3H47v-54.6h107.2L176,32h63.9l-21.8,127.7h105.6L345.5,32h63.1l-21.8,127.7H480v54.6\r\n\t\tH378.1l-12.3,83.3H465v54.6H358.5L336,480h-63.1l21.8-127.7H188.3L166.5,480h-63.1L125.2,352.3z M209.4,214.3L197,297.7h105.6\r\n\t\tl12.3-83.3H209.4z"},"children":[]}]}]}]};exports.pound=pound;var power={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,256c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32s32,14.3,32,32v160C288,241.7,273.7,256,256,256z"},"children":[{"name":"path","attribs":{"d":"M256,256c-17.7,0-32-14.3-32-32V64c0-17.7,14.3-32,32-32s32,14.3,32,32v160C288,241.7,273.7,256,256,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M379,68.8L379,68.8c-5-3-10.8-4.8-17-4.8c-17.7,0-32,14.3-32,32c0,6.2,1.8,12,4.8,16.9c2,3.2,4.6,6.1,7.6,8.4\r\n\t\tc1.2,0.9,2.4,1.7,3.7,2.5c8.1,5.6,15.8,11.9,23,19.1C399.4,173.1,416,213.3,416,256c0,42.7-16.6,82.9-46.9,113.1\r\n\t\tC338.9,399.4,298.7,416,256,416c-42.7,0-82.9-16.6-113.1-46.9C112.6,338.9,96,298.7,96,256c0-42.7,16.6-82.9,46.9-113.1\r\n\t\tc7.1-7.1,14.8-13.5,22.9-19c1.4-0.8,2.6-1.6,3.9-2.6c3-2.3,5.5-5.1,7.5-8.3c3.1-4.9,4.8-10.7,4.8-16.9c0-17.7-14.3-32-32-32\r\n\t\tc-6.2,0-12,1.8-16.9,4.8l-0.1-0.1C72.2,108.8,32,177.7,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\tC480,177.7,439.8,108.8,379,68.8z"},"children":[{"name":"path","attribs":{"d":"M379,68.8L379,68.8c-5-3-10.8-4.8-17-4.8c-17.7,0-32,14.3-32,32c0,6.2,1.8,12,4.8,16.9c2,3.2,4.6,6.1,7.6,8.4\r\n\t\tc1.2,0.9,2.4,1.7,3.7,2.5c8.1,5.6,15.8,11.9,23,19.1C399.4,173.1,416,213.3,416,256c0,42.7-16.6,82.9-46.9,113.1\r\n\t\tC338.9,399.4,298.7,416,256,416c-42.7,0-82.9-16.6-113.1-46.9C112.6,338.9,96,298.7,96,256c0-42.7,16.6-82.9,46.9-113.1\r\n\t\tc7.1-7.1,14.8-13.5,22.9-19c1.4-0.8,2.6-1.6,3.9-2.6c3-2.3,5.5-5.1,7.5-8.3c3.1-4.9,4.8-10.7,4.8-16.9c0-17.7-14.3-32-32-32\r\n\t\tc-6.2,0-12,1.8-16.9,4.8l-0.1-0.1C72.2,108.8,32,177.7,32,256c0,123.7,100.3,224,224,224c123.7,0,224-100.3,224-224\r\n\t\tC480,177.7,439.8,108.8,379,68.8z"},"children":[]}]}]}]};exports.power=power;var pricetag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M471,261.4L471,261.4C471,261.4,471,261.4,471,261.4L260.9,49.8c0,0,0,0,0,0l-1.5-1.5c0,0-0.4,0-0.4,0\r\n\t\tc-8.3-7.9-17.9-12-29.9-12.3v0l-99.7-3.7l-4.4-0.2c-11.2,0.2-22.2,4.5-30.7,13.1L45.1,94.3c-9,9-13.1,20.9-13.1,32.7c0,0,0,0,0,0.1\r\n\t\tl0.3,4.2l6.7,97.3c0,0.1,0,0.2,0,0.2v1.9c0,0,0,0,0,0c1,8.7,4.5,17.3,10.4,24.4l5.5,5.4l206.3,208.8l3.1,3.1\r\n\t\tc11.9,10.5,30,10,41.3-1.4l165.4-166.6C482.8,292.6,483,273.3,471,261.4z M144,192c-26.5,0-48-21.5-48-48s21.5-48,48-48\r\n\t\ts48,21.5,48,48S170.5,192,144,192z"},"children":[{"name":"path","attribs":{"d":"M471,261.4L471,261.4C471,261.4,471,261.4,471,261.4L260.9,49.8c0,0,0,0,0,0l-1.5-1.5c0,0-0.4,0-0.4,0\r\n\t\tc-8.3-7.9-17.9-12-29.9-12.3v0l-99.7-3.7l-4.4-0.2c-11.2,0.2-22.2,4.5-30.7,13.1L45.1,94.3c-9,9-13.1,20.9-13.1,32.7c0,0,0,0,0,0.1\r\n\t\tl0.3,4.2l6.7,97.3c0,0.1,0,0.2,0,0.2v1.9c0,0,0,0,0,0c1,8.7,4.5,17.3,10.4,24.4l5.5,5.4l206.3,208.8l3.1,3.1\r\n\t\tc11.9,10.5,30,10,41.3-1.4l165.4-166.6C482.8,292.6,483,273.3,471,261.4z M144,192c-26.5,0-48-21.5-48-48s21.5-48,48-48\r\n\t\ts48,21.5,48,48S170.5,192,144,192z"},"children":[]}]}]}]};exports.pricetag=pricetag;var pricetags={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M472,239.2L472,239.2C472,239.2,471.9,239.2,472,239.2L282.1,48.1c0,0,0,0,0,0l-1.4-1.4c0,0-0.5,0-0.5,0\r\n\t\tc-7.5-7.2-16.1-10.9-27.1-11.1v0l-89.9-3.3l-3.9-0.1c-10.1,0.1-20,4.1-27.7,11.8l-27.1,27.2c7.4-6.6,16.6-10,26-10.1l3.8,0.1\r\n\t\tl89.8,3.3v0c11,0.2,19.7,3.9,27.2,11.1c0,0,0.4,0,0.5,0l1.4,1.4c0,0,0,0,0,0L443,268.1c0,0,0,0,0,0v0c10,10.8,10.7,28.2,0,38.9\r\n\t\tl29-28.9C482.6,267.4,482,250,472,239.2z"},"children":[{"name":"path","attribs":{"d":"M472,239.2L472,239.2C472,239.2,471.9,239.2,472,239.2L282.1,48.1c0,0,0,0,0,0l-1.4-1.4c0,0-0.5,0-0.5,0\r\n\t\tc-7.5-7.2-16.1-10.9-27.1-11.1v0l-89.9-3.3l-3.9-0.1c-10.1,0.1-20,4.1-27.7,11.8l-27.1,27.2c7.4-6.6,16.6-10,26-10.1l3.8,0.1\r\n\t\tl89.8,3.3v0c11,0.2,19.7,3.9,27.2,11.1c0,0,0.4,0,0.5,0l1.4,1.4c0,0,0,0,0,0L443,268.1c0,0,0,0,0,0v0c10,10.8,10.7,28.2,0,38.9\r\n\t\tl29-28.9C482.6,267.4,482,250,472,239.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M428,282.5c0,0,0.3,0,0.3,0L238.6,91.4c0,0,0,0,0,0l-1.3-1.4c0,0-0.3,0-0.3,0c-7.5-7.2-15.9-10.9-26.9-11.1v0l-90.1-3.3\r\n\t\tl-4-0.1c-9.2,0.1-18.2,3.4-25.6,9.8c-0.3,0.3-0.7,0.6-1,0.9c-0.4,0.4-0.8,0.8-1.2,1.2l-44.3,44.5c-8.1,8.1-11.9,18.9-11.9,29.5\r\n\t\tc0,0,0,0,0,0.1l0.1,3.8l5.9,87.9c0,0.1,0,0.1,0,0.2v1.7c0,0,0,0,0,0c1,7.9,4.2,15.6,9.6,22l5.1,4.9L239,470.4l2.8,2.8\r\n\t\tc10.7,9.4,27.1,9,37.3-1.3l13.1-13.2c0.5-0.4,0.9-0.8,1.4-1.3l26.9-27c-0.2,0.1-0.3,0.2-0.5,0.4l108.3-109.3\r\n\t\tC438.9,310.8,439,293.3,428,282.5L428,282.5z M110.6,139.5c6.6-4,14.3-6.3,22.6-6.3c23.9,0,43.4,19.4,43.4,43.4\r\n\t\tc0,8.3-2.3,16-6.3,22.6c-7.6,12.5-21.3,20.8-37,20.8c-23.9,0-43.4-19.4-43.4-43.4C89.8,160.8,98.1,147.1,110.6,139.5z"},"children":[{"name":"path","attribs":{"d":"M428,282.5c0,0,0.3,0,0.3,0L238.6,91.4c0,0,0,0,0,0l-1.3-1.4c0,0-0.3,0-0.3,0c-7.5-7.2-15.9-10.9-26.9-11.1v0l-90.1-3.3\r\n\t\tl-4-0.1c-9.2,0.1-18.2,3.4-25.6,9.8c-0.3,0.3-0.7,0.6-1,0.9c-0.4,0.4-0.8,0.8-1.2,1.2l-44.3,44.5c-8.1,8.1-11.9,18.9-11.9,29.5\r\n\t\tc0,0,0,0,0,0.1l0.1,3.8l5.9,87.9c0,0.1,0,0.1,0,0.2v1.7c0,0,0,0,0,0c1,7.9,4.2,15.6,9.6,22l5.1,4.9L239,470.4l2.8,2.8\r\n\t\tc10.7,9.4,27.1,9,37.3-1.3l13.1-13.2c0.5-0.4,0.9-0.8,1.4-1.3l26.9-27c-0.2,0.1-0.3,0.2-0.5,0.4l108.3-109.3\r\n\t\tC438.9,310.8,439,293.3,428,282.5L428,282.5z M110.6,139.5c6.6-4,14.3-6.3,22.6-6.3c23.9,0,43.4,19.4,43.4,43.4\r\n\t\tc0,8.3-2.3,16-6.3,22.6c-7.6,12.5-21.3,20.8-37,20.8c-23.9,0-43.4-19.4-43.4-43.4C89.8,160.8,98.1,147.1,110.6,139.5z"},"children":[]}]}]}]};exports.pricetags=pricetags;var printer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M423.8,128H384V64H128v64H88.2C60.3,128,32,144.9,32,182.6v123.8c0,38,28.3,61.6,56.2,61.6c0,0,30.4,0,39.8,0v112h5h11h224\r\n\t\th8h8V368c10.3,0,39.8,0,39.8,0c27.9,0,56.2-22.6,56.2-53.6V182.6C480,146.9,451.8,128,423.8,128z M368,464H144V288h224V464z\r\n\t\t M368,128H144V80h224V128z M416,192h-17v-16h17V192z"},"children":[{"name":"path","attribs":{"d":"M423.8,128H384V64H128v64H88.2C60.3,128,32,144.9,32,182.6v123.8c0,38,28.3,61.6,56.2,61.6c0,0,30.4,0,39.8,0v112h5h11h224\r\n\t\th8h8V368c10.3,0,39.8,0,39.8,0c27.9,0,56.2-22.6,56.2-53.6V182.6C480,146.9,451.8,128,423.8,128z M368,464H144V288h224V464z\r\n\t\t M368,128H144V80h224V128z M416,192h-17v-16h17V192z"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"320","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"320","width":"192","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"368","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"368","width":"192","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"416","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"416","width":"192","height":"16"},"children":[]}]}]}]};exports.printer=printer;var pullRequest={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,64c-35.29,0-64,28.71-64,64c0,23.637,12.89,44.307,32,55.391v177.219C76.89,371.693,64,392.363,64,416\r\n\t\tc0,35.29,28.71,64,64,64s64-28.71,64-64c0-23.637-12.89-44.307-32-55.391V183.391c19.11-11.084,32-31.754,32-55.391\r\n\t\tC192,92.71,163.29,64,128,64z M128,448c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,448,128,448z M128,160\r\n\t\tc-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,160,128,160z"},"children":[{"name":"path","attribs":{"d":"M128,64c-35.29,0-64,28.71-64,64c0,23.637,12.89,44.307,32,55.391v177.219C76.89,371.693,64,392.363,64,416\r\n\t\tc0,35.29,28.71,64,64,64s64-28.71,64-64c0-23.637-12.89-44.307-32-55.391V183.391c19.11-11.084,32-31.754,32-55.391\r\n\t\tC192,92.71,163.29,64,128,64z M128,448c-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,448,128,448z M128,160\r\n\t\tc-17.673,0-32-14.327-32-32s14.327-32,32-32s32,14.327,32,32S145.673,160,128,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M415,360.034V204.989c0-33.987-10.49-61.002-31.18-80.294c-22.111-20.618-54.314-30.388-95.82-29.106V32l-96,96l96,96v-64\r\n\t\tc26.5,0,42.67,2.642,52.175,11.504c7.183,6.698,10.825,17.964,10.825,33.485v156.196c-18.562,11.217-31,31.589-31,54.814\r\n\t\tc0,35.29,28.71,64,64,64s64-28.71,64-64C448,391.951,434.662,370.969,415,360.034z M384,448c-17.673,0-32-14.327-32-32\r\n\t\ts14.327-32,32-32s32,14.327,32,32S401.673,448,384,448z"},"children":[{"name":"path","attribs":{"d":"M415,360.034V204.989c0-33.987-10.49-61.002-31.18-80.294c-22.111-20.618-54.314-30.388-95.82-29.106V32l-96,96l96,96v-64\r\n\t\tc26.5,0,42.67,2.642,52.175,11.504c7.183,6.698,10.825,17.964,10.825,33.485v156.196c-18.562,11.217-31,31.589-31,54.814\r\n\t\tc0,35.29,28.71,64,64,64s64-28.71,64-64C448,391.951,434.662,370.969,415,360.034z M384,448c-17.673,0-32-14.327-32-32\r\n\t\ts14.327-32,32-32s32,14.327,32,32S401.673,448,384,448z"},"children":[]}]}]}]};exports.pullRequest=pullRequest;var qrScanner={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M96,124.171c0-6.938,5.232-12.171,12.171-12.171H176V64h-66.829C75.717,64,48,90.717,48,124.171V192h48V124.171z"},"children":[{"name":"path","attribs":{"d":"M96,124.171c0-6.938,5.232-12.171,12.171-12.171H176V64h-66.829C75.717,64,48,90.717,48,124.171V192h48V124.171z"},"children":[]}]},{"name":"path","attribs":{"d":"M403.579,64H336v48h67.219c6.938,0,12.781,5.232,12.781,12.171V192h48v-67.829C464,90.717,437.033,64,403.579,64z"},"children":[{"name":"path","attribs":{"d":"M403.579,64H336v48h67.219c6.938,0,12.781,5.232,12.781,12.171V192h48v-67.829C464,90.717,437.033,64,403.579,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M416,386.829c0,6.938-5.232,12.171-12.171,12.171H336v49h67.829C437.283,448,464,420.283,464,386.829V320h-48V386.829z"},"children":[{"name":"path","attribs":{"d":"M416,386.829c0,6.938-5.232,12.171-12.171,12.171H336v49h67.829C437.283,448,464,420.283,464,386.829V320h-48V386.829z"},"children":[]}]},{"name":"path","attribs":{"d":"M108.171,399C101.232,399,96,393.768,96,386.829V320H48v66.829C48,420.283,75.717,448,109.171,448H176v-49H108.171z"},"children":[{"name":"path","attribs":{"d":"M108.171,399C101.232,399,96,393.768,96,386.829V320H48v66.829C48,420.283,75.717,448,109.171,448H176v-49H108.171z"},"children":[]}]}]}]};exports.qrScanner=qrScanner;var quote={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M192,64c-40.646,0-72.483,11.229-94.627,33.373C75.229,119.517,64,151.354,64,192v256h160V192h-96\r\n\t\t\tc0-23.056,4.922-39.666,14.627-49.373C152.334,132.922,168.944,128,192,128"},"children":[{"name":"path","attribs":{"d":"M192,64c-40.646,0-72.483,11.229-94.627,33.373C75.229,119.517,64,151.354,64,192v256h160V192h-96\r\n\t\t\tc0-23.056,4.922-39.666,14.627-49.373C152.334,132.922,168.944,128,192,128"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,64c-40.646,0-72.483,11.229-94.627,33.373C299.229,119.517,288,151.354,288,192v256h160V192h-96\r\n\t\t\tc0-23.056,4.922-39.666,14.627-49.373C376.334,132.922,392.944,128,416,128"},"children":[{"name":"path","attribs":{"d":"M416,64c-40.646,0-72.483,11.229-94.627,33.373C299.229,119.517,288,151.354,288,192v256h160V192h-96\r\n\t\t\tc0-23.056,4.922-39.666,14.627-49.373C376.334,132.922,392.944,128,416,128"},"children":[]}]}]}]}]}]};exports.quote=quote;var radioWaves={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"256","r":"64"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"256","r":"64"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,256c0-36.9,18.553-69.208,46.314-87.034l-23.141-24.512c-6.26,4.608-12.18,9.833-17.684,15.663\r\n\t\t\tC125.314,185.729,112,219.781,112,256c0,36.219,13.314,70.271,37.49,95.883c5.504,5.829,11.424,11.055,17.684,15.662\r\n\t\t\tl23.141-24.511C162.553,325.208,144,292.9,144,256z"},"children":[{"name":"path","attribs":{"d":"M144,256c0-36.9,18.553-69.208,46.314-87.034l-23.141-24.512c-6.26,4.608-12.18,9.833-17.684,15.663\r\n\t\t\tC125.314,185.729,112,219.781,112,256c0,36.219,13.314,70.271,37.49,95.883c5.504,5.829,11.424,11.055,17.684,15.662\r\n\t\t\tl23.141-24.511C162.553,325.208,144,292.9,144,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,256c0,36.9-18.553,69.208-46.314,87.034l23.141,24.511c6.26-4.607,12.18-9.833,17.684-15.662\r\n\t\t\tC386.686,326.271,400,292.219,400,256c0-36.219-13.314-70.271-37.49-95.882c-5.504-5.83-11.424-11.055-17.684-15.663\r\n\t\t\tl-23.141,24.512C349.447,186.792,368,219.1,368,256z"},"children":[{"name":"path","attribs":{"d":"M368,256c0,36.9-18.553,69.208-46.314,87.034l23.141,24.511c6.26-4.607,12.18-9.833,17.684-15.662\r\n\t\t\tC386.686,326.271,400,292.219,400,256c0-36.219-13.314-70.271-37.49-95.882c-5.504-5.83-11.424-11.055-17.684-15.663\r\n\t\t\tl-23.141,24.512C349.447,186.792,368,219.1,368,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,256c0-55.578,25.251-104.907,64.263-135.817L105.433,96c-5.999,5-11.739,10.396-17.197,16.178\r\n\t\t\tc-17.622,18.669-31.462,40.417-41.134,64.641C37.081,201.917,32,228.556,32,256c0,27.443,5.081,54.084,15.102,79.181\r\n\t\t\tc9.672,24.226,23.512,45.973,41.134,64.642c5.458,5.781,11.198,11.177,17.197,16.178l22.829-24.183\r\n\t\t\tC89.251,360.907,64,311.578,64,256z"},"children":[{"name":"path","attribs":{"d":"M64,256c0-55.578,25.251-104.907,64.263-135.817L105.433,96c-5.999,5-11.739,10.396-17.197,16.178\r\n\t\t\tc-17.622,18.669-31.462,40.417-41.134,64.641C37.081,201.917,32,228.556,32,256c0,27.443,5.081,54.084,15.102,79.181\r\n\t\t\tc9.672,24.226,23.512,45.973,41.134,64.642c5.458,5.781,11.198,11.177,17.197,16.178l22.829-24.183\r\n\t\t\tC89.251,360.907,64,311.578,64,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,256c0,55.578-25.251,104.907-64.262,135.817l22.828,23.848c6-5.001,11.74-10.062,17.198-15.843\r\n\t\t\tc17.622-18.669,31.462-40.416,41.134-64.642C474.918,310.084,480,283.443,480,256c0-27.444-5.082-54.083-15.102-79.181\r\n\t\t\tc-9.672-24.225-23.512-45.972-41.134-64.641C418.307,106.396,412.566,101,406.566,96l-22.829,24.183\r\n\t\t\tC422.749,151.093,448,200.422,448,256z"},"children":[{"name":"path","attribs":{"d":"M448,256c0,55.578-25.251,104.907-64.262,135.817l22.828,23.848c6-5.001,11.74-10.062,17.198-15.843\r\n\t\t\tc17.622-18.669,31.462-40.416,41.134-64.642C474.918,310.084,480,283.443,480,256c0-27.444-5.082-54.083-15.102-79.181\r\n\t\t\tc-9.672-24.225-23.512-45.972-41.134-64.641C418.307,106.396,412.566,101,406.566,96l-22.829,24.183\r\n\t\t\tC422.749,151.093,448,200.422,448,256z"},"children":[]}]}]}]}]}]};exports.radioWaves=radioWaves;var record={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,464c114.9,0,208-93.1,208-208c0-114.9-93.1-208-208-208C141.1,48,48,141.1,48,256C48,370.9,141.1,464,256,464z"},"children":[]}]};exports.record=record;var refresh={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M416,352l96-111.9h-64.7c-2.3-27.9-10.5-54-23.5-77.3c-27.4-49.2-75.8-85.1-133-95.6c-0.7-0.1-1.5-0.3-2.2-0.4\r\n\tc-0.5-0.1-0.9-0.2-1.4-0.2C277.1,64.9,266.6,64,256,64c-0.1,0-0.3,0-0.4,0c0,0,0,0,0,0c-90.9,0.2-167,63.6-186.7,148.6\r\n\tc0,0,0,0.1,0,0.1c-0.3,1.1-0.5,2.2-0.7,3.3c-0.1,0.5-0.2,0.9-0.3,1.4c-0.1,0.7-0.3,1.4-0.4,2.1c-0.2,0.9-0.3,1.7-0.5,2.6\r\n\tc-0.1,0.4-0.1,0.7-0.2,1.1c-0.2,1.2-0.4,2.4-0.6,3.6c0,0.1,0,0.1,0,0.2c-1,6.3-1.6,12.7-1.9,19.1c0,0.3,0,0.6,0,0.8\r\n\tc-0.1,1.4-0.1,2.7-0.2,4.1c0,1.6-0.1,3.3-0.1,5c0,1.7,0,3.3,0.1,5c0,1.4,0.1,2.7,0.2,4.1c0,0.3,0,0.6,0,0.9c0.3,6.5,1,12.9,1.9,19.1\r\n\tc0,0.1,0,0.1,0,0.2c0.2,1.2,0.4,2.4,0.6,3.6c0.1,0.4,0.1,0.7,0.2,1.1c0.2,0.9,0.3,1.8,0.5,2.6c0.1,0.7,0.3,1.4,0.4,2.1\r\n\tc0.1,0.5,0.2,1,0.3,1.4c0.2,1.1,0.5,2.2,0.7,3.2c0,0,0,0.1,0,0.1c19.7,85,96.1,148.4,187.1,148.6c42.9-0.1,83.1-14.2,116.9-40.7\r\n\tl7.5-5.9l-43.2-46.2l-6.2,4.6c-22.1,16.3-47.5,24.2-75,24.2c-70.6,0-128-57-128-128c0-71,57.4-128,128-128\r\n\tc66.4,0,122.8,46.6,129.5,112H312L416,352z"},"children":[]}]};exports.refresh=refresh;var replyAll={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M304.5,192v-80L152.7,255.8L304.5,390v-91.9c68,0,107.9,8.9,159.1,101.9C463.6,400,457.5,192,304.5,192z"},"children":[{"name":"path","attribs":{"d":"M304.5,192v-80L152.7,255.8L304.5,390v-91.9c68,0,107.9,8.9,159.1,101.9C463.6,400,457.5,192,304.5,192z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"47.5,256 191.5,382.5 191.5,324 109.3,256 191.5,177.4 191.5,120.4 \t\t"},"children":[{"name":"polygon","attribs":{"points":"47.5,256 191.5,382.5 191.5,324 109.3,256 191.5,177.4 191.5,120.4 \t\t"},"children":[]}]}]}]}]}]};exports.replyAll=replyAll;var reply={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M448,400c0,0-36.8-208-224-208v-80L64,256l160,134.4v-92.3C325.6,298.1,395,307,448,400z"},"children":[{"name":"path","attribs":{"d":"M448,400c0,0-36.8-208-224-208v-80L64,256l160,134.4v-92.3C325.6,298.1,395,307,448,400z"},"children":[]}]}]}]};exports.reply=reply;var ribbonA={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,32l-82.9,176.612c39.996,3.608,75.273,23.554,99.096,53.128L432,128L352,32z"},"children":[{"name":"path","attribs":{"d":"M352,32l-82.9,176.612c39.996,3.608,75.273,23.554,99.096,53.128L432,128L352,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,32l82.9,176.612c-39.996,3.608-75.273,23.554-99.096,53.128L80,128L160,32z"},"children":[{"name":"path","attribs":{"d":"M160,32l82.9,176.612c-39.996,3.608-75.273,23.554-99.096,53.128L80,128L160,32z"},"children":[]}]},{"name":"polygon","attribs":{"points":"269.092,32 256,32 176,32 228.572,144 256,144 283.428,144 336,32 \t"},"children":[{"name":"polygon","attribs":{"points":"269.092,32 256,32 176,32 228.572,144 256,144 283.428,144 336,32 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,224c-70.692,0-128,57.308-128,128s57.308,128,128,128s128-57.308,128-128S326.692,224,256,224z M256,448\r\n\t\tc-53.02,0-96-42.98-96-96s42.98-96,96-96s96,42.98,96,96S309.02,448,256,448z"},"children":[{"name":"path","attribs":{"d":"M256,224c-70.692,0-128,57.308-128,128s57.308,128,128,128s128-57.308,128-128S326.692,224,256,224z M256,448\r\n\t\tc-53.02,0-96-42.98-96-96s42.98-96,96-96s96,42.98,96,96S309.02,448,256,448z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,264c-48.523,0-88,39.477-88,88s39.477,88,88,88s88-39.477,88-88S304.523,264,256,264z"},"children":[{"name":"path","attribs":{"d":"M256,264c-48.523,0-88,39.477-88,88s39.477,88,88,88s88-39.477,88-88S304.523,264,256,264z"},"children":[]}]}]}]};exports.ribbonA=ribbonA;var ribbonB={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,72c-48.523,0-88,39.477-88,88s39.477,88,88,88s88-39.477,88-88S304.523,72,256,72z"},"children":[{"name":"path","attribs":{"d":"M256,72c-48.523,0-88,39.477-88,88s39.477,88,88,88s88-39.477,88-88S304.523,72,256,72z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32c-70.692,0-128,57.308-128,128s57.308,128,128,128s128-57.308,128-128S326.692,32,256,32z M256,256\r\n\t\t\tc-53.02,0-96-42.98-96-96s42.98-96,96-96s96,42.98,96,96S309.02,256,256,256z"},"children":[{"name":"path","attribs":{"d":"M256,32c-70.692,0-128,57.308-128,128s57.308,128,128,128s128-57.308,128-128S326.692,32,256,32z M256,256\r\n\t\t\tc-53.02,0-96-42.98-96-96s42.98-96,96-96s96,42.98,96,96S309.02,256,256,256z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M147.092,254.21L64,400h96l48,80l48-105.807l33.641-74.154C278.848,302.623,267.585,304,256,304\r\n\t\t\tC212.495,304,173.497,284.707,147.092,254.21z"},"children":[{"name":"path","attribs":{"d":"M147.092,254.21L64,400h96l48,80l48-105.807l33.641-74.154C278.848,302.623,267.585,304,256,304\r\n\t\t\tC212.495,304,173.497,284.707,147.092,254.21z"},"children":[]}]},{"name":"path","attribs":{"d":"M364.908,254.211c-15.077,17.412-34.26,31.172-56.043,39.774l-44.752,98.092L304,480l48-80h96L364.908,254.211z"},"children":[{"name":"path","attribs":{"d":"M364.908,254.211c-15.077,17.412-34.26,31.172-56.043,39.774l-44.752,98.092L304,480l48-80h96L364.908,254.211z"},"children":[]}]}]}]}]}]};exports.ribbonB=ribbonB;var sadOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M399.283,283.797c-5.1-16.379-14.22-29.995-33.802-37.263s-35.265-2.877-49.868,6.15\r\n\t\t\t\tc-7.615,4.707-10.029,14.019-4.214,22.123c2.049,2.854,5.019,4.717,8.376,5.963c5.059,1.876,10.584,1.678,14.965-1.036\r\n\t\t\t\tc4.778-2.957,10.644-6.526,19.607-3.199c9.01,3.343,11.103,9.839,12.752,15.161c1.551,4.952,5.62,8.724,10.693,10.606\r\n\t\t\t\tc3.357,1.246,6.816,1.774,10.236,0.938C396.895,301.056,401.944,292.333,399.283,283.797z"},"children":[{"name":"path","attribs":{"d":"M399.283,283.797c-5.1-16.379-14.22-29.995-33.802-37.263s-35.265-2.877-49.868,6.15\r\n\t\t\t\tc-7.615,4.707-10.029,14.019-4.214,22.123c2.049,2.854,5.019,4.717,8.376,5.963c5.059,1.876,10.584,1.678,14.965-1.036\r\n\t\t\t\tc4.778-2.957,10.644-6.526,19.607-3.199c9.01,3.343,11.103,9.839,12.752,15.161c1.551,4.952,5.62,8.724,10.693,10.606\r\n\t\t\t\tc3.357,1.246,6.816,1.774,10.236,0.938C396.895,301.056,401.944,292.333,399.283,283.797z"},"children":[]}]},{"name":"path","attribs":{"d":"M196.549,252.685c-14.603-9.027-30.286-13.418-49.868-6.15s-28.702,20.884-33.802,37.263\r\n\t\t\t\tc-2.661,8.536,2.389,17.259,11.255,19.443c3.42,0.837,6.878,0.309,10.236-0.938c5.073-1.883,9.143-5.654,10.693-10.606\r\n\t\t\t\tc1.649-5.322,3.743-11.818,12.752-15.161c8.964-3.327,14.829,0.242,19.607,3.199c4.381,2.714,9.907,2.912,14.965,1.036\r\n\t\t\t\tc3.357-1.246,6.327-3.108,8.376-5.963C206.578,266.703,204.164,257.392,196.549,252.685z"},"children":[{"name":"path","attribs":{"d":"M196.549,252.685c-14.603-9.027-30.286-13.418-49.868-6.15s-28.702,20.884-33.802,37.263\r\n\t\t\t\tc-2.661,8.536,2.389,17.259,11.255,19.443c3.42,0.837,6.878,0.309,10.236-0.938c5.073-1.883,9.143-5.654,10.693-10.606\r\n\t\t\t\tc1.649-5.322,3.743-11.818,12.752-15.161c8.964-3.327,14.829,0.242,19.607,3.199c4.381,2.714,9.907,2.912,14.965,1.036\r\n\t\t\t\tc3.357-1.246,6.327-3.108,8.376-5.963C206.578,266.703,204.164,257.392,196.549,252.685z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M391.765,391.765\r\n\t\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\t\tC156.5,83.972,204.715,64,256,64s99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256S428.028,355.5,391.765,391.765z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M349.119,359.176C348.013,357.59,321,320,256,320c-65.261,0-92.014,37.59-93.121,39.176\r\n\t\tc-5.057,7.247-3.283,17.221,3.963,22.278c2.789,1.946,5.982,2.881,9.143,2.881c5.052,0,10.024-2.388,13.135-6.845\r\n\t\tC189.296,377.239,208.02,352,256,352c48,0,66.703,25.239,66.879,25.49c3.11,4.457,8.081,6.845,13.134,6.845\r\n\t\tc3.161,0,6.354-0.935,9.144-2.881C352.402,376.396,354.177,366.423,349.119,359.176z"},"children":[{"name":"path","attribs":{"d":"M349.119,359.176C348.013,357.59,321,320,256,320c-65.261,0-92.014,37.59-93.121,39.176\r\n\t\tc-5.057,7.247-3.283,17.221,3.963,22.278c2.789,1.946,5.982,2.881,9.143,2.881c5.052,0,10.024-2.388,13.135-6.845\r\n\t\tC189.296,377.239,208.02,352,256,352c48,0,66.703,25.239,66.879,25.49c3.11,4.457,8.081,6.845,13.134,6.845\r\n\t\tc3.161,0,6.354-0.935,9.144-2.881C352.402,376.396,354.177,366.423,349.119,359.176z"},"children":[]}]}]}]};exports.sadOutline=sadOutline;var sad={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M145.062,291.696\r\n\t\tc-1.551,4.952-5.62,8.724-10.693,10.606c-3.358,1.246-6.816,1.774-10.236,0.938c-8.866-2.185-13.916-10.907-11.255-19.443\r\n\t\tc5.101-16.379,14.22-29.995,33.802-37.263s35.265-2.877,49.868,6.15c7.615,4.707,10.029,14.019,4.214,22.123\r\n\t\tc-2.049,2.854-5.019,4.717-8.376,5.963c-5.059,1.876-10.584,1.678-14.965-1.036c-4.778-2.957-10.643-6.526-19.607-3.199\r\n\t\tC148.805,279.878,146.712,286.374,145.062,291.696z M345.156,381.454c-2.789,1.946-5.982,2.881-9.144,2.881\r\n\t\tc-5.053,0-10.023-2.388-13.134-6.845C322.703,377.239,304,352,256,352c-47.98,0-66.704,25.239-66.879,25.49\r\n\t\tc-3.111,4.457-8.083,6.845-13.135,6.845c-3.161,0-6.354-0.935-9.143-2.881c-7.246-5.058-9.021-15.031-3.963-22.278\r\n\t\tC163.986,357.59,190.739,320,256,320c65,0,92.013,37.59,93.119,39.176C354.177,366.423,352.402,376.396,345.156,381.454z\r\n\t\t M388.029,303.24c-3.42,0.837-6.879,0.309-10.236-0.938c-5.073-1.883-9.143-5.654-10.693-10.606\r\n\t\tc-1.649-5.322-3.742-11.818-12.752-15.161c-8.964-3.327-14.829,0.242-19.607,3.199c-4.381,2.714-9.906,2.912-14.965,1.036\r\n\t\tc-3.357-1.246-6.327-3.108-8.376-5.963c-5.815-8.104-3.401-17.416,4.214-22.123c14.604-9.027,30.286-13.418,49.868-6.15\r\n\t\ts28.702,20.884,33.802,37.263C401.944,292.333,396.895,301.056,388.029,303.24z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M145.062,291.696\r\n\t\tc-1.551,4.952-5.62,8.724-10.693,10.606c-3.358,1.246-6.816,1.774-10.236,0.938c-8.866-2.185-13.916-10.907-11.255-19.443\r\n\t\tc5.101-16.379,14.22-29.995,33.802-37.263s35.265-2.877,49.868,6.15c7.615,4.707,10.029,14.019,4.214,22.123\r\n\t\tc-2.049,2.854-5.019,4.717-8.376,5.963c-5.059,1.876-10.584,1.678-14.965-1.036c-4.778-2.957-10.643-6.526-19.607-3.199\r\n\t\tC148.805,279.878,146.712,286.374,145.062,291.696z M345.156,381.454c-2.789,1.946-5.982,2.881-9.144,2.881\r\n\t\tc-5.053,0-10.023-2.388-13.134-6.845C322.703,377.239,304,352,256,352c-47.98,0-66.704,25.239-66.879,25.49\r\n\t\tc-3.111,4.457-8.083,6.845-13.135,6.845c-3.161,0-6.354-0.935-9.143-2.881c-7.246-5.058-9.021-15.031-3.963-22.278\r\n\t\tC163.986,357.59,190.739,320,256,320c65,0,92.013,37.59,93.119,39.176C354.177,366.423,352.402,376.396,345.156,381.454z\r\n\t\t M388.029,303.24c-3.42,0.837-6.879,0.309-10.236-0.938c-5.073-1.883-9.143-5.654-10.693-10.606\r\n\t\tc-1.649-5.322-3.742-11.818-12.752-15.161c-8.964-3.327-14.829,0.242-19.607,3.199c-4.381,2.714-9.906,2.912-14.965,1.036\r\n\t\tc-3.357-1.246-6.327-3.108-8.376-5.963c-5.815-8.104-3.401-17.416,4.214-22.123c14.604-9.027,30.286-13.418,49.868-6.15\r\n\t\ts28.702,20.884,33.802,37.263C401.944,292.333,396.895,301.056,388.029,303.24z"},"children":[]}]}]}]};exports.sad=sad;var scissors={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M405.178,115.667c13.314-32.667,17.309-64-5.326-83.667L255.726,224l-16.976,23c0,0-27.627,40.011-37.28,58.667\r\n\t\ts-19.306,39.333-27.294,54c-7.01,12.871-10.438,15.221-14.322,11.548c-0.506-0.591-1.026-1.168-1.553-1.736\r\n\t\tc-0.037-0.047-0.073-0.09-0.11-0.138c-1.143-1.472-2.75-3.002-4.635-4.467C144.195,356.795,132.548,352,119.92,352\r\n\t\tC89.037,352,64,380.653,64,416s25.037,64,55.92,64c25.282,0,46.635-19.205,53.553-45.561l-0.004,0.043\r\n\t\tc0,0,13.355-41.482,32.661-71.482c19.306-30,49.596-43,49.596-43l31.954-32C287.68,288,391.863,148.334,405.178,115.667z\r\n\t\t M119.92,448c-15.418,0-27.918-14.353-27.918-32s12.5-32,27.918-32c15.419,0,27.918,14.353,27.918,32S135.339,448,119.92,448z\r\n\t\t M256,288c-8.836,0-16-7.163-16-16c0-8.836,7.164-16,16-16c8.837,0,16,7.164,16,16C272,280.837,264.837,288,256,288z"},"children":[{"name":"path","attribs":{"d":"M405.178,115.667c13.314-32.667,17.309-64-5.326-83.667L255.726,224l-16.976,23c0,0-27.627,40.011-37.28,58.667\r\n\t\ts-19.306,39.333-27.294,54c-7.01,12.871-10.438,15.221-14.322,11.548c-0.506-0.591-1.026-1.168-1.553-1.736\r\n\t\tc-0.037-0.047-0.073-0.09-0.11-0.138c-1.143-1.472-2.75-3.002-4.635-4.467C144.195,356.795,132.548,352,119.92,352\r\n\t\tC89.037,352,64,380.653,64,416s25.037,64,55.92,64c25.282,0,46.635-19.205,53.553-45.561l-0.004,0.043\r\n\t\tc0,0,13.355-41.482,32.661-71.482c19.306-30,49.596-43,49.596-43l31.954-32C287.68,288,391.863,148.334,405.178,115.667z\r\n\t\t M119.92,448c-15.418,0-27.918-14.353-27.918-32s12.5-32,27.918-32c15.419,0,27.918,14.353,27.918,32S135.339,448,119.92,448z\r\n\t\t M256,288c-8.836,0-16-7.163-16-16c0-8.836,7.164-16,16-16c8.837,0,16,7.164,16,16C272,280.837,264.837,288,256,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M207.28,265.255c9.18-14.114,17.671-26.43,18.304-27.346l0.143-0.208l0.15-0.203l16.976-23l0.038-0.052l0.039-0.052\r\n\t\tl2.941-3.918L111.896,32c-22.634,19.667-18.64,51-5.326,83.667C116.523,140.087,177.249,224.29,207.28,265.255z"},"children":[{"name":"path","attribs":{"d":"M207.28,265.255c9.18-14.114,17.671-26.43,18.304-27.346l0.143-0.208l0.15-0.203l16.976-23l0.038-0.052l0.039-0.052\r\n\t\tl2.941-3.918L111.896,32c-22.634,19.667-18.64,51-5.326,83.667C116.523,140.087,177.249,224.29,207.28,265.255z"},"children":[]}]},{"name":"path","attribs":{"d":"M391.828,352c-12.628,0-24.275,4.795-33.637,12.874c-1.885,1.465-3.492,2.995-4.635,4.467\r\n\t\tc-0.037,0.048-0.072,0.091-0.109,0.138c-0.526,0.568-1.047,1.146-1.553,1.736c-3.884,3.673-7.312,1.323-14.322-11.548\r\n\t\tc-7.988-14.667-17.641-35.344-27.294-54c-1.77-3.421-4.146-7.561-6.843-12.038c-1.272,1.712-2.264,3.043-2.932,3.938l-0.688,0.924\r\n\t\tl-0.813,0.815l-28.688,28.729c10.433,6.855,24.565,18.276,35.306,34.965c19.305,30,32.66,71.482,32.66,71.482l-0.004-0.043\r\n\t\tC345.193,460.795,366.546,480,391.828,480C422.711,480,448,451.347,448,416S422.711,352,391.828,352z M391.828,448\r\n\t\tc-15.42,0-27.918-14.353-27.918-32s12.498-32,27.918-32c15.418,0,27.918,14.353,27.918,32S407.246,448,391.828,448z"},"children":[{"name":"path","attribs":{"d":"M391.828,352c-12.628,0-24.275,4.795-33.637,12.874c-1.885,1.465-3.492,2.995-4.635,4.467\r\n\t\tc-0.037,0.048-0.072,0.091-0.109,0.138c-0.526,0.568-1.047,1.146-1.553,1.736c-3.884,3.673-7.312,1.323-14.322-11.548\r\n\t\tc-7.988-14.667-17.641-35.344-27.294-54c-1.77-3.421-4.146-7.561-6.843-12.038c-1.272,1.712-2.264,3.043-2.932,3.938l-0.688,0.924\r\n\t\tl-0.813,0.815l-28.688,28.729c10.433,6.855,24.565,18.276,35.306,34.965c19.305,30,32.66,71.482,32.66,71.482l-0.004-0.043\r\n\t\tC345.193,460.795,366.546,480,391.828,480C422.711,480,448,451.347,448,416S422.711,352,391.828,352z M391.828,448\r\n\t\tc-15.42,0-27.918-14.353-27.918-32s12.498-32,27.918-32c15.418,0,27.918,14.353,27.918,32S407.246,448,391.828,448z"},"children":[]}]}]}]};exports.scissors=scissors;var search={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M445,386.7l-84.8-85.9c13.8-24.1,21-50.9,21-77.9c0-87.6-71.2-158.9-158.6-158.9C135.2,64,64,135.3,64,222.9\r\n\tc0,87.6,71.2,158.9,158.6,158.9c27.9,0,55.5-7.7,80.1-22.4l84.4,85.6c1.9,1.9,4.6,3.1,7.3,3.1c2.7,0,5.4-1.1,7.3-3.1l43.3-43.8\r\n\tC449,397.1,449,390.7,445,386.7z M222.6,125.9c53.4,0,96.8,43.5,96.8,97c0,53.5-43.4,97-96.8,97c-53.4,0-96.8-43.5-96.8-97\r\n\tC125.8,169.4,169.2,125.9,222.6,125.9z"},"children":[]}]};exports.search=search;var settings={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M450,138.3l-47.7,48.5l-2.7,2.8l-1.6,1.7c-1.1,0.8-2.4,1.2-3.9,1.2c-1.6,0-3.1-0.6-4.3-1.6l-0.9-0.9l-2.7-2.7l-41.3-42.1\r\n\tl-2.2-2.2l-1.7-1.7c-1-1.5-1.6-3.4-1.6-5.3c0-1.7,0.6-3.2,1.6-4.4l0.7-0.8l2.6-2.6l47.9-48.7c-5.1-10.1-24.7-14.9-35.1-14.1\r\n\tc-17.1,1.3-34.7,7-52.8,25.5c-0.7,0.8-1.5,1.6-2.2,2.3C277.5,120,272.6,156,282.6,189c0.7,1.4,1.3,3.1,1.6,4.6\r\n\tc1.1,5.5-0.4,10.2-4,13.5l-37.9,36.4c-11.8-12-13.5-13.6-13.5-13.6c-2-2-6-3.3-9.5-1.2l-5.9,3.6c-22.7-23.1-32.3-32.4-35.4-43.6\r\n\tc-3.2-11.7-0.3-27.3,2.7-33.1c2.5-4.6,10.3-8.9,16.9-9.4l8.6,8.8c2,2,5.1,2,7.1,0l30.9-31.4c2-2,2-5.3,0-7.3l-49.9-50.7\r\n\tc-2-2-5.2-2-7.1,0l-30.9,31.4c-2,2-2,5.3,0,7.3l3.3,3.4c0,4.9-0.7,12.5-4.7,16.6c-6.2,6.3-18.5-1-26.5,4.7\r\n\tc-7.9,5.6-17.9,14.6-24.3,21c-6.3,6.4-30.5,31.8-47.8,74.6c-17.3,42.8-4,82.5,5.4,92.9c5,5.5,14.1,11.1,12.5,0.7\r\n\tc-1.6-10.5-4.2-46.9,7.7-61.8c11.9-14.9,27.6-27.1,48-28.1c19.6-1,30.9,5.7,56.3,31.5l-2.8,5.2c-1.8,3.4-0.8,7.7,1.2,9.7\r\n\tc0,0,1.5,1.6,12.1,12.4l-97.2,93.2c-16.2,14.3-15.3,40.5-0.3,56c15.2,15.2,41.1,16.3,55.2-0.2l91.4-98.6\r\n\tc49.1,52.3,93.3,107.4,93.3,107.4c2,2,5.2,2,7.1,0l49.9-50.7c2-2,2-5.2,0-7.3c0,0-55.2-45.7-107-96.2l35.5-38.3\r\n\tc3.3-3.7,7.9-5.2,13.3-4.1c1.5,0.3,3.1,1,4.5,1.7c32.4,10.2,67.8,5.2,94-19.8c0.8-0.7,1.5-1.5,2.3-2.3c18.1-18.4,23.7-36.4,25-53.8\r\n\tC464.7,163.5,460.2,143.8,450,138.3z"},"children":[]}]};exports.settings=settings;var share={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,377.9H102.4V198.2h57.5c0,0,14.1-19.7,42.7-38.2H83.2c-10.6,0-19.2,8.5-19.2,19.1v217.9c0,10.5,8.6,19.1,19.2,19.1\r\n\t\th288c10.6,0,19.2-8.5,19.2-19.1V288L352,319.4V377.9z M320,224v63.9l128-95.5L320,96v59.7C165.2,155.7,160,320,160,320\r\n\t\tC203.8,248.5,236,224,320,224z"},"children":[{"name":"path","attribs":{"d":"M352,377.9H102.4V198.2h57.5c0,0,14.1-19.7,42.7-38.2H83.2c-10.6,0-19.2,8.5-19.2,19.1v217.9c0,10.5,8.6,19.1,19.2,19.1\r\n\t\th288c10.6,0,19.2-8.5,19.2-19.1V288L352,319.4V377.9z M320,224v63.9l128-95.5L320,96v59.7C165.2,155.7,160,320,160,320\r\n\t\tC203.8,248.5,236,224,320,224z"},"children":[]}]}]}]};exports.share=share;var shuffle={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M370.1,181.3H399v47.3l81-83.2L399,64v54h-28.9c-82.7,0-129.4,61.9-170.6,116.5c-37,49.1-69,95.4-120.6,95.4H32v63.3h46.9\r\n\tc82.7,0,129.4-65.8,170.6-120.4C286.5,223.7,318.4,181.3,370.1,181.3z M153.2,217.5c3.5-4.6,7.1-9.3,10.7-14.1\r\n\tc8.8-11.6,18-23.9,28-36.1c-29.6-27.9-65.3-48.5-113-48.5H32v63.3c0,0,13.3-0.6,46.9,0C111.4,182.8,131.8,196.2,153.2,217.5z\r\n\t M399,330.4h-28.9c-31.5,0-55.7-15.8-78.2-39.3c-2.2,3-4.5,6-6.8,9c-9.9,13.1-20.5,27.2-32.2,41.1c30.4,29.9,67.2,52.5,117.2,52.5\r\n\tH399V448l81-81.4l-81-83.2V330.4z"},"children":[]}]};exports.shuffle=shuffle;var skipBackward={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M75.7,96h8.1c6.7,0,12.2,5,12.2,11.7v113.5L283.1,98.7c2.5-1.7,5.1-2.3,8.1-2.3c8.3,0,15.4,7,15.4,17v63.1\r\n\tl118.5-78.2c2.5-1.7,5-2.3,8.1-2.3c8.3,0,14.9,7.4,14.9,17.4v286c0,10-6.7,16.5-15,16.5c-3.1,0-5.4-1.2-8.2-2.9l-118.3-77.6v64\r\n\tc0,10-7.2,16.5-15.5,16.5c-3.1,0-5.5-1.2-8.2-2.9L96,290.8v113c0,6.7-5.4,12.2-12.2,12.2h-8.1c-6.7,0-11.7-5.5-11.7-12.2V107.7\r\n\tC64,101,68.9,96,75.7,96z"},"children":[]}]};exports.skipBackward=skipBackward;var skipForward={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M436.3,96h-8.1c-6.7,0-12.2,5-12.2,11.7v113.5L228.9,98.7c-2.5-1.7-5.1-2.3-8.1-2.3c-8.3,0-15.4,7-15.4,17v63.1\r\n\tL86.9,98.3c-2.5-1.7-5.1-2.3-8.1-2.3c-8.3,0-14.9,7.4-14.9,17.4v286c0,10,6.7,16.5,15,16.5c3.1,0,5.4-1.2,8.2-2.9l118.3-77.6v64\r\n\tc0,10,7.2,16.5,15.5,16.5c3.1,0,5.5-1.2,8.2-2.9L416,290.8v113c0,6.7,5.4,12.2,12.2,12.2h8.1c6.7,0,11.7-5.5,11.7-12.2V107.7\r\n\tC448,101,443.1,96,436.3,96z"},"children":[]}]};exports.skipForward=skipForward;var socialAndroidOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,208v60.5V357h-22.5H313v15.5V424c0,4.4-3,7.9-7.3,8l0,0l-0.1,0c-0.1,0-0.2,0-0.3,0c-1.6,0-3.1-0.6-4.3-1.6l-0.1-0.1\r\n\t\t\tl-0.4-0.1c-2-1.6-3.4-4-3.4-6.2v-51.5V357h-15.5h-49H216v15.5V424c0,4.4-3.6,8-8,8s-8-3.6-8-8v-51.5V357h-15.5H160v-88.6V208H352\r\n\t\t\t M368,192H144v76.4V358c0,6.9,5.5,15,12.4,15H184v51c0,13.3,10.7,24,24,24s24-10.7,24-24v-51h49v51c0,7.5,3.9,14.2,9.3,18.6\r\n\t\t\tc3.9,3.4,9.3,5.4,15,5.4c0.1,0,0.3,0,0.4,0c0.1,0-0.3,0-0.2,0c13.3,0,23.6-10.7,23.6-24v-51h28.6c7,0,10.4-8.1,10.4-14.9v-89.6\r\n\t\t\tV192L368,192z"},"children":[{"name":"path","attribs":{"d":"M352,208v60.5V357h-22.5H313v15.5V424c0,4.4-3,7.9-7.3,8l0,0l-0.1,0c-0.1,0-0.2,0-0.3,0c-1.6,0-3.1-0.6-4.3-1.6l-0.1-0.1\r\n\t\t\tl-0.4-0.1c-2-1.6-3.4-4-3.4-6.2v-51.5V357h-15.5h-49H216v15.5V424c0,4.4-3.6,8-8,8s-8-3.6-8-8v-51.5V357h-15.5H160v-88.6V208H352\r\n\t\t\t M368,192H144v76.4V358c0,6.9,5.5,15,12.4,15H184v51c0,13.3,10.7,24,24,24s24-10.7,24-24v-51h49v51c0,7.5,3.9,14.2,9.3,18.6\r\n\t\t\tc3.9,3.4,9.3,5.4,15,5.4c0.1,0,0.3,0,0.4,0c0.1,0-0.3,0-0.2,0c13.3,0,23.6-10.7,23.6-24v-51h28.6c7,0,10.4-8.1,10.4-14.9v-89.6\r\n\t\t\tV192L368,192z"},"children":[]}]},{"name":"path","attribs":{"d":"M408,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C400,195.6,403.6,192,408,192 M408,176c-13.3,0-24,10.7-24,24\r\n\t\t\tv96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176L408,176z"},"children":[{"name":"path","attribs":{"d":"M408,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C400,195.6,403.6,192,408,192 M408,176c-13.3,0-24,10.7-24,24\r\n\t\t\tv96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176L408,176z"},"children":[]}]},{"name":"path","attribs":{"d":"M104,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C96,195.6,99.6,192,104,192 M104,176c-13.3,0-24,10.7-24,24\r\n\t\t\tv96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176L104,176z"},"children":[{"name":"path","attribs":{"d":"M104,192c4.4,0,8,3.6,8,8v96c0,4.4-3.6,8-8,8s-8-3.6-8-8v-96C96,195.6,99.6,192,104,192 M104,176c-13.3,0-24,10.7-24,24\r\n\t\t\tv96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176L104,176z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255,94.3l0.9,0h0h0c14.2,0,27.3,1.9,38.8,5.6l10,4.4c28.7,12.6,39.9,37.4,44.4,55.7H162.8c4.4-18.6,15.6-43.6,44.1-56\r\n\t\t\tl10.3-4.5C228.5,96.1,241.2,94.3,255,94.3 M185.4,64c-0.5,0-1.2,0.2-1.8,0.8c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,22.1\r\n\t\t\tc-48.2,20.9-55.4,71.7-56.4,86.7h223.6c-1.1-15-8.2-65.1-56.6-86.4l18.5-22.2c0.4-0.5-0.2-1.7-1.3-2.6c-0.7-0.5-1.5-0.8-2-0.8\r\n\t\t\tc-0.3,0-0.5,0.1-0.7,0.3l-19.2,22.7c-13.6-5.4-30.2-8.8-50.6-8.8c-0.3,0-0.6,0-1,0c-20,0-36.4,3.3-49.8,8.5l-19-22.5\r\n\t\t\tC186.1,64.1,185.8,64,185.4,64L185.4,64z"},"children":[{"name":"path","attribs":{"d":"M255,94.3l0.9,0h0h0c14.2,0,27.3,1.9,38.8,5.6l10,4.4c28.7,12.6,39.9,37.4,44.4,55.7H162.8c4.4-18.6,15.6-43.6,44.1-56\r\n\t\t\tl10.3-4.5C228.5,96.1,241.2,94.3,255,94.3 M185.4,64c-0.5,0-1.2,0.2-1.8,0.8c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,22.1\r\n\t\t\tc-48.2,20.9-55.4,71.7-56.4,86.7h223.6c-1.1-15-8.2-65.1-56.6-86.4l18.5-22.2c0.4-0.5-0.2-1.7-1.3-2.6c-0.7-0.5-1.5-0.8-2-0.8\r\n\t\t\tc-0.3,0-0.5,0.1-0.7,0.3l-19.2,22.7c-13.6-5.4-30.2-8.8-50.6-8.8c-0.3,0-0.6,0-1,0c-20,0-36.4,3.3-49.8,8.5l-19-22.5\r\n\t\t\tC186.1,64.1,185.8,64,185.4,64L185.4,64z"},"children":[]}]}]}]}]},{"name":"path","attribs":{"d":"M206.6,138.9c-7.4,0-13.5-6-13.5-13.3c0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C220.1,132.9,214.1,138.9,206.6,138.9z\r\n\t"},"children":[]},{"name":"path","attribs":{"d":"M305,138.9c-7.4,0-13.5-6-13.5-13.3c0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C318.5,132.9,312.4,138.9,305,138.9z"},"children":[]}]};exports.socialAndroidOutline=socialAndroidOutline;var socialAndroid={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,268.4V358c0,6.9,4.5,14,11.4,14H184v52c0,13.3,10.7,24,24,24s24-10.7,24-24v-52h49v52c0,7.5,3.4,14.2,8.8,18.6\r\n\t\t\tc3.9,3.4,9.1,5.4,14.7,5.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c13.3,0,24-10.7,24-24v-52h27.6c7,0,11.4-7.1,11.4-13.9v-89.6V192\r\n\t\t\tH144V268.4z"},"children":[{"name":"path","attribs":{"d":"M144,268.4V358c0,6.9,4.5,14,11.4,14H184v52c0,13.3,10.7,24,24,24s24-10.7,24-24v-52h49v52c0,7.5,3.4,14.2,8.8,18.6\r\n\t\t\tc3.9,3.4,9.1,5.4,14.7,5.4c0.1,0,0.2,0,0.3,0c0.1,0,0.1,0,0.2,0c13.3,0,24-10.7,24-24v-52h27.6c7,0,11.4-7.1,11.4-13.9v-89.6V192\r\n\t\t\tH144V268.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M408,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176z"},"children":[{"name":"path","attribs":{"d":"M408,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C432,186.7,421.3,176,408,176z"},"children":[]}]},{"name":"path","attribs":{"d":"M104,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176z"},"children":[{"name":"path","attribs":{"d":"M104,176c-13.3,0-24,10.7-24,24v96c0,13.3,10.7,24,24,24s24-10.7,24-24v-96C128,186.7,117.3,176,104,176z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M311.2,89.1l18.5-21.9c0.4-0.5-0.2-1.6-1.3-2.5c-1.1-0.8-2.4-1-2.7-0.4l-19.2,22.8c-13.6-5.4-30.2-8.8-50.6-8.8\r\n\t\t\tc-20.5-0.1-37.2,3.2-50.8,8.5l-19-22.4c-0.4-0.5-1.6-0.4-2.7,0.4c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,21.6\r\n\t\t\tc-48.2,20.9-55.4,72.2-56.4,87.2h223.6C366.7,161,359.6,110.4,311.2,89.1z M206.8,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C220.3,132.9,214.3,138.9,206.8,138.9z M305.2,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C318.7,132.9,312.6,138.9,305.2,138.9z"},"children":[{"name":"path","attribs":{"d":"M311.2,89.1l18.5-21.9c0.4-0.5-0.2-1.6-1.3-2.5c-1.1-0.8-2.4-1-2.7-0.4l-19.2,22.8c-13.6-5.4-30.2-8.8-50.6-8.8\r\n\t\t\tc-20.5-0.1-37.2,3.2-50.8,8.5l-19-22.4c-0.4-0.5-1.6-0.4-2.7,0.4c-1.1,0.8-1.7,1.8-1.3,2.5l18.3,21.6\r\n\t\t\tc-48.2,20.9-55.4,72.2-56.4,87.2h223.6C366.7,161,359.6,110.4,311.2,89.1z M206.8,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C220.3,132.9,214.3,138.9,206.8,138.9z M305.2,138.9c-7.4,0-13.5-6-13.5-13.3\r\n\t\t\tc0-7.3,6-13.3,13.5-13.3c7.4,0,13.5,6,13.5,13.3C318.7,132.9,312.6,138.9,305.2,138.9z"},"children":[]}]}]}]}]}]};exports.socialAndroid=socialAndroid;var socialAngularOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255.982,64l187.967,69.105l-39.17,230.389l-148.881,79.949l-148.812-80.051L68.031,133.11L255.982,64 M255.981,32L32,112\r\n\t\tl46.12,272L256,480l177.75-96L480,112L255.981,32L255.981,32z"},"children":[{"name":"path","attribs":{"d":"M255.982,64l187.967,69.105l-39.17,230.389l-148.881,79.949l-148.812-80.051L68.031,133.11L255.982,64 M255.981,32L32,112\r\n\t\tl46.12,272L256,480l177.75-96L480,112L255.981,32L255.981,32z"},"children":[]}]},{"name":"path","attribs":{"d":"M344,352h40L256,72L128,352h40l26.584-56h122.827L344,352z M213.573,256l42.419-89.356L298.419,256H213.573z"},"children":[{"name":"path","attribs":{"d":"M344,352h40L256,72L128,352h40l26.584-56h122.827L344,352z M213.573,256l42.419-89.356L298.419,256H213.573z"},"children":[]}]}]}]};exports.socialAngularOutline=socialAngularOutline;var socialAngular={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"213.573,256 298.419,256 255.992,166.644 \t"},"children":[{"name":"polygon","attribs":{"points":"213.573,256 298.419,256 255.992,166.644 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M255.981,32L32,112l46.12,272L256,480l177.75-96L480,112L255.981,32z M344,352l-26.589-56H194.584L168,352h-40L256,72\r\n\t\tl128,280H344z"},"children":[{"name":"path","attribs":{"d":"M255.981,32L32,112l46.12,272L256,480l177.75-96L480,112L255.981,32z M344,352l-26.589-56H194.584L168,352h-40L256,72\r\n\t\tl128,280H344z"},"children":[]}]}]}]};exports.socialAngular=socialAngular;var socialAppleOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M333.6,169.9c16.3,0,33.2,7.4,47.4,20.4c-9.9,8.5-17.9,18.7-23.7,30.2c-8,16-11.6,34.3-10.2,52.7\r\n\t\tc1.3,18.7,7.6,36.6,18,51.8c8,11.6,18.2,21.2,30,28.3c-5,10.7-9.2,18.4-16.8,30.5c-8.4,13.1-30.5,48-52,48.2l-0.4,0\r\n\t\tc-7.4,0-12.2-2.2-19.3-5.6c-10-4.7-22.3-10.6-43.4-10.6l-0.6,0c-21.1,0.1-33.8,5.9-43.9,10.6c-7.4,3.4-12.3,5.7-19.9,5.7l-0.4,0\r\n\t\tc-19.6-0.2-37.5-24.3-50.8-45.2c-19.3-30.4-31.7-65.6-34.9-99.1c-2.9-30.5,2-58.5,13.5-76.7c8-12.7,18.5-23.3,30.4-30.6\r\n\t\tc11.2-6.8,23-10.4,34.2-10.4c12.4,0,22.7,3.8,33.7,7.8c11.5,4.2,23.5,8.6,37.7,8.6c13.6,0,24.3-4.2,34.6-8.2\r\n\t\tC308,173.9,318.2,169.9,333.6,169.9 M333.6,153.9c-33.6,0-47.8,16.5-71.2,16.5c-24,0-42.3-16.4-71.4-16.4\r\n\t\tc-28.5,0-58.9,17.9-78.2,48.4c-27.1,43-22.5,124,21.4,193c15.7,24.7,36.7,52.4,64.2,52.7c0.2,0,0.3,0,0.5,0\r\n\t\tc23.9,0,31-16.1,63.9-16.3c0.2,0,0.3,0,0.5,0c32.4,0,38.9,16.2,62.7,16.2c0.2,0,0.3,0,0.5,0c27.5-0.3,49.6-31,65.3-55.6\r\n\t\tc11.3-17.7,15.5-26.6,24.2-46.6c-63.5-24.8-73.7-117.4-10.9-152.9C385.9,168.2,359,153.9,333.6,153.9L333.6,153.9z"},"children":[{"name":"path","attribs":{"d":"M333.6,169.9c16.3,0,33.2,7.4,47.4,20.4c-9.9,8.5-17.9,18.7-23.7,30.2c-8,16-11.6,34.3-10.2,52.7\r\n\t\tc1.3,18.7,7.6,36.6,18,51.8c8,11.6,18.2,21.2,30,28.3c-5,10.7-9.2,18.4-16.8,30.5c-8.4,13.1-30.5,48-52,48.2l-0.4,0\r\n\t\tc-7.4,0-12.2-2.2-19.3-5.6c-10-4.7-22.3-10.6-43.4-10.6l-0.6,0c-21.1,0.1-33.8,5.9-43.9,10.6c-7.4,3.4-12.3,5.7-19.9,5.7l-0.4,0\r\n\t\tc-19.6-0.2-37.5-24.3-50.8-45.2c-19.3-30.4-31.7-65.6-34.9-99.1c-2.9-30.5,2-58.5,13.5-76.7c8-12.7,18.5-23.3,30.4-30.6\r\n\t\tc11.2-6.8,23-10.4,34.2-10.4c12.4,0,22.7,3.8,33.7,7.8c11.5,4.2,23.5,8.6,37.7,8.6c13.6,0,24.3-4.2,34.6-8.2\r\n\t\tC308,173.9,318.2,169.9,333.6,169.9 M333.6,153.9c-33.6,0-47.8,16.5-71.2,16.5c-24,0-42.3-16.4-71.4-16.4\r\n\t\tc-28.5,0-58.9,17.9-78.2,48.4c-27.1,43-22.5,124,21.4,193c15.7,24.7,36.7,52.4,64.2,52.7c0.2,0,0.3,0,0.5,0\r\n\t\tc23.9,0,31-16.1,63.9-16.3c0.2,0,0.3,0,0.5,0c32.4,0,38.9,16.2,62.7,16.2c0.2,0,0.3,0,0.5,0c27.5-0.3,49.6-31,65.3-55.6\r\n\t\tc11.3-17.7,15.5-26.6,24.2-46.6c-63.5-24.8-73.7-117.4-10.9-152.9C385.9,168.2,359,153.9,333.6,153.9L333.6,153.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M309.9,84.5c-2.7,14.9-10.5,26.8-14.6,32.2c-7.4,9.8-18,17.4-28.8,21.1c0.5-3,1.3-6.1,2.4-9.2c3.5-10.2,8.9-18.2,12.8-23.1\r\n\t\tC288.8,96.7,299.3,89.1,309.9,84.5 M326.2,64c-20,1.4-43.3,14.5-57,31.6c-12.4,15.5-22.6,38.5-18.6,60.8c0.5,0,1,0,1.6,0\r\n\t\tc21.3,0,43.1-13.2,55.8-30.1C320.3,110.2,329.6,87.4,326.2,64L326.2,64z"},"children":[{"name":"path","attribs":{"d":"M309.9,84.5c-2.7,14.9-10.5,26.8-14.6,32.2c-7.4,9.8-18,17.4-28.8,21.1c0.5-3,1.3-6.1,2.4-9.2c3.5-10.2,8.9-18.2,12.8-23.1\r\n\t\tC288.8,96.7,299.3,89.1,309.9,84.5 M326.2,64c-20,1.4-43.3,14.5-57,31.6c-12.4,15.5-22.6,38.5-18.6,60.8c0.5,0,1,0,1.6,0\r\n\t\tc21.3,0,43.1-13.2,55.8-30.1C320.3,110.2,329.6,87.4,326.2,64L326.2,64z"},"children":[]}]}]}]};exports.socialAppleOutline=socialAppleOutline;var socialApple={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M333.6,153.9c-33.6,0-47.8,16.5-71.2,16.5c-24,0-42.3-16.4-71.4-16.4c-28.5,0-58.9,17.9-78.2,48.4\r\n\t\tc-27.1,43-22.5,124,21.4,193c15.7,24.7,36.7,52.4,64.2,52.7c0.2,0,0.3,0,0.5,0c23.9,0,31-16.1,63.9-16.3c0.2,0,0.3,0,0.5,0\r\n\t\tc32.4,0,38.9,16.2,62.7,16.2c0.2,0,0.3,0,0.5,0c27.5-0.3,49.6-31,65.3-55.6c11.3-17.7,15.5-26.6,24.2-46.6\r\n\t\tc-63.5-24.8-73.7-117.4-10.9-152.9C385.9,168.2,359,153.9,333.6,153.9L333.6,153.9z"},"children":[{"name":"path","attribs":{"d":"M333.6,153.9c-33.6,0-47.8,16.5-71.2,16.5c-24,0-42.3-16.4-71.4-16.4c-28.5,0-58.9,17.9-78.2,48.4\r\n\t\tc-27.1,43-22.5,124,21.4,193c15.7,24.7,36.7,52.4,64.2,52.7c0.2,0,0.3,0,0.5,0c23.9,0,31-16.1,63.9-16.3c0.2,0,0.3,0,0.5,0\r\n\t\tc32.4,0,38.9,16.2,62.7,16.2c0.2,0,0.3,0,0.5,0c27.5-0.3,49.6-31,65.3-55.6c11.3-17.7,15.5-26.6,24.2-46.6\r\n\t\tc-63.5-24.8-73.7-117.4-10.9-152.9C385.9,168.2,359,153.9,333.6,153.9L333.6,153.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M326.2,64c-20,1.4-43.3,14.5-57,31.6c-12.4,15.5-22.6,38.5-18.6,60.8c0.5,0,1,0,1.6,0c21.3,0,43.1-13.2,55.8-30.1\r\n\t\tC320.3,110.2,329.6,87.4,326.2,64L326.2,64z"},"children":[{"name":"path","attribs":{"d":"M326.2,64c-20,1.4-43.3,14.5-57,31.6c-12.4,15.5-22.6,38.5-18.6,60.8c0.5,0,1,0,1.6,0c21.3,0,43.1-13.2,55.8-30.1\r\n\t\tC320.3,110.2,329.6,87.4,326.2,64L326.2,64z"},"children":[]}]}]}]};exports.socialApple=socialApple;var socialBitcoinOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M279.7,48v47v15.1l15.1,0.8c16.9,0.9,28.8,3.3,40.7,7.9c13.8,5.3,24.2,12.6,31.1,21.7c5.7,7.6,9,19.4,10,36.2\r\n\t\tc0.6,8.8-1,17.1-2.6,22c-1.5,4.4-5.3,11.3-11.1,16.4c-5.4,4.8-8.6,6.7-12.3,8.4l-42.1,19.3l45,10.8c7.4,1.8,14,4.4,21.4,8.5\r\n\t\tc13.2,7.3,18,15.1,21.2,22.5c2.9,6.7,4.6,22.2,3.9,36.2c-0.7,13.4-4.4,31.5-12.6,42.3c-8.6,11.2-21.3,20.1-37.8,26.3\r\n\t\tc-13.6,5.1-31.1,8.1-54.5,9.3l-15.2,0.7v15.2V464h-8v-48v-16h-16H224h-16v16v48h-9v-48v-16h-16h-67.2l3-16h12.8\r\n\t\tc8.6,0,12.1-0.4,17.5-3c0.2-0.1,0.4-0.2,0.7-0.3c8.1-3.7,11-10.6,12.2-13.6c0.1-0.3,0.3-0.7,0.3-0.8c2.9-5.9,3-13.1,3-24.4v-178\r\n\t\tc0-11.7-0.1-13.6-3.1-19.5c-2.9-5.8-7.3-10.1-13.4-13c-5.9-2.8-13.2-3.4-24.5-3.4h-12.9v-16h71.6h16V96V48h9v48v16h16h31.8h16V96\r\n\t\tV48H279.7 M295.7,32h-39.9v64H224V32h-40.9v64H96v48h28.4c8.7,0,14.5,0.3,17.6,1.8c3.1,1.5,4.7,3.3,6,5.8c1.3,2.5,1.4,3.1,1.4,12.3\r\n\t\tv178c0,9-0.1,14.7-0.9,17.6c-1.2,2.7-2.2,5.2-5.3,6.6c-3.1,1.4-2.9,1.9-11.6,1.9h-27.4L96,416h87.1v64H224v-64h31.8v64h39.9v-65.4\r\n\t\tc26-1.3,44.4-4.7,59.3-10.3c19.3-7.2,34.3-17.7,44.9-31.5c10.5-13.8,15-34.9,15.9-51.2c0.8-14.5-0.7-33.2-5.2-43.4\r\n\t\tc-5-11.5-12.7-21.6-28.1-30.1c-8.1-4.5-16.1-7.8-25.4-10c5.4-2.5,9.9-5.4,16.3-11c7.5-6.6,13-15.7,15.6-23.3\r\n\t\tc2.6-7.5,4.1-18,3.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8c-8.8-11.7-21.7-20.7-38.1-27c-12.6-4.8-25.5-7.8-45.5-8.9V32L295.7,32z"},"children":[{"name":"path","attribs":{"d":"M279.7,48v47v15.1l15.1,0.8c16.9,0.9,28.8,3.3,40.7,7.9c13.8,5.3,24.2,12.6,31.1,21.7c5.7,7.6,9,19.4,10,36.2\r\n\t\tc0.6,8.8-1,17.1-2.6,22c-1.5,4.4-5.3,11.3-11.1,16.4c-5.4,4.8-8.6,6.7-12.3,8.4l-42.1,19.3l45,10.8c7.4,1.8,14,4.4,21.4,8.5\r\n\t\tc13.2,7.3,18,15.1,21.2,22.5c2.9,6.7,4.6,22.2,3.9,36.2c-0.7,13.4-4.4,31.5-12.6,42.3c-8.6,11.2-21.3,20.1-37.8,26.3\r\n\t\tc-13.6,5.1-31.1,8.1-54.5,9.3l-15.2,0.7v15.2V464h-8v-48v-16h-16H224h-16v16v48h-9v-48v-16h-16h-67.2l3-16h12.8\r\n\t\tc8.6,0,12.1-0.4,17.5-3c0.2-0.1,0.4-0.2,0.7-0.3c8.1-3.7,11-10.6,12.2-13.6c0.1-0.3,0.3-0.7,0.3-0.8c2.9-5.9,3-13.1,3-24.4v-178\r\n\t\tc0-11.7-0.1-13.6-3.1-19.5c-2.9-5.8-7.3-10.1-13.4-13c-5.9-2.8-13.2-3.4-24.5-3.4h-12.9v-16h71.6h16V96V48h9v48v16h16h31.8h16V96\r\n\t\tV48H279.7 M295.7,32h-39.9v64H224V32h-40.9v64H96v48h28.4c8.7,0,14.5,0.3,17.6,1.8c3.1,1.5,4.7,3.3,6,5.8c1.3,2.5,1.4,3.1,1.4,12.3\r\n\t\tv178c0,9-0.1,14.7-0.9,17.6c-1.2,2.7-2.2,5.2-5.3,6.6c-3.1,1.4-2.9,1.9-11.6,1.9h-27.4L96,416h87.1v64H224v-64h31.8v64h39.9v-65.4\r\n\t\tc26-1.3,44.4-4.7,59.3-10.3c19.3-7.2,34.3-17.7,44.9-31.5c10.5-13.8,15-34.9,15.9-51.2c0.8-14.5-0.7-33.2-5.2-43.4\r\n\t\tc-5-11.5-12.7-21.6-28.1-30.1c-8.1-4.5-16.1-7.8-25.4-10c5.4-2.5,9.9-5.4,16.3-11c7.5-6.6,13-15.7,15.6-23.3\r\n\t\tc2.6-7.5,4.1-18,3.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8c-8.8-11.7-21.7-20.7-38.1-27c-12.6-4.8-25.5-7.8-45.5-8.9V32L295.7,32z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,150 224,150 224,224 256,224 256,150 \t\t"},"children":[{"name":"polygon","attribs":{"points":"256,150 224,150 224,224 256,224 256,150 \t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,272h-32v90h32V272L256,272z"},"children":[{"name":"path","attribs":{"d":"M256,272h-32v90h32V272L256,272z"},"children":[]}]},{"name":"path","attribs":{"d":"M296,153.9v65.6c6-2.9,9.5-6.8,13.3-11.7c4.6-6,7-12.9,7-20.7c0-8.1-2.4-15-6.7-20.8C305.7,161.2,302,156.4,296,153.9\r\n\t\t\tL296,153.9z"},"children":[{"name":"path","attribs":{"d":"M296,153.9v65.6c6-2.9,9.5-6.8,13.3-11.7c4.6-6,7-12.9,7-20.7c0-8.1-2.4-15-6.7-20.8C305.7,161.2,302,156.4,296,153.9\r\n\t\t\tL296,153.9z"},"children":[]}]},{"name":"path","attribs":{"d":"M296,273.6v82.8c2-0.6,3.8-0.8,5.8-1.6c9.8-3.8,15.8-7.9,23.6-14.7c7.5-6.6,9.7-15.9,9.7-26.6c0-9.1-3.3-16.9-7.9-23.2\r\n\t\t\tc-4.6-6.3-11.7-9.9-19.4-13.2C304.1,275.4,301,274.4,296,273.6L296,273.6z"},"children":[{"name":"path","attribs":{"d":"M296,273.6v82.8c2-0.6,3.8-0.8,5.8-1.6c9.8-3.8,15.8-7.9,23.6-14.7c7.5-6.6,9.7-15.9,9.7-26.6c0-9.1-3.3-16.9-7.9-23.2\r\n\t\t\tc-4.6-6.3-11.7-9.9-19.4-13.2C304.1,275.4,301,274.4,296,273.6L296,273.6z"},"children":[]}]}]}]}]}]};exports.socialBitcoinOutline=socialBitcoinOutline;var socialBitcoin={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M410.5,279.2c-5-11.5-12.7-21.6-28.1-30.1c-8.2-4.5-16.1-7.8-25.4-10c5.4-2.5,10-5.4,16.3-11c7.5-6.6,13.1-15.7,15.6-23.3\r\n\tc2.6-7.5,4.1-18,3.5-28.2c-1.1-16.8-4.4-33.1-13.2-44.8c-8.8-11.7-21.2-20.7-37.6-27c-12.6-4.8-25.5-7.8-45.5-8.9V32h-40v64h-32V32\r\n\th-41v64H96v48h27.9c8.7,0,14.6,0.8,17.6,2.3c3.1,1.5,5.3,3.5,6.5,6c1.3,2.5,1.9,8.4,1.9,17.5V343c0,9-0.6,14.8-1.9,17.4\r\n\tc-1.3,2.6-2,4.9-5.1,6.3c-3.1,1.4-3.2,1.3-11.8,1.3h-26.4L96,416h87v64h41v-64h32v64h40v-64.4c26-1.3,44.5-4.7,59.4-10.3\r\n\tc19.3-7.2,34.1-17.7,44.7-31.5c10.6-13.8,14.9-34.9,15.8-51.2C416.6,308.1,415,289.4,410.5,279.2z M224,150h32v74h-32V150z M224,362\r\n\tv-90h32v90H224z M296,153.9c6,2.5,9.9,7.5,13.8,12.7c4.3,5.7,6.5,13.3,6.5,21.4c0,7.8-2.9,14.5-7.5,20.5c-3.8,4.9-6.8,8.3-12.8,11.1\r\n\tV153.9z M324.8,340.6c-7.8,6.9-12.3,10.1-22.1,13.8c-2,0.8-4.7,1.4-6.7,1.9v-82.8c5,0.8,7.6,1.8,11.3,3.4\r\n\tc7.8,3.3,15.2,6.9,19.8,13.2c4.6,6.3,8,15.6,8,24.7C335.1,325.7,332.3,334,324.8,340.6z"},"children":[]}]};exports.socialBitcoin=socialBitcoin;var socialBufferOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M70.7,164.5l169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7c8.9-4.3,8.9-11.3,0-15.6L272.1,67.2\r\n\t\t\tc-4.4-2.1-10.3-3.2-16.1-3.2s-11.7,1.1-16.1,3.2L70.7,148.9C61.8,153.2,61.8,160.2,70.7,164.5z M246.8,81.6\r\n\t\t\tc1.6-0.8,4.9-1.6,9.2-1.6c4.3,0,7.5,0.8,9.2,1.6l155.5,75.1l-155.5,75.1c-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6\r\n\t\t\tL91.3,156.7L246.8,81.6z"},"children":[{"name":"path","attribs":{"d":"M70.7,164.5l169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7c8.9-4.3,8.9-11.3,0-15.6L272.1,67.2\r\n\t\t\tc-4.4-2.1-10.3-3.2-16.1-3.2s-11.7,1.1-16.1,3.2L70.7,148.9C61.8,153.2,61.8,160.2,70.7,164.5z M246.8,81.6\r\n\t\t\tc1.6-0.8,4.9-1.6,9.2-1.6c4.3,0,7.5,0.8,9.2,1.6l155.5,75.1l-155.5,75.1c-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6\r\n\t\t\tL91.3,156.7L246.8,81.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M441.3,248.2c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1s-124.8,60.2-124.8,60.2c-4.5,2.1-10.3,3.2-16.1,3.2\r\n\t\t\ts-11.7-1.1-16.1-3.2c0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6\r\n\t\t\tl169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,259.5,450.2,252.5,441.3,248.2z M265.2,331.1\r\n\t\t\tc-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6L91.3,256l18.9-9.1l122.7,59.3c6.4,3.1,14.6,4.8,23.1,4.8s16.6-1.7,23.1-4.8\r\n\t\t\tl122.7-59.3l18.9,9.1L265.2,331.1z"},"children":[{"name":"path","attribs":{"d":"M441.3,248.2c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1s-124.8,60.2-124.8,60.2c-4.5,2.1-10.3,3.2-16.1,3.2\r\n\t\t\ts-11.7-1.1-16.1-3.2c0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6\r\n\t\t\tl169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,259.5,450.2,252.5,441.3,248.2z M265.2,331.1\r\n\t\t\tc-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6L91.3,256l18.9-9.1l122.7,59.3c6.4,3.1,14.6,4.8,23.1,4.8s16.6-1.7,23.1-4.8\r\n\t\t\tl122.7-59.3l18.9,9.1L265.2,331.1z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M441.3,347.5c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1S272.1,391,272.1,391c-4.5,2.1-10.3,3.2-16.1,3.2s-11.7-1.1-16.1-3.2\r\n\t\tc0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6l169.2,81.7\r\n\t\tc4.4,2.2,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,358.8,450.2,351.8,441.3,347.5z M265.2,430.4\r\n\t\tc-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6L91.3,355.3l18.9-9.1l122.7,59.3c6.4,3.1,14.6,4.8,23.1,4.8s16.6-1.7,23.1-4.8\r\n\t\tl122.7-59.3l18.9,9.1L265.2,430.4z"},"children":[{"name":"path","attribs":{"d":"M441.3,347.5c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1S272.1,391,272.1,391c-4.5,2.1-10.3,3.2-16.1,3.2s-11.7-1.1-16.1-3.2\r\n\t\tc0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6l169.2,81.7\r\n\t\tc4.4,2.2,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,358.8,450.2,351.8,441.3,347.5z M265.2,430.4\r\n\t\tc-1.6,0.8-4.9,1.6-9.2,1.6c-4.3,0-7.5-0.8-9.2-1.6L91.3,355.3l18.9-9.1l122.7,59.3c6.4,3.1,14.6,4.8,23.1,4.8s16.6-1.7,23.1-4.8\r\n\t\tl122.7-59.3l18.9,9.1L265.2,430.4z"},"children":[]}]}]}]};exports.socialBufferOutline=socialBufferOutline;var socialBuffer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M70.7,164.5l169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7c8.9-4.3,8.9-11.3,0-15.6L272.1,67.2\r\n\t\t\tc-4.4-2.1-10.3-3.2-16.1-3.2s-11.7,1.1-16.1,3.2L70.7,148.9C61.8,153.2,61.8,160.2,70.7,164.5z"},"children":[{"name":"path","attribs":{"d":"M70.7,164.5l169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7c8.9-4.3,8.9-11.3,0-15.6L272.1,67.2\r\n\t\t\tc-4.4-2.1-10.3-3.2-16.1-3.2s-11.7,1.1-16.1,3.2L70.7,148.9C61.8,153.2,61.8,160.2,70.7,164.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M441.3,248.2c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1s-124.8,60.2-124.8,60.2c-4.5,2.1-10.3,3.2-16.1,3.2\r\n\t\t\ts-11.7-1.1-16.1-3.2c0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6\r\n\t\t\tl169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,259.5,450.2,252.5,441.3,248.2z"},"children":[{"name":"path","attribs":{"d":"M441.3,248.2c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1s-124.8,60.2-124.8,60.2c-4.5,2.1-10.3,3.2-16.1,3.2\r\n\t\t\ts-11.7-1.1-16.1-3.2c0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6\r\n\t\t\tl169.2,81.7c4.4,2.1,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,259.5,450.2,252.5,441.3,248.2z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M441.3,347.5c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1S272.1,391,272.1,391c-4.5,2.1-10.3,3.2-16.1,3.2s-11.7-1.1-16.1-3.2\r\n\t\tc0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6l169.2,81.7\r\n\t\tc4.4,2.2,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,358.8,450.2,351.8,441.3,347.5z"},"children":[{"name":"path","attribs":{"d":"M441.3,347.5c0,0-30.9-14.9-35-16.9s-5.2-1.9-9.5,0.1S272.1,391,272.1,391c-4.5,2.1-10.3,3.2-16.1,3.2s-11.7-1.1-16.1-3.2\r\n\t\tc0,0-117.3-56.6-122.8-59.3c-6-2.9-7.7-2.9-13.1-0.3c-5.6,2.7-33.4,16.1-33.4,16.1c-8.9,4.3-8.9,11.3,0,15.6l169.2,81.7\r\n\t\tc4.4,2.2,10.3,3.2,16.1,3.2s11.7-1.1,16.1-3.2l169.2-81.7C450.2,358.8,450.2,351.8,441.3,347.5z"},"children":[]}]}]}]};exports.socialBuffer=socialBuffer;var socialChromeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"id":"Icon"},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.8,32,32,132.8,32,256s100.8,224,224,224s224-100.8,224-224S379.2,32,256,32z M256,76.799\r\n\t\t\tc66.084,0,124.315,35.843,154.558,89.602H256c-43.685,0-79.517,31.358-87.358,71.684l-53.758-92.969\r\n\t\t\tC147.358,103.685,198.884,76.799,256,76.799z M323.2,256c0,36.957-30.243,67.2-67.2,67.2s-67.2-30.243-67.2-67.2\r\n\t\t\ts30.243-67.2,67.2-67.2S323.2,219.043,323.2,256z M76.799,256c0-32.484,8.958-62.716,24.644-89.6L178.715,300.8l0,0\r\n\t\t\tc15.685,26.885,43.685,44.8,77.285,44.8c10.085,0,20.157-2.241,29.116-5.6l-53.758,92.958C144,421.758,76.799,346.715,76.799,256z\r\n\t\t\t M256,435.201L333.285,300.8l0,0c7.831-13.442,12.314-28,12.314-44.8c0-26.885-12.314-50.399-31.358-67.2h107.517\r\n\t\t\tc8.957,21.284,13.443,43.685,13.443,67.2C435.201,354.557,354.557,435.201,256,435.201z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.8,32,32,132.8,32,256s100.8,224,224,224s224-100.8,224-224S379.2,32,256,32z M256,76.799\r\n\t\t\tc66.084,0,124.315,35.843,154.558,89.602H256c-43.685,0-79.517,31.358-87.358,71.684l-53.758-92.969\r\n\t\t\tC147.358,103.685,198.884,76.799,256,76.799z M323.2,256c0,36.957-30.243,67.2-67.2,67.2s-67.2-30.243-67.2-67.2\r\n\t\t\ts30.243-67.2,67.2-67.2S323.2,219.043,323.2,256z M76.799,256c0-32.484,8.958-62.716,24.644-89.6L178.715,300.8l0,0\r\n\t\t\tc15.685,26.885,43.685,44.8,77.285,44.8c10.085,0,20.157-2.241,29.116-5.6l-53.758,92.958C144,421.758,76.799,346.715,76.799,256z\r\n\t\t\t M256,435.201L333.285,300.8l0,0c7.831-13.442,12.314-28,12.314-44.8c0-26.885-12.314-50.399-31.358-67.2h107.517\r\n\t\t\tc8.957,21.284,13.443,43.685,13.443,67.2C435.201,354.557,354.557,435.201,256,435.201z"},"children":[]}]}]}]}]}]};exports.socialChromeOutline=socialChromeOutline;var socialChrome={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M188.8,255.925c0,36.946,30.243,67.178,67.2,67.178s67.199-30.231,67.199-67.178c0-36.945-30.242-67.179-67.199-67.179\r\n\t\tS188.8,218.98,188.8,255.925z"},"children":[{"name":"path","attribs":{"d":"M188.8,255.925c0,36.946,30.243,67.178,67.2,67.178s67.199-30.231,67.199-67.178c0-36.945-30.242-67.179-67.199-67.179\r\n\t\tS188.8,218.98,188.8,255.925z"},"children":[]}]},{"name":"path","attribs":{"d":"M476.752,217.795c-0.009,0.005-0.016,0.038-0.024,0.042c-1.701-9.877-4.04-19.838-6.989-28.838h-0.107\r\n\t\tc2.983,9,5.352,19,7.072,29h-0.002c-1.719-10-4.088-20-7.07-29h-155.39c19.044,17,31.358,40.175,31.358,67.052\r\n\t\tc0,16.796-4.484,31.284-12.314,44.724L231.044,478.452c0,0-0.009,0.264-0.014,0.264l-0.01,0.284c0.005,0,0.009,0,0.015,0\r\n\t\tl-0.005-0.262c8.203,0.92,16.531,1.262,24.97,1.262c6.842,0,13.609-0.393,20.299-1.002c10.135-0.911,20.077-2.519,29.777-4.733\r\n\t\tC405.68,451.525,480,362.404,480,255.941C480,242.942,478.879,230.188,476.752,217.795z"},"children":[{"name":"path","attribs":{"d":"M476.752,217.795c-0.009,0.005-0.016,0.038-0.024,0.042c-1.701-9.877-4.04-19.838-6.989-28.838h-0.107\r\n\t\tc2.983,9,5.352,19,7.072,29h-0.002c-1.719-10-4.088-20-7.07-29h-155.39c19.044,17,31.358,40.175,31.358,67.052\r\n\t\tc0,16.796-4.484,31.284-12.314,44.724L231.044,478.452c0,0-0.009,0.264-0.014,0.264l-0.01,0.284c0.005,0,0.009,0,0.015,0\r\n\t\tl-0.005-0.262c8.203,0.92,16.531,1.262,24.97,1.262c6.842,0,13.609-0.393,20.299-1.002c10.135-0.911,20.077-2.519,29.777-4.733\r\n\t\tC405.68,451.525,480,362.404,480,255.941C480,242.942,478.879,230.188,476.752,217.795z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,345.496c-33.601,0-61.601-17.91-77.285-44.785L76.006,123.047l-0.137-0.236\r\n\t\tc-10.293,13.896-19.015,29.022-25.903,45.123C38.407,194.945,32,224.686,32,255.925c0,62.695,25.784,119.36,67.316,160.009\r\n\t\tc29.342,28.719,66.545,49.433,108.088,58.619l0.029-0.051l77.683-134.604C276.157,343.256,266.085,345.496,256,345.496z"},"children":[{"name":"path","attribs":{"d":"M256,345.496c-33.601,0-61.601-17.91-77.285-44.785L76.006,123.047l-0.137-0.236\r\n\t\tc-10.293,13.896-19.015,29.022-25.903,45.123C38.407,194.945,32,224.686,32,255.925c0,62.695,25.784,119.36,67.316,160.009\r\n\t\tc29.342,28.719,66.545,49.433,108.088,58.619l0.029-0.051l77.683-134.604C276.157,343.256,266.085,345.496,256,345.496z"},"children":[]}]},{"name":"path","attribs":{"d":"M91.292,104.575l77.35,133.25C176.483,197.513,212.315,166,256,166h205.172c-6.921-15-15.594-30.324-25.779-43.938\r\n\t\tc0.039,0.021,0.078,0.053,0.117,0.074C445.644,135.712,454.278,151,461.172,166h0.172c-6.884-15-15.514-30.38-25.668-43.99\r\n\t\tc-0.115-0.06-0.229-0.168-0.342-0.257C394.475,67.267,329.359,32,256,32c-26.372,0-51.673,4.569-75.172,12.936\r\n\t\tc-34.615,12.327-65.303,32.917-89.687,59.406l0.142,0.243C91.286,104.581,91.289,104.578,91.292,104.575z"},"children":[{"name":"path","attribs":{"d":"M91.292,104.575l77.35,133.25C176.483,197.513,212.315,166,256,166h205.172c-6.921-15-15.594-30.324-25.779-43.938\r\n\t\tc0.039,0.021,0.078,0.053,0.117,0.074C445.644,135.712,454.278,151,461.172,166h0.172c-6.884-15-15.514-30.38-25.668-43.99\r\n\t\tc-0.115-0.06-0.229-0.168-0.342-0.257C394.475,67.267,329.359,32,256,32c-26.372,0-51.673,4.569-75.172,12.936\r\n\t\tc-34.615,12.327-65.303,32.917-89.687,59.406l0.142,0.243C91.286,104.581,91.289,104.578,91.292,104.575z"},"children":[]}]}]}]};exports.socialChrome=socialChrome;var socialCodepenOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M387.547,203.724c-41.135-27.326-82.225-54.721-123.261-82.195\r\n\t\tc-5.844-3.912-11.12-3.802-16.938,0.095c-40.785,27.313-81.818,54.546-122.724,81.676c-5.103,3.384-7.624,7.575-7.624,13.716\r\n\t\tv79.729c0,6.174,2.484,10.342,7.594,13.73c40.906,27.13,81.841,54.361,122.625,81.676c5.81,3.891,11.131,4.055,16.984,0.137\r\n\t\tc41.035-27.474,82.145-54.873,123.286-82.188c4.858-3.226,7.511-7.309,7.511-13.094v-80.623\r\n\t\tC395,210.667,392.225,206.83,387.547,203.724z M268,152.484l93.055,62.218l-39.751,26.467c-0.919,0.603-2.923,0.604-3.839,0\r\n\t\tc-15.944-10.501-31.816-21.113-47.627-31.815c-1.033-0.699-1.828-2.319-1.838-3.52V152.484z M244,152.765v51.706\r\n\t\tc-0.024,1.825-1.313,4.316-2.799,5.334c-15.258,10.451-30.655,20.701-46.109,30.86c-1.17,0.77-3.547,1.148-4.566,0.485\r\n\t\tc-13.116-8.531-26.087-17.284-39.787-26.443C181.967,193.889,244,152.765,244,152.765z M141,237.116l29.622,19.771L141,276.725\r\n\t\tV237.116z M244,361.317c0,0-62.034-41.412-93.196-62.187l38.871-26.154c2.072-1.442,3.473-1.344,5.502,0.029\r\n\t\tc15.32,10.36,30.74,20.572,46.062,30.93c1.208,0.815,2.749,2.371,2.761,3.596V361.317z M258.949,282.892\r\n\t\tc-1.824,1.108-4.512,1.046-6.26-0.111l-38.842-25.865c0,0,17.108-11.493,25.356-17.023c4.701-3.152,9.346-6.393,14.164-9.355\r\n\t\tc1.132-0.696,3.532-0.97,4.743-0.168c5.773,3.829,39.854,26.53,39.854,26.53L258.949,282.892z M268,361.102v-51.346\r\n\t\tc-0.026-2.871,0.449-4.602,2.861-6.189c15.198-10.006,30.332-20.11,45.386-30.332c2.335-1.586,3.92-1.623,6.265-0.019\r\n\t\tl38.527,25.882L268,361.102z M370,276.676l-29.59-19.743L370,237.06V276.676z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M387.547,203.724c-41.135-27.326-82.225-54.721-123.261-82.195\r\n\t\tc-5.844-3.912-11.12-3.802-16.938,0.095c-40.785,27.313-81.818,54.546-122.724,81.676c-5.103,3.384-7.624,7.575-7.624,13.716\r\n\t\tv79.729c0,6.174,2.484,10.342,7.594,13.73c40.906,27.13,81.841,54.361,122.625,81.676c5.81,3.891,11.131,4.055,16.984,0.137\r\n\t\tc41.035-27.474,82.145-54.873,123.286-82.188c4.858-3.226,7.511-7.309,7.511-13.094v-80.623\r\n\t\tC395,210.667,392.225,206.83,387.547,203.724z M268,152.484l93.055,62.218l-39.751,26.467c-0.919,0.603-2.923,0.604-3.839,0\r\n\t\tc-15.944-10.501-31.816-21.113-47.627-31.815c-1.033-0.699-1.828-2.319-1.838-3.52V152.484z M244,152.765v51.706\r\n\t\tc-0.024,1.825-1.313,4.316-2.799,5.334c-15.258,10.451-30.655,20.701-46.109,30.86c-1.17,0.77-3.547,1.148-4.566,0.485\r\n\t\tc-13.116-8.531-26.087-17.284-39.787-26.443C181.967,193.889,244,152.765,244,152.765z M141,237.116l29.622,19.771L141,276.725\r\n\t\tV237.116z M244,361.317c0,0-62.034-41.412-93.196-62.187l38.871-26.154c2.072-1.442,3.473-1.344,5.502,0.029\r\n\t\tc15.32,10.36,30.74,20.572,46.062,30.93c1.208,0.815,2.749,2.371,2.761,3.596V361.317z M258.949,282.892\r\n\t\tc-1.824,1.108-4.512,1.046-6.26-0.111l-38.842-25.865c0,0,17.108-11.493,25.356-17.023c4.701-3.152,9.346-6.393,14.164-9.355\r\n\t\tc1.132-0.696,3.532-0.97,4.743-0.168c5.773,3.829,39.854,26.53,39.854,26.53L258.949,282.892z M268,361.102v-51.346\r\n\t\tc-0.026-2.871,0.449-4.602,2.861-6.189c15.198-10.006,30.332-20.11,45.386-30.332c2.335-1.586,3.92-1.623,6.265-0.019\r\n\t\tl38.527,25.882L268,361.102z M370,276.676l-29.59-19.743L370,237.06V276.676z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,64c51.285,0,99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256s-19.972,99.5-56.235,135.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64 M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32\r\n\t\tL256,32z"},"children":[{"name":"path","attribs":{"d":"M256,64c51.285,0,99.5,19.972,135.765,56.235C428.028,156.5,448,204.715,448,256s-19.972,99.5-56.235,135.765\r\n\t\tC355.5,428.028,307.285,448,256,448s-99.5-19.972-135.765-56.235C83.972,355.5,64,307.285,64,256s19.972-99.5,56.235-135.765\r\n\t\tC156.5,83.972,204.715,64,256,64 M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32\r\n\t\tL256,32z"},"children":[]}]}]}]};exports.socialCodepenOutline=socialCodepenOutline;var socialCodepen={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M241.239,303.936c-15.322-10.357-30.742-20.569-46.062-30.93c-2.03-1.373-3.43-1.472-5.502-0.029l-38.871,26.154\r\n\t\tC181.966,319.905,244,361.317,244,361.317v-53.786C243.988,306.307,242.447,304.751,241.239,303.936z"},"children":[{"name":"path","attribs":{"d":"M241.239,303.936c-15.322-10.357-30.742-20.569-46.062-30.93c-2.03-1.373-3.43-1.472-5.502-0.029l-38.871,26.154\r\n\t\tC181.966,319.905,244,361.317,244,361.317v-53.786C243.988,306.307,242.447,304.751,241.239,303.936z"},"children":[]}]},{"name":"path","attribs":{"d":"M195.092,240.666c15.454-10.16,30.851-20.409,46.109-30.86c1.486-1.018,2.775-3.509,2.799-5.334v-51.706\r\n\t\tc0,0-62.033,41.124-93.262,61.942c13.7,9.159,26.671,17.913,39.787,26.443C191.545,241.813,193.921,241.435,195.092,240.666z"},"children":[{"name":"path","attribs":{"d":"M195.092,240.666c15.454-10.16,30.851-20.409,46.109-30.86c1.486-1.018,2.775-3.509,2.799-5.334v-51.706\r\n\t\tc0,0-62.033,41.124-93.262,61.942c13.7,9.159,26.671,17.913,39.787,26.443C191.545,241.813,193.921,241.435,195.092,240.666z"},"children":[]}]},{"name":"path","attribs":{"d":"M269.838,209.354c15.811,10.703,31.683,21.314,47.627,31.815c0.916,0.604,2.92,0.602,3.839,0l39.751-26.467L268,152.484\r\n\t\tv53.35C268.01,207.035,268.805,208.655,269.838,209.354z"},"children":[{"name":"path","attribs":{"d":"M269.838,209.354c15.811,10.703,31.683,21.314,47.627,31.815c0.916,0.604,2.92,0.602,3.839,0l39.751-26.467L268,152.484\r\n\t\tv53.35C268.01,207.035,268.805,208.655,269.838,209.354z"},"children":[]}]},{"name":"path","attribs":{"d":"M258.109,230.369c-1.21-0.802-3.611-0.528-4.743,0.168c-4.817,2.962-9.463,6.203-14.164,9.355\r\n\t\tc-8.248,5.53-25.356,17.023-25.356,17.023l38.842,25.865c1.748,1.157,4.436,1.22,6.26,0.111l39.014-25.993\r\n\t\tC297.963,256.898,263.883,234.197,258.109,230.369z"},"children":[{"name":"path","attribs":{"d":"M258.109,230.369c-1.21-0.802-3.611-0.528-4.743,0.168c-4.817,2.962-9.463,6.203-14.164,9.355\r\n\t\tc-8.248,5.53-25.356,17.023-25.356,17.023l38.842,25.865c1.748,1.157,4.436,1.22,6.26,0.111l39.014-25.993\r\n\t\tC297.963,256.898,263.883,234.197,258.109,230.369z"},"children":[]}]},{"name":"polygon","attribs":{"points":"141,237.116 141,276.725 170.622,256.887 \t"},"children":[{"name":"polygon","attribs":{"points":"141,237.116 141,276.725 170.622,256.887 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M395,297.006\r\n\t\tc0,5.785-2.652,9.868-7.511,13.094c-41.142,27.314-82.251,54.714-123.286,82.188c-5.854,3.918-11.174,3.754-16.984-0.137\r\n\t\tc-40.783-27.314-81.719-54.546-122.625-81.676c-5.11-3.389-7.594-7.557-7.594-13.73v-79.729c0-6.141,2.521-10.332,7.624-13.716\r\n\t\tc40.906-27.13,81.939-54.363,122.724-81.676c5.818-3.896,11.094-4.007,16.938-0.095c41.036,27.474,82.126,54.869,123.261,82.195\r\n\t\tc4.678,3.106,7.453,6.943,7.453,12.66V297.006z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.288,32,32,132.288,32,256s100.288,224,224,224s224-100.288,224-224S379.712,32,256,32z M395,297.006\r\n\t\tc0,5.785-2.652,9.868-7.511,13.094c-41.142,27.314-82.251,54.714-123.286,82.188c-5.854,3.918-11.174,3.754-16.984-0.137\r\n\t\tc-40.783-27.314-81.719-54.546-122.625-81.676c-5.11-3.389-7.594-7.557-7.594-13.73v-79.729c0-6.141,2.521-10.332,7.624-13.716\r\n\t\tc40.906-27.13,81.939-54.363,122.724-81.676c5.818-3.896,11.094-4.007,16.938-0.095c41.036,27.474,82.126,54.869,123.261,82.195\r\n\t\tc4.678,3.106,7.453,6.943,7.453,12.66V297.006z"},"children":[]}]},{"name":"path","attribs":{"d":"M316.247,273.234c-15.054,10.222-30.188,20.326-45.386,30.332c-2.412,1.588-2.888,3.318-2.861,6.189v51.346l93.039-62.004\r\n\t\tl-38.527-25.882C320.167,271.611,318.582,271.648,316.247,273.234z"},"children":[{"name":"path","attribs":{"d":"M316.247,273.234c-15.054,10.222-30.188,20.326-45.386,30.332c-2.412,1.588-2.888,3.318-2.861,6.189v51.346l93.039-62.004\r\n\t\tl-38.527-25.882C320.167,271.611,318.582,271.648,316.247,273.234z"},"children":[]}]},{"name":"polygon","attribs":{"points":"370,276.676 370,237.06 340.41,256.933 \t"},"children":[{"name":"polygon","attribs":{"points":"370,276.676 370,237.06 340.41,256.933 \t"},"children":[]}]}]}]};exports.socialCodepen=socialCodepen;var socialCss3Outline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M354.676,366.898l-98.608,28.125l-98.458-28.248L150.864,289h48.253l3.433,39.563l53.586,15.163l0.132,0.273h0.034\r\n\t\tl53.467-14.852L315.381,265H203l-4-50h120.646l4.396-51H140l-4-49h240.58L354.676,366.898z"},"children":[{"name":"path","attribs":{"d":"M354.676,366.898l-98.608,28.125l-98.458-28.248L150.864,289h48.253l3.433,39.563l53.586,15.163l0.132,0.273h0.034\r\n\t\tl53.467-14.852L315.381,265H203l-4-50h120.646l4.396-51H140l-4-49h240.58L354.676,366.898z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,32l34.936,403.301L255.769,480l157.245-44.705L448,32H64z M383.041,410.51l-127.262,36.187l-126.867-36.169L98.896,64\r\n\t\tH413.1L383.041,410.51z"},"children":[{"name":"path","attribs":{"d":"M64,32l34.936,403.301L255.769,480l157.245-44.705L448,32H64z M383.041,410.51l-127.262,36.187l-126.867-36.169L98.896,64\r\n\t\tH413.1L383.041,410.51z"},"children":[]}]}]}]};exports.socialCss3Outline=socialCss3Outline;var socialCss3={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"transform":"translate(336 96)"},"children":[{"name":"g","attribs":{"id":"icon-css3"},"children":[{"name":"g","attribs":{"id":"icon-css3"},"children":[{"name":"path","attribs":{"d":"M-79.718,243.488L-79.718,243.488z"},"children":[{"name":"path","attribs":{"d":"M-79.718,243.488L-79.718,243.488z"},"children":[]}]},{"name":"path","attribs":{"d":"M-272-64l34.946,403.219L-80.233,384l157.259-44.85L112-64H-272z M18.676,270.898l-98.607,28.125l-98.458-28.248\r\n\t\t\tL-185.136,193h48.253l3.433,39.562l53.586,15.163l0.132,0.273h0.034l53.467-14.852L-20.619,169H-133l-4-50h120.646l4.396-51H-196\r\n\t\t\tl-4-49H40.58L18.676,270.898z"},"children":[{"name":"path","attribs":{"d":"M-272-64l34.946,403.219L-80.233,384l157.259-44.85L112-64H-272z M18.676,270.898l-98.607,28.125l-98.458-28.248\r\n\t\t\tL-185.136,193h48.253l3.433,39.562l53.586,15.163l0.132,0.273h0.034l53.467-14.852L-20.619,169H-133l-4-50h120.646l4.396-51H-196\r\n\t\t\tl-4-49H40.58L18.676,270.898z"},"children":[]}]}]}]}]}]};exports.socialCss3=socialCss3;var socialDesignernewsOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"290.9,145.9 226.5,96 291.1,198.8 \t"},"children":[{"name":"polygon","attribs":{"points":"290.9,145.9 226.5,96 291.1,198.8 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M32.5,260"},"children":[{"name":"path","attribs":{"d":"M32.5,260"},"children":[]}]},{"name":"path","attribs":{"d":"M329,96v80.3V260h-35.9l-63.2-98l1.7,98H191V152.9l-37.1-29.1c1,1.2,2.1,2.4,3,3.6c10,13.8,15,30.7,15,50.5\r\n\t\t\tc0,48.9-30.5,82-76.8,82H32l200.1,156H480V214.7L329,96z M464,400H237.7L78.6,276h16.5c13.5,0,26.2-2.7,37.7-7.4\r\n\t\t\tc11.5-4.7,21.4-11.8,29.8-20.7c4.8-5.1,9.4-11,12.4-17.1v28.7V276h16.2h40.4H248l-0.3-16.5l-0.7-41.9l32.6,50.7l4.7,7.6h8.8h36.8\r\n\t\t\tH345v-16.5v-83.1v-47l0.2,0.3L464,222.4V400z"},"children":[{"name":"path","attribs":{"d":"M329,96v80.3V260h-35.9l-63.2-98l1.7,98H191V152.9l-37.1-29.1c1,1.2,2.1,2.4,3,3.6c10,13.8,15,30.7,15,50.5\r\n\t\t\tc0,48.9-30.5,82-76.8,82H32l200.1,156H480V214.7L329,96z M464,400H237.7L78.6,276h16.5c13.5,0,26.2-2.7,37.7-7.4\r\n\t\t\tc11.5-4.7,21.4-11.8,29.8-20.7c4.8-5.1,9.4-11,12.4-17.1v28.7V276h16.2h40.4H248l-0.3-16.5l-0.7-41.9l32.6,50.7l4.7,7.6h8.8h36.8\r\n\t\t\tH345v-16.5v-83.1v-47l0.2,0.3L464,222.4V400z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M90.6,150.4c11,0,23.7,3.2,23.7,28.8c0,6.9-1,16.3-6,21.8c-3.6,3.9-9.6,6-17.7,6H87v-57h3 M90.7,134H71v89h19.5\r\n\t\tc26,0,39.9-15.6,39.9-43.9C130.4,150.3,116.1,134,90.7,134L90.7,134z"},"children":[{"name":"path","attribs":{"d":"M90.6,150.4c11,0,23.7,3.2,23.7,28.8c0,6.9-1,16.3-6,21.8c-3.6,3.9-9.6,6-17.7,6H87v-57h3 M90.7,134H71v89h19.5\r\n\t\tc26,0,39.9-15.6,39.9-43.9C130.4,150.3,116.1,134,90.7,134L90.7,134z"},"children":[]}]}]}]};exports.socialDesignernewsOutline=socialDesignernewsOutline;var socialDesignernews={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"290.4,145 227,96 290.6,198.2 \t\t"},"children":[{"name":"polygon","attribs":{"points":"290.4,145 227,96 290.6,198.2 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M329,96v79.6V259h-36.4l-63.2-98.6l1.7,98.6H191V152l-37.3-29.3c1,1.2,2,2.4,2.9,3.7c10,13.9,15,30.5,15,50.5\r\n\t\t\tc0,49.2-30.6,82.1-76.9,82.1H32v0.4L231.6,416H480V214.1L329,96z"},"children":[{"name":"path","attribs":{"d":"M329,96v79.6V259h-36.4l-63.2-98.6l1.7,98.6H191V152l-37.3-29.3c1,1.2,2,2.4,2.9,3.7c10,13.9,15,30.5,15,50.5\r\n\t\t\tc0,49.2-30.6,82.1-76.9,82.1H32v0.4L231.6,416H480V214.1L329,96z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M129.9,178.1c0-29-14.2-45.1-39.7-45.1H71v89h19C116,222,129.9,206.6,129.9,178.1z"},"children":[{"name":"path","attribs":{"d":"M129.9,178.1c0-29-14.2-45.1-39.7-45.1H71v89h19C116,222,129.9,206.6,129.9,178.1z"},"children":[]}]}]}]}]}]};exports.socialDesignernews=socialDesignernews;var socialDribbbleOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,64C150,64,64,150,64,256c0,106.1,86,192,192,192s192-85.9,192-192C448,150,362,64,256,64z M377.9,152.5\r\n\tc21.6,25.4,35.3,57.6,37.7,92.9c-34.6-1.8-76-1.8-109.2,1.3c-4.2-10.6-8.5-21-13.2-31C331.5,199.1,361,177.3,377.9,152.5z M256,96\r\n\tc38.8,0,74.4,13.8,102.1,36.8c-17.4,22-44.7,41.1-78.7,55.6c-18.6-34.4-40-64-62.8-87.3C229.3,97.9,242.4,96,256,96z M183.6,113.5\r\n\tc23.1,23,44.8,52.3,63.8,86.6c-36.1,11-77.5,17.3-121.7,17.3c-8.4,0-16.6-0.3-24.7-0.8C112.5,171.5,143,134.1,183.6,113.5z\r\n\t M96.3,248.4c9.1,0.4,18.3,0.6,27.6,0.5c50.4-0.6,97.3-8.5,137.6-21.4c3.8,7.9,7.4,16,10.8,24.3c-5.5,1.3-10.4,2.7-14.3,4.3\r\n\tc-55.1,23.1-98.5,60.4-122,105.5c-24.8-28.2-40-65.1-40-105.6C96,253.4,96.1,250.9,96.3,248.4z M256,416c-37,0-71-12.6-98.1-33.7\r\n\tc21.3-42.2,59.3-77.1,107.2-98.8c4.5-2.1,10.5-3.8,17.4-5.3c5.7,15.8,10.8,32.2,15.3,49.2c6.9,26.5,11.8,52.7,14.8,78.1\r\n\tC295,412.2,276,416,256,416z M342.5,390.5c-3-25.7-7.9-52.1-14.9-78.9c-3.4-13-7.3-25.6-11.5-37.9c31.4-2.6,69-2.2,98.9,0\r\n\tC409.6,322.8,382,365,342.5,390.5z"},"children":[]}]};exports.socialDribbbleOutline=socialDribbbleOutline;var socialDribbble={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,64C150,64,64,150,64,256c0,106.1,86,192,192,192s192-85.9,192-192C448,150,362,64,256,64z M256,415.5\r\n\t\t\tc-88.1,0-159.5-71.4-159.5-159.5c0-88.1,71.4-159.5,159.5-159.5c88.1,0,159.5,71.4,159.5,159.5C415.5,344.1,344.1,415.5,256,415.5\r\n\t\t\tz"},"children":[{"name":"path","attribs":{"d":"M256,64C150,64,64,150,64,256c0,106.1,86,192,192,192s192-85.9,192-192C448,150,362,64,256,64z M256,415.5\r\n\t\t\tc-88.1,0-159.5-71.4-159.5-159.5c0-88.1,71.4-159.5,159.5-159.5c88.1,0,159.5,71.4,159.5,159.5C415.5,344.1,344.1,415.5,256,415.5\r\n\t\t\tz"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M306.3,246.7c23.4-2.2,50.9-2.9,77.2-2.4c-2.3-25.4-12-48.7-27-67.6c-16.5,14.9-38,28.1-63.3,39\r\n\t\t\tC297.8,225.7,302.1,236.1,306.3,246.7z"},"children":[{"name":"path","attribs":{"d":"M306.3,246.7c23.4-2.2,50.9-2.9,77.2-2.4c-2.3-25.4-12-48.7-27-67.6c-16.5,14.9-38,28.1-63.3,39\r\n\t\t\tC297.8,225.7,302.1,236.1,306.3,246.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M335.4,155.6C313.6,138.3,286,128,256,128c-5.1,0-10.2,0.3-15.2,0.9c13.8,17.7,26.7,37.6,38.6,59.5\r\n\t\t\tC301.1,179.2,320,168.1,335.4,155.6z"},"children":[{"name":"path","attribs":{"d":"M335.4,155.6C313.6,138.3,286,128,256,128c-5.1,0-10.2,0.3-15.2,0.9c13.8,17.7,26.7,37.6,38.6,59.5\r\n\t\t\tC301.1,179.2,320,168.1,335.4,155.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M205.9,138.2c-34.1,14.5-60.7,43.4-72,79.1c41.1-0.7,79.6-7,113.4-17.3C234.7,177,220.7,156.3,205.9,138.2z"},"children":[{"name":"path","attribs":{"d":"M205.9,138.2c-34.1,14.5-60.7,43.4-72,79.1c41.1-0.7,79.6-7,113.4-17.3C234.7,177,220.7,156.3,205.9,138.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M383,272.2c-22.3-0.6-46-0.2-66.9,1.5c4.1,12.3,8.1,24.9,11.5,37.9c3.8,14.6,7,29.1,9.6,43.4\r\n\t\t\tC361.8,334.7,378.8,305.4,383,272.2z"},"children":[{"name":"path","attribs":{"d":"M383,272.2c-22.3-0.6-46-0.2-66.9,1.5c4.1,12.3,8.1,24.9,11.5,37.9c3.8,14.6,7,29.1,9.6,43.4\r\n\t\t\tC361.8,334.7,378.8,305.4,383,272.2z"},"children":[]}]},{"name":"path","attribs":{"d":"M258,256.1c3.9-1.6,8.8-3,14.3-4.3c-3.4-8.3-7.1-16.4-10.8-24.3c-39.1,12.6-84.6,20.3-133.3,21.3\r\n\t\t\tc-0.1,2.4-0.2,4.8-0.2,7.3c0,29.1,9.7,55.9,26,77.4C178.9,301,214.9,274.2,258,256.1z"},"children":[{"name":"path","attribs":{"d":"M258,256.1c3.9-1.6,8.8-3,14.3-4.3c-3.4-8.3-7.1-16.4-10.8-24.3c-39.1,12.6-84.6,20.3-133.3,21.3\r\n\t\t\tc-0.1,2.4-0.2,4.8-0.2,7.3c0,29.1,9.7,55.9,26,77.4C178.9,301,214.9,274.2,258,256.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M282.6,278.2c-6.9,1.5-12.9,3.2-17.4,5.3c-37.1,16.8-68.3,41.6-90.4,71.5c22.1,18.2,50.4,29,81.2,29\r\n\t\t\tc18.5,0,36-3.9,51.8-10.9c-2.7-15.1-6-30.3-10-45.7C293.4,310.5,288.2,294,282.6,278.2z"},"children":[{"name":"path","attribs":{"d":"M282.6,278.2c-6.9,1.5-12.9,3.2-17.4,5.3c-37.1,16.8-68.3,41.6-90.4,71.5c22.1,18.2,50.4,29,81.2,29\r\n\t\t\tc18.5,0,36-3.9,51.8-10.9c-2.7-15.1-6-30.3-10-45.7C293.4,310.5,288.2,294,282.6,278.2z"},"children":[]}]}]}]}]}]};exports.socialDribbble=socialDribbble;var socialDropboxOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M177,77.1L64,151l78.3,63L256,143.2L177,77.1z M91.4,153.3l84.5-56.8l52.9,46L143.4,195L91.4,153.3z"},"children":[{"name":"path","attribs":{"d":"M177,77.1L64,151l78.3,63L256,143.2L177,77.1z M91.4,153.3l84.5-56.8l52.9,46L143.4,195L91.4,153.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M369.8,213L256,284.1l79,66.1l19-12.6v20.2L256,417l-98-58.5V338l19,12.2l79-66.1L142.2,213L64,276.3l78,51.5v39.4\r\n\t\tl114,67.8l114-68.5v-39.2l78-51.2L369.8,213z M143.4,230.9l85.4,55.4l-52.9,44.1l-84.5-55.8L143.4,230.9z M283.2,286.3l85.4-55.4\r\n\t\tl52.1,43.6l-84.5,55.8L283.2,286.3z"},"children":[{"name":"path","attribs":{"d":"M369.8,213L256,284.1l79,66.1l19-12.6v20.2L256,417l-98-58.5V338l19,12.2l79-66.1L142.2,213L64,276.3l78,51.5v39.4\r\n\t\tl114,67.8l114-68.5v-39.2l78-51.2L369.8,213z M143.4,230.9l85.4,55.4l-52.9,44.1l-84.5-55.8L143.4,230.9z M283.2,286.3l85.4-55.4\r\n\t\tl52.1,43.6l-84.5,55.8L283.2,286.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M448,151L335,77.1l-79,66.1l113.8,70.8L448,151z M283.2,142.6l52.9-46l84.5,56.8L368.6,195L283.2,142.6z"},"children":[{"name":"path","attribs":{"d":"M448,151L335,77.1l-79,66.1l113.8,70.8L448,151z M283.2,142.6l52.9-46l84.5,56.8L368.6,195L283.2,142.6z"},"children":[]}]}]}]};exports.socialDropboxOutline=socialDropboxOutline;var socialDropbox={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"177,77 64,150.9 142.1,213.6 256,143.1 \t"},"children":[{"name":"polygon","attribs":{"points":"177,77 64,150.9 142.1,213.6 256,143.1 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"64,276.3 177,350.2 256,284.1 142.1,213.6 \t"},"children":[{"name":"polygon","attribs":{"points":"64,276.3 177,350.2 256,284.1 142.1,213.6 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,284.1 335,350.2 448,276.3 369.9,213.6 \t"},"children":[{"name":"polygon","attribs":{"points":"256,284.1 335,350.2 448,276.3 369.9,213.6 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"448,150.9 335,77 256,143.1 369.9,213.6 \t"},"children":[{"name":"polygon","attribs":{"points":"448,150.9 335,77 256,143.1 369.9,213.6 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256.2,298.3 176.4,364.3 142,342.1 142,367 256,435 370,367 370,342.1 335.8,364.3 \t"},"children":[{"name":"polygon","attribs":{"points":"256.2,298.3 176.4,364.3 142,342.1 142,367 256,435 370,367 370,342.1 335.8,364.3 \t"},"children":[]}]}]}]};exports.socialDropbox=socialDropbox;var socialEuroOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M310.143,64c31.337,0,59.096,2.607,88.137,8.364l-5.06,34.148c-29.405-4.319-55.659-6.429-79.853-6.429\r\n\t\tc-35.025,0-58.535,6.153-74.129,19.365C220.142,135.627,218,158.428,218,174.17v2.33V193h15.867h120.184l-2.383,16H233.867H218\r\n\t\tv15.5v48V289h15.867h105.885l-2.384,16H233.867H218v15.5v12.33c0,19.546,2.338,44.061,21.084,60.274\r\n\t\tc15.042,13.01,37.921,18.812,74.258,18.812c24.534,0,50.197-2.055,79.771-6.42l5.014,34.138\r\n\t\tc-29.031,5.759-56.741,8.366-87.977,8.366c-52.591,0-91.43-9.08-115.565-26.987C172.615,404.711,162,380.361,162,346.57V320.5V305\r\n\t\th-16.133H112v-16h33.867H162v-16.5v-48V209h-16.133H112v-16h33.867H162v-16.5v-11.07c0-33.791,10.613-58.142,32.582-74.442\r\n\t\tC218.715,73.08,257.552,64,310.143,64 M310.209,48C195.479,48,146,89.225,146,165.43V177H96v48h50v48H96v48h50v25.57\r\n\t\tC146,422.774,195.481,464,310.211,464c35.25,0,67.777-3.123,105.789-11.866l-9.411-64.96c-37.323,6.244-66.942,8.742-93.206,8.742\r\n\t\tc-64.275,0-79.383-18.739-79.383-63.086V321h117.162l7.148-48H234v-48h131.461l7.149-48H234v-2.83\r\n\t\tc0-35.92,15.159-58.086,79.434-58.086c26.264,0,55.959,2.498,93.281,8.742L416,60C377.988,51.257,345.458,48,310.209,48L310.209,48\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M310.143,64c31.337,0,59.096,2.607,88.137,8.364l-5.06,34.148c-29.405-4.319-55.659-6.429-79.853-6.429\r\n\t\tc-35.025,0-58.535,6.153-74.129,19.365C220.142,135.627,218,158.428,218,174.17v2.33V193h15.867h120.184l-2.383,16H233.867H218\r\n\t\tv15.5v48V289h15.867h105.885l-2.384,16H233.867H218v15.5v12.33c0,19.546,2.338,44.061,21.084,60.274\r\n\t\tc15.042,13.01,37.921,18.812,74.258,18.812c24.534,0,50.197-2.055,79.771-6.42l5.014,34.138\r\n\t\tc-29.031,5.759-56.741,8.366-87.977,8.366c-52.591,0-91.43-9.08-115.565-26.987C172.615,404.711,162,380.361,162,346.57V320.5V305\r\n\t\th-16.133H112v-16h33.867H162v-16.5v-48V209h-16.133H112v-16h33.867H162v-16.5v-11.07c0-33.791,10.613-58.142,32.582-74.442\r\n\t\tC218.715,73.08,257.552,64,310.143,64 M310.209,48C195.479,48,146,89.225,146,165.43V177H96v48h50v48H96v48h50v25.57\r\n\t\tC146,422.774,195.481,464,310.211,464c35.25,0,67.777-3.123,105.789-11.866l-9.411-64.96c-37.323,6.244-66.942,8.742-93.206,8.742\r\n\t\tc-64.275,0-79.383-18.739-79.383-63.086V321h117.162l7.148-48H234v-48h131.461l7.149-48H234v-2.83\r\n\t\tc0-35.92,15.159-58.086,79.434-58.086c26.264,0,55.959,2.498,93.281,8.742L416,60C377.988,51.257,345.458,48,310.209,48L310.209,48\r\n\t\tz"},"children":[]}]}]}]};exports.socialEuroOutline=socialEuroOutline;var socialEuro={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M234,272v-48h131.094l7.149-48H234v-1.83c0-35.92,14.975-58.086,79.25-58.086c26.264,0,55.867,2.498,93.189,8.742\r\n\t\tL416,59.866C377.988,51.123,345.306,48,310.057,48C195.326,48,146,89.225,146,165.43V176H96v48h50v48H96v48h50v26.57\r\n\t\tC146,422.774,195.297,464,310.027,464c35.25,0,67.848-3.123,105.859-11.866l-9.619-64.96c-37.322,6.244-66.781,8.742-93.045,8.742\r\n\t\tc-64.276,0-79.223-18.739-79.223-63.086V320h116.795l7.148-48H234z"},"children":[{"name":"path","attribs":{"d":"M234,272v-48h131.094l7.149-48H234v-1.83c0-35.92,14.975-58.086,79.25-58.086c26.264,0,55.867,2.498,93.189,8.742\r\n\t\tL416,59.866C377.988,51.123,345.306,48,310.057,48C195.326,48,146,89.225,146,165.43V176H96v48h50v48H96v48h50v26.57\r\n\t\tC146,422.774,195.297,464,310.027,464c35.25,0,67.848-3.123,105.859-11.866l-9.619-64.96c-37.322,6.244-66.781,8.742-93.045,8.742\r\n\t\tc-64.276,0-79.223-18.739-79.223-63.086V320h116.795l7.148-48H234z"},"children":[]}]}]}]};exports.socialEuro=socialEuro;var socialFacebookOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M288,192v-38.1c0-17.2,3.8-25.9,30.5-25.9H352V64h-55.9c-68.5,0-91.1,31.4-91.1,85.3V192h-45v64h45v192h83V256h56.4l7.6-64\r\n\tH288z M330.2,240h-41.1H272v15.5V432h-51V255.5V240h-14.9H176v-32h30.1H221v-16.5v-42.2c0-24.5,5.4-41.2,15.5-51.8\r\n\tC247.7,85.5,267.6,80,296.1,80H336v32h-17.5c-12,0-27.5,1.1-37.1,11.7c-8.1,9-9.4,20.1-9.4,30.1v37.6V208h17.1H334L330.2,240z"},"children":[]}]};exports.socialFacebookOutline=socialFacebookOutline;var socialFacebook={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M288,192v-38.1c0-17.2,3.8-25.9,30.5-25.9H352V64h-55.9c-68.5,0-91.1,31.4-91.1,85.3V192h-45v64h45v192h83V256h56.4l7.6-64\r\n\tH288z"},"children":[]}]};exports.socialFacebook=socialFacebook;var socialFoursquareOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M398.484,164.452l-27.399,137.185C372.848,294.486,386.545,224.793,398.484,164.452z"},"children":[{"name":"path","attribs":{"d":"M398.484,164.452l-27.399,137.185C372.848,294.486,386.545,224.793,398.484,164.452z"},"children":[]}]},{"name":"path","attribs":{"d":"M376.764,32c0,0-205.353,0-238.223,0C105.666,32,96,56.798,96,72.414c0,15.627,0,379.64,0,379.64\r\n\t\tc0,17.591,9.425,24.117,14.718,26.267c5.299,2.155,19.916,3.971,28.673-6.168c0,0,112.469-131.09,114.4-133.027\r\n\t\tc2.921-2.931,2.921-3.125,5.844-3.125c5.843,0,49.192,0,72.766,0c30.575,0,35.49-21.676,38.684-34.559l27.399-137.087\r\n\t\tc6.074-30.702,11.693-58.938,15.053-75.325C421.143,51.944,411.744,32,376.764,32z M376.426,96c0,0-31.575,156.209-36.034,176.834\r\n\t\tC335,297.771,332.75,304,307,304c-17.605,0-62.375,0-62.375,0c-2.747,0-3.868-0.147-6.049,2.041\r\n\t\tc-1.443,1.447-78.168,89.562-78.168,89.562c-19.034,23.396-26.909,31.795-29.033,31.795s-3.375,0-3.375-38.408V91.708\r\n\t\tC128,67.034,128.3,64,157.198,64C181.748,64,352,64,352,64C382,64,382.834,64.833,376.426,96z"},"children":[{"name":"path","attribs":{"d":"M376.764,32c0,0-205.353,0-238.223,0C105.666,32,96,56.798,96,72.414c0,15.627,0,379.64,0,379.64\r\n\t\tc0,17.591,9.425,24.117,14.718,26.267c5.299,2.155,19.916,3.971,28.673-6.168c0,0,112.469-131.09,114.4-133.027\r\n\t\tc2.921-2.931,2.921-3.125,5.844-3.125c5.843,0,49.192,0,72.766,0c30.575,0,35.49-21.676,38.684-34.559l27.399-137.087\r\n\t\tc6.074-30.702,11.693-58.938,15.053-75.325C421.143,51.944,411.744,32,376.764,32z M376.426,96c0,0-31.575,156.209-36.034,176.834\r\n\t\tC335,297.771,332.75,304,307,304c-17.605,0-62.375,0-62.375,0c-2.747,0-3.868-0.147-6.049,2.041\r\n\t\tc-1.443,1.447-78.168,89.562-78.168,89.562c-19.034,23.396-26.909,31.795-29.033,31.795s-3.375,0-3.375-38.408V91.708\r\n\t\tC128,67.034,128.3,64,157.198,64C181.748,64,352,64,352,64C382,64,382.834,64.833,376.426,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M398.484,164.452l15.053-75.374C410.178,105.466,404.559,133.75,398.484,164.452z"},"children":[{"name":"path","attribs":{"d":"M398.484,164.452l15.053-75.374C410.178,105.466,404.559,133.75,398.484,164.452z"},"children":[]}]},{"name":"path","attribs":{"d":"M328.573,96c-5.571,0-157.995,0-157.995,0C164.091,96,160,101.594,160,106.586v231.255c0,0.67,0.402,0.975,0.935,0.36\r\n\t\tc0,0,48.202-55.725,54.056-63.021c5.848-7.289,8.491-8.182,17.233-8.182c0,0,56.695,0,62.212,0c6.549,0,10.24-5.75,10.913-8.982\r\n\t\tc0.671-3.228,10.536-48.213,11.732-54.119c1.191-5.897-4.214-11.898-9.722-11.898c-5.5,0-64.805,0-64.805,0\r\n\t\tc-7.803,0-7.554-5.653-7.554-13.476v-5.512c0-7.815-0.282-13.012,7.516-13.012c0,0,70.403,0,75.313,0\r\n\t\tc4.911,0,10.208-4.442,11.102-8.662l8.468-44.042C338.739,100.823,333.828,96,328.573,96z"},"children":[{"name":"path","attribs":{"d":"M328.573,96c-5.571,0-157.995,0-157.995,0C164.091,96,160,101.594,160,106.586v231.255c0,0.67,0.402,0.975,0.935,0.36\r\n\t\tc0,0,48.202-55.725,54.056-63.021c5.848-7.289,8.491-8.182,17.233-8.182c0,0,56.695,0,62.212,0c6.549,0,10.24-5.75,10.913-8.982\r\n\t\tc0.671-3.228,10.536-48.213,11.732-54.119c1.191-5.897-4.214-11.898-9.722-11.898c-5.5,0-64.805,0-64.805,0\r\n\t\tc-7.803,0-7.554-5.653-7.554-13.476v-5.512c0-7.815-0.282-13.012,7.516-13.012c0,0,70.403,0,75.313,0\r\n\t\tc4.911,0,10.208-4.442,11.102-8.662l8.468-44.042C338.739,100.823,333.828,96,328.573,96z"},"children":[]}]}]}]};exports.socialFoursquareOutline=socialFoursquareOutline;var socialFoursquare={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M376.764,32c0,0-205.353,0-238.223,0C105.666,32,96,56.798,96,72.414c0,15.627,0,379.64,0,379.64\r\n\t\t\tc0,17.591,9.425,24.117,14.718,26.267c5.299,2.155,19.916,3.971,28.673-6.168c0,0,112.469-130.895,114.4-132.834\r\n\t\t\tc2.921-2.93,2.921-2.93,5.844-2.93c5.844,0,49.192,0,72.767,0c30.574,0,35.49-21.869,38.684-34.752\r\n\t\t\tc2.659-10.789,32.489-163.962,42.452-212.559C421.143,51.993,411.745,32,376.764,32z M371.086,301.637\r\n\t\t\tc2.659-10.789,32.489-163.962,42.452-212.559 M362.692,96.67l-9.999,51.734c-1.195,5.65-8.287,11.595-14.863,11.595\r\n\t\t\tc-6.575,0-95.917,0-95.917,0C231.473,160,224,166.138,224,176.602v13.448c0,10.473,7.519,17.894,17.965,17.894\r\n\t\t\tc0,0,74.482,0,81.848,0c7.374,0,14.61,8.109,13.016,16.005c-1.602,7.908-9.086,46.569-9.984,50.89\r\n\t\t\tc-0.902,4.328-5.845,11.725-14.611,11.725c-7.388,0-64.269,0-64.269,0c-11.705,0-15.244,1.533-23.074,11.293\r\n\t\t\tc-7.837,9.77-78.256,94.592-78.256,94.592c-0.713,0.822-1.41,0.584-1.41-0.312V95.896c0-6.684,5.793-14.523,14.479-14.523\r\n\t\t\tc0,0,183.713,0,191.173,0C357.912,81.372,364.488,88.004,362.692,96.67z"},"children":[{"name":"path","attribs":{"d":"M376.764,32c0,0-205.353,0-238.223,0C105.666,32,96,56.798,96,72.414c0,15.627,0,379.64,0,379.64\r\n\t\t\tc0,17.591,9.425,24.117,14.718,26.267c5.299,2.155,19.916,3.971,28.673-6.168c0,0,112.469-130.895,114.4-132.834\r\n\t\t\tc2.921-2.93,2.921-2.93,5.844-2.93c5.844,0,49.192,0,72.767,0c30.574,0,35.49-21.869,38.684-34.752\r\n\t\t\tc2.659-10.789,32.489-163.962,42.452-212.559C421.143,51.993,411.745,32,376.764,32z M371.086,301.637\r\n\t\t\tc2.659-10.789,32.489-163.962,42.452-212.559 M362.692,96.67l-9.999,51.734c-1.195,5.65-8.287,11.595-14.863,11.595\r\n\t\t\tc-6.575,0-95.917,0-95.917,0C231.473,160,224,166.138,224,176.602v13.448c0,10.473,7.519,17.894,17.965,17.894\r\n\t\t\tc0,0,74.482,0,81.848,0c7.374,0,14.61,8.109,13.016,16.005c-1.602,7.908-9.086,46.569-9.984,50.89\r\n\t\t\tc-0.902,4.328-5.845,11.725-14.611,11.725c-7.388,0-64.269,0-64.269,0c-11.705,0-15.244,1.533-23.074,11.293\r\n\t\t\tc-7.837,9.77-78.256,94.592-78.256,94.592c-0.713,0.822-1.41,0.584-1.41-0.312V95.896c0-6.684,5.793-14.523,14.479-14.523\r\n\t\t\tc0,0,183.713,0,191.173,0C357.912,81.372,364.488,88.004,362.692,96.67z"},"children":[]}]}]}]}]}]};exports.socialFoursquare=socialFoursquare;var socialFreebsdDevil={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M502.6,115c-22.5-43.7-58-51-58-51s15.5,32,16,51c0.4,16.1-5.5,28-27.2,33.5s-30.8-2-47.8-17.5\r\n\tS344,104.5,313,103c-40-2-77,9-77,9c-20-25,20-80,20-80c-74.5,29.5-93.7,83.3-96,113.7c-1.9,24.1,8.5,40.8,8.5,40.8s-0.5,27.8-5,42\r\n\tc-3.1,9.8-16.9,25-26,34.5c-12.2,12.7-12.5,38.5,0,57s44,27.5,67,39.5s31.5,21,31.5,21s1,8.3,0.5,15.3s-3.2,14-9,18.2\r\n\tc-5.5,3.9-15.5,0.5-20.5-2s-5-6.2-10.5-8s-7.3-4-6.5-11s2-9-3.5-18.5s-18.5-9.5-29.5-8s-17.3,6.8-17.3,6.8l-16.3-10\r\n\tc0,0,8.5-15.6,5.2-35.6c-7.3-43.8-50-62.8-50-62.8l10.4,44.4c0,0,1.1-2.6,6.4-6.4s8.1-3.6,8.1-3.6s6.6,7.6,9.1,25.3\r\n\tc2.5,18-6.7,27.2-6.7,27.2l-28.3-18l1-14.5L39.8,309L56,345.7l15-4l24,22.7c0,0-15.7,11.7-33,11.7c-11,0-22-6-22-6s-1.4-1-0.8-5.5\r\n\tc0.7-5,6.8-12.5,6.8-12.5H0c0,0,27.3,38.7,65,38.7c31,0,44.2-12.5,44.2-12.5L128,397c0,0,3,5.5,0,7s-7,3.5-9,15s18,29,18,29\r\n\tc21.8,17.8,7,32,7,32h272c-9-13-22.5-18-32-32c0,0-44.8-58.4-1.8-90.4c57.4-42.7,42.8-69.4,41.2-101.4c0,0,31.8-6.6,59.3-33.6\r\n\tS521.6,151.8,502.6,115z M195,203c-16.9,4.5-22.5,35.5-22.5,35.5c1.5-63,57.5-93,65-89s-6.5,39-21,64\r\n\tC216.5,213.5,208.5,199.4,195,203z M232,218c0,0,18-56,37.5-59.5s41.5,21,41.5,62s-26,65.4-42.8,69.2c-16.5,3.8-23,2-23,2\r\n\ts27.5-21.6,23.5-56.8C265.9,210.2,237.3,210.7,232,218z"},"children":[]}]};exports.socialFreebsdDevil=socialFreebsdDevil;var socialGithubOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,134.9,32,261.7c0,101.5,64.2,187.5,153.2,217.9c1.4,0.3,2.6,0.4,3.8,0.4c8.3,0,11.5-6.1,11.5-11.4\r\n\tc0-5.5-0.2-19.9-0.3-39.1c-8.4,1.9-15.9,2.7-22.6,2.7c-43.1,0-52.9-33.5-52.9-33.5c-10.2-26.5-24.9-33.6-24.9-33.6\r\n\tc-19.5-13.7-0.1-14.1,1.4-14.1c0.1,0,0.1,0,0.1,0c22.5,2,34.3,23.8,34.3,23.8c11.2,19.6,26.2,25.1,39.6,25.1c10.5,0,20-3.4,25.6-6\r\n\tc2-14.8,7.8-24.9,14.2-30.7c-49.7-5.8-102-25.5-102-113.5c0-25.1,8.7-45.6,23-61.6c-2.3-5.8-10-29.2,2.2-60.8c0,0,1.6-0.5,5-0.5\r\n\tc8.1,0,26.4,3.1,56.6,24.1c17.9-5.1,37-7.6,56.1-7.7c19,0.1,38.2,2.6,56.1,7.7c30.2-21,48.5-24.1,56.6-24.1c3.4,0,5,0.5,5,0.5\r\n\tc12.2,31.6,4.5,55,2.2,60.8c14.3,16.1,23,36.6,23,61.6c0,88.2-52.4,107.6-102.3,113.3c8,7.1,15.2,21.1,15.2,42.5\r\n\tc0,30.7-0.3,55.5-0.3,63c0,5.4,3.1,11.5,11.4,11.5c1.2,0,2.6-0.1,4-0.4C415.9,449.2,480,363.1,480,261.7C480,134.9,379.7,32,256,32z\r\n\t M177.6,448.1c2.2,0,4.4-0.1,6.7-0.2c0,2.8,0,5.5,0.1,7.9c0,2.4,0,4.6,0.1,6.5c-15.6-5.8-30.3-13.5-44.1-23\r\n\tC150.2,444.6,162.5,448.1,177.6,448.1z M189,375.2c-0.8,2.2-1.5,4.5-2.1,6.9c-3.4,1-7.5,1.8-11.7,1.8c-10.9,0-19-5.4-25.6-16.9\r\n\tc-2.4-4.6-6.8-10.7-12.9-16.3C153.5,364.8,173,371.6,189,375.2z M379,434.1c-15.8,11.9-33,21.3-51,28.2c0-1.9,0-4.1,0-6.5\r\n\tc0-11.9,0-29.8,0-50.4c0-12.4-2.1-22.5-5-30.5c37.2-8.3,92-33.7,92-125.4c0-24.6-7.1-46.5-21.2-65.1c3.1-12.9,5.5-35.6-5.1-63\r\n\tl-2.7-7.1l-7.2-2.4c-1.5-0.5-4.8-1.3-10-1.3c-11.5,0-30.9,4.1-59.5,22.8c-17-4.2-34.8-6.4-53.1-6.4H256h-0.1\r\n\tc-18.3,0-36.2,2.2-53.1,6.4c-28.6-18.7-48-22.8-59.5-22.8c-5.2,0-8.5,0.9-10,1.4l-7.2,2.4l-2.7,7.1c-10.6,27.5-8.2,50.2-5.1,63\r\n\tc-14.1,18.7-21.2,40.6-21.2,65.1c0,49.6,16,79.9,36.6,98.5c-8.1-6.6-18.6-12.1-31.2-13H102h-0.5h-0.3c-13.1,0-22.3,5.4-25.2,14.7\r\n\tc-4.7,14.8,9.8,25,14.6,28.4l0.5,0.6l1.5,0.6c1.6,1,10.1,7,16.9,24.5c2,6.2,6.3,14.5,13.6,22.2c-13.1-11.2-24.8-24-34.9-38.1\r\n\tC61.9,351.2,48,307.5,48,261.7c0-28.9,5.5-56.9,16.4-83.3c10.5-25.5,25.5-48.3,44.7-67.9c19.1-19.6,41.4-35,66.1-45.7\r\n\tC200.8,53.7,228,48,256,48s55.2,5.6,80.8,16.7c24.8,10.7,47,26.1,66.1,45.7c19.1,19.6,34.2,42.5,44.7,67.9\r\n\tc10.9,26.4,16.4,54.4,16.4,83.3c0,45.8-13.8,89.5-40.1,126.3C411.3,405.6,396.2,421.1,379,434.1z"},"children":[]}]};exports.socialGithubOutline=socialGithubOutline;var socialGithub={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,134.9,32,261.7c0,101.5,64.2,187.5,153.2,217.9c1.4,0.3,2.6,0.4,3.8,0.4c8.3,0,11.5-6.1,11.5-11.4\r\n\tc0-5.5-0.2-19.9-0.3-39.1c-8.4,1.9-15.9,2.7-22.6,2.7c-43.1,0-52.9-33.5-52.9-33.5c-10.2-26.5-24.9-33.6-24.9-33.6\r\n\tc-19.5-13.7-0.1-14.1,1.4-14.1c0.1,0,0.1,0,0.1,0c22.5,2,34.3,23.8,34.3,23.8c11.2,19.6,26.2,25.1,39.6,25.1c10.5,0,20-3.4,25.6-6\r\n\tc2-14.8,7.8-24.9,14.2-30.7c-49.7-5.8-102-25.5-102-113.5c0-25.1,8.7-45.6,23-61.6c-2.3-5.8-10-29.2,2.2-60.8c0,0,1.6-0.5,5-0.5\r\n\tc8.1,0,26.4,3.1,56.6,24.1c17.9-5.1,37-7.6,56.1-7.7c19,0.1,38.2,2.6,56.1,7.7c30.2-21,48.5-24.1,56.6-24.1c3.4,0,5,0.5,5,0.5\r\n\tc12.2,31.6,4.5,55,2.2,60.8c14.3,16.1,23,36.6,23,61.6c0,88.2-52.4,107.6-102.3,113.3c8,7.1,15.2,21.1,15.2,42.5\r\n\tc0,30.7-0.3,55.5-0.3,63c0,5.4,3.1,11.5,11.4,11.5c1.2,0,2.6-0.1,4-0.4C415.9,449.2,480,363.1,480,261.7C480,134.9,379.7,32,256,32z\r\n\t"},"children":[]}]};exports.socialGithub=socialGithub;var socialGoogleOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M319.408,82.141c11.779,9.576,36.43,29.718,36.43,68.043c0,37.295-21.547,54.934-43.094,71.545\r\n\t\tc-6.695,6.561-14.385,13.608-14.385,24.701c0,11.092,7.689,17.153,13.336,21.671l18.473,14.108\r\n\t\tc22.598,18.641,43.125,35.795,43.125,70.559c0,47.373-46.721,95.232-135.003,95.232c-74.428,0-110.343-34.766-110.343-72.061\r\n\t\tc0-18.139,9.245-43.827,39.525-61.48c31.798-19.142,74.952-21.657,98.023-23.172c-7.178-9.078-15.382-18.67-15.382-34.265\r\n\t\tc0-8.577,2.557-13.609,5.12-19.655c-5.648,0.5-11.283,1-16.42,1c-54.408,0-85.214-39.811-85.214-79.107\r\n\t\tc0-23.186,10.802-48.902,32.856-67.543C215.724,68.031,250.637,64,278.328,64h105.725l-32.846,18.141H319.408z M282.955,305.896\r\n\t\tc-4.137-0.501-6.684-0.501-11.793-0.501c-4.629,0-32.348,1.002-53.895,8.049c-11.3,4.046-44.146,16.125-44.146,51.918\r\n\t\tc0,35.78,35.393,61.467,90.339,61.467c49.283,0,75.432-23.156,75.432-54.404C338.893,346.707,321.971,333.113,282.955,305.896\r\n\t\t M297.834,210.148c11.824-11.592,12.844-27.73,12.844-36.793c0-36.281-22.086-92.73-64.671-92.73\r\n\t\tc-13.339,0-27.724,6.547-35.948,16.639c-8.722,10.593-11.284,24.188-11.284,37.281c0,33.764,20.005,89.727,64.163,89.727\r\n\t\tC275.764,224.271,289.594,218.212,297.834,210.148"},"children":[{"name":"path","attribs":{"d":"M319.408,82.141c11.779,9.576,36.43,29.718,36.43,68.043c0,37.295-21.547,54.934-43.094,71.545\r\n\t\tc-6.695,6.561-14.385,13.608-14.385,24.701c0,11.092,7.689,17.153,13.336,21.671l18.473,14.108\r\n\t\tc22.598,18.641,43.125,35.795,43.125,70.559c0,47.373-46.721,95.232-135.003,95.232c-74.428,0-110.343-34.766-110.343-72.061\r\n\t\tc0-18.139,9.245-43.827,39.525-61.48c31.798-19.142,74.952-21.657,98.023-23.172c-7.178-9.078-15.382-18.67-15.382-34.265\r\n\t\tc0-8.577,2.557-13.609,5.12-19.655c-5.648,0.5-11.283,1-16.42,1c-54.408,0-85.214-39.811-85.214-79.107\r\n\t\tc0-23.186,10.802-48.902,32.856-67.543C215.724,68.031,250.637,64,278.328,64h105.725l-32.846,18.141H319.408z M282.955,305.896\r\n\t\tc-4.137-0.501-6.684-0.501-11.793-0.501c-4.629,0-32.348,1.002-53.895,8.049c-11.3,4.046-44.146,16.125-44.146,51.918\r\n\t\tc0,35.78,35.393,61.467,90.339,61.467c49.283,0,75.432-23.156,75.432-54.404C338.893,346.707,321.971,333.113,282.955,305.896\r\n\t\t M297.834,210.148c11.824-11.592,12.844-27.73,12.844-36.793c0-36.281-22.086-92.73-64.671-92.73\r\n\t\tc-13.339,0-27.724,6.547-35.948,16.639c-8.722,10.593-11.284,24.188-11.284,37.281c0,33.764,20.005,89.727,64.163,89.727\r\n\t\tC275.764,224.271,289.594,218.212,297.834,210.148"},"children":[]}]}]}]};exports.socialGoogleOutline=socialGoogleOutline;var socialGoogle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M325.862,275.558l-18.187-13.653l-0.063-0.051c-5.827-4.579-9.952-8.313-9.952-14.685c0-6.979,5.049-11.824,10.896-17.436\r\n\t\tl0.466-0.449c20.025-15.171,44.726-34.286,44.726-74.556c0-26.934-11.916-44.729-23.28-57.729h12.969l60.322-33H270.308\r\n\t\tc-25.324,0-62.68,3.225-94.561,28.576l-0.128,0.25c-21.809,18.111-34.828,44.584-34.828,70.691\r\n\t\tc0,21.197,8.706,42.159,23.885,57.447c21.428,21.579,48.302,26.127,67.074,26.127c1.462,0,2.956-0.028,4.47-0.093\r\n\t\tc-0.759,2.969-1.25,6.321-1.25,10.321c0,10.926,3.628,19.301,8.083,26.195c-23.963,1.932-58.148,6.477-84.897,22.278\r\n\t\tc-39.335,22.562-42.396,55.875-42.396,65.551c0,38.207,35.707,76.762,115.479,76.762c91.611,0,139.543-49.792,139.543-98.979\r\n\t\tC370.781,311.966,347.945,293.457,325.862,275.558z M200.485,139.894c0-13.359,3.02-23.457,9.255-30.9\r\n\t\tc6.514-7.852,18.18-13.129,29.028-13.129c19.881,0,32.938,15.008,40.388,27.598c9.199,15.539,14.913,36.095,14.913,53.643\r\n\t\tc0,4.942,0,19.983-10.188,29.796c-6.951,6.686-18.707,11.353-28.59,11.353c-20.503,0-33.453-14.705-40.707-27.041\r\n\t\tC204.189,173.53,200.485,153.109,200.485,139.894z M321.6,367.974c0,27.444-25.212,44.493-65.799,44.493\r\n\t\tc-48.058,0-80.347-20.603-80.347-51.265c0-26.14,21.54-36.789,37.8-42.521c18.944-6.064,44.297-7.305,50.062-7.305\r\n\t\tc3.907,0,6.087,0,8.683,0.229C308.7,336.816,321.6,347.733,321.6,367.974z"},"children":[{"name":"path","attribs":{"d":"M325.862,275.558l-18.187-13.653l-0.063-0.051c-5.827-4.579-9.952-8.313-9.952-14.685c0-6.979,5.049-11.824,10.896-17.436\r\n\t\tl0.466-0.449c20.025-15.171,44.726-34.286,44.726-74.556c0-26.934-11.916-44.729-23.28-57.729h12.969l60.322-33H270.308\r\n\t\tc-25.324,0-62.68,3.225-94.561,28.576l-0.128,0.25c-21.809,18.111-34.828,44.584-34.828,70.691\r\n\t\tc0,21.197,8.706,42.159,23.885,57.447c21.428,21.579,48.302,26.127,67.074,26.127c1.462,0,2.956-0.028,4.47-0.093\r\n\t\tc-0.759,2.969-1.25,6.321-1.25,10.321c0,10.926,3.628,19.301,8.083,26.195c-23.963,1.932-58.148,6.477-84.897,22.278\r\n\t\tc-39.335,22.562-42.396,55.875-42.396,65.551c0,38.207,35.707,76.762,115.479,76.762c91.611,0,139.543-49.792,139.543-98.979\r\n\t\tC370.781,311.966,347.945,293.457,325.862,275.558z M200.485,139.894c0-13.359,3.02-23.457,9.255-30.9\r\n\t\tc6.514-7.852,18.18-13.129,29.028-13.129c19.881,0,32.938,15.008,40.388,27.598c9.199,15.539,14.913,36.095,14.913,53.643\r\n\t\tc0,4.942,0,19.983-10.188,29.796c-6.951,6.686-18.707,11.353-28.59,11.353c-20.503,0-33.453-14.705-40.707-27.041\r\n\t\tC204.189,173.53,200.485,153.109,200.485,139.894z M321.6,367.974c0,27.444-25.212,44.493-65.799,44.493\r\n\t\tc-48.058,0-80.347-20.603-80.347-51.265c0-26.14,21.54-36.789,37.8-42.521c18.944-6.064,44.297-7.305,50.062-7.305\r\n\t\tc3.907,0,6.087,0,8.683,0.229C308.7,336.816,321.6,347.733,321.6,367.974z"},"children":[]}]}]}]};exports.socialGoogle=socialGoogle;var socialGoogleplusOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M223.5,82.1c11.8,9.6,36.4,29.7,36.4,68c0,37.3-21.5,54.9-43.1,71.5c-6.7,6.6-14.4,13.6-14.4,24.7\r\n\t\tc0,11.1,7.7,17.2,13.3,21.7l18.5,14.1c22.6,18.6,43.1,35.8,43.1,70.6c0,47.4-46.7,95.2-135,95.2C67.9,448,32,413.2,32,375.9\r\n\t\tc0-18.1,9.2-43.8,39.5-61.5c31.8-19.1,75-21.7,98-23.2c-7.2-9.1-15.4-18.7-15.4-34.3c0-8.6,2.6-13.6,5.1-19.7\r\n\t\tc-5.6,0.5-11.3,1-16.4,1c-54.4,0-85.2-39.8-85.2-79.1c0-23.2,10.8-48.9,32.9-67.5C119.8,68,154.7,64,182.4,64h105.7l-32.8,18.1\r\n\t\tH223.5z M187,305.9c-4.1-0.5-6.7-0.5-11.8-0.5c-4.6,0-32.3,1-53.9,8c-11.3,4-44.1,16.1-44.1,51.9c0,35.8,35.4,61.5,90.3,61.5\r\n\t\tc49.3,0,75.4-23.2,75.4-54.4C242.9,346.7,226,333.1,187,305.9 M201.9,210.1c11.8-11.6,12.8-27.7,12.8-36.8\r\n\t\tc0-36.3-22.1-92.7-64.7-92.7c-13.3,0-27.7,6.5-35.9,16.6c-8.7,10.6-11.3,24.2-11.3,37.3c0,33.8,20,89.7,64.2,89.7\r\n\t\tC179.8,224.3,193.6,218.2,201.9,210.1"},"children":[{"name":"path","attribs":{"d":"M223.5,82.1c11.8,9.6,36.4,29.7,36.4,68c0,37.3-21.5,54.9-43.1,71.5c-6.7,6.6-14.4,13.6-14.4,24.7\r\n\t\tc0,11.1,7.7,17.2,13.3,21.7l18.5,14.1c22.6,18.6,43.1,35.8,43.1,70.6c0,47.4-46.7,95.2-135,95.2C67.9,448,32,413.2,32,375.9\r\n\t\tc0-18.1,9.2-43.8,39.5-61.5c31.8-19.1,75-21.7,98-23.2c-7.2-9.1-15.4-18.7-15.4-34.3c0-8.6,2.6-13.6,5.1-19.7\r\n\t\tc-5.6,0.5-11.3,1-16.4,1c-54.4,0-85.2-39.8-85.2-79.1c0-23.2,10.8-48.9,32.9-67.5C119.8,68,154.7,64,182.4,64h105.7l-32.8,18.1\r\n\t\tH223.5z M187,305.9c-4.1-0.5-6.7-0.5-11.8-0.5c-4.6,0-32.3,1-53.9,8c-11.3,4-44.1,16.1-44.1,51.9c0,35.8,35.4,61.5,90.3,61.5\r\n\t\tc49.3,0,75.4-23.2,75.4-54.4C242.9,346.7,226,333.1,187,305.9 M201.9,210.1c11.8-11.6,12.8-27.7,12.8-36.8\r\n\t\tc0-36.3-22.1-92.7-64.7-92.7c-13.3,0-27.7,6.5-35.9,16.6c-8.7,10.6-11.3,24.2-11.3,37.3c0,33.8,20,89.7,64.2,89.7\r\n\t\tC179.8,224.3,193.6,218.2,201.9,210.1"},"children":[]}]},{"name":"polygon","attribs":{"points":"480,142.3 401.7,142.3 401.7,64.1 384,64.1 384,142.3 304.3,142.3 304.3,160.1 384,160.1 384,241 401.7,241 \r\n\t\t401.7,160.1 480,160.1 \t"},"children":[{"name":"polygon","attribs":{"points":"480,142.3 401.7,142.3 401.7,64.1 384,64.1 384,142.3 304.3,142.3 304.3,160.1 384,160.1 384,241 401.7,241 \r\n\t\t401.7,160.1 480,160.1 \t"},"children":[]}]}]}]};exports.socialGoogleplusOutline=socialGoogleplusOutline;var socialGoogleplus={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M242.1,275.6l-18.2-13.7l-0.1-0.1c-5.8-4.6-10-8.3-10-14.7c0-7,5-11.8,10.9-17.4l0.5-0.4c20-15.2,44.7-34.3,44.7-74.6\r\n\t\tc0-26.9-11.9-44.7-23.3-57.7h13L320,64H186.5c-25.3,0-62.7,3.2-94.6,28.6l-0.1,0.3C70,110.9,57,137.4,57,163.5\r\n\t\tc0,21.2,8.7,42.2,23.9,57.4c21.4,21.6,48.3,26.1,67.1,26.1c1.5,0,3,0,4.5-0.1c-0.8,3-1.2,6.3-1.2,10.3c0,10.9,3.6,19.3,8.1,26.2\r\n\t\tc-24,1.9-58.1,6.5-84.9,22.3C35.1,328.4,32,361.7,32,371.3c0,38.2,35.7,76.8,115.5,76.8c91.6,0,139.5-49.8,139.5-99\r\n\t\tC287,312,264.2,293.5,242.1,275.6z M116.7,139.9c0-13.4,3-23.5,9.3-30.9c6.5-7.9,18.2-13.1,29-13.1c19.9,0,32.9,15,40.4,27.6\r\n\t\tc9.2,15.5,14.9,36.1,14.9,53.6c0,4.9,0,20-10.2,29.8c-7,6.7-18.7,11.4-28.6,11.4c-20.5,0-33.5-14.7-40.7-27\r\n\t\tC120.4,173.5,116.7,153.1,116.7,139.9z M237.8,368c0,27.4-25.2,44.5-65.8,44.5c-48.1,0-80.3-20.6-80.3-51.3\r\n\t\tc0-26.1,21.5-36.8,37.8-42.5c18.9-6.1,44.3-7.3,50.1-7.3c3.9,0,6.1,0,8.7,0.2C224.9,336.8,237.8,347.7,237.8,368z"},"children":[{"name":"path","attribs":{"d":"M242.1,275.6l-18.2-13.7l-0.1-0.1c-5.8-4.6-10-8.3-10-14.7c0-7,5-11.8,10.9-17.4l0.5-0.4c20-15.2,44.7-34.3,44.7-74.6\r\n\t\tc0-26.9-11.9-44.7-23.3-57.7h13L320,64H186.5c-25.3,0-62.7,3.2-94.6,28.6l-0.1,0.3C70,110.9,57,137.4,57,163.5\r\n\t\tc0,21.2,8.7,42.2,23.9,57.4c21.4,21.6,48.3,26.1,67.1,26.1c1.5,0,3,0,4.5-0.1c-0.8,3-1.2,6.3-1.2,10.3c0,10.9,3.6,19.3,8.1,26.2\r\n\t\tc-24,1.9-58.1,6.5-84.9,22.3C35.1,328.4,32,361.7,32,371.3c0,38.2,35.7,76.8,115.5,76.8c91.6,0,139.5-49.8,139.5-99\r\n\t\tC287,312,264.2,293.5,242.1,275.6z M116.7,139.9c0-13.4,3-23.5,9.3-30.9c6.5-7.9,18.2-13.1,29-13.1c19.9,0,32.9,15,40.4,27.6\r\n\t\tc9.2,15.5,14.9,36.1,14.9,53.6c0,4.9,0,20-10.2,29.8c-7,6.7-18.7,11.4-28.6,11.4c-20.5,0-33.5-14.7-40.7-27\r\n\t\tC120.4,173.5,116.7,153.1,116.7,139.9z M237.8,368c0,27.4-25.2,44.5-65.8,44.5c-48.1,0-80.3-20.6-80.3-51.3\r\n\t\tc0-26.1,21.5-36.8,37.8-42.5c18.9-6.1,44.3-7.3,50.1-7.3c3.9,0,6.1,0,8.7,0.2C224.9,336.8,237.8,347.7,237.8,368z"},"children":[]}]},{"name":"polygon","attribs":{"points":"402,142 402,64 368,64 368,142 288,142 288,176 368,176 368,257 402,257 402,176 480,176 480,142 \t"},"children":[{"name":"polygon","attribs":{"points":"402,142 402,64 368,64 368,142 288,142 288,176 368,176 368,257 402,257 402,176 480,176 480,142 \t"},"children":[]}]}]}]};exports.socialGoogleplus=socialGoogleplus;var socialHackernewsOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M416,96v320H96V96H416 M448,64H64v384h384V64L448,64z"},"children":[{"name":"path","attribs":{"d":"M416,96v320H96V96H416 M448,64H64v384h384V64L448,64z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M296.7,159H342l-63.9,120v72h-39.9v-72L172,159h47.1l39.7,83.6L296.7,159z"},"children":[{"name":"path","attribs":{"d":"M296.7,159H342l-63.9,120v72h-39.9v-72L172,159h47.1l39.7,83.6L296.7,159z"},"children":[]}]}]}]}]}]};exports.socialHackernewsOutline=socialHackernewsOutline;var socialHackernews={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M278,279v72h-40v-72l-66-120h47.1l39.7,83.6l38-83.6H342L278,279z"},"children":[{"name":"path","attribs":{"d":"M64,64v384h384V64H64z M278,279v72h-40v-72l-66-120h47.1l39.7,83.6l38-83.6H342L278,279z"},"children":[]}]}]}]};exports.socialHackernews=socialHackernews;var socialHtml5Outline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M64,32l34.936,403.301L255.769,480l157.245-44.705L448,32H64z M383.041,410.51l-127.262,36.187l-126.867-36.169L98.896,64\r\n\t\tH413.1L383.041,410.51z"},"children":[{"name":"path","attribs":{"d":"M64,32l34.936,403.301L255.769,480l157.245-44.705L448,32H64z M383.041,410.51l-127.262,36.187l-126.867-36.169L98.896,64\r\n\t\tH413.1L383.041,410.51z"},"children":[]}]},{"name":"polygon","attribs":{"points":"147.991,264 314.984,264 309.411,327.986 255.991,342.734 202.225,328.064 198.801,289 150.55,289 \r\n\t\t157.313,366.336 255.991,394.146 354.486,366.163 367.991,215 191.991,215 188,164 371.991,164 376.199,114.316 135.421,114.188 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"147.991,264 314.984,264 309.411,327.986 255.991,342.734 202.225,328.064 198.801,289 150.55,289 \r\n\t\t157.313,366.336 255.991,394.146 354.486,366.163 367.991,215 191.991,215 188,164 371.991,164 376.199,114.316 135.421,114.188 \t\r\n\t\t"},"children":[]}]}]}]};exports.socialHtml5Outline=socialHtml5Outline;var socialHtml5={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M64,32l34.936,403.213L255.769,480l157.245-44.854L448,32H64z M371.997,164h-184l3.991,51h176.008l-13.505,151.386\r\n\tl-98.5,28.094l-98.682-27.976L150.545,289h48.254l3.423,39.287l53.769,14.781l53.422-14.915L314.987,264H147.986l-12.571-149.589\r\n\tl240.789,0.016L371.997,164z"},"children":[]}]};exports.socialHtml5=socialHtml5;var socialInstagramOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill":"#231F20","d":"M448.5,112c0-26.233-21.267-47.5-47.5-47.5H112c-26.233,0-47.5,21.267-47.5,47.5v289\r\n\tc0,26.233,21.267,47.5,47.5,47.5h289c26.233,0,47.5-21.267,47.5-47.5V112z M257,175.833c44.182,0,80,35.816,80,80s-35.818,80-80,80\r\n\ts-80-35.816-80-80S212.818,175.833,257,175.833z M416.5,160.5c0,8.836-7.163,16-16,16h-48c-8.837,0-16-7.164-16-16v-48\r\n\tc0-8.836,7.163-16,16-16h48c8.837,0,16,7.164,16,16V160.5z M401.5,416.5h-288c-8.822,0-17-8.178-17-17v-175h53.072\r\n\tc-3.008,10-4.572,20.647-4.572,31.583C145,286,156.65,314,177.805,335.154s49.279,32.741,79.195,32.741s58.041-11.681,79.195-32.835\r\n\tS369,286.016,369,256.099c0-10.936-1.563-21.599-4.572-31.599H416.5v175C416.5,408.322,410.322,416.5,401.5,416.5z"},"children":[]}]};exports.socialInstagramOutline=socialInstagramOutline;var socialInstagram={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"256","cy":"255.833","r":"80"},"children":[{"name":"circle","attribs":{"cx":"256","cy":"255.833","r":"80"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M177.805,176.887c21.154-21.154,49.279-32.929,79.195-32.929s58.041,11.837,79.195,32.991\r\n\t\tc13.422,13.422,23.011,29.551,28.232,47.551H448.5v-113c0-26.51-20.49-47-47-47h-288c-26.51,0-49,20.49-49,47v113h85.072\r\n\t\tC154.794,206.5,164.383,190.309,177.805,176.887z M416.5,147.7c0,7.069-5.73,12.8-12.8,12.8h-38.4c-7.069,0-12.8-5.73-12.8-12.8\r\n\t\tv-38.4c0-7.069,5.73-12.8,12.8-12.8h38.4c7.069,0,12.8,5.73,12.8,12.8V147.7z"},"children":[{"name":"path","attribs":{"d":"M177.805,176.887c21.154-21.154,49.279-32.929,79.195-32.929s58.041,11.837,79.195,32.991\r\n\t\tc13.422,13.422,23.011,29.551,28.232,47.551H448.5v-113c0-26.51-20.49-47-47-47h-288c-26.51,0-49,20.49-49,47v113h85.072\r\n\t\tC154.794,206.5,164.383,190.309,177.805,176.887z M416.5,147.7c0,7.069-5.73,12.8-12.8,12.8h-38.4c-7.069,0-12.8-5.73-12.8-12.8\r\n\t\tv-38.4c0-7.069,5.73-12.8,12.8-12.8h38.4c7.069,0,12.8,5.73,12.8,12.8V147.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M336.195,335.279c-21.154,21.154-49.279,32.679-79.195,32.679s-58.041-11.462-79.195-32.616\r\n\t\tc-21.115-21.115-32.759-49.842-32.803-78.842H64.5v143c0,26.51,22.49,49,49,49h288c26.51,0,47-22.49,47-49v-143h-79.502\r\n\t\tC368.955,285.5,357.311,314.164,336.195,335.279z"},"children":[{"name":"path","attribs":{"d":"M336.195,335.279c-21.154,21.154-49.279,32.679-79.195,32.679s-58.041-11.462-79.195-32.616\r\n\t\tc-21.115-21.115-32.759-49.842-32.803-78.842H64.5v143c0,26.51,22.49,49,49,49h288c26.51,0,47-22.49,47-49v-143h-79.502\r\n\t\tC368.955,285.5,357.311,314.164,336.195,335.279z"},"children":[]}]}]}]};exports.socialInstagram=socialInstagram;var socialJavascriptOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"transform":"translate(384 48)"},"children":[{"name":"g","attribs":{"id":"icon-javascript_1_1_"},"children":[{"name":"g","attribs":{"id":"icon-javascript_1_1_"},"children":[{"name":"path","attribs":{"d":"M-192,56.001v197.017c0,41.567-9.644,71.988-28.662,90.417c-17.06,16.53-42.061,24.565-76.431,24.565\r\n\t\t\tc-12.002,0-25.78-1.496-37.185-3.886l4.09-30.505c7.146,1.269,15.465,2.149,24.774,2.149c21.92,0,37.892-6.459,48.827-19.745\r\n\t\t\tC-245.27,302.268-240,282.085-240,252.499V56.001H-192 M-176,40.001h-80v212.498c0,52.58-18.032,67.261-49.412,67.261\r\n\t\t\tc-14.705,0-27.948-2.521-38.25-6.063L-352,375.904c14.7,5.062,37.259,8.096,54.907,8.096C-225.045,384-176,350.129-176,253.02\r\n\t\t\tV40.001L-176,40.001z"},"children":[{"name":"path","attribs":{"d":"M-192,56.001v197.017c0,41.567-9.644,71.988-28.662,90.417c-17.06,16.53-42.061,24.565-76.431,24.565\r\n\t\t\tc-12.002,0-25.78-1.496-37.185-3.886l4.09-30.505c7.146,1.269,15.465,2.149,24.774,2.149c21.92,0,37.892-6.459,48.827-19.745\r\n\t\t\tC-245.27,302.268-240,282.085-240,252.499V56.001H-192 M-176,40.001h-80v212.498c0,52.58-18.032,67.261-49.412,67.261\r\n\t\t\tc-14.705,0-27.948-2.521-38.25-6.063L-352,375.904c14.7,5.062,37.259,8.096,54.907,8.096C-225.045,384-176,350.129-176,253.02\r\n\t\t\tV40.001L-176,40.001z"},"children":[]}]},{"name":"path","attribs":{"d":"M-1.537,48c24.458,0,45.898,3.146,65.1,9.585l-9.581,32.062C40.37,84.142,21.446,78.71-2.504,78.71\r\n\t\t\tc-18.607,0-34.462,4.584-45.849,13.256c-11.732,8.936-18.194,21.583-18.194,35.613c0,34.974,33.062,48.149,71.347,63.405\r\n\t\t\tl0.107,0.043l0.108,0.041c26.977,10.299,45.938,22.261,57.969,36.572C74.593,241.451,80,257.543,80,278.284\r\n\t\t\tc0,25.177-9.333,46.71-26.99,62.274C32.66,358.497,1.593,367.98-36.833,367.98c-28.052,0-54.698-6.427-72.615-13.979l7.593-31.603\r\n\t\t\tc17.579,7.248,41.882,14.382,69.438,14.382c20.28,0,36.629-4.478,48.591-13.306c12.807-9.45,19.857-23.697,19.857-40.119\r\n\t\t\tc0-15.348-6.041-27.922-18.469-38.444c-10.157-8.603-24.801-16.048-47.467-24.136c-26.86-9.904-47.359-21.947-60.934-35.795\r\n\t\t\tC-105.078,170.455-112,153.829-112,134.154c0-24.149,9.831-45.101,28.43-60.591C-63.49,56.839-35.124,48-1.537,48 M-1.537,32\r\n\t\t\tC-78.98,32-128,75.998-128,134.154c0,50.083,37.751,81.44,92.641,101.665c39.7,14.158,55.392,26.808,55.392,47.539\r\n\t\t\tc0,22.756-18.139,37.425-52.448,37.425c-31.863,0-60.789-10.64-80.394-21.255v-0.021L-128,362.727\r\n\t\t\tc18.639,10.638,53.441,21.255,91.167,21.255C53.854,383.98,96,335.43,96,278.284c0-48.55-26.958-79.9-85.278-102.163\r\n\t\t\tc-43.139-17.191-61.27-26.795-61.27-48.542c0-17.2,15.688-32.869,48.043-32.869c31.846,0,53.744,10.707,66.505,17.291l19.125-64\r\n\t\t\tC63.125,39.22,36.188,32-1.537,32L-1.537,32z"},"children":[{"name":"path","attribs":{"d":"M-1.537,48c24.458,0,45.898,3.146,65.1,9.585l-9.581,32.062C40.37,84.142,21.446,78.71-2.504,78.71\r\n\t\t\tc-18.607,0-34.462,4.584-45.849,13.256c-11.732,8.936-18.194,21.583-18.194,35.613c0,34.974,33.062,48.149,71.347,63.405\r\n\t\t\tl0.107,0.043l0.108,0.041c26.977,10.299,45.938,22.261,57.969,36.572C74.593,241.451,80,257.543,80,278.284\r\n\t\t\tc0,25.177-9.333,46.71-26.99,62.274C32.66,358.497,1.593,367.98-36.833,367.98c-28.052,0-54.698-6.427-72.615-13.979l7.593-31.603\r\n\t\t\tc17.579,7.248,41.882,14.382,69.438,14.382c20.28,0,36.629-4.478,48.591-13.306c12.807-9.45,19.857-23.697,19.857-40.119\r\n\t\t\tc0-15.348-6.041-27.922-18.469-38.444c-10.157-8.603-24.801-16.048-47.467-24.136c-26.86-9.904-47.359-21.947-60.934-35.795\r\n\t\t\tC-105.078,170.455-112,153.829-112,134.154c0-24.149,9.831-45.101,28.43-60.591C-63.49,56.839-35.124,48-1.537,48 M-1.537,32\r\n\t\t\tC-78.98,32-128,75.998-128,134.154c0,50.083,37.751,81.44,92.641,101.665c39.7,14.158,55.392,26.808,55.392,47.539\r\n\t\t\tc0,22.756-18.139,37.425-52.448,37.425c-31.863,0-60.789-10.64-80.394-21.255v-0.021L-128,362.727\r\n\t\t\tc18.639,10.638,53.441,21.255,91.167,21.255C53.854,383.98,96,335.43,96,278.284c0-48.55-26.958-79.9-85.278-102.163\r\n\t\t\tc-43.139-17.191-61.27-26.795-61.27-48.542c0-17.2,15.688-32.869,48.043-32.869c31.846,0,53.744,10.707,66.505,17.291l19.125-64\r\n\t\t\tC63.125,39.22,36.188,32-1.537,32L-1.537,32z"},"children":[]}]}]}]}]}]};exports.socialJavascriptOutline=socialJavascriptOutline;var socialJavascript={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"transform":"translate(384 48)"},"children":[{"name":"g","attribs":{"id":"icon-javascript_1_1_"},"children":[{"name":"g","attribs":{"id":"icon-javascript_1_1_"},"children":[{"name":"path","attribs":{"d":"M-176,40.001h-80v212.498c0,52.58-18.032,67.261-49.412,67.261c-14.705,0-27.948-2.521-38.25-6.063L-352,375.904\r\n\t\t\tc14.7,5.062,37.259,8.096,54.907,8.096C-225.045,384-176,350.129-176,253.02V40.001L-176,40.001z"},"children":[{"name":"path","attribs":{"d":"M-176,40.001h-80v212.498c0,52.58-18.032,67.261-49.412,67.261c-14.705,0-27.948-2.521-38.25-6.063L-352,375.904\r\n\t\t\tc14.7,5.062,37.259,8.096,54.907,8.096C-225.045,384-176,350.129-176,253.02V40.001L-176,40.001z"},"children":[]}]},{"name":"path","attribs":{"d":"M-1.537,32C-78.98,32-128,75.998-128,134.154c0,50.083,37.751,81.44,92.641,101.665\r\n\t\t\tc39.7,14.158,55.392,26.808,55.392,47.539c0,22.756-18.139,37.425-52.448,37.425c-31.863,0-60.789-10.64-80.394-21.255v-0.021\r\n\t\t\tL-128,362.727c18.639,10.638,53.441,21.255,91.167,21.255C53.854,383.98,96,335.43,96,278.284c0-48.55-26.958-79.9-85.278-102.163\r\n\t\t\tc-43.139-17.191-61.27-26.795-61.27-48.542c0-17.2,15.688-32.869,48.043-32.869c31.846,0,53.744,10.707,66.505,17.291l19.125-64\r\n\t\t\tC63.125,39.22,36.188,32-1.537,32L-1.537,32z"},"children":[{"name":"path","attribs":{"d":"M-1.537,32C-78.98,32-128,75.998-128,134.154c0,50.083,37.751,81.44,92.641,101.665\r\n\t\t\tc39.7,14.158,55.392,26.808,55.392,47.539c0,22.756-18.139,37.425-52.448,37.425c-31.863,0-60.789-10.64-80.394-21.255v-0.021\r\n\t\t\tL-128,362.727c18.639,10.638,53.441,21.255,91.167,21.255C53.854,383.98,96,335.43,96,278.284c0-48.55-26.958-79.9-85.278-102.163\r\n\t\t\tc-43.139-17.191-61.27-26.795-61.27-48.542c0-17.2,15.688-32.869,48.043-32.869c31.846,0,53.744,10.707,66.505,17.291l19.125-64\r\n\t\t\tC63.125,39.22,36.188,32-1.537,32L-1.537,32z"},"children":[]}]}]}]}]}]};exports.socialJavascript=socialJavascript;var socialLinkedinOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M182.8,384V212.9h-54.9V384H182.8L182.8,384z M157.4,187c18.3,0,29.7-13.1,29.7-29.5\r\n\t\t\tc-0.3-16.7-11.4-29.5-29.4-29.5c-18,0-29.7,12.8-29.7,29.5c0,16.4,11.4,29.5,29,29.5H157.4L157.4,187z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M182.8,384V212.9h-54.9V384H182.8L182.8,384z M157.4,187c18.3,0,29.7-13.1,29.7-29.5\r\n\t\t\tc-0.3-16.7-11.4-29.5-29.4-29.5c-18,0-29.7,12.8-29.7,29.5c0,16.4,11.4,29.5,29,29.5H157.4L157.4,187z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M320.6,209c-29.1,0-41.6,16.4-49.6,27.8V213h-55v171h55v-97.4c0-5,0.4-10,1.9-13.5c4-10,13-20.3,28.2-20.3\r\n\t\t\tc19.9,0,27.9,15.3,27.9,37.7V384h55v-99.9C384,232.8,356.8,209,320.6,209z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M320.6,209c-29.1,0-41.6,16.4-49.6,27.8V213h-55v171h55v-97.4c0-5,0.4-10,1.9-13.5c4-10,13-20.3,28.2-20.3\r\n\t\t\tc19.9,0,27.9,15.3,27.9,37.7V384h55v-99.9C384,232.8,356.8,209,320.6,209z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M417.2,64H96.8C79.3,64,64,76.6,64,93.9v321.1c0,17.4,15.3,32.9,32.8,32.9h320.3c17.6,0,30.8-15.6,30.8-32.9V93.9\r\n\t\tC448,76.6,434.7,64,417.2,64z M414,416c-1.1,0-313.1,0-314.9,0s-3.1-1.4-3.1-3.1S96,99.1,96,98s1-2,2-2s315,0,316,0s2,1,2,2\r\n\t\tc0,23.3,0,314.9,0,316C416,414.9,415.1,416,414,416z"},"children":[{"name":"path","attribs":{"d":"M417.2,64H96.8C79.3,64,64,76.6,64,93.9v321.1c0,17.4,15.3,32.9,32.8,32.9h320.3c17.6,0,30.8-15.6,30.8-32.9V93.9\r\n\t\tC448,76.6,434.7,64,417.2,64z M414,416c-1.1,0-313.1,0-314.9,0s-3.1-1.4-3.1-3.1S96,99.1,96,98s1-2,2-2s315,0,316,0s2,1,2,2\r\n\t\tc0,23.3,0,314.9,0,316C416,414.9,415.1,416,414,416z"},"children":[]}]}]}]};exports.socialLinkedinOutline=socialLinkedinOutline;var socialLinkedin={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M417.2,64H96.8C79.3,64,64,76.6,64,93.9v321.1c0,17.4,15.3,32.9,32.8,32.9h320.3c17.6,0,30.8-15.6,30.8-32.9V93.9\r\n\t\tC448,76.6,434.7,64,417.2,64z M183,384h-55V213h55V384z M157.4,187H157c-17.6,0-29-13.1-29-29.5c0-16.7,11.7-29.5,29.7-29.5\r\n\t\tc18,0,29,12.7,29.4,29.5C187.1,173.9,175.7,187,157.4,187z M384,384h-55v-93.5c0-22.4-8-37.7-27.9-37.7\r\n\t\tc-15.2,0-24.2,10.3-28.2,20.3c-1.5,3.6-1.9,8.5-1.9,13.5V384h-55V213h55v23.8c8-11.4,20.5-27.8,49.6-27.8\r\n\t\tc36.1,0,63.4,23.8,63.4,75.1V384z"},"children":[{"name":"path","attribs":{"d":"M417.2,64H96.8C79.3,64,64,76.6,64,93.9v321.1c0,17.4,15.3,32.9,32.8,32.9h320.3c17.6,0,30.8-15.6,30.8-32.9V93.9\r\n\t\tC448,76.6,434.7,64,417.2,64z M183,384h-55V213h55V384z M157.4,187H157c-17.6,0-29-13.1-29-29.5c0-16.7,11.7-29.5,29.7-29.5\r\n\t\tc18,0,29,12.7,29.4,29.5C187.1,173.9,175.7,187,157.4,187z M384,384h-55v-93.5c0-22.4-8-37.7-27.9-37.7\r\n\t\tc-15.2,0-24.2,10.3-28.2,20.3c-1.5,3.6-1.9,8.5-1.9,13.5V384h-55V213h55v23.8c8-11.4,20.5-27.8,49.6-27.8\r\n\t\tc36.1,0,63.4,23.8,63.4,75.1V384z"},"children":[]}]}]}]};exports.socialLinkedin=socialLinkedin;var socialMarkdown={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"transform":"translate(96 48)"},"children":[{"name":"g","attribs":{"id":"icon-markdown"},"children":[{"name":"g","attribs":{"id":"icon-markdown"},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M351.659,48H-31.659C-49.496,48-64,62.484-64,80.308v255.349C-64,353.493-49.496,368-31.659,368h383.318\r\n\t\t\tC369.496,368,384,353.493,384,335.656V80.308C384,62.484,369.496,48,351.659,48z M188.023,304h-56.048v-96l-42.04,53.878\r\n\t\t\tL47.913,208v96H-8.131V112h56.044l42.022,67.98l42.04-67.98h56.048V304L188.023,304z M271.68,304l-69.635-96h42v-96h56.043v96\r\n\t\t\th42.027l-70.453,96H271.68z"},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M351.659,48H-31.659C-49.496,48-64,62.484-64,80.308v255.349C-64,353.493-49.496,368-31.659,368h383.318\r\n\t\t\tC369.496,368,384,353.493,384,335.656V80.308C384,62.484,369.496,48,351.659,48z M188.023,304h-56.048v-96l-42.04,53.878\r\n\t\t\tL47.913,208v96H-8.131V112h56.044l42.022,67.98l42.04-67.98h56.048V304L188.023,304z M271.68,304l-69.635-96h42v-96h56.043v96\r\n\t\t\th42.027l-70.453,96H271.68z"},"children":[]}]}]}]}]}]};exports.socialMarkdown=socialMarkdown;var socialNodejs={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{"transform":"translate(96 96)"},"children":[{"name":"g","attribs":{"id":"icon-nodejs_small"},"children":[{"name":"g","attribs":{"id":"icon-nodejs_small"},"children":[{"name":"path","attribs":{"d":"M159.917,384c-5.77,0-11.536-1.562-16.633-4.599l-52.985-32.44c-7.914-4.562-4.023-6.203-1.443-7.141\r\n\t\t\tc10.565-3.781,13.713-5.657,24.947-12.285c1.206-0.667,2.747-0.424,3.955,0.322l39.71,23.504c1.476,0.85,3.557,0.85,4.931,0\r\n\t\t\tl155.188-92.246c1.475-0.877,2.415-2.646,2.415-4.441V67.869c0-1.85-0.94-3.592-2.449-4.528L162.433-31.331\r\n\t\t\tc-1.478-0.894-3.421-0.894-4.898,0L2.516,63.374C0.972,64.277,0,66.072,0,67.869v186.805c0,1.813,0.972,3.513,2.481,4.389\r\n\t\t\tl39.929,23.972C66.02,295.239,80,282.865,80,268.424V84.725c0-2.652,2.047-4.727,4.596-4.727h22.809\r\n\t\t\tc2.515,0,4.597,2.072,4.597,4.727v183.698c0,32.563-19.353,51.248-49.199,51.248c-9.156,0-16.397,0-36.552-10.279l-41.584-24.781\r\n\t\t\tC-25.629,278.459-32,266.965-32,254.656V65.191c0-12.316,6.371-23.784,16.665-29.917L143.35-59.59\r\n\t\t\tc10.027-5.88,23.374-5.88,33.332,0l158.65,94.864C345.63,41.423,352,52.899,352,65.191v189.465c0,12.309-6.37,23.75-16.668,29.953\r\n\t\t\tl-158.65,94.774c-5.097,3.036-10.832,4.599-16.698,4.599L159.917,384z"},"children":[{"name":"path","attribs":{"d":"M159.917,384c-5.77,0-11.536-1.562-16.633-4.599l-52.985-32.44c-7.914-4.562-4.023-6.203-1.443-7.141\r\n\t\t\tc10.565-3.781,13.713-5.657,24.947-12.285c1.206-0.667,2.747-0.424,3.955,0.322l39.71,23.504c1.476,0.85,3.557,0.85,4.931,0\r\n\t\t\tl155.188-92.246c1.475-0.877,2.415-2.646,2.415-4.441V67.869c0-1.85-0.94-3.592-2.449-4.528L162.433-31.331\r\n\t\t\tc-1.478-0.894-3.421-0.894-4.898,0L2.516,63.374C0.972,64.277,0,66.072,0,67.869v186.805c0,1.813,0.972,3.513,2.481,4.389\r\n\t\t\tl39.929,23.972C66.02,295.239,80,282.865,80,268.424V84.725c0-2.652,2.047-4.727,4.596-4.727h22.809\r\n\t\t\tc2.515,0,4.597,2.072,4.597,4.727v183.698c0,32.563-19.353,51.248-49.199,51.248c-9.156,0-16.397,0-36.552-10.279l-41.584-24.781\r\n\t\t\tC-25.629,278.459-32,266.965-32,254.656V65.191c0-12.316,6.371-23.784,16.665-29.917L143.35-59.59\r\n\t\t\tc10.027-5.88,23.374-5.88,33.332,0l158.65,94.864C345.63,41.423,352,52.899,352,65.191v189.465c0,12.309-6.37,23.75-16.668,29.953\r\n\t\t\tl-158.65,94.774c-5.097,3.036-10.832,4.599-16.698,4.599L159.917,384z"},"children":[]}]},{"name":"path","attribs":{"d":"M208.943,255.998c-64.61,0-84.006-31.61-84.006-59.271c0-2.629,2.048-4.729,4.562-4.729h20.521\r\n\t\t\tc2.282,0,4.227,1.7,4.562,4.016c3.084,21.602,16.748,31.15,54.324,31.15c33.399,0,47.091-10.346,47.091-28.684\r\n\t\t\tc0-10.592-3.463-18.424-55.407-23.697c-43.427-4.441-70.288-14.373-70.288-50.295c0-33.135,26.996-52.49,72.234-52.49\r\n\t\t\tc46.128,0,76.462,14,79.173,50.829c0.102,1.337-0.368,2.629-1.241,3.644c-0.871,0.965-2.078,1.527-3.353,1.527h-20.591\r\n\t\t\tc-2.146,0-4.024-1.562-4.459-3.713c-4.401-16.953-16.97-23.402-49.563-23.402c-36.486,0-40.746,12.753-40.746,22.607\r\n\t\t\tc0,11.963,5.031,15.441,54.294,22.172c48.761,6.663,71.933,16.117,71.933,51.552c0,35.781-28.808,58.783-79.075,58.783\r\n\t\t\tL208.943,255.998L208.943,255.998z"},"children":[{"name":"path","attribs":{"d":"M208.943,255.998c-64.61,0-84.006-31.61-84.006-59.271c0-2.629,2.048-4.729,4.562-4.729h20.521\r\n\t\t\tc2.282,0,4.227,1.7,4.562,4.016c3.084,21.602,16.748,31.15,54.324,31.15c33.399,0,47.091-10.346,47.091-28.684\r\n\t\t\tc0-10.592-3.463-18.424-55.407-23.697c-43.427-4.441-70.288-14.373-70.288-50.295c0-33.135,26.996-52.49,72.234-52.49\r\n\t\t\tc46.128,0,76.462,14,79.173,50.829c0.102,1.337-0.368,2.629-1.241,3.644c-0.871,0.965-2.078,1.527-3.353,1.527h-20.591\r\n\t\t\tc-2.146,0-4.024-1.562-4.459-3.713c-4.401-16.953-16.97-23.402-49.563-23.402c-36.486,0-40.746,12.753-40.746,22.607\r\n\t\t\tc0,11.963,5.031,15.441,54.294,22.172c48.761,6.663,71.933,16.117,71.933,51.552c0,35.781-28.808,58.783-79.075,58.783\r\n\t\t\tL208.943,255.998L208.943,255.998z"},"children":[]}]}]}]}]}]};exports.socialNodejs=socialNodejs;var socialOctocat={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M178.354,287.478c-9.123,0-16.928,4.207-23.201,12.833c-6.291,8.478-9.398,18.973-9.398,31.431\r\n\t\tc0,12.474,3.166,23.008,9.398,31.509c6.273,8.54,14.039,12.771,23.201,12.771c8.494,0,15.889-4.27,22.121-12.771\r\n\t\tc6.271-8.501,9.398-19.035,9.398-31.509c0-12.419-3.166-22.93-9.398-31.431C194.242,291.724,186.908,287.478,178.354,287.478z"},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M178.354,287.478c-9.123,0-16.928,4.207-23.201,12.833c-6.291,8.478-9.398,18.973-9.398,31.431\r\n\t\tc0,12.474,3.166,23.008,9.398,31.509c6.273,8.54,14.039,12.771,23.201,12.771c8.494,0,15.889-4.27,22.121-12.771\r\n\t\tc6.271-8.501,9.398-19.035,9.398-31.509c0-12.419-3.166-22.93-9.398-31.431C194.242,291.724,186.908,287.478,178.354,287.478z"},"children":[]}]},{"name":"path","attribs":{"fill":"#231F20","d":"M334.668,287.478c-9.045,0-16.891,4.207-23.182,12.833c-6.271,8.478-9.359,18.973-9.359,31.431\r\n\t\tc0,12.474,3.186,23.008,9.359,31.509c6.291,8.54,14.098,12.771,23.182,12.771c8.533,0,15.906-4.27,22.178-12.771\r\n\t\tc6.293-8.501,9.418-19.035,9.418-31.509c0-12.419-3.164-22.93-9.418-31.431C350.574,291.724,343.299,287.478,334.668,287.478z"},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M334.668,287.478c-9.045,0-16.891,4.207-23.182,12.833c-6.271,8.478-9.359,18.973-9.359,31.431\r\n\t\tc0,12.474,3.186,23.008,9.359,31.509c6.291,8.54,14.098,12.771,23.182,12.771c8.533,0,15.906-4.27,22.178-12.771\r\n\t\tc6.293-8.501,9.418-19.035,9.418-31.509c0-12.419-3.164-22.93-9.418-31.431C350.574,291.724,343.299,287.478,334.668,287.478z"},"children":[]}]},{"name":"path","attribs":{"fill":"#231F20","d":"M445.777,172h-0.059c0,0,2.793-14.264,0.314-39.18c-2.182-24.916-7.471-47.838-16.123-68.82\r\n\t\tc0,0-4.422,0.76-12.76,2.896s-22.08,6.299-40.938,14.768c-18.541,8.54-37.986,19.788-58.297,33.505\r\n\t\tc-13.803-3.934-34.408-5.939-61.994-5.939c-26.289,0-46.914,2.012-61.977,5.945c-44.592-30.859-81.832-47.945-112.092-51.175\r\n\t\tc-8.594,20.982-13.883,43.991-16.045,68.97c-2.398,24.939,0.432,39.329,0.432,39.329C41.979,198.551,32,236.541,32,267.793\r\n\t\tc0,24.244,0.658,46.078,6.125,65.48c5.564,19.31,12.662,35.13,21.098,47.221c8.611,12.121,19.012,22.788,31.576,31.938\r\n\t\tc12.467,9.314,23.988,15.962,34.389,20.216c10.461,4.372,22.375,7.602,35.982,9.861c13.33,2.386,23.438,3.645,30.477,3.996\r\n\t\tc0,0,28,1.494,64.354,1.494c36.354,0,64.295-1.494,64.295-1.494c7.02-0.352,17.145-1.634,30.535-3.996\r\n\t\tc13.547-2.299,25.521-5.607,35.941-9.861c10.402-4.293,21.943-10.901,34.469-20.216c12.523-9.032,22.906-19.739,31.518-31.938\r\n\t\tc8.436-12.091,15.494-27.911,21.098-47.221c5.486-19.402,6.145-41.385,6.145-65.629C480,237.389,469.982,199,445.777,172z\r\n\t\t M380.383,405.645C352.521,418.736,311.486,424,257.061,424l-2.143-0.039c-54.443,0-95.361-5.248-122.848-18.41\r\n\t\tc-27.508-13.092-41.271-40.057-41.271-80.738c0-24.33,8.572-43.99,25.482-59.107c7.354-6.515,16.438-11.019,27.645-13.717\r\n\t\tc11.129-2.558,21.354-2.762,30.969-2.465c9.398,0.415,22.551,2.196,39.344,3.464C231.029,254.285,243.535,256,256,256\r\n\t\tc11.698,0,27.213-1.957,52.104-3.959c24.99-1.971,43.494-2.971,55.467-1c12.289,2.002,22.986,6.202,32.129,14.742\r\n\t\tc17.734,15.751,26.602,35.505,26.602,59.084C422.301,365.533,408.164,392.537,380.383,405.645z"},"children":[{"name":"path","attribs":{"fill":"#231F20","d":"M445.777,172h-0.059c0,0,2.793-14.264,0.314-39.18c-2.182-24.916-7.471-47.838-16.123-68.82\r\n\t\tc0,0-4.422,0.76-12.76,2.896s-22.08,6.299-40.938,14.768c-18.541,8.54-37.986,19.788-58.297,33.505\r\n\t\tc-13.803-3.934-34.408-5.939-61.994-5.939c-26.289,0-46.914,2.012-61.977,5.945c-44.592-30.859-81.832-47.945-112.092-51.175\r\n\t\tc-8.594,20.982-13.883,43.991-16.045,68.97c-2.398,24.939,0.432,39.329,0.432,39.329C41.979,198.551,32,236.541,32,267.793\r\n\t\tc0,24.244,0.658,46.078,6.125,65.48c5.564,19.31,12.662,35.13,21.098,47.221c8.611,12.121,19.012,22.788,31.576,31.938\r\n\t\tc12.467,9.314,23.988,15.962,34.389,20.216c10.461,4.372,22.375,7.602,35.982,9.861c13.33,2.386,23.438,3.645,30.477,3.996\r\n\t\tc0,0,28,1.494,64.354,1.494c36.354,0,64.295-1.494,64.295-1.494c7.02-0.352,17.145-1.634,30.535-3.996\r\n\t\tc13.547-2.299,25.521-5.607,35.941-9.861c10.402-4.293,21.943-10.901,34.469-20.216c12.523-9.032,22.906-19.739,31.518-31.938\r\n\t\tc8.436-12.091,15.494-27.911,21.098-47.221c5.486-19.402,6.145-41.385,6.145-65.629C480,237.389,469.982,199,445.777,172z\r\n\t\t M380.383,405.645C352.521,418.736,311.486,424,257.061,424l-2.143-0.039c-54.443,0-95.361-5.248-122.848-18.41\r\n\t\tc-27.508-13.092-41.271-40.057-41.271-80.738c0-24.33,8.572-43.99,25.482-59.107c7.354-6.515,16.438-11.019,27.645-13.717\r\n\t\tc11.129-2.558,21.354-2.762,30.969-2.465c9.398,0.415,22.551,2.196,39.344,3.464C231.029,254.285,243.535,256,256,256\r\n\t\tc11.698,0,27.213-1.957,52.104-3.959c24.99-1.971,43.494-2.971,55.467-1c12.289,2.002,22.986,6.202,32.129,14.742\r\n\t\tc17.734,15.751,26.602,35.505,26.602,59.084C422.301,365.533,408.164,392.537,380.383,405.645z"},"children":[]}]}]}]};exports.socialOctocat=socialOctocat;var socialPinterestOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256s100.3,224,224,224s224-100.3,224-224S379.7,32,256,32z M391.8,391.8\r\n\tC355.5,428,307.3,448,256,448c-16.2,0-32.1-2-47.4-5.9c2.8-6.3,5.2-12.8,7-19.3c2.8-10,15.8-61.6,15.8-61.6\r\n\tc7.8,14.8,30.5,27.9,54.7,27.9c72,0,120.9-65.6,120.9-153.5c0-66.4-56.3-128.3-141.8-128.3c-106.4,0-160.1,76.3-160.1,139.9\r\n\tc0,38.5,14.6,72.8,45.9,85.6c5.1,2.1,9.7,0.1,11.2-5.6c1-3.9,3.5-13.9,4.6-18c1.5-5.6,0.9-7.6-3.2-12.5c-9-10.7-14.8-24.4-14.8-43.9\r\n\tc0-56.6,42.3-107.3,110.3-107.3c60.1,0,93.2,36.7,93.2,85.8c0,64.6-28.6,119.1-71,119.1c-23.4,0-41-19.4-35.4-43.1\r\n\tc6.7-28.4,19.8-59,19.8-79.5c0-18.3-9.8-33.6-30.2-33.6c-24,0-43.2,24.8-43.2,58c0,21.1,7.2,35.4,7.2,35.4s-24.5,103.9-28.8,122.1\r\n\tc-1.3,5.5-2.2,11.1-2.9,16.8c-17.3-9-33.3-20.6-47.4-34.8C84,355.5,64,307.3,64,256s20-99.5,56.2-135.8C156.5,84,204.7,64,256,64\r\n\ts99.5,20,135.8,56.2C428,156.5,448,204.7,448,256S428,355.5,391.8,391.8z"},"children":[]}]};exports.socialPinterestOutline=socialPinterestOutline;var socialPinterest={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,91.7,55.2,170.5,134.1,205.2c-0.6-15.6-0.1-34.4,3.9-51.4\r\n\t\tc4.3-18.2,28.8-122.1,28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2,19.2-58,43.2-58c20.4,0,30.2,15.3,30.2,33.6\r\n\t\tc0,20.5-13.1,51.1-19.8,79.5c-5.6,23.8,11.9,43.1,35.4,43.1c42.4,0,71-54.5,71-119.1c0-49.1-33.1-85.8-93.2-85.8\r\n\t\tc-67.9,0-110.3,50.7-110.3,107.3c0,19.5,5.8,33.3,14.8,43.9c4.1,4.9,4.7,6.9,3.2,12.5c-1.1,4.1-3.5,14-4.6,18\r\n\t\tc-1.5,5.7-6.1,7.7-11.2,5.6c-31.3-12.8-45.9-47-45.9-85.6c0-63.6,53.7-139.9,160.1-139.9c85.5,0,141.8,61.9,141.8,128.3\r\n\t\tc0,87.9-48.9,153.5-120.9,153.5c-24.2,0-46.9-13.1-54.7-27.9c0,0-13,51.6-15.8,61.6c-4.7,17.3-14,34.5-22.5,48\r\n\t\tc20.1,5.9,41.4,9.2,63.5,9.2c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z"},"children":[{"name":"path","attribs":{"d":"M256,32C132.3,32,32,132.3,32,256c0,91.7,55.2,170.5,134.1,205.2c-0.6-15.6-0.1-34.4,3.9-51.4\r\n\t\tc4.3-18.2,28.8-122.1,28.8-122.1s-7.2-14.3-7.2-35.4c0-33.2,19.2-58,43.2-58c20.4,0,30.2,15.3,30.2,33.6\r\n\t\tc0,20.5-13.1,51.1-19.8,79.5c-5.6,23.8,11.9,43.1,35.4,43.1c42.4,0,71-54.5,71-119.1c0-49.1-33.1-85.8-93.2-85.8\r\n\t\tc-67.9,0-110.3,50.7-110.3,107.3c0,19.5,5.8,33.3,14.8,43.9c4.1,4.9,4.7,6.9,3.2,12.5c-1.1,4.1-3.5,14-4.6,18\r\n\t\tc-1.5,5.7-6.1,7.7-11.2,5.6c-31.3-12.8-45.9-47-45.9-85.6c0-63.6,53.7-139.9,160.1-139.9c85.5,0,141.8,61.9,141.8,128.3\r\n\t\tc0,87.9-48.9,153.5-120.9,153.5c-24.2,0-46.9-13.1-54.7-27.9c0,0-13,51.6-15.8,61.6c-4.7,17.3-14,34.5-22.5,48\r\n\t\tc20.1,5.9,41.4,9.2,63.5,9.2c123.7,0,224-100.3,224-224C480,132.3,379.7,32,256,32z"},"children":[]}]}]}]};exports.socialPinterest=socialPinterest;var socialPython={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M193.46,249.056c3.723-0.67,7.589-1.041,11.586-1.041L201.924,248h103.823c4.503,0,8.806-0.617,12.908-1.754\r\n\t\tc19.37-5.363,33.345-22.537,33.345-43.663v-30.822v-56.402c0-24.832-21.15-43.484-46.289-47.606\r\n\t\tc-15.931-2.624-39.258-3.827-55.089-3.749c-15.829,0.086-30.981,1.404-44.277,3.749C167.143,74.576,160,88.928,160,115.359V144h96\r\n\t\tv16H128.82c-35.628,0-64.538,42.571-64.813,95.242C64.005,255.495,64,255.747,64,256c0,9.523,0.94,18.72,2.685,27.404\r\n\t\tC74.648,323.07,99.451,352,128.82,352H144v-2.662v-43.273C144,279.238,164.146,254.332,193.46,249.056z M203.656,127.002\r\n\t\tc-9.592,0-17.384-7.785-17.384-17.403c0-9.664,7.774-17.52,17.384-17.52c9.574,0,17.399,7.855,17.399,17.52\r\n\t\tC221.056,119.217,213.246,127.002,203.656,127.002z"},"children":[{"name":"path","attribs":{"d":"M193.46,249.056c3.723-0.67,7.589-1.041,11.586-1.041L201.924,248h103.823c4.503,0,8.806-0.617,12.908-1.754\r\n\t\tc19.37-5.363,33.345-22.537,33.345-43.663v-30.822v-56.402c0-24.832-21.15-43.484-46.289-47.606\r\n\t\tc-15.931-2.624-39.258-3.827-55.089-3.749c-15.829,0.086-30.981,1.404-44.277,3.749C167.143,74.576,160,88.928,160,115.359V144h96\r\n\t\tv16H128.82c-35.628,0-64.538,42.571-64.813,95.242C64.005,255.495,64,255.747,64,256c0,9.523,0.94,18.72,2.685,27.404\r\n\t\tC74.648,323.07,99.451,352,128.82,352H144v-2.662v-43.273C144,279.238,164.146,254.332,193.46,249.056z M203.656,127.002\r\n\t\tc-9.592,0-17.384-7.785-17.384-17.403c0-9.664,7.774-17.52,17.384-17.52c9.574,0,17.399,7.855,17.399,17.52\r\n\t\tC221.056,119.217,213.246,127.002,203.656,127.002z"},"children":[]}]},{"name":"path","attribs":{"d":"M443.951,222.543C434.78,186.021,411.033,160,383.18,160H368v2.626v38.046c0,33.915-22.286,58.474-49.489,62.681\r\n\t\tc-2.737,0.424-5.483,0.646-8.301,0.646H206.351c-4.518,0-8.904,0.584-13.049,1.672C174.18,270.689,160,286.6,160,307.236v32.922\r\n\t\tv54.305c0,24.832,24.977,39.426,49.481,46.551c29.327,8.531,61.267,10.068,96.366,0C329.15,434.354,352,420.893,352,394.463V368\r\n\t\th-96v-16h127.18c25.24,0,47.107-21.365,57.814-52.549C445.474,286.404,448,271.641,448,256\r\n\t\tC448,244.232,446.567,232.962,443.951,222.543z M307.867,382.82c9.59,0,17.381,7.785,17.381,17.4\r\n\t\tc0,9.65-7.791,17.521-17.381,17.521c-9.577,0-17.399-7.871-17.399-17.521C290.468,390.59,298.274,382.82,307.867,382.82z"},"children":[{"name":"path","attribs":{"d":"M443.951,222.543C434.78,186.021,411.033,160,383.18,160H368v2.626v38.046c0,33.915-22.286,58.474-49.489,62.681\r\n\t\tc-2.737,0.424-5.483,0.646-8.301,0.646H206.351c-4.518,0-8.904,0.584-13.049,1.672C174.18,270.689,160,286.6,160,307.236v32.922\r\n\t\tv54.305c0,24.832,24.977,39.426,49.481,46.551c29.327,8.531,61.267,10.068,96.366,0C329.15,434.354,352,420.893,352,394.463V368\r\n\t\th-96v-16h127.18c25.24,0,47.107-21.365,57.814-52.549C445.474,286.404,448,271.641,448,256\r\n\t\tC448,244.232,446.567,232.962,443.951,222.543z M307.867,382.82c9.59,0,17.381,7.785,17.381,17.4\r\n\t\tc0,9.65-7.791,17.521-17.381,17.521c-9.577,0-17.399-7.871-17.399-17.521C290.468,390.59,298.274,382.82,307.867,382.82z"},"children":[]}]}]}]};exports.socialPython=socialPython;var socialRedditOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"cx":"322.3","cy":"288.4","r":"31.8"},"children":[{"name":"circle","attribs":{"cx":"322.3","cy":"288.4","r":"31.8"},"children":[]}]},{"name":"circle","attribs":{"cx":"190.3","cy":"288.4","r":"31.8"},"children":[{"name":"circle","attribs":{"cx":"190.3","cy":"288.4","r":"31.8"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M480.5,251c0-27.7-22.2-50.2-49.5-50.2c-13,0-24.7,5-33.6,13.3c-33.2-23.4-78.4-38.5-128.7-40.7L292,95.7l69.6,13.9\r\n\t\t\tc0.2,24.7,20.1,44.7,44.5,44.7c24.6,0,44.5-20.2,44.5-45.1S430.7,64,406.1,64c-18.6,0-34.5,11.6-41.2,28l-85.2-17l-29.4,98.2\r\n\t\t\tl-7.1,0.2c-50.3,2.2-95.5,17.4-128.7,40.7c-8.8-8.3-20.6-13.3-33.6-13.3c-27.3,0-49.5,22.5-49.5,50.2c0,19.6,11,36.5,27.1,44.8\r\n\t\t\tc-0.8,4.9-1.2,9.8-1.2,14.8C57.5,386.4,146.4,448,256,448s198.5-61.6,198.5-137.5c0-5-0.4-9.9-1.1-14.8\r\n\t\t\tC469.5,287.4,480.5,270.5,480.5,251z M406.1,81.9c14.8,0,26.8,12.2,26.8,27.2c0,15-12,27.2-26.8,27.2c-14.8,0-26.8-12.2-26.8-27.2\r\n\t\t\tC379.3,94.1,391.3,81.9,406.1,81.9z M49.2,251c0-17.8,14.3-32.2,31.8-32.2c7.2,0,13.9,2.5,19.2,6.6c-17.3,15.2-30.1,33-37,52.4\r\n\t\t\tC54.8,271.9,49.2,262.1,49.2,251z M386.4,392.9c-34.6,23.9-80.9,37.1-130.4,37.1s-95.8-13.2-130.4-37.1\r\n\t\t\tc-32.5-22.5-50.4-51.8-50.4-82.4c0-3.2,0.2-6.5,0.6-9.7c0.7-6,2.2-11.9,4.3-17.7c5.6-15.6,16-30.3,30.7-43.4\r\n\t\t\tc4.4-3.9,9.2-7.7,14.4-11.3c0.1-0.1,0.3-0.2,0.4-0.3C160.2,204.2,206.5,191,256,191c49.5,0,95.8,13.2,130.4,37.1\r\n\t\t\tc0.1,0.1,0.3,0.2,0.4,0.3c5.2,3.6,10,7.4,14.4,11.3c14.7,13.1,25.1,27.8,30.7,43.4c2.1,5.8,3.5,11.7,4.3,17.7\r\n\t\t\tc0.4,3.2,0.6,6.4,0.6,9.7C436.8,341.1,418.9,370.4,386.4,392.9z M448.8,277.7c-6.9-19.4-19.7-37.2-37-52.4\r\n\t\t\tc5.3-4.1,12-6.6,19.2-6.6c17.5,0,31.8,14.5,31.8,32.2C462.8,262.1,457.2,271.9,448.8,277.7z"},"children":[{"name":"path","attribs":{"d":"M480.5,251c0-27.7-22.2-50.2-49.5-50.2c-13,0-24.7,5-33.6,13.3c-33.2-23.4-78.4-38.5-128.7-40.7L292,95.7l69.6,13.9\r\n\t\t\tc0.2,24.7,20.1,44.7,44.5,44.7c24.6,0,44.5-20.2,44.5-45.1S430.7,64,406.1,64c-18.6,0-34.5,11.6-41.2,28l-85.2-17l-29.4,98.2\r\n\t\t\tl-7.1,0.2c-50.3,2.2-95.5,17.4-128.7,40.7c-8.8-8.3-20.6-13.3-33.6-13.3c-27.3,0-49.5,22.5-49.5,50.2c0,19.6,11,36.5,27.1,44.8\r\n\t\t\tc-0.8,4.9-1.2,9.8-1.2,14.8C57.5,386.4,146.4,448,256,448s198.5-61.6,198.5-137.5c0-5-0.4-9.9-1.1-14.8\r\n\t\t\tC469.5,287.4,480.5,270.5,480.5,251z M406.1,81.9c14.8,0,26.8,12.2,26.8,27.2c0,15-12,27.2-26.8,27.2c-14.8,0-26.8-12.2-26.8-27.2\r\n\t\t\tC379.3,94.1,391.3,81.9,406.1,81.9z M49.2,251c0-17.8,14.3-32.2,31.8-32.2c7.2,0,13.9,2.5,19.2,6.6c-17.3,15.2-30.1,33-37,52.4\r\n\t\t\tC54.8,271.9,49.2,262.1,49.2,251z M386.4,392.9c-34.6,23.9-80.9,37.1-130.4,37.1s-95.8-13.2-130.4-37.1\r\n\t\t\tc-32.5-22.5-50.4-51.8-50.4-82.4c0-3.2,0.2-6.5,0.6-9.7c0.7-6,2.2-11.9,4.3-17.7c5.6-15.6,16-30.3,30.7-43.4\r\n\t\t\tc4.4-3.9,9.2-7.7,14.4-11.3c0.1-0.1,0.3-0.2,0.4-0.3C160.2,204.2,206.5,191,256,191c49.5,0,95.8,13.2,130.4,37.1\r\n\t\t\tc0.1,0.1,0.3,0.2,0.4,0.3c5.2,3.6,10,7.4,14.4,11.3c14.7,13.1,25.1,27.8,30.7,43.4c2.1,5.8,3.5,11.7,4.3,17.7\r\n\t\t\tc0.4,3.2,0.6,6.4,0.6,9.7C436.8,341.1,418.9,370.4,386.4,392.9z M448.8,277.7c-6.9-19.4-19.7-37.2-37-52.4\r\n\t\t\tc5.3-4.1,12-6.6,19.2-6.6c17.5,0,31.8,14.5,31.8,32.2C462.8,262.1,457.2,271.9,448.8,277.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M320.5,357.9c-0.2,0.2-24.2,24.2-64.5,24.4c-40.9-0.2-64.4-24.2-64.6-24.4l-12.6,12.4c1.2,1.2,29.6,29.5,77.2,29.7\r\n\t\t\tc47.6-0.2,75.9-28.5,77.1-29.7L320.5,357.9z"},"children":[{"name":"path","attribs":{"d":"M320.5,357.9c-0.2,0.2-24.2,24.2-64.5,24.4c-40.9-0.2-64.4-24.2-64.6-24.4l-12.6,12.4c1.2,1.2,29.6,29.5,77.2,29.7\r\n\t\t\tc47.6-0.2,75.9-28.5,77.1-29.7L320.5,357.9z"},"children":[]}]}]}]}]}]};exports.socialRedditOutline=socialRedditOutline;var socialReddit={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M480.5,251c0-27.7-22.2-50.2-49.5-50.2c-13,0-24.7,5-33.6,13.3c-32.4-22.8-76.1-37.8-124.9-40.6l21.9-73.2l67.1,13.5\r\n\tc2.3,22.7,21.2,40.4,44.3,40.4c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0c24.6,0,44.5-20.2,44.5-45.1S430.7,64,406.1,64\r\n\tc-0.1,0-0.1,0-0.2,0c0,0-0.1,0-0.1,0c-17.2,0-32,9.8-39.5,24.3l-89.7-18l-30.8,103l-2.5,0.1c-50.3,2.2-95.5,17.4-128.7,40.7\r\n\tc-8.8-8.3-20.6-13.3-33.6-13.3c-27.3,0-49.5,22.5-49.5,50.2c0,19.6,11,36.5,27.1,44.8c-0.8,4.9-1.2,9.8-1.2,14.8\r\n\tC57.5,386.4,146.4,448,256,448s198.5-61.6,198.5-137.5c0-5-0.4-9.9-1.1-14.8C469.5,287.4,480.5,270.5,480.5,251z M65.8,271.1\r\n\tc-6.6-4.5-10.9-12.1-10.9-20.8c0-13.8,11.1-25.1,24.7-25.1c5.6,0,10.8,1.9,15,5.1C81.1,242.2,71.1,256,65.8,271.1z M389.3,109.1\r\n\tc0-9.2,7.4-16.8,16.5-16.8s16.5,7.5,16.5,16.8c0,9.2-7.4,16.8-16.5,16.8S389.3,118.4,389.3,109.1z M158.5,288.4\r\n\tc0-17.6,14.2-31.8,31.8-31.8s31.8,14.2,31.8,31.8c0,17.6-14.2,31.8-31.8,31.8S158.5,306,158.5,288.4z M256,400\r\n\tc-47.6-0.2-76-28.5-77.2-29.7l12.6-12.4c0.2,0.2,23.7,24.2,64.6,24.4c40.3-0.2,64.2-24.2,64.5-24.4l12.6,12.4\r\n\tC331.9,371.5,303.6,399.8,256,400z M322.3,320.2c-17.6,0-31.8-14.2-31.8-31.8c0-17.6,14.2-31.8,31.8-31.8s31.8,14.2,31.8,31.8\r\n\tC354.1,306,339.8,320.2,322.3,320.2z M446.4,271.5c-5.4-15.3-15.6-29.4-29.3-41.4c4.2-3.3,9.5-5.2,15.2-5.2\r\n\tc13.9,0,25.1,11.4,25.1,25.5C457.5,259.2,453.1,266.9,446.4,271.5z"},"children":[]}]};exports.socialReddit=socialReddit;var socialRssOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M119.9,336.1c-30.8,0-55.9,25.1-55.9,55.8c0,30.8,25.1,55.6,55.9,55.6c30.9,0,55.9-24.9,55.9-55.6\r\n\t\tC175.8,361.2,150.8,336.1,119.9,336.1z M119.9,431.5c-22,0-39.9-17.8-39.9-39.6c0-21.9,17.9-39.8,39.9-39.8\r\n\t\tc22,0,39.9,17.9,39.9,39.8C159.8,413.7,141.9,431.5,119.9,431.5z"},"children":[{"name":"path","attribs":{"d":"M119.9,336.1c-30.8,0-55.9,25.1-55.9,55.8c0,30.8,25.1,55.6,55.9,55.6c30.9,0,55.9-24.9,55.9-55.6\r\n\t\tC175.8,361.2,150.8,336.1,119.9,336.1z M119.9,431.5c-22,0-39.9-17.8-39.9-39.6c0-21.9,17.9-39.8,39.9-39.8\r\n\t\tc22,0,39.9,17.9,39.9,39.8C159.8,413.7,141.9,431.5,119.9,431.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,192v79.9c48,0,94.1,14.2,128,48.1c33.9,33.9,48,79.9,48,128h80C320,308.1,204,192,64,192z M303.5,432h-48\r\n\t\tc-3.1-49.7-21-92.1-52.2-123.3C172.1,277.4,130,259.5,80,256.4v-47.8c26,1.8,52.1,8,76.7,18.5c28.5,12.2,54.2,29.6,76.4,51.8\r\n\t\tc22.2,22.2,39.6,47.9,51.8,76.4C295.5,379.9,301.7,405.6,303.5,432z"},"children":[{"name":"path","attribs":{"d":"M64,192v79.9c48,0,94.1,14.2,128,48.1c33.9,33.9,48,79.9,48,128h80C320,308.1,204,192,64,192z M303.5,432h-48\r\n\t\tc-3.1-49.7-21-92.1-52.2-123.3C172.1,277.4,130,259.5,80,256.4v-47.8c26,1.8,52.1,8,76.7,18.5c28.5,12.2,54.2,29.6,76.4,51.8\r\n\t\tc22.2,22.2,39.6,47.9,51.8,76.4C295.5,379.9,301.7,405.6,303.5,432z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,64v79.9c171,0,303.9,133,303.9,304.1H448C448,236.3,276,64,64,64z M291.4,220.5C235.4,164.4,161,132,80,128.2V80.3\r\n\t\tC270,88.5,423.5,241.8,431.7,432h-48.2C379.7,351.1,347.3,276.5,291.4,220.5z"},"children":[{"name":"path","attribs":{"d":"M64,64v79.9c171,0,303.9,133,303.9,304.1H448C448,236.3,276,64,64,64z M291.4,220.5C235.4,164.4,161,132,80,128.2V80.3\r\n\t\tC270,88.5,423.5,241.8,431.7,432h-48.2C379.7,351.1,347.3,276.5,291.4,220.5z"},"children":[]}]}]}]};exports.socialRssOutline=socialRssOutline;var socialRss={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M119.9,336.1c-30.8,0-55.9,25.1-55.9,55.8c0,30.8,25.1,55.6,55.9,55.6c30.9,0,55.9-24.9,55.9-55.6\r\n\t\tC175.8,361.2,150.8,336.1,119.9,336.1z"},"children":[{"name":"path","attribs":{"d":"M119.9,336.1c-30.8,0-55.9,25.1-55.9,55.8c0,30.8,25.1,55.6,55.9,55.6c30.9,0,55.9-24.9,55.9-55.6\r\n\t\tC175.8,361.2,150.8,336.1,119.9,336.1z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,192v79.9c48,0,94.1,14.2,128,48.1c33.9,33.9,48,79.9,48,128h80C320,308.1,204,192,64,192z"},"children":[{"name":"path","attribs":{"d":"M64,192v79.9c48,0,94.1,14.2,128,48.1c33.9,33.9,48,79.9,48,128h80C320,308.1,204,192,64,192z"},"children":[]}]},{"name":"path","attribs":{"d":"M64,64v79.9c171,0,303.9,133,303.9,304.1H448C448,236.3,276,64,64,64z"},"children":[{"name":"path","attribs":{"d":"M64,64v79.9c171,0,303.9,133,303.9,304.1H448C448,236.3,276,64,64,64z"},"children":[]}]}]}]};exports.socialRss=socialRss;var socialSass={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill":"#231F20","d":"M511.784,329.108c-1.67-13.599-9.236-24.146-20.795-32.416c2.857,2.04,5.275,3.766-0.055-0.041\r\n\tc-7.189-5.131-3.38-2.411-0.047-0.032c-28.5-20.301-65.676-15.789-96.733-4.511c-12.447-20.295-12.987-35.783-5.816-57.937\r\n\tc0.929-2.8,0.295-4.354-2.624-5.604c-7.086-3.03-17.291-1.427-24.422,0.463c-2.462,0.646-4.254,1.9-4.8,4.381\r\n\tc-5.154,24.243-21.009,46.448-34.828,66.886c-9.731-18.652-8.96-33.087-2.414-52.516c0.798-2.366,0.431-3.624-1.937-4.879\r\n\tc-7.26-3.757-18.401-1.912-25.8,0.276c-8.509,2.482-21.29,44.594-25.372,52.946c-8.531,17.442-16.091,44.665-30.585,58.502\r\n\tc-12.3-15.807,22.526-51.517,10.882-65.851c-3.938-4.848-11.063-4.723-15.586-0.616c1.085-7.608,1.648-12.609-0.32-19.063\r\n\tc-2.081-6.79-7.361-10.687-15.09-10.49c-17.995,0.527-33.843,13.815-44.641,26.397c-10.277,12.105-37.381,19.627-51.953,26.927\r\n\tc-25.032-21.807-79.221-44.947-80.632-82.081c-1.528-41.846,48.319-70.245,81.597-87.228\r\n\tc43.28-22.104,109.961-49.608,159.138-25.436c13.049,6.414,18.299,20.171,14.707,33.348c-9.368,34.366-47.198,57.293-80.103,67.807\r\n\tc-16.189,5.175-33.969,9.027-51.1,8.026c-22.955-1.343-40.83-15.224-43.281-16.086c-2.049-0.389-1.888,2.261-1.347,3.664\r\n\tc23.816,62.433,144.417,16.681,175.956-15.371c15.189-15.421,24.413-30.365,28.351-53.894c4.616-27.583-15.634-44.842-31.004-51.957\r\n\tC213.212,56.65,105.494,103.89,46.577,152.049c-25.568,20.901-57.552,54.11-42.874,88.946c15.93,37.805,64.736,57.19,96.503,80.312\r\n\tC74.502,334.08,42.344,347.29,25.688,371.24c-9.524,13.729-12.903,28.359-5.811,43.966c12.572,27.568,58.285,15.622,77.573,3.471\r\n\tc17.67-11.13,29.563-26.07,34.7-45.228c4.455-16.609,3.541-33.866-3.856-49.512l28.585-14.458\r\n\tc-7.697,23.076-11.097,52.003,4.881,72.855c6.402,8.338,23.017,8.675,29.817,0.311c8.816-10.943,14.664-24.655,20.503-37.206\r\n\tc-0.682,9.373-1.856,19.996,1.377,28.165c3.71,9.373,12.126,11.291,20.792,5.343c26.52-18.203,43.398-68.652,56.463-98.062\r\n\tc3.552,12.829,7.473,24.548,13.957,36.376c1.602,2.903,1.407,4.774-0.796,7.195c-9.685,10.675-32.826,28.479-35.069,42.899\r\n\tc-0.524,3.371,1.713,6.599,5.686,7.37c15.573,3.108,32.838-2.531,45.482-11.078c13.188-8.922,17.446-21.087,14.245-35.515\r\n\tc-4.576-20.771,10.993-43.98,25.801-61.03c2.719,12.908,6.816,25.331,14.143,36.606c-13.075,11.483-32.58,27.764-29.779,46.939\r\n\tc0.988,6.865,7.135,11.301,14.514,9.736c15.783-3.324,29.416-10.113,39.37-22.146c9.023-10.855,5.792-22.701,1.856-34.635\r\n\tc23.872-6.815,48.022-8.177,71.831-0.027c11.495,3.91,20.755,10.5,26.248,20.818c6.726,12.644,2.939,24.292-10.05,32.604\r\n\tc-3.287,2.104-5.562,3.833-4.45,4.743c1.112,0.911,4.9,2.113,13.284-3.152c8.384-5.267,13.51-12.383,14.823-21.725\r\n\tC512.071,334.28,512.063,331.696,511.784,329.108z M112.946,354.367c-1.358,16.673-9.636,30.193-23.175,41.114\r\n\tc-7.617,6.158-17.102,11.176-26.52,12.092c-9.418,0.917-16.751-1.461-17.378-11.23c-1.764-27.493,40.923-54.424,64.625-62.533\r\n\tc2.02,6.86,3.011,13.666,2.432,20.587L112.946,354.367z M216.048,281.914c-3.903,22.309-14.83,62.347-32.314,78.336\r\n\tc-2.356,2.143-4.61,2.018-5.809-0.771c-10.345-24.059,3.671-73.669,33.082-81.328C214.464,277.262,216.609,278.733,216.048,281.914z\r\n\t M286.359,363.682c8.422-8.962,16.834-17.916,25.269-26.927C312.671,346.776,294.057,366.719,286.359,363.682z M367.073,345.986\r\n\tc-2.348,1.273-7.621,2.515-7.827,0.835c-1.482-12.085,11.816-24.874,20.067-30.867C383.766,327.297,378.495,339.788,367.073,345.986\r\n\tz"},"children":[]}]};exports.socialSass=socialSass;var socialSkypeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M170.2,96c14,0,27.7,3.9,39.6,11.3l10.3,6.4l12-2c8.5-1.5,17.2-2.2,25.9-2.2c40.5,0,78.5,15.5,107,43.7\r\n\t\tc28.4,28,44.1,65.3,44.1,104.9c0,10.7-1.2,21.4-3.5,31.8l-2.5,11.1l5.1,10.2c5.1,10.1,7.7,20.9,7.7,32.2\r\n\t\tc0,40.1-33.3,72.7-74.2,72.7c-12.5,0-24.3-2.9-35.2-8.7l-9.8-5.2l-10.9,2c-9.1,1.7-18.5,2.5-27.8,2.5c-40.5,0-78.5-15.5-107-43.7\r\n\t\tc-28.4-28-44.1-65.3-44.1-104.9c0-10,1-20.1,3-29.9l2.5-12.2l-6.4-10.7C99.5,194.2,96,181.6,96,168.7C96,128.6,129.3,96,170.2,96\r\n\t\t M170.2,64C111.6,64,64,110.9,64,168.7c0,19.4,5.3,37.5,14.6,53c-2.4,11.7-3.7,23.9-3.7,36.3c0,99.8,82,180.6,183.1,180.6\r\n\t\tc11.5,0,22.7-1,33.5-3c15,7.9,32.1,12.4,50.2,12.4c58.7,0,106.2-46.9,106.2-104.7c0-16.7-4-32.5-11.1-46.5\r\n\t\tc2.8-12.5,4.2-25.4,4.2-38.7c0-99.7-82-180.6-183.2-180.6c-10.7,0-21.1,0.9-31.3,2.6C210.3,69.9,191,64,170.2,64L170.2,64z"},"children":[{"name":"path","attribs":{"d":"M170.2,96c14,0,27.7,3.9,39.6,11.3l10.3,6.4l12-2c8.5-1.5,17.2-2.2,25.9-2.2c40.5,0,78.5,15.5,107,43.7\r\n\t\tc28.4,28,44.1,65.3,44.1,104.9c0,10.7-1.2,21.4-3.5,31.8l-2.5,11.1l5.1,10.2c5.1,10.1,7.7,20.9,7.7,32.2\r\n\t\tc0,40.1-33.3,72.7-74.2,72.7c-12.5,0-24.3-2.9-35.2-8.7l-9.8-5.2l-10.9,2c-9.1,1.7-18.5,2.5-27.8,2.5c-40.5,0-78.5-15.5-107-43.7\r\n\t\tc-28.4-28-44.1-65.3-44.1-104.9c0-10,1-20.1,3-29.9l2.5-12.2l-6.4-10.7C99.5,194.2,96,181.6,96,168.7C96,128.6,129.3,96,170.2,96\r\n\t\t M170.2,64C111.6,64,64,110.9,64,168.7c0,19.4,5.3,37.5,14.6,53c-2.4,11.7-3.7,23.9-3.7,36.3c0,99.8,82,180.6,183.1,180.6\r\n\t\tc11.5,0,22.7-1,33.5-3c15,7.9,32.1,12.4,50.2,12.4c58.7,0,106.2-46.9,106.2-104.7c0-16.7-4-32.5-11.1-46.5\r\n\t\tc2.8-12.5,4.2-25.4,4.2-38.7c0-99.7-82-180.6-183.2-180.6c-10.7,0-21.1,0.9-31.3,2.6C210.3,69.9,191,64,170.2,64L170.2,64z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.9,344.1c-8.5,11.8-21,21.2-37.2,27.8c-16.1,6.6-35.3,9.9-57.3,9.9c-26.3,0-48.3-4.6-65.6-13.6\r\n\t\tc-12.3-6.6-22.4-15.4-30.2-26.4c-7.8-11-11.7-22-11.7-32.6c0-6.6,2.6-12.3,7.6-17.1c5-4.6,11.5-7,19.1-7c6.3,0,11.7,1.8,16.1,5.5\r\n\t\tc4.2,3.5,7.8,8.7,10.7,15.5c3.3,7.3,6.8,13.5,10.6,18.4c3.6,4.7,8.7,8.6,15.3,11.7c6.7,3.1,15.6,4.7,26.6,4.7\r\n\t\tc15.1,0,27.5-3.2,36.8-9.5c9.2-6.1,13.6-13.5,13.6-22.5c0-7.1-2.3-12.7-7.1-17.1c-5-4.6-11.5-8.2-19.6-10.6\r\n\t\tc-8.3-2.6-19.6-5.3-33.6-8.2c-19-4-35.1-8.8-48-14.2c-13.1-5.5-23.7-13.2-31.5-22.7C159,226.5,155,214.3,155,200\r\n\t\tc0-13.7,4.2-25.9,12.4-36.5c8.2-10.5,20.1-18.7,35.6-24.3c15.2-5.6,33.3-8.4,53.7-8.4c16.4,0,30.7,1.9,42.7,5.5\r\n\t\tc12.1,3.7,22.2,8.7,30.3,14.9c8,6.2,14,12.8,17.8,19.7c3.8,7,5.7,13.9,5.7,20.6c0,6.4-2.5,12.3-7.5,17.4c-5,5.1-11.3,7.8-18.8,7.8\r\n\t\tc-6.8,0-12.1-1.6-15.8-4.8c-3.4-3-7-7.6-10.9-14.3c-4.6-8.5-10.1-15.3-16.4-20.1c-6.2-4.6-16.4-7-30.6-7c-13.1,0-23.8,2.6-31.7,7.7\r\n\t\tc-7.6,4.9-11.3,10.6-11.3,17.3c0,4.1,1.2,7.5,3.7,10.5c2.6,3.1,6.2,5.9,10.9,8.2c4.8,2.4,9.8,4.3,14.7,5.6\r\n\t\tc5.1,1.4,13.6,3.5,25.3,6.1c14.9,3.1,28.5,6.7,40.5,10.4c12.2,3.9,22.7,8.6,31.3,14.1c8.8,5.6,15.7,12.9,20.7,21.5\r\n\t\tc4.9,8.6,7.4,19.4,7.4,31.8C364.7,318.7,360.4,332.3,351.9,344.1z"},"children":[{"name":"path","attribs":{"d":"M351.9,344.1c-8.5,11.8-21,21.2-37.2,27.8c-16.1,6.6-35.3,9.9-57.3,9.9c-26.3,0-48.3-4.6-65.6-13.6\r\n\t\tc-12.3-6.6-22.4-15.4-30.2-26.4c-7.8-11-11.7-22-11.7-32.6c0-6.6,2.6-12.3,7.6-17.1c5-4.6,11.5-7,19.1-7c6.3,0,11.7,1.8,16.1,5.5\r\n\t\tc4.2,3.5,7.8,8.7,10.7,15.5c3.3,7.3,6.8,13.5,10.6,18.4c3.6,4.7,8.7,8.6,15.3,11.7c6.7,3.1,15.6,4.7,26.6,4.7\r\n\t\tc15.1,0,27.5-3.2,36.8-9.5c9.2-6.1,13.6-13.5,13.6-22.5c0-7.1-2.3-12.7-7.1-17.1c-5-4.6-11.5-8.2-19.6-10.6\r\n\t\tc-8.3-2.6-19.6-5.3-33.6-8.2c-19-4-35.1-8.8-48-14.2c-13.1-5.5-23.7-13.2-31.5-22.7C159,226.5,155,214.3,155,200\r\n\t\tc0-13.7,4.2-25.9,12.4-36.5c8.2-10.5,20.1-18.7,35.6-24.3c15.2-5.6,33.3-8.4,53.7-8.4c16.4,0,30.7,1.9,42.7,5.5\r\n\t\tc12.1,3.7,22.2,8.7,30.3,14.9c8,6.2,14,12.8,17.8,19.7c3.8,7,5.7,13.9,5.7,20.6c0,6.4-2.5,12.3-7.5,17.4c-5,5.1-11.3,7.8-18.8,7.8\r\n\t\tc-6.8,0-12.1-1.6-15.8-4.8c-3.4-3-7-7.6-10.9-14.3c-4.6-8.5-10.1-15.3-16.4-20.1c-6.2-4.6-16.4-7-30.6-7c-13.1,0-23.8,2.6-31.7,7.7\r\n\t\tc-7.6,4.9-11.3,10.6-11.3,17.3c0,4.1,1.2,7.5,3.7,10.5c2.6,3.1,6.2,5.9,10.9,8.2c4.8,2.4,9.8,4.3,14.7,5.6\r\n\t\tc5.1,1.4,13.6,3.5,25.3,6.1c14.9,3.1,28.5,6.7,40.5,10.4c12.2,3.9,22.7,8.6,31.3,14.1c8.8,5.6,15.7,12.9,20.7,21.5\r\n\t\tc4.9,8.6,7.4,19.4,7.4,31.8C364.7,318.7,360.4,332.3,351.9,344.1z"},"children":[]}]}]}]};exports.socialSkypeOutline=socialSkypeOutline;var socialSkype={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M436.9,296.8c2.8-12.5,4.2-25.4,4.2-38.7c0-99.7-82-180.6-183.2-180.6c-10.7,0-21.1,0.9-31.3,2.6\r\n\tC210.3,69.9,191,64,170.2,64C111.6,64,64,110.9,64,168.7c0,19.4,5.3,37.5,14.6,53c-2.4,11.7-3.7,23.9-3.7,36.3\r\n\tc0,99.8,82,180.6,183.1,180.6c11.5,0,22.7-1,33.5-3c15,7.9,32.1,12.4,50.2,12.4c58.7,0,106.2-46.9,106.2-104.7\r\n\tC448,326.6,444,310.8,436.9,296.8z M351.9,344.3c-8.5,11.8-21,21.2-37.2,27.8c-16.1,6.6-35.3,9.9-57.3,9.9\r\n\tc-26.3,0-48.3-4.6-65.6-13.6c-12.3-6.6-22.4-15.4-30.2-26.4c-7.8-11-11.7-22-11.7-32.6c0-6.6,2.6-12.3,7.6-17.1c5-4.6,11.5-7,19.1-7\r\n\tc6.3,0,11.7,1.8,16.1,5.5c4.2,3.5,7.8,8.7,10.7,15.5c3.3,7.3,6.8,13.5,10.6,18.4c3.6,4.7,8.7,8.6,15.3,11.7\r\n\tc6.7,3.1,15.6,4.7,26.6,4.7c15.1,0,27.5-3.2,36.8-9.5c9.2-6.1,13.6-13.5,13.6-22.5c0-7.1-2.3-12.7-7.1-17.1\r\n\tc-5-4.6-11.5-8.2-19.6-10.6c-8.3-2.6-19.6-5.3-33.6-8.2c-19-4-35.1-8.8-48-14.2c-13.1-5.5-23.7-13.2-31.5-22.7\r\n\tc-7.9-9.7-11.8-21.9-11.8-36.2c0-13.7,4.2-25.9,12.4-36.5c8.2-10.5,20.1-18.7,35.6-24.3c15.2-5.6,33.3-8.4,53.7-8.4\r\n\tc16.4,0,30.7,1.9,42.7,5.5c12.1,3.7,22.2,8.7,30.3,14.9c8,6.2,14,12.8,17.8,19.7c3.8,7,5.7,13.9,5.7,20.6c0,6.4-2.5,12.3-7.5,17.4\r\n\tc-5,5.1-11.3,7.8-18.8,7.8c-6.8,0-12.1-1.6-15.8-4.8c-3.4-3-7-7.6-10.9-14.3c-4.6-8.5-10.1-15.3-16.4-20.1c-6.2-4.6-16.4-7-30.6-7\r\n\tc-13.1,0-23.8,2.6-31.7,7.7c-7.6,4.9-11.3,10.6-11.3,17.3c0,4.1,1.2,7.5,3.7,10.5c2.6,3.1,6.2,5.9,10.9,8.2\r\n\tc4.8,2.4,9.8,4.3,14.7,5.6c5.1,1.4,13.6,3.5,25.3,6.1c14.9,3.1,28.5,6.7,40.5,10.4c12.2,3.9,22.7,8.6,31.3,14.1\r\n\tc8.8,5.6,15.7,12.9,20.7,21.5c4.9,8.6,7.4,19.4,7.4,31.8C364.8,318.9,360.5,332.5,351.9,344.3z"},"children":[]}]};exports.socialSkype=socialSkype;var socialSnapchatOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.283,47.553c70.693,0,128,54.682,118,128.931c-2.072,15.388-3.422,31.483-4.26,44.759c0,0,2.402,4.253,12.664,4.253\r\n\t\tc6.071,0,14.895-1.543,27.596-6.354c2.236-0.847,4.377-1.241,6.377-1.241c7.918,0,13.615,5.931,14.123,12.271\r\n\t\tc0.426,5.31-4.564,11.199-8.371,13.009c-13.766,6.542-46.991,10.063-46.991,32.638c0,22.576,22.362,46.656,40.862,63.713\r\n\t\tS480,360.602,480,360.602s0.283,21.57-31.717,29.097c-32,7.524-32.1,5.712-33.25,13.796c-2.133,14.979-1.535,21.378-11.248,21.378\r\n\t\tc-1.672,0-3.651-0.19-6.002-0.558c-8.23-1.291-19.239-3.644-31.121-3.644c-11.216,0-23.21,2.097-34.379,9.161\r\n\t\tc-23,14.549-41.283,34.114-76.283,34.114s-53-19.565-76-34.114c-11.17-7.065-23.162-9.161-34.379-9.161\r\n\t\tc-11.88,0-22.892,2.353-31.121,3.644c-2.352,0.367-4.33,0.558-6.002,0.558c-9.71,0-9.115-6.399-11.248-21.378\r\n\t\tc-1.151-8.084-1.25-6.27-33.25-13.795s-32-29.097-32-29.097s45.5-4.012,64-21.068c18.5-17.058,40.862-41.134,40.862-63.71\r\n\t\tc0-22.575-33.226-26.09-46.991-32.632c-3.807-1.81-8.796-7.687-8.371-12.997c0.507-6.336,6.196-12.251,14.107-12.25\r\n\t\tc2.004,0,4.152,0.38,6.393,1.229c12.749,4.829,21.588,6.342,27.662,6.342c10.204,0,12.598-4.273,12.598-4.273\r\n\t\tc-0.837-13.275-2.187-29.371-4.259-44.759c-10-74.249,47.307-128.931,118-128.931l0,0 M256.283,32H256\r\n\t\tc-41.093,0-79.215,16.208-104.591,45.341c-23.982,27.534-34.375,63.345-29.265,101.292c1.416,10.51,2.46,21.231,3.21,30.618\r\n\t\tc-3.97-0.559-9.686-1.998-17.703-5.034c-3.965-1.502-8.017-2.295-12.043-2.295c-15.641-0.001-28.844,11.852-30.057,27.003\r\n\t\tc-1.027,12.818,8.235,24.393,17.47,28.783c4.251,2.02,9.181,3.578,14.4,5.232c6.707,2.125,14.309,4.532,19.293,7.703\r\n\t\tc4.147,2.639,4.147,4.168,4.147,5.182c0,8.66-6.191,24.691-35.688,51.888c-10.499,9.681-39.055,15.501-54.588,16.897l-14.572,1.311\r\n\t\tL16,360.603c0,1.679,0.312,10.546,6.485,20.319c5.246,8.306,16.073,19.283,37.863,24.407c6.179,1.453,11.186,2.563,15.208,3.454\r\n\t\tc2.306,0.512,4.555,1.01,6.454,1.453c0.027,0.209,0.054,0.417,0.081,0.623c0.9,7.004,1.611,12.535,4.392,17.75\r\n\t\tc2.453,4.6,8.574,12.316,22.015,12.316c2.478,0,5.249-0.246,8.472-0.751c1.672-0.263,3.386-0.554,5.2-0.863\r\n\t\tc7.116-1.212,15.182-2.587,23.451-2.587c10.277,0,18.732,2.188,25.846,6.688c4.531,2.867,8.892,5.972,13.509,9.26\r\n\t\tC202.967,465.481,223.358,480,256,480c32.726,0,53.293-14.582,71.439-27.446c4.576-3.244,8.898-6.309,13.377-9.142\r\n\t\tc7.113-4.5,15.568-6.688,25.846-6.688c8.27,0,16.334,1.375,23.449,2.586c1.814,0.311,3.529,0.602,5.202,0.864\r\n\t\tc3.223,0.505,5.993,0.751,8.472,0.751c13.44,0,19.562-7.715,22.015-12.313c2.781-5.214,3.492-10.746,4.392-17.749\r\n\t\tc0.027-0.208,0.055-0.418,0.082-0.629c1.898-0.441,4.148-0.941,6.455-1.452c4.023-0.892,9.029-2.001,15.206-3.454\r\n\t\tc21.851-5.139,32.611-16.17,37.79-24.518c6.098-9.828,6.296-18.736,6.273-20.422l-0.189-14.501l-14.398-1.278\r\n\t\tc-15.413-1.396-43.8-7.219-54.301-16.9c-16.281-15.011-35.688-36.199-35.688-51.893c0-1.014,0-2.546,4.15-5.186\r\n\t\tc4.985-3.174,12.589-5.584,19.297-7.71c5.217-1.654,10.144-3.217,14.394-5.236c9.236-4.39,18.498-15.978,17.471-28.807\r\n\t\tc-1.215-15.166-14.424-27.046-30.072-27.046c-4.021,0-8.068,0.76-12.027,2.259c-8.027,3.041-13.743,4.41-17.705,4.962\r\n\t\tc0.747-9.319,1.791-20.12,3.211-30.67c5.111-37.948-5.281-73.509-29.264-101.042C335.498,48.208,297.376,32,256.283,32L256.283,32z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M256.283,47.553c70.693,0,128,54.682,118,128.931c-2.072,15.388-3.422,31.483-4.26,44.759c0,0,2.402,4.253,12.664,4.253\r\n\t\tc6.071,0,14.895-1.543,27.596-6.354c2.236-0.847,4.377-1.241,6.377-1.241c7.918,0,13.615,5.931,14.123,12.271\r\n\t\tc0.426,5.31-4.564,11.199-8.371,13.009c-13.766,6.542-46.991,10.063-46.991,32.638c0,22.576,22.362,46.656,40.862,63.713\r\n\t\tS480,360.602,480,360.602s0.283,21.57-31.717,29.097c-32,7.524-32.1,5.712-33.25,13.796c-2.133,14.979-1.535,21.378-11.248,21.378\r\n\t\tc-1.672,0-3.651-0.19-6.002-0.558c-8.23-1.291-19.239-3.644-31.121-3.644c-11.216,0-23.21,2.097-34.379,9.161\r\n\t\tc-23,14.549-41.283,34.114-76.283,34.114s-53-19.565-76-34.114c-11.17-7.065-23.162-9.161-34.379-9.161\r\n\t\tc-11.88,0-22.892,2.353-31.121,3.644c-2.352,0.367-4.33,0.558-6.002,0.558c-9.71,0-9.115-6.399-11.248-21.378\r\n\t\tc-1.151-8.084-1.25-6.27-33.25-13.795s-32-29.097-32-29.097s45.5-4.012,64-21.068c18.5-17.058,40.862-41.134,40.862-63.71\r\n\t\tc0-22.575-33.226-26.09-46.991-32.632c-3.807-1.81-8.796-7.687-8.371-12.997c0.507-6.336,6.196-12.251,14.107-12.25\r\n\t\tc2.004,0,4.152,0.38,6.393,1.229c12.749,4.829,21.588,6.342,27.662,6.342c10.204,0,12.598-4.273,12.598-4.273\r\n\t\tc-0.837-13.275-2.187-29.371-4.259-44.759c-10-74.249,47.307-128.931,118-128.931l0,0 M256.283,32H256\r\n\t\tc-41.093,0-79.215,16.208-104.591,45.341c-23.982,27.534-34.375,63.345-29.265,101.292c1.416,10.51,2.46,21.231,3.21,30.618\r\n\t\tc-3.97-0.559-9.686-1.998-17.703-5.034c-3.965-1.502-8.017-2.295-12.043-2.295c-15.641-0.001-28.844,11.852-30.057,27.003\r\n\t\tc-1.027,12.818,8.235,24.393,17.47,28.783c4.251,2.02,9.181,3.578,14.4,5.232c6.707,2.125,14.309,4.532,19.293,7.703\r\n\t\tc4.147,2.639,4.147,4.168,4.147,5.182c0,8.66-6.191,24.691-35.688,51.888c-10.499,9.681-39.055,15.501-54.588,16.897l-14.572,1.311\r\n\t\tL16,360.603c0,1.679,0.312,10.546,6.485,20.319c5.246,8.306,16.073,19.283,37.863,24.407c6.179,1.453,11.186,2.563,15.208,3.454\r\n\t\tc2.306,0.512,4.555,1.01,6.454,1.453c0.027,0.209,0.054,0.417,0.081,0.623c0.9,7.004,1.611,12.535,4.392,17.75\r\n\t\tc2.453,4.6,8.574,12.316,22.015,12.316c2.478,0,5.249-0.246,8.472-0.751c1.672-0.263,3.386-0.554,5.2-0.863\r\n\t\tc7.116-1.212,15.182-2.587,23.451-2.587c10.277,0,18.732,2.188,25.846,6.688c4.531,2.867,8.892,5.972,13.509,9.26\r\n\t\tC202.967,465.481,223.358,480,256,480c32.726,0,53.293-14.582,71.439-27.446c4.576-3.244,8.898-6.309,13.377-9.142\r\n\t\tc7.113-4.5,15.568-6.688,25.846-6.688c8.27,0,16.334,1.375,23.449,2.586c1.814,0.311,3.529,0.602,5.202,0.864\r\n\t\tc3.223,0.505,5.993,0.751,8.472,0.751c13.44,0,19.562-7.715,22.015-12.313c2.781-5.214,3.492-10.746,4.392-17.749\r\n\t\tc0.027-0.208,0.055-0.418,0.082-0.629c1.898-0.441,4.148-0.941,6.455-1.452c4.023-0.892,9.029-2.001,15.206-3.454\r\n\t\tc21.851-5.139,32.611-16.17,37.79-24.518c6.098-9.828,6.296-18.736,6.273-20.422l-0.189-14.501l-14.398-1.278\r\n\t\tc-15.413-1.396-43.8-7.219-54.301-16.9c-16.281-15.011-35.688-36.199-35.688-51.893c0-1.014,0-2.546,4.15-5.186\r\n\t\tc4.985-3.174,12.589-5.584,19.297-7.71c5.217-1.654,10.144-3.217,14.394-5.236c9.236-4.39,18.498-15.978,17.471-28.807\r\n\t\tc-1.215-15.166-14.424-27.046-30.072-27.046c-4.021,0-8.068,0.76-12.027,2.259c-8.027,3.041-13.743,4.41-17.705,4.962\r\n\t\tc0.747-9.319,1.791-20.12,3.211-30.67c5.111-37.948-5.281-73.509-29.264-101.042C335.498,48.208,297.376,32,256.283,32L256.283,32z\r\n\t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,229c-20.838,0-40.604-8.29-55.657-23.343c-3.125-3.124-3.124-8.189,0-11.313c3.125-3.124,8.19-3.124,11.313,0\r\n\t\tC223.688,206.374,239.436,213,256,213c16.387,0,32.15-6.64,44.385-18.698c3.148-3.102,8.213-3.063,11.312,0.082\r\n\t\tc3.102,3.147,3.064,8.212-0.082,11.313C296.368,220.725,276.617,229,256,229z"},"children":[{"name":"path","attribs":{"d":"M256,229c-20.838,0-40.604-8.29-55.657-23.343c-3.125-3.124-3.124-8.189,0-11.313c3.125-3.124,8.19-3.124,11.313,0\r\n\t\tC223.688,206.374,239.436,213,256,213c16.387,0,32.15-6.64,44.385-18.698c3.148-3.102,8.213-3.063,11.312,0.082\r\n\t\tc3.102,3.147,3.064,8.212-0.082,11.313C296.368,220.725,276.617,229,256,229z"},"children":[]}]},{"name":"ellipse","attribs":{"cx":"208","cy":"152","rx":"16","ry":"24"},"children":[{"name":"ellipse","attribs":{"cx":"208","cy":"152","rx":"16","ry":"24"},"children":[]}]},{"name":"ellipse","attribs":{"cx":"304","cy":"152","rx":"16","ry":"24"},"children":[{"name":"ellipse","attribs":{"cx":"304","cy":"152","rx":"16","ry":"24"},"children":[]}]}]}]};exports.socialSnapchatOutline=socialSnapchatOutline;var socialSnapchat={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M495.998,360.389l-0.189-14.501l-14.398-1.278c-15.413-1.396-43.8-7.219-54.301-16.9\r\n\t\tc-16.281-15.011-35.688-36.199-35.688-51.893c0-1.014,0-2.546,4.15-5.186c4.985-3.174,12.589-5.584,19.297-7.71\r\n\t\tc5.217-1.654,10.144-3.217,14.394-5.236c9.236-4.39,18.498-15.978,17.471-28.807c-1.215-15.166-14.424-27.046-30.072-27.046\r\n\t\tc-4.021,0-8.068,0.76-12.027,2.259c-8.027,3.041-13.743,4.41-17.705,4.962c0.747-9.319,1.791-20.12,3.211-30.67\r\n\t\tc5.111-37.948-5.281-73.509-29.264-101.042C335.498,48.208,297.376,32,256.283,32H256c-41.093,0-79.215,16.208-104.591,45.341\r\n\t\tc-23.982,27.534-34.375,63.345-29.265,101.292c1.416,10.51,2.46,21.231,3.21,30.618c-3.97-0.559-9.686-1.998-17.703-5.034\r\n\t\tc-3.965-1.502-8.017-2.295-12.043-2.295c-15.641-0.001-28.844,11.852-30.057,27.003c-1.027,12.818,8.235,24.393,17.47,28.783\r\n\t\tc4.251,2.02,9.181,3.578,14.4,5.232c6.707,2.125,14.309,4.532,19.293,7.703c4.147,2.639,4.147,4.168,4.147,5.182\r\n\t\tc0,8.66-6.191,24.691-35.688,51.888c-10.499,9.681-39.055,15.501-54.588,16.897l-14.572,1.311L16,360.603\r\n\t\tc0,1.679,0.312,10.546,6.485,20.319c5.246,8.306,16.073,19.283,37.863,24.407c6.179,1.453,11.186,2.563,15.208,3.454\r\n\t\tc2.306,0.512,4.555,1.01,6.454,1.453c0.027,0.209,0.054,0.417,0.081,0.623c0.9,7.004,1.611,12.535,4.392,17.75\r\n\t\tc2.453,4.6,8.574,12.316,22.015,12.316c2.478,0,5.249-0.246,8.472-0.751c1.672-0.263,3.386-0.554,5.2-0.863\r\n\t\tc7.116-1.212,15.182-2.587,23.451-2.587c10.277,0,18.732,2.188,25.846,6.688c4.531,2.867,8.892,5.972,13.509,9.26\r\n\t\tC202.967,465.481,223.358,480,256,480c32.726,0,53.293-14.582,71.439-27.446c4.576-3.244,8.898-6.309,13.377-9.142\r\n\t\tc7.113-4.5,15.568-6.688,25.846-6.688c8.27,0,16.334,1.375,23.449,2.586c1.814,0.311,3.529,0.602,5.202,0.864\r\n\t\tc3.223,0.505,5.993,0.751,8.472,0.751c13.44,0,19.562-7.715,22.015-12.313c2.781-5.214,3.492-10.746,4.392-17.749\r\n\t\tc0.027-0.208,0.055-0.418,0.082-0.629c1.898-0.441,4.148-0.941,6.455-1.452c4.023-0.892,9.029-2.001,15.206-3.454\r\n\t\tc21.851-5.139,32.611-16.17,37.79-24.518C495.822,370.982,496.021,362.074,495.998,360.389z M208,128c8.836,0,16,10.745,16,24\r\n\t\ts-7.164,24-16,24s-16-10.745-16-24S199.164,128,208,128z M311.615,205.698C296.368,220.725,276.617,229,256,229\r\n\t\tc-20.838,0-40.604-8.29-55.657-23.343c-3.125-3.124-3.124-8.189,0-11.313c3.125-3.124,8.19-3.124,11.313,0\r\n\t\tC223.688,206.374,239.436,213,256,213c16.387,0,32.15-6.64,44.385-18.698c3.148-3.102,8.213-3.063,11.312,0.082\r\n\t\tC314.799,197.531,314.762,202.597,311.615,205.698z M304,176c-8.836,0-16-10.746-16-24s7.164-24,16-24s16,10.746,16,24\r\n\t\tS312.836,176,304,176z"},"children":[{"name":"path","attribs":{"d":"M495.998,360.389l-0.189-14.501l-14.398-1.278c-15.413-1.396-43.8-7.219-54.301-16.9\r\n\t\tc-16.281-15.011-35.688-36.199-35.688-51.893c0-1.014,0-2.546,4.15-5.186c4.985-3.174,12.589-5.584,19.297-7.71\r\n\t\tc5.217-1.654,10.144-3.217,14.394-5.236c9.236-4.39,18.498-15.978,17.471-28.807c-1.215-15.166-14.424-27.046-30.072-27.046\r\n\t\tc-4.021,0-8.068,0.76-12.027,2.259c-8.027,3.041-13.743,4.41-17.705,4.962c0.747-9.319,1.791-20.12,3.211-30.67\r\n\t\tc5.111-37.948-5.281-73.509-29.264-101.042C335.498,48.208,297.376,32,256.283,32H256c-41.093,0-79.215,16.208-104.591,45.341\r\n\t\tc-23.982,27.534-34.375,63.345-29.265,101.292c1.416,10.51,2.46,21.231,3.21,30.618c-3.97-0.559-9.686-1.998-17.703-5.034\r\n\t\tc-3.965-1.502-8.017-2.295-12.043-2.295c-15.641-0.001-28.844,11.852-30.057,27.003c-1.027,12.818,8.235,24.393,17.47,28.783\r\n\t\tc4.251,2.02,9.181,3.578,14.4,5.232c6.707,2.125,14.309,4.532,19.293,7.703c4.147,2.639,4.147,4.168,4.147,5.182\r\n\t\tc0,8.66-6.191,24.691-35.688,51.888c-10.499,9.681-39.055,15.501-54.588,16.897l-14.572,1.311L16,360.603\r\n\t\tc0,1.679,0.312,10.546,6.485,20.319c5.246,8.306,16.073,19.283,37.863,24.407c6.179,1.453,11.186,2.563,15.208,3.454\r\n\t\tc2.306,0.512,4.555,1.01,6.454,1.453c0.027,0.209,0.054,0.417,0.081,0.623c0.9,7.004,1.611,12.535,4.392,17.75\r\n\t\tc2.453,4.6,8.574,12.316,22.015,12.316c2.478,0,5.249-0.246,8.472-0.751c1.672-0.263,3.386-0.554,5.2-0.863\r\n\t\tc7.116-1.212,15.182-2.587,23.451-2.587c10.277,0,18.732,2.188,25.846,6.688c4.531,2.867,8.892,5.972,13.509,9.26\r\n\t\tC202.967,465.481,223.358,480,256,480c32.726,0,53.293-14.582,71.439-27.446c4.576-3.244,8.898-6.309,13.377-9.142\r\n\t\tc7.113-4.5,15.568-6.688,25.846-6.688c8.27,0,16.334,1.375,23.449,2.586c1.814,0.311,3.529,0.602,5.202,0.864\r\n\t\tc3.223,0.505,5.993,0.751,8.472,0.751c13.44,0,19.562-7.715,22.015-12.313c2.781-5.214,3.492-10.746,4.392-17.749\r\n\t\tc0.027-0.208,0.055-0.418,0.082-0.629c1.898-0.441,4.148-0.941,6.455-1.452c4.023-0.892,9.029-2.001,15.206-3.454\r\n\t\tc21.851-5.139,32.611-16.17,37.79-24.518C495.822,370.982,496.021,362.074,495.998,360.389z M208,128c8.836,0,16,10.745,16,24\r\n\t\ts-7.164,24-16,24s-16-10.745-16-24S199.164,128,208,128z M311.615,205.698C296.368,220.725,276.617,229,256,229\r\n\t\tc-20.838,0-40.604-8.29-55.657-23.343c-3.125-3.124-3.124-8.189,0-11.313c3.125-3.124,8.19-3.124,11.313,0\r\n\t\tC223.688,206.374,239.436,213,256,213c16.387,0,32.15-6.64,44.385-18.698c3.148-3.102,8.213-3.063,11.312,0.082\r\n\t\tC314.799,197.531,314.762,202.597,311.615,205.698z M304,176c-8.836,0-16-10.746-16-24s7.164-24,16-24s16,10.746,16,24\r\n\t\tS312.836,176,304,176z"},"children":[]}]}]}]};exports.socialSnapchat=socialSnapchat;var socialTumblrOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M321.2,396.3c-11.8,0-22.4-2.8-31.5-8.3c-6.9-4.1-11.5-9.6-14-16.4c-2.6-6.9-3.6-22.3-3.6-46.4V224h96v-64h-96V48h-61.9\r\n\tc-2.7,21.5-7.5,44.7-14.5,58.6s-14,25.8-25.6,35.7c-11.6,9.9-25.6,17.9-41.9,23.3V224h48v140.4c0,19,2,33.5,5.9,43.5\r\n\tc4,10,11.1,19.5,21.4,28.4c10.3,8.9,22.8,15.7,37.3,20.5c14.6,4.8,31.4,7.2,50.4,7.2c16.7,0,30.3-1.7,44.7-5.1\r\n\tc14.4-3.4,30.5-9.3,48.2-17.6v-65.6C363.2,389.4,342.3,396.3,321.2,396.3z M368,431c-13.1,5.7-25.1,9.9-35.9,12.4\r\n\tc-13.1,3.1-25.6,4.6-41.1,4.6c-17.2,0-32.5-2.2-45.4-6.4c-12.5-4.1-23.2-10-31.9-17.5c-8.3-7.2-14-14.6-17-22.2\r\n\tc-2.2-5.5-4.8-16.6-4.8-37.6V208H144v-31.3c13.4-5.6,25.5-13,36.3-22.2c13.2-11.2,21.6-24.9,29.6-40.7c7.1-14,11.6-34,14.1-49.8h32\r\n\tv112h96v32h-96v117.1c0,34.6,2.4,46,4.6,52c3.8,10.3,10.8,18.6,21,24.6c11.7,7,25,10.5,39.7,10.5c15.7,0,31.3-3.3,46.7-9.8V431z"},"children":[]}]};exports.socialTumblrOutline=socialTumblrOutline;var socialTumblr={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M321.2,396.3c-11.8,0-22.4-2.8-31.5-8.3c-6.9-4.1-11.5-9.6-14-16.4c-2.6-6.9-3.6-22.3-3.6-46.4V224h96v-64h-96V48h-61.9\r\n\tc-2.7,21.5-7.5,44.7-14.5,58.6c-7,13.9-14,25.8-25.6,35.7c-11.6,9.9-25.6,17.9-41.9,23.3V224h48v140.4c0,19,2,33.5,5.9,43.5\r\n\tc4,10,11.1,19.5,21.4,28.4c10.3,8.9,22.8,15.7,37.3,20.5c14.6,4.8,31.4,7.2,50.4,7.2c16.7,0,30.3-1.7,44.7-5.1\r\n\tc14.4-3.4,30.5-9.3,48.2-17.6v-65.6C363.2,389.4,342.3,396.3,321.2,396.3z"},"children":[]}]};exports.socialTumblr=socialTumblr;var socialTux={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M254.7,101.3c-0.6,1-1.2,2-1.7,3.1c1.8-3.5,4.3-6.5,7.4-8.7C258.3,97,256.3,98.8,254.7,101.3\r\n\t\tC254.1,102.3,256.3,98.8,254.7,101.3z"},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M254.7,101.3c-0.6,1-1.2,2-1.7,3.1c1.8-3.5,4.3-6.5,7.4-8.7C258.3,97,256.3,98.8,254.7,101.3\r\n\t\tC254.1,102.3,256.3,98.8,254.7,101.3z"},"children":[]}]},{"name":"path","attribs":{"fill":"#010101","d":"M426.3,396c-6.7-4-13.2-11-12-18.8c2.3-15.3,2.5-21.5-0.2-25.8c-1.899-3.2-5.5-5-8.6-5.801\r\n\t\tc2-2.5,3.1-5.399,3.8-10.899c1.842-14.168-3.239-30.67-6.61-44.243c-4.445-17.9-10.319-34.014-20.432-49.522\r\n\t\tc-16.489-25.288-37.253-46.804-51.857-73.435c-9.7-29-4.301-47.1-4.801-66.2C324.7,64,298.7,32,261,32h-14c-37.5,0-58,26.9-58,60\r\n\t\tc0.697,16.666,1.352,33.333,2,50c0.769,19.756,1.98,37.667-8,55.3c-7.033,12.488-19.571,22.43-28.592,33.478\r\n\t\tc-9.525,11.665-13.06,23.669-17.859,37.619c-5.987,17.401-21.275,30.906-24.886,48.929c-1.658,8.271,2.726,17.857-0.83,24.693\r\n\t\tc-3.698,7.109-0.813,14.469-2.833,21.682c-3.505,11.729-20.731,10.729-30.215,11.508c-17.602,1.443-11.051,17.988-7.843,29.701\r\n\t\tc5.598,20.435-19.54,42.078,11.032,50.471c13.989,3.84,28.586,5.13,42.727,8.32c13.981,3.154,26.917,8.612,40.396,13.262\r\n\t\tc10.469,3.611,20.262,4.146,30.323-1.232c10.982-5.87,18.947-15.083,31.691-17c24.707-3.716,54.829-4.169,79.373,0.63\r\n\t\tc7.507,1.468,10.075,6.525,14.905,11.766c8.145,8.838,21.514,10.125,32.794,8.22c11.89-2.01,20.846-9.466,29.686-17.112\r\n\t\tc12.526-10.835,26.137-17.996,40.791-25.547c7.439-3.833,22.178-9.388,24.159-18.903C450.151,406.573,433.642,400.383,426.3,396z\r\n\t\t M202,451.3c-1.3,13-13.9,20.3-25.4,19.3c-19.502-1.649-37.86-12.237-57.164-15.75c-9.393-1.709-47.351-3.173-46.943-17.079\r\n\t\tc0.215-7.361,5.751-11.666,7.567-18.415c2.811-10.449-5.753-19.932-6.32-30.16c-0.447-8.081,10.73-7.607,16.288-8.053\r\n\t\tc8.761-0.702,19.157-2.012,23.572-11.043c1.6-3.3-0.5-15,1.9-21.8c3.527-10.155,15.489-8.949,23.3-4.899\r\n\t\tc17.762,9.067,28.943,35.546,38.533,51.821C187.058,411.728,204.045,430.843,202,451.3z M318.3,385.7\r\n\t\tc2.289,11.787,4.224,24.387,1.7,36.3c-2.016,9.516-8.562,15.614-12.7,24c-2.2-6.8,11.3-16.7,9.8-33.7\r\n\t\tc-0.042-0.475-0.947-10.882-1.036-10.834c-1.979,1.082-3.825,5.075-5.304,6.73c-4.809,5.383-10.771,9.658-16.729,13.677\r\n\t\tc-13.797,9.306-29.221,15.058-45.83,16.627c-21,2-38-10.5-38-10.5c2.517,8.305,8.992,21,1.1,28.3\r\n\t\tc1.743-15.648-4.876-28.06-11.6-41.7c46.374-24.639-41.363-64.397-53-79.8c-10.476-13.896-5.553-31.83-2.7-43.5\r\n\t\tc-3.443,13.775-3.959,41.956,14,46.8c7.922,2.169,5.605-37.071,5.984-41.463c1.58-18.312,7.721-35.997,18.343-51.015\r\n\t\tc3.399-4.806,1.863-9.533,2.673-15.322c1.693-10.668,7.295-20.547,13.488-29.225c5.169-7.243,1.735-12.618,3.014-21.055\r\n\t\tc0.727-4.795,5.118,3.193,5.798,4.279c4,6.5,16.7,22.7,24.7,22c13.277-1.161,24.692-15.938,36.015-22.046\r\n\t\tc3.591-1.937,14.41-5.242,15.866-9.632c1.768-5.33-12.666-0.161-14.114,0.583c-10.782,5.535-31.018,21.448-43.867,15.295\r\n\t\tc-8.762-4.195-10.691-14.994-17.2-20.5c15.4,13.6,21.5,10.5,27.6,9.1c9.665-2.182,18.797-6.486,27.8-10.5\r\n\t\tc4.217-1.88,20.107-4.041,22.301-8.7c2.745-5.834-5.05-6.726-8.068-3.58c-6.251,6.515-15.853,8.981-24.097,11.787\r\n\t\tc-18.885,6.427-37.644,9.131-51.835-8.607c-8.354-10.212,15.558-22.504,22.2-28.8c0,0,1-7.2-0.6-12.7c-1.9-6.5-7.8-9.3-11.9-8.1\r\n\t\tc-4.1,1.1-8,5.5-6.8,14.8c1,8.3,7,11,7,11s-2.7,3.5-5.2,4.7c0,0-0.8-0.3-3.5-6.3c-2.7-6-6.6-19.5-0.3-31.1\r\n\t\tc6.3-11.6,19.6-5.2,23.8,3.8c3.9,8.3,2.4,22.7,2.4,22.7c3.358-0.843,6.835-1.3,10.3-1.3c4.242,0,6.814,4.563,10.6,4.8\r\n\t\tc-0.635,0-0.564-18.124-0.233-20.078c1.099-6.49,4.112-13.619,9.933-17.222c16.087-11.491,34.6,3.916,34.6,21.2\r\n\t\tc0.024,4.486-0.137,9.215-1.199,13.6c-0.659,2.637-1.582,8.469-5.114,9.177c-1.145,0.23-10.683-0.431-7.985-3.277\r\n\t\tc12.807-12.812-1.822-38.207-17.4-24.5c-5.601,4.199-5.483,13.833-4.801,20c1.098,9.141,20.51,11.541,26.852,13.78\r\n\t\tc8.224,2.903,7.943,9.626,6.679,17.116c-1.9,11.26-2.815,18.792,4.381,28.214c7.344,9.616,12.929,20.086,15.915,31.878\r\n\t\tc1.483,5.859,1.665,10.843,5.621,15.57c5.983,7.151,10.619,14.805,13.291,23.817c5.225,17.621,6.513,35.422,6.162,53.625\r\n\t\tc-0.5,8.199-2.1,15,8.3,9.699c4-2,6.5-2.899,11-3.699c3.101-6.301,4.4-18.301,4.5-24.301c0.2-13.5-0.3-41.5-27.699-71.5\r\n\t\tc0,0,28.5,21.7,33,62c2.5,22.301-2,34.4-2,34.4c5.3,1.3,10.8,5.3,13.6,9.8c-0.133-0.22,1.038,1.748,1.179,1.864\r\n\t\tc-9.811-8.171-31.708-12.859-39.679,0.236c-2,3.3-3.1,7.6-3.2,11.699c-7.1-1.199-12.399,0-16.8,4.9\r\n\t\tC313.5,358.1,316.3,375.3,318.3,385.7C320.3,396,316.3,375.3,318.3,385.7z M220.6,124.9c-0.2-4.9-2.1-9-4.7-10.8\r\n\t\tc0.3-0.3,0.8-0.7,1.7-0.4c1.4,0.4,3.5,2.7,4.3,6.3c0.7,2.9,0.4,7.7-1.4,7.7C220.498,126.766,220.531,125.833,220.6,124.9\r\n\t\tC220.4,120,220.6,125.8,220.6,124.9z M275.3,112.9c0.4-0.3,1.101-0.6,2.3-0.3c1.801,0.4,4.4,2.8,5.301,6.2\r\n\t\tc0.699,2.8,0.1,7.4-2.2,7.3c-0.005-0.903,0.062-1.803,0.2-2.7C280.8,118.8,278.6,114.8,275.3,112.9\r\n\t\tC275.7,112.6,278.6,114.8,275.3,112.9z M412.4,432.9c-17.504,7.553-31.304,19.968-47.117,30.19\r\n\t\tc-13.824,8.937-38.156,8.313-40.022-12.879c-1.565-17.776,4.184-35.288,1.84-53.357c-1.587-12.239-8.534-28.906-2.301-40.854\r\n\t\tc2.7-5.1,8.101-5.5,12.5-4c3.193,13.267,13.932,23.6,28,23.6c17.031,0,23.542-14.008,34-24.5c3.4,0.2,7.4,1.101,8.8,4.801\r\n\t\tc2.301,5.8-1.899,17.5-1.8,22.3c0.3,15.7,9,19.2,26.4,29C448,416,436.9,422.3,412.4,432.9C388.3,443.3,436.9,422.3,412.4,432.9z"},"children":[{"name":"path","attribs":{"fill":"#010101","d":"M426.3,396c-6.7-4-13.2-11-12-18.8c2.3-15.3,2.5-21.5-0.2-25.8c-1.899-3.2-5.5-5-8.6-5.801\r\n\t\tc2-2.5,3.1-5.399,3.8-10.899c1.842-14.168-3.239-30.67-6.61-44.243c-4.445-17.9-10.319-34.014-20.432-49.522\r\n\t\tc-16.489-25.288-37.253-46.804-51.857-73.435c-9.7-29-4.301-47.1-4.801-66.2C324.7,64,298.7,32,261,32h-14c-37.5,0-58,26.9-58,60\r\n\t\tc0.697,16.666,1.352,33.333,2,50c0.769,19.756,1.98,37.667-8,55.3c-7.033,12.488-19.571,22.43-28.592,33.478\r\n\t\tc-9.525,11.665-13.06,23.669-17.859,37.619c-5.987,17.401-21.275,30.906-24.886,48.929c-1.658,8.271,2.726,17.857-0.83,24.693\r\n\t\tc-3.698,7.109-0.813,14.469-2.833,21.682c-3.505,11.729-20.731,10.729-30.215,11.508c-17.602,1.443-11.051,17.988-7.843,29.701\r\n\t\tc5.598,20.435-19.54,42.078,11.032,50.471c13.989,3.84,28.586,5.13,42.727,8.32c13.981,3.154,26.917,8.612,40.396,13.262\r\n\t\tc10.469,3.611,20.262,4.146,30.323-1.232c10.982-5.87,18.947-15.083,31.691-17c24.707-3.716,54.829-4.169,79.373,0.63\r\n\t\tc7.507,1.468,10.075,6.525,14.905,11.766c8.145,8.838,21.514,10.125,32.794,8.22c11.89-2.01,20.846-9.466,29.686-17.112\r\n\t\tc12.526-10.835,26.137-17.996,40.791-25.547c7.439-3.833,22.178-9.388,24.159-18.903C450.151,406.573,433.642,400.383,426.3,396z\r\n\t\t M202,451.3c-1.3,13-13.9,20.3-25.4,19.3c-19.502-1.649-37.86-12.237-57.164-15.75c-9.393-1.709-47.351-3.173-46.943-17.079\r\n\t\tc0.215-7.361,5.751-11.666,7.567-18.415c2.811-10.449-5.753-19.932-6.32-30.16c-0.447-8.081,10.73-7.607,16.288-8.053\r\n\t\tc8.761-0.702,19.157-2.012,23.572-11.043c1.6-3.3-0.5-15,1.9-21.8c3.527-10.155,15.489-8.949,23.3-4.899\r\n\t\tc17.762,9.067,28.943,35.546,38.533,51.821C187.058,411.728,204.045,430.843,202,451.3z M318.3,385.7\r\n\t\tc2.289,11.787,4.224,24.387,1.7,36.3c-2.016,9.516-8.562,15.614-12.7,24c-2.2-6.8,11.3-16.7,9.8-33.7\r\n\t\tc-0.042-0.475-0.947-10.882-1.036-10.834c-1.979,1.082-3.825,5.075-5.304,6.73c-4.809,5.383-10.771,9.658-16.729,13.677\r\n\t\tc-13.797,9.306-29.221,15.058-45.83,16.627c-21,2-38-10.5-38-10.5c2.517,8.305,8.992,21,1.1,28.3\r\n\t\tc1.743-15.648-4.876-28.06-11.6-41.7c46.374-24.639-41.363-64.397-53-79.8c-10.476-13.896-5.553-31.83-2.7-43.5\r\n\t\tc-3.443,13.775-3.959,41.956,14,46.8c7.922,2.169,5.605-37.071,5.984-41.463c1.58-18.312,7.721-35.997,18.343-51.015\r\n\t\tc3.399-4.806,1.863-9.533,2.673-15.322c1.693-10.668,7.295-20.547,13.488-29.225c5.169-7.243,1.735-12.618,3.014-21.055\r\n\t\tc0.727-4.795,5.118,3.193,5.798,4.279c4,6.5,16.7,22.7,24.7,22c13.277-1.161,24.692-15.938,36.015-22.046\r\n\t\tc3.591-1.937,14.41-5.242,15.866-9.632c1.768-5.33-12.666-0.161-14.114,0.583c-10.782,5.535-31.018,21.448-43.867,15.295\r\n\t\tc-8.762-4.195-10.691-14.994-17.2-20.5c15.4,13.6,21.5,10.5,27.6,9.1c9.665-2.182,18.797-6.486,27.8-10.5\r\n\t\tc4.217-1.88,20.107-4.041,22.301-8.7c2.745-5.834-5.05-6.726-8.068-3.58c-6.251,6.515-15.853,8.981-24.097,11.787\r\n\t\tc-18.885,6.427-37.644,9.131-51.835-8.607c-8.354-10.212,15.558-22.504,22.2-28.8c0,0,1-7.2-0.6-12.7c-1.9-6.5-7.8-9.3-11.9-8.1\r\n\t\tc-4.1,1.1-8,5.5-6.8,14.8c1,8.3,7,11,7,11s-2.7,3.5-5.2,4.7c0,0-0.8-0.3-3.5-6.3c-2.7-6-6.6-19.5-0.3-31.1\r\n\t\tc6.3-11.6,19.6-5.2,23.8,3.8c3.9,8.3,2.4,22.7,2.4,22.7c3.358-0.843,6.835-1.3,10.3-1.3c4.242,0,6.814,4.563,10.6,4.8\r\n\t\tc-0.635,0-0.564-18.124-0.233-20.078c1.099-6.49,4.112-13.619,9.933-17.222c16.087-11.491,34.6,3.916,34.6,21.2\r\n\t\tc0.024,4.486-0.137,9.215-1.199,13.6c-0.659,2.637-1.582,8.469-5.114,9.177c-1.145,0.23-10.683-0.431-7.985-3.277\r\n\t\tc12.807-12.812-1.822-38.207-17.4-24.5c-5.601,4.199-5.483,13.833-4.801,20c1.098,9.141,20.51,11.541,26.852,13.78\r\n\t\tc8.224,2.903,7.943,9.626,6.679,17.116c-1.9,11.26-2.815,18.792,4.381,28.214c7.344,9.616,12.929,20.086,15.915,31.878\r\n\t\tc1.483,5.859,1.665,10.843,5.621,15.57c5.983,7.151,10.619,14.805,13.291,23.817c5.225,17.621,6.513,35.422,6.162,53.625\r\n\t\tc-0.5,8.199-2.1,15,8.3,9.699c4-2,6.5-2.899,11-3.699c3.101-6.301,4.4-18.301,4.5-24.301c0.2-13.5-0.3-41.5-27.699-71.5\r\n\t\tc0,0,28.5,21.7,33,62c2.5,22.301-2,34.4-2,34.4c5.3,1.3,10.8,5.3,13.6,9.8c-0.133-0.22,1.038,1.748,1.179,1.864\r\n\t\tc-9.811-8.171-31.708-12.859-39.679,0.236c-2,3.3-3.1,7.6-3.2,11.699c-7.1-1.199-12.399,0-16.8,4.9\r\n\t\tC313.5,358.1,316.3,375.3,318.3,385.7C320.3,396,316.3,375.3,318.3,385.7z M220.6,124.9c-0.2-4.9-2.1-9-4.7-10.8\r\n\t\tc0.3-0.3,0.8-0.7,1.7-0.4c1.4,0.4,3.5,2.7,4.3,6.3c0.7,2.9,0.4,7.7-1.4,7.7C220.498,126.766,220.531,125.833,220.6,124.9\r\n\t\tC220.4,120,220.6,125.8,220.6,124.9z M275.3,112.9c0.4-0.3,1.101-0.6,2.3-0.3c1.801,0.4,4.4,2.8,5.301,6.2\r\n\t\tc0.699,2.8,0.1,7.4-2.2,7.3c-0.005-0.903,0.062-1.803,0.2-2.7C280.8,118.8,278.6,114.8,275.3,112.9\r\n\t\tC275.7,112.6,278.6,114.8,275.3,112.9z M412.4,432.9c-17.504,7.553-31.304,19.968-47.117,30.19\r\n\t\tc-13.824,8.937-38.156,8.313-40.022-12.879c-1.565-17.776,4.184-35.288,1.84-53.357c-1.587-12.239-8.534-28.906-2.301-40.854\r\n\t\tc2.7-5.1,8.101-5.5,12.5-4c3.193,13.267,13.932,23.6,28,23.6c17.031,0,23.542-14.008,34-24.5c3.4,0.2,7.4,1.101,8.8,4.801\r\n\t\tc2.301,5.8-1.899,17.5-1.8,22.3c0.3,15.7,9,19.2,26.4,29C448,416,436.9,422.3,412.4,432.9C388.3,443.3,436.9,422.3,412.4,432.9z"},"children":[]}]}]}]};exports.socialTux=socialTux;var socialTwitchOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M80,32l-32,80v304h96v64h64l64-64h80l112-112V32H80z M416,288l-64,64h-96.001L192,416v-64h-80V80h304V288z"},"children":[{"name":"path","attribs":{"d":"M80,32l-32,80v304h96v64h64l64-64h80l112-112V32H80z M416,288l-64,64h-96.001L192,416v-64h-80V80h304V288z"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"320","y":"143","width":"48","height":"129"},"children":[{"name":"rect","attribs":{"x":"320","y":"143","width":"48","height":"129"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"143","width":"48","height":"129"},"children":[{"name":"rect","attribs":{"x":"208","y":"143","width":"48","height":"129"},"children":[]}]}]}]};exports.socialTwitchOutline=socialTwitchOutline;var socialTwitch={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M80,32l-32,80v304h96v64h64l64-64h80l112-112V32H80z M256,272h-48V143h48V272z M368,272h-48V143h48V272z"},"children":[{"name":"path","attribs":{"d":"M80,32l-32,80v304h96v64h64l64-64h80l112-112V32H80z M256,272h-48V143h48V272z M368,272h-48V143h48V272z"},"children":[]}]}]}]};exports.socialTwitch=socialTwitch;var socialTwitterOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M492,109.5c-17.4,7.7-36,12.9-55.6,15.3c20-12,35.4-31,42.6-53.6c-18.7,11.1-39.4,19.2-61.5,23.5\r\n\tC399.8,75.8,374.5,64,346.8,64c-53.5,0-96.8,43.4-96.8,96.9c0,7.6,0.8,15,2.5,22.1C172,179,100.5,140.4,52.8,81.7\r\n\tc-8.3,14.3-13.1,31-13.1,48.7c0,33.6,17.1,63.3,43.1,80.7C67,210.7,52,206.3,39,199c0,0.4,0,0.8,0,1.2c0,47,33.4,86.1,77.7,95\r\n\tc-8.1,2.2-16.7,3.4-25.5,3.4c-6.2,0-12.3-0.6-18.2-1.8c12.3,38.5,48.1,66.5,90.5,67.3c-33.1,26-74.9,41.5-120.3,41.5\r\n\tc-7.8,0-15.5-0.5-23.1-1.4C62.8,432,113.7,448,168.3,448C346.5,448,444,300.3,444,172.2c0-4.2-0.1-8.4-0.3-12.5\r\n\tC462.5,146,479,129,492,109.5z M434.2,146.7l-7,5.1l0.4,8.6c0.2,3.8,0.3,7.8,0.3,11.8c0,30.2-5.9,61.8-17,91.5\r\n\tc-11.7,31.2-28.5,59.4-50,83.8c-23,26.1-50.2,46.5-81.1,60.8c-33.8,15.7-71.3,23.6-111.5,23.6c-28.9,0-57.4-4.8-84.5-14.2\r\n\tc9.9-1.9,19.6-4.6,29.1-7.9c21.7-7.6,41.9-18.7,60.1-33l35.3-27.7l-44.9-0.8c-26.1-0.5-49.7-13.4-64.3-33.9\r\n\tc7.3-0.5,14.5-1.8,21.5-3.7l60.7-20.2l-61.7-10.9c-29.6-5.9-52.8-27.9-61.3-55.8c7.8,2,15.4,2.8,23.9,3.3c0,0,31.8,1.4,55.8-0.1\r\n\tc-13-6.2-46.4-29.2-46.4-29.2c-22.5-15.1-36-40.2-36-67.4c0-6.4,0.8-12.8,2.2-19c21.9,22.4,47,41.1,75.1,55.5\r\n\tc37,19.1,76.9,29.8,118.6,31.9l21.2,1.1l-4.8-20.7c-1.4-5.9-2.1-12.1-2.1-18.5c0-44.4,36.3-80.7,80.9-80.7c22.3,0,43.8,9.3,59,25.6\r\n\tl6.1,6.5l8.7-1.7c4.5-0.9,8.9-1.9,13.3-3.1c-1,1.4-5.7,6.1-11,10.8c-4.5,4-17.8,16.5-17.8,16.5s13,4.1,21.1,5\r\n\tc8.1,0.9,17.4-0.6,18.9-0.8C442.2,141.1,437.2,144.6,434.2,146.7z"},"children":[]}]};exports.socialTwitterOutline=socialTwitterOutline;var socialTwitter={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M492,109.5c-17.4,7.7-36,12.9-55.6,15.3c20-12,35.4-31,42.6-53.6c-18.7,11.1-39.4,19.2-61.5,23.5\r\n\tC399.8,75.8,374.6,64,346.8,64c-53.5,0-96.8,43.4-96.8,96.9c0,7.6,0.8,15,2.5,22.1c-80.5-4-151.9-42.6-199.6-101.3\r\n\tc-8.3,14.3-13.1,31-13.1,48.7c0,33.6,17.2,63.3,43.2,80.7C67,210.7,52,206.3,39,199c0,0.4,0,0.8,0,1.2c0,47,33.4,86.1,77.7,95\r\n\tc-8.1,2.2-16.7,3.4-25.5,3.4c-6.2,0-12.3-0.6-18.2-1.8c12.3,38.5,48.1,66.5,90.5,67.3c-33.1,26-74.9,41.5-120.3,41.5\r\n\tc-7.8,0-15.5-0.5-23.1-1.4C62.8,432,113.7,448,168.3,448C346.6,448,444,300.3,444,172.2c0-4.2-0.1-8.4-0.3-12.5\r\n\tC462.6,146,479,129,492,109.5z"},"children":[]}]};exports.socialTwitter=socialTwitter;var socialUsdOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M220.746,102.625c-7.788,1.683-17.44,4.813-24.641,8.529c-9.018,4.649-16.411,10.965-22.604,19.295\r\n\t\tc-6.706,9.002-10.105,19.989-10.105,32.657c0,17.916,6.197,32.288,18.405,42.702c9.334,7.983,21.504,14.431,36.687,19.165\r\n\t\tL240,230.667V100.244C240,100.244,231.766,100.244,220.746,102.625z M224,209.699c-12-3.743-23.912-9.088-32.051-16.048\r\n\t\tc-8.621-7.355-12.673-17.534-12.673-30.545c0-9.241,2.414-16.94,7.004-23.102c4.58-6.161,9.912-11.038,16.88-14.631\r\n\t\tc6.18-3.189,13.84-5.565,20.84-7.138V209.699z"},"children":[{"name":"path","attribs":{"d":"M220.746,102.625c-7.788,1.683-17.44,4.813-24.641,8.529c-9.018,4.649-16.411,10.965-22.604,19.295\r\n\t\tc-6.706,9.002-10.105,19.989-10.105,32.657c0,17.916,6.197,32.288,18.405,42.702c9.334,7.983,21.504,14.431,36.687,19.165\r\n\t\tL240,230.667V100.244C240,100.244,231.766,100.244,220.746,102.625z M224,209.699c-12-3.743-23.912-9.088-32.051-16.048\r\n\t\tc-8.621-7.355-12.673-17.534-12.673-30.545c0-9.241,2.414-16.94,7.004-23.102c4.58-6.161,9.912-11.038,16.88-14.631\r\n\t\tc6.18-3.189,13.84-5.565,20.84-7.138V209.699z"},"children":[]}]},{"name":"path","attribs":{"d":"M348.217,296.725c-8.432-8.289-18.002-14.296-28.414-17.84c-8.949-3.075-17.441-5.848-27.465-8.477L272,265.145v145.188\r\n\t\tc0,0,12.051-0.642,18.371-1.476s10.703-1.971,16.67-3.798c12.727-3.89,23.309-9.02,31.32-15.25\r\n\t\tc8.678-6.747,15.145-14.785,19.164-23.907c3.775-8.595,5.706-17.581,5.706-26.711C363.231,320.822,358.188,306.536,348.217,296.725\r\n\t\tz M342.902,359.471c-2.939,6.673-7.699,12.576-14.303,17.711c-6.602,5.133-15.744,9.328-26.377,12.577\r\n\t\tc-4.5,1.378-8.223,2.444-14.223,3.236v-107.11c10,2.624,18.18,5.332,26.326,8.131c8.062,2.744,15.748,7.443,22.537,14.116\r\n\t\tc6.785,6.676,10.309,17.03,10.309,31.06C347.172,346.042,345.834,352.797,342.902,359.471z"},"children":[{"name":"path","attribs":{"d":"M348.217,296.725c-8.432-8.289-18.002-14.296-28.414-17.84c-8.949-3.075-17.441-5.848-27.465-8.477L272,265.145v145.188\r\n\t\tc0,0,12.051-0.642,18.371-1.476s10.703-1.971,16.67-3.798c12.727-3.89,23.309-9.02,31.32-15.25\r\n\t\tc8.678-6.747,15.145-14.785,19.164-23.907c3.775-8.595,5.706-17.581,5.706-26.711C363.231,320.822,358.188,306.536,348.217,296.725\r\n\t\tz M342.902,359.471c-2.939,6.673-7.699,12.576-14.303,17.711c-6.602,5.133-15.744,9.328-26.377,12.577\r\n\t\tc-4.5,1.378-8.223,2.444-14.223,3.236v-107.11c10,2.624,18.18,5.332,26.326,8.131c8.062,2.744,15.748,7.443,22.537,14.116\r\n\t\tc6.785,6.676,10.309,17.03,10.309,31.06C347.172,346.042,345.834,352.797,342.902,359.471z"},"children":[]}]},{"name":"path","attribs":{"d":"M411.387,303.256c-3.119-9.577-7.891-18.561-14.301-26.952c-6.422-8.382-14.396-15.826-23.93-22.331\r\n\t\tc-9.539-6.498-20.721-11.63-33.553-15.4c-5.143-1.363-14.189-3.506-26.104-6.418c-8.516-2.074-16.5-4.2-25.5-6.367V120.065\r\n\t\tc9,2.396,15.252,6.202,21.926,10.43c14.279,9.04,23.232,24.505,25.855,45.505h69.174c-0.654-18-4.65-32.76-11.996-46.02\r\n\t\tc-8.07-14.543-18.977-27.024-32.73-36.956c-13.75-9.922-30.225-17.49-48.377-22.455C303.967,68.416,297,66.605,288,65.386V32h-64\r\n\t\tv33.167c-7,1.044-15.148,2.445-22.426,4.25c-17.242,4.283-32.388,10.868-45.951,19.764c-13.571,8.905-24.352,20.112-32.604,33.627\r\n\t\tc-8.251,13.523-12.312,29.52-12.312,48c0,9.585,1.407,18.993,4.157,28.235c2.752,9.241,7.442,17.967,14.042,26.181\r\n\t\tc6.603,8.214,15.495,15.658,26.687,22.332c11.183,6.672,24.705,12.064,41.576,16.171c9.287,2.345,18.83,4.534,26.83,6.576v119.586\r\n\t\tc-11-2.919-21.889-7.399-30.678-13.479c-9.17-6.327-16.066-13.953-21.198-23.884c-4.779-9.229-7.073-20.526-7.407-32.526H96\r\n\t\tc0.695,21,5.25,39.494,13.672,55.371c8.799,16.604,20.533,29.96,35.204,40.562c14.662,10.613,31.393,18.356,51.198,23.491\r\n\t\tc8.885,2.304,18.926,3.96,27.926,5.23V480h64v-34.54c10-1.069,18.957-2.69,28.527-4.879c18.701-4.273,35.645-11.036,50.316-20.276\r\n\t\tc14.662-9.24,26.621-21.128,35.611-35.681c8.98-14.541,13.545-32.085,13.545-52.619C416,322.427,414.498,312.841,411.387,303.256z\r\n\t\t M388.904,376.218c-7.623,12.34-17.873,22.619-30.457,30.55c-13.035,8.21-28.248,14.339-45.219,18.217\r\n\t\tc-9.059,2.071-17.285,3.564-26.654,4.566L272,431.08V464h-32v-33.244l-13.508-1.943c-9.256-1.307-18.671-2.968-26.271-4.938\r\n\t\tc-17.865-4.633-32.876-11.51-46.031-21.032c-12.845-9.283-22.77-20.551-30.408-34.967c-5.004-9.437-8.418-20.876-10.268-31.876\r\n\t\th36.714c1.529,8,4.162,16.837,7.804,23.869c6.324,12.239,14.979,21.914,26.441,29.823c10.145,7.017,23.81,12.64,35.676,15.724\r\n\t\tS240,408.667,240,408.667V257.874l-11.786-3.074c-4.952-1.263-11.074-2.583-16.558-3.96c-3.395-0.854-6.814-1.729-10.37-2.626\r\n\t\tl-0.033-0.017l-0.051-0.017c-14.952-3.64-27.533-8.472-37.411-14.365c-9.487-5.657-17.021-11.92-22.399-18.611\r\n\t\tc-5.271-6.56-9.029-13.533-11.17-20.722c-2.307-7.755-3.476-15.721-3.476-23.675c0-15.66,3.274-28.636,10.002-39.665\r\n\t\tc7.097-11.622,16.187-20.973,27.786-28.585c12.201-8.003,25.666-13.764,41.155-17.611c6.334-1.571,12.865-2.901,19.926-3.954\r\n\t\tL240,78.958V48h32v31.363l13.127,1.877c7.371,0.999,14.236,2.404,22.637,4.699c16.389,4.482,30.91,11.189,43.023,19.929\r\n\t\tc11.691,8.443,21.182,19.333,28.133,31.862c3.805,6.865,6.504,14.27,8.137,22.27h-38.119c-5.078-19-15.352-33.637-30.172-43.021\r\n\t\tc-9.254-5.861-17.561-9.215-27.373-12.251C281.766,101.75,272,101.25,272,101.25v137.142l12.529,2.951\r\n\t\tc7.631,1.837,14.184,3.644,21.453,5.415l3.92,0.938l0.812,0.19c11.373,2.78,19.651,4.799,24.558,6.096\r\n\t\tc11.084,3.275,20.8,7.721,28.851,13.204c8.078,5.513,14.895,11.853,20.236,18.828c5.291,6.925,9.264,14.393,11.801,22.179\r\n\t\tc2.562,7.898,3.863,15.91,3.863,23.812C400.023,349.395,396.283,364.271,388.904,376.218z"},"children":[{"name":"path","attribs":{"d":"M411.387,303.256c-3.119-9.577-7.891-18.561-14.301-26.952c-6.422-8.382-14.396-15.826-23.93-22.331\r\n\t\tc-9.539-6.498-20.721-11.63-33.553-15.4c-5.143-1.363-14.189-3.506-26.104-6.418c-8.516-2.074-16.5-4.2-25.5-6.367V120.065\r\n\t\tc9,2.396,15.252,6.202,21.926,10.43c14.279,9.04,23.232,24.505,25.855,45.505h69.174c-0.654-18-4.65-32.76-11.996-46.02\r\n\t\tc-8.07-14.543-18.977-27.024-32.73-36.956c-13.75-9.922-30.225-17.49-48.377-22.455C303.967,68.416,297,66.605,288,65.386V32h-64\r\n\t\tv33.167c-7,1.044-15.148,2.445-22.426,4.25c-17.242,4.283-32.388,10.868-45.951,19.764c-13.571,8.905-24.352,20.112-32.604,33.627\r\n\t\tc-8.251,13.523-12.312,29.52-12.312,48c0,9.585,1.407,18.993,4.157,28.235c2.752,9.241,7.442,17.967,14.042,26.181\r\n\t\tc6.603,8.214,15.495,15.658,26.687,22.332c11.183,6.672,24.705,12.064,41.576,16.171c9.287,2.345,18.83,4.534,26.83,6.576v119.586\r\n\t\tc-11-2.919-21.889-7.399-30.678-13.479c-9.17-6.327-16.066-13.953-21.198-23.884c-4.779-9.229-7.073-20.526-7.407-32.526H96\r\n\t\tc0.695,21,5.25,39.494,13.672,55.371c8.799,16.604,20.533,29.96,35.204,40.562c14.662,10.613,31.393,18.356,51.198,23.491\r\n\t\tc8.885,2.304,18.926,3.96,27.926,5.23V480h64v-34.54c10-1.069,18.957-2.69,28.527-4.879c18.701-4.273,35.645-11.036,50.316-20.276\r\n\t\tc14.662-9.24,26.621-21.128,35.611-35.681c8.98-14.541,13.545-32.085,13.545-52.619C416,322.427,414.498,312.841,411.387,303.256z\r\n\t\t M388.904,376.218c-7.623,12.34-17.873,22.619-30.457,30.55c-13.035,8.21-28.248,14.339-45.219,18.217\r\n\t\tc-9.059,2.071-17.285,3.564-26.654,4.566L272,431.08V464h-32v-33.244l-13.508-1.943c-9.256-1.307-18.671-2.968-26.271-4.938\r\n\t\tc-17.865-4.633-32.876-11.51-46.031-21.032c-12.845-9.283-22.77-20.551-30.408-34.967c-5.004-9.437-8.418-20.876-10.268-31.876\r\n\t\th36.714c1.529,8,4.162,16.837,7.804,23.869c6.324,12.239,14.979,21.914,26.441,29.823c10.145,7.017,23.81,12.64,35.676,15.724\r\n\t\tS240,408.667,240,408.667V257.874l-11.786-3.074c-4.952-1.263-11.074-2.583-16.558-3.96c-3.395-0.854-6.814-1.729-10.37-2.626\r\n\t\tl-0.033-0.017l-0.051-0.017c-14.952-3.64-27.533-8.472-37.411-14.365c-9.487-5.657-17.021-11.92-22.399-18.611\r\n\t\tc-5.271-6.56-9.029-13.533-11.17-20.722c-2.307-7.755-3.476-15.721-3.476-23.675c0-15.66,3.274-28.636,10.002-39.665\r\n\t\tc7.097-11.622,16.187-20.973,27.786-28.585c12.201-8.003,25.666-13.764,41.155-17.611c6.334-1.571,12.865-2.901,19.926-3.954\r\n\t\tL240,78.958V48h32v31.363l13.127,1.877c7.371,0.999,14.236,2.404,22.637,4.699c16.389,4.482,30.91,11.189,43.023,19.929\r\n\t\tc11.691,8.443,21.182,19.333,28.133,31.862c3.805,6.865,6.504,14.27,8.137,22.27h-38.119c-5.078-19-15.352-33.637-30.172-43.021\r\n\t\tc-9.254-5.861-17.561-9.215-27.373-12.251C281.766,101.75,272,101.25,272,101.25v137.142l12.529,2.951\r\n\t\tc7.631,1.837,14.184,3.644,21.453,5.415l3.92,0.938l0.812,0.19c11.373,2.78,19.651,4.799,24.558,6.096\r\n\t\tc11.084,3.275,20.8,7.721,28.851,13.204c8.078,5.513,14.895,11.853,20.236,18.828c5.291,6.925,9.264,14.393,11.801,22.179\r\n\t\tc2.562,7.898,3.863,15.91,3.863,23.812C400.023,349.395,396.283,364.271,388.904,376.218z"},"children":[]}]}]}]};exports.socialUsdOutline=socialUsdOutline;var socialUsd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M411.387,303.256c-3.119-9.577-7.891-18.561-14.301-26.952c-6.422-8.382-14.396-15.826-23.93-22.331\r\n\t\tc-9.539-6.498-20.721-11.63-33.553-15.4c-5.143-1.363-14.189-3.506-26.104-6.418c-8.516-2.074-16.5-4.2-25.5-6.367V120.065\r\n\t\tc9,2.396,15.252,6.202,21.926,10.43c14.279,9.04,23.232,24.505,25.855,45.505h69.174c-0.654-18-4.65-32.76-11.996-46.02\r\n\t\tc-8.07-14.543-18.977-27.024-32.73-36.956c-13.75-9.922-30.225-17.49-48.377-22.455C303.967,68.416,297,66.605,288,65.386V32h-64\r\n\t\tv33.167c-7,1.044-15.148,2.445-22.426,4.25c-17.242,4.283-32.388,10.868-45.951,19.764c-13.571,8.905-24.352,20.112-32.604,33.627\r\n\t\tc-8.251,13.523-12.312,29.52-12.312,48c0,9.585,1.407,18.993,4.157,28.235c2.752,9.241,7.442,17.967,14.042,26.181\r\n\t\tc6.603,8.214,15.495,15.658,26.687,22.332c11.183,6.672,24.705,12.064,41.576,16.171c9.287,2.345,18.83,4.534,26.83,6.576v119.586\r\n\t\tc-11-2.919-21.889-7.399-30.678-13.479c-9.17-6.327-16.066-13.953-21.198-23.884c-4.779-9.229-7.073-20.526-7.407-32.526H96\r\n\t\tc0.695,21,5.25,39.494,13.672,55.371c8.799,16.604,20.533,29.96,35.204,40.562c14.662,10.613,31.393,18.356,51.198,23.491\r\n\t\tc8.885,2.304,18.926,3.96,27.926,5.23V480h64v-34.54c10-1.069,18.957-2.69,28.527-4.879c18.701-4.273,35.645-11.036,50.316-20.276\r\n\t\tc14.662-9.24,26.621-21.128,35.611-35.681c8.98-14.541,13.545-32.085,13.545-52.619C416,322.427,414.498,312.841,411.387,303.256z\r\n\t\t M224,209.699c-12-3.743-23.912-9.088-32.051-16.048c-8.621-7.355-12.673-17.534-12.673-30.545c0-9.241,2.414-16.94,7.004-23.102\r\n\t\tc4.58-6.161,9.912-11.038,16.88-14.631c6.18-3.189,13.84-5.565,20.84-7.138V209.699z M342.902,359.471\r\n\t\tc-2.939,6.673-7.699,12.576-14.303,17.711c-6.602,5.133-15.744,9.328-26.377,12.577c-4.5,1.378-8.223,2.444-14.223,3.236v-107.11\r\n\t\tc10,2.624,18.18,5.332,26.326,8.131c8.062,2.744,15.748,7.443,22.537,14.116c6.785,6.676,10.309,17.03,10.309,31.06\r\n\t\tC347.172,346.042,345.834,352.797,342.902,359.471z"},"children":[{"name":"path","attribs":{"d":"M411.387,303.256c-3.119-9.577-7.891-18.561-14.301-26.952c-6.422-8.382-14.396-15.826-23.93-22.331\r\n\t\tc-9.539-6.498-20.721-11.63-33.553-15.4c-5.143-1.363-14.189-3.506-26.104-6.418c-8.516-2.074-16.5-4.2-25.5-6.367V120.065\r\n\t\tc9,2.396,15.252,6.202,21.926,10.43c14.279,9.04,23.232,24.505,25.855,45.505h69.174c-0.654-18-4.65-32.76-11.996-46.02\r\n\t\tc-8.07-14.543-18.977-27.024-32.73-36.956c-13.75-9.922-30.225-17.49-48.377-22.455C303.967,68.416,297,66.605,288,65.386V32h-64\r\n\t\tv33.167c-7,1.044-15.148,2.445-22.426,4.25c-17.242,4.283-32.388,10.868-45.951,19.764c-13.571,8.905-24.352,20.112-32.604,33.627\r\n\t\tc-8.251,13.523-12.312,29.52-12.312,48c0,9.585,1.407,18.993,4.157,28.235c2.752,9.241,7.442,17.967,14.042,26.181\r\n\t\tc6.603,8.214,15.495,15.658,26.687,22.332c11.183,6.672,24.705,12.064,41.576,16.171c9.287,2.345,18.83,4.534,26.83,6.576v119.586\r\n\t\tc-11-2.919-21.889-7.399-30.678-13.479c-9.17-6.327-16.066-13.953-21.198-23.884c-4.779-9.229-7.073-20.526-7.407-32.526H96\r\n\t\tc0.695,21,5.25,39.494,13.672,55.371c8.799,16.604,20.533,29.96,35.204,40.562c14.662,10.613,31.393,18.356,51.198,23.491\r\n\t\tc8.885,2.304,18.926,3.96,27.926,5.23V480h64v-34.54c10-1.069,18.957-2.69,28.527-4.879c18.701-4.273,35.645-11.036,50.316-20.276\r\n\t\tc14.662-9.24,26.621-21.128,35.611-35.681c8.98-14.541,13.545-32.085,13.545-52.619C416,322.427,414.498,312.841,411.387,303.256z\r\n\t\t M224,209.699c-12-3.743-23.912-9.088-32.051-16.048c-8.621-7.355-12.673-17.534-12.673-30.545c0-9.241,2.414-16.94,7.004-23.102\r\n\t\tc4.58-6.161,9.912-11.038,16.88-14.631c6.18-3.189,13.84-5.565,20.84-7.138V209.699z M342.902,359.471\r\n\t\tc-2.939,6.673-7.699,12.576-14.303,17.711c-6.602,5.133-15.744,9.328-26.377,12.577c-4.5,1.378-8.223,2.444-14.223,3.236v-107.11\r\n\t\tc10,2.624,18.18,5.332,26.326,8.131c8.062,2.744,15.748,7.443,22.537,14.116c6.785,6.676,10.309,17.03,10.309,31.06\r\n\t\tC347.172,346.042,345.834,352.797,342.902,359.471z"},"children":[]}]}]}]};exports.socialUsd=socialUsd;var socialVimeoOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M476.9,114c-5-23.4-17.5-38.8-40.6-46.3c-7.4-2.4-16.7-3.7-26.9-3.7c-21.7,0-47.4,6-67.2,20.5\r\n\tc-29.9,21.8-47.6,59.7-53.8,83.8c12.2-5.3,20.8-7.1,31.9-7.1c2.2,0,4.6,0.1,7.1,0.2c15,0.8,24.5,12,24.9,25.3\r\n\tc0.3,9.8-0.2,18.7-3.6,27.7c-10.8,28.7-27.7,56.5-47.6,80.8c-2.9,3.6-6.4,6.9-10,9.9c-4.1,3.4-8,5-11.6,5c-5.2,0-9.9-3.5-13.8-10.2\r\n\tc-5.4-9.3-9-18.9-12.2-29.1c-12.4-39.7-16.8-80.9-23.8-121.6c-3.3-19.5-7-39.8-18-56.9c-10-15.4-24-22.6-41.5-22.6\r\n\tc-2.8,0-5.6,0.2-8.6,0.5c-14.7,1.8-36.9,17.5-47.8,26.4c0,0-56,46.9-81.8,71.4l21.2,27c0,0,17.9-12.5,27.5-18.3\r\n\tc2.9-1.8,6.1-2.8,9.2-2.8c2.9,0,5.7,0.9,8,3c4.5,3.9,9.6,9,12.3,14.1c5.7,10.7,11.2,21.9,14.7,33.4c13.2,44.3,25.5,88.7,37.8,133.3\r\n\tc6.3,22.8,13.9,44.2,28,63.6c13.2,18.2,26.9,26.8,44.3,26.8c8,0,16.8-1.8,26.6-5.4c25.4-9.1,46.6-26.2,66-43.9\r\n\tc33.1-30.2,59.1-65.4,85.5-101.2c20.4-27.7,37.3-55.7,51.4-87C478.5,179.8,484,147.3,476.9,114z M450,203.9\r\n\tc-13.3,29.4-29.1,56.2-49.7,84.1l-0.3,0.4c-26.4,35.7-51.3,69.5-83.1,98.5c-17.8,16.3-37.5,32.4-60.6,40.7c-8.3,3-15.2,4.4-21.2,4.4\r\n\tc-8.2,0-18.4-2.4-31.4-20.2c-13.4-18.4-20.2-39-25.5-58.4c-12.4-45.1-24.6-89.2-37.9-133.6c-3.9-13.2-10.2-25.8-15.9-36.4\r\n\tc-3.2-5.9-8.4-12-15.9-18.6c-5.2-4.5-11.6-6.9-18.6-6.9c-5.9,0-12,1.8-17.5,5.1c-4.5,2.7-10.5,6.7-15.9,10.3l-2.8-3.6\r\n\tc26.9-24.4,68.3-59.1,70.3-60.8C138.8,96.8,155.8,87,163.5,86c2.3-0.3,4.5-0.4,6.6-0.4c12.4,0,21.3,4.9,28.1,15.3\r\n\tc9.5,14.7,12.8,33.9,15.7,50.9c1.6,9.7,3.2,19.6,4.7,29.1c4.8,31.1,9.8,63.3,19.6,94.6c3,9.7,7,21.2,13.6,32.5\r\n\tc8.8,15,19.9,18.1,27.6,18.1c7.4,0,14.7-2.9,21.7-8.6c4.6-3.7,8.7-7.8,12.3-12.2c21.9-26.8,39.3-56.3,50.2-85.3\r\n\tc4.5-12,4.9-23.3,4.6-33.8c-0.6-22.4-17.4-39.6-40-40.9c-2.9-0.2-5.5-0.2-8-0.2c-2.2,0-4.3,0.1-6.3,0.2\r\n\tc8.8-18.1,21.7-36.3,37.7-47.9c15-10.9,36.6-17.5,57.8-17.5c8.3,0,16.1,1,21.9,2.9c17,5.5,26,15.8,29.9,34.4\r\n\tC467.2,145.1,463.4,174.2,450,203.9z"},"children":[]}]};exports.socialVimeoOutline=socialVimeoOutline;var socialVimeo={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"class":"st0","d":"M476.9,114c-5-23.4-17.5-38.8-40.6-46.3c-23.1-7.5-64.9-4.5-94.1,16.8c-29.9,21.8-47.6,59.7-53.8,83.8\r\n\tc14.7-6.3,24-7.7,39-6.9c15,0.8,24.5,12,24.9,25.3c0.3,9.8-0.2,18.7-3.6,27.7c-10.8,28.7-27.7,56.5-47.6,80.8\r\n\tc-2.9,3.6-6.4,6.9-10,9.9c-10.2,8.3-18.8,6.1-25.4-5.2c-5.4-9.3-9-18.9-12.2-29.1c-12.4-39.7-16.8-80.9-23.8-121.6\r\n\tc-3.3-19.5-7-39.8-18-56.9c-11.6-17.8-28.6-24.6-50-22c-14.7,1.8-36.9,17.5-47.8,26.4c0,0-56,46.9-81.8,71.4l21.2,27\r\n\tc0,0,17.9-12.5,27.5-18.3c5.7-3.4,12.4-4.1,17.2,0.2c4.5,3.9,9.6,9,12.3,14.1c5.7,10.7,11.2,21.9,14.7,33.4\r\n\tc13.2,44.3,25.5,88.7,37.8,133.3c6.3,22.8,13.9,44.2,28,63.6c19.3,26.6,39.6,32.7,70.9,21.5c25.4-9.1,46.6-26.2,66-43.9\r\n\tc33.1-30.2,59.1-65.4,85.5-101.2c20.4-27.7,37.3-55.7,51.4-87C478.5,179.8,484,147.3,476.9,114z"},"children":[]}]};exports.socialVimeo=socialVimeo;var socialWhatsappOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M209.877,154.114c-4.258-11.323-9.176-10.515-12.45-10.639\r\n\t\tc-3.277-0.121-6.146-0.061-10.573,0.011c-3.746,0.061-9.882,1.026-15.232,6.413c-5.357,5.378-20.366,18.312-21.404,45.725\r\n\t\tc-1.031,27.408,18.08,54.643,20.749,58.455c2.667,3.826,36.494,63.236,92.719,87.67c56.231,24.427,56.525,16.981,66.84,16.435\r\n\t\tc10.325-0.54,33.726-12.246,38.899-25.073c5.172-12.827,5.588-23.979,4.271-26.358c-1.316-2.371-5-3.911-10.51-6.9\r\n\t\tc-5.516-2.995-32.595-17.498-37.673-19.55c-5.081-2.044-8.787-3.108-12.742,2.329c-3.957,5.422-15.191,17.569-18.596,21.168\r\n\t\tc-3.42,3.6-6.711,3.934-12.226,0.93c-5.5-2.988-23.373-9.548-44.098-29.317c-16.126-15.38-26.711-34.043-29.779-39.736\r\n\t\tc-3.069-5.697-0.02-8.604,2.9-11.269c2.618-2.407,5.857-6.301,8.792-9.449c2.919-3.148,3.949-5.43,5.961-9.083\r\n\t\tc2.007-3.645,1.2-6.932-0.102-9.771C224.32,193.267,214.133,165.437,209.877,154.114z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M209.877,154.114c-4.258-11.323-9.176-10.515-12.45-10.639\r\n\t\tc-3.277-0.121-6.146-0.061-10.573,0.011c-3.746,0.061-9.882,1.026-15.232,6.413c-5.357,5.378-20.366,18.312-21.404,45.725\r\n\t\tc-1.031,27.408,18.08,54.643,20.749,58.455c2.667,3.826,36.494,63.236,92.719,87.67c56.231,24.427,56.525,16.981,66.84,16.435\r\n\t\tc10.325-0.54,33.726-12.246,38.899-25.073c5.172-12.827,5.588-23.979,4.271-26.358c-1.316-2.371-5-3.911-10.51-6.9\r\n\t\tc-5.516-2.995-32.595-17.498-37.673-19.55c-5.081-2.044-8.787-3.108-12.742,2.329c-3.957,5.422-15.191,17.569-18.596,21.168\r\n\t\tc-3.42,3.6-6.711,3.934-12.226,0.93c-5.5-2.988-23.373-9.548-44.098-29.317c-16.126-15.38-26.711-34.043-29.779-39.736\r\n\t\tc-3.069-5.697-0.02-8.604,2.9-11.269c2.618-2.407,5.857-6.301,8.792-9.449c2.919-3.148,3.949-5.43,5.961-9.083\r\n\t\tc2.007-3.645,1.2-6.932-0.102-9.771C224.32,193.267,214.133,165.437,209.877,154.114z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M260.062,64c50.249,0,97.478,19.402,132.982,54.632C428.482,153.796,448,200.533,448,250.232\r\n\t\t\tc0,49.694-19.518,96.43-54.956,131.596c-35.507,35.232-82.735,54.637-132.982,54.637c-31.806,0-63.24-8.023-90.906-23.201\r\n\t\t\tl-12.017-6.593l-13.063,4.149l-61.452,19.522l19.375-57.149l4.798-14.151l-7.771-12.763\r\n\t\t\tc-17.593-28.898-26.892-62.111-26.892-96.047c0-49.699,19.518-96.436,54.957-131.601C162.596,83.402,209.819,64,260.062,64\r\n\t\t\t M260.062,32C138.605,32,40.134,129.701,40.134,250.232c0,41.229,11.532,79.791,31.559,112.687L32,480l121.764-38.682\r\n\t\t\tc31.508,17.285,67.745,27.146,106.298,27.146C381.535,468.464,480,370.749,480,250.232C480,129.701,381.535,32,260.062,32\r\n\t\t\tL260.062,32z"},"children":[{"name":"path","attribs":{"d":"M260.062,64c50.249,0,97.478,19.402,132.982,54.632C428.482,153.796,448,200.533,448,250.232\r\n\t\t\tc0,49.694-19.518,96.43-54.956,131.596c-35.507,35.232-82.735,54.637-132.982,54.637c-31.806,0-63.24-8.023-90.906-23.201\r\n\t\t\tl-12.017-6.593l-13.063,4.149l-61.452,19.522l19.375-57.149l4.798-14.151l-7.771-12.763\r\n\t\t\tc-17.593-28.898-26.892-62.111-26.892-96.047c0-49.699,19.518-96.436,54.957-131.601C162.596,83.402,209.819,64,260.062,64\r\n\t\t\t M260.062,32C138.605,32,40.134,129.701,40.134,250.232c0,41.229,11.532,79.791,31.559,112.687L32,480l121.764-38.682\r\n\t\t\tc31.508,17.285,67.745,27.146,106.298,27.146C381.535,468.464,480,370.749,480,250.232C480,129.701,381.535,32,260.062,32\r\n\t\t\tL260.062,32z"},"children":[]}]}]}]}]}]};exports.socialWhatsappOutline=socialWhatsappOutline;var socialWhatsapp={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M260.062,32C138.605,32,40.134,129.701,40.134,250.232c0,41.23,11.532,79.79,31.559,112.687L32,480l121.764-38.682\r\n\t\tc31.508,17.285,67.745,27.146,106.298,27.146C381.535,468.464,480,370.749,480,250.232C480,129.701,381.535,32,260.062,32z\r\n\t\t M369.424,333.11c-5.174,12.827-28.574,24.533-38.899,25.072c-10.314,0.547-10.608,7.994-66.84-16.434\r\n\t\tc-56.225-24.434-90.052-83.844-92.719-87.67c-2.669-3.812-21.78-31.047-20.749-58.455c1.038-27.413,16.047-40.346,21.404-45.725\r\n\t\tc5.351-5.387,11.486-6.352,15.232-6.413c4.428-0.072,7.296-0.132,10.573-0.011c3.274,0.124,8.192-0.685,12.45,10.639\r\n\t\tc4.256,11.323,14.443,39.153,15.746,41.989c1.302,2.839,2.108,6.126,0.102,9.771c-2.012,3.653-3.042,5.935-5.961,9.083\r\n\t\tc-2.935,3.148-6.174,7.042-8.792,9.449c-2.92,2.665-5.97,5.572-2.9,11.269c3.068,5.693,13.653,24.356,29.779,39.736\r\n\t\tc20.725,19.771,38.598,26.329,44.098,29.317c5.515,3.004,8.806,2.67,12.226-0.929c3.404-3.599,14.639-15.746,18.596-21.169\r\n\t\tc3.955-5.438,7.661-4.373,12.742-2.329c5.078,2.052,32.157,16.556,37.673,19.551c5.51,2.989,9.193,4.529,10.51,6.9\r\n\t\tC375.012,309.131,374.596,320.282,369.424,333.11z"},"children":[{"name":"path","attribs":{"d":"M260.062,32C138.605,32,40.134,129.701,40.134,250.232c0,41.23,11.532,79.79,31.559,112.687L32,480l121.764-38.682\r\n\t\tc31.508,17.285,67.745,27.146,106.298,27.146C381.535,468.464,480,370.749,480,250.232C480,129.701,381.535,32,260.062,32z\r\n\t\t M369.424,333.11c-5.174,12.827-28.574,24.533-38.899,25.072c-10.314,0.547-10.608,7.994-66.84-16.434\r\n\t\tc-56.225-24.434-90.052-83.844-92.719-87.67c-2.669-3.812-21.78-31.047-20.749-58.455c1.038-27.413,16.047-40.346,21.404-45.725\r\n\t\tc5.351-5.387,11.486-6.352,15.232-6.413c4.428-0.072,7.296-0.132,10.573-0.011c3.274,0.124,8.192-0.685,12.45,10.639\r\n\t\tc4.256,11.323,14.443,39.153,15.746,41.989c1.302,2.839,2.108,6.126,0.102,9.771c-2.012,3.653-3.042,5.935-5.961,9.083\r\n\t\tc-2.935,3.148-6.174,7.042-8.792,9.449c-2.92,2.665-5.97,5.572-2.9,11.269c3.068,5.693,13.653,24.356,29.779,39.736\r\n\t\tc20.725,19.771,38.598,26.329,44.098,29.317c5.515,3.004,8.806,2.67,12.226-0.929c3.404-3.599,14.639-15.746,18.596-21.169\r\n\t\tc3.955-5.438,7.661-4.373,12.742-2.329c5.078,2.052,32.157,16.556,37.673,19.551c5.51,2.989,9.193,4.529,10.51,6.9\r\n\t\tC375.012,309.131,374.596,320.282,369.424,333.11z"},"children":[]}]}]}]};exports.socialWhatsapp=socialWhatsapp;var socialWindowsOutline={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M464,281v180.5l-216-31.3V281H464 M480,265H232v179l248,36V265L480,265z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M464,281v180.5l-216-31.3V281H464 M480,265H232v179l248,36V265L480,265z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M200,281v142.2L48,401.2V281H200 M216,265H32v150l184,26.7V265L216,265z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M200,281v142.2L48,401.2V281H200 M216,265H32v150l184,26.7V265L216,265z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M464,50v183H248V81.3l216-30.9 M480,32L232,67.4V249h248V32L480,32z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M464,50v183H248V81.3l216-30.9 M480,32L232,67.4V249h248V32L480,32z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M200,88v145H48V109.9l152-21.7 M216,69.7L32,96v153h184V69.7L216,69.7z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M200,88v145H48V109.9l152-21.7 M216,69.7L32,96v153h184V69.7L216,69.7z"},"children":[]}]}]}]};exports.socialWindowsOutline=socialWindowsOutline;var socialWindows={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M480,265H232v179l248,36V265L480,265z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M480,265H232v179l248,36V265L480,265z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M216,265H32v150l184,26.7V265L216,265z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M216,265H32v150l184,26.7V265L216,265z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M480,32L232,67.4V249h248V32L480,32z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M480,32L232,67.4V249h248V32L480,32z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M216,69.7L32,96v153h184V69.7L216,69.7z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M216,69.7L32,96v153h184V69.7L216,69.7z"},"children":[]}]}]}]};exports.socialWindows=socialWindows;var socialWordpressOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M255.9,64C150.2,64,64,150.2,64,256.1C64,361.9,150.2,448,255.9,448c8.5,0,16.8-0.5,24.9-1.8\r\n\tc85.7-11,153.8-78.7,165.3-164.1c1.3-8.5,1.9-17.2,1.9-26C448,150.2,361.8,64,255.9,64z M83.4,256.1c0-25,5.4-48.8,15-70.2\r\n\tl82.3,225.5C123.1,383.4,83.4,324.3,83.4,256.1z M278.3,427.3c-7.3,0.9-14.8,1.4-22.4,1.4c-16.9,0-33.2-2.5-48.6-7.1l18.8-55h0.1\r\n\tl32.7-95.5L312,416.5c0.4,0.8,0.9,1.6,1.3,2.3C302.1,422.8,290.4,425.6,278.3,427.3z M279.8,175.1c10.4-0.5,19.7-1.6,19.7-1.6\r\n\tc9.4-1,8.2-14.8-1.1-14.2c0,0-28,2.2-46,2.2c-16.9,0-45.5-2.2-45.5-2.2c-9.2-0.6-10.4,13.7-1,14.2c0,0,8.7,1.1,18.1,1.6l26.9,73.7\r\n\tl-37.8,113.3l-62.9-187c10.5-0.5,19.8-1.6,19.8-1.6c9.2-1,8.2-14.8-1.1-14.2c0,0-27.9,2.2-46,2.2c-3.3,0-7.1-0.1-11.1-0.2\r\n\tc30.8-46.8,83.9-77.7,144.1-77.7c45,0,85.9,17.2,116.6,45.2c-0.8,0-1.5-0.1-2.3-0.1c-17,0-29,14.8-29,30.7\r\n\tc0,14.2,8.2,26.2,16.9,40.4c6.6,11.5,14.3,26.3,14.3,47.6c0,14.8-4.4,33.4-13.1,55.7l-17.3,57.6L279.8,175.1z M342.7,405.3\r\n\tl13.7-39.7l39-112.8c9.9-24.6,13.1-44.3,13.1-61.8c0-6.3-0.4-12.3-1.1-17.8c13.5,24.6,21.2,52.8,21.2,82.9c0,8-0.5,15.8-1.5,23.5\r\n\tC419.7,333.3,387.6,379.2,342.7,405.3z"},"children":[]}]};exports.socialWordpressOutline=socialWordpressOutline;var socialWordpress={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M259,271.3L226.2,367h-0.1l-25.4,73.1c1.8,0.5,3.5,0.9,5.3,1.4c0.1,0,0.2,0,0.3,0c15.8,4.2,32.4,6.5,49.5,6.5\r\n\t\tc8.5,0,16.8-0.5,24.9-1.8c11.2-1.4,22-3.8,32.5-7.1c0,0,0,0,0,0c2.6-0.8,5.2-1.7,7.8-2.6c-2.8-6-8.8-19.3-9.1-19.9L259,271.3z"},"children":[{"name":"path","attribs":{"d":"M259,271.3L226.2,367h-0.1l-25.4,73.1c1.8,0.5,3.5,0.9,5.3,1.4c0.1,0,0.2,0,0.3,0c15.8,4.2,32.4,6.5,49.5,6.5\r\n\t\tc8.5,0,16.8-0.5,24.9-1.8c11.2-1.4,22-3.8,32.5-7.1c0,0,0,0,0,0c2.6-0.8,5.2-1.7,7.8-2.6c-2.8-6-8.8-19.3-9.1-19.9L259,271.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M80.8,180.5c-10,22.6-16.8,50.4-16.8,75.5c0,6.3,0.3,12.6,0.9,18.8c6.9,71.2,52.9,131,116.1,157.9c2.6,1.1,5.3,2.2,8,3.2\r\n\t\tL96,180.6C88,180.3,86.5,180.8,80.8,180.5z"},"children":[{"name":"path","attribs":{"d":"M80.8,180.5c-10,22.6-16.8,50.4-16.8,75.5c0,6.3,0.3,12.6,0.9,18.8c6.9,71.2,52.9,131,116.1,157.9c2.6,1.1,5.3,2.2,8,3.2\r\n\t\tL96,180.6C88,180.3,86.5,180.8,80.8,180.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M430.2,175.4c-4.3-9.3-9.4-18.2-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2c-21.5-28.8-50.8-51.4-84.9-64.6\r\n\t\tC303.7,68.6,280.3,64,255.9,64c-60.3,0-114.2,28-149.4,71.7c-6.5,8-12.3,16.6-17.5,25.6c14.2,0.1,31.8,0.1,33.8,0.1\r\n\t\tc18.1,0,46-2.2,46-2.2c9.4-0.6,10.4,13.1,1.1,14.2c0,0-9.4,1.1-19.8,1.6l62.9,187l37.8-113.3L224,175.1c-9.4-0.5-18.1-1.6-18.1-1.6\r\n\t\tc-9.4-0.5-8.2-14.8,1-14.2c0,0,28.5,2.2,45.5,2.2c18.1,0,46-2.2,46-2.2c9.3-0.6,10.5,13.1,1.1,14.2c0,0-9.3,1.1-19.7,1.6\r\n\t\tl62.3,185.6l17.3-57.6c8.7-22.4,13.1-40.9,13.1-55.7c0-21.3-7.7-36.1-14.3-47.6c-8.7-14.3-16.9-26.3-16.9-40.4\r\n\t\tc0-15.9,12-30.7,29-30.7c0.7,0,1.5,0,2.2,0c26.2-0.7,34.8,25.3,35.9,43c0,0,0,0.4,0,0.6c0.4,7.2,0.1,12.5,0.1,18.8\r\n\t\tc0,17.4-3.3,37.1-13.1,61.8l-39,112.8l-22.3,65.7c1.8-0.8,3.5-1.6,5.3-2.5c56.7-27.4,98-82,106.7-146.7c1.3-8.5,1.9-17.2,1.9-26\r\n\t\tC448,227.3,441.6,199.9,430.2,175.4z"},"children":[{"name":"path","attribs":{"d":"M430.2,175.4c-4.3-9.3-9.4-18.2-15.1-26.6c-1.6-2.4-3.4-4.8-5.1-7.2c-21.5-28.8-50.8-51.4-84.9-64.6\r\n\t\tC303.7,68.6,280.3,64,255.9,64c-60.3,0-114.2,28-149.4,71.7c-6.5,8-12.3,16.6-17.5,25.6c14.2,0.1,31.8,0.1,33.8,0.1\r\n\t\tc18.1,0,46-2.2,46-2.2c9.4-0.6,10.4,13.1,1.1,14.2c0,0-9.4,1.1-19.8,1.6l62.9,187l37.8-113.3L224,175.1c-9.4-0.5-18.1-1.6-18.1-1.6\r\n\t\tc-9.4-0.5-8.2-14.8,1-14.2c0,0,28.5,2.2,45.5,2.2c18.1,0,46-2.2,46-2.2c9.3-0.6,10.5,13.1,1.1,14.2c0,0-9.3,1.1-19.7,1.6\r\n\t\tl62.3,185.6l17.3-57.6c8.7-22.4,13.1-40.9,13.1-55.7c0-21.3-7.7-36.1-14.3-47.6c-8.7-14.3-16.9-26.3-16.9-40.4\r\n\t\tc0-15.9,12-30.7,29-30.7c0.7,0,1.5,0,2.2,0c26.2-0.7,34.8,25.3,35.9,43c0,0,0,0.4,0,0.6c0.4,7.2,0.1,12.5,0.1,18.8\r\n\t\tc0,17.4-3.3,37.1-13.1,61.8l-39,112.8l-22.3,65.7c1.8-0.8,3.5-1.6,5.3-2.5c56.7-27.4,98-82,106.7-146.7c1.3-8.5,1.9-17.2,1.9-26\r\n\t\tC448,227.3,441.6,199.9,430.2,175.4z"},"children":[]}]}]}]};exports.socialWordpress=socialWordpress;var socialYahooOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M384.6,68.4c-11.3,0-22.5-0.8-32.6-4.4l-96,160L160,64c-10.1,3.6-20.7,4.4-32,4.4c-11.1,0-22.1-0.9-32-4.4l128,212.7V448\r\n\tc10-3.5,20.8-4.4,32-4.4s22,0.9,32,4.4V277L416,64C406.1,67.4,395.7,68.4,384.6,68.4z M274.2,268.5l-2.2,4v4.4v151.3\r\n\tc-5-0.6-11.2-0.7-16-0.7c-4.8,0-10,0.1-16,0.7V276.7v-4.4l-2.4-3.8L127,84.4c0.3,0,0.7,0,1,0c7.6,0,16-0.3,24.7-1.9l89.8,149.8\r\n\tl13.4,22.8l14-22.9l89.8-149.9c9,1.6,17.6,1.7,24.8,1.7c0.2,0,0.3,0,0.5,0L274.2,268.5z"},"children":[]}]};exports.socialYahooOutline=socialYahooOutline;var socialYahoo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M384.6,68.4c-11.3,0-22.5-0.8-32.6-4.4l-96,160L160,64c-10.1,3.6-20.7,4.4-32,4.4c-11.1,0-22.1-0.9-32-4.4l128,212.7V448\r\n\tc10-3.5,20.8-4.4,32-4.4s22,0.9,32,4.4V277L416,64C406.1,67.4,395.7,68.4,384.6,68.4z"},"children":[]}]};exports.socialYahoo=socialYahoo;var socialYenOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,32h-80L256,253.128L144,32H64l112.368,208H128v48h73.564L216,319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.891-31H384\r\n\tv-48h-48.289L448,32z M368,256v16h-67l-21,43v37h88v16h-88v96h-48v-96h-88v-16h88v-35.75L212,272h-68v-16h59.197l-12.752-23.605\r\n\tL90.829,48H134l122,240L378,48h43h0.18l-99.548,184.399L308.891,256H368z"},"children":[]}]};exports.socialYenOutline=socialYenOutline;var socialYen={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M448,32h-80L256,253.128L144,32H64l112.368,208H128v48h73.564L216,319v17h-88v48h88v96h80v-96h88v-48h-88v-17l14.891-31H384\r\n\tv-48h-48.289L448,32z"},"children":[]}]};exports.socialYen=socialYen;var socialYoutubeOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0\r\n\t\t\tc0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0\r\n\t\t\tc-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8\r\n\t\t\tc-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1\r\n\t\t\tc-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64\r\n\t\t\tc-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7\r\n\t\t\tc-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0\r\n\t\t\tc57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1\r\n\t\t\tC379.2,64.8,322.7,64,265,64L265,64z"},"children":[{"name":"path","attribs":{"d":"M265,96c65.3,0,118.7,1.1,168.1,3.3l0.7,0h0.7c23.1,0,42,22,42,49.1v1.1l0.1,1.1c2.3,34,3.4,69.3,3.4,104.9v0v0\r\n\t\t\tc0.1,35.6-1.1,70.9-3.4,104.9l-0.1,1.1v1.1c0,13.8-4.7,26.6-13.4,36.1c-7.8,8.6-18,13.4-28.6,13.4h-0.8l-0.8,0\r\n\t\t\tc-52.9,2.5-108.8,3.8-166.4,3.8c-3.5,0-7.1,0-10.6,0H256h-0.1c-3.6,0-7.2,0-10.8,0c-57.8,0-113.7-1.3-166.2-3.7l-0.8,0h-0.8\r\n\t\t\tc-10.6,0-20.7-4.8-28.5-13.4c-8.6-9.5-13.4-22.3-13.4-36.1v-1.1l-0.1-1.1c-2.4-34.1-3.5-69.4-3.3-104.7v-0.1v-0.1\r\n\t\t\tc-0.1-35.3,1-70.5,3.3-104.6l0.1-1.1v-1.1c0-27.2,18.8-49.3,41.9-49.3H78l0.7,0c49.5-2.3,102.9-3.3,168.2-3.3h9H265 M265,64\r\n\t\t\tc-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,0.8-169.6,3.3c-40.8,0-73.9,36.3-73.9,81.3C1,184.4-0.1,220,0,255.7\r\n\t\t\tc-0.1,35.7,0.9,71.3,3.4,107c0,45,33.1,81.6,73.9,81.6c54.8,2.6,110.7,3.8,167.8,3.8c3.6,0,7.3,0,10.9,0c3.6,0,7.2,0,10.7,0\r\n\t\t\tc57.1,0,113-1.2,167.9-3.8c40.9,0,74-36.6,74-81.6c2.4-35.7,3.5-71.4,3.4-107.1c0.1-35.7-1-71.3-3.4-107.1c0-45-33.1-81.1-74-81.1\r\n\t\t\tC379.2,64.8,322.7,64,265,64L265,64z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M207,353.8V157.4l145,98.2L207,353.8z"},"children":[{"name":"path","attribs":{"d":"M207,353.8V157.4l145,98.2L207,353.8z"},"children":[]}]}]}]}]}]};exports.socialYoutubeOutline=socialYoutubeOutline;var socialYoutube={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M508.6,148.8c0-45-33.1-81.2-74-81.2C379.2,65,322.7,64,265,64c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,1-169.6,3.6\r\n\t\tc-40.8,0-73.9,36.4-73.9,81.4C1,184.6-0.1,220.2,0,255.8C-0.1,291.4,1,327,3.4,362.7c0,45,33.1,81.5,73.9,81.5\r\n\t\tc58.2,2.7,117.9,3.9,178.6,3.8c60.8,0.2,120.3-1,178.6-3.8c40.9,0,74-36.5,74-81.5c2.4-35.7,3.5-71.3,3.4-107\r\n\t\tC512.1,220.1,511,184.5,508.6,148.8z M207,353.9V157.4l145,98.2L207,353.9z"},"children":[{"name":"path","attribs":{"d":"M508.6,148.8c0-45-33.1-81.2-74-81.2C379.2,65,322.7,64,265,64c-3,0-6,0-9,0s-6,0-9,0c-57.6,0-114.2,1-169.6,3.6\r\n\t\tc-40.8,0-73.9,36.4-73.9,81.4C1,184.6-0.1,220.2,0,255.8C-0.1,291.4,1,327,3.4,362.7c0,45,33.1,81.5,73.9,81.5\r\n\t\tc58.2,2.7,117.9,3.9,178.6,3.8c60.8,0.2,120.3-1,178.6-3.8c40.9,0,74-36.5,74-81.5c2.4-35.7,3.5-71.3,3.4-107\r\n\t\tC512.1,220.1,511,184.5,508.6,148.8z M207,353.9V157.4l145,98.2L207,353.9z"},"children":[]}]}]}]};exports.socialYoutube=socialYoutube;var soupCanOutline={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M255.82,144c88.269,0,159.824-28.654,159.824-64S344.089,16,255.82,16C167.552,16,95.997,44.654,95.997,80\r\n\t\tS167.552,144,255.82,144z M255.82,33.041c69.729,0,126.26,19.234,126.26,42.959s-56.531,42.959-126.26,42.959\r\n\t\tc-69.729,0-126.258-19.234-126.258-42.959S186.091,33.041,255.82,33.041z"},"children":[{"name":"path","attribs":{"d":"M255.82,144c88.269,0,159.824-28.654,159.824-64S344.089,16,255.82,16C167.552,16,95.997,44.654,95.997,80\r\n\t\tS167.552,144,255.82,144z M255.82,33.041c69.729,0,126.26,19.234,126.26,42.959s-56.531,42.959-126.26,42.959\r\n\t\tc-69.729,0-126.258-19.234-126.258-42.959S186.091,33.041,255.82,33.041z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.57,160c-88.269,0-160.567-28.654-160.567-64c0,0-0.003,33.999,7.997,40v240c0,35.346,63.732,64,152,64\r\n\t\tc88.269,0,152-28.654,152-64V136c8-7.438,7.708-34.853,7.817-40C414.665,130.946,344.116,160,256.57,160z M376,375.588\r\n\t\tc0,2.232-7.961,10.682-29.423,18.688C322.853,403.126,290.812,408,256.273,408c-34.539,0-66.83-4.874-90.554-13.725\r\n\t\tC144.257,386.27,137,377.82,136,375.588v-79.564c18,9.721,42.742,17.115,72.156,20.979l1.588,0.237\r\n\t\tC215.487,337.308,233.936,352,255.826,352c21.89,0,40.338-14.689,46.084-34.754l1.755-0.244\r\n\t\tC333.08,313.139,358,305.744,376,296.023V375.588z M376,264.023c-18,9.831-43.476,17.284-73.325,21.11l-2.61,0.195\r\n\t\tC292.791,268.097,275.723,256,255.859,256c-19.867,0-36.919,12.102-44.19,29.34l-2.514-0.206\r\n\t\tc-29.85-3.826-55.155-11.279-73.155-21.11v-91.265C170,185.25,211.923,192,256.499,192C300.665,192,343,185.287,376,173.045\r\n\t\tV264.023z"},"children":[{"name":"path","attribs":{"d":"M256.57,160c-88.269,0-160.567-28.654-160.567-64c0,0-0.003,33.999,7.997,40v240c0,35.346,63.732,64,152,64\r\n\t\tc88.269,0,152-28.654,152-64V136c8-7.438,7.708-34.853,7.817-40C414.665,130.946,344.116,160,256.57,160z M376,375.588\r\n\t\tc0,2.232-7.961,10.682-29.423,18.688C322.853,403.126,290.812,408,256.273,408c-34.539,0-66.83-4.874-90.554-13.725\r\n\t\tC144.257,386.27,137,377.82,136,375.588v-79.564c18,9.721,42.742,17.115,72.156,20.979l1.588,0.237\r\n\t\tC215.487,337.308,233.936,352,255.826,352c21.89,0,40.338-14.689,46.084-34.754l1.755-0.244\r\n\t\tC333.08,313.139,358,305.744,376,296.023V375.588z M376,264.023c-18,9.831-43.476,17.284-73.325,21.11l-2.61,0.195\r\n\t\tC292.791,268.097,275.723,256,255.859,256c-19.867,0-36.919,12.102-44.19,29.34l-2.514-0.206\r\n\t\tc-29.85-3.826-55.155-11.279-73.155-21.11v-91.265C170,185.25,211.923,192,256.499,192C300.665,192,343,185.287,376,173.045\r\n\t\tV264.023z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M274.002,463.58"},"children":[{"name":"path","attribs":{"d":"M274.002,463.58"},"children":[]}]},{"name":"path","attribs":{"d":"M256.272,464c0.293,0,0.583-0.006,0.876-0.007c-0.351,0.001-0.699,0.005-1.051,0.005\r\n\t\t\tC256.156,463.998,256.214,464,256.272,464z"},"children":[{"name":"path","attribs":{"d":"M256.272,464c0.293,0,0.583-0.006,0.876-0.007c-0.351,0.001-0.699,0.005-1.051,0.005\r\n\t\t\tC256.156,463.998,256.214,464,256.272,464z"},"children":[]}]},{"name":"path","attribs":{"d":"M408,415.999V400c0,36.001-63.432,64-152,64c-88.569,0-152-28.654-152-64v15.999L96.261,432\r\n\t\t\tc0,6.994,2.938,13.725,8.117,20.025C125.37,477.562,185.471,496,256.273,496c70.801,0,130.87-18.438,151.863-43.975\r\n\t\t\tc5.18-6.301,7.923-13.031,7.923-20.025L408,415.999z"},"children":[{"name":"path","attribs":{"d":"M408,415.999V400c0,36.001-63.432,64-152,64c-88.569,0-152-28.654-152-64v15.999L96.261,432\r\n\t\t\tc0,6.994,2.938,13.725,8.117,20.025C125.37,477.562,185.471,496,256.273,496c70.801,0,130.87-18.438,151.863-43.975\r\n\t\t\tc5.18-6.301,7.923-13.031,7.923-20.025L408,415.999z"},"children":[]}]}]}]}]}]};exports.soupCanOutline=soupCanOutline;var soupCan={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"ellipse","attribs":{"cx":"256","cy":"80","rx":"160","ry":"64"},"children":[{"name":"ellipse","attribs":{"cx":"256","cy":"80","rx":"160","ry":"64"},"children":[]}]},{"name":"path","attribs":{"d":"M256,440c88.365,0,152-28.654,152-64V248c0,28.581-41.612,52.783-104.26,61.002C301.238,333.16,280.82,352,256,352\r\n\t\ts-45.238-18.84-47.74-42.998C145.612,300.783,104,276.581,104,248v128C104,411.346,167.634,440,256,440z"},"children":[{"name":"path","attribs":{"d":"M256,440c88.365,0,152-28.654,152-64V248c0,28.581-41.612,52.783-104.26,61.002C301.238,333.16,280.82,352,256,352\r\n\t\ts-45.238-18.84-47.74-42.998C145.612,300.783,104,276.581,104,248v128C104,411.346,167.634,440,256,440z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,160c-88.366,0-160-28.654-160-64c0,0,0,32.834,8,40v96c0,28.732,42.049,53.042,105.25,61.134\r\n\t\tC214.176,271.861,233.229,256,256,256s41.824,15.861,46.75,37.134C365.951,285.042,408,260.732,408,232v-96c8-8.25,8-40,8-40\r\n\t\tC416,131.346,344.365,160,256,160z"},"children":[{"name":"path","attribs":{"d":"M256,160c-88.366,0-160-28.654-160-64c0,0,0,32.834,8,40v96c0,28.732,42.049,53.042,105.25,61.134\r\n\t\tC214.176,271.861,233.229,256,256,256s41.824,15.861,46.75,37.134C365.951,285.042,408,260.732,408,232v-96c8-8.25,8-40,8-40\r\n\t\tC416,131.346,344.365,160,256,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M408,392c0,35.346-63.635,64-152,64c-88.366,0-152-28.654-152-64v23.999L96,432c0,6.994,2.815,13.725,8,20.025\r\n\t\tC125.016,477.562,185.121,496,256,496c70.879,0,130.984-18.438,152-43.975c5.186-6.301,8-13.031,8-20.025l-8-16.001V392z"},"children":[{"name":"path","attribs":{"d":"M408,392c0,35.346-63.635,64-152,64c-88.366,0-152-28.654-152-64v23.999L96,432c0,6.994,2.815,13.725,8,20.025\r\n\t\tC125.016,477.562,185.121,496,256,496c70.879,0,130.984-18.438,152-43.975c5.186-6.301,8-13.031,8-20.025l-8-16.001V392z"},"children":[]}]}]}]};exports.soupCan=soupCan;var speakerphone={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M70.9,181.5c0-41,25-76.5,60.6-91.5h-7.7c-41.1,0-75.1,32.8-81.1,75.2c-6,1-10.7,7.9-10.7,16.1c0,8.6,5.1,15.4,11.6,15.9\r\n\t\tc7.2,36.4,35.1,65.8,69.7,68.8c0,0,0.1,0,0.1,0c1.4,0,2.8,0.6,4.2,0.9c1.1,0.2,2.2,0.4,3.3,0.7C91,250.5,70.9,218.4,70.9,181.5z"},"children":[{"name":"path","attribs":{"d":"M70.9,181.5c0-41,25-76.5,60.6-91.5h-7.7c-41.1,0-75.1,32.8-81.1,75.2c-6,1-10.7,7.9-10.7,16.1c0,8.6,5.1,15.4,11.6,15.9\r\n\t\tc7.2,36.4,35.1,65.8,69.7,68.8c0,0,0.1,0,0.1,0c1.4,0,2.8,0.6,4.2,0.9c1.1,0.2,2.2,0.4,3.3,0.7C91,250.5,70.9,218.4,70.9,181.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M465.1,91c-1.1-2.9-2.3-5.6-3.5-8.3c-6.5-14.4-14.4-26-23.4-34.6C427,37.6,414.1,32,400.8,32c-8.3,0-16.4,2.2-24.1,6.4\r\n\t\tc0,0,0,0-0.1,0c-1.2,0.7-2.4,1.3-3.6,2c-49,29-104.1,46.2-162.6,49.4c-6.5,0.4-13,0.2-19.5,0.2h-42.3c-34,15-59,50.5-59,91.5\r\n\t\tc0,36.8,19.2,69.1,47.8,86.1c13,10.9,41.7,11.7,40,23.9c-1.9,13.2-5.5,21.9-7.8,30.7c-1.3,4.8-23.6,72.9-25.3,144.7\r\n\t\tc0,2,0,3.7,0.2,6.6c0.2,2.9,2.2,6.4,8.5,6.4h76.8c6.6,0,9.7-3.3,9.3-9.3c-0.2-1.9-0.6-4.3-0.8-6.5c-2.4-23.1-4.6-49.8-3.3-81.6\r\n\t\tc1.3-34,5.2-51.9,7-61.3c2.1-10.4,7.6-22.4,12.1-30.3c30.8,0.9,92.9,19.3,115.1,28.9c0,0,7.2,3.4,10.1,5.2c7,3.4,14.2,5.1,21.6,5.1\r\n\t\tc0.9,0,1.8,0,2.7-0.1c12.3-0.7,24.2-9.7,34.7-19.5c9.1-8.5,16.9-20.2,23.4-34.6c1.2-2.8,2.4-5.6,3.5-8.6\r\n\t\tc9.6-25,14.8-55.9,14.8-88.1C480,147,474.8,116,465.1,91z M442,267.5c-7.8,18.5-18.2,33.3-29.5,33.3c-11.3,0-21.6-14.7-29.4-33.3\r\n\t\tc-9.1-21.6-14.9-53.1-14.9-88.1c0-35.2,5.8-66.8,15-88.4c7.8-18.4,18.1-29.5,29.3-29.5c11.3,0,21.5,11.2,29.4,29.5\r\n\t\tc9.2,21.6,15,53.2,15,88.4C456.9,214.4,451.1,245.9,442,267.5z"},"children":[{"name":"path","attribs":{"d":"M465.1,91c-1.1-2.9-2.3-5.6-3.5-8.3c-6.5-14.4-14.4-26-23.4-34.6C427,37.6,414.1,32,400.8,32c-8.3,0-16.4,2.2-24.1,6.4\r\n\t\tc0,0,0,0-0.1,0c-1.2,0.7-2.4,1.3-3.6,2c-49,29-104.1,46.2-162.6,49.4c-6.5,0.4-13,0.2-19.5,0.2h-42.3c-34,15-59,50.5-59,91.5\r\n\t\tc0,36.8,19.2,69.1,47.8,86.1c13,10.9,41.7,11.7,40,23.9c-1.9,13.2-5.5,21.9-7.8,30.7c-1.3,4.8-23.6,72.9-25.3,144.7\r\n\t\tc0,2,0,3.7,0.2,6.6c0.2,2.9,2.2,6.4,8.5,6.4h76.8c6.6,0,9.7-3.3,9.3-9.3c-0.2-1.9-0.6-4.3-0.8-6.5c-2.4-23.1-4.6-49.8-3.3-81.6\r\n\t\tc1.3-34,5.2-51.9,7-61.3c2.1-10.4,7.6-22.4,12.1-30.3c30.8,0.9,92.9,19.3,115.1,28.9c0,0,7.2,3.4,10.1,5.2c7,3.4,14.2,5.1,21.6,5.1\r\n\t\tc0.9,0,1.8,0,2.7-0.1c12.3-0.7,24.2-9.7,34.7-19.5c9.1-8.5,16.9-20.2,23.4-34.6c1.2-2.8,2.4-5.6,3.5-8.6\r\n\t\tc9.6-25,14.8-55.9,14.8-88.1C480,147,474.8,116,465.1,91z M442,267.5c-7.8,18.5-18.2,33.3-29.5,33.3c-11.3,0-21.6-14.7-29.4-33.3\r\n\t\tc-9.1-21.6-14.9-53.1-14.9-88.1c0-35.2,5.8-66.8,15-88.4c7.8-18.4,18.1-29.5,29.3-29.5c11.3,0,21.5,11.2,29.4,29.5\r\n\t\tc9.2,21.6,15,53.2,15,88.4C456.9,214.4,451.1,245.9,442,267.5z"},"children":[]}]}]}]};exports.speakerphone=speakerphone;var speedometer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,256l-84.4,64.2c-1.2-0.1-2.4-0.2-3.6-0.2c-17.7,0-32,14.3-32,32c0,17.7,14.3,32,32,32c17.7,0,32-14.3,32-32\r\n\t\tc0-1.2-0.1-2.4-0.2-3.6L352,264L344,256z"},"children":[{"name":"path","attribs":{"d":"M344,256l-84.4,64.2c-1.2-0.1-2.4-0.2-3.6-0.2c-17.7,0-32,14.3-32,32c0,17.7,14.3,32,32,32c17.7,0,32-14.3,32-32\r\n\t\tc0-1.2-0.1-2.4-0.2-3.6L352,264L344,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,96C132.3,96,32,196.3,32,320c0,34.4,7.8,66.9,21.6,96h36.1c-15.4-26.6-24.2-56.6-25.5-88H96v-16H64.2\r\n\t\tc1.2-28.8,8.7-56.5,21.8-81.4l27.5,15.9l8-13.9L94,216.8c7.4-11.6,16.2-22.6,26.2-32.6c10.2-10.1,21.3-19,33.1-26.5l15.8,27.3\r\n\t\tl13.9-8l-15.8-27.3c24.8-13,52.2-20.3,80.8-21.5V160h16v-31.8c28.6,1.2,56,8.6,80.8,21.5L329.1,177l13.9,8l15.8-27.3\r\n\t\tc11.8,7.5,22.9,16.4,33.1,26.5c10,10,18.7,20.9,26.2,32.6l-27.4,15.8l8,13.9l27.5-15.9c13.1,24.9,20.6,52.6,21.8,81.4H416v16h31.8\r\n\t\tc-1.3,31.4-10.1,61.4-25.5,88h36.1c13.8-29.1,21.6-61.6,21.6-96C480,196.3,379.7,96,256,96z"},"children":[{"name":"path","attribs":{"d":"M256,96C132.3,96,32,196.3,32,320c0,34.4,7.8,66.9,21.6,96h36.1c-15.4-26.6-24.2-56.6-25.5-88H96v-16H64.2\r\n\t\tc1.2-28.8,8.7-56.5,21.8-81.4l27.5,15.9l8-13.9L94,216.8c7.4-11.6,16.2-22.6,26.2-32.6c10.2-10.1,21.3-19,33.1-26.5l15.8,27.3\r\n\t\tl13.9-8l-15.8-27.3c24.8-13,52.2-20.3,80.8-21.5V160h16v-31.8c28.6,1.2,56,8.6,80.8,21.5L329.1,177l13.9,8l15.8-27.3\r\n\t\tc11.8,7.5,22.9,16.4,33.1,26.5c10,10,18.7,20.9,26.2,32.6l-27.4,15.8l8,13.9l27.5-15.9c13.1,24.9,20.6,52.6,21.8,81.4H416v16h31.8\r\n\t\tc-1.3,31.4-10.1,61.4-25.5,88h36.1c13.8-29.1,21.6-61.6,21.6-96C480,196.3,379.7,96,256,96z"},"children":[]}]}]}]};exports.speedometer=speedometer;var spoon={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M320,160C320,96,293.5,32,256,32s-64,64-64,128l0,0c0.9,25,15.7,54.3,36.6,64.3c0.5,0.2,0.9,0.4,1.4,0.6c0,0,0,0,0.1,0\r\n\tc3.4,1.9,9.8,5.5,9.8,9.7c0,0-16,198.7-16,210.1s5,20.5,10.5,26c5.5,5.5,13.1,9.2,21.3,9.2c0.1,0,0.1,0,0.2,0c0.1,0,0.1,0,0.2,0\r\n\tc8.2,0,15.8-3.7,21.4-9.2c5.5-5.5,10.3-12.9,10.3-26s-16-210.1-16-210.1c0-4.2,6.4-7.9,9.8-9.8l1.7-0.9C304.9,214,320,186,320,160"},"children":[]}]};exports.spoon=spoon;var star={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"480,200 308.519,200 256.029,32 203.519,200 32,200 170.946,304.209 116,480 256,368 396,480 341.073,304.195 "},"children":[]}]};exports.star=star;var statsBars={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"176","y":"96","width":"64","height":"320"},"children":[{"name":"rect","attribs":{"x":"176","y":"96","width":"64","height":"320"},"children":[]}]},{"name":"rect","attribs":{"x":"80","y":"320","width":"64","height":"96"},"children":[{"name":"rect","attribs":{"x":"80","y":"320","width":"64","height":"96"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"256","width":"64","height":"160"},"children":[{"name":"rect","attribs":{"x":"272","y":"256","width":"64","height":"160"},"children":[]}]},{"name":"rect","attribs":{"x":"368","y":"192","width":"64","height":"224"},"children":[{"name":"rect","attribs":{"x":"368","y":"192","width":"64","height":"224"},"children":[]}]}]}]};exports.statsBars=statsBars;var steam={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"path","attribs":{"id":"Gears","class":"st0","d":"M480,208.2c0,20.5-16.6,37.2-37.2,37.2c-20.5,0-37.2-16.6-37.2-37.2c0-20.5,16.6-37.2,37.2-37.2\r\n\tC463.3,171,480,187.7,480,208.2z M442.6,139c-38.1,0-69,30.7-69.4,68.7L330,269.7c-1.8-0.2-3.6-0.3-5.4-0.3\r\n\tc-9.7,0-18.7,2.7-26.4,7.3l-195.8-78.7c-5.1-23.2-25.9-40.7-50.6-40.7C23.3,157.2,0,180.6,0,209.1c0,28.5,23.3,51.8,51.8,51.8\r\n\tc9.7,0,18.7-2.7,26.4-7.3L274,332.2c5.1,23.3,25.8,40.8,50.6,40.8c26.8,0,49-20.6,51.5-46.7l66.5-48.6c38.3,0,69.4-31,69.4-69.3\r\n\tC512,170.1,480.9,139,442.6,139z M442.6,161.9c25.7,0,46.5,20.9,46.5,46.5c0,25.7-20.9,46.4-46.5,46.4c-25.7,0-46.5-20.8-46.5-46.4\r\n\tC396.1,182.7,416.9,161.9,442.6,161.9z M51.8,170.9c14.6,0,27.3,8.2,33.7,20.2l-18.9-7.6v0.1c-15.3-5.5-32.2,2-38.3,17.1\r\n\tc-6.1,15.2,0.9,32.3,15.7,38.9v0.1l16.1,6.4c-2.6,0.6-5.4,0.9-8.2,0.9c-21.1,0-38.1-17-38.1-38.1C13.7,188,30.7,170.9,51.8,170.9z\r\n\t M324.6,283.1c21.1,0,38.1,17,38.1,38.1c0,21.1-17,38.1-38.1,38.1c-14.7,0-27.4-8.2-33.7-20.3c6.3,2.5,12.5,5,18.8,7.6\r\n\tc15.5,6.2,33.2-1.3,39.4-16.8c6.2-15.5-1.3-33.1-16.9-39.4l-15.9-6.4C319.1,283.5,321.8,283.1,324.6,283.1z"},"children":[]}]};exports.steam=steam;var stop={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M437.4,64H74.6C68.7,64,64,68.7,64,74.6v362.8c0,5.9,4.7,10.6,10.6,10.6h362.8c5.8,0,10.6-4.7,10.6-10.6V74.6\r\n\tC448,68.7,443.2,64,437.4,64z"},"children":[]}]};exports.stop=stop;var thermometer={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M303,335.6V78.4c0-25.7-21-46.5-47-46.5c-26,0-47,20.8-47,46.5v256.8c-20,14.5-32.9,38.2-32.9,64.9c0,44.2,36,80,80.2,80\r\n\t\tc44.2,0,79.8-35.8,79.8-80C336,373.6,323,350.1,303,335.6z M241,78.4c0-8,6.7-14.5,15-14.5s15,6.5,15,14.5V128h-30V78.4z M272,288\r\n\t\th-16v-16h16V288z M272,256h-16v-64h16V256z"},"children":[{"name":"path","attribs":{"d":"M303,335.6V78.4c0-25.7-21-46.5-47-46.5c-26,0-47,20.8-47,46.5v256.8c-20,14.5-32.9,38.2-32.9,64.9c0,44.2,36,80,80.2,80\r\n\t\tc44.2,0,79.8-35.8,79.8-80C336,373.6,323,350.1,303,335.6z M241,78.4c0-8,6.7-14.5,15-14.5s15,6.5,15,14.5V128h-30V78.4z M272,288\r\n\t\th-16v-16h16V288z M272,256h-16v-64h16V256z"},"children":[]}]}]}]};exports.thermometer=thermometer;var thumbsdown={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M87.8,252.7C74,257.2,64,270.2,64,285.5c0,19,15.4,34.5,34.5,34.5h102.6c-2,25-10,53.6-1.1,87.3\r\n\t\tc7.5,28.4,39.4,49.7,52.4,36.8c5-4.9,3.5-15.2,3.5-33.8c0-42.8,17.8-86.1,39.8-108.7c9.4-9.7,25.2-13,40.2-13.6v16h112V64H336v32\r\n\t\tc-20.6,0.5-52.6-5.2-75.8-6.6c-52-3.1-102,2.4-126.3,8.1c-24.3,5.7-35,13-35,30.6c0,6.4,1.9,12.3,5.1,17.3\r\n\t\tc-11.8,4.7-20.1,16.2-20.1,29.7c0,7.2,2.4,13.8,6.4,19.2c-11.9,4.6-20.4,16.2-20.4,29.8C70,236.6,77.3,247.5,87.8,252.7z M400,96.3\r\n\t\tc8.8,0,16,7.1,16,16c0,8.8-7.2,16-16,16s-16-7.1-16-16C384,103.5,391.2,96.3,400,96.3z"},"children":[{"name":"path","attribs":{"d":"M87.8,252.7C74,257.2,64,270.2,64,285.5c0,19,15.4,34.5,34.5,34.5h102.6c-2,25-10,53.6-1.1,87.3\r\n\t\tc7.5,28.4,39.4,49.7,52.4,36.8c5-4.9,3.5-15.2,3.5-33.8c0-42.8,17.8-86.1,39.8-108.7c9.4-9.7,25.2-13,40.2-13.6v16h112V64H336v32\r\n\t\tc-20.6,0.5-52.6-5.2-75.8-6.6c-52-3.1-102,2.4-126.3,8.1c-24.3,5.7-35,13-35,30.6c0,6.4,1.9,12.3,5.1,17.3\r\n\t\tc-11.8,4.7-20.1,16.2-20.1,29.7c0,7.2,2.4,13.8,6.4,19.2c-11.9,4.6-20.4,16.2-20.4,29.8C70,236.6,77.3,247.5,87.8,252.7z M400,96.3\r\n\t\tc8.8,0,16,7.1,16,16c0,8.8-7.2,16-16,16s-16-7.1-16-16C384,103.5,391.2,96.3,400,96.3z"},"children":[]}]}]}]};exports.thumbsdown=thumbsdown;var thumbsup={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M424.2,259.3c13.8-4.5,23.8-17.5,23.8-32.8c0-19-15.4-34.5-34.5-34.5H310.9c2-25,10-53.6,1.1-87.3\r\n\t\tc-7.5-28.4-39.4-49.7-52.4-36.8c-5,4.9-3.5,15.2-3.5,33.8c0,42.8-17.8,86.1-39.8,108.7c-9.4,9.7-25.2,13-40.2,13.6v-16H64v240h112\r\n\t\tv-32c20.6-0.5,52.6,5.2,75.8,6.6c52,3.1,102-2.4,126.3-8.1c24.3-5.7,35-13,35-30.6c0-6.4-1.9-12.3-5.1-17.3\r\n\t\tc11.8-4.7,20.1-16.2,20.1-29.7c0-7.2-2.4-13.8-6.4-19.2c11.9-4.6,20.4-16.2,20.4-29.8C442,275.4,434.7,264.5,424.2,259.3z\r\n\t\t M112,415.7c-8.8,0-16-7.1-16-16c0-8.8,7.2-16,16-16s16,7.1,16,16C128,408.5,120.8,415.7,112,415.7z"},"children":[{"name":"path","attribs":{"d":"M424.2,259.3c13.8-4.5,23.8-17.5,23.8-32.8c0-19-15.4-34.5-34.5-34.5H310.9c2-25,10-53.6,1.1-87.3\r\n\t\tc-7.5-28.4-39.4-49.7-52.4-36.8c-5,4.9-3.5,15.2-3.5,33.8c0,42.8-17.8,86.1-39.8,108.7c-9.4,9.7-25.2,13-40.2,13.6v-16H64v240h112\r\n\t\tv-32c20.6-0.5,52.6,5.2,75.8,6.6c52,3.1,102-2.4,126.3-8.1c24.3-5.7,35-13,35-30.6c0-6.4-1.9-12.3-5.1-17.3\r\n\t\tc11.8-4.7,20.1-16.2,20.1-29.7c0-7.2-2.4-13.8-6.4-19.2c11.9-4.6,20.4-16.2,20.4-29.8C442,275.4,434.7,264.5,424.2,259.3z\r\n\t\t M112,415.7c-8.8,0-16-7.1-16-16c0-8.8,7.2-16,16-16s16,7.1,16,16C128,408.5,120.8,415.7,112,415.7z"},"children":[]}]}]}]};exports.thumbsup=thumbsup;var toggleFilled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,208c-26.467,0-48,21.533-48,48c0,26.467,21.533,48,48,48s48-21.533,48-48C400,229.533,378.467,208,352,208z"},"children":[{"name":"path","attribs":{"d":"M352,208c-26.467,0-48,21.533-48,48c0,26.467,21.533,48,48,48s48-21.533,48-48C400,229.533,378.467,208,352,208z"},"children":[]}]},{"name":"path","attribs":{"d":"M352,128H160c-70.692,0-128,57.308-128,128s57.308,128,128,128h192c70.692,0,128-57.308,128-128S422.692,128,352,128z\r\n\t\t M352,336c-44.183,0-80-35.817-80-80s35.817-80,80-80s80,35.817,80,80S396.183,336,352,336z"},"children":[{"name":"path","attribs":{"d":"M352,128H160c-70.692,0-128,57.308-128,128s57.308,128,128,128h192c70.692,0,128-57.308,128-128S422.692,128,352,128z\r\n\t\t M352,336c-44.183,0-80-35.817-80-80s35.817-80,80-80s80,35.817,80,80S396.183,336,352,336z"},"children":[]}]}]}]};exports.toggleFilled=toggleFilled;var toggle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,160c52.934,0,96,43.065,96,96s-43.066,96-96,96H160c-52.935,0-96-43.065-96-96s43.065-96,96-96H352 M352,128H160\r\n\t\tc-70.692,0-128,57.308-128,128s57.308,128,128,128h192c70.692,0,128-57.308,128-128S422.692,128,352,128L352,128z"},"children":[{"name":"path","attribs":{"d":"M352,160c52.934,0,96,43.065,96,96s-43.066,96-96,96H160c-52.935,0-96-43.065-96-96s43.065-96,96-96H352 M352,128H160\r\n\t\tc-70.692,0-128,57.308-128,128s57.308,128,128,128h192c70.692,0,128-57.308,128-128S422.692,128,352,128L352,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,208c26.467,0,48,21.533,48,48c0,26.467-21.533,48-48,48s-48-21.533-48-48C112,229.533,133.533,208,160,208 M160,176\r\n\t\tc-44.183,0-80,35.817-80,80s35.817,80,80,80s80-35.817,80-80S204.183,176,160,176L160,176z"},"children":[{"name":"path","attribs":{"d":"M160,208c26.467,0,48,21.533,48,48c0,26.467-21.533,48-48,48s-48-21.533-48-48C112,229.533,133.533,208,160,208 M160,176\r\n\t\tc-44.183,0-80,35.817-80,80s35.817,80,80,80s80-35.817,80-80S204.183,176,160,176L160,176z"},"children":[]}]}]}]};exports.toggle=toggle;var transgender={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M368,0v40h69.873l-93.046,91.97c-8.529-8.249-15.132-12.586-15.132-12.586C308.841,104.694,283.422,96,256,96\r\n\tc-34.525,0-65.86,13.669-88.903,35.894l-17.333-17.131l35.833-35.833L153.07,46.403l-36.022,36.021L74.127,40H144V0H0v144h40V67.806\r\n\tl46.085,45.582L50.402,149.07l32.526,32.526l35.862-35.861l22.185,21.942c-8.395,17.065-13.118,36.267-13.118,56.578\r\n\tC127.857,286.884,173,338.989,232,350.25V402h-72v46h72v64h48v-64h72v-46h-72v-51.75c58-11.261,104.222-63.397,104.222-126.025\r\n\tc0-20.202-4.794-39.738-13.094-56.649L472,67.806V144h40V0H368z M255.929,304.402c-44.156,0-80.079-35.968-80.079-80.178\r\n\tc0-44.211,35.923-80.18,80.079-80.18c44.155,0,80.078,35.969,80.078,80.18C336.007,268.435,300.084,304.402,255.929,304.402z"},"children":[]}]};exports.transgender=transgender;var trashA={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M341,128V99c0-19.1-14.5-35-34.5-35H205.4C185.5,64,171,79.9,171,99v29H80v32h9.2c0,0,5.4,0.6,8.2,3.4c2.8,2.8,3.9,9,3.9,9\r\n\tl19,241.7c1.5,29.4,1.5,33.9,36,33.9h199.4c34.5,0,34.5-4.4,36-33.8l19-241.6c0,0,1.1-6.3,3.9-9.1c2.8-2.8,8.2-3.4,8.2-3.4h9.2v-32\r\n\th-91V128z M192,99c0-9.6,7.8-15,17.7-15h91.7c9.9,0,18.6,5.5,18.6,15v29H192V99z M183.5,384l-10.3-192h20.3L204,384H183.5z\r\n\t M267.1,384h-22V192h22V384z M328.7,384h-20.4l10.5-192h20.3L328.7,384z"},"children":[]}]};exports.trashA=trashA;var trashB={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M413.7,133.4c-2.4-9-4-14-4-14c-2.6-9.3-9.2-9.3-19-10.9l-53.1-6.7c-6.6-1.1-6.6-1.1-9.2-6.8c-8.7-19.6-11.4-31-20.9-31\r\n\t\th-103c-9.5,0-12.1,11.4-20.8,31.1c-2.6,5.6-2.6,5.6-9.2,6.8l-53.2,6.7c-9.7,1.6-16.7,2.5-19.3,11.8c0,0-1.2,4.1-3.7,13\r\n\t\tc-3.2,11.9-4.5,10.6,6.5,10.6h302.4C418.2,144.1,417,145.3,413.7,133.4z"},"children":[{"name":"path","attribs":{"d":"M413.7,133.4c-2.4-9-4-14-4-14c-2.6-9.3-9.2-9.3-19-10.9l-53.1-6.7c-6.6-1.1-6.6-1.1-9.2-6.8c-8.7-19.6-11.4-31-20.9-31\r\n\t\th-103c-9.5,0-12.1,11.4-20.8,31.1c-2.6,5.6-2.6,5.6-9.2,6.8l-53.2,6.7c-9.7,1.6-16.7,2.5-19.3,11.8c0,0-1.2,4.1-3.7,13\r\n\t\tc-3.2,11.9-4.5,10.6,6.5,10.6h302.4C418.2,144.1,417,145.3,413.7,133.4z"},"children":[]}]},{"name":"path","attribs":{"d":"M379.4,176H132.6c-16.6,0-17.4,2.2-16.4,14.7l18.7,242.6c1.6,12.3,2.8,14.8,17.5,14.8h207.2c14.7,0,15.9-2.5,17.5-14.8\r\n\t\tl18.7-242.6C396.8,178.1,396,176,379.4,176z"},"children":[{"name":"path","attribs":{"d":"M379.4,176H132.6c-16.6,0-17.4,2.2-16.4,14.7l18.7,242.6c1.6,12.3,2.8,14.8,17.5,14.8h207.2c14.7,0,15.9-2.5,17.5-14.8\r\n\t\tl18.7-242.6C396.8,178.1,396,176,379.4,176z"},"children":[]}]}]}]};exports.trashB=trashB;var trophy={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M479.863,103.342c-0.051-2.833-0.096-5.279-0.096-7.342h-80.835c1.56-34.617,0.512-64,0.512-64s-95.591,0-142.568,0\r\n\tc-0.337,0-0.669,0.022-1,0.056c-0.33-0.034-0.662-0.056-1-0.056c-46.977,0-142.931,0-142.931,0s-1.048,29.383,0.512,64H32.232H32\r\n\tv20.548c0,0.114,0,0.228,0,0.342V128h0.161c0.811,26.096,4.98,60.999,22.333,96.729c14.718,30.307,35.912,55.664,62.996,75.367\r\n\tc22.422,16.312,48.041,28.064,76.205,35.084C209.96,352.539,226,362.109,240,365.957v35.625C238,412.165,225.86,448,141.234,448H128\r\n\tv32h256v-32h-13.178C271.538,448,272,398.666,272,398.666v-32.714c14-3.843,29.73-13.374,45.91-30.644\r\n\tc28.369-7.004,54.072-18.801,76.633-35.213c27.082-19.703,48.262-45.06,62.98-75.367\r\n\tC481.203,175.967,480.326,128.723,479.863,103.342z M83.262,210.745C68.802,180.966,65.018,150.996,64.187,128h50.487\r\n\tc0.868,8.914,1.966,17.701,3.356,25.98c8.513,50.709,20.213,95.493,42.354,135.009C126.546,271.848,99.97,245.149,83.262,210.745z\r\n\t M428.737,210.745c-16.807,34.61-43.603,61.421-77.729,78.55c22.215-39.591,33.816-84.475,42.352-135.314\r\n\tc1.39-8.28,2.488-17.067,3.356-25.98h51.096C446.981,150.996,443.198,180.966,428.737,210.745z"},"children":[]}]};exports.trophy=trophy;var tshirtOutline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M178.249,85.534c18.761,22.976,43.909,34.009,77.445,34.572l0.269-0.106h0.269c22.638,0,41.169-4.861,56.653-15.091\r\n\tc7.801-5.154,14.721-11.47,21.029-19.382l104.461,31.367L426.59,149.41l-38.743-4.685l-37.912-4.589l2.114,38.133L366.176,433\r\n\tH145.824l14.127-254.729l2.106-37.981l-37.782,4.428l-38.854,4.553l-11.767-32.358L178.249,85.534 M320,48\r\n\tc-13.988,27.227-30.771,40.223-63.769,40.223C223.723,87.676,205.722,75,192,48L32,96l32,88l64-7.5L112,465h288l-16-288.5l64,7.75\r\n\tL480,96L320,48L320,48z"},"children":[]}]};exports.tshirtOutline=tshirtOutline;var tshirt={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M480,96L320,48c-13.988,27.227-30.771,40.223-63.769,40.223C223.723,87.676,205.722,75,192,48L32,96l32,88l64-8l-16,288h288\r\n\tl-16-288l64,8L480,96z"},"children":[]}]};exports.tshirt=tshirt;var umbrella={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M376.2,288c0,0.1,0,0.2,0,0.4C376.2,288.2,376.2,288.1,376.2,288L376.2,288z"},"children":[{"name":"path","attribs":{"d":"M376.2,288c0,0.1,0,0.2,0,0.4C376.2,288.2,376.2,288.1,376.2,288L376.2,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M136.2,288c0,0.1,0,0.2,0,0.4C136.2,288.2,136.2,288.1,136.2,288L136.2,288z"},"children":[{"name":"path","attribs":{"d":"M136.2,288c0,0.1,0,0.2,0,0.4C136.2,288.2,136.2,288.1,136.2,288L136.2,288z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M272,48.8c0-0.3,0-0.5,0-0.8c0-8.8-7.2-16-16-16c-8.8,0-16,7.2-16,16c0,0.2,0,0.5,0,0.7c-116.3,8-208,103.1-208,221.4\r\n\t\tc0,3.6,0.2,14.2,0.4,17.8c2.7-26.3,24.7-51.7,51.7-51.7c28.7,0,51.9,23.1,52.1,51.7h0c0.2-28.6,23.4-51.7,52.1-51.7\r\n\t\tc26.5,0,50.9,21.1,51.7,45.5V416c0,17.9-14.1,32-32,32c-17.1,0-31-14.4-31-32c0-8.8-7.2-16-16-16s-16,7.2-16,16\r\n\t\tc0,35.3,28.3,64,63,64c17.3,0,33.5-6.7,45.5-18.8c11.9-12,18.5-28.1,18.5-45.2l0-135.3c3.3-32.7,23.4-44.4,52.1-44.4\r\n\t\tc28.7,0,51.9,23.1,52.1,51.7h0c0.2-28.6,23.4-51.7,52.1-51.7c26.1,0,47.6,26.7,51.4,51.7c0.1-2.8,0.2-9.1,0.2-11.8\r\n\t\tC480,157.8,388.2,57.3,272,48.8z"},"children":[{"name":"path","attribs":{"d":"M272,48.8c0-0.3,0-0.5,0-0.8c0-8.8-7.2-16-16-16c-8.8,0-16,7.2-16,16c0,0.2,0,0.5,0,0.7c-116.3,8-208,103.1-208,221.4\r\n\t\tc0,3.6,0.2,14.2,0.4,17.8c2.7-26.3,24.7-51.7,51.7-51.7c28.7,0,51.9,23.1,52.1,51.7h0c0.2-28.6,23.4-51.7,52.1-51.7\r\n\t\tc26.5,0,50.9,21.1,51.7,45.5V416c0,17.9-14.1,32-32,32c-17.1,0-31-14.4-31-32c0-8.8-7.2-16-16-16s-16,7.2-16,16\r\n\t\tc0,35.3,28.3,64,63,64c17.3,0,33.5-6.7,45.5-18.8c11.9-12,18.5-28.1,18.5-45.2l0-135.3c3.3-32.7,23.4-44.4,52.1-44.4\r\n\t\tc28.7,0,51.9,23.1,52.1,51.7h0c0.2-28.6,23.4-51.7,52.1-51.7c26.1,0,47.6,26.7,51.4,51.7c0.1-2.8,0.2-9.1,0.2-11.8\r\n\t\tC480,157.8,388.2,57.3,272,48.8z"},"children":[]}]}]}]};exports.umbrella=umbrella;var university={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"256,64 32,176.295 64,197.367 64,400 96,416 96,217.849 255.852,320 387.996,234.549 480,174.727 \t"},"children":[{"name":"polygon","attribs":{"points":"256,64 32,176.295 64,197.367 64,400 96,416 96,217.849 255.852,320 387.996,234.549 480,174.727 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M390.13,256L256,343.768L120.531,256L112,337.529C128,349.984,224,416,256.002,448C288,416,384,350.031,400,337.561\r\n\t\tL390.13,256z"},"children":[{"name":"path","attribs":{"d":"M390.13,256L256,343.768L120.531,256L112,337.529C128,349.984,224,416,256.002,448C288,416,384,350.031,400,337.561\r\n\t\tL390.13,256z"},"children":[]}]}]}]};exports.university=university;var unlocked={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M86.4,480h339.2c12.3,0,22.4-9.9,22.4-22.1V246c0-12.2-10-22-22.4-22H161v-30.9c0-27.3,9.9-61.1,28.1-80.3l0,0l0-0.3\r\n\tC206.7,93.9,231,83,255.9,83h0.1h0.1c24.9,0,49.2,10.9,66.8,29.5l0,0.2l0,0.1c11.3,11.9,19.4,29.3,24,47.3h53.4\r\n\tc-5.9-31.3-19.7-61.8-39.2-82.4C334.9,49.9,297.4,32,256.1,32c-0.1,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-41.3,0-79,17.9-105.3,45.6\r\n\tc-26.4,27.8-42.6,73.9-42.6,115.4V224H89h-2.6C74,224,64,233.9,64,246v211.9C64,470.1,74,480,86.4,480z"},"children":[]}]};exports.unlocked=unlocked;var upload={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M398.1,233.2c0-1.2,0.2-2.4,0.2-3.6c0-65-51.8-117.6-115.7-117.6c-46.1,0-85.7,27.4-104.3,67c-8.1-4.1-17.2-6.5-26.8-6.5\r\n\tc-29.5,0-54.1,21.9-58.8,50.5C57.3,235.2,32,269.1,32,309c0,50.2,40.1,91,89.5,91H224v-80l-48.2,0l80.2-83.7l80.2,83.6l-48.2,0v80\r\n\th110.3c45.2,0,81.7-37.5,81.7-83.4C480,270.6,443.3,233.3,398.1,233.2z"},"children":[]}]};exports.upload=upload;var usb={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,220C144,220,144.1,220.1,144,220L144,220z"},"children":[{"name":"path","attribs":{"d":"M144,220C144,220,144.1,220.1,144,220L144,220z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,128.3c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.1c0,12.1,6.7,22.7,16.6,28.2c1.3,1.5,2.2,4.5,2.2,6\r\n\t\tc0,0.1,0,0.2,0,0.4c-0.8,17.6-3.8,31.9-7.1,41.7c-4.3,12.6-38.2,39.6-51.5,42.2c-5.8,1.2-7.9-0.6-7.9-10.2c0,0,0-138.9,0-140.4\r\n\t\ts0.2-3.5,1.9-5c0,0,0,0,0,0c8.6-5.8,14.3-15.6,14.3-26.8c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.2\r\n\t\tc0,11.3,5.8,21.3,14.6,27c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.4c2.3,1.5,3.3,3,3.3,4.2\r\n\t\tc0,1.3,0,189.3,0,196.3s-1.1,12.3-8.4,11.8s-41.7-23.5-51.4-44.1c-4.5-9.5-6.8-18.8-6.8-28h0c0,0,0-0.4,0-0.5\r\n\t\tc0-3.1,0-11.3,3.2-13.6c7.8-5.9,12.8-15.2,12.8-25.7c0-17.8-14.4-32.2-32.1-32.2S128,174.4,128,192.2c0,11.9,6.5,22.3,16,27.8\r\n\t\tc2.4,1.5,3,2.9,3.8,10.6s3,24.6,9.1,39.9c7.3,18.6,20.9,32.6,39.7,45.2c13.6,9.3,25.3,16.6,32.1,26.4s10.2,13.5,10.2,27\r\n\t\tc0,0,0-0.9,0,0c0,12.8-4,14-9.3,17.8c-14.1,8.7-23.5,24.2-23.5,42c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,27.5,22.3,49.8,49.8,49.8\r\n\t\tc27.5,0,49.8-22.3,49.8-49.8c0-13.3-5.2-25.4-13.7-34.3c-2.9-3.2-6-6-9.6-8.3c-7.5-5.2-10.3-11.5-10.3-18.1v-24.1\r\n\t\tc0-25.1,4.1-41.1,11.1-53.3c7.3-12.7,18.3-22.6,35.4-34.2c18.8-12.6,32.2-26.6,39.6-45.2c5.7-14.4,7.6-31,8.6-50.9\r\n\t\tc0.1-1.8,1.4-5.8,3.3-6.8h0C378.4,149,384,139.3,384,128.3z M160.1,208.3c-8.9,0-16.1-7.3-16.1-16.2s7.2-16.2,16.1-16.2\r\n\t\ts16.1,7.3,16.1,16.2S169,208.3,160.1,208.3z M256,80.3c-8.9,0-16.1-7.3-16.1-16.2S247.1,48,256,48s16.1,7.3,16.1,16.2\r\n\t\tS264.9,80.3,256,80.3z M351.9,144.3c-8.9,0-16.1-7.3-16.1-16.2S343,112,351.9,112s16.1,7.3,16.1,16.2S360.8,144.3,351.9,144.3z"},"children":[{"name":"path","attribs":{"d":"M384,128.3c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.1c0,12.1,6.7,22.7,16.6,28.2c1.3,1.5,2.2,4.5,2.2,6\r\n\t\tc0,0.1,0,0.2,0,0.4c-0.8,17.6-3.8,31.9-7.1,41.7c-4.3,12.6-38.2,39.6-51.5,42.2c-5.8,1.2-7.9-0.6-7.9-10.2c0,0,0-138.9,0-140.4\r\n\t\ts0.2-3.5,1.9-5c0,0,0,0,0,0c8.6-5.8,14.3-15.6,14.3-26.8c0-17.8-14.4-32.2-32.1-32.2c-17.7,0-32.1,14.4-32.1,32.2\r\n\t\tc0,11.3,5.8,21.3,14.6,27c0,0,0.1,0.1,0.1,0.1c0.1,0.1,0.2,0.1,0.4,0.2c0.2,0.1,0.4,0.2,0.6,0.4c2.3,1.5,3.3,3,3.3,4.2\r\n\t\tc0,1.3,0,189.3,0,196.3s-1.1,12.3-8.4,11.8s-41.7-23.5-51.4-44.1c-4.5-9.5-6.8-18.8-6.8-28h0c0,0,0-0.4,0-0.5\r\n\t\tc0-3.1,0-11.3,3.2-13.6c7.8-5.9,12.8-15.2,12.8-25.7c0-17.8-14.4-32.2-32.1-32.2S128,174.4,128,192.2c0,11.9,6.5,22.3,16,27.8\r\n\t\tc2.4,1.5,3,2.9,3.8,10.6s3,24.6,9.1,39.9c7.3,18.6,20.9,32.6,39.7,45.2c13.6,9.3,25.3,16.6,32.1,26.4s10.2,13.5,10.2,27\r\n\t\tc0,0,0-0.9,0,0c0,12.8-4,14-9.3,17.8c-14.1,8.7-23.5,24.2-23.5,42c0,0.1,0,0.3,0,0.4c0,0.2,0,0.5,0,0.7c0,27.5,22.3,49.8,49.8,49.8\r\n\t\tc27.5,0,49.8-22.3,49.8-49.8c0-13.3-5.2-25.4-13.7-34.3c-2.9-3.2-6-6-9.6-8.3c-7.5-5.2-10.3-11.5-10.3-18.1v-24.1\r\n\t\tc0-25.1,4.1-41.1,11.1-53.3c7.3-12.7,18.3-22.6,35.4-34.2c18.8-12.6,32.2-26.6,39.6-45.2c5.7-14.4,7.6-31,8.6-50.9\r\n\t\tc0.1-1.8,1.4-5.8,3.3-6.8h0C378.4,149,384,139.3,384,128.3z M160.1,208.3c-8.9,0-16.1-7.3-16.1-16.2s7.2-16.2,16.1-16.2\r\n\t\ts16.1,7.3,16.1,16.2S169,208.3,160.1,208.3z M256,80.3c-8.9,0-16.1-7.3-16.1-16.2S247.1,48,256,48s16.1,7.3,16.1,16.2\r\n\t\tS264.9,80.3,256,80.3z M351.9,144.3c-8.9,0-16.1-7.3-16.1-16.2S343,112,351.9,112s16.1,7.3,16.1,16.2S360.8,144.3,351.9,144.3z"},"children":[]}]}]}]};exports.usb=usb;var videocamera={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M367,185.3c0-5.1-4-9.3-9.2-9.3H306v-32.2c0-35.2-29.3-63.8-64.9-63.8H63v48h176.1c4.5,0,9.9,5.6,9.9,10.1V176H41.4\r\n\tc-5.2,0-9.4,4.2-9.4,9.3v170.4v55.7v11.3c0,5.1,4.2,9.3,9.4,9.3h316.4c5.2,0,9.2-4.2,9.2-9.3v-64.5l113,34.7v-88.2v-88.2l-113,34.7\r\n\tV185.3z M258.2,341h-10.9H152h-11.9c-19.8,0-35.9-16-35.9-35.8s16.1-35.8,35.9-35.8c19.8,0,35.9,16.2,35.9,36\r\n\tc0,10-4.2,18.6-10.8,25.6h67.9c-6.6-7-10.8-15.6-10.8-25.6c0-19.8,16.1-35.9,35.9-35.9c19.8,0,35.9,15.9,35.9,35.7\r\n\tS278,341,258.2,341z"},"children":[]}]};exports.videocamera=videocamera;var volumeHigh={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"231,407.8 231,104.3 136.1,192 32,192 32,320 136.1,320 \t"},"children":[{"name":"polygon","attribs":{"points":"231,407.8 231,104.3 136.1,192 32,192 32,320 136.1,320 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M287.1,355.7c20.5-27.9,32.8-62.3,32.8-99.7c0-37.4-12.3-71.8-32.8-99.7l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.4\r\n\t\tc0,31.6-10.4,60.8-27.8,84.3L287.1,355.7z"},"children":[{"name":"path","attribs":{"d":"M287.1,355.7c20.5-27.9,32.8-62.3,32.8-99.7c0-37.4-12.3-71.8-32.8-99.7l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.4\r\n\t\tc0,31.6-10.4,60.8-27.8,84.3L287.1,355.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M353.7,401.7c30-40.7,48-91.1,48-145.7s-18-104.9-48-145.7l-20.4,15.3c26.9,36.4,43,81.5,43,130.4\r\n\t\tc0,48.9-16.1,93.9-43,130.3L353.7,401.7z"},"children":[{"name":"path","attribs":{"d":"M353.7,401.7c30-40.7,48-91.1,48-145.7s-18-104.9-48-145.7l-20.4,15.3c26.9,36.4,43,81.5,43,130.4\r\n\t\tc0,48.9-16.1,93.9-43,130.3L353.7,401.7z"},"children":[]}]},{"name":"path","attribs":{"d":"M396.7,79.4c36.4,49.3,57.9,110.5,57.9,176.6c0,66.1-21.5,127.2-57.9,176.6l20.5,15.4c39.4-53.6,62.8-120,62.8-192\r\n\t\tc0-72-23.4-138.4-62.8-192L396.7,79.4z"},"children":[{"name":"path","attribs":{"d":"M396.7,79.4c36.4,49.3,57.9,110.5,57.9,176.6c0,66.1-21.5,127.2-57.9,176.6l20.5,15.4c39.4-53.6,62.8-120,62.8-192\r\n\t\tc0-72-23.4-138.4-62.8-192L396.7,79.4z"},"children":[]}]}]}]};exports.volumeHigh=volumeHigh;var volumeLow={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"311,407.7 311,104.4 216.2,192 112,192 112,320 216.2,320 \t"},"children":[{"name":"polygon","attribs":{"points":"311,407.7 311,104.4 216.2,192 112,192 112,320 216.2,320 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M367.2,355.6c20.5-27.8,32.8-62.3,32.8-99.6c0-37.4-12.3-71.8-32.8-99.6l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.3\r\n\t\tc0,31.6-10.4,60.7-27.8,84.3L367.2,355.6z"},"children":[{"name":"path","attribs":{"d":"M367.2,355.6c20.5-27.8,32.8-62.3,32.8-99.6c0-37.4-12.3-71.8-32.8-99.6l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.3\r\n\t\tc0,31.6-10.4,60.7-27.8,84.3L367.2,355.6z"},"children":[]}]}]}]};exports.volumeLow=volumeLow;var volumeMedium={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"270,407.7 270,104.4 175.3,192 71,192 71,320 175.3,320 \t"},"children":[{"name":"polygon","attribs":{"points":"270,407.7 270,104.4 175.3,192 71,192 71,320 175.3,320 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M326.3,355.6c20.5-27.8,32.8-62.3,32.8-99.6c0-37.4-12.3-71.8-32.8-99.6l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.3\r\n\t\tc0,31.6-10.4,60.7-27.8,84.3L326.3,355.6z"},"children":[{"name":"path","attribs":{"d":"M326.3,355.6c20.5-27.8,32.8-62.3,32.8-99.6c0-37.4-12.3-71.8-32.8-99.6l-20.4,15.3c17.4,23.6,27.8,52.7,27.8,84.3\r\n\t\tc0,31.6-10.4,60.7-27.8,84.3L326.3,355.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M392.8,401.6c30-40.7,48-91,48-145.6s-18-104.9-48-145.6l-20.4,15.3c26.9,36.4,43,81.4,43,130.3c0,48.9-16.1,93.8-43,130.3\r\n\t\tL392.8,401.6z"},"children":[{"name":"path","attribs":{"d":"M392.8,401.6c30-40.7,48-91,48-145.6s-18-104.9-48-145.6l-20.4,15.3c26.9,36.4,43,81.4,43,130.3c0,48.9-16.1,93.8-43,130.3\r\n\t\tL392.8,401.6z"},"children":[]}]}]}]};exports.volumeMedium=volumeMedium;var volumeMute={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"255.9,217 191,217 191,295 255.9,295 303,346.3 303,165.7 \t"},"children":[{"name":"polygon","attribs":{"points":"255.9,217 191,217 191,295 255.9,295 303,346.3 303,165.7 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M364.5,60.1c-0.4-0.2-0.7-0.4-1.1-0.6C331.5,42,294.9,32,256,32C132.3,32,32,132.3,32,256c0,84.3,46.6,157.6,115.4,195.9\r\n\t\tc0.4,0.2,0.7,0.5,1.1,0.7C180.5,470,217.1,480,256,480c123.7,0,224-100.3,224-224C480,171.7,433.4,98.3,364.5,60.1z M393.9,355.4\r\n\t\tL336,297.1v76.7l19.6,19.9c-28,20.3-62.3,32.7-99.5,32.7c-21.6,0-42.3-4.2-61.3-11.5c-6.5-2.5-12.9-5.3-19-8.6\r\n\t\tc-53.6-28.7-90.1-85.2-90.1-150.3c0-37.2,12.4-71.4,32.7-99.4l35.3,35.4h76.7l-73.6-73.8c28-20.2,62.1-32.6,99.4-32.6\r\n\t\tc21.6,0,42.2,4.2,61.3,11.5c6.1,2.4,12.2,5,17.9,8c54.2,28.5,91.3,85.3,91.3,150.8C426.5,293.3,414.2,327.4,393.9,355.4z"},"children":[{"name":"path","attribs":{"d":"M364.5,60.1c-0.4-0.2-0.7-0.4-1.1-0.6C331.5,42,294.9,32,256,32C132.3,32,32,132.3,32,256c0,84.3,46.6,157.6,115.4,195.9\r\n\t\tc0.4,0.2,0.7,0.5,1.1,0.7C180.5,470,217.1,480,256,480c123.7,0,224-100.3,224-224C480,171.7,433.4,98.3,364.5,60.1z M393.9,355.4\r\n\t\tL336,297.1v76.7l19.6,19.9c-28,20.3-62.3,32.7-99.5,32.7c-21.6,0-42.3-4.2-61.3-11.5c-6.5-2.5-12.9-5.3-19-8.6\r\n\t\tc-53.6-28.7-90.1-85.2-90.1-150.3c0-37.2,12.4-71.4,32.7-99.4l35.3,35.4h76.7l-73.6-73.8c28-20.2,62.1-32.6,99.4-32.6\r\n\t\tc21.6,0,42.2,4.2,61.3,11.5c6.1,2.4,12.2,5,17.9,8c54.2,28.5,91.3,85.3,91.3,150.8C426.5,293.3,414.2,327.4,393.9,355.4z"},"children":[]}]}]}]};exports.volumeMute=volumeMute;var wand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"238.059","y":"206.059","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 249.3726 -122.0387)","width":"67.882","height":"67.882"},"children":[{"name":"rect","attribs":{"x":"238.059","y":"206.059","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 249.3726 -122.0387)","width":"67.882","height":"67.882"},"children":[]}]},{"name":"rect","attribs":{"x":"110.058","y":"243.549","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 302.3989 5.9646)","width":"67.884","height":"248.901"},"children":[{"name":"rect","attribs":{"x":"110.058","y":"243.549","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 302.3989 5.9646)","width":"67.884","height":"248.901"},"children":[]}]},{"name":"rect","attribs":{"x":"256","y":"32","width":"32","height":"64"},"children":[{"name":"rect","attribs":{"x":"256","y":"32","width":"32","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"380.451","y":"83.55","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 595.0701 477.5923)","width":"32","height":"63.999"},"children":[{"name":"rect","attribs":{"x":"380.451","y":"83.55","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 595.0701 477.5923)","width":"32","height":"63.999"},"children":[]}]},{"name":"rect","attribs":{"x":"131.549","y":"83.549","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -38.4898 138.1746)","width":"32","height":"64"},"children":[{"name":"rect","attribs":{"x":"131.549","y":"83.549","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -38.4898 138.1746)","width":"32","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"380.451","y":"332.451","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -141.5881 387.0668)","width":"32","height":"64"},"children":[{"name":"rect","attribs":{"x":"380.451","y":"332.451","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -141.5881 387.0668)","width":"32","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"416","y":"224","width":"64","height":"32"},"children":[{"name":"rect","attribs":{"x":"416","y":"224","width":"64","height":"32"},"children":[]}]}]}]};exports.wand=wand;var waterdrop={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M271,38.6c-0.3-0.4-0.7-0.7-0.9-1c0,0-0.1-0.1-0.1-0.1c-3.6-3.4-8.5-5.5-13.9-5.5c-5.5,0-10.4,2.1-13.9,5.5\r\n\tc0,0-0.1,0.1-0.1,0.1c-0.3,0.3-0.6,0.6-0.9,1c-6.1,6.3-13.8,14.4-22.4,24.1c-17.4,19.7-38.6,46-58.5,76.8\r\n\tc-33.4,51.8-62.9,116.1-64.1,183.1c0,1.3-0.1,2.7-0.1,4c0,19.7,3.9,38.5,10.9,55.8c4.1,10,9.2,19.4,15.2,28.2\r\n\tC150.7,452.4,200,480,256,480c88.4,0,160-68.7,160-153.4C416,198.7,310.8,79.2,271,38.6z M256,424c-15.8,0-30.7-3.7-43.9-10.1\r\n\tc65.9-14.4,118.4-64.7,135.8-129.5c5.2,12.1,8.2,25.5,8.2,39.6C356,379.2,311.2,424,256,424z"},"children":[]}]};exports.waterdrop=waterdrop;var wifi={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.1,96L256.1,96c-79.9,0-155.7,29.9-213.9,84.1L32,189.6l9.9,9.8l32.3,32l9.3,9.2l9.6-8.8\r\n\t\tc44.5-40.9,102.3-63.5,162.8-63.5c60.5,0,118.4,22.6,162.8,63.5l9.6,8.8l9.3-9.2l32.3-32l9.9-9.8l-10.2-9.5\r\n\t\tC411.6,125.9,335.7,96,256.1,96z"},"children":[{"name":"path","attribs":{"d":"M256.1,96L256.1,96c-79.9,0-155.7,29.9-213.9,84.1L32,189.6l9.9,9.8l32.3,32l9.3,9.2l9.6-8.8\r\n\t\tc44.5-40.9,102.3-63.5,162.8-63.5c60.5,0,118.4,22.6,162.8,63.5l9.6,8.8l9.3-9.2l32.3-32l9.9-9.8l-10.2-9.5\r\n\t\tC411.6,125.9,335.7,96,256.1,96z"},"children":[]}]},{"name":"path","attribs":{"d":"M397.4,256.4c-38.8-35.1-88.9-54.4-141.1-54.4h-0.1h-0.3h-8.5l-0.1,0.2c-49.2,2-96,21.1-132.6,54.2l-10.5,9.5l10.1,10\r\n\t\tl32.7,32.4l9.1,9l9.6-8.4c25.3-22.2,57.4-34.5,90.3-34.5c33.1,0,65.2,12.3,90.5,34.5l9.6,8.4l9.1-9l32.7-32.4l10.1-10L397.4,256.4z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M397.4,256.4c-38.8-35.1-88.9-54.4-141.1-54.4h-0.1h-0.3h-8.5l-0.1,0.2c-49.2,2-96,21.1-132.6,54.2l-10.5,9.5l10.1,10\r\n\t\tl32.7,32.4l9.1,9l9.6-8.4c25.3-22.2,57.4-34.5,90.3-34.5c33.1,0,65.2,12.3,90.5,34.5l9.6,8.4l9.1-9l32.7-32.4l10.1-10L397.4,256.4z\r\n\t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M256.2,416l9.6-9.5l52.8-52.2l10.6-10.5l-11.6-9.5c-15.4-11.4-32.4-20-61.5-20c-29,0-44.9,9.4-61.5,20l-11.5,9.5l10.6,10.5\r\n\t\tl52.8,52.2L256.2,416z"},"children":[{"name":"path","attribs":{"d":"M256.2,416l9.6-9.5l52.8-52.2l10.6-10.5l-11.6-9.5c-15.4-11.4-32.4-20-61.5-20c-29,0-44.9,9.4-61.5,20l-11.5,9.5l10.6,10.5\r\n\t\tl52.8,52.2L256.2,416z"},"children":[]}]}]}]};exports.wifi=wifi;var wineglass={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M294.9,295.4c11-4.1,18-6.9,26.2-11.7c12-6.9,22.8-15.8,31.9-26.1c20.4-22.9,31-51.1,31-86.1c0-49.9-3.7-101.1-8.1-114.7\r\n\t\tC371.5,43,362.4,32,345.2,32H166.7c-17.1,0-26.2,11.1-30.6,24.6c-4.4,13.5-8.1,64.9-8.1,114.8c0,35.1,10.6,63.2,30.9,86.1\r\n\t\tc9.1,10.3,19.9,19.1,31.8,26c8.2,4.8,15.1,7.8,26,11.7s22.3,7.5,22.3,31.8v94.2c0,10.7-2.9,19-11.1,24.8c-2.8,2.1-6.3,4.3-14.3,6.5\r\n\t\tc-31.5,8.6-46.9,15.6-49.2,17.2c-2,1.4-4.5,3.6-4.5,7.1c0,0,13.8,3.1,96.2,3.1c82.4,0,96-3.1,96-3.1c0-3.5-2.5-5.7-4.6-7.1\r\n\t\tc-2.3-1.6-17.8-8.6-49.4-17.2c-8-2.2-12.2-4.4-15.1-6.5C275,440.3,271,432,271,421.3v-94.2C271,303.1,283.9,299.4,294.9,295.4z\r\n\t\t M255.9,270.3c-25.4,0-48.5-10-65.5-26.3c-2.7-2.4-5.2-5-7.6-7.7c-15.6-17.5-22.4-36.7-23.1-64.8C159,143.3,159.6,99,167,64h177\r\n\t\tc6.3,24,9.1,76.8,7.7,107.2c-1.4,30.5-7.2,47.3-22.8,64.9c-2,2.2-3.9,4.3-6.1,6.4C305.7,259.7,282,270.3,255.9,270.3z"},"children":[{"name":"path","attribs":{"d":"M294.9,295.4c11-4.1,18-6.9,26.2-11.7c12-6.9,22.8-15.8,31.9-26.1c20.4-22.9,31-51.1,31-86.1c0-49.9-3.7-101.1-8.1-114.7\r\n\t\tC371.5,43,362.4,32,345.2,32H166.7c-17.1,0-26.2,11.1-30.6,24.6c-4.4,13.5-8.1,64.9-8.1,114.8c0,35.1,10.6,63.2,30.9,86.1\r\n\t\tc9.1,10.3,19.9,19.1,31.8,26c8.2,4.8,15.1,7.8,26,11.7s22.3,7.5,22.3,31.8v94.2c0,10.7-2.9,19-11.1,24.8c-2.8,2.1-6.3,4.3-14.3,6.5\r\n\t\tc-31.5,8.6-46.9,15.6-49.2,17.2c-2,1.4-4.5,3.6-4.5,7.1c0,0,13.8,3.1,96.2,3.1c82.4,0,96-3.1,96-3.1c0-3.5-2.5-5.7-4.6-7.1\r\n\t\tc-2.3-1.6-17.8-8.6-49.4-17.2c-8-2.2-12.2-4.4-15.1-6.5C275,440.3,271,432,271,421.3v-94.2C271,303.1,283.9,299.4,294.9,295.4z\r\n\t\t M255.9,270.3c-25.4,0-48.5-10-65.5-26.3c-2.7-2.4-5.2-5-7.6-7.7c-15.6-17.5-22.4-36.7-23.1-64.8C159,143.3,159.6,99,167,64h177\r\n\t\tc6.3,24,9.1,76.8,7.7,107.2c-1.4,30.5-7.2,47.3-22.8,64.9c-2,2.2-3.9,4.3-6.1,6.4C305.7,259.7,282,270.3,255.9,270.3z"},"children":[]}]},{"name":"path","attribs":{"d":"M336.2,170.6c0-7.5-0.1-31.9-1.3-52.6c-0.5-8.4-1.2-16-2.1-22h-153c-0.9,3-1.8,11.6-2.5,22c-1.3,18.9-2.1,43.9-1.5,52.9\r\n\t\tc0.9,13.8,1.5,20.6,4.5,29.4c3.1,9.1,8,17.3,14.6,24.7c2,2.3,4.1,4.4,6.4,6.4c14.2,13.6,33.5,22,54.7,22c21.8,0,41.5-8.8,55.9-23.1\r\n\t\tc1.8-1.7,3.5-3.5,5.2-5.3c6.6-7.4,11.4-15.5,14.5-24.6C334.7,191.4,336.2,181.1,336.2,170.6z M320,179c0,5-3.9,8.1-8.3,8.1\r\n\t\tc-1.6,0-3-0.5-4.3-1.3c-2.2-1.4-3.5-3.9-3.5-6.7v-26c0-4.4,3.6-8,8-8s8,3.6,8,8V179z M318.9,131.8c-1.2,1.8-3,3-5.1,3.5\r\n\t\tc-2.1,0.4-4.3,0-6-1.1c-1.8-1.2-3-3-3.5-5.1c-0.4-2.1,0-4.3,1.1-6c1.2-1.8,3-3,5.1-3.5c2.1-0.4,4.3,0,6,1.1c1.8,1.2,3,3,3.5,5.1\r\n\t\tC320.5,127.8,320.1,130,318.9,131.8z"},"children":[{"name":"path","attribs":{"d":"M336.2,170.6c0-7.5-0.1-31.9-1.3-52.6c-0.5-8.4-1.2-16-2.1-22h-153c-0.9,3-1.8,11.6-2.5,22c-1.3,18.9-2.1,43.9-1.5,52.9\r\n\t\tc0.9,13.8,1.5,20.6,4.5,29.4c3.1,9.1,8,17.3,14.6,24.7c2,2.3,4.1,4.4,6.4,6.4c14.2,13.6,33.5,22,54.7,22c21.8,0,41.5-8.8,55.9-23.1\r\n\t\tc1.8-1.7,3.5-3.5,5.2-5.3c6.6-7.4,11.4-15.5,14.5-24.6C334.7,191.4,336.2,181.1,336.2,170.6z M320,179c0,5-3.9,8.1-8.3,8.1\r\n\t\tc-1.6,0-3-0.5-4.3-1.3c-2.2-1.4-3.5-3.9-3.5-6.7v-26c0-4.4,3.6-8,8-8s8,3.6,8,8V179z M318.9,131.8c-1.2,1.8-3,3-5.1,3.5\r\n\t\tc-2.1,0.4-4.3,0-6-1.1c-1.8-1.2-3-3-3.5-5.1c-0.4-2.1,0-4.3,1.1-6c1.2-1.8,3-3,5.1-3.5c2.1-0.4,4.3,0,6,1.1c1.8,1.2,3,3,3.5,5.1\r\n\t\tC320.5,127.8,320.1,130,318.9,131.8z"},"children":[]}]}]}]};exports.wineglass=wineglass;var woman={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M190.4,148.6L161,252.9c-6.3,22.8,20.7,31.7,27.3,10.3l26.3-96.2h7.4l-45.2,169H219v127c0,23,32,23,32,0V336h10v127\r\n\t\tc0,23,31,23,31,0V336h43.4l-46.2-169h8.4l26.3,96.2c6.5,21.9,33.3,12.5,27.3-10.2l-29.4-104.4c-4-11.8-18.2-32.6-42-33.6h-47.3\r\n\t\tC207.9,116,193.8,136.6,190.4,148.6z"},"children":[{"name":"path","attribs":{"d":"M190.4,148.6L161,252.9c-6.3,22.8,20.7,31.7,27.3,10.3l26.3-96.2h7.4l-45.2,169H219v127c0,23,32,23,32,0V336h10v127\r\n\t\tc0,23,31,23,31,0V336h43.4l-46.2-169h8.4l26.3,96.2c6.5,21.9,33.3,12.5,27.3-10.2l-29.4-104.4c-4-11.8-18.2-32.6-42-33.6h-47.3\r\n\t\tC207.9,116,193.8,136.6,190.4,148.6z"},"children":[]}]},{"name":"path","attribs":{"d":"M292.6,69.2c0-20.6-16.4-37.3-36.6-37.3c-20.2,0-36.6,16.7-36.6,37.3c0,20.6,16.4,37.3,36.6,37.3\r\n\t\tC276.2,106.5,292.6,89.8,292.6,69.2z"},"children":[{"name":"path","attribs":{"d":"M292.6,69.2c0-20.6-16.4-37.3-36.6-37.3c-20.2,0-36.6,16.7-36.6,37.3c0,20.6,16.4,37.3,36.6,37.3\r\n\t\tC276.2,106.5,292.6,89.8,292.6,69.2z"},"children":[]}]}]}]};exports.woman=woman;var wrench={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M461.9,114.9l-56.5,56.7l-55.1-10l-9.9-55.1l56.5-56.7c-12.7-12.7-30.8-18.5-44.2-17.8c-13.5,0.7-42.3,8.3-64.6,32\r\n\tc-21.6,22.8-44.3,65.3-24.2,112.5c2.4,5.7,5.1,13.2-2.9,21.2c-8.1,8-215,202.8-215,202.8c-19.4,16.7-18,47.6-0.1,65.6\r\n\tc18.2,17.9,48.9,19,65.6-0.3c0,0,193.2-205.8,202.7-215.1c8.5-8.3,16.1-5.5,21.2-2.9c35.6,18.4,86.3,2.4,112.6-23.9\r\n\tc26.3-26.3,31.1-51.7,31.9-64.7C480.7,146.3,476.2,129.2,461.9,114.9z M91.3,443.2c-6.3,6.2-16.5,6.2-22.7,0\r\n\tc-6.2-6.3-6.2-16.5,0-22.7c6.3-6.2,16.5-6.2,22.7,0C97.5,426.8,97.5,437,91.3,443.2z"},"children":[]}]};exports.wrench=wrench;var xbox={"viewBox":"0 0 512 512","children":[{"name":"style","attribs":{"type":"text/css"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"class":"st0","d":"M126.8,248.3c39.7-58.6,77.9-92.8,77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-0.8C61.7,128.4,32,188.7,32,256\r\n\t\tc0,50.7,16.9,97.5,45.2,135C77.2,386.6,77.8,320.7,126.8,248.3z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M126.8,248.3c39.7-58.6,77.9-92.8,77.9-92.8s-42.1-48.9-92.8-67.4l-3.3-0.8C61.7,128.4,32,188.7,32,256\r\n\t\tc0,50.7,16.9,97.5,45.2,135C77.2,386.6,77.8,320.7,126.8,248.3z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M480,256c0-67.3-29.7-127.6-76.6-168.7l-3.2,0.9c-50.7,18.5-92.9,67.4-92.9,67.4s38.2,34.2,77.9,92.8\r\n\t\tc49,72.4,49.6,138.3,49.5,142.7C463.2,353.5,480,306.7,480,256z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M480,256c0-67.3-29.7-127.6-76.6-168.7l-3.2,0.9c-50.7,18.5-92.9,67.4-92.9,67.4s38.2,34.2,77.9,92.8\r\n\t\tc49,72.4,49.6,138.3,49.5,142.7C463.2,353.5,480,306.7,480,256z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M201.2,80.9c29.3,13.1,54.6,34.6,54.6,34.6s25.5-21.4,54.8-34.6c36.8-16.5,64.9-11.3,72.3-9.5\r\n\t\tC346.8,46.6,303.1,32,256,32c-47.1,0-90.8,14.6-126.9,39.4C136.3,69.6,164.3,64.3,201.2,80.9z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M201.2,80.9c29.3,13.1,54.6,34.6,54.6,34.6s25.5-21.4,54.8-34.6c36.8-16.5,64.9-11.3,72.3-9.5\r\n\t\tC346.8,46.6,303.1,32,256,32c-47.1,0-90.8,14.6-126.9,39.4C136.3,69.6,164.3,64.3,201.2,80.9z"},"children":[]}]},{"name":"path","attribs":{"class":"st0","d":"M358.7,292.9C312.4,236,255.8,199,255.8,199s-56.3,37-102.7,93.9c-39.8,48.9-54.6,84.8-62.6,107.8l-1.3,4.8\r\n\t\tc41,45.7,100.5,74.5,166.8,74.5c66.3,0,125.8-28.8,166.8-74.5l-1.4-4.8C413.4,377.7,398.5,341.8,358.7,292.9z"},"children":[{"name":"path","attribs":{"class":"st0","d":"M358.7,292.9C312.4,236,255.8,199,255.8,199s-56.3,37-102.7,93.9c-39.8,48.9-54.6,84.8-62.6,107.8l-1.3,4.8\r\n\t\tc41,45.7,100.5,74.5,166.8,74.5c66.3,0,125.8-28.8,166.8-74.5l-1.4-4.8C413.4,377.7,398.5,341.8,358.7,292.9z"},"children":[]}]}]}]};exports.xbox=xbox;

/***/ }),
/* 1409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.arrows_slim_right_dashed=exports.arrows_slim_right=exports.arrows_slim_left_dashed=exports.arrows_slim_left=exports.arrows_slim_down_dashed=exports.arrows_slim_down=exports.arrows_slide_up2=exports.arrows_slide_up1=exports.arrows_slide_right2=exports.arrows_slide_right1=exports.arrows_slide_left2=exports.arrows_slide_left1=exports.arrows_slide_down2=exports.arrows_slide_down1=exports.arrows_sign_up=exports.arrows_sign_right=exports.arrows_sign_left=exports.arrows_sign_down=exports.arrows_shrink_vertical2=exports.arrows_shrink_vertical1=exports.arrows_shrink_horizontal1=exports.arrows_shrink_horizonal2=exports.arrows_shrink_diagonal2=exports.arrows_shrink_diagonal1=exports.arrows_shrink=exports.arrows_rotate_dashed=exports.arrows_rotate_anti_dashed=exports.arrows_rotate_anti=exports.arrows_rotate=exports.arrows_right=exports.arrows_remove=exports.arrows_question=exports.arrows_plus=exports.arrows_move_top=exports.arrows_move_right=exports.arrows_move_left=exports.arrows_move_bottom=exports.arrows_move2=exports.arrows_move=exports.arrows_minus=exports.arrows_left=exports.arrows_keyboard_up=exports.arrows_keyboard_tab=exports.arrows_keyboard_shift=exports.arrows_keyboard_right=exports.arrows_keyboard_return=exports.arrows_keyboard_left=exports.arrows_keyboard_delete=exports.arrows_keyboard_alt=exports.arrows_info=exports.arrows_horizontal=exports.arrows_hamburger1=exports.arrows_glide_vertical=exports.arrows_glide_horizontal=exports.arrows_glide=exports.arrows_fit_vertical=exports.arrows_fit_horizontal=exports.arrows_expand_vertical1=exports.arrows_expand_horizontal1=exports.arrows_expand_diagonal1=exports.arrows_expand=exports.arrows_exclamation=exports.arrows_drag_vert=exports.arrows_drag_up_dashed=exports.arrows_drag_up=exports.arrows_drag_right_dashed=exports.arrows_drag_right=exports.arrows_drag_left_dashed=exports.arrows_drag_left=exports.arrows_drag_horiz=exports.arrows_drag_down_dashed=exports.arrows_drag_down=exports.arrows_downright=exports.arrows_downleft=exports.arrows_down=exports.arrows_diagonal2=exports.arrows_diagonal=exports.arrows_deny=exports.arrows_compress=exports.arrows_clockwise_dashed=exports.arrows_clockwise=exports.arrows_circle_upright=exports.arrows_circle_upleft=exports.arrows_circle_up=exports.arrows_circle_right=exports.arrows_circle_remove=exports.arrows_circle_plus=exports.arrows_circle_minus=exports.arrows_circle_left=exports.arrows_circle_downright=exports.arrows_circle_downleft=exports.arrows_circle_down=exports.arrows_circle_check=exports.arrows_check=exports.arrows_button_up=exports.arrows_button_on=exports.arrows_button_off=exports.arrows_button_down=exports.arrows_anticlockwise_dashed=exports.arrows_anticlockwise=void 0;exports.basic_map=exports.basic_male=exports.basic_mail_open_text=exports.basic_mail_open=exports.basic_mail_multiple=exports.basic_mail=exports.basic_magnifier_plus=exports.basic_magnifier_minus=exports.basic_magnifier=exports.basic_magic_mouse=exports.basic_lock_open=exports.basic_lock=exports.basic_link=exports.basic_lightbulb=exports.basic_life_buoy=exports.basic_laptop=exports.basic_keyboard=exports.basic_key=exports.basic_joypad=exports.basic_ipod=exports.basic_info=exports.basic_home=exports.basic_helm=exports.basic_heart_broken=exports.basic_heart=exports.basic_headset=exports.basic_hammer=exports.basic_gunsight=exports.basic_globe=exports.basic_gear=exports.basic_folder_multiple=exports.basic_folder=exports.basic_floppydisk=exports.basic_flag2=exports.basic_flag1=exports.basic_female=exports.basic_eye_closed=exports.basic_eye=exports.basic_exclamation=exports.basic_download=exports.basic_display=exports.basic_diamonds=exports.basic_cup=exports.basic_compass=exports.basic_clubs=exports.basic_cloud=exports.basic_clockwise=exports.basic_clock=exports.basic_clessidre=exports.basic_chronometer=exports.basic_case=exports.basic_cards_hearts=exports.basic_cards_diamonds=exports.basic_calendar=exports.basic_calculator=exports.basic_bookmark=exports.basic_book_pencil=exports.basic_book_pen=exports.basic_book=exports.basic_bolt=exports.basic_battery_half=exports.basic_battery_full=exports.basic_battery_empty=exports.basic_battery_charge=exports.basic_ban=exports.basic_archive_full=exports.basic_archive=exports.basic_anticlockwise=exports.basic_anchor=exports.basic_alarm=exports.basic_accelerator=exports.arrows_vertical=exports.arrows_upright=exports.arrows_up_double=exports.arrows_up=exports.arrows_switch_vertical=exports.arrows_switch_horizontal=exports.arrows_stretch_vertical2=exports.arrows_stretch_vertical1=exports.arrows_stretch_horizontal2=exports.arrows_stretch_horizontal1=exports.arrows_stretch_diagonal4=exports.arrows_stretch_diagonal3=exports.arrows_stretch_diagonal2=exports.arrows_stretch_diagonal1=exports.arrows_squares=exports.arrows_square_upright=exports.arrows_square_upleft=exports.arrows_square_up=exports.arrows_square_right=exports.arrows_square_remove=exports.arrows_square_plus=exports.arrows_square_minus=exports.arrows_square_left=exports.arrows_square_downright=exports.arrows_square_downleft=exports.arrows_square_down=exports.arrows_square_check=exports.arrows_slim_up_dashed=exports.arrows_slim_up=void 0;exports.basic_elaboration_cloud_download=exports.basic_elaboration_cloud_check=exports.basic_elaboration_calendar_upload=exports.basic_elaboration_calendar_star=exports.basic_elaboration_calendar_search=exports.basic_elaboration_calendar_remove=exports.basic_elaboration_calendar_refresh=exports.basic_elaboration_calendar_previous=exports.basic_elaboration_calendar_plus=exports.basic_elaboration_calendar_pencil=exports.basic_elaboration_calendar_noaccess=exports.basic_elaboration_calendar_next=exports.basic_elaboration_calendar_minus=exports.basic_elaboration_calendar_heart=exports.basic_elaboration_calendar_flagged=exports.basic_elaboration_calendar_empty=exports.basic_elaboration_calendar_download=exports.basic_elaboration_calendar_cloud=exports.basic_elaboration_calendar_check=exports.basic_elaboration_browser_upload=exports.basic_elaboration_browser_star=exports.basic_elaboration_browser_search=exports.basic_elaboration_browser_remove=exports.basic_elaboration_browser_refresh=exports.basic_elaboration_browser_plus=exports.basic_elaboration_browser_minus=exports.basic_elaboration_browser_download=exports.basic_elaboration_browser_check=exports.basic_elaboration_briefcase_upload=exports.basic_elaboration_briefcase_star=exports.basic_elaboration_briefcase_search=exports.basic_elaboration_briefcase_remove=exports.basic_elaboration_briefcase_refresh=exports.basic_elaboration_briefcase_plus=exports.basic_elaboration_briefcase_minus=exports.basic_elaboration_briefcase_flagged=exports.basic_elaboration_briefcase_download=exports.basic_elaboration_briefcase_check=exports.basic_elaboration_bookmark_remove=exports.basic_elaboration_bookmark_plus=exports.basic_elaboration_bookmark_minus=exports.basic_elaboration_bookmark_checck=exports.basic_world=exports.basic_webpage_txt=exports.basic_webpage_multiple=exports.basic_webpage_img_txt=exports.basic_webpage=exports.basic_watch=exports.basic_video=exports.basic_usb=exports.basic_upload=exports.basic_trashcan_remove=exports.basic_trashcan_refresh=exports.basic_trashcan_full=exports.basic_trashcan=exports.basic_todolist_pencil=exports.basic_todolist_pen=exports.basic_todo_txt=exports.basic_todo_pencil=exports.basic_todo=exports.basic_target=exports.basic_tablet=exports.basic_star=exports.basic_spread_text_bookmark=exports.basic_spread_text=exports.basic_spread_bookmark=exports.basic_spread=exports.basic_spades=exports.basic_smartphone=exports.basic_signs=exports.basic_sheet_pencil=exports.basic_sheet_pen=exports.basic_sheet=exports.basic_share=exports.basic_settings=exports.basic_server_upload=exports.basic_server_download=exports.basic_server_cloud=exports.basic_server2=exports.basic_server=exports.basic_rss=exports.basic_question=exports.basic_printer=exports.basic_postcard_multiple=exports.basic_postcard=exports.basic_pin2=exports.basic_pin1=exports.basic_picture_multiple=exports.basic_picture=exports.basic_photo=exports.basic_pencil_ruler=exports.basic_paperplane=exports.basic_notebook_pencil=exports.basic_notebook_pen=exports.basic_notebook=exports.basic_mouse=exports.basic_mixer2=exports.basic_message_txt=exports.basic_message_multiple=exports.basic_message=void 0;exports.basic_elaboration_todolist_remove=exports.basic_elaboration_todolist_refresh=exports.basic_elaboration_todolist_plus=exports.basic_elaboration_todolist_pencil=exports.basic_elaboration_todolist_noaccess=exports.basic_elaboration_todolist_minus=exports.basic_elaboration_todolist_flagged=exports.basic_elaboration_todolist_download=exports.basic_elaboration_todolist_cloud=exports.basic_elaboration_todolist_check=exports.basic_elaboration_todolist_2=exports.basic_elaboration_tablet_search=exports.basic_elaboration_tablet_refresh=exports.basic_elaboration_tablet_picture=exports.basic_elaboration_tablet_pencil=exports.basic_elaboration_tablet_note=exports.basic_elaboration_tablet_noaccess=exports.basic_elaboration_tablet_heart=exports.basic_elaboration_tablet_cloud=exports.basic_elaboration_smartphone_search=exports.basic_elaboration_smartphone_refresh=exports.basic_elaboration_smartphone_picture=exports.basic_elaboration_smartphone_pencil=exports.basic_elaboration_smartphone_note=exports.basic_elaboration_smartphone_noaccess=exports.basic_elaboration_smartphone_heart=exports.basic_elaboration_smartphone_cloud=exports.basic_elaboration_message_sad=exports.basic_elaboration_message_remove=exports.basic_elaboration_message_refresh=exports.basic_elaboration_message_plus=exports.basic_elaboration_message_note=exports.basic_elaboration_message_minus=exports.basic_elaboration_message_heart=exports.basic_elaboration_message_happy=exports.basic_elaboration_message_dots=exports.basic_elaboration_message_check=exports.basic_elaboration_mail_upload=exports.basic_elaboration_mail_star=exports.basic_elaboration_mail_search=exports.basic_elaboration_mail_remove=exports.basic_elaboration_mail_refresh=exports.basic_elaboration_mail_previous=exports.basic_elaboration_mail_picture=exports.basic_elaboration_mail_pencil=exports.basic_elaboration_mail_note=exports.basic_elaboration_mail_noaccess=exports.basic_elaboration_mail_next=exports.basic_elaboration_mail_heart=exports.basic_elaboration_mail_flagged=exports.basic_elaboration_mail_download=exports.basic_elaboration_mail_document=exports.basic_elaboration_mail_cloud=exports.basic_elaboration_mail_check=exports.basic_elaboration_folder_upload=exports.basic_elaboration_folder_star=exports.basic_elaboration_folder_search=exports.basic_elaboration_folder_remove=exports.basic_elaboration_folder_refresh=exports.basic_elaboration_folder_previous=exports.basic_elaboration_folder_plus=exports.basic_elaboration_folder_picture=exports.basic_elaboration_folder_pencil=exports.basic_elaboration_folder_note=exports.basic_elaboration_folder_noaccess=exports.basic_elaboration_folder_next=exports.basic_elaboration_folder_minus=exports.basic_elaboration_folder_heart=exports.basic_elaboration_folder_graph=exports.basic_elaboration_folder_flagged=exports.basic_elaboration_folder_download=exports.basic_elaboration_folder_document=exports.basic_elaboration_folder_cloud=exports.basic_elaboration_folder_check=exports.basic_elaboration_document_upload=exports.basic_elaboration_document_star=exports.basic_elaboration_document_search=exports.basic_elaboration_document_remove=exports.basic_elaboration_document_refresh=exports.basic_elaboration_document_previous=exports.basic_elaboration_document_plus=exports.basic_elaboration_document_picture=exports.basic_elaboration_document_pencil=exports.basic_elaboration_document_note=exports.basic_elaboration_document_noaccess=exports.basic_elaboration_document_next=exports.basic_elaboration_document_minus=exports.basic_elaboration_document_heart=exports.basic_elaboration_document_graph=exports.basic_elaboration_document_flagged=exports.basic_elaboration_document_download=exports.basic_elaboration_document_cloud=exports.basic_elaboration_document_check=exports.basic_elaboration_cloud_upload=exports.basic_elaboration_cloud_search=exports.basic_elaboration_cloud_remove=exports.basic_elaboration_cloud_refresh=exports.basic_elaboration_cloud_plus=exports.basic_elaboration_cloud_noaccess=exports.basic_elaboration_cloud_minus=void 0;exports.music_microphone_old=exports.music_microphone=exports.music_loudspeaker=exports.music_ipod=exports.music_headphones=exports.music_fastforward_button=exports.music_end_button=exports.music_eject_button=exports.music_diapason=exports.music_cd=exports.music_bell=exports.music_beginning_button=exports.ecommerce_yen2=exports.ecommerce_yen=exports.ecommerce_won=exports.ecommerce_wallet=exports.ecommerce_tugriks=exports.ecommerce_ticket=exports.ecommerce_sales=exports.ecommerce_sale=exports.ecommerce_safe=exports.ecommerce_rupee=exports.ecommerce_rublo=exports.ecommerce_recept_colon=exports.ecommerce_receipt_yen2=exports.ecommerce_receipt_yen=exports.ecommerce_receipt_won=exports.ecommerce_receipt_tugrik=exports.ecommerce_receipt_rupee=exports.ecommerce_receipt_rublo=exports.ecommerce_receipt_pound=exports.ecommerce_receipt_pesos=exports.ecommerce_receipt_naira=exports.ecommerce_receipt_lira=exports.ecommerce_receipt_kips=exports.ecommerce_receipt_guarani=exports.ecommerce_receipt_franc=exports.ecommerce_receipt_euro=exports.ecommerce_receipt_dollar=exports.ecommerce_receipt_cent=exports.ecommerce_receipt_bath=exports.ecommerce_receipt=exports.ecommerce_pound=exports.ecommerce_pesos=exports.ecommerce_naira=exports.ecommerce_money=exports.ecommerce_megaphone=exports.ecommerce_lira=exports.ecommerce_kips=exports.ecommerce_guarani=exports.ecommerce_graph_increase=exports.ecommerce_graph_decrease=exports.ecommerce_graph3=exports.ecommerce_graph2=exports.ecommerce_graph1=exports.ecommerce_gift=exports.ecommerce_franc=exports.ecommerce_euro=exports.ecommerce_dollar=exports.ecommerce_diamond=exports.ecommerce_creditcard=exports.ecommerce_colon=exports.ecommerce_cent=exports.ecommerce_cart_upload=exports.ecommerce_cart_search=exports.ecommerce_cart_remove=exports.ecommerce_cart_refresh=exports.ecommerce_cart_plus=exports.ecommerce_cart_minus=exports.ecommerce_cart_download=exports.ecommerce_cart_content=exports.ecommerce_cart_cloud=exports.ecommerce_cart_check=exports.ecommerce_cart=exports.ecommerce_bath=exports.ecommerce_basket_upload=exports.ecommerce_basket_search=exports.ecommerce_basket_remove=exports.ecommerce_basket_refresh=exports.ecommerce_basket_plus=exports.ecommerce_basket_minus=exports.ecommerce_basket_download=exports.ecommerce_basket_cloud=exports.ecommerce_basket_check=exports.ecommerce_basket=exports.ecommerce_banknotes=exports.ecommerce_banknote=exports.ecommerce_bag_upload=exports.ecommerce_bag_search=exports.ecommerce_bag_remove=exports.ecommerce_bag_refresh=exports.ecommerce_bag_plus=exports.ecommerce_bag_minus=exports.ecommerce_bag_download=exports.ecommerce_bag_cloud=exports.ecommerce_bag_check=exports.ecommerce_bag=exports.basic_elaboration_todolist_upload=exports.basic_elaboration_todolist_star=exports.basic_elaboration_todolist_search=void 0;exports.software_selection_polygon=exports.software_selection_oval=exports.software_scale_reduce=exports.software_scale_expand=exports.software_remove_vectorpoint=exports.software_reflect_vertical=exports.software_reflect_horizontal=exports.software_polygonallasso=exports.software_pencil=exports.software_pen_remove=exports.software_pen_add=exports.software_pen=exports.software_pathfinder_unite=exports.software_pathfinder_subtract=exports.software_pathfinder_intersect=exports.software_pathfinder_exclude=exports.software_paragraph_space_before=exports.software_paragraph_space_after=exports.software_paragraph_justify_right=exports.software_paragraph_justify_left=exports.software_paragraph_justify_center=exports.software_paragraph_justify_all=exports.software_paragraph_center=exports.software_paragraph_align_right=exports.software_paragraph_align_left=exports.software_paragraph=exports.software_paintroller=exports.software_paintbucket=exports.software_paintbrush=exports.software_pages=exports.software_magnete=exports.software_layout_sidebar_right=exports.software_layout_sidebar_left=exports.software_layout_header_sideright=exports.software_layout_header_sideleft=exports.software_layout_header_complex4=exports.software_layout_header_complex3=exports.software_layout_header_complex2=exports.software_layout_header_complex=exports.software_layout_header_4columns=exports.software_layout_header_4boxes=exports.software_layout_header_3columns=exports.software_layout_header_2columns=exports.software_layout_header=exports.software_layout_4lines=exports.software_layout_4columns=exports.software_layout_4boxes=exports.software_layout_3columns=exports.software_layout_2columns=exports.software_layout=exports.software_layers2=exports.software_layers1=exports.software_lasso=exports.software_indent_right=exports.software_indent_left=exports.software_indent_firstline=exports.software_horizontal_distribute_right=exports.software_horizontal_distribute_left=exports.software_horizontal_distribute_center=exports.software_horizontal_align_right=exports.software_horizontal_align_left=exports.software_horizontal_align_center=exports.software_font_vertical_scale=exports.software_font_underline=exports.software_font_tracking=exports.software_font_strikethrough=exports.software_font_smallcaps=exports.software_font_smallcapital=exports.software_font_size=exports.software_font_leading=exports.software_font_kerning=exports.software_font_horizontal_scale=exports.software_font_baseline_shift=exports.software_font_allcaps=exports.software_eyedropper=exports.software_crop=exports.software_character=exports.software_box_roundedrectangle=exports.software_box_rectangle=exports.software_box_polygon=exports.software_box_oval=exports.software_add_vectorpoint=exports.music_volume_up=exports.music_volume_down=exports.music_tape=exports.music_stop_button=exports.music_shuffle_button=exports.music_rewind_button=exports.music_repeat_button=exports.music_recordplayer=exports.music_record=exports.music_radio_portable=exports.music_radio_ghettoblaster=exports.music_playlist=exports.music_play_button=exports.music_pause_button=exports.music_note_single=exports.music_note_multiple=exports.music_mute=exports.music_mixer=void 0;exports.weather_windgust=exports.weather_wind_sun=exports.weather_wind_halfmoon=exports.weather_wind_fullmoon=exports.weather_wind_W=exports.weather_wind_SW=exports.weather_wind_SE=exports.weather_wind_S=exports.weather_wind_NW=exports.weather_wind_NE=exports.weather_wind_N=exports.weather_wind_E=exports.weather_wind=exports.weather_waxing_gibbous=exports.weather_waxing_cresent=exports.weather_waning_gibbous=exports.weather_waning_cresent=exports.weather_virgo=exports.weather_variable_sun=exports.weather_variable_halfmoon=exports.weather_variable_fullmoon=exports.weather_tempest_sun=exports.weather_tempest_halfmoon=exports.weather_tempest_fullmoon=exports.weather_tempest=exports.weather_taurus=exports.weather_sunset=exports.weather_sundown=exports.weather_sun=exports.weather_storm_sun=exports.weather_storm_halfmoon=exports.weather_storm_fullmoon=exports.weather_star=exports.weather_snowflake=exports.weather_snow_sun=exports.weather_snow_halfmoon=exports.weather_snow_fullmoon=exports.weather_snow=exports.weather_scorpio=exports.weather_sagittarius=exports.weather_rain_sun=exports.weather_rain_halfmoon=exports.weather_rain_fullmoon=exports.weather_rain=exports.weather_pisces=exports.weather_newmoon=exports.weather_move2=exports.weather_moonset_half=exports.weather_moonset_full=exports.weather_moondown_half=exports.weather_moondown_full=exports.weather_moon=exports.weather_mistyrain_sun=exports.weather_mistyrain_halfmoon=exports.weather_mistyrain_fullmoon=exports.weather_mistyrain=exports.weather_lightning=exports.weather_libra=exports.weather_leo=exports.weather_last_quarter=exports.weather_hail_sun=exports.weather_hail_halfmoon=exports.weather_hail_fullmoon=exports.weather_hail=exports.weather_gemini=exports.weather_fullmoon=exports.weather_fog_sun=exports.weather_fog_halfmoon=exports.weather_fog_fullmoon=exports.weather_fog=exports.weather_drop=exports.weather_downpour_sun=exports.weather_downpour_halfmoon=exports.weather_downpour_fullmoon=exports.weather_cloud_snowflake=exports.weather_cloud_lightning=exports.weather_cloud_drop=exports.weather_cloud=exports.weather_capricorn=exports.weather_cancer=exports.weather_aries=exports.weather_aquarius=exports.software_vertical_distribute_top=exports.software_vertical_distribute_center=exports.software_vertical_distribute_bottom=exports.software_vertical_align_top=exports.software_vertical_align_center=exports.software_vertical_align_bottom=exports.software_vector_line=exports.software_vector_composite=exports.software_vector_box=exports.software_transform_bezier=exports.software_slice=exports.software_shape_roundedrectangle=exports.software_shape_rectangle=exports.software_shape_polygon=exports.software_shape_oval=exports.software_selection_roundedrectangle=exports.software_selection_rectangle=void 0;var arrows_anticlockwise={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c17.121,0,31,13.879,31,31S49.121,63,32,63"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1C14.879,1,1,14.879,1,32\r\n\tc0,6.713,2.134,12.926,5.759,18l5.62,5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,45 13,56 2,56 \r\n\t"},"children":[]}]};exports.arrows_anticlockwise=arrows_anticlockwise;var arrows_anticlockwise_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c0.672,0,1.339,0.021,2,0.063"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c0.672,0,1.339,0.021,2,0.063"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0593,2.0296","d":"M36.021,1.258\r\n\t\t\tC51.242,3.229,63,16.241,63,32c0,16.104-12.279,29.34-27.986,30.855"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0593,2.0296","d":"M36.021,1.258\r\n\t\t\tC51.242,3.229,63,16.241,63,32c0,16.104-12.279,29.34-27.986,30.855"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34,62.937C33.339,62.979,32.672,63,32,63"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34,62.937C33.339,62.979,32.672,63,32,63"},"children":[]}]}]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1C14.879,1,1,14.879,1,32\r\n\tc0,6.713,2.134,12.926,5.759,18l5.62,5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,45 13,56 2,56 \r\n\t"},"children":[]}]};exports.arrows_anticlockwise_dashed=arrows_anticlockwise_dashed;var arrows_button_down={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,17c0-8.837-7.163-16-16-16S16,8.163,16,17v30\r\n\tc0,8.837,7.163,16,16,16s16-7.163,16-16V17z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"47","r":"12"},"children":[]}]};exports.arrows_button_down=arrows_button_down;var arrows_button_off={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M47,48c8.837,0,16-7.163,16-16s-7.163-16-16-16H17\r\n\tC8.163,16,1,23.163,1,32s7.163,16,16,16H47z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"17","cy":"32","r":"12"},"children":[]}]};exports.arrows_button_off=arrows_button_off;var arrows_button_on={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M47,48c8.837,0,16-7.163,16-16s-7.163-16-16-16H17\r\n\tC8.163,16,1,23.163,1,32s7.163,16,16,16H47z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"47","cy":"32","r":"12"},"children":[]}]};exports.arrows_button_on=arrows_button_on;var arrows_button_up={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,17c0-8.837-7.163-16-16-16S16,8.163,16,17v30\r\n\tc0,8.837,7.163,16,16,16s16-7.163,16-16V17z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"17","r":"12"},"children":[]}]};exports.arrows_button_up=arrows_button_up;var arrows_check={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[]}]}]}]};exports.arrows_check=arrows_check;var arrows_circle_check={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_check=arrows_circle_check;var arrows_circle_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_down=arrows_circle_down;var arrows_circle_downleft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[]}]}]}]};exports.arrows_circle_downleft=arrows_circle_downleft;var arrows_circle_downright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[]}]}]}]};exports.arrows_circle_downright=arrows_circle_downright;var arrows_circle_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_left=arrows_circle_left;var arrows_circle_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_minus=arrows_circle_minus;var arrows_circle_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_plus=arrows_circle_plus;var arrows_circle_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_remove=arrows_circle_remove;var arrows_circle_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_right=arrows_circle_right;var arrows_circle_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]}]};exports.arrows_circle_up=arrows_circle_up;var arrows_circle_upleft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,47 23,23 47,23 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,47 23,23 47,23 \t"},"children":[]}]}]}]};exports.arrows_circle_upleft=arrows_circle_upleft;var arrows_circle_upright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"30.999"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[]}]}]}]};exports.arrows_circle_upright=arrows_circle_upright;var arrows_clockwise={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1C14.879,1,1,14.879,1,32s13.879,31,31,31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c17.121,0,31,13.879,31,31\r\n\tc0,6.713-2.134,12.926-5.759,18l-5.62,5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,45 51,56 \r\n\t62,56 "},"children":[]}]};exports.arrows_clockwise=arrows_clockwise;var arrows_clockwise_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c-0.672,0-1.339,0.021-2,0.063"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c-0.672,0-1.339,0.021-2,0.063"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0593,2.0296","d":"M27.979,1.258\r\n\t\t\tC12.758,3.229,1,16.241,1,32c0,16.104,12.279,29.34,27.986,30.855"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0593,2.0296","d":"M27.979,1.258\r\n\t\t\tC12.758,3.229,1,16.241,1,32c0,16.104,12.279,29.34,27.986,30.855"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M30,62.937C30.661,62.979,31.328,63,32,63"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M30,62.937C30.661,62.979,31.328,63,32,63"},"children":[]}]}]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c17.121,0,31,13.879,31,31\r\n\tc0,6.713-2.134,12.926-5.759,18l-5.62,5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,45 51,56 \r\n\t62,56 "},"children":[]}]};exports.arrows_clockwise_dashed=arrows_clockwise_dashed;var arrows_compress={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,25 40,32 \r\n\t47,39 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,39 24,32 \r\n\t17,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"32","x2":"0","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"32","x2":"40","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,17 32,24 \r\n\t39,17 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,47 32,40 \r\n\t25,47 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"24"},"children":[]}]};exports.arrows_compress=arrows_compress;var arrows_deny={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.919,10.08c12.108,12.106,12.108,31.733,0,43.84\r\n\tc-12.105,12.107-31.732,12.107-43.838,0c-12.108-12.106-12.108-31.733,0-43.84C22.187-2.027,41.813-2.027,53.919,10.08z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10.08","y1":"10.08","x2":"53.92","y2":"53.92"},"children":[]}]};exports.arrows_deny=arrows_deny;var arrows_diagonal={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,12 63,1 52,1 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,52 1,63 12,63 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"63","y2":"1"},"children":[]}]};exports.arrows_diagonal=arrows_diagonal;var arrows_diagonal2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,63 63,63 \r\n\t63,52 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,1 1,1 1,12 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"1","x2":"63","y2":"63"},"children":[]}]};exports.arrows_diagonal2=arrows_diagonal2;var arrows_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[]}]}]}]};exports.arrows_down=arrows_down;var arrows_downleft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[]}]}]}]};exports.arrows_downleft=arrows_downleft;var arrows_downright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[]}]}]}]};exports.arrows_downright=arrows_downright;var arrows_drag_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"63"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"16","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,54 32,63 \r\n\t41,54 "},"children":[]}]};exports.arrows_drag_down=arrows_drag_down;var arrows_drag_down_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"31","x2":"32","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"31","x2":"32","y2":"63"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"16","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,54 32,63 \r\n\t41,54 "},"children":[]}]};exports.arrows_drag_down_dashed=arrows_drag_down_dashed;var arrows_drag_horiz={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"0","x2":"24","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"0","x2":"40","y2":"64"},"children":[]}]};exports.arrows_drag_horiz=arrows_drag_horiz;var arrows_drag_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"32","x2":"1","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"32","x2":"1","y2":"32"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"32","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,23 1,32 10,41 \r\n\t"},"children":[]}]};exports.arrows_drag_left=arrows_drag_left;var arrows_drag_left_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"33","y1":"32","x2":"1","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"33","y1":"32","x2":"1","y2":"32"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"32","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,23 1,32 10,41 \r\n\t"},"children":[]}]};exports.arrows_drag_left_dashed=arrows_drag_left_dashed;var arrows_drag_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"32","x2":"63","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"32","x2":"63","y2":"32"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"16","cy":"32","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,41 63,32 \r\n\t54,23 "},"children":[]}]};exports.arrows_drag_right=arrows_drag_right;var arrows_drag_right_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"31","y1":"32","x2":"63","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"31","y1":"32","x2":"63","y2":"32"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"16","cy":"32","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,41 63,32 \r\n\t54,23 "},"children":[]}]};exports.arrows_drag_right_dashed=arrows_drag_right_dashed;var arrows_drag_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"33","x2":"32","y2":"1"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"33","x2":"32","y2":"1"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"48","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,10 32,1 23,10 \r\n\t"},"children":[]}]};exports.arrows_drag_up=arrows_drag_up;var arrows_drag_up_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"33","x2":"32","y2":"1"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"33","x2":"32","y2":"1"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"48","r":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,10 32,1 23,10 \r\n\t"},"children":[]}]};exports.arrows_drag_up_dashed=arrows_drag_up_dashed;var arrows_drag_vert={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"40","x2":"64","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"64","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"24","x2":"64","y2":"24"},"children":[]}]};exports.arrows_drag_vert=arrows_drag_vert;var arrows_exclamation={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"32","y2":"39"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"43","x2":"32","y2":"47"},"children":[]}]};exports.arrows_exclamation=arrows_exclamation;var arrows_expand={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,12 1,1 12,1 \t\r\n\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,12 1,1 12,1 \t\r\n\t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,63 1,63 1,52 \r\n\t\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,63 1,63 1,52 \r\n\t\t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,52 63,63 \r\n\t\t52,63 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,52 63,63 \r\n\t\t52,63 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,1 63,1 63,12 \r\n\t\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,1 63,1 63,12 \r\n\t\t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"2","x2":"22","y2":"22"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"2","x2":"22","y2":"22"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"42","x2":"62","y2":"62"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"42","x2":"62","y2":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"62","x2":"22","y2":"42"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"62","x2":"22","y2":"42"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"62","y2":"2"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"62","y2":"2"},"children":[]}]}]}]};exports.arrows_expand=arrows_expand;var arrows_expand_diagonal1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"1","x2":"63","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"13","x2":"51.166","y2":"63.166"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,12 63,1 52,1 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,52 1,63 12,63 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"26","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"38","y1":"26","x2":"63","y2":"1"},"children":[]}]};exports.arrows_expand_diagonal1=arrows_expand_diagonal1;var arrows_expand_horizontal1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"0","x2":"21","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"64","x2":"43","y2":"0"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"8,25 1,32 8,39 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"32","x2":"21","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,39 63,32 \r\n\t56,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"32","x2":"43","y2":"32"},"children":[]}]};exports.arrows_expand_horizontal1=arrows_expand_horizontal1;var arrows_expand_vertical1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"21","x2":"0","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"43","x2":"64","y2":"43"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,8 32,1 25,8 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"1","x2":"32","y2":"21"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,56 32,63 \r\n\t39,56 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"43"},"children":[]}]};exports.arrows_expand_vertical1=arrows_expand_vertical1;var arrows_fit_horizontal={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"16,25 9,32 16,39 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"48,39 55,32 \r\n\t48,25 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,32 43,32 9,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"0","x2":"63","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"0","x2":"1","y2":"64"},"children":[]}]};exports.arrows_fit_horizontal=arrows_fit_horizontal;var arrows_fit_vertical={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,16 32,9 25,16 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,48 32,55 \r\n\t39,48 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,55 32,43 32,9 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"1","x2":"64","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"63","x2":"64","y2":"63"},"children":[]}]};exports.arrows_fit_vertical=arrows_fit_vertical;var arrows_glide={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45.968,48.968 \r\n\t\t31.967,62.968 18,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45.968,48.968 \r\n\t\t31.967,62.968 18,49 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,15 \r\n\t\t32.032,0.968 46.032,14.968 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,15 \r\n\t\t32.032,0.968 46.032,14.968 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.968","cy":"31.968","r":"5"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"49,18 63,32 \r\n\t\t49,46 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"49,18 63,32 \r\n\t\t49,46 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15.032,45.968 \r\n\t\t1,31.935 14.968,17.968 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15.032,45.968 \r\n\t\t1,31.935 14.968,17.968 \t"},"children":[]}]}]}]};exports.arrows_glide=arrows_glide;var arrows_glide_horizontal={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"46,15 63,32 \r\n\t\t46,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"46,15 63,32 \r\n\t\t46,49 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,48.935 \r\n\t\t1,31.935 18,14.935 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,48.935 \r\n\t\t1,31.935 18,14.935 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"32","r":"5"},"children":[]}]};exports.arrows_glide_horizontal=arrows_glide_horizontal;var arrows_glide_vertical={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"48.968,45.968 \r\n\t\t31.967,62.968 14.968,45.967 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"48.968,45.968 \r\n\t\t31.967,62.968 14.968,45.967 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15.032,17.967 \r\n\t\t32.032,0.968 49.032,17.968 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15.032,17.967 \r\n\t\t32.032,0.968 49.032,17.968 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.968","cy":"31.968","r":"5"},"children":[]}]};exports.arrows_glide_vertical=arrows_glide_vertical;var arrows_hamburger1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"21","x2":"6","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"21","x2":"64","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"33","x2":"6","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"33","x2":"64","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"45","x2":"6","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"45","x2":"64","y2":"45"},"children":[]}]};exports.arrows_hamburger1=arrows_hamburger1;var arrows_horizontal={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"8,25 1,32 8,39 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,39 63,32 \r\n\t56,25 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,32 43,32 1,32 "},"children":[]}]};exports.arrows_horizontal=arrows_horizontal;var arrows_info={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"32","y2":"25"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"17"},"children":[]}]};exports.arrows_info=arrows_info;var arrows_keyboard_alt={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"6,24 18,24 30,42 \r\n\t58,42 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"58","y1":"24","x2":"30","y2":"24"},"children":[]}]};exports.arrows_keyboard_alt=arrows_keyboard_alt;var arrows_keyboard_delete={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#231F20","stroke-width":"2","stroke-miterlimit":"10","points":"55,44 19,44 9,32 19,20 55,20 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#231F20","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"39","x2":"41","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#231F20","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"25","x2":"41","y2":"39"},"children":[]}]};exports.arrows_keyboard_delete=arrows_keyboard_delete;var arrows_keyboard_left={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"38,21 22,32 \r\n\t\t38,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"38,21 22,32 \r\n\t\t38,43 \t"},"children":[]}]}]}]};exports.arrows_keyboard_left=arrows_keyboard_left;var arrows_keyboard_return={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,37 55,37 55,18 44,18 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,37 55,37 55,18 44,18 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,46 9,37 18,28 \r\n\t"},"children":[]}]};exports.arrows_keyboard_return=arrows_keyboard_return;var arrows_keyboard_right={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"26,21 42,32 \r\n\t\t26,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"26,21 42,32 \r\n\t\t26,43 \t"},"children":[]}]}]}]};exports.arrows_keyboard_right=arrows_keyboard_right;var arrows_keyboard_shift={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,36 32,18 \r\n\t\t47,36 39,36 39.001,46 25,46 25,36 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,36 32,18 \r\n\t\t47,36 39,36 39.001,46 25,46 25,36 \t"},"children":[]}]}]}]};exports.arrows_keyboard_shift=arrows_keyboard_shift;var arrows_keyboard_tab={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,25 46,32 \r\n\t39,39 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,32 12,32 46,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"23","x2":"50","y2":"41"},"children":[]}]};exports.arrows_keyboard_tab=arrows_keyboard_tab;var arrows_keyboard_up={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#231F20","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"21,40 32,24 \r\n\t\t43,40 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"21,40 32,24 \r\n\t\t43,40 \t"},"children":[]}]}]}]};exports.arrows_keyboard_up=arrows_keyboard_up;var arrows_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[]}]}]}]};exports.arrows_left=arrows_left;var arrows_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[]}]}]}]};exports.arrows_minus=arrows_minus;var arrows_move={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,39 63,32 \r\n\t56,25 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"8,25 1,32 8,39 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"32","x2":"27","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"32","x2":"63","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,8 32,1 25,8 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,56 32,63 \r\n\t39,56 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"27","x2":"32","y2":"1"},"children":[]}]};exports.arrows_move=arrows_move;var arrows_move2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,39 63,32 \r\n\t56,25 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"8,25 1,32 8,39 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"32","x2":"32","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"32","x2":"63","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,8 32,1 25,8 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,56 32,63 \r\n\t39,56 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"32","x2":"32","y2":"1"},"children":[]}]};exports.arrows_move2=arrows_move2;var arrows_move_bottom={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,44 32,51 \r\n\t39,44 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,51 32,39 32,5 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"59","x2":"64","y2":"59"},"children":[]}]};exports.arrows_move_bottom=arrows_move_bottom;var arrows_move_left={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"20,25 13,32 \r\n\t20,39 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,32 47,32 13,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"0","x2":"5","y2":"64"},"children":[]}]};exports.arrows_move_left=arrows_move_left;var arrows_move_right={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"44,39 51,32 \r\n\t44,25 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"51,32 39,32 5,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"59","y1":"0","x2":"59","y2":"64"},"children":[]}]};exports.arrows_move_right=arrows_move_right;var arrows_move_top={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,20 32,13 \r\n\t25,20 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,59 32,47 32,13 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"5","x2":"64","y2":"5"},"children":[]}]};exports.arrows_move_top=arrows_move_top;var arrows_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[]}]}]}]};exports.arrows_plus=arrows_plus;var arrows_question={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"43","x2":"30","y2":"47"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,21c0-3,2-5,8-5c5,0,8,3,8,7s-6,7-6,7s-4,2-4,8v1\r\n\t"},"children":[]}]};exports.arrows_question=arrows_question;var arrows_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[]}]}]}]};exports.arrows_remove=arrows_remove;var arrows_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[]}]}]}]};exports.arrows_right=arrows_right;var arrows_rotate={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,1c7.678,0,15.354,2.929,21.212,8.787\r\n\t\tC64.91,20.484,65.841,37.248,57.003,49l-6.001,6.002"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,1c7.678,0,15.354,2.929,21.212,8.787\r\n\t\tC64.91,20.484,65.841,37.248,57.003,49l-6.001,6.002"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,63c-7.678,0-15.354-2.929-21.212-8.787\r\n\t\tC-0.91,43.516-1.841,26.752,6.997,15l6.001-6.002"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,63c-7.678,0-15.354-2.929-21.212-8.787\r\n\t\tC-0.91,43.516-1.841,26.752,6.997,15l6.001-6.002"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,44 51,55 \r\n\t62,55 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,20 13,9 2,9 \r\n\t"},"children":[]}]};exports.arrows_rotate=arrows_rotate;var arrows_rotate_anti={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,1C23.322,1,15.646,3.929,9.788,9.787\r\n\t\tC-0.91,20.484-1.841,37.248,6.997,49l6.001,6.002"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,1C23.322,1,15.646,3.929,9.788,9.787\r\n\t\tC-0.91,20.484-1.841,37.248,6.997,49l6.001,6.002"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,63c7.678,0,15.354-2.929,21.212-8.787\r\n\t\tC64.91,43.516,65.841,26.752,57.003,15l-6.001-6.002"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,63c7.678,0,15.354-2.929,21.212-8.787\r\n\t\tC64.91,43.516,65.841,26.752,57.003,15l-6.001-6.002"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,44 13,55 2,55 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,20 51,9 62,9 \r\n\t"},"children":[]}]};exports.arrows_rotate_anti=arrows_rotate_anti;var arrows_rotate_anti_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,1c-0.667,0-1.333,0.022-1.998,0.066"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,1c-0.667,0-1.333,0.022-1.998,0.066"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M26.929,1.275\r\n\t\t\t\tC20.659,2.13,14.607,4.967,9.788,9.787C-0.91,20.484-1.841,37.248,6.997,49l3.846,3.847"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M26.929,1.275\r\n\t\t\t\tC20.659,2.13,14.607,4.967,9.788,9.787C-0.91,20.484-1.841,37.248,6.997,49l3.846,3.847"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11.584","y1":"53.588","x2":"12.998","y2":"55.002"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11.584","y1":"53.588","x2":"12.998","y2":"55.002"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,63c0.667,0,1.333-0.022,1.998-0.066"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,63c0.667,0,1.333-0.022,1.998-0.066"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M37.071,62.725\r\n\t\t\t\tc6.27-0.854,12.321-3.691,17.141-8.512C64.91,43.516,65.841,26.752,57.003,15l-3.846-3.847"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M37.071,62.725\r\n\t\t\t\tc6.27-0.854,12.321-3.691,17.141-8.512C64.91,43.516,65.841,26.752,57.003,15l-3.846-3.847"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52.416","y1":"10.412","x2":"51.002","y2":"8.998"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52.416","y1":"10.412","x2":"51.002","y2":"8.998"},"children":[]}]}]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,44 13,55 2,55 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,20 51,9 62,9 \r\n\t"},"children":[]}]};exports.arrows_rotate_anti_dashed=arrows_rotate_anti_dashed;var arrows_rotate_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,1c0.666,0,1.333,0.022,1.998,0.066"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,1c0.666,0,1.333,0.022,1.998,0.066"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M37.071,1.276\r\n\t\t\t\tc6.27,0.854,12.321,3.691,17.141,8.511C64.91,20.484,65.841,37.248,57.003,49l-3.846,3.846"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M37.071,1.276\r\n\t\t\t\tc6.27,0.854,12.321,3.691,17.141,8.511C64.91,20.484,65.841,37.248,57.003,49l-3.846,3.846"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52.416","y1":"53.588","x2":"51.002","y2":"55.002"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52.416","y1":"53.588","x2":"51.002","y2":"55.002"},"children":[]}]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,63c-0.666,0-1.333-0.022-1.998-0.066"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31,63c-0.666,0-1.333-0.022-1.998-0.066"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M26.929,62.724\r\n\t\t\t\tc-6.27-0.854-12.321-3.691-17.141-8.511C-0.91,43.516-1.841,26.752,6.997,15l3.846-3.846"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1705,2.0853","d":"M26.929,62.724\r\n\t\t\t\tc-6.27-0.854-12.321-3.691-17.141-8.511C-0.91,43.516-1.841,26.752,6.997,15l3.846-3.846"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11.584","y1":"10.412","x2":"12.998","y2":"8.998"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11.584","y1":"10.412","x2":"12.998","y2":"8.998"},"children":[]}]}]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,44 51,55 \r\n\t62,55 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,20 13,9 2,9 \r\n\t"},"children":[]}]};exports.arrows_rotate_dashed=arrows_rotate_dashed;var arrows_shrink={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"23","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"23","y2":"41"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,41 23,41 \r\n\t\t23,52 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,41 23,41 \r\n\t\t23,52 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"63","x2":"41","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"63","x2":"41","y2":"41"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,52 41,41 \r\n\t\t52,41 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,52 41,41 \r\n\t\t52,41 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"1","x2":"41","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"1","x2":"41","y2":"23"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,23 41,23 \r\n\t\t41,12 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,23 41,23 \r\n\t\t41,12 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"1","x2":"23","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"1","x2":"23","y2":"23"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,12 23,23 \r\n\t\t12,23 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,12 23,23 \r\n\t\t12,23 \t"},"children":[]}]}]}]};exports.arrows_shrink=arrows_shrink;var arrows_shrink_diagonal1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"1","x2":"63","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"37","x2":"27","y2":"63"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"35,18 35,29 \r\n\t46,29 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"28.771,45.771 \r\n\t28.771,34.771 17.771,34.771 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"50","x2":"29","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"29","x2":"50.5","y2":"13.5"},"children":[]}]};exports.arrows_shrink_diagonal1=arrows_shrink_diagonal1;var arrows_shrink_diagonal2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"35,18 35,29 \r\n\t46,29 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"28.771,45.771 \r\n\t28.771,34.771 17.771,34.771 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"29","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"29","x2":"63","y2":"1"},"children":[]}]};exports.arrows_shrink_diagonal2=arrows_shrink_diagonal2;var arrows_shrink_horizonal2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45,25 38,32 \r\n\t45,39 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"32","x2":"64","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"19,39 26,32 \r\n\t19,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"32","x2":"0","y2":"32"},"children":[]}]};exports.arrows_shrink_horizonal2=arrows_shrink_horizonal2;var arrows_shrink_horizontal1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"0","x2":"5","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"59","y1":"0","x2":"59","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45,25 38,32 \r\n\t45,39 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"32","x2":"59","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"19,39 26,32 \r\n\t19,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"32","x2":"5","y2":"32"},"children":[]}]};exports.arrows_shrink_horizontal1=arrows_shrink_horizontal1;var arrows_shrink_vertical1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"5","x2":"0","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"59","x2":"0","y2":"59"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,19 32,26 \r\n\t39,19 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"26","x2":"32","y2":"5"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,45 32,38 \r\n\t25,45 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"38","x2":"32","y2":"59"},"children":[]}]};exports.arrows_shrink_vertical1=arrows_shrink_vertical1;var arrows_shrink_vertical2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,19 32,26 \r\n\t39,19 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"26","x2":"32","y2":"0"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,45 32,38 \r\n\t25,45 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"38","x2":"32","y2":"64"},"children":[]}]};exports.arrows_shrink_vertical2=arrows_shrink_vertical2;var arrows_sign_down={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"15,45 15,1 49,1 49,45 31.999,63 "},"children":[]}]};exports.arrows_sign_down=arrows_sign_down;var arrows_sign_left={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"19,15 63,15 63,49 19,49 1,31.999 "},"children":[]}]};exports.arrows_sign_left=arrows_sign_left;var arrows_sign_right={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"45,49 1,49 1,15 45,15 63,32.001 "},"children":[]}]};exports.arrows_sign_right=arrows_sign_right;var arrows_sign_up={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"49,19 49,63 15,63 15,19 32.001,1 "},"children":[]}]};exports.arrows_sign_up=arrows_sign_up;var arrows_slide_down1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,63 27,1 46,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,63 27,1 46,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,54 27,63 \r\n\t36,54 "},"children":[]}]};exports.arrows_slide_down1=arrows_slide_down1;var arrows_slide_down2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,63 37,1 18,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,63 37,1 18,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"46,54 37,63 \r\n\t28,54 "},"children":[]}]};exports.arrows_slide_down2=arrows_slide_down2;var arrows_slide_left1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,27 63,27 63,46 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,27 63,27 63,46 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,18 1,27 10,36 \r\n\t"},"children":[]}]};exports.arrows_slide_left1=arrows_slide_left1;var arrows_slide_left2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,37 63,37 63,18 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,37 63,37 63,18 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,46 1,37 10,28 \r\n\t"},"children":[]}]};exports.arrows_slide_left2=arrows_slide_left2;var arrows_slide_right1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,27 1,27 1,46 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,27 1,27 1,46 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,18 63,27 \r\n\t54,36 "},"children":[]}]};exports.arrows_slide_right1=arrows_slide_right1;var arrows_slide_right2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,37 1,37 1,18 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,37 1,37 1,18 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,46 63,37 \r\n\t54,28 "},"children":[]}]};exports.arrows_slide_right2=arrows_slide_right2;var arrows_slide_up1={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,1 37,63 18,63 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,1 37,63 18,63 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"46,10 37,1 28,10 \r\n\t"},"children":[]}]};exports.arrows_slide_up1=arrows_slide_up1;var arrows_slide_up2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,1 27,63 46,63 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,1 27,63 46,63 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"18,10 27,1 36,10 \r\n\t"},"children":[]}]};exports.arrows_slide_up2=arrows_slide_up2;var arrows_slim_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"63"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,54 32,63 \r\n\t23,54 "},"children":[]}]};exports.arrows_slim_down=arrows_slim_down;var arrows_slim_down_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"0","x2":"32","y2":"55"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"0","x2":"32","y2":"55"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,54 32,63 \r\n\t23,54 "},"children":[]}]};exports.arrows_slim_down_dashed=arrows_slim_down_dashed;var arrows_slim_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"32","x2":"1","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"32","x2":"1","y2":"32"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,23 1,32 10,41 \r\n\t"},"children":[]}]};exports.arrows_slim_left=arrows_slim_left;var arrows_slim_left_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"64","y1":"32","x2":"1","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"64","y1":"32","x2":"1","y2":"32"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,23 1,32 10,41 \r\n\t"},"children":[]}]};exports.arrows_slim_left_dashed=arrows_slim_left_dashed;var arrows_slim_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"63","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"63","y2":"32"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,41 63,32 \r\n\t54,23 "},"children":[]}]};exports.arrows_slim_right=arrows_slim_right;var arrows_slim_right_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"0","y1":"32","x2":"63","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"0","y1":"32","x2":"63","y2":"32"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54,41 63,32 \r\n\t54,23 "},"children":[]}]};exports.arrows_slim_right_dashed=arrows_slim_right_dashed;var arrows_slim_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"1"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"1"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,10 32,1 23,10 \r\n\t"},"children":[]}]};exports.arrows_slim_up=arrows_slim_up;var arrows_slim_up_dashed={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"64","x2":"32","y2":"2"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"64","x2":"32","y2":"2"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,10 32,1 23,10 \r\n\t"},"children":[]}]};exports.arrows_slim_up_dashed=arrows_slim_up_dashed;var arrows_square_check={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,33 25,45 \r\n\t\t49,21 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_check=arrows_square_check;var arrows_square_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,24 32,41 \r\n\t\t49,24 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_down=arrows_square_down;var arrows_square_downleft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"47,41 23,41 \r\n\t\t23,17 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_downleft=arrows_square_downleft;var arrows_square_downright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,17 41,41 \r\n\t\t17,41 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_downright=arrows_square_downright;var arrows_square_left={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,15 20,32 \r\n\t\t37,49 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_left=arrows_square_left;var arrows_square_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"31","x2":"50","y2":"31"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_minus=arrows_square_minus;var arrows_square_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"50","x2":"32","y2":"14"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"50","y2":"32"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_plus=arrows_square_plus;var arrows_square_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18.947","y1":"17.153","x2":"45.045","y2":"43.056"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19.045","y1":"43.153","x2":"44.947","y2":"17.056"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_remove=arrows_square_remove;var arrows_square_right={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,15 44,32 \r\n\t\t27,49 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_right=arrows_square_right;var arrows_square_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_up=arrows_square_up;var arrows_square_upleft={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,47 23,23 \r\n\t\t47,23 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,47 23,23 \r\n\t\t47,23 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_upleft=arrows_square_upleft;var arrows_square_upright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.arrows_square_upright=arrows_square_upright;var arrows_squares={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"27","height":"27"},"children":[]},{"name":"rect","attribs":{"x":"36","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"27","height":"27"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"36","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"27","height":"27"},"children":[]},{"name":"rect","attribs":{"x":"36","y":"36","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"27","height":"27"},"children":[]}]};exports.arrows_squares=arrows_squares;var arrows_stretch_diagonal1={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,12 63,1 52,1 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,52 1,63 12,63 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"26","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"38","y1":"26","x2":"63","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"24","y1":"24","x2":"40","y2":"40"},"children":[]}]};exports.arrows_stretch_diagonal1=arrows_stretch_diagonal1;var arrows_stretch_diagonal2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,12 1,1 12,1 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,52 63,63 \r\n\t52,63 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"63","y1":"63","x2":"38","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"26","y1":"26","x2":"1","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"40","y1":"24","x2":"24","y2":"40"},"children":[]}]};exports.arrows_stretch_diagonal2=arrows_stretch_diagonal2;var arrows_stretch_diagonal3={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,12 63,1 52,1 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,52 1,63 12,63 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"32","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"32","y1":"32","x2":"63","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"1","y1":"1","x2":"63","y2":"63"},"children":[]}]};exports.arrows_stretch_diagonal3=arrows_stretch_diagonal3;var arrows_stretch_diagonal4={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,12 1,1 12,1 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"63,52 63,63 \r\n\t52,63 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"63","y1":"63","x2":"32","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"32","y1":"32","x2":"1","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"63","y1":"1","x2":"1","y2":"63"},"children":[]}]};exports.arrows_stretch_diagonal4=arrows_stretch_diagonal4;var arrows_stretch_horizontal1={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"55,40 63,32 \r\n\t55,24 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"9,24 1,32 9,40 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"2,32 11.677,32 26,32 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,32 41.677,32 62,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"43"},"children":[]}]};exports.arrows_stretch_horizontal1=arrows_stretch_horizontal1;var arrows_stretch_horizontal2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"55,40 63,32 \r\n\t55,24 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"9,24 1,32 9,40 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"2,32 11.677,32 32,32 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,32 41.677,32 62,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"64"},"children":[]}]};exports.arrows_stretch_horizontal2=arrows_stretch_horizontal2;var arrows_stretch_vertical1={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,9 32,1 24,9 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"24,55 32,63 \r\n\t40,55 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,62 32,52.323 32,38 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,26 32,22.323 32,2 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"32","x2":"43","y2":"32"},"children":[]}]};exports.arrows_stretch_vertical1=arrows_stretch_vertical1;var arrows_stretch_vertical2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,9 32,1 24,9 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"24,55 32,63 \r\n\t40,55 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,62 32,52.323 32,32 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,32 32,22.323 32,2 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"64","y2":"32"},"children":[]}]};exports.arrows_stretch_vertical2=arrows_stretch_vertical2;var arrows_switch_horizontal={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"54.083,51 \r\n\t63.083,42 54.083,33 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"42","x2":"9","y2":"42"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10.083,13 \r\n\t1.083,22 10.083,31 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"22","x2":"55","y2":"22"},"children":[]}]};exports.arrows_switch_horizontal=arrows_switch_horizontal;var arrows_switch_vertical={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51.083,10 \r\n\t42.083,1 33.083,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42.083","y1":"1","x2":"42","y2":"55"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13.083,54 \r\n\t22.083,63 31.083,54 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.083","y1":"63","x2":"22","y2":"9"},"children":[]}]};exports.arrows_switch_vertical=arrows_switch_vertical;var arrows_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,40 32,23 \r\n\t\t49,40 \t"},"children":[]}]}]}]};exports.arrows_up=arrows_up;var arrows_up_double={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,32.936 \r\n\t\t32,15.936 49,32.936 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,32.936 \r\n\t\t32,15.936 49,32.936 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,47.936 \r\n\t\t32,30.936 49,47.936 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,47.936 \r\n\t\t32,30.936 49,47.936 \t"},"children":[]}]}]}]};exports.arrows_up_double=arrows_up_double;var arrows_upright={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"17,23 41,23 \r\n\t\t41,47 \t"},"children":[]}]}]}]};exports.arrows_upright=arrows_upright;var arrows_vertical={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,8 32,1 25,8 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,56 32,63 \r\n\t39,56 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,63 32,43 32,1 "},"children":[]}]};exports.arrows_vertical=arrows_vertical;var basic_accelerator={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.001,0.887c17.184,0,31.113,13.929,31.112,31.113\r\n\tC63.114,49.185,49.184,63.115,32,63.113C14.815,63.114,0.887,49.185,0.888,32.001C0.885,14.816,14.815,0.887,32.001,0.887z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M10,32c0-5.63,2.148-11.26,6.444-15.556\r\n\tc8.591-8.593,22.521-8.593,31.112,0C51.852,20.74,54,26.37,54,32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"26","x2":"30.333","y2":"33.333"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"35","r":"2"},"children":[]}]};exports.basic_accelerator=basic_accelerator;var basic_alarm={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"26"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,20 32,32 40,36 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21.995","y1":"56.005","x2":"15","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"63","x2":"42.005","y2":"56.005"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,8 5,4 15,6 3,18 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,4 63,8 61,18 49,6 "},"children":[]}]};exports.basic_alarm=basic_alarm;var basic_anchor={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"13","x2":"32","y2":"63"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"19,50 9,47 6,57 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45,50 55,47 \r\n\t59,57 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M54.752,47\r\n\tC51.555,56.301,42.576,63,32,63c-10.575,0-19.553-6.698-22.751-15.998"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"23","y1":"17","x2":"41","y2":"17"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"7","r":"6"},"children":[]}]};exports.basic_anchor=basic_anchor;var basic_anticlockwise={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,12 32,32 41,41 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"32","x2":"8","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"32","x2":"60","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"60","x2":"32","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"8","x2":"32","y2":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63C14.879,63,1,49.121,1,32S14.879,1,32,1"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63c17.121,0,31-13.879,31-31\r\n\tc0-6.713-2.134-12.926-5.759-18l-5.62-5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,19 51,8 62,8 \r\n\t"},"children":[]}]};exports.basic_anticlockwise=basic_anticlockwise;var basic_archive={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]}]};exports.basic_archive=basic_archive;var basic_archive_full={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"31","x2":"52","y2":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"21","x2":"50","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"11","x2":"48","y2":"11"},"children":[]}]};exports.basic_archive_full=basic_archive_full;var basic_ban={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.919,10.08c12.108,12.106,12.108,31.733,0,43.84\r\n\tc-12.105,12.107-31.732,12.107-43.838,0c-12.108-12.106-12.108-31.733,0-43.84C22.187-2.027,41.813-2.027,53.919,10.08z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10.08","y1":"10.08","x2":"53.92","y2":"53.92"},"children":[]}]};exports.basic_ban=basic_ban;var basic_battery_charge={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"5","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"50","height":"16"},"children":[{"name":"rect","attribs":{"x":"5","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"50","height":"16"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,33 29,30 29,36 36,33 "},"children":[]}]};exports.basic_battery_charge=basic_battery_charge;var basic_battery_empty={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,41 5,41 5,25 14,25 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,41 5,41 5,25 14,25 \t"},"children":[]}]}]}]};exports.basic_battery_empty=basic_battery_empty;var basic_battery_full={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"5","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"50","height":"16"},"children":[{"name":"rect","attribs":{"x":"5","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"50","height":"16"},"children":[]}]}]}]};exports.basic_battery_full=basic_battery_full;var basic_battery_half={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"58","height":"24"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,27 63,27 63,39 59,39 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"33,41 5,41 5,25 29,25 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"33,41 5,41 5,25 29,25 \t"},"children":[]}]}]}]};exports.basic_battery_half=basic_battery_half;var basic_bolt={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,1 17,37 31,37 \r\n\t24,63 50,27 36,27 "},"children":[]}]};exports.basic_bolt=basic_bolt;var basic_book={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"7","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"46","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"63","x2":"15","y2":"2"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"15","x2":"48","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"21","x2":"48","y2":"21"},"children":[]}]};exports.basic_book=basic_book;var basic_book_pen={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"46","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"63","x2":"9","y2":"2"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"15","x2":"42","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"21","x2":"42","y2":"21"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,3 63,53 59,61 55,53 55,3 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,7 51,7 51,17 "},"children":[]}]};exports.basic_book_pen=basic_book_pen;var basic_book_pencil={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"46","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"63","x2":"9","y2":"2"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"15","x2":"42","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"21","x2":"42","y2":"21"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,1 55,54 59,62 63,54 63,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"63","y2":"11"},"children":[]}]};exports.basic_book_pencil=basic_book_pencil;var basic_bookmark={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,1 46,1 46,62 32,48 18,62 "},"children":[]}]};exports.basic_bookmark=basic_bookmark;var basic_calculator={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"8","x2":"18","y2":"28"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"18","x2":"8","y2":"18"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"18","x2":"36","y2":"18"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"54","x2":"26","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"38","x2":"26","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"43","x2":"56","y2":"43"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"49","x2":"56","y2":"49"},"children":[]}]};exports.basic_calculator=basic_calculator;var basic_calendar={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"10","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"10","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]},{"name":"rect","attribs":{"x":"10","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"10","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]},{"name":"rect","attribs":{"x":"44","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"44","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]},{"name":"rect","attribs":{"x":"44","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"44","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]},{"name":"rect","attribs":{"x":"27","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"27","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]},{"name":"rect","attribs":{"x":"27","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[{"name":"rect","attribs":{"x":"27","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_calendar=basic_calendar;var basic_cards_diamonds={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,59 16,45 36,5 63,19 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31.899,14.004 28,6 1,20 19,59 32,52.964 \r\n\t"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"35,41 46,36 45,24 34,29 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"9","x2":"37","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"23","x2":"6","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"53","x2":"42","y2":"55"},"children":[]}]};exports.basic_cards_diamonds=basic_cards_diamonds;var basic_cards_hearts={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,59 16,45 36,5 63,19 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31.899,14.004 28,6 1,20 19,59 32,52.964 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"9","x2":"37","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"23","x2":"6","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"53","x2":"42","y2":"55"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M33,25c-2.848,5.281,3,15,3,15s11.151,0.28,14-5\r\n\tc1.18-2.188,1.377-5.718-1-7c-2.188-1.18-5.82-1.188-7,1c1.18-2.188,0.188-4.82-2-6C37.624,21.718,34.181,22.813,33,25z"},"children":[]}]};exports.basic_cards_hearts=basic_cards_hearts;var basic_case={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"18","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"36"},"children":[{"name":"rect","attribs":{"x":"1","y":"18","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"36"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"30","x2":"63","y2":"30"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,30 27,36 37,36 37,30 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,18c0,0,0-8,9-8s9,8,9,8"},"children":[]}]};exports.basic_case=basic_case;var basic_chronometer={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M51.799,15.202\r\n\t\tc10.936,10.933,10.936,28.662,0,39.595c-10.935,10.938-28.664,10.938-39.598,0c-10.935-10.933-10.935-28.662,0-39.595\r\n\t\tC23.135,4.266,40.864,4.266,51.799,15.202z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M51.799,15.202\r\n\t\tc10.936,10.933,10.936,28.662,0,39.595c-10.935,10.938-28.664,10.938-39.598,0c-10.935-10.933-10.935-28.662,0-39.595\r\n\t\tC23.135,4.266,40.864,4.266,51.799,15.202z"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,7 32,1 38,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,7 32,1 38,1 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"1","x2":"32","y2":"1"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"1","x2":"32","y2":"1"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"59"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"59"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"11","x2":"32","y2":"7"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"11","x2":"32","y2":"7"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"35","x2":"8","y2":"35"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"35","x2":"8","y2":"35"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"35","x2":"60","y2":"35"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"35","x2":"60","y2":"35"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14.564","y1":"17.565","x2":"17.394","y2":"20.394"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14.564","y1":"17.565","x2":"17.394","y2":"20.394"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46.606","y1":"49.606","x2":"49.436","y2":"52.436"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46.606","y1":"49.606","x2":"49.436","y2":"52.436"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49.436","y1":"17.565","x2":"46.607","y2":"20.394"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49.436","y1":"17.565","x2":"46.607","y2":"20.394"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17.395","y1":"49.606","x2":"14.564","y2":"52.436"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17.395","y1":"49.606","x2":"14.564","y2":"52.436"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"33"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"35","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"35","r":"3"},"children":[]}]}]}]};exports.basic_chronometer=basic_chronometer;var basic_clessidre={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"14","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"36","height":"4"},"children":[]},{"name":"rect","attribs":{"x":"14","y":"59","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"36","height":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M18,59c0,0,0-8,0-14s29-19,29-25c0-2,0-15,0-15"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M47,59c0,0,0-8,0-14S18,26,18,20c0-2,0-15,0-15"},"children":[]}]};exports.basic_clessidre=basic_clessidre;var basic_clock={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,12 32,32 41,41 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,12 32,32 41,41 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"32","x2":"8","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"32","x2":"8","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"32","x2":"60","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"32","x2":"60","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"60","x2":"32","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"60","x2":"32","y2":"56"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"8","x2":"32","y2":"4"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"8","x2":"32","y2":"4"},"children":[]}]}]}]};exports.basic_clock=basic_clock;var basic_clockwise={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,12 32,32 41,41 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"32","x2":"8","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"32","x2":"60","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"60","x2":"32","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"8","x2":"32","y2":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63c17.121,0,31-13.879,31-31S49.121,1,32,1"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63C14.879,63,1,49.121,1,32\r\n\tc0-6.713,2.134-12.926,5.759-18l5.62-5.621"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"13,19 13,8 2,8 \r\n\t"},"children":[]}]};exports.basic_clockwise=basic_clockwise;var basic_cloud={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]}]};exports.basic_cloud=basic_cloud;var basic_clubs={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M30,38v6c0,0,0,19-7,19h9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63h9c-7,0-7-19-7-19v-6"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M34,38\r\n\tc0,7.457,8.044,12.125,15.5,12.125c7.455,0,13.5-6.043,13.5-13.5s-6.045-13.5-13.5-13.5c-2.678,0-5.168,0.789-7.267,2.135\r\n\tc1.995-2.345,3.204-5.378,3.204-8.697c0-7.422-6.017-13.438-13.438-13.438S18.562,9.141,18.562,16.562\r\n\tc0,3.32,1.21,6.353,3.205,8.697c-2.1-1.345-4.59-2.135-7.268-2.135c-7.456,0-13.5,6.043-13.5,13.5s6.044,13.5,13.5,13.5\r\n\tC21.955,50.125,30,45.457,30,38"},"children":[]}]};exports.basic_clubs=basic_clubs;var basic_compass={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"35","r":"28.292"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,40 45,21 26,29 \r\n\t19,47 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"29","x2":"37","y2":"40"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M36.9,7C36.965,6.677,37,6.342,37,6\r\n\tc0-2.761-2.239-5-5-5s-5,2.239-5,5c0,0.342,0.035,0.677,0.1,1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"7","x2":"32","y2":"12"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"60","y1":"35","x2":"55","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"35","x2":"4","y2":"35"},"children":[]}]};exports.basic_compass=basic_compass;var basic_cup={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,27c0,4.418,6.059,8,16,8s16-3.582,16-8V1H16V27z\r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"63","x2":"44","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"32","y2":"63"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,7H7c0,0,0,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,7h9c0,0,0,9-9,9"},"children":[]}]};exports.basic_cup=basic_cup;var basic_diamonds={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"33,63 56,32 33,1 10,32 "},"children":[]}]};exports.basic_diamonds=basic_diamonds;var basic_display={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"10","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"41"},"children":[{"name":"rect","attribs":{"x":"1","y":"10","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"41"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"63","x2":"42","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"63","x2":"42","y2":"63"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"51"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"43","x2":"64","y2":"43"},"children":[]}]};exports.basic_display=basic_display;var basic_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,50 32,58 \r\n\t24,50 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"26"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"26"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"24,42 1,42 1,6 63,6 63,42 40,42 "},"children":[]}]};exports.basic_download=basic_download;var basic_exclamation={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"32","y2":"39"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"43","x2":"32","y2":"47"},"children":[]}]};exports.basic_exclamation=basic_exclamation;var basic_eye={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M1,32c0,0,11,15,31,15s31-15,31-15S52,17,32,17\r\n\tS1,32,1,32z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"7"},"children":[]}]};exports.basic_eye=basic_eye;var basic_eye_closed={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M1,32c0,0,11,15,31,15s31-15,31-15S52,17,32,17\r\n\tS1,32,1,32z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"55","x2":"55","y2":"9"},"children":[]}]};exports.basic_eye_closed=basic_eye_closed;var basic_female={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"25","r":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"63","x2":"22","y2":"42"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"46","x2":"18","y2":"63"},"children":[]}]};exports.basic_female=basic_female;var basic_flag1={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"0","x2":"12","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,6 53,6 47,18 53,30 12,30 "},"children":[]}]};exports.basic_flag1=basic_flag1;var basic_flag2={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"0","x2":"7","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32.062,6 26,11 26,35 57,35 51,23 57,11 \r\n\t26,11 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"26,30 7,30 7,6 32,6 32,11 "},"children":[]}]};exports.basic_flag2=basic_flag2;var basic_floppydisk={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,63 1,63 1,1 51,1 63,13 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,63 1,63 1,1 51,1 63,13 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"7","y":"31","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"50","height":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"39","x2":"50","y2":"39"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"47","x2":"50","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"55","x2":"50","y2":"55"},"children":[]},{"name":"rect","attribs":{"x":"15","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"34","height":"19"},"children":[]},{"name":"rect","attribs":{"x":"38","y":"5","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"11"},"children":[]}]};exports.basic_floppydisk=basic_floppydisk;var basic_folder={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]}]};exports.basic_folder=basic_folder;var basic_folder_multiple={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"56,22 56,54 1,54 1,15 19.629,15 26.726,22 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"8,13 8,7 26.629,7 33.726,14 63,14 63,46 \r\n\t58,46 "},"children":[]}]};exports.basic_folder_multiple=basic_folder_multiple;var basic_gear={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,1 26,1 26,10 20,12 14,6 6,14 12,20 \r\n\t\t10,26 1,26 1,38 10,38 12,44 6,50 14,58 20,52 26,54 26,63 32,63 38,63 38,54 44,52 50,58 58,50 52,44 54,38 63,38 63,26 54,26 \r\n\t\t52,20 58,14 50,6 44,12 38,10 38,1 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,1 26,1 26,10 20,12 14,6 6,14 12,20 \r\n\t\t10,26 1,26 1,38 10,38 12,44 6,50 14,58 20,52 26,54 26,63 32,63 38,63 38,54 44,52 50,58 58,50 52,44 54,38 63,38 63,26 54,26 \r\n\t\t52,20 58,14 50,6 44,12 38,10 38,1 \t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6"},"children":[]}]}]}]};exports.basic_gear=basic_gear;var basic_globe={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,1c14.359,0,27,12.641,27,27S46.359,55,32,55\r\n\tc-10,0-13-4-13-4"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"28","r":"20"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"54","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"63","x2":"42","y2":"63"},"children":[]}]};exports.basic_globe=basic_globe;var basic_gunsight={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"48","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"32","x2":"0","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"32","x2":"48","y2":"32"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"24"},"children":[]}]};exports.basic_gunsight=basic_gunsight;var basic_hammer={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"20","x2":"41","y2":"39"},"children":[]},{"name":"rect","attribs":{"x":"46.257","y":"35.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 120.5036 47.0858)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M1,19L17,3c6,6,13,1,13,1l4,4L12,30L1,19z"},"children":[]}]};exports.basic_hammer=basic_hammer;var basic_headset={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M11,48C5.477,48,1,43.523,1,38s4.477-10,10-10h2v20\r\n\tH11z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53,28c5.523,0,10,4.477,10,10s-4.477,10-10,10h-2\r\n\tV28H53z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M13,31v-9c0,0,0-16,19-16s19,16,19,16v6"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"51,48 51,53 36,59 28,59 28,55 36,55 \r\n\t36,58 "},"children":[]}]};exports.basic_headset=basic_headset;var basic_heart={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M1,21c0,20,31,38,31,38s31-18,31-38\r\n\tc0-8.285-6-16-15-16c-8.285,0-16,5.715-16,14c0-8.285-7.715-14-16-14C7,5,1,12.715,1,21z"},"children":[]}]};exports.basic_heart=basic_heart;var basic_heart_broken={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M1,21c0,20,31,38,31,38s31-18,31-38\r\n\tc0-8.285-6-16-15-16c-8.285,0-16,5.715-16,14c0-8.285-7.715-14-16-14C7,5,1,12.715,1,21z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,57 36,50 30,44 36,38 30,32 38,24 \r\n\t32,19 32,17 "},"children":[]}]};exports.basic_heart_broken=basic_heart_broken;var basic_helm={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"37","x2":"59","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"10","x2":"26","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"27","x2":"59","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"53","x2":"26","y2":"37"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"8"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"24"},"children":[]}]};exports.basic_helm=basic_helm;var basic_home={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,3 2,33 11,33 11,63 23,63 23,47 39,47 \r\n\t39,63 51,63 51,33 62,33 "},"children":[]}]};exports.basic_home=basic_home;var basic_info={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"32","y2":"25"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"17"},"children":[]}]};exports.basic_info=basic_info;var basic_ipod={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"36","x2":"48","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"36","x2":"48","y2":"36"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"5","x2":"48","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"5","x2":"48","y2":"5"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"9.5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"9.5"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"2.5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"2.5"},"children":[]}]}]}]};exports.basic_ipod=basic_ipod;var basic_joypad={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M50,27H14C6.82,27,1,32.82,1,40s5.82,13,13,13\r\n\tc4.6,0,8.632-2.396,10.943-6h14.113C41.368,50.604,45.4,53,50,53c7.18,0,13-5.82,13-13S57.18,27,50,27z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"14","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"22","y1":"40","x2":"6","y2":"40"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"50","cy":"39.99","r":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"50","y1":"33","x2":"50","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"57","y1":"40","x2":"43","y2":"40"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,27 32,21 46,21 46,14 36,14 36,11 "},"children":[]}]};exports.basic_joypad=basic_joypad;var basic_key={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"51","cy":"32","r":"12"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"38","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"32","x2":"6","y2":"42"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"32","x2":"14","y2":"38"},"children":[]}]};exports.basic_key=basic_key;var basic_keyboard={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"22","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"30"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"7,22 7,14 21,14 21,7 11,7 11,4 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"29","x2":"8","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"29","x2":"14","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"29","x2":"20","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"29","x2":"26","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"29","x2":"32","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"29","x2":"38","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"29","x2":"44","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"29","x2":"50","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"29","x2":"56","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"45","x2":"8","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"45","x2":"14","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"45","x2":"42","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"45","x2":"54","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"45","x2":"60","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"45","x2":"48","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"37","x2":"12","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"37","x2":"18","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"37","x2":"24","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"37","x2":"30","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"37","x2":"36","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"37","x2":"42","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"37","x2":"48","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"37","x2":"54","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"37","x2":"60","y2":"37"},"children":[]}]};exports.basic_keyboard=basic_keyboard;var basic_laptop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"8","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"34"},"children":[{"name":"rect","attribs":{"x":"8","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"34"},"children":[]}]},{"name":"rect","attribs":{"x":"1","y":"46","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"6"},"children":[{"name":"rect","attribs":{"x":"1","y":"46","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"16","x2":"30","y2":"16"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"16","x2":"30","y2":"16"},"children":[]}]}]}]};exports.basic_laptop=basic_laptop;var basic_life_buoy={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"18","x2":"26","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"18","x2":"38","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"63","x2":"26","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"63","x2":"38","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"26","x2":"63","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"38","x2":"63","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"26","x2":"18","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"38","x2":"18","y2":"38"},"children":[]}]};exports.basic_life_buoy=basic_life_buoy;var basic_lightbulb={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,40v5h22l0.001-5.107C49,36.195,53,29.564,53,22\r\n\tc0-11.598-9.402-21-21-21s-21,9.402-21,21C11,29.565,14.998,36.304,21,40z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"45","x2":"25","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"45","x2":"39","y2":"25"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,26 29,29 32,26 35,29 39,26 "},"children":[]},{"name":"rect","attribs":{"x":"21","y":"45","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"22","height":"6"},"children":[]},{"name":"rect","attribs":{"x":"23","y":"51","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"6"},"children":[]},{"name":"rect","attribs":{"x":"25","y":"57","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"14","height":"6"},"children":[]}]};exports.basic_lightbulb=basic_lightbulb;var basic_link={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M37.004,32.166c1.224,0.533,2.576,0.829,3.997,0.828\r\n\tc3.271-0.003,6.175-1.576,7.998-4.006L60.99,16.98c1.255-1.673,1.998-3.751,1.996-6.002c-0.003-5.522-4.484-9.997-10.007-9.993\r\n\tc-2.251,0.002-4.327,0.747-5.999,2.004L33.989,15.998c-1.768,1.805-2.997,4.277-2.996,7.003c0.001,1.424,0.3,2.778,0.837,4.003"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M37.004,32.166"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31.831,27.004c0.053,0.121,0.107,0.24,0.166,0.358"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M26.997,31.836c-1.225-0.535-2.577-0.831-3.998-0.83\r\n\tc-2.251,0.002-4.328,0.747-5.999,2.004L4.01,46.02c-1.768,1.804-2.997,4.276-2.995,7.002c0.003,5.522,4.484,9.997,10.007,9.993\r\n\tc3.271-0.003,6.174-1.576,7.997-4.006L31.01,47.001c1.255-1.673,1.998-3.751,1.996-6.002c-0.001-1.422-0.299-2.774-0.835-3.998"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23.006","y1":"41.006","x2":"40.994","y2":"22.994"},"children":[]}]};exports.basic_link=basic_link;var basic_lock={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"8","y":"33","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"30"},"children":[{"name":"rect","attribs":{"x":"8","y":"33","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"30"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,33V17c0-8.837,7.163-16,16-16s16,7.163,16,16\r\n\t\tv16"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,33V17c0-8.837,7.163-16,16-16s16,7.163,16,16\r\n\t\tv16"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"47","r":"4"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"47","r":"4"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"55"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"55"},"children":[]}]}]}]};exports.basic_lock=basic_lock;var basic_lock_open={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"8","y":"33","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"30"},"children":[{"name":"rect","attribs":{"x":"8","y":"33","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"30"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,33V17c0-8.837,7.163-16,16-16s16,7.163,16,16v3\r\n\t\t"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,33V17c0-8.837,7.163-16,16-16s16,7.163,16,16v3\r\n\t\t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"47","r":"4"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"47","r":"4"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"55"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"55"},"children":[]}]}]}]};exports.basic_lock_open=basic_lock_open;var basic_magic_mouse={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,17c0-8.836-7.164-16-16-16S16,8.164,16,17v30\r\n\tc0,8.836,7.164,16,16,16s16-7.164,16-16V17z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"10","x2":"32","y2":"18"},"children":[]}]};exports.basic_magic_mouse=basic_magic_mouse;var basic_magnifier={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[]}]},{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[]}]}]}]};exports.basic_magnifier=basic_magnifier;var basic_magnifier_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"21","x2":"30","y2":"21"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"21","x2":"30","y2":"21"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[]}]},{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[]}]}]}]};exports.basic_magnifier_minus=basic_magnifier_minus;var basic_magnifier_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"21","x2":"30","y2":"21"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"21","x2":"30","y2":"21"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"12","x2":"21","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"12","x2":"21","y2":"30"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"21","r":"20"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"35","x2":"41","y2":"41"},"children":[]}]},{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[{"name":"rect","attribs":{"x":"46.257","y":"37.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 121.9178 50.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[]}]}]}]};exports.basic_magnifier_plus=basic_magnifier_plus;var basic_mail={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"37"},"children":[{"name":"rect","attribs":{"x":"1","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"37"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,13 32,33 63,13 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,13 32,33 63,13 \t"},"children":[]}]}]}]};exports.basic_mail=basic_mail;var basic_mail_multiple={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"18","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9.887,16 9.887,9 63,9 63,41 55,41 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0.887,18 27,33.062 53,18 "},"children":[]}]};exports.basic_mail_multiple=basic_mail_multiple;var basic_mail_open={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_mail_open=basic_mail_open;var basic_mail_open_text={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"9","x2":"45","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"9","x2":"45","y2":"9"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"17","x2":"45","y2":"17"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"17","x2":"45","y2":"17"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"25","x2":"45","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"25","x2":"45","y2":"25"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t\t63,26 52.666,21.667 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t\t63,26 52.666,21.667 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t\t"},"children":[]}]}]}]}]}]};exports.basic_mail_open_text=basic_mail_open_text;var basic_male={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"39","r":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"1","x2":"42","y2":"22"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"45,1 63,1 63,19 \r\n\t"},"children":[]}]};exports.basic_male=basic_male;var basic_map={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,59 22,51 42,59 63,51 63,5 42,13 22,5 \r\n\t\t1,13 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,59 22,51 42,59 63,51 63,5 42,13 22,5 \r\n\t\t1,13 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"5","x2":"22","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"5","x2":"22","y2":"51"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"13","x2":"42","y2":"59"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"13","x2":"42","y2":"59"},"children":[]}]}]}]}]}]};exports.basic_map=basic_map;var basic_message={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]}]};exports.basic_message=basic_message;var basic_message_multiple={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"26,49.042 54.963,49.042 54.963,11.042 \r\n\t1,11.042 1,49.042 14,49.042 14,59.486 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,41.042 62.963,41.042 62.963,3.042 \r\n\t9,3.042 9,9 "},"children":[]}]};exports.basic_message_multiple=basic_message_multiple;var basic_message_txt={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"16","x2":"54","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"26","x2":"54","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"36","x2":"54","y2":"36"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]}]};exports.basic_message_txt=basic_message_txt;var basic_mixer2={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"19","x2":"12","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"0","x2":"52","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"38","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"26"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"12","cy":"13","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"52","cy":"51","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"0","x2":"12","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"57","x2":"52","y2":"64"},"children":[]}]};exports.basic_mixer2=basic_mixer2;var basic_mouse={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,17c0-8.836-7.164-16-16-16S16,8.164,16,17v30\r\n\tc0,8.836,7.164,16,16,16s16-7.164,16-16V17z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"1","x2":"32","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"21","x2":"48","y2":"21"},"children":[]}]};exports.basic_mouse=basic_mouse;var basic_notebook={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"1","x2":"41","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"16","x2":"7","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"8","x2":"7","y2":"8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"24","x2":"7","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"32","x2":"7","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"40","x2":"7","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"48","x2":"7","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"56","x2":"7","y2":"56"},"children":[]}]};exports.basic_notebook=basic_notebook;var basic_notebook_pen={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,3 63,53 59,61 55,53 55,3 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,7 51,7 51,17 "},"children":[]},{"name":"rect","attribs":{"x":"4","y":"3","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"3","x2":"34","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"16","x2":"0","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"8","x2":"0","y2":"8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"24","x2":"0","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"32","x2":"0","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"40","x2":"0","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"48","x2":"0","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"56","x2":"0","y2":"56"},"children":[]}]};exports.basic_notebook_pen=basic_notebook_pen;var basic_notebook_pencil={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"4","y":"3","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"3","x2":"34","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"16","x2":"0","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"8","x2":"0","y2":"8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"24","x2":"0","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"32","x2":"0","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"40","x2":"0","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"48","x2":"0","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"56","x2":"0","y2":"56"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,1 55,54 59,62 63,54 63,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"63","y2":"11"},"children":[]}]};exports.basic_notebook_pencil=basic_notebook_pencil;var basic_paperplane={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,30 63,1 23,41 \r\n\t"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"34,63 63,1 23,41 \r\n\t"},"children":[]}]};exports.basic_paperplane=basic_paperplane;var basic_pencil_ruler={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,63 1,2 62,63 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,54 14,30 38,54 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"22","x2":"2","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"30","x2":"2","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"38","x2":"2","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"46","x2":"2","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"54","x2":"2","y2":"54"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,1 19,7 55,43 63,45 61,37 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"13","x2":"31","y2":"7"},"children":[]}]};exports.basic_pencil_ruler=basic_pencil_ruler;var basic_photo={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"46,20 38,10 26,10 18,20 1,20 1,52 63,52 \r\n\t\t63,20 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"46,20 38,10 26,10 18,20 1,20 1,52 63,52 \r\n\t\t63,20 \t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"36","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"36","r":"8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"20","x2":"9","y2":"52"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"20","x2":"9","y2":"52"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"28","x2":"54","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"28","x2":"54","y2":"28"},"children":[]}]}]}]};exports.basic_photo=basic_photo;var basic_picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"11","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"42"},"children":[{"name":"rect","attribs":{"x":"1","y":"11","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"42"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,47 24,27 36,39 42,31 63,49 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,47 24,27 36,39 42,31 63,49 \t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"51","cy":"22","r":"5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"51","cy":"22","r":"5"},"children":[]}]}]}]};exports.basic_picture=basic_picture;var basic_picture_multiple={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"16","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"40"},"children":[{"name":"rect","attribs":{"x":"1","y":"16","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"40"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"10,14 10,8 63,8 63,48 55,48 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,46 15,32 29,48 39,42 53,54 "},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"40","cy":"29","r":"5"},"children":[]}]};exports.basic_picture_multiple=basic_picture_multiple;var basic_pin1={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"16","r":"15"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22.083,16c0-5.477,4.44-9.917,9.917-9.917"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"31"},"children":[]}]};exports.basic_pin1=basic_pin1;var basic_pin2={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"36"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,1 22,1 22,5 27,9 25,26 16,30 15,36 \r\n\t32,36 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,1 42,1 42,5 37,9 39,26 48,30 49,36 \r\n\t32,36 "},"children":[]}]};exports.basic_pin2=basic_pin2;var basic_postcard={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"41"},"children":[{"name":"rect","attribs":{"x":"1","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"41"},"children":[]}]}]},{"name":"rect","attribs":{"x":"49","y":"19","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8","height":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"18","x2":"39","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"21","x2":"34","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"27","x2":"30","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"33","x2":"32","y2":"33"},"children":[]}]};exports.basic_postcard=basic_postcard;var basic_postcard_multiple={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"20","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"53","height":"34"},"children":[{"name":"rect","attribs":{"x":"1","y":"20","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"53","height":"34"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"10,16.999 10,11 63,11 63,45 57,45 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"10,16.999 10,11 63,11 63,45 57,45 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"42","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"7","height":"8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"24","x2":"33","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"27","x2":"29","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"32","x2":"26","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"37","x2":"27","y2":"37"},"children":[]}]};exports.basic_postcard_multiple=basic_postcard_multiple;var basic_printer={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"19"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"19"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16.5,52"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16.5,52"},"children":[]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"16,52 1,52 1,20 63,20 63,52 48,52 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"16,52 1,52 1,20 63,20 63,52 48,52 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"16","y":"39","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"24"},"children":[{"name":"rect","attribs":{"x":"16","y":"39","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"24"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"27","x2":"10","y2":"27"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"27","x2":"10","y2":"27"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"27","x2":"16","y2":"27"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"27","x2":"16","y2":"27"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"47","x2":"42","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"47","x2":"42","y2":"47"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"55","x2":"42","y2":"55"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"55","x2":"42","y2":"55"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,52"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,52"},"children":[]}]}]}]}]}]};exports.basic_printer=basic_printer;var basic_question={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"43","x2":"30","y2":"47"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,21c0-3,2-5,8-5c5,0,8,3,8,7s-6,7-6,7s-4,2-4,8v1\r\n\t"},"children":[]}]};exports.basic_question=basic_question;var basic_rss={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M63.051,56\r\n\tc0-13.416-4.804-25.711-12.786-35.256"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M50.265,20.744\r\n\tC40.177,8.677,25.01,1,8.051,1"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M51.769,56\r\n\tc0-24.145-19.574-43.718-43.718-43.718"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M40.486,56\r\n\tc0-17.913-14.523-32.436-32.436-32.436"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M29.205,56\r\n\tc0-11.684-9.472-21.154-21.154-21.154"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"8.051","cy":"56","r":"7.051"},"children":[]}]};exports.basic_rss=basic_rss;var basic_server={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"22"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"52","r":"3"},"children":[]}]};exports.basic_server=basic_server;var basic_server2={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M59,56\r\n\tc0,3.866-11.641,7-26,7S7,59.866,7,56"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M59,40\r\n\tc0,3.866-11.641,7-26,7S7,43.866,7,40"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M59,24\r\n\tc0,3.866-11.641,7-26,7S7,27.866,7,24"},"children":[]},{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"33","cy":"8","rx":"26","ry":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"7","y1":"8","x2":"7","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","x1":"59","y1":"8","x2":"59","y2":"56"},"children":[]}]};exports.basic_server2=basic_server2;var basic_server_cloud={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"22"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"52","r":"3"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,27H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.basic_server_cloud=basic_server_cloud;var basic_server_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"22"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"52","r":"3"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,23 32,31 \r\n\t24,23 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"11"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"11"},"children":[]}]}]}]};exports.basic_server_download=basic_server_download;var basic_server_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"22"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"52","r":"3"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,20 \r\n\t31.998,12 39.998,20 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"12","x2":"31.998","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"12","x2":"31.998","y2":"32"},"children":[]}]}]}]};exports.basic_server_upload=basic_server_upload;var basic_settings={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"34","x2":"41","y2":"39"},"children":[]},{"name":"rect","attribs":{"x":"46.257","y":"35.065","transform":"matrix(-0.7071 0.7071 -0.7071 -0.7071 120.5036 47.0858)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8.485","height":"26.87"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,16 18,10 8,4 6,6 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"26","x2":"15","y2":"13"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M58,12.5l-8,3.75l-4-4.125l3.5-8.062l0,0\r\n\tC39.5,4.062,37,9,37,14v4L3.5,52l-1.75,6l2.125,2l6.062-1.5L44,25h4C53,25,58,22.5,58,12.5L58,12.5z"},"children":[]}]};exports.basic_settings=basic_settings;var basic_share={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"51","cy":"13","r":"12"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"11","cy":"42","r":"10"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"55","r":"8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"54","x2":"20","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"35","x2":"41","y2":"21"},"children":[]}]};exports.basic_share=basic_share;var basic_sheet={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]}]};exports.basic_sheet=basic_sheet;var basic_sheet_pen={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,3 63,53 59,61 55,53 55,3 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,7 51,7 51,17 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,15 42,61 1,61 1,3 30,3 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"13","x2":"20","y2":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"23","x2":"35","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"31","x2":"35","y2":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"39","x2":"35","y2":"39"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"47","x2":"35","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,15 30,15 30,3 "},"children":[]}]};exports.basic_sheet_pen=basic_sheet_pen;var basic_sheet_pencil={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,15 42,61 1,61 1,3 30,3 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,1 55,54 59,62 63,54 63,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"13","x2":"20","y2":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"23","x2":"35","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"31","x2":"35","y2":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"39","x2":"35","y2":"39"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"47","x2":"35","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,15 30,15 30,3 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"63","y2":"11"},"children":[]}]};exports.basic_sheet_pencil=basic_sheet_pencil;var basic_signs={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,24 22,24 22,12 55,12 62,18 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,28 42,28 42,40 9,40 2,34 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"28","x2":"32","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"12","x2":"32","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"63","x2":"40","y2":"63"},"children":[]}]};exports.basic_signs=basic_signs;var basic_smartphone={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]}]};exports.basic_smartphone=basic_smartphone;var basic_spades={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,63h9c-7,0-7-19-7-19v-6c0,7.671,6,13,13,13\r\n\tc8.334,0,14-7.329,14-15C61,17.48,32,1,32,1S3,17.48,3,36c0,7.671,6.667,15,15,15c7,0,11.395-5.87,12-13v6c0,0,0,19-7,19H32"},"children":[]}]};exports.basic_spades=basic_spades;var basic_spread={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,6 1,54 32,58 63,54 63,6 32,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"10"},"children":[]}]};exports.basic_spread=basic_spread;var basic_spread_bookmark={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,6 1,54 32,58 63,54 63,6 32,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,8 43,27 47,25 51,27 51,7 "},"children":[]}]};exports.basic_spread_bookmark=basic_spread_bookmark;var basic_spread_text={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,6 1,54 32,58 63,54 63,6 32,10 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,6 1,54 32,58 63,54 63,6 32,10 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"10"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"16","x2":"26","y2":"18"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"16","x2":"26","y2":"18"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"26","x2":"26","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"26","x2":"26","y2":"28"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"36","x2":"26","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"36","x2":"26","y2":"38"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"46","x2":"26","y2":"48"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"46","x2":"26","y2":"48"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"16","x2":"38","y2":"18"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"16","x2":"38","y2":"18"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"26","x2":"38","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"26","x2":"38","y2":"28"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"36","x2":"38","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"36","x2":"38","y2":"38"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"46","x2":"38","y2":"48"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"46","x2":"38","y2":"48"},"children":[]}]}]}]};exports.basic_spread_text=basic_spread_text;var basic_spread_text_bookmark={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,6 1,54 32,58 63,54 63,6 32,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,8 43,27 47,25 51,27 51,7 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"16","x2":"26","y2":"18"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"26","x2":"26","y2":"28"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"36","x2":"26","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"46","x2":"26","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"36","x2":"38","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"46","x2":"38","y2":"48"},"children":[]}]};exports.basic_spread_text_bookmark=basic_spread_text_bookmark;var basic_star={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 12,62 20,38 2,24 24,24 32,1 40,24 \r\n\t62,24 44,38 52,62 "},"children":[]}]};exports.basic_star=basic_star;var basic_tablet={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_tablet=basic_tablet;var basic_target={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"22.999"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"15"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6.999"},"children":[]}]};exports.basic_target=basic_target;var basic_todo={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_todo=basic_todo;var basic_todo_pencil={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,1 55,54 59,62 63,54 63,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"63","y2":"11"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,8 1,8 1,63 45,63 45,8 32,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,5 27,1 19,1 19,5 15,5 13,13 33,13 31,5 \r\n\t"},"children":[]}]};exports.basic_todo_pencil=basic_todo_pencil;var basic_todo_txt={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"24","x2":"47","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"34","x2":"47","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"44","x2":"47","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"54","x2":"47","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"24","x2":"17","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"34","x2":"17","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"44","x2":"17","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"54","x2":"17","y2":"54"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_todo_txt=basic_todo_txt;var basic_todolist_pen={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"24","x2":"38","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"34","x2":"38","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"44","x2":"38","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"54","x2":"38","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"24","x2":"8","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"34","x2":"8","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"44","x2":"8","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"54","x2":"8","y2":"54"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,8 1,8 1,63 45,63 45,8 32,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,5 27,1 19,1 19,5 15,5 13,13 33,13 31,5 \r\n\t"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,3 63,53 59,61 55,53 55,3 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,7 51,7 51,17 "},"children":[]}]};exports.basic_todolist_pen=basic_todolist_pen;var basic_todolist_pencil={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"24","x2":"38","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"34","x2":"38","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"44","x2":"38","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"54","x2":"38","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"24","x2":"8","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"34","x2":"8","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"44","x2":"8","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"54","x2":"8","y2":"54"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,8 1,8 1,63 45,63 45,8 32,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,5 27,1 19,1 19,5 15,5 13,13 33,13 31,5 \r\n\t"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,1 55,54 59,62 63,54 63,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"63","y2":"11"},"children":[]}]};exports.basic_todolist_pencil=basic_todolist_pencil;var basic_trashcan={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"20","x2":"26","y2":"54"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"20","x2":"26","y2":"54"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"20","x2":"38","y2":"54"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"20","x2":"38","y2":"54"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[]}]}]}]};exports.basic_trashcan=basic_trashcan;var basic_trashcan_full={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,36 58,34 62,48 56,50 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,36 58,34 62,48 56,50 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"10","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"36","height":"50"},"children":[{"name":"rect","attribs":{"x":"10","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"36","height":"50"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"22","x2":"22","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"22","x2":"22","y2":"56"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"22","x2":"34","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"22","x2":"34","y2":"56"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47.926","y1":"21.895","x2":"60","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47.926","y1":"21.895","x2":"60","y2":"63"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,13 14,6 22.857,6.143 25,13 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22.857,6.143 27,1 39,1 44,13 "},"children":[]}]};exports.basic_trashcan_full=basic_trashcan_full;var basic_trashcan_refresh={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,36c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,49 35,45 \r\n\t32,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,36c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,23 29,27 \r\n\t32,31 "},"children":[]}]};exports.basic_trashcan_refresh=basic_trashcan_refresh;var basic_trashcan_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,8 25,1 39,1 39,8 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,10 14,63 50,63 50,10 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"9","x2":"54","y2":"9"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"43","x2":"25","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"43","x2":"39","y2":"29"},"children":[]}]};exports.basic_trashcan_remove=basic_trashcan_remove;var basic_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"24,34 32,26 \r\n\t40,34 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"26","x2":"32","y2":"58"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"26","x2":"32","y2":"58"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"24,42 1,42 1,6 63,6 63,42 40,42 "},"children":[]}]};exports.basic_upload=basic_upload;var basic_usb={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"5.308","y":"4.601","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -6.0061 14.5)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18.385","height":"19.799"},"children":[]},{"name":"rect","attribs":{"x":"22.151","y":"15.08","transform":"matrix(0.7071 -0.7071 0.7071 0.7071 -15.3259 37)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"29.698","height":"43.841"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"13","x2":"16","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"7","x2":"22","y2":"16"},"children":[]}]};exports.basic_usb=basic_usb;var basic_video={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"46,30 63,20 63,52 46,42 46,52 1,52 1,20 \r\n\t\t46,20 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"46,30 63,20 63,52 46,42 46,52 1,52 1,20 \r\n\t\t46,20 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"28","x2":"10","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"28","x2":"10","y2":"28"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"28","x2":"18","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"28","x2":"18","y2":"28"},"children":[]}]},{"name":"rect","attribs":{"x":"7","y":"36","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"10"},"children":[{"name":"rect","attribs":{"x":"7","y":"36","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"6,12 32,12 40,20 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"6,12 32,12 40,20 \t"},"children":[]}]}]}]};exports.basic_video=basic_video;var basic_watch={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"20"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,15 20,1 44,1 44,15 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,49 44,63 20,63 20,49 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,20 32,32 40,36 "},"children":[]}]};exports.basic_watch=basic_watch;var basic_webpage={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]}]};exports.basic_webpage=basic_webpage;var basic_webpage_img_txt={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"25","x2":"33","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"33","x2":"33","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"41","x2":"33","y2":"41"},"children":[]},{"name":"rect","attribs":{"x":"38","y":"25","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"19","height":"16"},"children":[]}]};exports.basic_webpage_img_txt=basic_webpage_img_txt;var basic_webpage_multiple={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"42"},"children":[{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"54","height":"42"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,12 11,7 63,7 63,50 58,50 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,12 11,7 63,7 63,50 58,50 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"23","x2":"55","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"23","x2":"55","y2":"23"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"19","x2":"6","y2":"19"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"19","x2":"6","y2":"19"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"19","x2":"14","y2":"19"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"19","x2":"14","y2":"19"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"19","x2":"22","y2":"19"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"19","x2":"22","y2":"19"},"children":[]}]}]}]};exports.basic_webpage_multiple=basic_webpage_multiple;var basic_webpage_txt={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"25","x2":"58","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"33","x2":"58","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"41","x2":"58","y2":"41"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]}]};exports.basic_webpage_txt=basic_webpage_txt;var basic_world={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.001,0.887c17.184,0,31.113,13.929,31.112,31.113\r\n\tC63.114,49.185,49.184,63.115,32,63.113C14.815,63.114,0.887,49.185,0.888,32.001C0.885,14.816,14.815,0.887,32.001,0.887z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"1","x2":"32","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"32","x2":"1","y2":"32"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M30,1c0,0-14,11-14,31s14,31,14,31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34,1c0,0,14,11,14,31S34,63,34,63"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M8,12c0,0,5,10,24,10s24-10,24-10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M8,52c0,0,5-10,24-10s24,10,24,10"},"children":[]}]};exports.basic_world=basic_world;var basic_elaboration_bookmark_checck={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,1 46,1 46,62 32,48 18,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,22 30,29 \r\n\t43,16 "},"children":[]}]};exports.basic_elaboration_bookmark_checck=basic_elaboration_bookmark_checck;var basic_elaboration_bookmark_minus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"22","x2":"41","y2":"22"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,1 46,1 46,62 32,48 18,62 "},"children":[]}]};exports.basic_elaboration_bookmark_minus=basic_elaboration_bookmark_minus;var basic_elaboration_bookmark_plus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"22","x2":"41","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"13","x2":"32","y2":"31"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,1 46,1 46,62 32,48 18,62 "},"children":[]}]};exports.basic_elaboration_bookmark_plus=basic_elaboration_bookmark_plus;var basic_elaboration_bookmark_remove={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,1 46,1 46,62 32,48 18,62 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"29","x2":"25","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"29","x2":"39","y2":"15"},"children":[]}]};exports.basic_elaboration_bookmark_remove=basic_elaboration_bookmark_remove;var basic_elaboration_briefcase_check={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,22 30,29 \r\n\t43,16 "},"children":[]}]};exports.basic_elaboration_briefcase_check=basic_elaboration_briefcase_check;var basic_elaboration_briefcase_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,25 32,33 \r\n\t24,25 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"33","x2":"32","y2":"13"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"33","x2":"32","y2":"13"},"children":[]}]}]}]};exports.basic_elaboration_briefcase_download=basic_elaboration_briefcase_download;var basic_elaboration_briefcase_flagged={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"11","x2":"27","y2":"34"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,14 42,14 39.484,18 42,22 27,22 "},"children":[]}]};exports.basic_elaboration_briefcase_flagged=basic_elaboration_briefcase_flagged;var basic_elaboration_briefcase_minus={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"24","x2":"23","y2":"24"},"children":[]}]};exports.basic_elaboration_briefcase_minus=basic_elaboration_briefcase_minus;var basic_elaboration_briefcase_plus={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"15","x2":"32","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"24","x2":"23","y2":"24"},"children":[]}]};exports.basic_elaboration_briefcase_plus=basic_elaboration_briefcase_plus;var basic_elaboration_briefcase_refresh={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,24c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,37 36,33 \r\n\t33,29 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,24c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,11 30,15 \r\n\t33,19 "},"children":[]}]};exports.basic_elaboration_briefcase_refresh=basic_elaboration_briefcase_refresh;var basic_elaboration_briefcase_remove={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"31","x2":"25","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"31","x2":"39","y2":"17"},"children":[]}]};exports.basic_elaboration_briefcase_remove=basic_elaboration_briefcase_remove;var basic_elaboration_briefcase_search={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"21","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"21","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"25","x2":"41","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"25","x2":"41","y2":"33"},"children":[]}]}]}]};exports.basic_elaboration_briefcase_search=basic_elaboration_briefcase_search;var basic_elaboration_briefcase_star={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,27 25.875,31 \r\n\t28,24 22,20 29.213,20 32,12 35,20 42,20 36,24 37.938,31 "},"children":[]}]};exports.basic_elaboration_briefcase_star=basic_elaboration_briefcase_star;var basic_elaboration_briefcase_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,41 11,1 53,1 59,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M21,41c0,6.075,4.925,11,11,11s11-4.925,11-11h16v22\r\n\tH5V41H21z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,22 \r\n\t31.998,14 39.998,22 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"14","x2":"31.998","y2":"34"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"14","x2":"31.998","y2":"34"},"children":[]}]}]}]};exports.basic_elaboration_briefcase_upload=basic_elaboration_briefcase_upload;var basic_elaboration_browser_check={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,35 30,42 \r\n\t43,29 "},"children":[]}]};exports.basic_elaboration_browser_check=basic_elaboration_browser_check;var basic_elaboration_browser_download={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,38 32,46 \r\n\t24,38 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"46","x2":"32","y2":"26"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"46","x2":"32","y2":"26"},"children":[]}]}]}]};exports.basic_elaboration_browser_download=basic_elaboration_browser_download;var basic_elaboration_browser_minus={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"37","x2":"23","y2":"37"},"children":[]}]};exports.basic_elaboration_browser_minus=basic_elaboration_browser_minus;var basic_elaboration_browser_plus={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"28","x2":"32","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"37","x2":"23","y2":"37"},"children":[]}]};exports.basic_elaboration_browser_plus=basic_elaboration_browser_plus;var basic_elaboration_browser_refresh={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,37c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,50 36,46 \r\n\t33,42 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,37c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,24 30,28 \r\n\t33,32 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]}]};exports.basic_elaboration_browser_refresh=basic_elaboration_browser_refresh;var basic_elaboration_browser_remove={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"44","x2":"25","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"44","x2":"39","y2":"30"},"children":[]}]};exports.basic_elaboration_browser_remove=basic_elaboration_browser_remove;var basic_elaboration_browser_search={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"33","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"33","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"41","y2":"45"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"41","y2":"45"},"children":[]}]}]}]};exports.basic_elaboration_browser_search=basic_elaboration_browser_search;var basic_elaboration_browser_star={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,41 25.875,45 \r\n\t28,38 22,34 29.213,34 32,26 35,34 42,34 36,38 37.938,45 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]}]};exports.basic_elaboration_browser_star=basic_elaboration_browser_star;var basic_elaboration_browser_upload={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"15","x2":"63","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"11","x2":"6","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"11","x2":"14","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"11","x2":"22","y2":"11"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,35 \r\n\t31.998,27 39.998,35 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"27","x2":"31.998","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"27","x2":"31.998","y2":"47"},"children":[]}]}]}]};exports.basic_elaboration_browser_upload=basic_elaboration_browser_upload;var basic_elaboration_calendar_check={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,36 30,43 \r\n\t43,30 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_check=basic_elaboration_calendar_check;var basic_elaboration_calendar_cloud={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,44H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_cloud=basic_elaboration_calendar_cloud;var basic_elaboration_calendar_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,39 32,47 \r\n\t24,39 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"32","y2":"27"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"32","y2":"27"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_download=basic_elaboration_calendar_download;var basic_elaboration_calendar_empty={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_empty=basic_elaboration_calendar_empty;var basic_elaboration_calendar_flagged={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"27","x2":"27","y2":"50"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,30 42,30 39.484,34 42,38 27,38 "},"children":[]}]};exports.basic_elaboration_calendar_flagged=basic_elaboration_calendar_flagged;var basic_elaboration_calendar_heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,35c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,30,22,32.238,22,35z"},"children":[]}]};exports.basic_elaboration_calendar_heart=basic_elaboration_calendar_heart;var basic_elaboration_calendar_minus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"38","x2":"23","y2":"38"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_minus=basic_elaboration_calendar_minus;var basic_elaboration_calendar_next={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"34,30 42,38 \r\n\t34,46 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"38","x2":"22","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"38","x2":"22","y2":"38"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_next=basic_elaboration_calendar_next;var basic_elaboration_calendar_noaccess={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"38","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"31.834","x2":"38.166","y2":"44.166"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_noaccess=basic_elaboration_calendar_noaccess;var basic_elaboration_calendar_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,43 22,48 27,47 42,32 38,28 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,43 22,48 27,47 42,32 38,28 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"35","x2":"35","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"35","x2":"35","y2":"31"},"children":[]}]}]}]};exports.basic_elaboration_calendar_pencil=basic_elaboration_calendar_pencil;var basic_elaboration_calendar_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"29","x2":"32","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"38","x2":"23","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_plus=basic_elaboration_calendar_plus;var basic_elaboration_calendar_previous={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"30.001,46 \r\n\t22.001,38 30.001,30 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"38","x2":"42.001","y2":"38"},"children":[]}]};exports.basic_elaboration_calendar_previous=basic_elaboration_calendar_previous;var basic_elaboration_calendar_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,38c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,51 36,47 \r\n\t33,43 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,38c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,25 30,29 \r\n\t33,33 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_refresh=basic_elaboration_calendar_refresh;var basic_elaboration_calendar_remove={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"45","x2":"25","y2":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"45","x2":"39","y2":"31"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_remove=basic_elaboration_calendar_remove;var basic_elaboration_calendar_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_search=basic_elaboration_calendar_search;var basic_elaboration_calendar_star={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,43 25.875,47 \r\n\t28,40 22,36 29.213,36 32,28 35,36 42,36 36,40 37.938,47 "},"children":[]}]};exports.basic_elaboration_calendar_star=basic_elaboration_calendar_star;var basic_elaboration_calendar_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,36 \r\n\t31.998,28 39.998,36 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"28","x2":"31.998","y2":"48"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"28","x2":"31.998","y2":"48"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"10","x2":"18","y2":"10"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,10 1,10 1,58 63,58 63,10 52,10 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"12","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]},{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[{"name":"rect","attribs":{"x":"46","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"8"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"18","x2":"63","y2":"18"},"children":[]}]};exports.basic_elaboration_calendar_upload=basic_elaboration_calendar_upload;var basic_elaboration_cloud_check={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,34 30,41 \r\n\t43,28 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]}]};exports.basic_elaboration_cloud_check=basic_elaboration_cloud_check;var basic_elaboration_cloud_download={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,37 32,45 \r\n\t24,37 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[]}]}]}]};exports.basic_elaboration_cloud_download=basic_elaboration_cloud_download;var basic_elaboration_cloud_minus={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"34","x2":"23","y2":"34"},"children":[]}]};exports.basic_elaboration_cloud_minus=basic_elaboration_cloud_minus;var basic_elaboration_cloud_noaccess={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"34","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"27.834","x2":"38.166","y2":"40.166"},"children":[]}]};exports.basic_elaboration_cloud_noaccess=basic_elaboration_cloud_noaccess;var basic_elaboration_cloud_plus={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"25","x2":"32","y2":"43"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"34","x2":"23","y2":"34"},"children":[]}]};exports.basic_elaboration_cloud_plus=basic_elaboration_cloud_plus;var basic_elaboration_cloud_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,32c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,45 36,41 \r\n\t33,37 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,32c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,19 30,23 \r\n\t33,27 "},"children":[]}]};exports.basic_elaboration_cloud_refresh=basic_elaboration_cloud_refresh;var basic_elaboration_cloud_remove={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"41","x2":"25","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"41","x2":"39","y2":"27"},"children":[]}]};exports.basic_elaboration_cloud_remove=basic_elaboration_cloud_remove;var basic_elaboration_cloud_search={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"31","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"31","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"35","x2":"41","y2":"43"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"35","x2":"41","y2":"43"},"children":[]}]}]}]};exports.basic_elaboration_cloud_search=basic_elaboration_cloud_search;var basic_elaboration_cloud_upload={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,50h14c4.565,0,8-3.582,8-8s-3.435-8-8-8\r\n\tc0-11.046-9.52-20-20.934-20C23.966,14,14.8,20.732,13,30c0,0-0.831,0-1.667,0C5.626,30,1,34.477,1,40s4.293,10,10,10H41"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,34 \r\n\t31.998,26 39.998,34 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[]}]}]}]};exports.basic_elaboration_cloud_upload=basic_elaboration_cloud_upload;var basic_elaboration_document_check={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,36 30,43 \r\n\t43,30 "},"children":[]}]};exports.basic_elaboration_document_check=basic_elaboration_document_check;var basic_elaboration_document_cloud={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,42H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.basic_elaboration_document_cloud=basic_elaboration_document_cloud;var basic_elaboration_document_download={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,37 32,45 \r\n\t24,37 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[]}]}]}]};exports.basic_elaboration_document_download=basic_elaboration_document_download;var basic_elaboration_document_flagged={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"21","x2":"27","y2":"44"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,24 42,24 39.484,28 42,32 27,32 "},"children":[]}]};exports.basic_elaboration_document_flagged=basic_elaboration_document_flagged;var basic_elaboration_document_graph={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,44 27,37 23,37 23,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,44 27,37 23,37 23,44 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"34,44 34,27 30,27 30,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"34,44 34,27 30,27 30,44 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,44 41,34 37,34 37,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,44 41,34 37,34 37,44 \t\t"},"children":[]}]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"45","x2":"44","y2":"45"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"45","x2":"44","y2":"45"},"children":[]}]}]}]};exports.basic_elaboration_document_graph=basic_elaboration_document_graph;var basic_elaboration_document_heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,33c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,28,22,30.238,22,33z"},"children":[]}]};exports.basic_elaboration_document_heart=basic_elaboration_document_heart;var basic_elaboration_document_minus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]}]};exports.basic_elaboration_document_minus=basic_elaboration_document_minus;var basic_elaboration_document_next={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"34,28 42,36 \r\n\t34,44 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"36","x2":"22","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"36","x2":"22","y2":"36"},"children":[]}]}]}]};exports.basic_elaboration_document_next=basic_elaboration_document_next;var basic_elaboration_document_noaccess={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"36","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"29.834","x2":"38.166","y2":"42.166"},"children":[]}]};exports.basic_elaboration_document_noaccess=basic_elaboration_document_noaccess;var basic_elaboration_document_note={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"41","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"41","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"43","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"43","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,41 38,26 28,28 28,43 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,41 38,26 28,28 28,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"32","x2":"38","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"32","x2":"38","y2":"30"},"children":[]}]}]}]};exports.basic_elaboration_document_note=basic_elaboration_document_note;var basic_elaboration_document_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[]}]}]}]};exports.basic_elaboration_document_pencil=basic_elaboration_document_pencil;var basic_elaboration_document_picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"22","y":"29","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[{"name":"rect","attribs":{"x":"22","y":"29","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,41 29,34 33,39 35,37 41,42 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,41 29,34 33,39 35,37 41,42 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"32","r":"3"},"children":[]}]};exports.basic_elaboration_document_picture=basic_elaboration_document_picture;var basic_elaboration_document_plus={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"27","x2":"32","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]}]};exports.basic_elaboration_document_plus=basic_elaboration_document_plus;var basic_elaboration_document_previous={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"30.001,44 \r\n\t22.001,36 30.001,28 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"36","x2":"42.001","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"36","x2":"42.001","y2":"36"},"children":[]}]}]}]};exports.basic_elaboration_document_previous=basic_elaboration_document_previous;var basic_elaboration_document_refresh={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,36c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,49 36,45 \r\n\t33,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,36c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,23 30,27 \r\n\t33,31 "},"children":[]}]};exports.basic_elaboration_document_refresh=basic_elaboration_document_refresh;var basic_elaboration_document_remove={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"44","x2":"25","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"44","x2":"39","y2":"30"},"children":[]}]};exports.basic_elaboration_document_remove=basic_elaboration_document_remove;var basic_elaboration_document_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[]}]}]}]};exports.basic_elaboration_document_search=basic_elaboration_document_search;var basic_elaboration_document_star={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,39 25.875,43 \r\n\t28,36 22,32 29.213,32 32,24 35,32 42,32 36,36 37.938,43 "},"children":[]}]};exports.basic_elaboration_document_star=basic_elaboration_document_star;var basic_elaboration_document_upload={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,1 55,1 55,63 9,63 9,15 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,15 23,15 23,1 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,34 \r\n\t31.998,26 39.998,34 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[]}]}]}]};exports.basic_elaboration_document_upload=basic_elaboration_document_upload;var basic_elaboration_folder_check={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,36 30,43 \r\n\t43,30 "},"children":[]}]};exports.basic_elaboration_folder_check=basic_elaboration_folder_check;var basic_elaboration_folder_cloud={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,42H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.basic_elaboration_folder_cloud=basic_elaboration_folder_cloud;var basic_elaboration_folder_document={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,26 39,26 39,46 25,46 25,33 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,26 39,26 39,46 25,46 25,33 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,33 32,33 32,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,33 32,33 32,26 \t"},"children":[]}]}]}]};exports.basic_elaboration_folder_document=basic_elaboration_folder_document;var basic_elaboration_folder_download={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,37 32,45 \r\n\t24,37 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[]}]}]}]};exports.basic_elaboration_folder_download=basic_elaboration_folder_download;var basic_elaboration_folder_flagged={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"23","x2":"27","y2":"46"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,26 42,26 39.484,30 42,34 27,34 "},"children":[]}]};exports.basic_elaboration_folder_flagged=basic_elaboration_folder_flagged;var basic_elaboration_folder_graph={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,44 27,37 23,37 23,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,44 27,37 23,37 23,44 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"34,44 34,27 30,27 30,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"34,44 34,27 30,27 30,44 \t\t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,44 41,34 37,34 37,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,44 41,34 37,34 37,44 \t\t"},"children":[]}]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"45","x2":"44","y2":"45"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"45","x2":"44","y2":"45"},"children":[]}]}]}]};exports.basic_elaboration_folder_graph=basic_elaboration_folder_graph;var basic_elaboration_folder_heart={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,33c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,28,22,30.238,22,33z"},"children":[]}]};exports.basic_elaboration_folder_heart=basic_elaboration_folder_heart;var basic_elaboration_folder_minus={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]}]};exports.basic_elaboration_folder_minus=basic_elaboration_folder_minus;var basic_elaboration_folder_next={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"34,28 42,36 \r\n\t34,44 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"36","x2":"22","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"36","x2":"22","y2":"36"},"children":[]}]}]}]};exports.basic_elaboration_folder_next=basic_elaboration_folder_next;var basic_elaboration_folder_noaccess={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"36","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"29.834","x2":"38.166","y2":"42.166"},"children":[]}]};exports.basic_elaboration_folder_noaccess=basic_elaboration_folder_noaccess;var basic_elaboration_folder_note={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"41","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"41","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"43","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"43","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,41 38,26 28,28 28,43 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,41 38,26 28,28 28,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"32","x2":"38","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"32","x2":"38","y2":"30"},"children":[]}]}]}]};exports.basic_elaboration_folder_note=basic_elaboration_folder_note;var basic_elaboration_folder_pencil={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[]}]}]}]};exports.basic_elaboration_folder_pencil=basic_elaboration_folder_pencil;var basic_elaboration_folder_picture={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"22","y":"29","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[{"name":"rect","attribs":{"x":"22","y":"29","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,41 29,34 33,39 35,37 41,42 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,41 29,34 33,39 35,37 41,42 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"32","r":"3"},"children":[]}]};exports.basic_elaboration_folder_picture=basic_elaboration_folder_picture;var basic_elaboration_folder_plus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"27","x2":"32","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]}]};exports.basic_elaboration_folder_plus=basic_elaboration_folder_plus;var basic_elaboration_folder_previous={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"30.001,44 \r\n\t22.001,36 30.001,28 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"36","x2":"42.001","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"36","x2":"42.001","y2":"36"},"children":[]}]}]}]};exports.basic_elaboration_folder_previous=basic_elaboration_folder_previous;var basic_elaboration_folder_refresh={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,36c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,49 36,45 \r\n\t33,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,36c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,23 30,27 \r\n\t33,31 "},"children":[]}]};exports.basic_elaboration_folder_refresh=basic_elaboration_folder_refresh;var basic_elaboration_folder_remove={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"44","x2":"25","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"44","x2":"39","y2":"30"},"children":[]}]};exports.basic_elaboration_folder_remove=basic_elaboration_folder_remove;var basic_elaboration_folder_search={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"35","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"39","x2":"41","y2":"47"},"children":[]}]}]}]};exports.basic_elaboration_folder_search=basic_elaboration_folder_search;var basic_elaboration_folder_star={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,41 25.875,45 \r\n\t28,38 22,34 29.213,34 32,26 35,34 42,34 36,38 37.938,45 "},"children":[]}]};exports.basic_elaboration_folder_star=basic_elaboration_folder_star;var basic_elaboration_folder_upload={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,18 63,54 1,54 1,10 22,10 30,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,34 \r\n\t31.998,26 39.998,34 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[]}]}]}]};exports.basic_elaboration_folder_upload=basic_elaboration_folder_upload;var basic_elaboration_mail_check={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,20 30,27 \r\n\t43,14 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_check=basic_elaboration_mail_check;var basic_elaboration_mail_cloud={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,28H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_cloud=basic_elaboration_mail_cloud;var basic_elaboration_mail_document={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,10 39,10 39,30 25,30 25,17 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,10 39,10 39,30 25,30 25,17 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,17 32,17 32,10 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,17 32,17 32,10 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_document=basic_elaboration_mail_document;var basic_elaboration_mail_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,23 32,31 \r\n\t24,23 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"11"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"11"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_download=basic_elaboration_mail_download;var basic_elaboration_mail_flagged={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"9","x2":"27","y2":"32"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,12 42,12 39.484,16 42,20 27,20 "},"children":[]}]};exports.basic_elaboration_mail_flagged=basic_elaboration_mail_flagged;var basic_elaboration_mail_heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,19c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,14,22,16.238,22,19z"},"children":[]}]};exports.basic_elaboration_mail_heart=basic_elaboration_mail_heart;var basic_elaboration_mail_next={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"34,14 42,22 \r\n\t34,30 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"22","y2":"22"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"22","y2":"22"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_next=basic_elaboration_mail_next;var basic_elaboration_mail_noaccess={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"22","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"15.834","x2":"38.166","y2":"28.166"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_noaccess=basic_elaboration_mail_noaccess;var basic_elaboration_mail_note={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"27","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"27","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"29","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"29","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,27 38,12 28,14 28,29 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,27 38,12 28,14 28,29 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"18","x2":"38","y2":"16"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"18","x2":"38","y2":"16"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_note=basic_elaboration_mail_note;var basic_elaboration_mail_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,27 22,32 27,31 42,16 38,12 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,27 22,32 27,31 42,16 38,12 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"19","x2":"35","y2":"15"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"19","x2":"35","y2":"15"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_pencil=basic_elaboration_mail_pencil;var basic_elaboration_mail_picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"22","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[{"name":"rect","attribs":{"x":"22","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,27 29,20 33,25 35,23 41,28 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,27 29,20 33,25 35,23 41,28 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"18","r":"3"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_picture=basic_elaboration_mail_picture;var basic_elaboration_mail_previous={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"30.001,30 \r\n\t22.001,22 30.001,14 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"22","x2":"42.001","y2":"22"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22.001","y1":"22","x2":"42.001","y2":"22"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_previous=basic_elaboration_mail_previous;var basic_elaboration_mail_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,22c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,35 36,31 \r\n\t33,27 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,22c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,9 30,13 33,17 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_refresh=basic_elaboration_mail_refresh;var basic_elaboration_mail_remove={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"29","x2":"25","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"29","x2":"39","y2":"15"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.333,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.667,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_remove=basic_elaboration_mail_remove;var basic_elaboration_mail_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"19","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"19","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"23","x2":"41","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"23","x2":"41","y2":"31"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_search=basic_elaboration_mail_search;var basic_elaboration_mail_star={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,27 25.875,31 \r\n\t28,24 22,20 29.213,20 32,12 35,20 42,20 36,24 37.938,31 "},"children":[]}]};exports.basic_elaboration_mail_star=basic_elaboration_mail_star;var basic_elaboration_mail_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,20 \r\n\t31.998,12 39.998,20 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"12","x2":"31.998","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"12","x2":"31.998","y2":"32"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,26 32,45.434 63,26 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11.334,21.667 1,26 1,63 63,63 63,26 \r\n\t\t63,26 52.666,21.667 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,32 11,1 53,1 53,32 \t"},"children":[]}]}]}]};exports.basic_elaboration_mail_upload=basic_elaboration_mail_upload;var basic_elaboration_message_check={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,26 30,33 \r\n\t43,20 "},"children":[]}]};exports.basic_elaboration_message_check=basic_elaboration_message_check;var basic_elaboration_message_dots={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"26","x2":"35","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"26","x2":"45","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"26","x2":"25","y2":"26"},"children":[]}]};exports.basic_elaboration_message_dots=basic_elaboration_message_dots;var basic_elaboration_message_happy={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,30c0,4.418,3.582,8,8,8s8-3.582,8-8"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,30c0,4.418,3.582,8,8,8s8-3.582,8-8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"20","x2":"20","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"20","x2":"20","y2":"20"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"20","x2":"44","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"20","x2":"44","y2":"20"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 \t\r\n\t\t"},"children":[]}]}]}]};exports.basic_elaboration_message_happy=basic_elaboration_message_happy;var basic_elaboration_message_heart={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,23c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,18,22,20.238,22,23z"},"children":[]}]};exports.basic_elaboration_message_heart=basic_elaboration_message_heart;var basic_elaboration_message_minus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"26","x2":"23","y2":"26"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]}]};exports.basic_elaboration_message_minus=basic_elaboration_message_minus;var basic_elaboration_message_note={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"31","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"31","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"33","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"33","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,31 38,16 28,18 28,33 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,31 38,16 28,18 28,33 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"22","x2":"38","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"22","x2":"38","y2":"20"},"children":[]}]}]}]};exports.basic_elaboration_message_note=basic_elaboration_message_note;var basic_elaboration_message_plus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"32","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"26","x2":"23","y2":"26"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]}]};exports.basic_elaboration_message_plus=basic_elaboration_message_plus;var basic_elaboration_message_refresh={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,26c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,39 36,35 \r\n\t33,31 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,26c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,13 30,17 \r\n\t33,21 "},"children":[]}]};exports.basic_elaboration_message_refresh=basic_elaboration_message_refresh;var basic_elaboration_message_remove={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"25","y2":"19"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"33","x2":"39","y2":"19"},"children":[]}]};exports.basic_elaboration_message_remove=basic_elaboration_message_remove;var basic_elaboration_message_sad={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"20","x2":"20","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"20","x2":"20","y2":"20"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"20","x2":"44","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"20","x2":"44","y2":"20"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 63,47 63,5 1,5 1,47 18,47 18,59 \t\r\n\t\t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,38c0-4.418-3.582-8-8-8s-8,3.582-8,8"},"children":[]}]};exports.basic_elaboration_message_sad=basic_elaboration_message_sad;var basic_elaboration_smartphone_cloud={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,36H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.basic_elaboration_smartphone_cloud=basic_elaboration_smartphone_cloud;var basic_elaboration_smartphone_heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,27c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,22,22,24.238,22,27z"},"children":[]}]};exports.basic_elaboration_smartphone_heart=basic_elaboration_smartphone_heart;var basic_elaboration_smartphone_noaccess={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"30","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"23.834","x2":"38.166","y2":"36.166"},"children":[]}]};exports.basic_elaboration_smartphone_noaccess=basic_elaboration_smartphone_noaccess;var basic_elaboration_smartphone_note={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"35","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"35","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"37","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"37","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 38,20 28,22 28,37 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 38,20 28,22 28,37 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"26","x2":"38","y2":"24"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"26","x2":"38","y2":"24"},"children":[]}]}]}]};exports.basic_elaboration_smartphone_note=basic_elaboration_smartphone_note;var basic_elaboration_smartphone_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,35 22,40 27,39 42,24 38,20 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,35 22,40 27,39 42,24 38,20 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"27","x2":"35","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"27","x2":"35","y2":"23"},"children":[]}]}]}]};exports.basic_elaboration_smartphone_pencil=basic_elaboration_smartphone_pencil;var basic_elaboration_smartphone_picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"22","y":"23","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[{"name":"rect","attribs":{"x":"22","y":"23","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,35 29,28 33,33 35,31 41,36 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,35 29,28 33,33 35,31 41,36 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"26","r":"3"},"children":[]}]};exports.basic_elaboration_smartphone_picture=basic_elaboration_smartphone_picture;var basic_elaboration_smartphone_refresh={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,30c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,43 36,39 \r\n\t33,35 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,30c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,17 30,21 \r\n\t33,25 "},"children":[]}]};exports.basic_elaboration_smartphone_refresh=basic_elaboration_smartphone_refresh;var basic_elaboration_smartphone_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"51","x2":"48","y2":"51"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"9","x2":"48","y2":"9"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"27","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"27","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"31","x2":"41","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"31","x2":"41","y2":"39"},"children":[]}]}]}]};exports.basic_elaboration_smartphone_search=basic_elaboration_smartphone_search;var basic_elaboration_tablet_cloud={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,36H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_cloud=basic_elaboration_tablet_cloud;var basic_elaboration_tablet_heart={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,27c0,6.666,10,12,10,12s10-5.334,10-12\r\n\tc0-2.762-2-5-5-5c-2.762,0-5,2.238-5,5c0-2.762-2.238-5-5-5C24,22,22,24.238,22,27z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_heart=basic_elaboration_tablet_heart;var basic_elaboration_tablet_noaccess={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"30","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"23.834","x2":"38.166","y2":"36.166"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_noaccess=basic_elaboration_tablet_noaccess;var basic_elaboration_tablet_note={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"35","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"35","r":"3"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"37","r":"3"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"25","cy":"37","r":"3"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 38,20 28,22 28,37 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 38,20 28,22 28,37 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"26","x2":"38","y2":"24"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"26","x2":"38","y2":"24"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_note=basic_elaboration_tablet_note;var basic_elaboration_tablet_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,35 22,40 27,39 42,24 38,20 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,35 22,40 27,39 42,24 38,20 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"27","x2":"35","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"27","x2":"35","y2":"23"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_pencil=basic_elaboration_tablet_pencil;var basic_elaboration_tablet_picture={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"22","y":"23","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[{"name":"rect","attribs":{"x":"22","y":"23","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"14"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,35 29,28 33,33 35,31 41,36 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,35 29,28 33,33 35,31 41,36 \t"},"children":[]}]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"39","cy":"26","r":"3"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_picture=basic_elaboration_tablet_picture;var basic_elaboration_tablet_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,30c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,43 36,39 \r\n\t33,35 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,30c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,17 30,21 \r\n\t33,25 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_refresh=basic_elaboration_tablet_refresh;var basic_elaboration_tablet_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"27","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"27","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"31","x2":"41","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"31","x2":"41","y2":"39"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[{"name":"rect","attribs":{"x":"11","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"5","x2":"36","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"51","x2":"53","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"9","x2":"53","y2":"9"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"32","cy":"57","r":"2"},"children":[]}]};exports.basic_elaboration_tablet_search=basic_elaboration_tablet_search;var basic_elaboration_todolist_2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]},{"name":"rect","attribs":{"x":"14","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"36","height":"46"},"children":[]}]};exports.basic_elaboration_todolist_2=basic_elaboration_todolist_2;var basic_elaboration_todolist_check={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,34 30,41 \r\n\t43,28 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_check=basic_elaboration_todolist_check;var basic_elaboration_todolist_cloud={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,42H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_cloud=basic_elaboration_todolist_cloud;var basic_elaboration_todolist_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,37 32,45 \r\n\t24,37 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"45","x2":"32","y2":"25"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_download=basic_elaboration_todolist_download;var basic_elaboration_todolist_flagged={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"23","x2":"27","y2":"46"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,26 42,26 39.484,30 42,34 27,34 "},"children":[]}]};exports.basic_elaboration_todolist_flagged=basic_elaboration_todolist_flagged;var basic_elaboration_todolist_minus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_minus=basic_elaboration_todolist_minus;var basic_elaboration_todolist_noaccess={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"36","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25.834","y1":"29.834","x2":"38.166","y2":"42.166"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_noaccess=basic_elaboration_todolist_noaccess;var basic_elaboration_todolist_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 22,46 27,45 42,30 38,26 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"33","x2":"35","y2":"29"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_pencil=basic_elaboration_todolist_pencil;var basic_elaboration_todolist_plus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"27","x2":"32","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"36","x2":"23","y2":"36"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_plus=basic_elaboration_todolist_plus;var basic_elaboration_todolist_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,36c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,49 36,45 \r\n\t33,41 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,36c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,23 30,27 \r\n\t33,31 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_refresh=basic_elaboration_todolist_refresh;var basic_elaboration_todolist_remove={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"43","x2":"25","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"43","x2":"39","y2":"29"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_remove=basic_elaboration_todolist_remove;var basic_elaboration_todolist_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"33","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"33","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"41","y2":"45"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"41","y2":"45"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_search=basic_elaboration_todolist_search;var basic_elaboration_todolist_star={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"round","stroke-miterlimit":"10","points":"32,41 25.875,45 \r\n\t28,38 22,34 29.213,34 32,26 35,34 42,34 36,38 37.938,45 "},"children":[]}]};exports.basic_elaboration_todolist_star=basic_elaboration_todolist_star;var basic_elaboration_todolist_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,34 \r\n\t31.998,26 39.998,34 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"26","x2":"31.998","y2":"46"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,8 10,8 10,63 54,63 54,8 41,8 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,5 36,1 28,1 28,5 24,5 22,13 42,13 40,5 \r\n\t"},"children":[]}]};exports.basic_elaboration_todolist_upload=basic_elaboration_todolist_upload;var ecommerce_bag={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag=ecommerce_bag;var ecommerce_bag_check={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,40 30,47 \r\n\t43,34 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_check=ecommerce_bag_check;var ecommerce_bag_cloud={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,48H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.ecommerce_bag_cloud=ecommerce_bag_cloud;var ecommerce_bag_download={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,43 32,51 \r\n\t24,43 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"31"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"31"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_download=ecommerce_bag_download;var ecommerce_bag_minus={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"42","x2":"23","y2":"42"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_minus=ecommerce_bag_minus;var ecommerce_bag_plus={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"33","x2":"32","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"42","x2":"23","y2":"42"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_plus=ecommerce_bag_plus;var ecommerce_bag_refresh={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,42c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,55 36,51 \r\n\t33,47 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,42c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"33,29 30,33 \r\n\t33,37 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_refresh=ecommerce_bag_refresh;var ecommerce_bag_remove={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"49","x2":"25","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"49","x2":"39","y2":"35"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_remove=ecommerce_bag_remove;var ecommerce_bag_search={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"39","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"39","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"43","x2":"41","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"43","x2":"41","y2":"51"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_search=ecommerce_bag_search;var ecommerce_bag_upload={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,40 \r\n\t31.998,32 39.998,40 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"32","x2":"31.998","y2":"52"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"32","x2":"31.998","y2":"52"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,18 54,18 54,63 10,63 10,18 20,18 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22,24V11c0-5.523,4.477-10,10-10s10,4.477,10,10v13\r\n\t"},"children":[]}]};exports.ecommerce_bag_upload=ecommerce_bag_upload;var ecommerce_banknote={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"16","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"32"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M10,44c0-2.762-2.238-5-5-5V25c2.762,0,5-2.238,5-5\r\n\th44c0,2.762,2.238,5,5,5v14c-2.762,0-5,2.238-5,5H10z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"8"},"children":[]}]};exports.ecommerce_banknote=ecommerce_banknote;var ecommerce_banknotes={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"24","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"26"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,22 11,14 63,14 63,40 55,40 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M10,46c0-3-2-4-5-4V32c3,0,5-1,5-4h35c0,3,2,4,4,4\r\n\tv10c-2,0-4,1-4,4H10z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"27","cy":"37","r":"5"},"children":[]}]};exports.ecommerce_banknotes=ecommerce_banknotes;var ecommerce_basket={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]}]};exports.ecommerce_basket=ecommerce_basket;var ecommerce_basket_check={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23,41 30,48 \r\n\t43,35 "},"children":[]}]};exports.ecommerce_basket_check=ecommerce_basket_check;var ecommerce_basket_cloud={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M34.887,48H39c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.ecommerce_basket_cloud=ecommerce_basket_cloud;var ecommerce_basket_download={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,44 32,52 \r\n\t24,44 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"52","x2":"32","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"52","x2":"32","y2":"32"},"children":[]}]}]}]};exports.ecommerce_basket_download=ecommerce_basket_download;var ecommerce_basket_minus={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"43","x2":"23","y2":"43"},"children":[]}]};exports.ecommerce_basket_minus=ecommerce_basket_minus;var ecommerce_basket_plus={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"34","x2":"32","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"43","x2":"23","y2":"43"},"children":[]}]};exports.ecommerce_basket_plus=ecommerce_basket_plus;var ecommerce_basket_refresh={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,42c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,55 35,51 \r\n\t32,47 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,42c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,29 29,33 \r\n\t32,37 "},"children":[]}]};exports.ecommerce_basket_refresh=ecommerce_basket_refresh;var ecommerce_basket_remove={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"50","x2":"25","y2":"36"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"50","x2":"39","y2":"36"},"children":[]}]};exports.ecommerce_basket_remove=ecommerce_basket_remove;var ecommerce_basket_search={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"40","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"29","cy":"40","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"44","x2":"41","y2":"52"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"44","x2":"41","y2":"52"},"children":[]}]}]}]};exports.ecommerce_basket_search=ecommerce_basket_search;var ecommerce_basket_upload={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,25 12,59 52,59 63,25 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"25","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"25","x2":"42","y2":"5"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"23.998,41 \r\n\t31.998,33 39.998,41 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"33","x2":"31.998","y2":"53"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31.998","y1":"33","x2":"31.998","y2":"53"},"children":[]}]}]}]};exports.ecommerce_basket_upload=ecommerce_basket_upload;var ecommerce_bath={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"16"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,17h5.443c0,0,8.562-0.783,8.562,7\r\n\ts-8.562,7-8.562,7H24"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,31h6.221c0,0,9.781-0.893,9.781,8\r\n\ts-9.781,8-9.781,8H24"},"children":[]},{"name":"rect","attribs":{"x":"29","y":"13","width":"2","height":"39"},"children":[]}]};exports.ecommerce_bath=ecommerce_bath;var ecommerce_cart={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,10 22,4 32,4 34,10 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,4 37,1 53,1 56,10 "},"children":[]}]};exports.ecommerce_cart=ecommerce_cart;var ecommerce_cart_check={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,24 34,31 \r\n\t47,18 "},"children":[]}]};exports.ecommerce_cart_check=ecommerce_cart_check;var ecommerce_cart_cloud={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M38.887,31H43c1.887,0,3-1,3-3c0-1-1-3-3-3\r\n\tc0-3.604-3.277-6-7-6c-3.295,0-6.413,2.978-7,6l0,0c-2,0-3,2-3,3c0,2,1,3,3,3h10.434"},"children":[]}]};exports.ecommerce_cart_cloud=ecommerce_cart_cloud;var ecommerce_cart_content={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]}]};exports.ecommerce_cart_content=ecommerce_cart_content;var ecommerce_cart_download={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"44,27 36,35 \r\n\t28,27 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"35","x2":"36","y2":"15"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"35","x2":"36","y2":"15"},"children":[]}]}]}]};exports.ecommerce_cart_download=ecommerce_cart_download;var ecommerce_cart_minus={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"26","x2":"27","y2":"26"},"children":[]}]};exports.ecommerce_cart_minus=ecommerce_cart_minus;var ecommerce_cart_plus={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"17","x2":"36","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"26","x2":"27","y2":"26"},"children":[]}]};exports.ecommerce_cart_plus=ecommerce_cart_plus;var ecommerce_cart_refresh={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M28,26c0,4.418,3.582,9,8,9h4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,39 40,35 \r\n\t37,31 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M46,26c0-4.418-3.582-9-8-9h-4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,13 34,17 \r\n\t37,21 "},"children":[]}]};exports.ecommerce_cart_refresh=ecommerce_cart_refresh;var ecommerce_cart_remove={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"33","x2":"29","y2":"19"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"33","x2":"43","y2":"19"},"children":[]}]};exports.ecommerce_cart_remove=ecommerce_cart_remove;var ecommerce_cart_search={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"33","cy":"23","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"33","cy":"23","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"27","x2":"45","y2":"35"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"27","x2":"45","y2":"35"},"children":[]}]}]}]};exports.ecommerce_cart_search=ecommerce_cart_search;var ecommerce_cart_upload={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"57","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"57","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"57","x2":"38","y2":"57"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"14,57 10,2 0,2 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"13,43 56,40 63,10 11,10 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27.998,24 \r\n\t35.998,16 43.998,24 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35.998","y1":"16","x2":"35.998","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35.998","y1":"16","x2":"35.998","y2":"36"},"children":[]}]}]}]};exports.ecommerce_cart_upload=ecommerce_cart_upload;var ecommerce_cent={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,43c0,0-1,4-10,4s-12-7-12-15s3-15,12-15\r\n\ts10,4,10,4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"12","x2":"32","y2":"52"},"children":[]}]};exports.ecommerce_cent=ecommerce_cent;var ecommerce_colon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,43c0,0-1,4-10,4s-12-7-12-15s3-15,12-15\r\n\ts10,4,10,4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"14","x2":"21","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"14","x2":"26","y2":"49"},"children":[]}]};exports.ecommerce_colon=ecommerce_colon;var ecommerce_creditcard={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"11","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"42"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"17","x2":"63","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"25","x2":"63","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"47","x2":"10","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"47","x2":"41","y2":"47"},"children":[]}]};exports.ecommerce_creditcard=ecommerce_creditcard;var ecommerce_diamond={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,6 46,6 63,27 32,58 1,27 18,6 32,6 \r\n\t\t32,58 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,6 46,6 63,27 32,58 1,27 18,6 32,6 \r\n\t\t32,58 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,57 18,27 24,6 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,57 18,27 24,6 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,57 46,27 40,6 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,57 46,27 40,6 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"27","x2":"63","y2":"27"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"27","x2":"63","y2":"27"},"children":[]}]}]}]};exports.ecommerce_diamond=ecommerce_diamond;var ecommerce_dollar={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"29","y":"13","width":"2","height":"39"},"children":[]},{"name":"rect","attribs":{"x":"33","y":"13","width":"2","height":"39"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40.988,23c0,0,0-6-9-6s-8,7-8,7s0,7,8,7\r\n\tc9,0,10.012,6,10.012,7c0,2,0.988,8-10.012,8c-9,0-8.988-4-8.988-5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]};exports.ecommerce_dollar=ecommerce_dollar;var ecommerce_euro={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,43c0,0-1,4-10,4s-12-7-12-15s3-15,12-15\r\n\ts10,4,10,4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"30","x2":"34","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"34","x2":"34","y2":"34"},"children":[]}]};exports.ecommerce_euro=ecommerce_euro;var ecommerce_franc={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,48 25,18 41,18 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"32","x2":"39","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"38","x2":"34","y2":"38"},"children":[]}]};exports.ecommerce_franc=ecommerce_franc;var ecommerce_gift={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"18","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"9"},"children":[]},{"name":"rect","attribs":{"x":"6","y":"27","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"58","x2":"32","y2":"18"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,18c0,0-13,0.101-13-9c0-7,13-4.068,13,2\r\n\tC32,17.067,32,18,32,18z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,18c0,0,13,0.101,13-9c0-7-13-4.068-13,2\r\n\tC32,17.067,32,18,32,18z"},"children":[]}]};exports.ecommerce_gift=ecommerce_gift;var ecommerce_graph1={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M54.999,36.001C55,50.913,42.912,63,28,62.999\r\n\tC13.087,63,1,50.912,1.001,36C1,21.088,13.088,9,28,9.001V36L54.999,36.001z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M63,28C63.001,13.087,50.914,0.998,36.001,1v27H63z"},"children":[]}]};exports.ecommerce_graph1=ecommerce_graph1;var ecommerce_graph2={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"10","y":"29","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"34"},"children":[]},{"name":"rect","attribs":{"x":"42","y":"39","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"24"},"children":[]},{"name":"rect","attribs":{"x":"26","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"62"},"children":[]}]};exports.ecommerce_graph2=ecommerce_graph2;var ecommerce_graph3={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"56","cy":"34","r":"3"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"22","cy":"4","r":"3"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"40","cy":"50","r":"3"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"7","cy":"31","r":"3"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"28","x2":"20","y2":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"48","x2":"54","y2":"36"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"57","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"6","x2":"38","y2":"47"},"children":[]}]};exports.ecommerce_graph3=ecommerce_graph3;var ecommerce_graph_decrease={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"10","y":"16","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"47"},"children":[]},{"name":"rect","attribs":{"x":"42","y":"45","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"18"},"children":[]},{"name":"rect","attribs":{"x":"26","y":"32","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"31"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"1","x2":"54","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"1","x2":"54","y2":"39"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"43,39 54,39 \r\n\t\t54,28 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"43,39 54,39 \r\n\t\t54,28 \t"},"children":[]}]}]}]};exports.ecommerce_graph_decrease=ecommerce_graph_decrease;var ecommerce_graph_increase={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"10","y":"45","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"18"},"children":[]},{"name":"rect","attribs":{"x":"42","y":"18","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"45"},"children":[]},{"name":"rect","attribs":{"x":"26","y":"32","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"31"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"38","x2":"51","y2":"1"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"38","x2":"51","y2":"1"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,1 51,1 51,12 \r\n\t\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,1 51,1 51,12 \r\n\t\t\t"},"children":[]}]}]}]};exports.ecommerce_graph_increase=ecommerce_graph_increase;var ecommerce_guarani={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,21c0,0-1-4-10-4s-12,7-12,15s3,15,12,15\r\n\ts10-4,10-4v-7h-6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"12","x2":"32","y2":"52"},"children":[]}]};exports.ecommerce_guarani=ecommerce_guarani;var ecommerce_kips={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"16","x2":"25","y2":"48"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,48 26,31 42,16 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"31","x2":"39","y2":"31"},"children":[]}]};exports.ecommerce_kips=ecommerce_kips;var ecommerce_lira={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,19c0,0-1.059-3-6-3s-9,2-9,7s0,26,0,26h14"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"49","x2":"27","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"32","x2":"35","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"38","x2":"35","y2":"38"},"children":[]}]};exports.ecommerce_lira=ecommerce_lira;var ecommerce_megaphone={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,29 1,35 7,41 45.5,41 61,53 63,53 63,29 \r\n\t63,5 61,5 45.5,17 7,17 1,23 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"19,41 12,59 18,59 28,41 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"17","x2":"43","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"36","y1":"41","x2":"36","y2":"17"},"children":[]}]};exports.ecommerce_megaphone=ecommerce_megaphone;var ecommerce_money={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"38","r":"19"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"38","r":"13"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"30,51 1,51 1,57 38,57 38,56 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,45 3,45 3,51 30,51 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"26,39 5,39 5,45 27,45 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"26,33 1,33 1,39 26,39 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,27 3,27 3,33 26,33 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"35,21 1,21 1,27 29,27 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"40,20 40,15 3,15 3,21 35,21 "},"children":[]},{"name":"rect","attribs":{"x":"1","y":"9","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"37","height":"6"},"children":[]}]};exports.ecommerce_money=ecommerce_money;var ecommerce_naira={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,49 22,18 23,18 39,48 40,48 40,17 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"30","x2":"45","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"36","x2":"45","y2":"36"},"children":[]}]};exports.ecommerce_naira=ecommerce_naira;var ecommerce_pesos={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"16"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,17h7c0,0,11-1,11,9s-11,9-11,9h-7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"24","x2":"47","y2":"24"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"28","x2":"47","y2":"28"},"children":[]}]};exports.ecommerce_pesos=ecommerce_pesos;var ecommerce_pound={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,19c0,0-1.059-3-6-3c-4.941,0-9,2-9,7s0,26,0,26\r\n\th14"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"49","x2":"27","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"32","x2":"35","y2":"32"},"children":[]}]};exports.ecommerce_pound=ecommerce_pound;var ecommerce_receipt={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"14.999","x2":"46","y2":"14.999"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"14.999","x2":"46","y2":"14.999"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"23.999","x2":"46","y2":"23.999"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"23.999","x2":"46","y2":"23.999"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"33.999","x2":"46","y2":"33.999"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"33.999","x2":"46","y2":"33.999"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"43.999","x2":"46","y2":"43.999"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"43.999","x2":"46","y2":"43.999"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"53.999","x2":"46","y2":"53.999"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"53.999","x2":"46","y2":"53.999"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]}]};exports.ecommerce_receipt=ecommerce_receipt;var ecommerce_receipt_bath={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"48","x2":"26","y2":"22"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M26,23h5c0,0,6,0,6,6c0,5-6,5-6,5h-5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,34h5c0,0,7-0.226,7,7c0,6-7,6-7,6h-6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"20","x2":"32","y2":"50"},"children":[]}]};exports.ecommerce_receipt_bath=ecommerce_receipt_bath;var ecommerce_receipt_cent={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,42c0,0-0.933,4-8,4c-7.066,0-9-5.719-9-12\r\n\ts1.934-11,9-11c7.067,0,8,3,8,3"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"20","x2":"34","y2":"49"},"children":[]}]};exports.ecommerce_receipt_cent=ecommerce_receipt_cent;var ecommerce_receipt_dollar={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M38,28c0,0,0.161-4-6-4s-6,3-6,5s0.523,4,6,4\r\n\tc6.161,0,7,4.315,7,5c0,1.369,0.53,6-7,6c-6.161,0-6-3.315-6-4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"21","x2":"34","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"21","x2":"30","y2":"48"},"children":[]}]};exports.ecommerce_receipt_dollar=ecommerce_receipt_dollar;var ecommerce_receipt_euro={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,42c0,0-0.933,4-8,4c-7.066,0-9-5.719-9-12\r\n\ts1.934-11,9-11c7.067,0,8,3,8,3"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"33","x2":"36","y2":"33"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"37","x2":"36","y2":"37"},"children":[]}]};exports.ecommerce_receipt_euro=ecommerce_receipt_euro;var ecommerce_receipt_franc={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27,48 27,21 40,21 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"34","x2":"38","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"39","x2":"34","y2":"39"},"children":[]}]};exports.ecommerce_receipt_franc=ecommerce_receipt_franc;var ecommerce_receipt_guarani={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,26c0,0-0.933-3-8-3c-7.066,0-9,4.719-9,11\r\n\ts1.934,12,9,12c7.067,0,8-4,8-4v-5h-4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"20","x2":"34","y2":"49"},"children":[]}]};exports.ecommerce_receipt_guarani=ecommerce_receipt_guarani;var ecommerce_receipt_kips={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"20","x2":"27","y2":"48"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,48 26.916,33.125 40.024,20 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"33","x2":"37","y2":"33"},"children":[]}]};exports.ecommerce_receipt_kips=ecommerce_receipt_kips;var ecommerce_receipt_lira={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M39,23c0,0-1.062-1.916-4.941-1.916\r\n\tC30.178,21.084,27,22.074,27,26c0,3.927,0,21,0,21h11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"34","x2":"34","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"38","x2":"34","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"47","x2":"27","y2":"47"},"children":[]}]};exports.ecommerce_receipt_lira=ecommerce_receipt_lira;var ecommerce_receipt_naira={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,48 25,21 25.929,21 39.071,47 40,47 \r\n\t40,20 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"31","x2":"44","y2":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"37","x2":"44","y2":"37"},"children":[]}]};exports.ecommerce_receipt_naira=ecommerce_receipt_naira;var ecommerce_receipt_pesos={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"20"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,21h6c0,0,10.018-0.703,10.018,8S30,37,30,37h-6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"27","x2":"44","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"31","x2":"44","y2":"31"},"children":[]}]};exports.ecommerce_receipt_pesos=ecommerce_receipt_pesos;var ecommerce_receipt_pound={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M39,23c0,0-1.062-1.916-4.941-1.916\r\n\tC30.178,21.084,27,22.074,27,26c0,3.927,0,21,0,21h11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"34","x2":"34","y2":"34"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"47","x2":"27","y2":"47"},"children":[]}]};exports.ecommerce_receipt_pound=ecommerce_receipt_pound;var ecommerce_receipt_rublo={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"48","x2":"26","y2":"20"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M26,21h5.953c0,0,10.078-0.723,10.078,8\r\n\ts-10.078,8-10.078,8H22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"42","x2":"33","y2":"42"},"children":[]}]};exports.ecommerce_receipt_rublo=ecommerce_receipt_rublo;var ecommerce_receipt_rupee={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M35.062,49.938L22,38v-1h6c0,0,10,0.75,10-8\r\n\tc0-7.875-10-8-10-8h-7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"21","x2":"43","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"26","x2":"43","y2":"26"},"children":[]}]};exports.ecommerce_receipt_rupee=ecommerce_receipt_rupee;var ecommerce_receipt_tugrik={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"32","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"21","x2":"43","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"26","x2":"27","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"31","x2":"27","y2":"37"},"children":[]}]};exports.ecommerce_receipt_tugrik=ecommerce_receipt_tugrik;var ecommerce_receipt_won={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,20 24,47 25,47 31,22 33,22 39,47 \r\n\t40,47 46,20 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"32","x2":"48","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"37","x2":"48","y2":"37"},"children":[]}]};exports.ecommerce_receipt_won=ecommerce_receipt_won;var ecommerce_receipt_yen={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,22 32,36 32,48 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,22 32,36 32,48 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"32","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"22","x2":"32","y2":"36"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"38","x2":"41","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"38","x2":"41","y2":"38"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"33","x2":"41","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"33","x2":"41","y2":"33"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"33","x2":"30","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"33","x2":"30","y2":"33"},"children":[]}]}]}]};exports.ecommerce_receipt_yen=ecommerce_receipt_yen;var ecommerce_receipt_yen2={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"21","x2":"42","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"26","x2":"45","y2":"26"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M28,27v16c0,0-0.602,4-3.121,4H22"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M36,27v17c0,0,0.637,3,3.997,3H42"},"children":[]}]};exports.ecommerce_receipt_yen2=ecommerce_receipt_yen2;var ecommerce_recept_colon={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"52,62.999 52,0.999 26,0.999 12,14.999 \r\n\t\t12,63 16,61 20,63 24,61 28,63 32,61 36,63 40,61 44,63 48,61 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,14.999 26,14.999 26,0.999 \t"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M42,42c0,0-0.933,4-8,4c-7.066,0-9-5.719-9-12\r\n\ts1.934-11,9-11c7.067,0,8,3,8,3"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37.869","y1":"20","x2":"24","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"21","x2":"28","y2":"48"},"children":[]}]};exports.ecommerce_recept_colon=ecommerce_recept_colon;var ecommerce_rublo={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"16"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,17h7c0,0,11-1,11,9s-11,9-11,9H19"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"41","x2":"32","y2":"41"},"children":[]}]};exports.ecommerce_rublo=ecommerce_rublo;var ecommerce_rupee={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M36,50L21,36v-1h7c0,0,11,1,11-9c0-9-11-9-11-9h-8"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"17","x2":"44","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"23","x2":"44","y2":"23"},"children":[]}]};exports.ecommerce_rupee=ecommerce_rupee;var ecommerce_safe={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"5","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"54"},"children":[]},{"name":"rect","attribs":{"x":"11","y":"11","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"46","height":"42"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"17","x2":"12","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"27","x2":"12","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"37","x2":"12","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"47","x2":"12","y2":"47"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"32","r":"3"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"32","r":"9"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"32","x2":"41","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"29","x2":"44","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"32","x2":"53","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"35","x2":"44","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"34","x2":"50","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"46","y1":"30","x2":"50","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"30","x2":"38","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"34","x2":"38.026","y2":"38"},"children":[]}]};exports.ecommerce_safe=ecommerce_safe;var ecommerce_sale={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,1 63,39 39,63 1,25 1,1 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,1 63,39 39,63 1,25 1,1 \t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"17","cy":"17","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"17","cy":"17","r":"6"},"children":[]}]}]}]};exports.ecommerce_sale=ecommerce_sale;var ecommerce_sales={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"21.903,5 55,38.097 34.097,59 1,25.903 \r\n\t\t1,5 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"21.903,5 55,38.097 34.097,59 1,25.903 \r\n\t\t1,5 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29.903,5 63,38.097 42.097,59 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29.903,5 63,38.097 42.097,59 \t"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"14","cy":"18","r":"5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"14","cy":"18","r":"5"},"children":[]}]}]}]};exports.ecommerce_sales=ecommerce_sales;var ecommerce_ticket={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M57,18c-1.504,1.504-2.705,2-5,2\r\n\t\tc-4.59,0-8-3.41-8-8c0-2.295,0.496-3.496,2-5l-6-6L1,40l6,6c1.504-1.504,2.705-2,5-2c4.59,0,8,3.41,8,8c0,2.295-0.496,3.496-2,5\r\n\t\tl6,6l39-39L57,18z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M57,18c-1.504,1.504-2.705,2-5,2\r\n\t\tc-4.59,0-8-3.41-8-8c0-2.295,0.496-3.496,2-5l-6-6L1,40l6,6c1.504-1.504,2.705-2,5-2c4.59,0,8,3.41,8,8c0,2.295-0.496,3.496-2,5\r\n\t\tl6,6l39-39L57,18z"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"15","x2":"30","y2":"19"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"15","x2":"30","y2":"19"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"34","x2":"49","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"34","x2":"49","y2":"38"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"21","x2":"36","y2":"25"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"28","x2":"43","y2":"32"},"children":[]}]};exports.ecommerce_ticket=ecommerce_ticket;var ecommerce_tugriks={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"32","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"18","y1":"17","x2":"46","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"24","x2":"25","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"30","x2":"25","y2":"38"},"children":[]}]};exports.ecommerce_tugriks=ecommerce_tugriks;var ecommerce_wallet={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61,44 61,55 1,55 1,15 61,15 61,26 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"6,9 54,9 54,15 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M6,9c-2.762,0-5,2.239-5,5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M43.125,26c-4.972,0-9,4.029-9,9c0,4.97,4.028,9,9,9\r\n\tH63V26H43.125z"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"44","cy":"35","r":"3"},"children":[]}]};exports.ecommerce_wallet=ecommerce_wallet;var ecommerce_won={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"15,16 23,48 24,48 31,18 33,18 40,48 \r\n\t41,48 49,16 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"30","x2":"51","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"36","x2":"51","y2":"36"},"children":[]}]};exports.ecommerce_won=ecommerce_won;var ecommerce_yen={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,16 32,33 32,48 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,16 32,33 32,48 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"16","x2":"32","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"16","x2":"32","y2":"33"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"36","x2":"43","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"36","x2":"43","y2":"36"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"30","x2":"43","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"30","x2":"43","y2":"30"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"30","x2":"30","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"30","x2":"30","y2":"30"},"children":[]}]}]}]};exports.ecommerce_yen=ecommerce_yen;var ecommerce_yen2={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"17","x2":"44","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"23","x2":"48","y2":"23"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M26,23v20c0,0,0,5-3,5h-4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M37,23v21c0,0,0,4,4,4h2"},"children":[]}]};exports.ecommerce_yen2=ecommerce_yen2;var music_beginning_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,43 18,32 \r\n\t\t32,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,43 18,32 \r\n\t\t32,21 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,43 38,32 \r\n\t\t52,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,43 38,32 \r\n\t\t52,21 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"41","x2":"12","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"41","x2":"12","y2":"23"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_beginning_button=music_beginning_button;var music_bell={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,55h25v-4l-7-7V25c0-9.941-8.059-18-18-18\r\n\ts-18,8.059-18,18v19l-7,7v4H32z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"41","x2":"50","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"35","x2":"50","y2":"35"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M39,55c0,4.418-3.582,8-8,8s-8-3.582-8-8"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"28,7 28,1 36,1 36,7 "},"children":[]}]};exports.music_bell=music_bell;var music_cd={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"6"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"30","x2":"5","y2":"17"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"30","x2":"5","y2":"17"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"26","x2":"18","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"26","x2":"18","y2":"5"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"34","x2":"59","y2":"47"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"34","x2":"59","y2":"47"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"38","x2":"47","y2":"59"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"38","x2":"47","y2":"59"},"children":[]}]}]}]};exports.music_cd=music_cd;var music_diapason={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"5","cy":"59","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,29c-3.124,3.124-3.124,8.876,0,12\r\n\tc3.124,3.124,8.876,2.124,12-1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"29","x2":"51","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"40","x2":"63","y2":"12"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"41","x2":"8","y2":"56"},"children":[]}]};exports.music_diapason=music_diapason;var music_eject_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"21,34 32,20 \r\n\t\t43,34 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"21,34 32,20 \r\n\t\t43,34 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"40","x2":"42","y2":"40"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"40","x2":"42","y2":"40"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_eject_button=music_eject_button;var music_end_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,21 46,32 \r\n\t\t32,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"32,21 46,32 \r\n\t\t32,43 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,21 26,32 \r\n\t\t12,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,21 26,32 \r\n\t\t12,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"23","x2":"52","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"23","x2":"52","y2":"41"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_end_button=music_end_button;var music_fastforward_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"36,21 50,32 \r\n\t\t36,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"36,21 50,32 \r\n\t\t36,43 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"16,21 30,32 \r\n\t\t16,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"16,21 30,32 \r\n\t\t16,43 \t"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.84,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_fastforward_button=music_fastforward_button;var music_headphones={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M11,53C5.477,53,1,48.523,1,43s4.477-10,10-10h2v20\r\n\tH11z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53,33c5.523,0,10,4.477,10,10s-4.477,10-10,10h-2\r\n\tV33H53z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M13,36v-9c0,0,0-16,19-16s19,16,19,16v6"},"children":[]}]};exports.music_headphones=music_headphones;var music_ipod={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"32","height":"62"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"36","x2":"48","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"36","x2":"48","y2":"36"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"5","x2":"48","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"5","x2":"48","y2":"5"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"9.5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"9.5"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"2.5"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","cx":"31.5","cy":"49.5","r":"2.5"},"children":[]}]}]}]};exports.music_ipod=music_ipod;var music_loudspeaker={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"12","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"62"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"42","r":"12"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"16","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"42","r":"2.5"},"children":[]}]};exports.music_loudspeaker=music_loudspeaker;var music_microphone={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"45","cy":"15","r":"14"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,20 6,46 14,54 40,28 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"28","x2":"32","y2":"36"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"10,50 6,54 15,63 20,63 42,41 47,46 40,53 \r\n\t"},"children":[]}]};exports.music_microphone=music_microphone;var music_microphone_old={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"63","x2":"47","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"62","x2":"32","y2":"42"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,26c0,8-8,16-16,16s-16-8-16-16"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,27c0,4.418-3.582,8-8,8s-8-3.582-8-8V9\r\n\tc0-4.418,3.582-8,8-8s8,3.582,8,8V27z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"13","x2":"24","y2":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"23","x2":"24","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"13","x2":"35","y2":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"23","x2":"35","y2":"23"},"children":[]}]};exports.music_microphone_old=music_microphone_old;var music_mixer={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"16","y1":"10","x2":"16","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"10","x2":"48","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"10","x2":"32","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"14","x2":"22","y2":"14"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"50","x2":"54","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"32","x2":"38","y2":"32"},"children":[]}]};exports.music_mixer=music_mixer;var music_mute={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"4,32 4,20 16,20 34,2 34,32 34,62 16,44 \r\n\t\t4,44 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"4,32 4,20 16,20 34,2 34,32 34,62 16,44 \r\n\t\t4,44 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"23","x2":"60","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"23","x2":"60","y2":"41"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"41","x2":"60","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"41","x2":"60","y2":"23"},"children":[]}]}]}]};exports.music_mute=music_mute;var music_note_multiple={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"18","cy":"55","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"18","cy":"55","r":"8"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"46","cy":"49","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"46","cy":"49","r":"8"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"54,49 54,1 26,7 26,55 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"54,49 54,1 26,7 26,55 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"23","x2":"54","y2":"17"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"26","y1":"23","x2":"54","y2":"17"},"children":[]}]}]}]};exports.music_note_multiple=music_note_multiple;var music_note_single={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"22","cy":"55","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"22","cy":"55","r":"8"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"30,55 30,7 50,1 50,15 30,21 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"30,55 30,7 50,1 50,15 30,21 \t"},"children":[]}]}]}]};exports.music_note_single=music_note_single;var music_pause_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"23","x2":"25","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"23","x2":"25","y2":"41"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"23","x2":"38","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"23","x2":"38","y2":"41"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_pause_button=music_pause_button;var music_play_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,21 41,32 \r\n\t\t27,43 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"27,21 41,32 \r\n\t\t27,43 \t"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_play_button=music_play_button;var music_playlist={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"55","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"35","cy":"55","r":"8"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,55 43,7 63,1 63,15 43,21 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,55 43,7 63,1 63,15 43,21 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"16","x2":"38","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"26","x2":"38","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"36","x2":"38","y2":"36"},"children":[]}]};exports.music_playlist=music_playlist;var music_radio_ghettoblaster={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"21","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"35"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"17.5","cy":"38.5","r":"10.5"},"children":[]},{"name":"rect","attribs":{"x":"34","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"23","height":"15"},"children":[]},{"name":"rect","attribs":{"x":"52","y":"27","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"4"},"children":[]},{"name":"rect","attribs":{"x":"43","y":"27","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"4"},"children":[]},{"name":"rect","attribs":{"x":"34","y":"27","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,21 5,8 59,8 59,21 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"12","x2":"59","y2":"12"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"48","x2":"14","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"48","x2":"21","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"35","x2":"27","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"42","x2":"27","y2":"42"},"children":[]}]};exports.music_radio_ghettoblaster=music_radio_ghettoblaster;var music_radio_portable={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"22","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"38"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"20","cy":"41","r":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"36","x2":"32","y2":"36"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"8","y1":"46","x2":"32","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"29","x2":"25","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"29","x2":"15","y2":"53"},"children":[]},{"name":"rect","attribs":{"x":"43","y":"28","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"4"},"children":[]},{"name":"rect","attribs":{"x":"52","y":"28","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"5","height":"4"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"52","cy":"49","r":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"44","x2":"52","y2":"48"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,22 3,18 9,18 9,22 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"53,4 6,16 6,18 "},"children":[]}]};exports.music_radio_portable=music_radio_portable;var music_record={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]}]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"8"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"8"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,48c-8.838,0-16-7.16-16-16"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,48c-8.838,0-16-7.16-16-16"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.002,48"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.002,48"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,16c8.838,0,16,7.162,16,16"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,16c8.838,0,16,7.162,16,16"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,9"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,9"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.003,55C19.299,55,9,44.707,9,32"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.003,55C19.299,55,9,44.707,9,32"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.003,55"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32.003,55"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,32.002"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,32.002"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,9c12.704,0,23,10.295,23,23"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,9c12.704,0,23,10.295,23,23"},"children":[]}]}]}]};exports.music_record=music_record;var music_recordplayer={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"4","height":"8"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"27.5","cy":"27.5","r":"22.5"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"27.5","cy":"27.5","r":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"15","x2":"57","y2":"48"},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"57,49 51,52 51,48 \r\n\t57,45 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"56","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"3"},"children":[]},{"name":"rect","attribs":{"x":"15","y":"56","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"6","height":"3"},"children":[]}]};exports.music_recordplayer=music_recordplayer;var music_repeat_button={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"56,48 8,48 8,24 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"8,16 56,16 56,40 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"49,33 56,40 \r\n\t63,33 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"15,31 8,24 1,31 \r\n\t"},"children":[]}]};exports.music_repeat_button=music_repeat_button;var music_rewind_button={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"28,43 14,32 \r\n\t\t28,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"28,43 14,32 \r\n\t\t28,21 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"48,43 34,32 \r\n\t\t48,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"48,43 34,32 \r\n\t\t48,21 \t"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081\r\n\t\tc12.107,12.105,12.107,31.732,0,43.838c-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838\r\n\t\tC22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]}]}]};exports.music_rewind_button=music_rewind_button;var music_shuffle_button={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0,48 15,48 47,16 63,16 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,38 47,48 63,48 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0,16 15,16 25,26 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M56,23"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,23 63,16 56,9 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,55 63,48 \r\n\t56,41 "},"children":[]}]};exports.music_shuffle_button=music_shuffle_button;var music_stop_button={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"22","y":"22","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"20"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.92,10.081c12.107,12.105,12.107,31.732,0,43.838\r\n\tc-12.106,12.108-31.734,12.108-43.839,0c-12.107-12.105-12.107-31.732,0-43.838C22.186-2.027,41.813-2.027,53.92,10.081z"},"children":[]}]};exports.music_stop_button=music_stop_button;var music_tape={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"11","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"42"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"16","cy":"31","r":"6"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"48","cy":"31","r":"6"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,53 54,43 32,43 10,43 7,53 "},"children":[]},{"name":"rect","attribs":{"x":"5","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"55","height":"4"},"children":[]},{"name":"rect","attribs":{"x":"26","y":"28","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"12","height":"6"},"children":[]}]};exports.music_tape=music_tape;var music_volume_down={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"8,32 8,20 20,20 38,2 38,32 38,62 20,44 \r\n\t\t8,44 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"8,32 8,20 20,20 38,2 38,32 38,62 20,44 \r\n\t\t8,44 \t"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M46,42c5.522,0,10-4.478,10-10s-4.478-10-10-10"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M46,42c5.522,0,10-4.478,10-10s-4.478-10-10-10"},"children":[]}]}]}]};exports.music_volume_down=music_volume_down;var music_volume_up={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,32 3,20 15,20 33,2 33,32 33,62 15,44 \r\n\t\t3,44 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,32 3,20 15,20 33,2 33,32 33,62 15,44 \r\n\t\t3,44 \t"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,42c5.522,0,10-4.478,10-10s-4.478-10-10-10"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,42c5.522,0,10-4.478,10-10s-4.478-10-10-10"},"children":[]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,12c11.046,0,20,8.954,20,20s-8.954,20-20,20"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,12c11.046,0,20,8.954,20,20s-8.954,20-20,20"},"children":[]}]}]}]};exports.music_volume_up=music_volume_up;var software_add_vectorpoint={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,22 44,20 42,20 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,22 44,20 42,20 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"40","y1":"20","x2":"23","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"40","y1":"20","x2":"23","y2":"20"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,20 20,20 20,22 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,20 20,20 20,22 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"20","y1":"24","x2":"20","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"20","y1":"24","x2":"20","y2":"41"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,42 20,44 22,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,42 20,44 22,44 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"24","y1":"44","x2":"41","y2":"44"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"24","y1":"44","x2":"41","y2":"44"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,44 44,44 44,42 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,44 44,44 44,42 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"44","y1":"40","x2":"44","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"44","y1":"40","x2":"44","y2":"23"},"children":[]}]}]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"20","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"20","x2":"53","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"25","x2":"32","y2":"39"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"32","x2":"25","y2":"32"},"children":[]}]};exports.software_add_vectorpoint=software_add_vectorpoint;var software_box_oval={"viewBox":"0 0 64 64","children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","rx":"31","ry":"20"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"32","x2":"63","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"12","x2":"32","y2":"52"},"children":[]}]};exports.software_box_oval=software_box_oval;var software_box_polygon={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"16.676,59 1.351,32 16.676,5 47.324,5 \r\n\t62.649,32 47.324,59 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"5","x2":"47","y2":"59"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"5","x2":"17","y2":"59"},"children":[]}]};exports.software_box_polygon=software_box_polygon;var software_box_rectangle={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"12","x2":"63","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"12","x2":"1","y2":"52"},"children":[]}]};exports.software_box_rectangle=software_box_rectangle;var software_box_roundedrectangle={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M63,40c0,6.627-5.373,12-12,12H13\r\n\tC6.373,52,1,46.627,1,40V24c0-6.627,5.373-12,12-12h38c6.627,0,12,5.373,12,12V40z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"15","x2":"59","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"59","y1":"15","x2":"5","y2":"49"},"children":[]}]};exports.software_box_roundedrectangle=software_box_roundedrectangle;var software_character={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,52.5 27,10 28,10 43,52.75 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"12,52.5 27,10 28,10 43,52.75 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"38","x2":"38","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"38","x2":"38","y2":"38"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"0","x2":"52","y2":"64"},"children":[]}]};exports.software_character=software_character;var software_crop={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0,11 53,11 53,64 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,0 11,53 64,53 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"63","y2":"1"},"children":[]}]};exports.software_crop=software_crop;var software_eyedropper={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M47,26l12-12l4-4c0-4.371-4.628-9-9-9\r\n\tc0,0-2.563,2.533-4,4L38,17"},"children":[]},{"name":"rect","attribs":{"x":"28.479","y":"20.672","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 52.5208 68.7548)","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"24.042","height":"5.657"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"34,22 4,54 4,56 1,59 5,63 8,60 10,60 \r\n\t42,30 "},"children":[]}]};exports.software_eyedropper=software_eyedropper;var software_font_allcaps={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31,50.987 18,16 17,16 4,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31,50.987 18,16 17,16 4,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"39","x2":"8","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"39","x2":"8","y2":"39"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"60,50.987 47,16 46,16 33,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"60,50.987 47,16 46,16 33,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"39","x2":"37","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"39","x2":"37","y2":"39"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.software_font_allcaps=software_font_allcaps;var software_font_baseline_shift={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,43 21,1 20,1 5,43 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,43 21,1 20,1 5,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"29","x2":"10","y2":"29"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"29","x2":"10","y2":"29"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,31 51,8 50,8 42,31 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,31 51,8 50,8 42,31 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"24","x2":"44","y2":"24"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"24","x2":"44","y2":"24"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"47","x2":"2","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"35","x2":"40","y2":"35"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"58,47 51,40 \r\n\t44,47 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"51","y1":"64","x2":"51","y2":"40"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"51","y1":"64","x2":"51","y2":"40"},"children":[]}]}]}]};exports.software_font_baseline_shift=software_font_baseline_shift;var software_font_horizontal_scale={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"17,44 32,2 33,2 48,44 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"17,44 32,2 33,2 48,44 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"30","x2":"43","y2":"30"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"30","x2":"43","y2":"30"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M55,63"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"55,63 62,56 \r\n\t55,49 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"9,49 2,56 9,63 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[]}]}]}]};exports.software_font_horizontal_scale=software_font_horizontal_scale;var software_font_kerning={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,35 13,12 14,12 22,35 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,35 13,12 14,12 22,35 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"28","x2":"20","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"28","x2":"20","y2":"28"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,35 50,12 51,12 59,35 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,35 50,12 51,12 59,35 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"28","x2":"57","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"28","x2":"57","y2":"28"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"6","x2":"32","y2":"8"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"6","x2":"32","y2":"8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"10","x2":"32","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"10","x2":"32","y2":"39"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"42"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"42"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"55,63 62,56 \r\n\t55,49 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"9,49 2,56 9,63 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[]}]}]}]};exports.software_font_kerning=software_font_kerning;var software_font_leading={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,24 44,1 45,1 53,24 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,24 44,1 45,1 53,24 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"17","x2":"51","y2":"17"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"17","x2":"51","y2":"17"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"28","x2":"61","y2":"28"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,57 44,34 45,34 53,57 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,57 44,34 45,34 53,57 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"50","x2":"51","y2":"50"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"50","x2":"51","y2":"50"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"61","x2":"61","y2":"61"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"5,55 12,62 19,55 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"19,34 12,27 5,34 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"62","x2":"12","y2":"27"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"62","x2":"12","y2":"27"},"children":[]}]}]}]};exports.software_font_leading=software_font_leading;var software_font_size={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"28,43 43,1 44,1 59,43 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"28,43 43,1 44,1 59,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"29","x2":"54","y2":"29"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"29","x2":"54","y2":"29"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,43 13,20 14,20 22,43 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,43 13,20 14,20 22,43 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"36","x2":"20","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"36","x2":"20","y2":"36"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"56,63 63,56 \r\n\t56,49 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"8,49 1,56 8,63 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"56","x2":"1","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"56","x2":"1","y2":"56"},"children":[]}]}]}]};exports.software_font_size=software_font_size;var software_font_smallcapital={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,51 22,9 21,9 6,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37,51 22,9 21,9 6,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"37","x2":"11","y2":"37"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"37","x2":"11","y2":"37"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"58,51 50,28 49,28 41,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"58,51 50,28 49,28 41,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"44","x2":"43","y2":"44"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"56","y1":"44","x2":"43","y2":"44"},"children":[]}]}]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.software_font_smallcapital=software_font_smallcapital;var software_font_smallcaps={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"12","y2":"37"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"33","y1":"37","x2":"12","y2":"37"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M44,34c0,0,1.5-2,5.5-2s5.5,3,5.5,5s0,10,0,10\r\n\ts0,3,2.5,3"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40h-5c0,0-7,0-7,5s4,5,5,5s7,0,7-7"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.software_font_smallcaps=software_font_smallcaps;var software_font_strikethrough={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"13","y2":"35"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"13","y2":"35"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M44,34c0,0,1.5-2,5.5-2s5.5,3,5.5,5s0,10,0,10\r\n\ts0,3,2.5,3"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40h-5c0,0-7,0-7,5s4,5,5,5s7,0,7-7"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"44","x2":"58","y2":"44"},"children":[]}]};exports.software_font_strikethrough=software_font_strikethrough;var software_font_tracking={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,35 17,12 18,12 26,35 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"9,35 17,12 18,12 26,35 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"28","x2":"24","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"28","x2":"24","y2":"28"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 46,12 47,12 55,35 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,35 46,12 47,12 55,35 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"28","x2":"53","y2":"28"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"28","x2":"53","y2":"28"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"6","x2":"32","y2":"8"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"6","x2":"32","y2":"8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"10","x2":"32","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"10","x2":"32","y2":"39"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"42"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"42"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"6","x2":"4","y2":"8"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"6","x2":"4","y2":"8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"4","y1":"10","x2":"4","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"4","y1":"10","x2":"4","y2":"39"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"40","x2":"4","y2":"42"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"4","y1":"40","x2":"4","y2":"42"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"60","y1":"6","x2":"60","y2":"8"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"60","y1":"6","x2":"60","y2":"8"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"60","y1":"10","x2":"60","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"60","y1":"10","x2":"60","y2":"39"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"60","y1":"40","x2":"60","y2":"42"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"60","y1":"40","x2":"60","y2":"42"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"55,63 62,56 \r\n\t55,49 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"9,49 2,56 9,63 \r\n\t"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"56","x2":"2","y2":"56"},"children":[]}]}]}]};exports.software_font_tracking=software_font_tracking;var software_font_underline={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"38,51 23,9 22,9 7,51 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"13","y2":"35"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"13","y2":"35"},"children":[]}]}]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M44,34c0,0,1.5-2,5.5-2s5.5,3,5.5,5s0,10,0,10\r\n\ts0,3,2.5,3"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40h-5c0,0-7,0-7,5s4,5,5,5s7,0,7-7"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"55","x2":"58","y2":"55"},"children":[]}]};exports.software_font_underline=software_font_underline;var software_font_vertical_scale={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,53 44,11 45,11 60,53 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,53 44,11 45,11 60,53 \t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"39","x2":"55","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"39","x2":"55","y2":"39"},"children":[]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"5,55 12,62 19,55 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"19,9 12,2 5,9 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"62","x2":"12","y2":"2"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"62","x2":"12","y2":"2"},"children":[]}]}]}]};exports.software_font_vertical_scale=software_font_vertical_scale;var software_horizontal_align_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"51","x2":"32","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"0","x2":"32","y2":"13"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"29","x2":"32","y2":"35"},"children":[]},{"name":"rect","attribs":{"x":"6","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"12","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]}]};exports.software_horizontal_align_center=software_horizontal_align_center;var software_horizontal_align_left={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"0","x2":"1","y2":"64"},"children":[]},{"name":"rect","attribs":{"x":"7","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"7","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]}]};exports.software_horizontal_align_left=software_horizontal_align_left;var software_horizontal_align_right={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"0","x2":"63","y2":"64"},"children":[]},{"name":"rect","attribs":{"x":"5","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"17","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]}]};exports.software_horizontal_align_right=software_horizontal_align_right;var software_horizontal_distribute_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"0","x2":"43","y2":"12"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"52","x2":"43","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"0","x2":"21","y2":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"58","x2":"21","y2":"64"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]}]};exports.software_horizontal_distribute_center=software_horizontal_distribute_center;var software_horizontal_distribute_left={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"0","x2":"35","y2":"64"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"0","x2":"13","y2":"64"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]}]};exports.software_horizontal_distribute_left=software_horizontal_distribute_left;var software_horizontal_distribute_right={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"64","x2":"29","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"51","y1":"64","x2":"51","y2":"0"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]}]};exports.software_horizontal_distribute_right=software_horizontal_distribute_right;var software_indent_firstline={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"10","x2":"64","y2":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"20","x2":"53","y2":"20"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"30","x2":"64","y2":"30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"40","x2":"56","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"50","x2":"64","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"60","x2":"58","y2":"60"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"16,17 23,10 \r\n\t\t16,3 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"16,17 23,10 \r\n\t\t16,3 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"10","x2":"0","y2":"10"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"10","x2":"0","y2":"10"},"children":[]}]}]}]}]}]};exports.software_indent_firstline=software_indent_firstline;var software_indent_left={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"7","x2":"64","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"17","x2":"52","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"27","x2":"64","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"37","x2":"55","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"57","x2":"57","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"0","x2":"25","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"12,39 19,32 \r\n\t12,25 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"32","x2":"0","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"32","x2":"0","y2":"32"},"children":[]}]}]}]};exports.software_indent_left=software_indent_left;var software_indent_right={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"7","x2":"0","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"17","x2":"12","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"37","x2":"9","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"47","x2":"0","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"57","x2":"7","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"0","x2":"39","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,25 45,32 \r\n\t52,39 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"32","x2":"64","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"32","x2":"64","y2":"32"},"children":[]}]}]}]};exports.software_indent_right=software_indent_right;var software_lasso={"viewBox":"0 0 64 64","children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"25.5","rx":"31","ry":"19.5"},"children":[]},{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"48","rx":"6","ry":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M25,51c0,0,2,1,2,4s-2,3-2,3"},"children":[]}]};exports.software_lasso=software_lasso;var software_layers1={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,32.066 2,39 32,51 62,39 46,32.067 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,38 62,26 32,13 2,26 "},"children":[]}]};exports.software_layers1=software_layers1;var software_layers2={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,26.066 2,33 32,45 62,33 46,26.067 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"18,39.066 2,46 32,58 62,46 46,39.067 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,32 62,20 32,7 2,20 "},"children":[]}]};exports.software_layers2=software_layers2;var software_layout={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"62"},"children":[]}]};exports.software_layout=software_layout;var software_layout_2columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"62"},"children":[]}]};exports.software_layout_2columns=software_layout_2columns;var software_layout_3columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"43","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"21","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"22","height":"62"},"children":[]}]};exports.software_layout_3columns=software_layout_3columns;var software_layout_4boxes={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"32","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"31"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"32","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"31"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"31"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"31"},"children":[]}]};exports.software_layout_4boxes=software_layout_4boxes;var software_layout_4columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"16","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"47","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"62"},"children":[]}]};exports.software_layout_4columns=software_layout_4columns;var software_layout_4lines={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"15"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"16","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"32","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"15"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"47","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"16"},"children":[]}]};exports.software_layout_4lines=software_layout_4lines;var software_layout_header={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"48"},"children":[]}]};exports.software_layout_header=software_layout_header;var software_layout_header_2columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"48"},"children":[]}]};exports.software_layout_header_2columns=software_layout_header_2columns;var software_layout_header_3columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"43","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"21","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"22","height":"48"},"children":[]}]};exports.software_layout_header_3columns=software_layout_header_3columns;var software_layout_header_4boxes={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"39","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"24"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"39","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"24"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"24"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"24"},"children":[]}]};exports.software_layout_header_4boxes=software_layout_header_4boxes;var software_layout_header_4columns={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"16","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"47","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"48"},"children":[]}]};exports.software_layout_header_4columns=software_layout_header_4columns;var software_layout_header_complex={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"15","x2":"22","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"38","x2":"63","y2":"38"},"children":[]}]};exports.software_layout_header_complex=software_layout_header_complex;var software_layout_header_complex2={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"15","x2":"42","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"38","x2":"42","y2":"38"},"children":[]}]};exports.software_layout_header_complex2=software_layout_header_complex2;var software_layout_header_complex3={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"47","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"48"},"children":[]}]};exports.software_layout_header_complex3=software_layout_header_complex3;var software_layout_header_complex4={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"31","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"32","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"15","height":"48"},"children":[]},{"name":"rect","attribs":{"x":"47","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"48"},"children":[]}]};exports.software_layout_header_complex4=software_layout_header_complex4;var software_layout_header_sideleft={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"15","x2":"22","y2":"63"},"children":[]}]};exports.software_layout_header_sideleft=software_layout_header_sideleft;var software_layout_header_sideright={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"14"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"15","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"15","x2":"42","y2":"63"},"children":[]}]};exports.software_layout_header_sideright=software_layout_header_sideright;var software_layout_sidebar_left={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"21","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]};exports.software_layout_sidebar_left=software_layout_sidebar_left;var software_layout_sidebar_right={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"43","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"20","height":"62"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"42","height":"62"},"children":[]}]};exports.software_layout_sidebar_right=software_layout_sidebar_right;var software_magnete={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24,42c0,4.418,3.582,8,8,8s8-3.582,8-8V1h13v41\r\n\tc0,11.598-9.402,21-21,21s-21-9.402-21-21V1h13V42z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"10","x2":"24","y2":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"10","x2":"53","y2":"10"},"children":[]}]};exports.software_magnete=software_magnete;var software_pages={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,11 32,11 32,53 1,53 1,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"11,11 32,11 32,53 1,53 1,21 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,21 11,21 11,11 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,21 11,21 11,11 \t"},"children":[]}]}]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"53,11 32,11 32,53 63,53 63,21 \t"},"children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"53,11 32,11 32,53 63,53 63,21 \t"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,21 53,21 53,11 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,21 53,21 53,11 \t"},"children":[]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"6","x2":"32","y2":"58"},"children":[]}]};exports.software_pages=software_pages;var software_paintbrush={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"30,42 26,46 18,38 22,34 62,1 63,2 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"34","x2":"30","y2":"42"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M26,46c0,0-8,17-25,17c0,0,2.752-16.314,9-21\r\n\tc4-3,8-4,8-4"},"children":[]}]};exports.software_paintbrush=software_paintbrush;var software_paintbucket={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"3,38 28,63 54,37 \r\n\t61,36 33,8 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","d":"M32,27V6\r\n\tc0-2.762-2.238-5-5-5s-5,2.238-5,5v13"},"children":[]}]};exports.software_paintbucket=software_paintbucket;var software_paintroller={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"7","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"48","height":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"9","x2":"7","y2":"9"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"55,9 61,9 61,24 32,24 32,41 "},"children":[]},{"name":"rect","attribs":{"x":"28","y":"42","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"8","height":"21"},"children":[]}]};exports.software_paintroller=software_paintroller;var software_paragraph={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"51,64 51,1 41,1 41,64 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"33","x2":"41","y2":"33"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29,33c0,0-16,0-16-16S29,1,29,1h12"},"children":[]}]};exports.software_paragraph=software_paragraph;var software_paragraph_align_left={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"7","x2":"64","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"17","x2":"46","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"27","x2":"64","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"37","x2":"50","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"57","x2":"54","y2":"57"},"children":[]}]};exports.software_paragraph_align_left=software_paragraph_align_left;var software_paragraph_align_right={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"7","x2":"0","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"17","x2":"18","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"14","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"47","x2":"0","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"57","x2":"10","y2":"57"},"children":[]}]};exports.software_paragraph_align_right=software_paragraph_align_right;var software_paragraph_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"7","x2":"64","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"17","x2":"55","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"27","x2":"64","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"37","x2":"57","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"5","y1":"57","x2":"59","y2":"57"},"children":[]}]};exports.software_paragraph_center=software_paragraph_center;var software_paragraph_justify_all={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"7","x2":"0","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"17","x2":"0","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"0","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"47","x2":"0","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"57","x2":"0","y2":"57"},"children":[]}]};exports.software_paragraph_justify_all=software_paragraph_justify_all;var software_paragraph_justify_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"7","x2":"0","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"17","x2":"0","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"0","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"47","x2":"0","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"57","x2":"10","y2":"57"},"children":[]}]};exports.software_paragraph_justify_center=software_paragraph_justify_center;var software_paragraph_justify_left={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"7","x2":"64","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"17","x2":"64","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"27","x2":"64","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"37","x2":"64","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"57","x2":"44","y2":"57"},"children":[]}]};exports.software_paragraph_justify_left=software_paragraph_justify_left;var software_paragraph_justify_right={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"7","x2":"0","y2":"7"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"17","x2":"0","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"0","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"47","x2":"0","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"57","x2":"20","y2":"57"},"children":[]}]};exports.software_paragraph_justify_right=software_paragraph_justify_right;var software_paragraph_space_after={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"64","y2":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"16","x2":"56","y2":"16"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"26","x2":"64","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"36","x2":"58","y2":"36"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,48 59,46 57,46 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,48 59,46 57,46 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"55","y1":"46","x2":"26","y2":"46"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"55","y1":"46","x2":"26","y2":"46"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,46 23,46 23,48 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,46 23,46 23,48 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"23","y1":"50","x2":"23","y2":"53"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"23","y1":"50","x2":"23","y2":"53"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,54 23,56 25,56 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,54 23,56 25,56 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"56","x2":"56","y2":"56"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"56","x2":"56","y2":"56"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,56 59,56 59,54 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,56 59,56 59,54 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"59","y1":"53","x2":"59","y2":"49"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"59","y1":"53","x2":"59","y2":"49"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,58 17,51 \r\n\t\t10,44 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,58 17,51 \r\n\t\t10,44 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"51","x2":"0","y2":"51"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"51","x2":"0","y2":"51"},"children":[]}]}]}]}]}]};exports.software_paragraph_space_after=software_paragraph_space_after;var software_paragraph_space_before={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"29","x2":"64","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"39","x2":"56","y2":"39"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"49","x2":"64","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"59","x2":"58","y2":"59"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,11 59,9 57,9 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,11 59,9 57,9 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"55","y1":"9","x2":"26","y2":"9"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"55","y1":"9","x2":"26","y2":"9"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,9 23,9 23,11 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,9 23,9 23,11 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"23","y1":"13","x2":"23","y2":"16"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"23","y1":"13","x2":"23","y2":"16"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,17 23,19 25,19 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,17 23,19 25,19 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"19","x2":"56","y2":"19"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"19","x2":"56","y2":"19"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,19 59,19 59,17 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"57,19 59,19 59,17 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"59","y1":"16","x2":"59","y2":"12"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3,2","x1":"59","y1":"16","x2":"59","y2":"12"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,21 17,14 \r\n\t\t10,7 \t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"10,21 17,14 \r\n\t\t10,7 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"14","x2":"0","y2":"14"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"14","x2":"0","y2":"14"},"children":[]}]}]}]}]}]};exports.software_paragraph_space_before=software_paragraph_space_before;var software_pathfinder_exclude={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,23 41,41 23,41 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 1,41 1,1 41,1 41,23 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,23 63,23 63,63 23,63 23,41 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 23,23 41,23 "},"children":[]}]};exports.software_pathfinder_exclude=software_pathfinder_exclude;var software_pathfinder_intersect={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,23 41,41 23,41 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","points":"23,41 1,41 1,1 \r\n\t41,1 41,23 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","points":"41,23 63,23 63,63 \r\n\t23,63 23,41 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 23,23 41,23 "},"children":[]}]};exports.software_pathfinder_intersect=software_pathfinder_intersect;var software_pathfinder_subtract={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 1,41 1,1 41,1 41,23 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"23","x2":"43","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"23","x2":"43","y2":"23"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"45","y1":"23","x2":"60","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"45","y1":"23","x2":"60","y2":"23"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61,23 63,23 63,25 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61,23 63,23 63,25 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"27","x2":"63","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"27","x2":"63","y2":"60"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,61 63,63 61,63 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,61 63,63 61,63 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"59","y1":"63","x2":"26","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"59","y1":"63","x2":"26","y2":"63"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,63 23,63 23,61 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"25,63 23,63 23,61 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"23","y1":"59","x2":"23","y2":"44"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"23","y1":"59","x2":"23","y2":"44"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"43","x2":"23","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"43","x2":"23","y2":"41"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 23,23 41,23 "},"children":[]}]};exports.software_pathfinder_subtract=software_pathfinder_subtract;var software_pathfinder_unite={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"23","x2":"41","y2":"25"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"23","x2":"41","y2":"25"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"41","y1":"27","x2":"41","y2":"38"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"41","y1":"27","x2":"41","y2":"38"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,39 41,41 39,41 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,39 41,41 39,41 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"37","y1":"41","x2":"26","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"37","y1":"41","x2":"26","y2":"41"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"41","x2":"23","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"41","x2":"23","y2":"41"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,41 1,41 1,1 41,1 41,23 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,23 63,23 63,63 23,63 23,41 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"41","x2":"23","y2":"39"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"41","x2":"23","y2":"39"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"23","y1":"37","x2":"23","y2":"26"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"23","y1":"37","x2":"23","y2":"26"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,25 23,23 25,23 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"23,25 23,23 25,23 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"23","x2":"38","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"23","x2":"38","y2":"23"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"23","x2":"41","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"23","x2":"41","y2":"23"},"children":[]}]}]}]}]}]};exports.software_pathfinder_unite=software_pathfinder_unite;var software_pen={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"23","y":"57","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"6"},"children":[]},{"name":"rect","attribs":{"x":"19","y":"47","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"26","height":"10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,47 41,43 48,30 32,1 16,30 23,43 23,47 \r\n\t"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"28.875","r":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"1","x2":"32","y2":"25"},"children":[]}]};exports.software_pen=software_pen;var software_pen_add={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"23","y":"57","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"6"},"children":[]},{"name":"rect","attribs":{"x":"19","y":"47","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"26","height":"10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,47 41,43 48,30 32,1 16,30 23,43 23,47 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"23","x2":"32","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"30","x2":"25","y2":"30"},"children":[]}]};exports.software_pen_add=software_pen_add;var software_pen_remove={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"23","y":"57","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"18","height":"6"},"children":[]},{"name":"rect","attribs":{"x":"19","y":"47","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"26","height":"10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41,47 41,43 48,30 32,1 16,30 23,43 23,47 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"30","x2":"25","y2":"30"},"children":[]}]};exports.software_pen_remove=software_pen_remove;var software_pencil={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"54","x2":"10","y2":"44"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"54","x2":"10","y2":"44"},"children":[]}]}]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"10,44 1,62 2,63 20,54 63,11 53,1 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"20","x2":"44","y2":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"58","y1":"16","x2":"48","y2":"6"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,54 9,55 10,59 "},"children":[]}]};exports.software_pencil=software_pencil;var software_polygonallasso={"viewBox":"0 0 64 64","children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"21","cy":"53","rx":"6","ry":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M25,56c0,0,2,1,2,4s-2,3-2,3"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,49 5,12 40,18 59,1 59,41 26,51 "},"children":[]}]};exports.software_polygonallasso=software_polygonallasso;var software_reflect_horizontal={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,17 1,57 21,37 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61.586,55.586 63,57 63,55 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61.586,55.586 63,57 63,55 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"53","x2":"63","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"53","x2":"63","y2":"20"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,19 63,17 61.586,18.414 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,19 63,17 61.586,18.414 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"60.265","y1":"19.735","x2":"45.075","y2":"34.925"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"60.265","y1":"19.735","x2":"45.075","y2":"34.925"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44.414,35.586 43,37 44.414,38.414 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44.414,35.586 43,37 44.414,38.414 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"45.735","y1":"39.735","x2":"60.925","y2":"54.925"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"45.735","y1":"39.735","x2":"60.925","y2":"54.925"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"61","x2":"32","y2":"59"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"61","x2":"32","y2":"59"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"57","x2":"32","y2":"16"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"32","y1":"57","x2":"32","y2":"16"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"15","x2":"32","y2":"13"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"15","x2":"32","y2":"13"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"46,13 57,13 57,2 \r\n\t"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M57,13C51.378,5.132,42.408,1,32,1\r\n\tC21.591,1,12.622,5.13,7,13"},"children":[]}]};exports.software_reflect_horizontal=software_reflect_horizontal;var software_reflect_vertical={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"46,1 6,1 26,21 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"7.414,61.586 6,63 8,63 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"7.414,61.586 6,63 8,63 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"10","y1":"63","x2":"43","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"10","y1":"63","x2":"43","y2":"63"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,63 46,63 44.586,61.586 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,63 46,63 44.586,61.586 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"43.265","y1":"60.265","x2":"28.075","y2":"45.075"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"43.265","y1":"60.265","x2":"28.075","y2":"45.075"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27.414,44.414 26,43 24.586,44.414 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"27.414,44.414 26,43 24.586,44.414 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"23.265","y1":"45.735","x2":"8.075","y2":"60.925"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.736,1.868","x1":"23.265","y1":"45.735","x2":"8.075","y2":"60.925"},"children":[]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"32","x2":"4","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"2","y1":"32","x2":"4","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"6","y1":"32","x2":"47","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"6","y1":"32","x2":"47","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"32","x2":"50","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"32","x2":"50","y2":"32"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"51,46 51,57 \r\n\t62,57 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M51,57c7.868-5.622,12-14.592,12-25\r\n\tc0-10.409-4.13-19.378-12-25"},"children":[]}]};exports.software_reflect_vertical=software_reflect_vertical;var software_remove_vectorpoint={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,22 44,20 42,20 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"44,22 44,20 42,20 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"40","y1":"20","x2":"23","y2":"20"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"40","y1":"20","x2":"23","y2":"20"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,20 20,20 20,22 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,20 20,20 20,22 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"20","y1":"24","x2":"20","y2":"41"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"20","y1":"24","x2":"20","y2":"41"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,42 20,44 22,44 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"20,42 20,44 22,44 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"24","y1":"44","x2":"41","y2":"44"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"24","y1":"44","x2":"41","y2":"44"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,44 44,44 44,42 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,44 44,44 44,42 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"44","y1":"40","x2":"44","y2":"23"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"44","y1":"40","x2":"44","y2":"23"},"children":[]}]}]}]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"20","y2":"44"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"20","x2":"53","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"32","x2":"25","y2":"32"},"children":[]}]};exports.software_remove_vectorpoint=software_remove_vectorpoint;var software_scale_expand={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","points":"1,28 1,1 63,1 \r\n\t63,63 36,63 "},"children":[]},{"name":"rect","attribs":{"x":"1","y":"33","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"30","height":"30"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"57,18 57,7 46,7 \r\n\t"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"57","y1":"7","x2":"41","y2":"23"},"children":[]}]};exports.software_scale_expand=software_scale_expand;var software_scale_reduce={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,30 1,1 63,1 63,63 34,63 "},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31,35 31,33 29,33 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"31,35 31,33 29,33 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"33","x2":"4","y2":"33"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"27","y1":"33","x2":"4","y2":"33"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,33 1,33 1,35 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,33 1,33 1,35 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"1","y1":"37","x2":"1","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"1","y1":"37","x2":"1","y2":"60"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,61 1,63 3,63 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,61 1,63 3,63 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"5","y1":"63","x2":"28","y2":"63"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"5","y1":"63","x2":"28","y2":"63"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,63 31,63 31,61 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,63 31,63 31,61 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"31","y1":"59","x2":"31","y2":"36"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"31","y1":"59","x2":"31","y2":"36"},"children":[]}]}]}]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"41,12 41,23 \r\n\t52,23 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"23","x2":"57","y2":"7"},"children":[]}]};exports.software_scale_reduce=software_scale_reduce;var software_selection_oval={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0012,2.0006","cx":"32","cy":"32","rx":"31","ry":"20"},"children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.0012,2.0006","cx":"32","cy":"32","rx":"31","ry":"20"},"children":[]}]}]}]};exports.software_selection_oval=software_selection_oval;var software_selection_polygon={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"19,59 16.675,59 15.851,57.261 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"19,59 16.675,59 15.851,57.261 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"14.661","y1":"55.451","x2":"2.851","y2":"34.644"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"14.661","y1":"55.451","x2":"2.851","y2":"34.644"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"2.338,33.739 1.351,32 2.338,30.261 \t\t\r\n\t\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"2.338,33.739 1.351,32 2.338,30.261 \t\t\r\n\t\t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"3.365","y1":"28.451","x2":"15.175","y2":"7.644"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"3.365","y1":"28.451","x2":"15.175","y2":"7.644"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"15.851,6.739 16.675,5 19,5 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"15.851,6.739 16.675,5 19,5 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"21","y1":"5","x2":"44","y2":"5"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"21","y1":"5","x2":"44","y2":"5"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"45,5 47.325,5 48.149,6.739 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"45,5 47.325,5 48.149,6.739 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"49.339","y1":"8.549","x2":"61.149","y2":"29.356"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"49.339","y1":"8.549","x2":"61.149","y2":"29.356"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61.662,30.261 62.649,32 61.662,33.739 \r\n\t\t\t\t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61.662,30.261 62.649,32 61.662,33.739 \r\n\t\t\t\t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"60.635","y1":"35.549","x2":"48.825","y2":"56.356"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4.1609,2.0805","x1":"60.635","y1":"35.549","x2":"48.825","y2":"56.356"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"48.149,57.261 47.325,59 45,59 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"48.149,57.261 47.325,59 45,59 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"43","y1":"59","x2":"20","y2":"59"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"43","y1":"59","x2":"20","y2":"59"},"children":[]}]}]}]}]}]};exports.software_selection_polygon=software_selection_polygon;var software_selection_rectangle={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,50 63,52 61,52 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,50 63,52 61,52 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"59","y1":"52","x2":"4","y2":"52"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"59","y1":"52","x2":"4","y2":"52"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,52 1,52 1,50 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"3,52 1,52 1,50 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"1","y1":"48","x2":"1","y2":"15"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"1","y1":"48","x2":"1","y2":"15"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,14 1,12 3,12 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,14 1,12 3,12 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"5","y1":"12","x2":"60","y2":"12"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"5","y1":"12","x2":"60","y2":"12"},"children":[]}]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61,12 63,12 63,14 \t\t"},"children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"61,12 63,12 63,14 \t\t"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"16","x2":"63","y2":"49"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"4,2","x1":"63","y1":"16","x2":"63","y2":"49"},"children":[]}]}]}]}]}]};exports.software_selection_rectangle=software_selection_rectangle;var software_selection_roundedrectangle={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.9436,1.9718","d":"M63,40\r\n\t\tc0,6.627-5.373,12-12,12H13C6.373,52,1,46.627,1,40V24c0-6.627,5.373-12,12-12h38c6.627,0,12,5.373,12,12V40z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","stroke-dasharray":"3.9436,1.9718","d":"M63,40\r\n\t\tc0,6.627-5.373,12-12,12H13C6.373,52,1,46.627,1,40V24c0-6.627,5.373-12,12-12h38c6.627,0,12,5.373,12,12V40z"},"children":[]}]}]}]};exports.software_selection_roundedrectangle=software_selection_roundedrectangle;var software_shape_oval={"viewBox":"0 0 64 64","children":[{"name":"ellipse","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","rx":"31","ry":"20"},"children":[]}]};exports.software_shape_oval=software_shape_oval;var software_shape_polygon={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"16.675,59 1.351,32 16.675,5 47.325,5 \r\n\t62.649,32 47.325,59 "},"children":[]}]};exports.software_shape_polygon=software_shape_polygon;var software_shape_rectangle={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"62","height":"40"},"children":[]}]};exports.software_shape_rectangle=software_shape_rectangle;var software_shape_roundedrectangle={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M63,40c0,6.627-5.373,12-12,12H13\r\n\tC6.373,52,1,46.627,1,40V24c0-6.627,5.373-12,12-12h38c6.627,0,12,5.373,12,12V40z"},"children":[]}]};exports.software_shape_roundedrectangle=software_shape_roundedrectangle;var software_slice={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"1,59 37,23 44,30 \r\n\t36,45 "},"children":[]},{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,20 57,3 63,9 \r\n\t47,27 "},"children":[]}]};exports.software_slice=software_slice;var software_transform_bezier={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"41","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"27","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"4","cy":"18","r":"3"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"60","cy":"18","r":"3"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7,18h20C6,18,6,41,6,41"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M57,18H37c21,0,21,23,21,23"},"children":[]}]};exports.software_transform_bezier=software_transform_bezier;var software_vector_box={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"1","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"11","x2":"6","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"58","y1":"11","x2":"58","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"53","y1":"6","x2":"11","y2":"6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"53","y1":"58","x2":"11","y2":"58"},"children":[]}]};exports.software_vector_box=software_vector_box;var software_vector_composite={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"27","y":"27","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"27","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"27","x2":"53","y2":"11"},"children":[]}]};exports.software_vector_composite=software_vector_composite;var software_vector_line={"viewBox":"0 0 64 64","children":[{"name":"rect","attribs":{"x":"1","y":"53","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"rect","attribs":{"x":"53","y":"1","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"10","height":"10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"53","y2":"11"},"children":[]}]};exports.software_vector_line=software_vector_line;var software_vertical_align_bottom={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"63","x2":"0","y2":"63"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"5","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"17","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]}]};exports.software_vertical_align_bottom=software_vertical_align_bottom;var software_vertical_align_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"32","x2":"0","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"32","x2":"51","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"32","x2":"29","y2":"32"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"6","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"12","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]}]};exports.software_vertical_align_center=software_vertical_align_center;var software_vertical_align_top={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"1","x2":"64","y2":"1"},"children":[]},{"name":"rect","attribs":{"x":"13","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"52"},"children":[]},{"name":"rect","attribs":{"x":"35","y":"7","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"16","height":"40"},"children":[]}]};exports.software_vertical_align_top=software_vertical_align_top;var software_vertical_distribute_bottom={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"29","x2":"64","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"51","x2":"64","y2":"51"},"children":[]},{"name":"rect","attribs":{"x":"12","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"6","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]}]};exports.software_vertical_distribute_bottom=software_vertical_distribute_bottom;var software_vertical_distribute_center={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"21","x2":"12","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"21","x2":"64","y2":"21"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"43","x2":"6","y2":"43"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"58","y1":"43","x2":"64","y2":"43"},"children":[]},{"name":"rect","attribs":{"x":"12","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"6","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]}]};exports.software_vertical_distribute_center=software_vertical_distribute_center;var software_vertical_distribute_top={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"35","x2":"0","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"13","x2":"0","y2":"13"},"children":[]},{"name":"rect","attribs":{"x":"6","y":"35","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"52","height":"16"},"children":[]},{"name":"rect","attribs":{"x":"12","y":"13","fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","width":"40","height":"16"},"children":[]}]};exports.software_vertical_distribute_top=software_vertical_distribute_top;var weather_aquarius={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0,28 16,16 20,28 36,16 40,28 55,16 63,28 \r\n\t"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"0,48 16,36 20,48 36,36 40,48 55,36 63,48 \r\n\t"},"children":[]}]};exports.weather_aquarius=weather_aquarius;var weather_aries={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M6,25c0,0-5-5-5-11S3,1,13,1c13.25,0,19,22,19,63"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M58,25c0,0,5-5,5-11S61,1,51,1C37.75,1,32,23,32,64"},"children":[]}]};exports.weather_aries=weather_aries;var weather_cancer={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"11","cy":"27","r":"10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M5,19c0,0,7-6,28-6c15,0,31,10,31,10"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"53","cy":"37","r":"10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M59,45c0,0-7,6-28,6C16,51,0,41,0,41"},"children":[]}]};exports.weather_cancer=weather_cancer;var weather_capricorn={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M9,5c0,0,0-4,6-4c5,0,4,10,4,10v29"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M19,11c0,0,0-10,7-10s7,10,7,10v29c0,0-1,14,15,14"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,40c-3,0-12,1-12,12c0,1,1,11-12,11"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,54c3.866,0,7-3.134,7-7s-3.134-7-7-7"},"children":[]}]};exports.weather_capricorn=weather_capricorn;var weather_cloud={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,50c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20c-10.102,0-19.2,6.423-21,16c0,0-1.165,0-2,0C5.292,29,1,34.292,1,40s4.292,10,10,10H55z"},"children":[]}]};exports.weather_cloud=weather_cloud;var weather_cloud_drop={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M18,40h-7C5.292,40,1,35.708,1,30s4.292-11,10-11\r\n\tc0.835,0,2,0,2,0C14.8,9.423,23.898,3,34,3c11.414,0,21,8.586,21,20c4.565,0,8,4.435,8,9c0,4.565-3.435,8-8,8H45"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,42c0,5.034,4.136,8,9,8c4.864,0,8-2.966,8-8\r\n\t\tc0-7-8-17-8-17S23,35,23,42z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,42c0,5.034,4.136,8,9,8c4.864,0,8-2.966,8-8\r\n\t\tc0-7-8-17-8-17S23,35,23,42z"},"children":[]}]}]}]};exports.weather_cloud_drop=weather_cloud_drop;var weather_cloud_lightning={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"37,23 23,42 29,42 \r\n\t27,55 41,36 35,36 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M18,40h-7C5.292,40,1,35.708,1,30s4.292-11,10-11\r\n\tc0.835,0,2,0,2,0C14.8,9.423,23.898,3,34,3c11.414,0,21,8.586,21,20c4.565,0,8,4.435,8,9c0,4.565-3.435,8-8,8h-9"},"children":[]}]};exports.weather_cloud_lightning=weather_cloud_lightning;var weather_cloud_snowflake={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M18,40h-7C5.292,40,1,35.708,1,30s4.292-11,10-11\r\n\tc0.835,0,2,0,2,0C14.8,9.423,23.898,3,34,3c11.414,0,21,8.586,21,20c4.565,0,8,4.435,8,9c0,4.565-3.435,8-8,8h-9"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"21,37 23,40 21,43 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"43,43 41,40 43,37 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"40","x2":"23","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"40","x2":"34","y2":"40"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"29,51 32,49 35,51 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"35,29 32,31 29,29 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"42","x2":"32","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"31","x2":"32","y2":"38"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"26.343,30.101 25.636,33.636 \r\n\t22.101,34.343 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"37.657,49.899 38.364,46.364 \r\n\t41.899,45.657 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"38","x2":"25.636","y2":"33.636"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38.364","y1":"46.364","x2":"34","y2":"42"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22.101,45.657 25.636,46.364 \r\n\t26.343,49.899 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"41.899,34.343 38.364,33.636 \r\n\t37.657,30.101 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"42","x2":"25.636","y2":"46.364"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38.364","y1":"33.636","x2":"34","y2":"38"},"children":[]}]};exports.weather_cloud_snowflake=weather_cloud_snowflake;var weather_downpour_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"12","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"22","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"32","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"42","y2":"62"},"children":[]}]};exports.weather_downpour_fullmoon=weather_downpour_fullmoon;var weather_downpour_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"12","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"22","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"32","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"42","y2":"62"},"children":[]}]};exports.weather_downpour_halfmoon=weather_downpour_halfmoon;var weather_downpour_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"12","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"22","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"32","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"42","y2":"62"},"children":[]}]};exports.weather_downpour_sun=weather_downpour_sun;var weather_drop={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M11,41.265C11.052,53.27,20.401,63,32,63\r\n\t\ts21-9.73,21-21.735C53,25.729,32.035,1,32.035,1S10.931,25.729,11,41.265z"},"children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M11,41.265C11.052,53.27,20.401,63,32,63\r\n\t\ts21-9.73,21-21.735C53,25.729,32.035,1,32.035,1S10.931,25.729,11,41.265z"},"children":[]}]}]}]};exports.weather_drop=weather_drop;var weather_fog={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"40","x2":"53","y2":"40"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"48","x2":"53","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"13","y1":"56","x2":"53","y2":"56"},"children":[]}]};exports.weather_fog=weather_fog;var weather_fog_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"45","x2":"54","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"51","x2":"54","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"57","x2":"54","y2":"57"},"children":[]}]};exports.weather_fog_fullmoon=weather_fog_fullmoon;var weather_fog_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"45","x2":"54","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"51","x2":"54","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"57","x2":"54","y2":"57"},"children":[]}]};exports.weather_fog_halfmoon=weather_fog_halfmoon;var weather_fog_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.233,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"45","x2":"54","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"51","x2":"54","y2":"51"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"57","x2":"54","y2":"57"},"children":[]}]};exports.weather_fog_sun=weather_fog_sun;var weather_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]}]};exports.weather_fullmoon=weather_fullmoon;var weather_gemini={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M0,8c0,0,16,4,32,4s32-4,32-4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M64,56c0,0-16-4-32-4S0,56,0,56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"12","x2":"21","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"43","y1":"12","x2":"43","y2":"52"},"children":[]}]};exports.weather_gemini=weather_gemini;var weather_hail={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10H55z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"45","x2":"19","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"45","x2":"9","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"45","x2":"29","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"45","x2":"39","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"45","x2":"49","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"59","x2":"16","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"59","x2":"6","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"59","x2":"26","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"59","x2":"36","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"59","x2":"46","y2":"61"},"children":[]}]};exports.weather_hail=weather_hail;var weather_hail_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"16","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"26","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"36","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"46","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]}]};exports.weather_hail_fullmoon=weather_hail_fullmoon;var weather_hail_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"16","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"26","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"36","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"46","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]}]};exports.weather_hail_halfmoon=weather_hail_halfmoon;var weather_hail_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"16","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"26","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"36","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"46","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]}]};exports.weather_hail_sun=weather_hail_sun;var weather_last_quarter={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"59","x2":"47","y2":"59"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"53","x2":"55","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"59","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"41","x2":"62","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"63","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"1","x2":"32","y2":"63"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"29","x2":"63","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"23","x2":"62","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"59","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"11","x2":"55","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"5","x2":"47","y2":"5"},"children":[]}]};exports.weather_last_quarter=weather_last_quarter;var weather_leo={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M22.649,33.597\r\n\tc-8.337-4.888-11.134-15.608-6.247-23.946C21.29,1.312,32.012-1.485,40.35,3.403c8.337,4.888,11.134,15.608,6.247,23.946\r\n\tC46.597,27.35,36,46,36,54"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"19","cy":"42","r":"9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M53.064,58c-1.473,2.963-4.531,5-8.064,5\r\n\tc-4.971,0-9-4.029-9-9"},"children":[]}]};exports.weather_leo=weather_leo;var weather_libra={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41.667,38.002\r\n\tc3.913-2.939,6.444-7.619,6.444-12.891C48.111,16.213,40.897,9,32,9s-16.111,7.213-16.111,16.111c0,5.27,2.53,9.948,6.442,12.889"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"38","x2":"23","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"38","x2":"64","y2":"38"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"55","x2":"64","y2":"55"},"children":[]}]};exports.weather_libra=weather_libra;var weather_lightning={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"40,1 17,37 31,37 \r\n\t24,63 50,27 36,27 "},"children":[]}]};exports.weather_lightning=weather_lightning;var weather_mistyrain={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10H55z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"17","y1":"59","x2":"16","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"59","x2":"6","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"59","x2":"26","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"59","x2":"36","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"59","x2":"46","y2":"61"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"52","x2":"23","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"52","x2":"13","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"52","x2":"33","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"52","x2":"43","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"52","x2":"53","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"44","x2":"18","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"44","x2":"8","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"44","x2":"28","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"44","x2":"38","y2":"46"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"44","x2":"48","y2":"46"},"children":[]}]};exports.weather_mistyrain=weather_mistyrain;var weather_mistyrain_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"48","x2":"18","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"48","x2":"28","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"48","x2":"38","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"48","x2":"48","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"54","x2":"10","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"54","x2":"20","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"54","x2":"30","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"54","x2":"40","y2":"56"},"children":[]}]};exports.weather_mistyrain_fullmoon=weather_mistyrain_fullmoon;var weather_mistyrain_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"48","x2":"18","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"48","x2":"28","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"48","x2":"38","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"48","x2":"48","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"54","x2":"10","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"54","x2":"20","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"54","x2":"30","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"54","x2":"40","y2":"56"},"children":[]}]};exports.weather_mistyrain_halfmoon=weather_mistyrain_halfmoon;var weather_mistyrain_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"60","x2":"14","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"25","y1":"60","x2":"24","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"35","y1":"60","x2":"34","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"60","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"48","x2":"18","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"48","x2":"28","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"39","y1":"48","x2":"38","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"48","x2":"48","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"54","x2":"10","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"21","y1":"54","x2":"20","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"31","y1":"54","x2":"30","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"54","x2":"40","y2":"56"},"children":[]}]};exports.weather_mistyrain_sun=weather_mistyrain_sun;var weather_moon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M6,52c14.359,0,26-11.641,26-26\r\n\tc0-9.994-6.729-18.648-15-23c3.396-1.277,8.158-2,12-2c17.121,0,31,13.879,31,31S46.121,63,29,63c-9.505,0-18.313-4.265-24-11\r\n\tC5.23,52.006,5.768,52,6,52z"},"children":[]}]};exports.weather_moon=weather_moon;var weather_moondown_full={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,53 32,60 \r\n\t39,53 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48.159,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19s-19,8.507-19,19c0,3.668,1.04,7.094,2.841,9.998"},"children":[]}]};exports.weather_moondown_full=weather_moondown_full;var weather_moondown_half={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,53 32,60 \r\n\t39,53 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48.158,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19c-0.059,0-0.115,0.008-0.175,0.009C32.574,19.688,33,21.543,33,23.5C33,30.956,26.956,37,19.5,37\r\n\tc-2.323,0-4.51-0.588-6.418-1.621C13.037,35.914,13,36.453,13,37c0,3.668,1.039,7.094,2.841,9.998"},"children":[]}]};exports.weather_moondown_half=weather_moondown_half;var weather_moonset_full={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,60 32,53 \r\n\t25,60 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48.159,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19s-19,8.507-19,19c0,3.668,1.04,7.094,2.841,9.998"},"children":[]}]};exports.weather_moonset_full=weather_moonset_full;var weather_moonset_half={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#010101","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#010101","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,53 32,60 \r\n\t39,53 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#010101","stroke-width":"2","stroke-miterlimit":"10","d":"M48.158,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19c-0.059,0-0.115,0.008-0.175,0.009C32.574,19.688,33,21.543,33,23.5C33,30.956,26.956,37,19.5,37\r\n\tc-2.323,0-4.51-0.588-6.418-1.621C13.037,35.914,13,36.453,13,37c0,3.668,1.039,7.094,2.841,9.998"},"children":[]}]};exports.weather_moonset_half=weather_moonset_half;var weather_move2={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"5","x2":"17","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"11","x2":"9","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"17","x2":"5","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"23","x2":"2","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"29","x2":"1","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"63","x2":"32","y2":"1"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"35","x2":"1","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"41","x2":"2","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"47","x2":"5","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"53","x2":"9","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"59","x2":"17","y2":"59"},"children":[]}]};exports.weather_move2=weather_move2;var weather_newmoon={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"5","x2":"17","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"11","x2":"9","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"59","y1":"17","x2":"5","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"23","x2":"2","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"29","x2":"1","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"35","x2":"1","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"62","y1":"41","x2":"2","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"59","y1":"47","x2":"5","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"55","y1":"53","x2":"9","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"59","x2":"17","y2":"59"},"children":[]}]};exports.weather_newmoon=weather_newmoon;var weather_pisces={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M54,0c0,0-10,16-10,32s10,32,10,32"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M10,64c0,0,10-16,10-32S10,0,10,0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"7","y1":"32","x2":"57","y2":"32"},"children":[]}]};exports.weather_pisces=weather_pisces;var weather_rain={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10H55z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"46","x2":"22","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"46","x2":"22","y2":"60"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"46","x2":"12","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"12","y1":"46","x2":"12","y2":"60"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"46","x2":"32","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"46","x2":"32","y2":"60"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"46","x2":"42","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"46","x2":"42","y2":"60"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"46","x2":"52","y2":"60"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"52","y1":"46","x2":"52","y2":"60"},"children":[]}]}]}]};exports.weather_rain=weather_rain;var weather_rain_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"20","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"30","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"40","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"50","y2":"62"},"children":[]}]};exports.weather_rain_fullmoon=weather_rain_fullmoon;var weather_rain_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"20","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"30","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"40","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"50","y2":"62"},"children":[]}]};exports.weather_rain_halfmoon=weather_rain_halfmoon;var weather_rain_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.233,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"20","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"48","x2":"30","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"48","x2":"40","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"48","x2":"50","y2":"62"},"children":[]}]};exports.weather_rain_sun=weather_rain_sun;var weather_sagittarius={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"63","y1":"1","x2":"0","y2":"64"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"36,1 63,1 63,28 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"1","y1":"28","x2":"36","y2":"63"},"children":[]}]};exports.weather_sagittarius=weather_sagittarius;var weather_scorpio={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M30,52V12c0,0,0-11,8-11s8,11,8,11s0,33,0,40\r\n\tc0,0,0,6,6,6h5"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M14,52V12c0,0,0.083-11,8-11s8,11,8,11"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M14,12c0,0,0-10-8-10"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"52,53 57,58 \r\n\t52,63 "},"children":[]}]};exports.weather_scorpio=weather_scorpio;var weather_snow={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10H55z"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"43","x2":"22","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"52","x2":"22","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"45","x2":"24","y2":"48"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"52","x2":"17","y2":"55"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"55","x2":"24","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"48","x2":"17","y2":"45"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"29","y1":"50","x2":"24","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"50","x2":"15","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"48","x2":"42","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"57","x2":"42","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"50","x2":"44","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"57","x2":"37","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"60","x2":"44","y2":"57"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"53","x2":"37","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"49","y1":"55","x2":"44","y2":"55"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"55","x2":"35","y2":"55"},"children":[]}]};exports.weather_snow=weather_snow;var weather_snow_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"56","x2":"24","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"50","x2":"26","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"56","x2":"20","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"58","x2":"26","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"52","x2":"20","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"54","x2":"26","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"54","x2":"18","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"50","x2":"44","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"58","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"52","x2":"46","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"58","x2":"40","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"60","x2":"46","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"54","x2":"40","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"56","x2":"46","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"56","x2":"38","y2":"56"},"children":[]}]};exports.weather_snow_fullmoon=weather_snow_fullmoon;var weather_snow_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"56","x2":"24","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"50","x2":"26","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"56","x2":"20","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"58","x2":"26","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"52","x2":"20","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"54","x2":"26","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"54","x2":"18","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"50","x2":"44","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"58","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"52","x2":"46","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"58","x2":"40","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"60","x2":"46","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"54","x2":"40","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"56","x2":"46","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"56","x2":"38","y2":"56"},"children":[]}]};exports.weather_snow_halfmoon=weather_snow_halfmoon;var weather_snow_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"48","x2":"24","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"24","y1":"56","x2":"24","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"50","x2":"26","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"56","x2":"20","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"28","y1":"58","x2":"26","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"52","x2":"20","y2":"50"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"54","x2":"26","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"54","x2":"18","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"50","x2":"44","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"58","x2":"44","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"52","x2":"46","y2":"54"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"58","x2":"40","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"60","x2":"46","y2":"58"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"54","x2":"40","y2":"52"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"56","x2":"46","y2":"56"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"56","x2":"38","y2":"56"},"children":[]}]};exports.weather_snow_sun=weather_snow_sun;var weather_snowflake={"viewBox":"0 0 64 64","children":[{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"1,24 9,32 1,40 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"63,40 55,32 63,24 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"24,63 32,55 40,63 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"40,1 32,9 24,1 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"5,49 15,49 15,59 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"59,15 49,15 49,5 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"26","x2":"49","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"49","x2":"26","y2":"38"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"15,5 15,15 5,15 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"49,59 49,49 59,49 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"38","y1":"38","x2":"49","y2":"49"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"15","y1":"15","x2":"26","y2":"26"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"40","y1":"32","x2":"55","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"9","y1":"32","x2":"24","y2":"32"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"40","x2":"32","y2":"55"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"9","x2":"32","y2":"24"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"8"},"children":[]}]};exports.weather_snowflake=weather_snowflake;var weather_star={"viewBox":"0 0 64 64","children":[{"name":"polygon","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,47 12,62 20,38 2,24 24,24 32,1 40,24 \r\n\t62,24 44,38 52,62 "},"children":[]}]};exports.weather_star=weather_star;var weather_storm_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 34,55 30,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,48 39,55 44,55 40,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,48 19,55 24,55 20,62 "},"children":[]}]};exports.weather_storm_fullmoon=weather_storm_fullmoon;var weather_storm_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 34,55 30,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,48 39,55 44,55 40,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,48 19,55 24,55 20,62 "},"children":[]}]};exports.weather_storm_halfmoon=weather_storm_halfmoon;var weather_storm_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 34,55 30,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"42,48 39,55 44,55 40,62 "},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"22,48 19,55 24,55 20,62 "},"children":[]}]};exports.weather_storm_sun=weather_storm_sun;var weather_sun={"viewBox":"0 0 64 64","children":[{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"16"},"children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"16"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"10","x2":"32","y2":"0"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"10","x2":"32","y2":"0"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"54"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"64","x2":"32","y2":"54"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"32","x2":"64","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"54","y1":"32","x2":"64","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"10","y2":"32"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"32","x2":"10","y2":"32"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"16","x2":"53","y2":"11"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"16","x2":"53","y2":"11"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"16","y2":"48"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"53","x2":"16","y2":"48"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"48","x2":"53","y2":"53"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"48","y1":"48","x2":"53","y2":"53"},"children":[]}]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"11","x2":"16","y2":"16"},"children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"11","y1":"11","x2":"16","y2":"16"},"children":[]}]}]}]};exports.weather_sun=weather_sun;var weather_sundown={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"37","x2":"0","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"54","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"15","x2":"32","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"23","x2":"6","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"23","x2":"58","y2":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"25,53 32,60 \r\n\t39,53 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48.159,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19s-19,8.507-19,19c0,3.668,1.04,7.094,2.841,9.998"},"children":[]}]};exports.weather_sundown=weather_sundown;var weather_sunset={"viewBox":"0 0 64 64","children":[{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"0","y1":"47","x2":"64","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"37","x2":"0","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"64","y1":"37","x2":"54","y2":"37"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"32","y1":"15","x2":"32","y2":"4"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"14","y1":"23","x2":"6","y2":"15"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"50","y1":"23","x2":"58","y2":"15"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-linejoin":"bevel","stroke-miterlimit":"10","points":"39,60 32,53 \r\n\t25,60 "},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48.159,47C49.96,44.096,51,40.669,51,37\r\n\tc0-10.493-8.506-19-19-19s-19,8.507-19,19c0,3.668,1.04,7.094,2.841,9.998"},"children":[]}]};exports.weather_sunset=weather_sunset;var weather_taurus={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"43","r":"18"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M0,3c14,0,15,12,15,12s0,10,17,10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M64,3C50,3,49,15,49,15s0,10-17,10"},"children":[]}]};exports.weather_taurus=weather_taurus;var weather_tempest={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10H55z"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,46 29,53 33,53 29,60 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"46","x2":"39","y2":"60"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"46","x2":"14","y2":"60"},"children":[]}]};exports.weather_tempest=weather_tempest;var weather_tempest_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 33,55 29,62 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"48","x2":"15","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"48","x2":"39","y2":"62"},"children":[]}]};exports.weather_tempest_fullmoon=weather_tempest_fullmoon;var weather_tempest_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 33,55 29,62 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"48","x2":"15","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"48","x2":"39","y2":"62"},"children":[]}]};exports.weather_tempest_halfmoon=weather_tempest_halfmoon;var weather_tempest_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"polyline","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","points":"32,48 29,55 33,55 29,62 "},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"48","x2":"15","y2":"62"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"47","y1":"48","x2":"39","y2":"62"},"children":[]}]};exports.weather_tempest_sun=weather_tempest_sun;var weather_variable_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,50c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,37.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,31.979,1,29.577,1,27c0-7.18,5.82-13,13-13c4.604,0,8.646,2.392,10.957,6.001"},"children":[]}]};exports.weather_variable_fullmoon=weather_variable_fullmoon;var weather_variable_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,50c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,20.001C22.646,16.392,18.604,14,14,14\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]}]};exports.weather_variable_halfmoon=weather_variable_halfmoon;var weather_variable_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,50c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.233,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9H56z"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,16.752C27.793,15.028,25.017,14,22,14\r\n\tc-7.18,0-13,5.82-13,13c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"27","x2":"0","y2":"27"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"11","x2":"22","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"15","x2":"4","y2":"9"},"children":[]}]};exports.weather_variable_sun=weather_variable_sun;var weather_virgo={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M54,64c0,0-6-5-6-12s0-40,0-40s0-11-8-11s-8,11-8,11\r\n\tv40"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,52V12c0,0,0.083-11,8-11s8,11,8,11"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M16,12c0,0,0-10-8-10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M48,24c0,0,0-14,6-14s6,14,6,14s-1,34-27,34"},"children":[]}]};exports.weather_virgo=weather_virgo;var weather_waning_cresent={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32.002","cy":"31.999","r":"31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41.002,61.999c-13.242-3.528-22-15.646-22-30\r\n\tc0-14.355,8.756-26.473,22-30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"5","x2":"47","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"11","x2":"55","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"17","x2":"59","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"23","x2":"62","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"29","x2":"63","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"35","x2":"63","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"41","x2":"62","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"47","x2":"59","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"53","x2":"55","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"59","x2":"47","y2":"59"},"children":[]}]};exports.weather_waning_cresent=weather_waning_cresent;var weather_waning_gibbous={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,2c13.242,3.528,22,15.646,22,30\r\n\tc0,14.355-8.756,26.473-22,30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"59","x2":"47","y2":"59"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"53","x2":"55","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"47","x2":"59","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"41","x2":"62","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"35","x2":"63","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"29","x2":"63","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"23","x2":"62","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"17","x2":"59","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"11","x2":"55","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"5","x2":"47","y2":"5"},"children":[]}]};exports.weather_waning_gibbous=weather_waning_gibbous;var weather_waxing_cresent={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23,2c13.243,3.528,22,15.646,22,30\r\n\tc0,14.355-8.756,26.473-22,30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"59","x2":"17","y2":"59"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"53","x2":"9","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"42","y1":"47","x2":"5","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"41","x2":"2","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"35","x2":"1","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"45","y1":"29","x2":"1","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"44","y1":"23","x2":"2","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"41","y1":"17","x2":"5","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"37","y1":"11","x2":"9","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"30","y1":"5","x2":"17","y2":"5"},"children":[]}]};exports.weather_waxing_cresent=weather_waxing_cresent;var weather_waxing_gibbous={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M41,62c-13.243-3.528-22-15.646-22-30\r\n\tc0-14.355,8.756-26.473,22-30"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"5","x2":"17","y2":"5"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"11","x2":"9","y2":"11"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"17","x2":"5","y2":"17"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"23","x2":"2","y2":"23"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"29","x2":"1","y2":"29"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"19","y1":"35","x2":"1","y2":"35"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"20","y1":"41","x2":"2","y2":"41"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"23","y1":"47","x2":"5","y2":"47"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"27","y1":"53","x2":"9","y2":"53"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"34","y1":"59","x2":"17","y2":"59"},"children":[]}]};exports.weather_waxing_gibbous=weather_waxing_gibbous;var weather_wind={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M55,40c4.565,0,8-3.435,8-8c0-4.565-3.435-9-8-9\r\n\tc0-11.414-9.586-20-21-20C23.898,3,14.8,9.423,13,19c0,0-1.165,0-2,0C5.292,19,1,24.292,1,30s4.292,10,10,10"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,58c0,2.761,2.238,5,5,5s5-2.239,5-5\r\n\ts-2.238-5-5-5H2"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,42c0-2.761,2.238-5,5-5s5,2.239,5,5\r\n\ts-2.238,5-5,5H4"},"children":[]}]};exports.weather_wind=weather_wind;var weather_wind_E={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M32,44c6.628,0,25-12,25-12S38.628,20,32,20\r\n\ts-12,5.373-12,12S25.372,44,32,44z"},"children":[]}]};exports.weather_wind_E=weather_wind_E;var weather_wind_N={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M44,32c0-6.628-12-25-12-25S20,25.372,20,32\r\n\ts5.373,12,12,12S44,38.628,44,32z"},"children":[]}]};exports.weather_wind_N=weather_wind_N;var weather_wind_NE={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40.485,40.484C45.172,35.798,49,15,49,15\r\n\ts-20.799,3.827-25.485,8.514c-4.687,4.688-4.686,12.285,0,16.971C28.2,45.171,35.799,45.172,40.485,40.484z"},"children":[]}]};exports.weather_wind_NE=weather_wind_NE;var weather_wind_NW={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40.484,23.514C35.798,18.828,15,15,15,15\r\n\ts3.827,20.799,8.514,25.484c4.688,4.688,12.285,4.686,16.971,0C45.171,35.799,45.172,28.201,40.484,23.514z"},"children":[]}]};exports.weather_wind_NW=weather_wind_NW;var weather_wind_S={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M20,32c0,6.628,12,25,12,25s12-18.372,12-25\r\n\ts-5.373-12-12-12S20,25.372,20,32z"},"children":[]}]};exports.weather_wind_S=weather_wind_S;var weather_wind_SE={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"31.999","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"31.999","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23.515,40.484\r\n\tc4.687,4.687,25.484,8.515,25.484,8.515S45.172,28.2,40.485,23.514c-4.688-4.687-12.285-4.686-16.971,0\r\n\tC18.828,28.199,18.827,35.798,23.515,40.484z"},"children":[]}]};exports.weather_wind_SE=weather_wind_SE;var weather_wind_SW={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"32","cy":"32","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M23.515,23.515C18.828,28.201,15,48.999,15,48.999\r\n\ts20.799-3.827,25.485-8.514c4.687-4.688,4.686-12.285,0-16.971C35.8,18.828,28.201,18.827,23.515,23.515z"},"children":[]}]};exports.weather_wind_SW=weather_wind_SW;var weather_wind_W={"viewBox":"0 0 64 64","children":[{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"31.999","cy":"31.999","r":"31"},"children":[]},{"name":"circle","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","cx":"31.999","cy":"31.999","r":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M31.999,19.999c-6.628,0-25,12-25,12\r\n\ts18.372,12,25,12s12-5.373,12-12S38.627,19.999,31.999,19.999z"},"children":[]}]};exports.weather_wind_W=weather_wind_W;var weather_wind_fullmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M7.004,32.959c-1.59-1.017-2.943-2.37-3.961-3.96\r\n\tC1.75,26.979,1,24.577,1,22C1,14.82,6.82,9,14,9c4.604,0,8.646,2.392,10.957,6.001"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,58c0,2.761,2.238,5,5,5s5-2.239,5-5\r\n\ts-2.238-5-5-5H2"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,44c0-2.761,2.238-5,5-5s5,2.239,5,5\r\n\ts-2.238,5-5,5H4"},"children":[]}]};exports.weather_wind_fullmoon=weather_wind_fullmoon;var weather_wind_halfmoon={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M24.957,15.001C22.646,11.392,18.604,9,14,9\r\n\tc-0.826,0-1.631,0.085-2.414,0.233c0.891,1.396,1.414,3.05,1.414,4.83c0,4.971-4.029,9-9,9c-1.046,0-2.046-0.188-2.98-0.516\r\n\tc0.099,2.368,0.822,4.576,2.023,6.452c1.018,1.59,2.371,2.943,3.961,3.96"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,58c0,2.761,2.238,5,5,5s5-2.239,5-5\r\n\ts-2.238-5-5-5H2"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,44c0-2.761,2.238-5,5-5s5,2.239,5,5\r\n\ts-2.238,5-5,5H4"},"children":[]}]};exports.weather_wind_halfmoon=weather_wind_halfmoon;var weather_wind_sun={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M56,45c4.19,0,7-2.81,7-7c0-4.189-2.81-9-7-9\r\n\tc0-10.475-9.525-18-20-18c-9.271,0-17.348,6.211-19,15c0,0-1.232,0-2,0c-5.238,0-9,4.762-9,10s3.762,9,9,9"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M29.999,11.752C27.793,10.028,25.017,9,22,9\r\n\tC14.82,9,9,14.82,9,22c0,2.577,0.707,3.979,2,6"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"6","y1":"22","x2":"0","y2":"22"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"22","y1":"6","x2":"22","y2":"0"},"children":[]},{"name":"line","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","x1":"10","y1":"10","x2":"4","y2":"4"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,58c0,2.761,2.238,5,5,5s5-2.239,5-5\r\n\ts-2.238-5-5-5H2"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M40,44c0-2.761,2.238-5,5-5s5,2.239,5,5\r\n\ts-2.238,5-5,5H4"},"children":[]}]};exports.weather_wind_sun=weather_wind_sun;var weather_windgust={"viewBox":"0 0 64 64","children":[{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M44,40c0,3.866,3.134,7,7,7s7-3.134,7-7\r\n\ts-3.134-7-7-7H0"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M49,19c0-3.866,3.134-7,7-7s7,3.134,7,7\r\n\ts-3.134,7-7,7H0"},"children":[]},{"name":"path","attribs":{"fill":"none","stroke":"#000000","stroke-width":"2","stroke-miterlimit":"10","d":"M27,45c0,2.761,2.239,5,5,5s5-2.239,5-5\r\n\ts-2.239-5-5-5H0"},"children":[]}]};exports.weather_windgust=weather_windgust;

/***/ }),
/* 1410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ic_lock = exports.ic_list = exports.ic_line_weight = exports.ic_line_style = exports.ic_lightbulb_outline = exports.ic_launch = exports.ic_language = exports.ic_label_outline = exports.ic_label = exports.ic_invert_colors = exports.ic_input = exports.ic_info_outline = exports.ic_info = exports.ic_important_devices = exports.ic_https = exports.ic_http = exports.ic_hourglass_full = exports.ic_hourglass_empty = exports.ic_home = exports.ic_history = exports.ic_highlight_off = exports.ic_help_outline = exports.ic_help = exports.ic_group_work = exports.ic_grade = exports.ic_gif = exports.ic_get_app = exports.ic_gavel = exports.ic_g_translate = exports.ic_flip_to_front = exports.ic_flip_to_back = exports.ic_flight_takeoff = exports.ic_flight_land = exports.ic_fingerprint = exports.ic_find_replace = exports.ic_find_in_page = exports.ic_feedback = exports.ic_favorite_border = exports.ic_favorite = exports.ic_face = exports.ic_extension = exports.ic_explore = exports.ic_exit_to_app = exports.ic_event_seat = exports.ic_event = exports.ic_euro_symbol = exports.ic_eject = exports.ic_donut_small = exports.ic_donut_large = exports.ic_done_all = exports.ic_done = exports.ic_dns = exports.ic_description = exports.ic_delete_forever = exports.ic_delete = exports.ic_date_range = exports.ic_dashboard = exports.ic_credit_card = exports.ic_copyright = exports.ic_compare_arrows = exports.ic_code = exports.ic_class = exports.ic_chrome_reader_mode = exports.ic_check_circle = exports.ic_change_history = exports.ic_card_travel = exports.ic_card_membership = exports.ic_card_giftcard = exports.ic_camera_enhance = exports.ic_cached = exports.ic_build = exports.ic_bug_report = exports.ic_bookmark_border = exports.ic_bookmark = exports.ic_book = exports.ic_backup = exports.ic_autorenew = exports.ic_assignment_turned_in = exports.ic_assignment_returned = exports.ic_assignment_return = exports.ic_assignment_late = exports.ic_assignment_ind = exports.ic_assignment = exports.ic_assessment = exports.ic_aspect_ratio = exports.ic_announcement = exports.ic_android = exports.ic_all_out = exports.ic_alarm_on = exports.ic_alarm_off = exports.ic_alarm_add = exports.ic_alarm = exports.ic_add_shopping_cart = exports.ic_account_circle = exports.ic_account_box = exports.ic_account_balance_wallet = exports.ic_account_balance = exports.ic_accessible = exports.ic_accessibility = exports.ic_3d_rotation = void 0;
exports.ic_view_carousel = exports.ic_view_array = exports.ic_view_agenda = exports.ic_verified_user = exports.ic_update = exports.ic_turned_in_not = exports.ic_turned_in = exports.ic_trending_up = exports.ic_trending_flat = exports.ic_trending_down = exports.ic_translate = exports.ic_track_changes = exports.ic_touch_app = exports.ic_toll = exports.ic_today = exports.ic_toc = exports.ic_timeline = exports.ic_thumbs_up_down = exports.ic_thumb_up = exports.ic_thumb_down = exports.ic_theaters = exports.ic_tab_unselected = exports.ic_tab = exports.ic_system_update_alt = exports.ic_swap_vertical_circle = exports.ic_swap_vert = exports.ic_swap_horiz = exports.ic_supervisor_account = exports.ic_subject = exports.ic_store = exports.ic_stars = exports.ic_spellcheck = exports.ic_speaker_notes_off = exports.ic_speaker_notes = exports.ic_shopping_cart = exports.ic_shopping_basket = exports.ic_shop_two = exports.ic_shop = exports.ic_settings_voice = exports.ic_settings_remote = exports.ic_settings_power = exports.ic_settings_phone = exports.ic_settings_overscan = exports.ic_settings_input_svideo = exports.ic_settings_input_hdmi = exports.ic_settings_input_composite = exports.ic_settings_input_component = exports.ic_settings_input_antenna = exports.ic_settings_ethernet = exports.ic_settings_cell = exports.ic_settings_brightness = exports.ic_settings_bluetooth = exports.ic_settings_backup_restore = exports.ic_settings_applications = exports.ic_settings = exports.ic_search = exports.ic_schedule = exports.ic_rowing = exports.ic_rounded_corner = exports.ic_room = exports.ic_restore_page = exports.ic_restore = exports.ic_report_problem = exports.ic_reorder = exports.ic_remove_shopping_cart = exports.ic_redeem = exports.ic_record_voice_over = exports.ic_receipt = exports.ic_question_answer = exports.ic_query_builder = exports.ic_print = exports.ic_pregnant_woman = exports.ic_power_settings_new = exports.ic_polymer = exports.ic_play_for_work = exports.ic_picture_in_picture_alt = exports.ic_picture_in_picture = exports.ic_pets = exports.ic_perm_scan_wifi = exports.ic_perm_phone_msg = exports.ic_perm_media = exports.ic_perm_identity = exports.ic_perm_device_information = exports.ic_perm_data_setting = exports.ic_perm_contact_calendar = exports.ic_perm_camera_mic = exports.ic_payment = exports.ic_pan_tool = exports.ic_pageview = exports.ic_open_with = exports.ic_open_in_new = exports.ic_open_in_browser = exports.ic_opacity = exports.ic_offline_pin = exports.ic_note_add = exports.ic_motorcycle = exports.ic_markunread_mailbox = exports.ic_loyalty = exports.ic_lock_outline = exports.ic_lock_open = void 0;
exports.ic_business = exports.ic_web_asset = exports.ic_web = exports.ic_volume_up = exports.ic_volume_off = exports.ic_volume_mute = exports.ic_volume_down = exports.ic_videocam_off = exports.ic_videocam = exports.ic_video_library = exports.ic_video_label = exports.ic_video_call = exports.ic_surround_sound = exports.ic_subtitles = exports.ic_subscriptions = exports.ic_stop = exports.ic_sort_by_alpha = exports.ic_snooze = exports.ic_slow_motion_video = exports.ic_skip_previous = exports.ic_skip_next = exports.ic_shuffle = exports.ic_replay_5 = exports.ic_replay_30 = exports.ic_replay = exports.ic_replay_10 = exports.ic_repeat_one = exports.ic_repeat = exports.ic_remove_from_queue = exports.ic_recent_actors = exports.ic_radio = exports.ic_queue_play_next = exports.ic_queue_music = exports.ic_queue = exports.ic_playlist_play = exports.ic_playlist_add_check = exports.ic_playlist_add = exports.ic_play_circle_outline = exports.ic_play_circle_filled = exports.ic_play_arrow = exports.ic_pause_circle_outline = exports.ic_pause_circle_filled = exports.ic_pause = exports.ic_note = exports.ic_not_interested = exports.ic_new_releases = exports.ic_music_video = exports.ic_movie = exports.ic_mic_off = exports.ic_mic_none = exports.ic_mic = exports.ic_loop = exports.ic_library_music = exports.ic_library_books = exports.ic_library_add = exports.ic_high_quality = exports.ic_hearing = exports.ic_hd = exports.ic_games = exports.ic_forward_5 = exports.ic_forward_30 = exports.ic_forward_10 = exports.ic_fiber_smart_record = exports.ic_fiber_pin = exports.ic_fiber_new = exports.ic_fiber_manual_record = exports.ic_fiber_dvr = exports.ic_featured_video = exports.ic_featured_play_list = exports.ic_fast_rewind = exports.ic_fast_forward = exports.ic_explicit = exports.ic_equalizer = exports.ic_closed_caption = exports.ic_call_to_action = exports.ic_branding_watermark = exports.ic_av_timer = exports.ic_art_track = exports.ic_album = exports.ic_airplay = exports.ic_add_to_queue = exports.ic_warning = exports.ic_error_outline = exports.ic_error = exports.ic_add_alert = exports.ic_zoom_out = exports.ic_zoom_in = exports.ic_youtube_searched_for = exports.ic_work = exports.ic_watch_later = exports.ic_visibility_off = exports.ic_visibility = exports.ic_view_week = exports.ic_view_stream = exports.ic_view_quilt = exports.ic_view_module = exports.ic_view_list = exports.ic_view_headline = exports.ic_view_day = exports.ic_view_column = void 0;
exports.ic_battery_60 = exports.ic_battery_50 = exports.ic_battery_30 = exports.ic_battery_20 = exports.ic_airplanemode_inactive = exports.ic_airplanemode_active = exports.ic_add_alarm = exports.ic_access_time = exports.ic_access_alarms = exports.ic_access_alarm = exports.ic_weekend = exports.ic_undo = exports.ic_unarchive = exports.ic_text_format = exports.ic_sort = exports.ic_send = exports.ic_select_all = exports.ic_save = exports.ic_report = exports.ic_reply_all = exports.ic_reply = exports.ic_remove_circle_outline = exports.ic_remove_circle = exports.ic_remove = exports.ic_redo = exports.ic_next_week = exports.ic_move_to_inbox = exports.ic_markunread = exports.ic_mail = exports.ic_low_priority = exports.ic_link = exports.ic_inbox = exports.ic_gesture = exports.ic_forward = exports.ic_font_download = exports.ic_flag = exports.ic_filter_list = exports.ic_drafts = exports.ic_delete_sweep = exports.ic_create = exports.ic_content_paste = exports.ic_content_cut = exports.ic_content_copy = exports.ic_clear = exports.ic_block = exports.ic_backspace = exports.ic_archive = exports.ic_add_circle_outline = exports.ic_add_circle = exports.ic_add_box = exports.ic_add = exports.ic_vpn_key = exports.ic_voicemail = exports.ic_textsms = exports.ic_swap_calls = exports.ic_stop_screen_share = exports.ic_stay_primary_portrait = exports.ic_stay_primary_landscape = exports.ic_stay_current_portrait = exports.ic_stay_current_landscape = exports.ic_speaker_phone = exports.ic_screen_share = exports.ic_rss_feed = exports.ic_ring_volume = exports.ic_present_to_all = exports.ic_portable_wifi_off = exports.ic_phonelink_setup = exports.ic_phonelink_ring = exports.ic_phonelink_lock = exports.ic_phonelink_erase = exports.ic_phone = exports.ic_no_sim = exports.ic_message = exports.ic_mail_outline = exports.ic_location_on = exports.ic_location_off = exports.ic_live_help = exports.ic_invert_colors_off = exports.ic_import_export = exports.ic_import_contacts = exports.ic_forum = exports.ic_email = exports.ic_dialpad = exports.ic_dialer_sip = exports.ic_contacts = exports.ic_contact_phone = exports.ic_contact_mail = exports.ic_comment = exports.ic_clear_all = exports.ic_chat_bubble_outline = exports.ic_chat_bubble = exports.ic_chat = exports.ic_call_split = exports.ic_call_received = exports.ic_call_missed_outgoing = exports.ic_call_missed = exports.ic_call_merge = exports.ic_call_made = exports.ic_call_end = exports.ic_call = void 0;
exports.ic_format_list_numbered = exports.ic_format_list_bulleted = exports.ic_format_line_spacing = exports.ic_format_italic = exports.ic_format_indent_increase = exports.ic_format_indent_decrease = exports.ic_format_color_text = exports.ic_format_color_reset = exports.ic_format_color_fill = exports.ic_format_clear = exports.ic_format_bold = exports.ic_format_align_right = exports.ic_format_align_left = exports.ic_format_align_justify = exports.ic_format_align_center = exports.ic_drag_handle = exports.ic_bubble_chart = exports.ic_border_vertical = exports.ic_border_top = exports.ic_border_style = exports.ic_border_right = exports.ic_border_outer = exports.ic_border_left = exports.ic_border_inner = exports.ic_border_horizontal = exports.ic_border_color = exports.ic_border_clear = exports.ic_border_bottom = exports.ic_border_all = exports.ic_attach_money = exports.ic_attach_file = exports.ic_wifi_tethering = exports.ic_wifi_lock = exports.ic_widgets = exports.ic_wallpaper = exports.ic_usb = exports.ic_storage = exports.ic_signal_wifi_off = exports.ic_signal_wifi_4_bar_lock = exports.ic_signal_wifi_4_bar = exports.ic_signal_wifi_3_bar_lock = exports.ic_signal_wifi_3_bar = exports.ic_signal_wifi_2_bar_lock = exports.ic_signal_wifi_2_bar = exports.ic_signal_wifi_1_bar_lock = exports.ic_signal_wifi_1_bar = exports.ic_signal_wifi_0_bar = exports.ic_signal_cellular_off = exports.ic_signal_cellular_null = exports.ic_signal_cellular_no_sim = exports.ic_signal_cellular_connected_no_internet_4_bar = exports.ic_signal_cellular_connected_no_internet_3_bar = exports.ic_signal_cellular_connected_no_internet_2_bar = exports.ic_signal_cellular_connected_no_internet_1_bar = exports.ic_signal_cellular_connected_no_internet_0_bar = exports.ic_signal_cellular_4_bar = exports.ic_signal_cellular_3_bar = exports.ic_signal_cellular_2_bar = exports.ic_signal_cellular_1_bar = exports.ic_signal_cellular_0_bar = exports.ic_settings_system_daydream = exports.ic_sd_storage = exports.ic_screen_rotation = exports.ic_screen_lock_rotation = exports.ic_screen_lock_portrait = exports.ic_screen_lock_landscape = exports.ic_nfc = exports.ic_network_wifi = exports.ic_network_cell = exports.ic_location_searching = exports.ic_location_disabled = exports.ic_graphic_eq = exports.ic_gps_off = exports.ic_gps_not_fixed = exports.ic_gps_fixed = exports.ic_dvr = exports.ic_devices = exports.ic_developer_mode = exports.ic_data_usage = exports.ic_brightness_medium = exports.ic_brightness_low = exports.ic_brightness_high = exports.ic_brightness_auto = exports.ic_bluetooth_searching = exports.ic_bluetooth_disabled = exports.ic_bluetooth_connected = exports.ic_bluetooth = exports.ic_battery_unknown = exports.ic_battery_std = exports.ic_battery_full = exports.ic_battery_charging_full = exports.ic_battery_charging_90 = exports.ic_battery_charging_80 = exports.ic_battery_charging_60 = exports.ic_battery_charging_50 = exports.ic_battery_charging_30 = exports.ic_battery_charging_20 = exports.ic_battery_alert = exports.ic_battery_90 = exports.ic_battery_80 = void 0;
exports.ic_add_a_photo = exports.ic_watch = exports.ic_videogame_asset = exports.ic_tv = exports.ic_toys = exports.ic_tablet_mac = exports.ic_tablet_android = exports.ic_tablet = exports.ic_speaker_group = exports.ic_speaker = exports.ic_smartphone = exports.ic_sim_card = exports.ic_security = exports.ic_scanner = exports.ic_router = exports.ic_power_input = exports.ic_phonelink_off = exports.ic_phonelink = exports.ic_phone_iphone = exports.ic_phone_android = exports.ic_mouse = exports.ic_memory = exports.ic_laptop_windows = exports.ic_laptop_mac = exports.ic_laptop_chromebook = exports.ic_laptop = exports.ic_keyboard_voice = exports.ic_keyboard_tab = exports.ic_keyboard_return = exports.ic_keyboard_hide = exports.ic_keyboard_capslock = exports.ic_keyboard_backspace = exports.ic_keyboard_arrow_up = exports.ic_keyboard_arrow_right = exports.ic_keyboard_arrow_left = exports.ic_keyboard_arrow_down = exports.ic_keyboard = exports.ic_headset_mic = exports.ic_headset = exports.ic_gamepad = exports.ic_dock = exports.ic_devices_other = exports.ic_device_hub = exports.ic_developer_board = exports.ic_desktop_windows = exports.ic_desktop_mac = exports.ic_computer = exports.ic_cast_connected = exports.ic_cast = exports.ic_folder_shared = exports.ic_folder_open = exports.ic_folder = exports.ic_file_upload = exports.ic_file_download = exports.ic_create_new_folder = exports.ic_cloud_upload = exports.ic_cloud_queue = exports.ic_cloud_off = exports.ic_cloud_download = exports.ic_cloud_done = exports.ic_cloud_circle = exports.ic_cloud = exports.ic_attachment = exports.ic_wrap_text = exports.ic_vertical_align_top = exports.ic_vertical_align_center = exports.ic_vertical_align_bottom = exports.ic_title = exports.ic_text_fields = exports.ic_strikethrough_s = exports.ic_space_bar = exports.ic_show_chart = exports.ic_short_text = exports.ic_publish = exports.ic_pie_chart_outlined = exports.ic_pie_chart = exports.ic_multiline_chart = exports.ic_money_off = exports.ic_monetization_on = exports.ic_mode_edit = exports.ic_mode_comment = exports.ic_merge_type = exports.ic_linear_scale = exports.ic_insert_photo = exports.ic_insert_link = exports.ic_insert_invitation = exports.ic_insert_emoticon = exports.ic_insert_drive_file = exports.ic_insert_comment = exports.ic_insert_chart = exports.ic_highlight = exports.ic_functions = exports.ic_format_underlined = exports.ic_format_textdirection_r_to_l = exports.ic_format_textdirection_l_to_r = exports.ic_format_strikethrough = exports.ic_format_size = exports.ic_format_shapes = exports.ic_format_quote = exports.ic_format_paint = void 0;
exports.ic_looks_6 = exports.ic_looks_5 = exports.ic_looks_4 = exports.ic_looks_3 = exports.ic_looks = exports.ic_linked_camera = exports.ic_lens = exports.ic_leak_remove = exports.ic_leak_add = exports.ic_landscape = exports.ic_iso = exports.ic_image_aspect_ratio = exports.ic_image = exports.ic_healing = exports.ic_hdr_weak = exports.ic_hdr_strong = exports.ic_hdr_on = exports.ic_hdr_off = exports.ic_grid_on = exports.ic_grid_off = exports.ic_grain = exports.ic_gradient = exports.ic_flip = exports.ic_flash_on = exports.ic_flash_off = exports.ic_flash_auto = exports.ic_flare = exports.ic_filter_vintage = exports.ic_filter_tilt_shift = exports.ic_filter_none = exports.ic_filter_hdr = exports.ic_filter_frames = exports.ic_filter_drama = exports.ic_filter_center_focus = exports.ic_filter_b_and_w = exports.ic_filter_9_plus = exports.ic_filter_9 = exports.ic_filter_8 = exports.ic_filter_7 = exports.ic_filter_6 = exports.ic_filter_5 = exports.ic_filter_4 = exports.ic_filter_3 = exports.ic_filter_2 = exports.ic_filter = exports.ic_filter_1 = exports.ic_exposure_zero = exports.ic_exposure_plus_2 = exports.ic_exposure_plus_1 = exports.ic_exposure_neg_2 = exports.ic_exposure_neg_1 = exports.ic_exposure = exports.ic_edit = exports.ic_details = exports.ic_dehaze = exports.ic_crop_square = exports.ic_crop_rotate = exports.ic_crop_portrait = exports.ic_crop_original = exports.ic_crop_landscape = exports.ic_crop_free = exports.ic_crop_din = exports.ic_crop_7_5 = exports.ic_crop_5_4 = exports.ic_crop_3_2 = exports.ic_crop = exports.ic_crop_16_9 = exports.ic_control_point_duplicate = exports.ic_control_point = exports.ic_compare = exports.ic_colorize = exports.ic_color_lens = exports.ic_collections_bookmark = exports.ic_collections = exports.ic_center_focus_weak = exports.ic_center_focus_strong = exports.ic_camera_roll = exports.ic_camera_rear = exports.ic_camera_front = exports.ic_camera_alt = exports.ic_camera = exports.ic_burst_mode = exports.ic_brush = exports.ic_broken_image = exports.ic_brightness_7 = exports.ic_brightness_6 = exports.ic_brightness_5 = exports.ic_brightness_4 = exports.ic_brightness_3 = exports.ic_brightness_2 = exports.ic_brightness_1 = exports.ic_blur_on = exports.ic_blur_off = exports.ic_blur_linear = exports.ic_blur_circular = exports.ic_audiotrack = exports.ic_assistant_photo = exports.ic_assistant = exports.ic_adjust = exports.ic_add_to_photos = void 0;
exports.ic_local_shipping = exports.ic_local_see = exports.ic_local_printshop = exports.ic_local_post_office = exports.ic_local_play = exports.ic_local_pizza = exports.ic_local_phone = exports.ic_local_pharmacy = exports.ic_local_parking = exports.ic_local_offer = exports.ic_local_movies = exports.ic_local_mall = exports.ic_local_library = exports.ic_local_laundry_service = exports.ic_local_hotel = exports.ic_local_hospital = exports.ic_local_grocery_store = exports.ic_local_gas_station = exports.ic_local_florist = exports.ic_local_drink = exports.ic_local_dining = exports.ic_local_convenience_store = exports.ic_local_car_wash = exports.ic_local_cafe = exports.ic_local_bar = exports.ic_local_atm = exports.ic_local_airport = exports.ic_local_activity = exports.ic_layers_clear = exports.ic_layers = exports.ic_hotel = exports.ic_flight = exports.ic_ev_station = exports.ic_edit_location = exports.ic_directions_walk = exports.ic_directions_transit = exports.ic_directions_subway = exports.ic_directions_run = exports.ic_directions_railway = exports.ic_directions_car = exports.ic_directions_bus = exports.ic_directions_boat = exports.ic_directions_bike = exports.ic_directions = exports.ic_beenhere = exports.ic_add_location = exports.ic_wb_sunny = exports.ic_wb_iridescent = exports.ic_wb_incandescent = exports.ic_wb_cloudy = exports.ic_wb_auto = exports.ic_vignette = exports.ic_view_compact = exports.ic_view_comfy = exports.ic_tune = exports.ic_transform = exports.ic_tonality = exports.ic_timer_off = exports.ic_timer_3 = exports.ic_timer = exports.ic_timer_10 = exports.ic_timelapse = exports.ic_texture = exports.ic_tag_faces = exports.ic_switch_video = exports.ic_switch_camera = exports.ic_style = exports.ic_straighten = exports.ic_slideshow = exports.ic_rotate_right = exports.ic_rotate_left = exports.ic_rotate_90_degrees_ccw = exports.ic_remove_red_eye = exports.ic_portrait = exports.ic_picture_as_pdf = exports.ic_photo_size_select_small = exports.ic_photo_size_select_large = exports.ic_photo_size_select_actual = exports.ic_photo_library = exports.ic_photo_filter = exports.ic_photo_camera = exports.ic_photo_album = exports.ic_photo = exports.ic_panorama_wide_angle = exports.ic_panorama_vertical = exports.ic_panorama_horizontal = exports.ic_panorama_fish_eye = exports.ic_panorama = exports.ic_palette = exports.ic_navigate_next = exports.ic_navigate_before = exports.ic_nature_people = exports.ic_nature = exports.ic_music_note = exports.ic_movie_filter = exports.ic_movie_creation = exports.ic_monochrome_photos = exports.ic_loupe = exports.ic_looks_two = exports.ic_looks_one = void 0;
exports.ic_voice_chat = exports.ic_vibration = exports.ic_time_to_leave = exports.ic_tap_and_play = exports.ic_system_update = exports.ic_sync_problem = exports.ic_sync_disabled = exports.ic_sync = exports.ic_sms_failed = exports.ic_sms = exports.ic_sim_card_alert = exports.ic_sd_card = exports.ic_rv_hookup = exports.ic_priority_high = exports.ic_power = exports.ic_phone_paused = exports.ic_phone_missed = exports.ic_phone_locked = exports.ic_phone_in_talk = exports.ic_phone_forwarded = exports.ic_phone_bluetooth_speaker = exports.ic_personal_video = exports.ic_ondemand_video = exports.ic_no_encryption = exports.ic_network_locked = exports.ic_network_check = exports.ic_more = exports.ic_mms = exports.ic_live_tv = exports.ic_folder_special = exports.ic_event_note = exports.ic_event_busy = exports.ic_event_available = exports.ic_enhanced_encryption = exports.ic_drive_eta = exports.ic_do_not_disturb_on = exports.ic_do_not_disturb_off = exports.ic_do_not_disturb_alt = exports.ic_do_not_disturb = exports.ic_disc_full = exports.ic_confirmation_number = exports.ic_bluetooth_audio = exports.ic_airline_seat_recline_normal = exports.ic_airline_seat_recline_extra = exports.ic_airline_seat_legroom_reduced = exports.ic_airline_seat_legroom_normal = exports.ic_airline_seat_legroom_extra = exports.ic_airline_seat_individual_suite = exports.ic_airline_seat_flat_angled = exports.ic_airline_seat_flat = exports.ic_adb = exports.ic_unfold_more = exports.ic_unfold_less = exports.ic_subdirectory_arrow_right = exports.ic_subdirectory_arrow_left = exports.ic_refresh = exports.ic_more_vert = exports.ic_more_horiz = exports.ic_menu = exports.ic_last_page = exports.ic_fullscreen_exit = exports.ic_fullscreen = exports.ic_first_page = exports.ic_expand_more = exports.ic_expand_less = exports.ic_close = exports.ic_chevron_right = exports.ic_chevron_left = exports.ic_check = exports.ic_cancel = exports.ic_arrow_upward = exports.ic_arrow_forward = exports.ic_arrow_drop_up = exports.ic_arrow_drop_down_circle = exports.ic_arrow_drop_down = exports.ic_arrow_downward = exports.ic_arrow_back = exports.ic_apps = exports.ic_zoom_out_map = exports.ic_transfer_within_a_station = exports.ic_tram = exports.ic_train = exports.ic_traffic = exports.ic_terrain = exports.ic_subway = exports.ic_streetview = exports.ic_store_mall_directory = exports.ic_satellite = exports.ic_restaurant_menu = exports.ic_restaurant = exports.ic_rate_review = exports.ic_place = exports.ic_pin_drop = exports.ic_person_pin_circle = exports.ic_person_pin = exports.ic_near_me = exports.ic_navigation = exports.ic_my_location = exports.ic_map = exports.ic_local_taxi = void 0;
exports.ic_star_half = exports.ic_star_border = exports.ic_star = exports.ic_radio_button_unchecked = exports.ic_radio_button_checked = exports.ic_indeterminate_check_box = exports.ic_check_box_outline_blank = exports.ic_check_box = exports.ic_whatshot = exports.ic_share = exports.ic_sentiment_very_satisfied = exports.ic_sentiment_very_dissatisfied = exports.ic_sentiment_satisfied = exports.ic_sentiment_neutral = exports.ic_sentiment_dissatisfied = exports.ic_school = exports.ic_public = exports.ic_poll = exports.ic_plus_one = exports.ic_person_outline = exports.ic_person_add = exports.ic_person = exports.ic_people_outline = exports.ic_people = exports.ic_party_mode = exports.ic_pages = exports.ic_notifications_paused = exports.ic_notifications_off = exports.ic_notifications_none = exports.ic_notifications_active = exports.ic_notifications = exports.ic_mood_bad = exports.ic_mood = exports.ic_location_city = exports.ic_group_add = exports.ic_group = exports.ic_domain = exports.ic_cake = exports.ic_spa = exports.ic_smoking_rooms = exports.ic_smoke_free = exports.ic_room_service = exports.ic_pool = exports.ic_kitchen = exports.ic_hot_tub = exports.ic_golf_course = exports.ic_free_breakfast = exports.ic_fitness_center = exports.ic_child_friendly = exports.ic_child_care = exports.ic_casino = exports.ic_business_center = exports.ic_beach_access = exports.ic_all_inclusive = exports.ic_airport_shuttle = exports.ic_ac_unit = exports.ic_wifi = exports.ic_wc = exports.ic_vpn_lock = void 0;
var ic_3d_rotation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z"
    }
  }]
};
exports.ic_3d_rotation = ic_3d_rotation;
var ic_accessibility = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z"
    }
  }]
};
exports.ic_accessibility = ic_accessibility;
var ic_accessible = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "4",
      "r": "2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z"
    }
  }]
};
exports.ic_accessible = ic_accessible;
var ic_account_balance = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z"
    }
  }]
};
exports.ic_account_balance = ic_account_balance;
var ic_account_balance_wallet = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_account_balance_wallet = ic_account_balance_wallet;
var ic_account_box = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z"
    }
  }]
};
exports.ic_account_box = ic_account_box;
var ic_account_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z"
    }
  }]
};
exports.ic_account_circle = ic_account_circle;
var ic_add_shopping_cart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z"
    }
  }]
};
exports.ic_add_shopping_cart = ic_add_shopping_cart;
var ic_alarm = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_alarm = ic_alarm;
var ic_alarm_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
    }
  }]
};
exports.ic_alarm_add = ic_alarm_add;
var ic_alarm_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z"
    }
  }]
};
exports.ic_alarm_off = ic_alarm_off;
var ic_alarm_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z"
    }
  }]
};
exports.ic_alarm_on = ic_alarm_on;
var ic_all_out = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z",
      "fill": "#010101"
    }
  }]
};
exports.ic_all_out = ic_all_out;
var ic_android = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z"
    }
  }]
};
exports.ic_android = ic_android;
var ic_announcement = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z"
    }
  }]
};
exports.ic_announcement = ic_announcement;
var ic_aspect_ratio = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
    }
  }]
};
exports.ic_aspect_ratio = ic_aspect_ratio;
var ic_assessment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
    }
  }]
};
exports.ic_assessment = ic_assessment;
var ic_assignment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
    }
  }]
};
exports.ic_assignment = ic_assignment;
var ic_assignment_ind = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z"
    }
  }]
};
exports.ic_assignment_ind = ic_assignment_ind;
var ic_assignment_late = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    }
  }]
};
exports.ic_assignment_late = ic_assignment_late;
var ic_assignment_return = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z"
    }
  }]
};
exports.ic_assignment_return = ic_assignment_return;
var ic_assignment_returned = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z"
    }
  }]
};
exports.ic_assignment_returned = ic_assignment_returned;
var ic_assignment_turned_in = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    }
  }]
};
exports.ic_assignment_turned_in = ic_assignment_turned_in;
var ic_autorenew = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z"
    }
  }]
};
exports.ic_autorenew = ic_autorenew;
var ic_backup = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
    }
  }]
};
exports.ic_backup = ic_backup;
var ic_book = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
    }
  }]
};
exports.ic_book = ic_book;
var ic_bookmark = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_bookmark = ic_bookmark;
var ic_bookmark_border = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
    }
  }]
};
exports.ic_bookmark_border = ic_bookmark_border;
var ic_bug_report = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z"
    }
  }]
};
exports.ic_bug_report = ic_bug_report;
var ic_build = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z"
    }
  }]
};
exports.ic_build = ic_build;
var ic_cached = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z"
    }
  }]
};
exports.ic_cached = ic_cached;
var ic_camera_enhance = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z"
    }
  }]
};
exports.ic_camera_enhance = ic_camera_enhance;
var ic_card_giftcard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
    }
  }]
};
exports.ic_card_giftcard = ic_card_giftcard;
var ic_card_membership = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z"
    }
  }]
};
exports.ic_card_membership = ic_card_membership;
var ic_card_travel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z"
    }
  }]
};
exports.ic_card_travel = ic_card_travel;
var ic_change_history = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z"
    }
  }]
};
exports.ic_change_history = ic_change_history;
var ic_check_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  }]
};
exports.ic_check_circle = ic_check_circle;
var ic_chrome_reader_mode = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z"
    }
  }]
};
exports.ic_chrome_reader_mode = ic_chrome_reader_mode;
var ic_class = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z"
    }
  }]
};
exports.ic_class = ic_class;
var ic_code = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
    }
  }]
};
exports.ic_code = ic_code;
var ic_compare_arrows = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z"
    }
  }]
};
exports.ic_compare_arrows = ic_compare_arrows;
var ic_copyright = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_copyright = ic_copyright;
var ic_credit_card = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
    }
  }]
};
exports.ic_credit_card = ic_credit_card;
var ic_dashboard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"
    }
  }]
};
exports.ic_dashboard = ic_dashboard;
var ic_date_range = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"
    }
  }]
};
exports.ic_date_range = ic_date_range;
var ic_delete = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z"
    }
  }]
};
exports.ic_delete = ic_delete;
var ic_delete_forever = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z"
    }
  }]
};
exports.ic_delete_forever = ic_delete_forever;
var ic_description = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"
    }
  }]
};
exports.ic_description = ic_description;
var ic_dns = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_dns = ic_dns;
var ic_done = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z"
    }
  }]
};
exports.ic_done = ic_done;
var ic_done_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z"
    }
  }]
};
exports.ic_done_all = ic_done_all;
var ic_donut_large = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z"
    }
  }]
};
exports.ic_donut_large = ic_donut_large;
var ic_donut_small = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z"
    }
  }]
};
exports.ic_donut_small = ic_donut_small;
var ic_eject = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 17h14v2H5zm7-12L5.33 15h13.34z"
    }
  }]
};
exports.ic_eject = ic_eject;
var ic_euro_symbol = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z"
    }
  }]
};
exports.ic_euro_symbol = ic_euro_symbol;
var ic_event = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }
  }]
};
exports.ic_event = ic_event;
var ic_event_seat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z"
    }
  }]
};
exports.ic_event_seat = ic_event_seat;
var ic_exit_to_app = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_exit_to_app = ic_exit_to_app;
var ic_explore = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z"
    }
  }]
};
exports.ic_explore = ic_explore;
var ic_extension = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z"
    }
  }]
};
exports.ic_extension = ic_extension;
var ic_face = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z"
    }
  }]
};
exports.ic_face = ic_face;
var ic_favorite = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
    }
  }]
};
exports.ic_favorite = ic_favorite;
var ic_favorite_border = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z"
    }
  }]
};
exports.ic_favorite_border = ic_favorite_border;
var ic_feedback = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
    }
  }]
};
exports.ic_feedback = ic_feedback;
var ic_find_in_page = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z"
    }
  }]
};
exports.ic_find_in_page = ic_find_in_page;
var ic_find_replace = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z"
    }
  }]
};
exports.ic_find_replace = ic_find_replace;
var ic_fingerprint = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z"
    }
  }]
};
exports.ic_fingerprint = ic_fingerprint;
var ic_flight_land = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z"
    }
  }]
};
exports.ic_flight_land = ic_flight_land;
var ic_flight_takeoff = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z"
    }
  }]
};
exports.ic_flight_takeoff = ic_flight_takeoff;
var ic_flip_to_back = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z"
    }
  }]
};
exports.ic_flip_to_back = ic_flip_to_back;
var ic_flip_to_front = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z"
    }
  }]
};
exports.ic_flip_to_front = ic_flip_to_front;
var ic_g_translate = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z"
    }
  }]
};
exports.ic_g_translate = ic_g_translate;
var ic_gavel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z"
    }
  }]
};
exports.ic_gavel = ic_gavel;
var ic_get_app = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
    }
  }]
};
exports.ic_get_app = ic_get_app;
var ic_gif = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z"
    }
  }]
};
exports.ic_gif = ic_gif;
var ic_grade = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    }
  }]
};
exports.ic_grade = ic_grade;
var ic_group_work = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    }
  }]
};
exports.ic_group_work = ic_group_work;
var ic_help = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    }
  }]
};
exports.ic_help = ic_help;
var ic_help_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
    }
  }]
};
exports.ic_help_outline = ic_help_outline;
var ic_highlight_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_highlight_off = ic_highlight_off;
var ic_history = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    }
  }]
};
exports.ic_history = ic_history;
var ic_home = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
    }
  }]
};
exports.ic_home = ic_home;
var ic_hourglass_empty = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z"
    }
  }]
};
exports.ic_hourglass_empty = ic_hourglass_empty;
var ic_hourglass_full = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z"
    }
  }]
};
exports.ic_hourglass_full = ic_hourglass_full;
var ic_http = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z"
    }
  }]
};
exports.ic_http = ic_http;
var ic_https = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  }]
};
exports.ic_https = ic_https;
var ic_important_devices = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z"
    }
  }]
};
exports.ic_important_devices = ic_important_devices;
var ic_info = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
    }
  }]
};
exports.ic_info = ic_info;
var ic_info_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z"
    }
  }]
};
exports.ic_info_outline = ic_info_outline;
var ic_input = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z"
    }
  }]
};
exports.ic_input = ic_input;
var ic_invert_colors = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z"
    }
  }]
};
exports.ic_invert_colors = ic_invert_colors;
var ic_label = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z"
    }
  }]
};
exports.ic_label = ic_label;
var ic_label_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z"
    }
  }]
};
exports.ic_label_outline = ic_label_outline;
var ic_language = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z"
    }
  }]
};
exports.ic_language = ic_language;
var ic_launch = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  }]
};
exports.ic_launch = ic_launch;
var ic_lightbulb_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z"
    }
  }]
};
exports.ic_lightbulb_outline = ic_lightbulb_outline;
var ic_line_style = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z"
    }
  }]
};
exports.ic_line_style = ic_line_style;
var ic_line_weight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z"
    }
  }]
};
exports.ic_line_weight = ic_line_weight;
var ic_list = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z"
    }
  }]
};
exports.ic_list = ic_list;
var ic_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
    }
  }]
};
exports.ic_lock = ic_lock;
var ic_lock_open = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z"
    }
  }]
};
exports.ic_lock_open = ic_lock_open;
var ic_lock_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z"
    }
  }]
};
exports.ic_lock_outline = ic_lock_outline;
var ic_loyalty = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z"
    }
  }]
};
exports.ic_loyalty = ic_loyalty;
var ic_markunread_mailbox = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_markunread_mailbox = ic_markunread_mailbox;
var ic_motorcycle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z"
    }
  }]
};
exports.ic_motorcycle = ic_motorcycle;
var ic_note_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z"
    }
  }]
};
exports.ic_note_add = ic_note_add;
var ic_offline_pin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z"
    }
  }]
};
exports.ic_offline_pin = ic_offline_pin;
var ic_opacity = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z"
    }
  }]
};
exports.ic_opacity = ic_opacity;
var ic_open_in_browser = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z"
    }
  }]
};
exports.ic_open_in_browser = ic_open_in_browser;
var ic_open_in_new = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z"
    }
  }]
};
exports.ic_open_in_new = ic_open_in_new;
var ic_open_with = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z"
    }
  }]
};
exports.ic_open_with = ic_open_with;
var ic_pageview = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z"
    }
  }]
};
exports.ic_pageview = ic_pageview;
var ic_pan_tool = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z"
    }
  }]
};
exports.ic_pan_tool = ic_pan_tool;
var ic_payment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z"
    }
  }]
};
exports.ic_payment = ic_payment;
var ic_perm_camera_mic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z"
    }
  }]
};
exports.ic_perm_camera_mic = ic_perm_camera_mic;
var ic_perm_contact_calendar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z"
    }
  }]
};
exports.ic_perm_contact_calendar = ic_perm_contact_calendar;
var ic_perm_data_setting = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_perm_data_setting = ic_perm_data_setting;
var ic_perm_device_information = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
    }
  }]
};
exports.ic_perm_device_information = ic_perm_device_information;
var ic_perm_identity = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
    }
  }]
};
exports.ic_perm_identity = ic_perm_identity;
var ic_perm_media = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z"
    }
  }]
};
exports.ic_perm_media = ic_perm_media;
var ic_perm_phone_msg = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z"
    }
  }]
};
exports.ic_perm_phone_msg = ic_perm_phone_msg;
var ic_perm_scan_wifi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z"
    }
  }]
};
exports.ic_perm_scan_wifi = ic_perm_scan_wifi;
var ic_pets = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "4.5",
      "cy": "9.5",
      "r": "2.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "9",
      "cy": "5.5",
      "r": "2.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "15",
      "cy": "5.5",
      "r": "2.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "19.5",
      "cy": "9.5",
      "r": "2.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z"
    }
  }]
};
exports.ic_pets = ic_pets;
var ic_picture_in_picture = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z"
    }
  }]
};
exports.ic_picture_in_picture = ic_picture_in_picture;
var ic_picture_in_picture_alt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z"
    }
  }]
};
exports.ic_picture_in_picture_alt = ic_picture_in_picture_alt;
var ic_play_for_work = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z"
    }
  }]
};
exports.ic_play_for_work = ic_play_for_work;
var ic_polymer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z"
    }
  }]
};
exports.ic_polymer = ic_polymer;
var ic_power_settings_new = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z"
    }
  }]
};
exports.ic_power_settings_new = ic_power_settings_new;
var ic_pregnant_woman = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z"
    }
  }]
};
exports.ic_pregnant_woman = ic_pregnant_woman;
var ic_print = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
    }
  }]
};
exports.ic_print = ic_print;
var ic_query_builder = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  }]
};
exports.ic_query_builder = ic_query_builder;
var ic_question_answer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    }
  }]
};
exports.ic_question_answer = ic_question_answer;
var ic_receipt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z"
    }
  }]
};
exports.ic_receipt = ic_receipt;
var ic_record_voice_over = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "9",
      "cy": "9",
      "r": "4"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z"
    }
  }]
};
exports.ic_record_voice_over = ic_record_voice_over;
var ic_redeem = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
    }
  }]
};
exports.ic_redeem = ic_redeem;
var ic_remove_shopping_cart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_remove_shopping_cart = ic_remove_shopping_cart;
var ic_reorder = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z"
    }
  }]
};
exports.ic_reorder = ic_reorder;
var ic_report_problem = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }
  }]
};
exports.ic_report_problem = ic_report_problem;
var ic_restore = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z"
    }
  }]
};
exports.ic_restore = ic_restore;
var ic_restore_page = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z"
    }
  }]
};
exports.ic_restore_page = ic_restore_page;
var ic_room = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    }
  }]
};
exports.ic_room = ic_room;
var ic_rounded_corner = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z"
    }
  }]
};
exports.ic_rounded_corner = ic_rounded_corner;
var ic_rowing = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z"
    }
  }]
};
exports.ic_rowing = ic_rowing;
var ic_schedule = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  }]
};
exports.ic_schedule = ic_schedule;
var ic_search = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
    }
  }]
};
exports.ic_search = ic_search;
var ic_settings = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z"
    }
  }]
};
exports.ic_settings = ic_settings;
var ic_settings_applications = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z"
    }
  }]
};
exports.ic_settings_applications = ic_settings_applications;
var ic_settings_backup_restore = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z"
    }
  }]
};
exports.ic_settings_backup_restore = ic_settings_backup_restore;
var ic_settings_bluetooth = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z"
    }
  }]
};
exports.ic_settings_bluetooth = ic_settings_bluetooth;
var ic_settings_brightness = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z"
    }
  }]
};
exports.ic_settings_brightness = ic_settings_brightness;
var ic_settings_cell = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z"
    }
  }]
};
exports.ic_settings_cell = ic_settings_cell;
var ic_settings_ethernet = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z"
    }
  }]
};
exports.ic_settings_ethernet = ic_settings_ethernet;
var ic_settings_input_antenna = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z"
    }
  }]
};
exports.ic_settings_input_antenna = ic_settings_input_antenna;
var ic_settings_input_component = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
    }
  }]
};
exports.ic_settings_input_component = ic_settings_input_component;
var ic_settings_input_composite = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z"
    }
  }]
};
exports.ic_settings_input_composite = ic_settings_input_composite;
var ic_settings_input_hdmi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z"
    }
  }]
};
exports.ic_settings_input_hdmi = ic_settings_input_hdmi;
var ic_settings_input_svideo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
    }
  }]
};
exports.ic_settings_input_svideo = ic_settings_input_svideo;
var ic_settings_overscan = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
    }
  }]
};
exports.ic_settings_overscan = ic_settings_overscan;
var ic_settings_phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z"
    }
  }]
};
exports.ic_settings_phone = ic_settings_phone;
var ic_settings_power = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z"
    }
  }]
};
exports.ic_settings_power = ic_settings_power;
var ic_settings_remote = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z"
    }
  }]
};
exports.ic_settings_remote = ic_settings_remote;
var ic_settings_voice = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z"
    }
  }]
};
exports.ic_settings_voice = ic_settings_voice;
var ic_shop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z"
    }
  }]
};
exports.ic_shop = ic_shop;
var ic_shop_two = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z"
    }
  }]
};
exports.ic_shop_two = ic_shop_two;
var ic_shopping_basket = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_shopping_basket = ic_shopping_basket;
var ic_shopping_cart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_shopping_cart = ic_shopping_cart;
var ic_speaker_notes = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z"
    }
  }]
};
exports.ic_speaker_notes = ic_speaker_notes;
var ic_speaker_notes_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_speaker_notes_off = ic_speaker_notes_off;
var ic_spellcheck = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z"
    }
  }]
};
exports.ic_spellcheck = ic_spellcheck;
var ic_stars = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z"
    }
  }]
};
exports.ic_stars = ic_stars;
var ic_store = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
    }
  }]
};
exports.ic_store = ic_store;
var ic_subject = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z"
    }
  }]
};
exports.ic_subject = ic_subject;
var ic_supervisor_account = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z"
    }
  }]
};
exports.ic_supervisor_account = ic_supervisor_account;
var ic_swap_horiz = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z"
    }
  }]
};
exports.ic_swap_horiz = ic_swap_horiz;
var ic_swap_vert = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
    }
  }]
};
exports.ic_swap_vert = ic_swap_vert;
var ic_swap_vertical_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z"
    }
  }]
};
exports.ic_swap_vertical_circle = ic_swap_vertical_circle;
var ic_system_update_alt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_system_update_alt = ic_system_update_alt;
var ic_tab = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z"
    }
  }]
};
exports.ic_tab = ic_tab;
var ic_tab_unselected = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z"
    }
  }]
};
exports.ic_tab_unselected = ic_tab_unselected;
var ic_theaters = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
    }
  }]
};
exports.ic_theaters = ic_theaters;
var ic_thumb_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z"
    }
  }]
};
exports.ic_thumb_down = ic_thumb_down;
var ic_thumb_up = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z"
    }
  }]
};
exports.ic_thumb_up = ic_thumb_up;
var ic_thumbs_up_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z"
    }
  }]
};
exports.ic_thumbs_up_down = ic_thumbs_up_down;
var ic_timeline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z"
    }
  }]
};
exports.ic_timeline = ic_timeline;
var ic_toc = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z"
    }
  }]
};
exports.ic_toc = ic_toc;
var ic_today = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z"
    }
  }]
};
exports.ic_today = ic_today;
var ic_toll = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z"
    }
  }]
};
exports.ic_toll = ic_toll;
var ic_touch_app = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z"
    }
  }]
};
exports.ic_touch_app = ic_touch_app;
var ic_track_changes = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z"
    }
  }]
};
exports.ic_track_changes = ic_track_changes;
var ic_translate = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z"
    }
  }]
};
exports.ic_translate = ic_translate;
var ic_trending_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z"
    }
  }]
};
exports.ic_trending_down = ic_trending_down;
var ic_trending_flat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 12l-4-4v3H3v2h15v3z"
    }
  }]
};
exports.ic_trending_flat = ic_trending_flat;
var ic_trending_up = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z"
    }
  }]
};
exports.ic_trending_up = ic_trending_up;
var ic_turned_in = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_turned_in = ic_turned_in;
var ic_turned_in_not = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z"
    }
  }]
};
exports.ic_turned_in_not = ic_turned_in_not;
var ic_update = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z"
    }
  }]
};
exports.ic_update = ic_update;
var ic_verified_user = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
    }
  }]
};
exports.ic_verified_user = ic_verified_user;
var ic_view_agenda = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_view_agenda = ic_view_agenda;
var ic_view_array = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z"
    }
  }]
};
exports.ic_view_array = ic_view_array;
var ic_view_carousel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z"
    }
  }]
};
exports.ic_view_carousel = ic_view_carousel;
var ic_view_column = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z"
    }
  }]
};
exports.ic_view_column = ic_view_column;
var ic_view_day = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z"
    }
  }]
};
exports.ic_view_day = ic_view_day;
var ic_view_headline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z"
    }
  }]
};
exports.ic_view_headline = ic_view_headline;
var ic_view_list = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z"
    }
  }]
};
exports.ic_view_list = ic_view_list;
var ic_view_module = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z"
    }
  }]
};
exports.ic_view_module = ic_view_module;
var ic_view_quilt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z"
    }
  }]
};
exports.ic_view_quilt = ic_view_quilt;
var ic_view_stream = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 18h17v-6H4v6zM4 5v6h17V5H4z"
    }
  }]
};
exports.ic_view_stream = ic_view_stream;
var ic_view_week = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_view_week = ic_view_week;
var ic_visibility = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }
  }]
};
exports.ic_visibility = ic_visibility;
var ic_visibility_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z"
    }
  }]
};
exports.ic_visibility_off = ic_visibility_off;
var ic_watch_later = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z"
    }
  }]
};
exports.ic_watch_later = ic_watch_later;
var ic_work = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z"
    }
  }]
};
exports.ic_work = ic_work;
var ic_youtube_searched_for = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z"
    }
  }]
};
exports.ic_youtube_searched_for = ic_youtube_searched_for;
var ic_zoom_in = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z"
    }
  }]
};
exports.ic_zoom_in = ic_zoom_in;
var ic_zoom_out = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z"
    }
  }]
};
exports.ic_zoom_out = ic_zoom_out;
var ic_add_alert = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z"
    }
  }]
};
exports.ic_add_alert = ic_add_alert;
var ic_error = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"
    }
  }]
};
exports.ic_error = ic_error;
var ic_error_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }]
};
exports.ic_error_outline = ic_error_outline;
var ic_warning = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
    }
  }]
};
exports.ic_warning = ic_warning;
var ic_add_to_queue = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z"
    }
  }]
};
exports.ic_add_to_queue = ic_add_to_queue;
var ic_airplay = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_airplay = ic_airplay;
var ic_album = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
    }
  }]
};
exports.ic_album = ic_album;
var ic_art_track = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#010101",
      "d": "M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z"
    }
  }]
};
exports.ic_art_track = ic_art_track;
var ic_av_timer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z"
    }
  }]
};
exports.ic_av_timer = ic_av_timer;
var ic_branding_watermark = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z"
    }
  }]
};
exports.ic_branding_watermark = ic_branding_watermark;
var ic_call_to_action = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z"
    }
  }]
};
exports.ic_call_to_action = ic_call_to_action;
var ic_closed_caption = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z"
    }
  }]
};
exports.ic_closed_caption = ic_closed_caption;
var ic_equalizer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z"
    }
  }]
};
exports.ic_equalizer = ic_equalizer;
var ic_explicit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z"
    }
  }]
};
exports.ic_explicit = ic_explicit;
var ic_fast_forward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"
    }
  }]
};
exports.ic_fast_forward = ic_fast_forward;
var ic_fast_rewind = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"
    }
  }]
};
exports.ic_fast_rewind = ic_fast_rewind;
var ic_featured_play_list = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z"
    }
  }]
};
exports.ic_featured_play_list = ic_featured_play_list;
var ic_featured_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z"
    }
  }]
};
exports.ic_featured_video = ic_featured_video;
var ic_fiber_dvr = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z"
    }
  }]
};
exports.ic_fiber_dvr = ic_fiber_dvr;
var ic_fiber_manual_record = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "fill": "#010101",
      "cx": "12",
      "cy": "12",
      "r": "8"
    }
  }]
};
exports.ic_fiber_manual_record = ic_fiber_manual_record;
var ic_fiber_new = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z"
    }
  }]
};
exports.ic_fiber_new = ic_fiber_new;
var ic_fiber_pin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z"
    }
  }]
};
exports.ic_fiber_pin = ic_fiber_pin;
var ic_fiber_smart_record = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {
      "fill": "#010101"
    }
  }]
};
exports.ic_fiber_smart_record = ic_fiber_smart_record;
var ic_forward_10 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  }]
};
exports.ic_forward_10 = ic_forward_10;
var ic_forward_30 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z"
    }
  }]
};
exports.ic_forward_30 = ic_forward_30;
var ic_forward_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z"
    }
  }]
};
exports.ic_forward_5 = ic_forward_5;
var ic_games = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
    }
  }]
};
exports.ic_games = ic_games;
var ic_hd = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z"
    }
  }]
};
exports.ic_hd = ic_hd;
var ic_hearing = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z"
    }
  }]
};
exports.ic_hearing = ic_hearing;
var ic_high_quality = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z"
    }
  }]
};
exports.ic_high_quality = ic_high_quality;
var ic_library_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
    }
  }]
};
exports.ic_library_add = ic_library_add;
var ic_library_books = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z"
    }
  }]
};
exports.ic_library_books = ic_library_books;
var ic_library_music = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z"
    }
  }]
};
exports.ic_library_music = ic_library_music;
var ic_loop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    }
  }]
};
exports.ic_loop = ic_loop;
var ic_mic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
    }
  }]
};
exports.ic_mic = ic_mic;
var ic_mic_none = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
    }
  }]
};
exports.ic_mic_none = ic_mic_none;
var ic_mic_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z"
    }
  }]
};
exports.ic_mic_off = ic_mic_off;
var ic_movie = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
    }
  }]
};
exports.ic_movie = ic_movie;
var ic_music_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z"
    }
  }]
};
exports.ic_music_video = ic_music_video;
var ic_new_releases = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z"
    }
  }]
};
exports.ic_new_releases = ic_new_releases;
var ic_not_interested = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
    }
  }]
};
exports.ic_not_interested = ic_not_interested;
var ic_note = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z"
    }
  }]
};
exports.ic_note = ic_note;
var ic_pause = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 19h4V5H6v14zm8-14v14h4V5h-4z"
    }
  }]
};
exports.ic_pause = ic_pause;
var ic_pause_circle_filled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z"
    }
  }]
};
exports.ic_pause_circle_filled = ic_pause_circle_filled;
var ic_pause_circle_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z"
    }
  }]
};
exports.ic_pause_circle_outline = ic_pause_circle_outline;
var ic_play_arrow = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 5v14l11-7z"
    }
  }]
};
exports.ic_play_arrow = ic_play_arrow;
var ic_play_circle_filled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z"
    }
  }]
};
exports.ic_play_circle_filled = ic_play_circle_filled;
var ic_play_circle_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_play_circle_outline = ic_play_circle_outline;
var ic_playlist_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
    }
  }]
};
exports.ic_playlist_add = ic_playlist_add;
var ic_playlist_add_check = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z"
    }
  }]
};
exports.ic_playlist_add_check = ic_playlist_add_check;
var ic_playlist_play = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z"
    }
  }]
};
exports.ic_playlist_play = ic_playlist_play;
var ic_queue = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
    }
  }]
};
exports.ic_queue = ic_queue;
var ic_queue_music = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z"
    }
  }]
};
exports.ic_queue_music = ic_queue_music;
var ic_queue_play_next = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z"
    }
  }]
};
exports.ic_queue_play_next = ic_queue_play_next;
var ic_radio = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z"
    }
  }]
};
exports.ic_radio = ic_radio;
var ic_recent_actors = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z"
    }
  }]
};
exports.ic_recent_actors = ic_recent_actors;
var ic_remove_from_queue = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z"
    }
  }]
};
exports.ic_remove_from_queue = ic_remove_from_queue;
var ic_repeat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z"
    }
  }]
};
exports.ic_repeat = ic_repeat;
var ic_repeat_one = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z"
    }
  }]
};
exports.ic_repeat_one = ic_repeat_one;
var ic_replay_10 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  }]
};
exports.ic_replay_10 = ic_replay_10;
var ic_replay = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z"
    }
  }]
};
exports.ic_replay = ic_replay;
var ic_replay_30 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z"
    }
  }]
};
exports.ic_replay_30 = ic_replay_30;
var ic_replay_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z"
    }
  }]
};
exports.ic_replay_5 = ic_replay_5;
var ic_shuffle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z"
    }
  }]
};
exports.ic_shuffle = ic_shuffle;
var ic_skip_next = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z"
    }
  }]
};
exports.ic_skip_next = ic_skip_next;
var ic_skip_previous = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 6h2v12H6zm3.5 6l8.5 6V6z"
    }
  }]
};
exports.ic_skip_previous = ic_skip_previous;
var ic_slow_motion_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z"
    }
  }]
};
exports.ic_slow_motion_video = ic_slow_motion_video;
var ic_snooze = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z"
    }
  }]
};
exports.ic_snooze = ic_snooze;
var ic_sort_by_alpha = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z"
    }
  }]
};
exports.ic_sort_by_alpha = ic_sort_by_alpha;
var ic_stop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 6h12v12H6z"
    }
  }]
};
exports.ic_stop = ic_stop;
var ic_subscriptions = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z"
    }
  }]
};
exports.ic_subscriptions = ic_subscriptions;
var ic_subtitles = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z"
    }
  }]
};
exports.ic_subtitles = ic_subtitles;
var ic_surround_sound = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_surround_sound = ic_surround_sound;
var ic_video_call = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z"
    }
  }]
};
exports.ic_video_call = ic_video_call;
var ic_video_label = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z"
    }
  }]
};
exports.ic_video_label = ic_video_label;
var ic_video_library = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z"
    }
  }]
};
exports.ic_video_library = ic_video_library;
var ic_videocam = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z"
    }
  }]
};
exports.ic_videocam = ic_videocam;
var ic_videocam_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z"
    }
  }]
};
exports.ic_videocam_off = ic_videocam_off;
var ic_volume_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z"
    }
  }]
};
exports.ic_volume_down = ic_volume_down;
var ic_volume_mute = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 9v6h4l5 5V4l-5 5H7z"
    }
  }]
};
exports.ic_volume_mute = ic_volume_mute;
var ic_volume_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z"
    }
  }]
};
exports.ic_volume_off = ic_volume_off;
var ic_volume_up = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z"
    }
  }]
};
exports.ic_volume_up = ic_volume_up;
var ic_web = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z"
    }
  }]
};
exports.ic_web = ic_web;
var ic_web_asset = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#010101",
      "d": "M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z"
    }
  }]
};
exports.ic_web_asset = ic_web_asset;
var ic_business = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
    }
  }]
};
exports.ic_business = ic_business;
var ic_call = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    }
  }]
};
exports.ic_call = ic_call;
var ic_call_end = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z"
    }
  }]
};
exports.ic_call_end = ic_call_end;
var ic_call_made = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z"
    }
  }]
};
exports.ic_call_made = ic_call_made;
var ic_call_merge = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
    }
  }]
};
exports.ic_call_merge = ic_call_merge;
var ic_call_missed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z"
    }
  }]
};
exports.ic_call_missed = ic_call_missed;
var ic_call_missed_outgoing = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z"
    }
  }]
};
exports.ic_call_missed_outgoing = ic_call_missed_outgoing;
var ic_call_received = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z"
    }
  }]
};
exports.ic_call_received = ic_call_received;
var ic_call_split = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z"
    }
  }]
};
exports.ic_call_split = ic_call_split;
var ic_chat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
    }
  }]
};
exports.ic_chat = ic_chat;
var ic_chat_bubble = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_chat_bubble = ic_chat_bubble;
var ic_chat_bubble_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z"
    }
  }]
};
exports.ic_chat_bubble_outline = ic_chat_bubble_outline;
var ic_clear_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z"
    }
  }]
};
exports.ic_clear_all = ic_clear_all;
var ic_comment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    }
  }]
};
exports.ic_comment = ic_comment;
var ic_contact_mail = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z"
    }
  }]
};
exports.ic_contact_mail = ic_contact_mail;
var ic_contact_phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z"
    }
  }]
};
exports.ic_contact_phone = ic_contact_phone;
var ic_contacts = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z"
    }
  }]
};
exports.ic_contacts = ic_contacts;
var ic_dialer_sip = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_dialer_sip = ic_dialer_sip;
var ic_dialpad = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_dialpad = ic_dialpad;
var ic_email = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }]
};
exports.ic_email = ic_email;
var ic_forum = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z"
    }
  }]
};
exports.ic_forum = ic_forum;
var ic_import_contacts = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z"
    }
  }]
};
exports.ic_import_contacts = ic_import_contacts;
var ic_import_export = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z"
    }
  }]
};
exports.ic_import_export = ic_import_export;
var ic_invert_colors_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z"
    }
  }]
};
exports.ic_invert_colors_off = ic_invert_colors_off;
var ic_live_help = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
    }
  }]
};
exports.ic_live_help = ic_live_help;
var ic_location_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z"
    }
  }]
};
exports.ic_location_off = ic_location_off;
var ic_location_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    }
  }]
};
exports.ic_location_on = ic_location_on;
var ic_mail_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z"
    }
  }]
};
exports.ic_mail_outline = ic_mail_outline;
var ic_message = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    }
  }]
};
exports.ic_message = ic_message;
var ic_no_sim = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
    }
  }]
};
exports.ic_no_sim = ic_no_sim;
var ic_phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    }
  }]
};
exports.ic_phone = ic_phone;
var ic_phonelink_erase = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_phonelink_erase = ic_phonelink_erase;
var ic_phonelink_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z"
    }
  }]
};
exports.ic_phonelink_lock = ic_phonelink_lock;
var ic_phonelink_ring = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z"
    }
  }]
};
exports.ic_phonelink_ring = ic_phonelink_ring;
var ic_phonelink_setup = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_phonelink_setup = ic_phonelink_setup;
var ic_portable_wifi_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z"
    }
  }]
};
exports.ic_portable_wifi_off = ic_portable_wifi_off;
var ic_present_to_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z"
    }
  }]
};
exports.ic_present_to_all = ic_present_to_all;
var ic_ring_volume = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z"
    }
  }]
};
exports.ic_ring_volume = ic_ring_volume;
var ic_rss_feed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "6.18",
      "cy": "17.82",
      "r": "2.18"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z"
    }
  }]
};
exports.ic_rss_feed = ic_rss_feed;
var ic_screen_share = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z"
    }
  }]
};
exports.ic_screen_share = ic_screen_share;
var ic_speaker_phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z"
    }
  }]
};
exports.ic_speaker_phone = ic_speaker_phone;
var ic_stay_current_landscape = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
    }
  }]
};
exports.ic_stay_current_landscape = ic_stay_current_landscape;
var ic_stay_current_portrait = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
    }
  }]
};
exports.ic_stay_current_portrait = ic_stay_current_portrait;
var ic_stay_primary_landscape = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z"
    }
  }]
};
exports.ic_stay_primary_landscape = ic_stay_primary_landscape;
var ic_stay_primary_portrait = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
    }
  }]
};
exports.ic_stay_primary_portrait = ic_stay_primary_portrait;
var ic_stop_screen_share = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z"
    }
  }]
};
exports.ic_stop_screen_share = ic_stop_screen_share;
var ic_swap_calls = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z"
    }
  }]
};
exports.ic_swap_calls = ic_swap_calls;
var ic_textsms = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
    }
  }]
};
exports.ic_textsms = ic_textsms;
var ic_voicemail = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z"
    }
  }]
};
exports.ic_voicemail = ic_voicemail;
var ic_vpn_key = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_vpn_key = ic_vpn_key;
var ic_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
    }
  }]
};
exports.ic_add = ic_add;
var ic_add_box = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    }
  }]
};
exports.ic_add_box = ic_add_box;
var ic_add_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z"
    }
  }]
};
exports.ic_add_circle = ic_add_circle;
var ic_add_circle_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_add_circle_outline = ic_add_circle_outline;
var ic_archive = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z"
    }
  }]
};
exports.ic_archive = ic_archive;
var ic_backspace = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
    }
  }]
};
exports.ic_backspace = ic_backspace;
var ic_block = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z"
    }
  }]
};
exports.ic_block = ic_block;
var ic_clear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  }]
};
exports.ic_clear = ic_clear;
var ic_content_copy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"
    }
  }]
};
exports.ic_content_copy = ic_content_copy;
var ic_content_cut = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z"
    }
  }]
};
exports.ic_content_cut = ic_content_cut;
var ic_content_paste = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z"
    }
  }]
};
exports.ic_content_paste = ic_content_paste;
var ic_create = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }
  }]
};
exports.ic_create = ic_create;
var ic_delete_sweep = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z"
    }
  }]
};
exports.ic_delete_sweep = ic_delete_sweep;
var ic_drafts = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z"
    }
  }]
};
exports.ic_drafts = ic_drafts;
var ic_filter_list = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z"
    }
  }]
};
exports.ic_filter_list = ic_filter_list;
var ic_flag = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
    }
  }]
};
exports.ic_flag = ic_flag;
var ic_font_download = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z"
    }
  }]
};
exports.ic_font_download = ic_font_download;
var ic_forward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8V4l8 8-8 8v-4H4V8z"
    }
  }]
};
exports.ic_forward = ic_forward;
var ic_gesture = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z"
    }
  }]
};
exports.ic_gesture = ic_gesture;
var ic_inbox = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z"
    }
  }]
};
exports.ic_inbox = ic_inbox;
var ic_link = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    }
  }]
};
exports.ic_link = ic_link;
var ic_low_priority = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z"
    }
  }]
};
exports.ic_low_priority = ic_low_priority;
var ic_mail = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }]
};
exports.ic_mail = ic_mail;
var ic_markunread = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }]
};
exports.ic_markunread = ic_markunread;
var ic_move_to_inbox = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z"
    }
  }]
};
exports.ic_move_to_inbox = ic_move_to_inbox;
var ic_next_week = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#010101",
      "d": "M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z"
    }
  }]
};
exports.ic_next_week = ic_next_week;
var ic_redo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z"
    }
  }]
};
exports.ic_redo = ic_redo;
var ic_remove = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 13H5v-2h14v2z"
    }
  }]
};
exports.ic_remove = ic_remove;
var ic_remove_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
    }
  }]
};
exports.ic_remove_circle = ic_remove_circle;
var ic_remove_circle_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_remove_circle_outline = ic_remove_circle_outline;
var ic_reply = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
    }
  }]
};
exports.ic_reply = ic_reply;
var ic_reply_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z"
    }
  }]
};
exports.ic_reply_all = ic_reply_all;
var ic_report = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z"
    }
  }]
};
exports.ic_report = ic_report;
var ic_save = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z"
    }
  }]
};
exports.ic_save = ic_save;
var ic_select_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
    }
  }]
};
exports.ic_select_all = ic_select_all;
var ic_send = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.01 21L23 12 2.01 3 2 10l15 2-15 2z"
    }
  }]
};
exports.ic_send = ic_send;
var ic_sort = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z"
    }
  }]
};
exports.ic_sort = ic_sort;
var ic_text_format = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z"
    }
  }]
};
exports.ic_text_format = ic_text_format;
var ic_unarchive = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z"
    }
  }]
};
exports.ic_unarchive = ic_unarchive;
var ic_undo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z"
    }
  }]
};
exports.ic_undo = ic_undo;
var ic_weekend = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z",
      "fill": "#010101"
    }
  }]
};
exports.ic_weekend = ic_weekend;
var ic_access_alarm = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_access_alarm = ic_access_alarm;
var ic_access_alarms = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z"
    }
  }]
};
exports.ic_access_alarms = ic_access_alarms;
var ic_access_time = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z"
    }
  }]
};
exports.ic_access_time = ic_access_time;
var ic_add_alarm = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z"
    }
  }]
};
exports.ic_add_alarm = ic_add_alarm;
var ic_airplanemode_active = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.18 9"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
    }
  }]
};
exports.ic_airplanemode_active = ic_airplanemode_active;
var ic_airplanemode_inactive = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z"
    }
  }]
};
exports.ic_airplanemode_inactive = ic_airplanemode_inactive;
var ic_battery_20 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z"
    }
  }]
};
exports.ic_battery_20 = ic_battery_20;
var ic_battery_30 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z"
    }
  }]
};
exports.ic_battery_30 = ic_battery_30;
var ic_battery_50 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z"
    }
  }]
};
exports.ic_battery_50 = ic_battery_50;
var ic_battery_60 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z"
    }
  }]
};
exports.ic_battery_60 = ic_battery_60;
var ic_battery_80 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z"
    }
  }]
};
exports.ic_battery_80 = ic_battery_80;
var ic_battery_90 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z"
    }
  }]
};
exports.ic_battery_90 = ic_battery_90;
var ic_battery_alert = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z"
    }
  }]
};
exports.ic_battery_alert = ic_battery_alert;
var ic_battery_charging_20 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }]
};
exports.ic_battery_charging_20 = ic_battery_charging_20;
var ic_battery_charging_30 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z"
    }
  }]
};
exports.ic_battery_charging_30 = ic_battery_charging_30;
var ic_battery_charging_50 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }]
};
exports.ic_battery_charging_50 = ic_battery_charging_50;
var ic_battery_charging_60 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z"
    }
  }]
};
exports.ic_battery_charging_60 = ic_battery_charging_60;
var ic_battery_charging_80 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z"
    }
  }]
};
exports.ic_battery_charging_80 = ic_battery_charging_80;
var ic_battery_charging_90 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z"
    }
  }]
};
exports.ic_battery_charging_90 = ic_battery_charging_90;
var ic_battery_charging_full = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z"
    }
  }]
};
exports.ic_battery_charging_full = ic_battery_charging_full;
var ic_battery_full = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }]
};
exports.ic_battery_full = ic_battery_full;
var ic_battery_std = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z"
    }
  }]
};
exports.ic_battery_std = ic_battery_std;
var ic_battery_unknown = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z"
    }
  }]
};
exports.ic_battery_unknown = ic_battery_unknown;
var ic_bluetooth = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z"
    }
  }]
};
exports.ic_bluetooth = ic_bluetooth;
var ic_bluetooth_connected = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z"
    }
  }]
};
exports.ic_bluetooth_connected = ic_bluetooth_connected;
var ic_bluetooth_disabled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z"
    }
  }]
};
exports.ic_bluetooth_disabled = ic_bluetooth_disabled;
var ic_bluetooth_searching = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
    }
  }]
};
exports.ic_bluetooth_searching = ic_bluetooth_searching;
var ic_brightness_auto = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z"
    }
  }]
};
exports.ic_brightness_auto = ic_brightness_auto;
var ic_brightness_high = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
    }
  }]
};
exports.ic_brightness_high = ic_brightness_high;
var ic_brightness_low = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
    }
  }]
};
exports.ic_brightness_low = ic_brightness_low;
var ic_brightness_medium = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
    }
  }]
};
exports.ic_brightness_medium = ic_brightness_medium;
var ic_data_usage = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z"
    }
  }]
};
exports.ic_data_usage = ic_data_usage;
var ic_developer_mode = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z"
    }
  }]
};
exports.ic_developer_mode = ic_developer_mode;
var ic_devices = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
    }
  }]
};
exports.ic_devices = ic_devices;
var ic_dvr = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z"
    }
  }]
};
exports.ic_dvr = ic_dvr;
var ic_gps_fixed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_gps_fixed = ic_gps_fixed;
var ic_gps_not_fixed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_gps_not_fixed = ic_gps_not_fixed;
var ic_gps_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
    }
  }]
};
exports.ic_gps_off = ic_gps_off;
var ic_graphic_eq = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z"
    }
  }]
};
exports.ic_graphic_eq = ic_graphic_eq;
var ic_location_disabled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z"
    }
  }]
};
exports.ic_location_disabled = ic_location_disabled;
var ic_location_searching = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_location_searching = ic_location_searching;
var ic_network_cell = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M2 22h20V2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 7L2 22h15z"
    }
  }]
};
exports.ic_network_cell = ic_network_cell;
var ic_network_wifi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
    }
  }]
};
exports.ic_network_wifi = ic_network_wifi;
var ic_nfc = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z"
    }
  }]
};
exports.ic_nfc = ic_nfc;
var ic_screen_lock_landscape = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z"
    }
  }]
};
exports.ic_screen_lock_landscape = ic_screen_lock_landscape;
var ic_screen_lock_portrait = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z"
    }
  }]
};
exports.ic_screen_lock_portrait = ic_screen_lock_portrait;
var ic_screen_lock_rotation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z"
    }
  }]
};
exports.ic_screen_lock_rotation = ic_screen_lock_rotation;
var ic_screen_rotation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z"
    }
  }]
};
exports.ic_screen_rotation = ic_screen_rotation;
var ic_sd_storage = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
    }
  }]
};
exports.ic_sd_storage = ic_sd_storage;
var ic_settings_system_daydream = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z"
    }
  }]
};
exports.ic_settings_system_daydream = ic_settings_system_daydream;
var ic_signal_cellular_0_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M2 22h20V2z"
    }
  }]
};
exports.ic_signal_cellular_0_bar = ic_signal_cellular_0_bar;
var ic_signal_cellular_1_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M2 22h20V2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M12 12L2 22h10z"
    }
  }]
};
exports.ic_signal_cellular_1_bar = ic_signal_cellular_1_bar;
var ic_signal_cellular_2_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M2 22h20V2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M14 10L2 22h12z"
    }
  }]
};
exports.ic_signal_cellular_2_bar = ic_signal_cellular_2_bar;
var ic_signal_cellular_3_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M2 22h20V2z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 7L2 22h15z"
    }
  }]
};
exports.ic_signal_cellular_3_bar = ic_signal_cellular_3_bar;
var ic_signal_cellular_4_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 22h20V2z"
    }
  }]
};
exports.ic_signal_cellular_4_bar = ic_signal_cellular_4_bar;
var ic_signal_cellular_connected_no_internet_0_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M22 8V2L2 22h16V8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z"
    }
  }]
};
exports.ic_signal_cellular_connected_no_internet_0_bar = ic_signal_cellular_connected_no_internet_0_bar;
var ic_signal_cellular_connected_no_internet_1_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M22 8V2L2 22h16V8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z"
    }
  }]
};
exports.ic_signal_cellular_connected_no_internet_1_bar = ic_signal_cellular_connected_no_internet_1_bar;
var ic_signal_cellular_connected_no_internet_2_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M22 8V2L2 22h16V8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
    }
  }]
};
exports.ic_signal_cellular_connected_no_internet_2_bar = ic_signal_cellular_connected_no_internet_2_bar;
var ic_signal_cellular_connected_no_internet_3_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M22 8V2L2 22h16V8z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z"
    }
  }]
};
exports.ic_signal_cellular_connected_no_internet_3_bar = ic_signal_cellular_connected_no_internet_3_bar;
var ic_signal_cellular_connected_no_internet_4_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z"
    }
  }]
};
exports.ic_signal_cellular_connected_no_internet_4_bar = ic_signal_cellular_connected_no_internet_4_bar;
var ic_signal_cellular_no_sim = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z"
    }
  }]
};
exports.ic_signal_cellular_no_sim = ic_signal_cellular_no_sim;
var ic_signal_cellular_null = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z"
    }
  }]
};
exports.ic_signal_cellular_null = ic_signal_cellular_null;
var ic_signal_cellular_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z"
    }
  }]
};
exports.ic_signal_cellular_off = ic_signal_cellular_off;
var ic_signal_wifi_0_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }]
};
exports.ic_signal_wifi_0_bar = ic_signal_wifi_0_bar;
var ic_signal_wifi_1_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z"
    }
  }]
};
exports.ic_signal_wifi_1_bar = ic_signal_wifi_1_bar;
var ic_signal_wifi_1_bar_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
      "opacity": ".3"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z"
    }
  }]
};
exports.ic_signal_wifi_1_bar_lock = ic_signal_wifi_1_bar_lock;
var ic_signal_wifi_2_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z"
    }
  }]
};
exports.ic_signal_wifi_2_bar = ic_signal_wifi_2_bar;
var ic_signal_wifi_2_bar_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z",
      "opacity": ".3"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z"
    }
  }]
};
exports.ic_signal_wifi_2_bar_lock = ic_signal_wifi_2_bar_lock;
var ic_signal_wifi_3_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".3",
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z"
    }
  }]
};
exports.ic_signal_wifi_3_bar = ic_signal_wifi_3_bar;
var ic_signal_wifi_3_bar_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "opacity": ".3",
      "d": "M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9"
    }
  }]
};
exports.ic_signal_wifi_3_bar_lock = ic_signal_wifi_3_bar_lock;
var ic_signal_wifi_4_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z"
    }
  }]
};
exports.ic_signal_wifi_4_bar = ic_signal_wifi_4_bar;
var ic_signal_wifi_4_bar_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z"
    }
  }]
};
exports.ic_signal_wifi_4_bar_lock = ic_signal_wifi_4_bar_lock;
var ic_signal_wifi_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z"
    }
  }]
};
exports.ic_signal_wifi_off = ic_signal_wifi_off;
var ic_storage = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z"
    }
  }]
};
exports.ic_storage = ic_storage;
var ic_usb = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z"
    }
  }]
};
exports.ic_usb = ic_usb;
var ic_wallpaper = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z"
    }
  }]
};
exports.ic_wallpaper = ic_wallpaper;
var ic_widgets = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z"
    }
  }]
};
exports.ic_widgets = ic_widgets;
var ic_wifi_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
    }
  }]
};
exports.ic_wifi_lock = ic_wifi_lock;
var ic_wifi_tethering = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z"
    }
  }]
};
exports.ic_wifi_tethering = ic_wifi_tethering;
var ic_attach_file = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
    }
  }]
};
exports.ic_attach_file = ic_attach_file;
var ic_attach_money = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z"
    }
  }]
};
exports.ic_attach_money = ic_attach_money;
var ic_border_all = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z"
    }
  }]
};
exports.ic_border_all = ic_border_all;
var ic_border_bottom = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z"
    }
  }]
};
exports.ic_border_bottom = ic_border_bottom;
var ic_border_clear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z"
    }
  }]
};
exports.ic_border_clear = ic_border_clear;
var ic_border_color = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill-opacity": ".36",
      "d": "M0 20h24v4H0z"
    }
  }]
};
exports.ic_border_color = ic_border_color;
var ic_border_horizontal = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z"
    }
  }]
};
exports.ic_border_horizontal = ic_border_horizontal;
var ic_border_inner = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z"
    }
  }]
};
exports.ic_border_inner = ic_border_inner;
var ic_border_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z"
    }
  }]
};
exports.ic_border_left = ic_border_left;
var ic_border_outer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z"
    }
  }]
};
exports.ic_border_outer = ic_border_outer;
var ic_border_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z"
    }
  }]
};
exports.ic_border_right = ic_border_right;
var ic_border_style = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z"
    }
  }]
};
exports.ic_border_style = ic_border_style;
var ic_border_top = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z"
    }
  }]
};
exports.ic_border_top = ic_border_top;
var ic_border_vertical = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z"
    }
  }]
};
exports.ic_border_vertical = ic_border_vertical;
var ic_bubble_chart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "7.2",
      "cy": "14.4",
      "r": "3.2"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "14.8",
      "cy": "18",
      "r": "2"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "15.2",
      "cy": "8.8",
      "r": "4.8"
    }
  }]
};
exports.ic_bubble_chart = ic_bubble_chart;
var ic_drag_handle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 9H4v2h16V9zM4 15h16v-2H4v2z"
    }
  }]
};
exports.ic_drag_handle = ic_drag_handle;
var ic_format_align_center = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z"
    }
  }]
};
exports.ic_format_align_center = ic_format_align_center;
var ic_format_align_justify = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z"
    }
  }]
};
exports.ic_format_align_justify = ic_format_align_justify;
var ic_format_align_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z"
    }
  }]
};
exports.ic_format_align_left = ic_format_align_left;
var ic_format_align_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z"
    }
  }]
};
exports.ic_format_align_right = ic_format_align_right;
var ic_format_bold = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_format_bold = ic_format_bold;
var ic_format_clear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z"
    }
  }]
};
exports.ic_format_clear = ic_format_clear;
var ic_format_color_fill = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z"
    }
  }, {
    "name": "path",
    "attribs": {
      "fill-opacity": ".36",
      "d": "M0 20h24v4H0z"
    }
  }]
};
exports.ic_format_color_fill = ic_format_color_fill;
var ic_format_color_reset = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z"
    }
  }]
};
exports.ic_format_color_reset = ic_format_color_reset;
var ic_format_color_text = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill-opacity": ".36",
      "d": "M0 20h24v4H0z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z"
    }
  }]
};
exports.ic_format_color_text = ic_format_color_text;
var ic_format_indent_decrease = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
    }
  }]
};
exports.ic_format_indent_decrease = ic_format_indent_decrease;
var ic_format_indent_increase = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z"
    }
  }]
};
exports.ic_format_indent_increase = ic_format_indent_increase;
var ic_format_italic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z"
    }
  }]
};
exports.ic_format_italic = ic_format_italic;
var ic_format_line_spacing = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z"
    }
  }]
};
exports.ic_format_line_spacing = ic_format_line_spacing;
var ic_format_list_bulleted = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z"
    }
  }]
};
exports.ic_format_list_bulleted = ic_format_list_bulleted;
var ic_format_list_numbered = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z"
    }
  }]
};
exports.ic_format_list_numbered = ic_format_list_numbered;
var ic_format_paint = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z"
    }
  }]
};
exports.ic_format_paint = ic_format_paint;
var ic_format_quote = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z"
    }
  }]
};
exports.ic_format_quote = ic_format_quote;
var ic_format_shapes = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z"
    }
  }]
};
exports.ic_format_shapes = ic_format_shapes;
var ic_format_size = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z"
    }
  }]
};
exports.ic_format_size = ic_format_size;
var ic_format_strikethrough = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z"
    }
  }]
};
exports.ic_format_strikethrough = ic_format_strikethrough;
var ic_format_textdirection_l_to_r = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z"
    }
  }]
};
exports.ic_format_textdirection_l_to_r = ic_format_textdirection_l_to_r;
var ic_format_textdirection_r_to_l = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z"
    }
  }]
};
exports.ic_format_textdirection_r_to_l = ic_format_textdirection_r_to_l;
var ic_format_underlined = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z"
    }
  }]
};
exports.ic_format_underlined = ic_format_underlined;
var ic_functions = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z"
    }
  }]
};
exports.ic_functions = ic_functions;
var ic_highlight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z"
    }
  }]
};
exports.ic_highlight = ic_highlight;
var ic_insert_chart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
    }
  }]
};
exports.ic_insert_chart = ic_insert_chart;
var ic_insert_comment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z"
    }
  }]
};
exports.ic_insert_comment = ic_insert_comment;
var ic_insert_drive_file = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z"
    }
  }]
};
exports.ic_insert_drive_file = ic_insert_drive_file;
var ic_insert_emoticon = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    }
  }]
};
exports.ic_insert_emoticon = ic_insert_emoticon;
var ic_insert_invitation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z"
    }
  }]
};
exports.ic_insert_invitation = ic_insert_invitation;
var ic_insert_link = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z"
    }
  }]
};
exports.ic_insert_link = ic_insert_link;
var ic_insert_photo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    }
  }]
};
exports.ic_insert_photo = ic_insert_photo;
var ic_linear_scale = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z"
    }
  }]
};
exports.ic_linear_scale = ic_linear_scale;
var ic_merge_type = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z"
    }
  }]
};
exports.ic_merge_type = ic_merge_type;
var ic_mode_comment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z"
    }
  }]
};
exports.ic_mode_comment = ic_mode_comment;
var ic_mode_edit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }
  }]
};
exports.ic_mode_edit = ic_mode_edit;
var ic_monetization_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z"
    }
  }]
};
exports.ic_monetization_on = ic_monetization_on;
var ic_money_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z"
    }
  }]
};
exports.ic_money_off = ic_money_off;
var ic_multiline_chart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z"
    }
  }]
};
exports.ic_multiline_chart = ic_multiline_chart;
var ic_pie_chart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z"
    }
  }]
};
exports.ic_pie_chart = ic_pie_chart;
var ic_pie_chart_outlined = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z"
    }
  }]
};
exports.ic_pie_chart_outlined = ic_pie_chart_outlined;
var ic_publish = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z"
    }
  }]
};
exports.ic_publish = ic_publish;
var ic_short_text = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 9h16v2H4zm0 4h10v2H4z"
    }
  }]
};
exports.ic_short_text = ic_short_text;
var ic_show_chart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z"
    }
  }]
};
exports.ic_show_chart = ic_show_chart;
var ic_space_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 9v4H6V9H4v6h16V9z"
    }
  }]
};
exports.ic_space_bar = ic_space_bar;
var ic_strikethrough_s = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#010101",
      "d": "M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z"
    }
  }]
};
exports.ic_strikethrough_s = ic_strikethrough_s;
var ic_text_fields = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z"
    }
  }]
};
exports.ic_text_fields = ic_text_fields;
var ic_title = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 4v3h5.5v12h3V7H19V4z"
    }
  }]
};
exports.ic_title = ic_title;
var ic_vertical_align_bottom = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z"
    }
  }]
};
exports.ic_vertical_align_bottom = ic_vertical_align_bottom;
var ic_vertical_align_center = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z"
    }
  }]
};
exports.ic_vertical_align_center = ic_vertical_align_center;
var ic_vertical_align_top = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z"
    }
  }]
};
exports.ic_vertical_align_top = ic_vertical_align_top;
var ic_wrap_text = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z"
    }
  }]
};
exports.ic_wrap_text = ic_wrap_text;
var ic_attachment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z"
    }
  }]
};
exports.ic_attachment = ic_attachment;
var ic_cloud = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z"
    }
  }]
};
exports.ic_cloud = ic_cloud;
var ic_cloud_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z"
    }
  }]
};
exports.ic_cloud_circle = ic_cloud_circle;
var ic_cloud_done = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z"
    }
  }]
};
exports.ic_cloud_done = ic_cloud_done;
var ic_cloud_download = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
    }
  }]
};
exports.ic_cloud_download = ic_cloud_download;
var ic_cloud_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z"
    }
  }]
};
exports.ic_cloud_off = ic_cloud_off;
var ic_cloud_queue = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z"
    }
  }]
};
exports.ic_cloud_queue = ic_cloud_queue;
var ic_cloud_upload = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z"
    }
  }]
};
exports.ic_cloud_upload = ic_cloud_upload;
var ic_create_new_folder = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z"
    }
  }]
};
exports.ic_create_new_folder = ic_create_new_folder;
var ic_file_download = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z"
    }
  }]
};
exports.ic_file_download = ic_file_download;
var ic_file_upload = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z"
    }
  }]
};
exports.ic_file_upload = ic_file_upload;
var ic_folder = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z"
    }
  }]
};
exports.ic_folder = ic_folder;
var ic_folder_open = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z"
    }
  }]
};
exports.ic_folder_open = ic_folder_open;
var ic_folder_shared = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z"
    }
  }]
};
exports.ic_folder_shared = ic_folder_shared;
var ic_cast = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z"
    }
  }]
};
exports.ic_cast = ic_cast;
var ic_cast_connected = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_cast_connected = ic_cast_connected;
var ic_computer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
    }
  }]
};
exports.ic_computer = ic_computer;
var ic_desktop_mac = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z"
    }
  }]
};
exports.ic_desktop_mac = ic_desktop_mac;
var ic_desktop_windows = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z"
    }
  }]
};
exports.ic_desktop_windows = ic_desktop_windows;
var ic_developer_board = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z"
    }
  }]
};
exports.ic_developer_board = ic_developer_board;
var ic_device_hub = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z"
    }
  }]
};
exports.ic_device_hub = ic_device_hub;
var ic_devices_other = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z"
    }
  }]
};
exports.ic_devices_other = ic_devices_other;
var ic_dock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z"
    }
  }]
};
exports.ic_dock = ic_dock;
var ic_gamepad = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z"
    }
  }]
};
exports.ic_gamepad = ic_gamepad;
var ic_headset = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z"
    }
  }]
};
exports.ic_headset = ic_headset;
var ic_headset_mic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z"
    }
  }]
};
exports.ic_headset_mic = ic_headset_mic;
var ic_keyboard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z"
    }
  }]
};
exports.ic_keyboard = ic_keyboard;
var ic_keyboard_arrow_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z"
    }
  }]
};
exports.ic_keyboard_arrow_down = ic_keyboard_arrow_down;
var ic_keyboard_arrow_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
    }
  }]
};
exports.ic_keyboard_arrow_left = ic_keyboard_arrow_left;
var ic_keyboard_arrow_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
    }
  }]
};
exports.ic_keyboard_arrow_right = ic_keyboard_arrow_right;
var ic_keyboard_arrow_up = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"
    }
  }]
};
exports.ic_keyboard_arrow_up = ic_keyboard_arrow_up;
var ic_keyboard_backspace = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z"
    }
  }]
};
exports.ic_keyboard_backspace = ic_keyboard_backspace;
var ic_keyboard_capslock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z"
    }
  }]
};
exports.ic_keyboard_capslock = ic_keyboard_capslock;
var ic_keyboard_hide = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z"
    }
  }]
};
exports.ic_keyboard_hide = ic_keyboard_hide;
var ic_keyboard_return = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z"
    }
  }]
};
exports.ic_keyboard_return = ic_keyboard_return;
var ic_keyboard_tab = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z"
    }
  }]
};
exports.ic_keyboard_tab = ic_keyboard_tab;
var ic_keyboard_voice = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z"
    }
  }]
};
exports.ic_keyboard_voice = ic_keyboard_voice;
var ic_laptop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z"
    }
  }]
};
exports.ic_laptop = ic_laptop;
var ic_laptop_chromebook = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z"
    }
  }]
};
exports.ic_laptop_chromebook = ic_laptop_chromebook;
var ic_laptop_mac = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    }
  }]
};
exports.ic_laptop_mac = ic_laptop_mac;
var ic_laptop_windows = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z"
    }
  }]
};
exports.ic_laptop_windows = ic_laptop_windows;
var ic_memory = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z"
    }
  }]
};
exports.ic_memory = ic_memory;
var ic_mouse = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z"
    }
  }]
};
exports.ic_mouse = ic_mouse;
var ic_phone_android = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z"
    }
  }]
};
exports.ic_phone_android = ic_phone_android;
var ic_phone_iphone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z"
    }
  }]
};
exports.ic_phone_iphone = ic_phone_iphone;
var ic_phonelink = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z"
    }
  }]
};
exports.ic_phonelink = ic_phonelink;
var ic_phonelink_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_phonelink_off = ic_phonelink_off;
var ic_power_input = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z"
    }
  }]
};
exports.ic_power_input = ic_power_input;
var ic_router = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z"
    }
  }]
};
exports.ic_router = ic_router;
var ic_scanner = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z"
    }
  }]
};
exports.ic_scanner = ic_scanner;
var ic_security = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z"
    }
  }]
};
exports.ic_security = ic_security;
var ic_sim_card = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z"
    }
  }]
};
exports.ic_sim_card = ic_sim_card;
var ic_smartphone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z"
    }
  }]
};
exports.ic_smartphone = ic_smartphone;
var ic_speaker = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }
  }]
};
exports.ic_speaker = ic_speaker;
var ic_speaker_group = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "14",
      "cy": "12.5",
      "r": "2.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z"
    }
  }]
};
exports.ic_speaker_group = ic_speaker_group;
var ic_tablet = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z"
    }
  }]
};
exports.ic_tablet = ic_tablet;
var ic_tablet_android = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z"
    }
  }]
};
exports.ic_tablet_android = ic_tablet_android;
var ic_tablet_mac = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z"
    }
  }]
};
exports.ic_tablet_mac = ic_tablet_mac;
var ic_toys = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z"
    }
  }]
};
exports.ic_toys = ic_toys;
var ic_tv = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z"
    }
  }]
};
exports.ic_tv = ic_tv;
var ic_videogame_asset = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_videogame_asset = ic_videogame_asset;
var ic_watch = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z"
    }
  }]
};
exports.ic_watch = ic_watch;
var ic_add_a_photo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z"
    }
  }]
};
exports.ic_add_a_photo = ic_add_a_photo;
var ic_add_to_photos = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z"
    }
  }]
};
exports.ic_add_to_photos = ic_add_to_photos;
var ic_adjust = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"
    }
  }]
};
exports.ic_adjust = ic_adjust;
var ic_assistant = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z"
    }
  }]
};
exports.ic_assistant = ic_assistant;
var ic_assistant_photo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z"
    }
  }]
};
exports.ic_assistant_photo = ic_assistant_photo;
var ic_audiotrack = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z"
    }
  }]
};
exports.ic_audiotrack = ic_audiotrack;
var ic_blur_circular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z"
    }
  }]
};
exports.ic_blur_circular = ic_blur_circular;
var ic_blur_linear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z"
    }
  }]
};
exports.ic_blur_linear = ic_blur_linear;
var ic_blur_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z"
    }
  }]
};
exports.ic_blur_off = ic_blur_off;
var ic_blur_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"
    }
  }]
};
exports.ic_blur_on = ic_blur_on;
var ic_brightness_1 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "12",
      "r": "10"
    }
  }]
};
exports.ic_brightness_1 = ic_brightness_1;
var ic_brightness_2 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z"
    }
  }]
};
exports.ic_brightness_2 = ic_brightness_2;
var ic_brightness_3 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z"
    }
  }]
};
exports.ic_brightness_3 = ic_brightness_3;
var ic_brightness_4 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
    }
  }]
};
exports.ic_brightness_4 = ic_brightness_4;
var ic_brightness_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
    }
  }]
};
exports.ic_brightness_5 = ic_brightness_5;
var ic_brightness_6 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z"
    }
  }]
};
exports.ic_brightness_6 = ic_brightness_6;
var ic_brightness_7 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z"
    }
  }]
};
exports.ic_brightness_7 = ic_brightness_7;
var ic_broken_image = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z"
    }
  }]
};
exports.ic_broken_image = ic_broken_image;
var ic_brush = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z"
    }
  }]
};
exports.ic_brush = ic_brush;
var ic_burst_mode = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z"
    }
  }]
};
exports.ic_burst_mode = ic_burst_mode;
var ic_camera = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z"
    }
  }]
};
exports.ic_camera = ic_camera;
var ic_camera_alt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "12",
      "r": "3.2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }
  }]
};
exports.ic_camera_alt = ic_camera_alt;
var ic_camera_front = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z"
    }
  }]
};
exports.ic_camera_front = ic_camera_front;
var ic_camera_rear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z"
    }
  }]
};
exports.ic_camera_rear = ic_camera_rear;
var ic_camera_roll = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z"
    }
  }]
};
exports.ic_camera_roll = ic_camera_roll;
var ic_center_focus_strong = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z"
    }
  }]
};
exports.ic_center_focus_strong = ic_center_focus_strong;
var ic_center_focus_weak = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_center_focus_weak = ic_center_focus_weak;
var ic_collections = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
    }
  }]
};
exports.ic_collections = ic_collections;
var ic_collections_bookmark = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z"
    }
  }]
};
exports.ic_collections_bookmark = ic_collections_bookmark;
var ic_color_lens = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_color_lens = ic_color_lens;
var ic_colorize = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z"
    }
  }]
};
exports.ic_colorize = ic_colorize;
var ic_compare = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_compare = ic_compare;
var ic_control_point = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_control_point = ic_control_point;
var ic_control_point_duplicate = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"
    }
  }]
};
exports.ic_control_point_duplicate = ic_control_point_duplicate;
var ic_crop_16_9 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z"
    }
  }]
};
exports.ic_crop_16_9 = ic_crop_16_9;
var ic_crop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z"
    }
  }]
};
exports.ic_crop = ic_crop;
var ic_crop_3_2 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z"
    }
  }]
};
exports.ic_crop_3_2 = ic_crop_3_2;
var ic_crop_5_4 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
    }
  }]
};
exports.ic_crop_5_4 = ic_crop_5_4;
var ic_crop_7_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z"
    }
  }]
};
exports.ic_crop_7_5 = ic_crop_7_5;
var ic_crop_din = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
    }
  }]
};
exports.ic_crop_din = ic_crop_din;
var ic_crop_free = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_crop_free = ic_crop_free;
var ic_crop_landscape = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z"
    }
  }]
};
exports.ic_crop_landscape = ic_crop_landscape;
var ic_crop_original = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z"
    }
  }]
};
exports.ic_crop_original = ic_crop_original;
var ic_crop_portrait = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z"
    }
  }]
};
exports.ic_crop_portrait = ic_crop_portrait;
var ic_crop_rotate = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z"
    }
  }]
};
exports.ic_crop_rotate = ic_crop_rotate;
var ic_crop_square = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z"
    }
  }]
};
exports.ic_crop_square = ic_crop_square;
var ic_dehaze = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z"
    }
  }]
};
exports.ic_dehaze = ic_dehaze;
var ic_details = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z"
    }
  }]
};
exports.ic_details = ic_details;
var ic_edit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z"
    }
  }]
};
exports.ic_edit = ic_edit;
var ic_exposure = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z"
    }
  }]
};
exports.ic_exposure = ic_exposure;
var ic_exposure_neg_1 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z"
    }
  }]
};
exports.ic_exposure_neg_1 = ic_exposure_neg_1;
var ic_exposure_neg_2 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z"
    }
  }]
};
exports.ic_exposure_neg_2 = ic_exposure_neg_2;
var ic_exposure_plus_1 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z"
    }
  }]
};
exports.ic_exposure_plus_1 = ic_exposure_plus_1;
var ic_exposure_plus_2 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z"
    }
  }]
};
exports.ic_exposure_plus_2 = ic_exposure_plus_2;
var ic_exposure_zero = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z"
    }
  }]
};
exports.ic_exposure_zero = ic_exposure_zero;
var ic_filter_1 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
    }
  }]
};
exports.ic_filter_1 = ic_filter_1;
var ic_filter = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
    }
  }]
};
exports.ic_filter = ic_filter;
var ic_filter_2 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z"
    }
  }]
};
exports.ic_filter_2 = ic_filter_2;
var ic_filter_3 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z"
    }
  }]
};
exports.ic_filter_3 = ic_filter_3;
var ic_filter_4 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
    }
  }]
};
exports.ic_filter_4 = ic_filter_4;
var ic_filter_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z"
    }
  }]
};
exports.ic_filter_5 = ic_filter_5;
var ic_filter_6 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z"
    }
  }]
};
exports.ic_filter_6 = ic_filter_6;
var ic_filter_7 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z"
    }
  }]
};
exports.ic_filter_7 = ic_filter_7;
var ic_filter_8 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z"
    }
  }]
};
exports.ic_filter_8 = ic_filter_8;
var ic_filter_9 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z"
    }
  }]
};
exports.ic_filter_9 = ic_filter_9;
var ic_filter_9_plus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z"
    }
  }]
};
exports.ic_filter_9_plus = ic_filter_9_plus;
var ic_filter_b_and_w = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z"
    }
  }]
};
exports.ic_filter_b_and_w = ic_filter_b_and_w;
var ic_filter_center_focus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }
  }]
};
exports.ic_filter_center_focus = ic_filter_center_focus;
var ic_filter_drama = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z"
    }
  }]
};
exports.ic_filter_drama = ic_filter_drama;
var ic_filter_frames = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12"
    }
  }]
};
exports.ic_filter_frames = ic_filter_frames;
var ic_filter_hdr = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
    }
  }]
};
exports.ic_filter_hdr = ic_filter_hdr;
var ic_filter_none = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z"
    }
  }]
};
exports.ic_filter_none = ic_filter_none;
var ic_filter_tilt_shift = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z"
    }
  }]
};
exports.ic_filter_tilt_shift = ic_filter_tilt_shift;
var ic_filter_vintage = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
    }
  }]
};
exports.ic_filter_vintage = ic_filter_vintage;
var ic_flare = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z"
    }
  }]
};
exports.ic_flare = ic_flare;
var ic_flash_auto = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z"
    }
  }]
};
exports.ic_flash_auto = ic_flash_auto;
var ic_flash_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z"
    }
  }]
};
exports.ic_flash_off = ic_flash_off;
var ic_flash_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 2v11h3v9l7-12h-4l4-8z"
    }
  }]
};
exports.ic_flash_on = ic_flash_on;
var ic_flip = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z"
    }
  }]
};
exports.ic_flip = ic_flip;
var ic_gradient = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z"
    }
  }]
};
exports.ic_gradient = ic_gradient;
var ic_grain = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_grain = ic_grain;
var ic_grid_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z"
    }
  }]
};
exports.ic_grid_off = ic_grid_off;
var ic_grid_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z"
    }
  }]
};
exports.ic_grid_on = ic_grid_on;
var ic_hdr_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z"
    }
  }]
};
exports.ic_hdr_off = ic_hdr_off;
var ic_hdr_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z"
    }
  }]
};
exports.ic_hdr_on = ic_hdr_on;
var ic_hdr_strong = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_hdr_strong = ic_hdr_strong;
var ic_hdr_weak = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z"
    }
  }]
};
exports.ic_hdr_weak = ic_hdr_weak;
var ic_healing = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z"
    }
  }]
};
exports.ic_healing = ic_healing;
var ic_image = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    }
  }]
};
exports.ic_image = ic_image;
var ic_image_aspect_ratio = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z"
    }
  }]
};
exports.ic_image_aspect_ratio = ic_image_aspect_ratio;
var ic_iso = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z"
    }
  }]
};
exports.ic_iso = ic_iso;
var ic_landscape = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
    }
  }]
};
exports.ic_landscape = ic_landscape;
var ic_leak_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z"
    }
  }]
};
exports.ic_leak_add = ic_leak_add;
var ic_leak_remove = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z"
    }
  }]
};
exports.ic_leak_remove = ic_leak_remove;
var ic_lens = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"
    }
  }]
};
exports.ic_lens = ic_lens;
var ic_linked_camera = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "14",
      "r": "3.2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }
  }]
};
exports.ic_linked_camera = ic_linked_camera;
var ic_looks = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z"
    }
  }]
};
exports.ic_looks = ic_looks;
var ic_looks_3 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z"
    }
  }]
};
exports.ic_looks_3 = ic_looks_3;
var ic_looks_4 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z"
    }
  }]
};
exports.ic_looks_4 = ic_looks_4;
var ic_looks_5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z"
    }
  }]
};
exports.ic_looks_5 = ic_looks_5;
var ic_looks_6 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z"
    }
  }]
};
exports.ic_looks_6 = ic_looks_6;
var ic_looks_one = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z"
    }
  }]
};
exports.ic_looks_one = ic_looks_one;
var ic_looks_two = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z"
    }
  }]
};
exports.ic_looks_two = ic_looks_two;
var ic_loupe = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_loupe = ic_loupe;
var ic_monochrome_photos = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z"
    }
  }]
};
exports.ic_monochrome_photos = ic_monochrome_photos;
var ic_movie_creation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z"
    }
  }]
};
exports.ic_movie_creation = ic_movie_creation;
var ic_movie_filter = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z"
    }
  }]
};
exports.ic_movie_filter = ic_movie_filter;
var ic_music_note = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z"
    }
  }]
};
exports.ic_music_note = ic_music_note;
var ic_nature = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z"
    }
  }]
};
exports.ic_nature = ic_nature;
var ic_nature_people = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z"
    }
  }]
};
exports.ic_nature_people = ic_nature_people;
var ic_navigate_before = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }
  }]
};
exports.ic_navigate_before = ic_navigate_before;
var ic_navigate_next = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }
  }]
};
exports.ic_navigate_next = ic_navigate_next;
var ic_palette = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_palette = ic_palette;
var ic_panorama = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z"
    }
  }]
};
exports.ic_panorama = ic_panorama;
var ic_panorama_fish_eye = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"
    }
  }]
};
exports.ic_panorama_fish_eye = ic_panorama_fish_eye;
var ic_panorama_horizontal = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z"
    }
  }]
};
exports.ic_panorama_horizontal = ic_panorama_horizontal;
var ic_panorama_vertical = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z"
    }
  }]
};
exports.ic_panorama_vertical = ic_panorama_vertical;
var ic_panorama_wide_angle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z"
    }
  }]
};
exports.ic_panorama_wide_angle = ic_panorama_wide_angle;
var ic_photo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z"
    }
  }]
};
exports.ic_photo = ic_photo;
var ic_photo_album = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z"
    }
  }]
};
exports.ic_photo_album = ic_photo_album;
var ic_photo_camera = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "12",
      "r": "3.2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }
  }]
};
exports.ic_photo_camera = ic_photo_camera;
var ic_photo_filter = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z"
    }
  }]
};
exports.ic_photo_filter = ic_photo_filter;
var ic_photo_library = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z"
    }
  }]
};
exports.ic_photo_library = ic_photo_library;
var ic_photo_size_select_actual = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z"
    }
  }]
};
exports.ic_photo_size_select_actual = ic_photo_size_select_actual;
var ic_photo_size_select_large = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z"
    }
  }]
};
exports.ic_photo_size_select_large = ic_photo_size_select_large;
var ic_photo_size_select_small = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z"
    }
  }]
};
exports.ic_photo_size_select_small = ic_photo_size_select_small;
var ic_picture_as_pdf = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z"
    }
  }]
};
exports.ic_picture_as_pdf = ic_picture_as_pdf;
var ic_portrait = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
    }
  }]
};
exports.ic_portrait = ic_portrait;
var ic_remove_red_eye = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z"
    }
  }]
};
exports.ic_remove_red_eye = ic_remove_red_eye;
var ic_rotate_90_degrees_ccw = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z"
    }
  }]
};
exports.ic_rotate_90_degrees_ccw = ic_rotate_90_degrees_ccw;
var ic_rotate_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"
    }
  }]
};
exports.ic_rotate_left = ic_rotate_left;
var ic_rotate_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"
    }
  }]
};
exports.ic_rotate_right = ic_rotate_right;
var ic_slideshow = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z"
    }
  }]
};
exports.ic_slideshow = ic_slideshow;
var ic_straighten = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z"
    }
  }]
};
exports.ic_straighten = ic_straighten;
var ic_style = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z"
    }
  }]
};
exports.ic_style = ic_style;
var ic_switch_camera = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
    }
  }]
};
exports.ic_switch_camera = ic_switch_camera;
var ic_switch_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z"
    }
  }]
};
exports.ic_switch_video = ic_switch_video;
var ic_tag_faces = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    }
  }]
};
exports.ic_tag_faces = ic_tag_faces;
var ic_texture = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z"
    }
  }]
};
exports.ic_texture = ic_texture;
var ic_timelapse = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }]
};
exports.ic_timelapse = ic_timelapse;
var ic_timer_10 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z"
    }
  }]
};
exports.ic_timer_10 = ic_timer_10;
var ic_timer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_timer = ic_timer;
var ic_timer_3 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z"
    }
  }]
};
exports.ic_timer_3 = ic_timer_3;
var ic_timer_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z"
    }
  }]
};
exports.ic_timer_off = ic_timer_off;
var ic_tonality = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z"
    }
  }]
};
exports.ic_tonality = ic_tonality;
var ic_transform = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z"
    }
  }]
};
exports.ic_transform = ic_transform;
var ic_tune = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z"
    }
  }]
};
exports.ic_tune = ic_tune;
var ic_view_comfy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z"
    }
  }]
};
exports.ic_view_comfy = ic_view_comfy;
var ic_view_compact = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z"
    }
  }]
};
exports.ic_view_compact = ic_view_compact;
var ic_vignette = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z"
    }
  }]
};
exports.ic_vignette = ic_vignette;
var ic_wb_auto = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z"
    }
  }]
};
exports.ic_wb_auto = ic_wb_auto;
var ic_wb_cloudy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z"
    }
  }]
};
exports.ic_wb_cloudy = ic_wb_cloudy;
var ic_wb_incandescent = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z"
    }
  }]
};
exports.ic_wb_incandescent = ic_wb_incandescent;
var ic_wb_iridescent = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z"
    }
  }]
};
exports.ic_wb_iridescent = ic_wb_iridescent;
var ic_wb_sunny = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z"
    }
  }]
};
exports.ic_wb_sunny = ic_wb_sunny;
var ic_add_location = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z"
    }
  }]
};
exports.ic_add_location = ic_add_location;
var ic_beenhere = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z"
    }
  }]
};
exports.ic_beenhere = ic_beenhere;
var ic_directions = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"
    }
  }]
};
exports.ic_directions = ic_directions;
var ic_directions_bike = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z"
    }
  }]
};
exports.ic_directions_bike = ic_directions_bike;
var ic_directions_boat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z"
    }
  }]
};
exports.ic_directions_boat = ic_directions_boat;
var ic_directions_bus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z"
    }
  }]
};
exports.ic_directions_bus = ic_directions_bus;
var ic_directions_car = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
    }
  }]
};
exports.ic_directions_car = ic_directions_car;
var ic_directions_railway = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z"
    }
  }]
};
exports.ic_directions_railway = ic_directions_railway;
var ic_directions_run = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z"
    }
  }]
};
exports.ic_directions_run = ic_directions_run;
var ic_directions_subway = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
    }
  }]
};
exports.ic_directions_subway = ic_directions_subway;
var ic_directions_transit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z"
    }
  }]
};
exports.ic_directions_transit = ic_directions_transit;
var ic_directions_walk = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7"
    }
  }]
};
exports.ic_directions_walk = ic_directions_walk;
var ic_edit_location = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z"
    }
  }]
};
exports.ic_edit_location = ic_edit_location;
var ic_ev_station = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z"
    }
  }]
};
exports.ic_ev_station = ic_ev_station;
var ic_flight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.18 9"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
    }
  }]
};
exports.ic_flight = ic_flight;
var ic_hotel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
    }
  }]
};
exports.ic_hotel = ic_hotel;
var ic_layers = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z"
    }
  }]
};
exports.ic_layers = ic_layers;
var ic_layers_clear = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z"
    }
  }]
};
exports.ic_layers_clear = ic_layers_clear;
var ic_local_activity = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
    }
  }]
};
exports.ic_local_activity = ic_local_activity;
var ic_local_airport = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z"
    }
  }]
};
exports.ic_local_airport = ic_local_airport;
var ic_local_atm = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z"
    }
  }]
};
exports.ic_local_atm = ic_local_atm;
var ic_local_bar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z"
    }
  }]
};
exports.ic_local_bar = ic_local_bar;
var ic_local_cafe = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z"
    }
  }]
};
exports.ic_local_cafe = ic_local_cafe;
var ic_local_car_wash = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z"
    }
  }]
};
exports.ic_local_car_wash = ic_local_car_wash;
var ic_local_convenience_store = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z"
    }
  }]
};
exports.ic_local_convenience_store = ic_local_convenience_store;
var ic_local_dining = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
    }
  }]
};
exports.ic_local_dining = ic_local_dining;
var ic_local_drink = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z"
    }
  }]
};
exports.ic_local_drink = ic_local_drink;
var ic_local_florist = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z"
    }
  }]
};
exports.ic_local_florist = ic_local_florist;
var ic_local_gas_station = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    }
  }]
};
exports.ic_local_gas_station = ic_local_gas_station;
var ic_local_grocery_store = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_local_grocery_store = ic_local_grocery_store;
var ic_local_hospital = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z"
    }
  }]
};
exports.ic_local_hospital = ic_local_hospital;
var ic_local_hotel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z"
    }
  }]
};
exports.ic_local_hotel = ic_local_hotel;
var ic_local_laundry_service = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z"
    }
  }]
};
exports.ic_local_laundry_service = ic_local_laundry_service;
var ic_local_library = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z"
    }
  }]
};
exports.ic_local_library = ic_local_library;
var ic_local_mall = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z"
    }
  }]
};
exports.ic_local_mall = ic_local_mall;
var ic_local_movies = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z"
    }
  }]
};
exports.ic_local_movies = ic_local_movies;
var ic_local_offer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z"
    }
  }]
};
exports.ic_local_offer = ic_local_offer;
var ic_local_parking = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z"
    }
  }]
};
exports.ic_local_parking = ic_local_parking;
var ic_local_pharmacy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z"
    }
  }]
};
exports.ic_local_pharmacy = ic_local_pharmacy;
var ic_local_phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"
    }
  }]
};
exports.ic_local_phone = ic_local_phone;
var ic_local_pizza = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_local_pizza = ic_local_pizza;
var ic_local_play = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z"
    }
  }]
};
exports.ic_local_play = ic_local_play;
var ic_local_post_office = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
    }
  }]
};
exports.ic_local_post_office = ic_local_post_office;
var ic_local_printshop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z"
    }
  }]
};
exports.ic_local_printshop = ic_local_printshop;
var ic_local_see = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "12",
      "r": "3.2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
    }
  }]
};
exports.ic_local_see = ic_local_see;
var ic_local_shipping = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_local_shipping = ic_local_shipping;
var ic_local_taxi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z"
    }
  }]
};
exports.ic_local_taxi = ic_local_taxi;
var ic_map = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z"
    }
  }]
};
exports.ic_map = ic_map;
var ic_my_location = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z"
    }
  }]
};
exports.ic_my_location = ic_my_location;
var ic_navigation = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z"
    }
  }]
};
exports.ic_navigation = ic_navigation;
var ic_near_me = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z"
    }
  }]
};
exports.ic_near_me = ic_near_me;
var ic_person_pin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z"
    }
  }]
};
exports.ic_person_pin = ic_person_pin;
var ic_person_pin_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z"
    }
  }]
};
exports.ic_person_pin_circle = ic_person_pin_circle;
var ic_pin_drop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z"
    }
  }]
};
exports.ic_pin_drop = ic_pin_drop;
var ic_place = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
    }
  }]
};
exports.ic_place = ic_place;
var ic_rate_review = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z"
    }
  }]
};
exports.ic_rate_review = ic_rate_review;
var ic_restaurant = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z"
    }
  }]
};
exports.ic_restaurant = ic_restaurant;
var ic_restaurant_menu = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"
    }
  }]
};
exports.ic_restaurant_menu = ic_restaurant_menu;
var ic_satellite = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z"
    }
  }]
};
exports.ic_satellite = ic_satellite;
var ic_store_mall_directory = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z"
    }
  }]
};
exports.ic_store_mall_directory = ic_store_mall_directory;
var ic_streetview = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "18",
      "cy": "6",
      "r": "5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z"
    }
  }]
};
exports.ic_streetview = ic_streetview;
var ic_subway = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "15.5",
      "cy": "16",
      "r": "1"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "8.5",
      "cy": "16",
      "r": "1"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z"
    }
  }]
};
exports.ic_subway = ic_subway;
var ic_terrain = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z"
    }
  }]
};
exports.ic_terrain = ic_terrain;
var ic_traffic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z"
    }
  }]
};
exports.ic_traffic = ic_traffic;
var ic_train = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_train = ic_train;
var ic_tram = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z"
    }
  }]
};
exports.ic_tram = ic_tram;
var ic_transfer_within_a_station = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75"
    }
  }]
};
exports.ic_transfer_within_a_station = ic_transfer_within_a_station;
var ic_zoom_out_map = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z"
    }
  }]
};
exports.ic_zoom_out_map = ic_zoom_out_map;
var ic_apps = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z"
    }
  }]
};
exports.ic_apps = ic_apps;
var ic_arrow_back = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"
    }
  }]
};
exports.ic_arrow_back = ic_arrow_back;
var ic_arrow_downward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#010101",
      "d": "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
    }
  }]
};
exports.ic_arrow_downward = ic_arrow_downward;
var ic_arrow_drop_down = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 10l5 5 5-5z"
    }
  }]
};
exports.ic_arrow_drop_down = ic_arrow_drop_down;
var ic_arrow_drop_down_circle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z"
    }
  }]
};
exports.ic_arrow_drop_down_circle = ic_arrow_drop_down_circle;
var ic_arrow_drop_up = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 14l5-5 5 5z"
    }
  }]
};
exports.ic_arrow_drop_up = ic_arrow_drop_up;
var ic_arrow_forward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"
    }
  }]
};
exports.ic_arrow_forward = ic_arrow_forward;
var ic_arrow_upward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z"
    }
  }]
};
exports.ic_arrow_upward = ic_arrow_upward;
var ic_cancel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
    }
  }]
};
exports.ic_cancel = ic_cancel;
var ic_check = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"
    }
  }]
};
exports.ic_check = ic_check;
var ic_chevron_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
    }
  }]
};
exports.ic_chevron_left = ic_chevron_left;
var ic_chevron_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
    }
  }]
};
exports.ic_chevron_right = ic_chevron_right;
var ic_close = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
    }
  }]
};
exports.ic_close = ic_close;
var ic_expand_less = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
    }
  }]
};
exports.ic_expand_less = ic_expand_less;
var ic_expand_more = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
    }
  }]
};
exports.ic_expand_more = ic_expand_more;
var ic_first_page = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
    }
  }]
};
exports.ic_first_page = ic_first_page;
var ic_fullscreen = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z"
    }
  }]
};
exports.ic_fullscreen = ic_fullscreen;
var ic_fullscreen_exit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z"
    }
  }]
};
exports.ic_fullscreen_exit = ic_fullscreen_exit;
var ic_last_page = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
    }
  }]
};
exports.ic_last_page = ic_last_page;
var ic_menu = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"
    }
  }]
};
exports.ic_menu = ic_menu;
var ic_more_horiz = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_more_horiz = ic_more_horiz;
var ic_more_vert = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
    }
  }]
};
exports.ic_more_vert = ic_more_vert;
var ic_refresh = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z"
    }
  }]
};
exports.ic_refresh = ic_refresh;
var ic_subdirectory_arrow_left = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z"
    }
  }]
};
exports.ic_subdirectory_arrow_left = ic_subdirectory_arrow_left;
var ic_subdirectory_arrow_right = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z"
    }
  }]
};
exports.ic_subdirectory_arrow_right = ic_subdirectory_arrow_right;
var ic_unfold_less = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z"
    }
  }]
};
exports.ic_unfold_less = ic_unfold_less;
var ic_unfold_more = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z"
    }
  }]
};
exports.ic_unfold_more = ic_unfold_more;
var ic_adb = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z"
    }
  }]
};
exports.ic_adb = ic_adb;
var ic_airline_seat_flat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z"
    }
  }]
};
exports.ic_airline_seat_flat = ic_airline_seat_flat;
var ic_airline_seat_flat_angled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z"
    }
  }]
};
exports.ic_airline_seat_flat_angled = ic_airline_seat_flat_angled;
var ic_airline_seat_individual_suite = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z"
    }
  }]
};
exports.ic_airline_seat_individual_suite = ic_airline_seat_individual_suite;
var ic_airline_seat_legroom_extra = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z"
    }
  }]
};
exports.ic_airline_seat_legroom_extra = ic_airline_seat_legroom_extra;
var ic_airline_seat_legroom_normal = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z"
    }
  }]
};
exports.ic_airline_seat_legroom_normal = ic_airline_seat_legroom_normal;
var ic_airline_seat_legroom_reduced = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z"
    }
  }]
};
exports.ic_airline_seat_legroom_reduced = ic_airline_seat_legroom_reduced;
var ic_airline_seat_recline_extra = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z"
    }
  }]
};
exports.ic_airline_seat_recline_extra = ic_airline_seat_recline_extra;
var ic_airline_seat_recline_normal = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z"
    }
  }]
};
exports.ic_airline_seat_recline_normal = ic_airline_seat_recline_normal;
var ic_bluetooth_audio = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z"
    }
  }]
};
exports.ic_bluetooth_audio = ic_bluetooth_audio;
var ic_confirmation_number = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z"
    }
  }]
};
exports.ic_confirmation_number = ic_confirmation_number;
var ic_disc_full = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
    }
  }]
};
exports.ic_disc_full = ic_disc_full;
var ic_do_not_disturb = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z"
    }
  }]
};
exports.ic_do_not_disturb = ic_do_not_disturb;
var ic_do_not_disturb_alt = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z"
    }
  }]
};
exports.ic_do_not_disturb_alt = ic_do_not_disturb_alt;
var ic_do_not_disturb_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z"
    }
  }]
};
exports.ic_do_not_disturb_off = ic_do_not_disturb_off;
var ic_do_not_disturb_on = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z"
    }
  }]
};
exports.ic_do_not_disturb_on = ic_do_not_disturb_on;
var ic_drive_eta = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
    }
  }]
};
exports.ic_drive_eta = ic_drive_eta;
var ic_enhanced_encryption = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z"
    }
  }]
};
exports.ic_enhanced_encryption = ic_enhanced_encryption;
var ic_event_available = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
    }
  }]
};
exports.ic_event_available = ic_event_available;
var ic_event_busy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"
    }
  }]
};
exports.ic_event_busy = ic_event_busy;
var ic_event_note = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z"
    }
  }]
};
exports.ic_event_note = ic_event_note;
var ic_folder_special = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z"
    }
  }]
};
exports.ic_folder_special = ic_folder_special;
var ic_live_tv = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z"
    }
  }]
};
exports.ic_live_tv = ic_live_tv;
var ic_mms = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z"
    }
  }]
};
exports.ic_mms = ic_mms;
var ic_more = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"
    }
  }]
};
exports.ic_more = ic_more;
var ic_network_check = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z"
    }
  }]
};
exports.ic_network_check = ic_network_check;
var ic_network_locked = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z"
    }
  }]
};
exports.ic_network_locked = ic_network_locked;
var ic_no_encryption = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z"
    }
  }]
};
exports.ic_no_encryption = ic_no_encryption;
var ic_ondemand_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z"
    }
  }]
};
exports.ic_ondemand_video = ic_ondemand_video;
var ic_personal_video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z"
    }
  }]
};
exports.ic_personal_video = ic_personal_video;
var ic_phone_bluetooth_speaker = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_phone_bluetooth_speaker = ic_phone_bluetooth_speaker;
var ic_phone_forwarded = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z"
    }
  }]
};
exports.ic_phone_forwarded = ic_phone_forwarded;
var ic_phone_in_talk = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z"
    }
  }]
};
exports.ic_phone_in_talk = ic_phone_in_talk;
var ic_phone_locked = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z"
    }
  }]
};
exports.ic_phone_locked = ic_phone_locked;
var ic_phone_missed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z"
    }
  }]
};
exports.ic_phone_missed = ic_phone_missed;
var ic_phone_paused = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z"
    }
  }]
};
exports.ic_phone_paused = ic_phone_paused;
var ic_power = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z"
    }
  }]
};
exports.ic_power = ic_power;
var ic_priority_high = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "19",
      "r": "2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M10 3h4v12h-4z"
    }
  }]
};
exports.ic_priority_high = ic_priority_high;
var ic_rv_hookup = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z"
    }
  }]
};
exports.ic_rv_hookup = ic_rv_hookup;
var ic_sd_card = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z"
    }
  }]
};
exports.ic_sd_card = ic_sd_card;
var ic_sim_card_alert = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z"
    }
  }]
};
exports.ic_sim_card_alert = ic_sim_card_alert;
var ic_sms = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z"
    }
  }]
};
exports.ic_sms = ic_sms;
var ic_sms_failed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z"
    }
  }]
};
exports.ic_sms_failed = ic_sms_failed;
var ic_sync = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z"
    }
  }]
};
exports.ic_sync = ic_sync;
var ic_sync_disabled = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z"
    }
  }]
};
exports.ic_sync_disabled = ic_sync_disabled;
var ic_sync_problem = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z"
    }
  }]
};
exports.ic_sync_problem = ic_sync_problem;
var ic_system_update = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z"
    }
  }]
};
exports.ic_system_update = ic_system_update;
var ic_tap_and_play = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z"
    }
  }]
};
exports.ic_tap_and_play = ic_tap_and_play;
var ic_time_to_leave = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z"
    }
  }]
};
exports.ic_time_to_leave = ic_time_to_leave;
var ic_vibration = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z"
    }
  }]
};
exports.ic_vibration = ic_vibration;
var ic_voice_chat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z"
    }
  }]
};
exports.ic_voice_chat = ic_voice_chat;
var ic_vpn_lock = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z"
    }
  }]
};
exports.ic_vpn_lock = ic_vpn_lock;
var ic_wc = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z"
    }
  }]
};
exports.ic_wc = ic_wc;
var ic_wifi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z"
    }
  }]
};
exports.ic_wifi = ic_wifi;
var ic_ac_unit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z"
    }
  }]
};
exports.ic_ac_unit = ic_ac_unit;
var ic_airport_shuttle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z"
    }
  }]
};
exports.ic_airport_shuttle = ic_airport_shuttle;
var ic_all_inclusive = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z"
    }
  }]
};
exports.ic_all_inclusive = ic_all_inclusive;
var ic_beach_access = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z"
    }
  }]
};
exports.ic_beach_access = ic_beach_access;
var ic_business_center = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z"
    }
  }]
};
exports.ic_business_center = ic_business_center;
var ic_casino = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z"
    }
  }]
};
exports.ic_casino = ic_casino;
var ic_child_care = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "14.5",
      "cy": "10.5",
      "r": "1.25"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "9.5",
      "cy": "10.5",
      "r": "1.25"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z"
    }
  }]
};
exports.ic_child_care = ic_child_care;
var ic_child_friendly = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z"
    }
  }]
};
exports.ic_child_friendly = ic_child_friendly;
var ic_fitness_center = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z"
    }
  }]
};
exports.ic_fitness_center = ic_fitness_center;
var ic_free_breakfast = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z"
    }
  }]
};
exports.ic_free_breakfast = ic_free_breakfast;
var ic_golf_course = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "19.5",
      "cy": "19.5",
      "r": "1.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z"
    }
  }]
};
exports.ic_golf_course = ic_golf_course;
var ic_hot_tub = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "7",
      "cy": "6",
      "r": "2"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z"
    }
  }]
};
exports.ic_hot_tub = ic_hot_tub;
var ic_kitchen = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z"
    }
  }]
};
exports.ic_kitchen = ic_kitchen;
var ic_pool = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "16.5",
      "cy": "5.5",
      "r": "2.5"
    }
  }]
};
exports.ic_pool = ic_pool;
var ic_room_service = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z"
    }
  }]
};
exports.ic_room_service = ic_room_service;
var ic_smoke_free = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z"
    }
  }]
};
exports.ic_smoke_free = ic_smoke_free;
var ic_smoking_rooms = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z"
    }
  }]
};
exports.ic_smoking_rooms = ic_smoking_rooms;
var ic_spa = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "fill": "#607D8B",
      "d": "M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z"
    }
  }]
};
exports.ic_spa = ic_spa;
var ic_cake = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z"
    }
  }]
};
exports.ic_cake = ic_cake;
var ic_domain = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"
    }
  }]
};
exports.ic_domain = ic_domain;
var ic_group = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }
  }]
};
exports.ic_group = ic_group;
var ic_group_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z"
    }
  }]
};
exports.ic_group_add = ic_group_add;
var ic_location_city = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z"
    }
  }]
};
exports.ic_location_city = ic_location_city;
var ic_mood = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    }
  }]
};
exports.ic_mood = ic_mood;
var ic_mood_bad = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
    }
  }]
};
exports.ic_mood_bad = ic_mood_bad;
var ic_notifications = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z"
    }
  }]
};
exports.ic_notifications = ic_notifications;
var ic_notifications_active = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z"
    }
  }]
};
exports.ic_notifications_active = ic_notifications_active;
var ic_notifications_none = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z"
    }
  }]
};
exports.ic_notifications_none = ic_notifications_none;
var ic_notifications_off = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z"
    }
  }]
};
exports.ic_notifications_off = ic_notifications_off;
var ic_notifications_paused = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z"
    }
  }]
};
exports.ic_notifications_paused = ic_notifications_paused;
var ic_pages = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_pages = ic_pages;
var ic_party_mode = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z"
    }
  }]
};
exports.ic_party_mode = ic_party_mode;
var ic_people = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
    }
  }]
};
exports.ic_people = ic_people;
var ic_people_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z"
    }
  }]
};
exports.ic_people_outline = ic_people_outline;
var ic_person = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }
  }]
};
exports.ic_person = ic_person;
var ic_person_add = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
    }
  }]
};
exports.ic_person_add = ic_person_add;
var ic_person_outline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
    }
  }]
};
exports.ic_person_outline = ic_person_outline;
var ic_plus_one = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z"
    }
  }]
};
exports.ic_plus_one = ic_plus_one;
var ic_poll = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z"
    }
  }]
};
exports.ic_poll = ic_poll;
var ic_public = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z"
    }
  }]
};
exports.ic_public = ic_public;
var ic_school = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"
    }
  }]
};
exports.ic_school = ic_school;
var ic_sentiment_dissatisfied = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "15.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "8.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z"
    }
  }]
};
exports.ic_sentiment_dissatisfied = ic_sentiment_dissatisfied;
var ic_sentiment_neutral = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 14h6v1.5H9z"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "15.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "8.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }]
};
exports.ic_sentiment_neutral = ic_sentiment_neutral;
var ic_sentiment_satisfied = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "15.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "circle",
    "attribs": {
      "cx": "8.5",
      "cy": "9.5",
      "r": "1.5"
    }
  }, {
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z"
    }
  }]
};
exports.ic_sentiment_satisfied = ic_sentiment_satisfied;
var ic_sentiment_very_dissatisfied = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z"
    }
  }]
};
exports.ic_sentiment_very_dissatisfied = ic_sentiment_very_dissatisfied;
var ic_sentiment_very_satisfied = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"
    }
  }]
};
exports.ic_sentiment_very_satisfied = ic_sentiment_very_satisfied;
var ic_share = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"
    }
  }]
};
exports.ic_share = ic_share;
var ic_whatshot = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z"
    }
  }]
};
exports.ic_whatshot = ic_whatshot;
var ic_check_box = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
    }
  }]
};
exports.ic_check_box = ic_check_box;
var ic_check_box_outline_blank = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
    }
  }]
};
exports.ic_check_box_outline_blank = ic_check_box_outline_blank;
var ic_indeterminate_check_box = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
    }
  }]
};
exports.ic_indeterminate_check_box = ic_indeterminate_check_box;
var ic_radio_button_checked = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }]
};
exports.ic_radio_button_checked = ic_radio_button_checked;
var ic_radio_button_unchecked = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
    }
  }]
};
exports.ic_radio_button_unchecked = ic_radio_button_unchecked;
var ic_star = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
    }
  }]
};
exports.ic_star = ic_star;
var ic_star_border = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    }
  }]
};
exports.ic_star_border = ic_star_border;
var ic_star_half = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z"
    }
  }]
};
exports.ic_star_half = ic_star_half;

/***/ }),
/* 1411 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.dotLine=exports.dotCircle=exports.dollar=exports.documents=exports.documentIcon=exports.documentFill=exports.directions=exports.cross=exports.creditCard=exports.copyPasteDocument=exports.copyDocument=exports.contractVertical=exports.contractHorizontal=exports.contractDirections=exports.compass=exports.compass2=exports.comments=exports.comment=exports.coins=exports.cloud=exports.cloudUpload=exports.cloudRemove=exports.cloudDownload=exports.cloudAdd=exports.clock=exports.circles=exports.check=exports.chat=exports.chartDown=exports.cdDvdRom=exports.camera=exports.buttonQuestion=exports.buttonMinus=exports.buttonExclamation=exports.buttonEmail=exports.buttonClose=exports.buttonCheck=exports.buttonAdd=exports.brush=exports.browserSizes=exports.boxRemove=exports.boxClose=exports.boxBlank=exports.boxAdd=exports.bolt=exports.blockMenu=exports.blank=exports.bezier=exports.bars=exports.banCircle=exports.bag=exports.backward=exports.axisRules=exports.atom=exports.arrowUp=exports.arrowUpThin=exports.arrowUpLight=exports.arrowUpBold=exports.arrowUpBoldRound=exports.arrowUpBig=exports.arrowRight=exports.arrowRightThin=exports.arrowRightLight=exports.arrowRightBold=exports.arrowRightBoldRound=exports.arrowRightBig=exports.arrowObliqueExpand=exports.arrowObliqueExpandDirections=exports.arrowObliqueContract=exports.arrowObliqueContractDirections=exports.arrowMultiLineUp=exports.arrowMultiLineRight=exports.arrowMultiLineLeft=exports.arrowMultiLineDown=exports.arrowLeft=exports.arrowLeftThin=exports.arrowLeftLight=exports.arrowLeftBold=exports.arrowLeftBoldRound=exports.arrowLeftBig=exports.arrowFillUp=exports.arrowFillRight=exports.arrowFillLeft=exports.arrowFillDown=exports.arrowDown=exports.arrowDownThin=exports.arrowDownLight=exports.arrowDownBold=exports.arrowDownBoldRound=exports.arrowDownBig=exports.arrowCycling=exports.arrowCycle=exports.arrowCurveRight=exports.arrowCurveRecycle=exports.arrowCurveLeft=exports.animalFootprint=exports.alarmClock=exports.airPlane=exports.adjust=exports.threeDCube=void 0;exports.quote=exports.question=exports.previousFastStep=exports.prevStep=exports.pounds=exports.podcast=exports.plus=exports.play=exports.pin=exports.pinMap=exports.pigMoney=exports.pause=exports.paperclip=exports.paperclipOblique=exports.optionsSettings=exports.officine=exports.officine2=exports.off=exports.numberZero=exports.numberTwo=exports.numberThree=exports.numberSix=exports.numberSeven=exports.numberOne=exports.numberNine=exports.numberFour=exports.numberFive=exports.numberEight=exports.nextStep=exports.nextFastStep=exports.music=exports.multiBorders=exports.minus=exports.marker=exports.markerPoints=exports.markerMinus=exports.markerAdd=exports.map=exports.maleSymbol=exports.mailbox=exports.mail=exports.magnet=exports.magicWand=exports.loginLockRefresh=exports.locked=exports.location=exports.locationMaps=exports.listSquare=exports.listCircle=exports.linkUrl=exports.lineThrough=exports.limitDirections=exports.likeUpload=exports.likeRemove=exports.likeDownload=exports.likeClose=exports.likeBan=exports.likeAdd=exports.leftRight=exports.leaf=exports.layers=exports.landscape=exports.key=exports.italic=exports.info=exports.idea=exports.homeWifi=exports.heart=exports.hdd=exports.hddRaid=exports.hddNet=exports.grids=exports.gridBig=exports.graphs=exports.forward=exports.fire=exports.femaleSymbol=exports.eye=exports.eyeDisabled=exports.expand=exports.expandVertical=exports.expandHorizontal=exports.expandDirections=exports.exclamation=exports.euro=exports.emailUpload=exports.emailSpam=exports.emailRemove=exports.emailLuminosity=exports.emailDownload=exports.emailClose=exports.emailAdd=exports.eject=exports.drops=exports.drop=exports.download=exports.downloadSelection=exports.downloadSelectionCircle=exports.doubleDiamonds=exports.dotSquare=void 0;exports.yen=exports.world=exports.wireframeGlobe=exports.wind=exports.wifi=exports.waves=exports.viewport=exports.viewportVideo=exports.user=exports.userRemove=exports.userBan=exports.userAdd=exports.upload=exports.uploadSelection=exports.uploadSelectionCircle=exports.underline=exports.triplePoints=exports.topBottom=exports.threePoints=exports.threePointsTop=exports.threePointsBottom=exports.textWidth=exports.textSizeUpper=exports.textSizeReduce=exports.textParagraph=exports.textNormal=exports.textJustifyRight=exports.textJustifyLeft=exports.textJustifyCenter=exports.textHeight=exports.textCenter=exports.textBold=exports.textAlignRight=exports.textAlignLeft=exports.telephone=exports.sunshine=exports.sun=exports.stop=exports.star=exports.speed=exports.soundOn=exports.soundOff=exports.sos=exports.socialZerply=exports.socialYoutube=exports.socialYelp=exports.socialYahoo=exports.socialWordpress=exports.socialVirb=exports.socialVimeo=exports.socialViddler=exports.socialTwitter=exports.socialTumblr=exports.socialStumbleupon=exports.socialSoundcloud=exports.socialSkype=exports.socialSharethis=exports.socialQuora=exports.socialPinterest=exports.socialPhotobucket=exports.socialPaypal=exports.socialMyspace=exports.socialLinkedin=exports.socialLastFm=exports.socialGrooveshark=exports.socialGooglePlus=exports.socialGithub=exports.socialForrst=exports.socialFlickr=exports.socialFacebook=exports.socialEvernote=exports.socialEnvato=exports.socialEmail=exports.socialDribbble=exports.socialDigg=exports.socialDeviantart=exports.socialBlogger=exports.socialBehance=exports.socialBebo=exports.socialAddthis=exports.social500px=exports.snow=exports.sliders=exports.slidersVertical=exports.signMale=exports.signFemale=exports.shield=exports.settings=exports.setting=exports.selectSquare=exports.selectCircle=exports.search=exports.scale=exports.rules=exports.rss=exports.retweet=exports.reportComment=exports.refresh=exports.rec=exports.random=void 0;var threeDCube={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M367.766,223.875l-0.109-32.141l-14.031-8L255.688,128l-97.672,56.188L144,192.266l0.078,31.828l0.234,96.156l83.594,47.594\r\n\tL242.234,376l13.812,7.844l0.266,0.156l28.062-16.141L368,319.734L367.766,223.875z M255.781,160.156l69.812,39.719l-69.641,40.062\r\n\tl-69.828-39.734L255.781,160.156z M172.344,304.109l-0.203-79.766l69.547,39.578l0.219,79.781L172.344,304.109z M270.234,343.781\r\n\tL270.047,264l69.609-40.062l0.25,79.812L270.234,343.781z"},"children":[]}]};exports.threeDCube=threeDCube;var adjust={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-70.688,0-128,57.297-128,128c0,70.688,57.312,128,128,128\r\n\tc70.703,0,128-57.312,128-128C384,185.297,326.703,128,256,128z M160,256c0-52.938,48-96,96-96v192C208,352,160,308.938,160,256z"},"children":[]}]};exports.adjust=adjust;var airPlane={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128,128l73.141,256l73.141-51.203L329.141,384v-85.328L384,247.469L128,128z\r\n\t M292.578,298.672l-97.375-93.875l97.375,76.797V298.672z"},"children":[]}]};exports.airPlane=airPlane;var alarmClock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,144c-61.844,0-112,50.156-112,112s50.156,112,112,112s112-50.156,112-112S317.844,144,256,144z M256,347\r\n\t\tc-50.25,0-91-40.766-91-91c0-50.25,40.75-91,91-91c50.234,0,91,40.75,91,91C347,306.234,306.234,347,256,347z"},"children":[{"name":"path","attribs":{"d":"M256,144c-61.844,0-112,50.156-112,112s50.156,112,112,112s112-50.156,112-112S317.844,144,256,144z M256,347\r\n\t\tc-50.25,0-91-40.766-91-91c0-50.25,40.75-91,91-91c50.234,0,91,40.75,91,91C347,306.234,306.234,347,256,347z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,272c-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[{"name":"path","attribs":{"d":"M256,272c-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[]}]},{"name":"polygon","attribs":{"points":"246.062,257.375 257.391,246.062 287.547,276.219 276.234,287.547 \t"},"children":[{"name":"polygon","attribs":{"points":"246.062,257.375 257.391,246.062 287.547,276.219 276.234,287.547 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"234.969,204.453 250.5,200.609 265.219,259.953 249.688,263.797 \t"},"children":[{"name":"polygon","attribs":{"points":"234.969,204.453 250.5,200.609 265.219,259.953 249.688,263.797 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M373,138.969c-14.625-14.656-38.375-14.656-53.031,0L373,192C387.656,177.359,387.656,153.594,373,138.969z"},"children":[{"name":"path","attribs":{"d":"M373,138.969c-14.625-14.656-38.375-14.656-53.031,0L373,192C387.656,177.359,387.656,153.594,373,138.969z"},"children":[]}]},{"name":"path","attribs":{"d":"M138.984,139c-14.641,14.625-14.641,38.375,0,53.031L192.031,139C177.375,124.344,153.625,124.344,138.984,139z"},"children":[{"name":"path","attribs":{"d":"M138.984,139c-14.641,14.625-14.641,38.375,0,53.031L192.031,139C177.375,124.344,153.625,124.344,138.984,139z"},"children":[]}]}]}]};exports.alarmClock=alarmClock;var animalFootprint={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256-0.5C114.333-0.5-0.5,114.333-0.5,256S114.333,512.5,256,512.5S512.5,397.667,512.5,256S397.667-0.5,256-0.5z\r\n\t\t M256,472.422C136.47,472.422,39.578,375.53,39.578,256C39.578,136.47,136.47,39.578,256,39.578\r\n\t\tc119.53,0,216.422,96.892,216.422,216.422C472.422,375.53,375.53,472.422,256,472.422z"},"children":[{"name":"path","attribs":{"d":"M256-0.5C114.333-0.5-0.5,114.333-0.5,256S114.333,512.5,256,512.5S512.5,397.667,512.5,256S397.667-0.5,256-0.5z\r\n\t\t M256,472.422C136.47,472.422,39.578,375.53,39.578,256C39.578,136.47,136.47,39.578,256,39.578\r\n\t\tc119.53,0,216.422,96.892,216.422,216.422C472.422,375.53,375.53,472.422,256,472.422z"},"children":[]}]},{"name":"path","attribs":{"d":"M133.48,236.619c-9.394,8.673-6.982,27.397,5.385,41.863c12.368,14.45,29.996,19.131,39.374,10.427\r\n\t\tc9.378-8.643,6.967-27.397-5.401-41.832C160.47,232.642,142.842,227.945,133.48,236.619z"},"children":[{"name":"path","attribs":{"d":"M133.48,236.619c-9.394,8.673-6.982,27.397,5.385,41.863c12.368,14.45,29.996,19.131,39.374,10.427\r\n\t\tc9.378-8.643,6.967-27.397-5.401-41.832C160.47,232.642,142.842,227.945,133.48,236.619z"},"children":[]}]},{"name":"path","attribs":{"d":"M338.833,243.757c-11.006,15.625-11.694,34.52-1.55,42.223c10.129,7.671,27.257,1.314,38.247-14.325\r\n\t\tc10.99-15.593,11.679-34.473,1.55-42.191C366.95,221.777,349.808,228.18,338.833,243.757z"},"children":[{"name":"path","attribs":{"d":"M338.833,243.757c-11.006,15.625-11.694,34.52-1.55,42.223c10.129,7.671,27.257,1.314,38.247-14.325\r\n\t\tc10.99-15.593,11.679-34.473,1.55-42.191C366.95,221.777,349.808,228.18,338.833,243.757z"},"children":[]}]},{"name":"path","attribs":{"d":"M226.129,240.125c16.517-3.977,25.111-28.65,19.179-55.107c-5.887-26.458-24.078-44.681-40.595-40.705\r\n\t\tc-16.501,4.008-25.08,28.681-19.194,55.139C191.452,225.879,209.628,244.102,226.129,240.125z"},"children":[{"name":"path","attribs":{"d":"M226.129,240.125c16.517-3.977,25.111-28.65,19.179-55.107c-5.887-26.458-24.078-44.681-40.595-40.705\r\n\t\tc-16.501,4.008-25.08,28.681-19.194,55.139C191.452,225.879,209.628,244.102,226.129,240.125z"},"children":[]}]},{"name":"path","attribs":{"d":"M309.057,144.313c-16.501-3.977-34.677,14.247-40.595,40.705c-5.918,26.458,2.661,51.131,19.193,55.107\r\n\t\tc16.485,3.976,34.677-14.247,40.595-40.673C334.184,172.995,325.558,148.321,309.057,144.313z"},"children":[{"name":"path","attribs":{"d":"M309.057,144.313c-16.501-3.977-34.677,14.247-40.595,40.705c-5.918,26.458,2.661,51.131,19.193,55.107\r\n\t\tc16.485,3.976,34.677-14.247,40.595-40.673C334.184,172.995,325.558,148.321,309.057,144.313z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,262.513c-39.374,0-68.932,62.7-68.932,83.444c0,51.005,29.558-1.613,68.932-1.613c39.39,0,68.932,52.618,68.932,1.613\r\n\t\tC324.932,325.213,295.39,262.513,256,262.513z"},"children":[{"name":"path","attribs":{"d":"M256,262.513c-39.374,0-68.932,62.7-68.932,83.444c0,51.005,29.558-1.613,68.932-1.613c39.39,0,68.932,52.618,68.932,1.613\r\n\t\tC324.932,325.213,295.39,262.513,256,262.513z"},"children":[]}]}]}]};exports.animalFootprint=animalFootprint;var arrowCurveLeft={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M325,250.438C282.797,223.078,215.5,224,215.5,224v-48l-96,80l96,64v-48c0,0,45-9,85.844,6.406\r\n\t\tC338.688,292.484,379.75,336,379.75,336S367.203,277.828,325,250.438z"},"children":[{"name":"path","attribs":{"d":"M325,250.438C282.797,223.078,215.5,224,215.5,224v-48l-96,80l96,64v-48c0,0,45-9,85.844,6.406\r\n\t\tC338.688,292.484,379.75,336,379.75,336S367.203,277.828,325,250.438z"},"children":[]}]}]}]};exports.arrowCurveLeft=arrowCurveLeft;var arrowCurveRecycle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M279.5,176c0,0-58.797-0.922-101,26.438C136.297,229.828,125.875,288,125.875,288s37.875-43.516,75.219-57.594\r\n\t\tC241.938,215,279.5,224,279.5,224v48l96-64l-96-80V176z"},"children":[{"name":"path","attribs":{"d":"M279.5,176c0,0-58.797-0.922-101,26.438C136.297,229.828,125.875,288,125.875,288s37.875-43.516,75.219-57.594\r\n\t\tC241.938,215,279.5,224,279.5,224v48l96-64l-96-80V176z"},"children":[]}]},{"name":"path","attribs":{"d":"M301.344,281.594C260.5,297,215.5,288,215.5,288v-48l-96,64l96,80v-48c0,0,67.297,0.922,109.5-26.438\r\n\t\tC367.203,282.172,379.75,224,379.75,224S338.688,267.516,301.344,281.594z"},"children":[{"name":"path","attribs":{"d":"M301.344,281.594C260.5,297,215.5,288,215.5,288v-48l-96,64l96,80v-48c0,0,67.297,0.922,109.5-26.438\r\n\t\tC367.203,282.172,379.75,224,379.75,224S338.688,267.516,301.344,281.594z"},"children":[]}]}]}]};exports.arrowCurveRecycle=arrowCurveRecycle;var arrowCurveRight={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M279.5,224c0,0-58.797-0.922-101,26.438C136.297,277.828,125.875,336,125.875,336s37.875-43.516,75.219-57.594\r\n\t\tC241.938,263,279.5,272,279.5,272v48l96-64l-96-80V224z"},"children":[{"name":"path","attribs":{"d":"M279.5,224c0,0-58.797-0.922-101,26.438C136.297,277.828,125.875,336,125.875,336s37.875-43.516,75.219-57.594\r\n\t\tC241.938,263,279.5,272,279.5,272v48l96-64l-96-80V224z"},"children":[]}]}]}]};exports.arrowCurveRight=arrowCurveRight;var arrowCycle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M188.117,188.125c37.5-37.5,98.273-37.5,135.758,0l-11.312,11.312l50.922,16.969L346.5,165.484l-11.312,11.328\r\n\t\tc-43.75-43.75-114.641-43.75-158.383,0c-27.984,27.984-37.977,67.078-30.141,103.078l18.211,6.078\r\n\t\tC153.953,252.656,161.648,214.594,188.117,188.125z"},"children":[{"name":"path","attribs":{"d":"M188.117,188.125c37.5-37.5,98.273-37.5,135.758,0l-11.312,11.312l50.922,16.969L346.5,165.484l-11.312,11.328\r\n\t\tc-43.75-43.75-114.641-43.75-158.383,0c-27.984,27.984-37.977,67.078-30.141,103.078l18.211,6.078\r\n\t\tC153.953,252.656,161.648,214.594,188.117,188.125z"},"children":[]}]},{"name":"path","attribs":{"d":"M347.125,226.031c10.922,33.312,3.234,71.375-23.25,97.844c-37.5,37.5-98.258,37.5-135.758,0l11.312-11.312l-50.906-16.969\r\n\t\tl16.969,50.922l16.969-16.984l-5.656,5.672c43.742,43.734,114.648,43.734,158.383,0c28-28,37.984-67.078,30.156-103.094\r\n\t\tL347.125,226.031z"},"children":[{"name":"path","attribs":{"d":"M347.125,226.031c10.922,33.312,3.234,71.375-23.25,97.844c-37.5,37.5-98.258,37.5-135.758,0l11.312-11.312l-50.906-16.969\r\n\t\tl16.969,50.922l16.969-16.984l-5.656,5.672c43.742,43.734,114.648,43.734,158.383,0c28-28,37.984-67.078,30.156-103.094\r\n\t\tL347.125,226.031z"},"children":[]}]}]}]};exports.arrowCycle=arrowCycle;var arrowCycling={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M247.5,160v16l48-24l-48-24v16c-32,0-70.039,20.594-89.961,51.578L164,212.75C179.828,181.484,215.5,160,247.5,160z"},"children":[{"name":"path","attribs":{"d":"M247.5,160v16l48-24l-48-24v16c-32,0-70.039,20.594-89.961,51.578L164,212.75C179.828,181.484,215.5,160,247.5,160z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,264.5h16l-24-48l-24,48h16c0,32,20.586,70.031,51.578,89.969L212.75,348C181.484,332.172,160,296.5,160,264.5z"},"children":[{"name":"path","attribs":{"d":"M160,264.5h16l-24-48l-24,48h16c0,32,20.586,70.031,51.578,89.969L212.75,348C181.484,332.172,160,296.5,160,264.5z"},"children":[]}]},{"name":"path","attribs":{"d":"M247.5,352v-16l-48,24l48,24v-16c48,0,78.531-20.594,98.469-51.578L335.25,299.25C319.422,330.516,295.5,352,247.5,352z"},"children":[{"name":"path","attribs":{"d":"M247.5,352v-16l-48,24l48,24v-16c48,0,78.531-20.594,98.469-51.578L335.25,299.25C319.422,330.516,295.5,352,247.5,352z"},"children":[]}]},{"name":"path","attribs":{"d":"M316.422,166.031L299.25,176.75C330.516,192.578,352,216.5,352,264.5h-16l24,48l24-48h-16\r\n\t\tC368,216.5,347.406,185.969,316.422,166.031z"},"children":[{"name":"path","attribs":{"d":"M316.422,166.031L299.25,176.75C330.516,192.578,352,216.5,352,264.5h-16l24,48l24-48h-16\r\n\t\tC368,216.5,347.406,185.969,316.422,166.031z"},"children":[]}]}]}]};exports.arrowCycling=arrowCycling;var arrowDownBig={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M0,256c0,141.406,114.609,256,256,256s256-114.594,256-256C512,114.625,397.391,0,256,0S0,114.625,0,256z M472,256\r\n\tc0,119.312-96.703,216-216,216S40,375.312,40,256c0-119.281,96.703-216,216-216S472,136.719,472,256z"},"children":[]},{"name":"polygon","attribs":{"points":"160,272 256,384 352,272 303.984,272 303.984,128 207.984,128 207.984,272 "},"children":[]}]};exports.arrowDownBig=arrowDownBig;var arrowDownBoldRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M512,256C512,114.608,397.392,0,256,0S0,114.608,0,256s114.608,256,256,256S512,397.392,512,256z M40,256\r\n\tc0-119.296,96.704-216,216-216c119.298,0,216,96.704,216,216c0,119.298-96.702,216-216,216C136.704,472,40,375.298,40,256z"},"children":[]},{"name":"path","attribs":{"d":"M274.122,343.468l89.592-145.578c9.97-16.844,1.938-24.39-17.841-24.39H166.105c-19.75,0-27.796,7.546-17.812,24.39\r\n\tl89.579,148.655C247.841,363.452,264.152,360.359,274.122,343.468z"},"children":[]}]};exports.arrowDownBoldRound=arrowDownBoldRound;var arrowDownBold={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"256,362.5 368,170.5 144,170.5 "},"children":[]}]};exports.arrowDownBold=arrowDownBold;var arrowDownLight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,256c0,141.406,114.609,256,256,256s256-114.594,256-256\r\n\tC512,114.625,397.391,0,256,0S0,114.625,0,256z M472,256c0,119.312-96.703,216-216,216S40,375.312,40,256\r\n\tc0-119.281,96.703-216,216-216S472,136.719,472,256z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"239.961,128 239.961,326.406 198.836,288 175.992,309.344 255.992,384 \r\n\t336.008,309.344 313.102,288 271.961,326.406 271.961,128 "},"children":[]}]};exports.arrowDownLight=arrowDownLight;var arrowDownThin={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M0,256c0,141.391,114.594,256,256,256c141.375,0,256-114.609,256-256S397.375,0,256,0C114.594,0,0,114.609,0,256z M472,256\r\n\tc0,119.297-96.719,216-216,216c-119.312,0-216-96.703-216-216S136.688,40,256,40C375.281,40,472,136.703,472,256z"},"children":[]},{"name":"path","attribs":{"d":"M148.688,206.688c-6.25,6.25-6.25,16.375,0,22.625l96,96c6.25,6.25,16.375,6.25,22.625,0l96-96\r\n\tC366.438,226.188,368,222.094,368,218s-1.562-8.188-4.688-11.312c-6.25-6.25-16.375-6.25-22.625,0L256,291.375l-84.688-84.688\r\n\tC165.062,200.438,154.938,200.438,148.688,206.688z"},"children":[]}]};exports.arrowDownThin=arrowDownThin;var arrowDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M0,256c0,141.391,114.594,256,256,256c141.375,0,256-114.609,256-256\r\n\tS397.375,0,256,0C114.594,0,0,114.609,0,256z M472,256c0,119.297-96.719,216-216,216c-119.312,0-216-96.703-216-216\r\n\tS136.688,40,256,40C375.281,40,472,136.703,472,256z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"144,226 256,338 368,226 336,194 256,274 176,194 "},"children":[]}]};exports.arrowDown=arrowDown;var arrowFillDown={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M304,144h-96c-8.797,0-16,7.188-16,15.969v143.828c0,8.766,4.484,21.594,9.969,28.469l43.656,62.578\r\n\t\tc5.469,6.875,14.469,6.875,19.969,0.031l44.391-62.641C315.5,325.375,320,312.562,320,303.797V159.969\r\n\t\tC320,151.188,312.797,144,304,144z"},"children":[{"name":"path","attribs":{"d":"M304,144h-96c-8.797,0-16,7.188-16,15.969v143.828c0,8.766,4.484,21.594,9.969,28.469l43.656,62.578\r\n\t\tc5.469,6.875,14.469,6.875,19.969,0.031l44.391-62.641C315.5,325.375,320,312.562,320,303.797V159.969\r\n\t\tC320,151.188,312.797,144,304,144z"},"children":[]}]}]}]};exports.arrowFillDown=arrowFillDown;var arrowFillLeft={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M352.031,192H208.203c-8.766,0-21.594,4.484-28.469,9.969l-62.578,43.656c-6.875,5.469-6.875,14.469-0.031,19.969\r\n\t\tl62.641,44.391C186.625,315.5,199.438,320,208.203,320h143.828c8.781,0,15.969-7.203,15.969-16v-96\r\n\t\tC368,199.203,360.812,192,352.031,192z"},"children":[{"name":"path","attribs":{"d":"M352.031,192H208.203c-8.766,0-21.594,4.484-28.469,9.969l-62.578,43.656c-6.875,5.469-6.875,14.469-0.031,19.969\r\n\t\tl62.641,44.391C186.625,315.5,199.438,320,208.203,320h143.828c8.781,0,15.969-7.203,15.969-16v-96\r\n\t\tC368,199.203,360.812,192,352.031,192z"},"children":[]}]}]}]};exports.arrowFillLeft=arrowFillLeft;var arrowFillRight={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M332.234,202.016C325.375,196.5,312.562,192,303.797,192H159.969c-8.781,0-15.969,7.203-15.969,16v96\r\n\t\tc0,8.797,7.188,16,15.969,16h143.828c8.766,0,21.594-4.484,28.469-9.969l62.578-43.656c6.875-5.469,6.875-14.469,0.031-19.969\r\n\t\tL332.234,202.016z"},"children":[{"name":"path","attribs":{"d":"M332.234,202.016C325.375,196.5,312.562,192,303.797,192H159.969c-8.781,0-15.969,7.203-15.969,16v96\r\n\t\tc0,8.797,7.188,16,15.969,16h143.828c8.766,0,21.594-4.484,28.469-9.969l62.578-43.656c6.875-5.469,6.875-14.469,0.031-19.969\r\n\t\tL332.234,202.016z"},"children":[]}]}]}]};exports.arrowFillRight=arrowFillRight;var arrowFillUp={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M266.375,117.156c-5.469-6.875-14.469-6.875-19.969-0.031l-44.391,62.641C196.5,186.625,192,199.438,192,208.203v143.828\r\n\t\tc0,8.781,7.203,15.969,16,15.969h96c8.797,0,16-7.188,16-15.969V208.203c0-8.766-4.484-21.594-9.969-28.469L266.375,117.156z"},"children":[{"name":"path","attribs":{"d":"M266.375,117.156c-5.469-6.875-14.469-6.875-19.969-0.031l-44.391,62.641C196.5,186.625,192,199.438,192,208.203v143.828\r\n\t\tc0,8.781,7.203,15.969,16,15.969h96c8.797,0,16-7.188,16-15.969V208.203c0-8.766-4.484-21.594-9.969-28.469L266.375,117.156z"},"children":[]}]}]}]};exports.arrowFillUp=arrowFillUp;var arrowLeftBig={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.562,0,0,114.609,0,256s114.562,256,256,256c141.375,0,256-114.609,256-256S397.375,0,256,0z M256,472\r\n\tc-119.344,0-216.031-96.703-216.031-216S136.656,40,256,40c119.281,0,216,96.703,216,216S375.281,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"240,160 128,256 240,352 240,304.031 384,304.031 384,208.031 240,208.031 "},"children":[]}]};exports.arrowLeftBig=arrowLeftBig;var arrowLeftBoldRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256C512,114.609,397.391,0,256,0C114.609,0,0,114.609,0,256\r\n\tC0,397.391,114.609,512,256,512z M256,40c119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]},{"name":"path","attribs":{"d":"M157.84,274.121l145.872,89.594c16.844,9.969,24.685,1.938,24.685-17.844V166.105c0-19.75-7.841-27.797-24.685-17.812\r\n\tl-148.795,89.578C137.995,247.84,140.949,264.152,157.84,274.121z"},"children":[]}]};exports.arrowLeftBoldRound=arrowLeftBoldRound;var arrowLeftBold={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256C512,114.609,397.391,0,256,0C114.609,0,0,114.609,0,256\r\n\tC0,397.391,114.609,512,256,512z M256,40c119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]},{"name":"polygon","attribs":{"points":"331.5,144 139.5,256 331.5,368 "},"children":[]}]};exports.arrowLeftBold=arrowLeftBold;var arrowLeftLight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"384,240 185.594,240 224,198.844 202.656,176 128,256 202.656,336 \r\n\t224,313.125 185.594,272 384,272 "},"children":[]}]};exports.arrowLeftLight=arrowLeftLight;var arrowLeftThin={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M305.312,148.688c-6.25-6.25-16.375-6.25-22.625,0l-96,96c-6.25,6.25-6.25,16.375,0,22.625l96,96\r\n\tC285.812,366.438,289.906,368,294,368s8.188-1.562,11.312-4.688c6.25-6.25,6.25-16.375,0-22.625L220.625,256l84.688-84.688\r\n\tC311.562,165.062,311.562,154.938,305.312,148.688z"},"children":[]}]};exports.arrowLeftThin=arrowLeftThin;var arrowLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"286,144 174,256 286,368 318,336 238,256 318,176 "},"children":[]}]};exports.arrowLeft=arrowLeft;var arrowMultiLineDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M0,256c0,141.391,114.609,256,256,256s256-114.609,256-256S397.391,0,256,0S0,114.609,0,256z M472,256\r\n\tc0,119.297-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40S472,136.703,472,256z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"223.953","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.953","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"223.953","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.953","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"223.953","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.953","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"192,320 256,384 320,320 287.953,320 287.953,256 223.953,256 \r\n\t\t223.953,320 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"192,320 256,384 320,320 287.953,320 287.953,256 223.953,256 \r\n\t\t223.953,320 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"223.953","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.953","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]}]}]};exports.arrowMultiLineDown=arrowMultiLineDown;var arrowMultiLineLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"368","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"368","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"336","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"304","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"304","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"192,192 128,256 192,320 192,288 256,288 256,224 192,224 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"192,192 128,256 192,320 192,288 256,288 256,224 192,224 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"272","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]}]}]};exports.arrowMultiLineLeft=arrowMultiLineLeft;var arrowMultiLineRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256S114.609,512,256,512z M256,40\r\n\tc119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"128","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"160","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"192","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"320,320 384,256 320,192 320,224 256,224 256,288 320,288 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"320,320 384,256 320,192 320,224 256,224 256,288 320,288 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[{"name":"rect","attribs":{"x":"224","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"64"},"children":[]}]}]}]};exports.arrowMultiLineRight=arrowMultiLineRight;var arrowMultiLineUp={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M512,256C512,114.609,397.391,0,256,0S0,114.609,0,256s114.609,256,256,256S512,397.391,512,256z M40,256\r\n\tc0-119.297,96.703-216,216-216s216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"223.969","y":"368","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.969","y":"368","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"223.969","y":"336","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.969","y":"336","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"223.969","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.969","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"320,192 256,128 192,192 223.969,192 223.969,256 287.969,256 \r\n\t\t287.969,192 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"320,192 256,128 192,192 223.969,192 223.969,256 287.969,256 \r\n\t\t287.969,192 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"223.969","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"223.969","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"16"},"children":[]}]}]}]};exports.arrowMultiLineUp=arrowMultiLineUp;var arrowObliqueContractDirections={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"159.984,240 240,240 240,160 216,184 175.984,144 143.984,176 \r\n\t\t\t183.984,216 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"159.984,240 240,240 240,160 216,184 175.984,144 143.984,176 \r\n\t\t\t183.984,216 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"328.016,296 352.016,272 272,272 272,351.984 296,327.984 \r\n\t\t\t336.016,367.984 368.016,335.984 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"328.016,296 352.016,272 272,272 272,351.984 296,327.984 \r\n\t\t\t336.016,367.984 368.016,335.984 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"327.984,215.984 367.984,176 335.984,143.984 296,183.984 272,159.984 \r\n\t\t\t272,240 351.984,240 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"327.984,215.984 367.984,176 335.984,143.984 296,183.984 272,159.984 \r\n\t\t\t272,240 351.984,240 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"183.984,296 143.984,336.016 175.984,368.016 215.984,328.016 \r\n\t\t\t240,352.016 240,272 159.984,272 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"183.984,296 143.984,336.016 175.984,368.016 215.984,328.016 \r\n\t\t\t240,352.016 240,272 159.984,272 \t\t"},"children":[]}]}]}]}]}]};exports.arrowObliqueContractDirections=arrowObliqueContractDirections;var arrowObliqueContract={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"176,144 144,176 184,216 160,240 240,240 240,160 216,184 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"176,144 144,176 184,216 160,240 240,240 240,160 216,184 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352.031,272 272,272 272,351.984 296.016,327.984 336.031,367.984 \r\n\t\t368.031,335.984 328.031,296 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352.031,272 272,272 272,351.984 296.016,327.984 336.031,367.984 \r\n\t\t368.031,335.984 328.031,296 \t"},"children":[]}]}]}]};exports.arrowObliqueContract=arrowObliqueContract;var arrowObliqueExpandDirections={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"224,144 144,144 144,224 168,200 208,240 240,208 200,168 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"224,144 144,144 144,224 168,200 208,240 240,208 200,168 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"288,368 368,368 368,288 344,312 304,272 272,304 312,344 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"288,368 368,368 368,288 344,312 304,272 272,304 312,344 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,224 368,144 288,144 312,168 272,208 304,240 344,200 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,224 368,144 288,144 312,168 272,208 304,240 344,200 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"144,288 144,368 224,368 200,344 240,304 208,272 168,312 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"144,288 144,368 224,368 200,344 240,304 208,272 168,312 \t\t"},"children":[]}]}]}]}]}]};exports.arrowObliqueExpandDirections=arrowObliqueExpandDirections;var arrowObliqueExpand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"224,144 144,144 144,224 168,200 208,240 240,208 200,168 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"224,144 144,144 144,224 168,200 208,240 240,208 200,168 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,272 272,304 312,344 288,368 368,368 368,288 344,312 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,272 272,304 312,344 288,368 368,368 368,288 344,312 \t"},"children":[]}]}]}]};exports.arrowObliqueExpand=arrowObliqueExpand;var arrowRightBig={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256.008,512.004c141.408,0,255.988-114.611,255.988-256.004S397.416-0.004,256.008-0.004\r\n\tC114.631-0.004,0.004,114.607,0.004,256S114.631,512.004,256.008,512.004z M256.008,39.997\r\n\tc119.314,0,216.003,96.705,216.003,216.003s-96.688,216.004-216.003,216.004c-119.283,0-216.004-96.705-216.004-216.004\r\n\tS136.725,39.997,256.008,39.997z"},"children":[]},{"name":"polygon","attribs":{"points":"272,352.002 384.002,256 272,159.998 272,207.999 127.998,207.999 127.998,304 272,304 "},"children":[]}]};exports.arrowRightBig=arrowRightBig;var arrowRightBoldRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M353.661,237.879l-154.174-89.594c-16.844-9.969-32.987-1.938-32.987,17.844v179.766c0,19.75,16.143,27.797,32.987,17.812\r\n\tl152.955-89.578C369.348,264.16,370.552,247.848,353.661,237.879z"},"children":[]}]};exports.arrowRightBoldRound=arrowRightBoldRound;var arrowRightBold={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"169.5,368 361.5,256 169.5,144 "},"children":[]}]};exports.arrowRightBold=arrowRightBold;var arrowRightLight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256\r\n\tS114.609,512,256,512z M256,40c119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"128,272 326.406,272 288,313.156 309.344,336 384,256 309.344,176 \r\n\t288,198.875 326.406,240 128,240 "},"children":[]}]};exports.arrowRightLight=arrowRightLight;var arrowRightThin={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256S114.609,512,256,512z M256,40\r\n\t\tc119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256S114.609,512,256,512z M256,40\r\n\t\tc119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]}]},{"name":"path","attribs":{"d":"M212.688,363.312c6.25,6.25,16.375,6.25,22.625,0l96-96c6.25-6.25,6.25-16.375,0-22.625l-96-96\r\n\t\tC232.188,145.562,228.094,144,224,144s-8.188,1.562-11.312,4.688c-6.25,6.25-6.25,16.375,0,22.625L297.375,256l-84.688,84.688\r\n\t\tC206.438,346.938,206.438,357.062,212.688,363.312z"},"children":[{"name":"path","attribs":{"d":"M212.688,363.312c6.25,6.25,16.375,6.25,22.625,0l96-96c6.25-6.25,6.25-16.375,0-22.625l-96-96\r\n\t\tC232.188,145.562,228.094,144,224,144s-8.188,1.562-11.312,4.688c-6.25,6.25-6.25,16.375,0,22.625L297.375,256l-84.688,84.688\r\n\t\tC206.438,346.938,206.438,357.062,212.688,363.312z"},"children":[]}]}]}]};exports.arrowRightThin=arrowRightThin;var arrowRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256\r\n\tS114.609,512,256,512z M256,40c119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"226,368 338,256 226,144 194,176 274,256 194,336 "},"children":[]}]};exports.arrowRight=arrowRight;var arrowUpBig={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M512,256.008C512,114.597,397.388-0.016,255.992,0C114.598,0-0.016,114.581,0,256.008\r\n\tC0,397.387,114.613,512.016,255.992,512C397.388,512.016,512,397.387,512,256.008z M40.002,256.008\r\n\tc0-119.316,96.69-216.007,215.99-216.007C375.309,40.001,472,136.691,472,256.008c0,119.269-96.691,215.99-216.008,215.99\r\n\tC136.692,471.998,40.002,375.276,40.002,256.008z"},"children":[]},{"name":"polygon","attribs":{"points":"352.003,239.999 255.999,127.996 159.997,239.999 207.998,239.999 207.998,384.004 304.001,384.004 \r\n\t304.001,239.999 "},"children":[]}]};exports.arrowUpBig=arrowUpBig;var arrowUpBoldRound={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M0,256c0,141.391,114.609,256,256,256s256-114.609,256-256S397.391,0,256,0S0,114.609,0,256z M472,256\r\n\tc0,119.297-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40S472,136.703,472,256z"},"children":[]},{"name":"path","attribs":{"d":"M237.879,158.339l-89.594,154.175c-9.969,16.844-1.938,32.986,17.844,32.986h179.766c19.75,0,27.797-16.143,17.812-32.986\r\n\tl-89.578-152.955C264.16,142.652,247.848,141.448,237.879,158.339z"},"children":[]}]};exports.arrowUpBoldRound=arrowUpBoldRound;var arrowUpBold={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"144,342.5 368,342.5 256,150.5 "},"children":[]}]};exports.arrowUpBold=arrowUpBold;var arrowUpLight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M512,256C512,114.609,397.391,0,256,0S0,114.609,0,256s114.609,256,256,256\r\n\tS512,397.391,512,256z M40,256c0-119.297,96.703-216,216-216s216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"271.969,384 271.969,185.594 313.141,224 336,202.656 256,128 \r\n\t176,202.656 198.859,224 239.969,185.594 239.969,384 "},"children":[]}]};exports.arrowUpLight=arrowUpLight;var arrowUpThin={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M512,256C512,114.609,397.391,0,256,0S0,114.609,0,256s114.609,256,256,256S512,397.391,512,256z M40,256\r\n\t\tc0-119.297,96.703-216,216-216s216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256z"},"children":[{"name":"path","attribs":{"d":"M512,256C512,114.609,397.391,0,256,0S0,114.609,0,256s114.609,256,256,256S512,397.391,512,256z M40,256\r\n\t\tc0-119.297,96.703-216,216-216s216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M363.312,299.312c6.25-6.25,6.25-16.375,0-22.625l-96-96c-6.25-6.25-16.375-6.25-22.625,0l-96,96\r\n\t\tC145.562,279.812,144,283.906,144,288s1.562,8.188,4.688,11.312c6.25,6.25,16.375,6.25,22.625,0L256,214.625l84.688,84.688\r\n\t\tC346.938,305.562,357.062,305.562,363.312,299.312z"},"children":[{"name":"path","attribs":{"d":"M363.312,299.312c6.25-6.25,6.25-16.375,0-22.625l-96-96c-6.25-6.25-16.375-6.25-22.625,0l-96,96\r\n\t\tC145.562,279.812,144,283.906,144,288s1.562,8.188,4.688,11.312c6.25,6.25,16.375,6.25,22.625,0L256,214.625l84.688,84.688\r\n\t\tC346.938,305.562,357.062,305.562,363.312,299.312z"},"children":[]}]}]}]};exports.arrowUpThin=arrowUpThin;var arrowUp={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M512,256C512,114.609,397.391,0,256,0S0,114.609,0,256s114.609,256,256,256\r\n\tS512,397.391,512,256z M40,256c0-119.297,96.703-216,216-216s216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,286 256,174 144,286 176,318 256,238 336,318 "},"children":[]}]};exports.arrowUp=arrowUp;var atom={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,256c0-15.719-10.797-29.953-28.953-40.969c5.266-21.25,2.422-38.594-8.531-49.531\r\n\t\tc-7.297-7.312-17.78-11.156-30.297-11.156c-6.016,0-12.5,1.078-19.188,2.719C286,138.844,271.75,128,256,128\r\n\t\ts-30,10.844-41.031,29.062c-6.688-1.625-13.188-2.719-19.188-2.719c-12.531,0-23,3.859-30.297,11.156\r\n\t\tc-11.125,11.125-13.547,28.844-8.484,49.5c-18.188,11.031-29,25.266-29,41c0,15.733,10.812,29.969,29,41\r\n\t\tc-5.062,20.672-2.625,38.392,8.5,49.517c7.281,7.297,17.766,11.155,30.281,11.155c6.016,0,12.5-1.078,19.188-2.719\r\n\t\tC226,373.172,240.25,384,256,384s30-10.828,41.031-29.047c6.672,1.641,13.156,2.719,19.156,2.719\r\n\t\tc12.53,0,23.016-3.859,30.312-11.156c10.953-10.938,13.797-28.297,8.531-49.531C373.203,285.953,384,271.719,384,256z\r\n\t\t M288.969,176.312c5.344-2.047,10.562-3.672,15.484-4.625c4.094-0.812,8.078-1.344,11.766-1.344c8.312,0,14.688,2.172,18.984,6.469\r\n\t\tc6.188,6.172,7.891,17.062,5.156,30.75c-0.859,4.312-2.125,8.875-3.875,13.719c-0.203,0.562-0.562,1.188-0.781,1.75\r\n\t\tc-2.297,6-5.203,12.094-8.609,18.25c-2.703-3.719-5.344-7.438-8.344-11.109c-4.875-5.953-10.156-11.797-15.734-17.484\r\n\t\tc-0.625-0.625-1.141-1.312-1.766-1.938c-0.641-0.625-1.312-1.188-1.953-1.812c-5.734-5.625-11.625-10.812-17.594-15.688\r\n\t\tc-3.641-2.984-7.281-5.844-10.969-8.516C276.969,181.281,283.031,178.562,288.969,176.312z M318.203,256\r\n\t\tc-4.453,6.562-9.547,13.047-15.016,19.438c-4.188,4.906-8.531,9.781-13.25,14.5c-4.703,4.703-9.547,9.062-14.453,13.234\r\n\t\tc-6.422,5.484-12.953,10.469-19.5,14.922c-6.547-4.453-13.078-9.438-19.516-14.922c-4.875-4.172-9.719-8.516-14.406-13.219\r\n\t\tc-4.844-4.828-9.109-9.703-13.25-14.562c-5.531-6.516-10.594-12.983-14.906-19.391c4.312-6.391,9.375-12.875,14.906-19.375\r\n\t\tc4.141-4.875,8.406-9.75,13.25-14.562c4.688-4.719,9.531-9.062,14.438-13.25c6.422-5.469,12.953-10.438,19.484-14.891\r\n\t\tc6.547,4.453,13.062,9.422,19.484,14.891c4.906,4.188,9.767,8.547,14.47,13.25c4.719,4.719,9.062,9.594,13.25,14.5\r\n\t\tC308.656,242.969,313.75,249.469,318.203,256z M256,144c8.531,0,17.422,6.5,25.219,18.125c-8.234,3.281-16.688,7.594-25.219,12.781\r\n\t\tc-8.531-5.172-17-9.5-25.219-12.781C238.562,150.5,247.469,144,256,144z M176.797,176.812c4.297-4.281,10.672-6.469,18.984-6.469\r\n\t\tc3.688,0,7.656,0.531,11.766,1.344c4.922,0.969,10.141,2.594,15.484,4.625c5.922,2.266,11.984,4.969,18.219,8.422\r\n\t\tc-3.688,2.672-7.344,5.547-10.969,8.516c-5.969,4.875-11.844,10.031-17.578,15.656c-0.641,0.625-1.328,1.188-1.953,1.844\r\n\t\tc-0.656,0.641-1.25,1.312-1.891,1.969c-5.578,5.688-10.812,11.469-15.594,17.297c-2.984,3.641-5.766,7.297-8.438,10.969\r\n\t\tc-3.391-6.203-6.266-12.25-8.438-17.984c-2.047-5.438-3.641-10.656-4.594-15.5C169.078,193.766,170.75,182.844,176.797,176.812z\r\n\t\t M162.156,281.25C150.531,273.453,144,264.547,144,256c0-8.531,6.516-17.438,18.156-25.234c3.25,8.203,7.516,16.672,12.719,25.234\r\n\t\tC169.672,264.594,165.406,273.047,162.156,281.25z M223.031,335.703c-5.344,2.047-10.562,3.672-15.469,4.641\r\n\t\tc-4.109,0.797-8.078,1.328-11.781,1.328c-8.297,0-14.688-2.188-18.969-6.469c-6.047-6.047-7.719-16.953-5-30.703\r\n\t\tc0.953-4.828,2.531-10.047,4.594-15.5c2.156-5.719,5.047-11.766,8.422-17.969c2.672,3.672,5.453,7.328,8.453,10.969\r\n\t\tc4.766,5.828,10,11.594,15.562,17.281c0.656,0.656,1.25,1.328,1.906,1.984c0.641,0.641,1.312,1.202,1.969,1.844\r\n\t\tc5.719,5.608,11.594,10.781,17.531,15.641c3.656,2.984,7.312,5.859,11,8.531C235.031,330.734,228.969,333.438,223.031,335.703z\r\n\t\t M256,368c-8.531,0-17.422-6.5-25.203-18.109c8.219-3.281,16.672-7.608,25.188-12.797c8.531,5.203,16.984,9.531,25.219,12.812\r\n\t\tC273.422,361.5,264.531,368,256,368z M335.188,335.203c-4.297,4.297-10.688,6.469-19,6.469c-3.688,0-7.655-0.531-11.75-1.328\r\n\t\tc-4.922-0.969-10.125-2.594-15.483-4.641c-5.922-2.25-11.984-4.969-18.234-8.422c3.703-2.672,7.345-5.547,11-8.531\r\n\t\tc5.953-4.875,11.845-10.047,17.578-15.672c0.642-0.641,1.312-1.188,1.953-1.828c0.625-0.625,1.156-1.312,1.767-1.938\r\n\t\tc5.577-5.688,10.858-11.517,15.719-17.47c3-3.672,5.655-7.391,8.358-11.125c3.392,6.173,6.297,12.267,8.578,18.25\r\n\t\tc0.234,0.595,0.578,1.203,0.797,1.781c1.75,4.812,3,9.375,3.875,13.688C343.078,318.125,341.375,329.031,335.188,335.203z\r\n\t\t M349.75,281.297c-3.328-8.328-7.719-16.797-12.875-25.297c5.156-8.5,9.562-16.969,12.875-25.297\r\n\t\tC361.438,238.5,368,247.438,368,256C368,264.562,361.438,273.5,349.75,281.297z"},"children":[{"name":"path","attribs":{"d":"M384,256c0-15.719-10.797-29.953-28.953-40.969c5.266-21.25,2.422-38.594-8.531-49.531\r\n\t\tc-7.297-7.312-17.78-11.156-30.297-11.156c-6.016,0-12.5,1.078-19.188,2.719C286,138.844,271.75,128,256,128\r\n\t\ts-30,10.844-41.031,29.062c-6.688-1.625-13.188-2.719-19.188-2.719c-12.531,0-23,3.859-30.297,11.156\r\n\t\tc-11.125,11.125-13.547,28.844-8.484,49.5c-18.188,11.031-29,25.266-29,41c0,15.733,10.812,29.969,29,41\r\n\t\tc-5.062,20.672-2.625,38.392,8.5,49.517c7.281,7.297,17.766,11.155,30.281,11.155c6.016,0,12.5-1.078,19.188-2.719\r\n\t\tC226,373.172,240.25,384,256,384s30-10.828,41.031-29.047c6.672,1.641,13.156,2.719,19.156,2.719\r\n\t\tc12.53,0,23.016-3.859,30.312-11.156c10.953-10.938,13.797-28.297,8.531-49.531C373.203,285.953,384,271.719,384,256z\r\n\t\t M288.969,176.312c5.344-2.047,10.562-3.672,15.484-4.625c4.094-0.812,8.078-1.344,11.766-1.344c8.312,0,14.688,2.172,18.984,6.469\r\n\t\tc6.188,6.172,7.891,17.062,5.156,30.75c-0.859,4.312-2.125,8.875-3.875,13.719c-0.203,0.562-0.562,1.188-0.781,1.75\r\n\t\tc-2.297,6-5.203,12.094-8.609,18.25c-2.703-3.719-5.344-7.438-8.344-11.109c-4.875-5.953-10.156-11.797-15.734-17.484\r\n\t\tc-0.625-0.625-1.141-1.312-1.766-1.938c-0.641-0.625-1.312-1.188-1.953-1.812c-5.734-5.625-11.625-10.812-17.594-15.688\r\n\t\tc-3.641-2.984-7.281-5.844-10.969-8.516C276.969,181.281,283.031,178.562,288.969,176.312z M318.203,256\r\n\t\tc-4.453,6.562-9.547,13.047-15.016,19.438c-4.188,4.906-8.531,9.781-13.25,14.5c-4.703,4.703-9.547,9.062-14.453,13.234\r\n\t\tc-6.422,5.484-12.953,10.469-19.5,14.922c-6.547-4.453-13.078-9.438-19.516-14.922c-4.875-4.172-9.719-8.516-14.406-13.219\r\n\t\tc-4.844-4.828-9.109-9.703-13.25-14.562c-5.531-6.516-10.594-12.983-14.906-19.391c4.312-6.391,9.375-12.875,14.906-19.375\r\n\t\tc4.141-4.875,8.406-9.75,13.25-14.562c4.688-4.719,9.531-9.062,14.438-13.25c6.422-5.469,12.953-10.438,19.484-14.891\r\n\t\tc6.547,4.453,13.062,9.422,19.484,14.891c4.906,4.188,9.767,8.547,14.47,13.25c4.719,4.719,9.062,9.594,13.25,14.5\r\n\t\tC308.656,242.969,313.75,249.469,318.203,256z M256,144c8.531,0,17.422,6.5,25.219,18.125c-8.234,3.281-16.688,7.594-25.219,12.781\r\n\t\tc-8.531-5.172-17-9.5-25.219-12.781C238.562,150.5,247.469,144,256,144z M176.797,176.812c4.297-4.281,10.672-6.469,18.984-6.469\r\n\t\tc3.688,0,7.656,0.531,11.766,1.344c4.922,0.969,10.141,2.594,15.484,4.625c5.922,2.266,11.984,4.969,18.219,8.422\r\n\t\tc-3.688,2.672-7.344,5.547-10.969,8.516c-5.969,4.875-11.844,10.031-17.578,15.656c-0.641,0.625-1.328,1.188-1.953,1.844\r\n\t\tc-0.656,0.641-1.25,1.312-1.891,1.969c-5.578,5.688-10.812,11.469-15.594,17.297c-2.984,3.641-5.766,7.297-8.438,10.969\r\n\t\tc-3.391-6.203-6.266-12.25-8.438-17.984c-2.047-5.438-3.641-10.656-4.594-15.5C169.078,193.766,170.75,182.844,176.797,176.812z\r\n\t\t M162.156,281.25C150.531,273.453,144,264.547,144,256c0-8.531,6.516-17.438,18.156-25.234c3.25,8.203,7.516,16.672,12.719,25.234\r\n\t\tC169.672,264.594,165.406,273.047,162.156,281.25z M223.031,335.703c-5.344,2.047-10.562,3.672-15.469,4.641\r\n\t\tc-4.109,0.797-8.078,1.328-11.781,1.328c-8.297,0-14.688-2.188-18.969-6.469c-6.047-6.047-7.719-16.953-5-30.703\r\n\t\tc0.953-4.828,2.531-10.047,4.594-15.5c2.156-5.719,5.047-11.766,8.422-17.969c2.672,3.672,5.453,7.328,8.453,10.969\r\n\t\tc4.766,5.828,10,11.594,15.562,17.281c0.656,0.656,1.25,1.328,1.906,1.984c0.641,0.641,1.312,1.202,1.969,1.844\r\n\t\tc5.719,5.608,11.594,10.781,17.531,15.641c3.656,2.984,7.312,5.859,11,8.531C235.031,330.734,228.969,333.438,223.031,335.703z\r\n\t\t M256,368c-8.531,0-17.422-6.5-25.203-18.109c8.219-3.281,16.672-7.608,25.188-12.797c8.531,5.203,16.984,9.531,25.219,12.812\r\n\t\tC273.422,361.5,264.531,368,256,368z M335.188,335.203c-4.297,4.297-10.688,6.469-19,6.469c-3.688,0-7.655-0.531-11.75-1.328\r\n\t\tc-4.922-0.969-10.125-2.594-15.483-4.641c-5.922-2.25-11.984-4.969-18.234-8.422c3.703-2.672,7.345-5.547,11-8.531\r\n\t\tc5.953-4.875,11.845-10.047,17.578-15.672c0.642-0.641,1.312-1.188,1.953-1.828c0.625-0.625,1.156-1.312,1.767-1.938\r\n\t\tc5.577-5.688,10.858-11.517,15.719-17.47c3-3.672,5.655-7.391,8.358-11.125c3.392,6.173,6.297,12.267,8.578,18.25\r\n\t\tc0.234,0.595,0.578,1.203,0.797,1.781c1.75,4.812,3,9.375,3.875,13.688C343.078,318.125,341.375,329.031,335.188,335.203z\r\n\t\t M349.75,281.297c-3.328-8.328-7.719-16.797-12.875-25.297c5.156-8.5,9.562-16.969,12.875-25.297\r\n\t\tC361.438,238.5,368,247.438,368,256C368,264.562,361.438,273.5,349.75,281.297z"},"children":[]}]}]},{"name":"path","attribs":{"d":"M288,256c0,17.672-14.328,32-32,32c-17.656,0-32-14.328-32-32c0-17.656,14.344-32,32-32C273.672,224,288,238.344,288,256z"},"children":[]}]};exports.atom=atom;var axisRules={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 368,160 352,160 352,128 336,128 336,144 320,144 320,128 \r\n\t\t304,128 304,160 288,160 288,128 272,128 272,144 256,144 256,128 240,128 240,160 224,160 224,128 208,128 208,192 368,192 \r\n\t\t368,368 192,368 192,208 128,208 128,224 144,224 144,240 128,240 128,256 160,256 160,272 128,272 128,288 144,288 144,304 \r\n\t\t128,304 128,320 160,320 160,336 128,336 128,352 144,352 144,368 128,368 128,384 384,384 384,128 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 368,160 352,160 352,128 336,128 336,144 320,144 320,128 \r\n\t\t304,128 304,160 288,160 288,128 272,128 272,144 256,144 256,128 240,128 240,160 224,160 224,128 208,128 208,192 368,192 \r\n\t\t368,368 192,368 192,208 128,208 128,224 144,224 144,240 128,240 128,256 160,256 160,272 128,272 128,288 144,288 144,304 \r\n\t\t128,304 128,320 160,320 160,336 128,336 128,352 144,352 144,368 128,368 128,384 384,384 384,128 \t"},"children":[]}]}]}]};exports.axisRules=axisRules;var backward={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"336,336 336,176 240,256 \t"},"children":[{"name":"polygon","attribs":{"points":"336,336 336,176 240,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,256 240,336 240,256 240,176 \t"},"children":[{"name":"polygon","attribs":{"points":"144,256 240,336 240,256 240,176 \t"},"children":[]}]}]}]};exports.backward=backward;var bag={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,208.5h-16.5v160H368c8.844,0,15.5-7.656,15.5-16.5V224C383.5,215.156,376.844,208.5,368,208.5z"},"children":[{"name":"path","attribs":{"d":"M368,208.5h-16.5v160H368c8.844,0,15.5-7.656,15.5-16.5V224C383.5,215.156,376.844,208.5,368,208.5z"},"children":[]}]},{"name":"rect","attribs":{"x":"175.5","y":"208.5","width":"160","height":"160"},"children":[{"name":"rect","attribs":{"x":"175.5","y":"208.5","width":"160","height":"160"},"children":[]}]},{"name":"path","attribs":{"d":"M159.5,208.5H144c-8.836,0-16.5,6.656-16.5,15.5v128c0,8.844,7.664,16.5,16.5,16.5h15.5V208.5z"},"children":[{"name":"path","attribs":{"d":"M159.5,208.5H144c-8.836,0-16.5,6.656-16.5,15.5v128c0,8.844,7.664,16.5,16.5,16.5h15.5V208.5z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288,144.5h-64c-8.836,0-16.5,6.656-16.5,15.5v32.5h16V168c0-4.422,4.078-7.5,8.5-7.5h48c4.422,0,7.5,3.078,7.5,7.5v24.5\r\n\t\t\th16V160C303.5,151.156,296.844,144.5,288,144.5z"},"children":[{"name":"path","attribs":{"d":"M288,144.5h-64c-8.836,0-16.5,6.656-16.5,15.5v32.5h16V168c0-4.422,4.078-7.5,8.5-7.5h48c4.422,0,7.5,3.078,7.5,7.5v24.5\r\n\t\t\th16V160C303.5,151.156,296.844,144.5,288,144.5z"},"children":[]}]}]}]}]}]};exports.bag=bag;var banCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M165.5,165.484c-50,49.984-50,131.047,0,181.031c49.969,49.984,131.031,49.984,181.016,0s49.984-131.047,0-181.031\r\n\t\tS215.469,115.5,165.5,165.484z M188.125,188.109c33.547-33.547,85.844-36.781,123.297-10.172L177.938,311.422\r\n\t\tC151.344,273.969,154.562,221.656,188.125,188.109z M323.875,323.875c-33.547,33.562-85.828,36.781-123.297,10.172l133.469-133.484\r\n\t\tC360.656,238.031,357.438,290.328,323.875,323.875z"},"children":[{"name":"path","attribs":{"d":"M165.5,165.484c-50,49.984-50,131.047,0,181.031c49.969,49.984,131.031,49.984,181.016,0s49.984-131.047,0-181.031\r\n\t\tS215.469,115.5,165.5,165.484z M188.125,188.109c33.547-33.547,85.844-36.781,123.297-10.172L177.938,311.422\r\n\t\tC151.344,273.969,154.562,221.656,188.125,188.109z M323.875,323.875c-33.547,33.562-85.828,36.781-123.297,10.172l133.469-133.484\r\n\t\tC360.656,238.031,357.438,290.328,323.875,323.875z"},"children":[]}]}]}]};exports.banCircle=banCircle;var bars={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,368h32V144h-32V368z M192,368h32v-32h-32V368z M240,368h32V256h-32V368z\r\n\t\t\t M288,368h32V192h-32V368z M336,288v80h32v-80H336z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,368h32V144h-32V368z M192,368h32v-32h-32V368z M240,368h32V256h-32V368z\r\n\t\t\t M288,368h32V192h-32V368z M336,288v80h32v-80H336z"},"children":[]}]}]}]}]}]};exports.bars=bars;var bezier={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M368,288c0-61.75-50.25-112-112-112c-61.758,0-112,50.25-112,112h-16v48h48v-48h-16c0-52.938,43.062-96,96-96\r\n\ts96,43.062,96,96h-16v48h48v-48H368z M160,320h-16v-16h16V320z M368,320h-16v-16h16V320z"},"children":[]}]};exports.bezier=bezier;var blank={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]};exports.blank=blank;var blockMenu={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"151.5","y":"184.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[{"name":"rect","attribs":{"x":"151.5","y":"184.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"151.5","y":"248.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[{"name":"rect","attribs":{"x":"151.5","y":"248.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"151.5","y":"312.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[{"name":"rect","attribs":{"x":"151.5","y":"312.5","fill-rule":"evenodd","clip-rule":"evenodd","width":"192","height":"32"},"children":[]}]}]}]};exports.blockMenu=blockMenu;var bolt={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"208,271.5 251.203,271.5 208,383.688 304,239.5 261.656,239.5 304,127.688 "},"children":[]}]};exports.bolt=bolt;var boxAdd={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"271.5,160.5 351.5,160.5 351.5,240.5 383.5,240.5 383.5,128.5 271.5,128.5 \t\t"},"children":[{"name":"polygon","attribs":{"points":"271.5,160.5 351.5,160.5 351.5,240.5 383.5,240.5 383.5,128.5 271.5,128.5 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"159.5,240.5 159.5,160.5 239.5,160.5 239.5,128.5 127.5,128.5 127.5,240.5 \t\t"},"children":[{"name":"polygon","attribs":{"points":"159.5,240.5 159.5,160.5 239.5,160.5 239.5,128.5 127.5,128.5 127.5,240.5 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"239.5,352.5 159.5,352.5 159.5,272.5 127.5,272.5 127.5,384.5 239.5,384.5 \t\t"},"children":[{"name":"polygon","attribs":{"points":"239.5,352.5 159.5,352.5 159.5,272.5 127.5,272.5 127.5,384.5 239.5,384.5 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"351.5,272.5 351.5,352.5 271.5,352.5 271.5,384.5 383.5,384.5 383.5,272.5 \t\t"},"children":[{"name":"polygon","attribs":{"points":"351.5,272.5 351.5,352.5 271.5,352.5 271.5,384.5 383.5,384.5 383.5,272.5 \t\t"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"239.5","y":"192.5","width":"32","height":"128"},"children":[{"name":"rect","attribs":{"x":"239.5","y":"192.5","width":"32","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"191.5","y":"240.5","width":"128","height":"32"},"children":[{"name":"rect","attribs":{"x":"191.5","y":"240.5","width":"128","height":"32"},"children":[]}]}]}]};exports.boxAdd=boxAdd;var boxBlank={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t"},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t"},"children":[{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t"},"children":[{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t"},"children":[{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t"},"children":[]}]}]}]};exports.boxBlank=boxBlank;var boxClose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\t\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z\r\n\t\t"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\t\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z\r\n\t\t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t\t"},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t\t"},"children":[{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t\t"},"children":[{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t\t"},"children":[{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t\t"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"240.002","y":"192.008","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 256.0004 618.0388)","width":"31.997","height":"127.985"},"children":[{"name":"rect","attribs":{"x":"240.002","y":"192.008","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 256.0004 618.0388)","width":"31.997","height":"127.985"},"children":[]}]},{"name":"rect","attribs":{"x":"192.008","y":"240.002","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 256.0034 618.0388)","width":"127.985","height":"31.997"},"children":[{"name":"rect","attribs":{"x":"192.008","y":"240.002","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 256.0034 618.0388)","width":"127.985","height":"31.997"},"children":[]}]}]}]};exports.boxClose=boxClose;var boxRemove={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t"},"children":[{"name":"polygon","attribs":{"points":"272,160 352,160 352,240 384,240 384,128 272,128 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t"},"children":[{"name":"polygon","attribs":{"points":"160,240 160,160 240,160 240,128 128,128 128,240 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t"},"children":[{"name":"polygon","attribs":{"points":"240,352 160,352 160,272 128,272 128,384 240,384 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t"},"children":[{"name":"polygon","attribs":{"points":"352,272 352,352 272,352 272,384 384,384 384,272 \t"},"children":[]}]}]},{"name":"rect","attribs":{"x":"192","y":"240","width":"128","height":"32"},"children":[]}]};exports.boxRemove=boxRemove;var browserSizes={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"96"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"336","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"368","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"192"},"children":[{"name":"rect","attribs":{"x":"368","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"192"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"160","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"192"},"children":[{"name":"rect","attribs":{"x":"128","y":"160","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"192"},"children":[]}]}]}]};exports.browserSizes=browserSizes;var brush={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M223.07,317.875c20.578-15.703,48.273-41.188,77.195-71.852c53.297-56.531,90.359-108.906,82.734-116.969\r\n\tc-7.609-8.094-57,31.188-110.328,87.719c-29.68,31.469-54.281,61.633-68.969,83.602c-7.141,0.391-35.023,3.75-39.617,32.531\r\n\tc0,0-19.016,48.188-33.75,50.297c-14.586,2.109,43.75-0.312,51.328-3.047C189.148,377.469,227.25,374.234,223.07,317.875z"},"children":[]}]};exports.brush=brush;var buttonAdd={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-70.695,0-128,57.312-128,128s57.305,128,128,128\r\n\tc70.688,0,128-57.312,128-128S326.688,128,256,128z M320,272h-48v48h-32v-48h-48v-32h48v-48h32v48h48V272z"},"children":[]}]};exports.buttonAdd=buttonAdd;var buttonCheck={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M240,320l-48-48\r\n\tl22.398-25.594L240,272l72-80l24,25.594L240,320z"},"children":[]}]};exports.buttonCheck=buttonCheck;var buttonClose={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-70.695,0-128,57.312-128,128s57.305,128,128,128\r\n\tc70.688,0,128-57.312,128-128S326.688,128,256,128z M312.562,289.938l-22.625,22.625L256,278.625l-33.938,33.938l-22.633-22.625\r\n\tL233.367,256l-33.938-33.938l22.633-22.625L256,233.375l33.938-33.938l22.625,22.625L278.625,256L312.562,289.938z"},"children":[]}]};exports.buttonClose=buttonClose;var buttonEmail={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M259.203,231.438c-3.391,0-6.734,1.062-10.078,3.234c-3.312,2.156-6.312,4.891-8.938,8.188\r\n\t\tc-2.625,3.312-4.75,6.891-6.312,10.781c-1.578,3.922-2.359,7.609-2.359,11.094c0,2.156,0.297,4.281,0.844,6.391\r\n\t\tc0.578,2.125,1.453,4,2.672,5.656c1.172,1.703,2.703,3.062,4.594,4.078c1.875,1.016,4.156,1.516,6.781,1.516\r\n\t\tc4.75,0,9.344-1.594,13.719-4.75c4.391-3.219,7.625-7.75,9.609-13.625c1.016-3.109,1.797-5.688,2.344-7.734\r\n\t\tc0.547-2.031,1.031-3.688,1.312-4.953c0.359-1.25,0.516-2.203,0.547-2.875c0.094-0.672,0.109-1.234,0.109-1.703\r\n\t\tc0-4.562-1.438-8.25-4.312-11.062C266.844,232.828,263.328,231.438,259.203,231.438z"},"children":[{"name":"path","attribs":{"d":"M259.203,231.438c-3.391,0-6.734,1.062-10.078,3.234c-3.312,2.156-6.312,4.891-8.938,8.188\r\n\t\tc-2.625,3.312-4.75,6.891-6.312,10.781c-1.578,3.922-2.359,7.609-2.359,11.094c0,2.156,0.297,4.281,0.844,6.391\r\n\t\tc0.578,2.125,1.453,4,2.672,5.656c1.172,1.703,2.703,3.062,4.594,4.078c1.875,1.016,4.156,1.516,6.781,1.516\r\n\t\tc4.75,0,9.344-1.594,13.719-4.75c4.391-3.219,7.625-7.75,9.609-13.625c1.016-3.109,1.797-5.688,2.344-7.734\r\n\t\tc0.547-2.031,1.031-3.688,1.312-4.953c0.359-1.25,0.516-2.203,0.547-2.875c0.094-0.672,0.109-1.234,0.109-1.703\r\n\t\tc0-4.562-1.438-8.25-4.312-11.062C266.844,232.828,263.328,231.438,259.203,231.438z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128c-70.703,0-128,57.312-128,128s57.297,128,128,128c70.688,0,128-57.312,128-128S326.688,128,256,128z\r\n\t\t M316.328,265.109c-2.453,6-5.719,11.031-9.781,15.125c-4.062,4.047-8.734,7.141-13.953,9.156\r\n\t\tc-5.203,2.078-10.578,3.094-16.078,3.094c-3.266,0-5.875-1-7.828-2.984c-1.953-2-3.031-4.375-3.281-7.125\r\n\t\tc-2.625,3.609-5.594,6.156-8.828,7.75c-3.297,1.531-7.109,2.359-11.484,2.359c-4.031,0-7.641-0.766-10.844-2.266\r\n\t\tc-3.188-1.484-5.875-3.484-8.094-5.969c-2.172-2.406-3.875-5.25-5.094-8.359c-1.188-3.125-1.781-6.281-1.781-9.516\r\n\t\tc0-5.312,1-10.625,2.938-16.062c1.953-5.375,4.641-10.266,8.094-14.641c3.438-4.375,7.609-7.969,12.5-10.734\r\n\t\tc4.906-2.75,10.312-4.125,16.188-4.125c2.891,0,5.469,0.484,7.719,1.438s4.156,2.125,5.75,3.5c1.562,1.375,2.875,2.797,3.938,4.25\r\n\t\tc1.047,1.438,1.812,2.938,2.188,4.016L282.375,224h11.484l-14.719,48.531c-0.641,2.188-0.922,3.812-0.922,5.109\r\n\t\tc0,2.984,1.203,4.438,3.766,4.438c1.484,0,3.703-0.453,6.672-1.391c2.922-0.906,5.906-2.703,8.906-5.422\r\n\t\tc3.016-2.656,5.641-6.391,7.938-11.141c2.25-4.75,3.406-11.016,3.406-18.828c0-6.359-1.312-12.172-3.938-17.484\r\n\t\tc-2.703-5.25-6.234-9.812-10.688-13.578c-4.453-3.797-9.547-6.734-15.312-8.812c-5.75-2.109-11.75-3.172-17.891-3.172\r\n\t\tc-8.141,0-15.719,1.438-22.672,4.25c-6.969,2.812-13.047,6.75-18.25,11.797c-5.219,5.016-9.281,11.016-12.25,17.906\r\n\t\tc-2.938,6.906-4.422,14.359-4.422,22.422c0,7.656,1.516,14.656,4.625,20.969c3.078,6.281,7.141,11.656,12.234,16.125\r\n\t\tc5.078,4.422,10.906,7.812,17.5,10.25c6.594,2.406,13.438,3.625,20.594,3.625c9.672,0,18.188-2.391,25.516-6.109\r\n\t\tC291.281,299.734,297.156,288,301.5,288H313c-2.109,0-5.141,10.359-9.078,14.219c-4,3.859-8.484,7.281-13.578,9.875\r\n\t\tc-5.078,2.562-10.578,4.656-16.562,5.906c-5.969,1.25-12.031,1.938-18.156,1.938c-8.172,0-16.078-1.469-23.719-4.469\r\n\t\tc-7.656-3-14.438-7.203-20.312-12.594c-5.906-5.391-10.656-11.797-14.234-19.266c-3.547-7.406-5.359-15.578-5.359-24.484\r\n\t\tc0-10.312,1.891-19.609,5.656-27.875c3.75-8.297,8.812-15.328,15.156-21.141c6.344-5.844,13.656-10.312,22.016-13.422\r\n\t\tc8.359-3.125,17.141-4.688,26.453-4.688c7.516,0,14.828,1.297,21.906,3.875c7.078,2.562,13.344,6.188,18.812,10.797\r\n\t\tc5.469,4.641,9.812,10.141,13.078,16.578c3.266,6.391,4.922,13.438,4.922,21.141C320,252.188,318.734,259.078,316.328,265.109z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.703,0-128,57.312-128,128s57.297,128,128,128c70.688,0,128-57.312,128-128S326.688,128,256,128z\r\n\t\t M316.328,265.109c-2.453,6-5.719,11.031-9.781,15.125c-4.062,4.047-8.734,7.141-13.953,9.156\r\n\t\tc-5.203,2.078-10.578,3.094-16.078,3.094c-3.266,0-5.875-1-7.828-2.984c-1.953-2-3.031-4.375-3.281-7.125\r\n\t\tc-2.625,3.609-5.594,6.156-8.828,7.75c-3.297,1.531-7.109,2.359-11.484,2.359c-4.031,0-7.641-0.766-10.844-2.266\r\n\t\tc-3.188-1.484-5.875-3.484-8.094-5.969c-2.172-2.406-3.875-5.25-5.094-8.359c-1.188-3.125-1.781-6.281-1.781-9.516\r\n\t\tc0-5.312,1-10.625,2.938-16.062c1.953-5.375,4.641-10.266,8.094-14.641c3.438-4.375,7.609-7.969,12.5-10.734\r\n\t\tc4.906-2.75,10.312-4.125,16.188-4.125c2.891,0,5.469,0.484,7.719,1.438s4.156,2.125,5.75,3.5c1.562,1.375,2.875,2.797,3.938,4.25\r\n\t\tc1.047,1.438,1.812,2.938,2.188,4.016L282.375,224h11.484l-14.719,48.531c-0.641,2.188-0.922,3.812-0.922,5.109\r\n\t\tc0,2.984,1.203,4.438,3.766,4.438c1.484,0,3.703-0.453,6.672-1.391c2.922-0.906,5.906-2.703,8.906-5.422\r\n\t\tc3.016-2.656,5.641-6.391,7.938-11.141c2.25-4.75,3.406-11.016,3.406-18.828c0-6.359-1.312-12.172-3.938-17.484\r\n\t\tc-2.703-5.25-6.234-9.812-10.688-13.578c-4.453-3.797-9.547-6.734-15.312-8.812c-5.75-2.109-11.75-3.172-17.891-3.172\r\n\t\tc-8.141,0-15.719,1.438-22.672,4.25c-6.969,2.812-13.047,6.75-18.25,11.797c-5.219,5.016-9.281,11.016-12.25,17.906\r\n\t\tc-2.938,6.906-4.422,14.359-4.422,22.422c0,7.656,1.516,14.656,4.625,20.969c3.078,6.281,7.141,11.656,12.234,16.125\r\n\t\tc5.078,4.422,10.906,7.812,17.5,10.25c6.594,2.406,13.438,3.625,20.594,3.625c9.672,0,18.188-2.391,25.516-6.109\r\n\t\tC291.281,299.734,297.156,288,301.5,288H313c-2.109,0-5.141,10.359-9.078,14.219c-4,3.859-8.484,7.281-13.578,9.875\r\n\t\tc-5.078,2.562-10.578,4.656-16.562,5.906c-5.969,1.25-12.031,1.938-18.156,1.938c-8.172,0-16.078-1.469-23.719-4.469\r\n\t\tc-7.656-3-14.438-7.203-20.312-12.594c-5.906-5.391-10.656-11.797-14.234-19.266c-3.547-7.406-5.359-15.578-5.359-24.484\r\n\t\tc0-10.312,1.891-19.609,5.656-27.875c3.75-8.297,8.812-15.328,15.156-21.141c6.344-5.844,13.656-10.312,22.016-13.422\r\n\t\tc8.359-3.125,17.141-4.688,26.453-4.688c7.516,0,14.828,1.297,21.906,3.875c7.078,2.562,13.344,6.188,18.812,10.797\r\n\t\tc5.469,4.641,9.812,10.141,13.078,16.578c3.266,6.391,4.922,13.438,4.922,21.141C320,252.188,318.734,259.078,316.328,265.109z"},"children":[]}]}]}]};exports.buttonEmail=buttonEmail;var buttonExclamation={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256-2C114.609-2,0,112.609,0,254s114.609,256,256,256s256-114.609,256-256S397.391-2,256-2z M256,470\r\n\tc-119.297,0-216-96.703-216-216S136.703,38,256,38s216,96.703,216,216S375.297,470,256,470z"},"children":[]},{"name":"path","attribs":{"d":"M256,126c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,126,256,126z M256,318\r\n\tc-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,318,256,318z M264,270h-16l-8-80h32L264,270z"},"children":[]}]};exports.buttonExclamation=buttonExclamation;var buttonMinus={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-70.695,0-128,57.312-128,128s57.305,128,128,128\r\n\tc70.688,0,128-57.312,128-128S326.688,128,256,128z M320,272H192v-32h128V272z"},"children":[]}]};exports.buttonMinus=buttonMinus;var buttonQuestion={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M251.375,322\r\n\tc-10.172,0-17.078-7.484-17.078-17.469c0-10.344,7.094-17.453,17.078-17.453c10.344,0,17.062,7.109,17.281,17.453\r\n\tC268.656,314.516,261.938,322,251.375,322z M278.188,250.422c-6.906,7.859-6.188,15.359-6.188,23.984V272h-32.719l-0.188-2.062\r\n\tc-0.578-9.781,2.688-18.297,11.312-28.469c6.156-7.484,11.125-13.078,11.125-19.422c0-6.703-4.406-10.953-14-11.141\r\n\tc-6.328,0-14,2.484-19,5.938l-6.516-20.812c7.094-4.031,18.422-7.828,32.047-7.828c25.312,0,38.828,14.016,38.828,29.953\r\n\tC292.891,232.75,285.469,242.375,278.188,250.422z"},"children":[]}]};exports.buttonQuestion=buttonQuestion;var camera={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,224c-26.508,0-48,21.5-48,48c0,26.516,21.492,48,48,48c26.516,0,48-21.484,48-48C304,245.5,282.516,224,256,224z"},"children":[{"name":"path","attribs":{"d":"M256,224c-26.508,0-48,21.5-48,48c0,26.516,21.492,48,48,48c26.516,0,48-21.484,48-48C304,245.5,282.516,224,256,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,192h-71.922c-3.641,0-7.312-14.547-8.078-16.078c-1.594-3.203-7.156-15.922-16-15.922h-32\r\n\t\tc-8.836,0-14.398,12.719-16,15.922c-0.766,1.531-4.438,16.078-8.078,16.078H144c-8.836,0-16,7.234-16,16.062v128.016\r\n\t\tc0,8.844,7.164,15.922,16,15.922h224c8.844,0,16-7.078,16-15.922V208.062C384,199.234,376.844,192,368,192z M256,336\r\n\t\tc-35.336,0-64-28.641-64-64c0-35.344,28.664-64,64-64c35.359,0,64,28.656,64,64C320,307.359,291.359,336,256,336z"},"children":[{"name":"path","attribs":{"d":"M368,192h-71.922c-3.641,0-7.312-14.547-8.078-16.078c-1.594-3.203-7.156-15.922-16-15.922h-32\r\n\t\tc-8.836,0-14.398,12.719-16,15.922c-0.766,1.531-4.438,16.078-8.078,16.078H144c-8.836,0-16,7.234-16,16.062v128.016\r\n\t\tc0,8.844,7.164,15.922,16,15.922h224c8.844,0,16-7.078,16-15.922V208.062C384,199.234,376.844,192,368,192z M256,336\r\n\t\tc-35.336,0-64-28.641-64-64c0-35.344,28.664-64,64-64c35.359,0,64,28.656,64,64C320,307.359,291.359,336,256,336z"},"children":[]}]}]}]};exports.camera=camera;var cdDvdRom={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,320\r\n\t\tc-35.344,0-64-28.688-64-64c0-35.344,28.656-64,64-64c35.312,0,64,28.656,64,64C320,291.312,291.312,320,256,320z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,320\r\n\t\tc-35.344,0-64-28.688-64-64c0-35.344,28.656-64,64-64c35.312,0,64,28.656,64,64C320,291.312,291.312,320,256,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,218c-20.953,0-38,17.047-38,38s17.047,38,38,38s38-17.047,38-38S276.953,218,256,218z M256,272\r\n\t\tc-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[{"name":"path","attribs":{"d":"M256,218c-20.953,0-38,17.047-38,38s17.047,38,38,38s38-17.047,38-38S276.953,218,256,218z M256,272\r\n\t\tc-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[]}]}]}]};exports.cdDvdRom=cdDvdRom;var chartDown={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M383.5,136.5c0-4.418-3.582-8-8-8h-240c-4.418,0-8,3.582-8,8v240c0,4.418,3.582,8,8,8h240c4.418,0,8-3.582,8-8V136.5z\r\n\t M367.5,360.5c0,4.418-3.582,8-8,8h-208c-4.418,0-8-3.582-8-8v-208c0-4.418,3.582-8,8-8h208c4.418,0,8,3.582,8,8V360.5z"},"children":[]},{"name":"path","attribs":{"d":"M321.562,287.578L276.297,192l-48.469,51.188L186.922,200L176,211.547l51.828,54.719l44.234-46.719l35.734,75.438\r\n\tc-1.578,2.562-2.703,5.422-2.703,8.688c0,9.031,6.906,16.328,15.453,16.328S336,312.703,336,303.672\r\n\tC336,295.031,329.594,288.156,321.562,287.578z"},"children":[]}]};exports.chartDown=chartDown;var chat={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M384,207.828C384,163.75,341.016,128,288,128c-53,0-96,35.75-96,79.828c0,44.094,43,79.828,96,79.828\r\n\t\tc17.484,0,38.406-7.766,38.406-7.766l52.812,24.062l-11.234-51.281C367.984,252.672,384,227.344,384,207.828z M327.062,262.594\r\n\t\tl-6.219,2.281c-5.094,1.875-20.953,6.766-32.844,6.766c-44.109,0-80-28.625-80-63.812s35.891-63.812,80-63.812\r\n\t\ts79.984,28.625,79.984,63.812c0,10.734-8.266,27.953-13.516,36.297l-3.5,5.547l5.781,26.453L327.062,262.594z"},"children":[{"name":"path","attribs":{"d":"M384,207.828C384,163.75,341.016,128,288,128c-53,0-96,35.75-96,79.828c0,44.094,43,79.828,96,79.828\r\n\t\tc17.484,0,38.406-7.766,38.406-7.766l52.812,24.062l-11.234-51.281C367.984,252.672,384,227.344,384,207.828z M327.062,262.594\r\n\t\tl-6.219,2.281c-5.094,1.875-20.953,6.766-32.844,6.766c-44.109,0-80-28.625-80-63.812s35.891-63.812,80-63.812\r\n\t\ts79.984,28.625,79.984,63.812c0,10.734-8.266,27.953-13.516,36.297l-3.5,5.547l5.781,26.453L327.062,262.594z"},"children":[]}]},{"name":"path","attribs":{"d":"M224,351.688c-11.891,0-27.75-4.891-32.859-6.766l-6.172-2.281l-29.719,13.531l5.781-26.453l-3.5-5.547\r\n\t\tC152.297,315.844,144,298.609,144,287.875c0-22.375,14.578-42.016,36.5-53.406c-1.75-5.188-3.062-10.531-3.781-16.016\r\n\t\tC147.656,232.156,128,258.094,128,287.875c0,19.5,16,44.844,16,44.844L132.781,384l52.812-24.062c0,0,20.922,7.766,38.406,7.766\r\n\t\tc48.422,0,88.375-30.266,94.938-68.734c-5,1.344-10.953,2.641-17.266,3.547C293.312,330.641,261.781,351.688,224,351.688z"},"children":[{"name":"path","attribs":{"d":"M224,351.688c-11.891,0-27.75-4.891-32.859-6.766l-6.172-2.281l-29.719,13.531l5.781-26.453l-3.5-5.547\r\n\t\tC152.297,315.844,144,298.609,144,287.875c0-22.375,14.578-42.016,36.5-53.406c-1.75-5.188-3.062-10.531-3.781-16.016\r\n\t\tC147.656,232.156,128,258.094,128,287.875c0,19.5,16,44.844,16,44.844L132.781,384l52.812-24.062c0,0,20.922,7.766,38.406,7.766\r\n\t\tc48.422,0,88.375-30.266,94.938-68.734c-5,1.344-10.953,2.641-17.266,3.547C293.312,330.641,261.781,351.688,224,351.688z"},"children":[]}]}]}]};exports.chat=chat;var check={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"211.344,306.703 160,256 128,288 211.414,368 384,176 351.703,144 "},"children":[]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]};exports.check=check;var circles={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,128c-53.016,0-96,42.984-96,96c0,0.531,0.047,1.047,0.062,1.609C155.531,232.984,128,265.266,128,304\r\n\t\tc0,44.188,35.797,80,80,80c38.719,0,71.016-27.531,78.422-64.094c0.531,0.016,1.047,0.094,1.578,0.094c53.016,0,96-42.984,96-96\r\n\t\tS341.016,128,288,128z M208,368c-35.281,0-64-28.719-64-64c0-30.359,21.281-55.734,49.719-62.25\r\n\t\tc7.25,38.766,37.766,69.281,76.531,76.531C263.719,346.719,238.344,368,208,368z M209.672,240.156\r\n\t\tc33.906,0.875,61.297,28.234,62.156,62.203C240.688,295.922,216.047,271.344,209.672,240.156z M288,304c0-44.172-35.797-80-80-80\r\n\t\tc0-44.109,35.906-80,80-80s80,35.891,80,80S332.094,304,288,304z"},"children":[{"name":"path","attribs":{"d":"M288,128c-53.016,0-96,42.984-96,96c0,0.531,0.047,1.047,0.062,1.609C155.531,232.984,128,265.266,128,304\r\n\t\tc0,44.188,35.797,80,80,80c38.719,0,71.016-27.531,78.422-64.094c0.531,0.016,1.047,0.094,1.578,0.094c53.016,0,96-42.984,96-96\r\n\t\tS341.016,128,288,128z M208,368c-35.281,0-64-28.719-64-64c0-30.359,21.281-55.734,49.719-62.25\r\n\t\tc7.25,38.766,37.766,69.281,76.531,76.531C263.719,346.719,238.344,368,208,368z M209.672,240.156\r\n\t\tc33.906,0.875,61.297,28.234,62.156,62.203C240.688,295.922,216.047,271.344,209.672,240.156z M288,304c0-44.172-35.797-80-80-80\r\n\t\tc0-44.109,35.906-80,80-80s80,35.891,80,80S332.094,304,288,304z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,224c17.656,0,32-14.344,32-32s-14.344-32-32-32s-32,14.344-32,32S142.344,224,160,224z M160,176\r\n\t\tc8.812,0,16,7.188,16,16s-7.188,16-16,16s-16-7.188-16-16S151.188,176,160,176z"},"children":[{"name":"path","attribs":{"d":"M160,224c17.656,0,32-14.344,32-32s-14.344-32-32-32s-32,14.344-32,32S142.344,224,160,224z M160,176\r\n\t\tc8.812,0,16,7.188,16,16s-7.188,16-16,16s-16-7.188-16-16S151.188,176,160,176z"},"children":[]}]}]}]};exports.circles=circles;var clock={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,360\r\n\t\tc-57.438,0-104-46.578-104-104c0-57.438,46.562-104,104-104c57.422,0,104,46.562,104,104C360,313.422,313.422,360,256,360z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M256,360\r\n\t\tc-57.438,0-104-46.578-104-104c0-57.438,46.562-104,104-104c57.422,0,104,46.562,104,104C360,313.422,313.422,360,256,360z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,272c-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[{"name":"path","attribs":{"d":"M256,272c-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S264.844,272,256,272z"},"children":[]}]},{"name":"polygon","attribs":{"points":"246.062,257.375 257.375,246.062 294.75,283.422 283.438,294.75 \t"},"children":[{"name":"polygon","attribs":{"points":"246.062,257.375 257.375,246.062 294.75,283.422 283.438,294.75 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"192.469,203.781 203.781,192.453 265.953,254.625 254.625,265.938 \t"},"children":[{"name":"polygon","attribs":{"points":"192.469,203.781 203.781,192.453 265.953,254.625 254.625,265.938 \t"},"children":[]}]}]}]};exports.clock=clock;var cloudAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M336,336h-16v16h-16v-16h-16\r\n\t\tv-16h16v-16h16v16h16V336z"},"children":[{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M336,336h-16v16h-16v-16h-16\r\n\t\tv-16h16v-16h16v16h16V336z"},"children":[]}]}]}]};exports.cloudAdd=cloudAdd;var cloudDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M312,358.406L292.797,336H304\r\n\t\tv-32h16v32h11.203L312,358.406z"},"children":[{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M312,358.406L292.797,336H304\r\n\t\tv-32h16v32h11.203L312,358.406z"},"children":[]}]}]}]};exports.cloudDownload=cloudDownload;var cloudRemove={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M336,336h-48v-16h48V336z"},"children":[{"name":"path","attribs":{"d":"M312,288c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S334.094,288,312,288z M336,336h-48v-16h48V336z"},"children":[]}]}]}]};exports.cloudRemove=cloudRemove;var cloudUpload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[{"name":"path","attribs":{"d":"M358.719,240.734C364.484,231.125,368,220.016,368,208c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,181.742,221.625,176,208,176c-26.5,0-48,21.492-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h101.594c9-32,28.094-40,50.406-40c21.656,0,40.219,8.406,49.531,26.391\r\n\t\tC374.516,302.312,384,288.328,384,274C384,258.641,373.156,243.828,358.719,240.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M312,368c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S289.906,368,312,368z M312,297.594L331.203,320H320\r\n\t\tv32h-16v-32h-11.203L312,297.594z"},"children":[{"name":"path","attribs":{"d":"M312,368c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S289.906,368,312,368z M312,297.594L331.203,320H320\r\n\t\tv32h-16v-32h-11.203L312,297.594z"},"children":[]}]}]}]};exports.cloudUpload=cloudUpload;var cloud={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M358.719,272.734C364.484,263.125,368,252.016,368,240c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,213.75,221.625,208,208,208c-26.5,0-48,21.5-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h192c17.672,0,32-22.328,32-40C384,296.641,373.156,275.828,358.719,272.734z"},"children":[{"name":"path","attribs":{"d":"M358.719,272.734C364.484,263.125,368,252.016,368,240c0-35.344-28.656-64-64-64c-29.375,0-53.859,19.906-61.391,46.875\r\n\t\tC233.875,213.75,221.625,208,208,208c-26.5,0-48,21.5-48,48c0,5.75,1.188,11.203,3.031,16.312c-1-0.094-2-0.312-3.031-0.312\r\n\t\tc-17.672,0-32,22.328-32,40s14.328,40,32,40h192c17.672,0,32-22.328,32-40C384,296.641,373.156,275.828,358.719,272.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.cloud=cloud;var coins={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,336.219c-30.031,0-61.438-6.328-79.844-19.703c0,0.219-0.156,0.438-0.156,0.641c0,3.359,0,15.719,0,19.062\r\n\t\tC176,353.781,211.812,368,256,368s80-14.219,80-31.781c0-3.344,0-15.703,0-19.062c0-0.203-0.156-0.422-0.156-0.641\r\n\t\tC317.438,329.891,286.016,336.219,256,336.219z"},"children":[{"name":"path","attribs":{"d":"M256,336.219c-30.031,0-61.438-6.328-79.844-19.703c0,0.219-0.156,0.438-0.156,0.641c0,3.359,0,15.719,0,19.062\r\n\t\tC176,353.781,211.812,368,256,368s80-14.219,80-31.781c0-3.344,0-15.703,0-19.062c0-0.203-0.156-0.422-0.156-0.641\r\n\t\tC317.438,329.891,286.016,336.219,256,336.219z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,288.547c-30.031,0-61.438-6.312-79.844-19.688c0,0.219-0.156,0.422-0.156,0.641c0,3.359,0,15.703,0,19.047\r\n\t\tc0,17.562,35.812,31.797,80,31.797s80-14.234,80-31.797c0-3.344,0-15.688,0-19.047c0-0.219-0.156-0.422-0.156-0.641\r\n\t\tC317.438,282.234,286.016,288.547,256,288.547z"},"children":[{"name":"path","attribs":{"d":"M256,288.547c-30.031,0-61.438-6.312-79.844-19.688c0,0.219-0.156,0.422-0.156,0.641c0,3.359,0,15.703,0,19.047\r\n\t\tc0,17.562,35.812,31.797,80,31.797s80-14.234,80-31.797c0-3.344,0-15.688,0-19.047c0-0.219-0.156-0.422-0.156-0.641\r\n\t\tC317.438,282.234,286.016,288.547,256,288.547z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,222.656c0,4.031,0,15.078,0,18.25c0,17.562,35.812,31.781,80,31.781s80-14.219,80-31.781c0-3.172,0-14.219,0-18.25\r\n\t\tc-18.375,13.469-49.891,19.844-80,19.844S194.375,236.125,176,222.656z"},"children":[{"name":"path","attribs":{"d":"M176,222.656c0,4.031,0,15.078,0,18.25c0,17.562,35.812,31.781,80,31.781s80-14.219,80-31.781c0-3.172,0-14.219,0-18.25\r\n\t\tc-18.375,13.469-49.891,19.844-80,19.844S194.375,236.125,176,222.656z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,144c-44.188,0-80,14.219-80,31.781c0,3.344,0,15.703,0,19.062c0,17.531,35.812,31.766,80,31.766s80-14.234,80-31.766\r\n\t\tc0-3.359,0-15.719,0-19.062C336,158.219,300.188,144,256,144z"},"children":[{"name":"path","attribs":{"d":"M256,144c-44.188,0-80,14.219-80,31.781c0,3.344,0,15.703,0,19.062c0,17.531,35.812,31.766,80,31.766s80-14.234,80-31.766\r\n\t\tc0-3.359,0-15.719,0-19.062C336,158.219,300.188,144,256,144z"},"children":[]}]}]}]};exports.coins=coins;var comment={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,160c-61.859,0-112,37.383-112,83.469c0,20.531,15.547,43.906,32,58.453L160,352l48.625-32.953\r\n\t\tc14.406,5.031,30.406,7.906,47.375,7.906c61.859,0,112-37.359,112-83.484C368,197.383,317.859,160,256,160z"},"children":[{"name":"path","attribs":{"d":"M256,160c-61.859,0-112,37.383-112,83.469c0,20.531,15.547,43.906,32,58.453L160,352l48.625-32.953\r\n\t\tc14.406,5.031,30.406,7.906,47.375,7.906c61.859,0,112-37.359,112-83.484C368,197.383,317.859,160,256,160z"},"children":[]}]}]}]};exports.comment=comment;var comments={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M310.875,254.734c-40.438,0-73.172,22.078-73.172,49.234c0,12.094,10.172,25.875,20.922,34.469L248.188,368l31.703-19.469\r\n\t\tc9.453,2.969,19.891,4.656,30.984,4.656c40.391,0,73.125-22,73.125-49.219C384,276.812,351.266,254.734,310.875,254.734z"},"children":[{"name":"path","attribs":{"d":"M310.875,254.734c-40.438,0-73.172,22.078-73.172,49.234c0,12.094,10.172,25.875,20.922,34.469L248.188,368l31.703-19.469\r\n\t\tc9.453,2.969,19.891,4.656,30.984,4.656c40.391,0,73.125-22,73.125-49.219C384,276.812,351.266,254.734,310.875,254.734z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,144c-70.688,0-128,40.234-128,89.891c0,22.062,17.781,47.234,36.562,62.922l-18.266,53.969l55.547-35.562\r\n\t\tc7.25,2.375,14.938,4.25,22.844,5.656c-3.234-6.344-5.25-12.938-5.25-19.125c0-35.484,40.938-64.219,91.438-64.219\r\n\t\tc27.062,0,51.188,8.422,67.938,21.578c3.312-8,5.188-16.469,5.188-25.219C384,184.234,326.688,144,256,144z"},"children":[{"name":"path","attribs":{"d":"M256,144c-70.688,0-128,40.234-128,89.891c0,22.062,17.781,47.234,36.562,62.922l-18.266,53.969l55.547-35.562\r\n\t\tc7.25,2.375,14.938,4.25,22.844,5.656c-3.234-6.344-5.25-12.938-5.25-19.125c0-35.484,40.938-64.219,91.438-64.219\r\n\t\tc27.062,0,51.188,8.422,67.938,21.578c3.312-8,5.188-16.469,5.188-25.219C384,184.234,326.688,144,256,144z"},"children":[]}]}]}]};exports.comments=comments;var compass2={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-70.695,0-128,57.312-128,128s57.305,128,128,128c70.688,0,128-57.312,128-128S326.688,128,256,128z M256,368\r\n\t\tc-61.758,0-112-50.25-112-112s50.242-112,112-112c61.75,0,112,50.25,112,112S317.75,368,256,368z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.695,0-128,57.312-128,128s57.305,128,128,128c70.688,0,128-57.312,128-128S326.688,128,256,128z M256,368\r\n\t\tc-61.758,0-112-50.25-112-112s50.242-112,112-112c61.75,0,112,50.25,112,112S317.75,368,256,368z"},"children":[]}]},{"name":"path","attribs":{"d":"M192,320l80-48l48-80l-80,48L192,320z M256,248c4.422,0,8,3.578,8,8s-3.578,8-8,8s-8-3.578-8-8S251.578,248,256,248z"},"children":[{"name":"path","attribs":{"d":"M192,320l80-48l48-80l-80,48L192,320z M256,248c4.422,0,8,3.578,8,8s-3.578,8-8,8s-8-3.578-8-8S251.578,248,256,248z"},"children":[]}]}]}]};exports.compass2=compass2;var compass={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"224.391,224.469 231.359,196.641 144.359,144.438 196.547,231.438 \t"},"children":[{"name":"polygon","attribs":{"points":"224.391,224.469 231.359,196.641 144.359,144.438 196.547,231.438 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"315.281,231.172 367.125,144 280.5,196.406 287.5,224.344 \t"},"children":[{"name":"polygon","attribs":{"points":"315.281,231.172 367.125,144 280.5,196.406 287.5,224.344 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"287.688,287.453 280.828,315.344 368,367.219 315.469,280.391 \t"},"children":[{"name":"polygon","attribs":{"points":"287.688,287.453 280.828,315.344 368,367.219 315.469,280.391 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"196.547,280.672 144.359,367.656 231.547,315.312 224.516,287.641 \t"},"children":[{"name":"polygon","attribs":{"points":"196.547,280.672 144.359,367.656 231.547,315.312 224.516,287.641 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128l-25.594,102.391L128,256l102.5,25.625L256.5,384l25.234-102.547L384,255.5l-102.422-25.203L256,128z M256,272\r\n\t\tc-8.828,0-16-7.172-16-16s7.172-16,16-16s16,7.172,16,16S264.828,272,256,272z"},"children":[{"name":"path","attribs":{"d":"M256,128l-25.594,102.391L128,256l102.5,25.625L256.5,384l25.234-102.547L384,255.5l-102.422-25.203L256,128z M256,272\r\n\t\tc-8.828,0-16-7.172-16-16s7.172-16,16-16s16,7.172,16,16S264.828,272,256,272z"},"children":[]}]}]}]};exports.compass=compass;var contractDirections={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,288 176,256 144,224 \t"},"children":[{"name":"polygon","attribs":{"points":"144,288 176,256 144,224 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"368,288 368,224 335.984,256 \t"},"children":[{"name":"polygon","attribs":{"points":"368,288 368,224 335.984,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"287.969,160 223.953,160 255.953,192 \t"},"children":[{"name":"polygon","attribs":{"points":"287.969,160 223.953,160 255.953,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"223.938,352 287.969,352 255.969,320 \t"},"children":[{"name":"polygon","attribs":{"points":"223.938,352 287.969,352 255.969,320 \t"},"children":[]}]}]}]};exports.contractDirections=contractDirections;var contractHorizontal={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,288.047 176,256.047 144,224.031 \t"},"children":[{"name":"polygon","attribs":{"points":"144,288.047 176,256.047 144,224.031 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"368,288.047 368,224.031 335.984,256.047 \t"},"children":[{"name":"polygon","attribs":{"points":"368,288.047 368,224.031 335.984,256.047 \t"},"children":[]}]}]}]};exports.contractHorizontal=contractHorizontal;var contractVertical={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"288,160 224,160 256,192 \t"},"children":[{"name":"polygon","attribs":{"points":"288,160 224,160 256,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"224,352 288,352 256,319.969 \t"},"children":[{"name":"polygon","attribs":{"points":"224,352 288,352 256,319.969 \t"},"children":[]}]}]}]};exports.contractVertical=contractVertical;var copyDocument={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"192","width":"160","height":"192"},"children":[{"name":"rect","attribs":{"x":"144","y":"192","width":"160","height":"192"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"368,128 208,128 208,176 320,176 320,320 368,320 \t\t"},"children":[{"name":"polygon","attribs":{"points":"368,128 208,128 208,176 320,176 320,320 368,320 \t\t"},"children":[]}]}]}]}]}]};exports.copyDocument=copyDocument;var copyPasteDocument={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"224","width":"160","height":"160"},"children":[{"name":"rect","attribs":{"x":"128","y":"224","width":"160","height":"160"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"336,176 176,176 176,208 304,208 304,336 336,336 \t\t"},"children":[{"name":"polygon","attribs":{"points":"336,176 176,176 176,208 304,208 304,336 336,336 \t\t"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"384,128 224,128 224,160 352,160 352,288 384,288 \t\t"},"children":[{"name":"polygon","attribs":{"points":"384,128 224,128 224,160 352,160 352,288 384,288 \t\t"},"children":[]}]}]}]}]}]};exports.copyPasteDocument=copyPasteDocument;var creditCard={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,216c0-22.094-17.906-40-40-40H184c-22.094,0-40,17.906-40,40v80c0,22.094,17.906,40,40,40h144\r\n\t\tc22.094,0,40-17.906,40-40V216z M183.594,192h144c10.438,0,19.219,6.719,22.531,16H161.078\r\n\t\tC164.391,198.719,173.188,192,183.594,192z M352,296c0,13.234-11.156,24-24.406,24h-144C170.375,320,160,309.234,160,296v-56h192\r\n\t\tV296z"},"children":[{"name":"path","attribs":{"d":"M368,216c0-22.094-17.906-40-40-40H184c-22.094,0-40,17.906-40,40v80c0,22.094,17.906,40,40,40h144\r\n\t\tc22.094,0,40-17.906,40-40V216z M183.594,192h144c10.438,0,19.219,6.719,22.531,16H161.078\r\n\t\tC164.391,198.719,173.188,192,183.594,192z M352,296c0,13.234-11.156,24-24.406,24h-144C170.375,320,160,309.234,160,296v-56h192\r\n\t\tV296z"},"children":[]}]},{"name":"path","attribs":{"d":"M183.594,272h64c4.438,0,8-3.578,8-8s-3.562-8-8-8h-64c-4.406,0-8,3.578-8,8S179.188,272,183.594,272z"},"children":[{"name":"path","attribs":{"d":"M183.594,272h64c4.438,0,8-3.578,8-8s-3.562-8-8-8h-64c-4.406,0-8,3.578-8,8S179.188,272,183.594,272z"},"children":[]}]},{"name":"path","attribs":{"d":"M311.594,272h16c4.438,0,8-3.578,8-8s-3.562-8-8-8h-16c-4.406,0-8,3.578-8,8S307.188,272,311.594,272z"},"children":[{"name":"path","attribs":{"d":"M311.594,272h16c4.438,0,8-3.578,8-8s-3.562-8-8-8h-16c-4.406,0-8,3.578-8,8S307.188,272,311.594,272z"},"children":[]}]},{"name":"path","attribs":{"d":"M183.594,304h32c4.438,0,8-3.578,8-8s-3.562-8-8-8h-32c-4.406,0-8,3.578-8,8S179.188,304,183.594,304z"},"children":[{"name":"path","attribs":{"d":"M183.594,304h32c4.438,0,8-3.578,8-8s-3.562-8-8-8h-32c-4.406,0-8,3.578-8,8S179.188,304,183.594,304z"},"children":[]}]}]}]};exports.creditCard=creditCard;var cross={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"335.188,154.188 256,233.375 176.812,154.188 154.188,176.812 233.375,256 154.188,335.188 176.812,357.812 \r\n\t256,278.625 335.188,357.812 357.812,335.188 278.625,256 357.812,176.812 "},"children":[]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]};exports.cross=cross;var directions={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"384,256 352,224 352,240 272,240 272,160 288,160 256,128 224,160 \r\n\t240,160 240,240 160,240 160,224 128,256 160,288 160,272 240,272 240,352 224,352 256,384 288,352 272,352 272,272 352,272 \r\n\t352,288 "},"children":[]}]};exports.directions=directions;var documentFill={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M320,128H160v256h192V164.578L320,128z M176,368V144h128v32h32v192H176z"},"children":[{"name":"path","attribs":{"d":"M320,128H160v256h192V164.578L320,128z M176,368V144h128v32h32v192H176z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"272","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"272","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"240","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"240","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"192","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"192","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"160","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"160","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"304","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"304","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"336","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"336","width":"128","height":"16"},"children":[]}]}]}]};exports.documentFill=documentFill;var documentIcon={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M320,128H160v256h192V164.578L320,128z M176,368V144h128v32h32v192H176z"},"children":[]}]};exports.documentIcon=documentIcon;var documents={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M360.5,128.5h-121v64h-112v192h144v-64h112v-169L360.5,128.5z M255.5,368.5h-112v-160h96v112h16V368.5z M367.5,304.5h-112\r\n\tv-160h80v32h32V304.5z"},"children":[]}]};exports.documents=documents;var dollar={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M267.922,351.734V384h-25.719v-30.406c-19.516-0.609-39.047-6.25-50.203-13.469l8.375-29.766\r\n\tc12.406,7.531,29.438,13.781,48.344,13.781c19.812,0,33.141-9.703,33.141-24.438c0-14.391-10.828-23.156-34.078-31.641\r\n\tc-32.219-11.906-53.609-27.25-53.609-56.094c0-26.938,18.609-47.938,49.891-53.562V128h25.406v28.828\r\n\tc19.516,0.625,32.859,5.641,42.781,10.656l-8.375,28.828c-7.438-3.75-21.078-10.969-42.141-10.969\r\n\tc-21.703,0-29.453,11.281-29.453,21.938c0,12.844,11.156,20.359,37.812,30.719C304.797,251.156,320,268.062,320,296.281\r\n\tC320,322.922,301.703,346.094,267.922,351.734z"},"children":[]}]};exports.dollar=dollar;var dotCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M272,352c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS272,343.156,272,352z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M272,352c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS272,343.156,272,352z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M272,160c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS272,151.156,272,160z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M272,160c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS272,151.156,272,160z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,256c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS368,247.156,368,256z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,256c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS368,247.156,368,256z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M176,256c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS176,247.156,176,256z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M176,256c0,8.844-7.156,16-16,16s-16-7.156-16-16s7.156-16,16-16\r\n\t\tS176,247.156,176,256z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M173.062,226.844c8.844-25.062,28.719-44.938,53.781-53.781\r\n\t\t\tc-1.797-4-2.844-8.391-2.844-13.062c0-1.031,0.219-2.016,0.312-3.031c-31.891,10.25-57.094,35.453-67.344,67.344\r\n\t\t\tc1.016-0.094,2-0.312,3.031-0.312C164.672,224,169.062,225.047,173.062,226.844z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M173.062,226.844c8.844-25.062,28.719-44.938,53.781-53.781\r\n\t\t\tc-1.797-4-2.844-8.391-2.844-13.062c0-1.031,0.219-2.016,0.312-3.031c-31.891,10.25-57.094,35.453-67.344,67.344\r\n\t\t\tc1.016-0.094,2-0.312,3.031-0.312C164.672,224,169.062,225.047,173.062,226.844z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M226.844,338.938c-25.062-8.859-44.938-28.703-53.781-53.781\r\n\t\t\tc-4,1.797-8.391,2.844-13.062,2.844c-1.031,0-2.016-0.203-3.031-0.297c10.25,31.875,35.453,57.094,67.344,67.312\r\n\t\t\tc-0.094-1-0.312-1.984-0.312-3.016C224,347.328,225.047,342.922,226.844,338.938z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M226.844,338.938c-25.062-8.859-44.938-28.703-53.781-53.781\r\n\t\t\tc-4,1.797-8.391,2.844-13.062,2.844c-1.031,0-2.016-0.203-3.031-0.297c10.25,31.875,35.453,57.094,67.344,67.312\r\n\t\t\tc-0.094-1-0.312-1.984-0.312-3.016C224,347.328,225.047,342.922,226.844,338.938z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M285.156,173.062c25.078,8.844,44.922,28.719,53.781,53.781\r\n\t\t\tC342.922,225.047,347.328,224,352,224c1.031,0,2.016,0.219,3.016,0.312c-10.219-31.891-35.438-57.094-67.312-67.344\r\n\t\t\tc0.094,1.016,0.297,2,0.297,3.031C288,164.672,286.953,169.062,285.156,173.062z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M285.156,173.062c25.078,8.844,44.922,28.719,53.781,53.781\r\n\t\t\tC342.922,225.047,347.328,224,352,224c1.031,0,2.016,0.219,3.016,0.312c-10.219-31.891-35.438-57.094-67.312-67.344\r\n\t\t\tc0.094,1.016,0.297,2,0.297,3.031C288,164.672,286.953,169.062,285.156,173.062z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M338.922,285.156c-8.844,25.062-28.703,44.922-53.766,53.766\r\n\t\t\tc1.797,4,2.844,8.406,2.844,13.078c0,1.031-0.203,2.016-0.297,3.016c31.875-10.219,57.094-35.438,67.312-67.312\r\n\t\t\tc-1,0.094-1.984,0.297-3.016,0.297C347.328,288,342.922,286.953,338.922,285.156z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M338.922,285.156c-8.844,25.062-28.703,44.922-53.766,53.766\r\n\t\t\tc1.797,4,2.844,8.406,2.844,13.078c0,1.031-0.203,2.016-0.297,3.016c31.875-10.219,57.094-35.438,67.312-67.312\r\n\t\t\tc-1,0.094-1.984,0.297-3.016,0.297C347.328,288,342.922,286.953,338.922,285.156z"},"children":[]}]}]}]}]}]};exports.dotCircle=dotCircle;var dotLine={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M384,176v-48h-48v36.703L164.688,336H128v48h48v-36.688L347.328,176H384z M352,144\r\n\th16v16h-16V144z M160,368h-16v-16h16V368z"},"children":[]}]};exports.dotLine=dotLine;var dotSquare={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M384,176v-48h-48v16H176v-16h-48v48h16v160h-16v48h48v-16h160v16h48v-48h-16V176\r\n\tH384z M352,144h16v16h-16V144z M144,144h16v16h-16V144z M160,368h-16v-16h16V368z M368,368h-16v-16h16V368z M352,336h-16v16H176v-16\r\n\th-16V176h16v-16h160v16h16V336z"},"children":[]}]};exports.dotSquare=dotSquare;var doubleDiamonds={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M384,255.781L293.469,160l-37.672,39.875L218.5,160.422L128,256.203L218.5,352l37.688-39.859l37.281,39.453L384,255.781z\r\n\t M267.109,211.844l26.359-27.906l67.906,71.844l-67.906,71.859L267.5,300.172l41.531-43.969L267.109,211.844z"},"children":[]}]};exports.doubleDiamonds=doubleDiamonds;var downloadSelectionCircle={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"303.891,271.961 271.961,271.961 271.961,192.133 240.031,192.133 240.031,271.961 208.109,271.961 256,319.852 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"303.891,271.961 271.961,271.961 271.961,192.133 240.031,192.133 240.031,271.961 208.109,271.961 256,319.852 \t\r\n\t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M322.516,346.117c9.453-6.984,17.703-15.359,24.547-24.906l-12.969-9.297c-5.875,8.188-12.969,15.375-21.062,21.375\r\n\t\tL322.516,346.117z"},"children":[{"name":"path","attribs":{"d":"M322.516,346.117c9.453-6.984,17.703-15.359,24.547-24.906l-12.969-9.297c-5.875,8.188-12.969,15.375-21.062,21.375\r\n\t\tL322.516,346.117z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.836,352.039l0.148,15.969c11.789-0.094,23.391-2.031,34.5-5.75l-5.047-15.125\r\n\t\tC276.922,350.305,266.977,351.945,256.836,352.039z"},"children":[{"name":"path","attribs":{"d":"M256.836,352.039l0.148,15.969c11.789-0.094,23.391-2.031,34.5-5.75l-5.047-15.125\r\n\t\tC276.922,350.305,266.977,351.945,256.836,352.039z"},"children":[]}]},{"name":"path","attribs":{"d":"M321.484,165.133c-9.531-6.875-20.047-12.203-31.219-15.781l-4.891,15.203c9.578,3.062,18.594,7.609,26.766,13.516\r\n\t\tL321.484,165.133z"},"children":[{"name":"path","attribs":{"d":"M321.484,165.133c-9.531-6.875-20.047-12.203-31.219-15.781l-4.891,15.203c9.578,3.062,18.594,7.609,26.766,13.516\r\n\t\tL321.484,165.133z"},"children":[]}]},{"name":"path","attribs":{"d":"M362.375,220.82c-3.703-11.141-9.094-21.594-16.078-31.078l-12.844,9.453c5.953,8.141,10.594,17.094,13.766,26.641\r\n\t\tL362.375,220.82z"},"children":[{"name":"path","attribs":{"d":"M362.375,220.82c-3.703-11.141-9.094-21.594-16.078-31.078l-12.844,9.453c5.953,8.141,10.594,17.094,13.766,26.641\r\n\t\tL362.375,220.82z"},"children":[]}]},{"name":"path","attribs":{"d":"M347.547,285.102l15.219,4.844c3.469-10.938,5.234-22.375,5.234-33.938v-0.609l-15.969,0.609\r\n\t\tC352.031,265.945,350.531,275.742,347.547,285.102z"},"children":[{"name":"path","attribs":{"d":"M347.547,285.102l15.219,4.844c3.469-10.938,5.234-22.375,5.234-33.938v-0.609l-15.969,0.609\r\n\t\tC352.031,265.945,350.531,275.742,347.547,285.102z"},"children":[]}]},{"name":"path","attribs":{"d":"M166.062,322.773l12.828-9.516c-6.047-8.109-10.734-17.062-13.938-26.562l-15.141,5.094\r\n\t\tC153.547,302.898,159.016,313.32,166.062,322.773z"},"children":[{"name":"path","attribs":{"d":"M166.062,322.773l12.828-9.516c-6.047-8.109-10.734-17.062-13.938-26.562l-15.141,5.094\r\n\t\tC153.547,302.898,159.016,313.32,166.062,322.773z"},"children":[]}]},{"name":"path","attribs":{"d":"M148.75,256.852l11.219-0.844c0-10.125,1.578-20.078,4.672-29.641l-15.203-4.906C145.828,232.602,144,244.227,144,256.32\r\n\t\tL148.75,256.852z"},"children":[{"name":"path","attribs":{"d":"M148.75,256.852l11.219-0.844c0-10.125,1.578-20.078,4.672-29.641l-15.203-4.906C145.828,232.602,144,244.227,144,256.32\r\n\t\tL148.75,256.852z"},"children":[]}]},{"name":"path","attribs":{"d":"M199.453,178.383l-9.422-12.875c-9.516,6.938-17.828,15.281-24.703,24.766l12.906,9.391\r\n\t\tC184.141,191.508,191.297,184.367,199.453,178.383z"},"children":[{"name":"path","attribs":{"d":"M199.453,178.383l-9.422-12.875c-9.516,6.938-17.828,15.281-24.703,24.766l12.906,9.391\r\n\t\tC184.141,191.508,191.297,184.367,199.453,178.383z"},"children":[]}]},{"name":"path","attribs":{"d":"M222.375,362.867l4.812-15.234c-9.594-3.016-18.641-7.516-26.859-13.375l-9.281,13\r\n\t\tC200.656,354.086,211.203,359.352,222.375,362.867z"},"children":[{"name":"path","attribs":{"d":"M222.375,362.867l4.812-15.234c-9.594-3.016-18.641-7.516-26.859-13.375l-9.281,13\r\n\t\tC200.656,354.086,211.203,359.352,222.375,362.867z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.727,159.945l-0.062-15.953c-11.828,0.047-23.43,1.906-34.539,5.531l4.984,15.172\r\n\t\tC235.594,161.602,245.562,160.008,255.727,159.945z"},"children":[{"name":"path","attribs":{"d":"M255.727,159.945l-0.062-15.953c-11.828,0.047-23.43,1.906-34.539,5.531l4.984,15.172\r\n\t\tC235.594,161.602,245.562,160.008,255.727,159.945z"},"children":[]}]}]}]};exports.downloadSelectionCircle=downloadSelectionCircle;var downloadSelection={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"351.891","y":"224.031","width":"15.984","height":"63.938"},"children":[{"name":"rect","attribs":{"x":"351.891","y":"224.031","width":"15.984","height":"63.938"},"children":[]}]},{"name":"path","attribs":{"d":"M344.031,144h-8v15.984h8c4.391,0,7.984,3.578,7.984,7.984v8H368v-8C368,154.75,357.25,144,344.031,144z"},"children":[{"name":"path","attribs":{"d":"M344.031,144h-8v15.984h8c4.391,0,7.984,3.578,7.984,7.984v8H368v-8C368,154.75,357.25,144,344.031,144z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.039","y":"144.125","width":"63.93","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.039","y":"144.125","width":"63.93","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M144,167.969l0.125,8.125h15.984l-0.125-8.125c0-4.406,3.578-7.984,7.992-7.984h7.984V144h-7.984\r\n\t\tC154.75,144,144,154.75,144,167.969z"},"children":[{"name":"path","attribs":{"d":"M144,167.969l0.125,8.125h15.984l-0.125-8.125c0-4.406,3.578-7.984,7.992-7.984h7.984V144h-7.984\r\n\t\tC154.75,144,144,154.75,144,167.969z"},"children":[]}]},{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.938"},"children":[{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.938"},"children":[]}]},{"name":"path","attribs":{"d":"M159.984,344.031v-8H144v8C144,357.25,154.75,368,167.977,368h7.984v-15.984h-7.984\r\n\t\tC163.562,352.016,159.984,348.422,159.984,344.031z"},"children":[{"name":"path","attribs":{"d":"M159.984,344.031v-8H144v8C144,357.25,154.75,368,167.977,368h7.984v-15.984h-7.984\r\n\t\tC163.562,352.016,159.984,348.422,159.984,344.031z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.039","y":"351.891","width":"63.93","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.039","y":"351.891","width":"63.93","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M352.016,344.031c0,4.391-3.594,7.984-7.984,7.984h-8V368h8C357.25,368,368,357.25,368,344.031v-8h-15.984V344.031z"},"children":[{"name":"path","attribs":{"d":"M352.016,344.031c0,4.391-3.594,7.984-7.984,7.984h-8V368h8C357.25,368,368,357.25,368,344.031v-8h-15.984V344.031z"},"children":[]}]},{"name":"polygon","attribs":{"points":"272.109,191.875 240.141,191.875 240.016,272.172 208.055,272.172 256,320.109 303.953,272.172 272.094,272.25 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"272.109,191.875 240.141,191.875 240.016,272.172 208.055,272.172 256,320.109 303.953,272.172 272.094,272.25 \t\r\n\t\t"},"children":[]}]}]}]};exports.downloadSelection=downloadSelection;var download={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,320 352,352 256,352 160,352 160,320 128,320 128,384 384,384 \r\n\t\t\t384,320 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,320 352,352 256,352 160,352 160,320 128,320 128,384 384,384 \r\n\t\t\t384,320 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"272,256 272,128 240,128 240,256 192,256 256,336 320,256 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"272,256 272,128 240,128 240,256 192,256 256,336 320,256 \t\t"},"children":[]}]}]}]}]}]};exports.download=download;var drop={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-16,48-80,131.812-80,176s35.812,80,80,80s80-35.812,80-80\r\n\tS272,176,256,128z M256,352c-27.625,0-50-22.406-50-50c0-27.625,40-80,50-110c10,30,50,82.375,50,110\r\n\tC306,329.594,283.594,352,256,352z"},"children":[]}]};exports.drop=drop;var drops={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M304,304c0,44.188-35.812,80-80,80s-80-35.812-80-80s64-128,80-176\r\n\t\tC240,176,304,259.812,304,304z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M304,304c0,44.188-35.812,80-80,80s-80-35.812-80-80s64-128,80-176\r\n\t\tC240,176,304,259.812,304,304z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,194c0,16.562-14.344,30-32,30s-32-13.438-32-30s25.594-48,32-66\r\n\t\tC342.406,146,368,177.438,368,194z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,194c0,16.562-14.344,30-32,30s-32-13.438-32-30s25.594-48,32-66\r\n\t\tC342.406,146,368,177.438,368,194z"},"children":[]}]}]}]};exports.drops=drops;var eject={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"176,272 336,272 256,176 \t\t"},"children":[{"name":"polygon","attribs":{"points":"176,272 336,272 256,176 \t\t"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"304","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"176","y":"304","width":"160","height":"32"},"children":[]}]}]}]}]}]};exports.eject=eject;var emailAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-16-4-16-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.656L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-16-4-16-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.656L348.406,336H256z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M368,192h-16v16h-16v-16h-16\r\n\t\t\tv-16h16v-16h16v16h16V192z"},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M368,192h-16v16h-16v-16h-16\r\n\t\t\tv-16h16v-16h16v16h16V192z"},"children":[]}]}]}]}]}]};exports.emailAdd=emailAdd;var emailClose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M366.625,195.312\r\n\t\tl-11.312,11.312L344,195.312l-11.312,11.312l-11.312-11.312L332.688,184l-11.312-11.312l11.312-11.312L344,172.688l11.312-11.312\r\n\t\tl11.312,11.312L355.312,184L366.625,195.312z"},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M366.625,195.312\r\n\t\tl-11.312,11.312L344,195.312l-11.312,11.312l-11.312-11.312L332.688,184l-11.312-11.312l11.312-11.312L344,172.688l11.312-11.312\r\n\t\tl11.312,11.312L355.312,184L366.625,195.312z"},"children":[]}]}]}]};exports.emailClose=emailClose;var emailDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M344,214.406L324.797,192H336\r\n\t\tv-32h16v32h11.203L344,214.406z"},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M344,214.406L324.797,192H336\r\n\t\tv-32h16v32h11.203L344,214.406z"},"children":[]}]}]}]};exports.emailDownload=emailDownload;var emailLuminosity={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"248","y":"144","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"248","y":"144","width":"16","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"248","y":"336","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"248","y":"336","width":"16","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"315.876","y":"172.127","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 227.8853 -173.9137)","width":"15.998","height":"31.997"},"children":[{"name":"rect","attribs":{"x":"315.876","y":"172.127","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 227.8853 -173.9137)","width":"15.998","height":"31.997"},"children":[]}]},{"name":"rect","attribs":{"x":"180.126","y":"307.877","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 92.1353 685.9137)","width":"15.998","height":"31.997"},"children":[{"name":"rect","attribs":{"x":"180.126","y":"307.877","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 92.1353 685.9137)","width":"15.998","height":"31.997"},"children":[]}]},{"name":"rect","attribs":{"x":"172.127","y":"180.126","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 188.125 -77.9239)","width":"31.997","height":"15.998"},"children":[{"name":"rect","attribs":{"x":"172.127","y":"180.126","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 188.125 -77.9239)","width":"31.997","height":"15.998"},"children":[]}]},{"name":"rect","attribs":{"x":"307.877","y":"315.876","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 323.875 781.9034)","width":"31.997","height":"15.998"},"children":[{"name":"rect","attribs":{"x":"307.877","y":"315.876","transform":"matrix(-0.7071 -0.7071 0.7071 -0.7071 323.875 781.9034)","width":"31.997","height":"15.998"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"248","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"144","y":"248","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"248","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"336","y":"248","width":"32","height":"16"},"children":[]}]},{"name":"path","attribs":{"d":"M256,192c-35.297,0-64,28.719-64,64s28.703,64,64,64c35.281,0,64-28.719,64-64S291.281,192,256,192z M256,304v-96\r\n\t\tc26.469,0,48,21.531,48,48S282.469,304,256,304z"},"children":[{"name":"path","attribs":{"d":"M256,192c-35.297,0-64,28.719-64,64s28.703,64,64,64c35.281,0,64-28.719,64-64S291.281,192,256,192z M256,304v-96\r\n\t\tc26.469,0,48,21.531,48,48S282.469,304,256,304z"},"children":[]}]}]}]};exports.emailLuminosity=emailLuminosity;var emailRemove={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-16-4-16-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.656L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-16-4-16-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.656L348.406,336H256z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M368,192h-48v-16h48V192z"},"children":[{"name":"path","attribs":{"d":"M344,144c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,144,344,144z M368,192h-48v-16h48V192z"},"children":[]}]}]}]}]}]};exports.emailRemove=emailRemove;var emailSpam={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M384,184c0-22.094-17.938-40-40-40s-40,17.906-40,40c0,22.062,17.938,40,40,40S384,206.062,384,184z M314,184\r\n\t\tc0-16.547,13.469-30,30-30c6.438,0,12.469,2.094,17.375,5.562l-41.781,41.812C316.078,196.469,314,190.438,314,184z\r\n\t\t M326.625,208.406l41.781-41.766C371.938,171.547,374,177.562,374,184c0,16.531-13.469,30-30,30\r\n\t\tC337.562,214,331.531,211.938,326.625,208.406z"},"children":[{"name":"path","attribs":{"d":"M384,184c0-22.094-17.938-40-40-40s-40,17.906-40,40c0,22.062,17.938,40,40,40S384,206.062,384,184z M314,184\r\n\t\tc0-16.547,13.469-30,30-30c6.438,0,12.469,2.094,17.375,5.562l-41.781,41.812C316.078,196.469,314,190.438,314,184z\r\n\t\t M326.625,208.406l41.781-41.766C371.938,171.547,374,177.562,374,184c0,16.531-13.469,30-30,30\r\n\t\tC337.562,214,331.531,211.938,326.625,208.406z"},"children":[]}]}]}]};exports.emailSpam=emailSpam;var emailUpload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[{"name":"path","attribs":{"d":"M368,234.375v74.438l-54.5-59.422l16.719-11.312c-5.984-1.531-11.641-3.922-16.688-7.203L256,271.75L166.281,208H256\r\n\t\t\th37.625c-2.391-4.984-4-10.344-4.812-16H256H128v160h128h128V223.062C379.422,227.75,373.969,231.531,368,234.375z M144,212.531\r\n\t\t\tl54.5,36.859L144,308.812V212.531z M256,336h-92.406l45.562-79.422L256,288.25l46.844-31.672L348.406,336H256z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M344,224c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S321.906,224,344,224z M344,153.594L363.203,176H352\r\n\t\tv32h-16v-32h-11.203L344,153.594z"},"children":[{"name":"path","attribs":{"d":"M344,224c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S321.906,224,344,224z M344,153.594L363.203,176H352\r\n\t\tv32h-16v-32h-11.203L344,153.594z"},"children":[]}]}]}]};exports.emailUpload=emailUpload;var euro={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M277.719,384c-34.656,0-65.891-13.734-86.094-39.234c-12.188-14.109-20.562-33.172-24-56.375H143.25V264.75h21.344\r\n\t\tc0-1.906,0-3.781,0-5.719c0-4.938,0.375-9.891,0.75-14.078H143.25v-23.609h25.531c4.562-23.625,14.859-43.062,28.562-57.906\r\n\t\tC217.906,140.953,245.719,128,279.656,128c22.844,0,41.906,5.719,54.438,11.812l-9.5,35.047c-9.906-4.953-25.5-9.906-42.656-9.906\r\n\t\tc-19.062,0-35.812,6.859-48.406,20.953c-7.969,8.375-13.688,20.938-16.75,35.438h99.781v23.609H212.203\r\n\t\tc-0.766,4.188-0.766,8.766-0.766,13.719c0,2.297,0,3.812,0,6.078h105.125v23.641H215.625c2.688,15.984,8.391,28.578,16.375,36.953\r\n\t\tc12.969,14.094,31.25,20.578,51.062,20.578c18.656,0,36.188-6.484,44.969-11.047L336,368.781\r\n\t\tC323.438,376.375,302.125,384,277.719,384z"},"children":[{"name":"path","attribs":{"d":"M277.719,384c-34.656,0-65.891-13.734-86.094-39.234c-12.188-14.109-20.562-33.172-24-56.375H143.25V264.75h21.344\r\n\t\tc0-1.906,0-3.781,0-5.719c0-4.938,0.375-9.891,0.75-14.078H143.25v-23.609h25.531c4.562-23.625,14.859-43.062,28.562-57.906\r\n\t\tC217.906,140.953,245.719,128,279.656,128c22.844,0,41.906,5.719,54.438,11.812l-9.5,35.047c-9.906-4.953-25.5-9.906-42.656-9.906\r\n\t\tc-19.062,0-35.812,6.859-48.406,20.953c-7.969,8.375-13.688,20.938-16.75,35.438h99.781v23.609H212.203\r\n\t\tc-0.766,4.188-0.766,8.766-0.766,13.719c0,2.297,0,3.812,0,6.078h105.125v23.641H215.625c2.688,15.984,8.391,28.578,16.375,36.953\r\n\t\tc12.969,14.094,31.25,20.578,51.062,20.578c18.656,0,36.188-6.484,44.969-11.047L336,368.781\r\n\t\tC323.438,376.375,302.125,384,277.719,384z"},"children":[]}]}]}]};exports.euro=euro;var exclamation={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"240,234.656 246.234,320 265.781,320 272,233.875 272,128 240,128 \t"},"children":[{"name":"polygon","attribs":{"points":"240,234.656 246.234,320 265.781,320 272,233.875 272,128 240,128 \t"},"children":[]}]},{"name":"rect","attribs":{"x":"240","y":"352","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"240","y":"352","width":"32","height":"32"},"children":[]}]}]}]};exports.exclamation=exclamation;var expandDirections={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"176,288.016 176,224 144,256 \t"},"children":[{"name":"polygon","attribs":{"points":"176,288.016 176,224 144,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"336,288.016 368.016,256 336,224 \t"},"children":[{"name":"polygon","attribs":{"points":"336,288.016 368.016,256 336,224 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256.016,160.016 224,192 288.016,192 \t"},"children":[{"name":"polygon","attribs":{"points":"256.016,160.016 224,192 288.016,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"255.984,351.984 288,320 223.984,320 \t"},"children":[{"name":"polygon","attribs":{"points":"255.984,351.984 288,320 223.984,320 \t"},"children":[]}]}]}]};exports.expandDirections=expandDirections;var expandHorizontal={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"176,288.016 176,224 144,256 \t"},"children":[{"name":"polygon","attribs":{"points":"176,288.016 176,224 144,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"336,288.016 368.016,256 336,224 \t"},"children":[{"name":"polygon","attribs":{"points":"336,288.016 368.016,256 336,224 \t"},"children":[]}]}]}]};exports.expandHorizontal=expandHorizontal;var expandVertical={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[{"name":"rect","attribs":{"x":"192","y":"208","width":"128","height":"96"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,160 224,192 288,192 \t"},"children":[{"name":"polygon","attribs":{"points":"256,160 224,192 288,192 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,352.031 288,320 224,320 \t"},"children":[{"name":"polygon","attribs":{"points":"256,352.031 288,320 224,320 \t"},"children":[]}]}]}]};exports.expandVertical=expandVertical;var expand={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.594,0,256c0,141.375,114.609,256,256,256s256-114.625,256-256C512,114.594,397.391,0,256,0z\r\n\t\t M256,472c-119.297,0-216-96.719-216-216c0-119.312,96.703-216,216-216s216,96.688,216,216C472,375.281,375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.594,0,256c0,141.375,114.609,256,256,256s256-114.625,256-256C512,114.594,397.391,0,256,0z\r\n\t\t M256,472c-119.297,0-216-96.719-216-216c0-119.312,96.703-216,216-216s216,96.688,216,216C472,375.281,375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"384,192.188 384,128 319.281,128 336.281,145 255.469,225.812 174.562,144.969 191.469,128 128,128 128,192.312 \r\n\t\t144.766,175.219 225.438,256 144.75,336.922 128,319.906 128,384 191.406,384 174.531,367.078 255.469,286.188 336.312,367 \r\n\t\t319.281,384 384,384 384,320 366.797,336.906 285.922,256 366.734,175.188 \t"},"children":[{"name":"polygon","attribs":{"points":"384,192.188 384,128 319.281,128 336.281,145 255.469,225.812 174.562,144.969 191.469,128 128,128 128,192.312 \r\n\t\t144.766,175.219 225.438,256 144.75,336.922 128,319.906 128,384 191.406,384 174.531,367.078 255.469,286.188 336.312,367 \r\n\t\t319.281,384 384,384 384,320 366.797,336.906 285.922,256 366.734,175.188 \t"},"children":[]}]}]}]};exports.expand=expand;var eyeDisabled={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M335.578,221.688l-96.859,96.875C244.297,319.406,250,320,256,320c70.688,0,112-64,112-64S356.547,238.438,335.578,221.688\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M335.578,221.688l-96.859,96.875C244.297,319.406,250,320,256,320c70.688,0,112-64,112-64S356.547,238.438,335.578,221.688\r\n\t\tz"},"children":[]}]},{"name":"path","attribs":{"d":"M176.453,290.328l96.859-96.875C267.734,192.609,262,192,256,192c-70.688,0-112,64-112,64S155.453,273.594,176.453,290.328\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M176.453,290.328l96.859-96.875C267.734,192.609,262,192,256,192c-70.688,0-112,64-112,64S155.453,273.594,176.453,290.328\r\n\t\tz"},"children":[]}]},{"name":"polygon","attribs":{"points":"144,344 166.406,368 368,166.398 345.594,144 \t"},"children":[{"name":"polygon","attribs":{"points":"144,344 166.406,368 368,166.398 345.594,144 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.eyeDisabled=eyeDisabled;var eye={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,192c-70.688,0-112,64-112,64s41.312,64,112,64s112-64,112-64S326.688,192,256,192z M256,287.75\r\n\t\tc-17.672,0-32-14.219-32-31.75s14.328-31.75,32-31.75s31.984,14.219,31.984,31.75S273.672,287.75,256,287.75z"},"children":[{"name":"path","attribs":{"d":"M256,192c-70.688,0-112,64-112,64s41.312,64,112,64s112-64,112-64S326.688,192,256,192z M256,287.75\r\n\t\tc-17.672,0-32-14.219-32-31.75s14.328-31.75,32-31.75s31.984,14.219,31.984,31.75S273.672,287.75,256,287.75z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.eye=eye;var femaleSymbol={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"circle","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","cx":"256","cy":"160","r":"32"},"children":[{"name":"circle","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","cx":"256","cy":"160","r":"32"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,208 208,208 208,272 224,272 208,368 240,368 240,384 271.75,384 \r\n\t\t272,368 304,368 288,272 304,272 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,208 208,208 208,272 224,272 208,368 240,368 240,384 271.75,384 \r\n\t\t272,368 304,368 288,272 304,272 \t"},"children":[]}]}]}]};exports.femaleSymbol=femaleSymbol;var fire={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M230.839,128c0,0,95.484,64,84.266,152c0,0,32.047-8,23.438-60.938c0,0,46.234,44.609,45.453,84.938\r\n\tc-0.641,32.766-41.641,80-118.75,80c0,0,69.531-62.188-22.344-140.875c0,0-84.984,83.844-28.906,140.875\r\n\tc0,0-113.078-28.766-79.906-100.797C167.261,211.156,239.823,204.797,230.839,128z"},"children":[]}]};exports.fire=fire;var forward={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"176,336 272,256 176,176 \t"},"children":[{"name":"polygon","attribs":{"points":"176,336 272,256 176,176 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,256 272,336 368,256 272,176 \t"},"children":[{"name":"polygon","attribs":{"points":"272,256 272,336 368,256 272,176 \t"},"children":[]}]}]}]};exports.forward=forward;var graphs={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M352,128c-17.625,0-32,14.344-32,32c0,11.938,6.641,22.25,16.375,27.75L306,288.188c-0.656-0.047-1.312-0.188-2-0.188\r\n\tc-5.391,0-10.406,1.469-14.875,3.859l-35.781-39.172C255.031,248.781,256,244.5,256,240c0-17.656-14.344-32-32-32s-32,14.344-32,32\r\n\tc0,8.672,3.5,16.516,9.109,22.281l-33.859,58.609C164.906,320.375,162.5,320,160,320c-17.656,0-32,14.375-32,32s14.344,32,32,32\r\n\ts32-14.375,32-32c0-9.375-4.125-17.75-10.594-23.625l33.438-57.875c2.906,0.875,5.969,1.5,9.156,1.5\r\n\tc7.266,0,13.891-2.531,19.266-6.625l33.953,37.203C273.938,307.609,272,313.562,272,320c0,17.625,14.359,32,32,32\r\n\tc17.625,0,32-14.375,32-32c0-11.312-5.906-21.188-14.781-26.875l30.562-101.156c0.078,0,0.125,0.031,0.219,0.031\r\n\tc17.625,0,32-14.344,32-32S369.625,128,352,128z M160,368c-8.844,0-16-7.141-16-16s7.156-16,16-16s16,7.141,16,16\r\n\tS168.844,368,160,368z M224,256c-8.844,0-16-7.156-16-16s7.156-16,16-16s16,7.156,16,16S232.844,256,224,256z M304,336\r\n\tc-8.859,0-16-7.141-16-16s7.141-16,16-16s16,7.141,16,16S312.859,336,304,336z M352,176c-8.859,0-16-7.156-16-16s7.141-16,16-16\r\n\ts16,7.156,16,16S360.859,176,352,176z"},"children":[]}]};exports.graphs=graphs;var gridBig={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[{"name":"rect","attribs":{"x":"128","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[{"name":"rect","attribs":{"x":"272","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[{"name":"rect","attribs":{"x":"272","y":"272","fill-rule":"evenodd","clip-rule":"evenodd","width":"112","height":"112"},"children":[]}]}]}]}]}]};exports.gridBig=gridBig;var grids={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"144","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"144","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"224","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"304","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"304","y":"144","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"304","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"304","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"304","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"304","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"224","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"144","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"144","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"224","y":"224","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]}]}]};exports.grids=grids;var hddNet={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M364.422,182.844l-24.844-49.688C337.609,129.219,332.406,126,328,126H184c-4.398,0-9.609,3.219-11.578,7.156\r\n\t\tl-24.844,49.688C145.609,186.781,144,193.594,144,198v32c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32\r\n\t\tC368,193.594,366.391,186.781,364.422,182.844z M168,222c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S172.398,222,168,222z\r\n\t\t M200,222c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S204.398,222,200,222z M232,222c-4.398,0-8-3.594-8-8s3.602-8,8-8\r\n\t\ts8,3.594,8,8S236.398,222,232,222z M344,222c-4.406,0-8-3.594-8-8s3.594-8,8-8s8,3.594,8,8S348.406,222,344,222z"},"children":[{"name":"path","attribs":{"d":"M364.422,182.844l-24.844-49.688C337.609,129.219,332.406,126,328,126H184c-4.398,0-9.609,3.219-11.578,7.156\r\n\t\tl-24.844,49.688C145.609,186.781,144,193.594,144,198v32c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32\r\n\t\tC368,193.594,366.391,186.781,364.422,182.844z M168,222c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S172.398,222,168,222z\r\n\t\t M200,222c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S204.398,222,200,222z M232,222c-4.398,0-8-3.594-8-8s3.602-8,8-8\r\n\t\ts8,3.594,8,8S236.398,222,232,222z M344,222c-4.406,0-8-3.594-8-8s3.594-8,8-8s8,3.594,8,8S348.406,222,344,222z"},"children":[]}]},{"name":"path","attribs":{"d":"M360,254H152c-4.398,0-8,3.594-8,8v32c0,4.406,3.602,8,8,8h64c4.398,0,11.602,0,16,0c2.203,0,5.102,0,8,0v48h-64v32h64h32\r\n\t\th64v-32h-64v-48c2.906,0,5.797,0,8,0c4.406,0,11.594,0,16,0h64c4.406,0,8-3.594,8-8v-32C368,257.594,364.406,254,360,254z M168,286\r\n\t\tc-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S172.398,286,168,286z M200,286c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8\r\n\t\tS204.398,286,200,286z M232,286c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S236.398,286,232,286z M344,286c-4.406,0-8-3.594-8-8\r\n\t\ts3.594-8,8-8s8,3.594,8,8S348.406,286,344,286z"},"children":[{"name":"path","attribs":{"d":"M360,254H152c-4.398,0-8,3.594-8,8v32c0,4.406,3.602,8,8,8h64c4.398,0,11.602,0,16,0c2.203,0,5.102,0,8,0v48h-64v32h64h32\r\n\t\th64v-32h-64v-48c2.906,0,5.797,0,8,0c4.406,0,11.594,0,16,0h64c4.406,0,8-3.594,8-8v-32C368,257.594,364.406,254,360,254z M168,286\r\n\t\tc-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S172.398,286,168,286z M200,286c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8\r\n\t\tS204.398,286,200,286z M232,286c-4.398,0-8-3.594-8-8s3.602-8,8-8s8,3.594,8,8S236.398,286,232,286z M344,286c-4.406,0-8-3.594-8-8\r\n\t\ts3.594-8,8-8s8,3.594,8,8S348.406,286,344,286z"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"350","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"350","width":"16","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"350","width":"16","height":"32"},"children":[{"name":"rect","attribs":{"x":"352","y":"350","width":"16","height":"32"},"children":[]}]}]}]};exports.hddNet=hddNet;var hddRaid={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M338.969,135.438C337.344,131.344,332.406,128,328,128H184\r\n\t\t\tc-4.398,0-9.336,3.344-10.969,7.438l-26.062,65.125C145.336,204.656,144,211.594,144,216v32c0,4.406,3.602,8,8,8h208\r\n\t\t\tc4.406,0,8-3.594,8-8v-32c0-4.406-1.344-11.344-2.969-15.438L338.969,135.438z M176,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C172.398,224,176,227.594,176,232L176,232z M208,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C204.398,224,208,227.594,208,232L208,232z M240,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C236.398,224,240,227.594,240,232L240,232z M352,232c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tc-4.406,0-8-3.594-8-8l0,0c0-4.406,3.594-8,8-8l0,0C348.406,224,352,227.594,352,232L352,232z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M338.969,135.438C337.344,131.344,332.406,128,328,128H184\r\n\t\t\tc-4.398,0-9.336,3.344-10.969,7.438l-26.062,65.125C145.336,204.656,144,211.594,144,216v32c0,4.406,3.602,8,8,8h208\r\n\t\t\tc4.406,0,8-3.594,8-8v-32c0-4.406-1.344-11.344-2.969-15.438L338.969,135.438z M176,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C172.398,224,176,227.594,176,232L176,232z M208,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C204.398,224,208,227.594,208,232L208,232z M240,232c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tc-4.398,0-8-3.594-8-8l0,0c0-4.406,3.602-8,8-8l0,0C236.398,224,240,227.594,240,232L240,232z M352,232c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tc-4.406,0-8-3.594-8-8l0,0c0-4.406,3.594-8,8-8l0,0C348.406,224,352,227.594,352,232L352,232z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,312c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32c0-4.406-3.594-8-8-8\r\n\t\t\tH152c-4.398,0-8,3.594-8,8V312z M336,296c0-4.406,3.594-8,8-8l0,0c4.406,0,8,3.594,8,8l0,0c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tC339.594,304,336,300.406,336,296L336,296z M224,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC227.602,304,224,300.406,224,296L224,296z M192,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC195.602,304,192,300.406,192,296L192,296z M160,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC163.602,304,160,300.406,160,296L160,296z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,312c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32c0-4.406-3.594-8-8-8\r\n\t\t\tH152c-4.398,0-8,3.594-8,8V312z M336,296c0-4.406,3.594-8,8-8l0,0c4.406,0,8,3.594,8,8l0,0c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tC339.594,304,336,300.406,336,296L336,296z M224,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC227.602,304,224,300.406,224,296L224,296z M192,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC195.602,304,192,300.406,192,296L192,296z M160,296c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC163.602,304,160,300.406,160,296L160,296z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,376c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32c0-4.406-3.594-8-8-8\r\n\t\t\tH152c-4.398,0-8,3.594-8,8V376z M336,360c0-4.406,3.594-8,8-8l0,0c4.406,0,8,3.594,8,8l0,0c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tC339.594,368,336,364.406,336,360L336,360z M224,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC227.602,368,224,364.406,224,360L224,360z M192,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC195.602,368,192,364.406,192,360L192,360z M160,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC163.602,368,160,364.406,160,360L160,360z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,376c0,4.406,3.602,8,8,8h208c4.406,0,8-3.594,8-8v-32c0-4.406-3.594-8-8-8\r\n\t\t\tH152c-4.398,0-8,3.594-8,8V376z M336,360c0-4.406,3.594-8,8-8l0,0c4.406,0,8,3.594,8,8l0,0c0,4.406-3.594,8-8,8l0,0\r\n\t\t\tC339.594,368,336,364.406,336,360L336,360z M224,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC227.602,368,224,364.406,224,360L224,360z M192,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC195.602,368,192,364.406,192,360L192,360z M160,360c0-4.406,3.602-8,8-8l0,0c4.398,0,8,3.594,8,8l0,0c0,4.406-3.602,8-8,8l0,0\r\n\t\t\tC163.602,368,160,364.406,160,360L160,360z"},"children":[]}]}]}]}]}]};exports.hddRaid=hddRaid;var hdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M367.219,280.047l-12.594-128.078c-0.422-4.391-4.375-7.969-8.781-7.969h-176.25\r\n\t\t\tc-4.406,0-8.438,3.578-8.969,7.938l-15.656,128.141c-0.531,4.359-0.969,11.531-0.969,15.938V360c0,4.406,3.594,8,8,8h208\r\n\t\t\tc4.406,0,8-3.594,8-8v-63.984C368,291.609,367.641,284.438,367.219,280.047z M352,344c0,4.406-3.594,8-8,8H168\r\n\t\t\tc-4.406,0-8-3.594-8-8v-32c0-4.406,3.594-8,8-8h176c4.406,0,8,3.594,8,8V344z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M367.219,280.047l-12.594-128.078c-0.422-4.391-4.375-7.969-8.781-7.969h-176.25\r\n\t\t\tc-4.406,0-8.438,3.578-8.969,7.938l-15.656,128.141c-0.531,4.359-0.969,11.531-0.969,15.938V360c0,4.406,3.594,8,8,8h208\r\n\t\t\tc4.406,0,8-3.594,8-8v-63.984C368,291.609,367.641,284.438,367.219,280.047z M352,344c0,4.406-3.594,8-8,8H168\r\n\t\t\tc-4.406,0-8-3.594-8-8v-32c0-4.406,3.594-8,8-8h176c4.406,0,8,3.594,8,8V344z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M329.594,320h-144c-4.406,0-8,3.594-8,8.016c0,4.438,3.594,7.984,8,7.984h144\r\n\t\t\tc4.438,0,7.984-3.547,7.984-7.984C337.578,323.594,334.031,320,329.594,320z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M329.594,320h-144c-4.406,0-8,3.594-8,8.016c0,4.438,3.594,7.984,8,7.984h144\r\n\t\t\tc4.438,0,7.984-3.547,7.984-7.984C337.578,323.594,334.031,320,329.594,320z"},"children":[]}]}]}]}]}]};exports.hdd=hdd;var heart={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M310.75,144c-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\tC128,312,256,368,256,368s128-56,128-149.375C384,177.422,351.25,144,310.75,144z"},"children":[{"name":"path","attribs":{"d":"M310.75,144c-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\tC128,312,256,368,256,368s128-56,128-149.375C384,177.422,351.25,144,310.75,144z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.heart=heart;var homeWifi={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256.008,224c-17.672,0-32,14.312-32,32c0,17.672,14.328,32,32,32C273.672,288,288,273.672,288,256\r\n\t\tC288,238.312,273.672,224,256.008,224z"},"children":[{"name":"path","attribs":{"d":"M256.008,224c-17.672,0-32,14.312-32,32c0,17.672,14.328,32,32,32C273.672,288,288,273.672,288,256\r\n\t\tC288,238.312,273.672,224,256.008,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M304.875,202.688l-18.016,13.531C299.609,224.844,308,239.438,308,256s-8.391,31.141-21.141,39.766l18.016,13.531\r\n\t\tC320.094,296.453,330,277.453,330,256C330,234.531,320.094,215.531,304.875,202.688z"},"children":[{"name":"path","attribs":{"d":"M304.875,202.688l-18.016,13.531C299.609,224.844,308,239.438,308,256s-8.391,31.141-21.141,39.766l18.016,13.531\r\n\t\tC320.094,296.453,330,277.453,330,256C330,234.531,320.094,215.531,304.875,202.688z"},"children":[]}]},{"name":"path","attribs":{"d":"M348.844,169.594l-17.75,13.344C350.125,201.469,362,227.344,362,256s-11.875,54.531-30.906,73.047l17.75,13.359\r\n\t\tC370.562,320.047,384,289.625,384,256S370.562,191.938,348.844,169.594z"},"children":[{"name":"path","attribs":{"d":"M348.844,169.594l-17.75,13.344C350.125,201.469,362,227.344,362,256s-11.875,54.531-30.906,73.047l17.75,13.359\r\n\t\tC370.562,320.047,384,289.625,384,256S370.562,191.938,348.844,169.594z"},"children":[]}]},{"name":"path","attribs":{"d":"M204.008,256.531c0.219-16.562,8.781-31.062,21.656-39.516L207.82,203.25c-15.375,12.656-25.531,31.516-25.812,53\r\n\t\tc-0.281,21.469,9.375,40.578,24.438,53.625l18.188-13.297C211.992,287.812,203.789,273.094,204.008,256.531z"},"children":[{"name":"path","attribs":{"d":"M204.008,256.531c0.219-16.562,8.781-31.062,21.656-39.516L207.82,203.25c-15.375,12.656-25.531,31.516-25.812,53\r\n\t\tc-0.281,21.469,9.375,40.578,24.438,53.625l18.188-13.297C211.992,287.812,203.789,273.094,204.008,256.531z"},"children":[]}]},{"name":"path","attribs":{"d":"M181.867,183.156l-17.578-13.562c-22,22.062-35.844,52.312-36.281,85.938c-0.438,33.641,12.625,64.234,34.031,86.875\r\n\t\tl17.938-13.125c-18.812-18.781-30.344-44.797-29.969-73.453C150.383,227.156,162.602,201.438,181.867,183.156z"},"children":[{"name":"path","attribs":{"d":"M181.867,183.156l-17.578-13.562c-22,22.062-35.844,52.312-36.281,85.938c-0.438,33.641,12.625,64.234,34.031,86.875\r\n\t\tl17.938-13.125c-18.812-18.781-30.344-44.797-29.969-73.453C150.383,227.156,162.602,201.438,181.867,183.156z"},"children":[]}]}]}]};exports.homeWifi=homeWifi;var idea={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,384c17.672,0,32-14.328,32-32h-64C224,369.672,238.328,384,256,384z"},"children":[{"name":"path","attribs":{"d":"M256,384c17.672,0,32-14.328,32-32h-64C224,369.672,238.328,384,256,384z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128c-53.016,0-96,42.984-96,96c0,37.781,21.875,70.375,53.625,86.031L224,336h64l10.375-25.969\r\n\t\tC330.109,294.375,352,261.781,352,224C352,170.984,309.016,128,256,128z"},"children":[{"name":"path","attribs":{"d":"M256,128c-53.016,0-96,42.984-96,96c0,37.781,21.875,70.375,53.625,86.031L224,336h64l10.375-25.969\r\n\t\tC330.109,294.375,352,261.781,352,224C352,170.984,309.016,128,256,128z"},"children":[]}]}]}]};exports.idea=idea;var info={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M285.172,331.453c-12.453,13.25-20.547,18.781-26.094,18.781c-3.859,0-5.172-3.422-4.312-11.141\r\n\t\tc2.594-20.062,17.531-84.578,21.781-107.625c4.266-19.719,3-29.953-2.562-29.953c-10.641,0-36.734,17.516-53.828,35.016\r\n\t\tc-0.875,1.344-2.562,8.578-1.688,11.125c0,0.875,1.266,1.312,1.266,1.312c10.266-8.125,18.391-12.844,23.109-12.844\r\n\t\tc2.109,0,2.938,3.406,1.688,9.406c-5.125,25.625-13.672,65.406-20.078,98.281c-5.984,28.672-2.172,40.188,6.812,40.188\r\n\t\ts33.766-11.984,53.906-38.906c0.812-2.094,1.641-10.188,1.25-12.359C286.422,331.906,285.172,331.453,285.172,331.453z"},"children":[{"name":"path","attribs":{"d":"M285.172,331.453c-12.453,13.25-20.547,18.781-26.094,18.781c-3.859,0-5.172-3.422-4.312-11.141\r\n\t\tc2.594-20.062,17.531-84.578,21.781-107.625c4.266-19.719,3-29.953-2.562-29.953c-10.641,0-36.734,17.516-53.828,35.016\r\n\t\tc-0.875,1.344-2.562,8.578-1.688,11.125c0,0.875,1.266,1.312,1.266,1.312c10.266-8.125,18.391-12.844,23.109-12.844\r\n\t\tc2.109,0,2.938,3.406,1.688,9.406c-5.125,25.625-13.672,65.406-20.078,98.281c-5.984,28.672-2.172,40.188,6.812,40.188\r\n\t\ts33.766-11.984,53.906-38.906c0.812-2.094,1.641-10.188,1.25-12.359C286.422,331.906,285.172,331.453,285.172,331.453z"},"children":[]}]},{"name":"path","attribs":{"d":"M281.281,128c-7.297,0-16.25,3.414-20.516,7.703c-1.688,2.141-3.406,8.539-3.859,11.945\r\n\t\tc0.453,7.711,2.578,11.984,6.859,14.562c2.109,1.68,16.219,0.414,19.219-1.312c5.188-3.398,9.828-10.25,10.703-18.375\r\n\t\tc0.375-3.82-0.438-8.984-2.141-11.531C290.688,129.719,287.25,128,281.281,128z"},"children":[{"name":"path","attribs":{"d":"M281.281,128c-7.297,0-16.25,3.414-20.516,7.703c-1.688,2.141-3.406,8.539-3.859,11.945\r\n\t\tc0.453,7.711,2.578,11.984,6.859,14.562c2.109,1.68,16.219,0.414,19.219-1.312c5.188-3.398,9.828-10.25,10.703-18.375\r\n\t\tc0.375-3.82-0.438-8.984-2.141-11.531C290.688,129.719,287.25,128,281.281,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.info=info;var italic={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M272.562,361.891L271.016,368H192l1.984-6.109c7.922-0.219,13.172-1,15.719-2.312c4.141-1.875,7.219-4.469,9.203-7.766\r\n\tc3.109-5.172,6.312-14.422,9.625-27.75l33.406-135.125c2.844-11.25,4.25-19.719,4.25-25.438c0-2.875-0.625-5.297-1.828-7.281\r\n\tc-1.234-1.969-3.094-3.5-5.594-4.531c-2.516-1.062-7.391-1.578-14.672-1.578l1.719-6.109H320l-1.562,6.109\r\n\tc-6.031-0.109-10.516,0.672-13.453,2.312c-4.234,2.203-7.484,5.344-9.688,9.422c-2.234,4.062-5.078,13.094-8.578,27.094\r\n\tl-33.266,135.125c-3.016,12.438-4.531,20.375-4.531,23.781c0,2.75,0.578,5.094,1.766,7.031c1.188,1.922,3.078,3.406,5.656,4.453\r\n\tC258.938,360.375,264.359,361.234,272.562,361.891z"},"children":[]}]};exports.italic=italic;var key={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M253.734,240c-7.141-27.562-31.953-48-61.734-48c-35.344,0-64,28.656-64,64s28.656,64,64,64\r\n\tc29.781,0,54.594-20.453,61.734-48H336v32h32v-32h16v-32H253.734z M192,296c-22.094,0-40-17.922-40-40c0-22.094,17.906-40,40-40\r\n\ts40,17.906,40,40C232,278.078,214.094,296,192,296z"},"children":[]}]};exports.key=key;var landscape={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,160L128,352h256L256,160z M256,256l-16,16l-16-32l32-48l32,48h-16L256,256z"},"children":[]}]};exports.landscape=landscape;var layers={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,355.219 151.031,289.625 128,304 256,384 384,304.25 360.969,289.812 \t"},"children":[{"name":"polygon","attribs":{"points":"256,355.219 151.031,289.625 128,304 256,384 384,304.25 360.969,289.812 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,306.859 151.594,241.609 128,256.359 256,336.359 384,256.609 360.391,241.797 \t"},"children":[{"name":"polygon","attribs":{"points":"256,306.859 151.594,241.609 128,256.359 256,336.359 384,256.609 360.391,241.797 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"128,208 256,288 384,208.25 256,128 \t"},"children":[{"name":"polygon","attribs":{"points":"128,208 256,288 384,208.25 256,128 \t"},"children":[]}]}]}]};exports.layers=layers;var leaf={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M224,192c-40.289,32.219-46.742,100.328-47.781,121.453C166.477,323.422,144,346.969,144,352c0,6.406,8,16,16,16\r\n\tc6.875,0,20.82-35.406,24.609-45.359c22.312,6.062,83.609,17.438,127.391-25.047C366.406,244.797,368,144,368,144\r\n\tS272,153.594,224,192z"},"children":[]}]};exports.leaf=leaf;var leftRight={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,240 208,240 208,208 160,256 208,304 208,272 304,272 304,304 \r\n\t\t\t352,256 304,208 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"304,240 208,240 208,208 160,256 208,304 208,272 304,272 304,304 \r\n\t\t\t352,256 304,208 \t\t"},"children":[]}]},{"name":"rect","attribs":{"x":"368","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"368","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[{"name":"rect","attribs":{"x":"128","y":"192","fill-rule":"evenodd","clip-rule":"evenodd","width":"16","height":"128"},"children":[]}]}]}]}]}]};exports.leftRight=leftRight;var likeAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M368,352h-16v16h-16v-16h-16\r\n\t\tv-16h16v-16h16v16h16V352z"},"children":[{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M368,352h-16v16h-16v-16h-16\r\n\t\tv-16h16v-16h16v16h16V352z"},"children":[]}]}]}]};exports.likeAdd=likeAdd;var likeBan={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]}]}]},{"name":"path","attribs":{"d":"M384,344c0-22.094-17.938-40-40-40s-40,17.906-40,40c0,22.062,17.938,40,40,40S384,366.062,384,344z M314,344\r\n\t\tc0-16.547,13.469-30,30-30c6.438,0,12.469,2.094,17.375,5.562l-41.781,41.812C316.078,356.469,314,350.438,314,344z\r\n\t\t M326.625,368.406l41.781-41.766C371.938,331.547,374,337.562,374,344c0,16.531-13.469,30-30,30\r\n\t\tC337.562,374,331.531,371.938,326.625,368.406z"},"children":[{"name":"path","attribs":{"d":"M384,344c0-22.094-17.938-40-40-40s-40,17.906-40,40c0,22.062,17.938,40,40,40S384,366.062,384,344z M314,344\r\n\t\tc0-16.547,13.469-30,30-30c6.438,0,12.469,2.094,17.375,5.562l-41.781,41.812C316.078,356.469,314,350.438,314,344z\r\n\t\t M326.625,368.406l41.781-41.766C371.938,331.547,374,337.562,374,344c0,16.531-13.469,30-30,30\r\n\t\tC337.562,374,331.531,371.938,326.625,368.406z"},"children":[]}]}]}]};exports.likeBan=likeBan;var likeClose={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]}]}]},{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M366.625,355.312\r\n\t\tl-11.312,11.312L344,355.312l-11.312,11.312l-11.312-11.312L332.688,344l-11.312-11.312l11.312-11.312L344,332.688l11.312-11.312\r\n\t\tl11.312,11.312L355.312,344L366.625,355.312z"},"children":[{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M366.625,355.312\r\n\t\tl-11.312,11.312L344,355.312l-11.312,11.312l-11.312-11.312L332.688,344l-11.312-11.312l11.312-11.312L344,332.688l11.312-11.312\r\n\t\tl11.312,11.312L355.312,344L366.625,355.312z"},"children":[]}]}]}]};exports.likeClose=likeClose;var likeDownload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]}]}]},{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M344,374.406L324.797,352H336\r\n\t\tv-32h16v32h11.203L344,374.406z"},"children":[{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M344,374.406L324.797,352H336\r\n\t\tv-32h16v32h11.203L344,374.406z"},"children":[]}]}]}]};exports.likeDownload=likeDownload;var likeRemove={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M368,352h-48v-16h48V352z"},"children":[{"name":"path","attribs":{"d":"M344,304c-22.094,0-40,17.906-40,40s17.906,40,40,40s40-17.906,40-40S366.094,304,344,304z M368,352h-48v-16h48V352z"},"children":[]}]}]}]}]}]};exports.likeRemove=likeRemove;var likeUpload={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[{"name":"path","attribs":{"d":"M344,288c4.781,0,9.328,0.781,13.766,1.922C373.062,269.562,384,245.719,384,218.625C384,177.422,351.25,144,310.75,144\r\n\t\t\t\tc-21.875,0-41.375,10.078-54.75,25.766C242.5,154.078,223,144,201.125,144C160.75,144,128,177.422,128,218.625\r\n\t\t\t\tC128,312,256,368,256,368s14-6.203,32.641-17.688C288.406,348.203,288,346.156,288,344C288,313.125,313.125,288,344,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\t\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]}]}]},{"name":"path","attribs":{"d":"M344,384c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S321.906,384,344,384z M344,313.594L363.203,336H352\r\n\t\tv32h-16v-32h-11.203L344,313.594z"},"children":[{"name":"path","attribs":{"d":"M344,384c22.094,0,40-17.906,40-40s-17.906-40-40-40s-40,17.906-40,40S321.906,384,344,384z M344,313.594L363.203,336H352\r\n\t\tv32h-16v-32h-11.203L344,313.594z"},"children":[]}]}]}]};exports.likeUpload=likeUpload;var limitDirections={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,208 352,160 304,160 316,172 256,232 196,172 208,160 160,160 \r\n\t\t160,208 172,196 232,256 172,316 160,304 160,352 208,352 196,340 256,280 316,340 304,352 352,352 352,304 340,316 280,256 \r\n\t\t340,196 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,208 352,160 304,160 316,172 256,232 196,172 208,160 160,160 \r\n\t\t160,208 172,196 232,256 172,316 160,304 160,352 208,352 196,340 256,280 316,340 304,352 352,352 352,304 340,316 280,256 \r\n\t\t340,196 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 320,128 320,144 368,144 368,192 384,192 384,144 384,128 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 320,128 320,144 368,144 368,192 384,192 384,144 384,128 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"384,368 384,320 368,320 368,368 320,368 320,384 368,384 384,384 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"384,368 384,320 368,320 368,368 320,368 320,384 368,384 384,384 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"144,384 192,384 192,368 144,368 144,320 128,320 128,368 128,384 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"144,384 192,384 192,368 144,368 144,320 128,320 128,368 128,384 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"128,144.016 128,192 144,192 144,144 192,144 192,128 144,128 128,128 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"128,144.016 128,192 144,192 144,144 192,144 192,128 144,128 128,128 \t\r\n\t\t"},"children":[]}]}]}]};exports.limitDirections=limitDirections;var lineThrough={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M368,240h-94.406c-0.688-0.375-1.219-0.688-1.906-1.062c-24.188-13.156-39.453-23.719-45.875-31.594\r\n\tc-4.438-5.375-6.672-11.312-6.672-17.844c0-8.531,3.531-16.156,10.547-22.844c7.031-6.688,16-10,26.75-10\r\n\tc9.516,0,18.75,2.453,27.609,7.391c8.969,4.984,15.844,14.625,20.609,23.047c4.781,8.438,8.188,20.906,10.094,36.906H320v-80h-5.25\r\n\tc-1.062,4.938-2.516,8.219-4.234,9.859c-1.703,1.641-3.859,2.484-6.516,2.484c-2.375,0-6.469-1.312-12.266-3.953\r\n\tc-12.609-5.578-24.453-8.391-35.656-8.391c-17.891,0-32.641,5.562-44.266,16.656c-11.594,11.125-17.406,24.359-17.406,39.75\r\n\tc0,8.812,2,16.969,5.906,24.312c2.953,5.469,7.219,10.5,12.172,15.281H144v32h116.438c15.297,8.781,25.062,14.797,28.766,17.656\r\n\tc6.016,4.625,10.469,9.641,13.297,15.016c2.812,5.359,4.297,10.703,4.297,15.953c0,9.438-3.812,17.656-11.344,24.625\r\n\ts-17.672,10.422-30.625,10.422c-11.188,0-21.484-2.531-30.891-7.578c-9.344-5.047-16.312-14.656-20.844-22.297\r\n\tC208.5,318.156,204.875,304,202.203,288H192v80h10.203c0.703-4.953,1.859-8.234,3.297-9.812c1.516-1.562,3.594-2.359,6.188-2.359\r\n\tc2.688,0,9.062,1.672,19.156,4.984c10.109,3.312,16.781,5.234,20,5.781c5.406,0.938,11.172,1.406,17.25,1.406\r\n\tc19.406,0,35.328-5.875,47.766-17.594c12.312-11.75,18.547-25.734,18.547-41.938c0-8.531-1.953-16.703-5.828-24.5\r\n\tc-2.156-4.344-4.953-8.281-8.141-11.969H368V240z"},"children":[]}]};exports.lineThrough=lineThrough;var linkUrl={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M359.5,241.221c-10.844-10.828-23.969-17.719-37.766-21.375c-14.625-3.859-29.922-3.672-44.453,0.531\r\n\tc-13.172,3.766-25.688,10.469-36.062,20.844c-13.688,13.672-34.422,15.703-50.422,6.5c-3.109-1.812-6.078-3.859-8.734-6.5\r\n\tc-16.312-16.344-16.312-42.828,0-59.125c16.359-16.344,42.812-16.344,59.156,0c2.656,2.625,4.688,5.594,6.5,8.672\r\n\tc14.531-4.172,29.812-4.375,44.469-0.5c-3.688-13.797-10.594-26.922-21.406-37.797c-32.656-32.625-85.609-32.625-118.281,0\r\n\tc-32.656,32.703-32.656,85.656,0,118.312c10.844,10.797,23.969,17.719,37.75,21.406c14.641,3.812,29.906,3.609,44.469-0.516\r\n\tc13.188-3.828,25.688-10.484,36.062-20.891c13.703-13.672,34.453-15.75,50.453-6.484c3.047,1.797,6.047,3.844,8.719,6.484\r\n\tc16.297,16.312,16.297,42.797,0,59.156c-16.344,16.312-42.859,16.312-59.172,0c-2.656-2.656-4.688-5.641-6.5-8.703\r\n\tc-14.531,4.156-29.812,4.328-44.438,0.5c3.656,13.797,10.531,26.922,21.375,37.781c32.656,32.641,85.594,32.641,118.281,0\r\n\tC392.156,326.814,392.156,273.877,359.5,241.221z"},"children":[]}]};exports.linkUrl=linkUrl;var listCircle={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,304c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,304,160,304z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,304c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,304,160,304z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,240c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,240,160,240z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,240c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,240,160,240z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,176c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,176,160,176z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M160,176c-8.844,0-16,7.156-16,16s7.156,16,16,16s16-7.156,16-16\r\n\t\tS168.844,176,160,176z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,184c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V184z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,184c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V184z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,248c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V248z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,248c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V248z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,312c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V312z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M368,312c0-4.422-3.578-8-8-8H216c-4.422,0-8,3.578-8,8v16c0,4.422,3.578,8,8,8\r\n\t\th144c4.422,0,8-3.578,8-8V312z"},"children":[]}]}]}]};exports.listCircle=listCircle;var listSquare={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"176","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"176","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"240","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"240","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"176","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"176","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"240","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"240","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"32","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"304","fill-rule":"evenodd","clip-rule":"evenodd","width":"160","height":"32"},"children":[]}]}]}]};exports.listSquare=listSquare;var locationMaps={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M128,244.375l104.719,34.891L267.625,384L384,128L128,244.375z M247.266,264.719l-78.547-26.172l192-87.266L247.266,264.719\r\n\tz"},"children":[]}]};exports.locationMaps=locationMaps;var location={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M128,288l256-160L224,384v-96H128z"},"children":[]}]};exports.location=location;var locked={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M335.688,240H320l0.047-46.219c0-27.5-28.562-49.781-63.875-49.781c-35.266,0-63.875,22.281-63.875,49.781L192,240h-16.031\r\n\tc-8.828,0-15.625,7.125-15.625,14L160,354c0,6.875,7.484,14,16.312,14h159.75c8.797,0,15.594-7.125,15.594-14L352,254\r\n\tC352,247.125,344.484,240,335.688,240z M224,192c0-13.719,14.594-23.117,32.172-23.117c17.594,0,31.828,9.398,31.828,23.117\r\n\tl-0.219,48H224V192z"},"children":[]}]};exports.locked=locked;var loginLockRefresh={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M296,240h-8.5c0.312-2.516,0.5-5.188,0.5-8c0-13.203-14.406-24-32-24s-32,10.797-32,24c0,2.812,0.188,5.484,0.5,8H216\r\n\t\tc-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h80c4.422,0,8-3.578,8-8v-48C304,243.578,300.422,240,296,240z M240,240\r\n\t\tc-4.797-9.594,7.203-19.203,16-19.203s20.797,9.609,16,19.203H240z"},"children":[{"name":"path","attribs":{"d":"M296,240h-8.5c0.312-2.516,0.5-5.188,0.5-8c0-13.203-14.406-24-32-24s-32,10.797-32,24c0,2.812,0.188,5.484,0.5,8H216\r\n\t\tc-4.422,0-8,3.578-8,8v48c0,4.422,3.578,8,8,8h80c4.422,0,8-3.578,8-8v-48C304,243.578,300.422,240,296,240z M240,240\r\n\t\tc-4.797-9.594,7.203-19.203,16-19.203s20.797,9.609,16,19.203H240z"},"children":[]}]},{"name":"path","attribs":{"d":"M370.906,311.188L401.594,256h-19.188c-0.797-72.344-56.625-127.516-126.781-127.609\r\n\t\tc-70.609-0.078-127.766,57.078-127.672,127.688c0.078,70.625,57.359,127.906,127.969,127.969\r\n\t\tc39.875,0.094,75.406-18.125,98.797-46.625l-15.281-25.484c-17.938,27.016-48.641,44.75-83.562,44.703\r\n\t\tc-55.469-0.031-100.484-45.047-100.531-100.531c-0.062-55.484,44.844-100.375,100.312-100.312\r\n\t\tc55.219,0.094,99.078,45.781,99.547,100.203l-19.047-0.031L370.906,311.188z"},"children":[{"name":"path","attribs":{"d":"M370.906,311.188L401.594,256h-19.188c-0.797-72.344-56.625-127.516-126.781-127.609\r\n\t\tc-70.609-0.078-127.766,57.078-127.672,127.688c0.078,70.625,57.359,127.906,127.969,127.969\r\n\t\tc39.875,0.094,75.406-18.125,98.797-46.625l-15.281-25.484c-17.938,27.016-48.641,44.75-83.562,44.703\r\n\t\tc-55.469-0.031-100.484-45.047-100.531-100.531c-0.062-55.484,44.844-100.375,100.312-100.312\r\n\t\tc55.219,0.094,99.078,45.781,99.547,100.203l-19.047-0.031L370.906,311.188z"},"children":[]}]}]}]};exports.loginLockRefresh=loginLockRefresh;var magicWand={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M295.656,189.562L128,357.297L154.695,384l167.789-167.594L295.656,189.562z M256.664,237.516l39.445-39.469L314,215.938\r\n\t\tl-39.438,39.469L256.664,237.516z"},"children":[{"name":"path","attribs":{"d":"M295.656,189.562L128,357.297L154.695,384l167.789-167.594L295.656,189.562z M256.664,237.516l39.445-39.469L314,215.938\r\n\t\tl-39.438,39.469L256.664,237.516z"},"children":[]}]},{"name":"polygon","attribs":{"points":"362.734,162.719 349.312,149.297 322.484,176.141 335.906,189.562 \t"},"children":[{"name":"polygon","attribs":{"points":"362.734,162.719 349.312,149.297 322.484,176.141 335.906,189.562 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"288.406,165.375 281.812,128 263.148,131.297 269.75,168.688 \t"},"children":[{"name":"polygon","attribs":{"points":"288.406,165.375 281.812,128 263.148,131.297 269.75,168.688 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"346.641,223.656 343.359,242.328 380.719,248.938 384,230.25 \t"},"children":[{"name":"polygon","attribs":{"points":"346.641,223.656 343.359,242.328 380.719,248.938 384,230.25 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"304.422,278.719 320.453,313.125 337.656,305.094 321.625,270.703 \t"},"children":[{"name":"polygon","attribs":{"points":"304.422,278.719 320.453,313.125 337.656,305.094 321.625,270.703 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"241.391,190.453 207,174.422 198.969,191.625 233.367,207.656 \t"},"children":[{"name":"polygon","attribs":{"points":"241.391,190.453 207,174.422 198.969,191.625 233.367,207.656 \t"},"children":[]}]}]}]};exports.magicWand=magicWand;var magnet={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.702-216-216c0-119.297,96.703-216,216-216c119.298,0,216,96.703,216,216\r\n\tC472,375.298,375.298,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"320","y":"144","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"320","y":"144","width":"32","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M320,272.438C320,307.546,291.546,336,256.453,336h-0.906C220.453,336,192,307.546,192,272.438V192h-32v80.656\r\n\t\tC160,325.313,202.688,368,255.328,368h1.344C309.313,368,352,325.313,352,272.656V192h-32V272.438z"},"children":[{"name":"path","attribs":{"d":"M320,272.438C320,307.546,291.546,336,256.453,336h-0.906C220.453,336,192,307.546,192,272.438V192h-32v80.656\r\n\t\tC160,325.313,202.688,368,255.328,368h1.344C309.313,368,352,325.313,352,272.656V192h-32V272.438z"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"144","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"160","y":"144","width":"32","height":"32"},"children":[]}]}]}]};exports.magnet=magnet;var mail={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,176H128v160h128h128V176H256z M256,192h89.719L256,255.75L166.281,192H256z M144,196.531l54.5,36.859L144,292.812\r\n\tV196.531z M256,320h-92.406l45.562-79.422L256,272.25l46.844-31.672L348.406,320H256z M368,292.812l-54.5-59.422l54.5-36.859\r\n\tV292.812z"},"children":[]}]};exports.mail=mail;var mailbox={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352.062,128L352,128.016V128H160.25v0.062L159.938,128L128,288v96h256v-95.5L352.062,128z M144.594,288.25l28.5-144.25\r\n\t\th165.828l28.5,144.25H144.594z"},"children":[{"name":"path","attribs":{"d":"M352.062,128L352,128.016V128H160.25v0.062L159.938,128L128,288v96h256v-95.5L352.062,128z M144.594,288.25l28.5-144.25\r\n\t\th165.828l28.5,144.25H144.594z"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"256","width":"160","height":"16"},"children":[{"name":"rect","attribs":{"x":"176","y":"256","width":"160","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"184","y":"224","width":"144","height":"16"},"children":[{"name":"rect","attribs":{"x":"184","y":"224","width":"144","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"192","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"192","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"200","y":"160","width":"112","height":"16"},"children":[{"name":"rect","attribs":{"x":"200","y":"160","width":"112","height":"16"},"children":[]}]}]}]};exports.mailbox=mailbox;var maleSymbol={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,192c17.672,0,32-14.328,32-32s-14.328-32-32-32s-32,14.328-32,32S238.328,192,256,192z M208,208v80h16v96h64v-96h16\r\n\t\tv-80H208z"},"children":[{"name":"path","attribs":{"d":"M256,192c17.672,0,32-14.328,32-32s-14.328-32-32-32s-32,14.328-32,32S238.328,192,256,192z M208,208v80h16v96h64v-96h16\r\n\t\tv-80H208z"},"children":[]}]}]}]};exports.maleSymbol=maleSymbol;var map={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"135.5,368 199.5,336 199.5,144 135.5,176 \t"},"children":[{"name":"polygon","attribs":{"points":"135.5,368 199.5,336 199.5,144 135.5,176 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"215.5,336 279.5,368 279.5,176 215.5,144 \t"},"children":[{"name":"polygon","attribs":{"points":"215.5,336 279.5,368 279.5,176 215.5,144 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"295.5,368 359.5,336 359.5,144 295.5,176 \t"},"children":[{"name":"polygon","attribs":{"points":"295.5,368 359.5,336 359.5,144 295.5,176 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[]}]}]}]};exports.map=map;var markerAdd={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,208 240,208 240,240 208,240 208,272 240,272 240,304 272,304 272,272 304,272 304,240 272,240 \t"},"children":[{"name":"polygon","attribs":{"points":"272,208 240,208 240,240 208,240 208,272 240,272 240,304 272,304 272,272 304,272 304,240 272,240 \t"},"children":[]}]}]}]};exports.markerAdd=markerAdd;var markerMinus={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"240","width":"96","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"240","width":"96","height":"32"},"children":[]}]}]}]};exports.markerMinus=markerMinus;var markerPoints={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M256,352\r\n\t\tc-52.938,0-96-43.062-96-96s43.062-96,96-96s96,43.062,96,96S308.938,352,256,352z"},"children":[]}]},{"name":"path","attribs":{"d":"M208,240c-8.828,0-16,7.156-16,16s7.172,16,16,16c8.844,0,16-7.156,16-16S216.844,240,208,240z"},"children":[{"name":"path","attribs":{"d":"M208,240c-8.828,0-16,7.156-16,16s7.172,16,16,16c8.844,0,16-7.156,16-16S216.844,240,208,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,240c-8.844,0-16,7.156-16,16s7.156,16,16,16c8.828,0,16-7.156,16-16S264.828,240,256,240z"},"children":[{"name":"path","attribs":{"d":"M256,240c-8.844,0-16,7.156-16,16s7.156,16,16,16c8.828,0,16-7.156,16-16S264.828,240,256,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M304,240c-8.844,0-16,7.156-16,16s7.156,16,16,16c8.828,0,16-7.156,16-16S312.828,240,304,240z"},"children":[{"name":"path","attribs":{"d":"M304,240c-8.844,0-16,7.156-16,16s7.156,16,16,16c8.828,0,16-7.156,16-16S312.828,240,304,240z"},"children":[]}]}]}]};exports.markerPoints=markerPoints;var marker={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128h128V256C384,185.312,326.703,128,256,128z M160,256\r\n\tc0-52.938,43.062-96,96-96s96,43.062,96,96s-43.062,96-96,96S160,308.938,160,256z"},"children":[]}]};exports.marker=marker;var minus={"viewBox":"0 0 512 512","children":[{"name":"rect","attribs":{"x":"128","y":"240","width":"256","height":"32"},"children":[]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]};exports.minus=minus;var multiBorders={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"192","width":"256","height":"16"},"children":[{"name":"rect","attribs":{"x":"128","y":"192","width":"256","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"240","width":"256","height":"32"},"children":[{"name":"rect","attribs":{"x":"128","y":"240","width":"256","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"304","width":"256","height":"64"},"children":[{"name":"rect","attribs":{"x":"128","y":"304","width":"256","height":"64"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"144","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"128","y":"144","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"144","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"176","y":"144","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"144","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"224","y":"144","width":"64","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"304","y":"144","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"304","y":"144","width":"32","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"144","width":"32","height":"16"},"children":[{"name":"rect","attribs":{"x":"352","y":"144","width":"32","height":"16"},"children":[]}]}]}]};exports.multiBorders=multiBorders;var music={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M199.5,318.466c-16-4.635-7.93-7.499-18.514-7.499c-25.814,0-41.969,16.406-41.969,36.634\r\n\t\tc0,20.242,12.41,36.649,38.227,36.649c25.831,0,38.256-16.407,38.256-36.649V237.667l112-54.951v117.417\r\n\t\tc-16-4.634-6.475-7.483-17.057-7.483c-25.801,0-41.25,16.407-41.25,36.634c0,20.243,11.33,36.649,37.146,36.649\r\n\t\tc25.831,0,37.16-16.406,37.16-36.649V127.75l-144,73.284V318.466z"},"children":[{"name":"path","attribs":{"d":"M199.5,318.466c-16-4.635-7.93-7.499-18.514-7.499c-25.814,0-41.969,16.406-41.969,36.634\r\n\t\tc0,20.242,12.41,36.649,38.227,36.649c25.831,0,38.256-16.407,38.256-36.649V237.667l112-54.951v117.417\r\n\t\tc-16-4.634-6.475-7.483-17.057-7.483c-25.801,0-41.25,16.407-41.25,36.634c0,20.243,11.33,36.649,37.146,36.649\r\n\t\tc25.831,0,37.16-16.406,37.16-36.649V127.75l-144,73.284V318.466z"},"children":[]}]},{"name":"path","attribs":{"d":"M256-0.5C114.349-0.5-0.5,114.333-0.5,256S114.349,512.5,256,512.5c141.683,0,256.5-114.833,256.5-256.5\r\n\t\tS397.683-0.5,256-0.5z M256,472.422C136.485,472.422,39.578,375.53,39.578,256c0-119.53,96.907-216.422,216.422-216.422\r\n\t\tc119.546,0,216.422,96.892,216.422,216.422C472.422,375.53,375.546,472.422,256,472.422z"},"children":[{"name":"path","attribs":{"d":"M256-0.5C114.349-0.5-0.5,114.333-0.5,256S114.349,512.5,256,512.5c141.683,0,256.5-114.833,256.5-256.5\r\n\t\tS397.683-0.5,256-0.5z M256,472.422C136.485,472.422,39.578,375.53,39.578,256c0-119.53,96.907-216.422,216.422-216.422\r\n\t\tc119.546,0,216.422,96.892,216.422,216.422C472.422,375.53,375.546,472.422,256,472.422z"},"children":[]}]}]}]};exports.music=music;var nextFastStep={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"128,336 224,256 128,176 \t"},"children":[{"name":"polygon","attribs":{"points":"128,336 224,256 128,176 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"224,256 224,336 320,256 224,176 \t"},"children":[{"name":"polygon","attribs":{"points":"224,256 224,336 320,256 224,176 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"320,240 320,336 352,336 352,176 320,176 \t"},"children":[{"name":"polygon","attribs":{"points":"320,240 320,336 352,336 352,176 320,176 \t"},"children":[]}]}]}]};exports.nextFastStep=nextFastStep;var nextStep={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"176,336 272,256 176,176 \t"},"children":[{"name":"polygon","attribs":{"points":"176,336 272,256 176,176 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,240 272,336 304,336 304,176 272,176 \t"},"children":[{"name":"polygon","attribs":{"points":"272,240 272,336 304,336 304,176 272,176 \t"},"children":[]}]}]}]};exports.nextStep=nextStep;var numberEight={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M327.172,271.406c-3.094-5.688-7.219-10.688-12.141-15c-4.891-4.25-10.75-7.531-17.547-9.906\r\n\t\tc9.812-4.984,17.766-12.109,23.875-21.359c6.25-9.266,9.297-21.047,9.297-35.484c0-8.516-1.672-16.516-5.141-24.016\r\n\t\ts-8.391-14.016-14.938-19.609c-6.547-5.547-14.453-10-23.562-13.172C277.781,129.625,267.453,128,256,128\r\n\t\tc-11.766,0-22.172,1.625-31.375,4.859c-9.125,3.172-16.938,7.625-23.344,13.172c-6.422,5.594-11.297,12.109-14.562,19.609\r\n\t\tc-3.281,7.5-4.906,15.5-4.906,24.016c0,14.438,2.938,26.344,9,35.719c5.953,9.375,14.078,16.484,24.219,21.125\r\n\t\tc-7.188,2.375-13.156,5.75-18.062,10.141c-4.984,4.391-8.969,9.578-12.125,15.469c-3.125,5.875-5.375,12.125-6.75,18.672\r\n\t\tc-1.391,6.688-2.094,13.203-2.094,19.672c0,9.594,1.859,18.844,5.594,27.75c3.703,8.781,8.969,16.562,15.969,23.312\r\n\t\tc6.984,6.75,15.375,12.234,25.219,16.266C232.656,381.984,243.656,384,256,384s23.391-2.016,33.172-6.219\r\n\t\tc9.938-4.031,18.344-9.547,25.344-16.5c6.844-6.812,12.203-14.797,15.922-23.781c3.703-8.984,5.562-18.266,5.562-27.984\r\n\t\tc0-6.484-0.688-12.984-2.078-19.547C332.531,283.297,330.375,277.172,327.172,271.406z M214.688,193.234\r\n\t\tc0-9.453,3.422-17.969,10.312-25.609c6.875-7.625,17.375-11.469,31.453-11.469c7.141,0,13.328,1.078,18.531,3.094\r\n\t\tc5.281,2.094,9.5,4.875,12.781,8.375c3.422,3.516,5.828,7.5,7.453,11.891c1.656,4.453,2.531,8.984,2.531,13.719\r\n\t\tc0,5.266-0.906,10.266-2.75,14.922c-1.688,4.719-4.281,8.938-7.75,12.594s-7.844,6.609-13.047,8.781\r\n\t\tc-5.266,2.219-11.188,3.344-17.75,3.344c-13.766,0-24.234-4.016-31.234-12.125C218.203,212.641,214.688,203.5,214.688,193.234z\r\n\t\t M300.141,326.734c-1.906,5.266-4.734,10.031-8.656,14.281c-3.766,4.266-8.625,7.719-14.422,10.203\r\n\t\tc-5.781,2.5-12.656,3.75-20.609,3.75c-6.641,0-12.828-1.25-18.641-3.75c-5.734-2.484-10.75-5.766-15.047-9.969\r\n\t\tc-4.297-4.047-7.688-8.797-10.141-14.266c-2.469-5.469-3.734-11.188-3.734-17c0-5.938,1.047-11.75,3.141-17.688\r\n\t\tc2.094-5.812,5-11.031,8.859-15.562c3.859-4.594,8.734-8.234,14.672-11.016c5.875-2.828,12.75-4.219,20.438-4.219\r\n\t\tc7.469,0,14.125,1.391,20.047,4.219c5.891,2.781,10.938,6.422,14.906,11.016c3.984,4.531,7.016,9.75,9.094,15.562\r\n\t\tc1.953,5.938,3.062,11.75,3.062,17.688C303.109,315.797,302.172,321.484,300.141,326.734z"},"children":[{"name":"path","attribs":{"d":"M327.172,271.406c-3.094-5.688-7.219-10.688-12.141-15c-4.891-4.25-10.75-7.531-17.547-9.906\r\n\t\tc9.812-4.984,17.766-12.109,23.875-21.359c6.25-9.266,9.297-21.047,9.297-35.484c0-8.516-1.672-16.516-5.141-24.016\r\n\t\ts-8.391-14.016-14.938-19.609c-6.547-5.547-14.453-10-23.562-13.172C277.781,129.625,267.453,128,256,128\r\n\t\tc-11.766,0-22.172,1.625-31.375,4.859c-9.125,3.172-16.938,7.625-23.344,13.172c-6.422,5.594-11.297,12.109-14.562,19.609\r\n\t\tc-3.281,7.5-4.906,15.5-4.906,24.016c0,14.438,2.938,26.344,9,35.719c5.953,9.375,14.078,16.484,24.219,21.125\r\n\t\tc-7.188,2.375-13.156,5.75-18.062,10.141c-4.984,4.391-8.969,9.578-12.125,15.469c-3.125,5.875-5.375,12.125-6.75,18.672\r\n\t\tc-1.391,6.688-2.094,13.203-2.094,19.672c0,9.594,1.859,18.844,5.594,27.75c3.703,8.781,8.969,16.562,15.969,23.312\r\n\t\tc6.984,6.75,15.375,12.234,25.219,16.266C232.656,381.984,243.656,384,256,384s23.391-2.016,33.172-6.219\r\n\t\tc9.938-4.031,18.344-9.547,25.344-16.5c6.844-6.812,12.203-14.797,15.922-23.781c3.703-8.984,5.562-18.266,5.562-27.984\r\n\t\tc0-6.484-0.688-12.984-2.078-19.547C332.531,283.297,330.375,277.172,327.172,271.406z M214.688,193.234\r\n\t\tc0-9.453,3.422-17.969,10.312-25.609c6.875-7.625,17.375-11.469,31.453-11.469c7.141,0,13.328,1.078,18.531,3.094\r\n\t\tc5.281,2.094,9.5,4.875,12.781,8.375c3.422,3.516,5.828,7.5,7.453,11.891c1.656,4.453,2.531,8.984,2.531,13.719\r\n\t\tc0,5.266-0.906,10.266-2.75,14.922c-1.688,4.719-4.281,8.938-7.75,12.594s-7.844,6.609-13.047,8.781\r\n\t\tc-5.266,2.219-11.188,3.344-17.75,3.344c-13.766,0-24.234-4.016-31.234-12.125C218.203,212.641,214.688,203.5,214.688,193.234z\r\n\t\t M300.141,326.734c-1.906,5.266-4.734,10.031-8.656,14.281c-3.766,4.266-8.625,7.719-14.422,10.203\r\n\t\tc-5.781,2.5-12.656,3.75-20.609,3.75c-6.641,0-12.828-1.25-18.641-3.75c-5.734-2.484-10.75-5.766-15.047-9.969\r\n\t\tc-4.297-4.047-7.688-8.797-10.141-14.266c-2.469-5.469-3.734-11.188-3.734-17c0-5.938,1.047-11.75,3.141-17.688\r\n\t\tc2.094-5.812,5-11.031,8.859-15.562c3.859-4.594,8.734-8.234,14.672-11.016c5.875-2.828,12.75-4.219,20.438-4.219\r\n\t\tc7.469,0,14.125,1.391,20.047,4.219c5.891,2.781,10.938,6.422,14.906,11.016c3.984,4.531,7.016,9.75,9.094,15.562\r\n\t\tc1.953,5.938,3.062,11.75,3.062,17.688C303.109,315.797,302.172,321.484,300.141,326.734z"},"children":[]}]}]}]};exports.numberEight=numberEight;var numberFive={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M183.219,263.844L198.453,128h124.062v29.031H221.328l-6.828,70.109l1.219,0.484c5.844-5.641,12.719-9.656,20.656-12.031\r\n\t\tc7.875-2.375,15.719-3.594,23.469-3.594c10.969,0,21.109,2.234,30.5,6.719c9.266,4.406,17.359,10.531,24.078,18.281\r\n\t\tc6.734,7.75,12.078,16.891,15.906,27.5c3.797,10.531,5.672,21.781,5.672,33.734c0,11.016-1.656,21.578-5.031,31.984\r\n\t\tc-3.531,10.25-8.656,19.328-15.391,27.5c-6.734,8-15.297,14.328-25.656,19.078c-10.406,4.75-22.578,7.203-36.484,7.203\r\n\t\tc-19.531,0-36.375-6.188-50.531-18.281c-14.219-12.234-23.188-30.172-26.906-53.688h32.516c2.922,13.453,8.453,23.969,16.641,31.5\r\n\t\tc8.172,7.531,17.719,11.453,28.656,11.453c7.5,0,14.328-1.5,20.422-4.5c6.219-2.969,11.453-6.984,15.906-12.016\r\n\t\tc4.328-5.156,7.828-11.219,10.156-18.422c2.453-7.078,3.594-14.734,3.594-22.766c0-8.297-1.391-15.859-4.344-22.766\r\n\t\tc-3.062-6.797-6.906-12.734-11.859-17.641c-4.922-4.891-10.625-8.75-17.031-11.625C264.234,242.469,257.688,241,251,241\r\n\t\tc-7.469,0-14.719,1.844-21.688,5.375c-6.938,3.609-12.812,9.375-17.625,17.469H183.219z"},"children":[{"name":"path","attribs":{"d":"M183.219,263.844L198.453,128h124.062v29.031H221.328l-6.828,70.109l1.219,0.484c5.844-5.641,12.719-9.656,20.656-12.031\r\n\t\tc7.875-2.375,15.719-3.594,23.469-3.594c10.969,0,21.109,2.234,30.5,6.719c9.266,4.406,17.359,10.531,24.078,18.281\r\n\t\tc6.734,7.75,12.078,16.891,15.906,27.5c3.797,10.531,5.672,21.781,5.672,33.734c0,11.016-1.656,21.578-5.031,31.984\r\n\t\tc-3.531,10.25-8.656,19.328-15.391,27.5c-6.734,8-15.297,14.328-25.656,19.078c-10.406,4.75-22.578,7.203-36.484,7.203\r\n\t\tc-19.531,0-36.375-6.188-50.531-18.281c-14.219-12.234-23.188-30.172-26.906-53.688h32.516c2.922,13.453,8.453,23.969,16.641,31.5\r\n\t\tc8.172,7.531,17.719,11.453,28.656,11.453c7.5,0,14.328-1.5,20.422-4.5c6.219-2.969,11.453-6.984,15.906-12.016\r\n\t\tc4.328-5.156,7.828-11.219,10.156-18.422c2.453-7.078,3.594-14.734,3.594-22.766c0-8.297-1.391-15.859-4.344-22.766\r\n\t\tc-3.062-6.797-6.906-12.734-11.859-17.641c-4.922-4.891-10.625-8.75-17.031-11.625C264.234,242.469,257.688,241,251,241\r\n\t\tc-7.469,0-14.719,1.844-21.688,5.375c-6.938,3.609-12.812,9.375-17.625,17.469H183.219z"},"children":[]}]}]}]};exports.numberFive=numberFive;var numberFour={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M274.203,384v-62.5H176v-37.203L274.203,128H303.5v164.484H336V321.5h-32.5V384H274.203z M202.438,292.484h71.766V176.969\r\n\t\tL202.438,292.484z"},"children":[{"name":"path","attribs":{"d":"M274.203,384v-62.5H176v-37.203L274.203,128H303.5v164.484H336V321.5h-32.5V384H274.203z M202.438,292.484h71.766V176.969\r\n\t\tL202.438,292.484z"},"children":[]}]}]}]};exports.numberFour=numberFour;var numberNine={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M208.594,317.016c3.188,13.516,9.125,23.422,17.875,29.422c8.672,6.016,17.656,9.016,26.688,9.016\r\n\t\tc9.672,0,17.766-2.438,24.344-7.172c6.547-4.578,11.812-11,15.875-18.844c4.078-7.953,6.859-16.969,8.641-27.172\r\n\t\tc1.688-10.062,2.547-20.578,2.547-31.5c-7.359,10.922-15.734,18.234-24.875,22.016c-9.094,3.922-17.969,5.734-26.531,5.734\r\n\t\tc-9.031,0-18.219-1.984-27.281-5.969c-9.094-3.984-17.375-9.516-24.781-16.703c-7.312-7.203-13.375-15.719-18.031-25.562\r\n\t\tC178.375,240.469,176,229.5,176,217.469c0-12.062,1.719-23.5,5.031-34.375c3.375-10.859,8.266-20.344,14.672-28.438\r\n\t\tc6.484-8.062,14.469-14.531,24.141-19.391c9.594-4.797,20.688-7.266,33.312-7.266c26.031,0,46.328,10,60.938,29.984\r\n\t\tC328.688,177.969,336,206.625,336,243.875c0,15.875-1.156,32.141-3.438,48.672c-2.297,16.688-6.547,31.719-12.703,45.203\r\n\t\tc-6.188,13.516-14.625,24.688-25.312,33.266C283.844,379.734,270.031,384,253.156,384c-8.781,0-17.469-1.234-26.125-3.734\r\n\t\tc-8.547-2.5-16.156-6.312-22.891-11.703c-6.703-5.281-12.297-12.109-16.859-20.625c-4.562-8.5-7.203-18.906-8.094-30.922H208.594z\r\n\t\t M253.016,269.875c6.391,0,12.547-1.406,18.266-4.375c5.844-2.969,10.766-6.984,15.016-12.125\r\n\t\tc4.156-5.125,7.531-11.141,10.047-18.094c2.531-6.891,3.859-14.281,3.859-22.25c0-7.906-1.328-15.266-3.859-22.031\r\n\t\tc-2.516-6.734-5.891-12.719-10.047-17.844c-4.25-5.125-9.172-9.156-15.016-12.125c-5.719-2.906-11.875-4.406-18.266-4.406\r\n\t\tc-6.234,0-12.031,1.5-17.422,4.406c-5.344,2.969-10.109,7-14.125,12.125c-4,5.125-7.281,11.109-9.688,17.844\r\n\t\tc-2.406,6.766-3.625,14.125-3.625,22.031c0,7.969,1.219,15.359,3.625,22.25c2.406,6.953,5.688,12.969,9.688,18.094\r\n\t\tc4.016,5.141,8.781,9.156,14.125,12.125C240.984,268.469,246.781,269.875,253.016,269.875z"},"children":[{"name":"path","attribs":{"d":"M208.594,317.016c3.188,13.516,9.125,23.422,17.875,29.422c8.672,6.016,17.656,9.016,26.688,9.016\r\n\t\tc9.672,0,17.766-2.438,24.344-7.172c6.547-4.578,11.812-11,15.875-18.844c4.078-7.953,6.859-16.969,8.641-27.172\r\n\t\tc1.688-10.062,2.547-20.578,2.547-31.5c-7.359,10.922-15.734,18.234-24.875,22.016c-9.094,3.922-17.969,5.734-26.531,5.734\r\n\t\tc-9.031,0-18.219-1.984-27.281-5.969c-9.094-3.984-17.375-9.516-24.781-16.703c-7.312-7.203-13.375-15.719-18.031-25.562\r\n\t\tC178.375,240.469,176,229.5,176,217.469c0-12.062,1.719-23.5,5.031-34.375c3.375-10.859,8.266-20.344,14.672-28.438\r\n\t\tc6.484-8.062,14.469-14.531,24.141-19.391c9.594-4.797,20.688-7.266,33.312-7.266c26.031,0,46.328,10,60.938,29.984\r\n\t\tC328.688,177.969,336,206.625,336,243.875c0,15.875-1.156,32.141-3.438,48.672c-2.297,16.688-6.547,31.719-12.703,45.203\r\n\t\tc-6.188,13.516-14.625,24.688-25.312,33.266C283.844,379.734,270.031,384,253.156,384c-8.781,0-17.469-1.234-26.125-3.734\r\n\t\tc-8.547-2.5-16.156-6.312-22.891-11.703c-6.703-5.281-12.297-12.109-16.859-20.625c-4.562-8.5-7.203-18.906-8.094-30.922H208.594z\r\n\t\t M253.016,269.875c6.391,0,12.547-1.406,18.266-4.375c5.844-2.969,10.766-6.984,15.016-12.125\r\n\t\tc4.156-5.125,7.531-11.141,10.047-18.094c2.531-6.891,3.859-14.281,3.859-22.25c0-7.906-1.328-15.266-3.859-22.031\r\n\t\tc-2.516-6.734-5.891-12.719-10.047-17.844c-4.25-5.125-9.172-9.156-15.016-12.125c-5.719-2.906-11.875-4.406-18.266-4.406\r\n\t\tc-6.234,0-12.031,1.5-17.422,4.406c-5.344,2.969-10.109,7-14.125,12.125c-4,5.125-7.281,11.109-9.688,17.844\r\n\t\tc-2.406,6.766-3.625,14.125-3.625,22.031c0,7.969,1.219,15.359,3.625,22.25c2.406,6.953,5.688,12.969,9.688,18.094\r\n\t\tc4.016,5.141,8.781,9.156,14.125,12.125C240.984,268.469,246.781,269.875,253.016,269.875z"},"children":[]}]}]}]};exports.numberNine=numberNine;var numberOne={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M249.703,201.25H188v-25h19.312c6.859,0,13.422-1.219,19.5-3.594c6.172-2.375,11.438-5.641,15.797-9.797\r\n\t\tc4.358-4.203,7.922-9.25,10.547-15.234c2.734-5.906,4.047-12.5,4.047-19.625H284v256h-34.297V201.25z"},"children":[{"name":"path","attribs":{"d":"M249.703,201.25H188v-25h19.312c6.859,0,13.422-1.219,19.5-3.594c6.172-2.375,11.438-5.641,15.797-9.797\r\n\t\tc4.358-4.203,7.922-9.25,10.547-15.234c2.734-5.906,4.047-12.5,4.047-19.625H284v256h-34.297V201.25z"},"children":[]}]}]}]};exports.numberOne=numberOne;var numberSeven={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M210.188,384c5.156-43.219,15.688-83.281,31.562-120.266c15.844-37.016,36.953-72.328,63.391-105.828v-0.438H176V128h160\r\n\t\tv29.469c-13.047,17.516-24.922,35.875-35.562,55.031c-10.75,19.219-20.156,38.5-28.156,58c-7.984,19.484-14.5,38.953-19.531,58.234\r\n\t\tc-5.047,19.281-8.344,37.75-10,55.266H210.188z"},"children":[{"name":"path","attribs":{"d":"M210.188,384c5.156-43.219,15.688-83.281,31.562-120.266c15.844-37.016,36.953-72.328,63.391-105.828v-0.438H176V128h160\r\n\t\tv29.469c-13.047,17.516-24.922,35.875-35.562,55.031c-10.75,19.219-20.156,38.5-28.156,58c-7.984,19.484-14.5,38.953-19.531,58.234\r\n\t\tc-5.047,19.281-8.344,37.75-10,55.266H210.188z"},"children":[]}]}]}]};exports.numberSeven=numberSeven;var numberSix={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M302.922,193.656c0-4.406-1-8.797-3.297-13.188c-2.156-4.438-5.141-8.375-8.688-11.938\r\n\t\tc-3.547-3.531-7.938-6.375-13.047-8.562c-5.109-2.219-10.516-3.344-16.281-3.344c-10.281,0-18.516,2.516-24.859,7.5\r\n\t\tc-6.312,5-11.375,11.531-15.094,19.625c-3.688,8.094-6.344,17.125-7.875,27.125c-1.516,9.969-2.375,19.781-2.688,29.5h1.266\r\n\t\tc14.312-14.656,29.797-22.031,46.578-22.031c10.688,0,20.766,2.047,30.328,6.156c9.438,4.125,17.625,9.875,24.453,17.234\r\n\t\tc6.969,7.281,12.359,16.141,16.375,26.391c3.969,10.297,5.906,21.422,5.906,33.422c0,11.219-1.844,21.906-5.391,31.891\r\n\t\tc-3.531,10-8.656,18.625-15.25,26.094c-6.594,7.5-14.594,13.469-24.141,17.938c-9.422,4.328-20.094,6.531-31.938,6.531\r\n\t\tc-12.656,0-24.141-2.562-34.469-7.938c-10.25-5.266-19.016-12.812-26.156-22.609c-7.172-9.922-12.703-21.891-16.688-35.953\r\n\t\tc-4-14.047-5.969-30.062-5.969-48.016c0-25.609,1.969-47.391,5.969-65.484c4-18.031,9.719-32.641,17.156-43.844\r\n\t\tc7.469-11.141,16.406-19.281,26.875-24.422c10.5-5.125,22.156-7.734,35.156-7.734c10.188,0,19.688,1.844,28.359,5.5\r\n\t\tc8.688,3.719,16.156,8.609,22.312,14.766c6.141,6.203,11.203,13.234,14.953,21.141c3.594,7.953,5.734,16.062,6.359,24.25H302.922z\r\n\t\t M259.141,355.453c14.828,0,25.906-5.172,33-15.219c7.234-10.219,10.781-22.734,10.781-37.734c0-7.297-0.906-14.281-2.641-20.938\r\n\t\tc-1.828-6.578-4.625-12.453-8.359-17.578c-3.609-5.141-8.219-9.25-13.625-12.359C272.906,248.5,266.672,247,259.5,247\r\n\t\tc-8.797,0-16.281,1.75-22.281,5.25c-6.094,3.531-11,8.016-14.75,13.484c-3.656,5.391-6.344,11.359-7.844,17.797\r\n\t\tc-1.469,6.484-2.266,12.766-2.266,18.969c0,15.953,4.234,28.719,12.797,38.438C233.719,350.516,245,355.453,259.141,355.453z"},"children":[{"name":"path","attribs":{"d":"M302.922,193.656c0-4.406-1-8.797-3.297-13.188c-2.156-4.438-5.141-8.375-8.688-11.938\r\n\t\tc-3.547-3.531-7.938-6.375-13.047-8.562c-5.109-2.219-10.516-3.344-16.281-3.344c-10.281,0-18.516,2.516-24.859,7.5\r\n\t\tc-6.312,5-11.375,11.531-15.094,19.625c-3.688,8.094-6.344,17.125-7.875,27.125c-1.516,9.969-2.375,19.781-2.688,29.5h1.266\r\n\t\tc14.312-14.656,29.797-22.031,46.578-22.031c10.688,0,20.766,2.047,30.328,6.156c9.438,4.125,17.625,9.875,24.453,17.234\r\n\t\tc6.969,7.281,12.359,16.141,16.375,26.391c3.969,10.297,5.906,21.422,5.906,33.422c0,11.219-1.844,21.906-5.391,31.891\r\n\t\tc-3.531,10-8.656,18.625-15.25,26.094c-6.594,7.5-14.594,13.469-24.141,17.938c-9.422,4.328-20.094,6.531-31.938,6.531\r\n\t\tc-12.656,0-24.141-2.562-34.469-7.938c-10.25-5.266-19.016-12.812-26.156-22.609c-7.172-9.922-12.703-21.891-16.688-35.953\r\n\t\tc-4-14.047-5.969-30.062-5.969-48.016c0-25.609,1.969-47.391,5.969-65.484c4-18.031,9.719-32.641,17.156-43.844\r\n\t\tc7.469-11.141,16.406-19.281,26.875-24.422c10.5-5.125,22.156-7.734,35.156-7.734c10.188,0,19.688,1.844,28.359,5.5\r\n\t\tc8.688,3.719,16.156,8.609,22.312,14.766c6.141,6.203,11.203,13.234,14.953,21.141c3.594,7.953,5.734,16.062,6.359,24.25H302.922z\r\n\t\t M259.141,355.453c14.828,0,25.906-5.172,33-15.219c7.234-10.219,10.781-22.734,10.781-37.734c0-7.297-0.906-14.281-2.641-20.938\r\n\t\tc-1.828-6.578-4.625-12.453-8.359-17.578c-3.609-5.141-8.219-9.25-13.625-12.359C272.906,248.5,266.672,247,259.5,247\r\n\t\tc-8.797,0-16.281,1.75-22.281,5.25c-6.094,3.531-11,8.016-14.75,13.484c-3.656,5.391-6.344,11.359-7.844,17.797\r\n\t\tc-1.469,6.484-2.266,12.766-2.266,18.969c0,15.953,4.234,28.719,12.797,38.438C233.719,350.516,245,355.453,259.141,355.453z"},"children":[]}]}]}]};exports.numberSix=numberSix;var numberThree={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M182.828,204.781c2.688-24.062,9.672-42.922,20.938-56.5C215.031,134.766,232.812,128,257.25,128\r\n\t\tc21.156,0,37.938,5.969,50.25,17.875s18.469,27.75,18.469,47.469c0,14.125-2.562,25.375-7.781,33.781\r\n\t\tc-5.234,8.375-13.453,14.906-24.781,19.625c5.422,1.75,10.641,4.25,15.688,7.5c5.188,3.25,9.734,7.406,13.672,12.594\r\n\t\tc4.062,5.156,7.266,11.234,9.734,18.344c2.344,7.047,3.5,15.359,3.5,25.094c0,12.172-2.078,22.688-6.234,31.75\r\n\t\tc-4.281,9.188-9.984,16.906-17.078,22.984c-7.234,6.219-15.641,10.938-25.047,14.188c-9.531,3.234-19.672,4.797-30.391,4.797\r\n\t\tc-21.969,0-40.156-6.984-54.5-20.984c-14.344-13.984-23.25-34.547-26.75-62h32.562c3.188,20,8.734,34.047,16.5,42.203\r\n\t\tc7.75,8.031,18.531,12.062,32.188,12.062c6.156,0,12.094-1.016,17.703-3.047c5.641-2.016,10.516-5.016,14.812-9.016\r\n\t\tc4.312-4,7.734-8.734,10.391-14.281c2.5-5.688,3.703-11.906,3.703-18.656c0-13.516-4.125-25.016-12.5-34.438\r\n\t\tc-8.25-9.375-19.641-14.094-34.109-14.094h-18.516v-28.719h18.516c6.719,0,12.422-1.062,17.109-3.281\r\n\t\tc4.656-2.234,8.484-5.094,11.453-8.625c2.953-3.5,5.031-7.5,6.219-11.875c1.297-4.469,1.797-8.875,1.797-13.25\r\n\t\tc0-12.375-3.406-22.109-10.25-29.156c-6.828-7.078-15.922-10.594-27.188-10.594c-6.953,0-12.797,1.281-17.656,3.984\r\n\t\tc-4.812,2.641-8.875,6.156-12.078,10.547c-3.188,4.453-5.719,9.594-7.625,15.484c-1.859,5.875-3.219,12.109-4,18.516H182.828z"},"children":[{"name":"path","attribs":{"d":"M182.828,204.781c2.688-24.062,9.672-42.922,20.938-56.5C215.031,134.766,232.812,128,257.25,128\r\n\t\tc21.156,0,37.938,5.969,50.25,17.875s18.469,27.75,18.469,47.469c0,14.125-2.562,25.375-7.781,33.781\r\n\t\tc-5.234,8.375-13.453,14.906-24.781,19.625c5.422,1.75,10.641,4.25,15.688,7.5c5.188,3.25,9.734,7.406,13.672,12.594\r\n\t\tc4.062,5.156,7.266,11.234,9.734,18.344c2.344,7.047,3.5,15.359,3.5,25.094c0,12.172-2.078,22.688-6.234,31.75\r\n\t\tc-4.281,9.188-9.984,16.906-17.078,22.984c-7.234,6.219-15.641,10.938-25.047,14.188c-9.531,3.234-19.672,4.797-30.391,4.797\r\n\t\tc-21.969,0-40.156-6.984-54.5-20.984c-14.344-13.984-23.25-34.547-26.75-62h32.562c3.188,20,8.734,34.047,16.5,42.203\r\n\t\tc7.75,8.031,18.531,12.062,32.188,12.062c6.156,0,12.094-1.016,17.703-3.047c5.641-2.016,10.516-5.016,14.812-9.016\r\n\t\tc4.312-4,7.734-8.734,10.391-14.281c2.5-5.688,3.703-11.906,3.703-18.656c0-13.516-4.125-25.016-12.5-34.438\r\n\t\tc-8.25-9.375-19.641-14.094-34.109-14.094h-18.516v-28.719h18.516c6.719,0,12.422-1.062,17.109-3.281\r\n\t\tc4.656-2.234,8.484-5.094,11.453-8.625c2.953-3.5,5.031-7.5,6.219-11.875c1.297-4.469,1.797-8.875,1.797-13.25\r\n\t\tc0-12.375-3.406-22.109-10.25-29.156c-6.828-7.078-15.922-10.594-27.188-10.594c-6.953,0-12.797,1.281-17.656,3.984\r\n\t\tc-4.812,2.641-8.875,6.156-12.078,10.547c-3.188,4.453-5.719,9.594-7.625,15.484c-1.859,5.875-3.219,12.109-4,18.516H182.828z"},"children":[]}]}]}]};exports.numberThree=numberThree;var numberTwo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M176,209.75c2.531-24.406,10.969-44.141,25.375-59.219c14.344-15.031,34-22.531,58.859-22.531\r\n\t\tc12.234,0,23.172,2.141,32.594,6.484c9.422,4.297,17.375,10.141,23.719,17.484c6.328,7.281,11.219,15.547,14.516,24.797\r\n\t\tc3.281,9.266,4.938,18.844,4.938,28.703c0,8.625-0.984,16.391-3.062,23.266c-2.094,6.875-4.953,12.984-8.688,18.297\r\n\t\tc-3.75,5.438-8.031,10.375-13.109,15c-4.922,4.688-10.328,9.078-16.188,13.234c-10.844,8.406-22.125,16.453-33.672,24.203\r\n\t\tc-11.594,7.75-22.719,16.531-33.375,26.328c-3.875,3.672-7.062,7.438-9.594,11.453c-2.5,4.016-4.594,9.031-6.266,15.016h117.375\r\n\t\tV384H178.531v-24.203c0-10.047,3.188-20,9.625-29.578c6.438-9.734,14.438-19.188,24.125-28.219\r\n\t\tc9.625-9.031,20.188-17.828,31.781-26.359c11.609-8.516,22.531-16.766,32.891-24.781c7.844-5.984,14.031-12.359,18.672-19.234\r\n\t\tc4.516-6.859,6.859-15.625,6.859-26.344c0-15.172-3.812-27.031-11.734-35.531c-7.781-8.484-17.938-12.734-30.516-12.734\r\n\t\tc-15.359,0-27.531,4.703-36.453,14.109c-9,9.375-13.438,22.25-13.438,38.625H176z"},"children":[{"name":"path","attribs":{"d":"M176,209.75c2.531-24.406,10.969-44.141,25.375-59.219c14.344-15.031,34-22.531,58.859-22.531\r\n\t\tc12.234,0,23.172,2.141,32.594,6.484c9.422,4.297,17.375,10.141,23.719,17.484c6.328,7.281,11.219,15.547,14.516,24.797\r\n\t\tc3.281,9.266,4.938,18.844,4.938,28.703c0,8.625-0.984,16.391-3.062,23.266c-2.094,6.875-4.953,12.984-8.688,18.297\r\n\t\tc-3.75,5.438-8.031,10.375-13.109,15c-4.922,4.688-10.328,9.078-16.188,13.234c-10.844,8.406-22.125,16.453-33.672,24.203\r\n\t\tc-11.594,7.75-22.719,16.531-33.375,26.328c-3.875,3.672-7.062,7.438-9.594,11.453c-2.5,4.016-4.594,9.031-6.266,15.016h117.375\r\n\t\tV384H178.531v-24.203c0-10.047,3.188-20,9.625-29.578c6.438-9.734,14.438-19.188,24.125-28.219\r\n\t\tc9.625-9.031,20.188-17.828,31.781-26.359c11.609-8.516,22.531-16.766,32.891-24.781c7.844-5.984,14.031-12.359,18.672-19.234\r\n\t\tc4.516-6.859,6.859-15.625,6.859-26.344c0-15.172-3.812-27.031-11.734-35.531c-7.781-8.484-17.938-12.734-30.516-12.734\r\n\t\tc-15.359,0-27.531,4.703-36.453,14.109c-9,9.375-13.438,22.25-13.438,38.625H176z"},"children":[]}]}]}]};exports.numberTwo=numberTwo;var numberZero={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.984,128c-26.516,0-46.453,11.344-59.922,33.891C182.688,184.516,176,215.25,176,254.016\r\n\t\tc0,42.938,6.688,75.25,20.062,97.188C209.531,373.016,229.469,384,255.984,384c26.531,0,46.562-10.984,59.922-32.797\r\n\t\tC329.297,329.266,336,296.953,336,254.016C336,170,309.266,128,255.984,128z M292.219,330.719\r\n\t\tc-7.453,16.484-19.609,24.578-36.234,24.578c-16.688,0-28.703-8.094-36.266-24.578c-7.516-16.484-11.219-42.016-11.219-76.703\r\n\t\tc0-34.391,3.703-59.156,11.219-74.484c7.562-15.266,19.578-22.906,36.266-22.906c16.625,0,28.781,7.641,36.234,22.906\r\n\t\tc7.547,15.328,11.281,40.094,11.281,74.484C303.5,288.703,299.766,314.234,292.219,330.719z"},"children":[{"name":"path","attribs":{"d":"M255.984,128c-26.516,0-46.453,11.344-59.922,33.891C182.688,184.516,176,215.25,176,254.016\r\n\t\tc0,42.938,6.688,75.25,20.062,97.188C209.531,373.016,229.469,384,255.984,384c26.531,0,46.562-10.984,59.922-32.797\r\n\t\tC329.297,329.266,336,296.953,336,254.016C336,170,309.266,128,255.984,128z M292.219,330.719\r\n\t\tc-7.453,16.484-19.609,24.578-36.234,24.578c-16.688,0-28.703-8.094-36.266-24.578c-7.516-16.484-11.219-42.016-11.219-76.703\r\n\t\tc0-34.391,3.703-59.156,11.219-74.484c7.562-15.266,19.578-22.906,36.266-22.906c16.625,0,28.781,7.641,36.234,22.906\r\n\t\tc7.547,15.328,11.281,40.094,11.281,74.484C303.5,288.703,299.766,314.234,292.219,330.719z"},"children":[]}]}]}]};exports.numberZero=numberZero;var off={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"240","y":"128","width":"32","height":"80"},"children":[{"name":"rect","attribs":{"x":"240","y":"128","width":"32","height":"80"},"children":[]}]},{"name":"path","attribs":{"d":"M288,164.703v34.047c28.219,12.359,48,40.469,48,73.25c0,44.172-35.828,80-80,80c-44.188,0-80-35.828-80-80\r\n\t\tc0-32.781,19.766-60.891,48-73.25v-34.047c-46.25,13.766-80,56.562-80,107.297c0,61.859,50.141,112,112,112s112-50.141,112-112\r\n\t\tC368,221.266,334.25,178.469,288,164.703z"},"children":[{"name":"path","attribs":{"d":"M288,164.703v34.047c28.219,12.359,48,40.469,48,73.25c0,44.172-35.828,80-80,80c-44.188,0-80-35.828-80-80\r\n\t\tc0-32.781,19.766-60.891,48-73.25v-34.047c-46.25,13.766-80,56.562-80,107.297c0,61.859,50.141,112,112,112s112-50.141,112-112\r\n\t\tC368,221.266,334.25,178.469,288,164.703z"},"children":[]}]}]}]};exports.off=off;var officine2={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M284.516,258.023c3.609,4.391,9.984,4.969,14.281,1.25c4.25-3.594,4.812-10.031,1.328-14.375l76.828-65.281\r\n\tc8.359-7.125,9.438-19.875,2.422-28.406c-7.031-8.531-19.547-9.656-27.906-2.484l-76.812,65.234\r\n\tc-3.625-4.25-9.922-4.781-14.172-1.156c-4.289,3.656-4.836,10.203-1.227,14.547l6.211,7.547l-106.875,91.383l-14.219,4.453\r\n\tL128,352.438L140.828,368l23.523-12l7.195-14.031l106.781-91.477L284.516,258.023z"},"children":[]}]};exports.officine2=officine2;var officine={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M149.651,280.892c-15.734,15.734-26.062,37.047-19.781,56.891c0.781,2.469,22.594-5.531,22.594-5.531l10.547-24\r\n\tl29.297-5.625l8.531,8.547l8.531,8.531l-5.641,29.281l-23.984,10.547c0,0-8,21.812-5.531,22.609\r\n\tc19.844,6.266,41.156-4.062,56.891-19.812c17.344-17.328,21.203-42.891,11.891-64.062l134.172-122.516l6.828-20.469l-13.656-13.641\r\n\tl-13.641-13.641l-20.469,6.812L213.714,269.001C192.558,259.688,166.995,263.563,149.651,280.892z"},"children":[]}]};exports.officine=officine;var optionsSettings={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M152.312,242.875c17.797,14.688,42.258,16.219,61.484,5.828l4.227,3.828l18.062-14.906\r\n\t\tc-1.367-3.688-1.914-7.656-1.547-11.688c0.516-5.719,2.859-10.969,6.602-15.234c3.102-18.172-3.266-37.375-18.641-50.062\r\n\t\tc-16.188-13.344-37.164-21.203-55.352-13.766c-2.273,0.938,7.055,20.531,7.055,20.531l23.57,7.875L205.508,202l-7.359,8.625\r\n\t\tl-7.344,8.609l-28.141-2.844l-11.953-21.422c0,0-21.266-5.656-21.805-3.328C124.602,210.594,136.125,229.531,152.312,242.875z"},"children":[{"name":"path","attribs":{"d":"M152.312,242.875c17.797,14.688,42.258,16.219,61.484,5.828l4.227,3.828l18.062-14.906\r\n\t\tc-1.367-3.688-1.914-7.656-1.547-11.688c0.516-5.719,2.859-10.969,6.602-15.234c3.102-18.172-3.266-37.375-18.641-50.062\r\n\t\tc-16.188-13.344-37.164-21.203-55.352-13.766c-2.273,0.938,7.055,20.531,7.055,20.531l23.57,7.875L205.508,202l-7.359,8.625\r\n\t\tl-7.344,8.609l-28.141-2.844l-11.953-21.422c0,0-21.266-5.656-21.805-3.328C124.602,210.594,136.125,229.531,152.312,242.875z"},"children":[]}]},{"name":"path","attribs":{"d":"M375.875,322l-68.125-51.203c-1.406,2-2.969,3.859-4.938,5.484c-4.844,4.031-11.172,6.297-17.656,6.297\r\n\t\tc-4.891,0-9.609-1.266-13.75-3.594l-12.602,10.406l81.805,73.953L360.484,368l11.781-13.781L384,340.438L375.875,322z"},"children":[{"name":"path","attribs":{"d":"M375.875,322l-68.125-51.203c-1.406,2-2.969,3.859-4.938,5.484c-4.844,4.031-11.172,6.297-17.656,6.297\r\n\t\tc-4.891,0-9.609-1.266-13.75-3.594l-12.602,10.406l81.805,73.953L360.484,368l11.781-13.781L384,340.438L375.875,322z"},"children":[]}]},{"name":"path","attribs":{"d":"M278.047,261.312c3.297,3.875,9.156,4.391,13.078,1.125c3.891-3.188,4.406-8.875,1.234-12.75l70.375-57.672\r\n\t\tc7.672-6.328,8.672-17.578,2.234-25.125c-6.453-7.547-17.922-8.531-25.562-2.203L269,222.375c-3.297-3.781-9.07-4.266-12.961-1.031\r\n\t\tc-3.93,3.219-4.438,9.016-1.133,12.859l5.703,6.672l-97.93,80.781l-13.031,3.953l-15,19.156l11.75,13.766l21.555-10.594\r\n\t\tl6.586-12.406l97.836-80.859L278.047,261.312z"},"children":[{"name":"path","attribs":{"d":"M278.047,261.312c3.297,3.875,9.156,4.391,13.078,1.125c3.891-3.188,4.406-8.875,1.234-12.75l70.375-57.672\r\n\t\tc7.672-6.328,8.672-17.578,2.234-25.125c-6.453-7.547-17.922-8.531-25.562-2.203L269,222.375c-3.297-3.781-9.07-4.266-12.961-1.031\r\n\t\tc-3.93,3.219-4.438,9.016-1.133,12.859l5.703,6.672l-97.93,80.781l-13.031,3.953l-15,19.156l11.75,13.766l21.555-10.594\r\n\t\tl6.586-12.406l97.836-80.859L278.047,261.312z"},"children":[]}]}]}]};exports.optionsSettings=optionsSettings;var paperclipOblique={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M262.734,139.969l-38.016,41.438l-76.031,82.875l-9.5,10.344c-19.203,20.953-20.016,54.141,1.938,78.062\r\n\t\tc21.953,23.969,54.875,25.75,74.094,4.828l62.375-67.984l23.141-25.25l8.906-9.734c9.375-10.203,8.75-27.562-1.969-39.281\r\n\t\tc-10.734-11.688-26.656-12.359-36.031-2.141l-32.094,34.953c-9.359,10.234-7.812,28.562,2.906,40.266\r\n\t\tc1.781,1.953,5.938,5.375,6.312,4.969l-46.219,50.344c-12.234,13.344-34.766,10.469-48.734-4.75\r\n\t\tc-13.969-15.234-14.156-37.125-1.969-50.469l9.516-10.359l76.031-82.875l38.016-41.438c17.484-19.047,49.719-14.844,69.688,6.906\r\n\t\tc19.938,21.766,23.797,56.938,6.328,75.984L237.391,360.969c-3.5,3.812-4,9.422,0,13.812c4,4.328,9.156,3.812,12.656,0\r\n\t\tl114.062-124.312c24.438-26.672,21.578-73.141-6.359-103.609C329.828,116.406,287.172,113.312,262.734,139.969z M252.234,261.906\r\n\t\tl32.062-34.969c2.406-2.625,7.969-0.828,10.703,2.156c2.734,3,4.375,9.031,1.969,11.656l-8.906,9.719l-23.156,25.25\r\n\t\tc-2.406,2.625-7.938,0.812-10.688-2.172S249.828,264.516,252.234,261.906z"},"children":[{"name":"path","attribs":{"d":"M262.734,139.969l-38.016,41.438l-76.031,82.875l-9.5,10.344c-19.203,20.953-20.016,54.141,1.938,78.062\r\n\t\tc21.953,23.969,54.875,25.75,74.094,4.828l62.375-67.984l23.141-25.25l8.906-9.734c9.375-10.203,8.75-27.562-1.969-39.281\r\n\t\tc-10.734-11.688-26.656-12.359-36.031-2.141l-32.094,34.953c-9.359,10.234-7.812,28.562,2.906,40.266\r\n\t\tc1.781,1.953,5.938,5.375,6.312,4.969l-46.219,50.344c-12.234,13.344-34.766,10.469-48.734-4.75\r\n\t\tc-13.969-15.234-14.156-37.125-1.969-50.469l9.516-10.359l76.031-82.875l38.016-41.438c17.484-19.047,49.719-14.844,69.688,6.906\r\n\t\tc19.938,21.766,23.797,56.938,6.328,75.984L237.391,360.969c-3.5,3.812-4,9.422,0,13.812c4,4.328,9.156,3.812,12.656,0\r\n\t\tl114.062-124.312c24.438-26.672,21.578-73.141-6.359-103.609C329.828,116.406,287.172,113.312,262.734,139.969z M252.234,261.906\r\n\t\tl32.062-34.969c2.406-2.625,7.969-0.828,10.703,2.156c2.734,3,4.375,9.031,1.969,11.656l-8.906,9.719l-23.156,25.25\r\n\t\tc-2.406,2.625-7.938,0.812-10.688-2.172S249.828,264.516,252.234,261.906z"},"children":[]}]}]}]};exports.paperclipOblique=paperclipOblique;var paperclip={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M255.5,128c-35.281,0-64,25.125-64,56v48v96v12c0,24.266,18.719,44,46.453,44s49.547-19.734,49.547-44v-78.75V232v-11.25\r\n\tc0-11.844-10.453-21.5-24.016-21.5c-13.531,0-23.984,9.656-23.984,21.5v40.5c0,11.859,11.609,21.5,25.141,21.5\r\n\tc2.25,0,6.859-0.625,6.859-1.109V340c0,15.438-15.891,28-33.531,28S207.5,355.438,207.5,340v-12v-96v-48c0-22.062,22.797-40,48-40\r\n\ts48,17.938,48,40v144c0,4.422,2.938,8,8,8c5.047,0,8-3.578,8-8V184C319.5,153.125,290.781,128,255.5,128z M263.5,266.75\r\n\tc-3.453,0-8-2.469-8-5.5v-40.5c0-3.031,4.547-5.5,8-5.5c3.469,0,8,2.469,8,5.5V232v29.25C271.5,264.281,266.969,266.75,263.5,266.75\r\n\tz"},"children":[]}]};exports.paperclip=paperclip;var pause={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"271.5,336.5 335.5,336.5 335.5,211.5 335.5,176.5 271.5,176.5 \t\t"},"children":[{"name":"polygon","attribs":{"points":"271.5,336.5 335.5,336.5 335.5,211.5 335.5,176.5 271.5,176.5 \t\t"},"children":[]}]},{"name":"rect","attribs":{"x":"175.5","y":"176.5","width":"64","height":"160"},"children":[{"name":"rect","attribs":{"x":"175.5","y":"176.5","width":"64","height":"160"},"children":[]}]}]}]}]}]};exports.pause=pause;var pigMoney={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M265.875,153.75c-7.188,0-14.062,0.484-20.594,1.406c-5.594-7.094-14.656-13.25-26.219-17.062\r\n\t\tC200.922,132.125,159,120.875,159,134.328c11,7.578,20.281,32.953,31.156,44.203c-17.031,13.625-30.328,32.172-40.688,54.344\r\n\t\tc0,0-14.797,4.875-18.656,8.734c-3.875,3.891-3.625,43.125,0,46.75C134.422,292,152,295.922,152,295.922\r\n\t\tc8.75,19.281,21.828,35.078,38.469,46.656c-0.875,13.484-1.875,35.75,0.75,38.391c3.797,3.797,38.375,4.219,42.594,0\r\n\t\tc1.781-1.781,8.312-9.312,15.312-17.438c5.438,0.562,11,0.922,16.75,0.922c4.375,0,8.688-0.219,12.938-0.641\r\n\t\tc6.172,7.188,11.594,15.562,13.188,17.172c4.219,4.219,38.828,3.797,42.625,0c2.391-2.406,1.781-23.344,1-36.875\r\n\t\tC364.953,324.969,384,294.016,384,259.094C384,200.922,331.125,153.75,265.875,153.75z M326.891,330.672l-7.781,5.078l0.547,9.297\r\n\t\tc0.562,9.906,0.719,17.273,0.641,22.43c-2.125,0.141-4.672,0.023-7.578,0.023c0,0,0,0-0.016,0c-5.109,0-8.75-0.086-10.969-0.367\r\n\t\tc-0.109-0.156-0.234-0.215-0.359-0.387c-2.703-3.734-6.438-8.803-10.453-13.475l-5.422-6.284l-8.266,0.843\r\n\t\tc-3.734,0.375-7.516,0.569-11.359,0.569c-5.188,0-10.219-0.325-15.094-0.841l-8.312-0.857L237,353.046\r\n\t\tc-4.891,5.688-9.531,11.079-12.328,14.22c-2.141,0.312-5.953,0.672-11.547,0.672c-2.906,0-5.469-0.109-7.594-0.25\r\n\t\tc-0.031-4.797,0.156-12.359,0.906-24.078l0.578-9.047l-7.422-5.172c-14.375-10-25.5-23.5-33.031-40.125L163.25,282l-7.781-1.734\r\n\t\tc-3.719-0.844-7.906-2.016-11-3.031c-0.656-7.031-0.656-18.828,0.047-25.344c2.5-1.062,6.453-2.609,9.938-3.766l6.547-2.156\r\n\t\tl2.938-6.281c9.766-20.875,21.938-37.219,36.188-48.578l13.797-11.016l-12.266-12.719c-3.516-3.625-7.641-10.75-11.625-17.656\r\n\t\tc-0.656-1.156-1.328-2.312-2-3.438c8.562,1.781,18.062,4.438,26.047,7.062c8.047,2.656,14.844,6.938,18.641,11.75l5.688,7.25\r\n\t\tl9.094-1.281c5.906-0.844,12.062-1.266,18.375-1.266c56.312,0,102.125,40.062,102.125,89.297\r\n\t\tC368,287.516,353.016,313.594,326.891,330.672z"},"children":[{"name":"path","attribs":{"d":"M265.875,153.75c-7.188,0-14.062,0.484-20.594,1.406c-5.594-7.094-14.656-13.25-26.219-17.062\r\n\t\tC200.922,132.125,159,120.875,159,134.328c11,7.578,20.281,32.953,31.156,44.203c-17.031,13.625-30.328,32.172-40.688,54.344\r\n\t\tc0,0-14.797,4.875-18.656,8.734c-3.875,3.891-3.625,43.125,0,46.75C134.422,292,152,295.922,152,295.922\r\n\t\tc8.75,19.281,21.828,35.078,38.469,46.656c-0.875,13.484-1.875,35.75,0.75,38.391c3.797,3.797,38.375,4.219,42.594,0\r\n\t\tc1.781-1.781,8.312-9.312,15.312-17.438c5.438,0.562,11,0.922,16.75,0.922c4.375,0,8.688-0.219,12.938-0.641\r\n\t\tc6.172,7.188,11.594,15.562,13.188,17.172c4.219,4.219,38.828,3.797,42.625,0c2.391-2.406,1.781-23.344,1-36.875\r\n\t\tC364.953,324.969,384,294.016,384,259.094C384,200.922,331.125,153.75,265.875,153.75z M326.891,330.672l-7.781,5.078l0.547,9.297\r\n\t\tc0.562,9.906,0.719,17.273,0.641,22.43c-2.125,0.141-4.672,0.023-7.578,0.023c0,0,0,0-0.016,0c-5.109,0-8.75-0.086-10.969-0.367\r\n\t\tc-0.109-0.156-0.234-0.215-0.359-0.387c-2.703-3.734-6.438-8.803-10.453-13.475l-5.422-6.284l-8.266,0.843\r\n\t\tc-3.734,0.375-7.516,0.569-11.359,0.569c-5.188,0-10.219-0.325-15.094-0.841l-8.312-0.857L237,353.046\r\n\t\tc-4.891,5.688-9.531,11.079-12.328,14.22c-2.141,0.312-5.953,0.672-11.547,0.672c-2.906,0-5.469-0.109-7.594-0.25\r\n\t\tc-0.031-4.797,0.156-12.359,0.906-24.078l0.578-9.047l-7.422-5.172c-14.375-10-25.5-23.5-33.031-40.125L163.25,282l-7.781-1.734\r\n\t\tc-3.719-0.844-7.906-2.016-11-3.031c-0.656-7.031-0.656-18.828,0.047-25.344c2.5-1.062,6.453-2.609,9.938-3.766l6.547-2.156\r\n\t\tl2.938-6.281c9.766-20.875,21.938-37.219,36.188-48.578l13.797-11.016l-12.266-12.719c-3.516-3.625-7.641-10.75-11.625-17.656\r\n\t\tc-0.656-1.156-1.328-2.312-2-3.438c8.562,1.781,18.062,4.438,26.047,7.062c8.047,2.656,14.844,6.938,18.641,11.75l5.688,7.25\r\n\t\tl9.094-1.281c5.906-0.844,12.062-1.266,18.375-1.266c56.312,0,102.125,40.062,102.125,89.297\r\n\t\tC368,287.516,353.016,313.594,326.891,330.672z"},"children":[]}]},{"name":"path","attribs":{"d":"M302.75,191.719c-18.953-5.656-39.688,2.578-41.188,7.625s19.625-1.562,38.578,4.094\r\n\t\tc18.984,5.641,37.078,29.312,38.578,24.25C340.203,222.656,321.734,197.375,302.75,191.719z"},"children":[{"name":"path","attribs":{"d":"M302.75,191.719c-18.953-5.656-39.688,2.578-41.188,7.625s19.625-1.562,38.578,4.094\r\n\t\tc18.984,5.641,37.078,29.312,38.578,24.25C340.203,222.656,321.734,197.375,302.75,191.719z"},"children":[]}]},{"name":"path","attribs":{"d":"M207.672,213.469c-5.516,0-10,4.5-10,10.031s4.484,10.031,10,10.031s10-4.5,10-10.031S213.188,213.469,207.672,213.469z"},"children":[{"name":"path","attribs":{"d":"M207.672,213.469c-5.516,0-10,4.5-10,10.031s4.484,10.031,10,10.031s10-4.5,10-10.031S213.188,213.469,207.672,213.469z"},"children":[]}]}]}]};exports.pigMoney=pigMoney;var pinMap={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M304,191.953C304,165.469,282.516,144,256,144c-26.5,0-48,21.469-48,47.953c0,23.734,17.312,43.328,40,47.141v110.25\r\n\tc-13.781,1.047-24,4.766-24,9.156c0,5.234,14.328,9.5,32,9.5c17.656,0,32-4.266,32-9.5c0-4.391-10.219-8.109-24-9.156v-110.25\r\n\tC286.688,235.281,304,215.688,304,191.953z M236.406,181.75c-4.625,4.625-10.922,5.844-14.062,2.734\r\n\tc-3.125-3.141-1.875-9.422,2.75-14.047c4.641-4.625,10.938-5.859,14.062-2.75C242.266,170.812,241.047,177.109,236.406,181.75z"},"children":[]}]};exports.pinMap=pinMap;var pin={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,144c-44.188,0-80,38.609-80,80c0,22.031,11,32.344,32,69.906c18.453,32.984,33.859,62.938,33.859,62.938\r\n\t\tc7.641,14.859,20.172,14.875,27.828,0.031c0,0,15.516-30,34.312-62.969c21.406-37.562,32-47.859,32-69.906\r\n\t\tC336,182.609,300.188,144,256,144z M256,272c-26.5,0-48-21.5-48-48c0-26.508,21.5-48,48-48c26.516,0,48,21.492,48,48\r\n\t\tC304,250.5,282.516,272,256,272z"},"children":[{"name":"path","attribs":{"d":"M256,144c-44.188,0-80,38.609-80,80c0,22.031,11,32.344,32,69.906c18.453,32.984,33.859,62.938,33.859,62.938\r\n\t\tc7.641,14.859,20.172,14.875,27.828,0.031c0,0,15.516-30,34.312-62.969c21.406-37.562,32-47.859,32-69.906\r\n\t\tC336,182.609,300.188,144,256,144z M256,272c-26.5,0-48-21.5-48-48c0-26.508,21.5-48,48-48c26.516,0,48,21.492,48,48\r\n\t\tC304,250.5,282.516,272,256,272z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[]}]}]}]};exports.pin=pin;var play={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"192,336 352,256 192,176 \t"},"children":[{"name":"polygon","attribs":{"points":"192,336 352,256 192,176 \t"},"children":[]}]}]}]};exports.play=play;var plus={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"272,128 240,128 240,240 128,240 128,272 240,272 240,384 272,384 272,272 384,272 384,240 272,240 \t"},"children":[{"name":"polygon","attribs":{"points":"272,128 240,128 240,240 128,240 128,272 240,272 240,384 272,384 272,272 384,272 384,240 272,240 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.plus=plus;var podcast={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M230.406,256c0,14.141,11.453,25.594,25.594,25.594s25.594-11.453,25.594-25.594S270.141,230.406,256,230.406\r\n\t\tS230.406,241.859,230.406,256z"},"children":[{"name":"path","attribs":{"d":"M230.406,256c0,14.141,11.453,25.594,25.594,25.594s25.594-11.453,25.594-25.594S270.141,230.406,256,230.406\r\n\t\tS230.406,241.859,230.406,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M281.922,299.922l14.172,21.297c21.953-13.516,36.703-37.547,36.703-65.219c0-42.406-34.375-76.797-76.797-76.797\r\n\t\tc-42.406,0-76.797,34.391-76.797,76.797c0,27.672,14.75,51.703,36.688,65.219l14.203-21.297\r\n\t\tC215.016,291,204.797,274.781,204.797,256c0-28.281,22.922-51.203,51.203-51.203s51.203,22.922,51.203,51.203\r\n\t\tC307.203,274.781,296.969,291.031,281.922,299.922z"},"children":[{"name":"path","attribs":{"d":"M281.922,299.922l14.172,21.297c21.953-13.516,36.703-37.547,36.703-65.219c0-42.406-34.375-76.797-76.797-76.797\r\n\t\tc-42.406,0-76.797,34.391-76.797,76.797c0,27.672,14.75,51.703,36.688,65.219l14.203-21.297\r\n\t\tC215.016,291,204.797,274.781,204.797,256c0-28.281,22.922-51.203,51.203-51.203s51.203,22.922,51.203,51.203\r\n\t\tC307.203,274.781,296.969,291.031,281.922,299.922z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128c0,45.422,23.828,85.094,59.5,107.797l14.188-21.297\r\n\t\tc-28.797-18.125-48.094-49.953-48.094-86.5c0-56.547,45.859-102.406,102.406-102.406S358.406,199.453,358.406,256\r\n\t\tc0,36.547-19.312,68.406-48.109,86.5l14.203,21.297C360.172,341.094,384,301.422,384,256C384,185.312,326.703,128,256,128z"},"children":[{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128c0,45.422,23.828,85.094,59.5,107.797l14.188-21.297\r\n\t\tc-28.797-18.125-48.094-49.953-48.094-86.5c0-56.547,45.859-102.406,102.406-102.406S358.406,199.453,358.406,256\r\n\t\tc0,36.547-19.312,68.406-48.109,86.5l14.203,21.297C360.172,341.094,384,301.422,384,256C384,185.312,326.703,128,256,128z"},"children":[]}]},{"name":"polygon","attribs":{"points":"208,384 304,384 256,304 \t"},"children":[{"name":"polygon","attribs":{"points":"208,384 304,384 256,304 \t"},"children":[]}]}]}]};exports.podcast=podcast;var pounds={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M340.812,384H171.188v-25.969c22.844-10.812,43.359-34.062,43.359-61.906c0-7,0-13.188-1.547-20.562h-38.344v-32.906\r\n\t\th32.938c-1.562-10.469-3.5-23.25-3.5-36.031c0-47.641,33.688-78.625,81.75-78.625c20.5,0,35.641,4.656,43.75,9.281l-8.531,36.031\r\n\t\tc-7.375-3.875-18.188-7.359-33.297-7.359c-29.047,0-39.109,19.375-39.109,42.219c0,12.797,1.531,23.641,4.25,34.484h54.188v32.906\r\n\t\th-49.938c0.375,11.625,0.375,23.25-2.688,34.484c-3.891,13.172-11.625,24.375-22.5,34.062v0.766h108.844V384z"},"children":[{"name":"path","attribs":{"d":"M340.812,384H171.188v-25.969c22.844-10.812,43.359-34.062,43.359-61.906c0-7,0-13.188-1.547-20.562h-38.344v-32.906\r\n\t\th32.938c-1.562-10.469-3.5-23.25-3.5-36.031c0-47.641,33.688-78.625,81.75-78.625c20.5,0,35.641,4.656,43.75,9.281l-8.531,36.031\r\n\t\tc-7.375-3.875-18.188-7.359-33.297-7.359c-29.047,0-39.109,19.375-39.109,42.219c0,12.797,1.531,23.641,4.25,34.484h54.188v32.906\r\n\t\th-49.938c0.375,11.625,0.375,23.25-2.688,34.484c-3.891,13.172-11.625,24.375-22.5,34.062v0.766h108.844V384z"},"children":[]}]}]}]};exports.pounds=pounds;var prevStep={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"polygon","attribs":{"points":"304,336 304,176 208,256 \t"},"children":[{"name":"polygon","attribs":{"points":"304,336 304,176 208,256 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"176,176 176,336 208,336 208,240 208,176 \t"},"children":[{"name":"polygon","attribs":{"points":"176,176 176,336 208,336 208,240 208,176 \t"},"children":[]}]}]}]};exports.prevStep=prevStep;var previousFastStep={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256S114.609,512,256,512z M256,40\r\n\t\tc119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[{"name":"path","attribs":{"d":"M256,512c141.391,0,256-114.609,256-256S397.391,0,256,0S0,114.609,0,256S114.609,512,256,512z M256,40\r\n\t\tc119.297,0,216,96.703,216,216s-96.703,216-216,216S40,375.297,40,256S136.703,40,256,40z"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,176 256,256 352,336 \t"},"children":[{"name":"polygon","attribs":{"points":"352,176 256,256 352,336 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"256,256 256,176 160,256 256,336 \t"},"children":[{"name":"polygon","attribs":{"points":"256,256 256,176 160,256 256,336 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"160,240 160,176 128,176 128,336 160,336 \t"},"children":[{"name":"polygon","attribs":{"points":"160,240 160,176 128,176 128,336 160,336 \t"},"children":[]}]}]}]};exports.previousFastStep=previousFastStep;var question={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"240","y":"352","width":"32","height":"32"},"children":[{"name":"rect","attribs":{"x":"240","y":"352","width":"32","height":"32"},"children":[]}]},{"name":"path","attribs":{"d":"M317.734,150.148c-6.484-6.625-14.688-11.922-24.766-16.031c-10.203-4.102-22.172-6.117-36.281-6.117\r\n\t\tc-11.969,0-22.875,2.016-32.781,6.117c-9.938,4.109-18.5,9.773-25.688,17.125c-7.125,7.289-12.672,14.508-16.5,24.773\r\n\t\tC177.906,186.281,176,192,176,208h32.656c0-16,4.234-28.109,12.938-38.516c8.594-10.453,20.266-14.82,35.094-14.82\r\n\t\tc14.438,0,25.234,3.914,32.172,10.938c6.875,7.023,10.391,17.086,10.391,29.797c0,9.883-3.25,18.758-9.734,26.492\r\n\t\tc-6.375,7.75-13.359,15.297-20.844,22.438c-7.594,7.141-13.672,14.766-19.953,22.641S240,284.016,240,294.469V320h32v-13.75\r\n\t\tc0-8.203,1.203-15.312,4.406-21.516c3.094-6.219,6.953-11.859,11.844-16.891c4.734-5.094,9.812-10,15.469-14.828\r\n\t\tc5.5-4.766,10.781-9.859,15.531-15.172c4.844-5.344,8.875-11.344,11.938-17.969c3.219-6.625,4.828-14.406,4.828-23.477\r\n\t\tc0-7.875-1.422-15.891-4.391-24.039C328.719,164.148,324.031,156.766,317.734,150.148z"},"children":[{"name":"path","attribs":{"d":"M317.734,150.148c-6.484-6.625-14.688-11.922-24.766-16.031c-10.203-4.102-22.172-6.117-36.281-6.117\r\n\t\tc-11.969,0-22.875,2.016-32.781,6.117c-9.938,4.109-18.5,9.773-25.688,17.125c-7.125,7.289-12.672,14.508-16.5,24.773\r\n\t\tC177.906,186.281,176,192,176,208h32.656c0-16,4.234-28.109,12.938-38.516c8.594-10.453,20.266-14.82,35.094-14.82\r\n\t\tc14.438,0,25.234,3.914,32.172,10.938c6.875,7.023,10.391,17.086,10.391,29.797c0,9.883-3.25,18.758-9.734,26.492\r\n\t\tc-6.375,7.75-13.359,15.297-20.844,22.438c-7.594,7.141-13.672,14.766-19.953,22.641S240,284.016,240,294.469V320h32v-13.75\r\n\t\tc0-8.203,1.203-15.312,4.406-21.516c3.094-6.219,6.953-11.859,11.844-16.891c4.734-5.094,9.812-10,15.469-14.828\r\n\t\tc5.5-4.766,10.781-9.859,15.531-15.172c4.844-5.344,8.875-11.344,11.938-17.969c3.219-6.625,4.828-14.406,4.828-23.477\r\n\t\tc0-7.875-1.422-15.891-4.391-24.039C328.719,164.148,324.031,156.766,317.734,150.148z"},"children":[]}]}]}]};exports.question=question;var quote={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M239.078,185.492L209.25,160C172.219,187.18,144,235.609,144,287.438C144,329.047,167.344,352,193.969,352\r\n\t\tc24.172,0,43.5-20.375,43.5-45.922c0-24.625-16.891-43.281-39.469-43.281c-4.031,0-9.656,1.688-10.5,1.688\r\n\t\tC190.75,237.312,213.281,203.344,239.078,185.492z"},"children":[{"name":"path","attribs":{"d":"M239.078,185.492L209.25,160C172.219,187.18,144,235.609,144,287.438C144,329.047,167.344,352,193.969,352\r\n\t\tc24.172,0,43.5-20.375,43.5-45.922c0-24.625-16.891-43.281-39.469-43.281c-4.031,0-9.656,1.688-10.5,1.688\r\n\t\tC190.75,237.312,213.281,203.344,239.078,185.492z"},"children":[]}]},{"name":"path","attribs":{"d":"M326.938,262.797c-3.234,0-8.922,1.688-10.5,1.688c3.203-27.172,25.781-61.141,51.562-78.992L338.188,160\r\n\t\tc-37.031,27.18-65.234,75.609-65.234,127.438c0,41.609,23.328,64.562,49.953,64.562c24.141,0,43.469-20.375,43.469-45.922\r\n\t\tC366.375,281.453,349.516,262.797,326.938,262.797z"},"children":[{"name":"path","attribs":{"d":"M326.938,262.797c-3.234,0-8.922,1.688-10.5,1.688c3.203-27.172,25.781-61.141,51.562-78.992L338.188,160\r\n\t\tc-37.031,27.18-65.234,75.609-65.234,127.438c0,41.609,23.328,64.562,49.953,64.562c24.141,0,43.469-20.375,43.469-45.922\r\n\t\tC366.375,281.453,349.516,262.797,326.938,262.797z"},"children":[]}]}]}]};exports.quote=quote;var random={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"336,224 336,240 384,208.25 336,176 336,192 272,192 208,288 128,288.25 128,320 224,320 288,224 \t\t"},"children":[{"name":"polygon","attribs":{"points":"336,224 336,240 384,208.25 336,176 336,192 272,192 208,288 128,288.25 128,320 224,320 288,224 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"219.719,241.578 238.391,213.578 224,192 128,192 128,224 208,224 \t\t"},"children":[{"name":"polygon","attribs":{"points":"219.719,241.578 238.391,213.578 224,192 128,192 128,224 208,224 \t\t"},"children":[]}]},{"name":"polygon","attribs":{"points":"336,288 288,288 276.281,270.422 257.625,298.422 272,320 336,320 336,336 384,303.75 336,272 \t\t"},"children":[{"name":"polygon","attribs":{"points":"336,288 288,288 276.281,270.422 257.625,298.422 272,320 336,320 336,336 384,303.75 336,272 \t\t"},"children":[]}]}]}]}]}]};exports.random=random;var rec={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M336,256c0,44.188-35.812,80-80,80s-80-35.812-80-80s35.812-80,80-80S336,211.812,336,256z"},"children":[]}]};exports.rec=rec;var refresh={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M354.554,236.532c6.422,31.797-2.75,66.047-27.484,90.703c-39.234,39.203-102.907,39.203-142.172,0\r\n\tc-39.281-39.188-39.266-102.688,0-141.859c39.094-38.984,102.782-38.641,141.594-0.484l-13.828,14.391l63.609,14.469l-17.875-62.016\r\n\tl-12.891,13.375c-51.719-50.594-130.329-48.641-180.016,0.906c-49.984,49.875-49.984,130.703,0,180.562\r\n\tc50,49.891,131.016,49.891,181,0c28.25-28.125,40.5-66.125,36.891-102.828L354.554,236.532z"},"children":[]}]};exports.refresh=refresh;var reportComment={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256-2C114.609-2,0,112.609,0,254s114.609,256,256,256s256-114.609,256-256S397.391-2,256-2z M256,470\r\n\tc-119.297,0-216-96.703-216-216S136.703,38,256,38s216,96.703,216,216S375.297,470,256,470z"},"children":[]},{"name":"path","attribs":{"d":"M349.328,142H162.664C152.359,142,144,150.359,144,160.656v122.672c0,10.312,8.359,18.672,18.664,18.672H176v64l37.336-64\r\n\th135.992c10.312,0,18.672-8.359,18.672-18.672V160.656C368,150.359,359.641,142,349.328,142z M336,270h-96v-16h96V270z M336,222H176\r\n\tv-16h160V222z M336,190H176v-16h160V190z"},"children":[]}]};exports.reportComment=reportComment;var retweet={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"160,208 176,192 320,192 320,176 352,208 320,240 320,224 192,224 192,240 160,272 \t"},"children":[{"name":"polygon","attribs":{"points":"160,208 176,192 320,192 320,176 352,208 320,240 320,224 192,224 192,240 160,272 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,304 336,320 192,320 192,336 160,304 192,272 192,288 320,288 320,272 352,240 \t"},"children":[{"name":"polygon","attribs":{"points":"352,304 336,320 192,320 192,336 160,304 192,272 192,288 320,288 320,272 352,240 \t"},"children":[]}]}]}]};exports.retweet=retweet;var rss={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M128,230.391v51.203c56.547,0,102.406,45.844,102.406,102.406h51.188C281.594,299.188,212.844,230.391,128,230.391z"},"children":[{"name":"path","attribs":{"d":"M128,230.391v51.203c56.547,0,102.406,45.844,102.406,102.406h51.188C281.594,299.188,212.844,230.391,128,230.391z"},"children":[]}]},{"name":"path","attribs":{"d":"M128,128v51.203c113.094,0,204.812,91.703,204.812,204.797H384C384,242.609,269.406,128,128,128z"},"children":[{"name":"path","attribs":{"d":"M128,128v51.203c113.094,0,204.812,91.703,204.812,204.797H384C384,242.609,269.406,128,128,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M153.594,332.797c-14.141,0-25.594,11.453-25.594,25.609C128,372.547,139.453,384,153.594,384\r\n\t\tc14.156,0,25.609-11.453,25.609-25.594C179.203,344.25,167.75,332.797,153.594,332.797z"},"children":[{"name":"path","attribs":{"d":"M153.594,332.797c-14.141,0-25.594,11.453-25.594,25.609C128,372.547,139.453,384,153.594,384\r\n\t\tc14.156,0,25.609-11.453,25.609-25.594C179.203,344.25,167.75,332.797,153.594,332.797z"},"children":[]}]}]}]};exports.rss=rss;var rules={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[{"name":"rect","attribs":{"x":"128","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"64","height":"64"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 368,160 352,160 352,128 336,128 336,144 320,144 320,128 \r\n\t\t304,128 304,160 288,160 288,128 272,128 272,144 256,144 256,128 240,128 240,160 224,160 224,128 208,128 208,192 384,192 \r\n\t\t384,128 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"368,128 368,160 352,160 352,128 336,128 336,144 320,144 320,128 \r\n\t\t304,128 304,160 288,160 288,128 272,128 272,144 256,144 256,128 240,128 240,160 224,160 224,128 208,128 208,192 384,192 \r\n\t\t384,128 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"128,224 144,224 144,240 128,240 128,256 160,256 160,272 128,272 \r\n\t\t128,288 144,288 144,304 128,304 128,320 160,320 160,336 128,336 128,352 144,352 144,368 128,368 128,384 192,384 192,208 \r\n\t\t128,208 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"128,224 144,224 144,240 128,240 128,256 160,256 160,272 128,272 \r\n\t\t128,288 144,288 144,304 128,304 128,320 160,320 160,336 128,336 128,352 144,352 144,368 128,368 128,384 192,384 192,208 \r\n\t\t128,208 \t"},"children":[]}]}]}]};exports.rules=rules;var scale={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"119.5","y":"296.5","width":"112","height":"64"},"children":[{"name":"rect","attribs":{"x":"119.5","y":"296.5","width":"112","height":"64"},"children":[]}]},{"name":"polygon","attribs":{"points":"119.5,232.5 135.5,232.5 135.5,184.5 359.5,184.5 359.5,344.5 327.5,344.5 327.5,360.5 375.5,360.5 375.5,168.5 \r\n\t\t119.5,168.5 \t"},"children":[{"name":"polygon","attribs":{"points":"119.5,232.5 135.5,232.5 135.5,184.5 359.5,184.5 359.5,344.5 327.5,344.5 327.5,360.5 375.5,360.5 375.5,168.5 \r\n\t\t119.5,168.5 \t"},"children":[]}]},{"name":"polygon","attribs":{"points":"119.5,280.5 135.5,280.5 135.5,264.5 295.5,264.5 295.5,344.5 247.5,344.5 247.5,360.5 311.5,360.5 311.5,248.5 \r\n\t\t119.5,248.5 \t"},"children":[{"name":"polygon","attribs":{"points":"119.5,280.5 135.5,280.5 135.5,264.5 295.5,264.5 295.5,344.5 247.5,344.5 247.5,360.5 311.5,360.5 311.5,248.5 \r\n\t\t119.5,248.5 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[]}]}]}]};exports.scale=scale;var search={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill":"#1D1D1B","d":"M302.188,279.563C313.36,263.875,320,244.727,320,224c0-53.032-42.984-96-96-96c-53.017,0-96,42.968-96,96\r\n\t\t\tc0,53.016,42.983,96,96,96c20.727,0,39.875-6.64,55.563-17.812l77.124,77.124c6.25,6.252,16.375,6.252,22.624,0\r\n\t\t\tc6.252-6.249,6.252-16.374,0-22.623L302.188,279.563z M278.953,256.319c-5.53,9.36-13.273,17.104-22.634,22.634\r\n\t\t\tC246.805,284.563,235.843,288,224,288c-35.345,0-64-28.656-64-64s28.655-64,64-64c35.344,0,64,28.656,64,64\r\n\t\t\tC288,235.843,284.563,246.805,278.953,256.319z M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\t\tS397.391,0,256,0z M256,472c-119.298,0-216-96.702-216-216c0-119.297,96.702-216,216-216s216,96.703,216,216\r\n\t\t\tC472,375.298,375.298,472,256,472z"},"children":[{"name":"path","attribs":{"fill":"#1D1D1B","d":"M302.188,279.563C313.36,263.875,320,244.727,320,224c0-53.032-42.984-96-96-96c-53.017,0-96,42.968-96,96\r\n\t\t\tc0,53.016,42.983,96,96,96c20.727,0,39.875-6.64,55.563-17.812l77.124,77.124c6.25,6.252,16.375,6.252,22.624,0\r\n\t\t\tc6.252-6.249,6.252-16.374,0-22.623L302.188,279.563z M278.953,256.319c-5.53,9.36-13.273,17.104-22.634,22.634\r\n\t\t\tC246.805,284.563,235.843,288,224,288c-35.345,0-64-28.656-64-64s28.655-64,64-64c35.344,0,64,28.656,64,64\r\n\t\t\tC288,235.843,284.563,246.805,278.953,256.319z M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\t\tS397.391,0,256,0z M256,472c-119.298,0-216-96.702-216-216c0-119.297,96.702-216,216-216s216,96.703,216,216\r\n\t\t\tC472,375.298,375.298,472,256,472z"},"children":[]}]}]}]}]}]};exports.search=search;var selectCircle={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M177.914,311.906l-12.969,9.312c6.844,9.516,15.094,17.922,24.547,24.906l9.516-12.828\r\n\t\tC190.883,327.281,183.789,320.094,177.914,311.906z"},"children":[{"name":"path","attribs":{"d":"M177.914,311.906l-12.969,9.312c6.844,9.516,15.094,17.922,24.547,24.906l9.516-12.828\r\n\t\tC190.883,327.281,183.789,320.094,177.914,311.906z"},"children":[]}]},{"name":"path","attribs":{"d":"M144.008,255.406V256c0,11.578,1.766,23,5.25,33.953l15.188-4.844c-2.969-9.375-4.469-19.172-4.469-29.109L144.008,255.406\r\n\t\tz"},"children":[{"name":"path","attribs":{"d":"M144.008,255.406V256c0,11.578,1.766,23,5.25,33.953l15.188-4.844c-2.969-9.375-4.469-19.172-4.469-29.109L144.008,255.406\r\n\t\tz"},"children":[]}]},{"name":"path","attribs":{"d":"M165.711,189.75c-6.953,9.469-12.375,19.938-16.078,31.078l15.172,5.016c3.141-9.562,7.797-18.531,13.766-26.625\r\n\t\tL165.711,189.75z"},"children":[{"name":"path","attribs":{"d":"M165.711,189.75c-6.953,9.469-12.375,19.938-16.078,31.078l15.172,5.016c3.141-9.562,7.797-18.531,13.766-26.625\r\n\t\tL165.711,189.75z"},"children":[]}]},{"name":"path","attribs":{"d":"M220.539,362.25c11.078,3.719,22.688,5.625,34.469,5.75l0.156-15.969c-10.125-0.094-20.062-1.734-29.594-4.922\r\n\t\tL220.539,362.25z"},"children":[{"name":"path","attribs":{"d":"M220.539,362.25c11.078,3.719,22.688,5.625,34.469,5.75l0.156-15.969c-10.125-0.094-20.062-1.734-29.594-4.922\r\n\t\tL220.539,362.25z"},"children":[]}]},{"name":"path","attribs":{"d":"M221.758,149.344c-11.156,3.594-21.672,8.922-31.25,15.797l9.375,12.938c8.156-5.891,17.172-10.453,26.75-13.516\r\n\t\tL221.758,149.344z"},"children":[{"name":"path","attribs":{"d":"M221.758,149.344c-11.156,3.594-21.672,8.922-31.25,15.797l9.375,12.938c8.156-5.891,17.172-10.453,26.75-13.516\r\n\t\tL221.758,149.344z"},"children":[]}]},{"name":"path","attribs":{"d":"M290.883,149.531c-11.109-3.625-22.719-5.484-34.562-5.531l-0.031,15.969c10.125,0.047,20.109,1.625,29.609,4.734\r\n\t\tL290.883,149.531z"},"children":[{"name":"path","attribs":{"d":"M290.883,149.531c-11.109-3.625-22.719-5.484-34.562-5.531l-0.031,15.969c10.125,0.047,20.109,1.625,29.609,4.734\r\n\t\tL290.883,149.531z"},"children":[]}]},{"name":"path","attribs":{"d":"M333.117,313.25l12.828,9.547c7.031-9.469,12.5-19.891,16.234-31.016l-15.125-5.062\r\n\t\tC343.836,296.203,339.164,305.125,333.117,313.25z"},"children":[{"name":"path","attribs":{"d":"M333.117,313.25l12.828,9.547c7.031-9.469,12.5-19.891,16.234-31.016l-15.125-5.062\r\n\t\tC343.836,296.203,339.164,305.125,333.117,313.25z"},"children":[]}]},{"name":"path","attribs":{"d":"M362.555,221.469l-15.188,4.906c3.078,9.562,4.672,19.516,4.672,29.625l11.203,0.844l4.75-0.531\r\n\t\tC367.992,244.219,366.164,232.609,362.555,221.469z"},"children":[{"name":"path","attribs":{"d":"M362.555,221.469l-15.188,4.906c3.078,9.562,4.672,19.516,4.672,29.625l11.203,0.844l4.75-0.531\r\n\t\tC367.992,244.219,366.164,232.609,362.555,221.469z"},"children":[]}]},{"name":"path","attribs":{"d":"M284.82,347.625l4.797,15.234c11.188-3.516,21.734-8.766,31.328-15.594l-9.266-13.016\r\n\t\tC303.461,340.109,294.414,344.609,284.82,347.625z"},"children":[{"name":"path","attribs":{"d":"M284.82,347.625l4.797,15.234c11.188-3.516,21.734-8.766,31.328-15.594l-9.266-13.016\r\n\t\tC303.461,340.109,294.414,344.609,284.82,347.625z"},"children":[]}]},{"name":"path","attribs":{"d":"M346.68,190.25c-6.875-9.469-15.188-17.812-24.719-24.719l-9.406,12.859c8.156,5.969,15.297,13.125,21.203,21.266\r\n\t\tL346.68,190.25z"},"children":[{"name":"path","attribs":{"d":"M346.68,190.25c-6.875-9.469-15.188-17.812-24.719-24.719l-9.406,12.859c8.156,5.969,15.297,13.125,21.203,21.266\r\n\t\tL346.68,190.25z"},"children":[]}]}]}]};exports.selectCircle=selectCircle;var selectSquare={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"351.906","y":"224.031","width":"15.984","height":"63.938"},"children":[{"name":"rect","attribs":{"x":"351.906","y":"224.031","width":"15.984","height":"63.938"},"children":[]}]},{"name":"path","attribs":{"d":"M344.047,144h-8.016v15.984h8.016c4.375,0,7.969,3.578,7.969,7.984v8H368v-8C368,154.766,357.234,144,344.047,144z"},"children":[{"name":"path","attribs":{"d":"M344.047,144h-8.016v15.984h8.016c4.375,0,7.969,3.578,7.969,7.984v8H368v-8C368,154.766,357.234,144,344.047,144z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.031","y":"144.125","width":"63.938","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.031","y":"144.125","width":"63.938","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M144,167.969l0.125,8.125h15.984l-0.125-8.125c0-4.406,3.578-7.984,7.984-7.984h8V144h-8\r\n\t\tC154.75,144,144,154.766,144,167.969z"},"children":[{"name":"path","attribs":{"d":"M144,167.969l0.125,8.125h15.984l-0.125-8.125c0-4.406,3.578-7.984,7.984-7.984h8V144h-8\r\n\t\tC154.75,144,144,154.766,144,167.969z"},"children":[]}]},{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.938"},"children":[{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.938"},"children":[]}]},{"name":"path","attribs":{"d":"M159.984,344.047v-8.016H144v8.016C144,357.25,154.75,368,167.969,368h8v-15.984h-8\r\n\t\tC163.562,352.016,159.984,348.422,159.984,344.047z"},"children":[{"name":"path","attribs":{"d":"M159.984,344.047v-8.016H144v8.016C144,357.25,154.75,368,167.969,368h8v-15.984h-8\r\n\t\tC163.562,352.016,159.984,348.422,159.984,344.047z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.031","y":"351.906","width":"63.938","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.031","y":"351.906","width":"63.938","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M352.016,344.047c0,4.375-3.594,7.969-7.969,7.969h-8.016V368h8.016C357.234,368,368,357.25,368,344.047v-8.016h-15.984\r\n\t\tV344.047z"},"children":[{"name":"path","attribs":{"d":"M352.016,344.047c0,4.375-3.594,7.969-7.969,7.969h-8.016V368h8.016C357.234,368,368,357.25,368,344.047v-8.016h-15.984\r\n\t\tV344.047z"},"children":[]}]}]}]};exports.selectSquare=selectSquare;var setting={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M368,274.672v-37.328h-20.547c-0.75-3.703-2.109-7.156-3.281-10.688l18.141-10.469l-18.672-32.336l-18.094,10.445\r\n\t\t\tc-2.469-2.766-5.078-5.367-7.844-7.828l10.469-18.109l-32.328-18.672l-10.469,18.156c-3.547-1.18-6.984-2.539-10.703-3.297V144\r\n\t\t\th-37.344v20.547c-3.688,0.758-7.141,2.117-10.656,3.281l-10.484-18.141l-32.344,18.656l10.453,18.117\r\n\t\t\tc-2.766,2.461-5.359,5.047-7.828,7.82l-18.109-10.461l-18.672,32.336l18.156,10.469c-1.188,3.547-2.547,7-3.297,10.719H144v37.328\r\n\t\t\th20.547c0.75,3.703,2.109,7.156,3.281,10.672l-18.172,10.5l18.672,32.344l18.141-10.469c2.469,2.781,5.062,5.375,7.844,7.828\r\n\t\t\tl-10.469,18.141l32.328,18.672l10.5-18.188c3.516,1.172,6.969,2.547,10.656,3.281V368h37.344v-20.547\r\n\t\t\tc3.688-0.734,7.156-2.109,10.703-3.297l10.469,18.188l32.344-18.672l-10.469-18.141c2.781-2.469,5.359-5.062,7.844-7.844\r\n\t\t\tl18.125,10.469l18.656-32.344l-18.172-10.5c1.172-3.516,2.531-6.938,3.281-10.641H368z M256,312c-30.906,0-56-25.062-56-56\r\n\t\t\tc0-30.906,25.094-56,56-56c30.938,0,56,25.094,56,56C312,286.938,286.938,312,256,312z M256,237.344\r\n\t\t\tc-10.312,0-18.672,8.344-18.672,18.656s8.359,18.672,18.672,18.672s18.672-8.359,18.672-18.672S266.312,237.344,256,237.344z"},"children":[{"name":"path","attribs":{"d":"M368,274.672v-37.328h-20.547c-0.75-3.703-2.109-7.156-3.281-10.688l18.141-10.469l-18.672-32.336l-18.094,10.445\r\n\t\t\tc-2.469-2.766-5.078-5.367-7.844-7.828l10.469-18.109l-32.328-18.672l-10.469,18.156c-3.547-1.18-6.984-2.539-10.703-3.297V144\r\n\t\t\th-37.344v20.547c-3.688,0.758-7.141,2.117-10.656,3.281l-10.484-18.141l-32.344,18.656l10.453,18.117\r\n\t\t\tc-2.766,2.461-5.359,5.047-7.828,7.82l-18.109-10.461l-18.672,32.336l18.156,10.469c-1.188,3.547-2.547,7-3.297,10.719H144v37.328\r\n\t\t\th20.547c0.75,3.703,2.109,7.156,3.281,10.672l-18.172,10.5l18.672,32.344l18.141-10.469c2.469,2.781,5.062,5.375,7.844,7.828\r\n\t\t\tl-10.469,18.141l32.328,18.672l10.5-18.188c3.516,1.172,6.969,2.547,10.656,3.281V368h37.344v-20.547\r\n\t\t\tc3.688-0.734,7.156-2.109,10.703-3.297l10.469,18.188l32.344-18.672l-10.469-18.141c2.781-2.469,5.359-5.062,7.844-7.844\r\n\t\t\tl18.125,10.469l18.656-32.344l-18.172-10.5c1.172-3.516,2.531-6.938,3.281-10.641H368z M256,312c-30.906,0-56-25.062-56-56\r\n\t\t\tc0-30.906,25.094-56,56-56c30.938,0,56,25.094,56,56C312,286.938,286.938,312,256,312z M256,237.344\r\n\t\t\tc-10.312,0-18.672,8.344-18.672,18.656s8.359,18.672,18.672,18.672s18.672-8.359,18.672-18.672S266.312,237.344,256,237.344z"},"children":[]}]}]}]}]}]};exports.setting=setting;var settings={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M261.078,275.656l18.578-18.594l-24.719-24.734l-18.594,18.594c-2.953-1.547-6.031-2.812-9.25-3.828v-26.297h-34.984\r\n\t\t\tv26.297c-3.219,1.016-6.297,2.281-9.266,3.828l-18.594-18.578l-24.719,24.719l18.594,18.594c-1.562,2.953-2.812,6.031-3.844,9.25\r\n\t\t\tH128v34.984h26.281c1.031,3.219,2.281,6.297,3.844,9.25l-18.594,18.594l24.734,24.734l18.578-18.594\r\n\t\t\tc2.969,1.547,6.031,2.797,9.266,3.828V384h34.984v-26.281c3.219-1.031,6.297-2.297,9.25-3.844l18.594,18.594l24.734-24.734\r\n\t\t\tl-18.594-18.578c1.547-2.969,2.812-6.031,3.828-9.266h26.297v-34.984h-26.297C263.891,281.688,262.625,278.609,261.078,275.656z\r\n\t\t\t M209.594,337.375c-19.312,0-34.969-15.656-34.969-34.969c0-19.328,15.656-34.969,34.969-34.969\r\n\t\t\tc19.328,0,34.969,15.641,34.969,34.969C244.562,321.719,228.922,337.375,209.594,337.375z"},"children":[{"name":"path","attribs":{"d":"M261.078,275.656l18.578-18.594l-24.719-24.734l-18.594,18.594c-2.953-1.547-6.031-2.812-9.25-3.828v-26.297h-34.984\r\n\t\t\tv26.297c-3.219,1.016-6.297,2.281-9.266,3.828l-18.594-18.578l-24.719,24.719l18.594,18.594c-1.562,2.953-2.812,6.031-3.844,9.25\r\n\t\t\tH128v34.984h26.281c1.031,3.219,2.281,6.297,3.844,9.25l-18.594,18.594l24.734,24.734l18.578-18.594\r\n\t\t\tc2.969,1.547,6.031,2.797,9.266,3.828V384h34.984v-26.281c3.219-1.031,6.297-2.297,9.25-3.844l18.594,18.594l24.734-24.734\r\n\t\t\tl-18.594-18.578c1.547-2.969,2.812-6.031,3.828-9.266h26.297v-34.984h-26.297C263.891,281.688,262.625,278.609,261.078,275.656z\r\n\t\t\t M209.594,337.375c-19.312,0-34.969-15.656-34.969-34.969c0-19.328,15.656-34.969,34.969-34.969\r\n\t\t\tc19.328,0,34.969,15.641,34.969,34.969C244.562,321.719,228.922,337.375,209.594,337.375z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,197.281v-24.453h-18.391c-0.703-2.258-1.594-4.406-2.672-6.469l12.969-13.008l-17.281-17.289l-13,13\r\n\t\t\tc-2.047-1.086-4.219-1.969-6.469-2.68V128h-24.438v18.383c-2.25,0.711-4.422,1.602-6.484,2.68l-13-12.992l-17.297,17.289l13,13\r\n\t\t\tc-1.078,2.062-1.969,4.211-2.672,6.469h-18.391v24.453h18.391c0.703,2.258,1.594,4.406,2.672,6.469l-13,13l17.312,17.297\r\n\t\t\tl12.984-13c2.062,1.078,4.219,1.953,6.484,2.672v18.391h24.438v-18.375c2.25-0.719,4.422-1.609,6.469-2.688l13,13l17.312-17.297\r\n\t\t\tl-13-12.984c1.078-2.078,1.969-4.219,2.672-6.484H384z M326.938,209.5c-13.5,0-24.453-10.938-24.453-24.438\r\n\t\t\tc0-13.516,10.953-24.461,24.453-24.461c13.516,0,24.453,10.945,24.453,24.461C351.391,198.562,340.453,209.5,326.938,209.5z"},"children":[{"name":"path","attribs":{"d":"M384,197.281v-24.453h-18.391c-0.703-2.258-1.594-4.406-2.672-6.469l12.969-13.008l-17.281-17.289l-13,13\r\n\t\t\tc-2.047-1.086-4.219-1.969-6.469-2.68V128h-24.438v18.383c-2.25,0.711-4.422,1.602-6.484,2.68l-13-12.992l-17.297,17.289l13,13\r\n\t\t\tc-1.078,2.062-1.969,4.211-2.672,6.469h-18.391v24.453h18.391c0.703,2.258,1.594,4.406,2.672,6.469l-13,13l17.312,17.297\r\n\t\t\tl12.984-13c2.062,1.078,4.219,1.953,6.484,2.672v18.391h24.438v-18.375c2.25-0.719,4.422-1.609,6.469-2.688l13,13l17.312-17.297\r\n\t\t\tl-13-12.984c1.078-2.078,1.969-4.219,2.672-6.484H384z M326.938,209.5c-13.5,0-24.453-10.938-24.453-24.438\r\n\t\t\tc0-13.516,10.953-24.461,24.453-24.461c13.516,0,24.453,10.945,24.453,24.461C351.391,198.562,340.453,209.5,326.938,209.5z"},"children":[]}]}]}]}]}]};exports.settings=settings;var shield={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M367.625,161.469c0,0-37.266,4.281-55.875,0c-17.609-4.031-56.062-33.562-56.203-33.469\r\n\tc-3.766,2.938-38.188,29.531-55.266,33.469c-18.641,4.281-55.906,0-55.906,0S139.719,214.984,163,281.359\r\n\tc22.625,64.453,92.969,102.656,93,102.641c0.031,0.016,70.391-38.188,92.969-102.641\r\n\tC372.266,214.984,367.625,161.469,367.625,161.469z M315.797,271.516C303.984,305.219,275,330.875,256,344.781\r\n\tc-18.969-13.891-48-39.547-59.828-73.25c-10.391-29.625-14.641-56.625-16.312-76.156c11.562-0.094,21.016-1.031,28.875-2.844\r\n\tc13.984-3.203,31.297-13.062,47.234-23.906c25.953,17.344,38.812,21.969,47.328,23.906c7.828,1.812,17.281,2.75,28.844,2.844\r\n\tC330.484,214.891,326.219,241.844,315.797,271.516z"},"children":[]}]};exports.shield=shield;var signFemale={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M272,253.734c27.562-7.141,48-31.953,48-61.734c0-35.344-28.641-64-64-64c-35.344,0-64,28.656-64,64\r\n\tc0,29.781,20.453,54.594,48,61.734V320h-32v32h32v32h32v-32h32v-32h-32V253.734z M256,224c-17.672,0-32-14.312-32-32\r\n\ts14.328-32,32-32s32,14.312,32,32S273.672,224,256,224z"},"children":[]}]};exports.signFemale=signFemale;var signMale={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M293.086,151.031l22.625,22.625l-91,90.984c-9.5-5.609-20.469-9.047-32.312-9.047c-35.344,0-64,28.656-64,64\r\n\ts28.656,64,64,64c35.359,0,64-28.656,64-64c0-11.859-3.438-22.812-9.062-32.328l91-90.984l22.625,22.625l22.641-90.5\r\n\tL293.086,151.031z M192.398,351.594c-17.672,0-32-14.312-32-32s14.328-32,32-32s32,14.312,32,32S210.07,351.594,192.398,351.594z"},"children":[]}]};exports.signMale=signMale;var slidersVertical={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,328c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S176,314.75,176,328z"},"children":[{"name":"path","attribs":{"d":"M176,328c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S176,314.75,176,328z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,280c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S384,266.75,384,280z"},"children":[{"name":"path","attribs":{"d":"M384,280c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S384,266.75,384,280z"},"children":[]}]},{"name":"path","attribs":{"d":"M240,184c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S240,170.75,240,184z"},"children":[{"name":"path","attribs":{"d":"M240,184c0,13.25-10.75,24-24,24s-24-10.75-24-24s10.75-24,24-24S240,170.75,240,184z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M208,223.188V384h16V223.188c-2.594,0.531-5.25,0.812-8,0.812S210.594,223.719,208,223.188z"},"children":[{"name":"path","attribs":{"d":"M208,223.188V384h16V223.188c-2.594,0.531-5.25,0.812-8,0.812S210.594,223.719,208,223.188z"},"children":[]}]},{"name":"path","attribs":{"d":"M224,144.812V128h-16v16.812c2.594-0.531,5.25-0.812,8-0.812S221.406,144.281,224,144.812z"},"children":[{"name":"path","attribs":{"d":"M224,144.812V128h-16v16.812c2.594-0.531,5.25-0.812,8-0.812S221.406,144.281,224,144.812z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,319.188V384h16v-64.812c-2.594,0.531-5.266,0.812-8,0.812S354.594,319.719,352,319.188z"},"children":[{"name":"path","attribs":{"d":"M352,319.188V384h16v-64.812c-2.594,0.531-5.266,0.812-8,0.812S354.594,319.719,352,319.188z"},"children":[]}]},{"name":"path","attribs":{"d":"M368,240.812V128h-16v112.812c2.594-0.531,5.266-0.812,8-0.812S365.406,240.281,368,240.812z"},"children":[{"name":"path","attribs":{"d":"M368,240.812V128h-16v112.812c2.594-0.531,5.266-0.812,8-0.812S365.406,240.281,368,240.812z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M144,367.188V384h16v-16.812c-2.594,0.531-5.25,0.812-8,0.812S146.594,367.719,144,367.188z"},"children":[{"name":"path","attribs":{"d":"M144,367.188V384h16v-16.812c-2.594,0.531-5.25,0.812-8,0.812S146.594,367.719,144,367.188z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,288.812V128h-16v160.812c2.594-0.531,5.25-0.812,8-0.812S157.406,288.281,160,288.812z"},"children":[{"name":"path","attribs":{"d":"M160,288.812V128h-16v160.812c2.594-0.531,5.25-0.812,8-0.812S157.406,288.281,160,288.812z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M320,224c0,13.266-10.75,24-24,24s-24-10.734-24-24c0-13.25,10.75-24,24-24S320,210.75,320,224z"},"children":[{"name":"path","attribs":{"d":"M320,224c0,13.266-10.75,24-24,24s-24-10.734-24-24c0-13.25,10.75-24,24-24S320,210.75,320,224z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M304,184.812V128h-16v56.812c2.594-0.531,5.266-0.812,8-0.812S301.406,184.281,304,184.812z"},"children":[{"name":"path","attribs":{"d":"M304,184.812V128h-16v56.812c2.594-0.531,5.266-0.812,8-0.812S301.406,184.281,304,184.812z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,263.188V384h16V263.188c-2.594,0.531-5.266,0.812-8,0.812S290.594,263.719,288,263.188z"},"children":[{"name":"path","attribs":{"d":"M288,263.188V384h16V263.188c-2.594,0.531-5.266,0.812-8,0.812S290.594,263.719,288,263.188z"},"children":[]}]}]}]}]}]};exports.slidersVertical=slidersVertical;var sliders={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M336,176c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S349.25,176,336,176z"},"children":[{"name":"path","attribs":{"d":"M336,176c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S349.25,176,336,176z"},"children":[]}]},{"name":"path","attribs":{"d":"M288,240c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S301.25,240,288,240z"},"children":[{"name":"path","attribs":{"d":"M288,240c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S301.25,240,288,240z"},"children":[]}]},{"name":"path","attribs":{"d":"M232,320c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S245.25,320,232,320z"},"children":[{"name":"path","attribs":{"d":"M232,320c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S245.25,320,232,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M176,384c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S189.25,384,176,384z"},"children":[{"name":"path","attribs":{"d":"M176,384c-13.266,0-24-10.75-24-24s10.734-24,24-24c13.25,0,24,10.75,24,24S189.25,384,176,384z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M296.812,144H128v16h168.812c-0.531-2.594-0.812-5.25-0.812-8S296.281,146.594,296.812,144z"},"children":[{"name":"path","attribs":{"d":"M296.812,144H128v16h168.812c-0.531-2.594-0.812-5.25-0.812-8S296.281,146.594,296.812,144z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,144h-8.812c0.531,2.594,0.812,5.25,0.812,8s-0.281,5.406-0.812,8H384V144z"},"children":[{"name":"path","attribs":{"d":"M384,144h-8.812c0.531,2.594,0.812,5.25,0.812,8s-0.281,5.406-0.812,8H384V144z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M248.812,208H128v16h120.812c-0.531-2.594-0.812-5.25-0.812-8S248.281,210.594,248.812,208z"},"children":[{"name":"path","attribs":{"d":"M248.812,208H128v16h120.812c-0.531-2.594-0.812-5.25-0.812-8S248.281,210.594,248.812,208z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,208h-56.812c0.531,2.594,0.812,5.25,0.812,8s-0.281,5.406-0.812,8H384V208z"},"children":[{"name":"path","attribs":{"d":"M384,208h-56.812c0.531,2.594,0.812,5.25,0.812,8s-0.281,5.406-0.812,8H384V208z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M192.812,288H128v16h64.812c-0.531-2.594-0.812-5.266-0.812-8S192.281,290.594,192.812,288z"},"children":[{"name":"path","attribs":{"d":"M192.812,288H128v16h64.812c-0.531-2.594-0.812-5.266-0.812-8S192.281,290.594,192.812,288z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,288H271.188c0.531,2.594,0.812,5.266,0.812,8s-0.281,5.406-0.812,8H384V288z"},"children":[{"name":"path","attribs":{"d":"M384,288H271.188c0.531,2.594,0.812,5.266,0.812,8s-0.281,5.406-0.812,8H384V288z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M136.812,352H128v16h8.812c-0.531-2.594-0.812-5.266-0.812-8S136.281,354.594,136.812,352z"},"children":[{"name":"path","attribs":{"d":"M136.812,352H128v16h8.812c-0.531-2.594-0.812-5.266-0.812-8S136.281,354.594,136.812,352z"},"children":[]}]},{"name":"path","attribs":{"d":"M384,352H215.188c0.531,2.594,0.812,5.266,0.812,8s-0.281,5.406-0.812,8H384V352z"},"children":[{"name":"path","attribs":{"d":"M384,352H215.188c0.531,2.594,0.812,5.266,0.812,8s-0.281,5.406-0.812,8H384V352z"},"children":[]}]}]}]}]}]};exports.sliders=sliders;var snow={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M357.498,285l-26.094-15.062c0.828-4.531,1.391-9.172,1.391-13.938c0-4.781-0.562-9.438-1.438-13.969l26.109-15.078\r\n\tc12.266-7.109,16.438-22.75,9.375-34.953c-7.078-12.25-22.688-16.453-34.938-9.406l-26.359,15.219\r\n\tc-7.047-6-15.078-10.719-23.953-13.875v-30.344c0-14.125-11.438-25.594-25.594-25.594c-14.141,0-25.594,11.469-25.594,25.594v30.312\r\n\tc-8.875,3.156-16.906,7.891-23.969,13.891l-26.281-15.172c-12.25-7.078-27.938-2.891-35,9.359\r\n\tc-7.062,12.234-2.859,27.891,9.391,34.953l26.047,15.047c-0.844,4.547-1.406,9.219-1.406,14.016c0,4.766,0.562,9.406,1.406,13.953\r\n\tL154.529,285c-12.266,7.062-16.469,22.75-9.375,35c7.031,12.203,22.703,16.406,34.969,9.344l26.281-15.172\r\n\tc7.031,6,15.094,10.766,24,13.922v30.312c0,14.141,11.453,25.594,25.594,25.594c14.157,0,25.594-11.453,25.594-25.594v-30.344\r\n\tc8.906-3.156,16.953-7.891,23.969-13.906l26.344,15.188c12.25,7.062,27.891,2.859,34.938-9.344\r\n\tC373.936,307.75,369.748,292.094,357.498,285z M230.404,256c0-14.125,11.438-25.594,25.594-25.594\r\n\tc14.125,0,25.594,11.469,25.594,25.594s-11.469,25.594-25.594,25.594C241.841,281.594,230.404,270.125,230.404,256z"},"children":[]}]};exports.snow=snow;var social500px={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M367.922,210.203c-5.094-5.641-11.391-10.109-18.828-13.359c-7.453-3.219-15.859-4.844-25.188-4.844\r\n\t\tc-7.438,0-14.344,1.172-20.766,3.469c-6.391,2.328-12.328,5.375-17.781,9.203c-5.484,3.797-10.625,8.266-15.391,13.359\r\n\t\tc-4.781,5.062-9.375,10.281-13.781,15.594c-4.672-5.562-9.375-10.812-14.156-15.781s-9.906-9.375-15.359-13.172\r\n\t\tc-5.484-3.828-11.422-6.875-17.828-9.203c-6.406-2.297-13.438-3.469-21.125-3.469c-9.312,0-17.688,1.688-25.156,5.031\r\n\t\tc-7.438,3.359-13.75,7.875-18.859,13.531c-5.125,5.656-9.016,12.375-11.688,20.125c-2.703,7.75-4.016,16.125-4.016,25.125\r\n\t\tc0,9.047,1.406,17.484,4.188,25.328c2.781,7.875,6.875,14.641,12.234,20.281c5.344,5.719,11.766,10.219,19.203,13.547\r\n\t\tc7.438,3.375,15.938,5.031,25.5,5.031c7.688,0,14.594-1.141,20.781-3.312c6.156-2.188,11.875-5.047,17.109-8.656\r\n\t\tc5.234-3.594,10.172-7.734,14.828-12.469c4.656-4.75,9.438-9.703,14.344-14.75c4.406,5.047,9.062,10,13.969,14.75\r\n\t\tc4.875,4.734,10.047,8.875,15.516,12.469c5.469,3.609,11.375,6.469,17.672,8.656c6.297,2.172,13.016,3.312,20.25,3.312\r\n\t\tc9.266,0,17.75-1.656,25.266-5.031c7.594-3.328,13.969-7.984,19.062-13.828c5.141-5.953,9.094-12.797,11.891-20.703\r\n\t\tc2.828-7.797,4.188-16.312,4.188-25.312c0-9.016-1.359-17.328-4.188-24.969C377.016,222.531,373.062,215.875,367.922,210.203z\r\n\t\t M225.797,266.75c-3.484,3.391-7.234,6.391-11.188,9.031c-3.953,2.625-8.172,4.859-12.562,6.578\r\n\t\tc-4.438,1.781-8.859,2.594-13.266,2.594c-8.625,0-15.375-2.641-20.266-7.969s-7.328-12.125-7.328-20.453\r\n\t\tc0-7.641,2.375-14.516,7.141-20.656c4.766-6.125,11.234-9.188,19.391-9.188c4.422,0,8.844,1,13.281,2.953\r\n\t\tc4.422,1.953,8.672,4.453,12.734,7.453c4.078,3,7.969,6.312,11.703,9.875c3.734,3.594,7,6.891,9.781,9.891\r\n\t\tC232.438,260.094,229.281,263.391,225.797,266.75z M344.156,276.641c-4.625,5.531-11.297,8.312-19.875,8.312\r\n\t\tc-4.922,0-9.484-0.812-13.812-2.406c-4.312-1.641-8.422-3.766-12.375-6.406c-3.953-2.688-7.734-5.703-11.234-9\r\n\t\tc-3.469-3.391-6.734-6.828-9.734-10.281c2.781-3,5.953-6.297,9.438-9.891c3.5-3.562,7.156-6.875,11-9.875\r\n\t\tc3.797-3,7.906-5.5,12.219-7.453c4.328-1.953,8.812-2.953,13.438-2.953c8.641,0,15.422,2.875,20.422,8.672\r\n\t\ts7.516,12.703,7.516,20.828C351.156,264.281,348.859,271.109,344.156,276.641z"},"children":[{"name":"path","attribs":{"d":"M367.922,210.203c-5.094-5.641-11.391-10.109-18.828-13.359c-7.453-3.219-15.859-4.844-25.188-4.844\r\n\t\tc-7.438,0-14.344,1.172-20.766,3.469c-6.391,2.328-12.328,5.375-17.781,9.203c-5.484,3.797-10.625,8.266-15.391,13.359\r\n\t\tc-4.781,5.062-9.375,10.281-13.781,15.594c-4.672-5.562-9.375-10.812-14.156-15.781s-9.906-9.375-15.359-13.172\r\n\t\tc-5.484-3.828-11.422-6.875-17.828-9.203c-6.406-2.297-13.438-3.469-21.125-3.469c-9.312,0-17.688,1.688-25.156,5.031\r\n\t\tc-7.438,3.359-13.75,7.875-18.859,13.531c-5.125,5.656-9.016,12.375-11.688,20.125c-2.703,7.75-4.016,16.125-4.016,25.125\r\n\t\tc0,9.047,1.406,17.484,4.188,25.328c2.781,7.875,6.875,14.641,12.234,20.281c5.344,5.719,11.766,10.219,19.203,13.547\r\n\t\tc7.438,3.375,15.938,5.031,25.5,5.031c7.688,0,14.594-1.141,20.781-3.312c6.156-2.188,11.875-5.047,17.109-8.656\r\n\t\tc5.234-3.594,10.172-7.734,14.828-12.469c4.656-4.75,9.438-9.703,14.344-14.75c4.406,5.047,9.062,10,13.969,14.75\r\n\t\tc4.875,4.734,10.047,8.875,15.516,12.469c5.469,3.609,11.375,6.469,17.672,8.656c6.297,2.172,13.016,3.312,20.25,3.312\r\n\t\tc9.266,0,17.75-1.656,25.266-5.031c7.594-3.328,13.969-7.984,19.062-13.828c5.141-5.953,9.094-12.797,11.891-20.703\r\n\t\tc2.828-7.797,4.188-16.312,4.188-25.312c0-9.016-1.359-17.328-4.188-24.969C377.016,222.531,373.062,215.875,367.922,210.203z\r\n\t\t M225.797,266.75c-3.484,3.391-7.234,6.391-11.188,9.031c-3.953,2.625-8.172,4.859-12.562,6.578\r\n\t\tc-4.438,1.781-8.859,2.594-13.266,2.594c-8.625,0-15.375-2.641-20.266-7.969s-7.328-12.125-7.328-20.453\r\n\t\tc0-7.641,2.375-14.516,7.141-20.656c4.766-6.125,11.234-9.188,19.391-9.188c4.422,0,8.844,1,13.281,2.953\r\n\t\tc4.422,1.953,8.672,4.453,12.734,7.453c4.078,3,7.969,6.312,11.703,9.875c3.734,3.594,7,6.891,9.781,9.891\r\n\t\tC232.438,260.094,229.281,263.391,225.797,266.75z M344.156,276.641c-4.625,5.531-11.297,8.312-19.875,8.312\r\n\t\tc-4.922,0-9.484-0.812-13.812-2.406c-4.312-1.641-8.422-3.766-12.375-6.406c-3.953-2.688-7.734-5.703-11.234-9\r\n\t\tc-3.469-3.391-6.734-6.828-9.734-10.281c2.781-3,5.953-6.297,9.438-9.891c3.5-3.562,7.156-6.875,11-9.875\r\n\t\tc3.797-3,7.906-5.5,12.219-7.453c4.328-1.953,8.812-2.953,13.438-2.953c8.641,0,15.422,2.875,20.422,8.672\r\n\t\ts7.516,12.703,7.516,20.828C351.156,264.281,348.859,271.109,344.156,276.641z"},"children":[]}]}]}]};exports.social500px=social500px;var socialAddthis={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"287.5,128.5 223.5,128.5 223.5,224.5 127.5,224.5 127.5,288.5 223.5,288.5 223.5,384.5 287.5,384.5 287.5,288.5 \r\n\t383.5,288.5 383.5,224.5 287.5,224.5 "},"children":[]}]};exports.socialAddthis=socialAddthis;var socialBebo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M268.438,384h-24.875C188.656,384,144,338.047,144,281.594v-128C144,139.453,155.125,128,168.891,128\r\n\tc13.734,0,24.891,11.453,24.891,25.594v128c0,28.234,22.344,51.203,49.781,51.203h24.875c27.453,0,49.781-20.094,49.781-44.797\r\n\tc0-25.25-13.391-44.797-24.875-44.797h-49.781c-13.766,0-24.906-11.484-24.906-25.609c0-14.141,11.141-25.594,24.906-25.594h49.781\r\n\tC334.5,192,368,235.047,368,288C368,340.922,323.328,384,268.438,384z"},"children":[]}]};exports.socialBebo=socialBebo;var socialBehance={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M242.531,192.656c4.719,6.594,7.094,14.547,7.094,23.797c0,9.516-2.406,17.203-7.156,23\r\n\t\t\t\tc-2.688,3.234-6.578,6.203-11.75,8.859c7.859,2.922,13.797,7.484,17.812,13.766c4,6.328,6,13.922,6,22.891\r\n\t\t\t\tc0,9.25-2.281,17.531-6.875,24.859c-2.906,4.891-6.531,8.969-10.906,12.344c-4.906,3.797-10.75,6.375-17.422,7.812\r\n\t\t\t\tc-6.703,1.375-13.969,2.078-21.797,2.078H128V176h74.578C221.375,176.266,234.719,181.812,242.531,192.656z M158.781,203.141\r\n\t\t\t\tv34.375h37.5c6.688,0,12.109-1.281,16.328-3.844c4.141-2.609,6.25-7.172,6.25-13.719c0-7.297-2.766-12.047-8.281-14.406\r\n\t\t\t\tc-4.75-1.625-10.859-2.406-18.234-2.406H158.781z M158.781,263.406v41.578h37.438c6.688,0,11.906-0.953,15.625-2.766\r\n\t\t\t\tc6.781-3.406,10.156-9.906,10.156-19.484c0-8.141-3.281-13.703-9.844-16.734c-3.656-1.688-8.781-2.562-15.406-2.594H158.781z"},"children":[{"name":"path","attribs":{"d":"M242.531,192.656c4.719,6.594,7.094,14.547,7.094,23.797c0,9.516-2.406,17.203-7.156,23\r\n\t\t\t\tc-2.688,3.234-6.578,6.203-11.75,8.859c7.859,2.922,13.797,7.484,17.812,13.766c4,6.328,6,13.922,6,22.891\r\n\t\t\t\tc0,9.25-2.281,17.531-6.875,24.859c-2.906,4.891-6.531,8.969-10.906,12.344c-4.906,3.797-10.75,6.375-17.422,7.812\r\n\t\t\t\tc-6.703,1.375-13.969,2.078-21.797,2.078H128V176h74.578C221.375,176.266,234.719,181.812,242.531,192.656z M158.781,203.141\r\n\t\t\t\tv34.375h37.5c6.688,0,12.109-1.281,16.328-3.844c4.141-2.609,6.25-7.172,6.25-13.719c0-7.297-2.766-12.047-8.281-14.406\r\n\t\t\t\tc-4.75-1.625-10.859-2.406-18.234-2.406H158.781z M158.781,263.406v41.578h37.438c6.688,0,11.906-0.953,15.625-2.766\r\n\t\t\t\tc6.781-3.406,10.156-9.906,10.156-19.484c0-8.141-3.281-13.703-9.844-16.734c-3.656-1.688-8.781-2.562-15.406-2.594H158.781z"},"children":[]}]},{"name":"path","attribs":{"d":"M354.156,218.984c7.969,3.625,14.547,9.297,19.75,17.078c4.641,6.906,7.688,14.844,9.094,23.891\r\n\t\t\t\tc0.781,5.281,1.109,12.891,0.969,22.859h-83.094c0.469,11.625,4.469,19.719,11.969,24.391c4.531,2.891,10.016,4.328,16.406,4.328\r\n\t\t\t\tc6.797,0,12.328-1.766,16.547-5.297c2.344-1.906,4.375-4.516,6.172-7.938h30.438c-0.797,6.812-4.5,13.797-11.062,20.891\r\n\t\t\t\tC361.125,330.359,346.812,336,328.422,336c-15.172,0-28.547-4.734-40.172-14.203c-11.594-9.484-17.375-24.859-17.375-46.219\r\n\t\t\t\tc0-19.969,5.219-35.328,15.719-46c10.453-10.656,24.047-16.016,40.766-16.016C337.281,213.562,346.219,215.422,354.156,218.984z\r\n\t\t\t\t M309.562,245.062c-4.219,4.422-6.844,10.359-7.938,17.906H353c-0.547-8.031-3.203-14.141-7.969-18.266\r\n\t\t\t\tc-4.734-4.141-10.625-6.219-17.656-6.219C319.719,238.484,313.766,240.703,309.562,245.062z"},"children":[{"name":"path","attribs":{"d":"M354.156,218.984c7.969,3.625,14.547,9.297,19.75,17.078c4.641,6.906,7.688,14.844,9.094,23.891\r\n\t\t\t\tc0.781,5.281,1.109,12.891,0.969,22.859h-83.094c0.469,11.625,4.469,19.719,11.969,24.391c4.531,2.891,10.016,4.328,16.406,4.328\r\n\t\t\t\tc6.797,0,12.328-1.766,16.547-5.297c2.344-1.906,4.375-4.516,6.172-7.938h30.438c-0.797,6.812-4.5,13.797-11.062,20.891\r\n\t\t\t\tC361.125,330.359,346.812,336,328.422,336c-15.172,0-28.547-4.734-40.172-14.203c-11.594-9.484-17.375-24.859-17.375-46.219\r\n\t\t\t\tc0-19.969,5.219-35.328,15.719-46c10.453-10.656,24.047-16.016,40.766-16.016C337.281,213.562,346.219,215.422,354.156,218.984z\r\n\t\t\t\t M309.562,245.062c-4.219,4.422-6.844,10.359-7.938,17.906H353c-0.547-8.031-3.203-14.141-7.969-18.266\r\n\t\t\t\tc-4.734-4.141-10.625-6.219-17.656-6.219C319.719,238.484,313.766,240.703,309.562,245.062z"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"288","y":"192","width":"80","height":"16"},"children":[{"name":"rect","attribs":{"x":"288","y":"192","width":"80","height":"16"},"children":[]}]}]}]}]}]};exports.socialBehance=socialBehance;var socialBlogger={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M365.953,224.344h-9.734l0,0c0,0-1.734,0-2.016,0c-15.969,0-18.734-14.188-18.734-14.188l0.375,0.266\r\n\tc-1.875-45.797-36.672-82.156-84.219-82.453v0.062h-38.562h0.562c-47.391,0.297-85.625,38.062-85.625,85.5c0,0.188,0-0.172,0-0.172\r\n\tl0,0v85.344l0,0c0,47.406,38.031,85.016,85.594,85.297v0.031h85.578v-0.062C341.969,383.094,384,346.109,384,298.703l0,0v-57.516\r\n\tC384,232.094,375.094,224.344,365.953,224.344z M208.812,191.625c0.125,0,0.031,0.016,0.031,0.016l0,0l47.531,0.016v-0.016\r\n\tc9.5,0.203,15.562,8.859,15.562,17.234s-6.062,15.469-15.562,15.469l0,0h-47.531c0,0-0.469,0-0.594,0\r\n\tc-8.531,0-17.188-7.219-17.188-15.719S200.312,191.625,208.812,191.625z M296.656,320.656L296.656,320.656h-87.812v-0.5\r\n\tc0,0-0.469,0-0.594,0c-8.531,0-17.047-8.188-17.047-16.703c0-8.5,8.484-15.25,17.016-15.25c0.125,0,0.469,0,0.469,0h-0.031h89h-0.25\r\n\tc9.531,0,14.562,7.594,14.562,15.984C311.969,312.562,306.172,320.656,296.656,320.656z"},"children":[]}]};exports.socialBlogger=socialBlogger;var socialDeviantart={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M220.75,223.578c57.953-18.891,106.375,19.672,106.375,19.672l-39.906,12.188l-11.5-24.188\r\n\tc-10.812-2.219-23.094-2.938-36.203-0.438l27.141,62.469L384,255c0,0-42.562-75.617-169.484-51.172\r\n\tc-0.734,0.141-1.406,0.344-2.141,0.453L200.062,176l-36.531,4.703l14.906,34.453C101.406,251.125,135.531,336,135.531,336\r\n\tl117.516-38.281L220.75,223.578z M167.312,292.062c0,0-11.312-28.312,21.625-52.562l17.531,40.594L167.312,292.062z"},"children":[]}]};exports.socialDeviantart=socialDeviantart;var socialDigg={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M284.643,227.531h42.422c7.844,0,14.234-6.375,14.234-14.234v-42.719\r\n\t\t\tc0-7.859-6.391-14.234-14.234-14.234h-42.422c-7.875,0-14.25,6.375-14.25,14.234v42.719\r\n\t\t\tC270.393,221.156,276.768,227.531,284.643,227.531z M171.908,183.625c-45.094,0-43.906,27.891-43.906,27.891V256\r\n\t\t\tc0,11.875,14.25,14.25,14.25,14.25h14.219v43.719c-16.25,1.969-27.562,10.469-27.562,20.656c0,11.625,22.156,21.031,41.812,21.031\r\n\t\t\ts41.844-8.5,41.844-20.156c0-10.031-11.625-19.344-27.516-21.438l-0.078-43.812h13.625c13.656,0,14.844-14.25,14.844-14.25\r\n\t\t\tv-45.078C213.439,183.625,171.908,183.625,171.908,183.625z M383.127,212.688c0-14.219-14.25-14.219-14.25-14.219h-13.062v37.062\r\n\t\t\tc0,8.906-7.109,6.531-7.109,6.531h-87.5c-6.547,0-6.547-6.531-6.547-6.531l0.312-35.875l-13.734-1.312\r\n\t\t\tc-15.141,0-13.547,14.656-13.547,14.656v28.781c0,0-2.125,14.219,12.125,14.219h16.328v86.031\r\n\t\t\tc0,14.844,13.657,13.062,13.657,13.062h15.422c14.25,0,13.656-13.656,13.656-13.656v-42.719c0-7.688,7.109-9.781,7.109-9.781\r\n\t\t\tc4.156,0,6.531,9.188,6.531,9.188v42.75c0,14.781,19.578,14.781,19.578,14.781h7.422c14.234,0,15.391-13.625,15.391-13.625\r\n\t\t\tL355.814,256h12.469c14.219,0,15.719-15.422,15.719-15.422L383.127,212.688z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M284.643,227.531h42.422c7.844,0,14.234-6.375,14.234-14.234v-42.719\r\n\t\t\tc0-7.859-6.391-14.234-14.234-14.234h-42.422c-7.875,0-14.25,6.375-14.25,14.234v42.719\r\n\t\t\tC270.393,221.156,276.768,227.531,284.643,227.531z M171.908,183.625c-45.094,0-43.906,27.891-43.906,27.891V256\r\n\t\t\tc0,11.875,14.25,14.25,14.25,14.25h14.219v43.719c-16.25,1.969-27.562,10.469-27.562,20.656c0,11.625,22.156,21.031,41.812,21.031\r\n\t\t\ts41.844-8.5,41.844-20.156c0-10.031-11.625-19.344-27.516-21.438l-0.078-43.812h13.625c13.656,0,14.844-14.25,14.844-14.25\r\n\t\t\tv-45.078C213.439,183.625,171.908,183.625,171.908,183.625z M383.127,212.688c0-14.219-14.25-14.219-14.25-14.219h-13.062v37.062\r\n\t\t\tc0,8.906-7.109,6.531-7.109,6.531h-87.5c-6.547,0-6.547-6.531-6.547-6.531l0.312-35.875l-13.734-1.312\r\n\t\t\tc-15.141,0-13.547,14.656-13.547,14.656v28.781c0,0-2.125,14.219,12.125,14.219h16.328v86.031\r\n\t\t\tc0,14.844,13.657,13.062,13.657,13.062h15.422c14.25,0,13.656-13.656,13.656-13.656v-42.719c0-7.688,7.109-9.781,7.109-9.781\r\n\t\t\tc4.156,0,6.531,9.188,6.531,9.188v42.75c0,14.781,19.578,14.781,19.578,14.781h7.422c14.234,0,15.391-13.625,15.391-13.625\r\n\t\t\tL355.814,256h12.469c14.219,0,15.719-15.422,15.719-15.422L383.127,212.688z"},"children":[]}]}]}]}]}]};exports.socialDigg=socialDigg;var socialDribbble={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0.016-128,57.305-128,128c0,70.688,57.312,128,128,128s128-57.312,128-128\r\n\tC384,185.305,326.688,128.016,256,128z M334.422,194.367c12.484,15.852,20.312,35.492,21.297,56.945\r\n\tc-14.453-3.062-28.109-4.562-40.828-4.562l0,0h-0.094c-10.234,0-19.859,0.922-28.922,2.531c-2.219-5.406-4.438-10.594-6.688-15.562\r\n\tC299.375,224.875,318.75,212.281,334.422,194.367z M256,156.141c23.562,0,45.172,8.227,62.281,21.945\r\n\tc-13.094,15.672-30.391,27.008-49.047,35.039c-13.125-25.367-25.797-43.523-34.469-54.609\r\n\tC241.625,157.016,248.703,156.141,256,156.141z M211.875,166.539c6.938,8.188,20.828,26.203,35.641,54.336\r\n\tc-30.141,8.969-60.484,11.062-78.859,11.062c-0.531,0-1.062,0-1.562,0l0,0c-3.094,0-5.75-0.062-7.984-0.125\r\n\tC166.281,203.156,185.906,179.398,211.875,166.539z M156.141,256c0-0.469,0.016-0.938,0.047-1.438\r\n\tc2.844,0.109,6.5,0.203,10.906,0.203l0,0c20.094-0.141,55.156-1.812,90.656-13.031c1.938,4.234,3.844,8.641,5.75,13.234\r\n\tc-23.719,7.922-42.406,20.562-56.219,33.156C193.969,300.25,185,312.234,179.75,320.234C165.031,302.844,156.141,280.5,156.141,256z\r\n\t M256,355.859c-22.234,0-42.719-7.344-59.344-19.688c3.562-5.812,11.125-16.953,23.188-28.5\r\n\tc12.391-11.891,29.516-24.141,51.891-31.422c7.594,21.312,14.469,45.656,19.719,73.078C280.406,353.531,268.484,355.859,256,355.859\r\n\tz M312.516,338.141c-5.062-24.797-11.438-47.141-18.422-67.109c6.484-0.922,13.297-1.453,20.484-1.453h0.25h0.016h0.016\r\n\tc11.906,0,24.984,1.484,39.188,4.703C349.141,300.688,333.844,323.422,312.516,338.141z"},"children":[]}]};exports.socialDribbble=socialDribbble;var socialEmail={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M315.844,198.359c0.172-1.109,0.25-2.141,0.25-3.094c0-8.797-5.5-13.172-16.5-13.172c-5.281,0-8.844,0.906-10.688,2.688\r\n\t\tc-1.875,1.812-3.156,5.391-3.906,10.75c-4.219-5.938-8.469-9.938-12.75-12.016c-3.938-1.891-9.578-2.828-16.875-2.828\r\n\t\tc-18.797,0-35.109,9.562-48.875,28.672c-12.688,17.578-19.016,36.359-19.016,56.328c0,15.594,4.109,29.281,12.344,41.094\r\n\t\tc9.125,13.016,21.062,19.516,35.766,19.516c12.594,0,24.688-4.516,36.266-13.547c5.219,9.031,14.141,13.547,26.734,13.547\r\n\t\tc23.844,0,44.266-10.062,61.219-30.203C375.938,276.938,384,254.906,384,230.031c0-29.75-12.516-54.562-37.547-74.422\r\n\t\tC323.266,137.219,296.75,128,266.844,128c-38.906,0-71.562,12.297-98.016,36.906C141.609,190.281,128,222.656,128,262.062\r\n\t\tc0,40.266,13.953,71.188,41.828,92.781C194.859,374.297,227.688,384,268.344,384c17.312,0,34.188-2.703,50.656-8.141\r\n\t\tc18.062-5.922,32.922-14.359,44.594-25.297c3.766-3.609,7.391-8,10.828-13.156c4.297-6.297,6.422-11.375,6.422-15.234\r\n\t\tc0-2.922-1.016-5.531-3.078-7.828c-2.047-2.281-4.516-3.422-7.359-3.422c-5.391,0-9.922,1.906-13.625,5.672\r\n\t\tc-6.109,6.562-10.656,11.562-13.594,15c-20,17.469-44.844,26.203-74.594,26.203c-31.906,0-57.438-7.828-76.578-23.484\r\n\t\tc-20.922-17.109-31.375-41.625-31.375-73.531c0-30.969,9.938-56.844,29.859-77.625C210.406,162.391,235.484,152,265.703,152\r\n\t\tc23.781,0,43.547,6.75,59.328,20.281c16.906,14.344,25.328,33.438,25.328,57.25c0,12.469-2.125,24.094-6.422,34.828\r\n\t\tc-4.781,12.047-11.719,21.328-20.781,27.859c-6.812,4.891-12.141,7.344-16,7.344c-4.203,0-6.297-1.969-6.297-5.922\r\n\t\tc0-1.641,1.078-9.203,3.281-22.719L315.844,198.359z M267.344,269.578c-7.734,21.453-15.969,32.188-24.688,32.188\r\n\t\tc-13.031,0-19.547-8.312-19.547-24.953c0-12.922,3.734-27.469,11.234-43.688c8.734-19.141,18.672-28.703,29.844-28.703\r\n\t\tc4.625,0,8.062,2.5,10.328,7.484c1.844,3.812,2.766,8.344,2.766,13.594C277.281,236.719,273.984,251.406,267.344,269.578z"},"children":[{"name":"path","attribs":{"d":"M315.844,198.359c0.172-1.109,0.25-2.141,0.25-3.094c0-8.797-5.5-13.172-16.5-13.172c-5.281,0-8.844,0.906-10.688,2.688\r\n\t\tc-1.875,1.812-3.156,5.391-3.906,10.75c-4.219-5.938-8.469-9.938-12.75-12.016c-3.938-1.891-9.578-2.828-16.875-2.828\r\n\t\tc-18.797,0-35.109,9.562-48.875,28.672c-12.688,17.578-19.016,36.359-19.016,56.328c0,15.594,4.109,29.281,12.344,41.094\r\n\t\tc9.125,13.016,21.062,19.516,35.766,19.516c12.594,0,24.688-4.516,36.266-13.547c5.219,9.031,14.141,13.547,26.734,13.547\r\n\t\tc23.844,0,44.266-10.062,61.219-30.203C375.938,276.938,384,254.906,384,230.031c0-29.75-12.516-54.562-37.547-74.422\r\n\t\tC323.266,137.219,296.75,128,266.844,128c-38.906,0-71.562,12.297-98.016,36.906C141.609,190.281,128,222.656,128,262.062\r\n\t\tc0,40.266,13.953,71.188,41.828,92.781C194.859,374.297,227.688,384,268.344,384c17.312,0,34.188-2.703,50.656-8.141\r\n\t\tc18.062-5.922,32.922-14.359,44.594-25.297c3.766-3.609,7.391-8,10.828-13.156c4.297-6.297,6.422-11.375,6.422-15.234\r\n\t\tc0-2.922-1.016-5.531-3.078-7.828c-2.047-2.281-4.516-3.422-7.359-3.422c-5.391,0-9.922,1.906-13.625,5.672\r\n\t\tc-6.109,6.562-10.656,11.562-13.594,15c-20,17.469-44.844,26.203-74.594,26.203c-31.906,0-57.438-7.828-76.578-23.484\r\n\t\tc-20.922-17.109-31.375-41.625-31.375-73.531c0-30.969,9.938-56.844,29.859-77.625C210.406,162.391,235.484,152,265.703,152\r\n\t\tc23.781,0,43.547,6.75,59.328,20.281c16.906,14.344,25.328,33.438,25.328,57.25c0,12.469-2.125,24.094-6.422,34.828\r\n\t\tc-4.781,12.047-11.719,21.328-20.781,27.859c-6.812,4.891-12.141,7.344-16,7.344c-4.203,0-6.297-1.969-6.297-5.922\r\n\t\tc0-1.641,1.078-9.203,3.281-22.719L315.844,198.359z M267.344,269.578c-7.734,21.453-15.969,32.188-24.688,32.188\r\n\t\tc-13.031,0-19.547-8.312-19.547-24.953c0-12.922,3.734-27.469,11.234-43.688c8.734-19.141,18.672-28.703,29.844-28.703\r\n\t\tc4.625,0,8.062,2.5,10.328,7.484c1.844,3.812,2.766,8.344,2.766,13.594C277.281,236.719,273.984,251.406,267.344,269.578z"},"children":[]}]}]}]};exports.socialEmail=socialEmail;var socialEnvato={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M166.531,194.172c-28.344,36.844-29.438,86.891-6.125,124.359c20.969-55.344,47.359-117.625,79.844-173.25\r\n\t\tC209.719,158.562,181.25,175.047,166.531,194.172z"},"children":[{"name":"path","attribs":{"d":"M166.531,194.172c-28.344,36.844-29.438,86.891-6.125,124.359c20.969-55.344,47.359-117.625,79.844-173.25\r\n\t\tC209.719,158.562,181.25,175.047,166.531,194.172z"},"children":[]}]},{"name":"path","attribs":{"d":"M367.781,145.406c-69.641,49.047-129.109,125.984-176.844,204.953c-2.141-1.484,35,17.641,57.25,17.641\r\n\t\tc30.75,0,61.219-13.922,81.797-40.641C371.094,273.859,368.219,128.188,367.781,145.406z"},"children":[{"name":"path","attribs":{"d":"M367.781,145.406c-69.641,49.047-129.109,125.984-176.844,204.953c-2.141-1.484,35,17.641,57.25,17.641\r\n\t\tc30.75,0,61.219-13.922,81.797-40.641C371.094,273.859,368.219,128.188,367.781,145.406z"},"children":[]}]}]}]};exports.socialEnvato=socialEnvato;var socialEvernote={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M208.078,192.031c-0.062-0.25,0-16.016,0-16.016V128l-63.891,64.031h47.922\r\n\t\t\tC192.109,192.031,208.156,192.25,208.078,192.031z M353.438,160.125c-4.812-7.984-29.953-13.375-43-13.375\r\n\t\t\tc-13.031,0-33.625,0-33.625,0s-11.234-15.734-36.516-18.219c-20.406-2-16.234,6.141-16.234,15.469v64.031h-63.906\r\n\t\t\tc0,0-16.156-4.297-16.156,6.844c0,20.672,2.75,87.969,47.375,94.641c52.781,7.906,60.734-5.109,60.734-8\r\n\t\t\tc0-11.984,2.047-26,2.047-26s20.469,24.078,43.781,23.203c22.891-0.875,27.703,14.188,27.703,27.484c0,13.312,0,24.703,0,24.703\r\n\t\t\ts-0.094,9.078-13.828,9.078c-13.719,0-25.391,0-25.391,0s-9.609-1.016-9.609-11.016c0-9.984,6.047-12.656,11.547-12.656\r\n\t\t\tc5.484,0,9.609,0.672,9.609,0.672v-18c0,0-43.125-6.016-43.125,26.672C254.844,378.297,272,384,290.531,384s30.203,0,30.203,0\r\n\t\t\tS368,383.516,368,279.531S358.234,168.125,353.438,160.125z M298.438,250.219c0,0,3.422-13.344,13.719-13.344\r\n\t\t\ts20.188,20.969,20.188,20.969S310.781,250.219,298.438,250.219z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M208.078,192.031c-0.062-0.25,0-16.016,0-16.016V128l-63.891,64.031h47.922\r\n\t\t\tC192.109,192.031,208.156,192.25,208.078,192.031z M353.438,160.125c-4.812-7.984-29.953-13.375-43-13.375\r\n\t\t\tc-13.031,0-33.625,0-33.625,0s-11.234-15.734-36.516-18.219c-20.406-2-16.234,6.141-16.234,15.469v64.031h-63.906\r\n\t\t\tc0,0-16.156-4.297-16.156,6.844c0,20.672,2.75,87.969,47.375,94.641c52.781,7.906,60.734-5.109,60.734-8\r\n\t\t\tc0-11.984,2.047-26,2.047-26s20.469,24.078,43.781,23.203c22.891-0.875,27.703,14.188,27.703,27.484c0,13.312,0,24.703,0,24.703\r\n\t\t\ts-0.094,9.078-13.828,9.078c-13.719,0-25.391,0-25.391,0s-9.609-1.016-9.609-11.016c0-9.984,6.047-12.656,11.547-12.656\r\n\t\t\tc5.484,0,9.609,0.672,9.609,0.672v-18c0,0-43.125-6.016-43.125,26.672C254.844,378.297,272,384,290.531,384s30.203,0,30.203,0\r\n\t\t\tS368,383.516,368,279.531S358.234,168.125,353.438,160.125z M298.438,250.219c0,0,3.422-13.344,13.719-13.344\r\n\t\t\ts20.188,20.969,20.188,20.969S310.781,250.219,298.438,250.219z"},"children":[]}]}]}]}]}]};exports.socialEvernote=socialEvernote;var socialFacebook={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M316.75,216.812h-44.531v-32.5c0-9.969,10.312-12.281,15.125-12.281\r\n\tc4.781,0,28.766,0,28.766,0v-43.859L283.141,128c-44.984,0-55.25,32.703-55.25,53.672v35.141H195.25V262h32.641\r\n\tc0,58.016,0,122,0,122h44.328c0,0,0-64.641,0-122h37.656L316.75,216.812z"},"children":[]}]};exports.socialFacebook=socialFacebook;var socialFlickr={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M320,208c-26.516,0-48,21.484-48,48c0,26.484,21.484,48,48,48\r\n\t\tc26.469,0,48-21.516,48-48C368,229.484,346.469,208,320,208z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M320,208c-26.516,0-48,21.484-48,48c0,26.484,21.484,48,48,48\r\n\t\tc26.469,0,48-21.516,48-48C368,229.484,346.469,208,320,208z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M192,208c-26.516,0-48,21.484-48,48c0,26.484,21.484,48,48,48\r\n\t\tc26.484,0,48-21.516,48-48C240,229.484,218.484,208,192,208z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M192,208c-26.516,0-48,21.484-48,48c0,26.484,21.484,48,48,48\r\n\t\tc26.484,0,48-21.516,48-48C240,229.484,218.484,208,192,208z"},"children":[]}]}]}]};exports.socialFlickr=socialFlickr;var socialForrst={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M367.531,375.812L260.578,131.5c-0.891-2.125-2.891-3.5-5.109-3.5l0,0\r\n\tc-2.219,0-4.219,1.375-5.109,3.5L144.469,375.797c-0.75,1.828-0.594,3.922,0.438,5.578c1.031,1.625,2.781,2.625,4.656,2.625H240v-48\r\n\tl-32.016-16v-16L240,320v-48h32v32l32.016-16v16L272,320v16l48.016-32v16L272,352v32h90.438c1.875,0,3.625-0.969,4.656-2.625\r\n\tS368.281,377.625,367.531,375.812z"},"children":[]}]};exports.socialForrst=socialForrst;var socialGithub={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M336.005,128.769c-26.266,14.312-53.359,2.234-72.891,0\r\n\tc-86.234-9.891-113.641,77.734-50.812,112.859c-16.172,7.312-15.109,44.453,2.203,49.734c-40.812,4.078-48.391,54.188-26.5,74.625\r\n\tc26.625,24.844,108.531,23.188,132.547,0c16.766-16.219,19.109-49.625,4.422-65.031c-13.391-14.078-80.562-16.203-79.531-38.266\r\n\tc0.719-15.438,25.016-13,39.766-19.141c27.734-11.547,44.047-46.109,33.141-72.703c6.188-1,11.469-2.797,17.656-3.812\r\n\tC336.005,154.284,336.005,141.534,336.005,128.769z M229.974,209.128c-32.328-61.344,74.344-56.953,41.984,0\r\n\tC261.349,215.972,240.458,216.659,229.974,209.128z M289.63,329.644c2.859,27.5-61.094,28.719-68.5,9.562\r\n\tc-6.219-16.141,1.531-20.719,19.891-24.875C261.817,309.612,287.708,311.237,289.63,329.644z"},"children":[]}]};exports.socialGithub=socialGithub;var socialGooglePlus={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M278.062,135.945c8.719-4.891,12.531-8.062,12.531-8.062h-83.281c-16.688,0-63.031,18.953-63.031,63.203\r\n\t\t\tc0,44.258,48.062,53.758,65.5,53.039c-9.781,11.938-1.406,22.844,3.844,28.422c5.219,5.625,4.156,7.375-2.094,7.375\r\n\t\t\tc-6.281,0-83.625,0.844-83.625,56.219s102.781,59.375,136.562,29.531s26.469-71,0.344-89.594\r\n\t\t\tc-26.125-18.609-35.875-27.391-19.156-42.141s29.969-26.688,29.969-54.086c0-27.406-22.656-41.422-22.656-41.422\r\n\t\t\tS269.344,140.867,278.062,135.945z M265.156,333.328c0,23.891-20.281,35.469-54.719,35.469c-34.469,0-52.938-17.203-52.938-42.844\r\n\t\t\tc0-25.656,25.094-38.297,72.125-38.297C242.375,297.484,265.156,309.422,265.156,333.328z M215.344,233.219\r\n\t\t\tc-41.469,0-60.281-96.898-11.5-96.898C241.812,134.898,270.375,233.219,215.344,233.219z M352.75,160.039v-31.516h-16.281v31.516\r\n\t\t\th-31.875v16.359h31.875v31.57h16.281v-31.57h31.344v-16.359H352.75z"},"children":[{"name":"path","attribs":{"d":"M278.062,135.945c8.719-4.891,12.531-8.062,12.531-8.062h-83.281c-16.688,0-63.031,18.953-63.031,63.203\r\n\t\t\tc0,44.258,48.062,53.758,65.5,53.039c-9.781,11.938-1.406,22.844,3.844,28.422c5.219,5.625,4.156,7.375-2.094,7.375\r\n\t\t\tc-6.281,0-83.625,0.844-83.625,56.219s102.781,59.375,136.562,29.531s26.469-71,0.344-89.594\r\n\t\t\tc-26.125-18.609-35.875-27.391-19.156-42.141s29.969-26.688,29.969-54.086c0-27.406-22.656-41.422-22.656-41.422\r\n\t\t\tS269.344,140.867,278.062,135.945z M265.156,333.328c0,23.891-20.281,35.469-54.719,35.469c-34.469,0-52.938-17.203-52.938-42.844\r\n\t\t\tc0-25.656,25.094-38.297,72.125-38.297C242.375,297.484,265.156,309.422,265.156,333.328z M215.344,233.219\r\n\t\t\tc-41.469,0-60.281-96.898-11.5-96.898C241.812,134.898,270.375,233.219,215.344,233.219z M352.75,160.039v-31.516h-16.281v31.516\r\n\t\t\th-31.875v16.359h31.875v31.57h16.281v-31.57h31.344v-16.359H352.75z"},"children":[]}]}]}]}]}]};exports.socialGooglePlus=socialGooglePlus;var socialGrooveshark={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M240.625,128.875c-35.812,3.812-62.344,21.438-80.188,42.109\r\n\t\tc-17.688,20.453-33.062,50.141-32.406,87.234c0.656,36.781,15.5,64.641,34.406,85.219c23,25.078,59.156,43.672,105.25,40.125\r\n\t\tc65.859-5.094,117.734-59.703,116.281-131.359c-0.688-34.078-18.781-66.484-35.078-84.234\r\n\t\tC324.406,141.297,287.891,123.812,240.625,128.875z M307.797,261.219C280.656,226.625,260.094,195,210.562,181\r\n\t\tc1.125,28.75,4.344,60.812-13.031,81.234c-7.812,9.141-23.406,19.312-35.094,14.031c-11.844-5.359-8.5-28.672-5-44.109\r\n\t\tc9.531-42.297,44.594-75.047,91.219-78.219c41.547-2.844,77.359,21.125,93.219,47.125c8.156,13.375,15.578,36.25,15.047,55.156\r\n\t\tC355.75,297.25,324.844,282.984,307.797,261.219z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M240.625,128.875c-35.812,3.812-62.344,21.438-80.188,42.109\r\n\t\tc-17.688,20.453-33.062,50.141-32.406,87.234c0.656,36.781,15.5,64.641,34.406,85.219c23,25.078,59.156,43.672,105.25,40.125\r\n\t\tc65.859-5.094,117.734-59.703,116.281-131.359c-0.688-34.078-18.781-66.484-35.078-84.234\r\n\t\tC324.406,141.297,287.891,123.812,240.625,128.875z M307.797,261.219C280.656,226.625,260.094,195,210.562,181\r\n\t\tc1.125,28.75,4.344,60.812-13.031,81.234c-7.812,9.141-23.406,19.312-35.094,14.031c-11.844-5.359-8.5-28.672-5-44.109\r\n\t\tc9.531-42.297,44.594-75.047,91.219-78.219c41.547-2.844,77.359,21.125,93.219,47.125c8.156,13.375,15.578,36.25,15.047,55.156\r\n\t\tC355.75,297.25,324.844,282.984,307.797,261.219z"},"children":[]}]}]}]};exports.socialGrooveshark=socialGrooveshark;var socialLastFm={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M344.5,240.688c-2.234-0.812-4.391-1.562-6.5-2.297\r\n\t\tc-15.922-5.547-25.547-8.891-25.547-22.641c0-11.141,7.781-19.219,18.453-19.219c8.219,0,14.312,3.781,19.781,12.266\r\n\t\tc0.516,0.797,1.5,1.078,2.281,0.609l16.078-9.094c0.438-0.234,0.766-0.688,0.906-1.188c0.141-0.531,0.094-1.078-0.156-1.562\r\n\t\tc-8.625-16.938-21.047-25.188-37.969-25.188c-25.797,0-42.453,17.281-42.453,44.016c0,27.328,16.109,38.406,45.844,49.234\r\n\t\tc17.219,6.359,24.844,9.75,24.844,23.328c0,15.25-12.422,26.234-29.391,25.594c-17.766-0.672-23.156-11.125-29.922-28.203\r\n\t\tc-11.438-28.938-24.484-62.719-24.609-63.062c-13.078-33.422-39.016-52.594-71.141-52.594c-42.469,0-77,38.281-77,85.328\r\n\t\tc0,47.031,34.531,85.297,77,85.297c23.156,0,44.859-11.375,59.547-31.203c0.422-0.594,0.516-1.375,0.25-2.062l-9.703-24.812\r\n\t\tc-0.281-0.688-0.891-1.141-1.562-1.172c-0.719-0.031-1.344,0.391-1.656,1.062c-9.172,19.391-27.125,31.438-46.875,31.438\r\n\t\tc-29.141,0-52.844-26.25-52.844-58.547s23.703-58.547,52.844-58.547c21.188,0,40.625,13.938,48.359,34.75l24.016,60.656l2.75,6.797\r\n\t\tc10.875,28.016,26.797,40.578,51.781,40.688c29.703,0,52.094-21.812,52.094-50.719C384,260.609,369.516,249.719,344.5,240.688z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M344.5,240.688c-2.234-0.812-4.391-1.562-6.5-2.297\r\n\t\tc-15.922-5.547-25.547-8.891-25.547-22.641c0-11.141,7.781-19.219,18.453-19.219c8.219,0,14.312,3.781,19.781,12.266\r\n\t\tc0.516,0.797,1.5,1.078,2.281,0.609l16.078-9.094c0.438-0.234,0.766-0.688,0.906-1.188c0.141-0.531,0.094-1.078-0.156-1.562\r\n\t\tc-8.625-16.938-21.047-25.188-37.969-25.188c-25.797,0-42.453,17.281-42.453,44.016c0,27.328,16.109,38.406,45.844,49.234\r\n\t\tc17.219,6.359,24.844,9.75,24.844,23.328c0,15.25-12.422,26.234-29.391,25.594c-17.766-0.672-23.156-11.125-29.922-28.203\r\n\t\tc-11.438-28.938-24.484-62.719-24.609-63.062c-13.078-33.422-39.016-52.594-71.141-52.594c-42.469,0-77,38.281-77,85.328\r\n\t\tc0,47.031,34.531,85.297,77,85.297c23.156,0,44.859-11.375,59.547-31.203c0.422-0.594,0.516-1.375,0.25-2.062l-9.703-24.812\r\n\t\tc-0.281-0.688-0.891-1.141-1.562-1.172c-0.719-0.031-1.344,0.391-1.656,1.062c-9.172,19.391-27.125,31.438-46.875,31.438\r\n\t\tc-29.141,0-52.844-26.25-52.844-58.547s23.703-58.547,52.844-58.547c21.188,0,40.625,13.938,48.359,34.75l24.016,60.656l2.75,6.797\r\n\t\tc10.875,28.016,26.797,40.578,51.781,40.688c29.703,0,52.094-21.812,52.094-50.719C384,260.609,369.516,249.719,344.5,240.688z"},"children":[]}]}]}]};exports.socialLastFm=socialLastFm;var socialLinkedin={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128.094,383.891h48v-192h-48V383.891z M320.094,191.891\r\n\t\t\tc-41.094,0.688-61.312,30.641-64,32v-32h-48v192h48v-112c0-4.109,10.125-37,48-32c20.344,1.328,31.312,28.234,32,32v112\r\n\t\t\tl47.812,0.219V251.188C382.219,232,372.625,192.578,320.094,191.891z M152.094,127.891c-13.25,0-24,10.734-24,24s10.75,24,24,24\r\n\t\t\ts24-10.734,24-24S165.344,127.891,152.094,127.891z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128.094,383.891h48v-192h-48V383.891z M320.094,191.891\r\n\t\t\tc-41.094,0.688-61.312,30.641-64,32v-32h-48v192h48v-112c0-4.109,10.125-37,48-32c20.344,1.328,31.312,28.234,32,32v112\r\n\t\t\tl47.812,0.219V251.188C382.219,232,372.625,192.578,320.094,191.891z M152.094,127.891c-13.25,0-24,10.734-24,24s10.75,24,24,24\r\n\t\t\ts24-10.734,24-24S165.344,127.891,152.094,127.891z"},"children":[]}]}]}]}]}]};exports.socialLinkedin=socialLinkedin;var socialMyspace={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"polygon","attribs":{"points":"352,256 160,256 160,224 128,224 128,288 384,288 384,224 352,224 "},"children":[]}]};exports.socialMyspace=socialMyspace;var socialPaypal={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M212.077,284.562h48.297c46.188,0,84.781-28.469,95.125-76.891C367.202,152.891,327.905,128,294.108,128H178.983\r\n\t\tl-50.984,234.156h67.531L212.077,284.562z M236.233,175.656h33.094c16.547,0,27.594,14.25,22.734,32.016\r\n\t\tc-4.141,17.828-21.344,32.047-38.594,32.047h-31.734L236.233,175.656z"},"children":[{"name":"path","attribs":{"d":"M212.077,284.562h48.297c46.188,0,84.781-28.469,95.125-76.891C367.202,152.891,327.905,128,294.108,128H178.983\r\n\t\tl-50.984,234.156h67.531L212.077,284.562z M236.233,175.656h33.094c16.547,0,27.594,14.25,22.734,32.016\r\n\t\tc-4.141,17.828-21.344,32.047-38.594,32.047h-31.734L236.233,175.656z"},"children":[]}]},{"name":"path","attribs":{"d":"M370.702,172.016c5.297,11.781,7.047,26.578,3.203,44.719c-10.359,48.422-48.953,76.891-95.141,76.891h-48.281\r\n\t\tl-16.547,77.594h-56.75L154.39,384h67.547l16.547-77.562h48.281c46.188,0,84.781-28.469,95.141-76.906\r\n\t\tC387.343,204.047,381.702,185.094,370.702,172.016z"},"children":[{"name":"path","attribs":{"d":"M370.702,172.016c5.297,11.781,7.047,26.578,3.203,44.719c-10.359,48.422-48.953,76.891-95.141,76.891h-48.281\r\n\t\tl-16.547,77.594h-56.75L154.39,384h67.547l16.547-77.562h48.281c46.188,0,84.781-28.469,95.141-76.906\r\n\t\tC387.343,204.047,381.702,185.094,370.702,172.016z"},"children":[]}]}]}]};exports.socialPaypal=socialPaypal;var socialPhotobucket={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M356.781,187.414h-56c-11.641-6.344-30.469-11.406-44.781-11.406c-14.281,0-33.125,5.062-44.781,11.406H200\r\n\t\t\t\tc-0.359-11.562-9.688-11.406-15.25-11.406h-20.375c-5.609,0-9.156,5.922-9.156,11.406c-5.609,0-11.219,3.078-11.219,8.594v119.93\r\n\t\t\t\tc0,5.562,5.609,8.625,11.219,8.625h56C222.875,330.875,241.719,336,256,336c14.312,0,33.141-5.125,44.781-11.438h56\r\n\t\t\t\tc5.641,0,11.219-3.062,11.219-8.625v-119.93C368,190.492,362.422,187.414,356.781,187.414z M155.219,313.094V198.852H200\r\n\t\t\t\tc-16.938,14.648-25.438,33.211-25.438,57.117c0,23.938,8.5,42.531,25.438,57.125H155.219z M292.594,315.938\r\n\t\t\t\tc-5.25,3.094-10.938,5.562-17,7.281c-0.312,0.062-0.672,0.156-1.047,0.281c-2.453,0.656-4.922,1.125-7.453,1.562\r\n\t\t\t\tc-0.703,0.062-1.406,0.219-2.094,0.281c-2.938,0.375-5.953,0.625-9,0.625s-6.062-0.25-9-0.625\r\n\t\t\t\tc-0.688-0.062-1.391-0.219-2.094-0.281c-2.531-0.438-5.031-0.906-7.469-1.562c-0.344-0.125-0.719-0.219-1.062-0.281\r\n\t\t\t\tc-6.031-1.719-11.719-4.188-16.969-7.281c-20.75-12.188-34.656-34.438-34.656-59.969c0-25.5,13.906-47.75,34.656-59.961\r\n\t\t\t\tc5.25-3.109,10.938-5.562,16.969-7.25c0.344-0.109,0.719-0.188,1.062-0.281c2.438-0.656,4.938-1.156,7.469-1.531\r\n\t\t\t\tc0.703-0.141,1.406-0.25,2.109-0.328c2.938-0.391,5.953-0.641,8.984-0.641s6.047,0.25,8.984,0.641\r\n\t\t\t\tc0.703,0.078,1.406,0.188,2.109,0.328c2.531,0.375,5,0.875,7.453,1.531c0.375,0.094,0.734,0.172,1.047,0.281\r\n\t\t\t\tc6.062,1.688,11.75,4.141,17,7.25c20.75,12.211,34.656,34.461,34.656,59.961C327.25,281.5,313.344,303.75,292.594,315.938z\r\n\t\t\t\t M356.781,313.094H312c16.953-14.594,25.484-33.188,25.484-57.125c0-23.906-8.531-42.469-25.484-57.117h44.781V313.094z\r\n\t\t\t\t M256,198.852v11.43c26.141,0,44.781,20.031,44.781,45.688H312C312,225.656,286.906,198.852,256,198.852z"},"children":[{"name":"path","attribs":{"d":"M356.781,187.414h-56c-11.641-6.344-30.469-11.406-44.781-11.406c-14.281,0-33.125,5.062-44.781,11.406H200\r\n\t\t\t\tc-0.359-11.562-9.688-11.406-15.25-11.406h-20.375c-5.609,0-9.156,5.922-9.156,11.406c-5.609,0-11.219,3.078-11.219,8.594v119.93\r\n\t\t\t\tc0,5.562,5.609,8.625,11.219,8.625h56C222.875,330.875,241.719,336,256,336c14.312,0,33.141-5.125,44.781-11.438h56\r\n\t\t\t\tc5.641,0,11.219-3.062,11.219-8.625v-119.93C368,190.492,362.422,187.414,356.781,187.414z M155.219,313.094V198.852H200\r\n\t\t\t\tc-16.938,14.648-25.438,33.211-25.438,57.117c0,23.938,8.5,42.531,25.438,57.125H155.219z M292.594,315.938\r\n\t\t\t\tc-5.25,3.094-10.938,5.562-17,7.281c-0.312,0.062-0.672,0.156-1.047,0.281c-2.453,0.656-4.922,1.125-7.453,1.562\r\n\t\t\t\tc-0.703,0.062-1.406,0.219-2.094,0.281c-2.938,0.375-5.953,0.625-9,0.625s-6.062-0.25-9-0.625\r\n\t\t\t\tc-0.688-0.062-1.391-0.219-2.094-0.281c-2.531-0.438-5.031-0.906-7.469-1.562c-0.344-0.125-0.719-0.219-1.062-0.281\r\n\t\t\t\tc-6.031-1.719-11.719-4.188-16.969-7.281c-20.75-12.188-34.656-34.438-34.656-59.969c0-25.5,13.906-47.75,34.656-59.961\r\n\t\t\t\tc5.25-3.109,10.938-5.562,16.969-7.25c0.344-0.109,0.719-0.188,1.062-0.281c2.438-0.656,4.938-1.156,7.469-1.531\r\n\t\t\t\tc0.703-0.141,1.406-0.25,2.109-0.328c2.938-0.391,5.953-0.641,8.984-0.641s6.047,0.25,8.984,0.641\r\n\t\t\t\tc0.703,0.078,1.406,0.188,2.109,0.328c2.531,0.375,5,0.875,7.453,1.531c0.375,0.094,0.734,0.172,1.047,0.281\r\n\t\t\t\tc6.062,1.688,11.75,4.141,17,7.25c20.75,12.211,34.656,34.461,34.656,59.961C327.25,281.5,313.344,303.75,292.594,315.938z\r\n\t\t\t\t M356.781,313.094H312c16.953-14.594,25.484-33.188,25.484-57.125c0-23.906-8.531-42.469-25.484-57.117h44.781V313.094z\r\n\t\t\t\t M256,198.852v11.43c26.141,0,44.781,20.031,44.781,45.688H312C312,225.656,286.906,198.852,256,198.852z"},"children":[]}]}]}]}]}]}]}]};exports.socialPhotobucket=socialPhotobucket;var socialPinterest={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M262.031,128c-70.188,0-105.594,50.094-105.594,91.859c0,25.297,9.609,47.797,30.25,56.172\r\n\t\tc3.406,1.312,6.422,0.062,7.406-3.672c0.688-2.578,2.297-9.094,3.016-11.812c0.984-3.688,0.609-5-2.125-8.188\r\n\t\tc-5.953-6.984-9.75-16.016-9.75-28.828c0-37.172,27.938-70.422,72.734-70.422c39.625,0,61.469,24.109,61.469,56.359\r\n\t\tc0,42.375-18.844,78.125-46.812,78.125c-15.484,0-27.062-12.703-23.344-28.297c4.438-18.594,13.031-38.703,13.031-52.172\r\n\t\tc0-12.031-6.5-22.094-19.906-22.094c-15.812,0-28.484,16.297-28.484,38.078c0,13.875,4.703,23.266,4.703,23.266\r\n\t\ts-16.156,68.203-19,80.125c-5.656,23.797-0.844,52.938-0.438,55.875c0.234,1.75,2.5,2.172,3.5,0.844\r\n\t\tc1.469-1.891,20.281-25.016,26.672-48.125c1.828-6.516,10.391-40.422,10.391-40.422c5.141,9.75,20.141,18.344,36.094,18.344\r\n\t\tc47.484,0,79.719-43.078,79.719-100.781C355.562,168.625,318.438,128,262.031,128z"},"children":[{"name":"path","attribs":{"d":"M262.031,128c-70.188,0-105.594,50.094-105.594,91.859c0,25.297,9.609,47.797,30.25,56.172\r\n\t\tc3.406,1.312,6.422,0.062,7.406-3.672c0.688-2.578,2.297-9.094,3.016-11.812c0.984-3.688,0.609-5-2.125-8.188\r\n\t\tc-5.953-6.984-9.75-16.016-9.75-28.828c0-37.172,27.938-70.422,72.734-70.422c39.625,0,61.469,24.109,61.469,56.359\r\n\t\tc0,42.375-18.844,78.125-46.812,78.125c-15.484,0-27.062-12.703-23.344-28.297c4.438-18.594,13.031-38.703,13.031-52.172\r\n\t\tc0-12.031-6.5-22.094-19.906-22.094c-15.812,0-28.484,16.297-28.484,38.078c0,13.875,4.703,23.266,4.703,23.266\r\n\t\ts-16.156,68.203-19,80.125c-5.656,23.797-0.844,52.938-0.438,55.875c0.234,1.75,2.5,2.172,3.5,0.844\r\n\t\tc1.469-1.891,20.281-25.016,26.672-48.125c1.828-6.516,10.391-40.422,10.391-40.422c5.141,9.75,20.141,18.344,36.094,18.344\r\n\t\tc47.484,0,79.719-43.078,79.719-100.781C355.562,168.625,318.438,128,262.031,128z"},"children":[]}]}]}]};exports.socialPinterest=socialPinterest;var socialQuora={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M314.844,341.454C346.75,321.126,368,284.798,368,243.329c0-63.688-50.156-115.328-112-115.328\r\n\tc-61.875,0-112,51.641-112,115.328c0,63.703,50.125,115.344,112,115.344c9.094,0,17.938-1.156,26.406-3.266\r\n\tc10.625,19.656,26.812,33.562,61.203,26.906v-19.547C343.609,362.767,321.562,357.142,314.844,341.454z M314.062,258.579\r\n\tc0,19.266-6.031,36.734-15.828,49.656c-12.312-13.312-31.609-24.266-56.094-22.875v2.344v20.328c0,0,16.609,0.672,27.984,20.516\r\n\tc-4.266,1.281-8.703,1.969-13.281,1.969c-31.594,0-57.188-32.203-57.188-71.938c0-5.094,0-24.609,0-29.703\r\n\tc0-39.734,25.594-71.938,57.188-71.938c31.609,0,57.219,32.203,57.219,71.938C314.062,233.97,314.062,253.485,314.062,258.579z"},"children":[]}]};exports.socialQuora=socialQuora;var socialSharethis={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M342.906,210.25c22.734,0,41.172-18.438,41.172-41.172c0-22.719-18.438-41.156-41.172-41.156s-41.172,18.438-41.172,41.156\r\n\t\tc0,1.781,0.312,3.438,0.516,5.156l-104.328,52.438c-7.438-7.312-17.594-11.844-28.844-11.844\r\n\t\tc-22.719,0-41.156,18.438-41.156,41.156c0,22.734,18.438,41.188,41.156,41.188c11.484,0,21.859-4.734,29.328-12.328l103.891,52.594\r\n\t\tc-0.25,1.812-0.562,3.594-0.562,5.453c0,22.75,18.438,41.188,41.172,41.188s41.172-18.438,41.172-41.188\r\n\t\tc0-22.703-18.438-41.172-41.172-41.172c-11.609,0-22.062,4.875-29.531,12.609l-103.719-52.5c0.266-1.922,0.594-3.828,0.594-5.844\r\n\t\tc0-2.219-0.328-4.391-0.656-6.547l103.562-52.016C320.656,205.281,331.188,210.25,342.906,210.25z"},"children":[{"name":"path","attribs":{"d":"M342.906,210.25c22.734,0,41.172-18.438,41.172-41.172c0-22.719-18.438-41.156-41.172-41.156s-41.172,18.438-41.172,41.156\r\n\t\tc0,1.781,0.312,3.438,0.516,5.156l-104.328,52.438c-7.438-7.312-17.594-11.844-28.844-11.844\r\n\t\tc-22.719,0-41.156,18.438-41.156,41.156c0,22.734,18.438,41.188,41.156,41.188c11.484,0,21.859-4.734,29.328-12.328l103.891,52.594\r\n\t\tc-0.25,1.812-0.562,3.594-0.562,5.453c0,22.75,18.438,41.188,41.172,41.188s41.172-18.438,41.172-41.188\r\n\t\tc0-22.703-18.438-41.172-41.172-41.172c-11.609,0-22.062,4.875-29.531,12.609l-103.719-52.5c0.266-1.922,0.594-3.828,0.594-5.844\r\n\t\tc0-2.219-0.328-4.391-0.656-6.547l103.562-52.016C320.656,205.281,331.188,210.25,342.906,210.25z"},"children":[]}]}]}]};exports.socialSharethis=socialSharethis;var socialSkype={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M366.734,256.297c0-63.016-51.094-114.109-114.125-114.109c-5.891,0-11.641,0.578-17.281,1.438\r\n\t\tC223.938,133.906,209.203,128,193.078,128C157.156,128,128,157.141,128,193.078c0,14.672,4.906,28.172,13.109,39.047\r\n\t\tc-1.672,7.797-2.609,15.875-2.609,24.172c0,63.047,51.078,114.141,114.109,114.141c8.094,0,16-0.875,23.609-2.484\r\n\t\tC287.656,377.922,302.562,384,318.922,384C354.859,384,384,354.859,384,318.922c0-17.766-7.125-33.844-18.688-45.578\r\n\t\tC366.156,267.75,366.734,262.094,366.734,256.297z M305.859,306c-4.484,6.391-11.078,11.391-19.734,15\r\n\t\tc-8.656,3.641-18.922,5.438-30.781,5.438c-14.25,0-26-2.469-35.25-7.422c-6.547-3.547-11.875-8.297-15.984-14.25\r\n\t\tc-4.094-5.922-6.156-11.703-6.156-17.312c0-3.266,1.234-6.047,3.688-8.359c2.469-2.328,5.609-3.484,9.406-3.484\r\n\t\tc3.078,0,5.703,0.891,7.828,2.719c2.125,1.797,3.953,4.484,5.453,8.031c1.844,4.234,3.828,7.75,5.953,10.578\r\n\t\tc2.125,2.844,5.141,5.188,9,7.016c3.875,1.844,8.969,2.766,15.25,2.766c8.672,0,15.703-1.844,21.109-5.562\r\n\t\tc5.406-3.703,8.125-8.328,8.125-13.891c0-4.391-1.453-7.969-4.375-10.703c-2.922-2.75-6.688-4.844-11.328-6.297\r\n\t\tc-4.625-1.438-10.781-2.984-18.547-4.609c-10.359-2.234-19.031-4.844-26.016-7.812c-6.984-3-12.547-7.062-16.625-12.219\r\n\t\tc-4.109-5.172-6.156-11.578-6.156-19.219c0-7.312,2.156-13.781,6.5-19.453c4.312-5.656,10.578-10.031,18.797-13.062\r\n\t\tc8.203-3.047,17.828-4.562,28.922-4.562c8.844,0,16.516,1,22.969,3.016c6.469,2.016,11.828,4.703,16.094,8.047\r\n\t\tc4.25,3.359,7.375,6.875,9.344,10.547s2.953,7.266,2.953,10.75c0,3.203-1.234,6.094-3.672,8.656\r\n\t\tc-2.469,2.547-5.547,3.844-9.219,3.844c-3.344,0-5.891-0.781-7.625-2.312s-3.625-4.047-5.656-7.547\r\n\t\tc-2.625-5-5.766-8.922-9.453-11.719c-3.672-2.797-9.578-4.203-17.719-4.203c-7.531,0-13.609,1.516-18.234,4.562\r\n\t\tc-4.641,3.031-6.938,6.703-6.938,10.984c0,2.656,0.781,4.953,2.359,6.875c1.562,1.938,3.734,3.578,6.5,4.969\r\n\t\tc2.734,1.391,5.531,2.469,8.359,3.281c2.812,0.766,7.469,1.922,13.969,3.422c8.125,1.75,15.484,3.688,22.078,5.797\r\n\t\ts12.203,4.672,16.828,7.672c4.641,3.031,8.25,6.844,10.828,11.453c2.594,4.609,3.891,10.266,3.891,16.969\r\n\t\tC312.594,292.391,310.344,299.609,305.859,306z"},"children":[{"name":"path","attribs":{"d":"M366.734,256.297c0-63.016-51.094-114.109-114.125-114.109c-5.891,0-11.641,0.578-17.281,1.438\r\n\t\tC223.938,133.906,209.203,128,193.078,128C157.156,128,128,157.141,128,193.078c0,14.672,4.906,28.172,13.109,39.047\r\n\t\tc-1.672,7.797-2.609,15.875-2.609,24.172c0,63.047,51.078,114.141,114.109,114.141c8.094,0,16-0.875,23.609-2.484\r\n\t\tC287.656,377.922,302.562,384,318.922,384C354.859,384,384,354.859,384,318.922c0-17.766-7.125-33.844-18.688-45.578\r\n\t\tC366.156,267.75,366.734,262.094,366.734,256.297z M305.859,306c-4.484,6.391-11.078,11.391-19.734,15\r\n\t\tc-8.656,3.641-18.922,5.438-30.781,5.438c-14.25,0-26-2.469-35.25-7.422c-6.547-3.547-11.875-8.297-15.984-14.25\r\n\t\tc-4.094-5.922-6.156-11.703-6.156-17.312c0-3.266,1.234-6.047,3.688-8.359c2.469-2.328,5.609-3.484,9.406-3.484\r\n\t\tc3.078,0,5.703,0.891,7.828,2.719c2.125,1.797,3.953,4.484,5.453,8.031c1.844,4.234,3.828,7.75,5.953,10.578\r\n\t\tc2.125,2.844,5.141,5.188,9,7.016c3.875,1.844,8.969,2.766,15.25,2.766c8.672,0,15.703-1.844,21.109-5.562\r\n\t\tc5.406-3.703,8.125-8.328,8.125-13.891c0-4.391-1.453-7.969-4.375-10.703c-2.922-2.75-6.688-4.844-11.328-6.297\r\n\t\tc-4.625-1.438-10.781-2.984-18.547-4.609c-10.359-2.234-19.031-4.844-26.016-7.812c-6.984-3-12.547-7.062-16.625-12.219\r\n\t\tc-4.109-5.172-6.156-11.578-6.156-19.219c0-7.312,2.156-13.781,6.5-19.453c4.312-5.656,10.578-10.031,18.797-13.062\r\n\t\tc8.203-3.047,17.828-4.562,28.922-4.562c8.844,0,16.516,1,22.969,3.016c6.469,2.016,11.828,4.703,16.094,8.047\r\n\t\tc4.25,3.359,7.375,6.875,9.344,10.547s2.953,7.266,2.953,10.75c0,3.203-1.234,6.094-3.672,8.656\r\n\t\tc-2.469,2.547-5.547,3.844-9.219,3.844c-3.344,0-5.891-0.781-7.625-2.312s-3.625-4.047-5.656-7.547\r\n\t\tc-2.625-5-5.766-8.922-9.453-11.719c-3.672-2.797-9.578-4.203-17.719-4.203c-7.531,0-13.609,1.516-18.234,4.562\r\n\t\tc-4.641,3.031-6.938,6.703-6.938,10.984c0,2.656,0.781,4.953,2.359,6.875c1.562,1.938,3.734,3.578,6.5,4.969\r\n\t\tc2.734,1.391,5.531,2.469,8.359,3.281c2.812,0.766,7.469,1.922,13.969,3.422c8.125,1.75,15.484,3.688,22.078,5.797\r\n\t\ts12.203,4.672,16.828,7.672c4.641,3.031,8.25,6.844,10.828,11.453c2.594,4.609,3.891,10.266,3.891,16.969\r\n\t\tC312.594,292.391,310.344,299.609,305.859,306z"},"children":[]}]}]}]};exports.socialSkype=socialSkype;var socialSoundcloud={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128.591,281.609c-2.875,13.5,5.344,32,12.781,38.391v-64\r\n\t\t\tC133.935,262.391,130.778,271.5,128.591,281.609z M347.341,250.188c-4.469,0-8.672,0.875-12.609,2.266\r\n\t\t\tc-1.969-33.672-31-60.453-66.812-60.453c-22.891,0-50.609,8.938-62.703,25.594V320h142.125c20.25,0,36.656-15.625,36.656-34.891\r\n\t\t\tC383.997,265.812,367.591,250.188,347.341,250.188z M179.685,320h12.766v-89.594h-12.766V320z M154.138,320h12.766v-76.812\r\n\t\t\th-12.766V320z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128.591,281.609c-2.875,13.5,5.344,32,12.781,38.391v-64\r\n\t\t\tC133.935,262.391,130.778,271.5,128.591,281.609z M347.341,250.188c-4.469,0-8.672,0.875-12.609,2.266\r\n\t\t\tc-1.969-33.672-31-60.453-66.812-60.453c-22.891,0-50.609,8.938-62.703,25.594V320h142.125c20.25,0,36.656-15.625,36.656-34.891\r\n\t\t\tC383.997,265.812,367.591,250.188,347.341,250.188z M179.685,320h12.766v-89.594h-12.766V320z M154.138,320h12.766v-76.812\r\n\t\t\th-12.766V320z"},"children":[]}]}]}]}]}]};exports.socialSoundcloud=socialSoundcloud;var socialStumbleupon={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M270.219,228.578l16.625,11.734l26.031-11.734l-0.156-13.062C311.812,186.031,286.812,160,256,160\r\n\tc-30.719,0-55.672,25.844-56.75,55.188v79.203c0,7.141-6.031,12.953-13.438,12.953c-7.453,0-15.141-3.031-15.141-10.219V256H128\r\n\tc0,0,0,40.734,0,41.125C128,327.422,153.5,352,184.891,352c31.141,0,56.438-24.969,56.891-54.875v-82.281\r\n\tc0-7.156,6.781-13.688,14.219-13.688c7.422,0,14.219,6.531,14.219,13.688V228.578z M341.344,256v41.125\r\n\tc0,7.172-7.719,11.781-15.156,11.781s-13.469-5.797-13.469-12.969L312.875,256l-26.031,12.953L270.219,256v41.125\r\n\tC270.5,327.203,295.875,352,327.125,352C358.5,352,384,327.422,384,297.125c0-0.391,0-41.125,0-41.125H341.344z"},"children":[]}]};exports.socialStumbleupon=socialStumbleupon;var socialTumblr={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M227.391,332.562c-4.703-2.734-7.922-6.375-9.656-10.969\r\n\t\t\tc-1.734-4.562-5.453-14.906-5.453-31.016v-45.172h67.594v-48.562h-67.594V128h-28.375c-1.812,14.344-2.234,19.062-7,28.359\r\n\t\t\tc-4.781,9.281-11.125,21.484-19.031,28.109C150,191.094,139.078,197.578,128,201.125v44.281h32.594v71.375\r\n\t\t\tc0,12.719,1.344,22.406,4.047,29.094c2.703,6.703,7.547,13.016,14.547,18.953c6.984,5.922,22.469,13.719,22.469,13.719\r\n\t\t\ts12.438,4.812,25.312,4.812c11.344,0,21.922-1.125,31.688-3.375s24.266-7.594,36.312-13.203v-43.812\r\n\t\t\tc-14.125,9.141-31.938,15.125-46.172,15.125C240.75,338.094,233.625,336.25,227.391,332.562z M349.141,315.266\r\n\t\t\tc-19.234,0-34.859,15.391-34.859,34.375S329.906,384,349.141,384S384,368.625,384,349.641S368.375,315.266,349.141,315.266z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M227.391,332.562c-4.703-2.734-7.922-6.375-9.656-10.969\r\n\t\t\tc-1.734-4.562-5.453-14.906-5.453-31.016v-45.172h67.594v-48.562h-67.594V128h-28.375c-1.812,14.344-2.234,19.062-7,28.359\r\n\t\t\tc-4.781,9.281-11.125,21.484-19.031,28.109C150,191.094,139.078,197.578,128,201.125v44.281h32.594v71.375\r\n\t\t\tc0,12.719,1.344,22.406,4.047,29.094c2.703,6.703,7.547,13.016,14.547,18.953c6.984,5.922,22.469,13.719,22.469,13.719\r\n\t\t\ts12.438,4.812,25.312,4.812c11.344,0,21.922-1.125,31.688-3.375s24.266-7.594,36.312-13.203v-43.812\r\n\t\t\tc-14.125,9.141-31.938,15.125-46.172,15.125C240.75,338.094,233.625,336.25,227.391,332.562z M349.141,315.266\r\n\t\t\tc-19.234,0-34.859,15.391-34.859,34.375S329.906,384,349.141,384S384,368.625,384,349.641S368.375,315.266,349.141,315.266z"},"children":[]}]}]}]}]}]};exports.socialTumblr=socialTumblr;var socialTwitter={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.392,114.609,256,256,256c141.392,0,256-114.608,256-256\r\n\tC512,114.609,397.392,0,256,0z M256,472c-119.297,0-216-96.702-216-216c0-119.297,96.703-216,216-216c119.298,0,216,96.703,216,216\r\n\tC472,375.298,375.298,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M384,170.922c-4.313,2.562-17.248,7.671-29.313,8.953c7.736-4.491,19.188-19.203,22.016-30.89\r\n\tc-7.435,5.109-24.516,12.562-32.95,12.562c0,0,0,0.023,0.016,0.039C334.141,150.75,320.608,144,305.577,144\r\n\tc-29.154,0-52.81,25.461-52.81,56.875c0,4.36,0.481,8.595,1.357,12.672h-0.017c-39.562-1.094-85.811-22.446-111.874-59\r\n\tc-16,29.852-2.156,63.046,16.015,75.141c-6.203,0.516-17.671-0.766-23.061-6.407c-0.375,19.797,8.484,46.048,40.735,55.563\r\n\tc-6.221,3.61-17.19,2.579-21.984,1.781c1.687,16.75,23.437,38.623,47.202,38.623c-8.47,10.534-37.373,29.706-73.141,23.596\r\n\tC152.298,358.782,180.625,368,210.608,368c85.205,0,151.376-74.359,147.814-166.093c0-0.11-0.031-0.219-0.031-0.313\r\n\tc0-0.25,0.031-0.5,0.031-0.719c0-0.281-0.031-0.562-0.031-0.859C366.141,194.328,376.546,184.234,384,170.922z"},"children":[]}]};exports.socialTwitter=socialTwitter;var socialViddler={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M327.125,266.844c34.125,0,56.875-26.219,56.875-60.594S356.328,144,322.172,144c-31.047,0-56.719,23.031-61.109,53.094\r\n\th-1.984C254.688,167.031,229,144,197.953,144c-34.141,0-55.734,30.656-55.734,65.031c0,34.078,23.188,57.312,56.891,57.812l0,0l0,0\r\n\tv28.906L128,266.844v86.703l71.109-14.438V368h113.766l-42.656-101.156H327.125C327.156,266.844,327.062,266.844,327.125,266.844z\r\n\t M197.953,223.844c-9.641,0-17.453-7.875-17.453-17.594s7.812-17.594,17.453-17.594s17.453,7.875,17.453,17.594\r\n\tS207.594,223.844,197.953,223.844z M306,206.25c0-9.719,7.812-17.594,17.422-17.594c9.688,0,17.484,7.875,17.484,17.594\r\n\ts-7.797,17.594-17.484,17.594C313.812,223.844,306,215.969,306,206.25z"},"children":[]}]};exports.socialViddler=socialViddler;var socialVimeo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256-0.5C114.333-0.5-0.5,114.333-0.5,256S114.333,512.5,256,512.5S512.5,397.667,512.5,256S397.667-0.5,256-0.5z\r\n\t M256,472.422C136.47,472.422,39.578,375.53,39.578,256C39.578,136.47,136.47,39.578,256,39.578\r\n\tc119.53,0,216.422,96.892,216.422,216.422C472.422,375.53,375.53,472.422,256,472.422z"},"children":[]},{"name":"path","attribs":{"d":"M343.78,143.781c-32.61,0-58.113,21.104-69.15,60.822c12.023-5.699,33.848-8.673,35.554,11.178\r\n\tc1.723,19.867-28.446,71.249-41.69,71.249c-13.213,0-23.045-58.098-26.489-84.649c-3.413-26.583-9.55-55.859-34.552-55.859\r\n\tc-25.033,0-57.127,39.233-79.702,57.111l11.773,16.109c0,0,16.658-13.135,22.56-12.148c15.201,3.961,28.195,65.785,34.833,89.362\r\n\tc6.606,23.593,14.685,71.264,47.311,71.264c52.729,0,140.023-130.833,140.023-173.542\r\n\tC384.25,166.623,376.391,143.781,343.78,143.781z"},"children":[]}]};exports.socialVimeo=socialVimeo;var socialVirb={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"219.828,292.109 182.141,187.5 128,187.5 191.281,347.5 247.422,347.5 309.625,187.5 257.062,187.5 \t"},"children":[{"name":"polygon","attribs":{"points":"219.828,292.109 182.141,187.5 128,187.5 191.281,347.5 247.422,347.5 309.625,187.5 257.062,187.5 \t"},"children":[]}]},{"name":"path","attribs":{"d":"M357.469,164.023c-14.609,0-26.5,12.109-26.5,27.078c0,14.938,11.891,27.031,26.5,27.031\r\n\t\tc14.656,0,26.531-12.094,26.531-27.031C384,176.133,372.125,164.023,357.469,164.023z"},"children":[{"name":"path","attribs":{"d":"M357.469,164.023c-14.609,0-26.5,12.109-26.5,27.078c0,14.938,11.891,27.031,26.5,27.031\r\n\t\tc14.656,0,26.531-12.094,26.531-27.031C384,176.133,372.125,164.023,357.469,164.023z"},"children":[]}]}]}]};exports.socialVirb=socialVirb;var socialWordpress={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M128,256c0,50.625,29.438,94.438,72.156,115.156l-61.078-167.25C131.969,219.828,128,237.438,128,256z"},"children":[{"name":"path","attribs":{"d":"M128,256c0,50.625,29.438,94.438,72.156,115.156l-61.078-167.25C131.969,219.828,128,237.438,128,256z"},"children":[]}]},{"name":"path","attribs":{"d":"M258.266,267.203l-38.422,111.594c11.469,3.359,23.594,5.203,36.172,5.203c14.891,0,29.188-2.594,42.5-7.281\r\n\t\tc-0.344-0.547-0.656-1.094-0.906-1.75L258.266,267.203z"},"children":[{"name":"path","attribs":{"d":"M258.266,267.203l-38.422,111.594c11.469,3.359,23.594,5.203,36.172,5.203c14.891,0,29.188-2.594,42.5-7.281\r\n\t\tc-0.344-0.547-0.656-1.094-0.906-1.75L258.266,267.203z"},"children":[]}]},{"name":"path","attribs":{"d":"M342.406,249.547c0-15.828-5.688-26.797-10.547-35.312c-6.484-10.547-12.562-19.453-12.562-30.016\r\n\t\tc0-11.766,8.906-22.703,21.5-22.703c0.547,0,1.094,0.062,1.641,0.109C319.672,140.75,289.344,128,256.016,128\r\n\t\tc-44.734,0-84.078,22.953-106.953,57.688c3,0.109,5.828,0.172,8.234,0.172c13.391,0,34.141-1.641,34.141-1.641\r\n\t\tc6.875-0.391,7.688,9.719,0.781,10.562c0,0-6.906,0.797-14.656,1.219l46.625,138.625l28.016-84L232.25,196\r\n\t\tc-6.891-0.422-13.422-1.219-13.422-1.219c-6.891-0.422-6.078-10.953,0.828-10.562c0,0,21.125,1.641,33.703,1.641\r\n\t\tc13.375,0,34.125-1.641,34.125-1.641c6.891-0.391,7.703,9.719,0.797,10.562c0,0-6.906,0.797-14.641,1.219l46.266,137.562\r\n\t\tl12.766-42.656C339.156,274.281,342.406,260.5,342.406,249.547z"},"children":[{"name":"path","attribs":{"d":"M342.406,249.547c0-15.828-5.688-26.797-10.547-35.312c-6.484-10.547-12.562-19.453-12.562-30.016\r\n\t\tc0-11.766,8.906-22.703,21.5-22.703c0.547,0,1.094,0.062,1.641,0.109C319.672,140.75,289.344,128,256.016,128\r\n\t\tc-44.734,0-84.078,22.953-106.953,57.688c3,0.109,5.828,0.172,8.234,0.172c13.391,0,34.141-1.641,34.141-1.641\r\n\t\tc6.875-0.391,7.688,9.719,0.781,10.562c0,0-6.906,0.797-14.656,1.219l46.625,138.625l28.016-84L232.25,196\r\n\t\tc-6.891-0.422-13.422-1.219-13.422-1.219c-6.891-0.422-6.078-10.953,0.828-10.562c0,0,21.125,1.641,33.703,1.641\r\n\t\tc13.375,0,34.125-1.641,34.125-1.641c6.891-0.391,7.703,9.719,0.797,10.562c0,0-6.906,0.797-14.641,1.219l46.266,137.562\r\n\t\tl12.766-42.656C339.156,274.281,342.406,260.5,342.406,249.547z"},"children":[]}]},{"name":"path","attribs":{"d":"M369.203,207.766c0,12.969-2.438,27.562-9.75,45.828l-39.078,113.031C358.406,344.438,384,303.219,384,256\r\n\t\tc0-22.266-5.672-43.172-15.672-61.422C368.875,198.688,369.203,203.047,369.203,207.766z"},"children":[{"name":"path","attribs":{"d":"M369.203,207.766c0,12.969-2.438,27.562-9.75,45.828l-39.078,113.031C358.406,344.438,384,303.219,384,256\r\n\t\tc0-22.266-5.672-43.172-15.672-61.422C368.875,198.688,369.203,203.047,369.203,207.766z"},"children":[]}]}]}]};exports.socialWordpress=socialWordpress;var socialYahoo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M330.734,221.281c0,0,9.891-5.812,17.016-5.812s16.453,0,16.453,0l6.078-15H267.188l1.094,11.281l6.062,3.203L301.109,216\r\n\t\t\tc0,0,1.625,5.812-2.734,9.016c-4.438,3.141-43.422,37.734-43.422,37.734l-49.391-60.469c0,0,1.094-1.562,8.219-1.562\r\n\t\t\tc7.156,0,28.031,0,28.031,0V176H128v24.844c0,0,14.438,0,21.562,0s15.359,7.781,22.5,14.688\r\n\t\t\tc7.141,6.859,56.656,59.406,56.656,59.406l0.328,43.281c0,0-3.734,6.344-18,6.344c-14.281,0-19.766,1.094-19.766,1.094v10.156\r\n\t\t\th113.094v-7.438c0,0-3.266-4.875-6-4.875h-26.844c-3.281,0-4.391-3.688-4.391-8.469c0-4.719,0-37.469,0-37.469L330.734,221.281z\r\n\t\t\t M355.594,303.375l8.062,0.719L384,238.812l-28.438-2.094L355.594,303.375z M343.172,336h24.453l1.203-22.969l-25.656,0.625V336z"},"children":[{"name":"path","attribs":{"d":"M330.734,221.281c0,0,9.891-5.812,17.016-5.812s16.453,0,16.453,0l6.078-15H267.188l1.094,11.281l6.062,3.203L301.109,216\r\n\t\t\tc0,0,1.625,5.812-2.734,9.016c-4.438,3.141-43.422,37.734-43.422,37.734l-49.391-60.469c0,0,1.094-1.562,8.219-1.562\r\n\t\t\tc7.156,0,28.031,0,28.031,0V176H128v24.844c0,0,14.438,0,21.562,0s15.359,7.781,22.5,14.688\r\n\t\t\tc7.141,6.859,56.656,59.406,56.656,59.406l0.328,43.281c0,0-3.734,6.344-18,6.344c-14.281,0-19.766,1.094-19.766,1.094v10.156\r\n\t\t\th113.094v-7.438c0,0-3.266-4.875-6-4.875h-26.844c-3.281,0-4.391-3.688-4.391-8.469c0-4.719,0-37.469,0-37.469L330.734,221.281z\r\n\t\t\t M355.594,303.375l8.062,0.719L384,238.812l-28.438-2.094L355.594,303.375z M343.172,336h24.453l1.203-22.969l-25.656,0.625V336z"},"children":[]}]}]}]}]}]};exports.socialYahoo=socialYahoo;var socialYelp={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M246.375,301.547c-8.406-0.922-18,15.844-23.188,22.328c-5.188,6.5-25.25,29.375-25.438,35.5\r\n\t\tc-0.156,6.125,10.688,12.609,25.625,18.734c14.891,6.125,31.719,10.453,32.406-2.719c0.625-13.141,0-50.062,0-54.203\r\n\t\tS256.094,302.625,246.375,301.547z"},"children":[{"name":"path","attribs":{"d":"M246.375,301.547c-8.406-0.922-18,15.844-23.188,22.328c-5.188,6.5-25.25,29.375-25.438,35.5\r\n\t\tc-0.156,6.125,10.688,12.609,25.625,18.734c14.891,6.125,31.719,10.453,32.406-2.719c0.625-13.141,0-50.062,0-54.203\r\n\t\tS256.094,302.625,246.375,301.547z"},"children":[]}]},{"name":"path","attribs":{"d":"M233.828,272.75c0-7.188-20.109-17.312-20.109-17.312s-36.781-17.656-43.594-16.938\r\n\t\tc-6.797,0.719-9.438,20.188-10.016,34.25c-1.641,39.625,15.703,29.344,15.703,29.344s36.469-12.969,43.609-15.844\r\n\t\tC226.531,283.359,233.828,279.922,233.828,272.75z"},"children":[{"name":"path","attribs":{"d":"M233.828,272.75c0-7.188-20.109-17.312-20.109-17.312s-36.781-17.656-43.594-16.938\r\n\t\tc-6.797,0.719-9.438,20.188-10.016,34.25c-1.641,39.625,15.703,29.344,15.703,29.344s36.469-12.969,43.609-15.844\r\n\t\tC226.531,283.359,233.828,279.922,233.828,272.75z"},"children":[]}]},{"name":"path","attribs":{"d":"M244,241.031c6.656,0.531,11.359-4.5,11.359-13.125c0-8.656,2.922-91.344-3.234-97.312\r\n\t\tc-6.188-5.906-30.328-0.219-36.953,2.219c-14.109,5.125-29.797,13.125-30.125,19.969S237.375,240.5,244,241.031z"},"children":[{"name":"path","attribs":{"d":"M244,241.031c6.656,0.531,11.359-4.5,11.359-13.125c0-8.656,2.922-91.344-3.234-97.312\r\n\t\tc-6.188-5.906-30.328-0.219-36.953,2.219c-14.109,5.125-29.797,13.125-30.125,19.969S237.375,240.5,244,241.031z"},"children":[]}]},{"name":"path","attribs":{"d":"M300.875,261.406c11.828-2.531,50.047-10.469,50.859-21.281c0.797-10.781-22.188-48.281-31.75-48.281\r\n\t\tc-5.5,0.219-47.312,55.844-40.344,66.312C283.984,264.656,289.031,263.938,300.875,261.406z"},"children":[{"name":"path","attribs":{"d":"M300.875,261.406c11.828-2.531,50.047-10.469,50.859-21.281c0.797-10.781-22.188-48.281-31.75-48.281\r\n\t\tc-5.5,0.219-47.312,55.844-40.344,66.312C283.984,264.656,289.031,263.938,300.875,261.406z"},"children":[]}]},{"name":"path","attribs":{"d":"M340.672,306.938c-7.797-3.047-50.547-24.297-58.016-15.297c-4.75,5.734-1.781,15.125,3.219,24.156\r\n\t\tc5.031,9,23.188,39.438,23.188,39.438s3.234,8.094,8.906,8.094s16.859-11.781,22.531-20.578s11.5-19.391,11.5-25.172\r\n\t\tC352,311.812,348.438,310.016,340.672,306.938z"},"children":[{"name":"path","attribs":{"d":"M340.672,306.938c-7.797-3.047-50.547-24.297-58.016-15.297c-4.75,5.734-1.781,15.125,3.219,24.156\r\n\t\tc5.031,9,23.188,39.438,23.188,39.438s3.234,8.094,8.906,8.094s16.859-11.781,22.531-20.578s11.5-19.391,11.5-25.172\r\n\t\tC352,311.812,348.438,310.016,340.672,306.938z"},"children":[]}]}]}]};exports.socialYelp=socialYelp;var socialYoutube={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M214.859,128l-10.156,39.5h-1.016L193.031,128h-16.562l21.016,65.5v27.562h12.062\r\n\tv-29.375L231.562,128H214.859z M267.406,171.047c0-5.578-1.812-11.047-5-14.25c-3.688-3.688-5.531-5.828-11.578-5.828\r\n\tc-6.641,0-8.484,2.516-12.422,5.828c-3.938,3.375-5.672,8.172-5.672,13.797v30.562c0,6.219,1.938,11.141,5.75,14.844\r\n\tc3.828,3.625,5.672,5.438,12.031,5.438c6.609,0,7.453-1.781,11.281-5.281c3.75-3.531,5.609-8.438,5.609-14.688V171.047z\r\n\t M313.953,151.031h-11.672v46.625c-1.375,1.609-7.469,9.859-8.562,9.859c-1.344,0-1.609-0.375-2.234-1.156\r\n\tc-0.609-0.766-0.922-2-0.922-3.734v-51.594h-11.688v56.609c0,4.391,0.375,10.781,2.719,13.156c1.594,1.609,6.625,1.906,11.203-1.594\r\n\tc3.516-2.672,6.406-6.406,9.484-11.984v12.406h11.672V151.031z M384,291.906c0-26.406-20.906-47.812-46.75-47.812H174.766\r\n\tc-25.828,0-46.766,21.406-46.766,47.812v44.297C128,362.562,148.938,384,174.766,384H337.25c25.844,0,46.75-21.438,46.75-47.797\r\n\tV291.906z M319.578,360.578c-5.344,0-9.5-1.672-12.562-5.078c-3.047-3.281-4.594-7.922-4.594-13.812v-27.5\r\n\tc0-5.266,1.703-15,5.047-18.281c3.391-3.391,7.656-5.016,12.953-5.016c5.453,0,9.625,1.516,12.484,4.578\r\n\tc2.969,3.156,4.406,12.953,4.406,18.719v11.609h-22.688v15.484c0,3.25,0.422,5.453,1.203,6.719c0.797,1.234,2.078,1.875,4.031,1.875\r\n\tc1.938,0,3.281-0.531,4.062-1.594c0.766-1.062,1.203-3.328,1.203-7v-2.766h12.188v3.172c0,6.281-1.438,10.984-4.438,14.156\r\n\tC329.875,358.969,325.438,360.578,319.578,360.578z M325.125,316.281v-2.156c0-2.594-0.438-9.812-1.25-10.891\r\n\tc-0.766-1.109-2.141-1.672-3.953-1.672c-1.859,0-3.234,0.562-4.047,1.672c-0.812,1.078-1.25,8.297-1.25,10.891v2.156H325.125z\r\n\t M279.797,360.734c-2.422,0-4.562-0.5-6.422-1.453c-1.828-0.906-3.578-2.312-5.203-4.312v4.891h-12.297V267.5h11.578v27.922\r\n\tc1.672-1.938,4.172-3.438,5.922-4.453c1.891-1.016,3.75-1.531,5.672-1.531c3.828,0,6.828,1.422,8.828,4.141\r\n\tc2.016,2.719,3.031,6.703,3.031,11.922v41.188c0,4.531-0.953,7.969-2.828,10.391C286.141,359.469,283.375,360.734,279.797,360.734z\r\n\t M279.438,306.188c0-2.141-1.516-3.766-2.328-4.906c-0.938-1.109-2.203-1.609-3.812-1.609c-0.906,0-1.734,0.188-2.609,0.609\r\n\tc-0.812,0.391-2.375,1.062-3.234,1.922v45.516c0.969,1,2.672,1.797,3.656,2.25c0.922,0.484,1.875,0.719,2.922,0.719\r\n\tc1.484,0,2.594-0.469,3.297-1.391c0.672-0.859,2.109-2.328,2.109-4.375V306.188z M232.109,352.219\r\n\tc-2.25,2.5-4.578,5.234-7.031,6.562c-2.406,1.406-4.766,2.016-7.078,2.016c-2.812,0-4.938-0.922-6.359-2.828\r\n\tc-1.438-1.906-2.5-4.703-2.5-8.484v-58.438h11.797v54.125c0,1.484,0.266,2.547,0.766,3.234c0.531,0.641,1.359,1,2.5,1\r\n\tc0.875,0,2.75-0.438,4.125-1.359c1.375-0.859,3.359-2.016,4.5-3.328v-53.672h11.484v69.562h-12.203V352.219z M197.797,360.547\r\n\th-11.719v-81.422h-11.438V267.5h34.969v11.625h-11.812V360.547z M250.125,208.812c-1.938,0-3.438-0.547-4.438-1.641\r\n\tc-1.062-1.078-1.578-2.625-1.578-4.641v-32.453c0-1.609,0.578-2.891,1.672-3.859c1.109-1,2.547-1.5,4.344-1.5\r\n\tc1.922,0,2.75,0.5,3.953,1.5c1.172,0.969,1.797,2.25,1.797,3.859v32.453c0,1.984-0.609,3.5-1.75,4.641\r\n\tC252.906,208.266,252.109,208.812,250.125,208.812z"},"children":[]}]};exports.socialYoutube=socialYoutube;var socialZerply={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M211.264,128.001c6.328,1.594,10.688,3.109,15.938,4.797\r\n\tc8,1.609,13.688,3.422,20.938,4.672c28.656,6.266,64.766-2.75,88.906-5.672c0.734,2.109,2.172,5.625,2.156,9\r\n\tc0,4.797-2.641,10.531-4.047,13.734c-5.969,13.547-16.422,20.422-24.578,31.266c-17.484,23.125-37.328,45.906-57.719,66.312\r\n\tc-12.266,12.297-31.656,28.078-39.719,43.578c33.578,1.984,51.812,23.203,77.562,34.109c10.141,4.281,28.578,11.812,44.453,6.625\r\n\tc5.859-1.922,10.312-6.438,15.125-9.469c1.188,8.5,3.188,18.844,0,27.469c-5.969,16.203-27.281,36.156-53.906,27.469\r\n\tc-30.562-9.953-48.234-35.25-78.516-46.406c-10.219-3.781-21.812-4.75-35-4.75c-5.938,0-17.469,2.406-19.844,0.953\r\n\tc-9.641-14.234,6.438-40.266,12.281-46.422c20.219-21.297,40.875-42.656,58.656-66.312c10.5-13.969,25.719-25.719,34.047-41.688\r\n\tc-0.312,0-0.625,0-0.938,0c-3.406,2.219-10.297-0.016-15.141,0.953c-24.344,4.812-56.312,3.031-55.812-21.797\r\n\tc0.609-5.391,0.109-3.281,3.781-10.422C203.014,139.985,206.404,134.407,211.264,128.001z"},"children":[]}]};exports.socialZerply=socialZerply;var sos={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M376,256\r\n\tc0,4.297-0.25,8.531-0.688,12.719C375.766,264.531,376,260.297,376,256s-0.234-8.531-0.688-12.719\r\n\tC375.75,247.469,376,251.703,376,256z M375.031,241.484c-0.438-3.625-0.984-7.234-1.75-10.734\r\n\tC374.047,234.266,374.594,237.859,375.031,241.484z M373.094,230c-1.781-7.922-4.312-15.562-7.547-22.812\r\n\tC368.781,214.438,371.344,222.062,373.094,230z M365.531,207.125l-50.719,23.656c-6.469-15.062-18.547-27.125-33.594-33.594\r\n\tl23.641-50.719C331.812,158.516,353.484,180.188,365.531,207.125z M312,256c0,7.75-1.578,15.125-4.422,21.844\r\n\tc-5.672,13.359-16.375,24.062-29.734,29.719C271.125,310.422,263.75,312,256,312s-15.125-1.578-21.844-4.422\r\n\tc-13.359-5.672-24.062-16.375-29.719-29.734C201.578,271.125,200,263.75,200,256s1.578-15.125,4.438-21.844\r\n\tc5.656-13.359,16.359-24.062,29.719-29.719C240.875,201.578,248.25,200,256,200s15.125,1.578,21.844,4.422\r\n\tc13.359,5.672,24.062,16.375,29.734,29.734C310.422,240.875,312,248.25,312,256z M270.5,136.969c3.641,0.438,7.234,1,10.766,1.75\r\n\tC277.734,137.953,274.125,137.406,270.5,136.969z M281.938,138.891c7.969,1.766,15.625,4.328,22.922,7.578\r\n\tC297.562,143.219,289.891,140.672,281.938,138.891z M268.719,136.688C264.531,136.25,260.297,136,256,136s-8.531,0.25-12.719,0.688\r\n\tC247.469,136.25,251.703,136,256,136S264.531,136.25,268.719,136.688z M241.5,136.969c-3.625,0.438-7.234,0.984-10.75,1.75\r\n\tC234.266,137.969,237.875,137.406,241.5,136.969z M230.047,138.891c-7.938,1.781-15.594,4.312-22.859,7.562\r\n\tC214.453,143.203,222.094,140.656,230.047,138.891z M207.125,146.469l23.656,50.719c-15.062,6.469-27.125,18.531-33.594,33.594\r\n\tl-50.719-23.656c-3.25,7.297-5.797,14.969-7.578,22.938C147.156,192.625,172.891,161.781,207.125,146.469z M136.688,243.281\r\n\tC136.25,247.469,136,251.703,136,256s0.25,8.531,0.688,12.719C136.25,264.531,136,260.297,136,256S136.25,247.469,136.688,243.281z\r\n\t M138.719,230.734c-0.766,3.516-1.312,7.125-1.75,10.766C137.406,237.859,137.969,234.266,138.719,230.734z M146.469,304.875\r\n\tc-3.25-7.312-5.828-14.984-7.594-22.969C140.656,289.875,143.219,297.562,146.469,304.875z M138.719,281.266\r\n\tc-0.75-3.531-1.312-7.141-1.75-10.781C137.406,274.125,137.953,277.734,138.719,281.266z M146.469,304.875l50.719-23.656\r\n\tc6.469,15.062,18.547,27.125,33.594,33.578l-23.656,50.734C180.188,353.484,158.531,331.828,146.469,304.875z M241.484,375.031\r\n\tc-3.625-0.438-7.219-0.984-10.734-1.75C234.25,374.047,237.859,374.594,241.484,375.031z M230,373.094\r\n\tc-7.938-1.75-15.562-4.312-22.812-7.547C214.438,368.781,222.078,371.312,230,373.094z M243.281,375.312\r\n\tC247.469,375.766,251.703,376,256,376s8.531-0.234,12.719-0.688C264.531,375.75,260.297,376,256,376S247.469,375.75,243.281,375.312\r\n\tz M270.531,375.031c3.625-0.438,7.203-0.984,10.719-1.75C277.734,374.047,274.156,374.594,270.531,375.031z M282.062,373.078\r\n\tc3.844-0.859,7.625-1.875,11.312-3.094C289.688,371.203,285.906,372.219,282.062,373.078z M293.438,369.953\r\n\tc3.875-1.266,7.656-2.75,11.359-4.391C301.094,367.219,297.312,368.688,293.438,369.953z M304.875,365.531l-23.656-50.734\r\n\tc15.062-6.469,27.125-18.531,33.594-33.578l50.719,23.641C353.484,331.812,331.828,353.469,304.875,365.531z M375.047,270.5\r\n\tc-0.453,3.641-1,7.234-1.766,10.766C374.047,277.734,374.594,274.125,375.047,270.5z M373.109,281.938\r\n\tc-1.75,7.969-4.312,15.625-7.578,22.922C368.781,297.562,371.328,289.891,373.109,281.938z"},"children":[]}]};exports.sos=sos;var soundOff={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M380.766,365.172L146.844,131.234c-4.312-4.312-11.297-4.312-15.609,0s-4.312,11.266,0,15.594l233.938,233.938\r\n\t\tc4.312,4.312,11.297,4.312,15.594,0C385.078,376.469,385.078,369.484,380.766,365.172z"},"children":[{"name":"path","attribs":{"d":"M380.766,365.172L146.844,131.234c-4.312-4.312-11.297-4.312-15.609,0s-4.312,11.266,0,15.594l233.938,233.938\r\n\t\tc4.312,4.312,11.297,4.312,15.594,0C385.078,376.469,385.078,369.484,380.766,365.172z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M352,325.094V166.109c0-19.75-3.828-27.797-20.859-17.812l-97.266,58.672L352,325.094z"},"children":[{"name":"path","attribs":{"d":"M352,325.094V166.109c0-19.75-3.828-27.797-20.859-17.812l-97.266,58.672L352,325.094z"},"children":[]}]},{"name":"path","attribs":{"d":"M181.094,208H168c-4.422,0-8,3.578-8,8v80c0,4.422,3.578,8,8,8h67.5l95.641,59.719c3.891,2.281,7.031,3.5,9.656,3.984\r\n\t\t\tL181.094,208z"},"children":[{"name":"path","attribs":{"d":"M181.094,208H168c-4.422,0-8,3.578-8,8v80c0,4.422,3.578,8,8,8h67.5l95.641,59.719c3.891,2.281,7.031,3.5,9.656,3.984\r\n\t\t\tL181.094,208z"},"children":[]}]}]}]},{"name":"path","attribs":{"d":"M380.766,365.172L146.844,131.234c-4.312-4.312-11.297-4.312-15.609,0s-4.312,11.266,0,15.594l233.938,233.938\r\n\t\tc4.312,4.312,11.297,4.312,15.594,0C385.078,376.469,385.078,369.484,380.766,365.172z"},"children":[{"name":"path","attribs":{"d":"M380.766,365.172L146.844,131.234c-4.312-4.312-11.297-4.312-15.609,0s-4.312,11.266,0,15.594l233.938,233.938\r\n\t\tc4.312,4.312,11.297,4.312,15.594,0C385.078,376.469,385.078,369.484,380.766,365.172z"},"children":[]}]}]}]};exports.soundOff=soundOff;var soundOn={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M331.141,148.297L232.156,208H168c-4.422,0-8,3.578-8,8v80c0,4.422,3.578,8,8,8h67.5l95.641,59.719\r\n\t\tc17.031,9.969,20.859,1.938,20.859-17.844V166.109C352,146.359,348.172,138.312,331.141,148.297z"},"children":[{"name":"path","attribs":{"d":"M331.141,148.297L232.156,208H168c-4.422,0-8,3.578-8,8v80c0,4.422,3.578,8,8,8h67.5l95.641,59.719\r\n\t\tc17.031,9.969,20.859,1.938,20.859-17.844V166.109C352,146.359,348.172,138.312,331.141,148.297z"},"children":[]}]}]}]};exports.soundOn=soundOn;var speed={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M350.281,169.609l-23.594,21.625C343.016,209.047,352,232.047,352,256c0,52.938-43.062,96-96,96s-96-43.062-96-96\r\n\t\t\ts43.062-96,96-96v-32c-70.578,0-128,57.422-128,128s57.422,128,128,128s128-57.422,128-128\r\n\t\t\tC384,224.016,372.031,193.344,350.281,169.609z"},"children":[{"name":"path","attribs":{"d":"M350.281,169.609l-23.594,21.625C343.016,209.047,352,232.047,352,256c0,52.938-43.062,96-96,96s-96-43.062-96-96\r\n\t\t\ts43.062-96,96-96v-32c-70.578,0-128,57.422-128,128s57.422,128,128,128s128-57.422,128-128\r\n\t\t\tC384,224.016,372.031,193.344,350.281,169.609z"},"children":[]}]},{"name":"polygon","attribs":{"points":"272,262.391 307.188,138.688 240,249.609 248,272 \t\t"},"children":[{"name":"polygon","attribs":{"points":"272,262.391 307.188,138.688 240,249.609 248,272 \t\t"},"children":[]}]}]}]}]}]};exports.speed=speed;var star={"viewBox":"0 0 512 512","children":[{"name":"polygon","attribs":{"points":"295.578,214.41 256.25,134.152 216.484,214.191 128,226.785 191.812,289.363 176.469,377.395 255.688,336.02 \r\n\t334.688,377.848 319.828,289.723 384,227.52 "},"children":[]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]};exports.star=star;var stop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"176","width":"160","height":"160"},"children":[{"name":"rect","attribs":{"x":"176","y":"176","width":"160","height":"160"},"children":[]}]}]}]};exports.stop=stop;var sun={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,187.078c-38,0-68.922,30.922-68.922,68.922S218,324.922,256,324.922\r\n\t\tS324.922,294,324.922,256S294,187.078,256,187.078z M256,305.234c-27.188,0-49.234-22.047-49.234-49.234\r\n\t\ts22.047-49.234,49.234-49.234s49.234,22.047,49.234,49.234S283.188,305.234,256,305.234z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,187.078c-38,0-68.922,30.922-68.922,68.922S218,324.922,256,324.922\r\n\t\tS324.922,294,324.922,256S294,187.078,256,187.078z M256,305.234c-27.188,0-49.234-22.047-49.234-49.234\r\n\t\ts22.047-49.234,49.234-49.234s49.234,22.047,49.234,49.234S283.188,305.234,256,305.234z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-5.438,0-9.844,4.406-9.844,9.844v19.688\r\n\t\t\tc0,5.438,4.406,9.844,9.844,9.844s9.844-4.406,9.844-9.844v-19.688C265.844,132.406,261.438,128,256,128z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,128c-5.438,0-9.844,4.406-9.844,9.844v19.688\r\n\t\t\tc0,5.438,4.406,9.844,9.844,9.844s9.844-4.406,9.844-9.844v-19.688C265.844,132.406,261.438,128,256,128z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,344.609c-5.438,0-9.844,4.422-9.844,9.859v19.688\r\n\t\t\tc0,5.438,4.406,9.844,9.844,9.844s9.844-4.406,9.844-9.844v-19.688C265.844,349.031,261.438,344.609,256,344.609z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,344.609c-5.438,0-9.844,4.422-9.844,9.859v19.688\r\n\t\t\tc0,5.438,4.406,9.844,9.844,9.844s9.844-4.406,9.844-9.844v-19.688C265.844,349.031,261.438,344.609,256,344.609z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M346.5,165.484c-3.844-3.844-10.078-3.844-13.922,0l-13.922,13.922\r\n\t\t\tc-3.844,3.844-3.844,10.078,0,13.938c3.844,3.844,10.078,3.844,13.922,0l13.922-13.938\r\n\t\t\tC350.344,175.562,350.344,169.344,346.5,165.484z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M346.5,165.484c-3.844-3.844-10.078-3.844-13.922,0l-13.922,13.922\r\n\t\t\tc-3.844,3.844-3.844,10.078,0,13.938c3.844,3.844,10.078,3.844,13.922,0l13.922-13.938\r\n\t\t\tC350.344,175.562,350.344,169.344,346.5,165.484z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M193.344,318.672c-3.844-3.844-10.078-3.859-13.922,0L165.5,332.594\r\n\t\t\tc-3.844,3.844-3.844,10.078,0,13.922s10.078,3.844,13.922,0l13.922-13.922C197.188,328.734,197.188,322.516,193.344,318.672z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M193.344,318.672c-3.844-3.844-10.078-3.859-13.922,0L165.5,332.594\r\n\t\t\tc-3.844,3.844-3.844,10.078,0,13.922s10.078,3.844,13.922,0l13.922-13.922C197.188,328.734,197.188,322.516,193.344,318.672z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128,256c0,5.438,4.406,9.844,9.844,9.844h19.688\r\n\t\t\tc5.438,0,9.844-4.406,9.844-9.844s-4.406-9.844-9.844-9.844h-19.688C132.406,246.156,128,250.562,128,256z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M128,256c0,5.438,4.406,9.844,9.844,9.844h19.688\r\n\t\t\tc5.438,0,9.844-4.406,9.844-9.844s-4.406-9.844-9.844-9.844h-19.688C132.406,246.156,128,250.562,128,256z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M344.609,256c0,5.438,4.422,9.844,9.859,9.844h19.688\r\n\t\t\tc5.438,0,9.844-4.406,9.844-9.844s-4.406-9.844-9.844-9.844h-19.688C349.031,246.156,344.609,250.562,344.609,256z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M344.609,256c0,5.438,4.422,9.844,9.859,9.844h19.688\r\n\t\t\tc5.438,0,9.844-4.406,9.844-9.844s-4.406-9.844-9.844-9.844h-19.688C349.031,246.156,344.609,250.562,344.609,256z"},"children":[]}]}]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M165.484,165.484c-3.844,3.859-3.844,10.078,0,13.922l13.922,13.938\r\n\t\t\tc3.844,3.844,10.078,3.844,13.938,0c3.844-3.859,3.844-10.094,0-13.938l-13.938-13.922\r\n\t\t\tC175.562,161.641,169.344,161.641,165.484,165.484z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M165.484,165.484c-3.844,3.859-3.844,10.078,0,13.922l13.922,13.938\r\n\t\t\tc3.844,3.844,10.078,3.844,13.938,0c3.844-3.859,3.844-10.094,0-13.938l-13.938-13.922\r\n\t\t\tC175.562,161.641,169.344,161.641,165.484,165.484z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M318.672,318.656c-3.844,3.844-3.859,10.078,0,13.922l13.922,13.922\r\n\t\t\tc3.844,3.844,10.078,3.844,13.922,0s3.844-10.078,0-13.922l-13.922-13.922C328.734,314.812,322.516,314.812,318.672,318.656z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M318.672,318.656c-3.844,3.844-3.859,10.078,0,13.922l13.922,13.922\r\n\t\t\tc3.844,3.844,10.078,3.844,13.922,0s3.844-10.078,0-13.922l-13.922-13.922C328.734,314.812,322.516,314.812,318.672,318.656z"},"children":[]}]}]}]}]}]};exports.sun=sun;var sunshine={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M189.871,281.594c6.281-29.219,33.469-51.188,66.125-51.188\r\n\t\t\ts59.875,21.969,66.125,51.188h27c-6.625-43.297-45.625-76.797-93.125-76.797c-47.469,0-86.469,33.5-93.094,76.797H189.871z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M189.871,281.594c6.281-29.219,33.469-51.188,66.125-51.188\r\n\t\t\ts59.875,21.969,66.125,51.188h27c-6.625-43.297-45.625-76.797-93.125-76.797c-47.469,0-86.469,33.5-93.094,76.797H189.871z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M255.996,179.203c7.469,0,13.5-5.734,13.5-12.797v-25.609\r\n\t\t\tc0-7.062-6.031-12.797-13.5-12.797c-7.453,0-13.5,5.734-13.5,12.797v25.609C242.496,173.469,248.543,179.203,255.996,179.203z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M255.996,179.203c7.469,0,13.5-5.734,13.5-12.797v-25.609\r\n\t\t\tc0-7.062-6.031-12.797-13.5-12.797c-7.453,0-13.5,5.734-13.5,12.797v25.609C242.496,173.469,248.543,179.203,255.996,179.203z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M380.043,176.734c-5.281-5-13.812-5-19.078,0l-19.078,18.109\r\n\t\t\tc-5.281,5-5.281,13.094,0,18.094c5.266,5,13.812,5,19.078,0l19.078-18.094C385.324,189.844,385.324,181.734,380.043,176.734z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M380.043,176.734c-5.281-5-13.812-5-19.078,0l-19.078,18.109\r\n\t\t\tc-5.281,5-5.281,13.094,0,18.094c5.266,5,13.812,5,19.078,0l19.078-18.094C385.324,189.844,385.324,181.734,380.043,176.734z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M170.105,194.844l-19.078-18.109c-5.266-5-13.812-5-19.094,0\r\n\t\t\tc-5.25,5-5.25,13.109,0,18.109l19.094,18.094c5.266,5,13.797,5,19.078,0C175.371,207.938,175.371,199.844,170.105,194.844z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M170.105,194.844l-19.078-18.109c-5.266-5-13.812-5-19.094,0\r\n\t\t\tc-5.25,5-5.25,13.109,0,18.109l19.094,18.094c5.266,5,13.797,5,19.078,0C175.371,207.938,175.371,199.844,170.105,194.844z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M336.98,307.203H175.027c-7.453,0-13.5,5.734-13.5,12.797\r\n\t\t\ts6.047,12.797,13.5,12.797H336.98c7.453,0,13.5-5.734,13.5-12.797S344.434,307.203,336.98,307.203z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M336.98,307.203H175.027c-7.453,0-13.5,5.734-13.5,12.797\r\n\t\t\ts6.047,12.797,13.5,12.797H336.98c7.453,0,13.5-5.734,13.5-12.797S344.434,307.203,336.98,307.203z"},"children":[]}]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M309.98,358.406H202.012c-7.453,0-13.484,5.719-13.484,12.797\r\n\t\t\tc0,7.062,6.031,12.797,13.484,12.797H309.98c7.469,0,13.516-5.734,13.516-12.797C323.496,364.125,317.449,358.406,309.98,358.406z\r\n\t\t\t"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M309.98,358.406H202.012c-7.453,0-13.484,5.719-13.484,12.797\r\n\t\t\tc0,7.062,6.031,12.797,13.484,12.797H309.98c7.469,0,13.516-5.734,13.516-12.797C323.496,364.125,317.449,358.406,309.98,358.406z\r\n\t\t\t"},"children":[]}]}]}]}]}]};exports.sunshine=sunshine;var telephone={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M327.125,383.969c5.703,0.016,56.875-37.828,56.875-42.656s-57.266-40.906-62.219-40.906s-21.578,19.938-26.062,22.156\r\n\tc-4.5,2.219-32.5,1.422-63.703-29.781c-31.219-31.188-41.875-67.109-41.875-72.75s26.031-23.062,26.75-27.156\r\n\tS182.578,128,176.891,128S128,180.5,128,184.875s3.953,60.656,75.219,131.906S321.422,383.938,327.125,383.969z"},"children":[]}]};exports.telephone=telephone;var textAlignLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"144","y":"144","width":"128","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"144","width":"128","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"208","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"208","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"272","width":"192","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"272","width":"192","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[]}]}]}]};exports.textAlignLeft=textAlignLeft;var textAlignRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"240","y":"144","width":"128","height":"32"},"children":[{"name":"rect","attribs":{"x":"240","y":"144","width":"128","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"208","y":"208","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"208","y":"208","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"272","width":"192","height":"32"},"children":[{"name":"rect","attribs":{"x":"176","y":"272","width":"192","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[]}]}]}]};exports.textAlignRight=textAlignRight;var textBold={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M299.422,249.219c23.031,4.969,39.219,10.969,48.531,18.016C361.312,277.25,368,290.25,368,306.219\r\n\tc0,16.844-7.344,30.781-22.031,41.797C327.953,361.344,301.75,368,267.375,368H144v-6.109c11.219,0,18.828-0.969,22.828-2.891\r\n\tc4-1.938,6.797-4.438,8.422-7.516c1.609-3.094,2.406-10.688,2.406-22.797V183.312c0-12.109-0.797-19.734-2.406-22.875\r\n\tc-1.625-3.141-4.453-5.656-8.5-7.516c-4.062-1.875-11.656-2.812-22.75-2.812V144h116.391c27.812,0,47.5,2.281,59.078,6.844\r\n\tc11.578,4.578,20.719,11.406,27.406,20.5c6.688,9.078,10.031,18.75,10.031,28.984c0,10.797-4.25,20.406-12.719,28.828\r\n\tC335.703,237.578,320.781,244.281,299.422,249.219z M234.25,257.656v71.859l-0.188,8.25c0,5.953,1.641,10.438,4.938,13.469\r\n\tc3.281,3.031,8.125,4.547,14.594,4.547c9.531,0,18.344-1.953,26.406-5.875c8.062-3.906,14.234-9.578,18.531-17.016\r\n\tc4.297-7.422,6.438-15.719,6.438-24.859c0-10.453-2.625-19.844-7.875-28.156s-12.469-14.125-21.656-17.438\r\n\tC266.234,259.141,252.5,257.531,234.25,257.656z M234.25,244.766c16.938,0,29.453-1.766,37.5-5.281\r\n\tc8.062-3.531,14.25-8.484,18.531-14.859c4.312-6.406,6.453-14.547,6.453-24.469c0-9.906-2.125-18.031-6.359-24.359\r\n\ts-10.281-11.141-18.172-14.453c-7.875-3.312-20.531-4.906-37.953-4.781V244.766z"},"children":[]}]};exports.textBold=textBold;var textCenter={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"272","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"176","y":"272","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"176","y":"208","width":"160","height":"32"},"children":[{"name":"rect","attribs":{"x":"176","y":"208","width":"160","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"144","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"144","width":"224","height":"32"},"children":[]}]}]}]};exports.textCenter=textCenter;var textHeight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M301.891,144L304,196.531h-5.344c-1.016-9.25-2.422-15.859-4.219-19.828c-2.875-6.375-6.766-11.078-11.594-14.109\r\n\t\tc-4.812-3.031-11.172-4.562-19.047-4.562h-26.859v171.125c0,13.812,1.266,22.391,3.797,25.781\r\n\t\tc3.562,4.656,9.047,6.953,16.453,6.953h6.609V368h-80.859v-6.109h6.75c8.062,0,13.781-2.859,17.156-8.594\r\n\t\tc2.062-3.516,3.094-11.562,3.094-24.141V158.031h-22.922c-8.891,0-15.234,0.766-18.984,2.328c-4.875,2.094-9.031,6.094-12.5,12.047\r\n\t\ts-5.531,14-6.188,24.125H144L146.25,144H301.891z"},"children":[{"name":"path","attribs":{"d":"M301.891,144L304,196.531h-5.344c-1.016-9.25-2.422-15.859-4.219-19.828c-2.875-6.375-6.766-11.078-11.594-14.109\r\n\t\tc-4.812-3.031-11.172-4.562-19.047-4.562h-26.859v171.125c0,13.812,1.266,22.391,3.797,25.781\r\n\t\tc3.562,4.656,9.047,6.953,16.453,6.953h6.609V368h-80.859v-6.109h6.75c8.062,0,13.781-2.859,17.156-8.594\r\n\t\tc2.062-3.516,3.094-11.562,3.094-24.141V158.031h-22.922c-8.891,0-15.234,0.766-18.984,2.328c-4.875,2.094-9.031,6.094-12.5,12.047\r\n\t\ts-5.531,14-6.188,24.125H144L146.25,144H301.891z"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,176 368,176 344,144 320,176 336,176 336,336 320,336 344,368 368,336 352,336 \t"},"children":[{"name":"polygon","attribs":{"points":"352,176 368,176 344,144 320,176 336,176 336,336 320,336 344,368 368,336 352,336 \t"},"children":[]}]}]}]};exports.textHeight=textHeight;var textJustifyCenter={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"336","width":"224","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"272","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"272","width":"224","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"208","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"208","width":"224","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"144","width":"224","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"144","width":"224","height":"32"},"children":[]}]}]}]};exports.textJustifyCenter=textJustifyCenter;var textJustifyLeft={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"256","y":"144","width":"80","height":"32"},"children":[{"name":"rect","attribs":{"x":"256","y":"144","width":"80","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"256","y":"208","width":"96","height":"32"},"children":[{"name":"rect","attribs":{"x":"256","y":"208","width":"96","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"256","y":"272","width":"112","height":"32"},"children":[{"name":"rect","attribs":{"x":"256","y":"272","width":"112","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"256","y":"336","width":"128","height":"32"},"children":[{"name":"rect","attribs":{"x":"256","y":"336","width":"128","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"224","y":"144","width":"16","height":"224"},"children":[{"name":"rect","attribs":{"x":"224","y":"144","width":"16","height":"224"},"children":[]}]},{"name":"polygon","attribs":{"points":"128,240 176,240 176,224 208,256 176,288 176,272 128,272 \t"},"children":[{"name":"polygon","attribs":{"points":"128,240 176,240 176,224 208,256 176,288 176,272 128,272 \t"},"children":[]}]}]}]};exports.textJustifyLeft=textJustifyLeft;var textJustifyRight={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"176","y":"144","width":"80","height":"32"},"children":[{"name":"rect","attribs":{"x":"176","y":"144","width":"80","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"160","y":"208","width":"96","height":"32"},"children":[{"name":"rect","attribs":{"x":"160","y":"208","width":"96","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"144","y":"272","width":"112","height":"32"},"children":[{"name":"rect","attribs":{"x":"144","y":"272","width":"112","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"128","y":"336","width":"128","height":"32"},"children":[{"name":"rect","attribs":{"x":"128","y":"336","width":"128","height":"32"},"children":[]}]},{"name":"rect","attribs":{"x":"272","y":"144","width":"16","height":"224"},"children":[{"name":"rect","attribs":{"x":"272","y":"144","width":"16","height":"224"},"children":[]}]},{"name":"polygon","attribs":{"points":"384,240 336,240 336,224 304,256 336,288 336,272 384,272 \t"},"children":[{"name":"polygon","attribs":{"points":"384,240 336,240 336,224 304,256 336,288 336,272 384,272 \t"},"children":[]}]}]}]};exports.textJustifyRight=textJustifyRight;var textNormal={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M287.266,294.688h-81.672l-14.312,34.578C187.75,337.75,186,344.094,186,348.312c0,3.344,1.531,6.281,4.594,8.797\r\n\tc3.047,2.547,9.656,4.172,19.828,4.938V368H144v-5.953c8.812-1.625,14.5-3.719,17.109-6.312\r\n\tc5.297-5.172,11.141-15.641,17.578-31.484L252.891,144h5.453l73.422,182.188c5.906,14.625,11.25,24.156,16.094,28.484\r\n\tc4.812,4.391,11.531,6.828,20.141,7.375V368h-83.219v-5.953c8.406-0.438,14.062-1.875,17.047-4.375\r\n\tc2.922-2.469,4.406-5.484,4.406-9.031c0-4.75-2.062-12.219-6.203-22.453L287.266,294.688z M282.906,282.734l-35.781-88.5\r\n\tl-36.703,88.5H282.906z"},"children":[]}]};exports.textNormal=textNormal;var textParagraph={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,144v32h224v-32H144z M288,192H144v32h144V192z M224,240h-80v32h80V240z\r\n\t\t\t M144,320h192v-32H144V320z M144,368h128v-32H144V368z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M144,144v32h224v-32H144z M288,192H144v32h144V192z M224,240h-80v32h80V240z\r\n\t\t\t M144,320h192v-32H144V320z M144,368h128v-32H144V368z"},"children":[]}]}]}]}]}]};exports.textParagraph=textParagraph;var textSizeReduce={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M286.344,176L288,213.531h-4.234c-0.859-6.625-1.938-11.312-3.391-14.156c-2.312-4.594-5.406-7.938-9.281-10.094\r\n\t\tc-3.844-2.156-8.945-3.25-15.242-3.25h-21.477V308.25c0,9.875,1,15.984,3.031,18.438c2.836,3.312,7.227,4.953,13.156,4.953h5.289\r\n\t\tV336h-64.703v-4.359h5.43c6.438,0,11.023-2.047,13.719-6.156c1.648-2.516,2.469-8.25,2.469-17.234V186.031h-18.344\r\n\t\tc-7.117,0-12.195,0.562-15.172,1.656c-3.922,1.469-7.242,4.359-10.008,8.594c-2.766,4.266-4.43,10-4.953,17.25H160L161.82,176\r\n\t\tH286.344z"},"children":[{"name":"path","attribs":{"d":"M286.344,176L288,213.531h-4.234c-0.859-6.625-1.938-11.312-3.391-14.156c-2.312-4.594-5.406-7.938-9.281-10.094\r\n\t\tc-3.844-2.156-8.945-3.25-15.242-3.25h-21.477V308.25c0,9.875,1,15.984,3.031,18.438c2.836,3.312,7.227,4.953,13.156,4.953h5.289\r\n\t\tV336h-64.703v-4.359h5.43c6.438,0,11.023-2.047,13.719-6.156c1.648-2.516,2.469-8.25,2.469-17.234V186.031h-18.344\r\n\t\tc-7.117,0-12.195,0.562-15.172,1.656c-3.922,1.469-7.242,4.359-10.008,8.594c-2.766,4.266-4.43,10-4.953,17.25H160L161.82,176\r\n\t\tH286.344z"},"children":[]}]},{"name":"rect","attribs":{"x":"279.5","y":"264.5","width":"64","height":"16"},"children":[{"name":"rect","attribs":{"x":"279.5","y":"264.5","width":"64","height":"16"},"children":[]}]}]}]};exports.textSizeReduce=textSizeReduce;var textSizeUpper={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M285.938,160L288,205.031h-5.297c-1.078-7.938-2.406-13.594-4.234-17c-2.906-5.469-6.75-9.5-11.594-12.094\r\n\t\tc-4.828-2.594-11.195-3.906-19.055-3.906h-26.852v146.656c0,11.875,1.25,19.203,3.781,22.125c3.555,4,9.039,5.953,16.453,5.953\r\n\t\th6.617V352H166.93v-5.234h6.789c8.047,0,13.789-2.453,17.156-7.375c2.055-3.016,3.078-9.906,3.078-20.703V172.031h-22.922\r\n\t\tc-8.898,0-15.242,0.656-18.969,2c-4.906,1.781-9.055,5.219-12.508,10.312c-3.453,5.109-5.539,12-6.188,20.688H128L130.273,160\r\n\t\tH285.938z"},"children":[{"name":"path","attribs":{"d":"M285.938,160L288,205.031h-5.297c-1.078-7.938-2.406-13.594-4.234-17c-2.906-5.469-6.75-9.5-11.594-12.094\r\n\t\tc-4.828-2.594-11.195-3.906-19.055-3.906h-26.852v146.656c0,11.875,1.25,19.203,3.781,22.125c3.555,4,9.039,5.953,16.453,5.953\r\n\t\th6.617V352H166.93v-5.234h6.789c8.047,0,13.789-2.453,17.156-7.375c2.055-3.016,3.078-9.906,3.078-20.703V172.031h-22.922\r\n\t\tc-8.898,0-15.242,0.656-18.969,2c-4.906,1.781-9.055,5.219-12.508,10.312c-3.453,5.109-5.539,12-6.188,20.688H128L130.273,160\r\n\t\tH285.938z"},"children":[]}]},{"name":"rect","attribs":{"x":"295.5","y":"264.5","width":"80","height":"16"},"children":[{"name":"rect","attribs":{"x":"295.5","y":"264.5","width":"80","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"327.5","y":"232.5","width":"16","height":"80"},"children":[{"name":"rect","attribs":{"x":"327.5","y":"232.5","width":"16","height":"80"},"children":[]}]}]}]};exports.textSizeUpper=textSizeUpper;var textWidth={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M349.438,128L352,173.031h-6.406c-1.25-7.938-2.938-13.594-5.062-17c-3.469-5.469-8.156-9.5-13.906-12.094\r\n\t\tc-5.781-2.594-13.438-3.906-22.875-3.906h-32.219v146.688c0,11.812,1.516,19.172,4.531,22.094\r\n\t\tc4.281,3.969,10.875,5.953,19.75,5.953h7.938V320h-97v-5.234h8.094c9.656,0,16.516-2.453,20.562-7.375\r\n\t\tc2.5-3.016,3.719-9.906,3.719-20.672V140.031h-27.5c-10.688,0-18.281,0.656-22.781,1.984c-5.844,1.797-10.844,5.234-15,10.328\r\n\t\tc-4.172,5.109-6.641,12-7.438,20.688H160L162.688,128H349.438z"},"children":[{"name":"path","attribs":{"d":"M349.438,128L352,173.031h-6.406c-1.25-7.938-2.938-13.594-5.062-17c-3.469-5.469-8.156-9.5-13.906-12.094\r\n\t\tc-5.781-2.594-13.438-3.906-22.875-3.906h-32.219v146.688c0,11.812,1.516,19.172,4.531,22.094\r\n\t\tc4.281,3.969,10.875,5.953,19.75,5.953h7.938V320h-97v-5.234h8.094c9.656,0,16.516-2.453,20.562-7.375\r\n\t\tc2.5-3.016,3.719-9.906,3.719-20.672V140.031h-27.5c-10.688,0-18.281,0.656-22.781,1.984c-5.844,1.797-10.844,5.234-15,10.328\r\n\t\tc-4.172,5.109-6.641,12-7.438,20.688H160L162.688,128H349.438z"},"children":[]}]},{"name":"polygon","attribs":{"points":"352,360 320,336 320,352 192,352 192,336 160,360 192,384 192,368 320,368 320,384 \t"},"children":[{"name":"polygon","attribs":{"points":"352,360 320,336 320,352 192,352 192,336 160,360 192,384 192,368 320,368 320,384 \t"},"children":[]}]}]}]};exports.textWidth=textWidth;var threePointsBottom={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.938,320C334.266,320,320,334.297,320,351.969S334.266,384,351.938,384C369.672,384,384,369.641,384,351.969\r\n\t\tS369.672,320,351.938,320z"},"children":[{"name":"path","attribs":{"d":"M351.938,320C334.266,320,320,334.297,320,351.969S334.266,384,351.938,384C369.672,384,384,369.641,384,351.969\r\n\t\tS369.672,320,351.938,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.938,320C238.266,320,224,334.297,224,351.969S238.266,384,255.938,384C273.672,384,288,369.641,288,351.969\r\n\t\tS273.672,320,255.938,320z"},"children":[{"name":"path","attribs":{"d":"M255.938,320C238.266,320,224,334.297,224,351.969S238.266,384,255.938,384C273.672,384,288,369.641,288,351.969\r\n\t\tS273.672,320,255.938,320z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,320c-17.688,0-32,14.297-32,31.969S142.312,384,160,384c17.656,0,32-14.359,32-32.031S177.656,320,160,320z"},"children":[{"name":"path","attribs":{"d":"M160,320c-17.688,0-32,14.297-32,31.969S142.312,384,160,384c17.656,0,32-14.359,32-32.031S177.656,320,160,320z"},"children":[]}]}]}]};exports.threePointsBottom=threePointsBottom;var threePointsTop={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.938,128C334.266,128,320,142.297,320,159.969S334.266,192,351.938,192C369.672,192,384,177.641,384,159.969\r\n\t\tS369.672,128,351.938,128z"},"children":[{"name":"path","attribs":{"d":"M351.938,128C334.266,128,320,142.297,320,159.969S334.266,192,351.938,192C369.672,192,384,177.641,384,159.969\r\n\t\tS369.672,128,351.938,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.938,128C238.266,128,224,142.297,224,159.969S238.266,192,255.938,192C273.672,192,288,177.641,288,159.969\r\n\t\tS273.672,128,255.938,128z"},"children":[{"name":"path","attribs":{"d":"M255.938,128C238.266,128,224,142.297,224,159.969S238.266,192,255.938,192C273.672,192,288,177.641,288,159.969\r\n\t\tS273.672,128,255.938,128z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,128c-17.688,0-32,14.297-32,31.969S142.312,192,160,192c17.656,0,32-14.359,32-32.031S177.656,128,160,128z"},"children":[{"name":"path","attribs":{"d":"M160,128c-17.688,0-32,14.297-32,31.969S142.312,192,160,192c17.656,0,32-14.359,32-32.031S177.656,128,160,128z"},"children":[]}]}]}]};exports.threePointsTop=threePointsTop;var threePoints={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M351.938,224C334.266,224,320,238.297,320,255.969S334.266,288,351.938,288C369.672,288,384,273.641,384,255.969\r\n\t\tS369.672,224,351.938,224z"},"children":[{"name":"path","attribs":{"d":"M351.938,224C334.266,224,320,238.297,320,255.969S334.266,288,351.938,288C369.672,288,384,273.641,384,255.969\r\n\t\tS369.672,224,351.938,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.938,224C238.266,224,224,238.297,224,255.969S238.266,288,255.938,288C273.672,288,288,273.641,288,255.969\r\n\t\tS273.672,224,255.938,224z"},"children":[{"name":"path","attribs":{"d":"M255.938,224C238.266,224,224,238.297,224,255.969S238.266,288,255.938,288C273.672,288,288,273.641,288,255.969\r\n\t\tS273.672,224,255.938,224z"},"children":[]}]},{"name":"path","attribs":{"d":"M160,224c-17.688,0-32,14.297-32,31.969S142.312,288,160,288c17.656,0,32-14.359,32-32.031S177.656,224,160,224z"},"children":[{"name":"path","attribs":{"d":"M160,224c-17.688,0-32,14.297-32,31.969S142.312,288,160,288c17.656,0,32-14.359,32-32.031S177.656,224,160,224z"},"children":[]}]}]}]};exports.threePoints=threePoints;var topBottom={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256\r\n\t\tS397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"208,304 256,352 304,304 272,304 272,208 304,208 256,160 208,208 \r\n\t\t\t240,208 240,304 \t\t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"208,304 256,352 304,304 272,304 272,208 304,208 256,160 208,208 \r\n\t\t\t240,208 240,304 \t\t"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"128","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"192","y":"368","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"16"},"children":[{"name":"rect","attribs":{"x":"192","y":"368","fill-rule":"evenodd","clip-rule":"evenodd","width":"128","height":"16"},"children":[]}]}]}]}]}]};exports.topBottom=topBottom;var triplePoints={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M352,128c-17.672,0-32,14.328-32,32c0,1.781,0.25,3.5,0.531,5.188l-139.812,66.594C175.125,227,167.938,224,160,224\r\n\tc-17.672,0-32,14.328-32,32s14.328,32,32,32c6.781,0,13.062-2.156,18.25-5.75l64.938,56.062C241.203,342.484,240,347.078,240,352\r\n\tc0,17.672,14.328,32,32,32s32-14.328,32-32s-14.328-32-32-32c-6.938,0-13.328,2.266-18.562,6.031l-64.812-55.969\r\n\tc2.094-4.266,3.375-9,3.375-14.062c0-3.844-0.781-7.484-2.031-10.906l137.078-65.281C332.906,187.188,341.844,192,352,192\r\n\tc17.672,0,32-14.328,32-32S369.672,128,352,128z M144,256c0-8.812,7.188-16,16-16s16,7.188,16,16s-7.188,16-16,16\r\n\tS144,264.812,144,256z M272,336c8.828,0,16,7.172,16,16s-7.172,16-16,16c-8.812,0-16-7.172-16-16S263.188,336,272,336z M352,176\r\n\tc-8.828,0-16-7.188-16-16s7.172-16,16-16s16,7.188,16,16S360.828,176,352,176z"},"children":[]}]};exports.triplePoints=triplePoints;var underline={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M288.25,149.125V144H352v5.125h-6.75c-7.125,0-12.531,3.094-16.344,9.25c-1.844,2.875-2.781,9.516-2.781,19.938v76.062\r\n\t\t\tc0,18.828-1.844,33.422-5.375,43.781c-3.594,10.391-10.625,19.281-21.156,26.703C289.125,332.281,274.875,336,256.781,336\r\n\t\t\tc-19.641,0-34.562-3.547-44.719-10.672c-10.188-7.062-17.406-16.625-21.656-28.609c-2.812-8.219-4.25-23.609-4.25-46.219v-73.312\r\n\t\t\tc0-11.531-1.531-19.062-4.578-22.688c-3.062-3.578-7.984-5.375-14.828-5.375H160V144h77.812v5.125h-6.875\r\n\t\t\tc-7.469,0-12.75,2.438-15.969,7.328c-2.188,3.312-3.312,10.234-3.312,20.734v81.75c0,7.297,0.625,15.641,1.906,25.047\r\n\t\t\tc1.281,9.422,3.625,16.75,7,22s8.219,9.594,14.531,13.016c6.312,3.391,14.094,5.109,23.297,5.109\r\n\t\t\tc11.797,0,22.297-2.672,31.609-8.016c9.312-5.375,15.625-12.219,19.062-20.562c3.406-8.344,5.094-22.453,5.094-42.391v-75.953\r\n\t\t\tc0-11.703-1.25-19.031-3.75-21.969c-3.406-4.078-8.531-6.094-15.344-6.094H288.25z"},"children":[{"name":"path","attribs":{"d":"M288.25,149.125V144H352v5.125h-6.75c-7.125,0-12.531,3.094-16.344,9.25c-1.844,2.875-2.781,9.516-2.781,19.938v76.062\r\n\t\t\tc0,18.828-1.844,33.422-5.375,43.781c-3.594,10.391-10.625,19.281-21.156,26.703C289.125,332.281,274.875,336,256.781,336\r\n\t\t\tc-19.641,0-34.562-3.547-44.719-10.672c-10.188-7.062-17.406-16.625-21.656-28.609c-2.812-8.219-4.25-23.609-4.25-46.219v-73.312\r\n\t\t\tc0-11.531-1.531-19.062-4.578-22.688c-3.062-3.578-7.984-5.375-14.828-5.375H160V144h77.812v5.125h-6.875\r\n\t\t\tc-7.469,0-12.75,2.438-15.969,7.328c-2.188,3.312-3.312,10.234-3.312,20.734v81.75c0,7.297,0.625,15.641,1.906,25.047\r\n\t\t\tc1.281,9.422,3.625,16.75,7,22s8.219,9.594,14.531,13.016c6.312,3.391,14.094,5.109,23.297,5.109\r\n\t\t\tc11.797,0,22.297-2.672,31.609-8.016c9.312-5.375,15.625-12.219,19.062-20.562c3.406-8.344,5.094-22.453,5.094-42.391v-75.953\r\n\t\t\tc0-11.703-1.25-19.031-3.75-21.969c-3.406-4.078-8.531-6.094-15.344-6.094H288.25z"},"children":[]}]}]}]},{"name":"rect","attribs":{"x":"160","y":"352","width":"192","height":"16"},"children":[{"name":"rect","attribs":{"x":"160","y":"352","width":"192","height":"16"},"children":[]}]}]}]};exports.underline=underline;var uploadSelectionCircle={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"208.109,240.039 240.039,240.039 240.039,319.867 271.969,319.867 271.969,240.039 303.891,240.039 256,192.148 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"208.109,240.039 240.039,240.039 240.039,319.867 271.969,319.867 271.969,240.039 303.891,240.039 256,192.148 \t\r\n\t\t"},"children":[]}]},{"name":"path","attribs":{"d":"M189.484,165.883c-9.445,6.969-17.711,15.359-24.539,24.906l12.961,9.281c5.867-8.188,12.961-15.344,21.062-21.359\r\n\t\tL189.484,165.883z"},"children":[{"name":"path","attribs":{"d":"M189.484,165.883c-9.445,6.969-17.711,15.359-24.539,24.906l12.961,9.281c5.867-8.188,12.961-15.344,21.062-21.359\r\n\t\tL189.484,165.883z"},"children":[]}]},{"name":"path","attribs":{"d":"M255.164,159.961l-0.148-15.969c-11.789,0.109-23.398,2.031-34.5,5.75l5.055,15.125\r\n\t\tC235.078,161.695,245.023,160.039,255.164,159.961z"},"children":[{"name":"path","attribs":{"d":"M255.164,159.961l-0.148-15.969c-11.789,0.109-23.398,2.031-34.5,5.75l5.055,15.125\r\n\t\tC235.078,161.695,245.023,160.039,255.164,159.961z"},"children":[]}]},{"name":"path","attribs":{"d":"M190.516,346.867c9.539,6.875,20.047,12.203,31.227,15.781l4.891-15.203c-9.586-3.062-18.594-7.609-26.766-13.516\r\n\t\tL190.516,346.867z"},"children":[{"name":"path","attribs":{"d":"M190.516,346.867c9.539,6.875,20.047,12.203,31.227,15.781l4.891-15.203c-9.586-3.062-18.594-7.609-26.766-13.516\r\n\t\tL190.516,346.867z"},"children":[]}]},{"name":"path","attribs":{"d":"M149.633,291.18c3.703,11.141,9.094,21.594,16.07,31.078l12.852-9.453c-5.953-8.141-10.602-17.094-13.766-26.641\r\n\t\tL149.633,291.18z"},"children":[{"name":"path","attribs":{"d":"M149.633,291.18c3.703,11.141,9.094,21.594,16.07,31.078l12.852-9.453c-5.953-8.141-10.602-17.094-13.766-26.641\r\n\t\tL149.633,291.18z"},"children":[]}]},{"name":"path","attribs":{"d":"M164.453,226.883l-15.219-4.828c-3.469,10.953-5.234,22.359-5.234,33.938v0.609l15.961-0.609\r\n\t\tC159.961,246.055,161.477,236.258,164.453,226.883z"},"children":[{"name":"path","attribs":{"d":"M164.453,226.883l-15.219-4.828c-3.469,10.953-5.234,22.359-5.234,33.938v0.609l15.961-0.609\r\n\t\tC159.961,246.055,161.477,236.258,164.453,226.883z"},"children":[]}]},{"name":"path","attribs":{"d":"M345.938,189.227l-12.828,9.516c6.047,8.109,10.734,17.047,13.938,26.547l15.141-5.094\r\n\t\tC358.453,209.102,352.984,198.664,345.938,189.227z"},"children":[{"name":"path","attribs":{"d":"M345.938,189.227l-12.828,9.516c6.047,8.109,10.734,17.047,13.938,26.547l15.141-5.094\r\n\t\tC358.453,209.102,352.984,198.664,345.938,189.227z"},"children":[]}]},{"name":"path","attribs":{"d":"M363.25,255.164l-11.219,0.828c0,10.109-1.578,20.078-4.672,29.641l15.203,4.906c3.609-11.141,5.438-22.75,5.438-34.859\r\n\t\tL363.25,255.164z"},"children":[{"name":"path","attribs":{"d":"M363.25,255.164l-11.219,0.828c0,10.109-1.578,20.078-4.672,29.641l15.203,4.906c3.609-11.141,5.438-22.75,5.438-34.859\r\n\t\tL363.25,255.164z"},"children":[]}]},{"name":"path","attribs":{"d":"M312.547,333.617l9.422,12.875c9.516-6.938,17.828-15.281,24.703-24.766l-12.906-9.391\r\n\t\tC327.859,320.492,320.703,327.633,312.547,333.617z"},"children":[{"name":"path","attribs":{"d":"M312.547,333.617l9.422,12.875c9.516-6.938,17.828-15.281,24.703-24.766l-12.906-9.391\r\n\t\tC327.859,320.492,320.703,327.633,312.547,333.617z"},"children":[]}]},{"name":"path","attribs":{"d":"M289.625,149.133l-4.812,15.234c9.594,3.016,18.641,7.516,26.859,13.375l9.281-13.016\r\n\t\tC311.344,157.914,300.797,152.648,289.625,149.133z"},"children":[{"name":"path","attribs":{"d":"M289.625,149.133l-4.812,15.234c9.594,3.016,18.641,7.516,26.859,13.375l9.281-13.016\r\n\t\tC311.344,157.914,300.797,152.648,289.625,149.133z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.273,352.055l0.062,15.953c11.828-0.047,23.43-1.906,34.539-5.531l-4.984-15.172\r\n\t\tC276.406,350.398,266.438,351.992,256.273,352.055z"},"children":[{"name":"path","attribs":{"d":"M256.273,352.055l0.062,15.953c11.828-0.047,23.43-1.906,34.539-5.531l-4.984-15.172\r\n\t\tC276.406,350.398,266.438,351.992,256.273,352.055z"},"children":[]}]}]}]};exports.uploadSelectionCircle=uploadSelectionCircle;var uploadSelection={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.922"},"children":[{"name":"rect","attribs":{"x":"144.125","y":"224.031","width":"15.984","height":"63.922"},"children":[]}]},{"name":"path","attribs":{"d":"M167.969,368h8v-15.984h-8c-4.391,0-7.984-3.578-7.984-8v-7.984H144v7.984C144,357.234,154.75,368,167.969,368z"},"children":[{"name":"path","attribs":{"d":"M167.969,368h8v-15.984h-8c-4.391,0-7.984-3.578-7.984-8v-7.984H144v7.984C144,357.234,154.75,368,167.969,368z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.031","y":"351.891","width":"63.938","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.031","y":"351.891","width":"63.938","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M368,344.031l-0.125-8.125h-15.984l0.125,8.125c0,4.406-3.578,7.984-7.984,7.984h-8V368h8\r\n\t\tC357.25,368,368,357.25,368,344.031z"},"children":[{"name":"path","attribs":{"d":"M368,344.031l-0.125-8.125h-15.984l0.125,8.125c0,4.406-3.578,7.984-7.984,7.984h-8V368h8\r\n\t\tC357.25,368,368,357.25,368,344.031z"},"children":[]}]},{"name":"rect","attribs":{"x":"351.891","y":"224.031","width":"15.984","height":"63.938"},"children":[{"name":"rect","attribs":{"x":"351.891","y":"224.031","width":"15.984","height":"63.938"},"children":[]}]},{"name":"path","attribs":{"d":"M352.016,167.969v8H368v-8C368,154.75,357.25,144,344.031,144h-7.984v15.984h7.984\r\n\t\tC348.438,159.984,352.016,163.578,352.016,167.969z"},"children":[{"name":"path","attribs":{"d":"M352.016,167.969v8H368v-8C368,154.75,357.25,144,344.031,144h-7.984v15.984h7.984\r\n\t\tC348.438,159.984,352.016,163.578,352.016,167.969z"},"children":[]}]},{"name":"rect","attribs":{"x":"224.031","y":"144.125","width":"63.938","height":"15.984"},"children":[{"name":"rect","attribs":{"x":"224.031","y":"144.125","width":"63.938","height":"15.984"},"children":[]}]},{"name":"path","attribs":{"d":"M159.984,167.969c0-4.391,3.594-7.984,7.984-7.984h8V144h-8C154.75,144,144,154.75,144,167.969v8h15.984V167.969z"},"children":[{"name":"path","attribs":{"d":"M159.984,167.969c0-4.391,3.594-7.984,7.984-7.984h8V144h-8C154.75,144,144,154.75,144,167.969v8h15.984V167.969z"},"children":[]}]},{"name":"polygon","attribs":{"points":"239.891,320.109 271.859,320.125 271.984,239.828 303.953,239.828 256,191.891 208.047,239.828 239.906,239.75 \t\r\n\t\t"},"children":[{"name":"polygon","attribs":{"points":"239.891,320.109 271.859,320.125 271.984,239.828 303.953,239.828 256,191.891 208.047,239.828 239.906,239.75 \t\r\n\t\t"},"children":[]}]}]}]};exports.uploadSelection=uploadSelection;var upload={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,320 352,352 256,352 160,352 160,320 128,320 128,384 384,384 \r\n\t\t384,320 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"352,320 352,352 256,352 160,352 160,320 128,320 128,384 384,384 \r\n\t\t384,320 \t"},"children":[]}]},{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"240.047,208 240.047,336 272.047,336 272.047,208 320.047,208 \r\n\t\t256.047,128 192.047,208 \t"},"children":[{"name":"polygon","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","points":"240.047,208 240.047,336 272.047,336 272.047,208 320.047,208 \r\n\t\t256.047,128 192.047,208 \t"},"children":[]}]}]}]};exports.upload=upload;var userAdd={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.875-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.312,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.406,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.875-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.312,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.406,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"176","width":"48","height":"16"},"children":[{"name":"rect","attribs":{"x":"336","y":"176","width":"48","height":"16"},"children":[]}]},{"name":"rect","attribs":{"x":"352","y":"160","width":"16","height":"48"},"children":[{"name":"rect","attribs":{"x":"352","y":"160","width":"16","height":"48"},"children":[]}]}]}]};exports.userAdd=userAdd;var userBan={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.875-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.312,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.406,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.875-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.312,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.406,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[]}]},{"name":"rect","attribs":{"x":"336","y":"176","width":"48","height":"16"},"children":[{"name":"rect","attribs":{"x":"336","y":"176","width":"48","height":"16"},"children":[]}]}]}]};exports.userBan=userBan;var userRemove={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.891-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.328,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.422,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.531,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.438c4.031-4.969,4.625-12.531,5.547-15.969c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.281c-5.891-24.406-37.5-36.719-49.875-36.719s-43.969,12.312-49.875,36.719\r\n\t\tc-4.328,17.906,0.656,46.281,0.656,46.281s-6.328,0.219-4.875,5.625c0.938,3.438,1.984,11,6.031,15.969\r\n\t\tc2.125,2.594,3.422,1.406,3.766,2.438C215.422,245.969,224,257.844,224,264.188v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.531,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[]}]},{"name":"rect","attribs":{"x":"336.003","y":"176.001","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 235.5492 -200.6661)","width":"47.995","height":"15.998"},"children":[{"name":"rect","attribs":{"x":"336.003","y":"176.001","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 235.5492 -200.6661)","width":"47.995","height":"15.998"},"children":[]}]},{"name":"rect","attribs":{"x":"352.001","y":"160.003","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 235.5492 -200.6661)","width":"15.998","height":"47.995"},"children":[{"name":"rect","attribs":{"x":"352.001","y":"160.003","transform":"matrix(0.7071 0.7071 -0.7071 0.7071 235.5492 -200.6661)","width":"15.998","height":"47.995"},"children":[]}]}]}]};exports.userRemove=userRemove;var user={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.453c4.031-4.969,4.625-12.516,5.547-15.953c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.297c-5.875-24.406-37.5-36.703-49.875-36.703c-12.391,0-43.969,12.297-49.875,36.703\r\n\t\tc-4.344,17.922,0.656,46.297,0.656,46.297s-6.328,0.219-4.875,5.625c0.938,3.438,1.969,10.984,6.031,15.953\r\n\t\tc2.125,2.609,3.406,1.422,3.75,2.453c3.656,10.938,12.25,22.812,12.25,29.156v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[{"name":"path","attribs":{"d":"M325.906,306.188c-16-2.734-37.906-18.25-37.906-24.984v-17.016c0-6.344,8.594-18.219,12.25-29.156\r\n\t\tc0.344-1.031,2.547,0.156,4.688-2.453c4.031-4.969,4.625-12.516,5.547-15.953c1.469-5.406-5.094-5.625-5.094-5.625\r\n\t\ts4.891-28.375,0.547-46.297c-5.875-24.406-37.5-36.703-49.875-36.703c-12.391,0-43.969,12.297-49.875,36.703\r\n\t\tc-4.344,17.922,0.656,46.297,0.656,46.297s-6.328,0.219-4.875,5.625c0.938,3.438,1.969,10.984,6.031,15.953\r\n\t\tc2.125,2.609,3.406,1.422,3.75,2.453c3.656,10.938,12.25,22.812,12.25,29.156v17.016c0,6.734-21.922,22.25-37.922,24.984\r\n\t\tc-20.547,3.5-30.703,17.703-25.891,53.125c2.406,17.688,49.094,25.297,95.344,24.641c46.25,0.656,93.641-6.953,96.047-24.641\r\n\t\tC356.406,323.891,346.469,309.688,325.906,306.188z"},"children":[]}]}]}]};exports.user=user;var viewportVideo={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256c0,141.391,114.609,256,256,256c141.391,0,256-114.609,256-256\r\n\tC512,114.609,397.391,0,256,0z M256,472c-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"312.5,368 216.5,368 264.5,288 \t"},"children":[{"name":"polygon","attribs":{"points":"312.5,368 216.5,368 264.5,288 \t"},"children":[]}]},{"name":"g","attribs":{},"children":[{"name":"g","attribs":{},"children":[{"name":"polygon","attribs":{"points":"384,144 128,144 128,336 207.438,336 226.641,304 160,304 160,176 352,176 352,304 302.359,304 321.562,336 \r\n\t\t\t384,336 \t\t"},"children":[{"name":"polygon","attribs":{"points":"384,144 128,144 128,336 207.438,336 226.641,304 160,304 160,176 352,176 352,304 302.359,304 321.562,336 \r\n\t\t\t384,336 \t\t"},"children":[]}]}]}]}]}]};exports.viewportVideo=viewportVideo;var viewport={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M319.5,208.5h-128v96h128V208.5z M367.5,336.5h-48v16h64v-64h-16V336.5z\r\n\t M319.5,160.5v16h48v48h16v-64H319.5z M143.5,176.5h48v-16h-64v64h16V176.5z M143.5,288.5h-16v64h64v-16h-48V288.5z"},"children":[]}]};exports.viewport=viewport;var waves={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.625,0,0,114.609,0,256s114.625,256,256,256c141.406,0,256-114.609,256-256S397.406,0,256,0z M256,472\r\n\t\tc-119.281,0-216-96.703-216-216S136.719,40,256,40c119.312,0,216,96.703,216,216S375.312,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M312.188,335.281c-13.516,0-33.297-15.125-50.75-28.469c-21.656-16.547-44.062-33.656-66.875-33.656\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.5l26.328,19.844c0.141-0.172,14.109-17.531,40.234-17.531c11.594,0,30.25,14.281,46.719,26.828\r\n\t\tc22.703,17.359,46.172,35.297,70.906,35.297c45.484,0,70.766-34.406,71.812-35.844l-26.812-19.172\r\n\t\tC356.5,313.984,340.359,335.281,312.188,335.281z"},"children":[{"name":"path","attribs":{"d":"M312.188,335.281c-13.516,0-33.297-15.125-50.75-28.469c-21.656-16.547-44.062-33.656-66.875-33.656\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.5l26.328,19.844c0.141-0.172,14.109-17.531,40.234-17.531c11.594,0,30.25,14.281,46.719,26.828\r\n\t\tc22.703,17.359,46.172,35.297,70.906,35.297c45.484,0,70.766-34.406,71.812-35.844l-26.812-19.172\r\n\t\tC356.5,313.984,340.359,335.281,312.188,335.281z"},"children":[]}]},{"name":"path","attribs":{"d":"M312.188,206.031c-13.516,0-33.297-15.125-50.75-28.477c-21.656-16.531-44.062-33.648-66.875-33.648\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.516l26.328,19.836c0.141-0.18,14.109-17.539,40.234-17.539c11.594,0,30.25,14.266,46.719,26.844\r\n\t\tc22.703,17.344,46.172,35.281,70.906,35.281c45.484,0,70.766-34.391,71.812-35.844l-26.812-19.18\r\n\t\tC356.5,184.727,340.359,206.031,312.188,206.031z"},"children":[{"name":"path","attribs":{"d":"M312.188,206.031c-13.516,0-33.297-15.125-50.75-28.477c-21.656-16.531-44.062-33.648-66.875-33.648\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.516l26.328,19.836c0.141-0.18,14.109-17.539,40.234-17.539c11.594,0,30.25,14.266,46.719,26.844\r\n\t\tc22.703,17.344,46.172,35.281,70.906,35.281c45.484,0,70.766-34.391,71.812-35.844l-26.812-19.18\r\n\t\tC356.5,184.727,340.359,206.031,312.188,206.031z"},"children":[]}]},{"name":"path","attribs":{"d":"M312.188,270.906c-13.516,0-33.297-15.141-50.75-28.469c-21.656-16.547-44.062-33.656-66.875-33.656\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.5l26.328,19.844c0.141-0.188,14.109-17.531,40.234-17.531c11.594,0,30.25,14.266,46.719,26.844\r\n\t\tc22.703,17.344,46.172,35.281,70.906,35.281c45.484,0,70.766-34.406,71.812-35.844l-26.812-19.188\r\n\t\tC356.5,249.594,340.359,270.906,312.188,270.906z"},"children":[{"name":"path","attribs":{"d":"M312.188,270.906c-13.516,0-33.297-15.141-50.75-28.469c-21.656-16.547-44.062-33.656-66.875-33.656\r\n\t\tc-42.75,0-65.609,29.266-66.562,30.5l26.328,19.844c0.141-0.188,14.109-17.531,40.234-17.531c11.594,0,30.25,14.266,46.719,26.844\r\n\t\tc22.703,17.344,46.172,35.281,70.906,35.281c45.484,0,70.766-34.406,71.812-35.844l-26.812-19.188\r\n\t\tC356.5,249.594,340.359,270.906,312.188,270.906z"},"children":[]}]}]}]};exports.waves=waves;var wifi={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,336.156c-8.828,0-16,7.141-16,15.984s7.172,16.016,16,16.016s16-7.172,16-16.016S264.828,336.156,256,336.156z"},"children":[{"name":"path","attribs":{"d":"M256,336.156c-8.828,0-16,7.141-16,15.984s7.172,16.016,16,16.016s16-7.172,16-16.016S264.828,336.156,256,336.156z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,272.031c-23.125,0-43.562,10.625-57.359,27.047l14.547,19.391c9.297-13.734,24.984-22.75,42.812-22.75\r\n\t\ts33.516,9.016,42.797,22.75l14.578-19.391C299.547,282.656,279.125,272.031,256,272.031z"},"children":[{"name":"path","attribs":{"d":"M256,272.031c-23.125,0-43.562,10.625-57.359,27.047l14.547,19.391c9.297-13.734,24.984-22.75,42.812-22.75\r\n\t\ts33.516,9.016,42.797,22.75l14.578-19.391C299.547,282.656,279.125,272.031,256,272.031z"},"children":[]}]},{"name":"path","attribs":{"d":"M163.031,245.828l14.375,19.078c19.906-20.5,47.734-33.281,78.594-33.281c30.844,0,58.641,12.781,78.609,33.281\r\n\t\tl14.328-19.094c-24.031-23.406-56.781-37.875-92.938-37.875C219.812,207.938,187.062,222.406,163.031,245.828z"},"children":[{"name":"path","attribs":{"d":"M163.031,245.828l14.375,19.078c19.906-20.5,47.734-33.281,78.594-33.281c30.844,0,58.641,12.781,78.609,33.281\r\n\t\tl14.328-19.094c-24.031-23.406-56.781-37.875-92.938-37.875C219.812,207.938,187.062,222.406,163.031,245.828z"},"children":[]}]},{"name":"path","attribs":{"d":"M128,193.594l15.562,20.75c29.562-27.422,68.984-44.328,112.438-44.328s82.875,16.906,112.406,44.328L384,193.562\r\n\t\tc-33.922-30.594-78.734-49.391-128-49.391C206.719,144.172,161.938,162.969,128,193.594z"},"children":[{"name":"path","attribs":{"d":"M128,193.594l15.562,20.75c29.562-27.422,68.984-44.328,112.438-44.328s82.875,16.906,112.406,44.328L384,193.562\r\n\t\tc-33.922-30.594-78.734-49.391-128-49.391C206.719,144.172,161.938,162.969,128,193.594z"},"children":[]}]}]}]};exports.wifi=wifi;var wind={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M354.469,206.766c-16.312,0-29.547,13.234-29.547,29.547c0,3.469,0.719,6.734,1.812,9.844H137.844\r\n\t\tc-5.438,0-9.844,4.406-9.844,9.844s4.406,9.844,9.844,9.844h216.625c16.297,0,29.531-13.234,29.531-29.531\r\n\t\tC384,220,370.766,206.766,354.469,206.766z"},"children":[{"name":"path","attribs":{"d":"M354.469,206.766c-16.312,0-29.547,13.234-29.547,29.547c0,3.469,0.719,6.734,1.812,9.844H137.844\r\n\t\tc-5.438,0-9.844,4.406-9.844,9.844s4.406,9.844,9.844,9.844h216.625c16.297,0,29.531-13.234,29.531-29.531\r\n\t\tC384,220,370.766,206.766,354.469,206.766z"},"children":[]}]},{"name":"path","attribs":{"d":"M137.844,226.469H256c16.312,0,29.531-13.234,29.531-29.547c0-16.297-13.219-29.531-29.531-29.531\r\n\t\ts-29.531,13.234-29.531,29.531c0,3.469,0.719,6.75,1.797,9.844h-90.422c-5.438,0-9.844,4.406-9.844,9.844\r\n\t\tS132.406,226.469,137.844,226.469z"},"children":[{"name":"path","attribs":{"d":"M137.844,226.469H256c16.312,0,29.531-13.234,29.531-29.547c0-16.297-13.219-29.531-29.531-29.531\r\n\t\ts-29.531,13.234-29.531,29.531c0,3.469,0.719,6.75,1.797,9.844h-90.422c-5.438,0-9.844,4.406-9.844,9.844\r\n\t\tS132.406,226.469,137.844,226.469z"},"children":[]}]},{"name":"path","attribs":{"d":"M295.375,285.531c-0.562,0-1.125,0.141-1.719,0.188c-0.375-0.031-0.688-0.188-1.078-0.188H140.656\r\n\t\tc-7,0-12.656,4.422-12.656,9.859s5.656,9.844,12.656,9.844h127c-1.094,3.094-1.812,6.375-1.812,9.844\r\n\t\tc0,16.312,13.234,29.531,29.531,29.531c16.312,0,29.547-13.219,29.547-29.531S311.688,285.531,295.375,285.531z"},"children":[{"name":"path","attribs":{"d":"M295.375,285.531c-0.562,0-1.125,0.141-1.719,0.188c-0.375-0.031-0.688-0.188-1.078-0.188H140.656\r\n\t\tc-7,0-12.656,4.422-12.656,9.859s5.656,9.844,12.656,9.844h127c-1.094,3.094-1.812,6.375-1.812,9.844\r\n\t\tc0,16.312,13.234,29.531,29.531,29.531c16.312,0,29.547-13.219,29.547-29.531S311.688,285.531,295.375,285.531z"},"children":[]}]}]}]};exports.wind=wind;var wireframeGlobe={"viewBox":"0 0 512 512","children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]},{"name":"path","attribs":{"d":"M256,128c-70.688,0-128,57.312-128,128s57.312,128,128,128s128-57.312,128-128S326.688,128,256,128z M144.406,264h57.312\r\n\tc0.719,15.422,3.344,32.266,6.547,48h-49.109C150.844,297.688,145.641,281.406,144.406,264z M201.719,248h-57.312\r\n\tc1.234-17.406,6.438-33.688,14.75-48h49.109C205.062,215.734,202.438,232.578,201.719,248z M224.281,200h63.438\r\n\tc3.219,15.75,5.844,32.609,6.562,48h-76.562C218.438,232.609,221.062,215.75,224.281,200z M217.719,264h76.562\r\n\tc-0.719,15.391-3.344,32.234-6.562,48h-63.438C221.062,296.234,218.438,279.391,217.719,264z M310.281,264h57.312\r\n\tc-1.234,17.406-6.438,33.688-14.75,48h-49.109C306.953,296.266,309.562,279.422,310.281,264z M310.281,248\r\n\tc-0.719-15.422-3.328-32.266-6.547-48h49.109c8.312,14.312,13.516,30.594,14.75,48H310.281z M341.672,184h-41.484\r\n\tc-3.359-14.188-6.797-26.375-9.172-34.312C310.953,156.266,328.422,168.281,341.672,184z M273.75,145.547\r\n\tc2.266,7.359,6.406,21.484,10.422,38.453h-56.344c4.016-16.969,8.156-31.094,10.422-38.453C244.047,144.625,249.938,144,256,144\r\n\tS267.953,144.625,273.75,145.547z M221,149.688c-2.375,7.938-5.828,20.125-9.188,34.312h-41.469\r\n\tC183.562,168.281,201.047,156.266,221,149.688z M170.344,328h41.469c3.359,14.188,6.797,26.375,9.172,34.312\r\n\tC201.047,355.734,183.578,343.719,170.344,328z M238.25,366.453c-2.266-7.359-6.406-21.484-10.422-38.453h56.344\r\n\tc-4.016,16.953-8.141,31.094-10.406,38.453C267.969,367.375,262.062,368,256,368S244.047,367.375,238.25,366.453z M291.016,362.312\r\n\tc2.391-7.938,5.828-20.125,9.188-34.312h41.453C328.422,343.719,310.953,355.719,291.016,362.312z"},"children":[]}]};exports.wireframeGlobe=wireframeGlobe;var world={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M203.141,201c0.406,0.344,0.422,0.219,0.812,0.594c0.188-0.156,0.594-0.594,0.781-0.781\r\n\t\tc-0.547-0.867,0.094-0.867,0.375-0.125c-0.156-1.023,0.875-1.898,1.812-1.867C204.703,197.133,204.562,201.156,203.141,201z"},"children":[{"name":"path","attribs":{"d":"M203.141,201c0.406,0.344,0.422,0.219,0.812,0.594c0.188-0.156,0.594-0.594,0.781-0.781\r\n\t\tc-0.547-0.867,0.094-0.867,0.375-0.125c-0.156-1.023,0.875-1.898,1.812-1.867C204.703,197.133,204.562,201.156,203.141,201z"},"children":[]}]},{"name":"path","attribs":{"d":"M256.016,127.992C185.297,127.992,128,185.297,128,256c0,70.688,57.297,128,128.016,128C326.688,384,384,326.688,384,256\r\n\t\tC384,185.297,326.688,127.992,256.016,127.992z M344.438,231.344c0,0.094,2.344,2.688,0.531,3\r\n\t\tc-0.844,0.156-0.906-1.906-0.969-2.312C344.219,232.031,344.328,231.562,344.438,231.344z M339.781,237.375\r\n\t\tc-0.031,0.031-0.484,0.688-0.484,0.062C339.438,237.406,339.625,237.406,339.781,237.375z M339.031,238.125\r\n\t\tc0.062,0.188,0.328,0.219,0.406,0.438c-0.438,0-0.281,0-0.594-0.094C338.906,238.344,338.969,238.25,339.031,238.125z\r\n\t\t M338.031,237.875c-0.375,0,0.031-0.25-0.359,0.031c-0.141-0.25-0.016-0.094-0.016-0.312c-0.062-0.188,0-0.25,0.188-0.188\r\n\t\tC337.906,237.562,337.969,237.719,338.031,237.875z M322.5,226.469c0.25,0,0.469,0.062,0.469,0.656\r\n\t\tc0.125-0.125,0.25-0.094,0.188-0.312c0.156,0.219,1.25,0.719,1.281,0.938c0,0.75-0.906,0.656-0.906,1.125\r\n\t\tc-0.156-0.031-0.812-0.094-0.812-0.344c-0.359,0-0.438,0.625-1.156,0.625c0-0.094,0.516-1.062,0.656-1.25\r\n\t\tC322.453,227.906,322.5,226.781,322.5,226.469z M318.344,224.906c-0.188-0.656,1.125-1.75,1.125-1.062\r\n\t\tc0.594,0.25,1.594,1.562,0.594,1.938c1.156,0.094,0.844-0.219,0.844,0.781c0.562,0,0.281-0.156,0.5-0.594\r\n\t\tc0.375,0,0.625,1.969-0.781,1.406c0,0.625-1.859-0.406-1.75-0.062c-0.141-0.125-0.188-0.281-0.141-0.469\r\n\t\tc-0.219,0.031-0.266,0.125-0.547,0.125c0-0.094,0-0.188,0-0.312c0.188,0,1.531-0.969,1.531-1.031\r\n\t\tc-0.438-0.031-0.922-0.125-0.922,0.281c-0.25-0.156-1.328-0.562-1.328-0.719C317.969,225.188,317.781,224.906,318.344,224.906z\r\n\t\t M320,231.812c0.312,0.25,0.062,0.219-0.641-0.031c0.109-0.031,0.25-0.094,0.391-0.156\r\n\t\tC319.688,231.844,319.781,231.875,320,231.812z M317.375,225.656c0,0.344,0.438,0.781,0.688,1c-1.25-0.188-1.312,0.156-1.312-1.031\r\n\t\tC316.938,225.656,317.172,225.656,317.375,225.656z M316.234,223.25c0.422,0.062,0.016,0.156,0.453,0.156\r\n\t\tc-0.156,0.156-0.219,0.094-0.219,0.312C315.938,223.719,316.234,223.25,316.234,223.25z M308.766,236.156\r\n\t\tc-0.016,0.125,0.094,0.438,0.094,0.656c-0.312-0.031-0.359-0.156-0.578-0.375C308.438,236.344,308.594,236.25,308.766,236.156z\r\n\t\t M308.156,237.062c-0.094,0.25-0.906,1.281-0.781,0.375C307.641,237.219,307.75,237,308.156,237.062z M302.922,235.312\r\n\t\tc0.094-0.125,0.203-0.281,0.297-0.438c0.234,0.625,0.125,0.594-0.344,0.938C302.656,235.531,302.922,235.594,302.922,235.312z\r\n\t\t M299.375,221.625c0.453,0.094,1.531-0.594,1.531,0.25c-0.375-0.031-1.562,1.469-1.562,0.062\r\n\t\tC299.547,222.062,299.406,221.719,299.375,221.625z M297.75,221.531c0.562-0.062,0.844,0.281,0.844,0.906\r\n\t\tc-0.438-0.031-0.25,0.125-0.703-0.094c0.031,0.25,0.047,0.531,0.062,0.812c-0.312-0.031-0.547-0.031-0.875-0.125\r\n\t\tC296.906,222.375,297.141,221.875,297.75,221.531z M296.859,218.406c0.172,0,0.203,0,0.203,0.188\r\n\t\tc-0.188-0.031-0.375-0.031-0.562-0.094C296.609,218.469,296.75,218.438,296.859,218.406z M295.562,220.875\r\n\t\tc-0.5-0.312-0.562-0.344-0.734-0.781c0.375-0.156,0.391,0.344,0.484-0.219c0.219,0.188,0.5,0.281,0.75,0.438\r\n\t\tc-0.078,0.094-0.156,0.188-0.219,0.281c-0.25-0.219-0.219-0.344-0.562-0.406c0.203,0.188,0.25,0.531,0.531,0.562\r\n\t\tC295.844,220.938,295.781,221,295.562,220.875z M295.625,222.438c0,0.281-0.094,0.344-0.062,0.656\r\n\t\tC294.75,223.094,294.656,222.344,295.625,222.438z M296.359,220.688c-0.141-0.062-0.172,0.406-0.312-0.062\r\n\t\tC296.156,220.531,296.656,220.094,296.359,220.688z M295.766,222.156C297.281,222.281,295.656,223.688,295.766,222.156\r\n\t\tL295.766,222.156z M296.828,223.281c0.031,0.219,0.062,0.406,0.062,0.656c-0.266-0.094-0.562-0.312-0.562-0.562\r\n\t\tC296.5,223.344,296.656,223.344,296.828,223.281z M296.016,218.75c0.031,0.188,0.203,0.094,0.203,0.312\r\n\t\tc-0.094,0.062-0.172,0.094-0.266,0.156C295.906,219.062,295.797,218.688,296.016,218.75z M295.281,218.938\r\n\t\tc0.156,0.062,0.312,0.125,0.453,0.219c0,0.656-1.172,0.125-0.922,0.188C294.906,218.875,295.281,219.562,295.281,218.938z\r\n\t\t M294.281,220.312c0.125,0.188,0.219,0.219,0.5,0.281c0,0.406-0.812,0.125-0.75-0.156\r\n\t\tC294.25,220.562,294.312,220.531,294.281,220.312z M292.438,221.906C294.047,222.062,292.438,222.719,292.438,221.906\r\n\t\tL292.438,221.906z M292.422,232.125c0.078-0.594,0.203-0.75,0.812-0.5c-0.234-0.438-0.219-0.156,0.078-0.469\r\n\t\tc-0.188,0.031-0.219-0.094-0.094-0.312c0.578,0.062,3.328-0.344,3.531-0.906c0.062,0.219,0.188,0.281,0.469,0.25\r\n\t\tc0.109-0.938,1.016-0.406,1.016,0c0.859-0.25,1.266-0.438,2.047-0.656c0.312-0.062,0.594-0.375,1.156-0.312\r\n\t\tc0.188,0.188,0.359,1.281-0.219,1.062c-0.203,0.75-2.109,0.5-2.641,0.719c-1.047,0.469-1.531,0.219-2.562,0.938\r\n\t\tc0-0.5-0.781,0.219-1.016,0.156c-0.109,0.5-0.172,0.5-0.672,0.875c0.062-0.188,0.109-0.375-0.078-0.375\r\n\t\tc-0.094,1.094-0.219,0.281-0.25,0.938c-0.172-0.062-0.344-0.156-0.484-0.25c-0.062,0.812-0.391,0.875-0.797,0.344\r\n\t\tc-0.156,0.406-0.438-0.062-0.688-0.094c0,0.312,0.906,0.625,1.203,1c-0.953,0.656-0.984,3.688,0.5,3.844\r\n\t\tc-0.141,0.531-0.609-0.125-0.891-0.156c-0.094,0.656,0.141,0,0.031,0.625c-0.203,0-0.094-0.156-0.094-0.312\r\n\t\tc-1.125-0.156-1.219,0.094-2.219-0.25c0-0.375,0.406-0.719,0.734-0.688c0.078-0.781-0.641-0.062-0.344-1.188\r\n\t\tc-0.188,0-0.5,0.094-0.672,0.188c-0.031-0.094-0.047-0.219-0.062-0.312c-0.188,0.25-0.25,0.406-0.641,0.375\r\n\t\tc-0.078-0.469-0.031-0.875,0.25-1.281c0.375,0.281,0.281,0.094,0.484,0.25c0-0.531,0.406-0.812,0.406-1.031\r\n\t\tc0.125-0.219-0.031-0.562,0.125-0.812c0.438,0.094,0.672,0.125,0.812-0.312c-0.094,0.031-0.188,0.062-0.312,0.094\r\n\t\tc0.094-0.094,0.625-0.938,0.625-0.688c-0.391-0.156-0.812,0.188-0.812-0.469c0.188,0,1-0.094,1-0.469\r\n\t\tC292.375,232.031,292.172,232.125,292.422,232.125z M295.625,240.438c-0.406,0-0.594-0.125-0.797-0.156\r\n\t\tc-0.328-0.156-0.109-0.438-0.547-0.219c0.125-0.312-0.031-0.656,0-0.969C294.906,239.125,295.281,240,295.625,240.438z\r\n\t\t M290.766,222.375c0-0.188,0.219-0.25,0.391-0.219c0.031,0.094,0.031,0.188,0.062,0.312\r\n\t\tC291.078,222.438,290.938,222.375,290.766,222.375z M291.609,222.375c0.359,0,0.422,0.219,0.141,0.688\r\n\t\tc-0.203-0.031-0.406-0.094-0.594-0.125C291.156,222.781,291.5,222.594,291.609,222.375z M291.547,220.938\r\n\t\tc-0.047,0.156-0.109,0.281-0.203,0.438c0.156-0.062,0.281-0.156,0.438-0.25c0.125,1.094-1.469,0.562-2.375,1\r\n\t\tc0.125-0.375-0.062-0.312-0.406-0.406c0.062-0.25,0.188-0.25,0.328-0.406c-0.297,0.062-0.422,0-0.328-0.25\r\n\t\tc0.562-0.031,0.75,0.5,1.281,0.406c0.438-0.031,0.906-0.562,0.812-0.594C291.297,220.875,291.156,221.125,291.547,220.938z\r\n\t\t M287.812,220.188c0.359,0,2.859,0.125,2.641,1c-0.625-0.125-1.172-0.281-1.766-0.469c-0.281,0.594-0.594,0.625-0.969,0.094\r\n\t\tc0,0.156-0.5,0.156-0.75,0.344c0.25-0.344-0.719-0.344-0.719-0.625C286.719,220.156,287.109,220.094,287.812,220.188z\r\n\t\t M288.062,239.469c-0.109,0.5-0.406,0.656-0.469,1.062C286.828,240.344,287.047,239.156,288.062,239.469z M277.719,221.75\r\n\t\tc-0.312-0.094-0.891-0.219-0.781-0.531C277.094,221.25,277.922,221.5,277.719,221.75z M271.766,217.562\r\n\t\tc0.234-1,0.297,0.031,0.562-0.469c-0.547-0.156,0.172-0.375,0.234-0.469c0.172,0.656,0.906,0.844,0.953,1.25\r\n\t\tc0.109,0.844,0.812,0.125,1.031,0.156c-0.078,0.156-0.156,0.281,0.047,0.312c0.359-1.25,0.297-0.062,0.062,0.188\r\n\t\tc0.438,0.094,0.688-0.125,1.031-0.375c0,0.188-0.125,0.281-0.234,0.406c0.203-0.094,0.25,0.031,0.312-0.219\r\n\t\tc0.297,0.094,0.312,0.594,0.922,0.719c-0.125,0.406-0.453,0.656-0.875,0.594c-0.156,0.188-0.125,0.312,0.062,0.312\r\n\t\tc-0.312,0.031-0.594,0.094-0.906,0.094c-0.312,0.969-3.672-0.656-3.516-1.469c0.469,0.312,0.938,0.094,1.266,0.219\r\n\t\tc-0.297-0.219-1.266-0.25-1.469-0.406c-0.734-0.156,0.203-0.656,0.234-0.781c-0.266-0.031-0.547-0.312-0.453-0.594\r\n\t\tC271.234,217.25,271.562,217.5,271.766,217.562z M276.031,221.812c-0.312-0.156-0.281-0.094-0.281-0.438\r\n\t\tC276.266,221.5,275.812,221.5,276.031,221.812z M272.125,223.219c-0.047,0.156-0.672-0.344-1.234-0.219\r\n\t\tc0.078-0.344,0.172-0.75,0.281-1.062c1.422-0.25,1.391,0.781,2.359,0.969C273.375,223.5,272.734,223.375,272.125,223.219z\r\n\t\t M272.25,233.094c-0.156,0.312-0.328-0.094-0.547-0.156c0.109-0.219,0.172,0,0.203-0.281\r\n\t\tC272,232.812,272.094,233.062,272.25,233.094z M270.828,220.875c0.062,0.031,1.906,0.031,1.203,0.562\r\n\t\tC271.484,221.906,271.062,221.688,270.828,220.875z M266.5,218.625c0.031-0.625,0.453-1.188,0.031-1.312\r\n\t\tc0.141-0.219,0.25-0.438,0.375-0.688c0.141,0,0.25,0.375,0.438-0.062c0.234,0.125,0.328,0.312,0.641,0.406\r\n\t\tc-0.094,0.281-0.312,0.062-0.547,0.125c-0.078,0.281,0.297,0.219,0.188,0.562c0.094,0,0.172,0.031,0.234,0.062\r\n\t\tc0.469-1.5,0.109-0.062,0.594-0.625c0,0.5,0.188,0.781,0.25,1.219c0.188-0.688,0.422-1.062,0.953-1.5\r\n\t\tc0.266,0.125,0.234,0.469,0.234,0.688c0.219,0.094,0.234-0.188,0.406-0.188c-0.109,0.562,0.312,0.812,0.109,1.5\r\n\t\tc0.172,0.031,0.672,1.188,1.016,1.75c-1.188-0.344-1.062,0.438-1.203,1.094c-0.266-0.062-1.859,1.156-1.703,0.844\r\n\t\tc-0.125,0.219-0.344,0.188-0.328,0.719c-0.359-0.094-0.391,0.062-0.562,0.031c0.047-0.281,0.094-0.562,0.109-0.812\r\n\t\tc-0.5-0.125-1.531-0.531-1.172-1.5c0.391,0.281,0.516,0.312,0.984,0.438c0.078-0.25,0.469-0.75,0.453-0.656\r\n\t\tc-0.453-0.156-1.234-0.125-1.406-0.281c0.484-1.594,2.156,0.719,2.609-0.344c-0.5-0.219-0.359-0.125-0.719-0.562\r\n\t\tc-0.312,0.688-0.344-0.469-0.344-0.594c-0.156,0-0.344,0.219-0.234-0.062c-0.359,0.5-0.844,0.594-1.453,0.375\r\n\t\tC266.484,219.125,266.766,218.656,266.5,218.625z M268.953,232.844c0.094-0.531,0.469-0.5,1.031-0.531\r\n\t\tc-0.125,0.188-0.375,0.375-0.578,0.344C269.375,232.844,269.125,232.875,268.953,232.844z M270.297,233.062\r\n\t\tc-0.141,0.188-0.25,0.375-0.406,0.531c0.047-0.188,0-0.344-0.156-0.5C270.172,233.156,269.484,232.875,270.297,233.062z\r\n\t\t M267.234,233.031c-0.125,0.156-0.219,0.281-0.312,0.438c-0.094-0.094-0.219-0.188-0.328-0.25\r\n\t\tC266.875,232.656,266.922,233.031,267.234,233.031z M266.703,233.406c-0.141,0.312-0.188,0.438-0.531,0.312\r\n\t\tc0.031-0.156,0.078-0.281,0.109-0.438C266.422,233.312,266.547,233.375,266.703,233.406z M266.172,217.688\r\n\t\tc0.062,0.031,0.078,1.062,0.078,1.344C265.891,218.969,266.078,218,266.172,217.688z M264.234,234.5\r\n\t\tc-0.031,0.156-0.094,0.312-0.141,0.469c0.047,0.031,0.359-0.125,0.453-0.188c-0.062,0.656-1.125,1.219-0.969,0.531\r\n\t\tc-0.062,0.031-0.125,0.094-0.188,0.125C263.453,235.188,264.109,234.5,264.234,234.5z M263.188,235.188\r\n\t\tc-0.047,0.125-0.609,0.562-0.5,0.219C262.859,235.312,263.016,235.25,263.188,235.188z M262.453,235.312\r\n\t\tc0,0.125,0.031,0.25,0.031,0.344c-0.109-0.062-0.562,0.344-0.469-0.094C262.266,235.562,262.125,235.219,262.453,235.312z\r\n\t\t M231.297,196.539c0.062,0.688,0.781,1.375,0.5,1.906C231.453,197.727,230.922,197.18,231.297,196.539z M207.047,185.164\r\n\t\tc0.109-0.258,0.219-0.289,0.344-0.086c-0.109,0.312-0.344,0.703-0.531,0.977C206.844,185.805,207.031,185.156,207.047,185.164z\r\n\t\t M209.828,198.32c-0.812,1.125-1.219-0.25-1.406-0.438c-0.047,0.125-0.141,0.203-0.281,0.219c0.109-0.219,0.203-0.406,0.016-0.594\r\n\t\tc-0.641,0.844-1.672-0.844-1.719-1.062c-0.594,0.078-1.578-0.469-0.828-1.062c-0.656,0.422-1.406,0.125-1.812-0.375\r\n\t\tc0.656-0.625,2.406-2.391,1.438-3.156c-0.141,0.094-0.312,0.156-0.453,0.219c-0.297-0.656-0.453-2.523,0.547-1.594\r\n\t\tc0.062-0.094,2.375,3.812,0.844,2.719c-0.234,0.25,0.062,0.062-0.297,0.359c0.203,0.016,0.406,0.062,0.609,0.094\r\n\t\tc-0.062,0.109-0.156,0.172-0.281,0.172c0.25,0.188,0.5-0.125,0.156,0.312c0.031,0.031,0.656,0.312,0.281,0.656\r\n\t\tc0.25,0.156,0.125-0.094,0.375,0.281c0.203-0.266,2.375,0.938,3.078,1.438C209.984,196.633,211.328,198.977,209.828,198.32z\r\n\t\t M203.609,192.164c0.578-0.594,0.453,0.812,0.406,0.75c-0.156,0.609-0.844,0.844-1.125,1.156c-0.312-0.219-0.031-0.438-0.281-0.625\r\n\t\tC202.297,192.852,203.031,191.82,203.609,192.164z M202.828,191.945c0.469-0.5,0.188,0.016,0.625-0.094\r\n\t\tC203.344,191.961,203.094,192.133,202.828,191.945z M205.375,189.672c0.406-0.32,1.484,0.438,1.734,0.547\r\n\t\tc-0.203,0.125-0.156,0.234,0.125,0.32C206.141,191.164,206.125,190.266,205.375,189.672z M206.766,192.648\r\n\t\tc0.125-0.422,0.281-0.578,0.594-0.359c-0.094,0.172-0.203,0.375-0.312,0.531C206.953,192.758,206.875,192.711,206.766,192.648z\r\n\t\t M205.516,188.328c0.219,0.148,0.172,0.227,0.375,0.086c-0.75-0.438-0.172-1.023,0.469-1.266c0.125,0.414,0.438,1.062,0.094,1.344\r\n\t\tc0.734,1.141-0.719,0.852-1.141,0.492C205.516,188.766,205.422,188.492,205.516,188.328z M203.094,185.102\r\n\t\tc0.109-0.047,0.203-0.109,0.312-0.156c-0.141-0.125-0.203,0.047-0.328-0.094c0.891-0.906,0.203-0.094,0.062-0.32\r\n\t\tc0.469-0.523,0.312-0.328,0.719-0.484c0,0.539,0.219,0.625,0.062,1.164c0.141-0.07,0.312-0.141,0.469-0.234\r\n\t\tc-0.031,0.344,0.156,0.25-0.125,0.555c0.781,0.188,1.25,2.516-0.156,2.875c-0.094-0.664,0-2.836-0.5-2.195\r\n\t\tc-0.109-0.047-0.484-0.32-0.594-0.578c-0.016,0.062-0.031,0.102,0.125-0.031c-0.406-0.344,0.156-0.156,0.25-0.242\r\n\t\tc-0.125-0.062-0.094-0.125,0.031-0.18C203.219,184.961,203.391,185.422,203.094,185.102z M203.766,187.445\r\n\t\tc0.094,0-0.781,0.258-0.172-0.352C203.828,187.312,203.641,187.375,203.766,187.445z M202.859,189.461\r\n\t\tc0.094-0.367-0.062-0.641,0.562-0.617c-0.219,0.398-0.5,0.625-0.156,0.93c0.141-0.18,0.188-0.336,0.344-0.555\r\n\t\tc0.547,0.562-1,2.414-1.188,3.023c-0.188-0.359-0.203,0.078-0.266,0.172c-0.625-0.25-1.031-0.656-1.516-1.078\r\n\t\tc0.422-0.516,0.875-0.359,1.047-0.57c-0.422-0.242-1.141-0.297-1.391-0.578c0.219-0.25,0.469-0.359,0.625-0.516\r\n\t\tc0.125,0.109,0.297,0.266,0.438,0.391c0.188-0.633,0.344-1.258,1.031-1.258c-0.062,0.578-0.406,1.211-0.562,1.633\r\n\t\tc0.312-0.297,0.453-0.883,0.75-1.266C202.672,189.266,202.766,189.367,202.859,189.461z M201.734,192.695\r\n\t\tc-0.188,0.281-0.109-0.094-0.281,0.156C201.266,192.727,201.641,192.727,201.734,192.695z M199.625,194.711\r\n\t\tc0.344,0.266,0.156-0.109,0.453-0.047c-0.234,0.25-0.266,0.469-0.453,0.688c0.172,0,0.344,0,0.531,0\r\n\t\tc-0.328,1.062-1.984,1.812-2.953,1.094c0.625-0.781,0.281-1.297,0.375-2.234c-0.188,0.016-0.312,0.125-0.406,0.328\r\n\t\tc-0.156-0.75,0.156-1.047,0.516-1.734c0.453,0.469-0.172,0.797,0.766,1.328c0.781-0.625-0.312-1.625,1.297-1.656\r\n\t\tc-0.266,0.344,0.078,0.375,0.078,0.719c0.125-0.188,0-0.281,0.234-0.438c0.531,0.469,0.641-0.172,1.016,0.234\r\n\t\tc-0.281,0.328-1.094,0.094-0.844,0.359C201.609,193.68,199.969,194.289,199.625,194.711z M196.422,200.875\r\n\t\tc-0.531-0.25-0.438,0.031-0.781-0.469c-0.328,0.5-0.125,0.156-0.469,0.281c0.188-0.344-0.031-0.062-0.156-0.156\r\n\t\tc0.234-0.25,0.078-0.469,0.156-0.711c0.078,0.125,0.172,0.094,0.266-0.172c-0.203-0.156-0.234-0.141-0.359,0.109\r\n\t\tc-0.219-0.219-0.188-0.062,0.031-0.391c-0.094,0-0.172-0.016-0.25-0.016c0.219-0.438,0.609-0.656,1.125-0.75\r\n\t\tc0.188,0.172-0.094,0.094,0.062,0.266c0.312-0.312,0.125-0.203,0.453-0.234c0,0,0.156,1.219,0.359,1.312\r\n\t\tC196.594,200.281,196.078,200.594,196.422,200.875z M194.609,197.602c-0.719-0.562-0.25-0.281-0.531-0.844\r\n\t\tc-0.234,0.297-0.188,0.453-0.188,0.875c0.375,0.062,0.031-0.469,0.531,0.031c-0.5,0.625-0.891,0-1.281,0.406\r\n\t\tc-0.312-0.375-0.281-0.656-0.562-0.953c0.344-0.438,0.062-0.859,0.531-1.266c-0.625-0.531-1.844,0.25-2.25-0.344\r\n\t\tc-0.547,0.625-1.75-0.844-2.125-1.188c0.781,0.766-0.094-1.969-0.125-1.75c0.375-0.562,0.156-0.844,0.688-1.375\r\n\t\tc0.469,0.406,0.938,0.531,1.344,0.938c0.156,0.094,0.188,1.062,0.625,0.609c0.359,0.109,0.297-0.359,0.594-0.094\r\n\t\tc-0.188-0.5-1.375-1.859-2.156-2.195c0.344-0.391,0.656-0.773,1.016-0.133c0.328-0.281,0.453-0.219,0.766,0.141\r\n\t\tc0.281-0.344-0.406-0.648-0.625-0.445c-0.266-0.172-0.562-0.305-0.766-0.531c0.266-0.094-0.016-0.5,0.422-0.031\r\n\t\tc-0.125-0.203,0-0.281,0.156-0.328c-0.188-0.227-0.312-0.062-0.562-0.109c0.156-0.086,0.391-0.945,1.078-0.844\r\n\t\tc0.016,0.008,0.859-0.414,0.984-0.508c0.094,0.156,0.609,0.305,0.484,0.289c-0.031,0.047,0.641,0.164,0.922,0.031\r\n\t\tc1.094-0.422,0.062,1.055-0.016,0.914c-0.484,0.516-0.578,1.062-0.438,1.609c0.453-0.453,0.766-0.695,1.172-1.305\r\n\t\tc0.562,0.453-0.359,0.984,0.141,1.477c0.391-0.492,1.219-0.297,0.859,0.172c0.109,0.688-0.875,1.188-1.312,1.625\r\n\t\tc0.469-0.125,0.734-0.125,1.188-0.438c0.484,0.375,0.641,0.891,0.219,1.625c-0.234,0.469-1.031,2.859-0.188,1.906\r\n\t\tc-0.469,1.25,1.031,1.594-0.312,2.531c-0.016-0.312-0.031-0.531,0-0.844c-0.156-0.281-0.281-0.281-0.422,0.031\r\n\t\tC194.609,197.414,194.781,197.414,194.609,197.602z M194.453,198.977c-0.375-0.25,0.062-0.125-0.156-0.328\r\n\t\tC194.547,198.43,194.719,198.695,194.453,198.977z M192.422,197.617c-0.141,0.188-0.219,0.297-0.453,0.234\r\n\t\tc0.016-0.125,0.047-0.25,0.047-0.406C192.156,197.508,192.297,197.57,192.422,197.617z M194.672,184.203\r\n\t\tc0.281-0.336,0.938-0.477,1.312-0.461c-0.375,0.391-0.766,0.531-1.219,0.859C194.734,184.477,194.703,184.328,194.672,184.203z\r\n\t\t M195.703,192.508c-0.078,0.062-0.125-1.758,0.188-1.562c0.188-0.188,0.422-0.297,0.594-0.547\r\n\t\tC196.969,190.781,196,192.352,195.703,192.508z M196.297,196.523c-0.406,0.453-0.391,0.281-0.531,0.172\r\n\t\tC195.891,196.523,196.203,196.477,196.297,196.523z M196.797,187.789c-0.359-0.336-1.688,0.398-1.734-0.477\r\n\t\tc-0.094-1.078,1.312-0.109,1.438-0.016c0.234-0.219,0.547-0.172,0.828-0.297c-0.219-0.031-0.656-0.195-0.625-0.188\r\n\t\tc0.062-0.102,0.125-0.211,0.188-0.312c-0.219,0.195-0.172,0.039-0.156-0.133c-1.5,0.258,0.047-0.555-0.312-1.008\r\n\t\tc-0.219,0.219-0.781,1.086-1.094,0.734c0.109-0.094,0.25-0.211,0.344-0.336c-0.188-0.188-0.188-0.117-0.188-0.062\r\n\t\tc0-0.047-0.016-0.078-0.094-0.211c-0.062,0.117-0.375,0.016-0.469-0.031c0.422-0.398,0.062-0.492,1-0.367\r\n\t\tc-0.062-0.125-0.281-0.18-0.438-0.211c0.062-0.086,0.125-0.18,0.188-0.273c0.203,0.109,0.25,0.203,0.469,0.25\r\n\t\tc0.031-0.031,0.516-0.484,0.578-0.562c-0.328,0.344,0.297,0.133,0.453,0.234c-0.062,0.102-0.125,0.188-0.172,0.281\r\n\t\tc0.109-0.117,0.688,2.109,1.172,2.523c0.594-0.641,0.938-1.547,1.594-2.055c0.062,0.055-0.5,1.297-0.156,1.672\r\n\t\tc-0.281,0.289-0.266,0.32-0.562,0.547c-0.031-0.086,0.203,0.297,0.219,0.492c0.266-0.258,0.469-0.43,0.688-0.719\r\n\t\tc0.438,0.438-0.938,1.672-1.328,1.828C198.578,188.875,197.703,187.789,196.797,187.789z M202.438,186.047\r\n\t\tc-0.188,0.312-0.266,0.562-0.578,0.758C201.953,186.484,202.172,185.852,202.438,186.047z M201.359,188.734\r\n\t\tc0.094,0.102,0.188,0.188,0.281,0.266c-0.469,0.445-0.906,0.945-1.531,0.367c0.25-0.172,0.875-0.07,0.531-0.414\r\n\t\tc-0.312-0.32,0.312-0.164,0.531-0.141c-0.438-0.516-0.344-1.117,0.625-0.531C201.531,188.531,201.578,188.586,201.359,188.734z\r\n\t\t M201.766,188.023c-0.094-0.055-0.438-0.023-0.656-0.164c0.188-0.109,0.375-0.219,0.578-0.344\r\n\t\tC201.734,187.672,201.672,187.773,201.766,188.023z M200.703,183.289c0.188-0.148,0.344-0.398,0.531-0.148\r\n\t\tC201.609,182.789,202.156,184.453,200.703,183.289z M200.266,183.32c-0.016-0.523-0.281-0.555-0.406-0.875\r\n\t\tC200.734,182.359,201.344,182.906,200.266,183.32z M199.062,182.117c0.578,0.32,0.359,0.781-0.391,0.727\r\n\t\tC198.797,182.75,198.859,182.383,199.062,182.117z M199.859,183.594c0.656-0.102,0.703,0.18,1.094,0.609\r\n\t\tc-0.25-0.008-0.594,0.078-0.844,0.07c-0.188,0.812-0.641,0.711-1.25,0.477C197.984,184.383,199.297,182.688,199.859,183.594z\r\n\t\t M193.922,181.977c0.719-0.922,1.062-0.031,1.875-0.844c0.219,0.234,2.188,0.555,2.25,0.594c1.219,0.266,0.016,1.164-0.531,1.547\r\n\t\tc-0.047-0.203-0.062-0.398-0.094-0.578c-0.406,0.484-0.812,0.641-1.391,0.656c0.312-0.398,0.266-0.477,0.812-0.805\r\n\t\tc-0.297-0.273-1.109,0.195-1.484,0.562c0.047-0.125,0.125-0.391,0.062-0.43c-0.266,0.328-0.469,0.727-0.906,0.422\r\n\t\tc0.188-0.203,0.297-0.492,0.438-0.711c-0.406,0.422-0.688,0.438-1.125-0.086C193.875,182.25,194.016,182.055,193.922,181.977z\r\n\t\t M191.344,183.883c0.422-0.109,1.016,0.156,1.266,0.477c0.594-0.438,0.625,1.562,0.594,1.578c0-0.023,0.75,0.781,0.672,0.734\r\n\t\tc0.031,0.297-0.172,0.469-0.109,0.719c0.203,0.781-1.031-0.125-1.312,0.094c-0.406-0.32-1.109,0.352-1.312,0.031\r\n\t\tc-1.5,0.5-0.656,0.906-1.781,0.188c-0.453,0.508-1.422,0.219-0.922-0.344C188.578,186.516,190.672,184.047,191.344,183.883z\r\n\t\t M170.25,178.727c0.016-0.039-0.047-0.297,0.297-0.445c0.125,0.414,0,1.008-0.266,1.555c0-0.258-0.391,0.258-0.344,0.203\r\n\t\tC169.953,180.086,170.234,178.844,170.25,178.727z M167.594,183.414c0.078,0.32,0.156,0.391,0.328,0.164\r\n\t\tc-0.156,0.5-0.359,0.5-0.469,0.727C167.344,183.891,167.453,183.766,167.594,183.414z M162.984,190.219\r\n\t\tc0.438-0.391,0.344,0.039,0.297,0.398c-0.047-0.133-0.547-0.141-0.625-0.156C162.766,190.383,162.875,190.297,162.984,190.219z\r\n\t\t M161.766,190.344c0.156,0.172,0.234,0.234-0.375,0.438C161.562,190.773,161.578,190.594,161.766,190.344z M159,187.445\r\n\t\tc-0.297,0.281,0.109-0.344,0.156-0.438C159.109,187.164,159.047,187.305,159,187.445z M160.109,188.961\r\n\t\tc0-0.227-0.156,0.227-0.234,0.031C159.922,188.938,160.406,188.656,160.109,188.961z M174.328,327.594\r\n\t\tc0.141,0.188,0.344,0.406,0.344,0.656c-0.031-0.062-0.094-0.156-0.141-0.25c0.047,0.125,0.016,0.156-0.078,0\r\n\t\tc0.062,0.125,0.094,0.219,0.156,0.281c-0.219-0.156-0.266-0.188-0.172-0.031C174.25,328.188,173.859,327.406,174.328,327.594z\r\n\t\t M178.859,333.562c-0.125-0.438-0.406-0.625-0.719-0.781c0.188,0.281,0.312,0.281,0.438,0.594\r\n\t\tc-0.344-0.375-0.469-0.375-0.344-0.062c-0.25-0.188-0.5-0.438-0.688-0.656c0.125,0.094,0.125,0.094,0.062-0.031\r\n\t\tc0.125,0.125,0.281,0.188,0.469,0.188c-0.188-0.062-0.703-0.531-0.422-0.312c-0.203-0.156-0.578-0.531-0.828-0.656\r\n\t\tc0.25,0.156-0.234-0.219-0.344-0.375c0.125,0.062,0.312,0.156,0.469,0.219c-0.016-0.062-0.125-0.188-0.234-0.312\r\n\t\tc0.109,0.094,0.203,0.125,0.078-0.188c0.234,0.125,0.453,0.656,0.484,0.781c0.078,0,0.078-0.062,0.031-0.125\r\n\t\tc0.156,0.062,0.344,0.406,0.516,0.469c-0.344-0.375-0.5-0.688-0.75-1.031c0.156,0.156,0.234,0.062,0.375,0.188\r\n\t\tc-0.109-0.5-0.578-0.469-0.688-0.906c0.625,0.219,1.281,0.594,1.188,0.969c0.656,0.5,1.719,1.938,2.125,2.438\r\n\t\tC179.453,333.625,179.312,333.281,178.859,333.562z M180.516,334.094c0.094,0,0.109-0.062,0.062-0.125\r\n\t\tc0.188,0.125,0.344,0.438,0.391,0.469C180.797,334.344,180.547,334.312,180.516,334.094z M181.781,333.156\r\n\t\tc0.109,0.062,0.203,0.062,0.281,0c-0.047-0.156-0.172-0.156-0.078-0.406c0.141,0.25,0.344,0.438,0.641,0.5\r\n\t\tc-0.141,0.094-0.203,0.031-0.312,0.219C182.266,333.312,181.953,333.344,181.781,333.156z M183.219,334.125\r\n\t\tc-0.297-0.062-0.609-0.156-0.672-0.469c0.125,0,0.234,0,0.344-0.031c-0.031-0.062-0.094-0.156-0.141-0.25\r\n\t\tc0.328,0.125,0.453,0.156,0.672,0.469c0-0.25,0.453,0.281,0.234,0.219c-0.359-0.188-0.172,0.125-0.625-0.281\r\n\t\tC183.078,333.906,183.141,334.031,183.219,334.125z M185.797,320.469c0.375,0.094,0.453,0.188,0.234,0.25\r\n\t\tC185.812,320.562,185.797,320.906,185.797,320.469z M200.062,242.125c-0.234-0.156-0.328-0.031-0.328,0.344\r\n\t\tc-1.047-0.5,0.344-0.688,0.391-0.875c0.078,0.219,0.203,0.281,0.109,0.469C199.672,241.594,200.156,242.031,200.062,242.125z\r\n\t\t M200.031,240.812c-0.203,0.375-0.766,0.719-1.109,1.406c-0.875-0.5,0.906-1.5,1-1.875c0.156,0.156,0.438,0.25,0.609,0.375\r\n\t\tC200.484,241.094,200.297,241.125,200.031,240.812z M199.234,235.438c0.453,0.438,0.781,0.969,0.938,1.5\r\n\t\tc-0.094,0.219,0.281,0.375,0.094,0.781C199.672,237.469,199.016,235.938,199.234,235.438z M203.609,242.469\r\n\t\tc0.062-0.156,0.094-0.312,0.094-0.5C204.141,242.281,203.766,242.156,203.609,242.469z M206.266,242.469\r\n\t\tc0.094,0.062-0.188,1.031-0.906,1c0.266-0.469,0.062-0.281,0.156-0.688c-0.188,0.156-0.281,0.438-0.453,0.344\r\n\t\tc0.297-0.562,0.266-0.562,0.453-1.031c-0.266-0.156-0.719,0.25-0.75,0.281c-0.219-0.062-0.375,0-0.656,0.031\r\n\t\tc0.359-0.219,0.562-0.438,0.906-0.594c-0.188-0.125-0.375-0.031-0.625,0c0.125-0.219-1.812-1.781-2.719-1.562\r\n\t\tc0.094-0.156-0.047-0.312-0.031-0.562c0.375,0.219,0.688-0.312,0.969-0.375c-0.438-0.281-0.375-0.188-0.234-0.531\r\n\t\tc0.422,0.281,0.078,0.125,0.297,0.375c0-0.125,0-0.25,0.016-0.375c0.109,0.125,0.172,0.094,0.188-0.094\r\n\t\tc0.109,0.156,0.203,0.25,0.328,0.375c0.188-0.938,1.406-2.875,2.609-2.219c-0.344,0.562-1.312,1.312-1.688,1.844\r\n\t\tc0.078,0.031,1.422-0.312,0.438,0.406c0.297,0.188,0.234,0.438,0.469,0.656c0.219-0.406,0.203,0.031,0.719-0.156\r\n\t\tc-0.047,0.125-0.109,0.188-0.266,0.219c0.531,0.312,0.547-0.344,0.688,0.188c0.047,0.25-0.281,0.688-0.531,0.469\r\n\t\tc0.031,0.438,0.281,0.5,0.031,0.906c0.344-0.031,0.469,0.031,0.812-0.062c-0.266,0.5-1.312,1-0.562,1.312\r\n\t\tc0.281-0.312,0.422-0.312,0.672-0.531C206.484,242.219,206.375,242.344,206.266,242.469z M206.453,235.156\r\n\t\tc0.766,0.781-2.719,1.188-2.375,0.719c-0.75,0.188-1.641,1.5-2.5,0.375c-0.062,0.156-1.469-0.5-2.188-1.125\r\n\t\tc0.281-0.594-2.75-0.719-3.156,0.125c-0.531-0.438-0.906,0.531-1.406,0.062c-0.125,0.188-0.062,0.281,0.156,0.312\r\n\t\tc-0.438,0.281-0.875,0.562-1.094,1c1-0.812,5.531-2.188,4.938,0.25c-0.062-0.094-0.125-0.188-0.172-0.312\r\n\t\tc-0.141,0.312-0.125,0.469-0.234,0.812c-0.062-0.062-0.25-0.156-0.359-0.219c-0.328,0.781-0.672,0.438-0.672-0.188\r\n\t\tc-0.062,0.156-0.188,0.188-0.344,0.125c-0.125,0.344,0,0.281-0.094,0.5c0.25,0.188,0.531,0.344,0.859,0.406\r\n\t\tc-0.047,0.125-0.297,0.656-0.344,0.688c-0.078-0.094-0.172-0.094-0.297,0c0.125,0.062,0.234,0.156,0.344,0.219\r\n\t\tc-0.219,0.594-0.906,1.188,0.125,1.375c-0.047,0.125-0.094,0.25-0.156,0.344c-0.406-0.312-0.125-0.094-0.344,0.125\r\n\t\tc0.578,0.281,0.453,1.125,1.562,0.594c-0.062,0.281-0.156,0.688-0.203,0.781c-0.125-0.062-1.922,0.469-1.891,0.375\r\n\t\tc-0.031-0.125-0.062-0.281-0.109-0.406c-0.266,0.406-0.672,0.531-1.328,0.875c0.062-0.125,0.125-0.312,0.125-0.312\r\n\t\tc-0.172-0.188-0.203,0.094-0.375,0.156c-0.906-1.562,1.344-2.188,1.656-1.281c0.281-0.375,0.625-0.031,0.781-0.281\r\n\t\tc-0.344-0.094-0.703-0.281-1.031-0.406c0.125-0.312,0.25-0.625,0.531-0.469c0.062-0.25-0.094-0.281-0.25-0.5\r\n\t\tc-0.281,0.281-0.688,0.469-0.953,0.75c0.109-0.156,0.109-0.25,0.219-0.469c-0.156-0.156-0.859,0.031-0.359,0.375\r\n\t\tc-0.469-0.188-0.297,0.156-0.812-0.531c-0.188,0.875-0.578,0.531-0.781,1.031c-0.078-0.156-0.156-0.344-0.219-0.5\r\n\t\tc-0.062,0.094-0.094,0.188-0.141,0.281c-0.203-0.156-0.047-0.219-0.094-0.469c-0.297,0.75-0.875,0.531-1.109,0.094\r\n\t\tc-0.672,0.625-1.688,1.031-1.125,2.094c-0.281-0.156-0.281-0.062-0.531-0.125c0.078-0.281,0.281-0.25-0.109-0.438\r\n\t\tc-0.078,0.156-0.141,0.156-0.203,0.406c-0.719-0.469-1.422-0.594-2.031-0.156c-0.047,0.125-1.078,2.531-1.594,0.844\r\n\t\tc-0.125,0.719-0.5,1.406-0.656,1.812c-1.75-0.531,0.344-1.688,0.562-2.281c-0.109-0.062-0.406,0.094-0.812-0.188\r\n\t\tc-0.094,0.312-0.656,1.5-0.906,1.312c0.125,0.625,0.125,0.719,0,1.375c-0.938-0.688,0,0.688,0,0.75\r\n\t\tc-0.125,0.406-0.594,0.25-0.719,0.625c0.281,0.219,0.219,0.562,0.344,0.625c-0.125,0.031-0.266,0.094-0.391,0.125\r\n\t\tc0.203-0.219-0.125-0.469-0.328-0.625c-0.062,0.281,0.031,0.375,0.062,0.625c-0.344-0.125-0.016,0.25-0.406-0.094\r\n\t\tc-0.094,0.812-1.219,1.156-1.781,0.656c-0.172,0.281-3.719,1.688-2.703,2.688c-0.359,1.031-0.109,1.875-0.453,2.688\r\n\t\tc-0.391,1.062-0.625,1.656-0.984,2.719c-0.672-0.406-0.422-3.25,0.016-3.594c-0.25-0.219-0.219-0.062-0.438,0.062\r\n\t\tc0.656-1.625,0.156-1.594,0.188-3.094c-0.906,0.375-1.219-1.406-1.5-1.906c-0.094,0.312-0.266,0-0.406,0.281\r\n\t\tc-0.281-0.188,0.156-0.5-0.156-0.656c-0.062,0.25-1.156-0.344-1.328-0.5c0.531,0.594,0.359,1.094,0.141,1.688\r\n\t\tc-0.125-0.062-0.312-1-0.422-1.312c-0.125,0.312-0.234,0.281-0.328,0.531c-0.594-0.438-0.391-0.312-0.25-0.812\r\n\t\tc-0.328-0.219-0.688-0.125-0.406-0.656c-0.344-0.031-0.688-0.312-0.922-0.75c-0.172,0.562-0.641-0.156-0.703-0.219\r\n\t\tc-0.125,0.344-5.172,0.281-5.422,0.594c0.094-0.125-5.656-0.062-5.656-0.219c0,0.156,0,0.281,0,0.406\r\n\t\tc0-0.844,2.562,4.375,1.938,5.469c-0.406,0.656,1.516,2.75,2.266,3.312c0.094,0.656,1.047,2,1.578,2.531\r\n\t\tc0.656,0.562,2.109,0.125,2.234,0.938c-0.047,0.125,1.875-1.062,1.734-1.156c0.734-0.594,0.828-1.062,1.891-0.625\r\n\t\tc1.469,0.625-0.781,2.75-0.828,3.875c-0.125-0.094-0.203-0.5-0.141-0.656c-0.328,0.375-0.344,1.094-0.516,1.625\r\n\t\tc-0.031-0.031-0.656,0.781-0.781,0.875c1.219,0.562,3.5,1.875,3.031,3.938c-0.406-0.344-1.25,2.594-1.25,3.312\r\n\t\tc0,0.656,0.609,2.531,0.688,2.312c0.203,0.5,1.234,1.062,1.391,0.469c0.844,0.656,0.656,2.875,1.375,3.219\r\n\t\tc0.125-0.438,0.484-1.188,0.906-0.906c0.062-0.438,0.406-1.75,1.047-0.875c0.797-0.906,3.688-0.031,1.75,0.438\r\n\t\tc0.516,0.344-0.297,1.531-0.266,1.844c0,0.5,0.672,0.719,0.625,0.312c-0.078-0.438-0.062-1.219,0.062-1.688\r\n\t\tc0.312,0.125,0.781,0.125,1.062,0.312c0.031-0.062-0.047-0.906-0.031-0.906c0.891,2.688,2.531,4.312,4.859,4.625\r\n\t\tc-0.125,0.281,0.078,0.438-0.484,0.031c0.047,0.688,0.25,0.844,0.719,1.312c0.062-0.312,0.328,0.188,0.125,0.562\r\n\t\tc-0.141,0.688-0.609-0.031-1.25,0.281c0.984,0.344,1.469,0.219,2.094,1.062c-0.016,0.219,0.328,0.594,0.359,0.906\r\n\t\tc0.078,0.75-0.297,0.562-0.438,1.25c0.172,0.031,0.391-0.25,0.219,0.281c0.094-0.219,0.203-0.438,0.297-0.656\r\n\t\tc0.375,0.344,0.938,0.781,0.797,1.625c-0.094-0.031,1.297,0.062,1.266,0.188c1.75,1.531,2.828,4.531,2.625,6.656\r\n\t\tc-0.156-0.031-0.297-0.062-0.438-0.094c0.219,0.312,0.078,0.312,0.031,0.562c0.141,0.031,0.344,0.031,0.438,0.062\r\n\t\tc-0.156,0.469-0.25,0.344-0.344,0.906c-0.766-0.375-0.297-0.312-0.281-0.75c-0.281-0.094-1.234,0.438-0.734,0.688\r\n\t\tc-0.484-0.094-1,1-0.453,1.469c0.312-1.219,0.734-0.812,0.844,0.156c-0.531-1.469,1.344-1.812,1.125-1.156\r\n\t\tc1,0.656,0.281,1.719-0.844,1.156c-0.031,0.156,0.625,0.562,0.75,0.688c0.062-0.312,0.406-0.281,0.609-0.125\r\n\t\tc0.031-0.25-0.141-0.188-0.203-0.438c1.156-0.531,2.219,1.031,2.031,1.656c0.031,0.031,0.453,0.031,0.594,0\r\n\t\tc-0.125,0.406-0.031,1.531,0.406,1.781c0.062-0.156,0.156-0.344,0.234-0.5c0.422,0.219,0.625,0.781,1.016,0.938\r\n\t\tc-0.031-0.062-0.094-0.125-0.125-0.219c1,0.562,3.484,2.531,3.25,4.062c2.031-0.031,1.219,3.281,1.156,4.062\r\n\t\tc-0.547,0.969-2.188,1.312-3.062,2.375c-0.156-0.156-0.266-0.312-0.406-0.469c-0.094,0.5-0.469,0.812-0.719,1.062\r\n\t\tc0.703,0.5-0.281,2.5-0.312,3.031c0.203,0.062-2.219,2.719-2.062,3.312c-0.484,0.375-1.219,0-1.25,0.125\r\n\t\tc-0.484-0.219-1.094-0.25-1.297-0.406c0.016,0.125,0.062,0.281,0.094,0.406c-0.797-0.312-0.562-0.031-1.188-0.312\r\n\t\tc-0.016,0.188-1.266,0.469-1.719,0.188c-0.031,0.344-0.141,2.844-0.297,2.781c0-0.062-1.469,1.625-1.406,1.656\r\n\t\tc0-0.438,0.719-0.531-0.109-1.156c-0.391,0.625-1.469,1.531-1.469,2.094c-0.016,0-1.094,0-1.516-0.312\r\n\t\tc-0.859-0.406-1.469-1.438-1.469-2.438c-0.344,1-0.062,1.562,0.516,2.375c0.812,1.156,0.109,1.344,0.109,2.25\r\n\t\tc-0.172-0.156-0.328-0.094-0.328,0.031c-0.359-0.312-2.109-0.75-2.156-0.75c-0.141-0.125-0.25-0.375-0.453-0.469\r\n\t\tc0.109,0.781,0.188,0.875,0.266,1.688c-0.234,0.125-0.344-0.375-0.297,0.156c-0.188-0.219-0.25-0.25-0.219-0.062\r\n\t\tc-0.312-0.344-0.625-0.688-0.938-0.938c-0.094,0.125-0.094,0.188-0.047,0.375c-0.062-0.094-0.141-0.125-0.234-0.031\r\n\t\tc0.375,0.375,0.469,0.719,0.875,1.219c-0.078-0.5,0.344,0.156,0.344,0.438c-0.266-0.125-0.609-0.281-0.844-0.562\r\n\t\tc0,0.062,0.281,0.25,0.438,0.406c-0.562-0.031-0.625,0.312-0.375,0.938c-0.391-0.156-0.172,0.219-0.125,0.375\r\n\t\tc-2.047-1.188,0.016,2-0.031,2.062c0.094,0.062,0.312,0.219,0.344,0.281c-0.484,0.031-0.688,0.125-1.016,0.438\r\n\t\tc0.25,0.188,0.203,0.25,0.297,0.531c-0.281-0.188-0.359-0.156-0.641-0.469c0.016,0.188,0.062,0.344,0.234,0.562\r\n\t\tc-0.188-0.094-0.125-0.031-0.281-0.094c0.141,0.312,0.094,0.406-0.109,0.281c0.062,0.062,0.578,0.656,0.188,0.5\r\n\t\tc0.25,0.281-8.328,0.438-8.141,0.719c-0.172-0.125-9.203-0.25-9.203-0.406c0,0.094,0,0.156,0,0.25c0-0.125,8.219-0.281,7.969-0.375\r\n\t\tc0.125,0.594,4.344,0.125,4.469,0.719c-0.25-0.219,1.594-0.438,1.391-0.75c0.125,0.312,1.047,0.281,1.359,0.438\r\n\t\tc-0.062,0.062,0.422,0.062,0.375-0.031c0.062,0.156,0.469,0.25,0.562,0.406c-0.516-0.219-0.672-0.719-0.703-1.156\r\n\t\tc0.047,0.156,0.188,0.219,0.281,0.125c-0.375-0.188-0.453-0.688-0.562-1c0.188,0.094,0.234,0.219,0.422,0.281\r\n\t\tc-0.125-0.406-0.328-0.406-0.656-0.625c0.047,0.219,0.203,0.5,0.281,0.688c-0.172-0.062-0.266-0.281-0.422-0.344\r\n\t\tc0,0.062,0.047,0.125,0.094,0.188c-0.25-0.312-0.5-0.688-0.688-1.031c0.312,0.156,0.5,0.281,0.734,0.5\r\n\t\tc-0.062-0.094-0.141-0.219-0.234-0.312c0.094,0.094,0.219,0.188,0.297,0.312c-0.109-0.219-0.078-0.25,0.047-0.156\r\n\t\tc-0.062-0.25-0.203-0.344-0.328-0.625c0.094,0.062,0.172,0.094,0.266,0.125c-0.125-0.125-0.438-0.688-0.266-0.438\r\n\t\tc-0.016-0.031-0.703-1.031-0.172-0.781c0-0.062,0.016-0.156,0.031-0.219c-0.078-0.062-0.156-0.094-0.219-0.156\r\n\t\tc0.062,0.312,0.031,0.25-0.062,0.156c-0.031-0.031-0.062-0.062-0.094-0.062c0.031,0.125,0.062,0.281,0.094,0.438\r\n\t\tc-0.109-0.156-0.125-0.156-0.062,0.031c-0.125-0.062-0.25-0.188-0.312-0.219c0.266,0.125,0.125,0.344,0.109,0.469\r\n\t\tc-0.297-0.75-0.438-1.281-0.547-2c0.031,0.312,0.062,0,0.062-0.125c0.438,0.281,0.594,1,0.75,1.469\r\n\t\tc-0.062-0.469-0.219-0.906-0.312-1.375c0.062,0.062,0.125,0.125,0.203,0.188c-0.172-0.969-0.859-0.938-1.016-1.906\r\n\t\tc0.156,0.062,0.281,0.094,0.406,0.156c-0.031-0.125-0.109-0.125-0.141-0.25c0.578,0.438-0.078-0.188,0.281,0.094\r\n\t\tc-0.094-0.156-0.172-0.312-0.266-0.469c0.078,0.094,0.188,0.062,0.156-0.062c0.125,0.125,0.562,0.625,0.062,0.312\r\n\t\tc0.062,0.156,0.266,0.312,0.359,0.5c-0.297-0.156-0.234-0.062-0.516,0.031c0.188,0.188,0.5,0.375,0.719,0.469\r\n\t\tc-0.125-0.562-0.469-1.656-0.094-1.438c-0.203-0.281-0.156-0.25,0.125-0.281c-0.156-0.312-0.156-0.594-0.234-0.875\r\n\t\tc-0.047-0.5,0.141-0.938-0.453-1.188c-0.312-1.188,0-1.375-0.219-2.406c0-1.406,0.438-2.438,0.375-3.562\r\n\t\tc0.188-1.25,0.281-3.188,0.281-4.719c0.156-1.312,1-4.156,0.766-5.656c-0.422-2.438,0.031-3.062-1.328-4.938\r\n\t\tc-0.656-0.625-1.969-2.469-1.812-3.406c-0.281-0.25-0.172-3.844-0.688-4c0.219-1.375-0.625-4-1.422-5.188\r\n\t\tc-0.859-1.188,1.031-2.969,0.953-3.031c-0.031,0.156-0.141,0.156-0.281,0.25c-0.125-0.25-0.266-0.5-0.391-0.75\r\n\t\tc0.422,0.344,0.188-1.75,0.719-1.219c0.172-0.688,0.297-1.062,0.484-1.812c0.469,0.25,0.625-0.531,1.078-0.188\r\n\t\tc-0.328-1.125,0.578-0.344,0.703-0.844c0.172,0.188,0.531-1.219,0.625-1.594c0.156-0.781,0.312-0.875,0.5-1.656\r\n\t\tc0.016-0.062-0.938-2.312-0.031-1.562c0.062-0.25-0.531-1.125-0.656-1.719c-0.094,0.344-0.703,0.406-0.891,0.312\r\n\t\tc0.141,0.281,0.078,0.5,0.188,0.781c-0.203,0.031-0.172-0.094-0.297,0.156c-0.312-0.219-1.375-2.156-1.5-2.656\r\n\t\tc0.031,0.312-0.031,0.406-0.188,0.219c-0.016-0.125-0.031-0.25-0.031-0.375c0.344,0.156-0.344-1.656-0.438-1.906\r\n\t\tc-0.312,1.25-0.406-0.438-0.125-0.594c0-1.469-0.172-3.281-0.844-3.969c-1.672-1.812-1.25-3.906-2.734-5.812\r\n\t\tc-0.156,0.375-0.719-0.688-0.844-0.125c-1.031-1.719-2.016-3.531-2.906-5.469c-0.953-2.031,0.25-4,0.266-6.062\r\n\t\tc0.031-4.375-0.594-8.125,0.406-12.469c-0.156-0.094-0.312-0.125-0.375,0.062c-0.062-0.188-0.156-0.562-0.281-0.719\r\n\t\tc-0.969,1.5-0.547,4.125-0.75,5.906c0.328,0.594-0.531,4.625-0.75,5.312c-0.516-0.625,0.359-3.094-0.016-3.656\r\n\t\tc0.422-1.25-0.078-2.406-0.203-3.719c0.891,1.031,0.688-2.062,0.703-2.781c0.016-1.031,0.234-2.531,0.703-3.281\r\n\t\tc-0.234-0.281-0.562-2.938-0.547-3c0.203-0.344,0.422-3.031,0.672-2.75c0.125-0.25,0.062-0.875,0.062-1.25\r\n\t\tc0.109,0.125,0.078,0.25,0.156,0.375c0.172-0.281,0.312-1.406,0-0.625c-0.812-1,1.531-4.75,2.016-5.656\r\n\t\tc1.547-2.656,2.109-3.875,3.422-6.375c0.219,0.812,0.531,0.812,0.594,1.25c0.016-0.031,0.031-0.031,0.031-0.062\r\n\t\tc-0.094,0.094-0.109,0.188,0,0.25c0-0.062-0.031-0.125-0.031-0.188c-0.125,0.219-0.344,0.438-0.156,0.656\r\n\t\tc0.641-1.094,0.594-1.969,1.047-2.969c-0.547,0.062-0.359-0.906-0.062-1.5c-0.859,0-0.266-0.75-0.891-1.062\r\n\t\tc0.031,0.688,0.328,1.312,0.422,1.938c-0.281,0.406-0.062,1.875-0.203,2.562c-1.125-0.938,0.109-2.094-0.719-2.719\r\n\t\tc0.469-0.656-0.375-1.094,0.312-2.031c0.062,0.094,0.125,0.156,0.188,0.25c0.406-0.625,1.484-1.656,0.781-2.188\r\n\t\tc0.156-0.188,0.219-0.438,0.438-0.656c0.016,0.094,0.031,0.188,0.031,0.281c0.25-0.406,0.141-0.375,0.391-0.719\r\n\t\tc0.047,0.031-0.188,0-0.297-0.062c-0.094,0.156-0.141,0.188-0.281,0.281c0.109-0.188,0.688-1.594,0.641-1.625\r\n\t\tc-0.047-0.062,0.859-0.688,0.922-0.781c-0.141,0.062-0.375,0.219-0.531,0.281c-0.094-0.125,0.062-0.594,0.141-0.844\r\n\t\tc0.391,0.562,0.297-0.188,0.406-0.438c-0.047,0.125-0.078,0.219-0.109,0.344c-0.062-0.094-0.141-0.125-0.25-0.094\r\n\t\tc0.125-0.625,0.25-0.906,0.688-1.562c-0.5,0.781,0.406-1.062-0.156-0.219c0.062,0.094,1.172-3.289,1.406-3.742\r\n\t\tc-0.188,0.219-0.375,0.484-0.562,0.719c-0.062-0.062-0.234-0.5-0.281-0.609c0.062-0.078,0.031,2.109-0.469,1.438\r\n\t\tc-0.156,0.516-0.531,1.328-0.328,1.602c0.172-0.352,0.359-0.398,0.516-0.555c-0.469,0.523-0.219,0.805-0.906,1.055\r\n\t\tc-0.031-0.031,0.234-0.688,0.312-0.852c-0.109,0.164-0.188,0.195-0.312,0.289c0.141-0.711,0.438-1.352,0.844-1.852\r\n\t\tc-0.062,0.062-0.156,0.109-0.234,0.172c0.188-0.531,1.016-3.344,0.953-3.422c-0.047,0.094-0.094,0.203-0.156,0.297\r\n\t\tc0.016-0.594-0.062-0.703,0.297-1.156c-0.984-0.766-0.453-2.266-1.016-3.062c0.312-0.312,0.125-0.727,0.344-0.898\r\n\t\tc0.156,0.227,0.156-0.102,0.344-0.289c-0.047-0.18-0.281-0.156-0.375-0.031c-0.156-0.32,0.094-0.117-0.156-0.555\r\n\t\tc-0.438,0.57-0.391,0.859-0.969,1.305c0.016-0.336,0.031-0.477-0.031-0.711c-0.125,0.109-0.25,0.211-0.359,0.297\r\n\t\tc-0.047-0.07-0.047-0.133,0.078-0.18c-0.359,0.156-0.469,0.172-0.938,0.422c0-0.086,0.016-0.18,0.031-0.273\r\n\t\tc-0.188,0.188-0.141,0.07-0.281-0.156c0.688-0.414,1.188-1.406,2.031-1.547c0.156,0.32-0.156,0.117,0.125,0.547\r\n\t\tc0.25-0.273,0.281-0.422,0.5-0.586c-0.031-0.102-0.25-0.023-0.391-0.117c0.156-0.164,0.016-0.133,0.172-0.32\r\n\t\tc-0.594,0.133-1.281,0.336-1.625,0.742c-0.062-0.219,0.031-0.18,0-0.352c-0.406,0.484-2.219,1.742-2.312,1.5\r\n\t\tc-0.672,0.844-1.859,0.234-2.5,0.969c0-0.078,0.016-0.164,0.031-0.25c-0.25,0.102-0.688,0.125-0.781,0.234\r\n\t\tc0-0.094,0.031-0.188,0.031-0.289c-0.25,0.352-0.016-0.391-0.062-0.477c-0.125,0.273-0.453,0.367-0.766,0.641\r\n\t\tc-0.031-0.07-0.109-0.336-0.125-0.359c0.375-0.289,0.578-0.117,0.953-0.539c0.031,0.195,0.188,0.492,0.25,0.641\r\n\t\tc0.625-0.664,0.875-0.195,1.672-0.656c0.375-0.508,1.141-1.039,1.734-1.312c-0.062-0.164-0.344-0.148-0.531-0.195\r\n\t\tc0.078-0.125,0.172-0.25,0.281-0.375c-0.156-0.188-0.406,0.18-0.5,0.289c-0.047-0.242,0.297-0.977,0.406-1.227\r\n\t\tc-0.203,0-0.594-0.039-0.75-0.023c0.031-0.055,1.438-1.602,1.281-2.023c-0.188,0.203-0.281,0.227-0.438,0.391\r\n\t\tc-0.203-0.461,0.156-1.016,0.562-1.305c0.125-0.156,0.312-0.148,0.438-0.305c-0.297-0.938,0.281-1.445,1.375-1.961\r\n\t\tc-0.047,0.117-0.156,0.367-0.141,0.438c0.234-0.43,0.547-0.656,0.859-0.93c-0.094,0.219-0.188,0.648-0.141,0.836\r\n\t\tc0.953,0.391,1.469-0.391,1.938-1.273c-0.109,0.078-0.266-0.086-0.609-0.031c0.156-0.227,0.188-0.516,0.312-0.727\r\n\t\tc-0.281,0.305-0.25-0.531-0.531-0.273c0-0.297,0.516-1.695,0.594-1.25c0.359-0.312,0.219-0.492,0.062-0.766\r\n\t\tc0.406-0.43,0.594-0.008,0.828-0.188c-0.125,0.109-0.125,0.234-0.016,0.367c0.578-0.562,0.453,0.016,0.781-0.258\r\n\t\tc0.266,0.719-0.922,0.891-0.203,1.891c0.188-0.25,0.047-0.5,0.234-0.633c0.062,0.055,0.141,0.109,0.219,0.172\r\n\t\tc-0.156,0.062-0.172,0.188-0.031,0.328c0.25-0.234,0.594-1.406,0.609-1.57c-0.109-0.141-0.203-0.133-0.297,0.016\r\n\t\tc-0.172-0.531,1.062-2.586,1.562-2.898c0.328,0.891,0.719,0.469,0.875,0.703c0.719-0.922,2.062-0.523,2.25-0.688\r\n\t\tc0.031,0.188-0.312,0.414,0.188,0.008c0.047,0.102,0.469,0.945,0.812,0.414c0.188,0.562,0,0.555-0.344,1\r\n\t\tc0.156-0.008,0.453-0.086,0.5,0.008c-0.281,0.234-0.219,0.227-0.266,0.531c0.344-0.289,0.078,0.336,0.359,0.047\r\n\t\tc-0.047,0.289,0.156,1.352-0.062,1.523c0.5,0.18,1.031,1.945,0.953,2.906c0.141-0.062,0.297-0.117,0.453-0.188\r\n\t\tc0.047,0.195,0.406,1.977,0.312,2.227c-0.062,0.195-0.312,2.578-0.25,2.625c0.281-0.289,0.344-0.555,0.438-0.969\r\n\t\tc0.281,0.352-0.125,0.75,0.5,0.109c-0.016,0.094-0.031,0.18-0.031,0.266c0.188-0.195,0.422-0.312,0.609-0.516\r\n\t\tc0.047,0.109-0.141,0.594-0.234,0.734c0.562-0.125,0.984-0.133,1.219,0.305c0.219-0.133,0.438-0.273,0.656-0.414\r\n\t\tc0.562,0.977-0.25,0.484-0.625,0.992c0.469,0.562,1.562-0.359,2.094-0.672c-0.188,0.656-1.094,3.062-0.75,3.547\r\n\t\tc0.359-0.469,0.719-0.508,1.078-0.938c-0.203,0.266-0.406,0.664-0.766,1.094c0.188,0.289,0.625,0.008,0.75-0.133\r\n\t\tc0.656,0.75,0.062,3.219,1,3.938c0.031-0.125,0.062-0.25,0.078-0.375c0.359,0.375,0.578,1.031,0.141,1.5\r\n\t\tc-0.375-0.344-1.344,0.031-0.844,0.531c-0.172,0.125,0.453,0.5,0.625,0.625c-0.031-0.031,0.719,0.594,1.094,0.219\r\n\t\tc0.531,0.531,0,1.219-0.406,1.594c0.094,0.125,0.188,0.156,0.281,0.125c-0.156,0.297-0.281,0.594-0.344,0.938\r\n\t\tc0.609-0.344,0.641-1.109,1.297-1.422c0.078,0.078,1.422,0.141,1.609-0.016c-0.062-0.125-0.031-0.219-0.109-0.344\r\n\t\tc-0.406,0.406-0.781-0.141-1-0.281c-0.109,0.141-0.203,0.281-0.297,0.406c-0.031-0.047,0.031-0.609-0.219-0.219\r\n\t\tc0.312-0.531,0.922-0.844,1.25-0.391c0.578-0.734,0.469,1.453,0.422,1.766c0.141-0.031,0.234-0.094,0.297-0.219\r\n\t\tc-0.156,0.312-0.094,0.344-0.344,0.578c0.062,0.047,0.438,0.141,0.531,0.047c-0.016,0.469,0.219,1.219,0.266,1.523\r\n\t\tc0.703-0.18,1.219,0.625,1.672,1c0.219-0.5,0.562-0.688,0.797-1c-0.047,0.406,0.062,0.562-0.078,1\r\n\t\tc0.281,0.219,0.156,0.062,0.438-0.062c-0.062,0.188-0.188,0.281-0.375,0.312c0.062,0.094,0.156,0.094,0.25,0.031\r\n\t\tc-0.531,0.781-0.406,1.156-0.734,1.906c0.25-0.031,0.297,0.188,0.453-0.062c-0.594-0.469,0.5-1.031,0.719-1.281\r\n\t\tc0.234,0.031,1.344,0.219,1.734-0.281c-0.156-0.125-0.359-0.125-0.547-0.219c0.219-0.344,0.562-0.594,0.875-0.75\r\n\t\tc0.094,0.094-0.031,0.312,0.25,0.406c0.25-0.344,0.375-0.281,0.594-0.562c-0.281-0.406-0.828-0.156-0.75-1.211\r\n\t\tc-0.141,0.172-0.266,0.328-0.391,0.5c-0.094-0.172,0.109-0.312-0.25-0.188c0.812-0.562,0.172-0.875,0.641-1.359\r\n\t\tc0.219-0.266,0.906-0.609,1.266-1.047c0.047,0.156,0.094,0.344,0.141,0.5c0.656-1.031,1.625-2.422,2.5-3.344\r\n\t\tc0.016,0.094,0.031,0.188,0.062,0.25c0.516-0.391,0.281-0.438,0.719-0.016c0.156-0.094,0.312-0.156,0.469-0.25\r\n\t\tc0.391,0.359,0.531,0.703,0.438,1.172c0.328,0.172,0.453,0.375,0.844,0.656c-0.531,0.281-1.188,1-1.781,0.656\r\n\t\tc-0.734,0.016-1.531-1.156-1.453,0.078c-0.453,0.047-0.922,0.203-1.047,0.391c0.281,0.219,0.469,2.406,0.344,2.742\r\n\t\tc-0.047-0.094,0.141,0.125,0.156,0.156c-0.438,0.312-0.312,0-0.516-0.219c-0.109,0.094-0.25,0.188-0.375,0.281\r\n\t\tc0.109,0.031,0.234,0.062,0.359,0.094c-0.266,0.406-0.906,0.25-1.016,0.469c-0.109,0.312,0.234,0.719,0.109,0.875\r\n\t\tc0.5,0.406-0.25,1.531-0.625,2c0.625,0.438,1.188-1.094,2.141-1c-0.125,0.219-0.609,1.938-1.25,1.5\r\n\t\tc-0.484,0.719-0.172,1.031-0.578,1.969c0.297,0.219,0.062,0.062,0.391,0.281c1.172-0.812,3.547-1.562,3.422-3.281\r\n\t\tc0.656,0.531,1.125,0.938,1.125,1.625c-0.078-0.062-0.375,0.344,0.297,0.625c-0.297,0.219-0.391,0.562-0.953,0.688\r\n\t\tc0.094,0.094,0.219,0.156,0.312,0.219c-0.312,0.375-0.688,0.594-0.938,1.125c-0.172,0.375,0.219,0.562-0.266,1.219\r\n\t\tc-0.141-0.188-1.938-0.312-2.203,0.188c-0.031-0.438-0.25-0.5-0.031-1.031c-0.078-0.062-0.344-0.125-0.484-0.156\r\n\t\tc0.094,0.062,0.219,1.031,0.125,1.125c-0.547-0.438-0.5-0.75-1.156-1.281c-0.219,0.281-0.547,0.812-0.828,1.188\r\n\t\tc-0.234-0.125-0.938-1.594-0.969-1.719c-0.234,0.281-0.234,0.312-0.359,0.531c-0.141-0.156-0.297-0.25-0.484-0.375\r\n\t\tc-0.125,0.188,1.188,1.406,1.531,1.562c-0.422,0.625-1.312,0.406-1.594,0.844c0-0.25-0.281-0.719-0.219-0.781\r\n\t\tc-0.344-0.188-0.953,0.281-1.188,0.719c-0.062-0.125-0.125-0.25-0.203-0.375c-0.203,0.469-0.562,1.656-1.109,0.594\r\n\t\tc-0.203,0.25-0.203,0.438-0.531,0.156c0.109,0.062,0.125,0.156,0.094,0.281c-0.531-0.438-2.031,0.844-2.656,0.781\r\n\t\tc-0.266,0.438-0.625,0.625-1.172,1.125c0.234,0.188-0.172,0.906-0.25,1.219c1.172,0.344,0.391,2-0.125,2.781\r\n\t\tc2.156-0.094,1.031,3.344,1.797,3.844c0.406,1.469,3,2.781,1.156,4.25c-0.531,0.406-0.953,1.938-0.812,2.625\r\n\t\tc0.281,1.281,1.719,1.531,1.875,0.312c0.047-0.375,0.844-2.812,1.312-2.781c0.75,0.062,2.031-0.969,2.5-0.688\r\n\t\tc0.062-0.156,0.094-0.312,0.141-0.469c-0.047,0.281-0.125,0.344-0.266,0.188c0.594-0.781,1.219-2.312,0.922-3.281\r\n\t\tc-0.484-1.594,0.922-0.844,1.578-1.656c-0.5-0.25,0.219-0.938,0.469-1.062c-0.609-0.375,0.625-0.938,0.719-0.906\r\n\t\tc0.578-0.781,0.094,9.641,1.156,10.5c0.984,0.672,2.688,13.031,1.828,13.031c0.109,0,0.203,0,0.297,0\r\n\t\tc-0.375,0,0.078-9.969,0.641-9.672c-0.047,0.188-0.156-5.141-0.312-5.297c-0.391,0.562,0.297-2.125,0.578-1.922\r\n\t\tc-0.609,0.406-1.516-0.422-1.562,0.359c0.344,0.156,0.641,0.625,0.344,1.078c0.172,0,0.344-0.578,0.5-0.391\r\n\t\tc-0.156,0.203-0.094,0.297-0.125,0.547c0.484-0.188,0.812-0.328,1.125-0.156c0.312-0.547,1.672-1.922,2.109-1.625\r\n\t\tc-0.781,1.156-0.266,1.922-0.547,2.891c-0.188-0.109-0.312-0.016-0.5,0.047c0.438,0.25,0.625,1.484-0.094,1.828\r\n\t\tc0.219,0.156,0.531,0.781,0.312,1.125c-0.281-0.312-0.031,0.031-0.688-0.406c0.062-0.062-0.156,0.562-0.188,0.625\r\n\t\tc0.094,0.125,0.188,0.125,0.312,0c-0.406,0.75,0.688,2,0.422,2.719c0.109,0.125,0.234-0.094,0.391-0.188\r\n\t\tc-0.125,0.281,0.062,0.219,0.25,0.188c-0.594,1.281,0.781,0.469,0.484,1.406c-0.578-0.344-1.656,0.312-2.531-0.156\r\n\t\tc-0.031,1.281,3.141-0.438,2.547,1.656c0.188,0.125,0.203-0.031,0.375-0.156C206.406,234.938,206.891,234.312,206.453,235.156z\r\n\t\t M197.875,239.125c-0.391,0.844-0.016,1.031,0.75,1.406c-0.281-0.156-0.016,0.188-0.016,0.344\r\n\t\tc-0.156,0.031-0.312,0.062-0.484,0.094c0.141-0.312-0.078-0.188,0.203-0.438C197.75,240.25,196.828,239.625,197.875,239.125z\r\n\t\t M189.781,242.719c-0.266,0.562-0.953-0.031-1.25-0.219C188.703,242.031,189.516,242.594,189.781,242.719z M176,274.844\r\n\t\tc0,0.188,0,0.344,0,0.562C176,275.219,176,274.688,176,274.844z M185.406,279.125c-0.141-0.594-0.734,1.688-0.141-0.594\r\n\t\tC185.484,278.625,186,279.281,185.406,279.125z M184.844,269.25c-0.672-0.062-0.875,0-0.953-0.781\r\n\t\tc0.422,0.188,0.594,0.156,0.922,0.375C184.75,269.125,184.875,269,184.844,269.25z M177.609,262.531\r\n\t\tc1.031-0.688-0.906-2.438-0.938-3.438c-0.094-1.844-2.062-1.125-2.562-1.812c0.656-0.562,1.781-0.812,2.125,0.406\r\n\t\tc0.141,0,0.219-0.094,0.219-0.219c0.969,1.156,1.5,2.406,2.062,3.656c0.094,0.219,0.562,1.219,0.844,1.594\r\n\t\tC180.609,264.344,178.297,262.812,177.609,262.531z M177.797,265.062c-0.531-0.344-0.438-0.281-0.922-0.656\r\n\t\tc-0.172-0.281-0.375-0.656-0.266-0.906C177.109,263.594,178.172,264.406,177.797,265.062z M175.469,258.281\r\n\t\tc-0.281,0.219-0.219,0.469-0.656,0.25c0.078-0.25,0.281-0.375,0.375-0.688C175.266,258,175.359,258.125,175.469,258.281z\r\n\t\t M178.484,257.406c0.203,0.062,0.734-0.25,0.406,0.5C178.75,257.719,178.625,257.562,178.484,257.406z M180.328,266.219\r\n\t\tc0.297-0.531,0.25-1.031,0.125-1.75c1.078,0.594,2.594,1.938,2.625,3.281c-0.75-0.438-1.062-0.375-1.719-1.031\r\n\t\tc-0.156,0.469-0.188,0.125-0.422,0.438c0.016,0-0.828-0.938-1.125-1.094c-0.469-0.344-0.828-0.375-0.578-0.938\r\n\t\tC179.797,265.438,180.188,265.688,180.328,266.219z M173.828,321.75c-0.156-0.125-0.172-0.062-0.094,0.125\r\n\t\tc-0.094-0.094-0.125-0.062-0.078,0.031c-0.484-0.188-0.281-0.812-0.406-1.406c0.031,0.031,0.266,0.406,0.203,0.125\r\n\t\tc0.25,0.156,0.203,0.125,0.25,0.469C173.422,320.969,173.734,321.562,173.828,321.75z M166.781,192.102\r\n\t\tc-0.141-0.5,0.016-0.688,0.266-1.141c0.188,0.172,0.188,0.172,0.266,0.234c-0.094-0.125,0.016-0.281,0.156-0.297\r\n\t\tc0.078,0.078-0.016,0.234,0.047,0.406c0.25-0.281,0,0.078,0.234-0.172c-0.016,0.25-0.047,0.719-0.297,0.969\r\n\t\tC167.344,191.945,167.016,191.836,166.781,192.102z M167.953,190.883c0.156-0.133,0.312-0.273,0.469-0.422\r\n\t\tc0.109,0.156,0.062,0.289-0.125,0.391c0.031,0.125-0.094,0.219-0.188,0.312C168.125,190.664,168.094,191.227,167.953,190.883z\r\n\t\t M168.438,205.938c0.125-0.5,0.25-1.281,0.234-1.438c0.266-0.406,0.312-0.812,0.594-1.188c0.188,0.125,0.281,0.281,0.422,0.531\r\n\t\tc-0.734,0.562-0.625,1.312-0.938,1.781C168.562,205.281,168.578,205.781,168.438,205.938z M171.297,201.156\r\n\t\tc0.031,0.031-0.75,1.938-0.906,2.125c-0.141-0.312,0.016-0.281,0.125-0.625c-0.156-0.062,0.25-0.938,0.344-1.094\r\n\t\tc-0.141-0.312-0.031-0.406,0.25-0.906c-0.047,0.375,0,0.594-0.047,0.938C171.203,201.469,171.266,201.344,171.297,201.156z\r\n\t\t M172.094,198.914c-0.234,0.328-0.203,0.531-0.609,0.484c0.328-0.422,0.578-0.859,0.719-1.359\r\n\t\tC172.625,198.57,171.953,198.664,172.094,198.914z M201.766,202.406c-0.094,0.281,0,0.469,0,0.812\r\n\t\tc-0.109,0.188-0.234,0.188-0.391-0.094C201.484,202.844,201.641,202.656,201.766,202.406z M200.406,214.781\r\n\t\tc-0.141,0.188-0.172,0.031-0.203-0.125C200.594,214.375,200.266,214.719,200.406,214.781z M195.984,211.781\r\n\t\tc0.156-0.219,0.312-0.438,0.438-0.656c-0.312-0.156-0.312-0.062-0.562-0.219c0.25-0.688,0.641-0.031,1.031-0.438\r\n\t\tc0.328-0.594,0.578-1.188,1.188-1.75c0.188,0.156-0.094,0.219,0.188,0.344c-0.422,0.125-0.219,0.125-0.469,0.469\r\n\t\tc1.031-0.031,0.734,1.719,0.312,2.438c0.094,0.094,1.094-0.281,0.562,0.406c-0.094-0.062-0.281,0.188-0.531,0.188\r\n\t\tc0.062-0.156-0.344-0.531-0.453-0.688c-0.297-0.406,0.297-0.625,0.453-0.875C197.109,210.688,197.078,212.031,195.984,211.781z\r\n\t\t M197.578,212.969c-0.406,0.375-1.219,0.438-1.719,0.156C196.016,212.719,197.031,213.062,197.578,212.969z M198.281,208.844\r\n\t\tc0.188-0.25-0.109-0.375,0.266-0.188C198.547,208.938,198.516,209.062,198.281,208.844z M198.859,214.875\r\n\t\tc-0.25,0.344-0.297,0.562-0.625,0.75C197.797,215.281,198.672,214.969,198.859,214.875z M194.609,221.781\r\n\t\tc0.5,0.406-0.219,0.625-0.375,0.906C193.859,222.5,193.984,222.188,194.609,221.781z M191.203,225.906\r\n\t\tc-0.219,0.25-0.5-0.344-0.562-0.625C191.141,225.219,190.984,225.562,191.203,225.906z M207.672,220.062\r\n\t\tc0.297-0.5,0.984-0.562,0.625,0C208.047,220.062,207.922,220.281,207.672,220.062z M213.016,215.906\r\n\t\tc-0.516,0.312-0.406,0.094-0.719,0.688c-0.438-0.219,0.125-0.281-0.391-0.594c-0.156,0.312-0.344,0.281-0.609,0.75\r\n\t\tc-0.047-0.094-0.094-0.188-0.125-0.281c-0.188,0.406,0.094,0.312-0.125,0.719c-0.25-0.406-0.219-0.062-0.375-0.625\r\n\t\tc-0.25,0.438-0.156,1.438-0.781,1.031c0.125-0.188-0.188-0.438-0.375-0.594c0.125-0.25,0.156-0.062,0.375-0.125\r\n\t\tc-0.125-0.125-0.266-0.219-0.422-0.312c0.109-0.094,0.234-0.219,0.359-0.312c-0.531-0.188,0.078-0.031-0.562-0.344\r\n\t\tc0.141-0.219,0.359-0.125,0.594-0.188c-0.375-0.344-1.172-0.5-0.578-1.5c-0.375,0.094,0.078-0.031-0.328-0.219\r\n\t\tc-0.094,0.281-0.031,0.312-0.234,0.625c-0.297-0.125,0.219-0.438-0.047-0.625c-0.375,0.562-0.031,0.5-0.297,0.969\r\n\t\tc-0.25-0.188-0.047-0.312-0.359-0.406c-0.422,0.531,0.25,2.312,0.375,3.062c0.031-0.156,0.094-0.312,0.125-0.469\r\n\t\tc0.078,0.031,0.156,0.094,0.219,0.125c-0.031,0.219-0.344,0.562-0.125,0.688c-0.078,0.094-0.172,0.156-0.25,0.219\r\n\t\tc-0.062-0.062-0.094-0.188-0.125-0.281c-0.312,0.375,0,0.812-0.594,0.438c-0.062,0.125,0.125,0.688,0.031,0.969\r\n\t\tc-0.078-0.062-0.406-1.906-0.828-1.094c-0.141-0.25-0.234-0.5-0.328-0.781c-0.344,0.469-0.344-0.188-0.734-0.469\r\n\t\tc-0.656,1.375,1.25,2.438,0.641,3.469c-0.656-0.406-0.531-0.719-1.312-1.406c-0.641-0.562-1.438-0.531-1.938-1.25\r\n\t\tc0.156-0.156,0.438-0.094,0.688-0.125c-0.109-0.062-0.156-0.312-0.156-0.469c-0.062,0.312-0.188,0.375-0.375,0.125\r\n\t\tc0.297-0.5,0.125-0.156-0.125-0.281c0.375-0.688,0-0.75,0.438-1.438c-0.25-0.219-0.5-0.25-0.625-0.25\r\n\t\tc0.047-0.156,0.125-0.156,0.219-0.062c-0.031-0.188-0.094-0.406-0.062-0.594c-0.031,0.125-0.031,0.219-0.062,0.344\r\n\t\tc-0.406-0.219,0.125-0.562-0.188-0.688c-0.156,0.531-1,0.844-0.656,0.344c-0.656,0.344-1,0.094-1.484-0.219\r\n\t\tc0.172-0.281,0.609-1.188,0.953-1.75c0.375,0.625,1.031,0.75,1.344,0.906c0.141-0.125,0.172-0.094,0.375-0.094\r\n\t\tc-0.109,0.25,0.812,0.438,1.062,0.688c0.25-0.688,0.281-1.312,0.234-1.969c0.594,0.406,0.938-0.469,1.562-0.125\r\n\t\tc-0.016-0.781,0.172-0.688,0.453-0.688c0.094-0.094,0.188-0.125,0.281-0.219c-0.188-0.156,0.375-2.375,0.781-2.562\r\n\t\tc-0.375-0.25-0.812,0.062-1.344,0.062c0.266-0.375-0.031-0.531,0.547-1c0.031,0.094,0.078,0.188,0.109,0.281\r\n\t\tc0.188-0.344-0.391-1.281,0.453-0.875c0.172-0.312-0.312-0.125-0.141-0.469c-0.188,0.062-0.359,0.156-0.562,0.219\r\n\t\tc0.328-0.562,0.125-0.031,0.375-0.375c-0.312-0.188,0-0.344-0.297-0.562c-0.281,0.25-0.031-0.156-0.406,0.312\r\n\t\tc0.125-0.281,0.234-0.625,0.391-0.938c-0.312-0.188-0.281,0.094-0.406-0.062c0.094-0.188,0.188-0.406,0.297-0.594\r\n\t\tc-0.266-0.031-0.531-0.031-0.703,0.125c0.141,0.031,0.266,0.062,0.391,0.062c-0.578,1.031-1.109-0.312-1.359-0.75\r\n\t\tc-0.203,0.375-0.406,0.875-0.531,1.406c-0.109-0.062-0.141-1.562-0.219-1.938c0.047,0.281,0.094,0.906-0.094,1.125\r\n\t\tc-0.578-0.438-1.453-1.25-1.531-1.938c-0.031,0.125-0.062,0.25-0.094,0.375c-0.406-0.438-0.25-0.875-0.344-1.5\r\n\t\tc-0.156,0.188-0.344,0.125-0.562-0.031c0.062-0.344,0.078-0.719,0.484-0.969c-0.141-0.773-0.172-3.227,1-2.555\r\n\t\tc0.234-0.156,1.422-0.75,1.422-0.719c0.688-0.031,2.359,0.656,2.281,1.469c0.469,0.031,0.906,0.266,1.188,0.891\r\n\t\tc-0.156,0.109-0.281,0.266-0.406,0.383c0.812-0.164,2.656-0.148,2.312,0.156c0.078,0.219,0.016,1.188,0.016,1.188\r\n\t\tc-0.828,0.875-2.594,0.25-2.609-1.031c-0.469,0.562-0.938,1.156-1.344,1.594c0.656,0.656,0.438-0.031,0.562-0.156\r\n\t\tc0.344-0.156,0.5-0.219,0.875-0.219c0,0.344-0.125,0.312-0.188,0.469c0.156,0,0.312-0.031,0.453-0.031\r\n\t\tc-0.141,0.188-0.344,0.688-0.547,0.938c0.25-0.25,0.469-0.375,0.75-0.812c0.312,0.219,0.344,0.531,0.594,0.781\r\n\t\tc0.25-0.375-0.125-0.562-0.25-0.844c-0.188-0.469,1.156-0.531,0.969,0.156c-0.25,0.844,1.031,0.938,1.422,1.156\r\n\t\tc-0.234,0.375-0.484,0.625-0.578,0.812c0.125,0,0.25,0,0.406,0.031c-0.422,0.656-0.219,0.562-0.875,0.594\r\n\t\tc-0.062,0.312-0.062,0.5-0.062,0.75c0.188-0.125,0.375-0.281,0.562-0.406c0.109,0.062-0.062,0.531-0.156,0.688\r\n\t\tc0.078,0.094,0.141,0.062,0.156-0.094c0,0.156-0.109,0.344,0.031,0.375c0-0.156,0.109-0.531,0.172-0.656\r\n\t\tc0.016,0.031,0.312,0.094,0.5,0.156c-0.047,0.219-0.109,0.438-0.156,0.656c0.109,0.062,0.469,0.156,0.203,0.531\r\n\t\tc0.172,0.094,0.219-0.062,0.406,0.062c-0.297,0.469-0.438,0-0.75,0.438c0.188,0.219,0.531-0.031,0.75-0.062\r\n\t\tc-0.062,0.188-0.281,0.25-0.453,0.281c0.609-0.062,0.891,0.219,0.953,0.812c-0.344-0.188-0.391-0.031-0.719-0.062\r\n\t\tc0.594,0.375-0.141,0.281,0.344,0.562c0.188-0.062,0.25-0.375,0.484-0.281c0.094,0.781-0.422,1.188-0.953,0.781\r\n\t\tc0.062,0.125,0.031,0.25-0.062,0.312c0.531,0.375,0.219,0.312,0.453,0.875c-0.625-0.375-0.391-0.219-0.641-0.594\r\n\t\tc-0.125,0.188-0.094,0.438-0.031,0.75c-1.594-0.156-0.062,0.562-0.438,1.094c0.094,0.094,0.406-0.031-0.062,0.312\r\n\t\tc0.266,0.156,0.062-0.156,0.344,0c-0.375,0.438,0,0.125-0.188,0.469c0.25,0.156,0.094-0.219,0.312,0\r\n\t\tc-0.141,0.156-0.312,0.312-0.469,0.5c0.25,0.125,0.281-0.094,0.516-0.094c-0.172,0.438,0.188-0.094,0.266-0.219\r\n\t\tc0.188,0.125-0.062,0.344-0.125,0.5c0.125,0.062,0.344-0.312,0.625-0.375c-0.109,0.281-0.156,0.375-0.422,0.688\r\n\t\tc0.281,0.125,0.141,0.219,0.391-0.125c-0.062,0.469,0.109,0.438-0.219,0.812c0.141,0.031,0.156,0.094,0.047,0.188\r\n\t\tc0,0.031,0.578,0.5,0.453,0.469c0.078-0.406,0.234-0.5,0.469-0.281c-0.156,0.219-0.375,0.406-0.562,0.625\r\n\t\tc0.188,0.094,0.375-0.156,0.5-0.281c0.297,0.125,0.422,0.094,0.844,0.312C212.703,215.625,212.672,215.812,213.016,215.906z\r\n\t\t M204.078,207.094c0.297-0.5,0.375-0.062,0.406,0.25C204.359,207.281,204.203,207.188,204.078,207.094z M205.922,209.344\r\n\t\tc-0.125,0.281-0.688,0.438-0.953,0.5C204.641,208.5,205.75,209.25,205.922,209.344z M205.297,205.969\r\n\t\tc-0.344-0.156-0.562-0.156-0.578-0.625c0.516,0.344,0.516,0,0.984,0.312C205.562,205.75,205.422,205.875,205.297,205.969z\r\n\t\t M206.703,209.469c0.109-0.125,0.203-0.281,0.312-0.406C207.141,209.188,207.047,209.781,206.703,209.469z M206.516,207.188\r\n\t\tc0.125,0.031,0.25,0.062,0.391,0.062C206.641,207.594,206.641,207.281,206.516,207.188z M211.016,197.18\r\n\t\tc0.156-0.141,0.453-0.047,0.656,0.078C211.172,197.617,211.281,197.273,211.016,197.18z M215.312,195.508\r\n\t\tc-0.297,0.375-0.047,0.5-1.219-0.266c-0.625,0.672-0.453,0.547-1.594,0.047c0.578,1,0.844,1.781-0.516,1.594\r\n\t\tc0.031-0.125,0.062-0.234,0.094-0.344c-0.375,0.188-0.906,0.406-1.234,0.125c0.516-0.641,0.578-0.578,0.141-0.875\r\n\t\tc0.094-0.312-0.031-0.375,0.219-0.641c-0.141-0.109-0.297,0.484-0.688,0.391c-0.328-0.062-0.375-0.219-0.812-0.469\r\n\t\tc0.062-0.219,0.188-0.312,0.391-0.312c-0.172-0.094-0.422-0.188-0.609-0.266c-0.156,0.188-0.031,0.297-0.125,0.484\r\n\t\tc-0.312-0.141-0.375-0.078-0.594,0.188c-0.281-0.156-0.188-1.562-0.656-0.906c0.031-0.188,0-0.344,0.031-0.562\r\n\t\tc-0.656,0.172-0.625,0.219-0.781-0.406c-0.172,0.219-0.141,0.281-0.375,0.125c0.219-0.266,0.188-0.469,0.344-0.75\r\n\t\tc0.312,0.219,0.656-0.219,0.906,0.094c0.188-0.281,0.5,0.156,0.688,0.344c0.344-0.375,0.125-0.891,0.422-1.125\r\n\t\tc1.016,0.828,0.859,1.438,1.453,2.281c0.328-0.375,0.344-0.125,0.75-0.422c-0.141-0.141-0.344-0.141-0.531-0.203\r\n\t\tc0.094-0.062,0.125-0.172,0.125-0.312c-0.094,0.078-0.188,0.125-0.281,0.188c0-0.344,0.344-0.5,0.062-0.75\r\n\t\tc0.281-0.172,0.438-0.156,0.656-0.469c-0.094-0.109-1.547-0.094-1.938-0.5c0.359-0.484,0.406-0.375,0.797-0.781\r\n\t\tc0.359,0.328,0.516,0.156,0.766,0.391c0.094-0.047,0.125-0.094,0.125-0.141c0.469,0.25,1.156,0.906,1.625,1.422\r\n\t\tc0.078-0.078,0.156-0.172,0.219-0.25c-0.312-0.266-0.609-0.719-0.953-0.891c-0.172,0.094,0.812-0.219,0.766-0.219\r\n\t\tc-0.219-0.172-0.188,0.125-0.375,0.094c0.078-0.344,0.078-0.664,0.188-1.039c-0.5,0.539-0.078,0.695-0.719,0.852\r\n\t\tc-0.438,0.312-0.688-0.547-1-0.141c0-0.109,0-0.234,0.031-0.359c-0.203,0.203-1.172,0.469-0.5-0.211\r\n\t\tc-0.625,0.523-1.219,0.109-1.844,0.617c-0.062-0.25-0.156-0.414-0.156-0.742c-0.375,0.461-0.469,0.273-0.984-0.156\r\n\t\tc0.375-0.422,0.828-1.641,1.672-0.906c0.344-0.391-0.844-0.664-1.125-0.898c0.062-0.086,0.094-0.195,0.141-0.305\r\n\t\tc0.266,0.234,0.438,0.578,0.672,0.32c-0.547-0.484-0.531-0.656-0.516-1.211c0.109,0.141,0.375-0.398,0.422-0.492\r\n\t\tc0.156,0.469,0.25,0.633,0.656,0.93c0-0.344-0.766-1.102-0.594-1.281c0.312,0.211,1.188,0.156,1.562-0.195\r\n\t\tc-0.281-0.141-0.359-0.469-0.422-0.555c-0.172,0.164-0.234,0.109-0.438,0.062c0.047-0.102,0.141-0.414,0.203-0.648\r\n\t\tc0.797,0.867,1.062,0.562,0.328-0.359c0.016,0,0.453-0.023,0.453-0.023c-0.109,0.109,1.156,1.438,0.812,2.164\r\n\t\tc-0.281,0.586-0.344,2.117,1.141,1.594c-0.391,0.219,0.141,0.305,0.203,0.375c-0.094,0.289-0.219,0.562-0.594,1.133\r\n\t\tc0.281-0.344,0.688-0.188,1.016-0.648c0.328,0.352,0.953,0.523,1.375,0.812c0.078,0.117-0.078,0.578,0.109,0.688\r\n\t\tc-0.5,0.688,0.062,1.656,0.531,1.188c-0.812-0.562-0.703-1.617,0.375-1.062c0.438,0.188,1.75,1.125,2.094,0.797\r\n\t\tc-0.391-0.188-0.688-0.453-0.875-0.609c0.5,0.406,0.984,0.109,1.531,0.5c-0.125-0.156-0.281-0.344-0.438-0.5\r\n\t\tc0.234-0.25,0.375,0.062,0.656,0.062c-1.312-0.977-2.594-0.906-4-1.852c0.094-0.055,0.188-0.117,0.281-0.188\r\n\t\tc-0.234-0.148-0.531,0.047-0.812,0.219c-0.188,0.148-0.438-0.375-0.688-0.523c0.125-0.117,0.25-0.203,0.375-0.297\r\n\t\tc-0.438-0.477-1.438-0.781-2.047-1.375c0.297,0.008,0.766,0.109,0.922-0.109c-0.156-0.148-0.469-0.125-0.766-0.195\r\n\t\tc0.047-0.109,0.094-0.211,0.141-0.32c0.25,0.32,0.906,0.211,1.281,0.422c-0.344-0.375-0.734-0.539-1.141-0.719\r\n\t\tc0.203,0.039,0.391,0.039,0.594,0.102c-1.312-0.938,1.984,0.125,1.531,0.562c0.109,0.109,0.484,0.75,0.547,1.031\r\n\t\tc0.125-0.164,0.094-0.219,0.188-0.477c0.109,0.016,0.219,0.031,0.344,0.062c-0.094,0.133-0.156,0.273-0.219,0.414\r\n\t\tc0.625-0.633,0.5-0.688-0.469-1.148c0.109-0.18,0.219-0.352,0.328-0.531c0.203,0.344,0.422,0.328,0.641,0.695\r\n\t\tc0.125-0.188,0.203-0.414,0.281-0.609c0.125,0.086,0.797,1.086,0.719,1.133c0.297,0.32-0.266,1.469,0.406,0.68\r\n\t\tc-0.031,0.25-0.062,0.469-0.078,0.711c0.297-0.359,0.422-0.766,0.578-1.133c0.25,0.18,0.812,1.289,0.594,1.562\r\n\t\tc0.125,0.188,0.094-0.125,0.266,0.008c-0.266-0.57-0.391-0.586,0.078-0.883c0.031,0.016,0.125,0.828,0.625,0.047\r\n\t\tc0.391,0.375,0.969,0.742,0.609,1.555c0.266-0.477,0.266-0.477,0.094-1.086c0.984,0.188,2.016,0.523,2.016,1.539\r\n\t\tc0.938-1.25,2.812,0.719,3.547,1.172c-0.766,0.438-1.203,0.109-1.953,0.25c1.281,0.422,1.969-0.062,2.875,0.5\r\n\t\tc0.656,0.312,0.5,1.297,1.281,1.875c-0.422,0.75-2.594,0.266-2.906-0.125c-0.141,0.094-0.141,0.156,0,0.188\r\n\t\tc-0.234-0.047-1-0.156-1.062-0.078c0.484,0.234,1.094,0.375,1.625,0.422c-0.438,0.469-1.688-0.031-1.781,0.188\r\n\t\tc-0.469-0.234-2.188,0.031-2.375-0.156c0.125-0.172-0.062-0.219,0.172-0.438c-0.422,0.375-0.453,0.281-1.125,0.406\r\n\t\tc0.172-0.297-0.234-0.344-0.359-0.438c-0.094,0.141,0.094,0.438,0.156,0.484c-0.375-0.141-0.672-0.078-1.031-0.266\r\n\t\tc-0.188,0.516-0.094,0.266-0.656,0.312c0.219-0.5-0.344-0.375-0.562-0.375c-0.062-0.188-0.125-0.344-0.188-0.516\r\n\t\tc-0.109,0.203-0.156,0.297-0.344,0.125c0.031-0.156,0.062-0.328,0.094-0.484c-0.188,0.125-0.234,0.078-0.156-0.109\r\n\t\tc-0.078,0.078-0.141,0.156-0.219,0.234c-0.094-0.125-0.188-0.25-0.281-0.375c-0.094,0.062-0.188,0.125-0.281,0.188\r\n\t\tc0.938,0.938,1.594,0.891,0.969,1.781c-0.188-0.391-0.516-0.578-0.062-0.969c-0.125,0.031-0.25,0.078-0.375,0.125\r\n\t\tc0.141-0.188-0.375-0.656-0.531-0.75c0.406,0.812,0.156,0.391-0.047,0.75c-0.016,0.047-0.719-0.891-0.891-0.984\r\n\t\tc-0.156,0.266,0.188,0.375,0.375,0.609c-0.406,0.094-0.422-0.031-0.703,0.312c0.047,0.031,0.922,0.125,0.953,0.062\r\n\t\tc0.375,0.281,0.531,0.594,1,0.859c-0.406,0.484-0.375,0.516-0.938,0.109c-0.219,0.188-0.016,0.375-0.125,0.531\r\n\t\tC215.703,195.789,215.5,195.633,215.312,195.508z M207.531,191.602c0.359-0.156,0.438-0.297,0.234-0.422\r\n\t\tc0.203-0.109,0.438-0.172,0.625-0.359C208.5,191.445,208.109,191.898,207.531,191.602z M216.594,197.883\r\n\t\tc-0.172-0.125-0.344,0.203-0.266-0.188C216.672,197.477,216.422,197.758,216.594,197.883z M218.281,229.719\r\n\t\tc0.109-0.156,0.219-0.281,0.016-0.344c-0.156,0.375-0.203,0.281-0.531,0.094c0.094-0.094,0.203-0.156,0.312-0.219\r\n\t\tc-0.156-0.094-0.281-0.156-0.406-0.219c0.375-0.281,0.141-0.062,0.078-0.156c0.141-0.188,0.297-0.312,0.438-0.5\r\n\t\tc-0.547-0.219-1.094,0.469-1.672,0.219c0.156-0.281,0.094,0.094,0.297-0.188c-0.531-0.312-0.266-1.281-0.328-1.469\r\n\t\tc0.094-0.219,0.25-0.188,0.469-0.312c-0.094-0.094-0.219-0.094-0.344,0.031c0.141-0.125,0.125-0.188-0.047-0.219\r\n\t\tc0.125-0.125,0.266-0.25,0.375-0.375c-0.453-0.188-0.484-0.062-0.828,0.125c1.016-1.812,0.312-0.344-0.031-0.562\r\n\t\tc0.188-0.406,0.062-0.312,0.406-0.719c-0.344-0.156-0.266-0.094-0.516,0.094c0.016-0.469,0.109-0.125,0.234-0.406\r\n\t\tc-0.406-0.219-0.062-0.219,0.125-0.531c-0.438-0.188-0.219-0.375-0.281-0.844c0.156,0.062,0.312,0.156,0.438,0.219\r\n\t\tc0.125-0.125,0.062-0.219-0.156-0.281c0.203-0.062,0.656-0.344,0.688-0.375c0.375-0.094-0.281,1.188,0.375-0.156\r\n\t\tc-0.281-0.156-0.719-0.031-1.125,0.125c0.094-0.125,0.609-0.844,0.125-1c0.094-0.219,0.328-0.094,0.391-0.188\r\n\t\tc-0.062-0.156-0.141-0.312-0.203-0.469c0.25,0.094,0.594,0.031,0.719-0.156c-0.219-0.125-0.391-0.188-0.5,0.094\r\n\t\tc-0.156-0.25-0.125-0.219-0.469-0.25c0.266-0.625,0.156-0.062,0.469-0.312c-0.406-0.219-0.25-0.25-0.438-0.594\r\n\t\tc0.141,0,0.281,0.031,0.438,0.031c-0.188-0.094,0.438-0.531,0.516-0.625c-0.406-0.219,0.016-0.562-0.203-0.688\r\n\t\tc0.469-0.062,0.656-0.281,1.188-0.25c-0.484-0.25-0.641,0.031-0.969-0.156c0.359-0.5,0.969-0.438,1.344,0\r\n\t\tc-0.109-0.25-0.312-0.438-0.219-0.688c0.406,0.219,0.625,0.562,1.188,0.844c0.031-0.156,0.094-0.344,0.125-0.5\r\n\t\tc-0.438,0.031-1.656-0.156-1.25-0.656c0.5,0.219,0.641,0.188,1.094,0.281c0.781,0.219,0.25-1.125,1-0.844\r\n\t\tc-0.172,0.156-0.219,0.344-0.156,0.531c0.344-0.312,0.406-0.531,0.594-0.812c-0.141-0.094-0.234-0.031-0.406-0.031\r\n\t\tc0.359-0.562,0.422-0.562,0.844-1c-0.75-0.469-0.969-1.344-1.547-1.594c-0.625,1.062,1.031,1.375-0.422,2\r\n\t\tc-0.625,0.25-1.125-0.062-1.312-0.781c0.344,0.438,0.562,0.469,0.688,0.031c-0.406-0.188,0.062,0.062-0.75-0.406\r\n\t\tc0.312-0.469,0.703-0.969,1.375-1.094c-0.125,0.219,0.031,0.219,0.25,0.344c0.062-0.094,0.156-0.156,0.25-0.219\r\n\t\tc-0.906-0.594-0.125-1.438,0.906-0.156c0.344,0.406,0.281,1,0.797,1.25c0.25-0.25-0.297-0.281-0.094-0.594\r\n\t\tc0.203,0.094,0.266,0.188,0.438,0.031c-0.516-0.281-0.297-0.531,0.156-0.281c0.141-0.281-0.688-0.688,0.25-0.219\r\n\t\tc-0.234-0.219-0.266-0.5-0.578-0.688c0.219-0.312,0.469,0.188,0.672-0.188c-0.297-0.031-0.562-0.156-0.859-0.25\r\n\t\tc0.078-0.031,0.156-0.062,0.203-0.094c-0.141-0.094-0.578-0.469-0.516-0.625l-0.453-0.438c-0.422,0.781-1.562,0.062-0.562-0.5\r\n\t\tc-0.234-0.031-0.266-0.125-0.141-0.25c0.219,0.156,0.531-0.281,0.688-0.375c-0.219-0.062-0.281-0.125-0.125-0.281\r\n\t\tc1.312,0.719,0.781-1.531,1.234-2.406c-0.172-0.062-0.359-0.094-0.531-0.125c0.109-0.094,0.703-0.406,0.953-0.531\r\n\t\tc-0.594-0.812-0.75-5-2.484-4.25c0.109-0.188,0.188-0.375,0.266-0.562c-0.5,0.062-0.906-0.062-1.188-0.344\r\n\t\tc-0.125,0.219-0.281,0.156-0.469,0.281c0.25-0.75-0.031-0.938-0.688-0.656c-0.016-0.188,0.078-0.469-0.125-0.625\r\n\t\tc-0.125,0.219-0.469,0.5-0.625,0.719c-0.719-0.406-1.141-1.312-0.438-1.586c-0.344-0.328-0.406-1.234-0.375-1.219\r\n\t\tc0.156-0.016,0.297-0.047,0.469-0.062c-0.219,0.469,2.391,0.594,2.719,1.523c0.125-0.18,0.312-0.273,0.453-0.43\r\n\t\tc-0.469-0.344-1-0.625-1.547-0.812c0.062-0.156,0.125-0.281,0.188-0.438c-0.625-0.312-0.812,0.422-1.344-0.281\r\n\t\tc0.156-0.188,0.062-0.547-0.078-0.656c0.516-0.984-0.078-1.031,1.25-0.875c1.047,0.609,2.578,0.438,2.859,1.438\r\n\t\tc0.312-0.406,1.688-0.812,2.188-1.281c-0.859-0.406-1.125-0.5-1.812-0.906c0.359-0.875,1.391-0.828,2-0.469\r\n\t\tc0.094,0.062,0.719,0.031,0.766-0.094c0.312,0.25,0.516,0.188,1.062,0.469c0.109,0.031-0.234,0.469,0,0.562\r\n\t\tc0.156-0.312,0.703-1.375,1.406-1.016c-0.078,0.141-0.328,0.953-0.078,1.047c0.031-0.375,0.219-0.562,0.281-0.938\r\n\t\tc0.156,0.125,1.188,0.297,1.234,0.188c0.359,0.25,0.812,0.719,1.156,0.844c0.391-0.531,0.234-0.016,0.375,0.219\r\n\t\tc0.797-0.922,0.828,0.391,0.156,1.344c0.016,0,0.891-0.281,0.953-0.375c0.25,0.438,0.688,0.797,0.938,1.406\r\n\t\tc0.297-0.359,0.312-1.062,0.812-0.797c-0.016-0.516,0.016-0.453,0.422-1.016c1.172,0.922,0.078,2.5,1.016,3.367\r\n\t\tc0.625-0.375,0.984,0,1.125,0.562c0.375-0.562-1.094-2.133-0.562-3.086c0.672,0.312,1.234,0.281,1.25,1.172\r\n\t\tc0.094-0.297,0.172-0.406,0.203-0.766c0.859,0.344,0.641-0.219,1.016-0.719c0.406,0.719,0.312,0.156,1.188,0.609\r\n\t\tc0.266,0.203-0.281,0.891,0.484,0.922c0.156-0.281-0.109-0.031-0.031-0.375c0.453,0.219-0.141,0.125,0.312,0.344\r\n\t\tc0.484-0.25-0.359-0.688,0.75-0.156c-0.297-1,0.594,0.156,1.016-0.547c0.094,0.156,0.219,0.328,0.312,0.5\r\n\t\tc0.281-0.547,4.984,2.477,5.891,2.883c-0.219,0.5-0.859,0.125-1.047,0.531c0.344,0.156,1.25-0.219,1.5,0.062\r\n\t\tc0.578,0.688-0.469,0.75-0.656,1c0.234-0.062,1.047-0.062,1.094-0.031c-0.188,0.375,1.219,0.75,1.391,1.594\r\n\t\tc-1.484,0.562-2.672-0.594-4.219-1.156c-1.891-0.594-2.297-0.781-4.047-0.625c0.562,0.375,1,0.125,1.594,0.125\r\n\t\tc0.984,0.031,1.938,0.656,2.953,1.062c-0.141,0.156-0.281,0.312-0.422,0.5c1.375,0.625,1.469-0.062,2.781,0.5\r\n\t\tc-0.25,0.469-1.75,1.062-1.562,0.688c-0.234,0.094-0.422,0.156-0.625,0.25c0.125,0.031,0.188,0.125,0.219,0.281\r\n\t\tc-0.031,0.094,2.375-0.156,2.75-0.219c-0.125,0.188-0.016,0.281-0.094,0.469c0.156,0.094,0.281,0.094,0.656,0.281\r\n\t\tc0.469-0.969,3.969,0.656,3.859,1.344c-0.641,0.062-1.203,0.281-1.734,0.25c-0.844-0.031-1.641-0.594-2.672-0.469\r\n\t\tc0.891,0.375,1.234,0.5,1.922,0.75c-0.781,1.5-1.953-0.25-2.719-0.125c-0.031,0.094-0.047,0.188-0.219,0.094\r\n\t\tc0-0.031,0.031-0.031,0.031-0.062c-0.125,0.062-0.234,0.25-0.312,0.469c0.531-0.25,1.203-0.125,1.766,0.406\r\n\t\tc-0.266,0.656-1.234,0.719-1.766,0.438c-0.25,0.438,0.344,0.188-0.422,0.719c0.359,0.031-0.812,0.844-1.047,1.094\r\n\t\tc-0.109-0.344-0.625-0.938-0.938-0.25c0.438,0.344,0.844,0.375,1.219,1.031c-0.25-0.062-0.344-0.219-0.641-0.281\r\n\t\tc-0.781,1.25,1.297,0.25,0.5,2.094c-0.5-0.219-1-0.594-1.516-0.938c-0.047,0.219-0.094,0.844-0.641,0.562\r\n\t\tc-0.203,0.344-0.047,0.344,0.141,0.562c0.062-0.156,0.219-0.25,0.406-0.312c0.125,0.406,0.031,0.438-0.031,0.656\r\n\t\tc0.531,0.188-0.094,1.031-0.234,1.438c-0.422-0.156-0.641-0.625-1.125-0.812c-0.047,0.094,0.328,0.688,0.422,0.875\r\n\t\tc-0.25-0.125-0.312,0.188-0.562,0.281c0.172,0.031,0.281-0.031,0.422,0c0,0-0.172,0.562-0.203,0.438\r\n\t\tc2.062,0.781-0.094,0.781-0.719-0.5c-0.312,0.219-0.906,1.219-0.438,1.406c0.594-0.5,0.344-0.25,0.875,0\r\n\t\tc-0.281,0.656-0.875,0.156-1.031,0.625c-0.281-0.156-1.906-0.469-1.328-1.281c-0.422-0.188-1.172,0.5-1.625,0.375\r\n\t\tc0.234,0.156,0.391,0.344,0.641,0.438c-0.016-0.125-0.062-0.25-0.094-0.406c0.562,0.281,1.312-0.062,1.188,0.844\r\n\t\tc0.766,0.312,0.266,0.5,0.203,0.469c0.172,0.125,0.328,0.25,0.516,0.375c-0.234,0.062-0.234,0.219-0.203,0.438\r\n\t\tc-0.281-0.062-0.422-0.281-0.625-0.438c-0.156,0.281,0.312,0.531,0.484,0.75c-0.109,0.062-0.219,0.125-0.344,0.188\r\n\t\tc0.125,0.344,0.312,0.125,0.156,0.562c-1.312-0.438-0.438-2.094-1.125-2.188c0.031-0.188-0.047-0.312-0.219-0.469\r\n\t\tc-0.156,0.375-0.625,11.094-1,11.234c-0.031-0.547-0.312,10.078,0,10.078c-0.141,0-0.281,0-0.406,0\r\n\t\tc0.125,0,0.125-10.047,0.125-10.047c0.438,0.25,2.094-5.297,0.562-4.859c0.562,0.328,1.203-1.188,1.5-1.062\r\n\t\tc-0.094,0.125-0.203-1.125-0.312-0.984c0.188,0.094,0.188-0.766,0.25-0.922c0.5,0.219-0.25,1.438-0.312,1.625\r\n\t\tc-0.391-0.188-1.625-0.969-1.234-1.906c0.016,0-0.422-1.219-0.547-1.406c-0.516-0.219-0.938-0.891-1.453-1.188\r\n\t\tc-0.594,1.109,1.734,0.906,1.359,1.969c-0.625-0.266-1-0.156-1.688-0.734c-0.109,0.281-0.594,0.266-0.812,0.484\r\n\t\tc0.125,0.031,0.156,0.125,0.156,0.25c0.406-0.688,1.312-0.156,2.062,0.219c-0.266,0.656-0.219,0.438-0.781,0.156\r\n\t\tc-0.031,0.031-0.375,0.5-0.406,0.562c0.656,0.438,0.938,0.062,1.469,0.25c0.562,0.312,0.562,0.594,1.469,1\r\n\t\tc-0.203,0.344-0.688,0.344-0.922,0.625c-0.062-0.062-0.109-0.156-0.172-0.219c-0.125,0.344-0.234,0.156-0.375,0.531\r\n\t\tc-0.531-0.625-1.75-0.125-2.344-0.312c-0.281,0.594-1.375,0.281-1.844,0.438c0.094-0.219-1.312-0.688-1.5-0.312\r\n\t\tc-0.094-0.062-0.891-0.125-0.688-0.344c-0.531-0.125-0.312-0.812-0.469-0.906c-0.656,1.344-0.219,0.969-1.312,1.781\r\n\t\tc-0.719,0.531-2.062,0.062-2.469,1.094c-0.344-0.188-0.281-0.688-1.062,0.031c0.469-1-1.156-0.656-1.672-1.188\r\n\t\tc-0.344,0.625-0.188,0.5-0.797,0.344c0.156,1.125-0.281,1.219-0.906,0.969c-0.125,0.219,0.172,0.375,0.344,0.531\r\n\t\tc-0.156,0.312-0.391,0.375-0.594,0.812c-0.125-0.125-0.25-0.25-0.406-0.406c-0.031,0.281-0.031,0.469-0.031,0.719\r\n\t\tc-0.25-0.062-0.344-0.031-0.562-0.094c-0.094,0.062-0.203,0.125-0.281,0.219c0.406,0.188-0.906,1.344-1.094,1.25\r\n\t\tc-0.094,0.25-0.531,1.188-1.062,0.938c-0.062,0.25,0,0.781,0.094,1.125c-0.375-0.125-0.281,0.031-0.656,0.031\r\n\t\tc0-0.5-0.328-0.344,0-0.906c-0.125,0.125-0.25,0.25-0.344,0.375c-0.219-0.062-0.109-0.406-0.031-0.562\r\n\t\tc-0.125,0.062-0.25,0.125-0.375,0.156C218.812,229.75,218.328,229.844,218.281,229.719z M247.688,243.125\r\n\t\tc0.078-0.188,0.328-0.594,0.5-0.531c-0.141,0.406-0.219,0.469-0.422,0.719C248.078,242.5,247.828,243.219,247.688,243.125z\r\n\t\t M245.703,255.344c-0.375,1.25-2.531-0.938-2.875,0.062c-0.312-0.562-0.812-0.594-1.406-0.156c0.25-0.719-1.062-0.281-1.422,0\r\n\t\tc0.125-0.219-0.016-0.312-0.359-0.312c0.219-0.406,1.469-0.406,1.688-1.281c0.234,0.094,0.688,0.312,0.656,0.406\r\n\t\tc1.312,0.531,0.625-0.812,0.438-0.188c-0.469-0.219-0.406-0.188-1.062-0.375c0.125-0.062,0.188-0.156,0.281-0.219\r\n\t\tc-0.406-0.188-0.344,0.031-0.656,0.094c0.219-0.875,0.969-0.562,1.25-1.469c-0.188,0-0.391,0-0.594-0.031\r\n\t\tc0.656-0.438,0.406-0.375,0.562-0.812c-0.031-0.031,0.953,0.156,0.562,0.344c0.516,0.156,0.812-0.438,1.031-0.344\r\n\t\tc0.062-0.188,0.062-0.25,0.219-0.562c-0.719-0.25-0.625-0.375-0.203-0.781c-0.422-0.156-0.844-0.625-1.078-0.062\r\n\t\tc-0.562-0.656,0.266-1.25,0.547-1.906c-0.391-0.094-0.578,0.188-0.797,0.062c0.203-0.562,0.062-0.125-0.281-0.25\r\n\t\tc0.125-0.094,0.234-0.188,0.312-0.25c0.031,0,0.109,0.188,0.203,0.25c0.234-0.344,0-0.188,0.484-0.5\r\n\t\tc-0.531-0.312,0.094-1.562,0.25-2c0.469,0.156,0.891-0.406,1.094-1c0.375,0.156-0.172,0.312,0.156,0.438\r\n\t\tc0.25-0.5,0.125,0,0.594-0.312c-0.031,0.125,0.422,0.062,0.219,0.75c-0.125,0.312-0.953,0.281-1.156,0.969\r\n\t\tc0.656-0.094,1.312,0,1.719,0.438c-0.312,0.844-1.484,0.969-1.094,1.875c-0.25-0.062-0.469,0-0.562,0.156\r\n\t\tc0.594,0.156,1.719,3.219,1.531,3.812c-0.125-0.219-0.094-0.312-0.297-0.438c-0.141,0.438,0.391,0.844,0.141,1.406\r\n\t\tC248.297,254.031,244.141,254.844,245.703,255.344z M237.203,251.969c0.094-0.281,0.156-0.562,0.281-0.781\r\n\t\tc0.125,0.094,0.219,0.188,0.344,0.312c0.203-0.469,0.938-0.844,1.156-1.469c-0.188-0.094-0.625-0.062-1-0.219\r\n\t\tc0.125-0.281,0.703-0.562,0.969-0.5c-0.156-0.375-0.203-0.281-0.062-0.719c0.25,0.125,0.531,0.219,0.781,0.438\r\n\t\tc0.156-0.5,0.25-0.25,0.656-0.438c-0.781-0.312,0.75-1.031,0.562-0.312c0.156-0.031,0.172-0.125,0.25-0.25\r\n\t\tc-0.062,0.375,0.219,0.188-0.094,0.656c1-0.406,0.969,0.594,0.828,1.188c-0.234-0.031-0.516-0.062-0.734-0.094\r\n\t\tc-0.25,0.656-0.688,1.438-0.953,2.25c-0.141-0.062-2.453,0.75-2.078,0.094c-0.25,0.031-0.469,0.062-0.703,0.094\r\n\t\tc0.047-0.156,0.234-0.219,0.391-0.188C237.516,251.906,237.453,251.906,237.203,251.969z M236.609,233.156\r\n\t\tc0.156-0.188-1.344-0.844-1.594-1.188c0.688,0.25,0.312,0,0.906,0.031c-0.031,0-1.188-1.375-1.188-1.375\r\n\t\tc0.391,0.156,1.062,0,1.438,0.094c-0.469-0.281-0.062-0.125-0.234-0.5c0.203,0.062,0.188,0.219,0.312-0.031\r\n\t\tc-0.016-0.062-0.047-0.125-0.078-0.188c-0.422,0.047-0.656-0.062-0.938-0.172c0.25-0.359,0.328-0.297,0.469-0.766\r\n\t\tc0.375,0.219,0.188,0.031,0.484-0.125c0.047,0.594,0.156,0.531,0.297,1c-0.031-0.125-0.062-0.75-0.031-0.906\r\n\t\tc1,0.375,0.5,1.188,0.312,1.75c0.094,0.031,0.156,0.062,0.25,0.094c0.609-1.281,0.125-0.031,0.375-0.188\r\n\t\tc0.781-1.844,0.016-0.344,0.641-0.812c-0.016,0.25-0.109,0.688,0.125,0.781c0.266-0.656,0.406-0.25,0.922-0.5\r\n\t\tc-0.125,0.438-0.031,0.406-0.047,0.875c0.047-0.219,0.078-0.438,0.125-0.688c0.438,0.156,0.891,0.5,1.312,0.531\r\n\t\tc0.641-0.719,0.547,0.469,1.484,0.25c-0.078,0.25-0.719,0.469-0.875,1.062c0.906,0,0.734,0.656,0.531,1.25\r\n\t\tc-0.25-0.094-0.125-0.094-0.328-0.312c-0.266,0.75-1.578,0.469-2.297,0.844c0-0.125,0-0.25,0-0.375\r\n\t\tc-0.125,0.531-0.609-0.062-0.938-0.188c-0.094,0.188-0.281,0.562-0.328,0.75c0-0.125-0.016-0.25-0.016-0.375\r\n\t\tc-0.594,0.25-0.719-0.156-1.344-0.375C236.516,233.375,236.891,233.312,236.609,233.156z M234.797,229.75\r\n\t\tc0.094,0.094,0.156,0.062,0.188-0.094c0.031,0.062,0.078,0.109,0.109,0.156C235,229.766,234.891,229.828,234.797,229.75z\r\n\t\t M236.266,228.812c0.094,0,0.922-0.312,0.641,0.25C236.688,228.969,236.469,228.875,236.266,228.812z M242.578,246.656\r\n\t\tc-0.125,0.344,0.141,0.562-0.406,0.562c-0.031-0.062-0.062-0.125-0.094-0.219C242.578,247.219,241.859,246.406,242.578,246.656z\r\n\t\t M242.688,246.344c0.078-0.219-0.359-1.344,0.25-1.125c-0.078,0.25-0.422,0.375-0.172,0.469\r\n\t\tC242.656,246.062,243.078,245.969,242.688,246.344z M242.453,244.875c0.125-0.312,0.219-0.656,0.312-0.938\r\n\t\tc0.062,0,0.484,0.062,0.797-0.062C243.359,244.438,242.984,244.75,242.453,244.875z M245.406,216.312\r\n\t\tc-0.203,0.406-0.016,0.562,0.344,0.469c-0.203,0.406,0.203-0.125-0.078,0.469C245.016,217.062,244.266,216.531,245.406,216.312z\r\n\t\t M224,214.781c0-0.344,0,0.531,0,0.844C224,215.625,224,214.969,224,214.781z M244.266,217.219\r\n\t\tc-0.156,0.094-0.281,0.188-0.453,0.312c-0.016-0.219-0.031-0.406,0.031-0.656C244.203,217,243.891,217.062,244.266,217.219z\r\n\t\t M242.922,218.031c-0.234-0.125-0.469-0.219-0.75-0.312C242.578,217.031,243.172,217.562,242.922,218.031z M224.188,277.344\r\n\t\tc-0.078,0.312-0.016,0.375-0.375,0.188C223.984,277.25,223.688,277.188,224.188,277.344z M223.578,276.75\r\n\t\tc-0.266,0.125-0.266,0.375-0.594,0.281C223.203,276.406,223.156,276.969,223.578,276.75z M218.703,231.031\r\n\t\tc-0.125,0.188-0.125,0.094-0.312,0C218.609,230.5,218.453,230.875,218.703,231.031z M264.656,334.25\r\n\t\tc-0.109-0.031-0.359-0.344-0.312-0.438c-0.062,0.219-0.391,1.219-0.25,1.25c-0.25,0.219-2.109,2.594-2.203,2.562\r\n\t\tc-0.125,0.812-1.25,1.188-1.438,1.906c-0.266,0.781-1.906,1.25-1.938,1.375c-1.5-0.094-0.969-1.594-1.5-1.719\r\n\t\tc0-0.125,0.078-1.938,0.531-1.812c0.188-0.219,2.531-2.344,1.25-2.344c0.312-2.031,3.25-0.781,3.781-2.062\r\n\t\tc0.031,0.094,0.047,0.188,0.078,0.281c0,0,1.047-0.781,0.594-0.781c0.188,0.031,0.328-0.094,0.797-0.094\r\n\t\tc-0.016-0.344,0.281-0.906,0.781-1.219c0,0.062,0.672,1.625,0.406,1.562c-0.078,0.094-0.156,0.219-0.25,0.344\r\n\t\tC265.438,333.188,265.016,333.875,264.656,334.25z M258.703,324.656c-0.188-0.094-0.125-0.281,0-0.469\r\n\t\tC259.031,324.5,258.703,324.469,258.703,324.656z M296.281,318.406c-2.719,1.781-0.828-3.312-0.234-3.312\r\n\t\tC295.984,316.438,297.188,316.75,296.281,318.406z M322.719,355.406c-0.547,0-1.688,0.875-2.062,1.062\r\n\t\tc0.109-0.125,0.375-1.156,0.438-1.219c0.906-0.844,1.078,0.031,2.25-0.688C323.156,354.875,322.953,355.156,322.719,355.406z\r\n\t\t M323.578,354.25c0.156-0.062,0.203-0.125,0.141-0.25c0.375-0.219,0.25,0.094,0.25,0.094\r\n\t\tC323.859,354.094,323.656,354.25,323.578,354.25z M334.781,339.094c-0.125,0.406,0.047,0.219,0.453,0.125\r\n\t\tc-0.312,0.5,0.141,0.312-0.312,0.906c0.359-0.156,0,0.906-0.141,1.188c0.188-0.281,0.062,0,0.375,0\r\n\t\tc-0.234,0.531-0.094,1.594-0.266,1.781c0.109,0-1.062,1.844-1.062,1.875c-0.391,0.562-0.703,1.094-1.297,1.719\r\n\t\tc-0.312,0.688-1.734,1.25-1.906,1.781c-1.375,0-2.391,2.875-3.438,2.875c-0.594,0.531-0.656,0.844-1.562,1.125\r\n\t\tc0.031-0.031-1.938,1.125-2.188,1.125c0.344-0.344-0.062-0.094-0.156-0.312c0.062-0.031,0.234-0.125,0.281-0.219\r\n\t\tc-0.125,0.062-0.281,0.125-0.406,0.188c0.047-0.156,0.375-0.375,0.469-0.5c-0.75,0-1.266,0.969-2.125,0.969\r\n\t\tc0.062-0.094,0.109-0.156,0.125-0.25c-0.156,0.031-0.156,0.031-0.047-0.094c-0.359,0.062-0.531-0.062-0.828,0\r\n\t\tc-0.031-0.188,0.156-0.469-0.078-0.375c0.312-0.469,0.594-1.094,0.828-1.312c-0.219,0.062-0.438,0.125-0.656,0.156\r\n\t\tc0.281-0.375,0.453-0.688,0.688-1.031c-0.203,0.188-0.656,0.375-1.016,0.594c0.109-0.094,0.234-0.188,0.359-0.25\r\n\t\tc-0.094,0,0.812-0.875,1.031-1.062c-0.641,0.188-1.766,0.781-2.234,1.219c0.047-0.094,0.016-0.188-0.094-0.188\r\n\t\tc0.094-0.469,0.391-0.344,0.016-0.844c0.156-0.125,0.281-0.094,0.406-0.219c-0.109,0.031-0.25,0.031-0.391,0.031\r\n\t\tc0.359-0.5-1.797-0.656-1.875-0.344c-0.547,0-3.344,0.5-3.453,0.875c-0.5,0-1.688,0.656-2.156,0.906\r\n\t\tc-0.859,0.5-2.172-0.344-3,0.719c-0.219-0.281,0-0.062-0.156-0.312c-0.719,0.688-1.094,0.594-2.031,0.594\r\n\t\tc0.234-0.281-0.25-0.281-0.406-0.469c1.484-1.188,1.469-2.375,2.5-4c-0.25,0-0.156-0.188-0.375-0.188\r\n\t\tc0.078-0.219,0.141-1.719,0.344-1.719c0.031,0.469,0.031,0.312,0.125,0.625c0.062-0.031,0-0.344,0-0.625\r\n\t\tc-0.031,0,0.156,0.188,0.312,0.312c0.609-0.672,0.703-2.562,1.625-2.859c1.297-0.078,3.219-1.578,4.453-1.984\r\n\t\tc1.109,0,2.703-1.469,2.969-1.469c0.203-0.406,0.797-1.25,1.344-1.25c-0.141,0.469,0,0.375-0.141,0.719\r\n\t\tc0.344,0,0.625-0.656,0.906-1.031c0,0.031,0.125,0,0.188,0.125c0.281-0.562,0.766-0.719,1-0.719\r\n\t\tc0.406-0.781,0.719-0.531,1.312-1.281c0.062-0.219,1.125-0.125,0.531,1.094c1.125,0,2.359-1.438,2.906-2.562\r\n\t\tc0.078,0,0.797-0.188,0.625,0.062c0.734-0.062,1.5-0.062,0.656-0.906c0.125-0.062,0.219-0.094,0.344-0.156\r\n\t\tc0.094,0.094,0.109,0.156,0.016,0.25c0.062-0.062,0.141-0.094,0.203-0.156c-0.188,0.438,0.172-0.219-0.062,0.375\r\n\t\tc0.156-0.062,0.5-0.312,0.625-0.312c-0.281,0.406,1.578,0.312,2.062-0.031c-0.188,0.438-1.188,1.125-1.312,1.438\r\n\t\tc0.125,0-0.719,1.094-0.828,1.344c0.781,0,1.453,0.844,1.672,1.625c2.453-0.156,2.875-4.531,4.531-5.656\r\n\t\tc0.219,1-0.031,1.438-0.625,2.688c0.203-0.062,0.516-0.031,0.656-0.312c0.219,0.344,0.281,0.406,0.219,0.562\r\n\t\tc-0.469,0.656-0.312,1-0.469,1.531C334.781,337.656,333.656,339.531,334.781,339.094z M307.641,319.75\r\n\t\tc-0.031-0.031,1.734,1.062,1.578,1.062c0.781,0.875,0.531,1.562,1.188,2.562c0-0.219,0.094-0.312,0.266-0.25\r\n\t\tc0.141,0.719,0.203,1.781,0.938,0.938c-0.141,0.281,0.172,0.062-0.141,0.406c0.891,0,0.031,1.25-0.172,1.656\r\n\t\tc0.141-0.062,0.219,0,0.25,0.125c0.078-0.219,0.25,0,0.594,0c-0.422,0.531-0.484,1.156,0.359,1.156\r\n\t\tc-0.359,0.625,0.094,0.25,0.094,0.75c0,0.125-0.906,1.594-0.969,1.75c-0.406-0.156-0.5,0.062-0.922-0.188\r\n\t\tc-0.047,0.25,0.062,0.219,0.141,0.406c-0.703-0.25-1.625-2-1.562-2c-0.031-0.312-0.469-2.812-0.422-2.844\r\n\t\tc-0.422,0-0.391-1.156-0.484-1.156c0.203-0.531-0.281-1.656-0.594-2.125C307.641,321.781,305.812,319,307.641,319.75z\r\n\t\t M313.719,330.656c0.953,0,2.75-0.312,2.516,0.312c0.484,0,0.453-0.125,1.078-0.125c-0.531,0.469-1.016-0.188-1.156,0.625\r\n\t\tc1.156,0,1.203,0.344,0.75,1.156c-0.594,0-1.672-0.562-2.656-0.562c0,0-2.875-0.781-3.031-0.781\r\n\t\tc0.062-0.219,0.141-0.031,0.219-0.25c-0.281,0-0.531,0-0.812,0C311,329.5,313.094,330.062,313.719,330.656z M315.625,325.062\r\n\t\tc0.188-0.562,1.625-1.812,1.438-1.406c0.469-0.188,0.469,0.094,0.719,0c0.594,0,0.453-0.844,0.703-0.844\r\n\t\tc0.641-0.438,1.859-0.281,2.109-1.188c0.078-0.062,1.969-1.406,1.766-1.406c0.641-0.5,1.047-0.938,1.422-1.625\r\n\t\tc0,0.531,0.297,0.125,0.516,0.125c-0.203,0.625,0.141-0.188-0.109,0.875c0.344,0,0.219-0.156,0.172,0.312\r\n\t\tc0.562-0.031,0.25,0.219,0.641,0.219c-0.172,0.5-0.672,0.5-0.906,0.469c0,0.719-1.062,0.688-0.75,1.125\r\n\t\tc-0.609,0.5-0.75,1.938-0.047,2.469c-1.391,0.219-1.141,1.531-1.891,2.094c-0.391,0.281-1.734,1.562-2,1.906\r\n\t\tc-0.609,0-1.125-0.062-1.844-0.062c-0.094,0.156-1.125-0.125-1.094-0.125c-0.766-0.562-0.453-0.531-0.469-1.75\r\n\t\tc-0.156,0.062-0.312,0.125-0.469,0.156c0.094-0.094,0.172-0.188,0.25-0.281C315.453,326.188,315.656,325.281,315.625,325.062z\r\n\t\t M323.094,306.25c0.203,0.531-1.281,1.938-1.781,1.938c0.156-0.312,0.094-0.406-0.219-0.312\r\n\t\tC320.219,306.531,322.906,305.812,323.094,306.25z M328.625,311.719c-0.391,0,0.141-0.156-0.25-0.156\r\n\t\tc0.25-0.25,0.406-0.406,0.469-0.75c-0.188-0.062-0.297-0.031-0.281,0.156c-0.297-0.438-0.281-0.875-0.156-1.531\r\n\t\tc0.109,0.062,0.219,0.125,0.344,0.188c0.625-1.625,0.438-2.719,2.094-2.719c-0.062,0.156-0.078,0.438-0.312,0.656\r\n\t\tc0.469,0-0.156,2-0.906,2c-0.484,1.781-0.688,1.594,0.656,1.594c-0.047,0.094-0.062,0.188-0.078,0.312\r\n\t\tc0.047,0,0.328-0.188,0.328-0.188c0.266,0.625,0.125,1.062-0.031,1.5c-0.125-0.188-0.438-1-0.641-1\r\n\t\tc-0.047,0.125-0.047,0.188-0.172,0.469c-1.062-1.406-0.938,1.094-1.25,1.094c0-0.188,0.078-0.219,0.125-0.438\r\n\t\tc-0.438,0-0.375-0.5-0.469-0.719C329.562,312.188,328.203,312,328.625,311.719z M330.938,324.969\r\n\t\tc0.016-0.125,0.031-0.219-0.156-0.281c0.375,0,0.484-0.062,0.906-0.062C331.562,324.906,331.188,324.906,330.938,324.969z\r\n\t\t M330.469,322.75c0.188-0.219,0.188-0.281-0.016-0.25c0.047-0.125,0.078-0.281,0.141-0.438\r\n\t\tC330.734,322.406,331.156,322.656,330.469,322.75z M331.641,302.188c-0.172,0.344-0.453,0.656-0.734,0.969\r\n\t\tc-0.734-0.562,0.594-3.125,1.531-3.312C332.469,300.656,331.812,301.312,331.641,302.188z M331.438,312.719\r\n\t\tc-0.156,0.469-0.312,1.031-0.078,1.562c-0.234,0-0.078-0.062-0.172-0.25C331.266,313.844,330.031,313.156,331.438,312.719z\r\n\t\t M330.984,315.219c-0.078,0-0.172,0-0.25,0c-0.047-0.344-0.016-0.625-0.016-0.875c-0.234,0.062-0.25-0.031-0.062-0.281\r\n\t\tC331.125,314.281,331.094,314.812,330.984,315.219z M328.438,315.688c0.031-0.25,0.875-0.812,1.125-1.094\r\n\t\tc-0.156,0.812-0.375,1.5-1.125,1.5C328.578,315.938,328.578,315.781,328.438,315.688z M328.344,315.094\r\n\t\tc0.25-0.719,0.234-1.188,1.062-0.969c-0.109,0.406-0.391,0.75-0.406,0.938c-0.156,0.062-0.188,0-0.062-0.125\r\n\t\tC328.719,315,328.531,315.062,328.344,315.094z M329.5,315.188c0.172-0.188,0.531-0.75,0.656-0.812\r\n\t\tc-0.062,0.312-0.484,1.406-0.938,1.406C329.297,315.594,329.406,315.375,329.5,315.188z M329.688,313.719\r\n\t\tc0.172-0.5,0.703-0.156,0.625,0.062C330.109,313.781,329.922,313.75,329.688,313.719z M330.344,315.562\r\n\t\tc-0.25,0.188-0.766,0.438-0.656-0.094C330.062,315.469,330.141,315.125,330.344,315.562z M328.344,317.281\r\n\t\tc-0.078,0.344,2.25-1.156,2.641-1.219c0.109,0.969-0.391,1.938-0.922,2.688c0.047-0.062,0.031,0.219-0.109,0.219\r\n\t\tc0.047-0.125,0.078-0.188,0.078-0.219c-0.219,0.344-0.531,0.656-0.75,0.969c0.094-0.156,0.062-0.219-0.094-0.125\r\n\t\tc0.062-0.219,0.172-0.188,0.219-0.344c-1.391,0.625-0.469-0.781-0.406-1.188c-0.344,0-0.484,0.062-0.938,0.062\r\n\t\tc-0.031-0.094-0.031-0.188-0.031-0.281c-0.25,0.281-0.359,0.531-0.703,0.594C327.531,317.844,327.719,317.438,328.344,317.281z\r\n\t\t M328.969,327.594c0,0-0.562-0.062-0.719-0.062c0.625-0.406,1.031-0.25,1.875-0.156\r\n\t\tC329.969,327.781,329.406,327.594,328.969,327.594z M330.406,323.281c-0.156,0.375-0.312,0.312-0.578,0.562\r\n\t\tc0.641,0,0.422,0.531,0.047,0.531c0.219-0.719-0.656,0.844-0.578,0.719c-0.156-0.156-0.016-0.188-0.297-0.188\r\n\t\tc0.219-0.688,0.438-0.938,0.438-1.531c0.25-0.375,0.5-0.781,0.844-0.875c-0.25,0.656-0.188,0.594-0.594,1.25\r\n\t\tC329.953,323.688,330.125,323.406,330.406,323.281z M327.312,313.562c0.188,0.031,0.25,0.094,0.188,0.25\r\n\t\tC327.312,313.562,327.312,313.906,327.312,313.562z M327.594,323.5c0.156-0.062,0.188-0.156,0.438-0.156\r\n\t\tc-0.5,1.031-3.188,1.625-3.078,1.125c-0.922,0.125-1.391,1.094-0.938,1.656c0.422,0,1.188-0.344,1.781-0.344\r\n\t\tc-0.203,0.188-0.297,0.281-0.562,0.406c0.156,0.031,0.328,0.062,0.5,0.094c-0.078,0.281-0.359,0.281-0.641,0.281\r\n\t\tc0.016-0.125,0.062-0.25,0.141-0.375c-0.359,0-1.109,0.688-1.516,0.719c0.219,0.281,0.5,1.062,0.672,1.062\r\n\t\tc0.047,0.438-0.094,1.438-1.234,1.438c0.297-0.469,0.219-0.938,0.219-1.531c-1.234,0-0.531,2.062-2.047,2.062\r\n\t\tc0.281-0.844,0.516-1.219,0.844-1.719c-0.844,0,0.469-1.5,0.641-2.031c0.219-0.625,0.938-1.688,1.375-1.938\r\n\t\tC324.469,323.656,326.719,324.25,327.594,323.5z M327.359,327.844c-0.109,0.281-0.297-0.125-0.672-0.062\r\n\t\tc0.25-0.469,1.094-0.188,1.297-0.219C327.75,327.656,327.562,327.75,327.359,327.844z M319.188,332.438\r\n\t\tc0.625,0.188-0.469,0.188,0.75,0.188c-0.016,0.125-0.016,0.25-0.031,0.375c-0.781,0-1.281,0.125-1.719,0.188\r\n\t\tC318.656,332.25,318.906,333.25,319.188,332.438z M318.031,332.969c0.125-0.188,0.031-0.219-0.25-0.156\r\n\t\tc0.203-0.156,0.375-0.469,0.656-0.469c-0.094,0.125-0.062,0.156,0.094,0.094C318.406,332.656,318.188,332.75,318.031,332.969z\r\n\t\t M319.594,333.594C321.828,333.844,319.281,334.531,319.594,333.594L319.594,333.594z M320.344,332.844\r\n\t\tc0.281-0.719,1.906-0.312,2.438-0.375c-0.094,0.188-0.109,0.375-0.312,0.375C322.281,333,320.734,332.812,320.344,332.844z\r\n\t\t M325.734,332.25c-0.672,1-3.547,2-4.109,2.094C321.891,333.594,324.656,332.562,325.734,332.25z M323.859,329.938\r\n\t\tc0.438-1.031,0.078-0.094-0.047-0.562c0.281,0,0.625-0.375,0.906-0.594C324.531,329.375,324.359,329.625,323.859,329.938z\r\n\t\t M324.219,317.375c0.172-0.812,1.625-1.562,1.875-2.156c0.438,0,0.453-0.812,0.766-0.812\r\n\t\tC326.75,315.25,325.219,317.375,324.219,317.375z M317.75,332.375c-0.141,0.125-0.391,0.375-0.578,0.375\r\n\t\tc0.109-0.188,0.328-0.375,0.016-0.375C317.391,332.219,317.328,331.969,317.75,332.375z M312.781,328.031\r\n\t\tc0.062-0.188-0.25-0.812-0.391-0.812c0.281-0.719,0.109-0.219,0.344-0.531c0.109,0.094-0.078,0.406,0.234,0.125\r\n\t\tC312.906,326.906,313.453,328.031,312.781,328.031z M307.562,326.844c0.125-0.375,0.047-0.312-0.031-0.688\r\n\t\tC307.5,326.125,308.469,326.844,307.562,326.844z M307.188,323.656c0.344,0,0.094-0.094,0.375-0.094\r\n\t\tc-0.094,0.312,0.188,0.281,0.047,0.688C307.531,323.938,307.359,323.875,307.188,323.656z M331.938,329.781\r\n\t\tc-0.047,0.188-0.719,0.719-0.812,0.719c0.109-0.156,0.734-1.094,0.469-1.094c0.406,0,0.234,0.094,0.484,0.094\r\n\t\tC332,329.562,331.328,330.031,331.938,329.781z M340.062,330.062c-0.375,0.688,0.156-0.344-0.188,0.625\r\n\t\tc0.219,0.312,0.094,0,0.188,0.5c0.078-0.062,0.188-0.094,0.312-0.062c-0.125,0.406,0.25,0.281,0,0.656\r\n\t\tc-0.219,0.094-1,0-0.906-0.156c-0.109,0.094-0.219,0.156-0.312,0.188c0.094-0.375-1-0.875-0.672-1.594\r\n\t\tc-0.484,0.094-4.547,1.969-3.891,0.656c-0.656,0-1,0.156-1.625,0.438c0.438-0.469,0.562-0.5,1.031-0.469\r\n\t\tc0.141-0.562,0.188-2.5,0.141-2.469c-0.141,0.062-0.312,0.125-0.453,0.188c-0.094-0.844-0.797-0.5-1.25-0.719\r\n\t\tc0.062-0.094,0.156-0.156,0.219-0.25c-0.266,0-0.516-0.188-0.438-0.469c-0.219,0.062-0.625,0.438-0.75,0.594\r\n\t\tc0.078-0.125,0.047-0.156-0.094-0.125c0-0.156,0.094-0.25,0.234-0.25c0,0-0.25-0.25-0.25,0.031\r\n\t\tc0.297-0.469,0.219-0.562-0.234-0.406c0.156-0.594,1.312-0.188,1.547-0.688c-0.219,0.031-0.453,0.062-0.672,0.094\r\n\t\tc0.172-0.25-0.031-0.281-0.484-0.094c0.172-0.375,0.062-0.375-0.469-0.312c0.609-1.219,1.562-0.75,2.297-1\r\n\t\tc-0.062,0.156-0.344,1.156-0.406,1.656c0-0.156,0.094-0.219,0.297-0.156c-0.234,0.75,0.109,0.188-0.141,0.688\r\n\t\tc1.062-0.188,1.578-1.625,2.75-1.625c0.625-0.031,1.688,1.125,2.5,0.844c-0.031,0.125,0.812,0.812,1.234,0.688\r\n\t\tc-0.172,0.438,0.234,1.5,0.984,1.125c-0.094,0.25-0.5,0.938-0.656,0.938C339.812,329.312,339.312,330.281,340.062,330.062z\r\n\t\t M337.25,297.781c0,0.219-0.281,0.406-0.406,0.5C336.906,297.781,336.969,298.094,337.25,297.781z M336.906,291\r\n\t\tc0.172-0.062,0.344-0.125,0.484-0.188C337.219,291.219,337.125,290.969,336.906,291z M339.562,290.906\r\n\t\tc-0.469,0.094-0.219-0.125-0.219-0.438c0.281-0.125,0.344-0.031,0.281,0.156c0.547-0.844,0.625-0.375,1.219-0.438\r\n\t\tc-0.078,0.625-0.094,0.438,0.125,0.875c-0.125,0.188-0.344,0.656-0.469,0.656c-0.078,0.344-0.406,1.531-0.891,1.531\r\n\t\tc0.078-0.25,0.203-0.531,0.281-0.781c-0.234,0.25-0.234,0.5-0.641,0.5c0.031-0.25,1-1.938,0.594-1.938\r\n\t\tC339.531,292.031,339.359,291.562,339.562,290.906z M344.156,326.219v0.031c0,0-0.125,0.094-0.25,0.188\r\n\t\tc-0.609,0.594-1.312,1.719-2.578,1.719c0.141-0.156,0.078-0.188-0.141-0.188c0.594-0.094,0.875-0.562,1.406-0.75\r\n\t\tc-0.094,0.219,0.844-0.469,1.312-0.781C344,326.344,344.078,326.281,344.156,326.219c0.031-0.219,0.062-0.438,0.094-0.688\r\n\t\tc-0.375,0.094-0.094-0.156-0.562-0.25c0.25-0.188,0.359-0.031,0.688-0.031c-0.266,0.344,0.188,0.5,0.219,0.812\r\n\t\tC344.438,326.062,344.297,326.125,344.156,326.219z M345.031,327.281c-0.375,0.094,0.109-0.219-0.188-0.094\r\n\t\tc0.188-0.469,0.156-0.344,0.281-0.688c0.094,0,0.375,1.25,0.281,1.25C345.031,328.25,344.625,327.906,345.031,327.281z\r\n\t\t M345.75,329.125c-0.031-0.25-0.406-0.25,0.125-0.5C345.812,328.812,345.797,328.969,345.75,329.125z M346.375,329.969\r\n\t\tc0.266-0.25,0.125-0.781,0.656-0.281C346.938,329.938,346.719,330.031,346.375,329.969z M346.375,328.406\r\n\t\tc0.266-0.312,0.156-0.125,0.516-0.25c-0.031,0.156-0.016,0.312,0.078,0.406C346.75,328.906,346.625,328.406,346.375,328.406z\r\n\t\t M347.062,330.312c-0.234,0-0.031-0.062,0.031-0.219c0.094,0,0.188,0.031,0.281,0.031\r\n\t\tC347.5,330.688,347.25,330.219,347.062,330.312z M346.656,288.344c0.062-0.25,0.281-0.844,0.281-1.125\r\n\t\tc-0.531,0.781-0.531,0.75-0.969,1.656c-0.156-0.094-0.156-0.25-0.062-0.438c-0.375,0.25-0.812,0.344-1.188,0.625\r\n\t\tc0-0.219,0.141-0.156,0.172-0.312c-0.531-0.125-0.297-0.031-0.703,0.219c0.531,0-0.75,1.156-0.906,1.25\r\n\t\tc-0.297-0.375-0.25-0.875,0.172-1.312c-0.609,0.062-0.266-0.062-0.609-0.094c-0.031,0.125-0.094,1.156-0.031,1.156\r\n\t\tc-0.422,0.781-1,0.219-1.281,1.5c-0.688-1.062,0.156-1.75,1.125-2.312c-0.688-0.031-1.469,0.438-2.281,0.625\r\n\t\tc0.109-0.25,1.812-1.719,1.75-1.312c0.094-0.062,0.188-0.125,0.281-0.188c-0.156,0.062-0.188,0-0.094-0.125\r\n\t\tc0.422,0,0.891-0.406,1.344-0.031c0.141-0.156,0.344-0.375,0.453-0.531c0.172-0.094,0.234-1.719,1.047-2.156\r\n\t\tc-0.406,0.469-0.234,0.625-0.344,0.969c2.156,0,2.188-5.062,3.062-5.906c-0.031,0.156-0.031,0.312-0.031,0.469\r\n\t\tc0.172-0.031,0.328-0.031,0.5-0.062c-0.156,0.438,0.234,1.188,0.188,1.812C347.531,282.719,347.344,287.75,346.656,288.344z\r\n\t\t M350.734,277.969c0-0.5-1.016,1.281-1.047,1.281c-0.688,0.094-1.094-0.656-1.234-0.094c-0.438,0-0.562-0.219-0.641,0.406\r\n\t\tc0.703-0.094,0.188,0,0.625,0.219c-0.406,0.094-0.516,0.344-0.875,0.438c0-0.812,0.25-1.562,0.25-2.062\r\n\t\tc0,0,0.562,0.094,0.719,0.188c0.031-0.594,0.406-3.125,0.531-3.031c0.578,0.344,0.375,2.125,1.5,1.438\r\n\t\tc0.125,0.062,0.062,0.344,0.219,0.438c0.125-0.094,0.234-0.156,0.344-0.25c-0.031,0.188-0.078,0.344-0.125,0.5\r\n\t\tc0.312,0,0.25,0.062,0.312,0.438C351.125,277.906,350.938,277.938,350.734,277.969z M351.047,270.781\r\n\t\tc-1.141-2.156-0.859,3.938-0.859,3.938c-0.25,0.094-0.125-0.844-0.719-0.688c-0.312,0.094,0.062,0.844-0.406,0.844\r\n\t\tc0-0.125,0.438-1.281,0.188-1.281c0-1.719,0.281-3.531,0.281-5.469c-0.125,0.031,0.531-3.844,0.609-3.938\r\n\t\tc0.281,1,0.422,2.562,0.328,3.406c-0.094,0.594-0.219,1.312-0.125,1.844C350.484,270,351.047,270.094,351.047,270.781z\r\n\t\t M353.5,274.875c-0.375,0.5-0.656,0.75-1.094,1.188c0.156-0.438,0.891-1.625,1.125-1.625\r\n\t\tC353.516,274.594,353.516,274.75,353.5,274.875z M353.969,274.531c0-0.344,0.531-1.156,0.531-0.938\r\n\t\tC354.312,273.969,354.312,274.25,353.969,274.531z M357.641,267.781c0-0.188,0.453-0.969,0.453-0.562\r\n\t\tC358.094,267.438,357.812,267.656,357.641,267.781z M366.188,234.188c0.422-0.188,0.531-0.219,1.062-0.469\r\n\t\tc0.922,0.781-0.672,1-1.156,1.188C366.016,234.688,366.188,234.438,366.188,234.188z M362.156,237.625\r\n\t\tc-0.125,0-0.188,0.062-0.156,0.188c-0.125,0.031-0.562-0.312-0.391-0.375C361.5,237.406,361.938,237.375,362.156,237.625z\r\n\t\t M352.594,238.406c-0.094-0.594,0.531,0.188,0.844,0.156c-0.594,0.188-0.875,0.344-1.297,0.406\r\n\t\tC352.141,239,352.594,238.031,352.594,238.406z M351.75,238.094c-0.141-0.094-0.031-0.344-0.25-0.312\r\n\t\tc0.219,0.375,0.5,0.906-0.062,1.688c0.391,0,0.031-0.219,0.391-0.219c0.078-0.406,0.25-1.125,0.344-1.438\r\n\t\tc0,0.281,0.047,0.25,0.109-0.031c0.156,0.5-0.125,0.875-0.453,1.469c0.141-0.125,0.172-0.031,0.141,0.125\r\n\t\tc0.766-0.5,3-1.281,3.938-1.375c1.766-0.625,1.062,0.969,2.328,1.812c-0.062-0.094-0.047-0.156,0.062-0.156\r\n\t\tc0.078,0.25,0.141,0.625,0.172,0.938c-0.344-1.906,2.156-1.719,2.047-2.094c0.5,0.406,0.922,0.25,1.141-0.375\r\n\t\tc0.188,0.625,0.531,0.875,0.734,1.594c1.062-0.906,0.5-1.594,0.172-2.75c0.781,0.094,1.547-0.188,2.062-0.594\r\n\t\tc0.094,0.312,1.031,0.938,1.469,0.438c0.094,0.312,1.75,1.219,2.062,1.688c0.844,0.594,1.734,0.719,1.938,2.156\r\n\t\tc0.328-0.125-0.312-1,0.594-1.156c0,0.125,0.297,0.156,0.297,0.156c0.578,0.125,0.484,1.062,1.125,0.844\r\n\t\tc0.062,0.406-0.25,0.625-0.109,1.062c-0.359,0.188-0.484,0-0.719,0.219c0.094,0.469,0.266,0.219,0.094,0.938\r\n\t\tc0.094-0.031,0.281,0.531,0.406,0.688c-0.281,0.094-0.156-0.156-0.219,0.25c-0.062-0.125-0.156-0.25-0.234-0.375\r\n\t\tc-0.078,0.156-0.172,0.312-0.234,0.469c-0.391-0.594-0.422-0.25-0.719-0.344c-0.188-0.531-0.531-1.188-1.094-1.188\r\n\t\tc-0.375,1.875-0.781-0.312-0.828-0.812c-0.641,0.406,0.031,1.562,0.016,2.156c-0.016,0.938-1.391,0.844-1.047,1.656\r\n\t\tc0.203-0.062,0.141-0.188,0.297-0.281c0.203,0.75,1.375,2.312,0.438,2.688c0-0.719-1.719,1.281-1.969,1.781\r\n\t\tc-0.062-0.062-0.125-0.156-0.203-0.25c0,0.688,0.109,0.312-0.281,0.594c0.141,0.469-0.141,0.5-0.203,0.562\r\n\t\tc0,0.625-0.547,1.125-0.406,2c-0.734-0.281-0.625-0.781-1.297-0.844c-0.391,0-0.484,1.25-0.875,1.75\r\n\t\tc0.062-0.406-0.016-0.781-0.016-1.156c-0.469,0.156-0.344,1-0.656,1.188c-0.25-0.719-0.609,0.219-0.781,0.531\r\n\t\tc-0.203,0.312-0.531,2.312-0.281,2.688c0-0.406,0.781,0.188,0.25,0.688c-0.375,0.438,0.062,1.062,0.125,1.5\r\n\t\tc0.094-0.062,0.219-0.125,0.312-0.219c0.094,0.844-0.344,0.438-0.375,0.594c-0.125,0.5-0.406,0.969-0.531,1.625\r\n\t\tc-0.062,0.312,0.438,0.375,0.25,0.875c-0.156,0.438-0.547-0.062-0.703,0.375c0,0.469-0.578,2.094-0.766,2.125\r\n\t\tc0,1.031-0.531,2.219-1.25,2.906c0-1.281-1.719-7.688-0.156-8.031c0-1.906,1.375-2.969,2.141-4.969\r\n\t\tc0-0.531,0.078-1.531,0.609-1.688c1.156-0.25-0.125-2.562,1.047-2.594c-0.734-0.562-0.391-0.156-1.047-0.031\r\n\t\tc0.312-0.094-0.031,2.156-0.031,1.188c-0.578,0.188-0.75,1.406-1.172,2.156c-0.016-0.375-0.047-0.406,0.016-0.844\r\n\t\tc-0.188,0.031-0.188,0.219-0.281,0.375c0.062-0.375,0.156-0.938,0.062-1.312c-0.25,0.219-1.438,0.719-1.906,0.844\r\n\t\tc-0.531,0.781-1.344,2.531-1.125,3.375c0.156-0.125,0.281-0.188,0.453-0.281c0.062,0.625-0.984,1.219-1.859,1.594\r\n\t\tc0.031-0.719-0.391-0.5,0.406-0.906c-0.625-0.531-0.281-0.625-0.906-0.156c0-0.375-1.297-0.312-1,0.688\r\n\t\tc-0.875,0.156-1.25-0.469-1.781,0.375c-0.141-0.562-0.25-0.312-0.641-0.719c0,0.281-0.797,0.281-1.078,0.531\r\n\t\tc0.031-0.125,0.062-0.25,0.094-0.344c-1.609,0.312-1.75,3.812-3.094,4.562c0.094,1.531-7.094,2.469-7.094,3.969\r\n\t\tc0.328-0.031-4.156-0.062-4.156-0.125c0,0.406,0,0.875,0,1.312c0,0,5.359-0.344,5.453-0.562c0.078,0.062,2.672,0.094,2.766,0.156\r\n\t\tc-0.094,0.219,1.125,0.438,1.047,0.625c0.375,0,1.125-0.188,1.125-0.5c0.312,0,0.266,0.156,0.609,0.125\r\n\t\tc0-1.594,1.562,0.469,2.125,0.469c0-0.219-1.188,3.062-0.766,3.281c0.594,0.312-0.734,3.5-1.188,3.875\r\n\t\tc-0.359,0.25-1.594,3.125-1.656,3.5c-1.094,0.531-1.109,2.938-2.422,2.688c-0.125-0.562-0.344-0.312-0.188-0.969\r\n\t\tc-0.125,0.125-0.25,0.25-0.375,0.375c0.031-0.125,0.078-0.219,0.125-0.344c-0.688,0-1.672,1.75-2,2.375\r\n\t\tc-0.281,0.469-1.328,3.125-2.031,3.125c0.188,0.062,0.594,0.438,0.75,0.375c-0.125,0.375,0.438,2.656,0.484,2.656\r\n\t\tc-0.484,1.594-1.203,1.656-2.391,2.875c-0.047-0.75,0.125-1.562,0.719-2.094c-0.203,0.031-0.188-0.875-0.25-1.062\r\n\t\tc0.656,0,0.359-0.969-0.031-0.969c-0.516,0.062-1,0.25-0.734-0.406c-0.047,0.031-0.109,0.094-0.172,0.156\r\n\t\tc0-0.625-0.25-0.688,0.562-1c-0.688,0.094-0.031-1.219-0.594-1.062c-0.359,0-0.75,0.031-0.906,0.031\r\n\t\tc-0.344,0.594-1,0.531-1.062,1.188c-0.125,0.031-0.25,0.031-0.422,0.031c0.109-0.25,0.234-0.375,0.375-0.625\r\n\t\tc-0.641,0,0.359-1.188,0.578-1.625c-0.969-0.531-1.656,0.625-2.219,1.312c-0.703,0.844-1.156,0.594-1.516,1.594\r\n\t\tc-0.047,0.312,0.453,1.125,0.641,1.562c0.312-0.094,0.438-0.438,0.812-0.625c0.797-0.375,1.062,0.031,2.062-0.031\r\n\t\tc-0.188,0.562-1.625,1.5-1.938,1.562c-0.109,0.344-0.75,0.75-0.844,1.094c-0.188,0.844,0.484,1.438-0.141,2.062\r\n\t\tc0.453,0,0.078-0.156,0.391-0.156c0.031,0.656,0.594,1.438,0.5,2c-0.109,0-0.5,0.062-0.812,0.031\r\n\t\tc0.312-0.031,0.688,0.281,0.906,0.281c-0.031,0.688-0.625,0.812-0.625,1.25c0.938,0,0.453,0,0.969,0.469\r\n\t\tc-0.5,0.531-0.734,2.031-1.578,2.031c0,0.688-1.609,2.938-1.797,2.938c0.062,0.656-0.312,0.906-1.047,0.969\r\n\t\tc-0.078,0.969-2.219,2.406-3.172,2.406c0.094-0.375-0.047-0.188-0.125-0.594c0,0.844-1.938,1.562-2.344,1.562\r\n\t\tc-0.062,0.062-1.469,1.375-0.844,1.25c-0.719,0.125-0.906-0.438-0.391-1.219c-0.234,0-0.641-0.031-0.812-0.094\r\n\t\tc-0.453-0.219-0.734,0.688-1.141,0.812c-0.469,0.156-0.859,1.125-1.25,1.125c-1.203,1.906,0.188,1.844,0.188,3.188\r\n\t\tc0.781,0,0.719,3.594,0.656,4.125c-0.766,2-2.25,2.219-3.719,2.219c0.406,0.531,0.25,0.469,0.344,0.844\r\n\t\tc-0.25,0-0.328-0.375-0.438-0.562c0,0.25-0.297,0.875,0.031,0.875c-0.047,0.094-0.844,0.594-1.031,0.625\r\n\t\tc0.344-0.656-0.031-1.188,0.141-1.938c-0.172,0-0.422,0.281-0.172-0.312c-0.109,0.062-0.219,0.094-0.328,0.156\r\n\t\tc-0.016-0.875-0.516-1.219-0.766-2.094c-0.016,0.188-0.125,0.219-0.344,0.125c0.047-0.156,0.078-0.531,0.078-0.719\r\n\t\tc-1.359-0.156-2.297,3.812-2.312,4.844c0.391-0.094,1.328,2.438,1.422,3.062c0.094,0.812-0.188,1.938-0.188,3.031\r\n\t\tc-0.25,0-1.516,0.312-1.234-0.25c-0.266-0.312-0.797-2.281-0.672-2.281c0.281-0.875,0.469-1.781,0.281-2.719\r\n\t\tc-0.312-1.5-0.531-0.75-0.062-2.219c0.375-1.094,1.688-7.406,0.125-7.406c-0.484,0.719-0.875,1.125-1.641,1.188\r\n\t\tc0-1.25,0.703-2.812,0.297-4.469c-0.375,0-0.516,0.406-0.766,0.406c0.25-0.719-0.281-1-0.078-2.188c0.156,0-0.734-1.25-0.969-1.438\r\n\t\tc-0.25,0.75,0.062,0.969-0.75,1.312c-0.25,0.812-2.312-0.281-2.312,0.781c-0.156,0.25-1.406,1.25-1.484,1.5\r\n\t\tc-0.922-0.094-1.859,1.625-3.016,1.844c-0.672,0.156-1.172,0.844-1.844,1.312c-0.844,0.656-0.562,0.188-1.047,1.188\r\n\t\tc-0.172-0.062-0.719,1.969-0.859,2.375c-0.25,1.188-1.688,3.719-3.406,3.719c0.172-0.531-0.078-2.062-0.219-2.906\r\n\t\tc-0.969,0,0.109-3.406-0.422-3.562c0.609-1.844-0.984-5,0.891-6.5c-0.5-0.125,0-1.531,0.062-1.625\r\n\t\tc-0.172-0.031-1.625,2.688-2.219,1.5c-1.344-2.781,0.219-0.625,1.125-2.562c-0.188-0.062-3.062,0.594-1.656-1.031\r\n\t\tc-0.625,0.188-1.469-0.781-1.578-1.188c-0.078-0.281,0.594-0.75-0.5-0.844c-0.703-0.125-0.609,0.188-1.266,0.125\r\n\t\tc-1.016-0.188-5.156-0.062-5.25-1.719c-0.203-2.25-3.031-0.219-3.031-1.219c-1.297-0.406-1.641-3.375-1.625-4.406\r\n\t\tc-0.594-0.094-1.562-0.688-1.781-0.688c-0.094,0.469,0.219,0.469,0.094,0.844c-0.094-0.062-0.156-0.156-0.25-0.219\r\n\t\tc-0.156,0.281-0.312,2.531,0.438,2.688c0.062,0.438,0,2.312,0.281,2.688c0.141-0.188,0.609-0.656,0.875-0.656\r\n\t\tc0.031,0.312-0.531,1.375-0.438,1.531c0.453,0.75,1.359,0.344,1.891,0.875c0.031-0.281,2.141-1.438,2.547-1.812\r\n\t\tc-0.125,0.531-0.375,1.625,0.031,1.781c0.125,0.219,0.625,0.781,0.594,0.875c0.938,0.094,0.953,1.719,1.516,1.719\r\n\t\tc-0.453,0.469-0.984,1-1.297,1.531c-0.031,0-1.844,1.875-1.219,1.875c-0.484,0-2.75,1-2.75,1.281\r\n\t\tc-0.484,0.25-2.703,0.281-2.703,0.969c-0.984,1.406-4.703,1.562-5.844,1.688c-0.516,0.062-3.688,0.656-2.312-1.25\r\n\t\tc-0.266-0.094,0.078-0.906,0.156-1.219c0.203-0.719-0.031-1.531-0.078-2.125c0.172-0.531-0.453-2.625-0.625-2.688\r\n\t\tc0.062-0.469-0.422-0.656-0.641-0.656c0.141-0.469-0.094-2.094-0.25-2.156c1.125-1.188,0.219-3.031-0.109-4.469\r\n\t\tc0.109-0.438-1.234-3.312-1.469-3.312c-0.75,1.688-0.844-1.125-1.266-1.281c-0.5,1.562,0.719,4.812,1.125,6.188\r\n\t\tc-0.844-0.125,0.391,2.656,0.469,3.094c-0.031,0-0.75,2.219-0.375,2.875c0.297,0.5,0.812,0.969,0.75,1.406\r\n\t\tc-0.062,0.125-0.375,1.625-0.219,2.031c0.188,0.906,3.5,4.031,1.656,4.688c1.062,1.5,1.406,1.25,3.094,1.75\r\n\t\tc0.297-0.562,3.516-0.469,3.766-0.344c-1.406,1.625-2.297,4.969-4.578,6.344c-1.094,0.719-1.922,1.469-3.297,2.125\r\n\t\tc-0.766,0.312-2.328,0.625-2.672,1.625c-0.781,0-1.406,1.5-2.266,1.5c-0.859,0.625-1.891,1.562-2.078,2.531\r\n\t\tc-0.125,0.562,0.156,0.75,0.188,1.219c0.094,1.062-1,1.375-0.438,2.562c0.156,0.375-0.562,4.281-0.75,4.219\r\n\t\tc-1.109,1.219-2.719,1.781-4.547,1.438c-0.188,0.375-2.297,1.531-1.734,1.906c0.062,0.062,0,1.562-0.109,1.875\r\n\t\tc0.453,0.188-0.453,1.062-0.875,1.25c-0.266-0.094-2.109,0-2.188,0.406c0.141,0.094,0.266,0.156,0.391,0.219\r\n\t\tc-0.312,0.438-0.469,1.406-1,1.312c0.094,1.719-5.234,2.062-5.516,3c-2.266-0.562-4.984-0.719-6.531-1.219\r\n\t\tc0.172-0.75,1.047-4.781-0.516-5.062c0.281-0.688-0.344-1.656-0.094-2.688c0.188-0.875,0.25-1.531,0.344-1.938\r\n\t\tc0.031-0.969-0.969-1.844-0.734-2.625c0.234-0.938-0.703-1.188-0.453-2.094c0,0.062,0.375-1.781,0.766-1.656\r\n\t\tc0.109-0.344,1.547-2.469,2.047-2.344c0.344-1.219-0.344-2.25,0.656-3.062c-0.406-0.125-0.156-3.344-0.406-3.406\r\n\t\tc0.391-0.531-1.438-2.875-1.688-3.625c0.25,0.156,0.359,0.156,0.344-0.031c-0.688-0.281-0.344-1.75,0.406-1.5\r\n\t\tc-0.047-0.188-0.219-0.438-0.156-0.531c0.688,0.156,1.344-2.906,1.375-3.344c-0.297-0.25-0.688,0.25-0.547-0.5\r\n\t\tc-0.609-0.156-0.453-0.281-1.016-0.438c-0.078,0.812-1.5-0.406-1.719-0.438c0.188-0.594,0.047-0.844,0.188-1.312\r\n\t\tc-1.375-0.562-1.828-1.656-3.406-0.844c0.031-0.25,0.125-0.125,0.234-0.281c-0.172,0-0.219-0.062-0.109-0.188\r\n\t\tc-0.344-0.094-0.297,0.188-0.734-0.406c-0.047,0.281,0.078,0.438,0.141,0.688c-0.953-0.406-2.281,0.062-3.047-0.281\r\n\t\tc0.109-0.719-3.984-0.688-4.328-1c-1.156-1.188-2.312-3.156-2.906-4.531c0.047,0.062,0.078,0.125,0.125,0.188\r\n\t\tc-0.031,0-0.391-1.031-0.406-0.938c0.094,0.031,0.188,0.094,0.297,0.125c0.156-1.5-0.703-2.594-1.078-3.906\r\n\t\tc0.219-0.469-0.453-1.094-0.531-1.5c0.078-0.5,0.391-1.406-0.062-2.219c1.484,0.469,2.875-6.625,2.469-6.812\r\n\t\tc0.219-1.125,1.594-1.656,2.188-2.375c0.703-0.844,1.719-1.656,2.5-2.438c0.625-0.625,2.625-0.5,3.328-1.469\r\n\t\tc0.953-1.25,0.609-2.906,2.172-3.656c1.031,0.375,1.672-1.031,2.406-0.812c0.812-2.5,1.594,0.219,3.266,0\r\n\t\tc-0.125,0.219,0.109,0.344,0.172,0.531c1-0.344,2.281-0.094,3.219-0.688c0.844-0.469,4.922,1.656,5.062,1.062\r\n\t\tc0.688,0.688,1.688,0.531,2.438,0.625c-0.219,0.594,0.344,0.438,0.641,0.531c-0.188,0.594-1.562,1.219-0.734,1.469\r\n\t\tc-0.234,0.688-0.438,1.125-0.859,1.375c-0.609,0.344,0.109,1.281,0.203,1.344c0.328,0.75,2.031,1.781,2.688,1.969\r\n\t\tc-0.312,1.344,1.812,2.312,2.984,3c0.953,0.594,0.891-1.5,0.922-1.562c0.406-0.406,1.031-0.469,1.469-0.656\r\n\t\tc0.406-0.188,2.859,2.375,3.312,2.5c0.891,0.281,1.25,1,2.438,1.281c0,0.062,2.141,0.562,2.031,0.531c0-0.188,0-0.312-0.031-0.531\r\n\t\tc1,0.406,1.594,1.281,3.078,0.094c0.828-0.719,0.703-1.812,1.797-2.531c-0.547-0.344,0.234-2.188,0.375-2.781\r\n\t\tc-0.219-0.062-0.531,0.219-0.781,0.344c0.25-0.438-2.156,0.438-2.406-0.375c-0.094-0.469-0.625-0.656-1-0.781\r\n\t\tc-0.641,1.594-2.016-0.812-2.641-1.031c0.109-0.375,0.516-1.219-0.297-1.281c0.078-0.188,0.125-0.375,0.156-0.594\r\n\t\tc0.078,0.125,0.141,0.281,0.219,0.406c0.125-0.5,0.203-0.812,0.375-1.406c-1.297-0.375,0.422-1.062,1.094-0.938\r\n\t\tc0.062-0.281,1.25-0.156,1.734-0.031c0.203-0.625-1.125-0.281,0.672-0.5c-0.125,0.781,0.969,0.062,1.156,0.031\r\n\t\tc0.938-0.094,1.781,0.188,2.75,0.094c-0.312,0.812,3.922,2.75,4.875,1.594c0.172-1.25-1.172,4.391-2.172,4.25\r\n\t\tc0.078-0.422-0.109,7.719,0.016,7.719c-0.219,0-0.406,0-0.625,0c0.156,0,0.375-8.438,0.406-8.938\r\n\t\tc0.312-0.031,0.406-4.172,0.312-3.969c0.688-0.266,0.938-2.797,0.422-3.328c0.328,0.031,1.719-1.484,1.719-1.703\r\n\t\tc-1.75,0-2.984-0.094-4.547-0.359c-0.422,0.641,0.594,0.578,0.391,1.172c0.5,0.094,0.828,0.094,1.266-0.016\r\n\t\tc-0.094,0.141-0.031,0.141,0.109,0.109c-0.891,0.312-1.797,0.375-2.844,0.594c0.578-0.75,0.266-1-0.469-1.281\r\n\t\tc0.469-0.188,1.234-0.453,1.281-0.859c-0.5-0.125-1.266,0.047-1.656-0.734c0.234,0.062,0.422-0.031,0.625,0\r\n\t\tc-0.141-0.156-0.234-0.281-0.359-0.438c0.047-0.188-1.531,0.656-1.719,0.719c-0.531,0.25-0.703,0.938-0.734,1.375\r\n\t\tc-0.516-0.344-1.594,1.406-1.734,1.719c-0.594,1.312,0.297,1.219,0.156,2.406c-0.969-0.156-1.484,0.125-2.375,0.375\r\n\t\tc0.469-1.188-0.812-1.25-1.859-1.5c-0.078,0.375,0.016,0.562,0.234,0.906c-0.094-0.062-0.172-0.156-0.266-0.25\r\n\t\tc0.031,0.156,0.047,0.281,0.062,0.406c-0.141-0.062-0.109-0.156-0.25-0.25c-0.031,0.25-0.031,0.094-0.078,0.312\r\n\t\tc-0.375-0.125-0.344-0.531-0.375-0.938c-0.172,0.688-0.5,0.719-0.172,1.781c-0.281-0.094,0.031-0.156-0.234-0.25\r\n\t\tc-0.188,0.688,0.125,0.031-0.016,0.688c0.453,0.062,0.984,0.781,1.031,1.469c-0.203-0.281-0.328-0.469-0.672-0.5\r\n\t\tc0.031,0.406,0.219-0.188-0.031,0.625c-0.219-0.156-0.438-0.219-0.703-0.344c-0.047,0.156,0.125,0.312,0.172,0.531\r\n\t\tc-0.312,0-0.25-0.031-0.594-0.156c-0.281,1.219-0.719-0.312-0.922,0.25c-0.188-0.594-0.391-1.688,0.344-1.25\r\n\t\tc0-0.156,0.078-0.188,0.203-0.094c0.047-0.438-0.75-0.344-0.312-1.125c-0.141,0.031-0.266,0.062-0.375,0.062\r\n\t\tc0.094-0.469-0.25-0.656-0.141-1.219c-0.172-0.062-0.234,0.125-0.359,0.25c0.109-0.562,0.312-1.75,0.219-2.281\r\n\t\tc-0.031-0.156-0.031-2.031-1.094-2.031c0.094-0.312-1.25-1.531-1.344-1.562c-0.219,0-0.312-1.938-0.281-2.312\r\n\t\tc-0.188,0.312-0.656,0.875-0.844,0.781c-0.031-0.656-0.094-0.938,0.312-1.281c-0.406-0.156-0.875-0.125-1.219-0.188\r\n\t\tc-0.25,0.625-0.875,1.844-0.156,2.156c0.281,0.062,0.625,0.75,0.438,1.156c0.516,0.156,0.594,1.844,1.562,1.969\r\n\t\tc-0.094,0.156-0.188,0.312-0.281,0.438c0.812,0.219,1.25,1.688,1.125,2.219c-0.266-0.094-0.438-0.906-0.719-0.906\r\n\t\tc-1.203,0.656,0.031,0.938-0.281,1.594c-0.172-0.031-1,1.438-1.656,1.219c2.047-3.625-2.922-4.562-2.094-8.438\r\n\t\tc-0.516-1.156-2.172-0.938-2.875-0.25c-0.406,0.406-3.562-2.312-3.062,0.719c-0.922-0.344-2.422,0.938-3.094,1.281\r\n\t\tc-0.656,0.312-0.125,0.719-0.438,1.125c-0.156,0.562-1.031,0.5-1.188,1.156c-1.406,0.875-2.156,0.094-3.562,0.344\r\n\t\tc-1.094,0.219-1-0.188-1.266-1.156c-0.078-0.344-1.562-0.625-1.859-0.75c0.25-0.844,0.438-1.469,0.656-2.031\r\n\t\tc-0.312-0.094-0.031,0.125-0.344,0.062c0.062-0.188,2.281-3.281,1.453-3.438c0.547-0.438,0.516-0.969,0.219-1.531\r\n\t\tc0.188,0.062,1.141-0.156,1.141-0.062c0.344-0.531,1.156,0.406,1.469,0.469c0.625,0.188,3.25,1.875,3.719,1.5\r\n\t\tc0.344-0.312,1.578-2.688,1.062-2.844c-0.062-0.719-0.891-0.938-0.391-1.688c-0.625-0.188,0.172-0.281-0.438-0.5\r\n\t\tc0.047-0.281,0.188-0.156,0.359-0.219c-0.312-0.125-0.406-0.281-0.5,0.156c-0.281-0.094-0.344-0.531-0.25-0.781\r\n\t\tc-0.297,0-0.406-0.25-0.438-0.547c0.031-0.078,0.062-0.141,0.172-0.078c-0.172-0.656,0.016-0.562,0.594-0.312\r\n\t\tc-0.047,0.156,1.438,8.078,1.906,8.266c0.109-0.594,0.109,6.328,0,6.328c0.141,0,0.312,0,0.453,0c-0.031,0,2.312-7.719,2.406-7.781\r\n\t\tc0.531-0.328,0.062-4.781,1.125-4.484c0.156-0.281,0.938-1.953,1.125-1.922c-0.25-0.094-0.062-1.125-0.156-1.344\r\n\t\tc0,0,0.5,0.125,0.156-0.094c0.094,0.094,0.172-0.078,0.25,0c0.516-1.781,2.25-2.406,3.094-1c0.406-0.922,0.719-0.219,1.078-0.562\r\n\t\tc0.234-0.5,0.422-1.125,0.578-1.719c0.125,0.031-0.641-3.312,1.5-2.438c0.188-0.812-0.109-0.547-0.531-0.734\r\n\t\tc0.125,0.016,0.188,0.078,0.188,0.234c-0.328,0.062-0.312,0.25-0.188-0.25c-0.25,0.094-0.266,0.281-0.516,0.188\r\n\t\tc0.375-0.812,1.406-0.469,2.312-0.969c-0.266,0.656-0.234,0.969-0.953,0.906c0.141,0.062,0.344,0.094,0.5,0.125\r\n\t\tc-0.25,0.781,0.281,11.281-0.453,11.062c-0.234,0.281-0.703,10.781-0.75,10.781c0.219,0,0.422,0,0.609,0\r\n\t\tc-0.188,0,0.094-9.469-0.219-9.016c-0.094-0.188-0.344-5.703-0.531-5.766c0.031,0.531-0.062-2.344-0.172-1.781\r\n\t\tc0.141,0.031,0.266-1.156,0.422-1.109c-0.625,0.469-0.172,0.109-0.25,0.672c0.359,0.25,0.391-0.281,0.75,0.25\r\n\t\tc0.109-0.344,0.672-0.469,1.125-0.656c-0.344,1.25,4.219,0.656,4.656,0.969c-0.047,0.375-0.25-0.203-0.406,0.344\r\n\t\tc0.281-0.031,0.531-0.094,0.812-0.125c-0.062,0.125-0.094,0.266,0.047,0.328c0.172-0.188,0.484-0.484,0.625-0.641\r\n\t\tc-0.672-0.25,0.266-0.594,0.5-0.719c-0.031,0.125-0.078,0.281-0.109,0.438c1.344-0.656,0.672-2.906,2.578-3.312\r\n\t\tc-0.266,0.406-0.219,0.625,0.109,1.062c0.828,0.969,1.109-0.969,1.406-1.5c-0.125-0.062-0.281-0.094-0.438-0.125\r\n\t\tc0.188-0.688,0.188-0.719,0.359-1.25c0.875,0.156,3.406,0.531,3.734-0.031c-0.094,0.219,1.219,0.125,1.594,0.219\r\n\t\tc0.125-0.469-1.062-0.969-1.438-1.5c0.25,0.094,0.328,0,0.281-0.281c-1.125-0.125-2.062,0.688-2.984,0.375\r\n\t\tc-1.297-0.125-0.375-0.438-1.359-1.531c-0.031,0.156-0.047,0.312-0.109,0.469c-0.562-0.156,0.062-2.219,0.312-2.781\r\n\t\tc0.172-0.344-0.172-0.719,0.531-0.938c0.109-0.031,0.797-0.469,1.094-0.625c0.172,0.062,1.828-1.5,1.672-1.812\r\n\t\tc0.016,0-0.062-1.094-0.094-0.906c0-0.062-1.156-0.438-1.375-0.75c-0.25,0.375-0.344,0.812-0.906,0.594\r\n\t\tc-0.375,0.844-0.688,1.688-1.797,2.375c-0.703,0.375-0.812,0-1.266,0.625c-0.453,0.281-0.562,0.656-1.094,0.375\r\n\t\tc-0.531,1.25-0.609,1.75-0.953,3.125c0.297,0.219,0.453,0.219,0.453-0.062c0.312,0.281,0.047,0.344,0.531,0.469\r\n\t\tc0,0.125-0.109,0.844,0.172,0.906c-0.297,0.156-0.391,0.375-0.906,0.438c1.203,0.25-0.922,0.812-1.516,0.688\r\n\t\tc0.422,0.469-0.875,2.219-1.125,2.625c0.25,0.031,0.281-0.094,0.5-0.188c-0.062,0.25-0.312,0.5-0.469,0.688\r\n\t\tc-0.094-0.156-0.141-0.156-0.078-0.344c-1.359-0.531-1.703,1.156-3.078,0.594c0.469-1.375,0.531-1.125,0.344-2.781\r\n\t\tc-0.359-0.125,0.062-2.125,0.109-2.375c-0.578-0.125-1.547,0.688-2.266,0.5c-1.781,0.188-1.859-0.188-1.359-1.969\r\n\t\tc-0.297-0.156-0.328-0.156-0.719-0.219c0.031-0.125,0.047-0.219,0.172-0.312c0.594,0.188,0.969-0.094,1.281-0.781\r\n\t\tc-0.562-0.156-0.391,0-0.984-0.156c0.172-0.156,0.281,0.031,0.359-0.219c-0.797-0.25-0.5-0.375,0.016-0.5\r\n\t\tc-0.125-0.062-0.359-0.312-0.297-0.438c0.266,0.094,1.578,0.75,1.703,0.219c-0.234-0.125-1.078-0.281-1.672-0.375\r\n\t\tc0.172-0.5,0.125-0.156,0.281-0.406c-0.219-0.031-0.219-0.125-0.016-0.375c0.328,0.094,0.609,0.188,0.953,0.312\r\n\t\tc0.094-0.594-0.75,0.062-0.531-0.688c0.594,0.156,1.031-0.094,0.922,0.312c0.172-0.062,0.328-0.125,0.562-0.188\r\n\t\tc-0.266-0.031-0.422-0.281-0.328-0.562c0.25,0.094,0.406,0.219,0.547,0.312c0.172-0.562,0.312-0.312,0.109-0.844\r\n\t\tc0.547,0.219,0.703,0.469,0.906-0.031c0.078,0.156,0.188,0.281,0.312,0.469c0.031-0.188-0.094-0.281-0.203-0.438\r\n\t\tc0.516-0.281,0.312-0.312,0.656-0.625c-0.141,0.031-0.297,0.031-0.422,0.031c0.141-0.062,0.312-0.125,0.469-0.188\r\n\t\tc-0.219,0.438,0.469,0.312,0.531,0.344c0.125,0.438,0.219,0.312,0.516,0.625c0.203-0.438,0.859-0.438,0.953-0.688\r\n\t\tc-0.406,0.188-0.703,0.219-1.125,0.312c0.094-0.312-0.031-0.25,0-0.5c0.562,0.125,1.594-0.906,1.625-1\r\n\t\tc0.844,0.25,0.562,0.156,0.719-0.312c1.391-0.281,1.047-0.781,1.703-1.312c0.734,0.125,1.422-0.938,1.969-0.781\r\n\t\tc0.047-0.219,0.047-0.25,0.172-0.625c-0.156,0-0.297,0.031-0.438,0.062c0.031-0.219,0.125-0.25,0.312-0.094\r\n\t\tc0-0.125,0-0.156-0.031-0.188c0.125,0.031,0.219,0.062,0.422,0.312c0.203-0.156,0.656-0.438,0.797-0.625\r\n\t\tc-0.25-0.094-0.594-0.094-0.875-0.062c0,0,2.562-1.5,0.719-1.344c0.125-0.312,0.344-0.656,0.938-0.875\r\n\t\tc-0.062,0.312-0.156,0.625-0.25,0.938c0.312,0.156,0.422,0.062,0.375-0.375c0.359-0.125,0.094,0.25,0.359-0.25\r\n\t\tc0.078,0.188-5.438,0.375-5.219,0.406c0.156-0.406-5.125-0.656-5.125-0.875c0,0.156,0,0.312,0,0.5c0-0.312,5.906-0.062,5.969-0.562\r\n\t\tc0.531,0.094,2.703,0.312,3.219,0.469c0.5,0.125,1.641-0.062,1.766-0.406c0.203,0.062,1.094,0.344,1.219,0.5\r\n\t\tc-0.031-0.219,0.281-0.469,0.266-0.688c-0.109,0.031-0.031,0.062-0.125,0.094c0.062-0.125,0.125-0.219,0.031-0.344\r\n\t\tc0.438,0.125,2.109,1.344,2.266,0.125c0.391,0.156,0.125,1.219,0.516-0.375c0.391,0.312,0.406,0.219,0.625,0.312\r\n\t\tc-0.094,0.281-0.047,0.344,0.172,0.375c-0.469,0.312-0.75,0.75-0.75,1.281c0.188-0.312,1.25-1.656,1.547-1.562\r\n\t\tc0,0.469-0.312,0.656-0.375,1.031c1-0.438,0.719-1.531,1.656-1.188c-0.188,0.531,0.219,0.344-0.422,0.531\r\n\t\tc0.016,0.125,0.047,0.219,0.047,0.344c0.109-0.094,0.219-0.156,0.344-0.25c-0.125,0.188-0.188,0.438-0.281,0.625\r\n\t\tc0.156,0.031,0.5-0.656,0.625-0.875c0.125,0.25,0.219,0.594,0.219,0.75c0.188,0.031,0.297-0.094,0.469-0.062\r\n\t\tc-0.047,0.188-0.156,0.25-0.25,0.438c0.688,0.125-8.844,0.031-8.406,0.469c-0.812-0.25-10.344,0.406-10.344,0.156\r\n\t\tc0,0.188,0,0.344,0,0.531c0-0.281,9.438,0.031,9.844-0.312c0.344,0.312,5.141,0.688,5.406,0.219\r\n\t\tc0.266,0.219,2.438,0.375,2.781,0.469c-0.312,0.188,1.156,0.281,0.688,0.219c0,0.094,2.438,1.25,2.734,1.531\r\n\t\tc-0.047,0.156,2.609,1.594,2.609,2.125c-0.281,0.75,1.859,1.906-0.172,2.781c-0.078-0.031-2.328-0.062-2.078-0.5\r\n\t\tc-0.5-0.094-1.594-1.188-1.594-1.031c-0.75-0.344-0.812-1.188-1.344-1.344c0,0.25,0.156,0.719,0.375,0.781\r\n\t\tc-0.094,0.094-0.219,0.156-0.312,0.219c0.156,0.031,0.344,0.094,0.516,0.125c0.016,0.219-0.078,0.25-0.297,0.094\r\n\t\tc0.125,0.312,0.438,0.375,0.438,0.625c-0.25-0.031-0.344-0.156-0.469,0.062c2.156,0.531,0.719,1.781,1.188,3.438\r\n\t\tc0.031-0.094,0.781,0.906,1.531,1c0-0.188,0.781-0.312,0.391-1.094c-0.5-0.875-0.312-0.5-0.078-1.5\r\n\t\tc0.469,0.312,0.688,0.719,0.562,1.125c0.688-0.031,0.719,0.281,1.469,0.688c0-0.594-0.75-2.844,0.875-2.281\r\n\t\tc0.188-0.844,1.219,0.125,0.969,0.656c0.938,0.25,1.812-3.656,1.438-4.281c0.891,1.031,1.703,0.906,1.875,2.531\r\n\t\tc-1.219-0.375-1.125,0.281-1.125,1.562c0.5,0.156,1.312-0.188,1.469-0.625c0.359-1.062,0.844-0.5,0.938-1.188\r\n\t\tc0.938,0.406,1.781-0.781,2.812-0.469c0.109-0.125,0.469-0.562,0.812-0.5c0.094,0.219,0.094,0.531,0.266,1.031\r\n\t\tc-0.484-0.062-0.297,0.125-0.578,0.219c0.375-0.031,0.406,0.062,0.656,0.125c0.219-0.5,0.406-0.094,0.641,0.094\r\n\t\tc0-1,1.297-0.938,1.828-0.156c0.375-0.375,0.625-0.375,1.234-0.438c-0.078,0.375-0.266,1.125,0.25,1.188\r\n\t\tc0.547-0.75,1.406-0.75,0.734-2.188c0.172,0.062,0.594-0.062,0.594-0.375c1.094,0.812,2.562-0.125,2.297,1.781\r\n\t\tc0.297,0.062,0.234-0.375,0.328-0.562c0.656,0.438,1.703,1.438,1.609,2.281c0.406,0.094,0.734-0.781,0.797-1.188\r\n\t\tc-0.219,0-0.062,0.219-0.391,0.156c0.109-0.625-0.141-0.781,0.25-1.281c-0.391-0.094-0.484-0.219-0.859-0.312\r\n\t\tc0.375-0.812,0.328-1.156,0.438-2c-0.594-0.125,0.562-1.094,0.594-1.219c0.359-0.75,1.562-1.469,1.562-2.219\r\n\t\tc0.453,0.031,1.375,0.094,1.719,0.531c0,0.188,0.109,1.969-0.281,1.906c0,1.188-0.125,1.906-0.156,3.188\r\n\t\tc0,0.375-0.156,0.656-0.094,1.125c0.031,0.469,0.562,0.688,0.562,1.219c0,0-0.719,2-0.75,2.188\r\n\t\tc-0.719-0.094-1.344,0.188-2.312,0.188c-0.062,0.281,0.219,0.688,0.594,0.75c1.203,0,0.812,0.938,1.531,1\r\n\t\tc0.062-0.656,0.094-0.844-0.422-1.188c2.297,0.656,1.516-2.562,2.203-3.344c0.438-0.531,1.625-0.719,1.516,0.156\r\n\t\tc0.672,0.094-0.453,2.156,0.609,2.688c0-0.875,0.938-0.219,0.938,0.094c0.078-0.062,0.156-0.094,0.25-0.156\r\n\t\tc-0.312-0.25-0.594-0.531-0.984-0.562c-0.297-0.875,0.219-0.938,0.016-1.781c-0.469-1.656-1.422-0.906-2.688-1.125\r\n\t\tc0.188-1-0.062-1.562-0.062-2.438c0.203-1.406,0.625-1.812,0.812-3.594c0.656,0-0.5,3.344,1.375,3.5c0-0.375,0.516,0,0.656,0.094\r\n\t\tc0.062-0.125,0.109-0.219,0.172-0.312c-0.922-0.094-0.953-0.875-0.953-1.531c0.906,0.094,0.719,0.906,1.406,0.125\r\n\t\tc-0.266-0.125-0.172-0.156-0.5-0.188c0.375-1.344,2.469,0.719,3.359,0.812c0,0.719-0.703,2.406-1.141,2.938\r\n\t\tc0.328,0.062,0.312-0.469,0.656-0.406c0.688,0.594-0.094,0.844,1.078,0.875c-1.359-1.031,1.047-3.938-1.297-4.125\r\n\t\tc0-0.25-0.344-0.219-0.453-0.531c-0.359-0.719,0.078-1.125,0.078-1.781c0.375-0.625,1.844-0.781,2.594-0.25\r\n\t\tc0.219-0.375,1.344-0.625,0.969,0.375c1.609,0.156-0.875-1.562,0.375-1.562c0-0.375-0.062-0.5-0.469-0.5\r\n\t\tc0.047-0.094,0.094-0.219,0.141-0.312c0.219,0,0.328,0.219,0.578,0.375c0-0.594,0.375-0.656,0.375-0.938\r\n\t\tc-0.203-0.062-0.344-0.094-0.344-0.344c1.719,0,2.312-0.656,3.969-0.594c0.031-0.281,0.109-0.25,0.109-0.438\r\n\t\tc0.672,0.312,1.672-0.375,1.672,0.844c0.25,0.094,0.328,0,0.219-0.312c0.078,0.156,0.156,0.344,0.219,0.5\r\n\t\tc0.344-0.5,0.938-1.312,1.406-0.438c0-0.531-0.125-0.438-0.391-0.781c0.109-0.062,0.234-0.125,0.359-0.188\r\n\t\tc0,0.125,0.906,0.156,1.188,0.344c-0.812-0.906,0.25-1.75,0.875-2.219c0.797,0.625,1.359-0.594,1.359,1.125\r\n\t\tc0.766,0,1.188-0.094,1.188,1.156c0.469-0.562,2.406-1.188,2.406-1.156c0.297,0.594,2.422,2.531,1.266,2.531\r\n\t\tc0.031,0.219,0.688,0.781,0.531,1.125c-0.156,0.312-0.719,0.062-0.719,0.469c-0.75,0-1.547,0.469-2.062,1\r\n\t\tc-0.141,0.156-0.188,1.469-0.875,1.469c0,0.344-1.922,1.25-1.922,1.25c0.766,0,2.984-0.688,2.859-1.438\r\n\t\tc0.188,0.094,0.344,0.219,0.5,0.312c-0.219-0.406-0.297-0.906,0.031-1.438c0.453,0.031,0.141,0.062,0.594-0.031\r\n\t\tc-0.094,0.969,1.031,1.344,0.953,0.156c0.109,0.438,0.312,0.906,0.422,1.281c-0.281-1.781,2.812-1.75,2.969-0.594\r\n\t\tc-0.25,0,2.156,1.344,2.156,1.031c0.578,0,0.719,9.219,1.422,9.094c-0.109-0.125-0.172,8.844-0.141,8.844c0.109,0,0.25,0,0.359,0\r\n\t\tc0,0-0.391-9.5-0.609-9.484c0,0.125,0.031-4.359,0.141-4.297c-0.328,0.062-1.547-3.906,0.516-4.062\r\n\t\tc0.125,0.812,0.859-0.938,0.812-0.094c0,0.375-0.75,0.188-1.078,0.5c0.172,0,0.328-0.328,0.516-0.344\r\n\t\tc-0.047,0.203-0.031,0.344-0.203,0.344c0.172,0.094,0.328,0.109,0.484,0.203c-0.062-0.547,0.125-0.203,0.406-0.516\r\n\t\tc0,0.281-0.062,0.531-0.047,0.625c0.578,0,0.516,0.531,0.75,0.891c0.141,0,0.109-1.016,0.094-1.172\r\n\t\tc0.234,0.281,0.828,1.094,1.062,1.062c-0.109-0.219-0.109-0.344,0.047-0.344c0,0.031-0.094,0.812-0.094,0.812\r\n\t\tc0.094-0.031,0.188-0.125,0.281-0.188c0.328,0.688,0.844,0.688,1.312,0.688c0,0.312-0.25,0.781,0.188,0.781\r\n\t\tc0.234-0.438,0.281-2.812,0.625-2.812c0.141,0.469,0.25,0.625,0.25,1.125c0.078-0.031,0.969-0.438,0.766-0.781\r\n\t\tc0.281,0,0.953,0.438,1.141,0.375c0.672,0.062,1.125,0.719,1.281-0.531c0.406,1.469,0.297-0.531,0.344-0.688\r\n\t\tc0.188-0.688-0.25-0.875,0.547-1.219c-0.109-0.125-0.234-0.156-0.359-0.281c0.75-0.156,2.531,0.188,3,0.5\r\n\t\tc-0.312,0.062-0.5,0.219-0.562-0.062c-0.109,0.188-0.109,0.406,0,0.656c0.531-0.156,0.719-0.344,1.266-0.406\r\n\t\tc-0.047,0.312-0.094,0.438-0.203,0.719c-0.078-0.25,0.094-0.312,0-0.531c-0.344,0-0.469,1.25-0.469,1.406\r\n\t\tc1.172-0.188,0.391-1.312,0.938-1.781C351.047,236.875,352.172,237,351.75,238.094z M361.922,254.156\r\n\t\tc0.016,0.188-0.172,0.969-0.109,1.156c-0.125,0.031-0.156,0.25-0.172,0.406C361.641,255.156,361.5,254.719,361.922,254.156z\r\n\t\t M347.031,264.188c-0.469,0.062-1.031-0.281-0.281-0.5C346.828,263.844,346.938,264,347.031,264.188z M243.281,270.031\r\n\t\tc-0.844,0.469-0.828,0.031-0.641-0.562c0.359,0.125-0.062-0.156,0.5,0C242.859,270.031,243.172,269.688,243.281,270.031z\r\n\t\t M247.953,269.656c0.625,1,0,2.281-0.969,2.625c0.062-0.312-0.094-1.469-0.062-2.094\r\n\t\tC247.109,269.875,247.578,269.719,247.953,269.656z M247.547,268.844c0.156-0.438,0.453-1.625,1.172-1.312\r\n\t\tc0,0.875-0.25,1.312-0.719,2C247.859,269.281,247.656,269.062,247.547,268.844z M249.266,274.531\r\n\t\tc0.156-0.656,1.594,0.312,2.406,0.188c-0.312,0.469-0.594,1-0.75,1.469c-0.219-0.125-0.25-0.281-0.406-0.281\r\n\t\tC250.297,275.594,249.203,274.844,249.266,274.531z M255.891,275.938c0.047-0.281,0.188-0.031,0.281,0.094\r\n\t\tC256.078,276.406,256,276,255.891,275.938z M257.438,279.875c0.109-0.344,0.422-0.031,0.484-0.031\r\n\t\tc0.375,0.344,1.766,0.531,1.656,0.969C258.703,280.906,258.297,280.531,257.438,279.875z M264.328,282.031\r\n\t\tc0.188,0,1.125-0.125,0.75-0.156c0.641,0.094,0.938,0.188,1.438-0.156C266.281,282.406,264.703,283.094,264.328,282.031z\r\n\t\t M260.781,275.938c0.578,0.094,0.047,0.094,0.391,0.25c-0.203,0-0.094,0.312-0.375,0.219\r\n\t\tC260.953,275.844,260.75,276.312,260.781,275.938z M255.797,253.156c-0.328,0.281-0.188-0.188-0.438,0.375\r\n\t\tc-0.062-0.031-0.156-0.062-0.25-0.094c0.109-0.594-0.031-0.219-0.438-0.281c0.266-0.625,0.156-0.406-0.031-0.875\r\n\t\tc0.469,0.156,0.312-0.125,0.688-0.125c-0.156,0.188-0.141,0.312,0.031,0.344c0-0.188,0.094-0.188,0.219-0.125\r\n\t\tc0.156-0.5,0.125-0.188,0.469-0.5c-0.25,0.562,0.016,0.531-0.406,0.844C255.688,252.875,255.75,253.031,255.797,253.156z\r\n\t\t M255.797,253.656c-0.156,0.375-0.781,0.531-1.25,0.5c-0.031-0.25,0-0.5,0.031-0.688\r\n\t\tC255.109,253.844,255.234,253.562,255.797,253.656z M257.453,253.469c0.125,0.188,0.266,0.406,0.375,0.625\r\n\t\tc-0.094,0-0.203,0.062-0.312,0.094C257.484,253.906,257.453,253.688,257.453,253.469z M260.797,252.406\r\n\t\tc-0.219-0.625,0.375-1.438,1.078-1.219c-0.484,0.281-0.375,0.625-0.531,0.875C261.141,252.156,260.984,252.312,260.797,252.406z\r\n\t\t M262.828,247.938c0.469-0.031,0.25-0.219,0.312-0.438c0.281,0.031,0.297,0.344,0.219,0.719\r\n\t\tC263.156,248.219,263.016,248.031,262.828,247.938z M263.891,251.094c0.203-0.594,0.781-0.469,1.297-0.156\r\n\t\tc-0.234,0.125-1.172,0.875-1.328,0.844c-0.031-0.312,0.031-0.406,0.234-0.312C264.031,251.344,263.953,251.219,263.891,251.094z\r\n\t\t M264.484,250.062c0.031-0.156,0.422-0.219,0.562-0.188c0,0.094,0.031,0.219,0.031,0.344c-0.188-0.062-0.234,0.094-0.406,0.25\r\n\t\tC264.688,250.25,264.641,250.094,264.484,250.062z M265.359,248.625c0.062-0.281,0.094-0.062,0.125-0.469\r\n\t\tc0.156,0.031,0.281,0.062,0.406,0.094c-0.031,0.156-0.094,0.344-0.109,0.469C265.641,248.688,265.5,248.656,265.359,248.625z\r\n\t\t M329.5,236.031c0.062-0.281,0.359-0.531,0.328-0.656C330.188,235.375,329.688,235.969,329.5,236.031z M350.938,231.844\r\n\t\tc-0.094,0.031-0.844,0.312-1.156,0.375c0,0.125-1.203-1.031-0.562-1.031C349.859,231.062,351.812,231.562,350.938,231.844z\r\n\t\t M346.578,235.906c-0.391-0.062-0.266-0.312-0.672-0.25c-0.031-0.156,0.5-0.875,0.469-1.031c0.969-0.656,1.406,0.5,1.625,1.219\r\n\t\tC347.688,235.875,346.5,235.625,346.578,235.906z M347.406,233c-0.234-0.594-0.344-1.219-0.25-1.25\r\n\t\tC348.016,231.594,348.156,232.312,347.406,233z"},"children":[{"name":"path","attribs":{"d":"M256.016,127.992C185.297,127.992,128,185.297,128,256c0,70.688,57.297,128,128.016,128C326.688,384,384,326.688,384,256\r\n\t\tC384,185.297,326.688,127.992,256.016,127.992z M344.438,231.344c0,0.094,2.344,2.688,0.531,3\r\n\t\tc-0.844,0.156-0.906-1.906-0.969-2.312C344.219,232.031,344.328,231.562,344.438,231.344z M339.781,237.375\r\n\t\tc-0.031,0.031-0.484,0.688-0.484,0.062C339.438,237.406,339.625,237.406,339.781,237.375z M339.031,238.125\r\n\t\tc0.062,0.188,0.328,0.219,0.406,0.438c-0.438,0-0.281,0-0.594-0.094C338.906,238.344,338.969,238.25,339.031,238.125z\r\n\t\t M338.031,237.875c-0.375,0,0.031-0.25-0.359,0.031c-0.141-0.25-0.016-0.094-0.016-0.312c-0.062-0.188,0-0.25,0.188-0.188\r\n\t\tC337.906,237.562,337.969,237.719,338.031,237.875z M322.5,226.469c0.25,0,0.469,0.062,0.469,0.656\r\n\t\tc0.125-0.125,0.25-0.094,0.188-0.312c0.156,0.219,1.25,0.719,1.281,0.938c0,0.75-0.906,0.656-0.906,1.125\r\n\t\tc-0.156-0.031-0.812-0.094-0.812-0.344c-0.359,0-0.438,0.625-1.156,0.625c0-0.094,0.516-1.062,0.656-1.25\r\n\t\tC322.453,227.906,322.5,226.781,322.5,226.469z M318.344,224.906c-0.188-0.656,1.125-1.75,1.125-1.062\r\n\t\tc0.594,0.25,1.594,1.562,0.594,1.938c1.156,0.094,0.844-0.219,0.844,0.781c0.562,0,0.281-0.156,0.5-0.594\r\n\t\tc0.375,0,0.625,1.969-0.781,1.406c0,0.625-1.859-0.406-1.75-0.062c-0.141-0.125-0.188-0.281-0.141-0.469\r\n\t\tc-0.219,0.031-0.266,0.125-0.547,0.125c0-0.094,0-0.188,0-0.312c0.188,0,1.531-0.969,1.531-1.031\r\n\t\tc-0.438-0.031-0.922-0.125-0.922,0.281c-0.25-0.156-1.328-0.562-1.328-0.719C317.969,225.188,317.781,224.906,318.344,224.906z\r\n\t\t M320,231.812c0.312,0.25,0.062,0.219-0.641-0.031c0.109-0.031,0.25-0.094,0.391-0.156\r\n\t\tC319.688,231.844,319.781,231.875,320,231.812z M317.375,225.656c0,0.344,0.438,0.781,0.688,1c-1.25-0.188-1.312,0.156-1.312-1.031\r\n\t\tC316.938,225.656,317.172,225.656,317.375,225.656z M316.234,223.25c0.422,0.062,0.016,0.156,0.453,0.156\r\n\t\tc-0.156,0.156-0.219,0.094-0.219,0.312C315.938,223.719,316.234,223.25,316.234,223.25z M308.766,236.156\r\n\t\tc-0.016,0.125,0.094,0.438,0.094,0.656c-0.312-0.031-0.359-0.156-0.578-0.375C308.438,236.344,308.594,236.25,308.766,236.156z\r\n\t\t M308.156,237.062c-0.094,0.25-0.906,1.281-0.781,0.375C307.641,237.219,307.75,237,308.156,237.062z M302.922,235.312\r\n\t\tc0.094-0.125,0.203-0.281,0.297-0.438c0.234,0.625,0.125,0.594-0.344,0.938C302.656,235.531,302.922,235.594,302.922,235.312z\r\n\t\t M299.375,221.625c0.453,0.094,1.531-0.594,1.531,0.25c-0.375-0.031-1.562,1.469-1.562,0.062\r\n\t\tC299.547,222.062,299.406,221.719,299.375,221.625z M297.75,221.531c0.562-0.062,0.844,0.281,0.844,0.906\r\n\t\tc-0.438-0.031-0.25,0.125-0.703-0.094c0.031,0.25,0.047,0.531,0.062,0.812c-0.312-0.031-0.547-0.031-0.875-0.125\r\n\t\tC296.906,222.375,297.141,221.875,297.75,221.531z M296.859,218.406c0.172,0,0.203,0,0.203,0.188\r\n\t\tc-0.188-0.031-0.375-0.031-0.562-0.094C296.609,218.469,296.75,218.438,296.859,218.406z M295.562,220.875\r\n\t\tc-0.5-0.312-0.562-0.344-0.734-0.781c0.375-0.156,0.391,0.344,0.484-0.219c0.219,0.188,0.5,0.281,0.75,0.438\r\n\t\tc-0.078,0.094-0.156,0.188-0.219,0.281c-0.25-0.219-0.219-0.344-0.562-0.406c0.203,0.188,0.25,0.531,0.531,0.562\r\n\t\tC295.844,220.938,295.781,221,295.562,220.875z M295.625,222.438c0,0.281-0.094,0.344-0.062,0.656\r\n\t\tC294.75,223.094,294.656,222.344,295.625,222.438z M296.359,220.688c-0.141-0.062-0.172,0.406-0.312-0.062\r\n\t\tC296.156,220.531,296.656,220.094,296.359,220.688z M295.766,222.156C297.281,222.281,295.656,223.688,295.766,222.156\r\n\t\tL295.766,222.156z M296.828,223.281c0.031,0.219,0.062,0.406,0.062,0.656c-0.266-0.094-0.562-0.312-0.562-0.562\r\n\t\tC296.5,223.344,296.656,223.344,296.828,223.281z M296.016,218.75c0.031,0.188,0.203,0.094,0.203,0.312\r\n\t\tc-0.094,0.062-0.172,0.094-0.266,0.156C295.906,219.062,295.797,218.688,296.016,218.75z M295.281,218.938\r\n\t\tc0.156,0.062,0.312,0.125,0.453,0.219c0,0.656-1.172,0.125-0.922,0.188C294.906,218.875,295.281,219.562,295.281,218.938z\r\n\t\t M294.281,220.312c0.125,0.188,0.219,0.219,0.5,0.281c0,0.406-0.812,0.125-0.75-0.156\r\n\t\tC294.25,220.562,294.312,220.531,294.281,220.312z M292.438,221.906C294.047,222.062,292.438,222.719,292.438,221.906\r\n\t\tL292.438,221.906z M292.422,232.125c0.078-0.594,0.203-0.75,0.812-0.5c-0.234-0.438-0.219-0.156,0.078-0.469\r\n\t\tc-0.188,0.031-0.219-0.094-0.094-0.312c0.578,0.062,3.328-0.344,3.531-0.906c0.062,0.219,0.188,0.281,0.469,0.25\r\n\t\tc0.109-0.938,1.016-0.406,1.016,0c0.859-0.25,1.266-0.438,2.047-0.656c0.312-0.062,0.594-0.375,1.156-0.312\r\n\t\tc0.188,0.188,0.359,1.281-0.219,1.062c-0.203,0.75-2.109,0.5-2.641,0.719c-1.047,0.469-1.531,0.219-2.562,0.938\r\n\t\tc0-0.5-0.781,0.219-1.016,0.156c-0.109,0.5-0.172,0.5-0.672,0.875c0.062-0.188,0.109-0.375-0.078-0.375\r\n\t\tc-0.094,1.094-0.219,0.281-0.25,0.938c-0.172-0.062-0.344-0.156-0.484-0.25c-0.062,0.812-0.391,0.875-0.797,0.344\r\n\t\tc-0.156,0.406-0.438-0.062-0.688-0.094c0,0.312,0.906,0.625,1.203,1c-0.953,0.656-0.984,3.688,0.5,3.844\r\n\t\tc-0.141,0.531-0.609-0.125-0.891-0.156c-0.094,0.656,0.141,0,0.031,0.625c-0.203,0-0.094-0.156-0.094-0.312\r\n\t\tc-1.125-0.156-1.219,0.094-2.219-0.25c0-0.375,0.406-0.719,0.734-0.688c0.078-0.781-0.641-0.062-0.344-1.188\r\n\t\tc-0.188,0-0.5,0.094-0.672,0.188c-0.031-0.094-0.047-0.219-0.062-0.312c-0.188,0.25-0.25,0.406-0.641,0.375\r\n\t\tc-0.078-0.469-0.031-0.875,0.25-1.281c0.375,0.281,0.281,0.094,0.484,0.25c0-0.531,0.406-0.812,0.406-1.031\r\n\t\tc0.125-0.219-0.031-0.562,0.125-0.812c0.438,0.094,0.672,0.125,0.812-0.312c-0.094,0.031-0.188,0.062-0.312,0.094\r\n\t\tc0.094-0.094,0.625-0.938,0.625-0.688c-0.391-0.156-0.812,0.188-0.812-0.469c0.188,0,1-0.094,1-0.469\r\n\t\tC292.375,232.031,292.172,232.125,292.422,232.125z M295.625,240.438c-0.406,0-0.594-0.125-0.797-0.156\r\n\t\tc-0.328-0.156-0.109-0.438-0.547-0.219c0.125-0.312-0.031-0.656,0-0.969C294.906,239.125,295.281,240,295.625,240.438z\r\n\t\t M290.766,222.375c0-0.188,0.219-0.25,0.391-0.219c0.031,0.094,0.031,0.188,0.062,0.312\r\n\t\tC291.078,222.438,290.938,222.375,290.766,222.375z M291.609,222.375c0.359,0,0.422,0.219,0.141,0.688\r\n\t\tc-0.203-0.031-0.406-0.094-0.594-0.125C291.156,222.781,291.5,222.594,291.609,222.375z M291.547,220.938\r\n\t\tc-0.047,0.156-0.109,0.281-0.203,0.438c0.156-0.062,0.281-0.156,0.438-0.25c0.125,1.094-1.469,0.562-2.375,1\r\n\t\tc0.125-0.375-0.062-0.312-0.406-0.406c0.062-0.25,0.188-0.25,0.328-0.406c-0.297,0.062-0.422,0-0.328-0.25\r\n\t\tc0.562-0.031,0.75,0.5,1.281,0.406c0.438-0.031,0.906-0.562,0.812-0.594C291.297,220.875,291.156,221.125,291.547,220.938z\r\n\t\t M287.812,220.188c0.359,0,2.859,0.125,2.641,1c-0.625-0.125-1.172-0.281-1.766-0.469c-0.281,0.594-0.594,0.625-0.969,0.094\r\n\t\tc0,0.156-0.5,0.156-0.75,0.344c0.25-0.344-0.719-0.344-0.719-0.625C286.719,220.156,287.109,220.094,287.812,220.188z\r\n\t\t M288.062,239.469c-0.109,0.5-0.406,0.656-0.469,1.062C286.828,240.344,287.047,239.156,288.062,239.469z M277.719,221.75\r\n\t\tc-0.312-0.094-0.891-0.219-0.781-0.531C277.094,221.25,277.922,221.5,277.719,221.75z M271.766,217.562\r\n\t\tc0.234-1,0.297,0.031,0.562-0.469c-0.547-0.156,0.172-0.375,0.234-0.469c0.172,0.656,0.906,0.844,0.953,1.25\r\n\t\tc0.109,0.844,0.812,0.125,1.031,0.156c-0.078,0.156-0.156,0.281,0.047,0.312c0.359-1.25,0.297-0.062,0.062,0.188\r\n\t\tc0.438,0.094,0.688-0.125,1.031-0.375c0,0.188-0.125,0.281-0.234,0.406c0.203-0.094,0.25,0.031,0.312-0.219\r\n\t\tc0.297,0.094,0.312,0.594,0.922,0.719c-0.125,0.406-0.453,0.656-0.875,0.594c-0.156,0.188-0.125,0.312,0.062,0.312\r\n\t\tc-0.312,0.031-0.594,0.094-0.906,0.094c-0.312,0.969-3.672-0.656-3.516-1.469c0.469,0.312,0.938,0.094,1.266,0.219\r\n\t\tc-0.297-0.219-1.266-0.25-1.469-0.406c-0.734-0.156,0.203-0.656,0.234-0.781c-0.266-0.031-0.547-0.312-0.453-0.594\r\n\t\tC271.234,217.25,271.562,217.5,271.766,217.562z M276.031,221.812c-0.312-0.156-0.281-0.094-0.281-0.438\r\n\t\tC276.266,221.5,275.812,221.5,276.031,221.812z M272.125,223.219c-0.047,0.156-0.672-0.344-1.234-0.219\r\n\t\tc0.078-0.344,0.172-0.75,0.281-1.062c1.422-0.25,1.391,0.781,2.359,0.969C273.375,223.5,272.734,223.375,272.125,223.219z\r\n\t\t M272.25,233.094c-0.156,0.312-0.328-0.094-0.547-0.156c0.109-0.219,0.172,0,0.203-0.281\r\n\t\tC272,232.812,272.094,233.062,272.25,233.094z M270.828,220.875c0.062,0.031,1.906,0.031,1.203,0.562\r\n\t\tC271.484,221.906,271.062,221.688,270.828,220.875z M266.5,218.625c0.031-0.625,0.453-1.188,0.031-1.312\r\n\t\tc0.141-0.219,0.25-0.438,0.375-0.688c0.141,0,0.25,0.375,0.438-0.062c0.234,0.125,0.328,0.312,0.641,0.406\r\n\t\tc-0.094,0.281-0.312,0.062-0.547,0.125c-0.078,0.281,0.297,0.219,0.188,0.562c0.094,0,0.172,0.031,0.234,0.062\r\n\t\tc0.469-1.5,0.109-0.062,0.594-0.625c0,0.5,0.188,0.781,0.25,1.219c0.188-0.688,0.422-1.062,0.953-1.5\r\n\t\tc0.266,0.125,0.234,0.469,0.234,0.688c0.219,0.094,0.234-0.188,0.406-0.188c-0.109,0.562,0.312,0.812,0.109,1.5\r\n\t\tc0.172,0.031,0.672,1.188,1.016,1.75c-1.188-0.344-1.062,0.438-1.203,1.094c-0.266-0.062-1.859,1.156-1.703,0.844\r\n\t\tc-0.125,0.219-0.344,0.188-0.328,0.719c-0.359-0.094-0.391,0.062-0.562,0.031c0.047-0.281,0.094-0.562,0.109-0.812\r\n\t\tc-0.5-0.125-1.531-0.531-1.172-1.5c0.391,0.281,0.516,0.312,0.984,0.438c0.078-0.25,0.469-0.75,0.453-0.656\r\n\t\tc-0.453-0.156-1.234-0.125-1.406-0.281c0.484-1.594,2.156,0.719,2.609-0.344c-0.5-0.219-0.359-0.125-0.719-0.562\r\n\t\tc-0.312,0.688-0.344-0.469-0.344-0.594c-0.156,0-0.344,0.219-0.234-0.062c-0.359,0.5-0.844,0.594-1.453,0.375\r\n\t\tC266.484,219.125,266.766,218.656,266.5,218.625z M268.953,232.844c0.094-0.531,0.469-0.5,1.031-0.531\r\n\t\tc-0.125,0.188-0.375,0.375-0.578,0.344C269.375,232.844,269.125,232.875,268.953,232.844z M270.297,233.062\r\n\t\tc-0.141,0.188-0.25,0.375-0.406,0.531c0.047-0.188,0-0.344-0.156-0.5C270.172,233.156,269.484,232.875,270.297,233.062z\r\n\t\t M267.234,233.031c-0.125,0.156-0.219,0.281-0.312,0.438c-0.094-0.094-0.219-0.188-0.328-0.25\r\n\t\tC266.875,232.656,266.922,233.031,267.234,233.031z M266.703,233.406c-0.141,0.312-0.188,0.438-0.531,0.312\r\n\t\tc0.031-0.156,0.078-0.281,0.109-0.438C266.422,233.312,266.547,233.375,266.703,233.406z M266.172,217.688\r\n\t\tc0.062,0.031,0.078,1.062,0.078,1.344C265.891,218.969,266.078,218,266.172,217.688z M264.234,234.5\r\n\t\tc-0.031,0.156-0.094,0.312-0.141,0.469c0.047,0.031,0.359-0.125,0.453-0.188c-0.062,0.656-1.125,1.219-0.969,0.531\r\n\t\tc-0.062,0.031-0.125,0.094-0.188,0.125C263.453,235.188,264.109,234.5,264.234,234.5z M263.188,235.188\r\n\t\tc-0.047,0.125-0.609,0.562-0.5,0.219C262.859,235.312,263.016,235.25,263.188,235.188z M262.453,235.312\r\n\t\tc0,0.125,0.031,0.25,0.031,0.344c-0.109-0.062-0.562,0.344-0.469-0.094C262.266,235.562,262.125,235.219,262.453,235.312z\r\n\t\t M231.297,196.539c0.062,0.688,0.781,1.375,0.5,1.906C231.453,197.727,230.922,197.18,231.297,196.539z M207.047,185.164\r\n\t\tc0.109-0.258,0.219-0.289,0.344-0.086c-0.109,0.312-0.344,0.703-0.531,0.977C206.844,185.805,207.031,185.156,207.047,185.164z\r\n\t\t M209.828,198.32c-0.812,1.125-1.219-0.25-1.406-0.438c-0.047,0.125-0.141,0.203-0.281,0.219c0.109-0.219,0.203-0.406,0.016-0.594\r\n\t\tc-0.641,0.844-1.672-0.844-1.719-1.062c-0.594,0.078-1.578-0.469-0.828-1.062c-0.656,0.422-1.406,0.125-1.812-0.375\r\n\t\tc0.656-0.625,2.406-2.391,1.438-3.156c-0.141,0.094-0.312,0.156-0.453,0.219c-0.297-0.656-0.453-2.523,0.547-1.594\r\n\t\tc0.062-0.094,2.375,3.812,0.844,2.719c-0.234,0.25,0.062,0.062-0.297,0.359c0.203,0.016,0.406,0.062,0.609,0.094\r\n\t\tc-0.062,0.109-0.156,0.172-0.281,0.172c0.25,0.188,0.5-0.125,0.156,0.312c0.031,0.031,0.656,0.312,0.281,0.656\r\n\t\tc0.25,0.156,0.125-0.094,0.375,0.281c0.203-0.266,2.375,0.938,3.078,1.438C209.984,196.633,211.328,198.977,209.828,198.32z\r\n\t\t M203.609,192.164c0.578-0.594,0.453,0.812,0.406,0.75c-0.156,0.609-0.844,0.844-1.125,1.156c-0.312-0.219-0.031-0.438-0.281-0.625\r\n\t\tC202.297,192.852,203.031,191.82,203.609,192.164z M202.828,191.945c0.469-0.5,0.188,0.016,0.625-0.094\r\n\t\tC203.344,191.961,203.094,192.133,202.828,191.945z M205.375,189.672c0.406-0.32,1.484,0.438,1.734,0.547\r\n\t\tc-0.203,0.125-0.156,0.234,0.125,0.32C206.141,191.164,206.125,190.266,205.375,189.672z M206.766,192.648\r\n\t\tc0.125-0.422,0.281-0.578,0.594-0.359c-0.094,0.172-0.203,0.375-0.312,0.531C206.953,192.758,206.875,192.711,206.766,192.648z\r\n\t\t M205.516,188.328c0.219,0.148,0.172,0.227,0.375,0.086c-0.75-0.438-0.172-1.023,0.469-1.266c0.125,0.414,0.438,1.062,0.094,1.344\r\n\t\tc0.734,1.141-0.719,0.852-1.141,0.492C205.516,188.766,205.422,188.492,205.516,188.328z M203.094,185.102\r\n\t\tc0.109-0.047,0.203-0.109,0.312-0.156c-0.141-0.125-0.203,0.047-0.328-0.094c0.891-0.906,0.203-0.094,0.062-0.32\r\n\t\tc0.469-0.523,0.312-0.328,0.719-0.484c0,0.539,0.219,0.625,0.062,1.164c0.141-0.07,0.312-0.141,0.469-0.234\r\n\t\tc-0.031,0.344,0.156,0.25-0.125,0.555c0.781,0.188,1.25,2.516-0.156,2.875c-0.094-0.664,0-2.836-0.5-2.195\r\n\t\tc-0.109-0.047-0.484-0.32-0.594-0.578c-0.016,0.062-0.031,0.102,0.125-0.031c-0.406-0.344,0.156-0.156,0.25-0.242\r\n\t\tc-0.125-0.062-0.094-0.125,0.031-0.18C203.219,184.961,203.391,185.422,203.094,185.102z M203.766,187.445\r\n\t\tc0.094,0-0.781,0.258-0.172-0.352C203.828,187.312,203.641,187.375,203.766,187.445z M202.859,189.461\r\n\t\tc0.094-0.367-0.062-0.641,0.562-0.617c-0.219,0.398-0.5,0.625-0.156,0.93c0.141-0.18,0.188-0.336,0.344-0.555\r\n\t\tc0.547,0.562-1,2.414-1.188,3.023c-0.188-0.359-0.203,0.078-0.266,0.172c-0.625-0.25-1.031-0.656-1.516-1.078\r\n\t\tc0.422-0.516,0.875-0.359,1.047-0.57c-0.422-0.242-1.141-0.297-1.391-0.578c0.219-0.25,0.469-0.359,0.625-0.516\r\n\t\tc0.125,0.109,0.297,0.266,0.438,0.391c0.188-0.633,0.344-1.258,1.031-1.258c-0.062,0.578-0.406,1.211-0.562,1.633\r\n\t\tc0.312-0.297,0.453-0.883,0.75-1.266C202.672,189.266,202.766,189.367,202.859,189.461z M201.734,192.695\r\n\t\tc-0.188,0.281-0.109-0.094-0.281,0.156C201.266,192.727,201.641,192.727,201.734,192.695z M199.625,194.711\r\n\t\tc0.344,0.266,0.156-0.109,0.453-0.047c-0.234,0.25-0.266,0.469-0.453,0.688c0.172,0,0.344,0,0.531,0\r\n\t\tc-0.328,1.062-1.984,1.812-2.953,1.094c0.625-0.781,0.281-1.297,0.375-2.234c-0.188,0.016-0.312,0.125-0.406,0.328\r\n\t\tc-0.156-0.75,0.156-1.047,0.516-1.734c0.453,0.469-0.172,0.797,0.766,1.328c0.781-0.625-0.312-1.625,1.297-1.656\r\n\t\tc-0.266,0.344,0.078,0.375,0.078,0.719c0.125-0.188,0-0.281,0.234-0.438c0.531,0.469,0.641-0.172,1.016,0.234\r\n\t\tc-0.281,0.328-1.094,0.094-0.844,0.359C201.609,193.68,199.969,194.289,199.625,194.711z M196.422,200.875\r\n\t\tc-0.531-0.25-0.438,0.031-0.781-0.469c-0.328,0.5-0.125,0.156-0.469,0.281c0.188-0.344-0.031-0.062-0.156-0.156\r\n\t\tc0.234-0.25,0.078-0.469,0.156-0.711c0.078,0.125,0.172,0.094,0.266-0.172c-0.203-0.156-0.234-0.141-0.359,0.109\r\n\t\tc-0.219-0.219-0.188-0.062,0.031-0.391c-0.094,0-0.172-0.016-0.25-0.016c0.219-0.438,0.609-0.656,1.125-0.75\r\n\t\tc0.188,0.172-0.094,0.094,0.062,0.266c0.312-0.312,0.125-0.203,0.453-0.234c0,0,0.156,1.219,0.359,1.312\r\n\t\tC196.594,200.281,196.078,200.594,196.422,200.875z M194.609,197.602c-0.719-0.562-0.25-0.281-0.531-0.844\r\n\t\tc-0.234,0.297-0.188,0.453-0.188,0.875c0.375,0.062,0.031-0.469,0.531,0.031c-0.5,0.625-0.891,0-1.281,0.406\r\n\t\tc-0.312-0.375-0.281-0.656-0.562-0.953c0.344-0.438,0.062-0.859,0.531-1.266c-0.625-0.531-1.844,0.25-2.25-0.344\r\n\t\tc-0.547,0.625-1.75-0.844-2.125-1.188c0.781,0.766-0.094-1.969-0.125-1.75c0.375-0.562,0.156-0.844,0.688-1.375\r\n\t\tc0.469,0.406,0.938,0.531,1.344,0.938c0.156,0.094,0.188,1.062,0.625,0.609c0.359,0.109,0.297-0.359,0.594-0.094\r\n\t\tc-0.188-0.5-1.375-1.859-2.156-2.195c0.344-0.391,0.656-0.773,1.016-0.133c0.328-0.281,0.453-0.219,0.766,0.141\r\n\t\tc0.281-0.344-0.406-0.648-0.625-0.445c-0.266-0.172-0.562-0.305-0.766-0.531c0.266-0.094-0.016-0.5,0.422-0.031\r\n\t\tc-0.125-0.203,0-0.281,0.156-0.328c-0.188-0.227-0.312-0.062-0.562-0.109c0.156-0.086,0.391-0.945,1.078-0.844\r\n\t\tc0.016,0.008,0.859-0.414,0.984-0.508c0.094,0.156,0.609,0.305,0.484,0.289c-0.031,0.047,0.641,0.164,0.922,0.031\r\n\t\tc1.094-0.422,0.062,1.055-0.016,0.914c-0.484,0.516-0.578,1.062-0.438,1.609c0.453-0.453,0.766-0.695,1.172-1.305\r\n\t\tc0.562,0.453-0.359,0.984,0.141,1.477c0.391-0.492,1.219-0.297,0.859,0.172c0.109,0.688-0.875,1.188-1.312,1.625\r\n\t\tc0.469-0.125,0.734-0.125,1.188-0.438c0.484,0.375,0.641,0.891,0.219,1.625c-0.234,0.469-1.031,2.859-0.188,1.906\r\n\t\tc-0.469,1.25,1.031,1.594-0.312,2.531c-0.016-0.312-0.031-0.531,0-0.844c-0.156-0.281-0.281-0.281-0.422,0.031\r\n\t\tC194.609,197.414,194.781,197.414,194.609,197.602z M194.453,198.977c-0.375-0.25,0.062-0.125-0.156-0.328\r\n\t\tC194.547,198.43,194.719,198.695,194.453,198.977z M192.422,197.617c-0.141,0.188-0.219,0.297-0.453,0.234\r\n\t\tc0.016-0.125,0.047-0.25,0.047-0.406C192.156,197.508,192.297,197.57,192.422,197.617z M194.672,184.203\r\n\t\tc0.281-0.336,0.938-0.477,1.312-0.461c-0.375,0.391-0.766,0.531-1.219,0.859C194.734,184.477,194.703,184.328,194.672,184.203z\r\n\t\t M195.703,192.508c-0.078,0.062-0.125-1.758,0.188-1.562c0.188-0.188,0.422-0.297,0.594-0.547\r\n\t\tC196.969,190.781,196,192.352,195.703,192.508z M196.297,196.523c-0.406,0.453-0.391,0.281-0.531,0.172\r\n\t\tC195.891,196.523,196.203,196.477,196.297,196.523z M196.797,187.789c-0.359-0.336-1.688,0.398-1.734-0.477\r\n\t\tc-0.094-1.078,1.312-0.109,1.438-0.016c0.234-0.219,0.547-0.172,0.828-0.297c-0.219-0.031-0.656-0.195-0.625-0.188\r\n\t\tc0.062-0.102,0.125-0.211,0.188-0.312c-0.219,0.195-0.172,0.039-0.156-0.133c-1.5,0.258,0.047-0.555-0.312-1.008\r\n\t\tc-0.219,0.219-0.781,1.086-1.094,0.734c0.109-0.094,0.25-0.211,0.344-0.336c-0.188-0.188-0.188-0.117-0.188-0.062\r\n\t\tc0-0.047-0.016-0.078-0.094-0.211c-0.062,0.117-0.375,0.016-0.469-0.031c0.422-0.398,0.062-0.492,1-0.367\r\n\t\tc-0.062-0.125-0.281-0.18-0.438-0.211c0.062-0.086,0.125-0.18,0.188-0.273c0.203,0.109,0.25,0.203,0.469,0.25\r\n\t\tc0.031-0.031,0.516-0.484,0.578-0.562c-0.328,0.344,0.297,0.133,0.453,0.234c-0.062,0.102-0.125,0.188-0.172,0.281\r\n\t\tc0.109-0.117,0.688,2.109,1.172,2.523c0.594-0.641,0.938-1.547,1.594-2.055c0.062,0.055-0.5,1.297-0.156,1.672\r\n\t\tc-0.281,0.289-0.266,0.32-0.562,0.547c-0.031-0.086,0.203,0.297,0.219,0.492c0.266-0.258,0.469-0.43,0.688-0.719\r\n\t\tc0.438,0.438-0.938,1.672-1.328,1.828C198.578,188.875,197.703,187.789,196.797,187.789z M202.438,186.047\r\n\t\tc-0.188,0.312-0.266,0.562-0.578,0.758C201.953,186.484,202.172,185.852,202.438,186.047z M201.359,188.734\r\n\t\tc0.094,0.102,0.188,0.188,0.281,0.266c-0.469,0.445-0.906,0.945-1.531,0.367c0.25-0.172,0.875-0.07,0.531-0.414\r\n\t\tc-0.312-0.32,0.312-0.164,0.531-0.141c-0.438-0.516-0.344-1.117,0.625-0.531C201.531,188.531,201.578,188.586,201.359,188.734z\r\n\t\t M201.766,188.023c-0.094-0.055-0.438-0.023-0.656-0.164c0.188-0.109,0.375-0.219,0.578-0.344\r\n\t\tC201.734,187.672,201.672,187.773,201.766,188.023z M200.703,183.289c0.188-0.148,0.344-0.398,0.531-0.148\r\n\t\tC201.609,182.789,202.156,184.453,200.703,183.289z M200.266,183.32c-0.016-0.523-0.281-0.555-0.406-0.875\r\n\t\tC200.734,182.359,201.344,182.906,200.266,183.32z M199.062,182.117c0.578,0.32,0.359,0.781-0.391,0.727\r\n\t\tC198.797,182.75,198.859,182.383,199.062,182.117z M199.859,183.594c0.656-0.102,0.703,0.18,1.094,0.609\r\n\t\tc-0.25-0.008-0.594,0.078-0.844,0.07c-0.188,0.812-0.641,0.711-1.25,0.477C197.984,184.383,199.297,182.688,199.859,183.594z\r\n\t\t M193.922,181.977c0.719-0.922,1.062-0.031,1.875-0.844c0.219,0.234,2.188,0.555,2.25,0.594c1.219,0.266,0.016,1.164-0.531,1.547\r\n\t\tc-0.047-0.203-0.062-0.398-0.094-0.578c-0.406,0.484-0.812,0.641-1.391,0.656c0.312-0.398,0.266-0.477,0.812-0.805\r\n\t\tc-0.297-0.273-1.109,0.195-1.484,0.562c0.047-0.125,0.125-0.391,0.062-0.43c-0.266,0.328-0.469,0.727-0.906,0.422\r\n\t\tc0.188-0.203,0.297-0.492,0.438-0.711c-0.406,0.422-0.688,0.438-1.125-0.086C193.875,182.25,194.016,182.055,193.922,181.977z\r\n\t\t M191.344,183.883c0.422-0.109,1.016,0.156,1.266,0.477c0.594-0.438,0.625,1.562,0.594,1.578c0-0.023,0.75,0.781,0.672,0.734\r\n\t\tc0.031,0.297-0.172,0.469-0.109,0.719c0.203,0.781-1.031-0.125-1.312,0.094c-0.406-0.32-1.109,0.352-1.312,0.031\r\n\t\tc-1.5,0.5-0.656,0.906-1.781,0.188c-0.453,0.508-1.422,0.219-0.922-0.344C188.578,186.516,190.672,184.047,191.344,183.883z\r\n\t\t M170.25,178.727c0.016-0.039-0.047-0.297,0.297-0.445c0.125,0.414,0,1.008-0.266,1.555c0-0.258-0.391,0.258-0.344,0.203\r\n\t\tC169.953,180.086,170.234,178.844,170.25,178.727z M167.594,183.414c0.078,0.32,0.156,0.391,0.328,0.164\r\n\t\tc-0.156,0.5-0.359,0.5-0.469,0.727C167.344,183.891,167.453,183.766,167.594,183.414z M162.984,190.219\r\n\t\tc0.438-0.391,0.344,0.039,0.297,0.398c-0.047-0.133-0.547-0.141-0.625-0.156C162.766,190.383,162.875,190.297,162.984,190.219z\r\n\t\t M161.766,190.344c0.156,0.172,0.234,0.234-0.375,0.438C161.562,190.773,161.578,190.594,161.766,190.344z M159,187.445\r\n\t\tc-0.297,0.281,0.109-0.344,0.156-0.438C159.109,187.164,159.047,187.305,159,187.445z M160.109,188.961\r\n\t\tc0-0.227-0.156,0.227-0.234,0.031C159.922,188.938,160.406,188.656,160.109,188.961z M174.328,327.594\r\n\t\tc0.141,0.188,0.344,0.406,0.344,0.656c-0.031-0.062-0.094-0.156-0.141-0.25c0.047,0.125,0.016,0.156-0.078,0\r\n\t\tc0.062,0.125,0.094,0.219,0.156,0.281c-0.219-0.156-0.266-0.188-0.172-0.031C174.25,328.188,173.859,327.406,174.328,327.594z\r\n\t\t M178.859,333.562c-0.125-0.438-0.406-0.625-0.719-0.781c0.188,0.281,0.312,0.281,0.438,0.594\r\n\t\tc-0.344-0.375-0.469-0.375-0.344-0.062c-0.25-0.188-0.5-0.438-0.688-0.656c0.125,0.094,0.125,0.094,0.062-0.031\r\n\t\tc0.125,0.125,0.281,0.188,0.469,0.188c-0.188-0.062-0.703-0.531-0.422-0.312c-0.203-0.156-0.578-0.531-0.828-0.656\r\n\t\tc0.25,0.156-0.234-0.219-0.344-0.375c0.125,0.062,0.312,0.156,0.469,0.219c-0.016-0.062-0.125-0.188-0.234-0.312\r\n\t\tc0.109,0.094,0.203,0.125,0.078-0.188c0.234,0.125,0.453,0.656,0.484,0.781c0.078,0,0.078-0.062,0.031-0.125\r\n\t\tc0.156,0.062,0.344,0.406,0.516,0.469c-0.344-0.375-0.5-0.688-0.75-1.031c0.156,0.156,0.234,0.062,0.375,0.188\r\n\t\tc-0.109-0.5-0.578-0.469-0.688-0.906c0.625,0.219,1.281,0.594,1.188,0.969c0.656,0.5,1.719,1.938,2.125,2.438\r\n\t\tC179.453,333.625,179.312,333.281,178.859,333.562z M180.516,334.094c0.094,0,0.109-0.062,0.062-0.125\r\n\t\tc0.188,0.125,0.344,0.438,0.391,0.469C180.797,334.344,180.547,334.312,180.516,334.094z M181.781,333.156\r\n\t\tc0.109,0.062,0.203,0.062,0.281,0c-0.047-0.156-0.172-0.156-0.078-0.406c0.141,0.25,0.344,0.438,0.641,0.5\r\n\t\tc-0.141,0.094-0.203,0.031-0.312,0.219C182.266,333.312,181.953,333.344,181.781,333.156z M183.219,334.125\r\n\t\tc-0.297-0.062-0.609-0.156-0.672-0.469c0.125,0,0.234,0,0.344-0.031c-0.031-0.062-0.094-0.156-0.141-0.25\r\n\t\tc0.328,0.125,0.453,0.156,0.672,0.469c0-0.25,0.453,0.281,0.234,0.219c-0.359-0.188-0.172,0.125-0.625-0.281\r\n\t\tC183.078,333.906,183.141,334.031,183.219,334.125z M185.797,320.469c0.375,0.094,0.453,0.188,0.234,0.25\r\n\t\tC185.812,320.562,185.797,320.906,185.797,320.469z M200.062,242.125c-0.234-0.156-0.328-0.031-0.328,0.344\r\n\t\tc-1.047-0.5,0.344-0.688,0.391-0.875c0.078,0.219,0.203,0.281,0.109,0.469C199.672,241.594,200.156,242.031,200.062,242.125z\r\n\t\t M200.031,240.812c-0.203,0.375-0.766,0.719-1.109,1.406c-0.875-0.5,0.906-1.5,1-1.875c0.156,0.156,0.438,0.25,0.609,0.375\r\n\t\tC200.484,241.094,200.297,241.125,200.031,240.812z M199.234,235.438c0.453,0.438,0.781,0.969,0.938,1.5\r\n\t\tc-0.094,0.219,0.281,0.375,0.094,0.781C199.672,237.469,199.016,235.938,199.234,235.438z M203.609,242.469\r\n\t\tc0.062-0.156,0.094-0.312,0.094-0.5C204.141,242.281,203.766,242.156,203.609,242.469z M206.266,242.469\r\n\t\tc0.094,0.062-0.188,1.031-0.906,1c0.266-0.469,0.062-0.281,0.156-0.688c-0.188,0.156-0.281,0.438-0.453,0.344\r\n\t\tc0.297-0.562,0.266-0.562,0.453-1.031c-0.266-0.156-0.719,0.25-0.75,0.281c-0.219-0.062-0.375,0-0.656,0.031\r\n\t\tc0.359-0.219,0.562-0.438,0.906-0.594c-0.188-0.125-0.375-0.031-0.625,0c0.125-0.219-1.812-1.781-2.719-1.562\r\n\t\tc0.094-0.156-0.047-0.312-0.031-0.562c0.375,0.219,0.688-0.312,0.969-0.375c-0.438-0.281-0.375-0.188-0.234-0.531\r\n\t\tc0.422,0.281,0.078,0.125,0.297,0.375c0-0.125,0-0.25,0.016-0.375c0.109,0.125,0.172,0.094,0.188-0.094\r\n\t\tc0.109,0.156,0.203,0.25,0.328,0.375c0.188-0.938,1.406-2.875,2.609-2.219c-0.344,0.562-1.312,1.312-1.688,1.844\r\n\t\tc0.078,0.031,1.422-0.312,0.438,0.406c0.297,0.188,0.234,0.438,0.469,0.656c0.219-0.406,0.203,0.031,0.719-0.156\r\n\t\tc-0.047,0.125-0.109,0.188-0.266,0.219c0.531,0.312,0.547-0.344,0.688,0.188c0.047,0.25-0.281,0.688-0.531,0.469\r\n\t\tc0.031,0.438,0.281,0.5,0.031,0.906c0.344-0.031,0.469,0.031,0.812-0.062c-0.266,0.5-1.312,1-0.562,1.312\r\n\t\tc0.281-0.312,0.422-0.312,0.672-0.531C206.484,242.219,206.375,242.344,206.266,242.469z M206.453,235.156\r\n\t\tc0.766,0.781-2.719,1.188-2.375,0.719c-0.75,0.188-1.641,1.5-2.5,0.375c-0.062,0.156-1.469-0.5-2.188-1.125\r\n\t\tc0.281-0.594-2.75-0.719-3.156,0.125c-0.531-0.438-0.906,0.531-1.406,0.062c-0.125,0.188-0.062,0.281,0.156,0.312\r\n\t\tc-0.438,0.281-0.875,0.562-1.094,1c1-0.812,5.531-2.188,4.938,0.25c-0.062-0.094-0.125-0.188-0.172-0.312\r\n\t\tc-0.141,0.312-0.125,0.469-0.234,0.812c-0.062-0.062-0.25-0.156-0.359-0.219c-0.328,0.781-0.672,0.438-0.672-0.188\r\n\t\tc-0.062,0.156-0.188,0.188-0.344,0.125c-0.125,0.344,0,0.281-0.094,0.5c0.25,0.188,0.531,0.344,0.859,0.406\r\n\t\tc-0.047,0.125-0.297,0.656-0.344,0.688c-0.078-0.094-0.172-0.094-0.297,0c0.125,0.062,0.234,0.156,0.344,0.219\r\n\t\tc-0.219,0.594-0.906,1.188,0.125,1.375c-0.047,0.125-0.094,0.25-0.156,0.344c-0.406-0.312-0.125-0.094-0.344,0.125\r\n\t\tc0.578,0.281,0.453,1.125,1.562,0.594c-0.062,0.281-0.156,0.688-0.203,0.781c-0.125-0.062-1.922,0.469-1.891,0.375\r\n\t\tc-0.031-0.125-0.062-0.281-0.109-0.406c-0.266,0.406-0.672,0.531-1.328,0.875c0.062-0.125,0.125-0.312,0.125-0.312\r\n\t\tc-0.172-0.188-0.203,0.094-0.375,0.156c-0.906-1.562,1.344-2.188,1.656-1.281c0.281-0.375,0.625-0.031,0.781-0.281\r\n\t\tc-0.344-0.094-0.703-0.281-1.031-0.406c0.125-0.312,0.25-0.625,0.531-0.469c0.062-0.25-0.094-0.281-0.25-0.5\r\n\t\tc-0.281,0.281-0.688,0.469-0.953,0.75c0.109-0.156,0.109-0.25,0.219-0.469c-0.156-0.156-0.859,0.031-0.359,0.375\r\n\t\tc-0.469-0.188-0.297,0.156-0.812-0.531c-0.188,0.875-0.578,0.531-0.781,1.031c-0.078-0.156-0.156-0.344-0.219-0.5\r\n\t\tc-0.062,0.094-0.094,0.188-0.141,0.281c-0.203-0.156-0.047-0.219-0.094-0.469c-0.297,0.75-0.875,0.531-1.109,0.094\r\n\t\tc-0.672,0.625-1.688,1.031-1.125,2.094c-0.281-0.156-0.281-0.062-0.531-0.125c0.078-0.281,0.281-0.25-0.109-0.438\r\n\t\tc-0.078,0.156-0.141,0.156-0.203,0.406c-0.719-0.469-1.422-0.594-2.031-0.156c-0.047,0.125-1.078,2.531-1.594,0.844\r\n\t\tc-0.125,0.719-0.5,1.406-0.656,1.812c-1.75-0.531,0.344-1.688,0.562-2.281c-0.109-0.062-0.406,0.094-0.812-0.188\r\n\t\tc-0.094,0.312-0.656,1.5-0.906,1.312c0.125,0.625,0.125,0.719,0,1.375c-0.938-0.688,0,0.688,0,0.75\r\n\t\tc-0.125,0.406-0.594,0.25-0.719,0.625c0.281,0.219,0.219,0.562,0.344,0.625c-0.125,0.031-0.266,0.094-0.391,0.125\r\n\t\tc0.203-0.219-0.125-0.469-0.328-0.625c-0.062,0.281,0.031,0.375,0.062,0.625c-0.344-0.125-0.016,0.25-0.406-0.094\r\n\t\tc-0.094,0.812-1.219,1.156-1.781,0.656c-0.172,0.281-3.719,1.688-2.703,2.688c-0.359,1.031-0.109,1.875-0.453,2.688\r\n\t\tc-0.391,1.062-0.625,1.656-0.984,2.719c-0.672-0.406-0.422-3.25,0.016-3.594c-0.25-0.219-0.219-0.062-0.438,0.062\r\n\t\tc0.656-1.625,0.156-1.594,0.188-3.094c-0.906,0.375-1.219-1.406-1.5-1.906c-0.094,0.312-0.266,0-0.406,0.281\r\n\t\tc-0.281-0.188,0.156-0.5-0.156-0.656c-0.062,0.25-1.156-0.344-1.328-0.5c0.531,0.594,0.359,1.094,0.141,1.688\r\n\t\tc-0.125-0.062-0.312-1-0.422-1.312c-0.125,0.312-0.234,0.281-0.328,0.531c-0.594-0.438-0.391-0.312-0.25-0.812\r\n\t\tc-0.328-0.219-0.688-0.125-0.406-0.656c-0.344-0.031-0.688-0.312-0.922-0.75c-0.172,0.562-0.641-0.156-0.703-0.219\r\n\t\tc-0.125,0.344-5.172,0.281-5.422,0.594c0.094-0.125-5.656-0.062-5.656-0.219c0,0.156,0,0.281,0,0.406\r\n\t\tc0-0.844,2.562,4.375,1.938,5.469c-0.406,0.656,1.516,2.75,2.266,3.312c0.094,0.656,1.047,2,1.578,2.531\r\n\t\tc0.656,0.562,2.109,0.125,2.234,0.938c-0.047,0.125,1.875-1.062,1.734-1.156c0.734-0.594,0.828-1.062,1.891-0.625\r\n\t\tc1.469,0.625-0.781,2.75-0.828,3.875c-0.125-0.094-0.203-0.5-0.141-0.656c-0.328,0.375-0.344,1.094-0.516,1.625\r\n\t\tc-0.031-0.031-0.656,0.781-0.781,0.875c1.219,0.562,3.5,1.875,3.031,3.938c-0.406-0.344-1.25,2.594-1.25,3.312\r\n\t\tc0,0.656,0.609,2.531,0.688,2.312c0.203,0.5,1.234,1.062,1.391,0.469c0.844,0.656,0.656,2.875,1.375,3.219\r\n\t\tc0.125-0.438,0.484-1.188,0.906-0.906c0.062-0.438,0.406-1.75,1.047-0.875c0.797-0.906,3.688-0.031,1.75,0.438\r\n\t\tc0.516,0.344-0.297,1.531-0.266,1.844c0,0.5,0.672,0.719,0.625,0.312c-0.078-0.438-0.062-1.219,0.062-1.688\r\n\t\tc0.312,0.125,0.781,0.125,1.062,0.312c0.031-0.062-0.047-0.906-0.031-0.906c0.891,2.688,2.531,4.312,4.859,4.625\r\n\t\tc-0.125,0.281,0.078,0.438-0.484,0.031c0.047,0.688,0.25,0.844,0.719,1.312c0.062-0.312,0.328,0.188,0.125,0.562\r\n\t\tc-0.141,0.688-0.609-0.031-1.25,0.281c0.984,0.344,1.469,0.219,2.094,1.062c-0.016,0.219,0.328,0.594,0.359,0.906\r\n\t\tc0.078,0.75-0.297,0.562-0.438,1.25c0.172,0.031,0.391-0.25,0.219,0.281c0.094-0.219,0.203-0.438,0.297-0.656\r\n\t\tc0.375,0.344,0.938,0.781,0.797,1.625c-0.094-0.031,1.297,0.062,1.266,0.188c1.75,1.531,2.828,4.531,2.625,6.656\r\n\t\tc-0.156-0.031-0.297-0.062-0.438-0.094c0.219,0.312,0.078,0.312,0.031,0.562c0.141,0.031,0.344,0.031,0.438,0.062\r\n\t\tc-0.156,0.469-0.25,0.344-0.344,0.906c-0.766-0.375-0.297-0.312-0.281-0.75c-0.281-0.094-1.234,0.438-0.734,0.688\r\n\t\tc-0.484-0.094-1,1-0.453,1.469c0.312-1.219,0.734-0.812,0.844,0.156c-0.531-1.469,1.344-1.812,1.125-1.156\r\n\t\tc1,0.656,0.281,1.719-0.844,1.156c-0.031,0.156,0.625,0.562,0.75,0.688c0.062-0.312,0.406-0.281,0.609-0.125\r\n\t\tc0.031-0.25-0.141-0.188-0.203-0.438c1.156-0.531,2.219,1.031,2.031,1.656c0.031,0.031,0.453,0.031,0.594,0\r\n\t\tc-0.125,0.406-0.031,1.531,0.406,1.781c0.062-0.156,0.156-0.344,0.234-0.5c0.422,0.219,0.625,0.781,1.016,0.938\r\n\t\tc-0.031-0.062-0.094-0.125-0.125-0.219c1,0.562,3.484,2.531,3.25,4.062c2.031-0.031,1.219,3.281,1.156,4.062\r\n\t\tc-0.547,0.969-2.188,1.312-3.062,2.375c-0.156-0.156-0.266-0.312-0.406-0.469c-0.094,0.5-0.469,0.812-0.719,1.062\r\n\t\tc0.703,0.5-0.281,2.5-0.312,3.031c0.203,0.062-2.219,2.719-2.062,3.312c-0.484,0.375-1.219,0-1.25,0.125\r\n\t\tc-0.484-0.219-1.094-0.25-1.297-0.406c0.016,0.125,0.062,0.281,0.094,0.406c-0.797-0.312-0.562-0.031-1.188-0.312\r\n\t\tc-0.016,0.188-1.266,0.469-1.719,0.188c-0.031,0.344-0.141,2.844-0.297,2.781c0-0.062-1.469,1.625-1.406,1.656\r\n\t\tc0-0.438,0.719-0.531-0.109-1.156c-0.391,0.625-1.469,1.531-1.469,2.094c-0.016,0-1.094,0-1.516-0.312\r\n\t\tc-0.859-0.406-1.469-1.438-1.469-2.438c-0.344,1-0.062,1.562,0.516,2.375c0.812,1.156,0.109,1.344,0.109,2.25\r\n\t\tc-0.172-0.156-0.328-0.094-0.328,0.031c-0.359-0.312-2.109-0.75-2.156-0.75c-0.141-0.125-0.25-0.375-0.453-0.469\r\n\t\tc0.109,0.781,0.188,0.875,0.266,1.688c-0.234,0.125-0.344-0.375-0.297,0.156c-0.188-0.219-0.25-0.25-0.219-0.062\r\n\t\tc-0.312-0.344-0.625-0.688-0.938-0.938c-0.094,0.125-0.094,0.188-0.047,0.375c-0.062-0.094-0.141-0.125-0.234-0.031\r\n\t\tc0.375,0.375,0.469,0.719,0.875,1.219c-0.078-0.5,0.344,0.156,0.344,0.438c-0.266-0.125-0.609-0.281-0.844-0.562\r\n\t\tc0,0.062,0.281,0.25,0.438,0.406c-0.562-0.031-0.625,0.312-0.375,0.938c-0.391-0.156-0.172,0.219-0.125,0.375\r\n\t\tc-2.047-1.188,0.016,2-0.031,2.062c0.094,0.062,0.312,0.219,0.344,0.281c-0.484,0.031-0.688,0.125-1.016,0.438\r\n\t\tc0.25,0.188,0.203,0.25,0.297,0.531c-0.281-0.188-0.359-0.156-0.641-0.469c0.016,0.188,0.062,0.344,0.234,0.562\r\n\t\tc-0.188-0.094-0.125-0.031-0.281-0.094c0.141,0.312,0.094,0.406-0.109,0.281c0.062,0.062,0.578,0.656,0.188,0.5\r\n\t\tc0.25,0.281-8.328,0.438-8.141,0.719c-0.172-0.125-9.203-0.25-9.203-0.406c0,0.094,0,0.156,0,0.25c0-0.125,8.219-0.281,7.969-0.375\r\n\t\tc0.125,0.594,4.344,0.125,4.469,0.719c-0.25-0.219,1.594-0.438,1.391-0.75c0.125,0.312,1.047,0.281,1.359,0.438\r\n\t\tc-0.062,0.062,0.422,0.062,0.375-0.031c0.062,0.156,0.469,0.25,0.562,0.406c-0.516-0.219-0.672-0.719-0.703-1.156\r\n\t\tc0.047,0.156,0.188,0.219,0.281,0.125c-0.375-0.188-0.453-0.688-0.562-1c0.188,0.094,0.234,0.219,0.422,0.281\r\n\t\tc-0.125-0.406-0.328-0.406-0.656-0.625c0.047,0.219,0.203,0.5,0.281,0.688c-0.172-0.062-0.266-0.281-0.422-0.344\r\n\t\tc0,0.062,0.047,0.125,0.094,0.188c-0.25-0.312-0.5-0.688-0.688-1.031c0.312,0.156,0.5,0.281,0.734,0.5\r\n\t\tc-0.062-0.094-0.141-0.219-0.234-0.312c0.094,0.094,0.219,0.188,0.297,0.312c-0.109-0.219-0.078-0.25,0.047-0.156\r\n\t\tc-0.062-0.25-0.203-0.344-0.328-0.625c0.094,0.062,0.172,0.094,0.266,0.125c-0.125-0.125-0.438-0.688-0.266-0.438\r\n\t\tc-0.016-0.031-0.703-1.031-0.172-0.781c0-0.062,0.016-0.156,0.031-0.219c-0.078-0.062-0.156-0.094-0.219-0.156\r\n\t\tc0.062,0.312,0.031,0.25-0.062,0.156c-0.031-0.031-0.062-0.062-0.094-0.062c0.031,0.125,0.062,0.281,0.094,0.438\r\n\t\tc-0.109-0.156-0.125-0.156-0.062,0.031c-0.125-0.062-0.25-0.188-0.312-0.219c0.266,0.125,0.125,0.344,0.109,0.469\r\n\t\tc-0.297-0.75-0.438-1.281-0.547-2c0.031,0.312,0.062,0,0.062-0.125c0.438,0.281,0.594,1,0.75,1.469\r\n\t\tc-0.062-0.469-0.219-0.906-0.312-1.375c0.062,0.062,0.125,0.125,0.203,0.188c-0.172-0.969-0.859-0.938-1.016-1.906\r\n\t\tc0.156,0.062,0.281,0.094,0.406,0.156c-0.031-0.125-0.109-0.125-0.141-0.25c0.578,0.438-0.078-0.188,0.281,0.094\r\n\t\tc-0.094-0.156-0.172-0.312-0.266-0.469c0.078,0.094,0.188,0.062,0.156-0.062c0.125,0.125,0.562,0.625,0.062,0.312\r\n\t\tc0.062,0.156,0.266,0.312,0.359,0.5c-0.297-0.156-0.234-0.062-0.516,0.031c0.188,0.188,0.5,0.375,0.719,0.469\r\n\t\tc-0.125-0.562-0.469-1.656-0.094-1.438c-0.203-0.281-0.156-0.25,0.125-0.281c-0.156-0.312-0.156-0.594-0.234-0.875\r\n\t\tc-0.047-0.5,0.141-0.938-0.453-1.188c-0.312-1.188,0-1.375-0.219-2.406c0-1.406,0.438-2.438,0.375-3.562\r\n\t\tc0.188-1.25,0.281-3.188,0.281-4.719c0.156-1.312,1-4.156,0.766-5.656c-0.422-2.438,0.031-3.062-1.328-4.938\r\n\t\tc-0.656-0.625-1.969-2.469-1.812-3.406c-0.281-0.25-0.172-3.844-0.688-4c0.219-1.375-0.625-4-1.422-5.188\r\n\t\tc-0.859-1.188,1.031-2.969,0.953-3.031c-0.031,0.156-0.141,0.156-0.281,0.25c-0.125-0.25-0.266-0.5-0.391-0.75\r\n\t\tc0.422,0.344,0.188-1.75,0.719-1.219c0.172-0.688,0.297-1.062,0.484-1.812c0.469,0.25,0.625-0.531,1.078-0.188\r\n\t\tc-0.328-1.125,0.578-0.344,0.703-0.844c0.172,0.188,0.531-1.219,0.625-1.594c0.156-0.781,0.312-0.875,0.5-1.656\r\n\t\tc0.016-0.062-0.938-2.312-0.031-1.562c0.062-0.25-0.531-1.125-0.656-1.719c-0.094,0.344-0.703,0.406-0.891,0.312\r\n\t\tc0.141,0.281,0.078,0.5,0.188,0.781c-0.203,0.031-0.172-0.094-0.297,0.156c-0.312-0.219-1.375-2.156-1.5-2.656\r\n\t\tc0.031,0.312-0.031,0.406-0.188,0.219c-0.016-0.125-0.031-0.25-0.031-0.375c0.344,0.156-0.344-1.656-0.438-1.906\r\n\t\tc-0.312,1.25-0.406-0.438-0.125-0.594c0-1.469-0.172-3.281-0.844-3.969c-1.672-1.812-1.25-3.906-2.734-5.812\r\n\t\tc-0.156,0.375-0.719-0.688-0.844-0.125c-1.031-1.719-2.016-3.531-2.906-5.469c-0.953-2.031,0.25-4,0.266-6.062\r\n\t\tc0.031-4.375-0.594-8.125,0.406-12.469c-0.156-0.094-0.312-0.125-0.375,0.062c-0.062-0.188-0.156-0.562-0.281-0.719\r\n\t\tc-0.969,1.5-0.547,4.125-0.75,5.906c0.328,0.594-0.531,4.625-0.75,5.312c-0.516-0.625,0.359-3.094-0.016-3.656\r\n\t\tc0.422-1.25-0.078-2.406-0.203-3.719c0.891,1.031,0.688-2.062,0.703-2.781c0.016-1.031,0.234-2.531,0.703-3.281\r\n\t\tc-0.234-0.281-0.562-2.938-0.547-3c0.203-0.344,0.422-3.031,0.672-2.75c0.125-0.25,0.062-0.875,0.062-1.25\r\n\t\tc0.109,0.125,0.078,0.25,0.156,0.375c0.172-0.281,0.312-1.406,0-0.625c-0.812-1,1.531-4.75,2.016-5.656\r\n\t\tc1.547-2.656,2.109-3.875,3.422-6.375c0.219,0.812,0.531,0.812,0.594,1.25c0.016-0.031,0.031-0.031,0.031-0.062\r\n\t\tc-0.094,0.094-0.109,0.188,0,0.25c0-0.062-0.031-0.125-0.031-0.188c-0.125,0.219-0.344,0.438-0.156,0.656\r\n\t\tc0.641-1.094,0.594-1.969,1.047-2.969c-0.547,0.062-0.359-0.906-0.062-1.5c-0.859,0-0.266-0.75-0.891-1.062\r\n\t\tc0.031,0.688,0.328,1.312,0.422,1.938c-0.281,0.406-0.062,1.875-0.203,2.562c-1.125-0.938,0.109-2.094-0.719-2.719\r\n\t\tc0.469-0.656-0.375-1.094,0.312-2.031c0.062,0.094,0.125,0.156,0.188,0.25c0.406-0.625,1.484-1.656,0.781-2.188\r\n\t\tc0.156-0.188,0.219-0.438,0.438-0.656c0.016,0.094,0.031,0.188,0.031,0.281c0.25-0.406,0.141-0.375,0.391-0.719\r\n\t\tc0.047,0.031-0.188,0-0.297-0.062c-0.094,0.156-0.141,0.188-0.281,0.281c0.109-0.188,0.688-1.594,0.641-1.625\r\n\t\tc-0.047-0.062,0.859-0.688,0.922-0.781c-0.141,0.062-0.375,0.219-0.531,0.281c-0.094-0.125,0.062-0.594,0.141-0.844\r\n\t\tc0.391,0.562,0.297-0.188,0.406-0.438c-0.047,0.125-0.078,0.219-0.109,0.344c-0.062-0.094-0.141-0.125-0.25-0.094\r\n\t\tc0.125-0.625,0.25-0.906,0.688-1.562c-0.5,0.781,0.406-1.062-0.156-0.219c0.062,0.094,1.172-3.289,1.406-3.742\r\n\t\tc-0.188,0.219-0.375,0.484-0.562,0.719c-0.062-0.062-0.234-0.5-0.281-0.609c0.062-0.078,0.031,2.109-0.469,1.438\r\n\t\tc-0.156,0.516-0.531,1.328-0.328,1.602c0.172-0.352,0.359-0.398,0.516-0.555c-0.469,0.523-0.219,0.805-0.906,1.055\r\n\t\tc-0.031-0.031,0.234-0.688,0.312-0.852c-0.109,0.164-0.188,0.195-0.312,0.289c0.141-0.711,0.438-1.352,0.844-1.852\r\n\t\tc-0.062,0.062-0.156,0.109-0.234,0.172c0.188-0.531,1.016-3.344,0.953-3.422c-0.047,0.094-0.094,0.203-0.156,0.297\r\n\t\tc0.016-0.594-0.062-0.703,0.297-1.156c-0.984-0.766-0.453-2.266-1.016-3.062c0.312-0.312,0.125-0.727,0.344-0.898\r\n\t\tc0.156,0.227,0.156-0.102,0.344-0.289c-0.047-0.18-0.281-0.156-0.375-0.031c-0.156-0.32,0.094-0.117-0.156-0.555\r\n\t\tc-0.438,0.57-0.391,0.859-0.969,1.305c0.016-0.336,0.031-0.477-0.031-0.711c-0.125,0.109-0.25,0.211-0.359,0.297\r\n\t\tc-0.047-0.07-0.047-0.133,0.078-0.18c-0.359,0.156-0.469,0.172-0.938,0.422c0-0.086,0.016-0.18,0.031-0.273\r\n\t\tc-0.188,0.188-0.141,0.07-0.281-0.156c0.688-0.414,1.188-1.406,2.031-1.547c0.156,0.32-0.156,0.117,0.125,0.547\r\n\t\tc0.25-0.273,0.281-0.422,0.5-0.586c-0.031-0.102-0.25-0.023-0.391-0.117c0.156-0.164,0.016-0.133,0.172-0.32\r\n\t\tc-0.594,0.133-1.281,0.336-1.625,0.742c-0.062-0.219,0.031-0.18,0-0.352c-0.406,0.484-2.219,1.742-2.312,1.5\r\n\t\tc-0.672,0.844-1.859,0.234-2.5,0.969c0-0.078,0.016-0.164,0.031-0.25c-0.25,0.102-0.688,0.125-0.781,0.234\r\n\t\tc0-0.094,0.031-0.188,0.031-0.289c-0.25,0.352-0.016-0.391-0.062-0.477c-0.125,0.273-0.453,0.367-0.766,0.641\r\n\t\tc-0.031-0.07-0.109-0.336-0.125-0.359c0.375-0.289,0.578-0.117,0.953-0.539c0.031,0.195,0.188,0.492,0.25,0.641\r\n\t\tc0.625-0.664,0.875-0.195,1.672-0.656c0.375-0.508,1.141-1.039,1.734-1.312c-0.062-0.164-0.344-0.148-0.531-0.195\r\n\t\tc0.078-0.125,0.172-0.25,0.281-0.375c-0.156-0.188-0.406,0.18-0.5,0.289c-0.047-0.242,0.297-0.977,0.406-1.227\r\n\t\tc-0.203,0-0.594-0.039-0.75-0.023c0.031-0.055,1.438-1.602,1.281-2.023c-0.188,0.203-0.281,0.227-0.438,0.391\r\n\t\tc-0.203-0.461,0.156-1.016,0.562-1.305c0.125-0.156,0.312-0.148,0.438-0.305c-0.297-0.938,0.281-1.445,1.375-1.961\r\n\t\tc-0.047,0.117-0.156,0.367-0.141,0.438c0.234-0.43,0.547-0.656,0.859-0.93c-0.094,0.219-0.188,0.648-0.141,0.836\r\n\t\tc0.953,0.391,1.469-0.391,1.938-1.273c-0.109,0.078-0.266-0.086-0.609-0.031c0.156-0.227,0.188-0.516,0.312-0.727\r\n\t\tc-0.281,0.305-0.25-0.531-0.531-0.273c0-0.297,0.516-1.695,0.594-1.25c0.359-0.312,0.219-0.492,0.062-0.766\r\n\t\tc0.406-0.43,0.594-0.008,0.828-0.188c-0.125,0.109-0.125,0.234-0.016,0.367c0.578-0.562,0.453,0.016,0.781-0.258\r\n\t\tc0.266,0.719-0.922,0.891-0.203,1.891c0.188-0.25,0.047-0.5,0.234-0.633c0.062,0.055,0.141,0.109,0.219,0.172\r\n\t\tc-0.156,0.062-0.172,0.188-0.031,0.328c0.25-0.234,0.594-1.406,0.609-1.57c-0.109-0.141-0.203-0.133-0.297,0.016\r\n\t\tc-0.172-0.531,1.062-2.586,1.562-2.898c0.328,0.891,0.719,0.469,0.875,0.703c0.719-0.922,2.062-0.523,2.25-0.688\r\n\t\tc0.031,0.188-0.312,0.414,0.188,0.008c0.047,0.102,0.469,0.945,0.812,0.414c0.188,0.562,0,0.555-0.344,1\r\n\t\tc0.156-0.008,0.453-0.086,0.5,0.008c-0.281,0.234-0.219,0.227-0.266,0.531c0.344-0.289,0.078,0.336,0.359,0.047\r\n\t\tc-0.047,0.289,0.156,1.352-0.062,1.523c0.5,0.18,1.031,1.945,0.953,2.906c0.141-0.062,0.297-0.117,0.453-0.188\r\n\t\tc0.047,0.195,0.406,1.977,0.312,2.227c-0.062,0.195-0.312,2.578-0.25,2.625c0.281-0.289,0.344-0.555,0.438-0.969\r\n\t\tc0.281,0.352-0.125,0.75,0.5,0.109c-0.016,0.094-0.031,0.18-0.031,0.266c0.188-0.195,0.422-0.312,0.609-0.516\r\n\t\tc0.047,0.109-0.141,0.594-0.234,0.734c0.562-0.125,0.984-0.133,1.219,0.305c0.219-0.133,0.438-0.273,0.656-0.414\r\n\t\tc0.562,0.977-0.25,0.484-0.625,0.992c0.469,0.562,1.562-0.359,2.094-0.672c-0.188,0.656-1.094,3.062-0.75,3.547\r\n\t\tc0.359-0.469,0.719-0.508,1.078-0.938c-0.203,0.266-0.406,0.664-0.766,1.094c0.188,0.289,0.625,0.008,0.75-0.133\r\n\t\tc0.656,0.75,0.062,3.219,1,3.938c0.031-0.125,0.062-0.25,0.078-0.375c0.359,0.375,0.578,1.031,0.141,1.5\r\n\t\tc-0.375-0.344-1.344,0.031-0.844,0.531c-0.172,0.125,0.453,0.5,0.625,0.625c-0.031-0.031,0.719,0.594,1.094,0.219\r\n\t\tc0.531,0.531,0,1.219-0.406,1.594c0.094,0.125,0.188,0.156,0.281,0.125c-0.156,0.297-0.281,0.594-0.344,0.938\r\n\t\tc0.609-0.344,0.641-1.109,1.297-1.422c0.078,0.078,1.422,0.141,1.609-0.016c-0.062-0.125-0.031-0.219-0.109-0.344\r\n\t\tc-0.406,0.406-0.781-0.141-1-0.281c-0.109,0.141-0.203,0.281-0.297,0.406c-0.031-0.047,0.031-0.609-0.219-0.219\r\n\t\tc0.312-0.531,0.922-0.844,1.25-0.391c0.578-0.734,0.469,1.453,0.422,1.766c0.141-0.031,0.234-0.094,0.297-0.219\r\n\t\tc-0.156,0.312-0.094,0.344-0.344,0.578c0.062,0.047,0.438,0.141,0.531,0.047c-0.016,0.469,0.219,1.219,0.266,1.523\r\n\t\tc0.703-0.18,1.219,0.625,1.672,1c0.219-0.5,0.562-0.688,0.797-1c-0.047,0.406,0.062,0.562-0.078,1\r\n\t\tc0.281,0.219,0.156,0.062,0.438-0.062c-0.062,0.188-0.188,0.281-0.375,0.312c0.062,0.094,0.156,0.094,0.25,0.031\r\n\t\tc-0.531,0.781-0.406,1.156-0.734,1.906c0.25-0.031,0.297,0.188,0.453-0.062c-0.594-0.469,0.5-1.031,0.719-1.281\r\n\t\tc0.234,0.031,1.344,0.219,1.734-0.281c-0.156-0.125-0.359-0.125-0.547-0.219c0.219-0.344,0.562-0.594,0.875-0.75\r\n\t\tc0.094,0.094-0.031,0.312,0.25,0.406c0.25-0.344,0.375-0.281,0.594-0.562c-0.281-0.406-0.828-0.156-0.75-1.211\r\n\t\tc-0.141,0.172-0.266,0.328-0.391,0.5c-0.094-0.172,0.109-0.312-0.25-0.188c0.812-0.562,0.172-0.875,0.641-1.359\r\n\t\tc0.219-0.266,0.906-0.609,1.266-1.047c0.047,0.156,0.094,0.344,0.141,0.5c0.656-1.031,1.625-2.422,2.5-3.344\r\n\t\tc0.016,0.094,0.031,0.188,0.062,0.25c0.516-0.391,0.281-0.438,0.719-0.016c0.156-0.094,0.312-0.156,0.469-0.25\r\n\t\tc0.391,0.359,0.531,0.703,0.438,1.172c0.328,0.172,0.453,0.375,0.844,0.656c-0.531,0.281-1.188,1-1.781,0.656\r\n\t\tc-0.734,0.016-1.531-1.156-1.453,0.078c-0.453,0.047-0.922,0.203-1.047,0.391c0.281,0.219,0.469,2.406,0.344,2.742\r\n\t\tc-0.047-0.094,0.141,0.125,0.156,0.156c-0.438,0.312-0.312,0-0.516-0.219c-0.109,0.094-0.25,0.188-0.375,0.281\r\n\t\tc0.109,0.031,0.234,0.062,0.359,0.094c-0.266,0.406-0.906,0.25-1.016,0.469c-0.109,0.312,0.234,0.719,0.109,0.875\r\n\t\tc0.5,0.406-0.25,1.531-0.625,2c0.625,0.438,1.188-1.094,2.141-1c-0.125,0.219-0.609,1.938-1.25,1.5\r\n\t\tc-0.484,0.719-0.172,1.031-0.578,1.969c0.297,0.219,0.062,0.062,0.391,0.281c1.172-0.812,3.547-1.562,3.422-3.281\r\n\t\tc0.656,0.531,1.125,0.938,1.125,1.625c-0.078-0.062-0.375,0.344,0.297,0.625c-0.297,0.219-0.391,0.562-0.953,0.688\r\n\t\tc0.094,0.094,0.219,0.156,0.312,0.219c-0.312,0.375-0.688,0.594-0.938,1.125c-0.172,0.375,0.219,0.562-0.266,1.219\r\n\t\tc-0.141-0.188-1.938-0.312-2.203,0.188c-0.031-0.438-0.25-0.5-0.031-1.031c-0.078-0.062-0.344-0.125-0.484-0.156\r\n\t\tc0.094,0.062,0.219,1.031,0.125,1.125c-0.547-0.438-0.5-0.75-1.156-1.281c-0.219,0.281-0.547,0.812-0.828,1.188\r\n\t\tc-0.234-0.125-0.938-1.594-0.969-1.719c-0.234,0.281-0.234,0.312-0.359,0.531c-0.141-0.156-0.297-0.25-0.484-0.375\r\n\t\tc-0.125,0.188,1.188,1.406,1.531,1.562c-0.422,0.625-1.312,0.406-1.594,0.844c0-0.25-0.281-0.719-0.219-0.781\r\n\t\tc-0.344-0.188-0.953,0.281-1.188,0.719c-0.062-0.125-0.125-0.25-0.203-0.375c-0.203,0.469-0.562,1.656-1.109,0.594\r\n\t\tc-0.203,0.25-0.203,0.438-0.531,0.156c0.109,0.062,0.125,0.156,0.094,0.281c-0.531-0.438-2.031,0.844-2.656,0.781\r\n\t\tc-0.266,0.438-0.625,0.625-1.172,1.125c0.234,0.188-0.172,0.906-0.25,1.219c1.172,0.344,0.391,2-0.125,2.781\r\n\t\tc2.156-0.094,1.031,3.344,1.797,3.844c0.406,1.469,3,2.781,1.156,4.25c-0.531,0.406-0.953,1.938-0.812,2.625\r\n\t\tc0.281,1.281,1.719,1.531,1.875,0.312c0.047-0.375,0.844-2.812,1.312-2.781c0.75,0.062,2.031-0.969,2.5-0.688\r\n\t\tc0.062-0.156,0.094-0.312,0.141-0.469c-0.047,0.281-0.125,0.344-0.266,0.188c0.594-0.781,1.219-2.312,0.922-3.281\r\n\t\tc-0.484-1.594,0.922-0.844,1.578-1.656c-0.5-0.25,0.219-0.938,0.469-1.062c-0.609-0.375,0.625-0.938,0.719-0.906\r\n\t\tc0.578-0.781,0.094,9.641,1.156,10.5c0.984,0.672,2.688,13.031,1.828,13.031c0.109,0,0.203,0,0.297,0\r\n\t\tc-0.375,0,0.078-9.969,0.641-9.672c-0.047,0.188-0.156-5.141-0.312-5.297c-0.391,0.562,0.297-2.125,0.578-1.922\r\n\t\tc-0.609,0.406-1.516-0.422-1.562,0.359c0.344,0.156,0.641,0.625,0.344,1.078c0.172,0,0.344-0.578,0.5-0.391\r\n\t\tc-0.156,0.203-0.094,0.297-0.125,0.547c0.484-0.188,0.812-0.328,1.125-0.156c0.312-0.547,1.672-1.922,2.109-1.625\r\n\t\tc-0.781,1.156-0.266,1.922-0.547,2.891c-0.188-0.109-0.312-0.016-0.5,0.047c0.438,0.25,0.625,1.484-0.094,1.828\r\n\t\tc0.219,0.156,0.531,0.781,0.312,1.125c-0.281-0.312-0.031,0.031-0.688-0.406c0.062-0.062-0.156,0.562-0.188,0.625\r\n\t\tc0.094,0.125,0.188,0.125,0.312,0c-0.406,0.75,0.688,2,0.422,2.719c0.109,0.125,0.234-0.094,0.391-0.188\r\n\t\tc-0.125,0.281,0.062,0.219,0.25,0.188c-0.594,1.281,0.781,0.469,0.484,1.406c-0.578-0.344-1.656,0.312-2.531-0.156\r\n\t\tc-0.031,1.281,3.141-0.438,2.547,1.656c0.188,0.125,0.203-0.031,0.375-0.156C206.406,234.938,206.891,234.312,206.453,235.156z\r\n\t\t M197.875,239.125c-0.391,0.844-0.016,1.031,0.75,1.406c-0.281-0.156-0.016,0.188-0.016,0.344\r\n\t\tc-0.156,0.031-0.312,0.062-0.484,0.094c0.141-0.312-0.078-0.188,0.203-0.438C197.75,240.25,196.828,239.625,197.875,239.125z\r\n\t\t M189.781,242.719c-0.266,0.562-0.953-0.031-1.25-0.219C188.703,242.031,189.516,242.594,189.781,242.719z M176,274.844\r\n\t\tc0,0.188,0,0.344,0,0.562C176,275.219,176,274.688,176,274.844z M185.406,279.125c-0.141-0.594-0.734,1.688-0.141-0.594\r\n\t\tC185.484,278.625,186,279.281,185.406,279.125z M184.844,269.25c-0.672-0.062-0.875,0-0.953-0.781\r\n\t\tc0.422,0.188,0.594,0.156,0.922,0.375C184.75,269.125,184.875,269,184.844,269.25z M177.609,262.531\r\n\t\tc1.031-0.688-0.906-2.438-0.938-3.438c-0.094-1.844-2.062-1.125-2.562-1.812c0.656-0.562,1.781-0.812,2.125,0.406\r\n\t\tc0.141,0,0.219-0.094,0.219-0.219c0.969,1.156,1.5,2.406,2.062,3.656c0.094,0.219,0.562,1.219,0.844,1.594\r\n\t\tC180.609,264.344,178.297,262.812,177.609,262.531z M177.797,265.062c-0.531-0.344-0.438-0.281-0.922-0.656\r\n\t\tc-0.172-0.281-0.375-0.656-0.266-0.906C177.109,263.594,178.172,264.406,177.797,265.062z M175.469,258.281\r\n\t\tc-0.281,0.219-0.219,0.469-0.656,0.25c0.078-0.25,0.281-0.375,0.375-0.688C175.266,258,175.359,258.125,175.469,258.281z\r\n\t\t M178.484,257.406c0.203,0.062,0.734-0.25,0.406,0.5C178.75,257.719,178.625,257.562,178.484,257.406z M180.328,266.219\r\n\t\tc0.297-0.531,0.25-1.031,0.125-1.75c1.078,0.594,2.594,1.938,2.625,3.281c-0.75-0.438-1.062-0.375-1.719-1.031\r\n\t\tc-0.156,0.469-0.188,0.125-0.422,0.438c0.016,0-0.828-0.938-1.125-1.094c-0.469-0.344-0.828-0.375-0.578-0.938\r\n\t\tC179.797,265.438,180.188,265.688,180.328,266.219z M173.828,321.75c-0.156-0.125-0.172-0.062-0.094,0.125\r\n\t\tc-0.094-0.094-0.125-0.062-0.078,0.031c-0.484-0.188-0.281-0.812-0.406-1.406c0.031,0.031,0.266,0.406,0.203,0.125\r\n\t\tc0.25,0.156,0.203,0.125,0.25,0.469C173.422,320.969,173.734,321.562,173.828,321.75z M166.781,192.102\r\n\t\tc-0.141-0.5,0.016-0.688,0.266-1.141c0.188,0.172,0.188,0.172,0.266,0.234c-0.094-0.125,0.016-0.281,0.156-0.297\r\n\t\tc0.078,0.078-0.016,0.234,0.047,0.406c0.25-0.281,0,0.078,0.234-0.172c-0.016,0.25-0.047,0.719-0.297,0.969\r\n\t\tC167.344,191.945,167.016,191.836,166.781,192.102z M167.953,190.883c0.156-0.133,0.312-0.273,0.469-0.422\r\n\t\tc0.109,0.156,0.062,0.289-0.125,0.391c0.031,0.125-0.094,0.219-0.188,0.312C168.125,190.664,168.094,191.227,167.953,190.883z\r\n\t\t M168.438,205.938c0.125-0.5,0.25-1.281,0.234-1.438c0.266-0.406,0.312-0.812,0.594-1.188c0.188,0.125,0.281,0.281,0.422,0.531\r\n\t\tc-0.734,0.562-0.625,1.312-0.938,1.781C168.562,205.281,168.578,205.781,168.438,205.938z M171.297,201.156\r\n\t\tc0.031,0.031-0.75,1.938-0.906,2.125c-0.141-0.312,0.016-0.281,0.125-0.625c-0.156-0.062,0.25-0.938,0.344-1.094\r\n\t\tc-0.141-0.312-0.031-0.406,0.25-0.906c-0.047,0.375,0,0.594-0.047,0.938C171.203,201.469,171.266,201.344,171.297,201.156z\r\n\t\t M172.094,198.914c-0.234,0.328-0.203,0.531-0.609,0.484c0.328-0.422,0.578-0.859,0.719-1.359\r\n\t\tC172.625,198.57,171.953,198.664,172.094,198.914z M201.766,202.406c-0.094,0.281,0,0.469,0,0.812\r\n\t\tc-0.109,0.188-0.234,0.188-0.391-0.094C201.484,202.844,201.641,202.656,201.766,202.406z M200.406,214.781\r\n\t\tc-0.141,0.188-0.172,0.031-0.203-0.125C200.594,214.375,200.266,214.719,200.406,214.781z M195.984,211.781\r\n\t\tc0.156-0.219,0.312-0.438,0.438-0.656c-0.312-0.156-0.312-0.062-0.562-0.219c0.25-0.688,0.641-0.031,1.031-0.438\r\n\t\tc0.328-0.594,0.578-1.188,1.188-1.75c0.188,0.156-0.094,0.219,0.188,0.344c-0.422,0.125-0.219,0.125-0.469,0.469\r\n\t\tc1.031-0.031,0.734,1.719,0.312,2.438c0.094,0.094,1.094-0.281,0.562,0.406c-0.094-0.062-0.281,0.188-0.531,0.188\r\n\t\tc0.062-0.156-0.344-0.531-0.453-0.688c-0.297-0.406,0.297-0.625,0.453-0.875C197.109,210.688,197.078,212.031,195.984,211.781z\r\n\t\t M197.578,212.969c-0.406,0.375-1.219,0.438-1.719,0.156C196.016,212.719,197.031,213.062,197.578,212.969z M198.281,208.844\r\n\t\tc0.188-0.25-0.109-0.375,0.266-0.188C198.547,208.938,198.516,209.062,198.281,208.844z M198.859,214.875\r\n\t\tc-0.25,0.344-0.297,0.562-0.625,0.75C197.797,215.281,198.672,214.969,198.859,214.875z M194.609,221.781\r\n\t\tc0.5,0.406-0.219,0.625-0.375,0.906C193.859,222.5,193.984,222.188,194.609,221.781z M191.203,225.906\r\n\t\tc-0.219,0.25-0.5-0.344-0.562-0.625C191.141,225.219,190.984,225.562,191.203,225.906z M207.672,220.062\r\n\t\tc0.297-0.5,0.984-0.562,0.625,0C208.047,220.062,207.922,220.281,207.672,220.062z M213.016,215.906\r\n\t\tc-0.516,0.312-0.406,0.094-0.719,0.688c-0.438-0.219,0.125-0.281-0.391-0.594c-0.156,0.312-0.344,0.281-0.609,0.75\r\n\t\tc-0.047-0.094-0.094-0.188-0.125-0.281c-0.188,0.406,0.094,0.312-0.125,0.719c-0.25-0.406-0.219-0.062-0.375-0.625\r\n\t\tc-0.25,0.438-0.156,1.438-0.781,1.031c0.125-0.188-0.188-0.438-0.375-0.594c0.125-0.25,0.156-0.062,0.375-0.125\r\n\t\tc-0.125-0.125-0.266-0.219-0.422-0.312c0.109-0.094,0.234-0.219,0.359-0.312c-0.531-0.188,0.078-0.031-0.562-0.344\r\n\t\tc0.141-0.219,0.359-0.125,0.594-0.188c-0.375-0.344-1.172-0.5-0.578-1.5c-0.375,0.094,0.078-0.031-0.328-0.219\r\n\t\tc-0.094,0.281-0.031,0.312-0.234,0.625c-0.297-0.125,0.219-0.438-0.047-0.625c-0.375,0.562-0.031,0.5-0.297,0.969\r\n\t\tc-0.25-0.188-0.047-0.312-0.359-0.406c-0.422,0.531,0.25,2.312,0.375,3.062c0.031-0.156,0.094-0.312,0.125-0.469\r\n\t\tc0.078,0.031,0.156,0.094,0.219,0.125c-0.031,0.219-0.344,0.562-0.125,0.688c-0.078,0.094-0.172,0.156-0.25,0.219\r\n\t\tc-0.062-0.062-0.094-0.188-0.125-0.281c-0.312,0.375,0,0.812-0.594,0.438c-0.062,0.125,0.125,0.688,0.031,0.969\r\n\t\tc-0.078-0.062-0.406-1.906-0.828-1.094c-0.141-0.25-0.234-0.5-0.328-0.781c-0.344,0.469-0.344-0.188-0.734-0.469\r\n\t\tc-0.656,1.375,1.25,2.438,0.641,3.469c-0.656-0.406-0.531-0.719-1.312-1.406c-0.641-0.562-1.438-0.531-1.938-1.25\r\n\t\tc0.156-0.156,0.438-0.094,0.688-0.125c-0.109-0.062-0.156-0.312-0.156-0.469c-0.062,0.312-0.188,0.375-0.375,0.125\r\n\t\tc0.297-0.5,0.125-0.156-0.125-0.281c0.375-0.688,0-0.75,0.438-1.438c-0.25-0.219-0.5-0.25-0.625-0.25\r\n\t\tc0.047-0.156,0.125-0.156,0.219-0.062c-0.031-0.188-0.094-0.406-0.062-0.594c-0.031,0.125-0.031,0.219-0.062,0.344\r\n\t\tc-0.406-0.219,0.125-0.562-0.188-0.688c-0.156,0.531-1,0.844-0.656,0.344c-0.656,0.344-1,0.094-1.484-0.219\r\n\t\tc0.172-0.281,0.609-1.188,0.953-1.75c0.375,0.625,1.031,0.75,1.344,0.906c0.141-0.125,0.172-0.094,0.375-0.094\r\n\t\tc-0.109,0.25,0.812,0.438,1.062,0.688c0.25-0.688,0.281-1.312,0.234-1.969c0.594,0.406,0.938-0.469,1.562-0.125\r\n\t\tc-0.016-0.781,0.172-0.688,0.453-0.688c0.094-0.094,0.188-0.125,0.281-0.219c-0.188-0.156,0.375-2.375,0.781-2.562\r\n\t\tc-0.375-0.25-0.812,0.062-1.344,0.062c0.266-0.375-0.031-0.531,0.547-1c0.031,0.094,0.078,0.188,0.109,0.281\r\n\t\tc0.188-0.344-0.391-1.281,0.453-0.875c0.172-0.312-0.312-0.125-0.141-0.469c-0.188,0.062-0.359,0.156-0.562,0.219\r\n\t\tc0.328-0.562,0.125-0.031,0.375-0.375c-0.312-0.188,0-0.344-0.297-0.562c-0.281,0.25-0.031-0.156-0.406,0.312\r\n\t\tc0.125-0.281,0.234-0.625,0.391-0.938c-0.312-0.188-0.281,0.094-0.406-0.062c0.094-0.188,0.188-0.406,0.297-0.594\r\n\t\tc-0.266-0.031-0.531-0.031-0.703,0.125c0.141,0.031,0.266,0.062,0.391,0.062c-0.578,1.031-1.109-0.312-1.359-0.75\r\n\t\tc-0.203,0.375-0.406,0.875-0.531,1.406c-0.109-0.062-0.141-1.562-0.219-1.938c0.047,0.281,0.094,0.906-0.094,1.125\r\n\t\tc-0.578-0.438-1.453-1.25-1.531-1.938c-0.031,0.125-0.062,0.25-0.094,0.375c-0.406-0.438-0.25-0.875-0.344-1.5\r\n\t\tc-0.156,0.188-0.344,0.125-0.562-0.031c0.062-0.344,0.078-0.719,0.484-0.969c-0.141-0.773-0.172-3.227,1-2.555\r\n\t\tc0.234-0.156,1.422-0.75,1.422-0.719c0.688-0.031,2.359,0.656,2.281,1.469c0.469,0.031,0.906,0.266,1.188,0.891\r\n\t\tc-0.156,0.109-0.281,0.266-0.406,0.383c0.812-0.164,2.656-0.148,2.312,0.156c0.078,0.219,0.016,1.188,0.016,1.188\r\n\t\tc-0.828,0.875-2.594,0.25-2.609-1.031c-0.469,0.562-0.938,1.156-1.344,1.594c0.656,0.656,0.438-0.031,0.562-0.156\r\n\t\tc0.344-0.156,0.5-0.219,0.875-0.219c0,0.344-0.125,0.312-0.188,0.469c0.156,0,0.312-0.031,0.453-0.031\r\n\t\tc-0.141,0.188-0.344,0.688-0.547,0.938c0.25-0.25,0.469-0.375,0.75-0.812c0.312,0.219,0.344,0.531,0.594,0.781\r\n\t\tc0.25-0.375-0.125-0.562-0.25-0.844c-0.188-0.469,1.156-0.531,0.969,0.156c-0.25,0.844,1.031,0.938,1.422,1.156\r\n\t\tc-0.234,0.375-0.484,0.625-0.578,0.812c0.125,0,0.25,0,0.406,0.031c-0.422,0.656-0.219,0.562-0.875,0.594\r\n\t\tc-0.062,0.312-0.062,0.5-0.062,0.75c0.188-0.125,0.375-0.281,0.562-0.406c0.109,0.062-0.062,0.531-0.156,0.688\r\n\t\tc0.078,0.094,0.141,0.062,0.156-0.094c0,0.156-0.109,0.344,0.031,0.375c0-0.156,0.109-0.531,0.172-0.656\r\n\t\tc0.016,0.031,0.312,0.094,0.5,0.156c-0.047,0.219-0.109,0.438-0.156,0.656c0.109,0.062,0.469,0.156,0.203,0.531\r\n\t\tc0.172,0.094,0.219-0.062,0.406,0.062c-0.297,0.469-0.438,0-0.75,0.438c0.188,0.219,0.531-0.031,0.75-0.062\r\n\t\tc-0.062,0.188-0.281,0.25-0.453,0.281c0.609-0.062,0.891,0.219,0.953,0.812c-0.344-0.188-0.391-0.031-0.719-0.062\r\n\t\tc0.594,0.375-0.141,0.281,0.344,0.562c0.188-0.062,0.25-0.375,0.484-0.281c0.094,0.781-0.422,1.188-0.953,0.781\r\n\t\tc0.062,0.125,0.031,0.25-0.062,0.312c0.531,0.375,0.219,0.312,0.453,0.875c-0.625-0.375-0.391-0.219-0.641-0.594\r\n\t\tc-0.125,0.188-0.094,0.438-0.031,0.75c-1.594-0.156-0.062,0.562-0.438,1.094c0.094,0.094,0.406-0.031-0.062,0.312\r\n\t\tc0.266,0.156,0.062-0.156,0.344,0c-0.375,0.438,0,0.125-0.188,0.469c0.25,0.156,0.094-0.219,0.312,0\r\n\t\tc-0.141,0.156-0.312,0.312-0.469,0.5c0.25,0.125,0.281-0.094,0.516-0.094c-0.172,0.438,0.188-0.094,0.266-0.219\r\n\t\tc0.188,0.125-0.062,0.344-0.125,0.5c0.125,0.062,0.344-0.312,0.625-0.375c-0.109,0.281-0.156,0.375-0.422,0.688\r\n\t\tc0.281,0.125,0.141,0.219,0.391-0.125c-0.062,0.469,0.109,0.438-0.219,0.812c0.141,0.031,0.156,0.094,0.047,0.188\r\n\t\tc0,0.031,0.578,0.5,0.453,0.469c0.078-0.406,0.234-0.5,0.469-0.281c-0.156,0.219-0.375,0.406-0.562,0.625\r\n\t\tc0.188,0.094,0.375-0.156,0.5-0.281c0.297,0.125,0.422,0.094,0.844,0.312C212.703,215.625,212.672,215.812,213.016,215.906z\r\n\t\t M204.078,207.094c0.297-0.5,0.375-0.062,0.406,0.25C204.359,207.281,204.203,207.188,204.078,207.094z M205.922,209.344\r\n\t\tc-0.125,0.281-0.688,0.438-0.953,0.5C204.641,208.5,205.75,209.25,205.922,209.344z M205.297,205.969\r\n\t\tc-0.344-0.156-0.562-0.156-0.578-0.625c0.516,0.344,0.516,0,0.984,0.312C205.562,205.75,205.422,205.875,205.297,205.969z\r\n\t\t M206.703,209.469c0.109-0.125,0.203-0.281,0.312-0.406C207.141,209.188,207.047,209.781,206.703,209.469z M206.516,207.188\r\n\t\tc0.125,0.031,0.25,0.062,0.391,0.062C206.641,207.594,206.641,207.281,206.516,207.188z M211.016,197.18\r\n\t\tc0.156-0.141,0.453-0.047,0.656,0.078C211.172,197.617,211.281,197.273,211.016,197.18z M215.312,195.508\r\n\t\tc-0.297,0.375-0.047,0.5-1.219-0.266c-0.625,0.672-0.453,0.547-1.594,0.047c0.578,1,0.844,1.781-0.516,1.594\r\n\t\tc0.031-0.125,0.062-0.234,0.094-0.344c-0.375,0.188-0.906,0.406-1.234,0.125c0.516-0.641,0.578-0.578,0.141-0.875\r\n\t\tc0.094-0.312-0.031-0.375,0.219-0.641c-0.141-0.109-0.297,0.484-0.688,0.391c-0.328-0.062-0.375-0.219-0.812-0.469\r\n\t\tc0.062-0.219,0.188-0.312,0.391-0.312c-0.172-0.094-0.422-0.188-0.609-0.266c-0.156,0.188-0.031,0.297-0.125,0.484\r\n\t\tc-0.312-0.141-0.375-0.078-0.594,0.188c-0.281-0.156-0.188-1.562-0.656-0.906c0.031-0.188,0-0.344,0.031-0.562\r\n\t\tc-0.656,0.172-0.625,0.219-0.781-0.406c-0.172,0.219-0.141,0.281-0.375,0.125c0.219-0.266,0.188-0.469,0.344-0.75\r\n\t\tc0.312,0.219,0.656-0.219,0.906,0.094c0.188-0.281,0.5,0.156,0.688,0.344c0.344-0.375,0.125-0.891,0.422-1.125\r\n\t\tc1.016,0.828,0.859,1.438,1.453,2.281c0.328-0.375,0.344-0.125,0.75-0.422c-0.141-0.141-0.344-0.141-0.531-0.203\r\n\t\tc0.094-0.062,0.125-0.172,0.125-0.312c-0.094,0.078-0.188,0.125-0.281,0.188c0-0.344,0.344-0.5,0.062-0.75\r\n\t\tc0.281-0.172,0.438-0.156,0.656-0.469c-0.094-0.109-1.547-0.094-1.938-0.5c0.359-0.484,0.406-0.375,0.797-0.781\r\n\t\tc0.359,0.328,0.516,0.156,0.766,0.391c0.094-0.047,0.125-0.094,0.125-0.141c0.469,0.25,1.156,0.906,1.625,1.422\r\n\t\tc0.078-0.078,0.156-0.172,0.219-0.25c-0.312-0.266-0.609-0.719-0.953-0.891c-0.172,0.094,0.812-0.219,0.766-0.219\r\n\t\tc-0.219-0.172-0.188,0.125-0.375,0.094c0.078-0.344,0.078-0.664,0.188-1.039c-0.5,0.539-0.078,0.695-0.719,0.852\r\n\t\tc-0.438,0.312-0.688-0.547-1-0.141c0-0.109,0-0.234,0.031-0.359c-0.203,0.203-1.172,0.469-0.5-0.211\r\n\t\tc-0.625,0.523-1.219,0.109-1.844,0.617c-0.062-0.25-0.156-0.414-0.156-0.742c-0.375,0.461-0.469,0.273-0.984-0.156\r\n\t\tc0.375-0.422,0.828-1.641,1.672-0.906c0.344-0.391-0.844-0.664-1.125-0.898c0.062-0.086,0.094-0.195,0.141-0.305\r\n\t\tc0.266,0.234,0.438,0.578,0.672,0.32c-0.547-0.484-0.531-0.656-0.516-1.211c0.109,0.141,0.375-0.398,0.422-0.492\r\n\t\tc0.156,0.469,0.25,0.633,0.656,0.93c0-0.344-0.766-1.102-0.594-1.281c0.312,0.211,1.188,0.156,1.562-0.195\r\n\t\tc-0.281-0.141-0.359-0.469-0.422-0.555c-0.172,0.164-0.234,0.109-0.438,0.062c0.047-0.102,0.141-0.414,0.203-0.648\r\n\t\tc0.797,0.867,1.062,0.562,0.328-0.359c0.016,0,0.453-0.023,0.453-0.023c-0.109,0.109,1.156,1.438,0.812,2.164\r\n\t\tc-0.281,0.586-0.344,2.117,1.141,1.594c-0.391,0.219,0.141,0.305,0.203,0.375c-0.094,0.289-0.219,0.562-0.594,1.133\r\n\t\tc0.281-0.344,0.688-0.188,1.016-0.648c0.328,0.352,0.953,0.523,1.375,0.812c0.078,0.117-0.078,0.578,0.109,0.688\r\n\t\tc-0.5,0.688,0.062,1.656,0.531,1.188c-0.812-0.562-0.703-1.617,0.375-1.062c0.438,0.188,1.75,1.125,2.094,0.797\r\n\t\tc-0.391-0.188-0.688-0.453-0.875-0.609c0.5,0.406,0.984,0.109,1.531,0.5c-0.125-0.156-0.281-0.344-0.438-0.5\r\n\t\tc0.234-0.25,0.375,0.062,0.656,0.062c-1.312-0.977-2.594-0.906-4-1.852c0.094-0.055,0.188-0.117,0.281-0.188\r\n\t\tc-0.234-0.148-0.531,0.047-0.812,0.219c-0.188,0.148-0.438-0.375-0.688-0.523c0.125-0.117,0.25-0.203,0.375-0.297\r\n\t\tc-0.438-0.477-1.438-0.781-2.047-1.375c0.297,0.008,0.766,0.109,0.922-0.109c-0.156-0.148-0.469-0.125-0.766-0.195\r\n\t\tc0.047-0.109,0.094-0.211,0.141-0.32c0.25,0.32,0.906,0.211,1.281,0.422c-0.344-0.375-0.734-0.539-1.141-0.719\r\n\t\tc0.203,0.039,0.391,0.039,0.594,0.102c-1.312-0.938,1.984,0.125,1.531,0.562c0.109,0.109,0.484,0.75,0.547,1.031\r\n\t\tc0.125-0.164,0.094-0.219,0.188-0.477c0.109,0.016,0.219,0.031,0.344,0.062c-0.094,0.133-0.156,0.273-0.219,0.414\r\n\t\tc0.625-0.633,0.5-0.688-0.469-1.148c0.109-0.18,0.219-0.352,0.328-0.531c0.203,0.344,0.422,0.328,0.641,0.695\r\n\t\tc0.125-0.188,0.203-0.414,0.281-0.609c0.125,0.086,0.797,1.086,0.719,1.133c0.297,0.32-0.266,1.469,0.406,0.68\r\n\t\tc-0.031,0.25-0.062,0.469-0.078,0.711c0.297-0.359,0.422-0.766,0.578-1.133c0.25,0.18,0.812,1.289,0.594,1.562\r\n\t\tc0.125,0.188,0.094-0.125,0.266,0.008c-0.266-0.57-0.391-0.586,0.078-0.883c0.031,0.016,0.125,0.828,0.625,0.047\r\n\t\tc0.391,0.375,0.969,0.742,0.609,1.555c0.266-0.477,0.266-0.477,0.094-1.086c0.984,0.188,2.016,0.523,2.016,1.539\r\n\t\tc0.938-1.25,2.812,0.719,3.547,1.172c-0.766,0.438-1.203,0.109-1.953,0.25c1.281,0.422,1.969-0.062,2.875,0.5\r\n\t\tc0.656,0.312,0.5,1.297,1.281,1.875c-0.422,0.75-2.594,0.266-2.906-0.125c-0.141,0.094-0.141,0.156,0,0.188\r\n\t\tc-0.234-0.047-1-0.156-1.062-0.078c0.484,0.234,1.094,0.375,1.625,0.422c-0.438,0.469-1.688-0.031-1.781,0.188\r\n\t\tc-0.469-0.234-2.188,0.031-2.375-0.156c0.125-0.172-0.062-0.219,0.172-0.438c-0.422,0.375-0.453,0.281-1.125,0.406\r\n\t\tc0.172-0.297-0.234-0.344-0.359-0.438c-0.094,0.141,0.094,0.438,0.156,0.484c-0.375-0.141-0.672-0.078-1.031-0.266\r\n\t\tc-0.188,0.516-0.094,0.266-0.656,0.312c0.219-0.5-0.344-0.375-0.562-0.375c-0.062-0.188-0.125-0.344-0.188-0.516\r\n\t\tc-0.109,0.203-0.156,0.297-0.344,0.125c0.031-0.156,0.062-0.328,0.094-0.484c-0.188,0.125-0.234,0.078-0.156-0.109\r\n\t\tc-0.078,0.078-0.141,0.156-0.219,0.234c-0.094-0.125-0.188-0.25-0.281-0.375c-0.094,0.062-0.188,0.125-0.281,0.188\r\n\t\tc0.938,0.938,1.594,0.891,0.969,1.781c-0.188-0.391-0.516-0.578-0.062-0.969c-0.125,0.031-0.25,0.078-0.375,0.125\r\n\t\tc0.141-0.188-0.375-0.656-0.531-0.75c0.406,0.812,0.156,0.391-0.047,0.75c-0.016,0.047-0.719-0.891-0.891-0.984\r\n\t\tc-0.156,0.266,0.188,0.375,0.375,0.609c-0.406,0.094-0.422-0.031-0.703,0.312c0.047,0.031,0.922,0.125,0.953,0.062\r\n\t\tc0.375,0.281,0.531,0.594,1,0.859c-0.406,0.484-0.375,0.516-0.938,0.109c-0.219,0.188-0.016,0.375-0.125,0.531\r\n\t\tC215.703,195.789,215.5,195.633,215.312,195.508z M207.531,191.602c0.359-0.156,0.438-0.297,0.234-0.422\r\n\t\tc0.203-0.109,0.438-0.172,0.625-0.359C208.5,191.445,208.109,191.898,207.531,191.602z M216.594,197.883\r\n\t\tc-0.172-0.125-0.344,0.203-0.266-0.188C216.672,197.477,216.422,197.758,216.594,197.883z M218.281,229.719\r\n\t\tc0.109-0.156,0.219-0.281,0.016-0.344c-0.156,0.375-0.203,0.281-0.531,0.094c0.094-0.094,0.203-0.156,0.312-0.219\r\n\t\tc-0.156-0.094-0.281-0.156-0.406-0.219c0.375-0.281,0.141-0.062,0.078-0.156c0.141-0.188,0.297-0.312,0.438-0.5\r\n\t\tc-0.547-0.219-1.094,0.469-1.672,0.219c0.156-0.281,0.094,0.094,0.297-0.188c-0.531-0.312-0.266-1.281-0.328-1.469\r\n\t\tc0.094-0.219,0.25-0.188,0.469-0.312c-0.094-0.094-0.219-0.094-0.344,0.031c0.141-0.125,0.125-0.188-0.047-0.219\r\n\t\tc0.125-0.125,0.266-0.25,0.375-0.375c-0.453-0.188-0.484-0.062-0.828,0.125c1.016-1.812,0.312-0.344-0.031-0.562\r\n\t\tc0.188-0.406,0.062-0.312,0.406-0.719c-0.344-0.156-0.266-0.094-0.516,0.094c0.016-0.469,0.109-0.125,0.234-0.406\r\n\t\tc-0.406-0.219-0.062-0.219,0.125-0.531c-0.438-0.188-0.219-0.375-0.281-0.844c0.156,0.062,0.312,0.156,0.438,0.219\r\n\t\tc0.125-0.125,0.062-0.219-0.156-0.281c0.203-0.062,0.656-0.344,0.688-0.375c0.375-0.094-0.281,1.188,0.375-0.156\r\n\t\tc-0.281-0.156-0.719-0.031-1.125,0.125c0.094-0.125,0.609-0.844,0.125-1c0.094-0.219,0.328-0.094,0.391-0.188\r\n\t\tc-0.062-0.156-0.141-0.312-0.203-0.469c0.25,0.094,0.594,0.031,0.719-0.156c-0.219-0.125-0.391-0.188-0.5,0.094\r\n\t\tc-0.156-0.25-0.125-0.219-0.469-0.25c0.266-0.625,0.156-0.062,0.469-0.312c-0.406-0.219-0.25-0.25-0.438-0.594\r\n\t\tc0.141,0,0.281,0.031,0.438,0.031c-0.188-0.094,0.438-0.531,0.516-0.625c-0.406-0.219,0.016-0.562-0.203-0.688\r\n\t\tc0.469-0.062,0.656-0.281,1.188-0.25c-0.484-0.25-0.641,0.031-0.969-0.156c0.359-0.5,0.969-0.438,1.344,0\r\n\t\tc-0.109-0.25-0.312-0.438-0.219-0.688c0.406,0.219,0.625,0.562,1.188,0.844c0.031-0.156,0.094-0.344,0.125-0.5\r\n\t\tc-0.438,0.031-1.656-0.156-1.25-0.656c0.5,0.219,0.641,0.188,1.094,0.281c0.781,0.219,0.25-1.125,1-0.844\r\n\t\tc-0.172,0.156-0.219,0.344-0.156,0.531c0.344-0.312,0.406-0.531,0.594-0.812c-0.141-0.094-0.234-0.031-0.406-0.031\r\n\t\tc0.359-0.562,0.422-0.562,0.844-1c-0.75-0.469-0.969-1.344-1.547-1.594c-0.625,1.062,1.031,1.375-0.422,2\r\n\t\tc-0.625,0.25-1.125-0.062-1.312-0.781c0.344,0.438,0.562,0.469,0.688,0.031c-0.406-0.188,0.062,0.062-0.75-0.406\r\n\t\tc0.312-0.469,0.703-0.969,1.375-1.094c-0.125,0.219,0.031,0.219,0.25,0.344c0.062-0.094,0.156-0.156,0.25-0.219\r\n\t\tc-0.906-0.594-0.125-1.438,0.906-0.156c0.344,0.406,0.281,1,0.797,1.25c0.25-0.25-0.297-0.281-0.094-0.594\r\n\t\tc0.203,0.094,0.266,0.188,0.438,0.031c-0.516-0.281-0.297-0.531,0.156-0.281c0.141-0.281-0.688-0.688,0.25-0.219\r\n\t\tc-0.234-0.219-0.266-0.5-0.578-0.688c0.219-0.312,0.469,0.188,0.672-0.188c-0.297-0.031-0.562-0.156-0.859-0.25\r\n\t\tc0.078-0.031,0.156-0.062,0.203-0.094c-0.141-0.094-0.578-0.469-0.516-0.625l-0.453-0.438c-0.422,0.781-1.562,0.062-0.562-0.5\r\n\t\tc-0.234-0.031-0.266-0.125-0.141-0.25c0.219,0.156,0.531-0.281,0.688-0.375c-0.219-0.062-0.281-0.125-0.125-0.281\r\n\t\tc1.312,0.719,0.781-1.531,1.234-2.406c-0.172-0.062-0.359-0.094-0.531-0.125c0.109-0.094,0.703-0.406,0.953-0.531\r\n\t\tc-0.594-0.812-0.75-5-2.484-4.25c0.109-0.188,0.188-0.375,0.266-0.562c-0.5,0.062-0.906-0.062-1.188-0.344\r\n\t\tc-0.125,0.219-0.281,0.156-0.469,0.281c0.25-0.75-0.031-0.938-0.688-0.656c-0.016-0.188,0.078-0.469-0.125-0.625\r\n\t\tc-0.125,0.219-0.469,0.5-0.625,0.719c-0.719-0.406-1.141-1.312-0.438-1.586c-0.344-0.328-0.406-1.234-0.375-1.219\r\n\t\tc0.156-0.016,0.297-0.047,0.469-0.062c-0.219,0.469,2.391,0.594,2.719,1.523c0.125-0.18,0.312-0.273,0.453-0.43\r\n\t\tc-0.469-0.344-1-0.625-1.547-0.812c0.062-0.156,0.125-0.281,0.188-0.438c-0.625-0.312-0.812,0.422-1.344-0.281\r\n\t\tc0.156-0.188,0.062-0.547-0.078-0.656c0.516-0.984-0.078-1.031,1.25-0.875c1.047,0.609,2.578,0.438,2.859,1.438\r\n\t\tc0.312-0.406,1.688-0.812,2.188-1.281c-0.859-0.406-1.125-0.5-1.812-0.906c0.359-0.875,1.391-0.828,2-0.469\r\n\t\tc0.094,0.062,0.719,0.031,0.766-0.094c0.312,0.25,0.516,0.188,1.062,0.469c0.109,0.031-0.234,0.469,0,0.562\r\n\t\tc0.156-0.312,0.703-1.375,1.406-1.016c-0.078,0.141-0.328,0.953-0.078,1.047c0.031-0.375,0.219-0.562,0.281-0.938\r\n\t\tc0.156,0.125,1.188,0.297,1.234,0.188c0.359,0.25,0.812,0.719,1.156,0.844c0.391-0.531,0.234-0.016,0.375,0.219\r\n\t\tc0.797-0.922,0.828,0.391,0.156,1.344c0.016,0,0.891-0.281,0.953-0.375c0.25,0.438,0.688,0.797,0.938,1.406\r\n\t\tc0.297-0.359,0.312-1.062,0.812-0.797c-0.016-0.516,0.016-0.453,0.422-1.016c1.172,0.922,0.078,2.5,1.016,3.367\r\n\t\tc0.625-0.375,0.984,0,1.125,0.562c0.375-0.562-1.094-2.133-0.562-3.086c0.672,0.312,1.234,0.281,1.25,1.172\r\n\t\tc0.094-0.297,0.172-0.406,0.203-0.766c0.859,0.344,0.641-0.219,1.016-0.719c0.406,0.719,0.312,0.156,1.188,0.609\r\n\t\tc0.266,0.203-0.281,0.891,0.484,0.922c0.156-0.281-0.109-0.031-0.031-0.375c0.453,0.219-0.141,0.125,0.312,0.344\r\n\t\tc0.484-0.25-0.359-0.688,0.75-0.156c-0.297-1,0.594,0.156,1.016-0.547c0.094,0.156,0.219,0.328,0.312,0.5\r\n\t\tc0.281-0.547,4.984,2.477,5.891,2.883c-0.219,0.5-0.859,0.125-1.047,0.531c0.344,0.156,1.25-0.219,1.5,0.062\r\n\t\tc0.578,0.688-0.469,0.75-0.656,1c0.234-0.062,1.047-0.062,1.094-0.031c-0.188,0.375,1.219,0.75,1.391,1.594\r\n\t\tc-1.484,0.562-2.672-0.594-4.219-1.156c-1.891-0.594-2.297-0.781-4.047-0.625c0.562,0.375,1,0.125,1.594,0.125\r\n\t\tc0.984,0.031,1.938,0.656,2.953,1.062c-0.141,0.156-0.281,0.312-0.422,0.5c1.375,0.625,1.469-0.062,2.781,0.5\r\n\t\tc-0.25,0.469-1.75,1.062-1.562,0.688c-0.234,0.094-0.422,0.156-0.625,0.25c0.125,0.031,0.188,0.125,0.219,0.281\r\n\t\tc-0.031,0.094,2.375-0.156,2.75-0.219c-0.125,0.188-0.016,0.281-0.094,0.469c0.156,0.094,0.281,0.094,0.656,0.281\r\n\t\tc0.469-0.969,3.969,0.656,3.859,1.344c-0.641,0.062-1.203,0.281-1.734,0.25c-0.844-0.031-1.641-0.594-2.672-0.469\r\n\t\tc0.891,0.375,1.234,0.5,1.922,0.75c-0.781,1.5-1.953-0.25-2.719-0.125c-0.031,0.094-0.047,0.188-0.219,0.094\r\n\t\tc0-0.031,0.031-0.031,0.031-0.062c-0.125,0.062-0.234,0.25-0.312,0.469c0.531-0.25,1.203-0.125,1.766,0.406\r\n\t\tc-0.266,0.656-1.234,0.719-1.766,0.438c-0.25,0.438,0.344,0.188-0.422,0.719c0.359,0.031-0.812,0.844-1.047,1.094\r\n\t\tc-0.109-0.344-0.625-0.938-0.938-0.25c0.438,0.344,0.844,0.375,1.219,1.031c-0.25-0.062-0.344-0.219-0.641-0.281\r\n\t\tc-0.781,1.25,1.297,0.25,0.5,2.094c-0.5-0.219-1-0.594-1.516-0.938c-0.047,0.219-0.094,0.844-0.641,0.562\r\n\t\tc-0.203,0.344-0.047,0.344,0.141,0.562c0.062-0.156,0.219-0.25,0.406-0.312c0.125,0.406,0.031,0.438-0.031,0.656\r\n\t\tc0.531,0.188-0.094,1.031-0.234,1.438c-0.422-0.156-0.641-0.625-1.125-0.812c-0.047,0.094,0.328,0.688,0.422,0.875\r\n\t\tc-0.25-0.125-0.312,0.188-0.562,0.281c0.172,0.031,0.281-0.031,0.422,0c0,0-0.172,0.562-0.203,0.438\r\n\t\tc2.062,0.781-0.094,0.781-0.719-0.5c-0.312,0.219-0.906,1.219-0.438,1.406c0.594-0.5,0.344-0.25,0.875,0\r\n\t\tc-0.281,0.656-0.875,0.156-1.031,0.625c-0.281-0.156-1.906-0.469-1.328-1.281c-0.422-0.188-1.172,0.5-1.625,0.375\r\n\t\tc0.234,0.156,0.391,0.344,0.641,0.438c-0.016-0.125-0.062-0.25-0.094-0.406c0.562,0.281,1.312-0.062,1.188,0.844\r\n\t\tc0.766,0.312,0.266,0.5,0.203,0.469c0.172,0.125,0.328,0.25,0.516,0.375c-0.234,0.062-0.234,0.219-0.203,0.438\r\n\t\tc-0.281-0.062-0.422-0.281-0.625-0.438c-0.156,0.281,0.312,0.531,0.484,0.75c-0.109,0.062-0.219,0.125-0.344,0.188\r\n\t\tc0.125,0.344,0.312,0.125,0.156,0.562c-1.312-0.438-0.438-2.094-1.125-2.188c0.031-0.188-0.047-0.312-0.219-0.469\r\n\t\tc-0.156,0.375-0.625,11.094-1,11.234c-0.031-0.547-0.312,10.078,0,10.078c-0.141,0-0.281,0-0.406,0\r\n\t\tc0.125,0,0.125-10.047,0.125-10.047c0.438,0.25,2.094-5.297,0.562-4.859c0.562,0.328,1.203-1.188,1.5-1.062\r\n\t\tc-0.094,0.125-0.203-1.125-0.312-0.984c0.188,0.094,0.188-0.766,0.25-0.922c0.5,0.219-0.25,1.438-0.312,1.625\r\n\t\tc-0.391-0.188-1.625-0.969-1.234-1.906c0.016,0-0.422-1.219-0.547-1.406c-0.516-0.219-0.938-0.891-1.453-1.188\r\n\t\tc-0.594,1.109,1.734,0.906,1.359,1.969c-0.625-0.266-1-0.156-1.688-0.734c-0.109,0.281-0.594,0.266-0.812,0.484\r\n\t\tc0.125,0.031,0.156,0.125,0.156,0.25c0.406-0.688,1.312-0.156,2.062,0.219c-0.266,0.656-0.219,0.438-0.781,0.156\r\n\t\tc-0.031,0.031-0.375,0.5-0.406,0.562c0.656,0.438,0.938,0.062,1.469,0.25c0.562,0.312,0.562,0.594,1.469,1\r\n\t\tc-0.203,0.344-0.688,0.344-0.922,0.625c-0.062-0.062-0.109-0.156-0.172-0.219c-0.125,0.344-0.234,0.156-0.375,0.531\r\n\t\tc-0.531-0.625-1.75-0.125-2.344-0.312c-0.281,0.594-1.375,0.281-1.844,0.438c0.094-0.219-1.312-0.688-1.5-0.312\r\n\t\tc-0.094-0.062-0.891-0.125-0.688-0.344c-0.531-0.125-0.312-0.812-0.469-0.906c-0.656,1.344-0.219,0.969-1.312,1.781\r\n\t\tc-0.719,0.531-2.062,0.062-2.469,1.094c-0.344-0.188-0.281-0.688-1.062,0.031c0.469-1-1.156-0.656-1.672-1.188\r\n\t\tc-0.344,0.625-0.188,0.5-0.797,0.344c0.156,1.125-0.281,1.219-0.906,0.969c-0.125,0.219,0.172,0.375,0.344,0.531\r\n\t\tc-0.156,0.312-0.391,0.375-0.594,0.812c-0.125-0.125-0.25-0.25-0.406-0.406c-0.031,0.281-0.031,0.469-0.031,0.719\r\n\t\tc-0.25-0.062-0.344-0.031-0.562-0.094c-0.094,0.062-0.203,0.125-0.281,0.219c0.406,0.188-0.906,1.344-1.094,1.25\r\n\t\tc-0.094,0.25-0.531,1.188-1.062,0.938c-0.062,0.25,0,0.781,0.094,1.125c-0.375-0.125-0.281,0.031-0.656,0.031\r\n\t\tc0-0.5-0.328-0.344,0-0.906c-0.125,0.125-0.25,0.25-0.344,0.375c-0.219-0.062-0.109-0.406-0.031-0.562\r\n\t\tc-0.125,0.062-0.25,0.125-0.375,0.156C218.812,229.75,218.328,229.844,218.281,229.719z M247.688,243.125\r\n\t\tc0.078-0.188,0.328-0.594,0.5-0.531c-0.141,0.406-0.219,0.469-0.422,0.719C248.078,242.5,247.828,243.219,247.688,243.125z\r\n\t\t M245.703,255.344c-0.375,1.25-2.531-0.938-2.875,0.062c-0.312-0.562-0.812-0.594-1.406-0.156c0.25-0.719-1.062-0.281-1.422,0\r\n\t\tc0.125-0.219-0.016-0.312-0.359-0.312c0.219-0.406,1.469-0.406,1.688-1.281c0.234,0.094,0.688,0.312,0.656,0.406\r\n\t\tc1.312,0.531,0.625-0.812,0.438-0.188c-0.469-0.219-0.406-0.188-1.062-0.375c0.125-0.062,0.188-0.156,0.281-0.219\r\n\t\tc-0.406-0.188-0.344,0.031-0.656,0.094c0.219-0.875,0.969-0.562,1.25-1.469c-0.188,0-0.391,0-0.594-0.031\r\n\t\tc0.656-0.438,0.406-0.375,0.562-0.812c-0.031-0.031,0.953,0.156,0.562,0.344c0.516,0.156,0.812-0.438,1.031-0.344\r\n\t\tc0.062-0.188,0.062-0.25,0.219-0.562c-0.719-0.25-0.625-0.375-0.203-0.781c-0.422-0.156-0.844-0.625-1.078-0.062\r\n\t\tc-0.562-0.656,0.266-1.25,0.547-1.906c-0.391-0.094-0.578,0.188-0.797,0.062c0.203-0.562,0.062-0.125-0.281-0.25\r\n\t\tc0.125-0.094,0.234-0.188,0.312-0.25c0.031,0,0.109,0.188,0.203,0.25c0.234-0.344,0-0.188,0.484-0.5\r\n\t\tc-0.531-0.312,0.094-1.562,0.25-2c0.469,0.156,0.891-0.406,1.094-1c0.375,0.156-0.172,0.312,0.156,0.438\r\n\t\tc0.25-0.5,0.125,0,0.594-0.312c-0.031,0.125,0.422,0.062,0.219,0.75c-0.125,0.312-0.953,0.281-1.156,0.969\r\n\t\tc0.656-0.094,1.312,0,1.719,0.438c-0.312,0.844-1.484,0.969-1.094,1.875c-0.25-0.062-0.469,0-0.562,0.156\r\n\t\tc0.594,0.156,1.719,3.219,1.531,3.812c-0.125-0.219-0.094-0.312-0.297-0.438c-0.141,0.438,0.391,0.844,0.141,1.406\r\n\t\tC248.297,254.031,244.141,254.844,245.703,255.344z M237.203,251.969c0.094-0.281,0.156-0.562,0.281-0.781\r\n\t\tc0.125,0.094,0.219,0.188,0.344,0.312c0.203-0.469,0.938-0.844,1.156-1.469c-0.188-0.094-0.625-0.062-1-0.219\r\n\t\tc0.125-0.281,0.703-0.562,0.969-0.5c-0.156-0.375-0.203-0.281-0.062-0.719c0.25,0.125,0.531,0.219,0.781,0.438\r\n\t\tc0.156-0.5,0.25-0.25,0.656-0.438c-0.781-0.312,0.75-1.031,0.562-0.312c0.156-0.031,0.172-0.125,0.25-0.25\r\n\t\tc-0.062,0.375,0.219,0.188-0.094,0.656c1-0.406,0.969,0.594,0.828,1.188c-0.234-0.031-0.516-0.062-0.734-0.094\r\n\t\tc-0.25,0.656-0.688,1.438-0.953,2.25c-0.141-0.062-2.453,0.75-2.078,0.094c-0.25,0.031-0.469,0.062-0.703,0.094\r\n\t\tc0.047-0.156,0.234-0.219,0.391-0.188C237.516,251.906,237.453,251.906,237.203,251.969z M236.609,233.156\r\n\t\tc0.156-0.188-1.344-0.844-1.594-1.188c0.688,0.25,0.312,0,0.906,0.031c-0.031,0-1.188-1.375-1.188-1.375\r\n\t\tc0.391,0.156,1.062,0,1.438,0.094c-0.469-0.281-0.062-0.125-0.234-0.5c0.203,0.062,0.188,0.219,0.312-0.031\r\n\t\tc-0.016-0.062-0.047-0.125-0.078-0.188c-0.422,0.047-0.656-0.062-0.938-0.172c0.25-0.359,0.328-0.297,0.469-0.766\r\n\t\tc0.375,0.219,0.188,0.031,0.484-0.125c0.047,0.594,0.156,0.531,0.297,1c-0.031-0.125-0.062-0.75-0.031-0.906\r\n\t\tc1,0.375,0.5,1.188,0.312,1.75c0.094,0.031,0.156,0.062,0.25,0.094c0.609-1.281,0.125-0.031,0.375-0.188\r\n\t\tc0.781-1.844,0.016-0.344,0.641-0.812c-0.016,0.25-0.109,0.688,0.125,0.781c0.266-0.656,0.406-0.25,0.922-0.5\r\n\t\tc-0.125,0.438-0.031,0.406-0.047,0.875c0.047-0.219,0.078-0.438,0.125-0.688c0.438,0.156,0.891,0.5,1.312,0.531\r\n\t\tc0.641-0.719,0.547,0.469,1.484,0.25c-0.078,0.25-0.719,0.469-0.875,1.062c0.906,0,0.734,0.656,0.531,1.25\r\n\t\tc-0.25-0.094-0.125-0.094-0.328-0.312c-0.266,0.75-1.578,0.469-2.297,0.844c0-0.125,0-0.25,0-0.375\r\n\t\tc-0.125,0.531-0.609-0.062-0.938-0.188c-0.094,0.188-0.281,0.562-0.328,0.75c0-0.125-0.016-0.25-0.016-0.375\r\n\t\tc-0.594,0.25-0.719-0.156-1.344-0.375C236.516,233.375,236.891,233.312,236.609,233.156z M234.797,229.75\r\n\t\tc0.094,0.094,0.156,0.062,0.188-0.094c0.031,0.062,0.078,0.109,0.109,0.156C235,229.766,234.891,229.828,234.797,229.75z\r\n\t\t M236.266,228.812c0.094,0,0.922-0.312,0.641,0.25C236.688,228.969,236.469,228.875,236.266,228.812z M242.578,246.656\r\n\t\tc-0.125,0.344,0.141,0.562-0.406,0.562c-0.031-0.062-0.062-0.125-0.094-0.219C242.578,247.219,241.859,246.406,242.578,246.656z\r\n\t\t M242.688,246.344c0.078-0.219-0.359-1.344,0.25-1.125c-0.078,0.25-0.422,0.375-0.172,0.469\r\n\t\tC242.656,246.062,243.078,245.969,242.688,246.344z M242.453,244.875c0.125-0.312,0.219-0.656,0.312-0.938\r\n\t\tc0.062,0,0.484,0.062,0.797-0.062C243.359,244.438,242.984,244.75,242.453,244.875z M245.406,216.312\r\n\t\tc-0.203,0.406-0.016,0.562,0.344,0.469c-0.203,0.406,0.203-0.125-0.078,0.469C245.016,217.062,244.266,216.531,245.406,216.312z\r\n\t\t M224,214.781c0-0.344,0,0.531,0,0.844C224,215.625,224,214.969,224,214.781z M244.266,217.219\r\n\t\tc-0.156,0.094-0.281,0.188-0.453,0.312c-0.016-0.219-0.031-0.406,0.031-0.656C244.203,217,243.891,217.062,244.266,217.219z\r\n\t\t M242.922,218.031c-0.234-0.125-0.469-0.219-0.75-0.312C242.578,217.031,243.172,217.562,242.922,218.031z M224.188,277.344\r\n\t\tc-0.078,0.312-0.016,0.375-0.375,0.188C223.984,277.25,223.688,277.188,224.188,277.344z M223.578,276.75\r\n\t\tc-0.266,0.125-0.266,0.375-0.594,0.281C223.203,276.406,223.156,276.969,223.578,276.75z M218.703,231.031\r\n\t\tc-0.125,0.188-0.125,0.094-0.312,0C218.609,230.5,218.453,230.875,218.703,231.031z M264.656,334.25\r\n\t\tc-0.109-0.031-0.359-0.344-0.312-0.438c-0.062,0.219-0.391,1.219-0.25,1.25c-0.25,0.219-2.109,2.594-2.203,2.562\r\n\t\tc-0.125,0.812-1.25,1.188-1.438,1.906c-0.266,0.781-1.906,1.25-1.938,1.375c-1.5-0.094-0.969-1.594-1.5-1.719\r\n\t\tc0-0.125,0.078-1.938,0.531-1.812c0.188-0.219,2.531-2.344,1.25-2.344c0.312-2.031,3.25-0.781,3.781-2.062\r\n\t\tc0.031,0.094,0.047,0.188,0.078,0.281c0,0,1.047-0.781,0.594-0.781c0.188,0.031,0.328-0.094,0.797-0.094\r\n\t\tc-0.016-0.344,0.281-0.906,0.781-1.219c0,0.062,0.672,1.625,0.406,1.562c-0.078,0.094-0.156,0.219-0.25,0.344\r\n\t\tC265.438,333.188,265.016,333.875,264.656,334.25z M258.703,324.656c-0.188-0.094-0.125-0.281,0-0.469\r\n\t\tC259.031,324.5,258.703,324.469,258.703,324.656z M296.281,318.406c-2.719,1.781-0.828-3.312-0.234-3.312\r\n\t\tC295.984,316.438,297.188,316.75,296.281,318.406z M322.719,355.406c-0.547,0-1.688,0.875-2.062,1.062\r\n\t\tc0.109-0.125,0.375-1.156,0.438-1.219c0.906-0.844,1.078,0.031,2.25-0.688C323.156,354.875,322.953,355.156,322.719,355.406z\r\n\t\t M323.578,354.25c0.156-0.062,0.203-0.125,0.141-0.25c0.375-0.219,0.25,0.094,0.25,0.094\r\n\t\tC323.859,354.094,323.656,354.25,323.578,354.25z M334.781,339.094c-0.125,0.406,0.047,0.219,0.453,0.125\r\n\t\tc-0.312,0.5,0.141,0.312-0.312,0.906c0.359-0.156,0,0.906-0.141,1.188c0.188-0.281,0.062,0,0.375,0\r\n\t\tc-0.234,0.531-0.094,1.594-0.266,1.781c0.109,0-1.062,1.844-1.062,1.875c-0.391,0.562-0.703,1.094-1.297,1.719\r\n\t\tc-0.312,0.688-1.734,1.25-1.906,1.781c-1.375,0-2.391,2.875-3.438,2.875c-0.594,0.531-0.656,0.844-1.562,1.125\r\n\t\tc0.031-0.031-1.938,1.125-2.188,1.125c0.344-0.344-0.062-0.094-0.156-0.312c0.062-0.031,0.234-0.125,0.281-0.219\r\n\t\tc-0.125,0.062-0.281,0.125-0.406,0.188c0.047-0.156,0.375-0.375,0.469-0.5c-0.75,0-1.266,0.969-2.125,0.969\r\n\t\tc0.062-0.094,0.109-0.156,0.125-0.25c-0.156,0.031-0.156,0.031-0.047-0.094c-0.359,0.062-0.531-0.062-0.828,0\r\n\t\tc-0.031-0.188,0.156-0.469-0.078-0.375c0.312-0.469,0.594-1.094,0.828-1.312c-0.219,0.062-0.438,0.125-0.656,0.156\r\n\t\tc0.281-0.375,0.453-0.688,0.688-1.031c-0.203,0.188-0.656,0.375-1.016,0.594c0.109-0.094,0.234-0.188,0.359-0.25\r\n\t\tc-0.094,0,0.812-0.875,1.031-1.062c-0.641,0.188-1.766,0.781-2.234,1.219c0.047-0.094,0.016-0.188-0.094-0.188\r\n\t\tc0.094-0.469,0.391-0.344,0.016-0.844c0.156-0.125,0.281-0.094,0.406-0.219c-0.109,0.031-0.25,0.031-0.391,0.031\r\n\t\tc0.359-0.5-1.797-0.656-1.875-0.344c-0.547,0-3.344,0.5-3.453,0.875c-0.5,0-1.688,0.656-2.156,0.906\r\n\t\tc-0.859,0.5-2.172-0.344-3,0.719c-0.219-0.281,0-0.062-0.156-0.312c-0.719,0.688-1.094,0.594-2.031,0.594\r\n\t\tc0.234-0.281-0.25-0.281-0.406-0.469c1.484-1.188,1.469-2.375,2.5-4c-0.25,0-0.156-0.188-0.375-0.188\r\n\t\tc0.078-0.219,0.141-1.719,0.344-1.719c0.031,0.469,0.031,0.312,0.125,0.625c0.062-0.031,0-0.344,0-0.625\r\n\t\tc-0.031,0,0.156,0.188,0.312,0.312c0.609-0.672,0.703-2.562,1.625-2.859c1.297-0.078,3.219-1.578,4.453-1.984\r\n\t\tc1.109,0,2.703-1.469,2.969-1.469c0.203-0.406,0.797-1.25,1.344-1.25c-0.141,0.469,0,0.375-0.141,0.719\r\n\t\tc0.344,0,0.625-0.656,0.906-1.031c0,0.031,0.125,0,0.188,0.125c0.281-0.562,0.766-0.719,1-0.719\r\n\t\tc0.406-0.781,0.719-0.531,1.312-1.281c0.062-0.219,1.125-0.125,0.531,1.094c1.125,0,2.359-1.438,2.906-2.562\r\n\t\tc0.078,0,0.797-0.188,0.625,0.062c0.734-0.062,1.5-0.062,0.656-0.906c0.125-0.062,0.219-0.094,0.344-0.156\r\n\t\tc0.094,0.094,0.109,0.156,0.016,0.25c0.062-0.062,0.141-0.094,0.203-0.156c-0.188,0.438,0.172-0.219-0.062,0.375\r\n\t\tc0.156-0.062,0.5-0.312,0.625-0.312c-0.281,0.406,1.578,0.312,2.062-0.031c-0.188,0.438-1.188,1.125-1.312,1.438\r\n\t\tc0.125,0-0.719,1.094-0.828,1.344c0.781,0,1.453,0.844,1.672,1.625c2.453-0.156,2.875-4.531,4.531-5.656\r\n\t\tc0.219,1-0.031,1.438-0.625,2.688c0.203-0.062,0.516-0.031,0.656-0.312c0.219,0.344,0.281,0.406,0.219,0.562\r\n\t\tc-0.469,0.656-0.312,1-0.469,1.531C334.781,337.656,333.656,339.531,334.781,339.094z M307.641,319.75\r\n\t\tc-0.031-0.031,1.734,1.062,1.578,1.062c0.781,0.875,0.531,1.562,1.188,2.562c0-0.219,0.094-0.312,0.266-0.25\r\n\t\tc0.141,0.719,0.203,1.781,0.938,0.938c-0.141,0.281,0.172,0.062-0.141,0.406c0.891,0,0.031,1.25-0.172,1.656\r\n\t\tc0.141-0.062,0.219,0,0.25,0.125c0.078-0.219,0.25,0,0.594,0c-0.422,0.531-0.484,1.156,0.359,1.156\r\n\t\tc-0.359,0.625,0.094,0.25,0.094,0.75c0,0.125-0.906,1.594-0.969,1.75c-0.406-0.156-0.5,0.062-0.922-0.188\r\n\t\tc-0.047,0.25,0.062,0.219,0.141,0.406c-0.703-0.25-1.625-2-1.562-2c-0.031-0.312-0.469-2.812-0.422-2.844\r\n\t\tc-0.422,0-0.391-1.156-0.484-1.156c0.203-0.531-0.281-1.656-0.594-2.125C307.641,321.781,305.812,319,307.641,319.75z\r\n\t\t M313.719,330.656c0.953,0,2.75-0.312,2.516,0.312c0.484,0,0.453-0.125,1.078-0.125c-0.531,0.469-1.016-0.188-1.156,0.625\r\n\t\tc1.156,0,1.203,0.344,0.75,1.156c-0.594,0-1.672-0.562-2.656-0.562c0,0-2.875-0.781-3.031-0.781\r\n\t\tc0.062-0.219,0.141-0.031,0.219-0.25c-0.281,0-0.531,0-0.812,0C311,329.5,313.094,330.062,313.719,330.656z M315.625,325.062\r\n\t\tc0.188-0.562,1.625-1.812,1.438-1.406c0.469-0.188,0.469,0.094,0.719,0c0.594,0,0.453-0.844,0.703-0.844\r\n\t\tc0.641-0.438,1.859-0.281,2.109-1.188c0.078-0.062,1.969-1.406,1.766-1.406c0.641-0.5,1.047-0.938,1.422-1.625\r\n\t\tc0,0.531,0.297,0.125,0.516,0.125c-0.203,0.625,0.141-0.188-0.109,0.875c0.344,0,0.219-0.156,0.172,0.312\r\n\t\tc0.562-0.031,0.25,0.219,0.641,0.219c-0.172,0.5-0.672,0.5-0.906,0.469c0,0.719-1.062,0.688-0.75,1.125\r\n\t\tc-0.609,0.5-0.75,1.938-0.047,2.469c-1.391,0.219-1.141,1.531-1.891,2.094c-0.391,0.281-1.734,1.562-2,1.906\r\n\t\tc-0.609,0-1.125-0.062-1.844-0.062c-0.094,0.156-1.125-0.125-1.094-0.125c-0.766-0.562-0.453-0.531-0.469-1.75\r\n\t\tc-0.156,0.062-0.312,0.125-0.469,0.156c0.094-0.094,0.172-0.188,0.25-0.281C315.453,326.188,315.656,325.281,315.625,325.062z\r\n\t\t M323.094,306.25c0.203,0.531-1.281,1.938-1.781,1.938c0.156-0.312,0.094-0.406-0.219-0.312\r\n\t\tC320.219,306.531,322.906,305.812,323.094,306.25z M328.625,311.719c-0.391,0,0.141-0.156-0.25-0.156\r\n\t\tc0.25-0.25,0.406-0.406,0.469-0.75c-0.188-0.062-0.297-0.031-0.281,0.156c-0.297-0.438-0.281-0.875-0.156-1.531\r\n\t\tc0.109,0.062,0.219,0.125,0.344,0.188c0.625-1.625,0.438-2.719,2.094-2.719c-0.062,0.156-0.078,0.438-0.312,0.656\r\n\t\tc0.469,0-0.156,2-0.906,2c-0.484,1.781-0.688,1.594,0.656,1.594c-0.047,0.094-0.062,0.188-0.078,0.312\r\n\t\tc0.047,0,0.328-0.188,0.328-0.188c0.266,0.625,0.125,1.062-0.031,1.5c-0.125-0.188-0.438-1-0.641-1\r\n\t\tc-0.047,0.125-0.047,0.188-0.172,0.469c-1.062-1.406-0.938,1.094-1.25,1.094c0-0.188,0.078-0.219,0.125-0.438\r\n\t\tc-0.438,0-0.375-0.5-0.469-0.719C329.562,312.188,328.203,312,328.625,311.719z M330.938,324.969\r\n\t\tc0.016-0.125,0.031-0.219-0.156-0.281c0.375,0,0.484-0.062,0.906-0.062C331.562,324.906,331.188,324.906,330.938,324.969z\r\n\t\t M330.469,322.75c0.188-0.219,0.188-0.281-0.016-0.25c0.047-0.125,0.078-0.281,0.141-0.438\r\n\t\tC330.734,322.406,331.156,322.656,330.469,322.75z M331.641,302.188c-0.172,0.344-0.453,0.656-0.734,0.969\r\n\t\tc-0.734-0.562,0.594-3.125,1.531-3.312C332.469,300.656,331.812,301.312,331.641,302.188z M331.438,312.719\r\n\t\tc-0.156,0.469-0.312,1.031-0.078,1.562c-0.234,0-0.078-0.062-0.172-0.25C331.266,313.844,330.031,313.156,331.438,312.719z\r\n\t\t M330.984,315.219c-0.078,0-0.172,0-0.25,0c-0.047-0.344-0.016-0.625-0.016-0.875c-0.234,0.062-0.25-0.031-0.062-0.281\r\n\t\tC331.125,314.281,331.094,314.812,330.984,315.219z M328.438,315.688c0.031-0.25,0.875-0.812,1.125-1.094\r\n\t\tc-0.156,0.812-0.375,1.5-1.125,1.5C328.578,315.938,328.578,315.781,328.438,315.688z M328.344,315.094\r\n\t\tc0.25-0.719,0.234-1.188,1.062-0.969c-0.109,0.406-0.391,0.75-0.406,0.938c-0.156,0.062-0.188,0-0.062-0.125\r\n\t\tC328.719,315,328.531,315.062,328.344,315.094z M329.5,315.188c0.172-0.188,0.531-0.75,0.656-0.812\r\n\t\tc-0.062,0.312-0.484,1.406-0.938,1.406C329.297,315.594,329.406,315.375,329.5,315.188z M329.688,313.719\r\n\t\tc0.172-0.5,0.703-0.156,0.625,0.062C330.109,313.781,329.922,313.75,329.688,313.719z M330.344,315.562\r\n\t\tc-0.25,0.188-0.766,0.438-0.656-0.094C330.062,315.469,330.141,315.125,330.344,315.562z M328.344,317.281\r\n\t\tc-0.078,0.344,2.25-1.156,2.641-1.219c0.109,0.969-0.391,1.938-0.922,2.688c0.047-0.062,0.031,0.219-0.109,0.219\r\n\t\tc0.047-0.125,0.078-0.188,0.078-0.219c-0.219,0.344-0.531,0.656-0.75,0.969c0.094-0.156,0.062-0.219-0.094-0.125\r\n\t\tc0.062-0.219,0.172-0.188,0.219-0.344c-1.391,0.625-0.469-0.781-0.406-1.188c-0.344,0-0.484,0.062-0.938,0.062\r\n\t\tc-0.031-0.094-0.031-0.188-0.031-0.281c-0.25,0.281-0.359,0.531-0.703,0.594C327.531,317.844,327.719,317.438,328.344,317.281z\r\n\t\t M328.969,327.594c0,0-0.562-0.062-0.719-0.062c0.625-0.406,1.031-0.25,1.875-0.156\r\n\t\tC329.969,327.781,329.406,327.594,328.969,327.594z M330.406,323.281c-0.156,0.375-0.312,0.312-0.578,0.562\r\n\t\tc0.641,0,0.422,0.531,0.047,0.531c0.219-0.719-0.656,0.844-0.578,0.719c-0.156-0.156-0.016-0.188-0.297-0.188\r\n\t\tc0.219-0.688,0.438-0.938,0.438-1.531c0.25-0.375,0.5-0.781,0.844-0.875c-0.25,0.656-0.188,0.594-0.594,1.25\r\n\t\tC329.953,323.688,330.125,323.406,330.406,323.281z M327.312,313.562c0.188,0.031,0.25,0.094,0.188,0.25\r\n\t\tC327.312,313.562,327.312,313.906,327.312,313.562z M327.594,323.5c0.156-0.062,0.188-0.156,0.438-0.156\r\n\t\tc-0.5,1.031-3.188,1.625-3.078,1.125c-0.922,0.125-1.391,1.094-0.938,1.656c0.422,0,1.188-0.344,1.781-0.344\r\n\t\tc-0.203,0.188-0.297,0.281-0.562,0.406c0.156,0.031,0.328,0.062,0.5,0.094c-0.078,0.281-0.359,0.281-0.641,0.281\r\n\t\tc0.016-0.125,0.062-0.25,0.141-0.375c-0.359,0-1.109,0.688-1.516,0.719c0.219,0.281,0.5,1.062,0.672,1.062\r\n\t\tc0.047,0.438-0.094,1.438-1.234,1.438c0.297-0.469,0.219-0.938,0.219-1.531c-1.234,0-0.531,2.062-2.047,2.062\r\n\t\tc0.281-0.844,0.516-1.219,0.844-1.719c-0.844,0,0.469-1.5,0.641-2.031c0.219-0.625,0.938-1.688,1.375-1.938\r\n\t\tC324.469,323.656,326.719,324.25,327.594,323.5z M327.359,327.844c-0.109,0.281-0.297-0.125-0.672-0.062\r\n\t\tc0.25-0.469,1.094-0.188,1.297-0.219C327.75,327.656,327.562,327.75,327.359,327.844z M319.188,332.438\r\n\t\tc0.625,0.188-0.469,0.188,0.75,0.188c-0.016,0.125-0.016,0.25-0.031,0.375c-0.781,0-1.281,0.125-1.719,0.188\r\n\t\tC318.656,332.25,318.906,333.25,319.188,332.438z M318.031,332.969c0.125-0.188,0.031-0.219-0.25-0.156\r\n\t\tc0.203-0.156,0.375-0.469,0.656-0.469c-0.094,0.125-0.062,0.156,0.094,0.094C318.406,332.656,318.188,332.75,318.031,332.969z\r\n\t\t M319.594,333.594C321.828,333.844,319.281,334.531,319.594,333.594L319.594,333.594z M320.344,332.844\r\n\t\tc0.281-0.719,1.906-0.312,2.438-0.375c-0.094,0.188-0.109,0.375-0.312,0.375C322.281,333,320.734,332.812,320.344,332.844z\r\n\t\t M325.734,332.25c-0.672,1-3.547,2-4.109,2.094C321.891,333.594,324.656,332.562,325.734,332.25z M323.859,329.938\r\n\t\tc0.438-1.031,0.078-0.094-0.047-0.562c0.281,0,0.625-0.375,0.906-0.594C324.531,329.375,324.359,329.625,323.859,329.938z\r\n\t\t M324.219,317.375c0.172-0.812,1.625-1.562,1.875-2.156c0.438,0,0.453-0.812,0.766-0.812\r\n\t\tC326.75,315.25,325.219,317.375,324.219,317.375z M317.75,332.375c-0.141,0.125-0.391,0.375-0.578,0.375\r\n\t\tc0.109-0.188,0.328-0.375,0.016-0.375C317.391,332.219,317.328,331.969,317.75,332.375z M312.781,328.031\r\n\t\tc0.062-0.188-0.25-0.812-0.391-0.812c0.281-0.719,0.109-0.219,0.344-0.531c0.109,0.094-0.078,0.406,0.234,0.125\r\n\t\tC312.906,326.906,313.453,328.031,312.781,328.031z M307.562,326.844c0.125-0.375,0.047-0.312-0.031-0.688\r\n\t\tC307.5,326.125,308.469,326.844,307.562,326.844z M307.188,323.656c0.344,0,0.094-0.094,0.375-0.094\r\n\t\tc-0.094,0.312,0.188,0.281,0.047,0.688C307.531,323.938,307.359,323.875,307.188,323.656z M331.938,329.781\r\n\t\tc-0.047,0.188-0.719,0.719-0.812,0.719c0.109-0.156,0.734-1.094,0.469-1.094c0.406,0,0.234,0.094,0.484,0.094\r\n\t\tC332,329.562,331.328,330.031,331.938,329.781z M340.062,330.062c-0.375,0.688,0.156-0.344-0.188,0.625\r\n\t\tc0.219,0.312,0.094,0,0.188,0.5c0.078-0.062,0.188-0.094,0.312-0.062c-0.125,0.406,0.25,0.281,0,0.656\r\n\t\tc-0.219,0.094-1,0-0.906-0.156c-0.109,0.094-0.219,0.156-0.312,0.188c0.094-0.375-1-0.875-0.672-1.594\r\n\t\tc-0.484,0.094-4.547,1.969-3.891,0.656c-0.656,0-1,0.156-1.625,0.438c0.438-0.469,0.562-0.5,1.031-0.469\r\n\t\tc0.141-0.562,0.188-2.5,0.141-2.469c-0.141,0.062-0.312,0.125-0.453,0.188c-0.094-0.844-0.797-0.5-1.25-0.719\r\n\t\tc0.062-0.094,0.156-0.156,0.219-0.25c-0.266,0-0.516-0.188-0.438-0.469c-0.219,0.062-0.625,0.438-0.75,0.594\r\n\t\tc0.078-0.125,0.047-0.156-0.094-0.125c0-0.156,0.094-0.25,0.234-0.25c0,0-0.25-0.25-0.25,0.031\r\n\t\tc0.297-0.469,0.219-0.562-0.234-0.406c0.156-0.594,1.312-0.188,1.547-0.688c-0.219,0.031-0.453,0.062-0.672,0.094\r\n\t\tc0.172-0.25-0.031-0.281-0.484-0.094c0.172-0.375,0.062-0.375-0.469-0.312c0.609-1.219,1.562-0.75,2.297-1\r\n\t\tc-0.062,0.156-0.344,1.156-0.406,1.656c0-0.156,0.094-0.219,0.297-0.156c-0.234,0.75,0.109,0.188-0.141,0.688\r\n\t\tc1.062-0.188,1.578-1.625,2.75-1.625c0.625-0.031,1.688,1.125,2.5,0.844c-0.031,0.125,0.812,0.812,1.234,0.688\r\n\t\tc-0.172,0.438,0.234,1.5,0.984,1.125c-0.094,0.25-0.5,0.938-0.656,0.938C339.812,329.312,339.312,330.281,340.062,330.062z\r\n\t\t M337.25,297.781c0,0.219-0.281,0.406-0.406,0.5C336.906,297.781,336.969,298.094,337.25,297.781z M336.906,291\r\n\t\tc0.172-0.062,0.344-0.125,0.484-0.188C337.219,291.219,337.125,290.969,336.906,291z M339.562,290.906\r\n\t\tc-0.469,0.094-0.219-0.125-0.219-0.438c0.281-0.125,0.344-0.031,0.281,0.156c0.547-0.844,0.625-0.375,1.219-0.438\r\n\t\tc-0.078,0.625-0.094,0.438,0.125,0.875c-0.125,0.188-0.344,0.656-0.469,0.656c-0.078,0.344-0.406,1.531-0.891,1.531\r\n\t\tc0.078-0.25,0.203-0.531,0.281-0.781c-0.234,0.25-0.234,0.5-0.641,0.5c0.031-0.25,1-1.938,0.594-1.938\r\n\t\tC339.531,292.031,339.359,291.562,339.562,290.906z M344.156,326.219v0.031c0,0-0.125,0.094-0.25,0.188\r\n\t\tc-0.609,0.594-1.312,1.719-2.578,1.719c0.141-0.156,0.078-0.188-0.141-0.188c0.594-0.094,0.875-0.562,1.406-0.75\r\n\t\tc-0.094,0.219,0.844-0.469,1.312-0.781C344,326.344,344.078,326.281,344.156,326.219c0.031-0.219,0.062-0.438,0.094-0.688\r\n\t\tc-0.375,0.094-0.094-0.156-0.562-0.25c0.25-0.188,0.359-0.031,0.688-0.031c-0.266,0.344,0.188,0.5,0.219,0.812\r\n\t\tC344.438,326.062,344.297,326.125,344.156,326.219z M345.031,327.281c-0.375,0.094,0.109-0.219-0.188-0.094\r\n\t\tc0.188-0.469,0.156-0.344,0.281-0.688c0.094,0,0.375,1.25,0.281,1.25C345.031,328.25,344.625,327.906,345.031,327.281z\r\n\t\t M345.75,329.125c-0.031-0.25-0.406-0.25,0.125-0.5C345.812,328.812,345.797,328.969,345.75,329.125z M346.375,329.969\r\n\t\tc0.266-0.25,0.125-0.781,0.656-0.281C346.938,329.938,346.719,330.031,346.375,329.969z M346.375,328.406\r\n\t\tc0.266-0.312,0.156-0.125,0.516-0.25c-0.031,0.156-0.016,0.312,0.078,0.406C346.75,328.906,346.625,328.406,346.375,328.406z\r\n\t\t M347.062,330.312c-0.234,0-0.031-0.062,0.031-0.219c0.094,0,0.188,0.031,0.281,0.031\r\n\t\tC347.5,330.688,347.25,330.219,347.062,330.312z M346.656,288.344c0.062-0.25,0.281-0.844,0.281-1.125\r\n\t\tc-0.531,0.781-0.531,0.75-0.969,1.656c-0.156-0.094-0.156-0.25-0.062-0.438c-0.375,0.25-0.812,0.344-1.188,0.625\r\n\t\tc0-0.219,0.141-0.156,0.172-0.312c-0.531-0.125-0.297-0.031-0.703,0.219c0.531,0-0.75,1.156-0.906,1.25\r\n\t\tc-0.297-0.375-0.25-0.875,0.172-1.312c-0.609,0.062-0.266-0.062-0.609-0.094c-0.031,0.125-0.094,1.156-0.031,1.156\r\n\t\tc-0.422,0.781-1,0.219-1.281,1.5c-0.688-1.062,0.156-1.75,1.125-2.312c-0.688-0.031-1.469,0.438-2.281,0.625\r\n\t\tc0.109-0.25,1.812-1.719,1.75-1.312c0.094-0.062,0.188-0.125,0.281-0.188c-0.156,0.062-0.188,0-0.094-0.125\r\n\t\tc0.422,0,0.891-0.406,1.344-0.031c0.141-0.156,0.344-0.375,0.453-0.531c0.172-0.094,0.234-1.719,1.047-2.156\r\n\t\tc-0.406,0.469-0.234,0.625-0.344,0.969c2.156,0,2.188-5.062,3.062-5.906c-0.031,0.156-0.031,0.312-0.031,0.469\r\n\t\tc0.172-0.031,0.328-0.031,0.5-0.062c-0.156,0.438,0.234,1.188,0.188,1.812C347.531,282.719,347.344,287.75,346.656,288.344z\r\n\t\t M350.734,277.969c0-0.5-1.016,1.281-1.047,1.281c-0.688,0.094-1.094-0.656-1.234-0.094c-0.438,0-0.562-0.219-0.641,0.406\r\n\t\tc0.703-0.094,0.188,0,0.625,0.219c-0.406,0.094-0.516,0.344-0.875,0.438c0-0.812,0.25-1.562,0.25-2.062\r\n\t\tc0,0,0.562,0.094,0.719,0.188c0.031-0.594,0.406-3.125,0.531-3.031c0.578,0.344,0.375,2.125,1.5,1.438\r\n\t\tc0.125,0.062,0.062,0.344,0.219,0.438c0.125-0.094,0.234-0.156,0.344-0.25c-0.031,0.188-0.078,0.344-0.125,0.5\r\n\t\tc0.312,0,0.25,0.062,0.312,0.438C351.125,277.906,350.938,277.938,350.734,277.969z M351.047,270.781\r\n\t\tc-1.141-2.156-0.859,3.938-0.859,3.938c-0.25,0.094-0.125-0.844-0.719-0.688c-0.312,0.094,0.062,0.844-0.406,0.844\r\n\t\tc0-0.125,0.438-1.281,0.188-1.281c0-1.719,0.281-3.531,0.281-5.469c-0.125,0.031,0.531-3.844,0.609-3.938\r\n\t\tc0.281,1,0.422,2.562,0.328,3.406c-0.094,0.594-0.219,1.312-0.125,1.844C350.484,270,351.047,270.094,351.047,270.781z\r\n\t\t M353.5,274.875c-0.375,0.5-0.656,0.75-1.094,1.188c0.156-0.438,0.891-1.625,1.125-1.625\r\n\t\tC353.516,274.594,353.516,274.75,353.5,274.875z M353.969,274.531c0-0.344,0.531-1.156,0.531-0.938\r\n\t\tC354.312,273.969,354.312,274.25,353.969,274.531z M357.641,267.781c0-0.188,0.453-0.969,0.453-0.562\r\n\t\tC358.094,267.438,357.812,267.656,357.641,267.781z M366.188,234.188c0.422-0.188,0.531-0.219,1.062-0.469\r\n\t\tc0.922,0.781-0.672,1-1.156,1.188C366.016,234.688,366.188,234.438,366.188,234.188z M362.156,237.625\r\n\t\tc-0.125,0-0.188,0.062-0.156,0.188c-0.125,0.031-0.562-0.312-0.391-0.375C361.5,237.406,361.938,237.375,362.156,237.625z\r\n\t\t M352.594,238.406c-0.094-0.594,0.531,0.188,0.844,0.156c-0.594,0.188-0.875,0.344-1.297,0.406\r\n\t\tC352.141,239,352.594,238.031,352.594,238.406z M351.75,238.094c-0.141-0.094-0.031-0.344-0.25-0.312\r\n\t\tc0.219,0.375,0.5,0.906-0.062,1.688c0.391,0,0.031-0.219,0.391-0.219c0.078-0.406,0.25-1.125,0.344-1.438\r\n\t\tc0,0.281,0.047,0.25,0.109-0.031c0.156,0.5-0.125,0.875-0.453,1.469c0.141-0.125,0.172-0.031,0.141,0.125\r\n\t\tc0.766-0.5,3-1.281,3.938-1.375c1.766-0.625,1.062,0.969,2.328,1.812c-0.062-0.094-0.047-0.156,0.062-0.156\r\n\t\tc0.078,0.25,0.141,0.625,0.172,0.938c-0.344-1.906,2.156-1.719,2.047-2.094c0.5,0.406,0.922,0.25,1.141-0.375\r\n\t\tc0.188,0.625,0.531,0.875,0.734,1.594c1.062-0.906,0.5-1.594,0.172-2.75c0.781,0.094,1.547-0.188,2.062-0.594\r\n\t\tc0.094,0.312,1.031,0.938,1.469,0.438c0.094,0.312,1.75,1.219,2.062,1.688c0.844,0.594,1.734,0.719,1.938,2.156\r\n\t\tc0.328-0.125-0.312-1,0.594-1.156c0,0.125,0.297,0.156,0.297,0.156c0.578,0.125,0.484,1.062,1.125,0.844\r\n\t\tc0.062,0.406-0.25,0.625-0.109,1.062c-0.359,0.188-0.484,0-0.719,0.219c0.094,0.469,0.266,0.219,0.094,0.938\r\n\t\tc0.094-0.031,0.281,0.531,0.406,0.688c-0.281,0.094-0.156-0.156-0.219,0.25c-0.062-0.125-0.156-0.25-0.234-0.375\r\n\t\tc-0.078,0.156-0.172,0.312-0.234,0.469c-0.391-0.594-0.422-0.25-0.719-0.344c-0.188-0.531-0.531-1.188-1.094-1.188\r\n\t\tc-0.375,1.875-0.781-0.312-0.828-0.812c-0.641,0.406,0.031,1.562,0.016,2.156c-0.016,0.938-1.391,0.844-1.047,1.656\r\n\t\tc0.203-0.062,0.141-0.188,0.297-0.281c0.203,0.75,1.375,2.312,0.438,2.688c0-0.719-1.719,1.281-1.969,1.781\r\n\t\tc-0.062-0.062-0.125-0.156-0.203-0.25c0,0.688,0.109,0.312-0.281,0.594c0.141,0.469-0.141,0.5-0.203,0.562\r\n\t\tc0,0.625-0.547,1.125-0.406,2c-0.734-0.281-0.625-0.781-1.297-0.844c-0.391,0-0.484,1.25-0.875,1.75\r\n\t\tc0.062-0.406-0.016-0.781-0.016-1.156c-0.469,0.156-0.344,1-0.656,1.188c-0.25-0.719-0.609,0.219-0.781,0.531\r\n\t\tc-0.203,0.312-0.531,2.312-0.281,2.688c0-0.406,0.781,0.188,0.25,0.688c-0.375,0.438,0.062,1.062,0.125,1.5\r\n\t\tc0.094-0.062,0.219-0.125,0.312-0.219c0.094,0.844-0.344,0.438-0.375,0.594c-0.125,0.5-0.406,0.969-0.531,1.625\r\n\t\tc-0.062,0.312,0.438,0.375,0.25,0.875c-0.156,0.438-0.547-0.062-0.703,0.375c0,0.469-0.578,2.094-0.766,2.125\r\n\t\tc0,1.031-0.531,2.219-1.25,2.906c0-1.281-1.719-7.688-0.156-8.031c0-1.906,1.375-2.969,2.141-4.969\r\n\t\tc0-0.531,0.078-1.531,0.609-1.688c1.156-0.25-0.125-2.562,1.047-2.594c-0.734-0.562-0.391-0.156-1.047-0.031\r\n\t\tc0.312-0.094-0.031,2.156-0.031,1.188c-0.578,0.188-0.75,1.406-1.172,2.156c-0.016-0.375-0.047-0.406,0.016-0.844\r\n\t\tc-0.188,0.031-0.188,0.219-0.281,0.375c0.062-0.375,0.156-0.938,0.062-1.312c-0.25,0.219-1.438,0.719-1.906,0.844\r\n\t\tc-0.531,0.781-1.344,2.531-1.125,3.375c0.156-0.125,0.281-0.188,0.453-0.281c0.062,0.625-0.984,1.219-1.859,1.594\r\n\t\tc0.031-0.719-0.391-0.5,0.406-0.906c-0.625-0.531-0.281-0.625-0.906-0.156c0-0.375-1.297-0.312-1,0.688\r\n\t\tc-0.875,0.156-1.25-0.469-1.781,0.375c-0.141-0.562-0.25-0.312-0.641-0.719c0,0.281-0.797,0.281-1.078,0.531\r\n\t\tc0.031-0.125,0.062-0.25,0.094-0.344c-1.609,0.312-1.75,3.812-3.094,4.562c0.094,1.531-7.094,2.469-7.094,3.969\r\n\t\tc0.328-0.031-4.156-0.062-4.156-0.125c0,0.406,0,0.875,0,1.312c0,0,5.359-0.344,5.453-0.562c0.078,0.062,2.672,0.094,2.766,0.156\r\n\t\tc-0.094,0.219,1.125,0.438,1.047,0.625c0.375,0,1.125-0.188,1.125-0.5c0.312,0,0.266,0.156,0.609,0.125\r\n\t\tc0-1.594,1.562,0.469,2.125,0.469c0-0.219-1.188,3.062-0.766,3.281c0.594,0.312-0.734,3.5-1.188,3.875\r\n\t\tc-0.359,0.25-1.594,3.125-1.656,3.5c-1.094,0.531-1.109,2.938-2.422,2.688c-0.125-0.562-0.344-0.312-0.188-0.969\r\n\t\tc-0.125,0.125-0.25,0.25-0.375,0.375c0.031-0.125,0.078-0.219,0.125-0.344c-0.688,0-1.672,1.75-2,2.375\r\n\t\tc-0.281,0.469-1.328,3.125-2.031,3.125c0.188,0.062,0.594,0.438,0.75,0.375c-0.125,0.375,0.438,2.656,0.484,2.656\r\n\t\tc-0.484,1.594-1.203,1.656-2.391,2.875c-0.047-0.75,0.125-1.562,0.719-2.094c-0.203,0.031-0.188-0.875-0.25-1.062\r\n\t\tc0.656,0,0.359-0.969-0.031-0.969c-0.516,0.062-1,0.25-0.734-0.406c-0.047,0.031-0.109,0.094-0.172,0.156\r\n\t\tc0-0.625-0.25-0.688,0.562-1c-0.688,0.094-0.031-1.219-0.594-1.062c-0.359,0-0.75,0.031-0.906,0.031\r\n\t\tc-0.344,0.594-1,0.531-1.062,1.188c-0.125,0.031-0.25,0.031-0.422,0.031c0.109-0.25,0.234-0.375,0.375-0.625\r\n\t\tc-0.641,0,0.359-1.188,0.578-1.625c-0.969-0.531-1.656,0.625-2.219,1.312c-0.703,0.844-1.156,0.594-1.516,1.594\r\n\t\tc-0.047,0.312,0.453,1.125,0.641,1.562c0.312-0.094,0.438-0.438,0.812-0.625c0.797-0.375,1.062,0.031,2.062-0.031\r\n\t\tc-0.188,0.562-1.625,1.5-1.938,1.562c-0.109,0.344-0.75,0.75-0.844,1.094c-0.188,0.844,0.484,1.438-0.141,2.062\r\n\t\tc0.453,0,0.078-0.156,0.391-0.156c0.031,0.656,0.594,1.438,0.5,2c-0.109,0-0.5,0.062-0.812,0.031\r\n\t\tc0.312-0.031,0.688,0.281,0.906,0.281c-0.031,0.688-0.625,0.812-0.625,1.25c0.938,0,0.453,0,0.969,0.469\r\n\t\tc-0.5,0.531-0.734,2.031-1.578,2.031c0,0.688-1.609,2.938-1.797,2.938c0.062,0.656-0.312,0.906-1.047,0.969\r\n\t\tc-0.078,0.969-2.219,2.406-3.172,2.406c0.094-0.375-0.047-0.188-0.125-0.594c0,0.844-1.938,1.562-2.344,1.562\r\n\t\tc-0.062,0.062-1.469,1.375-0.844,1.25c-0.719,0.125-0.906-0.438-0.391-1.219c-0.234,0-0.641-0.031-0.812-0.094\r\n\t\tc-0.453-0.219-0.734,0.688-1.141,0.812c-0.469,0.156-0.859,1.125-1.25,1.125c-1.203,1.906,0.188,1.844,0.188,3.188\r\n\t\tc0.781,0,0.719,3.594,0.656,4.125c-0.766,2-2.25,2.219-3.719,2.219c0.406,0.531,0.25,0.469,0.344,0.844\r\n\t\tc-0.25,0-0.328-0.375-0.438-0.562c0,0.25-0.297,0.875,0.031,0.875c-0.047,0.094-0.844,0.594-1.031,0.625\r\n\t\tc0.344-0.656-0.031-1.188,0.141-1.938c-0.172,0-0.422,0.281-0.172-0.312c-0.109,0.062-0.219,0.094-0.328,0.156\r\n\t\tc-0.016-0.875-0.516-1.219-0.766-2.094c-0.016,0.188-0.125,0.219-0.344,0.125c0.047-0.156,0.078-0.531,0.078-0.719\r\n\t\tc-1.359-0.156-2.297,3.812-2.312,4.844c0.391-0.094,1.328,2.438,1.422,3.062c0.094,0.812-0.188,1.938-0.188,3.031\r\n\t\tc-0.25,0-1.516,0.312-1.234-0.25c-0.266-0.312-0.797-2.281-0.672-2.281c0.281-0.875,0.469-1.781,0.281-2.719\r\n\t\tc-0.312-1.5-0.531-0.75-0.062-2.219c0.375-1.094,1.688-7.406,0.125-7.406c-0.484,0.719-0.875,1.125-1.641,1.188\r\n\t\tc0-1.25,0.703-2.812,0.297-4.469c-0.375,0-0.516,0.406-0.766,0.406c0.25-0.719-0.281-1-0.078-2.188c0.156,0-0.734-1.25-0.969-1.438\r\n\t\tc-0.25,0.75,0.062,0.969-0.75,1.312c-0.25,0.812-2.312-0.281-2.312,0.781c-0.156,0.25-1.406,1.25-1.484,1.5\r\n\t\tc-0.922-0.094-1.859,1.625-3.016,1.844c-0.672,0.156-1.172,0.844-1.844,1.312c-0.844,0.656-0.562,0.188-1.047,1.188\r\n\t\tc-0.172-0.062-0.719,1.969-0.859,2.375c-0.25,1.188-1.688,3.719-3.406,3.719c0.172-0.531-0.078-2.062-0.219-2.906\r\n\t\tc-0.969,0,0.109-3.406-0.422-3.562c0.609-1.844-0.984-5,0.891-6.5c-0.5-0.125,0-1.531,0.062-1.625\r\n\t\tc-0.172-0.031-1.625,2.688-2.219,1.5c-1.344-2.781,0.219-0.625,1.125-2.562c-0.188-0.062-3.062,0.594-1.656-1.031\r\n\t\tc-0.625,0.188-1.469-0.781-1.578-1.188c-0.078-0.281,0.594-0.75-0.5-0.844c-0.703-0.125-0.609,0.188-1.266,0.125\r\n\t\tc-1.016-0.188-5.156-0.062-5.25-1.719c-0.203-2.25-3.031-0.219-3.031-1.219c-1.297-0.406-1.641-3.375-1.625-4.406\r\n\t\tc-0.594-0.094-1.562-0.688-1.781-0.688c-0.094,0.469,0.219,0.469,0.094,0.844c-0.094-0.062-0.156-0.156-0.25-0.219\r\n\t\tc-0.156,0.281-0.312,2.531,0.438,2.688c0.062,0.438,0,2.312,0.281,2.688c0.141-0.188,0.609-0.656,0.875-0.656\r\n\t\tc0.031,0.312-0.531,1.375-0.438,1.531c0.453,0.75,1.359,0.344,1.891,0.875c0.031-0.281,2.141-1.438,2.547-1.812\r\n\t\tc-0.125,0.531-0.375,1.625,0.031,1.781c0.125,0.219,0.625,0.781,0.594,0.875c0.938,0.094,0.953,1.719,1.516,1.719\r\n\t\tc-0.453,0.469-0.984,1-1.297,1.531c-0.031,0-1.844,1.875-1.219,1.875c-0.484,0-2.75,1-2.75,1.281\r\n\t\tc-0.484,0.25-2.703,0.281-2.703,0.969c-0.984,1.406-4.703,1.562-5.844,1.688c-0.516,0.062-3.688,0.656-2.312-1.25\r\n\t\tc-0.266-0.094,0.078-0.906,0.156-1.219c0.203-0.719-0.031-1.531-0.078-2.125c0.172-0.531-0.453-2.625-0.625-2.688\r\n\t\tc0.062-0.469-0.422-0.656-0.641-0.656c0.141-0.469-0.094-2.094-0.25-2.156c1.125-1.188,0.219-3.031-0.109-4.469\r\n\t\tc0.109-0.438-1.234-3.312-1.469-3.312c-0.75,1.688-0.844-1.125-1.266-1.281c-0.5,1.562,0.719,4.812,1.125,6.188\r\n\t\tc-0.844-0.125,0.391,2.656,0.469,3.094c-0.031,0-0.75,2.219-0.375,2.875c0.297,0.5,0.812,0.969,0.75,1.406\r\n\t\tc-0.062,0.125-0.375,1.625-0.219,2.031c0.188,0.906,3.5,4.031,1.656,4.688c1.062,1.5,1.406,1.25,3.094,1.75\r\n\t\tc0.297-0.562,3.516-0.469,3.766-0.344c-1.406,1.625-2.297,4.969-4.578,6.344c-1.094,0.719-1.922,1.469-3.297,2.125\r\n\t\tc-0.766,0.312-2.328,0.625-2.672,1.625c-0.781,0-1.406,1.5-2.266,1.5c-0.859,0.625-1.891,1.562-2.078,2.531\r\n\t\tc-0.125,0.562,0.156,0.75,0.188,1.219c0.094,1.062-1,1.375-0.438,2.562c0.156,0.375-0.562,4.281-0.75,4.219\r\n\t\tc-1.109,1.219-2.719,1.781-4.547,1.438c-0.188,0.375-2.297,1.531-1.734,1.906c0.062,0.062,0,1.562-0.109,1.875\r\n\t\tc0.453,0.188-0.453,1.062-0.875,1.25c-0.266-0.094-2.109,0-2.188,0.406c0.141,0.094,0.266,0.156,0.391,0.219\r\n\t\tc-0.312,0.438-0.469,1.406-1,1.312c0.094,1.719-5.234,2.062-5.516,3c-2.266-0.562-4.984-0.719-6.531-1.219\r\n\t\tc0.172-0.75,1.047-4.781-0.516-5.062c0.281-0.688-0.344-1.656-0.094-2.688c0.188-0.875,0.25-1.531,0.344-1.938\r\n\t\tc0.031-0.969-0.969-1.844-0.734-2.625c0.234-0.938-0.703-1.188-0.453-2.094c0,0.062,0.375-1.781,0.766-1.656\r\n\t\tc0.109-0.344,1.547-2.469,2.047-2.344c0.344-1.219-0.344-2.25,0.656-3.062c-0.406-0.125-0.156-3.344-0.406-3.406\r\n\t\tc0.391-0.531-1.438-2.875-1.688-3.625c0.25,0.156,0.359,0.156,0.344-0.031c-0.688-0.281-0.344-1.75,0.406-1.5\r\n\t\tc-0.047-0.188-0.219-0.438-0.156-0.531c0.688,0.156,1.344-2.906,1.375-3.344c-0.297-0.25-0.688,0.25-0.547-0.5\r\n\t\tc-0.609-0.156-0.453-0.281-1.016-0.438c-0.078,0.812-1.5-0.406-1.719-0.438c0.188-0.594,0.047-0.844,0.188-1.312\r\n\t\tc-1.375-0.562-1.828-1.656-3.406-0.844c0.031-0.25,0.125-0.125,0.234-0.281c-0.172,0-0.219-0.062-0.109-0.188\r\n\t\tc-0.344-0.094-0.297,0.188-0.734-0.406c-0.047,0.281,0.078,0.438,0.141,0.688c-0.953-0.406-2.281,0.062-3.047-0.281\r\n\t\tc0.109-0.719-3.984-0.688-4.328-1c-1.156-1.188-2.312-3.156-2.906-4.531c0.047,0.062,0.078,0.125,0.125,0.188\r\n\t\tc-0.031,0-0.391-1.031-0.406-0.938c0.094,0.031,0.188,0.094,0.297,0.125c0.156-1.5-0.703-2.594-1.078-3.906\r\n\t\tc0.219-0.469-0.453-1.094-0.531-1.5c0.078-0.5,0.391-1.406-0.062-2.219c1.484,0.469,2.875-6.625,2.469-6.812\r\n\t\tc0.219-1.125,1.594-1.656,2.188-2.375c0.703-0.844,1.719-1.656,2.5-2.438c0.625-0.625,2.625-0.5,3.328-1.469\r\n\t\tc0.953-1.25,0.609-2.906,2.172-3.656c1.031,0.375,1.672-1.031,2.406-0.812c0.812-2.5,1.594,0.219,3.266,0\r\n\t\tc-0.125,0.219,0.109,0.344,0.172,0.531c1-0.344,2.281-0.094,3.219-0.688c0.844-0.469,4.922,1.656,5.062,1.062\r\n\t\tc0.688,0.688,1.688,0.531,2.438,0.625c-0.219,0.594,0.344,0.438,0.641,0.531c-0.188,0.594-1.562,1.219-0.734,1.469\r\n\t\tc-0.234,0.688-0.438,1.125-0.859,1.375c-0.609,0.344,0.109,1.281,0.203,1.344c0.328,0.75,2.031,1.781,2.688,1.969\r\n\t\tc-0.312,1.344,1.812,2.312,2.984,3c0.953,0.594,0.891-1.5,0.922-1.562c0.406-0.406,1.031-0.469,1.469-0.656\r\n\t\tc0.406-0.188,2.859,2.375,3.312,2.5c0.891,0.281,1.25,1,2.438,1.281c0,0.062,2.141,0.562,2.031,0.531c0-0.188,0-0.312-0.031-0.531\r\n\t\tc1,0.406,1.594,1.281,3.078,0.094c0.828-0.719,0.703-1.812,1.797-2.531c-0.547-0.344,0.234-2.188,0.375-2.781\r\n\t\tc-0.219-0.062-0.531,0.219-0.781,0.344c0.25-0.438-2.156,0.438-2.406-0.375c-0.094-0.469-0.625-0.656-1-0.781\r\n\t\tc-0.641,1.594-2.016-0.812-2.641-1.031c0.109-0.375,0.516-1.219-0.297-1.281c0.078-0.188,0.125-0.375,0.156-0.594\r\n\t\tc0.078,0.125,0.141,0.281,0.219,0.406c0.125-0.5,0.203-0.812,0.375-1.406c-1.297-0.375,0.422-1.062,1.094-0.938\r\n\t\tc0.062-0.281,1.25-0.156,1.734-0.031c0.203-0.625-1.125-0.281,0.672-0.5c-0.125,0.781,0.969,0.062,1.156,0.031\r\n\t\tc0.938-0.094,1.781,0.188,2.75,0.094c-0.312,0.812,3.922,2.75,4.875,1.594c0.172-1.25-1.172,4.391-2.172,4.25\r\n\t\tc0.078-0.422-0.109,7.719,0.016,7.719c-0.219,0-0.406,0-0.625,0c0.156,0,0.375-8.438,0.406-8.938\r\n\t\tc0.312-0.031,0.406-4.172,0.312-3.969c0.688-0.266,0.938-2.797,0.422-3.328c0.328,0.031,1.719-1.484,1.719-1.703\r\n\t\tc-1.75,0-2.984-0.094-4.547-0.359c-0.422,0.641,0.594,0.578,0.391,1.172c0.5,0.094,0.828,0.094,1.266-0.016\r\n\t\tc-0.094,0.141-0.031,0.141,0.109,0.109c-0.891,0.312-1.797,0.375-2.844,0.594c0.578-0.75,0.266-1-0.469-1.281\r\n\t\tc0.469-0.188,1.234-0.453,1.281-0.859c-0.5-0.125-1.266,0.047-1.656-0.734c0.234,0.062,0.422-0.031,0.625,0\r\n\t\tc-0.141-0.156-0.234-0.281-0.359-0.438c0.047-0.188-1.531,0.656-1.719,0.719c-0.531,0.25-0.703,0.938-0.734,1.375\r\n\t\tc-0.516-0.344-1.594,1.406-1.734,1.719c-0.594,1.312,0.297,1.219,0.156,2.406c-0.969-0.156-1.484,0.125-2.375,0.375\r\n\t\tc0.469-1.188-0.812-1.25-1.859-1.5c-0.078,0.375,0.016,0.562,0.234,0.906c-0.094-0.062-0.172-0.156-0.266-0.25\r\n\t\tc0.031,0.156,0.047,0.281,0.062,0.406c-0.141-0.062-0.109-0.156-0.25-0.25c-0.031,0.25-0.031,0.094-0.078,0.312\r\n\t\tc-0.375-0.125-0.344-0.531-0.375-0.938c-0.172,0.688-0.5,0.719-0.172,1.781c-0.281-0.094,0.031-0.156-0.234-0.25\r\n\t\tc-0.188,0.688,0.125,0.031-0.016,0.688c0.453,0.062,0.984,0.781,1.031,1.469c-0.203-0.281-0.328-0.469-0.672-0.5\r\n\t\tc0.031,0.406,0.219-0.188-0.031,0.625c-0.219-0.156-0.438-0.219-0.703-0.344c-0.047,0.156,0.125,0.312,0.172,0.531\r\n\t\tc-0.312,0-0.25-0.031-0.594-0.156c-0.281,1.219-0.719-0.312-0.922,0.25c-0.188-0.594-0.391-1.688,0.344-1.25\r\n\t\tc0-0.156,0.078-0.188,0.203-0.094c0.047-0.438-0.75-0.344-0.312-1.125c-0.141,0.031-0.266,0.062-0.375,0.062\r\n\t\tc0.094-0.469-0.25-0.656-0.141-1.219c-0.172-0.062-0.234,0.125-0.359,0.25c0.109-0.562,0.312-1.75,0.219-2.281\r\n\t\tc-0.031-0.156-0.031-2.031-1.094-2.031c0.094-0.312-1.25-1.531-1.344-1.562c-0.219,0-0.312-1.938-0.281-2.312\r\n\t\tc-0.188,0.312-0.656,0.875-0.844,0.781c-0.031-0.656-0.094-0.938,0.312-1.281c-0.406-0.156-0.875-0.125-1.219-0.188\r\n\t\tc-0.25,0.625-0.875,1.844-0.156,2.156c0.281,0.062,0.625,0.75,0.438,1.156c0.516,0.156,0.594,1.844,1.562,1.969\r\n\t\tc-0.094,0.156-0.188,0.312-0.281,0.438c0.812,0.219,1.25,1.688,1.125,2.219c-0.266-0.094-0.438-0.906-0.719-0.906\r\n\t\tc-1.203,0.656,0.031,0.938-0.281,1.594c-0.172-0.031-1,1.438-1.656,1.219c2.047-3.625-2.922-4.562-2.094-8.438\r\n\t\tc-0.516-1.156-2.172-0.938-2.875-0.25c-0.406,0.406-3.562-2.312-3.062,0.719c-0.922-0.344-2.422,0.938-3.094,1.281\r\n\t\tc-0.656,0.312-0.125,0.719-0.438,1.125c-0.156,0.562-1.031,0.5-1.188,1.156c-1.406,0.875-2.156,0.094-3.562,0.344\r\n\t\tc-1.094,0.219-1-0.188-1.266-1.156c-0.078-0.344-1.562-0.625-1.859-0.75c0.25-0.844,0.438-1.469,0.656-2.031\r\n\t\tc-0.312-0.094-0.031,0.125-0.344,0.062c0.062-0.188,2.281-3.281,1.453-3.438c0.547-0.438,0.516-0.969,0.219-1.531\r\n\t\tc0.188,0.062,1.141-0.156,1.141-0.062c0.344-0.531,1.156,0.406,1.469,0.469c0.625,0.188,3.25,1.875,3.719,1.5\r\n\t\tc0.344-0.312,1.578-2.688,1.062-2.844c-0.062-0.719-0.891-0.938-0.391-1.688c-0.625-0.188,0.172-0.281-0.438-0.5\r\n\t\tc0.047-0.281,0.188-0.156,0.359-0.219c-0.312-0.125-0.406-0.281-0.5,0.156c-0.281-0.094-0.344-0.531-0.25-0.781\r\n\t\tc-0.297,0-0.406-0.25-0.438-0.547c0.031-0.078,0.062-0.141,0.172-0.078c-0.172-0.656,0.016-0.562,0.594-0.312\r\n\t\tc-0.047,0.156,1.438,8.078,1.906,8.266c0.109-0.594,0.109,6.328,0,6.328c0.141,0,0.312,0,0.453,0c-0.031,0,2.312-7.719,2.406-7.781\r\n\t\tc0.531-0.328,0.062-4.781,1.125-4.484c0.156-0.281,0.938-1.953,1.125-1.922c-0.25-0.094-0.062-1.125-0.156-1.344\r\n\t\tc0,0,0.5,0.125,0.156-0.094c0.094,0.094,0.172-0.078,0.25,0c0.516-1.781,2.25-2.406,3.094-1c0.406-0.922,0.719-0.219,1.078-0.562\r\n\t\tc0.234-0.5,0.422-1.125,0.578-1.719c0.125,0.031-0.641-3.312,1.5-2.438c0.188-0.812-0.109-0.547-0.531-0.734\r\n\t\tc0.125,0.016,0.188,0.078,0.188,0.234c-0.328,0.062-0.312,0.25-0.188-0.25c-0.25,0.094-0.266,0.281-0.516,0.188\r\n\t\tc0.375-0.812,1.406-0.469,2.312-0.969c-0.266,0.656-0.234,0.969-0.953,0.906c0.141,0.062,0.344,0.094,0.5,0.125\r\n\t\tc-0.25,0.781,0.281,11.281-0.453,11.062c-0.234,0.281-0.703,10.781-0.75,10.781c0.219,0,0.422,0,0.609,0\r\n\t\tc-0.188,0,0.094-9.469-0.219-9.016c-0.094-0.188-0.344-5.703-0.531-5.766c0.031,0.531-0.062-2.344-0.172-1.781\r\n\t\tc0.141,0.031,0.266-1.156,0.422-1.109c-0.625,0.469-0.172,0.109-0.25,0.672c0.359,0.25,0.391-0.281,0.75,0.25\r\n\t\tc0.109-0.344,0.672-0.469,1.125-0.656c-0.344,1.25,4.219,0.656,4.656,0.969c-0.047,0.375-0.25-0.203-0.406,0.344\r\n\t\tc0.281-0.031,0.531-0.094,0.812-0.125c-0.062,0.125-0.094,0.266,0.047,0.328c0.172-0.188,0.484-0.484,0.625-0.641\r\n\t\tc-0.672-0.25,0.266-0.594,0.5-0.719c-0.031,0.125-0.078,0.281-0.109,0.438c1.344-0.656,0.672-2.906,2.578-3.312\r\n\t\tc-0.266,0.406-0.219,0.625,0.109,1.062c0.828,0.969,1.109-0.969,1.406-1.5c-0.125-0.062-0.281-0.094-0.438-0.125\r\n\t\tc0.188-0.688,0.188-0.719,0.359-1.25c0.875,0.156,3.406,0.531,3.734-0.031c-0.094,0.219,1.219,0.125,1.594,0.219\r\n\t\tc0.125-0.469-1.062-0.969-1.438-1.5c0.25,0.094,0.328,0,0.281-0.281c-1.125-0.125-2.062,0.688-2.984,0.375\r\n\t\tc-1.297-0.125-0.375-0.438-1.359-1.531c-0.031,0.156-0.047,0.312-0.109,0.469c-0.562-0.156,0.062-2.219,0.312-2.781\r\n\t\tc0.172-0.344-0.172-0.719,0.531-0.938c0.109-0.031,0.797-0.469,1.094-0.625c0.172,0.062,1.828-1.5,1.672-1.812\r\n\t\tc0.016,0-0.062-1.094-0.094-0.906c0-0.062-1.156-0.438-1.375-0.75c-0.25,0.375-0.344,0.812-0.906,0.594\r\n\t\tc-0.375,0.844-0.688,1.688-1.797,2.375c-0.703,0.375-0.812,0-1.266,0.625c-0.453,0.281-0.562,0.656-1.094,0.375\r\n\t\tc-0.531,1.25-0.609,1.75-0.953,3.125c0.297,0.219,0.453,0.219,0.453-0.062c0.312,0.281,0.047,0.344,0.531,0.469\r\n\t\tc0,0.125-0.109,0.844,0.172,0.906c-0.297,0.156-0.391,0.375-0.906,0.438c1.203,0.25-0.922,0.812-1.516,0.688\r\n\t\tc0.422,0.469-0.875,2.219-1.125,2.625c0.25,0.031,0.281-0.094,0.5-0.188c-0.062,0.25-0.312,0.5-0.469,0.688\r\n\t\tc-0.094-0.156-0.141-0.156-0.078-0.344c-1.359-0.531-1.703,1.156-3.078,0.594c0.469-1.375,0.531-1.125,0.344-2.781\r\n\t\tc-0.359-0.125,0.062-2.125,0.109-2.375c-0.578-0.125-1.547,0.688-2.266,0.5c-1.781,0.188-1.859-0.188-1.359-1.969\r\n\t\tc-0.297-0.156-0.328-0.156-0.719-0.219c0.031-0.125,0.047-0.219,0.172-0.312c0.594,0.188,0.969-0.094,1.281-0.781\r\n\t\tc-0.562-0.156-0.391,0-0.984-0.156c0.172-0.156,0.281,0.031,0.359-0.219c-0.797-0.25-0.5-0.375,0.016-0.5\r\n\t\tc-0.125-0.062-0.359-0.312-0.297-0.438c0.266,0.094,1.578,0.75,1.703,0.219c-0.234-0.125-1.078-0.281-1.672-0.375\r\n\t\tc0.172-0.5,0.125-0.156,0.281-0.406c-0.219-0.031-0.219-0.125-0.016-0.375c0.328,0.094,0.609,0.188,0.953,0.312\r\n\t\tc0.094-0.594-0.75,0.062-0.531-0.688c0.594,0.156,1.031-0.094,0.922,0.312c0.172-0.062,0.328-0.125,0.562-0.188\r\n\t\tc-0.266-0.031-0.422-0.281-0.328-0.562c0.25,0.094,0.406,0.219,0.547,0.312c0.172-0.562,0.312-0.312,0.109-0.844\r\n\t\tc0.547,0.219,0.703,0.469,0.906-0.031c0.078,0.156,0.188,0.281,0.312,0.469c0.031-0.188-0.094-0.281-0.203-0.438\r\n\t\tc0.516-0.281,0.312-0.312,0.656-0.625c-0.141,0.031-0.297,0.031-0.422,0.031c0.141-0.062,0.312-0.125,0.469-0.188\r\n\t\tc-0.219,0.438,0.469,0.312,0.531,0.344c0.125,0.438,0.219,0.312,0.516,0.625c0.203-0.438,0.859-0.438,0.953-0.688\r\n\t\tc-0.406,0.188-0.703,0.219-1.125,0.312c0.094-0.312-0.031-0.25,0-0.5c0.562,0.125,1.594-0.906,1.625-1\r\n\t\tc0.844,0.25,0.562,0.156,0.719-0.312c1.391-0.281,1.047-0.781,1.703-1.312c0.734,0.125,1.422-0.938,1.969-0.781\r\n\t\tc0.047-0.219,0.047-0.25,0.172-0.625c-0.156,0-0.297,0.031-0.438,0.062c0.031-0.219,0.125-0.25,0.312-0.094\r\n\t\tc0-0.125,0-0.156-0.031-0.188c0.125,0.031,0.219,0.062,0.422,0.312c0.203-0.156,0.656-0.438,0.797-0.625\r\n\t\tc-0.25-0.094-0.594-0.094-0.875-0.062c0,0,2.562-1.5,0.719-1.344c0.125-0.312,0.344-0.656,0.938-0.875\r\n\t\tc-0.062,0.312-0.156,0.625-0.25,0.938c0.312,0.156,0.422,0.062,0.375-0.375c0.359-0.125,0.094,0.25,0.359-0.25\r\n\t\tc0.078,0.188-5.438,0.375-5.219,0.406c0.156-0.406-5.125-0.656-5.125-0.875c0,0.156,0,0.312,0,0.5c0-0.312,5.906-0.062,5.969-0.562\r\n\t\tc0.531,0.094,2.703,0.312,3.219,0.469c0.5,0.125,1.641-0.062,1.766-0.406c0.203,0.062,1.094,0.344,1.219,0.5\r\n\t\tc-0.031-0.219,0.281-0.469,0.266-0.688c-0.109,0.031-0.031,0.062-0.125,0.094c0.062-0.125,0.125-0.219,0.031-0.344\r\n\t\tc0.438,0.125,2.109,1.344,2.266,0.125c0.391,0.156,0.125,1.219,0.516-0.375c0.391,0.312,0.406,0.219,0.625,0.312\r\n\t\tc-0.094,0.281-0.047,0.344,0.172,0.375c-0.469,0.312-0.75,0.75-0.75,1.281c0.188-0.312,1.25-1.656,1.547-1.562\r\n\t\tc0,0.469-0.312,0.656-0.375,1.031c1-0.438,0.719-1.531,1.656-1.188c-0.188,0.531,0.219,0.344-0.422,0.531\r\n\t\tc0.016,0.125,0.047,0.219,0.047,0.344c0.109-0.094,0.219-0.156,0.344-0.25c-0.125,0.188-0.188,0.438-0.281,0.625\r\n\t\tc0.156,0.031,0.5-0.656,0.625-0.875c0.125,0.25,0.219,0.594,0.219,0.75c0.188,0.031,0.297-0.094,0.469-0.062\r\n\t\tc-0.047,0.188-0.156,0.25-0.25,0.438c0.688,0.125-8.844,0.031-8.406,0.469c-0.812-0.25-10.344,0.406-10.344,0.156\r\n\t\tc0,0.188,0,0.344,0,0.531c0-0.281,9.438,0.031,9.844-0.312c0.344,0.312,5.141,0.688,5.406,0.219\r\n\t\tc0.266,0.219,2.438,0.375,2.781,0.469c-0.312,0.188,1.156,0.281,0.688,0.219c0,0.094,2.438,1.25,2.734,1.531\r\n\t\tc-0.047,0.156,2.609,1.594,2.609,2.125c-0.281,0.75,1.859,1.906-0.172,2.781c-0.078-0.031-2.328-0.062-2.078-0.5\r\n\t\tc-0.5-0.094-1.594-1.188-1.594-1.031c-0.75-0.344-0.812-1.188-1.344-1.344c0,0.25,0.156,0.719,0.375,0.781\r\n\t\tc-0.094,0.094-0.219,0.156-0.312,0.219c0.156,0.031,0.344,0.094,0.516,0.125c0.016,0.219-0.078,0.25-0.297,0.094\r\n\t\tc0.125,0.312,0.438,0.375,0.438,0.625c-0.25-0.031-0.344-0.156-0.469,0.062c2.156,0.531,0.719,1.781,1.188,3.438\r\n\t\tc0.031-0.094,0.781,0.906,1.531,1c0-0.188,0.781-0.312,0.391-1.094c-0.5-0.875-0.312-0.5-0.078-1.5\r\n\t\tc0.469,0.312,0.688,0.719,0.562,1.125c0.688-0.031,0.719,0.281,1.469,0.688c0-0.594-0.75-2.844,0.875-2.281\r\n\t\tc0.188-0.844,1.219,0.125,0.969,0.656c0.938,0.25,1.812-3.656,1.438-4.281c0.891,1.031,1.703,0.906,1.875,2.531\r\n\t\tc-1.219-0.375-1.125,0.281-1.125,1.562c0.5,0.156,1.312-0.188,1.469-0.625c0.359-1.062,0.844-0.5,0.938-1.188\r\n\t\tc0.938,0.406,1.781-0.781,2.812-0.469c0.109-0.125,0.469-0.562,0.812-0.5c0.094,0.219,0.094,0.531,0.266,1.031\r\n\t\tc-0.484-0.062-0.297,0.125-0.578,0.219c0.375-0.031,0.406,0.062,0.656,0.125c0.219-0.5,0.406-0.094,0.641,0.094\r\n\t\tc0-1,1.297-0.938,1.828-0.156c0.375-0.375,0.625-0.375,1.234-0.438c-0.078,0.375-0.266,1.125,0.25,1.188\r\n\t\tc0.547-0.75,1.406-0.75,0.734-2.188c0.172,0.062,0.594-0.062,0.594-0.375c1.094,0.812,2.562-0.125,2.297,1.781\r\n\t\tc0.297,0.062,0.234-0.375,0.328-0.562c0.656,0.438,1.703,1.438,1.609,2.281c0.406,0.094,0.734-0.781,0.797-1.188\r\n\t\tc-0.219,0-0.062,0.219-0.391,0.156c0.109-0.625-0.141-0.781,0.25-1.281c-0.391-0.094-0.484-0.219-0.859-0.312\r\n\t\tc0.375-0.812,0.328-1.156,0.438-2c-0.594-0.125,0.562-1.094,0.594-1.219c0.359-0.75,1.562-1.469,1.562-2.219\r\n\t\tc0.453,0.031,1.375,0.094,1.719,0.531c0,0.188,0.109,1.969-0.281,1.906c0,1.188-0.125,1.906-0.156,3.188\r\n\t\tc0,0.375-0.156,0.656-0.094,1.125c0.031,0.469,0.562,0.688,0.562,1.219c0,0-0.719,2-0.75,2.188\r\n\t\tc-0.719-0.094-1.344,0.188-2.312,0.188c-0.062,0.281,0.219,0.688,0.594,0.75c1.203,0,0.812,0.938,1.531,1\r\n\t\tc0.062-0.656,0.094-0.844-0.422-1.188c2.297,0.656,1.516-2.562,2.203-3.344c0.438-0.531,1.625-0.719,1.516,0.156\r\n\t\tc0.672,0.094-0.453,2.156,0.609,2.688c0-0.875,0.938-0.219,0.938,0.094c0.078-0.062,0.156-0.094,0.25-0.156\r\n\t\tc-0.312-0.25-0.594-0.531-0.984-0.562c-0.297-0.875,0.219-0.938,0.016-1.781c-0.469-1.656-1.422-0.906-2.688-1.125\r\n\t\tc0.188-1-0.062-1.562-0.062-2.438c0.203-1.406,0.625-1.812,0.812-3.594c0.656,0-0.5,3.344,1.375,3.5c0-0.375,0.516,0,0.656,0.094\r\n\t\tc0.062-0.125,0.109-0.219,0.172-0.312c-0.922-0.094-0.953-0.875-0.953-1.531c0.906,0.094,0.719,0.906,1.406,0.125\r\n\t\tc-0.266-0.125-0.172-0.156-0.5-0.188c0.375-1.344,2.469,0.719,3.359,0.812c0,0.719-0.703,2.406-1.141,2.938\r\n\t\tc0.328,0.062,0.312-0.469,0.656-0.406c0.688,0.594-0.094,0.844,1.078,0.875c-1.359-1.031,1.047-3.938-1.297-4.125\r\n\t\tc0-0.25-0.344-0.219-0.453-0.531c-0.359-0.719,0.078-1.125,0.078-1.781c0.375-0.625,1.844-0.781,2.594-0.25\r\n\t\tc0.219-0.375,1.344-0.625,0.969,0.375c1.609,0.156-0.875-1.562,0.375-1.562c0-0.375-0.062-0.5-0.469-0.5\r\n\t\tc0.047-0.094,0.094-0.219,0.141-0.312c0.219,0,0.328,0.219,0.578,0.375c0-0.594,0.375-0.656,0.375-0.938\r\n\t\tc-0.203-0.062-0.344-0.094-0.344-0.344c1.719,0,2.312-0.656,3.969-0.594c0.031-0.281,0.109-0.25,0.109-0.438\r\n\t\tc0.672,0.312,1.672-0.375,1.672,0.844c0.25,0.094,0.328,0,0.219-0.312c0.078,0.156,0.156,0.344,0.219,0.5\r\n\t\tc0.344-0.5,0.938-1.312,1.406-0.438c0-0.531-0.125-0.438-0.391-0.781c0.109-0.062,0.234-0.125,0.359-0.188\r\n\t\tc0,0.125,0.906,0.156,1.188,0.344c-0.812-0.906,0.25-1.75,0.875-2.219c0.797,0.625,1.359-0.594,1.359,1.125\r\n\t\tc0.766,0,1.188-0.094,1.188,1.156c0.469-0.562,2.406-1.188,2.406-1.156c0.297,0.594,2.422,2.531,1.266,2.531\r\n\t\tc0.031,0.219,0.688,0.781,0.531,1.125c-0.156,0.312-0.719,0.062-0.719,0.469c-0.75,0-1.547,0.469-2.062,1\r\n\t\tc-0.141,0.156-0.188,1.469-0.875,1.469c0,0.344-1.922,1.25-1.922,1.25c0.766,0,2.984-0.688,2.859-1.438\r\n\t\tc0.188,0.094,0.344,0.219,0.5,0.312c-0.219-0.406-0.297-0.906,0.031-1.438c0.453,0.031,0.141,0.062,0.594-0.031\r\n\t\tc-0.094,0.969,1.031,1.344,0.953,0.156c0.109,0.438,0.312,0.906,0.422,1.281c-0.281-1.781,2.812-1.75,2.969-0.594\r\n\t\tc-0.25,0,2.156,1.344,2.156,1.031c0.578,0,0.719,9.219,1.422,9.094c-0.109-0.125-0.172,8.844-0.141,8.844c0.109,0,0.25,0,0.359,0\r\n\t\tc0,0-0.391-9.5-0.609-9.484c0,0.125,0.031-4.359,0.141-4.297c-0.328,0.062-1.547-3.906,0.516-4.062\r\n\t\tc0.125,0.812,0.859-0.938,0.812-0.094c0,0.375-0.75,0.188-1.078,0.5c0.172,0,0.328-0.328,0.516-0.344\r\n\t\tc-0.047,0.203-0.031,0.344-0.203,0.344c0.172,0.094,0.328,0.109,0.484,0.203c-0.062-0.547,0.125-0.203,0.406-0.516\r\n\t\tc0,0.281-0.062,0.531-0.047,0.625c0.578,0,0.516,0.531,0.75,0.891c0.141,0,0.109-1.016,0.094-1.172\r\n\t\tc0.234,0.281,0.828,1.094,1.062,1.062c-0.109-0.219-0.109-0.344,0.047-0.344c0,0.031-0.094,0.812-0.094,0.812\r\n\t\tc0.094-0.031,0.188-0.125,0.281-0.188c0.328,0.688,0.844,0.688,1.312,0.688c0,0.312-0.25,0.781,0.188,0.781\r\n\t\tc0.234-0.438,0.281-2.812,0.625-2.812c0.141,0.469,0.25,0.625,0.25,1.125c0.078-0.031,0.969-0.438,0.766-0.781\r\n\t\tc0.281,0,0.953,0.438,1.141,0.375c0.672,0.062,1.125,0.719,1.281-0.531c0.406,1.469,0.297-0.531,0.344-0.688\r\n\t\tc0.188-0.688-0.25-0.875,0.547-1.219c-0.109-0.125-0.234-0.156-0.359-0.281c0.75-0.156,2.531,0.188,3,0.5\r\n\t\tc-0.312,0.062-0.5,0.219-0.562-0.062c-0.109,0.188-0.109,0.406,0,0.656c0.531-0.156,0.719-0.344,1.266-0.406\r\n\t\tc-0.047,0.312-0.094,0.438-0.203,0.719c-0.078-0.25,0.094-0.312,0-0.531c-0.344,0-0.469,1.25-0.469,1.406\r\n\t\tc1.172-0.188,0.391-1.312,0.938-1.781C351.047,236.875,352.172,237,351.75,238.094z M361.922,254.156\r\n\t\tc0.016,0.188-0.172,0.969-0.109,1.156c-0.125,0.031-0.156,0.25-0.172,0.406C361.641,255.156,361.5,254.719,361.922,254.156z\r\n\t\t M347.031,264.188c-0.469,0.062-1.031-0.281-0.281-0.5C346.828,263.844,346.938,264,347.031,264.188z M243.281,270.031\r\n\t\tc-0.844,0.469-0.828,0.031-0.641-0.562c0.359,0.125-0.062-0.156,0.5,0C242.859,270.031,243.172,269.688,243.281,270.031z\r\n\t\t M247.953,269.656c0.625,1,0,2.281-0.969,2.625c0.062-0.312-0.094-1.469-0.062-2.094\r\n\t\tC247.109,269.875,247.578,269.719,247.953,269.656z M247.547,268.844c0.156-0.438,0.453-1.625,1.172-1.312\r\n\t\tc0,0.875-0.25,1.312-0.719,2C247.859,269.281,247.656,269.062,247.547,268.844z M249.266,274.531\r\n\t\tc0.156-0.656,1.594,0.312,2.406,0.188c-0.312,0.469-0.594,1-0.75,1.469c-0.219-0.125-0.25-0.281-0.406-0.281\r\n\t\tC250.297,275.594,249.203,274.844,249.266,274.531z M255.891,275.938c0.047-0.281,0.188-0.031,0.281,0.094\r\n\t\tC256.078,276.406,256,276,255.891,275.938z M257.438,279.875c0.109-0.344,0.422-0.031,0.484-0.031\r\n\t\tc0.375,0.344,1.766,0.531,1.656,0.969C258.703,280.906,258.297,280.531,257.438,279.875z M264.328,282.031\r\n\t\tc0.188,0,1.125-0.125,0.75-0.156c0.641,0.094,0.938,0.188,1.438-0.156C266.281,282.406,264.703,283.094,264.328,282.031z\r\n\t\t M260.781,275.938c0.578,0.094,0.047,0.094,0.391,0.25c-0.203,0-0.094,0.312-0.375,0.219\r\n\t\tC260.953,275.844,260.75,276.312,260.781,275.938z M255.797,253.156c-0.328,0.281-0.188-0.188-0.438,0.375\r\n\t\tc-0.062-0.031-0.156-0.062-0.25-0.094c0.109-0.594-0.031-0.219-0.438-0.281c0.266-0.625,0.156-0.406-0.031-0.875\r\n\t\tc0.469,0.156,0.312-0.125,0.688-0.125c-0.156,0.188-0.141,0.312,0.031,0.344c0-0.188,0.094-0.188,0.219-0.125\r\n\t\tc0.156-0.5,0.125-0.188,0.469-0.5c-0.25,0.562,0.016,0.531-0.406,0.844C255.688,252.875,255.75,253.031,255.797,253.156z\r\n\t\t M255.797,253.656c-0.156,0.375-0.781,0.531-1.25,0.5c-0.031-0.25,0-0.5,0.031-0.688\r\n\t\tC255.109,253.844,255.234,253.562,255.797,253.656z M257.453,253.469c0.125,0.188,0.266,0.406,0.375,0.625\r\n\t\tc-0.094,0-0.203,0.062-0.312,0.094C257.484,253.906,257.453,253.688,257.453,253.469z M260.797,252.406\r\n\t\tc-0.219-0.625,0.375-1.438,1.078-1.219c-0.484,0.281-0.375,0.625-0.531,0.875C261.141,252.156,260.984,252.312,260.797,252.406z\r\n\t\t M262.828,247.938c0.469-0.031,0.25-0.219,0.312-0.438c0.281,0.031,0.297,0.344,0.219,0.719\r\n\t\tC263.156,248.219,263.016,248.031,262.828,247.938z M263.891,251.094c0.203-0.594,0.781-0.469,1.297-0.156\r\n\t\tc-0.234,0.125-1.172,0.875-1.328,0.844c-0.031-0.312,0.031-0.406,0.234-0.312C264.031,251.344,263.953,251.219,263.891,251.094z\r\n\t\t M264.484,250.062c0.031-0.156,0.422-0.219,0.562-0.188c0,0.094,0.031,0.219,0.031,0.344c-0.188-0.062-0.234,0.094-0.406,0.25\r\n\t\tC264.688,250.25,264.641,250.094,264.484,250.062z M265.359,248.625c0.062-0.281,0.094-0.062,0.125-0.469\r\n\t\tc0.156,0.031,0.281,0.062,0.406,0.094c-0.031,0.156-0.094,0.344-0.109,0.469C265.641,248.688,265.5,248.656,265.359,248.625z\r\n\t\t M329.5,236.031c0.062-0.281,0.359-0.531,0.328-0.656C330.188,235.375,329.688,235.969,329.5,236.031z M350.938,231.844\r\n\t\tc-0.094,0.031-0.844,0.312-1.156,0.375c0,0.125-1.203-1.031-0.562-1.031C349.859,231.062,351.812,231.562,350.938,231.844z\r\n\t\t M346.578,235.906c-0.391-0.062-0.266-0.312-0.672-0.25c-0.031-0.156,0.5-0.875,0.469-1.031c0.969-0.656,1.406,0.5,1.625,1.219\r\n\t\tC347.688,235.875,346.5,235.625,346.578,235.906z M347.406,233c-0.234-0.594-0.344-1.219-0.25-1.25\r\n\t\tC348.016,231.594,348.156,232.312,347.406,233z"},"children":[]}]},{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]}]}]};exports.world=world;var yen={"viewBox":"0 0 512 512","children":[{"name":"g","attribs":{},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[{"name":"path","attribs":{"d":"M256,0C114.609,0,0,114.609,0,256s114.609,256,256,256s256-114.609,256-256S397.391,0,256,0z M256,472\r\n\t\tc-119.297,0-216-96.703-216-216S136.703,40,256,40s216,96.703,216,216S375.297,472,256,472z"},"children":[]}]},{"name":"path","attribs":{"d":"M338.5,243.406v24h-61.828v26.797H338.5v24.031h-61.828V384h-45.688v-65.766h-61.047v-24.031h61.047v-26.797h-61.047v-24\r\n\t\th48.844l-65-115.406h52l33.469,71.281c6.703,14.594,11.438,26.781,16.156,39.797h0.781c4.734-11.844,9.859-26,16.547-40.578\r\n\t\tl34.672-70.5h50.797l-68.531,115.406H338.5z"},"children":[{"name":"path","attribs":{"d":"M338.5,243.406v24h-61.828v26.797H338.5v24.031h-61.828V384h-45.688v-65.766h-61.047v-24.031h61.047v-26.797h-61.047v-24\r\n\t\th48.844l-65-115.406h52l33.469,71.281c6.703,14.594,11.438,26.781,16.156,39.797h0.781c4.734-11.844,9.859-26,16.547-40.578\r\n\t\tl34.672-70.5h50.797l-68.531,115.406H338.5z"},"children":[]}]}]}]};exports.yen=yen;

/***/ }),
/* 1412 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoGist = exports.lock = exports.location = exports.listUnordered = exports.listOrdered = exports.link = exports.linkExternal = exports.lightBulb = exports.law = exports.keyboard = exports.key = exports.jersey = exports.italic = exports.issueReopened = exports.issueOpened = exports.issueClosed = exports.info = exports.inbox = exports.hubot = exports.horizontalRule = exports.home = exports.history = exports.heart = exports.graph = exports.grabber = exports.globe = exports.gitPullRequest = exports.gitMerge = exports.gitCompare = exports.gitCommit = exports.gitBranch = exports.gist = exports.gistSecret = exports.gift = exports.gear = exports.fold = exports.flame = exports.file = exports.fileZip = exports.fileText = exports.fileSymlinkFile = exports.fileSymlinkDirectory = exports.fileSubmodule = exports.filePdf = exports.fileMedia = exports.fileDirectory = exports.fileCode = exports.fileBinary = exports.eye = exports.ellipsis = exports.ellipses = exports.diff = exports.diffRenamed = exports.diffRemoved = exports.diffModified = exports.diffIgnored = exports.diffAdded = exports.deviceMobile = exports.deviceDesktop = exports.deviceCamera = exports.deviceCameraVideo = exports.desktopDownload = exports.database = exports.dashboard = exports.dash = exports.creditCard = exports.comment = exports.commentDiscussion = exports.code = exports.cloudUpload = exports.cloudDownload = exports.clock = exports.clippy = exports.circuitBoard = exports.circleSlash = exports.chevronUp = exports.chevronRight = exports.chevronLeft = exports.chevronDown = exports.checklist = exports.check = exports.calendar = exports.bug = exports.browser = exports.broadcast = exports.briefcase = exports.bookmark = exports.book = exports.bold = exports.bell = exports.beaker = exports.arrowUp = exports.arrowSmallUp = exports.arrowSmallRight = exports.arrowSmallLeft = exports.arrowSmallDown = exports.arrowRight = exports.arrowLeft = exports.arrowDown = exports.alert = void 0;
exports.zap = exports.x = exports.watch = exports.versions = exports.verified = exports.unverified = exports.unmute = exports.unfold = exports.triangleUp = exports.triangleRight = exports.triangleLeft = exports.triangleDown = exports.trashcan = exports.tools = exports.thumbsup = exports.thumbsdown = exports.threeBars = exports.textSize = exports.terminal = exports.telescope = exports.tasklist = exports.tag = exports.sync = exports.stop = exports.star = exports.squirrel = exports.smiley = exports.signOut = exports.signIn = exports.shield = exports.settings = exports.server = exports.search = exports.screenNormal = exports.screenFull = exports.ruby = exports.rss = exports.rocket = exports.repo = exports.repoPush = exports.repoPull = exports.repoForked = exports.repoForcePush = exports.repoClone = exports.reply = exports.radioTower = exports.quote = exports.question = exports.pulse = exports.project = exports.primitiveSquare = exports.primitiveDot = exports.plus = exports.plusSmall = exports.plug = exports.pin = exports.person = exports.pencil = exports.paintcan = exports.packageIcon = exports.organization = exports.octoface = exports.note = exports.noNewline = exports.mute = exports.mortarBoard = exports.mirror = exports.milestone = exports.mention = exports.megaphone = exports.markdown = exports.markGithub = exports.mail = exports.mailReply = exports.mailRead = exports.logoGithub = void 0;
var alert = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "alert",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "alert",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.865,1.51999998 C8.685,1.20999998 8.355,1.01999998 7.995,1.01999998 C7.635,1.01999998 7.305,1.20999998 7.125,1.51999998 L0.275000001,13.5 C0.0950000006,13.81 0.0950000006,14.19 0.275000001,14.5 C0.465000001,14.81 0.795000001,15 1.145,15 L14.845,15 C15.205,15 15.535,14.81 15.705,14.5 C15.875,14.19 15.885,13.81 15.715,13.5 L8.865,1.51999998 Z M8.995,13 L6.995,13 L6.995,11 L8.995,11 L8.995,13 L8.995,13 Z M8.995,9.99999998 L6.995,9.99999998 L6.995,5.99999998 L8.995,5.99999998 L8.995,9.99999998 L8.995,9.99999998 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.865,1.51999998 C8.685,1.20999998 8.355,1.01999998 7.995,1.01999998 C7.635,1.01999998 7.305,1.20999998 7.125,1.51999998 L0.275000001,13.5 C0.0950000006,13.81 0.0950000006,14.19 0.275000001,14.5 C0.465000001,14.81 0.795000001,15 1.145,15 L14.845,15 C15.205,15 15.535,14.81 15.705,14.5 C15.875,14.19 15.885,13.81 15.715,13.5 L8.865,1.51999998 Z M8.995,13 L6.995,13 L6.995,11 L8.995,11 L8.995,13 L8.995,13 Z M8.995,9.99999998 L6.995,9.99999998 L6.995,5.99999998 L8.995,5.99999998 L8.995,9.99999998 L8.995,9.99999998 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.alert = alert;
var arrowDown = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-down",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-down",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "7 7 7 3 3 3 3 7 0 7 5 13 10 7"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "7 7 7 3 3 3 3 7 0 7 5 13 10 7"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowDown = arrowDown;
var arrowLeft = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-left",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-left",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "6 3 0 8 6 13 6 10 10 10 10 6 6 6"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "6 3 0 8 6 13 6 10 10 10 10 6 6 6"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowLeft = arrowLeft;
var arrowRight = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-right",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-right",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "10 8 4 3 4 6 0 6 0 10 4 10 4 13"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "10 8 4 3 4 6 0 6 0 10 4 10 4 13"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowRight = arrowRight;
var arrowSmallDown = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-small-down",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-small-down",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "4 7 4 5 2 5 2 7 0 7 3 11 6 7"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "4 7 4 5 2 5 2 7 0 7 3 11 6 7"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowSmallDown = arrowSmallDown;
var arrowSmallLeft = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-small-left",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-small-left",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "4 7 4 5 0 8 4 11 4 9 6 9 6 7"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "4 7 4 5 0 8 4 11 4 9 6 9 6 7"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowSmallLeft = arrowSmallLeft;
var arrowSmallRight = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-small-right",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-small-right",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "6 8 2 5 2 7 0 7 0 9 2 9 2 11"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "6 8 2 5 2 7 0 7 0 9 2 9 2 11"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowSmallRight = arrowSmallRight;
var arrowSmallUp = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-small-up",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-small-up",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "3 5 0 9 2 9 2 11 4 11 4 9 6 9"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "3 5 0 9 2 9 2 11 4 11 4 9 6 9"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowSmallUp = arrowSmallUp;
var arrowUp = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "arrow-up",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "arrow-up",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "5 3 0 9 3 9 3 13 7 13 7 9 10 9"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "5 3 0 9 3 9 3 13 7 13 7 9 10 9"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.arrowUp = arrowUp;
var beaker = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "beaker",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "beaker",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14.3797254,14.59 L10.9997254,7 L10.9997254,3 L11.9997254,3 L11.9997254,2 L2.99972539,2 L2.99972539,3 L3.99972539,3 L3.99972539,7 L0.62972539,14.59 C0.32972539,15.25 0.81972539,16 1.53972539,16 L13.4797254,16 C14.1997254,16 14.6797254,15.25 14.3897254,14.59 L14.3797254,14.59 Z M3.74972539,10 L4.99972539,7 L4.99972539,3 L9.99972539,3 L9.99972539,7 L11.2497254,10 L3.74972539,10 L3.74972539,10 Z M7.99972539,8 L8.99972539,8 L8.99972539,9 L7.99972539,9 L7.99972539,8 L7.99972539,8 Z M6.99972539,7 L5.99972539,7 L5.99972539,6 L6.99972539,6 L6.99972539,7 L6.99972539,7 Z M6.99972539,4 L7.99972539,4 L7.99972539,5 L6.99972539,5 L6.99972539,4 L6.99972539,4 Z M6.99972539,1 L5.99972539,1 L5.99972539,0 L6.99972539,0 L6.99972539,1 L6.99972539,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14.3797254,14.59 L10.9997254,7 L10.9997254,3 L11.9997254,3 L11.9997254,2 L2.99972539,2 L2.99972539,3 L3.99972539,3 L3.99972539,7 L0.62972539,14.59 C0.32972539,15.25 0.81972539,16 1.53972539,16 L13.4797254,16 C14.1997254,16 14.6797254,15.25 14.3897254,14.59 L14.3797254,14.59 Z M3.74972539,10 L4.99972539,7 L4.99972539,3 L9.99972539,3 L9.99972539,7 L11.2497254,10 L3.74972539,10 L3.74972539,10 Z M7.99972539,8 L8.99972539,8 L8.99972539,9 L7.99972539,9 L7.99972539,8 L7.99972539,8 Z M6.99972539,7 L5.99972539,7 L5.99972539,6 L6.99972539,6 L6.99972539,7 L6.99972539,7 Z M6.99972539,4 L7.99972539,4 L7.99972539,5 L6.99972539,5 L6.99972539,4 L6.99972539,4 Z M6.99972539,1 L5.99972539,1 L5.99972539,0 L6.99972539,0 L6.99972539,1 L6.99972539,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.beaker = beaker;
var bell = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "bell",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "bell",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,12 L14,13 L0,13 L0,12 L0.73,11.42 C1.5,10.65 1.54,8.87 1.92,7 C2.69,3.23 6,2 6,2 C6,1.45 6.45,1 7,1 C7.55,1 8,1.45 8,2 C8,2 11.39,3.23 12.16,7 C12.54,8.88 12.58,10.66 13.35,11.42 L14.01,12 L14,12 Z M7,16 C8.11,16 9,15.11 9,14 L5,14 C5,15.11 5.89,16 7,16 L7,16 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,12 L14,13 L0,13 L0,12 L0.73,11.42 C1.5,10.65 1.54,8.87 1.92,7 C2.69,3.23 6,2 6,2 C6,1.45 6.45,1 7,1 C7.55,1 8,1.45 8,2 C8,2 11.39,3.23 12.16,7 C12.54,8.88 12.58,10.66 13.35,11.42 L14.01,12 L14,12 Z M7,16 C8.11,16 9,15.11 9,14 L5,14 C5,15.11 5.89,16 7,16 L7,16 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.bell = bell;
var bold = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "bold",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "bold",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M1,2 L4.83,2 C7.31,2 9.13,2.75 9.13,4.95 C9.13,6.09 8.5,7.18 7.46,7.56 L7.46,7.62 C8.79,7.92 9.76,8.85 9.76,10.48 C9.76,12.87 7.79,14 5.15,14 L1,14 L1,2 L1,2 Z M4.66,6.95 C6.33,6.95 7.04,6.29 7.04,5.26 C7.04,4.09 6.26,3.65 4.7,3.65 L3.13,3.65 L3.13,6.95 L4.66,6.95 L4.66,6.95 Z M4.93,12.34 C6.7,12.34 7.68,11.7 7.68,10.36 C7.68,9.09 6.73,8.55 4.93,8.55 L3.13,8.55 L3.13,12.35 L4.93,12.35 L4.93,12.34 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M1,2 L4.83,2 C7.31,2 9.13,2.75 9.13,4.95 C9.13,6.09 8.5,7.18 7.46,7.56 L7.46,7.62 C8.79,7.92 9.76,8.85 9.76,10.48 C9.76,12.87 7.79,14 5.15,14 L1,14 L1,2 L1,2 Z M4.66,6.95 C6.33,6.95 7.04,6.29 7.04,5.26 C7.04,4.09 6.26,3.65 4.7,3.65 L3.13,3.65 L3.13,6.95 L4.66,6.95 L4.66,6.95 Z M4.93,12.34 C6.7,12.34 7.68,11.7 7.68,10.36 C7.68,9.09 6.73,8.55 4.93,8.55 L3.13,8.55 L3.13,12.35 L4.93,12.35 L4.93,12.34 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.bold = bold;
var book = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "book",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "book",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M3,5 L7,5 L7,6 L3,6 L3,5 L3,5 Z M3,8 L7,8 L7,7 L3,7 L3,8 L3,8 Z M3,10 L7,10 L7,9 L3,9 L3,10 L3,10 Z M14,5 L10,5 L10,6 L14,6 L14,5 L14,5 Z M14,7 L10,7 L10,8 L14,8 L14,7 L14,7 Z M14,9 L10,9 L10,10 L14,10 L14,9 L14,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L9.5,13 L8.5,14 L7.5,13 L2,13 C1.45,13 1,12.55 1,12 L1,3 C1,2.45 1.45,2 2,2 L7.5,2 L8.5,3 L9.5,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M8,3.5 L7.5,3 L2,3 L2,12 L8,12 L8,3.5 L8,3.5 Z M15,3 L9.5,3 L9,3.5 L9,12 L15,12 L15,3 L15,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M3,5 L7,5 L7,6 L3,6 L3,5 L3,5 Z M3,8 L7,8 L7,7 L3,7 L3,8 L3,8 Z M3,10 L7,10 L7,9 L3,9 L3,10 L3,10 Z M14,5 L10,5 L10,6 L14,6 L14,5 L14,5 Z M14,7 L10,7 L10,8 L14,8 L14,7 L14,7 Z M14,9 L10,9 L10,10 L14,10 L14,9 L14,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L9.5,13 L8.5,14 L7.5,13 L2,13 C1.45,13 1,12.55 1,12 L1,3 C1,2.45 1.45,2 2,2 L7.5,2 L8.5,3 L9.5,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M8,3.5 L7.5,3 L2,3 L2,12 L8,12 L8,3.5 L8,3.5 Z M15,3 L9.5,3 L9,3.5 L9,12 L15,12 L15,3 L15,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "bookmark",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "bookmark",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,0 L1,0 C0.27,0 0,0.27 0,1 L0,16 L5,12.91 L10,16 L10,1 C10,0.27 9.73,0 9,0 L9,0 Z M8.22,4.25 L6.36,5.61 L7.08,7.77 C7.14,7.99 7.06,8.05 6.88,7.94 L5,6.6 L3.12,7.94 C2.93,8.05 2.87,7.99 2.92,7.77 L3.64,5.61 L1.78,4.25 C1.61,4.09 1.64,4.02 1.87,4.02 L4.17,3.99 L4.87,1.83 L5.12,1.83 L5.82,3.99 L8.12,4.02 C8.35,4.02 8.39,4.1 8.21,4.25 L8.22,4.25 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,0 L1,0 C0.27,0 0,0.27 0,1 L0,16 L5,12.91 L10,16 L10,1 C10,0.27 9.73,0 9,0 L9,0 Z M8.22,4.25 L6.36,5.61 L7.08,7.77 C7.14,7.99 7.06,8.05 6.88,7.94 L5,6.6 L3.12,7.94 C2.93,8.05 2.87,7.99 2.92,7.77 L3.64,5.61 L1.78,4.25 C1.61,4.09 1.64,4.02 1.87,4.02 L4.17,3.99 L4.87,1.83 L5.12,1.83 L5.82,3.99 L8.12,4.02 C8.35,4.02 8.39,4.1 8.21,4.25 L8.22,4.25 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.bookmark = bookmark;
var briefcase = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "briefcase",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "briefcase",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,4 L9,3 C9,2.45 8.55,2 8,2 L6,2 C5.45,2 5,2.45 5,3 L5,4 L1,4 C0.45,4 0,4.45 0,5 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L9,4 L9,4 Z M6,3 L8,3 L8,4 L6,4 L6,3 L6,3 Z M13,9 L8,9 L8,10 L6,10 L6,9 L1,9 L1,5 L2,5 L2,8 L12,8 L12,5 L13,5 L13,9 L13,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,4 L9,3 C9,2.45 8.55,2 8,2 L6,2 C5.45,2 5,2.45 5,3 L5,4 L1,4 C0.45,4 0,4.45 0,5 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L9,4 L9,4 Z M6,3 L8,3 L8,4 L6,4 L6,3 L6,3 Z M13,9 L8,9 L8,10 L6,10 L6,9 L1,9 L1,5 L2,5 L2,8 L12,8 L12,5 L13,5 L13,9 L13,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.briefcase = briefcase;
var broadcast = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "broadcast",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "broadcast",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,9 L8,9 C8.55,9 9,8.55 9,8 L9,7 C9,6.45 8.55,6 8,6 L7,6 C6.45,6 6,6.45 6,7 L6,8 C6,8.55 6.45,9 7,9 L6,9 C5.45,9 5,9.45 5,10 L5,12 L6,12 L6,15 C6,15.55 6.45,16 7,16 L8,16 C8.55,16 9,15.55 9,15 L9,12 L10,12 L10,10 C10,9.45 9.55,9 9,9 L9,9 Z M7,7 L8,7 L8,8 L7,8 L7,7 L7,7 Z M9,11 L8,11 L8,15 L7,15 L7,11 L6,11 L6,10 L9,10 L9,11 L9,11 Z M11.09,7.5 C11.09,5.52 9.48,3.91 7.5,3.91 C5.52,3.91 3.91,5.52 3.91,7.5 C3.91,7.78 3.94,8.05 4,8.31 L4,10.29 C3.39,9.52 3,8.56 3,7.49 C3,5.01 5.02,2.99 7.5,2.99 C9.98,2.99 12,5.01 12,7.49 C12,8.55 11.61,9.52 11,10.29 L11,8.31 C11.06,8.04 11.09,7.78 11.09,7.5 L11.09,7.5 Z M15,7.5 C15,10.38 13.37,12.88 11,14.13 L11,13.08 C12.86,11.92 14.09,9.86 14.09,7.5 C14.09,3.86 11.14,0.91 7.5,0.91 C3.86,0.91 0.91,3.86 0.91,7.5 C0.91,9.86 2.14,11.92 4,13.08 L4,14.13 C1.63,12.88 0,10.38 0,7.5 C0,3.36 3.36,0 7.5,0 C11.64,0 15,3.36 15,7.5 L15,7.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,9 L8,9 C8.55,9 9,8.55 9,8 L9,7 C9,6.45 8.55,6 8,6 L7,6 C6.45,6 6,6.45 6,7 L6,8 C6,8.55 6.45,9 7,9 L6,9 C5.45,9 5,9.45 5,10 L5,12 L6,12 L6,15 C6,15.55 6.45,16 7,16 L8,16 C8.55,16 9,15.55 9,15 L9,12 L10,12 L10,10 C10,9.45 9.55,9 9,9 L9,9 Z M7,7 L8,7 L8,8 L7,8 L7,7 L7,7 Z M9,11 L8,11 L8,15 L7,15 L7,11 L6,11 L6,10 L9,10 L9,11 L9,11 Z M11.09,7.5 C11.09,5.52 9.48,3.91 7.5,3.91 C5.52,3.91 3.91,5.52 3.91,7.5 C3.91,7.78 3.94,8.05 4,8.31 L4,10.29 C3.39,9.52 3,8.56 3,7.49 C3,5.01 5.02,2.99 7.5,2.99 C9.98,2.99 12,5.01 12,7.49 C12,8.55 11.61,9.52 11,10.29 L11,8.31 C11.06,8.04 11.09,7.78 11.09,7.5 L11.09,7.5 Z M15,7.5 C15,10.38 13.37,12.88 11,14.13 L11,13.08 C12.86,11.92 14.09,9.86 14.09,7.5 C14.09,3.86 11.14,0.91 7.5,0.91 C3.86,0.91 0.91,3.86 0.91,7.5 C0.91,9.86 2.14,11.92 4,13.08 L4,14.13 C1.63,12.88 0,10.38 0,7.5 C0,3.36 3.36,0 7.5,0 C11.64,0 15,3.36 15,7.5 L15,7.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.broadcast = broadcast;
var browser = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "browser",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "browser",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M5,3 L6,3 L6,4 L5,4 L5,3 L5,3 Z M3,3 L4,3 L4,4 L3,4 L3,3 L3,3 Z M1,3 L2,3 L2,4 L1,4 L1,3 L1,3 Z M13,13 L1,13 L1,5 L13,5 L13,13 L13,13 Z M13,4 L7,4 L7,3 L13,3 L13,4 L13,4 Z M14,3 C14,2.45 13.55,2 13,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,3 L14,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M5,3 L6,3 L6,4 L5,4 L5,3 L5,3 Z M3,3 L4,3 L4,4 L3,4 L3,3 L3,3 Z M1,3 L2,3 L2,4 L1,4 L1,3 L1,3 Z M13,13 L1,13 L1,5 L13,5 L13,13 L13,13 Z M13,4 L7,4 L7,3 L13,3 L13,4 L13,4 Z M14,3 C14,2.45 13.55,2 13,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,3 L14,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.browser = browser;
var bug = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "bug",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "bug",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,10 L14,10 L14,9 L11,9 L11,8 L14.17,6.97 L13.83,6.03 L11,7 L11,6 C11,5.45 10.55,5 9.99999998,5 L9.99999998,4 C9.99999998,3.52 9.63999998,3.12 9.16999998,3.03 L10.2,2 L12,2 L12,1 L9.79999998,1 L7.79999998,3 L7.20999998,3 L5.19999998,1 L2.99999998,1 L2.99999998,2 L4.79999998,2 L5.82999998,3.03 C5.35999998,3.12 4.99999998,3.51 4.99999998,4 L4.99999998,5 C4.44999998,5 3.99999998,5.45 3.99999998,6 L3.99999998,7 L1.16999998,6.03 L0.829999983,6.97 L3.99999998,8 L3.99999998,9 L0.999999983,9 L0.999999983,10 L3.99999998,10 L3.99999998,11 L0.829999983,12.03 L1.16999998,12.97 L3.99999998,12 L3.99999998,13 C3.99999998,13.55 4.44999998,14 4.99999998,14 L5.99999998,14 L6.99999998,13 L6.99999998,6 L7.99999998,6 L7.99999998,13 L8.99999998,14 L9.99999998,14 C10.55,14 11,13.55 11,13 L11,12 L13.83,12.97 L14.17,12.03 L11,11 L11,10 L11,10 Z M8.99999998,5 L5.99999998,5 L5.99999998,4 L8.99999998,4 L8.99999998,5 L8.99999998,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,10 L14,10 L14,9 L11,9 L11,8 L14.17,6.97 L13.83,6.03 L11,7 L11,6 C11,5.45 10.55,5 9.99999998,5 L9.99999998,4 C9.99999998,3.52 9.63999998,3.12 9.16999998,3.03 L10.2,2 L12,2 L12,1 L9.79999998,1 L7.79999998,3 L7.20999998,3 L5.19999998,1 L2.99999998,1 L2.99999998,2 L4.79999998,2 L5.82999998,3.03 C5.35999998,3.12 4.99999998,3.51 4.99999998,4 L4.99999998,5 C4.44999998,5 3.99999998,5.45 3.99999998,6 L3.99999998,7 L1.16999998,6.03 L0.829999983,6.97 L3.99999998,8 L3.99999998,9 L0.999999983,9 L0.999999983,10 L3.99999998,10 L3.99999998,11 L0.829999983,12.03 L1.16999998,12.97 L3.99999998,12 L3.99999998,13 C3.99999998,13.55 4.44999998,14 4.99999998,14 L5.99999998,14 L6.99999998,13 L6.99999998,6 L7.99999998,6 L7.99999998,13 L8.99999998,14 L9.99999998,14 C10.55,14 11,13.55 11,13 L11,12 L13.83,12.97 L14.17,12.03 L11,11 L11,10 L11,10 Z M8.99999998,5 L5.99999998,5 L5.99999998,4 L8.99999998,4 L8.99999998,5 L8.99999998,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.bug = bug;
var calendar = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "calendar",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "calendar",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,2 L12,2 L12,3.5 C12,3.78 11.78,4 11.5,4 L9.5,4 C9.22,4 9,3.78 9,3.5 L9,2 L6,2 L6,3.5 C6,3.78 5.78,4 5.5,4 L3.5,4 C3.22,4 3,3.78 3,3.5 L3,2 L2,2 C1.45,2 1,2.45 1,3 L1,14 C1,14.55 1.45,15 2,15 L13,15 C13.55,15 14,14.55 14,14 L14,3 C14,2.45 13.55,2 13,2 L13,2 Z M13,14 L2,14 L2,5 L13,5 L13,14 L13,14 Z M5,3 L4,3 L4,1 L5,1 L5,3 L5,3 Z M11,3 L10,3 L10,1 L11,1 L11,3 L11,3 Z M6,7 L5,7 L5,6 L6,6 L6,7 L6,7 Z M8,7 L7,7 L7,6 L8,6 L8,7 L8,7 Z M10,7 L9,7 L9,6 L10,6 L10,7 L10,7 Z M12,7 L11,7 L11,6 L12,6 L12,7 L12,7 Z M4,9 L3,9 L3,8 L4,8 L4,9 L4,9 Z M6,9 L5,9 L5,8 L6,8 L6,9 L6,9 Z M8,9 L7,9 L7,8 L8,8 L8,9 L8,9 Z M10,9 L9,9 L9,8 L10,8 L10,9 L10,9 Z M12,9 L11,9 L11,8 L12,8 L12,9 L12,9 Z M4,11 L3,11 L3,10 L4,10 L4,11 L4,11 Z M6,11 L5,11 L5,10 L6,10 L6,11 L6,11 Z M8,11 L7,11 L7,10 L8,10 L8,11 L8,11 Z M10,11 L9,11 L9,10 L10,10 L10,11 L10,11 Z M12,11 L11,11 L11,10 L12,10 L12,11 L12,11 Z M4,13 L3,13 L3,12 L4,12 L4,13 L4,13 Z M6,13 L5,13 L5,12 L6,12 L6,13 L6,13 Z M8,13 L7,13 L7,12 L8,12 L8,13 L8,13 Z M10,13 L9,13 L9,12 L10,12 L10,13 L10,13 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,2 L12,2 L12,3.5 C12,3.78 11.78,4 11.5,4 L9.5,4 C9.22,4 9,3.78 9,3.5 L9,2 L6,2 L6,3.5 C6,3.78 5.78,4 5.5,4 L3.5,4 C3.22,4 3,3.78 3,3.5 L3,2 L2,2 C1.45,2 1,2.45 1,3 L1,14 C1,14.55 1.45,15 2,15 L13,15 C13.55,15 14,14.55 14,14 L14,3 C14,2.45 13.55,2 13,2 L13,2 Z M13,14 L2,14 L2,5 L13,5 L13,14 L13,14 Z M5,3 L4,3 L4,1 L5,1 L5,3 L5,3 Z M11,3 L10,3 L10,1 L11,1 L11,3 L11,3 Z M6,7 L5,7 L5,6 L6,6 L6,7 L6,7 Z M8,7 L7,7 L7,6 L8,6 L8,7 L8,7 Z M10,7 L9,7 L9,6 L10,6 L10,7 L10,7 Z M12,7 L11,7 L11,6 L12,6 L12,7 L12,7 Z M4,9 L3,9 L3,8 L4,8 L4,9 L4,9 Z M6,9 L5,9 L5,8 L6,8 L6,9 L6,9 Z M8,9 L7,9 L7,8 L8,8 L8,9 L8,9 Z M10,9 L9,9 L9,8 L10,8 L10,9 L10,9 Z M12,9 L11,9 L11,8 L12,8 L12,9 L12,9 Z M4,11 L3,11 L3,10 L4,10 L4,11 L4,11 Z M6,11 L5,11 L5,10 L6,10 L6,11 L6,11 Z M8,11 L7,11 L7,10 L8,10 L8,11 L8,11 Z M10,11 L9,11 L9,10 L10,10 L10,11 L10,11 Z M12,11 L11,11 L11,10 L12,10 L12,11 L12,11 Z M4,13 L3,13 L3,12 L4,12 L4,13 L4,13 Z M6,13 L5,13 L5,12 L6,12 L6,13 L6,13 Z M8,13 L7,13 L7,12 L8,12 L8,13 L8,13 Z M10,13 L9,13 L9,12 L10,12 L10,13 L10,13 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.calendar = calendar;
var check = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "check",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "check",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "12 5 4 13 0 9 1.5 7.5 4 10 10.5 3.5"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "12 5 4 13 0 9 1.5 7.5 4 10 10.5 3.5"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.check = check;
var checklist = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "checklist",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "checklist",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M16,8.5 L10,14.5 L7,11.5 L8.5,10 L10,11.5 L14.5,7 L16,8.5 L16,8.5 Z M5.7,12.2 L6.5,13 L2,13 C1.45,13 1,12.55 1,12 L1,3 C1,2.45 1.45,2 2,2 L9,2 C9.55,2 10,2.45 10,3 L10,9.5 L9.2,8.7 C8.81,8.31 8.17,8.31 7.78,8.7 L5.7,10.8 C5.31,11.19 5.31,11.82 5.7,12.21 L5.7,12.2 Z M4,4 L9,4 L9,3 L4,3 L4,4 L4,4 Z M4,6 L9,6 L9,5 L4,5 L4,6 L4,6 Z M4,8 L7,8 L7,7 L4,7 L4,8 L4,8 Z M3,9 L2,9 L2,10 L3,10 L3,9 L3,9 Z M3,7 L2,7 L2,8 L3,8 L3,7 L3,7 Z M3,5 L2,5 L2,6 L3,6 L3,5 L3,5 Z M3,3 L2,3 L2,4 L3,4 L3,3 L3,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M16,8.5 L10,14.5 L7,11.5 L8.5,10 L10,11.5 L14.5,7 L16,8.5 L16,8.5 Z M5.7,12.2 L6.5,13 L2,13 C1.45,13 1,12.55 1,12 L1,3 C1,2.45 1.45,2 2,2 L9,2 C9.55,2 10,2.45 10,3 L10,9.5 L9.2,8.7 C8.81,8.31 8.17,8.31 7.78,8.7 L5.7,10.8 C5.31,11.19 5.31,11.82 5.7,12.21 L5.7,12.2 Z M4,4 L9,4 L9,3 L4,3 L4,4 L4,4 Z M4,6 L9,6 L9,5 L4,5 L4,6 L4,6 Z M4,8 L7,8 L7,7 L4,7 L4,8 L4,8 Z M3,9 L2,9 L2,10 L3,10 L3,9 L3,9 Z M3,7 L2,7 L2,8 L3,8 L3,7 L3,7 Z M3,5 L2,5 L2,6 L3,6 L3,5 L3,5 Z M3,3 L2,3 L2,4 L3,4 L3,3 L3,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.checklist = checklist;
var chevronDown = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "chevron-down",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "chevron-down",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "5 11 0 6 1.5 4.5 5 8.25 8.5 4.5 10 6"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "5 11 0 6 1.5 4.5 5 8.25 8.5 4.5 10 6"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.chevronDown = chevronDown;
var chevronLeft = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "chevron-left",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "chevron-left",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "5.5 3 7 4.5 3.25 8 7 11.5 5.5 13 0.5 8"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "5.5 3 7 4.5 3.25 8 7 11.5 5.5 13 0.5 8"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.chevronLeft = chevronLeft;
var chevronRight = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "chevron-right",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "chevron-right",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "7.5 8 2.5 13 1 11.5 4.75 8 1 4.5 2.5 3"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "7.5 8 2.5 13 1 11.5 4.75 8 1 4.5 2.5 3"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.chevronRight = chevronRight;
var chevronUp = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "chevron-up",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "chevron-up",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "10 10 8.5 11.5 5 7.75 1.5 11.5 0 10 5 5"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "10 10 8.5 11.5 5 7.75 1.5 11.5 0 10 5 5"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.chevronUp = chevronUp;
var circleSlash = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "circle-slash",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "circle-slash",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z M7,2.3 C8.3,2.3 9.5,2.74 10.47,3.47 L2.47,11.47 C1.74,10.5 1.3,9.3 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,13.71 C5.7,13.71 4.5,13.27 3.53,12.54 L11.53,4.54 C12.26,5.51 12.7,6.71 12.7,8.01 C12.7,11.15 10.14,13.71 7,13.71 L7,13.71 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z M7,2.3 C8.3,2.3 9.5,2.74 10.47,3.47 L2.47,11.47 C1.74,10.5 1.3,9.3 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,13.71 C5.7,13.71 4.5,13.27 3.53,12.54 L11.53,4.54 C12.26,5.51 12.7,6.71 12.7,8.01 C12.7,11.15 10.14,13.71 7,13.71 L7,13.71 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.circleSlash = circleSlash;
var circuitBoard = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "circuit-board",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "circuit-board",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M3,5 C3,4.45 3.45,4 4,4 C4.55,4 5,4.45 5,5 C5,5.55 4.55,6 4,6 C3.45,6 3,5.55 3,5 L3,5 Z M11,5 C11,4.45 10.55,4 10,4 C9.45,4 9,4.45 9,5 C9,5.55 9.45,6 10,6 C10.55,6 11,5.55 11,5 L11,5 Z M11,11 C11,10.45 10.55,10 10,10 C9.45,10 9,10.45 9,11 C9,11.55 9.45,12 10,12 C10.55,12 11,11.55 11,11 L11,11 Z M13,1 L5,1 L5,3.17 C5.36,3.36 5.64,3.64 5.83,4 L8.17,4 C8.59,3.22 9.5,2.72 10.51,2.95 C11.26,3.14 11.87,3.75 12.04,4.5 C12.35,5.88 11.32,7.09 9.99,7.09 C9.19,7.09 8.51,6.65 8.16,6 L5.83,6 C5.41,6.8 4.5,7.28 3.49,7.03 C2.76,6.86 2.15,6.25 1.97,5.51 C1.72,4.49 2.2,3.59 3,3.17 L3,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L6,10 L8.17,10 C8.59,9.22 9.5,8.72 10.51,8.95 C11.26,9.14 11.87,9.75 12.04,10.5 C12.35,11.88 11.32,13.09 9.99,13.09 C9.19,13.09 8.51,12.65 8.16,12 L6.99,12 L4,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M3,5 C3,4.45 3.45,4 4,4 C4.55,4 5,4.45 5,5 C5,5.55 4.55,6 4,6 C3.45,6 3,5.55 3,5 L3,5 Z M11,5 C11,4.45 10.55,4 10,4 C9.45,4 9,4.45 9,5 C9,5.55 9.45,6 10,6 C10.55,6 11,5.55 11,5 L11,5 Z M11,11 C11,10.45 10.55,10 10,10 C9.45,10 9,10.45 9,11 C9,11.55 9.45,12 10,12 C10.55,12 11,11.55 11,11 L11,11 Z M13,1 L5,1 L5,3.17 C5.36,3.36 5.64,3.64 5.83,4 L8.17,4 C8.59,3.22 9.5,2.72 10.51,2.95 C11.26,3.14 11.87,3.75 12.04,4.5 C12.35,5.88 11.32,7.09 9.99,7.09 C9.19,7.09 8.51,6.65 8.16,6 L5.83,6 C5.41,6.8 4.5,7.28 3.49,7.03 C2.76,6.86 2.15,6.25 1.97,5.51 C1.72,4.49 2.2,3.59 3,3.17 L3,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L6,10 L8.17,10 C8.59,9.22 9.5,8.72 10.51,8.95 C11.26,9.14 11.87,9.75 12.04,10.5 C12.35,11.88 11.32,13.09 9.99,13.09 C9.19,13.09 8.51,12.65 8.16,12 L6.99,12 L4,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.circuitBoard = circuitBoard;
var clippy = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "clippy",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "clippy",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M2,13 L6,13 L6,14 L2,14 L2,13 L2,13 Z M7,7 L2,7 L2,8 L7,8 L7,7 L7,7 Z M9,10 L9,8 L6,11 L9,14 L9,12 L14,12 L14,10 L9,10 L9,10 Z M4.5,9 L2,9 L2,10 L4.5,10 L4.5,9 L4.5,9 Z M2,12 L4.5,12 L4.5,11 L2,11 L2,12 L2,12 Z M11,13 L12,13 L12,15 C11.98,15.28 11.89,15.52 11.7,15.7 C11.51,15.88 11.28,15.98 11,16 L1,16 C0.45,16 0,15.55 0,15 L0,4 C0,3.45 0.45,3 1,3 L4,3 C4,1.89 4.89,1 6,1 C7.11,1 8,1.89 8,3 L11,3 C11.55,3 12,3.45 12,4 L12,9 L11,9 L11,6 L1,6 L1,15 L11,15 L11,13 L11,13 Z M2,5 L10,5 C10,4.45 9.55,4 9,4 L8,4 C7.45,4 7,3.55 7,3 C7,2.45 6.55,2 6,2 C5.45,2 5,2.45 5,3 C5,3.55 4.55,4 4,4 L3,4 C2.45,4 2,4.45 2,5 L2,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M2,13 L6,13 L6,14 L2,14 L2,13 L2,13 Z M7,7 L2,7 L2,8 L7,8 L7,7 L7,7 Z M9,10 L9,8 L6,11 L9,14 L9,12 L14,12 L14,10 L9,10 L9,10 Z M4.5,9 L2,9 L2,10 L4.5,10 L4.5,9 L4.5,9 Z M2,12 L4.5,12 L4.5,11 L2,11 L2,12 L2,12 Z M11,13 L12,13 L12,15 C11.98,15.28 11.89,15.52 11.7,15.7 C11.51,15.88 11.28,15.98 11,16 L1,16 C0.45,16 0,15.55 0,15 L0,4 C0,3.45 0.45,3 1,3 L4,3 C4,1.89 4.89,1 6,1 C7.11,1 8,1.89 8,3 L11,3 C11.55,3 12,3.45 12,4 L12,9 L11,9 L11,6 L1,6 L1,15 L11,15 L11,13 L11,13 Z M2,5 L10,5 C10,4.45 9.55,4 9,4 L8,4 C7.45,4 7,3.55 7,3 C7,2.45 6.55,2 6,2 C5.45,2 5,2.45 5,3 C5,3.55 4.55,4 4,4 L3,4 C2.45,4 2,4.45 2,5 L2,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.clippy = clippy;
var clock = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "clock",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "clock",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,8 L11,8 L11,10 L7,10 C6.45,10 6,9.55 6,9 L6,4 L8,4 L8,8 L8,8 Z M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,8 L11,8 L11,10 L7,10 C6.45,10 6,9.55 6,9 L6,4 L8,4 L8,8 L8,8 Z M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.clock = clock;
var cloudDownload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "cloud-download",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "cloud-download",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,12 L11,12 L8,15 L5,12 L7,12 L7,7 L9,7 L9,12 L9,12 Z M12,4 C12,3.56 11.09,1 7.5,1 C5.08,1 3,2.92 3,5 C1.02,5 0,6.52 0,8 C0,9.53 1,11 3,11 L6,11 L6,9.7 L3,9.7 C1.38,9.7 1.3,8.28 1.3,8 C1.3,7.83 1.35,6.3 3,6.3 L4.3,6.3 L4.3,5 C4.3,3.61 5.86,2.3 7.5,2.3 C10.05,2.3 10.63,3.85 10.7,4.1 L10.7,5.3 L12,5.3 C12.81,5.3 14.7,5.52 14.7,7.5 C14.7,9.59 12.45,9.7 12,9.7 L10,9.7 L10,11 L12,11 C14.08,11 16,9.84 16,7.5 C16,5.06 14.08,4 12,4 L12,4 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,12 L11,12 L8,15 L5,12 L7,12 L7,7 L9,7 L9,12 L9,12 Z M12,4 C12,3.56 11.09,1 7.5,1 C5.08,1 3,2.92 3,5 C1.02,5 0,6.52 0,8 C0,9.53 1,11 3,11 L6,11 L6,9.7 L3,9.7 C1.38,9.7 1.3,8.28 1.3,8 C1.3,7.83 1.35,6.3 3,6.3 L4.3,6.3 L4.3,5 C4.3,3.61 5.86,2.3 7.5,2.3 C10.05,2.3 10.63,3.85 10.7,4.1 L10.7,5.3 L12,5.3 C12.81,5.3 14.7,5.52 14.7,7.5 C14.7,9.59 12.45,9.7 12,9.7 L10,9.7 L10,11 L12,11 C14.08,11 16,9.84 16,7.5 C16,5.06 14.08,4 12,4 L12,4 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.cloudDownload = cloudDownload;
var cloudUpload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "cloud-upload",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "cloud-upload",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,9 L5,9 L8,6 L11,9 L9,9 L9,14 L7,14 L7,9 L7,9 Z M12,5 C12,4.56 11.09,2 7.5,2 C5.08,2 3,3.92 3,6 C1.02,6 0,7.52 0,9 C0,10.53 1,12 3,12 L6,12 L6,10.7 L3,10.7 C1.38,10.7 1.3,9.28 1.3,9 C1.3,8.83 1.35,7.3 3,7.3 L4.3,7.3 L4.3,6 C4.3,4.61 5.86,3.3 7.5,3.3 C10.05,3.3 10.63,4.85 10.7,5.1 L10.7,6.3 L12,6.3 C12.81,6.3 14.7,6.52 14.7,8.5 C14.7,10.59 12.45,10.7 12,10.7 L10,10.7 L10,12 L12,12 C14.08,12 16,10.84 16,8.5 C16,6.06 14.08,5 12,5 L12,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,9 L5,9 L8,6 L11,9 L9,9 L9,14 L7,14 L7,9 L7,9 Z M12,5 C12,4.56 11.09,2 7.5,2 C5.08,2 3,3.92 3,6 C1.02,6 0,7.52 0,9 C0,10.53 1,12 3,12 L6,12 L6,10.7 L3,10.7 C1.38,10.7 1.3,9.28 1.3,9 C1.3,8.83 1.35,7.3 3,7.3 L4.3,7.3 L4.3,6 C4.3,4.61 5.86,3.3 7.5,3.3 C10.05,3.3 10.63,4.85 10.7,5.1 L10.7,6.3 L12,6.3 C12.81,6.3 14.7,6.52 14.7,8.5 C14.7,10.59 12.45,10.7 12,10.7 L10,10.7 L10,12 L12,12 C14.08,12 16,10.84 16,8.5 C16,6.06 14.08,5 12,5 L12,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.cloudUpload = cloudUpload;
var code = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "code",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "code",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9.5,3 L8,4.5 L11.5,8 L8,11.5 L9.5,13 L14,8 L9.5,3 L9.5,3 Z M4.5,3 L0,8 L4.5,13 L6,11.5 L2.5,8 L6,4.5 L4.5,3 L4.5,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9.5,3 L8,4.5 L11.5,8 L8,11.5 L9.5,13 L14,8 L9.5,3 L9.5,3 Z M4.5,3 L0,8 L4.5,13 L6,11.5 L2.5,8 L6,4.5 L4.5,3 L4.5,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.code = code;
var commentDiscussion = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "comment-discussion",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "comment-discussion",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15,1 L6,1 C5.45,1 5,1.45 5,2 L5,4 L1,4 C0.45,4 0,4.45 0,5 L0,11 C0,11.55 0.45,12 1,12 L2,12 L2,15 L5,12 L9,12 C9.55,12 10,11.55 10,11 L10,9 L11,9 L14,12 L14,9 L15,9 C15.55,9 16,8.55 16,8 L16,2 C16,1.45 15.55,1 15,1 L15,1 Z M9,11 L4.5,11 L3,12.5 L3,11 L1,11 L1,5 L5,5 L5,8 C5,8.55 5.45,9 6,9 L9,9 L9,11 L9,11 Z M15,8 L13,8 L13,9.5 L11.5,8 L6,8 L6,2 L15,2 L15,8 L15,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15,1 L6,1 C5.45,1 5,1.45 5,2 L5,4 L1,4 C0.45,4 0,4.45 0,5 L0,11 C0,11.55 0.45,12 1,12 L2,12 L2,15 L5,12 L9,12 C9.55,12 10,11.55 10,11 L10,9 L11,9 L14,12 L14,9 L15,9 C15.55,9 16,8.55 16,8 L16,2 C16,1.45 15.55,1 15,1 L15,1 Z M9,11 L4.5,11 L3,12.5 L3,11 L1,11 L1,5 L5,5 L5,8 C5,8.55 5.45,9 6,9 L9,9 L9,11 L9,11 Z M15,8 L13,8 L13,9.5 L11.5,8 L6,8 L6,2 L15,2 L15,8 L15,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.commentDiscussion = commentDiscussion;
var comment = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "comment",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "comment",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,1 L2,1 C1.45,1 1,1.45 1,2 L1,10 C1,10.55 1.45,11 2,11 L4,11 L4,14.5 L7.5,11 L14,11 C14.55,11 15,10.55 15,10 L15,2 C15,1.45 14.55,1 14,1 L14,1 Z M14,10 L7,10 L5,12 L5,10 L2,10 L2,2 L14,2 L14,10 L14,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,1 L2,1 C1.45,1 1,1.45 1,2 L1,10 C1,10.55 1.45,11 2,11 L4,11 L4,14.5 L7.5,11 L14,11 C14.55,11 15,10.55 15,10 L15,2 C15,1.45 14.55,1 14,1 L14,1 Z M14,10 L7,10 L5,12 L5,10 L2,10 L2,2 L14,2 L14,10 L14,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.comment = comment;
var creditCard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "credit-card",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "credit-card",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,9 L2,9 L2,8 L12,8 L12,9 L12,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L1,13 C0.45,13 0,12.55 0,12 L0,3 C0,2.45 0.45,2 1,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M15,6 L1,6 L1,12 L15,12 L15,6 L15,6 Z M15,3 L1,3 L1,4 L15,4 L15,3 L15,3 Z M6,10 L2,10 L2,11 L6,11 L6,10 L6,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,9 L2,9 L2,8 L12,8 L12,9 L12,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L1,13 C0.45,13 0,12.55 0,12 L0,3 C0,2.45 0.45,2 1,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M15,6 L1,6 L1,12 L15,12 L15,6 L15,6 Z M15,3 L1,3 L1,4 L15,4 L15,3 L15,3 Z M6,10 L2,10 L2,11 L6,11 L6,10 L6,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.creditCard = creditCard;
var dash = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "dash",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "dash",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "0 7 0 9 8 9 8 7"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "0 7 0 9 8 9 8 7"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.dash = dash;
var dashboard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "dashboard",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "dashboard",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,5 L8,5 L8,4 L9,4 L9,5 L9,5 Z M13,8 L12,8 L12,9 L13,9 L13,8 L13,8 Z M6,5 L5,5 L5,6 L6,6 L6,5 L6,5 Z M5,8 L4,8 L4,9 L5,9 L5,8 L5,8 Z M16,2.5 L15.5,2 L9,7 C8.94,6.98 8,7 8,7 C7.45,7 7,7.45 7,8 L7,9 C7,9.55 7.45,10 8,10 L9,10 C9.55,10 10,9.55 10,9 L10,8.08 L16,2.5 L16,2.5 Z M14.41,6.59 C14.6,7.2 14.71,7.84 14.71,8.5 C14.71,11.92 11.93,14.7 8.51,14.7 C5.09,14.7 2.3,11.92 2.3,8.5 C2.3,5.08 5.08,2.3 8.5,2.3 C9.7,2.3 10.81,2.64 11.77,3.24 L12.71,2.3 C11.52,1.49 10.07,1 8.51,1 C4.36,1 1,4.36 1,8.5 C1,12.64 4.36,16 8.5,16 C12.64,16 16,12.64 16,8.5 C16,7.47 15.8,6.48 15.41,5.59 L14.41,6.59 L14.41,6.59 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,5 L8,5 L8,4 L9,4 L9,5 L9,5 Z M13,8 L12,8 L12,9 L13,9 L13,8 L13,8 Z M6,5 L5,5 L5,6 L6,6 L6,5 L6,5 Z M5,8 L4,8 L4,9 L5,9 L5,8 L5,8 Z M16,2.5 L15.5,2 L9,7 C8.94,6.98 8,7 8,7 C7.45,7 7,7.45 7,8 L7,9 C7,9.55 7.45,10 8,10 L9,10 C9.55,10 10,9.55 10,9 L10,8.08 L16,2.5 L16,2.5 Z M14.41,6.59 C14.6,7.2 14.71,7.84 14.71,8.5 C14.71,11.92 11.93,14.7 8.51,14.7 C5.09,14.7 2.3,11.92 2.3,8.5 C2.3,5.08 5.08,2.3 8.5,2.3 C9.7,2.3 10.81,2.64 11.77,3.24 L12.71,2.3 C11.52,1.49 10.07,1 8.51,1 C4.36,1 1,4.36 1,8.5 C1,12.64 4.36,16 8.5,16 C12.64,16 16,12.64 16,8.5 C16,7.47 15.8,6.48 15.41,5.59 L14.41,6.59 L14.41,6.59 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.dashboard = dashboard;
var database = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "database",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "database",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,15 C2.69,15 0,14.1 0,13 L0,11 C0,10.83 0.09,10.66 0.21,10.5 C0.88,11.36 3.21,12 6,12 C8.79,12 11.12,11.36 11.79,10.5 C11.92,10.66 12,10.83 12,11 L12,13 C12,14.1 9.31,15 6,15 L6,15 Z M6,11 C2.69,11 0,10.1 0,9 L0,7 C0,6.89 0.04,6.79 0.09,6.69 L0.09,6.69 C0.12,6.63 0.16,6.56 0.21,6.5 C0.88,7.36 3.21,8 6,8 C8.79,8 11.12,7.36 11.79,6.5 C11.84,6.56 11.88,6.63 11.91,6.69 L11.91,6.69 C11.96,6.79 12,6.9 12,7 L12,9 C12,10.1 9.31,11 6,11 L6,11 Z M6,7 C2.69,7 0,6.1 0,5 L0,4 L0,3 C0,1.9 2.69,1 6,1 C9.31,1 12,1.9 12,3 L12,4 L12,5 C12,6.1 9.31,7 6,7 L6,7 Z M6,2 C3.79,2 2,2.45 2,3 C2,3.55 3.79,4 6,4 C8.21,4 10,3.55 10,3 C10,2.45 8.21,2 6,2 L6,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,15 C2.69,15 0,14.1 0,13 L0,11 C0,10.83 0.09,10.66 0.21,10.5 C0.88,11.36 3.21,12 6,12 C8.79,12 11.12,11.36 11.79,10.5 C11.92,10.66 12,10.83 12,11 L12,13 C12,14.1 9.31,15 6,15 L6,15 Z M6,11 C2.69,11 0,10.1 0,9 L0,7 C0,6.89 0.04,6.79 0.09,6.69 L0.09,6.69 C0.12,6.63 0.16,6.56 0.21,6.5 C0.88,7.36 3.21,8 6,8 C8.79,8 11.12,7.36 11.79,6.5 C11.84,6.56 11.88,6.63 11.91,6.69 L11.91,6.69 C11.96,6.79 12,6.9 12,7 L12,9 C12,10.1 9.31,11 6,11 L6,11 Z M6,7 C2.69,7 0,6.1 0,5 L0,4 L0,3 C0,1.9 2.69,1 6,1 C9.31,1 12,1.9 12,3 L12,4 L12,5 C12,6.1 9.31,7 6,7 L6,7 Z M6,2 C3.79,2 2,2.45 2,3 C2,3.55 3.79,4 6,4 C8.21,4 10,3.55 10,3 C10,2.45 8.21,2 6,2 L6,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.database = database;
var desktopDownload = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "desktop-download",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "desktop-download",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,6 L7,6 L7,0 L9,0 L9,6 L12,6 L8,10 L4,6 L4,6 Z M15,2 L11,2 L11,3 L15,3 L15,11 L1,11 L1,3 L5,3 L5,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L6.34,13 C6.09,13.61 5.48,14.39 4,15 L12,15 C10.52,14.39 9.91,13.61 9.66,13 L15,13 C15.55,13 16,12.55 16,12 L16,3 C16,2.45 15.55,2 15,2 L15,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,6 L7,6 L7,0 L9,0 L9,6 L12,6 L8,10 L4,6 L4,6 Z M15,2 L11,2 L11,3 L15,3 L15,11 L1,11 L1,3 L5,3 L5,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L6.34,13 C6.09,13.61 5.48,14.39 4,15 L12,15 C10.52,14.39 9.91,13.61 9.66,13 L15,13 C15.55,13 16,12.55 16,12 L16,3 C16,2.45 15.55,2 15,2 L15,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.desktopDownload = desktopDownload;
var deviceCameraVideo = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "device-camera-video",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "device-camera-video",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.2,2.09 L10,5.72 L10,3 C10,2.45 9.55,2 9,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L9,13 C9.55,13 10,12.55 10,12 L10,9.28 L15.2,12.91 C15.53,13.14 16,12.91 16,12.5 L16,2.5 C16,2.09 15.53,1.86 15.2,2.09 L15.2,2.09 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.2,2.09 L10,5.72 L10,3 C10,2.45 9.55,2 9,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L9,13 C9.55,13 10,12.55 10,12 L10,9.28 L15.2,12.91 C15.53,13.14 16,12.91 16,12.5 L16,2.5 C16,2.09 15.53,1.86 15.2,2.09 L15.2,2.09 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.deviceCameraVideo = deviceCameraVideo;
var deviceCamera = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "device-camera",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "device-camera",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15,3 L7,3 C7,2.45 6.55,2 6,2 L2,2 C1.45,2 1,2.45 1,3 C0.45,3 0,3.45 0,4 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 L16,4 C16,3.45 15.55,3 15,3 L15,3 Z M6,5 L2,5 L2,4 L6,4 L6,5 L6,5 Z M10.5,12 C8.56,12 7,10.44 7,8.5 C7,6.56 8.56,5 10.5,5 C12.44,5 14,6.56 14,8.5 C14,10.44 12.44,12 10.5,12 L10.5,12 Z M13,8.5 C13,9.88 11.87,11 10.5,11 C9.13,11 8,9.87 8,8.5 C8,7.13 9.13,6 10.5,6 C11.87,6 13,7.13 13,8.5 L13,8.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15,3 L7,3 C7,2.45 6.55,2 6,2 L2,2 C1.45,2 1,2.45 1,3 C0.45,3 0,3.45 0,4 L0,13 C0,13.55 0.45,14 1,14 L15,14 C15.55,14 16,13.55 16,13 L16,4 C16,3.45 15.55,3 15,3 L15,3 Z M6,5 L2,5 L2,4 L6,4 L6,5 L6,5 Z M10.5,12 C8.56,12 7,10.44 7,8.5 C7,6.56 8.56,5 10.5,5 C12.44,5 14,6.56 14,8.5 C14,10.44 12.44,12 10.5,12 L10.5,12 Z M13,8.5 C13,9.88 11.87,11 10.5,11 C9.13,11 8,9.87 8,8.5 C8,7.13 9.13,6 10.5,6 C11.87,6 13,7.13 13,8.5 L13,8.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.deviceCamera = deviceCamera;
var deviceDesktop = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "device-desktop",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "device-desktop",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L6.34,13 C6.09,13.61 5.48,14.39 4,15 L12,15 C10.52,14.39 9.91,13.61 9.66,13 L15,13 C15.55,13 16,12.55 16,12 L16,3 C16,2.45 15.55,2 15,2 L15,2 Z M15,11 L1,11 L1,3 L15,3 L15,11 L15,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15,2 L1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L6.34,13 C6.09,13.61 5.48,14.39 4,15 L12,15 C10.52,14.39 9.91,13.61 9.66,13 L15,13 C15.55,13 16,12.55 16,12 L16,3 C16,2.45 15.55,2 15,2 L15,2 Z M15,11 L1,11 L1,3 L15,3 L15,11 L15,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.deviceDesktop = deviceDesktop;
var deviceMobile = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "device-mobile",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "device-mobile",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M9,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L9,16 C9.55,16 10,15.55 10,15 L10,1 C10,0.45 9.55,0 9,0 L9,0 Z M5,15.3 C4.28,15.3 3.7,14.72 3.7,14 C3.7,13.28 4.28,12.7 5,12.7 C5.72,12.7 6.3,13.28 6.3,14 C6.3,14.72 5.72,15.3 5,15.3 L5,15.3 Z M9,12 L1,12 L1,2 L9,2 L9,12 L9,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M9,0 L1,0 C0.45,0 0,0.45 0,1 L0,15 C0,15.55 0.45,16 1,16 L9,16 C9.55,16 10,15.55 10,15 L10,1 C10,0.45 9.55,0 9,0 L9,0 Z M5,15.3 C4.28,15.3 3.7,14.72 3.7,14 C3.7,13.28 4.28,12.7 5,12.7 C5.72,12.7 6.3,13.28 6.3,14 C6.3,14.72 5.72,15.3 5,15.3 L5,15.3 Z M9,12 L1,12 L1,2 L9,2 L9,12 L9,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.deviceMobile = deviceMobile;
var diffAdded = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff-added",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff-added",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M6,9 L3,9 L3,7 L6,7 L6,4 L8,4 L8,7 L11,7 L11,9 L8,9 L8,12 L6,12 L6,9 L6,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M6,9 L3,9 L3,7 L6,7 L6,4 L8,4 L8,7 L11,7 L11,9 L8,9 L8,12 L6,12 L6,9 L6,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diffAdded = diffAdded;
var diffIgnored = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff-ignored",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff-ignored",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M4.5,12 L3,12 L3,10.5 L9.5,4 L11,4 L11,5.5 L4.5,12 L4.5,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M4.5,12 L3,12 L3,10.5 L9.5,4 L11,4 L11,5.5 L4.5,12 L4.5,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diffIgnored = diffIgnored;
var diffModified = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff-modified",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff-modified",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M4,8 C4,6.34 5.34,5 7,5 C8.66,5 10,6.34 10,8 C10,9.66 8.66,11 7,11 C5.34,11 4,9.66 4,8 L4,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M4,8 C4,6.34 5.34,5 7,5 C8.66,5 10,6.34 10,8 C10,9.66 8.66,11 7,11 C5.34,11 4,9.66 4,8 L4,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diffModified = diffModified;
var diffRemoved = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff-removed",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff-removed",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M11,9 L3,9 L3,7 L11,7 L11,9 L11,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,2 C14,1.45 13.55,1 13,1 L13,1 Z M13,14 L1,14 L1,2 L13,2 L13,14 L13,14 Z M11,9 L3,9 L3,7 L11,7 L11,9 L11,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diffRemoved = diffRemoved;
var diffRenamed = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff-renamed",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff-renamed",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,9 L3,9 L3,7 L6,7 L6,4 L11,8 L6,12 L6,9 L6,9 Z M14,2 L14,14 C14,14.55 13.55,15 13,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L13,1 C13.55,1 14,1.45 14,2 L14,2 Z M13,2 L1,2 L1,14 L13,14 L13,2 L13,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,9 L3,9 L3,7 L6,7 L6,4 L11,8 L6,12 L6,9 L6,9 Z M14,2 L14,14 C14,14.55 13.55,15 13,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L13,1 C13.55,1 14,1.45 14,2 L14,2 Z M13,2 L1,2 L1,14 L13,14 L13,2 L13,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diffRenamed = diffRenamed;
var diff = {
  "viewBox": "0 0 13 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "diff",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "diff",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,7 L8,7 L8,8 L6,8 L6,10 L5,10 L5,8 L3,8 L3,7 L5,7 L5,5 L6,5 L6,7 L6,7 Z M3,13 L8,13 L8,12 L3,12 L3,13 L3,13 Z M7.5,2 L11,5.5 L11,15 C11,15.55 10.55,16 10,16 L1,16 C0.45,16 0,15.55 0,15 L0,3 C0,2.45 0.45,2 1,2 L7.5,2 L7.5,2 Z M10,6 L7,3 L1,3 L1,15 L10,15 L10,6 L10,6 Z M8.5,0 L3,0 L3,1 L8,1 L12,5 L12,13 L13,13 L13,4.5 L8.5,0 L8.5,0 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,7 L8,7 L8,8 L6,8 L6,10 L5,10 L5,8 L3,8 L3,7 L5,7 L5,5 L6,5 L6,7 L6,7 Z M3,13 L8,13 L8,12 L3,12 L3,13 L3,13 Z M7.5,2 L11,5.5 L11,15 C11,15.55 10.55,16 10,16 L1,16 C0.45,16 0,15.55 0,15 L0,3 C0,2.45 0.45,2 1,2 L7.5,2 L7.5,2 Z M10,6 L7,3 L1,3 L1,15 L10,15 L10,6 L10,6 Z M8.5,0 L3,0 L3,1 L8,1 L12,5 L12,13 L13,13 L13,4.5 L8.5,0 L8.5,0 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.diff = diff;
var ellipses = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "ellipses",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "ellipses",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,5 L1,5 C0.45,5 0,5.45 0,6 L0,10 C0,10.55 0.45,11 1,11 L11,11 C11.55,11 12,10.55 12,10 L12,6 C12,5.45 11.55,5 11,5 L11,5 Z M4,9 L2,9 L2,7 L4,7 L4,9 L4,9 Z M7,9 L5,9 L5,7 L7,7 L7,9 L7,9 Z M10,9 L8,9 L8,7 L10,7 L10,9 L10,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,5 L1,5 C0.45,5 0,5.45 0,6 L0,10 C0,10.55 0.45,11 1,11 L11,11 C11.55,11 12,10.55 12,10 L12,6 C12,5.45 11.55,5 11,5 L11,5 Z M4,9 L2,9 L2,7 L4,7 L4,9 L4,9 Z M7,9 L5,9 L5,7 L7,7 L7,9 L7,9 Z M10,9 L8,9 L8,7 L10,7 L10,9 L10,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.ellipses = ellipses;
var ellipsis = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 5H1c-0.55 0-1 0.45-1 1v4c0 0.55 0.45 1 1 1h10c0.55 0 1-0.45 1-1V6c0-0.55-0.45-1-1-1zM4 9H2V7h2v2z m3 0H5V7h2v2z m3 0H8V7h2v2z"
    },
    "children": []
  }]
};
exports.ellipsis = ellipsis;
var eye = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "eye",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "eye",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.06,2 C3,2 0,8 0,8 C0,8 3,14 8.06,14 C13,14 16,8 16,8 C16,8 13,2 8.06,2 L8.06,2 Z M8,12 C5.8,12 4,10.22 4,8 C4,5.8 5.8,4 8,4 C10.22,4 12,5.8 12,8 C12,10.22 10.22,12 8,12 L8,12 Z M10,8 C10,9.11 9.11,10 8,10 C6.89,10 6,9.11 6,8 C6,6.89 6.89,6 8,6 C9.11,6 10,6.89 10,8 L10,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.06,2 C3,2 0,8 0,8 C0,8 3,14 8.06,14 C13,14 16,8 16,8 C16,8 13,2 8.06,2 L8.06,2 Z M8,12 C5.8,12 4,10.22 4,8 C4,5.8 5.8,4 8,4 C10.22,4 12,5.8 12,8 C12,10.22 10.22,12 8,12 L8,12 Z M10,8 C10,9.11 9.11,10 8,10 C6.89,10 6,9.11 6,8 C6,6.89 6.89,6 8,6 C9.11,6 10,6.89 10,8 L10,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.eye = eye;
var fileBinary = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-binary",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-binary",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,12 L5,12 L5,13 L2,13 L2,12 L3,12 L3,10 L2,10 L2,9 L4,9 L4,12 L4,12 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,14 L11,14 L11,5 L11,5 Z M8,4 L6,4 L6,5 L7,5 L7,7 L6,7 L6,8 L9,8 L9,7 L8,7 L8,4 L8,4 Z M2,4 L5,4 L5,8 L2,8 L2,4 L2,4 Z M3,7 L4,7 L4,5 L3,5 L3,7 L3,7 Z M6,9 L9,9 L9,13 L6,13 L6,9 L6,9 Z M7,12 L8,12 L8,10 L7,10 L7,12 L7,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,12 L5,12 L5,13 L2,13 L2,12 L3,12 L3,10 L2,10 L2,9 L4,9 L4,12 L4,12 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,14 L11,14 L11,5 L11,5 Z M8,4 L6,4 L6,5 L7,5 L7,7 L6,7 L6,8 L9,8 L9,7 L8,7 L8,4 L8,4 Z M2,4 L5,4 L5,8 L2,8 L2,4 L2,4 Z M3,7 L4,7 L4,5 L3,5 L3,7 L3,7 Z M6,9 L9,9 L9,13 L6,13 L6,9 L6,9 Z M7,12 L8,12 L8,10 L7,10 L7,12 L7,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileBinary = fileBinary;
var fileCode = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-code",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-code",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.5,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,4.5 L8.5,1 L8.5,1 Z M11,14 L1,14 L1,2 L8,2 L11,5 L11,14 L11,14 Z M5,6.98 L3.5,8.5 L5,10 L4.5,11 L2,8.5 L4.5,6 L5,6.98 L5,6.98 Z M7.5,6 L10,8.5 L7.5,11 L7,10.02 L8.5,8.5 L7,7 L7.5,6 L7.5,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.5,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,4.5 L8.5,1 L8.5,1 Z M11,14 L1,14 L1,2 L8,2 L11,5 L11,14 L11,14 Z M5,6.98 L3.5,8.5 L5,10 L4.5,11 L2,8.5 L4.5,6 L5,6.98 L5,6.98 Z M7.5,6 L10,8.5 L7.5,11 L7,10.02 L8.5,8.5 L7,7 L7.5,6 L7.5,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileCode = fileCode;
var fileDirectory = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-directory",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-directory",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M6,4 L1,4 L1,3 L6,3 L6,4 L6,4 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M6,4 L1,4 L1,3 L6,3 L6,4 L6,4 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileDirectory = fileDirectory;
var fileMedia = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-media",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-media",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,5 L8,5 L8,7 L6,7 L6,5 L6,5 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,13 L4,8 L6,12 L8,10 L11,13 L11,5 L11,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,5 L8,5 L8,7 L6,7 L6,5 L6,5 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,13 L4,8 L6,12 L8,10 L11,13 L11,5 L11,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileMedia = fileMedia;
var filePdf = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-pdf",
        "fill": "#010101"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-pdf",
          "fill": "#010101"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.5,1 L1,1 C0.44771525,1 0,1.44771525 0,2 L0,14 C0,14.5522847 0.44771525,15 1,15 L11,15 C11.5522847,15 12,14.5522847 12,14 L12,4.5 L8.5,1 Z M1,2 L5,2 C4.88021121,2.03682695 4.77292941,2.10604101 4.69,2.2 C4.57596619,2.33544491 4.49698141,2.4968486 4.46,2.67 C4.34406753,3.15093672 4.3136037,3.64851254 4.37,4.14 C4.42970074,4.74889969 4.54348307,5.35127671 4.71,5.94 C4.39913981,6.85020329 4.02832805,7.73881526 3.6,8.6 C3.1,9.6 2.8,10.26 2.69,10.44 C2.45490116,10.527838 2.22458325,10.6279762 2,10.74 C1.63797844,10.9047863 1.30126564,11.1202825 1,11.38 L1,2 L1,2 Z M5.42,6.8 C5.65615226,7.57227694 6.05511596,8.28495569 6.59,8.89 C6.8651023,9.12723152 7.18463148,9.30739159 7.53,9.42 C6.89,9.51 6.3,9.62 5.72,9.75 C5.10224214,9.89929979 4.49707287,10.0965649 3.91,10.34 C3.32292713,10.5834351 4.13,9.9 4.52,9.09 C4.8853939,8.349364 5.18973729,7.58014443 5.43,6.79 L5.43,6.79 L5.42,6.8 Z M11,14 L1.5,14 C1.44352149,14.0065306 1.38647851,14.0065306 1.33,14 C1.60061185,13.9042665 1.84896383,13.7545749 2.06,13.56 C2.76700578,12.8583965 3.36677981,12.0564515 3.84,11.18 C4.15,11.05 4.42,10.95 4.65,10.87 L5.07,10.73 C5.52,10.6 6.01,10.5 6.51,10.4 C7.01,10.3 7.51,10.24 7.99,10.2 C8.43725403,10.4162545 8.9023067,10.5935768 9.38,10.73 C9.78288787,10.8407498 10.1943157,10.9176835 10.61,10.96 L10.99,10.96 L10.99,14 L10.99,14 L11,14 Z M11,9.14 C10.7958695,9.02690387 10.5816018,8.93316173 10.36,8.86 C10.113806,8.8009088 9.86279363,8.76409365 9.61,8.75 C9.19880419,8.75303183 8.78812424,8.77974272 8.38,8.83 C8.0073597,8.68541471 7.66736947,8.46782096 7.38,8.19 C6.78281632,7.51840635 6.34221217,6.72258646 6.09,5.86 C6.20098287,5.19851127 6.26779732,4.53036675 6.29,3.86 C6.30923951,3.61037016 6.30923951,3.35962984 6.29,3.11 C6.35921678,2.80151577 6.28575056,2.47826438 6.09,2.23 C5.92718989,2.07232702 5.70638123,1.9890713 5.48,2 L8,2 L11,5 L11,9.13 L11,9.13 L11,9.14 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.5,1 L1,1 C0.44771525,1 0,1.44771525 0,2 L0,14 C0,14.5522847 0.44771525,15 1,15 L11,15 C11.5522847,15 12,14.5522847 12,14 L12,4.5 L8.5,1 Z M1,2 L5,2 C4.88021121,2.03682695 4.77292941,2.10604101 4.69,2.2 C4.57596619,2.33544491 4.49698141,2.4968486 4.46,2.67 C4.34406753,3.15093672 4.3136037,3.64851254 4.37,4.14 C4.42970074,4.74889969 4.54348307,5.35127671 4.71,5.94 C4.39913981,6.85020329 4.02832805,7.73881526 3.6,8.6 C3.1,9.6 2.8,10.26 2.69,10.44 C2.45490116,10.527838 2.22458325,10.6279762 2,10.74 C1.63797844,10.9047863 1.30126564,11.1202825 1,11.38 L1,2 L1,2 Z M5.42,6.8 C5.65615226,7.57227694 6.05511596,8.28495569 6.59,8.89 C6.8651023,9.12723152 7.18463148,9.30739159 7.53,9.42 C6.89,9.51 6.3,9.62 5.72,9.75 C5.10224214,9.89929979 4.49707287,10.0965649 3.91,10.34 C3.32292713,10.5834351 4.13,9.9 4.52,9.09 C4.8853939,8.349364 5.18973729,7.58014443 5.43,6.79 L5.43,6.79 L5.42,6.8 Z M11,14 L1.5,14 C1.44352149,14.0065306 1.38647851,14.0065306 1.33,14 C1.60061185,13.9042665 1.84896383,13.7545749 2.06,13.56 C2.76700578,12.8583965 3.36677981,12.0564515 3.84,11.18 C4.15,11.05 4.42,10.95 4.65,10.87 L5.07,10.73 C5.52,10.6 6.01,10.5 6.51,10.4 C7.01,10.3 7.51,10.24 7.99,10.2 C8.43725403,10.4162545 8.9023067,10.5935768 9.38,10.73 C9.78288787,10.8407498 10.1943157,10.9176835 10.61,10.96 L10.99,10.96 L10.99,14 L10.99,14 L11,14 Z M11,9.14 C10.7958695,9.02690387 10.5816018,8.93316173 10.36,8.86 C10.113806,8.8009088 9.86279363,8.76409365 9.61,8.75 C9.19880419,8.75303183 8.78812424,8.77974272 8.38,8.83 C8.0073597,8.68541471 7.66736947,8.46782096 7.38,8.19 C6.78281632,7.51840635 6.34221217,6.72258646 6.09,5.86 C6.20098287,5.19851127 6.26779732,4.53036675 6.29,3.86 C6.30923951,3.61037016 6.30923951,3.35962984 6.29,3.11 C6.35921678,2.80151577 6.28575056,2.47826438 6.09,2.23 C5.92718989,2.07232702 5.70638123,1.9890713 5.48,2 L8,2 L11,5 L11,9.13 L11,9.13 L11,9.14 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.filePdf = filePdf;
var fileSubmodule = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-submodule",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-submodule",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,7 L4,7 L4,14 L13,14 C13.55,14 14,13.55 14,13 L14,8 L10,8 L10,7 L10,7 Z M9,9 L5,9 L5,8 L9,8 L9,9 L9,9 Z M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L3,14 L3,7 C3,6.45 3.45,6 4,6 L10,6 C10.55,6 11,6.45 11,7 L14,7 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M6,4 L1,4 L1,3 L6,3 L6,4 L6,4 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,7 L4,7 L4,14 L13,14 C13.55,14 14,13.55 14,13 L14,8 L10,8 L10,7 L10,7 Z M9,9 L5,9 L5,8 L9,8 L9,9 L9,9 Z M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L3,14 L3,7 C3,6.45 3.45,6 4,6 L10,6 C10.55,6 11,6.45 11,7 L14,7 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M6,4 L1,4 L1,3 L6,3 L6,4 L6,4 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileSubmodule = fileSubmodule;
var fileSymlinkDirectory = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-symlink-directory",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-symlink-directory",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M1,3 L6,3 L6,4 L1,4 L1,3 L1,3 Z M7,12 L7,10 C6.02,9.98 5.16,10.22 4.45,10.7 C3.74,11.18 3.26,11.95 3,13 C3.02,11.36 3.39,10.12 4.13,9.27 C4.86,8.43 5.82,8 7.01,8 L7.01,6 L11.01,9 L7.01,12 L7,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,4 L7,4 L7,3 C7,2.34 6.69,2 6,2 L1,2 C0.45,2 0,2.45 0,3 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,5 C14,4.45 13.55,4 13,4 L13,4 Z M1,3 L6,3 L6,4 L1,4 L1,3 L1,3 Z M7,12 L7,10 C6.02,9.98 5.16,10.22 4.45,10.7 C3.74,11.18 3.26,11.95 3,13 C3.02,11.36 3.39,10.12 4.13,9.27 C4.86,8.43 5.82,8 7.01,8 L7.01,6 L11.01,9 L7.01,12 L7,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileSymlinkDirectory = fileSymlinkDirectory;
var fileSymlinkFile = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-symlink-file",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-symlink-file",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.5,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,4.5 L8.5,1 L8.5,1 Z M11,14 L1,14 L1,2 L8,2 L11,5 L11,14 L11,14 Z M6,4.5 L10,7.5 L6,10.5 L6,8.5 C5.02,8.48 4.16,8.72 3.45,9.2 C2.74,9.68 2.26,10.45 2,11.5 C2.02,9.86 2.39,8.62 3.13,7.77 C3.86,6.93 4.82,6.5 6.01,6.5 L6.01,4.5 L6,4.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.5,1 L1,1 C0.45,1 0,1.45 0,2 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,4.5 L8.5,1 L8.5,1 Z M11,14 L1,14 L1,2 L8,2 L11,5 L11,14 L11,14 Z M6,4.5 L10,7.5 L6,10.5 L6,8.5 C5.02,8.48 4.16,8.72 3.45,9.2 C2.74,9.68 2.26,10.45 2,11.5 C2.02,9.86 2.39,8.62 3.13,7.77 C3.86,6.93 4.82,6.5 6.01,6.5 L6.01,4.5 L6,4.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileSymlinkFile = fileSymlinkFile;
var fileText = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 5H2v-1h4v1zM2 8h7v-1H2v1z m0 2h7v-1H2v1z m0 2h7v-1H2v1z m10-7.5v9.5c0 0.55-0.45 1-1 1H1c-0.55 0-1-0.45-1-1V2c0-0.55 0.45-1 1-1h7.5l3.5 3.5z m-1 0.5L8 2H1v12h10V5z"
    },
    "children": []
  }]
};
exports.fileText = fileText;
var fileZip = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file-zip",
        "fill": "#010101"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file-zip",
          "fill": "#010101"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8.5,1 L1,1 C0.44771525,1 0,1.44771525 0,2 L0,14 C0,14.5522847 0.44771525,15 1,15 L11,15 C11.5522847,15 12,14.5522847 12,14 L12,4.5 L8.5,1 Z M11,14 L1,14 L1,2 L4,2 L4,3 L5,3 L5,2 L8,2 L11,5 L11,14 L11,14 Z M5,4 L5,3 L6,3 L6,4 L5,4 L5,4 Z M4,4 L5,4 L5,5 L4,5 L4,4 L4,4 Z M5,6 L5,5 L6,5 L6,6 L5,6 L5,6 Z M4,6 L5,6 L5,7 L4,7 L4,6 L4,6 Z M5,8 L5,7 L6,7 L6,8 L5,8 L5,8 Z M4,9.28 C3.38491093,9.63510459 3.00428692,10.2897779 3,11 L3,12 L7,12 L7,11 C7,9.8954305 6.1045695,9 5,9 L5,8 L4,8 L4,9.28 L4,9.28 Z M6,10 L6,11 L4,11 L4,10 L6,10 L6,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8.5,1 L1,1 C0.44771525,1 0,1.44771525 0,2 L0,14 C0,14.5522847 0.44771525,15 1,15 L11,15 C11.5522847,15 12,14.5522847 12,14 L12,4.5 L8.5,1 Z M11,14 L1,14 L1,2 L4,2 L4,3 L5,3 L5,2 L8,2 L11,5 L11,14 L11,14 Z M5,4 L5,3 L6,3 L6,4 L5,4 L5,4 Z M4,4 L5,4 L5,5 L4,5 L4,4 L4,4 Z M5,6 L5,5 L6,5 L6,6 L5,6 L5,6 Z M4,6 L5,6 L5,7 L4,7 L4,6 L4,6 Z M5,8 L5,7 L6,7 L6,8 L5,8 L5,8 Z M4,9.28 C3.38491093,9.63510459 3.00428692,10.2897779 3,11 L3,12 L7,12 L7,11 C7,9.8954305 6.1045695,9 5,9 L5,8 L4,8 L4,9.28 L4,9.28 Z M6,10 L6,11 L4,11 L4,10 L6,10 L6,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fileZip = fileZip;
var file = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "file",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "file",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,5 L2,5 L2,4 L6,4 L6,5 L6,5 Z M2,8 L9,8 L9,7 L2,7 L2,8 L2,8 Z M2,10 L9,10 L9,9 L2,9 L2,10 L2,10 Z M2,12 L9,12 L9,11 L2,11 L2,12 L2,12 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,14 L11,14 L11,5 L11,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,5 L2,5 L2,4 L6,4 L6,5 L6,5 Z M2,8 L9,8 L9,7 L2,7 L2,8 L2,8 Z M2,10 L9,10 L9,9 L2,9 L2,10 L2,10 Z M2,12 L9,12 L9,11 L2,11 L2,12 L2,12 Z M12,4.5 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,2 C0,1.45 0.45,1 1,1 L8.5,1 L12,4.5 L12,4.5 Z M11,5 L8,2 L1,2 L1,14 L11,14 L11,5 L11,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.file = file;
var flame = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "flame",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "flame",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M5.05,0.31 C5.86,2.48 5.46,3.69 4.53,4.62 C3.55,5.67 1.98,6.45 0.9,7.98 C-0.55,10.03 -0.8,14.51 4.43,15.68 C2.23,14.52 1.76,11.16 4.13,9.07 C3.52,11.1 4.66,12.4 6.07,11.93 C7.46,11.46 8.37,12.46 8.34,13.6 C8.32,14.38 8.03,15.04 7.21,15.41 C10.63,14.82 11.99,11.99 11.99,9.85 C11.99,7.01 9.46,6.63 10.74,4.24 C9.22,4.37 8.71,5.37 8.85,6.99 C8.94,8.07 7.83,8.79 6.99,8.32 C6.32,7.91 6.33,7.13 6.93,6.54 C8.18,5.31 8.68,2.45 5.05,0.32 L5.03,0.3 L5.05,0.31 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M5.05,0.31 C5.86,2.48 5.46,3.69 4.53,4.62 C3.55,5.67 1.98,6.45 0.9,7.98 C-0.55,10.03 -0.8,14.51 4.43,15.68 C2.23,14.52 1.76,11.16 4.13,9.07 C3.52,11.1 4.66,12.4 6.07,11.93 C7.46,11.46 8.37,12.46 8.34,13.6 C8.32,14.38 8.03,15.04 7.21,15.41 C10.63,14.82 11.99,11.99 11.99,9.85 C11.99,7.01 9.46,6.63 10.74,4.24 C9.22,4.37 8.71,5.37 8.85,6.99 C8.94,8.07 7.83,8.79 6.99,8.32 C6.32,7.91 6.33,7.13 6.93,6.54 C8.18,5.31 8.68,2.45 5.05,0.32 L5.03,0.3 L5.05,0.31 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.flame = flame;
var fold = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "fold",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "fold",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,9 L10,12 L8,12 L8,15 L6,15 L6,12 L4,12 L7,9 L7,9 Z M10,3 L8,3 L8,0 L6,0 L6,3 L4,3 L7,6 L10,3 L10,3 Z M14,5 C14,4.45 13.55,4 13,4 L10.5,4 L9.5,5 L12.5,5 L10.5,7 L3.5,7 L1.5,5 L4.5,5 L3.5,4 L1,4 C0.45,4 0,4.45 0,5 L2.5,7.5 L0,10 C0,10.55 0.45,11 1,11 L3.5,11 L4.5,10 L1.5,10 L3.5,8 L10.5,8 L12.5,10 L9.5,10 L10.5,11 L13,11 C13.55,11 14,10.55 14,10 L11.5,7.5 L14,5 L14,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,9 L10,12 L8,12 L8,15 L6,15 L6,12 L4,12 L7,9 L7,9 Z M10,3 L8,3 L8,0 L6,0 L6,3 L4,3 L7,6 L10,3 L10,3 Z M14,5 C14,4.45 13.55,4 13,4 L10.5,4 L9.5,5 L12.5,5 L10.5,7 L3.5,7 L1.5,5 L4.5,5 L3.5,4 L1,4 C0.45,4 0,4.45 0,5 L2.5,7.5 L0,10 C0,10.55 0.45,11 1,11 L3.5,11 L4.5,10 L1.5,10 L3.5,8 L10.5,8 L12.5,10 L9.5,10 L10.5,11 L13,11 C13.55,11 14,10.55 14,10 L11.5,7.5 L14,5 L14,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.fold = fold;
var gear = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "gear",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "gear",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,8.77 L14,7.17 L12.06,6.53 L11.61,5.44 L12.49,3.6 L11.36,2.47 L9.55,3.38 L8.46,2.93 L7.77,1.01 L6.17,1.01 L5.54,2.95 L4.43,3.4 L2.59,2.52 L1.46,3.65 L2.37,5.46 L1.92,6.55 L0,7.23 L0,8.82 L1.94,9.46 L2.39,10.55 L1.51,12.39 L2.64,13.52 L4.45,12.61 L5.54,13.06 L6.23,14.98 L7.82,14.98 L8.45,13.04 L9.56,12.59 L11.4,13.47 L12.53,12.34 L11.61,10.53 L12.08,9.44 L14,8.75 L14,8.77 Z M7,11 C5.34,11 4,9.66 4,8 C4,6.34 5.34,5 7,5 C8.66,5 10,6.34 10,8 C10,9.66 8.66,11 7,11 L7,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,8.77 L14,7.17 L12.06,6.53 L11.61,5.44 L12.49,3.6 L11.36,2.47 L9.55,3.38 L8.46,2.93 L7.77,1.01 L6.17,1.01 L5.54,2.95 L4.43,3.4 L2.59,2.52 L1.46,3.65 L2.37,5.46 L1.92,6.55 L0,7.23 L0,8.82 L1.94,9.46 L2.39,10.55 L1.51,12.39 L2.64,13.52 L4.45,12.61 L5.54,13.06 L6.23,14.98 L7.82,14.98 L8.45,13.04 L9.56,12.59 L11.4,13.47 L12.53,12.34 L11.61,10.53 L12.08,9.44 L14,8.75 L14,8.77 Z M7,11 C5.34,11 4,9.66 4,8 C4,6.34 5.34,5 7,5 C8.66,5 10,6.34 10,8 C10,9.66 8.66,11 7,11 L7,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gear = gear;
var gift = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "gift",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "gift",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,4 L11.62,4 C11.81,3.67 11.95,3.33 11.98,3.09 C12.04,2.42 11.87,1.87 11.46,1.48 C11.1,1.1 10.65,1 10.1,1 L9.99,1 C9.46,1.02 8.88,1.25 8.46,1.58 C8.04,1.91 7.73,2.3 7.49,2.78 C7.26,2.3 6.94,1.9 6.52,1.58 C6.1,1.26 5.52,1 4.99,1 L4.96,1 C4.4,1 3.9,1.09 3.52,1.48 C3.11,1.87 2.94,2.42 3,3.09 C3.03,3.32 3.17,3.67 3.36,4 L1.98,4 C1.43,4 0.98,4.45 0.98,5 L0.98,8 L1.98,8 L1.98,13 C1.98,13.55 2.43,14 2.98,14 L11.98,14 C12.53,14 12.98,13.55 12.98,13 L12.98,8 L13.98,8 L13.98,5 C13.98,4.45 13.53,4 12.98,4 L13,4 Z M8.22,3.12 C8.39,2.76 8.64,2.45 8.97,2.2 C9.27,1.97 9.69,1.81 10.02,1.79 L10.11,1.79 C10.56,1.79 10.77,1.9 10.91,2.04 C11.05,2.18 11.24,2.43 11.21,2.99 C11.16,3.18 10.96,3.6 10.71,3.99 L7.81,3.99 L8.22,3.11 L8.22,3.12 Z M4.09,2.04 C4.22,1.91 4.4,1.79 5,1.79 C5.31,1.79 5.72,1.96 6.03,2.2 C6.36,2.45 6.61,2.75 6.78,3.12 L7.2,4 L4.3,4 C4.05,3.61 3.85,3.19 3.8,3 C3.77,2.44 3.96,2.19 4.1,2.05 L4.09,2.04 Z M7,12.99 L3,12.99 L3,8 L7,8 L7,13 L7,12.99 Z M7,6.99 L2,6.99 L2,5 L7,5 L7,7 L7,6.99 Z M12,12.99 L8,12.99 L8,8 L12,8 L12,13 L12,12.99 Z M13,6.99 L8,6.99 L8,5 L13,5 L13,7 L13,6.99 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,4 L11.62,4 C11.81,3.67 11.95,3.33 11.98,3.09 C12.04,2.42 11.87,1.87 11.46,1.48 C11.1,1.1 10.65,1 10.1,1 L9.99,1 C9.46,1.02 8.88,1.25 8.46,1.58 C8.04,1.91 7.73,2.3 7.49,2.78 C7.26,2.3 6.94,1.9 6.52,1.58 C6.1,1.26 5.52,1 4.99,1 L4.96,1 C4.4,1 3.9,1.09 3.52,1.48 C3.11,1.87 2.94,2.42 3,3.09 C3.03,3.32 3.17,3.67 3.36,4 L1.98,4 C1.43,4 0.98,4.45 0.98,5 L0.98,8 L1.98,8 L1.98,13 C1.98,13.55 2.43,14 2.98,14 L11.98,14 C12.53,14 12.98,13.55 12.98,13 L12.98,8 L13.98,8 L13.98,5 C13.98,4.45 13.53,4 12.98,4 L13,4 Z M8.22,3.12 C8.39,2.76 8.64,2.45 8.97,2.2 C9.27,1.97 9.69,1.81 10.02,1.79 L10.11,1.79 C10.56,1.79 10.77,1.9 10.91,2.04 C11.05,2.18 11.24,2.43 11.21,2.99 C11.16,3.18 10.96,3.6 10.71,3.99 L7.81,3.99 L8.22,3.11 L8.22,3.12 Z M4.09,2.04 C4.22,1.91 4.4,1.79 5,1.79 C5.31,1.79 5.72,1.96 6.03,2.2 C6.36,2.45 6.61,2.75 6.78,3.12 L7.2,4 L4.3,4 C4.05,3.61 3.85,3.19 3.8,3 C3.77,2.44 3.96,2.19 4.1,2.05 L4.09,2.04 Z M7,12.99 L3,12.99 L3,8 L7,8 L7,13 L7,12.99 Z M7,6.99 L2,6.99 L2,5 L7,5 L7,7 L7,6.99 Z M12,12.99 L8,12.99 L8,8 L12,8 L12,13 L12,12.99 Z M13,6.99 L8,6.99 L8,5 L13,5 L13,7 L13,6.99 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gift = gift;
var gistSecret = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "gist-secret",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "gist-secret",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,10.5 L9,14 L5,14 L6,10.5 L5.25,9 L8.75,9 L8,10.5 L8,10.5 Z M10,6 L4,6 L2,7 L12,7 L10,6 L10,6 Z M9,2 L7,3 L5,2 L4,5 L10,5 L9,2 L9,2 Z M13.03,9.75 L10,9 L11,11 L9,14 L12.22,14 C12.67,14 13.08,13.69 13.19,13.25 L13.75,10.97 C13.89,10.44 13.56,9.89 13.03,9.75 L13.03,9.75 Z M4,9 L0.97,9.75 C0.44,9.89 0.11,10.44 0.25,10.97 L0.81,13.25 C0.92,13.69 1.33,14 1.78,14 L5,14 L3,11 L4,9 L4,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,10.5 L9,14 L5,14 L6,10.5 L5.25,9 L8.75,9 L8,10.5 L8,10.5 Z M10,6 L4,6 L2,7 L12,7 L10,6 L10,6 Z M9,2 L7,3 L5,2 L4,5 L10,5 L9,2 L9,2 Z M13.03,9.75 L10,9 L11,11 L9,14 L12.22,14 C12.67,14 13.08,13.69 13.19,13.25 L13.75,10.97 C13.89,10.44 13.56,9.89 13.03,9.75 L13.03,9.75 Z M4,9 L0.97,9.75 C0.44,9.89 0.11,10.44 0.25,10.97 L0.81,13.25 C0.92,13.69 1.33,14 1.78,14 L5,14 L3,11 L4,9 L4,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gistSecret = gistSecret;
var gist = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "gist",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "gist",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7.5,5 L10,7.5 L7.5,10 L6.75,9.25 L8.5,7.5 L6.75,5.75 L7.5,5 L7.5,5 Z M4.5,5 L2,7.5 L4.5,10 L5.25,9.25 L3.5,7.5 L5.25,5.75 L4.5,5 L4.5,5 Z M0,13 L0,2 C0,1.45 0.45,1 1,1 L11,1 C11.55,1 12,1.45 12,2 L12,13 C12,13.55 11.55,14 11,14 L1,14 C0.45,14 0,13.55 0,13 L0,13 Z M1,13 L11,13 L11,2 L1,2 L1,13 L1,13 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7.5,5 L10,7.5 L7.5,10 L6.75,9.25 L8.5,7.5 L6.75,5.75 L7.5,5 L7.5,5 Z M4.5,5 L2,7.5 L4.5,10 L5.25,9.25 L3.5,7.5 L5.25,5.75 L4.5,5 L4.5,5 Z M0,13 L0,2 C0,1.45 0.45,1 1,1 L11,1 C11.55,1 12,1.45 12,2 L12,13 C12,13.55 11.55,14 11,14 L1,14 C0.45,14 0,13.55 0,13 L0,13 Z M1,13 L11,13 L11,2 L1,2 L1,13 L1,13 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gist = gist;
var gitBranch = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "git-branch",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "git-branch",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,5 C10,3.89 9.11,3 8,3 C6.89,3 6,3.89 6,5 C6,5.73 6.41,6.38 7,6.72 L7,7.02 C6.98,7.54 6.77,8 6.37,8.4 C5.97,8.8 5.51,9.01 4.99,9.03 C4.16,9.05 3.51,9.19 2.99,9.48 L2.99,4.72 C3.58,4.38 3.99,3.74 3.99,3 C3.99,1.89 3.1,1 1.99,1 C0.88,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.63 0,12.27 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.47 3.8,12 3.47,11.64 C3.56,11.58 3.95,11.23 4.06,11.17 C4.31,11.06 4.62,11 5,11 C6.05,10.95 6.95,10.55 7.75,9.75 C8.55,8.95 8.95,7.77 9,6.73 L8.98,6.73 C9.59,6.37 10,5.73 10,5 L10,5 Z M2,1.8 C2.66,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 C1.35,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 L2,1.8 Z M2,14.21 C1.34,14.21 0.8,13.66 0.8,13.01 C0.8,12.36 1.35,11.81 2,11.81 C2.65,11.81 3.2,12.36 3.2,13.01 C3.2,13.66 2.65,14.21 2,14.21 L2,14.21 Z M8,6.21 C7.34,6.21 6.8,5.66 6.8,5.01 C6.8,4.36 7.35,3.81 8,3.81 C8.65,3.81 9.2,4.36 9.2,5.01 C9.2,5.66 8.65,6.21 8,6.21 L8,6.21 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,5 C10,3.89 9.11,3 8,3 C6.89,3 6,3.89 6,5 C6,5.73 6.41,6.38 7,6.72 L7,7.02 C6.98,7.54 6.77,8 6.37,8.4 C5.97,8.8 5.51,9.01 4.99,9.03 C4.16,9.05 3.51,9.19 2.99,9.48 L2.99,4.72 C3.58,4.38 3.99,3.74 3.99,3 C3.99,1.89 3.1,1 1.99,1 C0.88,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.63 0,12.27 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.47 3.8,12 3.47,11.64 C3.56,11.58 3.95,11.23 4.06,11.17 C4.31,11.06 4.62,11 5,11 C6.05,10.95 6.95,10.55 7.75,9.75 C8.55,8.95 8.95,7.77 9,6.73 L8.98,6.73 C9.59,6.37 10,5.73 10,5 L10,5 Z M2,1.8 C2.66,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 C1.35,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 L2,1.8 Z M2,14.21 C1.34,14.21 0.8,13.66 0.8,13.01 C0.8,12.36 1.35,11.81 2,11.81 C2.65,11.81 3.2,12.36 3.2,13.01 C3.2,13.66 2.65,14.21 2,14.21 L2,14.21 Z M8,6.21 C7.34,6.21 6.8,5.66 6.8,5.01 C6.8,4.36 7.35,3.81 8,3.81 C8.65,3.81 9.2,4.36 9.2,5.01 C9.2,5.66 8.65,6.21 8,6.21 L8,6.21 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gitBranch = gitBranch;
var gitCommit = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "git-commit",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "git-commit",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10.86,7 C10.41,5.28 8.86,4 7,4 C5.14,4 3.59,5.28 3.14,7 L0,7 L0,9 L3.14,9 C3.59,10.72 5.14,12 7,12 C8.86,12 10.41,10.72 10.86,9 L14,9 L14,7 L10.86,7 L10.86,7 Z M7,10.2 C5.78,10.2 4.8,9.22 4.8,8 C4.8,6.78 5.78,5.8 7,5.8 C8.22,5.8 9.2,6.78 9.2,8 C9.2,9.22 8.22,10.2 7,10.2 L7,10.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10.86,7 C10.41,5.28 8.86,4 7,4 C5.14,4 3.59,5.28 3.14,7 L0,7 L0,9 L3.14,9 C3.59,10.72 5.14,12 7,12 C8.86,12 10.41,10.72 10.86,9 L14,9 L14,7 L10.86,7 L10.86,7 Z M7,10.2 C5.78,10.2 4.8,9.22 4.8,8 C4.8,6.78 5.78,5.8 7,5.8 C8.22,5.8 9.2,6.78 9.2,8 C9.2,9.22 8.22,10.2 7,10.2 L7,10.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gitCommit = gitCommit;
var gitCompare = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "git-compare",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "git-compare",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M5,12 L4,12 C3.73,11.98 3.52,11.89 3.31,11.69 C3.1,11.49 3.01,11.27 3,11 L3,4.72 C3.59,4.38 4,3.74 4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11 C1.03,11.78 1.34,12.47 1.94,13.06 C2.54,13.65 3.22,13.97 4,14 L5,14 L5,16 L8,13 L5,10 L5,12 L5,12 Z M2,1.8 C2.66,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 C1.35,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 L2,1.8 Z M13,11.28 L13,5 C12.97,4.22 12.66,3.53 12.06,2.94 C11.46,2.35 10.78,2.03 10,2 L9,2 L9,0 L6,3 L9,6 L9,4 L10,4 C10.27,4.02 10.48,4.11 10.69,4.31 C10.9,4.51 10.99,4.73 11,5 L11,11.28 C10.41,11.62 10,12.26 10,13 C10,14.11 10.89,15 12,15 C13.11,15 14,14.11 14,13 C14,12.27 13.59,11.62 13,11.28 L13,11.28 Z M12,14.2 C11.34,14.2 10.8,13.65 10.8,13 C10.8,12.35 11.35,11.8 12,11.8 C12.65,11.8 13.2,12.35 13.2,13 C13.2,13.65 12.65,14.2 12,14.2 L12,14.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M5,12 L4,12 C3.73,11.98 3.52,11.89 3.31,11.69 C3.1,11.49 3.01,11.27 3,11 L3,4.72 C3.59,4.38 4,3.74 4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11 C1.03,11.78 1.34,12.47 1.94,13.06 C2.54,13.65 3.22,13.97 4,14 L5,14 L5,16 L8,13 L5,10 L5,12 L5,12 Z M2,1.8 C2.66,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 C1.35,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 L2,1.8 Z M13,11.28 L13,5 C12.97,4.22 12.66,3.53 12.06,2.94 C11.46,2.35 10.78,2.03 10,2 L9,2 L9,0 L6,3 L9,6 L9,4 L10,4 C10.27,4.02 10.48,4.11 10.69,4.31 C10.9,4.51 10.99,4.73 11,5 L11,11.28 C10.41,11.62 10,12.26 10,13 C10,14.11 10.89,15 12,15 C13.11,15 14,14.11 14,13 C14,12.27 13.59,11.62 13,11.28 L13,11.28 Z M12,14.2 C11.34,14.2 10.8,13.65 10.8,13 C10.8,12.35 11.35,11.8 12,11.8 C12.65,11.8 13.2,12.35 13.2,13 C13.2,13.65 12.65,14.2 12,14.2 L12,14.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gitCompare = gitCompare;
var gitMerge = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "git-merge",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "git-merge",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,7 C9.27,7 8.62,7.41 8.27,8.02 L8.27,8 C7.22,7.98 6,7.64 5.14,6.98 C4.39,6.4 3.64,5.37 3.25,4.54 C3.7,4.18 4,3.62 4,2.99 C4,1.88 3.11,0.99 2,0.99 C0.89,0.99 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.63 0,12.27 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.27 3.59,11.62 3,11.28 L3,7.67 C3.67,8.37 4.44,8.94 5.3,9.36 C6.16,9.78 7.33,9.99 8.27,10 L8.27,9.98 C8.63,10.59 9.27,11 10,11 C11.11,11 12,10.11 12,9 C12,7.89 11.11,7 10,7 L10,7 Z M3.2,13 C3.2,13.66 2.65,14.2 2,14.2 C1.35,14.2 0.8,13.65 0.8,13 C0.8,12.35 1.35,11.8 2,11.8 C2.65,11.8 3.2,12.35 3.2,13 L3.2,13 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z M10,10.2 C9.34,10.2 8.8,9.65 8.8,9 C8.8,8.35 9.35,7.8 10,7.8 C10.65,7.8 11.2,8.35 11.2,9 C11.2,9.65 10.65,10.2 10,10.2 L10,10.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,7 C9.27,7 8.62,7.41 8.27,8.02 L8.27,8 C7.22,7.98 6,7.64 5.14,6.98 C4.39,6.4 3.64,5.37 3.25,4.54 C3.7,4.18 4,3.62 4,2.99 C4,1.88 3.11,0.99 2,0.99 C0.89,0.99 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.63 0,12.27 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.27 3.59,11.62 3,11.28 L3,7.67 C3.67,8.37 4.44,8.94 5.3,9.36 C6.16,9.78 7.33,9.99 8.27,10 L8.27,9.98 C8.63,10.59 9.27,11 10,11 C11.11,11 12,10.11 12,9 C12,7.89 11.11,7 10,7 L10,7 Z M3.2,13 C3.2,13.66 2.65,14.2 2,14.2 C1.35,14.2 0.8,13.65 0.8,13 C0.8,12.35 1.35,11.8 2,11.8 C2.65,11.8 3.2,12.35 3.2,13 L3.2,13 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z M10,10.2 C9.34,10.2 8.8,9.65 8.8,9 C8.8,8.35 9.35,7.8 10,7.8 C10.65,7.8 11.2,8.35 11.2,9 C11.2,9.65 10.65,10.2 10,10.2 L10,10.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gitMerge = gitMerge;
var gitPullRequest = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "git-pull-request",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "git-pull-request",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,11.28 L11,5 C10.97,4.22 10.66,3.53 10.06,2.94 C9.46,2.35 8.78,2.03 8,2 L7,2 L7,0 L4,3 L7,6 L7,4 L8,4 C8.27,4.02 8.48,4.11 8.69,4.31 C8.9,4.51 8.99,4.73 9,5 L9,11.28 C8.41,11.62 8,12.26 8,13 C8,14.11 8.89,15 10,15 C11.11,15 12,14.11 12,13 C12,12.27 11.59,11.62 11,11.28 L11,11.28 Z M10,14.2 C9.34,14.2 8.8,13.65 8.8,13 C8.8,12.35 9.35,11.8 10,11.8 C10.65,11.8 11.2,12.35 11.2,13 C11.2,13.65 10.65,14.2 10,14.2 L10,14.2 Z M4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.62 0,12.26 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.27 3.59,11.62 3,11.28 L3,4.72 C3.59,4.38 4,3.74 4,3 L4,3 Z M3.2,13 C3.2,13.66 2.65,14.2 2,14.2 C1.35,14.2 0.8,13.65 0.8,13 C0.8,12.35 1.35,11.8 2,11.8 C2.65,11.8 3.2,12.35 3.2,13 L3.2,13 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,11.28 L11,5 C10.97,4.22 10.66,3.53 10.06,2.94 C9.46,2.35 8.78,2.03 8,2 L7,2 L7,0 L4,3 L7,6 L7,4 L8,4 C8.27,4.02 8.48,4.11 8.69,4.31 C8.9,4.51 8.99,4.73 9,5 L9,11.28 C8.41,11.62 8,12.26 8,13 C8,14.11 8.89,15 10,15 C11.11,15 12,14.11 12,13 C12,12.27 11.59,11.62 11,11.28 L11,11.28 Z M10,14.2 C9.34,14.2 8.8,13.65 8.8,13 C8.8,12.35 9.35,11.8 10,11.8 C10.65,11.8 11.2,12.35 11.2,13 C11.2,13.65 10.65,14.2 10,14.2 L10,14.2 Z M4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,11.28 C0.41,11.62 0,12.26 0,13 C0,14.11 0.89,15 2,15 C3.11,15 4,14.11 4,13 C4,12.27 3.59,11.62 3,11.28 L3,4.72 C3.59,4.38 4,3.74 4,3 L4,3 Z M3.2,13 C3.2,13.66 2.65,14.2 2,14.2 C1.35,14.2 0.8,13.65 0.8,13 C0.8,12.35 1.35,11.8 2,11.8 C2.65,11.8 3.2,12.35 3.2,13 L3.2,13 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.gitPullRequest = gitPullRequest;
var globe = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "globe",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "globe",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C7.48,15 7.94,14.95 8.38,14.86 C8.21,14.78 8.18,14.13 8.36,13.77 C8.55,13.36 9.17,12.32 8.56,11.97 C7.95,11.62 8.12,11.47 7.75,11.06 C7.38,10.65 7.53,10.59 7.5,10.48 C7.42,10.14 7.86,9.59 7.89,9.54 C7.91,9.48 7.91,9.27 7.89,9.21 C7.89,9.13 7.62,8.99 7.55,8.98 C7.49,8.98 7.44,9.09 7.35,9.11 C7.26,9.13 6.85,8.86 6.76,8.78 C6.67,8.7 6.62,8.55 6.49,8.44 C6.36,8.31 6.35,8.41 6.16,8.33 C5.97,8.25 5.36,8.02 4.88,7.85 C4.4,7.66 4.36,7.38 4.36,7.19 C4.34,6.99 4.06,6.72 3.94,6.52 C3.8,6.32 3.78,6.05 3.74,6.11 C3.7,6.17 3.99,6.89 3.94,6.92 C3.89,6.94 3.78,6.72 3.64,6.54 C3.5,6.35 3.78,6.45 3.34,5.59 C2.9,4.73 3.48,4.29 3.51,3.84 C3.54,3.39 3.89,4.01 3.7,3.71 C3.51,3.41 3.7,2.82 3.56,2.6 C3.43,2.38 2.68,2.85 2.68,2.85 C2.7,2.63 3.37,2.27 3.84,1.93 C4.31,1.59 4.62,1.87 5,1.98 C5.39,2.11 5.41,2.07 5.28,1.93 C5.15,1.8 5.34,1.76 5.64,1.8 C5.92,1.85 6.02,2.21 6.47,2.16 C6.94,2.13 6.52,2.25 6.58,2.38 C6.64,2.51 6.52,2.49 6.2,2.68 C5.9,2.88 6.22,2.9 6.75,3.29 C7.28,3.68 7.13,3.04 7.06,2.74 C6.99,2.44 7.45,2.68 7.45,2.68 C7.78,2.9 7.72,2.7 7.95,2.76 C8.18,2.82 8.86,3.4 8.86,3.4 C8.03,3.84 8.55,3.88 8.69,3.99 C8.83,4.1 8.41,4.29 8.41,4.29 C8.24,4.12 8.22,4.31 8.11,4.37 C8,4.43 8.09,4.59 8.09,4.59 C7.53,4.68 7.65,5.28 7.67,5.42 C7.67,5.56 7.29,5.78 7.2,6 C7.11,6.2 7.45,6.64 7.26,6.66 C7.07,6.69 6.92,6 5.95,6.25 C5.65,6.33 5.01,6.66 5.36,7.33 C5.72,8.02 6.28,7.14 6.47,7.24 C6.66,7.34 6.41,7.77 6.45,7.79 C6.49,7.81 6.98,7.81 7.01,8.4 C7.04,8.99 7.78,8.93 7.93,8.95 C8.1,8.95 8.63,8.51 8.7,8.5 C8.76,8.47 9.08,8.22 9.73,8.59 C10.39,8.95 10.71,8.9 10.93,9.06 C11.15,9.22 11.01,9.53 11.21,9.64 C11.41,9.75 12.27,9.61 12.49,9.95 C12.71,10.29 11.61,12.04 11.27,12.23 C10.93,12.42 10.79,12.87 10.43,13.15 C10.07,13.43 9.62,13.79 9.16,14.06 C8.75,14.29 8.69,14.72 8.5,14.86 C11.64,14.16 13.98,11.36 13.98,8.02 C13.98,4.16 10.84,1.02 6.98,1.02 L7,1 Z M8.64,7.56 C8.55,7.59 8.36,7.78 7.86,7.48 C7.38,7.18 7.05,7.25 7,7.2 C7,7.2 6.95,7.09 7.17,7.06 C7.61,7.01 8.15,7.47 8.28,7.47 C8.41,7.47 8.47,7.34 8.69,7.42 C8.91,7.5 8.74,7.55 8.64,7.56 L8.64,7.56 Z M6.34,1.7 C6.29,1.67 6.37,1.62 6.43,1.56 C6.46,1.53 6.45,1.45 6.48,1.42 C6.59,1.31 7.09,1.17 7,1.45 C6.89,1.72 6.42,1.75 6.34,1.7 L6.34,1.7 Z M7.57,2.59 C7.38,2.57 6.99,2.54 7.05,2.45 C7.35,2.17 6.96,2.07 6.71,2.07 C6.46,2.05 6.37,1.91 6.49,1.88 C6.61,1.85 7.1,1.9 7.19,1.96 C7.27,2.02 7.71,2.21 7.74,2.34 C7.76,2.47 7.74,2.59 7.57,2.59 L7.57,2.59 Z M9.04,2.54 C8.9,2.63 8.21,2.13 8.09,2.02 C7.53,1.54 7.2,1.71 7.09,1.61 C6.98,1.51 7.01,1.42 7.2,1.27 C7.39,1.12 7.89,1.33 8.2,1.36 C8.5,1.39 8.86,1.63 8.86,1.91 C8.88,2.16 9.19,2.41 9.05,2.54 L9.04,2.54 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C7.48,15 7.94,14.95 8.38,14.86 C8.21,14.78 8.18,14.13 8.36,13.77 C8.55,13.36 9.17,12.32 8.56,11.97 C7.95,11.62 8.12,11.47 7.75,11.06 C7.38,10.65 7.53,10.59 7.5,10.48 C7.42,10.14 7.86,9.59 7.89,9.54 C7.91,9.48 7.91,9.27 7.89,9.21 C7.89,9.13 7.62,8.99 7.55,8.98 C7.49,8.98 7.44,9.09 7.35,9.11 C7.26,9.13 6.85,8.86 6.76,8.78 C6.67,8.7 6.62,8.55 6.49,8.44 C6.36,8.31 6.35,8.41 6.16,8.33 C5.97,8.25 5.36,8.02 4.88,7.85 C4.4,7.66 4.36,7.38 4.36,7.19 C4.34,6.99 4.06,6.72 3.94,6.52 C3.8,6.32 3.78,6.05 3.74,6.11 C3.7,6.17 3.99,6.89 3.94,6.92 C3.89,6.94 3.78,6.72 3.64,6.54 C3.5,6.35 3.78,6.45 3.34,5.59 C2.9,4.73 3.48,4.29 3.51,3.84 C3.54,3.39 3.89,4.01 3.7,3.71 C3.51,3.41 3.7,2.82 3.56,2.6 C3.43,2.38 2.68,2.85 2.68,2.85 C2.7,2.63 3.37,2.27 3.84,1.93 C4.31,1.59 4.62,1.87 5,1.98 C5.39,2.11 5.41,2.07 5.28,1.93 C5.15,1.8 5.34,1.76 5.64,1.8 C5.92,1.85 6.02,2.21 6.47,2.16 C6.94,2.13 6.52,2.25 6.58,2.38 C6.64,2.51 6.52,2.49 6.2,2.68 C5.9,2.88 6.22,2.9 6.75,3.29 C7.28,3.68 7.13,3.04 7.06,2.74 C6.99,2.44 7.45,2.68 7.45,2.68 C7.78,2.9 7.72,2.7 7.95,2.76 C8.18,2.82 8.86,3.4 8.86,3.4 C8.03,3.84 8.55,3.88 8.69,3.99 C8.83,4.1 8.41,4.29 8.41,4.29 C8.24,4.12 8.22,4.31 8.11,4.37 C8,4.43 8.09,4.59 8.09,4.59 C7.53,4.68 7.65,5.28 7.67,5.42 C7.67,5.56 7.29,5.78 7.2,6 C7.11,6.2 7.45,6.64 7.26,6.66 C7.07,6.69 6.92,6 5.95,6.25 C5.65,6.33 5.01,6.66 5.36,7.33 C5.72,8.02 6.28,7.14 6.47,7.24 C6.66,7.34 6.41,7.77 6.45,7.79 C6.49,7.81 6.98,7.81 7.01,8.4 C7.04,8.99 7.78,8.93 7.93,8.95 C8.1,8.95 8.63,8.51 8.7,8.5 C8.76,8.47 9.08,8.22 9.73,8.59 C10.39,8.95 10.71,8.9 10.93,9.06 C11.15,9.22 11.01,9.53 11.21,9.64 C11.41,9.75 12.27,9.61 12.49,9.95 C12.71,10.29 11.61,12.04 11.27,12.23 C10.93,12.42 10.79,12.87 10.43,13.15 C10.07,13.43 9.62,13.79 9.16,14.06 C8.75,14.29 8.69,14.72 8.5,14.86 C11.64,14.16 13.98,11.36 13.98,8.02 C13.98,4.16 10.84,1.02 6.98,1.02 L7,1 Z M8.64,7.56 C8.55,7.59 8.36,7.78 7.86,7.48 C7.38,7.18 7.05,7.25 7,7.2 C7,7.2 6.95,7.09 7.17,7.06 C7.61,7.01 8.15,7.47 8.28,7.47 C8.41,7.47 8.47,7.34 8.69,7.42 C8.91,7.5 8.74,7.55 8.64,7.56 L8.64,7.56 Z M6.34,1.7 C6.29,1.67 6.37,1.62 6.43,1.56 C6.46,1.53 6.45,1.45 6.48,1.42 C6.59,1.31 7.09,1.17 7,1.45 C6.89,1.72 6.42,1.75 6.34,1.7 L6.34,1.7 Z M7.57,2.59 C7.38,2.57 6.99,2.54 7.05,2.45 C7.35,2.17 6.96,2.07 6.71,2.07 C6.46,2.05 6.37,1.91 6.49,1.88 C6.61,1.85 7.1,1.9 7.19,1.96 C7.27,2.02 7.71,2.21 7.74,2.34 C7.76,2.47 7.74,2.59 7.57,2.59 L7.57,2.59 Z M9.04,2.54 C8.9,2.63 8.21,2.13 8.09,2.02 C7.53,1.54 7.2,1.71 7.09,1.61 C6.98,1.51 7.01,1.42 7.2,1.27 C7.39,1.12 7.89,1.33 8.2,1.36 C8.5,1.39 8.86,1.63 8.86,1.91 C8.88,2.16 9.19,2.41 9.05,2.54 L9.04,2.54 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.globe = globe;
var grabber = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "grabber",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "grabber",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,4 L8,5 L0,5 L0,4 L8,4 L8,4 Z M0,8 L8,8 L8,7 L0,7 L0,8 L0,8 Z M0,11 L8,11 L8,10 L0,10 L0,11 L0,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,4 L8,5 L0,5 L0,4 L8,4 L8,4 Z M0,8 L8,8 L8,7 L0,7 L0,8 L0,8 Z M0,11 L8,11 L8,10 L0,10 L0,11 L0,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.grabber = grabber;
var graph = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "graph",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "graph",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M16,14 L16,15 L0,15 L0,0 L1,0 L1,14 L16,14 L16,14 Z M5,13 L3,13 L3,8 L5,8 L5,13 L5,13 Z M9,13 L7,13 L7,3 L9,3 L9,13 L9,13 Z M13,13 L11,13 L11,6 L13,6 L13,13 L13,13 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M16,14 L16,15 L0,15 L0,0 L1,0 L1,14 L16,14 L16,14 Z M5,13 L3,13 L3,8 L5,8 L5,13 L5,13 Z M9,13 L7,13 L7,3 L9,3 L9,13 L9,13 Z M13,13 L11,13 L11,6 L13,6 L13,13 L13,13 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.graph = graph;
var heart = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "heart",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "heart",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11.2,3 C10.68,2.37 9.95,2.05 9,2 C8.03,2 7.31,2.42 6.8,3 C6.29,3.58 6.02,3.92 6,4 C5.98,3.92 5.72,3.58 5.2,3 C4.68,2.42 4.03,2 3,2 C2.05,2.05 1.31,2.38 0.8,3 C0.28,3.61 0.02,4.28 0,5 C0,5.52 0.09,6.52 0.67,7.67 C1.25,8.82 3.01,10.61 6,13 C8.98,10.61 10.77,8.83 11.34,7.67 C11.91,6.51 12,5.5 12,5 C11.98,4.28 11.72,3.61 11.2,2.98 L11.2,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11.2,3 C10.68,2.37 9.95,2.05 9,2 C8.03,2 7.31,2.42 6.8,3 C6.29,3.58 6.02,3.92 6,4 C5.98,3.92 5.72,3.58 5.2,3 C4.68,2.42 4.03,2 3,2 C2.05,2.05 1.31,2.38 0.8,3 C0.28,3.61 0.02,4.28 0,5 C0,5.52 0.09,6.52 0.67,7.67 C1.25,8.82 3.01,10.61 6,13 C8.98,10.61 10.77,8.83 11.34,7.67 C11.91,6.51 12,5.5 12,5 C11.98,4.28 11.72,3.61 11.2,2.98 L11.2,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.heart = heart;
var history = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "history",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "history",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,13 L6,13 L6,6 L11,6 L11,8 L8,8 L8,13 L8,13 Z M7,1 C4.81,1 2.87,2.02 1.59,3.59 L0,2 L0,6 L4,6 L2.5,4.5 C3.55,3.17 5.17,2.3 7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,7.66 1.33,7.33 1.39,7 L0.08,7 C0.03,7.33 0,7.66 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,13 L6,13 L6,6 L11,6 L11,8 L8,8 L8,13 L8,13 Z M7,1 C4.81,1 2.87,2.02 1.59,3.59 L0,2 L0,6 L4,6 L2.5,4.5 C3.55,3.17 5.17,2.3 7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,7.66 1.33,7.33 1.39,7 L0.08,7 C0.03,7.33 0,7.66 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.history = history;
var home = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "home",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "home",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M16,9 L13,6 L13,2 L11,2 L11,4 L8,1 L0,9 L2,9 L3,14 C3,14.55 3.45,15 4,15 L12,15 C12.55,15 13,14.55 13,14 L14,9 L16,9 L16,9 Z M12,14 L9,14 L9,10 L7,10 L7,14 L4,14 L2.81,7.69 L8,2.5 L13.19,7.69 L12,14 L12,14 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M16,9 L13,6 L13,2 L11,2 L11,4 L8,1 L0,9 L2,9 L3,14 C3,14.55 3.45,15 4,15 L12,15 C12.55,15 13,14.55 13,14 L14,9 L16,9 L16,9 Z M12,14 L9,14 L9,10 L7,10 L7,14 L4,14 L2.81,7.69 L8,2.5 L13.19,7.69 L12,14 L12,14 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.home = home;
var horizontalRule = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "horizontal-rule",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "horizontal-rule",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M1,7 L3,7 L3,9 L4,9 L4,3 L3,3 L3,6 L1,6 L1,3 L0,3 L0,9 L1,9 L1,7 L1,7 Z M10,9 L10,7 L9,7 L9,9 L10,9 L10,9 Z M10,6 L10,4 L9,4 L9,6 L10,6 L10,6 Z M7,6 L7,4 L9,4 L9,3 L6,3 L6,9 L7,9 L7,7 L9,7 L9,6 L7,6 L7,6 Z M0,13 L10,13 L10,11 L0,11 L0,13 L0,13 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M1,7 L3,7 L3,9 L4,9 L4,3 L3,3 L3,6 L1,6 L1,3 L0,3 L0,9 L1,9 L1,7 L1,7 Z M10,9 L10,7 L9,7 L9,9 L10,9 L10,9 Z M10,6 L10,4 L9,4 L9,6 L10,6 L10,6 Z M7,6 L7,4 L9,4 L9,3 L6,3 L6,9 L7,9 L7,7 L9,7 L9,6 L7,6 L7,6 Z M0,13 L10,13 L10,11 L0,11 L0,13 L0,13 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.horizontalRule = horizontalRule;
var hubot = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "hubot",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "hubot",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M3,6 C2.45,6 2,6.45 2,7 L2,9 C2,9.55 2.45,10 3,10 L11,10 C11.55,10 12,9.55 12,9 L12,7 C12,6.45 11.55,6 11,6 L3,6 L3,6 Z M11,7.75 L9.75,9 L8.25,9 L7,7.75 L5.75,9 L4.25,9 L3,7.75 L3,7 L3.75,7 L5,8.25 L6.25,7 L7.75,7 L9,8.25 L10.25,7 L11,7 L11,7.75 L11,7.75 Z M5,11 L9,11 L9,12 L5,12 L5,11 L5,11 Z M7,2 C3.14,2 0,4.91 0,8.5 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,8.5 C14,4.91 10.86,2 7,2 L7,2 Z M13,13 L1,13 L1,8.5 C1,5.41 3.64,2.91 7,2.91 C10.36,2.91 13,5.41 13,8.5 L13,13 L13,13 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M3,6 C2.45,6 2,6.45 2,7 L2,9 C2,9.55 2.45,10 3,10 L11,10 C11.55,10 12,9.55 12,9 L12,7 C12,6.45 11.55,6 11,6 L3,6 L3,6 Z M11,7.75 L9.75,9 L8.25,9 L7,7.75 L5.75,9 L4.25,9 L3,7.75 L3,7 L3.75,7 L5,8.25 L6.25,7 L7.75,7 L9,8.25 L10.25,7 L11,7 L11,7.75 L11,7.75 Z M5,11 L9,11 L9,12 L5,12 L5,11 L5,11 Z M7,2 C3.14,2 0,4.91 0,8.5 L0,13 C0,13.55 0.45,14 1,14 L13,14 C13.55,14 14,13.55 14,13 L14,8.5 C14,4.91 10.86,2 7,2 L7,2 Z M13,13 L1,13 L1,8.5 C1,5.41 3.64,2.91 7,2.91 C10.36,2.91 13,5.41 13,8.5 L13,13 L13,13 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.hubot = hubot;
var inbox = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "inbox",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "inbox",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,9 L12.87,1.86 C12.79,1.38 12.37,1 11.87,1 L2.13,1 C1.63,1 1.21,1.38 1.13,1.86 L0,9 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,9 L14,9 Z M10.72,9.55 L10.28,10.44 C10.11,10.78 9.76,11 9.37,11 L4.61,11 C4.23,11 3.89,10.78 3.72,10.45 L3.28,9.54 C3.11,9.21 2.76,8.99 2.39,8.99 L1,8.99 L2,1.99 L12,1.99 L13,8.99 L11.62,8.99 C11.23,8.99 10.89,9.21 10.71,9.54 L10.72,9.55 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,9 L12.87,1.86 C12.79,1.38 12.37,1 11.87,1 L2.13,1 C1.63,1 1.21,1.38 1.13,1.86 L0,9 L0,14 C0,14.55 0.45,15 1,15 L13,15 C13.55,15 14,14.55 14,14 L14,9 L14,9 Z M10.72,9.55 L10.28,10.44 C10.11,10.78 9.76,11 9.37,11 L4.61,11 C4.23,11 3.89,10.78 3.72,10.45 L3.28,9.54 C3.11,9.21 2.76,8.99 2.39,8.99 L1,8.99 L2,1.99 L12,1.99 L13,8.99 L11.62,8.99 C11.23,8.99 10.89,9.21 10.71,9.54 L10.72,9.55 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.inbox = inbox;
var info = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "info",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "info",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6.3,5.69 C6.11,5.5 6.02,5.27 6.02,4.99 C6.02,4.71 6.11,4.47 6.3,4.29 C6.49,4.11 6.72,4.01 7,4.01 C7.28,4.01 7.52,4.1 7.7,4.29 C7.88,4.48 7.98,4.71 7.98,4.99 C7.98,5.27 7.89,5.51 7.7,5.69 C7.51,5.87 7.28,5.99 7,5.99 C6.72,5.99 6.48,5.88 6.3,5.69 L6.3,5.69 Z M8,7.99 C7.98,7.74 7.89,7.51 7.69,7.3 C7.49,7.11 7.27,7 7,6.99 L6,6.99 C5.73,7.01 5.52,7.12 5.31,7.3 C5.11,7.5 5.01,7.74 5,7.99 L6,7.99 L6,10.99 C6.02,11.26 6.11,11.49 6.31,11.68 C6.51,11.88 6.73,11.99 7,11.99 L8,11.99 C8.27,11.99 8.48,11.88 8.69,11.68 C8.89,11.49 8.99,11.26 9,10.99 L8,10.99 L8,7.98 L8,7.99 Z M7,2.3 C3.86,2.3 1.3,4.84 1.3,7.98 C1.3,11.12 3.86,13.68 7,13.68 C10.14,13.68 12.7,11.13 12.7,7.98 C12.7,4.83 10.14,2.29 7,2.29 L7,2.3 Z M7,0.98 C10.86,0.98 14,4.12 14,7.98 C14,11.84 10.86,14.98 7,14.98 C3.14,14.98 0,11.86 0,7.98 C0,4.1 3.14,0.98 7,0.98 L7,0.98 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6.3,5.69 C6.11,5.5 6.02,5.27 6.02,4.99 C6.02,4.71 6.11,4.47 6.3,4.29 C6.49,4.11 6.72,4.01 7,4.01 C7.28,4.01 7.52,4.1 7.7,4.29 C7.88,4.48 7.98,4.71 7.98,4.99 C7.98,5.27 7.89,5.51 7.7,5.69 C7.51,5.87 7.28,5.99 7,5.99 C6.72,5.99 6.48,5.88 6.3,5.69 L6.3,5.69 Z M8,7.99 C7.98,7.74 7.89,7.51 7.69,7.3 C7.49,7.11 7.27,7 7,6.99 L6,6.99 C5.73,7.01 5.52,7.12 5.31,7.3 C5.11,7.5 5.01,7.74 5,7.99 L6,7.99 L6,10.99 C6.02,11.26 6.11,11.49 6.31,11.68 C6.51,11.88 6.73,11.99 7,11.99 L8,11.99 C8.27,11.99 8.48,11.88 8.69,11.68 C8.89,11.49 8.99,11.26 9,10.99 L8,10.99 L8,7.98 L8,7.99 Z M7,2.3 C3.86,2.3 1.3,4.84 1.3,7.98 C1.3,11.12 3.86,13.68 7,13.68 C10.14,13.68 12.7,11.13 12.7,7.98 C12.7,4.83 10.14,2.29 7,2.29 L7,2.3 Z M7,0.98 C10.86,0.98 14,4.12 14,7.98 C14,11.84 10.86,14.98 7,14.98 C3.14,14.98 0,11.86 0,7.98 C0,4.1 3.14,0.98 7,0.98 L7,0.98 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.info = info;
var issueClosed = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "issue-closed",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "issue-closed",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,10 L9,10 L9,12 L7,12 L7,10 L7,10 Z M9,4 L7,4 L7,9 L9,9 L9,4 L9,4 Z M10.5,5.5 L9.5,6.5 L12,9 L16,4.5 L15,3.5 L12,7 L10.5,5.5 L10.5,5.5 Z M8,13.7 C4.86,13.7 2.3,11.14 2.3,8 C2.3,4.86 4.86,2.3 8,2.3 C9.83,2.3 11.45,3.18 12.5,4.5 L13.42,3.58 C12.14,2 10.19,1 8,1 C4.14,1 1,4.14 1,8 C1,11.86 4.14,15 8,15 C11.86,15 15,11.86 15,8 L13.48,9.52 C12.82,11.93 10.62,13.71 8,13.71 L8,13.7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,10 L9,10 L9,12 L7,12 L7,10 L7,10 Z M9,4 L7,4 L7,9 L9,9 L9,4 L9,4 Z M10.5,5.5 L9.5,6.5 L12,9 L16,4.5 L15,3.5 L12,7 L10.5,5.5 L10.5,5.5 Z M8,13.7 C4.86,13.7 2.3,11.14 2.3,8 C2.3,4.86 4.86,2.3 8,2.3 C9.83,2.3 11.45,3.18 12.5,4.5 L13.42,3.58 C12.14,2 10.19,1 8,1 C4.14,1 1,4.14 1,8 C1,11.86 4.14,15 8,15 C11.86,15 15,11.86 15,8 L13.48,9.52 C12.82,11.93 10.62,13.71 8,13.71 L8,13.7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.issueClosed = issueClosed;
var issueOpened = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "issue-opened",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "issue-opened",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z M8,4 L6,4 L6,9 L8,9 L8,4 L8,4 Z M8,10 L6,10 L6,12 L8,12 L8,10 L8,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z M8,4 L6,4 L6,9 L8,9 L8,4 L8,4 Z M8,10 L6,10 L6,12 L8,12 L8,10 L8,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.issueOpened = issueOpened;
var issueReopened = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "issue-reopened",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "issue-reopened",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,9 L6,9 L6,4 L8,4 L8,9 L8,9 Z M6,12 L8,12 L8,10 L6,10 L6,12 L6,12 Z M12.33,10 L10,10 L11.5,11.5 C10.45,12.83 8.83,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,7.66 1.33,7.33 1.39,7 L0.08,7 C0.03,7.33 0,7.66 0,8 C0,11.86 3.14,15 7,15 C9.19,15 11.13,13.98 12.41,12.41 L14,14 L14,10 L12.33,10 L12.33,10 Z M1.67,6 L4,6 L2.5,4.5 C3.55,3.17 5.17,2.3 7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,8.34 12.67,8.67 12.61,9 L13.92,9 C13.97,8.67 14,8.34 14,8 C14,4.14 10.86,1 7,1 C4.81,1 2.87,2.02 1.59,3.59 L0,2 L0,6 L1.67,6 L1.67,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,9 L6,9 L6,4 L8,4 L8,9 L8,9 Z M6,12 L8,12 L8,10 L6,10 L6,12 L6,12 Z M12.33,10 L10,10 L11.5,11.5 C10.45,12.83 8.83,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,7.66 1.33,7.33 1.39,7 L0.08,7 C0.03,7.33 0,7.66 0,8 C0,11.86 3.14,15 7,15 C9.19,15 11.13,13.98 12.41,12.41 L14,14 L14,10 L12.33,10 L12.33,10 Z M1.67,6 L4,6 L2.5,4.5 C3.55,3.17 5.17,2.3 7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,8.34 12.67,8.67 12.61,9 L13.92,9 C13.97,8.67 14,8.34 14,8 C14,4.14 10.86,1 7,1 C4.81,1 2.87,2.02 1.59,3.59 L0,2 L0,6 L1.67,6 L1.67,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.issueReopened = issueReopened;
var italic = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "italic",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "italic",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M2.81,5 L4.79,5 L3,14 L1,14 L2.81,5 L2.81,5 Z M3.17,2.3 C3.17,1.6 3.75,1 4.5,1 C5.06,1 5.63,1.38 5.63,2.03 C5.63,2.78 5.04,3.33 4.3,3.33 C3.72,3.33 3.17,2.95 3.17,2.3 L3.17,2.3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M2.81,5 L4.79,5 L3,14 L1,14 L2.81,5 L2.81,5 Z M3.17,2.3 C3.17,1.6 3.75,1 4.5,1 C5.06,1 5.63,1.38 5.63,2.03 C5.63,2.78 5.04,3.33 4.3,3.33 C3.72,3.33 3.17,2.95 3.17,2.3 L3.17,2.3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.italic = italic;
var jersey = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "jersey",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "jersey",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4.5,6 L4,6.5 L4,11.5 L4.5,12 L6.5,12 L7,11.5 L7,6.5 L6.5,6 L4.5,6 L4.5,6 Z M6,11 L5,11 L5,7 L6,7 L6,11 L6,11 Z M12.27,3.75 C12.05,2.37 11.96,1.12 12,0 L9.02,0 C9.02,0.27 8.89,0.48 8.63,0.69 C8.38,0.89 8,0.99 7.5,0.99 C7,0.99 6.62,0.9 6.37,0.69 C6.14,0.49 6.01,0.27 6.01,0 L3,0 C3.05,1.13 2.97,2.38 2.75,3.75 C2.55,5.13 1.95,5.88 1,6 L1,15 C1.02,15.27 1.11,15.48 1.31,15.69 C1.51,15.9 1.73,15.99 2,16 L13,16 C13.27,15.98 13.48,15.89 13.69,15.69 C13.9,15.49 13.99,15.27 14,15 L14,6 C13.05,5.87 12.47,5.12 12.25,3.75 L12.27,3.75 Z M13,15 L2,15 L2,7 C2.89,6.5 3.48,5.75 3.72,4.75 C3.96,3.75 4.03,2.5 4,1 L5,1 C4.98,1.78 5.16,2.47 5.52,3.06 C5.88,3.64 6.54,3.95 7.52,4 C8.5,3.98 9.16,3.67 9.52,3.06 C9.88,2.47 10.02,1.78 10,1 L11,1 C11.02,2.42 11.13,3.55 11.33,4.38 C11.53,5.19 12.02,6.38 13,7.01 L13,15.01 L13,15 Z M8.5,6 L8,6.5 L8,11.5 L8.5,12 L10.5,12 L11,11.5 L11,6.5 L10.5,6 L8.5,6 L8.5,6 Z M10,11 L9,11 L9,7 L10,7 L10,11 L10,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4.5,6 L4,6.5 L4,11.5 L4.5,12 L6.5,12 L7,11.5 L7,6.5 L6.5,6 L4.5,6 L4.5,6 Z M6,11 L5,11 L5,7 L6,7 L6,11 L6,11 Z M12.27,3.75 C12.05,2.37 11.96,1.12 12,0 L9.02,0 C9.02,0.27 8.89,0.48 8.63,0.69 C8.38,0.89 8,0.99 7.5,0.99 C7,0.99 6.62,0.9 6.37,0.69 C6.14,0.49 6.01,0.27 6.01,0 L3,0 C3.05,1.13 2.97,2.38 2.75,3.75 C2.55,5.13 1.95,5.88 1,6 L1,15 C1.02,15.27 1.11,15.48 1.31,15.69 C1.51,15.9 1.73,15.99 2,16 L13,16 C13.27,15.98 13.48,15.89 13.69,15.69 C13.9,15.49 13.99,15.27 14,15 L14,6 C13.05,5.87 12.47,5.12 12.25,3.75 L12.27,3.75 Z M13,15 L2,15 L2,7 C2.89,6.5 3.48,5.75 3.72,4.75 C3.96,3.75 4.03,2.5 4,1 L5,1 C4.98,1.78 5.16,2.47 5.52,3.06 C5.88,3.64 6.54,3.95 7.52,4 C8.5,3.98 9.16,3.67 9.52,3.06 C9.88,2.47 10.02,1.78 10,1 L11,1 C11.02,2.42 11.13,3.55 11.33,4.38 C11.53,5.19 12.02,6.38 13,7.01 L13,15.01 L13,15 Z M8.5,6 L8,6.5 L8,11.5 L8.5,12 L10.5,12 L11,11.5 L11,6.5 L10.5,6 L8.5,6 L8.5,6 Z M10,11 L9,11 L9,7 L10,7 L10,11 L10,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.jersey = jersey;
var key = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "key",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "key",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12.83,2.17 C12.08,1.42 11.14,1.03 10,1 C8.87,1.03 7.92,1.42 7.17,2.17 C6.42,2.92 6.04,3.86 6.01,5 C6.01,5.3 6.04,5.59 6.1,5.89 L0,12 L0,13 L1,14 L3,14 L4,13 L4,12 L5,12 L5,11 L6,11 L6,10 L8,10 L9.09,8.89 C9.39,8.97 9.68,9 10,9 C11.14,8.97 12.08,8.58 12.83,7.83 C13.58,7.08 13.97,6.14 14,5 C13.97,3.86 13.58,2.92 12.83,2.17 L12.83,2.17 Z M11,5.38 C10.23,5.38 9.62,4.77 9.62,4 C9.62,3.23 10.23,2.62 11,2.62 C11.77,2.62 12.38,3.23 12.38,4 C12.38,4.77 11.77,5.38 11,5.38 L11,5.38 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12.83,2.17 C12.08,1.42 11.14,1.03 10,1 C8.87,1.03 7.92,1.42 7.17,2.17 C6.42,2.92 6.04,3.86 6.01,5 C6.01,5.3 6.04,5.59 6.1,5.89 L0,12 L0,13 L1,14 L3,14 L4,13 L4,12 L5,12 L5,11 L6,11 L6,10 L8,10 L9.09,8.89 C9.39,8.97 9.68,9 10,9 C11.14,8.97 12.08,8.58 12.83,7.83 C13.58,7.08 13.97,6.14 14,5 C13.97,3.86 13.58,2.92 12.83,2.17 L12.83,2.17 Z M11,5.38 C10.23,5.38 9.62,4.77 9.62,4 C9.62,3.23 10.23,2.62 11,2.62 C11.77,2.62 12.38,3.23 12.38,4 C12.38,4.77 11.77,5.38 11,5.38 L11,5.38 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.key = key;
var keyboard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "keyboard",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "keyboard",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,5 L9,5 L9,4 L10,4 L10,5 L10,5 Z M3,6 L2,6 L2,7 L3,7 L3,6 L3,6 Z M8,4 L7,4 L7,5 L8,5 L8,4 L8,4 Z M4,4 L2,4 L2,5 L4,5 L4,4 L4,4 Z M12,11 L14,11 L14,10 L12,10 L12,11 L12,11 Z M8,7 L9,7 L9,6 L8,6 L8,7 L8,7 Z M4,10 L2,10 L2,11 L4,11 L4,10 L4,10 Z M12,4 L11,4 L11,5 L12,5 L12,4 L12,4 Z M14,4 L13,4 L13,5 L14,5 L14,4 L14,4 Z M12,9 L14,9 L14,6 L12,6 L12,9 L12,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L1,13 C0.45,13 0,12.55 0,12 L0,3 C0,2.45 0.45,2 1,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M15,3 L1,3 L1,12 L15,12 L15,3 L15,3 Z M6,7 L7,7 L7,6 L6,6 L6,7 L6,7 Z M6,4 L5,4 L5,5 L6,5 L6,4 L6,4 Z M4,7 L5,7 L5,6 L4,6 L4,7 L4,7 Z M5,11 L11,11 L11,10 L5,10 L5,11 L5,11 Z M10,7 L11,7 L11,6 L10,6 L10,7 L10,7 Z M3,8 L2,8 L2,9 L3,9 L3,8 L3,8 Z M8,8 L8,9 L9,9 L9,8 L8,8 L8,8 Z M6,8 L6,9 L7,9 L7,8 L6,8 L6,8 Z M5,8 L4,8 L4,9 L5,9 L5,8 L5,8 Z M10,9 L11,9 L11,8 L10,8 L10,9 L10,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,5 L9,5 L9,4 L10,4 L10,5 L10,5 Z M3,6 L2,6 L2,7 L3,7 L3,6 L3,6 Z M8,4 L7,4 L7,5 L8,5 L8,4 L8,4 Z M4,4 L2,4 L2,5 L4,5 L4,4 L4,4 Z M12,11 L14,11 L14,10 L12,10 L12,11 L12,11 Z M8,7 L9,7 L9,6 L8,6 L8,7 L8,7 Z M4,10 L2,10 L2,11 L4,11 L4,10 L4,10 Z M12,4 L11,4 L11,5 L12,5 L12,4 L12,4 Z M14,4 L13,4 L13,5 L14,5 L14,4 L14,4 Z M12,9 L14,9 L14,6 L12,6 L12,9 L12,9 Z M16,3 L16,12 C16,12.55 15.55,13 15,13 L1,13 C0.45,13 0,12.55 0,12 L0,3 C0,2.45 0.45,2 1,2 L15,2 C15.55,2 16,2.45 16,3 L16,3 Z M15,3 L1,3 L1,12 L15,12 L15,3 L15,3 Z M6,7 L7,7 L7,6 L6,6 L6,7 L6,7 Z M6,4 L5,4 L5,5 L6,5 L6,4 L6,4 Z M4,7 L5,7 L5,6 L4,6 L4,7 L4,7 Z M5,11 L11,11 L11,10 L5,10 L5,11 L5,11 Z M10,7 L11,7 L11,6 L10,6 L10,7 L10,7 Z M3,8 L2,8 L2,9 L3,9 L3,8 L3,8 Z M8,8 L8,9 L9,9 L9,8 L8,8 L8,8 Z M6,8 L6,9 L7,9 L7,8 L6,8 L6,8 Z M5,8 L4,8 L4,9 L5,9 L5,8 L5,8 Z M10,9 L11,9 L11,8 L10,8 L10,9 L10,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.keyboard = keyboard;
var law = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "law",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "law",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,4 C6.17,4 5.5,3.33 5.5,2.5 C5.5,1.67 6.17,1 7,1 C7.83,1 8.5,1.67 8.5,2.5 C8.5,3.33 7.83,4 7,4 L7,4 Z M14,10 C14,11.11 13.11,12 12,12 L11,12 C9.89,12 9,11.11 9,10 L11,6 L10,6 C9.45,6 9,5.55 9,5 L8,5 L8,13 C8.42,13 9,13.45 9,14 L10,14 C10.42,14 11,14.45 11,15 L3,15 C3,14.45 3.58,14 4,14 L5,14 C5,13.45 5.58,13 6,13 L6.03,13 L6,5 L5,5 C5,5.55 4.55,6 4,6 L3,6 L5,10 C5,11.11 4.11,12 3,12 L2,12 C0.89,12 0,11.11 0,10 L2,6 L1,6 L1,5 L4,5 C4,4.45 4.45,4 5,4 L9,4 C9.55,4 10,4.45 10,5 L13,5 L13,6 L12,6 L14,10 L14,10 Z M2.5,7 L1,10 L4,10 L2.5,7 L2.5,7 Z M13,10 L11.5,7 L10,10 L13,10 L13,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,4 C6.17,4 5.5,3.33 5.5,2.5 C5.5,1.67 6.17,1 7,1 C7.83,1 8.5,1.67 8.5,2.5 C8.5,3.33 7.83,4 7,4 L7,4 Z M14,10 C14,11.11 13.11,12 12,12 L11,12 C9.89,12 9,11.11 9,10 L11,6 L10,6 C9.45,6 9,5.55 9,5 L8,5 L8,13 C8.42,13 9,13.45 9,14 L10,14 C10.42,14 11,14.45 11,15 L3,15 C3,14.45 3.58,14 4,14 L5,14 C5,13.45 5.58,13 6,13 L6.03,13 L6,5 L5,5 C5,5.55 4.55,6 4,6 L3,6 L5,10 C5,11.11 4.11,12 3,12 L2,12 C0.89,12 0,11.11 0,10 L2,6 L1,6 L1,5 L4,5 C4,4.45 4.45,4 5,4 L9,4 C9.55,4 10,4.45 10,5 L13,5 L13,6 L12,6 L14,10 L14,10 Z M2.5,7 L1,10 L4,10 L2.5,7 L2.5,7 Z M13,10 L11.5,7 L10,10 L13,10 L13,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.law = law;
var lightBulb = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "light-bulb",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "light-bulb",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6.5,0 C3.48,0 1,2.19 1,5 C1,5.92 1.55,7.25 2,8 C3.34,10.25 3.78,10.78 4,12 L4,13 L9,13 L9,12 C9.22,10.78 9.66,10.25 11,8 C11.45,7.25 12,5.92 12,5 C12,2.19 9.52,0 6.5,0 L6.5,0 Z M10.14,7.48 C9.89,7.92 9.67,8.28 9.47,8.59 C8.61,10 8.22,10.65 8.02,11.82 C8,11.87 8,11.93 8,11.99 L5,11.99 C5,11.93 5,11.86 4.98,11.82 C4.78,10.65 4.39,9.99 3.53,8.59 C3.33,8.28 3.11,7.92 2.86,7.48 C2.44,6.78 2,5.65 2,5 C2,2.8 4.02,1 6.5,1 C7.72,1 8.86,1.42 9.72,2.19 C10.55,2.94 11,3.94 11,5 C11,5.66 10.56,6.78 10.14,7.48 L10.14,7.48 Z M4,14 L9,14 C8.77,15.14 7.7,16 6.5,16 C5.3,16 4.23,15.14 4,14 L4,14 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6.5,0 C3.48,0 1,2.19 1,5 C1,5.92 1.55,7.25 2,8 C3.34,10.25 3.78,10.78 4,12 L4,13 L9,13 L9,12 C9.22,10.78 9.66,10.25 11,8 C11.45,7.25 12,5.92 12,5 C12,2.19 9.52,0 6.5,0 L6.5,0 Z M10.14,7.48 C9.89,7.92 9.67,8.28 9.47,8.59 C8.61,10 8.22,10.65 8.02,11.82 C8,11.87 8,11.93 8,11.99 L5,11.99 C5,11.93 5,11.86 4.98,11.82 C4.78,10.65 4.39,9.99 3.53,8.59 C3.33,8.28 3.11,7.92 2.86,7.48 C2.44,6.78 2,5.65 2,5 C2,2.8 4.02,1 6.5,1 C7.72,1 8.86,1.42 9.72,2.19 C10.55,2.94 11,3.94 11,5 C11,5.66 10.56,6.78 10.14,7.48 L10.14,7.48 Z M4,14 L9,14 C8.77,15.14 7.7,16 6.5,16 C5.3,16 4.23,15.14 4,14 L4,14 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.lightBulb = lightBulb;
var linkExternal = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "link-external",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "link-external",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,10 L12,10 L12,13 C12,13.55 11.55,14 11,14 L1,14 C0.45,14 0,13.55 0,13 L0,3 C0,2.45 0.45,2 1,2 L4,2 L4,3 L1,3 L1,13 L11,13 L11,10 L11,10 Z M6,2 L8.25,4.25 L5,7.5 L6.5,9 L9.75,5.75 L12,8 L12,2 L6,2 L6,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,10 L12,10 L12,13 C12,13.55 11.55,14 11,14 L1,14 C0.45,14 0,13.55 0,13 L0,3 C0,2.45 0.45,2 1,2 L4,2 L4,3 L1,3 L1,13 L11,13 L11,10 L11,10 Z M6,2 L8.25,4.25 L5,7.5 L6.5,9 L9.75,5.75 L12,8 L12,2 L6,2 L6,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.linkExternal = linkExternal;
var link = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "link",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "link",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,9 L5,9 L5,10 L4,10 C2.5,10 1,8.31 1,6.5 C1,4.69 2.55,3 4,3 L8,3 C9.45,3 11,4.69 11,6.5 C11,7.91 10.09,9.22 9,9.75 L9,8.59 C9.58,8.14 10,7.32 10,6.5 C10,5.22 8.98,4 8,4 L4,4 C3.02,4 2,5.22 2,6.5 C2,7.78 3,9 4,9 L4,9 Z M13,6 L12,6 L12,7 L13,7 C14,7 15,8.22 15,9.5 C15,10.78 13.98,12 13,12 L9,12 C8.02,12 7,10.78 7,9.5 C7,8.67 7.42,7.86 8,7.41 L8,6.25 C6.91,6.78 6,8.09 6,9.5 C6,11.31 7.55,13 9,13 L13,13 C14.45,13 16,11.31 16,9.5 C16,7.69 14.5,6 13,6 L13,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,9 L5,9 L5,10 L4,10 C2.5,10 1,8.31 1,6.5 C1,4.69 2.55,3 4,3 L8,3 C9.45,3 11,4.69 11,6.5 C11,7.91 10.09,9.22 9,9.75 L9,8.59 C9.58,8.14 10,7.32 10,6.5 C10,5.22 8.98,4 8,4 L4,4 C3.02,4 2,5.22 2,6.5 C2,7.78 3,9 4,9 L4,9 Z M13,6 L12,6 L12,7 L13,7 C14,7 15,8.22 15,9.5 C15,10.78 13.98,12 13,12 L9,12 C8.02,12 7,10.78 7,9.5 C7,8.67 7.42,7.86 8,7.41 L8,6.25 C6.91,6.78 6,8.09 6,9.5 C6,11.31 7.55,13 9,13 L13,13 C14.45,13 16,11.31 16,9.5 C16,7.69 14.5,6 13,6 L13,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.link = link;
var listOrdered = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "list-ordered",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "list-ordered",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,13 C12,13.59 12,14 11.41,14 L4.59,14 C4,14 4,13.59 4,13 C4,12.41 4,12 4.59,12 L11.4,12 C11.99,12 11.99,12.41 11.99,13 L12,13 Z M4.59,4 L11.4,4 C11.99,4 11.99,3.59 11.99,3 C11.99,2.41 11.99,2 11.4,2 L4.59,2 C4,2 4,2.41 4,3 C4,3.59 4,4 4.59,4 L4.59,4 Z M11.4,7 L4.59,7 C4,7 4,7.41 4,8 C4,8.59 4,9 4.59,9 L11.4,9 C11.99,9 11.99,8.59 11.99,8 C11.99,7.41 11.99,7 11.4,7 L11.4,7 Z M2,1 L1.28,1 C0.98,1.19 0.7,1.25 0.25,1.34 L0.25,2 L1,2 L1,4.14 L0.16,4.14 L0.16,5 L3,5 L3,4.14 L2,4.14 L2,1 L2,1 Z M2.25,9.13 C2.08,9.13 1.8,9.16 1.59,9.19 C2.12,8.63 2.73,7.94 2.73,7.3 C2.71,6.52 2.17,6 1.37,6 C0.78,6 0.4,6.2 -0.01,6.64 L0.57,7.22 C0.76,7.03 0.95,6.84 1.21,6.84 C1.49,6.84 1.69,7 1.69,7.36 C1.69,7.89 0.92,8.56 -0.01,9.42 L-0.01,10 L2.99,10 L2.9,9.12 L2.24,9.12 L2.25,9.13 Z M2.17,12.91 L2.17,12.88 C2.61,12.69 2.81,12.41 2.81,12.02 C2.81,11.32 2.25,10.91 1.37,10.91 C0.89,10.91 0.48,11.1 0.09,11.43 L0.64,12.07 C0.89,11.87 1.08,11.76 1.33,11.76 C1.6,11.76 1.75,11.89 1.75,12.12 C1.75,12.39 1.55,12.56 0.89,12.56 L0.89,13.31 C1.72,13.31 1.87,13.48 1.87,13.78 C1.87,14.03 1.64,14.16 1.29,14.16 C1.01,14.16 0.73,14.02 0.48,13.78 L-2.22044605e-16,14.44 C0.3,14.8 0.77,15 1.41,15 C2.24,15 2.94,14.59 2.94,13.84 C2.94,13.34 2.63,13.03 2.17,12.9 L2.17,12.91 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,13 C12,13.59 12,14 11.41,14 L4.59,14 C4,14 4,13.59 4,13 C4,12.41 4,12 4.59,12 L11.4,12 C11.99,12 11.99,12.41 11.99,13 L12,13 Z M4.59,4 L11.4,4 C11.99,4 11.99,3.59 11.99,3 C11.99,2.41 11.99,2 11.4,2 L4.59,2 C4,2 4,2.41 4,3 C4,3.59 4,4 4.59,4 L4.59,4 Z M11.4,7 L4.59,7 C4,7 4,7.41 4,8 C4,8.59 4,9 4.59,9 L11.4,9 C11.99,9 11.99,8.59 11.99,8 C11.99,7.41 11.99,7 11.4,7 L11.4,7 Z M2,1 L1.28,1 C0.98,1.19 0.7,1.25 0.25,1.34 L0.25,2 L1,2 L1,4.14 L0.16,4.14 L0.16,5 L3,5 L3,4.14 L2,4.14 L2,1 L2,1 Z M2.25,9.13 C2.08,9.13 1.8,9.16 1.59,9.19 C2.12,8.63 2.73,7.94 2.73,7.3 C2.71,6.52 2.17,6 1.37,6 C0.78,6 0.4,6.2 -0.01,6.64 L0.57,7.22 C0.76,7.03 0.95,6.84 1.21,6.84 C1.49,6.84 1.69,7 1.69,7.36 C1.69,7.89 0.92,8.56 -0.01,9.42 L-0.01,10 L2.99,10 L2.9,9.12 L2.24,9.12 L2.25,9.13 Z M2.17,12.91 L2.17,12.88 C2.61,12.69 2.81,12.41 2.81,12.02 C2.81,11.32 2.25,10.91 1.37,10.91 C0.89,10.91 0.48,11.1 0.09,11.43 L0.64,12.07 C0.89,11.87 1.08,11.76 1.33,11.76 C1.6,11.76 1.75,11.89 1.75,12.12 C1.75,12.39 1.55,12.56 0.89,12.56 L0.89,13.31 C1.72,13.31 1.87,13.48 1.87,13.78 C1.87,14.03 1.64,14.16 1.29,14.16 C1.01,14.16 0.73,14.02 0.48,13.78 L-2.22044605e-16,14.44 C0.3,14.8 0.77,15 1.41,15 C2.24,15 2.94,14.59 2.94,13.84 C2.94,13.34 2.63,13.03 2.17,12.9 L2.17,12.91 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.listOrdered = listOrdered;
var listUnordered = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "list-unordered",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "list-unordered",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M2,13 C2,13.59 2,14 1.41,14 L0.59,14 C0,14 0,13.59 0,13 C0,12.41 0,12 0.59,12 L1.4,12 C1.99,12 1.99,12.41 1.99,13 L2,13 Z M4.59,4 L11.4,4 C11.99,4 11.99,3.59 11.99,3 C11.99,2.41 11.99,2 11.4,2 L4.59,2 C4,2 4,2.41 4,3 C4,3.59 4,4 4.59,4 L4.59,4 Z M1.41,7 L0.59,7 C0,7 0,7.41 0,8 C0,8.59 0,9 0.59,9 L1.4,9 C1.99,9 1.99,8.59 1.99,8 C1.99,7.41 1.99,7 1.4,7 L1.41,7 Z M1.41,2 L0.59,2 C0,2 0,2.41 0,3 C0,3.59 0,4 0.59,4 L1.4,4 C1.99,4 1.99,3.59 1.99,3 C1.99,2.41 1.99,2 1.4,2 L1.41,2 Z M11.41,7 L4.59,7 C4,7 4,7.41 4,8 C4,8.59 4,9 4.59,9 L11.4,9 C11.99,9 11.99,8.59 11.99,8 C11.99,7.41 11.99,7 11.4,7 L11.41,7 Z M11.41,12 L4.59,12 C4,12 4,12.41 4,13 C4,13.59 4,14 4.59,14 L11.4,14 C11.99,14 11.99,13.59 11.99,13 C11.99,12.41 11.99,12 11.4,12 L11.41,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M2,13 C2,13.59 2,14 1.41,14 L0.59,14 C0,14 0,13.59 0,13 C0,12.41 0,12 0.59,12 L1.4,12 C1.99,12 1.99,12.41 1.99,13 L2,13 Z M4.59,4 L11.4,4 C11.99,4 11.99,3.59 11.99,3 C11.99,2.41 11.99,2 11.4,2 L4.59,2 C4,2 4,2.41 4,3 C4,3.59 4,4 4.59,4 L4.59,4 Z M1.41,7 L0.59,7 C0,7 0,7.41 0,8 C0,8.59 0,9 0.59,9 L1.4,9 C1.99,9 1.99,8.59 1.99,8 C1.99,7.41 1.99,7 1.4,7 L1.41,7 Z M1.41,2 L0.59,2 C0,2 0,2.41 0,3 C0,3.59 0,4 0.59,4 L1.4,4 C1.99,4 1.99,3.59 1.99,3 C1.99,2.41 1.99,2 1.4,2 L1.41,2 Z M11.41,7 L4.59,7 C4,7 4,7.41 4,8 C4,8.59 4,9 4.59,9 L11.4,9 C11.99,9 11.99,8.59 11.99,8 C11.99,7.41 11.99,7 11.4,7 L11.41,7 Z M11.41,12 L4.59,12 C4,12 4,12.41 4,13 C4,13.59 4,14 4.59,14 L11.4,14 C11.99,14 11.99,13.59 11.99,13 C11.99,12.41 11.99,12 11.4,12 L11.41,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.listUnordered = listUnordered;
var location = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "location",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "location",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,0 C2.69,0 0,2.5 0,5.5 C0,10.02 6,16 6,16 C6,16 12,10.02 12,5.5 C12,2.5 9.31,0 6,0 L6,0 Z M6,14.55 C4.14,12.52 1,8.44 1,5.5 C1,3.02 3.25,1 6,1 C7.34,1 8.61,1.48 9.56,2.36 C10.48,3.22 11,4.33 11,5.5 C11,8.44 7.86,12.52 6,14.55 L6,14.55 Z M8,5.5 C8,6.61 7.11,7.5 6,7.5 C4.89,7.5 4,6.61 4,5.5 C4,4.39 4.89,3.5 6,3.5 C7.11,3.5 8,4.39 8,5.5 L8,5.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,0 C2.69,0 0,2.5 0,5.5 C0,10.02 6,16 6,16 C6,16 12,10.02 12,5.5 C12,2.5 9.31,0 6,0 L6,0 Z M6,14.55 C4.14,12.52 1,8.44 1,5.5 C1,3.02 3.25,1 6,1 C7.34,1 8.61,1.48 9.56,2.36 C10.48,3.22 11,4.33 11,5.5 C11,8.44 7.86,12.52 6,14.55 L6,14.55 Z M8,5.5 C8,6.61 7.11,7.5 6,7.5 C4.89,7.5 4,6.61 4,5.5 C4,4.39 4.89,3.5 6,3.5 C7.11,3.5 8,4.39 8,5.5 L8,5.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.location = location;
var lock = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "lock",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "lock",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,13 L3,13 L3,12 L4,12 L4,13 L4,13 Z M12,7 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,7 C0,6.45 0.45,6 1,6 L2,6 L2,4 C2,1.8 3.8,0 6,0 C8.2,0 10,1.8 10,4 L10,6 L11,6 C11.55,6 12,6.45 12,7 L12,7 Z M3.8,6 L8.21,6 L8.21,4 C8.21,2.78 7.23,1.8 6.01,1.8 C4.79,1.8 3.81,2.78 3.81,4 L3.81,6 L3.8,6 Z M11,7 L2,7 L2,14 L11,14 L11,7 L11,7 Z M4,8 L3,8 L3,9 L4,9 L4,8 L4,8 Z M4,10 L3,10 L3,11 L4,11 L4,10 L4,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,13 L3,13 L3,12 L4,12 L4,13 L4,13 Z M12,7 L12,14 C12,14.55 11.55,15 11,15 L1,15 C0.45,15 0,14.55 0,14 L0,7 C0,6.45 0.45,6 1,6 L2,6 L2,4 C2,1.8 3.8,0 6,0 C8.2,0 10,1.8 10,4 L10,6 L11,6 C11.55,6 12,6.45 12,7 L12,7 Z M3.8,6 L8.21,6 L8.21,4 C8.21,2.78 7.23,1.8 6.01,1.8 C4.79,1.8 3.81,2.78 3.81,4 L3.81,6 L3.8,6 Z M11,7 L2,7 L2,14 L11,14 L11,7 L11,7 Z M4,8 L3,8 L3,9 L4,9 L4,8 L4,8 Z M4,10 L3,10 L3,11 L4,11 L4,10 L4,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.lock = lock;
var logoGist = {
  "viewBox": "0 0 25 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "logo-gist",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "logo-gist",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4.7,8.73 L7.15,8.73 L7.15,12.75 C6.6,13.02 5.51,13.09 4.62,13.09 C2.06,13.09 1.15,10.89 1.15,8.04 C1.15,5.19 2.06,2.98 4.63,2.98 C5.91,2.98 6.69,3.21 7.91,3.71 L7.91,2.66 C7.27,2.33 6.25,2 4.63,2 C1.13,2 0,4.69 0,8.03 C0,11.37 1.11,14.06 4.63,14.06 C6.27,14.06 7.44,13.79 8.22,13.42 L8.22,7.73 L4.7,7.73 L4.7,8.73 L4.7,8.73 Z M11.09,12.45 L11.09,6.06 L10.04,6.06 L10.04,12.34 C10.04,13.59 10.62,14.06 11.76,14.06 L11.76,13.17 C11.28,13.17 11.09,13.01 11.09,12.47 L11.09,12.45 L11.09,12.45 Z M11.34,3.73 C11.34,3.29 11.01,2.95 10.56,2.95 C10.11,2.95 9.79,3.29 9.79,3.73 C9.79,4.17 10.12,4.51 10.56,4.51 C11,4.51 11.34,4.17 11.34,3.73 L11.34,3.73 Z M15.68,9.42 C14.18,9.29 13.9,8.94 13.9,8.25 C13.9,7.48 14.23,6.91 15.78,6.91 C16.83,6.91 17.44,7.07 18.05,7.27 L18.05,6.33 C17.36,6.03 16.53,5.94 15.8,5.94 C13.6,5.94 12.88,7.14 12.88,8.25 C12.88,9.33 13.35,10.13 15.61,10.33 C17.16,10.46 17.38,10.96 17.38,11.67 C17.38,12.4 16.94,13.09 15.32,13.09 C14.21,13.09 13.46,12.9 12.99,12.73 L12.99,13.67 C13.49,13.87 14.57,14.06 15.32,14.06 C17.7,14.06 18.46,12.86 18.46,11.65 C18.46,10.37 17.93,9.62 15.71,9.42 L15.69,9.42 L15.68,9.42 Z M24.26,6.95 L24.26,6.09 L21.84,6.09 L21.84,3.59 L20.76,3.9 L20.76,6.01 L19.2,6.45 L19.2,6.93 L20.76,6.93 L20.76,11.93 C20.76,13.46 21.95,14.06 23.26,14.06 C23.45,14.06 23.78,14.04 23.95,14.01 L23.95,13.12 C23.76,13.15 23.54,13.15 23.34,13.15 C22.37,13.15 21.84,12.76 21.84,11.81 L21.84,6.94 L24.26,6.94 L24.26,6.96 L24.26,6.95 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4.7,8.73 L7.15,8.73 L7.15,12.75 C6.6,13.02 5.51,13.09 4.62,13.09 C2.06,13.09 1.15,10.89 1.15,8.04 C1.15,5.19 2.06,2.98 4.63,2.98 C5.91,2.98 6.69,3.21 7.91,3.71 L7.91,2.66 C7.27,2.33 6.25,2 4.63,2 C1.13,2 0,4.69 0,8.03 C0,11.37 1.11,14.06 4.63,14.06 C6.27,14.06 7.44,13.79 8.22,13.42 L8.22,7.73 L4.7,7.73 L4.7,8.73 L4.7,8.73 Z M11.09,12.45 L11.09,6.06 L10.04,6.06 L10.04,12.34 C10.04,13.59 10.62,14.06 11.76,14.06 L11.76,13.17 C11.28,13.17 11.09,13.01 11.09,12.47 L11.09,12.45 L11.09,12.45 Z M11.34,3.73 C11.34,3.29 11.01,2.95 10.56,2.95 C10.11,2.95 9.79,3.29 9.79,3.73 C9.79,4.17 10.12,4.51 10.56,4.51 C11,4.51 11.34,4.17 11.34,3.73 L11.34,3.73 Z M15.68,9.42 C14.18,9.29 13.9,8.94 13.9,8.25 C13.9,7.48 14.23,6.91 15.78,6.91 C16.83,6.91 17.44,7.07 18.05,7.27 L18.05,6.33 C17.36,6.03 16.53,5.94 15.8,5.94 C13.6,5.94 12.88,7.14 12.88,8.25 C12.88,9.33 13.35,10.13 15.61,10.33 C17.16,10.46 17.38,10.96 17.38,11.67 C17.38,12.4 16.94,13.09 15.32,13.09 C14.21,13.09 13.46,12.9 12.99,12.73 L12.99,13.67 C13.49,13.87 14.57,14.06 15.32,14.06 C17.7,14.06 18.46,12.86 18.46,11.65 C18.46,10.37 17.93,9.62 15.71,9.42 L15.69,9.42 L15.68,9.42 Z M24.26,6.95 L24.26,6.09 L21.84,6.09 L21.84,3.59 L20.76,3.9 L20.76,6.01 L19.2,6.45 L19.2,6.93 L20.76,6.93 L20.76,11.93 C20.76,13.46 21.95,14.06 23.26,14.06 C23.45,14.06 23.78,14.04 23.95,14.01 L23.95,13.12 C23.76,13.15 23.54,13.15 23.34,13.15 C22.37,13.15 21.84,12.76 21.84,11.81 L21.84,6.94 L24.26,6.94 L24.26,6.96 L24.26,6.95 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.logoGist = logoGist;
var logoGithub = {
  "viewBox": "0 0 45 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "logo-github",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "logo-github",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M18.53,12.0301 L18.51,12.0301 C18.519,12.0301 18.525,12.0391 18.534,12.0411 C18.535,12.0411 18.539,12.0401 18.54,12.0401 L18.53,12.0301 Z M18.534,12.0411 C18.441,12.0421 18.207,12.0901 17.96,12.0901 C17.18,12.0901 16.91,11.7301 16.91,11.2601 L16.91,8.1301 L18.5,8.1301 C18.59,8.1301 18.66,8.0501 18.66,7.9401 L18.66,6.2401 C18.66,6.1501 18.58,6.0701 18.5,6.0701 L16.91,6.0701 L16.91,3.9601 C16.91,3.8801 16.86,3.8301 16.77,3.8301 L14.61,3.8301 C14.52,3.8301 14.47,3.8801 14.47,3.9601 L14.47,6.1301 C14.47,6.1301 13.38,6.4001 13.31,6.4101 C13.23,6.4301 13.18,6.5001 13.18,6.5801 L13.18,7.9401 C13.18,8.0501 13.26,8.1301 13.35,8.1301 L14.46,8.1301 L14.46,11.4101 C14.46,13.8501 16.16,14.1001 17.32,14.1001 C17.85,14.1001 18.49,13.9301 18.59,13.8801 C18.65,13.8601 18.68,13.7901 18.68,13.7201 L18.68,12.2201 C18.68,12.1211 18.612,12.0551 18.534,12.0411 L18.534,12.0411 Z M42.23,9.8401 C42.23,8.0301 41.5,7.7901 40.73,7.8701 C40.13,7.9101 39.65,8.2101 39.65,8.2101 L39.65,11.7301 C39.65,11.7301 40.14,12.0701 40.87,12.0901 C41.9,12.1201 42.23,11.7501 42.23,9.8401 L42.23,9.8401 Z M44.66,9.6801 C44.66,13.1101 43.55,14.0901 41.61,14.0901 C39.97,14.0901 39.09,13.2601 39.09,13.2601 C39.09,13.2601 39.05,13.7201 39,13.7801 C38.97,13.8401 38.92,13.8601 38.86,13.8601 L37.38,13.8601 C37.28,13.8601 37.19,13.7801 37.19,13.6901 L37.21,2.5801 C37.21,2.4901 37.29,2.4101 37.38,2.4101 L39.51,2.4101 C39.6,2.4101 39.68,2.4901 39.68,2.5801 L39.68,6.3501 C39.68,6.3501 40.5,5.8201 41.7,5.8201 L41.69,5.8001 C42.89,5.8001 44.66,6.2501 44.66,9.6801 L44.66,9.6801 Z M35.94,6.0701 L35.93,6.0701 L33.84,6.0701 C33.73,6.0701 33.67,6.1501 33.67,6.2601 L33.67,11.7001 C33.67,11.7001 33.12,12.0901 32.37,12.0901 C31.62,12.0901 31.4,11.7501 31.4,11.0001 L31.4,6.2501 C31.4,6.1601 31.32,6.0801 31.23,6.0801 L29.09,6.0801 C29,6.0801 28.92,6.1601 28.92,6.2501 L28.92,11.3601 C28.92,13.5601 30.15,14.1101 31.84,14.1101 C33.23,14.1101 34.36,13.3401 34.36,13.3401 C34.36,13.3401 34.41,13.7301 34.44,13.7901 C34.46,13.8401 34.53,13.8801 34.6,13.8801 L35.94,13.8801 C36.05,13.8801 36.11,13.8001 36.11,13.7101 L36.13,6.2401 C36.13,6.1501 36.05,6.0701 35.94,6.0701 L35.94,6.0701 Z M12.24,6.0601 L10.11,6.0601 C10.02,6.0601 9.94,6.1501 9.94,6.2601 L9.94,13.6001 C9.94,13.8001 10.07,13.8701 10.24,13.8701 L12.16,13.8701 C12.36,13.8701 12.41,13.7801 12.41,13.6001 L12.41,6.2401 L12.41,6.2301 C12.41,6.1401 12.33,6.0601 12.24,6.0601 L12.24,6.0601 Z M11.19,2.6801 C10.42,2.6801 9.81,3.2901 9.81,4.0601 C9.81,4.8301 10.42,5.4401 11.19,5.4401 C11.94,5.4401 12.55,4.8301 12.55,4.0601 C12.55,3.2901 11.94,2.6801 11.19,2.6801 L11.19,2.6801 Z M27.68,2.4301 L25.57,2.4301 C25.48,2.4301 25.4,2.5101 25.4,2.6001 L25.4,6.6901 L22.09,6.6901 L22.09,2.6001 C22.09,2.5101 22.01,2.4301 21.92,2.4301 L19.79,2.4301 C19.7,2.4301 19.62,2.5101 19.62,2.6001 L19.62,13.7101 C19.62,13.8001 19.71,13.8801 19.79,13.8801 L21.92,13.8801 C22.01,13.8801 22.09,13.8001 22.09,13.7101 L22.09,8.9601 L25.4,8.9601 L25.38,13.7101 C25.38,13.8001 25.46,13.8801 25.55,13.8801 L27.68,13.8801 C27.77,13.8801 27.85,13.8001 27.85,13.7101 L27.85,2.6001 C27.85,2.5101 27.77,2.4301 27.68,2.4301 L27.68,2.4301 Z M8.81,7.3501 L8.81,13.0901 C8.81,13.1301 8.8,13.2001 8.75,13.2201 C8.75,13.2201 7.5,14.1101 5.44,14.1101 C2.95,14.1101 0,13.3301 0,8.1901 C0,3.0501 2.58,1.9901 5.1,2.0001 C7.28,2.0001 8.16,2.4901 8.3,2.5801 C8.34,2.6301 8.36,2.6701 8.36,2.7201 L7.94,4.5001 C7.94,4.5901 7.85,4.7001 7.74,4.6701 C7.38,4.5601 6.84,4.3401 5.57,4.3401 C4.1,4.3401 2.52,4.7601 2.52,8.0701 C2.52,11.3801 4.02,11.7701 5.1,11.7701 C6.02,11.7701 6.35,11.6601 6.35,11.6601 L6.35,9.3601 L4.88,9.3601 C4.77,9.3601 4.69,9.2801 4.69,9.1901 L4.69,7.3501 C4.69,7.2601 4.77,7.1801 4.88,7.1801 L8.62,7.1801 C8.73,7.1801 8.81,7.2601 8.81,7.3501 L8.81,7.3501 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M18.53,12.0301 L18.51,12.0301 C18.519,12.0301 18.525,12.0391 18.534,12.0411 C18.535,12.0411 18.539,12.0401 18.54,12.0401 L18.53,12.0301 Z M18.534,12.0411 C18.441,12.0421 18.207,12.0901 17.96,12.0901 C17.18,12.0901 16.91,11.7301 16.91,11.2601 L16.91,8.1301 L18.5,8.1301 C18.59,8.1301 18.66,8.0501 18.66,7.9401 L18.66,6.2401 C18.66,6.1501 18.58,6.0701 18.5,6.0701 L16.91,6.0701 L16.91,3.9601 C16.91,3.8801 16.86,3.8301 16.77,3.8301 L14.61,3.8301 C14.52,3.8301 14.47,3.8801 14.47,3.9601 L14.47,6.1301 C14.47,6.1301 13.38,6.4001 13.31,6.4101 C13.23,6.4301 13.18,6.5001 13.18,6.5801 L13.18,7.9401 C13.18,8.0501 13.26,8.1301 13.35,8.1301 L14.46,8.1301 L14.46,11.4101 C14.46,13.8501 16.16,14.1001 17.32,14.1001 C17.85,14.1001 18.49,13.9301 18.59,13.8801 C18.65,13.8601 18.68,13.7901 18.68,13.7201 L18.68,12.2201 C18.68,12.1211 18.612,12.0551 18.534,12.0411 L18.534,12.0411 Z M42.23,9.8401 C42.23,8.0301 41.5,7.7901 40.73,7.8701 C40.13,7.9101 39.65,8.2101 39.65,8.2101 L39.65,11.7301 C39.65,11.7301 40.14,12.0701 40.87,12.0901 C41.9,12.1201 42.23,11.7501 42.23,9.8401 L42.23,9.8401 Z M44.66,9.6801 C44.66,13.1101 43.55,14.0901 41.61,14.0901 C39.97,14.0901 39.09,13.2601 39.09,13.2601 C39.09,13.2601 39.05,13.7201 39,13.7801 C38.97,13.8401 38.92,13.8601 38.86,13.8601 L37.38,13.8601 C37.28,13.8601 37.19,13.7801 37.19,13.6901 L37.21,2.5801 C37.21,2.4901 37.29,2.4101 37.38,2.4101 L39.51,2.4101 C39.6,2.4101 39.68,2.4901 39.68,2.5801 L39.68,6.3501 C39.68,6.3501 40.5,5.8201 41.7,5.8201 L41.69,5.8001 C42.89,5.8001 44.66,6.2501 44.66,9.6801 L44.66,9.6801 Z M35.94,6.0701 L35.93,6.0701 L33.84,6.0701 C33.73,6.0701 33.67,6.1501 33.67,6.2601 L33.67,11.7001 C33.67,11.7001 33.12,12.0901 32.37,12.0901 C31.62,12.0901 31.4,11.7501 31.4,11.0001 L31.4,6.2501 C31.4,6.1601 31.32,6.0801 31.23,6.0801 L29.09,6.0801 C29,6.0801 28.92,6.1601 28.92,6.2501 L28.92,11.3601 C28.92,13.5601 30.15,14.1101 31.84,14.1101 C33.23,14.1101 34.36,13.3401 34.36,13.3401 C34.36,13.3401 34.41,13.7301 34.44,13.7901 C34.46,13.8401 34.53,13.8801 34.6,13.8801 L35.94,13.8801 C36.05,13.8801 36.11,13.8001 36.11,13.7101 L36.13,6.2401 C36.13,6.1501 36.05,6.0701 35.94,6.0701 L35.94,6.0701 Z M12.24,6.0601 L10.11,6.0601 C10.02,6.0601 9.94,6.1501 9.94,6.2601 L9.94,13.6001 C9.94,13.8001 10.07,13.8701 10.24,13.8701 L12.16,13.8701 C12.36,13.8701 12.41,13.7801 12.41,13.6001 L12.41,6.2401 L12.41,6.2301 C12.41,6.1401 12.33,6.0601 12.24,6.0601 L12.24,6.0601 Z M11.19,2.6801 C10.42,2.6801 9.81,3.2901 9.81,4.0601 C9.81,4.8301 10.42,5.4401 11.19,5.4401 C11.94,5.4401 12.55,4.8301 12.55,4.0601 C12.55,3.2901 11.94,2.6801 11.19,2.6801 L11.19,2.6801 Z M27.68,2.4301 L25.57,2.4301 C25.48,2.4301 25.4,2.5101 25.4,2.6001 L25.4,6.6901 L22.09,6.6901 L22.09,2.6001 C22.09,2.5101 22.01,2.4301 21.92,2.4301 L19.79,2.4301 C19.7,2.4301 19.62,2.5101 19.62,2.6001 L19.62,13.7101 C19.62,13.8001 19.71,13.8801 19.79,13.8801 L21.92,13.8801 C22.01,13.8801 22.09,13.8001 22.09,13.7101 L22.09,8.9601 L25.4,8.9601 L25.38,13.7101 C25.38,13.8001 25.46,13.8801 25.55,13.8801 L27.68,13.8801 C27.77,13.8801 27.85,13.8001 27.85,13.7101 L27.85,2.6001 C27.85,2.5101 27.77,2.4301 27.68,2.4301 L27.68,2.4301 Z M8.81,7.3501 L8.81,13.0901 C8.81,13.1301 8.8,13.2001 8.75,13.2201 C8.75,13.2201 7.5,14.1101 5.44,14.1101 C2.95,14.1101 0,13.3301 0,8.1901 C0,3.0501 2.58,1.9901 5.1,2.0001 C7.28,2.0001 8.16,2.4901 8.3,2.5801 C8.34,2.6301 8.36,2.6701 8.36,2.7201 L7.94,4.5001 C7.94,4.5901 7.85,4.7001 7.74,4.6701 C7.38,4.5601 6.84,4.3401 5.57,4.3401 C4.1,4.3401 2.52,4.7601 2.52,8.0701 C2.52,11.3801 4.02,11.7701 5.1,11.7701 C6.02,11.7701 6.35,11.6601 6.35,11.6601 L6.35,9.3601 L4.88,9.3601 C4.77,9.3601 4.69,9.2801 4.69,9.1901 L4.69,7.3501 C4.69,7.2601 4.77,7.1801 4.88,7.1801 L8.62,7.1801 C8.73,7.1801 8.81,7.2601 8.81,7.3501 L8.81,7.3501 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.logoGithub = logoGithub;
var mailRead = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mail-read",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mail-read",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,5 L4,5 L4,4 L6,4 L6,5 L6,5 Z M9,6 L4,6 L4,7 L9,7 L9,6 L9,6 Z M14,5.52 L14,14 C14,14.55 13.55,15 13,15 L1,15 C0.45,15 0,14.55 0,14 L0,5.52 C0,5.19 0.16,4.89 0.42,4.71 L2,3.58 L2,3 C2,2.45 2.45,2 3,2 L4.2,2 L7,0 L9.8,2 L11,2 C11.55,2 12,2.45 12,3 L12,3.58 L13.58,4.71 C13.85,4.9 14,5.19 14,5.52 L14,5.52 Z M3,7.5 L7,10 L11,7.5 L11,3 L3,3 L3,7.5 L3,7.5 Z M1,13.5 L5.5,10.5 L1,7.5 L1,13.5 L1,13.5 Z M12,14 L7,11 L2,14 L12,14 L12,14 Z M13,7.5 L8.5,10.5 L13,13.5 L13,7.5 L13,7.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,5 L4,5 L4,4 L6,4 L6,5 L6,5 Z M9,6 L4,6 L4,7 L9,7 L9,6 L9,6 Z M14,5.52 L14,14 C14,14.55 13.55,15 13,15 L1,15 C0.45,15 0,14.55 0,14 L0,5.52 C0,5.19 0.16,4.89 0.42,4.71 L2,3.58 L2,3 C2,2.45 2.45,2 3,2 L4.2,2 L7,0 L9.8,2 L11,2 C11.55,2 12,2.45 12,3 L12,3.58 L13.58,4.71 C13.85,4.9 14,5.19 14,5.52 L14,5.52 Z M3,7.5 L7,10 L11,7.5 L11,3 L3,3 L3,7.5 L3,7.5 Z M1,13.5 L5.5,10.5 L1,7.5 L1,13.5 L1,13.5 Z M12,14 L7,11 L2,14 L12,14 L12,14 Z M13,7.5 L8.5,10.5 L13,13.5 L13,7.5 L13,7.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mailRead = mailRead;
var mailReply = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mail-reply",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mail-reply",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,2.5 L0,7 L6,11.5 L6,8.5 C7.73,8.5 11.14,9.45 12,12.88 C12,8.33 8.94,5.83 6,5.5 L6,2.5 L6,2.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,2.5 L0,7 L6,11.5 L6,8.5 C7.73,8.5 11.14,9.45 12,12.88 C12,8.33 8.94,5.83 6,5.5 L6,2.5 L6,2.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mailReply = mailReply;
var mail = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mail",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mail",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M0,4 L0,12 C0,12.55 0.45,13 1,13 L13,13 C13.55,13 14,12.55 14,12 L14,4 C14,3.45 13.55,3 13,3 L1,3 C0.45,3 0,3.45 0,4 L0,4 Z M13,4 L7,9 L1,4 L13,4 L13,4 Z M1,5.5 L5,8.5 L1,11.5 L1,5.5 L1,5.5 Z M2,12 L5.5,9 L7,10.5 L8.5,9 L12,12 L2,12 L2,12 Z M13,11.5 L9,8.5 L13,5.5 L13,11.5 L13,11.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M0,4 L0,12 C0,12.55 0.45,13 1,13 L13,13 C13.55,13 14,12.55 14,12 L14,4 C14,3.45 13.55,3 13,3 L1,3 C0.45,3 0,3.45 0,4 L0,4 Z M13,4 L7,9 L1,4 L13,4 L13,4 Z M1,5.5 L5,8.5 L1,11.5 L1,5.5 L1,5.5 Z M2,12 L5.5,9 L7,10.5 L8.5,9 L12,12 L2,12 L2,12 Z M13,11.5 L9,8.5 L13,5.5 L13,11.5 L13,11.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mail = mail;
var markGithub = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mark-github",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mark-github",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,0 C3.58,0 0,3.58 0,8 C0,11.54 2.29,14.53 5.47,15.59 C5.87,15.66 6.02,15.42 6.02,15.21 C6.02,15.02 6.01,14.39 6.01,13.72 C4,14.09 3.48,13.23 3.32,12.78 C3.23,12.55 2.84,11.84 2.5,11.65 C2.22,11.5 1.82,11.13 2.49,11.12 C3.12,11.11 3.57,11.7 3.72,11.94 C4.44,13.15 5.59,12.81 6.05,12.6 C6.12,12.08 6.33,11.73 6.56,11.53 C4.78,11.33 2.92,10.64 2.92,7.58 C2.92,6.71 3.23,5.99 3.74,5.43 C3.66,5.23 3.38,4.41 3.82,3.31 C3.82,3.31 4.49,3.1 6.02,4.13 C6.66,3.95 7.34,3.86 8.02,3.86 C8.7,3.86 9.38,3.95 10.02,4.13 C11.55,3.09 12.22,3.31 12.22,3.31 C12.66,4.41 12.38,5.23 12.3,5.43 C12.81,5.99 13.12,6.7 13.12,7.58 C13.12,10.65 11.25,11.33 9.47,11.53 C9.76,11.78 10.01,12.26 10.01,13.01 C10.01,14.08 10,14.94 10,15.21 C10,15.42 10.15,15.67 10.55,15.59 C13.71,14.53 16,11.53 16,8 C16,3.58 12.42,0 8,0 L8,0 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,0 C3.58,0 0,3.58 0,8 C0,11.54 2.29,14.53 5.47,15.59 C5.87,15.66 6.02,15.42 6.02,15.21 C6.02,15.02 6.01,14.39 6.01,13.72 C4,14.09 3.48,13.23 3.32,12.78 C3.23,12.55 2.84,11.84 2.5,11.65 C2.22,11.5 1.82,11.13 2.49,11.12 C3.12,11.11 3.57,11.7 3.72,11.94 C4.44,13.15 5.59,12.81 6.05,12.6 C6.12,12.08 6.33,11.73 6.56,11.53 C4.78,11.33 2.92,10.64 2.92,7.58 C2.92,6.71 3.23,5.99 3.74,5.43 C3.66,5.23 3.38,4.41 3.82,3.31 C3.82,3.31 4.49,3.1 6.02,4.13 C6.66,3.95 7.34,3.86 8.02,3.86 C8.7,3.86 9.38,3.95 10.02,4.13 C11.55,3.09 12.22,3.31 12.22,3.31 C12.66,4.41 12.38,5.23 12.3,5.43 C12.81,5.99 13.12,6.7 13.12,7.58 C13.12,10.65 11.25,11.33 9.47,11.53 C9.76,11.78 10.01,12.26 10.01,13.01 C10.01,14.08 10,14.94 10,15.21 C10,15.42 10.15,15.67 10.55,15.59 C13.71,14.53 16,11.53 16,8 C16,3.58 12.42,0 8,0 L8,0 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.markGithub = markGithub;
var markdown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "markdown",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "markdown",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14.85,3 L1.15,3 C0.52,3 0,3.52 0,4.15 L0,11.84 C0,12.48 0.52,13 1.15,13 L14.84,13 C15.48,13 15.99,12.48 15.99,11.85 L15.99,4.15 C16,3.52 15.48,3 14.85,3 L14.85,3 Z M9,11 L7,11 L7,8 L5.5,9.92 L4,8 L4,11 L2,11 L2,5 L4,5 L5.5,7 L7,5 L9,5 L9,11 L9,11 Z M11.99,11.5 L9.5,8 L11,8 L11,5 L13,5 L13,8 L14.5,8 L11.99,11.5 L11.99,11.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14.85,3 L1.15,3 C0.52,3 0,3.52 0,4.15 L0,11.84 C0,12.48 0.52,13 1.15,13 L14.84,13 C15.48,13 15.99,12.48 15.99,11.85 L15.99,4.15 C16,3.52 15.48,3 14.85,3 L14.85,3 Z M9,11 L7,11 L7,8 L5.5,9.92 L4,8 L4,11 L2,11 L2,5 L4,5 L5.5,7 L7,5 L9,5 L9,11 L9,11 Z M11.99,11.5 L9.5,8 L11,8 L11,5 L13,5 L13,8 L14.5,8 L11.99,11.5 L11.99,11.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.markdown = markdown;
var megaphone = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "megaphone",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "megaphone",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,1 C9.83,1 9.64,1.05 9.48,1.14 C8.04,2.02 4.5,4.58 3,5 C1.62,5 0,5.67 0,7.5 C0,9.33 1.63,10 3,10 C3.3,10.08 3.64,10.23 4,10.41 L4,15 L6,15 L6,11.55 C7.34,12.41 8.69,13.38 9.48,13.86 C9.64,13.95 9.82,14 10,14 C10.52,14 11,13.58 11,13 L11,2 C11,1.42 10.52,1 10,1 L10,1 Z M10,13 C9.62,12.77 9.11,12.42 8.5,12 C8.34,11.89 8.17,11.78 8,11.66 L8,3.31 C8.16,3.2 8.31,3.11 8.47,3 C9.08,2.59 9.63,2.23 10,2 L10,13 L10,13 Z M12,7 L16,7 L16,8 L12,8 L12,7 L12,7 Z M12,9 L16,11 L16,12 L12,10 L12,9 L12,9 Z M16,3 L16,4 L12,6 L12,5 L16,3 L16,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,1 C9.83,1 9.64,1.05 9.48,1.14 C8.04,2.02 4.5,4.58 3,5 C1.62,5 0,5.67 0,7.5 C0,9.33 1.63,10 3,10 C3.3,10.08 3.64,10.23 4,10.41 L4,15 L6,15 L6,11.55 C7.34,12.41 8.69,13.38 9.48,13.86 C9.64,13.95 9.82,14 10,14 C10.52,14 11,13.58 11,13 L11,2 C11,1.42 10.52,1 10,1 L10,1 Z M10,13 C9.62,12.77 9.11,12.42 8.5,12 C8.34,11.89 8.17,11.78 8,11.66 L8,3.31 C8.16,3.2 8.31,3.11 8.47,3 C9.08,2.59 9.63,2.23 10,2 L10,13 L10,13 Z M12,7 L16,7 L16,8 L12,8 L12,7 L12,7 Z M12,9 L16,11 L16,12 L12,10 L12,9 L12,9 Z M16,3 L16,4 L12,6 L12,5 L16,3 L16,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.megaphone = megaphone;
var mention = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mention",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mention",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6.58,15 C7.83,15 9.1,14.69 10.14,14.06 L9.72,13.12 C8.88,13.64 7.83,13.95 6.69,13.95 C3.46,13.95 1.05,11.87 1.05,8.23 C1.05,3.86 4.28,1.05 7.63,1.05 C11.08,1.05 12.85,3.24 12.85,6.25 C12.85,8.64 11.51,10.11 10.35,10.11 C9.3,10.11 8.99,9.38 9.3,7.92 L10.03,4.17 L8.98,4.17 L8.87,4.89 C8.46,4.26 7.93,4.06 7.31,4.06 C5.12,4.06 3.65,6.45 3.65,8.44 C3.65,10.11 4.59,11.05 5.95,11.05 C6.79,11.05 7.62,10.52 8.25,9.8 C8.36,10.74 9.19,11.25 10.23,11.25 C11.9,11.25 14,9.58 14,6.25 C14,2.61 11.59,0 7.83,0 C3.66,0 0,3.33 0,8.33 C0,12.71 2.92,15 6.58,15 L6.58,15 Z M6.27,10 C5.54,10 4.91,9.48 4.91,8.33 C4.91,6.88 5.85,5.11 7.32,5.11 C7.84,5.11 8.16,5.31 8.57,5.94 L8.05,8.96 C7.42,9.69 6.8,10.01 6.27,10.01 L6.27,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6.58,15 C7.83,15 9.1,14.69 10.14,14.06 L9.72,13.12 C8.88,13.64 7.83,13.95 6.69,13.95 C3.46,13.95 1.05,11.87 1.05,8.23 C1.05,3.86 4.28,1.05 7.63,1.05 C11.08,1.05 12.85,3.24 12.85,6.25 C12.85,8.64 11.51,10.11 10.35,10.11 C9.3,10.11 8.99,9.38 9.3,7.92 L10.03,4.17 L8.98,4.17 L8.87,4.89 C8.46,4.26 7.93,4.06 7.31,4.06 C5.12,4.06 3.65,6.45 3.65,8.44 C3.65,10.11 4.59,11.05 5.95,11.05 C6.79,11.05 7.62,10.52 8.25,9.8 C8.36,10.74 9.19,11.25 10.23,11.25 C11.9,11.25 14,9.58 14,6.25 C14,2.61 11.59,0 7.83,0 C3.66,0 0,3.33 0,8.33 C0,12.71 2.92,15 6.58,15 L6.58,15 Z M6.27,10 C5.54,10 4.91,9.48 4.91,8.33 C4.91,6.88 5.85,5.11 7.32,5.11 C7.84,5.11 8.16,5.31 8.57,5.94 L8.05,8.96 C7.42,9.69 6.8,10.01 6.27,10.01 L6.27,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mention = mention;
var milestone = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "milestone",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "milestone",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,2 L6,2 L6,0 L8,0 L8,2 L8,2 Z M12,7 L2,7 C1.45,7 1,6.55 1,6 L1,4 C1,3.45 1.45,3 2,3 L12,3 L14,5 L12,7 L12,7 Z M8,4 L6,4 L6,6 L8,6 L8,4 L8,4 Z M6,16 L8,16 L8,8 L6,8 L6,16 L6,16 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,2 L6,2 L6,0 L8,0 L8,2 L8,2 Z M12,7 L2,7 C1.45,7 1,6.55 1,6 L1,4 C1,3.45 1.45,3 2,3 L12,3 L14,5 L12,7 L12,7 Z M8,4 L6,4 L6,6 L8,6 L8,4 L8,4 Z M6,16 L8,16 L8,8 L6,8 L6,16 L6,16 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.milestone = milestone;
var mirror = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mirror",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mirror",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.5,4.7 L8.5,0 L1.5,4.7 C1.2,4.89 1,5.15 1,5.5 L1,16 L8.5,12 L16,16 L16,5.5 C16,5.16 15.8,4.89 15.5,4.7 L15.5,4.7 Z M15,14.5 L9,11.25 L9,10 L8,10 L8,11.25 L2,14.5 L2,5.5 L8,1.5 L8,6 L9,6 L9,1.5 L15,5.5 L15,14.5 L15,14.5 Z M6,7 L11,7 L11,5 L14,8 L11,11 L11,9 L6,9 L6,11 L3,8 L6,5 L6,7 L6,7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.5,4.7 L8.5,0 L1.5,4.7 C1.2,4.89 1,5.15 1,5.5 L1,16 L8.5,12 L16,16 L16,5.5 C16,5.16 15.8,4.89 15.5,4.7 L15.5,4.7 Z M15,14.5 L9,11.25 L9,10 L8,10 L8,11.25 L2,14.5 L2,5.5 L8,1.5 L8,6 L9,6 L9,1.5 L15,5.5 L15,14.5 L15,14.5 Z M6,7 L11,7 L11,5 L14,8 L11,11 L11,9 L6,9 L6,11 L3,8 L6,5 L6,7 L6,7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mirror = mirror;
var mortarBoard = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mortar-board",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mortar-board",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7.83,9.19 L4,8 C8.8817842e-16,1.33226763e-15 4,9.5 4,10.5 C4,11.5 5.8,12 8,12 C10.2,12 12,11.5 12,10.5 L12,8 L8.17,9.19 C8.06,9.22 7.94,9.22 7.81,9.19 L7.83,9.19 L7.83,9.19 Z M8.11,2.8 C8.05,2.78 7.97,2.78 7.91,2.8 L0.27,5.18 C-0.06,5.29 -0.06,5.74 0.27,5.85 L2,6.4 L2,8.17 C1.7,8.34 1.5,8.67 1.5,9.03 C1.5,9.22 1.55,9.39 1.64,9.53 C1.56,9.67 1.5,9.84 1.5,10.03 L1.5,12.61 C1.5,13.16 3.5,13.16 3.5,12.61 L3.5,10.03 C3.5,9.84 3.45,9.67 3.36,9.53 C3.44,9.39 3.5,9.22 3.5,9.03 C3.5,8.65 3.3,8.34 3,8.17 L3,6.72 L7.89,8.25 C7.95,8.27 8.03,8.27 8.09,8.25 L15.73,5.87 C16.06,5.76 16.06,5.31 15.73,5.2 L8.1,2.81 L8.11,2.8 Z M8.02,6 C7.47,6 7.02,5.78 7.02,5.5 C7.02,5.22 7.47,5 8.02,5 C8.57,5 9.02,5.22 9.02,5.5 C9.02,5.78 8.57,6 8.02,6 L8.02,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7.83,9.19 L4,8 C8.8817842e-16,1.33226763e-15 4,9.5 4,10.5 C4,11.5 5.8,12 8,12 C10.2,12 12,11.5 12,10.5 L12,8 L8.17,9.19 C8.06,9.22 7.94,9.22 7.81,9.19 L7.83,9.19 L7.83,9.19 Z M8.11,2.8 C8.05,2.78 7.97,2.78 7.91,2.8 L0.27,5.18 C-0.06,5.29 -0.06,5.74 0.27,5.85 L2,6.4 L2,8.17 C1.7,8.34 1.5,8.67 1.5,9.03 C1.5,9.22 1.55,9.39 1.64,9.53 C1.56,9.67 1.5,9.84 1.5,10.03 L1.5,12.61 C1.5,13.16 3.5,13.16 3.5,12.61 L3.5,10.03 C3.5,9.84 3.45,9.67 3.36,9.53 C3.44,9.39 3.5,9.22 3.5,9.03 C3.5,8.65 3.3,8.34 3,8.17 L3,6.72 L7.89,8.25 C7.95,8.27 8.03,8.27 8.09,8.25 L15.73,5.87 C16.06,5.76 16.06,5.31 15.73,5.2 L8.1,2.81 L8.11,2.8 Z M8.02,6 C7.47,6 7.02,5.78 7.02,5.5 C7.02,5.22 7.47,5 8.02,5 C8.57,5 9.02,5.22 9.02,5.5 C9.02,5.78 8.57,6 8.02,6 L8.02,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mortarBoard = mortarBoard;
var mute = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "mute",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "mute",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,2.81 L8,13.19 C8,13.86 7.19,14.19 6.72,13.72 L3,10 L1,10 C0.45,10 0,9.55 0,9 L0,7 C0,6.45 0.45,6 1,6 L3,6 L6.72,2.28 C7.19,1.81 8,2.14 8,2.81 L8,2.81 Z M15.53,6.03 L14.47,4.97 L12.5,6.94 L10.53,4.97 L9.47,6.03 L11.44,8 L9.47,9.97 L10.53,11.03 L12.5,9.06 L14.47,11.03 L15.53,9.97 L13.56,8 L15.53,6.03 L15.53,6.03 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,2.81 L8,13.19 C8,13.86 7.19,14.19 6.72,13.72 L3,10 L1,10 C0.45,10 0,9.55 0,9 L0,7 C0,6.45 0.45,6 1,6 L3,6 L6.72,2.28 C7.19,1.81 8,2.14 8,2.81 L8,2.81 Z M15.53,6.03 L14.47,4.97 L12.5,6.94 L10.53,4.97 L9.47,6.03 L11.44,8 L9.47,9.97 L10.53,11.03 L12.5,9.06 L14.47,11.03 L15.53,9.97 L13.56,8 L15.53,6.03 L15.53,6.03 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.mute = mute;
var noNewline = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "no-newline",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "no-newline",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M16,5 L16,8 C16,8.55 15.55,9 15,9 L12,9 L12,11 L9,8 L12,5 L12,7 L14,7 L14,5 L16,5 L16,5 Z M8,8 C8,10.2 6.2,12 4,12 C1.8,12 0,10.2 0,8 C0,5.8 1.8,4 4,4 C6.2,4 8,5.8 8,8 L8,8 Z M1.5,9.66 L5.66,5.5 C5.18,5.19 4.61,5 4,5 C2.34,5 1,6.34 1,8 C1,8.61 1.19,9.17 1.5,9.66 L1.5,9.66 Z M7,8 C7,7.39 6.81,6.83 6.5,6.34 L2.34,10.5 C2.82,10.81 3.39,11 4,11 C5.66,11 7,9.66 7,8 L7,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M16,5 L16,8 C16,8.55 15.55,9 15,9 L12,9 L12,11 L9,8 L12,5 L12,7 L14,7 L14,5 L16,5 L16,5 Z M8,8 C8,10.2 6.2,12 4,12 C1.8,12 0,10.2 0,8 C0,5.8 1.8,4 4,4 C6.2,4 8,5.8 8,8 L8,8 Z M1.5,9.66 L5.66,5.5 C5.18,5.19 4.61,5 4,5 C2.34,5 1,6.34 1,8 C1,8.61 1.19,9.17 1.5,9.66 L1.5,9.66 Z M7,8 C7,7.39 6.81,6.83 6.5,6.34 L2.34,10.5 C2.82,10.81 3.39,11 4,11 C5.66,11 7,9.66 7,8 L7,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.noNewline = noNewline;
var note = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "note",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "note",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M3,10 L7,10 L7,9 L3,9 L3,10 L3,10 Z M3,8 L9,8 L9,7 L3,7 L3,8 L3,8 Z M3,6 L11,6 L11,5 L3,5 L3,6 L3,6 Z M13,12 L1,12 L1,3 L13,3 L13,12 L13,12 Z M1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L13,13 C13.55,13 14,12.55 14,12 L14,3 C14,2.45 13.55,2 13,2 L1,2 L1,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M3,10 L7,10 L7,9 L3,9 L3,10 L3,10 Z M3,8 L9,8 L9,7 L3,7 L3,8 L3,8 Z M3,6 L11,6 L11,5 L3,5 L3,6 L3,6 Z M13,12 L1,12 L1,3 L13,3 L13,12 L13,12 Z M1,2 C0.45,2 0,2.45 0,3 L0,12 C0,12.55 0.45,13 1,13 L13,13 C13.55,13 14,12.55 14,12 L14,3 C14,2.45 13.55,2 13,2 L1,2 L1,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.note = note;
var octoface = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "octoface",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "octoface",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14.7,5.34 C14.83,5.02 15.25,3.75 14.57,2.03 C14.57,2.03 13.52,1.7 11.13,3.33 C10.13,3.05 9.06,3.01 8,3.01 C6.94,3.01 5.87,3.05 4.87,3.33 C2.48,1.69 1.43,2.03 1.43,2.03 C0.75,3.75 1.17,5.02 1.3,5.34 C0.49,6.21 0,7.33 0,8.69 C0,13.84 3.33,15 7.98,15 C12.63,15 16,13.84 16,8.69 C16,7.33 15.51,6.21 14.7,5.34 L14.7,5.34 Z M8,14.02 C4.7,14.02 2.02,13.87 2.02,10.67 C2.02,9.91 2.4,9.19 3.04,8.6 C4.11,7.62 5.94,8.14 8,8.14 C10.07,8.14 11.88,7.62 12.96,8.6 C13.61,9.19 13.98,9.9 13.98,10.67 C13.98,13.86 11.3,14.02 8,14.02 L8,14.02 Z M5.49,9.01 C4.83,9.01 4.29,9.81 4.29,10.79 C4.29,11.77 4.83,12.58 5.49,12.58 C6.15,12.58 6.69,11.78 6.69,10.79 C6.69,9.8 6.15,9.01 5.49,9.01 L5.49,9.01 Z M10.51,9.01 C9.85,9.01 9.31,9.8 9.31,10.79 C9.31,11.78 9.85,12.58 10.51,12.58 C11.17,12.58 11.71,11.78 11.71,10.79 C11.71,9.8 11.18,9.01 10.51,9.01 L10.51,9.01 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14.7,5.34 C14.83,5.02 15.25,3.75 14.57,2.03 C14.57,2.03 13.52,1.7 11.13,3.33 C10.13,3.05 9.06,3.01 8,3.01 C6.94,3.01 5.87,3.05 4.87,3.33 C2.48,1.69 1.43,2.03 1.43,2.03 C0.75,3.75 1.17,5.02 1.3,5.34 C0.49,6.21 0,7.33 0,8.69 C0,13.84 3.33,15 7.98,15 C12.63,15 16,13.84 16,8.69 C16,7.33 15.51,6.21 14.7,5.34 L14.7,5.34 Z M8,14.02 C4.7,14.02 2.02,13.87 2.02,10.67 C2.02,9.91 2.4,9.19 3.04,8.6 C4.11,7.62 5.94,8.14 8,8.14 C10.07,8.14 11.88,7.62 12.96,8.6 C13.61,9.19 13.98,9.9 13.98,10.67 C13.98,13.86 11.3,14.02 8,14.02 L8,14.02 Z M5.49,9.01 C4.83,9.01 4.29,9.81 4.29,10.79 C4.29,11.77 4.83,12.58 5.49,12.58 C6.15,12.58 6.69,11.78 6.69,10.79 C6.69,9.8 6.15,9.01 5.49,9.01 L5.49,9.01 Z M10.51,9.01 C9.85,9.01 9.31,9.8 9.31,10.79 C9.31,11.78 9.85,12.58 10.51,12.58 C11.17,12.58 11.71,11.78 11.71,10.79 C11.71,9.8 11.18,9.01 10.51,9.01 L10.51,9.01 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.octoface = octoface;
var organization = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "organization",
        "fill": "#221F20"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "organization",
          "fill": "#221F20"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M16,12.999 C16,13.438 15.55,13.999 15,13.999 L7.995,13.999 C7.456,13.999 7.001,13.552 7,13 L1,13 C0.46,13 0,12.439 0,12 C0,9.366 3,8 3,8 C3,8 3.229,7.591 3,7 C2.159,6.379 1.942,6.41 2,4 C2.058,1.581 3.367,1 4.5,1 C5.633,1 6.942,1.58 7,4 C7.058,6.41 6.841,6.379 6,7 C5.771,7.59 6,8 6,8 C6,8 7.549,8.711 8.42,10.088 C9.196,9.369 10,8.999 10,8.999 C10,8.999 10.229,8.59 10,7.999 C9.159,7.379 8.942,7.409 9,4.999 C9.058,2.58 10.367,1.999 11.5,1.999 C12.633,1.999 13.937,2.58 13.995,4.999 C14.054,7.409 13.837,7.379 12.995,7.999 C12.766,8.589 12.995,8.999 12.995,8.999 C12.995,8.999 16,10.365 16,12.999",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M16,12.999 C16,13.438 15.55,13.999 15,13.999 L7.995,13.999 C7.456,13.999 7.001,13.552 7,13 L1,13 C0.46,13 0,12.439 0,12 C0,9.366 3,8 3,8 C3,8 3.229,7.591 3,7 C2.159,6.379 1.942,6.41 2,4 C2.058,1.581 3.367,1 4.5,1 C5.633,1 6.942,1.58 7,4 C7.058,6.41 6.841,6.379 6,7 C5.771,7.59 6,8 6,8 C6,8 7.549,8.711 8.42,10.088 C9.196,9.369 10,8.999 10,8.999 C10,8.999 10.229,8.59 10,7.999 C9.159,7.379 8.942,7.409 9,4.999 C9.058,2.58 10.367,1.999 11.5,1.999 C12.633,1.999 13.937,2.58 13.995,4.999 C14.054,7.409 13.837,7.379 12.995,7.999 C12.766,8.589 12.995,8.999 12.995,8.999 C12.995,8.999 16,10.365 16,12.999",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.organization = organization;
var packageIcon = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "package",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "package",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M1,4.27 L1,11.74 C1,12.19 1.3,12.58 1.75,12.71 L8.25,14.44 C8.41,14.49 8.59,14.49 8.75,14.44 L15.25,12.71 C15.7,12.58 16,12.19 16,11.74 L16,4.27 C16,3.82 15.7,3.43 15.25,3.3 L8.75,1.56 C8.59,1.53 8.41,1.53 8.25,1.56 L1.75,3.3 C1.3,3.43 1,3.82 1,4.27 L1,4.27 Z M8,13.36 L2,11.77 L2,5 L8,6.61 L8,13.36 L8,13.36 Z M2,4 L4.5,3.33 L11,5.06 L8.5,5.73 L2,4 L2,4 Z M15,11.77 L9,13.36 L9,6.61 L11,6.06 L11,8.5 L13,7.97 L13,5.53 L15,5 L15,11.77 L15,11.77 Z M13,4.53 L6.5,2.8 L8.5,2.27 L15,4 L13,4.53 L13,4.53 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M1,4.27 L1,11.74 C1,12.19 1.3,12.58 1.75,12.71 L8.25,14.44 C8.41,14.49 8.59,14.49 8.75,14.44 L15.25,12.71 C15.7,12.58 16,12.19 16,11.74 L16,4.27 C16,3.82 15.7,3.43 15.25,3.3 L8.75,1.56 C8.59,1.53 8.41,1.53 8.25,1.56 L1.75,3.3 C1.3,3.43 1,3.82 1,4.27 L1,4.27 Z M8,13.36 L2,11.77 L2,5 L8,6.61 L8,13.36 L8,13.36 Z M2,4 L4.5,3.33 L11,5.06 L8.5,5.73 L2,4 L2,4 Z M15,11.77 L9,13.36 L9,6.61 L11,6.06 L11,8.5 L13,7.97 L13,5.53 L15,5 L15,11.77 L15,11.77 Z M13,4.53 L6.5,2.8 L8.5,2.27 L15,4 L13,4.53 L13,4.53 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.packageIcon = packageIcon;
var paintcan = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "paintcan",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "paintcan",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,0 C2.69,0 0,2.69 0,6 L0,7 C0,7.55 0.45,8 1,8 L1,13 C1,14.1 3.24,15 6,15 C8.76,15 11,14.1 11,13 L11,8 C11.55,8 12,7.55 12,7 L12,6 C12,2.69 9.31,0 6,0 L6,0 Z M9,10 L9,10.5 C9,10.78 8.78,11 8.5,11 C8.22,11 8,10.78 8,10.5 L8,10 C8,9.72 7.78,9.5 7.5,9.5 C7.22,9.5 7,9.72 7,10 L7,12.5 C7,12.78 6.78,13 6.5,13 C6.22,13 6,12.78 6,12.5 L6,10.5 C6,10.22 5.78,10 5.5,10 C5.22,10 5,10.22 5,10.5 L5,11 C5,11.55 4.55,12 4,12 C3.45,12 3,11.55 3,11 L3,10 C2.45,10 2,9.55 2,9 L2,7.2 C2.91,7.69 4.36,8 6,8 C7.64,8 9.09,7.69 10,7.2 L10,9 C10,9.55 9.55,10 9,10 L9,10 Z M6,7 C4.32,7 2.88,6.59 2.29,6 C2.88,5.41 4.32,5 6,5 C7.68,5 9.12,5.41 9.71,6 C9.12,6.59 7.68,7 6,7 L6,7 Z M6,4 C3.24,4 1,4.89 1,6 L1,6 C1,3.24 3.24,1 6,1 C8.76,1 11,3.24 11,6 C11,4.9 8.76,4 6,4 L6,4 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,0 C2.69,0 0,2.69 0,6 L0,7 C0,7.55 0.45,8 1,8 L1,13 C1,14.1 3.24,15 6,15 C8.76,15 11,14.1 11,13 L11,8 C11.55,8 12,7.55 12,7 L12,6 C12,2.69 9.31,0 6,0 L6,0 Z M9,10 L9,10.5 C9,10.78 8.78,11 8.5,11 C8.22,11 8,10.78 8,10.5 L8,10 C8,9.72 7.78,9.5 7.5,9.5 C7.22,9.5 7,9.72 7,10 L7,12.5 C7,12.78 6.78,13 6.5,13 C6.22,13 6,12.78 6,12.5 L6,10.5 C6,10.22 5.78,10 5.5,10 C5.22,10 5,10.22 5,10.5 L5,11 C5,11.55 4.55,12 4,12 C3.45,12 3,11.55 3,11 L3,10 C2.45,10 2,9.55 2,9 L2,7.2 C2.91,7.69 4.36,8 6,8 C7.64,8 9.09,7.69 10,7.2 L10,9 C10,9.55 9.55,10 9,10 L9,10 Z M6,7 C4.32,7 2.88,6.59 2.29,6 C2.88,5.41 4.32,5 6,5 C7.68,5 9.12,5.41 9.71,6 C9.12,6.59 7.68,7 6,7 L6,7 Z M6,4 C3.24,4 1,4.89 1,6 L1,6 C1,3.24 3.24,1 6,1 C8.76,1 11,3.24 11,6 C11,4.9 8.76,4 6,4 L6,4 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.paintcan = paintcan;
var pencil = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "pencil",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "pencil",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M0,12 L0,15 L3,15 L11,7 L8,4 L0,12 L0,12 Z M3,14 L1,14 L1,12 L2,12 L2,13 L3,13 L3,14 L3,14 Z M13.3,4.7 L12,6 L9,3 L10.3,1.7 C10.69,1.31 11.32,1.31 11.71,1.7 L13.3,3.29 C13.69,3.68 13.69,4.31 13.3,4.7 L13.3,4.7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M0,12 L0,15 L3,15 L11,7 L8,4 L0,12 L0,12 Z M3,14 L1,14 L1,12 L2,12 L2,13 L3,13 L3,14 L3,14 Z M13.3,4.7 L12,6 L9,3 L10.3,1.7 C10.69,1.31 11.32,1.31 11.71,1.7 L13.3,3.29 C13.69,3.68 13.69,4.31 13.3,4.7 L13.3,4.7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.pencil = pencil;
var person = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "person",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "person",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,14.002 C12,14.553 11.553,15 11.002,15 L1.001,15 C0.448,15 0,14.552 0,13.999 L0,13 C0,10.367 4,9 4,9 C4,9 4.229,8.591 4,8 C3.159,7.38 3.056,6.41 3,4 C3.173,1.587 4.867,1 6,1 C7.133,1 8.827,1.586 9,4 C8.944,6.41 8.841,7.38 8,8 C7.771,8.59 8,9 8,9 C8,9 12,10.367 12,13 L12,14.002 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,14.002 C12,14.553 11.553,15 11.002,15 L1.001,15 C0.448,15 0,14.552 0,13.999 L0,13 C0,10.367 4,9 4,9 C4,9 4.229,8.591 4,8 C3.159,7.38 3.056,6.41 3,4 C3.173,1.587 4.867,1 6,1 C7.133,1 8.827,1.586 9,4 C8.944,6.41 8.841,7.38 8,8 C7.771,8.59 8,9 8,9 C8,9 12,10.367 12,13 L12,14.002 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.person = person;
var pin = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "pin",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "pin",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,1.2 L10,2 L10.5,3 L6,6 L2.2,6 C1.76,6 1.53,6.53 1.86,6.86 L5,10 L1,15 L6,11 L9.14,14.14 C9.47,14.47 10,14.23 10,13.8 L10,10 L13,5.5 L14,6 L14.8,6 C15.24,6 15.47,5.47 15.14,5.14 L10.86,0.86 C10.53,0.53 10,0.77 10,1.2 L10,1.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,1.2 L10,2 L10.5,3 L6,6 L2.2,6 C1.76,6 1.53,6.53 1.86,6.86 L5,10 L1,15 L6,11 L9.14,14.14 C9.47,14.47 10,14.23 10,13.8 L10,10 L13,5.5 L14,6 L14.8,6 C15.24,6 15.47,5.47 15.14,5.14 L10.86,0.86 C10.53,0.53 10,0.77 10,1.2 L10,1.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.pin = pin;
var plug = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "plug",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "plug",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,6 L14,5 L10,5 L10,3 L8,3 L8,4 L6,4 C4.97,4 4.23,4.81 4,6 L3,7 C1.34,7 0,8.34 0,10 L0,12 L1,12 L1,10 C1,8.89 1.89,8 3,8 L4,9 C4.25,10.16 4.98,11 6,11 L8,11 L8,12 L10,12 L10,10 L14,10 L14,9 L10,9 L10,6 L14,6 L14,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,6 L14,5 L10,5 L10,3 L8,3 L8,4 L6,4 C4.97,4 4.23,4.81 4,6 L3,7 C1.34,7 0,8.34 0,10 L0,12 L1,12 L1,10 C1,8.89 1.89,8 3,8 L4,9 C4.25,10.16 4.98,11 6,11 L8,11 L8,12 L10,12 L10,10 L14,10 L14,9 L10,9 L10,6 L14,6 L14,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.plug = plug;
var plusSmall = {
  "viewBox": "0 0 7 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "plus-small",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "plus-small",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,7 L4,4 L3,4 L3,7 L0,7 L0,8 L3,8 L3,11 L4,11 L4,8 L7,8 L7,7 L4,7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,7 L4,4 L3,4 L3,7 L0,7 L0,8 L3,8 L3,11 L4,11 L4,8 L7,8 L7,7 L4,7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.plusSmall = plusSmall;
var plus = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "plus",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "plus",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "12 9 7 9 7 14 5 14 5 9 0 9 0 7 5 7 5 2 7 2 7 7 12 7"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "12 9 7 9 7 14 5 14 5 9 0 9 0 7 5 7 5 2 7 2 7 7 12 7"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.plus = plus;
var primitiveDot = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "primitive-dot",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "primitive-dot",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M0,8 C0,5.8 1.8,4 4,4 C6.2,4 8,5.8 8,8 C8,10.2 6.2,12 4,12 C1.8,12 0,10.2 0,8 L0,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M0,8 C0,5.8 1.8,4 4,4 C6.2,4 8,5.8 8,8 C8,10.2 6.2,12 4,12 C1.8,12 0,10.2 0,8 L0,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.primitiveDot = primitiveDot;
var primitiveSquare = {
  "viewBox": "0 0 8 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "primitive-square",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "primitive-square",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "8 12 0 12 0 4 8 4"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "8 12 0 12 0 4 8 4"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.primitiveSquare = primitiveSquare;
var project = {
  "viewBox": "0 0 15 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "project",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "project",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,12 L13,12 L13,2 L10,2 L10,12 L10,12 Z M6,10 L9,10 L9,2 L6,2 L6,10 L6,10 Z M2,14 L5,14 L5,2 L2,2 L2,14 L2,14 Z M1,15 L14,15 L14,1 L1,1 L1,15 L1,15 Z M14,0 L1,0 C0.448,0 0,0.448 0,1 L0,15 C0,15.552 0.448,16 1,16 L14,16 C14.552,16 15,15.552 15,15 L15,1 C15,0.448 14.552,0 14,0 L14,0 L14,0 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,12 L13,12 L13,2 L10,2 L10,12 L10,12 Z M6,10 L9,10 L9,2 L6,2 L6,10 L6,10 Z M2,14 L5,14 L5,2 L2,2 L2,14 L2,14 Z M1,15 L14,15 L14,1 L1,1 L1,15 L1,15 Z M14,0 L1,0 C0.448,0 0,0.448 0,1 L0,15 C0,15.552 0.448,16 1,16 L14,16 C14.552,16 15,15.552 15,15 L15,1 C15,0.448 14.552,0 14,0 L14,0 L14,0 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.project = project;
var pulse = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "pulse",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "pulse",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "11.5 8 8.8 5.4 6.6 8.5 5.5 1.6 2.38 8 0 8 0 10 3.6 10 4.5 8.2 5.4 13.6 9 8.5 10.6 10 14 10 14 8"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "11.5 8 8.8 5.4 6.6 8.5 5.5 1.6 2.38 8 0 8 0 10 3.6 10 4.5 8.2 5.4 13.6 9 8.5 10.6 10 14 10 14 8"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.pulse = pulse;
var question = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "question",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "question",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,10 L8,10 L8,12 L6,12 L6,10 L6,10 Z M10,6.5 C10,8.64 8,9 8,9 L6,9 C6,8.45 6.45,8 7,8 L7.5,8 C7.78,8 8,7.78 8,7.5 L8,6.5 C8,6.22 7.78,6 7.5,6 L6.5,6 C6.22,6 6,6.22 6,6.5 L6,7 L4,7 C4,5.5 5.5,4 7,4 C8.5,4 10,5 10,6.5 L10,6.5 Z M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,10 L8,10 L8,12 L6,12 L6,10 L6,10 Z M10,6.5 C10,8.64 8,9 8,9 L6,9 C6,8.45 6.45,8 7,8 L7.5,8 C7.78,8 8,7.78 8,7.5 L8,6.5 C8,6.22 7.78,6 7.5,6 L6.5,6 C6.22,6 6,6.22 6,6.5 L6,7 L4,7 C4,5.5 5.5,4 7,4 C8.5,4 10,5 10,6.5 L10,6.5 Z M7,2.3 C10.14,2.3 12.7,4.86 12.7,8 C12.7,11.14 10.14,13.7 7,13.7 C3.86,13.7 1.3,11.14 1.3,8 C1.3,4.86 3.86,2.3 7,2.3 L7,2.3 Z M7,1 C3.14,1 0,4.14 0,8 C0,11.86 3.14,15 7,15 C10.86,15 14,11.86 14,8 C14,4.14 10.86,1 7,1 L7,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.question = question;
var quote = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "quote",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "quote",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6.16,3.50000004 C3.73,5.06000004 2.55,6.67000004 2.55,9.36000004 C2.71,9.31000004 2.85,9.31000004 2.99,9.31000004 C4.26,9.31000004 5.49,10.17 5.49,11.72 C5.49,13.33 4.46,14.33 2.99,14.33 C1.09,14.33 0,12.81 0,10.08 C0,6.28000004 1.75,3.55000004 5.02,1.66000004 L6.16,3.50000004 L6.16,3.50000004 Z M13.16,3.50000004 C10.73,5.06000004 9.55,6.67000004 9.55,9.36000004 C9.71,9.31000004 9.85,9.31000004 9.99,9.31000004 C11.26,9.31000004 12.49,10.17 12.49,11.72 C12.49,13.33 11.46,14.33 9.99,14.33 C8.1,14.33 7.01,12.81 7.01,10.08 C7.01,6.28000004 8.76,3.55000004 12.03,1.66000004 L13.17,3.50000004 L13.16,3.50000004 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6.16,3.50000004 C3.73,5.06000004 2.55,6.67000004 2.55,9.36000004 C2.71,9.31000004 2.85,9.31000004 2.99,9.31000004 C4.26,9.31000004 5.49,10.17 5.49,11.72 C5.49,13.33 4.46,14.33 2.99,14.33 C1.09,14.33 0,12.81 0,10.08 C0,6.28000004 1.75,3.55000004 5.02,1.66000004 L6.16,3.50000004 L6.16,3.50000004 Z M13.16,3.50000004 C10.73,5.06000004 9.55,6.67000004 9.55,9.36000004 C9.71,9.31000004 9.85,9.31000004 9.99,9.31000004 C11.26,9.31000004 12.49,10.17 12.49,11.72 C12.49,13.33 11.46,14.33 9.99,14.33 C8.1,14.33 7.01,12.81 7.01,10.08 C7.01,6.28000004 8.76,3.55000004 12.03,1.66000004 L13.17,3.50000004 L13.16,3.50000004 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.quote = quote;
var radioTower = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "radio-tower",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "radio-tower",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4.79,6.11 C5.04,5.86 5.04,5.44 4.79,5.19 C4.47,4.86 4.31,4.43 4.31,4 C4.31,3.57 4.47,3.14 4.79,2.81 C5.04,2.55 5.04,2.14 4.79,1.89 C4.67,1.76 4.5,1.7 4.34,1.7 C4.18,1.7 4.01,1.76 3.89,1.89 C3.32,2.47 3.04,3.24 3.04,4 C3.04,4.76 3.33,5.53 3.89,6.11 C4.14,6.36 4.55,6.36 4.79,6.11 L4.79,6.11 Z M2.33,0.52 C2.2,0.39 2.04,0.33 1.87,0.33 C1.71,0.33 1.54,0.39 1.41,0.52 C0.48,1.48 0.01,2.74 0.01,3.99 C0.01,5.25 0.48,6.51 1.41,7.47 C1.66,7.73 2.07,7.73 2.32,7.47 C2.57,7.21 2.57,6.79 2.32,6.53 C1.64,5.83 1.3,4.91 1.3,3.99 C1.3,3.07 1.64,2.15 2.32,1.45 C2.58,1.2 2.58,0.78 2.33,0.52 L2.33,0.52 Z M8.02,5.62 C8.92,5.62 9.64,4.89 9.64,4 C9.64,3.1 8.91,2.38 8.02,2.38 C7.12,2.38 6.4,3.11 6.4,4 C6.39,4.89 7.12,5.62 8.02,5.62 L8.02,5.62 Z M14.59,0.53 C14.34,0.27 13.93,0.27 13.68,0.53 C13.43,0.79 13.43,1.21 13.68,1.47 C14.36,2.17 14.7,3.09 14.7,4.01 C14.7,4.93 14.36,5.84 13.68,6.55 C13.43,6.81 13.43,7.23 13.68,7.49 C13.81,7.62 13.97,7.68 14.14,7.68 C14.3,7.68 14.47,7.62 14.6,7.49 C15.53,6.53 16,5.27 16,4.01 C15.99,2.75 15.52,1.49 14.59,0.53 L14.59,0.53 Z M8.02,6.92 L8.02,6.92 C7.61,6.92 7.19,6.82 6.82,6.62 L3.67,14.99 L5.16,14.99 L6.02,13.99 L10.02,13.99 L10.86,14.99 L12.35,14.99 L9.21,6.62 C8.83,6.82 8.43,6.92 8.02,6.92 L8.02,6.92 Z M8.01,7.4 L9.02,11 L7.02,11 L8.01,7.4 L8.01,7.4 Z M6.02,12.99 L7.02,11.99 L9.02,11.99 L10.02,12.99 L6.02,12.99 L6.02,12.99 Z M11.21,1.89 C10.96,2.14 10.96,2.56 11.21,2.81 C11.53,3.14 11.69,3.57 11.69,4 C11.69,4.43 11.53,4.86 11.21,5.19 C10.96,5.45 10.96,5.86 11.21,6.11 C11.33,6.24 11.5,6.3 11.66,6.3 C11.82,6.3 11.98,6.24 12.11,6.11 C12.68,5.53 12.96,4.76 12.96,4 C12.96,3.24 12.68,2.47 12.11,1.89 C11.86,1.64 11.45,1.64 11.21,1.89 L11.21,1.89 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4.79,6.11 C5.04,5.86 5.04,5.44 4.79,5.19 C4.47,4.86 4.31,4.43 4.31,4 C4.31,3.57 4.47,3.14 4.79,2.81 C5.04,2.55 5.04,2.14 4.79,1.89 C4.67,1.76 4.5,1.7 4.34,1.7 C4.18,1.7 4.01,1.76 3.89,1.89 C3.32,2.47 3.04,3.24 3.04,4 C3.04,4.76 3.33,5.53 3.89,6.11 C4.14,6.36 4.55,6.36 4.79,6.11 L4.79,6.11 Z M2.33,0.52 C2.2,0.39 2.04,0.33 1.87,0.33 C1.71,0.33 1.54,0.39 1.41,0.52 C0.48,1.48 0.01,2.74 0.01,3.99 C0.01,5.25 0.48,6.51 1.41,7.47 C1.66,7.73 2.07,7.73 2.32,7.47 C2.57,7.21 2.57,6.79 2.32,6.53 C1.64,5.83 1.3,4.91 1.3,3.99 C1.3,3.07 1.64,2.15 2.32,1.45 C2.58,1.2 2.58,0.78 2.33,0.52 L2.33,0.52 Z M8.02,5.62 C8.92,5.62 9.64,4.89 9.64,4 C9.64,3.1 8.91,2.38 8.02,2.38 C7.12,2.38 6.4,3.11 6.4,4 C6.39,4.89 7.12,5.62 8.02,5.62 L8.02,5.62 Z M14.59,0.53 C14.34,0.27 13.93,0.27 13.68,0.53 C13.43,0.79 13.43,1.21 13.68,1.47 C14.36,2.17 14.7,3.09 14.7,4.01 C14.7,4.93 14.36,5.84 13.68,6.55 C13.43,6.81 13.43,7.23 13.68,7.49 C13.81,7.62 13.97,7.68 14.14,7.68 C14.3,7.68 14.47,7.62 14.6,7.49 C15.53,6.53 16,5.27 16,4.01 C15.99,2.75 15.52,1.49 14.59,0.53 L14.59,0.53 Z M8.02,6.92 L8.02,6.92 C7.61,6.92 7.19,6.82 6.82,6.62 L3.67,14.99 L5.16,14.99 L6.02,13.99 L10.02,13.99 L10.86,14.99 L12.35,14.99 L9.21,6.62 C8.83,6.82 8.43,6.92 8.02,6.92 L8.02,6.92 Z M8.01,7.4 L9.02,11 L7.02,11 L8.01,7.4 L8.01,7.4 Z M6.02,12.99 L7.02,11.99 L9.02,11.99 L10.02,12.99 L6.02,12.99 L6.02,12.99 Z M11.21,1.89 C10.96,2.14 10.96,2.56 11.21,2.81 C11.53,3.14 11.69,3.57 11.69,4 C11.69,4.43 11.53,4.86 11.21,5.19 C10.96,5.45 10.96,5.86 11.21,6.11 C11.33,6.24 11.5,6.3 11.66,6.3 C11.82,6.3 11.98,6.24 12.11,6.11 C12.68,5.53 12.96,4.76 12.96,4 C12.96,3.24 12.68,2.47 12.11,1.89 C11.86,1.64 11.45,1.64 11.21,1.89 L11.21,1.89 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.radioTower = radioTower;
var reply = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "reply",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "reply",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,3.5 C9.92,3.94 14,6.625 14,13.5 C11.688,8.438 9.25,7.5 6,7.5 L6,11 L0.5,5.5 L6,0 L6,3.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,3.5 C9.92,3.94 14,6.625 14,13.5 C11.688,8.438 9.25,7.5 6,7.5 L6,11 L0.5,5.5 L6,0 L6,3.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.reply = reply;
var repoClone = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo-clone",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo-clone",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15,0 L9,0 L9,7 C9,7.55 9.45,8 10,8 L11,8 L11,9 L12,9 L12,8 L15,8 C15.55,8 16,7.55 16,7 L16,1 C16,0.45 15.55,0 15,0 L15,0 Z M11,7 L10,7 L10,6 L11,6 L11,7 L11,7 Z M15,7 L12,7 L12,6 L15,6 L15,7 L15,7 Z M15,5 L11,5 L11,1 L15,1 L15,5 L15,5 Z M4,5 L3,5 L3,4 L4,4 L4,5 L4,5 Z M4,3 L3,3 L3,2 L4,2 L4,3 L4,3 Z M2,1 L8,1 L8,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L3,14 L3,16 L4.5,14.5 L6,16 L6,14 L11,14 C11.55,14 12,13.55 12,13 L12,10 L2,10 L2,1 L2,1 Z M11,11 L11,13 L6,13 L6,12 L3,12 L3,13 L1,13 L1,11 L11,11 L11,11 Z M3,8 L4,8 L4,9 L3,9 L3,8 L3,8 Z M4,7 L3,7 L3,6 L4,6 L4,7 L4,7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15,0 L9,0 L9,7 C9,7.55 9.45,8 10,8 L11,8 L11,9 L12,9 L12,8 L15,8 C15.55,8 16,7.55 16,7 L16,1 C16,0.45 15.55,0 15,0 L15,0 Z M11,7 L10,7 L10,6 L11,6 L11,7 L11,7 Z M15,7 L12,7 L12,6 L15,6 L15,7 L15,7 Z M15,5 L11,5 L11,1 L15,1 L15,5 L15,5 Z M4,5 L3,5 L3,4 L4,4 L4,5 L4,5 Z M4,3 L3,3 L3,2 L4,2 L4,3 L4,3 Z M2,1 L8,1 L8,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L3,14 L3,16 L4.5,14.5 L6,16 L6,14 L11,14 C11.55,14 12,13.55 12,13 L12,10 L2,10 L2,1 L2,1 Z M11,11 L11,13 L6,13 L6,12 L3,12 L3,13 L1,13 L1,11 L11,11 L11,11 Z M3,8 L4,8 L4,9 L3,9 L3,8 L3,8 Z M4,7 L3,7 L3,6 L4,6 L4,7 L4,7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repoClone = repoClone;
var repoForcePush = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo-force-push",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo-force-push",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,9 L8,9 L8,16 L6,16 L6,9 L4,9 L6.25,6 L4,6 L7,2 L10,6 L7.75,6 L10,9 L10,9 Z M11,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L5,14 L5,13 L1,13 L1,11 L5,11 L5,10 L2,10 L2,1 L11,1 L11,10 L9,10 L9,11 L11,11 L11,13 L9,13 L9,14 L11,14 C11.55,14 12,13.55 12,13 L12,1 C12,0.45 11.55,0 11,0 L11,0 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,9 L8,9 L8,16 L6,16 L6,9 L4,9 L6.25,6 L4,6 L7,2 L10,6 L7.75,6 L10,9 L10,9 Z M11,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L5,14 L5,13 L1,13 L1,11 L5,11 L5,10 L2,10 L2,1 L11,1 L11,10 L9,10 L9,11 L11,11 L11,13 L9,13 L9,14 L11,14 C11.55,14 12,13.55 12,13 L12,1 C12,0.45 11.55,0 11,0 L11,0 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repoForcePush = repoForcePush;
var repoForked = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo-forked",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo-forked",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,1 C6.89,1 6,1.89 6,3 C6,3.73 6.41,4.38 7,4.72 L7,6 L5,8 L3,6 L3,4.72 C3.59,4.38 4,3.74 4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,6.5 L4,9.5 L4,11.28 C3.41,11.62 3,12.26 3,13 C3,14.11 3.89,15 5,15 C6.11,15 7,14.11 7,13 C7,12.27 6.59,11.62 6,11.28 L6,9.5 L9,6.5 L9,4.72 C9.59,4.38 10,3.74 10,3 C10,1.89 9.11,1 8,1 L8,1 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z M5,14.2 C4.34,14.2 3.8,13.65 3.8,13 C3.8,12.35 4.35,11.8 5,11.8 C5.65,11.8 6.2,12.35 6.2,13 C6.2,13.65 5.65,14.2 5,14.2 L5,14.2 Z M8,4.2 C7.34,4.2 6.8,3.65 6.8,3 C6.8,2.35 7.35,1.8 8,1.8 C8.65,1.8 9.2,2.35 9.2,3 C9.2,3.65 8.65,4.2 8,4.2 L8,4.2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,1 C6.89,1 6,1.89 6,3 C6,3.73 6.41,4.38 7,4.72 L7,6 L5,8 L3,6 L3,4.72 C3.59,4.38 4,3.74 4,3 C4,1.89 3.11,1 2,1 C0.89,1 0,1.89 0,3 C0,3.73 0.41,4.38 1,4.72 L1,6.5 L4,9.5 L4,11.28 C3.41,11.62 3,12.26 3,13 C3,14.11 3.89,15 5,15 C6.11,15 7,14.11 7,13 C7,12.27 6.59,11.62 6,11.28 L6,9.5 L9,6.5 L9,4.72 C9.59,4.38 10,3.74 10,3 C10,1.89 9.11,1 8,1 L8,1 Z M2,4.2 C1.34,4.2 0.8,3.65 0.8,3 C0.8,2.35 1.35,1.8 2,1.8 C2.65,1.8 3.2,2.35 3.2,3 C3.2,3.65 2.65,4.2 2,4.2 L2,4.2 Z M5,14.2 C4.34,14.2 3.8,13.65 3.8,13 C3.8,12.35 4.35,11.8 5,11.8 C5.65,11.8 6.2,12.35 6.2,13 C6.2,13.65 5.65,14.2 5,14.2 L5,14.2 Z M8,4.2 C7.34,4.2 6.8,3.65 6.8,3 C6.8,2.35 7.35,1.8 8,1.8 C8.65,1.8 9.2,2.35 9.2,3 C9.2,3.65 8.65,4.2 8,4.2 L8,4.2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repoForked = repoForked;
var repoPull = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo-pull",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo-pull",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,8 L13,6 L7,6 L7,4 L13,4 L13,2 L16,5 L13,8 L13,8 Z M4,2 L3,2 L3,3 L4,3 L4,2 L4,2 Z M11,7 L12,7 L12,13 C12,13.55 11.55,14 11,14 L6,14 L6,16 L4.5,14.5 L3,16 L3,14 L1,14 C0.45,14 0,13.55 0,13 L0,1 C0,0.45 0.45,0 1,0 L11,0 C11.55,0 12,0.45 12,1 L12,3 L11,3 L11,1 L2,1 L2,10 L11,10 L11,7 L11,7 Z M11,11 L1,11 L1,13 L3,13 L3,12 L6,12 L6,13 L11,13 L11,11 L11,11 Z M4,6 L3,6 L3,7 L4,7 L4,6 L4,6 Z M4,4 L3,4 L3,5 L4,5 L4,4 L4,4 Z M3,9 L4,9 L4,8 L3,8 L3,9 L3,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,8 L13,6 L7,6 L7,4 L13,4 L13,2 L16,5 L13,8 L13,8 Z M4,2 L3,2 L3,3 L4,3 L4,2 L4,2 Z M11,7 L12,7 L12,13 C12,13.55 11.55,14 11,14 L6,14 L6,16 L4.5,14.5 L3,16 L3,14 L1,14 C0.45,14 0,13.55 0,13 L0,1 C0,0.45 0.45,0 1,0 L11,0 C11.55,0 12,0.45 12,1 L12,3 L11,3 L11,1 L2,1 L2,10 L11,10 L11,7 L11,7 Z M11,11 L1,11 L1,13 L3,13 L3,12 L6,12 L6,13 L11,13 L11,11 L11,11 Z M4,6 L3,6 L3,7 L4,7 L4,6 L4,6 Z M4,4 L3,4 L3,5 L4,5 L4,4 L4,4 Z M3,9 L4,9 L4,8 L3,8 L3,9 L3,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repoPull = repoPull;
var repoPush = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo-push",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo-push",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,3 L3,3 L3,2 L4,2 L4,3 L4,3 Z M3,5 L4,5 L4,4 L3,4 L3,5 L3,5 Z M7,5 L4,9 L6,9 L6,16 L8,16 L8,9 L10,9 L7,5 L7,5 Z M11,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L5,14 L5,13 L1,13 L1,11 L5,11 L5,10 L2,10 L2,1 L11.02,1 L11,10 L9,10 L9,11 L11,11 L11,13 L9,13 L9,14 L11,14 C11.55,14 12,13.55 12,13 L12,1 C12,0.45 11.55,0 11,0 L11,0 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,3 L3,3 L3,2 L4,2 L4,3 L4,3 Z M3,5 L4,5 L4,4 L3,4 L3,5 L3,5 Z M7,5 L4,9 L6,9 L6,16 L8,16 L8,9 L10,9 L7,5 L7,5 Z M11,0 L1,0 C0.45,0 0,0.45 0,1 L0,13 C0,13.55 0.45,14 1,14 L5,14 L5,13 L1,13 L1,11 L5,11 L5,10 L2,10 L2,1 L11.02,1 L11,10 L9,10 L9,11 L11,11 L11,13 L9,13 L9,14 L11,14 C11.55,14 12,13.55 12,13 L12,1 C12,0.45 11.55,0 11,0 L11,0 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repoPush = repoPush;
var repo = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "repo",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "repo",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,9 L3,9 L3,8 L4,8 L4,9 L4,9 Z M4,6 L3,6 L3,7 L4,7 L4,6 L4,6 Z M4,4 L3,4 L3,5 L4,5 L4,4 L4,4 Z M4,2 L3,2 L3,3 L4,3 L4,2 L4,2 Z M12,1 L12,13 C12,13.55 11.55,14 11,14 L6,14 L6,16 L4.5,14.5 L3,16 L3,14 L1,14 C0.45,14 0,13.55 0,13 L0,1 C0,0.45 0.45,0 1,0 L11,0 C11.55,0 12,0.45 12,1 L12,1 Z M11,11 L1,11 L1,13 L3,13 L3,12 L6,12 L6,13 L11,13 L11,11 L11,11 Z M11,1 L2,1 L2,10 L11,10 L11,1 L11,1 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,9 L3,9 L3,8 L4,8 L4,9 L4,9 Z M4,6 L3,6 L3,7 L4,7 L4,6 L4,6 Z M4,4 L3,4 L3,5 L4,5 L4,4 L4,4 Z M4,2 L3,2 L3,3 L4,3 L4,2 L4,2 Z M12,1 L12,13 C12,13.55 11.55,14 11,14 L6,14 L6,16 L4.5,14.5 L3,16 L3,14 L1,14 C0.45,14 0,13.55 0,13 L0,1 C0,0.45 0.45,0 1,0 L11,0 C11.55,0 12,0.45 12,1 L12,1 Z M11,11 L1,11 L1,13 L3,13 L3,12 L6,12 L6,13 L11,13 L11,11 L11,11 Z M11,1 L2,1 L2,10 L11,10 L11,1 L11,1 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.repo = repo;
var rocket = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "rocket",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "rocket",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12.17,3.83 C11.9,3.56 11.7,3.28 11.54,2.95 C11.38,2.64 11.27,2.29 11.2,1.93 C10.62,2.26 10.04,2.63 9.47,3.06 C8.89,3.5 8.33,4 7.78,4.54 C7.08,5.24 6.45,6.35 6,6.99 L3,6.99 L0,10 L3,10 L5,8 C4.66,8.77 3.98,10.98 4,11 L5,12 C5.02,12.02 7.23,11.36 8,11 L6,13 L6,16 L9,13 L9,10 C9.64,9.55 10.75,8.91 11.45,8.22 C12,7.67 12.5,7.09 12.92,6.52 C13.36,5.94 13.73,5.36 14.06,4.8 C13.7,4.72 13.36,4.61 13.03,4.46 C12.72,4.3 12.44,4.1 12.17,3.83 M16,0 C16,0 15.91,0.38 15.7,1.06 C15.5,1.76 15.15,2.64 14.64,3.72 C13.94,3.64 13.37,3.39 12.98,3 C12.59,2.61 12.35,2.06 12.28,1.36 C13.36,0.84 14.23,0.48 14.92,0.28 C15.62,0.08 16,0 16,0",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12.17,3.83 C11.9,3.56 11.7,3.28 11.54,2.95 C11.38,2.64 11.27,2.29 11.2,1.93 C10.62,2.26 10.04,2.63 9.47,3.06 C8.89,3.5 8.33,4 7.78,4.54 C7.08,5.24 6.45,6.35 6,6.99 L3,6.99 L0,10 L3,10 L5,8 C4.66,8.77 3.98,10.98 4,11 L5,12 C5.02,12.02 7.23,11.36 8,11 L6,13 L6,16 L9,13 L9,10 C9.64,9.55 10.75,8.91 11.45,8.22 C12,7.67 12.5,7.09 12.92,6.52 C13.36,5.94 13.73,5.36 14.06,4.8 C13.7,4.72 13.36,4.61 13.03,4.46 C12.72,4.3 12.44,4.1 12.17,3.83 M16,0 C16,0 15.91,0.38 15.7,1.06 C15.5,1.76 15.15,2.64 14.64,3.72 C13.94,3.64 13.37,3.39 12.98,3 C12.59,2.61 12.35,2.06 12.28,1.36 C13.36,0.84 14.23,0.48 14.92,0.28 C15.62,0.08 16,0 16,0",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.rocket = rocket;
var rss = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "rss",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "rss",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M2,13 L0,13 L0,11 C1.11,11 2,11.89 2,13 L2,13 Z M0,3 L0,4 C4.97,4 9,8.03 9,13 L10,13 C10,7.48 5.52,3 0,3 L0,3 Z M0,7 L0,8 C2.75,8 5,10.25 5,13 L6,13 C6,9.69 3.31,7 0,7 L0,7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M2,13 L0,13 L0,11 C1.11,11 2,11.89 2,13 L2,13 Z M0,3 L0,4 C4.97,4 9,8.03 9,13 L10,13 C10,7.48 5.52,3 0,3 L0,3 Z M0,7 L0,8 C2.75,8 5,10.25 5,13 L6,13 C6,9.69 3.31,7 0,7 L0,7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.rss = rss;
var ruby = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "ruby",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "ruby",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,6 L8,11 L8,4 L11,4 L13,6 L13,6 Z M16,6 L8,14 L0,6 L4,2 L12,2 L16,6 L16,6 Z M8,12.5 L14.5,6 L11.5,3 L4.5,3 L1.5,6 L8,12.5 L8,12.5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,6 L8,11 L8,4 L11,4 L13,6 L13,6 Z M16,6 L8,14 L0,6 L4,2 L12,2 L16,6 L16,6 Z M8,12.5 L14.5,6 L11.5,3 L4.5,3 L1.5,6 L8,12.5 L8,12.5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.ruby = ruby;
var screenFull = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "screen-full",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "screen-full",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,10 L14,10 L14,13 C14,13.546875 13.546875,14 13,14 L10,14 L10,13 L13,13 L13,10 L13,10 L13,10 Z M1,10 L0,10 L0,13 C0,13.546875 0.453125,14 1,14 L4,14 L4,13 L1,13 L1,10 L1,10 L1,10 Z M1,3 L4,3 L4,2 L1,2 C0.453125,2 0,2.453125 0,3 L0,6 L1,6 L1,3 L1,3 L1,3 Z M2,4 L12,4 L12,12 L2,12 L2,4 L2,4 L2,4 Z M4,10 L10,10 L10,6 L4,6 L4,10 L4,10 L4,10 Z M10,2 L10,3 L13,3 L13,6 L14,6 L14,3 C14,2.453125 13.546875,2 13,2 L10,2 L10,2 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,10 L14,10 L14,13 C14,13.546875 13.546875,14 13,14 L10,14 L10,13 L13,13 L13,10 L13,10 L13,10 Z M1,10 L0,10 L0,13 C0,13.546875 0.453125,14 1,14 L4,14 L4,13 L1,13 L1,10 L1,10 L1,10 Z M1,3 L4,3 L4,2 L1,2 C0.453125,2 0,2.453125 0,3 L0,6 L1,6 L1,3 L1,3 L1,3 Z M2,4 L12,4 L12,12 L2,12 L2,4 L2,4 L2,4 Z M4,10 L10,10 L10,6 L4,6 L4,10 L4,10 L4,10 Z M10,2 L10,3 L13,3 L13,6 L14,6 L14,3 C14,2.453125 13.546875,2 13,2 L10,2 L10,2 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.screenFull = screenFull;
var screenNormal = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "screen-normal",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "screen-normal",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M2,4 L0,4 L0,3 L2,3 L2,1 L3,1 L3,3 C3,3.546875 2.546875,4 2,4 L2,4 L2,4 Z M2,12 L0,12 L0,13 L2,13 L2,15 L3,15 L3,13 C3,12.453125 2.546875,12 2,12 L2,12 L2,12 Z M11,10 C11,10.546875 10.546875,11 10,11 L4,11 C3.453125,11 3,10.546875 3,10 L3,6 C3,5.453125 3.453125,5 4,5 L10,5 C10.546875,5 11,5.453125 11,6 L11,10 L11,10 L11,10 Z M9,7 L5,7 L5,9 L9,9 L9,7 L9,7 L9,7 Z M11,13 L11,15 L12,15 L12,13 L14,13 L14,12 L12,12 C11.453125,12 11,12.453125 11,13 L11,13 L11,13 Z M12,3 L12,1 L11,1 L11,3 C11,3.546875 11.453125,4 12,4 L14,4 L14,3 L12,3 L12,3 L12,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M2,4 L0,4 L0,3 L2,3 L2,1 L3,1 L3,3 C3,3.546875 2.546875,4 2,4 L2,4 L2,4 Z M2,12 L0,12 L0,13 L2,13 L2,15 L3,15 L3,13 C3,12.453125 2.546875,12 2,12 L2,12 L2,12 Z M11,10 C11,10.546875 10.546875,11 10,11 L4,11 C3.453125,11 3,10.546875 3,10 L3,6 C3,5.453125 3.453125,5 4,5 L10,5 C10.546875,5 11,5.453125 11,6 L11,10 L11,10 L11,10 Z M9,7 L5,7 L5,9 L9,9 L9,7 L9,7 L9,7 Z M11,13 L11,15 L12,15 L12,13 L14,13 L14,12 L12,12 C11.453125,12 11,12.453125 11,13 L11,13 L11,13 Z M12,3 L12,1 L11,1 L11,3 C11,3.546875 11.453125,4 12,4 L14,4 L14,3 L12,3 L12,3 L12,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.screenNormal = screenNormal;
var search = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "search",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "search",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.7,13.3 L11.89,9.47 C12.59,8.49 13,7.3 13,6 C13,2.69 10.31,0 7,0 C3.69,0 1,2.69 1,6 C1,9.31 3.69,12 7,12 C8.3,12 9.48,11.59 10.47,10.89 L14.3,14.7 C14.49,14.9 14.75,15 15,15 C15.25,15 15.52,14.91 15.7,14.7 C16.09,14.31 16.09,13.68 15.7,13.29 L15.7,13.3 Z M7,10.7 C4.41,10.7 2.3,8.59 2.3,6 C2.3,3.41 4.41,1.3 7,1.3 C9.59,1.3 11.7,3.41 11.7,6 C11.7,8.59 9.59,10.7 7,10.7 L7,10.7 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.7,13.3 L11.89,9.47 C12.59,8.49 13,7.3 13,6 C13,2.69 10.31,0 7,0 C3.69,0 1,2.69 1,6 C1,9.31 3.69,12 7,12 C8.3,12 9.48,11.59 10.47,10.89 L14.3,14.7 C14.49,14.9 14.75,15 15,15 C15.25,15 15.52,14.91 15.7,14.7 C16.09,14.31 16.09,13.68 15.7,13.29 L15.7,13.3 Z M7,10.7 C4.41,10.7 2.3,8.59 2.3,6 C2.3,3.41 4.41,1.3 7,1.3 C9.59,1.3 11.7,3.41 11.7,6 C11.7,8.59 9.59,10.7 7,10.7 L7,10.7 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.search = search;
var server = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "server",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "server",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,6 L1,6 C0.45,6 0,6.45 0,7 L0,9 C0,9.55 0.45,10 1,10 L11,10 C11.55,10 12,9.55 12,9 L12,7 C12,6.45 11.55,6 11,6 L11,6 Z M2,9 L1,9 L1,7 L2,7 L2,9 L2,9 Z M4,9 L3,9 L3,7 L4,7 L4,9 L4,9 Z M6,9 L5,9 L5,7 L6,7 L6,9 L6,9 Z M8,9 L7,9 L7,7 L8,7 L8,9 L8,9 Z M11,1 L1,1 C0.45,1 0,1.45 0,2 L0,4 C0,4.55 0.45,5 1,5 L11,5 C11.55,5 12,4.55 12,4 L12,2 C12,1.45 11.55,1 11,1 L11,1 Z M2,4 L1,4 L1,2 L2,2 L2,4 L2,4 Z M4,4 L3,4 L3,2 L4,2 L4,4 L4,4 Z M6,4 L5,4 L5,2 L6,2 L6,4 L6,4 Z M8,4 L7,4 L7,2 L8,2 L8,4 L8,4 Z M11,3 L10,3 L10,2 L11,2 L11,3 L11,3 Z M11,11 L1,11 C0.45,11 0,11.45 0,12 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,12 C12,11.45 11.55,11 11,11 L11,11 Z M2,14 L1,14 L1,12 L2,12 L2,14 L2,14 Z M4,14 L3,14 L3,12 L4,12 L4,14 L4,14 Z M6,14 L5,14 L5,12 L6,12 L6,14 L6,14 Z M8,14 L7,14 L7,12 L8,12 L8,14 L8,14 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,6 L1,6 C0.45,6 0,6.45 0,7 L0,9 C0,9.55 0.45,10 1,10 L11,10 C11.55,10 12,9.55 12,9 L12,7 C12,6.45 11.55,6 11,6 L11,6 Z M2,9 L1,9 L1,7 L2,7 L2,9 L2,9 Z M4,9 L3,9 L3,7 L4,7 L4,9 L4,9 Z M6,9 L5,9 L5,7 L6,7 L6,9 L6,9 Z M8,9 L7,9 L7,7 L8,7 L8,9 L8,9 Z M11,1 L1,1 C0.45,1 0,1.45 0,2 L0,4 C0,4.55 0.45,5 1,5 L11,5 C11.55,5 12,4.55 12,4 L12,2 C12,1.45 11.55,1 11,1 L11,1 Z M2,4 L1,4 L1,2 L2,2 L2,4 L2,4 Z M4,4 L3,4 L3,2 L4,2 L4,4 L4,4 Z M6,4 L5,4 L5,2 L6,2 L6,4 L6,4 Z M8,4 L7,4 L7,2 L8,2 L8,4 L8,4 Z M11,3 L10,3 L10,2 L11,2 L11,3 L11,3 Z M11,11 L1,11 C0.45,11 0,11.45 0,12 L0,14 C0,14.55 0.45,15 1,15 L11,15 C11.55,15 12,14.55 12,14 L12,12 C12,11.45 11.55,11 11,11 L11,11 Z M2,14 L1,14 L1,12 L2,12 L2,14 L2,14 Z M4,14 L3,14 L3,12 L4,12 L4,14 L4,14 Z M6,14 L5,14 L5,12 L6,12 L6,14 L6,14 Z M8,14 L7,14 L7,12 L8,12 L8,14 L8,14 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.server = server;
var settings = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "settings",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "settings",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4,7 L3,7 L3,2 L4,2 L4,7 L4,7 Z M3,14 L4,14 L4,11 L3,11 L3,14 L3,14 Z M8,14 L9,14 L9,8 L8,8 L8,14 L8,14 Z M13,14 L14,14 L14,12 L13,12 L13,14 L13,14 Z M14,2 L13,2 L13,8 L14,8 L14,2 L14,2 Z M9,2 L8,2 L8,4 L9,4 L9,2 L9,2 Z M5,8 L2,8 C1.45,8 1,8.45 1,9 C1,9.55 1.45,10 2,10 L5,10 C5.55,10 6,9.55 6,9 C6,8.45 5.55,8 5,8 L5,8 Z M10,5 L7,5 C6.45,5 6,5.45 6,6 C6,6.55 6.45,7 7,7 L10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 L10,5 Z M15,9 L12,9 C11.45,9 11,9.45 11,10 C11,10.55 11.45,11 12,11 L15,11 C15.55,11 16,10.55 16,10 C16,9.45 15.55,9 15,9 L15,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4,7 L3,7 L3,2 L4,2 L4,7 L4,7 Z M3,14 L4,14 L4,11 L3,11 L3,14 L3,14 Z M8,14 L9,14 L9,8 L8,8 L8,14 L8,14 Z M13,14 L14,14 L14,12 L13,12 L13,14 L13,14 Z M14,2 L13,2 L13,8 L14,8 L14,2 L14,2 Z M9,2 L8,2 L8,4 L9,4 L9,2 L9,2 Z M5,8 L2,8 C1.45,8 1,8.45 1,9 C1,9.55 1.45,10 2,10 L5,10 C5.55,10 6,9.55 6,9 C6,8.45 5.55,8 5,8 L5,8 Z M10,5 L7,5 C6.45,5 6,5.45 6,6 C6,6.55 6.45,7 7,7 L10,7 C10.55,7 11,6.55 11,6 C11,5.45 10.55,5 10,5 L10,5 Z M15,9 L12,9 C11.45,9 11,9.45 11,10 C11,10.55 11.45,11 12,11 L15,11 C15.55,11 16,10.55 16,10 C16,9.45 15.55,9 15,9 L15,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.settings = settings;
var shield = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "shield",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "shield",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,0 L0,2 L0,8.02 C0,12.69 5.31,16 7,16 C8.69,16 14,12.69 14,8.02 L14,2 L7,0 L7,0 Z M5,11 L6.14,8.2 C6.19,7.97 6.08,7.73 5.89,7.61 C5.33,7.25 5,6.66 5,6 C5,4.91 5.89,4 6.98,4 C8.06,4 9,4.91 9,6 C9,6.66 8.67,7.25 8.11,7.61 C7.92,7.74 7.81,7.97 7.86,8.2 L9,11 L5,11 L5,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,0 L0,2 L0,8.02 C0,12.69 5.31,16 7,16 C8.69,16 14,12.69 14,8.02 L14,2 L7,0 L7,0 Z M5,11 L6.14,8.2 C6.19,7.97 6.08,7.73 5.89,7.61 C5.33,7.25 5,6.66 5,6 C5,4.91 5.89,4 6.98,4 C8.06,4 9,4.91 9,6 C9,6.66 8.67,7.25 8.11,7.61 C7.92,7.74 7.81,7.97 7.86,8.2 L9,11 L5,11 L5,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.shield = shield;
var signIn = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "sign-in",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "sign-in",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,6.75 L7,12 L11,12 L11,8 L12,8 L12,12 C12,12.55 11.55,13 11,13 L7,13 L7,16 L1.55,13.28 C1.22,13.11 1,12.76 1,12.37 L1,1 C1,0.45 1.45,0 2,0 L11,0 C11.55,0 12,0.45 12,1 L12,4 L11,4 L11,1 L3,1 L7,3 L7,5.25 L10,3 L10,5 L14,5 L14,7 L10,7 L10,9 L7,6.75 L7,6.75 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,6.75 L7,12 L11,12 L11,8 L12,8 L12,12 C12,12.55 11.55,13 11,13 L7,13 L7,16 L1.55,13.28 C1.22,13.11 1,12.76 1,12.37 L1,1 C1,0.45 1.45,0 2,0 L11,0 C11.55,0 12,0.45 12,1 L12,4 L11,4 L11,1 L3,1 L7,3 L7,5.25 L10,3 L10,5 L14,5 L14,7 L10,7 L10,9 L7,6.75 L7,6.75 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.signIn = signIn;
var signOut = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "sign-out",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "sign-out",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,9 L12,7 L8,7 L8,5 L12,5 L12,3 L16,6 L12,9 L12,9 Z M10,12 L6,12 L6,3 L2,1 L10,1 L10,4 L11,4 L11,1 C11,0.45 10.55,0 10,0 L1,0 C0.45,0 0,0.45 0,1 L0,12.38 C0,12.77 0.22,13.11 0.55,13.29 L6,16.01 L6,13 L10,13 C10.55,13 11,12.55 11,12 L11,8 L10,8 L10,12 L10,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,9 L12,7 L8,7 L8,5 L12,5 L12,3 L16,6 L12,9 L12,9 Z M10,12 L6,12 L6,3 L2,1 L10,1 L10,4 L11,4 L11,1 C11,0.45 10.55,0 10,0 L1,0 C0.45,0 0,0.45 0,1 L0,12.38 C0,12.77 0.22,13.11 0.55,13.29 L6,16.01 L6,13 L10,13 C10.55,13 11,12.55 11,12 L11,8 L10,8 L10,12 L10,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.signOut = signOut;
var smiley = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "smiley",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "smiley",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 L8,0 Z M12.81,12.81 C12.18,13.44 11.45,13.92 10.64,14.26 C9.81,14.62 8.92,14.79 8,14.79 C7.08,14.79 6.19,14.62 5.36,14.26 C4.55,13.92 3.81,13.43 3.19,12.81 C2.57,12.19 2.08,11.45 1.74,10.64 C1.38,9.81 1.21,8.92 1.21,8 C1.21,7.08 1.38,6.19 1.74,5.36 C2.08,4.55 2.57,3.81 3.19,3.19 C3.81,2.57 4.55,2.08 5.36,1.74 C6.19,1.38 7.08,1.21 8,1.21 C8.92,1.21 9.81,1.38 10.64,1.74 C11.45,2.08 12.19,2.57 12.81,3.19 C13.43,3.81 13.92,4.55 14.26,5.36 C14.62,6.19 14.79,7.08 14.79,8 C14.79,8.92 14.62,9.81 14.26,10.64 C13.92,11.45 13.43,12.19 12.81,12.81 L12.81,12.81 Z M4,6.8 L4,6.21 C4,5.55 4.53,5.02 5.2,5.02 L5.79,5.02 C6.45,5.02 6.98,5.55 6.98,6.21 L6.98,6.8 C6.98,7.47 6.45,8 5.79,8 L5.2,8 C4.53,8 4,7.47 4,6.8 L4,6.8 Z M9,6.8 L9,6.21 C9,5.55 9.53,5.02 10.2,5.02 L10.79,5.02 C11.45,5.02 11.98,5.55 11.98,6.21 L11.98,6.8 C11.98,7.47 11.45,8 10.79,8 L10.2,8 C9.53,8 9,7.47 9,6.8 L9,6.8 Z M13,10 C12.28,11.88 10.09,13 8,13 C5.91,13 3.72,11.87 3,10 C2.86,9.61 3.23,9 3.66,9 L12.25,9 C12.66,9 13.14,9.61 13,10 L13,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,0 C3.58,0 0,3.58 0,8 C0,12.42 3.58,16 8,16 C12.42,16 16,12.42 16,8 C16,3.58 12.42,0 8,0 L8,0 Z M12.81,12.81 C12.18,13.44 11.45,13.92 10.64,14.26 C9.81,14.62 8.92,14.79 8,14.79 C7.08,14.79 6.19,14.62 5.36,14.26 C4.55,13.92 3.81,13.43 3.19,12.81 C2.57,12.19 2.08,11.45 1.74,10.64 C1.38,9.81 1.21,8.92 1.21,8 C1.21,7.08 1.38,6.19 1.74,5.36 C2.08,4.55 2.57,3.81 3.19,3.19 C3.81,2.57 4.55,2.08 5.36,1.74 C6.19,1.38 7.08,1.21 8,1.21 C8.92,1.21 9.81,1.38 10.64,1.74 C11.45,2.08 12.19,2.57 12.81,3.19 C13.43,3.81 13.92,4.55 14.26,5.36 C14.62,6.19 14.79,7.08 14.79,8 C14.79,8.92 14.62,9.81 14.26,10.64 C13.92,11.45 13.43,12.19 12.81,12.81 L12.81,12.81 Z M4,6.8 L4,6.21 C4,5.55 4.53,5.02 5.2,5.02 L5.79,5.02 C6.45,5.02 6.98,5.55 6.98,6.21 L6.98,6.8 C6.98,7.47 6.45,8 5.79,8 L5.2,8 C4.53,8 4,7.47 4,6.8 L4,6.8 Z M9,6.8 L9,6.21 C9,5.55 9.53,5.02 10.2,5.02 L10.79,5.02 C11.45,5.02 11.98,5.55 11.98,6.21 L11.98,6.8 C11.98,7.47 11.45,8 10.79,8 L10.2,8 C9.53,8 9,7.47 9,6.8 L9,6.8 Z M13,10 C12.28,11.88 10.09,13 8,13 C5.91,13 3.72,11.87 3,10 C2.86,9.61 3.23,9 3.66,9 L12.25,9 C12.66,9 13.14,9.61 13,10 L13,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.smiley = smiley;
var squirrel = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "squirrel",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "squirrel",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,1 C9.79,1 8,2.31 8,3.92 C8,5.86 8.5,6.95 8,10 C8,5.5 5.23,3.66 4,3.66 C4.05,3.16 3.52,3 3.52,3 C3.52,3 3.3,3.11 3.22,3.34 C2.95,3.03 2.66,3.07 2.66,3.07 L2.53,3.65 C2.53,3.65 0.7,4.29 0.68,6.87 C0.88,7.2 2.21,7.47 3.15,7.3 C4.04,7.35 3.82,8.09 3.62,8.29 C2.78,9.13 2,8 1,8 C0,8 0,9 1,9 C2,9 2,10 4,10 C0.91,11.2 4,14 4,14 L3,14 C2,14 2,15 2,15 L8,15 C11,15 13,14 13,11.53 C13,10.68 12.57,9.74 12,9 C10.89,7.54 12.23,6.32 13,7 C13.77,7.68 16,8 16,5 C16,2.79 14.21,1 12,1 L12,1 Z M2.5,6 C2.22,6 2,5.78 2,5.5 C2,5.22 2.22,5 2.5,5 C2.78,5 3,5.22 3,5.5 C3,5.78 2.78,6 2.5,6 L2.5,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,1 C9.79,1 8,2.31 8,3.92 C8,5.86 8.5,6.95 8,10 C8,5.5 5.23,3.66 4,3.66 C4.05,3.16 3.52,3 3.52,3 C3.52,3 3.3,3.11 3.22,3.34 C2.95,3.03 2.66,3.07 2.66,3.07 L2.53,3.65 C2.53,3.65 0.7,4.29 0.68,6.87 C0.88,7.2 2.21,7.47 3.15,7.3 C4.04,7.35 3.82,8.09 3.62,8.29 C2.78,9.13 2,8 1,8 C0,8 0,9 1,9 C2,9 2,10 4,10 C0.91,11.2 4,14 4,14 L3,14 C2,14 2,15 2,15 L8,15 C11,15 13,14 13,11.53 C13,10.68 12.57,9.74 12,9 C10.89,7.54 12.23,6.32 13,7 C13.77,7.68 16,8 16,5 C16,2.79 14.21,1 12,1 L12,1 Z M2.5,6 C2.22,6 2,5.78 2,5.5 C2,5.22 2.22,5 2.5,5 C2.78,5 3,5.22 3,5.5 C3,5.78 2.78,6 2.5,6 L2.5,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.squirrel = squirrel;
var star = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "star",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "star",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "14 6 9.1 5.36 7 1 4.9 5.36 0 6 3.6 9.26 2.67 14 7 11.67 11.33 14 10.4 9.26"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "14 6 9.1 5.36 7 1 4.9 5.36 0 6 3.6 9.26 2.67 14 7 11.67 11.33 14 10.4 9.26"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.star = star;
var stop = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "stop",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "stop",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10,1 L4,1 L0,5 L0,11 L4,15 L10,15 L14,11 L14,5 L10,1 L10,1 Z M13,10.5 L9.5,14 L4.5,14 L1,10.5 L1,5.5 L4.5,2 L9.5,2 L13,5.5 L13,10.5 L13,10.5 Z M6,4 L8,4 L8,9 L6,9 L6,4 L6,4 Z M6,10 L8,10 L8,12 L6,12 L6,10 L6,10 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10,1 L4,1 L0,5 L0,11 L4,15 L10,15 L14,11 L14,5 L10,1 L10,1 Z M13,10.5 L9.5,14 L4.5,14 L1,10.5 L1,5.5 L4.5,2 L9.5,2 L13,5.5 L13,10.5 L13,10.5 Z M6,4 L8,4 L8,9 L6,9 L6,4 L6,4 Z M6,10 L8,10 L8,12 L6,12 L6,10 L6,10 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.stop = stop;
var sync = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "sync",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "sync",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M10.24,7.4 C10.43,8.68 10.04,10.02 9.04,11 C7.57,12.45 5.3,12.63 3.63,11.54 L4.8,10.4 L0.5,9.8 L1.1,14 L2.41,12.74 C4.77,14.48 8.11,14.31 10.25,12.2 C11.49,10.97 12.06,9.35 11.99,7.74 L10.24,7.4 L10.24,7.4 Z M2.96,5 C4.43,3.55 6.7,3.37 8.37,4.46 L7.2,5.6 L11.5,6.2 L10.9,2 L9.59,3.26 C7.23,1.52 3.89,1.69 1.74,3.8 C0.5,5.03 -0.06,6.65 0.01,8.26 L1.76,8.61 C1.57,7.33 1.96,5.98 2.96,5 L2.96,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M10.24,7.4 C10.43,8.68 10.04,10.02 9.04,11 C7.57,12.45 5.3,12.63 3.63,11.54 L4.8,10.4 L0.5,9.8 L1.1,14 L2.41,12.74 C4.77,14.48 8.11,14.31 10.25,12.2 C11.49,10.97 12.06,9.35 11.99,7.74 L10.24,7.4 L10.24,7.4 Z M2.96,5 C4.43,3.55 6.7,3.37 8.37,4.46 L7.2,5.6 L11.5,6.2 L10.9,2 L9.59,3.26 C7.23,1.52 3.89,1.69 1.74,3.8 C0.5,5.03 -0.06,6.65 0.01,8.26 L1.76,8.61 C1.57,7.33 1.96,5.98 2.96,5 L2.96,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.sync = sync;
var tag = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "tag",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "tag",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7.73,1.73 C7.26,1.26 6.62,1 5.96,1 L3.5,1 C2.13,1 1,2.13 1,3.5 L1,5.97 C1,6.63 1.27,7.27 1.73,7.74 L7.79,13.8 C8.18,14.19 8.81,14.19 9.2,13.8 L13.79,9.21 C14.18,8.82 14.18,8.19 13.79,7.8 L7.73,1.73 L7.73,1.73 Z M2.38,7.09 C2.07,6.79 1.91,6.39 1.91,5.96 L1.91,3.5 C1.91,2.62 2.63,1.91 3.5,1.91 L5.97,1.91 C6.39,1.91 6.8,2.07 7.1,2.38 L13.24,8.51 L8.51,13.24 L2.38,7.09 L2.38,7.09 Z M3.01,3 L5.01,3 L5.01,5 L3,5 L3,3 L3.01,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7.73,1.73 C7.26,1.26 6.62,1 5.96,1 L3.5,1 C2.13,1 1,2.13 1,3.5 L1,5.97 C1,6.63 1.27,7.27 1.73,7.74 L7.79,13.8 C8.18,14.19 8.81,14.19 9.2,13.8 L13.79,9.21 C14.18,8.82 14.18,8.19 13.79,7.8 L7.73,1.73 L7.73,1.73 Z M2.38,7.09 C2.07,6.79 1.91,6.39 1.91,5.96 L1.91,3.5 C1.91,2.62 2.63,1.91 3.5,1.91 L5.97,1.91 C6.39,1.91 6.8,2.07 7.1,2.38 L13.24,8.51 L8.51,13.24 L2.38,7.09 L2.38,7.09 Z M3.01,3 L5.01,3 L5.01,5 L3,5 L3,3 L3.01,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.tag = tag;
var tasklist = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "tasklist",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "tasklist",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.41,9 L7.59,9 C7,9 7,8.59 7,8 C7,7.41 7,7 7.59,7 L15.4,7 C15.99,7 15.99,7.41 15.99,8 C15.99,8.59 15.99,9 15.4,9 L15.41,9 Z M9.59,4 C9,4 9,3.59 9,3 C9,2.41 9,2 9.59,2 L15.4,2 C15.99,2 15.99,2.41 15.99,3 C15.99,3.59 15.99,4 15.4,4 L9.59,4 L9.59,4 Z M0,3.91 L1.41,2.61 L3,4.2 L7.09,0 L8.5,1.41 L3,6.91 L0,3.91 L0,3.91 Z M7.59,12 L15.4,12 C15.99,12 15.99,12.41 15.99,13 C15.99,13.59 15.99,14 15.4,14 L7.59,14 C7,14 7,13.59 7,13 C7,12.41 7,12 7.59,12 L7.59,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.41,9 L7.59,9 C7,9 7,8.59 7,8 C7,7.41 7,7 7.59,7 L15.4,7 C15.99,7 15.99,7.41 15.99,8 C15.99,8.59 15.99,9 15.4,9 L15.41,9 Z M9.59,4 C9,4 9,3.59 9,3 C9,2.41 9,2 9.59,2 L15.4,2 C15.99,2 15.99,2.41 15.99,3 C15.99,3.59 15.99,4 15.4,4 L9.59,4 L9.59,4 Z M0,3.91 L1.41,2.61 L3,4.2 L7.09,0 L8.5,1.41 L3,6.91 L0,3.91 L0,3.91 Z M7.59,12 L15.4,12 C15.99,12 15.99,12.41 15.99,13 C15.99,13.59 15.99,14 15.4,14 L7.59,14 C7,14 7,13.59 7,13 C7,12.41 7,12 7.59,12 L7.59,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.tasklist = tasklist;
var telescope = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "telescope",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "telescope",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M8,9 L11,15 L10,15 L8,11 L8,16 L7,16 L7,10 L5,15 L4,15 L6,10 L8,9 L8,9 Z M7,0 L6,0 L6,1 L7,1 L7,0 L7,0 Z M5,3 L4,3 L4,4 L5,4 L5,3 L5,3 Z M2,1 L1,1 L1,2 L2,2 L2,1 L2,1 Z M0.63,9 C0.41,9.16 0.35,9.44 0.47,9.67 L1.02,10.59 C1.15,10.82 1.43,10.9 1.66,10.79 L3.05,10.13 L1.89,8.13 L0.62,8.99 L0.63,9 Z M8.52,3.61 L2.72,7.56 L3.95,9.7 L10.28,6.67 L8.51,3.61 L8.52,3.61 Z M12.74,4.89 L11.27,2.37 C11.13,2.12 10.8,2.04 10.55,2.2 L9.35,3.03 L11.19,6.23 L12.52,5.59 C12.79,5.46 12.88,5.15 12.74,4.89 L12.74,4.89 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M8,9 L11,15 L10,15 L8,11 L8,16 L7,16 L7,10 L5,15 L4,15 L6,10 L8,9 L8,9 Z M7,0 L6,0 L6,1 L7,1 L7,0 L7,0 Z M5,3 L4,3 L4,4 L5,4 L5,3 L5,3 Z M2,1 L1,1 L1,2 L2,2 L2,1 L2,1 Z M0.63,9 C0.41,9.16 0.35,9.44 0.47,9.67 L1.02,10.59 C1.15,10.82 1.43,10.9 1.66,10.79 L3.05,10.13 L1.89,8.13 L0.62,8.99 L0.63,9 Z M8.52,3.61 L2.72,7.56 L3.95,9.7 L10.28,6.67 L8.51,3.61 L8.52,3.61 Z M12.74,4.89 L11.27,2.37 C11.13,2.12 10.8,2.04 10.55,2.2 L9.35,3.03 L11.19,6.23 L12.52,5.59 C12.79,5.46 12.88,5.15 12.74,4.89 L12.74,4.89 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.telescope = telescope;
var terminal = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "terminal",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "terminal",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M7,10 L11,10 L11,11 L7,11 L7,10 L7,10 Z M4,11 L7,8 L4,5 L3.25,5.75 L5.5,8 L3.25,10.25 L4,11 L4,11 Z M14,3 L14,13 C14,13.55 13.55,14 13,14 L1,14 C0.45,14 0,13.55 0,13 L0,3 C0,2.45 0.45,2 1,2 L13,2 C13.55,2 14,2.45 14,3 L14,3 Z M13,3 L1,3 L1,13 L13,13 L13,3 L13,3 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M7,10 L11,10 L11,11 L7,11 L7,10 L7,10 Z M4,11 L7,8 L4,5 L3.25,5.75 L5.5,8 L3.25,10.25 L4,11 L4,11 Z M14,3 L14,13 C14,13.55 13.55,14 13,14 L1,14 C0.45,14 0,13.55 0,13 L0,3 C0,2.45 0.45,2 1,2 L13,2 C13.55,2 14,2.45 14,3 L14,3 Z M13,3 L1,3 L1,13 L13,13 L13,3 L13,3 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.terminal = terminal;
var textSize = {
  "viewBox": "0 0 18 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "text-size",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "text-size",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13.62,9.08 L12.1,3.66 L12.04,3.66 L10.54,9.08 L13.62,9.08 Z M5.7,10.13 C5.7,10.13 4.68,6.52 4.53,6.02 L4.45,6.02 L3.32,10.13 L5.7,10.13 Z M17.31,14 L15.06,14 L14.11,10.75 L10.04,10.75 L9.09,14 L6.84,14 L6.15,11.67 L2.87,11.67 L2.17,14 L0,14 L3.3,4.41 L5.8,4.41 L7.97,10.75 L10.86,2 L13.38,2 L17.32,14 L17.31,14 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13.62,9.08 L12.1,3.66 L12.04,3.66 L10.54,9.08 L13.62,9.08 Z M5.7,10.13 C5.7,10.13 4.68,6.52 4.53,6.02 L4.45,6.02 L3.32,10.13 L5.7,10.13 Z M17.31,14 L15.06,14 L14.11,10.75 L10.04,10.75 L9.09,14 L6.84,14 L6.15,11.67 L2.87,11.67 L2.17,14 L0,14 L3.3,4.41 L5.8,4.41 L7.97,10.75 L10.86,2 L13.38,2 L17.32,14 L17.31,14 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.textSize = textSize;
var threeBars = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "three-bars",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "three-bars",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11.41,9 L0.59,9 C0,9 0,8.59 0,8 C0,7.41 0,7 0.59,7 L11.4,7 C11.99,7 11.99,7.41 11.99,8 C11.99,8.59 11.99,9 11.4,9 L11.41,9 Z M11.41,5 L0.59,5 C0,5 0,4.59 0,4 C0,3.41 0,3 0.59,3 L11.4,3 C11.99,3 11.99,3.41 11.99,4 C11.99,4.59 11.99,5 11.4,5 L11.41,5 Z M0.59,11 L11.4,11 C11.99,11 11.99,11.41 11.99,12 C11.99,12.59 11.99,13 11.4,13 L0.59,13 C0,13 0,12.59 0,12 C0,11.41 0,11 0.59,11 L0.59,11 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11.41,9 L0.59,9 C0,9 0,8.59 0,8 C0,7.41 0,7 0.59,7 L11.4,7 C11.99,7 11.99,7.41 11.99,8 C11.99,8.59 11.99,9 11.4,9 L11.41,9 Z M11.41,5 L0.59,5 C0,5 0,4.59 0,4 C0,3.41 0,3 0.59,3 L11.4,3 C11.99,3 11.99,3.41 11.99,4 C11.99,4.59 11.99,5 11.4,5 L11.41,5 Z M0.59,11 L11.4,11 C11.99,11 11.99,11.41 11.99,12 C11.99,12.59 11.99,13 11.4,13 L0.59,13 C0,13 0,12.59 0,12 C0,11.41 0,11 0.59,11 L0.59,11 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.threeBars = threeBars;
var thumbsdown = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "thumbsdown",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "thumbsdown",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.98,7.83 L15.01,1.88 C14.84,0.5 13.13,0 12,0 L5.69,0 C5.49,0 5.31,0.05 5.16,0.14 L3.72,1 L2,1 C0.94,1 0,1.94 0,3 L0,7 C0,8.06 0.94,9.02 2,9 L4,9 C4.91,9 5.39,9.45 6.39,10.55 C7.3,11.55 7.27,12.35 7.02,13.82 C6.94,14.32 7.08,14.82 7.44,15.24 C7.83,15.71 8.42,16.01 9,16.01 C10.83,16.01 12,12.29 12,10.99 L11.98,10.01 L12,10.01 L14.02,10.01 C15.18,10.01 15.97,9.21 16,8.04 C16,7.98 16.02,7.91 15.98,7.84 L15.98,7.83 Z M14.01,9.02 L12.02,9.02 C11.32,9.02 10.99,9.3 10.99,9.99 L11.02,11.02 C11.02,12.29 9.85,15.02 9.02,15.02 C8.52,15.02 7.94,14.52 8.02,14.02 C8.27,12.44 8.36,11.24 7.13,9.88 C6.11,8.75 5.36,8 4,8 L4,2 L5.67,1 L12,1 C12.73,1 13.95,1.31 14,2 L14.02,2.02 L15.02,8.02 C14.99,8.66 14.64,9.02 14.02,9.02 L14.01,9.02 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.98,7.83 L15.01,1.88 C14.84,0.5 13.13,0 12,0 L5.69,0 C5.49,0 5.31,0.05 5.16,0.14 L3.72,1 L2,1 C0.94,1 0,1.94 0,3 L0,7 C0,8.06 0.94,9.02 2,9 L4,9 C4.91,9 5.39,9.45 6.39,10.55 C7.3,11.55 7.27,12.35 7.02,13.82 C6.94,14.32 7.08,14.82 7.44,15.24 C7.83,15.71 8.42,16.01 9,16.01 C10.83,16.01 12,12.29 12,10.99 L11.98,10.01 L12,10.01 L14.02,10.01 C15.18,10.01 15.97,9.21 16,8.04 C16,7.98 16.02,7.91 15.98,7.84 L15.98,7.83 Z M14.01,9.02 L12.02,9.02 C11.32,9.02 10.99,9.3 10.99,9.99 L11.02,11.02 C11.02,12.29 9.85,15.02 9.02,15.02 C8.52,15.02 7.94,14.52 8.02,14.02 C8.27,12.44 8.36,11.24 7.13,9.88 C6.11,8.75 5.36,8 4,8 L4,2 L5.67,1 L12,1 C12.73,1 13.95,1.31 14,2 L14.02,2.02 L15.02,8.02 C14.99,8.66 14.64,9.02 14.02,9.02 L14.01,9.02 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.thumbsdown = thumbsdown;
var thumbsup = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "thumbsup",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "thumbsup",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M14,14 C13.95,14.69 12.73,15 12,15 L5.67,15 L4,14 L4,8 C5.36,8 6.11,7.25 7.13,6.12 C8.36,4.76 8.27,3.56 8.01,1.99 C7.93,1.49 8.51,0.99 9.01,0.99 C9.84,0.99 11.01,3.72 11.01,4.99 L10.99,6.02 C10.99,6.71 11.32,6.99 12.01,6.99 L14.01,6.99 C14.64,6.99 14.99,7.35 15.01,7.99 L14.01,13.99 L14,14 Z M14,6 L12,6 L11.98,6 L12,5.02 C12,3.72 10.83,0 9,0 C8.42,0 7.83,0.3 7.44,0.77 C7.08,1.18 6.94,1.68 7.02,2.18 C7.27,3.66 7.3,4.46 6.39,5.46 C5.39,6.55 4.91,7.01 4,7.01 L2,7.01 C0.94,7 0,7.94 0,9 L0,13 C0,14.06 0.94,15 2,15 L3.72,15 L5.16,15.86 C5.32,15.95 5.49,16 5.68,16 L12.01,16 C13.14,16 14.85,15.5 15.01,14.12 L15.99,8.17 C16.01,8.09 16.01,8.03 16.01,7.97 C15.98,6.8 15.17,6 14.01,6 L14,6 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M14,14 C13.95,14.69 12.73,15 12,15 L5.67,15 L4,14 L4,8 C5.36,8 6.11,7.25 7.13,6.12 C8.36,4.76 8.27,3.56 8.01,1.99 C7.93,1.49 8.51,0.99 9.01,0.99 C9.84,0.99 11.01,3.72 11.01,4.99 L10.99,6.02 C10.99,6.71 11.32,6.99 12.01,6.99 L14.01,6.99 C14.64,6.99 14.99,7.35 15.01,7.99 L14.01,13.99 L14,14 Z M14,6 L12,6 L11.98,6 L12,5.02 C12,3.72 10.83,0 9,0 C8.42,0 7.83,0.3 7.44,0.77 C7.08,1.18 6.94,1.68 7.02,2.18 C7.27,3.66 7.3,4.46 6.39,5.46 C5.39,6.55 4.91,7.01 4,7.01 L2,7.01 C0.94,7 0,7.94 0,9 L0,13 C0,14.06 0.94,15 2,15 L3.72,15 L5.16,15.86 C5.32,15.95 5.49,16 5.68,16 L12.01,16 C13.14,16 14.85,15.5 15.01,14.12 L15.99,8.17 C16.01,8.09 16.01,8.03 16.01,7.97 C15.98,6.8 15.17,6 14.01,6 L14,6 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.thumbsup = thumbsup;
var tools = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "tools",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "tools",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M4.48,7.27 C4.74,7.53 5.76,8.6 5.76,8.6 L6.32,8.02 L5.44,7.11 L7.13,5.31 C7.13,5.31 6.37,4.57 6.7,4.86 C7.02,3.67 6.73,2.35 5.83,1.42 C4.93,0.5 3.66,0.2 2.52,0.51 L4.45,2.51 L3.94,4.47 L2.05,4.99 L0.12,2.99 C-0.19,4.17 0.1,5.48 1,6.4 C1.94,7.38 3.29,7.66 4.48,7.27 L4.48,7.27 Z M10.92,9.21 L8.59,11.51 L12.43,15.49 C12.74,15.82 13.16,15.98 13.57,15.98 C13.98,15.98 14.39,15.82 14.71,15.49 C15.34,14.84 15.34,13.79 14.71,13.14 L10.92,9.21 L10.92,9.21 Z M16,2.53 L13.55,0 L6.33,7.46 L7.21,8.37 L2.9,12.83 L1.91,13.36 L0.52,15.63 L0.87,16 L3.07,14.56 L3.58,13.54 L7.9,9.08 L8.78,9.99 L16,2.53 L16,2.53 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M4.48,7.27 C4.74,7.53 5.76,8.6 5.76,8.6 L6.32,8.02 L5.44,7.11 L7.13,5.31 C7.13,5.31 6.37,4.57 6.7,4.86 C7.02,3.67 6.73,2.35 5.83,1.42 C4.93,0.5 3.66,0.2 2.52,0.51 L4.45,2.51 L3.94,4.47 L2.05,4.99 L0.12,2.99 C-0.19,4.17 0.1,5.48 1,6.4 C1.94,7.38 3.29,7.66 4.48,7.27 L4.48,7.27 Z M10.92,9.21 L8.59,11.51 L12.43,15.49 C12.74,15.82 13.16,15.98 13.57,15.98 C13.98,15.98 14.39,15.82 14.71,15.49 C15.34,14.84 15.34,13.79 14.71,13.14 L10.92,9.21 L10.92,9.21 Z M16,2.53 L13.55,0 L6.33,7.46 L7.21,8.37 L2.9,12.83 L1.91,13.36 L0.52,15.63 L0.87,16 L3.07,14.56 L3.58,13.54 L7.9,9.08 L8.78,9.99 L16,2.53 L16,2.53 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.tools = tools;
var trashcan = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "trashcan",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "trashcan",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11,2 L9,2 C9,1.45 8.55,1 8,1 L5,1 C4.45,1 4,1.45 4,2 L2,2 C1.45,2 1,2.45 1,3 L1,4 C1,4.55 1.45,5 2,5 L2,14 C2,14.55 2.45,15 3,15 L10,15 C10.55,15 11,14.55 11,14 L11,5 C11.55,5 12,4.55 12,4 L12,3 C12,2.45 11.55,2 11,2 L11,2 Z M10,14 L3,14 L3,5 L4,5 L4,13 L5,13 L5,5 L6,5 L6,13 L7,13 L7,5 L8,5 L8,13 L9,13 L9,5 L10,5 L10,14 L10,14 Z M11,4 L2,4 L2,3 L11,3 L11,4 L11,4 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11,2 L9,2 C9,1.45 8.55,1 8,1 L5,1 C4.45,1 4,1.45 4,2 L2,2 C1.45,2 1,2.45 1,3 L1,4 C1,4.55 1.45,5 2,5 L2,14 C2,14.55 2.45,15 3,15 L10,15 C10.55,15 11,14.55 11,14 L11,5 C11.55,5 12,4.55 12,4 L12,3 C12,2.45 11.55,2 11,2 L11,2 Z M10,14 L3,14 L3,5 L4,5 L4,13 L5,13 L5,5 L6,5 L6,13 L7,13 L7,5 L8,5 L8,13 L9,13 L9,5 L10,5 L10,14 L10,14 Z M11,4 L2,4 L2,3 L11,3 L11,4 L11,4 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.trashcan = trashcan;
var triangleDown = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "triangle-down",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "triangle-down",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "0 5 6 11 12 5"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "0 5 6 11 12 5"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.triangleDown = triangleDown;
var triangleLeft = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "triangle-left",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "triangle-left",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "6 2 0 8 6 14"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "6 2 0 8 6 14"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.triangleLeft = triangleLeft;
var triangleRight = {
  "viewBox": "0 0 6 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "triangle-right",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "triangle-right",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "0 14 6 8 0 2"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "0 14 6 8 0 2"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.triangleRight = triangleRight;
var triangleUp = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "triangle-up",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "triangle-up",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "12 11 6 5 0 11"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "12 11 6 5 0 11"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.triangleUp = triangleUp;
var unfold = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "unfold",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "unfold",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M11.5,7.5 L14,10 C14,10.55 13.55,11 13,11 L9,11 L9,10 L12.5,10 L10.5,8 L3.5,8 L1.5,10 L5,10 L5,11 L1,11 C0.45,11 0,10.55 0,10 L2.5,7.5 L0,5 C0,4.45 0.45,4 1,4 L5,4 L5,5 L1.5,5 L3.5,7 L10.5,7 L12.5,5 L9,5 L9,4 L13,4 C13.55,4 14,4.45 14,5 L11.5,7.5 L11.5,7.5 Z M6,6 L8,6 L8,3 L10,3 L7,0 L4,3 L6,3 L6,6 L6,6 Z M8,9 L6,9 L6,12 L4,12 L7,15 L10,12 L8,12 L8,9 L8,9 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M11.5,7.5 L14,10 C14,10.55 13.55,11 13,11 L9,11 L9,10 L12.5,10 L10.5,8 L3.5,8 L1.5,10 L5,10 L5,11 L1,11 C0.45,11 0,10.55 0,10 L2.5,7.5 L0,5 C0,4.45 0.45,4 1,4 L5,4 L5,5 L1.5,5 L3.5,7 L10.5,7 L12.5,5 L9,5 L9,4 L13,4 C13.55,4 14,4.45 14,5 L11.5,7.5 L11.5,7.5 Z M6,6 L8,6 L8,3 L10,3 L7,0 L4,3 L6,3 L6,6 L6,6 Z M8,9 L6,9 L6,12 L4,12 L7,15 L10,12 L8,12 L8,9 L8,9 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.unfold = unfold;
var unmute = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "unmute",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "unmute",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M12,8.02 C12,9.11 11.55,10.11 10.83,10.85 L10.16,10.18 C10.71,9.62 11.05,8.87 11.05,8.02 C11.05,7.17 10.71,6.41 10.16,5.86 L10.83,5.19 C11.55,5.91 12,6.91 12,8.02 L12,8.02 Z M7.72,2.28 L4,6 L2,6 C1.45,6 1,6.45 1,7 L1,9 C1,9.55 1.45,10 2,10 L4,10 L7.72,13.72 C8.19,14.19 9,13.86 9,13.19 L9,2.81 C9,2.14 8.19,1.81 7.72,2.28 L7.72,2.28 Z M13.66,2.36 L12.99,3.03 C14.27,4.31 15.05,6.06 15.05,8.01 C15.05,9.95 14.27,11.71 12.99,12.99 L13.66,13.66 C15.11,12.21 16,10.21 16,8 C16,5.78 15.11,3.78 13.66,2.34 L13.66,2.36 Z M12.25,3.77 L11.56,4.44 C12.48,5.36 13.04,6.63 13.04,8.02 C13.04,9.41 12.48,10.68 11.56,11.58 L12.25,12.25 C13.33,11.17 14,9.67 14,8.02 C14,6.37 13.33,4.86 12.25,3.77 L12.25,3.77 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M12,8.02 C12,9.11 11.55,10.11 10.83,10.85 L10.16,10.18 C10.71,9.62 11.05,8.87 11.05,8.02 C11.05,7.17 10.71,6.41 10.16,5.86 L10.83,5.19 C11.55,5.91 12,6.91 12,8.02 L12,8.02 Z M7.72,2.28 L4,6 L2,6 C1.45,6 1,6.45 1,7 L1,9 C1,9.55 1.45,10 2,10 L4,10 L7.72,13.72 C8.19,14.19 9,13.86 9,13.19 L9,2.81 C9,2.14 8.19,1.81 7.72,2.28 L7.72,2.28 Z M13.66,2.36 L12.99,3.03 C14.27,4.31 15.05,6.06 15.05,8.01 C15.05,9.95 14.27,11.71 12.99,12.99 L13.66,13.66 C15.11,12.21 16,10.21 16,8 C16,5.78 15.11,3.78 13.66,2.34 L13.66,2.36 Z M12.25,3.77 L11.56,4.44 C12.48,5.36 13.04,6.63 13.04,8.02 C13.04,9.41 12.48,10.68 11.56,11.58 L12.25,12.25 C13.33,11.17 14,9.67 14,8.02 C14,6.37 13.33,4.86 12.25,3.77 L12.25,3.77 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.unmute = unmute;
var unverified = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "unverified",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "unverified",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.67,7.06 L14.59,5.72 C14.42,5.5 14.31,5.24 14.28,4.95 L14.09,3.25 C14.01,2.55 13.46,2 12.76,1.92 L11.06,1.73 C10.76,1.7 10.5,1.57 10.28,1.4 L8.94,0.32 C8.39,-0.12 7.61,-0.12 7.06,0.32 L5.72,1.4 C5.5,1.57 5.24,1.68 4.95,1.71 L3.25,1.9 C2.55,1.98 2,2.53 1.92,3.23 L1.73,4.93 C1.7,5.23 1.57,5.49 1.4,5.71 L0.32,7.05 C-0.12,7.6 -0.12,8.38 0.32,8.93 L1.4,10.27 C1.57,10.49 1.68,10.75 1.71,11.04 L1.9,12.74 C1.98,13.44 2.53,13.99 3.23,14.07 L4.93,14.26 C5.23,14.29 5.49,14.42 5.71,14.59 L7.05,15.67 C7.6,16.11 8.38,16.11 8.93,15.67 L10.27,14.59 C10.49,14.42 10.75,14.31 11.04,14.28 L12.74,14.09 C13.44,14.01 13.99,13.46 14.07,12.76 L14.26,11.06 C14.29,10.76 14.42,10.5 14.59,10.28 L15.67,8.94 C16.11,8.39 16.11,7.61 15.67,7.06 L15.67,7.06 Z M9,11.5 C9,11.78 8.78,12 8.5,12 L7.5,12 C7.23,12 7,11.78 7,11.5 L7,10.5 C7,10.22 7.23,10 7.5,10 L8.5,10 C8.78,10 9,10.22 9,10.5 L9,11.5 L9,11.5 Z M10.56,6.61 C10.5,6.78 10.39,6.94 10.26,7.08 C10.13,7.24 10.12,7.27 9.93,7.46 C9.77,7.63 9.62,7.76 9.41,7.91 C9.3,8 9.21,8.1 9.13,8.18 C9.05,8.26 8.99,8.35 8.94,8.45 C8.89,8.55 8.86,8.64 8.83,8.75 C8.8,8.86 8.8,8.88 8.8,9 L7.13,9 C7.13,8.78 7.13,8.69 7.16,8.52 C7.19,8.33 7.24,8.16 7.3,8 C7.36,7.86 7.44,7.72 7.55,7.58 C7.66,7.45 7.78,7.33 7.96,7.2 C8.23,7.01 8.32,6.9 8.44,6.68 C8.56,6.46 8.64,6.3 8.64,6.09 C8.64,5.82 8.58,5.64 8.44,5.51 C8.31,5.38 8.13,5.32 7.86,5.32 C7.77,5.32 7.67,5.34 7.56,5.37 C7.45,5.4 7.39,5.46 7.31,5.53 C7.23,5.6 7.17,5.64 7.11,5.73 C7.05,5.82 7.02,5.87 7.02,6.01 L5.02,6.01 C5.02,5.63 5.15,5.45 5.29,5.18 C5.45,4.91 5.65,4.68 5.9,4.51 C6.15,4.34 6.45,4.21 6.78,4.13 C7.11,4.05 7.48,4 7.87,4 C8.31,4 8.7,4.05 9.04,4.13 C9.38,4.22 9.67,4.35 9.92,4.52 C10.15,4.69 10.33,4.9 10.47,5.15 C10.6,5.4 10.66,5.7 10.66,6.03 C10.66,6.25 10.66,6.45 10.58,6.62 L10.56,6.61 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.67,7.06 L14.59,5.72 C14.42,5.5 14.31,5.24 14.28,4.95 L14.09,3.25 C14.01,2.55 13.46,2 12.76,1.92 L11.06,1.73 C10.76,1.7 10.5,1.57 10.28,1.4 L8.94,0.32 C8.39,-0.12 7.61,-0.12 7.06,0.32 L5.72,1.4 C5.5,1.57 5.24,1.68 4.95,1.71 L3.25,1.9 C2.55,1.98 2,2.53 1.92,3.23 L1.73,4.93 C1.7,5.23 1.57,5.49 1.4,5.71 L0.32,7.05 C-0.12,7.6 -0.12,8.38 0.32,8.93 L1.4,10.27 C1.57,10.49 1.68,10.75 1.71,11.04 L1.9,12.74 C1.98,13.44 2.53,13.99 3.23,14.07 L4.93,14.26 C5.23,14.29 5.49,14.42 5.71,14.59 L7.05,15.67 C7.6,16.11 8.38,16.11 8.93,15.67 L10.27,14.59 C10.49,14.42 10.75,14.31 11.04,14.28 L12.74,14.09 C13.44,14.01 13.99,13.46 14.07,12.76 L14.26,11.06 C14.29,10.76 14.42,10.5 14.59,10.28 L15.67,8.94 C16.11,8.39 16.11,7.61 15.67,7.06 L15.67,7.06 Z M9,11.5 C9,11.78 8.78,12 8.5,12 L7.5,12 C7.23,12 7,11.78 7,11.5 L7,10.5 C7,10.22 7.23,10 7.5,10 L8.5,10 C8.78,10 9,10.22 9,10.5 L9,11.5 L9,11.5 Z M10.56,6.61 C10.5,6.78 10.39,6.94 10.26,7.08 C10.13,7.24 10.12,7.27 9.93,7.46 C9.77,7.63 9.62,7.76 9.41,7.91 C9.3,8 9.21,8.1 9.13,8.18 C9.05,8.26 8.99,8.35 8.94,8.45 C8.89,8.55 8.86,8.64 8.83,8.75 C8.8,8.86 8.8,8.88 8.8,9 L7.13,9 C7.13,8.78 7.13,8.69 7.16,8.52 C7.19,8.33 7.24,8.16 7.3,8 C7.36,7.86 7.44,7.72 7.55,7.58 C7.66,7.45 7.78,7.33 7.96,7.2 C8.23,7.01 8.32,6.9 8.44,6.68 C8.56,6.46 8.64,6.3 8.64,6.09 C8.64,5.82 8.58,5.64 8.44,5.51 C8.31,5.38 8.13,5.32 7.86,5.32 C7.77,5.32 7.67,5.34 7.56,5.37 C7.45,5.4 7.39,5.46 7.31,5.53 C7.23,5.6 7.17,5.64 7.11,5.73 C7.05,5.82 7.02,5.87 7.02,6.01 L5.02,6.01 C5.02,5.63 5.15,5.45 5.29,5.18 C5.45,4.91 5.65,4.68 5.9,4.51 C6.15,4.34 6.45,4.21 6.78,4.13 C7.11,4.05 7.48,4 7.87,4 C8.31,4 8.7,4.05 9.04,4.13 C9.38,4.22 9.67,4.35 9.92,4.52 C10.15,4.69 10.33,4.9 10.47,5.15 C10.6,5.4 10.66,5.7 10.66,6.03 C10.66,6.25 10.66,6.45 10.58,6.62 L10.56,6.61 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.unverified = unverified;
var verified = {
  "viewBox": "0 0 16 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "verified",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "verified",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M15.67,7.06 L14.59,5.72 C14.42,5.5 14.31,5.24 14.28,4.95 L14.09,3.25 C14.01,2.55 13.46,2 12.76,1.92 L11.06,1.73 C10.76,1.7 10.5,1.57 10.28,1.4 L8.94,0.32 C8.39,-0.12 7.61,-0.12 7.06,0.32 L5.72,1.4 C5.5,1.57 5.24,1.68 4.95,1.71 L3.25,1.9 C2.55,1.98 2,2.53 1.92,3.23 L1.73,4.93 C1.7,5.23 1.57,5.49 1.4,5.71 L0.32,7.05 C-0.12,7.6 -0.12,8.38 0.32,8.93 L1.4,10.27 C1.57,10.49 1.68,10.75 1.71,11.04 L1.9,12.74 C1.98,13.44 2.53,13.99 3.23,14.07 L4.93,14.26 C5.23,14.29 5.49,14.42 5.71,14.59 L7.05,15.67 C7.6,16.11 8.38,16.11 8.93,15.67 L10.27,14.59 C10.49,14.42 10.75,14.31 11.04,14.28 L12.74,14.09 C13.44,14.01 13.99,13.46 14.07,12.76 L14.26,11.06 C14.29,10.76 14.42,10.5 14.59,10.28 L15.67,8.94 C16.11,8.39 16.11,7.61 15.67,7.06 L15.67,7.06 Z M6.5,12 L3,8.5 L4.5,7 L6.5,9 L11.5,4 L13,5.55 L6.5,12 L6.5,12 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M15.67,7.06 L14.59,5.72 C14.42,5.5 14.31,5.24 14.28,4.95 L14.09,3.25 C14.01,2.55 13.46,2 12.76,1.92 L11.06,1.73 C10.76,1.7 10.5,1.57 10.28,1.4 L8.94,0.32 C8.39,-0.12 7.61,-0.12 7.06,0.32 L5.72,1.4 C5.5,1.57 5.24,1.68 4.95,1.71 L3.25,1.9 C2.55,1.98 2,2.53 1.92,3.23 L1.73,4.93 C1.7,5.23 1.57,5.49 1.4,5.71 L0.32,7.05 C-0.12,7.6 -0.12,8.38 0.32,8.93 L1.4,10.27 C1.57,10.49 1.68,10.75 1.71,11.04 L1.9,12.74 C1.98,13.44 2.53,13.99 3.23,14.07 L4.93,14.26 C5.23,14.29 5.49,14.42 5.71,14.59 L7.05,15.67 C7.6,16.11 8.38,16.11 8.93,15.67 L10.27,14.59 C10.49,14.42 10.75,14.31 11.04,14.28 L12.74,14.09 C13.44,14.01 13.99,13.46 14.07,12.76 L14.26,11.06 C14.29,10.76 14.42,10.5 14.59,10.28 L15.67,8.94 C16.11,8.39 16.11,7.61 15.67,7.06 L15.67,7.06 Z M6.5,12 L3,8.5 L4.5,7 L6.5,9 L11.5,4 L13,5.55 L6.5,12 L6.5,12 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.verified = verified;
var versions = {
  "viewBox": "0 0 14 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "versions",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "versions",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M13,3 L7,3 C6.45,3 6,3.45 6,4 L6,12 C6,12.55 6.45,13 7,13 L13,13 C13.55,13 14,12.55 14,12 L14,4 C14,3.45 13.55,3 13,3 L13,3 Z M12,11 L8,11 L8,5 L12,5 L12,11 L12,11 Z M4,4 L5,4 L5,5 L4,5 L4,11 L5,11 L5,12 L4,12 C3.45,12 3,11.55 3,11 L3,5 C3,4.45 3.45,4 4,4 L4,4 Z M1,5 L2,5 L2,6 L1,6 L1,10 L2,10 L2,11 L1,11 C0.45,11 0,10.55 0,10 L0,6 C0,5.45 0.45,5 1,5 L1,5 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M13,3 L7,3 C6.45,3 6,3.45 6,4 L6,12 C6,12.55 6.45,13 7,13 L13,13 C13.55,13 14,12.55 14,12 L14,4 C14,3.45 13.55,3 13,3 L13,3 Z M12,11 L8,11 L8,5 L12,5 L12,11 L12,11 Z M4,4 L5,4 L5,5 L4,5 L4,11 L5,11 L5,12 L4,12 C3.45,12 3,11.55 3,11 L3,5 C3,4.45 3.45,4 4,4 L4,4 Z M1,5 L2,5 L2,6 L1,6 L1,10 L2,10 L2,11 L1,11 C0.45,11 0,10.55 0,10 L0,6 C0,5.45 0.45,5 1,5 L1,5 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.versions = versions;
var watch = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "watch",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "watch",
          "fill": "#000000"
        },
        "children": [{
          "name": "path",
          "attribs": {
            "d": "M6,8 L8,8 L8,9 L5,9 L5,5 L6,5 L6,8 L6,8 Z M12,8 C12,10.22 10.8,12.16 9,13.19 L9,15 C9,15.55 8.55,16 8,16 L4,16 C3.45,16 3,15.55 3,15 L3,13.19 C1.2,12.16 0,10.22 0,8 C0,5.78 1.2,3.84 3,2.81 L3,1 C3,0.45 3.45,0 4,0 L8,0 C8.55,0 9,0.45 9,1 L9,2.81 C10.8,3.84 12,5.78 12,8 L12,8 Z M11,8 C11,5.23 8.77,3 6,3 C3.23,3 1,5.23 1,8 C1,10.77 3.23,13 6,13 C8.77,13 11,10.77 11,8 L11,8 Z",
            "id": "Shape"
          },
          "children": [{
            "name": "path",
            "attribs": {
              "d": "M6,8 L8,8 L8,9 L5,9 L5,5 L6,5 L6,8 L6,8 Z M12,8 C12,10.22 10.8,12.16 9,13.19 L9,15 C9,15.55 8.55,16 8,16 L4,16 C3.45,16 3,15.55 3,15 L3,13.19 C1.2,12.16 0,10.22 0,8 C0,5.78 1.2,3.84 3,2.81 L3,1 C3,0.45 3.45,0 4,0 L8,0 C8.55,0 9,0.45 9,1 L9,2.81 C10.8,3.84 12,5.78 12,8 L12,8 Z M11,8 C11,5.23 8.77,3 6,3 C3.23,3 1,5.23 1,8 C1,10.77 3.23,13 6,13 C8.77,13 11,10.77 11,8 L11,8 Z",
              "id": "Shape"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.watch = watch;
var x = {
  "viewBox": "0 0 12 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "x",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "x",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "7.48 8 11.23 11.75 9.75 13.23 6 9.48 2.25 13.23 0.77 11.75 4.52 8 0.77 4.25 2.25 2.77 6 6.52 9.75 2.77 11.23 4.25"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "7.48 8 11.23 11.75 9.75 13.23 6 9.48 2.25 13.23 0.77 11.75 4.52 8 0.77 4.25 2.25 2.77 6 6.52 9.75 2.77 11.23 4.25"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.x = x;
var zap = {
  "viewBox": "0 0 10 16",
  "children": [{
    "name": "title",
    "attribs": {},
    "children": []
  }, {
    "name": "desc",
    "attribs": {},
    "children": []
  }, {
    "name": "defs",
    "attribs": {},
    "children": []
  }, {
    "name": "g",
    "attribs": {
      "id": "Octicons",
      "stroke": "none",
      "stroke-width": "1",
      "fill": "none",
      "fill-rule": "evenodd"
    },
    "children": [{
      "name": "g",
      "attribs": {
        "id": "zap",
        "fill": "#000000"
      },
      "children": [{
        "name": "g",
        "attribs": {
          "id": "zap",
          "fill": "#000000"
        },
        "children": [{
          "name": "polygon",
          "attribs": {
            "id": "Shape",
            "points": "10 7 6 7 9 0 0 9 4 9 1 16"
          },
          "children": [{
            "name": "polygon",
            "attribs": {
              "id": "Shape",
              "points": "10 7 6 7 9 0 0 9 4 9 1 16"
            },
            "children": []
          }]
        }]
      }]
    }]
  }]
};
exports.zap = zap;

/***/ }),
/* 1413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.documentIcon = exports.documentText = exports.documentDelete = exports.documentAdd = exports.divide = exports.divideOutline = exports.directions = exports.deviceTablet = exports.devicePhone = exports.deviceLaptop = exports.deviceDesktop = exports.deleteIconic = exports.deleteOutline = exports.database = exports.css3 = exports.creditCard = exports.contacts = exports.compass = exports.cog = exports.cogOutline = exports.coffee = exports.code = exports.codeOutline = exports.cloudStorage = exports.cloudStorageOutline = exports.clipboard = exports.chevronRight = exports.chevronRightOutline = exports.chevronLeft = exports.chevronLeftOutline = exports.chartPie = exports.chartPieOutline = exports.chartLine = exports.chartLineOutline = exports.chartBar = exports.chartBarOutline = exports.chartArea = exports.chartAreaOutline = exports.cancel = exports.cancelOutline = exports.camera = exports.cameraOutline = exports.calendar = exports.calendarOutline = exports.calculator = exports.businessCard = exports.brush = exports.briefcase = exports.bookmark = exports.book = exports.bell = exports.beer = exports.beaker = exports.batteryMid = exports.batteryLow = exports.batteryHigh = exports.batteryFull = exports.batteryCharge = exports.backspace = exports.backspaceOutline = exports.attachment = exports.attachmentOutline = exports.at = exports.arrowUp = exports.arrowUpThick = exports.arrowUpOutline = exports.arrowUnsorted = exports.arrowSync = exports.arrowSyncOutline = exports.arrowSortedUp = exports.arrowSortedDown = exports.arrowShuffle = exports.arrowRight = exports.arrowRightThick = exports.arrowRightOutline = exports.arrowRepeat = exports.arrowRepeatOutline = exports.arrowMove = exports.arrowMoveOutline = exports.arrowMinimise = exports.arrowMinimiseOutline = exports.arrowMaximise = exports.arrowMaximiseOutline = exports.arrowLoop = exports.arrowLoopOutline = exports.arrowLeft = exports.arrowLeftThick = exports.arrowLeftOutline = exports.arrowForward = exports.arrowForwardOutline = exports.arrowDown = exports.arrowDownThick = exports.arrowDownOutline = exports.arrowBack = exports.arrowBackOutline = exports.archive = exports.anchor = exports.anchorOutline = exports.adjustContrast = exports.adjustBrightness = void 0;
exports.pi = exports.piOutline = exports.phone = exports.phoneOutline = exports.pencil = exports.pen = exports.notes = exports.notesOutline = exports.news = exports.mortarBoard = exports.minus = exports.minusOutline = exports.microphone = exports.microphoneOutline = exports.messages = exports.message = exports.messageTyping = exports.mediaStop = exports.mediaStopOutline = exports.mediaRewind = exports.mediaRewindOutline = exports.mediaRecord = exports.mediaRecordOutline = exports.mediaPlay = exports.mediaPlayReverse = exports.mediaPlayReverseOutline = exports.mediaPlayOutline = exports.mediaPause = exports.mediaPauseOutline = exports.mediaFastForward = exports.mediaFastForwardOutline = exports.mediaEject = exports.mediaEjectOutline = exports.map = exports.mail = exports.lockOpen = exports.lockOpenOutline = exports.lockClosed = exports.lockClosedOutline = exports.location = exports.locationOutline = exports.locationArrow = exports.locationArrowOutline = exports.link = exports.linkOutline = exports.lightbulb = exports.leaf = exports.keyboard = exports.key = exports.keyOutline = exports.inputChecked = exports.inputCheckedOutline = exports.info = exports.infoOutline = exports.infoLarge = exports.infoLargeOutline = exports.infinity = exports.infinityOutline = exports.image = exports.imageOutline = exports.html5 = exports.home = exports.homeOutline = exports.heart = exports.heartOutline = exports.heartHalfOutline = exports.heartFullOutline = exports.headphones = exports.group = exports.groupOutline = exports.globe = exports.globeOutline = exports.gift = exports.folder = exports.folderOpen = exports.folderDelete = exports.folderAdd = exports.flowSwitch = exports.flowParallel = exports.flowMerge = exports.flowChildren = exports.flash = exports.flashOutline = exports.flag = exports.flagOutline = exports.filter = exports.film = exports.feather = exports.eye = exports.eyeOutline = exports.exportIcon = exports.exportOutline = exports.equals = exports.equalsOutline = exports.eject = exports.ejectOutline = exports.edit = exports.dropbox = exports.download = exports.downloadOutline = void 0;
exports.userOutline = exports.userDelete = exports.userDeleteOutline = exports.userAdd = exports.userAddOutline = exports.upload = exports.uploadOutline = exports.tree = exports.trash = exports.times = exports.timesOutline = exports.time = exports.ticket = exports.tick = exports.tickOutline = exports.thumbsUp = exports.thumbsOk = exports.thumbsDown = exports.thermometer = exports.thSmall = exports.thSmallOutline = exports.thMenu = exports.thMenuOutline = exports.thList = exports.thListOutline = exports.thLarge = exports.thLargeOutline = exports.tags = exports.tag = exports.tabsOutline = exports.support = exports.stopwatch = exports.starburst = exports.starburstOutline = exports.star = exports.starOutline = exports.starHalf = exports.starHalfOutline = exports.starFullOutline = exports.spiral = exports.spanner = exports.spannerOutline = exports.sortNumerically = exports.sortNumericallyOutline = exports.sortAlphabetically = exports.sortAlphabeticallyOutline = exports.socialYoutube = exports.socialYoutubeCircular = exports.socialVimeo = exports.socialVimeoCircular = exports.socialTwitter = exports.socialTwitterCircular = exports.socialTumbler = exports.socialTumblerCircular = exports.socialSkype = exports.socialSkypeOutline = exports.socialPinterest = exports.socialPinterestCircular = exports.socialLinkedin = exports.socialLinkedinCircular = exports.socialLastFm = exports.socialLastFmCircular = exports.socialInstagram = exports.socialInstagramCircular = exports.socialGooglePlus = exports.socialGooglePlusCircular = exports.socialGithub = exports.socialGithubCircular = exports.socialFlickr = exports.socialFlickrCircular = exports.socialFacebook = exports.socialFacebookCircular = exports.socialDribbble = exports.socialDribbbleCircular = exports.socialAtCircular = exports.shoppingCart = exports.shoppingBag = exports.scissors = exports.scissorsOutline = exports.rss = exports.rssOutline = exports.refresh = exports.refreshOutline = exports.radar = exports.radarOutline = exports.puzzle = exports.puzzleOutline = exports.printer = exports.power = exports.powerOutline = exports.pointOfInterest = exports.pointOfInterestOutline = exports.plus = exports.plusOutline = exports.plug = exports.plane = exports.planeOutline = exports.pipette = exports.pin = exports.pinOutline = void 0;
exports.zoom = exports.zoomOutline = exports.zoomOut = exports.zoomOutOutline = exports.zoomIn = exports.zoomInOutline = exports.world = exports.worldOutline = exports.wine = exports.wiFi = exports.wiFiOutline = exports.weatherWindy = exports.weatherWindyCloudy = exports.weatherSunny = exports.weatherStormy = exports.weatherSnow = exports.weatherShower = exports.weatherPartlySunny = exports.weatherNight = exports.weatherDownpour = exports.weatherCloudy = exports.waves = exports.wavesOutline = exports.watch = exports.warning = exports.warningOutline = exports.volume = exports.volumeUp = exports.volumeMute = exports.volumeDown = exports.video = exports.videoOutline = exports.vendorMicrosoft = exports.vendorApple = exports.vendorAndroid = exports.user = void 0;
var adjustBrightness = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6.934l1-2.934c.072-.213.078-.452 0-.682-.188-.553-.789-.848-1.341-.659-.553.189-.847.788-.659 1.341l1 2.934zM4 11c-.213-.072-.452-.078-.682 0-.553.188-.848.789-.659 1.341.189.553.788.847 1.341.659l2.934-1-2.934-1zM12 17.066l-1 2.934c-.072.213-.078.452 0 .682.188.553.789.848 1.341.659.553-.189.847-.788.659-1.341l-1-2.934zM21.341 11.657c-.188-.553-.788-.848-1.341-.659l-2.934 1 2.934 1c.213.072.452.078.682 0 .552-.188.847-.789.659-1.341zM5.636 7.05l2.781 1.367-1.367-2.781c-.1-.202-.265-.375-.482-.482-.524-.258-1.157-.042-1.415.482-.257.523-.041 1.157.483 1.414zM5.153 17.432c-.257.523-.041 1.156.482 1.414.523.257 1.157.041 1.414-.482l1.367-2.781-2.781 1.367c-.201.099-.374.263-.482.482zM18.363 16.949l-2.781-1.367 1.367 2.781c.1.202.264.375.482.482.523.257 1.156.041 1.414-.482s.042-1.157-.482-1.414zM18.844 6.566c.258-.524.042-1.157-.481-1.415-.523-.257-1.157-.041-1.414.482l-1.369 2.783 2.782-1.368c.202-.1.375-.264.482-.482zM12 7.5c-2.481 0-4.5 2.019-4.5 4.5s2.019 4.5 4.5 4.5 4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
    },
    "children": []
  }]
};
exports.adjustBrightness = adjustBrightness;
var adjustContrast = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 14c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6zM12 7v10c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 4c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 14c-3.314 0-6-2.686-6-6s2.686-6 6-6 6 2.686 6 6-2.686 6-6 6zM12 7v10c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.adjustContrast = adjustContrast;
var anchorOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "circle",
      "attribs": {
        "cx": "12",
        "cy": "6",
        "r": "1"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "12",
          "cy": "6",
          "r": "1"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M19.793 12.096c.134-.34.207-.709.207-1.096 0-1.654-1.346-3-3-3h-.422c.273-.619.422-1.297.422-2 0-2.757-2.243-5-5-5s-5 2.243-5 5c0 .703.149 1.381.422 2h-.422c-1.654 0-3 1.346-3 3 0 .387.073.756.207 1.096-.732.548-1.207 1.422-1.207 2.404 0 4.963 4.037 9 9 9s9-4.037 9-9c0-.982-.475-1.856-1.207-2.404zm-7.793 9.404c-3.859 0-7-3.141-7-7 0-.553.447-1 1-1s1 .447 1 1c0 2.414 1.721 4.434 4 4.898v-7.398h-4c-.553 0-1-.447-1-1s.447-1 1-1h4v-1.184c-1.162-.413-2-1.511-2-2.816 0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.305-.838 2.403-2 2.816v1.184h4c.553 0 1 .447 1 1s-.447 1-1 1h-4v7.398c2.279-.465 4-2.484 4-4.898 0-.553.447-1 1-1s1 .447 1 1c0 3.859-3.141 7-7 7zm-4.679-8.5h2.679v4.962c-1.207-.701-2-2.009-2-3.462 0-.597-.263-1.133-.679-1.5zm9.358 0c-.416.367-.679.903-.679 1.5 0 1.453-.793 2.761-2 3.462v-4.962h2.679z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M19.793 12.096c.134-.34.207-.709.207-1.096 0-1.654-1.346-3-3-3h-.422c.273-.619.422-1.297.422-2 0-2.757-2.243-5-5-5s-5 2.243-5 5c0 .703.149 1.381.422 2h-.422c-1.654 0-3 1.346-3 3 0 .387.073.756.207 1.096-.732.548-1.207 1.422-1.207 2.404 0 4.963 4.037 9 9 9s9-4.037 9-9c0-.982-.475-1.856-1.207-2.404zm-7.793 9.404c-3.859 0-7-3.141-7-7 0-.553.447-1 1-1s1 .447 1 1c0 2.414 1.721 4.434 4 4.898v-7.398h-4c-.553 0-1-.447-1-1s.447-1 1-1h4v-1.184c-1.162-.413-2-1.511-2-2.816 0-1.657 1.343-3 3-3s3 1.343 3 3c0 1.305-.838 2.403-2 2.816v1.184h4c.553 0 1 .447 1 1s-.447 1-1 1h-4v7.398c2.279-.465 4-2.484 4-4.898 0-.553.447-1 1-1s1 .447 1 1c0 3.859-3.141 7-7 7zm-4.679-8.5h2.679v4.962c-1.207-.701-2-2.009-2-3.462 0-.597-.263-1.133-.679-1.5zm9.358 0c-.416.367-.679.903-.679 1.5 0 1.453-.793 2.761-2 3.462v-4.962h2.679z"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "12",
        "cy": "6",
        "r": "1"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "12",
          "cy": "6",
          "r": "1"
        },
        "children": []
      }]
    }]
  }]
};
exports.anchorOutline = anchorOutline;
var anchor = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 13.5c-.553 0-1 .447-1 1 0 2.414-1.721 4.434-4 4.898v-7.398h4c.553 0 1-.447 1-1s-.447-1-1-1h-4v-1.184c1.162-.413 2-1.511 2-2.816 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.305.838 2.403 2 2.816v1.184h-4c-.553 0-1 .447-1 1s.447 1 1 1h4v7.398c-2.279-.465-4-2.484-4-4.898 0-.553-.447-1-1-1s-1 .447-1 1c0 3.859 3.141 7 7 7s7-3.141 7-7c0-.553-.447-1-1-1zm-6-8.5c.551 0 1 .449 1 1s-.449 1-1 1-1-.449-1-1 .449-1 1-1z"
    },
    "children": []
  }]
};
exports.anchor = anchor;
var archive = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M13 12h-3c-.276 0-.5.224-.5.5s.224.5.5.5h3c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM20 5h-17c-.553 0-1 .448-1 1s.447 1 1 1h17c.553 0 1-.448 1-1s-.447-1-1-1zM18 8h-13c-.553 0-1 .448-1 1v8c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-8c0-.552-.447-1-1-1zm-2 10h-9c-.552 0-1-.449-1-1v-7h11v7c0 .551-.448 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M13 12h-3c-.276 0-.5.224-.5.5s.224.5.5.5h3c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM20 5h-17c-.553 0-1 .448-1 1s.447 1 1 1h17c.553 0 1-.448 1-1s-.447-1-1-1zM18 8h-13c-.553 0-1 .448-1 1v8c0 1.654 1.346 3 3 3h9c1.654 0 3-1.346 3-3v-8c0-.552-.447-1-1-1zm-2 10h-9c-.552 0-1-.449-1-1v-7h11v7c0 .551-.448 1-1 1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.archive = archive;
var arrowBackOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.164 19.547c-1.641-2.5-3.669-3.285-6.164-3.484v1.437c0 .534-.208 1.036-.586 1.414-.756.756-2.077.751-2.823.005l-6.293-6.207c-.191-.189-.298-.444-.298-.713s.107-.524.298-.712l6.288-6.203c.754-.755 2.073-.756 2.829.001.377.378.585.88.585 1.414v1.704c4.619.933 8 4.997 8 9.796v1c0 .442-.29.832-.714.958-.095.027-.19.042-.286.042-.331 0-.646-.165-.836-.452zm-7.141-5.536c2.207.056 4.638.394 6.758 2.121-.768-3.216-3.477-5.702-6.893-6.08-.504-.056-.888-.052-.888-.052v-3.497l-5.576 5.496 5.576 5.5v-3.499l1.023.011z"
    },
    "children": []
  }]
};
exports.arrowBackOutline = arrowBackOutline;
var arrowBack = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 9.059v-2.559c0-.256-.098-.512-.293-.708-.195-.195-.451-.292-.707-.292s-.512.097-.707.292l-6.293 6.208 6.293 6.207c.195.195.451.293.707.293s.512-.098.707-.293.293-.452.293-.707v-2.489c2.75.068 5.755.566 8 3.989v-1c0-4.633-3.5-8.443-8-8.941z"
    },
    "children": []
  }]
};
exports.arrowBack = arrowBack;
var arrowDownOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 21.312l-7.121-7.121c-1.17-1.17-1.17-3.073 0-4.242 1.094-1.094 2.978-1.138 4.121-.115v-4.834c0-1.654 1.346-3 3-3s3 1.346 3 3v4.834c1.143-1.023 3.027-.979 4.121.115 1.17 1.169 1.17 3.072 0 4.242l-7.121 7.121zm-5-10.242c-.268 0-.518.104-.707.293-.391.39-.391 1.023 0 1.414l5.707 5.707 5.707-5.707c.391-.391.391-1.024 0-1.414-.379-.379-1.035-.379-1.414 0l-3.293 3.293v-9.656c0-.551-.448-1-1-1s-1 .449-1 1v9.656l-3.293-3.293c-.189-.189-.439-.293-.707-.293z"
    },
    "children": []
  }]
};
exports.arrowDownOutline = arrowDownOutline;
var arrowDownThick = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.414 10.656c-.781-.781-2.047-.781-2.828 0l-1.586 1.586v-7.242c0-1.105-.896-2-2-2-1.105 0-2 .895-2 2v7.242l-1.586-1.586c-.781-.781-2.047-.781-2.828 0s-.781 2.047 0 2.828l6.414 6.414 6.414-6.414c.781-.781.781-2.046 0-2.828z"
    },
    "children": []
  }]
};
exports.arrowDownThick = arrowDownThick;
var arrowDown = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.707 13.293c-.391-.391-1.023-.391-1.414 0l-2.293 2.293v-7.586c0-.552-.447-1-1-1s-1 .448-1 1v7.586l-2.293-2.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l4.707 4.707 4.707-4.707c.391-.391.391-1.023 0-1.414z"
    },
    "children": []
  }]
};
exports.arrowDown = arrowDown;
var arrowForwardOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 19.999c-.096 0-.191-.015-.286-.042-.424-.126-.714-.516-.714-.958v-1c0-4.8 3.381-8.864 8-9.796v-1.704c0-.534.208-1.036.585-1.414.756-.757 2.075-.756 2.829-.001l6.288 6.203c.191.188.298.443.298.712s-.107.524-.298.712l-6.293 6.207c-.746.746-2.067.751-2.823-.005-.378-.378-.586-.88-.586-1.414v-1.437c-2.495.201-4.523.985-6.164 3.484-.19.288-.505.453-.836.453zm8-5.989l1-.01v3.499l5.576-5.5-5.576-5.496v3.497s-.384-.004-.891.052c-3.416.378-6.125 2.864-6.892 6.08 2.121-1.728 4.551-2.066 6.783-2.122z"
    },
    "children": []
  }]
};
exports.arrowForwardOutline = arrowForwardOutline;
var arrowForward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 5.499c-.256 0-.512.097-.707.292-.195.196-.293.452-.293.708v2.559c-4.5.498-8 4.309-8 8.941v1c2.245-3.423 5.25-3.92 8-3.989v2.489c0 .255.098.512.293.707s.451.293.707.293.512-.098.707-.293l6.293-6.207-6.293-6.208c-.195-.195-.451-.292-.707-.292z"
    },
    "children": []
  }]
};
exports.arrowForward = arrowForward;
var arrowLeftOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.928 21c-.801 0-1.555-.312-2.121-.879l-7.121-7.121 7.121-7.121c1.133-1.134 3.109-1.134 4.242 0 .566.564.879 1.317.879 2.119 0 .746-.27 1.451-.764 2.002h4.836c1.654 0 3 1.346 3 3s-1.346 3-3 3h-4.836c.493.549.764 1.252.764 1.998.002.802-.312 1.557-.879 2.124-.567.566-1.32.878-2.121.878zm-6.414-8l5.707 5.707c.379.378 1.035.378 1.414 0 .189-.189.293-.441.293-.708s-.104-.517-.291-.705l-3.295-3.294h9.658c.552 0 1-.449 1-1s-.448-1-1-1h-9.658l3.293-3.293c.189-.189.293-.441.293-.708s-.104-.517-.292-.705c-.381-.38-1.036-.379-1.415-.001l-5.707 5.707z"
    },
    "children": []
  }]
};
exports.arrowLeftOutline = arrowLeftOutline;
var arrowLeftThick = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 11h-7.244l1.586-1.586c.781-.781.781-2.049 0-2.828-.781-.781-2.047-.781-2.828 0l-6.414 6.414 6.414 6.414c.39.391.902.586 1.414.586s1.023-.195 1.414-.586c.781-.781.781-2.049 0-2.828l-1.586-1.586h7.244c1.104 0 2-.896 2-2 0-1.105-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.arrowLeftThick = arrowLeftThick;
var arrowLeft = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 11h-7.586l2.293-2.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-4.707 4.707 4.707 4.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-2.293-2.293h7.586c.552 0 1-.448 1-1s-.448-1-1-1z"
    },
    "children": []
  }]
};
exports.arrowLeft = arrowLeft;
var arrowLoopOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.994 7.187l.006-.187c0-.801-.312-1.555-.879-2.121-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879l-2.883 2.883c-.531-.474-1.23-.762-1.996-.762h-1c-3.859 0-7 3.14-7 7s3.141 7 7 7h9c3.859 0 7-3.14 7-7 0-3.306-2.14-6.084-5.006-6.813zm-1.994 11.813h-9c-2.757 0-5-2.243-5-5s2.243-5 5-5h1c.553 0 1 .448 1 1s-.447 1-1 1h-1c-1.654 0-3 1.346-3 3s1.346 3 3 3h9c1.654 0 3-1.346 3-3s-1.121-3-2.5-3h-2.086l1.293 1.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.707-3.707 3.707-3.707c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-1.293 1.293h2.086c2.481 0 4.5 2.243 4.5 5s-2.243 5-5 5zm.749-6.971c.7.164 1.251 1 1.251 1.971 0 1.103-.897 2-2 2h-9c-1.103 0-2-.897-2-2s.897-2 2-2h1c.856 0 1.588-.541 1.873-1.299l3.713 3.713c.378.378.88.586 1.414.586s1.036-.208 1.414-.586.586-.88.586-1.414c0-.345-.087-.677-.251-.971z"
    },
    "children": []
  }]
};
exports.arrowLoopOutline = arrowLoopOutline;
var arrowLoop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 8h-2.086l1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.707 3.707 3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293h2.086c1.379 0 2.5 1.346 2.5 3s-1.346 3-3 3h-8c-1.654 0-3-1.346-3-3s1.346-3 3-3c.553 0 1-.448 1-1s-.447-1-1-1c-2.757 0-5 2.243-5 5s2.243 5 5 5h8c2.757 0 5-2.243 5-5s-2.019-5-4.5-5z"
    },
    "children": []
  }]
};
exports.arrowLoop = arrowLoop;
var arrowMaximiseOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 3h-5.243c-1.302 0-2.401.838-2.815 2h-6.942v7.061l.012.12c-1.167.41-2.012 1.512-2.012 2.819v7h7c1.311 0 2.593-.826 3-2h7v-7.061l-.012-.12c1.167-.41 2.012-1.512 2.012-2.819v-7h-2zm-2 15h-5c-.553 0-1-.448-1-1s.447-1 1-1h3v-3.061c0-.552.447-1 1-1s1 .448 1 1v5.061zm-11-11h5.061c.553 0 1 .448 1 1s-.447 1-1 1h-3.061v3.061c0 .552-.448 1-1 1-.553 0-1-.448-1-1v-5.061zm13 3c0 .552-.447 1-1 1s-1-.448-1-1v-1.586l-3.293 3.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l3.293-3.293h-1.586c-.553 0-1-.448-1-1s.447-1 1-1h5v5zm-10 10h-5v-5c0-.552.447-1 1-1s1 .448 1 1v1.586l3.293-3.293c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-3.293 3.293h1.586c.553 0 1 .448 1 1s-.448 1-1 1zm2.414-7.414c-.378-.378-.88-.586-1.414-.586-.367 0-.716.105-1.023.289l.023-.228v-2.061h2.061l.229-.023c-.186.307-.29.656-.29 1.023 0 .534.208 1.036.586 1.414s.88.586 1.414.586c.367 0 .716-.105 1.023-.289l-.023.228v2.061h-1.939c-.122 0-.24.015-.356.036.189-.31.295-.664.295-1.036 0-.534-.208-1.036-.586-1.414z"
    },
    "children": []
  }]
};
exports.arrowMaximiseOutline = arrowMaximiseOutline;
var arrowMaximise = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 4c-.553 0-1 .448-1 1s.447 1 1 1h1.586l-3.293 3.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.293-3.293v1.586c0 .552.447 1 1 1s1-.448 1-1v-5h-5zM9.293 13.293l-3.293 3.293v-1.586c0-.552-.447-1-1-1s-1 .448-1 1v4.999h.996l4.004.001c.552 0 1-.448 1-1s-.447-1-1-1h-1.586l3.293-3.292c.391-.391.391-1.023 0-1.414s-1.023-.392-1.414-.001zM7 12c.552 0 1-.448 1-1v-3h3c.553 0 1-.448 1-1s-.447-1-1-1h-4.999l-.001 5c0 .552.447 1 1 1zM17 12c-.553 0-1 .448-1 1v3h-3c-.553 0-1 .448-1 1s.447 1 1 1h5v-5c0-.552-.447-1-1-1z"
    },
    "children": []
  }]
};
exports.arrowMaximise = arrowMaximise;
var arrowMinimiseOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22 6c0-.801-.312-1.555-.879-2.121-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879l-.883.883c-.531-.474-1.23-.762-1.996-.762-.919 0-1.732.424-2.283 1.077-.212-.047-.431-.077-.656-.077h-6.061v6.06c0 .255.042.499.102.736-.598.549-.98 1.33-.98 2.204 0 .735.266 1.409.705 1.931l-.947.948c-.568.566-.88 1.32-.88 2.121s.312 1.555.879 2.121c.566.567 1.32.879 2.121.879.539 0 1.334-.152 2.061-.879l.903-.919c.535.495 1.251.798 2.036.798.934 0 1.758-.437 2.309-1.107.241.063.49.107.752.107h5.939v-6.061c0-.226-.029-.444-.077-.656.653-.55 1.077-1.364 1.077-2.283 0-.766-.288-1.465-.762-1.996l.883-.883c.567-.566.879-1.32.879-2.121zm-15 1h4c.553 0 1 .448 1 1s-.447 1-1 1h-2v2c0 .552-.448 1-1 1-.553 0-1-.448-1-1v-4zm12.707-.293l-3.293 3.293h1.586c.553 0 1 .448 1 1s-.448 1-1 1h-5v-5c0-.552.447-1 1-1s1 .448 1 1v1.586l3.293-3.293c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414zm-7.707 11.293c0 .552-.447 1-1 1s-1-.448-1-1v-1.707l-3.354 3.414c-.195.195-.39.293-.646.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l3.293-3.293h-1.465c-.553 0-1-.448-1-1s.447-1 1-1h4.879v5zm0-6h-2.278c.173-.295.278-.634.278-1v-1h1.061c.342 0 .658-.094.939-.245v2.245zm1 1h2.713c-.433.094-.713.33-.713.939v1.061h-.939c-.391 0-.752.117-1.061.311v-2.311zm.061 4c0-.552.447-1 1-1h1.939v-2c0-.552.447-1 1-1s1 .448 1 1v4h-3.939c-.553 0-1-.448-1-1z"
    },
    "children": []
  }]
};
exports.arrowMinimiseOutline = arrowMinimiseOutline;
var arrowMinimise = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.121 13c-.553 0-1 .448-1 1s.447 1 1 1h1.465l-3.293 3.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.414-3.414v1.707c0 .552.447 1 1 1s.879-.448.879-1v-5h-4.879zM7 11c.552 0 1-.448 1-1v-2h2c.553 0 1-.448 1-1s-.447-1-1-1h-3.999l-.001 4c0 .552.447 1 1 1zM17 13c-.553 0-1 .448-1 1v2h-2c-.553 0-1 .448-1 1s.447 1 1 1h4v-4c0-.552-.447-1-1-1zM18.293 4.293l-3.293 3.293v-1.586c0-.552-.447-1-1-1s-1 .448-1 1v5h5c.552 0 1-.448 1-1s-.447-1-1-1h-1.586l3.293-3.292c.391-.391.391-1.023 0-1.414s-1.023-.392-1.414-.001z"
    },
    "children": []
  }]
};
exports.arrowMinimise = arrowMinimise;
var arrowMoveOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.828 10.586l-9.414-9.414c-.391-.391-.902-.586-1.414-.586s-1.023.195-1.414.586l-9.414 9.414c-.781.779-.781 2.047 0 2.828l9.414 9.414c.391.391.902.586 1.414.586s1.023-.195 1.414-.586l9.414-9.414c.781-.781.781-2.049 0-2.828zm-5.828 5.414c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l1.293-1.293h-4.586v4.586l1.293-1.293c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-3.707 3.707-3.707-3.707c-.391-.391-.391-1.023 0-1.414.195-.195.451-.293.707-.293s.512.098.707.293l1.293 1.293v-4.586h-4.586l1.293 1.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.707-3.707 3.707-3.707c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-1.293 1.293h4.586v-4.586l-1.293 1.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l3.707-3.707 3.707 3.707c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.293-1.293v4.586h4.586l-1.293-1.293c-.391-.391-.391-1.023 0-1.414.195-.195.451-.293.707-.293s.512.098.707.293l3.707 3.707-3.707 3.707c-.195.195-.451.293-.707.293zm-1.732-2c-.175.301-.268.643-.268 1-.357 0-.699.093-1 .268v-1.268h1.268zm-6.536 0h1.268v1.268c-.301-.175-.643-.268-1-.268 0-.357-.093-.699-.268-1zm0-4c.175-.301.268-.643.268-1 .357 0 .699-.093 1-.268v1.268h-1.268zm6.536 0h-1.268v-1.268c.301.175.643.268 1 .268 0 .357.093.699.268 1z"
    },
    "children": []
  }]
};
exports.arrowMoveOutline = arrowMoveOutline;
var arrowMove = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.707 8.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.293 1.293h-4.586v-4.586l1.293 1.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-3.707-3.707-3.707 3.707c-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0l1.293-1.293v4.586h-4.586l1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.707 3.707 3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293h4.586v4.586l-1.293-1.293c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l3.707 3.707 3.707-3.707c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.293 1.293v-4.586h4.586l-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.707-3.707-3.707-3.707z"
    },
    "children": []
  }]
};
exports.arrowMove = arrowMove;
var arrowRepeatOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.994 7.187l.006-.187c0-.801-.312-1.555-.879-2.121-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879l-2.892 2.891c-.53-.473-1.221-.77-1.987-.77h-1c-3.859 0-7 3.14-7 7 0 3.306 2.14 6.084 5.006 6.813l-.006.187c0 .801.312 1.555.879 2.121.566.567 1.32.879 2.121.879s1.555-.312 2.121-.879l2.892-2.891c.53.473 1.221.77 1.987.77h1c3.859 0 7-3.14 7-7 0-3.306-2.14-6.084-5.006-6.813zm-1.994 11.813h-1c-.553 0-1-.448-1-1s.447-1 1-1h1c1.654 0 3-1.346 3-3s-1.121-3-2.5-3h-2.086l1.293 1.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.707-3.707 3.707-3.707c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-1.293 1.293h2.086c2.481 0 4.5 2.243 4.5 5s-2.243 5-5 5zm.749-6.971c.7.164 1.251 1 1.251 1.971 0 1.103-.897 2-2 2h-1c-.857 0-1.584.544-1.868 1.304l-3.718-3.718c-.378-.378-.88-.586-1.414-.586s-1.036.208-1.414.586-.586.88-.586 1.414c0 .345.087.677.251.971-.7-.164-1.251-1-1.251-1.971 0-1.103.897-2 2-2h1c.857 0 1.584-.544 1.868-1.304l3.718 3.718c.378.378.88.586 1.414.586s1.036-.208 1.414-.586.586-.88.586-1.414c0-.345-.087-.677-.251-.971zm-7.749-2.029c0 .552-.447 1-1 1h-1c-1.654 0-3 1.346-3 3s1.121 3 2.5 3h2.086l-1.293-1.293c-.391-.391-.391-1.023 0-1.414.195-.195.451-.293.707-.293s.512.098.707.293l3.707 3.707-3.707 3.707c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l1.293-1.293h-2.086c-2.481 0-4.5-2.243-4.5-5s2.243-5 5-5h1c.553 0 1 .448 1 1z"
    },
    "children": []
  }]
};
exports.arrowRepeatOutline = arrowRepeatOutline;
var arrowRepeat = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 7h-2.086l1.293-1.293c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.707 3.707 3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.293-1.293h2.086c1.379 0 2.5 1.346 2.5 3s-1.346 3-3 3c-.553 0-1 .448-1 1s.447 1 1 1c2.757 0 5-2.243 5-5s-2.019-5-4.5-5zM8.293 12.293c-.391.391-.391 1.023 0 1.414l1.293 1.293h-2.086c-1.379 0-2.5-1.346-2.5-3s1.346-3 3-3c.553 0 1-.448 1-1s-.447-1-1-1c-2.757 0-5 2.243-5 5s2.019 5 4.5 5h2.086l-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.707-3.707-3.707-3.707c-.391-.391-1.023-.391-1.414 0z"
    },
    "children": []
  }]
};
exports.arrowRepeat = arrowRepeat;
var arrowRightOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 21c-.801 0-1.555-.312-2.121-.879s-.88-1.321-.879-2.123c0-.746.271-.998.764-1.998h-4.836c-1.654 0-3-1.347-3-3 0-1.654 1.346-3 3-3h4.836c-.494-1-.764-1.255-.764-2.001.001-.802.312-1.554.88-2.121 1.132-1.132 3.108-1.133 4.241.001l7.121 7.121-7.121 7.121c-.566.567-1.32.879-2.121.879zm-7.072-9c-.552 0-1 .449-1 1s.448 1 1 1h9.658l-3.293 3.293c-.189.189-.293.439-.293.706 0 .269.104.519.293.708.379.378 1.035.378 1.414 0l5.707-5.707-5.707-5.707c-.379-.378-1.035-.378-1.414 0-.189.189-.293.439-.293.706 0 .268.104.519.293.708l3.293 3.293h-9.658z"
    },
    "children": []
  }]
};
exports.arrowRightOutline = arrowRightOutline;
var arrowRightThick = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.586 6.586c-.781.779-.781 2.047 0 2.828l1.586 1.586h-7.244c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2h7.244l-1.586 1.586c-.781.779-.781 2.047 0 2.828.391.391.902.586 1.414.586s1.023-.195 1.414-.586l6.414-6.414-6.414-6.414c-.781-.781-2.047-.781-2.828 0z"
    },
    "children": []
  }]
};
exports.arrowRightThick = arrowRightThick;
var arrowRight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.293 7.293c-.391.391-.391 1.023 0 1.414l2.293 2.293h-7.586c-.552 0-1 .448-1 1s.448 1 1 1h7.586l-2.293 2.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l4.707-4.707-4.707-4.707c-.391-.391-1.023-.391-1.414 0z"
    },
    "children": []
  }]
};
exports.arrowRight = arrowRight;
var arrowShuffle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 9h3.5c.736 0 1.393.391 1.851 1.001.325-.604.729-1.163 1.191-1.662-.803-.823-1.866-1.339-3.042-1.339h-3.5c-.553 0-1 .448-1 1s.447 1 1 1zM11.685 12.111c.551-1.657 2.256-3.111 3.649-3.111h1.838l-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.707-3.707-3.707-3.707c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.293 1.293h-1.838c-2.274 0-4.711 1.967-5.547 4.479l-.472 1.411c-.641 1.926-2.072 3.11-2.815 3.11h-2.5c-.553 0-1 .448-1 1s.447 1 1 1h2.5c1.837 0 3.863-1.925 4.713-4.479l.472-1.41zM15.879 13.293c-.391.391-.391 1.023 0 1.414l1.293 1.293h-2.338c-1.268 0-2.33-.891-2.691-2.108-.256.75-.627 1.499-1.09 2.185.886 1.162 2.243 1.923 3.781 1.923h2.338l-1.293 1.293c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l3.707-3.707-3.707-3.707c-.391-.391-1.023-.391-1.414 0z"
    },
    "children": []
  }]
};
exports.arrowShuffle = arrowShuffle;
var arrowSortedDown = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.8 9.7l6.2 6.3 6.2-6.3c.2-.2.3-.5.3-.7s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3h-11c-.3 0-.5.1-.7.3-.2.2-.3.4-.3.7s.1.5.3.7z"
    },
    "children": []
  }]
};
exports.arrowSortedDown = arrowSortedDown;
var arrowSortedUp = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.2 13.3l-6.2-6.3-6.2 6.3c-.2.2-.3.5-.3.7s.1.5.3.7c.2.2.4.3.7.3h11c.3 0 .5-.1.7-.3.2-.2.3-.5.3-.7s-.1-.5-.3-.7z"
    },
    "children": []
  }]
};
exports.arrowSortedUp = arrowSortedUp;
var arrowSyncOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.5 12.473c0-2.495-.818-4.426-2.653-6.259-.309-.309-.676-.533-1.073-.682l-.946-.946-3.707-3.707c-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879c-.567.566-.879 1.32-.879 2.121 0 .277.037.549.11.809-1.029.461-1.974 1.12-2.827 1.974-1.795 1.793-2.783 4.178-2.783 6.717 0 2.495.818 4.426 2.653 6.259.299.298.652.521 1.034.669l.985.986 3.707 3.707c.566.567 1.32.879 2.121.879s1.555-.312 2.121-.879c.567-.566.879-1.32.879-2.121 0-.286-.04-.566-.117-.834 1.031-.461 1.978-1.121 2.833-1.975 1.796-1.794 2.784-4.18 2.784-6.718zm-9.13 7.484l1.337 1.336c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-3.707-3.707 3.707-3.707c.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414l-1.247 1.247c1.351-.091 2.425-.59 3.428-1.593 1.039-1.038 1.611-2.419 1.611-3.888 0-1.422-.401-2.351-1.48-3.429-.391-.391-.391-1.023 0-1.415.195-.195.451-.293.708-.293.256 0 .512.098.707.292 1.448 1.447 2.066 2.896 2.066 4.844 0 2.004-.78 3.887-2.197 5.303-1.39 1.39-3.01 2.1-4.933 2.182zm-.766-14.939l-1.311-1.311c-.391-.391-.391-1.023 0-1.414.195-.195.451-.293.707-.293s.512.098.707.293l3.707 3.707-3.707 3.707c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l1.275-1.275c-1.365.086-2.448.584-3.456 1.593-1.04 1.039-1.612 2.42-1.612 3.889 0 1.422.401 2.351 1.48 3.429.391.391.391 1.023 0 1.415-.195.195-.452.293-.708.293s-.512-.098-.707-.292c-1.447-1.448-2.065-2.897-2.065-4.845 0-2.004.78-3.887 2.197-5.303 1.382-1.383 2.993-2.093 4.907-2.179zm-2.916 10.204c-.888-.887-1.188-1.574-1.188-2.722 0-1.202.468-2.332 1.318-3.181l.187-.179c.033.481.236.93.581 1.274.378.378.88.586 1.414.586s1.036-.208 1.414-.586l2.339-2.339c-.078.596.104 1.219.56 1.675.888.887 1.188 1.574 1.188 2.722 0 1.202-.468 2.332-1.318 3.181l-.188.181c-.039-.472-.241-.91-.579-1.248-.38-.378-.882-.586-1.416-.586s-1.036.208-1.414.586l-2.342 2.342c.089-.605-.093-1.242-.556-1.706z"
    },
    "children": []
  }]
};
exports.arrowSyncOutline = arrowSyncOutline;
var arrowSync = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.5 12.473c0-1.948-.618-3.397-2.066-4.844-.391-.39-1.023-.39-1.414 0-.391.391-.391 1.024 0 1.415 1.079 1.078 1.48 2.007 1.48 3.429 0 1.469-.572 2.85-1.611 3.888-1.004 1.003-2.078 1.502-3.428 1.593l1.246-1.247c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-3.707 3.707 3.707 3.707c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-1.337-1.336c1.923-.082 3.542-.792 4.933-2.181 1.417-1.416 2.197-3.299 2.197-5.303zM6.5 12.5c0-1.469.572-2.85 1.611-3.889 1.009-1.009 2.092-1.508 3.457-1.594l-1.275 1.275c-.391.391-.391 1.023 0 1.414.195.196.451.294.707.294s.512-.098.707-.293l3.707-3.707-3.707-3.707c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.311 1.311c-1.914.086-3.525.796-4.907 2.179-1.417 1.416-2.197 3.299-2.197 5.303 0 1.948.618 3.397 2.066 4.844.195.195.451.292.707.292s.512-.098.707-.293c.391-.391.391-1.024 0-1.415-1.079-1.077-1.48-2.006-1.48-3.428z"
    },
    "children": []
  }]
};
exports.arrowSync = arrowSync;
var arrowUnsorted = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.2 9.3l-6.2-6.3-6.2 6.3c-.2.2-.3.4-.3.7s.1.5.3.7c.2.2.4.3.7.3h11c.3 0 .5-.1.7-.3.2-.2.3-.5.3-.7s-.1-.5-.3-.7zM5.8 14.7l6.2 6.3 6.2-6.3c.2-.2.3-.5.3-.7s-.1-.5-.3-.7c-.2-.2-.4-.3-.7-.3h-11c-.3 0-.5.1-.7.3-.2.2-.3.5-.3.7s.1.5.3.7z"
    },
    "children": []
  }]
};
exports.arrowUnsorted = arrowUnsorted;
var arrowUpOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 21c-1.654 0-3-1.346-3-3v-4.764c-1.143 1.024-3.025.979-4.121-.115-1.17-1.169-1.17-3.073 0-4.242l7.121-7.121 7.121 7.121c1.17 1.169 1.17 3.073 0 4.242-1.094 1.095-2.979 1.14-4.121.115v4.764c0 1.654-1.346 3-3 3zm-1-12.586v9.586c0 .551.448 1 1 1s1-.449 1-1v-9.586l3.293 3.293c.379.378 1.035.378 1.414 0 .391-.391.391-1.023 0-1.414l-5.707-5.707-5.707 5.707c-.391.391-.391 1.023 0 1.414.379.378 1.035.378 1.414 0l3.293-3.293z"
    },
    "children": []
  }]
};
exports.arrowUpOutline = arrowUpOutline;
var arrowUpThick = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3.172l-6.414 6.414c-.781.781-.781 2.047 0 2.828s2.047.781 2.828 0l1.586-1.586v7.242c0 1.104.895 2 2 2 1.104 0 2-.896 2-2v-7.242l1.586 1.586c.391.391.902.586 1.414.586s1.023-.195 1.414-.586c.781-.781.781-2.047 0-2.828l-6.414-6.414z"
    },
    "children": []
  }]
};
exports.arrowUpThick = arrowUpThick;
var arrowUp = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 5.586l-4.707 4.707c-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0l2.293-2.293v7.586c0 .552.447 1 1 1s1-.448 1-1v-7.586l2.293 2.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023 0-1.414l-4.707-4.707z"
    },
    "children": []
  }]
};
exports.arrowUp = arrowUp;
var at = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8c1.616 0 3.172-.479 4.499-1.384.456-.312.574-.934.263-1.39-.311-.457-.932-.572-1.39-.263-.994.679-2.16 1.037-3.372 1.037-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6v.5c0 .552-.448 1-1 1s-1-.448-1-1v-3c0-.553-.447-1-1-1-.441 0-.805.29-.938.688-.58-.427-1.289-.688-2.062-.688-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5c1.045 0 1.975-.47 2.616-1.199.548.723 1.408 1.199 2.384 1.199 1.654 0 3-1.346 3-3v-.5c0-4.411-3.589-8-8-8zm0 9.5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5z"
    },
    "children": []
  }]
};
exports.at = at;
var attachmentOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.534 4.466c1.024 0 2.05.39 2.829 1.169 1.561 1.561 1.561 4.098 0 5.656l-7.071 7.072c-.778.779-1.804 1.17-2.828 1.17s-2.049-.391-2.828-1.17c-1.56-1.559-1.56-4.098 0-5.656l.807-.807c-.004.805.25 1.524.701 2.125l-.094.096c-.78.779-.78 2.049 0 2.828.39.39.901.584 1.414.584s1.024-.195 1.414-.584l2.535-2.535 4.537-4.537c.778-.779.778-2.049 0-2.828-.392-.39-.904-.584-1.417-.584-.512 0-1.023.195-1.413.584l-4.535 4.537c-.128.127-.146.275-.146.354 0 .076.019.226.146.353.099.099.228.147.356.147.127 0 .254-.049.352-.146l2.122-2.121 1.414-1.414c.392.392.586.902.586 1.414 0 .511-.194 1.021-.584 1.41l-2.124 2.125c-.486.487-1.127.729-1.768.729s-1.28-.244-1.769-.729c-.472-.474-.731-1.101-.731-1.769 0-.67.261-1.297.732-1.77l4.534-4.535c.779-.779 1.805-1.168 2.829-1.168m0-2c-1.604 0-3.11.623-4.242 1.755l-7.069 7.073c-1.133 1.131-1.757 2.638-1.757 4.242s.624 3.11 1.757 4.243c1.131 1.132 2.639 1.755 4.241 1.755s3.11-.624 4.242-1.757l7.071-7.071c1.133-1.131 1.757-2.638 1.757-4.242 0-1.603-.623-3.11-1.755-4.241-1.133-1.134-2.64-1.757-4.245-1.757z"
    },
    "children": []
  }]
};
exports.attachmentOutline = attachmentOutline;
var attachment = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.364 6.635c-1.561-1.559-4.1-1.559-5.658 0l-4.534 4.535c-.473.473-.733 1.1-.733 1.77 0 .668.261 1.295.732 1.768.487.486 1.128.73 1.769.73.64 0 1.279-.242 1.767-.73l2.122-2.121c.391-.395.586-.904.586-1.414 0-.512-.195-1.023-.586-1.414l-3.536 3.535c-.193.195-.511.195-.708-.002-.127-.127-.146-.275-.146-.352 0-.078.019-.227.146-.354l4.535-4.537c.778-.779 2.048-.779 2.83 0 .779.779.779 2.049 0 2.828l-4.537 4.537-2.535 2.535c-.779.779-2.049.779-2.828 0-.78-.779-.78-2.049 0-2.828l.095-.096c-.451-.6-.702-1.359-.702-2.125l-.807.807c-1.56 1.559-1.56 4.098 0 5.656.779.779 1.804 1.17 2.828 1.17s2.049-.391 2.828-1.17l7.072-7.072c1.56-1.559 1.56-4.096 0-5.656z"
    },
    "children": []
  }]
};
exports.attachment = attachment;
var backspaceOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 21h-10c-1.436 0-3.145-.88-3.977-2.046l-2.619-3.667-1.188-1.661c-.246-.344-.249-.894-.008-1.241l1.204-1.686 2.608-3.653c.835-1.167 2.546-2.046 3.98-2.046h10c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3zm-15.771-8.001l.806 1.125 2.618 3.667c.451.633 1.57 1.209 2.348 1.209h10c.552 0 1-.45 1-1.001v-9.999c0-.551-.448-1-1-1h-10c-.776 0-1.897.576-2.351 1.209l-2.608 3.652-.813 1.138zM13.707 13l2.646-2.646c.194-.194.194-.512 0-.707-.195-.194-.513-.194-.707 0l-2.646 2.646-2.646-2.646c-.195-.194-.513-.194-.707 0-.195.195-.195.513 0 .707l2.646 2.646-2.646 2.646c-.195.195-.195.513 0 .707.097.098.225.147.353.147s.256-.049.354-.146l2.646-2.647 2.646 2.646c.098.098.226.147.354.147s.256-.049.354-.146c.194-.194.194-.512 0-.707l-2.647-2.647z"
    },
    "children": []
  }]
};
exports.backspaceOutline = backspaceOutline;
var backspace = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.5 5h-10c-1.266 0-2.834.807-3.57 1.837l-2.61 3.653-1.199 1.679c-.121.175-.122.492.003.664l1.188 1.664 2.619 3.667c.735 1.029 2.302 1.836 3.569 1.836h10c1.379 0 2.5-1.122 2.5-2.5v-10c0-1.378-1.121-2.5-2.5-2.5zm-2.293 9.793c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293 2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l2.293 2.293 2.293-2.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-2.293 2.293 2.293 2.293z"
    },
    "children": []
  }]
};
exports.backspace = backspace;
var batteryCharge = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5 10v6h11v-6h-11zm5.83 4.908l-1.21-1.908-2.62.428 3.223-2.324 1.175 1.896 2.602-.43-3.17 2.338zM19 10c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3 1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm-2 6c0 .552-.449 1-1 1h-11c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1h11c.551 0 1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.batteryCharge = batteryCharge;
var batteryFull = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM6 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM15 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM12 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM19 10c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3 1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm-2 6c0 .552-.449 1-1 1h-11c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1h11c.551 0 1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.batteryFull = batteryFull;
var batteryHigh = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM6 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM12 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM19 10c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3 1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm-2 6c0 .552-.449 1-1 1h-11c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1h11c.551 0 1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.batteryHigh = batteryHigh;
var batteryLow = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM19 10c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3 1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm-2 6c0 .552-.449 1-1 1h-11c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1h11c.551 0 1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.batteryLow = batteryLow;
var batteryMid = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM6 16c-.552 0-1-.447-1-1v-4c0-.553.448-1 1-1s1 .447 1 1v4c0 .553-.448 1-1 1zM19 10c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3 1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm-2 6c0 .552-.449 1-1 1h-11c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1h11c.551 0 1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.batteryMid = batteryMid;
var beaker = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.445 16.809l-2.64-9.809h1.195c.552 0 1-.448 1-1s-.448-1-1-1h-12c-.552 0-1 .448-1 1s.448 1 1 1h1.135c-.013.176-.048.402-.121.671l-2.459 9.138c-.218.809-.074 1.623.393 2.231.466.61 1.214.96 2.052.96h10c.838 0 1.586-.35 2.055-.959.466-.609.609-1.423.39-2.232zm-4.713-9.809l1.352 5.018-.084-.018h-8l-.084.018 1.029-3.826c.084-.312.173-.744.192-1.192h5.595zm2.734 10.824c-.087.114-.252.176-.466.176h-10c-.214 0-.379-.062-.466-.176-.086-.113-.104-.289-.048-.496l1.197-4.45c.088.073.195.122.317.122h8c.122 0 .229-.049.316-.121l1.197 4.45c.057.206.04.382-.047.495z"
    },
    "children": []
  }]
};
exports.beaker = beaker;
var beer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M10 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM12 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM14 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM18.5 6h-.5v-1c0-1.104-.896-2-2-2h-9c-1.104 0-2 .896-2 2v13c0 1.656 1.344 3 3 3h7c1.656 0 3-1.344 3-3h.5c1.93 0 3.5-1.57 3.5-3.5v-5c0-1.93-1.57-3.5-3.5-3.5zm-11.5-1h9v1h-4.444l-.118.332c-.164.458-.663.73-1.117.648l-.348-.058-.173.307c-.267.475-.765.771-1.3.771-.827 0-1.5-.673-1.5-1.5v-1.5zm9 13c0 .552-.448 1-1 1h-7c-.552 0-1-.448-1-1v-9.51c.419.317.936.51 1.5.51.784 0 1.521-.376 1.989-1 .728 0 1.383-.391 1.736-1h3.775v11zm4-3.5c0 .827-.673 1.5-1.5 1.5h-1.5v-8h1.5c.827 0 1.5.673 1.5 1.5v5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M10 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM12 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM14 16.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5v-6c0-.275.225-.5.5-.5s.5.225.5.5v6zM18.5 6h-.5v-1c0-1.104-.896-2-2-2h-9c-1.104 0-2 .896-2 2v13c0 1.656 1.344 3 3 3h7c1.656 0 3-1.344 3-3h.5c1.93 0 3.5-1.57 3.5-3.5v-5c0-1.93-1.57-3.5-3.5-3.5zm-11.5-1h9v1h-4.444l-.118.332c-.164.458-.663.73-1.117.648l-.348-.058-.173.307c-.267.475-.765.771-1.3.771-.827 0-1.5-.673-1.5-1.5v-1.5zm9 13c0 .552-.448 1-1 1h-7c-.552 0-1-.448-1-1v-9.51c.419.317.936.51 1.5.51.784 0 1.521-.376 1.989-1 .728 0 1.383-.391 1.736-1h3.775v11zm4-3.5c0 .827-.673 1.5-1.5 1.5h-1.5v-8h1.5c.827 0 1.5.673 1.5 1.5v5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.beer = beer;
var bell = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.715 17.301c-.017-.018-1.717-1.854-1.73-6.32-.009-2.607-1.69-4.824-4.019-5.641l.034-.34c0-1.103-.896-2-2-2s-2 .897-2 2l.034.338c-2.336.816-4.019 3.036-4.019 5.646 0 4.462-1.711 6.296-1.721 6.306-.287.286-.374.716-.22 1.091s.521.619.926.619h3.143c.447 1.72 1.999 3 3.857 3s3.41-1.28 3.857-3h3.143c.4 0 .758-.243.915-.61s.076-.799-.2-1.089zm-7.715-10.301c2.189 0 3.978 1.789 3.984 3.987.002.728.046 1.396.118 2.013h-8.2c.071-.617.113-1.286.113-2.016.001-2.196 1.788-3.984 3.985-3.984zm0 13c-.737 0-1.375-.405-1.722-1h3.443c-.346.595-.984 1-1.721 1zm-5.186-3c.352-.736.705-1.731.938-3h8.502c.234 1.269.588 2.264.938 3h-10.378z"
    },
    "children": []
  }]
};
exports.bell = bell;
var book = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 3h-11c-.265 0-.52.105-.707.293l-3 3-.057.062c-.139.165-.225.373-.235.6l-.001.053v10.992c0 1.654 1.346 3 3 3h9c1.304 0 2.416-.836 2.829-2h.671c1.402 0 2.5-1.317 2.5-3v-10c0-1.654-1.346-3-3-3zm-12 16c-.551 0-1-.448-1-1v-10h2v11h-1zm10-1c0 .552-.449 1-1 1h-7v-11h7c.551 0 1 .448 1 1v9zm3-2c0 .62-.324 1-.5 1h-.5v-8c0-1.654-1.346-3-3-3h-8.586l1-1h10.586c.551 0 1 .448 1 1v10z"
    },
    "children": []
  }]
};
exports.book = book;
var bookmark = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 2h-8c-1.654 0-3 1.346-3 3v14c0 .514.104.946.308 1.285.564.935 1.815 1.008 2.813.008l3.172-3.172c.375-.374 1.039-.374 1.414 0l3.172 3.172c.491.491 1.002.74 1.52.74.797 0 1.601-.629 1.601-2.033v-14c0-1.654-1.346-3-3-3zm-8 2h8c.551 0 1 .449 1 1v9.905l-2.451-2.247c-1.406-1.289-3.693-1.288-5.099 0l-2.45 2.247v-9.905c0-.551.449-1 1-1zm6.121 11.707c-.565-.565-1.318-.876-2.121-.876s-1.556.312-2.121.876l-2.879 2.879v-2.324l3.126-2.866c1.033-.947 2.714-.947 3.747 0l3.127 2.866v2.324l-2.879-2.879z"
    },
    "children": []
  }]
};
exports.bookmark = bookmark;
var briefcase = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M18 7c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-7c0-1.654-1.346-3-3-3zm-9-1h6c.551 0 1 .449 1 1h-8c0-.551.449-1 1-1zm10 11c0 .551-.449 1-1 1h-12c-.551 0-1-.449-1-1v-1h14v1zm-14-2v-5c0-.551.449-1 1-1h12c.551 0 1 .449 1 1v5h-14zM13 12h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M18 7c0-1.654-1.346-3-3-3h-6c-1.654 0-3 1.346-3 3-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-7c0-1.654-1.346-3-3-3zm-9-1h6c.551 0 1 .449 1 1h-8c0-.551.449-1 1-1zm10 11c0 .551-.449 1-1 1h-12c-.551 0-1-.449-1-1v-1h14v1zm-14-2v-5c0-.551.449-1 1-1h12c.551 0 1 .449 1 1v5h-14zM13 12h-2c-.55 0-1 .45-1 1s.45 1 1 1h2c.55 0 1-.45 1-1s-.45-1-1-1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.briefcase = briefcase;
var brush = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.177 3.823c-.382-.383-.894-.586-1.415-.586-.25 0-.503.047-.744.144-4.449 1.787-7.792 4.76-10.517 9.357-.102.172-.163.355-.209.542-1.38.215-2.6.903-3.442 1.993-.916 1.185-1.295 2.695-1.066 4.254l.216 1.473 1.473.217c.293.043.589.064.88.064 2.743 0 4.949-1.909 5.367-4.564.188-.047.371-.115.544-.218 4.598-2.728 7.571-6.069 9.355-10.517.298-.743.123-1.593-.442-2.159zm-14.824 15.458c-.192 0-.389-.016-.59-.044-.309-2.104 1.055-3.81 3-4.021l1.021 1.021c-.192 1.76-1.605 3.044-3.431 3.044zm4.89-4.502l-1.021-1.021c.38-.641.774-1.233 1.178-1.804.027.041 1.639 1.653 1.639 1.653-.568.401-1.158.794-1.796 1.172zm2.608-1.773s-1.821-1.801-1.879-1.824c2.147-2.784 4.651-4.685 7.791-5.943-1.255 3.127-3.144 5.623-5.912 7.767z"
    },
    "children": []
  }]
};
exports.brush = brush;
var businessCard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M20 20h-16c-1.654 0-3-1.346-3-3v-10c0-1.654 1.346-3 3-3h16c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3zm-16-14c-.551 0-1 .449-1 1v10c0 .551.449 1 1 1h16c.551 0 1-.449 1-1v-10c0-.551-.449-1-1-1h-16zM10 15h-4c-.553 0-1-.448-1-1s.447-1 1-1h4c.553 0 1 .448 1 1s-.447 1-1 1zM10 11h-4c-.553 0-1-.448-1-1s.447-1 1-1h4c.553 0 1 .448 1 1s-.447 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M20 20h-16c-1.654 0-3-1.346-3-3v-10c0-1.654 1.346-3 3-3h16c1.654 0 3 1.346 3 3v10c0 1.654-1.346 3-3 3zm-16-14c-.551 0-1 .449-1 1v10c0 .551.449 1 1 1h16c.551 0 1-.449 1-1v-10c0-.551-.449-1-1-1h-16zM10 15h-4c-.553 0-1-.448-1-1s.447-1 1-1h4c.553 0 1 .448 1 1s-.447 1-1 1zM10 11h-4c-.553 0-1-.448-1-1s.447-1 1-1h4c.553 0 1 .448 1 1s-.447 1-1 1z"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "16",
        "cy": "10.5",
        "r": "2"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "16",
          "cy": "10.5",
          "r": "2"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M16 13.356c-1.562 0-2.5.715-2.5 1.429 0 .357.938.715 2.5.715 1.466 0 2.5-.357 2.5-.715 0-.714-.98-1.429-2.5-1.429z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M16 13.356c-1.562 0-2.5.715-2.5 1.429 0 .357.938.715 2.5.715 1.466 0 2.5-.357 2.5-.715 0-.714-.98-1.429-2.5-1.429z"
        },
        "children": []
      }]
    }]
  }]
};
exports.businessCard = businessCard;
var calculator = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 21h-8c-1.7 0-3-1.3-3-3v-12c0-1.7 1.3-3 3-3h8c1.7 0 3 1.3 3 3v12c0 1.7-1.3 3-3 3zm-8-16c-.6 0-1 .4-1 1v12c0 .6.4 1 1 1h8c.6 0 1-.4 1-1v-12c0-.6-.4-1-1-1h-8z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "10",
      "cy": "11",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "13",
      "cy": "11",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "16",
      "cy": "11",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "10",
      "cy": "14",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "13",
      "cy": "14",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "16",
      "cy": "14",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "10",
      "cy": "17",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "13",
      "cy": "17",
      "r": "1"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "16",
      "cy": "17",
      "r": "1"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M16 7v1h-6v-1h6m1-1h-8v3h8v-3z"
    },
    "children": []
  }]
};
exports.calculator = calculator;
var calendarOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6.184v-.184c0-1.657-1.343-3-3-3s-3 1.343-3 3h-2c0-1.657-1.343-3-3-3s-3 1.343-3 3v.184c-1.161.415-2 1.514-2 2.816v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-1.302-.839-2.401-2-2.816zm-4-.184c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1v-2zm-8 0c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1v-2zm12 12c0 .551-.448 1-1 1h-12c-.552 0-1-.449-1-1v-6h14v6zm0-7h-14v-2c0-.551.448-1 1-1 0 1.104.896 2 2 2s2-.896 2-2h4c0 1.104.896 2 2 2s2-.896 2-2c.552 0 1 .449 1 1v2z"
    },
    "children": []
  }]
};
exports.calendarOutline = calendarOutline;
var calendar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6.184v-.184c0-1.657-1.343-3-3-3s-3 1.343-3 3h-2c0-1.657-1.343-3-3-3s-3 1.343-3 3v.184c-1.161.415-2 1.514-2 2.816v9c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-9c0-1.302-.839-2.401-2-2.816zm-4-.184c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1v-2zm-8 0c0-.552.447-1 1-1s1 .448 1 1v2c0 .552-.447 1-1 1s-1-.448-1-1v-2zm12 12c0 .551-.448 1-1 1h-12c-.552 0-1-.449-1-1v-6h14v6z"
    },
    "children": []
  }]
};
exports.calendar = calendar;
var cameraOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 20h-14c-1.654 0-3-1.346-3-3v-8c0-1.654 1.346-3 3-3h1.586l1-1c.579-.579 1.596-1 2.414-1h4c.818 0 1.835.421 2.414 1l1 1h1.586c1.654 0 3 1.346 3 3v8c0 1.654-1.346 3-3 3zm-14-12c-.552 0-1 .448-1 1v8c0 .552.448 1 1 1h14c.552 0 1-.448 1-1v-8c0-.552-.448-1-1-1h-2c-.266 0-.52-.105-.707-.293l-1.293-1.293c-.201-.201-.715-.414-1-.414h-4c-.285 0-.799.213-1 .414l-1.293 1.293c-.187.188-.441.293-.707.293h-2zM12 10c1.379 0 2.5 1.121 2.5 2.5s-1.121 2.5-2.5 2.5-2.5-1.121-2.5-2.5 1.121-2.5 2.5-2.5m0-1c-1.934 0-3.5 1.566-3.5 3.5 0 1.932 1.566 3.5 3.5 3.5s3.5-1.568 3.5-3.5c0-1.934-1.566-3.5-3.5-3.5zM18 8.699c-.719 0-1.3.582-1.3 1.301s.581 1.299 1.3 1.299 1.3-.58 1.3-1.299-.581-1.301-1.3-1.301z"
    },
    "children": []
  }]
};
exports.cameraOutline = cameraOutline;
var camera = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6h-1.586l-1-1c-.579-.579-1.595-1-2.414-1h-4c-.819 0-1.835.421-2.414 1l-1 1h-1.586c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h14c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm-7 10c-1.933 0-3.5-1.568-3.5-3.5 0-1.934 1.567-3.5 3.5-3.5s3.5 1.566 3.5 3.5c0 1.932-1.567 3.5-3.5 3.5zm6-4.701c-.719 0-1.3-.58-1.3-1.299s.581-1.301 1.3-1.301 1.3.582 1.3 1.301-.581 1.299-1.3 1.299z"
    },
    "children": []
  }]
};
exports.camera = camera;
var cancelOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 20.5c-4.688 0-8.5-3.812-8.5-8.5s3.812-8.5 8.497-8.5c4.69 0 8.503 3.812 8.503 8.5s-3.812 8.5-8.5 8.5zm0-15c-3.586 0-6.5 2.916-6.5 6.5s2.916 6.5 6.5 6.5 6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5zM12.003 8.5c1.929 0 3.497 1.57 3.497 3.5 0 .206-.02.412-.057.615l-4.057-4.059c.203-.036.408-.056.614-.056m.003-1c-.882 0-1.696.262-2.39.697l6.188 6.188c.438-.692.699-1.508.699-2.387 0-2.48-2.014-4.498-4.497-4.498zM8.557 11.384l4.059 4.06c-.204.036-.409.056-.616.056-1.93 0-3.5-1.57-3.5-3.502 0-.206.02-.412.057-.614m-.358-1.773c-.435.694-.699 1.508-.699 2.387 0 2.486 2.016 4.502 4.5 4.502.879 0 1.693-.264 2.387-.699l-6.188-6.19z"
    },
    "children": []
  }]
};
exports.cancelOutline = cancelOutline;
var cancel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4c-4.411 0-8 3.589-8 8s3.589 8 8 8 8-3.589 8-8-3.589-8-8-8zm-5 8c0-.832.224-1.604.584-2.295l6.711 6.711c-.691.36-1.463.584-2.295.584-2.757 0-5-2.243-5-5zm9.416 2.295l-6.711-6.711c.691-.36 1.463-.584 2.295-.584 2.757 0 5 2.243 5 5 0 .832-.224 1.604-.584 2.295z"
    },
    "children": []
  }]
};
exports.cancel = cancel;
var chartAreaOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 17h-16c-.552 0-1-.447-1-1v-3c0-.68.234-1.346.658-1.874l4-5c.98-1.226 2.885-1.469 4.143-.524l1.674 1.254 2.185-2.729c.57-.717 1.424-1.127 2.341-1.127.679 0 1.343.232 1.873.657.716.572 1.126 1.426 1.126 2.343v10c0 .553-.448 1-1 1zm-15-2h14v-9c0-.307-.137-.59-.375-.779-.227-.183-.465-.221-.624-.221-.306 0-.591.137-.782.376l-2.789 3.485c-.337.423-.949.5-1.381.176l-2.449-1.837c-.422-.316-1.055-.233-1.381.176l-4 5c-.181.228-.219.464-.219.624v2zM20 21h-16c-.552 0-1-.447-1-1s.448-1 1-1h16c.552 0 1 .447 1 1s-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.chartAreaOutline = chartAreaOutline;
var chartArea = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 6c0-.587-.257-1.167-.75-1.562-.863-.69-2.121-.551-2.812.312l-2.789 3.486-2.449-1.836c-.864-.648-2.087-.493-2.762.351l-4 5c-.294.368-.438.811-.438 1.249v3h16v-10zM20 19h-16c-.552 0-1 .447-1 1s.448 1 1 1h16c.552 0 1-.447 1-1s-.448-1-1-1z"
    },
    "children": []
  }]
};
exports.chartArea = chartArea;
var chartBarOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 5c-.771 0-1.468.301-2 .779v-1.779c0-1.654-1.346-3-3-3s-3 1.346-3 3v4.779c-.532-.478-1.229-.779-2-.779-1.654 0-3 1.346-3 3v6h16v-9c0-1.654-1.346-3-3-3zm-5-2c.551 0 1 .448 1 1v11h-2v-11c0-.552.449-1 1-1zm-4 12h-2v-4c0-.552.449-1 1-1s1 .448 1 1v4zm10 0h-2v-7c0-.552.449-1 1-1s1 .448 1 1v7zM19 21h-14c-.552 0-1-.447-1-1s.448-1 1-1h14c.552 0 1 .447 1 1s-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.chartBarOutline = chartBarOutline;
var chartBar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 4c0-1.105-.896-2-2-2s-2 .895-2 2v12h4v-12zM19 8c0-1.105-.896-2-2-2s-2 .895-2 2v8h4v-8zM9 11c0-1.105-.896-2-2-2s-2 .895-2 2v5h4v-5zM19 19h-14c-.553 0-1 .447-1 1s.447 1 1 1h14c.553 0 1-.447 1-1s-.447-1-1-1z"
    },
    "children": []
  }]
};
exports.chartBar = chartBar;
var chartLineOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.999 17c-.677 0-1.342-.234-1.873-.658-.626-.501-1.019-1.215-1.107-2.011-.089-.796.138-1.58.639-2.206l4-5c.978-1.225 2.883-1.471 4.143-.523l1.674 1.254 2.184-2.729c.571-.716 1.425-1.127 2.342-1.127.679 0 1.343.232 1.873.657.626.501 1.021 1.216 1.108 2.013s-.14 1.58-.641 2.204l-4 5c-.977 1.226-2.882 1.471-4.143.526l-1.674-1.256-2.184 2.729c-.57.716-1.424 1.127-2.341 1.127zm4.001-9c-.306 0-.591.137-.781.374l-4 5.001c-.167.208-.243.471-.213.734.03.266.161.504.369.67.228.183.465.221.624.221.306 0 .591-.137.782-.376l3.395-4.244 3.224 2.42c.42.316 1.056.231 1.381-.176l4-5.001c.167-.208.242-.469.213-.734-.03-.266-.161-.504-.369-.67-.227-.182-.464-.22-.624-.22-.306 0-.591.137-.782.376l-3.395 4.242-3.224-2.417c-.175-.132-.382-.2-.6-.2zM19 21h-14c-.552 0-1-.447-1-1s.448-1 1-1h14c.552 0 1 .447 1 1s-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.chartLineOutline = chartLineOutline;
var chartLine = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4.75 15.561c.369.294.811.439 1.248.439.588 0 1.168-.258 1.563-.752l2.789-3.486 2.45 1.838c.864.648 2.088.492 2.762-.352l4-5c.69-.861.55-2.121-.312-2.811-.863-.689-2.121-.551-2.812.312l-2.789 3.486-2.449-1.835c-.864-.648-2.087-.494-2.762.35l-4 5c-.69.863-.549 2.121.312 2.811zM5 21h14c.553 0 1-.447 1-1s-.447-1-1-1h-14c-.553 0-1 .447-1 1s.447 1 1 1z"
    },
    "children": []
  }]
};
exports.chartLine = chartLine;
var chartPieOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.227 7.609l.557-.559c.396-.396.607-.943.582-1.504-.026-.561-.286-1.084-.717-1.443-2.129-1.775-4.711-2.848-7.469-3.097l-.18-.006c-.497 0-.979.186-1.35.523-.414.379-.65.915-.65 1.477v2.229c-3.657.865-6.333 4.188-6.333 8.006 0 4.547 3.688 8.244 8.224 8.244 1.594 0 3.11-.479 4.441-1.345.277.142.583.226.9.226l.109-.004c.569-.03 1.098-.305 1.453-.75 1.421-1.781 2.204-4.019 2.204-6.297.002-2.032-.625-4.027-1.771-5.7zm-7.336 11.87c-3.438 0-6.224-2.793-6.224-6.244 0-3.137 2.317-5.729 5.333-6.164v6.408l4.609 4.754c-1.037.779-2.322 1.246-3.718 1.246zm.109-7.454v-9.025c2.411.218 4.607 1.173 6.366 2.641l-6.366 6.384zm.214 1.269l5.019-5.028c1.104 1.385 1.769 3.141 1.769 5.043 0 1.914-.664 3.666-1.769 5.051l-5.019-5.066z"
    },
    "children": []
  }]
};
exports.chartPieOutline = chartPieOutline;
var chartPie = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.614 13.98l4.908 4.922c.39.391.99.36 1.286-.106.88-1.394 1.393-3.044 1.393-4.815 0-2.131-.741-4.086-1.972-5.631l-5.615 5.63zM9 14.396v-7.355c-3.391.487-6 3.405-6 6.939 0 3.876 3.134 7.02 7 7.02 1.572 0 3.018-.526 4.186-1.403l-5.186-5.201zM16.331 6.213c.39-.391.365-.999-.089-1.313-1.253-.868-2.695-1.479-4.251-1.765-.544-.1-.991.312-.991.865v7.56l5.331-5.347z"
    },
    "children": []
  }]
};
exports.chartPie = chartPie;
var chevronLeftOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 20c-.802 0-1.555-.312-2.122-.879l-7.121-7.121 7.122-7.121c1.133-1.133 3.11-1.133 4.243 0 .566.566.878 1.32.878 2.121s-.312 1.555-.879 2.122l-2.878 2.878 2.878 2.879c.567.566.879 1.32.879 2.121s-.312 1.555-.879 2.122c-.566.566-1.319.878-2.121.878zm-6.415-8l5.708 5.707c.378.378 1.037.377 1.414 0 .189-.189.293-.439.293-.707s-.104-.518-.293-.707l-4.292-4.293 4.292-4.293c.189-.189.293-.44.293-.707s-.104-.518-.293-.707c-.378-.379-1.037-.378-1.414-.001l-5.708 5.708z"
    },
    "children": []
  }]
};
exports.chevronLeftOutline = chevronLeftOutline;
var chevronLeft = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.414 5.586c-.78-.781-2.048-.781-2.828 0l-6.415 6.414 6.415 6.414c.39.391.902.586 1.414.586s1.024-.195 1.414-.586c.781-.781.781-2.047 0-2.828l-3.585-3.586 3.585-3.586c.781-.781.781-2.047 0-2.828z"
    },
    "children": []
  }]
};
exports.chevronLeft = chevronLeft;
var chevronRightOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 20c-.802 0-1.555-.312-2.122-.879-.566-.566-.878-1.32-.878-2.121s.312-1.555.879-2.122l2.878-2.878-2.878-2.879c-.567-.566-.879-1.32-.879-2.121s.312-1.555.879-2.122c1.133-1.132 3.109-1.133 4.243.001l7.121 7.121-7.122 7.121c-.566.567-1.319.879-2.121.879zm0-14c-.268 0-.518.104-.707.292-.189.19-.293.441-.293.708s.104.518.293.707l4.292 4.293-4.292 4.293c-.189.189-.293.439-.293.707s.104.518.293.707c.378.379 1.037.378 1.414.001l5.708-5.708-5.708-5.707c-.189-.189-.439-.293-.707-.293z"
    },
    "children": []
  }]
};
exports.chevronRightOutline = chevronRightOutline;
var chevronRight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.586 5.586c-.781.781-.781 2.047 0 2.828l3.585 3.586-3.585 3.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l6.415-6.414-6.415-6.414c-.78-.781-2.048-.781-2.828 0z"
    },
    "children": []
  }]
};
exports.chevronRight = chevronRight;
var clipboard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 3h-10c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-8 2h6v1c0 .551-.449 1-1 1h-4c-.551 0-1-.449-1-1v-1zm9 13c0 .551-.449 1-1 1h-10c-.551 0-1-.449-1-1v-12c0-.551.449-1 1-1h1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1h1c.551 0 1 .449 1 1v12zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 3h-10c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-8 2h6v1c0 .551-.449 1-1 1h-4c-.551 0-1-.449-1-1v-1zm9 13c0 .551-.449 1-1 1h-10c-.551 0-1-.449-1-1v-12c0-.551.449-1 1-1h1v1c0 1.1.9 2 2 2h4c1.1 0 2-.9 2-2v-1h1c.551 0 1 .449 1 1v12zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.clipboard = clipboard;
var cloudStorageOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 8.999l-.352.015c-.824-2.375-3.312-4.015-5.898-4.015-3.309 0-6.25 2.69-6.25 6v.126c-1 .445-2.75 2.014-2.75 3.875 0 2.206 2.044 4 4.25 4h11c2.757 0 5-2.244 5-5s-2.243-5.001-5-5.001zm0 8.001h-4.5v-3.794l2.146 2.146c.098.099.226.146.354.146s.256-.049.354-.146c.195-.194.195-.512 0-.707l-2.998-3-.164-.107c-.123-.051-.26-.051-.383 0l-.162.107-3 3c-.194.195-.194.513 0 .707.099.099.227.146.354.146s.256-.049.354-.146l2.145-2.146v3.794h-5.5c-1.104 0-2-.896-2-2s.896-2 1.908-2.005l1.422.015-.248-1.201c-.055-.264-.082-.536-.082-.809 0-2.206 1.794-4 4-4 1.951 0 3.604 1.402 3.93 3.334l.187 1.102 1.073-.306c.312-.089.569-.13.812-.13 1.653 0 3 1.346 3 3s-1.348 3-3.002 3z"
    },
    "children": []
  }]
};
exports.cloudStorageOutline = cloudStorageOutline;
var cloudStorage = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 9l-.351.015c-.825-2.377-3.062-4.015-5.649-4.015-3.309 0-6 2.691-6 6l.001.126c-1.724.445-3.001 2.013-3.001 3.874 0 2.206 1.794 4 4 4h5v-4.586l-1.293 1.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l2.999-2.999c.093-.093.203-.166.326-.217.244-.101.52-.101.764 0 .123.051.233.124.326.217l2.999 2.999c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-1.293-1.293v4.586h4c2.757 0 5-2.243 5-5s-2.243-5-5-5z"
    },
    "children": []
  }]
};
exports.cloudStorage = cloudStorage;
var codeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M7.828 19c-.801 0-1.555-.312-2.121-.879l-5.121-5.121 5.121-5.121c1.133-1.134 3.112-1.134 4.243.001 1.169 1.168 1.169 3.072-.001 4.241l-.878.879.878.879c1.17 1.169 1.17 3.073 0 4.242-.564.567-1.318.879-2.121.879zm-4.414-6l3.707 3.707c.38.379 1.039.377 1.413.001.391-.391.391-1.025.001-1.415l-2.292-2.293 2.292-2.293c.39-.39.39-1.024 0-1.414-.378-.379-1.036-.377-1.414 0l-3.707 3.707zM16.172 19c-.803 0-1.557-.312-2.122-.88-1.169-1.168-1.169-3.072.001-4.241l.878-.879-.878-.879c-1.17-1.169-1.17-3.073 0-4.242 1.129-1.133 3.109-1.134 4.242 0l5.121 5.121-5.121 5.121c-.566.567-1.32.879-2.121.879zm-.001-10c-.267 0-.518.104-.705.292-.391.391-.391 1.025-.001 1.415l2.292 2.293-2.292 2.293c-.39.39-.39 1.024 0 1.414.377.378 1.035.379 1.414 0l3.707-3.707-3.707-3.707c-.19-.189-.441-.293-.708-.293z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M7.828 19c-.801 0-1.555-.312-2.121-.879l-5.121-5.121 5.121-5.121c1.133-1.134 3.112-1.134 4.243.001 1.169 1.168 1.169 3.072-.001 4.241l-.878.879.878.879c1.17 1.169 1.17 3.073 0 4.242-.564.567-1.318.879-2.121.879zm-4.414-6l3.707 3.707c.38.379 1.039.377 1.413.001.391-.391.391-1.025.001-1.415l-2.292-2.293 2.292-2.293c.39-.39.39-1.024 0-1.414-.378-.379-1.036-.377-1.414 0l-3.707 3.707zM16.172 19c-.803 0-1.557-.312-2.122-.88-1.169-1.168-1.169-3.072.001-4.241l.878-.879-.878-.879c-1.17-1.169-1.17-3.073 0-4.242 1.129-1.133 3.109-1.134 4.242 0l5.121 5.121-5.121 5.121c-.566.567-1.32.879-2.121.879zm-.001-10c-.267 0-.518.104-.705.292-.391.391-.391 1.025-.001 1.415l2.292 2.293-2.292 2.293c-.39.39-.39 1.024 0 1.414.377.378 1.035.379 1.414 0l3.707-3.707-3.707-3.707c-.19-.189-.441-.293-.708-.293z"
        },
        "children": []
      }]
    }]
  }]
};
exports.codeOutline = codeOutline;
var code = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.171 18c-.512 0-1.023-.195-1.414-.586l-4.414-4.414 4.414-4.414c.781-.781 2.049-.781 2.828 0 .781.781.781 2.047 0 2.828l-1.585 1.586 1.585 1.586c.781.781.781 2.047 0 2.828-.39.391-.902.586-1.414.586zM15.829 18c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828l1.585-1.586-1.585-1.586c-.781-.781-.781-2.047 0-2.828.779-.781 2.047-.781 2.828 0l4.414 4.414-4.414 4.414c-.39.391-.902.586-1.414.586z"
    },
    "children": []
  }]
};
exports.code = code;
var coffee = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 19h-12c-.553 0-1-.447-1-1s.447-1 1-1h12c.553 0 1 .447 1 1s-.447 1-1 1zM17.5 5h-12.5v9c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zm-2.5 9h-8v-7h8v7zm2.5-4h-1.5v-3h1.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 19h-12c-.553 0-1-.447-1-1s.447-1 1-1h12c.553 0 1 .447 1 1s-.447 1-1 1zM17.5 5h-12.5v9c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-2h.5c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zm-2.5 9h-8v-7h8v7zm2.5-4h-1.5v-3h1.5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.coffee = coffee;
var cogOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 5l.855 3.42 3.389-.971 1.501 2.6-2.535 2.449 2.535 2.451-1.5 2.6-3.39-.971-.855 3.422h-3l-.855-3.422-3.39.971-1.501-2.6 2.535-2.451-2.534-2.449 1.5-2.6 3.39.971.855-3.42h3m0-2h-3c-.918 0-1.718.625-1.939 1.516l-.354 1.412-1.4-.4c-.184-.053-.369-.078-.552-.078-.7 0-1.368.37-1.731 1l-1.5 2.6c-.459.796-.317 1.802.342 2.438l1.047 1.011-1.048 1.015c-.66.637-.802 1.643-.343 2.438l1.502 2.6c.363.631 1.031 1 1.731 1 .183 0 .368-.025.552-.076l1.399-.401.354 1.415c.222.885 1.022 1.51 1.94 1.51h3c.918 0 1.718-.625 1.939-1.516l.354-1.414 1.399.4c.184.053.369.077.552.077.7 0 1.368-.37 1.731-1l1.5-2.6c.459-.796.317-1.8-.342-2.438l-1.047-1.013 1.047-1.013c.66-.637.801-1.644.342-2.438l-1.5-2.6c-.365-.631-1.031-1-1.732-1-.184 0-.368.025-.551.076l-1.4.401-.354-1.413c-.22-.884-1.02-1.509-1.938-1.509zM11.5 10.5c1.104 0 2 .895 2 2 0 1.104-.896 2-2 2s-2-.896-2-2c0-1.105.896-2 2-2m0-1c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"
    },
    "children": []
  }]
};
exports.cogOutline = cogOutline;
var cog = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.387 17.548l.371 1.482c.133.533.692.97 1.242.97h1c.55 0 1.109-.437 1.242-.97l.371-1.482c.133-.533.675-.846 1.203-.694l1.467.42c.529.151 1.188-.114 1.462-.591l.5-.867c.274-.477.177-1.179-.219-1.562l-1.098-1.061c-.396-.383-.396-1.008.001-1.39l1.096-1.061c.396-.382.494-1.084.22-1.561l-.501-.867c-.275-.477-.933-.742-1.461-.591l-1.467.42c-.529.151-1.07-.161-1.204-.694l-.37-1.48c-.133-.532-.692-.969-1.242-.969h-1c-.55 0-1.109.437-1.242.97l-.37 1.48c-.134.533-.675.846-1.204.695l-1.467-.42c-.529-.152-1.188.114-1.462.59l-.5.867c-.274.477-.177 1.179.22 1.562l1.096 1.059c.395.383.395 1.008 0 1.391l-1.098 1.061c-.395.383-.494 1.085-.219 1.562l.501.867c.274.477.933.742 1.462.591l1.467-.42c.528-.153 1.07.16 1.203.693zm2.113-7.048c1.104 0 2 .895 2 2 0 1.104-.896 2-2 2s-2-.896-2-2c0-1.105.896-2 2-2z"
    },
    "children": []
  }]
};
exports.cog = cog;
var compass = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 5c3.859.001 7 3.142 7 7.001 0 3.858-3.141 6.998-7 6.999-3.859 0-7-3.14-7-6.999s3.141-7 7-7.001m0-2c-4.971.001-9 4.03-9 9.001 0 4.97 4.029 8.999 9 8.999 4.97-.001 9-4.03 9-8.999 0-4.971-4.029-9-9-9.001zM16.182 7.819c-.129-.128-.315-.178-.491-.127l-5.951 1.706c-.166.048-.295.177-.342.343l-1.707 5.951c-.051.175-.002.363.127.491.095.095.223.146.354.146l.138-.02 5.95-1.708c.165-.047.295-.177.342-.343l1.707-5.949c.05-.173.002-.361-.127-.49zm-7.282 7.282l1.383-4.817 3.434 3.435-4.817 1.382z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 5c3.859.001 7 3.142 7 7.001 0 3.858-3.141 6.998-7 6.999-3.859 0-7-3.14-7-6.999s3.141-7 7-7.001m0-2c-4.971.001-9 4.03-9 9.001 0 4.97 4.029 8.999 9 8.999 4.97-.001 9-4.03 9-8.999 0-4.971-4.029-9-9-9.001zM16.182 7.819c-.129-.128-.315-.178-.491-.127l-5.951 1.706c-.166.048-.295.177-.342.343l-1.707 5.951c-.051.175-.002.363.127.491.095.095.223.146.354.146l.138-.02 5.95-1.708c.165-.047.295-.177.342-.343l1.707-5.949c.05-.173.002-.361-.127-.49zm-7.282 7.282l1.383-4.817 3.434 3.435-4.817 1.382z"
        },
        "children": []
      }]
    }]
  }]
};
exports.compass = compass;
var contacts = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M19 3h-11c-1.654 0-3 1.346-3 3v1h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v2h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v2h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v1c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-12 3c0-.551.449-1 1-1v2h-1v-1zm0 3h1v2h-1v-2zm0 4h1v2h-1v-2zm0 5v-1h1v2c-.551 0-1-.449-1-1zm13 0c0 .551-.449 1-1 1h-10v-14h10c.551 0 1 .449 1 1v12z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M19 3h-11c-1.654 0-3 1.346-3 3v1h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v2h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v2h-1c-.553 0-1 .448-1 1s.447 1 1 1h1v1c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm-12 3c0-.551.449-1 1-1v2h-1v-1zm0 3h1v2h-1v-2zm0 4h1v2h-1v-2zm0 5v-1h1v2c-.551 0-1-.449-1-1zm13 0c0 .551-.449 1-1 1h-10v-14h10c.551 0 1 .449 1 1v12z"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "14",
        "cy": "10.5",
        "r": "2"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "14",
          "cy": "10.5",
          "r": "2"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M14 13.356c-1.562 0-2.5.715-2.5 1.429 0 .357.938.715 2.5.715 1.466 0 2.5-.357 2.5-.715 0-.714-.98-1.429-2.5-1.429z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M14 13.356c-1.562 0-2.5.715-2.5 1.429 0 .357.938.715 2.5.715 1.466 0 2.5-.357 2.5-.715 0-.714-.98-1.429-2.5-1.429z"
        },
        "children": []
      }]
    }]
  }]
};
exports.contacts = contacts;
var creditCard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 7h-11c-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-7c0-1.654-1.346-3-3-3zm1 10c0 .552-.448 1-1 1h-11c-.552 0-1-.448-1-1v-4h13v4zm0-6h-13v-1c0-.552.448-1 1-1h11c.552 0 1 .448 1 1v1zM14 16h2c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5s.224.5.5.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 7h-11c-1.654 0-3 1.346-3 3v7c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-7c0-1.654-1.346-3-3-3zm1 10c0 .552-.448 1-1 1h-11c-.552 0-1-.448-1-1v-4h13v4zm0-6h-13v-1c0-.552.448-1 1-1h11c.552 0 1 .448 1 1v1zM14 16h2c.276 0 .5-.224.5-.5s-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5s.224.5.5.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.creditCard = creditCard;
var css3 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M5.7 3.4l-.6 3.2h12.3l-.4 2.1h-12.3l-.6 3.2h12.3l-.7 3.6-5 1.7-4.3-1.7.3-1.6h-3l-.7 3.8 7.1 2.9 8.2-2.9 1.1-5.8.2-1.2 1.4-7.3h-15.3z"
    },
    "children": []
  }]
};
exports.css3 = css3;
var database = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.983 8.791c-.176-3.704-3.236-6.666-6.983-6.666s-6.807 2.962-6.983 6.666l-.017.084v6.25c0 3.86 3.141 7 7 7s7-3.14 7-7v-6.25l-.017-.084zm-6.983 8.834c-2.22 0-4.132-1.324-5-3.222v-.388c1.271 1.3 3.042 2.11 5 2.11s3.729-.811 5-2.11v.388c-.868 1.898-2.78 3.222-5 3.222zm0-13.5c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5zm0 16c-2.271 0-4.172-1.532-4.778-3.609 1.188 1.293 2.888 2.109 4.778 2.109s3.59-.816 4.778-2.109c-.606 2.077-2.507 3.609-4.778 3.609z"
    },
    "children": []
  }]
};
exports.database = database;
var deleteOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3c-4.963 0-9 4.038-9 9s4.037 9 9 9 9-4.038 9-9-4.037-9-9-9zm0 16c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zM12.707 12l2.646-2.646c.194-.194.194-.512 0-.707-.195-.194-.513-.194-.707 0l-2.646 2.646-2.646-2.647c-.195-.194-.513-.194-.707 0-.195.195-.195.513 0 .707l2.646 2.647-2.646 2.646c-.195.195-.195.513 0 .707.097.098.225.147.353.147s.256-.049.354-.146l2.646-2.647 2.646 2.646c.098.098.226.147.354.147s.256-.049.354-.146c.194-.194.194-.512 0-.707l-2.647-2.647z"
    },
    "children": []
  }]
};
exports.deleteOutline = deleteOutline;
var deleteIconic = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 4c-4.419 0-8 3.582-8 8s3.581 8 8 8 8-3.582 8-8-3.581-8-8-8zm3.707 10.293c.391.391.391 1.023 0 1.414-.195.195-.451.293-.707.293s-.512-.098-.707-.293l-2.293-2.293-2.293 2.293c-.195.195-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414l2.293-2.293-2.293-2.293c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l2.293 2.293 2.293-2.293c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-2.293 2.293 2.293 2.293z"
    },
    "children": []
  }]
};
exports.deleteIconic = deleteIconic;
var deviceDesktop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M21 1h-18c-1.654 0-3 1.346-3 3v11c0 1.654 1.346 3 3 3h6v2h-3c-.552 0-1 .448-1 1s.448 1 1 1h12c.552 0 1-.448 1-1s-.448-1-1-1h-3v-2h6c1.654 0 3-1.346 3-3v-11c0-1.654-1.346-3-3-3zm-7 19h-4v-2h4v2zm8-5c0 .551-.449 1-1 1h-18c-.551 0-1-.449-1-1v-11c0-.551.449-1 1-1h18c.551 0 1 .449 1 1v11zM20 4h-16c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm0 9h-16v-8h16v8z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M21 1h-18c-1.654 0-3 1.346-3 3v11c0 1.654 1.346 3 3 3h6v2h-3c-.552 0-1 .448-1 1s.448 1 1 1h12c.552 0 1-.448 1-1s-.448-1-1-1h-3v-2h6c1.654 0 3-1.346 3-3v-11c0-1.654-1.346-3-3-3zm-7 19h-4v-2h4v2zm8-5c0 .551-.449 1-1 1h-18c-.551 0-1-.449-1-1v-11c0-.551.449-1 1-1h18c.551 0 1 .449 1 1v11zM20 4h-16c-.55 0-1 .45-1 1v8c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-8c0-.55-.45-1-1-1zm0 9h-16v-8h16v8z"
        },
        "children": []
      }]
    }]
  }]
};
exports.deviceDesktop = deviceDesktop;
var deviceLaptop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.989 16.049c.009-.315.011-.657.011-1.049v-9c0-1.654-1.346-3-3-3h-14c-1.654 0-3 1.346-3 3v9c0 .385.002.73.012 1.049-1.145.228-2.012 1.24-2.012 2.451 0 1.378 1.122 2.5 2.5 2.5h19c1.378 0 2.5-1.122 2.5-2.5 0-1.211-.866-2.222-2.011-2.451zm-17.989-10.049c0-.551.449-1 1-1h14c.551 0 1 .449 1 1v9c0 .388-.005.726-.014 1h-.986v-9c0-.55-.45-1-1-1h-12c-.55 0-1 .45-1 1v9h-.98c-.012-.264-.02-.599-.02-1v-9zm14 10h-12v-9h12v9zm3.5 3h-19c-.271 0-.5-.229-.5-.5s.229-.5.5-.5h19c.271 0 .5.229.5.5s-.229.5-.5.5z"
    },
    "children": []
  }]
};
exports.deviceLaptop = deviceLaptop;
var devicePhone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M15 3h-7c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h7c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm1 15c0 .551-.449 1-1 1h-7c-.551 0-1-.449-1-1v-12c0-.551.449-1 1-1h7c.551 0 1 .449 1 1v12zM14 6h-5c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1.5c0 .553.448 1 1 1s1-.447 1-1h1.5c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zm0 10h-5v-9h5v9z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M15 3h-7c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h7c1.654 0 3-1.346 3-3v-12c0-1.654-1.346-3-3-3zm1 15c0 .551-.449 1-1 1h-7c-.551 0-1-.449-1-1v-12c0-.551.449-1 1-1h7c.551 0 1 .449 1 1v12zM14 6h-5c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h1.5c0 .553.448 1 1 1s1-.447 1-1h1.5c.55 0 1-.45 1-1v-9c0-.55-.45-1-1-1zm0 10h-5v-9h5v9z"
        },
        "children": []
      }]
    }]
  }]
};
exports.devicePhone = devicePhone;
var deviceTablet = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 4h-9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3.5c0 .553.448 1 1 1s1-.447 1-1h3.5c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm0 13h-9v-12h9v12zM18 1h-11c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-15c0-1.654-1.346-3-3-3zm1 18c0 .551-.449 1-1 1h-11c-.551 0-1-.449-1-1v-15c0-.551.449-1 1-1h11c.551 0 1 .449 1 1v15z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 4h-9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3.5c0 .553.448 1 1 1s1-.447 1-1h3.5c.55 0 1-.45 1-1v-12c0-.55-.45-1-1-1zm0 13h-9v-12h9v12zM18 1h-11c-1.654 0-3 1.346-3 3v15c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-15c0-1.654-1.346-3-3-3zm1 18c0 .551-.449 1-1 1h-11c-.551 0-1-.449-1-1v-15c0-.551.449-1 1-1h11c.551 0 1 .449 1 1v15z"
        },
        "children": []
      }]
    }]
  }]
};
exports.deviceTablet = deviceTablet;
var directions = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.908 9.5l-2.754-2.607c-.568-.541-1.447-.893-2.237-.893h-2.917v-.5c0-.828-.672-1.5-1.5-1.5s-1.5.672-1.5 1.5v.5h-3.5c-1.93 0-3.5 1.57-3.5 3.5 0 1.396.828 2.596 2.016 3.157l-1.844 1.843 2.561 2.561c.57.57 1.46.939 2.268.939h2.2l.8 4h1l.8-4h2.7c1.931 0 3.5-1.57 3.5-3.5 0-.902-.353-1.718-.915-2.339l.072-.056 2.75-2.605zm-5.408 6.5h-7.5c-.275 0-.658-.158-.854-.354l-1.146-1.146 1.146-1.146c.195-.195.577-.354.854-.354h7.5c.828 0 1.5.672 1.5 1.5s-.672 1.5-1.5 1.5zm1.279-5.344c-.199.19-.586.344-.862.344h-9.417c-.828 0-1.5-.672-1.5-1.5s.672-1.5 1.5-1.5h9.417c.276 0 .663.154.862.344l1.221 1.156-1.221 1.156z"
    },
    "children": []
  }]
};
exports.directions = directions;
var divideOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .449-1 1s.448 1 1 1 1-.449 1-1-.448-1-1-1zM12 21.5c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-4c-.552 0-1 .449-1 1s.448 1 1 1 1-.449 1-1-.448-1-1-1zM18 15h-12c-1.654 0-3-1.346-3-3s1.346-3 3-3h12c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-12-4c-.552 0-1 .449-1 1s.448 1 1 1h12c.552 0 1-.449 1-1s-.448-1-1-1h-12z"
    },
    "children": []
  }]
};
exports.divideOutline = divideOutline;
var divide = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "6",
      "r": "2.25"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "18",
      "r": "2.25"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M18 10h-12c-1.104 0-2 .896-2 2s.896 2 2 2h12c1.104 0 2-.896 2-2s-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.divide = divide;
var documentAdd = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 12h-2v-2c0-.553-.447-1-1-1s-1 .447-1 1v2h-2c-.553 0-1 .447-1 1s.447 1 1 1h2v2c0 .553.447 1 1 1s1-.447 1-1v-2h2c.553 0 1-.447 1-1s-.447-1-1-1zM19.707 7.293l-4-4c-.187-.188-.441-.293-.707-.293h-8c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-10c0-.266-.105-.52-.293-.707zm-2.121.707h-1.086c-.827 0-1.5-.673-1.5-1.5v-1.086l2.586 2.586zm-.586 11h-10c-.552 0-1-.448-1-1v-12c0-.552.448-1 1-1h7v1.5c0 1.379 1.121 2.5 2.5 2.5h1.5v9c0 .552-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.documentAdd = documentAdd;
var documentDelete = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.707 7.293l-4-4c-.187-.188-.441-.293-.707-.293h-8c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-10c0-.266-.105-.52-.293-.707zm-2.121.707h-1.086c-.827 0-1.5-.673-1.5-1.5v-1.086l2.586 2.586zm-.586 11h-10c-.552 0-1-.448-1-1v-12c0-.552.448-1 1-1h7v1.5c0 1.379 1.121 2.5 2.5 2.5h1.5v9c0 .552-.448 1-1 1zM15 14h-6c-.553 0-1-.447-1-1s.447-1 1-1h6c.553 0 1 .447 1 1s-.447 1-1 1z"
    },
    "children": []
  }]
};
exports.documentDelete = documentDelete;
var documentText = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 21h-10c-1.654 0-3-1.346-3-3v-12c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zm-10-16c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h10c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1h-10zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 8h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 21h-10c-1.654 0-3-1.346-3-3v-12c0-1.654 1.346-3 3-3h10c1.654 0 3 1.346 3 3v12c0 1.654-1.346 3-3 3zm-10-16c-.551 0-1 .449-1 1v12c0 .551.449 1 1 1h10c.551 0 1-.449 1-1v-12c0-.551-.449-1-1-1h-10zM16 11h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 8h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 14h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5zM16 17h-8c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h8c.276 0 .5.224.5.5s-.224.5-.5.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.documentText = documentText;
var documentIcon = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.707 7.293l-4-4c-.187-.188-.441-.293-.707-.293h-8c-1.654 0-3 1.346-3 3v12c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-10c0-.266-.105-.52-.293-.707zm-2.121.707h-1.086c-.827 0-1.5-.673-1.5-1.5v-1.086l2.586 2.586zm-.586 11h-10c-.552 0-1-.448-1-1v-12c0-.552.448-1 1-1h7v1.5c0 1.379 1.121 2.5 2.5 2.5h1.5v9c0 .552-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.documentIcon = documentIcon;
var downloadOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.986 17c0-.105-.004-.211-.038-.316l-2-6c-.136-.409-.516-.684-.948-.684h-.561l.682-.678c1.17-1.17 1.17-3.072 0-4.242-.81-.812-2.068-1.078-3.121-.709v-1.371c0-1.654-1.346-3-3-3s-3 1.346-3 3v1.371c-1.052-.369-2.311-.103-3.121.709-1.17 1.17-1.17 3.072.002 4.244l.68.676h-.561c-.432 0-.812.275-.948.684l-2 6c-.034.105-.038.211-.038.316-.014 0-.014 5-.014 5 0 .553.447 1 1 1h16c.553 0 1-.447 1-1 0 0 0-5-.014-5zm-13.693-10.506c.189-.187.439-.293.707-.293s.518.104.707.293l2.293 2.293v-5.787c0-.552.448-1 1-1s1 .448 1 1v5.787l2.293-2.293c.379-.377 1.035-.377 1.414 0 .391.39.391 1.023.002 1.412l-4.709 4.684-4.707-4.682c-.391-.388-.391-1.024 0-1.414zm-.572 5.506h1.852l3.429 3.41 3.428-3.41h1.852l1.667 5h-13.894l1.666-5zm12.279 9h-14v-3h14v3z"
    },
    "children": []
  }]
};
exports.downloadOutline = downloadOutline;
var download = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.707 7.404c-.189-.188-.448-.283-.707-.283s-.518.095-.707.283l-2.293 2.293v-6.697c0-.552-.448-1-1-1s-1 .448-1 1v6.697l-2.293-2.293c-.189-.188-.44-.293-.707-.293s-.518.105-.707.293c-.39.39-.39 1.024 0 1.414l4.707 4.682 4.709-4.684c.388-.387.388-1.022-.002-1.412zM20.987 16c0-.105-.004-.211-.039-.316l-2-6c-.136-.409-.517-.684-.948-.684h-.219c-.094.188-.21.368-.367.525l-1.482 1.475h1.348l1.667 5h-13.893l1.667-5h1.348l-1.483-1.475c-.157-.157-.274-.337-.367-.525h-.219c-.431 0-.812.275-.948.684l-2 6c-.035.105-.039.211-.039.316-.013 0-.013 5-.013 5 0 .553.447 1 1 1h16c.553 0 1-.447 1-1 0 0 0-5-.013-5z"
    },
    "children": []
  }]
};
exports.download = download;
var dropbox = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3 12.9l5.3 3.5 3.7-3.1-5.3-3.3zM8.3 3.6l-5.3 3.5 3.7 2.9 5.3-3.3zM21 7.1l-5.3-3.5-3.7 3.1 5.3 3.3zM12 13.3l3.7 3.1 5.3-3.5-3.7-2.9zM12 14.5l-3.7 3.1-1.6-1.1v1.2l5.3 3.2 5.3-3.2v-1.2l-1.6 1.1z"
    },
    "children": []
  }]
};
exports.dropbox = dropbox;
var edit = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.561 5.318l-2.879-2.879c-.293-.293-.677-.439-1.061-.439-.385 0-.768.146-1.061.439l-3.56 3.561h-9c-.552 0-1 .447-1 1v13c0 .553.448 1 1 1h13c.552 0 1-.447 1-1v-9l3.561-3.561c.293-.293.439-.677.439-1.061s-.146-.767-.439-1.06zm-10.061 9.354l-2.172-2.172 6.293-6.293 2.172 2.172-6.293 6.293zm-2.561-1.339l1.756 1.728-1.695-.061-.061-1.667zm7.061 5.667h-11v-11h6l-3.18 3.18c-.293.293-.478.812-.629 1.289-.16.5-.191 1.056-.191 1.47v3.061h3.061c.414 0 1.108-.1 1.571-.29.464-.19.896-.347 1.188-.64l3.18-3.07v6zm2.5-11.328l-2.172-2.172 1.293-1.293 2.171 2.172-1.292 1.293z"
    },
    "children": []
  }]
};
exports.edit = edit;
var ejectOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 8.551v-1.551c0-1.105-.896-2-2-2h-10v10c0 1.104.896 2 2 2h1.066c.893 2.887 3.646 5 6.809 5 3.859 0 7.062-3.016 7.062-6.875.001-3.161-2.068-5.74-4.937-6.574zm-8 1.862v3.243c0 .552-.448 1-1 1s-1-.448-1-1v-6.656h6.656c.552 0 1 .448 1 1s-.448 1-1 1h-3.243l4.801 4.799c.392.391.392 1.025.001 1.415-.189.188-.439.292-.708.292-.268 0-.519-.104-.707-.291l-4.8-4.802zm6 9.618c-2.757 0-5-2.26-5-5.016 0-.705-.004-1.371.21-1.979l2.883 2.884c.39.39.901.584 1.414.584s1.022-.194 1.414-.584c.781-.78.781-2.049 0-2.83l-2.567-2.567c.517-.226 1.065-.398 1.646-.398 2.757 0 5 2.182 5 4.938 0 2.757-2.243 4.968-5 4.968z"
    },
    "children": []
  }]
};
exports.ejectOutline = ejectOutline;
var eject = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 17.5c-2.481 0-4.5-2.019-4.5-4.5 0-.553-.447-1-1-1s-1 .447-1 1c0 3.584 2.916 6.5 6.5 6.5s6.5-2.916 6.5-6.5-2.916-6.5-6.5-6.5c-.553 0-1 .447-1 1s.447 1 1 1c2.481 0 4.5 2.019 4.5 4.5s-2.019 4.5-4.5 4.5zM10.656 4c.552 0 1 .448 1 1s-.448 1-1 1h-3.243l1.708 1.707 4.093 4.092c.391.391.391 1.025.001 1.415-.189.188-.44.292-.708.292s-.519-.104-.707-.291l-4.093-4.094-1.707-1.708v3.243c0 .552-.448 1-1 1s-1-.448-1-1v-6.656h6.656"
    },
    "children": []
  }]
};
exports.eject = eject;
var equalsOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 12h-12c-1.654 0-3-1.346-3-3s1.346-3 3-3h12c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-12-4c-.552 0-1 .449-1 1s.448 1 1 1h12c.552 0 1-.449 1-1s-.448-1-1-1h-12zM18 19h-12c-1.654 0-3-1.346-3-3s1.346-3 3-3h12c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-12-4c-.552 0-1 .449-1 1s.448 1 1 1h12c.552 0 1-.449 1-1s-.448-1-1-1h-12z"
    },
    "children": []
  }]
};
exports.equalsOutline = equalsOutline;
var equals = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 7h-12c-1.104 0-2 .896-2 2s.896 2 2 2h12c1.104 0 2-.896 2-2s-.896-2-2-2zM18 14h-12c-1.104 0-2 .896-2 2s.896 2 2 2h12c1.104 0 2-.896 2-2s-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.equals = equals;
var exportOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.711 9.796c-.041-.041-4.055-4.096-5.982-6.146-.42-.414-.999-.65-1.586-.65-1.182 0-2.143.896-2.143 2h-8c-.553 0-1 .448-1 1v14c0 .552.447 1 1 1h14c.553 0 1-.448 1-1v-6.045c1.434-1.461 2.688-2.729 2.711-2.751.387-.39.387-1.018 0-1.408zm-7.432 6.145l-.136.059-.144-.04v-3.96h-1c-1.771.034-3.336.68-4.753 1.958.43-2.215 1.6-4.958 4.753-4.958h1v-3.958l.144-.042.154.05c1.436 1.525 4.051 4.187 5.297 5.45-.253.257-4.342 4.422-5.315 5.441zm-9.279 3.059v-12h8v1c-4.66 0-6 4.871-6 8.5v.5c1.691-2.578 3.6-3.953 6-4v3c0 .551.512 1 1.143 1 .364 0 .676-.158.883-.391.539-.565 1.242-1.291 1.976-2.043v4.434h-12.002z"
    },
    "children": []
  }]
};
exports.exportOutline = exportOutline;
var exportIcon = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 16.5v.5c1.691-2.578 3.6-3.953 6-4v3c0 .551.511 1 1.143 1 .364 0 .675-.158.883-.391 1.933-2.029 5.974-6.109 5.974-6.109s-4.041-4.082-5.975-6.137c-.208-.205-.518-.363-.882-.363-.632 0-1.143.447-1.143 1v3c-4.66 0-6 4.871-6 8.5zM5 21h14c.553 0 1-.448 1-1v-6.046c-.664.676-1.364 1.393-2 2.047v2.999h-12v-12h7v-2h-8c-.553 0-1 .448-1 1v14c0 .552.447 1 1 1z"
    },
    "children": []
  }]
};
exports.exportIcon = exportIcon;
var eyeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 9c1.211 0 2.381.355 3.297 1.004 1.301.92 2.43 2.124 3.165 2.996-.735.872-1.864 2.077-3.166 2.996-.915.649-2.085 1.004-3.296 1.004s-2.382-.355-3.299-1.004c-1.301-.92-2.43-2.124-3.164-2.996.734-.872 1.863-2.076 3.164-2.995.917-.65 2.088-1.005 3.299-1.005m0-2c-1.691 0-3.242.516-4.453 1.371-2.619 1.852-4.547 4.629-4.547 4.629s1.928 2.777 4.547 4.629c1.211.855 2.762 1.371 4.453 1.371s3.242-.516 4.451-1.371c2.619-1.852 4.549-4.629 4.549-4.629s-1.93-2.777-4.549-4.629c-1.209-.855-2.76-1.371-4.451-1.371zM12 12c-.553 0-1 .447-1 1 0 .551.447 1 1 1 .551 0 1-.449 1-1 0-.553-.449-1-1-1zM12 16c-1.654 0-3-1.346-3-3s1.346-3 3-3 3 1.346 3 3-1.346 3-3 3zm0-5c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.eyeOutline = eyeOutline;
var eye = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.821 12.43c-.083-.119-2.062-2.944-4.793-4.875-1.416-1.003-3.202-1.555-5.028-1.555-1.825 0-3.611.552-5.03 1.555-2.731 1.931-4.708 4.756-4.791 4.875-.238.343-.238.798 0 1.141.083.119 2.06 2.944 4.791 4.875 1.419 1.002 3.205 1.554 5.03 1.554 1.826 0 3.612-.552 5.028-1.555 2.731-1.931 4.71-4.756 4.793-4.875.239-.342.239-.798 0-1.14zm-9.821 4.07c-1.934 0-3.5-1.57-3.5-3.5 0-1.934 1.566-3.5 3.5-3.5 1.93 0 3.5 1.566 3.5 3.5 0 1.93-1.57 3.5-3.5 3.5zM14 13c0 1.102-.898 2-2 2-1.105 0-2-.898-2-2 0-1.105.895-2 2-2 1.102 0 2 .895 2 2z"
    },
    "children": []
  }]
};
exports.eye = eye;
var feather = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.68 1.017l-.18-.034-.18.033c-4.821.884-8.32 5.084-8.32 9.984 0 4.617 3.108 8.61 7.5 9.795v1.205c0 .553.448 1 1 1s1-.447 1-1v-1.205c4.392-1.185 7.5-5.178 7.5-9.795 0-4.9-3.499-9.1-8.32-9.983zm.82 17.683v-11.7c0-.553-.448-1-1-1s-1 .447-1 1v11.7c-3.18-1.093-5.4-4.054-5.49-7.483l3.137 3.137c.097.097.225.146.353.146s.256-.049.354-.146c.195-.195.195-.512 0-.707l-3.769-3.769c.133-.964.434-1.877.877-2.709l2.184 2.185c.098.097.226.146.354.146s.256-.049.354-.146c.195-.195.195-.512 0-.707l-2.353-2.353c1.162-1.641 2.919-2.846 4.999-3.275 2.08.43 3.837 1.635 4.999 3.275l-2.353 2.353c-.195.195-.195.512 0 .707.098.097.226.146.354.146s.256-.049.354-.146l2.184-2.185c.444.832.744 1.745.877 2.709l-3.769 3.769c-.195.195-.195.512 0 .707.098.098.226.146.354.146s.256-.049.354-.146l3.137-3.137c-.091 3.429-2.311 6.39-5.491 7.483z"
    },
    "children": []
  }]
};
exports.feather = feather;
var film = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M8 8v7h8v-7h-8zm7 6h-6v-5h6v5zM17 2h-3v2h-4v-2h-3c-1.654 0-3 1.346-3 3v13c0 1.654 1.346 3 3 3h3v-2h4v2h3c1.654 0 3-1.346 3-3v-13c0-1.654-1.346-3-3-3zm1 4c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c0 .551-.448 1-1 1h-1v-2h-8v2h-1c-.552 0-1-.449-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c0-.551.448-1 1-1h1v2h8v-2h1c.552 0 1 .449 1 1v1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M8 8v7h8v-7h-8zm7 6h-6v-5h6v5zM17 2h-3v2h-4v-2h-3c-1.654 0-3 1.346-3 3v13c0 1.654 1.346 3 3 3h3v-2h4v2h3c1.654 0 3-1.346 3-3v-13c0-1.654-1.346-3-3-3zm1 4c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c-.553 0-1 .447-1 1s.447 1 1 1v1c0 .551-.448 1-1 1h-1v-2h-8v2h-1c-.552 0-1-.449-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c.553 0 1-.447 1-1s-.447-1-1-1v-1c0-.551.448-1 1-1h1v2h8v-2h1c.552 0 1 .449 1 1v1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.film = film;
var filter = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 6h-14c-1.1 0-1.4.6-.6 1.4l4.2 4.2c.8.8 1.4 2.3 1.4 3.4v5l4-2v-3.5c0-.8.6-2.1 1.4-2.9l4.2-4.2c.8-.8.5-1.4-.6-1.4z"
    },
    "children": []
  }]
};
exports.filter = filter;
var flagOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.383 4.318c-.374-.155-.804-.069-1.09.217-1.264 1.263-3.321 1.264-4.586 0-2.045-2.043-5.37-2.043-7.414 0-.188.187-.293.442-.293.707v13c0 .552.448 1 1 1s1-.448 1-1v-4.553c1.271-.997 3.121-.911 4.293.26 2.045 2.043 5.371 2.043 7.414 0 .188-.188.293-.442.293-.707v-8c0-.405-.244-.769-.617-.924zm-7.09 1.631c1.54 1.539 3.808 1.918 5.707 1.138v2.311c-1.446.916-3.387.749-4.646-.51-1.448-1.447-3.598-1.743-5.354-.927v-2.272c1.271-.997 3.121-.912 4.293.26zm1.414 6.585c-1.022-1.021-2.365-1.532-3.707-1.532-.681 0-1.361.131-2 .394v-2.311c1.446-.916 3.387-.749 4.646.51.925.924 2.139 1.386 3.354 1.386.687 0 1.366-.164 2-.459v2.272c-1.272.997-3.122.911-4.293-.26z"
    },
    "children": []
  }]
};
exports.flagOutline = flagOutline;
var flag = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.383 4.318c-.374-.155-.804-.069-1.09.217-1.264 1.263-3.321 1.264-4.586 0-2.045-2.043-5.37-2.043-7.414 0-.188.187-.293.442-.293.707v13c0 .552.447 1 1 1s1-.448 1-1v-4.553c1.271-.997 3.121-.911 4.293.26 2.045 2.043 5.371 2.043 7.414 0 .188-.188.293-.442.293-.707v-8c0-.405-.244-.769-.617-.924z"
    },
    "children": []
  }]
};
exports.flag = flag;
var flashOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.5 4h.005m-.005 0l-2.5 6 5 2.898-7.5 7.102 2.5-6-5-2.9 7.5-7.1m0-2c-.562.012-1.029.219-1.379.551l-7.497 7.095c-.458.435-.685 1.059-.61 1.686.072.626.437 1.182.982 1.498l3.482 2.021-1.826 4.381c-.362.871-.066 1.879.712 2.416.344.236.739.354 1.135.354.498 0 .993-.186 1.375-.548l7.5-7.103c.458-.434.685-1.058.61-1.685-.073-.627-.438-1.183-.982-1.498l-3.482-2.018 1.789-4.293c.123-.26.192-.551.192-.857 0-1.102-.89-1.996-2.001-2z"
    },
    "children": []
  }]
};
exports.flashOutline = flashOutline;
var flash = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.502 12.033l-4.241-2.458 2.138-5.131c.066-.134.103-.285.103-.444 0-.552-.445-1-.997-1-.249.004-.457.083-.622.214l-.07.06-7.5 7.1c-.229.217-.342.529-.306.842.036.313.219.591.491.75l4.242 2.46-2.163 5.19c-.183.436-.034.94.354 1.208.173.118.372.176.569.176.248 0 .496-.093.688-.274l7.5-7.102c.229-.217.342-.529.306-.842-.037-.313-.22-.591-.492-.749z"
    },
    "children": []
  }]
};
exports.flash = flash;
var flowChildren = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 16c-1.305 0-2.403.837-2.816 2h-3.184c-1.654 0-3-1.346-3-3v-3.025c.838.634 1.87 1.025 3 1.025h3.184c.413 1.163 1.512 2 2.816 2 1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.305 0-2.403.837-2.816 2h-3.184c-1.654 0-3-1.346-3-3v-.184c1.163-.413 2-1.512 2-2.816 0-1.657-1.343-3-3-3s-3 1.343-3 3c0 1.304.837 2.403 2 2.816v7.184c0 2.757 2.243 5 5 5h3.184c.413 1.163 1.512 2 2.816 2 1.657 0 3-1.343 3-3s-1.343-3-3-3zm0-5c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm-10-7c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm10 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.flowChildren = flowChildren;
var flowMerge = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 16.184v-1.851c0-1.93-1.57-3.5-3.5-3.5-.827 0-1.5-.673-1.5-1.5v-1.517c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815v1.518c0 .827-.673 1.5-1.5 1.5-1.93 0-3.5 1.57-3.5 3.5v1.851c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816v-1.851c0-.827.673-1.5 1.5-1.5.979 0 1.864-.407 2.5-1.058.636.651 1.521 1.058 2.5 1.058.827 0 1.5.673 1.5 1.5v1.851c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-11 3.816c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zm5-16c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm5 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.flowMerge = flowMerge;
var flowParallel = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M18 16.184v-8.368c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815v8.369c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-1-12.184c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zM10 5c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815v8.369c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816v-8.368c1.161-.415 2-1.514 2-2.816zm-3-1c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M18 16.184v-8.368c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815v8.369c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-1-12.184c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zM10 5c0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815v8.369c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816v-8.368c1.161-.415 2-1.514 2-2.816zm-3-1c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm0 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.flowParallel = flowParallel;
var flowSwitch = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M8 16.184v-.684c0-.848.512-1.595 1.287-2.047-.667-.282-1.279-.667-1.822-1.131-.904.814-1.465 1.938-1.465 3.178v.684c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-1 3.816c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zM16 7.815v.351c0 .985-.535 1.852-1.345 2.36.665.274 1.279.646 1.823 1.1.936-.878 1.522-2.102 1.522-3.459v-.351c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815zm1-3.815c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zM17.935 16.164c-.41-2.913-2.911-5.164-5.935-5.164-1.936 0-3.552-1.381-3.92-3.209 1.12-.436 1.92-1.519 1.92-2.791 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.326.87 2.44 2.065 2.836.41 2.913 2.911 5.164 5.935 5.164 1.936 0 3.552 1.381 3.92 3.209-1.12.436-1.92 1.519-1.92 2.791 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.326-.87-2.44-2.065-2.836zm-10.935-12.164c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm10 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M8 16.184v-.684c0-.848.512-1.595 1.287-2.047-.667-.282-1.279-.667-1.822-1.131-.904.814-1.465 1.938-1.465 3.178v.684c-1.161.415-2 1.514-2 2.816 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.302-.839-2.401-2-2.816zm-1 3.816c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1zM16 7.815v.351c0 .985-.535 1.852-1.345 2.36.665.274 1.279.646 1.823 1.1.936-.878 1.522-2.102 1.522-3.459v-.351c1.161-.415 2-1.514 2-2.816 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.302.839 2.401 2 2.815zm1-3.815c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zM17.935 16.164c-.41-2.913-2.911-5.164-5.935-5.164-1.936 0-3.552-1.381-3.92-3.209 1.12-.436 1.92-1.519 1.92-2.791 0-1.654-1.346-3-3-3s-3 1.346-3 3c0 1.326.87 2.44 2.065 2.836.41 2.913 2.911 5.164 5.935 5.164 1.936 0 3.552 1.381 3.92 3.209-1.12.436-1.92 1.519-1.92 2.791 0 1.654 1.346 3 3 3s3-1.346 3-3c0-1.326-.87-2.44-2.065-2.836zm-10.935-12.164c.552 0 1 .449 1 1s-.448 1-1 1-1-.449-1-1 .448-1 1-1zm10 16c-.552 0-1-.449-1-1s.448-1 1-1 1 .449 1 1-.448 1-1 1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.flowSwitch = flowSwitch;
var folderAdd = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 6h-6c0-1.104-.896-2-2-2h-4c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm0 12h-12c-.552 0-1-.448-1-1v-7h4c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-4v-2c0-.552.448-1 1-1h4c0 1.104.896 2 2 2h6c.552 0 1 .448 1 1h-4c-.275 0-.5.225-.5.5s.225.5.5.5h4v7c0 .552-.448 1-1 1zM15 12h-2v-2c0-.553-.447-1-1-1s-1 .447-1 1v2h-2c-.553 0-1 .447-1 1s.447 1 1 1h2v2c0 .553.447 1 1 1s1-.447 1-1v-2h2c.553 0 1-.447 1-1s-.447-1-1-1z"
    },
    "children": []
  }]
};
exports.folderAdd = folderAdd;
var folderDelete = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 6h-6c0-1.104-.896-2-2-2h-4c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm-12 0h4c0 1.104.896 2 2 2h6c.552 0 1 .448 1 1h-14v-2c0-.552.448-1 1-1zm12 12h-12c-.552 0-1-.448-1-1v-7h14v7c0 .552-.448 1-1 1zM15 14h-6c-.553 0-1-.447-1-1s.447-1 1-1h6c.553 0 1 .447 1 1s-.447 1-1 1z"
    },
    "children": []
  }]
};
exports.folderDelete = folderDelete;
var folderOpen = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.3 8h-2.4c-.4-1.2-1.5-2-2.8-2h-6c0-1.1-.9-2-2-2h-4.1c-1.7 0-3 1.3-3 3v10c0 1.7 1.3 3 3 3h12c1.7 0 3.4-1.3 3.8-3l2.2-8c.1-.6-.2-1-.7-1zm-18.3 1v-2c0-.6.4-1 1-1h4c0 1.1.9 2 2 2h6c.6 0 1 .4 1 1h-11.1c-.6 0-1.1.4-1.3 1l-1.6 6.3v-7.3zm14.9 7.5c-.2.8-1.1 1.5-1.9 1.5h-12s-.4-.2-.2-.8l1.9-7c0-.1.2-.2.3-.2h13.7l-1.8 6.5z"
    },
    "children": []
  }]
};
exports.folderOpen = folderOpen;
var folder = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 6h-6c0-1.104-.896-2-2-2h-4c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h12c1.654 0 3-1.346 3-3v-8c0-1.654-1.346-3-3-3zm-12 0h4c0 1.104.896 2 2 2h6c.552 0 1 .448 1 1h-14v-2c0-.552.448-1 1-1zm12 12h-12c-.552 0-1-.448-1-1v-7h14v7c0 .552-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.folder = folder;
var gift = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 8h-2.352c.219-.457.352-.961.352-1.5 0-1.93-1.57-3.5-3.5-3.5-.979 0-1.864.407-2.5 1.058-.636-.651-1.521-1.058-2.5-1.058-1.93 0-3.5 1.57-3.5 3.5 0 .539.133 1.043.352 1.5h-2.352c-.553 0-1 .448-1 1v4c0 .552.447 1 1 1v5c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-5c.553 0 1-.448 1-1v-4c0-.552-.447-1-1-1zm-1 4h-5v-2h5v2zm-8-5h2v1h-2v-1zm2 3v2h-2v-2h2zm1.5-5c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5c-.177 0-.344-.039-.5-.097v-.903c0-.521-.404-.937-.913-.982.202-.59.756-1.018 1.413-1.018zm-6.5 1.5c0-.827.673-1.5 1.5-1.5.657 0 1.211.428 1.413 1.018-.509.045-.913.461-.913.982v.903c-.156.058-.323.097-.5.097-.827 0-1.5-.673-1.5-1.5zm2 3.5v2h-5v-2h5zm-3 10c-.551 0-1-.449-1-1v-6h4v7h-3zm4 0v-7h2v7h-2zm6 0h-3v-7h4v6c0 .551-.449 1-1 1z"
    },
    "children": []
  }]
};
exports.gift = gift;
var globeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 6c2.206 0 4 1.794 4 4s-1.794 4-4 4c-2.204 0-3.998-1.794-3.998-4s1.794-4 3.998-4m0-2c-3.314 0-5.998 2.686-5.998 6s2.684 6 5.998 6c3.312 0 6-2.688 6-6 0-3.314-2.688-6-6-6zM17 20h-4v-1.23c1.641-.371 3.146-1.188 4.363-2.406 1.699-1.699 2.637-3.96 2.637-6.363 0-2.067-.691-4.028-1.968-5.619l.675-.673c.391-.391.391-1.023.001-1.415-.392-.392-1.024-.39-1.415-.001l-2.052 2.049.708.708c1.322 1.321 2.051 3.08 2.051 4.95s-.729 3.627-2.051 4.949-3.079 2.051-4.949 2.051-3.627-.729-4.949-2.051c-.391-.391-1.023-.391-1.414 0-.391.39-.391 1.023 0 1.414 1.699 1.699 3.959 2.637 6.363 2.637v1h-4c-.553 0-1 .447-1 1s.447 1 1 1h10c.553 0 1-.447 1-1s-.447-1-1-1z"
    },
    "children": []
  }]
};
exports.globeOutline = globeOutline;
var globe = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 20h-4c-.553 0-1 .447-1 1s.447 1 1 1h10c.553 0 1-.447 1-1s-.447-1-1-1h-4v-1.23c1.64-.371 3.146-1.188 4.363-2.406 1.7-1.7 2.637-3.96 2.637-6.364 0-2.067-.692-4.029-1.968-5.619l.675-.673c.391-.391.391-1.023.001-1.415-.391-.391-1.024-.39-1.415-.001l-2.052 2.049.708.708c1.322 1.322 2.051 3.081 2.051 4.951s-.729 3.627-2.051 4.949-3.079 2.051-4.949 2.051-3.627-.729-4.949-2.051c-.391-.391-1.023-.391-1.414 0-.391.39-.391 1.023 0 1.414 1.699 1.7 3.959 2.637 6.363 2.637v1zM11 4c1.657 0 3.157.672 4.243 1.757 1.085 1.086 1.757 2.586 1.757 4.243 0 1.656-.672 3.156-1.757 4.242-1.086 1.086-2.586 1.758-4.243 1.758-1.658 0-3.157-.672-4.242-1.757-1.085-1.086-1.756-2.586-1.756-4.243s.671-3.157 1.756-4.243c1.085-1.085 2.584-1.757 4.242-1.757z"
    },
    "children": []
  }]
};
exports.globe = globe;
var groupOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 14c2.764 0 5-2.238 5-5s-2.236-5-5-5-5 2.238-5 5 2.236 5 5 5zm0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3zM20 15c1.381 0 2.5-1.117 2.5-2.5 0-1.381-1.119-2.5-2.5-2.5-1.382 0-2.5 1.119-2.5 2.5 0 1.383 1.118 2.5 2.5 2.5zm0-4c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5zM20 15.59c-1.331 0-2.332.406-2.917.969-1.115-.918-2.878-1.559-5.083-1.559-2.266 0-3.995.648-5.092 1.564-.596-.565-1.608-.975-2.908-.975-2.188 0-3.5 1.091-3.5 2.183 0 .545 1.312 1.092 3.5 1.092.604 0 1.146-.051 1.623-.133l-.04.27c0 1 2.405 2 6.417 2 3.762 0 6.417-1 6.417-2l-.021-.255c.463.073.996.118 1.604.118 2.051 0 3.5-.547 3.5-1.092 0-1.092-1.373-2.182-3.5-2.182zm-16 2.273c-1.309 0-2.068-.207-2.417-.354.239-.405 1.003-.92 2.417-.92 1.107 0 1.837.351 2.208.706l-.235.344c-.452.119-1.108.224-1.973.224zm8 1.137c-2.163 0-3.501-.312-4.184-.561.521-.678 1.918-1.439 4.184-1.439 2.169 0 3.59.761 4.148 1.425-.755.27-2.162.575-4.148.575zm8-1.137c-.914 0-1.546-.103-1.973-.213-.072-.127-.155-.252-.248-.375.356-.345 1.071-.685 2.221-.685 1.324 0 2.141.501 2.404.911-.39.163-1.205.362-2.404.362zM4 15c1.381 0 2.5-1.119 2.5-2.5 0-1.379-1.119-2.5-2.5-2.5-1.382 0-2.5 1.121-2.5 2.5 0 1.381 1.118 2.5 2.5 2.5zm0-4c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5z"
    },
    "children": []
  }]
};
exports.groupOutline = groupOutline;
var group = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 14c1.381 0 2.631-.56 3.536-1.465.904-.904 1.464-2.154 1.464-3.535s-.56-2.631-1.464-3.535c-.905-.905-2.155-1.465-3.536-1.465s-2.631.56-3.536 1.465c-.904.904-1.464 2.154-1.464 3.535s.56 2.631 1.464 3.535c.905.905 2.155 1.465 3.536 1.465zM20 15c.69 0 1.315-.279 1.768-.731.453-.452.732-1.077.732-1.769 0-.69-.279-1.315-.732-1.768-.453-.453-1.078-.732-1.768-.732-.691 0-1.316.279-1.769.732-.452.453-.731 1.078-.731 1.768 0 .691.279 1.316.731 1.769s1.078.731 1.769.731zM20 15.59c-1.331 0-2.332.406-2.917.968-1.115-.917-2.878-1.558-5.083-1.558-2.266 0-3.995.648-5.092 1.564-.596-.565-1.608-.974-2.908-.974-2.188 0-3.5 1.09-3.5 2.182 0 .545 1.312 1.092 3.5 1.092.604 0 1.146-.051 1.623-.133l-.04.27c0 1 2.406 2 6.417 2 3.762 0 6.417-1 6.417-2l-.02-.255c.463.073.995.118 1.603.118 2.051 0 3.5-.547 3.5-1.092 0-1.092-1.373-2.182-3.5-2.182zM4 15c.69 0 1.315-.279 1.768-.732.453-.453.732-1.078.732-1.768 0-.689-.279-1.314-.732-1.768-.453-.452-1.078-.732-1.768-.732-.691 0-1.316.28-1.769.732-.452.454-.731 1.079-.731 1.768 0 .69.279 1.315.731 1.768.453.453 1.078.732 1.769.732z"
    },
    "children": []
  }]
};
exports.group = group;
var headphones = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 13c0-4.963-4.037-9-9-9s-9 4.037-9 9v2.6l.023.113c-.013.243-.023.5-.023.787v2c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-2c0-1.511-.83-2.79-1.982-3.278.095-2.122 1.837-3.823 3.982-3.823s3.887 1.7 3.982 3.822c-1.152.49-1.982 1.768-1.982 3.279v2c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5v-2c0-.287-.01-.544-.023-.787l.023-.113v-2.6zm-16 0c0-1.586.538-3.046 1.432-4.221l.89.889c-.742.928-1.218 2.075-1.302 3.332-.02 0-.02 1-.02 1h-1v-1zm3 5.5c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-2c0-.666.057-1.176.114-1.5h1.886c.473 0 1 .616 1 1.5v2zm7.77-9.338l-.354.354c-.912-.913-2.125-1.416-3.416-1.416s-2.504.503-3.417 1.416l-.354-.354-1.141-1.141-.627-.626c1.479-1.48 3.447-2.295 5.539-2.295 2.093 0 4.06.815 5.539 2.295l-.627.626-1.142 1.141zm3.23 9.338c0 .827-.673 1.5-1.5 1.5s-1.5-.673-1.5-1.5v-2c0-.884.527-1.5 1-1.5h1.886c.057.324.114.834.114 1.5v2zm0-4.5h-1v-1c-.104-1.257-.58-2.404-1.322-3.332l.891-.889c.893 1.175 1.431 2.634 1.431 4.221v1z"
    },
    "children": []
  }]
};
exports.headphones = headphones;
var heartFullOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.2 9.4c0 1.3.2 3.3 2 5.1 1.6 1.6 6.9 5.2 7.1 5.4.2.1.4.2.6.2s.4-.1.6-.2c.2-.2 5.5-3.7 7.1-5.4 1.8-1.8 2-3.8 2-5.1 0-3-2.4-5.4-5.4-5.4-1.6 0-3.2.9-4.2 2.3-1-1.4-2.6-2.3-4.4-2.3-2.9 0-5.4 2.4-5.4 5.4z"
    },
    "children": []
  }]
};
exports.heartFullOutline = heartFullOutline;
var heartHalfOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M2.2 9.4c0 1.3.2 3.3 2 5.1 1.6 1.6 6.9 5.2 7.1 5.4.2.1.4.2.6.2s.4-.1.6-.2c.2-.2 5.5-3.7 7.1-5.4 1.8-1.8 2-3.8 2-5.1 0-3-2.4-5.4-5.4-5.4-1.6 0-3.2.9-4.2 2.3-1-1.4-2.6-2.3-4.4-2.3-2.9 0-5.4 2.4-5.4 5.4zm9.8 1c.6 0 1-.4 1-1 0-1.9 1.5-3.4 3.4-3.4s3.4 1.5 3.4 3.4c0 1.1-.2 2.4-1.5 3.7-1.2 1.2-4.9 3.8-6.3 4.7v-7.4z"
    },
    "children": []
  }]
};
exports.heartHalfOutline = heartHalfOutline;
var heartOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 20c-.195 0-.391-.057-.561-.172-.225-.151-5.508-3.73-7.146-5.371-1.831-1.831-2.043-3.777-2.043-5.082 0-2.964 2.411-5.375 5.375-5.375 1.802 0 3.398.891 4.375 2.256.977-1.365 2.573-2.256 4.375-2.256 2.964 0 5.375 2.411 5.375 5.375 0 1.305-.212 3.251-2.043 5.082-1.641 1.641-6.923 5.22-7.146 5.371-.17.115-.366.172-.561.172zm-4.375-14c-1.861 0-3.375 1.514-3.375 3.375 0 1.093.173 2.384 1.457 3.668 1.212 1.212 4.883 3.775 6.293 4.746 1.41-.971 5.081-3.534 6.293-4.746 1.284-1.284 1.457-2.575 1.457-3.668 0-1.861-1.514-3.375-3.375-3.375s-3.375 1.514-3.375 3.375c0 .552-.447 1-1 1s-1-.448-1-1c0-1.861-1.514-3.375-3.375-3.375z"
    },
    "children": []
  }]
};
exports.heartOutline = heartOutline;
var heart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 10.375c0-2.416-1.959-4.375-4.375-4.375s-4.375 1.959-4.375 4.375c0 1.127.159 2.784 1.75 4.375l7 5.25s5.409-3.659 7-5.25 1.75-3.248 1.75-4.375c0-2.416-1.959-4.375-4.375-4.375s-4.375 1.959-4.375 4.375"
    },
    "children": []
  }]
};
exports.heart = heart;
var homeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.262 10.468c-3.39-2.854-9.546-8.171-9.607-8.225l-.655-.563-.652.563c-.062.053-6.221 5.368-9.66 8.248-.438.394-.688.945-.688 1.509 0 1.104.896 2 2 2h1v6c0 1.104.896 2 2 2h12c1.104 0 2-.896 2-2v-6h1c1.104 0 2-.896 2-2 0-.598-.275-1.161-.738-1.532zm-8.262 9.532h-4v-5h4v5zm4-8l.002 8h-3.002v-6h-6v6h-3v-8h-3.001c2.765-2.312 7.315-6.227 9.001-7.68 1.686 1.453 6.234 5.367 9 7.681l-3-.001z"
    },
    "children": []
  }]
};
exports.homeOutline = homeOutline;
var home = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3s-6.186 5.34-9.643 8.232c-.203.184-.357.452-.357.768 0 .553.447 1 1 1h2v7c0 .553.447 1 1 1h3c.553 0 1-.448 1-1v-4h4v4c0 .552.447 1 1 1h3c.553 0 1-.447 1-1v-7h2c.553 0 1-.447 1-1 0-.316-.154-.584-.383-.768-3.433-2.892-9.617-8.232-9.617-8.232z"
    },
    "children": []
  }]
};
exports.home = home;
var html5 = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.1 3.5l.7 1.1.7-1.1v1.5h1v-3h-1l-.7 1.1-.6-1.1h-1.1v3h1zM18.4 5v-1h-1.4v-2h-1v3zM9.8 5h1v-2h.9v-1h-2.8v1h.9zM6.6 4h.9v1h1v-3h-1v1h-.9v-1h-1v3h1zM5 6l1.2 14.4 5.8 1.6 5.8-1.6 1.2-14.4h-14zm11.3 4.6h-6.8l.2 1.8h6.3999999999999995l-.5 5.5-3.6 1-3.6-1-.3-2.9h1.8l.1 1.5 2 .5 2-.5.2-2.3h-6.2l-.5-5.3h9l-.2 1.7z"
    },
    "children": []
  }]
};
exports.html5 = html5;
var imageOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.5 7.999c.827 0 1.5.673 1.5 1.5s-.673 1.5-1.5 1.5-1.5-.673-1.5-1.5.673-1.5 1.5-1.5m0-1c-1.381 0-2.5 1.119-2.5 2.5s1.119 2.5 2.5 2.5 2.5-1.119 2.5-2.5-1.119-2.5-2.5-2.5zM16 11.999c.45.051 1.27 1.804 1.779 4.001h-11.392c.434-1.034 1.055-2.001 1.612-2.001.806 0 1.125.185 1.53.42.447.258 1.006.58 1.97.58 1.138 0 1.942-.885 2.653-1.666.627-.687 1.218-1.334 1.848-1.334m0-1c-2 0-3 3-4.5 3s-1.499-1-3.5-1c-2 0-3.001 4-3.001 4h14.001s-1-6-3-6zM22 6c0-1.104-.896-2-2-2h-16c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h16c1.104 0 2-.896 2-2v-12zm-2 12h-16v-12h16.003l-.003 12z"
    },
    "children": []
  }]
};
exports.imageOutline = imageOutline;
var image = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "8.5",
      "cy": "8.501",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M16 10c-2 0-3 3-4.5 3s-1.499-1-3.5-1c-2 0-3.001 4-3.001 4h14.001s-1-6-3-6zM20 3h-16c-1.103 0-2 .897-2 2v12c0 1.103.897 2 2 2h16c1.103 0 2-.897 2-2v-12c0-1.103-.897-2-2-2zm0 14h-16v-12h16v12z"
    },
    "children": []
  }]
};
exports.image = image;
var infinityOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.434 8.596c1.152 0 2.237.449 3.053 1.264.815.816 1.266 1.9 1.266 3.056s-.45 2.239-1.268 3.056c-.813.815-1.898 1.266-3.053 1.266s-2.238-.449-3.055-1.266l-1.376-1.32-1.395 1.338c-.797.799-1.882 1.248-3.036 1.248-1.154 0-2.239-.449-3.054-1.267-.815-.813-1.265-1.899-1.265-3.053s.45-2.237 1.267-3.056c.814-.813 1.898-1.266 3.053-1.266 1.154 0 2.239.449 3.055 1.266l1.375 1.32 1.396-1.34c.798-.797 1.882-1.246 3.037-1.246m0-2c-1.679 0-3.25.645-4.433 1.813-1.163-1.159-2.746-1.813-4.43-1.813-1.688 0-3.274.657-4.467 1.853-1.194 1.192-1.852 2.78-1.852 4.469s.658 3.274 1.852 4.468c1.191 1.192 2.779 1.852 4.468 1.852 1.679 0 3.251-.645 4.431-1.814 1.163 1.16 2.746 1.814 4.431 1.814 1.689 0 3.276-.658 4.469-1.854 1.193-1.188 1.852-2.776 1.852-4.467 0-1.688-.658-3.274-1.852-4.47-1.197-1.195-2.783-1.851-4.469-1.851zM7.571 12.096c.225 0 .426.088.612.271l.57.548-.603.579c-.141.142-.352.223-.578.223-.227 0-.438-.08-.58-.223-.155-.155-.24-.36-.24-.578 0-.221.084-.422.243-.581.156-.155.355-.239.576-.239m0-1c-.486 0-.942.189-1.285.533-.345.346-.535.801-.535 1.287 0 .484.189.941.533 1.285.344.344.815.516 1.287.516.471 0 .942-.172 1.285-.516l1.339-1.285-1.321-1.27c-.36-.361-.817-.55-1.303-.55zM16.434 12.113c.228 0 .438.08.576.219.158.159.242.359.242.582s-.083.422-.243.581c-.144.146-.352.228-.571.228-.23 0-.444-.088-.617-.261l-.571-.548.603-.578c.141-.143.353-.223.581-.223m0-1c-.472 0-.943.172-1.287.516l-1.34 1.285 1.322 1.27c.362.361.838.539 1.311.539.472 0 .937-.177 1.279-.521.346-.344.534-.801.534-1.287s-.188-.941-.532-1.287c-.346-.344-.817-.515-1.287-.515z"
    },
    "children": []
  }]
};
exports.infinityOutline = infinityOutline;
var infinity = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.433 8.596c-1.153 0-2.237.449-3.036 1.246l-1.396 1.34-1.375-1.32c-.815-.817-1.901-1.266-3.055-1.266-1.154 0-2.239.451-3.053 1.266-.817.816-1.267 1.9-1.267 3.055 0 1.152.449 2.238 1.266 3.053.814.816 1.899 1.266 3.054 1.266 1.153 0 2.239-.449 3.036-1.248l1.395-1.338 1.376 1.32c.815.816 1.901 1.266 3.055 1.266s2.238-.449 3.053-1.266c.817-.814 1.267-1.9 1.267-3.055s-.449-2.238-1.266-3.055c-.817-.815-1.901-1.264-3.054-1.264zm-7.576 5.605c-.687.688-1.884.688-2.572 0-.344-.344-.533-.801-.533-1.285 0-.486.189-.941.535-1.287.342-.344.799-.533 1.284-.533s.942.189 1.305.551l1.321 1.27-1.34 1.284zm8.861 0c-.687.689-1.866.705-2.59-.018l-1.321-1.27 1.339-1.285c.688-.688 1.886-.688 2.573-.002.344.346.533.801.533 1.287s-.19.944-.534 1.288z"
    },
    "children": []
  }]
};
exports.infinity = infinity;
var infoLargeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.234 16.014l.554-1.104c.808-1.61.897-3.228.253-4.552-.122-.252-.277-.479-.443-.693 1.411-.619 2.402-2.026 2.402-3.664 0-2.206-1.794-4-4-4s-4 1.794-4 4c0 .783.234 1.508.624 2.126-1.696.33-2.806 1.248-2.947 1.375-.716.631-.885 1.68-.405 2.504.324.559.886.909 1.494.98l-.554 1.104c-.808 1.61-.897 3.228-.254 4.552.565 1.164 1.621 1.955 2.972 2.229.413.084.836.127 1.254.127 2.368 0 3.965-1.347 4.14-1.501.716-.63.887-1.678.407-2.503-.325-.556-.887-.909-1.497-.98zm-1.234-12.013c1.104 0 2 .896 2 2s-.896 2-2 2c-1.105 0-2-.896-2-2s.895-2 2-2zm-1.816 14.999c-.271 0-.559-.025-.854-.087-1.642-.334-2.328-1.933-1.328-3.927l1-1.995c.5-.996.47-1.63-.108-2.035-.181-.125-.431-.169-.689-.169-.577 0-1.201.214-1.201.214s1.133-1.001 2.812-1.001c.271 0 .56.025.856.087 1.64.334 2.328 1.933 1.328 3.927l-1 1.993c-.5.998-.472 1.632.106 2.035.181.126.433.169.692.169.577 0 1.2-.212 1.2-.212s-1.133 1.001-2.814 1.001z"
    },
    "children": []
  }]
};
exports.infoLargeOutline = infoLargeOutline;
var infoLarge = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.839 17.525c-.006.002-.559.186-1.039.186-.265 0-.372-.055-.406-.079-.168-.117-.48-.336.054-1.4l1-1.994c.593-1.184.681-2.329.245-3.225-.356-.733-1.039-1.236-1.92-1.416-.317-.065-.639-.097-.958-.097-1.849 0-3.094 1.08-3.146 1.126-.179.158-.221.42-.102.626.12.206.367.3.595.222.005-.002.559-.187 1.039-.187.263 0 .369.055.402.078.169.118.482.34-.051 1.402l-1 1.995c-.594 1.185-.681 2.33-.245 3.225.356.733 1.038 1.236 1.921 1.416.314.063.636.097.954.097 1.85 0 3.096-1.08 3.148-1.126.179-.157.221-.42.102-.626-.12-.205-.369-.297-.593-.223z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "13",
      "cy": "6.001",
      "r": "2.5"
    },
    "children": []
  }]
};
exports.infoLarge = infoLarge;
var infoOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12,5.51c0.56,0,1.12,0.35,1.54,1.06l5.91,9.85C20.31,17.84,19.65,19,18,19H6c-1.65,0-2.31-1.16-1.46-2.57l5.91-9.85\r\n\tC10.88,5.86,11.44,5.51,12,5.51 M12,3.51c-1.3,0-2.48,0.74-3.26,2.03L2.83,15.4c-0.44,0.74-0.66,1.5-0.66,2.23\r\n\tc0,0.56,0.14,1.11,0.42,1.6C3.23,20.35,4.47,21,6,21h12c1.53,0,2.77-0.65,3.41-1.77c0.29-0.51,0.43-1.07,0.42-1.65\r\n\tc-0.01-0.71-0.23-1.46-0.66-2.18l-5.91-9.85C14.48,4.25,13.3,3.51,12,3.51z M13.5,16.75c0,0-0.71,0.36-1.07,0.18\r\n\tc-0.36-0.18-0.43-0.54-0.23-1.15l0.41-1.22c0.4-1.22-0.12-2.08-1.08-2.13c-1.26-0.07-2.02,0.83-2.02,0.83s0.71-0.36,1.07-0.18\r\n\tc0.36,0.18,0.43,0.54,0.23,1.15l-0.41,1.22c-0.4,1.22,0.12,2.07,1.08,2.13C12.74,17.64,13.5,16.75,13.5,16.75z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "10",
      "r": "1.3"
    },
    "children": []
  }]
};
exports.infoOutline = infoOutline;
var info = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.17,15.4l-5.91-9.85C14.48,4.25,13.3,3.51,12,3.51S9.52,4.25,8.74,5.54L2.83,15.4c-0.44,0.73-0.66,1.49-0.66,2.21\r\n\tc0,0.57,0.14,1.13,0.42,1.62C3.23,20.35,4.47,21,6,21h12c1.53,0,2.77-0.65,3.41-1.77c0.28-0.49,0.42-1.02,0.42-1.58\r\n\tC21.84,16.91,21.62,16.14,21.17,15.4z M12,8.45c0.85,0,1.55,0.7,1.55,1.55c0,0.85-0.69,1.55-1.55,1.55c-0.85,0-1.55-0.7-1.55-1.55\r\n\tC10.45,9.14,11.14,8.45,12,8.45z M13.69,16.91c-0.03,0.04-0.8,0.92-2.07,0.92l-0.15,0c-0.51-0.03-0.93-0.25-1.18-0.63\r\n\tc-0.31-0.47-0.36-1.11-0.12-1.82l0.41-1.22c0.23-0.68,0.01-0.79-0.11-0.85l-0.14-0.02c-0.25,0-0.6,0.15-0.71,0.21\r\n\tc-0.1,0.05-0.23,0.03-0.31-0.07c-0.07-0.1-0.07-0.23,0.01-0.32c0.03-0.04,0.87-0.99,2.22-0.91c0.51,0.03,0.93,0.25,1.18,0.63\r\n\tc0.32,0.47,0.36,1.11,0.12,1.83l-0.41,1.22c-0.23,0.68-0.01,0.79,0.11,0.85l0.14,0.02c0.25,0,0.6-0.15,0.71-0.2\r\n\tc0.11-0.06,0.23-0.03,0.31,0.07C13.77,16.69,13.77,16.82,13.69,16.91z"
    },
    "children": []
  }]
};
exports.info = info;
var inputCheckedOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.885 6.177c-.221-.771-.728-1.409-1.427-1.798-.445-.248-.949-.379-1.457-.379-.862 0-1.661.381-2.219 1h-6.782c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h8c1.654 0 3-1.346 3-3v-6.454l.622-1.088c.39-.7.482-1.51.263-2.281zm-3.758.338c.104-.189.27-.328.459-.416.301-.113.623-.127.9.027.232.13.402.343.476.6.033.117.039.236.03.353-.012.115-.043.227-.092.332l-.021.065-4.006 7.011c-.151.273-.427.461-.742.506l-.132.009c-.267 0-.518-.104-.707-.293l-3-3c-.39-.39-.39-1.024 0-1.414.189-.189.44-.293.707-.293s.518.104.707.293l1.125 1.125.92.92.652-1.125 2.724-4.7zm-.127 10.485h-8c-.552 0-1-.449-1-1v-8c0-.551.448-1 1-1h6.689l-2.15 3.712-1.125-1.125c-.391-.391-.902-.586-1.414-.586s-1.023.195-1.414.586c-.781.781-.781 2.047 0 2.828l3 3c.378.378.888.586 1.414.586l.277-.02c.621-.087 1.166-.461 1.471-1.01l2.252-3.94v4.969c0 .551-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.inputCheckedOutline = inputCheckedOutline;
var inputChecked = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 19h-8c-1.654 0-3-1.346-3-3v-8c0-1.654 1.346-3 3-3h5c.553 0 1 .448 1 1s-.447 1-1 1h-5c-.552 0-1 .449-1 1v8c0 .551.448 1 1 1h8c.552 0 1-.449 1-1v-3c0-.552.447-1 1-1s1 .448 1 1v3c0 1.654-1.346 3-3 3zM13.166 14.833c-.35 0-.689-.139-.941-.391l-2.668-2.667c-.52-.521-.52-1.365 0-1.885.521-.521 1.365-.521 1.887 0l1.416 1.417 3.475-5.455c.357-.644 1.17-.877 1.814-.519.643.358.875 1.17.518 1.813l-4.334 7c-.203.366-.566.615-.98.673l-.187.014z"
    },
    "children": []
  }]
};
exports.inputChecked = inputChecked;
var keyOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 21h-6v-4.414l3.783-3.783c-.187-.587-.283-1.192-.283-1.803 0-3.309 2.691-6 6-6s6 2.691 6 6-2.691 6-6 6h-1.5v2h-2v2zm-4-2h2v-2h2v-2h3.5c2.206 0 4-1.794 4-4s-1.794-4-4-4-4 1.794-4 4c0 .559.121 1.109.359 1.639l.285.631-4.144 4.144v1.586zM13.5 9.998c.551 0 1 .449 1 1.002 0 .552-.449 1-1 1s-1-.448-1-1c0-.553.449-1.002 1-1.002m0-1c-1.104 0-2 .896-2 2.002 0 1.104.896 2 2 2 1.105 0 2-.896 2-2 0-1.105-.895-2.002-2-2.002z"
    },
    "children": []
  }]
};
exports.keyOutline = keyOutline;
var key = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.5 11c0 .732.166 1.424.449 2.051l-3.949 3.949v1.5s.896 1.5 2 1.5h2v-2h2v-2h2.5c2.762 0 5-2.238 5-5s-2.238-5-5-5-5 2.238-5 5zm5 2c-1.104 0-2-.896-2-2 0-1.105.896-2.002 2-2.002 1.105 0 2 .896 2 2.002 0 1.104-.895 2-2 2z"
    },
    "children": []
  }]
};
exports.key = key;
var keyboard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 13h7v2h-7zM5 13h2v2h-2zM5 9h2v1h-2zM8 12v-1h-3v1h2zM8 9h1v1h-1zM9 11h1v1h-1zM10 9h1v1h-1zM11 11h1v1h-1zM12 9h1v1h-1zM13 11h1v1h-1zM14 9h1v1h-1zM15 11h1v1h-1zM16 9h1v1h-1zM17 12h2v-3h-1v2h-1zM18 13h-1v1h-1v1h3v-1h-1zM20 6h-16c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2zm0 10h-16v-8h16v8z"
    },
    "children": []
  }]
};
exports.keyboard = keyboard;
var leaf = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 11c0-4.9-3.499-9.1-8.32-9.983l-.18-.034-.18.033c-4.821.884-8.32 5.084-8.32 9.984 0 4.617 3.108 8.61 7.5 9.795v1.205c0 .553.448 1 1 1s1-.447 1-1v-1.205c4.392-1.185 7.5-5.178 7.5-9.795zm-7.5 7.7v-2.993l4.354-4.354c.195-.195.195-.512 0-.707s-.512-.195-.707 0l-3.647 3.647v-3.586l2.354-2.354c.195-.195.195-.512 0-.707s-.512-.195-.707 0l-1.647 1.647v-3.293c0-.553-.448-1-1-1s-1 .447-1 1v3.293l-1.646-1.647c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l2.354 2.354v3.586l-3.646-3.646c-.195-.195-.512-.195-.707 0s-.195.512 0 .707l4.354 4.354v2.992c-3.249-1.116-5.502-4.179-5.502-7.7 0-3.874 2.723-7.201 6.5-7.981 3.777.78 6.5 4.107 6.5 7.981 0 3.521-2.253 6.584-5.5 7.7z"
    },
    "children": []
  }]
};
exports.leaf = leaf;
var lightbulb = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12.5 5.5c-.276 0-.5.224-.5.5s.224.5.5.5c1.083 0 1.964.881 1.964 1.964 0 .276.224.5.5.5s.5-.224.5-.5c0-1.634-1.33-2.964-2.964-2.964zM12.5 1c-4.136 0-7.5 3.364-7.5 7.5 0 1.486.44 2.922 1.274 4.165l.08.135c1.825 2.606 2.146 3.43 2.146 4.2v3c0 .552.448 1 1 1h2c0 .26.11.52.29.71.19.18.45.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71h2c.552 0 1-.448 1-1v-3c0-.782.319-1.61 2.132-4.199.895-1.275 1.368-2.762 1.368-4.301 0-4.136-3.364-7.5-7.5-7.5zm2 18h-4v-1h4v1zm2.495-7.347c-1.466 2.093-2.143 3.289-2.385 4.347h-1.11v-2c0-.552-.448-1-1-1s-1 .448-1 1v2h-1.113c-.24-1.03-.898-2.2-2.306-4.22l-.077-.129c-.657-.934-1.004-2.024-1.004-3.151 0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5c0 1.126-.347 2.216-1.005 3.153z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12.5 5.5c-.276 0-.5.224-.5.5s.224.5.5.5c1.083 0 1.964.881 1.964 1.964 0 .276.224.5.5.5s.5-.224.5-.5c0-1.634-1.33-2.964-2.964-2.964zM12.5 1c-4.136 0-7.5 3.364-7.5 7.5 0 1.486.44 2.922 1.274 4.165l.08.135c1.825 2.606 2.146 3.43 2.146 4.2v3c0 .552.448 1 1 1h2c0 .26.11.52.29.71.19.18.45.29.71.29.26 0 .52-.11.71-.29.18-.19.29-.45.29-.71h2c.552 0 1-.448 1-1v-3c0-.782.319-1.61 2.132-4.199.895-1.275 1.368-2.762 1.368-4.301 0-4.136-3.364-7.5-7.5-7.5zm2 18h-4v-1h4v1zm2.495-7.347c-1.466 2.093-2.143 3.289-2.385 4.347h-1.11v-2c0-.552-.448-1-1-1s-1 .448-1 1v2h-1.113c-.24-1.03-.898-2.2-2.306-4.22l-.077-.129c-.657-.934-1.004-2.024-1.004-3.151 0-3.033 2.467-5.5 5.5-5.5s5.5 2.467 5.5 5.5c0 1.126-.347 2.216-1.005 3.153z"
        },
        "children": []
      }]
    }]
  }]
};
exports.lightbulb = lightbulb;
var linkOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.5 5.999c.282 0 .562.106.777.321.431.431.431 1.127 0 1.557l-1.72 1.723.307.308c.585.584.906 1.362.906 2.192s-.321 1.607-.906 2.191l-4.172 4.172c-.584.584-1.361.906-2.191.906s-1.607-.322-2.191-.906l-.31-.309-1.723 1.723c-.215.215-.495.322-.777.322s-.562-.107-.777-.322c-.431-.43-.431-1.126 0-1.557l1.72-1.72-.308-.309c-.583-.584-.905-1.361-.905-2.191s.321-1.608.905-2.192l4.173-4.173c.584-.584 1.387-.875 2.191-.875s1.607.291 2.191.875l.31.308 1.723-1.723c.215-.215.495-.321.777-.321m0-2c-.828 0-1.605.321-2.191.908l-.492.491c-.707-.351-1.504-.539-2.316-.539-1.363 0-2.677.533-3.605 1.461l-4.172 4.173c-.964.962-1.494 2.241-1.494 3.607 0 .822.192 1.616.558 2.327l-.479.48c-.586.585-.909 1.364-.909 2.193 0 .827.322 1.605.908 2.191.584.586 1.363.908 2.191.908s1.605-.322 2.191-.908l.48-.48c.711.365 1.504.559 2.328.559 1.363 0 2.645-.53 3.605-1.492l4.172-4.172c.963-.962 1.492-2.242 1.492-3.605 0-.824-.192-1.617-.558-2.328l.479-.48c.589-.587.912-1.366.912-2.193 0-.828-.322-1.606-.908-2.192-.587-.588-1.364-.909-2.192-.909zM11.4 11.168c.017.535.233 1.036.613 1.416.381.38.881.598 1.416.614l-1.832 1.831c-.017-.534-.234-1.035-.613-1.415-.381-.38-.881-.597-1.416-.614l1.832-1.832m1.1-2.139c-.242 0-.468.094-.637.262l-4.172 4.172c-.168.168-.26.395-.26.637 0 .24.092.467.26.635l.309.308.723-.723c.215-.215.495-.321.777-.321s.562.106.777.321c.431.431.431 1.127 0 1.557l-.72.723.308.308c.168.168.401.253.636.253s.468-.084.637-.253l4.172-4.173c.168-.168.26-.395.26-.635 0-.242-.092-.469-.26-.637l-.31-.309-.723.723c-.215.215-.495.322-.777.322s-.562-.107-.777-.322c-.431-.43-.431-1.126 0-1.557l.72-.72-.307-.309c-.169-.168-.395-.262-.636-.262z"
    },
    "children": []
  }]
};
exports.linkOutline = linkOutline;
var link = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.277 6.321c-.43-.43-1.126-.43-1.556 0l-1.721 1.722-.308-.308c-1.168-1.168-3.216-1.168-4.384 0l-4.172 4.172c-.584.584-.906 1.363-.906 2.192s.322 1.608.906 2.192l.308.308-1.722 1.722c-.43.43-.43 1.126 0 1.556.215.215.496.322.778.322s.563-.107.778-.322l1.722-1.722.308.308c.584.584 1.362.906 2.192.906s1.608-.322 2.192-.906l4.172-4.172c.584-.584.906-1.362.906-2.192s-.322-1.608-.906-2.192l-.308-.308 1.722-1.722c.429-.43.429-1.126-.001-1.556zm-2.969 6.414l-4.172 4.172c-.168.168-.402.253-.636.253s-.468-.084-.636-.253l-.308-.308.722-.722c.43-.43.43-1.126 0-1.556-.215-.215-.496-.322-.778-.322s-.563.107-.778.322l-.722.722-.308-.308c-.168-.168-.261-.395-.261-.636s.093-.468.261-.636l4.172-4.172c.168-.168.394-.261.636-.261s.468.093.636.261l.308.308-.722.722c-.43.43-.43 1.126 0 1.556.215.215.496.322.778.322s.563-.107.778-.322l.722-.722.308.308c.168.168.261.395.261.636s-.093.468-.261.636z"
    },
    "children": []
  }]
};
exports.link = link;
var locationArrowOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.087 20.914c-.353 0-1.219-.146-1.668-1.496l-1.209-3.627-3.628-1.209c-1.244-.415-1.469-1.172-1.493-1.587s.114-1.193 1.302-1.747l11.375-5.309c1.031-.479 1.922-.309 2.348.362.224.351.396.97-.053 1.933l-5.309 11.375c-.529 1.135-1.272 1.305-1.665 1.305zm-5.39-8.068l4.094 1.363 1.365 4.093 4.775-10.233-10.234 4.777z"
    },
    "children": []
  }]
};
exports.locationArrowOutline = locationArrowOutline;
var locationArrow = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.368 19.102c.349 1.049 1.011 1.086 1.478.086l5.309-11.375c.467-1.002.034-1.434-.967-.967l-11.376 5.308c-1.001.467-.963 1.129.085 1.479l4.103 1.367 1.368 4.102z"
    },
    "children": []
  }]
};
exports.locationArrow = locationArrow;
var locationOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5c1.609 0 3.12.614 4.254 1.73 1.126 1.107 1.746 2.579 1.746 4.14s-.62 3.03-1.745 4.139l-4.255 4.184-4.254-4.186c-1.125-1.107-1.745-2.576-1.745-4.139s.62-3.032 1.745-4.141c1.135-1.113 2.647-1.727 4.254-1.727m0-2c-2.047 0-4.096.768-5.657 2.305-3.124 3.074-3.124 8.057 0 11.131l5.657 5.563 5.657-5.565c3.124-3.072 3.124-8.056 0-11.129-1.561-1.537-3.609-2.305-5.657-2.305zM12 8.499c.668 0 1.296.26 1.768.731.976.976.976 2.562 0 3.537-.473.472-1.1.731-1.768.731s-1.295-.26-1.768-.731c-.976-.976-.976-2.562 0-3.537.473-.471 1.101-.731 1.768-.731m0-1c-.896 0-1.792.342-2.475 1.024-1.367 1.367-1.367 3.584 0 4.951.684.684 1.578 1.024 2.475 1.024s1.792-.342 2.475-1.024c1.366-1.367 1.366-3.584 0-4.951-.683-.683-1.579-1.024-2.475-1.024z"
    },
    "children": []
  }]
};
exports.locationOutline = locationOutline;
var location = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.657 5.304c-3.124-3.073-8.189-3.073-11.313 0-3.124 3.074-3.124 8.057 0 11.13l5.656 5.565 5.657-5.565c3.124-3.073 3.124-8.056 0-11.13zm-5.657 8.195c-.668 0-1.295-.26-1.768-.732-.975-.975-.975-2.561 0-3.536.472-.472 1.1-.732 1.768-.732s1.296.26 1.768.732c.975.975.975 2.562 0 3.536-.472.472-1.1.732-1.768.732z"
    },
    "children": []
  }]
};
exports.location = location;
var lockClosedOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "17",
      "r": "1.3"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M17 10h-1v-2c0-2.206-1.794-4-4-4s-4 1.794-4 4v2h-1c-1.104 0-2 .896-2 2v7c0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2v-7c0-1.104-.896-2-2-2zm-7-2c0-1.104.896-2 2-2s2 .896 2 2v3h-4v-3zm7 11h-10v-7h10.003l-.003 7z"
    },
    "children": []
  }]
};
exports.lockClosedOutline = lockClosedOutline;
var lockClosed = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 10h-1v-2c0-2.205-1.794-4-4-4s-4 1.795-4 4v2h-1c-1.103 0-2 .896-2 2v7c0 1.104.897 2 2 2h10c1.103 0 2-.896 2-2v-7c0-1.104-.897-2-2-2zm-5 8.299c-.719 0-1.3-.58-1.3-1.299s.581-1.301 1.3-1.301 1.3.582 1.3 1.301-.581 1.299-1.3 1.299zm2-7.299h-4v-3c0-1.104.897-2 2-2s2 .896 2 2v3z"
    },
    "children": []
  }]
};
exports.lockClosed = lockClosed;
var lockOpenOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "17",
      "r": "1.3"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M18 4c-2.206 0-4 1.794-4 4v3h-4v-1h-3c-1.104 0-2 .896-2 2v7c0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2v-7c0-1.104-.896-2-2-2h-1v-2c0-1.104.896-2 2-2s2 .896 2 2v3c0 .552.448 1 1 1s1-.448 1-1v-3c0-2.206-1.794-4-4-4zm-1 15h-10v-7h10.003l-.003 7z"
    },
    "children": []
  }]
};
exports.lockOpenOutline = lockOpenOutline;
var lockOpen = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4c-2.206 0-4 1.795-4 4v3h-4v-1h-3c-1.103 0-2 .896-2 2v7c0 1.104.897 2 2 2h10c1.103 0 2-.896 2-2v-7c0-1.104-.897-2-2-2h-1v-2c0-1.104.897-2 2-2s2 .896 2 2v3c0 .553.448 1 1 1s1-.447 1-1v-3c0-2.205-1.794-4-4-4zm-6 14.299c-.719 0-1.3-.58-1.3-1.299s.581-1.301 1.3-1.301 1.3.582 1.3 1.301-.581 1.299-1.3 1.299z"
    },
    "children": []
  }]
};
exports.lockOpen = lockOpen;
var mail = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 7h-14c-1.104 0-2 .896-2 2v9c0 1.104.896 2 2 2h14c1.104 0 2-.896 2-2v-9c0-1.104-.896-2-2-2zm-9.684 7.316l1.602 1.4c.305.266.691.398 1.082.398s.777-.133 1.082-.398l1.602-1.4-.037.037 3.646 3.646h-12.586l3.646-3.646-.037-.037zm-4.316 2.977v-6.753l3.602 3.151-3.602 3.602zm10.398-3.602l3.602-3.151v6.75l-3.602-3.599zm3.602-4.691v.21l-6.576 5.754c-.227.198-.621.198-.848 0l-6.576-5.754v-.21h14z"
    },
    "children": []
  }]
};
exports.mail = mail;
var map = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.383 3.076c-.373-.155-.804-.069-1.09.217l-3.867 3.867-4.301-3.441c-.396-.316-.973-.287-1.332.074l-4.5 4.5c-.188.187-.293.441-.293.707v10c0 .404.243.77.617.924.124.053.254.076.383.076.26 0 .516-.102.707-.293l3.867-3.867 4.301 3.441c.396.316.971.285 1.332-.074l4.5-4.5c.188-.187.293-.441.293-.707v-10c0-.404-.243-.77-.617-.924zm-13.383 13.51v-7.172l3-3v7.24c-.07.043-3 2.932-3 2.932zm4.125-2.867l-.125-.068v-7.469s3.959 3.143 4 3.166v7.473l-3.875-3.102zm7.875-.133l-3 3v-7.236c.07-.043 3-2.936 3-2.936v7.172z"
    },
    "children": []
  }]
};
exports.map = map;
var mediaEjectOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M16 21h-8c-1.654 0-3-1.346-3-3s1.346-3 3-3h8c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-8-4c-.551 0-1 .448-1 1s.449 1 1 1h8c.551 0 1-.448 1-1s-.449-1-1-1h-8zM12 6.866l4.964 5.096.036.038-10 .004.08-.087 4.92-5.051m0-2.866s-3.859 3.963-6.433 6.604c-.349.363-.567.853-.567 1.396 0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2 0-.543-.218-1.033-.568-1.393-2.573-2.644-6.432-6.607-6.432-6.607z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M16 21h-8c-1.654 0-3-1.346-3-3s1.346-3 3-3h8c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-8-4c-.551 0-1 .448-1 1s.449 1 1 1h8c.551 0 1-.448 1-1s-.449-1-1-1h-8zM12 6.866l4.964 5.096.036.038-10 .004.08-.087 4.92-5.051m0-2.866s-3.859 3.963-6.433 6.604c-.349.363-.567.853-.567 1.396 0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2 0-.543-.218-1.033-.568-1.393-2.573-2.644-6.432-6.607-6.432-6.607z"
        },
        "children": []
      }]
    }]
  }]
};
exports.mediaEjectOutline = mediaEjectOutline;
var mediaEject = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 16h-10c-1.104 0-2 .895-2 2 0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2 0-1.105-.896-2-2-2zM18.433 10.604c-2.574-2.641-6.433-6.604-6.433-6.604s-3.859 3.963-6.433 6.604c-.349.363-.567.853-.567 1.396 0 1.104.896 2 2 2h10c1.104 0 2-.896 2-2 0-.543-.218-1.033-.567-1.396z"
    },
    "children": []
  }]
};
exports.mediaEject = mediaEject;
var mediaFastForwardOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M14 8.676l4.133 4.025-4.133 4.026v-8.051m-.2-2.276c-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.475-5.944-5.789c-.327-.314-.768-.512-1.256-.512zM5 8.676l4.133 4.025-4.133 4.026v-8.051m-.2-2.276c-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.474-5.944-5.789c-.327-.314-.768-.512-1.256-.512z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M14 8.676l4.133 4.025-4.133 4.026v-8.051m-.2-2.276c-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.475-5.944-5.789c-.327-.314-.768-.512-1.256-.512zM5 8.676l4.133 4.025-4.133 4.026v-8.051m-.2-2.276c-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.474-5.944-5.789c-.327-.314-.768-.512-1.256-.512z"
        },
        "children": []
      }]
    }]
  }]
};
exports.mediaFastForwardOutline = mediaFastForwardOutline;
var mediaFastForward = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.053 6.912c-.324-.314-.765-.512-1.253-.512-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.474-5.947-5.789zM6.053 6.912c-.324-.314-.765-.512-1.253-.512-.994 0-1.8.807-1.8 1.801v9c0 .994.806 1.799 1.8 1.799.488 0 .93-.195 1.253-.512 2.381-2.314 5.947-5.787 5.947-5.787s-3.566-3.474-5.947-5.789z"
    },
    "children": []
  }]
};
exports.mediaFastForward = mediaFastForward;
var mediaPauseOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 20c-1.654 0-3-1.346-3-3v-9c0-1.654 1.346-3 3-3s3 1.346 3 3v9c0 1.654-1.346 3-3 3zm0-13c-.552 0-1 .449-1 1v9c0 .551.448 1 1 1s1-.449 1-1v-9c0-.551-.448-1-1-1zM15 20c-1.654 0-3-1.346-3-3v-9c0-1.654 1.346-3 3-3s3 1.346 3 3v9c0 1.654-1.346 3-3 3zm0-13c-.552 0-1 .449-1 1v9c0 .551.448 1 1 1s1-.449 1-1v-9c0-.551-.448-1-1-1z"
    },
    "children": []
  }]
};
exports.mediaPauseOutline = mediaPauseOutline;
var mediaPause = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 6c-1.104 0-2 .896-2 2v8c0 1.104.896 2 2 2s2-.896 2-2v-8c0-1.104-.896-2-2-2zM15 6c-1.104 0-2 .896-2 2v8c0 1.104.896 2 2 2s2-.896 2-2v-8c0-1.104-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.mediaPause = mediaPause;
var mediaPlayOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.998 7.002l.085.078 5.051 4.92-5.096 4.964-.038.036-.002-9.998m.002-2.002c-1.104 0-2 .896-2 2v10c0 1.104.896 2 2 2 .543 0 1.033-.218 1.393-.568 2.644-2.573 6.607-6.432 6.607-6.432s-3.963-3.859-6.604-6.433c-.363-.349-.853-.567-1.396-.567z"
    },
    "children": []
  }]
};
exports.mediaPlayOutline = mediaPlayOutline;
var mediaPlayReverseOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 7v10l-5.1-5 5.1-5m-1.4-1.4c-2.6 2.5-6.6 6.4-6.6 6.4s4 3.9 6.6 6.4c.4.4.9.6 1.4.6 1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2-.5 0-1 .2-1.4.6z"
    },
    "children": []
  }]
};
exports.mediaPlayReverseOutline = mediaPlayReverseOutline;
var mediaPlayReverse = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 19c1.1 0 2-.9 2-2v-10c0-1.1-.9-2-2-2-.5 0-1 .2-1.4.6-2.6 2.5-6.6 6.4-6.6 6.4s4 3.9 6.6 6.4c.4.4.9.6 1.4.6z"
    },
    "children": []
  }]
};
exports.mediaPlayReverse = mediaPlayReverse;
var mediaPlay = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.396 18.433c2.641-2.574 6.604-6.433 6.604-6.433s-3.963-3.859-6.604-6.433c-.363-.349-.853-.567-1.396-.567-1.104 0-2 .896-2 2v10c0 1.104.896 2 2 2 .543 0 1.033-.218 1.396-.567z"
    },
    "children": []
  }]
};
exports.mediaPlay = mediaPlay;
var mediaRecordOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 8c2.205 0 4 1.794 4 4s-1.795 4-4 4-4-1.794-4-4 1.795-4 4-4m0-2c-3.314 0-6 2.686-6 6 0 3.312 2.686 6 6 6 3.312 0 6-2.688 6-6 0-3.314-2.688-6-6-6z"
    },
    "children": []
  }]
};
exports.mediaRecordOutline = mediaRecordOutline;
var mediaRecord = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 12c0-1.657-.672-3.157-1.757-4.243-1.086-1.085-2.586-1.757-4.243-1.757-1.656 0-3.156.672-4.242 1.757-1.086 1.086-1.758 2.586-1.758 4.243 0 1.656.672 3.156 1.758 4.242s2.586 1.758 4.242 1.758c1.657 0 3.157-.672 4.243-1.758 1.085-1.086 1.757-2.586 1.757-4.242z"
    },
    "children": []
  }]
};
exports.mediaRecord = mediaRecord;
var mediaRewindOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M10 8.676v8.05l-4.133-4.025 4.133-4.025m.2-2.276c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801zM19 8.676v8.051l-4.133-4.025 4.133-4.026m.2-2.276c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M10 8.676v8.05l-4.133-4.025 4.133-4.025m.2-2.276c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801zM19 8.676v8.051l-4.133-4.025 4.133-4.026m.2-2.276c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801z"
        },
        "children": []
      }]
    }]
  }]
};
exports.mediaRewindOutline = mediaRewindOutline;
var mediaRewind = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.2 6.4c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801zM19.2 6.4c-.488 0-.931.197-1.253.512-2.381 2.315-5.947 5.789-5.947 5.789l5.944 5.789c.326.315.768.51 1.256.51.994 0 1.8-.805 1.8-1.799v-9c0-.994-.806-1.801-1.8-1.801z"
    },
    "children": []
  }]
};
exports.mediaRewind = mediaRewind;
var mediaStopOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 8v8h-8v-8h8m0-2h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2z"
    },
    "children": []
  }]
};
exports.mediaStopOutline = mediaStopOutline;
var mediaStop = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 6h-8c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2v-8c0-1.1-.9-2-2-2z"
    },
    "children": []
  }]
};
exports.mediaStop = mediaStop;
var messageTyping = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 6h-13c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h1v3l3-3h9c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3zm1 10c0 .542-.458 1-1 1h-13c-.542 0-1-.458-1-1v-7c0-.542.458-1 1-1h13c.542 0 1 .458 1 1v7zM7 14.5c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2zm0-3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM11.5 14.5c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2zm0-3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1zM16 14.5c-1.104 0-2-.896-2-2s.896-2 2-2 2 .896 2 2-.896 2-2 2zm0-3c-.552 0-1 .448-1 1s.448 1 1 1 1-.448 1-1-.448-1-1-1z"
    },
    "children": []
  }]
};
exports.messageTyping = messageTyping;
var message = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 7c.542 0 1 .458 1 1v7c0 .542-.458 1-1 1h-8.829l-.171.171v-.171h-3c-.542 0-1-.458-1-1v-7c0-.542.458-1 1-1h12m0-2h-12c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3h1v3l3-3h8c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3z"
    },
    "children": []
  }]
};
exports.message = message;
var messages = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 7h-3c0-1.65-1.35-3-3-3h-12c-1.65 0-3 1.35-3 3v7c0 1.65 1.35 3 3 3v3l3-3c0 1.65 1.35 3 3 3h8l3 3v-3h1c1.65 0 3-1.35 3-3v-7c0-1.65-1.35-3-3-3zm-18 8c-.542 0-1-.458-1-1v-7c0-.542.458-1 1-1h12c.542 0 1 .458 1 1v1h-6.5c-1.379 0-2.5 1.121-2.5 2.5v4.5h-4zm19 2c0 .542-.458 1-1 1h-12c-.542 0-1-.458-1-1v-6.5c0-.827.673-1.5 1.5-1.5h11.5c.542 0 1 .458 1 1v7z"
    },
    "children": []
  }]
};
exports.messages = messages;
var microphoneOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 16c-2.206 0-4-1.795-4-4v-6c0-2.205 1.794-4 4-4s4 1.795 4 4v6c0 2.205-1.794 4-4 4zm0-12c-1.103 0-2 .896-2 2v6c0 1.104.897 2 2 2s2-.896 2-2v-6c0-1.104-.897-2-2-2zM19 12v-2c0-.553-.447-1-1-1s-1 .447-1 1v2c0 2.757-2.243 5-5 5s-5-2.243-5-5v-2c0-.553-.447-1-1-1s-1 .447-1 1v2c0 3.52 2.613 6.432 6 6.92v1.08h-3c-.553 0-1 .447-1 1s.447 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-3v-1.08c3.387-.488 6-3.4 6-6.92z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 16c-2.206 0-4-1.795-4-4v-6c0-2.205 1.794-4 4-4s4 1.795 4 4v6c0 2.205-1.794 4-4 4zm0-12c-1.103 0-2 .896-2 2v6c0 1.104.897 2 2 2s2-.896 2-2v-6c0-1.104-.897-2-2-2zM19 12v-2c0-.553-.447-1-1-1s-1 .447-1 1v2c0 2.757-2.243 5-5 5s-5-2.243-5-5v-2c0-.553-.447-1-1-1s-1 .447-1 1v2c0 3.52 2.613 6.432 6 6.92v1.08h-3c-.553 0-1 .447-1 1s.447 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-3v-1.08c3.387-.488 6-3.4 6-6.92z"
        },
        "children": []
      }]
    }]
  }]
};
exports.microphoneOutline = microphoneOutline;
var microphone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 16c2.206 0 4-1.795 4-4v-6c0-2.206-1.794-4-4-4s-4 1.794-4 4v6c0 2.205 1.794 4 4 4zM19 12v-2c0-.552-.447-1-1-1s-1 .448-1 1v2c0 2.757-2.243 5-5 5s-5-2.243-5-5v-2c0-.552-.447-1-1-1s-1 .448-1 1v2c0 3.52 2.613 6.432 6 6.92v1.08h-3c-.553 0-1 .447-1 1s.447 1 1 1h8c.553 0 1-.447 1-1s-.447-1-1-1h-3v-1.08c3.387-.488 6-3.4 6-6.92z"
    },
    "children": []
  }]
};
exports.microphone = microphone;
var minusOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 16h-12c-1.654 0-3-1.346-3-3s1.346-3 3-3h12c1.654 0 3 1.346 3 3s-1.346 3-3 3zm-12-4c-.551 0-1 .449-1 1s.449 1 1 1h12c.551 0 1-.449 1-1s-.449-1-1-1h-12z"
    },
    "children": []
  }]
};
exports.minusOutline = minusOutline;
var minus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 11h-12c-1.104 0-2 .896-2 2s.896 2 2 2h12c1.104 0 2-.896 2-2s-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.minus = minus;
var mortarBoard = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.5 7.9s-5.8-2.9-6.9-3.5-1.7-.7-3 0c-1.3.6-6.7 3.3-6.7 3.3-.8.4-1.5 1.2-1.5 2s.2 1.2.2 1.2-.1.3-.3 1.5c-.3 1.2-.3 2.7-.3 3.3 0 1.5 1.3 2.6 2.2 2.7.9.1 1.6-.1 1.6-.1 1.4 1.3 3.7 2.1 6.4 2.1 4.4 0 7.8-2.2 7.8-5 0-1.1-.4-2.7-.4-2.7l1.1-.6c.9-.5 1.3-1.4 1.3-2.3-.1-.8-.6-1.5-1.5-1.9zm-8.2 10.4c-3.2 0-5.8-1.3-5.8-3l.5-2.8 4.2 2.1c.6.3 1.5.3 2.2 0l4.3-2.1.4 2.8c0 1.6-2.5 3-5.8 3zm7.3-8.1l-6.6 3.4c-.4.2-1 .2-1.4 0l-5.7-2.9c-.2.5-.3 1.2-.3 2 0 1.4.2 2.4.2 2.9s-.3.8-.7.8h-.1c-.4 0-.8-.3-.8-.8s0-1.6.3-3.1c.2-.9.4-1.7.6-2.2l-.2-.1c-.4-.2-.4-.5 0-.7l6.7-3.4c.4-.2.9-.2 1.3 0s6.7 3.4 6.7 3.4c.4.2.4.5 0 .7z"
    },
    "children": []
  }]
};
exports.mortarBoard = mortarBoard;
var news = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 4h-18c-1.104 0-2 .896-2 2v12c0 1.104.896 2 2 2h18c1.104 0 2-.896 2-2v-12c0-1.104-.896-2-2-2zm-18 2h8v12h-8v-12zm18 12h-9v-12h9.003l-.003 12zM20 13.5c0-.275-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5h1c.275 0 .5-.225.5-.5v-3zM17 7.5c0-.275-.225-.5-.5-.5h-3c-.275 0-.5.225-.5.5v5c0 .275.225.5.5.5h3c.275 0 .5-.225.5-.5v-5zM18.5 10h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5s.225.5.5.5zM18.5 12h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5s.225.5.5.5zM13.5 15h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-3c-.275 0-.5.225-.5.5s.225.5.5.5zM16.5 16h-3c-.275 0-.5.225-.5.5s.225.5.5.5h3c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM18.5 8h1c.275 0 .5-.225.5-.5s-.225-.5-.5-.5h-1c-.275 0-.5.225-.5.5s.225.5.5.5zM10 7.5c0-.275-.225-.5-.5-.5h-5c-.275 0-.5.225-.5.5v3c0 .275.225.5.5.5h5c.275 0 .5-.225.5-.5v-3zM9.501 14h-5c-.274 0-.5.225-.5.5s.226.5.5.5h5c.274 0 .499-.225.499-.5s-.225-.5-.499-.5zM9.501 12h-5c-.274 0-.5.225-.5.5s.226.5.5.5h5c.274 0 .499-.225.499-.5s-.225-.5-.499-.5zM9.501 16h-5c-.274 0-.5.225-.5.5s.226.5.5.5h5c.274 0 .499-.225.499-.5s-.225-.5-.499-.5z"
    },
    "children": []
  }]
};
exports.news = news;
var notesOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.324 4.367c-.368-.324-.84-.5-1.324-.5l-.248.016-9 1.25c-1.001.125-1.752.975-1.752 1.984v6.111c-1.746.551-3 2.034-3 3.772 0 2.205 2.019 4 4.5 4 1.695 0 3.169-.842 3.937-2.078.803.667 1.879 1.078 3.063 1.078 2.481 0 4.5-1.795 4.5-4v-10.133c0-.574-.246-1.119-.676-1.5zm-7.324 11.633v-4.256l3-.45v1.737c-1.693.208-3 1.46-3 2.969zm6 0c0 1.104-1.119 2-2.5 2s-2.5-.896-2.5-2 1.119-2 2.5-2c.172 0 .338.014.5.041v-3.908l-5 .75v6.117c0 1.104-1.119 2-2.5 2s-2.5-.896-2.5-2 1.119-2 2.5-2c.172 0 .338.014.5.041v-7.924l9-1.25v10.133z"
    },
    "children": []
  }]
};
exports.notesOutline = notesOutline;
var notes = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.831 4.059c-.107-.095-.243-.139-.394-.121l-11 1.25c-.249.031-.437.244-.437.496v10.316c-1.654 0-3 1.122-3 2.5s1.346 2.5 3 2.5 3-1.122 3-2.5v-7.609l6-.625v3.734c-1.654 0-3 1.122-3 2.5s1.346 2.5 3 2.5 3-1.122 3-2.5v-12.066c0-.144-.062-.28-.169-.375z"
    },
    "children": []
  }]
};
exports.notes = notes;
var pen = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.329 7.207c0-1.212-.472-2.352-1.329-3.207s-1.996-1.329-3.207-1.329c-1.199 0-2.327.463-3.18 1.304-.027.025-7.967 7.964-7.967 7.964-.373.373-.717.91-.967 1.514-.195.473-1.979 5.863-2.336 6.939-.119.358-.025.754.242 1.021.189.189.445.293.707.293.105 0 .211-.018.314-.051 1.076-.355 6.465-2.141 6.938-2.336.603-.248 1.14-.592 1.515-.967l2.157-2.156.076.01c.64 0 1.28-.244 1.769-.732l4.5-4.5c.696-.695.887-1.699.588-2.572.107-.386.18-.783.18-1.195zm-11.864 10.379c-.406.143-1.145.393-2.038.691l-1.704-1.704c.301-.894.551-1.634.691-2.038l3.051 3.051zm-4.097.047l.999.999-1.498.499.499-1.498zm7.698-3.113l-2.42 2.42-.235.18-3.53-3.529.18-.234 7.131-7.131 2.731 2.731-3.69 3.69c-.513.512-.549 1.289-.167 1.873zm6.08-4.959l-4.5 4.5c-.098.099-.226.146-.354.146s-.256-.049-.354-.146c-.195-.194-.195-.512 0-.707l4.5-4.5c.194-.194.512-.194.707 0 .196.195.197.511.001.707zm.107-1.764c-.519-.168-1.108-.062-1.521.35l-.102.102-2.731-2.731.078-.078c.984-.98 2.652-.981 3.608-.023.479.479.743 1.116.743 1.793.001.199-.03.394-.075.587z"
    },
    "children": []
  }]
};
exports.pen = pen;
var pencil = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 6.879l-3.879-3.879c-.293-.293-.678-.439-1.061-.439-.384 0-.767.146-1.06.439l-10.939 10.939c-.293.293-.558.727-.75 1.188-.192.463-.311.959-.311 1.373v4.5h4.5c.414 0 .908-.119 1.371-.311.463-.192.896-.457 1.189-.75l10.94-10.939c.293-.293.439-.678.439-1.061 0-.384-.146-.767-.439-1.06zm-15.232 8.182l8.293-8.293 1.232 1.232-8.293 8.293-1.232-1.232zm1.732 3.939h-1.5l-1-1v-1.5c0-.077.033-.305.158-.605.01-.02 2.967 2.938 2.967 2.938-.322.134-.548.167-.625.167zm1.439-.768l-1.232-1.232 8.293-8.293 1.232 1.232-8.293 8.293zm9-9l-3.172-3.172 1.293-1.293 3.17 3.172-1.291 1.293z"
    },
    "children": []
  }]
};
exports.pencil = pencil;
var phoneOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.502 3.672l-1.795-1.793c-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879l-1.586 1.586c-1.17 1.17-1.17 3.072 0 4.242l1.379 1.379-4.172 4.172-1.379-1.379c-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879l-1.586 1.586c-1.17 1.17-1.17 3.072 0 4.242l1.794 1.793c.465.465 1.796 1.545 4.116 1.545 2.764 0 5.694-1.529 8.711-4.545 6.245-6.246 4.825-11.002 3.002-12.828zm-6.209 1.207l1.586-1.586c.195-.195.451-.293.707-.293s.512.098.707.293l1.083 1.082-3.001 3-1.082-1.082c-.391-.391-.391-1.023 0-1.414zm-10 11.414c-.391-.391-.391-1.023 0-1.414l1.586-1.586c.195-.195.451-.293.707-.293s.512.098.707.293l1.082 1.082-2.999 3-1.083-1.082zm11.793-1.207c-3.083 3.082-5.551 3.959-7.297 3.959-1.349 0-2.267-.523-2.702-.959-.004-.004 2.995-3.004 2.995-3.004l.297.297c.195.195.451.293.707.293s.512-.098.707-.293l5.586-5.586c.391-.391.391-1.023 0-1.414l-.297-.297 3.001-3c1.003 1.004 2.467 4.539-2.997 10.004z"
    },
    "children": []
  }]
};
exports.phoneOutline = phoneOutline;
var phone = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.374 7.083l3.711-3.71-.438-.434c-.566-.566-1.555-.566-2.121 0l-1.586 1.586c-.284.284-.44.661-.44 1.061s.156.777.438 1.06l.436.437zM6.646 12.939c-.566-.566-1.555-.566-2.121 0l-1.586 1.586c-.283.284-.439.661-.439 1.061s.156.777.441 1.062l.437.432 3.703-3.703-.435-.438zM18.437 4.729l-.354-.354-3.708 3.708.65.649c.095.095.146.22.146.354s-.052.259-.146.354l-5.586 5.586c-.189.188-.518.189-.707 0l-.65-.65-3.702 3.71.354.354c.26.26 1.246 1.105 3.056 1.105 1.616 0 4.256-.712 7.65-4.105 6.773-6.775 3.158-10.55 2.997-10.711z"
    },
    "children": []
  }]
};
exports.phone = phone;
var piOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.121 7.121c-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879c-.233.233-.546.362-.879.362s-.646-.129-.879-.362c-1.366-1.366-3.185-2.118-5.121-2.118s-3.755.752-5.121 2.118c-.567.567-.879 1.32-.879 2.121s.312 1.555.879 2.121c.566.567 1.32.879 2.121.879v4.758c0 1.654 1.346 3 3 3s3-1.346 3-3c0 1.654 1.346 3 3 3s3-1.346 3-3v-4.166c.784-.356 1.501-.851 2.12-1.47.568-.567.88-1.321.88-2.122s-.312-1.554-.879-2.121zm-1.414 2.828c-.768.767-1.715 1.245-2.707 1.437v5.614c0 .553-.447 1-1 1s-1-.447-1-1v-5.614c-.992-.191-1.939-.67-2.707-1.437-.374-.374-.821-.623-1.293-.775v7.826c0 .553-.447 1-1 1s-1-.447-1-1v-7.827c-.473.152-.919.402-1.293.776-.195.196-.451.293-.707.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414 1.021-1.021 2.364-1.532 3.707-1.532s2.685.511 3.707 1.532c.633.632 1.463.948 2.293.948.831 0 1.661-.316 2.293-.948.195-.195.451-.293.707-.293s.512.098.707.293c.391.391.391 1.024 0 1.414z"
    },
    "children": []
  }]
};
exports.piOutline = piOutline;
var pi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.707 8.535c-.391-.391-1.023-.391-1.414 0-1.264 1.264-3.321 1.264-4.586 0-2.045-2.044-5.371-2.042-7.414 0-.391.391-.391 1.023 0 1.414s1.023.391 1.414 0c.374-.374.82-.624 1.293-.776v7.827c0 .553.447 1 1 1s1-.447 1-1v-7.826c.472.152.919.401 1.293.775.768.767 1.715 1.245 2.707 1.437v5.614c0 .553.447 1 1 1s1-.447 1-1v-5.614c.992-.191 1.939-.67 2.707-1.437.391-.39.391-1.023 0-1.414z"
    },
    "children": []
  }]
};
exports.pi = pi;
var pinOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.436 7.586l-3.998-4.02c-.752-.756-2.063-.764-2.83-.006-.196.196-.35.436-.418.629-.653 1.362-1.354 2.215-2.254 2.727l-.217.105c-.968.485-2.285.979-4.719.979-.266 0-.521.052-.766.152-.484.202-.879.595-1.082 1.084-.199.484-.199 1.041 0 1.525.104.249.25.471.435.651l3.235 3.235-3.822 5.353 5.352-3.822 3.227 3.227c.186.189.406.339.656.441.247.103.503.154.766.154s.519-.052.765-.154c.498-.205.883-.592 1.08-1.078.103-.242.155-.507.155-.768 0-2.436.494-3.752.978-4.721.496-.992 1.369-1.748 2.754-2.414.271-.104.51-.256.711-.457.772-.782.768-2.051-.008-2.822zm-5.248 4.801c-.819 1.643-1.188 3.37-1.195 5.604l-7.993-7.991c2.139 0 3.814-.335 5.396-1.084l.235-.105c1.399-.699 2.468-1.893 3.388-3.834l3.924 4.051c-1.863.893-3.056 1.96-3.755 3.359z"
    },
    "children": []
  }]
};
exports.pinOutline = pinOutline;
var pin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.729 4.271c-.389-.391-1.021-.393-1.414-.004-.104.104-.176.227-.225.355-.832 1.736-1.748 2.715-2.904 3.293-1.297.64-2.786 1.085-5.186 1.085-.13 0-.26.025-.382.076-.245.102-.439.297-.541.541-.101.244-.101.52 0 .764.051.123.124.234.217.326l3.243 3.243-4.537 6.05 6.05-4.537 3.242 3.242c.092.094.203.166.326.217.122.051.252.078.382.078s.26-.027.382-.078c.245-.102.44-.295.541-.541.051-.121.077-.252.077-.381 0-2.4.444-3.889 1.083-5.166.577-1.156 1.556-2.072 3.293-2.904.129-.049.251-.121.354-.225.389-.393.387-1.025-.004-1.414l-3.997-4.02z"
    },
    "children": []
  }]
};
exports.pin = pin;
var pipette = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.384 7.331c.073-1.199-.354-2.388-1.146-3.179-.732-.731-1.793-1.152-2.912-1.152-1.176 0-2.206.453-2.825 1.243-.692.883-1.392 2.625-1.769 3.647l-1.616-1.617c-.392-.391-1.023-.391-1.414 0-.392.392-.392 1.023 0 1.414l.293.293-5.231 5.232c-.375.375-.719.912-.968 1.516-.019.043-1.726 4.328-.093 5.959.527.526 1.33.707 2.178.707 1.778-.002 3.753-.787 3.783-.801.602-.248 1.141-.592 1.514-.967l5.232-5.232.293.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.022 0-1.414l-1.617-1.616c1.023-.376 2.766-1.075 3.648-1.769.721-.562 1.17-1.493 1.236-2.557zm-16.265 11.944c-.247-.295-.105-1.508.154-2.58l2.422 2.423c-1.071.261-2.283.403-2.576.157zm4.645-1.061c-.188.188-.511.388-.865.533l-.116.042-3.181-3.18.043-.117c.146-.354.346-.678.533-.864l5.232-5.231 3.586 3.586-5.232 5.231z"
    },
    "children": []
  }]
};
exports.pipette = pipette;
var planeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M20.988 12.396l-4.988-2.851v-4.795c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v4.795l-4.988 2.851c-1.317.752-1.865 2.371-1.276 3.769.589 1.399 2.132 2.135 3.589 1.72l2.675-.765v.838l-.874.699c-1.198.959-1.48 2.667-.653 3.959.827 1.293 2.494 1.753 3.869 1.066.004-.001.5-.183 1.158-.183l1.158.183c1.375.687 3.042.227 3.869-1.066.827-1.292.545-3-.653-3.959l-.874-.699v-.838l2.676.765c1.457.415 3-.321 3.589-1.72s.041-3.017-1.277-3.769zm-.566 2.992c-.197.466-.711.713-1.196.573l-5.226-1.492v4.451l1.625 1.3c.399.319.493.889.218 1.32-.275.43-.828.583-1.29.355-.008-.004-.824-.395-2.053-.395s-2.045.391-2.053.395c-.462.227-1.015.074-1.29-.355-.275-.431-.182-1 .218-1.32l1.625-1.3v-4.451l-5.226 1.493c-.485.14-.999-.107-1.196-.573-.196-.466-.014-1.005.426-1.256l5.996-3.427v-5.956c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v5.956l5.996 3.426c.44.251.622.79.426 1.256z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M20.988 12.396l-4.988-2.851v-4.795c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v4.795l-4.988 2.851c-1.317.752-1.865 2.371-1.276 3.769.589 1.399 2.132 2.135 3.589 1.72l2.675-.765v.838l-.874.699c-1.198.959-1.48 2.667-.653 3.959.827 1.293 2.494 1.753 3.869 1.066.004-.001.5-.183 1.158-.183l1.158.183c1.375.687 3.042.227 3.869-1.066.827-1.292.545-3-.653-3.959l-.874-.699v-.838l2.676.765c1.457.415 3-.321 3.589-1.72s.041-3.017-1.277-3.769zm-.566 2.992c-.197.466-.711.713-1.196.573l-5.226-1.492v4.451l1.625 1.3c.399.319.493.889.218 1.32-.275.43-.828.583-1.29.355-.008-.004-.824-.395-2.053-.395s-2.045.391-2.053.395c-.462.227-1.015.074-1.29-.355-.275-.431-.182-1 .218-1.32l1.625-1.3v-4.451l-5.226 1.493c-.485.14-.999-.107-1.196-.573-.196-.466-.014-1.005.426-1.256l5.996-3.427v-5.956c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v5.956l5.996 3.426c.44.251.622.79.426 1.256z"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "12.5",
        "cy": "4.5",
        "r": ".5"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "12.5",
          "cy": "4.5",
          "r": ".5"
        },
        "children": []
      }]
    }]
  }]
};
exports.planeOutline = planeOutline;
var plane = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.996 13.507l-5.996-3.426v-5.956c0-.827-.673-1.5-1.5-1.5s-1.5.673-1.5 1.5v5.956l-5.996 3.426c-.439.251-.622.79-.426 1.256.197.466.711.713 1.196.573l5.226-1.492v4.451l-1.625 1.3c-.387.31-.488.856-.239 1.284s.776.608 1.235.425l2.129-.852 2.129.852c.121.048.247.071.371.071.347 0 .681-.181.864-.497.249-.428.147-.975-.239-1.284l-1.625-1.3v-4.451l5.226 1.493.274.039c.394 0 .762-.233.922-.612.196-.466.014-1.005-.426-1.256zm-7.496-9.132c-.276 0-.5-.224-.5-.5s.224-.5.5-.5.5.224.5.5-.224.5-.5.5z"
    },
    "children": []
  }]
};
exports.plane = plane;
var plug = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18,6h-1V3c0-0.6-0.4-1-1-1h-2c-0.6,0-1,0.4-1,1v3h-2V3c0-0.6-0.4-1-1-1H8C7.4,2,7,2.4,7,3v3H6C5.4,6,5,6.4,5,7v4\r\n\tc0,0.1,0,0.1,0,0.2c0.2,2.5,1.8,4.6,4,5.6V20c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2v-3.2c2.2-1,3.7-3.1,4-5.6c0-0.1,0-0.1,0-0.2V7\r\n\tC19,6.4,18.6,6,18,6z M14,3h2v3h-2V3z M8,3h2v3H8V3z M13,20h-2v-2h2V20z M12,15.5c-2.2,0-4.1-1.5-4.7-3.5h9.5\r\n\tC16.1,14,14.2,15.5,12,15.5z M17,10.5c0,0.2,0,0.3-0.1,0.5H7.1C7,10.8,7,10.7,7,10.5V8h10V10.5z"
    },
    "children": []
  }]
};
exports.plug = plug;
var plusOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 21c-1.654 0-3-1.346-3-3l.053-3.053-3.035.053c-1.672 0-3.018-1.346-3.018-3s1.346-3 3-3l3.053-.054-.053-2.928c0-1.672 1.346-3.018 3-3.018s3 1.346 3 3l.055 2.946 2.963.054c1.636 0 2.982 1.346 2.982 3s-1.346 3-3 3l-2.945-.053-.055 3.071c0 1.636-1.346 2.982-3 2.982zm-1-8v5.018c0 .533.449.982 1 .982s1-.449 1-1v-5h5.018c.533 0 .982-.449.982-1s-.449-1-1-1h-5v-5c0-.569-.449-1-1-1s-1 .449-1 1v5h-5c-.569 0-1 .449-1 1s.449 1 1 1h5z"
    },
    "children": []
  }]
};
exports.plusOutline = plusOutline;
var plus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 10h-4v-4c0-1.104-.896-2-2-2s-2 .896-2 2l.071 4h-4.071c-1.104 0-2 .896-2 2s.896 2 2 2l4.071-.071-.071 4.071c0 1.104.896 2 2 2s2-.896 2-2v-4.071l4 .071c1.104 0 2-.896 2-2s-.896-2-2-2z"
    },
    "children": []
  }]
};
exports.plus = plus;
var pointOfInterestOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 4c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5h-1.5v2h1.5c1.93 0 3.5 1.57 3.5 3.5s-1.57 3.5-3.5 3.5-3.5-1.57-3.5-3.5v-1.5h-2v1.5c0 1.93-1.57 3.5-3.5 3.5s-3.5-1.57-3.5-3.5 1.57-3.5 3.5-3.5h1.5v-2h-1.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5v1.5h2v-1.5c0-1.93 1.57-3.5 3.5-3.5m-1.5 5h1.5c.827 0 1.5-.674 1.5-1.5 0-.828-.673-1.5-1.5-1.5s-1.5.672-1.5 1.5v1.5m-7.5 0h1.5v-1.5c0-.828-.673-1.5-1.5-1.5s-1.5.672-1.5 1.5c0 .826.673 1.5 1.5 1.5m9 9c.827 0 1.5-.674 1.5-1.5 0-.828-.673-1.5-1.5-1.5h-1.5v1.5c0 .826.673 1.5 1.5 1.5m-9 0c.827 0 1.5-.674 1.5-1.5v-1.5h-1.5c-.827 0-1.5.672-1.5 1.5 0 .826.673 1.5 1.5 1.5m9-16c-1.857 0-3.504.926-4.5 2.341-.996-1.415-2.643-2.341-4.5-2.341-3.033 0-5.5 2.468-5.5 5.5 0 1.857.926 3.504 2.341 4.5-1.415.996-2.341 2.643-2.341 4.5 0 3.032 2.467 5.5 5.5 5.5 1.857 0 3.504-.926 4.5-2.341.996 1.415 2.643 2.341 4.5 2.341 3.033 0 5.5-2.468 5.5-5.5 0-1.857-.926-3.504-2.341-4.5 1.415-.996 2.341-2.643 2.341-4.5 0-3.032-2.467-5.5-5.5-5.5zM13 11h-2v2h2z"
    },
    "children": []
  }]
};
exports.pointOfInterestOutline = pointOfInterestOutline;
var pointOfInterest = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.5 11c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5v1.5h-2v-1.5c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5h1.5v2h-1.5c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5v-1.5h2v1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5h-1.5v-2h1.5zm-1.5-3.5c0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5c0 .826-.673 1.5-1.5 1.5h-1.5v-1.5zm-6 9c0 .826-.673 1.5-1.5 1.5s-1.5-.674-1.5-1.5c0-.828.673-1.5 1.5-1.5h1.5v1.5zm0-7.5h-1.5c-.827 0-1.5-.674-1.5-1.5 0-.828.673-1.5 1.5-1.5s1.5.672 1.5 1.5v1.5zm4 4h-2v-2h2v2zm3.5 2c.827 0 1.5.672 1.5 1.5 0 .826-.673 1.5-1.5 1.5s-1.5-.674-1.5-1.5v-1.5h1.5z"
    },
    "children": []
  }]
};
exports.pointOfInterest = pointOfInterest;
var powerOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.51 6.062c-.814-.815-1.98-1.05-3.01-.729v-.333c0-1.656-1.344-3-3-3s-3 1.344-3 3v.332c-1.029-.319-2.195-.085-3.01.73-1.605 1.606-2.49 3.741-2.49 6.011s.885 4.405 2.49 6.011c1.604 1.605 3.739 2.489 6.01 2.489s4.405-.884 6.01-2.489c1.605-1.605 2.49-3.74 2.49-6.011s-.885-4.405-2.49-6.011zm-7.01-1.062c0-.552.447-1 1-1s1 .448 1 1v5c0 .552-.447 1-1 1s-1-.448-1-1v-5zm-1 3.803v1.197c0 1.104.896 2 2 2s2-.896 2-2v-1.182c.095.284.248.554.475.78.661.661 1.025 1.54 1.025 2.475s-.364 1.814-1.025 2.476c-1.322 1.321-3.627 1.321-4.949 0-.662-.662-1.026-1.541-1.026-2.476s.364-1.814 1.025-2.476c.231-.23.383-.504.475-.794zm6.596 7.867c-1.228 1.228-2.859 1.903-4.596 1.903s-3.368-.676-4.596-1.903c-1.227-1.228-1.904-2.86-1.904-4.597s.677-3.369 1.904-4.597c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414c-.85.851-1.318 1.981-1.318 3.183s.468 2.333 1.318 3.183c.85.85 1.979 1.317 3.182 1.317s2.332-.468 3.182-1.317c.851-.85 1.318-1.98 1.318-3.183s-.468-2.333-1.318-3.183c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0c1.227 1.229 1.904 2.861 1.904 4.597s-.677 3.369-1.904 4.597z"
    },
    "children": []
  }]
};
exports.powerOutline = powerOutline;
var power = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.5 18.573c-1.736 0-3.368-.676-4.596-1.903-1.227-1.228-1.904-2.86-1.904-4.597s.677-3.369 1.904-4.597c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414c-.85.851-1.318 1.981-1.318 3.183s.468 2.333 1.318 3.183c.85.85 1.979 1.317 3.182 1.317s2.332-.468 3.182-1.317c.851-.85 1.318-1.98 1.318-3.183s-.468-2.333-1.318-3.183c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0c1.227 1.229 1.904 2.861 1.904 4.597s-.677 3.369-1.904 4.597c-1.228 1.227-2.86 1.903-4.596 1.903zM11.5 11c-.553 0-1-.448-1-1v-5c0-.552.447-1 1-1s1 .448 1 1v5c0 .552-.447 1-1 1z"
    },
    "children": []
  }]
};
exports.power = power;
var printer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 5v-2c0-.552-.448-1-1-1h-9c-.552 0-1 .448-1 1v2c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-10c0-1.654-1.346-3-3-3zm-9-1h7v5h-7v-5zm-2 3v3c0 .552.448 1 1 1h9c.552 0 1-.448 1-1v-3c.551 0 1 .449 1 1v2.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-2.5c0-.551.449-1 1-1zm11 12h-11c-.551 0-1-.449-1-1v-5.513c.419.318.935.513 1.5.513h10c.565 0 1.081-.195 1.5-.513v5.513c0 .551-.449 1-1 1zM13.5 7h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM15 16h-7c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM13.5 5h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 5v-2c0-.552-.448-1-1-1h-9c-.552 0-1 .448-1 1v2c-1.654 0-3 1.346-3 3v10c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-10c0-1.654-1.346-3-3-3zm-9-1h7v5h-7v-5zm-2 3v3c0 .552.448 1 1 1h9c.552 0 1-.448 1-1v-3c.551 0 1 .449 1 1v2.5c0 .827-.673 1.5-1.5 1.5h-10c-.827 0-1.5-.673-1.5-1.5v-2.5c0-.551.449-1 1-1zm11 12h-11c-.551 0-1-.449-1-1v-5.513c.419.318.935.513 1.5.513h10c.565 0 1.081-.195 1.5-.513v5.513c0 .551-.449 1-1 1zM13.5 7h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM15 16h-7c-.276 0-.5.224-.5.5s.224.5.5.5h7c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM13.5 5h-4c-.276 0-.5.224-.5.5s.224.5.5.5h4c.276 0 .5-.224.5-.5s-.224-.5-.5-.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.printer = printer;
var puzzleOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20 11.25v-1.75c0-1.93-1.57-3.5-3.5-3.5h-.759c-.141-1.982-1.953-3.5-4.241-3.5s-4.1 1.518-4.241 3.5h-.759c-1.93 0-3.5 1.57-3.5 3.5v1.75c0 1.012.514 1.847 1.295 2.246-.358.188-.668.469-.894.825-.262.414-.401.908-.401 1.429v2.75c0 1.93 1.57 3.5 3.5 3.5h2.75c.976 0 1.831-.497 2.242-1.299l.036.066c.435.772 1.266 1.233 2.222 1.233h2.75c1.93 0 3.5-1.57 3.5-3.5v-2.75c0-1.013-.515-1.849-1.297-2.247.776-.411 1.297-1.256 1.297-2.253zm-2 7.25c0 .825-.675 1.5-1.5 1.5h-2.75c-.356 0-.724-.216-.391-.766.246-.28.391-.619.391-.984 0-.967-1.007-1.75-2.25-1.75s-2.25.783-2.25 1.75c0 .3.095.576.255.823.507.673.136.927-.255.927h-2.75c-.825 0-1.5-.675-1.5-1.5v-2.75c0-.258.113-.521.384-.521.104 0 .229.039.382.13.28.246.62.391.984.391.966 0 1.75-1.008 1.75-2.25s-.784-2.25-1.75-2.25c-.3 0-.576.095-.822.255-.237.171-.422.243-.562.243-.26 0-.366-.245-.366-.498v-1.75c0-.825.675-1.5 1.5-1.5h2.75c.391 0 .762-.254.243-.927-.148-.247-.243-.523-.243-.823 0-.967 1.007-1.75 2.25-1.75s2.25.783 2.25 1.75c0 .365-.145.704-.391.984-.333.55.035.766.391.766h2.75c.825 0 1.5.675 1.5 1.5v1.75c0 .258-.113.521-.384.521-.104 0-.229-.039-.382-.13-.28-.246-.62-.391-.984-.391-.966 0-1.75 1.008-1.75 2.25s.784 2.25 1.75 2.25c.3 0 .576-.095.822-.255.237-.171.422-.244.562-.243.259 0 .365.245.365.498v2.75zm-13-5.806c.116.032.236.054.365.054.342 0 .683-.119 1.038-.364l.069-.041c.097-.063.188-.093.278-.093.354 0 .75.535.75 1.25s-.396 1.25-.75 1.25c-.108 0-.217-.048-.324-.142l-.143-.104c-.301-.183-.604-.275-.899-.275-.134 0-.261.023-.384.059v-1.594zm12.635 1.558c-.342 0-.683.119-1.038.364l-.069.041c-.097.063-.188.093-.277.093-.354 0-.75-.535-.75-1.25s.396-1.25.75-1.25c.108 0 .217.048.324.142l.143.104c.302.183.604.275.899.275.136 0 .262-.025.384-.062v1.597c-.117-.032-.237-.054-.366-.054zm-6.943 5.748c.101-.346.093-.816-.305-1.396l-.044-.074c-.062-.098-.094-.189-.094-.279 0-.354.534-.75 1.25-.75s1.25.396 1.25.75c0 .108-.048.217-.143.325l-.104.142c-.325.537-.311.979-.22 1.284h-1.59z"
    },
    "children": []
  }]
};
exports.puzzleOutline = puzzleOutline;
var puzzle = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.25 11.25c.364 0 .704.145.984.391.549.332.766-.034.766-.391v-1.75c0-.825-.675-1.5-1.5-1.5h-2.75c-.356 0-.724-.216-.391-.766.246-.28.391-.619.391-.984 0-.967-1.007-1.75-2.25-1.75s-2.25.783-2.25 1.75c0 .3.095.576.255.823.507.673.136.927-.255.927h-2.75c-.825 0-1.5.675-1.5 1.5v1.75c0 .391.254.762.928.244.246-.149.522-.244.822-.244.966 0 1.75 1.008 1.75 2.25s-.784 2.25-1.75 2.25c-.364 0-.704-.145-.984-.391-.549-.332-.766.034-.766.391v2.75c0 .825.675 1.5 1.5 1.5h2.75c.391 0 .762-.254.243-.927-.148-.247-.243-.523-.243-.823 0-.967 1.007-1.75 2.25-1.75s2.25.783 2.25 1.75c0 .365-.145.704-.391.984-.333.55.035.766.391.766h2.75c.825 0 1.5-.675 1.5-1.5v-2.75c0-.391-.254-.762-.928-.244-.246.149-.522.244-.822.244-.966 0-1.75-1.008-1.75-2.25s.784-2.25 1.75-2.25z"
    },
    "children": []
  }]
};
exports.puzzle = puzzle;
var radarOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.997 4.5c-4.685 0-8.497 3.812-8.497 8.5s3.813 8.5 8.5 8.5c4.688 0 8.5-3.812 8.5-8.5s-3.812-8.5-8.503-8.5zm.003 15c-3.584 0-6.5-2.916-6.5-6.5s2.914-6.5 6.5-6.5c3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5zM15.348 12.031l.152-.031h.879c-.383-1.677-1.699-2.995-3.379-3.378v.878c0 .551-.449 1-1 1-.497 0-.892-.371-.969-.846l-.031-.154v-.88c-1.678.382-2.997 1.702-3.38 3.38h.88l.153.031c.476.076.847.472.847.969s-.371.893-.846.969l-.154.031h-.878c.384 1.677 1.702 2.995 3.378 3.379v-.879l.031-.154c.077-.476.472-.846.969-.846s.893.371.969.848l.031.152v.879c1.677-.383 2.996-1.702 3.379-3.379h-.879l-.152-.031c-.477-.076-.848-.472-.848-.969s.371-.893.848-.969zm-.446 2.867c-.264.399-.604.74-1.004 1.002-.256-.81-1.004-1.401-1.897-1.401s-1.642.592-1.898 1.401c-.4-.262-.74-.603-1.003-1.002.81-.256 1.401-1.006 1.401-1.898 0-.895-.592-1.643-1.402-1.898.263-.399.603-.74 1.004-1.002.256.81 1.005 1.401 1.898 1.401.894 0 1.644-.593 1.899-1.403.399.264.74.604 1.002 1.004-.81.256-1.401 1.006-1.401 1.898-.001.893.591 1.643 1.401 1.898z"
    },
    "children": []
  }]
};
exports.radarOutline = radarOutline;
var radar = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 20c3.86 0 7-3.141 7-7s-3.14-7-7.003-7c-3.858 0-6.997 3.141-6.997 7s3.14 7 7 7zm-1-11.898v1.898c0 .553.448 1 1 1s1-.447 1-1v-1.898c1.956.398 3.5 1.942 3.899 3.898h-1.899c-.552 0-1 .447-1 1s.448 1 1 1h1.899c-.399 1.956-1.943 3.5-3.899 3.898v-1.898c0-.553-.448-1-1-1s-1 .447-1 1v1.898c-1.956-.398-3.5-1.942-3.899-3.898h1.899c.552 0 1-.447 1-1s-.448-1-1-1h-1.899c.399-1.956 1.942-3.5 3.899-3.898z"
    },
    "children": []
  }]
};
exports.radar = radar;
var refreshOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.368 4.998c-.488 0-1.2.145-1.956.773-1.036-.489-2.189-.771-3.412-.771-4.418 0-8 3.582-8 8s3.582 8 8 8c4.312 0 8-3.316 8-8v-4.936c-.016-2.111-1.375-3.066-2.632-3.066zm.632 8.002h-5.128c-1.134 0-1.407-.561-.604-1.363l1.448-1.402c-.562-.371-1.22-.549-1.909-.549-.93 0-1.805.375-2.464 1.033-.657.656-1.02 1.537-1.02 2.467 0 .933.362 1.811 1.02 2.469.659.658 1.534 1.021 2.464 1.021s1.805-.36 2.465-1.019c.177-.18.334-.372.468-.579.222-.345.596-.533.979-.533.216 0 .433.06.625.185.54.346.697 1.063.351 1.604-.223.344-.484.668-.78.965-1.097 1.099-2.556 1.703-4.106 1.703-1.55 0-3.009-.604-4.104-1.701-1.097-1.096-1.701-2.555-1.701-4.106 0-1.551.604-3.012 1.702-4.104 1.096-1.098 2.554-1.7 4.104-1.7 1.311 0 2.551.436 3.566 1.229l1.154-1.158c.311-.312.602-.461.841-.461.377 0 .627.372.632 1.065v4.934zm-7.08.05c.162.392.63.95 1.952.95h1.299s-.21.504-.614.907-1.086.745-1.75.745-1.289-.246-1.758-.715c-.468-.47-.727-1.088-.727-1.752s.258-1.139.726-1.604c.472-.472 1.097-.581 1.759-.581l-.246.123c-.935.934-.803 1.536-.641 1.927z"
    },
    "children": []
  }]
};
exports.refreshOutline = refreshOutline;
var refresh = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.872 13.191h5.128v-5.127c-.008-1.135-.671-1.408-1.473-.605l-1.154 1.158c-1.015-.795-2.257-1.23-3.566-1.23-1.55 0-3.009.604-4.104 1.701-1.099 1.092-1.703 2.553-1.703 4.103 0 1.553.604 3.012 1.701 4.107 1.097 1.097 2.555 1.702 4.106 1.702 1.55 0 3.009-.605 4.106-1.703.296-.297.558-.621.78-.965.347-.541.19-1.26-.35-1.605-.539-.346-1.258-.189-1.604.35-.133.207-.292.4-.468.58-.659.658-1.534 1.02-2.464 1.02-.93 0-1.805-.361-2.464-1.02-.657-.658-1.02-1.533-1.02-2.465 0-.93.362-1.805 1.02-2.461.659-.658 1.534-1.021 2.464-1.021.688 0 1.346.201 1.909.572l-1.448 1.451c-.803.802-.53 1.458.604 1.458z"
    },
    "children": []
  }]
};
exports.refresh = refresh;
var rssOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 4.999c-1.657 0-3.011 1.344-3.011 3l.005 9c0 2.209 1.793 4 4.002 4l9.003.001c1.655 0 3-1.346 3-3.001.001-7.179-5.819-13-12.999-13zm1.001 14c-1.105.002-2.001-.894-2.001-1.999-.002-1.105.894-2.001 2.001-2.001 1.105-.002 2.001.894 1.999 2.001.002 1.105-.894 2.001-1.999 1.999zm4.499 0c-.829 0-1.5-.671-1.5-1.5 0-1.931-1.57-3.5-3.5-3.5-.829 0-1.5-.671-1.5-1.5s.671-1.5 1.5-1.5c3.584 0 6.5 2.916 6.5 6.5 0 .829-.671 1.5-1.5 1.5zm4 0c-.829 0-1.5-.671-1.5-1.5 0-4.136-3.364-7.5-7.5-7.5-.829 0-1.5-.671-1.5-1.5s.671-1.5 1.5-1.5c5.79 0 10.5 4.71 10.5 10.5 0 .829-.671 1.5-1.5 1.5z"
    },
    "children": []
  }]
};
exports.rssOutline = rssOutline;
var rss = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6.002 15.999c-1.107 0-2.004.897-2.002 2.001 0 1.104.896 2.001 2.002 1.999 1.103.002 2-.894 1.998-1.999.002-1.107-.895-2.003-1.998-2.001zM6 4c-1.104 0-2 .896-2 2s.896 2 2 2c5.514 0 10 4.486 10 10 0 1.104.896 2 2 2s2-.896 2-2c0-7.72-6.28-14-14-14zM6 10c-1.104 0-2 .896-2 2s.896 2 2 2c2.205 0 4 1.794 4 4 0 1.104.896 2 2 2s2-.896 2-2c0-4.411-3.589-8-8-8z"
    },
    "children": []
  }]
};
exports.rss = rss;
var scissorsOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.124 5.27l.25.013c.163.022.319.02.468.077.146.05.292.084.42.146.254.131.471.262.631.422.174.137.248.279.321.371l.108.146-.166-.074c-.105-.043-.258-.139-.442-.16-.129-.037-.282-.047-.442-.047l-.15.002-.318.061c-.103.01-.201.078-.295.113-.186.088-.35.203-.461.34l-.057.076c.451.477.732 1.115.732 1.824 0 1.471-1.195 2.668-2.666 2.668-.908 0-1.707-.457-2.189-1.15l-1.657 2.625c1.712 1.92 3.22 4.348 3.22 4.348 1.037 1.429-.789 3.947-.789 3.947l-3.552-6.522-3.551 6.522s-1.826-2.52-.789-3.947c0 0 1.507-2.428 3.22-4.348l-1.656-2.625c-.482.693-1.283 1.15-2.188 1.15-1.472 0-2.667-1.197-2.667-2.668 0-1.469 1.195-2.666 2.667-2.666.925 0 1.739.475 2.218 1.193.955 1.428 1.739 3.156 2.748 4.334 1.008-1.178 1.792-2.906 2.746-4.336.48-.717 1.295-1.191 2.221-1.191l.186.018.326-.188.383-.211c.132-.072.297-.107.449-.158.224-.07.475-.105.721-.105m-2.069 4.376c.273 0 .547-.104.756-.312.416-.416.416-1.092 0-1.508-.209-.208-.481-.312-.754-.312s-.545.104-.754.312l-.24.377c-.144.381-.066.826.24 1.131.207.209.479.312.752.312m-9.931 0c.272 0 .545-.104.752-.312.308-.305.382-.75.237-1.131l-.237-.377c-.207-.208-.48-.312-.753-.312s-.547.104-.755.312c-.417.416-.417 1.092 0 1.508.208.208.482.312.756.312m4.965 3.762c.218 0 .396-.178.396-.395 0-.22-.176-.396-.396-.396-.219 0-.394.176-.394.396 0 .217.176.395.394.395m7.035-10.138c-.448 0-.901.066-1.312.191l-.117.036c-.168.051-.426.126-.707.28l-.271.148c-1.388.102-2.656.815-3.467 1.961l-.079.108c-.39.584-.741 1.192-1.082 1.784-.339-.592-.69-1.199-1.081-1.784l-.078-.107c-.877-1.239-2.289-1.974-3.807-1.974-2.574 0-4.667 2.093-4.667 4.666s2.094 4.668 4.667 4.668c.309 0 .611-.03.908-.09-1.016 1.338-1.777 2.53-1.948 2.803-1.714 2.467.392 5.619.835 6.229.377.521.98.826 1.619.826l.129-.004c.686-.044 1.3-.437 1.628-1.039l1.795-3.298 1.795 3.298c.328.604.943.995 1.628 1.039l.129.004c.639 0 1.241-.306 1.619-.826.443-.61 2.549-3.764.834-6.229-.17-.271-.932-1.465-1.947-2.803.295.06.601.09.908.09 2.573 0 4.668-2.095 4.668-4.668l-.004-.179c.467-.096.898-.356 1.2-.758.547-.729.536-1.733-.032-2.445l-.049-.067-.039-.053c-.102-.146-.279-.394-.572-.644-.35-.326-.738-.547-1.045-.705-.275-.136-.488-.201-.628-.244l-.062-.02c-.333-.117-.622-.146-.784-.16l-.054-.006-.086-.01-.444-.018z"
    },
    "children": []
  }]
};
exports.scissorsOutline = scissorsOutline;
var scissors = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.625 5.515c-1-1.522-2.915-1.67-4.397-.824l-.186.107-.076-.003c-1.042 0-2.01.511-2.604 1.369l-.034.045c-.43.645-.723 1.236-1.005 1.809-.255.516-.5 1.01-.824 1.483-.325-.475-.57-.97-.826-1.486-.283-.571-.575-1.162-1.004-1.806l-.033-.044c-.593-.859-1.562-1.37-2.603-1.37-1.747 0-3.167 1.42-3.167 3.166 0 1.747 1.421 3.168 3.167 3.168.775 0 1.515-.287 2.087-.791l.652 1.198c-1.621 1.876-2.979 4.054-3.019 4.121-1.236 1.702.705 4.42.789 4.534.094.131.245.207.405.207.204-.012.357-.11.439-.261l3.112-5.717 3.113 5.717c.082.15.235.249.407.26.174.019.336-.066.437-.206.083-.114 2.024-2.832.809-4.504l-.323-.521c-1.076-1.736-1.187-1.916-2.715-3.634l.651-1.195c.572.504 1.313.791 2.088.791 1.746 0 3.167-1.421 3.167-3.168 0-.634-.191-1.246-.547-1.768.472-.27.997-.123 1.456.095.466.191.897-.377.584-.772zm-13.625 3.485c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1zm4.5 3.395c-.277 0-.5-.225-.5-.5 0-.277.223-.5.5-.5s.5.223.5.5c0 .275-.223.5-.5.5zm4.5-3.395c-.552 0-1-.447-1-1s.448-1 1-1 1 .447 1 1-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.scissors = scissors;
var shoppingBag = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 4h-10c-1.654 0-3 1.346-3 3v11c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3v-11c0-1.654-1.346-3-3-3zm1 14c0 .551-.448 1-1 1h-10c-.552 0-1-.449-1-1v-7.28c.296.174.635.28 1 .28h1.5c0 1.93 1.57 3.5 3.5 3.5s3.5-1.57 3.5-3.5h1.5c.365 0 .704-.106 1-.279v7.279zm-8.5-7h5c0 1.378-1.121 2.5-2.5 2.5s-2.5-1.122-2.5-2.5zm8.5-2c0 .551-.448 1-1 1h-10c-.552 0-1-.449-1-1v-2c0-.551.448-1 1-1h10c.552 0 1 .449 1 1v2z"
    },
    "children": []
  }]
};
exports.shoppingBag = shoppingBag;
var shoppingCart = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M20.756 5.345c-.191-.219-.466-.345-.756-.345h-13.819l-.195-1.164c-.08-.482-.497-.836-.986-.836h-2.25c-.553 0-1 .447-1 1s.447 1 1 1h1.403l1.86 11.164.045.124.054.151.12.179.095.112.193.13.112.065c.116.047.238.075.367.075h11.001c.553 0 1-.447 1-1s-.447-1-1-1h-10.153l-.166-1h11.319c.498 0 .92-.366.99-.858l1-7c.041-.288-.045-.579-.234-.797zm-1.909 1.655l-.285 2h-3.562v-2h3.847zm-4.847 0v2h-3v-2h3zm0 3v2h-3v-2h3zm-4-3v2h-3l-.148.03-.338-2.03h3.486zm-2.986 3h2.986v2h-2.653l-.333-2zm7.986 2v-2h3.418l-.285 2h-3.133z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M20.756 5.345c-.191-.219-.466-.345-.756-.345h-13.819l-.195-1.164c-.08-.482-.497-.836-.986-.836h-2.25c-.553 0-1 .447-1 1s.447 1 1 1h1.403l1.86 11.164.045.124.054.151.12.179.095.112.193.13.112.065c.116.047.238.075.367.075h11.001c.553 0 1-.447 1-1s-.447-1-1-1h-10.153l-.166-1h11.319c.498 0 .92-.366.99-.858l1-7c.041-.288-.045-.579-.234-.797zm-1.909 1.655l-.285 2h-3.562v-2h3.847zm-4.847 0v2h-3v-2h3zm0 3v2h-3v-2h3zm-4-3v2h-3l-.148.03-.338-2.03h3.486zm-2.986 3h2.986v2h-2.653l-.333-2zm7.986 2v-2h3.418l-.285 2h-3.133z"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "8.5",
        "cy": "19.5",
        "r": "1.5"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "8.5",
          "cy": "19.5",
          "r": "1.5"
        },
        "children": []
      }]
    }, {
      "name": "circle",
      "attribs": {
        "cx": "17.5",
        "cy": "19.5",
        "r": "1.5"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "17.5",
          "cy": "19.5",
          "r": "1.5"
        },
        "children": []
      }]
    }]
  }]
};
exports.shoppingCart = shoppingCart;
var socialAtCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M11.844 7.5c-2.481 0-4.438 2.019-4.438 4.5s2.05 4.5 4.531 4.5c.908 0 1.799-.27 2.547-.778.228-.155.295-.466.139-.694-.155-.229-.462-.287-.691-.132-.58.396-1.258.604-1.965.604-1.93 0-3.499-1.57-3.499-3.5s1.446-3.5 3.376-3.5 3.375 1.57 3.375 3.5v.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.75c0-.276-.099-.5-.375-.5-.205 0-.318.124-.396.301-.303-.188-.628-.301-1.01-.301-1.104 0-1.984.896-1.984 2s.904 2 2.008 2c.562 0 1.073-.235 1.438-.609.319.369.664.609 1.192.609.965 0 1.627-.785 1.627-1.75v-.25c0-2.481-1.894-4.5-4.375-4.5zm.125 5.5c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M11.844 7.5c-2.481 0-4.438 2.019-4.438 4.5s2.05 4.5 4.531 4.5c.908 0 1.799-.27 2.547-.778.228-.155.295-.466.139-.694-.155-.229-.462-.287-.691-.132-.58.396-1.258.604-1.965.604-1.93 0-3.499-1.57-3.499-3.5s1.446-3.5 3.376-3.5 3.375 1.57 3.375 3.5v.25c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-1.75c0-.276-.099-.5-.375-.5-.205 0-.318.124-.396.301-.303-.188-.628-.301-1.01-.301-1.104 0-1.984.896-1.984 2s.904 2 2.008 2c.562 0 1.073-.235 1.438-.609.319.369.664.609 1.192.609.965 0 1.627-.785 1.627-1.75v-.25c0-2.481-1.894-4.5-4.375-4.5zm.125 5.5c-.551 0-1-.449-1-1s.449-1 1-1 1 .449 1 1-.449 1-1 1zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialAtCircular = socialAtCircular;
var socialDribbbleCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 21c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9zm0-16c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7zM12 6.5c-3.033 0-5.5 2.468-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.467-5.5-5.5-5.5zm4.49 5.402c-1.048-.186-2.1-.18-3.103.042-.127-.326-.267-.647-.417-.965.875-.524 1.652-1.221 2.284-2.07.746.785 1.211 1.834 1.236 2.993zm-2-3.646c-.546.748-1.215 1.367-1.975 1.832-.479-.856-1.046-1.663-1.692-2.412.378-.103.767-.176 1.177-.176.921 0 1.776.28 2.49.756zm-4.641-.184c.687.758 1.278 1.59 1.776 2.473-1.238.531-2.622.691-3.998.437.293-1.259 1.118-2.302 2.222-2.91zm-2.349 3.928c.468.064.936.121 1.399.121 1.106 0 2.187-.244 3.185-.683.123.261.238.524.344.793-1.469.526-2.769 1.489-3.728 2.805-.738-.802-1.2-1.862-1.2-3.036zm1.948 3.699c.842-1.189 2.004-2.057 3.318-2.527.314 1.001.518 2.039.596 3.095-.433.138-.884.233-1.362.233-.948 0-1.826-.298-2.552-.801zm4.872.137c-.099-1-.296-1.983-.593-2.937.87-.176 1.778-.172 2.683.001-.256 1.247-1.035 2.296-2.09 2.936z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-4.962 0-9-4.037-9-9s4.038-9 9-9 9 4.037 9 9-4.038 9-9 9zm0-16c-3.86 0-7 3.141-7 7s3.14 7 7 7 7-3.141 7-7-3.14-7-7-7zM12 6.5c-3.033 0-5.5 2.468-5.5 5.5s2.467 5.5 5.5 5.5 5.5-2.468 5.5-5.5-2.467-5.5-5.5-5.5zm4.49 5.402c-1.048-.186-2.1-.18-3.103.042-.127-.326-.267-.647-.417-.965.875-.524 1.652-1.221 2.284-2.07.746.785 1.211 1.834 1.236 2.993zm-2-3.646c-.546.748-1.215 1.367-1.975 1.832-.479-.856-1.046-1.663-1.692-2.412.378-.103.767-.176 1.177-.176.921 0 1.776.28 2.49.756zm-4.641-.184c.687.758 1.278 1.59 1.776 2.473-1.238.531-2.622.691-3.998.437.293-1.259 1.118-2.302 2.222-2.91zm-2.349 3.928c.468.064.936.121 1.399.121 1.106 0 2.187-.244 3.185-.683.123.261.238.524.344.793-1.469.526-2.769 1.489-3.728 2.805-.738-.802-1.2-1.862-1.2-3.036zm1.948 3.699c.842-1.189 2.004-2.057 3.318-2.527.314 1.001.518 2.039.596 3.095-.433.138-.884.233-1.362.233-.948 0-1.826-.298-2.552-.801zm4.872.137c-.099-1-.296-1.983-.593-2.937.87-.176 1.778-.172 2.683.001-.256 1.247-1.035 2.296-2.09 2.936z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialDribbbleCircular = socialDribbbleCircular;
var socialDribbble = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3c-4.962 0-9 4.037-9 9s4.038 9 9 9 9-4.037 9-9-4.038-9-9-9zm6.962 8.275c-1.765-.289-3.534-.187-5.205.262-.18-.436-.383-.859-.59-1.283 1.422-.81 2.685-1.912 3.713-3.262 1.143 1.113 1.909 2.611 2.082 4.283zm-2.832-4.914c-.939 1.243-2.1 2.259-3.401 3.009-.782-1.445-1.729-2.8-2.807-4.056.657-.204 1.355-.314 2.078-.314 1.545 0 2.971.51 4.13 1.361zm-7.183-.65c1.119 1.265 2.093 2.645 2.892 4.117-2.061.957-4.396 1.294-6.717.899.408-2.212 1.86-4.058 3.825-5.016zm-3.947 6.289l.015-.294c.676.111 1.353.188 2.024.188 1.827 0 3.607-.426 5.237-1.187.182.373.365.744.525 1.127-2.429.866-4.583 2.486-6.101 4.726-1.056-1.227-1.7-2.818-1.7-4.56zm2.393 5.257c1.43-2.129 3.465-3.673 5.764-4.487.683 1.854 1.123 3.795 1.292 5.779-.763.287-1.587.451-2.449.451-1.765 0-3.375-.661-4.607-1.743zm8.014.852c-.196-1.932-.631-3.822-1.293-5.632 1.564-.404 3.222-.486 4.871-.19-.102 2.502-1.516 4.668-3.578 5.822z"
    },
    "children": []
  }]
};
exports.socialDribbble = socialDribbble;
var socialFacebookCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.354 5.624c-1.75-1.741-3.888-2.624-6.354-2.624-2.489 0-4.633.884-6.373 2.625-1.743 1.741-2.627 3.887-2.627 6.375 0 2.465.883 4.603 2.624 6.354 1.741 1.756 3.886 2.646 6.376 2.646 2.467 0 4.605-.89 6.356-2.643 1.755-1.753 2.644-3.892 2.644-6.357 0-2.488-.89-4.634-2.646-6.376zm-1.412 11.319c-1.137 1.139-2.436 1.788-3.942 1.985v-4.928h2v-2h-2v-1.4c0-.331.269-.6.601-.6h1.399v-2h-1.397c-.742 0-1.361.273-1.857.822-.496.547-.746 1.215-.746 2.008v1.17h-2v2h2v4.93c-1.522-.195-2.826-.845-3.957-1.984-1.375-1.384-2.043-3.002-2.043-4.946 0-1.966.667-3.588 2.042-4.96 1.37-1.373 2.992-2.04 4.958-2.04 1.945 0 3.562.668 4.945 2.043 1.383 1.372 2.055 2.994 2.055 4.957 0 1.941-.673 3.559-2.058 4.943z"
    },
    "children": []
  }]
};
exports.socialFacebookCircular = socialFacebookCircular;
var socialFacebook = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 10h3v3h-3v7h-3v-7h-3v-3h3v-1.255c0-1.189.374-2.691 1.118-3.512.744-.823 1.673-1.233 2.786-1.233h2.096v3h-2.1c-.498 0-.9.402-.9.899v2.101z"
    },
    "children": []
  }]
};
exports.socialFacebook = socialFacebook;
var socialFlickrCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 21c-2.489 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.889-2.624-6.354 0-2.488.884-4.634 2.627-6.375 1.74-1.741 3.885-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.755 1.742 2.646 3.888 2.646 6.376 0 2.465-.89 4.604-2.644 6.357-1.751 1.753-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.374 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.941-2.057 1.386-1.384 2.059-3.002 2.059-4.943 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043zM9 14.5c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM15 14.5c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-2.489 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.889-2.624-6.354 0-2.488.884-4.634 2.627-6.375 1.74-1.741 3.885-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.755 1.742 2.646 3.888 2.646 6.376 0 2.465-.89 4.604-2.644 6.357-1.751 1.753-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.374 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.941-2.057 1.386-1.384 2.059-3.002 2.059-4.943 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043zM9 14.5c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5zm0-4c-.827 0-1.5.673-1.5 1.5s.673 1.5 1.5 1.5 1.5-.673 1.5-1.5-.673-1.5-1.5-1.5zM15 14.5c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialFlickrCircular = socialFlickrCircular;
var socialFlickr = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.5 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.794 4-4 4zm0-6c-1.103 0-2 .897-2 2s.897 2 2 2 2-.897 2-2-.897-2-2-2zM16.5 8c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4z"
    },
    "children": []
  }]
};
exports.socialFlickr = socialFlickr;
var socialGithubCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 21c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.038 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7-3.141-7-7-7zM13.565 12.626c.171 0 .316.084.441.255.124.169.187.378.187.625 0 .248-.062.457-.187.626-.125.169-.271.254-.441.254-.181 0-.337-.084-.461-.254-.124-.169-.187-.378-.187-.626s.062-.456.187-.625c.125-.171.281-.255.461-.255m2.21-2.289c.482.522.725 1.155.725 1.898 0 .482-.057.915-.166 1.301-.111.384-.252.698-.42.939-.171.242-.378.454-.627.635-.249.184-.478.316-.685.401-.208.085-.446.15-.716.196-.266.047-.467.072-.606.079l-.44.009-.352.01-.488.011-.488-.011-.352-.01-.44-.009c-.14-.007-.341-.032-.606-.079-.271-.045-.508-.11-.716-.196-.207-.084-.436-.217-.684-.401-.25-.182-.457-.394-.628-.635-.168-.241-.309-.555-.42-.939-.109-.386-.166-.819-.166-1.301 0-.743.242-1.376.725-1.898-.053-.026-.056-.286-.008-.782.043-.496.148-.953.319-1.37.602.064 1.343.404 2.23 1.017.3-.078.71-.118 1.233-.118.549 0 .959.04 1.234.118.404-.273.791-.496 1.16-.666.374-.168.644-.267.814-.293l.254-.058c.172.417.277.875.32 1.37.05.496.047.756-.006.782m-3.754 5.027c1.083 0 1.899-.129 2.454-.39.553-.26.833-.796.833-1.605 0-.469-.176-.861-.529-1.174-.181-.17-.394-.273-.638-.313-.238-.039-.607-.039-1.104 0-.495.04-.834.058-1.016.058-.248 0-.517-.013-.851-.039l-.783-.049c-.191-.006-.395.018-.616.069-.223.053-.404.143-.55.273-.336.3-.507.691-.507 1.174 0 .809.274 1.345.821 1.605.547.261 1.361.39 2.444.39m-1.524-2.737c.17 0 .316.084.44.255.124.169.187.378.187.625 0 .248-.062.457-.187.626-.124.169-.271.254-.44.254-.182 0-.337-.084-.462-.254-.124-.169-.187-.378-.187-.626s.062-.456.187-.625c.125-.171.28-.255.462-.255"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-4.963 0-9-4.038-9-9s4.037-9 9-9 9 4.038 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.14-7 7s3.141 7 7 7 7-3.14 7-7-3.141-7-7-7zM13.565 12.626c.171 0 .316.084.441.255.124.169.187.378.187.625 0 .248-.062.457-.187.626-.125.169-.271.254-.441.254-.181 0-.337-.084-.461-.254-.124-.169-.187-.378-.187-.626s.062-.456.187-.625c.125-.171.281-.255.461-.255m2.21-2.289c.482.522.725 1.155.725 1.898 0 .482-.057.915-.166 1.301-.111.384-.252.698-.42.939-.171.242-.378.454-.627.635-.249.184-.478.316-.685.401-.208.085-.446.15-.716.196-.266.047-.467.072-.606.079l-.44.009-.352.01-.488.011-.488-.011-.352-.01-.44-.009c-.14-.007-.341-.032-.606-.079-.271-.045-.508-.11-.716-.196-.207-.084-.436-.217-.684-.401-.25-.182-.457-.394-.628-.635-.168-.241-.309-.555-.42-.939-.109-.386-.166-.819-.166-1.301 0-.743.242-1.376.725-1.898-.053-.026-.056-.286-.008-.782.043-.496.148-.953.319-1.37.602.064 1.343.404 2.23 1.017.3-.078.71-.118 1.233-.118.549 0 .959.04 1.234.118.404-.273.791-.496 1.16-.666.374-.168.644-.267.814-.293l.254-.058c.172.417.277.875.32 1.37.05.496.047.756-.006.782m-3.754 5.027c1.083 0 1.899-.129 2.454-.39.553-.26.833-.796.833-1.605 0-.469-.176-.861-.529-1.174-.181-.17-.394-.273-.638-.313-.238-.039-.607-.039-1.104 0-.495.04-.834.058-1.016.058-.248 0-.517-.013-.851-.039l-.783-.049c-.191-.006-.395.018-.616.069-.223.053-.404.143-.55.273-.336.3-.507.691-.507 1.174 0 .809.274 1.345.821 1.605.547.261 1.361.39 2.444.39m-1.524-2.737c.17 0 .316.084.44.255.124.169.187.378.187.625 0 .248-.062.457-.187.626-.124.169-.271.254-.44.254-.182 0-.337-.084-.462-.254-.124-.169-.187-.378-.187-.626s.062-.456.187-.625c.125-.171.28-.255.462-.255"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialGithubCircular = socialGithubCircular;
var socialGithub = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14.435 12.973c.269 0 .492.133.686.396.192.265.294.588.294.975 0 .385-.102.711-.294.973-.193.265-.417.396-.686.396-.278 0-.522-.131-.715-.396-.192-.262-.294-.588-.294-.973 0-.387.102-.71.294-.975.192-.264.436-.396.715-.396m3.44-3.559c.746.811 1.125 1.795 1.125 2.953 0 .748-.086 1.423-.259 2.023-.175.597-.394 1.084-.654 1.459-.264.376-.588.705-.974.989-.386.286-.741.492-1.065.623-.325.132-.695.233-1.111.306-.417.071-.726.111-.943.123l-.685.014-.547.015c-.301.013-.56.016-.762.016s-.461-.003-.762-.016l-.547-.015-.685-.014c-.218-.012-.526-.052-.943-.123-.423-.072-.786-.174-1.111-.306-.324-.131-.68-.337-1.064-.623-.387-.284-.711-.613-.975-.989-.261-.375-.479-.862-.654-1.459-.173-.6-.259-1.275-.259-2.023 0-1.158.379-2.143 1.125-2.953-.082-.041-.085-.447-.008-1.217.063-.771.227-1.482.495-2.132.934.099 2.09.629 3.471 1.581.466-.119 1.101-.183 1.917-.183.852 0 1.491.064 1.918.184.629-.425 1.23-.771 1.805-1.034.584-.261 1.005-.416 1.269-.457l.396-.09c.27.649.434 1.36.496 2.132.076.769.073 1.175-.009 1.216m-5.845 7.82c1.688 0 2.954-.202 3.821-.607.855-.404 1.292-1.238 1.292-2.496 0-.73-.273-1.34-.822-1.828-.278-.263-.613-.425-.989-.486-.375-.061-.949-.061-1.72 0-.769.062-1.298.09-1.582.09-.385 0-.8-.018-1.319-.059-.52-.04-.928-.065-1.223-.078-.294-.009-.609.027-.958.108-.345.082-.629.224-.853.425-.521.469-.79 1.077-.79 1.828 0 1.258.426 2.092 1.28 2.496.85.405 2.113.607 3.802.607h.061m-2.434-4.261c.268 0 .492.133.685.396.192.265.294.588.294.975 0 .385-.102.711-.294.973-.192.265-.417.396-.685.396-.279 0-.522-.131-.716-.396-.192-.262-.294-.588-.294-.973 0-.387.102-.71.294-.975.193-.264.436-.396.716-.396"
    },
    "children": []
  }]
};
exports.socialGithub = socialGithub;
var socialGooglePlusCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.8 13.1l-.4-.3c-.1-.1-.3-.2-.3-.5l.3-.6c.5-.4 1-.8 1-1.7s-.6-1.4-.8-1.6h.7l.7-.4h-2.4c-.6 0-1.4.1-2.1.6-.5.4-.8 1-.8 1.6 0 .9.7 1.9 2 1.9h.4c-.1.1-.1.2-.1.4 0 .4.2.6.4.8-.5 0-1.5.1-2.3.5-.7.4-.9 1-.9 1.4 0 .9.8 1.7 2.5 1.7 2 0 3.1-1.1 3.1-2.2 0-.7-.5-1.1-1-1.6zm-1.6-1.3c-1 0-1.5-1.3-1.5-2.1.1-.4.1-.7.3-.9s.5-.4.8-.4c1 0 1.5 1.3 1.5 2.2 0 .2 0 .6-.3.9-.1.1-.5.3-.8.3zm.1 4.7c-1.3 0-2.1-.6-2.1-1.4 0-.8.8-1.1 1-1.2.5-.2 1.1-.2 1.2-.2h.3c.9.6 1.3 1 1.3 1.6 0 .7-.6 1.2-1.7 1.2zM15 12h-1v-1h1v-1h1v1h1v1h-1v1h-1zM12 21c-5 0-9-4-9-9s4-9 9-9 9 4 9 9-4 9-9 9zm0-16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7z"
    },
    "children": []
  }]
};
exports.socialGooglePlusCircular = socialGooglePlusCircular;
var socialGooglePlus = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.9 13.5l-.7-.5c-.2-.2-.5-.4-.5-.8s.3-.7.6-1c.8-.6 1.7-1.3 1.7-2.8 0-1.5-.9-2.3-1.4-2.7h1.2l1.2-.7h-4.1c-1 0-2.4.2-3.5 1.1-.8.7-1.2 1.7-1.2 2.6 0 1.5 1.2 3.1 3.3 3.1h.6c-.1.2-.2.4-.2.7 0 .6.3 1 .6 1.3-.9.1-2.5.2-3.8.9-1.2.7-1.5 1.7-1.5 2.4 0 1.5 1.4 2.8 4.2 2.8 3.4 0 5.2-1.9 5.2-3.7 0-1.3-.8-1.9-1.7-2.7zm-2.5-2.2c-1.7 0-2.5-2.2-2.5-3.5 0-.5.1-1 .4-1.5.3-.4.9-.7 1.4-.7 1.6 0 2.5 2.2 2.5 3.6 0 .4 0 1-.5 1.4-.3.4-.9.7-1.3.7zm0 7.9c-2.1 0-3.5-1-3.5-2.4s1.3-1.9 1.7-2c.8-.3 1.9-.3 2.1-.3h.5c1.5 1.1 2.1 1.6 2.1 2.6 0 1.2-1 2.1-2.9 2.1zM17 12h-2v-1h2v-1.9l1-.1v2h2v1h-2v2h-1z"
    },
    "children": []
  }]
};
exports.socialGooglePlus = socialGooglePlus;
var socialInstagramCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 7c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm2.8-2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2zm-2.8 11c-3.9 0-7-3.1-7-7h3c0 2.2 1.8 4 4 4s4-1.8 4-4h3c0 3.9-3.1 7-7 7z"
    },
    "children": []
  }]
};
exports.socialInstagramCircular = socialInstagramCircular;
var socialInstagram = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 3h-12c-1.7 0-3 1.3-3 3v12c0 1.7 1.3 3 3 3h12c1.7 0 3-1.3 3-3v-12c0-1.7-1.3-3-3-3zm-6 6c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3zm3.8-2c0-.7.6-1.2 1.2-1.2s1.2.6 1.2 1.2-.5 1.2-1.2 1.2-1.2-.5-1.2-1.2zm2.2 12h-12c-.6 0-1-.4-1-1v-6h2c0 2.8 2.2 5 5 5s5-2.2 5-5h2v6c0 .6-.4 1-1 1z"
    },
    "children": []
  }]
};
exports.socialInstagram = socialInstagram;
var socialLastFmCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 21c-2.489 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.89-2.624-6.354 0-2.489.884-4.633 2.627-6.375 1.74-1.741 3.885-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.755 1.742 2.646 3.887 2.646 6.376 0 2.464-.89 4.604-2.644 6.357-1.751 1.754-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.374 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.941-2.056 1.386-1.385 2.059-3.002 2.059-4.944 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043zM14.199 14.333c1.335 0 2-.444 2-1.333 0-.733-.422-1.199-1.267-1.4l-.632-.133c-.354-.089-.534-.277-.534-.566 0-.334.224-.5.666-.5.49 0 .746.188.767.565l.967-.1c-.063-.822-.622-1.233-1.666-1.233-1.134 0-1.699.467-1.699 1.401 0 .665.365 1.088 1.099 1.267l.668.133c.443.11.666.312.666.601 0 .354-.345.532-1.034.532-.844 0-1.398-.411-1.666-1.233l-.334-.967c-.199-.644-.449-1.095-.75-1.35-.3-.255-.771-.384-1.416-.384-.601 0-1.128.223-1.584.667-.456.445-.683 1.033-.683 1.767 0 .688.216 1.239.649 1.649.435.413.95.617 1.55.617.602 0 1.078-.144 1.434-.433l-.299-.834c-.311.312-.679.468-1.101.468-.354 0-.662-.14-.916-.417-.257-.277-.385-.64-.385-1.084 0-.556.139-.961.417-1.217s.594-.383.951-.383c.379 0 .648.1.816.299.167.201.315.512.45.935l.3.967c.356 1.133 1.212 1.699 2.566 1.699"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-2.489 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.89-2.624-6.354 0-2.489.884-4.633 2.627-6.375 1.74-1.741 3.885-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.755 1.742 2.646 3.887 2.646 6.376 0 2.464-.89 4.604-2.644 6.357-1.751 1.754-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.374 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.941-2.056 1.386-1.385 2.059-3.002 2.059-4.944 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043zM14.199 14.333c1.335 0 2-.444 2-1.333 0-.733-.422-1.199-1.267-1.4l-.632-.133c-.354-.089-.534-.277-.534-.566 0-.334.224-.5.666-.5.49 0 .746.188.767.565l.967-.1c-.063-.822-.622-1.233-1.666-1.233-1.134 0-1.699.467-1.699 1.401 0 .665.365 1.088 1.099 1.267l.668.133c.443.11.666.312.666.601 0 .354-.345.532-1.034.532-.844 0-1.398-.411-1.666-1.233l-.334-.967c-.199-.644-.449-1.095-.75-1.35-.3-.255-.771-.384-1.416-.384-.601 0-1.128.223-1.584.667-.456.445-.683 1.033-.683 1.767 0 .688.216 1.239.649 1.649.435.413.95.617 1.55.617.602 0 1.078-.144 1.434-.433l-.299-.834c-.311.312-.679.468-1.101.468-.354 0-.662-.14-.916-.417-.257-.277-.385-.64-.385-1.084 0-.556.139-.961.417-1.217s.594-.383.951-.383c.379 0 .648.1.816.299.167.201.315.512.45.935l.3.967c.356 1.133 1.212 1.699 2.566 1.699"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialLastFmCircular = socialLastFmCircular;
var socialLastFm = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.942 16.182c2.374 0 3.558-.791 3.558-2.373 0-1.304-.749-2.132-2.254-2.49l-1.119-.235c-.637-.159-.951-.495-.951-1.009 0-.594.396-.889 1.186-.889.869 0 1.323.334 1.363 1.006l1.717-.178c-.114-1.463-1.109-2.195-2.962-2.195-2.019 0-3.026.832-3.026 2.495 0 1.182.654 1.935 1.958 2.251l1.188.236c.79.196 1.186.555 1.186 1.068 0 .631-.614.949-1.842.949-1.498 0-2.489-.732-2.962-2.195l-.597-1.721c-.354-1.145-.796-1.947-1.334-2.401-.53-.45-1.367-.683-2.519-.683-1.069 0-2.007.396-2.815 1.188-.811.791-1.217 1.838-1.217 3.142 0 1.223.383 2.203 1.156 2.935.774.733 1.688 1.099 2.756 1.099 1.069 0 1.918-.256 2.55-.77l-.53-1.485c-.554.556-1.211.833-1.96.833-.63 0-1.175-.248-1.628-.744-.455-.492-.686-1.137-.686-1.927 0-.989.247-1.708.743-2.163.497-.455 1.056-.681 1.689-.681.674 0 1.155.177 1.457.53.296.357.56.912.797 1.662l.537 1.721c.632 2.014 2.154 3.024 4.561 3.024"
    },
    "children": []
  }]
};
exports.socialLastFm = socialLastFm;
var socialLinkedinCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M10.033 15.3h-1.6v-5.199h1.6v5.199zm-.8-5.866c-.577 0-.866-.267-.866-.8 0-.223.082-.412.25-.567.166-.155.371-.233.616-.233.577 0 .866.268.866.801s-.288.799-.866.799zm6.734 5.866h-1.633v-2.9c0-.755-.268-1.133-.801-1.133-.422 0-.699.211-.834.633-.043.067-.066.201-.066.4v3h-1.633v-3.533c0-.8-.012-1.355-.033-1.666h1.4l.1.699c.367-.556.9-.833 1.633-.833.557 0 1.006.194 1.35.583.346.389.518.95.518 1.684v3.066zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M10.033 15.3h-1.6v-5.199h1.6v5.199zm-.8-5.866c-.577 0-.866-.267-.866-.8 0-.223.082-.412.25-.567.166-.155.371-.233.616-.233.577 0 .866.268.866.801s-.288.799-.866.799zm6.734 5.866h-1.633v-2.9c0-.755-.268-1.133-.801-1.133-.422 0-.699.211-.834.633-.043.067-.066.201-.066.4v3h-1.633v-3.533c0-.8-.012-1.355-.033-1.666h1.4l.1.699c.367-.556.9-.833 1.633-.833.557 0 1.006.194 1.35.583.346.389.518.95.518 1.684v3.066zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialLinkedinCircular = socialLinkedinCircular;
var socialLinkedin = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 19h-3v-10h3v10zm11 0h-3v-5.342c0-1.392-.496-2.085-1.479-2.085-.779 0-1.273.388-1.521 1.165v6.262h-3s.04-9 0-10h2.368l.183 2h.062c.615-1 1.598-1.678 2.946-1.678 1.025 0 1.854.285 2.487 1.001.637.717.954 1.679.954 3.03v5.647z"
    },
    "children": []
  }, {
    "name": "ellipse",
    "attribs": {
      "cx": "6.5",
      "cy": "6.5",
      "rx": "1.55",
      "ry": "1.5"
    },
    "children": []
  }]
};
exports.socialLinkedin = socialLinkedin;
var socialPinterestCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zM12.335 8c-2.468 0-3.712 1.77-3.712 3.244 0 .895.338 1.688 1.063 1.984.119.049.226.002.261-.129l.105-.418c.035-.129.021-.175-.074-.289-.209-.246-.344-.566-.344-1.019 0-1.312.982-2.487 2.558-2.487 1.396 0 2.161.853 2.161 1.99 0 1.498-.662 2.762-1.646 2.762-.543 0-.95-.449-.82-1.001.156-.658.459-1.368.459-1.843 0-.426-.229-.779-.7-.779-.556 0-1.002.574-1.002 1.344 0 .49.166.822.166.822l-.669 2.83c-.198.84-.029 1.87-.015 1.974.008.062.087.077.123.03.052-.067.713-.885.938-1.7.064-.23.366-1.427.366-1.427.18.344.707.646 1.268.646 1.67 0 2.803-1.521 2.803-3.56-.001-1.538-1.306-2.974-3.289-2.974z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7zM12.335 8c-2.468 0-3.712 1.77-3.712 3.244 0 .895.338 1.688 1.063 1.984.119.049.226.002.261-.129l.105-.418c.035-.129.021-.175-.074-.289-.209-.246-.344-.566-.344-1.019 0-1.312.982-2.487 2.558-2.487 1.396 0 2.161.853 2.161 1.99 0 1.498-.662 2.762-1.646 2.762-.543 0-.95-.449-.82-1.001.156-.658.459-1.368.459-1.843 0-.426-.229-.779-.7-.779-.556 0-1.002.574-1.002 1.344 0 .49.166.822.166.822l-.669 2.83c-.198.84-.029 1.87-.015 1.974.008.062.087.077.123.03.052-.067.713-.885.938-1.7.064-.23.366-1.427.366-1.427.18.344.707.646 1.268.646 1.67 0 2.803-1.521 2.803-3.56-.001-1.538-1.306-2.974-3.289-2.974z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialPinterestCircular = socialPinterestCircular;
var socialPinterest = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12.486 4.771c-4.23 0-6.363 3.033-6.363 5.562 0 1.533.581 2.894 1.823 3.401.205.084.387.004.446-.221l.182-.717c.061-.221.037-.3-.127-.495-.359-.422-.588-.972-.588-1.747 0-2.25 1.683-4.264 4.384-4.264 2.392 0 3.706 1.463 3.706 3.412 0 2.568-1.137 4.734-2.824 4.734-.932 0-1.629-.77-1.405-1.715.268-1.13.786-2.347.786-3.16 0-.729-.392-1.336-1.2-1.336-.952 0-1.718.984-1.718 2.304 0 .841.286 1.409.286 1.409l-1.146 4.852c-.34 1.44-.051 3.206-.025 3.385.013.104.149.131.21.051.088-.115 1.223-1.517 1.607-2.915.111-.396.627-2.445.627-2.445.311.589 1.213 1.108 2.175 1.108 2.863 0 4.804-2.608 4.804-6.103-.003-2.64-2.24-5.1-5.64-5.1z"
    },
    "children": []
  }]
};
exports.socialPinterest = socialPinterest;
var socialSkypeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8.865 5c.751 0 1.44.202 2.069.609.324-.08.711-.121 1.157-.121 1.846 0 3.418.67 4.717 2.008 1.299 1.339 1.948 2.962 1.948 4.87 0 .466-.051.953-.152 1.461.264.589.396 1.187.396 1.794 0 1.097-.38 2.036-1.142 2.815-.761.781-1.668 1.173-2.725 1.173-.629 0-1.237-.162-1.825-.488-.527.081-.933.122-1.217.122-1.847 0-3.425-.67-4.733-2.009s-1.963-2.962-1.963-4.868c0-.447.051-.902.152-1.37-.364-.609-.547-1.288-.547-2.039 0-1.096.376-2.029 1.126-2.799.75-.772 1.664-1.158 2.739-1.158m3.135 10.53c-.406 0-.729-.061-.975-.183-.263-.142-.445-.284-.547-.425-.243-.447-.376-.681-.396-.7-.081-.243-.202-.447-.364-.609-.203-.14-.406-.213-.61-.213-.284 0-.517.091-.7.274-.183.182-.274.396-.274.639 0 .386.144.801.428 1.248.263.405.629.741 1.096 1.003.648.346 1.45.519 2.404.519.79 0 1.49-.122 2.1-.365.609-.284 1.055-.639 1.339-1.065.304-.467.456-.975.456-1.522 0-.445-.08-.852-.242-1.217-.163-.304-.416-.578-.762-.82-.365-.225-.75-.407-1.156-.548-.689-.204-1.178-.336-1.461-.396-.143-.021-.32-.055-.533-.107l-.41-.106c-.243-.08-.416-.152-.518-.212-.163-.081-.294-.193-.396-.336-.103-.1-.152-.233-.152-.396 0-.243.142-.455.426-.639.265-.203.649-.305 1.156-.305.508 0 .884.092 1.127.273.263.225.456.478.577.762.163.264.295.446.396.547.162.123.355.184.578.184.264 0 .498-.102.699-.306.184-.181.275-.404.275-.669 0-.202-.072-.467-.214-.791-.162-.243-.376-.486-.639-.729-.284-.224-.659-.417-1.127-.579-.485-.143-1.004-.213-1.552-.213-.73 0-1.38.11-1.948.335-.566.2-1.003.505-1.307.911-.305.406-.457.872-.457 1.4 0 .527.143.984.426 1.37.346.405.73.688 1.156.851.488.224 1.076.407 1.766.548.121.021.27.056.441.106l.457.123.319.075c.284.103.517.243.699.427.183.141.274.354.274.639 0 .346-.162.629-.486.853-.364.243-.821.364-1.369.364m-3.135-12.53c-1.609 0-3.053.61-4.174 1.765-1.105 1.134-1.691 2.585-1.691 4.192 0 .832.156 1.619.466 2.348-.047.357-.07.713-.07 1.062 0 2.438.853 4.547 2.532 6.267 1.693 1.732 3.768 2.61 6.164 2.61.254 0 .547-.02.896-.06.69.283 1.409.426 2.146.426 1.588 0 3.025-.614 4.157-1.777 1.117-1.143 1.709-2.6 1.709-4.211 0-.677-.111-1.349-.332-2.004.059-.427.089-.846.089-1.251 0-2.437-.846-4.544-2.513-6.263-1.685-1.735-3.755-2.615-6.152-2.615-.279 0-.546.013-.801.038-.756-.35-1.568-.527-2.426-.527z"
    },
    "children": []
  }]
};
exports.socialSkypeOutline = socialSkypeOutline;
var socialSkype = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.668 13.312c.059-.427.089-.846.089-1.251 0-2.437-.846-4.544-2.513-6.263-1.685-1.735-3.755-2.615-6.152-2.615-.279 0-.546.013-.801.038-.756-.35-1.568-.526-2.426-.526-1.609 0-3.053.61-4.174 1.765-1.105 1.135-1.691 2.585-1.691 4.192 0 .832.156 1.619.466 2.348-.047.357-.07.713-.07 1.062 0 2.438.853 4.547 2.532 6.267 1.693 1.732 3.768 2.61 6.164 2.61.254 0 .547-.02.896-.06.69.283 1.409.426 2.146.426 1.588 0 3.025-.614 4.157-1.777 1.117-1.143 1.709-2.6 1.709-4.211 0-.677-.111-1.349-.332-2.005zm-5.168 2.036c-.284.427-.729.781-1.339 1.065-.609.243-1.31.365-2.1.365-.954 0-1.756-.173-2.404-.519-.467-.262-.833-.598-1.096-1.003-.284-.447-.428-.862-.428-1.248 0-.243.092-.457.274-.639.184-.184.416-.274.7-.274.203 0 .406.072.609.213.162.162.283.366.364.609.021.02.153.253.396.7.102.141.284.283.547.425.245.122.568.183.975.183.548 0 1.005-.121 1.37-.364.324-.224.486-.507.486-.853 0-.284-.092-.498-.274-.639-.183-.184-.415-.324-.699-.427l-.319-.075-.457-.123c-.172-.051-.32-.086-.441-.106-.689-.141-1.277-.324-1.766-.548-.426-.162-.811-.445-1.156-.851-.283-.386-.426-.843-.426-1.37 0-.528.152-.994.457-1.4.304-.406.74-.711 1.308-.913.569-.224 1.219-.334 1.949-.334.548 0 1.066.07 1.552.213.468.162.843.355 1.127.579.263.243.477.486.639.729.142.324.214.589.214.791 0 .265-.092.488-.275.669-.201.204-.436.306-.699.306-.223 0-.416-.061-.578-.184-.102-.101-.233-.283-.396-.547-.121-.284-.314-.537-.577-.762-.243-.182-.619-.273-1.127-.273-.507 0-.892.102-1.156.305-.284.184-.426.396-.426.639 0 .162.05.296.152.396.102.143.232.255.396.336.102.06.274.132.518.212l.41.106c.213.053.391.087.533.107.283.061.771.192 1.461.396.406.141.791.323 1.156.548.346.242.599.517.762.82.162.365.242.771.242 1.217-.002.548-.154 1.056-.458 1.523z"
    },
    "children": []
  }]
};
exports.socialSkype = socialSkype;
var socialTumblerCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M14.377 15.59v-1.234c-.399.268-.788.4-1.166.4-.178 0-.377-.057-.6-.166-.134-.09-.211-.189-.234-.301-.066-.133-.1-.422-.1-.867v-1.966h1.834v-1.233h-1.834v-1.967h-1.066c-.089.467-.178.8-.267 1-.11.244-.288.467-.533.666-.245.201-.5.345-.767.434v1.101h.833v2.7c0 .311.044.576.134.799.066.178.199.355.4.533.154.156.377.289.666.4.355.09.666.133.934.133.311 0 .6-.033.866-.1.312-.067.612-.178.9-.332"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M14.377 15.59v-1.234c-.399.268-.788.4-1.166.4-.178 0-.377-.057-.6-.166-.134-.09-.211-.189-.234-.301-.066-.133-.1-.422-.1-.867v-1.966h1.834v-1.233h-1.834v-1.967h-1.066c-.089.467-.178.8-.267 1-.11.244-.288.467-.533.666-.245.201-.5.345-.767.434v1.101h.833v2.7c0 .311.044.576.134.799.066.178.199.355.4.533.154.156.377.289.666.4.355.09.666.133.934.133.311 0 .6-.033.866-.1.312-.067.612-.178.9-.332"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialTumblerCircular = socialTumblerCircular;
var socialTumbler = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15.527 17.921v-2.066c-.669.448-1.32.67-1.952.67-.298 0-.631-.094-1.004-.277-.223-.151-.354-.317-.393-.503-.11-.224-.178-.708-.178-1.454v-3.291h3v-2h-3v-3.356h-1.772c-.149.782-.298 1.338-.448 1.673-.184.41-.482.782-.891 1.116-.411.337-.837.577-1.285.725v1.842h1.396v4.521c0 .52.073.964.223 1.337.111.298.334.595.671.893.259.262.631.484 1.115.67.595.15 1.114.223 1.562.223.52 0 1.004-.056 1.45-.167.521-.112 1.023-.298 1.506-.556"
    },
    "children": []
  }]
};
exports.socialTumbler = socialTumbler;
var socialTwitterCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M15.279 10.283c.358-.221.597-.521.713-.904-.349.186-.697.312-1.045.383-.312-.336-.708-.507-1.182-.507-.464 0-.855.163-1.175.479-.317.318-.478.706-.478 1.158 0 .137.017.26.052.364-1.368-.048-2.499-.614-3.391-1.706-.151.267-.227.539-.227.82 0 .578.244 1.036.73 1.373-.277-.023-.521-.094-.73-.209 0 .413.121.758.365 1.062.243.3.557.492.939.573-.139.036-.285.053-.435.053-.14 0-.237-.012-.296-.037.104.337.296.609.574.818.277.21.597.32.957.33-.591.465-1.269.694-2.035.694-.188 0-.32-.002-.4-.017.754.489 1.594.733 2.521.733.951 0 1.792-.241 2.522-.723.73-.479 1.271-1.07 1.617-1.767.348-.695.521-1.419.521-2.174v-.209c.336-.253.609-.538.818-.854-.298.133-.611.222-.935.267zM12 21c-2.49 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.889-2.624-6.354 0-2.488.884-4.634 2.627-6.375 1.74-1.741 3.884-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.756 1.742 2.646 3.888 2.646 6.376 0 2.465-.889 4.604-2.644 6.357-1.751 1.753-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.375 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.942-2.057 1.385-1.384 2.058-3.002 2.058-4.943 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M15.279 10.283c.358-.221.597-.521.713-.904-.349.186-.697.312-1.045.383-.312-.336-.708-.507-1.182-.507-.464 0-.855.163-1.175.479-.317.318-.478.706-.478 1.158 0 .137.017.26.052.364-1.368-.048-2.499-.614-3.391-1.706-.151.267-.227.539-.227.82 0 .578.244 1.036.73 1.373-.277-.023-.521-.094-.73-.209 0 .413.121.758.365 1.062.243.3.557.492.939.573-.139.036-.285.053-.435.053-.14 0-.237-.012-.296-.037.104.337.296.609.574.818.277.21.597.32.957.33-.591.465-1.269.694-2.035.694-.188 0-.32-.002-.4-.017.754.489 1.594.733 2.521.733.951 0 1.792-.241 2.522-.723.73-.479 1.271-1.07 1.617-1.767.348-.695.521-1.419.521-2.174v-.209c.336-.253.609-.538.818-.854-.298.133-.611.222-.935.267zM12 21c-2.49 0-4.635-.89-6.376-2.646-1.741-1.751-2.624-3.889-2.624-6.354 0-2.488.884-4.634 2.627-6.375 1.74-1.741 3.884-2.625 6.373-2.625 2.466 0 4.604.883 6.354 2.624 1.756 1.742 2.646 3.888 2.646 6.376 0 2.465-.889 4.604-2.644 6.357-1.751 1.753-3.889 2.643-6.356 2.643zm0-16c-1.966 0-3.588.667-4.958 2.04-1.375 1.372-2.042 2.994-2.042 4.96 0 1.944.668 3.562 2.043 4.945 1.372 1.383 2.993 2.055 4.957 2.055 1.943 0 3.56-.673 4.942-2.057 1.385-1.384 2.058-3.002 2.058-4.943 0-1.963-.672-3.585-2.055-4.957-1.383-1.375-3-2.043-4.945-2.043z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialTwitterCircular = socialTwitterCircular;
var socialTwitter = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.89 7.012c.808-.496 1.343-1.173 1.605-2.034-.786.417-1.569.703-2.351.861-.703-.756-1.593-1.14-2.66-1.14-1.043 0-1.924.366-2.643 1.078-.715.717-1.076 1.588-1.076 2.605 0 .309.039.585.117.819-3.076-.105-5.622-1.381-7.628-3.837-.34.601-.51 1.213-.51 1.846 0 1.301.549 2.332 1.645 3.089-.625-.053-1.176-.211-1.645-.47 0 .929.273 1.705.82 2.388.549.676 1.254 1.107 2.115 1.291-.312.08-.641.118-.979.118-.312 0-.533-.026-.664-.083.23.757.664 1.371 1.291 1.841.625.472 1.344.721 2.152.743-1.332 1.045-2.855 1.562-4.578 1.562-.422 0-.721-.006-.902-.038 1.697 1.102 3.586 1.649 5.676 1.649 2.139 0 4.029-.542 5.674-1.626 1.645-1.078 2.859-2.408 3.639-3.974.784-1.564 1.172-3.192 1.172-4.892v-.468c.758-.57 1.371-1.212 1.84-1.921-.68.293-1.383.492-2.11.593z"
    },
    "children": []
  }]
};
exports.socialTwitter = socialTwitter;
var socialVimeoCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M14.463 9.141c-.512 0-.988.238-1.43.715-.311.312-.5.678-.566 1.101.207-.131.387-.196.541-.196.159 0 .29.07.393.212.199.278.188.629-.033 1.051-.489.934-.846 1.4-1.066 1.4-.156 0-.356-.522-.602-1.567-.043-.155-.088-.378-.133-.667-.045-.288-.088-.538-.133-.75-.045-.211-.111-.428-.2-.649s-.2-.384-.333-.483c-.094-.069-.202-.104-.327-.104l-.173.021c-.289.067-.623.245-1 .534-.379.288-.689.566-.934.833l-.334.4.301.399.166-.133c.066-.045.189-.101.367-.167l.191-.043c.069 0 .116.025.143.076.066.089.271.717.615 1.884.346 1.167.562 1.839.65 2.017.156.311.367.55.633.717.13.08.271.121.427.121.165 0 .346-.047.54-.139.601-.399 1.289-1.066 2.067-2 .778-.933 1.255-1.922 1.433-2.966.156-.911-.11-1.434-.799-1.567-.138-.035-.272-.05-.404-.05zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M14.463 9.141c-.512 0-.988.238-1.43.715-.311.312-.5.678-.566 1.101.207-.131.387-.196.541-.196.159 0 .29.07.393.212.199.278.188.629-.033 1.051-.489.934-.846 1.4-1.066 1.4-.156 0-.356-.522-.602-1.567-.043-.155-.088-.378-.133-.667-.045-.288-.088-.538-.133-.75-.045-.211-.111-.428-.2-.649s-.2-.384-.333-.483c-.094-.069-.202-.104-.327-.104l-.173.021c-.289.067-.623.245-1 .534-.379.288-.689.566-.934.833l-.334.4.301.399.166-.133c.066-.045.189-.101.367-.167l.191-.043c.069 0 .116.025.143.076.066.089.271.717.615 1.884.346 1.167.562 1.839.65 2.017.156.311.367.55.633.717.13.08.271.121.427.121.165 0 .346-.047.54-.139.601-.399 1.289-1.066 2.067-2 .778-.933 1.255-1.922 1.433-2.966.156-.911-.11-1.434-.799-1.567-.138-.035-.272-.05-.404-.05zM12 21c-4.963 0-9-4.037-9-9s4.037-9 9-9 9 4.037 9 9-4.037 9-9 9zm0-16c-3.859 0-7 3.141-7 7s3.141 7 7 7 7-3.141 7-7-3.141-7-7-7z"
        },
        "children": []
      }]
    }]
  }]
};
exports.socialVimeoCircular = socialVimeoCircular;
var socialVimeo = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18.92 8.776c-.329 1.929-1.211 3.758-2.649 5.48-1.436 1.725-2.71 2.957-3.819 3.695-.699.331-1.293.34-1.786.034-.493-.31-.883-.751-1.169-1.325-.165-.328-.565-1.569-1.202-3.728-.636-2.155-1.017-3.315-1.139-3.479-.083-.163-.288-.184-.616-.061-.33.122-.555.226-.678.309-.123.081-.226.165-.308.245l-.554-.737.616-.74c.452-.492 1.026-1.007 1.724-1.54.7-.534 1.314-.862 1.848-.987.371-.08.679-.028.924.156.247.184.452.484.616.894.165.409.289.811.369 1.199.083.392.165.854.248 1.387.081.534.164.945.246 1.232.451 1.93.821 2.896 1.109 2.896.41 0 1.067-.863 1.971-2.59.41-.779.432-1.426.062-1.941-.369-.512-.943-.522-1.724-.029.123-.78.472-1.456 1.046-2.031 1.026-1.109 2.157-1.521 3.388-1.234 1.273.247 1.765 1.213 1.477 2.895z"
    },
    "children": []
  }]
};
exports.socialVimeo = socialVimeo;
var socialYoutubeCircular = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "polygon",
    "attribs": {
      "points": "8.48,13.14 9.21,13.14 9.21,16.75 9.91,16.75 9.91,13.14 10.64,13.14 10.64,12.53 8.48,12.53 "
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M12.17,16c-0.12,0.14-0.53,0.42-0.53,0.02v-2.39h-0.62v2.61c0,0.79,0.79,0.58,1.16,0.17v0.34h0.62v-3.12h-0.62V16H12.17z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M14.48,13.61c-0.36,0-0.59,0.27-0.59,0.27v-1.36h-0.63v4.23h0.63v-0.24c0,0,0.21,0.28,0.59,0.28c0.33,0,0.58-0.29,0.58-0.69\r\n\tc0,0,0-1.26,0-1.73S14.84,13.61,14.48,13.61z M14.41,16.02c0,0.23-0.16,0.34-0.37,0.25c-0.05-0.02-0.1-0.06-0.15-0.11v-1.94\r\n\tc0.04-0.04,0.09-0.07,0.13-0.1c0.22-0.11,0.39,0.06,0.39,0.29L14.41,16.02L14.41,16.02z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M16.72,15.86c0,0.24-0.13,0.4-0.28,0.41c-0.16,0.01-0.32-0.12-0.32-0.41v-0.59h1.19v-0.8c0-0.29-0.11-0.51-0.26-0.66\r\n\tc-0.17-0.16-0.4-0.24-0.63-0.24c-0.22,0-0.45,0.07-0.63,0.21c-0.19,0.15-0.31,0.38-0.31,0.69v1.4c0,0.28,0.09,0.5,0.23,0.66\r\n\tc0.17,0.18,0.4,0.28,0.64,0.29c0.29,0.01,0.6-0.11,0.78-0.36c0.11-0.15,0.18-0.35,0.18-0.59v-0.16h-0.59\r\n\tC16.72,15.71,16.72,15.76,16.72,15.86z M16.12,14.47c0-0.17,0.1-0.37,0.29-0.37s0.31,0.18,0.31,0.37s0,0.32,0,0.32h-0.6\r\n\tC16.12,14.78,16.12,14.64,16.12,14.47z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M12.97,3c-4.97,0-9,4.03-9,9s4.03,9,9,9s9-4.03,9-9S17.94,3,12.97,3z M14.55,6.37h0.8v2.68c0,0.17,0.08,0.17,0.11,0.17\r\n\tc0.12,0,0.3-0.13,0.39-0.22V6.36h0.8V9.9h-0.8V9.59c-0.11,0.1-0.22,0.18-0.33,0.24c-0.15,0.08-0.29,0.11-0.43,0.11\r\n\tc-0.18,0-0.31-0.06-0.41-0.17c-0.09-0.11-0.13-0.28-0.13-0.49V6.37z M12,7.3c0-0.55,0.45-1,1-1s1,0.45,1,1V9c0,0.55-0.45,1-1,1\r\n\ts-1-0.45-1-1V7.3z M9.92,5.15l0.48,1.76l0.49-1.76h0.91l-0.94,2.78V9.9H9.97V7.93L9.01,5.15H9.92z M17.82,17.69\r\n\tc-0.51,0.5-4.83,0.51-4.83,0.51s-4.31-0.01-4.83-0.51c-0.51-0.5-0.51-2.99-0.51-3.01c0-0.01,0-2.5,0.51-3.01\r\n\tc0.51-0.5,4.83-0.51,4.83-0.51s4.31,0.01,4.83,0.51c0.51,0.5,0.52,2.99,0.52,3.01C18.34,14.68,18.34,17.18,17.82,17.69z"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M12.98,9.35c0.17,0,0.25-0.1,0.26-0.26v-1.9c0-0.13-0.13-0.24-0.25-0.24s-0.25,0.1-0.25,0.24v1.9\r\n\tC12.74,9.24,12.81,9.34,12.98,9.35z"
    },
    "children": []
  }]
};
exports.socialYoutubeCircular = socialYoutubeCircular;
var socialYoutube = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.8 8.6c-.2-1.5-.4-2.6-1-3-.6-.5-5.8-.6-9.8-.6s-9.2.1-9.8.6c-.6.4-.8 1.5-1 3s-.2 2.4-.2 3.4 0 1.9.2 3.4.4 2.6 1 3c.6.5 5.8.6 9.8.6 4 0 9.2-.1 9.8-.6.6-.4.8-1.5 1-3s.2-2.4.2-3.4 0-1.9-.2-3.4zm-12.8 7v-7.2l6 3.6-6 3.6z"
    },
    "children": []
  }]
};
exports.socialYoutube = socialYoutube;
var sortAlphabeticallyOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M5.618 14h2.764l-1.382-2.764zM21 14l2.4-3.2c.686-.915.795-2.119.284-3.142-.512-1.023-1.54-1.658-2.684-1.658h-6c-1.654 0-3 1.346-3 3 0 .77.295 1.469.774 2h-.274c-.368 0-.708.107-1.005.281l-1.811-3.623c-.498-.995-1.527-1.614-2.684-1.614s-2.186.619-2.684 1.614l-4 8c-.358.717-.416 1.53-.163 2.291s.788 1.376 1.504 1.735c.414.207.879.316 1.342.316 1.143 0 2.171-.635 2.684-1.657l.171-.343h2.291l.171.342c.512 1.023 1.54 1.658 2.684 1.658.464 0 .928-.109 1.342-.316.243-.122.455-.282.652-.458.54.488 1.246.774 2.006.774h6c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-9.553 3.895c-.143.071-.296.105-.446.105-.368 0-.721-.203-.896-.553l-.723-1.447h-4.764l-.724 1.447c-.175.35-.528.553-.895.553-.15 0-.303-.034-.446-.106-.494-.247-.694-.848-.447-1.342l4-8c.169-.338.532-.508.894-.508s.725.169.895.508l4 8c.247.495.046 1.095-.448 1.343zm1.053-3.895c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1h-1zm8.5 4h-6c-.379 0-.725-.214-.895-.553s-.132-.744.095-1.047l4.8-6.4h-4c-.552 0-1-.448-1-1s.448-1 1-1h6c.379 0 .725.214.895.553s.132.744-.095 1.047l-4.8 6.4h4c.552 0 1 .448 1 1s-.448 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M5.618 14h2.764l-1.382-2.764zM21 14l2.4-3.2c.686-.915.795-2.119.284-3.142-.512-1.023-1.54-1.658-2.684-1.658h-6c-1.654 0-3 1.346-3 3 0 .77.295 1.469.774 2h-.274c-.368 0-.708.107-1.005.281l-1.811-3.623c-.498-.995-1.527-1.614-2.684-1.614s-2.186.619-2.684 1.614l-4 8c-.358.717-.416 1.53-.163 2.291s.788 1.376 1.504 1.735c.414.207.879.316 1.342.316 1.143 0 2.171-.635 2.684-1.657l.171-.343h2.291l.171.342c.512 1.023 1.54 1.658 2.684 1.658.464 0 .928-.109 1.342-.316.243-.122.455-.282.652-.458.54.488 1.246.774 2.006.774h6c1.654 0 3-1.346 3-3s-1.346-3-3-3zm-9.553 3.895c-.143.071-.296.105-.446.105-.368 0-.721-.203-.896-.553l-.723-1.447h-4.764l-.724 1.447c-.175.35-.528.553-.895.553-.15 0-.303-.034-.446-.106-.494-.247-.694-.848-.447-1.342l4-8c.169-.338.532-.508.894-.508s.725.169.895.508l4 8c.247.495.046 1.095-.448 1.343zm1.053-3.895c-.552 0-1-.448-1-1s.448-1 1-1h1c.552 0 1 .448 1 1s-.448 1-1 1h-1zm8.5 4h-6c-.379 0-.725-.214-.895-.553s-.132-.744.095-1.047l4.8-6.4h-4c-.552 0-1-.448-1-1s.448-1 1-1h6c.379 0 .725.214.895.553s.132.744-.095 1.047l-4.8 6.4h4c.552 0 1 .448 1 1s-.448 1-1 1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.sortAlphabeticallyOutline = sortAlphabeticallyOutline;
var sortAlphabetically = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.895 16.553l-4-8c-.339-.678-1.45-.678-1.789 0l-4 8c-.247.494-.047 1.095.447 1.342.495.248 1.095.046 1.342-.447l.723-1.448h4.764l.724 1.447c.175.351.528.553.895.553.15 0 .303-.034.446-.105.494-.248.695-.848.448-1.342zm-6.277-2.553l1.382-2.764 1.382 2.764h-2.764zM22 18h-6c-.379 0-.725-.214-.895-.553s-.132-.744.095-1.047l4.8-6.4h-4c-.552 0-1-.448-1-1s.448-1 1-1h6c.379 0 .725.214.895.553s.132.744-.095 1.047l-4.8 6.4h4c.552 0 1 .448 1 1s-.448 1-1 1zM14 14h-2c-.552 0-1-.448-1-1s.448-1 1-1h2c.552 0 1 .448 1 1s-.448 1-1 1z"
    },
    "children": []
  }]
};
exports.sortAlphabetically = sortAlphabetically;
var sortNumericallyOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M23.292 12.134c.138-.445.208-.91.208-1.384 0-2.619-2.131-4.75-4.75-4.75-1.396 0-2.685.61-3.573 1.632l-.056-.067c-.973-.974-2.349-1.533-3.776-1.533-1.422 0-2.794.556-3.77 1.525-.264-.431-.644-.813-1.122-1.108-.474-.294-1.032-.449-1.613-.449-.482 0-.955.109-1.369.316l-1.406.747c-1.442.721-2.051 2.526-1.313 4.002.272.543.714.982 1.248 1.272v4.663c0 1.654 1.346 3 3 3 .766 0 1.458-.297 1.989-.771.54.487 1.25.771 2.011.771h5c.778 0 1.479-.305 2.01-.795.796.5 1.731.795 2.74.795 2.895 0 5.25-2.355 5.25-5.25 0-.922-.25-1.825-.708-2.616zm-17.292 4.866c0 .552-.448 1-1 1s-1-.448-1-1v-6.382c-.144.072-.306.106-.471.106-.401 0-.813-.203-.988-.553-.247-.494-.031-1.095.463-1.342l1.361-.724c.141-.07.307-.105.475-.105.199 0 .4.05.561.149.294.183.599.504.599.851v8zm8 1h-5c-.404 0-.769-.244-.924-.617-.155-.374-.069-.804.217-1.09l4-4c.254-.254.394-.591.394-.95 0-.358-.14-.695-.394-.949s-.601-.381-.949-.381-.696.127-.952.382c-.252.252-.392.589-.392.948 0 .552-.448 1-1 1s-1-.448-1-1c0-.894.348-1.733.98-2.364.632-.631 1.498-.947 2.364-.947s1.731.316 2.363.948c.632.631.979 1.471.979 2.363 0 .893-.348 1.733-.979 2.364l-2.293 2.293h2.586c.552 0 1 .448 1 1s-.448 1-1 1zm4.75 0c-1.792 0-3.25-1.458-3.25-3.25 0-.552.448-1 1-1s1 .448 1 1c0 .689.561 1.25 1.25 1.25s1.25-.561 1.25-1.25-.561-1.25-1.25-1.25c-.552 0-1-.448-1-1s.448-1 1-1c.414 0 .75-.336.75-.75s-.336-.75-.75-.75c-.281 0-.536.155-.665.404-.178.343-.527.54-.889.54-.155 0-.312-.036-.459-.112-.491-.254-.682-.857-.428-1.348.475-.915 1.41-1.484 2.441-1.484 1.516 0 2.75 1.233 2.75 2.75 0 .611-.207 1.17-.545 1.627.639.594 1.045 1.434 1.045 2.373 0 1.792-1.458 3.25-3.25 3.25z"
    },
    "children": []
  }]
};
exports.sortNumericallyOutline = sortNumericallyOutline;
var sortNumerically = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M4 18c-.552 0-1-.448-1-1v-6.382l-.553.276c-.495.248-1.095.046-1.342-.447-.247-.494-.046-1.094.448-1.342l2-1c.31-.155.678-.139.973.044.294.183.474.504.474.851v8c0 .552-.448 1-1 1zM13 18h-5c-.404 0-.769-.244-.924-.617-.155-.374-.069-.804.217-1.09l4-4c.254-.254.394-.591.394-.95 0-.358-.14-.695-.394-.949-.508-.508-1.39-.508-1.9.001-.253.252-.393.589-.393.948 0 .552-.448 1-1 1s-1-.448-1-1c0-.894.348-1.733.98-2.364 1.265-1.263 3.464-1.263 4.727.001.632.631.979 1.471.979 2.363 0 .893-.348 1.733-.979 2.364l-2.293 2.293h2.586c.552 0 1 .448 1 1s-.448 1-1 1zM20.955 12.377c.338-.457.545-1.016.545-1.627 0-1.517-1.234-2.75-2.75-2.75-1.031 0-1.966.569-2.44 1.484-.254.49-.063 1.094.428 1.348.49.254 1.094.062 1.348-.428.128-.249.383-.404.664-.404.414 0 .75.336.75.75s-.336.75-.75.75c-.552 0-1 .448-1 1s.448 1 1 1c.689 0 1.25.561 1.25 1.25s-.561 1.25-1.25 1.25-1.25-.561-1.25-1.25c0-.552-.448-1-1-1s-1 .448-1 1c0 1.792 1.458 3.25 3.25 3.25s3.25-1.458 3.25-3.25c0-.939-.406-1.779-1.045-2.373z"
    },
    "children": []
  }]
};
exports.sortNumerically = sortNumerically;
var spannerOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "circle",
      "attribs": {
        "cx": "8",
        "cy": "16",
        "r": "1"
      },
      "children": [{
        "name": "circle",
        "attribs": {
          "cx": "8",
          "cy": "16",
          "r": "1"
        },
        "children": []
      }]
    }, {
      "name": "path",
      "attribs": {
        "d": "M20.733 4.657c-.392-.378-1.013-.377-1.399.009.387-.386.388-1.008.01-1.4-1.078-.792-2.405-1.266-3.844-1.266-3.59 0-6.5 2.91-6.5 6.5l.031.379c-.337.239-2.893 2.147-4.258 3.301-1.135.99-1.773 2.375-1.773 3.82 0 2.757 2.243 5 5 5 1.465 0 2.854-.65 3.811-1.784 1.173-1.375 3.08-3.923 3.317-4.229l.372.013c3.59 0 6.5-2.91 6.5-6.5 0-1.44-.474-2.766-1.267-3.843zm-12.733 14.343c-1.656 0-3-1.343-3-3 0-.92.423-1.732 1.064-2.292 2.368-2.002 3.617-2.748 5.115-4.015-.105-.382-.179-.777-.179-1.193 0-2.485 2.015-4.5 4.5-4.5.47 0 .914.092 1.339.226l-2.839 2.774.5 2.5 2.5.5 2.805-2.741c.115.396.195.807.195 1.241 0 2.485-2.015 4.5-4.5 4.5-.416 0-.811-.074-1.193-.18-1.267 1.498-2.013 2.748-4.024 5.105-.551.652-1.363 1.075-2.283 1.075zm11.384-12.729l-2.705 2.645-1.329-.266-.263-1.314 2.726-2.663c.651.393 1.19.939 1.571 1.598z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M20.733 4.657c-.392-.378-1.013-.377-1.399.009.387-.386.388-1.008.01-1.4-1.078-.792-2.405-1.266-3.844-1.266-3.59 0-6.5 2.91-6.5 6.5l.031.379c-.337.239-2.893 2.147-4.258 3.301-1.135.99-1.773 2.375-1.773 3.82 0 2.757 2.243 5 5 5 1.465 0 2.854-.65 3.811-1.784 1.173-1.375 3.08-3.923 3.317-4.229l.372.013c3.59 0 6.5-2.91 6.5-6.5 0-1.44-.474-2.766-1.267-3.843zm-12.733 14.343c-1.656 0-3-1.343-3-3 0-.92.423-1.732 1.064-2.292 2.368-2.002 3.617-2.748 5.115-4.015-.105-.382-.179-.777-.179-1.193 0-2.485 2.015-4.5 4.5-4.5.47 0 .914.092 1.339.226l-2.839 2.774.5 2.5 2.5.5 2.805-2.741c.115.396.195.807.195 1.241 0 2.485-2.015 4.5-4.5 4.5-.416 0-.811-.074-1.193-.18-1.267 1.498-2.013 2.748-4.024 5.105-.551.652-1.363 1.075-2.283 1.075zm11.384-12.729l-2.705 2.645-1.329-.266-.263-1.314 2.726-2.663c.651.393 1.19.939 1.571 1.598z"
        },
        "children": []
      }]
    }]
  }]
};
exports.spannerOutline = spannerOutline;
var spanner = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.285 7.119c-.05-.168-.184-.299-.354-.344-.172-.047-.352.003-.477.126l-2.616 2.557-1.914-.383-.381-1.907 2.645-2.585c.126-.123.178-.303.137-.474s-.168-.308-.336-.361c-.531-.166-1.018-.248-1.489-.248-2.757 0-5 2.243-5 5 0 .323.038.65.118 1.01-.562.463-1.096.862-1.701 1.314-.865.646-1.845 1.377-3.182 2.506-.785.686-1.235 1.659-1.235 2.67 0 1.93 1.57 3.5 3.5 3.5 1.021 0 1.993-.456 2.662-1.25 1.149-1.347 1.891-2.336 2.544-3.209.442-.591.832-1.111 1.283-1.66.36.081.688.119 1.011.119 2.757 0 5-2.243 5-5 0-.437-.068-.875-.215-1.381zm-12.285 9.881c-.553 0-1-.447-1-1s.447-1 1-1 1 .447 1 1-.447 1-1 1z"
    },
    "children": []
  }]
};
exports.spanner = spanner;
var spiral = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 11.8c1-.4.7-1.8 0-2.4-1.1-.9-2.7-.4-3.4.8-1.5 2.4.9 5 3.4 4.9 2.7-.2 4.3-2.9 3.7-5.4-.7-3-3.9-4.5-6.7-3.6-2.6.8-4.2 3.5-4 6.2.3 3 2.6 5.4 5.5 5.9 2.8.5 5.7-.8 7.2-3.2.7-1.1 1.2-2.4 1.2-3.8 0-.5.5-1 1.1-.9.8 0 1 .8.9 1.4-.4 4.7-4.5 8.6-9.3 8.6-5.9 0-10.5-6.2-8-11.8 2.5-5.4 10.3-6.5 13.3-1.2 1.5 2.5 1.2 5.8-.9 7.9-2 2-5.3 2.4-7.7.7-2.2-1.6-2.9-4.9-1.1-7.2 1.7-2.3 5.5-2.4 7 .2 1.1 1.9 0 5.2-2.5 4.9-1.6 0-3-1.7-2.1-3.2.6-.9 1.9-.6 2.3.1.2.8.1 1.1.1 1.1z"
    },
    "children": []
  }]
};
exports.spiral = spiral;
var starFullOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.1 11.3l3.6 3.3-1 4.6c-.1.6.1 1.2.6 1.5.2.2.5.3.8.3.2 0 .4 0 .6-.1 0 0 .1 0 .1-.1l4.1-2.3 4.1 2.3s.1 0 .1.1c.5.2 1.1.2 1.5-.1.5-.3.7-.9.6-1.5l-1-4.6c.4-.3 1-.9 1.6-1.5l1.9-1.7.1-.1c.4-.4.5-1 .3-1.5s-.6-.9-1.2-1h-.1l-4.7-.5-1.9-4.3s0-.1-.1-.1c-.1-.7-.6-1-1.1-1-.5 0-1 .3-1.3.8 0 0 0 .1-.1.1l-1.9 4.3-4.7.5h-.1c-.5.1-1 .5-1.2 1-.1.6 0 1.2.4 1.6z"
    },
    "children": []
  }]
};
exports.starFullOutline = starFullOutline;
var starHalfOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M3.1 11.3l3.6 3.3-1 4.6c-.1.6.1 1.2.6 1.5.2.2.5.3.8.3.2 0 .4 0 .6-.1 0 0 .1 0 .1-.1l4.1-2.3 4.1 2.3s.1 0 .1.1c.5.2 1.1.2 1.5-.1.5-.3.7-.9.6-1.5l-1-4.6c.4-.3 1-.9 1.6-1.5l1.9-1.7.1-.1c.4-.4.5-1 .3-1.5s-.6-.9-1.2-1h-.1l-4.7-.5-1.9-4.3s0-.1-.1-.1c-.1-.7-.6-1-1.1-1-.5 0-1 .3-1.3.8 0 0 0 .1-.1.1l-1.9 4.3-4.7.5h-.1c-.5.1-1 .5-1.2 1-.1.6 0 1.2.4 1.6zm8.9 5v-10.5l1.7 3.8c.1.3.5.5.8.6l4.2.5-3.1 2.8c-.3.2-.4.6-.3 1 0 .2.5 2.2.8 4.1l-3.6-2.1c-.2-.2-.3-.2-.5-.2z"
    },
    "children": []
  }]
};
exports.starHalfOutline = starHalfOutline;
var starHalf = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.5 4.3c-.9 1.9-2.2 4.8-2.2 4.8s-3.1.4-5.2.6c-.2 0-.4.2-.4.3-.1.2 0 .4.1.5 1.6 1.4 3.9 3.6 3.9 3.6s-.6 3.1-1.1 5.2c0 .2 0 .4.2.5.2.2.4.2.6.1 1.8-1 4.6-2.6 4.6-2.6v-13.3c-.2 0-.4.2-.5.3z"
    },
    "children": []
  }]
};
exports.starHalf = starHalf;
var starOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.855 20.966c-.224 0-.443-.05-.646-.146l-.104-.051-4.107-2.343-4.107 2.344-.106.053c-.488.228-1.085.174-1.521-.143-.469-.34-.701-.933-.586-1.509l.957-4.642-1.602-1.457-1.895-1.725-.078-.082c-.375-.396-.509-.97-.34-1.492.173-.524.62-.912 1.16-1.009l.102-.018 4.701-.521 1.946-4.31.06-.11c.262-.473.764-.771 1.309-.771.543 0 1.044.298 1.309.77l.06.112 1.948 4.312 4.701.521.104.017c.539.1.986.486 1.158 1.012.17.521.035 1.098-.34 1.494l-.078.078-3.498 3.184.957 4.632c.113.587-.118 1.178-.59 1.519-.252.182-.556.281-.874.281zm-8.149-6.564c-.039.182-.466 2.246-.845 4.082l3.643-2.077c.307-.175.684-.175.99 0l3.643 2.075-.849-4.104c-.071-.346.045-.705.308-.942l3.1-2.822-4.168-.461c-.351-.039-.654-.26-.801-.584l-1.728-3.821-1.726 3.821c-.146.322-.45.543-.801.584l-4.168.461 3.1 2.822c.272.246.384.617.302.966z"
    },
    "children": []
  }]
};
exports.starOutline = starOutline;
var star = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9.362 9.158l-5.268.584c-.19.023-.358.15-.421.343s0 .394.14.521c1.566 1.429 3.919 3.569 3.919 3.569-.002 0-.646 3.113-1.074 5.19-.036.188.032.387.196.506.163.119.373.121.538.028 1.844-1.048 4.606-2.624 4.606-2.624l4.604 2.625c.168.092.378.09.541-.029.164-.119.232-.318.195-.505l-1.071-5.191 3.919-3.566c.14-.131.202-.332.14-.524s-.23-.319-.42-.341c-2.108-.236-5.269-.586-5.269-.586l-2.183-4.83c-.082-.173-.254-.294-.456-.294s-.375.122-.453.294l-2.183 4.83z"
    },
    "children": []
  }]
};
exports.star = star;
var starburstOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.556 11.169l-1.849-1.232.984-1.993c.148-.3.137-.654-.03-.943-.168-.29-.468-.477-.802-.498l-2.218-.143-.144-2.218c-.02-.334-.208-.635-.497-.802-.29-.167-.645-.18-.943-.03l-1.991.985-1.233-1.849c-.371-.557-1.293-.557-1.664 0l-1.234 1.848-1.992-.984c-.299-.15-.654-.137-.943.03-.29.167-.477.468-.498.802l-.143 2.217-2.218.143c-.334.022-.635.209-.802.498s-.179.644-.03.943l.984 1.993-1.849 1.233c-.278.186-.445.498-.445.832s.167.646.445.832l1.85 1.233-.985 1.992c-.148.3-.137.654.03.943s.468.477.802.498l2.218.143.143 2.218c.021.333.208.634.498.801s.642.179.943.031l1.992-.985 1.233 1.849c.186.278.498.445.832.445s.646-.167.832-.445l1.233-1.849 1.991.985c.299.148.653.136.943-.03.29-.167.477-.468.498-.802l.143-2.217 2.219-.144c.334-.021.635-.208.802-.498s.179-.644.03-.943l-.984-1.992 1.849-1.233c.278-.186.445-.498.445-.832 0-.334-.167-.647-.445-.832zm-4.032 2.997l.71 1.435-1.6.104c-.502.033-.901.432-.934.934l-.103 1.598-1.435-.709c-.45-.224-.996-.077-1.275.342l-.887 1.33-.889-1.333c-.191-.287-.508-.445-.833-.445-.149 0-.3.033-.442.104l-1.436.709-.103-1.598c-.032-.501-.432-.901-.934-.934l-1.596-.103.71-1.435c.223-.451.076-.997-.342-1.275l-1.333-.889 1.332-.888c.418-.279.564-.825.342-1.275l-.71-1.436 1.6-.103c.502-.033.901-.432.934-.934l.103-1.598 1.435.709c.448.221.996.076 1.275-.342l.887-1.331.889 1.333c.279.418.826.563 1.275.342l1.436-.71.104 1.599c.033.501.433.9.934.933l1.598.103-.709 1.437c-.223.451-.076.996.342 1.275l1.332.888-1.333.889c-.42.277-.566.823-.344 1.274z"
    },
    "children": []
  }]
};
exports.starburstOutline = starburstOutline;
var starburst = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.064 10.109l1.179-2.387c.074-.149.068-.327-.015-.471-.083-.145-.234-.238-.401-.249l-2.656-.172-.172-2.656c-.011-.167-.104-.317-.249-.401-.145-.084-.322-.09-.472-.015l-2.385 1.18-1.477-2.215c-.186-.278-.646-.278-.832 0l-1.477 2.215-2.385-1.18c-.151-.075-.327-.069-.472.015-.145.083-.238.234-.249.401l-.171 2.656-2.657.171c-.167.011-.318.104-.401.249-.084.145-.089.322-.015.472l1.179 2.386-2.214 1.477c-.139.093-.223.249-.223.416s.083.323.223.416l2.215 1.477-1.18 2.386c-.074.15-.068.327.015.472.083.144.234.238.401.248l2.656.171.171 2.657c.011.167.104.317.249.401.144.083.32.088.472.015l2.386-1.179 1.477 2.214c.093.139.249.223.416.223s.323-.083.416-.223l1.477-2.214 2.386 1.179c.15.073.327.068.472-.015s.238-.234.249-.401l.171-2.656 2.656-.172c.167-.011.317-.104.401-.249.083-.145.089-.322.015-.472l-1.179-2.385 2.214-1.478c.139-.093.223-.249.223-.416s-.083-.323-.223-.416l-2.214-1.475z"
    },
    "children": []
  }]
};
exports.starburst = starburst;
var stopwatch = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M19.414 8.902c.104-.048.206-.108.293-.195l.5-.5c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-.5.5-.115.173c-1.387-1.312-3.188-2.19-5.189-2.41l.011-.056v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1h1v1l.012.057c-4.506.492-8.012 4.307-8.012 8.943 0 4.971 4.029 9 9 9s9-4.029 9-9c0-1.894-.588-3.648-1.586-5.098zm-7.414 12.098c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zM13 13v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2zM12 8c-3.312 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm0 11c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M19.414 8.902c.104-.048.206-.108.293-.195l.5-.5c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-.5.5-.115.173c-1.387-1.312-3.188-2.19-5.189-2.41l.011-.056v-1h1c.55 0 1-.45 1-1s-.45-1-1-1h-4c-.55 0-1 .45-1 1s.45 1 1 1h1v1l.012.057c-4.506.492-8.012 4.307-8.012 8.943 0 4.971 4.029 9 9 9s9-4.029 9-9c0-1.894-.588-3.648-1.586-5.098zm-7.414 12.098c-3.859 0-7-3.14-7-7s3.141-7 7-7 7 3.14 7 7-3.141 7-7 7zM13 13v-2c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1h3c.55 0 1-.45 1-1s-.45-1-1-1h-2zM12 8c-3.312 0-6 2.688-6 6s2.688 6 6 6 6-2.688 6-6-2.688-6-6-6zm0 11c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.stopwatch = stopwatch;
var support = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 3.5c-4.688 0-8.5 3.812-8.5 8.5s3.812 8.5 8.5 8.5 8.5-3.812 8.5-8.5-3.812-8.5-8.5-8.5zm6.5 8.5c0 1.064-.264 2.066-.718 2.956l-1.931-1.931c.088-.332.147-.674.147-1.025 0-.355-.062-.693-.147-1.021l1.932-1.932c.455.889.717 1.891.717 2.953zm-13 0c0-1.064.264-2.066.718-2.956l1.933 1.933c-.086.33-.147.668-.147 1.022 0 .353.062.69.147 1.021l-1.934 1.934c-.455-.89-.717-1.892-.717-2.954zm3.068-2.02l-1.775-1.775 1.414-1.414 1.775 1.775c-.584.345-1.068.83-1.414 1.414zm-1.777 5.813l1.773-1.773c.17.289.362.564.605.809s.52.438.807.607l-1.771 1.771-1.414-1.414zm3.795-2.379c-.377-.378-.585-.88-.584-1.414 0-1.104.896-2 1.998-2 1.104 0 2 .896 2 2.001.001.533-.207 1.035-.584 1.412-.755.757-2.073.757-2.83.001zm6.623-5.207l-1.775 1.775c-.345-.586-.828-1.069-1.412-1.416l1.773-1.773 1.414 1.414zm-2.378 6.619c.241-.242.435-.518.604-.803l1.771 1.771-1.414 1.414-1.772-1.772c.291-.17.567-.366.811-.61zm.125-8.608l-1.933 1.932c-.328-.088-.668-.15-1.023-.15s-.693.062-1.021.148l-1.932-1.932c.889-.455 1.891-.717 2.953-.717 1.064.001 2.066.265 2.956.719zm-5.912 11.564l1.933-1.933c.332.088.672.149 1.023.149s.691-.062 1.021-.147l1.932 1.932c-.889.455-1.891.717-2.953.717-1.064 0-2.066-.264-2.956-.718z"
    },
    "children": []
  }]
};
exports.support = support;
var tabsOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 4h-10c-1.104 0-2 .896-2 2v2h-1c-1.104 0-2 .896-2 2v9c0 1.104.896 2 2 2h9c1.104 0 2-.896 2-2v-1h2c1.104 0 2-.896 2-2v-10c0-1.104-.896-2-2-2zm-13 15v-9h8.5c.275 0 .5.225.5.5v8.5h-9zm13-3h-3v-5.5c0-.827-.673-1.5-1.5-1.5h-5.5v-3h10v10z"
    },
    "children": []
  }]
};
exports.tabsOutline = tabsOutline;
var tag = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 4c1.279 0 2.559.488 3.535 1.465l3.465 3.535 5 5-7 7-5.498-5.498c-.037.033-3.037-2.967-3.037-2.967-1.953-1.953-1.953-5.119 0-7.07.976-.977 2.256-1.465 3.535-1.465m0-2c-1.87 0-3.628.729-4.949 2.051-1.322 1.32-2.051 3.078-2.051 4.948s.729 3.628 2.051 4.95l3 3c.107.107.227.201.35.279l5.187 5.186c.391.391.9.586 1.413.586s1.022-.195 1.414-.586l7-7c.78-.781.78-2.047 0-2.828l-5-5-3.45-3.521c-1.337-1.336-3.095-2.065-4.965-2.065zM9 7.498c.829 0 1.5.672 1.5 1.502s-.671 1.498-1.5 1.498-1.5-.668-1.5-1.498.671-1.502 1.5-1.502m0-1c-1.379 0-2.5 1.122-2.5 2.502 0 1.377 1.121 2.498 2.5 2.498s2.5-1.121 2.5-2.498c0-1.38-1.121-2.502-2.5-2.502z"
    },
    "children": []
  }]
};
exports.tag = tag;
var tags = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M21.422 9.594l-6.465-6.535c-1.329-1.33-3.087-2.059-4.957-2.059s-3.628.729-4.95 2.051c-1.416 1.414-2.127 3.356-2.027 5.314-.662 1.085-1.023 2.33-1.023 3.634 0 1.87.729 3.628 2.051 4.95l3.053 2.984 3.482 3.48c.391.392.902.587 1.414.587s1.023-.195 1.414-.586l7-7c.778-.778.782-2.038.008-2.82l-.093-.094 1.085-1.086c.778-.778.782-2.038.008-2.82zm-9.422 12.406l-3.498-3.497-3.037-2.968c-1.953-1.953-1.953-5.119 0-7.07.976-.977 2.256-1.465 3.535-1.465s2.559.488 3.535 1.465l6.465 6.535-7 7zm1.957-14.941c-1.329-1.33-3.087-2.059-4.957-2.059-1.276 0-2.497.347-3.565.982.241-.55.579-1.067 1.03-1.518.976-.976 2.256-1.464 3.535-1.464s2.559.488 3.535 1.465l6.465 6.535-1.078 1.078-4.965-5.019zM9 10.499c.83 0 1.5.672 1.5 1.501 0 .83-.67 1.499-1.5 1.499s-1.5-.669-1.5-1.499c0-.829.67-1.501 1.5-1.501m0-1c-1.378 0-2.5 1.122-2.5 2.501 0 1.378 1.122 2.499 2.5 2.499s2.5-1.121 2.5-2.499c0-1.379-1.122-2.501-2.5-2.501z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M21.422 9.594l-6.465-6.535c-1.329-1.33-3.087-2.059-4.957-2.059s-3.628.729-4.95 2.051c-1.416 1.414-2.127 3.356-2.027 5.314-.662 1.085-1.023 2.33-1.023 3.634 0 1.87.729 3.628 2.051 4.95l3.053 2.984 3.482 3.48c.391.392.902.587 1.414.587s1.023-.195 1.414-.586l7-7c.778-.778.782-2.038.008-2.82l-.093-.094 1.085-1.086c.778-.778.782-2.038.008-2.82zm-9.422 12.406l-3.498-3.497-3.037-2.968c-1.953-1.953-1.953-5.119 0-7.07.976-.977 2.256-1.465 3.535-1.465s2.559.488 3.535 1.465l6.465 6.535-7 7zm1.957-14.941c-1.329-1.33-3.087-2.059-4.957-2.059-1.276 0-2.497.347-3.565.982.241-.55.579-1.067 1.03-1.518.976-.976 2.256-1.464 3.535-1.464s2.559.488 3.535 1.465l6.465 6.535-1.078 1.078-4.965-5.019zM9 10.499c.83 0 1.5.672 1.5 1.501 0 .83-.67 1.499-1.5 1.499s-1.5-.669-1.5-1.499c0-.829.67-1.501 1.5-1.501m0-1c-1.378 0-2.5 1.122-2.5 2.501 0 1.378 1.122 2.499 2.5 2.499s2.5-1.121 2.5-2.499c0-1.379-1.122-2.501-2.5-2.501z"
        },
        "children": []
      }]
    }]
  }]
};
exports.tags = tags;
var thLargeOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 2h-5c-1.103 0-2 .896-2 2v5c0 1.104.897 2 2 2h5c1.103 0 2-.896 2-2v-5c0-1.104-.897-2-2-2zm0 7h-5v-5h5v5zM20 2h-5c-1.104 0-2 .896-2 2v5c0 1.104.896 2 2 2h5c1.104 0 2-.896 2-2v-5c0-1.104-.896-2-2-2zm0 7h-5v-5h5v5zM9 13h-5c-1.103 0-2 .896-2 2v5c0 1.104.897 2 2 2h5c1.103 0 2-.896 2-2v-5c0-1.104-.897-2-2-2zm0 7h-5v-5h5v5zM20 13h-5c-1.104 0-2 .896-2 2v5c0 1.104.896 2 2 2h5c1.104 0 2-.896 2-2v-5c0-1.104-.896-2-2-2zm0 7h-5v-5h5v5z"
    },
    "children": []
  }]
};
exports.thLargeOutline = thLargeOutline;
var thLarge = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M8 3h-2c-.825 0-1.575.337-2.119.881-.544.544-.881 1.294-.881 2.119v2c0 .825.337 1.575.881 2.119.544.544 1.294.881 2.119.881h2c.825 0 1.575-.337 2.119-.881.544-.544.881-1.294.881-2.119v-2c0-.825-.337-1.575-.881-2.119-.544-.544-1.294-.881-2.119-.881zM18 3h-2c-.825 0-1.575.337-2.119.881-.544.544-.881 1.294-.881 2.119v2c0 .825.337 1.575.881 2.119.544.544 1.294.881 2.119.881h2c.825 0 1.575-.337 2.119-.881.544-.544.881-1.294.881-2.119v-2c0-.825-.337-1.575-.881-2.119-.544-.544-1.294-.881-2.119-.881zM8 13h-2c-.825 0-1.575.337-2.119.881-.544.544-.881 1.294-.881 2.119v2c0 .825.337 1.575.881 2.119.544.544 1.294.881 2.119.881h2c.825 0 1.575-.337 2.119-.881.544-.544.881-1.294.881-2.119v-2c0-.825-.337-1.575-.881-2.119-.544-.544-1.294-.881-2.119-.881zM18 13h-2c-.825 0-1.575.337-2.119.881-.544.544-.881 1.294-.881 2.119v2c0 .825.337 1.575.881 2.119.544.544 1.294.881 2.119.881h2c.825 0 1.575-.337 2.119-.881.544-.544.881-1.294.881-2.119v-2c0-.825-.337-1.575-.881-2.119-.544-.544-1.294-.881-2.119-.881z"
    },
    "children": []
  }]
};
exports.thLarge = thLarge;
var thListOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 18c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7m0-2h-7c-1.654 0-3 1.346-3 3s1.346 3 3 3h7c1.654 0 3-1.346 3-3s-1.346-3-3-3zM19 11c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7m0-2h-7c-1.654 0-3 1.346-3 3s1.346 3 3 3h7c1.654 0 3-1.346 3-3s-1.346-3-3-3zM19 4c.55 0 1 .45 1 1s-.45 1-1 1h-7c-.55 0-1-.45-1-1s.45-1 1-1h7m0-2h-7c-1.654 0-3 1.346-3 3s1.346 3 3 3h7c1.654 0 3-1.346 3-3s-1.346-3-3-3zM6 16h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM6 9h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM6 2h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2z"
    },
    "children": []
  }]
};
exports.thListOutline = thListOutline;
var thList = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 17h-7c-1.103 0-2 .897-2 2s.897 2 2 2h7c1.103 0 2-.897 2-2s-.897-2-2-2zM19 10h-7c-1.103 0-2 .897-2 2s.897 2 2 2h7c1.103 0 2-.897 2-2s-.897-2-2-2zM19 3h-7c-1.103 0-2 .897-2 2s.897 2 2 2h7c1.103 0 2-.897 2-2s-.897-2-2-2z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "19",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "12",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "5",
      "r": "2.5"
    },
    "children": []
  }]
};
exports.thList = thList;
var thMenuOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 18c.55 0 1 .45 1 1s-.45 1-1 1h-14c-.55 0-1-.45-1-1s.45-1 1-1h14m0-2h-14c-1.654 0-3 1.346-3 3s1.346 3 3 3h14c1.654 0 3-1.346 3-3s-1.346-3-3-3zM19 11c.55 0 1 .45 1 1s-.45 1-1 1h-14c-.55 0-1-.45-1-1s.45-1 1-1h14m0-2h-14c-1.654 0-3 1.346-3 3s1.346 3 3 3h14c1.654 0 3-1.346 3-3s-1.346-3-3-3zM19 4c.55 0 1 .45 1 1s-.45 1-1 1h-14c-.55 0-1-.45-1-1s.45-1 1-1h14m0-2h-14c-1.654 0-3 1.346-3 3s1.346 3 3 3h14c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
    },
    "children": []
  }]
};
exports.thMenuOutline = thMenuOutline;
var thMenu = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 17h-14c-1.103 0-2 .897-2 2s.897 2 2 2h14c1.103 0 2-.897 2-2s-.897-2-2-2zM19 10h-14c-1.103 0-2 .897-2 2s.897 2 2 2h14c1.103 0 2-.897 2-2s-.897-2-2-2zM19 3h-14c-1.103 0-2 .897-2 2s.897 2 2 2h14c1.103 0 2-.897 2-2s-.897-2-2-2z"
    },
    "children": []
  }]
};
exports.thMenu = thMenu;
var thSmallOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M6 16h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM6 9h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM6 2h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM13 16h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM13 9h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM13 2h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM20 16h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM20 9h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2zM20 2h-2c-1.104 0-2 .896-2 2v2c0 1.104.896 2 2 2h2c1.104 0 2-.896 2-2v-2c0-1.104-.896-2-2-2zm0 4h-2v-2h2v2z"
    },
    "children": []
  }]
};
exports.thSmallOutline = thSmallOutline;
var thSmall = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "19",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "12",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "5",
      "cy": "5",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "19",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "12",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "5",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "19",
      "cy": "19",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "19",
      "cy": "12",
      "r": "2.5"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "19",
      "cy": "5",
      "r": "2.5"
    },
    "children": []
  }]
};
exports.thSmall = thSmall;
var thermometer = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M13 15.071v-5.571c0-.275-.225-.5-.5-.5s-.5.225-.5.5v5.571c-.86.224-1.5 1-1.5 1.929 0 1.103.896 2 2 2s2-.897 2-2c0-.929-.64-1.705-1.5-1.929zM16 13.459v-7.959c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v7.959c-.922.902-1.5 2.151-1.5 3.541 0 2.757 2.243 5 5 5s5-2.243 5-5c0-1.39-.578-2.639-1.5-3.541zm-3.5 6.541c-1.654 0-3-1.346-3-3 0-1.105.607-2.062 1.5-2.583v-8.917c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v8.917c.893.521 1.5 1.478 1.5 2.583 0 1.654-1.346 3-3 3z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M13 15.071v-5.571c0-.275-.225-.5-.5-.5s-.5.225-.5.5v5.571c-.86.224-1.5 1-1.5 1.929 0 1.103.896 2 2 2s2-.897 2-2c0-.929-.64-1.705-1.5-1.929zM16 13.459v-7.959c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5v7.959c-.922.902-1.5 2.151-1.5 3.541 0 2.757 2.243 5 5 5s5-2.243 5-5c0-1.39-.578-2.639-1.5-3.541zm-3.5 6.541c-1.654 0-3-1.346-3-3 0-1.105.607-2.062 1.5-2.583v-8.917c0-.827.673-1.5 1.5-1.5s1.5.673 1.5 1.5v8.917c.893.521 1.5 1.478 1.5 2.583 0 1.654-1.346 3-3 3z"
        },
        "children": []
      }]
    }]
  }]
};
exports.thermometer = thermometer;
var thumbsDown = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 5c-.755 0-1.438.289-1.965.751l-.188-.192c-.96-.737-3.665-1.559-5.847-1.559-1.879 0-2.607.293-3.252.552l-.316.124c-.834.305-1.578 1.229-1.738 2.2l-.664 5.972c-.174 1.039.441 2.127 1.4 2.478.394.144 2.512.405 3.883.56-.215 1.256-.312 2.405-.312 3.616 0 1.379 1.121 2.5 2.5 2.5s2.5-1.121 2.5-2.5c0-1.875.667-2.737 1.616-3.699.548.724 1.408 1.199 2.384 1.199 1.653 0 2.999-1.347 2.999-3v-6c-.001-1.656-1.346-3.002-3-3.002zm-6 14.5c0 .275-.225.5-.5.5s-.5-.225-.5-.5c0-1.805.256-3.241.479-4.293l.297-1.398-1.321.188c-.605-.05-3.934-.447-4.335-.552-.058-.028-.132-.18-.108-.321l.663-5.976c.037-.223.291-.539.443-.594l.377-.146c.544-.219 1.015-.408 2.506-.408 1.914 0 4.118.753 4.633 1.146.156.12.366.564.366.854v4.977c-.001.026-.04.649-.707 1.316-.913.913-2.293 2.293-2.293 5.207zm7-5.5c0 .552-.448 1-1 1s-1-.448-1-1v-6c0-.552.448-1 1-1s1 .448 1 1v6z"
    },
    "children": []
  }]
};
exports.thumbsDown = thumbsDown;
var thumbsOk = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.7 12.6c-.1-.3-.2-.6-.4-.9.3-.6.5-1 .3-1.9-.2-.8-.8-1.7-1.6-2.5l-1.7-.9.8-1.8c.4-.8.4-1.8-.1-2.5-.5-.8-1.4-1.3-2.3-1.3-1 0-1.8.6-2.3 1.5 0 0-.8-.2-1.8.1l-1.3 1.2s-1.7.5-2 2-.4 3.4-.8 4.1-2.5 3.3-3.7 4.7c-.9 1.1-.7 2.3.1 3.2l5 5c.8.8 2.7 1.1 4-.3 1.4-1.4.5-3.3.5-3.3.4-.3 1.5-1.2 2.6-1.5s2.8-.9 3.7-2.1c.8-1 1.2-1.8 1-2.8zm-9.3 8.3c-.4.4-1 .4-1.4 0l-4.2-4.2c-.2-.2-.3-.4-.3-.7s.1-.5.3-.7l.7-.7 4.9 4.9c.2.2.3.4.3.7 0 .3-.1.5-.3.7zm6.6-9.9c-.5 0-.7-.5-1.1-.9s-1.3-.5-2-.2-1 1-1 1.7c0 1 .7 1.9 1.7 1.9.7 0 .9-.1 1.3-.3.6-.4.8-.8 1.2-.8s.7.2.7.8-.6 1.3-1.2 1.7-1.1.5-1.7.6c-.6.1-1 .1-1.8.6-.7.4-1.4.9-1.8 1.3l-4.6-4.6c.9-1.1 1.7-2.3 1.8-2.9l.7-3.9c.1-.4.4-.5.6-.5.3 0 .6.2.7.4l.4-1.3c.1-.3.4-.5.6-.5.4 0 .8.3.7.8l-.5 2.4c.6-1.2 1.5-2.7 2.1-3.8.2-.3.4-.6.9-.6s.9.6.7 1.1c-.2.4-2 3.5-2.8 4.8-.1.1 0 .2.2.1.3-.2 1-.7 1.7-.7 1.2-.1 1.8.4 2.1.6.4.3.8.8 1.1 1.3.2.5-.2.9-.7.9zm-.2.7c-.4 0-.7.1-.9.4s-.6.7-1.1.7c-.7 0-1.1-.5-1.1-1.1s.4-1 1.1-1c.5 0 .9.4 1.1.7s.5.3.9.3z"
    },
    "children": []
  }]
};
exports.thumbsOk = thumbsOk;
var thumbsUp = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.57 8.676c-.391-.144-2.512-.406-3.883-.56.215-1.255.313-2.405.313-3.616 0-1.379-1.122-2.5-2.5-2.5s-2.5 1.121-2.5 2.5c0 1.875-.666 2.738-1.616 3.699-.548-.722-1.407-1.199-2.384-1.199-1.654 0-3 1.346-3 3v6c0 1.654 1.346 3 3 3 .755 0 1.438-.29 1.965-.752l.188.193c.96.736 3.667 1.559 5.848 1.559 1.879 0 2.608-.293 3.253-.553l.316-.123c.834-.305 1.576-1.227 1.736-2.2l.666-5.974c.173-1.037-.443-2.125-1.402-2.474zm-12.57 8.324c-.551 0-1-.448-1-1v-6c0-.552.449-1 1-1s1 .448 1 1v6c0 .552-.449 1-1 1zm11.327-.15c-.037.224-.292.541-.443.596l-.376.146c-.545.219-1.016.408-2.508.408-1.914 0-4.118-.753-4.632-1.146-.158-.12-.368-.564-.368-.854v-4.98c.003-.047.051-.656.707-1.312.913-.914 2.293-2.294 2.293-5.208 0-.275.225-.5.5-.5s.5.225.5.5c0 1.407-.146 2.73-.479 4.293l-.297 1.396 1.321-.188c.603.05 3.933.447 4.334.55.058.03.132.183.111.323l-.663 5.976z"
    },
    "children": []
  }]
};
exports.thumbsUp = thumbsUp;
var tickOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11 20c-.801 0-1.555-.312-2.121-.879l-4-4c-.567-.566-.879-1.32-.879-2.121s.312-1.555.879-2.122c1.133-1.133 3.109-1.133 4.242 0l1.188 1.188 3.069-5.523c.526-.952 1.533-1.544 2.624-1.544.507 0 1.012.131 1.456.378.7.39 1.206 1.028 1.427 1.798.221.771.127 1.581-.263 2.282l-5 9c-.454.818-1.279 1.384-2.206 1.514-.139.019-.277.029-.416.029zm-4-8c-.268 0-.518.104-.707.293s-.293.439-.293.707.104.518.293.707l4 4c.223.221.523.33.844.283.312-.043.586-.232.737-.504l5-9c.13-.233.161-.503.088-.76-.073-.257-.243-.47-.478-.6-.473-.264-1.101-.078-1.357.388l-4.357 7.841-3.062-3.062c-.19-.189-.44-.293-.708-.293z"
    },
    "children": []
  }]
};
exports.tickOutline = tickOutline;
var tick = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16.972 6.251c-.967-.538-2.185-.188-2.72.777l-3.713 6.682-2.125-2.125c-.781-.781-2.047-.781-2.828 0-.781.781-.781 2.047 0 2.828l4 4c.378.379.888.587 1.414.587l.277-.02c.621-.087 1.166-.46 1.471-1.009l5-9c.537-.966.189-2.183-.776-2.72z"
    },
    "children": []
  }]
};
exports.tick = tick;
var ticket = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M21.485 8.071l-5.364-5.364c-1.128-1.128-3.111-1.136-4.248-.018l-9.148 9.002c-.571.562-.887 1.313-.891 2.115-.003.803.307 1.556.873 2.121l5.365 5.365c.567.567 1.325.88 2.133.88.799 0 1.551-.307 2.115-.862l9.147-9.003c.571-.562.888-1.313.891-2.115.003-.802-.307-1.555-.873-2.121zm-1.421 2.811l-9.146 9.003c-.381.373-1.056.37-1.432-.006l-1.275-1.275c.71-.785.693-1.994-.062-2.752-.758-.757-1.968-.773-2.752-.063l-1.275-1.274c-.186-.187-.288-.435-.287-.699s.105-.513.293-.697l9.148-9.002c.189-.186.441-.288.713-.288.273 0 .529.104.719.294l1.275 1.275c-.711.785-.694 1.994.062 2.751.758.757 1.967.773 2.752.063l1.274 1.274c.187.187.288.435.287.699s-.105.512-.294.697zM11.601 17.042l-4.657-4.656 5.649-5.429 4.657 4.656-5.649 5.429zm-3.23-4.643l3.243 3.242 4.206-4.041-3.241-3.242-4.208 4.041z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M21.485 8.071l-5.364-5.364c-1.128-1.128-3.111-1.136-4.248-.018l-9.148 9.002c-.571.562-.887 1.313-.891 2.115-.003.803.307 1.556.873 2.121l5.365 5.365c.567.567 1.325.88 2.133.88.799 0 1.551-.307 2.115-.862l9.147-9.003c.571-.562.888-1.313.891-2.115.003-.802-.307-1.555-.873-2.121zm-1.421 2.811l-9.146 9.003c-.381.373-1.056.37-1.432-.006l-1.275-1.275c.71-.785.693-1.994-.062-2.752-.758-.757-1.968-.773-2.752-.063l-1.275-1.274c-.186-.187-.288-.435-.287-.699s.105-.513.293-.697l9.148-9.002c.189-.186.441-.288.713-.288.273 0 .529.104.719.294l1.275 1.275c-.711.785-.694 1.994.062 2.751.758.757 1.967.773 2.752.063l1.274 1.274c.187.187.288.435.287.699s-.105.512-.294.697zM11.601 17.042l-4.657-4.656 5.649-5.429 4.657 4.656-5.649 5.429zm-3.23-4.643l3.243 3.242 4.206-4.041-3.241-3.242-4.208 4.041z"
        },
        "children": []
      }]
    }]
  }]
};
exports.ticket = ticket;
var time = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 13c0-.55-.45-1-1-1h-3c-.55 0-1 .45-1 1s.45 1 1 1h3c.55 0 1-.45 1-1zM12 6c3.859 0 7 3.141 7 7s-3.141 7-7 7-7-3.141-7-7 3.141-7 7-7m0-2c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zM13 10c0-.55-.45-1-1-1s-1 .45-1 1v3c0 .55.45 1 1 1s1-.45 1-1v-3zM12 8c2.757 0 5 2.243 5 5s-2.243 5-5 5-5-2.243-5-5 2.243-5 5-5m0-1c-3.312 0-6 2.686-6 6 0 3.312 2.688 6 6 6s6-2.688 6-6c0-3.314-2.688-6-6-6z"
    },
    "children": []
  }]
};
exports.time = time;
var timesOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M16 19c-.802 0-1.555-.312-2.122-.879l-1.878-1.879-1.879 1.879c-1.133 1.133-3.109 1.133-4.243 0-.566-.566-.878-1.32-.878-2.121s.312-1.555.879-2.122l1.878-1.878-1.878-1.879c-.567-.566-.879-1.32-.879-2.121s.312-1.555.879-2.122c1.133-1.132 3.109-1.133 4.243.001l1.878 1.879 1.879-1.879c1.133-1.133 3.109-1.133 4.243 0 .566.566.878 1.32.878 2.121s-.312 1.555-.879 2.122l-1.878 1.878 1.878 1.879c.567.566.879 1.32.879 2.121s-.312 1.555-.879 2.122c-.566.566-1.319.878-2.121.878zm-4-5.586l3.293 3.293c.378.378 1.037.377 1.414 0 .189-.189.293-.439.293-.707s-.104-.518-.293-.707l-3.292-3.293 3.292-3.293c.189-.189.293-.44.293-.707s-.104-.518-.293-.707c-.378-.379-1.037-.378-1.414-.001l-3.293 3.294-3.293-3.293c-.378-.378-1.037-.377-1.414 0-.189.189-.293.44-.293.707s.104.518.293.707l3.292 3.293-3.292 3.293c-.189.189-.293.439-.293.707s.104.518.293.707c.378.379 1.037.378 1.414.001l3.293-3.294z"
    },
    "children": []
  }]
};
exports.timesOutline = timesOutline;
var times = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.414 6.586c-.78-.781-2.048-.781-2.828 0l-2.586 2.586-2.586-2.586c-.78-.781-2.048-.781-2.828 0-.781.781-.781 2.047 0 2.828l2.585 2.586-2.585 2.586c-.781.781-.781 2.047 0 2.828.39.391.902.586 1.414.586s1.024-.195 1.414-.586l2.586-2.586 2.586 2.586c.39.391.902.586 1.414.586s1.024-.195 1.414-.586c.781-.781.781-2.047 0-2.828l-2.585-2.586 2.585-2.586c.781-.781.781-2.047 0-2.828z"
    },
    "children": []
  }]
};
exports.times = times;
var trash = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M18 7h-1v-1c0-1.104-.896-2-2-2h-7c-1.104 0-2 .896-2 2v1h-1c-.552 0-1 .448-1 1s.448 1 1 1v8c0 2.206 1.794 4 4 4h5c2.206 0 4-1.794 4-4v-8c.552 0 1-.448 1-1s-.448-1-1-1zm-10-1h7v1h-7v-1zm8 11c0 1.104-.896 2-2 2h-5c-1.104 0-2-.896-2-2v-8h9v8zM8.5 10.5c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5s.5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM10.5 10.5c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5s.5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM12.5 10.5c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5s.5-.225.5-.5v-6c0-.275-.225-.5-.5-.5zM14.5 10.5c-.275 0-.5.225-.5.5v6c0 .275.225.5.5.5s.5-.225.5-.5v-6c0-.275-.225-.5-.5-.5z"
    },
    "children": []
  }]
};
exports.trash = trash;
var tree = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.781 17.375l-2.7-3.375h.919c.373 0 .715-.207.887-.538.172-.331.146-.729-.068-1.035l-7-10c-.317-.452-.94-.562-1.393-.246-.091.063-.158.146-.221.231-.025.015-7.025 10.015-7.025 10.015-.214.306-.24.704-.068 1.035.173.331.515.538.888.538h.919l-2.7 3.375c-.24.301-.287.712-.121 1.059.167.345.518.566.902.566h7v3c0 .553.448 1 1 1s1-.447 1-1v-3h7c.384 0 .735-.221.901-.566.167-.347.12-.758-.12-1.059zm-7.781-.375v-5c0-.553-.448-1-1-1s-1 .447-1 1v5h-4.919l2.7-3.375c.24-.301.287-.712.121-1.059-.167-.345-.518-.566-.902-.566h-1.08l5.08-7.256 5.08 7.256h-1.08c-.384 0-.735.221-.901.566-.167.347-.12.758.121 1.059l2.7 3.375h-4.92z"
    },
    "children": []
  }]
};
exports.tree = tree;
var uploadOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.986 17c0-.105-.004-.211-.038-.316l-2-6c-.093-.276-.302-.483-.56-.594.881-1.175.799-2.847-.269-3.914l-6.119-6.121-6.121 6.121c-1.067 1.067-1.149 2.739-.27 3.914-.256.109-.467.316-.559.594l-2 6c-.034.105-.038.211-.038.316-.012 0-.012 5-.012 5 0 .553.447 1 1 1h16c.553 0 1-.447 1-1 0 0 0-5-.014-5zm-13.693-9.41l4.707-4.707 4.707 4.707c.391.391.391 1.023 0 1.414-.379.377-1.035.377-1.414 0l-2.293-2.293v5.789c0 .552-.448 1-1 1s-1-.448-1-1v-5.789l-2.293 2.293c-.379.377-1.035.377-1.414 0-.391-.391-.391-1.025 0-1.414zm-.572 4.41h2.279v.5c0 1.654 1.346 3 3 3s3-1.346 3-3v-.5h2.279l1.666 5h-13.892l1.668-5zm-1.721 9v-3h14v3h-14z"
    },
    "children": []
  }]
};
exports.uploadOutline = uploadOutline;
var upload = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.987 16c0-.105-.004-.211-.039-.316l-2-6c-.136-.409-.517-.684-.948-.684h-4v2h3.279l1.667 5h-13.892l1.667-5h3.279v-2h-4c-.431 0-.812.275-.948.684l-2 6c-.035.105-.039.211-.039.316-.013 0-.013 5-.013 5 0 .553.447 1 1 1h16c.553 0 1-.447 1-1 0 0 0-5-.013-5zM16 7.904c.259 0 .518-.095.707-.283.39-.39.39-1.024 0-1.414l-4.707-4.707-4.707 4.707c-.39.39-.39 1.024 0 1.414.189.189.448.283.707.283s.518-.094.707-.283l2.293-2.293v6.672c0 .552.448 1 1 1s1-.448 1-1v-6.672l2.293 2.293c.189.189.448.283.707.283z"
    },
    "children": []
  }]
};
exports.upload = upload;
var userAddOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 14h-6c-.553 0-1-.448-1-1s.447-1 1-1h6c.553 0 1 .448 1 1s-.447 1-1 1zM18 17c-.553 0-1-.448-1-1v-6c0-.552.447-1 1-1s1 .448 1 1v6c0 .552-.447 1-1 1zM9 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-2c-2.764 0-5 2.238-5 5s2.236 5 5 5 5-2.238 5-5-2.236-5-5-5zM9 17c2.021 0 3.301.771 3.783 1.445-.683.26-1.969.555-3.783.555-1.984 0-3.206-.305-3.818-.542.459-.715 1.777-1.458 3.818-1.458m0-2c-3.75 0-6 2-6 4 0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4z"
    },
    "children": []
  }]
};
exports.userAddOutline = userAddOutline;
var userAdd = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M9 14c1.381 0 2.631-.56 3.536-1.465.904-.904 1.464-2.154 1.464-3.535s-.56-2.631-1.464-3.535c-.905-.905-2.155-1.465-3.536-1.465s-2.631.56-3.536 1.465c-.904.904-1.464 2.154-1.464 3.535s.56 2.631 1.464 3.535c.905.905 2.155 1.465 3.536 1.465zM9 21c3.518 0 6-1 6-2 0-2-2.354-4-6-4-3.75 0-6 2-6 4 0 1 2.25 2 6 2zM21 12h-2v-2c0-.553-.447-1-1-1s-1 .447-1 1v2h-2c-.553 0-1 .447-1 1s.447 1 1 1h2v2c0 .553.447 1 1 1s1-.447 1-1v-2h2c.553 0 1-.447 1-1s-.447-1-1-1z"
    },
    "children": []
  }]
};
exports.userAdd = userAdd;
var userDeleteOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 14h-6c-.553 0-1-.448-1-1s.447-1 1-1h6c.553 0 1 .448 1 1s-.447 1-1 1zM9 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-2c-2.764 0-5 2.238-5 5s2.236 5 5 5 5-2.238 5-5-2.236-5-5-5zM9 17c2.021 0 3.301.771 3.783 1.445-.683.26-1.969.555-3.783.555-1.984 0-3.206-.305-3.818-.542.459-.715 1.777-1.458 3.818-1.458m0-2c-3.75 0-6 2-6 4 0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4z"
    },
    "children": []
  }]
};
exports.userDeleteOutline = userDeleteOutline;
var userDelete = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21 14h-6c-.553 0-1-.447-1-1s.447-1 1-1h6c.553 0 1 .447 1 1s-.447 1-1 1zM14 9c0 1.381-.56 2.631-1.464 3.535-.905.905-2.155 1.465-3.536 1.465s-2.631-.56-3.536-1.465c-.904-.904-1.464-2.154-1.464-3.535s.56-2.631 1.464-3.535c.905-.905 2.155-1.465 3.536-1.465s2.631.56 3.536 1.465c.904.904 1.464 2.154 1.464 3.535zM9 15c-3.75 0-6 2-6 4 0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4z"
    },
    "children": []
  }]
};
exports.userDelete = userDelete;
var userOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 6c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3m0-2c-2.764 0-5 2.238-5 5s2.236 5 5 5 5-2.238 5-5-2.236-5-5-5zM12 17c2.021 0 3.301.771 3.783 1.445-.683.26-1.969.555-3.783.555-1.984 0-3.206-.305-3.818-.542.459-.715 1.777-1.458 3.818-1.458m0-2c-3.75 0-6 2-6 4 0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4z"
    },
    "children": []
  }]
};
exports.userOutline = userOutline;
var user = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 9c0-1.381-.56-2.631-1.464-3.535-.905-.905-2.155-1.465-3.536-1.465s-2.631.56-3.536 1.465c-.904.904-1.464 2.154-1.464 3.535s.56 2.631 1.464 3.535c.905.905 2.155 1.465 3.536 1.465s2.631-.56 3.536-1.465c.904-.904 1.464-2.154 1.464-3.535zM6 19c0 1 2.25 2 6 2 3.518 0 6-1 6-2 0-2-2.354-4-6-4-3.75 0-6 2-6 4z"
    },
    "children": []
  }]
};
exports.user = user;
var vendorAndroid = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M7.1 8h9.799999999999999c.1 0 .1 0 .1-.1-.1-.5-.2-.9-.4-1.3-.4-.9-1.1-1.5-1.9-2l-.4-.2s0-.1.1-.1c.3-.4.6-.8.9-1.3.1-.1.1-.2 0-.3-.1-.1-.2 0-.3.1l-.9 1.3s-.1.1-.1 0c-.8-.3-1.6-.4-2.4-.4-.6 0-1.1.2-1.6.4h-.1l-.9-1.2s0-.1-.1-.1c-.1-.1-.2-.1-.2 0-.1 0-.1.1 0 .2 0 0 0 .1.1.1.2.4.5.8.8 1.2l.1.1h-.1c-.6.3-1.1.7-1.5 1.2-.6.6-1 1.4-1.1 2.3 0 .1 0 .1.1.1zm7.1-2.8c.4 0 .8.3.8.8 0 .4-.3.8-.7.8-.4 0-.8-.3-.8-.8-.1-.4.3-.8.7-.8zm-4.3 0c.4 0 .8.3.8.8 0 .4-.3.8-.7.8-.5 0-.9-.4-.9-.8s.4-.8.8-.8zM5 9c-.5 0-1 .5-1 1v5c0 .5.5 1 1 1s1-.5 1-1v-5c0-.5-.5-1-1-1zM19 9c-.5 0-1 .5-1 1v5c0 .5.5 1 1 1s1-.5 1-1v-5c0-.5-.5-1-1-1zM7 17c0 .5.5 1 1 1h1v3c0 .5.5 1 1 1s1-.5 1-1v-3h2v3c0 .5.5 1 1 1s1-.5 1-1v-3h1c.5 0 1-.5 1-1v-8h-10v8z"
    },
    "children": []
  }]
};
exports.vendorAndroid = vendorAndroid;
var vendorApple = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M11.9 6.6s-.1-1.6.9-3l2.8-1.6s.1 1.6-.9 3l-2.8 1.6zM17.3 12.2c0-1.5.8-2.8 2-3.6l-.9-.9c-.5-.3-1.1-.7-2.4-.7-1.4 0-2.4.9-3.7.9-1.3 0-2.2-.8-3.1-.9-.7 0-1.4 0-2.1.3-.5.2-1.2.7-1.6 1.2-.6.6-1.2 1.9-1.3 3.1-.1 1.2-.1 2.1.2 3.2.2.9.6 1.8 1 2.6.3.6.6 1.2 1 1.8.3.4.7.8 1.1 1.1.3.2.6.4 1 .6.2 0 .5.1.8.1.6-.1 1.6-.9 2.4-1.1.4-.1.8-.1 1.3 0 .7.1 1.4.9 2.2 1 .6.1 1.2 0 1.7-.3.4-.2.7-.5 1-.9.4-.4.7-.9 1-1.3.4-.7.9-1.5 1.1-2.3-1.6-.6-2.7-2.1-2.7-3.9z"
    },
    "children": []
  }]
};
exports.vendorApple = vendorApple;
var vendorMicrosoft = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10 12.5c0-.3-.2-.5-.5-.5h-6c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.6l6 .7c.3 0 .5-.2.5-.4v-5.9zM11.5 12c-.3 0-.5.2-.5.5v5.9c0 .3.2.5.5.6l9 1c.3 0 .5-.2.5-.4v-7c0-.3-.2-.5-.5-.5l-9-.1zM10 4.7c0-.3-.2-.5-.5-.4l-6 .7c-.3 0-.5.2-.5.5v5c0 .3.2.5.5.5h6c.3 0 .5-.2.5-.5v-5.8zM11.5 4.1c-.3 0-.5.3-.5.6v5.9c0 .3.2.5.5.5h9c.3 0 .5-.2.5-.5v-7c0-.3-.2-.5-.5-.4l-9 .9z"
    },
    "children": []
  }]
};
exports.vendorMicrosoft = vendorMicrosoft;
var videoOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "circle",
    "attribs": {
      "cx": "7",
      "cy": "11",
      "r": "1"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M21.585 7.188c-.262-.188-.599-.241-.901-.137l-1.707.568c-.188-1.477-1.451-2.62-2.977-2.62h-11c-1.654 0-3 1.347-3 3v6c0 1.653 1.346 3 3 3h3v1.111l.008.09c.066.738.381 1.423.887 1.928.562.562 1.311.872 2.104.872s1.542-.31 2.104-.87c.574-.577.898-1.346.896-2.113v-1.017h2c1.524 0 2.789-1.145 2.978-2.62l1.707.568c.303.104.64.051.9-.138.262-.188.415-.49.415-.812v-6c.001-.318-.153-.621-.414-.81zm-9.585 10.835c.001.248-.119.5-.309.689-.191.189-.441.286-.692.286-.25 0-.501-.097-.69-.286-.19-.189-.285-.441-.309-.691v-2.021h2v2.023zm5-4.023c0 .552-.448 1-1 1h-11c-.552 0-1-.448-1-1v-6c0-.552.448-1 1-1h11c.552 0 1 .448 1 1v6zm3-1.389s-1.895-.605-2-.605v-2.012c.105 0 2-.605 2-.605v3.222z"
    },
    "children": []
  }]
};
exports.videoOutline = videoOutline;
var video = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M22.525 7.149c-.16-.099-.342-.149-.525-.149-.153 0-.306.035-.447.105l-2.553 1.277v-.382c0-1.654-1.346-3-3-3h-11c-1.654 0-3 1.346-3 3v8c0 1.654 1.346 3 3 3h11c1.654 0 3-1.346 3-3v-.382l2.553 1.276c.141.071.294.106.447.106.183 0 .365-.05.525-.149.295-.183.475-.504.475-.851v-8c0-.347-.18-.668-.475-.851zm-15.525 6.351c-.829 0-1.5-.671-1.5-1.5s.671-1.5 1.5-1.5 1.5.671 1.5 1.5-.671 1.5-1.5 1.5z"
    },
    "children": []
  }]
};
exports.video = video;
var volumeDown = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M15.138 5.824c-.449 0-.905.152-1.356.453l-2.672 1.781c-.753.503-2.206.942-3.11.942-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3 .904 0 2.357.439 3.109.941l2.672 1.781c.451.301.907.453 1.356.453.898.001 1.863-.68 1.863-2.175v-10c0-1.495-.965-2.176-1.862-2.176zm-7.138 9.176c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v6.293c-1.093-.652-2.789-1.147-4-1.147zm7 3l-.006.12-.104-.062-1.89-1.26v-7.596l1.891-1.261.104-.062.005.121v10zM18.292 10.294c-.39.391-.39 1.023.002 1.414.345.345.535.803.535 1.291 0 .489-.19.948-.536 1.294-.391.39-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c.724-.723 1.122-1.685 1.122-2.708s-.398-1.984-1.123-2.707c-.389-.389-1.023-.391-1.414.002z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M15.138 5.824c-.449 0-.905.152-1.356.453l-2.672 1.781c-.753.503-2.206.942-3.11.942-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3 .904 0 2.357.439 3.109.941l2.672 1.781c.451.301.907.453 1.356.453.898.001 1.863-.68 1.863-2.175v-10c0-1.495-.965-2.176-1.862-2.176zm-7.138 9.176c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v6.293c-1.093-.652-2.789-1.147-4-1.147zm7 3l-.006.12-.104-.062-1.89-1.26v-7.596l1.891-1.261.104-.062.005.121v10zM18.292 10.294c-.39.391-.39 1.023.002 1.414.345.345.535.803.535 1.291 0 .489-.19.948-.536 1.294-.391.39-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c.724-.723 1.122-1.685 1.122-2.708s-.398-1.984-1.123-2.707c-.389-.389-1.023-.391-1.414.002z"
        },
        "children": []
      }]
    }]
  }]
};
exports.volumeDown = volumeDown;
var volumeMute = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19.707 5.293c-.391-.391-1.023-.391-1.414 0l-1.551 1.551c-.345-.688-.987-1.02-1.604-1.02-.449 0-.905.152-1.356.453l-2.672 1.781c-.753.503-2.206.942-3.11.942-1.654 0-3 1.346-3 3v2c0 1.237.754 2.302 1.826 2.76l-1.533 1.533c-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293l2.527-2.527c.697.174 1.416.455 1.875.762l2.672 1.781c.451.301.907.453 1.356.453.898 0 1.863-.681 1.863-2.176v-8.586l2.707-2.707c.391-.391.391-1.023 0-1.414zm-4.816 2.648l.104-.062.005.121v1.293l-2 2v-2.091l1.891-1.261zm-7.891 4.059c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v2.439l-2.83 2.83c-.413-.077-.814-.123-1.17-.123-.552 0-1-.448-1-1v-2zm3.301 3.406l1.699-1.699v2.439c-.481-.287-1.075-.542-1.699-.74zm4.693 2.714l-.104-.062-1.89-1.26v-4.091l2-2v7.293l-.006.12z"
    },
    "children": []
  }]
};
exports.volumeMute = volumeMute;
var volumeUp = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M16.706 10.292c-.389-.389-1.023-.391-1.414.002-.39.391-.39 1.023.002 1.414.345.345.535.803.535 1.291 0 .489-.19.948-.536 1.294-.391.39-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c.724-.723 1.122-1.685 1.122-2.708s-.398-1.984-1.123-2.707zM18.706 8.292c-.391-.389-1.023-.39-1.414.002-.39.391-.39 1.024.002 1.414.879.877 1.363 2.044 1.364 3.287.001 1.246-.484 2.417-1.365 3.298-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c1.259-1.259 1.952-2.933 1.951-4.713-.001-1.777-.694-3.447-1.952-4.702zM20.706 6.292c-.391-.389-1.023-.39-1.414.002-.39.391-.39 1.024.002 1.414 1.412 1.409 2.191 3.285 2.192 5.284.002 2.002-.777 3.885-2.193 5.301-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c1.794-1.794 2.781-4.18 2.779-6.717-.001-2.533-.989-4.912-2.78-6.698zM12.138 5.824c-.449 0-.905.152-1.356.453l-2.673 1.782c-.752.502-2.205.941-3.109.941-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3 .904 0 2.357.439 3.109.941l2.672 1.781c.451.301.907.453 1.356.453.898.001 1.863-.68 1.863-2.175v-10c0-1.495-.965-2.176-1.862-2.176zm-7.138 9.176c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v6.293c-1.093-.652-2.789-1.147-4-1.147zm7 3l-.006.12-.104-.062-1.89-1.26v-7.596l1.891-1.261.104-.062.005.121v10z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M16.706 10.292c-.389-.389-1.023-.391-1.414.002-.39.391-.39 1.023.002 1.414.345.345.535.803.535 1.291 0 .489-.19.948-.536 1.294-.391.39-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c.724-.723 1.122-1.685 1.122-2.708s-.398-1.984-1.123-2.707zM18.706 8.292c-.391-.389-1.023-.39-1.414.002-.39.391-.39 1.024.002 1.414.879.877 1.363 2.044 1.364 3.287.001 1.246-.484 2.417-1.365 3.298-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c1.259-1.259 1.952-2.933 1.951-4.713-.001-1.777-.694-3.447-1.952-4.702zM20.706 6.292c-.391-.389-1.023-.39-1.414.002-.39.391-.39 1.024.002 1.414 1.412 1.409 2.191 3.285 2.192 5.284.002 2.002-.777 3.885-2.193 5.301-.391.391-.391 1.023 0 1.414.195.195.451.293.707.293s.512-.098.707-.293c1.794-1.794 2.781-4.18 2.779-6.717-.001-2.533-.989-4.912-2.78-6.698zM12.138 5.824c-.449 0-.905.152-1.356.453l-2.673 1.782c-.752.502-2.205.941-3.109.941-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3 .904 0 2.357.439 3.109.941l2.672 1.781c.451.301.907.453 1.356.453.898.001 1.863-.68 1.863-2.175v-10c0-1.495-.965-2.176-1.862-2.176zm-7.138 9.176c-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v6.293c-1.093-.652-2.789-1.147-4-1.147zm7 3l-.006.12-.104-.062-1.89-1.26v-7.596l1.891-1.261.104-.062.005.121v10z"
        },
        "children": []
      }]
    }]
  }]
};
exports.volumeUp = volumeUp;
var volume = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.138 5.824c-.449 0-.905.152-1.356.453l-2.672 1.781c-.753.503-2.206.942-3.11.942-1.654 0-3 1.346-3 3v2c0 1.654 1.346 3 3 3 .904 0 2.357.439 3.109.941l2.672 1.781c.451.301.907.453 1.356.453.898.001 1.863-.68 1.863-2.175v-10c0-1.495-.965-2.176-1.862-2.176zm-3.138 10.322c-1.093-.651-2.789-1.146-4-1.146-.552 0-1-.448-1-1v-2c0-.552.448-1 1-1 1.211 0 2.907-.495 4-1.146v6.292zm3 1.854l-.006.12-.104-.062-1.89-1.26v-7.596l1.891-1.261.104-.062.005.121v10z"
    },
    "children": []
  }]
};
exports.volume = volume;
var warningOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 5.511c.561 0 1.119.354 1.544 1.062l5.912 9.854c.851 1.415.194 2.573-1.456 2.573h-12c-1.65 0-2.307-1.159-1.456-2.573l5.912-9.854c.425-.708.983-1.062 1.544-1.062m0-2c-1.296 0-2.482.74-3.259 2.031l-5.912 9.856c-.786 1.309-.872 2.705-.235 3.83s1.879 1.772 3.406 1.772h12c1.527 0 2.77-.646 3.406-1.771s.551-2.521-.235-3.83l-5.912-9.854c-.777-1.294-1.963-2.034-3.259-2.034z"
    },
    "children": []
  }, {
    "name": "circle",
    "attribs": {
      "cx": "12",
      "cy": "16",
      "r": "1.3"
    },
    "children": []
  }, {
    "name": "path",
    "attribs": {
      "d": "M13.5 10c0-.83-.671-1.5-1.5-1.5s-1.5.67-1.5 1.5c0 .199.041.389.111.562.554 1.376 1.389 3.438 1.389 3.438l1.391-3.438c.068-.173.109-.363.109-.562z"
    },
    "children": []
  }]
};
exports.warningOutline = warningOutline;
var warning = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.171 15.398l-5.912-9.854c-.776-1.293-1.963-2.033-3.259-2.033s-2.483.74-3.259 2.031l-5.912 9.856c-.786 1.309-.872 2.705-.235 3.83.636 1.126 1.878 1.772 3.406 1.772h12c1.528 0 2.77-.646 3.406-1.771.637-1.125.551-2.521-.235-3.831zm-9.171 2.151c-.854 0-1.55-.695-1.55-1.549 0-.855.695-1.551 1.55-1.551s1.55.696 1.55 1.551c0 .854-.696 1.549-1.55 1.549zm1.633-7.424c-.011.031-1.401 3.468-1.401 3.468-.038.094-.13.156-.231.156s-.193-.062-.231-.156l-1.391-3.438c-.09-.233-.129-.443-.129-.655 0-.965.785-1.75 1.75-1.75s1.75.785 1.75 1.75c0 .212-.039.422-.117.625z"
    },
    "children": []
  }]
};
exports.warning = warning;
var watch = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 13h2c.55 0 1-.45 1-1s-.45-1-1-1h-1v-1c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1zM17 7.105v-2.105c0-1.654-1.346-3-3-3h-4c-1.654 0-3 1.346-3 3v2.105c-1.236 1.263-2 2.989-2 4.895s.764 3.632 2 4.895v2.105c0 1.654 1.346 3 3 3h4c1.654 0 3-1.346 3-3v-2.105c1.236-1.262 2-2.988 2-4.895s-.764-3.632-2-4.895zm-8-2.105c0-.551.449-1 1-1h4c.551 0 1 .449 1 1v1.809c-.883-.512-1.906-.809-3-.809s-2.117.297-3 .809v-1.809zm6 14c0 .551-.449 1-1 1h-4c-.551 0-1-.449-1-1v-1.811c.883.513 1.906.811 3 .811s2.117-.298 3-.811v1.811zm-3-2c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
    },
    "children": []
  }]
};
exports.watch = watch;
var wavesOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.221 10.761c.498-.552.779-1.252.779-2 0-.801-.312-1.555-.879-2.121-.566-.567-1.32-.879-2.121-.879s-1.555.312-2.121.879c-.233.232-.546.361-.879.361-.333 0-.646-.129-.879-.362-1.366-1.366-3.185-2.118-5.121-2.118s-3.755.752-5.121 2.118c-.567.567-.879 1.321-.879 2.122 0 .748.281 1.448.779 2-.498.551-.779 1.252-.779 2s.281 1.448.779 2c-.498.551-.779 1.252-.779 2 0 .801.312 1.555.879 2.121.566.566 1.32.879 2.121.879s1.555-.312 2.121-.879c.234-.233.545-.362.878-.362.333 0 .646.129.88.363 1.367 1.365 3.185 2.117 5.121 2.117 1.937 0 3.755-.752 5.121-2.118.567-.567.879-1.32.879-2.121 0-.748-.281-1.448-.779-2 .498-.552.779-1.252.779-2s-.281-1.449-.779-2zm-1.514 6.707c-1.021 1.021-2.364 1.532-3.707 1.532-1.342 0-2.685-.511-3.707-1.532-.633-.632-1.463-.948-2.293-.948-.831 0-1.661.316-2.292.948-.196.195-.452.293-.708.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414 1.021-1.021 2.364-1.532 3.706-1.532 1.343 0 2.686.511 3.708 1.532.632.632 1.463.947 2.293.947.831 0 1.661-.315 2.293-.947.195-.195.451-.293.707-.293s.512.098.707.293c.391.39.391 1.023 0 1.414zm-13.414-9.414c1.021-1.022 2.365-1.533 3.707-1.533 1.343 0 2.685.511 3.707 1.532.632.633 1.463.948 2.293.948.831 0 1.661-.315 2.293-.947.195-.196.451-.293.707-.293s.512.098.707.293c.391.391.391 1.023 0 1.414-1.021 1.021-2.364 1.532-3.707 1.532-1.342 0-2.685-.511-3.707-1.532-.633-.632-1.463-.948-2.293-.948-.831 0-1.661.316-2.292.948-.196.195-.452.293-.708.293s-.512-.098-.707-.293c-.391-.391-.391-1.024 0-1.414zm13.414 5.414c-1.021 1.021-2.364 1.532-3.707 1.532-1.342 0-2.685-.511-3.707-1.532-.633-.632-1.463-.948-2.293-.948-.831 0-1.661.316-2.292.948-.196.195-.452.293-.708.293s-.512-.098-.707-.293c-.391-.391-.391-1.023 0-1.414 1.021-1.021 2.364-1.532 3.706-1.532 1.343 0 2.686.511 3.708 1.532.632.632 1.463.947 2.293.947.831 0 1.661-.315 2.293-.947.195-.195.451-.293.707-.293s.512.098.707.293c.391.39.391 1.023 0 1.414z"
    },
    "children": []
  }]
};
exports.wavesOutline = wavesOutline;
var waves = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M15 19c-1.342 0-2.685-.511-3.707-1.532-1.266-1.265-3.323-1.264-4.586 0-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c2.043-2.043 5.369-2.043 7.414 0 1.265 1.264 3.322 1.263 4.586 0 .391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414c-1.021 1.021-2.364 1.532-3.707 1.532zM15 15c-1.342 0-2.685-.511-3.707-1.532-1.266-1.265-3.323-1.264-4.586 0-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c2.043-2.043 5.369-2.043 7.414 0 1.265 1.264 3.322 1.263 4.586 0 .391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414c-1.021 1.021-2.364 1.532-3.707 1.532zM15 11c-1.342 0-2.685-.511-3.707-1.532-1.266-1.265-3.323-1.264-4.586 0-.391.391-1.023.391-1.414 0s-.391-1.023 0-1.414c2.043-2.042 5.369-2.044 7.414 0 1.265 1.264 3.322 1.263 4.586 0 .391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414c-1.021 1.021-2.364 1.532-3.707 1.532z"
    },
    "children": []
  }]
};
exports.waves = waves;
var weatherCloudy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17 19h-11c-2.206 0-4-1.794-4-4 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.638 5.65 4.015 2.942-.246 5.35 2.113 5.35 4.985 0 2.757-2.243 5-5 5zm-11.095-6.006c-1.008.006-1.905.903-1.905 2.006s.897 2 2 2h11c1.654 0 3-1.346 3-3s-1.346-3-3-3c-.243 0-.5.041-.81.13l-1.075.307-.186-1.103c-.325-1.932-1.977-3.334-3.929-3.334-2.206 0-4 1.794-4 4 0 .272.027.545.082.811l.244 1.199-1.421-.016z"
    },
    "children": []
  }]
};
exports.weatherCloudy = weatherCloudy;
var weatherDownpour = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M15 22c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM9 22c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM12 24c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM6 18c-2.206 0-4-1.794-4-4 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.639 5.65 4.015 2.936-.244 5.35 2.113 5.35 4.985 0 2.241-1.507 4.223-3.666 4.819-.535.146-1.083-.166-1.23-.697-.147-.532.165-1.083.698-1.23 1.294-.358 2.198-1.547 2.198-2.892 0-1.654-1.346-3-3-3-.242 0-.499.041-.811.13l-1.074.306-.185-1.102c-.326-1.932-1.978-3.334-3.93-3.334-2.206 0-4 1.794-4 4 0 .272.027.545.082.808l.248 1.202-1.422-.016c-1.011.006-1.908.903-1.908 2.006s.897 2 2 2c.552 0 1 .447 1 1s-.448 1-1 1z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M15 22c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM9 22c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM12 24c-.552 0-1-.447-1-1v-6c0-.553.448-1 1-1s1 .447 1 1v6c0 .553-.448 1-1 1zM6 18c-2.206 0-4-1.794-4-4 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.639 5.65 4.015 2.936-.244 5.35 2.113 5.35 4.985 0 2.241-1.507 4.223-3.666 4.819-.535.146-1.083-.166-1.23-.697-.147-.532.165-1.083.698-1.23 1.294-.358 2.198-1.547 2.198-2.892 0-1.654-1.346-3-3-3-.242 0-.499.041-.811.13l-1.074.306-.185-1.102c-.326-1.932-1.978-3.334-3.93-3.334-2.206 0-4 1.794-4 4 0 .272.027.545.082.808l.248 1.202-1.422-.016c-1.011.006-1.908.903-1.908 2.006s.897 2 2 2c.552 0 1 .447 1 1s-.448 1-1 1z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherDownpour = weatherDownpour;
var weatherNight = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M10.5 20c-.861 0-1.71-.151-2.523-.451l-1.317-.485.89-1.087c1.275-1.56 1.95-3.454 1.95-5.477s-.675-3.917-1.951-5.477l-.89-1.087 1.317-.485c.814-.3 1.663-.451 2.524-.451 4.136 0 7.5 3.364 7.5 7.5s-3.364 7.5-7.5 7.5zm-.509-2.024c.169.016.339.024.509.024 3.032 0 5.5-2.468 5.5-5.5s-2.468-5.5-5.5-5.5c-.17 0-.34.008-.509.024.991 1.645 1.509 3.511 1.509 5.476s-.518 3.831-1.509 5.476z"
    },
    "children": []
  }]
};
exports.weatherNight = weatherNight;
var weatherPartlySunny = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M14.5 3l-1 3-1-3c-.184-.553.114-1.149.666-1.333.553-.185 1.15.114 1.334.666.075.226.07.458 0 .667zM19.864 6.05l-2.829 1.415 1.415-2.829c.261-.521.894-.731 1.414-.472.521.261.731.894.472 1.415-.107.212-.274.372-.472.471zM21.5 12l-3-1 3-1c.553-.185 1.149.114 1.334.667.184.552-.115 1.148-.668 1.333-.225.075-.457.069-.666 0zM8.55 4.636l1.415 2.829-2.829-1.415c-.521-.261-.732-.894-.472-1.414.261-.521.895-.731 1.414-.472.213.107.373.274.472.472zM17.776 12.342c.139-.424.224-.871.224-1.342 0-2.481-2.019-4.5-4.5-4.5-1.34 0-2.537.594-3.357 1.528l-.143-.028c-1.776 0-3.369.78-4.469 2.011-.24-.08-.472-.086-.697-.011-.553.185-.852.781-.668 1.333.057.167.158.299.277.411-.283.697-.443 1.458-.443 2.256l.002.126c-1.725.445-3.002 2.013-3.002 3.874 0 2.206 1.795 4 4 4h11c2.757 0 5-2.243 5-5 0-2.129-1.344-3.939-3.224-4.658zm-4.276-3.842c1.379 0 2.5 1.121 2.5 2.5 0 .366-.096.706-.238 1.019-.354.021-.72.074-1.118.188-.521-1.353-1.604-2.415-2.967-2.905.456-.49 1.102-.802 1.823-.802zm2.5 11.5h-11c-1.104 0-2-.897-2-2s.896-2 1.908-2.006l1.422.016-.248-1.202c-.055-.263-.082-.536-.082-.808 0-2.206 1.795-4 4-4l.069-.014c1.904.055 3.495 1.406 3.847 3.27l.038.186c.123.436.517.706.946.712l.289-.023c.312-.09.569-.131.811-.131 1.654 0 3 1.346 3 3s-1.346 3-3 3z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M14.5 3l-1 3-1-3c-.184-.553.114-1.149.666-1.333.553-.185 1.15.114 1.334.666.075.226.07.458 0 .667zM19.864 6.05l-2.829 1.415 1.415-2.829c.261-.521.894-.731 1.414-.472.521.261.731.894.472 1.415-.107.212-.274.372-.472.471zM21.5 12l-3-1 3-1c.553-.185 1.149.114 1.334.667.184.552-.115 1.148-.668 1.333-.225.075-.457.069-.666 0zM8.55 4.636l1.415 2.829-2.829-1.415c-.521-.261-.732-.894-.472-1.414.261-.521.895-.731 1.414-.472.213.107.373.274.472.472zM17.776 12.342c.139-.424.224-.871.224-1.342 0-2.481-2.019-4.5-4.5-4.5-1.34 0-2.537.594-3.357 1.528l-.143-.028c-1.776 0-3.369.78-4.469 2.011-.24-.08-.472-.086-.697-.011-.553.185-.852.781-.668 1.333.057.167.158.299.277.411-.283.697-.443 1.458-.443 2.256l.002.126c-1.725.445-3.002 2.013-3.002 3.874 0 2.206 1.795 4 4 4h11c2.757 0 5-2.243 5-5 0-2.129-1.344-3.939-3.224-4.658zm-4.276-3.842c1.379 0 2.5 1.121 2.5 2.5 0 .366-.096.706-.238 1.019-.354.021-.72.074-1.118.188-.521-1.353-1.604-2.415-2.967-2.905.456-.49 1.102-.802 1.823-.802zm2.5 11.5h-11c-1.104 0-2-.897-2-2s.896-2 1.908-2.006l1.422.016-.248-1.202c-.055-.263-.082-.536-.082-.808 0-2.206 1.795-4 4-4l.069-.014c1.904.055 3.495 1.406 3.847 3.27l.038.186c.123.436.517.706.946.712l.289-.023c.312-.09.569-.131.811-.131 1.654 0 3 1.346 3 3s-1.346 3-3 3z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherPartlySunny = weatherPartlySunny;
var weatherShower = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 18c-.552 0-1-.447-1-1s.448-1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3c-.243 0-.5.041-.81.13l-1.075.307-.185-1.103c-.326-1.932-1.978-3.334-3.93-3.334-2.206 0-4 1.794-4 4 0 .272.027.545.082.811l.244 1.199-1.42-.016c-1.009.006-1.906.903-1.906 2.006s.897 2 2 2c.552 0 1 .447 1 1s-.448 1-1 1c-2.206 0-4-1.794-4-4 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.638 5.65 4.015 2.939-.244 5.35 2.113 5.35 4.985 0 2.757-2.243 5-5 5zM10.5 18l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667zM13.5 20l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667zM7.5 20l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 18c-.552 0-1-.447-1-1s.448-1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3c-.243 0-.5.041-.81.13l-1.075.307-.185-1.103c-.326-1.932-1.978-3.334-3.93-3.334-2.206 0-4 1.794-4 4 0 .272.027.545.082.811l.244 1.199-1.42-.016c-1.009.006-1.906.903-1.906 2.006s.897 2 2 2c.552 0 1 .447 1 1s-.448 1-1 1c-2.206 0-4-1.794-4-4 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.638 5.65 4.015 2.939-.244 5.35 2.113 5.35 4.985 0 2.757-2.243 5-5 5zM10.5 18l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667zM13.5 20l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667zM7.5 20l1-3 1 3c.184.553-.114 1.149-.667 1.333-.552.185-1.149-.114-1.333-.666-.075-.226-.07-.458 0-.667z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherShower = weatherShower;
var weatherSnow = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M20.5 15.134l-2.457-.503 1.483-.396c.533-.143.85-.69.707-1.225-.142-.533-.689-.85-1.225-.707l-1.508.403c.037-.231.071-.464.071-.706s-.034-.476-.071-.707l1.51.404.26.034c.441 0 .846-.295.965-.741.143-.533-.174-1.082-.707-1.225l-1.483-.397 2.455-.502c.216-.044.42-.156.577-.333.386-.436.347-1.102-.089-1.488-.436-.386-1.102-.347-1.488.089l-1.663 1.874.398-1.479c.144-.533-.173-1.082-.706-1.226-.531-.142-1.082.173-1.226.706l-.407 1.517c-.366-.299-.771-.544-1.219-.717l1.102-1.102c.391-.391.391-1.023 0-1.414s-1.023-.391-1.414 0l-1.086 1.086.793-2.379c.069-.209.075-.441 0-.667-.184-.552-.781-.851-1.333-.666-.552.184-.85.78-.667 1.333l.793 2.379-1.086-1.086c-.391-.391-1.023-.391-1.414 0s-.391 1.023 0 1.414l1.102 1.102c-.447.173-.853.419-1.219.717l-.405-1.515c-.143-.534-.697-.852-1.224-.708-.534.143-.851.69-.708 1.224l.396 1.485-1.662-1.877c-.146-.164-.345-.285-.578-.333-.57-.117-1.127.25-1.244.82s.251 1.128.822 1.245l2.454.503-1.48.396c-.533.143-.85.691-.707 1.225.119.447.523.741.965.741l.26-.034 1.508-.404c-.039.231-.073.465-.073.706 0 .242.034.475.071.707l-1.508-.404c-.532-.142-1.081.173-1.225.707-.144.533.174 1.082.707 1.225l1.483.397-2.455.502c-.216.044-.42.156-.577.334-.387.436-.347 1.102.089 1.487.436.387 1.103.347 1.488-.089l1.665-1.878-.398 1.484c-.144.533.173 1.082.707 1.225l.26.034c.441 0 .845-.294.965-.741l.406-1.515c.366.298.771.544 1.22.716l-1.104 1.102c-.391.39-.391 1.023 0 1.414s1.023.391 1.414 0l.706-.707h.252l-.666 1.999c-.069.209-.075.441 0 .667.184.552.781.851 1.333.666.553-.184.851-.78.667-1.333l-.666-1.999h.252l.707.707c.196.195.451.293.707.293s.512-.098.707-.293c.391-.39.391-1.023 0-1.414l-1.102-1.103c.448-.172.854-.418 1.22-.717l.406 1.517c.12.447.523.741.965.741l.26-.034c.533-.143.851-.691.707-1.225l-.397-1.48 1.662 1.874c.146.165.345.285.577.333.57.117 1.128-.251 1.244-.821.117-.57-.251-1.127-.821-1.244zm-7.428-.634c-1.379 0-2.5-1.121-2.5-2.5s1.121-2.5 2.5-2.5 2.5 1.121 2.5 2.5-1.121 2.5-2.5 2.5z"
    },
    "children": []
  }]
};
exports.weatherSnow = weatherSnow;
var weatherStormy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M17 18c-.553 0-1-.447-1-1s.447-1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3c-.238 0-.496.042-.813.131l-1.071.301-.186-1.098c-.326-1.932-1.979-3.334-3.93-3.334-2.205 0-4 1.794-4 4 0 .274.027.545.082.806l.26 1.24-1.436-.052c-1.01.006-1.906.903-1.906 2.006s.896 2 2 2c.553 0 1 .447 1 1s-.447 1-1 1c-2.205 0-4-1.794-4-4 0-1.861 1.277-3.429 3.002-3.874l-.002-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.638 5.649 4.015 2.925-.241 5.351 2.112 5.351 4.985 0 2.757-2.243 5-5 5zM12.639 14l-4.5 4.051 3 1.449-1.5 3.5 4.5-4.05-3-1.45z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M17 18c-.553 0-1-.447-1-1s.447-1 1-1c1.654 0 3-1.346 3-3s-1.346-3-3-3c-.238 0-.496.042-.813.131l-1.071.301-.186-1.098c-.326-1.932-1.979-3.334-3.93-3.334-2.205 0-4 1.794-4 4 0 .274.027.545.082.806l.26 1.24-1.436-.052c-1.01.006-1.906.903-1.906 2.006s.896 2 2 2c.553 0 1 .447 1 1s-.447 1-1 1c-2.205 0-4-1.794-4-4 0-1.861 1.277-3.429 3.002-3.874l-.002-.126c0-3.309 2.691-6 6-6 2.587 0 4.824 1.638 5.649 4.015 2.925-.241 5.351 2.112 5.351 4.985 0 2.757-2.243 5-5 5zM12.639 14l-4.5 4.051 3 1.449-1.5 3.5 4.5-4.05-3-1.45z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherStormy = weatherStormy;
var weatherSunny = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M13 4l-1 2.934-1-2.934c-.188-.553.106-1.152.659-1.341.552-.188 1.153.107 1.341.659.078.23.072.469 0 .682zM4 11l2.934 1-2.934 1c-.553.188-1.152-.106-1.341-.659-.188-.552.107-1.153.659-1.341.23-.078.469-.072.682 0zM11 20l1-2.934 1 2.934c.188.553-.106 1.152-.659 1.341-.552.188-1.152-.106-1.341-.659-.078-.23-.072-.469 0-.682zM20 12.998l-2.934-1 2.934-1c.553-.188 1.152.106 1.341.659.188.552-.106 1.152-.659 1.341-.23.078-.469.072-.682 0zM7.05 5.636l1.367 2.781-2.781-1.367c-.524-.257-.74-.891-.483-1.414.258-.523.891-.739 1.414-.482.218.107.383.28.483.482zM5.636 16.949l2.781-1.367-1.367 2.781c-.257.523-.891.739-1.414.482-.523-.258-.739-.891-.482-1.414.107-.218.28-.382.482-.482zM16.949 18.363l-1.367-2.781 2.781 1.367c.523.257.739.891.482 1.414-.258.523-.891.739-1.414.482-.218-.107-.382-.28-.482-.482zM18.362 7.048l-2.782 1.368 1.368-2.782c.257-.523.891-.739 1.414-.482.523.258.739.891.481 1.415-.106.217-.279.381-.481.481zM12 16.5c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm0-7c-1.379 0-2.5 1.121-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M13 4l-1 2.934-1-2.934c-.188-.553.106-1.152.659-1.341.552-.188 1.153.107 1.341.659.078.23.072.469 0 .682zM4 11l2.934 1-2.934 1c-.553.188-1.152-.106-1.341-.659-.188-.552.107-1.153.659-1.341.23-.078.469-.072.682 0zM11 20l1-2.934 1 2.934c.188.553-.106 1.152-.659 1.341-.552.188-1.152-.106-1.341-.659-.078-.23-.072-.469 0-.682zM20 12.998l-2.934-1 2.934-1c.553-.188 1.152.106 1.341.659.188.552-.106 1.152-.659 1.341-.23.078-.469.072-.682 0zM7.05 5.636l1.367 2.781-2.781-1.367c-.524-.257-.74-.891-.483-1.414.258-.523.891-.739 1.414-.482.218.107.383.28.483.482zM5.636 16.949l2.781-1.367-1.367 2.781c-.257.523-.891.739-1.414.482-.523-.258-.739-.891-.482-1.414.107-.218.28-.382.482-.482zM16.949 18.363l-1.367-2.781 2.781 1.367c.523.257.739.891.482 1.414-.258.523-.891.739-1.414.482-.218-.107-.382-.28-.482-.482zM18.362 7.048l-2.782 1.368 1.368-2.782c.257-.523.891-.739 1.414-.482.523.258.739.891.481 1.415-.106.217-.279.381-.481.481zM12 16.5c-2.481 0-4.5-2.019-4.5-4.5s2.019-4.5 4.5-4.5 4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5zm0-7c-1.379 0-2.5 1.121-2.5 2.5s1.121 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.121-2.5-2.5-2.5z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherSunny = weatherSunny;
var weatherWindyCloudy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "g",
    "attribs": {},
    "children": [{
      "name": "path",
      "attribs": {
        "d": "M4.798 15.75c-.134 0-.27-.026-.4-.084-1.457-.639-2.398-2.077-2.398-3.666 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.932 0 5.413 2.104 5.902 5.001.092.544-.275 1.061-.82 1.152-.544.083-1.06-.276-1.152-.82-.326-1.931-1.979-3.333-3.93-3.333-2.206 0-4 1.794-4 4 0 .272.027.546.081.812l.259 1.27-1.431-.088c-1.012.006-1.909.903-1.909 2.006 0 .795.471 1.515 1.2 1.834.506.222.736.812.515 1.317-.164.375-.531.599-.917.599zM19 7c-.553 0-1 .447-1 1s.447 1 1 1c.552 0 1 .448 1 1s-.448 1-1 1h-9.6c-.553 0-1 .447-1 1s.447 1 1 1h4.6c.552 0 1 .448 1 1s-.448 1-1 1h-5c-1.654 0-3 1.346-3 3s1.346 3 3 3c.553 0 1-.447 1-1s-.447-1-1-1c-.552 0-1-.448-1-1s.448-1 1-1h5c1.654 0 3-1.346 3-3 0-.353-.072-.686-.185-1h2.185c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
      },
      "children": [{
        "name": "path",
        "attribs": {
          "d": "M4.798 15.75c-.134 0-.27-.026-.4-.084-1.457-.639-2.398-2.077-2.398-3.666 0-1.861 1.277-3.429 3.001-3.874l-.001-.126c0-3.309 2.691-6 6-6 2.932 0 5.413 2.104 5.902 5.001.092.544-.275 1.061-.82 1.152-.544.083-1.06-.276-1.152-.82-.326-1.931-1.979-3.333-3.93-3.333-2.206 0-4 1.794-4 4 0 .272.027.546.081.812l.259 1.27-1.431-.088c-1.012.006-1.909.903-1.909 2.006 0 .795.471 1.515 1.2 1.834.506.222.736.812.515 1.317-.164.375-.531.599-.917.599zM19 7c-.553 0-1 .447-1 1s.447 1 1 1c.552 0 1 .448 1 1s-.448 1-1 1h-9.6c-.553 0-1 .447-1 1s.447 1 1 1h4.6c.552 0 1 .448 1 1s-.448 1-1 1h-5c-1.654 0-3 1.346-3 3s1.346 3 3 3c.553 0 1-.447 1-1s-.447-1-1-1c-.552 0-1-.448-1-1s.448-1 1-1h5c1.654 0 3-1.346 3-3 0-.353-.072-.686-.185-1h2.185c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
        },
        "children": []
      }]
    }]
  }]
};
exports.weatherWindyCloudy = weatherWindyCloudy;
var weatherWindy = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M19 5c-.553 0-1 .447-1 1s.447 1 1 1c.552 0 1 .448 1 1s-.448 1-1 1h-11c-.553 0-1 .447-1 1s.447 1 1 1h6c.552 0 1 .448 1 1s-.448 1-1 1h-6.4c-1.654 0-3 1.346-3 3s1.346 3 3 3c.553 0 1-.447 1-1s-.447-1-1-1c-.552 0-1-.448-1-1s.448-1 1-1h6.4c1.654 0 3-1.346 3-3 0-.353-.072-.686-.185-1h2.185c1.654 0 3-1.346 3-3s-1.346-3-3-3z"
    },
    "children": []
  }]
};
exports.weatherWindy = weatherWindy;
var wiFiOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M21.157 10.764c0-.785-.269-1.464-.706-2.048-.045-.094-.131-.149-.21-.226-.163-.18-.341-.338-.536-.48-4.45-3.739-10.965-3.735-15.414.006-.193.142-.742.738-.742.738-.437.584-.706 1.305-.706 2.09 0 .816.362 1.758.759 2.155l5.775 5.796c.642.732 1.572 1.204 2.622 1.204.996 0 1.709-.167 2.526-1 .004 0 5.565-5.646 5.565-5.646.706-.703 1.067-1.699 1.067-2.589zm-9.156 7.234c-.829.002-1.501-.668-1.501-1.498-.002-.828.67-1.502 1.501-1.502.829-.002 1.501.67 1.499 1.502.002.828-.67 1.5-1.499 1.498zm3.888-3.268c-.293.293-.677.438-1.061.438-.385 0-.768-.146-1.061-.438-.976-.976-2.562-.976-3.536 0-.586.586-1.536.584-2.122 0-.586-.586-.586-1.537 0-2.123 2.144-2.144 5.632-2.144 7.779 0 .587.586.587 1.538.001 2.123zm2.829-2.828c-.293.293-.677.438-1.061.438s-.769-.146-1.062-.438c-2.533-2.534-6.658-2.534-9.192 0-.586.584-1.536.584-2.122 0-.585-.586-.585-1.536 0-2.123 3.704-3.701 9.729-3.701 13.435 0 .587.588.587 1.537.002 2.123z"
    },
    "children": []
  }]
};
exports.wiFiOutline = wiFiOutline;
var wiFi = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13.414 19.412c.783-.779.783-2.047 0-2.826-.781-.785-2.049-.785-2.828-.002-.783.783-.783 2.051 0 2.831.781.78 2.049.781 2.828-.003zM20.485 11.515c-.512 0-1.024-.195-1.414-.586-3.899-3.899-10.243-3.898-14.143 0-.782.781-2.048.78-2.829 0-.781-.781-.781-2.047 0-2.829 5.459-5.458 14.341-5.458 19.799 0 .781.781.781 2.047 0 2.828-.389.391-.901.587-1.413.587zM7.757 15.757c-.512 0-1.024-.195-1.414-.586-.781-.781-.781-2.047 0-2.828 3.118-3.119 8.194-3.119 11.313 0 .781.781.781 2.047 0 2.829-.781.781-2.047.781-2.829 0-1.559-1.56-4.097-1.559-5.657 0-.389.39-.901.585-1.413.585z"
    },
    "children": []
  }]
};
exports.wiFi = wiFi;
var wine = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M17.568 9.432c0-2.55-.906-5.592-.944-5.72-.128-.423-.517-.712-.958-.712h-7.332c-.441 0-.83.289-.958.712-.038.128-.944 3.17-.944 5.72 0 2.735 1.984 5.011 4.587 5.477l-.019.091v4h-1c-.553 0-1 .447-1 1s.447 1 1 1h4c.553 0 1-.447 1-1s-.447-1-1-1h-1v-4l-.019-.092c2.603-.466 4.587-2.741 4.587-5.476zm-5.568 3.568c-1.773 0-3.236-1.303-3.511-3h7.021c-.274 1.697-1.737 3-3.51 3zm-3.555-4c.062-1.468.422-3.093.653-4h5.803c.231.907.591 2.532.653 4h-7.109z"
    },
    "children": []
  }]
};
exports.wine = wine;
var worldOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm0 6c0-.553.447-1 1-1s1 .447 1 1v3c-.552 0-1 .448-1 1s.448 1 1 1c.553 0 1-.448 1-1h1v-2l1 1-1 1c0 3 0 3-2 4 0-1-1-1-3-1v-2l-2-2v-2c-1 0-1 1-1 1l-.561-.561-1.652-1.651c1.167-2.247 3.512-3.788 6.213-3.788.688 0 1.353.104 1.981.29-.086.895-.579 1.71-1.481 1.71-1 0-1.5 1-1.5 2v3s1 0 1-3zm0 10c-3.859 0-7-3.14-7-7 0-.776.133-1.521.367-2.219l1.926 1.926 1 1 1.707 1.707v1.586c0 .552.447 1 1 1 .779 0 1.651 0 2.006.091.038.301.209.582.468.742.168.104.36.16.552.16.145 0 .289-.032.422-.098 2.348-1.174 2.539-1.644 2.552-4.479l.708-.708c.391-.391.391-1.023 0-1.414l-1-1c-.192-.192-.448-.294-.708-.294-.129 0-.259.025-.383.076-.373.155-.617.52-.617.924v-2c0-.689-.351-1.298-.883-1.658.421-.411.712-.995.826-1.685 2.392 1.115 4.057 3.535 4.057 6.343 0 3.86-3.141 7-7 7z"
    },
    "children": []
  }]
};
exports.worldOutline = worldOutline;
var world = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M12 2c-4.971 0-9 4.029-9 9s4.029 9 9 9 9-4.029 9-9-4.029-9-9-9zm2 2c0 1-.5 2-1.5 2s-1.5 1-1.5 2v3s1 0 1-3c0-.553.447-1 1-1s1 .447 1 1v3c-.552 0-1 .448-1 1s.448 1 1 1c.553 0 1-.448 1-1h1v-2l1 1-1 1c0 3 0 3-2 4 0-1-1-1-3-1v-2l-2-2v-2c-1 0-1 1-1 1l-.561-.561-2.39-2.39c.11-.192.225-.382.35-.564l.523-.678c1.468-1.716 3.644-2.807 6.078-2.807.691 0 1.359.098 2 .262v.738z"
    },
    "children": []
  }]
};
exports.world = world;
var zoomInOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 11h-2v-2c0-.275-.225-.5-.5-.5s-.5.225-.5.5v2h-2c-.275 0-.5.225-.5.5s.225.5.5.5h2v2c0 .275.225.5.5.5s.5-.225.5-.5v-2h2c.275 0 .5-.225.5-.5s-.225-.5-.5-.5zM19.381 15.956l-2.244-2.283c.227-.687.363-1.412.363-2.173 0-3.859-3.141-7-7-7s-7 3.141-7 7 3.141 7 7 7c.762 0 1.488-.137 2.173-.364l2.397 2.386c.601.506 1.348.783 2.104.783 1.727 0 3.131-1.404 3.131-3.131 0-.84-.328-1.628-.924-2.218zm-3.901-1.11l2.492 2.531c.205.203.332.486.332.797 0 .625-.507 1.131-1.131 1.131-.312 0-.594-.127-.816-.313l-2.512-2.511c.646-.436 1.201-.991 1.635-1.635zm-9.98-3.346c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5z"
    },
    "children": []
  }]
};
exports.zoomInOutline = zoomInOutline;
var zoomIn = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 11h-2v-2c0-.276-.224-.5-.5-.5s-.5.224-.5.5v2h-2c-.276 0-.5.224-.5.5s.224.5.5.5h2v2c0 .276.224.5.5.5s.5-.224.5-.5v-2h2c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM18.432 14.97l-.536-.537-.749-.75c.227-.688.354-1.42.354-2.183 0-3.859-3.141-7-7-7s-7 3.141-7 7 3.141 7 7 7c.763 0 1.496-.127 2.184-.354l.75.749 1.512 1.51.061.061.064.055c.601.506 1.348.784 2.104.784 1.726 0 3.13-1.404 3.13-3.131 0-.84-.328-1.628-.924-2.218l-.95-.986zm-12.932-3.47c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5z"
    },
    "children": []
  }]
};
exports.zoomIn = zoomIn;
var zoomOutOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 12h-5c-.275 0-.5-.225-.5-.5s.225-.5.5-.5h5c.275 0 .5.225.5.5s-.225.5-.5.5zM19.381 15.956l-2.245-2.283c.228-.687.364-1.412.364-2.173 0-3.859-3.141-7-7-7s-7 3.141-7 7 3.141 7 7 7c.761 0 1.488-.137 2.173-.364l2.397 2.386c.601.506 1.348.783 2.104.783 1.727 0 3.131-1.404 3.131-3.131 0-.84-.328-1.628-.924-2.218zm-3.901-1.11l2.492 2.531c.205.203.332.486.332.797 0 .625-.507 1.131-1.131 1.131-.312 0-.594-.127-.816-.313l-2.512-2.511c.646-.436 1.201-.991 1.635-1.635zm-9.98-3.346c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5z"
    },
    "children": []
  }]
};
exports.zoomOutOutline = zoomOutOutline;
var zoomOut = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 11h-5c-.276 0-.5.224-.5.5s.224.5.5.5h5c.276 0 .5-.224.5-.5s-.224-.5-.5-.5zM19.381 15.956l-.949-.986-.537-.537-.749-.75c.227-.688.354-1.42.354-2.183 0-3.859-3.14-7-7-7s-7 3.141-7 7 3.14 7 7 7c.763 0 1.496-.127 2.184-.354l.75.749 1.512 1.51.06.061.065.055c.601.506 1.348.784 2.104.784 1.726 0 3.13-1.404 3.13-3.131 0-.84-.328-1.628-.924-2.218zm-13.881-4.456c0-2.757 2.243-5 5-5s5 2.243 5 5-2.243 5-5 5-5-2.243-5-5z"
    },
    "children": []
  }]
};
exports.zoomOut = zoomOut;
var zoomOutline = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M14 8c1.656 0 3 1.344 3 3s-1.344 3-3 3-3-1.344-3-3 1.344-3 3-3m0-1c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zM4.195 17.674c0 1.727 1.404 3.131 3.131 3.131.756 0 1.503-.277 2.104-.783l2.397-2.386c.685.227 1.412.364 2.173.364 3.86 0 7-3.141 7-7s-3.14-7-7-7c-3.859 0-7 3.141-7 7 0 .761.136 1.486.364 2.173l-2.245 2.283c-.596.59-.924 1.378-.924 2.218zm6.459-1.694l-2.512 2.511c-.223.187-.504.313-.816.313-.624 0-1.131-.506-1.131-1.131 0-.311.127-.594.332-.797l2.492-2.531c.435.645.99 1.2 1.635 1.635zm3.346.02c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5z"
    },
    "children": []
  }]
};
exports.zoomOutline = zoomOutline;
var zoom = {
  "viewBox": "0 0 24 24",
  "children": [{
    "name": "path",
    "attribs": {
      "d": "M13 4c-3.859 0-7 3.141-7 7 0 .763.127 1.495.354 2.183l-.749.75-.511.512-1.008 1.045c-.562.557-.891 1.345-.891 2.185 0 1.727 1.404 3.131 3.13 3.131.757 0 1.504-.278 2.104-.784l.064-.055.061-.061 1.512-1.51.75-.749c.688.226 1.421.353 2.184.353 3.859 0 7-3.141 7-7s-3.141-7-7-7zm0 12c-2.757 0-5-2.243-5-5s2.243-5 5-5 5 2.243 5 5-2.243 5-5 5zM13 7c-2.205 0-4 1.794-4 4s1.795 4 4 4 4-1.794 4-4-1.795-4-4-4zm0 7c-1.656 0-3-1.344-3-3s1.344-3 3-3 3 1.344 3 3-1.344 3-3 3z"
    },
    "children": []
  }]
};
exports.zoom = zoom;

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4s171.2-381.4 381.4-381.4 381.4 171.2 381.4 381.4-171.2 381.4-381.4 381.4z",
      "M528 256h-32v240h-240v32h240v240h32v-240h240v-32h-240z"
    ],
    "grid": 0,
    "tags": [
      "ios-add-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 528h-240v240h-32v-240h-240v-32h240v-240h32v240h240v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-add-circle"
    ]
  },
  {
    "paths": [
      "M768 528h-240v240h-32v-240h-240v-32h240v-240h32v240h240v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-add"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M512 666.2c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32s-14.4-32-32-32z",
      "M488.4 466.4v-178.4h48v178.4l-12 141.6h-24l-12-141.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-alert-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM488.4 288h48v178.4l-12 141.6h-24l-12-141.6v-178.4zM512 730.2c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32 0 17.8-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-alert"
    ]
  },
  {
    "paths": [
      "M757.21 266.79c-145.406-145.408-378.45-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.508 170.79 77.852 0 130.384-7.316 130.384-7.316s59.97-430.452-163.472-653.894zM130.284 130.416c21.99-2.028 58.464-4.416 103.428-4.416h0.288l-0.136-0.142c54.334 0 106.334 3.508 155.584 10.44l-253.2 253.162c-2.050-14.566-3.82-29.394-5.28-44.492-9.172-94.87-4.172-176.456-0.684-214.552zM287.8 736.204c-47.7-47.704-85.586-109.876-112.608-184.792-13.946-38.664-25.020-80.746-33.14-125.732l283.624-283.58c21.344 3.858 42.128 8.382 62.282 13.608 104.054 26.984 187.566 71.416 248.278 132.128 47.702 47.7 85.572 109.856 112.594 184.772 13.948 38.666 25.018 80.75 33.134 125.742l-283.624 283.622c-21.32-3.86-42.082-8.382-62.208-13.602-104.060-26.978-187.612-71.452-248.332-132.166zM893.722 893.736c-21.988 2.024-58.46 4.55-103.42 4.55-54.384 0-106.45-3.54-155.752-10.5l253.214-253.214c2.048 14.558 3.816 29.376 5.276 44.466 9.176 94.874 4.172 176.596 0.682 214.698z",
      "M614.608 635.694l45.25 45.264-57.308 57.304 22.63 22.628 135.762-135.762-22.628-22.628-57.442 57.442-45.25-45.262 57.432-57.434-22.626-22.626-57.43 57.428-45.266-45.276 57.404-57.404-22.626-22.628-57.4 57.4-45.252-45.262 57.394-57.394-22.628-22.626-57.388 57.39-45.262-45.274 57.374-57.374-22.626-22.626-57.37 57.37-45.248-45.26 57.364-57.364-22.626-22.626-135.766 135.764 22.628 22.628 57.386-57.388 45.248 45.26-57.382 57.382 22.626 22.626 57.378-57.378 45.26 45.274-57.356 57.358 22.626 22.626 57.354-57.354 45.252 45.262-57.348 57.348 22.628 22.626 57.342-57.342 45.266 45.276-57.32 57.32 22.628 22.628z"
    ],
    "grid": 0,
    "tags": [
      "ios-american-football-outline"
    ]
  },
  {
    "paths": [
      "M757.21 266.79c-145.406-145.408-378.448-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.506 170.79 77.854 0 130.386-7.316 130.386-7.316s59.972-430.452-163.472-653.894zM136.248 389.456l253.166-253.164c12.246 1.722 24.328 3.65 36.224 5.798l-283.588 283.586c-2.14-11.874-4.076-23.952-5.802-36.22zM534.624 670.39l57.376-57.376-45.254-45.256-57.376 57.376-22.626-22.624 57.376-57.376-45.254-45.254-57.376 57.376-22.626-22.624 57.376-57.376-45.256-45.256-57.376 57.376-22.626-22.624 57.378-57.378-45.256-45.254-57.376 57.376-22.628-22.626 135.768-135.766 22.626 22.628-57.376 57.376 45.256 45.254 57.376-57.376 22.626 22.626-57.376 57.376 45.256 45.256 57.376-57.376 22.628 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.626 22.624-57.376 57.376 45.256 45.256 57.376-57.376 22.624 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.628 22.624-135.766 135.768-22.626-22.626 57.376-57.376-45.256-45.256-57.376 57.376-22.63-22.628zM634.518 887.782c-12.242-1.726-24.318-3.66-36.208-5.812l283.648-283.65c2.142 11.876 4.076 23.954 5.802 36.222l-253.242 253.24z"
    ],
    "grid": 0,
    "tags": [
      "ios-american-football"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM242.4 242.4c148.6-148.6 390.6-148.6 539.2 0 76 76 113 176.2 111.4 276-5.8-9.2-46.2-70.4-105-70.4-55.8 0-84.6 52.2-103.6 86.6-2.8 5.2-5.6 10-8 14.2-23.2 39-55.4 60.8-86.2 58.6-27.2-2-50.4-22.6-65.2-58.4-18.6-44.8-59.2-93-107.4-99.8-22.8-3.2-57.2 1.8-90.6 43.4-6.6 8.2-14 19-22.4 31.8-21.2 31.4-53 78.8-77.4 82.8-42 6.8-73.2-24.4-78.6-29.2-4-3.4-8.8-8.6-14.6-15.2-15-113.8 21-233.2 108.4-320.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0-48.4-48.4-81-106.6-97.8-168.2 14 11.4 38.6 26.6 71 26.6 5.4 0 11.2-0.4 17-1.4 38-6.2 71.6-56.2 98.8-96.4 7.8-11.6 15-22.4 20.8-29.6 19.4-24 40-34.8 61.2-31.8 25.8 3.6 62.2 32.4 82.2 80.4 19.8 47.4 52.6 75.2 92.6 78 43.2 3 86.6-24.8 116-74.2 2.8-4.6 5.6-9.6 8.4-15 17.2-31.2 38.6-70.2 75.4-70.2 22.2 0 41.8 14.6 54.4 26.8 14.8 14.4 18 18 25.8 29.2 6.8 9.6 13 17.4 20.6 33.4-11.6 77.8-47.4 152.6-107.2 212.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-analytics-outline"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM242.4 242.4c148.6-148.6 390.6-148.6 539.2 0 76 76 113 176.2 111.4 276-5.8-9.4-46.2-70.4-105-70.4-55.8 0-84.6 52.2-103.6 86.6-2.8 5.2-5.6 10-8 14.2-23.2 39-55.4 60.8-86.2 58.6-27.2-2-50.4-22.6-65.2-58.4-18.6-44.8-59.2-93-107.4-99.8-22.8-3.2-57.2 1.8-90.6 43.4-6.6 8.2-14 19-22.4 31.8-21.2 31.4-53 78.8-77.4 82.8-42 6.8-73.2-24.4-78.6-29.2-4-3.4-8.8-8.6-14.4-15-15.2-114 20.8-233.4 108.2-320.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-analytics"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416 0 131 60.6 247.8 155.2 324.2l-1.2 2.2 16.6 9.6c68.8 50.4 153.6 80 245.4 80 229.8 0 416-186.2 416-416s-186.2-416-416-416zM865.8 362.6c20 47.4 30.2 97.6 30.2 149.4 0 10.8-0.4 21.4-1.4 32h-325.6l188.8-327c8.8 7.4 17.4 15.2 25.8 23.4 35.2 35.4 62.8 76.4 82.2 122.2zM474 514.2l19.8-34.2h37.4l18.8 32.8-18 31.2h-40.8l-17.2-29.8zM661.4 158.2c25 10.6 48.6 23.8 70.8 39.2l-163.6 283.4-190-329c42.6-15.8 87.4-23.8 133.4-23.8 51.8 0 102.2 10.2 149.4 30.2zM240.4 240.4c31.8-31.8 68.2-57.4 108.4-76.2l164 283.8h-379.4c5-29.4 13.2-57.8 24.8-85.4 19.4-45.8 47-86.8 82.2-122.2zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-19.8-47.4-30-97.8-30-149.6 0-10.8 0.4-21.4 1.4-32h327.6l-189.4 328c-9.4-7.6-18.4-15.8-27.2-24.4zM362.6 865.8c-24.6-10.4-47.8-23.2-69.4-38.2l162.4-281.4 188.4 326.4c-42.2 15.4-86.6 23.4-132 23.4-51.8 0-102.2-10.2-149.4-30.2zM783.6 783.6c-32 32-68.8 57.8-109.6 76.8l-164.2-284.4h381c-5 29.4-13.2 57.8-24.8 85.4-19.6 45.8-47.2 86.8-82.4 122.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-aperture-outline"
    ]
  },
  {
    "paths": [
      "M493.8 480l-19.8 34.2 17.2 29.8h40.8l18.2-31.2-19-32.8z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM509.8 576l164.2 284.2c-4.2 2-8.2 3.8-12.4 5.6-5.8 2.4-11.6 4.8-17.4 6.8l-188.4-326.4-162.4 281.4c-8.8-6.2-17.4-12.6-25.6-19.4l189.4-328h-327.8c0.8-10.8 2.2-21.4 4-32h379.4l-163.8-284c4.4-2.2 9-4.2 13.6-6 5.4-2.2 10.8-4.4 16.2-6.4l190 329 163.6-283.4c8.8 6.2 17.4 12.8 25.6 19.6l-189 327h325.6c-0.8 10.8-2.2 21.4-4 32h-380.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-aperture"
    ]
  },
  {
    "paths": [
      "M308 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M564 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M820 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M308 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M564 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M820 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M308 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M564 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z",
      "M820 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-apps-outline"
    ]
  },
  {
    "paths": [
      "M308 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M564 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M820 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M308 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M564 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M820 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M308 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M564 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z",
      "M820 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z"
    ],
    "grid": 0,
    "tags": [
      "ios-apps"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M278.6 704l68.4-57.6-49.4-32.4z",
      "M684.4 596c-13.6 6.4-30.4 28-7.8 57.2 18.2 23.4 36 17.4 53 50.8 9.6-8.2 18.8-43.4 14.6-71.4-4.8-30.6-24.6-53-59.8-36.6z",
      "M503.2 379.2c3.2-5.4 1.2-12.6-4.2-15.8l-30.2-17.2c-5.6-3.2-12.6-1.2-15.8 4.2l-111.8 193.6-33.8 58.4 49.8 30 87.8-152.6 58.2-100.6z",
      "M461.2 480l-37 64h178.4l-36.2-64z",
      "M702 544h66v-64h-102z",
      "M362.2 480h-106.2v64h69.2z",
      "M649.2 480l-120-211.6c-3.2-5.6-10.4-7.4-15.8-4.2l-30.2 17.2c-5.6 3.2-7.4 10.2-4.2 15.8l140 247.4 1-0.6 48.8-29.6-19.6-34.4z",
      "M686.4 544l-9.8-17.4-49.6 30 26 46 49.8-30.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-appstore-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM256 480h106.2l-37 64h-69.2v-64zM278.6 704l19-90 49.6 32.4-68.6 57.6zM357.2 632.6l-49.8-30 33.8-58.4 37-64 74.8-129.6c3.2-5.6 10.4-7.4 15.8-4.2l30.2 17.2c5.6 3.2 7.4 10.2 4.2 15.8l-94.8 164.8-51.2 88.4zM424.2 544l36.8-64h105.4l36.2 64h-178.4zM619 544.6l-0.4-0.6-139.6-246.8c-3.2-5.4-1.2-12.6 4.2-15.8l30.2-17.2c5.6-3.2 12.6-1.2 15.8 4.2l120 211.6 19.6 34.4-49.8 30.2zM627 556.6l49.6-30 10 17.4 16.2 28.4-49.8 30-26-45.8zM729.4 704c-17-33.6-34.8-27.4-53-50.8-22.6-29.2-5.8-50.8 7.8-57.2 35.2-16.4 55 6 59.6 36.6 4.4 28-4.8 63.2-14.4 71.4zM768 544h-66l-36-64h102v64z"
    ],
    "grid": 0,
    "tags": [
      "ios-appstore"
    ]
  },
  {
    "paths": [
      "M575.6 480c17.6 0 32.2 14.4 32.2 32s-14 32-31.8 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32h126zM576 448h-128c-35.2 0-64 28.8-64 64s28.8 64 64 64h128c35.2 0 64-28.8 64-64s-28.8-64-64-64v0z",
      "M832 224h-640v160h32v416h576v-416h32v-160zM768 768h-512v-384h512v384zM800 352h-576v-96h576v96z"
    ],
    "grid": 0,
    "tags": [
      "ios-archive-outline"
    ]
  },
  {
    "paths": [
      "M224 800h576v-384h-576v384zM448 480h128c17.6 0 32 14.4 32 32s-14.4 32-32 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32z",
      "M192 224v160h640v-160z"
    ],
    "grid": 0,
    "tags": [
      "ios-archive"
    ]
  },
  {
    "paths": [
      "M256.8 320l-64.8 64.6 320 319.4 320-319.4-64.8-64.6-255.2 254.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-down"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM512 616.8l186.4-200.8 25.6 27.6-212 228.4-212-228.4 25.6-27.6 186.4 200.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropdown-circle"
    ]
  },
  {
    "paths": [
      "M698.4 416l25.6 27.6-212 228.4-212-228.4 25.6-27.6 186.4 200.8z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 210.2-171 381.4-381.4 381.4-210.2 0-381.4-171-381.4-381.4-0-210.2 171.2-381.4 381.4-381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropdown"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM608 698.4l-27.6 25.6-228.4-212 228.4-212 27.6 25.6-200.8 186.4 200.8 186.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropleft-circle"
    ]
  },
  {
    "paths": [
      "M608 325.6l-27.6-25.6-228.4 212 228.4 212 27.6-25.6-200.8-186.4z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropleft"
    ]
  },
  {
    "paths": [
      "M96 512c0 229.8 186.2 416 416 416s416-186.2 416-416-186.2-416-416-416c-229.8 0-416 186.2-416 416zM616.8 512l-200.8-186.4 27.6-25.6 228.4 212-228.4 212-27.6-25.6 200.8-186.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropright-circle"
    ]
  },
  {
    "paths": [
      "M416 325.6l27.6-25.6 228.4 212-228.4 212-27.6-25.6 200.8-186.4z",
      "M96 512c0 229.8 186.2 416 416 416s416-186.2 416-416-186.2-416-416-416c-229.8 0-416 186.2-416 416zM130.6 512c0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171 381.4-381.4 381.4-210.2 0-381.4-171.2-381.4-381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropright"
    ]
  },
  {
    "paths": [
      "M512 928c229.8 0 416-186.2 416-416s-186.2-416-416-416-416 186.2-416 416c0 229.8 186.2 416 416 416zM512 407.2l-186.4 200.8-25.6-27.6 212-228.4 212 228.4-25.6 27.6-186.4-200.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropup-circle"
    ]
  },
  {
    "paths": [
      "M325.6 608l-25.6-27.6 212-228.4 212 228.4-25.6 27.6-186.4-200.8z",
      "M512 928c229.8 0 416-186.2 416-416s-186.2-416-416-416-416 186.2-416 416c0 229.8 186.2 416 416 416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-dropup"
    ]
  },
  {
    "paths": [
      "M574.6 512l-254.6 255.2 64.6 64.8 319.4-320-319.4-320-64.6 64.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-forward"
    ]
  },
  {
    "paths": [
      "M752 496h-441.4l132.6-148.8c5.8-6.8 6.4-16.2 0.2-22.4s-17-6.6-22.8-0.2l-160 176c-0.4 0.4-0.8 0.8-1 1.2-0.2 0.2-0.2 0.4-0.4 0.6s-0.4 0.4-0.6 0.8c-0.2 0.2-0.2 0.4-0.4 0.6s-0.2 0.4-0.4 0.6c-0.2 0.2-0.2 0.4-0.4 0.8-0.2 0.2-0.2 0.4-0.4 0.6 0 0.2-0.2 0.4-0.2 0.8 0 0.2-0.2 0.6-0.2 0.8s-0.2 0.4-0.2 0.8c0 0.2-0.2 0.6-0.2 0.8s0 0.6-0.2 0.8c0 0.2 0 0.4 0 0.6-0.2 1-0.2 2.2 0 3.2 0 0.2 0 0.4 0 0.6s0 0.6 0.2 0.8c0 0.2 0.2 0.6 0.2 0.8s0.2 0.4 0.2 0.8c0 0.2 0.2 0.6 0.2 0.8s0.2 0.4 0.2 0.8c0 0.2 0.2 0.4 0.4 0.6s0.2 0.4 0.4 0.8c0.2 0.2 0.2 0.4 0.4 0.6s0.2 0.4 0.4 0.6c0.2 0.2 0.4 0.4 0.6 0.8 0.2 0.2 0.2 0.4 0.4 0.6 0.4 0.4 0.6 0.8 1 1.2l160 176c3.2 3.4 7.2 4.6 11.4 4.6 4 0 8.2-1.6 11.4-4.6 6.2-6.2 6-16 0-22.6l-132.8-148.8h441.4c8.8 0 16-7.2 16-16s-7.2-16-16-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-round-back"
    ]
  },
  {
    "paths": [
      "M496 272v441.4l-148.8-132.6c-6.8-5.8-16.2-6.4-22.4-0.2s-6.6 17-0.2 22.8l176 160c0.4 0.4 0.8 0.8 1.2 1 0.2 0.2 0.4 0.2 0.6 0.4s0.4 0.4 0.8 0.6c0.2 0.2 0.4 0.2 0.6 0.4s0.4 0.2 0.6 0.4c0.2 0.2 0.4 0.2 0.8 0.4 0.2 0.2 0.4 0.2 0.6 0.4 0.2 0 0.4 0.2 0.8 0.2 0.2 0 0.6 0.2 0.8 0.2s0.4 0.2 0.8 0.2c0.2 0 0.6 0.2 0.8 0.2s0.6 0 0.8 0.2c0.2 0 0.4 0 0.6 0 1 0.2 2.2 0.2 3.2 0 0.2 0 0.4 0 0.6 0s0.6 0 0.8-0.2c0.2 0 0.6-0.2 0.8-0.2s0.4-0.2 0.8-0.2c0.2 0 0.6-0.2 0.8-0.2s0.4-0.2 0.8-0.2c0.2 0 0.4-0.2 0.6-0.4s0.4-0.2 0.8-0.4c0.2-0.2 0.4-0.2 0.6-0.4s0.4-0.2 0.6-0.4c0.2-0.2 0.4-0.4 0.8-0.6 0.2-0.2 0.4-0.2 0.6-0.4 0.4-0.4 0.8-0.6 1.2-1l176-160c3.4-3.2 4.6-7.2 4.6-11.4 0-4-1.6-8.2-4.6-11.4-6.2-6.2-16-6-22.6 0l-148.8 132.8v-441.4c0-8.8-7.2-16-16-16s-16 7.2-16 16z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-round-down"
    ]
  },
  {
    "paths": [
      "M272 528h441.4l-132.6 148.8c-5.8 6.8-6.4 16.2-0.2 22.4s17 6.6 22.8 0.2l160-176c0.4-0.4 0.8-0.8 1-1.2 0.2-0.2 0.2-0.4 0.4-0.6s0.4-0.4 0.6-0.8c0.2-0.2 0.2-0.4 0.4-0.6s0.2-0.4 0.4-0.6c0.2-0.2 0.2-0.4 0.4-0.8 0.2-0.2 0.2-0.4 0.4-0.6 0-0.2 0.2-0.4 0.2-0.8 0-0.2 0.2-0.6 0.2-0.8s0.2-0.4 0.2-0.8c0-0.2 0.2-0.6 0.2-0.8s0-0.6 0.2-0.8c0-0.2 0-0.4 0-0.6 0.2-1 0.2-2.2 0-3.2 0-0.2 0-0.4 0-0.6s0-0.6-0.2-0.8c0-0.2-0.2-0.6-0.2-0.8s-0.2-0.4-0.2-0.8c0-0.2-0.2-0.6-0.2-0.8s-0.2-0.4-0.2-0.8c0-0.2-0.2-0.4-0.4-0.6s-0.2-0.4-0.4-0.8c-0.2-0.2-0.2-0.4-0.4-0.6s-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.4-0.6-0.8-0.2-0.2-0.2-0.4-0.4-0.6-0.4-0.4-0.6-0.8-1-1.2l-160-176c-3.2-3.4-7.2-4.6-11.4-4.6-4 0-8.2 1.6-11.4 4.6-6.2 6.2-6 16 0 22.6l132.6 148.6h-441.2c-8.8 0-16 7.2-16 16 0 9 7.2 16.2 16 16.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-round-forward"
    ]
  },
  {
    "paths": [
      "M528 752v-441.4l148.8 132.6c6.8 5.8 16.2 6.4 22.4 0.2s6.6-17 0.2-22.8l-176-160c-0.4-0.4-0.8-0.8-1.2-1-0.2-0.2-0.4-0.2-0.6-0.4s-0.4-0.4-0.8-0.6c-0.2-0.2-0.4-0.2-0.6-0.4s-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.2-0.8-0.4-0.2-0.2-0.4-0.2-0.6-0.4-0.2 0-0.4-0.2-0.8-0.2-0.2 0-0.6-0.2-0.8-0.2s-0.4-0.2-0.8-0.2c-0.2 0-0.6-0.2-0.8-0.2s-0.6 0-0.8-0.2c-0.2 0-0.4 0-0.6 0-1-0.2-2.2-0.2-3.2 0-0.2 0-0.4 0-0.6 0s-0.6 0-0.8 0.2c-0.2 0-0.6 0.2-0.8 0.2s-0.4 0.2-0.8 0.2c-0.2 0-0.6 0.2-0.8 0.2s-0.4 0.2-0.8 0.2c-0.2 0-0.4 0.2-0.6 0.4s-0.4 0.2-0.8 0.4c-0.2 0.2-0.4 0.2-0.6 0.4s-0.4 0.2-0.6 0.4c-0.2 0.2-0.4 0.4-0.8 0.6-0.2 0.2-0.4 0.2-0.6 0.4-0.4 0.4-0.8 0.6-1.2 1l-176 160c-3.4 3.2-4.6 7.2-4.6 11.4 0 4 1.6 8.2 4.6 11.4 6.2 6.2 16 6 22.6 0l148.6-132.6v441.2c0 8.8 7.2 16 16 16 9 0 16.2-7.2 16.2-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-round-up"
    ]
  },
  {
    "paths": [
      "M767.2 704l64.8-64.6-320-319.4-320 319.4 64.8 64.6 255.2-254.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-up"
    ]
  },
  {
    "paths": [
      "M867.8 689.2c-65.8 127.6-195.2 206.8-337.6 206.8-101 0-194.6-39.8-263.8-112.2-68.8-72-106.6-168.4-106.6-271.8s37.8-199.8 106.6-271.8c69.2-72.4 163-112.2 263.8-112.2 101.8 0 187.8 38.6 242.2 108.4 52.6 67.6 69 156.2 46.4 249.8-21.8 90.2-67 131.6-101 150.4-35 19.4-83.6 26.8-104.8 8.8v0c-0.6-0.6-1.2-1.2-1.6-1.8-3-3.8-4.6-10.8-4.8-17s0.4-13.4 2-21.4c1.6-8 3.8-16.8 6.4-25.4l77.2-233.8h-42.6l-20 53c-9.2-24.2-21.2-41.6-36.2-52-15-10.6-31.4-15.8-49-15.8-28.4 0-54.4 7-77.8 20.8-23.6 13.8-43.6 31.8-60.2 54.2s-29.4 47.6-38.6 75.4c-9.2 27.8-13.6 55.8-13.6 83.8 0 16.2 2.4 31.4 7.2 45.4s11.8 26.4 20.8 37.2c9 10.8 20.2 19.4 33.4 25.6s28 9.4 44.6 9.4c20.4 0 39.4-5.4 57-16.8s32.6-24.2 45-36.2h1.6c1.6 18 9.4 31 19.6 40.2 5.2 4.6 12.6 9 22.2 12.2v0.2c42.2 14.4 84.2 6 127.6-18 39.6-22 92.2-69.4 116.6-171 25-103.2 6.4-201.6-52.4-277.2-60.4-77.6-155.4-120.4-267.2-120.4-109.6 0-211.4 43.4-286.6 122-74.6 78-115.6 182.4-115.6 294s41 216 115.6 294c75.2 78.8 177.2 122 286.6 122 154.2 0 294.4-85.8 365.8-224l-28.2-14.8zM567 572.8c-12.2 19.6-26.6 36-43 49.6-16.4 13.4-34 20.2-53.2 20.2-19.6 0-35.8-7.2-48.6-21.4-12.8-14.4-19.2-33.8-19.2-58.6 0-19.2 3.2-40 9.8-62.4 6.6-22.2 16-43 28.2-62s27-34.8 44.2-47.4c17.2-12.6 36.2-19 56.8-19 8.2 0 16 2.2 23.8 6.6 7.6 4.4 14.4 10.2 20.4 17.4s11 15.2 14.8 24.4c3.8 9 5.8 18.6 5.8 28.4 0 18.2-3.6 38.6-10.6 61.2-7.2 22.4-17 43.4-29.2 63z"
    ],
    "grid": 0,
    "tags": [
      "ios-at-outline"
    ]
  },
  {
    "paths": [
      "M768 184.2c10.6 10 20.4 21 29.4 32.6 58.8 75.4 77.4 173.8 52.4 277.2-24.6 101.4-77 149-116.6 171-43.4 24-85.4 32.4-127.6 18v-0.2c-9.6-3.2-17-7.6-22.2-12.2-10.2-9.2-18-22.2-19.6-40.2h-1.6c-12.4 12-27.2 24.8-45 36.2s-36.6 16.8-57 16.8c-16.6 0-31.4-3-44.6-9.4-13.2-6.2-24.2-14.8-33.4-25.6s-16-23.2-20.8-37.2c-4.8-14-7.2-29.2-7.2-45.4 0-28 4.6-56 13.6-83.8s22-53 38.6-75.4c16.6-22.4 36.6-40.6 60.2-54.2 23.6-13.8 49.4-20.8 77.8-20.8 17.6 0 34 5.2 49 15.8s27 27.8 36.2 52l20-53h42.6l-77 233.6c-2.6 8.6-4.8 17.4-6.4 25.4s-2.2 15.2-2 21.4c0.2 6.2 1.8 13.2 4.8 17 0.4 0.6 1 1.2 1.6 1.8 21.2 18.2 69.8 10.6 104.8-8.8 34.2-18.8 79.4-60.2 101-150.4 22.6-93.6 6-182.2-46.4-249.8-45.6-58.4-109.2-117.6-193.6-133-27.8-5-44.2-7.6-67-7.6-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-133.2-62.6-251.8-160-327.8z",
      "M422.2 621.2c12.8 14.2 29 21.4 48.6 21.4 19.2 0 36.8-6.8 53.2-20.2 16.4-13.6 30.8-30 43-49.6s22-40.6 29-63.2 10.6-43 10.8-61c0-9.8-2-19.4-5.8-28.4-2-4.6-4.2-9-6.6-13.2-2.4-4-5.2-7.8-8.2-11.4-6-7.2-12.8-13-20.4-17.4s-15.6-6.6-23.8-6.6c-20.8 0-39.6 6.4-56.8 19s-32 28.4-44.2 47.4c-12.2 19-21.6 39.6-28.2 62-6.6 22.2-9.8 43-9.8 62.4 0 0 0 0 0 0.2 0 0 0 0 0 0 0 24.8 6.4 44.2 19.2 58.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-at"
    ]
  },
  {
    "paths": [
      "M687 383c-9.4 0-17 7.6-17 17v314c0 38-15 76.4-41.8 104.8-27.4 28.8-66.6 45.2-104.2 45.2h-24c-79 0-148-72-148-150v-442.2c0-61.2 50.8-109.6 112-109.6s110 48.4 110 109.6v428.6c0 34.4-27.2 67.6-62 67.6s-64-33-64-67.6v-236.4c0-9.4-7.6-17-17-17s-17 7.6-17 17v236.4c0 57.6 44.6 99.6 98 99.6s96-40 96-99.6v-428.6c0-79.8-64.8-143.8-144.6-143.8s-143.4 64-143.4 143.8v442.2c0 46.4 19 93.6 54.6 128.6 35.4 34.8 79 53.4 125.4 53.4h24c96 0 180-82.8 180-182v-314c0-9.4-7.6-17-17-17z"
    ],
    "grid": 0,
    "tags": [
      "ios-attach"
    ]
  },
  {
    "paths": [
      "M790 192h-330c-93.4 0-146.4 69.4-204 127s-144.2 149.4-144.2 149.4c-9.8 11.2-15.8 25.6-15.8 41.8 0 16 6 30.6 15.8 42 0 0 68.6 75.2 144.2 151 75.6 75.6 113.4 129 204 129h330c77 0 138-65 138-142v-360.2c0-77-61-138-138-138zM896 690c0 29-10.6 56.8-31 77.4-20.2 20.8-46.6 32.6-75 32.6h-330c-65.2 0-96.4-32.6-153-90.8l-171.4-178.4c-3.6-4.2-7.6-11.2-7.6-20.8 0-9.4 4-16.4 7.6-20.6l166.2-172.2c24.4-25.4 47.6-49 73.8-66.6 27.6-18.6 54.4-26.8 84.4-26.8h330c28.6 0 55 10.6 75.2 30.8s30.8 46.6 30.8 75.2v360.2z",
      "M632.8 512l127.2-126.8-29.2-29.2-127.2 127-126.4-126.4-29.2 29.2 126.6 126.2-126.6 126.4 29.2 29 126.4-126.2 127.2 126.8 29.2-29z"
    ],
    "grid": 0,
    "tags": [
      "ios-backspace-outline"
    ]
  },
  {
    "paths": [
      "M790 192h-330c-93.4 0-146.4 69.4-204 127s-144.2 149.4-144.2 149.4c-9.8 11.2-15.8 25.6-15.8 41.8 0 16 6 30.6 15.8 42 0 0 68.6 75.2 144.2 151 75.6 75.6 113.4 129 204 129h330c77 0 138-65 138-142v-360.2c0-77-61-138-138-138zM730.8 668l-127.2-126.8-126.6 126.2-29-29 126.6-126.4-126.6-126.2 29.2-29.2 126.6 126.4 127.2-127 29.2 29.2-127.4 126.8 127.2 127-29.2 29z"
    ],
    "grid": 0,
    "tags": [
      "ios-backspace"
    ]
  },
  {
    "paths": [
      "M800 448v-192c0-70.4-57.6-128-128-128h-320c-70.4 0-128 57.6-128 128v192h-160l105 388.6c9.4 34 40.8 59.4 78.2 59.4h529.4c37.4 0 68.8-25 78.6-59l104.8-389h-160zM918 480h0.2l-25.8 96h-156.4v-96h182zM140.4 608h147.6v128h-113l-34.6-128zM320 608h176v128h-176v-128zM704 576h-176v-96h176v96zM496 576h-176v-96h176v96zM496 768v96h-176v-96h176zM528 768h176v96h-176v-96zM528 736v-128h176v128h-176zM736 608h147.8l-34.4 128h-113.4v-128zM256 256c0-25.6 10-49.6 28.2-67.8s42.2-28.2 67.8-28.2h320c25.6 0 49.6 10 67.8 28.2s28.2 42.2 28.2 67.8v192h-512v-192zM288 480v96h-156.2l-26-96h182.2zM200 828.2l-16.4-60.2h104.4v96h-40.8c-22 0-41.4-14.6-47.2-35.8zM824.6 828.4c-6.2 21-25.8 35.6-47.8 35.6h-40.8v-96h104.8l-16.2 60.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-basket-outline"
    ]
  },
  {
    "paths": [
      "M800 448v-192c0-70.4-57.6-128-128-128h-320c-70.4 0-128 57.6-128 128v192h-160l105 388.6c9.4 34 40.8 59.4 78.2 59.4h529.4c37.4 0 68.8-25 78.6-59l104.8-389h-160zM256 256c0-25.6 10-49.6 28.2-67.8s42.2-28.2 67.8-28.2h320c25.6 0 49.6 10 67.8 28.2s28.2 42.2 28.2 67.8v192h-512v-192zM883.8 608h-147.8v128h113.4l-8.6 32h-104.8v96h-32v-96h-176v96h-32v-96h-176v96h-32v-96h-104.4l-8.6-32h113v-128h-147.6l-8.6-32h156.2v-96h32v96h176v-96h32v96h176v-96h32v96h156.4l-8.6 32z",
      "M528 608h176v128h-176v-128z",
      "M320 608h176v128h-176v-128z"
    ],
    "grid": 0,
    "tags": [
      "ios-basket"
    ]
  },
  {
    "paths": [
      "M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z",
      "M740 352h-552c-17.6 0-28 10.4-28 28v264c0 17.6 10.4 28 28 28h552c17.6 0 28-10.4 28-28v-264c0-17.6-10.4-28-28-28zM437.6 616l16.8-86h-54.4l90.4-122-16.8 86h54.4l-90.4 122z",
      "M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-battery-charging"
    ]
  },
  {
    "paths": [
      "M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z",
      "M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-battery-dead"
    ]
  },
  {
    "paths": [
      "M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z",
      "M740 352h-552c-17.6 0-28 10.4-28 28v264c0 17.6 10.4 28 28 28h552c17.6 0 28-10.4 28-28v-264c0-17.6-10.4-28-28-28z",
      "M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-battery-full"
    ]
  },
  {
    "paths": [
      "M890.4 96h-633.6c-108.6 0-128.8 55.8-128.8 80.4 60.6 8.4 64 8.4 64 72.4 0 32 0 551 0 551 0 70.6 57.6 128 128.4 128h415.6c70.8 0 126-58.4 126-129v-620.4c4-35 25-63.2 27.2-66.6 2.4-3.8 6.8-8.8 6.8-11 0-2.4-0.6-4.8-5.6-4.8zM830 178.6v620.4c0 26-9.4 48.8-27.4 67.4s-41 29.6-66.4 29.6h-416c-52.8 0-96.2-43.8-96.2-97v-550c0-33.4 0.6-61.6-16.6-80.8-8.6-9.6-21.2-12.6-34.6-16.4 11.4-10 35.4-24 84.2-24h587.2c0 0.2-14.2 12.8-14.2 50.8z",
      "M766 352v416c0 20.4-3.6 36-11 43.8-11.4 11.6-27.6 20.4-40.2 20.4h-374c-17.6 0-30.8-5.4-39-15.8-8.8-10.8-13.8-28.6-13.8-50.2v-414.2h478zM798 320h-542v446c0 56.6 27.4 98 84.8 98h374c22.8 0 46.8-13.4 63-30 16.2-16.8 20.2-42.6 20.2-66v-448z"
    ],
    "grid": 0,
    "tags": [
      "ios-beaker-outline"
    ]
  },
  {
    "paths": [
      "M340.8 832h374c12.6 0 28.8-8.6 40.2-20.4 7.6-7.8 11-23.2 11-43.8v-415.8h-478v414c0 21.6 5.2 39.4 13.8 50.2 8.2 10.4 21.4 15.8 39 15.8z",
      "M890.4 96h-633.4c-108.8 0-129 55.8-129 80.4 60.6 8.4 64 8.4 64 72.4 0 32 0 551 0 551 0 70.6 57.8 128 128.4 128h415.6c70.8 0 126-58.4 126-129v-620.4c4-35 25-63.2 27.2-66.6 2.4-3.8 6.8-8.8 6.8-11 0-2.4-0.6-4.8-5.6-4.8zM798 768c0 23.4-3.8 49.2-20.2 66-16.2 16.6-40.4 30-63 30h-374c-57.4 0-84.8-41.4-84.8-98v-446h542v448z"
    ],
    "grid": 0,
    "tags": [
      "ios-beaker"
    ]
  },
  {
    "paths": [
      "M767.4 236.6c0-41.6-34.4-76.6-76.2-76.6l-21-1.4c-12-54-64-94.6-118.2-94.6s-82.2 23.2-103.4 57.8c-17-19.6-42.2-30.8-70.4-30.8-36.6 0-68.2 23-83.4 53h-48.8c-50 0-86 39.2-86 90.8v8c0 57.6 32 41.8 32 79.6 0 35.6 0 213.6 0 213.6 0 26.8-22.4 38.6-22.4 70.4 0 17.6 16 33.6 33.6 33.6h20.8v-352h544c0 0-0.6-9.8-0.6-51.4zM735.2 256h-512.8c0 0-15.6 0-21.6 0s-8.8-7.6-8.8-13.2v-8c0-17.8 6.8-32.8 16.4-43.8 9.2-10.6 22.8-15 37.6-15h69l8.6-19.2c10-21 30.8-34.4 54.6-34.4 18 0 37 10.2 52.4 22.2l21.4 18.6 16-20c22.6-30 52.8-47.6 84.2-47.6 20.6 0 40 6.8 56 19.8 15.6 12.6 26.6 30.2 30.8 49.6l5.2 23.6c0 0 18.8-0.8 47 3.2s44.2 20.8 44.2 44.8l-0.2 19.4z",
      "M616 448c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z",
      "M544 544c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M576 704c0 13.255-10.745 24-24 24s-24-10.745-24-24c0-13.255 10.745-24 24-24s24 10.745 24 24z",
      "M192 928h608v32h-608v-32z",
      "M832 416h-96v-96h-480v544l-32 32h544l-32-32v-128h96c17.6 0 32-14.4 32-32v-256c0-17.6-14.4-32-32-32zM704 864h-416v-512h416v512zM832 704c0 0 0 0 0 0h-96v-256h96c0 0 0 0 0 0v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-beer-outline"
    ]
  },
  {
    "paths": [
      "M224 640v-352h544c0 0-0.6-9.8-0.6-51.4s-34.4-76.6-76.2-76.6l-21-1.4c-12-54-64-94.6-118.2-94.6s-82.2 23.2-103.4 57.8c-17-19.6-42.2-30.8-70.4-30.8-36.6 0-68.2 23-83.4 53h-48.8c-50 0-86 39.2-86 90.8v8c0 57.6 32 41.8 32 79.6 0 35.6 0 213.6 0 213.6 0 26.8-22.4 38.6-22.4 70.4 0 17.6 16 33.6 33.6 33.6h20.8z",
      "M832 416h-96v-96h-480v544l-64 64v32h608v-32l-64-64v-128h96c17.6 0 32-14.4 32-32v-256c0-17.6-14.4-32-32-32zM576 408c22 0 40 18 40 40s-18 40-40 40-40-18-40-40 18-40 40-40zM576 704c0 13.2-10.8 24-24 24s-24-10.8-24-24 10.8-24 24-24 24 10.8 24 24zM512 512c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM832 704v0h-96v-256h96v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-beer"
    ]
  },
  {
    "paths": [
      "M250.6 522.6c-102.6 0-186.6 84-186.6 186.6 0 102.8 84 186.8 186.6 186.8s186.6-84 186.6-186.6c0.2-102.8-83.8-186.8-186.6-186.8zM359.8 818.6c-29.4 29.4-68 45.4-109.2 45.4s-79.8-16.2-109.2-45.4-45.4-68.2-45.4-109.2c0-41.2 16.2-79.8 45.4-109.2 29.4-29.4 68-45.4 109.2-45.4s79.8 16.2 109.2 45.4c29.4 29.4 45.4 68 45.4 109.2 0.2 41-16 79.8-45.4 109.2z",
      "M639.6 255.6c35.6 0 64-28.4 64-64s-28-63.6-63.6-63.6c-35.6 0-64.4 28-64.4 63.6s28.6 64 64 64z",
      "M773.4 522.6c-102.6 0-186.6 84-186.6 186.6s84 186.6 186.6 186.6c102.6 0 186.6-84 186.6-186.6s-84-186.6-186.6-186.6zM882.6 818.6c-29.4 29.4-68 45.4-109.2 45.4s-79.8-16.2-109.2-45.4c-29.4-29.4-45.4-68-45.4-109.2s16.2-79.8 45.4-109.2c29.4-29.4 68-45.4 109.2-45.4s79.8 16.2 109.2 45.4c29.4 29.4 45.4 68 45.4 109.2 0 41-16.2 79.8-45.4 109.2z",
      "M736 384h-96l-59-120.2c-11.2-18.6-31.8-31.8-54.2-31.8-16.8 0-33.6 7.4-44.8 18.6l-143.4 138.2c-11.2 11.2-18.6 28-18.6 44.8 0 34.8 25.2 47.2 37 54.2 91 52.4 123 58.2 123 84.4s0 131.8 0 131.8c0 17.6 14.4 32 32 32s32-14.4 32-32c0 0 0-153.6 0-180s-60.8-48-96.6-76l97.8-103c37.4 57 54.6 103 76 103s114.8 0 114.8 0c17.6 0 32-14.4 32-32s-14.4-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-bicycle"
    ]
  },
  {
    "paths": [
      "M572 512l196-174-256.4-274h-31.6v360l-178.8-154-45.2 50 224 192-224 192 45.2 51.6 178.8-157.6v362h31.6l0.4-0.8 256-271.2-196-176zM675.6 689l-131.6 141v-255.6l131.6 114.6zM544 451.2v-257l131.6 142.4-131.6 114.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-bluetooth"
    ]
  },
  {
    "paths": [
      "M512 895.6c-59.2 0-139.8-13.4-192-31.6 0 0-70 45-160 64 64.6 0 106.6-18 160-32 46 18 133.4 31.6 192 31.6s148-11.6 192-31.6c53.4 14 94 32 160 32-87.6-19-160-64-160-64-52.2 18.2-132.8 31.6-192 31.6z",
      "M891 526c0 0 0 0 0 0l-61.4-28.2-46-243.8v-0.2c-11-53.2-34.8-93.8-79.6-93.8h-69.2l-16.4-64h-213.4l-16.2 64h-68.8c-45.8 0-70.2 41.4-79.6 94l-46 243.8-61.4 28.2c0 0 0 0 0 0-12.4 5.8-21 18.2-21 32.8 0 4.8 1 9.2 2.6 13.4l109.4 291.8c55 0 113.4-38 113.4-38 39.8 20 121.6 37.6 174.6 37.6s134.8-17.6 174.6-37.6c0 0 58.4 38 113.4 38l109.4-291.8c1.6-4.2 2.6-8.6 2.6-13.4 0-14.6-8.6-27-21-32.8zM429.8 128h163.6l8.2 32h-180l8.2-32zM271.8 259.8c7.6-42 22.2-67.8 48.2-67.8h384c25.6 0 39.4 25.6 48.2 68.2l41.8 221.2-72.8-33.4h0.4c17.8 0 33.6-9.2 30.2-32l-30.2-160c-6-22-14.4-32-32.2-32h-354.6c-17.8 0-27.2 10.6-32.2 32l-30.2 160c-2.6 16 12.4 32 30.2 32h0.4l-73 33.4 41.8-221.6zM512 352l-139.4 64h-67.6l29-153.2c0.8-3.2 1.6-5.4 2.2-6.8h351.6c0.6 1.4 1.6 3.8 2.6 7.4l28.8 152.6h-67.6l-139.6-64zM335.4 789.2l-15.4 10c-11.4 7.4-42.4 24-73.4 30.4l-102.6-270.8c0-2.2 1.6-3.2 2.2-3.6l349.8-163.8v439.6c-48-3-112.4-17.6-144.2-33.6l-16.4-8.2zM777.4 829.6c-31-6.4-62-23-73.4-30.4l-15.4-10-16.4 8.2c-31.8 16-96.4 30.8-144.2 33.6v-439.6l349.8 163.8c0.6 0.4 2.2 1.4 2.2 3.6l-102.6 270.8z",
      "M624 532c0 24.301-10.745 44-24 44s-24-19.699-24-44c0-24.301 10.745-44 24-44s24 19.699 24 44z",
      "M448 532c0 24.301-10.745 44-24 44s-24-19.699-24-44c0-24.301 10.745-44 24-44s24 19.699 24 44z"
    ],
    "grid": 0,
    "tags": [
      "ios-boat-outline"
    ]
  },
  {
    "paths": [
      "M704 864c-52.2 18.2-132.8 31.6-192 31.6s-139.8-13.4-192-31.6c0 0-70 45-160 64 64.6 0 106.6-18 160-32 46 18 133.4 31.6 192 31.6s148-11.6 192-31.6c53.4 14 94 32 160 32-87.6-19-160-64-160-64z",
      "M891 526c0 0 0 0 0 0l-379-174-379 174c0 0 0 0 0 0-12.4 5.8-21 18.2-21 32.8 0 4.8 1 9.2 2.6 13.4l109.4 291.8c55 0 113.4-38 113.4-38 36 18 106.2 34.2 158.6 37.2 5.6 0.4 11 0.4 16 0.4s10.4-0.2 16-0.4c52.4-3 122.6-19 158.6-37.2 0 0 58.4 38 113.4 38l109.4-291.8c1.6-4.2 2.6-8.6 2.6-13.4 0-14.6-8.6-27-21-32.8zM424 576c-13.2 0-24-19.6-24-44s10.8-44 24-44 24 19.6 24 44-10.8 44-24 44zM600 576c-13.2 0-24-19.6-24-44s10.8-44 24-44 24 19.6 24 44-10.8 44-24 44z",
      "M783.8 254v-0.2c-11.2-53.2-35-93.8-79.8-93.8h-69.2l-16.4-64h-213.4l-16.2 64h-68.8c-45.8 0-70.2 41.4-79.6 94l-39.4 208.8 68.4-31.4 33.2-175.4c5-21.4 14.6-32 32.2-32h354.2c17.8 0 26.2 10 32.2 32l33.2 175.4 68.6 31.4-39.2-208.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-boat"
    ]
  },
  {
    "paths": [
      "M510 704.2l0.2 1.6 0.4 1.8 30.4 152c0.8 2.8 1.2 5.6 1.2 8.4 0 19.2-16.6 28-32 28-9.4 0-17.8-3-23.6-8.4-5.6-5-8.4-11.6-8.4-19.6 0-2.4 0.2-4.6 0.8-7v-0.8l31-156zM510 672c-15.2 0-28 10.8-31.2 25v0l-31.2 157c-1 4.6-1.6 9.2-1.6 14 0 35.4 28.6 60 64 60s64-24.6 64-60c0-5.8-0.8-11.4-2.2-16.8l-30-150c-1.4-16.4-15-29.2-31.8-29.2v0z",
      "M666 730.2l84 61.2 1.4 0.8c0.6 0.4 2.2 1.8 3.4 2.8 0.8 0.8 1.8 1.4 2.6 2.2 0.8 0.6 2.2 3.4 2.6 7.6 0.2 5.6-1.6 11.2-4.8 14.4-2.8 2.8-7.6 4.6-12.8 4.6s-8.6-1.8-9.6-2.8c-0.4-0.6-1-1.2-1.4-1.8-1-1-2.2-2.4-2.4-3l-1.2-1.6-61.8-84.4zM631.8 672.2c-6 0-11.8 2.4-16.6 7.2-8.2 8.2-9.4 20.8-3.4 30.8l90 123.6c1.8 3 4.4 5.6 6.8 8.4 8 9.2 20.6 14 33.8 14 12.8 0 26-4.6 35.4-14 19.2-19.2 18.8-54 0-69.4-3.4-2.8-6.6-5.8-10.2-7.8l-119.2-87c-5.6-4-11.2-5.8-16.6-5.8v0z",
      "M357.8 730.4l-62.4 85.6c-0.6 1-1.4 2-2.4 3-3.2 3.2-7.4 5-12 5s-8.8-1.8-12-5c-6.6-6.6-6.6-17.4 0-24 1-1 2.2-2 3.6-2.8l1.4-0.8 1.4-1 82.4-60zM391.2 672c-5.6 0-11 1.8-15.4 5.6l-119.2 86.8c-3.6 2.2-7.2 4.8-10.2 7.8-19.2 19.2-19.2 50.2 0 69.4 9.6 9.6 22 14.4 34.6 14.4s25-4.8 34.6-14.4c2.6-2.6 4.8-5.4 6.8-8.4l90-123.2c6-10 5-22.4-3.4-30.6-5-5-11.4-7.4-17.8-7.4v0z",
      "M558.6 136c18.6 6.8 41 18 61.6 33.2 29.8 21.8 65.2 58.4 65.2 108 0 28.2-4.8 49.4-15.8 68.6-13 23.2-36 45.2-70.4 67.6-14.6 9.6-31.2 18.8-48.8 28.8-59.6 33.6-132 74.2-169.4 151-5.8-4.4-11.8-10-17.8-16.4-27-29.8-37.2-68-30.4-113.4 7.6-49.6 52.4-91.4 99.8-135.6 56.4-51.8 118.8-109.8 126-191.8zM525.4 96c24 161.6-203.4 226-224 362.6s96 181.4 96 181.4c32.6-113.2 144.8-151.2 219.4-199.6 81.4-52.8 100.6-102.6 100.6-163 0-115.2-144.6-181.4-192-181.4v0z",
      "M711.4 392.2c-6.6 12.6-14.6 24.4-25 35.8 0 0 2.8 22.2 4 40.8s-1.4 34.2-3.4 40c-13 38-30.2 64.2-52.8 79.6-19.6 13.4-44 19.6-77 19.6-12.8 0-32.8-7.8-48.4-21.8s-22.2-22.4-22.2-22.4c-8.2 7-15 13-22.2 21 22.6 32.8 62.6 55.4 92.6 55.4 72 0 128-27 160-120.8 10.6-29.8 4.4-98.8-5.6-127.2z",
      "M374.2 155.8c-3 0-5.8 0.2-8.6 0.6 4.6 57.2-60 88-64 129.6-2.4 25.2 11 50 22 57.6 7.6-9.6 21.4-23.8 21.4-23.8-9-7.4-13.4-25.4-11-33.6s12-19.8 21.2-31c13.4-16.4 30.4-37 38.2-63.2 2.6 1.2 5.2 2.4 7.6 4 5.8 3.4 13.6 7.8 19.4 14.8s11.6 13.8 16.8 23c0 0 12.6-15.8 17.6-25.2-19.2-36.2-53.8-52.8-80.6-52.8z",
      "M275.4 670.4l-121 25.2c-11.6 2.4-23.2-4.6-25.8-15.8s4.8-22.2 16.6-24.6c0.6-0.2 1.4-0.2 2-0.4l123-14.6c8.8-1 16.8 5 18 13.4 0.8 7.8-4.8 15-12.8 16.8z",
      "M748.6 670.4l121 25.2c11.6 2.4 23.2-4.6 25.8-15.8s-4.8-22.2-16.6-24.6c-0.6-0.2-1.4-0.2-2-0.4l-123-14.6c-8.8-1-16.8 5-18 13.4-0.8 7.8 4.8 15 12.8 16.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-bonfire-outline"
    ]
  },
  {
    "paths": [
      "M541.8 701.2c-1.4-16.4-15.2-29.2-31.8-29.2-15.2 0-28 10.8-31.2 25v0l-31.2 157c-1 4.6-1.6 9.2-1.6 14 0 35.4 28.6 60 64 60s64-24.6 64-60c0-5.8-0.8-11.4-2.2-16.8l-30-150z",
      "M611.8 710v0 0z",
      "M777.8 772.6c-3.4-2.8-6.6-5.8-10.2-7.8l-119.2-87c-11.6-7.6-24-7.4-33 1.8-8.2 8.2-9.4 20.8-3.4 30.8l90 123.6c1.8 3 4.4 5.6 6.8 8.4 15.6 18.2 50.2 19.2 69.2 0 18.8-19.6 18.6-54.4-0.2-69.8z",
      "M745 670v0 0z",
      "M870.8 640c-15.6 0-111.2 0-119 0s-14.8 4.4-16.2 12.4c-1.2 7.2 2.6 14.2 9.4 17.6v0c0 0 0.2 0 0.2 0l115.4 35.6c16.6 3.8 35.4-11 35.4-29.6 0-23.6-9.6-36-25.2-36z",
      "M278.4 670v0 0z",
      "M278.4 670v0c6.6-3.2 10.6-10.4 9.4-17.6-1.4-8-7.8-12.4-16.2-12.4s-103.8 0-119 0-24.6 16.6-24.6 35.2 18.2 34.2 34.8 30.4l115.4-35.6c-0 0 0.2 0 0.2 0z",
      "M375.8 677.6l-119.2 86.8c-3.6 2.2-7.2 4.8-10.2 7.8-19.2 19.2-19.2 50.2 0 69.2 19.2 19.2 50.2 19.2 69.2 0 2.6-2.6 4.8-5.4 6.8-8.4l90-123.2c6-10 5-22.4-3.4-30.6-9.2-9-23.6-9.6-33.2-1.6z",
      "M717.4 277.4c0-115.2-144.8-181.4-192-181.4 24 161.6-203.4 226-224 362.6s96 181.4 96 181.4c32.6-113.2 144.8-151.2 219.4-199.6 81.4-52.8 100.6-102.6 100.6-163z",
      "M717.4 519.2c10-29.4 3.8-98.6-6-126.8-18 35-52.6 64.8-94.4 92-17.2 11.2-41.8 21.6-59.6 31.8-37.4 21-68 41.2-92.6 68.8 22.6 32.8 62.6 55.4 92.6 55.4 72-0.4 128-27.4 160-121.2z",
      "M323.6 343.8c23.4-30.2 49.8-47.6 76.4-72.4 26.8-25 44.2-42.4 55-62.6-21.4-40.2-61.6-56.2-89.4-52.2 4.6 57.2-60 88-64 129.6-2.6 25.2 10.8 50 22 57.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-bonfire"
    ]
  },
  {
    "paths": [
      "M256 96v832l256-192.8 256 192.8v-832h-512zM736 864l-224-168.6-224 168.6v-736h448v736z"
    ],
    "grid": 0,
    "tags": [
      "ios-bookmark-outline"
    ]
  },
  {
    "paths": [
      "M256 96v832l256-192.8 256 192.8v-832h-512z"
    ],
    "grid": 0,
    "tags": [
      "ios-bookmark"
    ]
  },
  {
    "paths": [
      "M534.4 404c0 0 0 0 0 0-14 0-29.8 2.6-46.6 5.8-23.8 4.6-40 14.2-40 14.2s7 54.6 0 117c-7 62.4-16 85-16 85s10.4 24.2 80 30c7.8 0.6 15.2 1 22 1 49 0 72.8-14.6 72.8-14.6s7.2-10.8 9.2-44.4c3.8-64.2-13.4-136.8-33-171-9.6-17.2-26.8-23-48.4-23zM583.8 596c-0.6 10.2-1.8 17.4-2.8 22.2-9 3-24.6 6.6-47.2 6.6-6.2 0-12.8-0.2-19.4-0.8-23.8-2-38-6.2-46.2-9.6 3.4-14.8 7.8-37.6 11.4-69.8 4.4-40.2 3.6-77 2.2-100 3.6-1.2 7.8-2.2 12.2-3 12.2-2.4 27.6-5 40.4-5v0 0 0c16.8 0 19.4 4.4 20.6 6.6 8.2 14.2 16.2 38.6 21.8 64.8 6.2 29.8 8.6 61.2 7 88z",
      "M168.8 224c-53 0-104.8 137-104.8 288s46 288 103 288c66.8 0 233-160 233-160s11.4-25.2 19.8-67.2l3.6-20.8c1.4-9.4 2.6-19.4 3.4-30 0.6-7 1-13.6 1.2-19.8l0.6-19.6c1.6-32-5-65.2-5-65.2-44.2-80.4-184.6-193.4-254.8-193.4zM288.4 695c-86.6 69.4-116.2 73-121.4 73-6.4 0-25.2-16.2-42.6-66-18-51.4-28.4-120.6-28.4-190 0-66 10.6-133.8 29.2-185.8 19.8-55.4 39.6-69.6 43.6-70.2 6.6 0 22 2 49 15.6 21.2 10.6 44.8 25.8 68.6 44.4 46.2 35.8 86.6 78.6 106.4 112.6 1.4 8.2 3.8 26.2 3.8 44.4-16.2-7-41.8-15.8-77.4-22.8-56-11-84.8-6.2-86-6-1.8 0.4-3.2 2-3.4 3.8 0 2 1.4 3.6 3.2 4 0.4 0 37.6 7.6 113.8 33.8 17 5.8 28.6 10 38 13.4 4 1.4 7.4 2.6 10.8 3.8-0.2 5.6-0.6 11-1 16.6-0.8 9-1.8 18.4-3 27.4l-1 5.6c-11 4-26.2 9-43.4 13.6-34 9-76 20-76 20-2 0.6-3.2 2.4-3 4.6 0.4 2 2.2 3.4 4.2 3.4 3.2-0.2 70.8-5.4 112.6-13.6-4.6 19.6-9.6 34-12.4 41.2-11.8 11.2-45.6 42.4-84.2 73.2z",
      "M855.2 224c-72.8 0-204.8 113-248.6 193.6l-1.6 2.8c0 0 2.8 5 3.8 6.8 6.8 12 13.4 28.6 18.8 48l5.8 23.4c4.4 20.4 7.4 42.4 8.4 64.4l0.4 18c0 5.8-0.2 11.4-0.6 17-2 33.4-9.2 44.2-9.2 44.2 15.2 21 150 157.8 224.4 157.8 57 0 103-137 103-288s-51.6-288-104.6-288zM857 768c-22.8 0-65.4-23.8-114.2-63.8-32.4-26.6-59.6-53.6-74-69 2.2-9 3.8-20.6 4.8-35.4 0.2-3.2 0.4-6.6 0.4-10 42.2 11.4 120.4 19.2 124.2 19.6 0.2 0 0.2 0 0.4 0 1.8 0 3.6-1.4 4-3.2 0.4-2-0.8-4-2.8-4.6-0.4-0.2-43.4-13.2-81-23-17.6-4.6-33.2-9.8-44.8-14.2v-2.2l0.2-0.4v-0.4c-1.8-21.4-4-44-8.4-65.6 40.8-22.6 126-61 127-61.4 1.8-0.8 2.8-2.8 2.2-4.8s-2.4-3.2-4.4-2.8c-0.4 0-30.8 5.2-70.6 19.2-20.2 7-42.6 14.8-61 21.2l-0.4-1.2c-4.8-17.2-10.6-32.8-16.8-45.4 21.2-33.4 57.8-72.6 98.4-105.4 54.4-43.8 95-59.4 115-59.4 4 0.6 23.8 14.6 43.6 70.2 18.6 52.2 29.2 120 29.2 185.8 0 69.4-10.4 138.6-28.4 190-17.4 50-36.2 66.2-42.6 66.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-bowtie-outline"
    ]
  },
  {
    "paths": [
      "M581.6 427c-9.6-17-27.6-22.6-49.6-22.6v-0.4c-12 0-28.6 2.6-45.2 5.8-23.8 4.6-39.4 14.2-39.4 14.2s7.2 54.6 0.2 117c-7 62.4-15.8 85-15.8 85s10.6 24.2 80 30c7.8 0.6 15.2 1 22 1 49 0 72.8-14.6 72.8-14.6s6.6-10.8 8.6-44.2c3.8-64.4-14-137-33.6-171.2z",
      "M423.4 417.6c-44-80.4-184.4-193.6-254.6-193.6-53-0-104.8 137-104.8 288s46 288 103 288c66.8 0 233-160 233-160s11.4-25.2 19.8-67.2l3.6-20.8c1.4-9.4 2.6-19.4 3.4-30 0.6-7 1-13.6 1.2-19.8l0.6-19.6c1.4-32-5.2-65-5.2-65zM230 448c0-2 1.4-3.6 3.4-3.8 1.2-0.2 29.8-5 86 6 42 8.2 70.2 19.2 85.4 26.4l-2.6 28.6c-5.2-1.8-10.6-3.6-17-6-9.4-3.4-21-7.4-38-13.4-76.2-26.2-113.4-33.8-113.8-33.8-2-0.4-3.4-2.2-3.4-4zM395 578.2c-40.2 9.4-118.8 15.4-122.2 15.6-2 0.2-4-1.2-4.2-3.4-0.4-2 1-4 3-4.6 0 0 42-11 76-20 23-6 42.2-13 52.8-17l-5.4 29.4z",
      "M855.2 224c-72.8 0-204.8 113-248.6 193.6l-1.6 2.8c0 0 2.8 5 3.8 6.8 6.8 12 13.4 28.6 18.8 48l5.8 23.4c4.4 20.4 7.4 42.4 8.4 64.4l0.4 18c0 5.8-0.2 11.4-0.6 17-2 33.4-9.2 44.2-9.2 44.2 15.2 21 150 157.8 224.4 157.8 57 0 103-137 103-288s-51.6-288-104.6-288zM719.6 446.2c39.8-14 70.4-19.2 70.6-19.2 2-0.4 4 0.8 4.4 2.8 0.6 2-0.4 4-2.2 4.8-1 0.4-101.4 45.8-136.4 67 0 0 0 0.4 0 0.4v0c0 0 0-0.2 0-0.4l-7.6-30.6v-0.2c20-6.6 47-16.2 71.2-24.6zM802.4 606.2c-0.4 1.8-2 3.2-4 3.2-0.2 0-0.2 0-0.4 0-4.2-0.4-98.8-9.8-136-23.2-4-23.2 1.8-24.8 1.8-25.8 11.8 4.6 31.6 11.8 54.8 18 37.6 10 80.6 23 81 23 2 0.8 3.2 2.8 2.8 4.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-bowtie"
    ]
  },
  {
    "paths": [
      "M299 566.6c-103.8 0-167.8 91.4-167.8 190.2 0 45.4-20.2 78.4-67.2 96.2 28.6 55.6 124 75 191.4 75 16.8 0 31.8-1.2 43.6-3.4 71.2-12.8 160.2-49.8 181.4-154 24.6-121.2-77.6-204-181.4-204zM449 764.4c-8 39.2-27.2 69-59 91.4-25.2 17.8-57.6 30.4-96.6 37.4-7.2 1.2-19.6 2.8-38 2.8-50.8 0-108.2-11.6-141-34.2 32-24.4 48.8-60 48.8-104.8 0-42 13.8-82.8 37.6-111.8 17.4-21.2 48.6-46.4 98.2-46.4 48.4 0 96.2 21.8 124.8 56.6 17.2 21.2 35.6 57.2 25.2 109z",
      "M935.2 120.8c-15.4-15.4-33.6-24.8-52.2-24.8-12.6 0-25.4 4.4-37.6 14l-350.2 308.2c-6.8-1.8-13.2-2.8-19.4-2.8-9.6 0-18.6 2.4-26.4 7.6l-127.2 105.6c-3.2 3.2-3 8.6 0.2 11.8 1 1 2.2 1.6 3.4 2 1.2 0 2.6 0.2 3.8 0.2 0 0 0 0 0.2 0 95.8 6.8 184 75.6 180.6 181 0 1 0 2-0.2 3 0.2 1.6 1 3.4 2.2 4.6 1.6 1.6 3.8 2.4 5.8 2.4s4.2-0.8 5.8-2.4c0 0 0 0 0.2 0 0.2-0.2 0.2-0.2 0.4-0.4l108.6-124.4c8.4-12.8 9.4-28.4 4.8-45.8l308.4-350c23.4-30 14.8-64-11.2-89.8zM921.4 190l-319.2 362.4 4.6 16.6c2.2 8 2.2 14.2 0.2 18.4l-70.8 81c-9.2-36.4-28.8-69.4-57.4-96-26.6-24.6-59.6-42.8-95.8-53l85-70.4c1.6-0.8 3.8-1.6 7.6-1.6 3.2 0 7 0.6 11 1.6l16.6 4.6 362.8-319c5.8-4.4 11.4-6.6 17-6.6 9.2 0 19.8 5.4 29.6 15.4 8.4 8.4 13.8 17.6 15 25.8 0.8 4.4 1 11.6-6.2 20.8z",
      "M322.2 528.4v0 0z"
    ],
    "grid": 0,
    "tags": [
      "ios-brush-outline"
    ]
  },
  {
    "paths": [
      "M299 566.6c-103.8 0-167.8 91.4-167.8 190.2 0 45.4-20.2 78.4-67.2 96.2 28.6 55.6 124 75 191.4 75 16.8 0 31.8-1.2 43.6-3.4 71.2-12.8 160.2-49.8 181.4-154 24.6-121.2-77.6-204-181.4-204z",
      "M935.2 120.8c-15.4-15.4-33.6-24.8-52.2-24.8-12.6 0-25.4 4.4-37.6 14l-350.2 308.2c-6.8-1.8-13.2-2.8-19.4-2.8-9.6 0-18.6 2.4-26.4 7.6l-127.2 105.6c-3.2 3.2-3 8.6 0.2 11.8 1 1 2.2 1.6 3.4 2 1.2 0 2.6 0.2 3.8 0.2 0 0 0 0 0.2 0 95.8 6.8 184 75.6 180.6 181 0 1 0 2-0.2 3 0.2 1.6 1 3.4 2.2 4.6 1.6 1.6 3.8 2.4 5.8 2.4s4.2-0.8 5.8-2.4c0 0 0 0 0.2 0 0.2-0.2 0.2-0.2 0.4-0.4l108.6-124.4c8.4-12.8 9.4-28.4 4.8-45.8l308.4-350c23.4-30 14.8-64-11.2-89.8z",
      "M322.2 528.4v0 0z"
    ],
    "grid": 0,
    "tags": [
      "ios-brush"
    ]
  },
  {
    "paths": [
      "M912 512c-9.2 0-18 2.6-25.2 7.2-10.8-4.8-28.8-10.6-54.8-12.2-0.6-55.4-11-108-29.2-155.4 17-12.6 31.6-28.8 42.6-47.6 0.8 0 1.8 0 2.6 0 26.4 0 48-21.4 48-48s-21.4-48-48-48c-26.4 0-48 21.4-48 48 0 14 6 26.6 15.6 35.4-6 9.6-14.6 20.2-26 29.8-55-115.4-158.8-193.2-277.6-193.2s-222.6 77.8-277.8 193c-11.4-9.6-19.8-20.2-25.8-29.8 9.6-8.8 15.6-21.4 15.6-35.4 0-26.6-21.4-48-48-48s-48 21.4-48 48c0 26.6 21.4 48 48 48 0.8 0 1.8 0 2.6 0 11.2 18.8 25.6 35 42.6 47.6-18.2 47.4-28.6 100-29.2 155.6-26.2 1.6-44 7.4-54.8 12.2-7.4-4.6-16-7.2-25.2-7.2-26.6 0-48 21.4-48 48s21.4 48 48 48 48-21.4 48-48c0-5-0.8-9.8-2.2-14.4 8-2.6 19.6-5.4 35-6.6 4.6 78 28.4 149.6 66 207.8-12 9-29.2 26-39.8 53.4-24.2 2.6-43 23-43 47.8 0 26.6 21.4 48 48 48s48-21.4 48-48c0-16.8-8.6-31.4-21.6-40 7.8-18 19-29 26.8-35 55 71.4 132.4 117.4 218.8 122.6 2.4 0.2 4.4 0.2 6.4 0.2 0.6 0 1.4 0 2 0 2.4 0 4.8 0.2 7.4 0.2 0 0 0 0 0 0s0 0 0 0 0 0 0 0c2.6 0 5 0 7.4-0.2 0.6 0 1.4 0 2 0 2 0 4.2-0.2 6.6-0.2v0c86.4-5.2 163.8-51.4 218.8-122.6 7.8 6 19 17 27 35.2-13 8.6-21.6 23.4-21.6 40 0 26.6 21.4 48 48 48 26.4 0 48-21.4 48-48 0-24.8-18.8-45.2-43-47.8-10.8-27.6-27.8-44.4-39.8-53.6 37.6-58.2 61.4-129.8 66-207.6 15.4 1 27 3.8 35 6.6-1.4 4.6-2.2 9.4-2.2 14.4 0 26.6 21.4 48 48 48s48-21.4 48-48-21.4-48.2-48-48.2zM848.2 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-8.8 0-16-7.2-16-16s7-16 16-16zM176 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM112 576c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM224 864c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM800.2 832c8.8 0 16 7.2 16 16s-7.2 16-16 16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM512 160c88.8 0 168.4 49.4 221.4 127-11 18.8-24.4 36.4-40.4 52.2-48.4 48.4-112.6 75-181 75s-132.6-26.6-181-75c-15.8-15.8-29.4-33.4-40.4-52.2 53-77.6 132.6-127 221.4-127zM224 512c0-71.8 17.8-138.8 48-194.4 49 73.4 130.8 123.2 224 128.2v417.8c-151.4-10.4-272-164-272-351.6zM528 863.4v-417.6c93-5.2 175-54.8 224-128.2 30.4 55.8 48 122.6 48 194.6 0 187.4-120.6 341-272 351.2zM912 576c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16z"
    ],
    "grid": 0,
    "tags": [
      "ios-bug-outline"
    ]
  },
  {
    "paths": [
      "M749.2 254.6c-58.4-77.6-143-126.6-237.2-126.6s-178.8 49-237.2 126.6c12.8 31.2 31.6 60 56.2 84.6 48.4 48.4 112.6 75 181 75s132.6-26.6 181-75c24.6-24.6 43.6-53.2 56.2-84.6z",
      "M253.6 285.6c-3.4 5.6-6.8 11.4-10 17.2-5.8-3.6-10.6-7.4-15.4-11.6-2.4-2-6-7.8-9-14.8 10.8-22.6 2.4-50-19.8-62.6-23.2-13-52.4-4.8-65.4 18.4s-4.8 52.4 18.4 65.4c2.6 1.4 5 2.6 7.6 3.4 5.6 12.6 14.6 28.6 27 39 8.4 7 17.6 14.2 30.4 21.4-14.4 40.6-23.2 84.6-25 130.8-22 0.4-37.2 4.2-51 8.2-8.4 2.4-16.4 6.8-23.6 11.8-2-0.2-3.8-0.4-5.8-0.4-26.6 0-48 21.4-48 48s21.4 48 48 48c25.8 0 47-20.4 48-46 10-3 19.8-5.4 34.2-5.6 6.4 66 26.6 127 57.2 178.4-28.4 22-45.8 46-53.2 72.6 0 0-1.6 0.8-3.8 2.8-2 1.6-3.8 3.2-5.6 5.2-17.8 19.8-16.2 50 3.6 67.8s50 16.2 67.8-3.6c16.2-18 16.2-44.8 1.2-62.8 6.2-11.2 12.4-18 27.4-30 54.2 63.4 126.8 104 207.4 108.8v-449.6c-106.6-5.8-197.8-69.6-242.6-160.2z",
      "M912 512.2c-2 0-4 0.2-5.8 0.4-7.2-5-15.4-9.2-23.6-11.8-13.8-4-28.8-7.8-51-8.2-2-46.2-10.8-90.4-25-130.8 12.8-7.2 22-14.4 30.4-21.4 12.4-10.4 21.4-26.6 27-39 2.6-1 5.2-2 7.6-3.4 23.2-13 31.4-42.2 18.4-65.4s-42.2-31.4-65.4-18.4c-22.2 12.4-30.6 39.8-19.8 62.6-3.2 6.8-6.8 12.8-9 14.8-4.8 4-9.6 7.8-15.4 11.6-3.2-5.8-6.6-11.6-10-17.2-44.8 90.6-135.8 154.2-242.4 160v450c80.6-4.8 153.2-45.6 207.4-108.8 14.8 11.8 21.2 18.8 27.4 30-15 18-15 44.8 1.2 62.8 17.8 19.8 48 21.4 67.8 3.6s21.4-48 3.6-67.8c-1.8-2-3.6-3.6-5.6-5.2-2.2-1.8-3.8-2.8-3.8-2.8-7.4-26.6-24.8-50.6-53.2-72.6 30.6-51.4 50.8-112.4 57.2-178.4 14.4 0.2 24 2.6 34.2 5.6 1 25.6 22 46 48 46 26.6 0 48-21.4 48-48s-21.6-48.2-48.2-48.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-bug"
    ]
  },
  {
    "paths": [
      "M695.8 128v0c8 0 18 2 28 6l-89.4 89.8 3 16.4 18.4 102.4 4 21.8 21.8 4 119 21.6 11.8-11.8 78-78.4c6 14.2 6 26 5.8 30.8-1.4 24-11.4 61-50 99.6-29.8 29.8-78.6 49.8-121.6 49.8-19 0-35.8-3.8-50-11.2v0 0c-7-3.6-18-8.4-31.8-8.4-11.2 0-28 3.4-44.6 19.4-18 17.6-362.6 384.8-377.4 400.4l-0.8 0.8c-11.4 13.2-26.8 15.2-35 15.2-14.8 0-29.4-6-40.2-16.4-10.8-11-17-26.8-16.4-42.4 0.4-9.2 3.2-22.4 15-32.4l1.2-0.8c15.6-14.8 384.6-362.2 399.8-377.2v0 0c15.8-15.8 19.2-32.4 19.4-43.6 0-13.8-4.8-25.2-7-30.8v0 0c-36.4-85.4 20.4-155.2 38.8-174.4v0 0c34.6-36.8 79.4-48.4 98.4-49.4 0-0.8 0.8-0.8 1.8-0.8zM695.8 96c-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40.2 42.4-82.2 121.2-45 209 4.4 10.6 9.4 24.6-5.4 39.4-15.2 14.8-399.4 376.6-399.4 376.6-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 358.8-382.2 376.4-399.6 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-24-6.8-55.8-33.4-82.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.2-22.2-53.6-33-77.8-33v0z",
      "M205 858.6c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11.2 10.8 29 0 39.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-build-outline"
    ]
  },
  {
    "paths": [
      "M894.4 250l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.2-22.2-53.6-33-77.8-33-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40.2 42.4-82.2 121.2-45 209 4.4 10.6 9.4 24.6-5.4 39.4-15.2 14.8-399.4 376.6-399.4 376.6-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 358.8-382.2 376.4-399.6 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.6-23.8-6.8-55.6-33.4-82.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-build"
    ]
  },
  {
    "paths": [
      "M800 377.6c0-155.8-132.2-281.6-288-281.6s-288 125.8-288 281.6c0 62.2 26.4 118.2 60.4 166.2h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163v3h256v-3c0-17.8-7.2-87.4 36.8-163 20.2-34.6 41.2-60 63-90h-0.2c33.8-47.8 60.2-104 60.2-166.2zM702 540.6c-1.2 1.6-2.2 3-3.4 4.6-16.2 21.8-33 44.4-49.4 72.4-34.6 59.4-40.8 116.4-41.6 150.4h-31.6v-224.2l64-127.8h-33.2l-62.8 127.8v224.2h-64v-224.2l-62.8-127.8h-33.2l64 127.8v224.2h-31.8c-1-34-7.8-91.4-41.8-150-9-15.4-18.2-30-27.4-42h0.4l-37.2-51.2c-31.6-43.2-54.2-94.2-54.2-147.2 0-66.8 32-129.8 79.2-177s110-73 176.8-73 129.6 25.6 176.8 72.8c47.2 47.2 79.2 110 79.2 176.8 0 53-22.6 103.8-54.2 147.2l-11.8 16.2z",
      "M448 896h128v32h-128v-32z",
      "M416 832h192v32h-192v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-bulb-outline"
    ]
  },
  {
    "paths": [
      "M800 377.8c0-155.8-132.2-281.8-288-281.8s-288 126.2-288 281.8c0 62 26.4 118.2 60.4 166.2h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163v3h64v-256.2l-64.2-127.8h33.2l62.8 127.8v256.2h64v-256.2l62.8-127.8h33.2l-64 127.8v256.2h64v-3c0-17.8-7.2-87.4 36.8-163 20.2-34.6 41.2-60 63-90h-0.2c34-48 60.4-104.2 60.4-166.2z",
      "M448 896h128v32h-128v-32z",
      "M416 832h192v32h-192v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-bulb"
    ]
  },
  {
    "paths": [
      "M832 832c-17 37.4-48 32-127.8 32 0 21-2.2 32 6.6 32s100.8 0 110.2 0 8.4-7.6 11-64z",
      "M192 832c3 56.8 1.6 64 11 64s101.4 0 110.2 0c8.8 0 6.6-11 6.6-32-79.8 0-100.8 6-127.8-32z",
      "M752 704c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M368 704c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M768 128h-512c-35.2 0-64 28.8-64 64v0 560c0 44 36 80 80 80h480c44 0 80-36 80-80v-560c0-35.2-28.8-64-64-64zM800 752c0 26.4-21.6 48-48 48h-480c-26.4 0-48-21.6-48-48v-144h576v144zM224 544v-255.6c0-17.6 14.8-32.4 32.4-32.4h239.6v320h-239.6c-17.6 0-32.4-14.4-32.4-32zM800 544c0 17.6-14.4 32-32 32h-240v-320h240c17.6 0 32 14.8 32 32.4v255.6zM768 224h-512c-17.6 0-32-14.4-32-32s14.4-32 32-32h512c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-bus-outline"
    ]
  },
  {
    "paths": [
      "M704.2 864c0 21-2.2 32 6.6 32s100.8 0 110.2 0 8.2-7.6 11-64c-17 37.4-48 32-127.8 32z",
      "M192 832c3 56.8 1.6 64 11 64s101.4 0 110.2 0c8.8 0 6.6-11 6.6-32-79.8 0-100.8 6-127.8-32z",
      "M768 128h-512c-35.2 0-64 28.8-64 64v0 560c0 44 36 80 80 80h480c44 0 80-36 80-80v-560c0-35.2-28.8-64-64-64zM320 752c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48zM496 576h-239.6c-17.6 0-32.4-14.4-32.4-32v-255.6c0-17.6 14.8-32.4 32.4-32.4h239.6v320zM704 752c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48zM800 544c0 17.6-14.4 32-32 32h-240v-320h240c17.6 0 32 14.8 32 32.4v255.6zM768 224h-512c-17.6 0-32-14.4-32-32s14.4-32 32-32h512c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-bus"
    ]
  },
  {
    "paths": [
      "M64 800h896v32h-896v-32z",
      "M400 768c30 0 131.4 0 160 0 17.6 0 116-24 189.4-160.8 6.2 0.6 12.4 0.8 18.6 0.8 106 0 192-78.8 192-176 0-77.2-54.2-142.8-129.8-166.6 1.2-23.4 1.8-47.8 1.8-73.4h-704c0 512 242 576 272 576zM928 432c0 79.4-71.8 144-160 144-1 0-2.2 0-3.2 0 30.4-67.2 54.4-157.2 63.4-277.4 58.4 21.4 99.8 73.2 99.8 133.4zM160.4 224h639.2c-2.2 98.4-14.6 185.8-36.8 260.2-19.4 64.8-46.4 119.8-80.2 163.4-49 63.4-101.6 88.4-121.4 88.4s-136.6 0-160.2 0-74.4-25.2-123.4-88.4c-33.8-43.6-60.8-98.6-80.2-163.4-22.4-74.4-34.8-161.8-37-260.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-cafe-outline"
    ]
  },
  {
    "paths": [
      "M64 800h896v32h-896v-32z",
      "M400 768c30 0 131.4 0 160 0 17.6 0 116-24 189.4-160.8 6.2 0.6 12.4 0.8 18.6 0.8 106 0 192-78.8 192-176 0-77.2-54.2-142.8-129.8-166.6 1.2-23.4 1.8-47.8 1.8-73.4h-704c0 512 242 576 272 576zM928 432c0 79.4-71.8 144-160 144-1 0-2.2 0-3.2 0 30.4-67.2 54.4-157.2 63.4-277.4 58.4 21.4 99.8 73.2 99.8 133.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-cafe"
    ]
  },
  {
    "paths": [
      "M704 192v-64h-32v64h-320v-64h-32v64h-192v704h768v-704h-192zM864 864h-704v-480h704v480zM864 352h-704v-128h160v64h32v-64h320v64h32v-64h160v128z"
    ],
    "grid": 0,
    "tags": [
      "ios-calendar-outline"
    ]
  },
  {
    "paths": [
      "M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4zM808.8 782.8c-40 48.4-63 48.4-104.6 48.4-40.6 0-103.6-28-168.4-74.6-62-44.8-89.6-65.4-151.8-129.2-65.8-67.4-107.2-123.6-152.8-207-48.2-88.2-42.8-126.8-33-158.6 5.2-17 20.8-35.2 42-48.4 1-0.6 2-1.4 3.2-2 10.6-6.8 28.2-18.2 47.4-18.2 16 0 30.2 8 43.8 24.6l2 2.4c51 62.4 90.8 117.6 60.8 158.4-21.2 28.6-32.4 48-30.6 68 1.6 19.4 14.6 34 34.2 56l1.4 1.6c32.2 36.4 41.4 46 54.2 59 2.2 2.2 4.4 4.6 7 7.2l3.6 3.8c14.8 15.4 23 23.8 60.6 56.8l2.2 2c16 14 27.8 24.2 45 24.2 17.8 0 37.4-11.2 74.6-35 3.8-2.4 9.2-3.8 16-3.8 43.4 0 118.2 49.6 144.4 76.6 24 24.4 36 42.8-1.2 87.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-call-outline"
    ]
  },
  {
    "paths": [
      "M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-call"
    ]
  },
  {
    "paths": [
      "M869.4 406.8l31-4.8c0 0 0 0 0 0 14.2 0 44.8-6 51-12.4s8.4-11.6 8.4-17.2-3.4-15.8-9.6-22.6c-6-6.8-32-10.6-47.4-12.6-4.4-0.6-7.8-0.8-10.4-0.8-6.4 0-8.2 1.4-11 3.2-4.6 3-6 23.4-6.4 34l-16.2 3.6c-9.6-25-22.8-71.2-43-108-23-41.6-47-54.8-57-58-9.8-3-18.8-5.2-86-12.2-67.4-7-126-7-160.8-7s-93.4 0-161.2 7.2c-67.2 6.8-76.2 9-86 12.2-10 3.2-34 16.4-57 58-20.2 36.8-33.4 83-43 108l-16.2-3.6c-0.4-10.6-1.8-31.2-6.4-34-2.8-1.8-4.8-3.4-11-3.4-2.6 0-5.8 0.2-10.2 0.8-15.2 2-41.2 5.6-47.4 12.4-6 6.8-9.4 16.6-9.4 22.2s2.2 11.8 8.4 18.2c6.2 6.4 37 12.4 51 12.4 0 0 0 0 0 0l31 4.8c0 0-53.6 28.4-82.4 60.8 0 0-8.2 49-8.2 115.8 0 96 11.6 176.6 11.6 176.6 53 9.2 92.4 12.4 131.8 13.4 10.8 0.2 21.2 0.4 31.8 0.4 8.6 0 17.4 0 26.6-0.2 48.8-0.6 31.6-14.8 53.4-14.8 0.2 0 0.6 0 0.8 0 22.6 0.4 110 9 192 9s169.4-8.6 192-9c0.2 0 0.6 0 0.8 0 21.6 0 4.4 14.2 53.4 14.6 9 0 17.6 0.2 26 0.2 10.8 0 21.4-0.2 32.6-0.4 39.4-1 79-4.4 131.8-13.6 0 0 11.6-80.6 11.6-176.8 0-67-8.2-115.8-8.2-115.8-29-32.4-82.6-60.6-82.6-60.6zM220.8 308.8c8.6-20.2 28-54.2 44.2-65.6 0 0 94-19.2 247-19.2s247 19.2 247 19.2c16.2 11.2 35.6 45.2 44.2 65.6s22.8 67.6 20.6 73c-1.6 4 0.4 6.6-10.8 6.6-3.6 0-8.8-0.2-16-0.8-28.6-2.2-199-4.6-285-4.6s-256.2 2.4-285 4.6c-7.2 0.6-12.2 0.8-16 0.8-11.4 0-9.2-2.6-10.8-6.6-2.2-5.6 12-52.8 20.6-73zM919.6 732.2c-36.6 5.6-68.6 8.4-103.8 9.2-10.2 0.2-20.2 0.4-31.8 0.4-7.4 0-15.6 0-25.6-0.2-11-0.2-16.2-1-18.2-1.6-7.2-6.6-17-13.2-35.4-13.2-0.4 0-0.8 0-1.4 0-7.8 0.2-21 1-39.4 2-38.4 2.4-96.6 6.8-152 7-55.4 0-113.6-4.6-152.2-7-18.4-1.2-31.6-2-39.4-2-0.4 0-0.8 0-1.4 0-18.4 0-28.2 6.6-35.4 13.2-2 0.4-7.2 1.4-18.2 1.6-10.6 0.2-18.8 0.2-26.2 0.2-11.2 0-21.2-0.2-31-0.4-35.2-1-67.4-3.8-103.8-9.2-3.4-30.2-8.4-86.4-8.4-148.8 0-46.6 4.2-84.6 6.4-101.4 21.4-20.8 55.2-41.2 67.4-47.8l27.6-15c0 0 88.6-4 314.6-4s314.4 4 314.4 4l27.8 15c12.2 6.6 46 26.8 67.4 47.6 2.2 16.8 6.4 54.6 6.4 101.6 0 62.2-5 118.6-8.4 148.8z",
      "M277.6 556.6c-19.8 0-59.6-2-69-2.4-9.4-0.2-17.6 7.6-22.4 7.6s-51-7.2-56-29.8c-5-22.4 0-46 0-45.6 31-1.4 61-0.4 117 15.6 56.2 15.8 87.2 46.6 87.2 46.6s-37 8-56.8 8z",
      "M684.4 678.6c-25.4 3.4-117 4.4-172.4 4.4s-147-1-172.4-4.4c-26.2-3.4-59.6-34.6-36.8-60.4 15.2-17 41.6-27.2 97.8-34.6 59.6-7.6 97.2-8.6 111.2-8.6s51.6 1 111.2 8.6c56.2 7.4 86.4 19.2 97.8 34.6 20.8 27.6-10.2 56.8-36.4 60.4z",
      "M893.8 532.2c-5 22.4-51.2 29.8-56 29.8s-13-7.8-22.4-7.6c-9.4 0.4-49.2 2.4-69 2.4s-56.8-8-56.8-8 31-30.8 87.2-46.6c56-16 86-17 117-15.6-0-0.4 5 23-0 45.6z",
      "M802 824.6c0 4.2 2.6 7.4 6.4 7.4 0 0 106 0 113 0 9.8 0 11.8-7 12.4-11 2.8-16.8 3.8-42.6 3.8-42.6-51.4 9.4-97.6 11-135.6 12v34.2z",
      "M90.4 821c0.6 4 2.6 11 12.4 11 7 0 113.4 0 113.4 0 3.8 0 6-3.2 6-7.4v-34.2c-38-1-84.4-2.6-135.8-12-0.2 0.2 1.2 25.8 4 42.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-car-outline"
    ]
  },
  {
    "paths": [
      "M951.8 468c-28.8-32.6-82.4-61.6-82.4-61.6l31-6.2c0 0 0 0 0 0 14.2 0 44.8-4.6 51-10.8 6.2-6.4 8.4-10.8 8.4-16.4s-3.4-15.4-9.6-22.2c-6-6.8-32-10.4-47.4-12.4-15.2-2-17.4 0-21.4 2.4-4.6 3-6 23.4-6.4 34l-16.2 3.6c-9.6-25-22.8-71.2-43-108-23-41.6-47-54.8-57-58-9.8-3-18.8-5.2-86-12.2-67.4-7.2-126-8.2-160.8-8.2s-93.4 1-161.2 8.2c-67.2 6.8-76.2 9-86 12.2-10 3.2-34 16.4-57 58-20.2 36.8-33.4 83-43 108l-16.2-3.6c-0.4-10.6-1.8-31.2-6.4-34-4-2.6-6-4.4-21.4-2.4-15.2 2-41.2 5.6-47.4 12.4-6 6.8-9.4 16.6-9.4 22.2s2.2 10.2 8.4 16.6c6.2 6.4 37 10.8 51 10.8 0 0 0 0 0 0l31 6.2c0 0-53.6 29.2-82.4 61.6 0 0-8.2 49.4-8.2 116.2 0 96 11.6 176.8 11.6 176.8 53 9.2 92.4 12.6 131.8 13.6 19.8 0.4 37.8 0.4 58.4 0.2 49.6-0.6 31.2-15 54.2-14.6 22.6 0.4 110 8 192 8s169.4-7.6 192-8c23-0.4 4.6 14.2 54.2 14.6 20.6 0.2 38.8 0.2 58.4-0.2 39.4-1 79-4.4 131.8-13.6 0 0 11.6-80.6 11.6-176.8 0.2-67.2-8-116.4-8-116.4zM220.8 309.8c8.6-20.2 28-54.2 44.2-65.6 0 0 94-20.2 247-20.2s247 20.2 247 20.2c16.2 11.2 35.6 45.2 44.2 65.6 8.6 20.2 22.8 67.6 20.6 73s2.2 8.2-26.8 5.8c-28.8-2.2-199-4.6-285-4.6s-256.2 2.4-285 4.6c-29 2.4-24.8-0.4-26.8-5.8-2.2-5.6 12-52.8 20.6-73zM247.6 541.6c-19.8 0-59.6-2-69-2.4-9.4-0.2-17.6 7.6-22.4 7.6s-51-7.2-56-29.8c-5-22.4 0-46 0-45.6 31-1.4 61-0.4 117 15.6 56.2 15.8 87.2 46.6 87.2 46.6s-37 8-56.8 8zM684.4 679.6c-25.4 3.4-117 4.4-172.4 4.4s-147-1-172.4-4.4c-26.2-3.4-59.6-34.6-36.8-60.4 15.2-17 41.6-27.2 97.8-34.6 59.6-7.6 97.2-8.6 111.2-8.6s51.6 1 111.2 8.6c56.2 7.4 86.4 19.2 97.8 34.6 20.8 27.6-10.2 56.8-36.4 60.4zM923.8 517.2c-5 22.4-51.2 29.8-56 29.8s-13-7.8-22.4-7.6c-9.4 0.4-49.2 2.4-69 2.4s-56.8-8-56.8-8 31-30.8 87.2-46.6c56-16 86-17 117-15.6-0-0.4 5 23-0 45.6z",
      "M802 824.6c0 4.2 2.4 7.4 6.2 7.4 0 0 106 0 113 0 9.8 0 11.8-7 12.4-11 2.8-16.8 4-42.6 4-42.6-51.4 9.4-97.6 11-135.6 12v34.2z",
      "M90.2 821c0.6 4 2.6 11 12.4 11 7 0 113.4 0 113.4 0 3.8 0 6.2-3.2 6.2-7.4v-34.2c-38-1-84.4-2.6-135.8-12-0.2 0.2 1 25.8 3.8 42.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-car"
    ]
  },
  {
    "paths": [
      "M864 224h-704c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM160 256h704c17.6 0 32 14.4 32 32v64h-768v-64c0-17.6 14.4-32 32-32zM896 384v96h-768v-96h768zM864 768h-704c-17.6 0-32-14.4-32-32v-224h768v224c0 17.6-14.4 32-32 32z",
      "M192 640h64v32h-64v-32z",
      "M320 640h384v32h-384v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-card-outline"
    ]
  },
  {
    "paths": [
      "M864 224h-704c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM160 256h704c17.6 0 32 14.4 32 32v64h-768v-64c0-17.6 14.4-32 32-32zM864 768h-704c-17.6 0-32-14.4-32-32v-224h768v224c0 17.6-14.4 32-32 32z",
      "M192 640h64v32h-64v-32z",
      "M320 640h384v32h-384v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-card"
    ]
  },
  {
    "paths": [
      "M80 736h864v32h-864v-32z",
      "M96 800h832v32h-832v-32z",
      "M64 192v512h896v-512h-896zM928 672h-832v-448h832v448z",
      "M768 256h128v32h-128v-32z",
      "M768 608h128v32h-128v-32z",
      "M128 256h128v32h-128v-32z",
      "M128 608h128v32h-128v-32z",
      "M512 592c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zM512 336c-61.8 0-112 50.2-112 112s50.2 112 112 112 112-50.2 112-112-50.2-112-112-112z"
    ],
    "grid": 0,
    "tags": [
      "ios-cash-outline"
    ]
  },
  {
    "paths": [
      "M80 736h864v32h-864v-32z",
      "M96 800h832v32h-832v-32z",
      "M512 336c-61.8 0-112 50.2-112 112s50.2 112 112 112 112-50.2 112-112-50.2-112-112-112z",
      "M64 192v512h896v-512h-896zM256 640h-128v-32h128v32zM256 288h-128v-32h128v32zM512 592c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zM896 640h-128v-32h128v32zM896 288h-128v-32h128v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-cash"
    ]
  },
  {
    "paths": [
      "M862 641.2c0-8.8 2.4-17.2 6.6-24.4 1.2-2.2 2.8-4.2 4.2-6.2 34.8-52 55.2-114.2 55.2-180.6 0.6-184.4-155-334-347.4-334-167.8 0-307.8 114.2-340.6 265.8-4.8 22.2-7.4 44.8-7.4 68.4 0 184.6 149.6 338.2 342 338.2 30.6 0 71.8-9.2 94.4-15.4s45-14.4 50.8-16.6 12.2-3.4 18.6-3.4c7.2 0 14 1.4 20.2 4l113.4 40.2c0 0 4.8 2 7.8 2 8.8 0 16-7 16-16 0-2-1-5.4-1-5.4l-32.8-116.6zM770.2 707.2c-10-4-20.6-6.4-31.6-6.4-8.2 0-20.2 1.6-24.4 3.2s-22.6 7.6-22.6 7.6c-8.4 2.8-19.8 7.6-30.4 10.2-28 7.2-60.2 14.4-86.4 14.4-83.8 0-162.2-32.2-220.6-90.6-28.2-28.2-50.2-61-65.6-97.4-15.8-37.6-23.8-77.4-23.8-118.2 0-20.4 2.2-41.2 6.6-61.6 14.4-66.8 53-127.6 108.4-171.4 27.6-21.8 58.8-39 92.2-50.8 34.8-12.2 71.4-18.4 108.8-18.4 44 0 86.6 8.4 126.6 25.2 38.6 16.2 72.8 39.2 102 68.4 56 56.6 86.6 130.6 86.6 208.6v0 0c0 57.8-17.2 114-49.4 162.4-0.2 0.2-0.4 0.6-0.6 0.8-1.4 1.8-3.2 4.4-5 7.6-7 12.2-10.8 24.8-10.8 40.2s16.4 65 26 96.4l-86-30.2z",
      "M610.6 791.4c-12.6 12.2-24.2 20.8-24.2 20.8-49.8 40.4-112.8 62.8-179 62.8-37.6 0-74.2-7.2-109-21.4-0.8-0.4-1.6-0.6-2-0.8v0c-1.2-0.6-2.4-1-3.6-1.2-14-4.6-29.4-4-42.8 1.4l-85 33.6 18.6-97c0.2-1 0.2-2 0.2-3 0-10.2-2.6-20-7.8-28.6l-0.8-1.4c-1-1.6-2-3.6-3.4-5.4-28.8-43.4-44-93.8-44-145.8 0-60 21.2-125.6 75.6-185.8 1.2-8.6 2.6-17.2 4.6-25.6 2-9 4.4-18 7-26.8l-16 14.2c-65.4 57-103 138.6-103 223.6 0 58.6 17.2 115.2 49.6 164 0.2 0.2 0.4 0.4 0.6 0.8 0.4 0.4 1.2 1.8 1.6 2.8 0.4 0.6 0.6 1.2 1 1.6 2 3.4 3 6.8 3.2 10.8l-23.8 124c-1.2 5.8 1 11.6 5.4 15.4 3 2.4 6.6 3.6 10.2 3.6 2 0 4-0.4 5.8-1.2l112.2-44.2c3.6-1.4 7.4-2.2 11.4-2.2 3.6 0 7.2 0.6 10.6 1.8 0.4 0.2 1 0.4 1.4 0.4v0c0.2 0.2 0.4 0.2 0.6 0.2 38.6 16 79.6 24 121.4 24 93.2 0 180.8-40.2 240.2-110.2 0 0 6.4-8.8 13.8-19.2-7.6 2.4-16 5-24.4 7.4-7.2 2.2-16.2 4.4-26.2 6.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-chatbubbles-outline"
    ]
  },
  {
    "paths": [
      "M862 641.2c0-8.8 2.4-17.2 6.6-24.4 1.2-2.2 2.8-4.2 4.2-6.2 34.8-52 55.2-114.2 55.2-180.6 0.6-184.4-155-334-347.4-334-167.8 0-307.8 114.2-340.6 265.8-4.8 22.2-7.4 44.8-7.4 68.4 0 184.6 149.6 338.2 342 338.2 30.6 0 71.8-9.2 94.4-15.4s45-14.4 50.8-16.6 12.2-3.4 18.6-3.4c7.2 0 14 1.4 20.2 4l113.4 40.2c0 0 4.8 2 7.8 2 8.8 0 16-7 16-16 0-2-1-5.4-1-5.4l-32.8-116.6z",
      "M622.4 806.8c-0.6 1-0.2 1.4 1.4 0.8-0.2-0.6-0.6-0.8-1.4-0.8z",
      "M637 785c-7.2 2-16.4 4.2-26.4 6.4-21 4.4-47.8 9-68 9-192.4 0-342-153.6-342-338.2 0-13.2 1.4-30 3-42.8 1.2-8.6 2.6-17.2 4.6-25.6 2-9 4.4-18 7-26.8l-16 14.2c-65.6 57.2-103.2 138.8-103.2 223.8 0 58.6 17 115 49.6 164 4.6 7 7.2 12.4 6.4 16s-23.8 124-23.8 124c-1.2 5.8 1 11.6 5.4 15.4 3 2.4 6.6 3.6 10.2 3.6 2 0 4-0.4 5.8-1.2l112.2-44.2c3.6-1.4 7.4-2.2 11.4-2.2 0 0 4.8-0.4 12.6 2.6 37.8 14.8 79.6 24 121.4 24 93.2 0 180.8-40.2 240.2-110.2 0 0 6.4-8.8 13.8-19.2-7.4 2.6-15.8 5.2-24.2 7.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-chatbubbles"
    ]
  },
  {
    "paths": [
      "M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z",
      "M680.2 354.6l-249.6 251.4-94.4-94.4-35.8 35.6 130.2 130 284.6-286.4z",
      "M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z"
    ],
    "grid": 0,
    "tags": [
      "ios-checkbox-outline"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM432 714c-1 0-0.8-0.2 0-0.4 0.8 0.2 0.8 0.4 0 0.4zM430.6 677.2l-130-130 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-284.6 286.4z",
      "M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-checkbox"
    ]
  },
  {
    "paths": [
      "M680.2 354.6l-249.6 251.4-94.4-94.4-35.6 35.6 112 112c5 5 11.8 9 17.8 9s12.6-4 17.6-8.8l267.4-268.8-35.2-36z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-checkmark-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-checkmark-circle"
    ]
  },
  {
    "paths": [
      "M447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-checkmark"
    ]
  },
  {
    "paths": [
      "M544 191.4c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M800 128h-184.2c8.2 9.2 14.6 20 18.8 32h149.4c8.8 0 16 7.2 16 16v704c0 8.8-7.2 16-16 16h-544c-8.8 0-16-7.2-16-16v-704c0-8.8 7.2-16 16-16h149.4c4.2-12 10.6-22.8 18.8-32h-184.2c-17.6 0-32 14.4-32 32v736c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32v-736c0-17.6-14.4-32-32-32z",
      "M352 222v34h-96v608h512v-608h-96v-34c0-17.6-12.8-30-30.4-30h-33.6c0-11.2-2-22-5.4-32-4.2-12-10.6-22.8-18.8-32-17.6-19.8-43.2-32-71.8-32s-54.2 12.2-71.8 32c-8.2 9.2-14.6 20-18.8 32-3.4 10-5.4 20.8-5.4 32h-29c-17.6 0-35 12.4-35 30zM672 320v-32h64v544h-448v-544h64v32h320zM448 224v-33c0-35.8 28.2-64 64-64s64 28.2 64 64v33h64v64h-256v-64h64z"
    ],
    "grid": 0,
    "tags": [
      "ios-clipboard-outline"
    ]
  },
  {
    "paths": [
      "M288 832h448v-544h-32v64h-384v-64h-32z",
      "M641.6 192h-33.6c0-11.2-2-22-5.4-32-4.2-12-10.6-22.8-18.8-32-17.6-19.8-43.2-32-71.8-32s-54.2 12.2-71.8 32c-8.2 9.2-14.6 20-18.8 32-3.4 10-5.4 20.8-5.4 32h-29c-17.6 0-35 12.4-35 30v98h320v-98c-0-17.6-12.8-30-30.4-30zM512 223.4c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32c0 17.6-14.4 32-32 32z",
      "M704 222c0 0.6 0 1.4 0 2v-2z",
      "M800 128h-184.2c8.2 9.2 14.6 20 18.8 32l0.2 0.2c1.6-0.2 3.4-0.2 5.2-0.2 34.6 0 62.8 27.6 64 62v0 34h64v608h-512v-608h64v-22c0-35.4 23.4-68 64-68 0.8 0 1.8 0 2.6 0 1 0 1.8 0 2.8 0 3.4-18 10.6-28.8 18.8-38h-184.2c-17.6 0-32 14.4-32 32v736c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32v-736c0-17.6-14.4-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-clipboard"
    ]
  },
  {
    "paths": [
      "M528 176c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M528 848c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M864 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M192 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M237 344c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M819 680c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M696 221c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M360 803c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M237 680c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M819 344c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M360 221c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M696 803c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z",
      "M539.8 496c-5.8-10-16.2-15.6-26.8-16l-60-110.8c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22l59.2 109.8c-5.8 9.6-6.4 22.2-0.4 32.6 3 5 7 9 11.8 11.6v228.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-228.2c15.2-9 20.4-28.4 11.6-43.8z",
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0s-148.6-390.6 0-539.2 390.6-148.6 539.2 0c148.8 148.6 148.8 390.6 0 539.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-clock-outline"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM512 160c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.8 7.2-16 16-16zM207.2 336c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8zM176 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM229 693.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8 17.4-1.8 21.8 5.8c4.4 7.6 1.8 17.4-5.8 21.8zM357.8 811c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM352 234.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM512 864c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM528 539.8v228.2c0 8.8-7.2 16-16 16s-16-7.2-16-16v-228.4c-4.8-2.8-8.8-6.6-11.8-11.6-6-10.4-5.4-23 0.4-32.6l-59.2-109.8c-4.6-7.6-2-17.4 5.4-22 7.6-4.6 17.4-2 22 5.4l60 110.8c10.8 0.2 21.2 6 26.8 16 9 15.6 3.8 35-11.6 44zM688 816.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM693.8 229c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM816.8 688c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM811 357.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8 17.4-1.8 21.8 5.8c4.4 7.6 1.8 17.4-5.8 21.8zM848 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16z"
    ],
    "grid": 0,
    "tags": [
      "ios-clock"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0s-148.6-390.6 0-539.2 390.6-148.6 539.2 0c148.8 148.6 148.8 390.6 0 539.2z",
      "M680.4 320l-168.8 168.4-168-167.6-23.6 23.6 168 167.6-168 167.6 23.6 23.6 168-167.6 168.8 168.4 23.6-23.6-168.8-168.4 168.8-168.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-close-circle-outline"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM704 680.4l-23.6 23.6-168.8-168.4-168 167.6-23.6-23.6 168-167.6-168-167.6 23.6-23.6 168 167.6 168.8-168.4 23.6 23.6-168.8 168.4 168.8 168.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-close-circle"
    ]
  },
  {
    "paths": [
      "M680.4 320l-168.8 168.6-168-167.8-23.6 23.6 168 167.6-168 167.8 23.6 23.4 168-167.6 168.8 168.4 23.6-23.4-168.8-168.6 168.8-168.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-close"
    ]
  },
  {
    "paths": [
      "M960 832h-896v-640h896v640zM96 800h832v-576h-832v576zM540 780c-9.4 0-18.8 0-28 0s-18.4 0-27.8 0c-71.4 0-162-0.8-227.6-6.8-72.2-6.6-113-48.2-118-120l-1-15.4c-3.4-50-5.6-83-5.6-126.2 0-48 0.2-78.2 6.8-142 7.2-70.8 48-112 117.8-119.2 64-6.4 174.6-6.4 255.6-6.4 80.8 0 191.6 0 255.6 6.4 69.8 7 110.4 48.2 117.8 119.2 6.6 63.8 6.8 94 6.8 142 0 43-2.2 76-5.6 126l-1 15.6c-4.8 71.8-45.6 113.4-118 120-66 6-156.4 6.8-227.8 6.8zM512 748v0c9.2 0 18.6 0 28 0 70.8 0 160.2-0.8 224.6-6.6 56-5.2 85.2-34.8 89-90.4l1-15.6c3.4-49.2 5.6-81.8 5.6-123.8 0-47-0.2-76.6-6.6-138.8-5.8-56.2-34-85-89.2-90.6-62.4-6.2-172.2-6.2-252.4-6.2s-190 0-252.2 6.4c-55 5.6-83.4 34.4-89.2 90.6-6.4 62.2-6.6 91.8-6.6 138.8 0 42 2.2 74.6 5.6 124l1 15.4c3.8 55.6 32.8 85.2 89 90.4 64.4 6 153.8 6.6 224.6 6.6 9.4-0.2 18.8-0.2 27.8-0.2z",
      "M675.4 356.8c34.4 0 58.8 8.6 74.8 26.4 11.2 12.4 18.8 31.6 22.6 54.8h-28.2c-10.8-35.4-39.8-59.6-75.8-59.6-22.4 0-41.6 8-55.8 23.2-12.8 13.6-20.8 32.4-24.2 56v0 0c-0.2 1-3 22.6-3 56.4 0 29.8 2 46.8 2.6 51.4 4.4 47.2 37 80.2 79.6 80.2 22.2 0 42.4-8.4 57-23.6 9.6-10 16-22.2 19.6-36.2h28.8c-3.4 23.4-10.8 41.6-22.4 54.6-15.4 17.6-43.4 26.4-83.4 26.4-20.2 0-37.8-2.2-52.2-6.8-11.4-3.6-20.8-10-28.4-19.4-8.6-10.6-15.4-26-20.2-45.4-5.2-21.6-8-49.2-8-82.4 0-33.4 3.2-61.2 9.6-82.2 5.8-19.4 13.8-34.6 23.6-45.4 9.4-10.4 20.2-17.2 33.2-21.4 14.8-4.6 31.8-7 50.2-7zM675.4 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z",
      "M365.6 356.8c34.4 0 58.8 8.6 74.8 26.4 11.2 12.4 18.8 31.6 22.6 54.8h-28.2c-10.8-35.4-39.8-59.6-75.8-59.6-22.4 0-41.6 8-55.8 23.2-12.8 13.6-20.8 32.4-24.2 56v0 0c-0.2 1-3 22.6-3 56.4 0 29.8 2 46.8 2.6 51.4 4.4 47.2 37 80.2 79.6 80.2 22.2 0 42.4-8.4 57-23.6 9.6-10 16-22.2 19.6-36.2h28.8c-3.4 23.4-10.8 41.6-22.4 54.6-15.4 17.6-43.4 26.4-83.4 26.4-20.2 0-37.8-2.2-52.2-6.8-11.4-3.6-20.8-10-28.4-19.4-8.6-10.6-15.4-26-20.2-45.4-5.2-21.6-8-49.2-8-82.4 0-33.4 3.2-61.2 9.6-82.2 5.8-19.4 13.8-34.6 23.6-45.4 9.4-10.4 20.2-17.2 33.2-21.4 14.8-4.6 31.8-7 50.2-7zM365.6 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-closed-captioning-outline"
    ]
  },
  {
    "paths": [
      "M64 192v640h896v-640h-896zM860 511.6c0 41.8-2.2 74.4-5.6 123.8l-1 15.6c-3.8 55.6-32.8 85.2-89 90.4-64.4 6-153.8 6.6-224.6 6.6-9.4 0-18.6 0-27.8 0v0c-9.2 0-18.4 0-27.8 0-70.8 0-160.4-0.8-224.6-6.6-56-5.2-85.2-34.8-89-90.4l-1-15.4c-3.4-49.4-5.6-82-5.6-124 0-47 0.2-76.6 6.6-138.8 5.8-56.2 34-85 89.2-90.6 62.4-6.4 172.2-6.4 252.2-6.4 80.2 0 190 0 252.4 6.4 55 5.6 83.4 34.4 89.2 90.6 6.2 62.2 6.6 91.8 6.4 138.8z",
      "M675.4 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z",
      "M365.6 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-closed-captioning"
    ]
  },
  {
    "paths": [
      "M548.6 352c28 0 54.4 10.6 74.8 29.8 20.4 19.4 33.2 46.2 36.4 75.4l2.6 24.2 24.2 4c28.8 4.6 49.6 30 49.6 60.4 0 16.8-6.4 32.4-17.8 44.4-11.2 11.6-25.8 18-41.2 18h-330.4c-15.4 0-30-6.4-41.2-18-11.4-12-17.8-27.8-17.8-44.4 0-28.6 17.8-53.6 44.2-62.2l21.8-7 0.4-22.8c0.4-22.4 18-40.8 39.4-40.8 5.6 0 16.8 2.2 24.2 5.6s17.6 8 17.6 8l15.2-21.8c20.8-32.6 58.4-52.8 98-52.8zM548.6 320c-51.2 0-98.8 26.8-125 67.6-9-4.2-19.2-6.8-29.8-6.8-39 0-70.8 32.2-71.4 72.2-40 13-66.4 50.4-66.4 92.4 0 51.4 40.6 94.4 90.8 94.4h330.2c50.2 0 90.8-42.8 90.8-94.4 0-46.4-33.2-84.8-76.6-91.8-7.6-75-67.2-133.6-142.6-133.6v0z",
      "M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM677.2 640h-330.4c-50.2 0-90.8-42.8-90.8-94.4 0-42 26.4-79.6 66.4-92.4 0.6-40 32.4-72.2 71.4-72.2 10.6 0 20.8 2.4 29.8 6.8 26.2-41 73.8-67.6 125-67.6 75.4 0 135 58.6 142.8 133.8 43.4 7 76.6 45.4 76.6 91.8 0 51.4-40.6 94.2-90.8 94.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-circle"
    ]
  },
  {
    "paths": [
      "M618.4 432l-154 153.8-58.4-57.8-22 22 69.2 68.6c3 3 7.2 5.6 11 5.6s7.8-2.4 10.8-5.4l165-164.4-21.6-22.4z",
      "M826 452.2c-13.8-128.4-118-228.2-250-228.2-89.6 0-173 45.6-218.8 115.4-15.8-7.4-33.6-11.4-52.2-11.4-68.4 0-124 55-125 123.2-69.8 22-116 85.2-116 156.8 0 87.8 71.2 160 159 160h578c87.8 0 159-72.2 159-160 0-79.2-58-143.8-134-155.8zM801 736h-578c-70 0-127-57.6-127-128 0-28.6 8.8-54 25.6-77.2 17-23.2 40.4-40.4 68-49l22-7 0.4-23.2c0.4-24.6 10.2-47.6 27.6-64.8 17.6-17.2 40.6-26.8 65.2-26.8 13.6 0 26.6 2.8 38.8 8.4l25 11.6 15.2-23c41.6-63.6 115.8-101.4 191.6-101.4 55.6 0 105 20.6 146.2 57.8 41 37 66.6 87.4 72.6 142l2.6 24.4 24.2 3.8c29.4 4.6 56.6 19.8 76.2 42.8 19.8 23.2 30.8 51.2 30.8 81.6 0 70.4-57 128-127 128z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-done-outline"
    ]
  },
  {
    "paths": [
      "M826 452.2c-13.8-128.4-118-228.2-250-228.2-89.6 0-173 45.6-218.8 115.4-15.8-7.4-33.6-11.4-52.2-11.4-68.4 0-124 55-125 123.2-69.8 22-116 85.2-116 156.8 0 87.8 71.2 160 159 160h578c87.8 0 159-72.2 159-160 0-79.2-58-143.8-134-155.8zM475 618.6c-3 3-7.2 5.4-10.8 5.4s-8-2.6-11-5.6l-69.2-68.4 22-21.8 58.4 57.8 154-153.8 21.6 22.2-165 164.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-done"
    ]
  },
  {
    "paths": [
      "M354.236 723.86l-23.232 23.206 180.996 180.934 181.162-180.884-23.232-23.208-141.39 141.268v-449.176h-32.86v449.176z",
      "M826.024 324.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h193v-32h-193c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128h-193v32h193c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-download-outline"
    ]
  },
  {
    "paths": [
      "M496 865.176l-141.604-141.316-23.312 23.206 180.956 180.934 181.142-180.884-23.512-23.208-141.67 141.268v-225.176h-32z",
      "M826.024 324.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h273v-224h32v224h273c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-download"
    ]
  },
  {
    "paths": [
      "M826.024 452.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h578c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774zM801 736h-578c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-outline"
    ]
  },
  {
    "paths": [
      "M669.93 524.14l23.232-23.206-180.998-180.934-181.16 180.886 23.232 23.208 141.388-141.27 0.002 513.176h32.86l-0.002-513.176z",
      "M826.024 356.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h193v-32h-193c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128h-193v32h193c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-upload-outline"
    ]
  },
  {
    "paths": [
      "M496 672h32v224h-32v-224z",
      "M826.024 356.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h273v-289.176l-141.576 141.27-23.326-23.208 181.112-180.886 180.974 180.934-23.484 23.206-141.7-141.316v289.176h273c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud-upload"
    ]
  },
  {
    "paths": [
      "M826.024 452.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h578c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloud"
    ]
  },
  {
    "paths": [
      "M553.2 590.8c-1 0-2.2-0.2-3.2-0.2-5.2 0-10.4 0-15.6 0.6-18.4-81.6-91.2-143.2-178.4-143.2-101 0-183 82-183 183.2 0 6.2 0.4 12.2 1 18.2-61.6 5.4-110 60.4-110 123.6 0 66.8 53.2 125 120 125h369.2c83.4 0 150.8-69.6 150.8-153s-67.6-154.2-150.8-154.2zM637 830c-22.6 22.8-52.4 36-83.8 36h-369.2c-23.2 0-45.2-10.2-61.8-27.8-16.6-17.4-26.2-41.6-26.2-65.6 0-22.8 8.4-44.8 23.8-62 15.2-17 35.4-27.4 57-29.4l32.2-2.8-3.2-32.2c-0.4-5-0.8-10.2-0.8-15.2 0-83.4 67.8-151.2 151-151.2 34.8 0 67.6 11.6 94.8 33.8 26.4 21.6 45 51.6 52.4 84.6l6.4 28.4 28.8-3.8c3.2-0.4 7.4-0.8 11.6-0.8h3.2c31.4 0 61.2 13 83.8 36.2s35.2 54 35.2 86c-0.2 32.2-12.6 63-35.2 85.8z",
      "M900 612c-5 0.2-10 0.4-15 0.4-82.8 0-160.8-31.6-219.4-88.8s-90.8-133.2-90.8-214.2c0-46 10.4-90.6 30.4-131 8.8-17.8 17.8-34.6 30-50.6h-0.6c-21.6 2.4-40.4 6.6-60.6 12.8-123.6 38-215.6 145.4-228.2 275.4 3.6-0.2 7-0.2 10.6-0.2 7.2 0 14.4 0.4 21.6 1.2 5.4-51.6 24.8-100.2 56.8-142.2 34.4-45.2 82.6-80.2 136.6-99.4-18.8 42.2-28.4 87.2-28.4 134 0 89.6 35.8 173.8 100.6 237 64.6 63 150.4 97.8 241.8 97.8 1.6 0 3.2 0 4.8 0-41.6 43.4-95.6 72.8-154.2 85.2 0.4 4.8 0.6 9.6 0.6 14.4 0 6.2-0.4 12.2-0.8 18.2 75-14 140.8-52.8 188.4-107.4 13.8-15.8 26-30.6 36.6-49-20.2 5-40.4 5.4-60.8 6.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloudy-night-outline"
    ]
  },
  {
    "paths": [
      "M553.2 590.4c-5 0-9.8 0-14.6 0.4-1.4 0.2-2.8 0.2-4.2 0.4-8.6-38.2-29-71.8-57.2-97-2-1.8-4.2-3.6-6.2-5.4-2-1.6-4-3.2-6-4.6-2.8-2.2-5.8-4.2-8.8-6-5.6-3.6-11.2-7-17.2-10-2.2-1.2-4.6-2.2-6.8-3.4-23.2-10.8-49-16.8-76.2-16.8 0 0 0 0 0 0-2 0-3.8 0-5.8 0-0.2 0-0.4-0.2-0.6-0.2-1.8 0-3.8 0-5.6 0 0 0 0 0 0 0s0 0.2 0 0.2c-96 6.2-171 85.8-171 183 0 6.2 0.4 12.2 1 18.2-61.6 5.4-110 59.4-110 122.6 0 4.2 0.2 8.4 0.6 12.4 6 61.4 56.8 111.6 119.4 111.6h369.2c75.6 0 138.2-56.4 149.2-129.2 0 0 0 0 0 0v0 0c0.4-2.2 0.6-4.2 0.8-6.4 0-0.8 0.2-1.6 0.2-2.4 0.2-1.6 0.2-3.2 0.4-4.8 0-0.8 0-1.4 0.2-2.2 0.2-2.2 0.2-4.6 0.2-7 0-10.4-1-20.6-3-30.6-14.4-69.2-75.2-122.8-148-122.8z",
      "M900 612c-5 0.2-10 0.4-15 0.4-82.8 0-160.8-31.6-219.4-88.8s-90.8-133.2-90.8-214.2c0-46 10.4-90.6 30.4-131 8.8-17.8 17.8-34.6 30-50.6h-0.6c-21.6 2.4-40.4 6.6-60.6 12.8-123.6 38-215.6 145.4-228.2 275.4 3.6-0.2 7-0.2 10.6-0.2 49 0 97 17 135.2 48.2 30.4 24.8 53.6 57.6 67 94.2 47 1.2 91 20.8 124.6 55.2 34.4 35.2 53.2 81.6 53.2 130.4 0 6.2-0.4 12.2-0.8 18.2 75-14 140.8-52.8 188.4-107.4 13.8-15.8 26-30.6 36.6-49-20 5-40.2 5.4-60.6 6.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloudy-night"
    ]
  },
  {
    "paths": [
      "M472 224c57 0 108 18.8 147.2 54.2 35.4 31.8 60.8 76.6 71.6 126l5.8 26.6 27.4-1.8c3.2-0.2 7.4-0.2 10.2-0.2 2.4 0 4.8 0 7 0 2.4 0 5 0 7.4 0 47.2 0 92 19.6 126.2 55 34.2 35.6 53 82 53 130.8 0 48.6-18.8 95.4-52.8 130.2-34 34.6-79.6 54.8-127.2 54.8h-515.8c-36.2 0-69.2-15.8-95.4-42.8-26.2-26.6-40.6-62.6-40.6-100 0-35.8 13.2-71 37-98.8 23.6-27.6 54.8-44.6 87.8-47.4l32.2-3-3.2-32c-0.6-6.8-1.4-14.6-1.4-22.6 0-60.6 23.6-118 66.2-161.6 42.6-43.4 98.6-67.4 157.4-67.4zM472 192c-140 0-255.6 119.4-255.6 261.6 0 8.6 0.6 17.2 1.6 25.6-86.4 7.8-154 88-154 176.8 0 94 75.8 176 169.2 176h515.6c116.6 0 211.2-98.8 211.2-216s-94.6-217.6-211.2-217.6c-4.6 0-9.6-0.4-14.4-0.4-4.2 0-8.4 0-12.2 0.2-23.6-107-110.2-206.2-250.2-206.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloudy-outline"
    ]
  },
  {
    "paths": [
      "M472 192c-140 0-255.6 119.4-255.6 261.6 0 8.6 0.6 17.2 1.6 25.6-86.4 7.8-154 88-154 176.8 0 94 75.8 176 169.2 176h515.6c116.6 0 211.2-98.8 211.2-216s-94.6-217.6-211.2-217.6c-4.6 0-9.6-0.4-14.4-0.4-4.2 0-8.4 0-12.2 0.2-23.6-107-110.2-206.2-250.2-206.2v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-cloudy"
    ]
  },
  {
    "paths": [
      "M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z",
      "M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z",
      "M637.8 511l23.2 23.2-149 137-149-137 23.2-23.2 109.4 97.4v-255.6h32.8v255.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-code-download"
    ]
  },
  {
    "paths": [
      "M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z",
      "M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z",
      "M544 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M416 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M672 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-code-working"
    ]
  },
  {
    "paths": [
      "M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z",
      "M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-code"
    ]
  },
  {
    "paths": [
      "M522.2 160l11.2 44.8 5 19.8 20 3.8 44 8.6 12-15.8 28.4-37.2 13.2 5.4-6.8 45.4-3 19.8 16.6 11.4 21.4 14.6 16.6 11.4 17.4-10 39.2-22.6 10.2 10.2-33.2 55.8 12 17 15 21.2 11.2 16 19.4-2.6 44.2-6.2 5.6 13.4-51.4 39 3.6 19.4 5 26.4 3.8 19.8 61.8 16.4v14.6l-62 16.2-3.6 20.2-5 27-3.6 19.4 15.8 11.8 34.6 26-5.6 13.2-62.6-9-11.2 16.2-15.8 22.8-11.6 16.8 31.4 54.2-10.4 10.4-37-21.4-18-10.6-37.2 27-15.6 11.4 2.8 19.2 6.4 42.8-13.4 5.6-26.4-34.6-12.2-15.8-19.6 4-27.2 5.4-19.8 4-4.8 19.6-11 42.4h-14.4l-11.4-42.8-5-19.2-19.4-4-46.8-9.8-12.2 16.4-26.4 35.6-13.4-5.6 5.8-44.2 2.6-20-16.8-11-22.4-14.6-16.8-11-17.2 10.4-39 23.4-10-10 23.4-40 9.8-16.8-10.4-16.4-14.2-22.6-11-17.6-20.6 3-45.2 6.8-5.6-13.2 53-39.8-4-19.8-5-25-4-19.8-19.4-5-46-11.6v-14.2l65.2-16.4 4.2-19.4 5.2-24.4 4.4-20-16.4-12.4-38-28.6 5.6-13.4 46.4 6.6 20.4 2.8 11-17.4 24-37.6-10.2-17-24.8-41.6 10-10 41.2 24.6 16.6 10 40-24.6 17.8-11-2.8-20.6-6.4-47 13.4-5.6 40.2 54.2 19.8-3.8 44-8.4 5.2-19.6 12-45.6h14.2zM547 128h-64l-18.4 69.4-24.2 4.6-43-58.2-59.2 24.6 9.6 71.4-23.4 14.4-62.4-37.6-45.2 45.2 37.6 63-13.4 21-71-10-24.4 59.2 57.8 43.4-5.4 24.4-70 17.8v64l69.8 17.8 5 25-56.6 42.6 24.6 59 70-10 14.2 22.6-35.8 61.2 45.2 45.2 60.4-36.4 22.4 14.6-9 68.6 59.2 24.4 41.2-55.6 26.8 5.6 17.6 66.8h64l16.6-66.8 27.2-5.4 41.4 54 59.2-24.4-10-67.4 20.4-14.8 58 33.8 45.2-45.2-33.6-57.8 15.8-22.8 67.6 9.6 24.6-59-54.4-41 5-27 66-17.2v-64l-66-17.4-5-26.4 55.4-41.8-24.4-59.4-68.8 9.6-15-21.2 35.4-59.4-45.2-45.2-60.4 34.8-21.4-14.6 10.6-70-59-24.6-43.2 56.6-24.6-4.8-17.4-68.8z",
      "M512 256c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256zM290.8 547c-1.8-11.6-2.8-23.2-2.8-35 0-59.8 23.4-116 65.6-158.4 42.4-42.2 98.6-65.6 158.4-65.6 12 0 23.8 1 35.6 2.8 2.8 0.4 5.8 1 8.6 1.6l-55.6 207.8-208.4 55.8c-0.4-3-1-6-1.4-9zM651.4 687.4c-39.4 31.4-88.2 48.6-139.4 48.6-59.8 0-116-23.4-158.4-65.6-22.2-22.2-39-48-50.2-76.4-0.8-2.2-1.8-4.4-2.4-6.6l206.8-55 149.8 149.8c-2 1.8-4 3.4-6.2 5.2zM685.8 653.2c-1.8 2.2-3.6 4.4-5.6 6.6l-150-150 56-209.2c2.2 0.8 4.4 1.6 6.6 2.4 28.6 11.2 54.8 28.2 77.2 50.4 42.6 42.6 66 98.8 66 158.6 0 52-17.6 101.4-50.2 141.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-cog-outline"
    ]
  },
  {
    "paths": [
      "M593.2 303.2c-2.2-0.8-4.4-1.6-6.6-2.4l-56 209.2 150 150c2-2.2 3.8-4.4 5.6-6.6 32.2-40 49.8-89.4 49.8-141.4 0-59.8-23.4-116-65.6-158.4-22.4-22.4-48.6-39.4-77.2-50.4z",
      "M556.2 292.4c-2.8-0.6-5.8-1-8.6-1.6-11.6-1.8-23.6-2.8-35.6-2.8-59.8 0-116 23.4-158.4 65.6-42.2 42.4-65.6 98.6-65.6 158.4 0 11.8 1 23.6 2.8 35 0.4 3 1 6 1.6 8.8l208.4-55.8 55.4-207.6z",
      "M301 587.4c0.8 2.2 1.6 4.4 2.4 6.6 11.2 28.2 28 54.2 50.2 76.4 42.4 42.2 98.6 65.6 158.4 65.6 51.2 0 100-17.2 139.4-48.6 2.2-1.6 4.2-3.4 6.2-5.2l-149.8-149.8-206.8 55z",
      "M896 545.6v-64l-66.6-17.4-5.2-26.4 55.2-41.8-24.4-59.2-68.8 9.6-15-21.2 35.4-59.4-45.2-45.2-60.4 34.8-21.4-14.6 10.6-70-59-24.8-43.2 56.6-24.6-5.2-17.4-69.4h-64l-18.4 69.8-24.2 4.8-43-58-59.2 24.6 9.6 71.4-23.4 14.4-62.6-37.4-45.2 45.2 37.6 63-13.4 21-71-10-24.2 59.2 57.8 43.4-4.8 24.4-69.6 17.8v64l69.4 17.8 4.8 25-56.8 42.6 24.6 59.2 70-10 14.2 22.6-35.8 61.2 45.2 45.2 60.4-36.4 22.4 14.6-9 68.6 59.2 24.4 41.2-55.6 26.8 5 17.6 66.2h64l16.6-66.2 27.2-5.2 41.4 54.2 59.2-24.4-10-67.4 20.4-14.8 58 33.8 45.2-45.2-33.6-57.8 15.8-22.8 67.6 9.6 24.6-59-54.6-41 5.4-27 66.6-17.2zM512 768c-141.4 0-256-114.6-256-256s114.6-256 256-256 256 114.6 256 256-114.6 256-256 256z"
    ],
    "grid": 0,
    "tags": [
      "ios-cog"
    ]
  },
  {
    "paths": [
      "M822.8 600.6l-367.6-364c0 0 0 0 0 0l-112.4-112.6c-18.6-18.6-43.2-28-67.8-28s-49.2 9.4-67.8 28v0c-37.4 37.4-37.4 98.4 0 135.8l98.6 98.6-209.8 208.4 342.6 329.2c0 0 270.2-261.4 292.2-283.4 11.6-11.6 36.4-14.2 57.2-14.2 19 0 34.8 2.2 34.8 2.2zM229.6 237.2c-12-12-18.6-28-18.6-45.2s6.6-33.2 18.6-45.2c12-12 28-18.6 45.2-18.6s33.2 6.6 45.2 18.6l99 99-90.8 90.2-98.6-98.8zM708 590c-17.8 17.8-204.6 198.6-269.6 261.6l-296.6-285.2 299.8-298.2 305.2 302.2c-16.6 3.8-29.4 10.4-38.8 19.6z",
      "M832 672c0 0-96 106.6-96 159.8s43 96.2 96 96.2c0 0 0 0 0 0 53 0 96-43.2 96-96.2 0-53.2-96-159.8-96-159.8zM877.2 877.2c-12 12.2-28.2 18.8-45.2 18.8-35.2 0-64-28.8-64-64.2 0-3.8 2-25.6 41.6-80.6 7.8-10.8 15.4-20.8 22.4-29.4 6.8 8.4 14.4 18.4 22 29 40 55.4 42 77.2 42 81 0 17.2-6.6 33.2-18.8 45.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-fill-outline"
    ]
  },
  {
    "paths": [
      "M822.8 600.6l-367.6-364c0 0 0 0 0 0l-112.4-112.6c-18.6-18.6-43.2-28-67.8-28s-49.2 9.4-67.8 28v0c-37.4 37.4-37.4 98.4 0 135.8l98.6 98.6-209.8 208.4 342.6 329.2c0 0 270.2-261.4 292.2-283.4 11.6-11.6 36.4-14.2 57.2-14.2 19 0 34.8 2.2 34.8 2.2zM229.6 237.2c-12-12-18.6-28-18.6-45.2s6.6-33.2 18.6-45.2c12-12 28-18.6 45.2-18.6s33.2 6.6 45.2 18.6l99 99-90.8 90.2-98.6-98.8z",
      "M832 672c0 0-96 106.6-96 159.8s43 96.2 96 96.2c0 0 0 0 0 0 53 0 96-43.2 96-96.2 0-53.2-96-159.8-96-159.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-fill"
    ]
  },
  {
    "paths": [
      "M570.8 160c91.2 0 174.4 29.2 234.4 82.2 37.8 33.6 58.8 78 58.8 125.2s-20.8 91.6-58.8 125.2l-60.6 53.8c-20.8 18.4-32.2 42.4-32.2 67.8 0 25.2 11.4 49.2 32.2 67.8 18.6 16.4 32.8 22.8 61.2 27.6l1.6 0.2c11.8 2 25.2 4.2 31 9.4 5.8 5.4 9.6 16 9.6 26.2 0 5.4-1.4 15.2-9 22-69.2 61.4-170 96.8-276.4 96.8-1 0-2.2 0-3.2 0-53-0.4-104.4-9.2-152.8-26.2-50.2-17.8-94.6-43.4-132-76.4-37.4-33.2-66.4-71.8-86-114.8-19-41.6-28.6-85.4-28.6-130.2s9.6-88.4 28.4-129.8c19.6-43 48.6-81.6 86-114.8 80.6-71.2 188.6-112 296.4-112zM570.8 128c-111.4 0-227.8 40.6-317.6 120.2-167 147.6-167 389.4 0 537 83 73.4 195 110 305.8 110.8 1.2 0 2.4 0 3.4 0 110.8 0 220-35.8 297.6-104.8 28.6-25.4 23.8-73.2 0-95.6-13.2-12.2-32.6-15.2-49.2-18-23-3.8-31.8-8-45.2-20-28.6-25.4-28.6-62.2 0-87.6l60.6-53.8c92.8-82 92.8-216.4 0-298.4-68.2-60-160-89.8-255.4-89.8v0z",
      "M640 288c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM640 256c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z",
      "M448 266c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM448 234c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z",
      "M304 400c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM304 368c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z",
      "M320 588c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM320 556c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z",
      "M592 800c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM592 640c-35.2 0-64 28.8-64 64s28.8 64 64 64 64-28.8 64-64-28.8-64-64-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-palette-outline"
    ]
  },
  {
    "paths": [
      "M860.2 695.8c-13.2-12.2-32.6-15.2-49.2-18-23-3.8-31.8-8-45.2-20-28.6-25.4-28.6-62.2 0-87.6l60.6-53.8c92.8-82 92.8-216.4 0-298.4-68.4-60.2-160.2-90-255.6-90-111.4 0-227.8 40.6-317.6 120.2-167 147.6-167 389.4 0 537 83 73.4 195 110 305.8 110.8 1.2 0 2.4 0 3.4 0 110.8 0 220-35.8 297.6-104.8 28.8-25.4 24-73.2 0.2-95.4zM240 432c0-35.4 28.6-64 64-64s64 28.6 64 64-28.6 64-64 64-64-28.6-64-64zM320 684c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM448 362c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM592 800c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM640 384c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-palette"
    ]
  },
  {
    "paths": [
      "M384 299.4l-68 68 512.2 512.2 67.8-68-512-512.2zM425.2 431.4l22.8-22.8 403 403-22.8 22.8-403-403z",
      "M368 128h32v80h-32v-80z",
      "M368 536h32v80h-32v-80z",
      "M560 352h80v32h-80v-32z",
      "M128 352h80v32h-80v-32z",
      "M200.223 211.181l22.627-22.627 56.568 56.568-22.627 22.627-56.568-56.568z",
      "M256.8 477.050l22.627 22.627-56.568 56.568-22.627-22.627 56.568-56.568z",
      "M545.154 188.548l22.627 22.627-56.568 56.568-22.627-22.627 56.568-56.568z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-wand-outline"
    ]
  },
  {
    "paths": [
      "M366 124h48v128h-48v-128z",
      "M366 532h48v128h-48v-128z",
      "M548 358h128v48h-128v-48z",
      "M595.8 212.2l-33.2-33.2-90.4 90.6 33.2 33.4z",
      "M190.2 218.2l90.4 90.8 33.2-33.4-90.4-90.6z",
      "M184.2 558.2l33.2 33.4 90.4-90.6-33.2-33.4z",
      "M116 358h128v48h-128v-48z",
      "M384.4 306.8l-68 68.4 86.8 87 68.2-68.2z",
      "M894 817.6l-390.6-391.6-68.2 68.2 390.8 391.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-wand"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4s381.4 171.2 381.4 381.4c0 210.2-171.2 381.4-381.4 381.4z",
      "M448 448l-192 320 320-192 192-320-320 192zM349.2 674.8l122-203.4 81.4 81.4-203.4 122z"
    ],
    "grid": 0,
    "tags": [
      "ios-compass-outline"
    ]
  },
  {
    "paths": [
      "M552.6 552.6l-81.2-81.2-122.2 203.4z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM576 576l-320 192 192-320 320-192-192 320z"
    ],
    "grid": 0,
    "tags": [
      "ios-compass"
    ]
  },
  {
    "paths": [
      "M274.6 852.8c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11 10.8 29 0 39.8z",
      "M760.2 128.2v0 0z",
      "M426.2 481.4l51.8-51.8c6.2 6-2-2.2 17.2 16.6 8.4-7.8 16.2-15.2 23.2-22-38.4-37.8-29-28.4-29-28.4-2.8-2.8-7.6-4.6-12.6-4.6-2.8 0-5.8 0.6-8.4 2l-11.4 6c-56.2-55.6-70.8-80.6-68.6-123.6 2.2-44.8 24.6-74.4 61.2-105.4 49.6-42.2 121.4-30.6 121.4-30.6 16 0-8.2-17-20.8-25-18.8-12-46.6-19.2-75.8-19.2-28.6 0-60.8 5-93.6 18.6-93 38-148.2 91-162.4 105-14 14-33.6 36-45.8 53.4s3.8 42-12.2 58-49.6 0-49.6 0c-2.8 0-5.8 1-7.8 3.2l-68.4 67.8c-4.4 4.4-4.4 11.4 0 15.6l127.2 126.4c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l66.4-69.6c4.4-4.4 4.4-11.4 0-15.6 0 0-10.6-10.4-24.2-24s1.6-38.8 10.6-46.8c9-8.2 23.2-13.6 42.4-13.6 8.6 0 14.8 1.4 22.8 3.6 24.4 6.8 51.6 31.8 101.8 81.6l-7.8 13c-4.6 7.6-1.8 16.6 2.6 20.8 0 0-10-9.8 26.2 26.4 8-7.4 15.6-14.8 23.2-22-18-18.6-9.2-9.8-15.2-15.8zM420 435.8l-8-8c-47.8-47.6-76.6-73.2-107.8-81.8-10.2-2.8-19-4.8-31.4-4.8-23 0-39.4 5.4-57.4 17.4-21 14-37.2 44.2-37.2 63 0 19 13.4 29 24.6 40.4l-38.8 38.4-92-91.2 38.6-38.2 15.2 2.4c25.8 0 45.6-7 58.8-20 17.4-17.4 16-40.2 15-53.6-0.2-3.2-0.6-8-0.4-10.4 11-15.4 29-35.6 41.4-47.8 23-22.8 73.4-66 152-98 23-9.4 47-14.8 71.4-15.8-13.8 4.4-25.4 10.2-34.6 17.6v0 0c-46.2 37.2-70.8 80.6-73 129-2.8 57.8 20.6 91 78 147.8l2.8 2.8-14.2 14.2-3-3.4z",
      "M886.4 809.6l-77.8 77.2c-32-38.2-123.6-143-217.4-240.2-7.2 7.6-14.6 15.4-22 23.4 117.2 121.4 230.2 255.6 230.2 255.6 2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.4-4.4 4.4-11.4 0-15.6 0 0-138-114.6-260.8-231.6-6.8 7.2-14.2 15-22 23.2 98 93.2 204.8 185.4 243.8 217.6z",
      "M959 250.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.4-22.4-53.6-33.2-78-33.2-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40 42.4-82.2 121.4-45 209 4.4 10.6 9.4 24.6-5.4 39.4-3 2.8-19.8 18.8-45 42.6-7.2 6.8-15 14-23.2 22-16.2 15.2-34.2 32.4-53.6 50.6-7.6 7.2-15.4 14.6-23.2 22-114.2 107.8-254.2 239.4-254.2 239.4-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 131.2-139.8 238.8-254.2 7.4-8 14.8-15.8 22-23.4 18.6-19.8 36-38.2 51.6-54.6 7.8-8.4 15.2-16.2 22-23.2 23-24.4 38.8-40.8 42-44 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-23.8-6.8-55.6-33.4-82.2zM960.4 330.6c-1.4 24-11.4 61-50 99.6-29.8 29.8-78.6 49.8-121.6 49.8-19 0-35.8-3.8-50-11.2v0 0c-7-3.6-18-8.4-31.8-8.4-11.2 0-28 3.4-44.6 19.4-18 17.6-362.6 384.8-377.4 400.4l-0.8 0.8c-11.4 13.2-26.8 15.2-35 15.2-14.8 0-29.4-6-40.2-16.4-10.8-11-17-26.8-16.4-42.4 0.4-9.2 3.2-22.4 15-32.4l1.2-0.8c15.6-14.8 384.6-362.2 399.8-377.2v0 0c15.8-15.8 19.2-32.4 19.4-43.6 0-13.8-4.8-25.2-7-30.8v0 0c-36.4-85.4 20.4-155.2 38.8-174.4v0 0c34.6-36.8 79.4-48.4 98.4-49.4 0.8 0 1.6 0 2.4 0 8 0 18 2 28 6l-89.4 89.8 3 16.4 18.4 102.4 4 21.8 21.8 4 119 21.6 11.8-11.8 78-78.4c5.6 13.4 5.6 25.4 5.2 30z"
    ],
    "grid": 0,
    "tags": [
      "ios-construct-outline"
    ]
  },
  {
    "paths": [
      "M760.2 128.2v0 0z",
      "M550.2 114.6c-18.8-12-46.6-19.2-75.8-19.2-28.6 0-60.8 5-93.6 18.6-93 38-148.2 91-162.4 105-14 14-33.6 36-45.8 53.4s3.8 42-12.2 58-49.6 0-49.6 0c-2.8 0-5.8 1-7.8 3.2l-68.4 67.8c-4.4 4.4-4.4 11.4 0 15.6l127.2 126.4c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l66.4-69.6c4.4-4.4 4.4-11.4 0-15.6 0 0-10.6-10.4-24.2-24s1.6-38.8 10.6-46.8c9-8.2 23.2-13.6 42.4-13.6 8.6 0 14.8 1.4 22.8 3.6 24.4 6.8 51.6 31.8 101.8 81.6l-7.8 13c-4.6 7.6-1.8 16.6 2.6 20.8 0 0-10-9.8 26.2 26.4l100.2-94.4c-38.4-37.8-29-28.4-29-28.4-2.8-2.8-7.6-4.6-12.6-4.6-2.8 0-5.8 0.6-8.4 2l-11.4 6c-56.2-55.6-70.8-80.6-68.6-123.6 2.2-44.8 24.6-74.4 61.2-105.4 49.6-42.2 121.4-30.6 121.4-30.6 16-0.6-8.2-17.6-20.8-25.6z",
      "M925.4 800.2c0 0-138-114.6-260.8-231.6l-95.6 101.4c117.2 121.4 230.2 255.6 230.2 255.6 2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.6-4.4 4.6-11.4 0.2-15.8z",
      "M959 250.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.4-22.4-53.6-33.2-78-33.2-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40 42.4-82.2 121.4-45 209 4.4 10.6 9.4 24.6-5.4 39.4-3 2.8-19.8 18.8-45 42.6-7.2 6.8-15 14-23.2 22-16.2 15.2-34.2 32.4-53.6 50.6-7.6 7.2-15.4 14.6-23.2 22-114.2 107.8-254.2 239.4-254.2 239.4-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 131.2-139.8 238.8-254.2 7.4-8 14.8-15.8 22-23.4 18.6-19.8 36-38.2 51.6-54.6 7.8-8.4 15.2-16.2 22-23.2 23-24.4 38.8-40.8 42-44 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-23.8-6.8-55.6-33.4-82.2zM274.6 852.8c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11 10.8 29 0 39.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-construct"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 93.2-33.6 178.4-89.2 244.8 0 0-0.2-0.2-0.2-0.2-40-16.4-131.8-48.2-185.8-64.2-4.8-1.4-5.4-1.8-5.4-21.4 0-16.2 6.6-32.6 13.2-46.6 7.2-15 15.4-40.4 18.4-63.2 8.4-9.8 20-29 27.2-65.8 6.4-32.4 3.4-44.2-0.8-55.2-0.4-1.2-1-2.4-1.2-3.4-1.6-7.6 0.6-47 6.2-77.6 3.8-21-1-65.6-29.8-102.6-18.2-23.4-53.2-52-117-56h-35c-62.8 4-97.6 32.6-116 56-29 37-33.8 81.6-30 102.6 5.6 30.6 7.8 70 6.2 77.6-0.4 1.4-0.8 2.4-1.2 3.6-4.2 11-7.4 22.8-0.8 55.2 7.4 36.8 18.8 56 27.2 65.8 3 22.8 11.4 48 18.4 63.2 5.2 11 7.6 26 7.6 47.2 0 19.8-0.8 20-5.2 21.4-56 16.6-144.4 48.4-180.2 63.8-55.8-66.4-89.4-151.8-89.4-245 0-210.2 171.2-381.4 381.4-381.4zM242.8 782c39.8-16 117.2-43.6 166.2-58.2h0.4c16.8-5.2 23.2-17 25.6-26 1.8-6.4 2-13 2-26 0-26.2-3.4-45.4-10.6-60.8-5.8-12.2-13.2-34.4-15.8-53.8l-1.2-9.4-6.2-7.2c-3.8-4.4-13.6-18.4-20.2-51.2-5.2-26-2.8-32-0.8-37.4v-0.4l0.2-0.6c0.4-1.2 1.2-3.2 2-5.6l0.4-2c3.4-16-1.2-63.8-6-90-2.2-12.4 0.6-47.6 23.6-77.2 14.2-18 41.6-40.2 91.8-43.6h33c51.2 3.4 78.8 25.6 92.8 43.8 23.2 29.6 25.8 64.8 23.6 77.2-4.8 26-9.4 74-6 90l0.4 1.2c0.8 3 1.8 5.6 2.4 7.2 2.2 5.6 4.2 11.8-0.8 37.2-6.6 32.8-16.2 46.6-20 51.2l-6.2 7.2-1.2 9.6c-2.6 19.4-10 41.4-15.6 53.6-8 17-16.2 37.6-16.2 60.2 0 11.6 0.2 19.2 2.2 26.4 2.6 8.8 9 20.4 25.8 25.6h0.4c47.4 14 127.8 41.6 172 58.8-69 68.8-164.2 111.4-269 111.4-104.8 0.2-199.8-42.4-269-111.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-contact-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 93-33.4 178.2-88.8 244.4-40-16.4-131.8-48.2-185.8-64.2-4.8-1.4-5.4-1.8-5.4-21.4 0-16.2 6.6-32.6 13.2-46.6 7.2-15 15.4-40.4 18.4-63.2 8.4-9.8 20-29 27.2-65.8 6.4-32.4 3.4-44.2-0.8-55.2-0.4-1.2-1-2.4-1.2-3.4-1.6-7.6 0.6-47 6.2-77.6 3.8-21-1-65.6-29.8-102.6-18.2-23.4-53.2-52-117-56h-35c-62.8 4-97.6 32.6-116 56-29 37-33.8 81.6-30 102.6 5.6 30.6 7.8 70 6.2 77.6-0.4 1.4-0.8 2.4-1.2 3.6-4.2 11-7.4 22.8-0.8 55.2 7.4 36.8 18.8 56 27.2 65.8 3 22.8 11.4 48 18.4 63.2 5.2 11 7.6 26 7.6 47.2 0 19.8-0.8 20-5.2 21.4-56.2 16.6-145.2 48.6-180.8 64-55.8-66.4-89.4-151.8-89.4-245 0-210.2 171.2-381.4 381.4-381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-contact"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM511.8 893.2c-104.8 0.2-199.8-42.4-269-111.2l-22.8-25c-6.2-7.4-12-14.8-17.6-22.6 9.4-8 20.2-15 31.6-19.2 21-8 44.8-7.6 66.6-13.2 18-4.6 40.4-11.8 54.4-24.8 12.8-12 14.2-30.4 15.4-47 1-14 0.8-27.8 0.8-41.8 0-9.8-11.4-15.4-17-23.2-9-12.2-9.4-30.4-11.2-45-0.8-6.4-1-14.6-6.4-19-6-4.8-10.4-7.4-13.4-15-4-10.4-5.4-21.6-8.6-32.4-2-7 5-13.6 7.8-19.4 5.2-10.6-3.8-27-5.6-38-5.6-32.8-5.4-68.6 18.2-94.6 47.4-52.4 156-35.8 171.6 37.8 4.8 23 1.8 49.8-4.6 72.2-2.8 9.6-6 16.6-0.4 26 8.4 13.6 4.8 22.4 0.8 37.6-3.2 12.6-7.2 18.2-16.8 26-8 6.4-6.8 22.4-8.2 31.6-1.6 11.2-2.6 23-9.4 32.4-2.6 3.6-16.8 14.8-16.8 18.6 0 22-1 44.4 2.8 66.2 5.2 31 31.2 38.4 57.2 49 26.4 10.2 57 6.4 82.6 19 26.4 13 51.8 36.8 59.4 66.2 0 0 4.4 38.2 4.2 80-44.8 18.4-94 28.8-145.6 28.8zM804.2 756.8l-0.2-0.2-23.2 25.2c-26.8 26.6-57.4 49.4-91.2 67.2l-0.6-33.2c0-59-35.6-111-91.6-130.4-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 10-41.8-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-12.8 5.6-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-0.6 0.4-1 0.8-1.4 1.2-34.4-57.2-54.2-124.2-54.2-195.6 0-210.2 171.2-381.4 381.4-381.4s381.4 171 381.4 381.4c0 59.2-13.6 115.4-37.8 165.4-8.8-25.6-30.4-44.8-57-53.6-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2-33.2-2-33.2 50.4-2.8 62-12.2 62-12.2 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-15.2-9.4-39.4-13.8-62.8-13.8-19 0-37.4 2.8-50.6 8.2-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 0 0 15 8.8 57.8 12.6 0 0 0.6 25.2 0 27.8-2.2 9.8-23.6 16.6-31.6 18.8-8.2 2.2-30.8 9.2-58.2 22.6 0 0 30.4 3 50 9.8 13.6-9.2 33.8-11.4 48-17.6s20.6-11.6 23.2-26.6-1-66.4-1-66.4c-24.4 1.8-53.8-3.4-53.8-3.4 8.2-26.4 8-55.4 8-83.4 0-24.4-0.2-47.6 5.2-65.4 4.8-16 12.8-25 28-31v0 0c8.8-3.6 23.6-5.8 38.4-5.8 23.2 0 39.2 4.8 46 9 19.6 12.2 24.4 40.6 24.8 62.4 0.2 9-0.2 18.8-0.6 29.2-1 26.6-2.4 55.8 6.6 84-0.2 0-0.2 0-0.4 0 0 0-26.6 3.6-52.6 0.6l-2.8 34.6c-1.4 14.2-3.8 35.8 9.6 52 15.4 18.6 40.4 23.8 60.4 27.8 5.2 1 10.4 2.2 13.4 3 15.2 5 41.4 18.8 44.8 62.6-8.6 14-18.4 27.4-29 40z"
    ],
    "grid": 0,
    "tags": [
      "ios-contacts-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM689 816c0-59-35.6-111-91.6-130.4-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 10-41.8-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-12.8 5.6-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-0.6 0.4-1 0.8-1.4 1.2-34.4-57.2-54.2-124.2-54.2-195.6 0-210.2 171.2-381.4 381.4-381.4s381.4 170.8 381.4 381.2c0 59.2-13.6 115.4-37.8 165.4-8.8-25.6-30.4-44.8-57-53.6-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2-33.2-2-33.2 50.4-2.8 62-12.2 62-12.2 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-15.2-9.4-39.4-13.8-62.8-13.8-19 0-37.4 2.8-50.6 8.2-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 0 0 15 8.8 57.8 12.6 0 0 0.6 25.2 0 27.8-2.2 9.8-23.6 16.6-31.6 18.8-8.2 2.2-30.8 9.2-58.2 22.6 0 0 30.4 3 50 9.8 0 0 52.8 12 92 50 36 34.8 41.2 77.4 42 128.6-10.4 7-21.2 13.4-32.4 19.2l-0.6-33z"
    ],
    "grid": 0,
    "tags": [
      "ios-contacts"
    ]
  },
  {
    "paths": [
      "M392 416h-200v32h256v-256h-32v200l-265.8-264-22.2 22.2z",
      "M632 416h200v32h-256v-256h32v200l265.8-264 22.2 22.2z",
      "M392 608h-200v-32h256v256h-32v-200l-265.8 264-22.2-22.2z",
      "M632 608h200v-32h-256v256h32v-200l265.8 264 22.2-22.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-contract"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2v-768.2c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.6 45.8-47.2 86.8-82.4 122.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-contrast"
    ]
  },
  {
    "paths": [
      "M736 832h-576v-544h448.234l32-32h-512.234v608h640v-480.234l-32 32z",
      "M475.246 568.168l-19.412-19.414 342.646-342.646-22.626-22.628-359.854 359.822v64.698h64.432l360.090-359.968-22.628-22.572z",
      "M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"
    ],
    "grid": 0,
    "tags": [
      "ios-create-outline"
    ]
  },
  {
    "paths": [
      "M512 640h-128v-128l256-256h-512v608h640v-480z",
      "M775.854 183.48l-359.854 359.822v64.698h64.432l360.090-359.968z",
      "M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"
    ],
    "grid": 0,
    "tags": [
      "ios-create"
    ]
  },
  {
    "paths": [
      "M256 128h32v96h-32v-96z",
      "M288 736v-416h-32v448h448v-32z",
      "M800 736h96v32h-96v-32z",
      "M128 256v32h608v608h32v-640z"
    ],
    "grid": 0,
    "tags": [
      "ios-crop-outline"
    ]
  },
  {
    "paths": [
      "M256 128h64v96h-64v-96z",
      "M320 704v-352h-64v416h416v-64z",
      "M800 704h96v64h-96v-64z",
      "M128 256v64h576v576h64v-640z"
    ],
    "grid": 0,
    "tags": [
      "ios-crop"
    ]
  },
  {
    "paths": [
      "M512 64l-448 192v448l448 256 448-256v-448l-448-192zM908 268.4l-396 223.6-393.6-224.4 393.6-171.6 396 172.4zM96 291.6l400 228.4v394l-400-228.6v-393.8zM528 914v-394l400-226.2v391.6l-400 228.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-cube-outline"
    ]
  },
  {
    "paths": [
      "M941.6 248.4l-429.6-184.4-429.6 184.4 429.6 245.8z",
      "M528 952l432-247.2v-430.2l-432 247.2z",
      "M64 274.6v430.2l432 247.2v-430.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-cube"
    ]
  },
  {
    "paths": [
      "M256.8 271.4c-22.8-56-29.6-109.8 9-143.4l206 276 20-26.8-210-281.2c-17.8 0-28.8 1.8-37 7.8-23.8 17.8-38.2 51.2-38.6 87.2-0.4 27 6.6 57.2 20.8 92.4 17 42 85 140.4 155.8 237.2 1.4 2 3.2 3.8 5 5.4 5.8-9.4 12-19 18-28.2-52.2-71.6-132.4-185.2-149-226.4z",
      "M780.8 109.8c-10.4-9.6-27-13.8-40-13.8l-254.8 342c0 0-0.2 0.2-0.2 0.2l-29 39.4c-0.2 0.2-0.4 0.6-0.6 0.8-1 1.6-15 21.8-30.4 45.4-6 9.2-12.2 19-18 28.2-7 11.2-13.2 22-17.6 30.4-7.2 14.2-14.6 28.8-21.4 43-7.4 15-14.4 29.2-20.8 41.4-20.4-14.6-44-22.2-68.6-22.2-35 0-67.4 15.4-91.6 43.2-23 26.4-35.8 61.4-35.8 98.4s12.8 72 35.8 98.6c24.2 27.8 56.8 43.2 91.6 43.2 28.8 0 56-10.4 78.4-30 21-18.2 36-42.6 43.6-70.8 2-6.2 23.2-69.4 52.2-114.6 18.4-28.8 44.4-46.8 59.2-55.6l27-19.4c0 0 25.2-17.4 76.2-83.4s161-223 180.4-270.8c14.4-35.2 21.2-65.6 20.8-92.4-0.2-35.8-11.8-58.6-36.4-81.2zM766.8 271.4c-22.8 56-173.6 263.8-200.8 295.4s-54.6 54.8-54.6 54.8-51.8 22.2-84.8 73.8c-33 51.4-55.8 122.6-55.8 122.6v0c-11.8 45.2-48.2 78.2-91.4 78.2-52.8 0-95.6-49.2-95.6-109.8s42.8-109.8 95.6-109.8c21.6 0 41.4 8.2 57.4 22 3.2 2.6 6 5.2 8 7.6 0 0 0.2 0.2 0.2 0.2 1 1 1.8 2 2.6 3 1.8 1.8 3.6 2.6 5.4 2.6 4.8 0 10.4-6.6 19-22.4 13.6-25.2 30.2-60.6 46.6-92.6s63.6-100.6 63.6-100.6l29-39.4 246.6-329c38.6 33.8 31.8 87.4 9 143.4z",
      "M744 644.6c-24.6 0-48.2 7.6-68.6 22.2-6.4-12.2-13.4-26.4-20.8-41.4-6.8-13.8-13.8-28-20.8-41.6l-21.8 27.8c14 27.8 27.6 56.6 39.2 78 8.6 16 14.2 22.4 19 22.4 1.8 0 3.6-1 5.4-2.6 0.8-1 1.8-2 2.6-3 0 0 0.2-0.2 0.2-0.2 2-2.6 4.6-5.2 8-7.6 16-13.8 35.8-22 57.4-22 52.8 0 96 49.2 96 109.8s-43 109.6-95.8 109.6c-43.2 0-79.6-33-91.4-78.2v0c0 0-22.8-71.2-55.8-122.6-9.4-14.8-20.6-27.2-31.4-37.4l-26 19.6c10.4 9.2 21.4 20.8 30.6 35 29 45.2 50 108.4 52.2 114.6 7.6 28.2 22.6 52.6 43.6 70.8 22.6 19.6 49.8 30 78.4 30 70.6 0 128-63.6 128-141.8s-57.6-141.4-128.2-141.4z",
      "M279.8 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.6 56-48 56z",
      "M544.2 544.4c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M744.2 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.4 56-48 56z"
    ],
    "grid": 0,
    "tags": [
      "ios-cut-outline"
    ]
  },
  {
    "paths": [
      "M616 554.4c51-66 161-223 180.4-270.8 14.4-35.2 21.2-65.6 20.8-92.4-0.4-35.8-12-58.6-36.6-81.2-10.4-9.6-27-13.8-40-13.8l-254.6 341.8c0 0-0.2 0.2-0.2 0.2l-29 39.4c-0.2 0.2-0.4 0.6-0.6 0.8-1 1.6-15 21.8-30.4 45.4-6 9.2-12.2 19-18 28.2-7 11.2-13.2 22-17.6 30.4-7.2 14.2-14.6 28.8-21.4 43-7.4 15-14.4 29.2-20.8 41.4-20.4-14.6-44-22.2-68.6-22.2-35 0-67.4 15.4-91.6 43.2-23 26.4-35.8 61.4-35.8 98.4s12.8 72 35.8 98.6c24.2 27.8 56.8 43.2 91.6 43.2 28.8 0 56-10.4 78.4-30 21-18.2 36-42.6 43.6-70.8 2-6.2 23.2-69.4 52.2-114.6 18.4-28.8 44.4-46.8 59.2-55.6l27-19.4c0 0.2 25.4-17.4 76.2-83.2zM279.8 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.6 56-48 56zM512.2 576.4c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z",
      "M383 520.8c1.4 2 3.2 3.8 5 5.4 3.4-5.6 7.2-11.4 10.8-17.2l93-131.6-210-281.4c-17.8 0-28.8 1.8-37 7.8-23.8 17.8-38.2 51.2-38.6 87.2-0.4 27 6.6 57.2 20.8 92.4 17.2 42 85.2 140.4 156 237.4z",
      "M744 644.6c-24.6 0-48.2 7.6-68.6 22.2-6.4-12.2-13.4-26.4-20.8-41.4-6.8-13.8-13.8-28-20.8-41.6l-21.8 27.8-72.8 66.2c10.4 9.2 21.4 20.8 30.6 35 29 45.2 50 108.4 52.2 114.6 7.6 28.2 22.6 52.6 43.6 70.8 22.6 19.6 49.8 30 78.4 30 70.6 0 128-63.6 128-141.8s-57.4-141.8-128-141.8zM744.2 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.4 56-48 56z"
    ],
    "grid": 0,
    "tags": [
      "ios-cut"
    ]
  },
  {
    "paths": [
      "M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z"
    ],
    "grid": 0,
    "tags": [
      "ios-desktop-outline"
    ]
  },
  {
    "paths": [
      "M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z",
      "M96 256h832v448h-832v-448z"
    ],
    "grid": 0,
    "tags": [
      "ios-desktop"
    ]
  },
  {
    "paths": [
      "M512 363.6c81.8 0 148.6 66.6 148.6 148.6 0 81.8-66.6 148.4-148.6 148.4-39.8 0-77-15.4-105-43.4s-43.4-65.2-43.4-105c-0.2-82 66.6-148.6 148.4-148.6zM512 624.6c62.2 0 112.8-50.6 112.8-112.8s-50.6-112.8-112.8-112.8-112.8 50.6-112.8 112.8c0 62.2 50.6 112.8 112.8 112.8zM512 331.6c-99.8 0-180.6 80.8-180.6 180.6s80.8 180.4 180.6 180.4 180.6-80.8 180.6-180.4c0-99.8-80.8-180.6-180.6-180.6v0zM512 592.6c-44.6 0-80.8-36.2-80.8-80.8s36.2-80.8 80.8-80.8 80.8 36.2 80.8 80.8c0 44.6-36.2 80.8-80.8 80.8v0z",
      "M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4s63 76.4 82.4 122c20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122s-76.4 63-122 82.4c-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 772c69.4 0 134.8-27 183.8-76.2s76.2-114.4 76.2-183.8-27-134.8-76.2-183.8-114.4-76.2-183.8-76.2-134.8 27-183.8 76.2-76.2 114.4-76.2 183.8 27 134.8 76.2 183.8 114.4 76.2 183.8 76.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0zM512 740c-126 0-228-102.2-228-228s102-228 228-228 228 102 228 228-102 228-228 228v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-disc-outline"
    ]
  },
  {
    "paths": [
      "M512 331.6c-99.8 0-180.6 80.8-180.6 180.6s80.8 180.4 180.6 180.4 180.6-80.8 180.6-180.4c0-99.8-80.8-180.6-180.6-180.6zM512 592.8c-44.6 0-80.8-36.2-80.8-80.8s36.2-80.8 80.8-80.8 80.8 36.2 80.8 80.8-36.2 80.8-80.8 80.8z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM512 740c-126 0-228-102.2-228-228s102-228 228-228 228 102 228 228-102 228-228 228z"
    ],
    "grid": 0,
    "tags": [
      "ios-disc"
    ]
  },
  {
    "paths": [
      "M544 128h-288v768h512v-545l-224-223zM544 173.2l179.6 178.8h-179.6v-178.8zM288 864v-704h224v224h224v480h-448z"
    ],
    "grid": 0,
    "tags": [
      "ios-document-outline"
    ]
  },
  {
    "paths": [
      "M768 352v-1l-224-223v224z",
      "M512 128h-256v768h512v-512h-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-document"
    ]
  },
  {
    "paths": [
      "M733.8 364l-228 234.2-92.2-93.8-34.8 35.4 109.2 111.4c4.8 4.8 11.4 9 17.4 9 5.8 0 12.4-4 17.2-8.8l245.4-251.4-34.2-36z",
      "M290.8 504.2l-34.8 35.4 109.2 111.4c4.8 4.8 11.4 9 17.4 9 5.8 0 12.4-4 17.2-8.8l17.4-17.8-126.4-129.2z",
      "M595.2 380l-124 127.4 34.4 35 123.8-126.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-done-all"
    ]
  },
  {
    "paths": [
      "M928 192v512h-832v-512h832zM928 160h-832c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h832.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32v0z",
      "M768 768l64 160h33.2l-65.2-160z",
      "M225.2 768l-65.2 160h33.2l64-160z",
      "M496 768h32v96h-32v-96z",
      "M864 256v384h-704v-384h704zM896 224h-768v448h768v-448z",
      "M512 96c-17.6 0-32 14.4-32 32h64c0-17.6-14.4-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-easel-outline"
    ]
  },
  {
    "paths": [
      "M768 768l64 160h33.2l-65.2-160z",
      "M225.2 768l-65.2 160h33.2l64-160z",
      "M496 768h32v96h-32v-96z",
      "M160 256h704v384h-704v-384z",
      "M928 160h-832c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h832.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32zM896 672h-768v-448h768v448z",
      "M512 96c-17.6 0-32 14.4-32 32h64c0-17.6-14.4-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-easel"
    ]
  },
  {
    "paths": [
      "M512 96c23.2 0 53 13.6 84 38.4 33.4 26.8 67.2 65.2 97.2 111.2 31.6 48.2 58 102.6 76.4 157.6 20.2 60.2 30.4 118.8 30.4 174.4 0 57.4-7.2 109.4-21.6 154.4-13.4 42.6-33.2 79-58.6 108.4-24.6 28.4-54.6 50.2-89.2 64.8-35.2 14.8-75 22.4-118.6 22.4s-83.4-7.6-118.6-22.4c-34.6-14.6-64.6-36.4-89.2-64.8-25.4-29.4-45.2-65.8-58.6-108.4-14.2-45.2-21.6-97-21.6-154.4 0-55.6 10.2-114.4 30.4-174.4 18.4-55 44.8-109.4 76.4-157.6 30.2-46 63.8-84.4 97.2-111.2 31-24.8 60.8-38.4 84-38.4zM512 64c-128 0-320 266.4-320 513.8s128 382.2 320 382.2 320-134.8 320-382.2-192-513.8-320-513.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-egg-outline"
    ]
  },
  {
    "paths": [
      "M512 64c-128 0-320 266.4-320 513.8s128 382.2 320 382.2 320-134.8 320-382.2-192-513.8-320-513.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-egg"
    ]
  },
  {
    "paths": [
      "M256 448h32v-224h576v576h-576v-224h-32v256h640v-640h-640z",
      "M595.8 386.2l23.2-23.2 149 149-149 149-23.2-23.2 109.4-109.4h-577.2v-32.8h577.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-exit-outline"
    ]
  },
  {
    "paths": [
      "M256 192v303.6h449.2l-109.4-109.4 23.2-23.2 149 149-149 149-23.2-23.2 109.4-109.4h-449.2v303.6h640v-640z",
      "M128 495.6h128v32.8h-128v-32.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-exit"
    ]
  },
  {
    "paths": [
      "M184 160h200v-32h-256v256h32v-200l265.8 264 22.2-22.2z",
      "M840 160h-200v-32h256v256h-32v-200l-265.8 264-22.2-22.2z",
      "M184 864h200v32h-256v-256h32v200l265.8-264 22.2 22.2z",
      "M840 864h-200v32h256v-256h-32v200l-265.8-264-22.2 22.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-expand"
    ]
  },
  {
    "paths": [
      "M240.8 80l514.8 880 27.6-16-514.8-880z",
      "M512 288c-24.6 0-48 2.6-71 7.6l13.2 22.6c18.8-3.6 38-5.4 57.8-5.4 148 0 262 102.2 348 199.2-53.8 54.6-118.4 121.2-198 161.4l12.6 21.6c91.6-46.6 164.8-125.8 221.4-183-88.8-102.8-214.8-224-384-224z",
      "M512 711.2c-152.2 0-243.2-91.6-348-199.2 71.6-72.6 134-127.4 198.4-161l-12.6-21.6c-73 38.4-143.2 101.4-221.8 182.6 115.6 118.4 212.6 224 384 224 24.6 0 48.2-2.8 71-7.8l-13.2-22.6c-18.8 3.6-38 5.6-57.8 5.6z",
      "M626 612c24.6-26.4 39.6-61.6 39.6-100 0-82.4-68.8-149.4-153.6-149.4-10.2 0-20.4 1-30 2.8l13.4 23c5.4-0.6 11-1 16.6-1 70.6 0 128 55.8 128 124.4 0 29-10.2 55.8-27.4 77l13.4 23.2z",
      "M398 412c-24.6 26.4-39.6 61.6-39.6 100 0 82.4 68.8 149.4 153.6 149.4 10.4 0 20.4-1 30.2-2.8l-13.4-23c-5.4 0.6-11 1-16.6 1-70.6 0-128-55.8-128-124.4 0-29 10.2-55.8 27.4-77l-13.6-23.2z",
      "M432.8 471.4c-6.6 12.2-10.4 26-10.4 40.6 0 46.6 37.6 84.6 85 87l-16.6-28.2c-24.8-8.6-42.8-31.6-42.8-58.6 0-4.2 0.4-8.4 1.2-12.4l-16.4-28.4z",
      "M591.2 552.6c6.6-12.2 10.4-26 10.4-40.6h-25.6c0 4.2-0.4 8.4-1.2 12.4l16.4 28.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-eye-off-outline"
    ]
  },
  {
    "paths": [
      "M240.8 80l514.8 880 27.6-16-514.8-880z",
      "M512 288c-24.6 0-48 2.6-71 7.6l40.8 70c9.8-1.8 19.8-2.8 30.2-2.8 84.8 0 153.6 67 153.6 149.4 0 38.4-15 73.4-39.6 100l48.6 83c91.6-46.6 164.8-125.8 221.4-183-88.8-103-214.8-224.2-384-224.2z",
      "M512 661.4c-84.8 0-153.6-67-153.6-149.4 0-38.4 15-73.4 39.6-100l-48.2-82.4c-73 38.2-143.2 101.2-221.8 182.4 115.6 118.4 212.6 224 384 224 24.6 0 48.2-2.8 71-7.8l-40.8-69.8c-9.8 2-19.8 3-30.2 3z",
      "M601.4 506.8c-7.8 3.4-16.4 5.2-25.4 5.2-3 0-6-0.2-8.8-0.6l24 41.2c6.6-12.2 10.4-26 10.4-40.6 0-1.8 0-3.6-0.2-5.2z",
      "M432.8 471.4c-6.6 12.2-10.4 26-10.4 40.6 0 46.6 37.6 84.6 85 87l-74.6-127.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-eye-off"
    ]
  },
  {
    "paths": [
      "M592 96c-185.6 0-336 150.4-336 336 0 87 33 166.4 87.4 226l-119.4 119.4-84.6-84.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l84.6 84.6-100.6 100.6c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l100.6-100.6 84.6 84.6c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-85-84.6 119.4-119.4c59.6 54.2 139 87.4 226 87.4 185.6 0 336-150.4 336-336s-150.4-336-336-336zM807 647c-57.4 57.4-133.8 89-215 89s-157.6-31.6-215-89-89-133.8-89-215 31.6-157.6 89-215 133.8-89 215-89 157.6 31.6 215 89 89 133.8 89 215-31.6 157.6-89 215z"
    ],
    "grid": 0,
    "tags": [
      "ios-female"
    ]
  },
  {
    "paths": [
      "M512 576c-59.6 0-109.8-40.8-124-96h-228v288h704v-288h-228c-14.2 55.2-64.4 96-124 96z",
      "M737 256h-1v160h-32v-160h-384v160h-32v-160h-1l-127 192h256c0 53 43 96 96 96s96-43 96-96h256l-127-192z"
    ],
    "grid": 0,
    "tags": [
      "ios-filing"
    ]
  },
  {
    "paths": [
      "M911.6 548c-0.2 0-0.4 0-0.8 0-8.8-0.4-15.6-7.8-15.2-16.6 0.2-5.4 0.4-15.2 0.4-21.4 0-85.6-36.8-192.2-82.2-237.6-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c51.4 51.4 91.6 165.6 91.6 260.2 0 6.4-0.2 16.6-0.4 22.8-0.4 8.6-7.4 15.2-16 15.2z",
      "M764 222.6c-3.6 0-7.2-1.2-10.2-3.8-71.4-59.4-155-90.8-241.8-90.8-82.6 0-159.8 24-223.4 69.6-7.2 5.2-17.2 3.4-22.4-3.6-5.2-7.2-3.4-17.2 3.6-22.4 69.2-49.4 153-75.6 242.2-75.6 94.4 0 185 34 262.2 98.4 6.8 5.6 7.8 15.8 2 22.6-3 3.6-7.6 5.6-12.2 5.6z",
      "M142.4 703.6c-6.8 0-13.2-4.4-15.4-11.4-19-63.6-31-116.2-31-182.2 0-100.6 36.4-197.6 102.4-273.4 5.8-6.6 16-7.4 22.6-1.6s7.4 16 1.6 22.6c-61 70-94.6 159.6-94.6 252.4 0 62 11.4 112.2 29.8 173 2.6 8.4-2.2 17.4-10.6 20-1.6 0.4-3.2 0.6-4.8 0.6z",
      "M244.2 847.2c-0.4 0-0.6 0-1 0-8.8-0.6-15.6-8-15-17 5.8-98-1.4-133.2-10.6-177.8-6.6-32.4-14.2-69-18.8-135.6-6.2-86 21.8-166.8 78.4-227.8 59.6-64 145.2-99.2 241.2-99.2 71 0 137.2 24.8 191 71.4 52.4 45.4 91.8 110.4 114.2 188 25 86.2 32 194.8 20.2 314-0.8 8.8-8.8 15.2-17.4 14.4-8.8-0.8-15.2-8.6-14.4-17.4 11.2-115.2 4.6-219.8-19.2-302-20.8-71.6-56.8-131.4-104.6-172.8-48-41.6-106.8-63.6-170-63.6-87 0-164.2 31.6-217.6 89-50.6 54.4-75.6 126.8-70 203.8 4.6 64.4 11.8 100 18.2 131.4 9.6 46.8 17.2 83.8 11.2 186-0.4 8.8-7.4 15.2-15.8 15.2z",
      "M337.4 896.6c-0.8 0-1.4 0-2.2-0.2-8.8-1.2-14.8-9.4-13.6-18 16-112.8-0.8-237.2-19.2-344-11.6-67.2 1.6-125.8 38.2-169.4 38.6-45.8 102.6-73 171.4-73 57.2 0 109 22.6 149.4 65.6 40.8 43 68.6 105.4 80.4 180 10 63 15 114.4 15.2 157 0.6 86-10 154.6-10.4 157.4-1.4 8.8-9.6 14.8-18.2 13.4-8.8-1.4-14.8-9.6-13.4-18.2 0.2-0.6 10.6-69.2 10.2-152.4-0.2-41-5-90.8-14.8-152.2-21.4-134.8-97.4-218.6-198.4-218.6-59.6 0-114.4 23-147 61.6-30.8 36.6-41.4 84.8-31.2 143.2 18.8 109.2 36 236.8 19.4 354-1.2 8-8 13.8-15.8 13.8z",
      "M632.6 906c-1 0-2 0-3-0.2-8.6-1.6-14.4-10-12.8-18.8 7-36.4 5.6-74.2 5.6-74.6-0.4-8.8 6.6-16.2 15.4-16.6 0.2 0 0.4 0 0.6 0 8.6 0 15.6 6.8 16 15.4 0 1.6 1.4 41.8-6.2 81.8-1.2 7.6-8 13-15.6 13z",
      "M432.2 922.6c-0.6 0-1.4 0-2-0.2-8.8-1.2-15-9.2-13.8-18 14.4-112.6 8.8-235.6-16.8-365.4-11.8-59.6 4.4-94.6 19.8-113.4 20-24.4 51.4-37.8 88.6-37.8 57.8 0 102 41.4 121.4 113.8 15.2 56.4 23.8 136.8 25.2 232.6 0.2 8.8-7 16-15.8 16.2 0 0-0.2 0-0.2 0-8.8 0-15.8-7-16-15.8-1.2-93-9.6-170.8-24.2-224.6-21.8-81.2-70.4-90-90.4-90-27.4 0-50 9.2-63.8 26-16 19.4-20.4 49.4-13.2 86.8 26.2 133.2 32 259.6 17 375.6-1 8.4-7.8 14.2-15.8 14.2z",
      "M532 928c-0.6 0-1.2 0-1.8 0-8.8-1-15.2-8.8-14.2-17.6 15.8-142.6 3.6-330.6-25.8-402.2-3.4-8.2 0.6-17.6 8.6-21 8.2-3.4 17.6 0.6 21 8.6 31.8 77 44.6 268.2 28.2 417.8-1 8.4-8 14.4-16 14.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-finger-print"
    ]
  },
  {
    "paths": [
      "M447.8 96c51.4 269.2-193.4 263.8-191.8 534.8 1.4 222 210 297.2 256.2 297.2 46.4 0 227.8-48.2 253.8-297.2 21.4-202.8-144.8-416-318.2-534.8zM512.2 913.2c0 0-81.4-66.6-81.4-148.6s81.2-148.6 81.2-148.6 80.6 66.6 80.6 148.6c-0 82-80.4 148.6-80.4 148.6zM734.4 628c-5.6 53.8-19.4 101.2-41 141-17.4 32.4-40.2 59.6-67.4 81.2-13 10.4-26.6 18.8-39.6 25.6 20-29.6 38.2-68.2 38.2-111.2 0-94.4-87.6-167.8-91.4-170.8l-21.2-17.4-21.2 17.4c-3.8 3-92 76.4-92 170.8 0 40.6 16.4 77.2 35.2 106.2-14.8-8-30.4-18.2-46-30.6-29.4-23.6-52.8-51.2-69.4-82.4-20.2-37.6-30.4-80.4-30.8-127-0.8-118.8 48.2-177.8 100-240.2 49.2-59.2 99.6-120.2 99-226.8 65 53.6 122.6 117 165.6 183.6 62.8 96.6 91 193.6 82 280.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-flame-outline"
    ]
  },
  {
    "paths": [
      "M447.8 96c51.4 269.2-193.4 263.8-191.8 534.8 1.4 222 210 297.2 256.2 297.2 46.4 0 227.8-48.2 253.8-297.2 21.4-202.8-144.8-416-318.2-534.8zM512.2 913.2c0 0-81.4-66.6-81.4-148.6s81.2-148.6 81.2-148.6 80.6 66.6 80.6 148.6c-0 82-80.4 148.6-80.4 148.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-flame"
    ]
  },
  {
    "paths": [
      "M547.8 264l-33 178.2-6.8 37.8h168l-199.6 280 33-178.2 6.6-37.8h-167.8l199.6-280zM605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-flash-outline"
    ]
  },
  {
    "paths": [
      "M605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-flash"
    ]
  },
  {
    "paths": [
      "M873.8 708.8l-233.8-390.8v-190h32v-32h-64v230.8l5 7.6 233.2 389.6c13.6 25.6 18.6 52 18 76-0.4 18.6-4 35.8-13 51.2-17 28.2-46.4 44.8-81.2 44.8h-511.8c-35 0-65-16.8-82-45.4-23.8-39.6-21.8-76.2 4.6-126.2l182.8-308.4h116.4v-32h-97.4l29.4-49.6 4-7.6v-6.8h96v-32h-96v-64h64v-32h-64v-64h160v-32h-224v32h32v190l-231.8 390.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2z",
      "M216.6 717.2c-13.8 21-21.8 48.2-21.8 67 0 55.2 31.6 79.6 91.4 79.6h451.8c59.6 0 90-31.4 91.4-80 0.6-19-6.2-45.4-20.2-66.6l-143.8-237.2h-306.4l-142.4 237.2zM647.4 512l134.4 221.8 0.4 0.2 0.4 0.4c10.8 16.4 15.2 36.6 15 48.4-0.4 15.6-5 28-13.4 35.6-9.6 8.6-25.4 13.6-46 13.6h-452.2c-22.2 0-38.6-4.4-47.4-12-3-2.4-12-10.2-12-36.2 0-11.8 5.8-32.8 16.6-49.4l0.4-0.6h0.4l133.2-221.8h270.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-flask-outline"
    ]
  },
  {
    "paths": [
      "M782 734l-0.4-0.2-134.2-221.8h-270.2l-133.2 221.8h-0.4l-0.4 0.6c-11 16.6-16.6 37.6-16.6 49.4 0 25.8 9 33.6 12 36.2 9 7.6 25.4 12 47.4 12h452c20.6 0 36.4-5 46-13.6 8.4-7.6 13-20 13.4-35.6 0.4-11.8-4.2-32-15-48.4l-0.4-0.4z",
      "M873.8 708.8l-233.8-390.8v-190h32v-32h-320v32h32v190l-231.8 390.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2zM432 192h48v32h-48v-32zM432 288h80v32h-80v-32zM398.6 384h81.4v32h-100.4l19-32zM829.2 784c-1.4 48.4-31.8 80-91.4 80h-451.8c-59.8 0-91.4-24.4-91.4-79.6 0-19 8-46 21.8-67l142.6-237.4h306.4l143.6 237.4c14 21.2 20.8 47.8 20.2 66.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-flask"
    ]
  },
  {
    "paths": [
      "M770.2 460.4c-53.4 0-120.2 13.8-172.6 27-1.8-6.4-4.2-12.4-7.4-18.2 46.4-27.6 103.4-65 141-102.8 73.4-73.4 96.6-127.2 75.2-148.6-5.2-5.2-12-7.6-20.6-7.6-27.6 0-72 26.8-128 82.8-37.6 37.6-75.2 94.4-102.8 140.8-5.6-3.2-11.8-5.6-18.2-7.6 13.4-52.4 27-119 27-172.2 0-103.8-21.6-158.2-52-158.2s-52 54.4-52 158.2c0 53.2 13.6 120 27 172.2-6.4 1.8-12.4 4.4-18.2 7.6-27.6-46.4-65-103.2-102.8-140.8-56-56-100.6-82.8-128-82.8-8.6 0-15.4 2.6-20.6 7.6-21.6 21.6 1.6 75.2 75.2 148.6 37.8 37.8 94.6 75.2 141 102.8-3 5.6-5.6 11.8-7.4 18.2-52.4-13.4-119.2-27-172.6-27-103.6 0-157.4 21.2-157.4 51.6s53.8 52.4 157.8 52.4c53.4 0 120.4-13.8 172.8-27.2 1.8 6.2 4.4 12.4 7.6 18-46.6 27.6-103.6 65.2-141.4 103-73.4 73.4-96.6 127.2-75.2 148.6 5.2 5.2 12 7.6 20.6 7.6 27.6 0 72-26.8 128-82.8 37.8-37.8 75.6-95 103.2-141.6 5.6 3 11.6 5.6 18 7.4-13.4 52.4-27.2 119.6-27.2 173 0 103.8 21.6 157.2 52 157.2s52-53.4 52-157.2c0-53.6-13.8-120.6-27.2-173 6.2-1.8 12.2-4.2 18-7.4 27.6 46.6 65.2 103.8 103.2 141.6 56 56 100.6 82.8 128 82.8 8.6 0 15.4-2.6 20.6-7.6 21.6-21.6-1.6-75.2-75.2-148.6-37.8-37.8-95-75.4-141.4-103 3.2-5.6 5.6-11.6 7.6-18 52.4 13.4 119.4 27.2 172.8 27.2 103.8 0 157.8-21.6 157.8-52s-54.2-52-158.2-52zM678.8 314c65.8-65.8 97.8-73.2 105.6-74-0.4 4.2-2.4 13.6-11.8 29.6-12.6 21.6-34 47.8-62.2 75.8-25.2 25.2-63.6 54-112.4 84.4-1.2-1.2-2.4-2.4-3.6-3.6 30.4-48.4 59.4-87 84.4-112.2zM499.4 156.6c4.8-18 9.8-26.2 12.6-29.4 2.8 3.4 7.8 11.4 12.6 29.4 6.4 24.2 9.8 57.8 9.8 97.6 0 35.6-6.8 83.2-19.8 139-0.8 0-1.6 0-2.6 0-0.8 0-1.6 0-2.6 0-13-55.8-19.8-103.4-19.8-139 0.2-39.6 3.4-73.4 9.8-97.6zM426 430c-48.6-30.4-87.2-59.2-112.4-84.4-28-28-49.4-54.2-62.2-75.8-9.4-16-11.6-25.4-11.8-29.6 7.6 0.8 39.8 8.2 105.6 74 25.2 25.2 54 63.6 84.4 112.4-1.2 1-2.4 2.2-3.6 3.4zM253.8 534.8c-39.6 0-73.4-3.4-97.4-10-18-4.8-26-10-29.2-12.8 3.2-2.6 11.2-7.8 29.4-12.4 24-6.2 57.6-9.4 97.2-9.4 35.6 0 83.4 6.8 139.4 19.8 0 0.6 0 1.4 0 2 0 1 0 2 0 2.8-56 13.2-103.8 20-139.4 20zM345.2 710.8c-65.8 65.8-97.8 73.2-105.6 74 0.4-4.2 2.4-13.6 11.8-29.6 12.6-21.6 34-47.8 62.2-75.8 25.2-25.2 64-54.2 113-84.8 1 1.2 2.2 2.2 3.4 3.4-30.6 48.8-59.6 87.6-84.8 112.8zM524.6 867.8c-4.8 18-10 26-12.6 29-2.6-3.2-7.8-11-12.6-29-6.4-24-9.6-57.6-9.6-97.2 0-35.8 6.8-83.6 20-139.8 0.8 0 1.6 0 2.4 0s1.6 0 2.4 0c13 56.2 20 104.2 20 139.8-0.4 39.8-3.6 73.2-10 97.2zM512 576c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM597.4 594.6c49 30.4 87.8 59.4 113 84.8 28 28 49.6 54.2 62.2 75.8 9.4 16 11.6 25.4 11.8 29.6-7.6-0.8-39.8-8.2-105.6-74-25.2-25.2-54.2-64-84.8-113 1.2-1 2.4-2 3.4-3.2zM867.6 525c-24 6.4-57.8 9.6-97.4 9.6-35.6 0-83.4-6.8-139.4-19.8 0-1 0-2 0-2.8 0-0.6 0-1.4 0-2 56-13 103.8-19.8 139.4-19.8 39.6 0 73.2 3.4 97.4 9.6 18 4.8 26 9.8 29.2 12.6-3.2 2.8-11.2 8-29.2 12.6z",
      "M636.8 752.8c-17-17-33.8-37.4-49.6-59 4 26.4 6.6 52.8 6.6 76.8 0 23.4-1 45-3.2 64.2 24.6 43.6 48.6 65.4 68 65.4 3.2 0 6.4-0.6 9.4-1.8 22-9 26.6-46.6 9-108.6-12.8-10.6-26.2-23-40.2-37zM656.4 869.6c-5-2.8-17.4-11.8-35.2-41.4 1.2-14.6 2-30.4 2.2-47 9.4 9 18.4 17.6 27.4 25.2 9.4 37 7.8 56.2 5.6 63.2z",
      "M387.6 272.2c16.8 16.8 33.4 37 49.2 58.4-4-26.4-6.4-52.6-6.4-76.4 0-23.4 1-45 3.2-64.2-24.6-43.6-48.6-65.4-68-65.4-3.2 0-6.4 0.6-9.4 1.8-22 9-26.6 46.6-9 108.6 12.8 10.8 26.4 23.2 40.4 37.2zM367.6 155.4c5 2.8 17.4 11.8 35.2 41.4-1.2 14.6-2 30.2-2.2 46.8-9.2-9-18.4-17.4-27.4-25.2-9.4-36.8-7.8-56-5.6-63z",
      "M271.6 637.2c17-17 37.4-33.8 59-49.6-26.4 4-52.8 6.6-76.8 6.6-23.4 0-45-1-64.2-3.2-51 28.8-72.2 56.4-63.6 77.4 5.2 12.8 20.2 19.8 44.2 19.8 17 0 38.6-3.4 64.4-10.8 10.8-12.8 23-26.2 37-40.2zM170.2 658.6c-7.6 0-12.6-1-15.2-1.8 2.8-5.2 11.8-17.4 41.4-35.2 14.6 1.2 30.4 2 47 2.2-9 9.2-17.4 18.4-25.2 27.4-19 4.8-35.4 7.4-48 7.4z",
      "M752.4 387.6c-17 17-37.4 33.8-59 49.6 26.4-4 52.8-6.6 76.8-6.6 23.4 0 45 1 64.2 3.2 51-28.8 72.2-56.4 63.6-77.4-5.2-12.8-20.2-19.8-44.2-19.8-17 0-38.6 3.4-64.4 10.8-10.8 13-23 26.4-37 40.2zM853.8 366.4c7.6 0 12.6 1 15.2 1.8-2.8 5.2-12 17.4-41.4 35.2-14.6-1.2-30.4-2-47-2.2 9-9.2 17.4-18.4 25.2-27.4 19-5 35.4-7.4 48-7.4z",
      "M387.2 752.8c-16.6 16.6-32.6 31.2-47.6 43.2-15.6 56.4-11 90.8 9.8 99.8 3.2 1.4 6.4 2 9.8 2 20.6 0 46.4-24 73.4-72.4-1.4-16.8-2.2-35-2.2-54.6 0-24 2.6-50.4 6.6-76.8-16 21.4-32.8 41.8-49.8 58.8zM361.6 867c-1.6-5.6-4-20.8 4.2-54.2 11.2-9.4 22.8-20 34.8-31.6 0.2 13 0.6 25.4 1.6 37.2-19.4 32.8-34 45.4-40.6 48.6z",
      "M636.8 272.4c16.6-16.6 32.4-31 47.4-43 15.8-56.8 11.4-91.6-9.6-100.4-3.2-1.4-6.4-2-9.8-2-20.6 0-46.4 24-73.4 72.4 1.4 16.8 2.2 35 2.2 54.6 0 24.2-2.6 50.6-6.6 77.4 16-21.4 32.8-42 49.8-59zM662.4 157.8c1.6 5.6 4 20.8-4.4 54.8-11.2 9.4-22.8 20-34.6 31.4-0.2-13.2-0.6-25.8-1.6-37.6 19.4-32.8 34-45.2 40.6-48.6z",
      "M199.2 433c16.8-1.4 35-2.2 54.6-2.2 24 0 50.2 2.6 76.6 6.6-21.4-15.8-41.8-32.6-58.8-49.6-16.6-16.6-31.2-32.6-43.4-47.8-22.6-6.2-41.8-9.2-57.2-9.2-22.8 0-37.2 6.6-42.4 19-9.2 21.8 14.2 51.8 70.6 83.2zM171.2 360.4c10.8 0 24.6 2 40.2 5.8 9.4 11.2 20 22.8 31.6 34.8-13 0.2-25.4 0.6-37.2 1.6-32.8-19.4-45.2-34-48.6-40.6 2.8-0.8 7.2-1.6 14-1.6z",
      "M824.8 592c-16.8 1.4-35 2.2-54.6 2.2-24 0-50.4-2.6-76.8-6.6 21.6 15.8 42 32.8 59 49.6 16.6 16.6 31 32.6 43.2 47.6 22.8 6.4 41.8 9.4 57.2 9.4 22.8 0 37.2-6.6 42.4-19 9.4-22-14-51.8-70.4-83.2zM852.8 664.6c-10.8 0-24.6-2-40.4-6-9.4-11.2-20-22.8-31.6-34.8 13-0.2 25.4-0.6 37.2-1.6 32.8 19.4 45.2 34 48.6 40.6-2.6 1-7 1.8-13.8 1.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-flower-outline"
    ]
  },
  {
    "paths": [
      "M770.2 460.4c-53.4 0-120.2 13.8-172.6 27-1.8-6.4-4.2-12.4-7.4-18.2 46.4-27.6 103.4-65 141-102.8 73.4-73.4 96.6-127.2 75.2-148.6-5.2-5.2-12-7.6-20.6-7.6-27.6 0-72 26.8-128 82.8-37.6 37.6-75.2 94.4-102.8 140.8-5.6-3.2-11.8-5.6-18.2-7.6 13.4-52.4 27-119 27-172.2 0-103.8-21.6-158.2-52-158.2s-52 54.4-52 158.2c0 53.2 13.6 120 27 172.2-6.4 1.8-12.4 4.4-18.2 7.6-27.6-46.4-65-103.2-102.8-140.8-56-56-100.6-82.8-128-82.8-8.6 0-15.4 2.6-20.6 7.6-21.6 21.6 1.6 75.2 75.2 148.6 37.8 37.8 94.6 75.2 141 102.8-3 5.6-5.6 11.8-7.4 18.2-52.4-13.4-119.2-27-172.6-27-103.6 0-157.4 21.2-157.4 51.6s53.8 52.4 157.8 52.4c53.4 0 120.4-13.8 172.8-27.2 1.8 6.2 4.4 12.4 7.6 18-46.6 27.6-103.6 65.2-141.4 103-73.4 73.4-96.6 127.2-75.2 148.6 5.2 5.2 12 7.6 20.6 7.6 27.6 0 72-26.8 128-82.8 37.8-37.8 75.6-95 103.2-141.6 5.6 3 11.6 5.6 18 7.4-13.4 52.4-27.2 119.6-27.2 173 0 103.8 21.6 157.2 52 157.2s52-53.4 52-157.2c0-53.6-13.8-120.6-27.2-173 6.2-1.8 12.2-4.2 18-7.4 27.6 46.6 65.2 103.8 103.2 141.6 56 56 100.6 82.8 128 82.8 8.6 0 15.4-2.6 20.6-7.6 21.6-21.6-1.6-75.2-75.2-148.6-37.8-37.8-95-75.4-141.4-103 3.2-5.6 5.6-11.6 7.6-18 52.4 13.4 119.4 27.2 172.8 27.2 103.8 0 157.8-21.6 157.8-52s-54.2-52-158.2-52zM512 544c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z",
      "M636.8 752.8c-17-17-33.8-37.4-49.6-59 4 26.4 6.6 52.8 6.6 76.8 0 23.4-1 45-3.2 64.2 24.6 43.6 48.6 65.4 68 65.4 3.2 0 6.4-0.6 9.4-1.8 22-9 26.6-46.6 9-108.6-12.8-10.6-26.2-23-40.2-37z",
      "M387.6 272.2c16.8 16.8 33.4 37 49.2 58.4-4-26.4-6.4-52.6-6.4-76.4 0-23.4 1-45 3.2-64.2-24.6-43.6-48.6-65.4-68-65.4-3.2 0-6.4 0.6-9.4 1.8-22 9-26.6 46.6-9 108.6 12.8 10.8 26.4 23.2 40.4 37.2z",
      "M271.6 637.2c17-17 37.4-33.8 59-49.6-26.4 4-52.8 6.6-76.8 6.6-23.4 0-45-1-64.2-3.2-51 28.8-72.2 56.4-63.6 77.4 5.2 12.8 20.2 19.8 44.2 19.8 17 0 38.6-3.4 64.4-10.8 10.8-12.8 23-26.2 37-40.2z",
      "M752.4 387.6c-17 17-37.4 33.8-59 49.6 26.4-4 52.8-6.6 76.8-6.6 23.4 0 45 1 64.2 3.2 51-28.8 72.2-56.4 63.6-77.4-5.2-12.8-20.2-19.8-44.2-19.8-17 0-38.6 3.4-64.4 10.8-10.8 13-23 26.4-37 40.2z",
      "M387.2 752.8c-16.6 16.6-32.6 31.2-47.6 43.2-15.6 56.4-11 90.8 9.8 99.8 3.2 1.4 6.4 2 9.8 2 20.6 0 46.4-24 73.4-72.4-1.4-16.8-2.2-35-2.2-54.6 0-24 2.6-50.4 6.6-76.8-16 21.4-32.8 41.8-49.8 58.8z",
      "M636.8 272.4c16.6-16.6 32.4-31 47.4-43 15.8-56.8 11.4-91.6-9.6-100.4-3.2-1.4-6.4-2-9.8-2-20.6 0-46.4 24-73.4 72.4 1.4 16.8 2.2 35 2.2 54.6 0 24.2-2.6 50.6-6.6 77.4 16-21.4 32.8-42 49.8-59z",
      "M199.2 433c16.8-1.4 35-2.2 54.6-2.2 24 0 50.2 2.6 76.6 6.6-21.4-15.8-41.8-32.6-58.8-49.6-16.6-16.6-31.2-32.6-43.4-47.8-22.6-6.2-41.8-9.2-57.2-9.2-22.8 0-37.2 6.6-42.4 19-9.2 21.8 14.2 51.8 70.6 83.2z",
      "M824.8 592c-16.8 1.4-35 2.2-54.6 2.2-24 0-50.4-2.6-76.8-6.6 21.6 15.8 42 32.8 59 49.6 16.6 16.6 31 32.6 43.2 47.6 22.8 6.4 41.8 9.4 57.2 9.4 22.8 0 37.2-6.6 42.4-19 9.4-22-14-51.8-70.4-83.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-flower"
    ]
  },
  {
    "paths": [
      "M912.6 320c-2.2 0-8.6 0-16.6 0v-82c0-26.6-18.8-46-45.6-46h-388.6c-5.6 0-8.6-1.2-12.2-4.8l-45.4-45.4c-9.8-9.2-17.8-13.8-34.6-13.8h-192.2c-27.6 0-49.4 20.6-49.4 46v146c-8 0-14.2 0-16.6 0-25.6 0-50.6 10.2-47 48.6s47 477.4 47 477.4c5.4 35.6 23.4 50 50 50h705c25.4 0 42-15.6 46-50 0 0 44.4-425.8 47.2-467s-17.8-59-47-59zM160 174c0-8.6 8.8-14 17.4-14h192.2c7 0 7.4 0.4 12.4 5l45 44.8c9.6 9.6 20.8 14.2 34.8 14.2h388.6c9 0 13.6 5.2 13.6 14v82c-144 0-560 0-704 0v-146zM880.4 846c-1.6 9.4-7.4 18-16 18h-700.4c-9 0-19-7-20.6-18l-48-478c0-8.8 7.2-16 16-16h801.2c8.8 0 16 7.2 16 16l-48.2 478z"
    ],
    "grid": 0,
    "tags": [
      "ios-folder-open-outline"
    ]
  },
  {
    "paths": [
      "M896 238c0-26.6-18.8-46-45.6-46h-388.6c-5.6 0-8.6-1.2-12.2-4.8l-45.4-45.4c-9.8-9.2-17.8-13.8-34.6-13.8h-192.2c-27.6 0-49.4 20.6-49.4 46v114h768v-50z",
      "M128 320c-8 0-14.2 0-16.6 0-25.6 0-50.6 10.2-47 48.6s47 477.4 47 477.4c5.4 35.6 23.4 50 50 50h705c25.4 0 42-15.6 46-50 0 0 44.4-425.8 47.2-467 2.8-41-17.8-59-47.2-59-2.2 0-8.6 0-16.6 0h-767.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-folder-open"
    ]
  },
  {
    "paths": [
      "M64 128v64l352 384v256l192 64v-320l352-384v-64h-896zM928 180l-352 384v287.6l-128-42.6v-245l-352-384v-20h832v20z"
    ],
    "grid": 0,
    "tags": [
      "ios-funnel-outline"
    ]
  },
  {
    "paths": [
      "M64 128v64l352 384v256l192 64v-320l352-384v-64h-896z"
    ],
    "grid": 0,
    "tags": [
      "ios-funnel"
    ]
  },
  {
    "paths": [
      "M832 320c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 65.2 48.8 119 112 127v1c0 46-19.8 84.8-59 115-42.6 33-97.4 48.2-135.8 55-86.4 15.6-128.2 66.6-143.2 89.4-5.2-1.2-10.6-2.2-16-2.8v-385.4c64.2-7 114-61.2 114-127.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.8-110 62.2-110 126.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-48.6-27.2-91-67.2-112.6 14.6-20.2 50.2-57.4 118-69.8 42-7.6 102-24.4 149.6-61.2 46.8-36.2 71.4-84.6 71.4-140.4v-1c63.4-8.2 112.2-62 112.2-127.2zM224 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM416 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM704 416c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-branch"
    ]
  },
  {
    "paths": [
      "M944 496h-176c-0.2 0-0.4 0-0.6 0-8.2-134-119.4-240-255.4-240s-247.2 106-255.4 240c-0.2 0-0.4 0-0.6 0h-176c-8.8 0-16 7.2-16 16s7.2 16 16 16h176c0.2 0 0.4 0 0.6 0 8.2 134 119.4 240 255.4 240s247.2-106 255.4-240c0.2 0 0.4 0 0.6 0h176c8.8 0 16-7.2 16-16s-7.2-16-16-16zM670.4 670.4c-42.4 42.4-98.6 65.6-158.4 65.6s-116-23.2-158.4-65.6c-42.2-42.4-65.6-98.6-65.6-158.4s23.4-116 65.6-158.4c42.4-42.2 98.6-65.6 158.4-65.6s116 23.4 158.4 65.6c42.2 42.4 65.6 98.6 65.6 158.4s-23.4 116-65.6 158.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-commit"
    ]
  },
  {
    "paths": [
      "M447.4 692.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l103.2 100.8h-208c-98.4 0-114-84.6-114-176v-320.8c64.2-7 114-61.2 114-127.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v321.2c0 28.6 0 81.8 18 126 22 54.4 66.6 82 128 82h208l-99.4 100.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l115.2-114.8c12.6-12.6 12.6-32.8 0-45.2l-119.2-118.8zM96 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96z",
      "M850 705.2v-321.2c0-28.6 0-81.8-18-126-22-54.4-66.6-82-128-82h-208l99.4-100.8c6.2-6.2 6.2-16.4 0-22.6-3.2-3-7.2-4.6-11.4-4.6s-8.2 1.4-11.4 4.6l-115.2 114.8c-12.6 12.6-12.6 32.8 0 45.2l119.2 118.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-103.2-100.8h208c98.4 0 114 84.6 114 176v320.8c-64.2 7-114 61.2-114 127.2 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8zM832 928c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-compare"
    ]
  },
  {
    "paths": [
      "M768 448c-65.4 0-119.4 49.2-127 112.4-18.2 0-59.2-2.6-111-22.6-65.2-25.4-159.8-84.4-243-221.6 55.6-13.8 97-64.2 97-124.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.6-110 62-110 126.6 0 70.6 57.4 128 128 128s128-57.4 128-128c0-66-49.8-120.2-114-127.2v-355.2c85.4 133 181.2 191.8 248.4 218 55.6 21.6 100.2 24.8 122 24.8 0.2 0 0.4 0 0.8 0 8 62.8 61.8 111.6 127 111.6 70.6 0 128-57.4 128-128s-57.6-128-128.2-128zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM352 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM768 672c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-merge"
    ]
  },
  {
    "paths": [
      "M896 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8h2v119.2l-240 118.2-240-118.2v-119c63.2-7.8 112-61.6 112-127 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8h2v139.2l256 126v120.6c-63.2 7.8-112 61.6-112 127 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8h-2v-120.8l256-126v-139c63.2-8 112-61.8 112-127zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM608 831.6c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM768 288c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-network"
    ]
  },
  {
    "paths": [
      "M384 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.6-110 62-110 126.6 0 70.6 57.4 128 128 128s128-57.4 128-128c0-66-49.8-120.2-114-127.2v-385.6c64.2-7 114-61.2 114-127.2zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM352 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96z",
      "M786 705.2v-321.2c0-28.6 0-81.8-18-126-22-54.4-66.6-82-128-82h-208l99.4-100.8c6.2-6.2 6.2-16.4 0-22.6-3.2-3-7.2-4.6-11.4-4.6s-8.2 1.4-11.4 4.6l-115.2 114.8c-12.6 12.6-12.6 32.8 0 45.2l119.2 118.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-103.2-100.8h208c98.4 0 114 84.6 114 176v320.8c-64.2 7-114 61.2-114 127.2 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8zM768 928c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-git-pull-request"
    ]
  },
  {
    "paths": [
      "M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM528.6 345c44.2-1.2 87-7 128.4-17 12.4 49 20.2 105.6 21.4 167.6h-149.8v-150.6zM528.6 311.6v-179.6c44.8 12.4 90.4 72.2 119.2 164-38.4 9.2-78.2 14.4-119.2 15.6zM495.4 131.6v180.2c-41.4-1.2-81.6-6.6-120.2-16 29.2-92.4 75-152.6 120.2-164.2zM495.4 345v150.4h-150.8c1.2-62 9-118.6 21.4-167.6 41.6 10 85 16 129.4 17.2zM311 495.4h-181.2c3.6-85.6 35.6-164 86.6-226 37 20.4 76.4 37.2 117.6 49.6-13.6 53-21.6 112.8-23 176.4zM311 528.6c1.2 63.4 9.2 123.4 22.8 176.4-41.2 12.6-80.4 29.2-117.6 49.6-51-62-82.8-140.4-86.6-226h181.4zM344.6 528.6h150.8v150.2c-44.4 1.2-87.8 7.2-129.4 17.4-12.4-49-20.2-105.6-21.4-167.6zM495.4 712.2v180.4c-45.2-11.8-91-71.8-120.2-164.2 38.6-9.6 78.8-15 120.2-16.2zM528.6 892v-180c41 1.2 80.8 6.6 119.4 15.8-29 92-74.4 151.8-119.4 164.2zM528.6 678.8v-150.2h149.8c-1.2 61.8-9 118.4-21.4 167.4-41.4-10-84.2-16-128.4-17.2zM711.8 528.6h182.4c-3.6 85.6-35.6 163.8-86.6 226-37.4-20.6-77-37.4-118.6-50 13.6-53 21.6-112.6 22.8-176zM711.8 495.4c-1.2-63.4-9.2-123.2-22.6-176.2 41.6-12.6 81.2-29.4 118.4-49.8 51 62 83 140.4 86.6 226.2h-182.4zM784.8 243.8c-33.2 17.6-68 32.2-104.6 43.2-19.4-62.6-46.8-113.6-79-147.2 70.8 17 134 53.8 183.6 104zM421.6 140.2c-32.2 33.4-59.4 84.4-78.6 146.6-36.2-11-70.8-25.4-103.6-43 49-50 111.8-86.6 182.2-103.6zM239.2 780c32.8-17.6 67.6-32 103.6-43 19.4 62.4 46.6 113.2 78.8 146.8-70.4-17-133.2-53.6-182.4-103.8zM601.2 884.2c32.4-33.6 59.6-84.6 79.2-147.4 36.6 11 71.4 25.6 104.6 43.2-49.6 50.4-113 87.2-183.8 104.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-globe-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 894.8c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-210.8-0.6-381.8-171.8-381.8-382.8s170.8-382.2 381.8-382.6c0.2 0 0.2 0 0.4 0 0 0 0.2 0 0.2 0 0.2 0 0.2 0 0.4 0 211.4 0 382.8 171.4 382.8 382.8 0 211.2-171.4 382.6-382.8 382.6z",
      "M644.6 343.6c-37.4 9-76 14.4-115.8 15.6v136.2h135.2c-1.2-56.2-8.2-107.2-19.4-151.8z",
      "M528.6 165v163.8c37-1.2 73-6 107.6-14.4-26.2-82.8-67-137.2-107.6-149.4z",
      "M386.8 314.2c35 8.4 71.2 13.4 108.4 14.6v-164.2c-40.6 11.8-82 66.2-108.4 149.6z",
      "M761.2 266.8c-45.2-46-103-79.6-167.8-95 29.6 30.6 54.4 77.4 72.2 134.6 33.4-10.2 65.4-23.4 95.6-39.6z",
      "M694.6 495.4h166.6c-3.6-77.6-32.6-148.8-79-205.2-34.2 18.8-70.4 34.2-108.2 45.6 12.2 48 19.4 102.2 20.6 159.6z",
      "M359 495.4h136.4v-136.2c-40.2-1.2-79.2-6.6-116.8-15.8-11.4 44.6-18.4 95.8-19.6 152z",
      "M664 528.6h-135.4v136c39.8 1.2 78.6 6.4 116 15.6 11.2-44.4 18.2-95.6 19.4-151.6z",
      "M378.6 680.4c37.6-9.2 76.6-14.6 116.8-15.8v-136h-136.4c1.2 56.2 8.2 107.4 19.6 151.8z",
      "M495.4 859.2v-164.2c-37.2 1.2-73.6 6.2-108.6 14.6 26.4 83.4 67.8 138 108.6 149.6z",
      "M593.4 852.2c64.8-15.6 122.6-49 168-95.2-30.2-16.2-62.2-29.4-95.6-39.6-17.8 57.4-42.8 104-72.4 134.8z",
      "M429.4 172.2c-64.2 15.6-121.6 49-166.6 94.8 30 16 61.6 29.2 94.6 39.2 17.8-57 42.6-103.4 72-134z",
      "M674 688.2c38 11.4 74.2 26.8 108.4 45.6 46.4-56.4 75.4-127.6 79-205.2h-166.6c-1.4 57.4-8.6 111.4-20.8 159.6z",
      "M528.6 695v164c40.6-12.2 81.4-66.6 107.6-149.6-34.6-8.4-70.6-13.2-107.6-14.4z",
      "M349.2 335.6c-37.6-11.4-73.6-26.6-107.4-45.4-46.4 56.4-75.4 127.6-79 205.2h165.8c1-57.6 8.4-111.8 20.6-159.8z",
      "M328.4 528.6h-165.8c3.6 77.6 32.6 148.8 79 205.2 33.8-18.6 69.8-34 107.4-45.4-12-48-19.4-102.2-20.6-159.8z",
      "M262.6 757c45 45.8 102.4 79.2 166.8 94.8-29.4-30.6-54.2-77.2-72-134.2-33 10.2-64.8 23.4-94.8 39.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-globe"
    ]
  },
  {
    "paths": [
      "M896 384v-32h-224v-224h-32v224h-256v-224h-32v224h-224v32h224v256h-224v32h224v224h32v-224h256v224h32v-224h224v-32h-224v-256h224zM640 640h-256v-256h256v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-grid-outline"
    ]
  },
  {
    "paths": [
      "M384 384h256v256h-256v-256z",
      "M128 128v768h768v-768h-768zM832 384h-160v256h160v32h-160v160h-32v-160h-256v160h-32v-160h-160v-32h160v-256h-160v-32h160v-160h32v160h256v-160h32v160h160v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-grid"
    ]
  },
  {
    "paths": [
      "M924.8 433.8l-68.4-67.8c-2.2-2.2-5-3.2-7.8-3.2s-5.8 1-7.8 3.2l-7.4 7.4c-10.6 0-27.2-1.4-36.2-10.4-13.8-13.6 2.2-40.6-10.2-58-12.2-17.4-31.8-39.4-45.8-53.4s-69.2-66.8-162.4-105c-32.8-13.4-65-18.6-93.6-18.6-52.6 0-93.8 17-108.4 30.4-10.8 10-22.2 28-6.2 28 1.4 0 3-0.2 4.8-0.4 8.8-1.4 26.4-3 46.4-3 31.2 0 68.4 4.2 88.2 20 32.4 26 59 60.6 61.2 105.4 2.2 43-12.4 68-68.6 123.6l-11.4-6c-2.6-1.4-5.6-2-8.4-2-5 0-9.8 1.8-12.6 4.6 0 0-8.8 8.2-92.8 91.6-124.6 123.2-278.2 247.4-278.2 247.4-4.4 4.4-4.4 11.4 0 15.6l110.4 109.6c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2c0 0 125.2-152.4 249.4-275.6 84-83.4 92.2-92 92.2-92 4.4-4.4 7.2-13.2 2.6-20.8l-7.8-13c50.2-49.8 70.4-71 95-77.8 8-2.2 16.6-3 25.4-3 19.2 0 38 4.4 46.6 9 10.2 5.4 19.4 22.6 20.4 37.2l-19 19c-4.4 4.4-4.4 11.4 0 15.6l68.4 67.8c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.6-4.4 4.6-11.6 0.4-15.8zM452.4 594.4c-98.8 98-198.8 215-236.4 259.6l-77.8-77.2c45.2-37.4 163-136.4 261.4-234.2 46.8-46.4 70.2-69.4 81.6-80.6l51.8 51.8c-11.4 11.8-34.6 35-80.6 80.6zM806.4 521.8l-38.6-38.4 4-4 6.4-10.4 3-14.6c-1.6-22.4-15-51.2-37.2-63-14.6-7.8-38.8-12.8-61.8-12.8-12.2 0-23.6 1.4-34 4.2-31.2 8.6-53 30.4-100.8 77.8l-8 8-3.4 3.2-14.2-14.2 2.8-2.8c57.4-56.8 80.8-90 78-147.8-2.2-48.2-26.8-91.6-73-129v0 0c-9.2-7.4-20.8-13.2-34.6-17.6 24.4 1.2 48.4 6.4 71.4 15.8 78.6 32.2 129 75.2 152 98 12.4 12.2 30.2 32.4 41.4 47.8 0.2 2.4-0.2 7-0.4 10.4-1 13.4-2.4 36.4 15 53.6 13.2 13 33 20 58.8 20l15.2-2.4 38.6 38.2-80.6 80z"
    ],
    "grid": 0,
    "tags": [
      "ios-hammer-outline"
    ]
  },
  {
    "paths": [
      "M491 426c-2.6-1.4-5.6-2-8.4-2-5 0-9.8 1.8-12.6 4.6 0 0-8.8 8.2-92.8 91.6-124.4 123.2-278 247.4-278 247.4-4.4 4.4-4.4 11.4 0 15.6l110.4 109.6c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2c0 0 125.2-152.4 249.4-275.6 84-83.4 92.2-92 92.2-92 4.4-4.4 7.2-13.2 2.6-20.8l-7.8-12.8-59.4-59.6-11.2-6z",
      "M924.8 433.8l-68.4-67.8c-2.2-2.2-5-3.2-7.8-3.2s-5.8 1-7.8 3.2l-7.4 7.4c-10.6 0-27.2-1.4-36.2-10.4-13.8-13.6 2.2-40.6-10.2-58-12.2-17.4-31.8-39.4-45.8-53.4s-69.2-66.8-162.4-105c-32.8-13.4-65-18.6-93.6-18.6-52.6 0-93.8 17-108.4 30.4-10.8 10-22.2 28-6.2 28 1.4 0 3-0.2 4.8-0.4 8.8-1.4 26.4-3 46.4-3 31.2 0 68.4 4.2 88.2 20 32.4 26 59 60.6 61.2 105.4 1.8 36.8-8.6 60.4-46.8 101.4l59.8 59.8c35-34.4 52.6-50.4 73-56 8-2.2 16.6-3 25.4-3 19.2 0 38 4.4 46.6 9 10.2 5.4 19.4 22.6 20.4 37.2l-19 19c-4.4 4.4-4.4 11.4 0 15.6l68.4 67.8c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4-4.4 4-11.6-0.2-15.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-hammer"
    ]
  },
  {
    "paths": [
      "M546 127.8c21 0 38 17 38 37.8v265.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-233.2c0-20.8 17-37.8 38-37.8s38 17 38 37.8v297c0 8.8 7.2 16 16 16s16-7.2 16-16v-201.2c0-20.8 17-37.8 38-37.8s38 17 38 37.8v428.6c0 101.6-57.2 174-140.4 174 0 0-60 0-103 0s-73.2-22.2-73.2-22.2c-77.8-46.8-169.6-177.2-204-216.8-35.8-41-70.2-76.4-48.4-98 11.2-10.6 23.4-15.6 36.2-15.6 24.4 0 52.4 17 83 44.4l49.8 43.4v-401.6c0-20.8 17-37.8 38-37.8s38 17 38 37.8v233.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-297c-0-20.8 17-38 38-38zM545.8 96c-38.6 0-69.8 31.2-69.8 69.8v5.2c-10-7-24-11.2-38-11.2-38.6 0-70 31.4-70 69.8v331c-38-33.8-70.4-49-100.6-49-21.8 0-41.6 8.2-58.6 24.2l-0.8 0.4c-11.4 11.4-27.4 36.4-5 76.2 10.2 17.8 26.4 36.4 43.6 56 2.6 3 5.4 6.2 8.2 9.2 7 8 17.2 21 29.2 36 46.2 58.4 116.2 147.2 181.8 187 7.6 5.2 42.2 27.4 90.6 27.4h103c50 0 94.8-22 126.2-60.8 30.4-37 46.4-87.8 46.4-145.2v-428.6c0-38.4-31.4-69.8-70-69.8-14 0-26 4.2-38 11.2v-37.2c0-38.4-31.6-69.8-70.2-69.8-15.8 0-30.4 5.2-42.2 14.2-9.8-26.8-35.6-46-65.8-46v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-hand-outline"
    ]
  },
  {
    "paths": [
      "M790 234c-23.2 0-42 18.4-42 41v218c0 9.6-9.2 17.2-19 17.2s-19-7.8-19-17.2v-321.4c0-22.6-18.8-41-42-41s-42 18.4-42 41v252.4c0 9.6-7.2 17.2-17 17.2s-17-7.8-17-17.2v-287c0-22.6-18.8-41-42-41s-42 18.4-42 41v321.6c0 9.6-8.2 17.2-18 17.2s-18-7.8-18-17.2v-252.6c0-22.6-20.8-41-44-41s-44 18.4-44 41v434.8l-51.8-47.2c-52.2-45.2-96.6-64.6-132.6-31.2-24.2 23.4 13.8 61.6 53.4 106 38.4 42.8 140 184.6 226.4 235.2 0 0 33.4 24.4 81.2 24.4s114.4 0 114.4 0c92.2 0 156.8-79 156.8-189v-464c0.2-22.4-18.6-41-41.8-41z"
    ],
    "grid": 0,
    "tags": [
      "ios-hand"
    ]
  },
  {
    "paths": [
      "M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416v0z",
      "M704 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M416 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M512 738c96.6 0 177-70 193-162h-386c16 92 96.4 162 193 162z"
    ],
    "grid": 0,
    "tags": [
      "ios-happy-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM656 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM368 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM512 738c-96.6 0-177-70-193-162h386.2c-16.2 92-96.6 162-193.2 162z"
    ],
    "grid": 0,
    "tags": [
      "ios-happy"
    ]
  },
  {
    "paths": [
      "M688 423.6c-8.8 0-16-7.2-16-16 0-80-77.4-144-160-144s-160 64-160 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-50 23.6-88.6 59.2-123.2 35.2-34.2 82.4-52.8 132.8-52.8s97.6 18.8 132.8 52.8c35.6 34.4 59.2 73 59.2 123.2 0 8.8-7.2 16-16 16z",
      "M816 520h-48v-95.6c0-140.8-115.2-256-256-256v0 0c-140.8 0-256 115.2-256 256v95.6h-48c-79.2 0-144 64.8-144 144v31.6c0 79.2 64.8 144.4 144 144.4h48c0 8 7.2 15.8 16 15.8s16-7.4 16-16.2v-415.2c0-59.6 23.4-115.8 65.8-158.2s98.6-65.8 158.2-65.8c60 0 115.8 23.4 158.2 65.8s65.8 98.6 65.8 158.2v415.2c0 8.8 7.2 16.2 16 16.2s16-7.8 16-15.8h48c79.2 0 144-65.2 144-144.4v-31.6c0-79.2-64.8-144-144-144zM256 808h-48c-29.8 0-57.8-11.8-79-33.2s-33-49.4-33-79.2v-31.6c0-29.8 11.6-57.8 33-79s49.2-33 79-33h48v256zM928 695.6c0 29.8-11.6 58-33 79.2s-49.2 33.2-79 33.2h-48v-256h48c29.8 0 57.8 11.6 79 33s33 49.2 33 79v31.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-headset-outline"
    ]
  },
  {
    "paths": [
      "M816 520h-48v-95.6c0-140.8-115.2-256-256-256v0 0c-140.8 0-256 115.2-256 256v95.6h-48c-79.2 0-144 64.8-144 144v31.6c0 79.2 64.8 144.4 144 144.4h48c0 8 7.2 15.8 16 15.8s16-7.4 16-16.2v-413.6c16.4 0 42 0 48 0 8.8 0 16-8 16-16.8 0-80 77.4-144.8 160-144.8s160 64.6 160 144.6c0 8.8 7.2 17.2 16 17.2 5.8 0 31 0 48 0v413.6c0 8.8 7.2 16.2 16 16.2s16-7.8 16-15.8h48c79.2 0 144-65.2 144-144.4v-31.8c0-79.2-64.8-144-144-144z"
    ],
    "grid": 0,
    "tags": [
      "ios-headset"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM783.6 240.4c35.2 35.2 63 76.4 82.4 122 5.4 12.6 10 25.6 14 38.8l-202.2 13.6c-16.4-28-39.8-51.4-67.8-68l13-202.6c13 4 26 8.6 38.6 14 45.6 19.4 86.6 47 122 82.2zM896 512c0 27-2.8 53.4-8.2 79.2l-195.2-14c7.4-20.4 11.4-42.4 11.4-65.4 0-22.8-4-44.8-11.4-65.2l195.2-14c5.4 26 8.2 52.4 8.2 79.4zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160c0 88.2-71.8 160-160 160zM128 512c0-27 2.8-53.4 8.2-79.2l195.2 14c-7.4 20.4-11.4 42.2-11.4 65.2 0 22.8 4 44.8 11.4 65.2l-195.2 14.2c-5.4-26-8.2-52.4-8.2-79.4zM591.2 136.2l-13.6 195.4c-20.4-7.4-42.6-11.6-65.6-11.6s-45 4-65.6 11.4l-13.8-195.2c25.8-5.4 52.4-8.2 79.2-8.2 27.2 0 53.6 2.8 79.4 8.2zM240.4 240.4c35.2-35.2 76.4-63 122-82.4 12.6-5.4 25.6-10 38.6-14l13 202.6c-27.8 16.6-51.2 40-67.8 67.8l-202.2-13.4c4-13 8.6-26 14-38.6 19.6-45.6 47.2-86.6 82.4-122zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-5.4-12.6-10-25.6-14-38.6l202.6-13c16.4 27.8 39.8 51 67.6 67.6l-13.2 202.4c-13-4-26-8.6-38.6-14-45.6-19.6-86.6-47.2-122-82.4zM432.8 887.8l14-195.2c20.4 7.4 42.4 11.4 65.2 11.4 23 0 45.2-4 65.8-11.6l13.6 195.4c-25.8 5.4-52.4 8.2-79.2 8.2-27.2 0-53.6-2.8-79.4-8.2zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-12.6 5.4-25.6 10-38.6 14l-13.4-202.2c28.2-16.6 51.6-40.2 68.2-68.4l202.2 13.6c-4 13-8.6 26-14 38.8-19.6 45.4-47.2 86.4-82.4 121.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-help-buoy-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM783.6 240.4c35.2 35.2 63 76.4 82.4 122 5.4 12.6 10 25.6 14 38.8l-202.2 13.6c-16.4-28-39.8-51.4-67.8-68l13-202.6c13 4 26 8.6 38.6 14 45.6 19.4 86.6 47 122 82.2zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160c0 88.2-71.8 160-160 160zM240.4 240.4c35.2-35.2 76.4-63 122-82.4 12.6-5.4 25.6-10 38.6-14l13 202.6c-27.8 16.6-51.2 40-67.8 67.8l-202.2-13.4c4-13 8.6-26 14-38.6 19.6-45.6 47.2-86.6 82.4-122zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-5.4-12.6-10-25.6-14-38.6l202.6-13c16.4 27.8 39.8 51 67.6 67.6l-13.2 202.4c-13-4-26-8.6-38.6-14-45.6-19.6-86.6-47.2-122-82.4zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-12.6 5.4-25.6 10-38.6 14l-13.4-202.2c28.2-16.6 51.6-40.2 68.2-68.4l202.2 13.6c-4 13-8.6 26-14 38.8-19.6 45.4-47.2 86.4-82.4 121.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-help-buoy"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M519.2 292c-86.4 0-134.6 40.6-135.2 124.4h37.6c-1.2-60.8 31-93 95.8-93 46.4 0 85.2 32.4 85.2 79.6 0 30.6-16.6 55.4-38.8 76.2-45.2 41.6-58 72-60.2 129h38c2.2-51.6 1-61.4 46.6-106.6 30.4-28.4 51.8-56.6 51.8-100.4-0-68.4-54.8-109.2-120.8-109.2z",
      "M520.6 664.6c-18.8 0-34 15-34 33.6s15.2 33.8 34 33.8c18.8 0 34-15 34-33.8 0-18.6-15.2-33.6-34-33.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-help-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-help-circle"
    ]
  },
  {
    "paths": [
      "M520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-help"
    ]
  },
  {
    "paths": [
      "M760.8 327.2c-12.8-6.2-24.8-9.2-24.8-9.2 0-123.8-100.2-226-224-226s-224 102.4-224 226.2c0 0-11.4 1.8-24.8 8.8-24.4 12.8-39.4 39.6-39.4 69 0 44.2 35.8 80 80 80 25 0 63.4-11.6 78.2-29.6 30.6 30.2 75.6 45.6 129.8 45.6s99.4-15.4 129.8-45.6c14.6 18 53 29.6 78.2 29.6 44.2 0 80-35.8 80-80 0.2-29.2-17.4-58.2-39-68.8zM720 444c-9 0-21.4-2.4-32.4-6.2-12.8-4.6-21-11.6-21-11.6-10.4-6.8-22.2-27.4-22.2-27.4l-25 24.8c-24 23.8-61 36.4-107.4 36.4-46.2 0-83.4-12.6-107.4-36.4l-25-24.8c0 0-9.2 17.8-22.2 27.4-4 3-8.2 7-21 11.6-10.8 3.8-23.2 6.2-32.4 6.2-26.6 0-48-21.6-48-48 0-16.4 8-31.2 21.4-40 0 0 8.2-5 16.2-7.8 9.2-3 16.8-4 16.8-4 20.2 15.6 42.8 21 42.8 21-17.4-12-32.8-43.4-32.8-43.4v-3.8c0-51.6 20-100.2 56.4-137 36-36.6 84.2-57 135.2-57s99.2 20.2 135.6 57c36.4 36.8 56.4 85.6 56.4 137v4.2c0 0-14 31.2-31.2 43.2 0 0 22.4-5.4 42.6-20.8 0 0 7-0.4 15 2.6s16.2 9 16.2 9c13.4 9 21.4 23.6 21.4 40 0 26.2-21.6 47.8-48 47.8z",
      "M382.2 480.4c-0.2 0.2-0.4 0.4-0.6 0.6l0.6-0.6c0.2 0.2 0 0 0 0z",
      "M642 480.4c-30.6 30.2-75.8 45.6-130 45.6-54 0-99.2-15.2-129.6-45.4l-0.8 0.4c-8 9.4-22.4 17-37.8 22l109.8 375c1.8 5.2 19 54 58.6 54 18.2 0 35-11.8 47.4-29.4 7.4-10.6 11.2-22.8 11.8-24.8l110.6-374c-16.4-5.4-32-13.4-40-23.4zM512.2 567.4l71.6 49.2-71.6 49.2-71.6-49.2 71.6-49.2zM395.6 585.6l-21.4-69.6 10-6c19 20.8 72.2 36.2 103.6 40.4l1 0.6-85.8 59-7.4-24.4zM410.6 637.2l6.4-4.4 71.6 49.2-54.2 37.2-23.8-82zM466.2 828.6l-11.2-38.6 33.6 23.2-22.4 15.4zM512.2 906c-22.6 0-34.2-36.8-34.2-36.8l-2-7.6 36.2-26.2 36.4 26.4-1.8 7.2c-0 0.2-11.4 37-34.6 37zM558.6 828.8l-22.8-15.6 34.2-23.6-11.4 39.2zM581.8 749l-69.6 48-69-47.4-0.8-3 70-48 70.4 48.4-1 2zM590.4 719.6l-54.6-37.6 71.6-49.2 7 4.8-24 82zM629.6 585l-7.4 25.4-14.8-10.2-71.6-49.2 1-0.6c31.2-4.2 74-16.4 103.4-37.6l8 5.2-18.6 67z"
    ],
    "grid": 0,
    "tags": [
      "ios-ice-cream-outline"
    ]
  },
  {
    "paths": [
      "M438.4 801.8l14.4 44.8 28.8-18z",
      "M571.8 846.8l14.6-45.6-44 27.4z",
      "M481.6 523.8l-1.2-0.8c-40.2-5-73.8-19.6-98.2-43.8-8.2 10-23.6 18-40 23.2l19.8 61.6 9.2 28.4 18.4-11.4 92-57.2z",
      "M389.4 619l-8.2 5 30.8 95.6 69.6-43.4z",
      "M512 695.2l-92.2 57.2 3.4 2.2 88.8 55.2 92.2-57.4-1.6-1z",
      "M604.2 600l-92.2-57.2-92.2 57.2 92.2 57.4z",
      "M641.8 479.4c-24.4 24.2-58 38.8-98.2 43.8l-1.2 0.8 111.2 69.2 9.6-29.6 19.6-60.6c-16.8-5.4-32.6-13.4-41-23.6z",
      "M462.8 878l5.2 16c0 0 15 38 44 38 30 0 44.4-38 44.4-38l5-15.6-49.4-31-49.2 30.6z",
      "M542.4 676.2l70.2 43.8 31-95.6-9-5.4z",
      "M760.8 327.8c-22 25.4-56.2 33.6-56.2 33.6 17.4-12 31.2-43.2 31.2-43.2 0-0.6 0-1 0-1.6 0.2-124-100-224.6-223.8-224.6s-224 101.4-224 225.4c0 0.6 0 2.6 0 2.6h0.6c0 0 14 30.2 31.2 42.2 0 0-34.4-8.6-56.4-34.2-23.6 14-39.6 39.4-39.6 69 0 44.2 35.8 80 80 80 25 0 63.4-11.6 78.2-29.8 30.6 30.4 75.6 45.6 129.8 45.6s99.4-15.4 129.8-45.8c14.6 18.2 53 29.6 78.2 29.6 44.2 0 80-36 80-80.2 0.2-29-15.6-54.6-39-68.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-ice-cream"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM864 864h-706v-704h706v704z",
      "M640 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M192 192v512h640v-512h-640zM589.2 672h-282.4l141.2-200.4 141.2 200.4zM576.8 598.8l44.6-63.2 96 136.4h-89.2l-51.4-73.2zM800 672h-43.4l-135.2-192-64.2 91-109.2-155-180.2 256h-43.8v-448h576v448z"
    ],
    "grid": 0,
    "tags": [
      "ios-image-outline"
    ]
  },
  {
    "paths": [
      "M895.6 128.4l-767.6-0.4v768h768v-768l-0.4 0.4zM864 864h-704v-704h704v704z",
      "M832 192h-640v512h640v-512zM608.4 319.6c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32c0-17.8 14.4-32 32-32zM307 672l141.4-201 141.6 201h-283zM629.2 672.2v0l-51.8-73.8 44.6-63.2 96.4 137h-89.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-image"
    ]
  },
  {
    "paths": [
      "M780.8 243.8l-12.8-179.8-704 48 46.6 639.8 44.4-3.2-11 157.8 768 53.6 48-704-179.2-12.2zM138.4 717.8l-40.2-574.6 640.4-44.8 10 143.2-32.2-2.2-7.4-107-574.8 40.4 30.6 436.4-7.6 107.2-18.8 1.4zM193.2 204l-12.4 175.8-12.4-177.4 510.8-35.8 5 70.6-491-33.2zM881.2 925.8l-705-49.2 44.6-638.6 705 49.2-44.6 638.6z",
      "M720.597 465.539c-17.631-1.234-30.923-16.527-29.689-34.158s16.527-30.923 34.158-29.689c17.631 1.234 30.923 16.527 29.689 34.158s-16.527 30.923-34.158 29.689z",
      "M252.6 272.4l-31.2 447 639 44.6 31.2-447-639-44.6zM338.2 695.4l155-190.2 126.8 209.8-281.8-19.6zM659.2 717.8l-46.4-76.6 49-60 86.4 142.8-89-6.2zM830.6 729.8l-43.4-3-121.6-201-70.4 86.4-98.2-162.4-197.8 242.8-43.6-3 26.8-383.2 575.2 40.2-27 383.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-images-outline"
    ]
  },
  {
    "paths": [
      "M780.8 243.8l-12.8-179.8-704 48 46.6 639.8 44.4-3.2-11 157.8 768 53.6 48-704-179.2-12.2zM138.4 717.8l-40.2-574.6 640.4-44.8 10 143.2-32.2-2.2-7.4-107-574.8 40.4 30.6 436.4-7.6 107.2-18.8 1.4zM881.2 925.8l-705-49.2 44.6-638.6 705 49.2-44.6 638.6z",
      "M252.6 272.4l-31.2 447 639 44.6 31.2-447-639-44.6zM338.2 695.4l155-190.2 126.8 209.8-281.8-19.6zM659.2 717.8l-46.4-76.6 49-60 86.4 142.8-89-6.2zM754.8 435.8c-1.2 17.6-16.6 31-34.2 29.6s-31-16.6-29.8-34.2c1.2-17.6 16.6-31 34.2-29.6 17.8 1.2 31.2 16.6 29.8 34.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-images"
    ]
  },
  {
    "paths": [
      "M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z",
      "M544 688v-256h-96v16h32v240h-32v16h128v-16z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-information-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM503 304c22.2 0 40 18 40 40s-18 40-40 40c-22 0-40-18-40-40s17.8-40 40-40zM576 704h-128v-16h32v-240h-32v-16h96v256h32v16z"
    ],
    "grid": 0,
    "tags": [
      "ios-information-circle"
    ]
  },
  {
    "paths": [
      "M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z",
      "M544 688v-256h-96v16h32v240h-32v16h128v-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-information"
    ]
  },
  {
    "paths": [
      "M851 269.6c9.4-11.8 15-27 15-43.2 0-38.4-31.2-69.8-69.6-69.8-16.4 0-31.4 5.6-43.2 15-68-48.4-150-75.6-239.8-75.6-229.8-0-417.4 185-417.4 415.2s187.4 416.8 417.2 416.8 414.8-186.6 414.8-416.8c0-90-28.6-173.4-77-241.6zM783.6 783.4c-35.2 35.2-76.4 63.2-122.2 82.6-47.4 20-96.4 30.4-148.4 30.4-51.8 0-103.4-10.2-150.8-30.4-45.8-19.4-86.8-47-122.2-82.6-35.2-35.2-63-76.6-82.4-122.4-20-47.4-30.2-97.8-30.2-149.8 0-51.8 10.2-102.4 30.2-149.8 19.4-45.8 47-87 82.4-122.4s76.4-63.2 122.2-82.6c47.4-20 98.8-28.2 150.8-28.2 51.8 0 101 8 148.4 28.2 25.4 10.8 49.4 24.2 71.8 40-4.2 9-6.6 19-6.6 29.8 0 38.4 31.2 69.8 69.6 69.8 10.6 0 20.6-2.4 29.8-6.6 15.8 22.4 29.2 46.4 40 72 20 47.4 30.2 97.8 30.2 149.8 0 51.8-10.2 102.4-30.2 149.8-19.4 45.8-47 87-82.4 122.4z",
      "M513 320.2c-106 0-192 85.6-192 191.8s85.8 192.2 192 192.2c106 0 192-86 192-192.2s-86-191.8-192-191.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-ionic"
    ]
  },
  {
    "paths": [
      "M935.4 538.4c-8.6-61.8-28.8-114.6-67.6-114.6l-15.2 0.2c-61.2-124-188.4-207-333.2-207-7 0-14 0.2-21 0.6-171.6 9.6-309.4 133.4-343.4 293.6l-22.8 3.2c-34.4 4.8-53.8 69.6-43.2 145 10 72.4 44.2 128 77.2 128 1.4 0 2.8 0 4-0.2l31.4-4.4c65.8 107 184.2 177.4 317 177.4 7 0 14-0.2 21-0.6 170.4-9.4 307.6-131.8 342.8-290.4l14.8-0.8c30.4-5 47.6-62.8 38.2-130zM212.4 748.8l-46.2 6.4c-2.2-0.6-11.2-6-21.6-24.4-11.4-20-19.8-47-23.8-76s-3.2-57.2 2.2-79.6c5-20.4 12.2-28 14.2-29.4l43.2-6c14.4 25.8 27.2 60 33 98.6 6 41.8 8 81.4-1 110.4zM902.2 610.6c-3.6 16-8.6 23.6-11 26l-35 2-5.2 23.6c-8 35.8-21.6 69.8-40.6 101.4-18.8 31-42.2 58.8-69.8 82.4-57.2 49.2-127.4 77.4-202.8 81.6-6.4 0.4-12.8 0.6-19.2 0.6-58.8 0-116.8-15.4-167.8-44.4-49.8-28.4-92-69-121.8-117.8l-10.2-16.6c16-23.8 25.6-63.2 19.2-115-5.6-45.2-30.8-81-54.8-101.6l3.2-14.8c15.2-71.6 54.2-137.4 109.8-185.8 57.4-49.8 128.2-78.2 204.2-82.4 6.4-0.4 13.6-0.6 19.6-0.6 64.4 0 126.4 18 180.6 52 53.2 33.4 95.8 80.8 123.4 137l7.2 15c16.2 38 25 74.2 27.8 115 3-50.6-4.2-85.4-14.2-112l23-0.2c6.8 0 13.8 11.8 16.6 17 8.4 16 15 40.2 19.2 70.2 3.4 24.2 3 48.2-1.4 67.4z",
      "M543.961 698.821c16.985-0.944 31.519 12.059 32.464 29.044s-12.059 31.519-29.044 32.464c-16.985 0.944-31.519-12.059-32.464-29.044s12.059-31.519 29.044-32.464z",
      "M705.6 689.6c-17 1-30 15.4-29 32.4s15.4 30 32.4 29c17-1 30-15.4 29-32.4-0.8-17-15.4-30-32.4-29z",
      "M336 147.2c4.2 2.8 10 4.8 17.2 6 5 0.8 10.6 1.2 16.6 1.2 2.4 0 4.8 0 7.2-0.2 2 0 3.8-0.2 5.8-0.4-0.8-0.8-1.6-1.8-2.4-2.6-0.8 0-1.8 0-2.6 0s-1.6 0-2.4 0c-7.6 0-14.8-0.6-20.8-1.8-7-1.4-13.4-4.2-16.8-6.8-3.2-2.8-2.6-7.4-2.6-7.4 0.6-5.2 4.8-9.6 10.8-14.8 5.4-4.6 12.8-9.4 21.6-14l6.2-3c-1.6 6.6-1.8 13.8-0.4 21 4.2 21.8 21.8 37.8 42.8 40.8l9.4 46.2 31.6-6.4-9.2-45.6c18.8-10.2 29.6-31.6 25.6-53.8-1.4-7-4-13.4-7.8-19-3.6-0.6-8.6-1-14.4-1-11.2 0-26.2 1.2-44 5.2 2.2-0.6 4.2-1.4 6.4-2 15.2-4.2 29-7 43-8.4 17.2-2 30-0.6 33.2-0.2s6 1 8.6 1.8c-1.6 2.4-2.4 5.4-2.4 8.4 0 6.6 4.2 12.4 10 14.8-0.4 0.6-1 1.2-1.4 1.8-1.6 1.8-3.6 3.8-5.8 5.6s-4.4 3.6-7 5.4l-13 7.6c-0.2 1-0.4 2-0.6 3 0.2 0 0.4-0.2 0.4-0.2l16.6-9.4c2.4-1.6 4.8-3.2 6.8-4.8 2.4-1.8 4.4-3.6 6.2-5.6 0.6-0.6 1.4-1.4 2-2 0.6 0 1.2 0 1.8 0 8.8 0 16-7.2 16-16s-7.2-16-16-16c-3.2 0-6.2 1-8.8 2.6-3.6-1.6-7.2-2.6-12.8-3.6s-23.6-2.4-39.2-0.6c-6.2-4.6-17.8-8.4-27.8-8.4-3.2 0-6.2 0.2-9.4 0.8-15.8 3-28.4 13-35.4 26 0 0-23.4 9-39.2 23.4-6.4 5.8-10 12.8-10.6 16.6-1.4 5.8 0.6 11.6 7 15.8zM423.2 92.6c11.6 0 21 9.4 21 21s-9.4 21-21 21c-11.6 0-21-9.4-21-21s9.4-21 21-21z"
    ],
    "grid": 0,
    "tags": [
      "ios-ionitron-outline"
    ]
  },
  {
    "paths": [
      "M935.4 538.4c-9-64-30.4-118.4-71.8-114.6 12.8 29.2 27 70.4 23.4 144-2.8-51.8-12.6-100.4-34.2-144-64-129.2-201-214.8-354.4-206.2-171.6 9.6-309.4 133.4-343.4 293.6l-22.8 3.2c-34.4 4.8-53.8 69.8-43.2 145 10.6 75.4 47 132.4 81.4 127.6l31.4-4.4c69.2 112.6 196.6 184.6 338 176.8 170.4-9.4 307.6-131.8 342.8-290.4l14.8-0.8c30.2-5 47.4-62.8 38-129.8zM180.4 528c21.4 16.4 44.6 56.6 52.2 110.2 7.8 55.4-3.6 108.2-20.8 128.6 12-29.6 16-74.6 9.4-123.8-6.6-48-22-89.4-40.8-115zM547.6 760.4c-17 1-31.6-12-32.4-29-1-17 12-31.4 29-32.4s31.6 12 32.4 29c1 17-12 31.4-29 32.4zM709.2 751c-17 1-31.6-12-32.4-29-1-17 12-31.4 29-32.4s31.6 12 32.4 29c1 17-12 31.6-29 32.4z",
      "M330.6 140c0 0 0 0.2 0 0 0.2 0.2 0.2 0.4 0.2 0.4s0 0 0 0c0.2 0.4 0.4 0.6 0.6 1 0 0 0 0.2 0 0.2 0.8 2 2.2 3.8 4.6 5.4 4 3 10 4.8 17.2 6 6.8 1 15 1.4 23.8 1 2 0 3.8-0.2 5.8-0.4-0.8-0.8-1.6-1.8-2.4-2.6-0.8 0-1.8 0-2.6 0-8.6 0.2-16.4-0.4-23.2-1.8-7-1.4-12.8-3.6-16.8-6.8-1.2-1-2-1.8-2.6-2.8-0.4-1.4-0.4-3 0-4.6 1-4.6 4.8-9.6 10.8-14.8 5.4-4.6 12.8-9.4 21.6-14 1.6-0.8 3.4-1.8 5.2-2.6 0.2-0.2 0.6-0.2 1-0.4-1.6 6.6-1.8 13.8-0.4 21 4.6 23.8 25 40.6 48.4 41.2l10 52.6 21.4-4-10-52.6c21.6-9.2 34.6-32.2 30-56-1.4-7-4-13.4-7.8-19-10.6-1.6-31.2-1.6-58.4 4.2 2.2-0.6 4.2-1.4 6.4-2 15.2-4.2 29.8-7 43-8.4 1.2-0.2 2.4-0.2 3.6-0.4 2.4-0.2 4.6-0.4 7-0.6 0.4 0 0.8 0 1.2 0 8-0.4 15.4-0.2 21.6 0.6 4.8 0.6 8.8 1.6 12.2 2.8-1.2 1.8-1.8 4-1.8 6.4 0 5.4 3.6 10 8.6 11.6 0 0 0 0 0 0-1.2 1.8-2.6 3.8-4.2 5.6s-3.6 3.8-5.8 5.6c-2.2 1.8-4.4 3.6-7 5.4l-13 7.6c-0.2 1-0.4 2-0.6 3 0.2 0 0.4-0.2 0.4-0.2l16.6-9.4c2.4-1.6 4.8-3.2 6.8-4.8 2.4-1.8 4.4-3.6 6.2-5.6 1.8-1.8 3.4-3.8 4.8-5.6 0.2-0.4 0.4-0.8 0.6-1.2 6-0.8 10.8-5.8 10.8-12 0-6.8-5.4-12.2-12.2-12.2-2 0-3.8 0.6-5.4 1.4-4-2.4-9.6-4.2-16.4-5.4-8.6-1.6-19-2-31-1.2-1.4 0-2.8 0.2-4.2 0.4s-2.6 0.4-4 0.4c-10.6-7-23.8-10-37.2-7.4-15.8 3-28.4 13-35.4 26-2.6 1-5.2 2.2-7.6 3.4-1.4 0.6-2.6 1.2-4 1.8-11.8 5.8-21.2 12.2-27.8 18.2-6.2 5.8-9.8 11.4-10.6 16.6-0.4 2.8 0 5.6 1.4 8 0.2 0.2 0.4 0.6 0.6 1z"
    ],
    "grid": 0,
    "tags": [
      "ios-ionitron"
    ]
  },
  {
    "paths": [
      "M928 96c0 0-39.6 2.8-106.2 54.4-31 24-324.4 241.2-324.4 241.2l-319.4-15.8-82 73 204 102.4-16 20.2-163.2 8.2-13.4 67.2 121.2 94.4-53.4 107.2 107.4-53 94.6 121.2 67.2-13.4 8.2-163.2 20.2-15.8 102.4 203.8 73-81.8-15.8-319.4c0 0 217.2-293.4 241.2-324 51.8-67.2 54.4-106.8 54.4-106.8zM848.6 183.2l-248.4 333.8 15.6 317.6-33 37-81.4-161.8-17.6-34.8-62.6 49-7.8 152.8-23.4 4.6-98.4-126.2-45.6 22.4 22.8-45.6-126.2-98.4 4.6-23.4 152.8-7.8 49.6-62.2-35.2-17.6-161.8-81.4 37-33 317.8 15.6 334-248.2c9-7 17.4-13 25.2-18-5 7.8-11 16.4-18 25.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-jet-outline"
    ]
  },
  {
    "paths": [
      "M928 96c0 0-39.6 2.8-106.2 54.4-31 24-324.4 241.2-324.4 241.2l-319.4-15.8-82 73 204 102.4-16 20.2-163.2 8.2-13.4 67.2 121.2 94.4-53.4 107.2 107.4-53 94.6 121.2 67.2-13.4 8.2-163.2 20.2-15.8 102.4 203.8 73-81.8-15.8-319.4c0 0 217.2-293.4 241.2-324 51.8-67.2 54.4-106.8 54.4-106.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-jet"
    ]
  },
  {
    "paths": [
      "M685.2 436.2c-26.6 0-52.2 0-76.2 8.2-103.2-86.2-375.6-313.8-396.4-335-9.6-9.8-20.2-13.4-30.6-13.4-17.4 0-34 10.4-43.4 19.2-14 13.2-51.2 53.6-41 64 30.6 30.8 54.8 53 67.4 65.6 9.6 9.6 26.8-1.6 39.2 6.6 11 7.2 20 19.8 29.2 29 10.6 10.8 18 15.6 17.8 31.4-0.2 16.6 1 27.6 12.6 40 9.4 10 18.2 15.2 31.8 15.4 18.4 0.4 29.8 4.8 41.8 19.8 11.4 14.2 4.2 28.4 9.8 44 3.6 10.2 32 36.2 36 40.2s22 0 26.6 4.6 34.4 31.6 36.4 40.8-6 18-4 27.2c2.4 11.2 14.4 24.2 21.2 34.8-13.6 31-21.2 65.2-21.2 101.4 0 137 108.8 248 242.8 248s243-111 243-248-108.8-243.8-242.8-243.8zM685.2 896c-116.4 0-211-97-211-216 0-30.8 6.2-60.6 18.4-88.4l7-15.8c0 0-15.4-26.8-20.8-32.4-5.4-5.4 4.4-26.2-1.2-33.2-5.8-7-39.2-50.4-49.4-60.6s-28-3.6-33.4-9c-5.4-5.4-14.6-15.8-17.4-20.8-0.4-1.6-0.4-4.8-0.6-7.6-0.2-10.4-0.6-28-14.2-44.8-17.2-21.6-37-31-65.8-31.8-3.2 0-4.4-0.2-9.4-5.4-3.2-3.4-4-4.4-4-17.8 0.2-27.4-13.4-40.8-23.2-50.4l-38.2-37.2c-15.4-10.2-30.2-10.4-39.8-10.4-2.6 0-5.2 0-6.8-0.4l-43.6-45.4c2-6 15.4-17.8 21.2-23 2.8-2.4 5.2-4.8 7.8-7 5.6-5.2 14.8-10.6 21.6-10.6 2 0 4.2 0.2 7.8 3.8 20.8 21.2 258.8 220.4 398.8 337.2l13.6 11.4 16.8-5.6c19.2-6.4 41.8-6.4 66-6.4 56.6 0 109.6 21.8 149.2 61.2 39.8 39.6 61.6 93.2 61.6 150.6 0 118.8-94.6 215.8-211 215.8z",
      "M768 704c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64c0-35.4-28.6-64-64-64zM768 800c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-key-outline"
    ]
  },
  {
    "paths": [
      "M768 736c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32z",
      "M685.2 436.2c-26.6 0-52.2 0-76.2 8.2-103.2-86.2-375.6-313.8-396.4-335-9.6-9.8-20.2-13.4-30.6-13.4-17.4 0-34 10.4-43.4 19.2-14 13.2-51.2 53.6-41 64 30.6 30.8 54.8 53 67.4 65.6 9.6 9.6 26.8-1.6 39.2 6.6 11 7.2 20 19.8 29.2 29 10.6 10.8 18 15.6 17.8 31.4-0.2 16.6 1 27.6 12.6 40 9.4 10 18.2 15.2 31.8 15.4 18.4 0.4 29.8 4.8 41.8 19.8 11.4 14.2 4.2 28.4 9.8 44 3.6 10.2 32 36.2 36 40.2s22 0 26.6 4.6 34.4 31.6 36.4 40.8-6 18-4 27.2c2.4 11.2 14.4 24.2 21.2 34.8-13.6 31-21.2 65.2-21.2 101.4 0 137 108.8 248 242.8 248s243-111 243-248-108.8-243.8-242.8-243.8zM768 832c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64c0 35.4-28.6 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-key"
    ]
  },
  {
    "paths": [
      "M896 735v-476.8c0-18.8-15.8-34.2-34.4-34.2h-699.2c-18.6 0-34.4 15.2-34.4 34.2v476.8h-96.2v31.2c0 6.2 62 33.8 104.2 33.8h752c48.6 0 104-28.2 104.2-33v-32h-96.2zM512 240c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8c0-4.4 3.6-8 8-8zM160 272.4h704v430.6h-704v-430.6zM596.6 751c0 0-158.6 0-169.2 0s-19.4-12-19.4-15h208c0 3-6 15-19.4 15z"
    ],
    "grid": 0,
    "tags": [
      "ios-laptop"
    ]
  },
  {
    "paths": [
      "M907.8 765.4c-103.6-16-109.8-25.4-109.8-25.4 31.2-148-46.4-308.2-154.2-397.2-143.6-118.4-361.8-32.4-531.8-212.4-1.6-1.6-3-2.4-4.4-2.4-33.2 0-4 481 200.6 667.8 85.6 78.4 179.8 100.2 255.4 100.2 61.6 0 111-14.6 133.6-25 45.6-21.2 77.4-67.8 77.4-67.8 74 23.2 114.6 24.4 122.6 24.4 1 0 1.4 0 1.4 0 0.8 0.2 1.6 0.2 2.4 0.2 27.6-0 40.6-57.2 6.8-62.4zM683.8 842c-17.8 8.2-63 22-120 22-39.2 0-77.4-6.4-113.4-19-43.8-15.2-84.2-39.8-120.4-72.8-40.8-37.2-77.2-90.4-108-158-26.6-58-48.6-125-65.2-199-13.6-60-23-123.6-26.8-178.8-1.2-19-1.8-34.6-1.8-47.2 92.8 76.4 195.6 92.8 287.6 107.6 77.8 12.4 151.2 24.2 207.8 70.8 51 42.2 93.4 99.4 119.2 161.2 28 66.8 31.8 133.8 25.4 201.4-360-126-529-341-529-341s145 250.4 504.6 401.6c-10.2 13-26.6 35.6-60 51.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-leaf-outline"
    ]
  },
  {
    "paths": [
      "M907.8 765.4c-103.6-16-111.4-31.4-111.4-31.4 31.2-148-44.8-302.2-152.6-391.2-143.6-118.4-361.8-32.4-531.8-212.4-39.6-42-16.6 471 196.2 665.4 155.6 142 338.8 98.4 389 75.2 45.6-21.2 77.4-67.8 77.4-67.8 83 26 124 24.4 124 24.4 29.2 3.6 44-56.8 9.2-62.2zM724.2 772.2c-272.4-81.8-483.2-375-483.2-375s185.8 221.4 502.8 326.4c0.2 16.2-9.2 39.4-19.6 48.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-leaf"
    ]
  },
  {
    "paths": [
      "M557.2 693l-135.8 135.8c-30 30-70.2 46.6-113.2 46.6s-83-16.6-113.2-46.6c-30-30-46.6-70.2-46.6-113.2s16.6-83 46.6-113.2l135.8-135.8c7.8-7.8 16.2-14.6 25-20.4 10.2-6.8 21.2-12.2 32.6-16.4 10.6-3.8 21.6-6.6 33-8.2 7.4-1 14.8-1.6 22.4-1.6 3.4 0 6.8 0.2 10.2 0.4 39 2.4 75.2 18.6 103 46.2 27.6 27.6 43.8 64 46.2 103 10.8-2 21.4-5.4 31.2-10-4.4-42.2-22.8-83.4-55-115.6s-73.2-50.6-115.6-55c-11.4-1.2-23-1.4-34.4-0.6-12 0.8-23.8 2.8-35.4 6-12.2 3.2-24.2 7.6-35.6 13.4-18.2 9-35.4 21-50.6 36.2l-135.8 135.8c-74.6 74.6-74.6 196.8 0 271.6v0c74.6 74.6 196.8 74.6 271.6 0l135.8-135.8c15.2-15.2 27.2-32.2 36.2-50.6-12.8 2-25.6 3-38.4 3-5.4 9-12.2 17.4-20 25z",
      "M851.4 172.6v0c-74.6-74.6-196.8-74.6-271.6 0l-135.8 135.8c-15.2 15.2-27.2 32.2-36.2 50.6 12.8-2 25.6-3 38.4-3 5.8-9 12.6-17.4 20.4-25l135.8-135.8c30-30 70.2-46.6 113.2-46.6s83 16.6 113.2 46.6c30 30 46.6 70.2 46.6 113.2 0 42.8-16.6 83-46.6 113.2l-135.8 135.8c-7.8 7.8-16.2 14.6-25 20.4-10.2 6.8-21.2 12.2-32.6 16.4-10.6 3.8-21.6 6.6-33 8.2-7.4 1-14.8 1.6-22.4 1.6-3.4 0-6.8-0.2-10.2-0.4-39-2.4-75.2-18.6-103-46.2-27.6-27.6-43.8-64-46.2-103-10.8 2-21.4 5.4-31.2 10 4.4 42.2 22.8 83.4 55 115.6v0c32.2 32.2 73.2 50.6 115.6 55 11.4 1.2 23 1.4 34.4 0.6 12-0.8 23.8-2.8 35.4-6 12.2-3.2 24.2-7.6 35.6-13.4 18.2-9 35.4-21 50.6-36.2l135.8-135.8c74.2-74.8 74.2-197-0.4-271.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-link-outline"
    ]
  },
  {
    "paths": [
      "M546 681.8l-135.8 135.8c-27 27-63.2 42-101.8 42s-74.8-14.8-101.8-42c-27-27-42-63.2-42-101.8s14.8-74.8 42-101.8l135.8-135.8c6.8-6.8 14.4-13 22.6-18.4 9.2-6 19-11 29.4-14.8 9.6-3.6 19.6-6 29.8-7.4 6.8-1 13.6-1.4 20.2-1.4 2.8 0 5.6 0.2 9.2 0.4 35 2.2 68 17 92.6 41.6 21.6 21.6 35.6 49.6 40.2 79.6 4.6-0.2 16.4-1 32.4-5.8s26.8-12.6 26.8-12.6c-6.6-42.4-23.2-75.6-54.2-106.4-30.8-30.8-71-51.2-114-58-3.8-0.6-7.4-1.2-11.2-1.6-7.2-0.8-14.6-1.2-22-1.2-5 0-10.2 0.2-15.4 0.6-10.8 0.8-21.4 2.4-32 4.8-2.2 0.4-4.2 1-6.4 1.6-13.4 3.6-26.4 8.4-38.6 14.4-20.2 10-38.8 23.2-54.8 39.2l-135.8 135.8c-39.2 39.2-60.6 91.4-60.6 147s21.6 108 60.6 147c39.2 39.2 91.4 60.6 147 60.6 55.8 0 108-21.6 147-60.6l135.8-135.8c14.4-14.4 26.4-30.8 36-48.6 0 0-22.4 5.4-47.2 5.4s-33.8-1.8-33.8-1.8z",
      "M862.8 161.2c-39.2-39.2-91.4-60.6-147-60.6s-108 21.6-147 60.6l-135.8 135.8c-14.4 14.4-26.4 30.8-36 48.6 0 0 0 0 0 0 10.4-2.4 30.6-4.8 48-4.8s32.4 2.2 32.4 2.2l136.6-136.2c27-27 63.2-42 101.8-42s74.8 14.8 101.8 42c27 27 42 63.2 42 101.8s-14.8 74.8-42 101.8l-135.8 135.6c-6.8 6.8-14.4 13-22.6 18.4-9.2 6-19 11-29.4 14.8-9.6 3.4-19.6 6-29.8 7.4-6.8 1-13.6 1.4-20.2 1.4-2.8 0-5.6-0.2-9.2-0.4-35-2.2-68-17-92.6-41.6-21.2-21.2-35-48.4-39.8-77.6 0 0-13.2-1-31.4 4.6-11.4 3.4-23.2 8.4-28.4 11 6 43 22.8 75.4 54.2 107v0l0.4 0.4c33.4 33.4 78 54.6 125.2 59.6 7.2 0.8 14.6 1.2 22 1.2 5.2 0 10.2-0.2 15.4-0.6 12.8-1 25.8-3 38.2-6.4 13.4-3.6 26.4-8.4 38.6-14.4 20.2-10 38.8-23.2 54.8-39.2l135.8-135.8c39.2-39.2 60.6-91.4 60.6-147s-21.8-108.4-60.8-147.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-link"
    ]
  },
  {
    "paths": [
      "M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z",
      "M384 304h384v32h-384v-32z",
      "M384 496h384v32h-384v-32z",
      "M384 688h384v32h-384v-32z",
      "M320 320c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 704c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-list-box-outline"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM288 736c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 544c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 352c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM768 720h-384v-32h384v32zM768 528h-384v-32h384v32zM768 336h-384v-32h384v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-list-box"
    ]
  },
  {
    "paths": [
      "M384 304h384v32h-384v-32z",
      "M384 496h384v32h-384v-32z",
      "M384 688h384v32h-384v-32z",
      "M320 320c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M320 704c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-list"
    ]
  },
  {
    "paths": [
      "M640 512c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z",
      "M944 496h-48.4c-8.2-199.4-168.2-359.4-367.6-367.6v-48.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.4c-199.4 8.2-359.4 168.2-367.6 367.6h-48.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.4c8.2 199.4 168.4 359.4 367.6 367.6v48.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.4c199.4-8.2 359.4-168.4 367.6-367.6h48.4c8.8 0 16-7.2 16-16s-7.2-16-16-16zM760.8 760.8c-62.8 62.8-144.8 98.8-232.8 102.8v-79.6c0-8.8-7.2-16-16-16s-16 7.2-16 16v79.6c-88-4-170.2-40-232.8-102.8-62.8-62.6-99-144.8-102.8-232.8h79.6c8.8 0 16-7.2 16-16s-7.2-16-16-16h-79.6c4-88 40-170.2 102.8-232.8s144.8-99 232.8-102.8v79.6c0 8.8 7.2 16 16 16s16-7.2 16-16v-79.6c88 4 170.2 40 232.8 102.8s99 144.8 102.8 232.8h-79.6c-8.8 0-16 7.2-16 16s7.2 16 16 16h79.6c-3.8 88-40 170.2-102.8 232.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-locate-outline"
    ]
  },
  {
    "paths": [
      "M768 512c0-8.8 7.2-16 16-16h111.6c-8.2-199.4-168.2-359.4-367.6-367.6v111.6c0 8.8-7.2 16-16 16s-16-7.2-16-16v-111.6c-199.4 8.2-359.4 168.2-367.6 367.6h111.6c8.8 0 16 7.2 16 16s-7.2 16-16 16h-111.6c8.2 199.4 168.4 359.4 367.6 367.6v-111.6c0-8.8 7.2-16 16-16s16 7.2 16 16v111.6c199.4-8.2 359.4-168.4 367.6-367.6h-111.6c-8.8 0-16-7.2-16-16zM512 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128-57.4 128-128 128z",
      "M944 496h-48.4c0.2 5.4 0.4 10.6 0.4 16s-0.2 10.6-0.4 16h48.4c8.8 0 16-7.2 16-16s-7.2-16-16-16z",
      "M128.4 496h-48.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.4c-0.2-5.4-0.4-10.6-0.4-16s0.2-10.6 0.4-16z",
      "M496 895.6v48.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.4c-5.4 0.2-10.6 0.4-16 0.4s-10.6-0.2-16-0.4z",
      "M528 128.4v-48.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.4c5.4-0.2 10.6-0.4 16-0.4s10.6 0.2 16 0.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-locate"
    ]
  },
  {
    "paths": [
      "M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM336 304c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144h-352v-144zM800 896h-576v-416h576v416z",
      "M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-lock-outline"
    ]
  },
  {
    "paths": [
      "M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984zM688 448h-352v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144z",
      "M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-lock"
    ]
  },
  {
    "paths": [
      "M274 160h572c44.2 0 80 35.8 80 80v544c0 44.2-35.8 80-80 80h-572c-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16s16 7.2 16 16c0 26.4 21.6 48 48 48h572c26.4 0 48-21.6 48-48v-544c0-26.4-21.6-48-48-48h-572c-26.4 0-48 21.6-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80z",
      "M632.6 493.4l-169.2-168.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l151.2 148.8h-478c-8.8 0-16 7.2-16 16s7.2 16 16 16h478l-147.4 148.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l165.2-164.8c12.6-12.6 12.6-28.8 0-41.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-log-in"
    ]
  },
  {
    "paths": [
      "M560 864h-384c-44.2 0-80-35.8-80-80v-544c0-44.2 35.8-80 80-80h384c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.4-21.6-48-48-48h-384c-26.4 0-48 21.6-48 48v544c0 26.4 21.6 48 48 48h384c26.4 0 48-21.6 48-48 0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2-35.8 80-80 80z",
      "M918.6 493.4l-169.2-168.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l151.2 148.8h-542c-8.8 0-16 7.2-16 16s7.2 16 16 16h542l-147.4 148.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l165.2-164.8c12.6-12.6 12.6-28.8 0-41.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-log-out"
    ]
  },
  {
    "paths": [
      "M380.2 266.2c32.2 3.8 65.6 21.6 93.8 49.8l335.4 335.4 118.6-118.6-355.6-355.4c-108.6-108.6-286.4-108.6-395 0v0c-108.6 108.6-108.6 286.4 0 395l355.6 355.6 118.6-118.6-335.4-335.2c-28.8-28.8-46.8-61.8-50.8-93.2-4.2-32 6.2-60.8 30.6-85.2 23-23.2 52.2-33.4 84.2-29.6zM888.4 533l-79 79-59.2-59.2 79-79 59.2 59.2zM612 809.4l-79 79-59.2-59.2 79-79 59.2 59.2zM296.4 493.8l236.6 236.6-79 79-256.8-256.6c-47.2-47.4-73.2-110.4-73.2-177.8s26-130.4 73.2-177.8c47.2-47.2 110.4-73.2 177.8-73.2s130.4 26 177.8 73.2l256.6 256.8-79 79-236.6-236.6c-65.4-65.4-156-82-217.8-20.2-64 64-45 152.2 20.4 217.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-magnet-outline"
    ]
  },
  {
    "paths": [
      "M380.2 266.2c32.2 3.8 65.6 21.6 93.8 49.8l335.4 335.4 118.6-118.6-355.6-355.4c-108.6-108.6-286.4-108.6-395 0v0c-108.6 108.6-108.6 286.4 0 395l355.6 355.6 118.6-118.6-335.4-335.2c-28.8-28.8-46.8-61.8-50.8-93.2-4.2-32 6.2-60.8 30.6-85.2 23-23.2 52.2-33.4 84.2-29.6zM888.4 533l-79 79-59.2-59.2 79-79 59.2 59.2zM612 809.4l-79 79-59.2-59.2 79-79 59.2 59.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-magnet"
    ]
  },
  {
    "paths": [
      "M512 128l-384 256v512h768v-512l-384-256zM864 864h-704v-427.2l229.8 174.2-135.8 154.4 4 4 157.4-138.8 96.6 73.4 96.2-73.4 157.6 139 4-4-136-154.6 230-175.6v428.6zM512 663.6l-306.6-235.6h178.6v-6.4l-219.8-25.4-0.6-0.4 348.4-227.6 349.2 228-221.2 25.4v6.4h180.8l-308.8 235.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-mail-open-outline"
    ]
  },
  {
    "paths": [
      "M634 610.8l136 154.6-4 4-157.6-139-96.2 73.4-96.8-73.4-157.4 139-4-4 135.8-154.4-261.8-198v483h768v-485.2z",
      "M384 428h-178.6l306.6 235.6 308.8-235.6h-180.8v-6.4l256-29.8v-7.8l-384-256-384 256v8.4l256 29.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-mail-open"
    ]
  },
  {
    "paths": [
      "M128 256v512h768v-512h-768zM512 535.8l-325.6-247.8h651.2l-325.6 247.8zM160 736v-427.8l230.2 175.2-136.2 154.6 4 4 157.8-139.2 96.2 73.2 96.2-73.2 157.8 139.2 4-4-136.2-154.8 230.2-175v427.8h-704z"
    ],
    "grid": 0,
    "tags": [
      "ios-mail-outline"
    ]
  },
  {
    "paths": [
      "M896 768v-484.4l-262.2 199.6 136.2 154.8-4 4-157.8-139.2-96.2 73.2-96.2-73.2-157.8 139.2-4-4 136-154.8-262-199.2v484z",
      "M879.4 256h-735.4l368 279.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-mail"
    ]
  },
  {
    "paths": [
      "M912 96h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-214 215.4c-59.6-54.2-139-87.4-226-87.4-185.6 0-336 150.4-336 336s150.4 336 336 336c185.6 0 336-150.4 336-336 0-87-33-166.4-87.4-226l215.4-214v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16zM736 592c0 81.2-31.6 157.6-89 215s-133.8 89-215 89c-81.2 0-157.6-31.6-215-89s-89-133.8-89-215 31.6-157.6 89-215 133.8-89 215-89c81.2 0 157.6 31.6 215 89s89 133.8 89 215z"
    ],
    "grid": 0,
    "tags": [
      "ios-male"
    ]
  },
  {
    "paths": [
      "M511.4 213.2c0 0 0 0 0 0h-0.4c-50 0-91-40.6-91-90.6s40.8-90.6 91-90.6 91 40.6 91 90.6c0 24.2-9.4 47-26.6 64-17 17.2-39.8 26.6-64 26.6zM511 64c-32.4 0-58.8 26.2-58.8 58.6s26.4 58.6 58.8 58.6h0.4c0 0 0 0 0 0 15.6 0 30.4-6 41.4-17.2 11-11 17.2-25.8 17.2-41.4-0.2-32.4-26.6-58.6-59-58.6z",
      "M442.4 992c-28.8 0-58-21-58-60.8l2-555.2h-12v210c0 18.6-8 30.2-14.8 36.6-8.6 8.2-20.2 12.8-32.4 12.8s-23.8-4.6-32.4-12.8c-6.8-6.4-14.8-17.8-14.8-36.6v-243.2c0-27.6 10.8-55.6 29.6-76.8 20.8-23.2 49.2-36 80-36h244.6c30.8 0 59.2 12.8 80 36.2 18.8 21.2 29.6 49 29.6 76.6v243.2c0 14.6-5.4 27.6-15.2 36.6-8.8 8-20.6 12.4-33 12.4s-24.2-4.4-33-12.4c-9.8-9-15.2-22-15.2-36.6v-210h-10v555.2c0 39.4-30.8 60.8-59.6 60.8-26.8 0-56.6-18.6-58.8-59.6 0-0.2 0-0.6 0-0.8v-281.6h-16v281.2c0 0.2 0 0.4 0 0.6-1.4 39.4-31.6 60.2-60.6 60.2zM358.4 344h44.2c4.2 0 8.4 1.6 11.4 4.8s4.8 7 4.6 11.4l-2 571.2c0 21.2 13.4 28.8 25.8 28.8 13.6 0 27.6-9 28.4-29.2v-297c0-8.8 7.2-16 16-16h48.2c8.8 0 16 7.2 16 16v297c1.4 21.4 14.6 29 26.8 29 13.2 0 27.4-9 27.4-28.8v-571.2c0-8.8 7.2-16 16-16h42.2c8.8 0 16 7.2 16 16v226c0 16.2 13.4 17 16 17s16-0.8 16-17v-243.2c0-39-31.2-80.8-77.6-80.8h-244.2c-37.2 0-77.6 30.8-77.6 80.8v243.2c0 16.4 12.6 17.2 15 17.2s15-0.8 15-17.2v-226c0.2-8.8 7.4-16 16.4-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-man-outline"
    ]
  },
  {
    "paths": [
      "M511.4 213.2v0h-0.4c-50 0-91-40.6-91-90.6s40.8-90.6 91-90.6 91 40.6 91 90.6c0 24.2-9.4 47-26.6 64-17 17.2-39.8 26.6-64 26.6z",
      "M442.4 992c-28.8 0-58-21-58-60.8l2-555.2h-12v210c0 18.6-8 30.2-14.8 36.6-8.6 8.2-20.2 12.8-32.4 12.8s-23.8-4.6-32.4-12.8c-6.8-6.4-14.8-17.8-14.8-36.6v-243.2c0-27.6 10.8-55.6 29.6-76.8 20.8-23.2 49.2-36 80-36h244.6c30.8 0 59.2 12.8 80 36.2 18.8 21.2 29.6 49 29.6 76.6v243.2c0 14.6-5.4 27.6-15.2 36.6-8.8 8-20.6 12.4-33 12.4s-24.2-4.4-33-12.4c-9.8-9-15.2-22-15.2-36.6v-210h-10v555.2c0 39.4-30.8 60.8-59.6 60.8-26.8 0-56.6-18.6-58.8-59.6 0-0.2 0-0.6 0-0.8v-281.6h-16v281.2c0 0.2 0 0.4 0 0.6-1.4 39.4-31.6 60.2-60.6 60.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-man"
    ]
  },
  {
    "paths": [
      "M704.8 256l-191.4-128-192.6 128-192.8-128v640l192.8 128 192.6-128 191.4 128 191.2-128v-640l-191.2 128zM336 284.8l160-106.4v563l-160 106.2v-562.8zM528 176l160 106.8v563.2l-160-107v-563zM160 188l144 95.2v563.2l-144-95.6v-562.8zM864 750.8l-144 96.6v-562.6l144-96.8v562.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-map-outline"
    ]
  },
  {
    "paths": [
      "M128 128v640l176 116.8v-640z",
      "M336 246v640l160-106.4v-640z",
      "M896 128l-176 117.8v640l176-117.8z",
      "M528 137.6v640l160 107.2v-640z"
    ],
    "grid": 0,
    "tags": [
      "ios-map"
    ]
  },
  {
    "paths": [
      "M704 510.8c31.2 41.4 48 91.4 48 144.2 0 64.2-25 124.4-70.2 169.8s-105.6 70.2-169.8 70.2-124.4-25-169.8-70.2-70.2-105.6-70.2-169.8c0-52.8 17-103 48.2-144.4l-12.4-3.4-20.4-5.8c-30 43.6-47.4 96.6-47.4 153.6 0 150.2 121.8 273 272 273s272-122.8 272-273c0-56.8-17.4-109.6-47.2-153.2l-32.8 9z",
      "M597.4 540.2l-43.4 12c41 16.6 70 56.8 70 103.8 0 61.8-50.2 112-112 112s-112-50.2-112-112c0-47 29-87.2 69.8-103.8l-43.2-12c-35.6 26.2-58.6 68.4-58.6 115.8 0 79.4 64.6 144 144 144s144-64.6 144-144c0-47.4-23-89.6-58.6-115.8z",
      "M96 96v320l416 116 416-116v-320h-832zM896 128v64h-768v-64h768zM128 392v-168h224v232l-224-64zM512 497.4l-128-34v-239.4h256v239.4l-128 34zM672 456v-232h224v168l-224 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-medal-outline"
    ]
  },
  {
    "paths": [
      "M96 224v192l256 72v-264z",
      "M512 564.4z",
      "M400 656.4c0 61.8 50.2 112 112 112s112-50.2 112-112c0-47-28.8-87-69.8-103.8l-42.2 11.6-42-11.8c-41.2 17-70 57.2-70 104z",
      "M736.8 502.2l-139.2 38.4c35.4 26.2 58.4 68.4 58.4 115.8 0 79.4-64.6 144-144 144s-144-64.6-144-144c0-47.4 23-89.6 58.6-115.8l-139.2-38.6c-30 43.6-47.4 96.6-47.4 153.6 0 150.2 121.8 272 272 272s272-121.8 272-272c0-57-17.4-109.6-47.2-153.4z",
      "M384 224v272l128 36 128-35.2v-272.8z",
      "M672 224v264l256-72v-192z",
      "M96 96h832v96h-832v-96z"
    ],
    "grid": 0,
    "tags": [
      "ios-medal"
    ]
  },
  {
    "paths": [
      "M152.2 374c0-76.2 44.4-142 110.6-170h-14.2c-57.4 0-121.4 60.8-132.6 139.6-11.2 1.8-19.8 14.6-19.8 29.8 0 16 9.4 28.6 21.6 29.6 8.4 60 71.4 118 113.8 130.8l20.2 6.4c-55.6-31.6-99.6-97.6-99.6-166.2z",
      "M781 128c17.4 0 31.6 6.4 47.4 21.2 13.8 13.2 26 31.4 36.2 54.2 2 4.8 4 9.2 5.8 13.8v0.4c16.4 42.4 25.6 96.6 25.6 152.4 0 55.6-9 109.6-25.4 152.2v0.4c-1.8 4.6-3.6 9.2-5.8 14.2-10.2 22.4-20.8 38.4-37 54.8-23.8 23.8-40.6 26.4-46.8 26.4-6.4 0-12.2-1.2-28.8-7.4-12.4-4.8-24.8-9.8-37-14.6-62.2-25-126.4-50.8-213-50.8-14.2 0-27.4 5.8-37.2 16.6-29.4 32-25.4 103.4-16.4 208.8 2.4 27.4 4.6 53.4 4.6 70 0 19.8-0.6 32.8-1.8 42.6-0.8 6.8-1.8 10.6-2.6 12.4-1.4 0.2-3.6 0.4-7.2 0.4-14.8 0-36.6-2.8-56.8-7.4-24.4-5.6-36-11.2-39.2-13.4-4.2-5.2-4.6-8-0.4-38.2 4-28.6 30-168.2 41.2-227.8 2.2-11.8 3.8-20.6 4.6-25 4-21.2-6.6-40.4-28.2-51.6-11.2-5.8-24.6-9.2-37.6-12.6-10-2.6-27-7-31.4-10.6l-2-1.6-2.2-1.4c-45.2-26.8-73.2-77.6-73.2-132.4 0-30.4 9-59.8 25.8-85.4 15-22.8 35.4-40.8 59-52.6 15.4-0.2 56-0.4 119.6-0.4 43.8 0 101.2-9.8 162-27.8 61.2-18.2 119-42.6 162.4-68.6l1.2-0.8c7.8-4.4 17.6-10.4 34.6-10.4zM781 96c-27 0-43 10.4-51.6 15.6-86.2 51.8-224.6 92-308 92s-126.8 0.4-126.8 0.4c-63.2 28-109.6 93.8-109.6 170 0 68.4 35.6 128.4 88.8 160 24.2 20.2 91.2 17.6 86.2 44.4s-41 219-46 254-5.8 47 8 64c14 17 83 31.6 120 31.6s43.6-17.4 43.6-87.6-34.6-263.4 17-263.4c96.6 0 163 34.6 238.6 63.4 18 6.8 28.2 9.4 40.2 9.4s37.4-3.8 69.4-36.4c18.4-18.8 31.4-37.6 43.4-64.4 2.2-5.2 4.4-10.4 6.4-16 17.8-46.4 27.4-103.8 27.4-163.8 0-59.8-9.6-117.4-27.6-164-2-5.4-4.2-10.4-6.4-15.4-12-26.8-26.8-48.4-43.4-64.4-21-19-42.8-29.4-69.6-29.4v0z",
      "M770.6 192.6c4.2 0 20 8.2 31.4 33.4 9 20.4 30 74.8 30 144 0 68.4-20.8 123.2-29.8 143.6-10.6 24-25 37-31 39.6-4-2.8-14.2-13.4-25.8-39.6-15.8-36-25-88.4-25-143.6 0-55.8 9.2-108.2 25.2-144 12.2-27.6 23.4-33.4 25-33.4zM770.6 160.6c-20.8 0-40 19.8-54.4 52.4-17 38.4-27.8 94.4-27.8 157 0 62.2 10.8 118.2 27.6 156.4 14.4 33 33.6 59.2 54.6 59.2s46.2-26.2 60.8-59.2c16.8-38.4 32.6-94.4 32.6-156.4 0-62.6-15.6-118.6-32.8-157-14.6-32.4-39.6-52.4-60.6-52.4v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-megaphone-outline"
    ]
  },
  {
    "paths": [
      "M152.2 374c0-76.2 44.4-142 110.6-170h-14.2c-57.4 0-121.4 60.8-132.6 139.6-11.2 1.8-19.8 14.6-19.8 29.8 0 16 9.4 28.6 21.6 29.6 8.4 60 71.4 118 113.8 130.8l20.2 6.4c-55.6-31.6-99.6-97.6-99.6-166.2z",
      "M900.4 205.6c-2-5.4-4.2-10.4-6.4-15.4-12-26.8-26.8-48.4-43.4-64.4-21-19.4-42.8-29.8-69.6-29.8s-43 10.4-51.6 15.6c-86.2 51.8-224.6 92-308 92s-126.8 0.4-126.8 0.4c-63.2 28-109.6 93.8-109.6 170 0 68.4 35.6 128.4 88.8 160 24.2 20.2 91.2 17.6 86.2 44.4s-41 219-46 254-5.8 47 8 64c14 17 83 31.6 120 31.6s43.6-17.4 43.6-87.6-34.6-263.4 17-263.4c96.6 0 163 34.6 238.6 63.4 18 6.8 28.2 9.4 40.2 9.4s37.4-3.8 69.4-36.4c18.4-18.8 31.4-37.6 43.4-64.4 2.2-5.2 4.4-10.4 6.4-16 17.8-46.4 27.4-103.8 27.4-163.8 0-59.6-9.6-117.2-27.6-163.6zM863.4 526.6c-14.4 32.8-39.8 59.2-60.8 59.2s-40.2-26.2-54.6-59.2c-16.8-38.4-27.6-94.4-27.6-156.4 0-62.6 10.8-118.6 27.8-157 14.4-32.6 33.6-52.4 54.4-52.4 21 0 46 19.8 60.6 52.4 17 38.4 32.8 94.4 32.8 157 0 62-15.6 118-32.6 156.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-megaphone"
    ]
  },
  {
    "paths": [
      "M128 288h768v32h-768v-32z",
      "M128 496h768v32h-768v-32z",
      "M128 704h768v32h-768v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-menu-outline"
    ]
  },
  {
    "paths": [
      "M128 288h768v64h-768v-64z",
      "M128 480h768v64h-768v-64z",
      "M128 672h768v64h-768v-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-menu"
    ]
  },
  {
    "paths": [
      "M669.8 553c0 0.4 0 0.8-0.2 1.2 0-0.4 0-0.8 0.2-1.2z",
      "M670.4 544.8c0 0.4 0 0.8 0 1.4-0.2-0.6-0.2-1 0-1.4z",
      "M354 536.6v0.2c0 92.2 70.6 167.2 158.2 167.2 18.2 0 35.6-3.2 51.8-9.2l-0.2-0.2c-16.2 6-33.4 9.2-51.6 9.2-87.6-0.2-158.2-75-158.2-167.2z",
      "M512.2 671.6c-69.6 0-126.2-60.6-126.2-135v-146l-32-54.6v200.6c0 92.2 70.6 167.2 158.2 167.2 18.2 0 35.6-3.2 51.8-9.2l-16.6-28.2c-11.2 3.4-23 5.2-35.2 5.2z",
      "M670 536.8v-0.2c0 2.8 0 5.4-0.2 8.2 0.2-2.6 0.2-5.4 0.2-8z",
      "M670.2 546.2c-0.2 2.4-0.2 4.6-0.4 7 0.2-2.4 0.4-4.8 0.4-7z",
      "M640.4 634.8c15.8-23 26.2-50.6 29.2-80.4-3 29.6-13.4 57.2-29.2 80.4v0z",
      "M511.8 96c-59.2 0-110.6 34.2-137.8 84.8l20 33.8c18.2-50.8 64-87 117.8-87 69.6 0 126.2 60.6 126.2 135v273.6c0 24.2-5.8 47-16.4 66.6l18.6 31.4c15.8-23 26.4-50.6 29.4-80.4 0-0.4 0.2-0.8 0.2-1.2 0.2-2.2 0.4-4.6 0.6-7 0-0.4-0.2-0.8-0.2-1.4 0.2-2.8 0-5.4 0-8.2v-272.8c-0.2-92.2-70.8-167.2-158.4-167.2z",
      "M528.4 766.6l-16.4 1.2-16.8-1.2c-57.2-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 254.8v97.6h-148v32h322v-32h-144v-97.4c30-2.2 58.2-9.4 84.6-21l-15.6-26.6c-22 8.6-45.2 13.8-68.6 15.6z",
      "M768 543.6v-127.6h-32v127.6c0 56.8-20.2 111-58.4 152.4-0.4 0.4-0.4 0.6-0.8 1l15.2 26.4c46.8-46.2 76-109.8 76-179.8z",
      "M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-mic-off-outline"
    ]
  },
  {
    "paths": [
      "M354 536.8c0 92.2 70.6 167.2 158 167.2 18.2 0 35.6-3.2 51.8-9.2l-209.8-358.8v200.8z",
      "M670 536.8v-273.8c0-92.2-70.6-167.2-158-167.2-59 0-110.4 34.2-137.6 84.8l265.4 454c19-27.4 30.2-61.2 30.2-97.8z",
      "M528.4 766.6l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c29.6-2.2 58-9.4 84.2-21l-15.6-26.6c-21.8 8.6-45 14-68.2 15.6z",
      "M768 543.6v-127.6h-32v127.6c0 56.8-20.4 111-58.6 152.6-0.4 0.4-0.6 0.6-1 1l15.4 26.4c46.8-46.4 76.2-110 76.2-180z",
      "M268.4 64l-27.6 16 514.8 880 27.6-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-mic-off"
    ]
  },
  {
    "paths": [
      "M512 127.8c69.4 0 126 60.6 126 135.2v273.8c0 74.6-56.6 135.2-126 135.2s-126-60.6-126-135.2v-273.8c0-74.6 56.6-135.2 126-135.2zM512 96c-87.4 0-158 74.8-158 167v273.8c0 92.2 70.6 167.2 158 167.2s158-75 158-167.2v-273.8c0-92.2-70.6-167-158-167v0z",
      "M736 416v127.6c0 56.8-20.4 111-58.6 152.6-38 41.4-93.4 66.4-149 70.4l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c132-9.8 240-120.6 240-255v-127.6h-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-mic-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-87.4 0-158 74.8-158 167v273.8c0 92.2 70.6 167.2 158 167.2s158-75 158-167.2v-273.8c0-92.2-70.6-167-158-167v0z",
      "M736 416v127.6c0 56.8-20.4 111-58.6 152.6-38 41.4-93.4 66.4-149 70.4l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c132-9.8 240-120.6 240-255v-127.6h-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-mic"
    ]
  },
  {
    "paths": [
      "M560 96h-96c-132 0-240 108-240 240v256c0 126.6 99.4 231.2 224 239.4v96.6h128v-96.6c124.6-8.4 224-112.8 224-239.4v-256c0-132-108-240-240-240zM480 896v-64h64v64h-64zM560 800h-96c-55.2 0-107.4-21.8-146.8-61.2-1-1-1.8-2-2.8-2.8h395.4c-1 1-1.8 2-2.8 2.8-39.6 39.4-91.8 61.2-147 61.2zM735 704h-446c-21.4-33.2-33-71.8-33-112v-16h160v-32h-160v-64h160v-32h-160v-64h160v-32h-160v-16c0-55.2 21.8-107.4 61.2-146.8 27.8-27.8 61.8-46.8 98.8-55.6v90.4h32v-95.4c5.2-0.4 10.6-0.6 16-0.6h32v128h32v-128h32c5.4 0 10.8 0.2 16 0.6v95.4h32v-90.4c37 8.8 71.2 27.8 98.8 55.6 39.4 39.4 61.2 91.6 61.2 146.8v16h-160v32h160v64h-160v32h160v64h-160v32h160v16c0 40.2-11.6 78.8-33 112z"
    ],
    "grid": 0,
    "tags": [
      "ios-microphone-outline"
    ]
  },
  {
    "paths": [
      "M608 384v-32h192v-16c0-115.6-82.8-212.8-192-235.2v123.2h-32v-127.4c-5.2-0.4-10.6-0.6-16-0.6h-32v160h-32v-160h-32c-5.4 0-10.8 0.2-16 0.6v127.4h-32v-123.2c-109.2 22.4-192 119.6-192 235.2v16h192v32h-192v64h192v32h-192v64h192v32h-192v16c0 40.4 10.2 78.6 28 112h520c17.8-33.4 28-71.6 28-112v-16h-192v-32h192v-64h-192v-32h192v-64h-192z",
      "M751.6 736h-479.2c41.2 54.6 105.4 91.4 177.6 95.6l-2 0.4v96h128v-96l-3-0.4c72.8-4 137.2-40.6 178.6-95.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-microphone"
    ]
  },
  {
    "paths": [
      "M428.2 174.6c0 0 0 0.2-0.2 0.2-25.6 53.4-38.6 111-38.6 170.8 0 105.6 41 205 115.6 279.6 74.6 74.8 173.6 115.8 279.2 115.8 6.4 0 12.8-0.2 19.2-0.4 0.2 0 0.2 0 0.4 0-67.2 78.4-164.4 123.2-267.4 123.2-94.2 0-182.6-36.8-249.2-103.4s-103.2-155.2-103.2-249.6c0-76.6 24-149.4 69.6-210.8 22-29.4 48.2-55.2 78-76.6 29.6-21.2 62.2-37.6 96.6-48.8zM493.8 128c-25.2 2.8-49.8 8-73.2 15.4-155.8 49.4-268.6 195.2-268.6 367.4 0 212.8 172 385.2 384.4 385.2 117.4 0 222.4-52.8 293-135.8 16.2-19 30.4-39.6 42.8-61.6-22.8 5.6-46.2 9-70 10.2-5.8 0.2-11.8 0.4-17.6 0.4-96.8 0-188-37.8-256.4-106.4-68.6-68.6-106.2-160-106.2-257 0-55.2 12.2-108.6 35.4-157 9.8-21.4 22-41.8 36.4-60.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-moon-outline"
    ]
  },
  {
    "paths": [
      "M493.8 128c-25.2 2.8-49.8 8-73.2 15.4-155.8 49.4-268.6 195.2-268.6 367.4 0 212.8 172 385.2 384.4 385.2 117.4 0 222.4-52.8 293-135.8 16.2-19 30.4-39.6 42.8-61.6-22.8 5.6-46.2 9-70 10.2-5.8 0.2-11.8 0.4-17.6 0.4-96.8 0-188-37.8-256.4-106.4-68.6-68.6-106.2-160-106.2-257 0-55.2 12.2-108.6 35.4-157 9.8-21.4 22-41.8 36.4-60.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-moon"
    ]
  },
  {
    "paths": [
      "M779.2 331l-22.6 22.6 141.6 142.4h-370.2v-370.2l142.4 141.8 22.6-22.8-181-181-181 181 22.6 22.6 142.4-141.6v370.2h-370.2l141.6-142.4-22.6-22.6-180.8 181 181 181 22.6-22.6-141.8-142.4h370.2v370l-142.4-141.6-22.6 22.6 181 181 181-181-22.6-22.6-142.4 141.6v-370h370.2l-141.8 142.4 22.6 22.6 181-181z"
    ],
    "grid": 0,
    "tags": [
      "ios-move"
    ]
  },
  {
    "paths": [
      "M716.6 96.4c-9.4 1.8-212 40.2-220.4 41.8s-16.2 7.2-16.2 16c0 0 0 515.4 0 518.8 0 3.2-0.2 14.4-4.8 23.4-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.2 0 62 44.8 90 83.4 94.8 4.2 0.6 9 1.6 14.2 1.6 0 0 0 0 0 0 13.4 0 48-2.8 78.4-22.6 22-14.2 48.2-42.8 48.2-95.6v-476.8l224-45.8v-175.6c-0.2-8.6-7.6-17.6-19.6-15.2zM480 809.6c0 30.8-11.2 54.6-33.6 69-23.8 15.6-52.6 17.4-61 17.4 0 0 0 0 0 0-3.8 0-7.2-0.8-10.2-1.2-4.6-0.6-21-3.8-34.6-14.8-13.8-11-20.8-27.4-20.8-48.4 0-45 49.2-59.8 103.8-72.2 11.4-2.6 21.2-4.8 29.2-7.4 11-3.6 19-8.4 27-13.8v71.4zM704 261.4l-192 37.8v-131.6l192-36.4v130.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-musical-note-outline"
    ]
  },
  {
    "paths": [
      "M716.6 96.4c-9.4 1.8-212 40.2-220.4 41.8s-16.2 7.2-16.2 16c0 0 0 515.4 0 518.8 0 3.2-0.2 14.4-4.8 23.4-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.2 0 62 44.8 90 83.4 94.8 4.2 0.6 9 1.6 14.2 1.6 0 0 0 0 0 0 13.4 0 48-2.8 78.4-22.6 22-14.2 48.2-42.8 48.2-95.6v-476.8l224-45.8v-175.6c-0.2-8.6-7.6-17.6-19.6-15.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-musical-note"
    ]
  },
  {
    "paths": [
      "M812.6 96.4c-9.4 1.8-404 78.4-412.4 80s-16.2 7.2-16.2 16c0 0 0 477 0 480.2s-0.2 14.4-4.8 23.4c-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29.2-128.8 103.6 0 62.2 44.8 90.2 83.4 95 4.2 0.6 9 1.4 14.2 1.4 0 0 0 0 0 0 13.4 0 48-2.6 78.4-22.4 22-14.4 48.2-42.8 48.2-95.6v-438l384-78c0 0 0 273.2 0 281.4s-0.4 17.8-5 26.8c-6.2 11.8-17 20.4-32.4 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.4 0 67.4 52.6 91.2 83.6 94.6 2.4 0.2 5.2 0.2 8.2 0.2 0 0 0 0 0 0 20.4 0 51.4-5 77.6-20 35.8-20.6 55-53.6 55-96.4v-604.2c-0.2-8.8-7.6-17.8-19.6-15.4zM384 809.6c0 31-11.2 54.6-33.6 69.2-23.8 15.6-52.6 17.4-61 17.4 0 0 0 0 0 0-3.8 0-7.2-0.8-10.2-1.2-4.6-0.6-21-3.8-34.6-14.8-13.8-11-20.8-27.4-20.8-48.4 0-45.2 49.2-60 103.8-72.4 11.4-2.6 21.2-4.8 29.2-7.4 11-3.6 19-8.4 27-13.8v71.4zM800 715.6c0 31-13.2 53.8-38.8 68.6-20.8 11.8-46.2 15.8-61.8 15.8 0 0 0 0 0 0-2.6 0-4.2 0.2-4.8 0-9.2-1-55.2-8.4-55.2-62.4 0-45.2 49.2-60 103.8-72.4 11.4-2.6 21.4-4.8 29.4-7.4 11-3.6 19.2-8.4 27.2-13.8v71.6zM800 261.8l-384 76v-132l384-74.4v130.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-musical-notes-outline"
    ]
  },
  {
    "paths": [
      "M812.6 96.4c-9.4 1.8-404 78.4-412.4 80s-16.2 7.2-16.2 16c0 0 0 477 0 480.2s-0.2 14.4-4.8 23.4c-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29.2-128.8 103.6 0 62.2 44.8 90.2 83.4 95 4.2 0.6 9 1.4 14.2 1.4 0 0 0 0 0 0 13.4 0 48-2.6 78.4-22.4 22-14.4 48.2-42.8 48.2-95.6v-438l384-78c0 0 0 273.2 0 281.4s-0.4 17.8-5 26.8c-6.2 11.8-17 20.4-32.4 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.4 0 67.4 52.6 91.2 83.6 94.6 2.4 0.2 5.2 0.2 8.2 0.2 0 0 0 0 0 0 20.4 0 51.4-5 77.6-20 35.8-20.6 55-53.6 55-96.4v-604.2c-0.2-8.8-7.6-17.8-19.6-15.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-musical-notes"
    ]
  },
  {
    "paths": [
      "M720 512h32v96h-32v-96z",
      "M256 576v-32h234l-32-32h-234v96h330l-32-32z",
      "M600 544h72v26h-46l38 38h40v-96h-136z",
      "M768 512h32v96h-32v-96z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM512 896c-51.8 0-102.2-10.2-149.4-30.2-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c17.2-40.8 41.2-78 71.2-110.6l542.6 542.6c-32.6 30-69.6 54-110.6 71.2-47.2 20-97.6 30.2-149.4 30.2zM794.6 772l-542.6-542.6c32.6-30 69.6-54 110.6-71.2 47.2-20 97.6-30.2 149.4-30.2s102.2 10.2 149.4 30.2c45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-17.2 40.8-41.2 78-71.2 110.6z",
      "M720.4 425.4c-17.6-8.2-44.2-9.4-91.4-9.4-2.4 0-4.8 0-7.2 0-25.4 0.2-31.8-2.2-40-14.2-5.6-8.4-2-29.6 7.4-43.8 3.2-4.8 3.6-11.2 0.8-16.4s-8.2-8.4-14-8.6c-0.2 0-18.8-0.2-36.6-7.8-21.2-9-31.2-24.2-31.2-46.2 0-51.6 33.8-55 35.8-55 8.8 0 16-7.2 16-16s-7.2-16-16-16c-24 0-67.8 21.6-67.8 87 0 35 18 62 51.4 76 8.4 3.4 16.8 5.8 24 7.2-6.6 19.6-7.2 43.8 3.4 59.4 18 26.6 40.6 26.2 66.6 26.2 2.2 0 4.6 0 7 0 52.6 0 69.4 2.4 78 6.4 11.4 5.2 13.4 15 13.4 31.4 0 1.4 0 0.2 0 2.2h32c0 0 0-1 0-2.2 0-14 0.4-45.4-31.6-60.2z",
      "M800 488c0-52-6-78.4-18.2-99-17.2-29-44.8-37-77.8-37h-34.8c5.8-16.6 10.8-47.6 7-69.8-6.4-37.6-30.8-58.2-68.2-58.2-8.8 0-16 7.2-16 16s7.2 16 16 16c32 0 34.2 16.4 36.8 31.6 5 29-13.6 72.2-13.8 72.6-2.8 5-2.6 11 0.2 15.8s8.2 8 13.8 8h59c21.8 0 38.8 1.8 50.2 21.2 6.2 10.6 13.8 26.8 13.8 82.8h32z",
      "M800 488v0 0c0-0.2 0 0 0 0z"
    ],
    "grid": 0,
    "tags": [
      "ios-no-smoking-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM608 224c37.4 0 61.8 20.6 68.2 58.2 3.8 22.2-1.2 53.2-7 69.8h34.8c33 0 60.6 8.2 77.8 36.8 12.2 20.8 18.2 47.2 18.2 99.2h-32c0-56-7.6-72.2-13.8-82.8-11.4-19.4-28.4-21.2-50.2-21.2h-59c-5.6 0-11-3.2-13.8-7.8-2.8-4.8-3-10.8-0.2-15.8 0.2-0.4 18.8-43.6 13.8-72.6-2.6-15.2-4.8-31.6-36.8-31.6-8.8 0-16-7.2-16-16s7.2-16.2 16-16.2zM544 192c8.8 0 16 7.2 16 16s-7.2 16-16 16c-2 0-35.8 3.4-35.8 55 0 22 10 37.2 31.2 46.2 17.8 7.6 36.4 7.8 36.6 7.8 5.8 0.2 11.2 3.4 14 8.6s2.4 11.6-0.8 16.4c-9.4 14.2-13 35.4-7.4 43.8 8.2 12 14.6 14.4 40 14.2 2.4 0 4.8 0 7.2 0 47.2 0 73.8 1.2 91.4 9.4 32 14.8 31.6 46.2 31.6 60.4 0 1.2 0 2.2 0 2.2h-32c0-2 0-0.8 0-2.2 0-16.4-2-26-13.4-31.4-8.6-4-25.4-6.4-78-6.4-2.4 0-4.8 0-7 0-26 0-48.6 0.4-66.6-26.2-10.6-15.6-10-40-3.4-59.6-7.2-1.4-15.6-3.8-24-7.2-33.4-14-51.4-41-51.4-76-0-65.4 43.8-87 67.8-87zM752 512v96h-32v-96h32zM704 512v96h-40l-96-96h136zM224 608v-96h234l96 96h-330zM783.6 783.6c-3.8 3.8-7.6 7.4-11.6 11l-542.6-542.6c3.6-4 7.2-7.8 11-11.6s7.6-7.4 11.6-11l542.6 542.6c-3.6 3.8-7.2 7.8-11 11.6zM800 608h-32v-96h32v96zM800 488c0 0 0-0.2 0 0v0 0z",
      "M800 488v0 0c0-0.2 0 0 0 0z"
    ],
    "grid": 0,
    "tags": [
      "ios-no-smoking"
    ]
  },
  {
    "paths": [
      "M576 800c0 36-28.8 64-64 64s-64.4-28-64.4-64h-32c0 54 43.2 96 96.2 96s96.2-42 96.2-96h-32z",
      "M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z",
      "M472.6 208.4c33.6-4.2 44.4-4.8 79.4 0 41.6 5.8 83.2 28 110.4 60.8 35.4 42.8 53.4 106.4 53.4 189.2 0 102.8 8.8 169.8 28.4 217.4 10.4 25.2 23.4 44 38 60h-83l18.8 32h146c-70.8-64-116.2-78-116.2-309.8 0-198.2-98-265.8-189.8-281.2 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-26.2 4.4-53 13.2-77.8 28l16 27.4c20.4-12.4 43.8-21 68-24z",
      "M242.2 736c14.4-16 27.4-34.6 37.8-59.8 19.6-47.6 28.2-114.6 28.2-217.6 0-60.4 9.6-110.8 28.8-150.2l-19-32.4c-25.6 42.8-41.8 101.8-41.8 182.4 0 231.8-45 245.6-116.2 309.6h445.8l-18.8-32h-344.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-notifications-off-outline"
    ]
  },
  {
    "paths": [
      "M415.6 800c0 54 43.2 96 96.2 96s96.2-42 96.2-96h-192.4z",
      "M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z",
      "M747.8 458c0-198.2-98-265.8-189.8-281.2 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-26.2 4.4-53 13.2-77.8 28l329.4 562.8h146c-70.8-64-116.2-78-116.2-309.8z",
      "M276.2 458.4c0 231.8-45 245.6-116.2 309.6h445.8l-287.8-492c-25.6 42.8-41.8 101.8-41.8 182.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-notifications-off"
    ]
  },
  {
    "paths": [
      "M576 800c0 34-28.8 64-64 64s-64.4-30-64.4-64h-32c0 52 43.2 95.8 96.2 95.8s96.2-43.8 96.2-95.8h-32z",
      "M747.8 458.4c0-198-98-265.6-189.8-281 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-91.8 15.6-189.8 83.8-189.8 281.4-0.4 231-45.4 245-116.6 309h704c-70.8-64-116.2-78.2-116.2-309.6zM242.2 736c14.4-16 27.4-34.8 37.8-60 19.6-47.4 28.2-114.6 28.2-217.4 0-82.6 18-146.2 53.6-189 27.2-32.8 67.4-55.4 110.8-61 33.6-4.2 44.4-4.8 79.4 0 41.6 5.8 83.2 28 110.4 60.8 35.4 42.8 53.4 106.4 53.4 189 0 102.8 8.8 169.8 28.4 217.4 10.4 25.2 23.4 44.2 38 60.2h-540z"
    ],
    "grid": 0,
    "tags": [
      "ios-notifications-outline"
    ]
  },
  {
    "paths": [
      "M415.6 800c0 52 43.2 95.8 96.2 95.8s96.2-43.8 96.2-95.8h-192.4z",
      "M747.8 458.4c0-198-98-265.6-189.8-281 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-91.8 15.6-189.8 83.8-189.8 281.4-0.4 231-45.4 245-116.6 309h704c-70.8-64-116.2-78.2-116.2-309.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-notifications"
    ]
  },
  {
    "paths": [
      "M640 544c0-47.6-26.2-89.4-65-111.4l162.4-275.8c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l159.2 277.8c-36.6 22.6-61 63-61 109h-320c0 166.6 93.8 306.8 228.8 384l156.2-272.6c18.6 10.6 40.2 16.6 63 16.6s44.2-6 62.6-16.4l156.6 272.4c135-77.2 228.8-217.4 228.8-384h-320zM330 169.8c56.4-27.4 118.8-41.8 182-41.8 62.8 0 124.8 14.2 180.8 41.4l-147.8 251c-10.6-2.8-21.6-4.4-33-4.4-13.2 0-26 2-38 5.8l-144-252zM281.4 883.4c-51.6-34.6-94.8-79.2-126.4-130.6-33-53.6-52.6-114.2-57.8-176.8h290.8c6 23.2 18.4 43.8 35 60l-141.6 247.4zM416 544c0-34.2 18-64.2 44.8-81.2v0c0.8-0.6 1.6-1 2.4-1.6 14.2-8.4 31-13.2 48.6-13.2 53 0 96 43 96 96s-43 96-96 96-95.8-43-95.8-96zM742.4 883.4l-142.2-247c17-16.2 29.6-37 35.6-60.4h290.8c-5 62.6-24.8 123.2-57.8 176.8-31.4 51.4-74.8 96-126.4 130.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-nuclear-outline"
    ]
  },
  {
    "paths": [
      "M608 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
      "M960 544h-320c0 47.8-26.2 89.4-65.2 111.4l156.4 272.6c135-77.2 228.8-217.4 228.8-384z",
      "M512 416c23.4 0 45.4 6.4 64.2 17.4l161.2-276.6c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l159.6 277.6c19.4-12 42.2-18.8 66.6-18.8z",
      "M384 544h-320c0 166.6 93.8 306.8 228.8 384l156.4-272.6c-39-22-65.2-63.6-65.2-111.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-nuclear"
    ]
  },
  {
    "paths": [
      "M800 864h-640v-640h352v-32h-384v704h704v-384h-32z",
      "M640 128v32h200l-392 393.8 22.2 22.2 393.8-392v200h32v-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-open-outline"
    ]
  },
  {
    "paths": [
      "M640 128v32h200l-392 393.8 22.2 22.2 393.8-392v200h32v-256z",
      "M470.2 621.6l-67.8-67.6 359.6-362h-634v704h704v-634z"
    ],
    "grid": 0,
    "tags": [
      "ios-open"
    ]
  },
  {
    "paths": [
      "M704 208c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 176c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M704 752c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 720c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M320 480c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM320 448c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z",
      "M414.64 496h545.36v32h-545.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M224 512c0 5.454 0.48 10.792 1.36 16h-161.36v-32h161.36c-0.88 5.208-1.36 10.546-1.36 16z",
      "M798.64 768h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M608 784c0 5.454 0.48 10.792 1.36 16h-545.36v-32h545.36c-0.88 5.208-1.36 10.546-1.36 16z",
      "M798.64 224h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z",
      "M609.36 224c-0.878 5.208-1.36 10.546-1.36 16s0.48 10.792 1.36 16h-545.36v-32h545.36z"
    ],
    "grid": 0,
    "tags": [
      "ios-options-outline"
    ]
  },
  {
    "paths": [
      "M64 752h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z",
      "M64 480h182.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h566.7v64h-566.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-182.7z",
      "M64 208h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z"
    ],
    "grid": 0,
    "tags": [
      "ios-options"
    ]
  },
  {
    "paths": [
      "M742.8 128h-461.6c-130.2 78-217.2 221-217.2 384s87 304 217.2 384h461.8c130-80 217-221 217-384s-87-306-217.2-384zM733.6 864h-443.2c-57.4-38-105.2-87.4-139-145.4-36.2-62.6-55.4-134.6-55.4-207.4 0-73 19.2-144.6 55.4-207.4 34-58.6 81.8-109.8 138.8-143.8h443.6c61.6 40 104.8 85 138.6 143.6 36.4 63 55.4 134.6 55.4 207.6 0 72.8-19.2 144.8-55.4 207.4-33.6 58.2-81.4 107.4-138.8 145.4z",
      "M640 320h64v192h-64v-192z",
      "M320 288h64v256h-64v-256z",
      "M512 640v0c-35.2 0-64 28.8-64 64v96h128v-96c0-35.2-28.8-64-64-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-outlet-outline"
    ]
  },
  {
    "paths": [
      "M742.8 128h-461.6c-130.2 78-217.2 221-217.2 384s87 304 217.2 384h461.8c130-80 217-221 217-384s-87-306-217.2-384zM384 544h-64v-256h64v256zM576 800h-128v-96c0-35.2 28.8-64 64-64s64 28.8 64 64v96zM704 512h-64v-192h64v192z"
    ],
    "grid": 0,
    "tags": [
      "ios-outlet"
    ]
  },
  {
    "paths": [
      "M224 96v736h32v-704h608v738.2c0 16.4-13.4 29.8-29.8 29.8h-644.4c-16.4 0-29.8-13.4-29.8-29.8v-610.2h32v-32h-64v642.2c0 34 27.6 61.8 61.8 61.8h644.6c34 0 61.8-27.6 61.8-61.8v-770.2h-672.2z",
      "M320 224h256v32h-256v-32z",
      "M320 384h480v32h-480v-32z",
      "M320 544h384v32h-384v-32z",
      "M320 704h480v32h-480v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-paper-outline"
    ]
  },
  {
    "paths": [
      "M96 541.8l239.8 103.2 59.6 275 115-161.8 233.6 169.8 184-832-832 445.8zM829.8 184.8l-486.2 428.6-174-74.8 660.2-353.8zM367 638l-0.4-2.2 336.2-304.4-300.6 349.6 0.8 0.6h-1l-3.2 103.2-31.8-146.8zM429.8 816.4l3.6-113.4 51.4 36.4-0.2 0.2-54.8 76.8zM724.2 869.6l-274.2-194.6 429.8-509-155.6 703.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-paper-plane-outline"
    ]
  },
  {
    "paths": [
      "M928 96l-832 445.8 221 95 595.2-524.4-482.8 586.6-2.2 174.8 83.2-115.8 233.6 170z",
      "M339.2 660.6l56.2 259.4h0.8v-1l5.8-237.4 300.6-350.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-paper-plane"
    ]
  },
  {
    "paths": [
      "M224 96v736h-32v-608h-64v642.2c0 34 27.6 61.8 61.8 61.8h644.6c34 0 61.8-27.6 61.8-61.8v-770.2h-672.2zM320 224h256v32h-256v-32zM320 544h384v32h-384v-32zM800 736h-480v-32h480v32zM800 416h-480v-32h480v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-paper"
    ]
  },
  {
    "paths": [
      "M320 128h32v108h-32v-108z",
      "M32 416h110v32h-110v-32z",
      "M119 234.8l22-22.2 62.8 63-22 22.2z",
      "M478.8 295.8l-22-22.2 62.6-63 22.2 22.2z",
      "M145 641.4l-22-22.2 62.8-63 22 22.2z",
      "M307.8 535.8c-52.6-10.4-92.4-56.8-92.4-112.4 0-63.2 51.4-114.6 114.6-114.6 36.6 0 69.2 17.2 90.2 44 9.4-5.4 19.2-10.2 29.4-14.2-26.6-37.4-70.2-61.8-119.6-61.8-81 0-146.6 65.6-146.6 146.6 0 73.6 54.2 134.6 125 145-0.6-6.6-1-13.4-1-20.2 0-4.2 0-8.2 0.4-12.4z",
      "M806.6 518.4c-1.6 0-3.2 0-4.8 0-6.2 0-12.2 0-18 0.8-22.6-100.6-112.2-176.4-219.4-176.4-29.2 0-57.2 5.6-82.8 15.8-10.2 4-20 8.8-29.4 14.2-64 37-108.2 104.8-112.4 183.2-0.2 4.2-0.4 8.2-0.4 12.4 0 6.8 0.4 13.6 1 20.2 0 0.8 0.2 1.6 0.2 2.2-75.8 6.8-135.2 74.2-135.2 152 0 82.2 66.6 153.4 148.6 153.4h452.8c102.4 0 185.4-86.8 185.4-189.6-0.2-102.8-83.2-188.2-185.6-188.2zM914.8 817.4c-29.2 30-67.6 46.6-108.2 46.6h-452.8c-63.2 0-116.6-55.8-116.6-121.4 0-29.8 11-58.8 31.2-81.4 19.8-22.4 46.6-36.2 75-38.6l32.2-2.8-3-30.2-0.2-2c-0.6-6.4-1-13-1-19.4 0-3.6 0.2-7.2 0.2-10.6 3.6-67.2 41.6-125.4 96.6-157.2 9.2-5.4 19-10 29-13.6 20.8-7.8 43.4-12 67-12 44.6 0 86.4 15 121.2 43.2 33.8 27.6 57.4 66 67 108.2l6.4 28.4 28.8-3.6c4.2-0.6 9.4-0.6 14.2-0.6h5c40.8 0 79.2 16.4 108.4 45.8 29.2 29.6 45.2 68.8 45.2 110-0.4 41.6-16.4 81.2-45.6 111.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-partly-sunny-outline"
    ]
  },
  {
    "paths": [
      "M320 128h32v108h-32v-108z",
      "M32 416h110v32h-110v-32z",
      "M119 234.8l22-22.2 62.8 63-22 22.2z",
      "M478.8 295.8l-22-22.2 62.6-63 22.2 22.2z",
      "M145 641.4l-22-22.2 62.8-63 22 22.2z",
      "M330 276.6c-81 0-146.6 65.6-146.6 146.6 0 73.6 54.2 134.6 125 145 0 0-2.4-85.8 37.8-145.8s103.6-84 103.6-84c-26.8-37.4-70.4-61.8-119.8-61.8z",
      "M806.6 518.4c-1.6 0-3.2 0-4.8 0-6.2 0-12.2 0-18 0.8-22.6-100.6-112.2-176.4-219.4-176.4-29.2 0-57.2 5.6-82.8 15.8-10.2 4-20 8.8-29.4 14.2-64 37-108.2 104.8-112.4 183.2-0.2 4.2-0.4 8.2-0.4 12.4 0 6.8 0.4 13.6 1 20.2 0 0.8 0.2 1.6 0.2 2.2-75.8 6.8-135.2 74.2-135.2 152 0 82.2 66.6 153.4 148.6 153.4h452.8c102.4 0 185.4-86.8 185.4-189.6-0.2-102.8-83.2-188.2-185.6-188.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-partly-sunny"
    ]
  },
  {
    "paths": [
      "M648.6 160.6c-2.4-0.4-4.8-0.6-7.2-0.6v0.2c-0.2 0-0.4 0-0.8 0-44 0-85.8 51.8-95.6 120.6-10.6 73.2 18.8 138 65.4 144.8 2.6 0.4 5.4 0.6 8 0.6 44 0 85.8-51.8 95.6-120.6 10.6-73.4-18.8-138.2-65.4-145zM682.6 300.8c-8 55.8-39.8 93.2-64.2 93.2-1.2 0-2.4 0-3.4-0.2-11.4-1.6-22.2-12.2-29.8-29-9.8-21.6-13-50.4-8.8-79.4 8-55.4 39.6-92.6 64-93.2 1.2 0 3.2 0.2 4 0.2 11.4 1.6 22 12.2 29.6 29 9.8 21.4 12.8 50.4 8.6 79.4z",
      "M641.2 160v0 0z",
      "M884.6 338.8c-7-2.8-14.2-4.2-21.8-4.2-0.2 0-0.6 0-0.8 0v0 0c-39.4 0.6-83.6 38.4-106.8 95.6-27.8 68.4-15 138.4 28.8 156.4 7 2.8 14.2 4.2 21.8 4.2 39.6 0 84.4-38 107.8-95.6 27.6-68.4 14.6-138.4-29-156.4zM883.8 483c-9.4 23-23.2 43.4-39.2 57.4-13.4 11.6-27.6 18.4-39 18.4-3.6 0-6.8-0.6-9.8-1.8-10.6-4.4-18.6-17.2-22-35.4-4.2-23.2-0.4-52.2 10.6-79.2 9.4-23 23.4-43.4 39.2-57.4 13.2-11.6 27-18.2 38.4-18.4 3.8 0 7 0.6 10 1.8 10.6 4.4 18.8 17.2 22.2 35.4 4.4 23.4 0.6 52.2-10.4 79.2z",
      "M655.2 590.8c-55.6-87.2-79.6-120-143.2-120s-87.8 33-143.4 120c-47.6 74.4-143.8 80.6-167.8 143.8-4.8 11.2-7.2 23.4-7.2 36.4 0 51.4 41.6 93 92.8 93 63.6 0 150.2-48 225.8-48s161.8 48 225.4 48c51.2 0 92.6-41.6 92.6-93 0-13-2.6-25.2-7.4-36.4-24-63.4-120-69.4-167.6-143.8zM737.6 832c-25.6 0-58.8-10.2-94-21-43-13.2-87.4-27-131.6-27s-88.6 13.6-131.6 26.8c-35.2 10.8-68.4 21-94 21-33.6 0-61-27.4-61-61 0-8.6 1.6-16.6 4.6-23.8l0.4-1.2c8-21.2 32-34.8 62.2-52 35.2-20 75-42.6 102.8-86 55.4-86.8 71.6-105.4 116.6-105.4 23.6 0 38 5.2 53.2 19 18 16.6 37.6 46.2 63.2 86.4 27.8 43.4 67.4 66 102.6 86 30.2 17.2 54 30.8 62.2 52l0.4 1.2c3.2 7.6 4.8 15.6 4.8 23.8-0 33.8-27.2 61.2-60.8 61.2z",
      "M405.6 426c2.6 0 5.4-0.2 8-0.6 46.8-6.8 76-71.6 65.4-144.8-10-69-51.8-120.6-95.6-120.6-2.6 0-5.4 0.2-8 0.6-46.8 6.8-76 71.6-65.4 144.8 10 68.8 51.8 120.6 95.6 120.6zM350.2 221.2c7.6-16.8 18.4-27.4 29.8-29 1.2-0.2 2.2-0.2 3.4-0.2 24.6 0 56.2 37.4 64.2 93.2 4.2 29 1 58-8.8 79.4-7.6 16.8-18.4 27.4-29.8 29-1.2 0.2-2.2 0.2-3.4 0.2-24.6 0-56.2-37.4-64.2-93.2-4.2-28.8-1-57.8 8.8-79.4z",
      "M240.2 586.6c43.8-18 56.6-88 28.8-156.4-23.4-57.6-68.2-95.6-107.8-95.6-7.6 0-14.8 1.4-21.8 4.2-43.8 18-56.6 88-28.8 156.4 23.4 57.6 68.2 95.6 107.8 95.6 7.6-0 14.8-1.4 21.8-4.2zM140.2 483c-11-27-14.8-56-10.6-79.2 3.4-18.2 11.4-31.2 22-35.4 3-1.2 6.2-1.8 9.8-1.8 11.6 0 25.8 6.6 39 18.4 16 14 29.8 34.4 39.2 57.4 22 54 12.2 105-11.4 114.6-3 1.2-6.2 1.8-9.8 1.8-11.6 0-25.8-6.6-39-18.4-16-14-30-34.4-39.2-57.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-paw-outline"
    ]
  },
  {
    "paths": [
      "M648.6 160.6c-2.4-0.4-4.8-0.6-7.2-0.6v0.2c-0.2 0-0.4 0-0.8 0-44 0-85.8 51.8-95.6 120.6-10.6 73.2 18.8 138 65.4 144.8 2.6 0.4 5.4 0.6 8 0.6 44 0 85.8-51.8 95.6-120.6 10.6-73.4-18.8-138.2-65.4-145z",
      "M641.2 160v0 0z",
      "M884.6 338.8c-7-2.8-14.2-4.2-21.8-4.2-0.2 0-0.6 0-0.8 0v0 0c-39.4 0.6-83.6 38.4-106.8 95.6-27.8 68.4-15 138.4 28.8 156.4 7 2.8 14.2 4.2 21.8 4.2 39.6 0 84.4-38 107.8-95.6 27.6-68.4 14.6-138.4-29-156.4z",
      "M655.2 590.8c-55.6-87.2-79.6-120-143.2-120s-87.8 33-143.4 120c-47.6 74.4-143.8 80.6-167.8 143.8-4.8 11.2-7.2 23.4-7.2 36.4 0 51.4 41.6 93 92.8 93 63.6 0 150.2-48 225.8-48s161.8 48 225.4 48c51.2 0 92.6-41.6 92.6-93 0-13-2.6-25.2-7.4-36.4-24-63.4-120-69.4-167.6-143.8z",
      "M405.6 426c2.6 0 5.4-0.2 8-0.6 46.8-6.8 76-71.6 65.4-144.8-10-69-51.8-120.6-95.6-120.6-2.6 0-5.4 0.2-8 0.6-46.8 6.8-76 71.6-65.4 144.8 10 68.8 51.8 120.6 95.6 120.6z",
      "M240.2 586.6c43.8-18 56.6-88 28.8-156.4-23.4-57.6-68.2-95.6-107.8-95.6-7.6 0-14.8 1.4-21.8 4.2-43.8 18-56.6 88-28.8 156.4 23.4 57.6 68.2 95.6 107.8 95.6 7.6-0 14.8-1.4 21.8-4.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-paw"
    ]
  },
  {
    "paths": [
      "M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z",
      "M404.8 403.4c0 0 0 0 0 0v0z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6 0 0 0 0 0 0-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4 0 0 0 0 0 0 0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2h-274.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-person-add-outline"
    ]
  },
  {
    "paths": [
      "M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-person-add"
    ]
  },
  {
    "paths": [
      "M64 352.6v317c0 36.6 29.2 66.2 65.8 66.2h762c36.8 0 68.2-29.6 68.2-66.2v-317c0-36.6-31.4-64.6-68.2-64.6h-762c-36.6 0-65.8 28-65.8 64.6zM110 542v-60c0-4.4 3.6-8 8-8s8 3.6 8 8v60c0 4.4-3.6 8-8 8s-8-3.6-8-8zM938 511c0 19.2-15.6 34.8-34.8 34.8s-34.8-15.6-34.8-34.8c0-19.2 15.6-34.8 34.8-34.8s34.8 15.6 34.8 34.8zM848 320v384h-682v-384h682z",
      "M883.2 511c0 11 9 20 19.8 20 11 0 20-9 20-20s-9-20-20-20c-10.8 0.2-19.8 9-19.8 20z"
    ],
    "grid": 0,
    "tags": [
      "ios-phone-landscape"
    ]
  },
  {
    "paths": [
      "M671.4 64h-317.2c-36.6 0-66.2 29.2-66.2 65.8v762c0 36.8 29.6 68.2 66.2 68.2h317c36.6 0 64.6-31.4 64.6-68.2v-762c0.2-36.6-27.8-65.8-64.4-65.8zM482 110h60c4.4 0 8 3.6 8 8s-3.6 8-8 8h-60c-4.4 0-8-3.6-8-8s3.6-8 8-8zM513 938c-19.2 0-34.8-15.6-34.8-34.8s15.6-34.8 34.8-34.8c19.2 0 34.8 15.6 34.8 34.8s-15.6 34.8-34.8 34.8zM704 848h-384v-682h384v682z",
      "M513 883.2c-11 0-20 9-20 19.8 0 11 9 20 20 20s20-9 20-20c-0.2-10.8-9-19.8-20-19.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-phone-portrait"
    ]
  },
  {
    "paths": [
      "M512 128c141.2 0 256 105.6 256 235.4 0 79-48 197.4-138.8 342.8-44.8 71.8-90.2 134-117.2 169.6-27-35.6-72-97.4-116.8-169-91-145.6-139.2-264.4-139.2-343.4 0-129.8 114.8-235.4 256-235.4zM512 96c-159 0-288 119.8-288 267.4 0 208 288 564.6 288 564.6s288-356.6 288-564.6c0-147.6-129-267.4-288-267.4v0z",
      "M512 256c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128-57.4-128-128-128zM512 477.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-pin-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-159 0-288 119.8-288 267.4 0 208 288 564.6 288 564.6s288-356.6 288-564.6c0-147.6-129-267.4-288-267.4zM512 477.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-pin"
    ]
  },
  {
    "paths": [
      "M736 350.4c0-39-2-163.4-38.6-231.2-9-16.4-25-23.2-63.4-23.2h-244c-38.6 0-54.4 6.8-63.4 23.2-36.6 67.8-38.6 193-38.6 232 0 182 64 186.2 64 335.6 0 73.4-32 133.4-32 185.4 0 50.2 18 55.6 64 55.6h256c46 0 64-5.8 64-55.8 0-52-32-111.4-32-184.8 0-149.4 64-154.8 64-336.8zM354.8 134c1-1.8 1.4-2 4-3 4-1.6 12.8-3 31.2-3h244c18.2 0 27 1.4 31.2 3 2.8 1 3.2 1.4 4.2 3.2 14.2 26.2 24.4 67.6 30 119.8h-374.6c5.6-52.2 15.8-94 30-120zM669.6 893.2c-2.8 1.2-10.4 2.8-29.6 2.8h-256c-19.2 0-26.8-1.6-29.8-2.8-0.8-1.8-2.2-7.6-2.2-21 0-19.6 6-42.4 12.8-68.6 9-34 19.2-72.6 19.2-116.6 0-77-16.2-119.6-31.8-160.8-16.6-43.8-32.2-85.4-32.2-175 0-22.8 0.8-44.6 2-65h380c1.4 20.4 2 42 2 64.4 0 89.6-15.6 131.4-32.4 175.6-15.6 41.4-31.6 84.2-31.6 161.2 0 44 10.2 82.4 19.2 116.2 7 26.2 12.8 49 12.8 68.6 0 13.4-1.6 19.2-2.4 21z"
    ],
    "grid": 0,
    "tags": [
      "ios-pint-outline"
    ]
  },
  {
    "paths": [
      "M736 350.4c0-39-2-163.4-38.6-231.2-9-16.4-25-23.2-63.4-23.2h-244c-38.6 0-54.4 6.8-63.4 23.2-36.6 67.8-38.6 193-38.6 232 0 182 64 186.2 64 335.6 0 73.4-32 133.4-32 185.4 0 50.2 18 55.6 64 55.6h256c46 0 64-5.8 64-55.8 0-52-32-111.4-32-184.8 0-149.4 64-154.8 64-336.8zM354.8 134c1-1.8 1.4-2 4-3 4-1.6 12.8-3 31.2-3h244c18.2 0 27 1.4 31.2 3 2.8 1 3.2 1.4 4.2 3.2 14.2 26.2 24.4 67.6 30 119.8h-374.6c5.6-52.2 15.8-94 30-120z"
    ],
    "grid": 0,
    "tags": [
      "ios-pint"
    ]
  },
  {
    "paths": [
      "M836.6 183c-60.2-27-152-55-323.2-55-170.8 0-260 24.6-323 54.8-55 26.2-38.2 48-26.2 73.2 8 17.2 16.4 23.6 29 23.6 1 0 2 0 2.8-0.2l317.4 616.6 316.6-615c0.6 0 1.2 0 1.8 0 13 0 22-6.8 31-25.2 12.2-24.8 19.6-52.4-26.2-72.8zM266.6 347.8c18-7.8 38-8.8 56.8-2.4 20 6.8 36.4 21.2 45.8 40.2 9.4 19.2 10.8 40.8 4.2 61-6 18-17.8 33-33.8 42.6-26.8-51.6-52.2-101-73-141.4zM593.6 660.8c-43.8 0-79.4-35.8-79.4-80s35.6-80 79.4-80c28 0 53.4 14.6 67.8 38.4l-62.4 121.4c-1.8 0.2-3.6 0.2-5.4 0.2zM677.6 507.6c-20.8-24.4-51.2-38.6-84-38.6-61.2 0-111.2 50.2-111.2 112 0 58 44 105.8 100.2 111.4l-69.2 134.8c-28.6-55.4-95.8-186-159.2-309 23.2-13.6 40.6-35 49.2-61 9.4-28.4 7.4-58.8-5.8-85.6-26.6-54.2-91.4-77-145.6-52.2-10-19.4-18.4-35.8-24.6-47.8 45.8-15.4 126.6-47.6 285.8-47.6 1 0 1.8 0 2.8 0-1.4 54.6 38 103.2 93 111.4 5.4 0.8 10.8 1.2 16.2 1.2 23.2 0 45.8-7.4 64.8-21.6 21.2-15.8 35.6-38.2 41.2-63.8 28.6 8 50.2 16.4 67 22.2l-120.6 234.2zM548 224.6c63.8 2 113.6 9.6 152.6 18.6-4 18.4-14.2 34.6-29.4 46-16.6 12.4-36.8 17.6-57.2 14.6s-38.4-13.8-50.6-30.6c-10.8-14.2-16-31.2-15.4-48.6zM834.2 241.8c-1.8 3.8-3.2 6-4.2 7.2-6.6-0.8-19.6-5.4-33.4-10.2-49.2-17.6-131.4-46.8-283.2-46.8-152.6 0-235.6 28.6-285.2 45.6-13.2 4.6-25.8 8.8-32.6 9.8-0.6-1.2-1.6-2.8-2.8-5.2s-2.2-4.8-3.4-7c-1.8-3.6-4.2-8.4-5.2-11.6 2.2-2 7.4-6.4 19.6-12.2 50.4-24 131.2-51.6 309.4-51.6 173.4 0 260.2 29.8 310.4 52.2 14.4 6.4 16.4 11.2 16.4 11.2 0.2 0.6 1.2 4.2-5.8 18.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-pizza-outline"
    ]
  },
  {
    "paths": [
      "M836.6 183c-60.2-27-152-55-323.2-55-170.8 0-260 24.6-323 54.8-55 26.2-38.2 48-26.2 73.2 8 17.2 16.4 23.6 29 23.6 1 0 2 0 2.8-0.2l317.4 616.6 316.6-615c0.6 0 1.2 0 1.8 0 13 0 22-6.8 31-25.2 12.2-24.8 19.6-52.4-26.2-72.8zM266.6 347.8c18-7.8 38-8.8 56.8-2.4 20 6.8 36.4 21.2 45.8 40.2 9.4 19.2 10.8 40.8 4.2 61-6 18-17.8 33-33.8 42.6-26.8-51.6-52.2-101-73-141.4zM593.6 660.8c-43.8 0-79.4-35.8-79.4-80s35.6-80 79.4-80c28 0 53.4 14.6 67.8 38.4l-62.4 121.4c-1.8 0.2-3.6 0.2-5.4 0.2zM548 224.6c63.8 2 113.6 9.6 152.6 18.6-4 18.4-14.2 34.6-29.4 46-16.6 12.4-36.8 17.6-57.2 14.6s-38.4-13.8-50.6-30.6c-10.8-14.2-16-31.2-15.4-48.6zM834.2 241.8c-1.8 3.8-3.2 6-4.2 7.2-6.6-0.8-19.6-5.4-33.4-10.2-49.2-17.6-131.4-46.8-283.2-46.8-152.6 0-235.6 28.6-285.2 45.6-13.2 4.6-25.8 8.8-32.6 9.8-0.6-1.2-1.6-2.8-2.8-5.2s-2.2-4.8-3.4-7c-1.8-3.6-4.2-8.4-5.2-11.6 2.2-2 7.4-6.4 19.6-12.2 50.4-24 131.2-51.6 309.4-51.6 173.4 0 260.2 29.8 310.4 52.2 14.4 6.4 16.4 11.2 16.4 11.2 0.2 0.6 1.2 4.2-5.8 18.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-pizza"
    ]
  },
  {
    "paths": [
      "M430.4 176l187 292.2 9.8 15 18.2-0.6 136.4-4c6.4-0.4 12.4-0.4 18.4-0.4 34.4 0 67.4 4.8 93 13.4 21.2 7.2 30.8 14.8 34.2 18.6-3.2 3.8-13 11.4-34.2 18.6-25.6 8.6-58.6 13.4-93 13.4-5.6 0-12.2 0-18.4-0.4h-0.8l-153.6-3.6-9.8 15.8-187.2 294h-32.2l101.8-270 15.6-41.8-44.4-2-268.6-10.8-10.2 13.4-80 103.2h-1.2l46.4-116.6 4.8-12.2-4.8-11.6-46.4-115.6h1.2l78.8 99.6 10 12.4 16.2-0.6 298.4-9.8-15.8-41.4-101.6-268.2h31.6zM448 144h-96l118 311.4-253.6 8.6-88.4-112h-64l64 160-64 160h64l89.8-115.4 252.2 10.4-118 313h96l196.4-309 135.6 3c6.6 0.4 13.2 0.2 20 0.2 88.4 0 160-28.8 160-64.2s-71.6-64-160-64c-6.8 0-13.4 0.2-20 0.4l-135.6 4.4-196.4-306.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-plane-outline"
    ]
  },
  {
    "paths": [
      "M448 144h-96l118 311.4-253.6 8.6-88.4-112h-64l64 160-64 160h64l89.8-115.4 252.2 10.4-118 313h96l196.4-309 135.6 3c6.6 0.4 13.2 0.2 20 0.2 88.4 0 160-28.8 160-64.2s-71.6-64-160-64c-6.8 0-13.4 0.2-20 0.4l-135.6 4.4-196.4-306.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-plane"
    ]
  },
  {
    "paths": [
      "M792.4 577.8c-2.2 9-4.6 18-7.8 26.8 11.6 9 22.8 17.8 33.6 26.6 72 58.2 118 114.4 106.4 114.4-15.8 1-55.2-2.2-142.2-34.2-24.4-9-50.4-19.4-77.6-31.2 39.4-45 63.2-104 63.2-168.4 0-141.4-114.6-256-256-256-114 0-210.4 74.4-243.6 177.2-24-17.2-46.4-34.2-66.6-50.4-72-58.2-95.2-90.4-102.4-104.4-8.6-14 65.2-1.8 152.2 30.2 13.6 5 27.8 10.4 42.2 16 5.6-6.6 11.6-13 17.8-19-131.8-55-228.4-75.4-245-45.8-18 31.8 61.6 113.4 193.6 206.8-2.6 14.8-4 29.8-4 45.4 0 141.4 114.6 256 256 256 64.6 0 123.6-23.8 168.6-63.4 148 65.2 259 91.4 277 59.6 16.4-29.4-50.6-101.4-165.4-186.2zM353.6 353.6c42.4-42.4 98.6-65.6 158.4-65.6s116 23.4 158.4 65.6c42.2 42.4 65.6 98.6 65.6 158.4 0 58.2-22 112.8-62 154.6-61.4-27.8-127.4-61.6-193.6-99-66-37.4-129-76.6-184.6-115 10.2-37 29.8-71 57.8-99zM512 736c-59.8 0-116-23.4-158.4-65.6-42.2-42.4-65.6-98.6-65.6-158.4 0-8.4 0.4-16.8 1.4-25 52.4 35.6 111.6 72.4 175.4 108.6s125.8 68 183.4 94.4c-39 29.8-86.4 46-136.2 46z"
    ],
    "grid": 0,
    "tags": [
      "ios-planet-outline"
    ]
  },
  {
    "paths": [
      "M792.4 577.8c-2.2 9-4.6 18-7.8 26.8 11.6 9 22.8 17.8 33.6 26.6 72 58.2 118 114.4 106.4 114.4-15.8 1-55.2-2.2-142.2-34.2-24.4-9-50.6-19.4-77.6-31.2 39.4-45 63.2-103.8 63.2-168.4 0-141.4-114.6-256-256-256-114 0-210.4 74.4-243.6 177.4-24-17.2-46.4-34.2-66.6-50.6-72-58.2-95.2-90.4-102.4-104.4-8.6-14 65.2-1.8 152.2 30.2 13.6 5 27.8 10.4 42.2 16 5.6-6.6 11.6-13 17.8-19-131.8-55-228.4-75.4-245-45.8-26.2 46.2 152.2 196.4 398.2 335.8 246 139.2 466.8 214.8 492.8 168.6 16.6-29.4-50.4-101.4-165.2-186.2z",
      "M256.2 504.6c0 2.4-0.2 4.8-0.2 7.4 0 141.4 114.6 256 256 256 51.6 0 99.6-15.2 139.8-41.4-65-28.8-132.8-59-207-101-67.6-38.4-134.2-83.4-188.6-121z"
    ],
    "grid": 0,
    "tags": [
      "ios-planet"
    ]
  },
  {
    "paths": [
      "M640 512v-320h-256v192h-256v448h768v-320h-256zM384 800h-224v-384h224v384zM608 800h-192v-576h192v576zM864 800h-224v-256h224v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-podium-outline"
    ]
  },
  {
    "paths": [
      "M128 384h224v448h-224v-448z",
      "M384 192v640h256v-640z",
      "M672 512h224v320h-224v-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-podium"
    ]
  },
  {
    "paths": [
      "M781.4 195.8c-6.8-5.8-16.8-5-22.6 1.8s-5 16.8 1.8 22.6c86 73.2 135.2 179.4 135.2 291.6 0.2 211.8-172 384.2-383.8 384.2s-384-172.4-384-384.2c0-112.2 49.2-218.4 135.2-291.6 6.8-5.8 7.6-15.8 1.8-22.6s-15.8-7.6-22.6-1.8c-93 79.2-146.4 194.4-146.4 316 0 229.4 186.6 416.2 416 416.2s416-186.8 416-416.2c0-121.6-53.4-236.8-146.6-316z",
      "M514 544c8.8 0 16-7.2 16-16v-416c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16z"
    ],
    "grid": 0,
    "tags": [
      "ios-power-outline"
    ]
  },
  {
    "paths": [
      "M781.4 199.4c-5.6-4.8-12.8-7.4-20.4-7.4-9.2 0-18 4-23.8 11-5.4 6.4-8 14.4-7.4 22.8s4.6 16 11 21.4c79 67 124.4 164.2 124.4 266.6 0 193.8-158.4 351.6-353.2 351.6s-353.2-157.8-353.2-351.6c0-102.6 45.4-199.8 124.4-266.6 6.4-5.4 10.4-13 11-21.4s-2-16.4-7.4-22.8c-6-7-14.6-11-23.8-11-7.4 0-14.6 2.6-20.4 7.4-93.2 78.8-146.6 193.4-146.6 314.4 0 228.4 186.6 414.2 416 414.2s416-185.8 416-414.2c0-121-53.4-235.6-146.6-314.4z",
      "M514 544c17.6 0 32-14.4 32-32v-384c0-17.6-14.4-32-32-32s-32 14.4-32 32v384c0 17.6 14.4 32 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-power"
    ]
  },
  {
    "paths": [
      "M768 320c35.2 0 64-28.8 64-64s-28.8-64-64-64-64 28.8-64 64 28.8 64 64 64zM768 224c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32z",
      "M896 128v261.4l-493.4 493.4-261.4-261.4 493.4-493.4h261.4zM928 96h-306.6l-525.4 525.4 306.6 306.6 525.4-525.4v-306.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-pricetag-outline"
    ]
  },
  {
    "paths": [
      "M800 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z",
      "M928 96h-306.6l-525.4 525.4 306.6 306.6 525.4-525.4v-306.6zM768 320c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64c0 35.2-28.8 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-pricetag"
    ]
  },
  {
    "paths": [
      "M865 224h-65v-96h-576v96h-63c-35.2 0-65 27.6-65 62.6v316.8c0 35 29.8 64.6 65 64.6h95v228h512v-228h97c35.2 0 63-29.6 63-64.6v-316.8c0-35-27.8-62.6-63-62.6zM256 160h512v64h-512v-64zM736 864h-448v-384h448v384zM896 603.4c0 17.4-13.4 32.6-31 32.6h-97v-188h-512v188h-95c-17.6 0-33-15.2-33-32.6v-316.8c0-17.4 15.4-30.6 33-30.6h704c17.6 0 31 13.2 31 30.6v316.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-print-outline"
    ]
  },
  {
    "paths": [
      "M256 448h512v448h-512v-448z",
      "M255 449h512v448h-512v-448z",
      "M223 129h576v64h-576v-64z",
      "M865 225h-704c-35.29 0-66 25.684-66 60.618v316.786c0 34.936 30.71 66.598 66 66.598h62v-252h576v252h66c35.29 0 62-31.662 62-66.598v-316.786c0-34.934-26.71-60.618-62-60.618z"
    ],
    "grid": 0,
    "tags": [
      "ios-print"
    ]
  },
  {
    "paths": [
      "M896 576c-30.536 0-56.058 21.39-62.446 50h-118.008l-60.362-181.792c-2.21-6.658-8.492-11.086-15.518-10.956-7.016 0.144-13.118 4.844-15.048 11.59l-108.484 378.638-116.35-698.11c-1.248-7.48-7.574-13.056-15.152-13.358-7.618-0.278-14.322 4.764-16.156 12.122l-124.98 501.866h-179.496v32h192c7.348 0 13.75-5.004 15.526-12.132l109.37-439.182 115.322 691.946c1.23 7.376 7.406 12.918 14.874 13.344 0.306 0.018 0.614 0.026 0.918 0.026 7.098 0 13.398-4.7 15.374-11.594l113.744-396.992 47.69 143.626c2.174 6.542 8.292 10.958 15.186 10.958h130.584c7.78 26.578 32.322 46 61.416 46 35.348 0 64-28.654 64-64s-28.656-64-64.004-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-pulse-outline"
    ]
  },
  {
    "paths": [
      "M896 546.002c-42.54 0-78.592 27.998-91.192 65.998h-77.714l-56.722-170.834c-4.352-13.106-16.606-21.912-30.366-21.912-0.224 0-0.448 0-0.67 0.008-14.032 0.29-26.234 9.688-30.098 23.176l-88.968 310.524-104.706-628.216c-2.494-14.96-14.898-28.746-31.564-28.746s-27.386 11.552-31.050 26.27l-121.958 489.73h-198.992v63.998h224c14.696 0 27.5-10.006 31.050-24.268l90.736-364.354 102.648 615.88c2.458 14.754 14.794 23.84 29.728 24.688 0.616 0.036 1.228 0.056 1.838 0.056 14.194 0 26.812-7.402 30.762-21.188l99.488-347.234 31.378 94.504c4.346 13.086 16.584 21.916 30.372 21.916h102.216c13.73 36 48.738 62.002 89.784 62.002 53.022 0 96-44.984 96-98 0-53.018-42.978-93.998-96-93.998z"
    ],
    "grid": 0,
    "tags": [
      "ios-pulse"
    ]
  },
  {
    "paths": [
      "M128 248.4c0-44.4 42-88.4 88.4-88.4 39.6 0 135.6 0 135.6 0v-32h-133.6c-67 0-122.4 53.4-122.4 120.4v135.6h32c0 0 0-91.4 0-135.6z",
      "M896 384h32v-135.6c0-67-55.4-120.4-122.4-120.4h-133.6v32c0 0 96 0 135.6 0 46.4 0 88.4 44 88.4 88.4s0 135.6 0 135.6z",
      "M128 640h-32v135.6c0 67 55.4 120.4 122.4 120.4h133.6v-32c0 0-96 0-135.6 0-46.4 0-88.4-44-88.4-88.4s0-135.6 0-135.6z",
      "M896 775.6c0 44.4-42 88.4-88.4 88.4-39.6 0-135.6 0-135.6 0v32h133.6c67 0 122.4-53.4 122.4-120.4v-135.6h-32c0 0 0 91.4 0 135.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-qr-scanner"
    ]
  },
  {
    "paths": [
      "M418 224c17.6 0 30 12.4 30 30v384c0 46.6-8.6 90-26.6 128-7 15-13.6 26-18.8 34h-38.6c25.4-38 50-90.6 50-161v-31h-156c-17.6 0-34-16.4-34-34v-320c0-17 15.8-30 34-30h160zM418 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z",
      "M770 224c17.6 0 30 12.4 30 30v384c0 46.6-8.6 90-26.6 128-7 15-13.6 26-18.8 34h-38.6c25.4-38 50-90.6 50-161v-31h-156c-17.6 0-34-16.4-34-34v-320c0-17 15.8-30 34-30h160zM770 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-quote-outline"
    ]
  },
  {
    "paths": [
      "M418 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z",
      "M770 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-quote"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-radio-button-off"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M512 192c-176.8 0-320 143.2-320 320s143.2 320 320 320c176.8 0 320-143.2 320-320s-143.2-320-320-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-radio-button-on"
    ]
  },
  {
    "paths": [
      "M227.8 812c-4.2 0-8.4-1.6-11.6-5-78.6-82-120.2-184-120.2-295s41.6-213 120.4-295c6.2-6.4 16.2-6.6 22.6-0.4s6.6 16.2 0.4 22.6c-72.8 75.8-111.4 170.2-111.4 272.8s38.6 197 111.4 273c6.2 6.4 6 16.6-0.4 22.6-3.2 3-7.2 4.4-11.2 4.4z",
      "M796.2 812c-4 0-8-1.4-11-4.4-6.4-6.2-6.6-16.2-0.4-22.6 72.8-76 111.4-170.4 111.4-273s-38.6-197-111.4-273c-6.2-6.4-6-16.6 0.4-22.6s16.6-6 22.6 0.4c78.8 82 120.4 184 120.4 295s-41.6 213-120.4 295c-3.2 3.6-7.4 5.2-11.6 5.2z",
      "M312.2 731.2c-4.2 0-8.2-1.6-11.4-4.8-56.2-57.2-87.2-132.6-87.2-212.8 0-82 32.2-158.8 90.6-216.2 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.6c-52.4 51.4-81.2 120.2-81.2 193.4 0 71.6 27.6 139.2 78 190.2 6.2 6.4 6.2 16.4-0.2 22.6-3 3.2-7 4.8-11 4.8z",
      "M711.8 731.2c-4 0-8.2-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.6 50.2-51 78-118.6 78-190.2 0-73.4-28.8-142-81.2-193.4-6.2-6.2-6.4-16.4-0.2-22.6s16.4-6.4 22.6-0.2c58.4 57.6 90.6 134.4 90.6 216.2 0 80-31 155.6-87.2 212.8-2.8 3-7 4.6-11.2 4.6z",
      "M396 653.8c-4.2 0-8.2-1.6-11.4-4.8-35.8-36.4-55.6-84.8-55.6-135.8 0-52.4 20.6-101.4 58-138.2 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.6c-31.2 30.6-48.4 71.6-48.4 115.4 0 42.8 16.4 83 46.4 113.4 6.2 6.2 6.2 16.4-0.2 22.6-3 3-7 4.6-11.2 4.6z",
      "M628 653.8c-4 0-8.2-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.6 30-30.4 46.4-70.8 46.4-113.4 0-43.8-17.2-84.6-48.4-115.4-6.2-6.2-6.4-16.4-0.2-22.6s16.4-6.4 22.6-0.2c37.4 36.8 58 85.8 58 138.2 0 51.2-19.8 99.4-55.6 135.8-3.2 3.2-7.4 4.8-11.4 4.8z",
      "M576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-radio-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM323.6 727.4c-3.2 3-7.2 4.6-11.2 4.6-4.2 0-8.2-1.6-11.4-4.8-56-57.4-87-133.2-87-213.6 0-82.2 32.2-159.4 90.6-217 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.8c-52.2 51.6-81 120.6-81 194.2 0 71.8 27.6 139.8 77.8 191 6.2 6.2 6.2 16.4-0.2 22.6zM407.6 627c6.2 6.4 6.2 16.4-0.2 22.8-3.2 3-7.2 4.6-11.2 4.6-4.2 0-8.2-1.6-11.4-4.8-35.8-36.6-55.6-85-55.6-136.4 0-52.6 20.6-101.8 57.8-138.6 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.8c-31.2 30.8-48.2 71.8-48.2 115.8-0 42.6 16.4 83 46.4 113.6zM512 576.2c-35.4 0-64-28.8-64-64.2s28.6-64.2 64-64.2 64 28.8 64 64.2c0 35.4-28.6 64.2-64 64.2zM639.2 649.4c-3.2 3.2-7.2 4.8-11.4 4.8-4 0-8-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.8 30-30.6 46.4-71 46.4-113.8 0-43.8-17.2-85-48.2-115.8-6.2-6.2-6.4-16.4-0.2-22.8s16.4-6.4 22.6-0.2c37.4 36.8 57.8 86.2 57.8 138.6 0 51.6-19.8 100-55.6 136.6zM723 727.2c-3.2 3.2-7.2 4.8-11.4 4.8-4 0-8-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.8 50.2-51.2 77.8-119.2 77.8-191 0-73.6-28.8-142.6-81-194.2-6.2-6.2-6.4-16.4-0.2-22.8s16.4-6.4 22.6-0.2c58.4 57.8 90.6 134.8 90.6 217 0 80.6-31 156.4-87 213.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-radio"
    ]
  },
  {
    "paths": [
      "M748.8 286.4l-26.6-0.2c-23.6-107-110.2-190.2-250.2-190.2s-255.6 103.4-255.6 245.6l0.6 9.6c-84.6 11.2-153 89-153 177.8 0 94 75.8 177 169.2 177h21.2l-74.8 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.4-120.2h122.8l-144.6 198c-5.2 7.2-4.4 16 2.8 21.2 2.6 2 6.6 2.8 9.6 2.8 7.4 0 12.2-2.6 15.6-7.2l156-214.8h122.2l-74.6 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.2-120.2h122.8l-144.6 198c-5.2 7.2-4.2 15.6 3 20.6 2.6 2 6.4 3.4 9.4 3.4 4.6 0 10.2-1.6 13.6-6.2l160.2-220.6c100.8-16.8 177.8-107.4 177.8-213.2-0.2-117.2-94.8-201.6-211.4-201.6zM774.4 671.6c0 0-17.8 2.4-40.4 2.4s-500.8 0-500.8 0c-36 0-70.2-15.8-96.4-43.6-26-27.4-40.8-64.6-40.8-101.8 0-35 13.2-69.4 37-96.8 23.6-27 54.8-44.4 88.2-48.8l29.6-4-2-29.8-0.6-8.6c0.2-58.6 23.4-112.6 65.2-151.8 42-39.2 98.2-60.8 158.6-60.8 58.6 0 110 16.6 148.6 47.8 35.4 28.8 59.8 69.4 70.4 117.4l5.8 26.8c23-1.4 52-1.4 52-1.4 49 0 94.2 17.2 127.4 48.2 33.4 31.2 51.6 74.2 51.6 121.4 0.2 89.2-67.2 169-153.4 183.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-rainy-outline"
    ]
  },
  {
    "paths": [
      "M748.8 286.4l-26.6-0.2c-23.6-107-110.2-190.2-250.2-190.2s-255.6 103.4-255.6 245.6l0.6 9.6c-84.6 11.2-153 89-153 177.8 0 94 75.8 177 169.2 177h21.2l-74.8 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.4-120.2h122.8l-144.6 198c-5.2 7.2-4.4 16 2.8 21.2 2.6 2 6.6 2.8 9.6 2.8 7.4 0 12.2-2.6 15.6-7.2l156-214.8h122.2l-74.6 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.2-120.2h122.8l-144.6 198c-5.2 7.2-4.2 15.6 3 20.6 2.6 2 6.4 3.4 9.4 3.4 4.6 0 10.2-1.6 13.6-6.2l160.2-220.6c100.8-16.8 177.8-107.4 177.8-213.2-0.2-117.2-94.8-201.6-211.4-201.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-rainy"
    ]
  },
  {
    "paths": [
      "M728.2 512c0 120-97 216.4-216.2 216.4s-216.2-97-216.2-216.4c0-119.2 97-216.2 216.2-216.2v111.6l192-111.4-192-128v88c-141.4 0-256 114.8-256 256.2 0 141.6 114.6 256.2 256 256.2s256-114.2 256-256.2h-39.8z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-refresh-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-refresh-circle"
    ]
  },
  {
    "paths": [
      "M512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-refresh"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M256 496h512v34h-512v-34z"
    ],
    "grid": 0,
    "tags": [
      "ios-remove-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 530h-512v-34h512v34z"
    ],
    "grid": 0,
    "tags": [
      "ios-remove-circle"
    ]
  },
  {
    "paths": [
      "M768 530h-512v-34h512v34z"
    ],
    "grid": 0,
    "tags": [
      "ios-remove"
    ]
  },
  {
    "paths": [
      "M160 608h704v32h-704v-32z",
      "M160 496h704v32h-704v-32z",
      "M160 384h704v32h-704v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-reorder"
    ]
  },
  {
    "paths": [
      "M664.6 327.4l-67.2-66.8c-3.2-3.2-7.2-4.6-11.4-4.6s-8.2 1.6-11.4 4.6c-6.2 6.2-6.2 16.4 0 22.6l53.4 52.8h-356c-79.2 0-144 64.8-144 144v48h32v-48c0-29.8 11.6-57.8 33-79 21.2-21.2 49.4-33 79-33h352l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l71.2-70.8c12.6-12.4 12.6-32.6 0-45.2z",
      "M864.2 496v48c0 29.8-11.6 57.8-33 79-21.4 21.4-49.4 33-79.2 33h-352l53.2-52.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-71.2 70.8c-12.6 12.4-12.6 32.6 0 45.2l67.2 66.8c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-53.2-52.8h356c79.2 0 144-64.8 144-144v-48h-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-repeat"
    ]
  },
  {
    "paths": [
      "M880 128h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-680 679.8v-183.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-8-16-16.8-16h-183.2l680-680v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-resize"
    ]
  },
  {
    "paths": [
      "M769 128c-49.6 0-95.6 154.6-95.6 320 0 114 64.2 160 64.2 160s12.4 9.6 30.2 12v260c0 8.8 7.2 16 16 16s16-7.2 16-16v-730c0.2-22-20.8-22-30.8-22zM768 162v424c-2-0.2-10-2-14.6-6.2-2.6-2.2-10.4-9.2-20.6-25.8-22.6-36.2-27.2-77.6-27.2-105.8 0-69.8 8.4-142.8 24-200.2 15-56 32.4-79.4 38.4-86v0z",
      "M592 128h-16l20 207c0 8.8-7.2 15.6-16 15.6s-16-6.4-16-15.2l-12-207.4h-16l-12 207c0 8.8-7.2 15.6-16 15.6s-16-6.4-16-15.2l20-207.4h-16c0 0-48 214.2-48 255.8s26.4 78.8 64 90.6c10.6 3.4 16 3.6 16 3.6v402c0 8.8 7.2 16 16 16s16-7.2 16-16v-402c0 0 10.2-1.8 16-3.6 37.2-12 64-48.4 64-90.4s-48-256-48-256zM544 446c-57.2 0-64-53.2-64-63.2 0 0 0.2-5.4 0.6-9 7.8 5.4 17.2 8.6 27.4 8.6 14.4 0 23-6.2 36-6.2s21.6 6.2 36 6.2c10.2 0 19.6-3.2 27.4-8.6 0.4 3.8 0.6 9.2 0.6 9.2 0 9.4-6.8 63-64 63z",
      "M320 128c-53 0-96 127.8-96 255.8 0 34.6 18.4 66.4 46.4 82.6 22.8 13.4 33.6 13.6 33.6 13.6v400c0 8.8 7.2 16 16 16s16-7.2 16-16v-400c0 0 10.2 0 32.4-12.4 28.4-16 47.6-48 47.6-83.6 0-128-43-256-96-256zM352.6 439.2l-0.4 0.4c-1.4 0.8-3.2 2-5.2 2.8-2.4 0.6-4.8 1.4-7 2.6-6.8 1.4-13.6 2.6-19.8 2.6s-13-1.2-19.8-2.6c-2.2-1-4.4-1.8-7-2.4-2-1-4.4-2.4-6-3.4l-0.8-0.4c-18.8-11.2-30.6-32.2-30.6-54.8 0-58.8 9.6-119 26.2-165 9.6-26.4 19-41 25.2-48.6 6.8-8.4 11.6-10.2 12.6-10.2s5.8 1.8 12.6 10.2c6.2 7.6 15.6 22 25.2 48.6 16.6 46 26.2 106 26.2 165-0 22.6-12.4 44.4-31.4 55.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-restaurant-outline"
    ]
  },
  {
    "paths": [
      "M768 128c-49.6 0-96 154.6-96 320 0 114 64 160 64 160v256c0 17.6 14.4 32 32 32s32-14.4 32-32v-714c0-22-22-22-32-22z",
      "M576 128l20 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l-12-208h-16l-12 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l20-208h-16c0 0-48 214.4-48 256s26.8 77.2 64 90.4v389.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-389.6c37.2-13.2 64-48.4 64-90.4s-48-256-48-256h-16z",
      "M320 128c-53 0-96 128-96 256 0 41.6 26.8 77.2 64 90.4v389.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-389.6c37.2-13.2 64-48.4 64-90.4 0-128-43-256-96-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-restaurant"
    ]
  },
  {
    "paths": [
      "M137.4 584.6l115.2 114.8c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-99.4-100.8h576c79.2 0 144-64.8 144-144v-112h-32v112c0 29.8-11.6 57.8-33 79-21.2 21.2-49.4 33-79 33h-576l103.2-100.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-119.2 118.8c-12.6 12.4-12.6 32.6 0 45.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-return-left"
    ]
  },
  {
    "paths": [
      "M886.6 584.6l-115.2 114.8c-3.2 3.2-7.2 4.6-11.4 4.6s-8.2-1.6-11.4-4.6c-6.2-6.2-6.2-16.4 0-22.6l99.4-100.8h-576c-79.2 0-144-64.8-144-144v-112h32v112c0 29.8 11.6 57.8 33 79 21.2 21.2 49.4 33 79 33h576l-103.2-100.8c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l119.2 118.8c12.6 12.4 12.6 32.6 0 45.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-return-right"
    ]
  },
  {
    "paths": [
      "M512 176c79.4 0 144 64.6 144 144s-64.6 144-144 144-144-64.6-144-144 64.6-144 144-144zM512 144c-97 0-176 79-176 176s79 176 176 176 176-79 176-176-79-176-176-176v0z",
      "M512 96c59.8 0 116 23.4 158.4 65.6s65.6 98.6 65.6 158.4-23.4 116-65.6 158.4-98.6 65.6-158.4 65.6-116-23.4-158.4-65.6-65.6-98.6-65.6-158.4 23.4-116 65.6-158.4 98.6-65.6 158.4-65.6zM512 64c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256v0z",
      "M301.2 560.8c58 50.8 132.8 79.2 210.8 79.2 4.8 0 9.4-0.2 14.2-0.4l-43.4 95.4-70.8 156-74-123.2h-155l118.2-207zM294.2 508.4l-166.2 291.6h192l96 160 96-211.6 67.2-148.4c-21.6 5.2-44.2 8-67.2 8-87 0-165-38.6-217.8-99.6v0z",
      "M722.8 560.8l118.2 207.2h-155.2l-9.4 15.6-64.4 107.6-48.6-107 78.2-171.6c29.4-13 57-30.6 81.2-51.8zM729.8 508.4c-30.2 34.8-68.6 62.4-112 79.6l-89.6 196.2 79.8 175.8 96-160h192l-166.2-291.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-ribbon-outline"
    ]
  },
  {
    "paths": [
      "M512 576c141.4 0 256-114.6 256-256s-114.6-256-256-256-256 114.6-256 256 114.6 256 256 256zM512 144c97 0 176 79 176 176s-79 176-176 176-176-79-176-176 79-176 176-176z",
      "M512 464c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144z",
      "M512 608c-87 0-165-38.6-217.8-99.6l-166.2 291.6h192l96 160 96-211.6 67.2-148.4c-21.6 5.2-44 8-67.2 8z",
      "M729.8 508.4c-30.2 34.8-68.6 62.4-112 79.6l-89.6 196.2 79.8 175.8 96-160h192l-166.2-291.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-ribbon"
    ]
  },
  {
    "paths": [
      "M757.2 324.2c-57 102.2-32.8 183.4-10.8 256.6 11 37.2 21.6 72.2 21.6 109.2 0 58-23 108.4-66.4 145.4-46.4 39.6-112 60.4-189.6 60.4s-143-21-189.6-60.4c-43.4-37-66.4-87.2-66.4-145.4 0-57.8 13.6-102.4 42.8-140 26-33.6 65.2-63.2 126.8-95.8l13-7c40.4-21.4 54-28.8 88-43.8 63.8-28.4 133.2-52.8 206.4-72.6 8-2.2 16.2-4.4 24.2-6.6zM832 274.2c-37.8 7.8-73.6 16.4-107.4 25.6-81 22-151 47.8-210.8 74.4-38.6 17.2-52.4 24.8-103 51.8-116.8 61.8-186.8 128.6-186.8 264 0 135.6 111.2 238 288 238s288-102.4 288-238c0-135.4-122-237.4 32-415.8v0z",
      "M269 268c42.6 13 94.6 31.4 138.4 55.2 11 6 21 12 30 18-9.6 4.8-19 9.6-28.2 14.4-14.4 7.6-28.8 15.6-42.4 23.6-21.4 12.4-41.6 25.2-60.6 38-1.2-46.8-11-98.6-37.2-149.2zM192 214.8c83 87.4 89.2 193 78.8 268.8 25.6-21 62.4-47.8 112.2-76.8 12.8-7.6 26.6-15.2 41.2-22.8 23.2-12.2 47-23.8 71.6-34.8-18.2-20.2-44.2-38.2-73.2-54-97.4-53-230.6-80.4-230.6-80.4v0z",
      "M689.8 188.6c9.8 12.4 22.8 30.2 33 47.6-59.6 15.8-131.2 39.2-188.6 62-11.2-11-24.4-21.6-39.2-32 42.2-34.2 89.4-53.2 124.4-63.4 29.8-8.6 55.2-12.6 70.4-14.2zM704 155.4c0 0-157.2 4.4-261.4 116 33.2 18.4 59.4 38 78 58.6l5.4 6c74.4-31.2 176.2-63.4 242-78-12.8-43.4-64-102.6-64-102.6v0z",
      "M362.2 137.8c18 11 44.2 29.4 70.6 57.2-9 7.4-17.6 15-25.8 23-28.4-13.4-50.2-22.8-72.8-30.6 7.2-15 16.6-32 28-49.6zM352 96c-30.6 41.6-51.4 84.2-60.6 111.4 42.2 11.8 71 24.6 122.8 49.4 19-21.2 40.8-40.2 65.2-56.8-58.8-75-127.4-104-127.4-104v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-rose-outline"
    ]
  },
  {
    "paths": [
      "M832 274.2c-37.8 7.8-73.6 16.4-107.4 25.6-81 22-151 47.8-210.8 74.4-38.6 17.2-52.4 24.8-103 51.8-116.8 61.8-186.8 128.6-186.8 264 0 135.6 111.2 238 288 238s288-102.4 288-238c0-135.4-122-237.4 32-415.8v0z",
      "M192 214.8c83 87.4 89.2 193 78.8 268.8 25.6-21 62.4-47.8 112.2-76.8 12.8-7.6 26.6-15.2 41.2-22.8 23.2-12.2 47-23.8 71.6-34.8-18.2-20.2-44.2-38.2-73.2-54-97.4-53-230.6-80.4-230.6-80.4v0z",
      "M704 155.4c0 0-157.2 4.4-261.4 116 33.2 18.4 59.4 38 78 58.6l5.4 6c74.4-31.2 176.2-63.4 242-78-12.8-43.4-64-102.6-64-102.6v0z",
      "M352 96c-30.6 41.6-51.4 84.2-60.6 111.4 42.2 11.8 71 24.6 122.8 49.4 19-21.2 40.8-40.2 65.2-56.8-58.8-75-127.4-104-127.4-104v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-rose"
    ]
  },
  {
    "paths": [
      "M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416v0z",
      "M704 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M416 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z",
      "M512 542c-96.6 0-176 70-192 162h384c-16-92-95.4-162-192-162z"
    ],
    "grid": 0,
    "tags": [
      "ios-sad-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM368 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM320 704c16-92 95.4-162 192-162s176 70 192 162h-384zM656 496c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48z"
    ],
    "grid": 0,
    "tags": [
      "ios-sad"
    ]
  },
  {
    "paths": [
      "M512.8 128l-448.4 256 127.6 73.2v255.8l320 183 320-183v-255.8l96-54.8v365.6h32v-384l-447.2-256zM496 850l-272-155.6v-219l272 155.4v219.2zM800 694.4l-272 155.6v-219.2l272-155.4v219zM512 602l-382.8-218 384-219.2 383 219.2-384.2 218z"
    ],
    "grid": 0,
    "tags": [
      "ios-school-outline"
    ]
  },
  {
    "paths": [
      "M192 489.2v223.8l304 173.8v-224z",
      "M528 886.8l304-173.8v-223.8l-304 173.6z",
      "M512 128l-448 256 448 256 416-237.8v365.8h32v-384z"
    ],
    "grid": 0,
    "tags": [
      "ios-school"
    ]
  },
  {
    "paths": [
      "M896.6 849.4l-226.6-226.8c41.6-52 66.6-118.2 66.6-190.2 0-168.2-136.2-304.4-304-304.4-168 0-304 136.4-304 304.4s136.2 304.4 304 304.4c72.4 0 138.8-25.4 191-67.6l226.4 226.8 46.6-46.6zM240.2 625.2c-51.4-51.4-79.6-119.8-79.6-192.6s28.4-141.2 79.6-192.6 119.8-80 192.4-80c72.6 0 141 28.4 192.4 79.8s79.6 119.8 79.6 192.6-28.4 141.2-79.6 192.6c-51.4 51.4-119.8 79.8-192.4 79.8-72.6 0.2-141-28.2-192.4-79.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-search-outline"
    ]
  },
  {
    "paths": [
      "M689 596c30-47.2 47.6-103.2 47.6-163.4 0-168.2-136.2-304.6-304.2-304.6-168.2 0-304.4 136.4-304.4 304.6s136.2 304.6 304.2 304.6c61 0 117.8-18 165.4-48.8l13.8-9.6 217.2 217.2 67.4-68.6-217-217.2 10-14.2zM602.8 262.4c45.4 45.4 70.4 105.8 70.4 170s-25 124.6-70.4 170c-45.4 45.4-105.8 70.4-170 70.4s-124.6-25-170-70.4c-45.4-45.4-70.4-105.8-70.4-170s25-124.6 70.4-170c45.4-45.4 105.8-70.4 170-70.4s124.6 25 170 70.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-search"
    ]
  },
  {
    "paths": [
      "M192 499.2l233.2 102.6 114.4 230.2 292.4-640-640 307.2zM456.2 593l311.4-332.4-229.2 497.8-82.2-165.4zM763.6 256.6l-330 314.2-165.6-72.8 495.6-241.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-send-outline"
    ]
  },
  {
    "paths": [
      "M192 499.2l212 93.4 428-400.6z",
      "M832 192l-396.2 431.4 103.8 208.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-send"
    ]
  },
  {
    "paths": [
      "M378.4 166c13.4 17 29.8 31.6 48.2 42.8 26.6 16.4 56 25 85.4 25s58.8-8.6 85.4-25c18.4-11.2 34.6-25.8 48.2-42.8 9.4 3.4 18.6 7.2 27.6 11.4-6.4 49.6 8.6 93 44.6 128.8 35.8 35.8 74.8 53.8 116 53.8 4.2 0 8.4-0.2 12.6-0.6 4.2 9 8 18.4 11.6 27.8-43.8 32.8-67.8 76.4-67.8 124.6 0 48.4 23.8 91.8 67.6 124.6-3.4 9.4-7.4 18.8-11.6 27.8-4.2-0.4-8.4-0.6-12.4-0.6-41.4 0-80.4 18.2-116.2 53.8-35.8 36-50.8 79.4-44.6 128.8-9 4.2-18.2 8-27.6 11.4-13.4-17-29.8-31.6-48.2-42.8-26.6-16.4-56-25-85.4-25s-58.8 8.6-85.4 25c-18.4 11.2-34.6 25.8-48.2 42.8-9.4-3.4-18.6-7.2-27.6-11.4 6.4-49.8-8.6-93-44.6-128.8-30.6-30.6-66.6-46-107-46-7 0-14.2 0.4-21.6 1.4-4.2-9-8-18.2-11.4-27.6 17-13.4 31.6-29.8 43-48.2 16.4-26.6 25.2-56.2 25.2-85.4 0-48.4-24-91.8-68-124.8 3.4-9.4 7.4-18.8 11.6-27.8 4.2 0.4 8.4 0.6 12.4 0.6 41.4 0 80.4-18.2 116.2-53.8 35.8-36 50.8-79.4 44.6-128.8 8.8-3.8 18-7.6 27.4-11zM512 736c59.8 0 116-23.2 158.4-65.6s65.6-98.6 65.6-158.4-23.2-116-65.6-158.4-98.6-65.6-158.4-65.6-116 23.2-158.4 65.6-65.6 98.6-65.6 158.4c0 123.6 100.4 224 224 224zM632.8 128c-26 44.4-72.8 73.8-120.8 73.8-47.8 0-94.8-29.4-120.8-73.8-26.8 8-52.4 18.6-76.4 31.6 13 49.8 2.6 90-31.2 124-26.6 26.6-57.4 44.4-93.4 44.4-9.8 0-19.8-1.2-30.4-4-13.2 24-23.8 49.6-31.8 76.4 44.4 26 74 63.8 74 111.6s-29.6 94.8-74 120.8c8 26.8 18.6 52.4 31.6 76.4 13.8-3.6 27-5.4 39.4-5.4 32.2 0 60 12.2 84.4 36.6 34 33.8 44.2 74.2 31.2 124 24.2 13 49.6 23.6 76.4 31.6 26-44.4 73-73.8 120.8-73.8s94.8 29.4 120.8 73.8c26.8-8 52.4-18.6 76.4-31.6-13-49.8-2.6-90 31.2-124 26.6-26.6 57.4-44.4 93.6-44.4 9.8 0 19.8 1.2 30.4 4 13-24.2 23.6-49.8 31.6-76.4-44.2-26-73.6-63.8-73.6-111.6s29.6-85.6 73.8-111.6c-8-26.6-18.6-52.4-31.6-76.4-10.6 2.8-20.8 4-30.6 4-36 0-66.6-17.8-93.4-44.4-33.8-33.8-44.2-74.2-31.2-124-24-13-49.6-23.6-76.4-31.6v0zM512 704c-105.8 0-192-86-192-192s86-192 192-192 192 86 192 192c0 106-86 192-192 192v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-settings-outline"
    ]
  },
  {
    "paths": [
      "M822.2 512c0-47.8 29.6-85.6 73.8-111.6-8-26.6-18.6-52.4-31.6-76.4-49.8 13-90-6.4-124-40.4-33.8-33.8-44.2-74.2-31.2-124-24-13-49.6-23.6-76.4-31.6-26 44.4-72.8 73.8-120.8 73.8-47.8 0-94.8-29.4-120.8-73.8-26.8 8-52.4 18.6-76.4 31.6 13 49.8 2.6 90-31.2 124-33.8 33.8-74.2 53.4-123.8 40.4-13.2 24-23.8 49.6-31.8 76.4 44.4 26 74 63.8 74 111.6s-29.6 94.8-74 120.8c8 26.8 18.6 52.4 31.6 76.4 49.8-13 90-2.6 123.8 31.2 34 33.8 44.2 74.2 31.2 124 24.2 13 49.6 23.6 76.4 31.6 26-44.4 73-73.8 120.8-73.8s94.8 29.4 120.8 73.8c26.8-8 52.4-18.6 76.4-31.6-13-49.8-2.6-90 31.2-124 33.8-33.8 74.2-53.4 124-40.4 13-24.2 23.6-49.8 31.6-76.4-44.2-26-73.6-63.8-73.6-111.6zM512 704c-105.8 0-192-86-192-192s86-192 192-192 192 86 192 192-86 192-192 192z"
    ],
    "grid": 0,
    "tags": [
      "ios-settings"
    ]
  },
  {
    "paths": [
      "M896 496l-320-304v170.6c-298.6 42.8-405.4 256-448 469.4 106.6-149.4 234.6-217.6 448-217.6v175l320-293.4zM297.8 638.4c-37 18.4-70.4 41.2-102.4 69.4 22.2-60.4 50.6-111.4 85.4-154.2 33.8-41.6 74.4-75.8 120.8-101.6 51.4-28.6 111.6-48 179-57.6l27.4-2.4v-128l241 231.6-241 224.4v-136l-32-2c-111.2 0-202.2 18.6-278.2 56.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-share-alt-outline"
    ]
  },
  {
    "paths": [
      "M896 496l-320-304v170.6c-298.6 42.8-405.4 256-448 469.4 106.6-149.4 234.6-217.6 448-217.6v175l320-293.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-share-alt"
    ]
  },
  {
    "paths": [
      "M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z",
      "M386.2 236.2l-23.2-23.2 149-149 149 149-23.2 23.2-109.4-109.4v486h-32.8v-486z"
    ],
    "grid": 0,
    "tags": [
      "ios-share-outline"
    ]
  },
  {
    "paths": [
      "M528 288v324h-32v-324h-304v608h640v-608z",
      "M528 126.8l109.6 109.4 23.2-23.2-148.8-149-149 149 23.4 23.2 109.6-109.4v161.2h32z"
    ],
    "grid": 0,
    "tags": [
      "ios-share"
    ]
  },
  {
    "paths": [
      "M745 185.2c-41-29.4-81-57.4-125-57.4s-44 16-108 16-64-16-108-16-84 28-125 57.4c-63.2 45.4-183 172.8-183 172.8l160 186.4v351.6h512v-350.8l160-187.4c0-0-119.8-127.2-183-172.6zM426.2 161.6c19.8 0 50.8 14.6 85.8 14.6s66.2-14.6 85.8-14.6c13.8 0 22.2 7.2 22.2 32 0 46.6-48.4 88-108 88s-108-42.6-108-88c0-24.6 8.2-32 22.2-32zM768 400.2c0-8.8-7.2-16-16-16s-16 7.2-16 16v463.8h-448v-463.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v98.4c-27.2-32-102.8-121.8-117.2-139.2 36-37.4 113.8-115.8 159-148.2 25.8-18.6 52.4-37.6 78.4-46.4-2.8 8.2-4.2 17.8-4.2 29 0 31.4 15.8 62.6 43.2 85.6 26.6 22.2 61 34.4 96.8 34.4 36 0 70.4-12 96.8-33.8 27.4-22.8 43.2-54.2 43.2-86.2 0-11.2-1.4-20.8-4.2-29 26 8.8 52.6 27.8 78.4 46.4 45.2 32.4 122.8 110.8 158.8 148.2-14.8 18-92.2 109.8-117.2 139.2v-98.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-shirt-outline"
    ]
  },
  {
    "paths": [
      "M745 185.4c-41-29.4-81-57.4-125-57.4s-44 16-108 16-64-16-108-16-84 28-125 57.4c-63.2 45.4-183 172.6-183 172.6s69.2 82.6 103.4 122c25.4 29.4 32 35.6 32 0 0-85.4 0-96 12.6-96s12 7.2 12 16v496h512v-496c0-8.8-0.6-16 12-16s12.6 10.6 12.6 96c0 35.6 6.6 29.4 32 0 34-39.4 103.4-122 103.4-122s-119.8-127.2-183-172.6zM512 282c-60 0-108-41.4-108-88 0-60 48-17.4 108-17.4 59.6 0 108-42.6 108 17.4 0 46.6-48.4 88-108 88z"
    ],
    "grid": 0,
    "tags": [
      "ios-shirt"
    ]
  },
  {
    "paths": [
      "M886.6 651.4l-71.2-70.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l53.2 52.8h-198l-251.6-314.4c-3-3.6-7.8-5.6-12.6-5.6h-239.8c-8.8 0-16 7.2-16 16s7.2 16 16 16h232.6l114.6 144-114.6 144h-232.6c-8.8 0-16 7.2-16 16s7.2 16 16 16h240c4.8 0 9.2-2 12.2-5.6l115.8-145.4 115.8 145.4c3 3.6 7.6 5.6 12.2 5.6h210l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l67.2-66.8c12.4-12.6 12.4-32.8-0.2-45.2z",
      "M647.4 368h198.4l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l71.2-70.8c12.4-12.4 12.4-32.6 0-45l-67.2-66.8c-3.2-3.2-7.2-4.6-11.4-4.6s-8.2 1.6-11.4 4.6c-6.2 6.2-6.2 16.4 0 22.6l53.2 52.8h-209.6c-4.8 0-9.2 2-12.2 5.6l-94.6 120.4 21 24.8 93.2-119z"
    ],
    "grid": 0,
    "tags": [
      "ios-shuffle"
    ]
  },
  {
    "paths": [
      "M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158zM351.2 512l15.2-8.8 433.6-255.2v528l-448.8-264zM224 224h94v576h-94v-576z"
    ],
    "grid": 0,
    "tags": [
      "ios-skip-backward-outline"
    ]
  },
  {
    "paths": [
      "M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158z"
    ],
    "grid": 0,
    "tags": [
      "ios-skip-backward"
    ]
  },
  {
    "paths": [
      "M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158zM657.8 520.8l-433.8 255.2v-528l449 264-15.2 8.8zM800 800h-94v-576h94v576z"
    ],
    "grid": 0,
    "tags": [
      "ios-skip-forward-outline"
    ]
  },
  {
    "paths": [
      "M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158z"
    ],
    "grid": 0,
    "tags": [
      "ios-skip-forward"
    ]
  },
  {
    "paths": [
      "M863.4 696.8l-75.2-43.8c26.2-33.8 64.2-49.6 64.8-49.8 8.6-3.4 13.2-13.4 10.4-22.2s-12.2-13.2-20.8-9.6c-2.2 1-50.2 20.6-82.6 65l-213.6-124.4 213.4-124.4c32.2 44.4 80.4 64.2 82.6 65 8.6 3.4 18-0.8 20.8-9.6s-1.8-18.8-10.4-22.2c-0.4-0.2-38.6-15.8-64.8-49.8l75.2-43.8c8.2-4.8 11-15.4 6.2-23.8s-15.2-11.2-23.6-6.4l-75.2 43.8c-15.8-39.6-10.4-81-10.2-81.4 1.4-9.2-4.8-18.4-13.8-20.2s-17.4 4.2-18.6 13.4c-0.4 2.4-7 54.2 15 104.8l-213 124.4v-248c54-6 95-38 97-39.6 7.4-5.8 8-16 2-23-6.2-7-16.8-7.8-24-2-0.4 0.2-32.8 25.8-74.8 31.6v-87.4c0-9.6-8.4-17.4-18-17.4s-18 7.8-18 17.4v87.4c-42-6-74.4-31.4-74.8-31.6-7.4-5.8-18-4.8-24.2 2-6.2 7-5.4 17.2 1.8 23 1.8 1.4 43 33.6 97 39.6v248.2l-213-124.4c22-50.4 15-102.4 14.8-104.8-1.4-9.2-9.6-15.2-18.6-13.4s-15.2 11-13.8 20.2c0 0.4 5.6 41.6-10.2 81.4l-75.2-43.8c-8.2-4.8-18.8-2-23.6 6.4s-2 19 6.4 23.8l75.2 43.8c-26 33.6-64.2 49.6-64.6 49.8-8.6 3.4-13.2 13.4-10.4 22.2s12.2 13.2 20.8 9.6c2.2-0.8 50.2-20.6 82.6-65l213.2 124.2-213.4 124.4c-32.2-44.4-80.4-64.2-82.6-65-8.6-3.4-18 0.8-20.8 9.6s1.8 18.8 10.4 22.2c0.4 0.2 38.6 16 64.6 49.8l-75.2 43.8c-8.2 4.8-11 15.4-6.2 23.8s15.2 11.2 23.6 6.4l75.2-43.8c16 39.8 10.4 81 10.2 81.4-1.4 9.2 4.8 18.4 13.8 20.2s17.4-4.2 18.6-13.4c0.4-2.4 7-54.2-15-104.8l213.2-124.4v248.2c-54 6-95 38-97 39.6-7.4 5.8-8 16-2 23 6.2 7 16.8 7.8 24 2 0.4-0.2 32.8-25.6 74.8-31.6v87.4c0 9.6 8.4 17.4 18 17.4s18-7.8 18-17.4v-87.4c42 6 74.4 31.4 74.8 31.6 7.4 5.8 18 4.8 24.2-2 6.2-7 5.4-17.2-1.8-23-1.8-1.4-43-33.6-97-39.6v-248.2l213 124.4c-22 50.4-15 102.4-14.8 104.8 1.4 9.2 9.6 15.2 18.6 13.4s15.2-11 13.8-20.2c0-0.4-5.6-41.8 10.2-81.4l75.2 43.8c8.2 4.8 18.8 2 23.6-6.4s2-19-6.2-23.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-snow-outline"
    ]
  },
  {
    "paths": [
      "M871.4 683l-58.2-34c21.4-20.8 45.4-30.8 45.6-31 16.6-6.6 25.2-25.2 19.6-42-4.2-13-16.4-21.8-30-21.8-4.2 0-8.2 0.8-12 2.4-5 2-47 19.8-80.6 59l-175.6-103.6 175.8-103.6c34.2 40.2 78.4 58.2 80.6 59.2 3.8 1.6 8 2.4 12 2.4 13.6 0 25.6-8.8 30-21.8 5.6-17-3-35.4-19.6-42-0.2-0.2-24.4-10.2-45.8-31l58.2-34c15.8-9.2 21.2-29.6 12.2-45.6-6-10.4-17-16.8-28.8-16.8-5.8 0-11.6 1.6-16.6 4.6l-58 33.8c-7-29-3.6-55-3.6-55.2 2.6-17.8-9-34.6-26.4-38.2-2.2-0.4-4.4-0.6-6.6-0.6-15.6 0-28.6 11.2-31.2 26.8l-0.2 0.6c-4.8 20.8-6.2 61.6 7 101.8l-173.2 102.2v-207.2c50-9.4 83.6-32.6 88.8-36.8 8.4-6.6 13.8-16.2 14.8-25.6 0.6-7.6-1.8-15-6.6-20.6-6.4-7.2-16.8-11.2-28.6-11.2-8.8 0-16.8 2.4-22.8 6.8-2.8 1.8-17.6 13-45.6 21v-67.6c0-18-15.6-33.4-34-33.4s-34 15.2-34 33.4v67.4c-22-7.4-37.2-17.4-45.4-22.8-8.2-5.6-18.2-8.4-24.2-8.4-5.8 0-19.6 0.2-27.4 13.2-6 9.8-5.6 18.4-4.8 23.6 1 5.8 3.8 12.6 11 20.4s46.8 32.2 90.8 40.6v206l-183.2-102.6c18.8-52 14.8-99.8 14.8-100.4-2.4-16.4-14-27.4-29.2-27.4-2.2 0-4.4 0.2-6.4 0.6-17 3.6-28 20-25.4 38.2 0.2 1.2 3.8 26.6-3.2 55.2l-59.6-33.8c-5-3-10.8-4.6-16.6-4.6-11.8 0-22.8 6.4-28.8 16.8-9 15.8-3.6 36.2 12.2 45.6l58.2 34c-21.4 20.6-45.4 30.8-45.6 31-16.6 6.6-25.2 25.2-19.6 42 4.2 13 16.4 21.8 30 21.8 4.2 0 8.2-0.8 12-2.4 2-0.8 46.2-19 80.6-59.2l179.8 103.6-179.8 103.6c-33.4-39.4-75.4-57-80.6-59-3.8-1.6-8-2.4-12-2.4-13.6 0-25.6 8.8-30 21.8-5.6 17 3 35.4 19.4 42 0.2 0.2 24.4 10.4 45.8 31l-58.2 34c-15.8 9.2-21.2 29.6-12.2 45.6 6 10.4 17 16.8 28.8 16.8 5.8 0 11.6-1.6 16.6-4.6l58-33.8c7 29 3.6 55 3.6 55.2-2.6 17.8 9 34.4 26.4 38.2 2.2 0.4 4.4 0.6 6.6 0.6 15.8 0 29-11.6 31.2-27.4 1-6.8 6.4-53.6-10.8-100.4l177.2-102.6v206c-42 8.4-79.6 32.8-90.8 42.6l-0.2 0.2c-5.8 4.6-9.2 11.2-9.8 18.6-0.8 9.2 2.8 19.2 10.2 27.4 2.4 2.8 10 11.2 21.6 11.2 6.2 0 12.2-2.4 18.4-7.2l1-0.8c2-1.8 26-17.6 50-25.4v67.4c0 18 15.6 33.4 34 33.4s34-15.2 34-33.4v-67.8c30 8 44.4 21.2 47.6 23.2 5.8 4.4 13.6 6.6 21.8 6.6 11.2 0 21.2-4 27.4-11.2 4.6-5.4 7-12.2 6.4-19.2-0.8-9.4-7-19.4-16.2-26.8-0.4-0.4-33-28.8-87-38.8v-205l173.2 102.2c-14.4 42.6-9.6 83.2-6.6 99.6v0.4c2.4 15.6 12.6 27.2 29 27.2 2.2 0 4.4-0.2 6.6-0.6 17.6-3.6 29.8-20.6 27.4-38-0.2-1.6-2.8-27.2 4-55.6l58.2 34.2c5 3 10.8 5 16.6 5 0 0 0 0 0 0 12 0 23-6.8 28.8-17.2 9-15.6 3.6-36.4-12.2-45.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-snow"
    ]
  },
  {
    "paths": [
      "M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z",
      "M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z"
    ],
    "grid": 0,
    "tags": [
      "ios-square-outline"
    ]
  },
  {
    "paths": [
      "M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z",
      "M896 128h-768v768h768v-768z"
    ],
    "grid": 0,
    "tags": [
      "ios-square"
    ]
  },
  {
    "paths": [
      "M352 896h128v-768h-128v768zM384 160h64v704h-64v-704z",
      "M160 896h128v-320h-128v320zM192 608h64v256h-64v-256z",
      "M544 896h128v-448h-128v448zM576 480h64v384h-64v-384z",
      "M736 256v640h128v-640h-128zM832 864h-64v-576h64v576z"
    ],
    "grid": 0,
    "tags": [
      "ios-stats-outline"
    ]
  },
  {
    "paths": [
      "M352 896h128v-768h-128v768z",
      "M160 896h128v-320h-128v320z",
      "M544 896h128v-448h-128v448z",
      "M736 256v640h128v-640h-128z"
    ],
    "grid": 0,
    "tags": [
      "ios-stats"
    ]
  },
  {
    "paths": [
      "M694.4 928h45.6l-98.6-96h-45.6l32.2 32h-232l32.2-32h-45.6l-98.6 96h45.6l34.2-32h296.4z",
      "M400 144h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16z",
      "M688 128c53 0 96 43 96 96v448c0 53-43 96-96 96h-352c-53 0-96-43-96-96v-448c0-53 43-96 96-96h352zM336 512h356c35.2 0 64-28.8 64-64v-192c0-35.2-28.6-64-64-64h-356c-35.2 0-64 28.8-64 64v192c0 35.2 28.6 64 64 64zM673 751c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88zM353 751c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88zM688 96h-352c-70.6 0-128 57.4-128 128v448c0 70.6 57.4 128 128 128h352c70.6 0 128-57.4 128-128v-448c0-70.6-57.4-128-128-128v0zM336 480c-17.6 0-32-14.4-32-32v-192c0-17.6 14.4-32 32-32h356c17.6 0 32 14.4 32 32v192c0 17.6-14.4 32-32 32h-356zM673 719c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56v0zM353 719c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-subway-outline"
    ]
  },
  {
    "paths": [
      "M688 96h-352c-70.4 0-128 57.6-128 128v448c0 70.4 57.6 128 128 128h352c70.4 0 128-57.6 128-128v-448c0-70.4-57.6-128-128-128zM400 144h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 752c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56zM688 752c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56zM768 448c0 17.6-14.4 32-32 32h-447.6c-17.6 0-32.4-14.4-32.4-32v-191.6c0-17.6 14.8-32.4 32.4-32.4h447.6c17.6 0 32 14.8 32 32.4v191.6z",
      "M738.4 928h45.6l-98.6-96h-45.6l32.2 32h-320l32.2-32h-45.6l-98.6 96h45.6l34.2-32h384.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-subway"
    ]
  },
  {
    "paths": [
      "M496 800h32v128h-32v-128z",
      "M496 96h32v128h-32v-128z",
      "M96 496h128v32h-128v-32z",
      "M800 496h128v32h-128v-32z",
      "M296.903 704.327l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z",
      "M794.978 206.523l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z",
      "M319.809 297.039l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z",
      "M817.341 794.842l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z",
      "M512 352c88.2 0 160 71.8 160 160s-71.8 160-160 160c-88.2 0-160-71.8-160-160s71.8-160 160-160zM512 320c-105.8 0-192 86.2-192 192s86.2 192 192 192c105.8 0 192-86.2 192-192s-86.2-192-192-192v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-sunny-outline"
    ]
  },
  {
    "paths": [
      "M496 800h32v128h-32v-128z",
      "M496 96h32v128h-32v-128z",
      "M96 496h128v32h-128v-32z",
      "M800 496h128v32h-128v-32z",
      "M296.903 704.327l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z",
      "M794.978 206.523l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z",
      "M319.809 297.039l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z",
      "M817.341 794.842l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z",
      "M512 320c-105.8 0-192 86.2-192 192s86.2 192 192 192c105.8 0 192-86.2 192-192s-86.2-192-192-192v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-sunny"
    ]
  },
  {
    "paths": [
      "M779 186l-22.6 23.2 141.6 142.8h-514v32h514l-141.6 141.8 22.6 22.4 181-181.2z",
      "M245 473.8l22.6 23.2-141.6 143h514v32h-514l141.6 141.8-22.6 22.2-181-181z"
    ],
    "grid": 0,
    "tags": [
      "ios-swap"
    ]
  },
  {
    "paths": [
      "M288 640c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96zM288 608c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z",
      "M734.4 576c88.8 0 161.2 72.2 161.2 161s-72 159-160.8 159h-446c-88.8 0-161-70.2-161-159s72.2-161 161-161h445.2zM735 544h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193v0z",
      "M736 192c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96zM736 160c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z",
      "M290 128h445c88.8 0 161 72.2 161 161s-72.2 159-161 159h-446c-88.8 0-160.8-70.2-160.8-159s72.6-161 161.4-161zM289 96c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193h-446z"
    ],
    "grid": 0,
    "tags": [
      "ios-switch-outline"
    ]
  },
  {
    "paths": [
      "M735 544h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193zM288 864c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128z",
      "M289 480h446c106.6 0 193-84.4 193-191s-86.4-193-193-193h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191zM736 160c70.6 0 128 57.4 128 128s-57.4 128-128 128-128-57.4-128-128c0-70.6 57.4-128 128-128z"
    ],
    "grid": 0,
    "tags": [
      "ios-switch"
    ]
  },
  {
    "paths": [
      "M986.8 512l-63.6 63.6c19.4-126-19.6-260.4-117-357.8-162.4-162.4-426-162.6-588.4 0-32.6 32.6-58.6 69-78 108l31 15.6c17.8-35.8 41.6-69.4 71.4-99.2 148.6-148.6 390.6-148.6 539.4 0.2 91.2 91.2 126.4 217.2 105.8 336l-68.2-66.4-21.6 21.6 106.4 106.4 105.4-105.4-22.6-22.6z",
      "M781.6 781.6c-148.6 148.6-390.6 148.8-539.4 0-91-91.2-126.2-217.8-105.6-335.8l66.2 66.2 22.6-22.6-105.4-105.4-105.4 105.4 22.6 22.6 63.6-63.6c-19.6 126.8 19.4 260.4 116.8 357.8 162.4 162.4 426 162.4 588.4 0 32.6-32.6 58.6-69.2 78-108l-31-15.6c-17.8 35.8-41.6 69.2-71.4 99z"
    ],
    "grid": 0,
    "tags": [
      "ios-sync"
    ]
  },
  {
    "paths": [
      "M64 220v584c0 15.6 12.2 28 28 28h840c15.8 0 28-12.4 28-28v-584c0-15.6-12.2-28-28-28h-840c-15.8 0-28 12.6-28 28zM97.4 512.8c0-7.8 6.2-14 14-14s14 6.2 14 14c0 7.8-6.2 14-14 14-7.6 0-14-6.4-14-14zM940 512c0 15.4-13 28-28.2 28-15 0-28-12.4-28-28 0-15.4 12.8-28.2 28-28.2 15.2 0.2 28.2 12.8 28.2 28.2zM864 224v576h-704v-576h704z"
    ],
    "grid": 0,
    "tags": [
      "ios-tablet-landscape"
    ]
  },
  {
    "paths": [
      "M804 64h-584c-15.6 0-28 12.2-28 28v840c0 15.8 12.4 28 28 28h584c15.6 0 28-12.2 28-28v-840c0-15.8-12.6-28-28-28zM511.2 97.4c7.8 0 14 6.2 14 14s-6.2 14-14 14c-7.8 0-14-6.2-14-14-0-7.6 6.4-14 14-14zM512 940c-15.4 0-28-13-28-28.2 0-15 12.4-28 28-28 15.4 0 28.2 12.8 28.2 28-0.2 15.2-12.8 28.2-28.2 28.2zM800 864h-576v-704h576v704z"
    ],
    "grid": 0,
    "tags": [
      "ios-tablet-portrait"
    ]
  },
  {
    "paths": [
      "M512 224c194 0 352 124 352 276.6 0 71.8-35.2 138.4-99 187.8-65.6 50.8-154.8 78.6-251 78.6-57.8 0-102-6-139.4-18.6-1.2-0.4-2.6-1-4-1.4-0.6-0.2-1.2-0.4-1.6-0.4-9.4-2.8-19.4-4.2-29.4-4.2-11.2 0-22.2 1.8-32.6 5.2v0l-0.6 0.2c-1.2 0.4-17.8 6.6-22 8.6v0l-79.2 34.4c27.6-87.8 27.6-89.6 27.6-95.2 0-14.2-4.4-28.2-12.6-40.4-1-1.4-2-2.8-3.2-4.2-1.4-1.8-2.6-3.4-3.6-4.6-34.8-43.8-53.2-94.2-53.2-146-0.2-152.4 157.8-276.4 351.8-276.4zM512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-text-outline"
    ]
  },
  {
    "paths": [
      "M512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-text"
    ]
  },
  {
    "paths": [
      "M606 600.6v-443.8c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-97.8 95.6-97.8 167.4 0 106 86 192 192 192s192-86 192-192c0-71.8-40.2-134.6-98.2-167.4zM625 881.2c-30.2 30.2-70.2 46.8-113 46.8-88.4 0-160.2-71.8-160.2-160 0-57.6 31.6-111 81.6-139.6l16.6-9.2v-462.4c0-33.6 27.8-61 62-61s62 27.4 62 61v462.2l15.8 9.2c50.8 28.8 82 82.2 82 139.8 0 42.8-16.8 83-46.8 113.2z",
      "M544 644v-356c0-17.6-14.4-32-32-32s-32 14.4-32 32v356c-56 14.2-96.2 64.4-96.2 124 0 70.6 57.2 128 128 128s128.2-57.4 128.2-128c-0.2-59.6-42-109.8-96-124z"
    ],
    "grid": 0,
    "tags": [
      "ios-thermometer-outline"
    ]
  },
  {
    "paths": [
      "M606 600.6v-443.6c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-98 95.6-98 167.2 0 106 85.8 192 191.8 192s192.2-86 192.2-192c0-72-40-134.6-98-167.4zM512.4 896c-70.6 0-128-57.2-128-128 0-59.6 39.6-109.8 95.6-124v-356c0-17.6 14.4-32 32-32s32 14.4 32 32v356c54 14.2 96.2 64.4 96.2 124 0 70.6-57.2 128-127.8 128z",
      "M607.6 768.4c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"
    ],
    "grid": 0,
    "tags": [
      "ios-thermometer"
    ]
  },
  {
    "paths": [
      "M428.6 96c77 0 160.4 8.2 225.2 16.2 43 5.2 68.2 15 92.8 24.2 31.8 12.2 62 23.6 133.4 23.6 8.8 0 16 7.2 16 16s-7.2 16-16 16c-77.4 0-111.6-13-144.8-25.8-23.6-9-46-17.6-85.2-22.4-97.2-12-223-22-330.8-8.2-74.8 9.4-112.2 25-124.4 54.6-4.2 10 1 21.8 5.4 32.2 3 7 5.8 13.2 5.8 19.6 0 11-8.2 17.8-17.8 25.6-12.6 10.4-28.2 23.2-28.2 41.6 0 18.2 9.6 29.6 18.8 40.6 7.4 9 15.2 18.2 15.2 30.2 0 11.2-5.8 19-10.6 25.2-6.4 8.4-13.4 17.8-13.4 42.8 0 17.6 9 25 19.2 33.6 9.2 7.6 28.4 23.6 11.8 47.6-14.6 21-5 45.2 4.8 56.2 10.6 12 16.4 15.6 67.2 12.6 34.4-2 108.4-13.6 157.4-21.2 22.4-3.6 38.6-6 44.8-6.6 9.8-1 23-2.4 35.6 0.8 16.6 4.4 27.6 15.8 31.8 33.2 3.8 15.6-3 29-12.2 47.8-7.4 15.2-17.8 36-27 66.8-14.6 48-19.4 120 2.6 159.6 5.4 9.8 13.8 15.6 25.2 17.4 12 1.8 22-1.8 24.6-3.8 3-5 8-25 12-41 6.6-26.2 14.6-64.8 25.8-89.4 16.4-36.2 69.4-84.8 122-131.4 8-7 14.8-13.2 19.6-17.6 14.8-13.6 31.6-38.2 46.4-60 12-17.6 22.4-33 31.2-41.6 18.8-18.8 45.4-31.2 67.4-31.2 8.8 0 16 7.2 16 16s-7.2 16-16 16c-11.4 0-30.4 7.4-44.6 21.8-6.6 6.6-16.8 21.4-27.4 37-15.8 23-33.6 49.2-51 65.4-5 4.8-12.2 11-20.2 18.2-34.6 30.6-99 87.6-114 120.8-10 22-17.8 59-24 84-7.6 30.6-11.6 45.6-18.4 53.6-9.2 11-26.8 15.8-49.8 15.8s-41.6-14.4-52.6-34.2c-23.4-42-25.4-118-5.4-184.4 10-33.4 21-55.4 29-71.6 6-12.2 10.8-21.8 9.8-26-2.4-9.6-7.4-12.4-32.8-9.8-5.4 0.6-23 3.4-43.2 6.4-49.6 7.8-124.4 19.4-160.4 21.6-52.2 3-72 0.2-92.8-23.4-20.4-23-29.6-63.2-7.4-95.4-1.6-1.4-3.8-3.4-5.8-5-11.8-9.8-31.2-25.8-31.2-58.6 0-35.8 12-51.6 20-62.2 1.4-1.8 3.2-4.4 3.8-5.6-1.2-2.2-4.8-6.6-7.6-10-10.4-12.4-26.2-31.4-26.2-61.2 0-33.6 25-54.2 39.8-66.4 1.4-1.2 3.2-2.6 4.8-4-0.6-1.2-1.2-2.6-1.6-3.8-5.6-13-15.2-34.6-5.6-57.4 21.8-52.4 88.2-66.8 150.4-74 33-3.4 72-7.4 112.8-7.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-thumbs-down-outline"
    ]
  },
  {
    "paths": [
      "M128 309.2c0 29.8 15.8 48.6 26.2 61.2 2.8 3.2 6.4 7.6 7.6 10-0.6 1.2-2.4 3.8-3.8 5.6-8 10.4-20 26.4-20 62.2 0 32.8 19.4 48.8 30.8 58.2 1.8 1.6 4.2 3.4 5.8 5-22.2 32.2-13 72.4 7.4 95.4 21 23.6 40.6 26.4 92.8 23.4 36-2.2 111-13.8 160.4-21.6 20.2-3.2 37.8-6 43.2-6.4 25.4-2.6 30.4 0 32.8 9.8 1 4.2-3.8 13.8-9.8 26-8 16.2-19 38.4-29 71.6-20.2 66.4-18 142.4 5.4 184.4 11 19.8 29.6 34.2 52.6 34.2s40.6-4.8 49.8-15.8c6.8-8 10.6-23.2 18.4-53.6 6.2-24.8 14-61.8 24-84 15-33.2 79.4-90.2 114-120.8 8.2-7.2 15.2-13.4 20.2-18.2 17.4-16.2 35.2-42.2 51-65.4 10.8-15.6 20.8-30.4 27.4-37 14.2-14.2 33.2-21.8 44.6-21.8 8.8 0 16-7.2 16-16v-319.6c0-8.8-7.2-16-16-16-71.4 0-101.4-11.4-133.4-23.6-24.4-9.4-49.8-19-92.8-24.2-64.8-8-148.4-16.2-225.2-16.2-40.8 0-79.8 4-113.2 7.8-62 7.2-128.4 21.6-150.4 74-9.4 22.8 0 44.4 5.6 57.4 0.6 1.2 1 2.4 1.6 3.8-1.6 1.2-3.2 2.8-4.8 4-14.2 12.2-39.2 32.6-39.2 66.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-thumbs-down"
    ]
  },
  {
    "paths": [
      "M595.4 928c-77 0-160.4-8.2-225.2-16.2-43-5.2-68.2-15-92.8-24.2-31.8-12.2-62-23.6-133.4-23.6-8.8 0-16-7.2-16-16s7.2-16 16-16c77.4 0 111.6 13 144.8 25.8 23.6 9 46 17.6 85.2 22.4 97.2 12 223 22 330.8 8.2 74.8-9.4 112.2-25 124.4-54.6 4.2-10-1-21.8-5.4-32.2-3-7-5.8-13.2-5.8-19.6 0-11 8.2-17.8 17.8-25.6 12.6-10.2 28.2-23 28.2-41.6 0-18.2-9.6-29.6-18.8-40.6-7.4-9-15.2-18.2-15.2-30.2 0-11.2 5.8-19 10.6-25.2 6.4-8.4 13.4-17.8 13.4-42.8 0-17.6-9-25-19.2-33.6-9.2-7.6-28.4-23.6-11.8-47.6 14.6-21 5-45.2-4.8-56.2-10.6-12-16.4-15.6-67.2-12.6-34.4 2-108.4 13.6-157.4 21.2-22.4 3.6-38.6 6-44.8 6.6-9.8 1-23 2.4-35.6-0.8-16.6-4.4-27.6-15.8-31.8-33.2-3.8-15.6 3-29 12.2-47.8 7.4-15.2 17.8-36 27-66.8 14.6-48 19.4-120-2.6-159.6-5.4-9.8-13.8-15.6-25.2-17.4-12-1.8-22 1.8-24.6 3.8-3 5-8 25-12 41-6.6 26.2-14.6 64.8-25.8 89.4-16.4 36.2-69.4 84.8-122 131.4-8 7-14.8 13.2-19.6 17.6-14.8 13.6-31.6 38.2-46.4 60-12 17.6-22.4 33-31.2 41.6-18.8 18.8-45.4 31.2-67.4 31.2-8.8 0-16-7.2-16-16s7.2-16 16-16c11.4 0 30.4-7.4 44.6-21.8 6.6-6.6 16.8-21.4 27.4-37 15.8-23 33.6-49.2 51-65.4 5-4.8 12.2-11 20.2-18.2 34.6-30.6 99-87.6 114-120.8 10-22 17.8-59 24-84 7.6-30.6 11.6-45.6 18.4-53.6 9.2-11 26.8-15.8 49.8-15.8s41.6 14.4 52.6 34.2c23.4 42 25.4 118 5.4 184.4-10 33.4-21 55.4-29 71.6-6 12.2-10.8 21.8-9.8 26 2.4 9.6 7.4 12.4 32.8 9.8 5.4-0.6 23-3.4 43.2-6.4 49.6-7.8 124.4-19.4 160.4-21.6 52.2-3 72-0.2 92.8 23.4 20.4 23 29.6 63.2 7.4 95.4 1.6 1.4 3.8 3.4 5.8 5 11.6 9.6 30.8 25.6 30.8 58.2 0 35.8-12 51.6-20 62.2-1.4 1.8-3.2 4.4-3.8 5.6 1.2 2.2 4.8 6.6 7.6 10 10.4 12.4 26.2 31.4 26.2 61.2 0 33.6-25 54.2-39.8 66.4-1.4 1.2-3.2 2.6-4.8 4 0.6 1.2 1.2 2.6 1.6 3.8 5.6 13 15.2 34.6 5.6 57.4-21.8 52.4-88.2 66.8-150.4 74-32.6 3.8-71.6 7.8-112.4 7.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-thumbs-up-outline"
    ]
  },
  {
    "paths": [
      "M896 714.8c0-29.8-15.8-48.6-26.2-61.2-2.8-3.2-6.4-7.6-7.6-10 0.6-1.2 2.4-3.8 3.8-5.6 8-10.4 20-26.4 20-62.2 0-32.8-19.4-48.8-30.8-58.2-1.8-1.6-4.2-3.4-5.8-5 22.2-32.2 13-72.4-7.4-95.4-21-23.6-40.6-26.4-92.8-23.4-36 2.2-111 13.8-160.4 21.6-20.2 3.2-37.8 6-43.2 6.4-25.4 2.6-30.4 0-32.8-9.8-1-4.2 3.8-13.8 9.8-26 8-16.2 19-38.4 29-71.6 20.2-66.4 18-142.4-5.4-184.4-11-19.8-29.6-34.2-52.6-34.2s-40.6 4.8-49.8 15.8c-6.8 8-10.6 23.2-18.4 53.6-6.2 24.8-14 61.8-24 84-15 33.2-79.4 90.2-114 120.8-8.2 7.2-15.2 13.4-20.2 18.2-17.4 16.2-35.2 42.2-51 65.4-10.8 15.6-20.8 30.4-27.4 37-14.2 14.2-33.2 21.8-44.6 21.8-8.8 0-16 7.2-16 16v319.6c0 8.8 7.2 16 16 16 71.4 0 101.4 11.4 133.4 23.6 24.4 9.4 49.8 19 92.8 24.2 64.8 8 148.4 16.2 225.2 16.2 40.8 0 79.8-4 113.2-7.8 62-7.2 128.4-21.6 150.4-74 9.4-22.8 0-44.4-5.6-57.4-0.6-1.2-1-2.4-1.6-3.8 1.6-1.2 3.2-2.8 4.8-4 14.2-12.2 39.2-32.6 39.2-66.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-thumbs-up"
    ]
  },
  {
    "paths": [
      "M566.4 352l-35.6 118.8-12.4 41.2h105.6l-138.4 219.6 31-115.4 10.8-40.4h-145.6l49.8-224h134.8zM609.4 320h-203.4l-64 288h143.6l-85.6 320 282-448h-120.6l48-160z",
      "M748.8 283.8l-26.6-0.2c-23.4-107.2-110.2-187.6-250.2-187.6s-255.6 100.8-255.6 243l0.6 9.6c-84.4 11.2-153 90.6-153 179.4 0 94 75.8 176 169.4 176h194.6l8.4-32c-126 0-203 0-203 0-36 0-70.2-16.2-96.4-43.8-26-27.4-40.8-64.8-40.8-102 0-35 13.2-69.6 37-97 23.6-27 54.8-44.4 88.2-49l29.6-4-2-29.8-0.6-8.6c0.2-58.6 23.4-112.6 65.2-151.8s98-58.8 158.4-58.8c58.6 0 110 14.6 148.6 45.8 35.4 28.8 59.8 69.4 70.4 117.4l5.8 26.8c23-1.4 52-1.4 52-1.4 49 0 94.2 17.2 127.4 48.2 33.4 31.2 51.6 74.4 51.6 121.6 0 89.4-67.4 169.4-153.6 183.6 0 0-17.8 2.8-40.4 2.8-7.4 0-140.8 0-140.8 0l-20.4 32h161.4c144 0 226-104 226-220 0-117.2-94.6-200.2-211.2-200.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-thunderstorm-outline"
    ]
  },
  {
    "paths": [
      "M748.8 283.8l-26.6-0.2c-23.4-107.2-110.2-187.6-250.2-187.6s-255.6 100.8-255.6 243l0.6 9.6c-84.4 11.2-153 90.6-153 179.4 0 94 75.8 176 169.4 176h193.6l17.2-64h-141.8l8.6-39 64-288 5.6-25h271.8l-12.4 41.2-35.6 118.8h135.6l-30.8 49-130.4 207h155.2c144 0 226-104 226-220 0-117.2-94.6-200.2-211.2-200.2z",
      "M682 480h-120.6l48-160h-203.4l-64 288h144l-85.8 320z"
    ],
    "grid": 0,
    "tags": [
      "ios-thunderstorm"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z",
      "M512 512h-192v34.6h226.6v-290.6h-34.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-time-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM546 546h-226v-34h192v-256h34v290z"
    ],
    "grid": 0,
    "tags": [
      "ios-time"
    ]
  },
  {
    "paths": [
      "M694.4 928h45.6l-109-106.4-35.2 10.4 32.2 32h-232l32.2-32-34.8-10.4-109.4 106.4h45.6l34.2-32h296.4z",
      "M512 736c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM512 579c-33.6 0-61 27.4-61 61s27.4 61 61 61 61-27.4 61-61-27.4-61-61-61z",
      "M674 128h-34c0-17.6-14.4-32-32-32h-192c-17.6 0-32 14.4-32 32h-30c-70.6 0-130 55.4-130 126v448c0 70.6 288 130 288 130s288-59.4 288-130v-448c0-70.6-55.4-126-126-126zM418 128h188v32h-188v-32zM768 701c0 3.2-17.4 28.6-130 63.8-54.4 17-107.4 30.8-125.2 34.6-17.8-3.8-71-17.4-125.4-34.4-113-35.2-129.4-60.6-131.4-63.8v-447.2c0-52.4 44.6-94 98-94h30c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32h34c25.6 0 49 9.4 66.8 27.2s27.2 41.2 27.2 66.8v447z",
      "M672 288c0 0 0 0 0 0v128c0 0 0 0 0 0h-320c0 0 0 0 0 0v-127.8c0 0 0-0.2 0-0.2h320zM672 256h-320c-17.6 0-32 14.4-32 32v128c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32v-128c0-17.6-14.4-32-32-32v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-train-outline"
    ]
  },
  {
    "paths": [
      "M595.8 832l32.2 32h-232l32.2-32-34.8-10.4-109.4 106.4h45.6l34.2-32h296.4l34.2 32h45.6l-109-106.4z",
      "M674 128h-34c0-17.6-14.4-32-32-32h-192c-17.6 0-32 14.4-32 32h-30c-70.6 0-130 55.4-130 126v448c0 70.6 288 130 288 130s288-59.4 288-130v-448c0-70.6-55.4-126-126-126zM418 128h188v32h-188v-32zM512 736c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM704 416c0 17.6-14.4 32-32 32h-320c-17.6 0-32-14.4-32-32v-128c0-17.6 14.4-32 32-32h320c17.6 0 32 14.4 32 32v128z",
      "M512 579c-33.6 0-61 27.4-61 61s27.4 61 61 61 61-27.4 61-61-27.4-61-61-61z"
    ],
    "grid": 0,
    "tags": [
      "ios-train"
    ]
  },
  {
    "paths": [
      "M854.6 832l68.6-68.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-68.6 68.6-54.6-54.6c34.4-51 54.6-112.6 54.6-178.8 0-98.8-44.8-187.2-115.2-246l179.2-178v152c0 8.8 7.2 16 16 16s16-7.2 16-16v-192c0-8.8-7.2-16-16-16h-192c-8.8 0-16 7.2-16 16s7.2 16 16 16h152l-181.4 182.4c-51-34.4-112.4-54.4-178.6-54.4s-127.6 20-178.6 54.4l-54.4-54.8 66.4-66.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66.4 66.4-104.4-105h152c8.8 0 16-7.2 16-16s-7.2-16-16-16h-192c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-152l105 104.4-70.4 70.4c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l70.4-70.4 51.6 51.2c-70.6 58.6-115.4 147-115.4 245.8 0 176.8 143.2 320 320 320 98.8 0 187.4-44.8 246-115.4l51.4 51.4-68.6 68.6c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l68.6-68.6 68.6 68.6c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-69-68.6zM715.6 779.6c-54.4 54.4-126.6 84.4-203.6 84.4s-149.2-30-203.6-84.4c-54.4-54.4-84.4-126.6-84.4-203.6s30-149.2 84.4-203.6c54.4-54.4 126.6-84.4 203.6-84.4s149.2 30 203.6 84.4c54.4 54.4 84.4 126.6 84.4 203.6s-30 149.2-84.4 203.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-transgender"
    ]
  },
  {
    "paths": [
      "M944 792h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16h184l-328.8-328.4-167.8 168.2c-3 3-7 4.8-11.4 4.8-4.2 0-8.4-1.6-11.4-4.6l-316.4-316.8c-3.2-3.2-4.2-7.4-4.2-11.8 0-4.2 1.2-7.8 4.2-10.8 3.2-3.2 7.2-4.6 11.4-4.6 4 0 8.2 1.6 11.4 4.6l305 305.4 167.8-168c6.2-6.2 16.4-6.2 22.6 0l341.6 338.6v-184c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 15.4-16 15.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-trending-down"
    ]
  },
  {
    "paths": [
      "M944 256h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-328.8 328.8-167.8-168c-3-3-7-4.6-11.4-4.6-4.2 0-8.4 1.6-11.4 4.6l-316.4 316.4c-3.2 3.2-4.2 7.4-4.2 11.8 0 4.2 1.2 7.8 4.2 11 3.2 3.2 7.2 4.6 11.4 4.6 4 0 8.2-1.6 11.4-4.6l305-305.4 167.8 168c6.2 6.2 16.4 6.2 22.6 0l341.6-338.6v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16z"
    ],
    "grid": 0,
    "tags": [
      "ios-trending-up"
    ]
  },
  {
    "paths": [
      "M768 192c0-38.6 0-64 0-64h-512c0 0 0 25.4 0 64h-160v16c0 164 61 264.4 164 271.6 25.8 98.4 167.8 151.6 236 159.4v225h-176v32h384v-32h-176v-225c68.2-7.8 210.2-61 236-159.4 103-7.2 164-107.4 164-271.6v-16h-160zM161.4 376.6c-14.2-27.4-31.2-75.6-33.2-152.6h127.8c0 65.8 0 153.6 0 222.8-40-5.4-73-28.8-94.6-70.2zM736 448c0 54.6-47.8 93.4-87.8 116.2-53 30.2-111.4 43.8-136.2 43.8s-83.2-13.6-136.2-43.8c-40-23-87.8-61.6-87.8-116.2v-288h448v288zM862.6 376.6c-21.6 41.4-54.6 64.8-94.6 70.2 0-69.2 0-157 0-222.8h127.8c-2 77-19 125.2-33.2 152.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-trophy-outline"
    ]
  },
  {
    "paths": [
      "M768 192c0-38.6 0-64 0-64h-512c0 0 0 25.4 0 64h-160v16c0 164 61 264.4 164 271.6 25.8 98.4 167.8 151.6 236 159.4v225h-176v32h384v-32h-176v-225c68.2-7.8 210.2-61 236-159.4 103-7.2 164-107.4 164-271.6v-16h-160zM161.4 376.6c-14.2-27.4-31.2-75.6-33.2-152.6h127.8c0 65.8 0 153.6 0 222.8-40-5.4-73-28.8-94.6-70.2zM862.6 376.6c-21.6 41.4-54.6 64.8-94.6 70.2 0-69.2 0-157 0-222.8h127.8c-2 77-19 125.2-33.2 152.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-trophy"
    ]
  },
  {
    "paths": [
      "M542 129.6c0-0.6 0-1 0-1.6 0-17.6-13.6-32-30-32s-30 14.4-30 32c0 0.4 0 1 0 1.4-216 16-385.6 207.4-385.6 444 0 0.8-0.4 1.6-0.4 2.6h6.4c12.8-46 52.4-79.6 99.2-79.6 46.6 0 86 33.8 99 79.6h9.8c12.8-46 52.8-79.6 99.6-79.6 36.8 0 70 21 88 52.6v299c0 26.4-22 48-48.4 48s-48.2-21.6-48.2-48c0-8.8-7.2-16-16.2-16-8.8 0-16 7.2-16 16 0 44.2 36.4 80 80.4 80s80.4-35.8 80.4-80v-297.6c18-32.4 50.6-54 88-54 46.6 0 85.6 33.8 98.6 79.6h9.8c12.8-46 52.4-80 99.2-80 47 0 86.8 33.8 99.4 80h3.2c-4-233.2-172.2-429.6-386.2-446.4zM825.6 463.8c-41.8 0-79.2 20.2-104.2 51.8-24.8-31.6-62.2-51.6-104-51.6s-79.2 20.2-104 51.8c-24.8-31.6-62.2-51.8-104-51.8s-79.2 20.2-104 51.8c-24.8-31.6-62.2-51.8-104-51.8-23 0-44.6 6-63.6 16.8 15-71.4 47.2-137.4 94.4-191.4 66-75.4 155.6-121 252-128.2 0 0 13.2-0.8 28.6-0.8 15.6 0 26.4 1 26.4 1 96 7.6 185.6 55 252.4 133.8 44.6 52.6 76 115.2 92 182.6-17.6-9.2-37.4-14-58-14z"
    ],
    "grid": 0,
    "tags": [
      "ios-umbrella-outline"
    ]
  },
  {
    "paths": [
      "M542 129.6c0-0.6 0-1 0-1.6 0-17.6-13.6-32-30-32s-30 14.4-30 32c0 0.4 0 1 0 1.4-216 16-385.6 207.4-385.6 444 0 0.8-0.4 1.6-0.4 2.6h6.4c12.8-46 52.4-79.6 99.2-79.6 46.6 0 86 33.8 99 79.6h9.8c12.8-46 52.8-79.6 99.6-79.6 36.8 0 70 21 88 52.6v299c0 26.4-22 48-48.4 48s-48.2-21.6-48.2-48c0-8.8-7.2-16-16.2-16-8.8 0-16 7.2-16 16 0 44.2 36.4 80 80.4 80s80.4-35.8 80.4-80v-297.6c18-32.4 50.6-54 88-54 46.6 0 85.6 33.8 98.6 79.6h9.8c12.8-46 52.4-80 99.2-80 47 0 86.8 33.8 99.4 80h3.2c-4-233.2-172.2-429.6-386.2-446.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-umbrella"
    ]
  },
  {
    "paths": [
      "M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z",
      "M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM800 896h-576v-416h576v416z"
    ],
    "grid": 0,
    "tags": [
      "ios-unlock-outline"
    ]
  },
  {
    "paths": [
      "M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z",
      "M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984z"
    ],
    "grid": 0,
    "tags": [
      "ios-unlock"
    ]
  },
  {
    "paths": [
      "M660.8 639.8c27-35.8 43.2-79.8 43.2-127.8s-16.2-92-43.2-127.8l-26.6 19.6c22.8 30.2 36.4 67.6 36.4 108.2s-13.6 78-36.4 108.2l26.6 19.6z",
      "M435.8 432h-115.8v160h115.8l138.2 112v-384z"
    ],
    "grid": 0,
    "tags": [
      "ios-volume-down"
    ]
  },
  {
    "paths": [
      "M499.8 432h-115.8v160h115.8l140.2 112v-384z"
    ],
    "grid": 0,
    "tags": [
      "ios-volume-mute"
    ]
  },
  {
    "paths": [
      "M730 776c60-70.4 94-168 94-264s-31.2-184.6-83.8-256.2l-27.2 20.6c48.4 65.8 77.2 147.4 77.2 235.6s-28.8 169.8-77.2 235.6l17 28.4z",
      "M702.4 512c0-71.8-24-138-64-191.6l-27 20.2c35.8 48 57.2 107.2 57.2 171.6 0 42.8-9.6 83.4-26.6 120l20.2 34.6c25.6-46 40.2-98.6 40.2-154.8z",
      "M587.8 512c0-48-16.4-92-43.6-127.8l-27 19.6c16 20.8 27.4 45 33 71.4l36.2 61.6c1-8 1.4-16.4 1.4-24.8z",
      "M316.8 432h-116.8v160h116.8l139.2 112v-185.6l-79-134.8z",
      "M325.6 160l-29.6 17 402.4 687 29.6-17z"
    ],
    "grid": 0,
    "tags": [
      "ios-volume-off"
    ]
  },
  {
    "paths": [
      "M748.2 256l-27.2 20.6c48.2 65.8 77 147.2 77 235.4s-28.8 169.6-77.2 235.4l27.2 20.6c52.6-71.4 83.8-160 83.8-256s-31-184.6-83.6-256z",
      "M640 703.6c40-53.6 64-119.8 64-191.6s-24-138-64-191.6l-27.2 20.2c35.8 48 57.2 107.2 57.2 171.4s-21.4 123.4-57.2 171.4l27.2 20.2z",
      "M546.2 639.8c27.4-35.8 43.8-79.8 43.8-127.8s-16.4-92-43.8-127.8l-27 19.6c23.2 30.2 37 67.6 37 108.2s-13.8 77.8-37 108.2l27 19.6z",
      "M307.8 432h-115.8v160h115.8l140.2 112v-384z"
    ],
    "grid": 0,
    "tags": [
      "ios-volume-up"
    ]
  },
  {
    "paths": [
      "M416 692.2l-118.8 83.8c-6.4 6-9 15.6-9.2 23.8s2 15 8.2 21.4c6.2 6.6 15.4 10.6 23.8 10.6 8 0 21.8-8.4 28-14.4l122-88.6c6.4-6 10-14.4 10-23.2l16-90-80-80v156.6z",
      "M608 192c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z",
      "M677.8 860.4l-26.6-201.4c-0.8-6-3.4-11.6-7.2-16.2l-99.8-118v-213.4c0-19.4-26.4-23.4-32-23.4h-64c-5 0-9.8 1.2-14.4 3.4l-119 59.4c-17.4 9.2-26.8 26.6-26.8 49.2v112c0 17.6 14.4 32 32 32s32-14.4 32-32v-108.2l64-32v140.2l173 173 25.4 184c2.2 16 16 26.8 31.6 26.8h3.6c17.4-2.2 30.6-18 28.2-35.4z",
      "M726.2 471.6l-166.2-165v90.2l121.2 120.2c12.6 12.4 32.8 12.4 45.2-0.2 6.2-6.2 9.6-12.8 9.6-20.8-0-8.2-3.4-18-9.8-24.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-walk"
    ]
  },
  {
    "paths": [
      "M512 736c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32s-14.4-32-32-32z",
      "M488.4 547.4v-131.4h48v131.4l-12 140.6h-24l-12-140.6z",
      "M512 195l362.4 669h-724.8l362.4-669zM512 128l-416 768h832l-416-768z"
    ],
    "grid": 0,
    "tags": [
      "ios-warning-outline"
    ]
  },
  {
    "paths": [
      "M512 128l-416 768h832l-416-768zM488.4 416h48v131.4l-12 140.6h-24l-12-140.6v-131.4zM512 800c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-warning"
    ]
  },
  {
    "paths": [
      "M255.8 752c0-4 1.4-8 4.4-11 6.2-6.4 16.2-6.6 22.6-0.4 41.8 40 93.6 61.6 158.6 65.6 38 2.4 54.2 11.6 70 20.6 18.6 10.6 37.8 21.4 108.4 21.4 143.4 0 244-118.4 244-264v-112c0-49.4-6-97.8-32.2-139.6-25.6-40.8-53.8-74-96.6-95.8-7.8-4-11-13.6-7-21.6 4-7.8 13.6-11 21.6-7 48 24.4 80.4 61.6 109.2 107.2 29.6 47 37 101.2 37 156.6v112c0 163.2-115 296-276 296-78.8 0-102.8-13.6-124-25.6-14.4-8.2-25.6-14.6-56.4-16.4-72.8-4.6-131.2-28.8-178.6-74.4-3.2-3.2-5-7.4-5-11.6z",
      "M545.4 804c0-0.8 0-1.8 0.2-2.6 1.4-8.8 9.6-14.6 18.4-13.2 71 11.6 132.2-4.8 177-47.8 6.4-6.2 16.6-5.8 22.6 0.4 6.2 6.4 5.8 16.6-0.4 22.6-52.4 50.2-123 69.6-204.2 56.2-8-1.2-13.6-8-13.6-15.6z",
      "M128 584v-112c0-55.4 7.6-109.6 37-156.6 28.6-45.6 61.2-82.8 109.2-107.2 7.8-4 17.6-0.8 21.6 7s0.8 17.6-7 21.6c-42.8 21.8-71 55-96.6 95.8-26.4 41.6-32.4 90-32.4 139.4v112c0 69.6 18 140.2 77.6 193.8 60.6 54.8 142 86.2 223.2 86.2 8.8 0 16 7.2 16 16s-7.2 16-16 16c-89 0-178-34.4-244.6-94.4-66.2-59.8-88-139-88-217.6z",
      "M646.4 208c0 20.987-17.013 38-38 38s-38-17.013-38-38c0-20.987 17.013-38 38-38s38 17.013 38 38z",
      "M750.6 258c-3.8 1.2-7.8 2-12.2 2-21 0-38-17-38-38s17-38 38-38c11.4 0 21.4 4.8 28.4 12.6-6-38.8-39.6-68.6-80-68.6h-350c-39.2 0-72.2 28-79.6 65.4 6.8-6 15.6-9.4 25.2-9.4 21 0 38 17 38 38s-17 38-38 38c-3 0-5.8-0.4-8.6-1 14.8 17.8 37.6 29 63 29h350c25.8 0 49.2-11.6 63.8-30zM554.4 208c0-29.8 24.2-54 54-54s54 24.2 54 54-24.2 54-54 54c-29.4 0-54-24.2-54-54z"
    ],
    "grid": 0,
    "tags": [
      "ios-watch"
    ]
  },
  {
    "paths": [
      "M511.6 136c60.4 48.2 116.2 108 166.2 178.4 82.2 115.4 122 222.8 122 328.6 0 139.4-129.2 252.8-288.2 252.8-98.2 0-188.6-43.4-241.8-115.8-10.8-14.6-19.8-30.2-26.8-46.2-12.6-29.2-19.2-59.6-19.2-90.8 0-0.6 0-1.6 0-2.4 0-1.4 0.2-3 0.2-4.6 2-105.2 42-210.4 122.2-321.6 69-95.6 130.6-151 165.4-178.4zM512.2 96c-46.2 32-117.2 96.2-191.6 199.6s-125.8 215.6-128.2 340c0 2.4-0.2 5-0.2 7.4 0 36.6 7.8 71.6 21.8 103.6 8.2 18.6 18.4 36 30.4 52.4 57 77.6 155.6 128.8 267.6 128.8 176.8 0 320.2-127.6 320.2-284.8 0-126.8-54-243.2-128-347.2s-145.2-164.8-192-199.8v0z",
      "M531.8 822c-31.6 0-65.4-2.8-91.8-14.8 174-27.2 238-91.2 279.6-244.4 10.4 22.4 12.4 47.4 12.4 73.6 0 102.4-89.6 185.6-200.2 185.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-water-outline"
    ]
  },
  {
    "paths": [
      "M704 296c-74-104-145-165-192-200-46.2 32-117.2 96.2-191.6 199.6s-125.8 215.6-128.2 340c0 2.4-0.2 5-0.2 7.4 0 36.6 7.8 71.6 21.8 103.6 8.2 18.6 18.4 36 30.4 52.4 57 77.6 155.6 128.8 267.6 128.8 176.8 0 320.2-127.6 320.2-284.8 0-126.6-54-243-128-347zM531.8 822c-31.6 0-65.4-2.8-91.8-14.8 174-27.2 238-91.2 279.6-244.4 10.4 22.4 12.4 47.4 12.4 73.6 0 102.4-89.6 185.6-200.2 185.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-water"
    ]
  },
  {
    "paths": [
      "M512 224c144.6 0 293 58.2 402.8 156.8l-30.8 32.6c-45.8-40.8-97.4-73.6-154-97.4-69-29.2-142.4-44-218-44s-149 14.8-218 44c-56.6 24-108.2 56.6-154 97.4l-30.8-32.6c109.8-98.6 258.2-156.8 402.8-156.8zM512 192c-166 0-332.2 71.6-448 187.4l74.6 79.2c48.6-48.6 105-86.6 167.8-113.2 65.2-27.4 134.2-41.4 205.6-41.4s140.4 14 205.4 41.4c62.8 26.6 119.4 64.6 167.8 113.2l74.6-79.2c-115.6-115.8-281.8-187.4-447.8-187.4v0z",
      "M512 450c91.2 0 177.8 31.8 246.8 89.8l-34 34c-59.8-49.2-134.4-76-212.8-76s-153 26.8-212.8 76l-34-34c69-58 155.6-89.8 246.8-89.8zM512 418c-114.4 0-218 46.2-293.2 120.8l79.2 79.2c57.4-56.8 133.2-88 214-88s156.6 31.2 214 88l79.2-79.2c-75.2-74.6-178.8-120.8-293.2-120.8v0z",
      "M512 674c30.8 0 59.8 10.8 82.6 30.2l-82.6 82.6-82.6-82.6c22.8-19.4 51.8-30.2 82.6-30.2zM512 642c-51.8 0-97.8 24.6-127.2 62.8l127.2 127.2 127.2-127.2c-29.4-38.2-75.4-62.8-127.2-62.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-wifi-outline"
    ]
  },
  {
    "paths": [
      "M512 192c-166 0-332.2 71.6-448 187.4l74.6 79.2c48.6-48.6 105-86.6 167.8-113.2 65.2-27.4 134.2-41.4 205.6-41.4s140.4 14 205.4 41.4c62.8 26.6 119.4 64.6 167.8 113.2l74.6-79.2c-115.6-115.8-281.8-187.4-447.8-187.4v0z",
      "M512 418c-114.4 0-218 46.2-293.2 120.8l79.2 79.2c57.4-56.8 133.2-88 214-88s156.6 31.2 214 88l79.2-79.2c-75.2-74.6-178.8-120.8-293.2-120.8v0z",
      "M512 642c-51.8 0-97.8 24.6-127.2 62.8l127.2 127.2 127.2-127.2c-29.4-38.2-75.4-62.8-127.2-62.8v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-wifi"
    ]
  },
  {
    "paths": [
      "M528 650c0-44 41-77.4 80.4-109.6 15.8-13 30.8-25 43-38 53-55.4 52.4-103.4 52.4-142.2v-8.2c0-88.4-61.6-249.2-64-256h-256c-2.4 6.8-64 167-64 256v8.2c0 38.6-0.6 86.8 52.4 142.2 12.2 12.8 27.2 25 43 38 39.8 32.2 80.8 65.6 80.8 109.6v246h-144v32h320v-32h-144v-246zM405.4 128h213.2c10.8 32 39 125.4 49.6 192h-312.4c10.6-66.6 39-160 49.6-192zM512 578.8c-6 0-10.4-1.8-14.4-5.6 0 0 0 0 0 0-17.6-21.6-40.4-40.4-62-57.8-15-12.2-29.2-23.8-40.2-35.2-44.2-46-43.8-81.8-43.6-119.8 0-2.8-0.2-5.6 0-8.6h320c0.2 2.8 0 5.6 0 8.6 0.2 38 0.6 73.8-43.6 119.8-11 11.4-25.2 23-40.2 35.2-21.4 17.6-44.4 36.2-62 57.8 0 0 0 0 0 0-3.6 3.8-8 5.6-14 5.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-wine-outline"
    ]
  },
  {
    "paths": [
      "M528 650c0-44 41-77.4 80.4-109.6 15.8-13 30.8-25 43-38 53-55.4 52.4-103.4 52.4-142.2v-8.2c0-88.4-61.6-249.2-64-256h-256c-2.4 6.8-64 167-64 256v8.2c0 38.6-0.6 86.8 52.4 142.2 12.2 12.8 27.2 25 43 38 39.8 32.2 80.8 65.6 80.8 109.6v246h-144v32h320v-32h-144v-246zM405.4 128h213.2c10.8 32 39 125.4 49.6 192h-312.4c10.6-66.6 39-160 49.6-192z"
    ],
    "grid": 0,
    "tags": [
      "ios-wine"
    ]
  },
  {
    "paths": [
      "M572 992c-12.2 0-23.6-4.6-32-13.2-6.4-6.6-14.2-18.2-14.2-37.2v-238.8h-27.8v238.8c0 19-8 30.8-14.8 37.4-8.6 8.4-20.2 13-32.6 13s-23.8-4.6-32.6-13c-6.8-6.6-14.8-18.2-14.8-37.4v-238.8h-87.8l89-341.2h-13.6l-48.8 180.8c-8 26.2-27.4 35.6-42.8 35.6 0 0 0 0 0 0-13.2 0-25.8-6.4-34-17.4-9.6-12.8-12.2-29.8-7.2-47.8l58-208.2c8.4-30.4 41.4-76.4 97.4-78.6h196.8c56.8 2.4 88.2 52 97 77.8l0.2 0.8 58 208.6c4.8 18 2 35.2-7.8 48-8.2 10.8-20.8 17.2-33.8 17.2-15.4 0-34.6-9.6-42.6-36.2v-0.4l-48.6-180.2h-15.4l91 341.2h-90.2v238.8c0 19-7.8 30.6-14.2 37.2-8.4 8.6-19.6 13.2-31.8 13.2zM466.6 671h90.6v270.6c0 13.6 7.6 18.4 14.8 18.4s14.8-4.8 14.8-18.4v-270.6h80.6l-91-341.2h80.6l55 203.4c2.4 8.4 7 13.2 12.2 13.2 3.2 0 6.6-1.8 8.8-4.8 3.6-4.8 4.4-12 2.2-20.2l-57.8-207.8c-5.2-15.2-27.2-54-68-55.8h-194.8c-43.4 2-64.2 41.6-68 55.4l-57.8 208.2c-2.2 8.2-1.6 15.2 2 19.8 2.2 3 5.6 4.8 9 4.8v0c5.4 0 10-4.6 12.6-12.8l54.8-203.4h78.6l-89 341.2h78.4v270.6c0 17.6 13.2 18.4 15.8 18.4s15.8-0.8 15.8-18.4v-270.6z",
      "M511.8 212.8c-48.4 0-87.8-40.6-87.8-90.4s39.4-90.4 87.8-90.4 87.8 40.6 87.8 90.4-39.4 90.4-87.8 90.4zM511.8 64c-31 0-56.4 26.2-56.4 58.4s25.2 58.4 56.4 58.4 56.4-26.2 56.4-58.4-25.2-58.4-56.4-58.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-woman-outline"
    ]
  },
  {
    "paths": [
      "M572 992c-12.2 0-23.6-4.6-32-13.2-6.4-6.6-14.2-18.2-14.2-37.2v-238.8h-27.8v238.8c0 19-8 30.8-14.8 37.4-8.6 8.4-20.2 13-32.6 13s-23.8-4.6-32.6-13c-6.8-6.6-14.8-18.2-14.8-37.4v-238.8h-87.8l89-341.2h-13.6l-48.8 180.8c-8 26.2-27.4 35.6-42.8 35.6v0c-13.2 0-25.8-6.4-34-17.4-9.6-12.8-12.2-29.8-7.2-47.8l58-208.2c8.4-30.4 41.4-76.4 97.4-78.6h196.8c56.8 2.4 88.2 52 97 77.8l0.2 0.8 58 208.6c4.8 18 2 35.2-7.8 48-8.2 10.8-20.8 17.2-33.8 17.2-15.4 0-34.6-9.6-42.6-36.2v-0.4l-48.6-180.2h-15.4l91 341.2h-90.2v238.8c0 19-7.8 30.6-14.2 37.2-8.4 8.6-19.6 13.2-31.8 13.2z",
      "M511.8 212.8c-48.4 0-87.8-40.6-87.8-90.4s39.4-90.4 87.8-90.4 87.8 40.6 87.8 90.4-39.4 90.4-87.8 90.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-woman"
    ]
  },
  {
    "paths": [
      "M288 536.8v179.2c0 13.8 9 28 22.8 28h57.2v104c0 26.6 21.4 48 48 48s48-21.4 48-48v-104h98v104c0 15 6.8 28.4 17.6 37.2 7.8 6.8 18.2 10.8 29.4 10.8 0.2 0 0.4 0 0.6 0s0.2 0 0.4 0c26.6 0 48-21.4 48-48v-104h55.2c14 0 22.8-14.2 22.8-27.8v-332.2h-448v152.8z",
      "M816 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z",
      "M208 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z",
      "M622.4 178.2l37-43.8c0.8-1-0.4-3.2-2.6-5-2.2-1.6-4.8-2-5.4-0.8l-38.4 45.6c-27.2-10.8-60.4-17.6-101.2-17.6-41-0.2-74.4 6.4-101.6 17l-38-44.8c-0.8-1-3.2-0.8-5.4 0.8s-3.4 3.6-2.6 5l36.6 43.2c-96.4 41.8-110.8 144.4-112.8 174.4h447.2c-1.8-30.2-16-131.4-112.8-174zM413.6 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12 26.6-27 26.6zM610.4 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12.2 26.6-27 26.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-android"
    ]
  },
  {
    "paths": [
      "M427.146 512h169.692l-84.854-178.712z",
      "M511.962 64l-447.962 160 92.24 544 355.76 192 355.5-192 92.5-544-448.038-160zM688 704l-53.178-112h-245.654l-53.168 112h-80l256-560 256 560h-80z"
    ],
    "grid": 0,
    "tags": [
      "logo-angular"
    ]
  },
  {
    "paths": [
      "M667.2 307.8c-67.2 0-95.6 33-142.4 33-48 0-84.6-32.8-142.8-32.8-57 0-117.8 35.8-156.4 96.8-54.2 86-45 248 42.8 386 31.4 49.4 73.4 104.8 128.4 105.4 0.4 0 0.6 0 1 0 47.8 0 62-32.2 127.8-32.6 0.4 0 0.6 0 1 0 64.8 0 77.8 32.4 125.4 32.4 0.4 0 0.6 0 1 0 55-0.6 99.2-62 130.6-111.2 22.6-35.4 31-53.2 48.4-93.2-127-49.6-147.4-234.8-21.8-305.8-38.4-49.4-92.2-78-143-78v0z",
      "M652.4 128c-40 2.8-86.6 29-114 63.2-24.8 31-45.2 77-37.2 121.6 1 0 2 0 3.2 0 42.6 0 86.2-26.4 111.6-60.2 24.6-32.2 43.2-77.8 36.4-124.6v0z"
    ],
    "grid": 0,
    "tags": [
      "logo-apple"
    ]
  },
  {
    "paths": [
      "M821 558.4c-10-23-25.4-43.2-56.2-60.2-16.4-9-32.2-15.6-50.8-20 10.8-5 20-10.8 32.6-22 15-13.2 26.2-31.4 31.2-46.6 5.2-15 8.2-36 7-56.4-2.2-33.6-8.8-66.2-26.4-89.6s-42.4-41.4-75.2-54c-25.2-9.6-51-15.6-91-17.8v-127.8h-80v128h-64v-128h-82v128h-174.2v96h55.8c17.4 0 29.2 1.6 35.2 4.6 6.2 3 10.6 7 13 12 2.6 5 3.8 16.8 3.8 35v346.4c0 18-1.2 29.6-3.8 34.8s-4 9.8-10.2 12.6c-6.2 2.8-6.4 2.6-23.6 2.6h-52.8l-17.4 96h174v128h82v-128h64v128h80v-128.8c52-2.6 89-9.4 118.8-20.6 38.6-14.4 68.2-35.4 89.4-63s29.8-69.8 31.6-102.4c1.4-29-1.8-66.4-10.8-86.8zM448 300h64v148h-64v-148zM448 724v-180h64v180h-64zM592 307.8c12 5 19.8 15 27.6 25.4 8.6 11.4 13 26.6 13 42.8 0 15.6-5.8 29-15 41-7.6 9.8-13.6 16.6-25.6 22.2v-131.4zM649.6 681.2c-15.6 13.8-24.6 20.2-44.2 27.6-4 1.6-9.4 2.8-13.4 3.8v-165.6c10 1.6 15.2 3.6 22.6 6.8 15.6 6.6 30.4 13.8 39.6 26.4s16 31.2 16 49.4c0 21.8-5.6 38.4-20.6 51.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-bitcoin"
    ]
  },
  {
    "paths": [
      "M141.4 329l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c17.8-8.6 17.8-22.6 0-31.2l-338.4-163.4c-8.8-4.2-20.6-6.4-32.2-6.4s-23.4 2.2-32.2 6.4l-338.4 163.4c-17.8 8.6-17.8 22.6 0 31.2z",
      "M882.6 496.4c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.6 120.4-249.6 120.4c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18.2-8.4 18.2-22.4 0.4-31z",
      "M882.6 695c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.4 120.6-249.4 120.6c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.4 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18-8.6 18-22.6 0.2-31.2z"
    ],
    "grid": 0,
    "tags": [
      "logo-buffer"
    ]
  },
  {
    "paths": [
      "M377.6 511.85c0 73.892 60.486 134.356 134.4 134.356s134.398-60.462 134.398-134.356c0-73.89-60.484-134.358-134.398-134.358s-134.4 60.468-134.4 134.358z",
      "M953.504 435.59c-0.018 0.010-0.032 0.076-0.048 0.084-3.402-19.754-8.080-39.676-13.978-57.676h-0.214c5.966 18 10.704 38 14.144 58h-0.004c-3.438-20-8.176-40-14.14-58h-310.78c38.088 34 62.716 80.35 62.716 134.104 0 33.592-8.968 62.568-24.628 89.448l-204.484 355.354c0 0-0.018 0.528-0.028 0.528l-0.020 0.568c0.010 0 0.018 0 0.030 0l-0.010-0.524c16.406 1.84 33.062 2.524 49.94 2.524 13.684 0 27.218-0.786 40.598-2.004 20.27-1.822 40.154-5.038 59.554-9.466 199.208-45.48 347.848-223.722 347.848-436.648 0-25.998-2.242-51.506-6.496-76.292z",
      "M512 690.992c-67.202 0-123.202-35.82-154.57-89.57l-205.692-355.8c-20.586 27.792-38.030 58.044-51.806 90.246-23.118 54.022-35.932 113.504-35.932 175.982 0 125.39 51.568 238.72 134.632 320.018 58.684 57.438 133.090 98.866 216.176 117.238l0.058-0.102 155.366-269.208c-17.918 6.716-38.062 11.196-58.232 11.196z",
      "M182.584 209.15l154.7 266.5c15.682-80.624 87.346-143.65 174.716-143.65h410.344c-13.842-30-31.188-60.648-51.558-87.876 0.078 0.042 0.156 0.106 0.234 0.148 20.268 27.152 37.536 57.728 51.324 87.728h0.344c-13.768-30-31.028-60.76-51.336-87.98-0.23-0.12-0.458-0.336-0.684-0.514-81.718-108.972-211.95-179.506-358.668-179.506-52.744 0-103.346 9.138-150.344 25.872-69.23 24.654-130.606 65.834-179.374 118.812l0.284 0.486c0.006-0.008 0.012-0.014 0.018-0.020z"
    ],
    "grid": 0,
    "tags": [
      "logo-chrome"
    ]
  },
  {
    "paths": [
      "M482.478 607.872c-30.644-20.714-61.484-41.138-92.124-61.86-4.060-2.746-6.86-2.944-11.004-0.058l-77.742 52.308c62.324 41.548 186.392 124.372 186.392 124.372v-107.572c-0.024-2.448-3.106-5.56-5.522-7.19z",
      "M390.184 481.332c30.908-20.32 61.702-40.818 92.218-61.72 2.972-2.036 5.55-7.018 5.598-10.668v-103.412c0 0-124.066 82.248-186.524 123.884 27.4 18.318 53.342 35.826 79.574 52.886 2.040 1.324 6.792 0.568 9.134-0.97z",
      "M539.676 418.708c31.622 21.406 63.366 42.628 95.254 63.63 1.832 1.208 5.84 1.204 7.678 0l79.502-52.934-186.11-124.436v106.7c0.020 2.402 1.61 5.642 3.676 7.040z",
      "M516.218 460.738c-2.42-1.604-7.222-1.056-9.486 0.336-9.634 5.924-18.926 12.406-28.328 18.71-16.496 11.060-50.712 34.046-50.712 34.046l77.684 51.73c3.496 2.314 8.872 2.44 12.52 0.222l78.028-51.986c0.002 0-68.158-45.402-79.706-53.058z",
      "M282 474.232v79.218l59.244-39.676z",
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM790 594.012c0 11.57-5.304 19.736-15.022 26.188-82.284 54.628-164.502 109.428-246.572 164.376-11.708 7.836-22.348 7.508-33.968-0.274-81.566-54.628-163.438-109.092-245.25-163.352-10.22-6.778-15.188-15.114-15.188-27.46v-159.458c0-12.282 5.042-20.664 15.248-27.432 81.812-54.26 163.878-108.726 245.448-163.352 11.636-7.792 22.188-8.014 33.876-0.19 82.072 54.948 164.252 109.738 246.522 164.39 9.356 6.212 14.906 13.886 14.906 25.32v161.244z",
      "M632.494 546.468c-30.108 20.444-60.376 40.652-90.772 60.664-4.824 3.176-5.776 6.636-5.722 12.378v102.692l186.078-124.008-77.054-51.764c-4.69-3.208-7.86-3.134-12.53 0.038z",
      "M740 553.352v-79.232l-59.18 39.746z"
    ],
    "grid": 0,
    "tags": [
      "logo-codepen"
    ]
  },
  {
    "paths": [
      "M512.564 678.976v0z",
      "M128 64l69.892 806.438 313.642 89.562 314.518-89.7 69.948-806.3h-768zM709.352 733.796l-197.214 56.25-196.916-56.496-13.494-155.55h96.506l6.866 79.124 107.172 30.326 0.264 0.546h0.068l106.934-29.704 11.224-128.292h-224.762l-8-100h241.292l8.792-102h-368.084l-8-98h481.16l-43.808 503.796z"
    ],
    "grid": 0,
    "tags": [
      "logo-css3"
    ]
  },
  {
    "paths": [
      "M580.8 290l-126.8-98 127.2 204.4z",
      "M658 192v326h-72.8l-126.4-197.2 3.4 197.2h-80.2v-214l-74.6-58.6c2 2.4 4 4.8 5.8 7.4 20 27.8 30 61 30 101 0 98.4-61.2 164.2-153.8 164.2h-125.4v0.8l399.2 313.2h496.8v-403.8l-302-236.2z",
      "M259.8 356.2c0-58-28.4-90.2-79.4-90.2h-38.4v178h38c52 0 79.8-30.8 79.8-87.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-designernews"
    ]
  },
  {
    "paths": [
      "M512 128c-212 0-384 172-384 384 0 212.2 172 384 384 384s384-171.8 384-384c0-212-172-384-384-384zM755.8 305c43.2 50.8 70.6 115.2 75.4 185.8-69.2-3.6-152-3.6-218.4 2.6-8.4-21.2-17-42-26.4-62 76.6-33.2 135.6-76.8 169.4-126.4zM512 192c77.6 0 148.8 27.6 204.2 73.6-34.8 44-89.4 82.2-157.4 111.2-37.2-68.8-80-128-125.6-174.6 25.4-6.4 51.6-10.2 78.8-10.2zM367.2 227c46.2 46 89.6 104.6 127.6 173.2-72.2 22-155 34.6-243.4 34.6-16.8 0-33.2-0.6-49.4-1.6 23-90.2 84-165 165.2-206.2zM192.6 496.8c18.2 0.8 36.6 1.2 55.2 1 100.8-1.2 194.6-17 275.2-42.8 7.6 15.8 14.8 32 21.6 48.6-11 2.6-20.8 5.4-28.6 8.6-110.2 46.2-197 120.8-244 211-49.6-56.4-80-130.2-80-211.2 0-5.2 0.2-10.2 0.6-15.2zM512 832c-74 0-142-25.2-196.2-67.4 42.6-84.4 118.6-154.2 214.4-197.6 9-4.2 21-7.6 34.8-10.6 11.4 31.6 21.6 64.4 30.6 98.4 13.8 53 23.6 105.4 29.6 156.2-35.2 13.4-73.2 21-113.2 21zM685 781c-6-51.4-15.8-104.2-29.8-157.8-6.8-26-14.6-51.2-23-75.8 62.8-5.2 138-4.4 197.8 0-10.8 98.2-66 182.6-145 233.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-dribbble"
    ]
  },
  {
    "paths": [
      "M354 154l-226 147.8 156.2 125.4 227.8-141z",
      "M128 552.6l226 147.8 158-132.2-227.8-141z",
      "M512 568.2l158 132.2 226-147.8-156.2-125.4z",
      "M896 301.8l-226-147.8-158 132.2 227.8 141z",
      "M512.4 596.6l-159.6 132-68.8-44.4v49.8l228 136 228-136v-49.8l-68.4 44.4z"
    ],
    "grid": 0,
    "tags": [
      "logo-dropbox"
    ]
  },
  {
    "paths": [
      "M468 544v-96h262.188l14.298-96h-276.486v-3.66c0-71.84 29.95-116.172 158.5-116.172 52.528 0 111.734 4.996 186.378 17.484l19.122-129.92c-76.024-17.486-141.388-23.732-211.886-23.732-229.462 0-328.114 82.45-328.114 234.86v21.14h-100v96h100v96h-100v96h100v53.14c0 152.408 98.594 234.86 328.054 234.86 70.5 0 135.696-6.246 211.718-23.732l-19.238-129.92c-74.644 12.488-133.562 17.484-186.090 17.484-128.552 0-158.446-37.478-158.446-126.172v-25.66h233.59l14.296-96h-247.884z"
    ],
    "grid": 0,
    "tags": [
      "logo-euro"
    ]
  },
  {
    "paths": [
      "M853.6 128h-683.2c-23.4 0-42.4 19-42.4 42.4v683.2c0 23.4 19 42.4 42.4 42.4h341.6v-304h-91.8v-112h91.8v-82.8c0-99.2 68.8-153.2 157.4-153.2 42.4 0 88 3.2 98.6 4.6v103.6h-70.6c-48.2 0-57.4 22.8-57.4 56.4v71.4h114.8l-15 112h-99.8v304h213.6c23.4 0 42.4-19 42.4-42.4v-683.2c0-23.4-19-42.4-42.4-42.4z"
    ],
    "grid": 0,
    "tags": [
      "logo-facebook"
    ]
  },
  {
    "paths": [
      "M753.528 64c0 0-410.706 0-476.446 0-65.75 0-85.082 49.596-85.082 80.828 0 31.254 0 759.28 0 759.28 0 35.182 18.85 48.234 29.436 52.534 10.598 4.31 39.832 7.942 57.346-12.336 0 0 224.938-261.79 228.8-265.668 5.842-5.86 5.842-5.86 11.688-5.86 11.688 0 98.384 0 145.534 0 61.148 0 70.98-43.738 77.368-69.504 5.318-21.578 64.978-327.924 84.904-425.118 15.21-74.17-3.586-114.156-73.548-114.156zM742.172 603.274c5.318-21.578 64.978-327.924 84.904-425.118zM725.384 193.34l-19.998 103.468c-2.39 11.3-16.574 23.19-29.726 23.19-13.15 0-191.834 0-191.834 0-20.88 0.002-35.826 12.278-35.826 33.206v26.896c0 20.946 15.038 35.788 35.93 35.788 0 0 148.964 0 163.696 0 14.748 0 29.22 16.218 26.032 32.010-3.204 15.816-18.172 93.138-19.968 101.78-1.804 8.656-11.69 23.45-29.222 23.45-14.776 0-128.538 0-128.538 0-23.41 0-30.488 3.066-46.148 22.586-15.674 19.54-156.512 189.184-156.512 189.184-1.426 1.644-2.82 1.168-2.82-0.624v-592.482c0-13.368 11.586-29.046 28.958-29.046 0 0 367.426 0 382.346 0 14.070-0.002 27.222 13.262 23.63 30.594z"
    ],
    "grid": 0,
    "tags": [
      "logo-foursquare"
    ]
  },
  {
    "paths": [
      "M1005.2 230c-45-87.4-116-102-116-102s31 64 32 102c0.8 32.2-11 56-54.4 67s-61.6-4-95.6-35-83.2-53-145.2-56c-80-4-154 18-154 18-40-50 40-160 40-160-149 59-187.4 166.6-192 227.4-3.8 48.2 17 81.6 17 81.6s-1 55.6-10 84c-6.2 19.6-33.8 50-52 69-24.4 25.4-25 77 0 114s88 55 134 79 63 42 63 42 2 16.6 1 30.6-6.4 28-18 36.4c-11 7.8-31 1-41-4s-10-12.4-21-16-14.6-8-13-22 4-18-7-37-37-19-59-16-34.6 13.6-34.6 13.6l-32.6-20c0 0 17-31.2 10.4-71.2-14.6-87.6-100-125.6-100-125.6l20.8 88.8c0 0 2.2-5.2 12.8-12.8s16.2-7.2 16.2-7.2 13.2 15.2 18.2 50.6c5 36-13.4 54.4-13.4 54.4l-56.6-36 2-29-77.6-20.6 32.4 73.4 30-8 48 45.4c0 0-31.4 23.4-66 23.4-22 0-44-12-44-12s-2.8-2-1.6-11c1.4-10 13.6-25 13.6-25h-92c0 0 54.6 77.4 130 77.4 62 0 88.4-25 88.4-25l37.6 37.4c0 0 6 11 0 14s-14 7-18 30 36 58 36 58c43.6 35.6 14 64 14 64h544c-18-26-45-36-64-64 0 0-89.6-116.8-3.6-180.8 114.8-85.4 85.6-138.8 82.4-202.8 0 0 63.6-13.2 118.6-67.2s77.8-141.6 39.8-215.2zM390 406c-33.8 9-45 71-45 71 3-126 115-186 130-178s-13 78-42 128c0 0-16-28.2-43-21zM464 436c0 0 36-112 75-119s83 42 83 124-52 130.8-85.6 138.4c-33 7.6-46 4-46 4s55-43.2 47-113.6c-5.6-49.4-62.8-48.4-73.4-33.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-freebsd-devil"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 205.8-448 459.4 0 203 128.4 375 306.4 435.8 2.8 0.6 5.2 0.8 7.6 0.8 16.6 0 23-12.2 23-22.8 0-11-0.4-39.8-0.6-78.2-16.8 3.8-31.8 5.4-45.2 5.4-86.2 0-105.8-67-105.8-67-20.4-53-49.8-67.2-49.8-67.2-39-27.4-0.2-28.2 2.8-28.2 0.2 0 0.2 0 0.2 0 45 4 68.6 47.6 68.6 47.6 22.4 39.2 52.4 50.2 79.2 50.2 21 0 40-6.8 51.2-12 4-29.6 15.6-49.8 28.4-61.4-99.4-11.6-204-51-204-227 0-50.2 17.4-91.2 46-123.2-4.6-11.6-20-58.4 4.4-121.6 0 0 3.2-1 10-1 16.2 0 52.8 6.2 113.2 48.2 35.8-10.2 74-15.2 112.2-15.4 38 0.2 76.4 5.2 112.2 15.4 60.4-42 97-48.2 113.2-48.2 6.8 0 10 1 10 1 24.4 63.2 9 110 4.4 121.6 28.6 32.2 46 73.2 46 123.2 0 176.4-104.8 215.2-204.6 226.6 16 14.2 30.4 42.2 30.4 85 0 61.4-0.6 111-0.6 126 0 10.8 6.2 23 22.8 23 2.4 0 5.2-0.2 8-0.8 178.2-60.8 306.4-233 306.4-435.8 0-253.6-200.6-459.4-448-459.4z"
    ],
    "grid": 0,
    "tags": [
      "logo-github"
    ]
  },
  {
    "paths": [
      "M915.2 448l-4.2-17.8h-387v163.8h231.2c-24 114-135.4 174-226.4 174-66.2 0-136-27.8-182.2-72.6-47.4-46-77.6-113.8-77.6-183.6 0-69 31-138 76.2-183.4 45-45.2 113.2-70.8 181-70.8 77.6 0 133.2 41.2 154 60l116.4-115.8c-34.2-30-128-105.6-274.2-105.6 0 0 0 0 0 0-112.8 0-221 43.2-300 122-78 77.6-118.4 189.8-118.4 293.8s38.2 210.8 113.8 289c80.8 83.4 195.2 127 313 127 107.2 0 208.8-42 281.2-118.2 71.2-75 108-178.8 108-287.6 0-45.8-4.6-73-4.8-74.2z"
    ],
    "grid": 0,
    "tags": [
      "logo-google"
    ]
  },
  {
    "paths": [
      "M636.4 461.8l-3.2-14h-313.2v128.2h181.4c-18.8 90-96.8 127.2-168.2 127.2-52 0-100.4-15.6-136.6-50.6-37.2-36.2-57.8-86.2-57.8-140.8 0-54.2 19.6-103.6 55.2-139.2 35.4-35.4 84-50.8 137.4-50.8 61 0 99.8 27.6 116.2 42.2l96-95.4c-27-23.4-100.6-82.6-215.4-82.6 0 0 0 0 0 0-88.6 0-173.4 33.6-235.4 95.6-61 61-92.8 148.8-92.8 230.4s30 165.2 89.2 226.6c63.4 65.4 153.2 99.4 245.8 99.4 84.2 0 163.8-33 220.6-92.6 56-58.8 84.8-140.2 84.8-225.4-0.2-36-3.8-57.4-4-58.2z",
      "M1024 448h-114v-114h-82v114h-114v82h114v114h82v-114h114z"
    ],
    "grid": 0,
    "tags": [
      "logo-googleplus"
    ]
  },
  {
    "paths": [
      "M128 128v768h768v-768h-768zM556 558v144h-80v-144l-132-240h94.2l79.4 167.2 76-167.2h90.4l-128 240z"
    ],
    "grid": 0,
    "tags": [
      "logo-hackernews"
    ]
  },
  {
    "paths": [
      "M128 64l69.872 806.426 313.666 89.574 314.49-89.708 69.972-806.292h-768zM743.994 328h-368l7.982 102h352.016l-27.010 302.772-197 56.188-197.364-55.952-13.528-155.008h96.508l6.846 78.574 107.538 29.562 106.844-29.83 11.148-128.306h-334.002l-25.142-299.178 481.578 0.032-8.414 99.146z"
    ],
    "grid": 0,
    "tags": [
      "logo-html5"
    ]
  },
  {
    "paths": [
      "M672 511.666c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.366 71.634-160 160-160s160 71.634 160 160z",
      "M355.61 353.774c42.308-42.308 98.558-65.858 158.39-65.858s116.082 23.674 158.39 65.982c26.844 26.844 46.022 59.102 56.464 95.102h168.146v-226c0-53.020-40.98-94-94-94h-576c-53.020 0-98 40.98-98 94v226h170.144c10.444-36 29.622-68.382 56.466-95.226zM833 295.4c0 14.138-11.46 25.6-25.6 25.6h-76.8c-14.138 0-25.6-11.46-25.6-25.6v-76.8c0-14.138 11.46-25.6 25.6-25.6h76.8c14.138 0 25.6 11.46 25.6 25.6v76.8z",
      "M672.39 670.558c-42.308 42.308-98.558 65.358-158.39 65.358s-116.082-22.924-158.39-65.232c-42.23-42.23-65.518-99.684-65.606-157.684h-161.004v286c0 53.020 44.98 98 98 98h576c53.020 0 94-44.98 94-98v-286h-159.004c-0.086 58-23.374 115.328-65.606 157.558z"
    ],
    "grid": 0,
    "tags": [
      "logo-instagram"
    ]
  },
  {
    "paths": [
      "M416 176.002h-160v424.996c0 105.16-36.064 134.522-98.824 134.522-29.41 0-55.896-5.042-76.5-12.126l-16.676 124.414c29.4 10.124 74.518 16.192 109.814 16.192 144.096 0 242.186-67.742 242.186-261.96v-426.038z",
      "M764.926 160c-154.886 0-252.926 87.996-252.926 204.308 0 100.166 75.502 162.88 185.282 203.33 79.4 28.316 110.784 53.616 110.784 95.078 0 45.512-36.278 74.85-104.896 74.85-63.726 0-121.578-21.28-160.788-42.51v-0.042l-30.382 126.44c37.278 21.276 106.882 42.51 182.334 42.51 181.374-0.004 265.666-97.104 265.666-211.396 0-97.1-53.916-159.8-170.556-204.326-86.278-34.382-122.54-53.59-122.54-97.084 0-34.4 31.376-65.738 96.086-65.738 63.692 0 107.488 21.414 133.010 34.582l38.25-128c-40-17.562-93.874-32.002-169.324-32.002v0z"
    ],
    "grid": 0,
    "tags": [
      "logo-javascript"
    ]
  },
  {
    "paths": [
      "M834.4 128h-640.8c-35 0-65.6 25.2-65.6 59.8v642.2c0 34.8 30.6 65.8 65.6 65.8h640.6c35.2 0 61.6-31.2 61.6-65.8v-642.2c0.2-34.6-26.4-59.8-61.4-59.8zM366 768h-110v-342h110v342zM314.8 374h-0.8c-35.2 0-58-26.2-58-59 0-33.4 23.4-59 59.4-59s58 25.4 58.8 59c0 32.8-22.8 59-59.4 59zM768 768h-110v-187c0-44.8-16-75.4-55.8-75.4-30.4 0-48.4 20.6-56.4 40.6-3 7.2-3.8 17-3.8 27v194.8h-110v-342h110v47.6c16-22.8 41-55.6 99.2-55.6 72.2 0 126.8 47.6 126.8 150.2v199.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-linkedin"
    ]
  },
  {
    "paths": [
      "M895.318 192h-766.636c-35.674 0-64.682 28.968-64.682 64.616v510.698c0 35.672 29.008 64.686 64.682 64.686h766.636c35.674 0 64.682-29.014 64.682-64.688v-510.696c0-35.648-29.008-64.616-64.682-64.616zM568.046 704h-112.096v-192l-84.080 107.756-84.044-107.756v192h-112.088v-384h112.088l84.044 135.96 84.080-135.96h112.096v384zM735.36 704l-139.27-192h84v-192h112.086v192h84.054l-140.87 192z"
    ],
    "grid": 0,
    "tags": [
      "logo-markdown"
    ]
  },
  {
    "paths": [
      "M511.834 960c-11.54 0-23.072-3.124-33.266-9.198l-105.97-64.88c-15.828-9.124-8.046-12.406-2.886-14.282 21.13-7.562 27.426-11.314 49.894-24.57 2.412-1.334 5.494-0.848 7.91 0.644l79.42 47.008c2.952 1.7 7.114 1.7 9.862 0l310.376-184.492c2.95-1.754 4.83-5.292 4.83-8.882v-373.61c0-3.7-1.88-7.184-4.898-9.056l-310.24-189.344c-2.956-1.788-6.842-1.788-9.796 0l-310.038 189.41c-3.088 1.806-5.032 5.396-5.032 8.99v373.61c0 3.626 1.944 7.026 4.962 8.778l79.858 47.944c47.22 24.408 75.18-0.34 75.18-29.222v-367.398c0-5.304 4.094-9.454 9.192-9.454h45.618c5.030 0 9.194 4.144 9.194 9.454v367.396c0 65.126-38.706 102.496-98.398 102.496-18.312 0-32.794 0-73.104-20.558l-83.168-49.562c-20.592-12.304-33.334-35.292-33.334-59.91v-378.93c0-24.632 12.742-47.568 33.33-59.834l317.37-189.728c20.054-11.76 46.748-11.76 66.664 0l317.3 189.728c20.596 12.298 33.336 35.25 33.336 59.834v378.93c0 24.618-12.74 47.5-33.336 59.906l-317.3 189.548c-10.194 6.072-21.664 9.198-33.396 9.198l-0.134 0.036z",
      "M609.886 703.996c-129.22 0-168.012-63.22-168.012-118.542 0-5.258 4.096-9.458 9.124-9.458h41.042c4.564 0 8.454 3.4 9.124 8.032 6.168 43.204 33.496 62.3 108.648 62.3 66.798 0 94.182-20.692 94.182-57.368 0-21.184-6.926-36.848-110.814-47.394-86.854-8.882-140.576-28.746-140.576-100.59 0-66.27 53.992-104.98 144.468-104.98 92.256 0 152.924 28 158.346 101.658 0.204 2.674-0.736 5.258-2.482 7.288-1.742 1.93-4.156 3.054-6.706 3.054h-41.182c-4.292 0-8.048-3.124-8.918-7.426-8.802-33.906-33.94-46.804-99.126-46.804-72.972 0-81.492 25.506-81.492 45.214 0 23.926 10.062 30.882 108.588 44.344 97.522 13.326 143.866 32.234 143.866 103.104 0 71.562-57.616 117.566-158.15 117.566l0.070 0.002z"
    ],
    "grid": 0,
    "tags": [
      "logo-nodejs"
    ]
  },
  {
    "paths": [
      "M356.708 574.956c-18.246 0-33.856 8.414-46.402 25.666-12.582 16.956-18.796 37.946-18.796 62.862 0 24.948 6.332 46.016 18.796 63.018 12.546 17.080 28.078 25.542 46.402 25.542 16.988 0 31.778-8.54 44.242-25.542 12.542-17.002 18.796-38.070 18.796-63.018 0-24.838-6.332-45.86-18.796-62.862-12.466-17.174-27.134-25.666-44.242-25.666z",
      "M669.336 574.956c-18.090 0-33.782 8.414-46.364 25.666-12.542 16.956-18.718 37.946-18.718 62.862 0 24.948 6.372 46.016 18.718 63.018 12.582 17.080 28.196 25.542 46.364 25.542 17.066 0 31.812-8.54 44.356-25.542 12.586-17.002 18.836-38.070 18.836-63.018 0-24.838-6.328-45.86-18.836-62.862-12.544-17.174-27.094-25.666-44.356-25.666z",
      "M891.554 344h-0.118c0 0 5.586-28.528 0.628-78.36-4.364-49.832-14.942-95.676-32.246-137.64 0 0-8.844 1.52-25.52 5.792s-44.16 12.598-81.876 29.536c-37.082 17.080-75.972 39.576-116.594 67.010-27.606-7.868-68.816-11.878-123.988-11.878-52.578 0-93.828 4.024-123.954 11.89-89.184-61.718-163.664-95.89-224.184-102.35-17.188 41.964-27.766 87.982-32.090 137.94-4.796 49.878 0.864 78.658 0.864 78.658-48.518 52.504-68.476 128.484-68.476 190.988 0 48.488 1.316 92.156 12.25 130.96 11.128 38.62 25.324 70.26 42.196 94.442 17.222 24.242 38.024 45.576 63.152 63.876 24.934 18.628 47.976 31.924 68.778 40.432 20.922 8.744 44.75 15.204 71.964 19.722 26.66 4.772 46.876 7.29 60.954 7.992 0 0 56 2.988 128.708 2.988s128.59-2.988 128.59-2.988c14.040-0.704 34.29-3.268 61.070-7.992 27.094-4.598 51.042-11.214 71.882-19.722 20.804-8.586 43.886-21.802 68.938-40.432 25.046-18.064 45.812-39.478 63.036-63.876 16.872-24.182 30.988-55.822 42.196-94.442 10.972-38.804 12.29-82.77 12.29-131.258-0.004-60.51-20.040-137.288-68.45-191.288zM760.766 811.29c-55.724 26.182-137.794 36.71-246.644 36.71l-4.286-0.078c-108.886 0-190.722-10.496-245.696-36.82-55.016-26.184-82.542-80.114-82.542-161.476 0-48.66 17.144-87.98 50.964-118.214 14.708-13.030 32.876-22.038 55.29-27.434 22.258-5.116 42.708-5.524 61.938-4.93 18.796 0.83 45.102 4.392 78.688 6.928 33.58 2.594 58.592 6.024 83.522 6.024 23.396 0 54.426-3.914 104.208-7.918 49.98-3.942 86.988-5.942 110.934-2 24.578 4.004 45.972 12.404 64.258 29.484 35.468 31.502 53.204 71.010 53.204 118.168-0.002 81.332-28.276 135.34-83.838 161.556z"
    ],
    "grid": 0,
    "tags": [
      "logo-octocat"
    ]
  },
  {
    "paths": [
      "M512 64c-247.4 0-448 200.6-448 448 0 183.4 110.4 341 268.2 410.4-1.2-31.2-0.2-68.8 7.8-102.8 8.6-36.4 57.6-244.2 57.6-244.2s-14.4-28.6-14.4-70.8c0-66.4 38.4-116 86.4-116 40.8 0 60.4 30.6 60.4 67.2 0 41-26.2 102.2-39.6 159-11.2 47.6 23.8 86.2 70.8 86.2 84.8 0 142-109 142-238.2 0-98.2-66.2-171.6-186.4-171.6-135.8 0-220.6 101.4-220.6 214.6 0 39 11.6 66.6 29.6 87.8 8.2 9.8 9.4 13.8 6.4 25-2.2 8.2-7 28-9.2 36-3 11.4-12.2 15.4-22.4 11.2-62.6-25.6-91.8-94-91.8-171.2 0-127.2 107.4-279.8 320.2-279.8 171 0 283.6 123.8 283.6 256.6 0 175.8-97.8 307-241.8 307-48.4 0-93.8-26.2-109.4-55.8 0 0-26 103.2-31.6 123.2-9.4 34.6-28 69-45 96 40.2 11.8 82.8 18.4 127 18.4 247.4 0 448-200.6 448-448 0.2-247.6-200.4-448.2-447.8-448.2z"
    ],
    "grid": 0,
    "tags": [
      "logo-pinterest"
    ]
  },
  {
    "paths": [
      "M799.6 406c-1.6-34.2-6.6-69-21.6-100.2-8.2-17.2-19.4-33-33-46.4-12.6-12.8-27.2-23.4-42.6-32.6-34.2-20.4-75-34-168.8-62s-149.6-36.8-149.6-36.8v716.6l159.8 51.4c0 0 0.2-397.6 0.2-599v-7.6c0-18.6 15-33.6 32.2-33.6h1c17 0 31 15 31 33.6v266.6c22 10.6 58.4 18.6 83.6 18.2 16.6 0.4 33.4-3.4 48-11.4 15.2-8.2 27.8-20.8 36.8-35.6 10.2-16.6 16.4-35.6 19.8-54.6 3.8-21.6 4-44.2 3.2-66.6z",
      "M173.4 715.6c54.8-19.6 178.6-59 178.6-59v-94.4c0 0-153 49.6-222.6 74.2-17.2 6.2-34.6 11.8-51.4 19-19.6 8.2-38.8 17.4-56.2 29.6-7.6 5.2-14.4 11.8-18.4 20.2s-4.4 18.4-1 27.2c4 10.2 11.6 18.6 20.2 25.2 15.6 11.8 34.2 19 52.8 24.4 56.8 18.8 116.8 28 176.8 26.6 29-0.4 72-3.8 100-8.8v-84c0 0-22 5-82.6 25-9.2 3-18.4 6.6-28 8.6-14.2 3.2-28.8 4.2-43.2 4.4-13-0.6-26.4-1.4-38.6-6.2-4.4-2-9.2-4.4-11-9.2-1.6-4 0.6-8 3.4-10.8 5.6-5.8 13.6-9 21.2-12z",
      "M1024 691.8c-0.2-12-7.4-22.4-15.8-30-14.2-12.6-31.8-20.6-49.4-27-11-3.8-18.6-6.6-29.4-10-50.4-16.4-103.8-22.4-156.6-22.6-16 0.6-46.2 1-62 2.8-43.8 5-134.6 30.8-134.6 30.8v97.6c0 0 135-43.2 193-63.6 19.4-6.6 40.2-9.2 60.6-9.2 13 0.4 26.4 1.4 38.8 6.2 4.4 1.8 9 4.4 11 9 1.8 5.2-1.8 10-5.8 13-9.4 7.6-21.4 10.6-32.4 14.8-82 29-265.4 89.4-265.4 89.4v94c0 0 234.4-79.2 341.6-117.6 17.8-6.6 35.8-12.2 52.8-20.8 15.8-8 31.6-17.2 43.6-30.6 6.2-7.2 10-16 10-26.2z"
    ],
    "grid": 0,
    "tags": [
      "logo-playstation"
    ]
  },
  {
    "paths": [
      "M386.92 498.112c7.446-1.34 15.178-2.082 23.172-2.082l-6.244-0.030h207.646c9.006 0 17.612-1.234 25.816-3.508 38.74-10.726 66.69-45.074 66.69-87.326v-174.448c0-49.664-42.3-86.968-92.578-95.212-31.862-5.248-78.516-7.654-110.178-7.498-31.658 0.172-61.962 2.808-88.554 7.498-78.404 13.646-92.69 42.35-92.69 95.212v57.282h192v32h-254.36c-71.256 0-129.076 85.142-129.626 190.484-0.004 0.506-0.014 1.010-0.014 1.516 0 19.046 1.88 37.44 5.37 54.808 15.926 79.332 65.532 137.192 124.27 137.192h30.36v-91.87c0-53.654 40.292-103.466 98.92-114.018zM407.312 254.004c-19.184 0-34.768-15.57-34.768-34.806 0-19.328 15.548-35.040 34.768-35.040 19.148 0 34.798 15.71 34.798 35.040 0.002 19.236-15.618 34.806-34.798 34.806z",
      "M887.902 445.086c-18.342-73.044-65.836-125.086-121.542-125.086h-30.36v81.344c0 67.83-44.572 116.948-98.978 125.362-5.474 0.848-10.966 1.292-16.602 1.292h-207.718c-9.036 0-17.808 1.168-26.098 3.344-38.244 10.036-66.604 41.858-66.604 83.13v174.454c0 49.664 49.954 78.852 98.962 93.102 58.654 17.062 122.534 20.136 192.732 0 46.606-13.32 92.306-40.242 92.306-93.102v-52.926h-192v-32h254.36c50.48 0 94.214-42.73 115.628-105.098 8.96-26.094 14.012-55.62 14.012-86.902 0-23.536-2.866-46.076-8.098-66.914zM615.734 765.64c19.18 0 34.762 15.57 34.762 34.8 0 19.3-15.582 35.042-34.762 35.042-19.154 0-34.798-15.742-34.798-35.042-0-19.26 15.612-34.8 34.798-34.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-python"
    ]
  },
  {
    "paths": [
      "M708.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z",
      "M444.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z",
      "M961 502c0-55.4-44.4-100.4-99-100.4-26 0-49.4 10-67.2 26.6-66.4-46.8-156.8-77-257.4-81.4l46.6-155.4 139.2 27.8c0.4 49.4 40.2 89.4 89 89.4 49.2 0 89-40.4 89-90.2s-39.8-90.4-89-90.4c-37.2 0-69 23.2-82.4 56l-170.4-34-58.8 196.4-14.2 0.4c-100.6 4.4-191 34.8-257.4 81.4-17.6-16.6-41.2-26.6-67.2-26.6-54.6 0-99 45-99 100.4 0 39.2 22 73 54.2 89.6-1.6 9.8-2.4 19.6-2.4 29.6 0.4 151.6 178.2 274.8 397.4 274.8s397-123.2 397-275c0-10-0.8-19.8-2.2-29.6 32.2-16.6 54.2-50.4 54.2-89.4zM812.2 163.8c29.6 0 53.6 24.4 53.6 54.4s-24 54.4-53.6 54.4c-29.6 0-53.6-24.4-53.6-54.4s24-54.4 53.6-54.4zM98.4 502c0-35.6 28.6-64.4 63.6-64.4 14.4 0 27.8 5 38.4 13.2-34.6 30.4-60.2 66-74 104.8-16.8-11.8-28-31.4-28-53.6zM772.8 785.8c-69.2 47.8-161.8 74.2-260.8 74.2s-191.6-26.4-260.8-74.2c-65-45-100.8-103.6-100.8-164.8 0-6.4 0.4-13 1.2-19.4 1.4-12 4.4-23.8 8.6-35.4 11.2-31.2 32-60.6 61.4-86.8 8.8-7.8 18.4-15.4 28.8-22.6 0.2-0.2 0.6-0.4 0.8-0.6 69.2-47.8 161.8-74.2 260.8-74.2s191.6 26.4 260.8 74.2c0.2 0.2 0.6 0.4 0.8 0.6 10.4 7.2 20 14.8 28.8 22.6 29.4 26.2 50.2 55.6 61.4 86.8 4.2 11.6 7 23.4 8.6 35.4 0.8 6.4 1.2 12.8 1.2 19.4 0 61.2-35.8 119.8-100.8 164.8zM897.6 555.4c-13.8-38.8-39.4-74.4-74-104.8 10.6-8.2 24-13.2 38.4-13.2 35 0 63.6 29 63.6 64.4 0 22.4-11.2 42-28 53.6z",
      "M641 715.8c-0.4 0.4-48.4 48.4-129 48.8-81.8-0.4-128.8-48.4-129.2-48.8l-25.2 24.8c2.4 2.4 59.2 59 154.4 59.4 95.2-0.4 151.8-57 154.2-59.4l-25.2-24.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-reddit"
    ]
  },
  {
    "paths": [
      "M239.8 672.2c-61.6 0-111.8 50.2-111.8 111.6 0 61.6 50.2 111.2 111.8 111.2 61.8 0 111.8-49.8 111.8-111.2s-50-111.6-111.8-111.6z",
      "M128 384v159.8c96 0 188.2 28.4 256 96.2s96 159.8 96 256h160c0-279.8-232-512-512-512z",
      "M128 128v159.8c342 0 607.8 266 607.8 608.2h160.2c0-423.4-344-768-768-768z"
    ],
    "grid": 0,
    "tags": [
      "logo-rss"
    ]
  },
  {
    "paths": [
      "M1023.568 658.216c-3.34-27.198-18.472-48.292-41.59-64.832 5.714 4.080 10.55 7.532-0.11-0.082-14.378-10.262-6.76-4.822-0.094-0.064-57-40.602-131.352-31.578-193.466-9.022-24.894-40.59-25.974-71.566-11.632-115.874 1.858-5.6 0.59-8.708-5.248-11.208-14.172-6.060-34.582-2.854-48.844 0.926-4.924 1.292-8.508 3.8-9.6 8.762-10.308 48.486-42.018 92.896-69.656 133.772-19.462-37.304-17.92-66.174-4.828-105.032 1.596-4.732 0.862-7.248-3.874-9.758-14.52-7.514-36.802-3.824-51.6 0.552-17.018 4.964-42.58 89.188-50.744 105.892-17.062 34.884-32.182 89.33-61.17 117.004-24.6-31.614 45.052-103.034 21.764-131.702-7.876-9.696-22.126-9.446-31.172-1.232 2.17-15.216 3.296-25.218-0.64-38.126-4.162-13.58-14.722-21.374-30.18-20.98-35.99 1.054-67.686 27.63-89.282 52.794-20.554 24.21-74.762 39.254-103.906 53.854-50.064-43.614-158.442-89.894-161.264-164.162-3.056-83.692 96.638-140.49 163.194-174.456 86.56-44.208 219.922-99.216 318.276-50.872 26.098 12.828 36.598 40.342 29.414 66.696-18.736 68.732-94.396 114.586-160.206 135.614-32.378 10.35-67.938 18.054-102.2 16.052-45.91-2.686-81.66-30.448-86.562-32.172-4.098-0.778-3.776 4.522-2.694 7.328 47.632 124.866 288.834 33.362 351.912-30.742 30.378-30.842 48.826-60.73 56.702-107.788 9.232-55.166-31.268-89.684-62.008-103.914-155.836-72.144-371.272 22.336-489.106 118.654-51.136 41.802-115.104 108.22-85.748 177.892 31.86 75.61 129.472 114.38 193.006 160.624-51.408 25.546-115.724 51.966-149.036 99.866-19.048 27.458-25.806 56.718-11.622 87.932 25.144 55.136 116.57 31.244 155.146 6.942 35.34-22.26 59.126-52.14 69.4-90.456 8.91-33.218 7.082-67.732-7.712-99.024l57.17-28.916c-15.394 46.152-22.194 104.006 9.762 145.71 12.804 16.676 46.034 17.35 59.634 0.622 17.632-21.886 29.328-49.31 41.006-74.412-1.364 18.746-3.712 39.992 2.754 56.33 7.42 18.746 24.252 22.582 41.584 10.686 53.040-36.406 86.796-137.304 112.926-196.124 7.104 25.658 14.946 49.096 27.914 72.752 3.204 5.806 2.814 9.548-1.592 14.39-19.37 21.35-65.652 56.958-70.138 85.798-1.048 6.742 3.426 13.198 11.372 14.74 31.146 6.216 65.676-5.062 90.964-22.156 26.376-17.844 34.892-42.174 28.49-71.030-9.152-41.542 21.986-87.96 51.602-122.060 5.438 25.816 13.632 50.662 28.286 73.212-26.15 22.966-65.16 55.528-59.558 93.878 1.976 13.73 14.27 22.602 29.028 19.472 31.566-6.648 58.832-20.226 78.74-44.292 18.046-21.71 11.584-45.402 3.712-69.27 47.744-13.63 96.044-16.354 143.662-0.054 22.99 7.82 41.51 21 52.496 41.636 13.452 25.288 5.878 48.584-20.1 65.208-6.574 4.208-11.124 7.666-8.9 9.486 2.224 1.822 9.8 4.226 26.568-6.304 16.768-10.534 27.020-24.766 29.646-43.45 0.526-5.166 0.51-10.334-0.048-15.51zM225.892 708.734c-2.716 33.346-19.272 60.386-46.35 82.228-15.234 12.316-34.204 22.352-53.040 24.184-18.836 1.834-33.502-2.922-34.756-22.46-3.528-54.986 81.846-108.848 129.25-125.066 4.040 13.72 6.022 27.332 4.864 41.174l0.032-0.060zM432.096 563.828c-7.806 44.618-29.66 124.694-64.628 156.672-4.712 4.286-9.22 4.036-11.618-1.542-20.69-48.118 7.342-147.338 66.164-162.656 6.914-1.778 11.204 1.164 10.082 7.526zM572.718 727.364c16.844-17.924 33.668-35.832 50.538-53.854 2.086 20.042-35.142 59.928-50.538 53.854zM734.146 691.972c-4.696 2.546-15.242 5.030-15.654 1.67-2.964-24.17 23.632-49.748 40.134-61.734 8.906 22.686-1.636 47.668-24.48 60.064z"
    ],
    "grid": 0,
    "tags": [
      "logo-sass"
    ]
  },
  {
    "paths": [
      "M873.8 593.6c5.6-25 8.4-50.8 8.4-77.4 0-199.4-164-361.2-366.4-361.2-21.4 0-42.2 1.8-62.6 5.2-32.6-20.4-71.2-32.2-112.8-32.2-117.2 0-212.4 93.8-212.4 209.4 0 38.8 10.6 75 29.2 106-4.8 23.4-7.4 47.8-7.4 72.6 0 199.6 164 361.2 366.2 361.2 23 0 45.4-2 67-6 30 15.8 64.2 24.8 100.4 24.8 117.4 0 212.4-93.8 212.4-209.4 0.2-33.4-7.8-65-22-93zM703.8 688.6c-17 23.6-42 42.4-74.4 55.6-32.2 13.2-70.6 19.8-114.6 19.8-52.6 0-96.6-9.2-131.2-27.2-24.6-13.2-44.8-30.8-60.4-52.8s-23.4-44-23.4-65.2c0-13.2 5.2-24.6 15.2-34.2 10-9.2 23-14 38.2-14 12.6 0 23.4 3.6 32.2 11 8.4 7 15.6 17.4 21.4 31 6.6 14.6 13.6 27 21.2 36.8 7.2 9.4 17.4 17.2 30.6 23.4 13.4 6.2 31.2 9.4 53.2 9.4 30.2 0 55-6.4 73.6-19 18.4-12.2 27.2-27 27.2-45 0-14.2-4.6-25.4-14.2-34.2-10-9.2-23-16.4-39.2-21.2-16.6-5.2-39.2-10.6-67.2-16.4-38-8-70.2-17.6-96-28.4-26.2-11-47.4-26.4-63-45.4-15.8-19.4-23.6-43.8-23.6-72.4 0-27.4 8.4-51.8 24.8-73 16.4-21 40.2-37.4 71.2-48.6 30.4-11.2 66.6-16.8 107.4-16.8 32.8 0 61.4 3.8 85.4 11 24.2 7.4 44.4 17.4 60.6 29.8 16 12.4 28 25.6 35.6 39.4 7.6 14 11.4 27.8 11.4 41.2 0 12.8-5 24.6-15 34.8s-22.6 15.6-37.6 15.6c-13.6 0-24.2-3.2-31.6-9.6-6.8-6-14-15.2-21.8-28.6-9.2-17-20.2-30.6-32.8-40.2-12.4-9.2-32.8-14-61.2-14-26.2 0-47.6 5.2-63.4 15.4-15.2 9.8-22.6 21.2-22.6 34.6 0 8.2 2.4 15 7.4 21 5.2 6.2 12.4 11.8 21.8 16.4 9.6 4.8 19.6 8.6 29.4 11.2 10.2 2.8 27.2 7 50.6 12.2 29.8 6.2 57 13.4 81 20.8 24.4 7.8 45.4 17.2 62.6 28.2 17.6 11.2 31.4 25.8 41.4 43 9.8 17.2 14.8 38.8 14.8 63.6 0.8 30.2-7.8 57.4-25 81z"
    ],
    "grid": 0,
    "tags": [
      "logo-skype"
    ]
  },
  {
    "paths": [
      "M991.996 720.778l-0.378-29.002-28.796-2.556c-30.826-2.792-87.6-14.438-108.602-33.8-32.562-30.022-71.376-72.398-71.376-103.786 0-2.028 0-5.092 8.3-10.372 9.97-6.348 25.178-11.168 38.594-15.42 10.434-3.308 20.288-6.434 28.788-10.472 18.472-8.78 36.996-31.956 34.942-57.614-2.43-30.332-28.848-54.092-60.144-54.092-8.042 0-16.136 1.52-24.054 4.518-16.054 6.082-27.486 8.82-35.41 9.924 1.494-18.638 3.582-40.24 6.422-61.34 10.222-75.896-10.562-147.018-58.528-202.084-50.758-58.266-127.002-90.682-209.188-90.682h-0.566c-82.186 0-158.43 32.416-209.182 90.682-47.964 55.068-68.75 126.69-58.53 202.584 2.832 21.020 4.92 42.462 6.42 61.236-7.94-1.118-19.372-3.996-35.406-10.068-7.93-3.004-16.034-4.59-24.086-4.59-31.282-0.002-57.688 23.704-60.114 54.006-2.054 25.636 16.47 48.786 34.94 57.566 8.502 4.040 18.362 7.156 28.8 10.464 13.414 4.25 28.618 9.064 38.586 15.406 8.294 5.278 8.294 8.336 8.294 10.364 0 17.32-12.382 49.382-71.376 103.776-20.998 19.362-78.11 31.002-109.176 33.794l-29.144 2.622-0.026 29.364c0 3.358 0.624 21.092 12.97 40.638 10.492 16.612 32.146 38.566 75.726 48.814 12.358 2.906 22.372 5.126 30.416 6.908 4.612 1.024 9.11 2.020 12.908 2.906 0.054 0.418 0.108 0.834 0.162 1.246 1.8 14.008 3.222 25.070 8.784 35.5 4.906 9.2 17.148 24.632 44.030 24.632 4.956 0 10.498-0.492 16.944-1.502 3.344-0.526 6.772-1.108 10.4-1.726 14.232-2.424 30.364-5.174 46.902-5.174 20.554 0 37.464 4.376 51.692 13.376 9.062 5.734 17.784 11.944 27.018 18.52 35.982 25.618 76.764 54.656 142.048 54.656 65.452 0 106.586-29.164 142.878-54.892 9.152-6.488 17.796-12.618 26.754-18.284 14.226-9 31.136-13.376 51.692-13.376 16.54 0 32.668 2.75 46.898 5.172 3.628 0.622 7.058 1.204 10.404 1.728 6.446 1.010 11.986 1.502 16.944 1.502 26.88 0 39.124-15.43 44.030-24.626 5.562-10.428 6.984-21.492 8.784-35.498 0.054-0.416 0.11-0.836 0.164-1.258 3.796-0.882 8.296-1.882 12.91-2.904 8.046-1.784 18.058-4.002 30.412-6.908 43.702-10.278 65.222-32.34 75.58-49.036 12.194-19.656 12.592-37.472 12.546-40.842zM416 256c17.672 0 32 21.49 32 48s-14.328 48-32 48-32-21.49-32-48 14.328-48 32-48zM623.23 411.396c-30.494 30.054-69.996 46.604-111.23 46.604-41.676 0-81.208-16.58-111.314-46.686-6.25-6.248-6.248-16.378 0-22.626 6.25-6.248 16.38-6.248 22.626 0 24.064 24.060 55.56 37.312 88.688 37.312 32.774 0 64.3-13.28 88.77-37.396 6.296-6.204 16.426-6.126 22.624 0.164 6.204 6.294 6.13 16.426-0.164 22.628zM608 352c-17.672 0-32-21.492-32-48s14.328-48 32-48 32 21.492 32 48-14.328 48-32 48z"
    ],
    "grid": 0,
    "tags": [
      "logo-snapchat"
    ]
  },
  {
    "paths": [
      "M960 416.4c0 41-33.2 74.4-74.4 74.4-41 0-74.4-33.2-74.4-74.4 0-41 33.2-74.4 74.4-74.4 41 0 74.4 33.4 74.4 74.4zM885.2 278c-76.2 0-138 61.4-138.8 137.4l-86.4 124c-3.6-0.4-7.2-0.6-10.8-0.6-19.4 0-37.4 5.4-52.8 14.6l-391.6-157.4c-10.2-46.4-51.8-81.4-101.2-81.4-57-0.2-103.6 46.6-103.6 103.6s46.6 103.6 103.6 103.6c19.4 0 37.4-5.4 52.8-14.6l391.6 157.2c10.2 46.6 51.6 81.6 101.2 81.6 53.6 0 98-41.2 103-93.4l133-97.2c76.6 0 138.8-62 138.8-138.6s-62.2-138.8-138.8-138.8zM885.2 323.8c51.4 0 93 41.8 93 93 0 51.4-41.8 92.8-93 92.8-51.4 0-93-41.6-93-92.8 0-51.4 41.6-93 93-93zM103.6 341.8c29.2 0 54.6 16.4 67.4 40.4l-37.8-15.2v0.2c-30.6-11-64.4 4-76.6 34.2-12.2 30.4 1.8 64.6 31.4 77.8v0.2l32.2 12.8c-5.2 1.2-10.8 1.8-16.4 1.8-42.2 0-76.2-34-76.2-76.2-0.2-41.8 33.8-76 76-76zM649.2 566.2c42.2 0 76.2 34 76.2 76.2s-34 76.2-76.2 76.2c-29.4 0-54.8-16.4-67.4-40.6 12.6 5 25 10 37.6 15.2 31 12.4 66.4-2.6 78.8-33.6s-2.6-66.2-33.8-78.8l-31.8-12.8c5.6-1 11-1.8 16.6-1.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-steam"
    ]
  },
  {
    "paths": [
      "M642.4 792.6c-23.6 0-44.8-5.6-63-16.6-13.8-8.2-23-19.2-28-32.8-5.2-13.8-7.2-44.6-7.2-92.8v-202.4h192v-128h-192v-224h-123.8c-5.4 43-15 89.4-29 117.2s-28 51.6-51.2 71.4c-23.2 19.8-51.2 35.8-83.8 46.6v116.8h96v280.8c0 38 4 67 11.8 87 8 20 22.2 39 42.8 56.8s45.6 31.4 74.6 41c29.2 9.6 62.8 14.4 100.8 14.4 33.4 0 60.6-3.4 89.4-10.2s61-18.6 96.4-35.2v-131.2c-41.8 27.4-83.6 41.2-125.8 41.2z"
    ],
    "grid": 0,
    "tags": [
      "logo-tumblr"
    ]
  },
  {
    "paths": [
      "M852.6 792c-13.4-8-26.4-22-24-37.6 4.6-30.6 5-43-0.4-51.6-3.8-6.4-11-10-17.2-11.6 4-5 6.2-10.8 7.6-21.8 2.6-20-9.4-82-25.4-131.4s-59.8-100-89.4-136c-52-63.6-45.6-78.4-52.6-199.4-4.4-77-38.6-138.6-139.2-138.6s-134 64-134 118c0 57.4 4 102 4 102 2.6 66.8 2 78.8-16 110.6-9.8 17.4-54 60-71.4 89.4s-15.2 59-49.2 105.6c-24.8 34-27.6 56.8-19.4 88-14 16.4-7.2 39.8-10 49.8-5.2 17.4-27.4 20.6-44.6 22s-30.6 0-37.4 10.6 1.4 32 8.6 60-14.6 30-14.6 62 60 32 119.4 45.4 81.4 32.6 112 32.6 53.6-20.4 76-38.6c14.4-11.8 58-7.4 84.6-7.4s68.6-1.2 91.4 4.8 22.6 41.2 78.6 41.2 69.4-41.4 122-68.6 84-40 84-59.4-30-32-43.4-40zM399.6 903c-2.6 26-25.2 34.2-48.2 32.2-26-2.2-58-15.2-88.2-24.2s-71-15-98-19.8c-30.6-5.4 0-27.2-0.4-68.4-0.2-16-14.2-38.8-8.4-49.4s34.6-4.8 44.6-7.6 25.4-11.4 30.6-23.8c2.8-6.8 3.6-35.4 5.8-45.6 2.2-9.8 15.8-14.4 44.4 0.2s57.8 76.2 84.6 119.6 35.8 60.8 33.2 86.8zM636.6 771.4c4 20.6 6.4 49 1.4 72.6s-14 31-21.4 46c-4.4-13.6 10.6-27.6 8.8-61.6-1-19-1.6-15.6-23 3.6-24.4 21.6-55.2 40.2-106 45-42 4-65-16.6-65-16.6 10 32-8.6 49.4-8.6 49.4 0.6-7.4 1.6-28.6-5-43.2-8-18-18.6-37.4-18.6-37.4s17.2-5.4 23.2-20 4-34.6-17.4-55.4-105-75.2-111.8-84.2c-9.8-13-13.4-20.4-14-46.4s10.8-49.6 8.6-40.6c-1.6 6.4 0.2 13.6 0.2 39.6s15.2 46.6 27.8 50c19 5.2 4-52.2 16-106.2s23.4-65.6 38.4-87.6 38.4-41 34-86.2-0.2-40.2 10.2-23.6c8 13 26.6 48 49.4 44 38.8-6.6 87.8-49.2 95.2-56.4s1.4-14.2-4.6-11.6c-31 13.4-88.6 43-103 36.4s-36.2-41.2-33.6-39c30.8 27.2 39.8 22.2 52.8 18 16.8-5.6 25.6-8.6 57-22.6s41.4-10.6 44.6-17.4-0.8-13.4-9.4-11.4c-12.8 3-6.8 10.2-45.4 24.6-50.6 19-66.6 20.6-88 6-17.2-11.8-30-25.4-30-33.4s16.6-16.6 24.6-22.6 24.6-21.8 24.6-21.8 2-14.4-1.2-25.4c-3.8-13-15.6-18.6-23.8-16.2-8.2 2.2-16 11-13.6 29.6 2 16.6 14 22 14 22s-5.4 7-10.4 9.4c0 0-1.6-0.6-7-12.6s-13.2-39-0.6-62.2 39.2-10.4 47.6 7.6c7.8 16.6 4.8 45.4 4.8 45.4 12-4.4 26-4 42 7-14.2-59.6 19-82.2 44-82.2s44.6 19.2 44.6 50c0 24-7 36.4-13.8 44-8.2-1-16.4-3-12.6-6.8 2.6-2.8 8.8-11.4 8.8-26.4s-11.8-27.4-27.4-27.4c-18.4 0-25.2 16.6-27.4 26s-0.8 17.2-0.4 20.8c1.2 10 21.8 19.2 47.8 25.8s22.6 18 16.6 50.6 12.6 36.6 28.6 67.6 11.4 43.6 31.8 70.4 38 95.6 32.8 153.6c-1.8 21-7.8 20.4 14.6 13.4 11.2-3.4 24-5.4 24-5.4 6.2-12.6 6.8-32.6 7-44.6 0.4-27 1.4-83-53.4-143 0 0 59 43.4 68 124 5 44.6-4 64.8-4 64.8 10.6 2.6 19.6 14.6 25.2 23.6 7.4 12.2-7.8-11.6-40-11.6-17 0-30.6 7.8-37 15.8s-6.2 15.2-6.4 23.4c-14.2-2.4-24.8 0-33.6 9.8-11.2 14-5.6 48.4-1.6 69.2zM816.8 865.8c-48.2 20.8-65.4 47-95.4 63s-55.4 4.6-67.4-16 20.8-56.4 9.4-119.2c-8.8-48.4-12.6-62-9.8-73.6 2.8-11 18.8-8.8 23-7.8 2.6 10.8 13.4 39 54 39 0 0 46.4 5.2 65.4-42.4 0 0 11.4-0.4 14.4 7 4.6 11.6-5.8 33-5.6 42.6 0.6 31.4 23.4 42.2 56.8 64 16.4 11.2 4.2 22.2-44.8 43.4z"
    ],
    "grid": 0,
    "tags": [
      "logo-tux"
    ]
  },
  {
    "paths": [
      "M160 64l-64 160v608h192v128h128l128-128h160l224-224v-544h-768zM832 576l-128 128h-192.002l-127.998 128v-128h-160v-544h608v416z",
      "M640 286h96v258h-96v-258z",
      "M416 286h96v258h-96v-258z"
    ],
    "grid": 0,
    "tags": [
      "logo-twitch"
    ]
  },
  {
    "paths": [
      "M984 219c-34.8 15.4-72 25.8-111.2 30.6 40-24 70.8-62 85.2-107.2-37.4 22.2-78.8 38.4-123 47-35.4-37.8-85.8-61.4-141.4-61.4-107 0-193.6 86.8-193.6 193.8 0 15.2 1.6 30 5 44.2-161-8-303.8-85.2-399.2-202.6-16.6 28.6-26.2 62-26.2 97.4 0 67.2 34.4 126.6 86.4 161.4-32-0.8-62-9.6-88-24.2 0 0.8 0 1.6 0 2.4 0 94 66.8 172.2 155.4 190-16.2 4.4-33.4 6.8-51 6.8-12.4 0-24.6-1.2-36.4-3.6 24.6 77 96.2 133 181 134.6-66.2 52-149.8 83-240.6 83-15.6 0-31-1-46.2-2.8 85.4 55.6 187.2 87.6 296.4 87.6 356.6 0 551.4-295.4 551.4-551.6 0-8.4-0.2-16.8-0.6-25 37.8-27.4 70.6-61.4 96.6-100.4z"
    ],
    "grid": 0,
    "tags": [
      "logo-twitter"
    ]
  },
  {
    "paths": [
      "M822.774 606.512c-6.238-19.154-15.782-37.122-28.602-53.904-12.844-16.764-28.792-31.652-47.86-44.662-19.078-12.996-41.442-23.26-67.106-30.8-10.286-2.726-28.378-7.012-52.208-12.836-17.032-4.148-33-8.4-51-12.734v-211.446c18 4.792 30.504 12.404 43.852 20.86 28.558 18.080 46.464 49.010 51.71 91.010h138.348c-1.308-36-9.3-65.52-23.992-92.040-16.14-29.086-37.954-54.048-65.46-73.912-27.5-19.844-60.45-34.98-96.754-44.91-15.768-4.306-29.702-7.928-47.702-10.366v-66.772h-128v66.334c-14 2.088-30.296 4.89-44.852 8.5-34.484 8.566-64.776 21.736-91.902 39.528-27.142 17.81-48.704 40.224-65.208 67.254-16.502 27.046-24.624 59.040-24.624 96 0 19.17 2.814 37.986 8.314 56.47 5.504 18.482 14.884 35.934 28.084 52.362 13.206 16.428 30.99 31.316 53.374 44.664 22.366 13.344 49.41 24.128 83.152 32.342 18.574 4.69 37.66 9.068 53.66 13.152v239.172c-22-5.838-43.778-14.798-61.356-26.958-18.34-12.654-32.132-27.906-42.396-47.768-9.558-18.458-14.146-41.052-14.814-65.052h-137.432c1.39 42 10.5 78.988 27.344 110.742 17.598 33.208 41.066 59.92 70.408 81.124 29.324 21.226 62.786 36.712 102.396 46.982 17.77 4.608 37.852 7.92 55.852 10.46v70.692h128v-69.080c20-2.138 37.914-5.38 57.054-9.758 37.402-8.546 71.29-22.072 100.632-40.552 29.324-18.48 53.242-42.256 71.222-71.362 17.96-29.082 27.090-64.17 27.090-105.238 0.002-19.156-3.002-38.328-9.224-57.498zM448 419.398c-24-7.486-47.824-18.176-64.102-32.096-17.242-14.71-25.346-35.068-25.346-61.090 0-18.482 4.828-33.88 14.008-46.204 9.16-12.322 19.824-22.076 33.76-29.262 12.36-6.378 27.68-11.13 41.68-14.276v182.928zM685.804 718.942c-5.878 13.346-15.398 25.152-28.606 35.422-13.204 10.266-31.488 18.656-52.754 25.154-9 2.756-16.446 4.888-28.446 6.472v-214.22c20 5.248 36.36 10.664 52.652 16.262 16.124 5.488 31.496 14.886 45.074 28.232 13.57 13.352 20.618 34.060 20.618 62.12 0.002 13.7-2.674 27.21-8.538 40.558z"
    ],
    "grid": 0,
    "tags": [
      "logo-usd"
    ]
  },
  {
    "paths": [
      "M953.8 228c-10-46.8-35-77.6-81.2-92.6s-129.8-9-188.2 33.6c-59.8 43.6-95.2 119.4-107.6 167.6 29.4-12.6 48-15.4 78-13.8s49 24 49.8 50.6c0.6 19.6-0.4 37.4-7.2 55.4-21.6 57.4-55.4 113-95.2 161.6-5.8 7.2-12.8 13.8-20 19.8-20.4 16.6-37.6 12.2-50.8-10.4-10.8-18.6-18-37.8-24.4-58.2-24.8-79.4-33.6-161.8-47.6-243.2-6.6-39-14-79.6-36-113.8-23.2-35.6-57.2-49.2-100-44-29.4 3.6-73.8 35-95.6 52.8 0 0-112 93.8-163.6 142.8l42.4 54c0 0 35.8-25 55-36.6 11.4-6.8 24.8-8.2 34.4 0.4 9 7.8 19.2 18 24.6 28.2 11.4 21.4 22.4 43.8 29.4 66.8 26.4 88.6 51 177.4 75.6 266.6 12.6 45.6 27.8 88.4 56 127.2 38.6 53.2 79.2 65.4 141.8 43 50.8-18.2 93.2-52.4 132-87.8 66.2-60.4 118.2-130.8 171-202.4 40.8-55.4 74.6-111.4 102.8-174 27.8-62 38.8-127 24.6-193.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-vimeo"
    ]
  },
  {
    "paths": [
      "M520.124 64c-242.914 0-439.856 195.402-439.856 436.464 0 82.46 23.064 159.58 63.118 225.374l-79.386 234.162 243.528-77.364c63.016 34.57 135.49 54.292 212.596 54.292 242.946 0 439.876-195.43 439.876-436.464 0-241.062-196.93-436.464-439.876-436.464zM738.848 666.22c-10.348 25.654-57.148 49.066-77.798 50.144-20.628 1.094-21.216 15.988-133.68-32.868-112.45-48.868-180.104-167.688-185.438-175.34-5.338-7.624-43.56-62.094-41.498-116.91 2.076-54.826 32.094-80.692 42.808-91.45 10.702-10.774 22.972-12.704 30.464-12.826 8.856-0.144 14.592-0.264 21.146-0.022 6.548 0.248 16.384-1.37 24.9 21.278 8.512 22.646 28.886 78.306 31.492 83.978 2.604 5.678 4.216 12.252 0.204 19.542-4.024 7.306-6.084 11.87-11.922 18.166-5.87 6.296-12.348 14.084-17.584 18.898-5.84 5.33-11.94 11.144-5.8 22.538 6.136 11.386 27.306 48.712 59.558 79.472 41.45 39.542 77.196 52.658 88.196 58.634 11.030 6.008 17.612 5.34 24.452-1.858 6.808-7.198 29.278-31.492 37.192-42.338 7.91-10.876 15.322-8.746 25.484-4.658 10.156 4.104 64.314 33.112 75.346 39.102 11.020 5.978 18.386 9.058 21.020 13.8 2.634 4.76 1.802 27.062-8.542 52.718z"
    ],
    "grid": 0,
    "tags": [
      "logo-whatsapp"
    ]
  },
  {
    "paths": [
      "M960 530h-496v358l496 72v-430z",
      "M432 530h-368v300l368 53.4v-353.4z",
      "M960 64l-496 70.8v363.2h496v-434z",
      "M432 139.4l-368 52.6v306h368v-358.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-windows"
    ]
  },
  {
    "paths": [
      "M518 542.6l-65.6 191.4h-0.2l-50.8 146.2c3.6 1 7 1.8 10.6 2.8 0.2 0 0.4 0 0.6 0 31.6 8.4 64.8 13 99 13 17 0 33.6-1 49.8-3.6 22.4-2.8 44-7.6 65-14.2 0 0 0 0 0 0 5.2-1.6 10.4-3.4 15.6-5.2-5.6-12-17.6-38.6-18.2-39.8l-105.8-290.6z",
      "M161.6 361c-20 45.2-33.6 100.8-33.6 151 0 12.6 0.6 25.2 1.8 37.6 13.8 142.4 105.8 262 232.2 315.8 5.2 2.2 10.6 4.4 16 6.4l-186-510.6c-16-0.6-19 0.4-30.4-0.2z",
      "M860.4 350.8c-8.6-18.6-18.8-36.4-30.2-53.2-3.2-4.8-6.8-9.6-10.2-14.4-43-57.6-101.6-102.8-169.8-129.2-42.8-16.8-89.6-26-138.4-26-120.6 0-228.4 56-298.8 143.4-13 16-24.6 33.2-35 51.2 28.4 0.2 63.6 0.2 67.6 0.2 36.2 0 92-4.4 92-4.4 18.8-1.2 20.8 26.2 2.2 28.4 0 0-18.8 2.2-39.6 3.2l125.8 374 75.6-226.6-53.6-147.2c-18.8-1-36.2-3.2-36.2-3.2-18.8-1-16.4-29.6 2-28.4 0 0 57 4.4 91 4.4 36.2 0 92-4.4 92-4.4 18.6-1.2 21 26.2 2.2 28.4 0 0-18.6 2.2-39.4 3.2l124.6 371.2 34.6-115.2c17.4-44.8 26.2-81.8 26.2-111.4 0-42.6-15.4-72.2-28.6-95.2-17.4-28.6-33.8-52.6-33.8-80.8 0-31.8 24-61.4 58-61.4 1.4 0 3 0 4.4 0 52.4-1.4 69.6 50.6 71.8 86 0 0 0 0.8 0 1.2 0.8 14.4 0.2 25 0.2 37.6 0 34.8-6.6 74.2-26.2 123.6l-78 225.6-44.6 131.4c3.6-1.6 7-3.2 10.6-5 113.4-54.8 196-164 213.4-293.4 2.6-17 3.8-34.4 3.8-52 0-57.8-12.8-112.6-35.6-161.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-wordpress"
    ]
  },
  {
    "paths": [
      "M253.6 496.6c79.4-117.2 155.8-185.6 155.8-185.6s-84.2-97.8-185.6-134.8l-6.6-1.6c-93.8 82.2-153.2 202.8-153.2 337.4 0 101.4 33.8 195 90.4 270 0-8.8 1.2-140.6 99.2-285.4z",
      "M960 512c0-134.6-59.4-255.2-153.2-337.4l-6.4 1.8c-101.4 37-185.8 134.8-185.8 134.8s76.4 68.4 155.8 185.6c98 144.8 99.2 276.6 99 285.4 57-75.2 90.6-168.8 90.6-270.2z",
      "M402.4 161.8c58.6 26.2 109.2 69.2 109.2 69.2s51-42.8 109.6-69.2c73.6-33 129.8-22.6 144.6-19-72.2-49.6-159.6-78.8-253.8-78.8s-181.6 29.2-253.8 78.8c14.4-3.6 70.4-14.2 144.2 19z",
      "M717.4 585.8c-92.6-113.8-205.8-187.8-205.8-187.8s-112.6 74-205.4 187.8c-79.6 97.8-109.2 169.6-125.2 215.6l-2.6 9.6c82 91.4 201 149 333.6 149s251.6-57.6 333.6-149l-2.8-9.6c-16-46-45.8-117.8-125.4-215.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-xbox"
    ]
  },
  {
    "paths": [
      "M769.2 136.8c-22.6 0-45-1.6-65.2-8.8l-192 320-192-320c-20.2 7.2-41.4 8.8-64 8.8-22.2 0-44.2-1.8-64-8.8l256 425.4v342.6c20-7 41.6-8.8 64-8.8s44 1.8 64 8.8v-342l256-426c-19.8 6.8-40.6 8.8-62.8 8.8z"
    ],
    "grid": 0,
    "tags": [
      "logo-yahoo"
    ]
  },
  {
    "paths": [
      "M896 64h-160l-224 442.256-224-442.256h-160l224.736 416h-96.736v96h147.128l28.872 62v34h-176v96h176v192h160v-192h176v-96h-176v-34l29.782-62h146.218v-96h-96.578l224.578-416z"
    ],
    "grid": 0,
    "tags": [
      "logo-yen"
    ]
  },
  {
    "paths": [
      "M1017.2 297.6c0-90-66.2-162.4-148-162.4-110.8-5.2-223.8-7.2-339.2-7.2-6 0-12 0-18 0s-12 0-18 0c-115.2 0-228.4 2-339.2 7.2-81.6 0-147.8 72.8-147.8 162.8-5 71.2-7.2 142.4-7 213.6-0.2 71.2 2 142.4 6.8 213.8 0 90 66.2 163 147.8 163 116.4 5.4 235.8 7.8 357.2 7.6 121.6 0.4 240.6-2 357.2-7.6 81.8 0 148-73 148-163 4.8-71.4 7-142.6 6.8-214 0.4-71.2-1.8-142.4-6.6-213.8zM414 707.8v-393l290 196.4-290 196.6z"
    ],
    "grid": 0,
    "tags": [
      "logo-youtube"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-172v172h-84v-172h-172v-84h172v-172h84v172h172v84z"
    ],
    "grid": 0,
    "tags": [
      "md-add-circle"
    ]
  },
  {
    "paths": [
      "M832 554.666h-277.334v277.334h-85.332v-277.334h-277.334v-85.332h277.334v-277.334h85.332v277.334h277.334v85.332z"
    ],
    "grid": 0,
    "tags": [
      "md-add"
    ]
  },
  {
    "paths": [
      "M940 249.674l-196.886-163.56-55.628 65.862 196.884 163.538 55.63-65.84zM334.384 149.838l-55.652-65.838-194.732 165.674 55.628 65.838 194.756-165.674zM533.402 345.256h-64.202v254.892l203.298 121.078 32.102-53.106-171.2-99.834v-223.030zM512 175.33c-214 0-385.202 172.042-385.202 382.332 0 210.298 171.202 382.338 385.202 382.338 211.872 0 385.202-172.040 385.202-382.338 0-210.288-173.33-382.332-385.202-382.332zM512 855.040c-164.786 0-299.6-133.812-299.6-297.376 0-163.554 134.814-297.368 299.6-297.368 164.788 0 299.6 133.812 299.6 297.368 0 165.678-134.812 297.376-299.6 297.376z"
    ],
    "grid": 0,
    "tags": [
      "md-alarm"
    ]
  },
  {
    "paths": [
      "M309.4 928h533.4c47 0 85.4-38.4 85.4-85.4v-533.2c0-47-38.4-85.4-85.4-85.4h-533.4c-47 0-85.4 38.4-85.4 85.4v533.4c0 46.8 38.4 85.2 85.4 85.2z",
      "M181.4 96h533.4c47 0 85.4 38.4 85.4 85.4v10.6h-522.8c-47 0-85.4 38.4-85.4 85.4v522.6h-10.6c-47 0-85.4-38.4-85.4-85.4v-533.2c0-47 38.4-85.4 85.4-85.4z"
    ],
    "grid": 0,
    "tags": [
      "md-albums"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.202-416 416s187.2 416 416 416c228.8 0 416-187.202 416-416s-187.2-416-416-416zM560 720h-96v-80h96v80zM560 544h-96v-256h96v256z"
    ],
    "grid": 0,
    "tags": [
      "md-alert"
    ]
  },
  {
    "paths": [
      "M64 512c28.2 70 72.4 132 128 181.2v-362.4c-55.6 49.2-99.8 111.2-128 181.2z",
      "M960 512c-28.2-70-72.4-132-128-181.2v362.4c55.6-49.2 99.8-111.2 128-181.2z",
      "M512 210c-94.2 0-182 26.8-256 73v457.8c74 46.2 161.8 73 256 73s182-26.8 256-73v-457.8c-74-46.2-161.8-73-256-73zM704 480v128h-64v-64h-96v64h-64v-64h-96v64h-64v-192h64v64h96v-64h64v64h96v-64h64v64z"
    ],
    "grid": 0,
    "tags": [
      "md-american-football"
    ]
  },
  {
    "paths": [
      "M758.8 356.6l-174.4 266.8c13.6 16.6 21.6 37.6 21.6 60.6 0 53-43 96-96 96s-96-43-96-96c0-6 0.6-12 1.6-17.8l-115.2-67c-17.2 16.6-40.6 26.8-66.6 26.8-17.2 0-33.2-4.6-47.2-12.4l-122.6 114.8v114.4c0 47 38.4 85.4 85.4 85.4h725.4c47 0 85.4-38.4 85.4-85.4v-425.2l-117.2-77.8c-16.2 12.6-36.6 20.2-58.8 20.2-8.8 0-17.4-1.2-25.4-3.4z",
      "M234 434c53 0 96 43 96 96 0 4.2-0.4 8.4-0.8 12.4l120.2 67.2c16.6-13.6 37.6-21.6 60.8-21.6 7.2 0 14.2 0.8 20.8 2.2l174.8-270.8c-11.2-15.6-17.8-34.8-17.8-55.6 0-53 43-96 96-96s96 43 96 96c0 7.8-1 15.4-2.6 22.6l82.6 55.2v-160.2c0-47-38.4-85.4-85.4-85.4h-725.2c-47 0-85.4 38.4-85.4 85.4v458.6l80-76.6c-3.8-10.4-6-21.6-6-33.4 0-53 43-96 96-96z"
    ],
    "grid": 0,
    "tags": [
      "md-analytics"
    ]
  },
  {
    "paths": [
      "M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM783.53 783.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53z",
      "M400.086 212.134c-81.262 30.342-146.868 92.764-181.434 171.866h293.348l-111.914-171.866z",
      "M825.594 576c4.198-20.68 6.406-42.082 6.406-64 0-73.248-24.628-140.734-66.032-194.668l-143.968 258.668h203.594z",
      "M719.946 268.79c-55.932-47.868-128.558-76.79-207.946-76.79-15.932 0-31.588 1.182-46.896 3.43l156.6 252.57 98.242-179.21z",
      "M198.408 448c-4.2 20.68-6.408 42.082-6.408 64 0 73.278 24.648 140.788 66.082 194.732l143.918-258.732h-203.592z",
      "M623.918 811.864c81.262-30.342 146.866-92.764 181.43-171.864h-293.348l111.918 171.864z",
      "M304.092 755.242c55.926 47.848 128.536 76.758 207.908 76.758 15.938 0 31.598-1.184 46.912-3.432l-156.584-252.568-98.236 179.242z"
    ],
    "grid": 0,
    "tags": [
      "md-aperture"
    ]
  },
  {
    "paths": [
      "M192 352h160v-160h-160v160zM432 832h160v-160h-160v160zM192 832h160v-160h-160v160zM192 592h160v-160h-160v160zM432 592h160v-160h-160v160zM672 192v160h160v-160h-160zM432 352h160v-160h-160v160zM672 592h160v-160h-160v160zM672 832h160v-160h-160v160z"
    ],
    "grid": 0,
    "tags": [
      "md-apps"
    ]
  },
  {
    "paths": [
      "M928 304h-208c0-114-93.124-207.718-208-207.718s-208 93.718-208 207.718h-208c37.376 432 26 624 26 624h779.998c-0.002 0-11.376-196 26.002-624zM512 148.21c86.016 0 155.998 69.79 155.998 155.79h-311.998c0-86 69.982-155.79 156-155.79zM408 795.28v-337.546l285.998 168.774-285.998 168.772z"
    ],
    "grid": 0,
    "tags": [
      "md-appstore"
    ]
  },
  {
    "paths": [
      "M907.188 200.002l-64.706-78.598c-11.544-16.15-32.316-25.404-53.154-25.404h-554.658c-20.832 0-41.602 9.254-53.152 25.404l-64.702 78.598c-13.88 13.844-20.816 34.668-20.816 57.77v577.78c0 50.848 41.6 92.448 92.45 92.448h647.106c50.848 0 92.444-41.6 92.444-92.45v-577.78c0-23.1-6.926-43.924-20.812-57.768zM512 766.218l-254.22-254.218h161.78v-92.448h184.886v92.448h161.78l-254.226 254.218zM193.068 188.442l36.972-46.222h554.662l43.93 46.222h-635.564z"
    ],
    "grid": 0,
    "tags": [
      "md-archive"
    ]
  },
  {
    "paths": [
      "M854 469.25h-519.408l239.404-239.404-61.996-59.846-342 342 342 342 59.844-59.848-237.252-239.402h519.408v-85.5z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-back"
    ]
  },
  {
    "paths": [
      "M554.75 170v519.408l239.404-239.404 59.846 61.996-342 342-342-342 59.848-59.844 239.402 237.252v-519.408h85.5z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-down"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM512 640l-192-192h384l-192 192z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropdown-circle"
    ]
  },
  {
    "paths": [
      "M256 384l256 256 256-256z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropdown"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM384 512l192-192v384l-192-192z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropleft-circle"
    ]
  },
  {
    "paths": [
      "M640 256l-256 256 256 256z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropleft"
    ]
  },
  {
    "paths": [
      "M512 928c229.75 0 416-186.25 416-416s-186.25-416-416-416-416 186.25-416 416 186.25 416 416 416zM448 704v-384l192 192-192 192z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropright-circle"
    ]
  },
  {
    "paths": [
      "M384 256l256 256-256 256z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropright"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM704 576h-384l192-192 192 192z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropup-circle"
    ]
  },
  {
    "paths": [
      "M256 640l256-256 256 256z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-dropup"
    ]
  },
  {
    "paths": [
      "M170 554.75h519.408l-239.404 239.404 61.996 59.846 342-342-342-342-59.844 59.848 237.252 239.402h-519.408v85.5z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-forward"
    ]
  },
  {
    "paths": [
      "M802.8 448h-428l166-158.8c23.8-25 23.8-65.4 0-90.4s-62.4-25-86.4 0l-276.4 268c-12 11.6-18 27.4-18 44.8v0.8c0 17.4 6 33.2 18 44.8l276.2 268c24 25 62.6 25 86.4 0s23.8-65.4 0-90.4l-166-158.8h428c33.8 0 61.2-28.6 61.2-64 0.2-36-27.2-64-61-64z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-round-back"
    ]
  },
  {
    "paths": [
      "M198.8 569.8l268 276.2c11.6 12 27.4 18 44.8 18h0.8c17.4 0 33.2-6 44.8-18l268-276.2c25-24 25-62.6 0-86.4s-65.4-23.8-90.4 0l-158.8 166v-428c0-33.8-28.6-61.2-64-61.2-36 0-64 27.4-64 61.2v428l-158.8-166c-25-23.8-65.4-23.8-90.4 0s-25 62.4 0 86.4z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-round-down"
    ]
  },
  {
    "paths": [
      "M569.8 825.2l276.2-268c12-11.6 18-27.4 18-44.8v-0.8c0-17.4-6-33.2-18-44.8l-276.2-268c-24-25-62.6-25-86.4 0s-23.8 65.4 0 90.4l166 158.8h-428c-34-0-61.4 28.6-61.4 64 0 36 27.4 64 61.2 64h428l-166 158.8c-23.8 25-23.8 65.4 0 90.4 24 25 62.6 25 86.6 0z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-round-forward"
    ]
  },
  {
    "paths": [
      "M825.2 454.2l-268-276.2c-11.6-12-27.4-18-44.8-18h-0.8c-17.4 0-33.2 6-44.8 18l-268 276.2c-25 24-25 62.6 0 86.4s65.4 23.8 90.4 0l158.8-166v428c0 33.8 28.6 61.2 64 61.2 36 0 64-27.4 64-61.2v-428l158.8 166c25 23.8 65.4 23.8 90.4 0s25-62.4 0-86.4z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-round-up"
    ]
  },
  {
    "paths": [
      "M554.75 854v-519.408l239.404 239.404 59.846-61.996-342-342-342 342 59.848 59.844 239.402-237.252v519.408h85.5z"
    ],
    "grid": 0,
    "tags": [
      "md-arrow-up"
    ]
  },
  {
    "paths": [
      "M531.2 424.6c-21 0-37 8.8-48 26.4s-18.2 44-21.6 79.2c-1.8 23.4 0 41 5.4 53s14.2 18 26.2 18c11 0 20.6-3 29.2-8.8s16.2-16.6 22.6-32.4l12.2-132c-4.4-1-8.8-1.8-13-2.4-4.6-0.8-8.8-1-13-1z",
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM767.6 499.8c-1.8 42.8-15.2 79.8-40 111.2-24.8 31.2-62 46.8-111.2 46.8-16.4 0-30.6-4.4-42.4-13.2-12-8.8-20.4-21.4-25.2-37.6-8.2 16.6-18.8 29-31.4 37.2s-27.4 12.4-44.4 12.4c-30.2 0-53.2-11.6-69.2-34.6s-21.8-53.6-17.6-91.8c5.2-48.8 20-88 44.4-117.4s54-44 88.8-44c24.4 0 44.2 2.6 59 7.6s31.2 11.4 49 22l-1-0.2h1.6l-15.4 166.8c-1 17 0.2 29.2 3.4 35.6 3.4 6.4 7.8 9.8 13.4 9.8 22.6 0 40.8-10.2 54.4-31.2s21.2-47.2 22.8-79.2c3.2-66-10.2-117.4-40.4-154.2s-76.6-55.4-139.4-55.4c-61 0-109.6 19.8-145.6 59.6s-55.4 93.8-58.6 162.4c-3.4 66.8 11.2 119.6 43.8 158.2 32.6 38.8 79.4 58.2 140.6 58.2 17 0 34.6-1.8 53-5.4 18.2-3.6 34.2-8.2 47.4-13.6l11.6 48.4c-13.6 8.2-30.8 14.6-51.8 19.2s-41.4 6.8-61.4 6.8c-81.6 0-144.6-24.2-188.6-72.8-44-48.4-64.4-114.8-61-199.2 3.6-83.6 29.8-149.8 78.2-198.8 48.6-49 113-73.4 193.4-73.4 79 0 139.6 23.2 181.4 69.4 42.4 46.4 61.6 109.8 58.4 190.4z"
    ],
    "grid": 0,
    "tags": [
      "md-at"
    ]
  },
  {
    "paths": [
      "M682.668 256v469.332c0 93.876-76.792 170.668-170.668 170.668-93.874 0-170.666-76.792-170.666-170.668v-490.664c0-59.73 46.936-106.668 106.666-106.668 59.728 0 106.666 46.938 106.666 106.668v490.666c0 23.458-19.21 42.666-42.668 42.666s-42.666-19.208-42.666-42.666v-405.334h-64v405.334c0.002 59.728 46.938 106.666 106.668 106.666s106.668-46.938 106.668-106.666v-490.666c0-93.866-76.792-170.668-170.668-170.668s-170.668 76.802-170.668 170.668v490.664c0.002 130.126 104.544 234.668 234.668 234.668s234.668-104.542 234.668-234.668v-469.332h-64z"
    ],
    "grid": 0,
    "tags": [
      "md-attach"
    ]
  },
  {
    "paths": [
      "M867 192h-532.6c-24.4 0-43.6 12.4-56.4 31.2l-192 288.8 192 288.4c12.8 18.8 32 31.6 56.4 31.6h532.4c39 0 71-32 71-71.2v-497.6c0.2-39.2-31.8-71.2-70.8-71.2zM760.4 639.6l-50 50.2-127.4-127.6-127.4 127.6-50-50.2 127.4-127.6-127.4-127.6 50-50.2 127.4 127.6 127.4-127.6 50 50.2-127.4 127.6 127.4 127.6z"
    ],
    "grid": 0,
    "tags": [
      "md-backspace"
    ]
  },
  {
    "paths": [
      "M176 256h96v512h-96v-512z",
      "M464 256h96v512h-96v-512z",
      "M320 288h96v448h-96v-448z",
      "M608 288h96v448h-96v-448z",
      "M752 256h96v512h-96v-512z",
      "M208 208v-96h-176v800h176v-96h-80v-608z",
      "M816 112v96h80v608h-80v96h176v-800z"
    ],
    "grid": 0,
    "tags": [
      "md-barcode"
    ]
  },
  {
    "paths": [
      "M731.8 805.2l-45.8 27-32-56 40.4-23.8c-10.4-17-19.6-34.8-27.8-53.4-2.8-6.2-5.4-12.6-7.8-19l-50.2 11.6-14.2-63.2 45.2-10.4c-5.6-24.2-9.4-48-11-74h-48.6v-64h48.6c1.6-24 5.4-49.6 11-73.6l-45.2-10.4 14.2-63.2 50.2 11.6c2.6-6.4 5.2-12.8 8-19.2 8.2-18.4 17.4-36.2 27.6-53.2l-40.4-23.8 32-56 45.6 27c10.4-12.8 21.6-25 33.4-36.6-70.2-54.4-158-86.6-253-86.6s-182.8 32.2-253 86.4c11.8 11.6 23 24 33.4 36.6l45.6-26.8 32 56-40.4 23.8c10.2 17 19.6 34.8 27.6 53.2 2.8 6.4 5.4 12.8 8 19.2l50.2-11.6 14.2 63.2-45.2 10.4c5.6 24.2 9.2 49.6 11 73.6h48.6v64h-48.6c-1.6 26-5.4 49.8-11 74l45.2 10.4-14.2 63.2-50.2-11.6c-2.4 6.4-5 12.6-7.8 19-8.2 18.4-17.4 36.2-27.8 53.4l40.4 23.8-32 56-45.8-27c-10.4 12.6-21.4 24.8-33.2 36.4 70.2 54.2 158 86.4 253 86.4s182.8-32.2 253-86.4c-11.8-11.6-22.8-23.8-33.2-36.4z",
      "M787.6 252l36.2 21.4-32 56-42.4-25c-10 16.6-19 33.8-26.6 51.8-0.4 0.8-0.8 1.8-1 2.6l42 9.8-14.2 63.2-47.8-11c-4.6 19.4-7.6 39.2-9.2 59.2h47.4v64h-47.2c1.6 20 4.6 40 9.2 59.6l47.8-11 14.2 63.2-42 9.8c0.4 0.8 0.6 1.6 1 2.4 7.6 18 16.6 35.4 26.6 52l42.2-24.8 32 56-36 21.2c6.6 7.8 13.6 15.4 21 22.6 1.2 1.2 2.6 2.6 4 4 71.2-75 115.2-176.2 115.2-287s-44-212-115.4-286.8c-1.4 1.4-2.8 2.6-4 4-7.4 7.4-14.4 15-21 22.8z",
      "M236.4 772.2l-36-21.2 32-56 42.2 24.8c10.2-16.6 19-34 26.6-52 0.4-0.8 0.6-1.6 1-2.4l-42-9.8 14.2-63.2 47.8 11c4.6-19.6 7.6-39.6 9.2-59.6h-47.4v-64h47.2c-1.6-20-4.6-39.8-9.2-59.2l-47.8 11-14.2-63.2 42-9.8c-0.4-0.8-0.6-1.8-1-2.6-7.6-18-16.4-35.4-26.6-51.8l-42.4 25-32-56 36.2-21.4c-6.8-7.8-13.8-15.4-21.2-22.8-1.2-1.2-2.6-2.6-4-4-71 75-115 176.2-115 287s44 212 115.4 286.8c1.4-1.4 2.8-2.6 4-4 7.2-7.2 14.2-14.8 21-22.6z"
    ],
    "grid": 0,
    "tags": [
      "md-baseball"
    ]
  },
  {
    "paths": [
      "M724.2 410.4l-178.4-265.4c-7.8-11.4-20.8-17-33.8-17s-26 5.6-33.8 17.4l-178.4 265h-195c-22.4 0-40.8 18.2-40.8 40.4 0 3.6 0.4 7.2 1.6 11l103.4 375c9.4 34 40.8 59 78.2 59h529.4c37.4 0 68.8-25 78.6-59l103.4-375 1.2-11c0-22.2-18.4-40.4-40.8-40.4h-194.8zM389.8 410.4l122.2-178 122.2 178h-244.4zM512 734.2c-44.8 0-81.4-36.4-81.4-81s36.6-81 81.4-81 81.4 36.4 81.4 81c0 44.6-36.6 81-81.4 81z"
    ],
    "grid": 0,
    "tags": [
      "md-basket"
    ]
  },
  {
    "paths": [
      "M383.2 544c-7.6 110-52.8 214.2-129 295.4 63.2 50 141.8 82 225.8 88.6v-384h-96.8z",
      "M544 928c84-6.6 163-38.8 226.2-89-76-81.2-121-185-128.6-295h-97.6v384z",
      "M480 96c-84 6.4-161 38-223.8 87.2 76 81.8 120.6 186.8 127.4 296.8h96.4v-384z",
      "M641.4 480c6.8-110 51.2-214.8 127-296.6-63-49.2-140.4-81-224.4-87.4v384h97.4z",
      "M817.2 228.4c-34.4 37-61.4 79.4-80.2 125.8-16.4 40.4-26.2 81.8-29.2 125.8h220.2c-7.4-96-48.2-184.4-110.8-251.6z",
      "M737 666.2c19.2 47.4 46.6 90.2 81.8 127.6 61.8-67 101.8-153.8 109.2-249.8h-219.8c3.2 42 13 83 28.8 122.2z",
      "M287.8 354.2c-19-46.6-46-89-80.6-126.2-62.8 67.2-103.8 156-111.2 252h221c-3.2-44-13-85.6-29.2-125.8z",
      "M205.4 794.2c35.4-37.6 63-80.6 82.2-128 16-39.2 25.6-80.2 29-122.2h-220.6c7.4 96 47.6 183.2 109.4 250.2z"
    ],
    "grid": 0,
    "tags": [
      "md-basketball"
    ]
  },
  {
    "paths": [
      "M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6zM467.2 870.4v-246.4h-89.6l179.2-336v246.4h89.6l-179.2 336z"
    ],
    "grid": 0,
    "tags": [
      "md-battery-charging"
    ]
  },
  {
    "paths": [
      "M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6zM640 864h-256v-614.4h256v614.4z"
    ],
    "grid": 0,
    "tags": [
      "md-battery-dead"
    ]
  },
  {
    "paths": [
      "M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6z"
    ],
    "grid": 0,
    "tags": [
      "md-battery-full"
    ]
  },
  {
    "paths": [
      "M896.2 69.8c0-2.4-0.8-5.8-5.8-5.8h-633.4c-108.6 0-128.8 54.8-128.8 79.6 60.6 8.4 63.8 9.4 63.8 73.4 0 32 0 614 0 614 0 70.6 57.8 129 128.6 129h415.4c70.6 0 128-58.4 128-129 0 0 0-7.4 0-20.4v-664c4.4-35 24-63.6 26.2-67 2.4-3.8 6-7.6 6-9.8zM708.4 864h-355.8c-31.8 0-59.4-23.8-64.6-54.2v-649.8h480v639.4c0 36-24.8 64.6-59.6 64.6z",
      "M364 320v452c0 8.8 7.2 16 16 16h296c8.8 0 16-7.2 16-16v-452h-328z"
    ],
    "grid": 0,
    "tags": [
      "md-beaker"
    ]
  },
  {
    "paths": [
      "M832 280h-32v-12c17.8-18 32-45.8 32-76 0-70.6-57.4-128-128-128-32.6 0-62.2 12.2-84.8 32.2-24.8-20.2-56.4-32.2-90.8-32.2-31.6 0-60.8 10.2-84.6 27.4-19.8-17-45.8-27.4-74-27.4-34.2 0-64.8 15.2-85.6 39-23.4-24-56-39-92.2-39-70.6 0-128 57.4-128 128 0 32.4 12.2 62 32 84.6v109.4c0 53 43 96 96 96v349c0 70.6 57.6 129 128.4 129h351.6c70.6 0 128.2-58.4 128.2-129 0 0 0-7.4 0-20.4v-66.6h32c100 0 128-65.4 128-136v-192c-0.2-70.6-34.2-136-128.2-136zM704 384h-416v-107.4c0.6-0.8 1.4-1.6 2-2.4 2.4-3 4.8-6 7-9.2 3 2.4 6 4.8 9.2 6.8 18.2 12.2 40 19.4 63.4 19.4 12.8 0 25.2-2.2 36.6-6 25.6 40.4 70.6 67.4 122 67.4 44 0 83.4-19.8 109.8-50.8 11.4-13.4 20.4-28.8 26.2-45.8h39.8v128zM192 256.2v150c-18 0-32-14.4-32-32v-126.6c-16-9-26.8-24.2-30.6-42-1-4.2-1.4-8.8-1.4-13.4 0-35.2 28.8-64 64-64 23.6 0 46.6 15.4 60.2 30.8s53.4 15.4 67.8 0c13.6-14.6 28.6-30.8 49.6-30.8 12 0 23.2 4.4 31.8 11.6 3.8 3.2 7.2 7 9.8 11.2 2.2 3.6 4 8.4 6.2 11.6 5.4 6.8 13 11 22.4 11 8.8 0 16.6-3.8 22-10 1.2-1.4 2.4-3 3.4-4.6 4-5 8.4-9.6 13.4-13.6 13.6-10.8 31-17.2 49.6-17.2 21.2 0 40.4 8.2 54.8 21.8 3.4 3.2 13.4 9 26.4 10.2 9 0.8 12.2 0.6 16.4 0 20.6-2.6 28.8-9.4 32.8-13.2 11.6-11.6 27.6-18.8 45.2-18.8 35.2 0 64 28.8 64 64 0.4 6.2-0.6 12.4-2.4 18.2-5-11-16.2-18.4-29.2-18.4h-110c0 0-17.4-1.4-17.4 16.4s-5.8 34.2-15.6 47.4c-14.6 19.8-38.2 32.8-64.8 32.8-29.8 0-55.8-16.2-69.6-40.4-3.2-5.4-5.6-11.2-7.4-17.2-0.2-1.2-0.6-2.2-0.8-3.2-4-11.8-15-20.4-28.2-20.4-7.8 0-15 3-20.4 8 0 0 0 0-0.2 0.2-4.8 4.2-10.6 7.4-16.8 9.4-4.8 1.6-10 2.4-15.4 2.4-15 0-29.4-8-37.6-17.2-20-22.8-47.4-13.6-59.4-11s-24.4 23.4-24.4 23.4c-2.2 4.2-4.8 8-7.8 11.6-12 13.4-30.4 22-48.4 22zM864 608c0 35.4-12.6 48-48 48h-16v-288h16c35.4 0 48 12.6 48 48v192z"
    ],
    "grid": 0,
    "tags": [
      "md-beer"
    ]
  },
  {
    "paths": [
      "M661.332 262.404c37.336 0 67.196-29.87 67.196-67.202s-29.86-67.202-67.196-67.202c-37.332 0-67.192 29.87-67.192 67.202s29.86 67.202 67.192 67.202zM773.332 522.668c-102.664 0-186.664 84-186.664 186.666s84 186.666 186.664 186.666c102.668 0 186.668-84 186.668-186.666s-84-186.666-186.668-186.666zM773.332 840c-72.804 0-130.664-57.86-130.664-130.666s57.86-130.666 130.664-130.666c72.808 0 130.668 57.86 130.668 130.666s-57.86 130.666-130.668 130.666zM611.194 448h156.806v-64h-117.69l-69.24-120.268c-11.21-18.666-31.738-31.728-54.14-31.728-16.798 0-33.596 7.464-44.798 18.666l-143.464 138.13c-11.202 11.202-18.666 28-18.666 44.798 0 24.262 18.404 42.93 37.070 54.13l122.928 76.54v171.732h64v-224l-78.666-64 85.858-89.066 60.002 89.066zM250.666 522.668c-102.666 0-186.666 84-186.666 186.666s84 186.666 186.666 186.666c102.666 0 186.666-84 186.666-186.666s-83.998-186.666-186.666-186.666zM250.666 840c-72.798 0-130.666-57.86-130.666-130.666s57.868-130.666 130.666-130.666c72.798 0 130.666 57.86 130.666 130.666s-57.868 130.666-130.666 130.666z"
    ],
    "grid": 0,
    "tags": [
      "md-bicycle"
    ]
  },
  {
    "paths": [
      "M798 319.8l-257-255.8h-45v340l-206.6-205.6-63.4 63.2 251.6 250.4-251.6 250.4 63.4 63.2 206.6-205.6v340h45l257-255.8-193.6-192.2c0 0 193.6-192.2 193.6-192.2zM586 235.6l84.6 84.2-84.6 84.2v-168.4zM670.6 704.2l-84.6 84.2v-168.4c0 0 84.6 84.2 84.6 84.2z"
    ],
    "grid": 0,
    "tags": [
      "md-bluetooth"
    ]
  },
  {
    "paths": [
      "M168.51 826h2.126c68.246 0 127.954-38.042 170.61-84.988 42.65 46.946 102.36 85.524 170.608 85.524s127.958-38.668 170.61-85.612c42.654 46.944 102.36 85.076 170.606 85.076h2.124l102.506-277.56c4.252-10.658 2.126-23.282-2.14-33.952-4.272-10.666-14.474-16.974-25.134-21.246l-76.426-24.976v-196.3c0-46.946-39.312-85.966-86.232-85.966h-127.958l-31.986-106h-191.938l-31.99 106h-127.958c-46.916 0-85.938 39.020-85.938 85.964v196.3l-76.148 25.066c-10.66 4.272-21.164 10.668-25.436 21.334-4.27 10.67-6.316 20.98-2.062 33.774l102.156 277.562zM256 272h512v168.522l-256-83.21-256 83.21v-168.522z",
      "M682.462 816.014c-104.506 72.534-236.712 72.516-341.216-0.018 0 0-115.276 128.004-213.264 128.004h42.654c59.708 0 117.292-23.452 170.61-51.188 106.63 55.468 234.586 55.456 341.216-0.014 53.318 27.738 110.9 51.202 170.608 51.202h42.656c-95.302 0-213.264-127.986-213.264-127.986z"
    ],
    "grid": 0,
    "tags": [
      "md-boat"
    ]
  },
  {
    "paths": [
      "M512 96c44 0 80 36 80 80s-36 80-80 80-80-36-80-80 36-80 80-80zM896 384.2h-256v543.8h-85.4v-288h-85.4v288h-85.2v-543.8h-256v-85.4h768v85.4z"
    ],
    "grid": 0,
    "tags": [
      "md-body"
    ]
  },
  {
    "paths": [
      "M544.4 701.2c-1.6-16.4-16.4-29.2-34.6-29.2-16.6 0-30.4 10.8-33.8 25v0l-33.8 185c-1 4.6-1.6 9.2-1.6 14 0 35.4 31 64 69.4 64s69.4-28.6 69.4-64c0-5.8-0.8-11.4-2.4-16.8l-32.6-178z",
      "M620.2 710v0 0z",
      "M808.6 780.6c-3.8-2.8-7.2-5.8-11.2-7.8l-137.8-95c-12.6-7.6-26-7.4-35.8 1.8-9 8.2-10.2 20.8-3.6 30.8l106 131.6c2 3 4.6 5.6 7.2 8.4 17 18.2 54.4 19.2 75 0 20.8-19.6 20.6-54.4 0.2-69.8z",
      "M764.4 670v0 0z",
      "M900.8 645l-129-4.6c-8.4-1.2-16 4.2-17.4 12-1.4 7.2 3 14.2 10.2 17.6v0c0 0 0.2 0 0.2 0l125 35.6c18 3.8 38.2-4.6 38.2-23.2-0-23.8-6.6-35-27.2-37.4z",
      "M259 670v0 0z",
      "M259 670v0c7.2-3.2 11.4-10.4 10.2-17.6-1.4-8-9-13.2-17.4-12l-129 4.6c-20.8 2.4-26.8 13.6-26.8 37.2 0 18.6 19.8 27.2 37.6 23.2l125-35.6c0.2 0.2 0.2 0.2 0.4 0.2z",
      "M364.4 677.6l-137.8 94.8c-4 2.2-7.8 4.8-11.2 7.8-20.8 19.2-20.8 50.2 0 69.2 20.8 19.2 54.2 19.2 75 0 2.8-2.6 5.2-5.4 7.2-8.4l106-131.2c6.6-10 5.4-22.4-3.6-30.6-9.6-9-25.2-9.6-35.6-1.6z",
      "M512 64c0 0 60.4 70.8 60.4 128.8 0 55.6-36.4 100.6-91.8 100.6-55.8 0-97.8-45-97.8-100.6l0.8-13.8c-54.4 64.6-87 152.4-87 243.6 0 119.2 96.4 215.6 215.6 215.6s215.6-96.4 215.6-215.6c-0.2-145.2-71.8-315.2-215.8-358.6zM504.2 557.4c-48 0-86.8-37.8-86.8-84.6 0-43.6 28.2-74.4 75.8-84 47.6-9.8 97-32.6 124.6-69.6 10.6 34.8 15.8 71.4 15.8 108.8 0 71.4-58 129.4-129.4 129.4z"
    ],
    "grid": 0,
    "tags": [
      "md-bonfire"
    ]
  },
  {
    "paths": [
      "M852.4 160.8l-340.4 64-340.4-64c-43.6-6.8-75.6 33.8-75.6 75.2v489c0 41.4 32 65.2 75.6 75.2l340.4 63.8 340.4-64c43.6-10 75.6-33.8 75.6-75.2v-488.8c0-41.4-32-82-75.6-75.2zM852.4 724.8l-302.4 64v-489l302.4-64v489zM474 788.8l-302.4-64v-488.8l302.4 64v488.8z"
    ],
    "grid": 0,
    "tags": [
      "md-book"
    ]
  },
  {
    "paths": [
      "M720 128h-416c-44.004 0-80 35.996-80 80v688l288-128 288 128v-688c0-44.004-35.996-80-80-80z"
    ],
    "grid": 0,
    "tags": [
      "md-bookmark"
    ]
  },
  {
    "paths": [
      "M810.4 128h-42c30 11.4 45.6 41.2 45.6 85.4v597.4c0 44.2-14 74.6-45.6 85.4h42c47.4 0 85.6-38.4 85.6-85.4v-597.4c0-47-38.2-85.4-85.6-85.4z",
      "M691 128.4c-2.8-0.2-5.6-0.4-8.4-0.4h-469.2c-47 0-85.4 38.4-85.4 85.4v597.4c0 47 38.4 85.4 85.4 85.4h469.4c2.8 0 5.6-0.2 8.4-0.4 43-4.2 77-40.8 77-85v-597.4c-0.2-44.2-34.2-80.8-77.2-85zM416 512l-112-64-112 64v-320h224v320z"
    ],
    "grid": 0,
    "tags": [
      "md-bookmarks"
    ]
  },
  {
    "paths": [
      "M552 608h-80c-30.8 0-56-25.2-56-56v-80c0-30.8 25.2-56 56-56h80c30.8 0 56 25.2 56 56v80c0 30.8-25.2 56-56 56z",
      "M352 560v-96c0-36.4 17.4-68.8 44.4-89.2-12.4-54.8-204.4-182.8-268.4-182.8-35.2 0-64 28.8-64 64v512c0 35.2 28.6 64 64 64 64 0 256-128 268.4-182.8-27-20.4-44.4-52.8-44.4-89.2z",
      "M896 192c-64 0-256 128-268.4 182.8 27 20.4 44.4 52.8 44.4 89.2v96c0 36.4-17.4 68.8-44.4 89.2 12.4 54.8 204.4 182.8 268.4 182.8 35.4 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64z"
    ],
    "grid": 0,
    "tags": [
      "md-bowtie"
    ]
  },
  {
    "paths": [
      "M704 288v-79.2c0-44.8-36-80.8-80.8-80.8h-222.4c-44.8 0-80.8 36-80.8 80.8v79.2h-224v527.2c0 44.8 36 80.8 80.8 80.8h670.4c44.8 0 80.8-36 80.8-80.8v-527.2h-224zM624 288h-224v-80h224v80z"
    ],
    "grid": 0,
    "tags": [
      "md-briefcase"
    ]
  },
  {
    "paths": [
      "M848 128h-672c-53.2 0-96 43.2-96 96v576c0 52.8 42.8 96 96 96h672c52.8 0 96-43.2 96-96v-576c0-52.8-42.8-96-96-96zM848 800h-672v-448h672v448z"
    ],
    "grid": 0,
    "tags": [
      "md-browsers"
    ]
  },
  {
    "paths": [
      "M299.8 604.4c-78.2 0-141.4 62-141.4 138.6 0 60.6-54.6 92.4-94.4 92.4 43.4 56.6 117.4 92.6 188.6 92.6 104.2 0 188.6-82.8 188.6-184.8 0-76.8-63.2-138.8-141.4-138.8zM946.2 171.4l-63.2-62c-18.4-18-48-18-66.4 0l-422.6 414.2 129.6 127 422.4-414c18.6-18 18.6-47.2 0.2-65.2z"
    ],
    "grid": 0,
    "tags": [
      "md-brush"
    ]
  },
  {
    "paths": [
      "M896 320h-134.8c-21.6-37.4-51.4-69.6-87.4-94l78.2-78.4-67.6-67.6-104.2 104.2c-22.2-5.4-44.6-8.2-68.2-8.2s-46 2.8-67.6 8.2l-104.8-104.2-67.6 67.6 77.8 78.2c-35.6 24.4-65.2 56.6-86.8 94h-135v96h100.4c-2.4 15.8-4.4 31.6-4.4 48v48h-96v96h96v48c0 16.4 2 32.2 4.4 48h-100.4v96h134.8c50 86 142.6 144 249.2 144s199.2-58 249.2-144h134.8v-96h-100.4c2.4-15.8 4.4-31.6 4.4-48v-48h96v-96h-96v-48c0-16.4-2-32.2-4.4-48h100.4v-95.8z"
    ],
    "grid": 0,
    "tags": [
      "md-bug"
    ]
  },
  {
    "paths": [
      "M948.2 796.4l-370-372.4c36.6-94 16.2-204.6-61-282.2-81.4-81.8-203.4-98.2-301-53.2l174.8 176-122 122.8-179-176c-48.6 98-28.2 220.8 53 302.6 77.2 77.8 187 98.2 280.6 61.4l370 372.4c16.2 16.4 40.6 16.4 57 0l93.6-94c20.4-16.6 20.4-45.2 4-57.4z"
    ],
    "grid": 0,
    "tags": [
      "md-build"
    ]
  },
  {
    "paths": [
      "M512 340.272c50.998 0 99.134 20.050 135.542 56.458 36.408 36.406 56.458 84.544 56.458 135.542 0 35.242-8.844 68.062-26.288 97.546-16.678 28.196-40.874 52.072-69.97 69.052l-31.742 18.524v178.606h-128v-178.606l-31.742-18.524c-59.374-34.648-96.258-98.486-96.258-166.598 0-50.998 20.050-99.134 56.458-135.542s84.544-56.458 135.542-56.458zM554.666 64c-12.792 0-85.332 0-85.332 0v128h85.332v-128zM812.792 171.728l-76.792 76.814 59.728 59.73 76.812-76.792-59.748-59.752zM211.208 171.728l-59.75 59.75 76.812 76.792 59.73-59.728-76.792-76.814zM512 276.272c-140.792 0-256 115.208-256 256 0 93.876 51.208 177.062 128 221.876v205.852h256v-205.854c76.792-44.812 128-125.876 128-221.876 0-140.792-115.208-255.998-256-255.998v0zM960 489.604h-128v85.334h128v-85.334zM192 489.604h-128v85.334h128v-85.334z"
    ],
    "grid": 0,
    "tags": [
      "md-bulb"
    ]
  },
  {
    "paths": [
      "M160 704c0 38.396 27.728 49.062 53.334 72.542v76.792c0 23.458 19.198 42.668 42.666 42.668h42.666c23.468 0 42.668-19.208 42.668-42.668v-42.666h341.332v42.666c0 23.458 19.208 42.668 42.668 42.668h42.666c23.458 0 42.666-19.208 42.666-42.668v-76.792c25.606-23.48 53.334-36.27 53.334-72.542v-407.332c0-149.334-164.272-168.668-352-168.668s-352 19.334-352 168.668v407.332zM320 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM704 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM768 490.666h-512v-213.332h512v213.332z"
    ],
    "grid": 0,
    "tags": [
      "md-bus"
    ]
  },
  {
    "paths": [
      "M96 800h736v96h-736v-96z",
      "M848 128h-688v448c0 88 72 160 160 160h288c88 0 160-72 160-160v-128h80c44 0 80-36 80-80v-160c0-44-36-80-80-80zM848 352h-80v-128h80v128z"
    ],
    "grid": 0,
    "tags": [
      "md-cafe"
    ]
  },
  {
    "paths": [
      "M736 96h-448c-53.2 0-96 43.2-96 96v640c0 52.8 42.8 96 96 96h448c52.8 0 96-43.2 96-96v-640c0-52.8-42.8-96-96-96zM400 832h-96v-96h96v96zM400 656h-96v-96h96v96zM400 480h-96v-96h96v96zM560 832h-96v-96h96v96zM560 656h-96v-96h96v96zM560 480h-96v-96h96v96zM720 832h-96v-272h96v272zM720 480h-96v-96h96v96zM720 288h-416v-96h416v96z"
    ],
    "grid": 0,
    "tags": [
      "md-calculator"
    ]
  },
  {
    "paths": [
      "M736.010 544h-192v192h192v-192zM672.010 128v64h-320v-64h-96v64h-48.020c-44.004 0-80 35.996-80 80v544c0 44.004 35.996 80 80 80h608.020c44.004 0 80-35.996 80-80v-544c0-44.004-35.996-80-80-80h-48v-64h-96zM816.010 816h-608.020v-424h608.020v424z"
    ],
    "grid": 0,
    "tags": [
      "md-calendar"
    ]
  },
  {
    "paths": [
      "M853.332 661.334c-53.332 0-104.542-8.542-151.458-23.458-14.938-4.272-32-2.146-42.664 10.666l-93.878 93.856c-121.604-61.856-219.728-160-281.604-281.606l93.878-93.854c10.664-10.666 14.924-27.728 10.664-42.666-17.074-49.062-25.604-100.272-25.604-153.606 0-23.458-19.198-42.666-42.666-42.666h-149.334c-23.468 0-42.666 19.208-42.666 42.666 0 401.062 324.272 725.334 725.332 725.334 23.46 0 42.668-19.208 42.668-42.666v-149.334c0-23.458-19.208-42.666-42.668-42.666z"
    ],
    "grid": 0,
    "tags": [
      "md-call"
    ]
  },
  {
    "paths": [
      "M638 560c0 69.588-56.412 126-126 126s-126-56.412-126-126c0-69.588 56.412-126 126-126s126 56.412 126 126z",
      "M880 192h-176l-64-64h-256l-64 64h-176c-44.184 0-80 35.816-80 80v544c0 44.184 35.816 80 80 80h736c44.184 0 80-35.816 80-80v-544c0-44.184-35.816-80-80-80zM512 784c-123.71 0-224-100.29-224-224s100.29-224 224-224 224 100.29 224 224-100.29 224-224 224z"
    ],
    "grid": 0,
    "tags": [
      "md-camera"
    ]
  },
  {
    "paths": [
      "M806.416 234.666c-8.542-25.604-32-42.666-59.75-42.666h-469.332c-27.75 0-51.208 17.062-59.75 42.666l-89.584 234.668v320c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-21.334h512v21.334c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-320l-89.584-234.668zM277.334 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM746.666 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM213.334 426.666l64-170.666h469.332l64 170.666h-597.332z"
    ],
    "grid": 0,
    "tags": [
      "md-car"
    ]
  },
  {
    "paths": [
      "M870.4 160h-716.8c-49.8 0-89.2 39.2-89.2 88l-0.4 528c0 48.8 39.8 88 89.6 88h716.8c49.8 0 89.6-39.2 89.6-88v-528c0-48.8-39.8-88-89.6-88zM870.4 776h-716.8v-264h716.8v264zM870.4 336h-716.8v-88h716.8v88z"
    ],
    "grid": 0,
    "tags": [
      "md-card"
    ]
  },
  {
    "paths": [
      "M339.2 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.436 83.202-83.2c-0.002-45.768-37.44-83.202-83.202-83.202zM96 102.4v83.2h83.2l149.766 303.364-62.616 101.908c-6.236 10.4-10.4 24.964-10.4 39.53 0 55.7 38.050 83.2 89.65 83.2h486.4v-80h-476.214c-6.236 0-10.4-4.164-10.4-10.4 0-2.072 4.414-10.4 4.414-10.4l41.564-65.6h309.908c31.202 0 58.256-16.634 72.8-43.672l149.764-257.6c2.474-4.922 4.164-12.492 4.164-20.798 0-22.892-18.728-39.53-41.6-39.53h-615.672l-39.528-83.202h-135.2zM748.798 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.438 83.202-83.202c0-45.766-37.438-83.2-83.202-83.2z"
    ],
    "grid": 0,
    "tags": [
      "md-cart"
    ]
  },
  {
    "paths": [
      "M64 192v512h896v-512h-896zM385 640h-160.8c0-53.2-43-96.2-96.2-96.2v-159.8c70.6 0 128-57.4 128-128h129c-39.8 47-65 115.6-65 192s25.2 145 65 192zM896 543.8c-52 0-96 43-96 96.2h-161c39.8-47 65-115.6 65-192s-25.2-145-65-192h129c0 70.6 57.4 128 128 128v159.8z",
      "M64 768h896v64h-896v-64z"
    ],
    "grid": 0,
    "tags": [
      "md-cash"
    ]
  },
  {
    "paths": [
      "M783.106 128h-667.892c-8.952 0-19.214 7.49-19.214 16.318v428.434c0 8.826 10.262 17.248 19.214 17.248h114.786v177.788l180.256-177.788h372.85c8.954 0 14.894-8.422 14.894-17.248v-428.434c0-8.828-5.942-16.318-14.894-16.318z",
      "M912.792 254h-64.792v333.14c0 31.974-13.83 52.86-50.304 52.86h-361.504l-77.81 78h259.376l180.242 178v-178h114.792c8.956 0 15.208-8.524 15.208-17.364v-428.43c0-8.828-6.252-18.206-15.208-18.206z"
    ],
    "grid": 0,
    "tags": [
      "md-chatboxes"
    ]
  },
  {
    "paths": [
      "M265.6 736c-40.4 0-89.6-49.2-89.6-89.6v-326.4h-19.2c-33.4 0-60.8 27.4-60.8 60.8v547.2l117-116h430.2c33.4 0 60.8-28.2 60.8-61.8v-14.2h-438.4z",
      "M858.2 96h-558.4c-38.4 0-69.8 31.4-69.8 69.8v452.2c0 38.4 31.4 70 69.8 70h476.4l151.8 106v-628.2c0-38.4-31.4-69.8-69.8-69.8z"
    ],
    "grid": 0,
    "tags": [
      "md-chatbubbles"
    ]
  },
  {
    "paths": [
      "M337.062 430.938l-59.728 59.728 192 192 426.666-426.666-59.728-59.728-366.938 364.79-132.272-130.124zM810.666 810.666h-597.332v-597.332h426.666v-85.334h-426.666c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-341.332h-85.334v341.332z"
    ],
    "grid": 0,
    "tags": [
      "md-checkbox-outline"
    ]
  },
  {
    "paths": [
      "M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334zM426.666 725.334l-213.332-213.334 59.728-59.728 153.604 153.604 324.272-324.272 59.728 59.73-384 384z"
    ],
    "grid": 0,
    "tags": [
      "md-checkbox"
    ]
  },
  {
    "paths": [
      "M341.436 432.964l-58.236 58.236 187.2 187.2 416-416-58.236-58.236-357.764 355.672-128.964-126.872zM844.8 512c0 183.036-149.766 332.8-332.8 332.8s-332.8-149.764-332.8-332.8 149.764-332.8 332.8-332.8c31.2 0 62.4 4.164 91.528 12.482l64.472-64.482c-47.836-20.8-99.836-31.2-156-31.2-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416h-83.2z"
    ],
    "grid": 0,
    "tags": [
      "md-checkmark-circle-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM426.6 733.8l-213.2-213.2 59.8-59.8 153.6 153.6 324.2-324.2 59.8 59.8-384.2 383.8z"
    ],
    "grid": 0,
    "tags": [
      "md-checkmark-circle"
    ]
  },
  {
    "paths": [
      "M372.602 679.786l-180.602-180.864-64 61.014 244.602 244.064 523.398-522.988-64-61.012z"
    ],
    "grid": 0,
    "tags": [
      "md-checkmark"
    ]
  },
  {
    "paths": [
      "M810.666 160h-174.7c-14.208-55.208-64.324-96-123.966-96s-109.758 40.792-123.966 96h-174.7c-46.938 0-85.334 38.396-85.334 85.334v629.33c0 46.938 38.396 85.336 85.334 85.336h597.332c46.938 0 85.334-38.398 85.334-85.336v-629.33c0-46.938-38.396-85.334-85.334-85.334zM512 160c23.458 0 42.666 19.198 42.666 42.666s-19.208 42.668-42.666 42.668-42.666-19.2-42.666-42.668 19.208-42.666 42.666-42.666zM816 880h-608v-640h80v144h448v-144h80v640z"
    ],
    "grid": 0,
    "tags": [
      "md-clipboard"
    ]
  },
  {
    "paths": [
      "M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM773.2 324.2c15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8zM160 512c0-17.6 14.4-32 32-32s32 14.4 32 32-14.4 32-32 32-32-14.4-32-32zM250.8 699.8c-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8 15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8zM262.6 368c-8.8 15.2-28.4 20.6-43.8 11.8-15.2-8.8-20.6-28.4-11.8-43.8 8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM336 207.2c15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8s-35 3.6-43.8-11.8c-8.8-15.4-3.4-35 11.8-43.8zM320.4 428.6l31.2-53.2 190.4 113.8v278.8h-62v-246.8l-159.6-92.6zM379.8 805.2c-8.8 15.2-28.4 20.6-43.8 11.8s-20.6-28.4-11.8-43.8c8.8-15.2 28.4-20.6 43.8-11.8 15.2 8.8 20.6 28.4 11.8 43.8zM512 864c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zM512 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32c0 17.6-14.4 32-32 32zM688 816.8c-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8 15.2-8.8 35-3.6 43.8 11.8s3.4 35-11.8 43.8zM699.8 250.8c-8.8 15.2-28.4 20.6-43.8 11.8s-20.6-28.4-11.8-43.8c8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM816.8 688c-8.8 15.2-28.4 20.6-43.8 11.8-15.2-8.8-20.6-28.4-11.8-43.8 8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM832 544c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z"
    ],
    "grid": 0,
    "tags": [
      "md-clock"
    ]
  },
  {
    "paths": [
      "M512 96c-230.882 0-416 185.118-416 416 0 230.872 185.118 416 416 416 230.87 0 416-185.128 416-416 0-230.882-185.128-416-416-416zM720.004 661.762l-58.24 58.234-149.764-149.762-149.762 149.762-58.242-58.234 149.766-149.762-149.766-149.762 58.242-58.232 149.762 149.756 149.762-149.756 58.24 58.232-149.764 149.762 149.766 149.762z"
    ],
    "grid": 0,
    "tags": [
      "md-close-circle"
    ]
  },
  {
    "paths": [
      "M810 273.596l-59.596-59.596-238.404 238.404-238.404-238.404-59.596 59.596 238.404 238.404-238.404 238.404 59.596 59.596 238.404-238.404 238.404 238.404 59.596-59.596-238.404-238.404z"
    ],
    "grid": 0,
    "tags": [
      "md-close"
    ]
  },
  {
    "paths": [
      "M64 192v640h896v-640h-896zM876 511.6c0 46.8-2.8 82.4-6.6 140.4s-33.6 98.8-103.4 105.2c-69.8 6.4-167.6 7-254 6.8-85.8 0.2-184-0.2-254-6.8-69.8-6.4-99.4-47.2-103.4-105.2s-6.6-93.6-6.6-140.4c0-46.8 0.2-77.2 6.6-140.4s40.2-98.4 103.4-104.8 172-6.4 254-6.4 190.8 0 254 6.4c63.2 6.4 97 41.8 103.4 104.8 6.4 63.2 6.6 93.8 6.6 140.4z",
      "M715 560.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-22-24.8-55-37.2-98.6-37.2-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0.4 0 0.4 5 0.4 6.8z",
      "M405.2 560.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-22-24.8-55-37.2-98.6-37.2-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0.4 0 0.4 5 0.4 6.8z"
    ],
    "grid": 0,
    "tags": [
      "md-closed-captioning"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416c228.8 0 416-187.2 416-416s-187.2-416-416-416zM699.2 678.4c0 0-351.518 0-353.598 0-68.636 0-124.8-56.164-124.8-124.798 0-68.638 56.164-124.8 124.8-124.8 2.082 0 4.164 0 6.234 0 18.728-72.8 83.202-124.798 160.166-124.798 91.528 0 166.398 74.87 166.398 166.396h20.8c58.236 0 104 45.764 104 104.002 0 58.234-45.764 103.998-104 103.998z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud-circle"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM426.666 725.334l-149.332-149.334 59.728-59.728 89.604 89.604 221.876-221.876 59.73 59.728-281.606 281.606z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud-done"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM448 536v-152h128v152h136l-200 200-200-200h136z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud-download"
    ]
  },
  {
    "paths": [
      "M806.002 434.002c-28.008-137.998-148.006-242.002-294.002-242.002-115.996 0-215.998 65.996-265.994 162-120.002 12.004-214.006 113.996-214.006 238 0 131.992 108.008 240 240 240h520c110 0 200-90 200-200.002 0-105.994-81.994-191.998-185.998-197.996zM792 752h-520c-88.008 0-160-71.992-160-160 0-88 71.992-160 160-160h28.008c25.996-92 110-160 211.992-160 121.992 0 220 98 220 220v20h60c65.996 0 120 54.006 120 120 0 65.996-54.004 120-120 120z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud-outline"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM576 552v152h-128v-152h-136l200-200 200 200h-136z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud-upload"
    ]
  },
  {
    "paths": [
      "M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998z"
    ],
    "grid": 0,
    "tags": [
      "md-cloud"
    ]
  },
  {
    "paths": [
      "M246.8 366c0.8-0.2 1.6-0.2 2.4-0.4-1 0.2-1.6 0.4-2.4 0.4z",
      "M683 606.8c-21.6-111.4-118.6-194.8-235-194.8-68 0-130.2 24-173 78.2 58.8 4.4 113.4 26.2 155.4 68.4 31.2 31.4 53.2 69.8 64.2 111.6h-57.4c-26.2-75.2-96-129-181.2-129-10.2 0-24.6 1.2-35.4 3.4-91.4 18.8-156.6 95.2-156.6 190 0 106.8 86 193.6 192 193.6h416c88.2 0 160-72.2 160-161.2-0.2-85.4-65.8-154.4-149-160.2z",
      "M225 450.8c27.2-34.6 61.4-61 101.6-78.4 36.8-16 77.6-24 121.4-24 12.2 0 24.4 0.8 36.4 2.2-12.2-36.2-18.8-75.2-18.8-115.6 0-49.2 9.8-96.2 27.6-138.8-169.4 41.2-295.2 195.2-295.2 378.4 0 3.2 0 6.4 0.2 9.6 0.2 0 0.4-0.2 0.6-0.2l26.2-33.2z",
      "M835.2 613.6c26.6 28.4 45.2 63 54.2 100.2 33-42.8 57.4-92.8 70.6-147-42.4 18-89 27.8-137.8 27.8-2.4 0-4.8 0-7.2 0 7 5.8 13.8 12.2 20.2 19z"
    ],
    "grid": 0,
    "tags": [
      "md-cloudy-night"
    ]
  },
  {
    "paths": [
      "M246.8 366c0.8-0.2 1.6-0.2 2.4-0.4-1 0.2-1.6 0.4-2.4 0.4z",
      "M786.4 438.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 100.4 225 224 225h485.4c103 0 186.6-84 186.6-187.6 0-98.8-76.6-179.2-173.6-186z"
    ],
    "grid": 0,
    "tags": [
      "md-cloudy"
    ]
  },
  {
    "paths": [
      "M469.2 320v251.4l-89.4-87.2-59.8 59.8 192 192 192-192-59.8-62-89.4 89.4v-251.4h-85.6z",
      "M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z"
    ],
    "grid": 0,
    "tags": [
      "md-code-download"
    ]
  },
  {
    "paths": [
      "M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z",
      "M311.2 552h80v-80h-80v80zM712.8 472h-80v80h80v-80zM472 552h80v-80h-80v80z"
    ],
    "grid": 0,
    "tags": [
      "md-code-working"
    ]
  },
  {
    "paths": [
      "M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z"
    ],
    "grid": 0,
    "tags": [
      "md-code"
    ]
  },
  {
    "paths": [
      "M960 576v-128h-69.4c-4-24.2-10.4-47.6-18.6-70l60-34.6-64-110.8-60 34.6c-15.4-18.6-32.6-35.8-51.2-51.2l34.6-60-110.8-64-34.6 60c-22.4-8.4-45.8-14.6-70-18.6v-69.4h-128v69.4c-24.2 4-47.6 10.4-70 18.6l-34.6-60-110.8 64 34.6 60c-18.6 15.4-35.8 32.6-51.2 51.2l-60-34.6-64 110.8 60 34.6c-8.4 22.4-14.6 45.8-18.6 70h-69.4v128h69.4c4 24.2 10.4 47.6 18.6 70l-60 34.6 64 110.8 60-34.6c15.4 18.6 32.6 35.8 51.2 51.2l-34.6 60 110.8 64 34.6-60c22.4 8.4 45.8 14.6 70 18.6v69.4h128v-69.4c24.2-4 47.6-10.4 70-18.6l34.6 60 110.8-64-34.6-60c18.6-15.4 35.8-32.6 51.2-51.2l60 34.6 64-110.8-60-34.6c8.4-22.4 14.6-45.8 18.6-70h69.4zM754 355.8l-93.8 34.2c-22-26.6-51-47.2-84.2-59v-99.8c74.4 16.8 137.8 62.4 178 124.6zM448 231.2v99.8c-33.2 11.8-62.2 32.4-84.2 59l-93.8-34.2c40.2-62.2 103.6-107.8 178-124.6zM224 512c0-12.2 0.8-24.2 2.2-36l93.8 34.2c0 0.6 0 1.2 0 1.8 0 35.6 9.8 69 26.6 97.6l-64.2 76.4c-36.6-48.4-58.4-108.6-58.4-174zM512 800c-47.4 0-92-11.4-131.6-31.8l64.2-76.4c21 7.8 43.6 12.2 67.4 12.2s46.4-4.4 67.4-12.2l64.2 76.4c-39.6 20.4-84.2 31.8-131.6 31.8zM741.6 686l-64.2-76.4c16.8-28.6 26.6-62 26.6-97.6 0-0.6 0-1.2 0-1.8l93.8-34.2c1.4 11.8 2.2 23.8 2.2 36 0 65.4-21.8 125.6-58.4 174z"
    ],
    "grid": 0,
    "tags": [
      "md-cog"
    ]
  },
  {
    "paths": [
      "M273 155.4l74 134-283 282 368.8 356.6 304.8-297.2 108.8-22.8-513.6-512-59.8 59.4zM641 571.4h-411.2l205.6-204.6 205.6 204.6z",
      "M846.6 608c0 0-113.4 123-113.4 184.2 0 61.4 50.8 111 113.4 111s113.4-49.8 113.4-111c0-61.2-113.4-184.2-113.4-184.2z"
    ],
    "grid": 0,
    "tags": [
      "md-color-fill"
    ]
  },
  {
    "paths": [
      "M883.6 240.2l-99.8-99.8c-16.6-16.6-43.6-16.6-60.2 0l-133.2 133.2-82.2-81.6-60.2 60.2 60.6 60.6-380.6 380.6v202.6h202.6l380.6-380.6 60.6 60.6 60.2-60.2-82-82 133.2-133.2c17-16.8 17-43.6 0.4-60.4zM295.2 810.8l-82-82 343.8-343.8 82 82-343.8 343.8z"
    ],
    "grid": 0,
    "tags": [
      "md-color-filter"
    ]
  },
  {
    "paths": [
      "M512 128c-211.198 0-384 172.802-384 384 0 211.208 172.802 384 384 384 36.272 0 64-27.728 64-64 0-17.062-6.396-32-17.062-42.666-10.666-10.668-17.062-25.606-17.062-42.668 0-36.27 27.728-64 64-64h76.792c117.334 0 213.334-96 213.334-213.332-0.002-187.73-172.794-341.334-384.002-341.334zM277.334 512c-36.272 0-64-27.728-64-64s27.728-64 64-64c36.27 0 64 27.728 64 64s-27.73 64-64 64zM405.334 341.334c-36.272 0-64-27.73-64-64 0-36.272 27.728-64 64-64 36.27 0 64 27.728 64 64 0 36.27-27.73 64-64 64zM618.666 341.334c-36.27 0-64-27.73-64-64 0-36.272 27.73-64 64-64 36.272 0 64 27.728 64 64 0 36.27-27.728 64-64 64zM746.666 512c-36.27 0-64-27.728-64-64s27.73-64 64-64c36.272 0 64 27.728 64 64s-27.728 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "md-color-palette"
    ]
  },
  {
    "paths": [
      "M401.6 314.4l-72.8 74.8 494.6 506.8 72.6-74.8z",
      "M362 128h74v136h-74v-136z",
      "M362 524h74v136h-74v-136z",
      "M540 352h138v74h-138v-74z",
      "M611.2 231.6l-51.4-52.6-94.2 96.6 51.2 52.4z",
      "M337.6 275.6l-94.2-96.6-51.2 52.6 94.2 96.4z",
      "M192.2 555.8l51.2 52.4 94.2-96.4-51.2-52.6z",
      "M128 352h130v74h-130v-74z"
    ],
    "grid": 0,
    "tags": [
      "md-color-wand"
    ]
  },
  {
    "paths": [
      "M512 462.716c-26.884 0-49.286 22.4-49.286 49.284s22.4 49.286 49.286 49.286 49.286-22.4 49.286-49.286-22.402-49.284-49.286-49.284zM512 64c-246.4 0-448 201.6-448 448s201.6 448 448 448 448-201.6 448-448-201.6-448-448-448zM610.568 610.568l-367.368 170.232 170.232-367.358 367.368-170.242-170.232 367.368z"
    ],
    "grid": 0,
    "tags": [
      "md-compass"
    ]
  },
  {
    "paths": [
      "M861.8 786.8l-382.2-380.4c31.8-81.2 14.2-176.4-53.2-243.4-70.8-70.6-177-84.6-262-45.8l152.2 151.6-106.2 105.8-155.8-151.6c-42.2 84.6-24.6 190.4 46.2 261 67.2 67 162.8 84.6 244.2 53l28.8 28.6-210.4 210.4c-15.2 11.4-15.2 38 3.8 53.2l87.6 87.4c15.2 15.2 38.2 15.2 53.4 0l192.2-224.8 226.8 225.8c14.2 14.2 35.4 14.2 49.6 0l81.4-81.2c17.8-14.2 17.8-39 3.6-49.6z",
      "M988.8 433.2l-69-68.2c-4.4-4.4-11.6-4.4-16 0l-7.4 7.4-37-31.6c0 0 2.4-20-9.8-37.4-12.4-17.4-32.2-39.6-46.4-53.8-14.2-14-68.2-67.8-139.4-102.8-71.4-35.4-121.8-50.8-181.8-50.8v59.4c0 0 57.4 33.2 90.2 59.4 32.6 26.2 33.6 119 33.6 119l-57 57 113 112.2 62-72.6c25.8-7 47.6-7.6 60.4-0.6l27.4 26.6-19.2 19c-4.4 4.4-4.4 11.4 0 15.8l69 68.2c4.4 4.4 11.6 4.4 16 0l111.4-110.4c4.2-4.4 4.2-11.6 0-15.8z"
    ],
    "grid": 0,
    "tags": [
      "md-construct"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM512 220.8c68.6 0 124.8 56.2 124.8 124.8s-56.2 124.8-124.8 124.8-124.8-56.2-124.8-124.8 56.2-124.8 124.8-124.8zM512 811.6c-104 0-195.6-54-249.6-133.2 2-83.2 166.4-129 249.6-129s247.6 45.8 249.6 129c-54 79-145.6 133.2-249.6 133.2z"
    ],
    "grid": 0,
    "tags": [
      "md-contact"
    ]
  },
  {
    "paths": [
      "M478.416 687.874c-35.56 20.206-76.684 31.752-120.51 31.752-43.818 0-84.934-11.542-120.492-31.74-94.326 28.776-152.128 124.114-173.414 208.114h587.824c-21.278-84-79.074-179.366-173.408-208.126z",
      "M357.906 240.070c-116.958 0-211.772 94.788-211.772 211.716s94.814 211.714 211.772 211.714c116.958 0 211.772-94.788 211.772-211.714 0-116.928-94.816-211.716-211.772-211.716zM357.906 613.046c-67.342 0-124.89-45.026-147.994-101.046h295.988c-23.108 56.022-80.652 101.046-147.994 101.046z",
      "M645.204 768h314.796c-21.276-84-79.074-163.382-173.406-192.144-35.562 20.208-76.686 31.746-120.512 31.746-29.646 0-58.048-5.308-84.336-14.98-14.89 24.94-33.854 51.184-55.948 69.812 52.692 20.274 92.494 65.566 119.406 105.566z",
      "M613.090 400h200.986c-23.108 56-80.654 100.586-147.994 100.586-17.75 0-34.808-3.384-50.75-9.020-2.676 17.418-7.086 34.14-13.040 50.236 20.132 6.348 41.558 9.724 63.79 9.724 116.958 0 211.772-94.82 211.772-211.744 0-116.93-94.814-211.732-211.772-211.732-74.98 0-140.854 39.406-178.486 98.18 63.618 36.536 110.326 99.77 125.494 173.77z"
    ],
    "grid": 0,
    "tags": [
      "md-contacts"
    ]
  },
  {
    "paths": [
      "M128 742.4h153.59v153.6h102.41v-256h-256v102.4zM281.59 281.6h-153.59v102.4h256v-256h-102.41v153.6zM640 896h102.4v-153.6h153.6v-102.4h-256v256zM742.4 281.6v-153.6h-102.4v256h256v-102.4h-153.6z"
    ],
    "grid": 0,
    "tags": [
      "md-contract"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM738.2 738.2c-60.4 60.6-140.8 93.8-226.2 93.8v-640c85.4 0 165.8 33.2 226.2 93.8 60.6 60.4 93.8 140.8 93.8 226.2s-33.2 165.8-93.8 226.2z"
    ],
    "grid": 0,
    "tags": [
      "md-contrast"
    ]
  },
  {
    "paths": [
      "M592 96h-239c-44.2 0-81 34.8-81 79v17h-15c-44.2 0-81 34.8-81 79v576c0 44.2 36.8 81 81 81h416c44.2 0 79-36.8 79-81v-15h17c44.2 0 79-36.8 79-81v-399l-256-256zM592 185.2l166.8 166.8h-166.8v-166.8zM688 847c0 9.4-6.8 17-15 17h-416c-8.8 0-17-8.2-17-17v-576c0-8.2 7.6-15 17-15h15v511c0 44.2 20.8 65 65 65h351v15zM784 751c0 9.4-6.8 17-15 17h-416c-8.8 0-17-8.2-17-17v-576c0-8.2 7.6-15 17-15h175v256h256v335z"
    ],
    "grid": 0,
    "tags": [
      "md-copy"
    ]
  },
  {
    "paths": [
      "M128 736v160h160l471.454-471.458-159.998-159.996-471.456 471.454zM883.204 300.796c17.062-17.062 17.062-42.668 0-59.73l-100.27-100.27c-17.062-17.062-42.668-17.062-59.73 0l-78.936 78.938 159.998 159.996 78.938-78.934z"
    ],
    "grid": 0,
    "tags": [
      "md-create"
    ]
  },
  {
    "paths": [
      "M704 625.4h75.6v-305.4c0-41.6-34-75.6-75.6-75.6h-305.4v75.6h305.4v305.4zM320 692.4v-596.4h-75.6v148.4h-148.4v75.6h148.4v372.4c0 41.6 34 75.6 75.6 75.6h384v160h75.6v-160h148.4v-75.6h-608z"
    ],
    "grid": 0,
    "tags": [
      "md-crop"
    ]
  },
  {
    "paths": [
      "M934.6 336.2c-3.6 0-7 0.6-10.2 2l-355.2 184.2c0 0-0.2 0-0.2 0-15.2 9.4-25 25-25 42.8v371.8c0 12.8 11.2 23 25.4 23 4.4 0 8.6-1 12.2-2.8 0.4-0.2 0.8-0.4 1-0.6l350-185.6c16.4-9 27.4-25.4 27.4-44.2v-367.6c0-12.8-11.4-23-25.4-23z",
      "M908.6 237l-363.4-163.4c0 0-21.4-9.6-33.2-9.6s-33 9.6-33 9.6l-363.8 163.4c0 0-16 6.6-16 19 0 13.2 16.6 23 16.6 23l371 195.6c7.6 3.4 16.2 5.2 25.2 5.2 9.2 0 17.8-2 25.4-5.4l370.8-195.8c0 0 15-8 15-23 0.2-12.6-14.6-18.6-14.6-18.6z",
      "M455 522.4l-355.4-184.4c-3-1.2-6.6-2-10.2-2-14 0-25.4 10.2-25.4 23v367.6c0 18.8 11 35.2 27.4 44.2l0.4 0.2 349.4 185.4c3.8 2.2 8.4 3.4 13.2 3.4 14 0 25.4-10.4 25.4-23v-371.6c0.2-17.8-9.8-33.6-24.8-42.8z"
    ],
    "grid": 0,
    "tags": [
      "md-cube"
    ]
  },
  {
    "paths": [
      "M406.2 316.6c10.4-22.4 16.2-47 16.2-73.4 0-99-80.2-179.2-179.2-179.2s-179.2 80.2-179.2 179.2 80.2 179.2 179.2 179.2c26.4 0 51-5.8 73.4-16.2l105.8 105.8-105.8 105.8c-22.4-10.4-47-16.2-73.4-16.2-99 0-179.2 80.2-179.2 179.2s80.2 179.2 179.2 179.2 179.2-80.2 179.2-179.2c0-26.4-5.8-51-16.2-73.4l105.8-105.8 313.6 313.6h134.4v-44.8l-553.8-553.8zM243.2 332.8c-49.2 0-89.6-39.8-89.6-89.6s40.4-89.6 89.6-89.6 89.6 39.8 89.6 89.6-40.4 89.6-89.6 89.6zM243.2 870.4c-49.2 0-89.6-39.8-89.6-89.6s40.4-89.6 89.6-89.6 89.6 39.8 89.6 89.6-40.4 89.6-89.6 89.6zM512 534.4c-12.6 0-22.4-9.8-22.4-22.4s9.8-22.4 22.4-22.4c12.6 0 22.4 9.8 22.4 22.4s-9.8 22.4-22.4 22.4zM825.6 108.8l-268.8 268.8 89.6 89.6 313.6-313.6v-44.8h-134.4z"
    ],
    "grid": 0,
    "tags": [
      "md-cut"
    ]
  },
  {
    "paths": [
      "M874.666 64h-725.332c-46.938 0-85.334 38.394-85.334 85.332v565.334c0 46.938 38.396 85.334 85.334 85.334h277.332l-85.332 96v64h341.332v-64l-85.332-96h277.332c46.938 0 85.334-38.396 85.334-85.334v-565.334c0-46.938-38.396-85.332-85.334-85.332zM874.666 640h-725.332v-490.668h725.332v490.668z"
    ],
    "grid": 0,
    "tags": [
      "md-desktop"
    ]
  },
  {
    "paths": [
      "M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416-186.4-416-416-416zM512 699.2c-103.6 0-187.2-83.6-187.2-187.2s83.6-187.2 187.2-187.2 187.2 83.6 187.2 187.2-83.6 187.2-187.2 187.2zM512 470.4c-22.8 0-41.6 18.8-41.6 41.6s18.8 41.6 41.6 41.6 41.6-18.8 41.6-41.6-18.8-41.6-41.6-41.6z"
    ],
    "grid": 0,
    "tags": [
      "md-disc"
    ]
  },
  {
    "paths": [
      "M576 96h-304c-44.184 0-80 35.816-80 80v672c0 44.184 35.816 80 80 80h480c44.184 0 80-35.816 80-80v-496l-256-256zM544 384v-224l224 224h-224z"
    ],
    "grid": 0,
    "tags": [
      "md-document"
    ]
  },
  {
    "paths": [
      "M775.162 279.424l-61.652-61.424-279.684 278.638 61.662 61.438 279.674-278.652zM962.344 218l-466.856 462.938-182.78-182.102-61.654 61.43 244.434 245.734 528.512-526.576-61.656-61.424zM0 560.266l246.642 245.734 61.658-61.426-244.432-245.738-63.868 61.43z"
    ],
    "grid": 0,
    "tags": [
      "md-done-all"
    ]
  },
  {
    "paths": [
      "M832 399h-182.8v-271h-274.4v271h-182.8l320 316.2 320-316.2zM192 805.6v90.4h640v-90.4h-640z"
    ],
    "grid": 0,
    "tags": [
      "md-download"
    ]
  },
  {
    "paths": [
      "M256 352h512v256h-512v-256z",
      "M896 192h-768c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h768.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32zM832 672h-640v-384h640v384z",
      "M160 928h114l45-128h-112.8z",
      "M558.8 96h-93.6l-23 64h139.6z",
      "M750 928h114l-46-128h-113z",
      "M464 800h96v64h-96v-64z"
    ],
    "grid": 0,
    "tags": [
      "md-easel"
    ]
  },
  {
    "paths": [
      "M512 64c-140.8 0-352 266.4-352 513.8s140.8 382.2 352 382.2 352-134.8 352-382.2-211.2-513.8-352-513.8z"
    ],
    "grid": 0,
    "tags": [
      "md-egg"
    ]
  },
  {
    "paths": [
      "M430.938 665.604l59.726 59.728 213.336-213.332-213.336-213.334-59.726 59.73 110.938 110.938h-413.876v85.332h411.728l-108.79 110.938zM810.668 128h-597.336c-46.936 0-85.332 38.396-85.332 85.332v170.668h85.332v-170.666h597.336v597.336h-597.336v-170.67h-85.332v170.668c0 46.936 38.396 85.332 85.332 85.332h597.336c46.936 0 85.332-38.396 85.332-85.332v-597.336c0-46.936-38.396-85.332-85.332-85.332z"
    ],
    "grid": 0,
    "tags": [
      "md-exit"
    ]
  },
  {
    "paths": [
      "M793.59 793.6h-153.59v102.4h256v-256h-102.41z",
      "M793.6 230.41v153.59h102.4v-256h-256v102.41z",
      "M230.41 230.4h153.59v-102.4h-256v256h102.41z",
      "M230.4 793.59v-153.59h-102.4v256h256v-102.41z"
    ],
    "grid": 0,
    "tags": [
      "md-expand"
    ]
  },
  {
    "paths": [
      "M512.2 289.6c112.4 0 203.8 90.6 203.8 202.2 0 26.2-5.2 51-14.6 74l119 118c61.6-51 110-116.8 139.8-192-70.6-177.4-244.6-303.2-448.4-303.2-57 0-111.6 10.2-162.2 28.2l88 87.4c23.2-9.2 48.2-14.6 74.6-14.6zM104.8 179.4l111.8 110.8c-67.8 52-120.8 121.6-152.6 201.6 70.4 177.4 244.4 303.2 448.2 303.2 63.2 0 123.4-12.2 178.4-34l136.6 135 51.8-51.4-722.6-716.6-51.6 51.4zM330 402.8l63.2 62.6c-2 8.4-3.2 17.4-3.2 26.2 0 67 54.6 121.2 122.2 121.2 9 0 18-1.2 26.4-3.2l63.2 62.6c-27.2 13.4-57.4 21.4-89.6 21.4-112.4 0-203.8-90.6-203.8-202.2-0-31.6 8.2-61.4 21.6-88.6zM505.6 371.4l128.4 127.4 0.8-6.4c0-67-54.6-121.2-122.2-121.2l-7 0.2z"
    ],
    "grid": 0,
    "tags": [
      "md-eye-off"
    ]
  },
  {
    "paths": [
      "M512 210c-203.6 0-376.8 124.8-448 302 71.2 177.2 244.4 302 448 302s376.8-124.8 448-302c-71.2-177.2-244.4-302-448-302zM512 713.4c-112 0-203.6-90.6-203.6-201.4s91.6-201.4 203.6-201.4 203.6 90.6 203.6 201.4-91.6 201.4-203.6 201.4zM512 391.2c-67.2 0-122.2 54.4-122.2 120.8s55 120.8 122.2 120.8 122.2-54.4 122.2-120.8-55-120.8-122.2-120.8z"
    ],
    "grid": 0,
    "tags": [
      "md-eye"
    ]
  },
  {
    "paths": [
      "M960 512l-435.2-292v584l435.2-292zM64 220v584l435.2-292-435.2-292z"
    ],
    "grid": 0,
    "tags": [
      "md-fastforward"
    ]
  },
  {
    "paths": [
      "M800 352c0-159-129-288-288-288s-288 129-288 288c0 142.8 103.8 261.2 240 284v100h-144v96h144v128h96v-128h144v-96h-144v-100c136.2-22.8 240-141.2 240-284zM320 352c0-105.8 86.2-192 192-192s192 86.2 192 192-86.2 192-192 192-192-86.2-192-192z"
    ],
    "grid": 0,
    "tags": [
      "md-female"
    ]
  },
  {
    "paths": [
      "M898.4 416h-52.4v-64l-28.8-96h-51.2v-64l-30-96h-448l-30 96v64h-51.2l-28.8 96v64h-52.4l-29.6 96v330.6c0 47 70.4 85.4 117.4 85.4h629.4c43.6 0 85.4-39.4 85.4-82v-334l-29.8-96zM352 192h320v64h-320v-64zM270 352h484v64h-484v-64zM834 576h-165.2c-14.8 73-79.4 128-156.8 128s-142-55-156.8-128h-165.2v-64h644v64z"
    ],
    "grid": 0,
    "tags": [
      "md-filing"
    ]
  },
  {
    "paths": [
      "M752 128v85.334h-80v-85.334h-320v85.334h-80v-85.334h-80v768h80v-85.332h80v85.332h320v-85.332h80v85.332h80v-768h-80zM352 725.334h-80v-85.334h80v85.334zM352 554.668h-80v-85.334h80v85.334zM352 384h-80v-85.332h80v85.332zM752 725.334h-80v-85.334h80v85.334zM752 554.668h-80v-85.334h80v85.334zM752 384h-80v-85.332h80v85.332z"
    ],
    "grid": 0,
    "tags": [
      "md-film"
    ]
  },
  {
    "paths": [
      "M156.2 411.2c-4.8 0-9.8-1.2-14.2-3.8-13.4-7.8-18-24.8-10.2-38.2 35.6-60 143.8-200.2 380.2-200.2 102.4 0 192.2 27.2 266.8 80.8 61.4 44 95.8 93.8 112.2 117.8 8.8 12.8 5.4 30-7.4 38.8-12.8 8.6-30.4 5.4-39.2-7.4-29.8-43.2-120.2-174.4-332.4-174.4-207.2 0-300.8 120.8-331.4 172.6-5.2 9.2-14.6 14-24.4 14z",
      "M631 960c-2.4 0-4.6-0.2-7-0.8-171.4-43-235.4-216.2-238-223.4l-0.4-1.6c-1.4-5-35.8-123.8 17-193.4 24.2-31.8 61-48 109.6-48 45.2 0 77.8 14.2 100.2 43.6 18.4 24 25.8 53.6 33 82.2 15 59.4 25.8 90.6 88.2 93.8 27.4 1.4 45.4-14.8 55.6-28.6 27.6-37.6 32.4-99 11.6-153-26.8-70-121.6-201.8-288.8-201.8-71.4 0-137 23.2-189.6 66.8-43.6 36.2-78.2 87.2-94.8 139.6-30.8 97.6 9.6 251 10 252.4 4 14.8-5 30.2-20 34-15 4-30.6-5-34.6-19.8-1.8-7-45-170.6-9.4-283.4 38.8-122.2 158.4-245.4 338.4-245.4 83.2 0 161.8 28.6 227.4 82.6 50.8 42 92.4 98.4 114 154.8 27.6 72 20.2 152.8-18.8 205.6-26 35.2-63 53.6-104 51.6-106.8-5.4-126-80.8-140-135.8-14.4-56.4-23.6-83.6-78.6-83.6-30.2 0-51.4 8.4-64.6 25.8-18 23.8-19.4 61-17.4 88 2 28.2 8 51 9.4 55.6 4.4 11.2 61.6 153 198.6 187.4 15.2 3.8 24.2 19 20.4 33.8-3.4 12.6-14.8 21-27.4 21z",
      "M411 947.2c-7.6 0-15-3-20.6-8.8-68.6-72.8-107.4-154.2-122-256v-0.6c-8.2-67.4 3.8-162.8 62.6-228.4 43.4-48.4 104.4-73 181-73 90.6 0 161.8 42.6 206.2 123 32.2 58.4 38.6 116.6 38.8 119 1.6 15.4-9.8 29-25.2 30.6s-29.4-9.6-31-24.8v0c0-0.6-5.6-50.6-33-99.4-34.4-61.4-86.8-92.6-156-92.6-59.8 0-106.6 18.2-138.8 54.2-46.4 51.8-55.4 131.6-49 184.4 12.8 90 47 161.6 107.4 225.6 10.6 11.2 10 29-1.4 39.4-5.2 4.8-12.2 7.4-19 7.4z",
      "M727 867c-60 0-111-16.8-151.8-50.2-82-66.8-91.2-175.6-91.6-180.2-1.2-15.4 10.4-28.8 26-30s29 10.2 30.2 25.6c0.2 1.6 8.4 90.6 71.6 141.8 37.4 30.2 87.4 42.2 149 35.2 15.4-1.8 29.4 9.2 31.2 24.6s-9.4 29.2-24.8 30.8c-13.6 1.6-27 2.4-39.8 2.4z",
      "M774.4 125.2c-23.4-15.4-106.4-61.2-262.4-61.2-163.8 0-247 50.6-265.4 63.4-1.2 0.8-2.4 1.6-3.4 2.6-0.2 0.2-0.4 0.2-0.4 0.2v0c-5.8 5.2-9.4 12.6-9.4 20.8 0 15.4 12.6 27.8 28.2 27.8 6.2 0 11.8-2 16.4-5.2v0l-0.2 0.2c0.8-0.6 72.6-54 234.2-54s233.4 53.6 234.2 54l-0.2-0.2 0.4-0.4c4.8 3.6 10.6 5.6 17 5.6 15.6 0 28.2-12.4 28.2-27.8 0-11.6-7-21.6-17.2-25.8z"
    ],
    "grid": 0,
    "tags": [
      "md-finger-print"
    ]
  },
  {
    "paths": [
      "M792 166.4c-27.6 3.4-62.2 8.4-99.2 8.4-57.6 0-110-13.6-163-24.4-53.8-11-109.4-22.4-168.2-22.4-117.2 0-157 24.2-161.2 26.8l-8.4 5.8v735.4h96v-356.4c19.4-2.4 43.8-4 73.8-4 54.6 0 105.6 20 159.6 31 55.2 11.2 112 23 173.8 23 36.8 0 69.2-4.8 96.8-8 15-1.8 28-3.4 40-5.4v-415.8c-10 2-25 4.2-40 6z"
    ],
    "grid": 0,
    "tags": [
      "md-flag"
    ]
  },
  {
    "paths": [
      "M786.6 444.2l-0.4 20.8c-1.6 23.4-15.8 86.8-44.2 109.4 14-30.4 34.6-94.4 20.4-165.4-39.2-195-187.4-277.8-376.4-309l-34.4-4.4c79 94.4 112.2 163.4 99.4 233.6-4.6 25.2-20 46.8-28 63.2 0 0 4.8-25.8 4-57.4-0.6-28.4-13.2-62-36-79.2 7 36.8-1.6 67-18.2 95.4-49.4 84.4-170.8 115.6-180.8 271.6v7.6c0 107.4 51.2 198 137.4 250-13.6-24.6-24-70.4-11.4-120.4 8 47.4 28 72 49.8 103.6 16.4 23.4 38.2 38.6 66.2 49.8s62 14.4 95.8 14.4c111.6 0 182.8-36.2 238.2-101s64.2-136 64.2-212.8-17-121.8-45.6-169.8z"
    ],
    "grid": 0,
    "tags": [
      "md-flame"
    ]
  },
  {
    "paths": [
      "M320 96v448h128v384l256-512h-128l128-320h-384z"
    ],
    "grid": 0,
    "tags": [
      "md-flash"
    ]
  },
  {
    "paths": [
      "M873.8 708.8l-201.8-324.8v-192h64v-96h-448v96h64v192l-199.8 324.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2zM310.2 608l59-96h286.2l59.6 96h-404.8z"
    ],
    "grid": 0,
    "tags": [
      "md-flask"
    ]
  },
  {
    "paths": [
      "M810.2 512c50.4-23.8 85.8-74.2 85.8-133.8 0-82-67.2-148.6-150-148.6-31.8 0-60.6 9.6-85.2 26.2l1.2-11.2c0-82-67.2-148.6-150-148.6s-150 66.6-150 148.6l1.2 11.2c-24-16.6-53.4-26.2-85.2-26.2-82.8 0-150 66.6-150 148.6 0 59.4 35.4 110 85.8 133.8-50.4 23.8-85.8 74.2-85.8 133.8 0 82 67.2 148.6 150 148.6 31.8 0 60.6-9.6 85.2-26.2l-1.2 11.2c0 82 67.2 148.6 150 148.6s150-66.6 150-148.6l-1.2-11.2c24 16.6 53.4 26.2 85.2 26.2 82.8 0 150-66.6 150-148.6 0-59.6-35.4-110-85.8-133.8zM512 660.6c-82.8 0-150-66.6-150-148.6s67.2-148.6 150-148.6 150 66.6 150 148.6c0 82-67.2 148.6-150 148.6z"
    ],
    "grid": 0,
    "tags": [
      "md-flower"
    ]
  },
  {
    "paths": [
      "M874.668 288h-362.656l-85.336-96h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334zM896 746.666c0 11.564-9.77 21.334-21.332 21.334h-725.336c-11.564 0-21.332-9.77-21.332-21.334v-394.666h746.668c11.562 0 21.332 9.77 21.332 21.334v373.332z"
    ],
    "grid": 0,
    "tags": [
      "md-folder-open"
    ]
  },
  {
    "paths": [
      "M426.676 192h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334h-362.656l-85.336-96z"
    ],
    "grid": 0,
    "tags": [
      "md-folder"
    ]
  },
  {
    "paths": [
      "M512 96c-229.4 0-416 186.6-416 416s186.6 416 416 416 416-186.6 416-416-186.6-416-416-416zM254 476.4l78.4 35.8 34.2 133.8-31.2 58.6-114.4-1.4c-29.8-45.2-48.6-97-55-150.6l88-76.2zM688.6 704.6l-31.2-58.6 34.2-134 78.2-35.6 88 76.2c-6.2 53.6-25.2 105.4-55 150.6l-114.2 1.4zM753.4 412.2l-87.2 39.2-122.2-103.2v-94.4l95.8-65.2c59.6 23.8 112.8 64.6 151.2 115.6l-37.6 108zM382.6 188.8l95.4 65v94.4l-122 103-86-39.2-37.4-107.2c38.6-52.2 90.2-92 150-116zM436.8 852c-1.4-0.4-2.6-0.6-4-1l-41-110.2 29.4-58.8h181.6l30 60.6-39.6 107.8c-2 0.4-4 1-6 1.4-23 4.6-54 7.6-80.8 8.2-23.4-0.2-46.8-3-69.6-8z"
    ],
    "grid": 0,
    "tags": [
      "md-football"
    ]
  },
  {
    "paths": [
      "M416 800h192v-95.988h-192v95.988zM64 224v95.988h896v-95.988h-896zM224 561.566h576v-99.11h-576v99.11z"
    ],
    "grid": 0,
    "tags": [
      "md-funnel"
    ]
  },
  {
    "paths": [
      "M312 430h-48v62h-62v48h62v60h48v-60h60v-48h-60z",
      "M738.6 288h-453.2c-122.4 0-221.4 93-221.4 222.8 0 130 99 225.2 221.4 225.2h453c122.4 0 221.4-95.2 221.4-225.2 0.2-129.8-98.8-222.8-221.2-222.8zM288.4 633c-66.2 0-120-54.2-120-121s53.8-121 120-121 120 54.2 120 121c0 66.8-53.6 121-120 121zM694.6 538.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM769.6 613.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.6 38 0 52.4zM769.6 463.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.6 38 0 52.4zM844.8 538.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4z"
    ],
    "grid": 0,
    "tags": [
      "md-game-controller-a"
    ]
  },
  {
    "paths": [
      "M326 320h-48v62h-62v48h62v60h48v-60h60v-48h-60z",
      "M934.2 408.2c-10.4-126.2-95.4-216.2-214.2-216.2h-416c-118.8 0-203.6 90-214 216.2 0 0-26 269.4-26 327.8s43 96 96 96c26.2 0 50-10.6 68-27.8v0h-0.6l156.6-162.2h256l156.6 162-0.6 0.2c18 17.2 41.8 27.8 68 27.8 53 0 96-40.6 96-96s-25.8-327.8-25.8-327.8zM302 524c-66.2 0-120-54.2-120-121s53.8-121 120-121 120 54.2 120 121c0 66.8-53.8 121-120 121zM676.2 429.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM751.2 504.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM751.2 354.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM826.2 429.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4z"
    ],
    "grid": 0,
    "tags": [
      "md-game-controller-b"
    ]
  },
  {
    "paths": [
      "M832 320c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v17.2c0 39.8-15.6 67.4-50.6 89.8-30.8 19.6-76.2 34.2-135 43-28 4.2-51.4 12-70.4 21.4v-299.4c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-33.2-12.6-63.4-33.4-86.2 3.8-9.8 19.4-32.6 58.8-38.6 77.6-11.6 137.8-31.8 184.6-61.6 72-45.6 110-114 110-197.6v-17.2c38.2-22.2 64-63.4 64-110.8zM320 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80zM320 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM704 400c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-git-branch"
    ]
  },
  {
    "paths": [
      "M960 448h-199.6c-28.4-110.4-128.4-192-247.4-192s-219 81.6-247.4 192h-201.6v128h201.6c28.4 110.4 128.4 192 247.4 192s219-81.6 247.4-192h199.6v-128zM513 672c-88 0-159.6-71.8-159.6-160s71.6-160 159.6-160c88 0 159.6 71.8 159.6 160s-71.6 160-159.6 160z"
    ],
    "grid": 0,
    "tags": [
      "md-git-commit"
    ]
  },
  {
    "paths": [
      "M384 764h-44c-49.2 0-58-7.2-67.6-19.2-11-13.8-16.4-38.2-16.4-108.4v-333.6c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v333.6c0 92.8 7.4 141.6 44.2 188 39.8 50.2 90 71.6 167.8 71.6h44v128l192-192-192-192v124zM192 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z",
      "M896 721.2v-339.6c0-92.8-7.4-141.6-44.2-188-39.8-50.2-90-69.6-167.8-69.6h-44v-124l-192 192 192 192v-128h44c49.2 0 58 5.2 67.6 17.2 11 13.8 16.4 38.2 16.4 108.4v339.6c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8zM832 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-git-compare"
    ]
  },
  {
    "paths": [
      "M768 448c-47.4 0-88.8 25.8-110.8 64-36.6-1-104.8-8.2-151-36.2-64.6-38.8-129.2-106.2-174-181 31.4-23.4 52-60.6 52-102.8 0-70.6-57.4-128-128-128s-128.2 57.4-128.2 128c0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8v-232.8c37.4 38.8 78.2 72 120 97.2 77.6 46.8 174 53.8 217.2 54.6 22.2 38.2 63.4 63.8 110.8 63.8 70.6 0 128-57.4 128-128s-57.4-128-128-128zM176 192c0-44.2 35.8-80 80-80s80 35.8 80 80-35.8 80-80 80-80-35.8-80-80zM336 832c0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80 80 35.8 80 80zM768 656c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-git-merge"
    ]
  },
  {
    "paths": [
      "M896 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.2 25.8 88.6 64 110.8v105.6l-192 96-192-96v-105.6c38.2-22.2 64-63.6 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.2 25.8 88.6 64 110.8v184.8l256 128v105.6c-38.2 22.2-64 63.6-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.2-25.8-88.6-64-110.8v-105.6l256-128v-184.8c38.2-22.2 64-63.6 64-110.8zM256 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80zM512 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM768 272c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-git-network"
    ]
  },
  {
    "paths": [
      "M832 753.2v-339.6c0-92.8-7.4-141.6-44.2-188-39.8-50.2-90-71.6-167.8-71.6h-44v-122l-192 192 192 192v-130h44c49.2 0 58 7.2 67.6 19.2 11 13.8 16.4 38.2 16.4 108.4v339.6c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8zM768 944c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z",
      "M256 96c-70.6 0-128 57.4-128 128 0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8v-418.4c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128zM256 944c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM256 304c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-git-pull-request"
    ]
  },
  {
    "paths": [
      "M960 352h-896v96h22l10 43c32 135 81 181 192 181s192-34.8 192-181v-43c0 0 3-32 32-32s32 32 32 32v43.6c0 146 84.2 180.4 194 180.4s158-50 190-180.4l10-43.6h22v-96z"
    ],
    "grid": 0,
    "tags": [
      "md-glasses"
    ]
  },
  {
    "paths": [
      "M512 96c-229.752 0-416 186.25-416 416s186.248 416 416 416c229.75 0 416-186.25 416-416s-186.25-416-416-416zM468.902 865.998c-78.928-9.452-151.956-44.784-209.038-101.864-67.348-67.348-104.436-156.89-104.436-252.134 0-85.74 30.072-166.848 85.202-231.318 1.42 17.034 4.926 35.296 4.028 48.35-3.28 47.59-7.976 77.374 19.88 117.524 10.852 15.638 13.518 38.056 18.8 56.156 5.166 17.708 25.804 26.996 40.038 37.906 28.718 22.018 56.192 47.61 86.644 66.988 20.098 12.79 32.652 19.152 26.766 43.678-4.734 19.724-6.056 31.874-16.26 49.446-3.114 5.362 11.754 39.836 16.702 44.784 14.996 14.994 29.876 28.75 46.222 42.25 25.342 20.938-2.462 48.144-14.548 78.234zM764.134 764.134c-51.266 51.266-115.398 84.972-185.112 98.162 9.88-24.432 27.472-46.14 43.79-58.724 14.194-10.952 31.972-32.018 39.386-48.704 7.408-16.664 17.222-31.11 27.154-46.434 14.13-21.798-34.838-54.672-50.706-61.562-35.708-15.502-62.588-36.42-94.322-58.75-22.61-15.908-68.514 8.308-94.040-2.834-34.962-15.266-63.766-41.792-94.156-64.678-31.36-23.618-29.844-51.152-29.844-85.994 24.564 0.906 59.508-6.798 75.816 12.956 5.146 6.234 22.84 34.084 34.684 24.188 9.676-8.086-7.17-40.498-10.424-48.118-10.010-23.43 22.808-32.568 39.606-48.456 21.92-20.728 68.94-53.236 65.224-68.094s-47.048-56.954-72.498-50.386c-3.814 0.984-37.394 36.194-43.882 41.718 0.172-11.492 0.344-22.982 0.52-34.474 0.11-7.256-13.536-14.704-12.902-19.384 1.6-11.828 34.524-33.294 42.714-42.714-5.738-3.586-25.318-20.404-31.244-17.936-14.348 5.98-30.552 10.1-44.9 16.078 0-4.976-0.604-9.65-1.324-14.266 28.752-12.73 59.174-21.582 90.62-26.304l28.168 11.32 19.888 23.602 19.848 20.466 17.35 5.59 27.558-25.99-7.106-18.554v-16.678c54.5 7.916 105.968 28.248 151.044 59.6-8.064 0.722-16.926 1.908-26.924 3.18-4.13-2.44-9.428-3.548-13.93-5.246 13.062 28.084 26.686 55.78 40.528 83.492 14.786 29.602 47.586 61.354 53.346 92.602 6.788 36.832 2.078 70.288 5.792 113.622 3.576 41.73 47.048 89.144 47.048 89.144s20.074 6.838 36.768 4.456c-15.562 61.566-47.466 118.028-93.538 164.104z"
    ],
    "grid": 0,
    "tags": [
      "md-globe"
    ]
  },
  {
    "paths": [
      "M819.2 128h-614.4c-42.2 0-76.8 34.6-76.8 76.8v614.4c0 42.2 34.6 76.8 76.8 76.8h614.4c42.2 0 76.8-34.6 76.8-76.8v-614.4c0-42.2-34.6-76.8-76.8-76.8zM358.4 819.2h-153.6v-153.6h153.6v153.6zM358.4 588.8h-153.6v-153.6h153.6v153.6zM358.4 358.4h-153.6v-153.6h153.6v153.6zM588.8 819.2h-153.6v-153.6h153.6v153.6zM588.8 588.8h-153.6v-153.6h153.6v153.6zM588.8 358.4h-153.6v-153.6h153.6v153.6zM819.2 819.2h-153.6v-153.6h153.6v153.6zM819.2 588.8h-153.6v-153.6h153.6v153.6zM819.2 358.4h-153.6v-153.6h153.6v153.6z"
    ],
    "grid": 0,
    "tags": [
      "md-grid"
    ]
  },
  {
    "paths": [
      "M948.2 796.4l-488.6-460.8c0 0 17.6-115.4 52.4-143.6 35-28.4 96-64 96-64v-64c-64 0-117.6 16.6-193.8 54.6-76 37.8-133.6 95.6-148.8 110.8s-36.2 39-49.4 57.8-10.6 40.2-10.6 40.2l-39.4 34-8-8c-4.6-4.6-12.4-4.6-17 0l-73.6 73.6c-4.6 4.6-4.6 12.4 0 17l118.8 118.8c4.6 4.6 12.4 4.6 17 0l73.6-73.6c4.6-4.6 4.6-12.4 0-17l-20.6-20.6 29.2-28.6c13.6-7.4 50.8-17.8 78.2-10.2l429.8 534.6c16.2 16.4 40.6 16.4 57 0l93.6-94.2c20.6-16 20.6-44.6 4.2-56.8z"
    ],
    "grid": 0,
    "tags": [
      "md-hammer"
    ]
  },
  {
    "paths": [
      "M901.358 547c-29.17-29.154-72.108-31.78-101.278-2.624l-83.374 83.328c-21.704 21.672-47.86 21.718-63.128 3.704-10.114-11.936-6.122-48.748-3.288-72.098l41.814-343.698c3.734-30.706-18.14-60.37-48.86-64.102-30.716-3.734-58.644 19.878-62.382 50.578l-46.122 269.954c-2.41 6.716-7.58 7.876-8.162-1.164l-15.698-350.878c0-30.93-25.084-56-56.028-56-30.946 0-56.030 25.070-56.030 56l-1.104 353.504c0.292 4.080-3.208 5.248-3.84 0.588l-49.846-275.938c-5.5-30.438-34.646-52.406-65.096-46.906-30.454 5.496-50.678 36.374-45.182 66.806l44.386 322.91c0.046 5.744-1.882 9.026-4.616 1.662l-66.218-177.034c-10.36-29.144-42.392-46.13-71.552-35.778-29.158 10.354-44.402 44.122-34.046 73.262l116.084 379.25c0.606 2.092 1.248 4.17 1.906 6.236l0.242 0.78c0.022 0.062 0.050 0.116 0.070 0.176 32.148 98.948 125.13 170.482 234.844 170.482 70.232 0 143.182-24.756 198.714-67.344 0.002 0 0.006-0.004 0.006-0.004 59.98-36.102 252.142-242.694 252.142-242.694 29.174-29.154 24.816-73.798-4.358-102.958z"
    ],
    "grid": 0,
    "tags": [
      "md-hand"
    ]
  },
  {
    "paths": [
      "M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8zM657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4zM366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4zM512 740.8c97.766 0 178.872-60.328 212.162-145.602h-424.324c33.29 85.274 114.396 145.602 212.162 145.602z"
    ],
    "grid": 0,
    "tags": [
      "md-happy"
    ]
  },
  {
    "paths": [
      "M512 96c-212 0-384 176.4-384 394.2v306.6c0 72.6 57.2 131.4 128 131.4h128v-352.2h-170.6v-85.8c0-169.4 133.6-306.6 298.6-306.6s298.6 137 298.6 306.6v85.8h-170.6v352h128c70.8 0 128-58.6 128-131.4v-306.4c0-217.8-172-394.2-384-394.2z"
    ],
    "grid": 0,
    "tags": [
      "md-headset"
    ]
  },
  {
    "paths": [
      "M699.2 128c-72.8 0-141.436 33.484-187.2 87.894-45.766-54.41-114.4-87.894-187.2-87.894-128.964 0-228.8 100.442-228.8 230.19 0 159.032 141.436 286.696 355.672 483.388l60.328 54.422 60.328-54.422c214.234-196.694 355.672-324.358 355.672-483.388 0-129.748-99.836-230.19-228.8-230.19zM537.672 786.514l-8.438 7.746-17.234 15.546-17.232-15.544-8.428-7.738c-100.836-92.564-187.922-172.508-245.492-243.988-55.914-69.426-80.848-126.28-80.848-184.346 0-45.73 16.844-87.862 47.43-118.632 30.484-30.668 72.166-47.558 117.37-47.558 52.268 0 103.94 24.334 138.22 65.090l48.98 58.232 48.978-58.232c34.282-40.756 85.952-65.090 138.222-65.090 45.206 0 86.886 16.89 117.372 47.556 30.584 30.772 47.428 72.902 47.428 118.634 0 58.066-24.934 114.918-80.844 184.342-57.568 71.48-144.65 151.418-245.484 243.982z"
    ],
    "grid": 0,
    "tags": [
      "md-heart-outline"
    ]
  },
  {
    "paths": [
      "M512 896l-60.328-54.422c-214.236-196.694-355.672-324.358-355.672-483.388 0-129.748 99.836-230.19 228.8-230.19 72.798 0 141.434 33.484 187.2 87.894 45.764-54.41 114.398-87.894 187.2-87.894 128.964 0 228.8 100.442 228.8 230.19 0 159.032-141.438 286.696-355.672 483.388l-60.328 54.422z"
    ],
    "grid": 0,
    "tags": [
      "md-heart"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM634 808l-24.4-79.2c26-11.6 49.8-28 70.6-48.8s37.2-44.6 48.8-70.6l79 24.2c-15.8 38.6-39.4 74-69.8 104.4-30.2 30.6-65.6 54.2-104.2 70zM390 216l24.4 79.2c-26 11.6-49.8 28-70.6 48.8s-37.2 44.6-48.8 70.6l-79-24.2c15.8-38.6 39.4-74 69.8-104.4 30.2-30.6 65.6-54.2 104.2-70zM512 384c70.6 0 128 57.4 128 128s-57.4 128-128 128-128-57.4-128-128c0-70.6 57.4-128 128-128zM738.2 285.8c30.4 30.4 53.8 65.8 69.8 104.2l-79 24.4c-11.8-26-28-49.8-48.8-70.6s-44.6-37.2-70.6-48.8l24.2-79c38.6 15.8 74 39.4 104.4 69.8zM285.8 738.2c-30.4-30.2-54-65.6-69.8-104.2l79-24.4c11.8 26 28 49.8 48.8 70.6s44.6 37.2 70.6 48.8l-24.2 79c-38.6-15.8-74-39.4-104.4-69.8z"
    ],
    "grid": 0,
    "tags": [
      "md-help-buoy"
    ]
  },
  {
    "paths": [
      "M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416-186.4-416-416-416zM554 762h-84v-84h84v84zM553.6 636h-83.2c0-134 124.8-124.4 124.8-207.6 0-45.8-37.4-83.4-83.2-83.4s-83.2 39-83.2 83h-83.2c0-92 74.4-166 166.4-166s166.4 74.2 166.4 166.2c0 104-124.8 115.8-124.8 207.8z"
    ],
    "grid": 0,
    "tags": [
      "md-help-circle"
    ]
  },
  {
    "paths": [
      "M578 896h-132v-130h132v130zM576 700h-128c0-202 192-190.2 192-318 0-70.4-57.6-126.8-128-126.8s-128 60.8-128 128.8h-128c0-142 114.6-256 256-256s256 112.8 256 254c0 159.8-192 178-192 318z"
    ],
    "grid": 0,
    "tags": [
      "md-help"
    ]
  },
  {
    "paths": [
      "M416 896v-256h192v256h195.2v-384h124.8l-416-384-416 384h124.8v384z"
    ],
    "grid": 0,
    "tags": [
      "md-home"
    ]
  },
  {
    "paths": [
      "M256.2 512l256 448 256-448z",
      "M784 322c6-18 9.4-45.4 9.4-65.8 0-106.2-86-192.2-192.2-192.2-62.8 0-118.4 30-153.6 76.6 0 0-18.2 28-21.6 58l-6.8-2c-4.6-18-7.4-40 3.2-63-14.8-5-18.8-5.6-35.2-5.6-83.4 0-151.2 67.6-151.2 151.2 0 12.6 1.6 31 4.6 42.8-27.8 7-48.6 32.2-48.6 62v0c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v0c0-29.6-20.4-54.8-48-62z"
    ],
    "grid": 0,
    "tags": [
      "md-ice-cream"
    ]
  },
  {
    "paths": [
      "M896 810.666v-597.332c0-46.938-38.396-85.334-85.334-85.334h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334zM362.666 576l106.668 128 149.332-192 192 256h-597.332l149.332-192z"
    ],
    "grid": 0,
    "tags": [
      "md-image"
    ]
  },
  {
    "paths": [
      "M915.2 280.4l-165-8-9.6-107.6c-2-22.6-22.2-38.4-45.8-36.6l-591.8 48.6c-23.6 2-40.6 21-38.8 43.4l42.4 471.6c2 22.6 22.4 38.4 45.8 36.6l30-2.4-4.8 91.6c-1.2 25.2 18.4 45.6 44.8 47l660.2 31.4c26.4 1.2 48.2-17.2 49.6-42.4l27.8-526.6c1.2-25-18.6-45.4-44.8-46.6zM205.4 291l-14.2 269.6-35 49.4-32.2-356c0-0.4 0-0.6 0-1s0-0.6 0-1c2-10 8.8-18 19.2-18.8l522-42.8c10.4-0.8 19.4 6 21 15.8 0 0.4 0.6 0.4 0.6 0.8 0 0.2 0.6 0.4 0.6 0.8l5.4 61.6-438-21c-26.4-0.8-48.2 17.6-49.4 42.6zM873.4 764.8l-169.6-199-74.8 68.6-138.4-161.6-245.4 261.4 20.8-398.2c0 0 0-0.6 0-0.8 2-10.8 12.4-18.6 23.8-18l582.4 28c11.6 0.6 20.6 9.4 20.8 20.4 0 0.4 0.6 0.6 0.6 1l-20.2 398.2z",
      "M768 512c35.2 0 64-28.8 64-64s-28.6-64-64-64c-35.2 0-64 28.6-64 64s28.6 64 64 64z"
    ],
    "grid": 0,
    "tags": [
      "md-images"
    ]
  },
  {
    "paths": [
      "M869.4 376c-37.6-36-87.6-56-141-56-53.2 0-103.2 19.8-140.8 55.8l-35.2 31.8 66.2 64.2 34.2-31c20.2-19.2 47-30 75.4-30s55.2 10.6 75.4 29.8c20 19.2 30.8 44.6 30.8 71.6s-11 52.2-30.8 71.2c-20.2 19.2-47 30-75.4 30s-55.2-10.6-75.4-29.8l-216.4-207.6c-37.8-36-87.8-56-140.8-56-53.4 0-103.4 19.8-141 56-37.8 36.2-58.6 84.4-58.6 136 0 51.4 20.8 99.8 58.6 136 37.6 36 87.6 56 141 56s103.4-19.8 140.8-56l75.6-72.2 75.4 72.2c37.8 36 87.8 56 140.8 56 53.4 0 103.4-19.8 140.8-55.8 38-36.2 58.8-84.4 58.8-136 0.2-51.6-20.6-100-58.4-136.2zM371 583.4c-20.2 19.2-47 30-75.4 30s-55.2-10.6-75.4-29.8c-20-19.2-30.8-44.6-30.8-71.6s11-52.2 30.8-71.2c20.2-19.2 47-30 75.4-30s55.2 10.6 75.4 29.8l74.8 71.6-74.8 71.2z"
    ],
    "grid": 0,
    "tags": [
      "md-infinite"
    ]
  },
  {
    "paths": [
      "M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416c0-229.6-186.4-416-416-416zM554 720h-84v-250h84v250zM554 388h-84v-84h84v84z"
    ],
    "grid": 0,
    "tags": [
      "md-information-circle"
    ]
  },
  {
    "paths": [
      "M464 470h96v274h-96v-274z",
      "M464 280h96v96h-96v-96z"
    ],
    "grid": 0,
    "tags": [
      "md-information"
    ]
  },
  {
    "paths": [
      "M512 328.6c-101.2 0-183.4 82.2-183.4 183.4s82.2 183.4 183.4 183.4 183.4-82.2 183.4-183.4c0-101.2-82.2-183.4-183.4-183.4z",
      "M875.6 249.2c0 48.38-39.22 87.6-87.6 87.6s-87.6-39.22-87.6-87.6c0-48.38 39.22-87.6 87.6-87.6s87.6 39.22 87.6 87.6z",
      "M890.6 339.6c-14.8 16.8-33.8 30-55.2 38 17.2 41.4 26.8 86.8 26.8 134.4 0 193.2-157.2 350.4-350.4 350.4s-350.4-157.2-350.4-350.4c0-193.2 157.2-350.4 350.4-350.4 53.8 0 104.6 12.2 150.2 33.8 9-21 23-39.2 40.6-53.2-57-29.4-121.8-46.2-190.6-46.2-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-61.4-13.4-119.8-37.4-172.4z"
    ],
    "grid": 0,
    "tags": [
      "md-ionic"
    ]
  },
  {
    "paths": [
      "M957.4 539.6c-9.4-66.8-37.4-123.6-71.4-119.6 13.6 30.6 24.2 73.6 20.6 150.6-3-54-13.2-104.8-36-150.6-67.4-135-211.4-224.4-372.6-215.4-180.4 10-325.4 139.4-361.2 306.6l-24 3.4c-36.2 5-56.6 72.8-45.6 151.4s49.4 138.4 85.6 133.4l33.2-4.6c72.8 117.6 206.8 193 355.6 184.8 179.2-9.8 323.4-137.8 360.4-303.4l15.4-1c31.8-5.2 49.8-65.6 40-135.6zM163.2 528.8c14.2 11.2 53 37 62.8 115.2s-17.8 117.8-30 134.2c12.6-31 13-78 6-129.4-6.8-50-19-93.4-38.8-120zM549.4 771.4c-17.8 1-33.2-12.6-34.2-30.4s12.6-32.8 30.6-33.8c17.8-1 33.2 12.6 34.2 30.4s-12.8 33-30.6 33.8zM719.4 761.8c-17.8 1-33.2-12.6-34.2-30.4s12.6-32.8 30.6-33.8c17.8-1 33.2 12.6 34.2 30.4 1 17.6-12.8 32.8-30.6 33.8z",
      "M321.2 123.4c0 0 0.2 0 0 0 0.2 0.2 0.2 0.4 0.2 0.4s0 0 0 0c0.2 0.4 0.4 0.8 0.6 1 0 0 0 0.2 0 0.2 0.8 2.2 2.4 4 4.8 5.8 4.2 3 10.4 5 18 6.2 7.2 1.2 15.8 1.4 25 1 2 0 4-0.2 6.2-0.4-0.8-1-1.8-1.8-2.6-2.8-1 0-1.8 0-2.8 0-9 0.2-17.4-0.4-24.4-1.8-7.4-1.4-13.6-3.8-17.6-7.2-1.2-1-2-2-2.8-3-0.4-1.4-0.4-3 0-4.8 1-4.8 5-10 11.4-15.6 5.8-4.8 13.4-9.8 22.8-14.6 1.8-1 3.6-1.8 5.6-2.8 0.4-0.2 0.6-0.2 1-0.4-1.6 7-2 14.4-0.6 21.8 4.8 25 26.4 42.4 51 43.2l10.4 55 22.6-4.2-10.4-55c22.6-9.6 36.4-33.6 31.6-58.6-1.4-7.4-4.2-14-8.2-19.8-11.2-1.6-32.8-1.6-61.4 4.4 2.2-0.6 4.4-1.4 6.8-2 16-4.4 31.4-7.4 45.2-8.8 1.2-0.2 2.6-0.2 3.8-0.4 2.4-0.2 5-0.4 7.4-0.6 0.4 0 0.8 0 1.2 0 8.6-0.4 16.2-0.2 22.6 0.8 5 0.6 9.4 1.6 12.8 3-1.2 2-2 4.2-2 6.6 0 5.8 3.8 10.6 9 12.2 0 0 0 0 0 0-1.2 2-2.6 4-4.4 6s-3.8 3.8-6 5.8c-2.2 1.8-4.8 3.8-7.4 5.6l-13.6 7.8c-0.2 1-0.4 2.2-0.6 3.2 0.2 0 0.4-0.2 0.6-0.2l17.6-9.8c2.6-1.6 5-3.4 7.2-5 2.4-2 4.6-3.8 6.6-5.8s3.6-4 5-5.8c0.2-0.4 0.4-0.8 0.6-1.2 6.4-0.8 11.2-6 11.2-12.6 0-7-5.8-12.8-12.8-12.8-2 0-4 0.6-5.8 1.4-4.2-2.6-10-4.4-17.2-5.8-9-1.6-20-2-32.6-1.4-1.4 0-3 0.2-4.4 0.4s-2.8 0.4-4.2 0.4c-11.2-7.2-25-10.4-39.2-7.8-16.6 3-30 13.6-37.2 27.2-2.8 1.2-5.4 2.2-8 3.4-1.4 0.6-2.8 1.2-4.2 2-12.4 6.2-22.4 12.6-29.2 19-6.6 6-10.4 12-11.2 17.4-0.4 3 0 5.8 1.6 8.2-0 0.8 0.2 1.2 0.4 1.6z"
    ],
    "grid": 0,
    "tags": [
      "md-ionitron"
    ]
  },
  {
    "paths": [
      "M960 64c0 0-46.8-1.4-118.6 54.2-33.4 25.8-351.6 255.4-351.6 255.4l-337.6-8.4-88.2 78.8 219.6 110.4-17.2 21.6-175.8 0.2-14.4 81 126.2 97.4-53.2 119.6 120-52.8 97.4 126.2 81-14.4 0.2-175.6 21.8-17 110.6 219.4 78.6-88.2-8.4-337.4c0 0 229.8-318 255.6-351.2 55.4-72.2 54-119.2 54-119.2z"
    ],
    "grid": 0,
    "tags": [
      "md-jet"
    ]
  },
  {
    "paths": [
      "M498.4 448c-28.4-80.4-110.2-144-200.4-144-114.4 0-202 93.6-202 208s91.6 208 206 208c90.2 0 168.2-63.6 196.4-144h205.6v128h138.2v-128h85.8v-128h-429.6zM303.2 581c-38 0-69-31-69-69s31-69 69-69 69 31 69 69-31 69-69 69z"
    ],
    "grid": 0,
    "tags": [
      "md-key"
    ]
  },
  {
    "paths": [
      "M512 797c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.6-36.4-81.4-81-81.4zM273 64c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM273 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM273 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 227c44.6 0 81-36.6 81-81.4s-36.4-81.6-81-81.6-81 36.6-81 81.4 36.4 81.6 81 81.6zM512 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM512 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM512 64c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4z"
    ],
    "grid": 0,
    "tags": [
      "md-keypad"
    ]
  },
  {
    "paths": [
      "M874.668 832c46.938 0 85.332-38.394 85.332-85.332v-533.332c0-46.938-38.394-85.336-85.332-85.336h-725.336c-46.938 0-85.332 38.398-85.332 85.336v533.332c0 46.938 38.394 85.332 85.332 85.332h-149.332c0 46.938 128 64 192 64h640c64 0 192-17.062 192-64h-149.332zM149.332 213.336h725.336v543.996h-725.336v-543.996zM512 869.332c-23.458 0-42.666-19.208-42.666-42.668 0-23.458 19.208-42.664 42.666-42.664s42.666 19.208 42.666 42.664c0 23.46-19.208 42.668-42.666 42.668z"
    ],
    "grid": 0,
    "tags": [
      "md-laptop"
    ]
  },
  {
    "paths": [
      "M832 575.2c0-333.4-320-511.2-320-511.2s-320 177.8-320 511.2c0 237.6 162.6 281 256 286.4v98.4h128v-98.6c93.4-5.2 256-48.6 256-286.2z"
    ],
    "grid": 0,
    "tags": [
      "md-leaf"
    ]
  },
  {
    "paths": [
      "M149.2 512c0-76.6 62.2-138.8 138.8-138.8h176v-85.2h-176c-123.6 0-224 100.4-224 224s100.4 224 224 224h176v-85.2h-176c-76.6 0-138.8-62.2-138.8-138.8zM320 556h384v-88h-384v88zM736 288h-176v85.2h176c76.6 0 138.8 62.2 138.8 138.8s-62.2 138.8-138.8 138.8h-176v85.2h176c123.6 0 224-100.4 224-224s-100.4-224-224-224z"
    ],
    "grid": 0,
    "tags": [
      "md-link"
    ]
  },
  {
    "paths": [
      "M816 128h-608c-44.182 0-80 35.816-80 80v608c0 44.184 35.818 80 80 80h608c44.184 0 80-35.816 80-80v-608c0-44.184-35.816-80-80-80zM608 736h-320v-96h320v96zM736 560h-448v-96h448v96zM736 384h-448v-96h448v96z"
    ],
    "grid": 0,
    "tags": [
      "md-list-box"
    ]
  },
  {
    "paths": [
      "M160 560h512v96h-512v-96z",
      "M160 368h640v96h-640v-96z",
      "M160 176h704v96h-704v-96z",
      "M160 752h576v96h-576v-96z"
    ],
    "grid": 0,
    "tags": [
      "md-list"
    ]
  },
  {
    "paths": [
      "M512 352c-88.008 0-160.002 72-160.002 160 0 88.008 71.994 160 160.002 160 88.010 0 159.998-71.992 159.998-160 0-88-71.988-160-159.998-160zM893.876 469.334c-19.21-177.062-162.148-320-339.21-339.198v-66.136h-85.332v66.134c-177.062 19.198-320 162.136-339.208 339.198h-66.126v85.334h66.124c19.208 177.062 162.144 320 339.208 339.208v66.126h85.332v-66.124c177.062-19.208 320-162.146 339.21-339.208h66.126v-85.334h-66.124zM512 810.666c-164.274 0-298.668-134.396-298.668-298.666 0-164.272 134.394-298.666 298.668-298.666 164.27 0 298.664 134.396 298.664 298.666s-134.394 298.666-298.664 298.666z"
    ],
    "grid": 0,
    "tags": [
      "md-locate"
    ]
  },
  {
    "paths": [
      "M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200v80h-40c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80zM636.004 372h-248.008v-80c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004v80z"
    ],
    "grid": 0,
    "tags": [
      "md-lock"
    ]
  },
  {
    "paths": [
      "M512 96c-85.8 0-168.4 26-238.4 75-68.4 48-120.4 114.4-150.2 192.2l-7.4 20.8h91.4l3.8-10c16.4-35.6 38.8-67.8 67-96 62.4-62.4 145.4-96.8 233.8-96.8s171.4 34.4 233.8 96.8c62.4 62.4 96.8 145.4 96.8 233.8 0 88.2-34.4 171.4-96.8 233.8s-145.4 96.8-233.8 96.8c-88.2 0-171.2-34.4-233.8-96.8-28-28-50.6-60.2-67-95.8l-3.8-10h-91.4l7.2 20.8c29.8 77.8 81.8 144.2 150.2 192.2 70.2 49.4 152.6 75.2 238.6 75.2 229.4 0 416-186.6 416-416s-186.6-416-416-416z",
      "M96 554.8h379.4l-87.2 89.4 59.8 59.8 192-192-192-192-62 59.8 89.4 89.4h-379.4v85.6z"
    ],
    "grid": 0,
    "tags": [
      "md-log-in"
    ]
  },
  {
    "paths": [
      "M384 554.8h379.4l-87.2 89.4 59.8 59.8 192-192-192-192-62 59.8 89.4 89.4h-379.4v85.6z",
      "M511.4 842.6c-88.2 0-171-34.4-233.4-96.8s-96.6-145.4-96.6-233.8c0-88.2 34.4-171.4 96.6-233.8 62.4-62.4 145.2-96.8 233.4-96.8 88 0 170.6 34.2 233 96.4l60.6-60.6c-17-16.8-35.6-32.4-55.4-46.4-70.2-48.8-152.4-74.8-238.2-74.8-229 0-415.4 186.6-415.4 416s186.4 416 415.4 416c85.8 0 168-26 238-75 20-14 38.4-29.4 55.4-46.4l-60.4-60.4c-62.2 62.2-145 96.4-233 96.4z",
      "M896.008 513.694l-1.697-1.697 1.697-1.697 1.697 1.697-1.697 1.697z"
    ],
    "grid": 0,
    "tags": [
      "md-log-out"
    ]
  },
  {
    "paths": [
      "M767.2 197.6c-63-66-151.2-101.2-255.2-101.6-103.8 0.4-192 35.6-255 101.6-63.4 66.4-97 160-97 270.4 0 87 3.6 138.4 25.8 231.6 0 0 45.4 151.4 71 208.2 7 15.6 14.8 23.6 31 18.6 12.8-4 93.6-35.8 109.4-43.2 15.8-7.2 23.2-17.2 17.8-30.4-7.6-18.4-67.8-191.2-67.8-191.2-16.8-72.6-23.2-107.8-23.2-188.6 0-56.4 19.6-108.2 55.4-145.8 35-36.6 82-56.8 132.6-56.8s97.6 20.2 132.6 56.8c35.8 37.6 55.4 89.2 55.4 145.6 0 80-6.4 128-23.4 188.8s-64.4 180.2-67.8 191.2c-3.4 11.2 4.2 25 17.8 30.4s98.6 39.2 109.4 43.2c10.8 4 21.2 1.2 29-15.4 8-16.6 49.2-122.8 73-211.4 24-88.6 26-144.6 26-231.6 0-110.4-33.4-203.8-96.8-270.4zM346.2 839.4l-45.8 19.2c-13.8-32.6-34.4-86.4-51.8-154.4l44-13 53.6 148.2zM723.4 858.6l-45.8-19.2c14.4-33.2 38.2-90.2 53.2-148.2l44 13c-16.8 67.8-37.4 121.8-51.4 154.4z"
    ],
    "grid": 0,
    "tags": [
      "md-magnet"
    ]
  },
  {
    "paths": [
      "M960 403.334c0-29.866-14.938-57.606-40.542-72.532l-407.458-202.802-407.458 202.802c-23.48 14.926-40.542 42.666-40.542 72.532v407.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-407.332zM512 608l-342.738-224 342.738-170.666 342.738 170.666-342.738 224z"
    ],
    "grid": 0,
    "tags": [
      "md-mail-open"
    ]
  },
  {
    "paths": [
      "M874.664 160h-725.328c-46.938 0-85.336 38.396-85.336 85.334v533.332c0 46.938 38.398 85.334 85.336 85.334h725.328c46.938 0 85.336-38.396 85.336-85.334v-533.332c0-46.938-38.398-85.334-85.336-85.334zM864 341.334l-352 234.666-352-234.666v-85.334l352 234.666 352-234.666v85.334z"
    ],
    "grid": 0,
    "tags": [
      "md-mail"
    ]
  },
  {
    "paths": [
      "M832 96h-256v96h188.2l-213.4 213.2c-47-33.4-104.6-53.2-166.8-53.2-159 0-288 129-288 288s129 288 288 288 288-129 288-288c0-62.2-19.8-119.8-53.2-166.8l213.2-213.4v188.2h96v-352h-96zM384 832c-105.8 0-192-86.2-192-192s86.2-192 192-192 192 86.2 192 192-86.2 192-192 192z"
    ],
    "grid": 0,
    "tags": [
      "md-male"
    ]
  },
  {
    "paths": [
      "M512 213.2c41.2 0.2 74.6-33.2 74.6-74.6 0-41.2-33.4-74.6-74.6-74.6s-74.6 33.4-74.6 74.6c0 41.2 33.4 74.6 74.6 74.6z",
      "M586.8 230h-149.6c-56.4 0-93.2 49.6-93.2 96.8v227.2c0 44 62 44 62 0v-210h12v571.2c0 60.8 84 58.8 86 0v-329.2h16v329.4c3.4 62.4 86 56.4 86-0.2v-571.2h10v210c0 44 64 44 64 0v-227.2c0-47-37-96.8-93.2-96.8z"
    ],
    "grid": 0,
    "tags": [
      "md-man"
    ]
  },
  {
    "paths": [
      "M874.666 128c-4.352 0-8.792 2.738-18.352 6.414s-216.314 83.19-216.314 83.19l-256-89.604-241.062 81.062c-8.544 2.146-14.938 10.666-14.938 21.332v644.272c0 12.792 8.542 21.334 21.332 21.334 3.656 0 13.010-4.66 18.174-6.638s216.494-82.968 216.494-82.968l256 89.606 241.062-81.062c8.542-2.146 14.938-10.668 14.938-21.334v-644.272c0-12.79-8.542-21.332-21.334-21.332zM640 810.666l-256-89.604v-507.73l256 89.606v507.728z"
    ],
    "grid": 0,
    "tags": [
      "md-map"
    ]
  },
  {
    "paths": [
      "M547 304.2h-451l108.2-207.8h481.4z",
      "M685.6 754.4c0 95.656-77.544 173.2-173.2 173.2s-173.2-77.544-173.2-173.2c0-95.656 77.544-173.2 173.2-173.2s173.2 77.544 173.2 173.2z",
      "M697.8 598.2l230.2-294-138.6-207.8-276.6 415.6c64.6 0 125.4 25.4 171 71 5 5 9.6 10 14 15.2z",
      "M411.6 533.2l-107-161.2h-207.8l180.2 323c10.4-42.4 32.2-81.2 64-112.8 20.8-20.6 44.6-37.2 70.6-49z"
    ],
    "grid": 0,
    "tags": [
      "md-medal"
    ]
  },
  {
    "paths": [
      "M703.8 512l216.2-124.8-96-166.4-216 124.8v-249.6h-192v249.6l-216-124.8-96 166.4 216.2 124.8-216.2 124.8 96 166.4 216-124.8v249.6h192v-249.6l216 124.8 96-166.4z"
    ],
    "grid": 0,
    "tags": [
      "md-medical"
    ]
  },
  {
    "paths": [
      "M704 288v-79.2c0-44.8-36-80.8-80.8-80.8h-222.4c-44.8 0-80.8 36-80.8 80.8v79.2h-224v527.2c0 44.8 36 80.8 80.8 80.8h670.4c44.8 0 80.8-36 80.8-80.8v-527.2h-224zM400 208h224v80h-224v-80zM672 656h-112v112h-96v-112h-112v-96h112v-112h96v112h112v96z"
    ],
    "grid": 0,
    "tags": [
      "md-medkit"
    ]
  },
  {
    "paths": [
      "M764.2 286.8l-46.2 46c29.4 29.4 47.8 70.4 47.8 115.2s-18.4 85.8-47.8 115.2l46.2 46.2c41.2-41.2 66.8-98.4 66.8-161.2s-25.6-120.2-66.8-161.4z",
      "M856.4 198l-45.4 45.4c52.2 52.2 84.6 124.8 84.6 204.6 0 79.6-32.2 152.2-84.6 204.6l45.4 45.4c63.8-64.2 103.6-152.6 103.6-250s-39.6-185.8-103.6-250z",
      "M640 368.2v-208.2h-64l-192 160h-256l-64 32v224l64 32 160 256h96l-60-256h60l192 128h64v-208.2c36.8-3.4 64-37.8 64-79.8s-27.2-76.4-64-79.8z"
    ],
    "grid": 0,
    "tags": [
      "md-megaphone"
    ]
  },
  {
    "paths": [
      "M128 768h768v-85.332h-768v85.332zM128 554.668h768v-85.334h-768v85.334zM128 256v85.33h768v-85.33h-768z"
    ],
    "grid": 0,
    "tags": [
      "md-menu"
    ]
  },
  {
    "paths": [
      "M735.902 709.308l-361.902-361.226v0.692l-221.776-221.712-48.382 48.082 270.158 269.796v57.632c0 75.58 62.242 137.428 137.82 137.428 17.22 0 33.904-3.24 49.13-9.090l64.778 64.548c-34.666 17.586-73.624 27.72-113.564 27.72-125.972 0-242.73-97.18-242.73-233.18h-77.888c0 154.002 124.454 285.404 274.454 306.028v163.974h92v-163.974c44-6.704 86.132-22.444 123.254-45.244l190.556 190.156 48.066-48-67.694-67.57-116.432-115.918 116.448 115.918-116.296-116.060z",
      "M650 502.572v-301.144c0-75.58-62.418-137.428-138-137.428s-138 61.848-138 137.428v50.488l274.218 273.936c1.34-7.582 1.782-15.358 1.782-23.28z",
      "M832.878 490h-77.882c0 40.992-10.996 79.352-29.862 112.394l55.144 55.032c33.046-48.22 52.6-105.574 52.6-167.426z",
      "M919.998 892.854l-67.794-67.486 67.71 67.57z"
    ],
    "grid": 0,
    "tags": [
      "md-mic-off"
    ]
  },
  {
    "paths": [
      "M512 640c75.424 0 137.142-61.848 137.142-137.428v-301.144c0-75.58-61.718-137.428-137.142-137.428s-137.142 61.848-137.142 137.428v301.144c0 75.58 61.718 137.428 137.142 137.428zM754.278 489.096c0 137.428-116.564 233.63-242.278 233.63s-242.278-96.204-242.278-233.63h-77.722c0 155.746 123.438 286.306 274.288 306.93v163.974h91.426v-163.974c150.848-22.904 274.286-151.184 274.286-306.93h-77.722z"
    ],
    "grid": 0,
    "tags": [
      "md-mic"
    ]
  },
  {
    "paths": [
      "M768 224v-55.2c0-58-49-104.8-109.6-104.8h-292.6c-60.8-0-109.8 46.8-109.8 104.8v55.2h304v74h-304v86h304v74h-304v86h304v74h-304v83.6c0 58 49 104.4 109.8 104.4h60.2v154h172v-154h60.4c60.6 0 109.6-46.4 109.6-104.4v-83.6h-112v-74h112v-86h-112v-74h112v-86h-112v-74h112z"
    ],
    "grid": 0,
    "tags": [
      "md-microphone"
    ]
  },
  {
    "paths": [
      "M390 250c0-52.6 10.6-102.6 29.8-148.2-182.4 44.2-317.8 208.4-317.8 404.2 0 229.6 186.4 416 416 416 195.8 0 360-135.4 404.2-317.8-45.6 19.2-95.8 29.8-148.2 29.8-212 0-384-172-384-384z"
    ],
    "grid": 0,
    "tags": [
      "md-moon"
    ]
  },
  {
    "paths": [
      "M592 272c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 752c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 512c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80z"
    ],
    "grid": 0,
    "tags": [
      "md-more"
    ]
  },
  {
    "paths": [
      "M960 512l-192-192v128h-192v-192h128l-192-192-192 192h128v192h-192v-128l-192 192 192 192v-128h192v192h-128l192 192 192-192h-128v-192h192v128z"
    ],
    "grid": 0,
    "tags": [
      "md-move"
    ]
  },
  {
    "paths": [
      "M512 128v450.2c-25.2-14.6-54.2-23.4-85.4-23.4-94.2 0-170.6 76.4-170.6 170.6s76.4 170.6 170.6 170.6 170.6-76.4 170.6-170.6v-426.8h170.8v-170.6h-256z"
    ],
    "grid": 0,
    "tags": [
      "md-musical-note"
    ]
  },
  {
    "paths": [
      "M320 128v515.2c-16.4-5.4-34.4-8.2-53.2-8.2-76.6 0-138.8 54.2-138.8 130.8s62.2 130.2 138.8 130.2c76.6 0 139.2-56.4 139.2-138.2v-357.8h404v243.2c-16.4-5.4-34.4-8.2-53.2-8.2-76.6 0-138.8 54.2-138.8 130.8s62.2 130.2 138.8 130.2c76.6 0 139.2-56.4 139.2-138.2v-629.8h-576zM810 320h-404v-106h404v106z"
    ],
    "grid": 0,
    "tags": [
      "md-musical-notes"
    ]
  },
  {
    "paths": [
      "M512 128l-320 738.124 29.876 29.876 290.124-128 290.124 128 29.876-29.876z"
    ],
    "grid": 0,
    "tags": [
      "md-navigate"
    ]
  },
  {
    "paths": [
      "M720 512h32v96h-32v-96z",
      "M224 608h259.2l-96-96h-163.2z",
      "M729 120.2c-0.8-0.4-1.4-0.8-2-1.2-21.8-12-45-21.4-68.8-29.6-3.6-1.2-7.2-2.4-10.8-3.6-42.8-13.6-88.2-21.8-135.4-21.8-247.4 0-448 200.6-448 448 0 168.6 93.2 315.2 230.8 391.6 0.8 0.4 1.4 1 2.2 1.4 21.8 12 45 21.4 68.8 29.6 3.6 1.2 7.2 2.4 10.8 3.6 42.8 13.6 88 21.8 135.4 21.8 247.4 0 448-200.6 448-448 0-168.6-93.2-315.4-231-391.8zM512 852.8c-18.6 0-36.8-1.8-54.4-4.8-19.6-3.2-38.6-8.2-57-14.6-3.8-1.2-7.6-2.4-11.2-3.8-13-5-25.8-10.6-38-17.2-107.2-57.4-180.2-170.4-180.2-300.6 0-74.4 24.8-142.8 65.4-198.8l474.4 474.4c-56.2 40.6-124.6 65.4-199 65.4zM787.6 710.8l-474.4-474.4c56-40.4 124.2-65.2 198.8-65.2 18.6 0 36.6 1.8 54.4 4.8 19.6 3.2 38.6 8.2 57 14.6 3.6 1.2 7.4 2.4 11.2 3.8 12.4 4.8 24.4 10 36 16.2 108.4 57 182.4 170.6 182.4 301.6-0.2 74.4-25 142.6-65.4 198.6z",
      "M704 512h-68l68 68z",
      "M768 512h32v96h-32v-96z",
      "M720.2 425.4c-17.6-8.2-44-11.4-91.2-11.4-2.4 0-4.8 0-7.2 0-25.4 0.2-31.8-0.2-40-12.2-5.6-8.4-2-29.6 7.4-43.8 3.2-4.8 3.6-11.2 0.8-16.4s-8.2-8.4-14-8.6c-0.2 0-18.8-0.2-36.6-7.8-21.2-9-31.2-24.2-31.2-46.2 0-51.6 43.6-55.4 45.6-55.4v-32c-24 0-77.6 22-77.6 87.4 0 35 18 62 51.4 76 8.4 3.4 16.8 5.8 24 7.2-6.6 19.6-7.2 41.8 3.4 57.4 18 26.6 40.6 26.4 66.6 26.2 2.2 0 4.6 0 7 0 52.6 0 69.2 4.6 77.8 8.6 11.4 5.2 13.6 15 13.2 31.4 0 1.4 0 0.8 0 2h32c0-0.8 0-0.8 0-2 0-14.2 0.6-45.6-31.4-60.4z",
      "M800 488c0-51.4-6-78.4-18.2-99.2-17.2-28.8-44.8-44.8-77.8-44.8h-34.8c5.8-16.6 10.8-39.6 7-61.8-6.4-37.6-38.2-60-86.2-60v32c42 0 52.2 18.2 54.8 33.4 5 29-13.6 64.2-13.8 64.6-2.8 5-2.6 11 0.2 15.8s8.2 7.8 13.8 7.8h59c21.8 0 38.8 9.8 50.2 29.2 6.2 10.6 13.8 27 13.8 82.8h32v0.2z"
    ],
    "grid": 0,
    "tags": [
      "md-no-smoking"
    ]
  },
  {
    "paths": [
      "M512 927.312c45.628 0 82.95-37.312 82.95-83.312h-165.9c-0 46 37.322 83.312 82.95 83.312z",
      "M262.166 214.344l0.106 0.148-66.092-65.938-48.172 48.212 126.084 126.306c-20.316 37.97-32.092 81.32-32.092 127.068v229.11l-82 83.312v41.438h595.486l72.364 72.66 48.158-48.602-24.208-24.058h0.632l-590.266-589.656z",
      "M782 450.14c0-127.052-90-235.354-208-262.436v-29.156c0-35.412-26.742-62.486-62-62.486-35.256 0-62 27.074-62 62.486v29.156c-30 6.876-58.096 19.002-83.5 35.326l415.5 415.68v-188.57z"
    ],
    "grid": 0,
    "tags": [
      "md-notifications-off"
    ]
  },
  {
    "paths": [
      "M514 240.942c14.166 0 47.822 8.958 47.822 8.958 91.178 20.894 155.356 104.878 155.356 199.7v255.224l34.218 34.374h-478.792l34.218-34.374v-255.224c0-94.82 64.178-178.806 155.356-199.7 0 0 36.086-8.958 47.822-8.958zM512 96c-35.204 0-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4v0zM594.822 844.8h-165.646c0 45.762 37.266 83.2 82.824 83.2s82.822-37.438 82.822-83.2v0z"
    ],
    "grid": 0,
    "tags": [
      "md-notifications-outline"
    ]
  },
  {
    "paths": [
      "M512 928c45.558 0 82.822-37.438 82.822-83.2h-165.646c-0 45.762 37.266 83.2 82.824 83.2zM781.178 678.4v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4s-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2z"
    ],
    "grid": 0,
    "tags": [
      "md-notifications"
    ]
  },
  {
    "paths": [
      "M672 544c0-59.6-32.6-111.4-80.8-139l146.2-248.2c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l143.2 250c-46.2 28-77 78.8-77 136.8h-288c0 166.6 93.8 306.8 228.8 384l140.2-244.8c23.4 13.2 50.2 20.8 79 20.8 28.6 0 55.4-7.6 78.6-20.6l140.6 244.6c135-77.2 228.8-217.4 228.8-384h-288z"
    ],
    "grid": 0,
    "tags": [
      "md-nuclear"
    ]
  },
  {
    "paths": [
      "M714.4 471.2l-165-165.2h-1.6c-16.2-12-36.4-20.6-56.8-20.6-27.4 0-52.2 12.6-68.6 32.6h-1.2l-315.2 510.2v1.6c-6 12.4-10 26.6-10 41.6 0 48.8 39.4 88.6 88.6 88.6 18.8 0 36-5.8 54.8-18.2l465.8-336.2c21.8-16.6 34.8-43.2 34.8-72 0-24-9.4-46.4-25.6-62.4z",
      "M928 290.2l-58.4-98-73.2 40.6 63-111.8-98.2-57-134.6 255.6 82.6 82.8z"
    ],
    "grid": 0,
    "tags": [
      "md-nutrition"
    ]
  },
  {
    "paths": [
      "M810.68 810.664h-597.36v-597.328h266.68v-85.336h-266.68c-46.938 0-85.32 38.394-85.32 85.336v597.328c0 46.942 38.382 85.336 85.32 85.336h597.36c46.938 0 85.32-38.394 85.32-85.336v-266.664h-85.32v266.664zM576 128v85.336h174.948l-430.95 430.93 59.732 59.732 430.952-430.94v174.942h85.318v-320h-320z"
    ],
    "grid": 0,
    "tags": [
      "md-open"
    ]
  },
  {
    "paths": [
      "M64 768h544v64h-544v-64z",
      "M800 768h160v64h-160v-64z",
      "M768 895c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z",
      "M64 480h160v64h-160v-64z",
      "M416 480h544v64h-544v-64z",
      "M384 607c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z",
      "M64 192h544v64h-544v-64z",
      "M800 192h160v64h-160v-64z",
      "M768 319c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z"
    ],
    "grid": 0,
    "tags": [
      "md-options"
    ]
  },
  {
    "paths": [
      "M739 64h-454.2c-121.8 0-220.8 101.2-220.8 225.2v445.6c0 124 99 225.2 220.8 225.2h454.4c121.8 0 221-101.2 221-225.2v-445.6c-0.2-124-99.2-225.2-221.2-225.2zM350 502v1.4c0 21.8-18.2 40.8-39.8 40.8h-46.6c-21.6 0-39.8-19-39.8-40.8v-207.2c2-21.6 18.4-40.4 39.8-40.4h46.6c21.8 0 39.8 19.6 39.8 41.6v204.6zM594 796.8c0 22.8-17.8 35.2-40.2 35.2h-83.6c-22.4 0-40.2-16.2-40.2-39.2v-58.6c0-46.6 36.2-84.6 82-84.6s82 38 82 84.6v62.6zM800 502v1.4c0 21.8-18.2 40.8-39.8 40.8h-48.6c-21.6 0-39.8-19-39.8-40.8v-207.2c2-21.6 18.4-40.4 39.8-40.4h48.6c21.6 0 39.8 19.6 39.8 41.6v204.6z"
    ],
    "grid": 0,
    "tags": [
      "md-outlet"
    ]
  },
  {
    "paths": [
      "M96 541.8l237.8 89.2 29.6 297 148.6-208 208 208 208-832-832 445.8zM685.8 793.8l-165.8-167 229.8-322.8-362.6 275.6-137.4-49.6 582-312.4-146 576.2z"
    ],
    "grid": 0,
    "tags": [
      "md-paper-plane"
    ]
  },
  {
    "paths": [
      "M928 128h-544c-17.6 0-32 15.4-32 33v63h-204c-46.2 0-84 37.8-84 84v415c0 95.2 78 173 172 173h559.4c90.2 0 164.6-73.8 164.6-164v-572c0-17.6-14.4-32-32-32zM352 288v384h-84v-345.6c0-13.6-1.6-26.6-6.6-38.4h90.6zM318 798.8c-22 21.2-51.6 33.2-81 33.2-29 0-56.2-11.4-77-32-20.6-20.6-32-48-32-77v-396.6c0-21.2 16.8-38.4 38-38.4s38 17.2 38 38.4v377.6c0 17.6 14.4 32 32 32h115c-3 23.2-14.4 45.2-33 62.8zM896 732c0 26.6-10.8 51.6-29.8 70.6s-44.4 29.4-70.8 29.4h-420.8c25.6-29.8 41.4-67.8 41.4-109v-529h480v538z",
      "M496 272h320v112h-320v-112z",
      "M496 448h320v64h-320v-64z",
      "M496 576h320v64h-320v-64z",
      "M816 704h-320c0 0 0 64-16 64 14 0 277.2 0 297.4 0 38.6 0 38.6-42 38.6-64z"
    ],
    "grid": 0,
    "tags": [
      "md-paper"
    ]
  },
  {
    "paths": [
      "M496.062 233.62l49.356-49.356 38.466 38.466-49.356 49.356-38.466-38.466z",
      "M352 251.4c-90.6 0-164.6 74-164.6 164.6 0 35 11 67.4 29.8 94 30.6-26 67.8-45.2 109.4-55.2l26.4-33.2c27.2-34.2 61.4-60.4 101.6-77.8 12.2-5.2 24.8-9.6 38-13.2-29-47.4-81.2-79.2-140.6-79.2z",
      "M324 128h56v82h-56v-82z",
      "M64 388h82v56h-82v-56z",
      "M163.2 553.6l-1.6-1.6-49.4 49.4 38.4 38.4 49.4-49.4z",
      "M158.578 184.26l49.356 49.356-38.466 38.466-49.356-49.356 38.466-38.466z",
      "M811.2 577.2c-21.8-110.4-118.8-193.2-235.2-193.2-68 0-130.2 23.8-173 77.6 58.8 4.4 113.4 26 155.6 67.8 31.2 31.2 53.2 69.2 64.2 110.6h-57.4c-26.2-74.6-96-128-181.2-128-10.2 0-24.6 1.2-35.4 3.4-91.6 18.8-156.8 94.6-156.8 188.6 0 106 86 192 192 192h416c88.4 0 160-71.6 160-160 0-84.4-65.6-153-148.8-158.8z"
    ],
    "grid": 0,
    "tags": [
      "md-partly-sunny"
    ]
  },
  {
    "paths": [
      "M192 896h213.4v-768h-213.4v768zM618.6 128v768h213.4v-768h-213.4z"
    ],
    "grid": 0,
    "tags": [
      "md-pause"
    ]
  },
  {
    "paths": [
      "M919 381c-9.4-25.4-25.4-43.8-46.2-53.2-9.6-4.2-19.4-6.4-29.6-6.4-43.4 0-87.4 40.4-109.8 100.6-27.6 74.6-11.6 147.6 37.2 170 9.8 4.4 20.2 6.8 31.2 6.8 44.2 0 89.2-37 111.8-92.2 17-42 19-88.8 5.4-125.6z",
      "M290.6 422c-22.2-60.2-66.4-100.6-109.8-100.6-10.2 0-20.2 2.2-29.6 6.4-20.8 9.4-36.6 27.8-46.2 53.2-13.8 36.8-11.8 83.6 5.4 125.4 22.6 55.2 67.6 92.2 111.8 92.2 10.8 0 21.4-2.2 31.2-6.8 48.8-22.2 64.8-95.2 37.2-169.8z",
      "M387 413.6c4 0.2 8 0 12-0.4 23.4-2.2 44.6-14.2 61.2-34.6 26.8-33 34.2-84.4 28.6-137.4-8.6-81.6-51.6-142.6-109.6-145.2 0 0-8.2 0-12.4 0.4-25.6 2.6-48.8 15.8-67 38.4-26.6 32.8-39.4 81.4-34.2 130.2 8.6 80.8 61.8 146 121.4 148.6z",
      "M512 477.4c-138.6 0-277.4 164.8-277.4 323.2 0 47.2 23.6 85.2 47 100.8 28.8 19.2 49 26.8 91 26.8 50 0 63.6-17.6 87-33 17-11.2 31.6-20.8 52.4-20.8s35.4 9.6 52.4 20.8c23.4 15.4 37 33 87 33 42.2 0 62.4-7.6 91-26.8 23.2-15.6 47-53.6 47-100.8 0-158.4-138.8-323.2-277.4-323.2z",
      "M625.2 413c4 0.4 8 0.6 12 0.4 59.6-2.6 113-67.8 121.6-148.6 5.2-48.8-7.6-97.6-34.2-130.2-18.4-22.6-40.6-35.2-66.2-37.6-4.2-0.4-13.4-0.6-13.4-0.6-57.8 2.6-100.8 63-109.6 144.8-5.6 53 1.8 104.6 28.6 137.4 16.8 20 38 32 61.2 34.4z"
    ],
    "grid": 0,
    "tags": [
      "md-paw"
    ]
  },
  {
    "paths": [
      "M674.908 464c67.198 0 122.184-54.004 122.184-120 0-65.994-54.986-120-122.184-120s-122.18 54.006-122.18 120c-0 65.996 54.982 120 122.18 120zM349.092 464c67.198 0 122.18-54.004 122.18-120 0-65.994-54.982-120-122.18-120s-122.184 54.006-122.184 120c0 65.996 54.986 120 122.184 120zM349.092 552c-95.716 0-285.092 45.996-285.092 140v108h576v-108c0-94.004-195.198-140-290.908-140zM674.908 574.006c-12.21 0-20.65 0-34.908 1.994 46.852 34.004 64 56 64 116v108h256v-108c0-94.004-189.376-117.994-285.092-117.994z"
    ],
    "grid": 0,
    "tags": [
      "md-people"
    ]
  },
  {
    "paths": [
      "M608 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM608 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z",
      "M224 448v-128h-64v128h-128v64h128v128h64v-128h128v-64h-128z"
    ],
    "grid": 0,
    "tags": [
      "md-person-add"
    ]
  },
  {
    "paths": [
      "M512 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM512 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z"
    ],
    "grid": 0,
    "tags": [
      "md-person"
    ]
  },
  {
    "paths": [
      "M960 717.712v-411.426c0-45.262-36.652-82.286-81.456-82.286h-733.088c-44.804 0-81.456 37.024-81.456 82.286v411.426c0 45.264 36.652 82.288 81.456 82.288h733.090c44.802 0 81.454-37.024 81.454-82.288zM224 728v-432h576v432h-576z"
    ],
    "grid": 0,
    "tags": [
      "md-phone-landscape"
    ]
  },
  {
    "paths": [
      "M717.712 64h-411.426c-45.262 0-82.286 36.652-82.286 81.456v733.090c0 44.802 37.024 81.454 82.286 81.454h411.426c45.264 0 82.288-36.652 82.288-81.456v-733.088c0-44.804-37.024-81.456-82.288-81.456zM728 800h-432v-576h432v576z"
    ],
    "grid": 0,
    "tags": [
      "md-phone-portrait"
    ]
  },
  {
    "paths": [
      "M800 842.6v-533.2c0-47-38.4-85.4-85.4-85.4h-533.2c-47 0-85.4 38.4-85.4 85.4v533.4c0 47 38.4 85.4 85.4 85.4h533.4c46.8-0.2 85.2-38.6 85.2-85.6zM314.6 608l90.6 128 133.4-192 176 256h-533.2l133.2-192z",
      "M842.6 96h-533.2c-47 0-85.4 38.4-85.4 85.4v10.6h522.6c47 0 85.4 38.4 85.4 85.4v522.6h10.6c47 0 85.4-38.4 85.4-85.4v-533.2c0-47-38.4-85.4-85.4-85.4z"
    ],
    "grid": 0,
    "tags": [
      "md-photos"
    ]
  },
  {
    "paths": [
      "M65.2 512h446.8v-446.8c-10-0.8-21.2-1.2-32-1.2-229.8 0-416 186.2-416 416 0 10.8 0.4 22 1.2 32z",
      "M219.6 804.4c76.2 94.8 193.2 155.6 324.4 155.6 229.8 0 416-186.2 416-416 0-131.2-60.8-248.2-155.6-324.4-63.4-51-142.4-83.8-228.4-90.4v446.8h-446.8c6.6 86 39.4 165 90.4 228.4z"
    ],
    "grid": 0,
    "tags": [
      "md-pie"
    ]
  },
  {
    "paths": [
      "M512 64c-176.008 0-320 141.114-320 313.602 0 235.198 320 582.398 320 582.398s320-347.2 320-582.398c0-172.488-143.992-313.602-320-313.602zM512 489.602c-63.992 0-114.288-49.29-114.288-112 0-62.714 50.294-112 114.288-112s114.288 49.286 114.288 112c0 62.71-50.296 112-114.288 112z"
    ],
    "grid": 0,
    "tags": [
      "md-pin"
    ]
  },
  {
    "paths": [
      "M128 96l85.8 758.4c5.2 41.6 41 73.6 85 73.6h426.6c44 0 79.8-32 85-73.6l85.6-758.4h-768zM782 345.6h-540l-18.8-166.4h577.2l-18.4 166.4z"
    ],
    "grid": 0,
    "tags": [
      "md-pint"
    ]
  },
  {
    "paths": [
      "M814.4 260.8c-93-37.8-194.8-56.8-302.4-56.8-107.8 0-216.6 20.6-302.4 56-16.2 6.6-30.6 18-20.2 39s322.4 661 322.4 661l322-659.8c6.4-13.8 1.8-30.8-19.4-39.4zM372.4 408c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64zM512 694c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64zM651.6 448c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64z",
      "M873.8 132c-104.4-41.2-233.2-68-361.8-68s-255.2 24.2-361.8 66.8c-9.4 3.8-22.2 11.2-22.2 27.6l19.4 48.2c5.6 9.8 17.4 16.4 30.2 16.4 3.6 0 8.6-0.6 14.6-3 98-37.8 206.2-59.2 320-59.2s230.4 23.2 320 59.2c7.2 2.8 11.2 3 14.6 3 13.2 0 24.4-6.6 30-16.2l19.6-48.2c-0.4-14.6-10-21.6-22.6-26.6z"
    ],
    "grid": 0,
    "tags": [
      "md-pizza"
    ]
  },
  {
    "paths": [
      "M896 672v-80l-320-208v-225.6c0-35.366-29.64-62.4-64-62.4-34.358 0-64 27.036-64 62.4v225.6l-320 208v80l320-96v227.204l-96 62.398v62.398l160-32 160 32v-62.398l-96-62.398v-227.204l320 96z"
    ],
    "grid": 0,
    "tags": [
      "md-plane"
    ]
  },
  {
    "paths": [
      "M271.4 302c-5 6-9.8 12-14.4 18.4 64.4 72.6 152.2 153 248.4 227.4 75.6 58.4 152.6 110.4 222.8 150.2 11.8 6.6 23.4 13 34.6 18.8 5-6 9.8-12 14.4-18.4 23.4-32.2 36.2-66.4 46.6-107.2 1.6-6.4 3-12.8 4.2-19 31.6-166-71.2-329.8-237-371.8-74-18.8-148.2-10.2-212.6 19.4-42.8 19.8-76.4 45.8-107 82.2z",
      "M836.4 653.6c-8.2 22-14.8 35-14.8 35 36.4 42.2 49.2 67.8 63.8 92.8 4.8 8.2 14.8 26.2 1.8 24.8-3.4-0.6-7-1.4-11-2.6-42.6-10.8-102.4-37.4-168.6-74.8-71.6-40.6-149.8-93.4-226.6-152.6-102.2-79-195-164.6-261.2-241-30.6-35.2-55.2-68.4-71.4-95.8-4.8-8.2-7.8-12.6-11.2-20.8-5-12.4 10-10.2 14-9.2 29.8 7.6 70 19.8 116.4 47.6 0 0 8.6-9.6 27.8-22.8-45.6-30.8-89.2-55.4-130.4-71-46.2-17.6-82.2-13.6-95 7.4-24.4 39.8 28 144.6 130.6 264-43 172 61.2 346.6 233 390 82.2 20.8 164.8 7.8 233.6-30 76.2 35.2 144.2 57.2 193.8 69.8 47.8 12.2 80.8 11 93.6-9.8 22.2-36.4-24.2-103.6-118.2-201z"
    ],
    "grid": 0,
    "tags": [
      "md-planet"
    ]
  },
  {
    "paths": [
      "M192 104v816l640-408-640-408z"
    ],
    "grid": 0,
    "tags": [
      "md-play"
    ]
  },
  {
    "paths": [
      "M64 448h256v384h-256v-384z",
      "M384 256h256v576h-256v-576z",
      "M704 576h256v256h-256v-256z"
    ],
    "grid": 0,
    "tags": [
      "md-podium"
    ]
  },
  {
    "paths": [
      "M558.2 96h-92.4v462.2h92.4v-462.2zM781.4 196.4l-65.6 65.6c73 58.8 119.8 148.8 119.8 250 0 178.8-144.6 323.6-323.6 323.6s-323.6-144.8-323.6-323.6c0-101.2 46.6-191.4 119.2-250.6l-65.2-65.2c-89.6 76.4-146.4 189.2-146.4 315.8 0 229.8 186.2 416 416 416s416-186.2 416-416c0-126.6-56.8-239.4-146.6-315.6z"
    ],
    "grid": 0,
    "tags": [
      "md-power"
    ]
  },
  {
    "paths": [
      "M832 128h-316.8l-362.2 375.2c-16 16-24.6 37-25 58-0.6 22.6 7.8 45.2 25 62.4l247.4 247.2c16 16 41.6 25 57.6 25s45.6-7.8 62.8-25l375.2-358.8v-320l-64-64zM770.6 333.4c-43.4 12.2-82.6-20-82.6-61.4 0-35.4 28.6-64 64-64 41.4 0 73.6 39.2 61.4 82.6-5.8 20.6-22.2 37-42.8 42.8z"
    ],
    "grid": 0,
    "tags": [
      "md-pricetag"
    ]
  },
  {
    "paths": [
      "M884 214v282l-425.6 407.4c16 16 41.6 24.6 57.6 24.6s45.6-7.4 62.8-24.6l381.2-359.4v-256l-76-74z",
      "M768 96h-320l-359.4 375.2c-16 16-24 35.6-24.6 56.8-0.6 22.6 7.4 46.6 24.6 63.8l247.6 247.2c16 16 41.6 25 57.6 25s45.4-7.8 62.6-25l375.6-359v-320l-64-64zM706.6 301.4c-43.4 12.2-82.6-20-82.6-61.4 0-35.4 28.6-64 64-64 41.4 0 73.6 39.2 61.4 82.6-5.8 20.6-22.2 37-42.8 42.8z"
    ],
    "grid": 0,
    "tags": [
      "md-pricetags"
    ]
  },
  {
    "paths": [
      "M799.9 320h-575.8c-70.452 0-128.1 57.606-128.1 128v277.334h159.798v170.666h512.402v-170.666h159.8v-277.334c0-70.394-57.65-128-128.1-128zM704 832h-384v-256h384v256zM768.202 128h-512.404v160h512.402v-160z"
    ],
    "grid": 0,
    "tags": [
      "md-print"
    ]
  },
  {
    "paths": [
      "M856 538c-43 0-81.2 26.2-96.8 66h-82.4l-62.8-161.4c-5.4-16.4-20.6-27.4-38-27.4-0.4 0-0.6 0-0.8 0-17.6 0.4-32.8 12-37.6 29l-67.2 270.8-111-583.6c-3.4-20.2-20.2-35.4-39.4-35.4-19 0-33.8 12.4-38.8 32.4l-100.6 475.6h-116.6v80h148c18.4 0 34.4-12.4 38.8-30.4l61.4-321.2 108.2 564.2c3 17.6 17.8 30.2 37.2 31.4 0.8 0 1.6 0 2.4 0 18.6 0 33.8-10.6 38.4-27l80.4-325.8 31 81.4c5.4 16.4 20.6 27.4 38 27.4h112.8c16.6 38 54.2 62 95.2 62 27.8 0 53.8-11.2 73.6-31.6 19.6-20.2 30.4-46.6 30.4-74.4 0.2-57.2-45.4-102-103.8-102z"
    ],
    "grid": 0,
    "tags": [
      "md-pulse"
    ]
  },
  {
    "paths": [
      "M192 248.4c0-13.8 10.4-24.4 24.4-24.4h135.6v-96h-133.6c-67 0-122.4 53.4-122.4 120.4v135.6h96v-135.6z",
      "M807.2 128h-135.2v96h134.4c13.8 0 25.6 10.4 25.6 24.4v135.6h96v-135.6c0-67-54-120.4-120.8-120.4z",
      "M832 773.6c0 13.8-10.4 24.4-24.4 24.4h-135.6v98h135.6c67 0 120.4-55.4 120.4-122.4v-133.6h-96v133.6z",
      "M216.4 798c-13.8 0-24.4-10.4-24.4-24.4v-133.6h-96v133.6c0 67 55.4 122.4 122.4 122.4h133.6v-98h-135.6z"
    ],
    "grid": 0,
    "tags": [
      "md-qr-scanner"
    ]
  },
  {
    "paths": [
      "M192.8 832h154.2l101.8-193.2v-446.8h-320v446.8h154.2l-90.2 193.2zM640.8 832h154.2l100-193.2v-446.8h-318.2v446.8h164l-100 193.2z"
    ],
    "grid": 0,
    "tags": [
      "md-quote"
    ]
  },
  {
    "paths": [
      "M512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.798c-183.036 0-332.798-149.764-332.798-332.798s149.762-332.8 332.798-332.8 332.8 149.764 332.8 332.8-149.764 332.798-332.8 332.798z"
    ],
    "grid": 0,
    "tags": [
      "md-radio-button-off"
    ]
  },
  {
    "paths": [
      "M512 304c-114.4 0-208 93.6-208 208s93.6 208 208 208 208-93.6 208-208-93.6-208-208-208zM512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.8c-183.036 0-332.8-149.766-332.8-332.8s149.764-332.8 332.8-332.8 332.8 149.764 332.8 332.8-149.764 332.8-332.8 332.8z"
    ],
    "grid": 0,
    "tags": [
      "md-radio-button-on"
    ]
  },
  {
    "paths": [
      "M147.6 283.8c-30.4 12-51.6 43.6-51.6 79v512c0 47 37 85.4 83.2 85.4h665.6c46.2 0 83.2-38.4 83.2-85.4v-512c0-47.4-37-85.4-83.2-85.4h-486.8l343.6-142.6-28.2-70.8-525.8 219.8zM320 876c-70.8 0-128-57.2-128-128s57.2-128 128-128 128 57.2 128 128-57.2 128-128 128zM832 533.4h-64v-92.4h-89.6v92.4h-486.4v-170.6h640v170.6z"
    ],
    "grid": 0,
    "tags": [
      "md-radio"
    ]
  },
  {
    "paths": [
      "M278 800c0 0-46 50.6-46 81.4 0 25.6 20.6 46.6 46 46.6s46-21 46-46.6c0-30.8-46-81.4-46-81.4z",
      "M434 736c0 0-46 50.6-46 81.4 0 25.6 20.8 46.6 46 46.6 25.4 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z",
      "M590 800c0 0-46 50.6-46 81.4 0 25.6 20.6 46.6 46 46.6 25.2 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z",
      "M746 736c0 0-46 50.6-46 81.4 0 25.6 20.8 46.6 46 46.6 25.4 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z",
      "M786.4 322.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 94.8 233 218.4 233h485.4c103 0 192.4-92 192.4-195.6-0.2-98.8-76.8-179.2-173.8-186z"
    ],
    "grid": 0,
    "tags": [
      "md-rainy"
    ]
  },
  {
    "paths": [
      "M739.6 320c-106.8 0-192.4 85.6-192.4 192 0 47.2 15.8 89 43.8 122.2h-157.6c28-33.2 43.8-75 43.8-122.2 0-106.4-85.8-192-192.4-192s-192.8 85.6-192.8 192 85.8 192 192.4 192h455c106.8 0 192.4-85.6 192.4-192s-85.6-192-192.2-192zM284.4 634.2c-68.2 0-122.4-54.2-122.4-122.2s54.2-122.2 122.4-122.2 122.4 54.2 122.4 122.2-54 122.2-122.4 122.2zM739.6 634.2c-68.2 0-122.4-54.2-122.4-122.2s54.2-122.2 122.4-122.2 122.4 54.2 122.4 122.2-54.2 122.2-122.4 122.2z"
    ],
    "grid": 0,
    "tags": [
      "md-recording"
    ]
  },
  {
    "paths": [
      "M64 674.4l103.6 29.6c45.8-139.4 177.4-235.6 332-235.6 85.6 0 163 31.4 223.6 82.2l-158.2 153.4h395v-384l-159.2 152.6c-80.8-70.4-185.6-113.6-301.4-113.6-203 0.2-374.6 132.4-435.4 315.4z"
    ],
    "grid": 0,
    "tags": [
      "md-redo"
    ]
  },
  {
    "paths": [
      "M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM736 484h-196l89.6-89.6c-29.4-30.8-71.4-50.4-117.6-50.4-92.4 0-168 75.6-168 168s75.6 168 168 168c69.8 0 130.6-42.4 155.2-104h59.6c-27.8 92.6-112.6 160-214.8 160-124.6 0-224-100.8-224-224s100.8-224 224-224c61.6 0 117.6 25.2 158.2 65.8l65.8-65.8v196z"
    ],
    "grid": 0,
    "tags": [
      "md-refresh-circle"
    ]
  },
  {
    "paths": [
      "M512 776c-145.194 0-264-118.81-264-264 0-145.202 118.806-264 264-264 72.6 0 138.598 30.8 184.812 79.202l-140.812 140.798h308v-308l-103.396 103.404c-63.792-63.808-151.792-103.404-248.604-103.404-193.594 0-352 158.406-352 352s156.188 352 352 352c162.090 0 296.574-108.268 338.802-256h-93.102c-37.49 99.122-134.276 168-245.7 168z"
    ],
    "grid": 0,
    "tags": [
      "md-refresh"
    ]
  },
  {
    "paths": [
      "M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-428v-84h428v84z"
    ],
    "grid": 0,
    "tags": [
      "md-remove-circle"
    ]
  },
  {
    "paths": [
      "M192 470h640v84h-640v-84z"
    ],
    "grid": 0,
    "tags": [
      "md-remove"
    ]
  },
  {
    "paths": [
      "M192 696h640v72h-640v-72z",
      "M192 256h640v72h-640v-72z",
      "M192 401.4h640v71.2h-640v-71.2z",
      "M192 551.6h640v71.2h-640v-71.2z"
    ],
    "grid": 0,
    "tags": [
      "md-reorder"
    ]
  },
  {
    "paths": [
      "M298.6 304h426.6v124.8l170.6-166.4-170.4-166.4v124.8h-512v249.6h85.4v-166.4zM725.4 720h-426.8v-124.8l-170.6 166.4 170.6 166.4v-124.8h512v-249.6h-85.4v166.4z"
    ],
    "grid": 0,
    "tags": [
      "md-repeat"
    ]
  },
  {
    "paths": [
      "M595.2 96l129.8 129.8-499.2 499.2-129.8-129.8v332.8h332.8l-129.8-129.8 499.2-499.2 129.8 129.8v-332.8z"
    ],
    "grid": 0,
    "tags": [
      "md-resize"
    ]
  },
  {
    "paths": [
      "M329.704 559.878l123.668-120.502-305.932-295.964c-67.252 65.528-67.252 173.354 0 238.88l182.264 177.586z",
      "M624.778 483.76c67.272 29.604 160.566 8.464 227.82-59.186 82.444-80.33 99.818-196.606 34.726-257.92-62.93-63.42-182.262-46.49-264.708 33.842-69.436 67.65-91.132 158.552-60.748 221.972-95.478 95.136-423.104 414.346-423.104 414.346l60.754 59.186 299.42-291.732 299.416 291.732 60.748-59.186-299.418-291.738 65.094-61.316z"
    ],
    "grid": 0,
    "tags": [
      "md-restaurant"
    ]
  },
  {
    "paths": [
      "M865.6 272v192h-621l168.8-172.4-66.4-67.6-283 288 283 288 66.4-67.6-168.8-172.4h715.4v-288h-94.4z"
    ],
    "grid": 0,
    "tags": [
      "md-return-left"
    ]
  },
  {
    "paths": [
      "M64 272v288h715.4l-168.8 172.4 66.4 67.6 283-288-283-288-66.4 67.6 168.8 172.4h-621v-192h-94.4z"
    ],
    "grid": 0,
    "tags": [
      "md-return-right"
    ]
  },
  {
    "paths": [
      "M880 192h-176l-64-64h-256l-64 64h-176c-44.2 0-80 35.8-80 80v544c0 44.2 35.8 80 80 80h736c44.2 0 80-35.8 80-80v-544c0-44.2-35.8-80-80-80zM736 534h-195.4l89.6-90.2c-29.4-30.8-71.4-51-117.6-51-92.4 0-168 75.6-168 168s75.6 168 168 168c71 0 132.4-43 156.4-107h59.2c-26.8 94-112.4 163-215.6 163-124.6 0-224-100.8-224-224s100.8-224 224-224c61.6 0 117.4 25.2 158 65.8l65.6-65.8v197.2z"
    ],
    "grid": 0,
    "tags": [
      "md-reverse-camera"
    ]
  },
  {
    "paths": [
      "M499.2 804v-584l-435.2 292 435.2 292zM524.8 512l435.2 292v-584l-435.2 292z"
    ],
    "grid": 0,
    "tags": [
      "md-rewind"
    ]
  },
  {
    "paths": [
      "M512 64c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256zM512 480c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z",
      "M387.4 614.8c-38.2-16.2-72.4-39.2-101.6-68.6-2.8-2.8-5.6-5.6-8.2-8.6l-149.6 262.4h192l96 160 147-324c-16.8 2.6-33.8 4-51 4-43.2 0-85-8.4-124.6-25.2z",
      "M746.6 537.8c-2.6 2.8-5.4 5.8-8.2 8.6-29.2 29.2-63.4 52.4-101.4 68.4l-49 107.6-43.8 96.8 63.8 140.8 96-160h192l-149.4-262.2z"
    ],
    "grid": 0,
    "tags": [
      "md-ribbon"
    ]
  },
  {
    "paths": [
      "M521.2 429.6c47.6-81.8 96-143.2 182.8-192.8 16.6-9.6 42.4-16 45.6-17.8-168.2-51.6-237.6-155-237.6-155s-69.4 103.4-241 153c11.6 6.8 33 13 61.4 27.4 69 34.8 125 102.6 188.8 185.2z",
      "M492.6 506.8c-119.2-184.4-229.8-253.2-396.6-253.2 108.4 157.2 104 349.2 104 430.8 0 152.2 139.6 275.6 312 275.6 115.2 0 215.8-55.2 270-137.4-71-55.2-170.2-131.4-289.4-315.8z",
      "M928 253.6c0 0-110.4-4.6-170.4 30.8-86 51-148.8 122.6-190.8 206.4 77.6 104 146 175.8 190.8 218.8 21.4 20.4 39.6 36.4 55 49 7.4-23.6 11.6-48.6 11.6-74.4-0.2-81.6-34.8-228.2 103.8-430.6z"
    ],
    "grid": 0,
    "tags": [
      "md-rose"
    ]
  },
  {
    "paths": [
      "M512 576c-90.886 0-167.35 52.152-204.41 128h408.82c-37.060-75.848-113.524-128-204.41-128z",
      "M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8z",
      "M657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4z",
      "M366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4z"
    ],
    "grid": 0,
    "tags": [
      "md-sad"
    ]
  },
  {
    "paths": [
      "M227 562.4v170.6l285 163 285-163v-170.6l-285 163-285-163zM512 128l-448 256 448 256 366.6-209.4v294.8h81.4v-341.4l-448-256z"
    ],
    "grid": 0,
    "tags": [
      "md-school"
    ]
  },
  {
    "paths": [
      "M675.018 610.744h-35.002l-13.142-10.972c41.582-50.464 67.844-114.108 67.844-186.514-0.002-157.994-126.926-285.258-284.448-285.258-155.366 0-282.27 127.264-282.27 285.258s126.904 285.256 284.45 285.256c70.022 0 135.662-26.334 185.982-68.016l13.122 10.974v35.102l218.806 219.426 65.64-65.828-220.982-219.428zM412.45 610.744c-109.404 0-196.926-87.774-196.926-197.486 0-109.716 87.522-197.484 196.926-197.484 109.4 0 196.924 87.768 196.924 197.484 0 109.712-87.524 197.486-196.924 197.486z"
    ],
    "grid": 0,
    "tags": [
      "md-search"
    ]
  },
  {
    "paths": [
      "M96 896l832-384-832-384v298.666l596 85.334-596 85.334z"
    ],
    "grid": 0,
    "tags": [
      "md-send"
    ]
  },
  {
    "paths": [
      "M827.934 553.6c2.12-12.47 2.12-27.036 2.12-41.6s-2.12-27.036-2.12-41.6l89.334-68.636c8.52-6.236 10.638-16.634 4.26-27.036l-85.098-143.528c-4.258-8.328-17.014-12.47-25.534-8.328l-106.372 41.602c-21.276-16.636-46.788-31.202-72.32-41.602l-14.896-110.234c-2.12-8.308-10.638-16.636-21.276-16.636h-170.196c-10.636 0-19.154 8.328-21.274 16.636l-17.016 110.234c-25.534 10.4-48.928 24.964-72.342 41.602l-106.372-41.602c-10.638-4.142-21.276 0-25.534 8.328l-85.098 143.53c-4.238 8.306-2.122 20.798 4.258 27.036l91.482 68.634c0 14.564-2.12 27.036-2.12 41.6s2.12 27.036 2.12 41.6l-89.336 68.636c-8.52 6.236-10.636 16.634-4.26 27.036l85.098 143.528c4.26 8.328 17.016 12.47 25.534 8.328l106.374-41.602c21.274 16.636 46.788 31.202 72.32 41.602l17.016 110.234c2.138 10.4 10.636 16.636 21.274 16.636h170.196c10.638 0 19.156-8.328 21.276-16.636l17.036-110.234c25.514-10.4 48.928-24.964 72.32-41.602l106.374 41.602c10.636 4.142 21.274 0 25.534-8.328l85.098-143.53c4.258-8.306 2.12-20.798-4.26-27.036l-93.6-68.634zM510.936 657.6c-82.978 0-148.92-64.47-148.92-145.6s65.942-145.6 148.92-145.6 148.922 64.47 148.922 145.6-65.944 145.6-148.922 145.6z"
    ],
    "grid": 0,
    "tags": [
      "md-settings"
    ]
  },
  {
    "paths": [
      "M896 496l-320-304v170.668c-298.668 42.666-405.334 256-448 469.332 106.666-149.332 234.666-217.604 448-217.604v174.938l320-293.334z"
    ],
    "grid": 0,
    "tags": [
      "md-share-alt"
    ]
  },
  {
    "paths": [
      "M767.644 688.854c-32.090 0-62.048 10.652-83.442 31.958l-305.914-176.84c2.142-10.656 4.284-19.186 4.284-29.838 0-10.656-2.142-19.186-4.284-29.838l301.652-174.7c23.524 21.306 53.482 34.082 87.704 34.082 70.59 0 128.356-57.532 128.356-127.84 0-70.304-57.766-127.838-128.356-127.838-70.594 0-128.358 57.534-128.358 127.84 0 10.654 2.13 19.186 4.284 29.838l-301.642 174.7c-23.534-21.308-53.482-34.082-87.712-34.082-70.592 0-126.216 57.532-126.216 127.84 0 70.306 57.754 127.84 128.356 127.84 34.23 0 64.178-12.778 87.712-34.084l303.782 176.842c-2.152 8.51-4.282 17.042-4.282 27.694 0 68.188 55.612 123.574 124.074 123.574 68.458 0 124.072-55.386 124.072-123.574 0.002-68.188-55.61-123.574-124.070-123.574z"
    ],
    "grid": 0,
    "tags": [
      "md-share"
    ]
  },
  {
    "paths": [
      "M640 128c-22.2 38.2-80.6 64-128 64s-105.8-25.8-128-64l-256 64v192l154-32-26 544h512l-26-544 154 32v-192l-256-64z"
    ],
    "grid": 0,
    "tags": [
      "md-shirt"
    ]
  },
  {
    "paths": [
      "M444.4 376.2l-248.8-248.2-67.6 67.6 248.2 248.2 68.2-67.6zM632 128l98 98-602 602.4 67.6 67.6 602.4-602 98 98v-264h-264zM647.8 579.6l-67.6 67.6 150.2 150.2-98.4 98.6h264v-264l-98 98c0 0-150.2-150.4-150.2-150.4z"
    ],
    "grid": 0,
    "tags": [
      "md-shuffle"
    ]
  },
  {
    "paths": [
      "M341.4 512l554.6 384v-768l-554.6 384z",
      "M128 128h128v768h-128v-768z"
    ],
    "grid": 0,
    "tags": [
      "md-skip-backward"
    ]
  },
  {
    "paths": [
      "M128 128v768l554.6-384-554.6-384z",
      "M768 128h128v768h-128v-768z"
    ],
    "grid": 0,
    "tags": [
      "md-skip-forward"
    ]
  },
  {
    "paths": [
      "M922.8 597l-16.6-61.8-176 47.2-120.8-69.8 120.8-69.8 176 47.2 16.6-61.8-114.2-30.6 115.4-66.6-48-83-113.2 65.4 30.6-114.2-61.8-16.6-47.2 176-124.4 71.8v-142.2l129-128.8-45.4-45.2-83.6 83.6v-133.8h-96v131.2l-83.4-83.4-45.2 45.2 128.6 128.8v142.8l-121.4-70-47.2-176-61.8 16.6 30.6 114.2-115.4-66.8-48 83.2 113.4 65.4-114.2 30.6 16.6 61.8 175.8-47.2 125.2 72.2-125.2 72.4-175.8-47.2-16.6 61.8 114.2 30.6-113.4 65.4 48 83 115.4-66.6-30.6 114 61.8 16.6 47.2-175.8 121.4-70.2v141.8l-128.6 128.8 45.2 45.2 83.4-83.6v131.2h96v-133.6l83.8 83.4 45-45.2-128.8-128.6v-141.2l124.4 72 47.2 175.8 61.8-16.6-30.6-114 113.2 65.4 48-83.2-115.4-66.6z"
    ],
    "grid": 0,
    "tags": [
      "md-snow"
    ]
  },
  {
    "paths": [
      "M256 832h512v96h-512v-96z",
      "M512 576c35.4 0 64-28.6 64-64s-28.6-64-64-64c-6 0-12 0.8-17.6 2.4l-133.4-97.4-8 7 97.8 133.4c-1.8 5.8-2.8 12-2.8 18.6 0 35.4 28.6 64 64 64z",
      "M512 96c-229.8 0-416 186.2-416 416 0 96.6 33 185.4 88.2 256h117.6l52.2-52.2-45.8-45.8-44.2 44c-39.8-48.6-64.2-108-70.4-170h62.4v-64h-62.4c6.2-62 30.6-121.4 70.4-170l44.2 44 45.8-45.8-44-44.2c48.6-39.8 108-64.2 170-70.4v62.4h64v-62.4c62 6.2 121.4 30.6 170 70.4l-44 44.2 45.8 45.8 44.2-44c39.8 48.6 64.2 108 70.4 170h-62.4v64h62.4c-6.2 62-30.6 121.4-70.4 170l-44.2-44-45.8 45.8 52.2 52.2h117.6c55.2-70.6 88.2-159.4 88.2-256-0-229.8-186.2-416-416-416z"
    ],
    "grid": 0,
    "tags": [
      "md-speedometer"
    ]
  },
  {
    "paths": [
      "M810.666 213.334v597.332h-597.332v-597.332h597.332zM810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334v0z"
    ],
    "grid": 0,
    "tags": [
      "md-square-outline"
    ]
  },
  {
    "paths": [
      "M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334z"
    ],
    "grid": 0,
    "tags": [
      "md-square"
    ]
  },
  {
    "paths": [
      "M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.574l-33.062-19.948-0.004-378.554 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"
    ],
    "grid": 0,
    "tags": [
      "md-star-half"
    ]
  },
  {
    "paths": [
      "M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.572l-33.062-19.948-153.036 92.328 40.496-174.172-135.142-117.152 178.084-15.296 69.594-164.262 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"
    ],
    "grid": 0,
    "tags": [
      "md-star-outline"
    ]
  },
  {
    "paths": [
      "M512 745.372l249.66 150.628-66.042-284.132 220.382-191.050-290.534-24.95-113.466-267.868-113.486 267.868-290.514 24.95 220.384 191.050-66.062 284.132z"
    ],
    "grid": 0,
    "tags": [
      "md-star"
    ]
  },
  {
    "paths": [
      "M352 128h128v768h-128v-768z",
      "M160 672h128v224h-128v-224z",
      "M544 544h128v352h-128v-352z",
      "M736 352h128v544h-128v-544z"
    ],
    "grid": 0,
    "tags": [
      "md-stats"
    ]
  },
  {
    "paths": [
      "M464 613.334h96v-261.334h-96v261.334z",
      "M815.34 340.542l61.572-61.572-67.884-67.882-61.57 61.572c-65.024-50.546-146.72-80.66-235.458-80.66-212.078 0-384 171.922-384 384s171.922 384 384 384 384-171.922 384-384c0-88.738-30.114-170.434-80.66-235.458zM724.132 788.132c-56.664 56.664-132 87.868-212.132 87.868s-155.47-31.204-212.132-87.868c-56.664-56.662-87.868-132-87.868-212.132s31.204-155.47 87.868-212.132c56.662-56.664 132-87.868 212.132-87.868s155.468 31.204 212.132 87.868c56.664 56.662 87.868 132 87.868 212.132s-31.204 155.47-87.868 212.132z",
      "M384 64h256v96h-256v-96z"
    ],
    "grid": 0,
    "tags": [
      "md-stopwatch"
    ]
  },
  {
    "paths": [
      "M512 96c-187.728 0-352 21.336-352 170.668v426.664c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668zM320 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM480 480h-224v-192h224v192zM704 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM768 480h-224v-192h224v192z"
    ],
    "grid": 0,
    "tags": [
      "md-subway"
    ]
  },
  {
    "paths": [
      "M554.6 64h-85.4v128h85.4v-128zM812.8 151.4l-76.8 76.8 59.8 59.8 76.8-76.8-59.8-59.8zM211.2 151.4l-59.8 59.8 76.8 76.8 59.8-59.8-76.8-76.8zM512 256c-140.8 0-256 115.2-256 256s115.2 256 256 256 256-115.2 256-256-115.2-256-256-256v0zM960 469.4h-128v85.4h128v-85.4zM192 469.4h-128v85.4h128v-85.4zM795.8 736l-59.8 59.8 76.8 76.8 59.8-59.8-76.8-76.8zM228.2 736l-76.8 76.8 59.8 59.8 76.8-76.8-59.8-59.8zM554.6 832h-85.4v128c12.8 0 85.4 0 85.4 0v-128z"
    ],
    "grid": 0,
    "tags": [
      "md-sunny"
    ]
  },
  {
    "paths": [
      "M262.6 462.2l-198.6 199 198.6 198.8v-149.2h349v-99.4h-349v-149.2zM960 362.8l-198.6-198.8v149.2h-349v99.4h349v149.2l198.6-199z"
    ],
    "grid": 0,
    "tags": [
      "md-swap"
    ]
  },
  {
    "paths": [
      "M336 432h189.8c29 29.6 69.4 48 114.2 48 88.4 0 160-71.6 160-160s-71.6-160-160-160c-44.8 0-85.2 18.4-114.2 48h-189.8c-61.6 0-112 50.4-112 112s50.4 112 112 112zM302.2 286.2c9.2-9.2 21.2-14.2 33.8-14.2h151.4c-4.8 15.2-7.4 31.2-7.4 48s2.6 32.8 7.4 48h-151.4c-12.6 0-24.8-5-33.8-14.2-9.2-9.2-14.2-21.2-14.2-33.8s5-24.8 14.2-33.8z",
      "M688 592h-189.8c-29-29.6-69.4-48-114.2-48-88.4 0-160 71.6-160 160s71.6 160 160 160c44.8 0 85.2-18.4 114.2-48h189.8c61.6 0 112-50.4 112-112s-50.4-112-112-112zM721.8 737.8c-9.2 9.2-21.2 14.2-33.8 14.2h-151.4c4.8-15.2 7.4-31.2 7.4-48s-2.6-32.8-7.4-48h151.4c12.6 0 24.8 5 33.8 14.2 9.2 9.2 14.2 21.2 14.2 33.8s-5 24.8-14.2 33.8z"
    ],
    "grid": 0,
    "tags": [
      "md-switch"
    ]
  },
  {
    "paths": [
      "M512 186.18v-122.18l-160 162.908 160 162.912v-122.186c131.992 0 240 109.964 240 244.366 0 40.726-10 79.428-28.008 114.032l58.008 59.062c31.992-50.914 50-109.976 50-173.094 0-179.198-144.004-325.82-320-325.82zM512 756.368c-132.002 0-240-109.976-240-244.368 0-40.726 10-79.418 27.998-114.040l-57.998-59.052c-32.002 48.872-50 109.964-50 173.092 0 179.198 144.004 325.82 320 325.82v122.18l160-162.906-160-162.914v122.188z"
    ],
    "grid": 0,
    "tags": [
      "md-sync"
    ]
  },
  {
    "paths": [
      "M64 240c0 85.8 0 444.6 0 544 0 26.6 21.4 48 48 48 60.8 0 742 0 800 0 26.6 0 48-21.4 48-48v-544c0-26.6-21.4-48-48-48-58 0-739.4 0-800 0-26.6 0-48 21.4-48 48zM832 256v512h-672v-512h672zM924 512c0 15.4-13 28-28.2 28-15 0-28-12.4-28-28 0-15.4 12.8-28.2 28-28.2 15.2 0.2 28.2 12.8 28.2 28.2z"
    ],
    "grid": 0,
    "tags": [
      "md-tablet-landscape"
    ]
  },
  {
    "paths": [
      "M784 64c-85.8 0-444.6 0-544 0-26.6 0-48 21.4-48 48 0 60.8 0 742 0 800 0 26.6 21.4 48 48 48h544c26.6 0 48-21.4 48-48 0-58 0-739.4 0-800 0-26.6-21.4-48-48-48zM768 832h-512v-672h512v672zM512 924c-15.4 0-28-13-28-28.2 0-15 12.4-28 28-28 15.4 0 28.2 12.8 28.2 28-0.2 15.2-12.8 28.2-28.2 28.2z"
    ],
    "grid": 0,
    "tags": [
      "md-tablet-portrait"
    ]
  },
  {
    "paths": [
      "M767.6 184.4c-70.6-55.4-159.4-88.4-255.6-88.4-96 0-184.6 33-255.2 88 83.2 89.6 128.6 206 128 328.6-0.6 122-46.6 237.2-129.8 325.8 70.8 56 160.2 89.6 257 89.6 97 0 186.6-33.6 257.6-90-83-88.6-129-203.6-129.6-325.4-0.6-122.4 44.6-238.6 127.6-328.2z",
      "M706.2 510.2c0 53.8 10.2 106 30.2 155.6 19.2 47.2 46.6 89.8 81.6 127.2 68.2-74.2 110-173 110-281 0-109-42.4-208.4-111.6-282.8-34.2 37-61.2 79.2-80 125.4-20 49.6-30.2 102-30.2 155.6z",
      "M318.6 510.2c0-53.8-10.2-106-30.2-155.6-18.8-46.4-45.8-88.8-80.4-125.8-69.4 74.4-112 174-112 283.2 0 108.4 42 207.2 110.4 281.4 35.2-37.4 62.8-80.2 82-127.6 20-49.4 30.2-101.8 30.2-155.6z"
    ],
    "grid": 0,
    "tags": [
      "md-tennisball"
    ]
  },
  {
    "paths": [
      "M816 128h-624c-44.004 0-64 35.996-64 80v688l128-128h560c44.004 0 80-35.996 80-80v-480c0-44.004-35.996-80-80-80zM396.8 484h-76.8v-80h76.8v80zM550.4 484h-76.8v-80h76.8v80zM704 484h-76.8v-80h76.8v80z"
    ],
    "grid": 0,
    "tags": [
      "md-text"
    ]
  },
  {
    "paths": [
      "M606 600.4v-443.6c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-97.8 95.6-97.8 167.4 0 106 86 192 192 192s192-86 192-192c0-72-40.2-134.6-98.2-167.6zM480 156.8c0-16 15.4-29 32-29s32 13 32 29v99.2h-64v-99.2z"
    ],
    "grid": 0,
    "tags": [
      "md-thermometer"
    ]
  },
  {
    "paths": [
      "M628 128h-344c-31.4 0-57.2 19.2-68.4 46.8l-114.4 270.8c-3.4 8.8-5.2 18-5.2 28v77.2c0 42.2 34 89.2 75.6 89.2h238.6l-36 163-1.2 12c0 15.8 6.4 30.2 16.6 40.6l40 40.2 252.4-254.4c13.6-13.8 22-33 22-54.2v-384c0-42.2-34.4-75.2-76-75.2z",
      "M800 128h128v448h-128v-448z"
    ],
    "grid": 0,
    "tags": [
      "md-thumbs-down"
    ]
  },
  {
    "paths": [
      "M396 896h344c31.4 0 57.2-19.2 68.4-46.8l114.2-270.8c3.4-8.8 5.2-18 5.2-28v-77.2c0-42.2-34-89.2-75.6-89.2h-238.4l36-163 1.2-12c0-15.8-6.4-30.2-16.6-40.6l-40.4-40.4-252 254.6c-13.6 13.8-22 33-22 54.2v384c0 42.2 34.4 75.2 76 75.2z",
      "M96 448h128v448h-128v-448z"
    ],
    "grid": 0,
    "tags": [
      "md-thumbs-up"
    ]
  },
  {
    "paths": [
      "M786.4 322.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 100.4 201 224 201h136v-206h198.2l-66.4 134h66.2l-36 72h187.4c103 0 186.6-60 186.6-163.6 0-98.8-76.6-179.2-173.6-186z",
      "M424 736h44v192l118-256h-162z"
    ],
    "grid": 0,
    "tags": [
      "md-thunderstorm"
    ]
  },
  {
    "paths": [
      "M511.6 96c-229.6 0-415.6 186.4-415.6 416s186 416 415.6 416c230 0 416.4-186.4 416.4-416s-186.4-416-416.4-416zM512 844.8c-183.8 0-332.8-149-332.8-332.8s149-332.8 332.8-332.8 332.8 149 332.8 332.8-149 332.8-332.8 332.8z",
      "M532.8 304h-62.4v249.6l218.4 131 31.2-51.2-187.2-111v-218.4z"
    ],
    "attrs": [
      {
        "opacity": 0.9
      },
      {
        "opacity": 0.9
      }
    ],
    "grid": 0,
    "tags": [
      "md-time"
    ]
  },
  {
    "paths": [
      "M465.8 743.2c0 25.4 20.8 46.2 46.2 46.2s46.2-20.8 46.2-46.2c0-25.4-20.8-46.2-46.2-46.2s-46.2 20.6-46.2 46.2zM465.8 96v184.8h92.4v-88.6c156.6 22.6 277.4 156.6 277.4 319.8 0 178.8-144.6 323.6-323.6 323.6s-323.6-144.8-323.6-323.6c0-77.6 27.2-148.8 73-204.4l250.6 250.6 65.2-65.2-314.4-314.2v1c-101.2 75.6-166.8 195.8-166.8 332.2 0 229.8 185.8 416 416 416 229.8 0 416-186.2 416-416s-186.2-416-416-416h-46.2zM789.4 512c0-25.4-20.8-46.2-46.2-46.2s-46.2 20.8-46.2 46.2 20.8 46.2 46.2 46.2c25.4 0 46.2-20.8 46.2-46.2zM234.6 512c0 25.4 20.8 46.2 46.2 46.2s46.2-20.8 46.2-46.2-20.8-46.2-46.2-46.2-46.2 20.8-46.2 46.2z"
    ],
    "grid": 0,
    "tags": [
      "md-timer"
    ]
  },
  {
    "paths": [
      "M160 693.332c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668s-352 21.336-352 170.668v426.664zM512 752c-44.004 0-80-35.994-80-79.998s35.996-80.002 80-80.002 80 35.998 80 80.002-35.996 79.998-80 79.998zM768 448h-512v-192h512v192z"
    ],
    "grid": 0,
    "tags": [
      "md-train"
    ]
  },
  {
    "paths": [
      "M704 64v70h126.2l-162.8 161c-15-14.4-26.4-22-26.4-22-36.6-25.8-81-41-129-41-60.4 0-115.2 24-155.6 62.8l-30.4-30 62.8-62.8-57-57-63 63-75-74h126.2v-70h-256v256h70v-137.4l80.6 79.8-62.4 62.4 57 57 62.8-62.8 38.8 38.4c-14.6 29.8-23 63.4-23 99 0 109.6 79 200.8 182.2 220.4v90.6h-126v80.6h126v112h84v-112h126v-80.4h-126v-90.6c101.6-19.8 182.4-111 182.4-220.6 0-35.4-8.4-69.6-23-99.2l176.6-174.6v137.4h70v-256h-256zM512 580c-70.6 0-128-57.4-128-128s57.4-128 128-128c70.6 0 128 57.4 128 128s-57.4 128-128 128z"
    ],
    "grid": 0,
    "tags": [
      "md-transgender"
    ]
  },
  {
    "paths": [
      "M256 810.858c0 46.834 38.396 85.142 85.334 85.142h341.334c46.936 0 85.332-38.308 85.332-85.142v-490.858h-512v490.858zM832 192h-160l-53.57-64h-212.858l-53.572 64h-160v64h640v-64z"
    ],
    "grid": 0,
    "tags": [
      "md-trash"
    ]
  },
  {
    "paths": [
      "M960 794v-269l-102.6 102.6-282.2-282-179.2 179.4-268.8-269-63.2 63.2 332 332.6 179.2-179.4 218.6 218.8-102.6 102.8h268.8z"
    ],
    "grid": 0,
    "tags": [
      "md-trending-down"
    ]
  },
  {
    "paths": [
      "M691.2 256l102.6 102.6-218.6 218.8-179.2-179.2-332 332.6 63.2 63.2 268.8-269 179.2 179.4 282.2-282 102.6 102.6v-269h-268.8z"
    ],
    "grid": 0,
    "tags": [
      "md-trending-up"
    ]
  },
  {
    "paths": [
      "M784 210c1.8-54 0.4-112 0.2-114h-545.6c0 2-1.6 60 0.2 114h-142.8c0 136 19.8 204.6 42 253.4s52.8 90.6 117.4 140.6c60.2 46.6 191 107.2 208.6 115.2v56.6c-9.2 20-47 56.4-166.6 56.4h-41.4v96h512v-96h-51.4c-121.4 0-150-38.2-156.6-56.4v-56.6c18.6-9.2 161.8-80.6 208.8-115 50.4-36.8 101.8-103 117.4-140.6s41.8-129.6 41.8-253.6h-144zM219.2 423.8c-17.6-36.4-28-75.8-31.4-123.8h57.4c1.4 12 2.8 22.6 4.6 32.6 13.2 78.4 29.6 140.4 51.4 193-34.6-27-62.6-61.6-82-101.8zM804.8 423.8c-19.8 40.6-48 75.4-83.2 102.6 22-52.4 38-113.6 51.6-193.8 1.6-10 3.2-20.6 4.6-32.6h58.6c-3.6 48-13.8 87.4-31.6 123.8z"
    ],
    "grid": 0,
    "tags": [
      "md-trophy"
    ]
  },
  {
    "paths": [
      "M820.2 488.2c24 0 53.2 21.8 67.6 51.8h40.2c-0.6-100-42.4-203-118.8-281.8-72.6-74.8-166-121-265.2-131.4-6-18-23-30.8-43.2-30.8-20 0-37 13-43 30.6-207.2 21-361.8 192.8-361.8 405.8 0 2.2 0.2 3.6 0.8 7.6h43.6c13.6-30 44.4-51.8 70.6-51.8 34 0 63 21.8 73 51.8h39.6c8.2-30 33.8-51.4 66-51.4 35.6 0 66.2 29 68.2 65.2v236.6c0 18.6 0.2 48.2-26.8 48.2-13.8 0-33.2-3.6-33.2-32v-42.6h-86v42.6c0 69.2 47.2 121.4 120 121.4 39 0 66.6-17 87-37.4 26.2-26.4 27-69.4 27-100.2v-238.2c4-51.6 47.8-63.4 83.8-63.4 34.4 0 64.6 23.2 75.6 51.2h41c10.2-30 39.6-51.8 74-51.8z"
    ],
    "grid": 0,
    "tags": [
      "md-umbrella"
    ]
  },
  {
    "paths": [
      "M524.6 359.2c-115.8 0-220.6 43.2-301.4 113.6l-159.2-152.8v384h395l-158.2-153.6c60.8-50.6 138-82.2 223.6-82.2 154.6 0 286.2 96.4 332 235.6l103.6-29.6c-60.8-182.8-232.4-315-435.4-315z"
    ],
    "grid": 0,
    "tags": [
      "md-undo"
    ]
  },
  {
    "paths": [
      "M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200h75.996c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004h-0.004v80h-364c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80z"
    ],
    "grid": 0,
    "tags": [
      "md-unlock"
    ]
  },
  {
    "paths": [
      "M768 439v-170.4c0-26.8-22.4-48.6-49.8-48.6h-604.4c-27.4-0-49.8 21.8-49.8 48.6v486.6c0 26.8 22.4 48.8 49.8 48.8h604.4c27.4 0 49.8-22 49.8-48.6v-170.4l192 194.6v-535.2l-192 194.6z"
    ],
    "grid": 0,
    "tags": [
      "md-videocam"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546z"
    ],
    "grid": 0,
    "tags": [
      "md-volume-down"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668z"
    ],
    "grid": 0,
    "tags": [
      "md-volume-mute"
    ]
  },
  {
    "paths": [
      "M811 512c0 45.434-9.766 88.724-27.206 127.71l63.76 63.76c31.012-56.81 48.446-122.164 48.446-191.47 0-186.512-128-344.508-298-384v89.956c124 37.308 213 155.808 213 294.044z",
      "M512 160.916l-102.042 104.96 102.042 102.038z",
      "M841.684 793.77l-659.452-659.456-48 48 180.998 180.826-16.56 20.86h-170.67v256h170.668l213.332 223.086v-303.086l189.83 189.372c-30.24 25.514-65.83 45.054-103.83 56.672v89.956c62-14.344 117.992-44.326 164.63-85.618l79.22 79.386 48-48.086-48.004-48.078-0.162 0.166z",
      "M704.376 512c0-76.798-42.376-144.814-106.376-177.726v119.64l101.602 101.602c3.108-14.038 4.774-28.608 4.774-43.516z"
    ],
    "grid": 0,
    "tags": [
      "md-volume-off"
    ]
  },
  {
    "paths": [
      "M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546zM597.334 128v89.956c123.728 37.308 213.334 155.808 213.334 294.044 0 138.238-89.606 256.738-213.334 294.044v89.956c170.666-39.492 298.666-197.486 298.666-384 0-186.512-128-344.508-298.666-384z"
    ],
    "grid": 0,
    "tags": [
      "md-volume-up"
    ]
  },
  {
    "paths": [
      "M576 224c44.446 0 79.994-35.552 79.994-80 0-44.45-35.548-80-79.994-80s-80.006 35.55-80.006 80c0 44.448 35.56 80 80.006 80z",
      "M576 464h208v-80h-144l-89.604-138.666c-15.396-23.334-36.272-36.272-61.866-36.272-6.396 0-17.656 1.062-25.598 3.494l-222.932 75.444v224h80v-160l81.062-32-161.062 640h80l113.396-328.542 100.604 136.542v192h76v-256l-114.062-192 39.49-123.728 40.572 75.728z"
    ],
    "grid": 0,
    "tags": [
      "md-walk"
    ]
  },
  {
    "paths": [
      "M64 928h896l-448-832-448 832zM560 800h-96v-96h96v96zM560 640h-96v-192h96v192z"
    ],
    "grid": 0,
    "tags": [
      "md-warning"
    ]
  },
  {
    "paths": [
      "M832 512c0-102.002-48.008-192.002-121.992-250l-38.008-230h-320l-38.008 230c-73.984 57.998-121.992 147.998-121.992 250 0 101.992 48.008 191.992 121.992 250l38.008 230h320l38.008-230c73.984-58.008 121.992-148.008 121.992-250zM272 512c0-132.002 108.008-240 240-240s240 107.998 240 240c0 131.992-108.008 240-240 240s-240-108.008-240-240z"
    ],
    "grid": 0,
    "tags": [
      "md-watch"
    ]
  },
  {
    "paths": [
      "M761 326.6l-249-262.6-249 262.6c-137.2 144.8-137.2 380 0 524.8 68.6 72.4 158.8 108.6 249 108.6s180.4-36.2 249-108.6c137.4-144.8 137.4-380 0-524.8z"
    ],
    "grid": 0,
    "tags": [
      "md-water"
    ]
  },
  {
    "paths": [
      "M512 457.438c-45.758 0-83.194 37.058-83.194 82.36 0 45.304 37.436 82.364 83.194 82.364 45.756 0 83.194-37.058 83.194-82.364 0-45.302-37.438-82.36-83.194-82.36zM761.6 539.796c0-135.892-112.326-247.078-249.6-247.078s-249.6 111.186-249.6 247.078c0 90.606 49.922 170.894 124.792 214.144l41.614-72.064c-49.944-28.834-83.208-80.306-83.208-142.080 0-90.59 74.866-164.716 166.402-164.716 91.542 0 166.402 74.126 166.402 164.716 0 61.774-33.266 113.246-83.208 142.080l41.614 72.064c74.866-43.248 124.792-123.538 124.792-214.144zM512 128c-228.806 0-416 185.308-416 411.796 0 152.374 83.184 284.14 208 356.204l41.598-72.064c-99.838-57.648-166.414-162.648-166.414-284.138 0-181.186 149.782-329.436 332.816-329.436s332.812 148.25 332.812 329.436c0 121.49-66.568 228.542-166.41 284.138l41.598 72.064c124.812-72.064 208-203.83 208-356.204 0-226.488-187.194-411.796-416-411.796z"
    ],
    "grid": 0,
    "tags": [
      "md-wifi"
    ]
  },
  {
    "paths": [
      "M469.334 554.666v261.334h-213.334v80h512v-80h-213.334v-261.334l341.334-341.332v-85.334h-768v85.334l341.334 341.332zM320 298.666l-85.334-85.332h554.668l-85.334 85.332h-384z"
    ],
    "grid": 0,
    "tags": [
      "md-wine"
    ]
  },
  {
    "paths": [
      "M380.8 297.2l-58.8 208.6c-12.6 45.6 41.4 63.4 54.6 20.6l52.6-192.4h14.8l-90.4 338h84.4v254c0 46 64 46 64 0v-254h20v254c0 46 62 46 62 0v-254h86.8l-92.4-338h16.8l52.6 192.4c13 43.8 66.6 25 54.6-20.4l-58.8-208.8c-8-23.6-36.4-65.2-84-67.2h-94.6c-49.2 2-77.4 43.2-84.2 67.2z",
      "M585.2 138.4c0-41.2-32.8-74.6-73.2-74.6s-73.2 33.4-73.2 74.6c0 41.2 32.8 74.6 73.2 74.6s73.2-33.4 73.2-74.6z"
    ],
    "grid": 0,
    "tags": [
      "md-woman"
    ]
  },
  {
    "paths": [
      "M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21 20.8c-51.4-38.8-114-64-182-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-67.8 5.8-130.2 31-181.4 69.8l-20.8-20.8 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 24.6 20.4 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM152.4 335.6c-8.4-17.2-12.8-36.8-13-56-0.2-70.2 56.8-129.2 131-133.6 25.4-1.4 46.2 2.8 64.2 12.2l-182.2 177.4zM831.8 553c0 175.4-144 314.2-320.2 314.2-176 0-319.6-138.8-319.6-314.2s143.6-317.4 319.8-317.4c176.2-0 320 141.8 320 317.4zM689.4 158.4c17.6-9.6 38.6-13.6 64.2-12.2 74.4 4 131.2 63 131 133.6 0 19.2-4.6 38.8-13 56.2l-182.2-177.6z",
      "M512 320v256h-192v32h224v-288z"
    ],
    "grid": 0,
    "tags": [
      "ios-alarm-outline"
    ]
  },
  {
    "paths": [
      "M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21.2 20.8c-51.4-38.8-114.4-64-182.4-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-68 5.8-130 31-181.2 69.8l-20.8-20.6 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 25 20.2 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM544 608h-224v-32h192v-256h32v288z"
    ],
    "grid": 0,
    "tags": [
      "ios-alarm"
    ]
  },
  {
    "paths": [
      "M928 288v576h-832v-576h832zM960 256h-896v640h896v-640z",
      "M144 192h736v32h-736v-32z",
      "M208 128h608v32h-608v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-albums-outline"
    ]
  },
  {
    "paths": [
      "M960 256h-896v640h896v-640z",
      "M144 192h736v32h-736v-32z",
      "M208 128h608v32h-608v-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-albums"
    ]
  },
  {
    "paths": [
      "M704 256.8l-64.6-64.8-319.4 320 319.4 320 64.6-64.8-254.6-255.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-arrow-back"
    ]
  },
  {
    "paths": [
      "M96 768h160v-32h-128v-448h128v-32h-160z",
      "M768 256v32h128v448h-128v32h160v-512z",
      "M224 384h32v256h-32v-256z",
      "M768 384h32v256h-32v-256z",
      "M640 320h32v384h-32v-384z",
      "M352 320h32v384h-32v-384z",
      "M494 352h32v320h-32v-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-barcode-outline"
    ]
  },
  {
    "paths": [
      "M96 256v512h832v-512h-832zM256 640h-32v-256h32v256zM384 704h-32v-384h32v384zM526 672h-32v-320h32v320zM672 704h-32v-384h32v384zM800 640h-32v-256h32v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-barcode"
    ]
  },
  {
    "paths": [
      "M925.372 558.738c0.264-2.364 0.514-4.73 0.738-7.108 0.008-0.076 0.014-0.156 0.022-0.234 1.218-12.97 1.868-26.106 1.868-39.396 0-229.726-186.26-416-416-416-15.902 0-31.584 0.924-47.024 2.662-0.178 0.020-0.36 0.036-0.54 0.056 0 0.002 0 0.004 0 0.006-194.022 22.094-347.552 177.674-366.458 372.65-0.002 0-0.006 0-0.008 0-0.144 1.496-0.262 2.994-0.39 4.492-0.272 3.152-0.506 6.314-0.706 9.486-0.052 0.836-0.112 1.67-0.16 2.508-0.128 2.242-0.232 4.49-0.326 6.742-0.022 0.562-0.042 1.124-0.064 1.686-0.194 5.214-0.324 10.448-0.324 15.712 0 229.726 186.274 416 416 416 5.254 0 10.478-0.13 15.686-0.324 0.586-0.022 1.172-0.042 1.756-0.066 2.22-0.092 4.438-0.196 6.648-0.32 0.908-0.050 1.812-0.116 2.718-0.172 3.208-0.206 6.402-0.444 9.59-0.72 1.408-0.122 2.82-0.23 4.226-0.368 0-0.002 0-0.006 0-0.008 194.988-18.904 350.558-172.432 372.652-366.458 0.002 0 0.004 0 0.008 0 0.032-0.274 0.056-0.55 0.088-0.826zM893.33 512c0 5.136-0.132 10.244-0.334 15.332-20.668-0.936-41.104-3.38-61.228-7.328l12.22-38.112-30.464-9.768-12.976 40.47c-15.182-4.224-30.16-9.302-44.884-15.276-9.952-4.036-19.702-8.446-29.25-13.208l23.036-34.006-26.494-17.948-24.718 36.492c-24.482-14.7-47.406-31.954-68.61-51.624l29.46-29.46-22.626-22.626-29.46 29.46c-19.11-20.594-35.928-42.816-50.35-66.508l36.974-25.044-17.944-26.492-34.648 23.47c-5.194-10.262-9.996-20.75-14.348-31.48-5.686-14.018-10.552-28.268-14.654-42.704l41.624-13.346-9.77-30.468-39.422 12.64c-4.208-20.846-6.82-42.028-7.792-63.458 5.088-0.202 10.194-0.334 15.33-0.334 210.262-0.004 381.328 171.064 381.328 381.326zM130.674 512c0-2.634 0.046-5.258 0.1-7.878 18.128 1.118 36.078 3.374 53.782 6.818l-14.23 44.382 30.47 9.77 15-46.782c15.384 4.256 30.56 9.392 45.476 15.442 10.35 4.198 20.478 8.808 30.394 13.792l-26.81 39.58 26.492 17.946 28.438-41.984c24.076 14.558 46.64 31.586 67.53 50.966l-33.706 33.706 22.626 22.628 33.708-33.708c19.936 21.488 37.4 44.738 52.228 69.592l-41.506 28.116 17.944 26.492 38.946-26.38c4.566 9.222 8.8 18.634 12.694 28.232 6.322 15.59 11.668 31.458 16.032 47.556l-45.664 14.64 9.768 30.466 43.062-13.806c3.216 17.012 5.358 34.244 6.43 51.644-2.622 0.052-5.244 0.1-7.878 0.1-210.26-0.002-381.328-171.070-381.326-381.33zM551.786 891.258c-1.242-19.948-3.822-39.822-7.718-59.492l48.2-15.454-9.768-30.464-45.792 14.682c-7.892-28.83-18.712-57.020-32.468-84.108l40.344-27.328-17.946-26.492-37.976 25.724c-15.776-26.188-34.466-51.104-56.080-74.29l34.162-34.162-22.626-22.626-34.164 34.162c-22.576-21.042-46.786-39.32-72.216-54.828l25.392-37.486-26.492-17.944-26.892 39.7c-27.096-13.948-55.318-24.934-84.188-32.988l14.316-44.65-30.47-9.77-15.040 46.904c-20.362-4.136-40.954-6.848-61.62-8.134 18.336-176.074 156.984-316.908 332.046-338.622 1.148 23.716 4.19 47.352 9.086 70.678l-51.87 16.632 9.77 30.468 49.806-15.97c8.090 28.288 19.008 55.934 32.772 82.492l-44.644 30.242 17.946 26.492 42.472-28.77c15.376 25.056 33.47 48.91 54.232 71.18l-38.408 38.408 22.626 22.628 38.408-38.41c22.894 21.338 47.47 39.842 73.294 55.49l-29.11 42.972 26.496 17.948 30.656-45.256c26.56 13.578 54.2 24.31 82.458 32.236l-16.336 50.954 30.464 9.768 17.050-53.18c22.602 4.624 45.488 7.508 68.448 8.62-21.712 175.060-162.546 313.706-338.62 332.044z"
    ],
    "grid": 0,
    "tags": [
      "ios-baseball-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-16.088 0-31.95 0.946-47.564 2.722v0 0c-207.326 23.61-368.436 199.638-368.436 413.278 0 229.726 186.274 416 416 416 213.654 0 389.666-161.106 413.276-368.436v0 0c1.778-15.61 2.724-31.474 2.724-47.564 0-229.726-186.26-416-416-416zM519.878 893.228c-1.078-17.386-3.21-34.61-6.418-51.608l-43.022 13.792-9.77-30.468 45.624-14.628c-4.366-16.112-9.712-31.988-16.040-47.588-3.886-9.588-8.122-18.994-12.682-28.21l-38.928 26.372-17.944-26.494 41.488-28.108c-14.832-24.858-32.298-48.114-52.238-69.606l-33.704 33.706-22.626-22.626 33.704-33.704c-20.884-19.378-43.442-36.404-67.514-50.96l-28.432 41.976-26.494-17.946 26.806-39.576c-9.92-4.982-20.054-9.598-30.412-13.8-14.91-6.042-30.076-11.18-45.45-15.434l-15 46.784-30.472-9.77 14.23-44.384c-17.712-3.446-35.67-5.706-53.808-6.824 0.218-10.746 0.876-21.39 1.968-31.906 20.678 1.294 41.278 3.996 61.654 8.136l15.036-46.908 30.474 9.772-14.318 44.656c28.866 8.054 57.084 19.042 84.18 32.988l26.898-39.708 26.496 17.946-25.4 37.496c25.424 15.508 49.63 33.784 72.2 54.822l34.164-34.164 22.628 22.628-34.166 34.164c21.618 23.19 40.312 48.11 56.088 74.302l37.998-25.738 17.946 26.496-40.366 27.34c13.756 27.092 24.578 55.284 32.464 84.116l45.838-14.698 9.77 30.472-48.244 15.468c3.894 19.656 6.462 39.522 7.708 59.454-10.518 1.096-21.164 1.75-31.914 1.97zM821.922 550.586l-17.058 53.208-30.472-9.77 16.348-50.986c-28.248-7.928-55.88-18.658-82.436-32.232l-30.67 45.282-26.496-17.946 29.128-42.998c-25.824-15.652-50.398-34.154-73.288-55.492l-38.41 38.408-22.624-22.628 38.404-38.406c-20.762-22.27-38.854-46.124-54.228-71.18l-42.496 28.786-17.948-26.496 44.67-30.254c-13.762-26.556-24.678-54.198-32.768-82.482l-49.836 15.98-9.77-30.474 51.902-16.642c-4.894-23.326-7.886-46.964-9.044-70.674 10.378-1.288 20.892-2.136 31.508-2.568 1.014 21.486 3.718 42.668 7.944 63.614l39.488-12.718 9.814 30.424-41.578 13.316c4.102 14.436 8.982 28.676 14.666 42.696 4.352 10.726 9.156 21.206 14.348 31.462l34.63-23.458 17.946 26.492-36.954 25.032c14.418 23.692 31.238 45.914 50.348 66.508l29.458-29.462 22.628 22.626-29.464 29.462c21.204 19.672 44.124 36.926 68.604 51.626l24.704-36.47 26.496 17.946-23.024 33.988c9.554 4.766 19.312 9.178 29.27 13.216 14.708 5.964 29.674 11.042 44.842 15.262l12.968-40.44 30.466 9.77-12.208 38.086c20.232 3.968 40.572 6.622 61.252 7.648-0.43 10.624-1.286 21.144-2.57 31.536-22.972-1.128-45.874-3.97-68.49-8.598z"
    ],
    "grid": 0,
    "tags": [
      "ios-baseball"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM893.328 512c0 0.096-0.004 0.194-0.004 0.29-44.63-3.442-87.978-13.944-129.24-31.398-35.776-15.132-68.906-35.010-98.958-59.268 41.38-59.002 76.884-122.424 105.648-189.43 75.316 69.706 122.554 169.338 122.554 279.806zM745.212 210.522c-0.56 1.352-1.1 2.708-1.67 4.056-27.816 65.766-62.124 127.912-102.572 185.974-3.076-2.898-6.126-5.828-9.126-8.826-38.214-38.214-68.214-82.708-89.166-132.24-17.394-41.126-27.866-84.326-31.342-128.802 0.222 0 0.442-0.008 0.664-0.008 87.768-0.002 168.694 29.822 233.212 79.846zM479.35 132.088c8.862 116.252 62.088 220.082 142.782 294.624-18.99 25.498-39.218 50.152-60.638 73.93-95.108-100.064-209.63-181.492-337.534-238.264 63.272-72.912 153.706-121.628 255.39-130.29zM561.374 547.68c72.458 81.34 130.96 172.876 174.37 272.906-50.8 36.934-111.020 61.658-176.324 69.796-4.544-95.632-39.042-183.414-94.358-254.142 33.904-27.526 66.074-57.106 96.312-88.56zM524.078 540.078c-25.408 25.406-51.954 49.324-79.556 71.74-77.474-85.77-187.662-141.412-310.9-147.27 8.14-65.292 32.864-125.5 69.792-176.292 118.39 51.376 224.89 123.894 316.664 215.666 6.646 6.646 13.18 13.378 19.624 20.178-5.148 5.372-10.348 10.702-15.624 15.978zM131.016 496.46c50.476 2.29 98.872 13.594 142.9 32.218 49.534 20.952 94.026 50.952 132.24 89.166 4.508 4.508 8.89 9.11 13.168 13.79-62.828 47.83-130.854 88.098-203.416 120.364-53.264-65.588-85.236-149.124-85.236-239.998 0-5.208 0.136-10.382 0.344-15.54zM238.134 777.052c71.976-32.868 139.62-73.574 201.828-121.042 22.498 28.744 41.044 60.23 55.36 94.074 19.228 45.458 30.026 93.448 32.228 142.9-5.16 0.208-10.34 0.344-15.55 0.344-107.366 0-204.498-44.622-273.866-116.276zM761.62 800.042c-44.978-101.342-105.44-194.28-178.382-275.818 22.202-24.538 43.268-50.122 63.112-76.672 68.342 54.684 153.042 89.77 245.602 96.726-8.58 101.838-57.33 192.416-130.332 255.764z"
    ],
    "grid": 0,
    "tags": [
      "ios-basketball-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM761.594 800.064c-8.316 7.216-16.96 14.058-25.884 20.544-43.408-100.030-101.876-191.59-174.336-272.93-30.236 31.456-62.406 61.036-96.312 88.56 55.318 70.728 89.832 158.508 94.378 254.138-10.504 1.31-21.142 2.172-31.888 2.606-2.206-49.454-13-97.442-32.228-142.9-14.316-33.844-32.862-65.33-55.36-94.074-62.208 47.466-129.846 88.186-201.82 121.052-7.766-8.022-15.184-16.382-22.23-25.058 72.56-32.268 140.582-72.542 203.41-120.372-4.278-4.68-8.66-9.282-13.168-13.79-38.214-38.214-82.708-68.214-132.24-89.166-44.030-18.624-92.424-29.928-142.9-32.216 0.434-10.758 1.296-21.406 2.606-31.918 123.24 5.858 233.426 61.506 310.9 147.276 27.604-22.416 54.15-46.334 79.556-71.74 5.276-5.276 10.476-10.606 15.624-15.976-6.446-6.8-12.978-13.534-19.624-20.18-91.774-91.772-198.274-164.29-316.664-215.664 6.486-8.922 13.33-17.564 20.544-25.878 127.902 56.774 242.424 138.202 337.534 238.264 21.422-23.778 41.648-48.432 60.638-73.93-80.694-74.542-133.912-178.376-142.776-294.624 10.546-0.898 21.208-1.384 31.98-1.404 3.476 44.476 13.948 87.676 31.342 128.802 20.952 49.534 50.952 94.026 89.166 132.24 3 3 6.050 5.93 9.124 8.826 40.452-58.062 74.758-120.208 102.574-185.974 0.57-1.348 1.11-2.706 1.67-4.056 8.838 6.852 17.362 14.084 25.558 21.67-28.766 67.004-64.264 130.43-105.644 189.432 30.052 24.26 63.182 44.136 98.958 59.27 41.262 17.454 84.61 27.956 129.24 31.396-0.008 10.774-0.486 21.434-1.376 31.982-92.556-6.958-177.262-42.036-245.602-96.718-19.844 26.55-40.91 52.134-63.112 76.672 72.95 81.54 133.382 174.494 178.362 275.838z"
    ],
    "grid": 0,
    "tags": [
      "ios-basketball"
    ]
  },
  {
    "paths": [
      "M512 95.918c35.29 0 64 28.702 64 63.982s-28.71 63.98-64 63.98-64-28.702-64-63.98c0-35.28 28.71-63.982 64-63.982zM512 63.928c-53.020 0-96 42.966-96 95.972 0 53.004 42.98 95.97 96 95.97s96-42.966 96-95.97c0-53.006-42.98-95.972-96-95.972v0z",
      "M848 288h-672c-26.51 0-48 21.494-48 48s21.49 48 48 48h200.902c11.098 0 26.394 8.59 34.432 29.416 9.302 24.11 4.74 66.66-1.078 102.888l-7.846 42.52c-0.038 0.208-0.41 0.2-0.41 0.406l-64.458 344.476c-4.606 26.102 12.974 50.988 39.080 55.594 2.816 0.496 5.688 0.734 8.436 0.734 22.714 0 41.834-16.38 45.94-39.672l41.002-239.878v0.332c0 0 14.5-62.816 38.904-62.816h2.192c24.904 0 34.904 62.816 34.904 62.816v-0.164l42.966 239.79c4.104 23.284 24.662 39.63 47.526 39.63 2.774 0 5.71-0.242 8.536-0.736 26.106-4.606 43.642-29.52 39.038-55.622l-64.698-344.502c-0.004-0.016 0.022-0.040 0.018-0.054-0.038-0.208-0.064-0.434-0.104-0.644l-7.542-42.822c-5.818-36.238-10.376-78.166-1.076-102.274 8.038-20.828 24.336-29.418 34.434-29.418h200.902c26.51 0 48-21.494 48-48s-21.49-48-48-48zM176 352.226c-8.822 0-16-7.292-16-16.114s7.178-16.114 16-16.114h672c8.822 0 16 7.18 16 16s-7.178 16-16 16h-203c-31.076 0-54.876 29.476-61.964 47.844-9.692 25.114-10.008 63.884-0.776 121.376l-0.018 0.208 0.012 0.22 6.734 38.276 1.124 6.482 64.504 343.256c1 5.668-1.24 9.922-2.664 11.954-1.426 2.034-4.67 5.598-10.358 6.602-0.952 0.166-1.91 0.252-2.854 0.252-7.786 0-14.414-5.278-15.766-12.944l-42.464-239.524h-0.030c-0.542-4-3.656-20.1-10.044-37.542-4.556-12.434-9.688-22.068-15.688-30.010-14.182-18.776-30.478-22.448-41.652-22.448h-2.192c-10.94 0-27.006 3.462-41.42 21.876-6.1 7.792-11.458 17.342-16.38 29.604-7.256 18.074-11.010 35.308-11.416 37.226l-0.22 0.738-41.456 239.8c-1.386 7.772-7.5 13.192-14.882 13.192-0.918 0-1.864-0.086-2.806-0.254-5.68-1-8.91-4.55-10.33-6.576-1.418-2.026-3.648-6.272-2.646-11.95l64.87-345.016 7.594-42.91 0.042-0.252c9.258-57.658 9.054-96.6-0.664-121.782-7.086-18.362-27.152-47.474-63.52-47.474z"
    ],
    "grid": 0,
    "tags": [
      "ios-body-outline"
    ]
  },
  {
    "paths": [
      "M608 159.676c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z",
      "M848 288h-672c-26.51 0-48 21.49-48 48s21.49 48 48 48h196.902c11.158 2 26.394 7.674 34.432 28.504 9.302 24.112 4.74 67.212-1.078 103.454l-7.55 42.79c-0.038 0.208-0.078 0.414-0.116 0.622-0.004 0.016-0.004 0.024-0.008 0.040l-60.75 344.536c-4.606 26.106 12.828 51 38.934 55.606 26.11 4.602 50.666-12.832 55.268-38.942l41.966-239.914v0.334c0 0 12.5-65.030 36.904-65.030h2.192c24.904 0 36.904 65.030 36.904 65.030v-0.166l41.966 239.826c4.602 26.11 29.326 43.498 55.436 38.896 26.106-4.606 43.456-29.524 38.85-55.628l-60.792-344.552c-0.004-0.016-0.026-0.040-0.030-0.054-0.038-0.208-0.088-0.434-0.126-0.644l-7.554-42.828c-5.818-36.242-10.382-79.262-1.082-103.376 8.040-20.828 23.272-26.504 34.43-28.504h196.902c26.51 0 48-21.49 48-48s-21.49-48-48-48z"
    ],
    "grid": 0,
    "tags": [
      "ios-body"
    ]
  },
  {
    "paths": [
      "M695.242 128c-81.882 0-158.242 28-183.156 88.99-27.086-60.99-101.27-88.99-183.154-88.99-110.402 0-200.932 51.96-200.932 158v566h44.28c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.234 128h39.428c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.106v-566c0-106.040-90.354-158-200.758-158zM496 821.852c-36-51.742-97.46-85.852-167-85.852-69.538 0-129 20.11-167 71.852l-2 1.074v-526.926c6-83.65 80.178-122 168.586-122 90.324 0 164.29 37.416 166.726 123.616-0.034 1.458 0.032 2.918 0.032 4.384l0.656 26.206v507.646zM864 296v511.852c-36-51.742-99.462-71.852-169-71.852-69.54 0-131 34.11-167 85.852v-533.852c0-88.224 75.318-128 167.174-128 88.406 0 162.826 22.35 168.826 106v30z"
    ],
    "grid": 0,
    "tags": [
      "ios-book-outline"
    ]
  },
  {
    "paths": [
      "M328.932 128c-110.4 0-200.932 51.96-200.932 158v566h44.282c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.232 128h3.836v-705.308c-34.48-42.79-98.038-62.692-167.068-62.692z",
      "M695.242 128c-68.664 0-133.426 19.702-167.242 62.022v705.978h3.594c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.104v-566c0-106.040-90.354-158-200.758-158z"
    ],
    "grid": 0,
    "tags": [
      "ios-book"
    ]
  },
  {
    "paths": [
      "M864 128h-300.8c-20.6 0-38.6 9.2-51.2 23.4v0 0c-12.4-14.4-30.6-23.4-51.2-23.4h-300.8c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64zM496 822.2c-9.4-15.6-27-22.2-47.6-22.2h-288.4c-18.8 0-32-17-32-35.8v-572.2c0-18.8 13.2-32 32-32 0 0 261.2 0 286.6 0 25.6 0 49.4 25.6 49.4 44.4v617.8zM640 160c37.6 0 86 0 128 0v200.8l-45.8-29-18.2-12.8-18.2 12.8-45.8 29v-200.8zM896 764.2c0 18.8-13.2 35.8-32 35.8h-288.4c-20.6 0-38.2 4.6-47.6 22.2v-617.8c0-18.8 23.8-44.4 49.4-44.4 4.4 0 15.4 0 30.6 0v262l96-64 96 64v-262c37.2 0 64 0 64 0 18.8 0 32 13.4 32 32v572.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-bookmarks-outline"
    ]
  },
  {
    "paths": [
      "M685.8 330.8l18.2-12.8 18.2 12.8 45.8 29v-231.8c-41.4 0-89 0-128 0v231.8l45.8-29z",
      "M864 128c0 0-26.6 0-64 0v293l-96-64-96 64v-293c-24.2 0-41.2 0-44.8 0-16.2 0-35.2 14.4-35.2 30s0 658 0 658l-16 11-16-11c0 0 0-644 0-658s-18.4-30-35.2-30-300.8 0-300.8 0c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-bookmarks"
    ]
  },
  {
    "paths": [
      "M832 256v-32h-64v32h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v-32h-64v32h-96v640h832v-640h-96zM384 255v-58.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-1zM896 864h-768v-448h768v448zM896 384h-768v-96h64v32h64v-32h512v32h64v-32h64v96z"
    ],
    "grid": 0,
    "tags": [
      "ios-briefcase-outline"
    ]
  },
  {
    "paths": [
      "M192 224h64v32h-64v-32z",
      "M96 416h832v480h-832v-480z",
      "M768 224h64v32h-64v-32z",
      "M832 256v64h-64v-64h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v64h-64v-64h-96v128h832v-128h-96zM640 255v1h-256v-59.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v58.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-briefcase"
    ]
  },
  {
    "paths": [
      "M128 288v608h607.8v-608h-607.8zM703.8 864h-543.8v-544h543.8v544z",
      "M896 128h-608v128h32v-96h544v544h-96v32h128z"
    ],
    "grid": 0,
    "tags": [
      "ios-browsers-outline"
    ]
  },
  {
    "paths": [
      "M128 288v608h607.8v-608h-607.8z",
      "M288 128v128h480v480h128v-608z"
    ],
    "grid": 0,
    "tags": [
      "ios-browsers"
    ]
  },
  {
    "paths": [
      "M288 320h448v-128h-448v128zM320 224h384v64h-384v-64z",
      "M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM768 832c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-640c0-17.6 14.4-32 32-32h448c17.6 0 32 14.4 32 32v640z",
      "M320 480v-96h-32v128h128v-32h-32z",
      "M320 640v-96h-32v128h128v-32h-32z",
      "M320 800v-96h-32v128h128v-32h-32z",
      "M480 480v-96h-32v128h128v-32h-32z",
      "M640 480v-96h-32v128h128v-32h-32z",
      "M480 640v-96h-32v128h128v-32h-32z",
      "M480 800v-96h-32v128h128v-32h-32z",
      "M640 800v-256h-32v288h128v-32h-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-calculator-outline"
    ]
  },
  {
    "paths": [
      "M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM720 560v256h-96v-256h96zM720 400v96h-96v-96h96zM560 720v96h-96v-96h96zM560 560v96h-96v-96h96zM560 400v96h-96v-96h96zM400 720v96h-96v-96h96zM400 560v96h-96v-96h96zM400 400v96h-96v-96h96zM304 304v-96h416v96h-416z"
    ],
    "grid": 0,
    "tags": [
      "ios-calculator"
    ]
  },
  {
    "paths": [
      "M128 384h768v512h-768v-512z",
      "M896 192h-192v96h-32v-96h-320v96h-32v-96h-192v160h768z",
      "M320 128h32v64h-32v-64z",
      "M672 128h32v64h-32v-64z"
    ],
    "grid": 0,
    "tags": [
      "ios-calendar"
    ]
  },
  {
    "paths": [
      "M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM864 733.4c0 18.6-12.4 34.6-29 34.6h-640c-17.4 0-35-17.4-35-34.6v-352c0-16.4 16.2-29.4 35-29.4h135.6l9.6-6.4c8-9 15.4-20 22.2-27.6 22.6-25.4 39-43.4 50.6-53.8 9.4-8.4 12.4-8.2 12.4-8.2h177c0 0 3.2-0.2 13.4 9 12.2 11 29.4 33 53.2 59.6 5.8 6.6 12 13.6 18.6 21l9.6 6.4h137.8c17.6 0 29 12 29 29.4v352z",
      "M512 379c-94.2 0-171 76.8-171 171s76.8 171 171 171 171-76.8 171-171-76.8-171-171-171zM512 689c-76.8 0-139-62.2-139-139s62.2-139 139-139 139 62.2 139 139-62.2 139-139 139z",
      "M704 384h34v34h-34v-34z",
      "M576 550c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-camera-outline"
    ]
  },
  {
    "paths": [
      "M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM512 721c-94.2 0-171-76.8-171-171s76.8-171 171-171 171 76.8 171 171-76.8 171-171 171zM738 418h-34v-34h34v34z",
      "M512 411c-76.8 0-139 62.2-139 139s62.2 139 139 139 139-62.2 139-139-62.2-139-139-139zM512 614c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-camera"
    ]
  },
  {
    "paths": [
      "M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM320 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z",
      "M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM769 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z",
      "M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256zM837.18 484.696l-521.202 91.98-63.464-352.6 607.738 61.216-23.072 199.404z"
    ],
    "grid": 0,
    "tags": [
      "ios-cart-outline"
    ]
  },
  {
    "paths": [
      "M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z",
      "M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z",
      "M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-cart"
    ]
  },
  {
    "paths": [
      "M128 128h512v192h32v-224h-576v448h224v-32h-192z",
      "M352 352v448h325.2l128 128h26.8v-128h96v-448h-576zM896 768h-96v109.2l-110-109.2h-306v-384h512v384z"
    ],
    "grid": 0,
    "tags": [
      "ios-chatboxes-outline"
    ]
  },
  {
    "paths": [
      "M672 96h-576v448h224v-224h352z",
      "M352 352v448h325.2l128 128h26.8v-128h96v-448h-576z"
    ],
    "grid": 0,
    "tags": [
      "ios-chatboxes"
    ]
  },
  {
    "paths": [
      "M732.39 424.244c2.37-13.056 3.612-26.504 3.612-40.244 0-123.712-100.29-224.002-224.002-224.002s-224.002 100.29-224.002 224.002c0 13.74 1.242 27.188 3.612 40.244-94.378 26.36-163.612 112.968-163.612 215.756 0 123.712 100.29 224.002 224.002 224.002 62.684 0 119.342-25.758 160-67.254 40.658 41.496 97.316 67.254 160 67.254 123.712 0 224.002-100.29 224.002-224.002 0-102.788-69.234-189.394-163.612-215.756zM319.998 384c0-105.87 86.13-192.002 192.002-192.002s192.002 86.132 192.002 192.002c0 11.552-1.026 22.87-2.99 33.866-9.498-1.228-19.18-1.868-29.012-1.868-62.684 0-119.342 25.758-160 67.254-40.658-41.496-97.316-67.254-160-67.254-9.832 0-19.514 0.638-29.012 1.868-1.964-10.996-2.99-22.314-2.99-33.866zM544.002 640c0 39.16-11.792 75.612-32.002 106.012-20.208-30.4-32.002-66.852-32.002-106.012 0-11.552 1.026-22.87 2.99-33.866 9.498 1.228 19.18 1.868 29.012 1.868s19.514-0.638 29.012-1.868c1.964 10.996 2.99 22.314 2.99 33.866zM512 576.002c-6.968 0-13.85-0.382-20.628-1.112 5.252-14.524 12.21-28.238 20.628-40.902 8.42 12.664 15.376 26.378 20.628 40.902-6.778 0.73-13.66 1.112-20.628 1.112zM459.582 568.728c-59.512-16.91-107.332-61.874-128.21-119.62 6.78-0.728 13.66-1.112 20.628-1.112 54.706 0 104.138 23 139.144 59.834-13.45 18.378-24.176 38.872-31.562 60.898zM532.856 507.834c35.006-36.836 84.438-59.836 139.144-59.836 6.968 0 13.85 0.382 20.628 1.112-20.878 57.746-68.7 102.708-128.21 119.62-7.386-22.028-18.112-42.522-31.562-60.896zM352 832.002c-105.872 0-192.002-86.13-192.002-192.002 0-87.704 59.11-161.862 139.584-184.728 23.464 69.966 80.53 124.514 152.028 144.486-2.37 13.054-3.612 26.504-3.612 40.242 0 49.434 16.026 95.118 43.146 132.168-35.006 36.834-84.438 59.834-139.144 59.834zM672 832.002c-54.708 0-104.138-23-139.144-59.836 27.122-37.048 43.146-82.732 43.146-132.166 0-13.738-1.242-27.188-3.612-40.242 71.498-19.972 128.562-74.52 152.028-144.486 80.474 22.868 139.584 97.026 139.584 184.728 0 105.872-86.13 192.002-192.002 192.002z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-filter-outline"
    ]
  },
  {
    "paths": [
      "M732.388 424.244c2.37-13.056 3.614-26.504 3.614-40.244 0-123.712-100.292-224-224.002-224-123.714 0-224.002 100.288-224.002 224 0 13.74 1.244 27.188 3.612 40.244-94.374 26.36-163.61 112.968-163.61 215.756 0 123.71 100.288 224 224 224 62.682 0 119.34-25.758 160-67.254 40.656 41.496 97.316 67.254 159.998 67.254 123.71 0 224.002-100.29 224.002-224 0-102.788-69.238-189.394-163.612-215.756zM511.996 790.746c-0.968 0.99-1.958 1.964-2.95 2.938-6.402-6.788-12.378-13.974-17.902-21.518-27.122-37.050-43.148-82.732-43.148-132.166 0-13.738 1.244-27.188 3.614-40.242-71.498-19.972-128.562-74.52-152.028-144.486-3.188-9.504-5.744-19.294-7.644-29.318 1.884-0.58 3.764-1.178 5.67-1.708-0.092-0.504-0.17-1.014-0.258-1.518 8.372-2.098 16.926-3.734 25.64-4.86 9.496-1.23 19.178-1.868 29.010-1.868 62.682 0 119.34 25.756 160 67.252 40.656-41.496 97.316-67.252 159.998-67.252 9.832 0 19.514 0.638 29.012 1.868 8.71 1.126 17.266 2.76 25.632 4.858-0.086 0.506-0.164 1.014-0.258 1.52 1.91 0.534 3.79 1.128 5.676 1.71-1.898 10.024-4.458 19.814-7.644 29.316-23.464 69.966-80.532 124.514-152.026 144.484 2.37 13.056 3.614 26.506 3.614 40.244 0 49.434-16.028 95.116-43.148 132.166-5.524 7.544-11.504 14.734-17.906 21.52-0.992-0.974-1.982-1.948-2.954-2.94z",
      "M541.012 606.134c-9.498 1.228-19.18 1.868-29.012 1.868s-19.516-0.638-29.012-1.868c-1.964 10.996-2.992 22.312-2.992 33.866 0 39.16 11.796 75.612 32.004 106.010 20.208-30.398 32.004-66.85 32.004-106.010 0-11.552-1.028-22.87-2.992-33.866z",
      "M692.626 449.11c-6.78-0.728-13.66-1.112-20.628-1.112-54.708 0-104.138 23-139.142 59.834 13.45 18.376 24.176 38.868 31.562 60.896 59.51-16.91 107.33-61.872 128.208-119.618z",
      "M532.628 574.89c-5.25-14.524-12.21-28.238-20.628-40.902-8.418 12.664-15.378 26.378-20.628 40.902 6.778 0.728 13.66 1.112 20.628 1.112s13.85-0.382 20.628-1.112z",
      "M352 447.998c-6.968 0-13.85 0.382-20.628 1.112 20.878 57.746 68.698 102.708 128.212 119.62 7.386-22.030 18.11-42.522 31.562-60.896-35.006-36.836-84.44-59.836-139.146-59.836z"
    ],
    "grid": 0,
    "tags": [
      "ios-color-filter"
    ]
  },
  {
    "paths": [
      "M608 192h-32v160h160v-32h-128z",
      "M650.6 128h-330.6v96h-96v672h480v-96h96v-522l-149.4-150zM672 864h-416v-608h64v544h352v64zM768 768h-416v-608h285.4l130.6 131.2v476.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-copy-outline"
    ]
  },
  {
    "paths": [
      "M288 832v-608h-64v672h480v-64h-384z",
      "M650.6 128h-330.6v672h480v-522l-149.4-150zM736 352h-160v-160h32v128h128v32z"
    ],
    "grid": 0,
    "tags": [
      "ios-copy"
    ]
  },
  {
    "paths": [
      "M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z",
      "M386.2 504.6l-23.2 23.2 149 149 149-149-23.2-23.2-109.4 109.4v-486h-32.8v486z"
    ],
    "grid": 0,
    "tags": [
      "ios-download-outline"
    ]
  },
  {
    "paths": [
      "M528 288v326l109.6-109.4 23.2 23.2-148.8 149-149-149 23.4-23.2 109.6 109.4v-326h-304v608h640v-608z",
      "M496 128h32v160h-32v-160z"
    ],
    "grid": 0,
    "tags": [
      "ios-download"
    ]
  },
  {
    "paths": [
      "M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 320c66.2 0 129.8 19 194.4 61.2 47.8 31.2 94.8 73.4 147.4 132.2-76.6 77.4-191.6 190.6-341.8 190.6-68.4 0-128.4-16.8-188.4-56.4-55-36.2-104.6-86.6-152.4-135.6 118.2-119.4 216.8-192 340.8-192z",
      "M512 672c88.2 0 160-71.8 160-160s-71.8-160-160-160c-88.2 0-160 71.8-160 160s71.8 160 160 160zM512 384.6c70.4 0 128 57.2 128 127.4s-57.6 127.4-128 127.4c-70.4 0-127.8-57.2-127.8-127.4s57.4-127.4 127.8-127.4z",
      "M576 512v0c0 35-28.8 64-63.6 64s-64.4-30.4-64.4-65.4 31.6-62.6 64-62.6v-32c-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43.2 96-96.2v-0.4h-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-eye-outline"
    ]
  },
  {
    "paths": [
      "M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160c88.2 0 160 71.8 160 160s-71.8 160-160 160z",
      "M500.8 453.6c0-13.8 4-26.8 11-37.6-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43 96-96.2v0c-10.8 7-23.8 11-37.6 11-38.2-0.2-69.4-31.4-69.4-69.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-eye"
    ]
  },
  {
    "paths": [
      "M96 310l367 202-367 201.8v-403.8zM544 311.6l352 200.4-352 200.8v-400.8zM512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-fastforward-outline"
    ]
  },
  {
    "paths": [
      "M512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"
    ],
    "grid": 0,
    "tags": [
      "ios-fastforward"
    ]
  },
  {
    "paths": [
      "M737 256h-450l-127 192v320h704v-320l-127-192zM826.8 448h-90.8v-136l90.8 136zM320 288h384v160h-96c0 53-43 96-96 96s-96-43-96-96h-96v-160zM288 312v136h-90.8l90.8-136zM832 736h-640v-256h196c14.2 55.2 64.4 96 124 96s109.8-40.8 124-96h196v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-filing-outline"
    ]
  },
  {
    "paths": [
      "M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 816h-448v-288h448v288zM736 496h-448v-288h448v288zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"
    ],
    "grid": 0,
    "tags": [
      "ios-film-outline"
    ]
  },
  {
    "paths": [
      "M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 528h-448v-32h448v32zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"
    ],
    "grid": 0,
    "tags": [
      "ios-film"
    ]
  },
  {
    "paths": [
      "M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5zM736 538c-22 2.8-47.8 7-77.4 7-46.2 0-90-9.4-132.4-18.4-43-9.2-87.2-26.6-134.2-26.6-51.4 0-83.8 6-103.8 12v-274.6c12-5 43.8-13.6 103.8-13.6 43.6 0 84.4 8.6 127.8 18 44 9.4 87.6 21.2 137 21.2 29.4 0 57.4-4 79.4-6.6l-0.2 281.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-flag-outline"
    ]
  },
  {
    "paths": [
      "M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5z"
    ],
    "grid": 0,
    "tags": [
      "ios-flag"
    ]
  },
  {
    "paths": [
      "M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v672c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-608c0-26.654-19.346-46-46-46zM114 160h224c6.994 0 7.474 0.378 12.35 4.976l44.834 44.836c9.68 9.68 20.744 14.188 34.816 14.188h484c8.896 0 14 5.104 14 14v84.752c-5.008-1.776-10.39-2.752-16-2.752h-800c-5.61 0-10.992 0.976-16 2.752v-148.752c0-8.646 9.344-14 18-14zM928 846c0 8.656-5.354 18-14 18h-800c-8.916 0-18-9.084-18-18v-478c0-8.822 7.178-16 16-16h800c8.822 0 16 7.178 16 16v478z"
    ],
    "grid": 0,
    "tags": [
      "ios-folder-outline"
    ]
  },
  {
    "paths": [
      "M944 352h-864c-8.822 0-16 7.178-16 16v478c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-478c0-8.822-7.178-16-16-16z",
      "M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v148.752c5.008-1.776 10.39-2.752 16-2.752h864c5.61 0 10.992 0.976 16 2.752v-84.752c0-26.654-19.346-46-46-46z"
    ],
    "grid": 0,
    "tags": [
      "ios-folder"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM178.634 327.044l36.726 105.576-84.608 73.22c1.032-64.77 18.288-125.664 47.882-178.796zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM650.050 494.412l1.842 1.53-36.754 144.058h-206.276l-36.97-144.906 0.89-0.752 137.746-116.54 139.522 116.61zM893.252 505.842l-84.908-73.476 36.85-105.63c29.7 53.208 47.024 114.21 48.058 179.106zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83zM510.514 205.34l-92.252-62.996c30-7.612 61.402-11.672 93.738-11.67 31.922 0 62.932 3.964 92.586 11.388l-94.072 63.278zM332.846 763.058l1.696 5.022 39.892 99.562c-58.478-22.702-110.022-59.408-150.464-106.012l108.876 1.428zM649.126 867.808l35.868-97.216 3.254-7.496 111.784-1.464c-40.544 46.718-92.246 83.492-150.906 106.176z"
    ],
    "grid": 0,
    "tags": [
      "ios-football-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83z"
    ],
    "grid": 0,
    "tags": [
      "ios-football"
    ]
  },
  {
    "paths": [
      "M389.644 480h-69.644v-69.524c0-5.634-5.208-10.476-10.606-10.476h-44.29c-5.396 0-9.104 4.744-9.104 10.356v69.644h-70.934c-5.23 0-9.066 4.286-9.066 9.542v42.854c0 5.396 4.062 11.606 9.722 11.606h70.278v70.934c0 5.23 4.286 9.066 9.542 9.066h42.854c5.396 0 11.606-4.062 11.606-9.722v-70.28h69.524c5.634 0 10.476-5.208 10.476-10.606v-44.29c-0.002-5.396-4.746-9.104-10.358-9.104z",
      "M724.628 558.126c-21.472 0-38.902 17.030-38.902 38.306 0 21.11 17.43 38.168 38.902 38.168 21.566 0 38.996-17.058 38.996-38.168 0-21.276-17.428-38.306-38.996-38.306z",
      "M639.532 474.33c-21.472 0-38.902 17.206-38.902 38.336 0 21.132 17.43 38.306 38.902 38.306 21.566 0 38.996-17.174 38.996-38.306 0-21.13-17.43-38.336-38.996-38.336z",
      "M809.724 474.33c-21.458 0-38.884 17.206-38.884 38.336 0 21.132 17.428 38.306 38.884 38.306 21.474 0 38.904-17.174 38.904-38.306 0-21.13-17.428-38.336-38.904-38.336z",
      "M724.628 390.602c-21.472 0-38.902 17.204-38.902 38.338 0 21.132 17.43 38.292 38.902 38.292 21.566 0 38.996-17.158 38.996-38.292 0-21.136-17.428-38.338-38.996-38.338z",
      "M738.538 324c51.676 0 99.408 18.628 134.408 52.458 35.504 34.314 55.054 82.036 55.054 134.378 0 52.606-19.612 100.81-55.222 135.738-35.126 34.452-82.8 53.426-134.24 53.426h-453.060c-51.424 0-99.096-18.974-134.234-53.43-35.624-34.934-55.244-83.136-55.244-135.734 0-52.334 19.56-100.056 55.078-134.376 35.008-33.83 82.74-52.46 134.4-52.46h453.060zM738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-game-controller-a-outline"
    ]
  },
  {
    "paths": [
      "M738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836zM400 533.394c0 5.396-4.842 10.606-10.476 10.606h-69.524v70.278c0 5.66-6.208 9.722-11.606 9.722h-42.854c-5.256 0-9.542-3.836-9.542-9.066v-70.934h-70.276c-5.66 0-9.722-6.208-9.722-11.606v-42.854c0-5.256 3.836-9.542 9.066-9.542h70.934v-69.644c0-5.612 3.708-10.356 9.106-10.356h44.29c5.396 0 10.606 4.842 10.606 10.476v69.526h69.644c5.612 0 10.356 3.708 10.356 9.106v44.288zM639.532 550.972c-21.472 0-38.902-17.174-38.902-38.306 0-21.13 17.43-38.336 38.902-38.336 21.566 0 38.996 17.206 38.996 38.336 0 21.132-17.43 38.306-38.996 38.306zM724.628 634.602c-21.472 0-38.902-17.058-38.902-38.168 0-21.278 17.43-38.306 38.902-38.306 21.566 0 38.996 17.030 38.996 38.306 0 21.108-17.428 38.168-38.996 38.168zM724.628 467.23c-21.472 0-38.902-17.158-38.902-38.292s17.43-38.338 38.902-38.338c21.566 0 38.996 17.204 38.996 38.338s-17.428 38.292-38.996 38.292zM809.724 550.972c-21.458 0-38.884-17.174-38.884-38.306 0-21.13 17.428-38.336 38.884-38.336 21.474 0 38.904 17.206 38.904 38.336 0 21.132-17.428 38.306-38.904 38.306z"
    ],
    "grid": 0,
    "tags": [
      "ios-game-controller-a"
    ]
  },
  {
    "paths": [
      "M616.152 407.858c-22.116 0-40.152 18.028-40.152 40.208 0 22.178 18.038 40.214 40.152 40.214 22.262 0 40.296-18.038 40.296-40.214 0.002-22.182-18.034-40.208-40.296-40.208z",
      "M703.976 495.756c-22.116 0-40.106 17.898-40.106 40.212 0 22.128 17.99 40.032 40.106 40.032 22.292 0 40.296-17.902 40.296-40.032 0.002-22.314-18.004-40.212-40.296-40.212z",
      "M270.468 368.734c-43.28 0-78.468 35.606-78.468 79.286 0 43.73 35.188 79.246 78.468 79.246 43.31 0 78.498-35.516 78.498-79.246 0-43.68-35.186-79.286-78.498-79.286zM270.246 486.914c-21.376 0-38.686-17.442-38.686-38.894 0-21.45 17.31-38.882 38.686-38.882 21.282 0 38.594 17.434 38.594 38.882 0 21.452-17.312 38.894-38.594 38.894z",
      "M703.976 320c-22.116 0-40.106 18.028-40.106 40.214 0 22.18 17.99 40.166 40.106 40.166 22.292 0 40.296-17.986 40.296-40.166 0.002-22.186-18.004-40.214-40.296-40.214z",
      "M791.894 407.858c-22.21 0-40.202 18.028-40.202 40.208 0 22.178 17.99 40.214 40.202 40.214 22.118 0 40.106-18.038 40.106-40.214 0-22.182-17.988-40.208-40.106-40.208z",
      "M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM903.354 797.432c-3.67 1.752-7.208 2.568-11.128 2.568-12.044 0-28.154-8.098-46.59-23.416-18.362-15.26-38.614-37.018-63.74-68.478-25.918-32.44-47.334-56.458-87.056-67.898-33.294-9.586-77.248-10.208-158.508-10.208h-48.686c-81.266 0-125.222 0.622-158.518 10.21-39.706 11.438-61.12 35.37-87.046 67.816-25.112 31.454-45.36 53.254-63.724 68.516-18.432 15.316-34.54 23.436-46.586 23.436-3.864 0-7.502-0.83-11.136-2.564-19.112-9.114-45.144-95.346 1.996-292.258 42.774-179.182 84.762-253.554 154.918-274.414 15.266-4.54 29.108-6.744 42.318-6.744 19.484 0 37.198 4.634 59.624 10.498 32.14 8.406 72.144 18.87 132.504 18.87 60.296 0 100.292-10.456 132.43-18.858 22.458-5.872 40.2-10.508 59.73-10.508 13.236 0 27.102 2.208 42.37 6.742 70.074 20.856 112.060 95.234 154.912 274.428 47.050 196.912 21.022 283.15 1.916 292.262z"
    ],
    "grid": 0,
    "tags": [
      "ios-game-controller-b-outline"
    ]
  },
  {
    "paths": [
      "M270.246 409.136c-21.376 0-38.686 17.434-38.686 38.882 0 21.454 17.31 38.894 38.686 38.894 21.282 0 38.594-17.442 38.594-38.894 0-21.448-17.312-38.882-38.594-38.882z",
      "M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM270.468 527.266c-43.28 0-78.468-35.516-78.468-79.246 0-43.68 35.188-79.286 78.468-79.286 43.31 0 78.498 35.606 78.498 79.286 0 43.73-35.186 79.246-78.498 79.246zM616.152 488.28c-22.116 0-40.152-18.038-40.152-40.214 0-22.18 18.038-40.208 40.152-40.208 22.262 0 40.296 18.028 40.296 40.208 0.002 22.176-18.034 40.214-40.296 40.214zM703.976 576c-22.116 0-40.106-17.902-40.106-40.032 0-22.314 17.99-40.212 40.106-40.212 22.292 0 40.296 17.898 40.296 40.212 0.002 22.13-18.004 40.032-40.296 40.032zM703.976 400.38c-22.116 0-40.106-17.986-40.106-40.166 0-22.188 17.99-40.214 40.106-40.214 22.292 0 40.296 18.028 40.296 40.214 0.002 22.18-18.004 40.166-40.296 40.166zM791.894 488.28c-22.21 0-40.202-18.038-40.202-40.214 0-22.18 17.99-40.208 40.202-40.208 22.118 0 40.106 18.028 40.106 40.208 0 22.176-17.988 40.214-40.106 40.214z"
    ],
    "grid": 0,
    "tags": [
      "ios-game-controller-b"
    ]
  },
  {
    "paths": [
      "M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2zM747.6 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154zM276.4 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154z"
    ],
    "grid": 0,
    "tags": [
      "ios-glasses-outline"
    ]
  },
  {
    "paths": [
      "M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-glasses"
    ]
  },
  {
    "paths": [
      "M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558zM853.66 582.282c-53.704 63.88-84.36 97.79-193.458 169.894-80.474 53.192-130.504 72.602-148.204 78.466-17.7-5.866-67.728-25.278-148.204-78.466-109.096-72.104-139.752-106.012-193.458-169.896-24.13-28.702-43.714-62.548-56.632-97.886-11.58-31.684-17.704-63.786-17.704-92.836 0-60.568 20.262-111.286 58.594-146.67 18.28-16.874 40.316-29.984 65.504-38.968 25.89-9.238 54.532-13.92 85.132-13.92 76.036 0 146.434 35.364 179.348 90.092l27.422 45.596 27.422-45.596c32.916-54.728 103.314-90.092 179.348-90.092 30.6 0 59.242 4.682 85.132 13.918 25.188 8.986 47.224 22.096 65.504 38.968 38.332 35.386 58.594 86.104 58.594 146.672 0 29.050-6.124 61.152-17.708 92.836-12.916 35.336-32.5 69.184-56.632 97.888z"
    ],
    "grid": 0,
    "tags": [
      "ios-heart-outline"
    ]
  },
  {
    "paths": [
      "M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558z"
    ],
    "grid": 0,
    "tags": [
      "ios-heart"
    ]
  },
  {
    "paths": [
      "M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256zM800 864h-160v-256h-256v256h-160v-368.62l288-230.4 288 230.4v368.62z",
      "M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996zM288 307.198l-64 51.2v-134.398h64v83.198z"
    ],
    "grid": 0,
    "tags": [
      "ios-home-outline"
    ]
  },
  {
    "paths": [
      "M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256z",
      "M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996z"
    ],
    "grid": 0,
    "tags": [
      "ios-home"
    ]
  },
  {
    "paths": [
      "M902.458 376.196c-37.094-36.262-86.558-56.196-139.288-56.196-52.726 0-102.19 19.934-139.284 56.196l-84.458 82.374 27.298 26.894 84.458-82.612c29.866-29.058 69.528-45.146 111.756-45.146 42.226 0 81.892 16.088 111.756 45.146 61.594 60.278 61.594 158.26 0 218.296-29.864 29.058-69.53 45.146-111.756 45.146-42.228 0-81.89-16.088-111.756-45.146l-251.042-244.952c-37.33-36.262-86.792-56.196-139.288-56.196-52.726 0-102.19 19.934-139.286 56.196-38.338 37.422-57.526 86.686-57.568 135.804-0.042 49.222 19.146 98.298 57.568 135.804 37.096 36.26 86.558 56.196 139.286 56.196 52.73 0 102.19-19.936 139.29-56.196l84.222-82.372-27.294-26.658-84.458 82.374c-29.864 29.058-69.528 45.146-111.758 45.146-42.226 0-81.888-16.088-111.752-45.146-61.598-60.28-61.598-158.26 0-218.296 29.864-29.058 69.526-45.146 111.752-45.146 42.23 0 81.894 16.088 111.758 45.146l251.040 244.954c37.326 36.258 86.79 56.194 139.286 56.194 52.726 0 102.19-19.936 139.286-56.196 38.496-37.344 57.744-86.604 57.774-135.804 0.030-49.202-19.16-98.34-57.542-135.804z"
    ],
    "grid": 0,
    "tags": [
      "ios-infinite-outline"
    ]
  },
  {
    "paths": [
      "M913.642 364.754c-40.078-39.178-93.518-60.754-150.472-60.754s-110.39 21.576-150.42 60.708l-78.212 75.77 50.12 49.378 77.686-75.538c26.916-26.19 62.642-40.614 100.598-40.614 37.958 0 73.682 14.424 100.564 40.582 26.726 26.154 41.424 60.936 41.386 97.94-0.038 36.886-14.726 71.5-41.354 97.456-26.916 26.19-62.64 40.614-100.598 40.614-37.956 0-73.682-14.424-100.582-40.598l-251.066-244.98c-40.31-39.154-93.736-60.718-150.438-60.718-56.954 0-110.39 21.576-150.46 60.746-40.188 39.226-62.348 91.518-62.394 147.24-0.048 55.644 22.11 107.946 62.384 147.26 40.080 39.178 93.518 60.754 150.47 60.754 56.95 0 110.388-21.576 150.446-60.726l77.988-75.818-50.176-49.004-77.658 75.23c-26.916 26.19-62.642 40.614-100.6 40.614-37.954 0-73.678-14.424-100.56-40.582-26.728-26.154-41.428-60.938-41.388-97.942 0.038-36.886 14.726-71.498 41.356-97.454 26.916-26.19 62.64-40.614 100.594-40.614 37.958 0 73.684 14.424 100.584 40.598l251.064 244.978c40.308 39.156 93.734 60.72 150.436 60.72 56.952 0 110.388-21.576 150.426-60.71 40.358-39.146 62.602-91.454 62.634-147.28 0.034-55.676-22.116-107.974-62.358-147.256z"
    ],
    "grid": 0,
    "tags": [
      "ios-infinite"
    ]
  },
  {
    "paths": [
      "M851 269.6c9.4-11.8 15-27 15-43.2 0-38.4-31.2-69.8-69.6-69.8-16.4 0-31.4 5.6-43.2 15-68-48.4-150-75.6-239.8-75.6-229.8-0-417.4 185-417.4 415.2s187.4 416.8 417.2 416.8c229.8 0 414.8-186.6 414.8-416.8 0-90-28.6-173.4-77-241.6zM796 182.6c24.4 0 44 19.8 44 44 0 24.4-19.8 44-44 44-24.4 0-44-19.8-44-44s19.6-44 44-44zM783.6 783.4c-35.2 35.2-76.4 63.2-122.2 82.6-47.4 20-96.4 30.4-148.4 30.4-51.8 0-103.4-10.2-150.8-30.4-45.8-19.4-86.8-47-122.2-82.6-35.2-35.2-63-76.6-82.4-122.4-20-47.4-30.2-97.8-30.2-149.8 0-51.8 10.2-102.4 30.2-149.8 19.4-45.8 47-87 82.4-122.4s76.4-63.2 122.2-82.6c47.4-20 98.8-28.2 150.8-28.2 51.8 0 101 8 148.4 28.2 25.4 10.8 49.4 24.2 71.8 40-4.2 9-6.6 19-6.6 29.8 0 38.4 31.2 69.8 69.6 69.8 10.6 0 20.6-2.4 29.8-6.6 15.8 22.4 29.2 46.4 40 72 20 47.4 30.2 97.8 30.2 149.8 0 51.8-10.2 102.4-30.2 149.8-19.4 45.8-47 87-82.4 122.4z",
      "M513 320.2c-106 0-192 85.6-192 191.8s85.8 192.2 192 192.2c106 0 192-86 192-192.2s-86-191.8-192-191.8zM513 671.6c-88.2 0-159.4-71.6-159.4-159.6 0-88.2 71.2-159.2 159.4-159.2s159.4 71.2 159.4 159.2c0 88.2-71.4 159.6-159.4 159.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-ionic-outline"
    ]
  },
  {
    "paths": [
      "M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z",
      "M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z",
      "M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8zM789.2 160c41.2 0 74.8 33.6 74.8 74.8s-33.6 74.8-74.8 74.8-74.8-33.6-74.8-74.8c-0-41.2 33.4-74.8 74.8-74.8z",
      "M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z",
      "M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-keypad-outline"
    ]
  },
  {
    "paths": [
      "M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8z",
      "M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z",
      "M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-keypad"
    ]
  },
  {
    "paths": [
      "M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574zM832.352 660.25l-31.926 55.732-256.426-147.982v296h-64v-296l-256.426 148-31.938-55.57 256.456-148.394-256.448-148.314 31.928-55.718 256.428 147.996v-296h64v296l256.426-148 31.938 55.57-256.456 148.358 256.444 148.322z"
    ],
    "grid": 0,
    "tags": [
      "ios-medical-outline"
    ]
  },
  {
    "paths": [
      "M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574z"
    ],
    "grid": 0,
    "tags": [
      "ios-medical"
    ]
  },
  {
    "paths": [
      "M544 416v128h128v64h-128v128h-64v-128h-128v-64h128v-128h64zM576 384h-128v128h-128v128h128v128h128v-128h128v-128h-128v-128z",
      "M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM896 864h-768v-576h768v576z"
    ],
    "grid": 0,
    "tags": [
      "ios-medkit-outline"
    ]
  },
  {
    "paths": [
      "M544 544v-128h-64v128h-128v64h128v128h64v-128h128v-64h-96z",
      "M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM704 640h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"
    ],
    "grid": 0,
    "tags": [
      "ios-medkit"
    ]
  },
  {
    "paths": [
      "M512 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M256.8 476c19.8 0 36 16.2 36 36s-16.2 36-36 36c-19.8 0-36-16.2-36-36s16.2-36 36-36zM256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z",
      "M768 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-more-outline"
    ]
  },
  {
    "paths": [
      "M512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z",
      "M256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z",
      "M768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-more"
    ]
  },
  {
    "paths": [
      "M512 129c102.2 0 198.4 39.8 270.8 112.2s112.2 168.4 112.2 270.8-39.8 198.4-112.2 270.8-168.4 112.2-270.8 112.2-198.4-39.8-270.8-112.2c-72.2-72.4-112.2-168.6-112.2-270.8s39.8-198.4 112.2-270.8c72.4-72.2 168.6-112.2 270.8-112.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0z",
      "M704 320l-447.4 192h255.4v256z"
    ],
    "grid": 0,
    "tags": [
      "ios-navigate-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768v-256h-255.4l447.4-192-192 448z"
    ],
    "grid": 0,
    "tags": [
      "ios-navigate"
    ]
  },
  {
    "paths": [
      "M716 467.71l0.826-0.078c-0.274-0.274-0.092-0.202-0.37-0.474l-156.868-157.158c-11.666-12-28.386-20.308-46.97-20.308-23.622 0-44.23 12.308-55.27 32.308h-0.014c0 0-14.18 21.988-36.54 57.748l65.062 79.274c5.878 7.538 6.592 15.602 2.822 19.378l-0.228 0.142c-1.818 1.818-4.042 2.66-6.548 2.66-3.816 0-8.284-1.98-12.97-5.536l-71.744-58.836c-47.092 75.31-113.354 181.268-166.9 266.902l38.144 46.674c5.878 7.54 6.592 15.768 2.82 19.544l-0.228 0.228c-1.822 1.826-4.056 2.684-6.574 2.684-3.81 0-8.272-1.962-12.944-5.51l-42.134-33.066c-39.904 63.816-69.372 110.642-73.372 114.446v0.006c-6 10.124-8.17 22.264-8.17 35.328 0 35.31 29.314 63.934 64.57 63.934 15.642 0 29.14-6.79 41.598-15l229.302-168.218-57.676-70.716c-5.88-7.538-6.536-15.774-2.764-19.55l0.256-0.228c1.824-1.824 4.068-2.682 6.588-2.682 3.81 0 8.28 1.962 12.952 5.51l75.728 63.18c109.676-80.492 211.78-154.296 211.78-154.296h0.010c15.678-12 24.946-31.422 24.946-52.476 0-17.408-7.12-34.28-19.12-45.808v-0.006zM691.062 539.668c-5.328 3.868-93.384 67.864-191.528 139.798l-57.612-47.834c-10.49-7.962-21.326-11.996-32.216-11.996-10.93 0-21.184 4.194-28.916 11.818l-0.128 0.124-0.166 0.164-0.166 0.166c-15.616 15.642-15.522 41.646 0.222 61.834l0.22 0.286 0.226 0.276 36.446 44.624-201.312 147.792c-10.132 6.608-16.854 9.314-23.084 9.314-17.644 0-32-14.342-32-31.966 0-6.172 1.388-12.090 4.034-17.246 4.782-6.322 13.2-19.752 37.31-58.702 5.086-8.216 10.504-16.974 16.268-26.258l13.17 10.664 0.4 0.304c10.49 7.962 21.33 12 32.222 12 11.034 0 21.384-4.278 29.142-12.046l0.228-0.226c15.612-15.634 15.512-41.64-0.236-61.832l-0.226-0.288-0.23-0.284-23.628-28.91 135.504-216.692 44.652 36.586c10.508 7.976 21.356 12.020 32.246 12.020 9.908 0 19.262-3.45 26.678-9.78l0.922-0.674 1.742-1.748c15.58-15.606 15.48-41.556-0.236-61.708l-0.24-0.306-50.726-61.378c5.914-9.406 10.914-16.982 14.81-22.976l10.418-16.988c5.554-10.050 15.522-16.314 27.346-16.314 8.734 0 17.52 4.084 24.114 10.86l9.402 9.856h0.244l137.622 138.57v0.752l10.372 9.432c5.586 5.38 9.078 13.564 9.078 22.454 0 10.392-4.516 20.246-12.388 26.458z",
      "M879.988 230.35l-192.832 111.51 132.504-229.876-27.638-15.984-4.976 8.626-141.55 245.57 33.34 33.392 217.112-125.552z"
    ],
    "grid": 0,
    "tags": [
      "ios-nutrition-outline"
    ]
  },
  {
    "paths": [
      "M718 467.24l-0.212-0.078c-0.272-0.276-0.612-0.886-0.888-1.158l-157.806-158.004c-11.696-12-28.46-20.336-47.094-20.336-23.684 0-44.348 12.336-55.416 32.336h-0.014c0 0-14.218 22.702-36.636 58.498l65.234 79.7c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-71.934-58.878c-47.216 75.386-113.654 181.462-167.342 267.184l38.246 46.724c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-40.44-33.1c-40.010 63.88-69.37 110.754-71.758 114.562v0.006c-6 10.132-10 22.288-10 35.364 0 35.348 28.488 64 63.836 64 15.684 0 28.766-6.796 41.256-15.016l229.684-168.39-57.942-70.79c-5.894-7.544-6.61-15.79-2.828-19.57l0.228-0.228c4.592-4.592 11.788-3.068 19.57 2.83l75.926 62.43c109.97-80.57 212.34-155.266 212.34-155.266h0.010c15.718-12 26.048-30.638 26.048-51.714 0-17.426-6.128-33.5-18.128-45.042v-0.004z",
      "M896 277.562l-32.972-55.388-132.46 76.424 98.462-170.426-55.238-32.172-139.998 242.168 57.176 57.176z"
    ],
    "grid": 0,
    "tags": [
      "ios-nutrition"
    ]
  },
  {
    "paths": [
      "M382 224v576h-94v-576h94zM414 192h-158v640h158v-640z",
      "M736 224v576h-94v-576h94zM768 192h-158v640h158v-640z"
    ],
    "grid": 0,
    "tags": [
      "ios-pause-outline"
    ]
  },
  {
    "paths": [
      "M256 192h158v640h-158v-640z",
      "M610 192h158v640h-158v-640z"
    ],
    "grid": 0,
    "tags": [
      "ios-pause"
    ]
  },
  {
    "paths": [
      "M512 224v0 0z",
      "M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4-22.4-7.8 22.6 7.8 0 0zM294.2 727.2c11.2-11.8 25.4-22.2 40.8-28 21-8 44.8-7.6 66.6-13.2 18-4.6 40.4-11.8 54.4-24.8 12.8-12 14.2-30.4 15.4-47 1-14 0.8-27.8 0.8-41.8 0-9.8-11.4-15.4-17-23.2-9-12.2-9.4-30.4-11.2-45-0.8-6.4-1-14.6-6.4-19-6-4.8-10.4-7.4-13.4-15-4-10.4-5.4-21.6-8.6-32.4-2-7 5-13.6 7.8-19.4 5.2-10.6-3.8-27-5.6-38-5.6-32.8-5.4-68.6 18.2-94.6 47.4-52.4 156-35.8 171.6 37.8 4.8 23 1.8 49.8-4.6 72.2-2.8 9.6-6 16.6-0.4 26 8.4 13.6 4.8 22.4 0.8 37.6-3.2 12.6-7.2 18.2-16.8 26-8 6.4-6.8 22.4-8.2 31.6-1.6 11.2-2.6 23-9.4 32.4-2.6 3.6-16.8 14.8-16.8 18.6 0 22-1 44.4 2.8 66.2 5.2 31 31.2 38.4 57.2 49 26.4 10.2 57 6.4 82.6 19 26.4 13 51.8 36.8 59.4 66.2-158.6 0-317.2 0-475.8 0-2.8 0-5.6 0-8.4 0 3.8-16.6 13-29.2 24.2-41.2 18.4-19.4-11.8 12.6 0 0z",
      "M288.2 644c14-7 29.2-8.6 44.6-10.2 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35.2 11.8-61.2 41.2-61.2 80.2 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 14-15.6 31.2-29 49.8-38.4 18-9-29.2 14.8 0 0zM205.6 672c-32.6 0-65.2 0-97.8 0 14.2-23.6 49.8-22 73.2-30.4 21.6-7.8 35.4-21 37.6-44 0.2-2.6 0.4-58.4-1.8-58.4-17.4-0.6-35.6-0.2-53-2.8 13.8-44.6 0.6-90.6 8-135.6 5.4-32.6 26.2-50.6 59.4-50.6 31.8 0 55.4 14.8 62.2 46.8 9.6 46.4-4 93.8 10.8 139.8-11 2.8-22.6 3.2-34 3.6-5.6 0.2-11.4 0.4-17 0.6-3.6 0.2-2.4 6.4-2.6 9.4-2 21.8-10 56.2 7.4 73.8-19.2 12-40 28.6-52.4 47.8z",
      "M799.6 704c53.4 0 107 0 160.4 0 0-39-26.2-68.6-61.4-80.2-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 11.8 9.6 27.8 23.2 32.2 38.8zM798.8 649.8c-10.2-9.4-20.8-18.6-32.6-26 17.6-17.6 9.4-51.8 7.4-73.8-1.2-12.6-4-9.4-16.6-9.8-12-0.4-25.6 0.2-37-3.6 14.4-44.6 2.6-90.4 10-135.8 5.6-34.2 29-51 63-51 30.8 0 52 15.4 58.4 46 9.8 46.2-5.2 94 9 140-17 2.6-34.6 2-51.8 2.6-4.2 0.2-3.8 50.2-3.4 54.6 1.4 23.4 12.2 37.6 34.4 46.6 24.2 9.8 62 7.2 76.8 31.8-18.6 0-37 0-55.6 0-11.2 0-22.4 0-33.8 0-14.2 0.2-17.8-12.2-28.2-21.6-10-9.2 8 7.2 0 0z"
    ],
    "grid": 0,
    "tags": [
      "ios-people-outline"
    ]
  },
  {
    "paths": [
      "M698.4 669.6c22.6 7.8-22.4-7.8 0 0v0z",
      "M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4z",
      "M286.6 645c1.2-0.6 2.4-1.2 3.2-1.6-0.6 0.2-1.2 0.6-1.6 0.8-0.6 0.2-1 0.4-1.6 0.8z",
      "M286.6 645c-6.8 3.4-15 7.6 1.6-0.8 6-3 4.8-2.4 1.6-0.8 13.6-6.4 28.2-8 42.8-9.4 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35 11.6-61 40-61 80 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 13.6-15 30.2-28 48.2-37.4z",
      "M898.6 623.8c-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 12 9.8 28.2 23 32.6 39 53.4 0 107 0 160.4 0-0.4-40.2-26.6-68.8-61.8-80.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-people"
    ]
  },
  {
    "paths": [
      "M404.8 403.4v0 0z",
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6v0c-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4v0c0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2l-274.4-0.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-person-outline"
    ]
  },
  {
    "paths": [
      "M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-person"
    ]
  },
  {
    "paths": [
      "M192 256v640h768v-640h-768zM928 864h-704v-576h704v576z",
      "M64 128v640h96v-32h-64v-576h704v64h32v-96z"
    ],
    "grid": 0,
    "tags": [
      "ios-photos-outline"
    ]
  },
  {
    "paths": [
      "M192 256v640h768v-640h-768z",
      "M832 128h-768v640h96v-544h672z"
    ],
    "grid": 0,
    "tags": [
      "ios-photos"
    ]
  },
  {
    "paths": [
      "M576 161.652c90.586 7.41 174.708 46.048 239.618 110.988 72.47 72.5 112.382 168.848 112.382 271.446 0 51.848-10.16 102.084-30.198 149.406-19.36 45.718-47.080 86.768-82.388 122.048-35.308 35.278-76.408 62.962-122.16 82.302-47.346 20.020-97.646 30.162-149.504 30.162-82.386 0-160.94-25.694-227.168-74.292-31.9-23.41-59.914-51.466-83.266-83.384-16.756-22.906-30.844-47.448-42.082-73.268l384.766-96.068v-438.992zM544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z",
      "M480 96.362v429.886l-360.684 91.46c-18.234-47.136-22.394-113.946-22.316-138.992v-0.142c0-94.622 32.93-187.492 90.346-254.796 33.47-39.236 75.004-69.962 123.442-91.326 49.41-21.79 106.25-33.904 169.212-36.090zM512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"
    ],
    "grid": 0,
    "tags": [
      "ios-pie-outline"
    ]
  },
  {
    "paths": [
      "M544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z",
      "M512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"
    ],
    "grid": 0,
    "tags": [
      "ios-pie"
    ]
  },
  {
    "paths": [
      "M288 249.8l419.6 262.2-419.6 262.2v-524.4zM256 192v640l512-320-512-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-play-outline"
    ]
  },
  {
    "paths": [
      "M256 192v640l512-320-512-320z"
    ],
    "grid": 0,
    "tags": [
      "ios-play"
    ]
  },
  {
    "paths": [
      "M896 128v-64h-320l-512 576 320 320 46.942-47.808 49.058 47.808 480-544v-288h-64zM384 914.742l-275.22-274.742 480.462-544h274.758v274.754l-433.11 495.98-22.68 22.726-24.21 25.282zM928 402.754l-448 511.988-26.364-25.3 442.364-505.442v-224h32v242.754z",
      "M704 320c35.29 0 64-28.71 64-64s-28.71-64-64-64-64 28.71-64 64 28.71 64 64 64zM704 224c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32z"
    ],
    "grid": 0,
    "tags": [
      "ios-pricetags-outline"
    ]
  },
  {
    "paths": [
      "M928 128v274.754l-473.694 532.206 25.694 25.040 480-544v-288z",
      "M576 64l-512 576 320 320 46.942-47.808 22.696-22.75 442.362-505.442v-320h-320zM704 320c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z",
      "M736 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"
    ],
    "grid": 0,
    "tags": [
      "ios-pricetags"
    ]
  },
  {
    "paths": [
      "M772.4 288c-121.2 0-219.6 100.2-219.6 224 0 80.8 42 151.4 105 190.8h-291.6c63-39.4 105-110 105-190.8 0-123.8-98.4-224-219.6-224s-219.6 100.2-219.6 224c0 123.8 98.4 224 219.6 224h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM64.6 512c0-105.2 84-190.8 187-190.8 103.2 0 187 85.6 187 190.8s-84 190.8-187 190.8c-103.2 0-187-85.6-187-190.8zM772.4 702.8c-103.2 0-187-85.6-187-190.8s84-190.8 187-190.8 187 85.6 187 190.8-83.8 190.8-187 190.8z",
      "M768 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM768 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z",
      "M256 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM256 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z"
    ],
    "grid": 0,
    "tags": [
      "ios-recording-outline"
    ]
  },
  {
    "paths": [
      "M772.4 288c-121.2 0-219.6 99.8-219.6 223.6 0 80.8 42 152.4 105 190.4h-291.6c63-38 105-109.6 105-190.4 0-123.8-98.4-223.8-219.6-223.8s-219.6 100.4-219.6 224c0 123.8 98.4 224.2 219.6 224.2h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM256 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128zM768 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128z",
      "M768 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z",
      "M256 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z"
    ],
    "grid": 0,
    "tags": [
      "ios-recording"
    ]
  },
  {
    "paths": [
      "M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6zM544 384v-129.4l296.2 193.6-296.2 193.4v-129.6c-182 0-289.2 49.2-384.4 210.8-0 0-17.6-338.8 384.4-338.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-redo-outline"
    ]
  },
  {
    "paths": [
      "M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-redo"
    ]
  },
  {
    "paths": [
      "M603.63 637.216c-26.228 22.058-57.912 34.712-91.63 34.712-72.72 0-132.572-57.93-141.78-123.93h61.22l-77.74-100-75.068 100h58.958c9.392 84 83.434 156 174.41 156 41.8 0 82.34-15.132 114.152-42.436l4.74-4.318-23.198-23.324-4.064 3.296z",
      "M631.472 397.77c-32.376-29.55-74.804-45.678-119.472-45.678-41.8 0-82.338 15.112-114.15 42.412l-4.742 4.104 23.198 23.22 4.066-3.412c25.854-21.744 58.394-34.010 91.628-34.010 72.686 0 132.548 57.594 141.782 127.594h-61.288l77.692 102.45 75.252-102.45h-59.024c-4.482-40-23.864-85.872-54.942-114.23z",
      "M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM864 733.402c0 18.526-12.458 34.598-29 34.598h-640c-17.476 0-35-17.328-35-34.598v-352.034c0-16.332 16.252-29.368 35-29.368h121.458c0 0 8.248 0 12.266 0s6.45-0.398 11.536-6.4 15.404-20.016 22.16-27.59c22.592-25.332 38.914-43.83 50.632-54.264 9.492-8.45 12.422-7.746 12.45-7.746h177c0.032 0 3.222-0.726 13.418 8.438 12.282 11.042 29.41 33.68 53.116 60.396 5.776 6.51 14.428 16.22 18.634 20.88s8.504 6.286 11.542 6.286 12.34 0 12.34 0h123.448c17.664 0 29 11.93 29 29.368v352.034z"
    ],
    "grid": 0,
    "tags": [
      "ios-reverse-camera-outline"
    ]
  },
  {
    "paths": [
      "M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM626.152 661.564c-31.812 27.304-72.352 42.436-114.152 42.436-90.974 0-165.018-72-174.41-156h-58.958l75.068-100 77.74 100h-61.22c9.208 66 69.060 123.93 141.78 123.93 33.718 0 65.402-12.654 91.63-34.712l4.064-3.294 23.198 23.324-4.74 4.316zM670.188 614.45l-77.692-102.45h61.288c-9.234-70-69.096-127.594-141.782-127.594-33.236 0-65.776 12.266-91.628 34.010l-4.066 3.412-23.198-23.22 4.742-4.104c31.81-27.3 72.35-42.412 114.15-42.412 44.666 0 87.096 16.126 119.472 45.678 31.076 28.358 50.458 74.23 54.94 114.23h59.024l-75.25 102.45z"
    ],
    "grid": 0,
    "tags": [
      "ios-reverse-camera"
    ]
  },
  {
    "paths": [
      "M928 310v403.8l-367-201.8 367-202zM480 312v400.8l-352-200.8 352-200.4zM512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-rewind-outline"
    ]
  },
  {
    "paths": [
      "M512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"
    ],
    "grid": 0,
    "tags": [
      "ios-rewind"
    ]
  },
  {
    "paths": [
      "M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124 6.118-6.98 12.464-13.668 19.078-20.282 0.96-0.96 1.944-1.894 2.912-2.844 37.56-36.852 81.042-65.898 129.328-86.322 51.266-21.684 105.742-32.678 161.916-32.678s110.65 10.994 161.916 32.678c48.288 20.424 91.768 49.47 129.328 86.322 0.968 0.95 1.952 1.882 2.912 2.844 6.614 6.614 12.96 13.3 19.078 20.282 7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.004-247.424-200.572-447.876-447.996-447.876zM895.322 738.354c-17.326 40.962-40.858 78.184-70.088 111.552-80.78-79.020-191.306-127.89-313.234-127.89s-232.456 48.66-313.234 127.68c-29.23-33.37-52.762-70.344-70.088-111.306-19.62-46.38-30.456-95.388-32.346-145.388h62.668v-32h-62.668c1.89-50 12.726-100.096 32.346-146.478 18.744-44.314 44.752-84.862 77.384-120.22l53.864 53.786 10.992-11.076 10.554-10.528-0.040-0.054 1.094-1.104-53.902-53.968c35.724-33.294 76.008-59.788 120.958-78.8 46.382-19.62 95.416-30.458 145.416-32.348v74.788h32v-74.792c52 1.89 100.034 12.726 146.416 32.346 44.874 18.98 85.842 45.412 121.524 78.624l-53.95 54.138 1.154 1.094-0.008 0.038 10.57 10.492 11 11.006 54.052-54.114c32.712 35.406 58.784 76.296 77.56 120.69 19.62 46.382 30.458 96.478 32.348 146.478h-64.664v32h64.668c-1.89 50-12.726 98.972-32.346 145.354z",
      "M736.958 349.090l-170.968 147.454c-15.394-10.51-33.984-16.668-53.988-16.668-52.934 0-96 43.066-96 96 0 20.958 6.77 40.356 18.212 56.16l-23.896 23.896 22.624 22.626 24.066-24.066c15.59 10.938 34.546 17.382 54.992 17.382 52.934 0 96-43.066 96-96 0-20.774-6.654-40.010-17.912-55.736l149.698-168.22-2.828-2.828zM512 639.876c-35.346 0-64-28.652-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-speedometer-outline"
    ]
  },
  {
    "paths": [
      "M834 557.484v-1.484h59.628c-1.862-46-12.112-91.218-29.662-132.302-17.286-40.456-41.006-77.33-70.514-109.124l-49.734 49.292-22.458-21.984 49.576-49.358c-32.374-29.672-69.72-53.484-111.030-70.784-42.848-17.946-87.806-27.556-133.806-29.368v67.628h-30v-67.628c-46 1.788-89.9 11.398-132.808 29.37-40.706 17.046-77.916 40.914-110.63 70.942l49.592 49.166-1.098 1.098 0.002 0.012-0.58 0.67-20.54 20.406-49.558-48.958c-29.54 31.864-53.208 68.486-70.352 108.618-17.546 41.080-27.794 86.304-29.654 132.304h57.626v32h-57.626c1.852 44 11.83 88.864 29.658 130.594 15.378 36.002 36.796 69.328 63.662 99.852 77.57-74.754 179.916-115.856 288.308-115.856 108.226 0 210.572 41.352 288.308 116.27 26.708-30.35 48.122-63.958 63.66-100.332 17.83-41.736 27.808-86.528 29.658-130.528h-59.628v-30.516zM608 575.876c0 52.934-43.066 96-96 96-20.446 0-39.402-6.446-54.992-17.382l-24.066 24.066-22.624-22.626 23.896-23.896c-11.444-15.804-18.212-35.204-18.212-56.16 0-52.934 43.066-96 96-96 20.004 0 38.594 6.158 53.988 16.668l146.968-131.454 2.828 2.828-125.698 152.22c11.258 15.726 17.912 34.962 17.912 55.736z",
      "M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124h44.386c63.426-78.206 160.288-128.192 268.848-128.192s205.424 49.986 268.85 128.192h44.386c7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.002-247.424-200.574-447.876-447.998-447.876zM821.488 841.594c-6.102 6.816-12.784 13.726-20.426 21.128l-0.752 0.73-0.696-0.786c-5.258-5.94-10.986-11.97-17.518-18.44-0.55-0.542-1.11-1.078-1.668-1.614l-1.008-0.97c-34.516-33.532-74.468-59.934-118.75-78.476-47.070-19.712-97.090-29.708-148.672-29.708s-101.602 9.996-148.672 29.708c-44.28 18.542-84.234 44.946-118.75 78.476l-1.008 0.97c-0.558 0.536-1.116 1.070-1.666 1.614-6.532 6.468-12.26 12.5-17.518 18.44l-0.696 0.786-0.754-0.73c-7.642-7.402-14.324-14.312-20.424-21.128-67.028-74.882-103.942-171.258-103.942-271.37 0-109.332 43.004-212.106 121.090-289.388 78.082-77.278 181.904-119.836 292.342-119.836 110.44 0 214.26 42.558 292.34 119.836 78.086 77.284 121.090 180.058 121.090 289.388 0 100.112-36.912 196.486-103.942 271.37z",
      "M576 575.876c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"
    ],
    "grid": 0,
    "tags": [
      "ios-speedometer"
    ]
  },
  {
    "paths": [
      "M344.496 609.862l-109.354 318.146 276.858-197.268 276.89 197.268-109.37-318.134 280.48-195.874h-342.774l-105.226-317.99-105.196 317.99h-342.804l280.496 195.862zM512 201.5l82 246.5h262l-216 149.422 85.246 244.962-213.246-151.87v-489.014z"
    ],
    "grid": 0,
    "tags": [
      "ios-star-half"
    ]
  },
  {
    "paths": [
      "M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8zM725.2 842.4l-213.2-152-213.2 152 85.2-245-216-149.4h262l82-246.6 82 246.6h262l-216 149.2 85.2 245.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-star-outline"
    ]
  },
  {
    "paths": [
      "M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-star"
    ]
  },
  {
    "paths": [
      "M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM512.6 891.4c-191 0-346.2-153.4-346.2-341.8 0-188.6 155.4-341.8 346.2-341.8 191 0 346.2 153.4 346.2 341.8 0.2 188.4-155.2 341.8-346.2 341.8z",
      "M528 514.6v-258.6h-32v258.8c-25 8.6-48 33-48 60.6 0 29.4 20 54 48 61l16 35.6 16-35.6c28-7 48-31.6 48-61 0-29-21-53.4-48-60.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-stopwatch-outline"
    ]
  },
  {
    "paths": [
      "M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM528 636.4l-16 35.6-16-35.6c-28-7-48-31.6-48-61 0-27.6 23-52 48-60.6v-258.8h32v258.6c27 7.4 48 31.8 48 60.8 0 29.4-20 54-48 61z"
    ],
    "grid": 0,
    "tags": [
      "ios-stopwatch"
    ]
  },
  {
    "paths": [
      "M928 512c0-229.726-186.26-416-416-416-229.726 0-416 186.272-416 416 0 229.726 186.274 416 416 416 5.082 0 10.136-0.124 15.174-0.304 0.958-0.034 1.914-0.068 2.87-0.11 1.884-0.080 3.768-0.166 5.646-0.272 1.7-0.094 3.396-0.208 5.094-0.322 1.278-0.088 2.558-0.16 3.834-0.26 2.708-0.208 5.41-0.442 8.11-0.704 0-0.006 0-0.012 0-0.018 194.94-18.948 350.458-172.458 372.548-366.446 0.040-0.002 0.076 0 0.114-0.002 1.208-10.63 2.004-21.334 2.392-32.1-0.032 0.002-0.064 0.002-0.098 0.002 0.19-5.132 0.316-10.282 0.316-15.464zM893.33 512c0 5.136-0.132 10.242-0.334 15.328-47.278-2.152-93.354-12.212-137.232-30.010-51.582-20.916-97.876-51.662-137.594-91.382-39.72-39.72-70.466-86.014-91.384-137.594-17.806-43.912-27.87-90.028-30.012-137.34 5.054-0.2 10.126-0.33 15.228-0.33 210.258-0.002 381.328 171.066 381.328 381.328zM130.674 512c0-2.636 0.046-5.262 0.1-7.884 44.952 2.758 88.776 12.674 130.6 29.634 51.582 20.916 97.876 51.662 137.596 91.382 39.72 39.718 70.464 86.014 91.382 137.596 16.948 41.792 26.86 85.584 29.628 130.498-2.656 0.054-5.312 0.102-7.98 0.102-210.26-0-381.328-171.068-381.326-381.328zM551.886 891.246c-6.546-105.132-49.948-208.396-130.29-288.738-80.372-80.372-183.68-123.778-288.854-130.3 18.344-176.106 157.040-316.956 332.148-338.626 5.19 107.28 48.72 213.050 130.652 294.98 81.898 81.904 187.622 125.426 294.866 130.644-21.706 175.030-162.494 313.658-338.522 332.040z"
    ],
    "grid": 0,
    "tags": [
      "ios-tennisball-outline"
    ]
  },
  {
    "paths": [
      "M96.1 503.112c-0.002 0.078-0.006 0.154-0.008 0.232 0 0 0.004 0 0.006 0 0-0.076 0-0.154 0.002-0.232z",
      "M520.622 927.83c0.132-0.004 0.266-0.012 0.398-0.014-0.132 0.002-0.266 0.002-0.398 0.008 0-0 0 0.002 0 0.006z",
      "M512 96.002c-5.172 0-10.58 0.128-15.704 0.316l-0.296-0.012c0 0.006 0 0.008 0 0.012-10 0.398-20 1.204-32 2.41 0-0.004 0-0.008 0-0.016 0 0.010 0.166 0.016 0.144 0.024-193.948 22.122-347.308 177.95-366.26 372.82-0.008 0.036 0.090 0.444 0.084 0.444 0.006 0 0.008 0 0.014 0-1.026 10-1.652 20-1.872 32-0.002 0-0.006 0-0.008 0l0.006-0.304c-0.056 2.86-0.108 5.554-0.108 8.43 0 229.704 185.954 415.876 415.682 415.876 13.712 0 28.318-0.766 40.318-2.062 0 0.004 0 0.012 0 0.012 0-0.008 0.426-0.016 0.48-0.028 194.872-18.972 350.494-172.172 372.624-366.072 0.008-0.028 0.176 0.148 0.184 0.148-0.004 0-0.012 0-0.016 0 1.778-16 2.726-31.718 2.726-47.808 0.002-229.702-186.258-416.19-415.998-416.19zM261.26 533.706c-41.79-16.948-85.576-26.86-130.488-29.632 0.22-10.748 0.876-21.39 1.972-31.904 105.136 6.55 208.406 49.954 288.75 130.292s123.752 183.594 130.304 288.718c-10.514 1.096-21.158 1.752-31.908 1.97-2.77-44.906-12.684-88.688-29.632-130.472-20.918-51.58-51.668-97.874-91.392-137.59-39.722-39.72-86.020-70.466-137.606-91.382zM595.444 428.53c-81.928-81.918-125.462-187.67-130.664-294.934 10.5-1.304 21.136-2.16 31.882-2.586 2.146 47.3 12.21 93.404 30.014 137.308 20.922 51.58 51.67 97.872 91.392 137.59 39.724 39.718 86.020 70.464 137.606 91.382 43.908 17.802 90.016 27.866 137.32 30.014-0.426 10.74-1.286 21.378-2.586 31.878-107.28-5.204-213.036-48.732-294.964-130.652z"
    ],
    "grid": 0,
    "tags": [
      "ios-tennisball"
    ]
  },
  {
    "paths": [
      "M473.2 543.2c9.2 11.4 23 18.8 38.8 18.8 27.6 0 50-22.4 50-50 0-14.6-6.4-27.6-16.4-36.8-1.2-1.4-2.6-3-4.4-4.4 0 0-235.4-175-240.6-170.4s170.6 240.4 170.6 240.4c0.4 0.8 1.4 1.6 2 2.4z",
      "M512.4 96v0h-0.4v224h32v-189.4c195.6 16.6 350.6 181 350.6 381 0 211-171.4 382.8-382.4 382.8s-382.6-171.6-382.6-382.6c0-105.6 43-201.2 112.2-270.4l-23.8-23.6c-75.4 75.4-122 179.4-122 294.2 0 229.8 186.2 416 416 416s416-186.2 416-416c0-229.8-186-416-415.6-416z"
    ],
    "grid": 0,
    "tags": [
      "ios-timer-outline"
    ]
  },
  {
    "paths": [
      "M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM301 301c5.2-4.6 239.8 169.8 239.8 169.8 2 1.4 3.2 3 4.4 4.4 10 9.2 16.4 22 16.4 36.6 0 27.4-22.2 49.8-49.8 49.8-15.6 0-29.4-7.4-38.6-18.8-0.8-0.8-1.6-1.4-2.2-2.2 0.2 0.2-175-234.8-170-239.6zM512.2 894.4c-211.4 0-382.8-171.4-382.8-382.8 0-105.6 42.8-201.4 112-270.6l23.6 23.6c-63.2 63.2-102.4 150.6-102.4 247 0 192.6 156.8 349.4 349.4 349.4s349-156.8 349-349.4c0-180.6-141-330.2-317-348v156.4h-32v-191.2c211.4 0 383 171.4 383 382.8s-171.6 382.8-382.8 382.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-timer"
    ]
  },
  {
    "paths": [
      "M800 226.6h-160v-40c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v40h-160v29.4h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-29.4zM413.2 186.6c0-16.2 13.2-29.4 29.2-29.4h139c16.2 0 29.2 13.2 29.2 29.4v40h-197.4v-40zM683.2 835.8v1.6c0 16.2-13.2 29.4-29.2 29.4h-282c-16.2 0-29.2-13.2-29.2-29.4v-1.6l-47.4-579.8h434.4l-46.6 579.8z",
      "M498 320h28v482h-28v-482z",
      "M640 320h-29.2l-21.4 482h29.2z",
      "M413 320h-29l21.4 482h29.2z"
    ],
    "grid": 0,
    "tags": [
      "ios-trash-outline"
    ]
  },
  {
    "paths": [
      "M640 226v-39.4c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v39.4h-160v30h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-30h-160zM414 186.6c0-16.2 12.4-28.6 28.6-28.6h139c16.2 0 28.6 12.4 28.6 28.6v39.4h-196v-39.4h-0.2zM405.4 802l-21.4-482h29l21.8 482h-29.4zM526 802h-28v-482h28v482zM618.6 802h-29.2l21.6-482h29l-21.4 482z"
    ],
    "grid": 0,
    "tags": [
      "ios-trash"
    ]
  },
  {
    "paths": [
      "M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6zM864.4 722.8c-95.2-161.6-202.4-210.8-384.4-210.8v129.6l-296.2-193.4 296.2-193.6v129.4c402 0 384.4 338.8 384.4 338.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-undo-outline"
    ]
  },
  {
    "paths": [
      "M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6z"
    ],
    "grid": 0,
    "tags": [
      "ios-undo"
    ]
  },
  {
    "paths": [
      "M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4zM640 697.2c0 18.6-13.8 36.8-32.6 36.8h-442c-18.8 0-37.4-18.2-37.4-36.8v-375.8c0-18.6 18-31 36.8-31l442 0.2c18.8 0 33.2 12.2 33.2 30.8v375.8z",
      "M734 426v171.2l196 106.8v-384l-196 106zM896 380v264.6l-128-67v-131.2l128.2-67.2-0.2 0.8z"
    ],
    "grid": 0,
    "tags": [
      "ios-videocam-outline"
    ]
  },
  {
    "paths": [
      "M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4z",
      "M734 426v171.2l196 106.8v-384l-196 106z"
    ],
    "grid": 0,
    "tags": [
      "ios-videocam"
    ]
  }
]);


/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icons_kit__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_icons_kit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_icons_kit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ionicons__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_ionicons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_ionicons__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Iconset_js__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__style_js__ = __webpack_require__(556);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// icons
// utilities
/**
 * Render an Icon component
 *
 * <Icon iconset={iconset} size={size} />
 * iconset = string (check availableIconsets constant)
 * size = integer (default 60)
 */var Icon=function(_Component){_inherits(Icon,_Component);function Icon(props){_classCallCheck(this,Icon);var _this=_possibleConstructorReturn(this,(Icon.__proto__||Object.getPrototypeOf(Icon)).call(this,props));var iconset=Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["e" /* guessIconset */])(_this.props.iconset);_this.state={iconset:iconset};_this.size=Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["f" /* isIonicons */])(iconset)?_this.props.size+"":parseInt(_this.props.size,10);_this.color=_this.props.color||__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["a" /* _DefaultIconColor */];return _this;}_createClass(Icon,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.iconset!=nextProps.iconset){var iconset=Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["e" /* guessIconset */])(nextProps.iconset);this.setState({iconset:iconset});}}},{key:"renderReactIconsKit",value:function renderReactIconsKit(){var icon=Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["d" /* getReactIconsKitSvg */])(this.state.iconset,this.props.icon);if(!icon){return null;}// render icon
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_icons_kit___default.a,{icon:icon,color:this.color,size:this.size,style:__WEBPACK_IMPORTED_MODULE_4__style_js__["a" /* default */].icon});}},{key:"renderIonic",value:function renderIonic(){// console.log("renderIonic", this.props.icon)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_ionicons___default.a,{icon:this.props.icon,color:this.color,fontSize:this.size,style:__WEBPACK_IMPORTED_MODULE_4__style_js__["a" /* default */].icon});}},{key:"render",value:function render(){return Object(__WEBPACK_IMPORTED_MODULE_3__Iconset_js__["f" /* isIonicons */])(this.state.iconset)?this.renderIonic():this.renderReactIconsKit();}}]);return Icon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 1416 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon.Icon;
  }
});
Object.defineProperty(exports, "withBaseIcon", {
  enumerable: true,
  get: function get() {
    return _Icon.withBaseIcon;
  }
});
Object.defineProperty(exports, "horizontalCenter", {
  enumerable: true,
  get: function get() {
    return _horizontalCenter.horizontalCenter;
  }
});
exports.default = void 0;

var _Icon = __webpack_require__(1417);

var _horizontalCenter = __webpack_require__(1426);

var _default = _Icon.Icon;
exports.default = _default;

/***/ }),
/* 1417 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.withBaseIcon = exports.Icon = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _SvgIcon = _interopRequireDefault(__webpack_require__(1418));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Icon = function Icon(props) {
  var style = props.style,
      className = props.className,
      icon = props.icon,
      size = props.size,
      tag = props.tag,
      others = _objectWithoutProperties(props, ["style", "className", "icon", "size", "tag"]); //eslint-disable-line


  var Tag = tag;
  return _react.default.createElement(Tag, _extends({}, others, {
    style: _objectSpread({
      display: 'inline-block'
    }, style),
    className: className
  }), _react.default.createElement(_SvgIcon.default, {
    size: props.size,
    icon: props.icon,
    title: props.title
  }));
};

exports.Icon = Icon;

var withBaseIcon = function withBaseIcon(defaultProps) {
  return function (props) {
    var propsToUse = _objectSpread({}, defaultProps);

    return _react.default.createElement(Icon, _extends({}, propsToUse, props));
  };
};

exports.withBaseIcon = withBaseIcon;
Icon.defaultProps = {
  size: 16,
  fill: 'currentColor',
  tag: 'i'
};
Icon.propTypes = {
  icon: _propTypes.default.object.isRequired,
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  style: _propTypes.default.object,
  tag: _propTypes.default.oneOf(['i', 'span', 'div']),
  className: _propTypes.default.string
};
var _default = Icon;
exports.default = _default;

/***/ }),
/* 1418 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.SvgIcon = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _camelCase = _interopRequireDefault(__webpack_require__(1419));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var walkChildren = function walkChildren(children) {
  return children.map(function (child, idx) {
    var name = child.name,
        attribsMap = child.attribs,
        _child$children = child.children,
        gchildren = _child$children === void 0 ? null : _child$children; //fill, stroke

    var attribs = Object.keys(attribsMap).filter(function (key) {
      return key !== 'fill' && key !== 'stroke' && attribsMap[key] !== 'none';
    }).reduce(function (partial, key) {
      partial[(0, _camelCase.default)(key)] = attribsMap[key];
      return partial;
    }, {}); //special case, it has fill and stroke at the same time

    var merge = {};

    if (attribsMap.fill === 'none' && attribsMap.stroke) {
      merge = {
        fill: 'none',
        stroke: 'currentColor'
      };
    }

    return (0, _react.createElement)(name, _objectSpread({
      key: idx
    }, attribs, merge), gchildren === null ? gchildren : walkChildren(gchildren));
  });
};

var SvgIcon = function SvgIcon(props) {
  var size = props.size;
  var _props$icon = props.icon,
      children = _props$icon.children,
      viewBox = _props$icon.viewBox,
      _props$icon$attribs = _props$icon.attribs,
      svgAttribs = _props$icon$attribs === void 0 ? {} : _props$icon$attribs;
  var camelCasedAttribs = Object.keys(svgAttribs).reduce(function (partial, key) {
    partial[(0, _camelCase.default)(key)] = svgAttribs[key];
    return partial;
  }, {});
  return _react.default.createElement("svg", _extends({
    fill: "currentColor",
    style: {
      display: 'inline-block',
      verticalAlign: 'middle'
    },
    height: size,
    width: size,
    viewBox: viewBox
  }, camelCasedAttribs), props.title ? _react.default.createElement("title", null, props.title) : null, walkChildren(children));
};

exports.SvgIcon = SvgIcon;
SvgIcon.defaultProps = {
  size: 16
};
SvgIcon.propTypes = {
  icon: _propTypes.default.object.isRequired,
  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  title: _propTypes.default.string
};
var _default = SvgIcon;
exports.default = _default;

/***/ }),
/* 1419 */
/***/ (function(module, exports, __webpack_require__) {

var upperCase = __webpack_require__(1420)
var noCase = __webpack_require__(1421)

/**
 * Camel case a string.
 *
 * @param  {string} value
 * @param  {string} [locale]
 * @return {string}
 */
module.exports = function (value, locale, mergeNumbers) {
  var result = noCase(value, locale)

  // Replace periods between numeric entities with an underscore.
  if (!mergeNumbers) {
    result = result.replace(/ (?=\d)/g, '_')
  }

  // Replace spaces between words with an upper cased character.
  return result.replace(/ (.)/g, function (m, $1) {
    return upperCase($1, locale)
  })
}


/***/ }),
/* 1420 */
/***/ (function(module, exports) {

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  az: {
    regexp: /[\u0069]/g,
    map: {
      '\u0069': '\u0130'
    }
  },
  lt: {
    regexp: /[\u0069\u006A\u012F]\u0307|\u0069\u0307[\u0300\u0301\u0303]/g,
    map: {
      '\u0069\u0307': '\u0049',
      '\u006A\u0307': '\u004A',
      '\u012F\u0307': '\u012E',
      '\u0069\u0307\u0300': '\u00CC',
      '\u0069\u0307\u0301': '\u00CD',
      '\u0069\u0307\u0303': '\u0128'
    }
  }
}

/**
 * Upper case a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toUpperCase()
}


/***/ }),
/* 1421 */
/***/ (function(module, exports, __webpack_require__) {

var lowerCase = __webpack_require__(1422)

var NON_WORD_REGEXP = __webpack_require__(1423)
var CAMEL_CASE_REGEXP = __webpack_require__(1424)
var CAMEL_CASE_UPPER_REGEXP = __webpack_require__(1425)

/**
 * Sentence case a string.
 *
 * @param  {string} str
 * @param  {string} locale
 * @param  {string} replacement
 * @return {string}
 */
module.exports = function (str, locale, replacement) {
  if (str == null) {
    return ''
  }

  replacement = typeof replacement !== 'string' ? ' ' : replacement

  function replace (match, index, value) {
    if (index === 0 || index === (value.length - match.length)) {
      return ''
    }

    return replacement
  }

  str = String(str)
    // Support camel case ("camelCase" -> "camel Case").
    .replace(CAMEL_CASE_REGEXP, '$1 $2')
    // Support odd camel case ("CAMELCase" -> "CAMEL Case").
    .replace(CAMEL_CASE_UPPER_REGEXP, '$1 $2')
    // Remove all non-word characters and replace with a single space.
    .replace(NON_WORD_REGEXP, replace)

  // Lower case the entire string.
  return lowerCase(str, locale)
}


/***/ }),
/* 1422 */
/***/ (function(module, exports) {

/**
 * Special language-specific overrides.
 *
 * Source: ftp://ftp.unicode.org/Public/UCD/latest/ucd/SpecialCasing.txt
 *
 * @type {Object}
 */
var LANGUAGES = {
  tr: {
    regexp: /\u0130|\u0049|\u0049\u0307/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  az: {
    regexp: /[\u0130]/g,
    map: {
      '\u0130': '\u0069',
      '\u0049': '\u0131',
      '\u0049\u0307': '\u0069'
    }
  },
  lt: {
    regexp: /[\u0049\u004A\u012E\u00CC\u00CD\u0128]/g,
    map: {
      '\u0049': '\u0069\u0307',
      '\u004A': '\u006A\u0307',
      '\u012E': '\u012F\u0307',
      '\u00CC': '\u0069\u0307\u0300',
      '\u00CD': '\u0069\u0307\u0301',
      '\u0128': '\u0069\u0307\u0303'
    }
  }
}

/**
 * Lowercase a string.
 *
 * @param  {String} str
 * @return {String}
 */
module.exports = function (str, locale) {
  var lang = LANGUAGES[locale]

  str = str == null ? '' : String(str)

  if (lang) {
    str = str.replace(lang.regexp, function (m) { return lang.map[m] })
  }

  return str.toLowerCase()
}


/***/ }),
/* 1423 */
/***/ (function(module, exports) {

module.exports = /[^A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0-\u08B4\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FD5\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AD\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19]+/g


/***/ }),
/* 1424 */
/***/ (function(module, exports) {

module.exports = /([a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A0-9\xB2\xB3\xB9\xBC-\xBE\u0660-\u0669\u06F0-\u06F9\u07C0-\u07C9\u0966-\u096F\u09E6-\u09EF\u09F4-\u09F9\u0A66-\u0A6F\u0AE6-\u0AEF\u0B66-\u0B6F\u0B72-\u0B77\u0BE6-\u0BF2\u0C66-\u0C6F\u0C78-\u0C7E\u0CE6-\u0CEF\u0D66-\u0D75\u0DE6-\u0DEF\u0E50-\u0E59\u0ED0-\u0ED9\u0F20-\u0F33\u1040-\u1049\u1090-\u1099\u1369-\u137C\u16EE-\u16F0\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1946-\u194F\u19D0-\u19DA\u1A80-\u1A89\u1A90-\u1A99\u1B50-\u1B59\u1BB0-\u1BB9\u1C40-\u1C49\u1C50-\u1C59\u2070\u2074-\u2079\u2080-\u2089\u2150-\u2182\u2185-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2CFD\u3007\u3021-\u3029\u3038-\u303A\u3192-\u3195\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\uA620-\uA629\uA6E6-\uA6EF\uA830-\uA835\uA8D0-\uA8D9\uA900-\uA909\uA9D0-\uA9D9\uA9F0-\uA9F9\uAA50-\uAA59\uABF0-\uABF9\uFF10-\uFF19])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])/g


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

module.exports = /([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A])([A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2E\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AD\uA7B0-\uA7B4\uA7B6\uFF21-\uFF3A][a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0561-\u0587\u13F8-\u13FD\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5E\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7B5\uA7B7\uA7FA\uAB30-\uAB5A\uAB60-\uAB65\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A])/g


/***/ }),
/* 1426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.horizontalCenter = void 0;

var _react = _interopRequireWildcard(__webpack_require__(0));

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var horizontalCenter = function horizontalCenter(Component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$rAlign = _ref.rAlign,
      rAlign = _ref$rAlign === void 0 ? false : _ref$rAlign,
      _ref$space = _ref.space,
      space = _ref$space === void 0 ? 4 : _ref$space;

  return function (props) {
    return _react.default.createElement(Component, props, _react.default.createElement("div", {
      style: {
        display: 'inline-flex',
        justifyContent: 'center',
        'alignItems': 'center'
      }
    }, _react.Children.toArray(props.children).map(function (child, idx) {
      var spacerField = rAlign ? 'paddingLeft' : 'paddingRight';
      return _react.default.createElement("div", {
        key: idx,
        style: _defineProperty({
          display: 'inline-block'
        }, spacerField, space)
      }, child);
    })));
  };
};

exports.horizontalCenter = horizontalCenter;
var _default = horizontalCenter;
exports.default = _default;

/***/ }),
/* 1427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(547);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(553);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _icons = __webpack_require__(1442);

var _icons2 = _interopRequireDefault(_icons);

var _SVG = __webpack_require__(1443);

var _SVG2 = _interopRequireDefault(_SVG);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Ionicon = function (_Component) {
  _inherits(Ionicon, _Component);

  function Ionicon(props) {
    _classCallCheck(this, Ionicon);

    var _this = _possibleConstructorReturn(this, (Ionicon.__proto__ || Object.getPrototypeOf(Ionicon)).call(this, props));

    _this.state = { classNames: [], animationActive: false };
    _this._getClasses = _this._getClasses.bind(_this);
    return _this;
  }

  _createClass(Ionicon, [{
    key: 'render',
    value: function render() {
      var style = _extends({}, this.props.style, {
        color: this.props.color,
        fontSize: this.props.fontSize
      });

      return _react2.default.createElement(
        _SVG2.default,
        {
          style: this.props.style,
          className: this._getClasses(),
          fill: this.props.color,
          width: this.props.fontSize,
          height: this.props.fontSize,
          viewBox: '0 0 1024 1024',
          onClick: this.props.onClick,
          rotate: this.props.rotate ? 1 : 0,
          shake: this.props.shake ? 1 : 0,
          beat: this.props.beat ? 1 : 0
        },
        _react2.default.createElement('path', { d: this._getPathByIconName() })
      );
    }
  }, {
    key: '_getClasses',
    value: function _getClasses() {
      return [].concat(_toConsumableArray(this.state.classNames), [this.props.className]).join(' ');
    }
  }, {
    key: '_getPathByIconName',
    value: function _getPathByIconName() {
      var _this2 = this;

      var icon = _icons2.default.find(function (icon) {
        return icon.tags[0] === _this2.props.icon;
      });
      if (icon) return icon.paths.join(' ');
      return '';
    }
  }]);

  return Ionicon;
}(_react.Component);

Ionicon.defaultProps = {
  // style
  style: {},
  color: '#000000',
  fontSize: '22px',

  // animation
  shake: false,
  beat: false,
  rotate: false
};

Ionicon.propTypes = {
  // style
  style: _propTypes2.default.object,
  color: _propTypes2.default.string,
  fontSize: _propTypes2.default.string,

  // animation
  shake: _propTypes2.default.bool,
  beat: _propTypes2.default.bool,
  rotate: _propTypes2.default.bool,

  // functions
  onClick: _propTypes2.default.func
};

exports.default = Ionicon;
module.exports = exports['default'];
//# sourceMappingURL=index.js.map

/***/ }),
/* 1428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var ReactChildren = __webpack_require__(1429);
var ReactComponent = __webpack_require__(293);
var ReactPureComponent = __webpack_require__(1433);
var ReactClass = __webpack_require__(1434);
var ReactDOMFactories = __webpack_require__(1435);
var ReactElement = __webpack_require__(126);
var ReactPropTypes = __webpack_require__(1436);
var ReactVersion = __webpack_require__(1438);

var onlyChild = __webpack_require__(1439);
var warning = __webpack_require__(80);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;

if (false) {
  var warned = false;
  __spread = function () {
    process.env.NODE_ENV !== 'production' ? warning(warned, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.') : void 0;
    warned = true;
    return _assign.apply(null, arguments);
  };
}

var React = {

  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactComponent,
  PureComponent: ReactPureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: ReactClass.createClass,
  createFactory: createFactory,
  createMixin: function (mixin) {
    // Currently a noop. Will be used to validate and trace mixins.
    return mixin;
  },

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

module.exports = React;

/***/ }),
/* 1429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var PooledClass = __webpack_require__(1430);
var ReactElement = __webpack_require__(126);

var emptyFunction = __webpack_require__(129);
var traverseAllChildren = __webpack_require__(1431);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var _prodInvariant = __webpack_require__(151);

var invariant = __webpack_require__(79);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(151);

var ReactCurrentOwner = __webpack_require__(548);
var REACT_ELEMENT_TYPE = __webpack_require__(550);

var getIteratorFn = __webpack_require__(551);
var invariant = __webpack_require__(79);
var KeyEscapeUtils = __webpack_require__(1432);
var warning = __webpack_require__(80);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = ' It looks like you\'re using an element created by a different ' + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _assign = __webpack_require__(77);

var ReactComponent = __webpack_require__(293);
var ReactNoopUpdateQueue = __webpack_require__(294);

var emptyObject = __webpack_require__(295);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = ReactPureComponent;

/***/ }),
/* 1434 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var _prodInvariant = __webpack_require__(151),
    _assign = __webpack_require__(77);

var ReactComponent = __webpack_require__(293);
var ReactElement = __webpack_require__(126);
var ReactPropTypeLocationNames = __webpack_require__(552);
var ReactNoopUpdateQueue = __webpack_require__(294);

var emptyObject = __webpack_require__(295);
var invariant = __webpack_require__(79);
var warning = __webpack_require__(80);

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

/**
 * Policies that describe methods in `ReactClassInterface`.
 */


var injectedMixins = [];

/**
 * Composite components are higher-level components that compose other composite
 * or host components.
 *
 * To create a new type of `ReactClass`, pass a specification of
 * your new class to `React.createClass`. The only requirement of your class
 * specification is that you implement a `render` method.
 *
 *   var MyComponent = React.createClass({
 *     render: function() {
 *       return <div>Hello World</div>;
 *     }
 *   });
 *
 * The class specification supports a specific protocol of methods that have
 * special meaning (e.g. `render`). See `ReactClassInterface` for
 * more the comprehensive protocol. Any other properties and methods in the
 * class specification will be available on the prototype.
 *
 * @interface ReactClassInterface
 * @internal
 */
var ReactClassInterface = {

  /**
   * An array of Mixin objects to include when defining your component.
   *
   * @type {array}
   * @optional
   */
  mixins: 'DEFINE_MANY',

  /**
   * An object containing properties and methods that should be defined on
   * the component's constructor instead of its prototype (static methods).
   *
   * @type {object}
   * @optional
   */
  statics: 'DEFINE_MANY',

  /**
   * Definition of prop types for this component.
   *
   * @type {object}
   * @optional
   */
  propTypes: 'DEFINE_MANY',

  /**
   * Definition of context types for this component.
   *
   * @type {object}
   * @optional
   */
  contextTypes: 'DEFINE_MANY',

  /**
   * Definition of context types this component sets for its children.
   *
   * @type {object}
   * @optional
   */
  childContextTypes: 'DEFINE_MANY',

  // ==== Definition methods ====

  /**
   * Invoked when the component is mounted. Values in the mapping will be set on
   * `this.props` if that prop is not specified (i.e. using an `in` check).
   *
   * This method is invoked before `getInitialState` and therefore cannot rely
   * on `this.state` or use `this.setState`.
   *
   * @return {object}
   * @optional
   */
  getDefaultProps: 'DEFINE_MANY_MERGED',

  /**
   * Invoked once before the component is mounted. The return value will be used
   * as the initial value of `this.state`.
   *
   *   getInitialState: function() {
   *     return {
   *       isOn: false,
   *       fooBaz: new BazFoo()
   *     }
   *   }
   *
   * @return {object}
   * @optional
   */
  getInitialState: 'DEFINE_MANY_MERGED',

  /**
   * @return {object}
   * @optional
   */
  getChildContext: 'DEFINE_MANY_MERGED',

  /**
   * Uses props from `this.props` and state from `this.state` to render the
   * structure of the component.
   *
   * No guarantees are made about when or how often this method is invoked, so
   * it must not have side effects.
   *
   *   render: function() {
   *     var name = this.props.name;
   *     return <div>Hello, {name}!</div>;
   *   }
   *
   * @return {ReactComponent}
   * @nosideeffects
   * @required
   */
  render: 'DEFINE_ONCE',

  // ==== Delegate methods ====

  /**
   * Invoked when the component is initially created and about to be mounted.
   * This may have side effects, but any external subscriptions or data created
   * by this method must be cleaned up in `componentWillUnmount`.
   *
   * @optional
   */
  componentWillMount: 'DEFINE_MANY',

  /**
   * Invoked when the component has been mounted and has a DOM representation.
   * However, there is no guarantee that the DOM node is in the document.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been mounted (initialized and rendered) for the first time.
   *
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidMount: 'DEFINE_MANY',

  /**
   * Invoked before the component receives new props.
   *
   * Use this as an opportunity to react to a prop transition by updating the
   * state using `this.setState`. Current props are accessed via `this.props`.
   *
   *   componentWillReceiveProps: function(nextProps, nextContext) {
   *     this.setState({
   *       likesIncreasing: nextProps.likeCount > this.props.likeCount
   *     });
   *   }
   *
   * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
   * transition may cause a state change, but the opposite is not true. If you
   * need it, you are probably looking for `componentWillUpdate`.
   *
   * @param {object} nextProps
   * @optional
   */
  componentWillReceiveProps: 'DEFINE_MANY',

  /**
   * Invoked while deciding if the component should be updated as a result of
   * receiving new props, state and/or context.
   *
   * Use this as an opportunity to `return false` when you're certain that the
   * transition to the new props/state/context will not require a component
   * update.
   *
   *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
   *     return !equal(nextProps, this.props) ||
   *       !equal(nextState, this.state) ||
   *       !equal(nextContext, this.context);
   *   }
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @return {boolean} True if the component should update.
   * @optional
   */
  shouldComponentUpdate: 'DEFINE_ONCE',

  /**
   * Invoked when the component is about to update due to a transition from
   * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
   * and `nextContext`.
   *
   * Use this as an opportunity to perform preparation before an update occurs.
   *
   * NOTE: You **cannot** use `this.setState()` in this method.
   *
   * @param {object} nextProps
   * @param {?object} nextState
   * @param {?object} nextContext
   * @param {ReactReconcileTransaction} transaction
   * @optional
   */
  componentWillUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component's DOM representation has been updated.
   *
   * Use this as an opportunity to operate on the DOM when the component has
   * been updated.
   *
   * @param {object} prevProps
   * @param {?object} prevState
   * @param {?object} prevContext
   * @param {DOMElement} rootNode DOM element representing the component.
   * @optional
   */
  componentDidUpdate: 'DEFINE_MANY',

  /**
   * Invoked when the component is about to be removed from its parent and have
   * its DOM representation destroyed.
   *
   * Use this as an opportunity to deallocate any external resources.
   *
   * NOTE: There is no `componentDidUnmount` since your component will have been
   * destroyed by that point.
   *
   * @optional
   */
  componentWillUnmount: 'DEFINE_MANY',

  // ==== Advanced methods ====

  /**
   * Updates the component's currently mounted DOM representation.
   *
   * By default, this implements React's rendering and reconciliation algorithm.
   * Sophisticated clients may wish to override this.
   *
   * @param {ReactReconcileTransaction} transaction
   * @internal
   * @overridable
   */
  updateComponent: 'OVERRIDE_BASE'

};

/**
 * Mapping from class specification keys to special processing functions.
 *
 * Although these are declared like instance properties in the specification
 * when defining classes using `React.createClass`, they are actually static
 * and are accessible on the constructor instead of the prototype. Despite
 * being static, they must be defined outside of the "statics" key under
 * which all other static methods are defined.
 */
var RESERVED_SPEC_KEYS = {
  displayName: function (Constructor, displayName) {
    Constructor.displayName = displayName;
  },
  mixins: function (Constructor, mixins) {
    if (mixins) {
      for (var i = 0; i < mixins.length; i++) {
        mixSpecIntoComponent(Constructor, mixins[i]);
      }
    }
  },
  childContextTypes: function (Constructor, childContextTypes) {
    if (false) {
      validateTypeDef(Constructor, childContextTypes, 'childContext');
    }
    Constructor.childContextTypes = _assign({}, Constructor.childContextTypes, childContextTypes);
  },
  contextTypes: function (Constructor, contextTypes) {
    if (false) {
      validateTypeDef(Constructor, contextTypes, 'context');
    }
    Constructor.contextTypes = _assign({}, Constructor.contextTypes, contextTypes);
  },
  /**
   * Special case getDefaultProps which should move into statics but requires
   * automatic merging.
   */
  getDefaultProps: function (Constructor, getDefaultProps) {
    if (Constructor.getDefaultProps) {
      Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
    } else {
      Constructor.getDefaultProps = getDefaultProps;
    }
  },
  propTypes: function (Constructor, propTypes) {
    if (false) {
      validateTypeDef(Constructor, propTypes, 'prop');
    }
    Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
  },
  statics: function (Constructor, statics) {
    mixStaticSpecIntoComponent(Constructor, statics);
  },
  autobind: function () {} };

function validateTypeDef(Constructor, typeDef, location) {
  for (var propName in typeDef) {
    if (typeDef.hasOwnProperty(propName)) {
      // use a warning instead of an invariant so components
      // don't show up in prod but only in __DEV__
       false ? warning(typeof typeDef[propName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'React.PropTypes.', Constructor.displayName || 'ReactClass', ReactPropTypeLocationNames[location], propName) : void 0;
    }
  }
}

function validateMethodOverride(isAlreadyDefined, name) {
  var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;

  // Disallow overriding of base class methods unless explicitly allowed.
  if (ReactClassMixin.hasOwnProperty(name)) {
    !(specPolicy === 'OVERRIDE_BASE') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.', name) : _prodInvariant('73', name) : void 0;
  }

  // Disallow defining methods more than once unless explicitly allowed.
  if (isAlreadyDefined) {
    !(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED') ?  false ? invariant(false, 'ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('74', name) : void 0;
  }
}

/**
 * Mixin helper which handles policy validation and reserved
 * specification keys when building React classes.
 */
function mixSpecIntoComponent(Constructor, spec) {
  if (!spec) {
    if (false) {
      var typeofSpec = typeof spec;
      var isMixinValid = typeofSpec === 'object' && spec !== null;

      process.env.NODE_ENV !== 'production' ? warning(isMixinValid, '%s: You\'re attempting to include a mixin that is either null ' + 'or not an object. Check the mixins included by the component, ' + 'as well as any mixins they include themselves. ' + 'Expected object but got %s.', Constructor.displayName || 'ReactClass', spec === null ? null : typeofSpec) : void 0;
    }

    return;
  }

  !(typeof spec !== 'function') ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component class or function as a mixin. Instead, just use a regular object.') : _prodInvariant('75') : void 0;
  !!ReactElement.isValidElement(spec) ?  false ? invariant(false, 'ReactClass: You\'re attempting to use a component as a mixin. Instead, just use a regular object.') : _prodInvariant('76') : void 0;

  var proto = Constructor.prototype;
  var autoBindPairs = proto.__reactAutoBindPairs;

  // By handling mixins before any other properties, we ensure the same
  // chaining order is applied to methods with DEFINE_MANY policy, whether
  // mixins are listed before or after these methods in the spec.
  if (spec.hasOwnProperty(MIXINS_KEY)) {
    RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
  }

  for (var name in spec) {
    if (!spec.hasOwnProperty(name)) {
      continue;
    }

    if (name === MIXINS_KEY) {
      // We have already handled mixins in a special case above.
      continue;
    }

    var property = spec[name];
    var isAlreadyDefined = proto.hasOwnProperty(name);
    validateMethodOverride(isAlreadyDefined, name);

    if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
      RESERVED_SPEC_KEYS[name](Constructor, property);
    } else {
      // Setup methods on prototype:
      // The following member methods should not be automatically bound:
      // 1. Expected ReactClass methods (in the "interface").
      // 2. Overridden methods (that were mixed in).
      var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
      var isFunction = typeof property === 'function';
      var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;

      if (shouldAutoBind) {
        autoBindPairs.push(name, property);
        proto[name] = property;
      } else {
        if (isAlreadyDefined) {
          var specPolicy = ReactClassInterface[name];

          // These cases should already be caught by validateMethodOverride.
          !(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY')) ?  false ? invariant(false, 'ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.', specPolicy, name) : _prodInvariant('77', specPolicy, name) : void 0;

          // For methods which are defined more than once, call the existing
          // methods before calling the new property, merging if appropriate.
          if (specPolicy === 'DEFINE_MANY_MERGED') {
            proto[name] = createMergedResultFunction(proto[name], property);
          } else if (specPolicy === 'DEFINE_MANY') {
            proto[name] = createChainedFunction(proto[name], property);
          }
        } else {
          proto[name] = property;
          if (false) {
            // Add verbose displayName to the function, which helps when looking
            // at profiling tools.
            if (typeof property === 'function' && spec.displayName) {
              proto[name].displayName = spec.displayName + '_' + name;
            }
          }
        }
      }
    }
  }
}

function mixStaticSpecIntoComponent(Constructor, statics) {
  if (!statics) {
    return;
  }
  for (var name in statics) {
    var property = statics[name];
    if (!statics.hasOwnProperty(name)) {
      continue;
    }

    var isReserved = name in RESERVED_SPEC_KEYS;
    !!isReserved ?  false ? invariant(false, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name) : _prodInvariant('78', name) : void 0;

    var isInherited = name in Constructor;
    !!isInherited ?  false ? invariant(false, 'ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.', name) : _prodInvariant('79', name) : void 0;
    Constructor[name] = property;
  }
}

/**
 * Merge two objects, but throw if both contain the same key.
 *
 * @param {object} one The first object, which is mutated.
 * @param {object} two The second object
 * @return {object} one after it has been mutated to contain everything in two.
 */
function mergeIntoWithNoDuplicateKeys(one, two) {
  !(one && two && typeof one === 'object' && typeof two === 'object') ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.') : _prodInvariant('80') : void 0;

  for (var key in two) {
    if (two.hasOwnProperty(key)) {
      !(one[key] === undefined) ?  false ? invariant(false, 'mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.', key) : _prodInvariant('81', key) : void 0;
      one[key] = two[key];
    }
  }
  return one;
}

/**
 * Creates a function that invokes two functions and merges their return values.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createMergedResultFunction(one, two) {
  return function mergedResult() {
    var a = one.apply(this, arguments);
    var b = two.apply(this, arguments);
    if (a == null) {
      return b;
    } else if (b == null) {
      return a;
    }
    var c = {};
    mergeIntoWithNoDuplicateKeys(c, a);
    mergeIntoWithNoDuplicateKeys(c, b);
    return c;
  };
}

/**
 * Creates a function that invokes two functions and ignores their return vales.
 *
 * @param {function} one Function to invoke first.
 * @param {function} two Function to invoke second.
 * @return {function} Function that invokes the two argument functions.
 * @private
 */
function createChainedFunction(one, two) {
  return function chainedFunction() {
    one.apply(this, arguments);
    two.apply(this, arguments);
  };
}

/**
 * Binds a method to the component.
 *
 * @param {object} component Component whose method is going to be bound.
 * @param {function} method Method to be bound.
 * @return {function} The bound method.
 */
function bindAutoBindMethod(component, method) {
  var boundMethod = method.bind(component);
  if (false) {
    boundMethod.__reactBoundContext = component;
    boundMethod.__reactBoundMethod = method;
    boundMethod.__reactBoundArguments = null;
    var componentName = component.constructor.displayName;
    var _bind = boundMethod.bind;
    boundMethod.bind = function (newThis) {
      for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      // User is trying to bind() an autobound method; we effectively will
      // ignore the value of "this" that the user is trying to use, so
      // let's warn.
      if (newThis !== component && newThis !== null) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): React component methods may only be bound to the ' + 'component instance. See %s', componentName) : void 0;
      } else if (!args.length) {
        process.env.NODE_ENV !== 'production' ? warning(false, 'bind(): You are binding a component method to the component. ' + 'React does this for you automatically in a high-performance ' + 'way, so you can safely remove this call. See %s', componentName) : void 0;
        return boundMethod;
      }
      var reboundMethod = _bind.apply(boundMethod, arguments);
      reboundMethod.__reactBoundContext = component;
      reboundMethod.__reactBoundMethod = method;
      reboundMethod.__reactBoundArguments = args;
      return reboundMethod;
    };
  }
  return boundMethod;
}

/**
 * Binds all auto-bound methods in a component.
 *
 * @param {object} component Component whose method is going to be bound.
 */
function bindAutoBindMethods(component) {
  var pairs = component.__reactAutoBindPairs;
  for (var i = 0; i < pairs.length; i += 2) {
    var autoBindKey = pairs[i];
    var method = pairs[i + 1];
    component[autoBindKey] = bindAutoBindMethod(component, method);
  }
}

/**
 * Add more to the ReactClass base class. These are all legacy features and
 * therefore not already part of the modern ReactComponent.
 */
var ReactClassMixin = {

  /**
   * TODO: This will be deprecated because state should always keep a consistent
   * type signature and the only use case for this, is to avoid that.
   */
  replaceState: function (newState, callback) {
    this.updater.enqueueReplaceState(this, newState);
    if (callback) {
      this.updater.enqueueCallback(this, callback, 'replaceState');
    }
  },

  /**
   * Checks whether or not this composite component is mounted.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function () {
    return this.updater.isMounted(this);
  }
};

var ReactClassComponent = function () {};
_assign(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);

/**
 * Module for creating composite components.
 *
 * @class ReactClass
 */
var ReactClass = {

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  createClass: function (spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function (props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        process.env.NODE_ENV !== 'production' ? warning(this instanceof Constructor, 'Something is calling a React component directly. Use a factory or ' + 'JSX instead. See: https://fb.me/react-legacyfactory') : void 0;
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (initialState === undefined && this.getInitialState._isMockFunction) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent') : _prodInvariant('82', Constructor.displayName || 'ReactCompositeComponent') : void 0;

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, spec);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    !Constructor.prototype.render ?  false ? invariant(false, 'createClass(...): Class specification must implement a `render` method.') : _prodInvariant('83') : void 0;

    if (false) {
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentShouldUpdate, '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', spec.displayName || 'A component') : void 0;
      process.env.NODE_ENV !== 'production' ? warning(!Constructor.prototype.componentWillRecieveProps, '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', spec.displayName || 'A component') : void 0;
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  },

  injection: {
    injectMixin: function (mixin) {
      injectedMixins.push(mixin);
    }
  }

};

module.exports = ReactClass;

/***/ }),
/* 1435 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(126);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 * This is also accessible via `React.DOM`.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



var ReactElement = __webpack_require__(126);
var ReactPropTypeLocationNames = __webpack_require__(552);
var ReactPropTypesSecret = __webpack_require__(1437);

var emptyFunction = __webpack_require__(129);
var getIteratorFn = __webpack_require__(551);
var warning = __webpack_require__(80);

/**
 * Collection of methods that allow declaration and validation of props that are
 * supplied to React components. Example usage:
 *
 *   var Props = require('ReactPropTypes');
 *   var MyArticle = React.createClass({
 *     propTypes: {
 *       // An optional string prop named "description".
 *       description: Props.string,
 *
 *       // A required enum prop named "category".
 *       category: Props.oneOf(['News','Photos']).isRequired,
 *
 *       // A prop named "dialog" that requires an instance of Dialog.
 *       dialog: Props.instanceOf(Dialog).isRequired
 *     },
 *     render: function() { ... }
 *   });
 *
 * A more formal specification of how these methods are used:
 *
 *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
 *   decl := ReactPropTypes.{type}(.isRequired)?
 *
 * Each and every declaration produces a function with the same signature. This
 * allows the creation of custom validation functions. For example:
 *
 *  var MyLink = React.createClass({
 *    propTypes: {
 *      // An optional string or URI prop named "href".
 *      href: function(props, propName, componentName) {
 *        var propValue = props[propName];
 *        if (propValue != null && typeof propValue !== 'string' &&
 *            !(propValue instanceof URI)) {
 *          return new Error(
 *            'Expected a string or an URI for ' + propName + ' in ' +
 *            componentName
 *          );
 *        }
 *      }
 *    },
 *    render: function() {...}
 *  });
 *
 * @internal
 */

var ANONYMOUS = '<<anonymous>>';

var ReactPropTypes = {
  array: createPrimitiveTypeChecker('array'),
  bool: createPrimitiveTypeChecker('boolean'),
  func: createPrimitiveTypeChecker('function'),
  number: createPrimitiveTypeChecker('number'),
  object: createPrimitiveTypeChecker('object'),
  string: createPrimitiveTypeChecker('string'),
  symbol: createPrimitiveTypeChecker('symbol'),

  any: createAnyTypeChecker(),
  arrayOf: createArrayOfTypeChecker,
  element: createElementTypeChecker(),
  instanceOf: createInstanceTypeChecker,
  node: createNodeChecker(),
  objectOf: createObjectOfTypeChecker,
  oneOf: createEnumTypeChecker,
  oneOfType: createUnionTypeChecker,
  shape: createShapeTypeChecker
};

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
/*eslint-disable no-self-compare*/
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return x !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}
/*eslint-enable no-self-compare*/

/**
 * We use an Error-like object for backward compatibility as people may call
 * PropTypes directly and inspect their output. However we don't use real
 * Errors anymore. We don't inspect their stack anyway, and creating them
 * is prohibitively expensive if they are created too often, such as what
 * happens in oneOfType() for any type before the one that matched.
 */
function PropTypeError(message) {
  this.message = message;
  this.stack = '';
}
// Make `instanceof Error` still work for returned errors.
PropTypeError.prototype = Error.prototype;

function createChainableTypeChecker(validate) {
  if (false) {
    var manualPropTypeCallCache = {};
  }
  function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
    componentName = componentName || ANONYMOUS;
    propFullName = propFullName || propName;
    if (false) {
      if (secret !== ReactPropTypesSecret && typeof console !== 'undefined') {
        var cacheKey = componentName + ':' + propName;
        if (!manualPropTypeCallCache[cacheKey]) {
          process.env.NODE_ENV !== 'production' ? warning(false, 'You are manually calling a React.PropTypes validation ' + 'function for the `%s` prop on `%s`. This is deprecated ' + 'and will not work in production with the next major version. ' + 'You may be seeing this warning due to a third-party PropTypes ' + 'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.', propFullName, componentName) : void 0;
          manualPropTypeCallCache[cacheKey] = true;
        }
      }
    }
    if (props[propName] == null) {
      var locationName = ReactPropTypeLocationNames[location];
      if (isRequired) {
        if (props[propName] === null) {
          return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
        }
        return new PropTypeError('The ' + locationName + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
      }
      return null;
    } else {
      return validate(props, propName, componentName, location, propFullName);
    }
  }

  var chainedCheckType = checkType.bind(null, false);
  chainedCheckType.isRequired = checkType.bind(null, true);

  return chainedCheckType;
}

function createPrimitiveTypeChecker(expectedType) {
  function validate(props, propName, componentName, location, propFullName, secret) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== expectedType) {
      var locationName = ReactPropTypeLocationNames[location];
      // `propValue` being instance of, say, date/regexp, pass the 'object'
      // check, but we can offer a more precise error message here rather than
      // 'of type `object`'.
      var preciseType = getPreciseType(propValue);

      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createAnyTypeChecker() {
  return createChainableTypeChecker(emptyFunction.thatReturns(null));
}

function createArrayOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
    }
    var propValue = props[propName];
    if (!Array.isArray(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
    }
    for (var i = 0; i < propValue.length; i++) {
      var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
      if (error instanceof Error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createElementTypeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    if (!ReactElement.isValidElement(propValue)) {
      var locationName = ReactPropTypeLocationNames[location];
      var propType = getPropType(propValue);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createInstanceTypeChecker(expectedClass) {
  function validate(props, propName, componentName, location, propFullName) {
    if (!(props[propName] instanceof expectedClass)) {
      var locationName = ReactPropTypeLocationNames[location];
      var expectedClassName = expectedClass.name || ANONYMOUS;
      var actualClassName = getClassName(props[propName]);
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createEnumTypeChecker(expectedValues) {
  if (!Array.isArray(expectedValues)) {
     false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    for (var i = 0; i < expectedValues.length; i++) {
      if (is(propValue, expectedValues[i])) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    var valuesString = JSON.stringify(expectedValues);
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
  }
  return createChainableTypeChecker(validate);
}

function createObjectOfTypeChecker(typeChecker) {
  function validate(props, propName, componentName, location, propFullName) {
    if (typeof typeChecker !== 'function') {
      return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
    }
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
    }
    for (var key in propValue) {
      if (propValue.hasOwnProperty(key)) {
        var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createUnionTypeChecker(arrayOfTypeCheckers) {
  if (!Array.isArray(arrayOfTypeCheckers)) {
     false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
    return emptyFunction.thatReturnsNull;
  }

  function validate(props, propName, componentName, location, propFullName) {
    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
        return null;
      }
    }

    var locationName = ReactPropTypeLocationNames[location];
    return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
  }
  return createChainableTypeChecker(validate);
}

function createNodeChecker() {
  function validate(props, propName, componentName, location, propFullName) {
    if (!isNode(props[propName])) {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function createShapeTypeChecker(shapeTypes) {
  function validate(props, propName, componentName, location, propFullName) {
    var propValue = props[propName];
    var propType = getPropType(propValue);
    if (propType !== 'object') {
      var locationName = ReactPropTypeLocationNames[location];
      return new PropTypeError('Invalid ' + locationName + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
    }
    for (var key in shapeTypes) {
      var checker = shapeTypes[key];
      if (!checker) {
        continue;
      }
      var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
      if (error) {
        return error;
      }
    }
    return null;
  }
  return createChainableTypeChecker(validate);
}

function isNode(propValue) {
  switch (typeof propValue) {
    case 'number':
    case 'string':
    case 'undefined':
      return true;
    case 'boolean':
      return !propValue;
    case 'object':
      if (Array.isArray(propValue)) {
        return propValue.every(isNode);
      }
      if (propValue === null || ReactElement.isValidElement(propValue)) {
        return true;
      }

      var iteratorFn = getIteratorFn(propValue);
      if (iteratorFn) {
        var iterator = iteratorFn.call(propValue);
        var step;
        if (iteratorFn !== propValue.entries) {
          while (!(step = iterator.next()).done) {
            if (!isNode(step.value)) {
              return false;
            }
          }
        } else {
          // Iterator will provide entry [k,v] tuples rather than values.
          while (!(step = iterator.next()).done) {
            var entry = step.value;
            if (entry) {
              if (!isNode(entry[1])) {
                return false;
              }
            }
          }
        }
      } else {
        return false;
      }

      return true;
    default:
      return false;
  }
}

function isSymbol(propType, propValue) {
  // Native Symbol.
  if (propType === 'symbol') {
    return true;
  }

  // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
  if (propValue['@@toStringTag'] === 'Symbol') {
    return true;
  }

  // Fallback for non-spec compliant Symbols which are polyfilled.
  if (typeof Symbol === 'function' && propValue instanceof Symbol) {
    return true;
  }

  return false;
}

// Equivalent of `typeof` but with special handling for array and regexp.
function getPropType(propValue) {
  var propType = typeof propValue;
  if (Array.isArray(propValue)) {
    return 'array';
  }
  if (propValue instanceof RegExp) {
    // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return 'object';
  }
  if (isSymbol(propType, propValue)) {
    return 'symbol';
  }
  return propType;
}

// This handles more types than `getPropType`. Only used for error messages.
// See `createPrimitiveTypeChecker`.
function getPreciseType(propValue) {
  var propType = getPropType(propValue);
  if (propType === 'object') {
    if (propValue instanceof Date) {
      return 'date';
    } else if (propValue instanceof RegExp) {
      return 'regexp';
    }
  }
  return propType;
}

// Returns class name of the object, if any.
function getClassName(propValue) {
  if (!propValue.constructor || !propValue.constructor.name) {
    return ANONYMOUS;
  }
  return propValue.constructor.name;
}

module.exports = ReactPropTypes;

/***/ }),
/* 1437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * 
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),
/* 1438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */



module.exports = '15.4.2';

/***/ }),
/* 1439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */


var _prodInvariant = __webpack_require__(151);

var ReactElement = __webpack_require__(126);

var invariant = __webpack_require__(79);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var emptyFunction = __webpack_require__(129);
var invariant = __webpack_require__(79);
var ReactPropTypesSecret = __webpack_require__(1441);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1441 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 1442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
Object.defineProperty(exports,"__esModule",{value:true});exports.default=[{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4s171.2-381.4 381.4-381.4 381.4 171.2 381.4 381.4-171.2 381.4-381.4 381.4z","M528 256h-32v240h-240v32h240v240h32v-240h240v-32h-240z"],"grid":0,"tags":["ios-add-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 528h-240v240h-32v-240h-240v-32h240v-240h32v240h240v32z"],"grid":0,"tags":["ios-add-circle"]},{"paths":["M768 528h-240v240h-32v-240h-240v-32h240v-240h32v240h240v32z"],"grid":0,"tags":["ios-add"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M512 666.2c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32s-14.4-32-32-32z","M488.4 466.4v-178.4h48v178.4l-12 141.6h-24l-12-141.6z"],"grid":0,"tags":["ios-alert-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM488.4 288h48v178.4l-12 141.6h-24l-12-141.6v-178.4zM512 730.2c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32 0 17.8-14.4 32-32 32z"],"grid":0,"tags":["ios-alert"]},{"paths":["M757.21 266.79c-145.406-145.408-378.45-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.508 170.79 77.852 0 130.384-7.316 130.384-7.316s59.97-430.452-163.472-653.894zM130.284 130.416c21.99-2.028 58.464-4.416 103.428-4.416h0.288l-0.136-0.142c54.334 0 106.334 3.508 155.584 10.44l-253.2 253.162c-2.050-14.566-3.82-29.394-5.28-44.492-9.172-94.87-4.172-176.456-0.684-214.552zM287.8 736.204c-47.7-47.704-85.586-109.876-112.608-184.792-13.946-38.664-25.020-80.746-33.14-125.732l283.624-283.58c21.344 3.858 42.128 8.382 62.282 13.608 104.054 26.984 187.566 71.416 248.278 132.128 47.702 47.7 85.572 109.856 112.594 184.772 13.948 38.666 25.018 80.75 33.134 125.742l-283.624 283.622c-21.32-3.86-42.082-8.382-62.208-13.602-104.060-26.978-187.612-71.452-248.332-132.166zM893.722 893.736c-21.988 2.024-58.46 4.55-103.42 4.55-54.384 0-106.45-3.54-155.752-10.5l253.214-253.214c2.048 14.558 3.816 29.376 5.276 44.466 9.176 94.874 4.172 176.596 0.682 214.698z","M614.608 635.694l45.25 45.264-57.308 57.304 22.63 22.628 135.762-135.762-22.628-22.628-57.442 57.442-45.25-45.262 57.432-57.434-22.626-22.626-57.43 57.428-45.266-45.276 57.404-57.404-22.626-22.628-57.4 57.4-45.252-45.262 57.394-57.394-22.628-22.626-57.388 57.39-45.262-45.274 57.374-57.374-22.626-22.626-57.37 57.37-45.248-45.26 57.364-57.364-22.626-22.626-135.766 135.764 22.628 22.628 57.386-57.388 45.248 45.26-57.382 57.382 22.626 22.626 57.378-57.378 45.26 45.274-57.356 57.358 22.626 22.626 57.354-57.354 45.252 45.262-57.348 57.348 22.628 22.626 57.342-57.342 45.266 45.276-57.32 57.32 22.628 22.628z"],"grid":0,"tags":["ios-american-football-outline"]},{"paths":["M757.21 266.79c-145.406-145.408-378.448-170.794-523.51-170.79-77.852 0.002-130.382 7.316-130.382 7.316s-59.968 430.454 163.472 653.894c145.408 145.408 378.444 170.79 523.506 170.79 77.854 0 130.386-7.316 130.386-7.316s59.972-430.452-163.472-653.894zM136.248 389.456l253.166-253.164c12.246 1.722 24.328 3.65 36.224 5.798l-283.588 283.586c-2.14-11.874-4.076-23.952-5.802-36.22zM534.624 670.39l57.376-57.376-45.254-45.256-57.376 57.376-22.626-22.624 57.376-57.376-45.254-45.254-57.376 57.376-22.626-22.624 57.376-57.376-45.256-45.256-57.376 57.376-22.626-22.624 57.378-57.378-45.256-45.254-57.376 57.376-22.628-22.626 135.768-135.766 22.626 22.628-57.376 57.376 45.256 45.254 57.376-57.376 22.626 22.626-57.376 57.376 45.256 45.256 57.376-57.376 22.628 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.626 22.624-57.376 57.376 45.256 45.256 57.376-57.376 22.624 22.626-57.376 57.376 45.254 45.254 57.376-57.376 22.628 22.624-135.766 135.768-22.626-22.626 57.376-57.376-45.256-45.256-57.376 57.376-22.63-22.628zM634.518 887.782c-12.242-1.726-24.318-3.66-36.208-5.812l283.648-283.65c2.142 11.876 4.076 23.954 5.802 36.222l-253.242 253.24z"],"grid":0,"tags":["ios-american-football"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM242.4 242.4c148.6-148.6 390.6-148.6 539.2 0 76 76 113 176.2 111.4 276-5.8-9.2-46.2-70.4-105-70.4-55.8 0-84.6 52.2-103.6 86.6-2.8 5.2-5.6 10-8 14.2-23.2 39-55.4 60.8-86.2 58.6-27.2-2-50.4-22.6-65.2-58.4-18.6-44.8-59.2-93-107.4-99.8-22.8-3.2-57.2 1.8-90.6 43.4-6.6 8.2-14 19-22.4 31.8-21.2 31.4-53 78.8-77.4 82.8-42 6.8-73.2-24.4-78.6-29.2-4-3.4-8.8-8.6-14.6-15.2-15-113.8 21-233.2 108.4-320.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0-48.4-48.4-81-106.6-97.8-168.2 14 11.4 38.6 26.6 71 26.6 5.4 0 11.2-0.4 17-1.4 38-6.2 71.6-56.2 98.8-96.4 7.8-11.6 15-22.4 20.8-29.6 19.4-24 40-34.8 61.2-31.8 25.8 3.6 62.2 32.4 82.2 80.4 19.8 47.4 52.6 75.2 92.6 78 43.2 3 86.6-24.8 116-74.2 2.8-4.6 5.6-9.6 8.4-15 17.2-31.2 38.6-70.2 75.4-70.2 22.2 0 41.8 14.6 54.4 26.8 14.8 14.4 18 18 25.8 29.2 6.8 9.6 13 17.4 20.6 33.4-11.6 77.8-47.4 152.6-107.2 212.4z"],"grid":0,"tags":["ios-analytics-outline"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM242.4 242.4c148.6-148.6 390.6-148.6 539.2 0 76 76 113 176.2 111.4 276-5.8-9.4-46.2-70.4-105-70.4-55.8 0-84.6 52.2-103.6 86.6-2.8 5.2-5.6 10-8 14.2-23.2 39-55.4 60.8-86.2 58.6-27.2-2-50.4-22.6-65.2-58.4-18.6-44.8-59.2-93-107.4-99.8-22.8-3.2-57.2 1.8-90.6 43.4-6.6 8.2-14 19-22.4 31.8-21.2 31.4-53 78.8-77.4 82.8-42 6.8-73.2-24.4-78.6-29.2-4-3.4-8.8-8.6-14.4-15-15.2-114 20.8-233.4 108.2-320.6z"],"grid":0,"tags":["ios-analytics"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416 0 131 60.6 247.8 155.2 324.2l-1.2 2.2 16.6 9.6c68.8 50.4 153.6 80 245.4 80 229.8 0 416-186.2 416-416s-186.2-416-416-416zM865.8 362.6c20 47.4 30.2 97.6 30.2 149.4 0 10.8-0.4 21.4-1.4 32h-325.6l188.8-327c8.8 7.4 17.4 15.2 25.8 23.4 35.2 35.4 62.8 76.4 82.2 122.2zM474 514.2l19.8-34.2h37.4l18.8 32.8-18 31.2h-40.8l-17.2-29.8zM661.4 158.2c25 10.6 48.6 23.8 70.8 39.2l-163.6 283.4-190-329c42.6-15.8 87.4-23.8 133.4-23.8 51.8 0 102.2 10.2 149.4 30.2zM240.4 240.4c31.8-31.8 68.2-57.4 108.4-76.2l164 283.8h-379.4c5-29.4 13.2-57.8 24.8-85.4 19.4-45.8 47-86.8 82.2-122.2zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-19.8-47.4-30-97.8-30-149.6 0-10.8 0.4-21.4 1.4-32h327.6l-189.4 328c-9.4-7.6-18.4-15.8-27.2-24.4zM362.6 865.8c-24.6-10.4-47.8-23.2-69.4-38.2l162.4-281.4 188.4 326.4c-42.2 15.4-86.6 23.4-132 23.4-51.8 0-102.2-10.2-149.4-30.2zM783.6 783.6c-32 32-68.8 57.8-109.6 76.8l-164.2-284.4h381c-5 29.4-13.2 57.8-24.8 85.4-19.6 45.8-47.2 86.8-82.4 122.2z"],"grid":0,"tags":["ios-aperture-outline"]},{"paths":["M493.8 480l-19.8 34.2 17.2 29.8h40.8l18.2-31.2-19-32.8z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM509.8 576l164.2 284.2c-4.2 2-8.2 3.8-12.4 5.6-5.8 2.4-11.6 4.8-17.4 6.8l-188.4-326.4-162.4 281.4c-8.8-6.2-17.4-12.6-25.6-19.4l189.4-328h-327.8c0.8-10.8 2.2-21.4 4-32h379.4l-163.8-284c4.4-2.2 9-4.2 13.6-6 5.4-2.2 10.8-4.4 16.2-6.4l190 329 163.6-283.4c8.8 6.2 17.4 12.8 25.6 19.6l-189 327h325.6c-0.8 10.8-2.2 21.4-4 32h-380.8z"],"grid":0,"tags":["ios-aperture"]},{"paths":["M308 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M564 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M820 160c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 128h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M308 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M564 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M820 448c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 416h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M308 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM308 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M564 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM564 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z","M820 736c6.6 0 12 5.4 12 12v104c0 6.6-5.4 12-12 12h-104c-6.6 0-12-5.4-12-12v-104c0-6.6 5.4-12 12-12h104zM820 704h-104c-24.2 0-44 19.8-44 44v104c0 24.2 19.8 44 44 44h104c24.2 0 44-19.8 44-44v-104c0-24.2-19.8-44-44-44v0z"],"grid":0,"tags":["ios-apps-outline"]},{"paths":["M308 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M564 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M820 320h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M308 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M564 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M820 608h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M308 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M564 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z","M820 896h-104c-24.2 0-44-19.8-44-44v-104c0-24.2 19.8-44 44-44h104c24.2 0 44 19.8 44 44v104c0 24.2-19.8 44-44 44z"],"grid":0,"tags":["ios-apps"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M278.6 704l68.4-57.6-49.4-32.4z","M684.4 596c-13.6 6.4-30.4 28-7.8 57.2 18.2 23.4 36 17.4 53 50.8 9.6-8.2 18.8-43.4 14.6-71.4-4.8-30.6-24.6-53-59.8-36.6z","M503.2 379.2c3.2-5.4 1.2-12.6-4.2-15.8l-30.2-17.2c-5.6-3.2-12.6-1.2-15.8 4.2l-111.8 193.6-33.8 58.4 49.8 30 87.8-152.6 58.2-100.6z","M461.2 480l-37 64h178.4l-36.2-64z","M702 544h66v-64h-102z","M362.2 480h-106.2v64h69.2z","M649.2 480l-120-211.6c-3.2-5.6-10.4-7.4-15.8-4.2l-30.2 17.2c-5.6 3.2-7.4 10.2-4.2 15.8l140 247.4 1-0.6 48.8-29.6-19.6-34.4z","M686.4 544l-9.8-17.4-49.6 30 26 46 49.8-30.2z"],"grid":0,"tags":["ios-appstore-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM256 480h106.2l-37 64h-69.2v-64zM278.6 704l19-90 49.6 32.4-68.6 57.6zM357.2 632.6l-49.8-30 33.8-58.4 37-64 74.8-129.6c3.2-5.6 10.4-7.4 15.8-4.2l30.2 17.2c5.6 3.2 7.4 10.2 4.2 15.8l-94.8 164.8-51.2 88.4zM424.2 544l36.8-64h105.4l36.2 64h-178.4zM619 544.6l-0.4-0.6-139.6-246.8c-3.2-5.4-1.2-12.6 4.2-15.8l30.2-17.2c5.6-3.2 12.6-1.2 15.8 4.2l120 211.6 19.6 34.4-49.8 30.2zM627 556.6l49.6-30 10 17.4 16.2 28.4-49.8 30-26-45.8zM729.4 704c-17-33.6-34.8-27.4-53-50.8-22.6-29.2-5.8-50.8 7.8-57.2 35.2-16.4 55 6 59.6 36.6 4.4 28-4.8 63.2-14.4 71.4zM768 544h-66l-36-64h102v64z"],"grid":0,"tags":["ios-appstore"]},{"paths":["M575.6 480c17.6 0 32.2 14.4 32.2 32s-14 32-31.8 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32h126zM576 448h-128c-35.2 0-64 28.8-64 64s28.8 64 64 64h128c35.2 0 64-28.8 64-64s-28.8-64-64-64v0z","M832 224h-640v160h32v416h576v-416h32v-160zM768 768h-512v-384h512v384zM800 352h-576v-96h576v96z"],"grid":0,"tags":["ios-archive-outline"]},{"paths":["M224 800h576v-384h-576v384zM448 480h128c17.6 0 32 14.4 32 32s-14.4 32-32 32h-128c-17.6 0-32-14.4-32-32s14.4-32 32-32z","M192 224v160h640v-160z"],"grid":0,"tags":["ios-archive"]},{"paths":["M256.8 320l-64.8 64.6 320 319.4 320-319.4-64.8-64.6-255.2 254.6z"],"grid":0,"tags":["ios-arrow-down"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM512 616.8l186.4-200.8 25.6 27.6-212 228.4-212-228.4 25.6-27.6 186.4 200.8z"],"grid":0,"tags":["ios-arrow-dropdown-circle"]},{"paths":["M698.4 416l25.6 27.6-212 228.4-212-228.4 25.6-27.6 186.4 200.8z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 210.2-171 381.4-381.4 381.4-210.2 0-381.4-171-381.4-381.4-0-210.2 171.2-381.4 381.4-381.4z"],"grid":0,"tags":["ios-arrow-dropdown"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM608 698.4l-27.6 25.6-228.4-212 228.4-212 27.6 25.6-200.8 186.4 200.8 186.4z"],"grid":0,"tags":["ios-arrow-dropleft-circle"]},{"paths":["M608 325.6l-27.6-25.6-228.4 212 228.4 212 27.6-25.6-200.8-186.4z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-arrow-dropleft"]},{"paths":["M96 512c0 229.8 186.2 416 416 416s416-186.2 416-416-186.2-416-416-416c-229.8 0-416 186.2-416 416zM616.8 512l-200.8-186.4 27.6-25.6 228.4 212-228.4 212-27.6-25.6 200.8-186.4z"],"grid":0,"tags":["ios-arrow-dropright-circle"]},{"paths":["M416 325.6l27.6-25.6 228.4 212-228.4 212-27.6-25.6 200.8-186.4z","M96 512c0 229.8 186.2 416 416 416s416-186.2 416-416-186.2-416-416-416c-229.8 0-416 186.2-416 416zM130.6 512c0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171 381.4-381.4 381.4-210.2 0-381.4-171.2-381.4-381.4z"],"grid":0,"tags":["ios-arrow-dropright"]},{"paths":["M512 928c229.8 0 416-186.2 416-416s-186.2-416-416-416-416 186.2-416 416c0 229.8 186.2 416 416 416zM512 407.2l-186.4 200.8-25.6-27.6 212-228.4 212 228.4-25.6 27.6-186.4-200.8z"],"grid":0,"tags":["ios-arrow-dropup-circle"]},{"paths":["M325.6 608l-25.6-27.6 212-228.4 212 228.4-25.6 27.6-186.4-200.8z","M512 928c229.8 0 416-186.2 416-416s-186.2-416-416-416-416 186.2-416 416c0 229.8 186.2 416 416 416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-arrow-dropup"]},{"paths":["M574.6 512l-254.6 255.2 64.6 64.8 319.4-320-319.4-320-64.6 64.8z"],"grid":0,"tags":["ios-arrow-forward"]},{"paths":["M752 496h-441.4l132.6-148.8c5.8-6.8 6.4-16.2 0.2-22.4s-17-6.6-22.8-0.2l-160 176c-0.4 0.4-0.8 0.8-1 1.2-0.2 0.2-0.2 0.4-0.4 0.6s-0.4 0.4-0.6 0.8c-0.2 0.2-0.2 0.4-0.4 0.6s-0.2 0.4-0.4 0.6c-0.2 0.2-0.2 0.4-0.4 0.8-0.2 0.2-0.2 0.4-0.4 0.6 0 0.2-0.2 0.4-0.2 0.8 0 0.2-0.2 0.6-0.2 0.8s-0.2 0.4-0.2 0.8c0 0.2-0.2 0.6-0.2 0.8s0 0.6-0.2 0.8c0 0.2 0 0.4 0 0.6-0.2 1-0.2 2.2 0 3.2 0 0.2 0 0.4 0 0.6s0 0.6 0.2 0.8c0 0.2 0.2 0.6 0.2 0.8s0.2 0.4 0.2 0.8c0 0.2 0.2 0.6 0.2 0.8s0.2 0.4 0.2 0.8c0 0.2 0.2 0.4 0.4 0.6s0.2 0.4 0.4 0.8c0.2 0.2 0.2 0.4 0.4 0.6s0.2 0.4 0.4 0.6c0.2 0.2 0.4 0.4 0.6 0.8 0.2 0.2 0.2 0.4 0.4 0.6 0.4 0.4 0.6 0.8 1 1.2l160 176c3.2 3.4 7.2 4.6 11.4 4.6 4 0 8.2-1.6 11.4-4.6 6.2-6.2 6-16 0-22.6l-132.8-148.8h441.4c8.8 0 16-7.2 16-16s-7.2-16-16-16z"],"grid":0,"tags":["ios-arrow-round-back"]},{"paths":["M496 272v441.4l-148.8-132.6c-6.8-5.8-16.2-6.4-22.4-0.2s-6.6 17-0.2 22.8l176 160c0.4 0.4 0.8 0.8 1.2 1 0.2 0.2 0.4 0.2 0.6 0.4s0.4 0.4 0.8 0.6c0.2 0.2 0.4 0.2 0.6 0.4s0.4 0.2 0.6 0.4c0.2 0.2 0.4 0.2 0.8 0.4 0.2 0.2 0.4 0.2 0.6 0.4 0.2 0 0.4 0.2 0.8 0.2 0.2 0 0.6 0.2 0.8 0.2s0.4 0.2 0.8 0.2c0.2 0 0.6 0.2 0.8 0.2s0.6 0 0.8 0.2c0.2 0 0.4 0 0.6 0 1 0.2 2.2 0.2 3.2 0 0.2 0 0.4 0 0.6 0s0.6 0 0.8-0.2c0.2 0 0.6-0.2 0.8-0.2s0.4-0.2 0.8-0.2c0.2 0 0.6-0.2 0.8-0.2s0.4-0.2 0.8-0.2c0.2 0 0.4-0.2 0.6-0.4s0.4-0.2 0.8-0.4c0.2-0.2 0.4-0.2 0.6-0.4s0.4-0.2 0.6-0.4c0.2-0.2 0.4-0.4 0.8-0.6 0.2-0.2 0.4-0.2 0.6-0.4 0.4-0.4 0.8-0.6 1.2-1l176-160c3.4-3.2 4.6-7.2 4.6-11.4 0-4-1.6-8.2-4.6-11.4-6.2-6.2-16-6-22.6 0l-148.8 132.8v-441.4c0-8.8-7.2-16-16-16s-16 7.2-16 16z"],"grid":0,"tags":["ios-arrow-round-down"]},{"paths":["M272 528h441.4l-132.6 148.8c-5.8 6.8-6.4 16.2-0.2 22.4s17 6.6 22.8 0.2l160-176c0.4-0.4 0.8-0.8 1-1.2 0.2-0.2 0.2-0.4 0.4-0.6s0.4-0.4 0.6-0.8c0.2-0.2 0.2-0.4 0.4-0.6s0.2-0.4 0.4-0.6c0.2-0.2 0.2-0.4 0.4-0.8 0.2-0.2 0.2-0.4 0.4-0.6 0-0.2 0.2-0.4 0.2-0.8 0-0.2 0.2-0.6 0.2-0.8s0.2-0.4 0.2-0.8c0-0.2 0.2-0.6 0.2-0.8s0-0.6 0.2-0.8c0-0.2 0-0.4 0-0.6 0.2-1 0.2-2.2 0-3.2 0-0.2 0-0.4 0-0.6s0-0.6-0.2-0.8c0-0.2-0.2-0.6-0.2-0.8s-0.2-0.4-0.2-0.8c0-0.2-0.2-0.6-0.2-0.8s-0.2-0.4-0.2-0.8c0-0.2-0.2-0.4-0.4-0.6s-0.2-0.4-0.4-0.8c-0.2-0.2-0.2-0.4-0.4-0.6s-0.2-0.4-0.4-0.6c-0.2-0.2-0.4-0.4-0.6-0.8-0.2-0.2-0.2-0.4-0.4-0.6-0.4-0.4-0.6-0.8-1-1.2l-160-176c-3.2-3.4-7.2-4.6-11.4-4.6-4 0-8.2 1.6-11.4 4.6-6.2 6.2-6 16 0 22.6l132.6 148.6h-441.2c-8.8 0-16 7.2-16 16 0 9 7.2 16.2 16 16.2z"],"grid":0,"tags":["ios-arrow-round-forward"]},{"paths":["M528 752v-441.4l148.8 132.6c6.8 5.8 16.2 6.4 22.4 0.2s6.6-17 0.2-22.8l-176-160c-0.4-0.4-0.8-0.8-1.2-1-0.2-0.2-0.4-0.2-0.6-0.4s-0.4-0.4-0.8-0.6c-0.2-0.2-0.4-0.2-0.6-0.4s-0.4-0.2-0.6-0.4c-0.2-0.2-0.4-0.2-0.8-0.4-0.2-0.2-0.4-0.2-0.6-0.4-0.2 0-0.4-0.2-0.8-0.2-0.2 0-0.6-0.2-0.8-0.2s-0.4-0.2-0.8-0.2c-0.2 0-0.6-0.2-0.8-0.2s-0.6 0-0.8-0.2c-0.2 0-0.4 0-0.6 0-1-0.2-2.2-0.2-3.2 0-0.2 0-0.4 0-0.6 0s-0.6 0-0.8 0.2c-0.2 0-0.6 0.2-0.8 0.2s-0.4 0.2-0.8 0.2c-0.2 0-0.6 0.2-0.8 0.2s-0.4 0.2-0.8 0.2c-0.2 0-0.4 0.2-0.6 0.4s-0.4 0.2-0.8 0.4c-0.2 0.2-0.4 0.2-0.6 0.4s-0.4 0.2-0.6 0.4c-0.2 0.2-0.4 0.4-0.8 0.6-0.2 0.2-0.4 0.2-0.6 0.4-0.4 0.4-0.8 0.6-1.2 1l-176 160c-3.4 3.2-4.6 7.2-4.6 11.4 0 4 1.6 8.2 4.6 11.4 6.2 6.2 16 6 22.6 0l148.6-132.6v441.2c0 8.8 7.2 16 16 16 9 0 16.2-7.2 16.2-16z"],"grid":0,"tags":["ios-arrow-round-up"]},{"paths":["M767.2 704l64.8-64.6-320-319.4-320 319.4 64.8 64.6 255.2-254.6z"],"grid":0,"tags":["ios-arrow-up"]},{"paths":["M867.8 689.2c-65.8 127.6-195.2 206.8-337.6 206.8-101 0-194.6-39.8-263.8-112.2-68.8-72-106.6-168.4-106.6-271.8s37.8-199.8 106.6-271.8c69.2-72.4 163-112.2 263.8-112.2 101.8 0 187.8 38.6 242.2 108.4 52.6 67.6 69 156.2 46.4 249.8-21.8 90.2-67 131.6-101 150.4-35 19.4-83.6 26.8-104.8 8.8v0c-0.6-0.6-1.2-1.2-1.6-1.8-3-3.8-4.6-10.8-4.8-17s0.4-13.4 2-21.4c1.6-8 3.8-16.8 6.4-25.4l77.2-233.8h-42.6l-20 53c-9.2-24.2-21.2-41.6-36.2-52-15-10.6-31.4-15.8-49-15.8-28.4 0-54.4 7-77.8 20.8-23.6 13.8-43.6 31.8-60.2 54.2s-29.4 47.6-38.6 75.4c-9.2 27.8-13.6 55.8-13.6 83.8 0 16.2 2.4 31.4 7.2 45.4s11.8 26.4 20.8 37.2c9 10.8 20.2 19.4 33.4 25.6s28 9.4 44.6 9.4c20.4 0 39.4-5.4 57-16.8s32.6-24.2 45-36.2h1.6c1.6 18 9.4 31 19.6 40.2 5.2 4.6 12.6 9 22.2 12.2v0.2c42.2 14.4 84.2 6 127.6-18 39.6-22 92.2-69.4 116.6-171 25-103.2 6.4-201.6-52.4-277.2-60.4-77.6-155.4-120.4-267.2-120.4-109.6 0-211.4 43.4-286.6 122-74.6 78-115.6 182.4-115.6 294s41 216 115.6 294c75.2 78.8 177.2 122 286.6 122 154.2 0 294.4-85.8 365.8-224l-28.2-14.8zM567 572.8c-12.2 19.6-26.6 36-43 49.6-16.4 13.4-34 20.2-53.2 20.2-19.6 0-35.8-7.2-48.6-21.4-12.8-14.4-19.2-33.8-19.2-58.6 0-19.2 3.2-40 9.8-62.4 6.6-22.2 16-43 28.2-62s27-34.8 44.2-47.4c17.2-12.6 36.2-19 56.8-19 8.2 0 16 2.2 23.8 6.6 7.6 4.4 14.4 10.2 20.4 17.4s11 15.2 14.8 24.4c3.8 9 5.8 18.6 5.8 28.4 0 18.2-3.6 38.6-10.6 61.2-7.2 22.4-17 43.4-29.2 63z"],"grid":0,"tags":["ios-at-outline"]},{"paths":["M768 184.2c10.6 10 20.4 21 29.4 32.6 58.8 75.4 77.4 173.8 52.4 277.2-24.6 101.4-77 149-116.6 171-43.4 24-85.4 32.4-127.6 18v-0.2c-9.6-3.2-17-7.6-22.2-12.2-10.2-9.2-18-22.2-19.6-40.2h-1.6c-12.4 12-27.2 24.8-45 36.2s-36.6 16.8-57 16.8c-16.6 0-31.4-3-44.6-9.4-13.2-6.2-24.2-14.8-33.4-25.6s-16-23.2-20.8-37.2c-4.8-14-7.2-29.2-7.2-45.4 0-28 4.6-56 13.6-83.8s22-53 38.6-75.4c16.6-22.4 36.6-40.6 60.2-54.2 23.6-13.8 49.4-20.8 77.8-20.8 17.6 0 34 5.2 49 15.8s27 27.8 36.2 52l20-53h42.6l-77 233.6c-2.6 8.6-4.8 17.4-6.4 25.4s-2.2 15.2-2 21.4c0.2 6.2 1.8 13.2 4.8 17 0.4 0.6 1 1.2 1.6 1.8 21.2 18.2 69.8 10.6 104.8-8.8 34.2-18.8 79.4-60.2 101-150.4 22.6-93.6 6-182.2-46.4-249.8-45.6-58.4-109.2-117.6-193.6-133-27.8-5-44.2-7.6-67-7.6-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-133.2-62.6-251.8-160-327.8z","M422.2 621.2c12.8 14.2 29 21.4 48.6 21.4 19.2 0 36.8-6.8 53.2-20.2 16.4-13.6 30.8-30 43-49.6s22-40.6 29-63.2 10.6-43 10.8-61c0-9.8-2-19.4-5.8-28.4-2-4.6-4.2-9-6.6-13.2-2.4-4-5.2-7.8-8.2-11.4-6-7.2-12.8-13-20.4-17.4s-15.6-6.6-23.8-6.6c-20.8 0-39.6 6.4-56.8 19s-32 28.4-44.2 47.4c-12.2 19-21.6 39.6-28.2 62-6.6 22.2-9.8 43-9.8 62.4 0 0 0 0 0 0.2 0 0 0 0 0 0 0 24.8 6.4 44.2 19.2 58.6z"],"grid":0,"tags":["ios-at"]},{"paths":["M687 383c-9.4 0-17 7.6-17 17v314c0 38-15 76.4-41.8 104.8-27.4 28.8-66.6 45.2-104.2 45.2h-24c-79 0-148-72-148-150v-442.2c0-61.2 50.8-109.6 112-109.6s110 48.4 110 109.6v428.6c0 34.4-27.2 67.6-62 67.6s-64-33-64-67.6v-236.4c0-9.4-7.6-17-17-17s-17 7.6-17 17v236.4c0 57.6 44.6 99.6 98 99.6s96-40 96-99.6v-428.6c0-79.8-64.8-143.8-144.6-143.8s-143.4 64-143.4 143.8v442.2c0 46.4 19 93.6 54.6 128.6 35.4 34.8 79 53.4 125.4 53.4h24c96 0 180-82.8 180-182v-314c0-9.4-7.6-17-17-17z"],"grid":0,"tags":["ios-attach"]},{"paths":["M790 192h-330c-93.4 0-146.4 69.4-204 127s-144.2 149.4-144.2 149.4c-9.8 11.2-15.8 25.6-15.8 41.8 0 16 6 30.6 15.8 42 0 0 68.6 75.2 144.2 151 75.6 75.6 113.4 129 204 129h330c77 0 138-65 138-142v-360.2c0-77-61-138-138-138zM896 690c0 29-10.6 56.8-31 77.4-20.2 20.8-46.6 32.6-75 32.6h-330c-65.2 0-96.4-32.6-153-90.8l-171.4-178.4c-3.6-4.2-7.6-11.2-7.6-20.8 0-9.4 4-16.4 7.6-20.6l166.2-172.2c24.4-25.4 47.6-49 73.8-66.6 27.6-18.6 54.4-26.8 84.4-26.8h330c28.6 0 55 10.6 75.2 30.8s30.8 46.6 30.8 75.2v360.2z","M632.8 512l127.2-126.8-29.2-29.2-127.2 127-126.4-126.4-29.2 29.2 126.6 126.2-126.6 126.4 29.2 29 126.4-126.2 127.2 126.8 29.2-29z"],"grid":0,"tags":["ios-backspace-outline"]},{"paths":["M790 192h-330c-93.4 0-146.4 69.4-204 127s-144.2 149.4-144.2 149.4c-9.8 11.2-15.8 25.6-15.8 41.8 0 16 6 30.6 15.8 42 0 0 68.6 75.2 144.2 151 75.6 75.6 113.4 129 204 129h330c77 0 138-65 138-142v-360.2c0-77-61-138-138-138zM730.8 668l-127.2-126.8-126.6 126.2-29-29 126.6-126.4-126.6-126.2 29.2-29.2 126.6 126.4 127.2-127 29.2 29.2-127.4 126.8 127.2 127-29.2 29z"],"grid":0,"tags":["ios-backspace"]},{"paths":["M800 448v-192c0-70.4-57.6-128-128-128h-320c-70.4 0-128 57.6-128 128v192h-160l105 388.6c9.4 34 40.8 59.4 78.2 59.4h529.4c37.4 0 68.8-25 78.6-59l104.8-389h-160zM918 480h0.2l-25.8 96h-156.4v-96h182zM140.4 608h147.6v128h-113l-34.6-128zM320 608h176v128h-176v-128zM704 576h-176v-96h176v96zM496 576h-176v-96h176v96zM496 768v96h-176v-96h176zM528 768h176v96h-176v-96zM528 736v-128h176v128h-176zM736 608h147.8l-34.4 128h-113.4v-128zM256 256c0-25.6 10-49.6 28.2-67.8s42.2-28.2 67.8-28.2h320c25.6 0 49.6 10 67.8 28.2s28.2 42.2 28.2 67.8v192h-512v-192zM288 480v96h-156.2l-26-96h182.2zM200 828.2l-16.4-60.2h104.4v96h-40.8c-22 0-41.4-14.6-47.2-35.8zM824.6 828.4c-6.2 21-25.8 35.6-47.8 35.6h-40.8v-96h104.8l-16.2 60.4z"],"grid":0,"tags":["ios-basket-outline"]},{"paths":["M800 448v-192c0-70.4-57.6-128-128-128h-320c-70.4 0-128 57.6-128 128v192h-160l105 388.6c9.4 34 40.8 59.4 78.2 59.4h529.4c37.4 0 68.8-25 78.6-59l104.8-389h-160zM256 256c0-25.6 10-49.6 28.2-67.8s42.2-28.2 67.8-28.2h320c25.6 0 49.6 10 67.8 28.2s28.2 42.2 28.2 67.8v192h-512v-192zM883.8 608h-147.8v128h113.4l-8.6 32h-104.8v96h-32v-96h-176v96h-32v-96h-176v96h-32v-96h-104.4l-8.6-32h113v-128h-147.6l-8.6-32h156.2v-96h32v96h176v-96h32v96h176v-96h32v96h156.4l-8.6 32z","M528 608h176v128h-176v-128z","M320 608h176v128h-176v-128z"],"grid":0,"tags":["ios-basket"]},{"paths":["M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z","M740 352h-552c-17.6 0-28 10.4-28 28v264c0 17.6 10.4 28 28 28h552c17.6 0 28-10.4 28-28v-264c0-17.6-10.4-28-28-28zM437.6 616l16.8-86h-54.4l90.4-122-16.8 86h54.4l-90.4 122z","M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"],"grid":0,"tags":["ios-battery-charging"]},{"paths":["M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z","M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"],"grid":0,"tags":["ios-battery-dead"]},{"paths":["M768 288h-608c-35.2 0-64 28.8-64 64v320c0 35.2 28.8 64 64 64h608c35.2 0 64-28.8 64-64v-320c0-35.2-28.8-64-64-64zM800 672c0 17.6-14.4 32-32 32h-608c-17.6 0-32-14.4-32-32v-320c0-17.6 14.4-32 32-32h608c17.6 0 32 14.4 32 32v320z","M740 352h-552c-17.6 0-28 10.4-28 28v264c0 17.6 10.4 28 28 28h552c17.6 0 28-10.4 28-28v-264c0-17.6-10.4-28-28-28z","M864 401.2v221.6c38.2-22.2 64-63.4 64-110.8s-25.8-88.6-64-110.8z"],"grid":0,"tags":["ios-battery-full"]},{"paths":["M890.4 96h-633.6c-108.6 0-128.8 55.8-128.8 80.4 60.6 8.4 64 8.4 64 72.4 0 32 0 551 0 551 0 70.6 57.6 128 128.4 128h415.6c70.8 0 126-58.4 126-129v-620.4c4-35 25-63.2 27.2-66.6 2.4-3.8 6.8-8.8 6.8-11 0-2.4-0.6-4.8-5.6-4.8zM830 178.6v620.4c0 26-9.4 48.8-27.4 67.4s-41 29.6-66.4 29.6h-416c-52.8 0-96.2-43.8-96.2-97v-550c0-33.4 0.6-61.6-16.6-80.8-8.6-9.6-21.2-12.6-34.6-16.4 11.4-10 35.4-24 84.2-24h587.2c0 0.2-14.2 12.8-14.2 50.8z","M766 352v416c0 20.4-3.6 36-11 43.8-11.4 11.6-27.6 20.4-40.2 20.4h-374c-17.6 0-30.8-5.4-39-15.8-8.8-10.8-13.8-28.6-13.8-50.2v-414.2h478zM798 320h-542v446c0 56.6 27.4 98 84.8 98h374c22.8 0 46.8-13.4 63-30 16.2-16.8 20.2-42.6 20.2-66v-448z"],"grid":0,"tags":["ios-beaker-outline"]},{"paths":["M340.8 832h374c12.6 0 28.8-8.6 40.2-20.4 7.6-7.8 11-23.2 11-43.8v-415.8h-478v414c0 21.6 5.2 39.4 13.8 50.2 8.2 10.4 21.4 15.8 39 15.8z","M890.4 96h-633.4c-108.8 0-129 55.8-129 80.4 60.6 8.4 64 8.4 64 72.4 0 32 0 551 0 551 0 70.6 57.8 128 128.4 128h415.6c70.8 0 126-58.4 126-129v-620.4c4-35 25-63.2 27.2-66.6 2.4-3.8 6.8-8.8 6.8-11 0-2.4-0.6-4.8-5.6-4.8zM798 768c0 23.4-3.8 49.2-20.2 66-16.2 16.6-40.4 30-63 30h-374c-57.4 0-84.8-41.4-84.8-98v-446h542v448z"],"grid":0,"tags":["ios-beaker"]},{"paths":["M767.4 236.6c0-41.6-34.4-76.6-76.2-76.6l-21-1.4c-12-54-64-94.6-118.2-94.6s-82.2 23.2-103.4 57.8c-17-19.6-42.2-30.8-70.4-30.8-36.6 0-68.2 23-83.4 53h-48.8c-50 0-86 39.2-86 90.8v8c0 57.6 32 41.8 32 79.6 0 35.6 0 213.6 0 213.6 0 26.8-22.4 38.6-22.4 70.4 0 17.6 16 33.6 33.6 33.6h20.8v-352h544c0 0-0.6-9.8-0.6-51.4zM735.2 256h-512.8c0 0-15.6 0-21.6 0s-8.8-7.6-8.8-13.2v-8c0-17.8 6.8-32.8 16.4-43.8 9.2-10.6 22.8-15 37.6-15h69l8.6-19.2c10-21 30.8-34.4 54.6-34.4 18 0 37 10.2 52.4 22.2l21.4 18.6 16-20c22.6-30 52.8-47.6 84.2-47.6 20.6 0 40 6.8 56 19.8 15.6 12.6 26.6 30.2 30.8 49.6l5.2 23.6c0 0 18.8-0.8 47 3.2s44.2 20.8 44.2 44.8l-0.2 19.4z","M616 448c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z","M544 544c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M576 704c0 13.255-10.745 24-24 24s-24-10.745-24-24c0-13.255 10.745-24 24-24s24 10.745 24 24z","M192 928h608v32h-608v-32z","M832 416h-96v-96h-480v544l-32 32h544l-32-32v-128h96c17.6 0 32-14.4 32-32v-256c0-17.6-14.4-32-32-32zM704 864h-416v-512h416v512zM832 704c0 0 0 0 0 0h-96v-256h96c0 0 0 0 0 0v256z"],"grid":0,"tags":["ios-beer-outline"]},{"paths":["M224 640v-352h544c0 0-0.6-9.8-0.6-51.4s-34.4-76.6-76.2-76.6l-21-1.4c-12-54-64-94.6-118.2-94.6s-82.2 23.2-103.4 57.8c-17-19.6-42.2-30.8-70.4-30.8-36.6 0-68.2 23-83.4 53h-48.8c-50 0-86 39.2-86 90.8v8c0 57.6 32 41.8 32 79.6 0 35.6 0 213.6 0 213.6 0 26.8-22.4 38.6-22.4 70.4 0 17.6 16 33.6 33.6 33.6h20.8z","M832 416h-96v-96h-480v544l-64 64v32h608v-32l-64-64v-128h96c17.6 0 32-14.4 32-32v-256c0-17.6-14.4-32-32-32zM576 408c22 0 40 18 40 40s-18 40-40 40-40-18-40-40 18-40 40-40zM576 704c0 13.2-10.8 24-24 24s-24-10.8-24-24 10.8-24 24-24 24 10.8 24 24zM512 512c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM832 704v0h-96v-256h96v256z"],"grid":0,"tags":["ios-beer"]},{"paths":["M250.6 522.6c-102.6 0-186.6 84-186.6 186.6 0 102.8 84 186.8 186.6 186.8s186.6-84 186.6-186.6c0.2-102.8-83.8-186.8-186.6-186.8zM359.8 818.6c-29.4 29.4-68 45.4-109.2 45.4s-79.8-16.2-109.2-45.4-45.4-68.2-45.4-109.2c0-41.2 16.2-79.8 45.4-109.2 29.4-29.4 68-45.4 109.2-45.4s79.8 16.2 109.2 45.4c29.4 29.4 45.4 68 45.4 109.2 0.2 41-16 79.8-45.4 109.2z","M639.6 255.6c35.6 0 64-28.4 64-64s-28-63.6-63.6-63.6c-35.6 0-64.4 28-64.4 63.6s28.6 64 64 64z","M773.4 522.6c-102.6 0-186.6 84-186.6 186.6s84 186.6 186.6 186.6c102.6 0 186.6-84 186.6-186.6s-84-186.6-186.6-186.6zM882.6 818.6c-29.4 29.4-68 45.4-109.2 45.4s-79.8-16.2-109.2-45.4c-29.4-29.4-45.4-68-45.4-109.2s16.2-79.8 45.4-109.2c29.4-29.4 68-45.4 109.2-45.4s79.8 16.2 109.2 45.4c29.4 29.4 45.4 68 45.4 109.2 0 41-16.2 79.8-45.4 109.2z","M736 384h-96l-59-120.2c-11.2-18.6-31.8-31.8-54.2-31.8-16.8 0-33.6 7.4-44.8 18.6l-143.4 138.2c-11.2 11.2-18.6 28-18.6 44.8 0 34.8 25.2 47.2 37 54.2 91 52.4 123 58.2 123 84.4s0 131.8 0 131.8c0 17.6 14.4 32 32 32s32-14.4 32-32c0 0 0-153.6 0-180s-60.8-48-96.6-76l97.8-103c37.4 57 54.6 103 76 103s114.8 0 114.8 0c17.6 0 32-14.4 32-32s-14.4-32-32-32z"],"grid":0,"tags":["ios-bicycle"]},{"paths":["M572 512l196-174-256.4-274h-31.6v360l-178.8-154-45.2 50 224 192-224 192 45.2 51.6 178.8-157.6v362h31.6l0.4-0.8 256-271.2-196-176zM675.6 689l-131.6 141v-255.6l131.6 114.6zM544 451.2v-257l131.6 142.4-131.6 114.6z"],"grid":0,"tags":["ios-bluetooth"]},{"paths":["M512 895.6c-59.2 0-139.8-13.4-192-31.6 0 0-70 45-160 64 64.6 0 106.6-18 160-32 46 18 133.4 31.6 192 31.6s148-11.6 192-31.6c53.4 14 94 32 160 32-87.6-19-160-64-160-64-52.2 18.2-132.8 31.6-192 31.6z","M891 526c0 0 0 0 0 0l-61.4-28.2-46-243.8v-0.2c-11-53.2-34.8-93.8-79.6-93.8h-69.2l-16.4-64h-213.4l-16.2 64h-68.8c-45.8 0-70.2 41.4-79.6 94l-46 243.8-61.4 28.2c0 0 0 0 0 0-12.4 5.8-21 18.2-21 32.8 0 4.8 1 9.2 2.6 13.4l109.4 291.8c55 0 113.4-38 113.4-38 39.8 20 121.6 37.6 174.6 37.6s134.8-17.6 174.6-37.6c0 0 58.4 38 113.4 38l109.4-291.8c1.6-4.2 2.6-8.6 2.6-13.4 0-14.6-8.6-27-21-32.8zM429.8 128h163.6l8.2 32h-180l8.2-32zM271.8 259.8c7.6-42 22.2-67.8 48.2-67.8h384c25.6 0 39.4 25.6 48.2 68.2l41.8 221.2-72.8-33.4h0.4c17.8 0 33.6-9.2 30.2-32l-30.2-160c-6-22-14.4-32-32.2-32h-354.6c-17.8 0-27.2 10.6-32.2 32l-30.2 160c-2.6 16 12.4 32 30.2 32h0.4l-73 33.4 41.8-221.6zM512 352l-139.4 64h-67.6l29-153.2c0.8-3.2 1.6-5.4 2.2-6.8h351.6c0.6 1.4 1.6 3.8 2.6 7.4l28.8 152.6h-67.6l-139.6-64zM335.4 789.2l-15.4 10c-11.4 7.4-42.4 24-73.4 30.4l-102.6-270.8c0-2.2 1.6-3.2 2.2-3.6l349.8-163.8v439.6c-48-3-112.4-17.6-144.2-33.6l-16.4-8.2zM777.4 829.6c-31-6.4-62-23-73.4-30.4l-15.4-10-16.4 8.2c-31.8 16-96.4 30.8-144.2 33.6v-439.6l349.8 163.8c0.6 0.4 2.2 1.4 2.2 3.6l-102.6 270.8z","M624 532c0 24.301-10.745 44-24 44s-24-19.699-24-44c0-24.301 10.745-44 24-44s24 19.699 24 44z","M448 532c0 24.301-10.745 44-24 44s-24-19.699-24-44c0-24.301 10.745-44 24-44s24 19.699 24 44z"],"grid":0,"tags":["ios-boat-outline"]},{"paths":["M704 864c-52.2 18.2-132.8 31.6-192 31.6s-139.8-13.4-192-31.6c0 0-70 45-160 64 64.6 0 106.6-18 160-32 46 18 133.4 31.6 192 31.6s148-11.6 192-31.6c53.4 14 94 32 160 32-87.6-19-160-64-160-64z","M891 526c0 0 0 0 0 0l-379-174-379 174c0 0 0 0 0 0-12.4 5.8-21 18.2-21 32.8 0 4.8 1 9.2 2.6 13.4l109.4 291.8c55 0 113.4-38 113.4-38 36 18 106.2 34.2 158.6 37.2 5.6 0.4 11 0.4 16 0.4s10.4-0.2 16-0.4c52.4-3 122.6-19 158.6-37.2 0 0 58.4 38 113.4 38l109.4-291.8c1.6-4.2 2.6-8.6 2.6-13.4 0-14.6-8.6-27-21-32.8zM424 576c-13.2 0-24-19.6-24-44s10.8-44 24-44 24 19.6 24 44-10.8 44-24 44zM600 576c-13.2 0-24-19.6-24-44s10.8-44 24-44 24 19.6 24 44-10.8 44-24 44z","M783.8 254v-0.2c-11.2-53.2-35-93.8-79.8-93.8h-69.2l-16.4-64h-213.4l-16.2 64h-68.8c-45.8 0-70.2 41.4-79.6 94l-39.4 208.8 68.4-31.4 33.2-175.4c5-21.4 14.6-32 32.2-32h354.2c17.8 0 26.2 10 32.2 32l33.2 175.4 68.6 31.4-39.2-208.8z"],"grid":0,"tags":["ios-boat"]},{"paths":["M510 704.2l0.2 1.6 0.4 1.8 30.4 152c0.8 2.8 1.2 5.6 1.2 8.4 0 19.2-16.6 28-32 28-9.4 0-17.8-3-23.6-8.4-5.6-5-8.4-11.6-8.4-19.6 0-2.4 0.2-4.6 0.8-7v-0.8l31-156zM510 672c-15.2 0-28 10.8-31.2 25v0l-31.2 157c-1 4.6-1.6 9.2-1.6 14 0 35.4 28.6 60 64 60s64-24.6 64-60c0-5.8-0.8-11.4-2.2-16.8l-30-150c-1.4-16.4-15-29.2-31.8-29.2v0z","M666 730.2l84 61.2 1.4 0.8c0.6 0.4 2.2 1.8 3.4 2.8 0.8 0.8 1.8 1.4 2.6 2.2 0.8 0.6 2.2 3.4 2.6 7.6 0.2 5.6-1.6 11.2-4.8 14.4-2.8 2.8-7.6 4.6-12.8 4.6s-8.6-1.8-9.6-2.8c-0.4-0.6-1-1.2-1.4-1.8-1-1-2.2-2.4-2.4-3l-1.2-1.6-61.8-84.4zM631.8 672.2c-6 0-11.8 2.4-16.6 7.2-8.2 8.2-9.4 20.8-3.4 30.8l90 123.6c1.8 3 4.4 5.6 6.8 8.4 8 9.2 20.6 14 33.8 14 12.8 0 26-4.6 35.4-14 19.2-19.2 18.8-54 0-69.4-3.4-2.8-6.6-5.8-10.2-7.8l-119.2-87c-5.6-4-11.2-5.8-16.6-5.8v0z","M357.8 730.4l-62.4 85.6c-0.6 1-1.4 2-2.4 3-3.2 3.2-7.4 5-12 5s-8.8-1.8-12-5c-6.6-6.6-6.6-17.4 0-24 1-1 2.2-2 3.6-2.8l1.4-0.8 1.4-1 82.4-60zM391.2 672c-5.6 0-11 1.8-15.4 5.6l-119.2 86.8c-3.6 2.2-7.2 4.8-10.2 7.8-19.2 19.2-19.2 50.2 0 69.4 9.6 9.6 22 14.4 34.6 14.4s25-4.8 34.6-14.4c2.6-2.6 4.8-5.4 6.8-8.4l90-123.2c6-10 5-22.4-3.4-30.6-5-5-11.4-7.4-17.8-7.4v0z","M558.6 136c18.6 6.8 41 18 61.6 33.2 29.8 21.8 65.2 58.4 65.2 108 0 28.2-4.8 49.4-15.8 68.6-13 23.2-36 45.2-70.4 67.6-14.6 9.6-31.2 18.8-48.8 28.8-59.6 33.6-132 74.2-169.4 151-5.8-4.4-11.8-10-17.8-16.4-27-29.8-37.2-68-30.4-113.4 7.6-49.6 52.4-91.4 99.8-135.6 56.4-51.8 118.8-109.8 126-191.8zM525.4 96c24 161.6-203.4 226-224 362.6s96 181.4 96 181.4c32.6-113.2 144.8-151.2 219.4-199.6 81.4-52.8 100.6-102.6 100.6-163 0-115.2-144.6-181.4-192-181.4v0z","M711.4 392.2c-6.6 12.6-14.6 24.4-25 35.8 0 0 2.8 22.2 4 40.8s-1.4 34.2-3.4 40c-13 38-30.2 64.2-52.8 79.6-19.6 13.4-44 19.6-77 19.6-12.8 0-32.8-7.8-48.4-21.8s-22.2-22.4-22.2-22.4c-8.2 7-15 13-22.2 21 22.6 32.8 62.6 55.4 92.6 55.4 72 0 128-27 160-120.8 10.6-29.8 4.4-98.8-5.6-127.2z","M374.2 155.8c-3 0-5.8 0.2-8.6 0.6 4.6 57.2-60 88-64 129.6-2.4 25.2 11 50 22 57.6 7.6-9.6 21.4-23.8 21.4-23.8-9-7.4-13.4-25.4-11-33.6s12-19.8 21.2-31c13.4-16.4 30.4-37 38.2-63.2 2.6 1.2 5.2 2.4 7.6 4 5.8 3.4 13.6 7.8 19.4 14.8s11.6 13.8 16.8 23c0 0 12.6-15.8 17.6-25.2-19.2-36.2-53.8-52.8-80.6-52.8z","M275.4 670.4l-121 25.2c-11.6 2.4-23.2-4.6-25.8-15.8s4.8-22.2 16.6-24.6c0.6-0.2 1.4-0.2 2-0.4l123-14.6c8.8-1 16.8 5 18 13.4 0.8 7.8-4.8 15-12.8 16.8z","M748.6 670.4l121 25.2c11.6 2.4 23.2-4.6 25.8-15.8s-4.8-22.2-16.6-24.6c-0.6-0.2-1.4-0.2-2-0.4l-123-14.6c-8.8-1-16.8 5-18 13.4-0.8 7.8 4.8 15 12.8 16.8z"],"grid":0,"tags":["ios-bonfire-outline"]},{"paths":["M541.8 701.2c-1.4-16.4-15.2-29.2-31.8-29.2-15.2 0-28 10.8-31.2 25v0l-31.2 157c-1 4.6-1.6 9.2-1.6 14 0 35.4 28.6 60 64 60s64-24.6 64-60c0-5.8-0.8-11.4-2.2-16.8l-30-150z","M611.8 710v0 0z","M777.8 772.6c-3.4-2.8-6.6-5.8-10.2-7.8l-119.2-87c-11.6-7.6-24-7.4-33 1.8-8.2 8.2-9.4 20.8-3.4 30.8l90 123.6c1.8 3 4.4 5.6 6.8 8.4 15.6 18.2 50.2 19.2 69.2 0 18.8-19.6 18.6-54.4-0.2-69.8z","M745 670v0 0z","M870.8 640c-15.6 0-111.2 0-119 0s-14.8 4.4-16.2 12.4c-1.2 7.2 2.6 14.2 9.4 17.6v0c0 0 0.2 0 0.2 0l115.4 35.6c16.6 3.8 35.4-11 35.4-29.6 0-23.6-9.6-36-25.2-36z","M278.4 670v0 0z","M278.4 670v0c6.6-3.2 10.6-10.4 9.4-17.6-1.4-8-7.8-12.4-16.2-12.4s-103.8 0-119 0-24.6 16.6-24.6 35.2 18.2 34.2 34.8 30.4l115.4-35.6c-0 0 0.2 0 0.2 0z","M375.8 677.6l-119.2 86.8c-3.6 2.2-7.2 4.8-10.2 7.8-19.2 19.2-19.2 50.2 0 69.2 19.2 19.2 50.2 19.2 69.2 0 2.6-2.6 4.8-5.4 6.8-8.4l90-123.2c6-10 5-22.4-3.4-30.6-9.2-9-23.6-9.6-33.2-1.6z","M717.4 277.4c0-115.2-144.8-181.4-192-181.4 24 161.6-203.4 226-224 362.6s96 181.4 96 181.4c32.6-113.2 144.8-151.2 219.4-199.6 81.4-52.8 100.6-102.6 100.6-163z","M717.4 519.2c10-29.4 3.8-98.6-6-126.8-18 35-52.6 64.8-94.4 92-17.2 11.2-41.8 21.6-59.6 31.8-37.4 21-68 41.2-92.6 68.8 22.6 32.8 62.6 55.4 92.6 55.4 72-0.4 128-27.4 160-121.2z","M323.6 343.8c23.4-30.2 49.8-47.6 76.4-72.4 26.8-25 44.2-42.4 55-62.6-21.4-40.2-61.6-56.2-89.4-52.2 4.6 57.2-60 88-64 129.6-2.6 25.2 10.8 50 22 57.6z"],"grid":0,"tags":["ios-bonfire"]},{"paths":["M256 96v832l256-192.8 256 192.8v-832h-512zM736 864l-224-168.6-224 168.6v-736h448v736z"],"grid":0,"tags":["ios-bookmark-outline"]},{"paths":["M256 96v832l256-192.8 256 192.8v-832h-512z"],"grid":0,"tags":["ios-bookmark"]},{"paths":["M534.4 404c0 0 0 0 0 0-14 0-29.8 2.6-46.6 5.8-23.8 4.6-40 14.2-40 14.2s7 54.6 0 117c-7 62.4-16 85-16 85s10.4 24.2 80 30c7.8 0.6 15.2 1 22 1 49 0 72.8-14.6 72.8-14.6s7.2-10.8 9.2-44.4c3.8-64.2-13.4-136.8-33-171-9.6-17.2-26.8-23-48.4-23zM583.8 596c-0.6 10.2-1.8 17.4-2.8 22.2-9 3-24.6 6.6-47.2 6.6-6.2 0-12.8-0.2-19.4-0.8-23.8-2-38-6.2-46.2-9.6 3.4-14.8 7.8-37.6 11.4-69.8 4.4-40.2 3.6-77 2.2-100 3.6-1.2 7.8-2.2 12.2-3 12.2-2.4 27.6-5 40.4-5v0 0 0c16.8 0 19.4 4.4 20.6 6.6 8.2 14.2 16.2 38.6 21.8 64.8 6.2 29.8 8.6 61.2 7 88z","M168.8 224c-53 0-104.8 137-104.8 288s46 288 103 288c66.8 0 233-160 233-160s11.4-25.2 19.8-67.2l3.6-20.8c1.4-9.4 2.6-19.4 3.4-30 0.6-7 1-13.6 1.2-19.8l0.6-19.6c1.6-32-5-65.2-5-65.2-44.2-80.4-184.6-193.4-254.8-193.4zM288.4 695c-86.6 69.4-116.2 73-121.4 73-6.4 0-25.2-16.2-42.6-66-18-51.4-28.4-120.6-28.4-190 0-66 10.6-133.8 29.2-185.8 19.8-55.4 39.6-69.6 43.6-70.2 6.6 0 22 2 49 15.6 21.2 10.6 44.8 25.8 68.6 44.4 46.2 35.8 86.6 78.6 106.4 112.6 1.4 8.2 3.8 26.2 3.8 44.4-16.2-7-41.8-15.8-77.4-22.8-56-11-84.8-6.2-86-6-1.8 0.4-3.2 2-3.4 3.8 0 2 1.4 3.6 3.2 4 0.4 0 37.6 7.6 113.8 33.8 17 5.8 28.6 10 38 13.4 4 1.4 7.4 2.6 10.8 3.8-0.2 5.6-0.6 11-1 16.6-0.8 9-1.8 18.4-3 27.4l-1 5.6c-11 4-26.2 9-43.4 13.6-34 9-76 20-76 20-2 0.6-3.2 2.4-3 4.6 0.4 2 2.2 3.4 4.2 3.4 3.2-0.2 70.8-5.4 112.6-13.6-4.6 19.6-9.6 34-12.4 41.2-11.8 11.2-45.6 42.4-84.2 73.2z","M855.2 224c-72.8 0-204.8 113-248.6 193.6l-1.6 2.8c0 0 2.8 5 3.8 6.8 6.8 12 13.4 28.6 18.8 48l5.8 23.4c4.4 20.4 7.4 42.4 8.4 64.4l0.4 18c0 5.8-0.2 11.4-0.6 17-2 33.4-9.2 44.2-9.2 44.2 15.2 21 150 157.8 224.4 157.8 57 0 103-137 103-288s-51.6-288-104.6-288zM857 768c-22.8 0-65.4-23.8-114.2-63.8-32.4-26.6-59.6-53.6-74-69 2.2-9 3.8-20.6 4.8-35.4 0.2-3.2 0.4-6.6 0.4-10 42.2 11.4 120.4 19.2 124.2 19.6 0.2 0 0.2 0 0.4 0 1.8 0 3.6-1.4 4-3.2 0.4-2-0.8-4-2.8-4.6-0.4-0.2-43.4-13.2-81-23-17.6-4.6-33.2-9.8-44.8-14.2v-2.2l0.2-0.4v-0.4c-1.8-21.4-4-44-8.4-65.6 40.8-22.6 126-61 127-61.4 1.8-0.8 2.8-2.8 2.2-4.8s-2.4-3.2-4.4-2.8c-0.4 0-30.8 5.2-70.6 19.2-20.2 7-42.6 14.8-61 21.2l-0.4-1.2c-4.8-17.2-10.6-32.8-16.8-45.4 21.2-33.4 57.8-72.6 98.4-105.4 54.4-43.8 95-59.4 115-59.4 4 0.6 23.8 14.6 43.6 70.2 18.6 52.2 29.2 120 29.2 185.8 0 69.4-10.4 138.6-28.4 190-17.4 50-36.2 66.2-42.6 66.2z"],"grid":0,"tags":["ios-bowtie-outline"]},{"paths":["M581.6 427c-9.6-17-27.6-22.6-49.6-22.6v-0.4c-12 0-28.6 2.6-45.2 5.8-23.8 4.6-39.4 14.2-39.4 14.2s7.2 54.6 0.2 117c-7 62.4-15.8 85-15.8 85s10.6 24.2 80 30c7.8 0.6 15.2 1 22 1 49 0 72.8-14.6 72.8-14.6s6.6-10.8 8.6-44.2c3.8-64.4-14-137-33.6-171.2z","M423.4 417.6c-44-80.4-184.4-193.6-254.6-193.6-53-0-104.8 137-104.8 288s46 288 103 288c66.8 0 233-160 233-160s11.4-25.2 19.8-67.2l3.6-20.8c1.4-9.4 2.6-19.4 3.4-30 0.6-7 1-13.6 1.2-19.8l0.6-19.6c1.4-32-5.2-65-5.2-65zM230 448c0-2 1.4-3.6 3.4-3.8 1.2-0.2 29.8-5 86 6 42 8.2 70.2 19.2 85.4 26.4l-2.6 28.6c-5.2-1.8-10.6-3.6-17-6-9.4-3.4-21-7.4-38-13.4-76.2-26.2-113.4-33.8-113.8-33.8-2-0.4-3.4-2.2-3.4-4zM395 578.2c-40.2 9.4-118.8 15.4-122.2 15.6-2 0.2-4-1.2-4.2-3.4-0.4-2 1-4 3-4.6 0 0 42-11 76-20 23-6 42.2-13 52.8-17l-5.4 29.4z","M855.2 224c-72.8 0-204.8 113-248.6 193.6l-1.6 2.8c0 0 2.8 5 3.8 6.8 6.8 12 13.4 28.6 18.8 48l5.8 23.4c4.4 20.4 7.4 42.4 8.4 64.4l0.4 18c0 5.8-0.2 11.4-0.6 17-2 33.4-9.2 44.2-9.2 44.2 15.2 21 150 157.8 224.4 157.8 57 0 103-137 103-288s-51.6-288-104.6-288zM719.6 446.2c39.8-14 70.4-19.2 70.6-19.2 2-0.4 4 0.8 4.4 2.8 0.6 2-0.4 4-2.2 4.8-1 0.4-101.4 45.8-136.4 67 0 0 0 0.4 0 0.4v0c0 0 0-0.2 0-0.4l-7.6-30.6v-0.2c20-6.6 47-16.2 71.2-24.6zM802.4 606.2c-0.4 1.8-2 3.2-4 3.2-0.2 0-0.2 0-0.4 0-4.2-0.4-98.8-9.8-136-23.2-4-23.2 1.8-24.8 1.8-25.8 11.8 4.6 31.6 11.8 54.8 18 37.6 10 80.6 23 81 23 2 0.8 3.2 2.8 2.8 4.8z"],"grid":0,"tags":["ios-bowtie"]},{"paths":["M299 566.6c-103.8 0-167.8 91.4-167.8 190.2 0 45.4-20.2 78.4-67.2 96.2 28.6 55.6 124 75 191.4 75 16.8 0 31.8-1.2 43.6-3.4 71.2-12.8 160.2-49.8 181.4-154 24.6-121.2-77.6-204-181.4-204zM449 764.4c-8 39.2-27.2 69-59 91.4-25.2 17.8-57.6 30.4-96.6 37.4-7.2 1.2-19.6 2.8-38 2.8-50.8 0-108.2-11.6-141-34.2 32-24.4 48.8-60 48.8-104.8 0-42 13.8-82.8 37.6-111.8 17.4-21.2 48.6-46.4 98.2-46.4 48.4 0 96.2 21.8 124.8 56.6 17.2 21.2 35.6 57.2 25.2 109z","M935.2 120.8c-15.4-15.4-33.6-24.8-52.2-24.8-12.6 0-25.4 4.4-37.6 14l-350.2 308.2c-6.8-1.8-13.2-2.8-19.4-2.8-9.6 0-18.6 2.4-26.4 7.6l-127.2 105.6c-3.2 3.2-3 8.6 0.2 11.8 1 1 2.2 1.6 3.4 2 1.2 0 2.6 0.2 3.8 0.2 0 0 0 0 0.2 0 95.8 6.8 184 75.6 180.6 181 0 1 0 2-0.2 3 0.2 1.6 1 3.4 2.2 4.6 1.6 1.6 3.8 2.4 5.8 2.4s4.2-0.8 5.8-2.4c0 0 0 0 0.2 0 0.2-0.2 0.2-0.2 0.4-0.4l108.6-124.4c8.4-12.8 9.4-28.4 4.8-45.8l308.4-350c23.4-30 14.8-64-11.2-89.8zM921.4 190l-319.2 362.4 4.6 16.6c2.2 8 2.2 14.2 0.2 18.4l-70.8 81c-9.2-36.4-28.8-69.4-57.4-96-26.6-24.6-59.6-42.8-95.8-53l85-70.4c1.6-0.8 3.8-1.6 7.6-1.6 3.2 0 7 0.6 11 1.6l16.6 4.6 362.8-319c5.8-4.4 11.4-6.6 17-6.6 9.2 0 19.8 5.4 29.6 15.4 8.4 8.4 13.8 17.6 15 25.8 0.8 4.4 1 11.6-6.2 20.8z","M322.2 528.4v0 0z"],"grid":0,"tags":["ios-brush-outline"]},{"paths":["M299 566.6c-103.8 0-167.8 91.4-167.8 190.2 0 45.4-20.2 78.4-67.2 96.2 28.6 55.6 124 75 191.4 75 16.8 0 31.8-1.2 43.6-3.4 71.2-12.8 160.2-49.8 181.4-154 24.6-121.2-77.6-204-181.4-204z","M935.2 120.8c-15.4-15.4-33.6-24.8-52.2-24.8-12.6 0-25.4 4.4-37.6 14l-350.2 308.2c-6.8-1.8-13.2-2.8-19.4-2.8-9.6 0-18.6 2.4-26.4 7.6l-127.2 105.6c-3.2 3.2-3 8.6 0.2 11.8 1 1 2.2 1.6 3.4 2 1.2 0 2.6 0.2 3.8 0.2 0 0 0 0 0.2 0 95.8 6.8 184 75.6 180.6 181 0 1 0 2-0.2 3 0.2 1.6 1 3.4 2.2 4.6 1.6 1.6 3.8 2.4 5.8 2.4s4.2-0.8 5.8-2.4c0 0 0 0 0.2 0 0.2-0.2 0.2-0.2 0.4-0.4l108.6-124.4c8.4-12.8 9.4-28.4 4.8-45.8l308.4-350c23.4-30 14.8-64-11.2-89.8z","M322.2 528.4v0 0z"],"grid":0,"tags":["ios-brush"]},{"paths":["M912 512c-9.2 0-18 2.6-25.2 7.2-10.8-4.8-28.8-10.6-54.8-12.2-0.6-55.4-11-108-29.2-155.4 17-12.6 31.6-28.8 42.6-47.6 0.8 0 1.8 0 2.6 0 26.4 0 48-21.4 48-48s-21.4-48-48-48c-26.4 0-48 21.4-48 48 0 14 6 26.6 15.6 35.4-6 9.6-14.6 20.2-26 29.8-55-115.4-158.8-193.2-277.6-193.2s-222.6 77.8-277.8 193c-11.4-9.6-19.8-20.2-25.8-29.8 9.6-8.8 15.6-21.4 15.6-35.4 0-26.6-21.4-48-48-48s-48 21.4-48 48c0 26.6 21.4 48 48 48 0.8 0 1.8 0 2.6 0 11.2 18.8 25.6 35 42.6 47.6-18.2 47.4-28.6 100-29.2 155.6-26.2 1.6-44 7.4-54.8 12.2-7.4-4.6-16-7.2-25.2-7.2-26.6 0-48 21.4-48 48s21.4 48 48 48 48-21.4 48-48c0-5-0.8-9.8-2.2-14.4 8-2.6 19.6-5.4 35-6.6 4.6 78 28.4 149.6 66 207.8-12 9-29.2 26-39.8 53.4-24.2 2.6-43 23-43 47.8 0 26.6 21.4 48 48 48s48-21.4 48-48c0-16.8-8.6-31.4-21.6-40 7.8-18 19-29 26.8-35 55 71.4 132.4 117.4 218.8 122.6 2.4 0.2 4.4 0.2 6.4 0.2 0.6 0 1.4 0 2 0 2.4 0 4.8 0.2 7.4 0.2 0 0 0 0 0 0s0 0 0 0 0 0 0 0c2.6 0 5 0 7.4-0.2 0.6 0 1.4 0 2 0 2 0 4.2-0.2 6.6-0.2v0c86.4-5.2 163.8-51.4 218.8-122.6 7.8 6 19 17 27 35.2-13 8.6-21.6 23.4-21.6 40 0 26.6 21.4 48 48 48 26.4 0 48-21.4 48-48 0-24.8-18.8-45.2-43-47.8-10.8-27.6-27.8-44.4-39.8-53.6 37.6-58.2 61.4-129.8 66-207.6 15.4 1 27 3.8 35 6.6-1.4 4.6-2.2 9.4-2.2 14.4 0 26.6 21.4 48 48 48s48-21.4 48-48-21.4-48.2-48-48.2zM848.2 240c8.8 0 16 7.2 16 16s-7.2 16-16 16c-8.8 0-16-7.2-16-16s7-16 16-16zM176 272c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM112 576c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM224 864c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM800.2 832c8.8 0 16 7.2 16 16s-7.2 16-16 16c-8.8 0-16-7.2-16-16s7.2-16 16-16zM512 160c88.8 0 168.4 49.4 221.4 127-11 18.8-24.4 36.4-40.4 52.2-48.4 48.4-112.6 75-181 75s-132.6-26.6-181-75c-15.8-15.8-29.4-33.4-40.4-52.2 53-77.6 132.6-127 221.4-127zM224 512c0-71.8 17.8-138.8 48-194.4 49 73.4 130.8 123.2 224 128.2v417.8c-151.4-10.4-272-164-272-351.6zM528 863.4v-417.6c93-5.2 175-54.8 224-128.2 30.4 55.8 48 122.6 48 194.6 0 187.4-120.6 341-272 351.2zM912 576c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16z"],"grid":0,"tags":["ios-bug-outline"]},{"paths":["M749.2 254.6c-58.4-77.6-143-126.6-237.2-126.6s-178.8 49-237.2 126.6c12.8 31.2 31.6 60 56.2 84.6 48.4 48.4 112.6 75 181 75s132.6-26.6 181-75c24.6-24.6 43.6-53.2 56.2-84.6z","M253.6 285.6c-3.4 5.6-6.8 11.4-10 17.2-5.8-3.6-10.6-7.4-15.4-11.6-2.4-2-6-7.8-9-14.8 10.8-22.6 2.4-50-19.8-62.6-23.2-13-52.4-4.8-65.4 18.4s-4.8 52.4 18.4 65.4c2.6 1.4 5 2.6 7.6 3.4 5.6 12.6 14.6 28.6 27 39 8.4 7 17.6 14.2 30.4 21.4-14.4 40.6-23.2 84.6-25 130.8-22 0.4-37.2 4.2-51 8.2-8.4 2.4-16.4 6.8-23.6 11.8-2-0.2-3.8-0.4-5.8-0.4-26.6 0-48 21.4-48 48s21.4 48 48 48c25.8 0 47-20.4 48-46 10-3 19.8-5.4 34.2-5.6 6.4 66 26.6 127 57.2 178.4-28.4 22-45.8 46-53.2 72.6 0 0-1.6 0.8-3.8 2.8-2 1.6-3.8 3.2-5.6 5.2-17.8 19.8-16.2 50 3.6 67.8s50 16.2 67.8-3.6c16.2-18 16.2-44.8 1.2-62.8 6.2-11.2 12.4-18 27.4-30 54.2 63.4 126.8 104 207.4 108.8v-449.6c-106.6-5.8-197.8-69.6-242.6-160.2z","M912 512.2c-2 0-4 0.2-5.8 0.4-7.2-5-15.4-9.2-23.6-11.8-13.8-4-28.8-7.8-51-8.2-2-46.2-10.8-90.4-25-130.8 12.8-7.2 22-14.4 30.4-21.4 12.4-10.4 21.4-26.6 27-39 2.6-1 5.2-2 7.6-3.4 23.2-13 31.4-42.2 18.4-65.4s-42.2-31.4-65.4-18.4c-22.2 12.4-30.6 39.8-19.8 62.6-3.2 6.8-6.8 12.8-9 14.8-4.8 4-9.6 7.8-15.4 11.6-3.2-5.8-6.6-11.6-10-17.2-44.8 90.6-135.8 154.2-242.4 160v450c80.6-4.8 153.2-45.6 207.4-108.8 14.8 11.8 21.2 18.8 27.4 30-15 18-15 44.8 1.2 62.8 17.8 19.8 48 21.4 67.8 3.6s21.4-48 3.6-67.8c-1.8-2-3.6-3.6-5.6-5.2-2.2-1.8-3.8-2.8-3.8-2.8-7.4-26.6-24.8-50.6-53.2-72.6 30.6-51.4 50.8-112.4 57.2-178.4 14.4 0.2 24 2.6 34.2 5.6 1 25.6 22 46 48 46 26.6 0 48-21.4 48-48s-21.6-48.2-48.2-48.2z"],"grid":0,"tags":["ios-bug"]},{"paths":["M695.8 128v0c8 0 18 2 28 6l-89.4 89.8 3 16.4 18.4 102.4 4 21.8 21.8 4 119 21.6 11.8-11.8 78-78.4c6 14.2 6 26 5.8 30.8-1.4 24-11.4 61-50 99.6-29.8 29.8-78.6 49.8-121.6 49.8-19 0-35.8-3.8-50-11.2v0 0c-7-3.6-18-8.4-31.8-8.4-11.2 0-28 3.4-44.6 19.4-18 17.6-362.6 384.8-377.4 400.4l-0.8 0.8c-11.4 13.2-26.8 15.2-35 15.2-14.8 0-29.4-6-40.2-16.4-10.8-11-17-26.8-16.4-42.4 0.4-9.2 3.2-22.4 15-32.4l1.2-0.8c15.6-14.8 384.6-362.2 399.8-377.2v0 0c15.8-15.8 19.2-32.4 19.4-43.6 0-13.8-4.8-25.2-7-30.8v0 0c-36.4-85.4 20.4-155.2 38.8-174.4v0 0c34.6-36.8 79.4-48.4 98.4-49.4 0-0.8 0.8-0.8 1.8-0.8zM695.8 96c-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40.2 42.4-82.2 121.2-45 209 4.4 10.6 9.4 24.6-5.4 39.4-15.2 14.8-399.4 376.6-399.4 376.6-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 358.8-382.2 376.4-399.6 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-24-6.8-55.8-33.4-82.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.2-22.2-53.6-33-77.8-33v0z","M205 858.6c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11.2 10.8 29 0 39.8z"],"grid":0,"tags":["ios-build-outline"]},{"paths":["M894.4 250l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.2-22.2-53.6-33-77.8-33-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40.2 42.4-82.2 121.2-45 209 4.4 10.6 9.4 24.6-5.4 39.4-15.2 14.8-399.4 376.6-399.4 376.6-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 358.8-382.2 376.4-399.6 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.6-23.8-6.8-55.6-33.4-82.2z"],"grid":0,"tags":["ios-build"]},{"paths":["M800 377.6c0-155.8-132.2-281.6-288-281.6s-288 125.8-288 281.6c0 62.2 26.4 118.2 60.4 166.2h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163v3h256v-3c0-17.8-7.2-87.4 36.8-163 20.2-34.6 41.2-60 63-90h-0.2c33.8-47.8 60.2-104 60.2-166.2zM702 540.6c-1.2 1.6-2.2 3-3.4 4.6-16.2 21.8-33 44.4-49.4 72.4-34.6 59.4-40.8 116.4-41.6 150.4h-31.6v-224.2l64-127.8h-33.2l-62.8 127.8v224.2h-64v-224.2l-62.8-127.8h-33.2l64 127.8v224.2h-31.8c-1-34-7.8-91.4-41.8-150-9-15.4-18.2-30-27.4-42h0.4l-37.2-51.2c-31.6-43.2-54.2-94.2-54.2-147.2 0-66.8 32-129.8 79.2-177s110-73 176.8-73 129.6 25.6 176.8 72.8c47.2 47.2 79.2 110 79.2 176.8 0 53-22.6 103.8-54.2 147.2l-11.8 16.2z","M448 896h128v32h-128v-32z","M416 832h192v32h-192v-32z"],"grid":0,"tags":["ios-bulb-outline"]},{"paths":["M800 377.8c0-155.8-132.2-281.8-288-281.8s-288 126.2-288 281.8c0 62 26.4 118.2 60.4 166.2h-0.6c21.8 30 42.8 55.4 63 90 44 75.6 37.2 148.6 37.4 163v3h64v-256.2l-64.2-127.8h33.2l62.8 127.8v256.2h64v-256.2l62.8-127.8h33.2l-64 127.8v256.2h64v-3c0-17.8-7.2-87.4 36.8-163 20.2-34.6 41.2-60 63-90h-0.2c34-48 60.4-104.2 60.4-166.2z","M448 896h128v32h-128v-32z","M416 832h192v32h-192v-32z"],"grid":0,"tags":["ios-bulb"]},{"paths":["M832 832c-17 37.4-48 32-127.8 32 0 21-2.2 32 6.6 32s100.8 0 110.2 0 8.4-7.6 11-64z","M192 832c3 56.8 1.6 64 11 64s101.4 0 110.2 0c8.8 0 6.6-11 6.6-32-79.8 0-100.8 6-127.8-32z","M752 704c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M368 704c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M768 128h-512c-35.2 0-64 28.8-64 64v0 560c0 44 36 80 80 80h480c44 0 80-36 80-80v-560c0-35.2-28.8-64-64-64zM800 752c0 26.4-21.6 48-48 48h-480c-26.4 0-48-21.6-48-48v-144h576v144zM224 544v-255.6c0-17.6 14.8-32.4 32.4-32.4h239.6v320h-239.6c-17.6 0-32.4-14.4-32.4-32zM800 544c0 17.6-14.4 32-32 32h-240v-320h240c17.6 0 32 14.8 32 32.4v255.6zM768 224h-512c-17.6 0-32-14.4-32-32s14.4-32 32-32h512c17.6 0 32 14.4 32 32s-14.4 32-32 32z"],"grid":0,"tags":["ios-bus-outline"]},{"paths":["M704.2 864c0 21-2.2 32 6.6 32s100.8 0 110.2 0 8.2-7.6 11-64c-17 37.4-48 32-127.8 32z","M192 832c3 56.8 1.6 64 11 64s101.4 0 110.2 0c8.8 0 6.6-11 6.6-32-79.8 0-100.8 6-127.8-32z","M768 128h-512c-35.2 0-64 28.8-64 64v0 560c0 44 36 80 80 80h480c44 0 80-36 80-80v-560c0-35.2-28.8-64-64-64zM320 752c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48zM496 576h-239.6c-17.6 0-32.4-14.4-32.4-32v-255.6c0-17.6 14.8-32.4 32.4-32.4h239.6v320zM704 752c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48zM800 544c0 17.6-14.4 32-32 32h-240v-320h240c17.6 0 32 14.8 32 32.4v255.6zM768 224h-512c-17.6 0-32-14.4-32-32s14.4-32 32-32h512c17.6 0 32 14.4 32 32s-14.4 32-32 32z"],"grid":0,"tags":["ios-bus"]},{"paths":["M64 800h896v32h-896v-32z","M400 768c30 0 131.4 0 160 0 17.6 0 116-24 189.4-160.8 6.2 0.6 12.4 0.8 18.6 0.8 106 0 192-78.8 192-176 0-77.2-54.2-142.8-129.8-166.6 1.2-23.4 1.8-47.8 1.8-73.4h-704c0 512 242 576 272 576zM928 432c0 79.4-71.8 144-160 144-1 0-2.2 0-3.2 0 30.4-67.2 54.4-157.2 63.4-277.4 58.4 21.4 99.8 73.2 99.8 133.4zM160.4 224h639.2c-2.2 98.4-14.6 185.8-36.8 260.2-19.4 64.8-46.4 119.8-80.2 163.4-49 63.4-101.6 88.4-121.4 88.4s-136.6 0-160.2 0-74.4-25.2-123.4-88.4c-33.8-43.6-60.8-98.6-80.2-163.4-22.4-74.4-34.8-161.8-37-260.2z"],"grid":0,"tags":["ios-cafe-outline"]},{"paths":["M64 800h896v32h-896v-32z","M400 768c30 0 131.4 0 160 0 17.6 0 116-24 189.4-160.8 6.2 0.6 12.4 0.8 18.6 0.8 106 0 192-78.8 192-176 0-77.2-54.2-142.8-129.8-166.6 1.2-23.4 1.8-47.8 1.8-73.4h-704c0 512 242 576 272 576zM928 432c0 79.4-71.8 144-160 144-1 0-2.2 0-3.2 0 30.4-67.2 54.4-157.2 63.4-277.4 58.4 21.4 99.8 73.2 99.8 133.4z"],"grid":0,"tags":["ios-cafe"]},{"paths":["M704 192v-64h-32v64h-320v-64h-32v64h-192v704h768v-704h-192zM864 864h-704v-480h704v480zM864 352h-704v-128h160v64h32v-64h320v64h32v-64h160v128z"],"grid":0,"tags":["ios-calendar-outline"]},{"paths":["M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4zM808.8 782.8c-40 48.4-63 48.4-104.6 48.4-40.6 0-103.6-28-168.4-74.6-62-44.8-89.6-65.4-151.8-129.2-65.8-67.4-107.2-123.6-152.8-207-48.2-88.2-42.8-126.8-33-158.6 5.2-17 20.8-35.2 42-48.4 1-0.6 2-1.4 3.2-2 10.6-6.8 28.2-18.2 47.4-18.2 16 0 30.2 8 43.8 24.6l2 2.4c51 62.4 90.8 117.6 60.8 158.4-21.2 28.6-32.4 48-30.6 68 1.6 19.4 14.6 34 34.2 56l1.4 1.6c32.2 36.4 41.4 46 54.2 59 2.2 2.2 4.4 4.6 7 7.2l3.6 3.8c14.8 15.4 23 23.8 60.6 56.8l2.2 2c16 14 27.8 24.2 45 24.2 17.8 0 37.4-11.2 74.6-35 3.8-2.4 9.2-3.8 16-3.8 43.4 0 118.2 49.6 144.4 76.6 24 24.4 36 42.8-1.2 87.8z"],"grid":0,"tags":["ios-call-outline"]},{"paths":["M831.8 671c-29.2-30-112.2-86.2-166.6-86.2-12.6 0-23.6 2.8-32.6 8.6-26.6 17-47.8 30.2-58 30.2-5.6 0-11.6-5-24.8-16.4l-2.2-2c-36.6-31.8-44.4-40-58.6-54.8l-3.6-3.8c-2.6-2.6-4.8-5-7-7.2-12.4-12.8-21.4-22-53.2-58l-1.4-1.6c-15.2-17.2-25.2-28.4-25.8-36.6-0.6-8 6.4-21 24.2-45.2 21.6-29.2 22.4-65.2 2.6-107-15.8-33-41.6-64.6-64.4-92.4l-2-2.4c-19.6-24-42.4-36-67.8-36-28.2 0-51.6 15.2-64 23.2-1 0.6-2 1.4-3 2-27.8 17.6-48 41.8-55.6 66.4-11.4 37-19 85 35.6 184.8 47.2 86.4 90 144.4 158 214.2 64 65.6 92.4 86.8 156 132.8 70.8 51.2 138.8 80.6 186.4 80.6 44.2 0 79 0 128.6-59.8 52-62.8 30.4-101.2-0.8-133.4z"],"grid":0,"tags":["ios-call"]},{"paths":["M869.4 406.8l31-4.8c0 0 0 0 0 0 14.2 0 44.8-6 51-12.4s8.4-11.6 8.4-17.2-3.4-15.8-9.6-22.6c-6-6.8-32-10.6-47.4-12.6-4.4-0.6-7.8-0.8-10.4-0.8-6.4 0-8.2 1.4-11 3.2-4.6 3-6 23.4-6.4 34l-16.2 3.6c-9.6-25-22.8-71.2-43-108-23-41.6-47-54.8-57-58-9.8-3-18.8-5.2-86-12.2-67.4-7-126-7-160.8-7s-93.4 0-161.2 7.2c-67.2 6.8-76.2 9-86 12.2-10 3.2-34 16.4-57 58-20.2 36.8-33.4 83-43 108l-16.2-3.6c-0.4-10.6-1.8-31.2-6.4-34-2.8-1.8-4.8-3.4-11-3.4-2.6 0-5.8 0.2-10.2 0.8-15.2 2-41.2 5.6-47.4 12.4-6 6.8-9.4 16.6-9.4 22.2s2.2 11.8 8.4 18.2c6.2 6.4 37 12.4 51 12.4 0 0 0 0 0 0l31 4.8c0 0-53.6 28.4-82.4 60.8 0 0-8.2 49-8.2 115.8 0 96 11.6 176.6 11.6 176.6 53 9.2 92.4 12.4 131.8 13.4 10.8 0.2 21.2 0.4 31.8 0.4 8.6 0 17.4 0 26.6-0.2 48.8-0.6 31.6-14.8 53.4-14.8 0.2 0 0.6 0 0.8 0 22.6 0.4 110 9 192 9s169.4-8.6 192-9c0.2 0 0.6 0 0.8 0 21.6 0 4.4 14.2 53.4 14.6 9 0 17.6 0.2 26 0.2 10.8 0 21.4-0.2 32.6-0.4 39.4-1 79-4.4 131.8-13.6 0 0 11.6-80.6 11.6-176.8 0-67-8.2-115.8-8.2-115.8-29-32.4-82.6-60.6-82.6-60.6zM220.8 308.8c8.6-20.2 28-54.2 44.2-65.6 0 0 94-19.2 247-19.2s247 19.2 247 19.2c16.2 11.2 35.6 45.2 44.2 65.6s22.8 67.6 20.6 73c-1.6 4 0.4 6.6-10.8 6.6-3.6 0-8.8-0.2-16-0.8-28.6-2.2-199-4.6-285-4.6s-256.2 2.4-285 4.6c-7.2 0.6-12.2 0.8-16 0.8-11.4 0-9.2-2.6-10.8-6.6-2.2-5.6 12-52.8 20.6-73zM919.6 732.2c-36.6 5.6-68.6 8.4-103.8 9.2-10.2 0.2-20.2 0.4-31.8 0.4-7.4 0-15.6 0-25.6-0.2-11-0.2-16.2-1-18.2-1.6-7.2-6.6-17-13.2-35.4-13.2-0.4 0-0.8 0-1.4 0-7.8 0.2-21 1-39.4 2-38.4 2.4-96.6 6.8-152 7-55.4 0-113.6-4.6-152.2-7-18.4-1.2-31.6-2-39.4-2-0.4 0-0.8 0-1.4 0-18.4 0-28.2 6.6-35.4 13.2-2 0.4-7.2 1.4-18.2 1.6-10.6 0.2-18.8 0.2-26.2 0.2-11.2 0-21.2-0.2-31-0.4-35.2-1-67.4-3.8-103.8-9.2-3.4-30.2-8.4-86.4-8.4-148.8 0-46.6 4.2-84.6 6.4-101.4 21.4-20.8 55.2-41.2 67.4-47.8l27.6-15c0 0 88.6-4 314.6-4s314.4 4 314.4 4l27.8 15c12.2 6.6 46 26.8 67.4 47.6 2.2 16.8 6.4 54.6 6.4 101.6 0 62.2-5 118.6-8.4 148.8z","M277.6 556.6c-19.8 0-59.6-2-69-2.4-9.4-0.2-17.6 7.6-22.4 7.6s-51-7.2-56-29.8c-5-22.4 0-46 0-45.6 31-1.4 61-0.4 117 15.6 56.2 15.8 87.2 46.6 87.2 46.6s-37 8-56.8 8z","M684.4 678.6c-25.4 3.4-117 4.4-172.4 4.4s-147-1-172.4-4.4c-26.2-3.4-59.6-34.6-36.8-60.4 15.2-17 41.6-27.2 97.8-34.6 59.6-7.6 97.2-8.6 111.2-8.6s51.6 1 111.2 8.6c56.2 7.4 86.4 19.2 97.8 34.6 20.8 27.6-10.2 56.8-36.4 60.4z","M893.8 532.2c-5 22.4-51.2 29.8-56 29.8s-13-7.8-22.4-7.6c-9.4 0.4-49.2 2.4-69 2.4s-56.8-8-56.8-8 31-30.8 87.2-46.6c56-16 86-17 117-15.6-0-0.4 5 23-0 45.6z","M802 824.6c0 4.2 2.6 7.4 6.4 7.4 0 0 106 0 113 0 9.8 0 11.8-7 12.4-11 2.8-16.8 3.8-42.6 3.8-42.6-51.4 9.4-97.6 11-135.6 12v34.2z","M90.4 821c0.6 4 2.6 11 12.4 11 7 0 113.4 0 113.4 0 3.8 0 6-3.2 6-7.4v-34.2c-38-1-84.4-2.6-135.8-12-0.2 0.2 1.2 25.8 4 42.6z"],"grid":0,"tags":["ios-car-outline"]},{"paths":["M951.8 468c-28.8-32.6-82.4-61.6-82.4-61.6l31-6.2c0 0 0 0 0 0 14.2 0 44.8-4.6 51-10.8 6.2-6.4 8.4-10.8 8.4-16.4s-3.4-15.4-9.6-22.2c-6-6.8-32-10.4-47.4-12.4-15.2-2-17.4 0-21.4 2.4-4.6 3-6 23.4-6.4 34l-16.2 3.6c-9.6-25-22.8-71.2-43-108-23-41.6-47-54.8-57-58-9.8-3-18.8-5.2-86-12.2-67.4-7.2-126-8.2-160.8-8.2s-93.4 1-161.2 8.2c-67.2 6.8-76.2 9-86 12.2-10 3.2-34 16.4-57 58-20.2 36.8-33.4 83-43 108l-16.2-3.6c-0.4-10.6-1.8-31.2-6.4-34-4-2.6-6-4.4-21.4-2.4-15.2 2-41.2 5.6-47.4 12.4-6 6.8-9.4 16.6-9.4 22.2s2.2 10.2 8.4 16.6c6.2 6.4 37 10.8 51 10.8 0 0 0 0 0 0l31 6.2c0 0-53.6 29.2-82.4 61.6 0 0-8.2 49.4-8.2 116.2 0 96 11.6 176.8 11.6 176.8 53 9.2 92.4 12.6 131.8 13.6 19.8 0.4 37.8 0.4 58.4 0.2 49.6-0.6 31.2-15 54.2-14.6 22.6 0.4 110 8 192 8s169.4-7.6 192-8c23-0.4 4.6 14.2 54.2 14.6 20.6 0.2 38.8 0.2 58.4-0.2 39.4-1 79-4.4 131.8-13.6 0 0 11.6-80.6 11.6-176.8 0.2-67.2-8-116.4-8-116.4zM220.8 309.8c8.6-20.2 28-54.2 44.2-65.6 0 0 94-20.2 247-20.2s247 20.2 247 20.2c16.2 11.2 35.6 45.2 44.2 65.6 8.6 20.2 22.8 67.6 20.6 73s2.2 8.2-26.8 5.8c-28.8-2.2-199-4.6-285-4.6s-256.2 2.4-285 4.6c-29 2.4-24.8-0.4-26.8-5.8-2.2-5.6 12-52.8 20.6-73zM247.6 541.6c-19.8 0-59.6-2-69-2.4-9.4-0.2-17.6 7.6-22.4 7.6s-51-7.2-56-29.8c-5-22.4 0-46 0-45.6 31-1.4 61-0.4 117 15.6 56.2 15.8 87.2 46.6 87.2 46.6s-37 8-56.8 8zM684.4 679.6c-25.4 3.4-117 4.4-172.4 4.4s-147-1-172.4-4.4c-26.2-3.4-59.6-34.6-36.8-60.4 15.2-17 41.6-27.2 97.8-34.6 59.6-7.6 97.2-8.6 111.2-8.6s51.6 1 111.2 8.6c56.2 7.4 86.4 19.2 97.8 34.6 20.8 27.6-10.2 56.8-36.4 60.4zM923.8 517.2c-5 22.4-51.2 29.8-56 29.8s-13-7.8-22.4-7.6c-9.4 0.4-49.2 2.4-69 2.4s-56.8-8-56.8-8 31-30.8 87.2-46.6c56-16 86-17 117-15.6-0-0.4 5 23-0 45.6z","M802 824.6c0 4.2 2.4 7.4 6.2 7.4 0 0 106 0 113 0 9.8 0 11.8-7 12.4-11 2.8-16.8 4-42.6 4-42.6-51.4 9.4-97.6 11-135.6 12v34.2z","M90.2 821c0.6 4 2.6 11 12.4 11 7 0 113.4 0 113.4 0 3.8 0 6.2-3.2 6.2-7.4v-34.2c-38-1-84.4-2.6-135.8-12-0.2 0.2 1 25.8 3.8 42.6z"],"grid":0,"tags":["ios-car"]},{"paths":["M864 224h-704c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM160 256h704c17.6 0 32 14.4 32 32v64h-768v-64c0-17.6 14.4-32 32-32zM896 384v96h-768v-96h768zM864 768h-704c-17.6 0-32-14.4-32-32v-224h768v224c0 17.6-14.4 32-32 32z","M192 640h64v32h-64v-32z","M320 640h384v32h-384v-32z"],"grid":0,"tags":["ios-card-outline"]},{"paths":["M864 224h-704c-35.2 0-64 28.8-64 64v448c0 35.2 28.8 64 64 64h704c35.2 0 64-28.8 64-64v-448c0-35.2-28.8-64-64-64zM160 256h704c17.6 0 32 14.4 32 32v64h-768v-64c0-17.6 14.4-32 32-32zM864 768h-704c-17.6 0-32-14.4-32-32v-224h768v224c0 17.6-14.4 32-32 32z","M192 640h64v32h-64v-32z","M320 640h384v32h-384v-32z"],"grid":0,"tags":["ios-card"]},{"paths":["M80 736h864v32h-864v-32z","M96 800h832v32h-832v-32z","M64 192v512h896v-512h-896zM928 672h-832v-448h832v448z","M768 256h128v32h-128v-32z","M768 608h128v32h-128v-32z","M128 256h128v32h-128v-32z","M128 608h128v32h-128v-32z","M512 592c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zM512 336c-61.8 0-112 50.2-112 112s50.2 112 112 112 112-50.2 112-112-50.2-112-112-112z"],"grid":0,"tags":["ios-cash-outline"]},{"paths":["M80 736h864v32h-864v-32z","M96 800h832v32h-832v-32z","M512 336c-61.8 0-112 50.2-112 112s50.2 112 112 112 112-50.2 112-112-50.2-112-112-112z","M64 192v512h896v-512h-896zM256 640h-128v-32h128v32zM256 288h-128v-32h128v32zM512 592c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zM896 640h-128v-32h128v32zM896 288h-128v-32h128v32z"],"grid":0,"tags":["ios-cash"]},{"paths":["M862 641.2c0-8.8 2.4-17.2 6.6-24.4 1.2-2.2 2.8-4.2 4.2-6.2 34.8-52 55.2-114.2 55.2-180.6 0.6-184.4-155-334-347.4-334-167.8 0-307.8 114.2-340.6 265.8-4.8 22.2-7.4 44.8-7.4 68.4 0 184.6 149.6 338.2 342 338.2 30.6 0 71.8-9.2 94.4-15.4s45-14.4 50.8-16.6 12.2-3.4 18.6-3.4c7.2 0 14 1.4 20.2 4l113.4 40.2c0 0 4.8 2 7.8 2 8.8 0 16-7 16-16 0-2-1-5.4-1-5.4l-32.8-116.6zM770.2 707.2c-10-4-20.6-6.4-31.6-6.4-8.2 0-20.2 1.6-24.4 3.2s-22.6 7.6-22.6 7.6c-8.4 2.8-19.8 7.6-30.4 10.2-28 7.2-60.2 14.4-86.4 14.4-83.8 0-162.2-32.2-220.6-90.6-28.2-28.2-50.2-61-65.6-97.4-15.8-37.6-23.8-77.4-23.8-118.2 0-20.4 2.2-41.2 6.6-61.6 14.4-66.8 53-127.6 108.4-171.4 27.6-21.8 58.8-39 92.2-50.8 34.8-12.2 71.4-18.4 108.8-18.4 44 0 86.6 8.4 126.6 25.2 38.6 16.2 72.8 39.2 102 68.4 56 56.6 86.6 130.6 86.6 208.6v0 0c0 57.8-17.2 114-49.4 162.4-0.2 0.2-0.4 0.6-0.6 0.8-1.4 1.8-3.2 4.4-5 7.6-7 12.2-10.8 24.8-10.8 40.2s16.4 65 26 96.4l-86-30.2z","M610.6 791.4c-12.6 12.2-24.2 20.8-24.2 20.8-49.8 40.4-112.8 62.8-179 62.8-37.6 0-74.2-7.2-109-21.4-0.8-0.4-1.6-0.6-2-0.8v0c-1.2-0.6-2.4-1-3.6-1.2-14-4.6-29.4-4-42.8 1.4l-85 33.6 18.6-97c0.2-1 0.2-2 0.2-3 0-10.2-2.6-20-7.8-28.6l-0.8-1.4c-1-1.6-2-3.6-3.4-5.4-28.8-43.4-44-93.8-44-145.8 0-60 21.2-125.6 75.6-185.8 1.2-8.6 2.6-17.2 4.6-25.6 2-9 4.4-18 7-26.8l-16 14.2c-65.4 57-103 138.6-103 223.6 0 58.6 17.2 115.2 49.6 164 0.2 0.2 0.4 0.4 0.6 0.8 0.4 0.4 1.2 1.8 1.6 2.8 0.4 0.6 0.6 1.2 1 1.6 2 3.4 3 6.8 3.2 10.8l-23.8 124c-1.2 5.8 1 11.6 5.4 15.4 3 2.4 6.6 3.6 10.2 3.6 2 0 4-0.4 5.8-1.2l112.2-44.2c3.6-1.4 7.4-2.2 11.4-2.2 3.6 0 7.2 0.6 10.6 1.8 0.4 0.2 1 0.4 1.4 0.4v0c0.2 0.2 0.4 0.2 0.6 0.2 38.6 16 79.6 24 121.4 24 93.2 0 180.8-40.2 240.2-110.2 0 0 6.4-8.8 13.8-19.2-7.6 2.4-16 5-24.4 7.4-7.2 2.2-16.2 4.4-26.2 6.6z"],"grid":0,"tags":["ios-chatbubbles-outline"]},{"paths":["M862 641.2c0-8.8 2.4-17.2 6.6-24.4 1.2-2.2 2.8-4.2 4.2-6.2 34.8-52 55.2-114.2 55.2-180.6 0.6-184.4-155-334-347.4-334-167.8 0-307.8 114.2-340.6 265.8-4.8 22.2-7.4 44.8-7.4 68.4 0 184.6 149.6 338.2 342 338.2 30.6 0 71.8-9.2 94.4-15.4s45-14.4 50.8-16.6 12.2-3.4 18.6-3.4c7.2 0 14 1.4 20.2 4l113.4 40.2c0 0 4.8 2 7.8 2 8.8 0 16-7 16-16 0-2-1-5.4-1-5.4l-32.8-116.6z","M622.4 806.8c-0.6 1-0.2 1.4 1.4 0.8-0.2-0.6-0.6-0.8-1.4-0.8z","M637 785c-7.2 2-16.4 4.2-26.4 6.4-21 4.4-47.8 9-68 9-192.4 0-342-153.6-342-338.2 0-13.2 1.4-30 3-42.8 1.2-8.6 2.6-17.2 4.6-25.6 2-9 4.4-18 7-26.8l-16 14.2c-65.6 57.2-103.2 138.8-103.2 223.8 0 58.6 17 115 49.6 164 4.6 7 7.2 12.4 6.4 16s-23.8 124-23.8 124c-1.2 5.8 1 11.6 5.4 15.4 3 2.4 6.6 3.6 10.2 3.6 2 0 4-0.4 5.8-1.2l112.2-44.2c3.6-1.4 7.4-2.2 11.4-2.2 0 0 4.8-0.4 12.6 2.6 37.8 14.8 79.6 24 121.4 24 93.2 0 180.8-40.2 240.2-110.2 0 0 6.4-8.8 13.8-19.2-7.4 2.6-15.8 5.2-24.2 7.4z"],"grid":0,"tags":["ios-chatbubbles"]},{"paths":["M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z","M680.2 354.6l-249.6 251.4-94.4-94.4-35.8 35.6 130.2 130 284.6-286.4z","M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z"],"grid":0,"tags":["ios-checkbox-outline"]},{"paths":["M128 128v768h768v-768h-768zM432 714c-1 0-0.8-0.2 0-0.4 0.8 0.2 0.8 0.4 0 0.4zM430.6 677.2l-130-130 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-284.6 286.4z","M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z"],"grid":0,"tags":["ios-checkbox"]},{"paths":["M680.2 354.6l-249.6 251.4-94.4-94.4-35.6 35.6 112 112c5 5 11.8 9 17.8 9s12.6-4 17.6-8.8l267.4-268.8-35.2-36z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-checkmark-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"],"grid":0,"tags":["ios-checkmark-circle"]},{"paths":["M447.8 659.4c-4.8 4.8-11.6 8.8-17.6 8.8s-12.8-4.2-17.8-9l-112-112 35.6-35.6 94.4 94.4 249.6-251.4 35 36.2-267.2 268.6z"],"grid":0,"tags":["ios-checkmark"]},{"paths":["M544 191.4c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M800 128h-184.2c8.2 9.2 14.6 20 18.8 32h149.4c8.8 0 16 7.2 16 16v704c0 8.8-7.2 16-16 16h-544c-8.8 0-16-7.2-16-16v-704c0-8.8 7.2-16 16-16h149.4c4.2-12 10.6-22.8 18.8-32h-184.2c-17.6 0-32 14.4-32 32v736c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32v-736c0-17.6-14.4-32-32-32z","M352 222v34h-96v608h512v-608h-96v-34c0-17.6-12.8-30-30.4-30h-33.6c0-11.2-2-22-5.4-32-4.2-12-10.6-22.8-18.8-32-17.6-19.8-43.2-32-71.8-32s-54.2 12.2-71.8 32c-8.2 9.2-14.6 20-18.8 32-3.4 10-5.4 20.8-5.4 32h-29c-17.6 0-35 12.4-35 30zM672 320v-32h64v544h-448v-544h64v32h320zM448 224v-33c0-35.8 28.2-64 64-64s64 28.2 64 64v33h64v64h-256v-64h64z"],"grid":0,"tags":["ios-clipboard-outline"]},{"paths":["M288 832h448v-544h-32v64h-384v-64h-32z","M641.6 192h-33.6c0-11.2-2-22-5.4-32-4.2-12-10.6-22.8-18.8-32-17.6-19.8-43.2-32-71.8-32s-54.2 12.2-71.8 32c-8.2 9.2-14.6 20-18.8 32-3.4 10-5.4 20.8-5.4 32h-29c-17.6 0-35 12.4-35 30v98h320v-98c-0-17.6-12.8-30-30.4-30zM512 223.4c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32c0 17.6-14.4 32-32 32z","M704 222c0 0.6 0 1.4 0 2v-2z","M800 128h-184.2c8.2 9.2 14.6 20 18.8 32l0.2 0.2c1.6-0.2 3.4-0.2 5.2-0.2 34.6 0 62.8 27.6 64 62v0 34h64v608h-512v-608h64v-22c0-35.4 23.4-68 64-68 0.8 0 1.8 0 2.6 0 1 0 1.8 0 2.8 0 3.4-18 10.6-28.8 18.8-38h-184.2c-17.6 0-32 14.4-32 32v736c0 17.6 14.4 32 32 32h576c17.6 0 32-14.4 32-32v-736c0-17.6-14.4-32-32-32z"],"grid":0,"tags":["ios-clipboard"]},{"paths":["M528 176c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M528 848c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M864 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M192 512c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M237 344c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M819 680c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M696 221c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M360 803c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M237 680c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M819 344c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M360 221c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M696 803c0 8.837-7.163 16-16 16s-16-7.163-16-16c0-8.837 7.163-16 16-16s16 7.163 16 16z","M539.8 496c-5.8-10-16.2-15.6-26.8-16l-60-110.8c-4.6-7.6-14.4-10-22-5.4s-10 14.4-5.4 22l59.2 109.8c-5.8 9.6-6.4 22.2-0.4 32.6 3 5 7 9 11.8 11.6v228.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-228.2c15.2-9 20.4-28.4 11.6-43.8z","M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0s-148.6-390.6 0-539.2 390.6-148.6 539.2 0c148.8 148.6 148.8 390.6 0 539.2z"],"grid":0,"tags":["ios-clock-outline"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM512 160c8.8 0 16 7.2 16 16s-7.2 16-16 16-16-7.2-16-16c0-8.8 7.2-16 16-16zM207.2 336c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8zM176 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM229 693.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8 17.4-1.8 21.8 5.8c4.4 7.6 1.8 17.4-5.8 21.8zM357.8 811c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM352 234.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM512 864c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16zM528 539.8v228.2c0 8.8-7.2 16-16 16s-16-7.2-16-16v-228.4c-4.8-2.8-8.8-6.6-11.8-11.6-6-10.4-5.4-23 0.4-32.6l-59.2-109.8c-4.6-7.6-2-17.4 5.4-22 7.6-4.6 17.4-2 22 5.4l60 110.8c10.8 0.2 21.2 6 26.8 16 9 15.6 3.8 35-11.6 44zM688 816.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8c7.6-4.4 17.4-1.8 21.8 5.8s1.8 17.4-5.8 21.8zM693.8 229c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM816.8 688c-4.4 7.6-14.2 10.2-21.8 5.8s-10.2-14.2-5.8-21.8c4.4-7.6 14.2-10.2 21.8-5.8s10.2 14.2 5.8 21.8zM811 357.8c-7.6 4.4-17.4 1.8-21.8-5.8s-1.8-17.4 5.8-21.8 17.4-1.8 21.8 5.8c4.4 7.6 1.8 17.4-5.8 21.8zM848 528c-8.8 0-16-7.2-16-16s7.2-16 16-16 16 7.2 16 16c0 8.8-7.2 16-16 16z"],"grid":0,"tags":["ios-clock"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM781.6 781.6c-148.6 148.6-390.6 148.6-539.2 0s-148.6-390.6 0-539.2 390.6-148.6 539.2 0c148.8 148.6 148.8 390.6 0 539.2z","M680.4 320l-168.8 168.4-168-167.6-23.6 23.6 168 167.6-168 167.6 23.6 23.6 168-167.6 168.8 168.4 23.6-23.6-168.8-168.4 168.8-168.4z"],"grid":0,"tags":["ios-close-circle-outline"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0s162.4-426 0-588.4zM704 680.4l-23.6 23.6-168.8-168.4-168 167.6-23.6-23.6 168-167.6-168-167.6 23.6-23.6 168 167.6 168.8-168.4 23.6 23.6-168.8 168.4 168.8 168.4z"],"grid":0,"tags":["ios-close-circle"]},{"paths":["M680.4 320l-168.8 168.6-168-167.8-23.6 23.6 168 167.6-168 167.8 23.6 23.4 168-167.6 168.8 168.4 23.6-23.4-168.8-168.6 168.8-168.4z"],"grid":0,"tags":["ios-close"]},{"paths":["M960 832h-896v-640h896v640zM96 800h832v-576h-832v576zM540 780c-9.4 0-18.8 0-28 0s-18.4 0-27.8 0c-71.4 0-162-0.8-227.6-6.8-72.2-6.6-113-48.2-118-120l-1-15.4c-3.4-50-5.6-83-5.6-126.2 0-48 0.2-78.2 6.8-142 7.2-70.8 48-112 117.8-119.2 64-6.4 174.6-6.4 255.6-6.4 80.8 0 191.6 0 255.6 6.4 69.8 7 110.4 48.2 117.8 119.2 6.6 63.8 6.8 94 6.8 142 0 43-2.2 76-5.6 126l-1 15.6c-4.8 71.8-45.6 113.4-118 120-66 6-156.4 6.8-227.8 6.8zM512 748v0c9.2 0 18.6 0 28 0 70.8 0 160.2-0.8 224.6-6.6 56-5.2 85.2-34.8 89-90.4l1-15.6c3.4-49.2 5.6-81.8 5.6-123.8 0-47-0.2-76.6-6.6-138.8-5.8-56.2-34-85-89.2-90.6-62.4-6.2-172.2-6.2-252.4-6.2s-190 0-252.2 6.4c-55 5.6-83.4 34.4-89.2 90.6-6.4 62.2-6.6 91.8-6.6 138.8 0 42 2.2 74.6 5.6 124l1 15.4c3.8 55.6 32.8 85.2 89 90.4 64.4 6 153.8 6.6 224.6 6.6 9.4-0.2 18.8-0.2 27.8-0.2z","M675.4 356.8c34.4 0 58.8 8.6 74.8 26.4 11.2 12.4 18.8 31.6 22.6 54.8h-28.2c-10.8-35.4-39.8-59.6-75.8-59.6-22.4 0-41.6 8-55.8 23.2-12.8 13.6-20.8 32.4-24.2 56v0 0c-0.2 1-3 22.6-3 56.4 0 29.8 2 46.8 2.6 51.4 4.4 47.2 37 80.2 79.6 80.2 22.2 0 42.4-8.4 57-23.6 9.6-10 16-22.2 19.6-36.2h28.8c-3.4 23.4-10.8 41.6-22.4 54.6-15.4 17.6-43.4 26.4-83.4 26.4-20.2 0-37.8-2.2-52.2-6.8-11.4-3.6-20.8-10-28.4-19.4-8.6-10.6-15.4-26-20.2-45.4-5.2-21.6-8-49.2-8-82.4 0-33.4 3.2-61.2 9.6-82.2 5.8-19.4 13.8-34.6 23.6-45.4 9.4-10.4 20.2-17.2 33.2-21.4 14.8-4.6 31.8-7 50.2-7zM675.4 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z","M365.6 356.8c34.4 0 58.8 8.6 74.8 26.4 11.2 12.4 18.8 31.6 22.6 54.8h-28.2c-10.8-35.4-39.8-59.6-75.8-59.6-22.4 0-41.6 8-55.8 23.2-12.8 13.6-20.8 32.4-24.2 56v0 0c-0.2 1-3 22.6-3 56.4 0 29.8 2 46.8 2.6 51.4 4.4 47.2 37 80.2 79.6 80.2 22.2 0 42.4-8.4 57-23.6 9.6-10 16-22.2 19.6-36.2h28.8c-3.4 23.4-10.8 41.6-22.4 54.6-15.4 17.6-43.4 26.4-83.4 26.4-20.2 0-37.8-2.2-52.2-6.8-11.4-3.6-20.8-10-28.4-19.4-8.6-10.6-15.4-26-20.2-45.4-5.2-21.6-8-49.2-8-82.4 0-33.4 3.2-61.2 9.6-82.2 5.8-19.4 13.8-34.6 23.6-45.4 9.4-10.4 20.2-17.2 33.2-21.4 14.8-4.6 31.8-7 50.2-7zM365.6 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z"],"grid":0,"tags":["ios-closed-captioning-outline"]},{"paths":["M64 192v640h896v-640h-896zM860 511.6c0 41.8-2.2 74.4-5.6 123.8l-1 15.6c-3.8 55.6-32.8 85.2-89 90.4-64.4 6-153.8 6.6-224.6 6.6-9.4 0-18.6 0-27.8 0v0c-9.2 0-18.4 0-27.8 0-70.8 0-160.4-0.8-224.6-6.6-56-5.2-85.2-34.8-89-90.4l-1-15.4c-3.4-49.4-5.6-82-5.6-124 0-47 0.2-76.6 6.6-138.8 5.8-56.2 34-85 89.2-90.6 62.4-6.4 172.2-6.4 252.2-6.4 80.2 0 190 0 252.4 6.4 55 5.6 83.4 34.4 89.2 90.6 6.2 62.2 6.6 91.8 6.4 138.8z","M675.4 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z","M365.6 324.8c-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0 0 0 5 0 6.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-21.6-24.8-54.4-37.2-98.2-37.2v0z"],"grid":0,"tags":["ios-closed-captioning"]},{"paths":["M548.6 352c28 0 54.4 10.6 74.8 29.8 20.4 19.4 33.2 46.2 36.4 75.4l2.6 24.2 24.2 4c28.8 4.6 49.6 30 49.6 60.4 0 16.8-6.4 32.4-17.8 44.4-11.2 11.6-25.8 18-41.2 18h-330.4c-15.4 0-30-6.4-41.2-18-11.4-12-17.8-27.8-17.8-44.4 0-28.6 17.8-53.6 44.2-62.2l21.8-7 0.4-22.8c0.4-22.4 18-40.8 39.4-40.8 5.6 0 16.8 2.2 24.2 5.6s17.6 8 17.6 8l15.2-21.8c20.8-32.6 58.4-52.8 98-52.8zM548.6 320c-51.2 0-98.8 26.8-125 67.6-9-4.2-19.2-6.8-29.8-6.8-39 0-70.8 32.2-71.4 72.2-40 13-66.4 50.4-66.4 92.4 0 51.4 40.6 94.4 90.8 94.4h330.2c50.2 0 90.8-42.8 90.8-94.4 0-46.4-33.2-84.8-76.6-91.8-7.6-75-67.2-133.6-142.6-133.6v0z","M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0z"],"grid":0,"tags":["ios-cloud-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM677.2 640h-330.4c-50.2 0-90.8-42.8-90.8-94.4 0-42 26.4-79.6 66.4-92.4 0.6-40 32.4-72.2 71.4-72.2 10.6 0 20.8 2.4 29.8 6.8 26.2-41 73.8-67.6 125-67.6 75.4 0 135 58.6 142.8 133.8 43.4 7 76.6 45.4 76.6 91.8 0 51.4-40.6 94.2-90.8 94.2z"],"grid":0,"tags":["ios-cloud-circle"]},{"paths":["M618.4 432l-154 153.8-58.4-57.8-22 22 69.2 68.6c3 3 7.2 5.6 11 5.6s7.8-2.4 10.8-5.4l165-164.4-21.6-22.4z","M826 452.2c-13.8-128.4-118-228.2-250-228.2-89.6 0-173 45.6-218.8 115.4-15.8-7.4-33.6-11.4-52.2-11.4-68.4 0-124 55-125 123.2-69.8 22-116 85.2-116 156.8 0 87.8 71.2 160 159 160h578c87.8 0 159-72.2 159-160 0-79.2-58-143.8-134-155.8zM801 736h-578c-70 0-127-57.6-127-128 0-28.6 8.8-54 25.6-77.2 17-23.2 40.4-40.4 68-49l22-7 0.4-23.2c0.4-24.6 10.2-47.6 27.6-64.8 17.6-17.2 40.6-26.8 65.2-26.8 13.6 0 26.6 2.8 38.8 8.4l25 11.6 15.2-23c41.6-63.6 115.8-101.4 191.6-101.4 55.6 0 105 20.6 146.2 57.8 41 37 66.6 87.4 72.6 142l2.6 24.4 24.2 3.8c29.4 4.6 56.6 19.8 76.2 42.8 19.8 23.2 30.8 51.2 30.8 81.6 0 70.4-57 128-127 128z"],"grid":0,"tags":["ios-cloud-done-outline"]},{"paths":["M826 452.2c-13.8-128.4-118-228.2-250-228.2-89.6 0-173 45.6-218.8 115.4-15.8-7.4-33.6-11.4-52.2-11.4-68.4 0-124 55-125 123.2-69.8 22-116 85.2-116 156.8 0 87.8 71.2 160 159 160h578c87.8 0 159-72.2 159-160 0-79.2-58-143.8-134-155.8zM475 618.6c-3 3-7.2 5.4-10.8 5.4s-8-2.6-11-5.6l-69.2-68.4 22-21.8 58.4 57.8 154-153.8 21.6 22.2-165 164.2z"],"grid":0,"tags":["ios-cloud-done"]},{"paths":["M354.236 723.86l-23.232 23.206 180.996 180.934 181.162-180.884-23.232-23.208-141.39 141.268v-449.176h-32.86v449.176z","M826.024 324.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h193v-32h-193c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128h-193v32h193c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"],"grid":0,"tags":["ios-cloud-download-outline"]},{"paths":["M496 865.176l-141.604-141.316-23.312 23.206 180.956 180.934 181.142-180.884-23.512-23.208-141.67 141.268v-225.176h-32z","M826.024 324.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h273v-224h32v224h273c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"],"grid":0,"tags":["ios-cloud-download"]},{"paths":["M826.024 452.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h578c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774zM801 736h-578c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128z"],"grid":0,"tags":["ios-cloud-outline"]},{"paths":["M669.93 524.14l23.232-23.206-180.998-180.934-181.16 180.886 23.232 23.208 141.388-141.27 0.002 513.176h32.86l-0.002-513.176z","M826.024 356.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h193v-32h-193c-70.028 0-127-57.696-127-128 0-28.544 8.886-54.094 25.7-77.2 16.942-23.28 40.452-40.308 67.988-49.008l22.020-7.020 0.336-23.124c0.358-24.548 10.186-47.59 27.674-64.85 17.502-17.274 40.688-26.792 65.284-26.792 13.52 0 26.58 2.856 38.82 8.492l25.046 11.532 15.11-23.066c41.614-63.536 115.714-101.464 191.524-101.464 55.626 0 104.96 20.53 146.18 57.808 40.932 37.020 66.688 87.474 72.526 142.070l2.606 24.376 24.214 3.83c29.454 4.658 56.506 19.844 76.174 42.762 19.86 23.142 30.798 51.174 30.798 81.654 0 70.304-56.972 128-127 128h-193v32h193c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"],"grid":0,"tags":["ios-cloud-upload-outline"]},{"paths":["M496 672h32v224h-32v-224z","M826.024 356.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h273v-289.176l-141.576 141.27-23.326-23.208 181.112-180.886 180.974 180.934-23.484 23.206-141.7-141.316v289.176h273c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"],"grid":0,"tags":["ios-cloud-upload"]},{"paths":["M826.024 452.226c-13.732-128.436-117.942-228.226-250.024-228.226-89.676 0-173.070 45.624-218.792 115.43-15.892-7.318-33.566-11.43-52.208-11.43-68.416 0-123.962 54.974-124.954 123.154-69.862 22.072-116.046 85.162-116.046 156.846 0 87.812 71.188 160 159 160h578c87.812 0 159-72.188 159-160 0-79.296-58.054-143.768-133.976-155.774z"],"grid":0,"tags":["ios-cloud"]},{"paths":["M553.2 590.8c-1 0-2.2-0.2-3.2-0.2-5.2 0-10.4 0-15.6 0.6-18.4-81.6-91.2-143.2-178.4-143.2-101 0-183 82-183 183.2 0 6.2 0.4 12.2 1 18.2-61.6 5.4-110 60.4-110 123.6 0 66.8 53.2 125 120 125h369.2c83.4 0 150.8-69.6 150.8-153s-67.6-154.2-150.8-154.2zM637 830c-22.6 22.8-52.4 36-83.8 36h-369.2c-23.2 0-45.2-10.2-61.8-27.8-16.6-17.4-26.2-41.6-26.2-65.6 0-22.8 8.4-44.8 23.8-62 15.2-17 35.4-27.4 57-29.4l32.2-2.8-3.2-32.2c-0.4-5-0.8-10.2-0.8-15.2 0-83.4 67.8-151.2 151-151.2 34.8 0 67.6 11.6 94.8 33.8 26.4 21.6 45 51.6 52.4 84.6l6.4 28.4 28.8-3.8c3.2-0.4 7.4-0.8 11.6-0.8h3.2c31.4 0 61.2 13 83.8 36.2s35.2 54 35.2 86c-0.2 32.2-12.6 63-35.2 85.8z","M900 612c-5 0.2-10 0.4-15 0.4-82.8 0-160.8-31.6-219.4-88.8s-90.8-133.2-90.8-214.2c0-46 10.4-90.6 30.4-131 8.8-17.8 17.8-34.6 30-50.6h-0.6c-21.6 2.4-40.4 6.6-60.6 12.8-123.6 38-215.6 145.4-228.2 275.4 3.6-0.2 7-0.2 10.6-0.2 7.2 0 14.4 0.4 21.6 1.2 5.4-51.6 24.8-100.2 56.8-142.2 34.4-45.2 82.6-80.2 136.6-99.4-18.8 42.2-28.4 87.2-28.4 134 0 89.6 35.8 173.8 100.6 237 64.6 63 150.4 97.8 241.8 97.8 1.6 0 3.2 0 4.8 0-41.6 43.4-95.6 72.8-154.2 85.2 0.4 4.8 0.6 9.6 0.6 14.4 0 6.2-0.4 12.2-0.8 18.2 75-14 140.8-52.8 188.4-107.4 13.8-15.8 26-30.6 36.6-49-20.2 5-40.4 5.4-60.8 6.4z"],"grid":0,"tags":["ios-cloudy-night-outline"]},{"paths":["M553.2 590.4c-5 0-9.8 0-14.6 0.4-1.4 0.2-2.8 0.2-4.2 0.4-8.6-38.2-29-71.8-57.2-97-2-1.8-4.2-3.6-6.2-5.4-2-1.6-4-3.2-6-4.6-2.8-2.2-5.8-4.2-8.8-6-5.6-3.6-11.2-7-17.2-10-2.2-1.2-4.6-2.2-6.8-3.4-23.2-10.8-49-16.8-76.2-16.8 0 0 0 0 0 0-2 0-3.8 0-5.8 0-0.2 0-0.4-0.2-0.6-0.2-1.8 0-3.8 0-5.6 0 0 0 0 0 0 0s0 0.2 0 0.2c-96 6.2-171 85.8-171 183 0 6.2 0.4 12.2 1 18.2-61.6 5.4-110 59.4-110 122.6 0 4.2 0.2 8.4 0.6 12.4 6 61.4 56.8 111.6 119.4 111.6h369.2c75.6 0 138.2-56.4 149.2-129.2 0 0 0 0 0 0v0 0c0.4-2.2 0.6-4.2 0.8-6.4 0-0.8 0.2-1.6 0.2-2.4 0.2-1.6 0.2-3.2 0.4-4.8 0-0.8 0-1.4 0.2-2.2 0.2-2.2 0.2-4.6 0.2-7 0-10.4-1-20.6-3-30.6-14.4-69.2-75.2-122.8-148-122.8z","M900 612c-5 0.2-10 0.4-15 0.4-82.8 0-160.8-31.6-219.4-88.8s-90.8-133.2-90.8-214.2c0-46 10.4-90.6 30.4-131 8.8-17.8 17.8-34.6 30-50.6h-0.6c-21.6 2.4-40.4 6.6-60.6 12.8-123.6 38-215.6 145.4-228.2 275.4 3.6-0.2 7-0.2 10.6-0.2 49 0 97 17 135.2 48.2 30.4 24.8 53.6 57.6 67 94.2 47 1.2 91 20.8 124.6 55.2 34.4 35.2 53.2 81.6 53.2 130.4 0 6.2-0.4 12.2-0.8 18.2 75-14 140.8-52.8 188.4-107.4 13.8-15.8 26-30.6 36.6-49-20 5-40.2 5.4-60.6 6.4z"],"grid":0,"tags":["ios-cloudy-night"]},{"paths":["M472 224c57 0 108 18.8 147.2 54.2 35.4 31.8 60.8 76.6 71.6 126l5.8 26.6 27.4-1.8c3.2-0.2 7.4-0.2 10.2-0.2 2.4 0 4.8 0 7 0 2.4 0 5 0 7.4 0 47.2 0 92 19.6 126.2 55 34.2 35.6 53 82 53 130.8 0 48.6-18.8 95.4-52.8 130.2-34 34.6-79.6 54.8-127.2 54.8h-515.8c-36.2 0-69.2-15.8-95.4-42.8-26.2-26.6-40.6-62.6-40.6-100 0-35.8 13.2-71 37-98.8 23.6-27.6 54.8-44.6 87.8-47.4l32.2-3-3.2-32c-0.6-6.8-1.4-14.6-1.4-22.6 0-60.6 23.6-118 66.2-161.6 42.6-43.4 98.6-67.4 157.4-67.4zM472 192c-140 0-255.6 119.4-255.6 261.6 0 8.6 0.6 17.2 1.6 25.6-86.4 7.8-154 88-154 176.8 0 94 75.8 176 169.2 176h515.6c116.6 0 211.2-98.8 211.2-216s-94.6-217.6-211.2-217.6c-4.6 0-9.6-0.4-14.4-0.4-4.2 0-8.4 0-12.2 0.2-23.6-107-110.2-206.2-250.2-206.2v0z"],"grid":0,"tags":["ios-cloudy-outline"]},{"paths":["M472 192c-140 0-255.6 119.4-255.6 261.6 0 8.6 0.6 17.2 1.6 25.6-86.4 7.8-154 88-154 176.8 0 94 75.8 176 169.2 176h515.6c116.6 0 211.2-98.8 211.2-216s-94.6-217.6-211.2-217.6c-4.6 0-9.6-0.4-14.4-0.4-4.2 0-8.4 0-12.2 0.2-23.6-107-110.2-206.2-250.2-206.2v0z"],"grid":0,"tags":["ios-cloudy"]},{"paths":["M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z","M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z","M637.8 511l23.2 23.2-149 137-149-137 23.2-23.2 109.4 97.4v-255.6h32.8v255.6z"],"grid":0,"tags":["ios-code-download"]},{"paths":["M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z","M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z","M544 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M416 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M672 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"],"grid":0,"tags":["ios-code-working"]},{"paths":["M640 320.4l27.6-26.4 228.4 218-228.4 218-27.6-26.4 200.8-191.6z","M384 320.4l-27.6-26.4-228.4 218 228.4 218 27.6-26.4-200.8-191.6z"],"grid":0,"tags":["ios-code"]},{"paths":["M522.2 160l11.2 44.8 5 19.8 20 3.8 44 8.6 12-15.8 28.4-37.2 13.2 5.4-6.8 45.4-3 19.8 16.6 11.4 21.4 14.6 16.6 11.4 17.4-10 39.2-22.6 10.2 10.2-33.2 55.8 12 17 15 21.2 11.2 16 19.4-2.6 44.2-6.2 5.6 13.4-51.4 39 3.6 19.4 5 26.4 3.8 19.8 61.8 16.4v14.6l-62 16.2-3.6 20.2-5 27-3.6 19.4 15.8 11.8 34.6 26-5.6 13.2-62.6-9-11.2 16.2-15.8 22.8-11.6 16.8 31.4 54.2-10.4 10.4-37-21.4-18-10.6-37.2 27-15.6 11.4 2.8 19.2 6.4 42.8-13.4 5.6-26.4-34.6-12.2-15.8-19.6 4-27.2 5.4-19.8 4-4.8 19.6-11 42.4h-14.4l-11.4-42.8-5-19.2-19.4-4-46.8-9.8-12.2 16.4-26.4 35.6-13.4-5.6 5.8-44.2 2.6-20-16.8-11-22.4-14.6-16.8-11-17.2 10.4-39 23.4-10-10 23.4-40 9.8-16.8-10.4-16.4-14.2-22.6-11-17.6-20.6 3-45.2 6.8-5.6-13.2 53-39.8-4-19.8-5-25-4-19.8-19.4-5-46-11.6v-14.2l65.2-16.4 4.2-19.4 5.2-24.4 4.4-20-16.4-12.4-38-28.6 5.6-13.4 46.4 6.6 20.4 2.8 11-17.4 24-37.6-10.2-17-24.8-41.6 10-10 41.2 24.6 16.6 10 40-24.6 17.8-11-2.8-20.6-6.4-47 13.4-5.6 40.2 54.2 19.8-3.8 44-8.4 5.2-19.6 12-45.6h14.2zM547 128h-64l-18.4 69.4-24.2 4.6-43-58.2-59.2 24.6 9.6 71.4-23.4 14.4-62.4-37.6-45.2 45.2 37.6 63-13.4 21-71-10-24.4 59.2 57.8 43.4-5.4 24.4-70 17.8v64l69.8 17.8 5 25-56.6 42.6 24.6 59 70-10 14.2 22.6-35.8 61.2 45.2 45.2 60.4-36.4 22.4 14.6-9 68.6 59.2 24.4 41.2-55.6 26.8 5.6 17.6 66.8h64l16.6-66.8 27.2-5.4 41.4 54 59.2-24.4-10-67.4 20.4-14.8 58 33.8 45.2-45.2-33.6-57.8 15.8-22.8 67.6 9.6 24.6-59-54.4-41 5-27 66-17.2v-64l-66-17.4-5-26.4 55.4-41.8-24.4-59.4-68.8 9.6-15-21.2 35.4-59.4-45.2-45.2-60.4 34.8-21.4-14.6 10.6-70-59-24.6-43.2 56.6-24.6-4.8-17.4-68.8z","M512 256c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256zM290.8 547c-1.8-11.6-2.8-23.2-2.8-35 0-59.8 23.4-116 65.6-158.4 42.4-42.2 98.6-65.6 158.4-65.6 12 0 23.8 1 35.6 2.8 2.8 0.4 5.8 1 8.6 1.6l-55.6 207.8-208.4 55.8c-0.4-3-1-6-1.4-9zM651.4 687.4c-39.4 31.4-88.2 48.6-139.4 48.6-59.8 0-116-23.4-158.4-65.6-22.2-22.2-39-48-50.2-76.4-0.8-2.2-1.8-4.4-2.4-6.6l206.8-55 149.8 149.8c-2 1.8-4 3.4-6.2 5.2zM685.8 653.2c-1.8 2.2-3.6 4.4-5.6 6.6l-150-150 56-209.2c2.2 0.8 4.4 1.6 6.6 2.4 28.6 11.2 54.8 28.2 77.2 50.4 42.6 42.6 66 98.8 66 158.6 0 52-17.6 101.4-50.2 141.2z"],"grid":0,"tags":["ios-cog-outline"]},{"paths":["M593.2 303.2c-2.2-0.8-4.4-1.6-6.6-2.4l-56 209.2 150 150c2-2.2 3.8-4.4 5.6-6.6 32.2-40 49.8-89.4 49.8-141.4 0-59.8-23.4-116-65.6-158.4-22.4-22.4-48.6-39.4-77.2-50.4z","M556.2 292.4c-2.8-0.6-5.8-1-8.6-1.6-11.6-1.8-23.6-2.8-35.6-2.8-59.8 0-116 23.4-158.4 65.6-42.2 42.4-65.6 98.6-65.6 158.4 0 11.8 1 23.6 2.8 35 0.4 3 1 6 1.6 8.8l208.4-55.8 55.4-207.6z","M301 587.4c0.8 2.2 1.6 4.4 2.4 6.6 11.2 28.2 28 54.2 50.2 76.4 42.4 42.2 98.6 65.6 158.4 65.6 51.2 0 100-17.2 139.4-48.6 2.2-1.6 4.2-3.4 6.2-5.2l-149.8-149.8-206.8 55z","M896 545.6v-64l-66.6-17.4-5.2-26.4 55.2-41.8-24.4-59.2-68.8 9.6-15-21.2 35.4-59.4-45.2-45.2-60.4 34.8-21.4-14.6 10.6-70-59-24.8-43.2 56.6-24.6-5.2-17.4-69.4h-64l-18.4 69.8-24.2 4.8-43-58-59.2 24.6 9.6 71.4-23.4 14.4-62.6-37.4-45.2 45.2 37.6 63-13.4 21-71-10-24.2 59.2 57.8 43.4-4.8 24.4-69.6 17.8v64l69.4 17.8 4.8 25-56.8 42.6 24.6 59.2 70-10 14.2 22.6-35.8 61.2 45.2 45.2 60.4-36.4 22.4 14.6-9 68.6 59.2 24.4 41.2-55.6 26.8 5 17.6 66.2h64l16.6-66.2 27.2-5.2 41.4 54.2 59.2-24.4-10-67.4 20.4-14.8 58 33.8 45.2-45.2-33.6-57.8 15.8-22.8 67.6 9.6 24.6-59-54.6-41 5.4-27 66.6-17.2zM512 768c-141.4 0-256-114.6-256-256s114.6-256 256-256 256 114.6 256 256-114.6 256-256 256z"],"grid":0,"tags":["ios-cog"]},{"paths":["M822.8 600.6l-367.6-364c0 0 0 0 0 0l-112.4-112.6c-18.6-18.6-43.2-28-67.8-28s-49.2 9.4-67.8 28v0c-37.4 37.4-37.4 98.4 0 135.8l98.6 98.6-209.8 208.4 342.6 329.2c0 0 270.2-261.4 292.2-283.4 11.6-11.6 36.4-14.2 57.2-14.2 19 0 34.8 2.2 34.8 2.2zM229.6 237.2c-12-12-18.6-28-18.6-45.2s6.6-33.2 18.6-45.2c12-12 28-18.6 45.2-18.6s33.2 6.6 45.2 18.6l99 99-90.8 90.2-98.6-98.8zM708 590c-17.8 17.8-204.6 198.6-269.6 261.6l-296.6-285.2 299.8-298.2 305.2 302.2c-16.6 3.8-29.4 10.4-38.8 19.6z","M832 672c0 0-96 106.6-96 159.8s43 96.2 96 96.2c0 0 0 0 0 0 53 0 96-43.2 96-96.2 0-53.2-96-159.8-96-159.8zM877.2 877.2c-12 12.2-28.2 18.8-45.2 18.8-35.2 0-64-28.8-64-64.2 0-3.8 2-25.6 41.6-80.6 7.8-10.8 15.4-20.8 22.4-29.4 6.8 8.4 14.4 18.4 22 29 40 55.4 42 77.2 42 81 0 17.2-6.6 33.2-18.8 45.4z"],"grid":0,"tags":["ios-color-fill-outline"]},{"paths":["M822.8 600.6l-367.6-364c0 0 0 0 0 0l-112.4-112.6c-18.6-18.6-43.2-28-67.8-28s-49.2 9.4-67.8 28v0c-37.4 37.4-37.4 98.4 0 135.8l98.6 98.6-209.8 208.4 342.6 329.2c0 0 270.2-261.4 292.2-283.4 11.6-11.6 36.4-14.2 57.2-14.2 19 0 34.8 2.2 34.8 2.2zM229.6 237.2c-12-12-18.6-28-18.6-45.2s6.6-33.2 18.6-45.2c12-12 28-18.6 45.2-18.6s33.2 6.6 45.2 18.6l99 99-90.8 90.2-98.6-98.8z","M832 672c0 0-96 106.6-96 159.8s43 96.2 96 96.2c0 0 0 0 0 0 53 0 96-43.2 96-96.2 0-53.2-96-159.8-96-159.8z"],"grid":0,"tags":["ios-color-fill"]},{"paths":["M570.8 160c91.2 0 174.4 29.2 234.4 82.2 37.8 33.6 58.8 78 58.8 125.2s-20.8 91.6-58.8 125.2l-60.6 53.8c-20.8 18.4-32.2 42.4-32.2 67.8 0 25.2 11.4 49.2 32.2 67.8 18.6 16.4 32.8 22.8 61.2 27.6l1.6 0.2c11.8 2 25.2 4.2 31 9.4 5.8 5.4 9.6 16 9.6 26.2 0 5.4-1.4 15.2-9 22-69.2 61.4-170 96.8-276.4 96.8-1 0-2.2 0-3.2 0-53-0.4-104.4-9.2-152.8-26.2-50.2-17.8-94.6-43.4-132-76.4-37.4-33.2-66.4-71.8-86-114.8-19-41.6-28.6-85.4-28.6-130.2s9.6-88.4 28.4-129.8c19.6-43 48.6-81.6 86-114.8 80.6-71.2 188.6-112 296.4-112zM570.8 128c-111.4 0-227.8 40.6-317.6 120.2-167 147.6-167 389.4 0 537 83 73.4 195 110 305.8 110.8 1.2 0 2.4 0 3.4 0 110.8 0 220-35.8 297.6-104.8 28.6-25.4 23.8-73.2 0-95.6-13.2-12.2-32.6-15.2-49.2-18-23-3.8-31.8-8-45.2-20-28.6-25.4-28.6-62.2 0-87.6l60.6-53.8c92.8-82 92.8-216.4 0-298.4-68.2-60-160-89.8-255.4-89.8v0z","M640 288c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM640 256c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z","M448 266c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM448 234c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z","M304 400c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM304 368c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z","M320 588c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32zM320 556c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z","M592 800c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM592 640c-35.2 0-64 28.8-64 64s28.8 64 64 64 64-28.8 64-64-28.8-64-64-64z"],"grid":0,"tags":["ios-color-palette-outline"]},{"paths":["M860.2 695.8c-13.2-12.2-32.6-15.2-49.2-18-23-3.8-31.8-8-45.2-20-28.6-25.4-28.6-62.2 0-87.6l60.6-53.8c92.8-82 92.8-216.4 0-298.4-68.4-60.2-160.2-90-255.6-90-111.4 0-227.8 40.6-317.6 120.2-167 147.6-167 389.4 0 537 83 73.4 195 110 305.8 110.8 1.2 0 2.4 0 3.4 0 110.8 0 220-35.8 297.6-104.8 28.8-25.4 24-73.2 0.2-95.4zM240 432c0-35.4 28.6-64 64-64s64 28.6 64 64-28.6 64-64 64-64-28.6-64-64zM320 684c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM448 362c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM592 800c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM640 384c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"],"grid":0,"tags":["ios-color-palette"]},{"paths":["M384 299.4l-68 68 512.2 512.2 67.8-68-512-512.2zM425.2 431.4l22.8-22.8 403 403-22.8 22.8-403-403z","M368 128h32v80h-32v-80z","M368 536h32v80h-32v-80z","M560 352h80v32h-80v-32z","M128 352h80v32h-80v-32z","M200.223 211.181l22.627-22.627 56.568 56.568-22.627 22.627-56.568-56.568z","M256.8 477.050l22.627 22.627-56.568 56.568-22.627-22.627 56.568-56.568z","M545.154 188.548l22.627 22.627-56.568 56.568-22.627-22.627 56.568-56.568z"],"grid":0,"tags":["ios-color-wand-outline"]},{"paths":["M366 124h48v128h-48v-128z","M366 532h48v128h-48v-128z","M548 358h128v48h-128v-48z","M595.8 212.2l-33.2-33.2-90.4 90.6 33.2 33.4z","M190.2 218.2l90.4 90.8 33.2-33.4-90.4-90.6z","M184.2 558.2l33.2 33.4 90.4-90.6-33.2-33.4z","M116 358h128v48h-128v-48z","M384.4 306.8l-68 68.4 86.8 87 68.2-68.2z","M894 817.6l-390.6-391.6-68.2 68.2 390.8 391.8z"],"grid":0,"tags":["ios-color-wand"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4s381.4 171.2 381.4 381.4c0 210.2-171.2 381.4-381.4 381.4z","M448 448l-192 320 320-192 192-320-320 192zM349.2 674.8l122-203.4 81.4 81.4-203.4 122z"],"grid":0,"tags":["ios-compass-outline"]},{"paths":["M552.6 552.6l-81.2-81.2-122.2 203.4z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM576 576l-320 192 192-320 320-192-192 320z"],"grid":0,"tags":["ios-compass"]},{"paths":["M274.6 852.8c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11 10.8 29 0 39.8z","M760.2 128.2v0 0z","M426.2 481.4l51.8-51.8c6.2 6-2-2.2 17.2 16.6 8.4-7.8 16.2-15.2 23.2-22-38.4-37.8-29-28.4-29-28.4-2.8-2.8-7.6-4.6-12.6-4.6-2.8 0-5.8 0.6-8.4 2l-11.4 6c-56.2-55.6-70.8-80.6-68.6-123.6 2.2-44.8 24.6-74.4 61.2-105.4 49.6-42.2 121.4-30.6 121.4-30.6 16 0-8.2-17-20.8-25-18.8-12-46.6-19.2-75.8-19.2-28.6 0-60.8 5-93.6 18.6-93 38-148.2 91-162.4 105-14 14-33.6 36-45.8 53.4s3.8 42-12.2 58-49.6 0-49.6 0c-2.8 0-5.8 1-7.8 3.2l-68.4 67.8c-4.4 4.4-4.4 11.4 0 15.6l127.2 126.4c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l66.4-69.6c4.4-4.4 4.4-11.4 0-15.6 0 0-10.6-10.4-24.2-24s1.6-38.8 10.6-46.8c9-8.2 23.2-13.6 42.4-13.6 8.6 0 14.8 1.4 22.8 3.6 24.4 6.8 51.6 31.8 101.8 81.6l-7.8 13c-4.6 7.6-1.8 16.6 2.6 20.8 0 0-10-9.8 26.2 26.4 8-7.4 15.6-14.8 23.2-22-18-18.6-9.2-9.8-15.2-15.8zM420 435.8l-8-8c-47.8-47.6-76.6-73.2-107.8-81.8-10.2-2.8-19-4.8-31.4-4.8-23 0-39.4 5.4-57.4 17.4-21 14-37.2 44.2-37.2 63 0 19 13.4 29 24.6 40.4l-38.8 38.4-92-91.2 38.6-38.2 15.2 2.4c25.8 0 45.6-7 58.8-20 17.4-17.4 16-40.2 15-53.6-0.2-3.2-0.6-8-0.4-10.4 11-15.4 29-35.6 41.4-47.8 23-22.8 73.4-66 152-98 23-9.4 47-14.8 71.4-15.8-13.8 4.4-25.4 10.2-34.6 17.6v0 0c-46.2 37.2-70.8 80.6-73 129-2.8 57.8 20.6 91 78 147.8l2.8 2.8-14.2 14.2-3-3.4z","M886.4 809.6l-77.8 77.2c-32-38.2-123.6-143-217.4-240.2-7.2 7.6-14.6 15.4-22 23.4 117.2 121.4 230.2 255.6 230.2 255.6 2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.4-4.4 4.4-11.4 0-15.6 0 0-138-114.6-260.8-231.6-6.8 7.2-14.2 15-22 23.2 98 93.2 204.8 185.4 243.8 217.6z","M959 250.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.4-22.4-53.6-33.2-78-33.2-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40 42.4-82.2 121.4-45 209 4.4 10.6 9.4 24.6-5.4 39.4-3 2.8-19.8 18.8-45 42.6-7.2 6.8-15 14-23.2 22-16.2 15.2-34.2 32.4-53.6 50.6-7.6 7.2-15.4 14.6-23.2 22-114.2 107.8-254.2 239.4-254.2 239.4-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 131.2-139.8 238.8-254.2 7.4-8 14.8-15.8 22-23.4 18.6-19.8 36-38.2 51.6-54.6 7.8-8.4 15.2-16.2 22-23.2 23-24.4 38.8-40.8 42-44 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-23.8-6.8-55.6-33.4-82.2zM960.4 330.6c-1.4 24-11.4 61-50 99.6-29.8 29.8-78.6 49.8-121.6 49.8-19 0-35.8-3.8-50-11.2v0 0c-7-3.6-18-8.4-31.8-8.4-11.2 0-28 3.4-44.6 19.4-18 17.6-362.6 384.8-377.4 400.4l-0.8 0.8c-11.4 13.2-26.8 15.2-35 15.2-14.8 0-29.4-6-40.2-16.4-10.8-11-17-26.8-16.4-42.4 0.4-9.2 3.2-22.4 15-32.4l1.2-0.8c15.6-14.8 384.6-362.2 399.8-377.2v0 0c15.8-15.8 19.2-32.4 19.4-43.6 0-13.8-4.8-25.2-7-30.8v0 0c-36.4-85.4 20.4-155.2 38.8-174.4v0 0c34.6-36.8 79.4-48.4 98.4-49.4 0.8 0 1.6 0 2.4 0 8 0 18 2 28 6l-89.4 89.8 3 16.4 18.4 102.4 4 21.8 21.8 4 119 21.6 11.8-11.8 78-78.4c5.6 13.4 5.6 25.4 5.2 30z"],"grid":0,"tags":["ios-construct-outline"]},{"paths":["M760.2 128.2v0 0z","M550.2 114.6c-18.8-12-46.6-19.2-75.8-19.2-28.6 0-60.8 5-93.6 18.6-93 38-148.2 91-162.4 105-14 14-33.6 36-45.8 53.4s3.8 42-12.2 58-49.6 0-49.6 0c-2.8 0-5.8 1-7.8 3.2l-68.4 67.8c-4.4 4.4-4.4 11.4 0 15.6l127.2 126.4c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l66.4-69.6c4.4-4.4 4.4-11.4 0-15.6 0 0-10.6-10.4-24.2-24s1.6-38.8 10.6-46.8c9-8.2 23.2-13.6 42.4-13.6 8.6 0 14.8 1.4 22.8 3.6 24.4 6.8 51.6 31.8 101.8 81.6l-7.8 13c-4.6 7.6-1.8 16.6 2.6 20.8 0 0-10-9.8 26.2 26.4l100.2-94.4c-38.4-37.8-29-28.4-29-28.4-2.8-2.8-7.6-4.6-12.6-4.6-2.8 0-5.8 0.6-8.4 2l-11.4 6c-56.2-55.6-70.8-80.6-68.6-123.6 2.2-44.8 24.6-74.4 61.2-105.4 49.6-42.2 121.4-30.6 121.4-30.6 16-0.6-8.2-17.6-20.8-25.6z","M925.4 800.2c0 0-138-114.6-260.8-231.6l-95.6 101.4c117.2 121.4 230.2 255.6 230.2 255.6 2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.6-4.4 4.6-11.4 0.2-15.8z","M959 250.2l-105 105.4-102.4-18.6-18.4-102.4 105-105.4c-22.4-22.4-53.6-33.2-78-33.2-1.4 0-2.8 0-4 0.2-25 1.4-78.6 15.4-120 59.4-40 42.4-82.2 121.4-45 209 4.4 10.6 9.4 24.6-5.4 39.4-3 2.8-19.8 18.8-45 42.6-7.2 6.8-15 14-23.2 22-16.2 15.2-34.2 32.4-53.6 50.6-7.6 7.2-15.4 14.6-23.2 22-114.2 107.8-254.2 239.4-254.2 239.4-36 31-33.4 88.4-0.2 121.8 17 16.8 40 25.6 62.6 25.6 22.2 0 43.8-8.4 59.2-26.2 0 0 131.2-139.8 238.8-254.2 7.4-8 14.8-15.8 22-23.4 18.6-19.8 36-38.2 51.6-54.6 7.8-8.4 15.2-16.2 22-23.2 23-24.4 38.8-40.8 42-44 8-7.8 15.4-10.2 22.2-10.2 6.6 0 12.6 2.4 17.2 4.8 19.8 10.2 42 14.8 64.8 14.8 53.6 0 110-24.8 144.4-59.2 48.8-48.8 57.8-96 59.2-120.2 1.4-23.8-6.8-55.6-33.4-82.2zM274.6 852.8c-11 10.8-28.8 10.8-39.8 0-10.8-11-10.8-28.8 0-39.8 11-10.8 28.8-10.8 39.8 0 10.8 11 10.8 29 0 39.8z"],"grid":0,"tags":["ios-construct"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 93.2-33.6 178.4-89.2 244.8 0 0-0.2-0.2-0.2-0.2-40-16.4-131.8-48.2-185.8-64.2-4.8-1.4-5.4-1.8-5.4-21.4 0-16.2 6.6-32.6 13.2-46.6 7.2-15 15.4-40.4 18.4-63.2 8.4-9.8 20-29 27.2-65.8 6.4-32.4 3.4-44.2-0.8-55.2-0.4-1.2-1-2.4-1.2-3.4-1.6-7.6 0.6-47 6.2-77.6 3.8-21-1-65.6-29.8-102.6-18.2-23.4-53.2-52-117-56h-35c-62.8 4-97.6 32.6-116 56-29 37-33.8 81.6-30 102.6 5.6 30.6 7.8 70 6.2 77.6-0.4 1.4-0.8 2.4-1.2 3.6-4.2 11-7.4 22.8-0.8 55.2 7.4 36.8 18.8 56 27.2 65.8 3 22.8 11.4 48 18.4 63.2 5.2 11 7.6 26 7.6 47.2 0 19.8-0.8 20-5.2 21.4-56 16.6-144.4 48.4-180.2 63.8-55.8-66.4-89.4-151.8-89.4-245 0-210.2 171.2-381.4 381.4-381.4zM242.8 782c39.8-16 117.2-43.6 166.2-58.2h0.4c16.8-5.2 23.2-17 25.6-26 1.8-6.4 2-13 2-26 0-26.2-3.4-45.4-10.6-60.8-5.8-12.2-13.2-34.4-15.8-53.8l-1.2-9.4-6.2-7.2c-3.8-4.4-13.6-18.4-20.2-51.2-5.2-26-2.8-32-0.8-37.4v-0.4l0.2-0.6c0.4-1.2 1.2-3.2 2-5.6l0.4-2c3.4-16-1.2-63.8-6-90-2.2-12.4 0.6-47.6 23.6-77.2 14.2-18 41.6-40.2 91.8-43.6h33c51.2 3.4 78.8 25.6 92.8 43.8 23.2 29.6 25.8 64.8 23.6 77.2-4.8 26-9.4 74-6 90l0.4 1.2c0.8 3 1.8 5.6 2.4 7.2 2.2 5.6 4.2 11.8-0.8 37.2-6.6 32.8-16.2 46.6-20 51.2l-6.2 7.2-1.2 9.6c-2.6 19.4-10 41.4-15.6 53.6-8 17-16.2 37.6-16.2 60.2 0 11.6 0.2 19.2 2.2 26.4 2.6 8.8 9 20.4 25.8 25.6h0.4c47.4 14 127.8 41.6 172 58.8-69 68.8-164.2 111.4-269 111.4-104.8 0.2-199.8-42.4-269-111.2z"],"grid":0,"tags":["ios-contact-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 130.6c210.2 0 381.4 171 381.4 381.4 0 93-33.4 178.2-88.8 244.4-40-16.4-131.8-48.2-185.8-64.2-4.8-1.4-5.4-1.8-5.4-21.4 0-16.2 6.6-32.6 13.2-46.6 7.2-15 15.4-40.4 18.4-63.2 8.4-9.8 20-29 27.2-65.8 6.4-32.4 3.4-44.2-0.8-55.2-0.4-1.2-1-2.4-1.2-3.4-1.6-7.6 0.6-47 6.2-77.6 3.8-21-1-65.6-29.8-102.6-18.2-23.4-53.2-52-117-56h-35c-62.8 4-97.6 32.6-116 56-29 37-33.8 81.6-30 102.6 5.6 30.6 7.8 70 6.2 77.6-0.4 1.4-0.8 2.4-1.2 3.6-4.2 11-7.4 22.8-0.8 55.2 7.4 36.8 18.8 56 27.2 65.8 3 22.8 11.4 48 18.4 63.2 5.2 11 7.6 26 7.6 47.2 0 19.8-0.8 20-5.2 21.4-56.2 16.6-145.2 48.6-180.8 64-55.8-66.4-89.4-151.8-89.4-245 0-210.2 171.2-381.4 381.4-381.4z"],"grid":0,"tags":["ios-contact"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM511.8 893.2c-104.8 0.2-199.8-42.4-269-111.2l-22.8-25c-6.2-7.4-12-14.8-17.6-22.6 9.4-8 20.2-15 31.6-19.2 21-8 44.8-7.6 66.6-13.2 18-4.6 40.4-11.8 54.4-24.8 12.8-12 14.2-30.4 15.4-47 1-14 0.8-27.8 0.8-41.8 0-9.8-11.4-15.4-17-23.2-9-12.2-9.4-30.4-11.2-45-0.8-6.4-1-14.6-6.4-19-6-4.8-10.4-7.4-13.4-15-4-10.4-5.4-21.6-8.6-32.4-2-7 5-13.6 7.8-19.4 5.2-10.6-3.8-27-5.6-38-5.6-32.8-5.4-68.6 18.2-94.6 47.4-52.4 156-35.8 171.6 37.8 4.8 23 1.8 49.8-4.6 72.2-2.8 9.6-6 16.6-0.4 26 8.4 13.6 4.8 22.4 0.8 37.6-3.2 12.6-7.2 18.2-16.8 26-8 6.4-6.8 22.4-8.2 31.6-1.6 11.2-2.6 23-9.4 32.4-2.6 3.6-16.8 14.8-16.8 18.6 0 22-1 44.4 2.8 66.2 5.2 31 31.2 38.4 57.2 49 26.4 10.2 57 6.4 82.6 19 26.4 13 51.8 36.8 59.4 66.2 0 0 4.4 38.2 4.2 80-44.8 18.4-94 28.8-145.6 28.8zM804.2 756.8l-0.2-0.2-23.2 25.2c-26.8 26.6-57.4 49.4-91.2 67.2l-0.6-33.2c0-59-35.6-111-91.6-130.4-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 10-41.8-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-12.8 5.6-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-0.6 0.4-1 0.8-1.4 1.2-34.4-57.2-54.2-124.2-54.2-195.6 0-210.2 171.2-381.4 381.4-381.4s381.4 171 381.4 381.4c0 59.2-13.6 115.4-37.8 165.4-8.8-25.6-30.4-44.8-57-53.6-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2-33.2-2-33.2 50.4-2.8 62-12.2 62-12.2 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-15.2-9.4-39.4-13.8-62.8-13.8-19 0-37.4 2.8-50.6 8.2-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 0 0 15 8.8 57.8 12.6 0 0 0.6 25.2 0 27.8-2.2 9.8-23.6 16.6-31.6 18.8-8.2 2.2-30.8 9.2-58.2 22.6 0 0 30.4 3 50 9.8 13.6-9.2 33.8-11.4 48-17.6s20.6-11.6 23.2-26.6-1-66.4-1-66.4c-24.4 1.8-53.8-3.4-53.8-3.4 8.2-26.4 8-55.4 8-83.4 0-24.4-0.2-47.6 5.2-65.4 4.8-16 12.8-25 28-31v0 0c8.8-3.6 23.6-5.8 38.4-5.8 23.2 0 39.2 4.8 46 9 19.6 12.2 24.4 40.6 24.8 62.4 0.2 9-0.2 18.8-0.6 29.2-1 26.6-2.4 55.8 6.6 84-0.2 0-0.2 0-0.4 0 0 0-26.6 3.6-52.6 0.6l-2.8 34.6c-1.4 14.2-3.8 35.8 9.6 52 15.4 18.6 40.4 23.8 60.4 27.8 5.2 1 10.4 2.2 13.4 3 15.2 5 41.4 18.8 44.8 62.6-8.6 14-18.4 27.4-29 40z"],"grid":0,"tags":["ios-contacts-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM689 816c0-59-35.6-111-91.6-130.4-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 10-41.8-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-12.8 5.6-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-0.6 0.4-1 0.8-1.4 1.2-34.4-57.2-54.2-124.2-54.2-195.6 0-210.2 171.2-381.4 381.4-381.4s381.4 170.8 381.4 381.2c0 59.2-13.6 115.4-37.8 165.4-8.8-25.6-30.4-44.8-57-53.6-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2-33.2-2-33.2 50.4-2.8 62-12.2 62-12.2 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-15.2-9.4-39.4-13.8-62.8-13.8-19 0-37.4 2.8-50.6 8.2-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 0 0 15 8.8 57.8 12.6 0 0 0.6 25.2 0 27.8-2.2 9.8-23.6 16.6-31.6 18.8-8.2 2.2-30.8 9.2-58.2 22.6 0 0 30.4 3 50 9.8 0 0 52.8 12 92 50 36 34.8 41.2 77.4 42 128.6-10.4 7-21.2 13.4-32.4 19.2l-0.6-33z"],"grid":0,"tags":["ios-contacts"]},{"paths":["M392 416h-200v32h256v-256h-32v200l-265.8-264-22.2 22.2z","M632 416h200v32h-256v-256h32v200l265.8-264 22.2 22.2z","M392 608h-200v-32h256v256h-32v-200l-265.8 264-22.2-22.2z","M632 608h200v-32h-256v256h32v-200l265.8 264 22.2-22.2z"],"grid":0,"tags":["ios-contract"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2v-768.2c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.6 45.8-47.2 86.8-82.4 122.2z"],"grid":0,"tags":["ios-contrast"]},{"paths":["M736 832h-576v-544h448.234l32-32h-512.234v608h640v-480.234l-32 32z","M475.246 568.168l-19.412-19.414 342.646-342.646-22.626-22.628-359.854 359.822v64.698h64.432l360.090-359.968-22.628-22.572z","M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"],"grid":0,"tags":["ios-create-outline"]},{"paths":["M512 640h-128v-128l256-256h-512v608h640v-480z","M775.854 183.48l-359.854 359.822v64.698h64.432l360.090-359.968z","M888.426 160.624l-24.93-24.932c-5.328-4.758-12.384-7.692-20.004-7.692-7.624 0-14.608 2.936-19.858 7.7l-24.302 24.3 64.786 64.786 24.3-24.3c4.766-5.25 7.582-12.234 7.582-19.858 0-7.62-2.816-14.678-7.574-20.004z"],"grid":0,"tags":["ios-create"]},{"paths":["M256 128h32v96h-32v-96z","M288 736v-416h-32v448h448v-32z","M800 736h96v32h-96v-32z","M128 256v32h608v608h32v-640z"],"grid":0,"tags":["ios-crop-outline"]},{"paths":["M256 128h64v96h-64v-96z","M320 704v-352h-64v416h416v-64z","M800 704h96v64h-96v-64z","M128 256v64h576v576h64v-640z"],"grid":0,"tags":["ios-crop"]},{"paths":["M512 64l-448 192v448l448 256 448-256v-448l-448-192zM908 268.4l-396 223.6-393.6-224.4 393.6-171.6 396 172.4zM96 291.6l400 228.4v394l-400-228.6v-393.8zM528 914v-394l400-226.2v391.6l-400 228.6z"],"grid":0,"tags":["ios-cube-outline"]},{"paths":["M941.6 248.4l-429.6-184.4-429.6 184.4 429.6 245.8z","M528 952l432-247.2v-430.2l-432 247.2z","M64 274.6v430.2l432 247.2v-430.2z"],"grid":0,"tags":["ios-cube"]},{"paths":["M256.8 271.4c-22.8-56-29.6-109.8 9-143.4l206 276 20-26.8-210-281.2c-17.8 0-28.8 1.8-37 7.8-23.8 17.8-38.2 51.2-38.6 87.2-0.4 27 6.6 57.2 20.8 92.4 17 42 85 140.4 155.8 237.2 1.4 2 3.2 3.8 5 5.4 5.8-9.4 12-19 18-28.2-52.2-71.6-132.4-185.2-149-226.4z","M780.8 109.8c-10.4-9.6-27-13.8-40-13.8l-254.8 342c0 0-0.2 0.2-0.2 0.2l-29 39.4c-0.2 0.2-0.4 0.6-0.6 0.8-1 1.6-15 21.8-30.4 45.4-6 9.2-12.2 19-18 28.2-7 11.2-13.2 22-17.6 30.4-7.2 14.2-14.6 28.8-21.4 43-7.4 15-14.4 29.2-20.8 41.4-20.4-14.6-44-22.2-68.6-22.2-35 0-67.4 15.4-91.6 43.2-23 26.4-35.8 61.4-35.8 98.4s12.8 72 35.8 98.6c24.2 27.8 56.8 43.2 91.6 43.2 28.8 0 56-10.4 78.4-30 21-18.2 36-42.6 43.6-70.8 2-6.2 23.2-69.4 52.2-114.6 18.4-28.8 44.4-46.8 59.2-55.6l27-19.4c0 0 25.2-17.4 76.2-83.4s161-223 180.4-270.8c14.4-35.2 21.2-65.6 20.8-92.4-0.2-35.8-11.8-58.6-36.4-81.2zM766.8 271.4c-22.8 56-173.6 263.8-200.8 295.4s-54.6 54.8-54.6 54.8-51.8 22.2-84.8 73.8c-33 51.4-55.8 122.6-55.8 122.6v0c-11.8 45.2-48.2 78.2-91.4 78.2-52.8 0-95.6-49.2-95.6-109.8s42.8-109.8 95.6-109.8c21.6 0 41.4 8.2 57.4 22 3.2 2.6 6 5.2 8 7.6 0 0 0.2 0.2 0.2 0.2 1 1 1.8 2 2.6 3 1.8 1.8 3.6 2.6 5.4 2.6 4.8 0 10.4-6.6 19-22.4 13.6-25.2 30.2-60.6 46.6-92.6s63.6-100.6 63.6-100.6l29-39.4 246.6-329c38.6 33.8 31.8 87.4 9 143.4z","M744 644.6c-24.6 0-48.2 7.6-68.6 22.2-6.4-12.2-13.4-26.4-20.8-41.4-6.8-13.8-13.8-28-20.8-41.6l-21.8 27.8c14 27.8 27.6 56.6 39.2 78 8.6 16 14.2 22.4 19 22.4 1.8 0 3.6-1 5.4-2.6 0.8-1 1.8-2 2.6-3 0 0 0.2-0.2 0.2-0.2 2-2.6 4.6-5.2 8-7.6 16-13.8 35.8-22 57.4-22 52.8 0 96 49.2 96 109.8s-43 109.6-95.8 109.6c-43.2 0-79.6-33-91.4-78.2v0c0 0-22.8-71.2-55.8-122.6-9.4-14.8-20.6-27.2-31.4-37.4l-26 19.6c10.4 9.2 21.4 20.8 30.6 35 29 45.2 50 108.4 52.2 114.6 7.6 28.2 22.6 52.6 43.6 70.8 22.6 19.6 49.8 30 78.4 30 70.6 0 128-63.6 128-141.8s-57.6-141.4-128.2-141.4z","M279.8 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.6 56-48 56z","M544.2 544.4c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M744.2 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.4 56-48 56z"],"grid":0,"tags":["ios-cut-outline"]},{"paths":["M616 554.4c51-66 161-223 180.4-270.8 14.4-35.2 21.2-65.6 20.8-92.4-0.4-35.8-12-58.6-36.6-81.2-10.4-9.6-27-13.8-40-13.8l-254.6 341.8c0 0-0.2 0.2-0.2 0.2l-29 39.4c-0.2 0.2-0.4 0.6-0.6 0.8-1 1.6-15 21.8-30.4 45.4-6 9.2-12.2 19-18 28.2-7 11.2-13.2 22-17.6 30.4-7.2 14.2-14.6 28.8-21.4 43-7.4 15-14.4 29.2-20.8 41.4-20.4-14.6-44-22.2-68.6-22.2-35 0-67.4 15.4-91.6 43.2-23 26.4-35.8 61.4-35.8 98.4s12.8 72 35.8 98.6c24.2 27.8 56.8 43.2 91.6 43.2 28.8 0 56-10.4 78.4-30 21-18.2 36-42.6 43.6-70.8 2-6.2 23.2-69.4 52.2-114.6 18.4-28.8 44.4-46.8 59.2-55.6l27-19.4c0 0.2 25.4-17.4 76.2-83.2zM279.8 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.6 56-48 56zM512.2 576.4c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z","M383 520.8c1.4 2 3.2 3.8 5 5.4 3.4-5.6 7.2-11.4 10.8-17.2l93-131.6-210-281.4c-17.8 0-28.8 1.8-37 7.8-23.8 17.8-38.2 51.2-38.6 87.2-0.4 27 6.6 57.2 20.8 92.4 17.2 42 85.2 140.4 156 237.4z","M744 644.6c-24.6 0-48.2 7.6-68.6 22.2-6.4-12.2-13.4-26.4-20.8-41.4-6.8-13.8-13.8-28-20.8-41.6l-21.8 27.8-72.8 66.2c10.4 9.2 21.4 20.8 30.6 35 29 45.2 50 108.4 52.2 114.6 7.6 28.2 22.6 52.6 43.6 70.8 22.6 19.6 49.8 30 78.4 30 70.6 0 128-63.6 128-141.8s-57.4-141.8-128-141.8zM744.2 842.2c-26.6 0-48-25.2-48-56s21.4-56 48-56c26.6 0 48 25.2 48 56s-21.4 56-48 56z"],"grid":0,"tags":["ios-cut"]},{"paths":["M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z"],"grid":0,"tags":["ios-desktop-outline"]},{"paths":["M992 768v-576h-960v576h350v32h-128v32h514v-32h-128v-32h352zM64 224h896v512h-896v-512z","M96 256h832v448h-832v-448z"],"grid":0,"tags":["ios-desktop"]},{"paths":["M512 363.6c81.8 0 148.6 66.6 148.6 148.6 0 81.8-66.6 148.4-148.6 148.4-39.8 0-77-15.4-105-43.4s-43.4-65.2-43.4-105c-0.2-82 66.6-148.6 148.4-148.6zM512 624.6c62.2 0 112.8-50.6 112.8-112.8s-50.6-112.8-112.8-112.8-112.8 50.6-112.8 112.8c0 62.2 50.6 112.8 112.8 112.8zM512 331.6c-99.8 0-180.6 80.8-180.6 180.6s80.8 180.4 180.6 180.4 180.6-80.8 180.6-180.4c0-99.8-80.8-180.6-180.6-180.6v0zM512 592.6c-44.6 0-80.8-36.2-80.8-80.8s36.2-80.8 80.8-80.8 80.8 36.2 80.8 80.8c0 44.6-36.2 80.8-80.8 80.8v0z","M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4s63 76.4 82.4 122c20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122s-76.4 63-122 82.4c-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 772c69.4 0 134.8-27 183.8-76.2s76.2-114.4 76.2-183.8-27-134.8-76.2-183.8-114.4-76.2-183.8-76.2-134.8 27-183.8 76.2-76.2 114.4-76.2 183.8 27 134.8 76.2 183.8 114.4 76.2 183.8 76.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0zM512 740c-126 0-228-102.2-228-228s102-228 228-228 228 102 228 228-102 228-228 228v0z"],"grid":0,"tags":["ios-disc-outline"]},{"paths":["M512 331.6c-99.8 0-180.6 80.8-180.6 180.6s80.8 180.4 180.6 180.4 180.6-80.8 180.6-180.4c0-99.8-80.8-180.6-180.6-180.6zM512 592.8c-44.6 0-80.8-36.2-80.8-80.8s36.2-80.8 80.8-80.8 80.8 36.2 80.8 80.8-36.2 80.8-80.8 80.8z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM512 740c-126 0-228-102.2-228-228s102-228 228-228 228 102 228 228-102 228-228 228z"],"grid":0,"tags":["ios-disc"]},{"paths":["M544 128h-288v768h512v-545l-224-223zM544 173.2l179.6 178.8h-179.6v-178.8zM288 864v-704h224v224h224v480h-448z"],"grid":0,"tags":["ios-document-outline"]},{"paths":["M768 352v-1l-224-223v224z","M512 128h-256v768h512v-512h-256z"],"grid":0,"tags":["ios-document"]},{"paths":["M733.8 364l-228 234.2-92.2-93.8-34.8 35.4 109.2 111.4c4.8 4.8 11.4 9 17.4 9 5.8 0 12.4-4 17.2-8.8l245.4-251.4-34.2-36z","M290.8 504.2l-34.8 35.4 109.2 111.4c4.8 4.8 11.4 9 17.4 9 5.8 0 12.4-4 17.2-8.8l17.4-17.8-126.4-129.2z","M595.2 380l-124 127.4 34.4 35 123.8-126.6z"],"grid":0,"tags":["ios-done-all"]},{"paths":["M928 192v512h-832v-512h832zM928 160h-832c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h832.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32v0z","M768 768l64 160h33.2l-65.2-160z","M225.2 768l-65.2 160h33.2l64-160z","M496 768h32v96h-32v-96z","M864 256v384h-704v-384h704zM896 224h-768v448h768v-448z","M512 96c-17.6 0-32 14.4-32 32h64c0-17.6-14.4-32-32-32z"],"grid":0,"tags":["ios-easel-outline"]},{"paths":["M768 768l64 160h33.2l-65.2-160z","M225.2 768l-65.2 160h33.2l64-160z","M496 768h32v96h-32v-96z","M160 256h704v384h-704v-384z","M928 160h-832c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h832.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32zM896 672h-768v-448h768v448z","M512 96c-17.6 0-32 14.4-32 32h64c0-17.6-14.4-32-32-32z"],"grid":0,"tags":["ios-easel"]},{"paths":["M512 96c23.2 0 53 13.6 84 38.4 33.4 26.8 67.2 65.2 97.2 111.2 31.6 48.2 58 102.6 76.4 157.6 20.2 60.2 30.4 118.8 30.4 174.4 0 57.4-7.2 109.4-21.6 154.4-13.4 42.6-33.2 79-58.6 108.4-24.6 28.4-54.6 50.2-89.2 64.8-35.2 14.8-75 22.4-118.6 22.4s-83.4-7.6-118.6-22.4c-34.6-14.6-64.6-36.4-89.2-64.8-25.4-29.4-45.2-65.8-58.6-108.4-14.2-45.2-21.6-97-21.6-154.4 0-55.6 10.2-114.4 30.4-174.4 18.4-55 44.8-109.4 76.4-157.6 30.2-46 63.8-84.4 97.2-111.2 31-24.8 60.8-38.4 84-38.4zM512 64c-128 0-320 266.4-320 513.8s128 382.2 320 382.2 320-134.8 320-382.2-192-513.8-320-513.8v0z"],"grid":0,"tags":["ios-egg-outline"]},{"paths":["M512 64c-128 0-320 266.4-320 513.8s128 382.2 320 382.2 320-134.8 320-382.2-192-513.8-320-513.8v0z"],"grid":0,"tags":["ios-egg"]},{"paths":["M256 448h32v-224h576v576h-576v-224h-32v256h640v-640h-640z","M595.8 386.2l23.2-23.2 149 149-149 149-23.2-23.2 109.4-109.4h-577.2v-32.8h577.2z"],"grid":0,"tags":["ios-exit-outline"]},{"paths":["M256 192v303.6h449.2l-109.4-109.4 23.2-23.2 149 149-149 149-23.2-23.2 109.4-109.4h-449.2v303.6h640v-640z","M128 495.6h128v32.8h-128v-32.8z"],"grid":0,"tags":["ios-exit"]},{"paths":["M184 160h200v-32h-256v256h32v-200l265.8 264 22.2-22.2z","M840 160h-200v-32h256v256h-32v-200l-265.8 264-22.2-22.2z","M184 864h200v32h-256v-256h32v200l265.8-264 22.2 22.2z","M840 864h-200v32h256v-256h-32v200l-265.8-264-22.2 22.2z"],"grid":0,"tags":["ios-expand"]},{"paths":["M240.8 80l514.8 880 27.6-16-514.8-880z","M512 288c-24.6 0-48 2.6-71 7.6l13.2 22.6c18.8-3.6 38-5.4 57.8-5.4 148 0 262 102.2 348 199.2-53.8 54.6-118.4 121.2-198 161.4l12.6 21.6c91.6-46.6 164.8-125.8 221.4-183-88.8-102.8-214.8-224-384-224z","M512 711.2c-152.2 0-243.2-91.6-348-199.2 71.6-72.6 134-127.4 198.4-161l-12.6-21.6c-73 38.4-143.2 101.4-221.8 182.6 115.6 118.4 212.6 224 384 224 24.6 0 48.2-2.8 71-7.8l-13.2-22.6c-18.8 3.6-38 5.6-57.8 5.6z","M626 612c24.6-26.4 39.6-61.6 39.6-100 0-82.4-68.8-149.4-153.6-149.4-10.2 0-20.4 1-30 2.8l13.4 23c5.4-0.6 11-1 16.6-1 70.6 0 128 55.8 128 124.4 0 29-10.2 55.8-27.4 77l13.4 23.2z","M398 412c-24.6 26.4-39.6 61.6-39.6 100 0 82.4 68.8 149.4 153.6 149.4 10.4 0 20.4-1 30.2-2.8l-13.4-23c-5.4 0.6-11 1-16.6 1-70.6 0-128-55.8-128-124.4 0-29 10.2-55.8 27.4-77l-13.6-23.2z","M432.8 471.4c-6.6 12.2-10.4 26-10.4 40.6 0 46.6 37.6 84.6 85 87l-16.6-28.2c-24.8-8.6-42.8-31.6-42.8-58.6 0-4.2 0.4-8.4 1.2-12.4l-16.4-28.4z","M591.2 552.6c6.6-12.2 10.4-26 10.4-40.6h-25.6c0 4.2-0.4 8.4-1.2 12.4l16.4 28.2z"],"grid":0,"tags":["ios-eye-off-outline"]},{"paths":["M240.8 80l514.8 880 27.6-16-514.8-880z","M512 288c-24.6 0-48 2.6-71 7.6l40.8 70c9.8-1.8 19.8-2.8 30.2-2.8 84.8 0 153.6 67 153.6 149.4 0 38.4-15 73.4-39.6 100l48.6 83c91.6-46.6 164.8-125.8 221.4-183-88.8-103-214.8-224.2-384-224.2z","M512 661.4c-84.8 0-153.6-67-153.6-149.4 0-38.4 15-73.4 39.6-100l-48.2-82.4c-73 38.2-143.2 101.2-221.8 182.4 115.6 118.4 212.6 224 384 224 24.6 0 48.2-2.8 71-7.8l-40.8-69.8c-9.8 2-19.8 3-30.2 3z","M601.4 506.8c-7.8 3.4-16.4 5.2-25.4 5.2-3 0-6-0.2-8.8-0.6l24 41.2c6.6-12.2 10.4-26 10.4-40.6 0-1.8 0-3.6-0.2-5.2z","M432.8 471.4c-6.6 12.2-10.4 26-10.4 40.6 0 46.6 37.6 84.6 85 87l-74.6-127.6z"],"grid":0,"tags":["ios-eye-off"]},{"paths":["M592 96c-185.6 0-336 150.4-336 336 0 87 33 166.4 87.4 226l-119.4 119.4-84.6-84.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l84.6 84.6-100.6 100.6c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l100.6-100.6 84.6 84.6c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-85-84.6 119.4-119.4c59.6 54.2 139 87.4 226 87.4 185.6 0 336-150.4 336-336s-150.4-336-336-336zM807 647c-57.4 57.4-133.8 89-215 89s-157.6-31.6-215-89-89-133.8-89-215 31.6-157.6 89-215 133.8-89 215-89 157.6 31.6 215 89 89 133.8 89 215-31.6 157.6-89 215z"],"grid":0,"tags":["ios-female"]},{"paths":["M512 576c-59.6 0-109.8-40.8-124-96h-228v288h704v-288h-228c-14.2 55.2-64.4 96-124 96z","M737 256h-1v160h-32v-160h-384v160h-32v-160h-1l-127 192h256c0 53 43 96 96 96s96-43 96-96h256l-127-192z"],"grid":0,"tags":["ios-filing"]},{"paths":["M911.6 548c-0.2 0-0.4 0-0.8 0-8.8-0.4-15.6-7.8-15.2-16.6 0.2-5.4 0.4-15.2 0.4-21.4 0-85.6-36.8-192.2-82.2-237.6-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0c51.4 51.4 91.6 165.6 91.6 260.2 0 6.4-0.2 16.6-0.4 22.8-0.4 8.6-7.4 15.2-16 15.2z","M764 222.6c-3.6 0-7.2-1.2-10.2-3.8-71.4-59.4-155-90.8-241.8-90.8-82.6 0-159.8 24-223.4 69.6-7.2 5.2-17.2 3.4-22.4-3.6-5.2-7.2-3.4-17.2 3.6-22.4 69.2-49.4 153-75.6 242.2-75.6 94.4 0 185 34 262.2 98.4 6.8 5.6 7.8 15.8 2 22.6-3 3.6-7.6 5.6-12.2 5.6z","M142.4 703.6c-6.8 0-13.2-4.4-15.4-11.4-19-63.6-31-116.2-31-182.2 0-100.6 36.4-197.6 102.4-273.4 5.8-6.6 16-7.4 22.6-1.6s7.4 16 1.6 22.6c-61 70-94.6 159.6-94.6 252.4 0 62 11.4 112.2 29.8 173 2.6 8.4-2.2 17.4-10.6 20-1.6 0.4-3.2 0.6-4.8 0.6z","M244.2 847.2c-0.4 0-0.6 0-1 0-8.8-0.6-15.6-8-15-17 5.8-98-1.4-133.2-10.6-177.8-6.6-32.4-14.2-69-18.8-135.6-6.2-86 21.8-166.8 78.4-227.8 59.6-64 145.2-99.2 241.2-99.2 71 0 137.2 24.8 191 71.4 52.4 45.4 91.8 110.4 114.2 188 25 86.2 32 194.8 20.2 314-0.8 8.8-8.8 15.2-17.4 14.4-8.8-0.8-15.2-8.6-14.4-17.4 11.2-115.2 4.6-219.8-19.2-302-20.8-71.6-56.8-131.4-104.6-172.8-48-41.6-106.8-63.6-170-63.6-87 0-164.2 31.6-217.6 89-50.6 54.4-75.6 126.8-70 203.8 4.6 64.4 11.8 100 18.2 131.4 9.6 46.8 17.2 83.8 11.2 186-0.4 8.8-7.4 15.2-15.8 15.2z","M337.4 896.6c-0.8 0-1.4 0-2.2-0.2-8.8-1.2-14.8-9.4-13.6-18 16-112.8-0.8-237.2-19.2-344-11.6-67.2 1.6-125.8 38.2-169.4 38.6-45.8 102.6-73 171.4-73 57.2 0 109 22.6 149.4 65.6 40.8 43 68.6 105.4 80.4 180 10 63 15 114.4 15.2 157 0.6 86-10 154.6-10.4 157.4-1.4 8.8-9.6 14.8-18.2 13.4-8.8-1.4-14.8-9.6-13.4-18.2 0.2-0.6 10.6-69.2 10.2-152.4-0.2-41-5-90.8-14.8-152.2-21.4-134.8-97.4-218.6-198.4-218.6-59.6 0-114.4 23-147 61.6-30.8 36.6-41.4 84.8-31.2 143.2 18.8 109.2 36 236.8 19.4 354-1.2 8-8 13.8-15.8 13.8z","M632.6 906c-1 0-2 0-3-0.2-8.6-1.6-14.4-10-12.8-18.8 7-36.4 5.6-74.2 5.6-74.6-0.4-8.8 6.6-16.2 15.4-16.6 0.2 0 0.4 0 0.6 0 8.6 0 15.6 6.8 16 15.4 0 1.6 1.4 41.8-6.2 81.8-1.2 7.6-8 13-15.6 13z","M432.2 922.6c-0.6 0-1.4 0-2-0.2-8.8-1.2-15-9.2-13.8-18 14.4-112.6 8.8-235.6-16.8-365.4-11.8-59.6 4.4-94.6 19.8-113.4 20-24.4 51.4-37.8 88.6-37.8 57.8 0 102 41.4 121.4 113.8 15.2 56.4 23.8 136.8 25.2 232.6 0.2 8.8-7 16-15.8 16.2 0 0-0.2 0-0.2 0-8.8 0-15.8-7-16-15.8-1.2-93-9.6-170.8-24.2-224.6-21.8-81.2-70.4-90-90.4-90-27.4 0-50 9.2-63.8 26-16 19.4-20.4 49.4-13.2 86.8 26.2 133.2 32 259.6 17 375.6-1 8.4-7.8 14.2-15.8 14.2z","M532 928c-0.6 0-1.2 0-1.8 0-8.8-1-15.2-8.8-14.2-17.6 15.8-142.6 3.6-330.6-25.8-402.2-3.4-8.2 0.6-17.6 8.6-21 8.2-3.4 17.6 0.6 21 8.6 31.8 77 44.6 268.2 28.2 417.8-1 8.4-8 14.4-16 14.4z"],"grid":0,"tags":["ios-finger-print"]},{"paths":["M447.8 96c51.4 269.2-193.4 263.8-191.8 534.8 1.4 222 210 297.2 256.2 297.2 46.4 0 227.8-48.2 253.8-297.2 21.4-202.8-144.8-416-318.2-534.8zM512.2 913.2c0 0-81.4-66.6-81.4-148.6s81.2-148.6 81.2-148.6 80.6 66.6 80.6 148.6c-0 82-80.4 148.6-80.4 148.6zM734.4 628c-5.6 53.8-19.4 101.2-41 141-17.4 32.4-40.2 59.6-67.4 81.2-13 10.4-26.6 18.8-39.6 25.6 20-29.6 38.2-68.2 38.2-111.2 0-94.4-87.6-167.8-91.4-170.8l-21.2-17.4-21.2 17.4c-3.8 3-92 76.4-92 170.8 0 40.6 16.4 77.2 35.2 106.2-14.8-8-30.4-18.2-46-30.6-29.4-23.6-52.8-51.2-69.4-82.4-20.2-37.6-30.4-80.4-30.8-127-0.8-118.8 48.2-177.8 100-240.2 49.2-59.2 99.6-120.2 99-226.8 65 53.6 122.6 117 165.6 183.6 62.8 96.6 91 193.6 82 280.6z"],"grid":0,"tags":["ios-flame-outline"]},{"paths":["M447.8 96c51.4 269.2-193.4 263.8-191.8 534.8 1.4 222 210 297.2 256.2 297.2 46.4 0 227.8-48.2 253.8-297.2 21.4-202.8-144.8-416-318.2-534.8zM512.2 913.2c0 0-81.4-66.6-81.4-148.6s81.2-148.6 81.2-148.6 80.6 66.6 80.6 148.6c-0 82-80.4 148.6-80.4 148.6z"],"grid":0,"tags":["ios-flame"]},{"paths":["M547.8 264l-33 178.2-6.8 37.8h168l-199.6 280 33-178.2 6.6-37.8h-167.8l199.6-280zM605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"],"grid":0,"tags":["ios-flash-outline"]},{"paths":["M605.4 128l-319.4 448h191.6l-59 320 319.4-448h-191.6l59-320z"],"grid":0,"tags":["ios-flash"]},{"paths":["M873.8 708.8l-233.8-390.8v-190h32v-32h-64v230.8l5 7.6 233.2 389.6c13.6 25.6 18.6 52 18 76-0.4 18.6-4 35.8-13 51.2-17 28.2-46.4 44.8-81.2 44.8h-511.8c-35 0-65-16.8-82-45.4-23.8-39.6-21.8-76.2 4.6-126.2l182.8-308.4h116.4v-32h-97.4l29.4-49.6 4-7.6v-6.8h96v-32h-96v-64h64v-32h-64v-64h160v-32h-224v32h32v190l-231.8 390.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2z","M216.6 717.2c-13.8 21-21.8 48.2-21.8 67 0 55.2 31.6 79.6 91.4 79.6h451.8c59.6 0 90-31.4 91.4-80 0.6-19-6.2-45.4-20.2-66.6l-143.8-237.2h-306.4l-142.4 237.2zM647.4 512l134.4 221.8 0.4 0.2 0.4 0.4c10.8 16.4 15.2 36.6 15 48.4-0.4 15.6-5 28-13.4 35.6-9.6 8.6-25.4 13.6-46 13.6h-452.2c-22.2 0-38.6-4.4-47.4-12-3-2.4-12-10.2-12-36.2 0-11.8 5.8-32.8 16.6-49.4l0.4-0.6h0.4l133.2-221.8h270.2z"],"grid":0,"tags":["ios-flask-outline"]},{"paths":["M782 734l-0.4-0.2-134.2-221.8h-270.2l-133.2 221.8h-0.4l-0.4 0.6c-11 16.6-16.6 37.6-16.6 49.4 0 25.8 9 33.6 12 36.2 9 7.6 25.4 12 47.4 12h452c20.6 0 36.4-5 46-13.6 8.4-7.6 13-20 13.4-35.6 0.4-11.8-4.2-32-15-48.4l-0.4-0.4z","M873.8 708.8l-233.8-390.8v-190h32v-32h-320v32h32v190l-231.8 390.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2zM432 192h48v32h-48v-32zM432 288h80v32h-80v-32zM398.6 384h81.4v32h-100.4l19-32zM829.2 784c-1.4 48.4-31.8 80-91.4 80h-451.8c-59.8 0-91.4-24.4-91.4-79.6 0-19 8-46 21.8-67l142.6-237.4h306.4l143.6 237.4c14 21.2 20.8 47.8 20.2 66.6z"],"grid":0,"tags":["ios-flask"]},{"paths":["M770.2 460.4c-53.4 0-120.2 13.8-172.6 27-1.8-6.4-4.2-12.4-7.4-18.2 46.4-27.6 103.4-65 141-102.8 73.4-73.4 96.6-127.2 75.2-148.6-5.2-5.2-12-7.6-20.6-7.6-27.6 0-72 26.8-128 82.8-37.6 37.6-75.2 94.4-102.8 140.8-5.6-3.2-11.8-5.6-18.2-7.6 13.4-52.4 27-119 27-172.2 0-103.8-21.6-158.2-52-158.2s-52 54.4-52 158.2c0 53.2 13.6 120 27 172.2-6.4 1.8-12.4 4.4-18.2 7.6-27.6-46.4-65-103.2-102.8-140.8-56-56-100.6-82.8-128-82.8-8.6 0-15.4 2.6-20.6 7.6-21.6 21.6 1.6 75.2 75.2 148.6 37.8 37.8 94.6 75.2 141 102.8-3 5.6-5.6 11.8-7.4 18.2-52.4-13.4-119.2-27-172.6-27-103.6 0-157.4 21.2-157.4 51.6s53.8 52.4 157.8 52.4c53.4 0 120.4-13.8 172.8-27.2 1.8 6.2 4.4 12.4 7.6 18-46.6 27.6-103.6 65.2-141.4 103-73.4 73.4-96.6 127.2-75.2 148.6 5.2 5.2 12 7.6 20.6 7.6 27.6 0 72-26.8 128-82.8 37.8-37.8 75.6-95 103.2-141.6 5.6 3 11.6 5.6 18 7.4-13.4 52.4-27.2 119.6-27.2 173 0 103.8 21.6 157.2 52 157.2s52-53.4 52-157.2c0-53.6-13.8-120.6-27.2-173 6.2-1.8 12.2-4.2 18-7.4 27.6 46.6 65.2 103.8 103.2 141.6 56 56 100.6 82.8 128 82.8 8.6 0 15.4-2.6 20.6-7.6 21.6-21.6-1.6-75.2-75.2-148.6-37.8-37.8-95-75.4-141.4-103 3.2-5.6 5.6-11.6 7.6-18 52.4 13.4 119.4 27.2 172.8 27.2 103.8 0 157.8-21.6 157.8-52s-54.2-52-158.2-52zM678.8 314c65.8-65.8 97.8-73.2 105.6-74-0.4 4.2-2.4 13.6-11.8 29.6-12.6 21.6-34 47.8-62.2 75.8-25.2 25.2-63.6 54-112.4 84.4-1.2-1.2-2.4-2.4-3.6-3.6 30.4-48.4 59.4-87 84.4-112.2zM499.4 156.6c4.8-18 9.8-26.2 12.6-29.4 2.8 3.4 7.8 11.4 12.6 29.4 6.4 24.2 9.8 57.8 9.8 97.6 0 35.6-6.8 83.2-19.8 139-0.8 0-1.6 0-2.6 0-0.8 0-1.6 0-2.6 0-13-55.8-19.8-103.4-19.8-139 0.2-39.6 3.4-73.4 9.8-97.6zM426 430c-48.6-30.4-87.2-59.2-112.4-84.4-28-28-49.4-54.2-62.2-75.8-9.4-16-11.6-25.4-11.8-29.6 7.6 0.8 39.8 8.2 105.6 74 25.2 25.2 54 63.6 84.4 112.4-1.2 1-2.4 2.2-3.6 3.4zM253.8 534.8c-39.6 0-73.4-3.4-97.4-10-18-4.8-26-10-29.2-12.8 3.2-2.6 11.2-7.8 29.4-12.4 24-6.2 57.6-9.4 97.2-9.4 35.6 0 83.4 6.8 139.4 19.8 0 0.6 0 1.4 0 2 0 1 0 2 0 2.8-56 13.2-103.8 20-139.4 20zM345.2 710.8c-65.8 65.8-97.8 73.2-105.6 74 0.4-4.2 2.4-13.6 11.8-29.6 12.6-21.6 34-47.8 62.2-75.8 25.2-25.2 64-54.2 113-84.8 1 1.2 2.2 2.2 3.4 3.4-30.6 48.8-59.6 87.6-84.8 112.8zM524.6 867.8c-4.8 18-10 26-12.6 29-2.6-3.2-7.8-11-12.6-29-6.4-24-9.6-57.6-9.6-97.2 0-35.8 6.8-83.6 20-139.8 0.8 0 1.6 0 2.4 0s1.6 0 2.4 0c13 56.2 20 104.2 20 139.8-0.4 39.8-3.6 73.2-10 97.2zM512 576c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64zM597.4 594.6c49 30.4 87.8 59.4 113 84.8 28 28 49.6 54.2 62.2 75.8 9.4 16 11.6 25.4 11.8 29.6-7.6-0.8-39.8-8.2-105.6-74-25.2-25.2-54.2-64-84.8-113 1.2-1 2.4-2 3.4-3.2zM867.6 525c-24 6.4-57.8 9.6-97.4 9.6-35.6 0-83.4-6.8-139.4-19.8 0-1 0-2 0-2.8 0-0.6 0-1.4 0-2 56-13 103.8-19.8 139.4-19.8 39.6 0 73.2 3.4 97.4 9.6 18 4.8 26 9.8 29.2 12.6-3.2 2.8-11.2 8-29.2 12.6z","M636.8 752.8c-17-17-33.8-37.4-49.6-59 4 26.4 6.6 52.8 6.6 76.8 0 23.4-1 45-3.2 64.2 24.6 43.6 48.6 65.4 68 65.4 3.2 0 6.4-0.6 9.4-1.8 22-9 26.6-46.6 9-108.6-12.8-10.6-26.2-23-40.2-37zM656.4 869.6c-5-2.8-17.4-11.8-35.2-41.4 1.2-14.6 2-30.4 2.2-47 9.4 9 18.4 17.6 27.4 25.2 9.4 37 7.8 56.2 5.6 63.2z","M387.6 272.2c16.8 16.8 33.4 37 49.2 58.4-4-26.4-6.4-52.6-6.4-76.4 0-23.4 1-45 3.2-64.2-24.6-43.6-48.6-65.4-68-65.4-3.2 0-6.4 0.6-9.4 1.8-22 9-26.6 46.6-9 108.6 12.8 10.8 26.4 23.2 40.4 37.2zM367.6 155.4c5 2.8 17.4 11.8 35.2 41.4-1.2 14.6-2 30.2-2.2 46.8-9.2-9-18.4-17.4-27.4-25.2-9.4-36.8-7.8-56-5.6-63z","M271.6 637.2c17-17 37.4-33.8 59-49.6-26.4 4-52.8 6.6-76.8 6.6-23.4 0-45-1-64.2-3.2-51 28.8-72.2 56.4-63.6 77.4 5.2 12.8 20.2 19.8 44.2 19.8 17 0 38.6-3.4 64.4-10.8 10.8-12.8 23-26.2 37-40.2zM170.2 658.6c-7.6 0-12.6-1-15.2-1.8 2.8-5.2 11.8-17.4 41.4-35.2 14.6 1.2 30.4 2 47 2.2-9 9.2-17.4 18.4-25.2 27.4-19 4.8-35.4 7.4-48 7.4z","M752.4 387.6c-17 17-37.4 33.8-59 49.6 26.4-4 52.8-6.6 76.8-6.6 23.4 0 45 1 64.2 3.2 51-28.8 72.2-56.4 63.6-77.4-5.2-12.8-20.2-19.8-44.2-19.8-17 0-38.6 3.4-64.4 10.8-10.8 13-23 26.4-37 40.2zM853.8 366.4c7.6 0 12.6 1 15.2 1.8-2.8 5.2-12 17.4-41.4 35.2-14.6-1.2-30.4-2-47-2.2 9-9.2 17.4-18.4 25.2-27.4 19-5 35.4-7.4 48-7.4z","M387.2 752.8c-16.6 16.6-32.6 31.2-47.6 43.2-15.6 56.4-11 90.8 9.8 99.8 3.2 1.4 6.4 2 9.8 2 20.6 0 46.4-24 73.4-72.4-1.4-16.8-2.2-35-2.2-54.6 0-24 2.6-50.4 6.6-76.8-16 21.4-32.8 41.8-49.8 58.8zM361.6 867c-1.6-5.6-4-20.8 4.2-54.2 11.2-9.4 22.8-20 34.8-31.6 0.2 13 0.6 25.4 1.6 37.2-19.4 32.8-34 45.4-40.6 48.6z","M636.8 272.4c16.6-16.6 32.4-31 47.4-43 15.8-56.8 11.4-91.6-9.6-100.4-3.2-1.4-6.4-2-9.8-2-20.6 0-46.4 24-73.4 72.4 1.4 16.8 2.2 35 2.2 54.6 0 24.2-2.6 50.6-6.6 77.4 16-21.4 32.8-42 49.8-59zM662.4 157.8c1.6 5.6 4 20.8-4.4 54.8-11.2 9.4-22.8 20-34.6 31.4-0.2-13.2-0.6-25.8-1.6-37.6 19.4-32.8 34-45.2 40.6-48.6z","M199.2 433c16.8-1.4 35-2.2 54.6-2.2 24 0 50.2 2.6 76.6 6.6-21.4-15.8-41.8-32.6-58.8-49.6-16.6-16.6-31.2-32.6-43.4-47.8-22.6-6.2-41.8-9.2-57.2-9.2-22.8 0-37.2 6.6-42.4 19-9.2 21.8 14.2 51.8 70.6 83.2zM171.2 360.4c10.8 0 24.6 2 40.2 5.8 9.4 11.2 20 22.8 31.6 34.8-13 0.2-25.4 0.6-37.2 1.6-32.8-19.4-45.2-34-48.6-40.6 2.8-0.8 7.2-1.6 14-1.6z","M824.8 592c-16.8 1.4-35 2.2-54.6 2.2-24 0-50.4-2.6-76.8-6.6 21.6 15.8 42 32.8 59 49.6 16.6 16.6 31 32.6 43.2 47.6 22.8 6.4 41.8 9.4 57.2 9.4 22.8 0 37.2-6.6 42.4-19 9.4-22-14-51.8-70.4-83.2zM852.8 664.6c-10.8 0-24.6-2-40.4-6-9.4-11.2-20-22.8-31.6-34.8 13-0.2 25.4-0.6 37.2-1.6 32.8 19.4 45.2 34 48.6 40.6-2.6 1-7 1.8-13.8 1.8z"],"grid":0,"tags":["ios-flower-outline"]},{"paths":["M770.2 460.4c-53.4 0-120.2 13.8-172.6 27-1.8-6.4-4.2-12.4-7.4-18.2 46.4-27.6 103.4-65 141-102.8 73.4-73.4 96.6-127.2 75.2-148.6-5.2-5.2-12-7.6-20.6-7.6-27.6 0-72 26.8-128 82.8-37.6 37.6-75.2 94.4-102.8 140.8-5.6-3.2-11.8-5.6-18.2-7.6 13.4-52.4 27-119 27-172.2 0-103.8-21.6-158.2-52-158.2s-52 54.4-52 158.2c0 53.2 13.6 120 27 172.2-6.4 1.8-12.4 4.4-18.2 7.6-27.6-46.4-65-103.2-102.8-140.8-56-56-100.6-82.8-128-82.8-8.6 0-15.4 2.6-20.6 7.6-21.6 21.6 1.6 75.2 75.2 148.6 37.8 37.8 94.6 75.2 141 102.8-3 5.6-5.6 11.8-7.4 18.2-52.4-13.4-119.2-27-172.6-27-103.6 0-157.4 21.2-157.4 51.6s53.8 52.4 157.8 52.4c53.4 0 120.4-13.8 172.8-27.2 1.8 6.2 4.4 12.4 7.6 18-46.6 27.6-103.6 65.2-141.4 103-73.4 73.4-96.6 127.2-75.2 148.6 5.2 5.2 12 7.6 20.6 7.6 27.6 0 72-26.8 128-82.8 37.8-37.8 75.6-95 103.2-141.6 5.6 3 11.6 5.6 18 7.4-13.4 52.4-27.2 119.6-27.2 173 0 103.8 21.6 157.2 52 157.2s52-53.4 52-157.2c0-53.6-13.8-120.6-27.2-173 6.2-1.8 12.2-4.2 18-7.4 27.6 46.6 65.2 103.8 103.2 141.6 56 56 100.6 82.8 128 82.8 8.6 0 15.4-2.6 20.6-7.6 21.6-21.6-1.6-75.2-75.2-148.6-37.8-37.8-95-75.4-141.4-103 3.2-5.6 5.6-11.6 7.6-18 52.4 13.4 119.4 27.2 172.8 27.2 103.8 0 157.8-21.6 157.8-52s-54.2-52-158.2-52zM512 544c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z","M636.8 752.8c-17-17-33.8-37.4-49.6-59 4 26.4 6.6 52.8 6.6 76.8 0 23.4-1 45-3.2 64.2 24.6 43.6 48.6 65.4 68 65.4 3.2 0 6.4-0.6 9.4-1.8 22-9 26.6-46.6 9-108.6-12.8-10.6-26.2-23-40.2-37z","M387.6 272.2c16.8 16.8 33.4 37 49.2 58.4-4-26.4-6.4-52.6-6.4-76.4 0-23.4 1-45 3.2-64.2-24.6-43.6-48.6-65.4-68-65.4-3.2 0-6.4 0.6-9.4 1.8-22 9-26.6 46.6-9 108.6 12.8 10.8 26.4 23.2 40.4 37.2z","M271.6 637.2c17-17 37.4-33.8 59-49.6-26.4 4-52.8 6.6-76.8 6.6-23.4 0-45-1-64.2-3.2-51 28.8-72.2 56.4-63.6 77.4 5.2 12.8 20.2 19.8 44.2 19.8 17 0 38.6-3.4 64.4-10.8 10.8-12.8 23-26.2 37-40.2z","M752.4 387.6c-17 17-37.4 33.8-59 49.6 26.4-4 52.8-6.6 76.8-6.6 23.4 0 45 1 64.2 3.2 51-28.8 72.2-56.4 63.6-77.4-5.2-12.8-20.2-19.8-44.2-19.8-17 0-38.6 3.4-64.4 10.8-10.8 13-23 26.4-37 40.2z","M387.2 752.8c-16.6 16.6-32.6 31.2-47.6 43.2-15.6 56.4-11 90.8 9.8 99.8 3.2 1.4 6.4 2 9.8 2 20.6 0 46.4-24 73.4-72.4-1.4-16.8-2.2-35-2.2-54.6 0-24 2.6-50.4 6.6-76.8-16 21.4-32.8 41.8-49.8 58.8z","M636.8 272.4c16.6-16.6 32.4-31 47.4-43 15.8-56.8 11.4-91.6-9.6-100.4-3.2-1.4-6.4-2-9.8-2-20.6 0-46.4 24-73.4 72.4 1.4 16.8 2.2 35 2.2 54.6 0 24.2-2.6 50.6-6.6 77.4 16-21.4 32.8-42 49.8-59z","M199.2 433c16.8-1.4 35-2.2 54.6-2.2 24 0 50.2 2.6 76.6 6.6-21.4-15.8-41.8-32.6-58.8-49.6-16.6-16.6-31.2-32.6-43.4-47.8-22.6-6.2-41.8-9.2-57.2-9.2-22.8 0-37.2 6.6-42.4 19-9.2 21.8 14.2 51.8 70.6 83.2z","M824.8 592c-16.8 1.4-35 2.2-54.6 2.2-24 0-50.4-2.6-76.8-6.6 21.6 15.8 42 32.8 59 49.6 16.6 16.6 31 32.6 43.2 47.6 22.8 6.4 41.8 9.4 57.2 9.4 22.8 0 37.2-6.6 42.4-19 9.4-22-14-51.8-70.4-83.2z"],"grid":0,"tags":["ios-flower"]},{"paths":["M912.6 320c-2.2 0-8.6 0-16.6 0v-82c0-26.6-18.8-46-45.6-46h-388.6c-5.6 0-8.6-1.2-12.2-4.8l-45.4-45.4c-9.8-9.2-17.8-13.8-34.6-13.8h-192.2c-27.6 0-49.4 20.6-49.4 46v146c-8 0-14.2 0-16.6 0-25.6 0-50.6 10.2-47 48.6s47 477.4 47 477.4c5.4 35.6 23.4 50 50 50h705c25.4 0 42-15.6 46-50 0 0 44.4-425.8 47.2-467s-17.8-59-47-59zM160 174c0-8.6 8.8-14 17.4-14h192.2c7 0 7.4 0.4 12.4 5l45 44.8c9.6 9.6 20.8 14.2 34.8 14.2h388.6c9 0 13.6 5.2 13.6 14v82c-144 0-560 0-704 0v-146zM880.4 846c-1.6 9.4-7.4 18-16 18h-700.4c-9 0-19-7-20.6-18l-48-478c0-8.8 7.2-16 16-16h801.2c8.8 0 16 7.2 16 16l-48.2 478z"],"grid":0,"tags":["ios-folder-open-outline"]},{"paths":["M896 238c0-26.6-18.8-46-45.6-46h-388.6c-5.6 0-8.6-1.2-12.2-4.8l-45.4-45.4c-9.8-9.2-17.8-13.8-34.6-13.8h-192.2c-27.6 0-49.4 20.6-49.4 46v114h768v-50z","M128 320c-8 0-14.2 0-16.6 0-25.6 0-50.6 10.2-47 48.6s47 477.4 47 477.4c5.4 35.6 23.4 50 50 50h705c25.4 0 42-15.6 46-50 0 0 44.4-425.8 47.2-467 2.8-41-17.8-59-47.2-59-2.2 0-8.6 0-16.6 0h-767.8z"],"grid":0,"tags":["ios-folder-open"]},{"paths":["M64 128v64l352 384v256l192 64v-320l352-384v-64h-896zM928 180l-352 384v287.6l-128-42.6v-245l-352-384v-20h832v20z"],"grid":0,"tags":["ios-funnel-outline"]},{"paths":["M64 128v64l352 384v256l192 64v-320l352-384v-64h-896z"],"grid":0,"tags":["ios-funnel"]},{"paths":["M832 320c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 65.2 48.8 119 112 127v1c0 46-19.8 84.8-59 115-42.6 33-97.4 48.2-135.8 55-86.4 15.6-128.2 66.6-143.2 89.4-5.2-1.2-10.6-2.2-16-2.8v-385.4c64.2-7 114-61.2 114-127.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.8-110 62.2-110 126.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-48.6-27.2-91-67.2-112.6 14.6-20.2 50.2-57.4 118-69.8 42-7.6 102-24.4 149.6-61.2 46.8-36.2 71.4-84.6 71.4-140.4v-1c63.4-8.2 112.2-62 112.2-127.2zM224 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM416 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM704 416c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"],"grid":0,"tags":["ios-git-branch"]},{"paths":["M944 496h-176c-0.2 0-0.4 0-0.6 0-8.2-134-119.4-240-255.4-240s-247.2 106-255.4 240c-0.2 0-0.4 0-0.6 0h-176c-8.8 0-16 7.2-16 16s7.2 16 16 16h176c0.2 0 0.4 0 0.6 0 8.2 134 119.4 240 255.4 240s247.2-106 255.4-240c0.2 0 0.4 0 0.6 0h176c8.8 0 16-7.2 16-16s-7.2-16-16-16zM670.4 670.4c-42.4 42.4-98.6 65.6-158.4 65.6s-116-23.2-158.4-65.6c-42.2-42.4-65.6-98.6-65.6-158.4s23.4-116 65.6-158.4c42.4-42.2 98.6-65.6 158.4-65.6s116 23.4 158.4 65.6c42.2 42.4 65.6 98.6 65.6 158.4s-23.4 116-65.6 158.4z"],"grid":0,"tags":["ios-git-commit"]},{"paths":["M447.4 692.6c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l103.2 100.8h-208c-98.4 0-114-84.6-114-176v-320.8c64.2-7 114-61.2 114-127.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v321.2c0 28.6 0 81.8 18 126 22 54.4 66.6 82 128 82h208l-99.4 100.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l115.2-114.8c12.6-12.6 12.6-32.8 0-45.2l-119.2-118.8zM96 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96z","M850 705.2v-321.2c0-28.6 0-81.8-18-126-22-54.4-66.6-82-128-82h-208l99.4-100.8c6.2-6.2 6.2-16.4 0-22.6-3.2-3-7.2-4.6-11.4-4.6s-8.2 1.4-11.4 4.6l-115.2 114.8c-12.6 12.6-12.6 32.8 0 45.2l119.2 118.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-103.2-100.8h208c98.4 0 114 84.6 114 176v320.8c-64.2 7-114 61.2-114 127.2 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8zM832 928c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"],"grid":0,"tags":["ios-git-compare"]},{"paths":["M768 448c-65.4 0-119.4 49.2-127 112.4-18.2 0-59.2-2.6-111-22.6-65.2-25.4-159.8-84.4-243-221.6 55.6-13.8 97-64.2 97-124.2 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.6-110 62-110 126.6 0 70.6 57.4 128 128 128s128-57.4 128-128c0-66-49.8-120.2-114-127.2v-355.2c85.4 133 181.2 191.8 248.4 218 55.6 21.6 100.2 24.8 122 24.8 0.2 0 0.4 0 0.8 0 8 62.8 61.8 111.6 127 111.6 70.6 0 128-57.4 128-128s-57.6-128-128.2-128zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM352 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM768 672c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"],"grid":0,"tags":["ios-git-merge"]},{"paths":["M896 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8h2v119.2l-240 118.2-240-118.2v-119c63.2-7.8 112-61.6 112-127 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8h2v139.2l256 126v120.6c-63.2 7.8-112 61.6-112 127 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8h-2v-120.8l256-126v-139c63.2-8 112-61.8 112-127zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM608 831.6c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96zM768 288c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"],"grid":0,"tags":["ios-git-network"]},{"paths":["M384 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 64.6 47.8 118 110 126.8v386.6c-62.2 8.6-110 62-110 126.6 0 70.6 57.4 128 128 128s128-57.4 128-128c0-66-49.8-120.2-114-127.2v-385.6c64.2-7 114-61.2 114-127.2zM160 192c0-53 43-96 96-96s96 43 96 96-43 96-96 96-96-43-96-96zM352 832c0 53-43 96-96 96s-96-43-96-96 43-96 96-96 96 43 96 96z","M786 705.2v-321.2c0-28.6 0-81.8-18-126-22-54.4-66.6-82-128-82h-208l99.4-100.8c6.2-6.2 6.2-16.4 0-22.6-3.2-3-7.2-4.6-11.4-4.6s-8.2 1.4-11.4 4.6l-115.2 114.8c-12.6 12.6-12.6 32.8 0 45.2l119.2 118.8c6.2 6.2 16.4 6.2 22.6 0s6.2-16.4 0-22.6l-103.2-100.8h208c98.4 0 114 84.6 114 176v320.8c-64.2 7-114 61.2-114 127.2 0 70.6 57.4 128 128 128s128-57.4 128-128c0-64.6-47.8-118-110-126.8zM768 928c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z"],"grid":0,"tags":["ios-git-pull-request"]},{"paths":["M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM528.6 345c44.2-1.2 87-7 128.4-17 12.4 49 20.2 105.6 21.4 167.6h-149.8v-150.6zM528.6 311.6v-179.6c44.8 12.4 90.4 72.2 119.2 164-38.4 9.2-78.2 14.4-119.2 15.6zM495.4 131.6v180.2c-41.4-1.2-81.6-6.6-120.2-16 29.2-92.4 75-152.6 120.2-164.2zM495.4 345v150.4h-150.8c1.2-62 9-118.6 21.4-167.6 41.6 10 85 16 129.4 17.2zM311 495.4h-181.2c3.6-85.6 35.6-164 86.6-226 37 20.4 76.4 37.2 117.6 49.6-13.6 53-21.6 112.8-23 176.4zM311 528.6c1.2 63.4 9.2 123.4 22.8 176.4-41.2 12.6-80.4 29.2-117.6 49.6-51-62-82.8-140.4-86.6-226h181.4zM344.6 528.6h150.8v150.2c-44.4 1.2-87.8 7.2-129.4 17.4-12.4-49-20.2-105.6-21.4-167.6zM495.4 712.2v180.4c-45.2-11.8-91-71.8-120.2-164.2 38.6-9.6 78.8-15 120.2-16.2zM528.6 892v-180c41 1.2 80.8 6.6 119.4 15.8-29 92-74.4 151.8-119.4 164.2zM528.6 678.8v-150.2h149.8c-1.2 61.8-9 118.4-21.4 167.4-41.4-10-84.2-16-128.4-17.2zM711.8 528.6h182.4c-3.6 85.6-35.6 163.8-86.6 226-37.4-20.6-77-37.4-118.6-50 13.6-53 21.6-112.6 22.8-176zM711.8 495.4c-1.2-63.4-9.2-123.2-22.6-176.2 41.6-12.6 81.2-29.4 118.4-49.8 51 62 83 140.4 86.6 226.2h-182.4zM784.8 243.8c-33.2 17.6-68 32.2-104.6 43.2-19.4-62.6-46.8-113.6-79-147.2 70.8 17 134 53.8 183.6 104zM421.6 140.2c-32.2 33.4-59.4 84.4-78.6 146.6-36.2-11-70.8-25.4-103.6-43 49-50 111.8-86.6 182.2-103.6zM239.2 780c32.8-17.6 67.6-32 103.6-43 19.4 62.4 46.6 113.2 78.8 146.8-70.4-17-133.2-53.6-182.4-103.8zM601.2 884.2c32.4-33.6 59.6-84.6 79.2-147.4 36.6 11 71.4 25.6 104.6 43.2-49.6 50.4-113 87.2-183.8 104.2z"],"grid":0,"tags":["ios-globe-outline"]},{"paths":["M512 96c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-229.4 0.6-415 186.6-415 416s185.6 415.4 415 416c0.2 0 0.4 0 0.4 0s0.2 0 0.2 0 0.2 0 0.4 0c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 894.8c-0.2 0-0.2 0-0.4 0 0 0 0 0-0.2 0s-0.4 0-0.4 0c-210.8-0.6-381.8-171.8-381.8-382.8s170.8-382.2 381.8-382.6c0.2 0 0.2 0 0.4 0 0 0 0.2 0 0.2 0 0.2 0 0.2 0 0.4 0 211.4 0 382.8 171.4 382.8 382.8 0 211.2-171.4 382.6-382.8 382.6z","M644.6 343.6c-37.4 9-76 14.4-115.8 15.6v136.2h135.2c-1.2-56.2-8.2-107.2-19.4-151.8z","M528.6 165v163.8c37-1.2 73-6 107.6-14.4-26.2-82.8-67-137.2-107.6-149.4z","M386.8 314.2c35 8.4 71.2 13.4 108.4 14.6v-164.2c-40.6 11.8-82 66.2-108.4 149.6z","M761.2 266.8c-45.2-46-103-79.6-167.8-95 29.6 30.6 54.4 77.4 72.2 134.6 33.4-10.2 65.4-23.4 95.6-39.6z","M694.6 495.4h166.6c-3.6-77.6-32.6-148.8-79-205.2-34.2 18.8-70.4 34.2-108.2 45.6 12.2 48 19.4 102.2 20.6 159.6z","M359 495.4h136.4v-136.2c-40.2-1.2-79.2-6.6-116.8-15.8-11.4 44.6-18.4 95.8-19.6 152z","M664 528.6h-135.4v136c39.8 1.2 78.6 6.4 116 15.6 11.2-44.4 18.2-95.6 19.4-151.6z","M378.6 680.4c37.6-9.2 76.6-14.6 116.8-15.8v-136h-136.4c1.2 56.2 8.2 107.4 19.6 151.8z","M495.4 859.2v-164.2c-37.2 1.2-73.6 6.2-108.6 14.6 26.4 83.4 67.8 138 108.6 149.6z","M593.4 852.2c64.8-15.6 122.6-49 168-95.2-30.2-16.2-62.2-29.4-95.6-39.6-17.8 57.4-42.8 104-72.4 134.8z","M429.4 172.2c-64.2 15.6-121.6 49-166.6 94.8 30 16 61.6 29.2 94.6 39.2 17.8-57 42.6-103.4 72-134z","M674 688.2c38 11.4 74.2 26.8 108.4 45.6 46.4-56.4 75.4-127.6 79-205.2h-166.6c-1.4 57.4-8.6 111.4-20.8 159.6z","M528.6 695v164c40.6-12.2 81.4-66.6 107.6-149.6-34.6-8.4-70.6-13.2-107.6-14.4z","M349.2 335.6c-37.6-11.4-73.6-26.6-107.4-45.4-46.4 56.4-75.4 127.6-79 205.2h165.8c1-57.6 8.4-111.8 20.6-159.8z","M328.4 528.6h-165.8c3.6 77.6 32.6 148.8 79 205.2 33.8-18.6 69.8-34 107.4-45.4-12-48-19.4-102.2-20.6-159.8z","M262.6 757c45 45.8 102.4 79.2 166.8 94.8-29.4-30.6-54.2-77.2-72-134.2-33 10.2-64.8 23.4-94.8 39.4z"],"grid":0,"tags":["ios-globe"]},{"paths":["M896 384v-32h-224v-224h-32v224h-256v-224h-32v224h-224v32h224v256h-224v32h224v224h32v-224h256v224h32v-224h224v-32h-224v-256h224zM640 640h-256v-256h256v256z"],"grid":0,"tags":["ios-grid-outline"]},{"paths":["M384 384h256v256h-256v-256z","M128 128v768h768v-768h-768zM832 384h-160v256h160v32h-160v160h-32v-160h-256v160h-32v-160h-160v-32h160v-256h-160v-32h160v-160h32v160h256v-160h32v160h160v32z"],"grid":0,"tags":["ios-grid"]},{"paths":["M924.8 433.8l-68.4-67.8c-2.2-2.2-5-3.2-7.8-3.2s-5.8 1-7.8 3.2l-7.4 7.4c-10.6 0-27.2-1.4-36.2-10.4-13.8-13.6 2.2-40.6-10.2-58-12.2-17.4-31.8-39.4-45.8-53.4s-69.2-66.8-162.4-105c-32.8-13.4-65-18.6-93.6-18.6-52.6 0-93.8 17-108.4 30.4-10.8 10-22.2 28-6.2 28 1.4 0 3-0.2 4.8-0.4 8.8-1.4 26.4-3 46.4-3 31.2 0 68.4 4.2 88.2 20 32.4 26 59 60.6 61.2 105.4 2.2 43-12.4 68-68.6 123.6l-11.4-6c-2.6-1.4-5.6-2-8.4-2-5 0-9.8 1.8-12.6 4.6 0 0-8.8 8.2-92.8 91.6-124.6 123.2-278.2 247.4-278.2 247.4-4.4 4.4-4.4 11.4 0 15.6l110.4 109.6c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2c0 0 125.2-152.4 249.4-275.6 84-83.4 92.2-92 92.2-92 4.4-4.4 7.2-13.2 2.6-20.8l-7.8-13c50.2-49.8 70.4-71 95-77.8 8-2.2 16.6-3 25.4-3 19.2 0 38 4.4 46.6 9 10.2 5.4 19.4 22.6 20.4 37.2l-19 19c-4.4 4.4-4.4 11.4 0 15.6l68.4 67.8c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4.6-4.4 4.6-11.6 0.4-15.8zM452.4 594.4c-98.8 98-198.8 215-236.4 259.6l-77.8-77.2c45.2-37.4 163-136.4 261.4-234.2 46.8-46.4 70.2-69.4 81.6-80.6l51.8 51.8c-11.4 11.8-34.6 35-80.6 80.6zM806.4 521.8l-38.6-38.4 4-4 6.4-10.4 3-14.6c-1.6-22.4-15-51.2-37.2-63-14.6-7.8-38.8-12.8-61.8-12.8-12.2 0-23.6 1.4-34 4.2-31.2 8.6-53 30.4-100.8 77.8l-8 8-3.4 3.2-14.2-14.2 2.8-2.8c57.4-56.8 80.8-90 78-147.8-2.2-48.2-26.8-91.6-73-129v0 0c-9.2-7.4-20.8-13.2-34.6-17.6 24.4 1.2 48.4 6.4 71.4 15.8 78.6 32.2 129 75.2 152 98 12.4 12.2 30.2 32.4 41.4 47.8 0.2 2.4-0.2 7-0.4 10.4-1 13.4-2.4 36.4 15 53.6 13.2 13 33 20 58.8 20l15.2-2.4 38.6 38.2-80.6 80z"],"grid":0,"tags":["ios-hammer-outline"]},{"paths":["M491 426c-2.6-1.4-5.6-2-8.4-2-5 0-9.8 1.8-12.6 4.6 0 0-8.8 8.2-92.8 91.6-124.4 123.2-278 247.4-278 247.4-4.4 4.4-4.4 11.4 0 15.6l110.4 109.6c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2c0 0 125.2-152.4 249.4-275.6 84-83.4 92.2-92 92.2-92 4.4-4.4 7.2-13.2 2.6-20.8l-7.8-12.8-59.4-59.6-11.2-6z","M924.8 433.8l-68.4-67.8c-2.2-2.2-5-3.2-7.8-3.2s-5.8 1-7.8 3.2l-7.4 7.4c-10.6 0-27.2-1.4-36.2-10.4-13.8-13.6 2.2-40.6-10.2-58-12.2-17.4-31.8-39.4-45.8-53.4s-69.2-66.8-162.4-105c-32.8-13.4-65-18.6-93.6-18.6-52.6 0-93.8 17-108.4 30.4-10.8 10-22.2 28-6.2 28 1.4 0 3-0.2 4.8-0.4 8.8-1.4 26.4-3 46.4-3 31.2 0 68.4 4.2 88.2 20 32.4 26 59 60.6 61.2 105.4 1.8 36.8-8.6 60.4-46.8 101.4l59.8 59.8c35-34.4 52.6-50.4 73-56 8-2.2 16.6-3 25.4-3 19.2 0 38 4.4 46.6 9 10.2 5.4 19.4 22.6 20.4 37.2l-19 19c-4.4 4.4-4.4 11.4 0 15.6l68.4 67.8c2.2 2.2 5 3.2 7.8 3.2s5.8-1 7.8-3.2l110.4-109.6c4-4.4 4-11.6-0.2-15.8z"],"grid":0,"tags":["ios-hammer"]},{"paths":["M546 127.8c21 0 38 17 38 37.8v265.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-233.2c0-20.8 17-37.8 38-37.8s38 17 38 37.8v297c0 8.8 7.2 16 16 16s16-7.2 16-16v-201.2c0-20.8 17-37.8 38-37.8s38 17 38 37.8v428.6c0 101.6-57.2 174-140.4 174 0 0-60 0-103 0s-73.2-22.2-73.2-22.2c-77.8-46.8-169.6-177.2-204-216.8-35.8-41-70.2-76.4-48.4-98 11.2-10.6 23.4-15.6 36.2-15.6 24.4 0 52.4 17 83 44.4l49.8 43.4v-401.6c0-20.8 17-37.8 38-37.8s38 17 38 37.8v233.2c0 8.8 7.2 16 16 16s16-7.2 16-16v-297c-0-20.8 17-38 38-38zM545.8 96c-38.6 0-69.8 31.2-69.8 69.8v5.2c-10-7-24-11.2-38-11.2-38.6 0-70 31.4-70 69.8v331c-38-33.8-70.4-49-100.6-49-21.8 0-41.6 8.2-58.6 24.2l-0.8 0.4c-11.4 11.4-27.4 36.4-5 76.2 10.2 17.8 26.4 36.4 43.6 56 2.6 3 5.4 6.2 8.2 9.2 7 8 17.2 21 29.2 36 46.2 58.4 116.2 147.2 181.8 187 7.6 5.2 42.2 27.4 90.6 27.4h103c50 0 94.8-22 126.2-60.8 30.4-37 46.4-87.8 46.4-145.2v-428.6c0-38.4-31.4-69.8-70-69.8-14 0-26 4.2-38 11.2v-37.2c0-38.4-31.6-69.8-70.2-69.8-15.8 0-30.4 5.2-42.2 14.2-9.8-26.8-35.6-46-65.8-46v0z"],"grid":0,"tags":["ios-hand-outline"]},{"paths":["M790 234c-23.2 0-42 18.4-42 41v218c0 9.6-9.2 17.2-19 17.2s-19-7.8-19-17.2v-321.4c0-22.6-18.8-41-42-41s-42 18.4-42 41v252.4c0 9.6-7.2 17.2-17 17.2s-17-7.8-17-17.2v-287c0-22.6-18.8-41-42-41s-42 18.4-42 41v321.6c0 9.6-8.2 17.2-18 17.2s-18-7.8-18-17.2v-252.6c0-22.6-20.8-41-44-41s-44 18.4-44 41v434.8l-51.8-47.2c-52.2-45.2-96.6-64.6-132.6-31.2-24.2 23.4 13.8 61.6 53.4 106 38.4 42.8 140 184.6 226.4 235.2 0 0 33.4 24.4 81.2 24.4s114.4 0 114.4 0c92.2 0 156.8-79 156.8-189v-464c0.2-22.4-18.6-41-41.8-41z"],"grid":0,"tags":["ios-hand"]},{"paths":["M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416v0z","M704 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M416 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M512 738c96.6 0 177-70 193-162h-386c16 92 96.4 162 193 162z"],"grid":0,"tags":["ios-happy-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM656 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM368 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM512 738c-96.6 0-177-70-193-162h386.2c-16.2 92-96.6 162-193.2 162z"],"grid":0,"tags":["ios-happy"]},{"paths":["M688 423.6c-8.8 0-16-7.2-16-16 0-80-77.4-144-160-144s-160 64-160 144c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-50 23.6-88.6 59.2-123.2 35.2-34.2 82.4-52.8 132.8-52.8s97.6 18.8 132.8 52.8c35.6 34.4 59.2 73 59.2 123.2 0 8.8-7.2 16-16 16z","M816 520h-48v-95.6c0-140.8-115.2-256-256-256v0 0c-140.8 0-256 115.2-256 256v95.6h-48c-79.2 0-144 64.8-144 144v31.6c0 79.2 64.8 144.4 144 144.4h48c0 8 7.2 15.8 16 15.8s16-7.4 16-16.2v-415.2c0-59.6 23.4-115.8 65.8-158.2s98.6-65.8 158.2-65.8c60 0 115.8 23.4 158.2 65.8s65.8 98.6 65.8 158.2v415.2c0 8.8 7.2 16.2 16 16.2s16-7.8 16-15.8h48c79.2 0 144-65.2 144-144.4v-31.6c0-79.2-64.8-144-144-144zM256 808h-48c-29.8 0-57.8-11.8-79-33.2s-33-49.4-33-79.2v-31.6c0-29.8 11.6-57.8 33-79s49.2-33 79-33h48v256zM928 695.6c0 29.8-11.6 58-33 79.2s-49.2 33.2-79 33.2h-48v-256h48c29.8 0 57.8 11.6 79 33s33 49.2 33 79v31.6z"],"grid":0,"tags":["ios-headset-outline"]},{"paths":["M816 520h-48v-95.6c0-140.8-115.2-256-256-256v0 0c-140.8 0-256 115.2-256 256v95.6h-48c-79.2 0-144 64.8-144 144v31.6c0 79.2 64.8 144.4 144 144.4h48c0 8 7.2 15.8 16 15.8s16-7.4 16-16.2v-413.6c16.4 0 42 0 48 0 8.8 0 16-8 16-16.8 0-80 77.4-144.8 160-144.8s160 64.6 160 144.6c0 8.8 7.2 17.2 16 17.2 5.8 0 31 0 48 0v413.6c0 8.8 7.2 16.2 16 16.2s16-7.8 16-15.8h48c79.2 0 144-65.2 144-144.4v-31.8c0-79.2-64.8-144-144-144z"],"grid":0,"tags":["ios-headset"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM783.6 240.4c35.2 35.2 63 76.4 82.4 122 5.4 12.6 10 25.6 14 38.8l-202.2 13.6c-16.4-28-39.8-51.4-67.8-68l13-202.6c13 4 26 8.6 38.6 14 45.6 19.4 86.6 47 122 82.2zM896 512c0 27-2.8 53.4-8.2 79.2l-195.2-14c7.4-20.4 11.4-42.4 11.4-65.4 0-22.8-4-44.8-11.4-65.2l195.2-14c5.4 26 8.2 52.4 8.2 79.4zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160c0 88.2-71.8 160-160 160zM128 512c0-27 2.8-53.4 8.2-79.2l195.2 14c-7.4 20.4-11.4 42.2-11.4 65.2 0 22.8 4 44.8 11.4 65.2l-195.2 14.2c-5.4-26-8.2-52.4-8.2-79.4zM591.2 136.2l-13.6 195.4c-20.4-7.4-42.6-11.6-65.6-11.6s-45 4-65.6 11.4l-13.8-195.2c25.8-5.4 52.4-8.2 79.2-8.2 27.2 0 53.6 2.8 79.4 8.2zM240.4 240.4c35.2-35.2 76.4-63 122-82.4 12.6-5.4 25.6-10 38.6-14l13 202.6c-27.8 16.6-51.2 40-67.8 67.8l-202.2-13.4c4-13 8.6-26 14-38.6 19.6-45.6 47.2-86.6 82.4-122zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-5.4-12.6-10-25.6-14-38.6l202.6-13c16.4 27.8 39.8 51 67.6 67.6l-13.2 202.4c-13-4-26-8.6-38.6-14-45.6-19.6-86.6-47.2-122-82.4zM432.8 887.8l14-195.2c20.4 7.4 42.4 11.4 65.2 11.4 23 0 45.2-4 65.8-11.6l13.6 195.4c-25.8 5.4-52.4 8.2-79.2 8.2-27.2 0-53.6-2.8-79.4-8.2zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-12.6 5.4-25.6 10-38.6 14l-13.4-202.2c28.2-16.6 51.6-40.2 68.2-68.4l202.2 13.6c-4 13-8.6 26-14 38.8-19.6 45.4-47.2 86.4-82.4 121.8z"],"grid":0,"tags":["ios-help-buoy-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM783.6 240.4c35.2 35.2 63 76.4 82.4 122 5.4 12.6 10 25.6 14 38.8l-202.2 13.6c-16.4-28-39.8-51.4-67.8-68l13-202.6c13 4 26 8.6 38.6 14 45.6 19.4 86.6 47 122 82.2zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160 160 71.8 160 160c0 88.2-71.8 160-160 160zM240.4 240.4c35.2-35.2 76.4-63 122-82.4 12.6-5.4 25.6-10 38.6-14l13 202.6c-27.8 16.6-51.2 40-67.8 67.8l-202.2-13.4c4-13 8.6-26 14-38.6 19.6-45.6 47.2-86.6 82.4-122zM240.4 783.6c-35.2-35.2-63-76.4-82.4-122-5.4-12.6-10-25.6-14-38.6l202.6-13c16.4 27.8 39.8 51 67.6 67.6l-13.2 202.4c-13-4-26-8.6-38.6-14-45.6-19.6-86.6-47.2-122-82.4zM783.6 783.6c-35.2 35.2-76.4 63-122 82.4-12.6 5.4-25.6 10-38.6 14l-13.4-202.2c28.2-16.6 51.6-40.2 68.2-68.4l202.2 13.6c-4 13-8.6 26-14 38.8-19.6 45.4-47.2 86.4-82.4 121.8z"],"grid":0,"tags":["ios-help-buoy"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M519.2 292c-86.4 0-134.6 40.6-135.2 124.4h37.6c-1.2-60.8 31-93 95.8-93 46.4 0 85.2 32.4 85.2 79.6 0 30.6-16.6 55.4-38.8 76.2-45.2 41.6-58 72-60.2 129h38c2.2-51.6 1-61.4 46.6-106.6 30.4-28.4 51.8-56.6 51.8-100.4-0-68.4-54.8-109.2-120.8-109.2z","M520.6 664.6c-18.8 0-34 15-34 33.6s15.2 33.8 34 33.8c18.8 0 34-15 34-33.8 0-18.6-15.2-33.6-34-33.6z"],"grid":0,"tags":["ios-help-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"],"grid":0,"tags":["ios-help-circle"]},{"paths":["M520.6 732c-18.8 0-34-15-34-33.8 0-18.6 15.2-33.6 34-33.6s34 15 34 33.6c0 18.8-15.2 33.8-34 33.8zM588.2 501.4c-45.6 45-44.4 54.8-46.6 106.6h-38c2.2-57 15-87.4 60.2-129 22-20.6 38.8-45.4 38.8-76.2 0-47.2-38.8-79.8-85.2-79.8-64.8 0-97 32.8-95.8 92.8h-37.6c0.6-84 48.8-124.2 135.2-124.2 66 0 120.8 40.8 120.8 109.2 0 43.8-21.4 72.4-51.8 100.6z"],"grid":0,"tags":["ios-help"]},{"paths":["M760.8 327.2c-12.8-6.2-24.8-9.2-24.8-9.2 0-123.8-100.2-226-224-226s-224 102.4-224 226.2c0 0-11.4 1.8-24.8 8.8-24.4 12.8-39.4 39.6-39.4 69 0 44.2 35.8 80 80 80 25 0 63.4-11.6 78.2-29.6 30.6 30.2 75.6 45.6 129.8 45.6s99.4-15.4 129.8-45.6c14.6 18 53 29.6 78.2 29.6 44.2 0 80-35.8 80-80 0.2-29.2-17.4-58.2-39-68.8zM720 444c-9 0-21.4-2.4-32.4-6.2-12.8-4.6-21-11.6-21-11.6-10.4-6.8-22.2-27.4-22.2-27.4l-25 24.8c-24 23.8-61 36.4-107.4 36.4-46.2 0-83.4-12.6-107.4-36.4l-25-24.8c0 0-9.2 17.8-22.2 27.4-4 3-8.2 7-21 11.6-10.8 3.8-23.2 6.2-32.4 6.2-26.6 0-48-21.6-48-48 0-16.4 8-31.2 21.4-40 0 0 8.2-5 16.2-7.8 9.2-3 16.8-4 16.8-4 20.2 15.6 42.8 21 42.8 21-17.4-12-32.8-43.4-32.8-43.4v-3.8c0-51.6 20-100.2 56.4-137 36-36.6 84.2-57 135.2-57s99.2 20.2 135.6 57c36.4 36.8 56.4 85.6 56.4 137v4.2c0 0-14 31.2-31.2 43.2 0 0 22.4-5.4 42.6-20.8 0 0 7-0.4 15 2.6s16.2 9 16.2 9c13.4 9 21.4 23.6 21.4 40 0 26.2-21.6 47.8-48 47.8z","M382.2 480.4c-0.2 0.2-0.4 0.4-0.6 0.6l0.6-0.6c0.2 0.2 0 0 0 0z","M642 480.4c-30.6 30.2-75.8 45.6-130 45.6-54 0-99.2-15.2-129.6-45.4l-0.8 0.4c-8 9.4-22.4 17-37.8 22l109.8 375c1.8 5.2 19 54 58.6 54 18.2 0 35-11.8 47.4-29.4 7.4-10.6 11.2-22.8 11.8-24.8l110.6-374c-16.4-5.4-32-13.4-40-23.4zM512.2 567.4l71.6 49.2-71.6 49.2-71.6-49.2 71.6-49.2zM395.6 585.6l-21.4-69.6 10-6c19 20.8 72.2 36.2 103.6 40.4l1 0.6-85.8 59-7.4-24.4zM410.6 637.2l6.4-4.4 71.6 49.2-54.2 37.2-23.8-82zM466.2 828.6l-11.2-38.6 33.6 23.2-22.4 15.4zM512.2 906c-22.6 0-34.2-36.8-34.2-36.8l-2-7.6 36.2-26.2 36.4 26.4-1.8 7.2c-0 0.2-11.4 37-34.6 37zM558.6 828.8l-22.8-15.6 34.2-23.6-11.4 39.2zM581.8 749l-69.6 48-69-47.4-0.8-3 70-48 70.4 48.4-1 2zM590.4 719.6l-54.6-37.6 71.6-49.2 7 4.8-24 82zM629.6 585l-7.4 25.4-14.8-10.2-71.6-49.2 1-0.6c31.2-4.2 74-16.4 103.4-37.6l8 5.2-18.6 67z"],"grid":0,"tags":["ios-ice-cream-outline"]},{"paths":["M438.4 801.8l14.4 44.8 28.8-18z","M571.8 846.8l14.6-45.6-44 27.4z","M481.6 523.8l-1.2-0.8c-40.2-5-73.8-19.6-98.2-43.8-8.2 10-23.6 18-40 23.2l19.8 61.6 9.2 28.4 18.4-11.4 92-57.2z","M389.4 619l-8.2 5 30.8 95.6 69.6-43.4z","M512 695.2l-92.2 57.2 3.4 2.2 88.8 55.2 92.2-57.4-1.6-1z","M604.2 600l-92.2-57.2-92.2 57.2 92.2 57.4z","M641.8 479.4c-24.4 24.2-58 38.8-98.2 43.8l-1.2 0.8 111.2 69.2 9.6-29.6 19.6-60.6c-16.8-5.4-32.6-13.4-41-23.6z","M462.8 878l5.2 16c0 0 15 38 44 38 30 0 44.4-38 44.4-38l5-15.6-49.4-31-49.2 30.6z","M542.4 676.2l70.2 43.8 31-95.6-9-5.4z","M760.8 327.8c-22 25.4-56.2 33.6-56.2 33.6 17.4-12 31.2-43.2 31.2-43.2 0-0.6 0-1 0-1.6 0.2-124-100-224.6-223.8-224.6s-224 101.4-224 225.4c0 0.6 0 2.6 0 2.6h0.6c0 0 14 30.2 31.2 42.2 0 0-34.4-8.6-56.4-34.2-23.6 14-39.6 39.4-39.6 69 0 44.2 35.8 80 80 80 25 0 63.4-11.6 78.2-29.8 30.6 30.4 75.6 45.6 129.8 45.6s99.4-15.4 129.8-45.8c14.6 18.2 53 29.6 78.2 29.6 44.2 0 80-36 80-80.2 0.2-29-15.6-54.6-39-68.6z"],"grid":0,"tags":["ios-ice-cream"]},{"paths":["M128 128v768h768v-768h-768zM864 864h-706v-704h706v704z","M640 352c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M192 192v512h640v-512h-640zM589.2 672h-282.4l141.2-200.4 141.2 200.4zM576.8 598.8l44.6-63.2 96 136.4h-89.2l-51.4-73.2zM800 672h-43.4l-135.2-192-64.2 91-109.2-155-180.2 256h-43.8v-448h576v448z"],"grid":0,"tags":["ios-image-outline"]},{"paths":["M895.6 128.4l-767.6-0.4v768h768v-768l-0.4 0.4zM864 864h-704v-704h704v704z","M832 192h-640v512h640v-512zM608.4 319.6c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32c0-17.8 14.4-32 32-32zM307 672l141.4-201 141.6 201h-283zM629.2 672.2v0l-51.8-73.8 44.6-63.2 96.4 137h-89.2z"],"grid":0,"tags":["ios-image"]},{"paths":["M780.8 243.8l-12.8-179.8-704 48 46.6 639.8 44.4-3.2-11 157.8 768 53.6 48-704-179.2-12.2zM138.4 717.8l-40.2-574.6 640.4-44.8 10 143.2-32.2-2.2-7.4-107-574.8 40.4 30.6 436.4-7.6 107.2-18.8 1.4zM193.2 204l-12.4 175.8-12.4-177.4 510.8-35.8 5 70.6-491-33.2zM881.2 925.8l-705-49.2 44.6-638.6 705 49.2-44.6 638.6z","M720.597 465.539c-17.631-1.234-30.923-16.527-29.689-34.158s16.527-30.923 34.158-29.689c17.631 1.234 30.923 16.527 29.689 34.158s-16.527 30.923-34.158 29.689z","M252.6 272.4l-31.2 447 639 44.6 31.2-447-639-44.6zM338.2 695.4l155-190.2 126.8 209.8-281.8-19.6zM659.2 717.8l-46.4-76.6 49-60 86.4 142.8-89-6.2zM830.6 729.8l-43.4-3-121.6-201-70.4 86.4-98.2-162.4-197.8 242.8-43.6-3 26.8-383.2 575.2 40.2-27 383.2z"],"grid":0,"tags":["ios-images-outline"]},{"paths":["M780.8 243.8l-12.8-179.8-704 48 46.6 639.8 44.4-3.2-11 157.8 768 53.6 48-704-179.2-12.2zM138.4 717.8l-40.2-574.6 640.4-44.8 10 143.2-32.2-2.2-7.4-107-574.8 40.4 30.6 436.4-7.6 107.2-18.8 1.4zM881.2 925.8l-705-49.2 44.6-638.6 705 49.2-44.6 638.6z","M252.6 272.4l-31.2 447 639 44.6 31.2-447-639-44.6zM338.2 695.4l155-190.2 126.8 209.8-281.8-19.6zM659.2 717.8l-46.4-76.6 49-60 86.4 142.8-89-6.2zM754.8 435.8c-1.2 17.6-16.6 31-34.2 29.6s-31-16.6-29.8-34.2c1.2-17.6 16.6-31 34.2-29.6 17.8 1.2 31.2 16.6 29.8 34.2z"],"grid":0,"tags":["ios-images"]},{"paths":["M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z","M544 688v-256h-96v16h32v240h-32v16h128v-16z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-information-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM503 304c22.2 0 40 18 40 40s-18 40-40 40c-22 0-40-18-40-40s17.8-40 40-40zM576 704h-128v-16h32v-240h-32v-16h96v256h32v16z"],"grid":0,"tags":["ios-information-circle"]},{"paths":["M543 344c0 22.091-17.909 40-40 40s-40-17.909-40-40c0-22.091 17.909-40 40-40s40 17.909 40 40z","M544 688v-256h-96v16h32v240h-32v16h128v-16z"],"grid":0,"tags":["ios-information"]},{"paths":["M851 269.6c9.4-11.8 15-27 15-43.2 0-38.4-31.2-69.8-69.6-69.8-16.4 0-31.4 5.6-43.2 15-68-48.4-150-75.6-239.8-75.6-229.8-0-417.4 185-417.4 415.2s187.4 416.8 417.2 416.8 414.8-186.6 414.8-416.8c0-90-28.6-173.4-77-241.6zM783.6 783.4c-35.2 35.2-76.4 63.2-122.2 82.6-47.4 20-96.4 30.4-148.4 30.4-51.8 0-103.4-10.2-150.8-30.4-45.8-19.4-86.8-47-122.2-82.6-35.2-35.2-63-76.6-82.4-122.4-20-47.4-30.2-97.8-30.2-149.8 0-51.8 10.2-102.4 30.2-149.8 19.4-45.8 47-87 82.4-122.4s76.4-63.2 122.2-82.6c47.4-20 98.8-28.2 150.8-28.2 51.8 0 101 8 148.4 28.2 25.4 10.8 49.4 24.2 71.8 40-4.2 9-6.6 19-6.6 29.8 0 38.4 31.2 69.8 69.6 69.8 10.6 0 20.6-2.4 29.8-6.6 15.8 22.4 29.2 46.4 40 72 20 47.4 30.2 97.8 30.2 149.8 0 51.8-10.2 102.4-30.2 149.8-19.4 45.8-47 87-82.4 122.4z","M513 320.2c-106 0-192 85.6-192 191.8s85.8 192.2 192 192.2c106 0 192-86 192-192.2s-86-191.8-192-191.8z"],"grid":0,"tags":["ios-ionic"]},{"paths":["M935.4 538.4c-8.6-61.8-28.8-114.6-67.6-114.6l-15.2 0.2c-61.2-124-188.4-207-333.2-207-7 0-14 0.2-21 0.6-171.6 9.6-309.4 133.4-343.4 293.6l-22.8 3.2c-34.4 4.8-53.8 69.6-43.2 145 10 72.4 44.2 128 77.2 128 1.4 0 2.8 0 4-0.2l31.4-4.4c65.8 107 184.2 177.4 317 177.4 7 0 14-0.2 21-0.6 170.4-9.4 307.6-131.8 342.8-290.4l14.8-0.8c30.4-5 47.6-62.8 38.2-130zM212.4 748.8l-46.2 6.4c-2.2-0.6-11.2-6-21.6-24.4-11.4-20-19.8-47-23.8-76s-3.2-57.2 2.2-79.6c5-20.4 12.2-28 14.2-29.4l43.2-6c14.4 25.8 27.2 60 33 98.6 6 41.8 8 81.4-1 110.4zM902.2 610.6c-3.6 16-8.6 23.6-11 26l-35 2-5.2 23.6c-8 35.8-21.6 69.8-40.6 101.4-18.8 31-42.2 58.8-69.8 82.4-57.2 49.2-127.4 77.4-202.8 81.6-6.4 0.4-12.8 0.6-19.2 0.6-58.8 0-116.8-15.4-167.8-44.4-49.8-28.4-92-69-121.8-117.8l-10.2-16.6c16-23.8 25.6-63.2 19.2-115-5.6-45.2-30.8-81-54.8-101.6l3.2-14.8c15.2-71.6 54.2-137.4 109.8-185.8 57.4-49.8 128.2-78.2 204.2-82.4 6.4-0.4 13.6-0.6 19.6-0.6 64.4 0 126.4 18 180.6 52 53.2 33.4 95.8 80.8 123.4 137l7.2 15c16.2 38 25 74.2 27.8 115 3-50.6-4.2-85.4-14.2-112l23-0.2c6.8 0 13.8 11.8 16.6 17 8.4 16 15 40.2 19.2 70.2 3.4 24.2 3 48.2-1.4 67.4z","M543.961 698.821c16.985-0.944 31.519 12.059 32.464 29.044s-12.059 31.519-29.044 32.464c-16.985 0.944-31.519-12.059-32.464-29.044s12.059-31.519 29.044-32.464z","M705.6 689.6c-17 1-30 15.4-29 32.4s15.4 30 32.4 29c17-1 30-15.4 29-32.4-0.8-17-15.4-30-32.4-29z","M336 147.2c4.2 2.8 10 4.8 17.2 6 5 0.8 10.6 1.2 16.6 1.2 2.4 0 4.8 0 7.2-0.2 2 0 3.8-0.2 5.8-0.4-0.8-0.8-1.6-1.8-2.4-2.6-0.8 0-1.8 0-2.6 0s-1.6 0-2.4 0c-7.6 0-14.8-0.6-20.8-1.8-7-1.4-13.4-4.2-16.8-6.8-3.2-2.8-2.6-7.4-2.6-7.4 0.6-5.2 4.8-9.6 10.8-14.8 5.4-4.6 12.8-9.4 21.6-14l6.2-3c-1.6 6.6-1.8 13.8-0.4 21 4.2 21.8 21.8 37.8 42.8 40.8l9.4 46.2 31.6-6.4-9.2-45.6c18.8-10.2 29.6-31.6 25.6-53.8-1.4-7-4-13.4-7.8-19-3.6-0.6-8.6-1-14.4-1-11.2 0-26.2 1.2-44 5.2 2.2-0.6 4.2-1.4 6.4-2 15.2-4.2 29-7 43-8.4 17.2-2 30-0.6 33.2-0.2s6 1 8.6 1.8c-1.6 2.4-2.4 5.4-2.4 8.4 0 6.6 4.2 12.4 10 14.8-0.4 0.6-1 1.2-1.4 1.8-1.6 1.8-3.6 3.8-5.8 5.6s-4.4 3.6-7 5.4l-13 7.6c-0.2 1-0.4 2-0.6 3 0.2 0 0.4-0.2 0.4-0.2l16.6-9.4c2.4-1.6 4.8-3.2 6.8-4.8 2.4-1.8 4.4-3.6 6.2-5.6 0.6-0.6 1.4-1.4 2-2 0.6 0 1.2 0 1.8 0 8.8 0 16-7.2 16-16s-7.2-16-16-16c-3.2 0-6.2 1-8.8 2.6-3.6-1.6-7.2-2.6-12.8-3.6s-23.6-2.4-39.2-0.6c-6.2-4.6-17.8-8.4-27.8-8.4-3.2 0-6.2 0.2-9.4 0.8-15.8 3-28.4 13-35.4 26 0 0-23.4 9-39.2 23.4-6.4 5.8-10 12.8-10.6 16.6-1.4 5.8 0.6 11.6 7 15.8zM423.2 92.6c11.6 0 21 9.4 21 21s-9.4 21-21 21c-11.6 0-21-9.4-21-21s9.4-21 21-21z"],"grid":0,"tags":["ios-ionitron-outline"]},{"paths":["M935.4 538.4c-9-64-30.4-118.4-71.8-114.6 12.8 29.2 27 70.4 23.4 144-2.8-51.8-12.6-100.4-34.2-144-64-129.2-201-214.8-354.4-206.2-171.6 9.6-309.4 133.4-343.4 293.6l-22.8 3.2c-34.4 4.8-53.8 69.8-43.2 145 10.6 75.4 47 132.4 81.4 127.6l31.4-4.4c69.2 112.6 196.6 184.6 338 176.8 170.4-9.4 307.6-131.8 342.8-290.4l14.8-0.8c30.2-5 47.4-62.8 38-129.8zM180.4 528c21.4 16.4 44.6 56.6 52.2 110.2 7.8 55.4-3.6 108.2-20.8 128.6 12-29.6 16-74.6 9.4-123.8-6.6-48-22-89.4-40.8-115zM547.6 760.4c-17 1-31.6-12-32.4-29-1-17 12-31.4 29-32.4s31.6 12 32.4 29c1 17-12 31.4-29 32.4zM709.2 751c-17 1-31.6-12-32.4-29-1-17 12-31.4 29-32.4s31.6 12 32.4 29c1 17-12 31.6-29 32.4z","M330.6 140c0 0 0 0.2 0 0 0.2 0.2 0.2 0.4 0.2 0.4s0 0 0 0c0.2 0.4 0.4 0.6 0.6 1 0 0 0 0.2 0 0.2 0.8 2 2.2 3.8 4.6 5.4 4 3 10 4.8 17.2 6 6.8 1 15 1.4 23.8 1 2 0 3.8-0.2 5.8-0.4-0.8-0.8-1.6-1.8-2.4-2.6-0.8 0-1.8 0-2.6 0-8.6 0.2-16.4-0.4-23.2-1.8-7-1.4-12.8-3.6-16.8-6.8-1.2-1-2-1.8-2.6-2.8-0.4-1.4-0.4-3 0-4.6 1-4.6 4.8-9.6 10.8-14.8 5.4-4.6 12.8-9.4 21.6-14 1.6-0.8 3.4-1.8 5.2-2.6 0.2-0.2 0.6-0.2 1-0.4-1.6 6.6-1.8 13.8-0.4 21 4.6 23.8 25 40.6 48.4 41.2l10 52.6 21.4-4-10-52.6c21.6-9.2 34.6-32.2 30-56-1.4-7-4-13.4-7.8-19-10.6-1.6-31.2-1.6-58.4 4.2 2.2-0.6 4.2-1.4 6.4-2 15.2-4.2 29.8-7 43-8.4 1.2-0.2 2.4-0.2 3.6-0.4 2.4-0.2 4.6-0.4 7-0.6 0.4 0 0.8 0 1.2 0 8-0.4 15.4-0.2 21.6 0.6 4.8 0.6 8.8 1.6 12.2 2.8-1.2 1.8-1.8 4-1.8 6.4 0 5.4 3.6 10 8.6 11.6 0 0 0 0 0 0-1.2 1.8-2.6 3.8-4.2 5.6s-3.6 3.8-5.8 5.6c-2.2 1.8-4.4 3.6-7 5.4l-13 7.6c-0.2 1-0.4 2-0.6 3 0.2 0 0.4-0.2 0.4-0.2l16.6-9.4c2.4-1.6 4.8-3.2 6.8-4.8 2.4-1.8 4.4-3.6 6.2-5.6 1.8-1.8 3.4-3.8 4.8-5.6 0.2-0.4 0.4-0.8 0.6-1.2 6-0.8 10.8-5.8 10.8-12 0-6.8-5.4-12.2-12.2-12.2-2 0-3.8 0.6-5.4 1.4-4-2.4-9.6-4.2-16.4-5.4-8.6-1.6-19-2-31-1.2-1.4 0-2.8 0.2-4.2 0.4s-2.6 0.4-4 0.4c-10.6-7-23.8-10-37.2-7.4-15.8 3-28.4 13-35.4 26-2.6 1-5.2 2.2-7.6 3.4-1.4 0.6-2.6 1.2-4 1.8-11.8 5.8-21.2 12.2-27.8 18.2-6.2 5.8-9.8 11.4-10.6 16.6-0.4 2.8 0 5.6 1.4 8 0.2 0.2 0.4 0.6 0.6 1z"],"grid":0,"tags":["ios-ionitron"]},{"paths":["M928 96c0 0-39.6 2.8-106.2 54.4-31 24-324.4 241.2-324.4 241.2l-319.4-15.8-82 73 204 102.4-16 20.2-163.2 8.2-13.4 67.2 121.2 94.4-53.4 107.2 107.4-53 94.6 121.2 67.2-13.4 8.2-163.2 20.2-15.8 102.4 203.8 73-81.8-15.8-319.4c0 0 217.2-293.4 241.2-324 51.8-67.2 54.4-106.8 54.4-106.8zM848.6 183.2l-248.4 333.8 15.6 317.6-33 37-81.4-161.8-17.6-34.8-62.6 49-7.8 152.8-23.4 4.6-98.4-126.2-45.6 22.4 22.8-45.6-126.2-98.4 4.6-23.4 152.8-7.8 49.6-62.2-35.2-17.6-161.8-81.4 37-33 317.8 15.6 334-248.2c9-7 17.4-13 25.2-18-5 7.8-11 16.4-18 25.6z"],"grid":0,"tags":["ios-jet-outline"]},{"paths":["M928 96c0 0-39.6 2.8-106.2 54.4-31 24-324.4 241.2-324.4 241.2l-319.4-15.8-82 73 204 102.4-16 20.2-163.2 8.2-13.4 67.2 121.2 94.4-53.4 107.2 107.4-53 94.6 121.2 67.2-13.4 8.2-163.2 20.2-15.8 102.4 203.8 73-81.8-15.8-319.4c0 0 217.2-293.4 241.2-324 51.8-67.2 54.4-106.8 54.4-106.8z"],"grid":0,"tags":["ios-jet"]},{"paths":["M685.2 436.2c-26.6 0-52.2 0-76.2 8.2-103.2-86.2-375.6-313.8-396.4-335-9.6-9.8-20.2-13.4-30.6-13.4-17.4 0-34 10.4-43.4 19.2-14 13.2-51.2 53.6-41 64 30.6 30.8 54.8 53 67.4 65.6 9.6 9.6 26.8-1.6 39.2 6.6 11 7.2 20 19.8 29.2 29 10.6 10.8 18 15.6 17.8 31.4-0.2 16.6 1 27.6 12.6 40 9.4 10 18.2 15.2 31.8 15.4 18.4 0.4 29.8 4.8 41.8 19.8 11.4 14.2 4.2 28.4 9.8 44 3.6 10.2 32 36.2 36 40.2s22 0 26.6 4.6 34.4 31.6 36.4 40.8-6 18-4 27.2c2.4 11.2 14.4 24.2 21.2 34.8-13.6 31-21.2 65.2-21.2 101.4 0 137 108.8 248 242.8 248s243-111 243-248-108.8-243.8-242.8-243.8zM685.2 896c-116.4 0-211-97-211-216 0-30.8 6.2-60.6 18.4-88.4l7-15.8c0 0-15.4-26.8-20.8-32.4-5.4-5.4 4.4-26.2-1.2-33.2-5.8-7-39.2-50.4-49.4-60.6s-28-3.6-33.4-9c-5.4-5.4-14.6-15.8-17.4-20.8-0.4-1.6-0.4-4.8-0.6-7.6-0.2-10.4-0.6-28-14.2-44.8-17.2-21.6-37-31-65.8-31.8-3.2 0-4.4-0.2-9.4-5.4-3.2-3.4-4-4.4-4-17.8 0.2-27.4-13.4-40.8-23.2-50.4l-38.2-37.2c-15.4-10.2-30.2-10.4-39.8-10.4-2.6 0-5.2 0-6.8-0.4l-43.6-45.4c2-6 15.4-17.8 21.2-23 2.8-2.4 5.2-4.8 7.8-7 5.6-5.2 14.8-10.6 21.6-10.6 2 0 4.2 0.2 7.8 3.8 20.8 21.2 258.8 220.4 398.8 337.2l13.6 11.4 16.8-5.6c19.2-6.4 41.8-6.4 66-6.4 56.6 0 109.6 21.8 149.2 61.2 39.8 39.6 61.6 93.2 61.6 150.6 0 118.8-94.6 215.8-211 215.8z","M768 704c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64c0-35.4-28.6-64-64-64zM768 800c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"],"grid":0,"tags":["ios-key-outline"]},{"paths":["M768 736c-17.6 0-32 14.4-32 32s14.4 32 32 32 32-14.4 32-32-14.4-32-32-32z","M685.2 436.2c-26.6 0-52.2 0-76.2 8.2-103.2-86.2-375.6-313.8-396.4-335-9.6-9.8-20.2-13.4-30.6-13.4-17.4 0-34 10.4-43.4 19.2-14 13.2-51.2 53.6-41 64 30.6 30.8 54.8 53 67.4 65.6 9.6 9.6 26.8-1.6 39.2 6.6 11 7.2 20 19.8 29.2 29 10.6 10.8 18 15.6 17.8 31.4-0.2 16.6 1 27.6 12.6 40 9.4 10 18.2 15.2 31.8 15.4 18.4 0.4 29.8 4.8 41.8 19.8 11.4 14.2 4.2 28.4 9.8 44 3.6 10.2 32 36.2 36 40.2s22 0 26.6 4.6 34.4 31.6 36.4 40.8-6 18-4 27.2c2.4 11.2 14.4 24.2 21.2 34.8-13.6 31-21.2 65.2-21.2 101.4 0 137 108.8 248 242.8 248s243-111 243-248-108.8-243.8-242.8-243.8zM768 832c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64c0 35.4-28.6 64-64 64z"],"grid":0,"tags":["ios-key"]},{"paths":["M896 735v-476.8c0-18.8-15.8-34.2-34.4-34.2h-699.2c-18.6 0-34.4 15.2-34.4 34.2v476.8h-96.2v31.2c0 6.2 62 33.8 104.2 33.8h752c48.6 0 104-28.2 104.2-33v-32h-96.2zM512 240c4.4 0 8 3.6 8 8s-3.6 8-8 8-8-3.6-8-8c0-4.4 3.6-8 8-8zM160 272.4h704v430.6h-704v-430.6zM596.6 751c0 0-158.6 0-169.2 0s-19.4-12-19.4-15h208c0 3-6 15-19.4 15z"],"grid":0,"tags":["ios-laptop"]},{"paths":["M907.8 765.4c-103.6-16-109.8-25.4-109.8-25.4 31.2-148-46.4-308.2-154.2-397.2-143.6-118.4-361.8-32.4-531.8-212.4-1.6-1.6-3-2.4-4.4-2.4-33.2 0-4 481 200.6 667.8 85.6 78.4 179.8 100.2 255.4 100.2 61.6 0 111-14.6 133.6-25 45.6-21.2 77.4-67.8 77.4-67.8 74 23.2 114.6 24.4 122.6 24.4 1 0 1.4 0 1.4 0 0.8 0.2 1.6 0.2 2.4 0.2 27.6-0 40.6-57.2 6.8-62.4zM683.8 842c-17.8 8.2-63 22-120 22-39.2 0-77.4-6.4-113.4-19-43.8-15.2-84.2-39.8-120.4-72.8-40.8-37.2-77.2-90.4-108-158-26.6-58-48.6-125-65.2-199-13.6-60-23-123.6-26.8-178.8-1.2-19-1.8-34.6-1.8-47.2 92.8 76.4 195.6 92.8 287.6 107.6 77.8 12.4 151.2 24.2 207.8 70.8 51 42.2 93.4 99.4 119.2 161.2 28 66.8 31.8 133.8 25.4 201.4-360-126-529-341-529-341s145 250.4 504.6 401.6c-10.2 13-26.6 35.6-60 51.2z"],"grid":0,"tags":["ios-leaf-outline"]},{"paths":["M907.8 765.4c-103.6-16-111.4-31.4-111.4-31.4 31.2-148-44.8-302.2-152.6-391.2-143.6-118.4-361.8-32.4-531.8-212.4-39.6-42-16.6 471 196.2 665.4 155.6 142 338.8 98.4 389 75.2 45.6-21.2 77.4-67.8 77.4-67.8 83 26 124 24.4 124 24.4 29.2 3.6 44-56.8 9.2-62.2zM724.2 772.2c-272.4-81.8-483.2-375-483.2-375s185.8 221.4 502.8 326.4c0.2 16.2-9.2 39.4-19.6 48.6z"],"grid":0,"tags":["ios-leaf"]},{"paths":["M557.2 693l-135.8 135.8c-30 30-70.2 46.6-113.2 46.6s-83-16.6-113.2-46.6c-30-30-46.6-70.2-46.6-113.2s16.6-83 46.6-113.2l135.8-135.8c7.8-7.8 16.2-14.6 25-20.4 10.2-6.8 21.2-12.2 32.6-16.4 10.6-3.8 21.6-6.6 33-8.2 7.4-1 14.8-1.6 22.4-1.6 3.4 0 6.8 0.2 10.2 0.4 39 2.4 75.2 18.6 103 46.2 27.6 27.6 43.8 64 46.2 103 10.8-2 21.4-5.4 31.2-10-4.4-42.2-22.8-83.4-55-115.6s-73.2-50.6-115.6-55c-11.4-1.2-23-1.4-34.4-0.6-12 0.8-23.8 2.8-35.4 6-12.2 3.2-24.2 7.6-35.6 13.4-18.2 9-35.4 21-50.6 36.2l-135.8 135.8c-74.6 74.6-74.6 196.8 0 271.6v0c74.6 74.6 196.8 74.6 271.6 0l135.8-135.8c15.2-15.2 27.2-32.2 36.2-50.6-12.8 2-25.6 3-38.4 3-5.4 9-12.2 17.4-20 25z","M851.4 172.6v0c-74.6-74.6-196.8-74.6-271.6 0l-135.8 135.8c-15.2 15.2-27.2 32.2-36.2 50.6 12.8-2 25.6-3 38.4-3 5.8-9 12.6-17.4 20.4-25l135.8-135.8c30-30 70.2-46.6 113.2-46.6s83 16.6 113.2 46.6c30 30 46.6 70.2 46.6 113.2 0 42.8-16.6 83-46.6 113.2l-135.8 135.8c-7.8 7.8-16.2 14.6-25 20.4-10.2 6.8-21.2 12.2-32.6 16.4-10.6 3.8-21.6 6.6-33 8.2-7.4 1-14.8 1.6-22.4 1.6-3.4 0-6.8-0.2-10.2-0.4-39-2.4-75.2-18.6-103-46.2-27.6-27.6-43.8-64-46.2-103-10.8 2-21.4 5.4-31.2 10 4.4 42.2 22.8 83.4 55 115.6v0c32.2 32.2 73.2 50.6 115.6 55 11.4 1.2 23 1.4 34.4 0.6 12-0.8 23.8-2.8 35.4-6 12.2-3.2 24.2-7.6 35.6-13.4 18.2-9 35.4-21 50.6-36.2l135.8-135.8c74.2-74.8 74.2-197-0.4-271.6z"],"grid":0,"tags":["ios-link-outline"]},{"paths":["M546 681.8l-135.8 135.8c-27 27-63.2 42-101.8 42s-74.8-14.8-101.8-42c-27-27-42-63.2-42-101.8s14.8-74.8 42-101.8l135.8-135.8c6.8-6.8 14.4-13 22.6-18.4 9.2-6 19-11 29.4-14.8 9.6-3.6 19.6-6 29.8-7.4 6.8-1 13.6-1.4 20.2-1.4 2.8 0 5.6 0.2 9.2 0.4 35 2.2 68 17 92.6 41.6 21.6 21.6 35.6 49.6 40.2 79.6 4.6-0.2 16.4-1 32.4-5.8s26.8-12.6 26.8-12.6c-6.6-42.4-23.2-75.6-54.2-106.4-30.8-30.8-71-51.2-114-58-3.8-0.6-7.4-1.2-11.2-1.6-7.2-0.8-14.6-1.2-22-1.2-5 0-10.2 0.2-15.4 0.6-10.8 0.8-21.4 2.4-32 4.8-2.2 0.4-4.2 1-6.4 1.6-13.4 3.6-26.4 8.4-38.6 14.4-20.2 10-38.8 23.2-54.8 39.2l-135.8 135.8c-39.2 39.2-60.6 91.4-60.6 147s21.6 108 60.6 147c39.2 39.2 91.4 60.6 147 60.6 55.8 0 108-21.6 147-60.6l135.8-135.8c14.4-14.4 26.4-30.8 36-48.6 0 0-22.4 5.4-47.2 5.4s-33.8-1.8-33.8-1.8z","M862.8 161.2c-39.2-39.2-91.4-60.6-147-60.6s-108 21.6-147 60.6l-135.8 135.8c-14.4 14.4-26.4 30.8-36 48.6 0 0 0 0 0 0 10.4-2.4 30.6-4.8 48-4.8s32.4 2.2 32.4 2.2l136.6-136.2c27-27 63.2-42 101.8-42s74.8 14.8 101.8 42c27 27 42 63.2 42 101.8s-14.8 74.8-42 101.8l-135.8 135.6c-6.8 6.8-14.4 13-22.6 18.4-9.2 6-19 11-29.4 14.8-9.6 3.4-19.6 6-29.8 7.4-6.8 1-13.6 1.4-20.2 1.4-2.8 0-5.6-0.2-9.2-0.4-35-2.2-68-17-92.6-41.6-21.2-21.2-35-48.4-39.8-77.6 0 0-13.2-1-31.4 4.6-11.4 3.4-23.2 8.4-28.4 11 6 43 22.8 75.4 54.2 107v0l0.4 0.4c33.4 33.4 78 54.6 125.2 59.6 7.2 0.8 14.6 1.2 22 1.2 5.2 0 10.2-0.2 15.4-0.6 12.8-1 25.8-3 38.2-6.4 13.4-3.6 26.4-8.4 38.6-14.4 20.2-10 38.8-23.2 54.8-39.2l135.8-135.8c39.2-39.2 60.6-91.4 60.6-147s-21.8-108.4-60.8-147.6z"],"grid":0,"tags":["ios-link"]},{"paths":["M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z","M384 304h384v32h-384v-32z","M384 496h384v32h-384v-32z","M384 688h384v32h-384v-32z","M320 320c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M320 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M320 704c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"],"grid":0,"tags":["ios-list-box-outline"]},{"paths":["M128 128v768h768v-768h-768zM288 736c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 544c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM288 352c-17.672 0-32-14.328-32-32s14.328-32 32-32 32 14.328 32 32-14.328 32-32 32zM768 720h-384v-32h384v32zM768 528h-384v-32h384v32zM768 336h-384v-32h384v32z"],"grid":0,"tags":["ios-list-box"]},{"paths":["M384 304h384v32h-384v-32z","M384 496h384v32h-384v-32z","M384 688h384v32h-384v-32z","M320 320c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M320 512c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M320 704c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"],"grid":0,"tags":["ios-list"]},{"paths":["M640 512c0 70.692-57.308 128-128 128s-128-57.308-128-128c0-70.692 57.308-128 128-128s128 57.308 128 128z","M944 496h-48.4c-8.2-199.4-168.2-359.4-367.6-367.6v-48.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.4c-199.4 8.2-359.4 168.2-367.6 367.6h-48.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.4c8.2 199.4 168.4 359.4 367.6 367.6v48.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.4c199.4-8.2 359.4-168.4 367.6-367.6h48.4c8.8 0 16-7.2 16-16s-7.2-16-16-16zM760.8 760.8c-62.8 62.8-144.8 98.8-232.8 102.8v-79.6c0-8.8-7.2-16-16-16s-16 7.2-16 16v79.6c-88-4-170.2-40-232.8-102.8-62.8-62.6-99-144.8-102.8-232.8h79.6c8.8 0 16-7.2 16-16s-7.2-16-16-16h-79.6c4-88 40-170.2 102.8-232.8s144.8-99 232.8-102.8v79.6c0 8.8 7.2 16 16 16s16-7.2 16-16v-79.6c88 4 170.2 40 232.8 102.8s99 144.8 102.8 232.8h-79.6c-8.8 0-16 7.2-16 16s7.2 16 16 16h79.6c-3.8 88-40 170.2-102.8 232.8z"],"grid":0,"tags":["ios-locate-outline"]},{"paths":["M768 512c0-8.8 7.2-16 16-16h111.6c-8.2-199.4-168.2-359.4-367.6-367.6v111.6c0 8.8-7.2 16-16 16s-16-7.2-16-16v-111.6c-199.4 8.2-359.4 168.2-367.6 367.6h111.6c8.8 0 16 7.2 16 16s-7.2 16-16 16h-111.6c8.2 199.4 168.4 359.4 367.6 367.6v-111.6c0-8.8 7.2-16 16-16s16 7.2 16 16v111.6c199.4-8.2 359.4-168.4 367.6-367.6h-111.6c-8.8 0-16-7.2-16-16zM512 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128-57.4 128-128 128z","M944 496h-48.4c0.2 5.4 0.4 10.6 0.4 16s-0.2 10.6-0.4 16h48.4c8.8 0 16-7.2 16-16s-7.2-16-16-16z","M128.4 496h-48.4c-8.8 0-16 7.2-16 16s7.2 16 16 16h48.4c-0.2-5.4-0.4-10.6-0.4-16s0.2-10.6 0.4-16z","M496 895.6v48.4c0 8.8 7.2 16 16 16s16-7.2 16-16v-48.4c-5.4 0.2-10.6 0.4-16 0.4s-10.6-0.2-16-0.4z","M528 128.4v-48.4c0-8.8-7.2-16-16-16s-16 7.2-16 16v48.4c5.4-0.2 10.6-0.4 16-0.4s10.6 0.2 16 0.4z"],"grid":0,"tags":["ios-locate"]},{"paths":["M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM336 304c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144h-352v-144zM800 896h-576v-416h576v416z","M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z"],"grid":0,"tags":["ios-lock-outline"]},{"paths":["M720 448v-144c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-112zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984zM688 448h-352v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v144z","M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z"],"grid":0,"tags":["ios-lock"]},{"paths":["M274 160h572c44.2 0 80 35.8 80 80v544c0 44.2-35.8 80-80 80h-572c-44.2 0-80-35.8-80-80 0-8.8 7.2-16 16-16s16 7.2 16 16c0 26.4 21.6 48 48 48h572c26.4 0 48-21.6 48-48v-544c0-26.4-21.6-48-48-48h-572c-26.4 0-48 21.6-48 48 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-44.2 35.8-80 80-80z","M632.6 493.4l-169.2-168.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l151.2 148.8h-478c-8.8 0-16 7.2-16 16s7.2 16 16 16h478l-147.4 148.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l165.2-164.8c12.6-12.6 12.6-28.8 0-41.2z"],"grid":0,"tags":["ios-log-in"]},{"paths":["M560 864h-384c-44.2 0-80-35.8-80-80v-544c0-44.2 35.8-80 80-80h384c44.2 0 80 35.8 80 80 0 8.8-7.2 16-16 16s-16-7.2-16-16c0-26.4-21.6-48-48-48h-384c-26.4 0-48 21.6-48 48v544c0 26.4 21.6 48 48 48h384c26.4 0 48-21.6 48-48 0-8.8 7.2-16 16-16s16 7.2 16 16c0 44.2-35.8 80-80 80z","M918.6 493.4l-169.2-168.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l151.2 148.8h-542c-8.8 0-16 7.2-16 16s7.2 16 16 16h542l-147.4 148.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3 7.2 4.6 11.4 4.6s8.2-1.4 11.4-4.6l165.2-164.8c12.6-12.6 12.6-28.8 0-41.2z"],"grid":0,"tags":["ios-log-out"]},{"paths":["M380.2 266.2c32.2 3.8 65.6 21.6 93.8 49.8l335.4 335.4 118.6-118.6-355.6-355.4c-108.6-108.6-286.4-108.6-395 0v0c-108.6 108.6-108.6 286.4 0 395l355.6 355.6 118.6-118.6-335.4-335.2c-28.8-28.8-46.8-61.8-50.8-93.2-4.2-32 6.2-60.8 30.6-85.2 23-23.2 52.2-33.4 84.2-29.6zM888.4 533l-79 79-59.2-59.2 79-79 59.2 59.2zM612 809.4l-79 79-59.2-59.2 79-79 59.2 59.2zM296.4 493.8l236.6 236.6-79 79-256.8-256.6c-47.2-47.4-73.2-110.4-73.2-177.8s26-130.4 73.2-177.8c47.2-47.2 110.4-73.2 177.8-73.2s130.4 26 177.8 73.2l256.6 256.8-79 79-236.6-236.6c-65.4-65.4-156-82-217.8-20.2-64 64-45 152.2 20.4 217.6z"],"grid":0,"tags":["ios-magnet-outline"]},{"paths":["M380.2 266.2c32.2 3.8 65.6 21.6 93.8 49.8l335.4 335.4 118.6-118.6-355.6-355.4c-108.6-108.6-286.4-108.6-395 0v0c-108.6 108.6-108.6 286.4 0 395l355.6 355.6 118.6-118.6-335.4-335.2c-28.8-28.8-46.8-61.8-50.8-93.2-4.2-32 6.2-60.8 30.6-85.2 23-23.2 52.2-33.4 84.2-29.6zM888.4 533l-79 79-59.2-59.2 79-79 59.2 59.2zM612 809.4l-79 79-59.2-59.2 79-79 59.2 59.2z"],"grid":0,"tags":["ios-magnet"]},{"paths":["M512 128l-384 256v512h768v-512l-384-256zM864 864h-704v-427.2l229.8 174.2-135.8 154.4 4 4 157.4-138.8 96.6 73.4 96.2-73.4 157.6 139 4-4-136-154.6 230-175.6v428.6zM512 663.6l-306.6-235.6h178.6v-6.4l-219.8-25.4-0.6-0.4 348.4-227.6 349.2 228-221.2 25.4v6.4h180.8l-308.8 235.6z"],"grid":0,"tags":["ios-mail-open-outline"]},{"paths":["M634 610.8l136 154.6-4 4-157.6-139-96.2 73.4-96.8-73.4-157.4 139-4-4 135.8-154.4-261.8-198v483h768v-485.2z","M384 428h-178.6l306.6 235.6 308.8-235.6h-180.8v-6.4l256-29.8v-7.8l-384-256-384 256v8.4l256 29.2z"],"grid":0,"tags":["ios-mail-open"]},{"paths":["M128 256v512h768v-512h-768zM512 535.8l-325.6-247.8h651.2l-325.6 247.8zM160 736v-427.8l230.2 175.2-136.2 154.6 4 4 157.8-139.2 96.2 73.2 96.2-73.2 157.8 139.2 4-4-136.2-154.8 230.2-175v427.8h-704z"],"grid":0,"tags":["ios-mail-outline"]},{"paths":["M896 768v-484.4l-262.2 199.6 136.2 154.8-4 4-157.8-139.2-96.2 73.2-96.2-73.2-157.8 139.2-4-4 136-154.8-262-199.2v484z","M879.4 256h-735.4l368 279.8z"],"grid":0,"tags":["ios-mail"]},{"paths":["M912 96h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-214 215.4c-59.6-54.2-139-87.4-226-87.4-185.6 0-336 150.4-336 336s150.4 336 336 336c185.6 0 336-150.4 336-336 0-87-33-166.4-87.4-226l215.4-214v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16zM736 592c0 81.2-31.6 157.6-89 215s-133.8 89-215 89c-81.2 0-157.6-31.6-215-89s-89-133.8-89-215 31.6-157.6 89-215 133.8-89 215-89c81.2 0 157.6 31.6 215 89s89 133.8 89 215z"],"grid":0,"tags":["ios-male"]},{"paths":["M511.4 213.2c0 0 0 0 0 0h-0.4c-50 0-91-40.6-91-90.6s40.8-90.6 91-90.6 91 40.6 91 90.6c0 24.2-9.4 47-26.6 64-17 17.2-39.8 26.6-64 26.6zM511 64c-32.4 0-58.8 26.2-58.8 58.6s26.4 58.6 58.8 58.6h0.4c0 0 0 0 0 0 15.6 0 30.4-6 41.4-17.2 11-11 17.2-25.8 17.2-41.4-0.2-32.4-26.6-58.6-59-58.6z","M442.4 992c-28.8 0-58-21-58-60.8l2-555.2h-12v210c0 18.6-8 30.2-14.8 36.6-8.6 8.2-20.2 12.8-32.4 12.8s-23.8-4.6-32.4-12.8c-6.8-6.4-14.8-17.8-14.8-36.6v-243.2c0-27.6 10.8-55.6 29.6-76.8 20.8-23.2 49.2-36 80-36h244.6c30.8 0 59.2 12.8 80 36.2 18.8 21.2 29.6 49 29.6 76.6v243.2c0 14.6-5.4 27.6-15.2 36.6-8.8 8-20.6 12.4-33 12.4s-24.2-4.4-33-12.4c-9.8-9-15.2-22-15.2-36.6v-210h-10v555.2c0 39.4-30.8 60.8-59.6 60.8-26.8 0-56.6-18.6-58.8-59.6 0-0.2 0-0.6 0-0.8v-281.6h-16v281.2c0 0.2 0 0.4 0 0.6-1.4 39.4-31.6 60.2-60.6 60.2zM358.4 344h44.2c4.2 0 8.4 1.6 11.4 4.8s4.8 7 4.6 11.4l-2 571.2c0 21.2 13.4 28.8 25.8 28.8 13.6 0 27.6-9 28.4-29.2v-297c0-8.8 7.2-16 16-16h48.2c8.8 0 16 7.2 16 16v297c1.4 21.4 14.6 29 26.8 29 13.2 0 27.4-9 27.4-28.8v-571.2c0-8.8 7.2-16 16-16h42.2c8.8 0 16 7.2 16 16v226c0 16.2 13.4 17 16 17s16-0.8 16-17v-243.2c0-39-31.2-80.8-77.6-80.8h-244.2c-37.2 0-77.6 30.8-77.6 80.8v243.2c0 16.4 12.6 17.2 15 17.2s15-0.8 15-17.2v-226c0.2-8.8 7.4-16 16.4-16z"],"grid":0,"tags":["ios-man-outline"]},{"paths":["M511.4 213.2v0h-0.4c-50 0-91-40.6-91-90.6s40.8-90.6 91-90.6 91 40.6 91 90.6c0 24.2-9.4 47-26.6 64-17 17.2-39.8 26.6-64 26.6z","M442.4 992c-28.8 0-58-21-58-60.8l2-555.2h-12v210c0 18.6-8 30.2-14.8 36.6-8.6 8.2-20.2 12.8-32.4 12.8s-23.8-4.6-32.4-12.8c-6.8-6.4-14.8-17.8-14.8-36.6v-243.2c0-27.6 10.8-55.6 29.6-76.8 20.8-23.2 49.2-36 80-36h244.6c30.8 0 59.2 12.8 80 36.2 18.8 21.2 29.6 49 29.6 76.6v243.2c0 14.6-5.4 27.6-15.2 36.6-8.8 8-20.6 12.4-33 12.4s-24.2-4.4-33-12.4c-9.8-9-15.2-22-15.2-36.6v-210h-10v555.2c0 39.4-30.8 60.8-59.6 60.8-26.8 0-56.6-18.6-58.8-59.6 0-0.2 0-0.6 0-0.8v-281.6h-16v281.2c0 0.2 0 0.4 0 0.6-1.4 39.4-31.6 60.2-60.6 60.2z"],"grid":0,"tags":["ios-man"]},{"paths":["M704.8 256l-191.4-128-192.6 128-192.8-128v640l192.8 128 192.6-128 191.4 128 191.2-128v-640l-191.2 128zM336 284.8l160-106.4v563l-160 106.2v-562.8zM528 176l160 106.8v563.2l-160-107v-563zM160 188l144 95.2v563.2l-144-95.6v-562.8zM864 750.8l-144 96.6v-562.6l144-96.8v562.8z"],"grid":0,"tags":["ios-map-outline"]},{"paths":["M128 128v640l176 116.8v-640z","M336 246v640l160-106.4v-640z","M896 128l-176 117.8v640l176-117.8z","M528 137.6v640l160 107.2v-640z"],"grid":0,"tags":["ios-map"]},{"paths":["M704 510.8c31.2 41.4 48 91.4 48 144.2 0 64.2-25 124.4-70.2 169.8s-105.6 70.2-169.8 70.2-124.4-25-169.8-70.2-70.2-105.6-70.2-169.8c0-52.8 17-103 48.2-144.4l-12.4-3.4-20.4-5.8c-30 43.6-47.4 96.6-47.4 153.6 0 150.2 121.8 273 272 273s272-122.8 272-273c0-56.8-17.4-109.6-47.2-153.2l-32.8 9z","M597.4 540.2l-43.4 12c41 16.6 70 56.8 70 103.8 0 61.8-50.2 112-112 112s-112-50.2-112-112c0-47 29-87.2 69.8-103.8l-43.2-12c-35.6 26.2-58.6 68.4-58.6 115.8 0 79.4 64.6 144 144 144s144-64.6 144-144c0-47.4-23-89.6-58.6-115.8z","M96 96v320l416 116 416-116v-320h-832zM896 128v64h-768v-64h768zM128 392v-168h224v232l-224-64zM512 497.4l-128-34v-239.4h256v239.4l-128 34zM672 456v-232h224v168l-224 64z"],"grid":0,"tags":["ios-medal-outline"]},{"paths":["M96 224v192l256 72v-264z","M512 564.4z","M400 656.4c0 61.8 50.2 112 112 112s112-50.2 112-112c0-47-28.8-87-69.8-103.8l-42.2 11.6-42-11.8c-41.2 17-70 57.2-70 104z","M736.8 502.2l-139.2 38.4c35.4 26.2 58.4 68.4 58.4 115.8 0 79.4-64.6 144-144 144s-144-64.6-144-144c0-47.4 23-89.6 58.6-115.8l-139.2-38.6c-30 43.6-47.4 96.6-47.4 153.6 0 150.2 121.8 272 272 272s272-121.8 272-272c0-57-17.4-109.6-47.2-153.4z","M384 224v272l128 36 128-35.2v-272.8z","M672 224v264l256-72v-192z","M96 96h832v96h-832v-96z"],"grid":0,"tags":["ios-medal"]},{"paths":["M152.2 374c0-76.2 44.4-142 110.6-170h-14.2c-57.4 0-121.4 60.8-132.6 139.6-11.2 1.8-19.8 14.6-19.8 29.8 0 16 9.4 28.6 21.6 29.6 8.4 60 71.4 118 113.8 130.8l20.2 6.4c-55.6-31.6-99.6-97.6-99.6-166.2z","M781 128c17.4 0 31.6 6.4 47.4 21.2 13.8 13.2 26 31.4 36.2 54.2 2 4.8 4 9.2 5.8 13.8v0.4c16.4 42.4 25.6 96.6 25.6 152.4 0 55.6-9 109.6-25.4 152.2v0.4c-1.8 4.6-3.6 9.2-5.8 14.2-10.2 22.4-20.8 38.4-37 54.8-23.8 23.8-40.6 26.4-46.8 26.4-6.4 0-12.2-1.2-28.8-7.4-12.4-4.8-24.8-9.8-37-14.6-62.2-25-126.4-50.8-213-50.8-14.2 0-27.4 5.8-37.2 16.6-29.4 32-25.4 103.4-16.4 208.8 2.4 27.4 4.6 53.4 4.6 70 0 19.8-0.6 32.8-1.8 42.6-0.8 6.8-1.8 10.6-2.6 12.4-1.4 0.2-3.6 0.4-7.2 0.4-14.8 0-36.6-2.8-56.8-7.4-24.4-5.6-36-11.2-39.2-13.4-4.2-5.2-4.6-8-0.4-38.2 4-28.6 30-168.2 41.2-227.8 2.2-11.8 3.8-20.6 4.6-25 4-21.2-6.6-40.4-28.2-51.6-11.2-5.8-24.6-9.2-37.6-12.6-10-2.6-27-7-31.4-10.6l-2-1.6-2.2-1.4c-45.2-26.8-73.2-77.6-73.2-132.4 0-30.4 9-59.8 25.8-85.4 15-22.8 35.4-40.8 59-52.6 15.4-0.2 56-0.4 119.6-0.4 43.8 0 101.2-9.8 162-27.8 61.2-18.2 119-42.6 162.4-68.6l1.2-0.8c7.8-4.4 17.6-10.4 34.6-10.4zM781 96c-27 0-43 10.4-51.6 15.6-86.2 51.8-224.6 92-308 92s-126.8 0.4-126.8 0.4c-63.2 28-109.6 93.8-109.6 170 0 68.4 35.6 128.4 88.8 160 24.2 20.2 91.2 17.6 86.2 44.4s-41 219-46 254-5.8 47 8 64c14 17 83 31.6 120 31.6s43.6-17.4 43.6-87.6-34.6-263.4 17-263.4c96.6 0 163 34.6 238.6 63.4 18 6.8 28.2 9.4 40.2 9.4s37.4-3.8 69.4-36.4c18.4-18.8 31.4-37.6 43.4-64.4 2.2-5.2 4.4-10.4 6.4-16 17.8-46.4 27.4-103.8 27.4-163.8 0-59.8-9.6-117.4-27.6-164-2-5.4-4.2-10.4-6.4-15.4-12-26.8-26.8-48.4-43.4-64.4-21-19-42.8-29.4-69.6-29.4v0z","M770.6 192.6c4.2 0 20 8.2 31.4 33.4 9 20.4 30 74.8 30 144 0 68.4-20.8 123.2-29.8 143.6-10.6 24-25 37-31 39.6-4-2.8-14.2-13.4-25.8-39.6-15.8-36-25-88.4-25-143.6 0-55.8 9.2-108.2 25.2-144 12.2-27.6 23.4-33.4 25-33.4zM770.6 160.6c-20.8 0-40 19.8-54.4 52.4-17 38.4-27.8 94.4-27.8 157 0 62.2 10.8 118.2 27.6 156.4 14.4 33 33.6 59.2 54.6 59.2s46.2-26.2 60.8-59.2c16.8-38.4 32.6-94.4 32.6-156.4 0-62.6-15.6-118.6-32.8-157-14.6-32.4-39.6-52.4-60.6-52.4v0z"],"grid":0,"tags":["ios-megaphone-outline"]},{"paths":["M152.2 374c0-76.2 44.4-142 110.6-170h-14.2c-57.4 0-121.4 60.8-132.6 139.6-11.2 1.8-19.8 14.6-19.8 29.8 0 16 9.4 28.6 21.6 29.6 8.4 60 71.4 118 113.8 130.8l20.2 6.4c-55.6-31.6-99.6-97.6-99.6-166.2z","M900.4 205.6c-2-5.4-4.2-10.4-6.4-15.4-12-26.8-26.8-48.4-43.4-64.4-21-19.4-42.8-29.8-69.6-29.8s-43 10.4-51.6 15.6c-86.2 51.8-224.6 92-308 92s-126.8 0.4-126.8 0.4c-63.2 28-109.6 93.8-109.6 170 0 68.4 35.6 128.4 88.8 160 24.2 20.2 91.2 17.6 86.2 44.4s-41 219-46 254-5.8 47 8 64c14 17 83 31.6 120 31.6s43.6-17.4 43.6-87.6-34.6-263.4 17-263.4c96.6 0 163 34.6 238.6 63.4 18 6.8 28.2 9.4 40.2 9.4s37.4-3.8 69.4-36.4c18.4-18.8 31.4-37.6 43.4-64.4 2.2-5.2 4.4-10.4 6.4-16 17.8-46.4 27.4-103.8 27.4-163.8 0-59.6-9.6-117.2-27.6-163.6zM863.4 526.6c-14.4 32.8-39.8 59.2-60.8 59.2s-40.2-26.2-54.6-59.2c-16.8-38.4-27.6-94.4-27.6-156.4 0-62.6 10.8-118.6 27.8-157 14.4-32.6 33.6-52.4 54.4-52.4 21 0 46 19.8 60.6 52.4 17 38.4 32.8 94.4 32.8 157 0 62-15.6 118-32.6 156.4z"],"grid":0,"tags":["ios-megaphone"]},{"paths":["M128 288h768v32h-768v-32z","M128 496h768v32h-768v-32z","M128 704h768v32h-768v-32z"],"grid":0,"tags":["ios-menu-outline"]},{"paths":["M128 288h768v64h-768v-64z","M128 480h768v64h-768v-64z","M128 672h768v64h-768v-64z"],"grid":0,"tags":["ios-menu"]},{"paths":["M669.8 553c0 0.4 0 0.8-0.2 1.2 0-0.4 0-0.8 0.2-1.2z","M670.4 544.8c0 0.4 0 0.8 0 1.4-0.2-0.6-0.2-1 0-1.4z","M354 536.6v0.2c0 92.2 70.6 167.2 158.2 167.2 18.2 0 35.6-3.2 51.8-9.2l-0.2-0.2c-16.2 6-33.4 9.2-51.6 9.2-87.6-0.2-158.2-75-158.2-167.2z","M512.2 671.6c-69.6 0-126.2-60.6-126.2-135v-146l-32-54.6v200.6c0 92.2 70.6 167.2 158.2 167.2 18.2 0 35.6-3.2 51.8-9.2l-16.6-28.2c-11.2 3.4-23 5.2-35.2 5.2z","M670 536.8v-0.2c0 2.8 0 5.4-0.2 8.2 0.2-2.6 0.2-5.4 0.2-8z","M670.2 546.2c-0.2 2.4-0.2 4.6-0.4 7 0.2-2.4 0.4-4.8 0.4-7z","M640.4 634.8c15.8-23 26.2-50.6 29.2-80.4-3 29.6-13.4 57.2-29.2 80.4v0z","M511.8 96c-59.2 0-110.6 34.2-137.8 84.8l20 33.8c18.2-50.8 64-87 117.8-87 69.6 0 126.2 60.6 126.2 135v273.6c0 24.2-5.8 47-16.4 66.6l18.6 31.4c15.8-23 26.4-50.6 29.4-80.4 0-0.4 0.2-0.8 0.2-1.2 0.2-2.2 0.4-4.6 0.6-7 0-0.4-0.2-0.8-0.2-1.4 0.2-2.8 0-5.4 0-8.2v-272.8c-0.2-92.2-70.8-167.2-158.4-167.2z","M528.4 766.6l-16.4 1.2-16.8-1.2c-57.2-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 254.8v97.6h-148v32h322v-32h-144v-97.4c30-2.2 58.2-9.4 84.6-21l-15.6-26.6c-22 8.6-45.2 13.8-68.6 15.6z","M768 543.6v-127.6h-32v127.6c0 56.8-20.2 111-58.4 152.4-0.4 0.4-0.4 0.6-0.8 1l15.2 26.4c46.8-46.2 76-109.8 76-179.8z","M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z"],"grid":0,"tags":["ios-mic-off-outline"]},{"paths":["M354 536.8c0 92.2 70.6 167.2 158 167.2 18.2 0 35.6-3.2 51.8-9.2l-209.8-358.8v200.8z","M670 536.8v-273.8c0-92.2-70.6-167.2-158-167.2-59 0-110.4 34.2-137.6 84.8l265.4 454c19-27.4 30.2-61.2 30.2-97.8z","M528.4 766.6l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c29.6-2.2 58-9.4 84.2-21l-15.6-26.6c-21.8 8.6-45 14-68.2 15.6z","M768 543.6v-127.6h-32v127.6c0 56.8-20.4 111-58.6 152.6-0.4 0.4-0.6 0.6-1 1l15.4 26.4c46.8-46.4 76.2-110 76.2-180z","M268.4 64l-27.6 16 514.8 880 27.6-16z"],"grid":0,"tags":["ios-mic-off"]},{"paths":["M512 127.8c69.4 0 126 60.6 126 135.2v273.8c0 74.6-56.6 135.2-126 135.2s-126-60.6-126-135.2v-273.8c0-74.6 56.6-135.2 126-135.2zM512 96c-87.4 0-158 74.8-158 167v273.8c0 92.2 70.6 167.2 158 167.2s158-75 158-167.2v-273.8c0-92.2-70.6-167-158-167v0z","M736 416v127.6c0 56.8-20.4 111-58.6 152.6-38 41.4-93.4 66.4-149 70.4l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c132-9.8 240-120.6 240-255v-127.6h-32z"],"grid":0,"tags":["ios-mic-outline"]},{"paths":["M512 96c-87.4 0-158 74.8-158 167v273.8c0 92.2 70.6 167.2 158 167.2s158-75 158-167.2v-273.8c0-92.2-70.6-167-158-167v0z","M736 416v127.6c0 56.8-20.4 111-58.6 152.6-38 41.4-93.4 66.4-149 70.4l-16.4 1.2-16.8-1.2c-57-4.2-106.4-29.2-145.8-70.8s-61.4-95.6-61.4-152.2v-127.6h-32v127.6c0 134.4 108 245.2 242 255v97.4h-148v32h322v-32h-144v-97.4c132-9.8 240-120.6 240-255v-127.6h-32z"],"grid":0,"tags":["ios-mic"]},{"paths":["M560 96h-96c-132 0-240 108-240 240v256c0 126.6 99.4 231.2 224 239.4v96.6h128v-96.6c124.6-8.4 224-112.8 224-239.4v-256c0-132-108-240-240-240zM480 896v-64h64v64h-64zM560 800h-96c-55.2 0-107.4-21.8-146.8-61.2-1-1-1.8-2-2.8-2.8h395.4c-1 1-1.8 2-2.8 2.8-39.6 39.4-91.8 61.2-147 61.2zM735 704h-446c-21.4-33.2-33-71.8-33-112v-16h160v-32h-160v-64h160v-32h-160v-64h160v-32h-160v-16c0-55.2 21.8-107.4 61.2-146.8 27.8-27.8 61.8-46.8 98.8-55.6v90.4h32v-95.4c5.2-0.4 10.6-0.6 16-0.6h32v128h32v-128h32c5.4 0 10.8 0.2 16 0.6v95.4h32v-90.4c37 8.8 71.2 27.8 98.8 55.6 39.4 39.4 61.2 91.6 61.2 146.8v16h-160v32h160v64h-160v32h160v64h-160v32h160v16c0 40.2-11.6 78.8-33 112z"],"grid":0,"tags":["ios-microphone-outline"]},{"paths":["M608 384v-32h192v-16c0-115.6-82.8-212.8-192-235.2v123.2h-32v-127.4c-5.2-0.4-10.6-0.6-16-0.6h-32v160h-32v-160h-32c-5.4 0-10.8 0.2-16 0.6v127.4h-32v-123.2c-109.2 22.4-192 119.6-192 235.2v16h192v32h-192v64h192v32h-192v64h192v32h-192v16c0 40.4 10.2 78.6 28 112h520c17.8-33.4 28-71.6 28-112v-16h-192v-32h192v-64h-192v-32h192v-64h-192z","M751.6 736h-479.2c41.2 54.6 105.4 91.4 177.6 95.6l-2 0.4v96h128v-96l-3-0.4c72.8-4 137.2-40.6 178.6-95.6z"],"grid":0,"tags":["ios-microphone"]},{"paths":["M428.2 174.6c0 0 0 0.2-0.2 0.2-25.6 53.4-38.6 111-38.6 170.8 0 105.6 41 205 115.6 279.6 74.6 74.8 173.6 115.8 279.2 115.8 6.4 0 12.8-0.2 19.2-0.4 0.2 0 0.2 0 0.4 0-67.2 78.4-164.4 123.2-267.4 123.2-94.2 0-182.6-36.8-249.2-103.4s-103.2-155.2-103.2-249.6c0-76.6 24-149.4 69.6-210.8 22-29.4 48.2-55.2 78-76.6 29.6-21.2 62.2-37.6 96.6-48.8zM493.8 128c-25.2 2.8-49.8 8-73.2 15.4-155.8 49.4-268.6 195.2-268.6 367.4 0 212.8 172 385.2 384.4 385.2 117.4 0 222.4-52.8 293-135.8 16.2-19 30.4-39.6 42.8-61.6-22.8 5.6-46.2 9-70 10.2-5.8 0.2-11.8 0.4-17.6 0.4-96.8 0-188-37.8-256.4-106.4-68.6-68.6-106.2-160-106.2-257 0-55.2 12.2-108.6 35.4-157 9.8-21.4 22-41.8 36.4-60.8v0z"],"grid":0,"tags":["ios-moon-outline"]},{"paths":["M493.8 128c-25.2 2.8-49.8 8-73.2 15.4-155.8 49.4-268.6 195.2-268.6 367.4 0 212.8 172 385.2 384.4 385.2 117.4 0 222.4-52.8 293-135.8 16.2-19 30.4-39.6 42.8-61.6-22.8 5.6-46.2 9-70 10.2-5.8 0.2-11.8 0.4-17.6 0.4-96.8 0-188-37.8-256.4-106.4-68.6-68.6-106.2-160-106.2-257 0-55.2 12.2-108.6 35.4-157 9.8-21.4 22-41.8 36.4-60.8v0z"],"grid":0,"tags":["ios-moon"]},{"paths":["M779.2 331l-22.6 22.6 141.6 142.4h-370.2v-370.2l142.4 141.8 22.6-22.8-181-181-181 181 22.6 22.6 142.4-141.6v370.2h-370.2l141.6-142.4-22.6-22.6-180.8 181 181 181 22.6-22.6-141.8-142.4h370.2v370l-142.4-141.6-22.6 22.6 181 181 181-181-22.6-22.6-142.4 141.6v-370h370.2l-141.8 142.4 22.6 22.6 181-181z"],"grid":0,"tags":["ios-move"]},{"paths":["M716.6 96.4c-9.4 1.8-212 40.2-220.4 41.8s-16.2 7.2-16.2 16c0 0 0 515.4 0 518.8 0 3.2-0.2 14.4-4.8 23.4-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.2 0 62 44.8 90 83.4 94.8 4.2 0.6 9 1.6 14.2 1.6 0 0 0 0 0 0 13.4 0 48-2.8 78.4-22.6 22-14.2 48.2-42.8 48.2-95.6v-476.8l224-45.8v-175.6c-0.2-8.6-7.6-17.6-19.6-15.2zM480 809.6c0 30.8-11.2 54.6-33.6 69-23.8 15.6-52.6 17.4-61 17.4 0 0 0 0 0 0-3.8 0-7.2-0.8-10.2-1.2-4.6-0.6-21-3.8-34.6-14.8-13.8-11-20.8-27.4-20.8-48.4 0-45 49.2-59.8 103.8-72.2 11.4-2.6 21.2-4.8 29.2-7.4 11-3.6 19-8.4 27-13.8v71.4zM704 261.4l-192 37.8v-131.6l192-36.4v130.2z"],"grid":0,"tags":["ios-musical-note-outline"]},{"paths":["M716.6 96.4c-9.4 1.8-212 40.2-220.4 41.8s-16.2 7.2-16.2 16c0 0 0 515.4 0 518.8 0 3.2-0.2 14.4-4.8 23.4-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.2 0 62 44.8 90 83.4 94.8 4.2 0.6 9 1.6 14.2 1.6 0 0 0 0 0 0 13.4 0 48-2.8 78.4-22.6 22-14.2 48.2-42.8 48.2-95.6v-476.8l224-45.8v-175.6c-0.2-8.6-7.6-17.6-19.6-15.2z"],"grid":0,"tags":["ios-musical-note"]},{"paths":["M812.6 96.4c-9.4 1.8-404 78.4-412.4 80s-16.2 7.2-16.2 16c0 0 0 477 0 480.2s-0.2 14.4-4.8 23.4c-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29.2-128.8 103.6 0 62.2 44.8 90.2 83.4 95 4.2 0.6 9 1.4 14.2 1.4 0 0 0 0 0 0 13.4 0 48-2.6 78.4-22.4 22-14.4 48.2-42.8 48.2-95.6v-438l384-78c0 0 0 273.2 0 281.4s-0.4 17.8-5 26.8c-6.2 11.8-17 20.4-32.4 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.4 0 67.4 52.6 91.2 83.6 94.6 2.4 0.2 5.2 0.2 8.2 0.2 0 0 0 0 0 0 20.4 0 51.4-5 77.6-20 35.8-20.6 55-53.6 55-96.4v-604.2c-0.2-8.8-7.6-17.8-19.6-15.4zM384 809.6c0 31-11.2 54.6-33.6 69.2-23.8 15.6-52.6 17.4-61 17.4 0 0 0 0 0 0-3.8 0-7.2-0.8-10.2-1.2-4.6-0.6-21-3.8-34.6-14.8-13.8-11-20.8-27.4-20.8-48.4 0-45.2 49.2-60 103.8-72.4 11.4-2.6 21.2-4.8 29.2-7.4 11-3.6 19-8.4 27-13.8v71.4zM800 715.6c0 31-13.2 53.8-38.8 68.6-20.8 11.8-46.2 15.8-61.8 15.8 0 0 0 0 0 0-2.6 0-4.2 0.2-4.8 0-9.2-1-55.2-8.4-55.2-62.4 0-45.2 49.2-60 103.8-72.4 11.4-2.6 21.4-4.8 29.4-7.4 11-3.6 19.2-8.4 27.2-13.8v71.6zM800 261.8l-384 76v-132l384-74.4v130.4z"],"grid":0,"tags":["ios-musical-notes-outline"]},{"paths":["M812.6 96.4c-9.4 1.8-404 78.4-412.4 80s-16.2 7.2-16.2 16c0 0 0 477 0 480.2s-0.2 14.4-4.8 23.4c-6.2 11.8-17 20.4-32.2 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29.2-128.8 103.6 0 62.2 44.8 90.2 83.4 95 4.2 0.6 9 1.4 14.2 1.4 0 0 0 0 0 0 13.4 0 48-2.6 78.4-22.4 22-14.4 48.2-42.8 48.2-95.6v-438l384-78c0 0 0 273.2 0 281.4s-0.4 17.8-5 26.8c-6.2 11.8-17 20.4-32.4 25.4-6.6 2.2-15.6 4.2-26.2 6.6-48.2 10.8-128.8 29-128.8 103.4 0 67.4 52.6 91.2 83.6 94.6 2.4 0.2 5.2 0.2 8.2 0.2 0 0 0 0 0 0 20.4 0 51.4-5 77.6-20 35.8-20.6 55-53.6 55-96.4v-604.2c-0.2-8.8-7.6-17.8-19.6-15.4z"],"grid":0,"tags":["ios-musical-notes"]},{"paths":["M720 512h32v96h-32v-96z","M256 576v-32h234l-32-32h-234v96h330l-32-32z","M600 544h72v26h-46l38 38h40v-96h-136z","M768 512h32v96h-32v-96z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM512 896c-51.8 0-102.2-10.2-149.4-30.2-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c17.2-40.8 41.2-78 71.2-110.6l542.6 542.6c-32.6 30-69.6 54-110.6 71.2-47.2 20-97.6 30.2-149.4 30.2zM794.6 772l-542.6-542.6c32.6-30 69.6-54 110.6-71.2 47.2-20 97.6-30.2 149.4-30.2s102.2 10.2 149.4 30.2c45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-17.2 40.8-41.2 78-71.2 110.6z","M720.4 425.4c-17.6-8.2-44.2-9.4-91.4-9.4-2.4 0-4.8 0-7.2 0-25.4 0.2-31.8-2.2-40-14.2-5.6-8.4-2-29.6 7.4-43.8 3.2-4.8 3.6-11.2 0.8-16.4s-8.2-8.4-14-8.6c-0.2 0-18.8-0.2-36.6-7.8-21.2-9-31.2-24.2-31.2-46.2 0-51.6 33.8-55 35.8-55 8.8 0 16-7.2 16-16s-7.2-16-16-16c-24 0-67.8 21.6-67.8 87 0 35 18 62 51.4 76 8.4 3.4 16.8 5.8 24 7.2-6.6 19.6-7.2 43.8 3.4 59.4 18 26.6 40.6 26.2 66.6 26.2 2.2 0 4.6 0 7 0 52.6 0 69.4 2.4 78 6.4 11.4 5.2 13.4 15 13.4 31.4 0 1.4 0 0.2 0 2.2h32c0 0 0-1 0-2.2 0-14 0.4-45.4-31.6-60.2z","M800 488c0-52-6-78.4-18.2-99-17.2-29-44.8-37-77.8-37h-34.8c5.8-16.6 10.8-47.6 7-69.8-6.4-37.6-30.8-58.2-68.2-58.2-8.8 0-16 7.2-16 16s7.2 16 16 16c32 0 34.2 16.4 36.8 31.6 5 29-13.6 72.2-13.8 72.6-2.8 5-2.6 11 0.2 15.8s8.2 8 13.8 8h59c21.8 0 38.8 1.8 50.2 21.2 6.2 10.6 13.8 26.8 13.8 82.8h32z","M800 488v0 0c0-0.2 0 0 0 0z"],"grid":0,"tags":["ios-no-smoking-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM608 224c37.4 0 61.8 20.6 68.2 58.2 3.8 22.2-1.2 53.2-7 69.8h34.8c33 0 60.6 8.2 77.8 36.8 12.2 20.8 18.2 47.2 18.2 99.2h-32c0-56-7.6-72.2-13.8-82.8-11.4-19.4-28.4-21.2-50.2-21.2h-59c-5.6 0-11-3.2-13.8-7.8-2.8-4.8-3-10.8-0.2-15.8 0.2-0.4 18.8-43.6 13.8-72.6-2.6-15.2-4.8-31.6-36.8-31.6-8.8 0-16-7.2-16-16s7.2-16.2 16-16.2zM544 192c8.8 0 16 7.2 16 16s-7.2 16-16 16c-2 0-35.8 3.4-35.8 55 0 22 10 37.2 31.2 46.2 17.8 7.6 36.4 7.8 36.6 7.8 5.8 0.2 11.2 3.4 14 8.6s2.4 11.6-0.8 16.4c-9.4 14.2-13 35.4-7.4 43.8 8.2 12 14.6 14.4 40 14.2 2.4 0 4.8 0 7.2 0 47.2 0 73.8 1.2 91.4 9.4 32 14.8 31.6 46.2 31.6 60.4 0 1.2 0 2.2 0 2.2h-32c0-2 0-0.8 0-2.2 0-16.4-2-26-13.4-31.4-8.6-4-25.4-6.4-78-6.4-2.4 0-4.8 0-7 0-26 0-48.6 0.4-66.6-26.2-10.6-15.6-10-40-3.4-59.6-7.2-1.4-15.6-3.8-24-7.2-33.4-14-51.4-41-51.4-76-0-65.4 43.8-87 67.8-87zM752 512v96h-32v-96h32zM704 512v96h-40l-96-96h136zM224 608v-96h234l96 96h-330zM783.6 783.6c-3.8 3.8-7.6 7.4-11.6 11l-542.6-542.6c3.6-4 7.2-7.8 11-11.6s7.6-7.4 11.6-11l542.6 542.6c-3.6 3.8-7.2 7.8-11 11.6zM800 608h-32v-96h32v96zM800 488c0 0 0-0.2 0 0v0 0z","M800 488v0 0c0-0.2 0 0 0 0z"],"grid":0,"tags":["ios-no-smoking"]},{"paths":["M576 800c0 36-28.8 64-64 64s-64.4-28-64.4-64h-32c0 54 43.2 96 96.2 96s96.2-42 96.2-96h-32z","M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z","M472.6 208.4c33.6-4.2 44.4-4.8 79.4 0 41.6 5.8 83.2 28 110.4 60.8 35.4 42.8 53.4 106.4 53.4 189.2 0 102.8 8.8 169.8 28.4 217.4 10.4 25.2 23.4 44 38 60h-83l18.8 32h146c-70.8-64-116.2-78-116.2-309.8 0-198.2-98-265.8-189.8-281.2 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-26.2 4.4-53 13.2-77.8 28l16 27.4c20.4-12.4 43.8-21 68-24z","M242.2 736c14.4-16 27.4-34.6 37.8-59.8 19.6-47.6 28.2-114.6 28.2-217.6 0-60.4 9.6-110.8 28.8-150.2l-19-32.4c-25.6 42.8-41.8 101.8-41.8 182.4 0 231.8-45 245.6-116.2 309.6h445.8l-18.8-32h-344.8z"],"grid":0,"tags":["ios-notifications-off-outline"]},{"paths":["M415.6 800c0 54 43.2 96 96.2 96s96.2-42 96.2-96h-192.4z","M267.6 64l-27.6 16.2 516.4 879.8 27.6-16.2z","M747.8 458c0-198.2-98-265.8-189.8-281.2 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-26.2 4.4-53 13.2-77.8 28l329.4 562.8h146c-70.8-64-116.2-78-116.2-309.8z","M276.2 458.4c0 231.8-45 245.6-116.2 309.6h445.8l-287.8-492c-25.6 42.8-41.8 101.8-41.8 182.4z"],"grid":0,"tags":["ios-notifications-off"]},{"paths":["M576 800c0 34-28.8 64-64 64s-64.4-30-64.4-64h-32c0 52 43.2 95.8 96.2 95.8s96.2-43.8 96.2-95.8h-32z","M747.8 458.4c0-198-98-265.6-189.8-281 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-91.8 15.6-189.8 83.8-189.8 281.4-0.4 231-45.4 245-116.6 309h704c-70.8-64-116.2-78.2-116.2-309.6zM242.2 736c14.4-16 27.4-34.8 37.8-60 19.6-47.4 28.2-114.6 28.2-217.4 0-82.6 18-146.2 53.6-189 27.2-32.8 67.4-55.4 110.8-61 33.6-4.2 44.4-4.8 79.4 0 41.6 5.8 83.2 28 110.4 60.8 35.4 42.8 53.4 106.4 53.4 189 0 102.8 8.8 169.8 28.4 217.4 10.4 25.2 23.4 44.2 38 60.2h-540z"],"grid":0,"tags":["ios-notifications-outline"]},{"paths":["M415.6 800c0 52 43.2 95.8 96.2 95.8s96.2-43.8 96.2-95.8h-192.4z","M747.8 458.4c0-198-98-265.6-189.8-281 0-1.2 0.2-2.2 0.2-3.4 0-25.4-20.6-46-46-46s-46 20.6-46 46c0 1.2 0 2.4 0.2 3.6-91.8 15.6-189.8 83.8-189.8 281.4-0.4 231-45.4 245-116.6 309h704c-70.8-64-116.2-78.2-116.2-309.6z"],"grid":0,"tags":["ios-notifications"]},{"paths":["M640 544c0-47.6-26.2-89.4-65-111.4l162.4-275.8c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l159.2 277.8c-36.6 22.6-61 63-61 109h-320c0 166.6 93.8 306.8 228.8 384l156.2-272.6c18.6 10.6 40.2 16.6 63 16.6s44.2-6 62.6-16.4l156.6 272.4c135-77.2 228.8-217.4 228.8-384h-320zM330 169.8c56.4-27.4 118.8-41.8 182-41.8 62.8 0 124.8 14.2 180.8 41.4l-147.8 251c-10.6-2.8-21.6-4.4-33-4.4-13.2 0-26 2-38 5.8l-144-252zM281.4 883.4c-51.6-34.6-94.8-79.2-126.4-130.6-33-53.6-52.6-114.2-57.8-176.8h290.8c6 23.2 18.4 43.8 35 60l-141.6 247.4zM416 544c0-34.2 18-64.2 44.8-81.2v0c0.8-0.6 1.6-1 2.4-1.6 14.2-8.4 31-13.2 48.6-13.2 53 0 96 43 96 96s-43 96-96 96-95.8-43-95.8-96zM742.4 883.4l-142.2-247c17-16.2 29.6-37 35.6-60.4h290.8c-5 62.6-24.8 123.2-57.8 176.8-31.4 51.4-74.8 96-126.4 130.6z"],"grid":0,"tags":["ios-nuclear-outline"]},{"paths":["M608 544c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z","M960 544h-320c0 47.8-26.2 89.4-65.2 111.4l156.4 272.6c135-77.2 228.8-217.4 228.8-384z","M512 416c23.4 0 45.4 6.4 64.2 17.4l161.2-276.6c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l159.6 277.6c19.4-12 42.2-18.8 66.6-18.8z","M384 544h-320c0 166.6 93.8 306.8 228.8 384l156.4-272.6c-39-22-65.2-63.6-65.2-111.4z"],"grid":0,"tags":["ios-nuclear"]},{"paths":["M800 864h-640v-640h352v-32h-384v704h704v-384h-32z","M640 128v32h200l-392 393.8 22.2 22.2 393.8-392v200h32v-256z"],"grid":0,"tags":["ios-open-outline"]},{"paths":["M640 128v32h200l-392 393.8 22.2 22.2 393.8-392v200h32v-256z","M470.2 621.6l-67.8-67.6 359.6-362h-634v704h704v-634z"],"grid":0,"tags":["ios-open"]},{"paths":["M704 208c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 176c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z","M704 752c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM704 720c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z","M320 480c17.674 0 32 14.326 32 32s-14.326 32-32 32-32-14.326-32-32 14.326-32 32-32zM320 448c-35.29 0-64 28.71-64 64s28.71 64 64 64 64-28.71 64-64-28.71-64-64-64v0z","M414.64 496h545.36v32h-545.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z","M224 512c0 5.454 0.48 10.792 1.36 16h-161.36v-32h161.36c-0.88 5.208-1.36 10.546-1.36 16z","M798.64 768h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z","M608 784c0 5.454 0.48 10.792 1.36 16h-545.36v-32h545.36c-0.88 5.208-1.36 10.546-1.36 16z","M798.64 224h161.36v32h-161.36c0.878-5.208 1.36-10.546 1.36-16s-0.48-10.792-1.36-16z","M609.36 224c-0.878 5.208-1.36 10.546-1.36 16s0.48 10.792 1.36 16h-545.36v-32h545.36z"],"grid":0,"tags":["ios-options-outline"]},{"paths":["M64 752h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z","M64 480h182.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h566.7v64h-566.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-182.7z","M64 208h566.7c12.372-28.224 40.562-48 73.3-48s60.93 19.776 73.3 48h182.7v64h-182.7c-12.372 28.224-40.562 48-73.3 48s-60.93-19.776-73.3-48h-566.7z"],"grid":0,"tags":["ios-options"]},{"paths":["M742.8 128h-461.6c-130.2 78-217.2 221-217.2 384s87 304 217.2 384h461.8c130-80 217-221 217-384s-87-306-217.2-384zM733.6 864h-443.2c-57.4-38-105.2-87.4-139-145.4-36.2-62.6-55.4-134.6-55.4-207.4 0-73 19.2-144.6 55.4-207.4 34-58.6 81.8-109.8 138.8-143.8h443.6c61.6 40 104.8 85 138.6 143.6 36.4 63 55.4 134.6 55.4 207.6 0 72.8-19.2 144.8-55.4 207.4-33.6 58.2-81.4 107.4-138.8 145.4z","M640 320h64v192h-64v-192z","M320 288h64v256h-64v-256z","M512 640v0c-35.2 0-64 28.8-64 64v96h128v-96c0-35.2-28.8-64-64-64z"],"grid":0,"tags":["ios-outlet-outline"]},{"paths":["M742.8 128h-461.6c-130.2 78-217.2 221-217.2 384s87 304 217.2 384h461.8c130-80 217-221 217-384s-87-306-217.2-384zM384 544h-64v-256h64v256zM576 800h-128v-96c0-35.2 28.8-64 64-64s64 28.8 64 64v96zM704 512h-64v-192h64v192z"],"grid":0,"tags":["ios-outlet"]},{"paths":["M224 96v736h32v-704h608v738.2c0 16.4-13.4 29.8-29.8 29.8h-644.4c-16.4 0-29.8-13.4-29.8-29.8v-610.2h32v-32h-64v642.2c0 34 27.6 61.8 61.8 61.8h644.6c34 0 61.8-27.6 61.8-61.8v-770.2h-672.2z","M320 224h256v32h-256v-32z","M320 384h480v32h-480v-32z","M320 544h384v32h-384v-32z","M320 704h480v32h-480v-32z"],"grid":0,"tags":["ios-paper-outline"]},{"paths":["M96 541.8l239.8 103.2 59.6 275 115-161.8 233.6 169.8 184-832-832 445.8zM829.8 184.8l-486.2 428.6-174-74.8 660.2-353.8zM367 638l-0.4-2.2 336.2-304.4-300.6 349.6 0.8 0.6h-1l-3.2 103.2-31.8-146.8zM429.8 816.4l3.6-113.4 51.4 36.4-0.2 0.2-54.8 76.8zM724.2 869.6l-274.2-194.6 429.8-509-155.6 703.6z"],"grid":0,"tags":["ios-paper-plane-outline"]},{"paths":["M928 96l-832 445.8 221 95 595.2-524.4-482.8 586.6-2.2 174.8 83.2-115.8 233.6 170z","M339.2 660.6l56.2 259.4h0.8v-1l5.8-237.4 300.6-350.2z"],"grid":0,"tags":["ios-paper-plane"]},{"paths":["M224 96v736h-32v-608h-64v642.2c0 34 27.6 61.8 61.8 61.8h644.6c34 0 61.8-27.6 61.8-61.8v-770.2h-672.2zM320 224h256v32h-256v-32zM320 544h384v32h-384v-32zM800 736h-480v-32h480v32zM800 416h-480v-32h480v32z"],"grid":0,"tags":["ios-paper"]},{"paths":["M320 128h32v108h-32v-108z","M32 416h110v32h-110v-32z","M119 234.8l22-22.2 62.8 63-22 22.2z","M478.8 295.8l-22-22.2 62.6-63 22.2 22.2z","M145 641.4l-22-22.2 62.8-63 22 22.2z","M307.8 535.8c-52.6-10.4-92.4-56.8-92.4-112.4 0-63.2 51.4-114.6 114.6-114.6 36.6 0 69.2 17.2 90.2 44 9.4-5.4 19.2-10.2 29.4-14.2-26.6-37.4-70.2-61.8-119.6-61.8-81 0-146.6 65.6-146.6 146.6 0 73.6 54.2 134.6 125 145-0.6-6.6-1-13.4-1-20.2 0-4.2 0-8.2 0.4-12.4z","M806.6 518.4c-1.6 0-3.2 0-4.8 0-6.2 0-12.2 0-18 0.8-22.6-100.6-112.2-176.4-219.4-176.4-29.2 0-57.2 5.6-82.8 15.8-10.2 4-20 8.8-29.4 14.2-64 37-108.2 104.8-112.4 183.2-0.2 4.2-0.4 8.2-0.4 12.4 0 6.8 0.4 13.6 1 20.2 0 0.8 0.2 1.6 0.2 2.2-75.8 6.8-135.2 74.2-135.2 152 0 82.2 66.6 153.4 148.6 153.4h452.8c102.4 0 185.4-86.8 185.4-189.6-0.2-102.8-83.2-188.2-185.6-188.2zM914.8 817.4c-29.2 30-67.6 46.6-108.2 46.6h-452.8c-63.2 0-116.6-55.8-116.6-121.4 0-29.8 11-58.8 31.2-81.4 19.8-22.4 46.6-36.2 75-38.6l32.2-2.8-3-30.2-0.2-2c-0.6-6.4-1-13-1-19.4 0-3.6 0.2-7.2 0.2-10.6 3.6-67.2 41.6-125.4 96.6-157.2 9.2-5.4 19-10 29-13.6 20.8-7.8 43.4-12 67-12 44.6 0 86.4 15 121.2 43.2 33.8 27.6 57.4 66 67 108.2l6.4 28.4 28.8-3.6c4.2-0.6 9.4-0.6 14.2-0.6h5c40.8 0 79.2 16.4 108.4 45.8 29.2 29.6 45.2 68.8 45.2 110-0.4 41.6-16.4 81.2-45.6 111.2z"],"grid":0,"tags":["ios-partly-sunny-outline"]},{"paths":["M320 128h32v108h-32v-108z","M32 416h110v32h-110v-32z","M119 234.8l22-22.2 62.8 63-22 22.2z","M478.8 295.8l-22-22.2 62.6-63 22.2 22.2z","M145 641.4l-22-22.2 62.8-63 22 22.2z","M330 276.6c-81 0-146.6 65.6-146.6 146.6 0 73.6 54.2 134.6 125 145 0 0-2.4-85.8 37.8-145.8s103.6-84 103.6-84c-26.8-37.4-70.4-61.8-119.8-61.8z","M806.6 518.4c-1.6 0-3.2 0-4.8 0-6.2 0-12.2 0-18 0.8-22.6-100.6-112.2-176.4-219.4-176.4-29.2 0-57.2 5.6-82.8 15.8-10.2 4-20 8.8-29.4 14.2-64 37-108.2 104.8-112.4 183.2-0.2 4.2-0.4 8.2-0.4 12.4 0 6.8 0.4 13.6 1 20.2 0 0.8 0.2 1.6 0.2 2.2-75.8 6.8-135.2 74.2-135.2 152 0 82.2 66.6 153.4 148.6 153.4h452.8c102.4 0 185.4-86.8 185.4-189.6-0.2-102.8-83.2-188.2-185.6-188.2z"],"grid":0,"tags":["ios-partly-sunny"]},{"paths":["M648.6 160.6c-2.4-0.4-4.8-0.6-7.2-0.6v0.2c-0.2 0-0.4 0-0.8 0-44 0-85.8 51.8-95.6 120.6-10.6 73.2 18.8 138 65.4 144.8 2.6 0.4 5.4 0.6 8 0.6 44 0 85.8-51.8 95.6-120.6 10.6-73.4-18.8-138.2-65.4-145zM682.6 300.8c-8 55.8-39.8 93.2-64.2 93.2-1.2 0-2.4 0-3.4-0.2-11.4-1.6-22.2-12.2-29.8-29-9.8-21.6-13-50.4-8.8-79.4 8-55.4 39.6-92.6 64-93.2 1.2 0 3.2 0.2 4 0.2 11.4 1.6 22 12.2 29.6 29 9.8 21.4 12.8 50.4 8.6 79.4z","M641.2 160v0 0z","M884.6 338.8c-7-2.8-14.2-4.2-21.8-4.2-0.2 0-0.6 0-0.8 0v0 0c-39.4 0.6-83.6 38.4-106.8 95.6-27.8 68.4-15 138.4 28.8 156.4 7 2.8 14.2 4.2 21.8 4.2 39.6 0 84.4-38 107.8-95.6 27.6-68.4 14.6-138.4-29-156.4zM883.8 483c-9.4 23-23.2 43.4-39.2 57.4-13.4 11.6-27.6 18.4-39 18.4-3.6 0-6.8-0.6-9.8-1.8-10.6-4.4-18.6-17.2-22-35.4-4.2-23.2-0.4-52.2 10.6-79.2 9.4-23 23.4-43.4 39.2-57.4 13.2-11.6 27-18.2 38.4-18.4 3.8 0 7 0.6 10 1.8 10.6 4.4 18.8 17.2 22.2 35.4 4.4 23.4 0.6 52.2-10.4 79.2z","M655.2 590.8c-55.6-87.2-79.6-120-143.2-120s-87.8 33-143.4 120c-47.6 74.4-143.8 80.6-167.8 143.8-4.8 11.2-7.2 23.4-7.2 36.4 0 51.4 41.6 93 92.8 93 63.6 0 150.2-48 225.8-48s161.8 48 225.4 48c51.2 0 92.6-41.6 92.6-93 0-13-2.6-25.2-7.4-36.4-24-63.4-120-69.4-167.6-143.8zM737.6 832c-25.6 0-58.8-10.2-94-21-43-13.2-87.4-27-131.6-27s-88.6 13.6-131.6 26.8c-35.2 10.8-68.4 21-94 21-33.6 0-61-27.4-61-61 0-8.6 1.6-16.6 4.6-23.8l0.4-1.2c8-21.2 32-34.8 62.2-52 35.2-20 75-42.6 102.8-86 55.4-86.8 71.6-105.4 116.6-105.4 23.6 0 38 5.2 53.2 19 18 16.6 37.6 46.2 63.2 86.4 27.8 43.4 67.4 66 102.6 86 30.2 17.2 54 30.8 62.2 52l0.4 1.2c3.2 7.6 4.8 15.6 4.8 23.8-0 33.8-27.2 61.2-60.8 61.2z","M405.6 426c2.6 0 5.4-0.2 8-0.6 46.8-6.8 76-71.6 65.4-144.8-10-69-51.8-120.6-95.6-120.6-2.6 0-5.4 0.2-8 0.6-46.8 6.8-76 71.6-65.4 144.8 10 68.8 51.8 120.6 95.6 120.6zM350.2 221.2c7.6-16.8 18.4-27.4 29.8-29 1.2-0.2 2.2-0.2 3.4-0.2 24.6 0 56.2 37.4 64.2 93.2 4.2 29 1 58-8.8 79.4-7.6 16.8-18.4 27.4-29.8 29-1.2 0.2-2.2 0.2-3.4 0.2-24.6 0-56.2-37.4-64.2-93.2-4.2-28.8-1-57.8 8.8-79.4z","M240.2 586.6c43.8-18 56.6-88 28.8-156.4-23.4-57.6-68.2-95.6-107.8-95.6-7.6 0-14.8 1.4-21.8 4.2-43.8 18-56.6 88-28.8 156.4 23.4 57.6 68.2 95.6 107.8 95.6 7.6-0 14.8-1.4 21.8-4.2zM140.2 483c-11-27-14.8-56-10.6-79.2 3.4-18.2 11.4-31.2 22-35.4 3-1.2 6.2-1.8 9.8-1.8 11.6 0 25.8 6.6 39 18.4 16 14 29.8 34.4 39.2 57.4 22 54 12.2 105-11.4 114.6-3 1.2-6.2 1.8-9.8 1.8-11.6 0-25.8-6.6-39-18.4-16-14-30-34.4-39.2-57.4z"],"grid":0,"tags":["ios-paw-outline"]},{"paths":["M648.6 160.6c-2.4-0.4-4.8-0.6-7.2-0.6v0.2c-0.2 0-0.4 0-0.8 0-44 0-85.8 51.8-95.6 120.6-10.6 73.2 18.8 138 65.4 144.8 2.6 0.4 5.4 0.6 8 0.6 44 0 85.8-51.8 95.6-120.6 10.6-73.4-18.8-138.2-65.4-145z","M641.2 160v0 0z","M884.6 338.8c-7-2.8-14.2-4.2-21.8-4.2-0.2 0-0.6 0-0.8 0v0 0c-39.4 0.6-83.6 38.4-106.8 95.6-27.8 68.4-15 138.4 28.8 156.4 7 2.8 14.2 4.2 21.8 4.2 39.6 0 84.4-38 107.8-95.6 27.6-68.4 14.6-138.4-29-156.4z","M655.2 590.8c-55.6-87.2-79.6-120-143.2-120s-87.8 33-143.4 120c-47.6 74.4-143.8 80.6-167.8 143.8-4.8 11.2-7.2 23.4-7.2 36.4 0 51.4 41.6 93 92.8 93 63.6 0 150.2-48 225.8-48s161.8 48 225.4 48c51.2 0 92.6-41.6 92.6-93 0-13-2.6-25.2-7.4-36.4-24-63.4-120-69.4-167.6-143.8z","M405.6 426c2.6 0 5.4-0.2 8-0.6 46.8-6.8 76-71.6 65.4-144.8-10-69-51.8-120.6-95.6-120.6-2.6 0-5.4 0.2-8 0.6-46.8 6.8-76 71.6-65.4 144.8 10 68.8 51.8 120.6 95.6 120.6z","M240.2 586.6c43.8-18 56.6-88 28.8-156.4-23.4-57.6-68.2-95.6-107.8-95.6-7.6 0-14.8 1.4-21.8 4.2-43.8 18-56.6 88-28.8 156.4 23.4 57.6 68.2 95.6 107.8 95.6 7.6-0 14.8-1.4 21.8-4.2z"],"grid":0,"tags":["ios-paw"]},{"paths":["M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z","M404.8 403.4c0 0 0 0 0 0v0z","M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6 0 0 0 0 0 0-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4 0 0 0 0 0 0 0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2h-274.4z"],"grid":0,"tags":["ios-person-add-outline"]},{"paths":["M832 306h-50v-50h-28v50h-50v28h50v50h28v-50h50z","M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36c6.6-16.8 13.8-62.8 13.8-62.8s13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19 0 0 0 0 0 0s9.8-27.2 11.2-84.8c1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8s0 0 0 0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"],"grid":0,"tags":["ios-person-add"]},{"paths":["M64 352.6v317c0 36.6 29.2 66.2 65.8 66.2h762c36.8 0 68.2-29.6 68.2-66.2v-317c0-36.6-31.4-64.6-68.2-64.6h-762c-36.6 0-65.8 28-65.8 64.6zM110 542v-60c0-4.4 3.6-8 8-8s8 3.6 8 8v60c0 4.4-3.6 8-8 8s-8-3.6-8-8zM938 511c0 19.2-15.6 34.8-34.8 34.8s-34.8-15.6-34.8-34.8c0-19.2 15.6-34.8 34.8-34.8s34.8 15.6 34.8 34.8zM848 320v384h-682v-384h682z","M883.2 511c0 11 9 20 19.8 20 11 0 20-9 20-20s-9-20-20-20c-10.8 0.2-19.8 9-19.8 20z"],"grid":0,"tags":["ios-phone-landscape"]},{"paths":["M671.4 64h-317.2c-36.6 0-66.2 29.2-66.2 65.8v762c0 36.8 29.6 68.2 66.2 68.2h317c36.6 0 64.6-31.4 64.6-68.2v-762c0.2-36.6-27.8-65.8-64.4-65.8zM482 110h60c4.4 0 8 3.6 8 8s-3.6 8-8 8h-60c-4.4 0-8-3.6-8-8s3.6-8 8-8zM513 938c-19.2 0-34.8-15.6-34.8-34.8s15.6-34.8 34.8-34.8c19.2 0 34.8 15.6 34.8 34.8s-15.6 34.8-34.8 34.8zM704 848h-384v-682h384v682z","M513 883.2c-11 0-20 9-20 19.8 0 11 9 20 20 20s20-9 20-20c-0.2-10.8-9-19.8-20-19.8z"],"grid":0,"tags":["ios-phone-portrait"]},{"paths":["M512 128c141.2 0 256 105.6 256 235.4 0 79-48 197.4-138.8 342.8-44.8 71.8-90.2 134-117.2 169.6-27-35.6-72-97.4-116.8-169-91-145.6-139.2-264.4-139.2-343.4 0-129.8 114.8-235.4 256-235.4zM512 96c-159 0-288 119.8-288 267.4 0 208 288 564.6 288 564.6s288-356.6 288-564.6c0-147.6-129-267.4-288-267.4v0z","M512 256c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128-57.4-128-128-128zM512 477.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"],"grid":0,"tags":["ios-pin-outline"]},{"paths":["M512 96c-159 0-288 119.8-288 267.4 0 208 288 564.6 288 564.6s288-356.6 288-564.6c0-147.6-129-267.4-288-267.4zM512 477.8c-51.8 0-93.8-42-93.8-93.8s42-93.8 93.8-93.8 93.8 42 93.8 93.8-42 93.8-93.8 93.8z"],"grid":0,"tags":["ios-pin"]},{"paths":["M736 350.4c0-39-2-163.4-38.6-231.2-9-16.4-25-23.2-63.4-23.2h-244c-38.6 0-54.4 6.8-63.4 23.2-36.6 67.8-38.6 193-38.6 232 0 182 64 186.2 64 335.6 0 73.4-32 133.4-32 185.4 0 50.2 18 55.6 64 55.6h256c46 0 64-5.8 64-55.8 0-52-32-111.4-32-184.8 0-149.4 64-154.8 64-336.8zM354.8 134c1-1.8 1.4-2 4-3 4-1.6 12.8-3 31.2-3h244c18.2 0 27 1.4 31.2 3 2.8 1 3.2 1.4 4.2 3.2 14.2 26.2 24.4 67.6 30 119.8h-374.6c5.6-52.2 15.8-94 30-120zM669.6 893.2c-2.8 1.2-10.4 2.8-29.6 2.8h-256c-19.2 0-26.8-1.6-29.8-2.8-0.8-1.8-2.2-7.6-2.2-21 0-19.6 6-42.4 12.8-68.6 9-34 19.2-72.6 19.2-116.6 0-77-16.2-119.6-31.8-160.8-16.6-43.8-32.2-85.4-32.2-175 0-22.8 0.8-44.6 2-65h380c1.4 20.4 2 42 2 64.4 0 89.6-15.6 131.4-32.4 175.6-15.6 41.4-31.6 84.2-31.6 161.2 0 44 10.2 82.4 19.2 116.2 7 26.2 12.8 49 12.8 68.6 0 13.4-1.6 19.2-2.4 21z"],"grid":0,"tags":["ios-pint-outline"]},{"paths":["M736 350.4c0-39-2-163.4-38.6-231.2-9-16.4-25-23.2-63.4-23.2h-244c-38.6 0-54.4 6.8-63.4 23.2-36.6 67.8-38.6 193-38.6 232 0 182 64 186.2 64 335.6 0 73.4-32 133.4-32 185.4 0 50.2 18 55.6 64 55.6h256c46 0 64-5.8 64-55.8 0-52-32-111.4-32-184.8 0-149.4 64-154.8 64-336.8zM354.8 134c1-1.8 1.4-2 4-3 4-1.6 12.8-3 31.2-3h244c18.2 0 27 1.4 31.2 3 2.8 1 3.2 1.4 4.2 3.2 14.2 26.2 24.4 67.6 30 119.8h-374.6c5.6-52.2 15.8-94 30-120z"],"grid":0,"tags":["ios-pint"]},{"paths":["M836.6 183c-60.2-27-152-55-323.2-55-170.8 0-260 24.6-323 54.8-55 26.2-38.2 48-26.2 73.2 8 17.2 16.4 23.6 29 23.6 1 0 2 0 2.8-0.2l317.4 616.6 316.6-615c0.6 0 1.2 0 1.8 0 13 0 22-6.8 31-25.2 12.2-24.8 19.6-52.4-26.2-72.8zM266.6 347.8c18-7.8 38-8.8 56.8-2.4 20 6.8 36.4 21.2 45.8 40.2 9.4 19.2 10.8 40.8 4.2 61-6 18-17.8 33-33.8 42.6-26.8-51.6-52.2-101-73-141.4zM593.6 660.8c-43.8 0-79.4-35.8-79.4-80s35.6-80 79.4-80c28 0 53.4 14.6 67.8 38.4l-62.4 121.4c-1.8 0.2-3.6 0.2-5.4 0.2zM677.6 507.6c-20.8-24.4-51.2-38.6-84-38.6-61.2 0-111.2 50.2-111.2 112 0 58 44 105.8 100.2 111.4l-69.2 134.8c-28.6-55.4-95.8-186-159.2-309 23.2-13.6 40.6-35 49.2-61 9.4-28.4 7.4-58.8-5.8-85.6-26.6-54.2-91.4-77-145.6-52.2-10-19.4-18.4-35.8-24.6-47.8 45.8-15.4 126.6-47.6 285.8-47.6 1 0 1.8 0 2.8 0-1.4 54.6 38 103.2 93 111.4 5.4 0.8 10.8 1.2 16.2 1.2 23.2 0 45.8-7.4 64.8-21.6 21.2-15.8 35.6-38.2 41.2-63.8 28.6 8 50.2 16.4 67 22.2l-120.6 234.2zM548 224.6c63.8 2 113.6 9.6 152.6 18.6-4 18.4-14.2 34.6-29.4 46-16.6 12.4-36.8 17.6-57.2 14.6s-38.4-13.8-50.6-30.6c-10.8-14.2-16-31.2-15.4-48.6zM834.2 241.8c-1.8 3.8-3.2 6-4.2 7.2-6.6-0.8-19.6-5.4-33.4-10.2-49.2-17.6-131.4-46.8-283.2-46.8-152.6 0-235.6 28.6-285.2 45.6-13.2 4.6-25.8 8.8-32.6 9.8-0.6-1.2-1.6-2.8-2.8-5.2s-2.2-4.8-3.4-7c-1.8-3.6-4.2-8.4-5.2-11.6 2.2-2 7.4-6.4 19.6-12.2 50.4-24 131.2-51.6 309.4-51.6 173.4 0 260.2 29.8 310.4 52.2 14.4 6.4 16.4 11.2 16.4 11.2 0.2 0.6 1.2 4.2-5.8 18.6z"],"grid":0,"tags":["ios-pizza-outline"]},{"paths":["M836.6 183c-60.2-27-152-55-323.2-55-170.8 0-260 24.6-323 54.8-55 26.2-38.2 48-26.2 73.2 8 17.2 16.4 23.6 29 23.6 1 0 2 0 2.8-0.2l317.4 616.6 316.6-615c0.6 0 1.2 0 1.8 0 13 0 22-6.8 31-25.2 12.2-24.8 19.6-52.4-26.2-72.8zM266.6 347.8c18-7.8 38-8.8 56.8-2.4 20 6.8 36.4 21.2 45.8 40.2 9.4 19.2 10.8 40.8 4.2 61-6 18-17.8 33-33.8 42.6-26.8-51.6-52.2-101-73-141.4zM593.6 660.8c-43.8 0-79.4-35.8-79.4-80s35.6-80 79.4-80c28 0 53.4 14.6 67.8 38.4l-62.4 121.4c-1.8 0.2-3.6 0.2-5.4 0.2zM548 224.6c63.8 2 113.6 9.6 152.6 18.6-4 18.4-14.2 34.6-29.4 46-16.6 12.4-36.8 17.6-57.2 14.6s-38.4-13.8-50.6-30.6c-10.8-14.2-16-31.2-15.4-48.6zM834.2 241.8c-1.8 3.8-3.2 6-4.2 7.2-6.6-0.8-19.6-5.4-33.4-10.2-49.2-17.6-131.4-46.8-283.2-46.8-152.6 0-235.6 28.6-285.2 45.6-13.2 4.6-25.8 8.8-32.6 9.8-0.6-1.2-1.6-2.8-2.8-5.2s-2.2-4.8-3.4-7c-1.8-3.6-4.2-8.4-5.2-11.6 2.2-2 7.4-6.4 19.6-12.2 50.4-24 131.2-51.6 309.4-51.6 173.4 0 260.2 29.8 310.4 52.2 14.4 6.4 16.4 11.2 16.4 11.2 0.2 0.6 1.2 4.2-5.8 18.6z"],"grid":0,"tags":["ios-pizza"]},{"paths":["M430.4 176l187 292.2 9.8 15 18.2-0.6 136.4-4c6.4-0.4 12.4-0.4 18.4-0.4 34.4 0 67.4 4.8 93 13.4 21.2 7.2 30.8 14.8 34.2 18.6-3.2 3.8-13 11.4-34.2 18.6-25.6 8.6-58.6 13.4-93 13.4-5.6 0-12.2 0-18.4-0.4h-0.8l-153.6-3.6-9.8 15.8-187.2 294h-32.2l101.8-270 15.6-41.8-44.4-2-268.6-10.8-10.2 13.4-80 103.2h-1.2l46.4-116.6 4.8-12.2-4.8-11.6-46.4-115.6h1.2l78.8 99.6 10 12.4 16.2-0.6 298.4-9.8-15.8-41.4-101.6-268.2h31.6zM448 144h-96l118 311.4-253.6 8.6-88.4-112h-64l64 160-64 160h64l89.8-115.4 252.2 10.4-118 313h96l196.4-309 135.6 3c6.6 0.4 13.2 0.2 20 0.2 88.4 0 160-28.8 160-64.2s-71.6-64-160-64c-6.8 0-13.4 0.2-20 0.4l-135.6 4.4-196.4-306.8z"],"grid":0,"tags":["ios-plane-outline"]},{"paths":["M448 144h-96l118 311.4-253.6 8.6-88.4-112h-64l64 160-64 160h64l89.8-115.4 252.2 10.4-118 313h96l196.4-309 135.6 3c6.6 0.4 13.2 0.2 20 0.2 88.4 0 160-28.8 160-64.2s-71.6-64-160-64c-6.8 0-13.4 0.2-20 0.4l-135.6 4.4-196.4-306.8z"],"grid":0,"tags":["ios-plane"]},{"paths":["M792.4 577.8c-2.2 9-4.6 18-7.8 26.8 11.6 9 22.8 17.8 33.6 26.6 72 58.2 118 114.4 106.4 114.4-15.8 1-55.2-2.2-142.2-34.2-24.4-9-50.4-19.4-77.6-31.2 39.4-45 63.2-104 63.2-168.4 0-141.4-114.6-256-256-256-114 0-210.4 74.4-243.6 177.2-24-17.2-46.4-34.2-66.6-50.4-72-58.2-95.2-90.4-102.4-104.4-8.6-14 65.2-1.8 152.2 30.2 13.6 5 27.8 10.4 42.2 16 5.6-6.6 11.6-13 17.8-19-131.8-55-228.4-75.4-245-45.8-18 31.8 61.6 113.4 193.6 206.8-2.6 14.8-4 29.8-4 45.4 0 141.4 114.6 256 256 256 64.6 0 123.6-23.8 168.6-63.4 148 65.2 259 91.4 277 59.6 16.4-29.4-50.6-101.4-165.4-186.2zM353.6 353.6c42.4-42.4 98.6-65.6 158.4-65.6s116 23.4 158.4 65.6c42.2 42.4 65.6 98.6 65.6 158.4 0 58.2-22 112.8-62 154.6-61.4-27.8-127.4-61.6-193.6-99-66-37.4-129-76.6-184.6-115 10.2-37 29.8-71 57.8-99zM512 736c-59.8 0-116-23.4-158.4-65.6-42.2-42.4-65.6-98.6-65.6-158.4 0-8.4 0.4-16.8 1.4-25 52.4 35.6 111.6 72.4 175.4 108.6s125.8 68 183.4 94.4c-39 29.8-86.4 46-136.2 46z"],"grid":0,"tags":["ios-planet-outline"]},{"paths":["M792.4 577.8c-2.2 9-4.6 18-7.8 26.8 11.6 9 22.8 17.8 33.6 26.6 72 58.2 118 114.4 106.4 114.4-15.8 1-55.2-2.2-142.2-34.2-24.4-9-50.6-19.4-77.6-31.2 39.4-45 63.2-103.8 63.2-168.4 0-141.4-114.6-256-256-256-114 0-210.4 74.4-243.6 177.4-24-17.2-46.4-34.2-66.6-50.6-72-58.2-95.2-90.4-102.4-104.4-8.6-14 65.2-1.8 152.2 30.2 13.6 5 27.8 10.4 42.2 16 5.6-6.6 11.6-13 17.8-19-131.8-55-228.4-75.4-245-45.8-26.2 46.2 152.2 196.4 398.2 335.8 246 139.2 466.8 214.8 492.8 168.6 16.6-29.4-50.4-101.4-165.2-186.2z","M256.2 504.6c0 2.4-0.2 4.8-0.2 7.4 0 141.4 114.6 256 256 256 51.6 0 99.6-15.2 139.8-41.4-65-28.8-132.8-59-207-101-67.6-38.4-134.2-83.4-188.6-121z"],"grid":0,"tags":["ios-planet"]},{"paths":["M640 512v-320h-256v192h-256v448h768v-320h-256zM384 800h-224v-384h224v384zM608 800h-192v-576h192v576zM864 800h-224v-256h224v256z"],"grid":0,"tags":["ios-podium-outline"]},{"paths":["M128 384h224v448h-224v-448z","M384 192v640h256v-640z","M672 512h224v320h-224v-320z"],"grid":0,"tags":["ios-podium"]},{"paths":["M781.4 195.8c-6.8-5.8-16.8-5-22.6 1.8s-5 16.8 1.8 22.6c86 73.2 135.2 179.4 135.2 291.6 0.2 211.8-172 384.2-383.8 384.2s-384-172.4-384-384.2c0-112.2 49.2-218.4 135.2-291.6 6.8-5.8 7.6-15.8 1.8-22.6s-15.8-7.6-22.6-1.8c-93 79.2-146.4 194.4-146.4 316 0 229.4 186.6 416.2 416 416.2s416-186.8 416-416.2c0-121.6-53.4-236.8-146.6-316z","M514 544c8.8 0 16-7.2 16-16v-416c0-8.8-7.2-16-16-16s-16 7.2-16 16v416c0 8.8 7.2 16 16 16z"],"grid":0,"tags":["ios-power-outline"]},{"paths":["M781.4 199.4c-5.6-4.8-12.8-7.4-20.4-7.4-9.2 0-18 4-23.8 11-5.4 6.4-8 14.4-7.4 22.8s4.6 16 11 21.4c79 67 124.4 164.2 124.4 266.6 0 193.8-158.4 351.6-353.2 351.6s-353.2-157.8-353.2-351.6c0-102.6 45.4-199.8 124.4-266.6 6.4-5.4 10.4-13 11-21.4s-2-16.4-7.4-22.8c-6-7-14.6-11-23.8-11-7.4 0-14.6 2.6-20.4 7.4-93.2 78.8-146.6 193.4-146.6 314.4 0 228.4 186.6 414.2 416 414.2s416-185.8 416-414.2c0-121-53.4-235.6-146.6-314.4z","M514 544c17.6 0 32-14.4 32-32v-384c0-17.6-14.4-32-32-32s-32 14.4-32 32v384c0 17.6 14.4 32 32 32z"],"grid":0,"tags":["ios-power"]},{"paths":["M768 320c35.2 0 64-28.8 64-64s-28.8-64-64-64-64 28.8-64 64 28.8 64 64 64zM768 224c17.6 0 32 14.4 32 32s-14.4 32-32 32-32-14.4-32-32 14.4-32 32-32z","M896 128v261.4l-493.4 493.4-261.4-261.4 493.4-493.4h261.4zM928 96h-306.6l-525.4 525.4 306.6 306.6 525.4-525.4v-306.6z"],"grid":0,"tags":["ios-pricetag-outline"]},{"paths":["M800 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z","M928 96h-306.6l-525.4 525.4 306.6 306.6 525.4-525.4v-306.6zM768 320c-35.2 0-64-28.8-64-64s28.8-64 64-64 64 28.8 64 64c0 35.2-28.8 64-64 64z"],"grid":0,"tags":["ios-pricetag"]},{"paths":["M865 224h-65v-96h-576v96h-63c-35.2 0-65 27.6-65 62.6v316.8c0 35 29.8 64.6 65 64.6h95v228h512v-228h97c35.2 0 63-29.6 63-64.6v-316.8c0-35-27.8-62.6-63-62.6zM256 160h512v64h-512v-64zM736 864h-448v-384h448v384zM896 603.4c0 17.4-13.4 32.6-31 32.6h-97v-188h-512v188h-95c-17.6 0-33-15.2-33-32.6v-316.8c0-17.4 15.4-30.6 33-30.6h704c17.6 0 31 13.2 31 30.6v316.8z"],"grid":0,"tags":["ios-print-outline"]},{"paths":["M256 448h512v448h-512v-448z","M255 449h512v448h-512v-448z","M223 129h576v64h-576v-64z","M865 225h-704c-35.29 0-66 25.684-66 60.618v316.786c0 34.936 30.71 66.598 66 66.598h62v-252h576v252h66c35.29 0 62-31.662 62-66.598v-316.786c0-34.934-26.71-60.618-62-60.618z"],"grid":0,"tags":["ios-print"]},{"paths":["M896 576c-30.536 0-56.058 21.39-62.446 50h-118.008l-60.362-181.792c-2.21-6.658-8.492-11.086-15.518-10.956-7.016 0.144-13.118 4.844-15.048 11.59l-108.484 378.638-116.35-698.11c-1.248-7.48-7.574-13.056-15.152-13.358-7.618-0.278-14.322 4.764-16.156 12.122l-124.98 501.866h-179.496v32h192c7.348 0 13.75-5.004 15.526-12.132l109.37-439.182 115.322 691.946c1.23 7.376 7.406 12.918 14.874 13.344 0.306 0.018 0.614 0.026 0.918 0.026 7.098 0 13.398-4.7 15.374-11.594l113.744-396.992 47.69 143.626c2.174 6.542 8.292 10.958 15.186 10.958h130.584c7.78 26.578 32.322 46 61.416 46 35.348 0 64-28.654 64-64s-28.656-64-64.004-64z"],"grid":0,"tags":["ios-pulse-outline"]},{"paths":["M896 546.002c-42.54 0-78.592 27.998-91.192 65.998h-77.714l-56.722-170.834c-4.352-13.106-16.606-21.912-30.366-21.912-0.224 0-0.448 0-0.67 0.008-14.032 0.29-26.234 9.688-30.098 23.176l-88.968 310.524-104.706-628.216c-2.494-14.96-14.898-28.746-31.564-28.746s-27.386 11.552-31.050 26.27l-121.958 489.73h-198.992v63.998h224c14.696 0 27.5-10.006 31.050-24.268l90.736-364.354 102.648 615.88c2.458 14.754 14.794 23.84 29.728 24.688 0.616 0.036 1.228 0.056 1.838 0.056 14.194 0 26.812-7.402 30.762-21.188l99.488-347.234 31.378 94.504c4.346 13.086 16.584 21.916 30.372 21.916h102.216c13.73 36 48.738 62.002 89.784 62.002 53.022 0 96-44.984 96-98 0-53.018-42.978-93.998-96-93.998z"],"grid":0,"tags":["ios-pulse"]},{"paths":["M128 248.4c0-44.4 42-88.4 88.4-88.4 39.6 0 135.6 0 135.6 0v-32h-133.6c-67 0-122.4 53.4-122.4 120.4v135.6h32c0 0 0-91.4 0-135.6z","M896 384h32v-135.6c0-67-55.4-120.4-122.4-120.4h-133.6v32c0 0 96 0 135.6 0 46.4 0 88.4 44 88.4 88.4s0 135.6 0 135.6z","M128 640h-32v135.6c0 67 55.4 120.4 122.4 120.4h133.6v-32c0 0-96 0-135.6 0-46.4 0-88.4-44-88.4-88.4s0-135.6 0-135.6z","M896 775.6c0 44.4-42 88.4-88.4 88.4-39.6 0-135.6 0-135.6 0v32h133.6c67 0 122.4-53.4 122.4-120.4v-135.6h-32c0 0 0 91.4 0 135.6z"],"grid":0,"tags":["ios-qr-scanner"]},{"paths":["M418 224c17.6 0 30 12.4 30 30v384c0 46.6-8.6 90-26.6 128-7 15-13.6 26-18.8 34h-38.6c25.4-38 50-90.6 50-161v-31h-156c-17.6 0-34-16.4-34-34v-320c0-17 15.8-30 34-30h160zM418 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z","M770 224c17.6 0 30 12.4 30 30v384c0 46.6-8.6 90-26.6 128-7 15-13.6 26-18.8 34h-38.6c25.4-38 50-90.6 50-161v-31h-156c-17.6 0-34-16.4-34-34v-320c0-17 15.8-30 34-30h160zM770 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z"],"grid":0,"tags":["ios-quote-outline"]},{"paths":["M418 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z","M770 192h-160c-35.4 0-66 26.6-66 62v320c0 35.4 30.6 66 66 66h124c0 128-92 192-92 192h128c0 0 62-67.2 62-194 0-91.4 0-283.6 0-384 0-35.4-26.6-62-62-62v0z"],"grid":0,"tags":["ios-quote"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-radio-button-off"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M512 192c-176.8 0-320 143.2-320 320s143.2 320 320 320c176.8 0 320-143.2 320-320s-143.2-320-320-320z"],"grid":0,"tags":["ios-radio-button-on"]},{"paths":["M227.8 812c-4.2 0-8.4-1.6-11.6-5-78.6-82-120.2-184-120.2-295s41.6-213 120.4-295c6.2-6.4 16.2-6.6 22.6-0.4s6.6 16.2 0.4 22.6c-72.8 75.8-111.4 170.2-111.4 272.8s38.6 197 111.4 273c6.2 6.4 6 16.6-0.4 22.6-3.2 3-7.2 4.4-11.2 4.4z","M796.2 812c-4 0-8-1.4-11-4.4-6.4-6.2-6.6-16.2-0.4-22.6 72.8-76 111.4-170.4 111.4-273s-38.6-197-111.4-273c-6.2-6.4-6-16.6 0.4-22.6s16.6-6 22.6 0.4c78.8 82 120.4 184 120.4 295s-41.6 213-120.4 295c-3.2 3.6-7.4 5.2-11.6 5.2z","M312.2 731.2c-4.2 0-8.2-1.6-11.4-4.8-56.2-57.2-87.2-132.6-87.2-212.8 0-82 32.2-158.8 90.6-216.2 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.6c-52.4 51.4-81.2 120.2-81.2 193.4 0 71.6 27.6 139.2 78 190.2 6.2 6.4 6.2 16.4-0.2 22.6-3 3.2-7 4.8-11 4.8z","M711.8 731.2c-4 0-8.2-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.6 50.2-51 78-118.6 78-190.2 0-73.4-28.8-142-81.2-193.4-6.2-6.2-6.4-16.4-0.2-22.6s16.4-6.4 22.6-0.2c58.4 57.6 90.6 134.4 90.6 216.2 0 80-31 155.6-87.2 212.8-2.8 3-7 4.6-11.2 4.6z","M396 653.8c-4.2 0-8.2-1.6-11.4-4.8-35.8-36.4-55.6-84.8-55.6-135.8 0-52.4 20.6-101.4 58-138.2 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.6c-31.2 30.6-48.4 71.6-48.4 115.4 0 42.8 16.4 83 46.4 113.4 6.2 6.2 6.2 16.4-0.2 22.6-3 3-7 4.6-11.2 4.6z","M628 653.8c-4 0-8.2-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.6 30-30.4 46.4-70.8 46.4-113.4 0-43.8-17.2-84.6-48.4-115.4-6.2-6.2-6.4-16.4-0.2-22.6s16.4-6.4 22.6-0.2c37.4 36.8 58 85.8 58 138.2 0 51.2-19.8 99.4-55.6 135.8-3.2 3.2-7.4 4.8-11.4 4.8z","M576 512c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"],"grid":0,"tags":["ios-radio-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM323.6 727.4c-3.2 3-7.2 4.6-11.2 4.6-4.2 0-8.2-1.6-11.4-4.8-56-57.4-87-133.2-87-213.6 0-82.2 32.2-159.4 90.6-217 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.8c-52.2 51.6-81 120.6-81 194.2 0 71.8 27.6 139.8 77.8 191 6.2 6.2 6.2 16.4-0.2 22.6zM407.6 627c6.2 6.4 6.2 16.4-0.2 22.8-3.2 3-7.2 4.6-11.2 4.6-4.2 0-8.2-1.6-11.4-4.8-35.8-36.6-55.6-85-55.6-136.4 0-52.6 20.6-101.8 57.8-138.6 6.2-6.2 16.4-6.2 22.6 0.2s6.2 16.4-0.2 22.8c-31.2 30.8-48.2 71.8-48.2 115.8-0 42.6 16.4 83 46.4 113.6zM512 576.2c-35.4 0-64-28.8-64-64.2s28.6-64.2 64-64.2 64 28.8 64 64.2c0 35.4-28.6 64.2-64 64.2zM639.2 649.4c-3.2 3.2-7.2 4.8-11.4 4.8-4 0-8-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.8 30-30.6 46.4-71 46.4-113.8 0-43.8-17.2-85-48.2-115.8-6.2-6.2-6.4-16.4-0.2-22.8s16.4-6.4 22.6-0.2c37.4 36.8 57.8 86.2 57.8 138.6 0 51.6-19.8 100-55.6 136.6zM723 727.2c-3.2 3.2-7.2 4.8-11.4 4.8-4 0-8-1.6-11.2-4.6-6.2-6.2-6.4-16.4-0.2-22.8 50.2-51.2 77.8-119.2 77.8-191 0-73.6-28.8-142.6-81-194.2-6.2-6.2-6.4-16.4-0.2-22.8s16.4-6.4 22.6-0.2c58.4 57.8 90.6 134.8 90.6 217 0 80.6-31 156.4-87 213.8z"],"grid":0,"tags":["ios-radio"]},{"paths":["M748.8 286.4l-26.6-0.2c-23.6-107-110.2-190.2-250.2-190.2s-255.6 103.4-255.6 245.6l0.6 9.6c-84.6 11.2-153 89-153 177.8 0 94 75.8 177 169.2 177h21.2l-74.8 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.4-120.2h122.8l-144.6 198c-5.2 7.2-4.4 16 2.8 21.2 2.6 2 6.6 2.8 9.6 2.8 7.4 0 12.2-2.6 15.6-7.2l156-214.8h122.2l-74.6 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.2-120.2h122.8l-144.6 198c-5.2 7.2-4.2 15.6 3 20.6 2.6 2 6.4 3.4 9.4 3.4 4.6 0 10.2-1.6 13.6-6.2l160.2-220.6c100.8-16.8 177.8-107.4 177.8-213.2-0.2-117.2-94.8-201.6-211.4-201.6zM774.4 671.6c0 0-17.8 2.4-40.4 2.4s-500.8 0-500.8 0c-36 0-70.2-15.8-96.4-43.6-26-27.4-40.8-64.6-40.8-101.8 0-35 13.2-69.4 37-96.8 23.6-27 54.8-44.4 88.2-48.8l29.6-4-2-29.8-0.6-8.6c0.2-58.6 23.4-112.6 65.2-151.8 42-39.2 98.2-60.8 158.6-60.8 58.6 0 110 16.6 148.6 47.8 35.4 28.8 59.8 69.4 70.4 117.4l5.8 26.8c23-1.4 52-1.4 52-1.4 49 0 94.2 17.2 127.4 48.2 33.4 31.2 51.6 74.2 51.6 121.4 0.2 89.2-67.2 169-153.4 183.4z"],"grid":0,"tags":["ios-rainy-outline"]},{"paths":["M748.8 286.4l-26.6-0.2c-23.6-107-110.2-190.2-250.2-190.2s-255.6 103.4-255.6 245.6l0.6 9.6c-84.6 11.2-153 89-153 177.8 0 94 75.8 177 169.2 177h21.2l-74.8 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.4-120.2h122.8l-144.6 198c-5.2 7.2-4.4 16 2.8 21.2 2.6 2 6.6 2.8 9.6 2.8 7.4 0 12.2-2.6 15.6-7.2l156-214.8h122.2l-74.6 101.4c-5.2 7.2-3.6 16.6 3.6 21.8 2.6 2 5.8 2.8 8.8 2.8 4.6 0 10.2-1.2 13.6-5.8l88.2-120.2h122.8l-144.6 198c-5.2 7.2-4.2 15.6 3 20.6 2.6 2 6.4 3.4 9.4 3.4 4.6 0 10.2-1.6 13.6-6.2l160.2-220.6c100.8-16.8 177.8-107.4 177.8-213.2-0.2-117.2-94.8-201.6-211.4-201.6z"],"grid":0,"tags":["ios-rainy"]},{"paths":["M728.2 512c0 120-97 216.4-216.2 216.4s-216.2-97-216.2-216.4c0-119.2 97-216.2 216.2-216.2v111.6l192-111.4-192-128v88c-141.4 0-256 114.8-256 256.2 0 141.6 114.6 256.2 256 256.2s256-114.2 256-256.2h-39.8z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z"],"grid":0,"tags":["ios-refresh-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"],"grid":0,"tags":["ios-refresh-circle"]},{"paths":["M512 768.2c-141.4 0-256-114.6-256-256.2s114.6-256.2 256-256.2v-87.8l192 128-192 111.4v-111.6c-119.2 0-216.2 97-216.2 216.2s97 216.2 216.2 216.2 216.2-96.2 216.2-216.2h39.8c0 142-114.6 256.2-256 256.2z"],"grid":0,"tags":["ios-refresh"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M256 496h512v34h-512v-34z"],"grid":0,"tags":["ios-remove-circle-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM768 530h-512v-34h512v34z"],"grid":0,"tags":["ios-remove-circle"]},{"paths":["M768 530h-512v-34h512v34z"],"grid":0,"tags":["ios-remove"]},{"paths":["M160 608h704v32h-704v-32z","M160 496h704v32h-704v-32z","M160 384h704v32h-704v-32z"],"grid":0,"tags":["ios-reorder"]},{"paths":["M664.6 327.4l-67.2-66.8c-3.2-3.2-7.2-4.6-11.4-4.6s-8.2 1.6-11.4 4.6c-6.2 6.2-6.2 16.4 0 22.6l53.4 52.8h-356c-79.2 0-144 64.8-144 144v48h32v-48c0-29.8 11.6-57.8 33-79 21.2-21.2 49.4-33 79-33h352l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l71.2-70.8c12.6-12.4 12.6-32.6 0-45.2z","M864.2 496v48c0 29.8-11.6 57.8-33 79-21.4 21.4-49.4 33-79.2 33h-352l53.2-52.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-71.2 70.8c-12.6 12.4-12.6 32.6 0 45.2l67.2 66.8c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-53.2-52.8h356c79.2 0 144-64.8 144-144v-48h-32z"],"grid":0,"tags":["ios-repeat"]},{"paths":["M880 128h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-680 679.8v-183.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16h224c8.8 0 16-7.2 16-16s-8-16-16.8-16h-183.2l680-680v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16z"],"grid":0,"tags":["ios-resize"]},{"paths":["M769 128c-49.6 0-95.6 154.6-95.6 320 0 114 64.2 160 64.2 160s12.4 9.6 30.2 12v260c0 8.8 7.2 16 16 16s16-7.2 16-16v-730c0.2-22-20.8-22-30.8-22zM768 162v424c-2-0.2-10-2-14.6-6.2-2.6-2.2-10.4-9.2-20.6-25.8-22.6-36.2-27.2-77.6-27.2-105.8 0-69.8 8.4-142.8 24-200.2 15-56 32.4-79.4 38.4-86v0z","M592 128h-16l20 207c0 8.8-7.2 15.6-16 15.6s-16-6.4-16-15.2l-12-207.4h-16l-12 207c0 8.8-7.2 15.6-16 15.6s-16-6.4-16-15.2l20-207.4h-16c0 0-48 214.2-48 255.8s26.4 78.8 64 90.6c10.6 3.4 16 3.6 16 3.6v402c0 8.8 7.2 16 16 16s16-7.2 16-16v-402c0 0 10.2-1.8 16-3.6 37.2-12 64-48.4 64-90.4s-48-256-48-256zM544 446c-57.2 0-64-53.2-64-63.2 0 0 0.2-5.4 0.6-9 7.8 5.4 17.2 8.6 27.4 8.6 14.4 0 23-6.2 36-6.2s21.6 6.2 36 6.2c10.2 0 19.6-3.2 27.4-8.6 0.4 3.8 0.6 9.2 0.6 9.2 0 9.4-6.8 63-64 63z","M320 128c-53 0-96 127.8-96 255.8 0 34.6 18.4 66.4 46.4 82.6 22.8 13.4 33.6 13.6 33.6 13.6v400c0 8.8 7.2 16 16 16s16-7.2 16-16v-400c0 0 10.2 0 32.4-12.4 28.4-16 47.6-48 47.6-83.6 0-128-43-256-96-256zM352.6 439.2l-0.4 0.4c-1.4 0.8-3.2 2-5.2 2.8-2.4 0.6-4.8 1.4-7 2.6-6.8 1.4-13.6 2.6-19.8 2.6s-13-1.2-19.8-2.6c-2.2-1-4.4-1.8-7-2.4-2-1-4.4-2.4-6-3.4l-0.8-0.4c-18.8-11.2-30.6-32.2-30.6-54.8 0-58.8 9.6-119 26.2-165 9.6-26.4 19-41 25.2-48.6 6.8-8.4 11.6-10.2 12.6-10.2s5.8 1.8 12.6 10.2c6.2 7.6 15.6 22 25.2 48.6 16.6 46 26.2 106 26.2 165-0 22.6-12.4 44.4-31.4 55.2z"],"grid":0,"tags":["ios-restaurant-outline"]},{"paths":["M768 128c-49.6 0-96 154.6-96 320 0 114 64 160 64 160v256c0 17.6 14.4 32 32 32s32-14.4 32-32v-714c0-22-22-22-32-22z","M576 128l20 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l-12-208h-16l-12 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l20-208h-16c0 0-48 214.4-48 256s26.8 77.2 64 90.4v389.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-389.6c37.2-13.2 64-48.4 64-90.4s-48-256-48-256h-16z","M320 128c-53 0-96 128-96 256 0 41.6 26.8 77.2 64 90.4v389.6c0 17.6 14.4 32 32 32s32-14.4 32-32v-389.6c37.2-13.2 64-48.4 64-90.4 0-128-43-256-96-256z"],"grid":0,"tags":["ios-restaurant"]},{"paths":["M137.4 584.6l115.2 114.8c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-99.4-100.8h576c79.2 0 144-64.8 144-144v-112h-32v112c0 29.8-11.6 57.8-33 79-21.2 21.2-49.4 33-79 33h-576l103.2-100.8c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-119.2 118.8c-12.6 12.4-12.6 32.6 0 45.2z"],"grid":0,"tags":["ios-return-left"]},{"paths":["M886.6 584.6l-115.2 114.8c-3.2 3.2-7.2 4.6-11.4 4.6s-8.2-1.6-11.4-4.6c-6.2-6.2-6.2-16.4 0-22.6l99.4-100.8h-576c-79.2 0-144-64.8-144-144v-112h32v112c0 29.8 11.6 57.8 33 79 21.2 21.2 49.4 33 79 33h576l-103.2-100.8c-6.2-6.2-6.2-16.4 0-22.6s16.4-6.2 22.6 0l119.2 118.8c12.6 12.4 12.6 32.6 0 45.2z"],"grid":0,"tags":["ios-return-right"]},{"paths":["M512 176c79.4 0 144 64.6 144 144s-64.6 144-144 144-144-64.6-144-144 64.6-144 144-144zM512 144c-97 0-176 79-176 176s79 176 176 176 176-79 176-176-79-176-176-176v0z","M512 96c59.8 0 116 23.4 158.4 65.6s65.6 98.6 65.6 158.4-23.4 116-65.6 158.4-98.6 65.6-158.4 65.6-116-23.4-158.4-65.6-65.6-98.6-65.6-158.4 23.4-116 65.6-158.4 98.6-65.6 158.4-65.6zM512 64c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256v0z","M301.2 560.8c58 50.8 132.8 79.2 210.8 79.2 4.8 0 9.4-0.2 14.2-0.4l-43.4 95.4-70.8 156-74-123.2h-155l118.2-207zM294.2 508.4l-166.2 291.6h192l96 160 96-211.6 67.2-148.4c-21.6 5.2-44.2 8-67.2 8-87 0-165-38.6-217.8-99.6v0z","M722.8 560.8l118.2 207.2h-155.2l-9.4 15.6-64.4 107.6-48.6-107 78.2-171.6c29.4-13 57-30.6 81.2-51.8zM729.8 508.4c-30.2 34.8-68.6 62.4-112 79.6l-89.6 196.2 79.8 175.8 96-160h192l-166.2-291.6z"],"grid":0,"tags":["ios-ribbon-outline"]},{"paths":["M512 576c141.4 0 256-114.6 256-256s-114.6-256-256-256-256 114.6-256 256 114.6 256 256 256zM512 144c97 0 176 79 176 176s-79 176-176 176-176-79-176-176 79-176 176-176z","M512 464c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144z","M512 608c-87 0-165-38.6-217.8-99.6l-166.2 291.6h192l96 160 96-211.6 67.2-148.4c-21.6 5.2-44 8-67.2 8z","M729.8 508.4c-30.2 34.8-68.6 62.4-112 79.6l-89.6 196.2 79.8 175.8 96-160h192l-166.2-291.6z"],"grid":0,"tags":["ios-ribbon"]},{"paths":["M757.2 324.2c-57 102.2-32.8 183.4-10.8 256.6 11 37.2 21.6 72.2 21.6 109.2 0 58-23 108.4-66.4 145.4-46.4 39.6-112 60.4-189.6 60.4s-143-21-189.6-60.4c-43.4-37-66.4-87.2-66.4-145.4 0-57.8 13.6-102.4 42.8-140 26-33.6 65.2-63.2 126.8-95.8l13-7c40.4-21.4 54-28.8 88-43.8 63.8-28.4 133.2-52.8 206.4-72.6 8-2.2 16.2-4.4 24.2-6.6zM832 274.2c-37.8 7.8-73.6 16.4-107.4 25.6-81 22-151 47.8-210.8 74.4-38.6 17.2-52.4 24.8-103 51.8-116.8 61.8-186.8 128.6-186.8 264 0 135.6 111.2 238 288 238s288-102.4 288-238c0-135.4-122-237.4 32-415.8v0z","M269 268c42.6 13 94.6 31.4 138.4 55.2 11 6 21 12 30 18-9.6 4.8-19 9.6-28.2 14.4-14.4 7.6-28.8 15.6-42.4 23.6-21.4 12.4-41.6 25.2-60.6 38-1.2-46.8-11-98.6-37.2-149.2zM192 214.8c83 87.4 89.2 193 78.8 268.8 25.6-21 62.4-47.8 112.2-76.8 12.8-7.6 26.6-15.2 41.2-22.8 23.2-12.2 47-23.8 71.6-34.8-18.2-20.2-44.2-38.2-73.2-54-97.4-53-230.6-80.4-230.6-80.4v0z","M689.8 188.6c9.8 12.4 22.8 30.2 33 47.6-59.6 15.8-131.2 39.2-188.6 62-11.2-11-24.4-21.6-39.2-32 42.2-34.2 89.4-53.2 124.4-63.4 29.8-8.6 55.2-12.6 70.4-14.2zM704 155.4c0 0-157.2 4.4-261.4 116 33.2 18.4 59.4 38 78 58.6l5.4 6c74.4-31.2 176.2-63.4 242-78-12.8-43.4-64-102.6-64-102.6v0z","M362.2 137.8c18 11 44.2 29.4 70.6 57.2-9 7.4-17.6 15-25.8 23-28.4-13.4-50.2-22.8-72.8-30.6 7.2-15 16.6-32 28-49.6zM352 96c-30.6 41.6-51.4 84.2-60.6 111.4 42.2 11.8 71 24.6 122.8 49.4 19-21.2 40.8-40.2 65.2-56.8-58.8-75-127.4-104-127.4-104v0z"],"grid":0,"tags":["ios-rose-outline"]},{"paths":["M832 274.2c-37.8 7.8-73.6 16.4-107.4 25.6-81 22-151 47.8-210.8 74.4-38.6 17.2-52.4 24.8-103 51.8-116.8 61.8-186.8 128.6-186.8 264 0 135.6 111.2 238 288 238s288-102.4 288-238c0-135.4-122-237.4 32-415.8v0z","M192 214.8c83 87.4 89.2 193 78.8 268.8 25.6-21 62.4-47.8 112.2-76.8 12.8-7.6 26.6-15.2 41.2-22.8 23.2-12.2 47-23.8 71.6-34.8-18.2-20.2-44.2-38.2-73.2-54-97.4-53-230.6-80.4-230.6-80.4v0z","M704 155.4c0 0-157.2 4.4-261.4 116 33.2 18.4 59.4 38 78 58.6l5.4 6c74.4-31.2 176.2-63.4 242-78-12.8-43.4-64-102.6-64-102.6v0z","M352 96c-30.6 41.6-51.4 84.2-60.6 111.4 42.2 11.8 71 24.6 122.8 49.4 19-21.2 40.8-40.2 65.2-56.8-58.8-75-127.4-104-127.4-104v0z"],"grid":0,"tags":["ios-rose"]},{"paths":["M512 128c51.8 0 102.2 10.2 149.4 30.2 45.8 19.4 86.8 47 122 82.4 35.2 35.2 63 76.4 82.4 122 20 47.4 30.2 97.6 30.2 149.4s-10.2 102.2-30.2 149.4c-19.4 45.8-47 86.8-82.4 122-35.2 35.2-76.4 63-122 82.4-47.4 20-97.6 30.2-149.4 30.2s-102.2-10.2-149.4-30.2c-45.8-19.4-86.8-47-122-82.4-35.2-35.2-63-76.4-82.4-122-20-47.2-30.2-97.6-30.2-149.4s10.2-102.2 30.2-149.4c19.4-45.8 47-86.8 82.4-122 35.2-35.2 76.4-63 122-82.4 47.2-20 97.6-30.2 149.4-30.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416v0z","M704 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M416 448c0 26.51-21.49 48-48 48s-48-21.49-48-48c0-26.51 21.49-48 48-48s48 21.49 48 48z","M512 542c-96.6 0-176 70-192 162h384c-16-92-95.4-162-192-162z"],"grid":0,"tags":["ios-sad-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-229.8-186.2-416-416-416zM368 400c26.6 0 48 21.4 48 48s-21.4 48-48 48-48-21.4-48-48 21.4-48 48-48zM320 704c16-92 95.4-162 192-162s176 70 192 162h-384zM656 496c-26.6 0-48-21.4-48-48s21.4-48 48-48 48 21.4 48 48-21.4 48-48 48z"],"grid":0,"tags":["ios-sad"]},{"paths":["M512.8 128l-448.4 256 127.6 73.2v255.8l320 183 320-183v-255.8l96-54.8v365.6h32v-384l-447.2-256zM496 850l-272-155.6v-219l272 155.4v219.2zM800 694.4l-272 155.6v-219.2l272-155.4v219zM512 602l-382.8-218 384-219.2 383 219.2-384.2 218z"],"grid":0,"tags":["ios-school-outline"]},{"paths":["M192 489.2v223.8l304 173.8v-224z","M528 886.8l304-173.8v-223.8l-304 173.6z","M512 128l-448 256 448 256 416-237.8v365.8h32v-384z"],"grid":0,"tags":["ios-school"]},{"paths":["M896.6 849.4l-226.6-226.8c41.6-52 66.6-118.2 66.6-190.2 0-168.2-136.2-304.4-304-304.4-168 0-304 136.4-304 304.4s136.2 304.4 304 304.4c72.4 0 138.8-25.4 191-67.6l226.4 226.8 46.6-46.6zM240.2 625.2c-51.4-51.4-79.6-119.8-79.6-192.6s28.4-141.2 79.6-192.6 119.8-80 192.4-80c72.6 0 141 28.4 192.4 79.8s79.6 119.8 79.6 192.6-28.4 141.2-79.6 192.6c-51.4 51.4-119.8 79.8-192.4 79.8-72.6 0.2-141-28.2-192.4-79.6z"],"grid":0,"tags":["ios-search-outline"]},{"paths":["M689 596c30-47.2 47.6-103.2 47.6-163.4 0-168.2-136.2-304.6-304.2-304.6-168.2 0-304.4 136.4-304.4 304.6s136.2 304.6 304.2 304.6c61 0 117.8-18 165.4-48.8l13.8-9.6 217.2 217.2 67.4-68.6-217-217.2 10-14.2zM602.8 262.4c45.4 45.4 70.4 105.8 70.4 170s-25 124.6-70.4 170c-45.4 45.4-105.8 70.4-170 70.4s-124.6-25-170-70.4c-45.4-45.4-70.4-105.8-70.4-170s25-124.6 70.4-170c45.4-45.4 105.8-70.4 170-70.4s124.6 25 170 70.4z"],"grid":0,"tags":["ios-search"]},{"paths":["M192 499.2l233.2 102.6 114.4 230.2 292.4-640-640 307.2zM456.2 593l311.4-332.4-229.2 497.8-82.2-165.4zM763.6 256.6l-330 314.2-165.6-72.8 495.6-241.4z"],"grid":0,"tags":["ios-send-outline"]},{"paths":["M192 499.2l212 93.4 428-400.6z","M832 192l-396.2 431.4 103.8 208.6z"],"grid":0,"tags":["ios-send"]},{"paths":["M378.4 166c13.4 17 29.8 31.6 48.2 42.8 26.6 16.4 56 25 85.4 25s58.8-8.6 85.4-25c18.4-11.2 34.6-25.8 48.2-42.8 9.4 3.4 18.6 7.2 27.6 11.4-6.4 49.6 8.6 93 44.6 128.8 35.8 35.8 74.8 53.8 116 53.8 4.2 0 8.4-0.2 12.6-0.6 4.2 9 8 18.4 11.6 27.8-43.8 32.8-67.8 76.4-67.8 124.6 0 48.4 23.8 91.8 67.6 124.6-3.4 9.4-7.4 18.8-11.6 27.8-4.2-0.4-8.4-0.6-12.4-0.6-41.4 0-80.4 18.2-116.2 53.8-35.8 36-50.8 79.4-44.6 128.8-9 4.2-18.2 8-27.6 11.4-13.4-17-29.8-31.6-48.2-42.8-26.6-16.4-56-25-85.4-25s-58.8 8.6-85.4 25c-18.4 11.2-34.6 25.8-48.2 42.8-9.4-3.4-18.6-7.2-27.6-11.4 6.4-49.8-8.6-93-44.6-128.8-30.6-30.6-66.6-46-107-46-7 0-14.2 0.4-21.6 1.4-4.2-9-8-18.2-11.4-27.6 17-13.4 31.6-29.8 43-48.2 16.4-26.6 25.2-56.2 25.2-85.4 0-48.4-24-91.8-68-124.8 3.4-9.4 7.4-18.8 11.6-27.8 4.2 0.4 8.4 0.6 12.4 0.6 41.4 0 80.4-18.2 116.2-53.8 35.8-36 50.8-79.4 44.6-128.8 8.8-3.8 18-7.6 27.4-11zM512 736c59.8 0 116-23.2 158.4-65.6s65.6-98.6 65.6-158.4-23.2-116-65.6-158.4-98.6-65.6-158.4-65.6-116 23.2-158.4 65.6-65.6 98.6-65.6 158.4c0 123.6 100.4 224 224 224zM632.8 128c-26 44.4-72.8 73.8-120.8 73.8-47.8 0-94.8-29.4-120.8-73.8-26.8 8-52.4 18.6-76.4 31.6 13 49.8 2.6 90-31.2 124-26.6 26.6-57.4 44.4-93.4 44.4-9.8 0-19.8-1.2-30.4-4-13.2 24-23.8 49.6-31.8 76.4 44.4 26 74 63.8 74 111.6s-29.6 94.8-74 120.8c8 26.8 18.6 52.4 31.6 76.4 13.8-3.6 27-5.4 39.4-5.4 32.2 0 60 12.2 84.4 36.6 34 33.8 44.2 74.2 31.2 124 24.2 13 49.6 23.6 76.4 31.6 26-44.4 73-73.8 120.8-73.8s94.8 29.4 120.8 73.8c26.8-8 52.4-18.6 76.4-31.6-13-49.8-2.6-90 31.2-124 26.6-26.6 57.4-44.4 93.6-44.4 9.8 0 19.8 1.2 30.4 4 13-24.2 23.6-49.8 31.6-76.4-44.2-26-73.6-63.8-73.6-111.6s29.6-85.6 73.8-111.6c-8-26.6-18.6-52.4-31.6-76.4-10.6 2.8-20.8 4-30.6 4-36 0-66.6-17.8-93.4-44.4-33.8-33.8-44.2-74.2-31.2-124-24-13-49.6-23.6-76.4-31.6v0zM512 704c-105.8 0-192-86-192-192s86-192 192-192 192 86 192 192c0 106-86 192-192 192v0z"],"grid":0,"tags":["ios-settings-outline"]},{"paths":["M822.2 512c0-47.8 29.6-85.6 73.8-111.6-8-26.6-18.6-52.4-31.6-76.4-49.8 13-90-6.4-124-40.4-33.8-33.8-44.2-74.2-31.2-124-24-13-49.6-23.6-76.4-31.6-26 44.4-72.8 73.8-120.8 73.8-47.8 0-94.8-29.4-120.8-73.8-26.8 8-52.4 18.6-76.4 31.6 13 49.8 2.6 90-31.2 124-33.8 33.8-74.2 53.4-123.8 40.4-13.2 24-23.8 49.6-31.8 76.4 44.4 26 74 63.8 74 111.6s-29.6 94.8-74 120.8c8 26.8 18.6 52.4 31.6 76.4 49.8-13 90-2.6 123.8 31.2 34 33.8 44.2 74.2 31.2 124 24.2 13 49.6 23.6 76.4 31.6 26-44.4 73-73.8 120.8-73.8s94.8 29.4 120.8 73.8c26.8-8 52.4-18.6 76.4-31.6-13-49.8-2.6-90 31.2-124 33.8-33.8 74.2-53.4 124-40.4 13-24.2 23.6-49.8 31.6-76.4-44.2-26-73.6-63.8-73.6-111.6zM512 704c-105.8 0-192-86-192-192s86-192 192-192 192 86 192 192-86 192-192 192z"],"grid":0,"tags":["ios-settings"]},{"paths":["M896 496l-320-304v170.6c-298.6 42.8-405.4 256-448 469.4 106.6-149.4 234.6-217.6 448-217.6v175l320-293.4zM297.8 638.4c-37 18.4-70.4 41.2-102.4 69.4 22.2-60.4 50.6-111.4 85.4-154.2 33.8-41.6 74.4-75.8 120.8-101.6 51.4-28.6 111.6-48 179-57.6l27.4-2.4v-128l241 231.6-241 224.4v-136l-32-2c-111.2 0-202.2 18.6-278.2 56.4z"],"grid":0,"tags":["ios-share-alt-outline"]},{"paths":["M896 496l-320-304v170.6c-298.6 42.8-405.4 256-448 469.4 106.6-149.4 234.6-217.6 448-217.6v175l320-293.4z"],"grid":0,"tags":["ios-share-alt"]},{"paths":["M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z","M386.2 236.2l-23.2-23.2 149-149 149 149-23.2 23.2-109.4-109.4v486h-32.8v-486z"],"grid":0,"tags":["ios-share-outline"]},{"paths":["M528 288v324h-32v-324h-304v608h640v-608z","M528 126.8l109.6 109.4 23.2-23.2-148.8-149-149 149 23.4 23.2 109.6-109.4v161.2h32z"],"grid":0,"tags":["ios-share"]},{"paths":["M745 185.2c-41-29.4-81-57.4-125-57.4s-44 16-108 16-64-16-108-16-84 28-125 57.4c-63.2 45.4-183 172.8-183 172.8l160 186.4v351.6h512v-350.8l160-187.4c0-0-119.8-127.2-183-172.6zM426.2 161.6c19.8 0 50.8 14.6 85.8 14.6s66.2-14.6 85.8-14.6c13.8 0 22.2 7.2 22.2 32 0 46.6-48.4 88-108 88s-108-42.6-108-88c0-24.6 8.2-32 22.2-32zM768 400.2c0-8.8-7.2-16-16-16s-16 7.2-16 16v463.8h-448v-463.8c0-8.8-7.2-16-16-16s-16 7.2-16 16v98.4c-27.2-32-102.8-121.8-117.2-139.2 36-37.4 113.8-115.8 159-148.2 25.8-18.6 52.4-37.6 78.4-46.4-2.8 8.2-4.2 17.8-4.2 29 0 31.4 15.8 62.6 43.2 85.6 26.6 22.2 61 34.4 96.8 34.4 36 0 70.4-12 96.8-33.8 27.4-22.8 43.2-54.2 43.2-86.2 0-11.2-1.4-20.8-4.2-29 26 8.8 52.6 27.8 78.4 46.4 45.2 32.4 122.8 110.8 158.8 148.2-14.8 18-92.2 109.8-117.2 139.2v-98.4z"],"grid":0,"tags":["ios-shirt-outline"]},{"paths":["M745 185.4c-41-29.4-81-57.4-125-57.4s-44 16-108 16-64-16-108-16-84 28-125 57.4c-63.2 45.4-183 172.6-183 172.6s69.2 82.6 103.4 122c25.4 29.4 32 35.6 32 0 0-85.4 0-96 12.6-96s12 7.2 12 16v496h512v-496c0-8.8-0.6-16 12-16s12.6 10.6 12.6 96c0 35.6 6.6 29.4 32 0 34-39.4 103.4-122 103.4-122s-119.8-127.2-183-172.6zM512 282c-60 0-108-41.4-108-88 0-60 48-17.4 108-17.4 59.6 0 108-42.6 108 17.4 0 46.6-48.4 88-108 88z"],"grid":0,"tags":["ios-shirt"]},{"paths":["M886.6 651.4l-71.2-70.8c-6.2-6.2-16.4-6.2-22.6 0s-6.2 16.4 0 22.6l53.2 52.8h-198l-251.6-314.4c-3-3.6-7.8-5.6-12.6-5.6h-239.8c-8.8 0-16 7.2-16 16s7.2 16 16 16h232.6l114.6 144-114.6 144h-232.6c-8.8 0-16 7.2-16 16s7.2 16 16 16h240c4.8 0 9.2-2 12.2-5.6l115.8-145.4 115.8 145.4c3 3.6 7.6 5.6 12.2 5.6h210l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l67.2-66.8c12.4-12.6 12.4-32.8-0.2-45.2z","M647.4 368h198.4l-53.2 52.8c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l71.2-70.8c12.4-12.4 12.4-32.6 0-45l-67.2-66.8c-3.2-3.2-7.2-4.6-11.4-4.6s-8.2 1.6-11.4 4.6c-6.2 6.2-6.2 16.4 0 22.6l53.2 52.8h-209.6c-4.8 0-9.2 2-12.2 5.6l-94.6 120.4 21 24.8 93.2-119z"],"grid":0,"tags":["ios-shuffle"]},{"paths":["M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158zM351.2 512l15.2-8.8 433.6-255.2v528l-448.8-264zM224 224h94v576h-94v-576z"],"grid":0,"tags":["ios-skip-backward-outline"]},{"paths":["M192 192v640h158v-283.6l482 283.6v-640l-482 283.6v-283.6h-158z"],"grid":0,"tags":["ios-skip-backward"]},{"paths":["M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158zM657.8 520.8l-433.8 255.2v-528l449 264-15.2 8.8zM800 800h-94v-576h94v576z"],"grid":0,"tags":["ios-skip-forward-outline"]},{"paths":["M674 192v283.6l-482-283.6v640l482-283.6v283.6h158v-640h-158z"],"grid":0,"tags":["ios-skip-forward"]},{"paths":["M863.4 696.8l-75.2-43.8c26.2-33.8 64.2-49.6 64.8-49.8 8.6-3.4 13.2-13.4 10.4-22.2s-12.2-13.2-20.8-9.6c-2.2 1-50.2 20.6-82.6 65l-213.6-124.4 213.4-124.4c32.2 44.4 80.4 64.2 82.6 65 8.6 3.4 18-0.8 20.8-9.6s-1.8-18.8-10.4-22.2c-0.4-0.2-38.6-15.8-64.8-49.8l75.2-43.8c8.2-4.8 11-15.4 6.2-23.8s-15.2-11.2-23.6-6.4l-75.2 43.8c-15.8-39.6-10.4-81-10.2-81.4 1.4-9.2-4.8-18.4-13.8-20.2s-17.4 4.2-18.6 13.4c-0.4 2.4-7 54.2 15 104.8l-213 124.4v-248c54-6 95-38 97-39.6 7.4-5.8 8-16 2-23-6.2-7-16.8-7.8-24-2-0.4 0.2-32.8 25.8-74.8 31.6v-87.4c0-9.6-8.4-17.4-18-17.4s-18 7.8-18 17.4v87.4c-42-6-74.4-31.4-74.8-31.6-7.4-5.8-18-4.8-24.2 2-6.2 7-5.4 17.2 1.8 23 1.8 1.4 43 33.6 97 39.6v248.2l-213-124.4c22-50.4 15-102.4 14.8-104.8-1.4-9.2-9.6-15.2-18.6-13.4s-15.2 11-13.8 20.2c0 0.4 5.6 41.6-10.2 81.4l-75.2-43.8c-8.2-4.8-18.8-2-23.6 6.4s-2 19 6.4 23.8l75.2 43.8c-26 33.6-64.2 49.6-64.6 49.8-8.6 3.4-13.2 13.4-10.4 22.2s12.2 13.2 20.8 9.6c2.2-0.8 50.2-20.6 82.6-65l213.2 124.2-213.4 124.4c-32.2-44.4-80.4-64.2-82.6-65-8.6-3.4-18 0.8-20.8 9.6s1.8 18.8 10.4 22.2c0.4 0.2 38.6 16 64.6 49.8l-75.2 43.8c-8.2 4.8-11 15.4-6.2 23.8s15.2 11.2 23.6 6.4l75.2-43.8c16 39.8 10.4 81 10.2 81.4-1.4 9.2 4.8 18.4 13.8 20.2s17.4-4.2 18.6-13.4c0.4-2.4 7-54.2-15-104.8l213.2-124.4v248.2c-54 6-95 38-97 39.6-7.4 5.8-8 16-2 23 6.2 7 16.8 7.8 24 2 0.4-0.2 32.8-25.6 74.8-31.6v87.4c0 9.6 8.4 17.4 18 17.4s18-7.8 18-17.4v-87.4c42 6 74.4 31.4 74.8 31.6 7.4 5.8 18 4.8 24.2-2 6.2-7 5.4-17.2-1.8-23-1.8-1.4-43-33.6-97-39.6v-248.2l213 124.4c-22 50.4-15 102.4-14.8 104.8 1.4 9.2 9.6 15.2 18.6 13.4s15.2-11 13.8-20.2c0-0.4-5.6-41.8 10.2-81.4l75.2 43.8c8.2 4.8 18.8 2 23.6-6.4s2-19-6.2-23.8z"],"grid":0,"tags":["ios-snow-outline"]},{"paths":["M871.4 683l-58.2-34c21.4-20.8 45.4-30.8 45.6-31 16.6-6.6 25.2-25.2 19.6-42-4.2-13-16.4-21.8-30-21.8-4.2 0-8.2 0.8-12 2.4-5 2-47 19.8-80.6 59l-175.6-103.6 175.8-103.6c34.2 40.2 78.4 58.2 80.6 59.2 3.8 1.6 8 2.4 12 2.4 13.6 0 25.6-8.8 30-21.8 5.6-17-3-35.4-19.6-42-0.2-0.2-24.4-10.2-45.8-31l58.2-34c15.8-9.2 21.2-29.6 12.2-45.6-6-10.4-17-16.8-28.8-16.8-5.8 0-11.6 1.6-16.6 4.6l-58 33.8c-7-29-3.6-55-3.6-55.2 2.6-17.8-9-34.6-26.4-38.2-2.2-0.4-4.4-0.6-6.6-0.6-15.6 0-28.6 11.2-31.2 26.8l-0.2 0.6c-4.8 20.8-6.2 61.6 7 101.8l-173.2 102.2v-207.2c50-9.4 83.6-32.6 88.8-36.8 8.4-6.6 13.8-16.2 14.8-25.6 0.6-7.6-1.8-15-6.6-20.6-6.4-7.2-16.8-11.2-28.6-11.2-8.8 0-16.8 2.4-22.8 6.8-2.8 1.8-17.6 13-45.6 21v-67.6c0-18-15.6-33.4-34-33.4s-34 15.2-34 33.4v67.4c-22-7.4-37.2-17.4-45.4-22.8-8.2-5.6-18.2-8.4-24.2-8.4-5.8 0-19.6 0.2-27.4 13.2-6 9.8-5.6 18.4-4.8 23.6 1 5.8 3.8 12.6 11 20.4s46.8 32.2 90.8 40.6v206l-183.2-102.6c18.8-52 14.8-99.8 14.8-100.4-2.4-16.4-14-27.4-29.2-27.4-2.2 0-4.4 0.2-6.4 0.6-17 3.6-28 20-25.4 38.2 0.2 1.2 3.8 26.6-3.2 55.2l-59.6-33.8c-5-3-10.8-4.6-16.6-4.6-11.8 0-22.8 6.4-28.8 16.8-9 15.8-3.6 36.2 12.2 45.6l58.2 34c-21.4 20.6-45.4 30.8-45.6 31-16.6 6.6-25.2 25.2-19.6 42 4.2 13 16.4 21.8 30 21.8 4.2 0 8.2-0.8 12-2.4 2-0.8 46.2-19 80.6-59.2l179.8 103.6-179.8 103.6c-33.4-39.4-75.4-57-80.6-59-3.8-1.6-8-2.4-12-2.4-13.6 0-25.6 8.8-30 21.8-5.6 17 3 35.4 19.4 42 0.2 0.2 24.4 10.4 45.8 31l-58.2 34c-15.8 9.2-21.2 29.6-12.2 45.6 6 10.4 17 16.8 28.8 16.8 5.8 0 11.6-1.6 16.6-4.6l58-33.8c7 29 3.6 55 3.6 55.2-2.6 17.8 9 34.4 26.4 38.2 2.2 0.4 4.4 0.6 6.6 0.6 15.8 0 29-11.6 31.2-27.4 1-6.8 6.4-53.6-10.8-100.4l177.2-102.6v206c-42 8.4-79.6 32.8-90.8 42.6l-0.2 0.2c-5.8 4.6-9.2 11.2-9.8 18.6-0.8 9.2 2.8 19.2 10.2 27.4 2.4 2.8 10 11.2 21.6 11.2 6.2 0 12.2-2.4 18.4-7.2l1-0.8c2-1.8 26-17.6 50-25.4v67.4c0 18 15.6 33.4 34 33.4s34-15.2 34-33.4v-67.8c30 8 44.4 21.2 47.6 23.2 5.8 4.4 13.6 6.6 21.8 6.6 11.2 0 21.2-4 27.4-11.2 4.6-5.4 7-12.2 6.4-19.2-0.8-9.4-7-19.4-16.2-26.8-0.4-0.4-33-28.8-87-38.8v-205l173.2 102.2c-14.4 42.6-9.6 83.2-6.6 99.6v0.4c2.4 15.6 12.6 27.2 29 27.2 2.2 0 4.4-0.2 6.6-0.6 17.6-3.6 29.8-20.6 27.4-38-0.2-1.6-2.8-27.2 4-55.6l58.2 34.2c5 3 10.8 5 16.6 5 0 0 0 0 0 0 12 0 23-6.8 28.8-17.2 9-15.6 3.6-36.4-12.2-45.6z"],"grid":0,"tags":["ios-snow"]},{"paths":["M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z","M864 160v704h-704v-704h704zM896 128h-768v768h768v-768z"],"grid":0,"tags":["ios-square-outline"]},{"paths":["M432 714c0.8 0 0.8-0.2 0-0.4-0.8 0.2-1 0.4 0 0.4z","M896 128h-768v768h768v-768z"],"grid":0,"tags":["ios-square"]},{"paths":["M352 896h128v-768h-128v768zM384 160h64v704h-64v-704z","M160 896h128v-320h-128v320zM192 608h64v256h-64v-256z","M544 896h128v-448h-128v448zM576 480h64v384h-64v-384z","M736 256v640h128v-640h-128zM832 864h-64v-576h64v576z"],"grid":0,"tags":["ios-stats-outline"]},{"paths":["M352 896h128v-768h-128v768z","M160 896h128v-320h-128v320z","M544 896h128v-448h-128v448z","M736 256v640h128v-640h-128z"],"grid":0,"tags":["ios-stats"]},{"paths":["M694.4 928h45.6l-98.6-96h-45.6l32.2 32h-232l32.2-32h-45.6l-98.6 96h45.6l34.2-32h296.4z","M400 144h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16z","M688 128c53 0 96 43 96 96v448c0 53-43 96-96 96h-352c-53 0-96-43-96-96v-448c0-53 43-96 96-96h352zM336 512h356c35.2 0 64-28.8 64-64v-192c0-35.2-28.6-64-64-64h-356c-35.2 0-64 28.8-64 64v192c0 35.2 28.6 64 64 64zM673 751c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88zM353 751c48.6 0 88-39.4 88-88s-39.4-88-88-88-88 39.4-88 88 39.4 88 88 88zM688 96h-352c-70.6 0-128 57.4-128 128v448c0 70.6 57.4 128 128 128h352c70.6 0 128-57.4 128-128v-448c0-70.6-57.4-128-128-128v0zM336 480c-17.6 0-32-14.4-32-32v-192c0-17.6 14.4-32 32-32h356c17.6 0 32 14.4 32 32v192c0 17.6-14.4 32-32 32h-356zM673 719c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56v0zM353 719c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56v0z"],"grid":0,"tags":["ios-subway-outline"]},{"paths":["M688 96h-352c-70.4 0-128 57.6-128 128v448c0 70.4 57.6 128 128 128h352c70.4 0 128-57.6 128-128v-448c0-70.4-57.6-128-128-128zM400 144h224c8.8 0 16 7.2 16 16s-7.2 16-16 16h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16zM336 752c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56zM688 752c-31 0-56-25-56-56s25-56 56-56c31 0 56 25 56 56s-25 56-56 56zM768 448c0 17.6-14.4 32-32 32h-447.6c-17.6 0-32.4-14.4-32.4-32v-191.6c0-17.6 14.8-32.4 32.4-32.4h447.6c17.6 0 32 14.8 32 32.4v191.6z","M738.4 928h45.6l-98.6-96h-45.6l32.2 32h-320l32.2-32h-45.6l-98.6 96h45.6l34.2-32h384.4z"],"grid":0,"tags":["ios-subway"]},{"paths":["M496 800h32v128h-32v-128z","M496 96h32v128h-32v-128z","M96 496h128v32h-128v-32z","M800 496h128v32h-128v-32z","M296.903 704.327l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z","M794.978 206.523l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z","M319.809 297.039l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z","M817.341 794.842l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z","M512 352c88.2 0 160 71.8 160 160s-71.8 160-160 160c-88.2 0-160-71.8-160-160s71.8-160 160-160zM512 320c-105.8 0-192 86.2-192 192s86.2 192 192 192c105.8 0 192-86.2 192-192s-86.2-192-192-192v0z"],"grid":0,"tags":["ios-sunny-outline"]},{"paths":["M496 800h32v128h-32v-128z","M496 96h32v128h-32v-128z","M96 496h128v32h-128v-32z","M800 496h128v32h-128v-32z","M296.903 704.327l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z","M794.978 206.523l22.627 22.627-90.509 90.509-22.627-22.627 90.509-90.509z","M319.809 297.039l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z","M817.341 794.842l-22.627 22.627-90.509-90.509 22.627-22.627 90.509 90.509z","M512 320c-105.8 0-192 86.2-192 192s86.2 192 192 192c105.8 0 192-86.2 192-192s-86.2-192-192-192v0z"],"grid":0,"tags":["ios-sunny"]},{"paths":["M779 186l-22.6 23.2 141.6 142.8h-514v32h514l-141.6 141.8 22.6 22.4 181-181.2z","M245 473.8l22.6 23.2-141.6 143h514v32h-514l141.6 141.8-22.6 22.2-181-181z"],"grid":0,"tags":["ios-swap"]},{"paths":["M288 640c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96zM288 608c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z","M734.4 576c88.8 0 161.2 72.2 161.2 161s-72 159-160.8 159h-446c-88.8 0-161-70.2-161-159s72.2-161 161-161h445.2zM735 544h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193v0z","M736 192c53 0 96 43 96 96s-43 96-96 96-96-43-96-96 43-96 96-96zM736 160c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z","M290 128h445c88.8 0 161 72.2 161 161s-72.2 159-161 159h-446c-88.8 0-160.8-70.2-160.8-159s72.6-161 161.4-161zM289 96c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193h-446z"],"grid":0,"tags":["ios-switch-outline"]},{"paths":["M735 544h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191h446c106.6 0 193-84.4 193-191s-86.4-193-193-193zM288 864c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128z","M289 480h446c106.6 0 193-84.4 193-191s-86.4-193-193-193h-446c-106.6 0-193 86.4-193 193s86.4 191 193 191zM736 160c70.6 0 128 57.4 128 128s-57.4 128-128 128-128-57.4-128-128c0-70.6 57.4-128 128-128z"],"grid":0,"tags":["ios-switch"]},{"paths":["M986.8 512l-63.6 63.6c19.4-126-19.6-260.4-117-357.8-162.4-162.4-426-162.6-588.4 0-32.6 32.6-58.6 69-78 108l31 15.6c17.8-35.8 41.6-69.4 71.4-99.2 148.6-148.6 390.6-148.6 539.4 0.2 91.2 91.2 126.4 217.2 105.8 336l-68.2-66.4-21.6 21.6 106.4 106.4 105.4-105.4-22.6-22.6z","M781.6 781.6c-148.6 148.6-390.6 148.8-539.4 0-91-91.2-126.2-217.8-105.6-335.8l66.2 66.2 22.6-22.6-105.4-105.4-105.4 105.4 22.6 22.6 63.6-63.6c-19.6 126.8 19.4 260.4 116.8 357.8 162.4 162.4 426 162.4 588.4 0 32.6-32.6 58.6-69.2 78-108l-31-15.6c-17.8 35.8-41.6 69.2-71.4 99z"],"grid":0,"tags":["ios-sync"]},{"paths":["M64 220v584c0 15.6 12.2 28 28 28h840c15.8 0 28-12.4 28-28v-584c0-15.6-12.2-28-28-28h-840c-15.8 0-28 12.6-28 28zM97.4 512.8c0-7.8 6.2-14 14-14s14 6.2 14 14c0 7.8-6.2 14-14 14-7.6 0-14-6.4-14-14zM940 512c0 15.4-13 28-28.2 28-15 0-28-12.4-28-28 0-15.4 12.8-28.2 28-28.2 15.2 0.2 28.2 12.8 28.2 28.2zM864 224v576h-704v-576h704z"],"grid":0,"tags":["ios-tablet-landscape"]},{"paths":["M804 64h-584c-15.6 0-28 12.2-28 28v840c0 15.8 12.4 28 28 28h584c15.6 0 28-12.2 28-28v-840c0-15.8-12.6-28-28-28zM511.2 97.4c7.8 0 14 6.2 14 14s-6.2 14-14 14c-7.8 0-14-6.2-14-14-0-7.6 6.4-14 14-14zM512 940c-15.4 0-28-13-28-28.2 0-15 12.4-28 28-28 15.4 0 28.2 12.8 28.2 28-0.2 15.2-12.8 28.2-28.2 28.2zM800 864h-576v-704h576v704z"],"grid":0,"tags":["ios-tablet-portrait"]},{"paths":["M512 224c194 0 352 124 352 276.6 0 71.8-35.2 138.4-99 187.8-65.6 50.8-154.8 78.6-251 78.6-57.8 0-102-6-139.4-18.6-1.2-0.4-2.6-1-4-1.4-0.6-0.2-1.2-0.4-1.6-0.4-9.4-2.8-19.4-4.2-29.4-4.2-11.2 0-22.2 1.8-32.6 5.2v0l-0.6 0.2c-1.2 0.4-17.8 6.6-22 8.6v0l-79.2 34.4c27.6-87.8 27.6-89.6 27.6-95.2 0-14.2-4.4-28.2-12.6-40.4-1-1.4-2-2.8-3.2-4.2-1.4-1.8-2.6-3.4-3.6-4.6-34.8-43.8-53.2-94.2-53.2-146-0.2-152.4 157.8-276.4 351.8-276.4zM512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"],"grid":0,"tags":["ios-text-outline"]},{"paths":["M512 192c-212.2 0-384 138.2-384 308.6 0 61.4 22.4 118.6 60.8 166.6 1.8 1.8 5.8 7.6 7.2 9.8 0 0-2-3.2-2.2-3.8 0 0 0 0 0 0v0c0 0 0 0 0 0 4.6 6.6 7.2 14.2 7.2 22.4 0 2.8-35.8 116-35.8 116v0c-2.6 8.8 4.2 17.8 15.2 20 1.6 0.4 3.2 0.4 4.8 0.4 2.6 0 5-0.4 7.4-1l3.2-1.2 101.2-44c1.8-0.8 18-7 20-7.8 0 0 1.2-0.4 1.2-0.4s-0.2 0-1.2 0.4c6.8-2.4 14.4-3.6 22.4-3.6 7.2 0 14.2 1 20.6 3 0.2 0 0.4 0 0.4 0.2 1 0.4 2 0.6 3 1 46.2 15.8 96.8 20.6 150.2 20.6 212 0 382-128.2 382-298.6 0.4-170.4-171.6-308.6-383.6-308.6v0z"],"grid":0,"tags":["ios-text"]},{"paths":["M606 600.6v-443.8c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-97.8 95.6-97.8 167.4 0 106 86 192 192 192s192-86 192-192c0-71.8-40.2-134.6-98.2-167.4zM625 881.2c-30.2 30.2-70.2 46.8-113 46.8-88.4 0-160.2-71.8-160.2-160 0-57.6 31.6-111 81.6-139.6l16.6-9.2v-462.4c0-33.6 27.8-61 62-61s62 27.4 62 61v462.2l15.8 9.2c50.8 28.8 82 82.2 82 139.8 0 42.8-16.8 83-46.8 113.2z","M544 644v-356c0-17.6-14.4-32-32-32s-32 14.4-32 32v356c-56 14.2-96.2 64.4-96.2 124 0 70.6 57.2 128 128 128s128.2-57.4 128.2-128c-0.2-59.6-42-109.8-96-124z"],"grid":0,"tags":["ios-thermometer-outline"]},{"paths":["M606 600.6v-443.6c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-98 95.6-98 167.2 0 106 85.8 192 191.8 192s192.2-86 192.2-192c0-72-40-134.6-98-167.4zM512.4 896c-70.6 0-128-57.2-128-128 0-59.6 39.6-109.8 95.6-124v-356c0-17.6 14.4-32 32-32s32 14.4 32 32v356c54 14.2 96.2 64.4 96.2 124 0 70.6-57.2 128-127.8 128z","M607.6 768.4c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z"],"grid":0,"tags":["ios-thermometer"]},{"paths":["M428.6 96c77 0 160.4 8.2 225.2 16.2 43 5.2 68.2 15 92.8 24.2 31.8 12.2 62 23.6 133.4 23.6 8.8 0 16 7.2 16 16s-7.2 16-16 16c-77.4 0-111.6-13-144.8-25.8-23.6-9-46-17.6-85.2-22.4-97.2-12-223-22-330.8-8.2-74.8 9.4-112.2 25-124.4 54.6-4.2 10 1 21.8 5.4 32.2 3 7 5.8 13.2 5.8 19.6 0 11-8.2 17.8-17.8 25.6-12.6 10.4-28.2 23.2-28.2 41.6 0 18.2 9.6 29.6 18.8 40.6 7.4 9 15.2 18.2 15.2 30.2 0 11.2-5.8 19-10.6 25.2-6.4 8.4-13.4 17.8-13.4 42.8 0 17.6 9 25 19.2 33.6 9.2 7.6 28.4 23.6 11.8 47.6-14.6 21-5 45.2 4.8 56.2 10.6 12 16.4 15.6 67.2 12.6 34.4-2 108.4-13.6 157.4-21.2 22.4-3.6 38.6-6 44.8-6.6 9.8-1 23-2.4 35.6 0.8 16.6 4.4 27.6 15.8 31.8 33.2 3.8 15.6-3 29-12.2 47.8-7.4 15.2-17.8 36-27 66.8-14.6 48-19.4 120 2.6 159.6 5.4 9.8 13.8 15.6 25.2 17.4 12 1.8 22-1.8 24.6-3.8 3-5 8-25 12-41 6.6-26.2 14.6-64.8 25.8-89.4 16.4-36.2 69.4-84.8 122-131.4 8-7 14.8-13.2 19.6-17.6 14.8-13.6 31.6-38.2 46.4-60 12-17.6 22.4-33 31.2-41.6 18.8-18.8 45.4-31.2 67.4-31.2 8.8 0 16 7.2 16 16s-7.2 16-16 16c-11.4 0-30.4 7.4-44.6 21.8-6.6 6.6-16.8 21.4-27.4 37-15.8 23-33.6 49.2-51 65.4-5 4.8-12.2 11-20.2 18.2-34.6 30.6-99 87.6-114 120.8-10 22-17.8 59-24 84-7.6 30.6-11.6 45.6-18.4 53.6-9.2 11-26.8 15.8-49.8 15.8s-41.6-14.4-52.6-34.2c-23.4-42-25.4-118-5.4-184.4 10-33.4 21-55.4 29-71.6 6-12.2 10.8-21.8 9.8-26-2.4-9.6-7.4-12.4-32.8-9.8-5.4 0.6-23 3.4-43.2 6.4-49.6 7.8-124.4 19.4-160.4 21.6-52.2 3-72 0.2-92.8-23.4-20.4-23-29.6-63.2-7.4-95.4-1.6-1.4-3.8-3.4-5.8-5-11.8-9.8-31.2-25.8-31.2-58.6 0-35.8 12-51.6 20-62.2 1.4-1.8 3.2-4.4 3.8-5.6-1.2-2.2-4.8-6.6-7.6-10-10.4-12.4-26.2-31.4-26.2-61.2 0-33.6 25-54.2 39.8-66.4 1.4-1.2 3.2-2.6 4.8-4-0.6-1.2-1.2-2.6-1.6-3.8-5.6-13-15.2-34.6-5.6-57.4 21.8-52.4 88.2-66.8 150.4-74 33-3.4 72-7.4 112.8-7.4z"],"grid":0,"tags":["ios-thumbs-down-outline"]},{"paths":["M128 309.2c0 29.8 15.8 48.6 26.2 61.2 2.8 3.2 6.4 7.6 7.6 10-0.6 1.2-2.4 3.8-3.8 5.6-8 10.4-20 26.4-20 62.2 0 32.8 19.4 48.8 30.8 58.2 1.8 1.6 4.2 3.4 5.8 5-22.2 32.2-13 72.4 7.4 95.4 21 23.6 40.6 26.4 92.8 23.4 36-2.2 111-13.8 160.4-21.6 20.2-3.2 37.8-6 43.2-6.4 25.4-2.6 30.4 0 32.8 9.8 1 4.2-3.8 13.8-9.8 26-8 16.2-19 38.4-29 71.6-20.2 66.4-18 142.4 5.4 184.4 11 19.8 29.6 34.2 52.6 34.2s40.6-4.8 49.8-15.8c6.8-8 10.6-23.2 18.4-53.6 6.2-24.8 14-61.8 24-84 15-33.2 79.4-90.2 114-120.8 8.2-7.2 15.2-13.4 20.2-18.2 17.4-16.2 35.2-42.2 51-65.4 10.8-15.6 20.8-30.4 27.4-37 14.2-14.2 33.2-21.8 44.6-21.8 8.8 0 16-7.2 16-16v-319.6c0-8.8-7.2-16-16-16-71.4 0-101.4-11.4-133.4-23.6-24.4-9.4-49.8-19-92.8-24.2-64.8-8-148.4-16.2-225.2-16.2-40.8 0-79.8 4-113.2 7.8-62 7.2-128.4 21.6-150.4 74-9.4 22.8 0 44.4 5.6 57.4 0.6 1.2 1 2.4 1.6 3.8-1.6 1.2-3.2 2.8-4.8 4-14.2 12.2-39.2 32.6-39.2 66.2z"],"grid":0,"tags":["ios-thumbs-down"]},{"paths":["M595.4 928c-77 0-160.4-8.2-225.2-16.2-43-5.2-68.2-15-92.8-24.2-31.8-12.2-62-23.6-133.4-23.6-8.8 0-16-7.2-16-16s7.2-16 16-16c77.4 0 111.6 13 144.8 25.8 23.6 9 46 17.6 85.2 22.4 97.2 12 223 22 330.8 8.2 74.8-9.4 112.2-25 124.4-54.6 4.2-10-1-21.8-5.4-32.2-3-7-5.8-13.2-5.8-19.6 0-11 8.2-17.8 17.8-25.6 12.6-10.2 28.2-23 28.2-41.6 0-18.2-9.6-29.6-18.8-40.6-7.4-9-15.2-18.2-15.2-30.2 0-11.2 5.8-19 10.6-25.2 6.4-8.4 13.4-17.8 13.4-42.8 0-17.6-9-25-19.2-33.6-9.2-7.6-28.4-23.6-11.8-47.6 14.6-21 5-45.2-4.8-56.2-10.6-12-16.4-15.6-67.2-12.6-34.4 2-108.4 13.6-157.4 21.2-22.4 3.6-38.6 6-44.8 6.6-9.8 1-23 2.4-35.6-0.8-16.6-4.4-27.6-15.8-31.8-33.2-3.8-15.6 3-29 12.2-47.8 7.4-15.2 17.8-36 27-66.8 14.6-48 19.4-120-2.6-159.6-5.4-9.8-13.8-15.6-25.2-17.4-12-1.8-22 1.8-24.6 3.8-3 5-8 25-12 41-6.6 26.2-14.6 64.8-25.8 89.4-16.4 36.2-69.4 84.8-122 131.4-8 7-14.8 13.2-19.6 17.6-14.8 13.6-31.6 38.2-46.4 60-12 17.6-22.4 33-31.2 41.6-18.8 18.8-45.4 31.2-67.4 31.2-8.8 0-16-7.2-16-16s7.2-16 16-16c11.4 0 30.4-7.4 44.6-21.8 6.6-6.6 16.8-21.4 27.4-37 15.8-23 33.6-49.2 51-65.4 5-4.8 12.2-11 20.2-18.2 34.6-30.6 99-87.6 114-120.8 10-22 17.8-59 24-84 7.6-30.6 11.6-45.6 18.4-53.6 9.2-11 26.8-15.8 49.8-15.8s41.6 14.4 52.6 34.2c23.4 42 25.4 118 5.4 184.4-10 33.4-21 55.4-29 71.6-6 12.2-10.8 21.8-9.8 26 2.4 9.6 7.4 12.4 32.8 9.8 5.4-0.6 23-3.4 43.2-6.4 49.6-7.8 124.4-19.4 160.4-21.6 52.2-3 72-0.2 92.8 23.4 20.4 23 29.6 63.2 7.4 95.4 1.6 1.4 3.8 3.4 5.8 5 11.6 9.6 30.8 25.6 30.8 58.2 0 35.8-12 51.6-20 62.2-1.4 1.8-3.2 4.4-3.8 5.6 1.2 2.2 4.8 6.6 7.6 10 10.4 12.4 26.2 31.4 26.2 61.2 0 33.6-25 54.2-39.8 66.4-1.4 1.2-3.2 2.6-4.8 4 0.6 1.2 1.2 2.6 1.6 3.8 5.6 13 15.2 34.6 5.6 57.4-21.8 52.4-88.2 66.8-150.4 74-32.6 3.8-71.6 7.8-112.4 7.8z"],"grid":0,"tags":["ios-thumbs-up-outline"]},{"paths":["M896 714.8c0-29.8-15.8-48.6-26.2-61.2-2.8-3.2-6.4-7.6-7.6-10 0.6-1.2 2.4-3.8 3.8-5.6 8-10.4 20-26.4 20-62.2 0-32.8-19.4-48.8-30.8-58.2-1.8-1.6-4.2-3.4-5.8-5 22.2-32.2 13-72.4-7.4-95.4-21-23.6-40.6-26.4-92.8-23.4-36 2.2-111 13.8-160.4 21.6-20.2 3.2-37.8 6-43.2 6.4-25.4 2.6-30.4 0-32.8-9.8-1-4.2 3.8-13.8 9.8-26 8-16.2 19-38.4 29-71.6 20.2-66.4 18-142.4-5.4-184.4-11-19.8-29.6-34.2-52.6-34.2s-40.6 4.8-49.8 15.8c-6.8 8-10.6 23.2-18.4 53.6-6.2 24.8-14 61.8-24 84-15 33.2-79.4 90.2-114 120.8-8.2 7.2-15.2 13.4-20.2 18.2-17.4 16.2-35.2 42.2-51 65.4-10.8 15.6-20.8 30.4-27.4 37-14.2 14.2-33.2 21.8-44.6 21.8-8.8 0-16 7.2-16 16v319.6c0 8.8 7.2 16 16 16 71.4 0 101.4 11.4 133.4 23.6 24.4 9.4 49.8 19 92.8 24.2 64.8 8 148.4 16.2 225.2 16.2 40.8 0 79.8-4 113.2-7.8 62-7.2 128.4-21.6 150.4-74 9.4-22.8 0-44.4-5.6-57.4-0.6-1.2-1-2.4-1.6-3.8 1.6-1.2 3.2-2.8 4.8-4 14.2-12.2 39.2-32.6 39.2-66.2z"],"grid":0,"tags":["ios-thumbs-up"]},{"paths":["M566.4 352l-35.6 118.8-12.4 41.2h105.6l-138.4 219.6 31-115.4 10.8-40.4h-145.6l49.8-224h134.8zM609.4 320h-203.4l-64 288h143.6l-85.6 320 282-448h-120.6l48-160z","M748.8 283.8l-26.6-0.2c-23.4-107.2-110.2-187.6-250.2-187.6s-255.6 100.8-255.6 243l0.6 9.6c-84.4 11.2-153 90.6-153 179.4 0 94 75.8 176 169.4 176h194.6l8.4-32c-126 0-203 0-203 0-36 0-70.2-16.2-96.4-43.8-26-27.4-40.8-64.8-40.8-102 0-35 13.2-69.6 37-97 23.6-27 54.8-44.4 88.2-49l29.6-4-2-29.8-0.6-8.6c0.2-58.6 23.4-112.6 65.2-151.8s98-58.8 158.4-58.8c58.6 0 110 14.6 148.6 45.8 35.4 28.8 59.8 69.4 70.4 117.4l5.8 26.8c23-1.4 52-1.4 52-1.4 49 0 94.2 17.2 127.4 48.2 33.4 31.2 51.6 74.4 51.6 121.6 0 89.4-67.4 169.4-153.6 183.6 0 0-17.8 2.8-40.4 2.8-7.4 0-140.8 0-140.8 0l-20.4 32h161.4c144 0 226-104 226-220 0-117.2-94.6-200.2-211.2-200.2z"],"grid":0,"tags":["ios-thunderstorm-outline"]},{"paths":["M748.8 283.8l-26.6-0.2c-23.4-107.2-110.2-187.6-250.2-187.6s-255.6 100.8-255.6 243l0.6 9.6c-84.4 11.2-153 90.6-153 179.4 0 94 75.8 176 169.4 176h193.6l17.2-64h-141.8l8.6-39 64-288 5.6-25h271.8l-12.4 41.2-35.6 118.8h135.6l-30.8 49-130.4 207h155.2c144 0 226-104 226-220 0-117.2-94.6-200.2-211.2-200.2z","M682 480h-120.6l48-160h-203.4l-64 288h144l-85.8 320z"],"grid":0,"tags":["ios-thunderstorm"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 893.4c-210.2 0-381.4-171-381.4-381.4 0-210.2 171-381.4 381.4-381.4 210.2 0 381.4 171 381.4 381.4 0 210.2-171.2 381.4-381.4 381.4z","M512 512h-192v34.6h226.6v-290.6h-34.6z"],"grid":0,"tags":["ios-time-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM546 546h-226v-34h192v-256h34v290z"],"grid":0,"tags":["ios-time"]},{"paths":["M694.4 928h45.6l-109-106.4-35.2 10.4 32.2 32h-232l32.2-32-34.8-10.4-109.4 106.4h45.6l34.2-32h296.4z","M512 736c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM512 579c-33.6 0-61 27.4-61 61s27.4 61 61 61 61-27.4 61-61-27.4-61-61-61z","M674 128h-34c0-17.6-14.4-32-32-32h-192c-17.6 0-32 14.4-32 32h-30c-70.6 0-130 55.4-130 126v448c0 70.6 288 130 288 130s288-59.4 288-130v-448c0-70.6-55.4-126-126-126zM418 128h188v32h-188v-32zM768 701c0 3.2-17.4 28.6-130 63.8-54.4 17-107.4 30.8-125.2 34.6-17.8-3.8-71-17.4-125.4-34.4-113-35.2-129.4-60.6-131.4-63.8v-447.2c0-52.4 44.6-94 98-94h30c0 17.6 14.4 32 32 32h192c17.6 0 32-14.4 32-32h34c25.6 0 49 9.4 66.8 27.2s27.2 41.2 27.2 66.8v447z","M672 288c0 0 0 0 0 0v128c0 0 0 0 0 0h-320c0 0 0 0 0 0v-127.8c0 0 0-0.2 0-0.2h320zM672 256h-320c-17.6 0-32 14.4-32 32v128c0 17.6 14.4 32 32 32h320c17.6 0 32-14.4 32-32v-128c0-17.6-14.4-32-32-32v0z"],"grid":0,"tags":["ios-train-outline"]},{"paths":["M595.8 832l32.2 32h-232l32.2-32-34.8-10.4-109.4 106.4h45.6l34.2-32h296.4l34.2 32h45.6l-109-106.4z","M674 128h-34c0-17.6-14.4-32-32-32h-192c-17.6 0-32 14.4-32 32h-30c-70.6 0-130 55.4-130 126v448c0 70.6 288 130 288 130s288-59.4 288-130v-448c0-70.6-55.4-126-126-126zM418 128h188v32h-188v-32zM512 736c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96zM704 416c0 17.6-14.4 32-32 32h-320c-17.6 0-32-14.4-32-32v-128c0-17.6 14.4-32 32-32h320c17.6 0 32 14.4 32 32v128z","M512 579c-33.6 0-61 27.4-61 61s27.4 61 61 61 61-27.4 61-61-27.4-61-61-61z"],"grid":0,"tags":["ios-train"]},{"paths":["M854.6 832l68.6-68.6c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-68.6 68.6-54.6-54.6c34.4-51 54.6-112.6 54.6-178.8 0-98.8-44.8-187.2-115.2-246l179.2-178v152c0 8.8 7.2 16 16 16s16-7.2 16-16v-192c0-8.8-7.2-16-16-16h-192c-8.8 0-16 7.2-16 16s7.2 16 16 16h152l-181.4 182.4c-51-34.4-112.4-54.4-178.6-54.4s-127.6 20-178.6 54.4l-54.4-54.8 66.4-66.4c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-66.4 66.4-104.4-105h152c8.8 0 16-7.2 16-16s-7.2-16-16-16h-192c-8.8 0-16 7.2-16 16v192c0 8.8 7.2 16 16 16s16-7.2 16-16v-152l105 104.4-70.4 70.4c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l70.4-70.4 51.6 51.2c-70.6 58.6-115.4 147-115.4 245.8 0 176.8 143.2 320 320 320 98.8 0 187.4-44.8 246-115.4l51.4 51.4-68.6 68.6c-6.2 6.2-6.2 16.4 0 22.6 3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6l68.6-68.6 68.6 68.6c3.2 3.2 7.2 4.6 11.4 4.6s8.2-1.6 11.4-4.6c6.2-6.2 6.2-16.4 0-22.6l-69-68.6zM715.6 779.6c-54.4 54.4-126.6 84.4-203.6 84.4s-149.2-30-203.6-84.4c-54.4-54.4-84.4-126.6-84.4-203.6s30-149.2 84.4-203.6c54.4-54.4 126.6-84.4 203.6-84.4s149.2 30 203.6 84.4c54.4 54.4 84.4 126.6 84.4 203.6s-30 149.2-84.4 203.6z"],"grid":0,"tags":["ios-transgender"]},{"paths":["M944 792h-224c-8.8 0-16-7.2-16-16s7.2-16 16-16h184l-328.8-328.4-167.8 168.2c-3 3-7 4.8-11.4 4.8-4.2 0-8.4-1.6-11.4-4.6l-316.4-316.8c-3.2-3.2-4.2-7.4-4.2-11.8 0-4.2 1.2-7.8 4.2-10.8 3.2-3.2 7.2-4.6 11.4-4.6 4 0 8.2 1.6 11.4 4.6l305 305.4 167.8-168c6.2-6.2 16.4-6.2 22.6 0l341.6 338.6v-184c0-8.8 7.2-16 16-16s16 7.2 16 16v224c0 8.8-7.2 15.4-16 15.4z"],"grid":0,"tags":["ios-trending-down"]},{"paths":["M944 256h-224c-8.8 0-16 7.2-16 16s7.2 16 16 16h184l-328.8 328.8-167.8-168c-3-3-7-4.6-11.4-4.6-4.2 0-8.4 1.6-11.4 4.6l-316.4 316.4c-3.2 3.2-4.2 7.4-4.2 11.8 0 4.2 1.2 7.8 4.2 11 3.2 3.2 7.2 4.6 11.4 4.6 4 0 8.2-1.6 11.4-4.6l305-305.4 167.8 168c6.2 6.2 16.4 6.2 22.6 0l341.6-338.6v184c0 8.8 7.2 16 16 16s16-7.2 16-16v-224c0-8.8-7.2-16-16-16z"],"grid":0,"tags":["ios-trending-up"]},{"paths":["M768 192c0-38.6 0-64 0-64h-512c0 0 0 25.4 0 64h-160v16c0 164 61 264.4 164 271.6 25.8 98.4 167.8 151.6 236 159.4v225h-176v32h384v-32h-176v-225c68.2-7.8 210.2-61 236-159.4 103-7.2 164-107.4 164-271.6v-16h-160zM161.4 376.6c-14.2-27.4-31.2-75.6-33.2-152.6h127.8c0 65.8 0 153.6 0 222.8-40-5.4-73-28.8-94.6-70.2zM736 448c0 54.6-47.8 93.4-87.8 116.2-53 30.2-111.4 43.8-136.2 43.8s-83.2-13.6-136.2-43.8c-40-23-87.8-61.6-87.8-116.2v-288h448v288zM862.6 376.6c-21.6 41.4-54.6 64.8-94.6 70.2 0-69.2 0-157 0-222.8h127.8c-2 77-19 125.2-33.2 152.6z"],"grid":0,"tags":["ios-trophy-outline"]},{"paths":["M768 192c0-38.6 0-64 0-64h-512c0 0 0 25.4 0 64h-160v16c0 164 61 264.4 164 271.6 25.8 98.4 167.8 151.6 236 159.4v225h-176v32h384v-32h-176v-225c68.2-7.8 210.2-61 236-159.4 103-7.2 164-107.4 164-271.6v-16h-160zM161.4 376.6c-14.2-27.4-31.2-75.6-33.2-152.6h127.8c0 65.8 0 153.6 0 222.8-40-5.4-73-28.8-94.6-70.2zM862.6 376.6c-21.6 41.4-54.6 64.8-94.6 70.2 0-69.2 0-157 0-222.8h127.8c-2 77-19 125.2-33.2 152.6z"],"grid":0,"tags":["ios-trophy"]},{"paths":["M542 129.6c0-0.6 0-1 0-1.6 0-17.6-13.6-32-30-32s-30 14.4-30 32c0 0.4 0 1 0 1.4-216 16-385.6 207.4-385.6 444 0 0.8-0.4 1.6-0.4 2.6h6.4c12.8-46 52.4-79.6 99.2-79.6 46.6 0 86 33.8 99 79.6h9.8c12.8-46 52.8-79.6 99.6-79.6 36.8 0 70 21 88 52.6v299c0 26.4-22 48-48.4 48s-48.2-21.6-48.2-48c0-8.8-7.2-16-16.2-16-8.8 0-16 7.2-16 16 0 44.2 36.4 80 80.4 80s80.4-35.8 80.4-80v-297.6c18-32.4 50.6-54 88-54 46.6 0 85.6 33.8 98.6 79.6h9.8c12.8-46 52.4-80 99.2-80 47 0 86.8 33.8 99.4 80h3.2c-4-233.2-172.2-429.6-386.2-446.4zM825.6 463.8c-41.8 0-79.2 20.2-104.2 51.8-24.8-31.6-62.2-51.6-104-51.6s-79.2 20.2-104 51.8c-24.8-31.6-62.2-51.8-104-51.8s-79.2 20.2-104 51.8c-24.8-31.6-62.2-51.8-104-51.8-23 0-44.6 6-63.6 16.8 15-71.4 47.2-137.4 94.4-191.4 66-75.4 155.6-121 252-128.2 0 0 13.2-0.8 28.6-0.8 15.6 0 26.4 1 26.4 1 96 7.6 185.6 55 252.4 133.8 44.6 52.6 76 115.2 92 182.6-17.6-9.2-37.4-14-58-14z"],"grid":0,"tags":["ios-umbrella-outline"]},{"paths":["M542 129.6c0-0.6 0-1 0-1.6 0-17.6-13.6-32-30-32s-30 14.4-30 32c0 0.4 0 1 0 1.4-216 16-385.6 207.4-385.6 444 0 0.8-0.4 1.6-0.4 2.6h6.4c12.8-46 52.4-79.6 99.2-79.6 46.6 0 86 33.8 99 79.6h9.8c12.8-46 52.8-79.6 99.6-79.6 36.8 0 70 21 88 52.6v299c0 26.4-22 48-48.4 48s-48.2-21.6-48.2-48c0-8.8-7.2-16-16.2-16-8.8 0-16 7.2-16 16 0 44.2 36.4 80 80.4 80s80.4-35.8 80.4-80v-297.6c18-32.4 50.6-54 88-54 46.6 0 85.6 33.8 98.6 79.6h9.8c12.8-46 52.4-80 99.2-80 47 0 86.8 33.8 99.4 80h3.2c-4-233.2-172.2-429.6-386.2-446.4z"],"grid":0,"tags":["ios-umbrella"]},{"paths":["M512 576c-35.346 0-64 28.654-64 64 0 29.82 20.396 54.878 48 61.984v66.016h32v-66.016c27.604-7.106 48-32.164 48-61.984 0-35.346-28.654-64-64-64zM512 672c-17.644 0-32-14.356-32-32s14.356-32 32-32 32 14.356 32 32-14.356 32-32 32z","M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM800 896h-576v-416h576v416z"],"grid":0,"tags":["ios-unlock-outline"]},{"paths":["M512 608c-17.644 0-32 14.356-32 32s14.356 32 32 32 32-14.356 32-32-14.356-32-32-32z","M336 448v-144c0-97.046 78.968-176 176.032-176 97.030 0 175.968 78.954 175.968 176v16h32v-16c0-114.86-93.124-208-207.968-208-114.908 0-208.032 93.14-208.032 208v144h-112v480h640v-480h-496zM528 701.984v66.016h-32v-66.016c-27.604-7.106-48-32.164-48-61.984 0-35.346 28.654-64 64-64s64 28.654 64 64c0 29.82-20.396 54.878-48 61.984z"],"grid":0,"tags":["ios-unlock"]},{"paths":["M660.8 639.8c27-35.8 43.2-79.8 43.2-127.8s-16.2-92-43.2-127.8l-26.6 19.6c22.8 30.2 36.4 67.6 36.4 108.2s-13.6 78-36.4 108.2l26.6 19.6z","M435.8 432h-115.8v160h115.8l138.2 112v-384z"],"grid":0,"tags":["ios-volume-down"]},{"paths":["M499.8 432h-115.8v160h115.8l140.2 112v-384z"],"grid":0,"tags":["ios-volume-mute"]},{"paths":["M730 776c60-70.4 94-168 94-264s-31.2-184.6-83.8-256.2l-27.2 20.6c48.4 65.8 77.2 147.4 77.2 235.6s-28.8 169.8-77.2 235.6l17 28.4z","M702.4 512c0-71.8-24-138-64-191.6l-27 20.2c35.8 48 57.2 107.2 57.2 171.6 0 42.8-9.6 83.4-26.6 120l20.2 34.6c25.6-46 40.2-98.6 40.2-154.8z","M587.8 512c0-48-16.4-92-43.6-127.8l-27 19.6c16 20.8 27.4 45 33 71.4l36.2 61.6c1-8 1.4-16.4 1.4-24.8z","M316.8 432h-116.8v160h116.8l139.2 112v-185.6l-79-134.8z","M325.6 160l-29.6 17 402.4 687 29.6-17z"],"grid":0,"tags":["ios-volume-off"]},{"paths":["M748.2 256l-27.2 20.6c48.2 65.8 77 147.2 77 235.4s-28.8 169.6-77.2 235.4l27.2 20.6c52.6-71.4 83.8-160 83.8-256s-31-184.6-83.6-256z","M640 703.6c40-53.6 64-119.8 64-191.6s-24-138-64-191.6l-27.2 20.2c35.8 48 57.2 107.2 57.2 171.4s-21.4 123.4-57.2 171.4l27.2 20.2z","M546.2 639.8c27.4-35.8 43.8-79.8 43.8-127.8s-16.4-92-43.8-127.8l-27 19.6c23.2 30.2 37 67.6 37 108.2s-13.8 77.8-37 108.2l27 19.6z","M307.8 432h-115.8v160h115.8l140.2 112v-384z"],"grid":0,"tags":["ios-volume-up"]},{"paths":["M416 692.2l-118.8 83.8c-6.4 6-9 15.6-9.2 23.8s2 15 8.2 21.4c6.2 6.6 15.4 10.6 23.8 10.6 8 0 21.8-8.4 28-14.4l122-88.6c6.4-6 10-14.4 10-23.2l16-90-80-80v156.6z","M608 192c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z","M677.8 860.4l-26.6-201.4c-0.8-6-3.4-11.6-7.2-16.2l-99.8-118v-213.4c0-19.4-26.4-23.4-32-23.4h-64c-5 0-9.8 1.2-14.4 3.4l-119 59.4c-17.4 9.2-26.8 26.6-26.8 49.2v112c0 17.6 14.4 32 32 32s32-14.4 32-32v-108.2l64-32v140.2l173 173 25.4 184c2.2 16 16 26.8 31.6 26.8h3.6c17.4-2.2 30.6-18 28.2-35.4z","M726.2 471.6l-166.2-165v90.2l121.2 120.2c12.6 12.4 32.8 12.4 45.2-0.2 6.2-6.2 9.6-12.8 9.6-20.8-0-8.2-3.4-18-9.8-24.4z"],"grid":0,"tags":["ios-walk"]},{"paths":["M512 736c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32s-14.4-32-32-32z","M488.4 547.4v-131.4h48v131.4l-12 140.6h-24l-12-140.6z","M512 195l362.4 669h-724.8l362.4-669zM512 128l-416 768h832l-416-768z"],"grid":0,"tags":["ios-warning-outline"]},{"paths":["M512 128l-416 768h832l-416-768zM488.4 416h48v131.4l-12 140.6h-24l-12-140.6v-131.4zM512 800c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z"],"grid":0,"tags":["ios-warning"]},{"paths":["M255.8 752c0-4 1.4-8 4.4-11 6.2-6.4 16.2-6.6 22.6-0.4 41.8 40 93.6 61.6 158.6 65.6 38 2.4 54.2 11.6 70 20.6 18.6 10.6 37.8 21.4 108.4 21.4 143.4 0 244-118.4 244-264v-112c0-49.4-6-97.8-32.2-139.6-25.6-40.8-53.8-74-96.6-95.8-7.8-4-11-13.6-7-21.6 4-7.8 13.6-11 21.6-7 48 24.4 80.4 61.6 109.2 107.2 29.6 47 37 101.2 37 156.6v112c0 163.2-115 296-276 296-78.8 0-102.8-13.6-124-25.6-14.4-8.2-25.6-14.6-56.4-16.4-72.8-4.6-131.2-28.8-178.6-74.4-3.2-3.2-5-7.4-5-11.6z","M545.4 804c0-0.8 0-1.8 0.2-2.6 1.4-8.8 9.6-14.6 18.4-13.2 71 11.6 132.2-4.8 177-47.8 6.4-6.2 16.6-5.8 22.6 0.4 6.2 6.4 5.8 16.6-0.4 22.6-52.4 50.2-123 69.6-204.2 56.2-8-1.2-13.6-8-13.6-15.6z","M128 584v-112c0-55.4 7.6-109.6 37-156.6 28.6-45.6 61.2-82.8 109.2-107.2 7.8-4 17.6-0.8 21.6 7s0.8 17.6-7 21.6c-42.8 21.8-71 55-96.6 95.8-26.4 41.6-32.4 90-32.4 139.4v112c0 69.6 18 140.2 77.6 193.8 60.6 54.8 142 86.2 223.2 86.2 8.8 0 16 7.2 16 16s-7.2 16-16 16c-89 0-178-34.4-244.6-94.4-66.2-59.8-88-139-88-217.6z","M646.4 208c0 20.987-17.013 38-38 38s-38-17.013-38-38c0-20.987 17.013-38 38-38s38 17.013 38 38z","M750.6 258c-3.8 1.2-7.8 2-12.2 2-21 0-38-17-38-38s17-38 38-38c11.4 0 21.4 4.8 28.4 12.6-6-38.8-39.6-68.6-80-68.6h-350c-39.2 0-72.2 28-79.6 65.4 6.8-6 15.6-9.4 25.2-9.4 21 0 38 17 38 38s-17 38-38 38c-3 0-5.8-0.4-8.6-1 14.8 17.8 37.6 29 63 29h350c25.8 0 49.2-11.6 63.8-30zM554.4 208c0-29.8 24.2-54 54-54s54 24.2 54 54-24.2 54-54 54c-29.4 0-54-24.2-54-54z"],"grid":0,"tags":["ios-watch"]},{"paths":["M511.6 136c60.4 48.2 116.2 108 166.2 178.4 82.2 115.4 122 222.8 122 328.6 0 139.4-129.2 252.8-288.2 252.8-98.2 0-188.6-43.4-241.8-115.8-10.8-14.6-19.8-30.2-26.8-46.2-12.6-29.2-19.2-59.6-19.2-90.8 0-0.6 0-1.6 0-2.4 0-1.4 0.2-3 0.2-4.6 2-105.2 42-210.4 122.2-321.6 69-95.6 130.6-151 165.4-178.4zM512.2 96c-46.2 32-117.2 96.2-191.6 199.6s-125.8 215.6-128.2 340c0 2.4-0.2 5-0.2 7.4 0 36.6 7.8 71.6 21.8 103.6 8.2 18.6 18.4 36 30.4 52.4 57 77.6 155.6 128.8 267.6 128.8 176.8 0 320.2-127.6 320.2-284.8 0-126.8-54-243.2-128-347.2s-145.2-164.8-192-199.8v0z","M531.8 822c-31.6 0-65.4-2.8-91.8-14.8 174-27.2 238-91.2 279.6-244.4 10.4 22.4 12.4 47.4 12.4 73.6 0 102.4-89.6 185.6-200.2 185.6z"],"grid":0,"tags":["ios-water-outline"]},{"paths":["M704 296c-74-104-145-165-192-200-46.2 32-117.2 96.2-191.6 199.6s-125.8 215.6-128.2 340c0 2.4-0.2 5-0.2 7.4 0 36.6 7.8 71.6 21.8 103.6 8.2 18.6 18.4 36 30.4 52.4 57 77.6 155.6 128.8 267.6 128.8 176.8 0 320.2-127.6 320.2-284.8 0-126.6-54-243-128-347zM531.8 822c-31.6 0-65.4-2.8-91.8-14.8 174-27.2 238-91.2 279.6-244.4 10.4 22.4 12.4 47.4 12.4 73.6 0 102.4-89.6 185.6-200.2 185.6z"],"grid":0,"tags":["ios-water"]},{"paths":["M512 224c144.6 0 293 58.2 402.8 156.8l-30.8 32.6c-45.8-40.8-97.4-73.6-154-97.4-69-29.2-142.4-44-218-44s-149 14.8-218 44c-56.6 24-108.2 56.6-154 97.4l-30.8-32.6c109.8-98.6 258.2-156.8 402.8-156.8zM512 192c-166 0-332.2 71.6-448 187.4l74.6 79.2c48.6-48.6 105-86.6 167.8-113.2 65.2-27.4 134.2-41.4 205.6-41.4s140.4 14 205.4 41.4c62.8 26.6 119.4 64.6 167.8 113.2l74.6-79.2c-115.6-115.8-281.8-187.4-447.8-187.4v0z","M512 450c91.2 0 177.8 31.8 246.8 89.8l-34 34c-59.8-49.2-134.4-76-212.8-76s-153 26.8-212.8 76l-34-34c69-58 155.6-89.8 246.8-89.8zM512 418c-114.4 0-218 46.2-293.2 120.8l79.2 79.2c57.4-56.8 133.2-88 214-88s156.6 31.2 214 88l79.2-79.2c-75.2-74.6-178.8-120.8-293.2-120.8v0z","M512 674c30.8 0 59.8 10.8 82.6 30.2l-82.6 82.6-82.6-82.6c22.8-19.4 51.8-30.2 82.6-30.2zM512 642c-51.8 0-97.8 24.6-127.2 62.8l127.2 127.2 127.2-127.2c-29.4-38.2-75.4-62.8-127.2-62.8v0z"],"grid":0,"tags":["ios-wifi-outline"]},{"paths":["M512 192c-166 0-332.2 71.6-448 187.4l74.6 79.2c48.6-48.6 105-86.6 167.8-113.2 65.2-27.4 134.2-41.4 205.6-41.4s140.4 14 205.4 41.4c62.8 26.6 119.4 64.6 167.8 113.2l74.6-79.2c-115.6-115.8-281.8-187.4-447.8-187.4v0z","M512 418c-114.4 0-218 46.2-293.2 120.8l79.2 79.2c57.4-56.8 133.2-88 214-88s156.6 31.2 214 88l79.2-79.2c-75.2-74.6-178.8-120.8-293.2-120.8v0z","M512 642c-51.8 0-97.8 24.6-127.2 62.8l127.2 127.2 127.2-127.2c-29.4-38.2-75.4-62.8-127.2-62.8v0z"],"grid":0,"tags":["ios-wifi"]},{"paths":["M528 650c0-44 41-77.4 80.4-109.6 15.8-13 30.8-25 43-38 53-55.4 52.4-103.4 52.4-142.2v-8.2c0-88.4-61.6-249.2-64-256h-256c-2.4 6.8-64 167-64 256v8.2c0 38.6-0.6 86.8 52.4 142.2 12.2 12.8 27.2 25 43 38 39.8 32.2 80.8 65.6 80.8 109.6v246h-144v32h320v-32h-144v-246zM405.4 128h213.2c10.8 32 39 125.4 49.6 192h-312.4c10.6-66.6 39-160 49.6-192zM512 578.8c-6 0-10.4-1.8-14.4-5.6 0 0 0 0 0 0-17.6-21.6-40.4-40.4-62-57.8-15-12.2-29.2-23.8-40.2-35.2-44.2-46-43.8-81.8-43.6-119.8 0-2.8-0.2-5.6 0-8.6h320c0.2 2.8 0 5.6 0 8.6 0.2 38 0.6 73.8-43.6 119.8-11 11.4-25.2 23-40.2 35.2-21.4 17.6-44.4 36.2-62 57.8 0 0 0 0 0 0-3.6 3.8-8 5.6-14 5.6z"],"grid":0,"tags":["ios-wine-outline"]},{"paths":["M528 650c0-44 41-77.4 80.4-109.6 15.8-13 30.8-25 43-38 53-55.4 52.4-103.4 52.4-142.2v-8.2c0-88.4-61.6-249.2-64-256h-256c-2.4 6.8-64 167-64 256v8.2c0 38.6-0.6 86.8 52.4 142.2 12.2 12.8 27.2 25 43 38 39.8 32.2 80.8 65.6 80.8 109.6v246h-144v32h320v-32h-144v-246zM405.4 128h213.2c10.8 32 39 125.4 49.6 192h-312.4c10.6-66.6 39-160 49.6-192z"],"grid":0,"tags":["ios-wine"]},{"paths":["M572 992c-12.2 0-23.6-4.6-32-13.2-6.4-6.6-14.2-18.2-14.2-37.2v-238.8h-27.8v238.8c0 19-8 30.8-14.8 37.4-8.6 8.4-20.2 13-32.6 13s-23.8-4.6-32.6-13c-6.8-6.6-14.8-18.2-14.8-37.4v-238.8h-87.8l89-341.2h-13.6l-48.8 180.8c-8 26.2-27.4 35.6-42.8 35.6 0 0 0 0 0 0-13.2 0-25.8-6.4-34-17.4-9.6-12.8-12.2-29.8-7.2-47.8l58-208.2c8.4-30.4 41.4-76.4 97.4-78.6h196.8c56.8 2.4 88.2 52 97 77.8l0.2 0.8 58 208.6c4.8 18 2 35.2-7.8 48-8.2 10.8-20.8 17.2-33.8 17.2-15.4 0-34.6-9.6-42.6-36.2v-0.4l-48.6-180.2h-15.4l91 341.2h-90.2v238.8c0 19-7.8 30.6-14.2 37.2-8.4 8.6-19.6 13.2-31.8 13.2zM466.6 671h90.6v270.6c0 13.6 7.6 18.4 14.8 18.4s14.8-4.8 14.8-18.4v-270.6h80.6l-91-341.2h80.6l55 203.4c2.4 8.4 7 13.2 12.2 13.2 3.2 0 6.6-1.8 8.8-4.8 3.6-4.8 4.4-12 2.2-20.2l-57.8-207.8c-5.2-15.2-27.2-54-68-55.8h-194.8c-43.4 2-64.2 41.6-68 55.4l-57.8 208.2c-2.2 8.2-1.6 15.2 2 19.8 2.2 3 5.6 4.8 9 4.8v0c5.4 0 10-4.6 12.6-12.8l54.8-203.4h78.6l-89 341.2h78.4v270.6c0 17.6 13.2 18.4 15.8 18.4s15.8-0.8 15.8-18.4v-270.6z","M511.8 212.8c-48.4 0-87.8-40.6-87.8-90.4s39.4-90.4 87.8-90.4 87.8 40.6 87.8 90.4-39.4 90.4-87.8 90.4zM511.8 64c-31 0-56.4 26.2-56.4 58.4s25.2 58.4 56.4 58.4 56.4-26.2 56.4-58.4-25.2-58.4-56.4-58.4z"],"grid":0,"tags":["ios-woman-outline"]},{"paths":["M572 992c-12.2 0-23.6-4.6-32-13.2-6.4-6.6-14.2-18.2-14.2-37.2v-238.8h-27.8v238.8c0 19-8 30.8-14.8 37.4-8.6 8.4-20.2 13-32.6 13s-23.8-4.6-32.6-13c-6.8-6.6-14.8-18.2-14.8-37.4v-238.8h-87.8l89-341.2h-13.6l-48.8 180.8c-8 26.2-27.4 35.6-42.8 35.6v0c-13.2 0-25.8-6.4-34-17.4-9.6-12.8-12.2-29.8-7.2-47.8l58-208.2c8.4-30.4 41.4-76.4 97.4-78.6h196.8c56.8 2.4 88.2 52 97 77.8l0.2 0.8 58 208.6c4.8 18 2 35.2-7.8 48-8.2 10.8-20.8 17.2-33.8 17.2-15.4 0-34.6-9.6-42.6-36.2v-0.4l-48.6-180.2h-15.4l91 341.2h-90.2v238.8c0 19-7.8 30.6-14.2 37.2-8.4 8.6-19.6 13.2-31.8 13.2z","M511.8 212.8c-48.4 0-87.8-40.6-87.8-90.4s39.4-90.4 87.8-90.4 87.8 40.6 87.8 90.4-39.4 90.4-87.8 90.4z"],"grid":0,"tags":["ios-woman"]},{"paths":["M288 536.8v179.2c0 13.8 9 28 22.8 28h57.2v104c0 26.6 21.4 48 48 48s48-21.4 48-48v-104h98v104c0 15 6.8 28.4 17.6 37.2 7.8 6.8 18.2 10.8 29.4 10.8 0.2 0 0.4 0 0.6 0s0.2 0 0.4 0c26.6 0 48-21.4 48-48v-104h55.2c14 0 22.8-14.2 22.8-27.8v-332.2h-448v152.8z","M816 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z","M208 352c-26.6 0-48 21.4-48 48v192c0 26.6 21.4 48 48 48s48-21.4 48-48v-192c0-26.6-21.4-48-48-48z","M622.4 178.2l37-43.8c0.8-1-0.4-3.2-2.6-5-2.2-1.6-4.8-2-5.4-0.8l-38.4 45.6c-27.2-10.8-60.4-17.6-101.2-17.6-41-0.2-74.4 6.4-101.6 17l-38-44.8c-0.8-1-3.2-0.8-5.4 0.8s-3.4 3.6-2.6 5l36.6 43.2c-96.4 41.8-110.8 144.4-112.8 174.4h447.2c-1.8-30.2-16-131.4-112.8-174zM413.6 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12 26.6-27 26.6zM610.4 277.8c-14.8 0-27-12-27-26.6s12-26.6 27-26.6c14.8 0 27 12 27 26.6s-12.2 26.6-27 26.6z"],"grid":0,"tags":["logo-android"]},{"paths":["M427.146 512h169.692l-84.854-178.712z","M511.962 64l-447.962 160 92.24 544 355.76 192 355.5-192 92.5-544-448.038-160zM688 704l-53.178-112h-245.654l-53.168 112h-80l256-560 256 560h-80z"],"grid":0,"tags":["logo-angular"]},{"paths":["M667.2 307.8c-67.2 0-95.6 33-142.4 33-48 0-84.6-32.8-142.8-32.8-57 0-117.8 35.8-156.4 96.8-54.2 86-45 248 42.8 386 31.4 49.4 73.4 104.8 128.4 105.4 0.4 0 0.6 0 1 0 47.8 0 62-32.2 127.8-32.6 0.4 0 0.6 0 1 0 64.8 0 77.8 32.4 125.4 32.4 0.4 0 0.6 0 1 0 55-0.6 99.2-62 130.6-111.2 22.6-35.4 31-53.2 48.4-93.2-127-49.6-147.4-234.8-21.8-305.8-38.4-49.4-92.2-78-143-78v0z","M652.4 128c-40 2.8-86.6 29-114 63.2-24.8 31-45.2 77-37.2 121.6 1 0 2 0 3.2 0 42.6 0 86.2-26.4 111.6-60.2 24.6-32.2 43.2-77.8 36.4-124.6v0z"],"grid":0,"tags":["logo-apple"]},{"paths":["M821 558.4c-10-23-25.4-43.2-56.2-60.2-16.4-9-32.2-15.6-50.8-20 10.8-5 20-10.8 32.6-22 15-13.2 26.2-31.4 31.2-46.6 5.2-15 8.2-36 7-56.4-2.2-33.6-8.8-66.2-26.4-89.6s-42.4-41.4-75.2-54c-25.2-9.6-51-15.6-91-17.8v-127.8h-80v128h-64v-128h-82v128h-174.2v96h55.8c17.4 0 29.2 1.6 35.2 4.6 6.2 3 10.6 7 13 12 2.6 5 3.8 16.8 3.8 35v346.4c0 18-1.2 29.6-3.8 34.8s-4 9.8-10.2 12.6c-6.2 2.8-6.4 2.6-23.6 2.6h-52.8l-17.4 96h174v128h82v-128h64v128h80v-128.8c52-2.6 89-9.4 118.8-20.6 38.6-14.4 68.2-35.4 89.4-63s29.8-69.8 31.6-102.4c1.4-29-1.8-66.4-10.8-86.8zM448 300h64v148h-64v-148zM448 724v-180h64v180h-64zM592 307.8c12 5 19.8 15 27.6 25.4 8.6 11.4 13 26.6 13 42.8 0 15.6-5.8 29-15 41-7.6 9.8-13.6 16.6-25.6 22.2v-131.4zM649.6 681.2c-15.6 13.8-24.6 20.2-44.2 27.6-4 1.6-9.4 2.8-13.4 3.8v-165.6c10 1.6 15.2 3.6 22.6 6.8 15.6 6.6 30.4 13.8 39.6 26.4s16 31.2 16 49.4c0 21.8-5.6 38.4-20.6 51.6z"],"grid":0,"tags":["logo-bitcoin"]},{"paths":["M141.4 329l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c17.8-8.6 17.8-22.6 0-31.2l-338.4-163.4c-8.8-4.2-20.6-6.4-32.2-6.4s-23.4 2.2-32.2 6.4l-338.4 163.4c-17.8 8.6-17.8 22.6 0 31.2z","M882.6 496.4c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.6 120.4-249.6 120.4c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.2 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18.2-8.4 18.2-22.4 0.4-31z","M882.6 695c0 0-61.8-29.8-70-33.8s-10.4-3.8-19 0.2-249.4 120.6-249.4 120.6c-9 4.2-20.6 6.4-32.2 6.4s-23.4-2.2-32.2-6.4c0 0-234.6-113.2-245.6-118.6-12-5.8-15.4-5.8-26.2-0.6-11.2 5.4-66.8 32.2-66.8 32.2-17.8 8.6-17.8 22.6 0 31.2l338.4 163.4c8.8 4.4 20.6 6.4 32.2 6.4s23.4-2.2 32.2-6.4l338.4-163.4c18-8.6 18-22.6 0.2-31.2z"],"grid":0,"tags":["logo-buffer"]},{"paths":["M377.6 511.85c0 73.892 60.486 134.356 134.4 134.356s134.398-60.462 134.398-134.356c0-73.89-60.484-134.358-134.398-134.358s-134.4 60.468-134.4 134.358z","M953.504 435.59c-0.018 0.010-0.032 0.076-0.048 0.084-3.402-19.754-8.080-39.676-13.978-57.676h-0.214c5.966 18 10.704 38 14.144 58h-0.004c-3.438-20-8.176-40-14.14-58h-310.78c38.088 34 62.716 80.35 62.716 134.104 0 33.592-8.968 62.568-24.628 89.448l-204.484 355.354c0 0-0.018 0.528-0.028 0.528l-0.020 0.568c0.010 0 0.018 0 0.030 0l-0.010-0.524c16.406 1.84 33.062 2.524 49.94 2.524 13.684 0 27.218-0.786 40.598-2.004 20.27-1.822 40.154-5.038 59.554-9.466 199.208-45.48 347.848-223.722 347.848-436.648 0-25.998-2.242-51.506-6.496-76.292z","M512 690.992c-67.202 0-123.202-35.82-154.57-89.57l-205.692-355.8c-20.586 27.792-38.030 58.044-51.806 90.246-23.118 54.022-35.932 113.504-35.932 175.982 0 125.39 51.568 238.72 134.632 320.018 58.684 57.438 133.090 98.866 216.176 117.238l0.058-0.102 155.366-269.208c-17.918 6.716-38.062 11.196-58.232 11.196z","M182.584 209.15l154.7 266.5c15.682-80.624 87.346-143.65 174.716-143.65h410.344c-13.842-30-31.188-60.648-51.558-87.876 0.078 0.042 0.156 0.106 0.234 0.148 20.268 27.152 37.536 57.728 51.324 87.728h0.344c-13.768-30-31.028-60.76-51.336-87.98-0.23-0.12-0.458-0.336-0.684-0.514-81.718-108.972-211.95-179.506-358.668-179.506-52.744 0-103.346 9.138-150.344 25.872-69.23 24.654-130.606 65.834-179.374 118.812l0.284 0.486c0.006-0.008 0.012-0.014 0.018-0.020z"],"grid":0,"tags":["logo-chrome"]},{"paths":["M482.478 607.872c-30.644-20.714-61.484-41.138-92.124-61.86-4.060-2.746-6.86-2.944-11.004-0.058l-77.742 52.308c62.324 41.548 186.392 124.372 186.392 124.372v-107.572c-0.024-2.448-3.106-5.56-5.522-7.19z","M390.184 481.332c30.908-20.32 61.702-40.818 92.218-61.72 2.972-2.036 5.55-7.018 5.598-10.668v-103.412c0 0-124.066 82.248-186.524 123.884 27.4 18.318 53.342 35.826 79.574 52.886 2.040 1.324 6.792 0.568 9.134-0.97z","M539.676 418.708c31.622 21.406 63.366 42.628 95.254 63.63 1.832 1.208 5.84 1.204 7.678 0l79.502-52.934-186.11-124.436v106.7c0.020 2.402 1.61 5.642 3.676 7.040z","M516.218 460.738c-2.42-1.604-7.222-1.056-9.486 0.336-9.634 5.924-18.926 12.406-28.328 18.71-16.496 11.060-50.712 34.046-50.712 34.046l77.684 51.73c3.496 2.314 8.872 2.44 12.52 0.222l78.028-51.986c0.002 0-68.158-45.402-79.706-53.058z","M282 474.232v79.218l59.244-39.676z","M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM790 594.012c0 11.57-5.304 19.736-15.022 26.188-82.284 54.628-164.502 109.428-246.572 164.376-11.708 7.836-22.348 7.508-33.968-0.274-81.566-54.628-163.438-109.092-245.25-163.352-10.22-6.778-15.188-15.114-15.188-27.46v-159.458c0-12.282 5.042-20.664 15.248-27.432 81.812-54.26 163.878-108.726 245.448-163.352 11.636-7.792 22.188-8.014 33.876-0.19 82.072 54.948 164.252 109.738 246.522 164.39 9.356 6.212 14.906 13.886 14.906 25.32v161.244z","M632.494 546.468c-30.108 20.444-60.376 40.652-90.772 60.664-4.824 3.176-5.776 6.636-5.722 12.378v102.692l186.078-124.008-77.054-51.764c-4.69-3.208-7.86-3.134-12.53 0.038z","M740 553.352v-79.232l-59.18 39.746z"],"grid":0,"tags":["logo-codepen"]},{"paths":["M512.564 678.976v0z","M128 64l69.892 806.438 313.642 89.562 314.518-89.7 69.948-806.3h-768zM709.352 733.796l-197.214 56.25-196.916-56.496-13.494-155.55h96.506l6.866 79.124 107.172 30.326 0.264 0.546h0.068l106.934-29.704 11.224-128.292h-224.762l-8-100h241.292l8.792-102h-368.084l-8-98h481.16l-43.808 503.796z"],"grid":0,"tags":["logo-css3"]},{"paths":["M580.8 290l-126.8-98 127.2 204.4z","M658 192v326h-72.8l-126.4-197.2 3.4 197.2h-80.2v-214l-74.6-58.6c2 2.4 4 4.8 5.8 7.4 20 27.8 30 61 30 101 0 98.4-61.2 164.2-153.8 164.2h-125.4v0.8l399.2 313.2h496.8v-403.8l-302-236.2z","M259.8 356.2c0-58-28.4-90.2-79.4-90.2h-38.4v178h38c52 0 79.8-30.8 79.8-87.8z"],"grid":0,"tags":["logo-designernews"]},{"paths":["M512 128c-212 0-384 172-384 384 0 212.2 172 384 384 384s384-171.8 384-384c0-212-172-384-384-384zM755.8 305c43.2 50.8 70.6 115.2 75.4 185.8-69.2-3.6-152-3.6-218.4 2.6-8.4-21.2-17-42-26.4-62 76.6-33.2 135.6-76.8 169.4-126.4zM512 192c77.6 0 148.8 27.6 204.2 73.6-34.8 44-89.4 82.2-157.4 111.2-37.2-68.8-80-128-125.6-174.6 25.4-6.4 51.6-10.2 78.8-10.2zM367.2 227c46.2 46 89.6 104.6 127.6 173.2-72.2 22-155 34.6-243.4 34.6-16.8 0-33.2-0.6-49.4-1.6 23-90.2 84-165 165.2-206.2zM192.6 496.8c18.2 0.8 36.6 1.2 55.2 1 100.8-1.2 194.6-17 275.2-42.8 7.6 15.8 14.8 32 21.6 48.6-11 2.6-20.8 5.4-28.6 8.6-110.2 46.2-197 120.8-244 211-49.6-56.4-80-130.2-80-211.2 0-5.2 0.2-10.2 0.6-15.2zM512 832c-74 0-142-25.2-196.2-67.4 42.6-84.4 118.6-154.2 214.4-197.6 9-4.2 21-7.6 34.8-10.6 11.4 31.6 21.6 64.4 30.6 98.4 13.8 53 23.6 105.4 29.6 156.2-35.2 13.4-73.2 21-113.2 21zM685 781c-6-51.4-15.8-104.2-29.8-157.8-6.8-26-14.6-51.2-23-75.8 62.8-5.2 138-4.4 197.8 0-10.8 98.2-66 182.6-145 233.6z"],"grid":0,"tags":["logo-dribbble"]},{"paths":["M354 154l-226 147.8 156.2 125.4 227.8-141z","M128 552.6l226 147.8 158-132.2-227.8-141z","M512 568.2l158 132.2 226-147.8-156.2-125.4z","M896 301.8l-226-147.8-158 132.2 227.8 141z","M512.4 596.6l-159.6 132-68.8-44.4v49.8l228 136 228-136v-49.8l-68.4 44.4z"],"grid":0,"tags":["logo-dropbox"]},{"paths":["M468 544v-96h262.188l14.298-96h-276.486v-3.66c0-71.84 29.95-116.172 158.5-116.172 52.528 0 111.734 4.996 186.378 17.484l19.122-129.92c-76.024-17.486-141.388-23.732-211.886-23.732-229.462 0-328.114 82.45-328.114 234.86v21.14h-100v96h100v96h-100v96h100v53.14c0 152.408 98.594 234.86 328.054 234.86 70.5 0 135.696-6.246 211.718-23.732l-19.238-129.92c-74.644 12.488-133.562 17.484-186.090 17.484-128.552 0-158.446-37.478-158.446-126.172v-25.66h233.59l14.296-96h-247.884z"],"grid":0,"tags":["logo-euro"]},{"paths":["M853.6 128h-683.2c-23.4 0-42.4 19-42.4 42.4v683.2c0 23.4 19 42.4 42.4 42.4h341.6v-304h-91.8v-112h91.8v-82.8c0-99.2 68.8-153.2 157.4-153.2 42.4 0 88 3.2 98.6 4.6v103.6h-70.6c-48.2 0-57.4 22.8-57.4 56.4v71.4h114.8l-15 112h-99.8v304h213.6c23.4 0 42.4-19 42.4-42.4v-683.2c0-23.4-19-42.4-42.4-42.4z"],"grid":0,"tags":["logo-facebook"]},{"paths":["M753.528 64c0 0-410.706 0-476.446 0-65.75 0-85.082 49.596-85.082 80.828 0 31.254 0 759.28 0 759.28 0 35.182 18.85 48.234 29.436 52.534 10.598 4.31 39.832 7.942 57.346-12.336 0 0 224.938-261.79 228.8-265.668 5.842-5.86 5.842-5.86 11.688-5.86 11.688 0 98.384 0 145.534 0 61.148 0 70.98-43.738 77.368-69.504 5.318-21.578 64.978-327.924 84.904-425.118 15.21-74.17-3.586-114.156-73.548-114.156zM742.172 603.274c5.318-21.578 64.978-327.924 84.904-425.118zM725.384 193.34l-19.998 103.468c-2.39 11.3-16.574 23.19-29.726 23.19-13.15 0-191.834 0-191.834 0-20.88 0.002-35.826 12.278-35.826 33.206v26.896c0 20.946 15.038 35.788 35.93 35.788 0 0 148.964 0 163.696 0 14.748 0 29.22 16.218 26.032 32.010-3.204 15.816-18.172 93.138-19.968 101.78-1.804 8.656-11.69 23.45-29.222 23.45-14.776 0-128.538 0-128.538 0-23.41 0-30.488 3.066-46.148 22.586-15.674 19.54-156.512 189.184-156.512 189.184-1.426 1.644-2.82 1.168-2.82-0.624v-592.482c0-13.368 11.586-29.046 28.958-29.046 0 0 367.426 0 382.346 0 14.070-0.002 27.222 13.262 23.63 30.594z"],"grid":0,"tags":["logo-foursquare"]},{"paths":["M1005.2 230c-45-87.4-116-102-116-102s31 64 32 102c0.8 32.2-11 56-54.4 67s-61.6-4-95.6-35-83.2-53-145.2-56c-80-4-154 18-154 18-40-50 40-160 40-160-149 59-187.4 166.6-192 227.4-3.8 48.2 17 81.6 17 81.6s-1 55.6-10 84c-6.2 19.6-33.8 50-52 69-24.4 25.4-25 77 0 114s88 55 134 79 63 42 63 42 2 16.6 1 30.6-6.4 28-18 36.4c-11 7.8-31 1-41-4s-10-12.4-21-16-14.6-8-13-22 4-18-7-37-37-19-59-16-34.6 13.6-34.6 13.6l-32.6-20c0 0 17-31.2 10.4-71.2-14.6-87.6-100-125.6-100-125.6l20.8 88.8c0 0 2.2-5.2 12.8-12.8s16.2-7.2 16.2-7.2 13.2 15.2 18.2 50.6c5 36-13.4 54.4-13.4 54.4l-56.6-36 2-29-77.6-20.6 32.4 73.4 30-8 48 45.4c0 0-31.4 23.4-66 23.4-22 0-44-12-44-12s-2.8-2-1.6-11c1.4-10 13.6-25 13.6-25h-92c0 0 54.6 77.4 130 77.4 62 0 88.4-25 88.4-25l37.6 37.4c0 0 6 11 0 14s-14 7-18 30 36 58 36 58c43.6 35.6 14 64 14 64h544c-18-26-45-36-64-64 0 0-89.6-116.8-3.6-180.8 114.8-85.4 85.6-138.8 82.4-202.8 0 0 63.6-13.2 118.6-67.2s77.8-141.6 39.8-215.2zM390 406c-33.8 9-45 71-45 71 3-126 115-186 130-178s-13 78-42 128c0 0-16-28.2-43-21zM464 436c0 0 36-112 75-119s83 42 83 124-52 130.8-85.6 138.4c-33 7.6-46 4-46 4s55-43.2 47-113.6c-5.6-49.4-62.8-48.4-73.4-33.8z"],"grid":0,"tags":["logo-freebsd-devil"]},{"paths":["M512 64c-247.4 0-448 205.8-448 459.4 0 203 128.4 375 306.4 435.8 2.8 0.6 5.2 0.8 7.6 0.8 16.6 0 23-12.2 23-22.8 0-11-0.4-39.8-0.6-78.2-16.8 3.8-31.8 5.4-45.2 5.4-86.2 0-105.8-67-105.8-67-20.4-53-49.8-67.2-49.8-67.2-39-27.4-0.2-28.2 2.8-28.2 0.2 0 0.2 0 0.2 0 45 4 68.6 47.6 68.6 47.6 22.4 39.2 52.4 50.2 79.2 50.2 21 0 40-6.8 51.2-12 4-29.6 15.6-49.8 28.4-61.4-99.4-11.6-204-51-204-227 0-50.2 17.4-91.2 46-123.2-4.6-11.6-20-58.4 4.4-121.6 0 0 3.2-1 10-1 16.2 0 52.8 6.2 113.2 48.2 35.8-10.2 74-15.2 112.2-15.4 38 0.2 76.4 5.2 112.2 15.4 60.4-42 97-48.2 113.2-48.2 6.8 0 10 1 10 1 24.4 63.2 9 110 4.4 121.6 28.6 32.2 46 73.2 46 123.2 0 176.4-104.8 215.2-204.6 226.6 16 14.2 30.4 42.2 30.4 85 0 61.4-0.6 111-0.6 126 0 10.8 6.2 23 22.8 23 2.4 0 5.2-0.2 8-0.8 178.2-60.8 306.4-233 306.4-435.8 0-253.6-200.6-459.4-448-459.4z"],"grid":0,"tags":["logo-github"]},{"paths":["M915.2 448l-4.2-17.8h-387v163.8h231.2c-24 114-135.4 174-226.4 174-66.2 0-136-27.8-182.2-72.6-47.4-46-77.6-113.8-77.6-183.6 0-69 31-138 76.2-183.4 45-45.2 113.2-70.8 181-70.8 77.6 0 133.2 41.2 154 60l116.4-115.8c-34.2-30-128-105.6-274.2-105.6 0 0 0 0 0 0-112.8 0-221 43.2-300 122-78 77.6-118.4 189.8-118.4 293.8s38.2 210.8 113.8 289c80.8 83.4 195.2 127 313 127 107.2 0 208.8-42 281.2-118.2 71.2-75 108-178.8 108-287.6 0-45.8-4.6-73-4.8-74.2z"],"grid":0,"tags":["logo-google"]},{"paths":["M636.4 461.8l-3.2-14h-313.2v128.2h181.4c-18.8 90-96.8 127.2-168.2 127.2-52 0-100.4-15.6-136.6-50.6-37.2-36.2-57.8-86.2-57.8-140.8 0-54.2 19.6-103.6 55.2-139.2 35.4-35.4 84-50.8 137.4-50.8 61 0 99.8 27.6 116.2 42.2l96-95.4c-27-23.4-100.6-82.6-215.4-82.6 0 0 0 0 0 0-88.6 0-173.4 33.6-235.4 95.6-61 61-92.8 148.8-92.8 230.4s30 165.2 89.2 226.6c63.4 65.4 153.2 99.4 245.8 99.4 84.2 0 163.8-33 220.6-92.6 56-58.8 84.8-140.2 84.8-225.4-0.2-36-3.8-57.4-4-58.2z","M1024 448h-114v-114h-82v114h-114v82h114v114h82v-114h114z"],"grid":0,"tags":["logo-googleplus"]},{"paths":["M128 128v768h768v-768h-768zM556 558v144h-80v-144l-132-240h94.2l79.4 167.2 76-167.2h90.4l-128 240z"],"grid":0,"tags":["logo-hackernews"]},{"paths":["M128 64l69.872 806.426 313.666 89.574 314.49-89.708 69.972-806.292h-768zM743.994 328h-368l7.982 102h352.016l-27.010 302.772-197 56.188-197.364-55.952-13.528-155.008h96.508l6.846 78.574 107.538 29.562 106.844-29.83 11.148-128.306h-334.002l-25.142-299.178 481.578 0.032-8.414 99.146z"],"grid":0,"tags":["logo-html5"]},{"paths":["M672 511.666c0 88.366-71.634 160-160 160s-160-71.634-160-160c0-88.366 71.634-160 160-160s160 71.634 160 160z","M355.61 353.774c42.308-42.308 98.558-65.858 158.39-65.858s116.082 23.674 158.39 65.982c26.844 26.844 46.022 59.102 56.464 95.102h168.146v-226c0-53.020-40.98-94-94-94h-576c-53.020 0-98 40.98-98 94v226h170.144c10.444-36 29.622-68.382 56.466-95.226zM833 295.4c0 14.138-11.46 25.6-25.6 25.6h-76.8c-14.138 0-25.6-11.46-25.6-25.6v-76.8c0-14.138 11.46-25.6 25.6-25.6h76.8c14.138 0 25.6 11.46 25.6 25.6v76.8z","M672.39 670.558c-42.308 42.308-98.558 65.358-158.39 65.358s-116.082-22.924-158.39-65.232c-42.23-42.23-65.518-99.684-65.606-157.684h-161.004v286c0 53.020 44.98 98 98 98h576c53.020 0 94-44.98 94-98v-286h-159.004c-0.086 58-23.374 115.328-65.606 157.558z"],"grid":0,"tags":["logo-instagram"]},{"paths":["M416 176.002h-160v424.996c0 105.16-36.064 134.522-98.824 134.522-29.41 0-55.896-5.042-76.5-12.126l-16.676 124.414c29.4 10.124 74.518 16.192 109.814 16.192 144.096 0 242.186-67.742 242.186-261.96v-426.038z","M764.926 160c-154.886 0-252.926 87.996-252.926 204.308 0 100.166 75.502 162.88 185.282 203.33 79.4 28.316 110.784 53.616 110.784 95.078 0 45.512-36.278 74.85-104.896 74.85-63.726 0-121.578-21.28-160.788-42.51v-0.042l-30.382 126.44c37.278 21.276 106.882 42.51 182.334 42.51 181.374-0.004 265.666-97.104 265.666-211.396 0-97.1-53.916-159.8-170.556-204.326-86.278-34.382-122.54-53.59-122.54-97.084 0-34.4 31.376-65.738 96.086-65.738 63.692 0 107.488 21.414 133.010 34.582l38.25-128c-40-17.562-93.874-32.002-169.324-32.002v0z"],"grid":0,"tags":["logo-javascript"]},{"paths":["M834.4 128h-640.8c-35 0-65.6 25.2-65.6 59.8v642.2c0 34.8 30.6 65.8 65.6 65.8h640.6c35.2 0 61.6-31.2 61.6-65.8v-642.2c0.2-34.6-26.4-59.8-61.4-59.8zM366 768h-110v-342h110v342zM314.8 374h-0.8c-35.2 0-58-26.2-58-59 0-33.4 23.4-59 59.4-59s58 25.4 58.8 59c0 32.8-22.8 59-59.4 59zM768 768h-110v-187c0-44.8-16-75.4-55.8-75.4-30.4 0-48.4 20.6-56.4 40.6-3 7.2-3.8 17-3.8 27v194.8h-110v-342h110v47.6c16-22.8 41-55.6 99.2-55.6 72.2 0 126.8 47.6 126.8 150.2v199.8z"],"grid":0,"tags":["logo-linkedin"]},{"paths":["M895.318 192h-766.636c-35.674 0-64.682 28.968-64.682 64.616v510.698c0 35.672 29.008 64.686 64.682 64.686h766.636c35.674 0 64.682-29.014 64.682-64.688v-510.696c0-35.648-29.008-64.616-64.682-64.616zM568.046 704h-112.096v-192l-84.080 107.756-84.044-107.756v192h-112.088v-384h112.088l84.044 135.96 84.080-135.96h112.096v384zM735.36 704l-139.27-192h84v-192h112.086v192h84.054l-140.87 192z"],"grid":0,"tags":["logo-markdown"]},{"paths":["M511.834 960c-11.54 0-23.072-3.124-33.266-9.198l-105.97-64.88c-15.828-9.124-8.046-12.406-2.886-14.282 21.13-7.562 27.426-11.314 49.894-24.57 2.412-1.334 5.494-0.848 7.91 0.644l79.42 47.008c2.952 1.7 7.114 1.7 9.862 0l310.376-184.492c2.95-1.754 4.83-5.292 4.83-8.882v-373.61c0-3.7-1.88-7.184-4.898-9.056l-310.24-189.344c-2.956-1.788-6.842-1.788-9.796 0l-310.038 189.41c-3.088 1.806-5.032 5.396-5.032 8.99v373.61c0 3.626 1.944 7.026 4.962 8.778l79.858 47.944c47.22 24.408 75.18-0.34 75.18-29.222v-367.398c0-5.304 4.094-9.454 9.192-9.454h45.618c5.030 0 9.194 4.144 9.194 9.454v367.396c0 65.126-38.706 102.496-98.398 102.496-18.312 0-32.794 0-73.104-20.558l-83.168-49.562c-20.592-12.304-33.334-35.292-33.334-59.91v-378.93c0-24.632 12.742-47.568 33.33-59.834l317.37-189.728c20.054-11.76 46.748-11.76 66.664 0l317.3 189.728c20.596 12.298 33.336 35.25 33.336 59.834v378.93c0 24.618-12.74 47.5-33.336 59.906l-317.3 189.548c-10.194 6.072-21.664 9.198-33.396 9.198l-0.134 0.036z","M609.886 703.996c-129.22 0-168.012-63.22-168.012-118.542 0-5.258 4.096-9.458 9.124-9.458h41.042c4.564 0 8.454 3.4 9.124 8.032 6.168 43.204 33.496 62.3 108.648 62.3 66.798 0 94.182-20.692 94.182-57.368 0-21.184-6.926-36.848-110.814-47.394-86.854-8.882-140.576-28.746-140.576-100.59 0-66.27 53.992-104.98 144.468-104.98 92.256 0 152.924 28 158.346 101.658 0.204 2.674-0.736 5.258-2.482 7.288-1.742 1.93-4.156 3.054-6.706 3.054h-41.182c-4.292 0-8.048-3.124-8.918-7.426-8.802-33.906-33.94-46.804-99.126-46.804-72.972 0-81.492 25.506-81.492 45.214 0 23.926 10.062 30.882 108.588 44.344 97.522 13.326 143.866 32.234 143.866 103.104 0 71.562-57.616 117.566-158.15 117.566l0.070 0.002z"],"grid":0,"tags":["logo-nodejs"]},{"paths":["M356.708 574.956c-18.246 0-33.856 8.414-46.402 25.666-12.582 16.956-18.796 37.946-18.796 62.862 0 24.948 6.332 46.016 18.796 63.018 12.546 17.080 28.078 25.542 46.402 25.542 16.988 0 31.778-8.54 44.242-25.542 12.542-17.002 18.796-38.070 18.796-63.018 0-24.838-6.332-45.86-18.796-62.862-12.466-17.174-27.134-25.666-44.242-25.666z","M669.336 574.956c-18.090 0-33.782 8.414-46.364 25.666-12.542 16.956-18.718 37.946-18.718 62.862 0 24.948 6.372 46.016 18.718 63.018 12.582 17.080 28.196 25.542 46.364 25.542 17.066 0 31.812-8.54 44.356-25.542 12.586-17.002 18.836-38.070 18.836-63.018 0-24.838-6.328-45.86-18.836-62.862-12.544-17.174-27.094-25.666-44.356-25.666z","M891.554 344h-0.118c0 0 5.586-28.528 0.628-78.36-4.364-49.832-14.942-95.676-32.246-137.64 0 0-8.844 1.52-25.52 5.792s-44.16 12.598-81.876 29.536c-37.082 17.080-75.972 39.576-116.594 67.010-27.606-7.868-68.816-11.878-123.988-11.878-52.578 0-93.828 4.024-123.954 11.89-89.184-61.718-163.664-95.89-224.184-102.35-17.188 41.964-27.766 87.982-32.090 137.94-4.796 49.878 0.864 78.658 0.864 78.658-48.518 52.504-68.476 128.484-68.476 190.988 0 48.488 1.316 92.156 12.25 130.96 11.128 38.62 25.324 70.26 42.196 94.442 17.222 24.242 38.024 45.576 63.152 63.876 24.934 18.628 47.976 31.924 68.778 40.432 20.922 8.744 44.75 15.204 71.964 19.722 26.66 4.772 46.876 7.29 60.954 7.992 0 0 56 2.988 128.708 2.988s128.59-2.988 128.59-2.988c14.040-0.704 34.29-3.268 61.070-7.992 27.094-4.598 51.042-11.214 71.882-19.722 20.804-8.586 43.886-21.802 68.938-40.432 25.046-18.064 45.812-39.478 63.036-63.876 16.872-24.182 30.988-55.822 42.196-94.442 10.972-38.804 12.29-82.77 12.29-131.258-0.004-60.51-20.040-137.288-68.45-191.288zM760.766 811.29c-55.724 26.182-137.794 36.71-246.644 36.71l-4.286-0.078c-108.886 0-190.722-10.496-245.696-36.82-55.016-26.184-82.542-80.114-82.542-161.476 0-48.66 17.144-87.98 50.964-118.214 14.708-13.030 32.876-22.038 55.29-27.434 22.258-5.116 42.708-5.524 61.938-4.93 18.796 0.83 45.102 4.392 78.688 6.928 33.58 2.594 58.592 6.024 83.522 6.024 23.396 0 54.426-3.914 104.208-7.918 49.98-3.942 86.988-5.942 110.934-2 24.578 4.004 45.972 12.404 64.258 29.484 35.468 31.502 53.204 71.010 53.204 118.168-0.002 81.332-28.276 135.34-83.838 161.556z"],"grid":0,"tags":["logo-octocat"]},{"paths":["M512 64c-247.4 0-448 200.6-448 448 0 183.4 110.4 341 268.2 410.4-1.2-31.2-0.2-68.8 7.8-102.8 8.6-36.4 57.6-244.2 57.6-244.2s-14.4-28.6-14.4-70.8c0-66.4 38.4-116 86.4-116 40.8 0 60.4 30.6 60.4 67.2 0 41-26.2 102.2-39.6 159-11.2 47.6 23.8 86.2 70.8 86.2 84.8 0 142-109 142-238.2 0-98.2-66.2-171.6-186.4-171.6-135.8 0-220.6 101.4-220.6 214.6 0 39 11.6 66.6 29.6 87.8 8.2 9.8 9.4 13.8 6.4 25-2.2 8.2-7 28-9.2 36-3 11.4-12.2 15.4-22.4 11.2-62.6-25.6-91.8-94-91.8-171.2 0-127.2 107.4-279.8 320.2-279.8 171 0 283.6 123.8 283.6 256.6 0 175.8-97.8 307-241.8 307-48.4 0-93.8-26.2-109.4-55.8 0 0-26 103.2-31.6 123.2-9.4 34.6-28 69-45 96 40.2 11.8 82.8 18.4 127 18.4 247.4 0 448-200.6 448-448 0.2-247.6-200.4-448.2-447.8-448.2z"],"grid":0,"tags":["logo-pinterest"]},{"paths":["M799.6 406c-1.6-34.2-6.6-69-21.6-100.2-8.2-17.2-19.4-33-33-46.4-12.6-12.8-27.2-23.4-42.6-32.6-34.2-20.4-75-34-168.8-62s-149.6-36.8-149.6-36.8v716.6l159.8 51.4c0 0 0.2-397.6 0.2-599v-7.6c0-18.6 15-33.6 32.2-33.6h1c17 0 31 15 31 33.6v266.6c22 10.6 58.4 18.6 83.6 18.2 16.6 0.4 33.4-3.4 48-11.4 15.2-8.2 27.8-20.8 36.8-35.6 10.2-16.6 16.4-35.6 19.8-54.6 3.8-21.6 4-44.2 3.2-66.6z","M173.4 715.6c54.8-19.6 178.6-59 178.6-59v-94.4c0 0-153 49.6-222.6 74.2-17.2 6.2-34.6 11.8-51.4 19-19.6 8.2-38.8 17.4-56.2 29.6-7.6 5.2-14.4 11.8-18.4 20.2s-4.4 18.4-1 27.2c4 10.2 11.6 18.6 20.2 25.2 15.6 11.8 34.2 19 52.8 24.4 56.8 18.8 116.8 28 176.8 26.6 29-0.4 72-3.8 100-8.8v-84c0 0-22 5-82.6 25-9.2 3-18.4 6.6-28 8.6-14.2 3.2-28.8 4.2-43.2 4.4-13-0.6-26.4-1.4-38.6-6.2-4.4-2-9.2-4.4-11-9.2-1.6-4 0.6-8 3.4-10.8 5.6-5.8 13.6-9 21.2-12z","M1024 691.8c-0.2-12-7.4-22.4-15.8-30-14.2-12.6-31.8-20.6-49.4-27-11-3.8-18.6-6.6-29.4-10-50.4-16.4-103.8-22.4-156.6-22.6-16 0.6-46.2 1-62 2.8-43.8 5-134.6 30.8-134.6 30.8v97.6c0 0 135-43.2 193-63.6 19.4-6.6 40.2-9.2 60.6-9.2 13 0.4 26.4 1.4 38.8 6.2 4.4 1.8 9 4.4 11 9 1.8 5.2-1.8 10-5.8 13-9.4 7.6-21.4 10.6-32.4 14.8-82 29-265.4 89.4-265.4 89.4v94c0 0 234.4-79.2 341.6-117.6 17.8-6.6 35.8-12.2 52.8-20.8 15.8-8 31.6-17.2 43.6-30.6 6.2-7.2 10-16 10-26.2z"],"grid":0,"tags":["logo-playstation"]},{"paths":["M386.92 498.112c7.446-1.34 15.178-2.082 23.172-2.082l-6.244-0.030h207.646c9.006 0 17.612-1.234 25.816-3.508 38.74-10.726 66.69-45.074 66.69-87.326v-174.448c0-49.664-42.3-86.968-92.578-95.212-31.862-5.248-78.516-7.654-110.178-7.498-31.658 0.172-61.962 2.808-88.554 7.498-78.404 13.646-92.69 42.35-92.69 95.212v57.282h192v32h-254.36c-71.256 0-129.076 85.142-129.626 190.484-0.004 0.506-0.014 1.010-0.014 1.516 0 19.046 1.88 37.44 5.37 54.808 15.926 79.332 65.532 137.192 124.27 137.192h30.36v-91.87c0-53.654 40.292-103.466 98.92-114.018zM407.312 254.004c-19.184 0-34.768-15.57-34.768-34.806 0-19.328 15.548-35.040 34.768-35.040 19.148 0 34.798 15.71 34.798 35.040 0.002 19.236-15.618 34.806-34.798 34.806z","M887.902 445.086c-18.342-73.044-65.836-125.086-121.542-125.086h-30.36v81.344c0 67.83-44.572 116.948-98.978 125.362-5.474 0.848-10.966 1.292-16.602 1.292h-207.718c-9.036 0-17.808 1.168-26.098 3.344-38.244 10.036-66.604 41.858-66.604 83.13v174.454c0 49.664 49.954 78.852 98.962 93.102 58.654 17.062 122.534 20.136 192.732 0 46.606-13.32 92.306-40.242 92.306-93.102v-52.926h-192v-32h254.36c50.48 0 94.214-42.73 115.628-105.098 8.96-26.094 14.012-55.62 14.012-86.902 0-23.536-2.866-46.076-8.098-66.914zM615.734 765.64c19.18 0 34.762 15.57 34.762 34.8 0 19.3-15.582 35.042-34.762 35.042-19.154 0-34.798-15.742-34.798-35.042-0-19.26 15.612-34.8 34.798-34.8z"],"grid":0,"tags":["logo-python"]},{"paths":["M708.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z","M444.2 576.8c0 35.125-28.475 63.6-63.6 63.6s-63.6-28.475-63.6-63.6c0-35.125 28.475-63.6 63.6-63.6s63.6 28.475 63.6 63.6z","M961 502c0-55.4-44.4-100.4-99-100.4-26 0-49.4 10-67.2 26.6-66.4-46.8-156.8-77-257.4-81.4l46.6-155.4 139.2 27.8c0.4 49.4 40.2 89.4 89 89.4 49.2 0 89-40.4 89-90.2s-39.8-90.4-89-90.4c-37.2 0-69 23.2-82.4 56l-170.4-34-58.8 196.4-14.2 0.4c-100.6 4.4-191 34.8-257.4 81.4-17.6-16.6-41.2-26.6-67.2-26.6-54.6 0-99 45-99 100.4 0 39.2 22 73 54.2 89.6-1.6 9.8-2.4 19.6-2.4 29.6 0.4 151.6 178.2 274.8 397.4 274.8s397-123.2 397-275c0-10-0.8-19.8-2.2-29.6 32.2-16.6 54.2-50.4 54.2-89.4zM812.2 163.8c29.6 0 53.6 24.4 53.6 54.4s-24 54.4-53.6 54.4c-29.6 0-53.6-24.4-53.6-54.4s24-54.4 53.6-54.4zM98.4 502c0-35.6 28.6-64.4 63.6-64.4 14.4 0 27.8 5 38.4 13.2-34.6 30.4-60.2 66-74 104.8-16.8-11.8-28-31.4-28-53.6zM772.8 785.8c-69.2 47.8-161.8 74.2-260.8 74.2s-191.6-26.4-260.8-74.2c-65-45-100.8-103.6-100.8-164.8 0-6.4 0.4-13 1.2-19.4 1.4-12 4.4-23.8 8.6-35.4 11.2-31.2 32-60.6 61.4-86.8 8.8-7.8 18.4-15.4 28.8-22.6 0.2-0.2 0.6-0.4 0.8-0.6 69.2-47.8 161.8-74.2 260.8-74.2s191.6 26.4 260.8 74.2c0.2 0.2 0.6 0.4 0.8 0.6 10.4 7.2 20 14.8 28.8 22.6 29.4 26.2 50.2 55.6 61.4 86.8 4.2 11.6 7 23.4 8.6 35.4 0.8 6.4 1.2 12.8 1.2 19.4 0 61.2-35.8 119.8-100.8 164.8zM897.6 555.4c-13.8-38.8-39.4-74.4-74-104.8 10.6-8.2 24-13.2 38.4-13.2 35 0 63.6 29 63.6 64.4 0 22.4-11.2 42-28 53.6z","M641 715.8c-0.4 0.4-48.4 48.4-129 48.8-81.8-0.4-128.8-48.4-129.2-48.8l-25.2 24.8c2.4 2.4 59.2 59 154.4 59.4 95.2-0.4 151.8-57 154.2-59.4l-25.2-24.8z"],"grid":0,"tags":["logo-reddit"]},{"paths":["M239.8 672.2c-61.6 0-111.8 50.2-111.8 111.6 0 61.6 50.2 111.2 111.8 111.2 61.8 0 111.8-49.8 111.8-111.2s-50-111.6-111.8-111.6z","M128 384v159.8c96 0 188.2 28.4 256 96.2s96 159.8 96 256h160c0-279.8-232-512-512-512z","M128 128v159.8c342 0 607.8 266 607.8 608.2h160.2c0-423.4-344-768-768-768z"],"grid":0,"tags":["logo-rss"]},{"paths":["M1023.568 658.216c-3.34-27.198-18.472-48.292-41.59-64.832 5.714 4.080 10.55 7.532-0.11-0.082-14.378-10.262-6.76-4.822-0.094-0.064-57-40.602-131.352-31.578-193.466-9.022-24.894-40.59-25.974-71.566-11.632-115.874 1.858-5.6 0.59-8.708-5.248-11.208-14.172-6.060-34.582-2.854-48.844 0.926-4.924 1.292-8.508 3.8-9.6 8.762-10.308 48.486-42.018 92.896-69.656 133.772-19.462-37.304-17.92-66.174-4.828-105.032 1.596-4.732 0.862-7.248-3.874-9.758-14.52-7.514-36.802-3.824-51.6 0.552-17.018 4.964-42.58 89.188-50.744 105.892-17.062 34.884-32.182 89.33-61.17 117.004-24.6-31.614 45.052-103.034 21.764-131.702-7.876-9.696-22.126-9.446-31.172-1.232 2.17-15.216 3.296-25.218-0.64-38.126-4.162-13.58-14.722-21.374-30.18-20.98-35.99 1.054-67.686 27.63-89.282 52.794-20.554 24.21-74.762 39.254-103.906 53.854-50.064-43.614-158.442-89.894-161.264-164.162-3.056-83.692 96.638-140.49 163.194-174.456 86.56-44.208 219.922-99.216 318.276-50.872 26.098 12.828 36.598 40.342 29.414 66.696-18.736 68.732-94.396 114.586-160.206 135.614-32.378 10.35-67.938 18.054-102.2 16.052-45.91-2.686-81.66-30.448-86.562-32.172-4.098-0.778-3.776 4.522-2.694 7.328 47.632 124.866 288.834 33.362 351.912-30.742 30.378-30.842 48.826-60.73 56.702-107.788 9.232-55.166-31.268-89.684-62.008-103.914-155.836-72.144-371.272 22.336-489.106 118.654-51.136 41.802-115.104 108.22-85.748 177.892 31.86 75.61 129.472 114.38 193.006 160.624-51.408 25.546-115.724 51.966-149.036 99.866-19.048 27.458-25.806 56.718-11.622 87.932 25.144 55.136 116.57 31.244 155.146 6.942 35.34-22.26 59.126-52.14 69.4-90.456 8.91-33.218 7.082-67.732-7.712-99.024l57.17-28.916c-15.394 46.152-22.194 104.006 9.762 145.71 12.804 16.676 46.034 17.35 59.634 0.622 17.632-21.886 29.328-49.31 41.006-74.412-1.364 18.746-3.712 39.992 2.754 56.33 7.42 18.746 24.252 22.582 41.584 10.686 53.040-36.406 86.796-137.304 112.926-196.124 7.104 25.658 14.946 49.096 27.914 72.752 3.204 5.806 2.814 9.548-1.592 14.39-19.37 21.35-65.652 56.958-70.138 85.798-1.048 6.742 3.426 13.198 11.372 14.74 31.146 6.216 65.676-5.062 90.964-22.156 26.376-17.844 34.892-42.174 28.49-71.030-9.152-41.542 21.986-87.96 51.602-122.060 5.438 25.816 13.632 50.662 28.286 73.212-26.15 22.966-65.16 55.528-59.558 93.878 1.976 13.73 14.27 22.602 29.028 19.472 31.566-6.648 58.832-20.226 78.74-44.292 18.046-21.71 11.584-45.402 3.712-69.27 47.744-13.63 96.044-16.354 143.662-0.054 22.99 7.82 41.51 21 52.496 41.636 13.452 25.288 5.878 48.584-20.1 65.208-6.574 4.208-11.124 7.666-8.9 9.486 2.224 1.822 9.8 4.226 26.568-6.304 16.768-10.534 27.020-24.766 29.646-43.45 0.526-5.166 0.51-10.334-0.048-15.51zM225.892 708.734c-2.716 33.346-19.272 60.386-46.35 82.228-15.234 12.316-34.204 22.352-53.040 24.184-18.836 1.834-33.502-2.922-34.756-22.46-3.528-54.986 81.846-108.848 129.25-125.066 4.040 13.72 6.022 27.332 4.864 41.174l0.032-0.060zM432.096 563.828c-7.806 44.618-29.66 124.694-64.628 156.672-4.712 4.286-9.22 4.036-11.618-1.542-20.69-48.118 7.342-147.338 66.164-162.656 6.914-1.778 11.204 1.164 10.082 7.526zM572.718 727.364c16.844-17.924 33.668-35.832 50.538-53.854 2.086 20.042-35.142 59.928-50.538 53.854zM734.146 691.972c-4.696 2.546-15.242 5.030-15.654 1.67-2.964-24.17 23.632-49.748 40.134-61.734 8.906 22.686-1.636 47.668-24.48 60.064z"],"grid":0,"tags":["logo-sass"]},{"paths":["M873.8 593.6c5.6-25 8.4-50.8 8.4-77.4 0-199.4-164-361.2-366.4-361.2-21.4 0-42.2 1.8-62.6 5.2-32.6-20.4-71.2-32.2-112.8-32.2-117.2 0-212.4 93.8-212.4 209.4 0 38.8 10.6 75 29.2 106-4.8 23.4-7.4 47.8-7.4 72.6 0 199.6 164 361.2 366.2 361.2 23 0 45.4-2 67-6 30 15.8 64.2 24.8 100.4 24.8 117.4 0 212.4-93.8 212.4-209.4 0.2-33.4-7.8-65-22-93zM703.8 688.6c-17 23.6-42 42.4-74.4 55.6-32.2 13.2-70.6 19.8-114.6 19.8-52.6 0-96.6-9.2-131.2-27.2-24.6-13.2-44.8-30.8-60.4-52.8s-23.4-44-23.4-65.2c0-13.2 5.2-24.6 15.2-34.2 10-9.2 23-14 38.2-14 12.6 0 23.4 3.6 32.2 11 8.4 7 15.6 17.4 21.4 31 6.6 14.6 13.6 27 21.2 36.8 7.2 9.4 17.4 17.2 30.6 23.4 13.4 6.2 31.2 9.4 53.2 9.4 30.2 0 55-6.4 73.6-19 18.4-12.2 27.2-27 27.2-45 0-14.2-4.6-25.4-14.2-34.2-10-9.2-23-16.4-39.2-21.2-16.6-5.2-39.2-10.6-67.2-16.4-38-8-70.2-17.6-96-28.4-26.2-11-47.4-26.4-63-45.4-15.8-19.4-23.6-43.8-23.6-72.4 0-27.4 8.4-51.8 24.8-73 16.4-21 40.2-37.4 71.2-48.6 30.4-11.2 66.6-16.8 107.4-16.8 32.8 0 61.4 3.8 85.4 11 24.2 7.4 44.4 17.4 60.6 29.8 16 12.4 28 25.6 35.6 39.4 7.6 14 11.4 27.8 11.4 41.2 0 12.8-5 24.6-15 34.8s-22.6 15.6-37.6 15.6c-13.6 0-24.2-3.2-31.6-9.6-6.8-6-14-15.2-21.8-28.6-9.2-17-20.2-30.6-32.8-40.2-12.4-9.2-32.8-14-61.2-14-26.2 0-47.6 5.2-63.4 15.4-15.2 9.8-22.6 21.2-22.6 34.6 0 8.2 2.4 15 7.4 21 5.2 6.2 12.4 11.8 21.8 16.4 9.6 4.8 19.6 8.6 29.4 11.2 10.2 2.8 27.2 7 50.6 12.2 29.8 6.2 57 13.4 81 20.8 24.4 7.8 45.4 17.2 62.6 28.2 17.6 11.2 31.4 25.8 41.4 43 9.8 17.2 14.8 38.8 14.8 63.6 0.8 30.2-7.8 57.4-25 81z"],"grid":0,"tags":["logo-skype"]},{"paths":["M991.996 720.778l-0.378-29.002-28.796-2.556c-30.826-2.792-87.6-14.438-108.602-33.8-32.562-30.022-71.376-72.398-71.376-103.786 0-2.028 0-5.092 8.3-10.372 9.97-6.348 25.178-11.168 38.594-15.42 10.434-3.308 20.288-6.434 28.788-10.472 18.472-8.78 36.996-31.956 34.942-57.614-2.43-30.332-28.848-54.092-60.144-54.092-8.042 0-16.136 1.52-24.054 4.518-16.054 6.082-27.486 8.82-35.41 9.924 1.494-18.638 3.582-40.24 6.422-61.34 10.222-75.896-10.562-147.018-58.528-202.084-50.758-58.266-127.002-90.682-209.188-90.682h-0.566c-82.186 0-158.43 32.416-209.182 90.682-47.964 55.068-68.75 126.69-58.53 202.584 2.832 21.020 4.92 42.462 6.42 61.236-7.94-1.118-19.372-3.996-35.406-10.068-7.93-3.004-16.034-4.59-24.086-4.59-31.282-0.002-57.688 23.704-60.114 54.006-2.054 25.636 16.47 48.786 34.94 57.566 8.502 4.040 18.362 7.156 28.8 10.464 13.414 4.25 28.618 9.064 38.586 15.406 8.294 5.278 8.294 8.336 8.294 10.364 0 17.32-12.382 49.382-71.376 103.776-20.998 19.362-78.11 31.002-109.176 33.794l-29.144 2.622-0.026 29.364c0 3.358 0.624 21.092 12.97 40.638 10.492 16.612 32.146 38.566 75.726 48.814 12.358 2.906 22.372 5.126 30.416 6.908 4.612 1.024 9.11 2.020 12.908 2.906 0.054 0.418 0.108 0.834 0.162 1.246 1.8 14.008 3.222 25.070 8.784 35.5 4.906 9.2 17.148 24.632 44.030 24.632 4.956 0 10.498-0.492 16.944-1.502 3.344-0.526 6.772-1.108 10.4-1.726 14.232-2.424 30.364-5.174 46.902-5.174 20.554 0 37.464 4.376 51.692 13.376 9.062 5.734 17.784 11.944 27.018 18.52 35.982 25.618 76.764 54.656 142.048 54.656 65.452 0 106.586-29.164 142.878-54.892 9.152-6.488 17.796-12.618 26.754-18.284 14.226-9 31.136-13.376 51.692-13.376 16.54 0 32.668 2.75 46.898 5.172 3.628 0.622 7.058 1.204 10.404 1.728 6.446 1.010 11.986 1.502 16.944 1.502 26.88 0 39.124-15.43 44.030-24.626 5.562-10.428 6.984-21.492 8.784-35.498 0.054-0.416 0.11-0.836 0.164-1.258 3.796-0.882 8.296-1.882 12.91-2.904 8.046-1.784 18.058-4.002 30.412-6.908 43.702-10.278 65.222-32.34 75.58-49.036 12.194-19.656 12.592-37.472 12.546-40.842zM416 256c17.672 0 32 21.49 32 48s-14.328 48-32 48-32-21.49-32-48 14.328-48 32-48zM623.23 411.396c-30.494 30.054-69.996 46.604-111.23 46.604-41.676 0-81.208-16.58-111.314-46.686-6.25-6.248-6.248-16.378 0-22.626 6.25-6.248 16.38-6.248 22.626 0 24.064 24.060 55.56 37.312 88.688 37.312 32.774 0 64.3-13.28 88.77-37.396 6.296-6.204 16.426-6.126 22.624 0.164 6.204 6.294 6.13 16.426-0.164 22.628zM608 352c-17.672 0-32-21.492-32-48s14.328-48 32-48 32 21.492 32 48-14.328 48-32 48z"],"grid":0,"tags":["logo-snapchat"]},{"paths":["M960 416.4c0 41-33.2 74.4-74.4 74.4-41 0-74.4-33.2-74.4-74.4 0-41 33.2-74.4 74.4-74.4 41 0 74.4 33.4 74.4 74.4zM885.2 278c-76.2 0-138 61.4-138.8 137.4l-86.4 124c-3.6-0.4-7.2-0.6-10.8-0.6-19.4 0-37.4 5.4-52.8 14.6l-391.6-157.4c-10.2-46.4-51.8-81.4-101.2-81.4-57-0.2-103.6 46.6-103.6 103.6s46.6 103.6 103.6 103.6c19.4 0 37.4-5.4 52.8-14.6l391.6 157.2c10.2 46.6 51.6 81.6 101.2 81.6 53.6 0 98-41.2 103-93.4l133-97.2c76.6 0 138.8-62 138.8-138.6s-62.2-138.8-138.8-138.8zM885.2 323.8c51.4 0 93 41.8 93 93 0 51.4-41.8 92.8-93 92.8-51.4 0-93-41.6-93-92.8 0-51.4 41.6-93 93-93zM103.6 341.8c29.2 0 54.6 16.4 67.4 40.4l-37.8-15.2v0.2c-30.6-11-64.4 4-76.6 34.2-12.2 30.4 1.8 64.6 31.4 77.8v0.2l32.2 12.8c-5.2 1.2-10.8 1.8-16.4 1.8-42.2 0-76.2-34-76.2-76.2-0.2-41.8 33.8-76 76-76zM649.2 566.2c42.2 0 76.2 34 76.2 76.2s-34 76.2-76.2 76.2c-29.4 0-54.8-16.4-67.4-40.6 12.6 5 25 10 37.6 15.2 31 12.4 66.4-2.6 78.8-33.6s-2.6-66.2-33.8-78.8l-31.8-12.8c5.6-1 11-1.8 16.6-1.8z"],"grid":0,"tags":["logo-steam"]},{"paths":["M642.4 792.6c-23.6 0-44.8-5.6-63-16.6-13.8-8.2-23-19.2-28-32.8-5.2-13.8-7.2-44.6-7.2-92.8v-202.4h192v-128h-192v-224h-123.8c-5.4 43-15 89.4-29 117.2s-28 51.6-51.2 71.4c-23.2 19.8-51.2 35.8-83.8 46.6v116.8h96v280.8c0 38 4 67 11.8 87 8 20 22.2 39 42.8 56.8s45.6 31.4 74.6 41c29.2 9.6 62.8 14.4 100.8 14.4 33.4 0 60.6-3.4 89.4-10.2s61-18.6 96.4-35.2v-131.2c-41.8 27.4-83.6 41.2-125.8 41.2z"],"grid":0,"tags":["logo-tumblr"]},{"paths":["M852.6 792c-13.4-8-26.4-22-24-37.6 4.6-30.6 5-43-0.4-51.6-3.8-6.4-11-10-17.2-11.6 4-5 6.2-10.8 7.6-21.8 2.6-20-9.4-82-25.4-131.4s-59.8-100-89.4-136c-52-63.6-45.6-78.4-52.6-199.4-4.4-77-38.6-138.6-139.2-138.6s-134 64-134 118c0 57.4 4 102 4 102 2.6 66.8 2 78.8-16 110.6-9.8 17.4-54 60-71.4 89.4s-15.2 59-49.2 105.6c-24.8 34-27.6 56.8-19.4 88-14 16.4-7.2 39.8-10 49.8-5.2 17.4-27.4 20.6-44.6 22s-30.6 0-37.4 10.6 1.4 32 8.6 60-14.6 30-14.6 62 60 32 119.4 45.4 81.4 32.6 112 32.6 53.6-20.4 76-38.6c14.4-11.8 58-7.4 84.6-7.4s68.6-1.2 91.4 4.8 22.6 41.2 78.6 41.2 69.4-41.4 122-68.6 84-40 84-59.4-30-32-43.4-40zM399.6 903c-2.6 26-25.2 34.2-48.2 32.2-26-2.2-58-15.2-88.2-24.2s-71-15-98-19.8c-30.6-5.4 0-27.2-0.4-68.4-0.2-16-14.2-38.8-8.4-49.4s34.6-4.8 44.6-7.6 25.4-11.4 30.6-23.8c2.8-6.8 3.6-35.4 5.8-45.6 2.2-9.8 15.8-14.4 44.4 0.2s57.8 76.2 84.6 119.6 35.8 60.8 33.2 86.8zM636.6 771.4c4 20.6 6.4 49 1.4 72.6s-14 31-21.4 46c-4.4-13.6 10.6-27.6 8.8-61.6-1-19-1.6-15.6-23 3.6-24.4 21.6-55.2 40.2-106 45-42 4-65-16.6-65-16.6 10 32-8.6 49.4-8.6 49.4 0.6-7.4 1.6-28.6-5-43.2-8-18-18.6-37.4-18.6-37.4s17.2-5.4 23.2-20 4-34.6-17.4-55.4-105-75.2-111.8-84.2c-9.8-13-13.4-20.4-14-46.4s10.8-49.6 8.6-40.6c-1.6 6.4 0.2 13.6 0.2 39.6s15.2 46.6 27.8 50c19 5.2 4-52.2 16-106.2s23.4-65.6 38.4-87.6 38.4-41 34-86.2-0.2-40.2 10.2-23.6c8 13 26.6 48 49.4 44 38.8-6.6 87.8-49.2 95.2-56.4s1.4-14.2-4.6-11.6c-31 13.4-88.6 43-103 36.4s-36.2-41.2-33.6-39c30.8 27.2 39.8 22.2 52.8 18 16.8-5.6 25.6-8.6 57-22.6s41.4-10.6 44.6-17.4-0.8-13.4-9.4-11.4c-12.8 3-6.8 10.2-45.4 24.6-50.6 19-66.6 20.6-88 6-17.2-11.8-30-25.4-30-33.4s16.6-16.6 24.6-22.6 24.6-21.8 24.6-21.8 2-14.4-1.2-25.4c-3.8-13-15.6-18.6-23.8-16.2-8.2 2.2-16 11-13.6 29.6 2 16.6 14 22 14 22s-5.4 7-10.4 9.4c0 0-1.6-0.6-7-12.6s-13.2-39-0.6-62.2 39.2-10.4 47.6 7.6c7.8 16.6 4.8 45.4 4.8 45.4 12-4.4 26-4 42 7-14.2-59.6 19-82.2 44-82.2s44.6 19.2 44.6 50c0 24-7 36.4-13.8 44-8.2-1-16.4-3-12.6-6.8 2.6-2.8 8.8-11.4 8.8-26.4s-11.8-27.4-27.4-27.4c-18.4 0-25.2 16.6-27.4 26s-0.8 17.2-0.4 20.8c1.2 10 21.8 19.2 47.8 25.8s22.6 18 16.6 50.6 12.6 36.6 28.6 67.6 11.4 43.6 31.8 70.4 38 95.6 32.8 153.6c-1.8 21-7.8 20.4 14.6 13.4 11.2-3.4 24-5.4 24-5.4 6.2-12.6 6.8-32.6 7-44.6 0.4-27 1.4-83-53.4-143 0 0 59 43.4 68 124 5 44.6-4 64.8-4 64.8 10.6 2.6 19.6 14.6 25.2 23.6 7.4 12.2-7.8-11.6-40-11.6-17 0-30.6 7.8-37 15.8s-6.2 15.2-6.4 23.4c-14.2-2.4-24.8 0-33.6 9.8-11.2 14-5.6 48.4-1.6 69.2zM816.8 865.8c-48.2 20.8-65.4 47-95.4 63s-55.4 4.6-67.4-16 20.8-56.4 9.4-119.2c-8.8-48.4-12.6-62-9.8-73.6 2.8-11 18.8-8.8 23-7.8 2.6 10.8 13.4 39 54 39 0 0 46.4 5.2 65.4-42.4 0 0 11.4-0.4 14.4 7 4.6 11.6-5.8 33-5.6 42.6 0.6 31.4 23.4 42.2 56.8 64 16.4 11.2 4.2 22.2-44.8 43.4z"],"grid":0,"tags":["logo-tux"]},{"paths":["M160 64l-64 160v608h192v128h128l128-128h160l224-224v-544h-768zM832 576l-128 128h-192.002l-127.998 128v-128h-160v-544h608v416z","M640 286h96v258h-96v-258z","M416 286h96v258h-96v-258z"],"grid":0,"tags":["logo-twitch"]},{"paths":["M984 219c-34.8 15.4-72 25.8-111.2 30.6 40-24 70.8-62 85.2-107.2-37.4 22.2-78.8 38.4-123 47-35.4-37.8-85.8-61.4-141.4-61.4-107 0-193.6 86.8-193.6 193.8 0 15.2 1.6 30 5 44.2-161-8-303.8-85.2-399.2-202.6-16.6 28.6-26.2 62-26.2 97.4 0 67.2 34.4 126.6 86.4 161.4-32-0.8-62-9.6-88-24.2 0 0.8 0 1.6 0 2.4 0 94 66.8 172.2 155.4 190-16.2 4.4-33.4 6.8-51 6.8-12.4 0-24.6-1.2-36.4-3.6 24.6 77 96.2 133 181 134.6-66.2 52-149.8 83-240.6 83-15.6 0-31-1-46.2-2.8 85.4 55.6 187.2 87.6 296.4 87.6 356.6 0 551.4-295.4 551.4-551.6 0-8.4-0.2-16.8-0.6-25 37.8-27.4 70.6-61.4 96.6-100.4z"],"grid":0,"tags":["logo-twitter"]},{"paths":["M822.774 606.512c-6.238-19.154-15.782-37.122-28.602-53.904-12.844-16.764-28.792-31.652-47.86-44.662-19.078-12.996-41.442-23.26-67.106-30.8-10.286-2.726-28.378-7.012-52.208-12.836-17.032-4.148-33-8.4-51-12.734v-211.446c18 4.792 30.504 12.404 43.852 20.86 28.558 18.080 46.464 49.010 51.71 91.010h138.348c-1.308-36-9.3-65.52-23.992-92.040-16.14-29.086-37.954-54.048-65.46-73.912-27.5-19.844-60.45-34.98-96.754-44.91-15.768-4.306-29.702-7.928-47.702-10.366v-66.772h-128v66.334c-14 2.088-30.296 4.89-44.852 8.5-34.484 8.566-64.776 21.736-91.902 39.528-27.142 17.81-48.704 40.224-65.208 67.254-16.502 27.046-24.624 59.040-24.624 96 0 19.17 2.814 37.986 8.314 56.47 5.504 18.482 14.884 35.934 28.084 52.362 13.206 16.428 30.99 31.316 53.374 44.664 22.366 13.344 49.41 24.128 83.152 32.342 18.574 4.69 37.66 9.068 53.66 13.152v239.172c-22-5.838-43.778-14.798-61.356-26.958-18.34-12.654-32.132-27.906-42.396-47.768-9.558-18.458-14.146-41.052-14.814-65.052h-137.432c1.39 42 10.5 78.988 27.344 110.742 17.598 33.208 41.066 59.92 70.408 81.124 29.324 21.226 62.786 36.712 102.396 46.982 17.77 4.608 37.852 7.92 55.852 10.46v70.692h128v-69.080c20-2.138 37.914-5.38 57.054-9.758 37.402-8.546 71.29-22.072 100.632-40.552 29.324-18.48 53.242-42.256 71.222-71.362 17.96-29.082 27.090-64.17 27.090-105.238 0.002-19.156-3.002-38.328-9.224-57.498zM448 419.398c-24-7.486-47.824-18.176-64.102-32.096-17.242-14.71-25.346-35.068-25.346-61.090 0-18.482 4.828-33.88 14.008-46.204 9.16-12.322 19.824-22.076 33.76-29.262 12.36-6.378 27.68-11.13 41.68-14.276v182.928zM685.804 718.942c-5.878 13.346-15.398 25.152-28.606 35.422-13.204 10.266-31.488 18.656-52.754 25.154-9 2.756-16.446 4.888-28.446 6.472v-214.22c20 5.248 36.36 10.664 52.652 16.262 16.124 5.488 31.496 14.886 45.074 28.232 13.57 13.352 20.618 34.060 20.618 62.12 0.002 13.7-2.674 27.21-8.538 40.558z"],"grid":0,"tags":["logo-usd"]},{"paths":["M953.8 228c-10-46.8-35-77.6-81.2-92.6s-129.8-9-188.2 33.6c-59.8 43.6-95.2 119.4-107.6 167.6 29.4-12.6 48-15.4 78-13.8s49 24 49.8 50.6c0.6 19.6-0.4 37.4-7.2 55.4-21.6 57.4-55.4 113-95.2 161.6-5.8 7.2-12.8 13.8-20 19.8-20.4 16.6-37.6 12.2-50.8-10.4-10.8-18.6-18-37.8-24.4-58.2-24.8-79.4-33.6-161.8-47.6-243.2-6.6-39-14-79.6-36-113.8-23.2-35.6-57.2-49.2-100-44-29.4 3.6-73.8 35-95.6 52.8 0 0-112 93.8-163.6 142.8l42.4 54c0 0 35.8-25 55-36.6 11.4-6.8 24.8-8.2 34.4 0.4 9 7.8 19.2 18 24.6 28.2 11.4 21.4 22.4 43.8 29.4 66.8 26.4 88.6 51 177.4 75.6 266.6 12.6 45.6 27.8 88.4 56 127.2 38.6 53.2 79.2 65.4 141.8 43 50.8-18.2 93.2-52.4 132-87.8 66.2-60.4 118.2-130.8 171-202.4 40.8-55.4 74.6-111.4 102.8-174 27.8-62 38.8-127 24.6-193.6z"],"grid":0,"tags":["logo-vimeo"]},{"paths":["M520.124 64c-242.914 0-439.856 195.402-439.856 436.464 0 82.46 23.064 159.58 63.118 225.374l-79.386 234.162 243.528-77.364c63.016 34.57 135.49 54.292 212.596 54.292 242.946 0 439.876-195.43 439.876-436.464 0-241.062-196.93-436.464-439.876-436.464zM738.848 666.22c-10.348 25.654-57.148 49.066-77.798 50.144-20.628 1.094-21.216 15.988-133.68-32.868-112.45-48.868-180.104-167.688-185.438-175.34-5.338-7.624-43.56-62.094-41.498-116.91 2.076-54.826 32.094-80.692 42.808-91.45 10.702-10.774 22.972-12.704 30.464-12.826 8.856-0.144 14.592-0.264 21.146-0.022 6.548 0.248 16.384-1.37 24.9 21.278 8.512 22.646 28.886 78.306 31.492 83.978 2.604 5.678 4.216 12.252 0.204 19.542-4.024 7.306-6.084 11.87-11.922 18.166-5.87 6.296-12.348 14.084-17.584 18.898-5.84 5.33-11.94 11.144-5.8 22.538 6.136 11.386 27.306 48.712 59.558 79.472 41.45 39.542 77.196 52.658 88.196 58.634 11.030 6.008 17.612 5.34 24.452-1.858 6.808-7.198 29.278-31.492 37.192-42.338 7.91-10.876 15.322-8.746 25.484-4.658 10.156 4.104 64.314 33.112 75.346 39.102 11.020 5.978 18.386 9.058 21.020 13.8 2.634 4.76 1.802 27.062-8.542 52.718z"],"grid":0,"tags":["logo-whatsapp"]},{"paths":["M960 530h-496v358l496 72v-430z","M432 530h-368v300l368 53.4v-353.4z","M960 64l-496 70.8v363.2h496v-434z","M432 139.4l-368 52.6v306h368v-358.6z"],"grid":0,"tags":["logo-windows"]},{"paths":["M518 542.6l-65.6 191.4h-0.2l-50.8 146.2c3.6 1 7 1.8 10.6 2.8 0.2 0 0.4 0 0.6 0 31.6 8.4 64.8 13 99 13 17 0 33.6-1 49.8-3.6 22.4-2.8 44-7.6 65-14.2 0 0 0 0 0 0 5.2-1.6 10.4-3.4 15.6-5.2-5.6-12-17.6-38.6-18.2-39.8l-105.8-290.6z","M161.6 361c-20 45.2-33.6 100.8-33.6 151 0 12.6 0.6 25.2 1.8 37.6 13.8 142.4 105.8 262 232.2 315.8 5.2 2.2 10.6 4.4 16 6.4l-186-510.6c-16-0.6-19 0.4-30.4-0.2z","M860.4 350.8c-8.6-18.6-18.8-36.4-30.2-53.2-3.2-4.8-6.8-9.6-10.2-14.4-43-57.6-101.6-102.8-169.8-129.2-42.8-16.8-89.6-26-138.4-26-120.6 0-228.4 56-298.8 143.4-13 16-24.6 33.2-35 51.2 28.4 0.2 63.6 0.2 67.6 0.2 36.2 0 92-4.4 92-4.4 18.8-1.2 20.8 26.2 2.2 28.4 0 0-18.8 2.2-39.6 3.2l125.8 374 75.6-226.6-53.6-147.2c-18.8-1-36.2-3.2-36.2-3.2-18.8-1-16.4-29.6 2-28.4 0 0 57 4.4 91 4.4 36.2 0 92-4.4 92-4.4 18.6-1.2 21 26.2 2.2 28.4 0 0-18.6 2.2-39.4 3.2l124.6 371.2 34.6-115.2c17.4-44.8 26.2-81.8 26.2-111.4 0-42.6-15.4-72.2-28.6-95.2-17.4-28.6-33.8-52.6-33.8-80.8 0-31.8 24-61.4 58-61.4 1.4 0 3 0 4.4 0 52.4-1.4 69.6 50.6 71.8 86 0 0 0 0.8 0 1.2 0.8 14.4 0.2 25 0.2 37.6 0 34.8-6.6 74.2-26.2 123.6l-78 225.6-44.6 131.4c3.6-1.6 7-3.2 10.6-5 113.4-54.8 196-164 213.4-293.4 2.6-17 3.8-34.4 3.8-52 0-57.8-12.8-112.6-35.6-161.6z"],"grid":0,"tags":["logo-wordpress"]},{"paths":["M253.6 496.6c79.4-117.2 155.8-185.6 155.8-185.6s-84.2-97.8-185.6-134.8l-6.6-1.6c-93.8 82.2-153.2 202.8-153.2 337.4 0 101.4 33.8 195 90.4 270 0-8.8 1.2-140.6 99.2-285.4z","M960 512c0-134.6-59.4-255.2-153.2-337.4l-6.4 1.8c-101.4 37-185.8 134.8-185.8 134.8s76.4 68.4 155.8 185.6c98 144.8 99.2 276.6 99 285.4 57-75.2 90.6-168.8 90.6-270.2z","M402.4 161.8c58.6 26.2 109.2 69.2 109.2 69.2s51-42.8 109.6-69.2c73.6-33 129.8-22.6 144.6-19-72.2-49.6-159.6-78.8-253.8-78.8s-181.6 29.2-253.8 78.8c14.4-3.6 70.4-14.2 144.2 19z","M717.4 585.8c-92.6-113.8-205.8-187.8-205.8-187.8s-112.6 74-205.4 187.8c-79.6 97.8-109.2 169.6-125.2 215.6l-2.6 9.6c82 91.4 201 149 333.6 149s251.6-57.6 333.6-149l-2.8-9.6c-16-46-45.8-117.8-125.4-215.6z"],"grid":0,"tags":["logo-xbox"]},{"paths":["M769.2 136.8c-22.6 0-45-1.6-65.2-8.8l-192 320-192-320c-20.2 7.2-41.4 8.8-64 8.8-22.2 0-44.2-1.8-64-8.8l256 425.4v342.6c20-7 41.6-8.8 64-8.8s44 1.8 64 8.8v-342l256-426c-19.8 6.8-40.6 8.8-62.8 8.8z"],"grid":0,"tags":["logo-yahoo"]},{"paths":["M896 64h-160l-224 442.256-224-442.256h-160l224.736 416h-96.736v96h147.128l28.872 62v34h-176v96h176v192h160v-192h176v-96h-176v-34l29.782-62h146.218v-96h-96.578l224.578-416z"],"grid":0,"tags":["logo-yen"]},{"paths":["M1017.2 297.6c0-90-66.2-162.4-148-162.4-110.8-5.2-223.8-7.2-339.2-7.2-6 0-12 0-18 0s-12 0-18 0c-115.2 0-228.4 2-339.2 7.2-81.6 0-147.8 72.8-147.8 162.8-5 71.2-7.2 142.4-7 213.6-0.2 71.2 2 142.4 6.8 213.8 0 90 66.2 163 147.8 163 116.4 5.4 235.8 7.8 357.2 7.6 121.6 0.4 240.6-2 357.2-7.6 81.8 0 148-73 148-163 4.8-71.4 7-142.6 6.8-214 0.4-71.2-1.8-142.4-6.6-213.8zM414 707.8v-393l290 196.4-290 196.6z"],"grid":0,"tags":["logo-youtube"]},{"paths":["M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-172v172h-84v-172h-172v-84h172v-172h84v172h172v84z"],"grid":0,"tags":["md-add-circle"]},{"paths":["M832 554.666h-277.334v277.334h-85.332v-277.334h-277.334v-85.332h277.334v-277.334h85.332v277.334h277.334v85.332z"],"grid":0,"tags":["md-add"]},{"paths":["M940 249.674l-196.886-163.56-55.628 65.862 196.884 163.538 55.63-65.84zM334.384 149.838l-55.652-65.838-194.732 165.674 55.628 65.838 194.756-165.674zM533.402 345.256h-64.202v254.892l203.298 121.078 32.102-53.106-171.2-99.834v-223.030zM512 175.33c-214 0-385.202 172.042-385.202 382.332 0 210.298 171.202 382.338 385.202 382.338 211.872 0 385.202-172.040 385.202-382.338 0-210.288-173.33-382.332-385.202-382.332zM512 855.040c-164.786 0-299.6-133.812-299.6-297.376 0-163.554 134.814-297.368 299.6-297.368 164.788 0 299.6 133.812 299.6 297.368 0 165.678-134.812 297.376-299.6 297.376z"],"grid":0,"tags":["md-alarm"]},{"paths":["M309.4 928h533.4c47 0 85.4-38.4 85.4-85.4v-533.2c0-47-38.4-85.4-85.4-85.4h-533.4c-47 0-85.4 38.4-85.4 85.4v533.4c0 46.8 38.4 85.2 85.4 85.2z","M181.4 96h533.4c47 0 85.4 38.4 85.4 85.4v10.6h-522.8c-47 0-85.4 38.4-85.4 85.4v522.6h-10.6c-47 0-85.4-38.4-85.4-85.4v-533.2c0-47 38.4-85.4 85.4-85.4z"],"grid":0,"tags":["md-albums"]},{"paths":["M512 96c-228.8 0-416 187.202-416 416s187.2 416 416 416c228.8 0 416-187.202 416-416s-187.2-416-416-416zM560 720h-96v-80h96v80zM560 544h-96v-256h96v256z"],"grid":0,"tags":["md-alert"]},{"paths":["M64 512c28.2 70 72.4 132 128 181.2v-362.4c-55.6 49.2-99.8 111.2-128 181.2z","M960 512c-28.2-70-72.4-132-128-181.2v362.4c55.6-49.2 99.8-111.2 128-181.2z","M512 210c-94.2 0-182 26.8-256 73v457.8c74 46.2 161.8 73 256 73s182-26.8 256-73v-457.8c-74-46.2-161.8-73-256-73zM704 480v128h-64v-64h-96v64h-64v-64h-96v64h-64v-192h64v64h96v-64h64v64h96v-64h64v64z"],"grid":0,"tags":["md-american-football"]},{"paths":["M758.8 356.6l-174.4 266.8c13.6 16.6 21.6 37.6 21.6 60.6 0 53-43 96-96 96s-96-43-96-96c0-6 0.6-12 1.6-17.8l-115.2-67c-17.2 16.6-40.6 26.8-66.6 26.8-17.2 0-33.2-4.6-47.2-12.4l-122.6 114.8v114.4c0 47 38.4 85.4 85.4 85.4h725.4c47 0 85.4-38.4 85.4-85.4v-425.2l-117.2-77.8c-16.2 12.6-36.6 20.2-58.8 20.2-8.8 0-17.4-1.2-25.4-3.4z","M234 434c53 0 96 43 96 96 0 4.2-0.4 8.4-0.8 12.4l120.2 67.2c16.6-13.6 37.6-21.6 60.8-21.6 7.2 0 14.2 0.8 20.8 2.2l174.8-270.8c-11.2-15.6-17.8-34.8-17.8-55.6 0-53 43-96 96-96s96 43 96 96c0 7.8-1 15.4-2.6 22.6l82.6 55.2v-160.2c0-47-38.4-85.4-85.4-85.4h-725.2c-47 0-85.4 38.4-85.4 85.4v458.6l80-76.6c-3.8-10.4-6-21.6-6-33.4 0-53 43-96 96-96z"],"grid":0,"tags":["md-analytics"]},{"paths":["M512 64c-247.424 0-448 200.576-448 448s200.576 448 448 448 448-200.576 448-448-200.576-448-448-448zM783.53 783.53c-72.53 72.526-168.96 112.47-271.53 112.47s-199-39.944-271.53-112.47c-72.526-72.53-112.47-168.96-112.47-271.53s39.944-199 112.47-271.53c72.53-72.526 168.96-112.47 271.53-112.47s199 39.944 271.53 112.47c72.526 72.53 112.47 168.96 112.47 271.53s-39.944 199-112.47 271.53z","M400.086 212.134c-81.262 30.342-146.868 92.764-181.434 171.866h293.348l-111.914-171.866z","M825.594 576c4.198-20.68 6.406-42.082 6.406-64 0-73.248-24.628-140.734-66.032-194.668l-143.968 258.668h203.594z","M719.946 268.79c-55.932-47.868-128.558-76.79-207.946-76.79-15.932 0-31.588 1.182-46.896 3.43l156.6 252.57 98.242-179.21z","M198.408 448c-4.2 20.68-6.408 42.082-6.408 64 0 73.278 24.648 140.788 66.082 194.732l143.918-258.732h-203.592z","M623.918 811.864c81.262-30.342 146.866-92.764 181.43-171.864h-293.348l111.918 171.864z","M304.092 755.242c55.926 47.848 128.536 76.758 207.908 76.758 15.938 0 31.598-1.184 46.912-3.432l-156.584-252.568-98.236 179.242z"],"grid":0,"tags":["md-aperture"]},{"paths":["M192 352h160v-160h-160v160zM432 832h160v-160h-160v160zM192 832h160v-160h-160v160zM192 592h160v-160h-160v160zM432 592h160v-160h-160v160zM672 192v160h160v-160h-160zM432 352h160v-160h-160v160zM672 592h160v-160h-160v160zM672 832h160v-160h-160v160z"],"grid":0,"tags":["md-apps"]},{"paths":["M928 304h-208c0-114-93.124-207.718-208-207.718s-208 93.718-208 207.718h-208c37.376 432 26 624 26 624h779.998c-0.002 0-11.376-196 26.002-624zM512 148.21c86.016 0 155.998 69.79 155.998 155.79h-311.998c0-86 69.982-155.79 156-155.79zM408 795.28v-337.546l285.998 168.774-285.998 168.772z"],"grid":0,"tags":["md-appstore"]},{"paths":["M907.188 200.002l-64.706-78.598c-11.544-16.15-32.316-25.404-53.154-25.404h-554.658c-20.832 0-41.602 9.254-53.152 25.404l-64.702 78.598c-13.88 13.844-20.816 34.668-20.816 57.77v577.78c0 50.848 41.6 92.448 92.45 92.448h647.106c50.848 0 92.444-41.6 92.444-92.45v-577.78c0-23.1-6.926-43.924-20.812-57.768zM512 766.218l-254.22-254.218h161.78v-92.448h184.886v92.448h161.78l-254.226 254.218zM193.068 188.442l36.972-46.222h554.662l43.93 46.222h-635.564z"],"grid":0,"tags":["md-archive"]},{"paths":["M854 469.25h-519.408l239.404-239.404-61.996-59.846-342 342 342 342 59.844-59.848-237.252-239.402h519.408v-85.5z"],"grid":0,"tags":["md-arrow-back"]},{"paths":["M554.75 170v519.408l239.404-239.404 59.846 61.996-342 342-342-342 59.848-59.844 239.402 237.252v-519.408h85.5z"],"grid":0,"tags":["md-arrow-down"]},{"paths":["M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM512 640l-192-192h384l-192 192z"],"grid":0,"tags":["md-arrow-dropdown-circle"]},{"paths":["M256 384l256 256 256-256z"],"grid":0,"tags":["md-arrow-dropdown"]},{"paths":["M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM384 512l192-192v384l-192-192z"],"grid":0,"tags":["md-arrow-dropleft-circle"]},{"paths":["M640 256l-256 256 256 256z"],"grid":0,"tags":["md-arrow-dropleft"]},{"paths":["M512 928c229.75 0 416-186.25 416-416s-186.25-416-416-416-416 186.25-416 416 186.25 416 416 416zM448 704v-384l192 192-192 192z"],"grid":0,"tags":["md-arrow-dropright-circle"]},{"paths":["M384 256l256 256-256 256z"],"grid":0,"tags":["md-arrow-dropright"]},{"paths":["M928 512c0-229.75-186.25-416-416-416s-416 186.25-416 416 186.25 416 416 416 416-186.25 416-416zM704 576h-384l192-192 192 192z"],"grid":0,"tags":["md-arrow-dropup-circle"]},{"paths":["M256 640l256-256 256 256z"],"grid":0,"tags":["md-arrow-dropup"]},{"paths":["M170 554.75h519.408l-239.404 239.404 61.996 59.846 342-342-342-342-59.844 59.848 237.252 239.402h-519.408v85.5z"],"grid":0,"tags":["md-arrow-forward"]},{"paths":["M802.8 448h-428l166-158.8c23.8-25 23.8-65.4 0-90.4s-62.4-25-86.4 0l-276.4 268c-12 11.6-18 27.4-18 44.8v0.8c0 17.4 6 33.2 18 44.8l276.2 268c24 25 62.6 25 86.4 0s23.8-65.4 0-90.4l-166-158.8h428c33.8 0 61.2-28.6 61.2-64 0.2-36-27.2-64-61-64z"],"grid":0,"tags":["md-arrow-round-back"]},{"paths":["M198.8 569.8l268 276.2c11.6 12 27.4 18 44.8 18h0.8c17.4 0 33.2-6 44.8-18l268-276.2c25-24 25-62.6 0-86.4s-65.4-23.8-90.4 0l-158.8 166v-428c0-33.8-28.6-61.2-64-61.2-36 0-64 27.4-64 61.2v428l-158.8-166c-25-23.8-65.4-23.8-90.4 0s-25 62.4 0 86.4z"],"grid":0,"tags":["md-arrow-round-down"]},{"paths":["M569.8 825.2l276.2-268c12-11.6 18-27.4 18-44.8v-0.8c0-17.4-6-33.2-18-44.8l-276.2-268c-24-25-62.6-25-86.4 0s-23.8 65.4 0 90.4l166 158.8h-428c-34-0-61.4 28.6-61.4 64 0 36 27.4 64 61.2 64h428l-166 158.8c-23.8 25-23.8 65.4 0 90.4 24 25 62.6 25 86.6 0z"],"grid":0,"tags":["md-arrow-round-forward"]},{"paths":["M825.2 454.2l-268-276.2c-11.6-12-27.4-18-44.8-18h-0.8c-17.4 0-33.2 6-44.8 18l-268 276.2c-25 24-25 62.6 0 86.4s65.4 23.8 90.4 0l158.8-166v428c0 33.8 28.6 61.2 64 61.2 36 0 64-27.4 64-61.2v-428l158.8 166c25 23.8 65.4 23.8 90.4 0s25-62.4 0-86.4z"],"grid":0,"tags":["md-arrow-round-up"]},{"paths":["M554.75 854v-519.408l239.404 239.404 59.846-61.996-342-342-342 342 59.848 59.844 239.402-237.252v519.408h85.5z"],"grid":0,"tags":["md-arrow-up"]},{"paths":["M531.2 424.6c-21 0-37 8.8-48 26.4s-18.2 44-21.6 79.2c-1.8 23.4 0 41 5.4 53s14.2 18 26.2 18c11 0 20.6-3 29.2-8.8s16.2-16.6 22.6-32.4l12.2-132c-4.4-1-8.8-1.8-13-2.4-4.6-0.8-8.8-1-13-1z","M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM767.6 499.8c-1.8 42.8-15.2 79.8-40 111.2-24.8 31.2-62 46.8-111.2 46.8-16.4 0-30.6-4.4-42.4-13.2-12-8.8-20.4-21.4-25.2-37.6-8.2 16.6-18.8 29-31.4 37.2s-27.4 12.4-44.4 12.4c-30.2 0-53.2-11.6-69.2-34.6s-21.8-53.6-17.6-91.8c5.2-48.8 20-88 44.4-117.4s54-44 88.8-44c24.4 0 44.2 2.6 59 7.6s31.2 11.4 49 22l-1-0.2h1.6l-15.4 166.8c-1 17 0.2 29.2 3.4 35.6 3.4 6.4 7.8 9.8 13.4 9.8 22.6 0 40.8-10.2 54.4-31.2s21.2-47.2 22.8-79.2c3.2-66-10.2-117.4-40.4-154.2s-76.6-55.4-139.4-55.4c-61 0-109.6 19.8-145.6 59.6s-55.4 93.8-58.6 162.4c-3.4 66.8 11.2 119.6 43.8 158.2 32.6 38.8 79.4 58.2 140.6 58.2 17 0 34.6-1.8 53-5.4 18.2-3.6 34.2-8.2 47.4-13.6l11.6 48.4c-13.6 8.2-30.8 14.6-51.8 19.2s-41.4 6.8-61.4 6.8c-81.6 0-144.6-24.2-188.6-72.8-44-48.4-64.4-114.8-61-199.2 3.6-83.6 29.8-149.8 78.2-198.8 48.6-49 113-73.4 193.4-73.4 79 0 139.6 23.2 181.4 69.4 42.4 46.4 61.6 109.8 58.4 190.4z"],"grid":0,"tags":["md-at"]},{"paths":["M682.668 256v469.332c0 93.876-76.792 170.668-170.668 170.668-93.874 0-170.666-76.792-170.666-170.668v-490.664c0-59.73 46.936-106.668 106.666-106.668 59.728 0 106.666 46.938 106.666 106.668v490.666c0 23.458-19.21 42.666-42.668 42.666s-42.666-19.208-42.666-42.666v-405.334h-64v405.334c0.002 59.728 46.938 106.666 106.668 106.666s106.668-46.938 106.668-106.666v-490.666c0-93.866-76.792-170.668-170.668-170.668s-170.668 76.802-170.668 170.668v490.664c0.002 130.126 104.544 234.668 234.668 234.668s234.668-104.542 234.668-234.668v-469.332h-64z"],"grid":0,"tags":["md-attach"]},{"paths":["M867 192h-532.6c-24.4 0-43.6 12.4-56.4 31.2l-192 288.8 192 288.4c12.8 18.8 32 31.6 56.4 31.6h532.4c39 0 71-32 71-71.2v-497.6c0.2-39.2-31.8-71.2-70.8-71.2zM760.4 639.6l-50 50.2-127.4-127.6-127.4 127.6-50-50.2 127.4-127.6-127.4-127.6 50-50.2 127.4 127.6 127.4-127.6 50 50.2-127.4 127.6 127.4 127.6z"],"grid":0,"tags":["md-backspace"]},{"paths":["M176 256h96v512h-96v-512z","M464 256h96v512h-96v-512z","M320 288h96v448h-96v-448z","M608 288h96v448h-96v-448z","M752 256h96v512h-96v-512z","M208 208v-96h-176v800h176v-96h-80v-608z","M816 112v96h80v608h-80v96h176v-800z"],"grid":0,"tags":["md-barcode"]},{"paths":["M731.8 805.2l-45.8 27-32-56 40.4-23.8c-10.4-17-19.6-34.8-27.8-53.4-2.8-6.2-5.4-12.6-7.8-19l-50.2 11.6-14.2-63.2 45.2-10.4c-5.6-24.2-9.4-48-11-74h-48.6v-64h48.6c1.6-24 5.4-49.6 11-73.6l-45.2-10.4 14.2-63.2 50.2 11.6c2.6-6.4 5.2-12.8 8-19.2 8.2-18.4 17.4-36.2 27.6-53.2l-40.4-23.8 32-56 45.6 27c10.4-12.8 21.6-25 33.4-36.6-70.2-54.4-158-86.6-253-86.6s-182.8 32.2-253 86.4c11.8 11.6 23 24 33.4 36.6l45.6-26.8 32 56-40.4 23.8c10.2 17 19.6 34.8 27.6 53.2 2.8 6.4 5.4 12.8 8 19.2l50.2-11.6 14.2 63.2-45.2 10.4c5.6 24.2 9.2 49.6 11 73.6h48.6v64h-48.6c-1.6 26-5.4 49.8-11 74l45.2 10.4-14.2 63.2-50.2-11.6c-2.4 6.4-5 12.6-7.8 19-8.2 18.4-17.4 36.2-27.8 53.4l40.4 23.8-32 56-45.8-27c-10.4 12.6-21.4 24.8-33.2 36.4 70.2 54.2 158 86.4 253 86.4s182.8-32.2 253-86.4c-11.8-11.6-22.8-23.8-33.2-36.4z","M787.6 252l36.2 21.4-32 56-42.4-25c-10 16.6-19 33.8-26.6 51.8-0.4 0.8-0.8 1.8-1 2.6l42 9.8-14.2 63.2-47.8-11c-4.6 19.4-7.6 39.2-9.2 59.2h47.4v64h-47.2c1.6 20 4.6 40 9.2 59.6l47.8-11 14.2 63.2-42 9.8c0.4 0.8 0.6 1.6 1 2.4 7.6 18 16.6 35.4 26.6 52l42.2-24.8 32 56-36 21.2c6.6 7.8 13.6 15.4 21 22.6 1.2 1.2 2.6 2.6 4 4 71.2-75 115.2-176.2 115.2-287s-44-212-115.4-286.8c-1.4 1.4-2.8 2.6-4 4-7.4 7.4-14.4 15-21 22.8z","M236.4 772.2l-36-21.2 32-56 42.2 24.8c10.2-16.6 19-34 26.6-52 0.4-0.8 0.6-1.6 1-2.4l-42-9.8 14.2-63.2 47.8 11c4.6-19.6 7.6-39.6 9.2-59.6h-47.4v-64h47.2c-1.6-20-4.6-39.8-9.2-59.2l-47.8 11-14.2-63.2 42-9.8c-0.4-0.8-0.6-1.8-1-2.6-7.6-18-16.4-35.4-26.6-51.8l-42.4 25-32-56 36.2-21.4c-6.8-7.8-13.8-15.4-21.2-22.8-1.2-1.2-2.6-2.6-4-4-71 75-115 176.2-115 287s44 212 115.4 286.8c1.4-1.4 2.8-2.6 4-4 7.2-7.2 14.2-14.8 21-22.6z"],"grid":0,"tags":["md-baseball"]},{"paths":["M724.2 410.4l-178.4-265.4c-7.8-11.4-20.8-17-33.8-17s-26 5.6-33.8 17.4l-178.4 265h-195c-22.4 0-40.8 18.2-40.8 40.4 0 3.6 0.4 7.2 1.6 11l103.4 375c9.4 34 40.8 59 78.2 59h529.4c37.4 0 68.8-25 78.6-59l103.4-375 1.2-11c0-22.2-18.4-40.4-40.8-40.4h-194.8zM389.8 410.4l122.2-178 122.2 178h-244.4zM512 734.2c-44.8 0-81.4-36.4-81.4-81s36.6-81 81.4-81 81.4 36.4 81.4 81c0 44.6-36.6 81-81.4 81z"],"grid":0,"tags":["md-basket"]},{"paths":["M383.2 544c-7.6 110-52.8 214.2-129 295.4 63.2 50 141.8 82 225.8 88.6v-384h-96.8z","M544 928c84-6.6 163-38.8 226.2-89-76-81.2-121-185-128.6-295h-97.6v384z","M480 96c-84 6.4-161 38-223.8 87.2 76 81.8 120.6 186.8 127.4 296.8h96.4v-384z","M641.4 480c6.8-110 51.2-214.8 127-296.6-63-49.2-140.4-81-224.4-87.4v384h97.4z","M817.2 228.4c-34.4 37-61.4 79.4-80.2 125.8-16.4 40.4-26.2 81.8-29.2 125.8h220.2c-7.4-96-48.2-184.4-110.8-251.6z","M737 666.2c19.2 47.4 46.6 90.2 81.8 127.6 61.8-67 101.8-153.8 109.2-249.8h-219.8c3.2 42 13 83 28.8 122.2z","M287.8 354.2c-19-46.6-46-89-80.6-126.2-62.8 67.2-103.8 156-111.2 252h221c-3.2-44-13-85.6-29.2-125.8z","M205.4 794.2c35.4-37.6 63-80.6 82.2-128 16-39.2 25.6-80.2 29-122.2h-220.6c7.4 96 47.6 183.2 109.4 250.2z"],"grid":0,"tags":["md-basketball"]},{"paths":["M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6zM467.2 870.4v-246.4h-89.6l179.2-336v246.4h89.6l-179.2 336z"],"grid":0,"tags":["md-battery-charging"]},{"paths":["M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6zM640 864h-256v-614.4h256v614.4z"],"grid":0,"tags":["md-battery-dead"]},{"paths":["M676.4 153.6h-74.8v-89.6h-179.2v89.6h-74.8c-32.8 0-59.6 26.8-59.6 59.6v686.8c0 33.2 26.8 60 59.6 60h328.4c33.2 0 60-26.8 60-59.6v-687.2c0-32.8-26.8-59.6-59.6-59.6z"],"grid":0,"tags":["md-battery-full"]},{"paths":["M896.2 69.8c0-2.4-0.8-5.8-5.8-5.8h-633.4c-108.6 0-128.8 54.8-128.8 79.6 60.6 8.4 63.8 9.4 63.8 73.4 0 32 0 614 0 614 0 70.6 57.8 129 128.6 129h415.4c70.6 0 128-58.4 128-129 0 0 0-7.4 0-20.4v-664c4.4-35 24-63.6 26.2-67 2.4-3.8 6-7.6 6-9.8zM708.4 864h-355.8c-31.8 0-59.4-23.8-64.6-54.2v-649.8h480v639.4c0 36-24.8 64.6-59.6 64.6z","M364 320v452c0 8.8 7.2 16 16 16h296c8.8 0 16-7.2 16-16v-452h-328z"],"grid":0,"tags":["md-beaker"]},{"paths":["M832 280h-32v-12c17.8-18 32-45.8 32-76 0-70.6-57.4-128-128-128-32.6 0-62.2 12.2-84.8 32.2-24.8-20.2-56.4-32.2-90.8-32.2-31.6 0-60.8 10.2-84.6 27.4-19.8-17-45.8-27.4-74-27.4-34.2 0-64.8 15.2-85.6 39-23.4-24-56-39-92.2-39-70.6 0-128 57.4-128 128 0 32.4 12.2 62 32 84.6v109.4c0 53 43 96 96 96v349c0 70.6 57.6 129 128.4 129h351.6c70.6 0 128.2-58.4 128.2-129 0 0 0-7.4 0-20.4v-66.6h32c100 0 128-65.4 128-136v-192c-0.2-70.6-34.2-136-128.2-136zM704 384h-416v-107.4c0.6-0.8 1.4-1.6 2-2.4 2.4-3 4.8-6 7-9.2 3 2.4 6 4.8 9.2 6.8 18.2 12.2 40 19.4 63.4 19.4 12.8 0 25.2-2.2 36.6-6 25.6 40.4 70.6 67.4 122 67.4 44 0 83.4-19.8 109.8-50.8 11.4-13.4 20.4-28.8 26.2-45.8h39.8v128zM192 256.2v150c-18 0-32-14.4-32-32v-126.6c-16-9-26.8-24.2-30.6-42-1-4.2-1.4-8.8-1.4-13.4 0-35.2 28.8-64 64-64 23.6 0 46.6 15.4 60.2 30.8s53.4 15.4 67.8 0c13.6-14.6 28.6-30.8 49.6-30.8 12 0 23.2 4.4 31.8 11.6 3.8 3.2 7.2 7 9.8 11.2 2.2 3.6 4 8.4 6.2 11.6 5.4 6.8 13 11 22.4 11 8.8 0 16.6-3.8 22-10 1.2-1.4 2.4-3 3.4-4.6 4-5 8.4-9.6 13.4-13.6 13.6-10.8 31-17.2 49.6-17.2 21.2 0 40.4 8.2 54.8 21.8 3.4 3.2 13.4 9 26.4 10.2 9 0.8 12.2 0.6 16.4 0 20.6-2.6 28.8-9.4 32.8-13.2 11.6-11.6 27.6-18.8 45.2-18.8 35.2 0 64 28.8 64 64 0.4 6.2-0.6 12.4-2.4 18.2-5-11-16.2-18.4-29.2-18.4h-110c0 0-17.4-1.4-17.4 16.4s-5.8 34.2-15.6 47.4c-14.6 19.8-38.2 32.8-64.8 32.8-29.8 0-55.8-16.2-69.6-40.4-3.2-5.4-5.6-11.2-7.4-17.2-0.2-1.2-0.6-2.2-0.8-3.2-4-11.8-15-20.4-28.2-20.4-7.8 0-15 3-20.4 8 0 0 0 0-0.2 0.2-4.8 4.2-10.6 7.4-16.8 9.4-4.8 1.6-10 2.4-15.4 2.4-15 0-29.4-8-37.6-17.2-20-22.8-47.4-13.6-59.4-11s-24.4 23.4-24.4 23.4c-2.2 4.2-4.8 8-7.8 11.6-12 13.4-30.4 22-48.4 22zM864 608c0 35.4-12.6 48-48 48h-16v-288h16c35.4 0 48 12.6 48 48v192z"],"grid":0,"tags":["md-beer"]},{"paths":["M661.332 262.404c37.336 0 67.196-29.87 67.196-67.202s-29.86-67.202-67.196-67.202c-37.332 0-67.192 29.87-67.192 67.202s29.86 67.202 67.192 67.202zM773.332 522.668c-102.664 0-186.664 84-186.664 186.666s84 186.666 186.664 186.666c102.668 0 186.668-84 186.668-186.666s-84-186.666-186.668-186.666zM773.332 840c-72.804 0-130.664-57.86-130.664-130.666s57.86-130.666 130.664-130.666c72.808 0 130.668 57.86 130.668 130.666s-57.86 130.666-130.668 130.666zM611.194 448h156.806v-64h-117.69l-69.24-120.268c-11.21-18.666-31.738-31.728-54.14-31.728-16.798 0-33.596 7.464-44.798 18.666l-143.464 138.13c-11.202 11.202-18.666 28-18.666 44.798 0 24.262 18.404 42.93 37.070 54.13l122.928 76.54v171.732h64v-224l-78.666-64 85.858-89.066 60.002 89.066zM250.666 522.668c-102.666 0-186.666 84-186.666 186.666s84 186.666 186.666 186.666c102.666 0 186.666-84 186.666-186.666s-83.998-186.666-186.666-186.666zM250.666 840c-72.798 0-130.666-57.86-130.666-130.666s57.868-130.666 130.666-130.666c72.798 0 130.666 57.86 130.666 130.666s-57.868 130.666-130.666 130.666z"],"grid":0,"tags":["md-bicycle"]},{"paths":["M798 319.8l-257-255.8h-45v340l-206.6-205.6-63.4 63.2 251.6 250.4-251.6 250.4 63.4 63.2 206.6-205.6v340h45l257-255.8-193.6-192.2c0 0 193.6-192.2 193.6-192.2zM586 235.6l84.6 84.2-84.6 84.2v-168.4zM670.6 704.2l-84.6 84.2v-168.4c0 0 84.6 84.2 84.6 84.2z"],"grid":0,"tags":["md-bluetooth"]},{"paths":["M168.51 826h2.126c68.246 0 127.954-38.042 170.61-84.988 42.65 46.946 102.36 85.524 170.608 85.524s127.958-38.668 170.61-85.612c42.654 46.944 102.36 85.076 170.606 85.076h2.124l102.506-277.56c4.252-10.658 2.126-23.282-2.14-33.952-4.272-10.666-14.474-16.974-25.134-21.246l-76.426-24.976v-196.3c0-46.946-39.312-85.966-86.232-85.966h-127.958l-31.986-106h-191.938l-31.99 106h-127.958c-46.916 0-85.938 39.020-85.938 85.964v196.3l-76.148 25.066c-10.66 4.272-21.164 10.668-25.436 21.334-4.27 10.67-6.316 20.98-2.062 33.774l102.156 277.562zM256 272h512v168.522l-256-83.21-256 83.21v-168.522z","M682.462 816.014c-104.506 72.534-236.712 72.516-341.216-0.018 0 0-115.276 128.004-213.264 128.004h42.654c59.708 0 117.292-23.452 170.61-51.188 106.63 55.468 234.586 55.456 341.216-0.014 53.318 27.738 110.9 51.202 170.608 51.202h42.656c-95.302 0-213.264-127.986-213.264-127.986z"],"grid":0,"tags":["md-boat"]},{"paths":["M512 96c44 0 80 36 80 80s-36 80-80 80-80-36-80-80 36-80 80-80zM896 384.2h-256v543.8h-85.4v-288h-85.4v288h-85.2v-543.8h-256v-85.4h768v85.4z"],"grid":0,"tags":["md-body"]},{"paths":["M544.4 701.2c-1.6-16.4-16.4-29.2-34.6-29.2-16.6 0-30.4 10.8-33.8 25v0l-33.8 185c-1 4.6-1.6 9.2-1.6 14 0 35.4 31 64 69.4 64s69.4-28.6 69.4-64c0-5.8-0.8-11.4-2.4-16.8l-32.6-178z","M620.2 710v0 0z","M808.6 780.6c-3.8-2.8-7.2-5.8-11.2-7.8l-137.8-95c-12.6-7.6-26-7.4-35.8 1.8-9 8.2-10.2 20.8-3.6 30.8l106 131.6c2 3 4.6 5.6 7.2 8.4 17 18.2 54.4 19.2 75 0 20.8-19.6 20.6-54.4 0.2-69.8z","M764.4 670v0 0z","M900.8 645l-129-4.6c-8.4-1.2-16 4.2-17.4 12-1.4 7.2 3 14.2 10.2 17.6v0c0 0 0.2 0 0.2 0l125 35.6c18 3.8 38.2-4.6 38.2-23.2-0-23.8-6.6-35-27.2-37.4z","M259 670v0 0z","M259 670v0c7.2-3.2 11.4-10.4 10.2-17.6-1.4-8-9-13.2-17.4-12l-129 4.6c-20.8 2.4-26.8 13.6-26.8 37.2 0 18.6 19.8 27.2 37.6 23.2l125-35.6c0.2 0.2 0.2 0.2 0.4 0.2z","M364.4 677.6l-137.8 94.8c-4 2.2-7.8 4.8-11.2 7.8-20.8 19.2-20.8 50.2 0 69.2 20.8 19.2 54.2 19.2 75 0 2.8-2.6 5.2-5.4 7.2-8.4l106-131.2c6.6-10 5.4-22.4-3.6-30.6-9.6-9-25.2-9.6-35.6-1.6z","M512 64c0 0 60.4 70.8 60.4 128.8 0 55.6-36.4 100.6-91.8 100.6-55.8 0-97.8-45-97.8-100.6l0.8-13.8c-54.4 64.6-87 152.4-87 243.6 0 119.2 96.4 215.6 215.6 215.6s215.6-96.4 215.6-215.6c-0.2-145.2-71.8-315.2-215.8-358.6zM504.2 557.4c-48 0-86.8-37.8-86.8-84.6 0-43.6 28.2-74.4 75.8-84 47.6-9.8 97-32.6 124.6-69.6 10.6 34.8 15.8 71.4 15.8 108.8 0 71.4-58 129.4-129.4 129.4z"],"grid":0,"tags":["md-bonfire"]},{"paths":["M852.4 160.8l-340.4 64-340.4-64c-43.6-6.8-75.6 33.8-75.6 75.2v489c0 41.4 32 65.2 75.6 75.2l340.4 63.8 340.4-64c43.6-10 75.6-33.8 75.6-75.2v-488.8c0-41.4-32-82-75.6-75.2zM852.4 724.8l-302.4 64v-489l302.4-64v489zM474 788.8l-302.4-64v-488.8l302.4 64v488.8z"],"grid":0,"tags":["md-book"]},{"paths":["M720 128h-416c-44.004 0-80 35.996-80 80v688l288-128 288 128v-688c0-44.004-35.996-80-80-80z"],"grid":0,"tags":["md-bookmark"]},{"paths":["M810.4 128h-42c30 11.4 45.6 41.2 45.6 85.4v597.4c0 44.2-14 74.6-45.6 85.4h42c47.4 0 85.6-38.4 85.6-85.4v-597.4c0-47-38.2-85.4-85.6-85.4z","M691 128.4c-2.8-0.2-5.6-0.4-8.4-0.4h-469.2c-47 0-85.4 38.4-85.4 85.4v597.4c0 47 38.4 85.4 85.4 85.4h469.4c2.8 0 5.6-0.2 8.4-0.4 43-4.2 77-40.8 77-85v-597.4c-0.2-44.2-34.2-80.8-77.2-85zM416 512l-112-64-112 64v-320h224v320z"],"grid":0,"tags":["md-bookmarks"]},{"paths":["M552 608h-80c-30.8 0-56-25.2-56-56v-80c0-30.8 25.2-56 56-56h80c30.8 0 56 25.2 56 56v80c0 30.8-25.2 56-56 56z","M352 560v-96c0-36.4 17.4-68.8 44.4-89.2-12.4-54.8-204.4-182.8-268.4-182.8-35.2 0-64 28.8-64 64v512c0 35.2 28.6 64 64 64 64 0 256-128 268.4-182.8-27-20.4-44.4-52.8-44.4-89.2z","M896 192c-64 0-256 128-268.4 182.8 27 20.4 44.4 52.8 44.4 89.2v96c0 36.4-17.4 68.8-44.4 89.2 12.4 54.8 204.4 182.8 268.4 182.8 35.4 0 64-28.8 64-64v-512c0-35.2-28.8-64-64-64z"],"grid":0,"tags":["md-bowtie"]},{"paths":["M704 288v-79.2c0-44.8-36-80.8-80.8-80.8h-222.4c-44.8 0-80.8 36-80.8 80.8v79.2h-224v527.2c0 44.8 36 80.8 80.8 80.8h670.4c44.8 0 80.8-36 80.8-80.8v-527.2h-224zM624 288h-224v-80h224v80z"],"grid":0,"tags":["md-briefcase"]},{"paths":["M848 128h-672c-53.2 0-96 43.2-96 96v576c0 52.8 42.8 96 96 96h672c52.8 0 96-43.2 96-96v-576c0-52.8-42.8-96-96-96zM848 800h-672v-448h672v448z"],"grid":0,"tags":["md-browsers"]},{"paths":["M299.8 604.4c-78.2 0-141.4 62-141.4 138.6 0 60.6-54.6 92.4-94.4 92.4 43.4 56.6 117.4 92.6 188.6 92.6 104.2 0 188.6-82.8 188.6-184.8 0-76.8-63.2-138.8-141.4-138.8zM946.2 171.4l-63.2-62c-18.4-18-48-18-66.4 0l-422.6 414.2 129.6 127 422.4-414c18.6-18 18.6-47.2 0.2-65.2z"],"grid":0,"tags":["md-brush"]},{"paths":["M896 320h-134.8c-21.6-37.4-51.4-69.6-87.4-94l78.2-78.4-67.6-67.6-104.2 104.2c-22.2-5.4-44.6-8.2-68.2-8.2s-46 2.8-67.6 8.2l-104.8-104.2-67.6 67.6 77.8 78.2c-35.6 24.4-65.2 56.6-86.8 94h-135v96h100.4c-2.4 15.8-4.4 31.6-4.4 48v48h-96v96h96v48c0 16.4 2 32.2 4.4 48h-100.4v96h134.8c50 86 142.6 144 249.2 144s199.2-58 249.2-144h134.8v-96h-100.4c2.4-15.8 4.4-31.6 4.4-48v-48h96v-96h-96v-48c0-16.4-2-32.2-4.4-48h100.4v-95.8z"],"grid":0,"tags":["md-bug"]},{"paths":["M948.2 796.4l-370-372.4c36.6-94 16.2-204.6-61-282.2-81.4-81.8-203.4-98.2-301-53.2l174.8 176-122 122.8-179-176c-48.6 98-28.2 220.8 53 302.6 77.2 77.8 187 98.2 280.6 61.4l370 372.4c16.2 16.4 40.6 16.4 57 0l93.6-94c20.4-16.6 20.4-45.2 4-57.4z"],"grid":0,"tags":["md-build"]},{"paths":["M512 340.272c50.998 0 99.134 20.050 135.542 56.458 36.408 36.406 56.458 84.544 56.458 135.542 0 35.242-8.844 68.062-26.288 97.546-16.678 28.196-40.874 52.072-69.97 69.052l-31.742 18.524v178.606h-128v-178.606l-31.742-18.524c-59.374-34.648-96.258-98.486-96.258-166.598 0-50.998 20.050-99.134 56.458-135.542s84.544-56.458 135.542-56.458zM554.666 64c-12.792 0-85.332 0-85.332 0v128h85.332v-128zM812.792 171.728l-76.792 76.814 59.728 59.73 76.812-76.792-59.748-59.752zM211.208 171.728l-59.75 59.75 76.812 76.792 59.73-59.728-76.792-76.814zM512 276.272c-140.792 0-256 115.208-256 256 0 93.876 51.208 177.062 128 221.876v205.852h256v-205.854c76.792-44.812 128-125.876 128-221.876 0-140.792-115.208-255.998-256-255.998v0zM960 489.604h-128v85.334h128v-85.334zM192 489.604h-128v85.334h128v-85.334z"],"grid":0,"tags":["md-bulb"]},{"paths":["M160 704c0 38.396 27.728 49.062 53.334 72.542v76.792c0 23.458 19.198 42.668 42.666 42.668h42.666c23.468 0 42.668-19.208 42.668-42.668v-42.666h341.332v42.666c0 23.458 19.208 42.668 42.668 42.668h42.666c23.458 0 42.666-19.208 42.666-42.668v-76.792c25.606-23.48 53.334-36.27 53.334-72.542v-407.332c0-149.334-164.272-168.668-352-168.668s-352 19.334-352 168.668v407.332zM320 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM704 735.978c-36.272 0-64-27.728-64-64 0-36.27 27.728-64 64-64s64 27.73 64 64c0 36.272-27.728 64-64 64zM768 490.666h-512v-213.332h512v213.332z"],"grid":0,"tags":["md-bus"]},{"paths":["M96 800h736v96h-736v-96z","M848 128h-688v448c0 88 72 160 160 160h288c88 0 160-72 160-160v-128h80c44 0 80-36 80-80v-160c0-44-36-80-80-80zM848 352h-80v-128h80v128z"],"grid":0,"tags":["md-cafe"]},{"paths":["M736 96h-448c-53.2 0-96 43.2-96 96v640c0 52.8 42.8 96 96 96h448c52.8 0 96-43.2 96-96v-640c0-52.8-42.8-96-96-96zM400 832h-96v-96h96v96zM400 656h-96v-96h96v96zM400 480h-96v-96h96v96zM560 832h-96v-96h96v96zM560 656h-96v-96h96v96zM560 480h-96v-96h96v96zM720 832h-96v-272h96v272zM720 480h-96v-96h96v96zM720 288h-416v-96h416v96z"],"grid":0,"tags":["md-calculator"]},{"paths":["M736.010 544h-192v192h192v-192zM672.010 128v64h-320v-64h-96v64h-48.020c-44.004 0-80 35.996-80 80v544c0 44.004 35.996 80 80 80h608.020c44.004 0 80-35.996 80-80v-544c0-44.004-35.996-80-80-80h-48v-64h-96zM816.010 816h-608.020v-424h608.020v424z"],"grid":0,"tags":["md-calendar"]},{"paths":["M853.332 661.334c-53.332 0-104.542-8.542-151.458-23.458-14.938-4.272-32-2.146-42.664 10.666l-93.878 93.856c-121.604-61.856-219.728-160-281.604-281.606l93.878-93.854c10.664-10.666 14.924-27.728 10.664-42.666-17.074-49.062-25.604-100.272-25.604-153.606 0-23.458-19.198-42.666-42.666-42.666h-149.334c-23.468 0-42.666 19.208-42.666 42.666 0 401.062 324.272 725.334 725.332 725.334 23.46 0 42.668-19.208 42.668-42.666v-149.334c0-23.458-19.208-42.666-42.668-42.666z"],"grid":0,"tags":["md-call"]},{"paths":["M638 560c0 69.588-56.412 126-126 126s-126-56.412-126-126c0-69.588 56.412-126 126-126s126 56.412 126 126z","M880 192h-176l-64-64h-256l-64 64h-176c-44.184 0-80 35.816-80 80v544c0 44.184 35.816 80 80 80h736c44.184 0 80-35.816 80-80v-544c0-44.184-35.816-80-80-80zM512 784c-123.71 0-224-100.29-224-224s100.29-224 224-224 224 100.29 224 224-100.29 224-224 224z"],"grid":0,"tags":["md-camera"]},{"paths":["M806.416 234.666c-8.542-25.604-32-42.666-59.75-42.666h-469.332c-27.75 0-51.208 17.062-59.75 42.666l-89.584 234.668v320c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-21.334h512v21.334c0 23.458 19.208 42.666 42.666 42.666h42.668c23.458 0 42.666-19.208 42.666-42.666v-320l-89.584-234.668zM277.334 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM746.666 640c-36.25 0-64-27.73-64-64s27.75-64 64-64 64 27.732 64 64-27.75 64-64 64zM213.334 426.666l64-170.666h469.332l64 170.666h-597.332z"],"grid":0,"tags":["md-car"]},{"paths":["M870.4 160h-716.8c-49.8 0-89.2 39.2-89.2 88l-0.4 528c0 48.8 39.8 88 89.6 88h716.8c49.8 0 89.6-39.2 89.6-88v-528c0-48.8-39.8-88-89.6-88zM870.4 776h-716.8v-264h716.8v264zM870.4 336h-716.8v-88h716.8v88z"],"grid":0,"tags":["md-card"]},{"paths":["M339.2 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.436 83.202-83.2c-0.002-45.768-37.44-83.202-83.202-83.202zM96 102.4v83.2h83.2l149.766 303.364-62.616 101.908c-6.236 10.4-10.4 24.964-10.4 39.53 0 55.7 38.050 83.2 89.65 83.2h486.4v-80h-476.214c-6.236 0-10.4-4.164-10.4-10.4 0-2.072 4.414-10.4 4.414-10.4l41.564-65.6h309.908c31.202 0 58.256-16.634 72.8-43.672l149.764-257.6c2.474-4.922 4.164-12.492 4.164-20.798 0-22.892-18.728-39.53-41.6-39.53h-615.672l-39.528-83.202h-135.2zM748.798 755.2c-45.764 0-83.2 37.436-83.2 83.202 0 45.764 37.436 83.2 83.2 83.2s83.202-37.438 83.202-83.202c0-45.766-37.438-83.2-83.202-83.2z"],"grid":0,"tags":["md-cart"]},{"paths":["M64 192v512h896v-512h-896zM385 640h-160.8c0-53.2-43-96.2-96.2-96.2v-159.8c70.6 0 128-57.4 128-128h129c-39.8 47-65 115.6-65 192s25.2 145 65 192zM896 543.8c-52 0-96 43-96 96.2h-161c39.8-47 65-115.6 65-192s-25.2-145-65-192h129c0 70.6 57.4 128 128 128v159.8z","M64 768h896v64h-896v-64z"],"grid":0,"tags":["md-cash"]},{"paths":["M783.106 128h-667.892c-8.952 0-19.214 7.49-19.214 16.318v428.434c0 8.826 10.262 17.248 19.214 17.248h114.786v177.788l180.256-177.788h372.85c8.954 0 14.894-8.422 14.894-17.248v-428.434c0-8.828-5.942-16.318-14.894-16.318z","M912.792 254h-64.792v333.14c0 31.974-13.83 52.86-50.304 52.86h-361.504l-77.81 78h259.376l180.242 178v-178h114.792c8.956 0 15.208-8.524 15.208-17.364v-428.43c0-8.828-6.252-18.206-15.208-18.206z"],"grid":0,"tags":["md-chatboxes"]},{"paths":["M265.6 736c-40.4 0-89.6-49.2-89.6-89.6v-326.4h-19.2c-33.4 0-60.8 27.4-60.8 60.8v547.2l117-116h430.2c33.4 0 60.8-28.2 60.8-61.8v-14.2h-438.4z","M858.2 96h-558.4c-38.4 0-69.8 31.4-69.8 69.8v452.2c0 38.4 31.4 70 69.8 70h476.4l151.8 106v-628.2c0-38.4-31.4-69.8-69.8-69.8z"],"grid":0,"tags":["md-chatbubbles"]},{"paths":["M337.062 430.938l-59.728 59.728 192 192 426.666-426.666-59.728-59.728-366.938 364.79-132.272-130.124zM810.666 810.666h-597.332v-597.332h426.666v-85.334h-426.666c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-341.332h-85.334v341.332z"],"grid":0,"tags":["md-checkbox-outline"]},{"paths":["M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334zM426.666 725.334l-213.332-213.334 59.728-59.728 153.604 153.604 324.272-324.272 59.728 59.73-384 384z"],"grid":0,"tags":["md-checkbox"]},{"paths":["M341.436 432.964l-58.236 58.236 187.2 187.2 416-416-58.236-58.236-357.764 355.672-128.964-126.872zM844.8 512c0 183.036-149.766 332.8-332.8 332.8s-332.8-149.764-332.8-332.8 149.764-332.8 332.8-332.8c31.2 0 62.4 4.164 91.528 12.482l64.472-64.482c-47.836-20.8-99.836-31.2-156-31.2-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416h-83.2z"],"grid":0,"tags":["md-checkmark-circle-outline"]},{"paths":["M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM426.6 733.8l-213.2-213.2 59.8-59.8 153.6 153.6 324.2-324.2 59.8 59.8-384.2 383.8z"],"grid":0,"tags":["md-checkmark-circle"]},{"paths":["M372.602 679.786l-180.602-180.864-64 61.014 244.602 244.064 523.398-522.988-64-61.012z"],"grid":0,"tags":["md-checkmark"]},{"paths":["M810.666 160h-174.7c-14.208-55.208-64.324-96-123.966-96s-109.758 40.792-123.966 96h-174.7c-46.938 0-85.334 38.396-85.334 85.334v629.33c0 46.938 38.396 85.336 85.334 85.336h597.332c46.938 0 85.334-38.398 85.334-85.336v-629.33c0-46.938-38.396-85.334-85.334-85.334zM512 160c23.458 0 42.666 19.198 42.666 42.666s-19.208 42.668-42.666 42.668-42.666-19.2-42.666-42.668 19.208-42.666 42.666-42.666zM816 880h-608v-640h80v144h448v-144h80v640z"],"grid":0,"tags":["md-clipboard"]},{"paths":["M806.2 217.8c-162.4-162.4-425.8-162.4-588.4 0s-162.4 425.8 0 588.4c162.4 162.4 425.8 162.4 588.4 0 162.4-162.4 162.4-426 0-588.4zM773.2 324.2c15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8zM160 512c0-17.6 14.4-32 32-32s32 14.4 32 32-14.4 32-32 32-32-14.4-32-32zM250.8 699.8c-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8 15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8zM262.6 368c-8.8 15.2-28.4 20.6-43.8 11.8-15.2-8.8-20.6-28.4-11.8-43.8 8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM336 207.2c15.2-8.8 35-3.6 43.8 11.8 8.8 15.2 3.6 35-11.8 43.8s-35 3.6-43.8-11.8c-8.8-15.4-3.4-35 11.8-43.8zM320.4 428.6l31.2-53.2 190.4 113.8v278.8h-62v-246.8l-159.6-92.6zM379.8 805.2c-8.8 15.2-28.4 20.6-43.8 11.8s-20.6-28.4-11.8-43.8c8.8-15.2 28.4-20.6 43.8-11.8 15.2 8.8 20.6 28.4 11.8 43.8zM512 864c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zM512 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32c0 17.6-14.4 32-32 32zM688 816.8c-15.2 8.8-35 3.6-43.8-11.8-8.8-15.2-3.6-35 11.8-43.8 15.2-8.8 35-3.6 43.8 11.8s3.4 35-11.8 43.8zM699.8 250.8c-8.8 15.2-28.4 20.6-43.8 11.8s-20.6-28.4-11.8-43.8c8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM816.8 688c-8.8 15.2-28.4 20.6-43.8 11.8-15.2-8.8-20.6-28.4-11.8-43.8 8.8-15.2 28.4-20.6 43.8-11.8s20.6 28.6 11.8 43.8zM832 544c-17.6 0-32-14.4-32-32s14.4-32 32-32c17.6 0 32 14.4 32 32s-14.4 32-32 32z"],"grid":0,"tags":["md-clock"]},{"paths":["M512 96c-230.882 0-416 185.118-416 416 0 230.872 185.118 416 416 416 230.87 0 416-185.128 416-416 0-230.882-185.128-416-416-416zM720.004 661.762l-58.24 58.234-149.764-149.762-149.762 149.762-58.242-58.234 149.766-149.762-149.766-149.762 58.242-58.232 149.762 149.756 149.762-149.756 58.24 58.232-149.764 149.762 149.766 149.762z"],"grid":0,"tags":["md-close-circle"]},{"paths":["M810 273.596l-59.596-59.596-238.404 238.404-238.404-238.404-59.596 59.596 238.404 238.404-238.404 238.404 59.596 59.596 238.404-238.404 238.404 238.404 59.596-59.596-238.404-238.404z"],"grid":0,"tags":["md-close"]},{"paths":["M64 192v640h896v-640h-896zM876 511.6c0 46.8-2.8 82.4-6.6 140.4s-33.6 98.8-103.4 105.2c-69.8 6.4-167.6 7-254 6.8-85.8 0.2-184-0.2-254-6.8-69.8-6.4-99.4-47.2-103.4-105.2s-6.6-93.6-6.6-140.4c0-46.8 0.2-77.2 6.6-140.4s40.2-98.4 103.4-104.8 172-6.4 254-6.4 190.8 0 254 6.4c63.2 6.4 97 41.8 103.4 104.8 6.4 63.2 6.6 93.8 6.6 140.4z","M715 560.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-22-24.8-55-37.2-98.6-37.2-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0.4 0 0.4 5 0.4 6.8z","M405.2 560.8v1.4c0 32.6-20.2 51.8-47.2 51.8s-45.2-21.6-47.8-51.8c0 0-2.4-15.8-2.4-47.8s2.8-52 2.8-52c4.8-34 21.4-51.8 48.4-51.8 26.8 0 48.2 23.2 48.2 58.4 0 0.2 0 1 0 1h90.2c0-43.8-11-83.2-33.2-108-22-24.8-55-37.2-98.6-37.2-21.8 0-41.8 2.8-60 8.6s-34 15.8-47.2 30.2c-13.2 14.4-23.4 33.6-30.8 57.8-7.2 24.2-11 54.6-11 91.4 0 36 3 66 8.8 90.2 6 24.2 14.6 43.4 26.2 57.8s26.2 24.4 43.6 30c17.6 5.6 38.2 8.4 61.8 8.4 50 0 86-12.8 107.6-37.4s32.4-60.6 32.4-107.8h-92.2c0.4 0 0.4 5 0.4 6.8z"],"grid":0,"tags":["md-closed-captioning"]},{"paths":["M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416c228.8 0 416-187.2 416-416s-187.2-416-416-416zM699.2 678.4c0 0-351.518 0-353.598 0-68.636 0-124.8-56.164-124.8-124.798 0-68.638 56.164-124.8 124.8-124.8 2.082 0 4.164 0 6.234 0 18.728-72.8 83.202-124.798 160.166-124.798 91.528 0 166.398 74.87 166.398 166.396h20.8c58.236 0 104 45.764 104 104.002 0 58.234-45.764 103.998-104 103.998z"],"grid":0,"tags":["md-cloud-circle"]},{"paths":["M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM426.666 725.334l-149.332-149.334 59.728-59.728 89.604 89.604 221.876-221.876 59.73 59.728-281.606 281.606z"],"grid":0,"tags":["md-cloud-done"]},{"paths":["M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM448 536v-152h128v152h136l-200 200-200-200h136z"],"grid":0,"tags":["md-cloud-download"]},{"paths":["M806.002 434.002c-28.008-137.998-148.006-242.002-294.002-242.002-115.996 0-215.998 65.996-265.994 162-120.002 12.004-214.006 113.996-214.006 238 0 131.992 108.008 240 240 240h520c110 0 200-90 200-200.002 0-105.994-81.994-191.998-185.998-197.996zM792 752h-520c-88.008 0-160-71.992-160-160 0-88 71.992-160 160-160h28.008c25.996-92 110-160 211.992-160 121.992 0 220 98 220 220v20h60c65.996 0 120 54.006 120 120 0 65.996-54.004 120-120 120z"],"grid":0,"tags":["md-cloud-outline"]},{"paths":["M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998zM576 552v152h-128v-152h-136l200-200 200 200h-136z"],"grid":0,"tags":["md-cloud-upload"]},{"paths":["M806.004 434.002c-28.008-137.998-148.008-242.002-294.004-242.002-115.996 0-215.996 65.996-265.996 162.002-120 12.002-214.004 113.994-214.004 237.998 0 131.992 107.998 240 240 240h520c110 0 200-90 200-200 0-105.996-81.992-192.002-185.996-197.998z"],"grid":0,"tags":["md-cloud"]},{"paths":["M246.8 366c0.8-0.2 1.6-0.2 2.4-0.4-1 0.2-1.6 0.4-2.4 0.4z","M683 606.8c-21.6-111.4-118.6-194.8-235-194.8-68 0-130.2 24-173 78.2 58.8 4.4 113.4 26.2 155.4 68.4 31.2 31.4 53.2 69.8 64.2 111.6h-57.4c-26.2-75.2-96-129-181.2-129-10.2 0-24.6 1.2-35.4 3.4-91.4 18.8-156.6 95.2-156.6 190 0 106.8 86 193.6 192 193.6h416c88.2 0 160-72.2 160-161.2-0.2-85.4-65.8-154.4-149-160.2z","M225 450.8c27.2-34.6 61.4-61 101.6-78.4 36.8-16 77.6-24 121.4-24 12.2 0 24.4 0.8 36.4 2.2-12.2-36.2-18.8-75.2-18.8-115.6 0-49.2 9.8-96.2 27.6-138.8-169.4 41.2-295.2 195.2-295.2 378.4 0 3.2 0 6.4 0.2 9.6 0.2 0 0.4-0.2 0.6-0.2l26.2-33.2z","M835.2 613.6c26.6 28.4 45.2 63 54.2 100.2 33-42.8 57.4-92.8 70.6-147-42.4 18-89 27.8-137.8 27.8-2.4 0-4.8 0-7.2 0 7 5.8 13.8 12.2 20.2 19z"],"grid":0,"tags":["md-cloudy-night"]},{"paths":["M246.8 366c0.8-0.2 1.6-0.2 2.4-0.4-1 0.2-1.6 0.4-2.4 0.4z","M786.4 438.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 100.4 225 224 225h485.4c103 0 186.6-84 186.6-187.6 0-98.8-76.6-179.2-173.6-186z"],"grid":0,"tags":["md-cloudy"]},{"paths":["M469.2 320v251.4l-89.4-87.2-59.8 59.8 192 192 192-192-59.8-62-89.4 89.4v-251.4h-85.6z","M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z"],"grid":0,"tags":["md-code-download"]},{"paths":["M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z","M311.2 552h80v-80h-80v80zM712.8 472h-80v80h80v-80zM472 552h80v-80h-80v80z"],"grid":0,"tags":["md-code-working"]},{"paths":["M380.8 708.2l-197-196.2 196.8-196.2-60-59.8-256.6 256 256.8 256 60-59.8zM643.2 708.2l196.8-196.2-196.8-196.2 60-59.8 256.8 256-256.8 256c0 0-60-59.8-60-59.8z"],"grid":0,"tags":["md-code"]},{"paths":["M960 576v-128h-69.4c-4-24.2-10.4-47.6-18.6-70l60-34.6-64-110.8-60 34.6c-15.4-18.6-32.6-35.8-51.2-51.2l34.6-60-110.8-64-34.6 60c-22.4-8.4-45.8-14.6-70-18.6v-69.4h-128v69.4c-24.2 4-47.6 10.4-70 18.6l-34.6-60-110.8 64 34.6 60c-18.6 15.4-35.8 32.6-51.2 51.2l-60-34.6-64 110.8 60 34.6c-8.4 22.4-14.6 45.8-18.6 70h-69.4v128h69.4c4 24.2 10.4 47.6 18.6 70l-60 34.6 64 110.8 60-34.6c15.4 18.6 32.6 35.8 51.2 51.2l-34.6 60 110.8 64 34.6-60c22.4 8.4 45.8 14.6 70 18.6v69.4h128v-69.4c24.2-4 47.6-10.4 70-18.6l34.6 60 110.8-64-34.6-60c18.6-15.4 35.8-32.6 51.2-51.2l60 34.6 64-110.8-60-34.6c8.4-22.4 14.6-45.8 18.6-70h69.4zM754 355.8l-93.8 34.2c-22-26.6-51-47.2-84.2-59v-99.8c74.4 16.8 137.8 62.4 178 124.6zM448 231.2v99.8c-33.2 11.8-62.2 32.4-84.2 59l-93.8-34.2c40.2-62.2 103.6-107.8 178-124.6zM224 512c0-12.2 0.8-24.2 2.2-36l93.8 34.2c0 0.6 0 1.2 0 1.8 0 35.6 9.8 69 26.6 97.6l-64.2 76.4c-36.6-48.4-58.4-108.6-58.4-174zM512 800c-47.4 0-92-11.4-131.6-31.8l64.2-76.4c21 7.8 43.6 12.2 67.4 12.2s46.4-4.4 67.4-12.2l64.2 76.4c-39.6 20.4-84.2 31.8-131.6 31.8zM741.6 686l-64.2-76.4c16.8-28.6 26.6-62 26.6-97.6 0-0.6 0-1.2 0-1.8l93.8-34.2c1.4 11.8 2.2 23.8 2.2 36 0 65.4-21.8 125.6-58.4 174z"],"grid":0,"tags":["md-cog"]},{"paths":["M273 155.4l74 134-283 282 368.8 356.6 304.8-297.2 108.8-22.8-513.6-512-59.8 59.4zM641 571.4h-411.2l205.6-204.6 205.6 204.6z","M846.6 608c0 0-113.4 123-113.4 184.2 0 61.4 50.8 111 113.4 111s113.4-49.8 113.4-111c0-61.2-113.4-184.2-113.4-184.2z"],"grid":0,"tags":["md-color-fill"]},{"paths":["M883.6 240.2l-99.8-99.8c-16.6-16.6-43.6-16.6-60.2 0l-133.2 133.2-82.2-81.6-60.2 60.2 60.6 60.6-380.6 380.6v202.6h202.6l380.6-380.6 60.6 60.6 60.2-60.2-82-82 133.2-133.2c17-16.8 17-43.6 0.4-60.4zM295.2 810.8l-82-82 343.8-343.8 82 82-343.8 343.8z"],"grid":0,"tags":["md-color-filter"]},{"paths":["M512 128c-211.198 0-384 172.802-384 384 0 211.208 172.802 384 384 384 36.272 0 64-27.728 64-64 0-17.062-6.396-32-17.062-42.666-10.666-10.668-17.062-25.606-17.062-42.668 0-36.27 27.728-64 64-64h76.792c117.334 0 213.334-96 213.334-213.332-0.002-187.73-172.794-341.334-384.002-341.334zM277.334 512c-36.272 0-64-27.728-64-64s27.728-64 64-64c36.27 0 64 27.728 64 64s-27.73 64-64 64zM405.334 341.334c-36.272 0-64-27.73-64-64 0-36.272 27.728-64 64-64 36.27 0 64 27.728 64 64 0 36.27-27.73 64-64 64zM618.666 341.334c-36.27 0-64-27.73-64-64 0-36.272 27.73-64 64-64 36.272 0 64 27.728 64 64 0 36.27-27.728 64-64 64zM746.666 512c-36.27 0-64-27.728-64-64s27.73-64 64-64c36.272 0 64 27.728 64 64s-27.728 64-64 64z"],"grid":0,"tags":["md-color-palette"]},{"paths":["M401.6 314.4l-72.8 74.8 494.6 506.8 72.6-74.8z","M362 128h74v136h-74v-136z","M362 524h74v136h-74v-136z","M540 352h138v74h-138v-74z","M611.2 231.6l-51.4-52.6-94.2 96.6 51.2 52.4z","M337.6 275.6l-94.2-96.6-51.2 52.6 94.2 96.4z","M192.2 555.8l51.2 52.4 94.2-96.4-51.2-52.6z","M128 352h130v74h-130v-74z"],"grid":0,"tags":["md-color-wand"]},{"paths":["M512 462.716c-26.884 0-49.286 22.4-49.286 49.284s22.4 49.286 49.286 49.286 49.286-22.4 49.286-49.286-22.402-49.284-49.286-49.284zM512 64c-246.4 0-448 201.6-448 448s201.6 448 448 448 448-201.6 448-448-201.6-448-448-448zM610.568 610.568l-367.368 170.232 170.232-367.358 367.368-170.242-170.232 367.368z"],"grid":0,"tags":["md-compass"]},{"paths":["M861.8 786.8l-382.2-380.4c31.8-81.2 14.2-176.4-53.2-243.4-70.8-70.6-177-84.6-262-45.8l152.2 151.6-106.2 105.8-155.8-151.6c-42.2 84.6-24.6 190.4 46.2 261 67.2 67 162.8 84.6 244.2 53l28.8 28.6-210.4 210.4c-15.2 11.4-15.2 38 3.8 53.2l87.6 87.4c15.2 15.2 38.2 15.2 53.4 0l192.2-224.8 226.8 225.8c14.2 14.2 35.4 14.2 49.6 0l81.4-81.2c17.8-14.2 17.8-39 3.6-49.6z","M988.8 433.2l-69-68.2c-4.4-4.4-11.6-4.4-16 0l-7.4 7.4-37-31.6c0 0 2.4-20-9.8-37.4-12.4-17.4-32.2-39.6-46.4-53.8-14.2-14-68.2-67.8-139.4-102.8-71.4-35.4-121.8-50.8-181.8-50.8v59.4c0 0 57.4 33.2 90.2 59.4 32.6 26.2 33.6 119 33.6 119l-57 57 113 112.2 62-72.6c25.8-7 47.6-7.6 60.4-0.6l27.4 26.6-19.2 19c-4.4 4.4-4.4 11.4 0 15.8l69 68.2c4.4 4.4 11.6 4.4 16 0l111.4-110.4c4.2-4.4 4.2-11.6 0-15.8z"],"grid":0,"tags":["md-construct"]},{"paths":["M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM512 220.8c68.6 0 124.8 56.2 124.8 124.8s-56.2 124.8-124.8 124.8-124.8-56.2-124.8-124.8 56.2-124.8 124.8-124.8zM512 811.6c-104 0-195.6-54-249.6-133.2 2-83.2 166.4-129 249.6-129s247.6 45.8 249.6 129c-54 79-145.6 133.2-249.6 133.2z"],"grid":0,"tags":["md-contact"]},{"paths":["M478.416 687.874c-35.56 20.206-76.684 31.752-120.51 31.752-43.818 0-84.934-11.542-120.492-31.74-94.326 28.776-152.128 124.114-173.414 208.114h587.824c-21.278-84-79.074-179.366-173.408-208.126z","M357.906 240.070c-116.958 0-211.772 94.788-211.772 211.716s94.814 211.714 211.772 211.714c116.958 0 211.772-94.788 211.772-211.714 0-116.928-94.816-211.716-211.772-211.716zM357.906 613.046c-67.342 0-124.89-45.026-147.994-101.046h295.988c-23.108 56.022-80.652 101.046-147.994 101.046z","M645.204 768h314.796c-21.276-84-79.074-163.382-173.406-192.144-35.562 20.208-76.686 31.746-120.512 31.746-29.646 0-58.048-5.308-84.336-14.98-14.89 24.94-33.854 51.184-55.948 69.812 52.692 20.274 92.494 65.566 119.406 105.566z","M613.090 400h200.986c-23.108 56-80.654 100.586-147.994 100.586-17.75 0-34.808-3.384-50.75-9.020-2.676 17.418-7.086 34.14-13.040 50.236 20.132 6.348 41.558 9.724 63.79 9.724 116.958 0 211.772-94.82 211.772-211.744 0-116.93-94.814-211.732-211.772-211.732-74.98 0-140.854 39.406-178.486 98.18 63.618 36.536 110.326 99.77 125.494 173.77z"],"grid":0,"tags":["md-contacts"]},{"paths":["M128 742.4h153.59v153.6h102.41v-256h-256v102.4zM281.59 281.6h-153.59v102.4h256v-256h-102.41v153.6zM640 896h102.4v-153.6h153.6v-102.4h-256v256zM742.4 281.6v-153.6h-102.4v256h256v-102.4h-153.6z"],"grid":0,"tags":["md-contract"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM738.2 738.2c-60.4 60.6-140.8 93.8-226.2 93.8v-640c85.4 0 165.8 33.2 226.2 93.8 60.6 60.4 93.8 140.8 93.8 226.2s-33.2 165.8-93.8 226.2z"],"grid":0,"tags":["md-contrast"]},{"paths":["M592 96h-239c-44.2 0-81 34.8-81 79v17h-15c-44.2 0-81 34.8-81 79v576c0 44.2 36.8 81 81 81h416c44.2 0 79-36.8 79-81v-15h17c44.2 0 79-36.8 79-81v-399l-256-256zM592 185.2l166.8 166.8h-166.8v-166.8zM688 847c0 9.4-6.8 17-15 17h-416c-8.8 0-17-8.2-17-17v-576c0-8.2 7.6-15 17-15h15v511c0 44.2 20.8 65 65 65h351v15zM784 751c0 9.4-6.8 17-15 17h-416c-8.8 0-17-8.2-17-17v-576c0-8.2 7.6-15 17-15h175v256h256v335z"],"grid":0,"tags":["md-copy"]},{"paths":["M128 736v160h160l471.454-471.458-159.998-159.996-471.456 471.454zM883.204 300.796c17.062-17.062 17.062-42.668 0-59.73l-100.27-100.27c-17.062-17.062-42.668-17.062-59.73 0l-78.936 78.938 159.998 159.996 78.938-78.934z"],"grid":0,"tags":["md-create"]},{"paths":["M704 625.4h75.6v-305.4c0-41.6-34-75.6-75.6-75.6h-305.4v75.6h305.4v305.4zM320 692.4v-596.4h-75.6v148.4h-148.4v75.6h148.4v372.4c0 41.6 34 75.6 75.6 75.6h384v160h75.6v-160h148.4v-75.6h-608z"],"grid":0,"tags":["md-crop"]},{"paths":["M934.6 336.2c-3.6 0-7 0.6-10.2 2l-355.2 184.2c0 0-0.2 0-0.2 0-15.2 9.4-25 25-25 42.8v371.8c0 12.8 11.2 23 25.4 23 4.4 0 8.6-1 12.2-2.8 0.4-0.2 0.8-0.4 1-0.6l350-185.6c16.4-9 27.4-25.4 27.4-44.2v-367.6c0-12.8-11.4-23-25.4-23z","M908.6 237l-363.4-163.4c0 0-21.4-9.6-33.2-9.6s-33 9.6-33 9.6l-363.8 163.4c0 0-16 6.6-16 19 0 13.2 16.6 23 16.6 23l371 195.6c7.6 3.4 16.2 5.2 25.2 5.2 9.2 0 17.8-2 25.4-5.4l370.8-195.8c0 0 15-8 15-23 0.2-12.6-14.6-18.6-14.6-18.6z","M455 522.4l-355.4-184.4c-3-1.2-6.6-2-10.2-2-14 0-25.4 10.2-25.4 23v367.6c0 18.8 11 35.2 27.4 44.2l0.4 0.2 349.4 185.4c3.8 2.2 8.4 3.4 13.2 3.4 14 0 25.4-10.4 25.4-23v-371.6c0.2-17.8-9.8-33.6-24.8-42.8z"],"grid":0,"tags":["md-cube"]},{"paths":["M406.2 316.6c10.4-22.4 16.2-47 16.2-73.4 0-99-80.2-179.2-179.2-179.2s-179.2 80.2-179.2 179.2 80.2 179.2 179.2 179.2c26.4 0 51-5.8 73.4-16.2l105.8 105.8-105.8 105.8c-22.4-10.4-47-16.2-73.4-16.2-99 0-179.2 80.2-179.2 179.2s80.2 179.2 179.2 179.2 179.2-80.2 179.2-179.2c0-26.4-5.8-51-16.2-73.4l105.8-105.8 313.6 313.6h134.4v-44.8l-553.8-553.8zM243.2 332.8c-49.2 0-89.6-39.8-89.6-89.6s40.4-89.6 89.6-89.6 89.6 39.8 89.6 89.6-40.4 89.6-89.6 89.6zM243.2 870.4c-49.2 0-89.6-39.8-89.6-89.6s40.4-89.6 89.6-89.6 89.6 39.8 89.6 89.6-40.4 89.6-89.6 89.6zM512 534.4c-12.6 0-22.4-9.8-22.4-22.4s9.8-22.4 22.4-22.4c12.6 0 22.4 9.8 22.4 22.4s-9.8 22.4-22.4 22.4zM825.6 108.8l-268.8 268.8 89.6 89.6 313.6-313.6v-44.8h-134.4z"],"grid":0,"tags":["md-cut"]},{"paths":["M874.666 64h-725.332c-46.938 0-85.334 38.394-85.334 85.332v565.334c0 46.938 38.396 85.334 85.334 85.334h277.332l-85.332 96v64h341.332v-64l-85.332-96h277.332c46.938 0 85.334-38.396 85.334-85.334v-565.334c0-46.938-38.396-85.332-85.334-85.332zM874.666 640h-725.332v-490.668h725.332v490.668z"],"grid":0,"tags":["md-desktop"]},{"paths":["M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416-186.4-416-416-416zM512 699.2c-103.6 0-187.2-83.6-187.2-187.2s83.6-187.2 187.2-187.2 187.2 83.6 187.2 187.2-83.6 187.2-187.2 187.2zM512 470.4c-22.8 0-41.6 18.8-41.6 41.6s18.8 41.6 41.6 41.6 41.6-18.8 41.6-41.6-18.8-41.6-41.6-41.6z"],"grid":0,"tags":["md-disc"]},{"paths":["M576 96h-304c-44.184 0-80 35.816-80 80v672c0 44.184 35.816 80 80 80h480c44.184 0 80-35.816 80-80v-496l-256-256zM544 384v-224l224 224h-224z"],"grid":0,"tags":["md-document"]},{"paths":["M775.162 279.424l-61.652-61.424-279.684 278.638 61.662 61.438 279.674-278.652zM962.344 218l-466.856 462.938-182.78-182.102-61.654 61.43 244.434 245.734 528.512-526.576-61.656-61.424zM0 560.266l246.642 245.734 61.658-61.426-244.432-245.738-63.868 61.43z"],"grid":0,"tags":["md-done-all"]},{"paths":["M832 399h-182.8v-271h-274.4v271h-182.8l320 316.2 320-316.2zM192 805.6v90.4h640v-90.4h-640z"],"grid":0,"tags":["md-download"]},{"paths":["M256 352h512v256h-512v-256z","M896 192h-768c-17.6 0-32 14.4-32 32v512c0 17.6 13.8 32 31.6 32h768.4c17.6 0 32-14.4 32-32v-512c0-17.6-14.4-32-32-32zM832 672h-640v-384h640v384z","M160 928h114l45-128h-112.8z","M558.8 96h-93.6l-23 64h139.6z","M750 928h114l-46-128h-113z","M464 800h96v64h-96v-64z"],"grid":0,"tags":["md-easel"]},{"paths":["M512 64c-140.8 0-352 266.4-352 513.8s140.8 382.2 352 382.2 352-134.8 352-382.2-211.2-513.8-352-513.8z"],"grid":0,"tags":["md-egg"]},{"paths":["M430.938 665.604l59.726 59.728 213.336-213.332-213.336-213.334-59.726 59.73 110.938 110.938h-413.876v85.332h411.728l-108.79 110.938zM810.668 128h-597.336c-46.936 0-85.332 38.396-85.332 85.332v170.668h85.332v-170.666h597.336v597.336h-597.336v-170.67h-85.332v170.668c0 46.936 38.396 85.332 85.332 85.332h597.336c46.936 0 85.332-38.396 85.332-85.332v-597.336c0-46.936-38.396-85.332-85.332-85.332z"],"grid":0,"tags":["md-exit"]},{"paths":["M793.59 793.6h-153.59v102.4h256v-256h-102.41z","M793.6 230.41v153.59h102.4v-256h-256v102.41z","M230.41 230.4h153.59v-102.4h-256v256h102.41z","M230.4 793.59v-153.59h-102.4v256h256v-102.41z"],"grid":0,"tags":["md-expand"]},{"paths":["M512.2 289.6c112.4 0 203.8 90.6 203.8 202.2 0 26.2-5.2 51-14.6 74l119 118c61.6-51 110-116.8 139.8-192-70.6-177.4-244.6-303.2-448.4-303.2-57 0-111.6 10.2-162.2 28.2l88 87.4c23.2-9.2 48.2-14.6 74.6-14.6zM104.8 179.4l111.8 110.8c-67.8 52-120.8 121.6-152.6 201.6 70.4 177.4 244.4 303.2 448.2 303.2 63.2 0 123.4-12.2 178.4-34l136.6 135 51.8-51.4-722.6-716.6-51.6 51.4zM330 402.8l63.2 62.6c-2 8.4-3.2 17.4-3.2 26.2 0 67 54.6 121.2 122.2 121.2 9 0 18-1.2 26.4-3.2l63.2 62.6c-27.2 13.4-57.4 21.4-89.6 21.4-112.4 0-203.8-90.6-203.8-202.2-0-31.6 8.2-61.4 21.6-88.6zM505.6 371.4l128.4 127.4 0.8-6.4c0-67-54.6-121.2-122.2-121.2l-7 0.2z"],"grid":0,"tags":["md-eye-off"]},{"paths":["M512 210c-203.6 0-376.8 124.8-448 302 71.2 177.2 244.4 302 448 302s376.8-124.8 448-302c-71.2-177.2-244.4-302-448-302zM512 713.4c-112 0-203.6-90.6-203.6-201.4s91.6-201.4 203.6-201.4 203.6 90.6 203.6 201.4-91.6 201.4-203.6 201.4zM512 391.2c-67.2 0-122.2 54.4-122.2 120.8s55 120.8 122.2 120.8 122.2-54.4 122.2-120.8-55-120.8-122.2-120.8z"],"grid":0,"tags":["md-eye"]},{"paths":["M960 512l-435.2-292v584l435.2-292zM64 220v584l435.2-292-435.2-292z"],"grid":0,"tags":["md-fastforward"]},{"paths":["M800 352c0-159-129-288-288-288s-288 129-288 288c0 142.8 103.8 261.2 240 284v100h-144v96h144v128h96v-128h144v-96h-144v-100c136.2-22.8 240-141.2 240-284zM320 352c0-105.8 86.2-192 192-192s192 86.2 192 192-86.2 192-192 192-192-86.2-192-192z"],"grid":0,"tags":["md-female"]},{"paths":["M898.4 416h-52.4v-64l-28.8-96h-51.2v-64l-30-96h-448l-30 96v64h-51.2l-28.8 96v64h-52.4l-29.6 96v330.6c0 47 70.4 85.4 117.4 85.4h629.4c43.6 0 85.4-39.4 85.4-82v-334l-29.8-96zM352 192h320v64h-320v-64zM270 352h484v64h-484v-64zM834 576h-165.2c-14.8 73-79.4 128-156.8 128s-142-55-156.8-128h-165.2v-64h644v64z"],"grid":0,"tags":["md-filing"]},{"paths":["M752 128v85.334h-80v-85.334h-320v85.334h-80v-85.334h-80v768h80v-85.332h80v85.332h320v-85.332h80v85.332h80v-768h-80zM352 725.334h-80v-85.334h80v85.334zM352 554.668h-80v-85.334h80v85.334zM352 384h-80v-85.332h80v85.332zM752 725.334h-80v-85.334h80v85.334zM752 554.668h-80v-85.334h80v85.334zM752 384h-80v-85.332h80v85.332z"],"grid":0,"tags":["md-film"]},{"paths":["M156.2 411.2c-4.8 0-9.8-1.2-14.2-3.8-13.4-7.8-18-24.8-10.2-38.2 35.6-60 143.8-200.2 380.2-200.2 102.4 0 192.2 27.2 266.8 80.8 61.4 44 95.8 93.8 112.2 117.8 8.8 12.8 5.4 30-7.4 38.8-12.8 8.6-30.4 5.4-39.2-7.4-29.8-43.2-120.2-174.4-332.4-174.4-207.2 0-300.8 120.8-331.4 172.6-5.2 9.2-14.6 14-24.4 14z","M631 960c-2.4 0-4.6-0.2-7-0.8-171.4-43-235.4-216.2-238-223.4l-0.4-1.6c-1.4-5-35.8-123.8 17-193.4 24.2-31.8 61-48 109.6-48 45.2 0 77.8 14.2 100.2 43.6 18.4 24 25.8 53.6 33 82.2 15 59.4 25.8 90.6 88.2 93.8 27.4 1.4 45.4-14.8 55.6-28.6 27.6-37.6 32.4-99 11.6-153-26.8-70-121.6-201.8-288.8-201.8-71.4 0-137 23.2-189.6 66.8-43.6 36.2-78.2 87.2-94.8 139.6-30.8 97.6 9.6 251 10 252.4 4 14.8-5 30.2-20 34-15 4-30.6-5-34.6-19.8-1.8-7-45-170.6-9.4-283.4 38.8-122.2 158.4-245.4 338.4-245.4 83.2 0 161.8 28.6 227.4 82.6 50.8 42 92.4 98.4 114 154.8 27.6 72 20.2 152.8-18.8 205.6-26 35.2-63 53.6-104 51.6-106.8-5.4-126-80.8-140-135.8-14.4-56.4-23.6-83.6-78.6-83.6-30.2 0-51.4 8.4-64.6 25.8-18 23.8-19.4 61-17.4 88 2 28.2 8 51 9.4 55.6 4.4 11.2 61.6 153 198.6 187.4 15.2 3.8 24.2 19 20.4 33.8-3.4 12.6-14.8 21-27.4 21z","M411 947.2c-7.6 0-15-3-20.6-8.8-68.6-72.8-107.4-154.2-122-256v-0.6c-8.2-67.4 3.8-162.8 62.6-228.4 43.4-48.4 104.4-73 181-73 90.6 0 161.8 42.6 206.2 123 32.2 58.4 38.6 116.6 38.8 119 1.6 15.4-9.8 29-25.2 30.6s-29.4-9.6-31-24.8v0c0-0.6-5.6-50.6-33-99.4-34.4-61.4-86.8-92.6-156-92.6-59.8 0-106.6 18.2-138.8 54.2-46.4 51.8-55.4 131.6-49 184.4 12.8 90 47 161.6 107.4 225.6 10.6 11.2 10 29-1.4 39.4-5.2 4.8-12.2 7.4-19 7.4z","M727 867c-60 0-111-16.8-151.8-50.2-82-66.8-91.2-175.6-91.6-180.2-1.2-15.4 10.4-28.8 26-30s29 10.2 30.2 25.6c0.2 1.6 8.4 90.6 71.6 141.8 37.4 30.2 87.4 42.2 149 35.2 15.4-1.8 29.4 9.2 31.2 24.6s-9.4 29.2-24.8 30.8c-13.6 1.6-27 2.4-39.8 2.4z","M774.4 125.2c-23.4-15.4-106.4-61.2-262.4-61.2-163.8 0-247 50.6-265.4 63.4-1.2 0.8-2.4 1.6-3.4 2.6-0.2 0.2-0.4 0.2-0.4 0.2v0c-5.8 5.2-9.4 12.6-9.4 20.8 0 15.4 12.6 27.8 28.2 27.8 6.2 0 11.8-2 16.4-5.2v0l-0.2 0.2c0.8-0.6 72.6-54 234.2-54s233.4 53.6 234.2 54l-0.2-0.2 0.4-0.4c4.8 3.6 10.6 5.6 17 5.6 15.6 0 28.2-12.4 28.2-27.8 0-11.6-7-21.6-17.2-25.8z"],"grid":0,"tags":["md-finger-print"]},{"paths":["M792 166.4c-27.6 3.4-62.2 8.4-99.2 8.4-57.6 0-110-13.6-163-24.4-53.8-11-109.4-22.4-168.2-22.4-117.2 0-157 24.2-161.2 26.8l-8.4 5.8v735.4h96v-356.4c19.4-2.4 43.8-4 73.8-4 54.6 0 105.6 20 159.6 31 55.2 11.2 112 23 173.8 23 36.8 0 69.2-4.8 96.8-8 15-1.8 28-3.4 40-5.4v-415.8c-10 2-25 4.2-40 6z"],"grid":0,"tags":["md-flag"]},{"paths":["M786.6 444.2l-0.4 20.8c-1.6 23.4-15.8 86.8-44.2 109.4 14-30.4 34.6-94.4 20.4-165.4-39.2-195-187.4-277.8-376.4-309l-34.4-4.4c79 94.4 112.2 163.4 99.4 233.6-4.6 25.2-20 46.8-28 63.2 0 0 4.8-25.8 4-57.4-0.6-28.4-13.2-62-36-79.2 7 36.8-1.6 67-18.2 95.4-49.4 84.4-170.8 115.6-180.8 271.6v7.6c0 107.4 51.2 198 137.4 250-13.6-24.6-24-70.4-11.4-120.4 8 47.4 28 72 49.8 103.6 16.4 23.4 38.2 38.6 66.2 49.8s62 14.4 95.8 14.4c111.6 0 182.8-36.2 238.2-101s64.2-136 64.2-212.8-17-121.8-45.6-169.8z"],"grid":0,"tags":["md-flame"]},{"paths":["M320 96v448h128v384l256-512h-128l128-320h-384z"],"grid":0,"tags":["md-flash"]},{"paths":["M873.8 708.8l-201.8-324.8v-192h64v-96h-448v96h64v192l-199.8 324.8c-16.8 31.8-25 62.8-24.2 91.2 2.2 73 57.4 128 130.2 128h511.8c72.6 0 124.2-55.2 126-128 0.6-28.4-5.2-59.4-22.2-91.2zM310.2 608l59-96h286.2l59.6 96h-404.8z"],"grid":0,"tags":["md-flask"]},{"paths":["M810.2 512c50.4-23.8 85.8-74.2 85.8-133.8 0-82-67.2-148.6-150-148.6-31.8 0-60.6 9.6-85.2 26.2l1.2-11.2c0-82-67.2-148.6-150-148.6s-150 66.6-150 148.6l1.2 11.2c-24-16.6-53.4-26.2-85.2-26.2-82.8 0-150 66.6-150 148.6 0 59.4 35.4 110 85.8 133.8-50.4 23.8-85.8 74.2-85.8 133.8 0 82 67.2 148.6 150 148.6 31.8 0 60.6-9.6 85.2-26.2l-1.2 11.2c0 82 67.2 148.6 150 148.6s150-66.6 150-148.6l-1.2-11.2c24 16.6 53.4 26.2 85.2 26.2 82.8 0 150-66.6 150-148.6 0-59.6-35.4-110-85.8-133.8zM512 660.6c-82.8 0-150-66.6-150-148.6s67.2-148.6 150-148.6 150 66.6 150 148.6c0 82-67.2 148.6-150 148.6z"],"grid":0,"tags":["md-flower"]},{"paths":["M874.668 288h-362.656l-85.336-96h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334zM896 746.666c0 11.564-9.77 21.334-21.332 21.334h-725.336c-11.564 0-21.332-9.77-21.332-21.334v-394.666h746.668c11.562 0 21.332 9.77 21.332 21.334v373.332z"],"grid":0,"tags":["md-folder-open"]},{"paths":["M426.676 192h-277.344c-46.938 0-85.332 38.396-85.332 85.334v469.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-373.332c0-46.938-38.394-85.334-85.332-85.334h-362.656l-85.336-96z"],"grid":0,"tags":["md-folder"]},{"paths":["M512 96c-229.4 0-416 186.6-416 416s186.6 416 416 416 416-186.6 416-416-186.6-416-416-416zM254 476.4l78.4 35.8 34.2 133.8-31.2 58.6-114.4-1.4c-29.8-45.2-48.6-97-55-150.6l88-76.2zM688.6 704.6l-31.2-58.6 34.2-134 78.2-35.6 88 76.2c-6.2 53.6-25.2 105.4-55 150.6l-114.2 1.4zM753.4 412.2l-87.2 39.2-122.2-103.2v-94.4l95.8-65.2c59.6 23.8 112.8 64.6 151.2 115.6l-37.6 108zM382.6 188.8l95.4 65v94.4l-122 103-86-39.2-37.4-107.2c38.6-52.2 90.2-92 150-116zM436.8 852c-1.4-0.4-2.6-0.6-4-1l-41-110.2 29.4-58.8h181.6l30 60.6-39.6 107.8c-2 0.4-4 1-6 1.4-23 4.6-54 7.6-80.8 8.2-23.4-0.2-46.8-3-69.6-8z"],"grid":0,"tags":["md-football"]},{"paths":["M416 800h192v-95.988h-192v95.988zM64 224v95.988h896v-95.988h-896zM224 561.566h576v-99.11h-576v99.11z"],"grid":0,"tags":["md-funnel"]},{"paths":["M312 430h-48v62h-62v48h62v60h48v-60h60v-48h-60z","M738.6 288h-453.2c-122.4 0-221.4 93-221.4 222.8 0 130 99 225.2 221.4 225.2h453c122.4 0 221.4-95.2 221.4-225.2 0.2-129.8-98.8-222.8-221.2-222.8zM288.4 633c-66.2 0-120-54.2-120-121s53.8-121 120-121 120 54.2 120 121c0 66.8-53.6 121-120 121zM694.6 538.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM769.6 613.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.6 38 0 52.4zM769.6 463.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.6 38 0 52.4zM844.8 538.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4z"],"grid":0,"tags":["md-game-controller-a"]},{"paths":["M326 320h-48v62h-62v48h62v60h48v-60h60v-48h-60z","M934.2 408.2c-10.4-126.2-95.4-216.2-214.2-216.2h-416c-118.8 0-203.6 90-214 216.2 0 0-26 269.4-26 327.8s43 96 96 96c26.2 0 50-10.6 68-27.8v0h-0.6l156.6-162.2h256l156.6 162-0.6 0.2c18 17.2 41.8 27.8 68 27.8 53 0 96-40.6 96-96s-25.8-327.8-25.8-327.8zM302 524c-66.2 0-120-54.2-120-121s53.8-121 120-121 120 54.2 120 121c0 66.8-53.8 121-120 121zM676.2 429.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM751.2 504.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM751.2 354.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4zM826.2 429.2c-14.4 14.4-38 14.4-52.4 0s-14.4-38 0-52.4c14.4-14.4 38-14.4 52.4 0s14.4 38 0 52.4z"],"grid":0,"tags":["md-game-controller-b"]},{"paths":["M832 320c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v17.2c0 39.8-15.6 67.4-50.6 89.8-30.8 19.6-76.2 34.2-135 43-28 4.2-51.4 12-70.4 21.4v-299.4c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-33.2-12.6-63.4-33.4-86.2 3.8-9.8 19.4-32.6 58.8-38.6 77.6-11.6 137.8-31.8 184.6-61.6 72-45.6 110-114 110-197.6v-17.2c38.2-22.2 64-63.4 64-110.8zM320 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80zM320 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM704 400c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"],"grid":0,"tags":["md-git-branch"]},{"paths":["M960 448h-199.6c-28.4-110.4-128.4-192-247.4-192s-219 81.6-247.4 192h-201.6v128h201.6c28.4 110.4 128.4 192 247.4 192s219-81.6 247.4-192h199.6v-128zM513 672c-88 0-159.6-71.8-159.6-160s71.6-160 159.6-160c88 0 159.6 71.8 159.6 160s-71.6 160-159.6 160z"],"grid":0,"tags":["md-git-commit"]},{"paths":["M384 764h-44c-49.2 0-58-7.2-67.6-19.2-11-13.8-16.4-38.2-16.4-108.4v-333.6c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.4 25.8 88.6 64 110.8v333.6c0 92.8 7.4 141.6 44.2 188 39.8 50.2 90 71.6 167.8 71.6h44v128l192-192-192-192v124zM192 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z","M896 721.2v-339.6c0-92.8-7.4-141.6-44.2-188-39.8-50.2-90-69.6-167.8-69.6h-44v-124l-192 192 192 192v-128h44c49.2 0 58 5.2 67.6 17.2 11 13.8 16.4 38.2 16.4 108.4v339.6c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8zM832 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"],"grid":0,"tags":["md-git-compare"]},{"paths":["M768 448c-47.4 0-88.8 25.8-110.8 64-36.6-1-104.8-8.2-151-36.2-64.6-38.8-129.2-106.2-174-181 31.4-23.4 52-60.6 52-102.8 0-70.6-57.4-128-128-128s-128.2 57.4-128.2 128c0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8v-232.8c37.4 38.8 78.2 72 120 97.2 77.6 46.8 174 53.8 217.2 54.6 22.2 38.2 63.4 63.8 110.8 63.8 70.6 0 128-57.4 128-128s-57.4-128-128-128zM176 192c0-44.2 35.8-80 80-80s80 35.8 80 80-35.8 80-80 80-80-35.8-80-80zM336 832c0 44.2-35.8 80-80 80s-80-35.8-80-80 35.8-80 80-80 80 35.8 80 80zM768 656c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"],"grid":0,"tags":["md-git-merge"]},{"paths":["M896 192c0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.2 25.8 88.6 64 110.8v105.6l-192 96-192-96v-105.6c38.2-22.2 64-63.6 64-110.8 0-70.6-57.4-128-128-128s-128 57.4-128 128c0 47.2 25.8 88.6 64 110.8v184.8l256 128v105.6c-38.2 22.2-64 63.6-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.2-25.8-88.6-64-110.8v-105.6l256-128v-184.8c38.2-22.2 64-63.6 64-110.8zM256 112c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80zM512 912c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM768 272c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"],"grid":0,"tags":["md-git-network"]},{"paths":["M832 753.2v-339.6c0-92.8-7.4-141.6-44.2-188-39.8-50.2-90-71.6-167.8-71.6h-44v-122l-192 192 192 192v-130h44c49.2 0 58 7.2 67.6 19.2 11 13.8 16.4 38.2 16.4 108.4v339.6c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8zM768 944c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z","M256 96c-70.6 0-128 57.4-128 128 0 47.4 25.8 88.6 64 110.8v418.4c-38.2 22.2-64 63.4-64 110.8 0 70.6 57.4 128 128 128s128-57.4 128-128c0-47.4-25.8-88.6-64-110.8v-418.4c38.2-22.2 64-63.4 64-110.8 0-70.6-57.4-128-128-128zM256 944c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80zM256 304c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z"],"grid":0,"tags":["md-git-pull-request"]},{"paths":["M960 352h-896v96h22l10 43c32 135 81 181 192 181s192-34.8 192-181v-43c0 0 3-32 32-32s32 32 32 32v43.6c0 146 84.2 180.4 194 180.4s158-50 190-180.4l10-43.6h22v-96z"],"grid":0,"tags":["md-glasses"]},{"paths":["M512 96c-229.752 0-416 186.25-416 416s186.248 416 416 416c229.75 0 416-186.25 416-416s-186.25-416-416-416zM468.902 865.998c-78.928-9.452-151.956-44.784-209.038-101.864-67.348-67.348-104.436-156.89-104.436-252.134 0-85.74 30.072-166.848 85.202-231.318 1.42 17.034 4.926 35.296 4.028 48.35-3.28 47.59-7.976 77.374 19.88 117.524 10.852 15.638 13.518 38.056 18.8 56.156 5.166 17.708 25.804 26.996 40.038 37.906 28.718 22.018 56.192 47.61 86.644 66.988 20.098 12.79 32.652 19.152 26.766 43.678-4.734 19.724-6.056 31.874-16.26 49.446-3.114 5.362 11.754 39.836 16.702 44.784 14.996 14.994 29.876 28.75 46.222 42.25 25.342 20.938-2.462 48.144-14.548 78.234zM764.134 764.134c-51.266 51.266-115.398 84.972-185.112 98.162 9.88-24.432 27.472-46.14 43.79-58.724 14.194-10.952 31.972-32.018 39.386-48.704 7.408-16.664 17.222-31.11 27.154-46.434 14.13-21.798-34.838-54.672-50.706-61.562-35.708-15.502-62.588-36.42-94.322-58.75-22.61-15.908-68.514 8.308-94.040-2.834-34.962-15.266-63.766-41.792-94.156-64.678-31.36-23.618-29.844-51.152-29.844-85.994 24.564 0.906 59.508-6.798 75.816 12.956 5.146 6.234 22.84 34.084 34.684 24.188 9.676-8.086-7.17-40.498-10.424-48.118-10.010-23.43 22.808-32.568 39.606-48.456 21.92-20.728 68.94-53.236 65.224-68.094s-47.048-56.954-72.498-50.386c-3.814 0.984-37.394 36.194-43.882 41.718 0.172-11.492 0.344-22.982 0.52-34.474 0.11-7.256-13.536-14.704-12.902-19.384 1.6-11.828 34.524-33.294 42.714-42.714-5.738-3.586-25.318-20.404-31.244-17.936-14.348 5.98-30.552 10.1-44.9 16.078 0-4.976-0.604-9.65-1.324-14.266 28.752-12.73 59.174-21.582 90.62-26.304l28.168 11.32 19.888 23.602 19.848 20.466 17.35 5.59 27.558-25.99-7.106-18.554v-16.678c54.5 7.916 105.968 28.248 151.044 59.6-8.064 0.722-16.926 1.908-26.924 3.18-4.13-2.44-9.428-3.548-13.93-5.246 13.062 28.084 26.686 55.78 40.528 83.492 14.786 29.602 47.586 61.354 53.346 92.602 6.788 36.832 2.078 70.288 5.792 113.622 3.576 41.73 47.048 89.144 47.048 89.144s20.074 6.838 36.768 4.456c-15.562 61.566-47.466 118.028-93.538 164.104z"],"grid":0,"tags":["md-globe"]},{"paths":["M819.2 128h-614.4c-42.2 0-76.8 34.6-76.8 76.8v614.4c0 42.2 34.6 76.8 76.8 76.8h614.4c42.2 0 76.8-34.6 76.8-76.8v-614.4c0-42.2-34.6-76.8-76.8-76.8zM358.4 819.2h-153.6v-153.6h153.6v153.6zM358.4 588.8h-153.6v-153.6h153.6v153.6zM358.4 358.4h-153.6v-153.6h153.6v153.6zM588.8 819.2h-153.6v-153.6h153.6v153.6zM588.8 588.8h-153.6v-153.6h153.6v153.6zM588.8 358.4h-153.6v-153.6h153.6v153.6zM819.2 819.2h-153.6v-153.6h153.6v153.6zM819.2 588.8h-153.6v-153.6h153.6v153.6zM819.2 358.4h-153.6v-153.6h153.6v153.6z"],"grid":0,"tags":["md-grid"]},{"paths":["M948.2 796.4l-488.6-460.8c0 0 17.6-115.4 52.4-143.6 35-28.4 96-64 96-64v-64c-64 0-117.6 16.6-193.8 54.6-76 37.8-133.6 95.6-148.8 110.8s-36.2 39-49.4 57.8-10.6 40.2-10.6 40.2l-39.4 34-8-8c-4.6-4.6-12.4-4.6-17 0l-73.6 73.6c-4.6 4.6-4.6 12.4 0 17l118.8 118.8c4.6 4.6 12.4 4.6 17 0l73.6-73.6c4.6-4.6 4.6-12.4 0-17l-20.6-20.6 29.2-28.6c13.6-7.4 50.8-17.8 78.2-10.2l429.8 534.6c16.2 16.4 40.6 16.4 57 0l93.6-94.2c20.6-16 20.6-44.6 4.2-56.8z"],"grid":0,"tags":["md-hammer"]},{"paths":["M901.358 547c-29.17-29.154-72.108-31.78-101.278-2.624l-83.374 83.328c-21.704 21.672-47.86 21.718-63.128 3.704-10.114-11.936-6.122-48.748-3.288-72.098l41.814-343.698c3.734-30.706-18.14-60.37-48.86-64.102-30.716-3.734-58.644 19.878-62.382 50.578l-46.122 269.954c-2.41 6.716-7.58 7.876-8.162-1.164l-15.698-350.878c0-30.93-25.084-56-56.028-56-30.946 0-56.030 25.070-56.030 56l-1.104 353.504c0.292 4.080-3.208 5.248-3.84 0.588l-49.846-275.938c-5.5-30.438-34.646-52.406-65.096-46.906-30.454 5.496-50.678 36.374-45.182 66.806l44.386 322.91c0.046 5.744-1.882 9.026-4.616 1.662l-66.218-177.034c-10.36-29.144-42.392-46.13-71.552-35.778-29.158 10.354-44.402 44.122-34.046 73.262l116.084 379.25c0.606 2.092 1.248 4.17 1.906 6.236l0.242 0.78c0.022 0.062 0.050 0.116 0.070 0.176 32.148 98.948 125.13 170.482 234.844 170.482 70.232 0 143.182-24.756 198.714-67.344 0.002 0 0.006-0.004 0.006-0.004 59.98-36.102 252.142-242.694 252.142-242.694 29.174-29.154 24.816-73.798-4.358-102.958z"],"grid":0,"tags":["md-hand"]},{"paths":["M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8zM657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4zM366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4zM512 740.8c97.766 0 178.872-60.328 212.162-145.602h-424.324c33.29 85.274 114.396 145.602 212.162 145.602z"],"grid":0,"tags":["md-happy"]},{"paths":["M512 96c-212 0-384 176.4-384 394.2v306.6c0 72.6 57.2 131.4 128 131.4h128v-352.2h-170.6v-85.8c0-169.4 133.6-306.6 298.6-306.6s298.6 137 298.6 306.6v85.8h-170.6v352h128c70.8 0 128-58.6 128-131.4v-306.4c0-217.8-172-394.2-384-394.2z"],"grid":0,"tags":["md-headset"]},{"paths":["M699.2 128c-72.8 0-141.436 33.484-187.2 87.894-45.766-54.41-114.4-87.894-187.2-87.894-128.964 0-228.8 100.442-228.8 230.19 0 159.032 141.436 286.696 355.672 483.388l60.328 54.422 60.328-54.422c214.234-196.694 355.672-324.358 355.672-483.388 0-129.748-99.836-230.19-228.8-230.19zM537.672 786.514l-8.438 7.746-17.234 15.546-17.232-15.544-8.428-7.738c-100.836-92.564-187.922-172.508-245.492-243.988-55.914-69.426-80.848-126.28-80.848-184.346 0-45.73 16.844-87.862 47.43-118.632 30.484-30.668 72.166-47.558 117.37-47.558 52.268 0 103.94 24.334 138.22 65.090l48.98 58.232 48.978-58.232c34.282-40.756 85.952-65.090 138.222-65.090 45.206 0 86.886 16.89 117.372 47.556 30.584 30.772 47.428 72.902 47.428 118.634 0 58.066-24.934 114.918-80.844 184.342-57.568 71.48-144.65 151.418-245.484 243.982z"],"grid":0,"tags":["md-heart-outline"]},{"paths":["M512 896l-60.328-54.422c-214.236-196.694-355.672-324.358-355.672-483.388 0-129.748 99.836-230.19 228.8-230.19 72.798 0 141.434 33.484 187.2 87.894 45.764-54.41 114.398-87.894 187.2-87.894 128.964 0 228.8 100.442 228.8 230.19 0 159.032-141.438 286.696-355.672 483.388l-60.328 54.422z"],"grid":0,"tags":["md-heart"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416-186.2-416-416-416zM634 808l-24.4-79.2c26-11.6 49.8-28 70.6-48.8s37.2-44.6 48.8-70.6l79 24.2c-15.8 38.6-39.4 74-69.8 104.4-30.2 30.6-65.6 54.2-104.2 70zM390 216l24.4 79.2c-26 11.6-49.8 28-70.6 48.8s-37.2 44.6-48.8 70.6l-79-24.2c15.8-38.6 39.4-74 69.8-104.4 30.2-30.6 65.6-54.2 104.2-70zM512 384c70.6 0 128 57.4 128 128s-57.4 128-128 128-128-57.4-128-128c0-70.6 57.4-128 128-128zM738.2 285.8c30.4 30.4 53.8 65.8 69.8 104.2l-79 24.4c-11.8-26-28-49.8-48.8-70.6s-44.6-37.2-70.6-48.8l24.2-79c38.6 15.8 74 39.4 104.4 69.8zM285.8 738.2c-30.4-30.2-54-65.6-69.8-104.2l79-24.4c11.8 26 28 49.8 48.8 70.6s44.6 37.2 70.6 48.8l-24.2 79c-38.6-15.8-74-39.4-104.4-69.8z"],"grid":0,"tags":["md-help-buoy"]},{"paths":["M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416-186.4-416-416-416zM554 762h-84v-84h84v84zM553.6 636h-83.2c0-134 124.8-124.4 124.8-207.6 0-45.8-37.4-83.4-83.2-83.4s-83.2 39-83.2 83h-83.2c0-92 74.4-166 166.4-166s166.4 74.2 166.4 166.2c0 104-124.8 115.8-124.8 207.8z"],"grid":0,"tags":["md-help-circle"]},{"paths":["M578 896h-132v-130h132v130zM576 700h-128c0-202 192-190.2 192-318 0-70.4-57.6-126.8-128-126.8s-128 60.8-128 128.8h-128c0-142 114.6-256 256-256s256 112.8 256 254c0 159.8-192 178-192 318z"],"grid":0,"tags":["md-help"]},{"paths":["M416 896v-256h192v256h195.2v-384h124.8l-416-384-416 384h124.8v384z"],"grid":0,"tags":["md-home"]},{"paths":["M256.2 512l256 448 256-448z","M784 322c6-18 9.4-45.4 9.4-65.8 0-106.2-86-192.2-192.2-192.2-62.8 0-118.4 30-153.6 76.6 0 0-18.2 28-21.6 58l-6.8-2c-4.6-18-7.4-40 3.2-63-14.8-5-18.8-5.6-35.2-5.6-83.4 0-151.2 67.6-151.2 151.2 0 12.6 1.6 31 4.6 42.8-27.8 7-48.6 32.2-48.6 62v0c0 35.2 28.8 64 64 64h512c35.2 0 64-28.8 64-64v0c0-29.6-20.4-54.8-48-62z"],"grid":0,"tags":["md-ice-cream"]},{"paths":["M896 810.666v-597.332c0-46.938-38.396-85.334-85.334-85.334h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334zM362.666 576l106.668 128 149.332-192 192 256h-597.332l149.332-192z"],"grid":0,"tags":["md-image"]},{"paths":["M915.2 280.4l-165-8-9.6-107.6c-2-22.6-22.2-38.4-45.8-36.6l-591.8 48.6c-23.6 2-40.6 21-38.8 43.4l42.4 471.6c2 22.6 22.4 38.4 45.8 36.6l30-2.4-4.8 91.6c-1.2 25.2 18.4 45.6 44.8 47l660.2 31.4c26.4 1.2 48.2-17.2 49.6-42.4l27.8-526.6c1.2-25-18.6-45.4-44.8-46.6zM205.4 291l-14.2 269.6-35 49.4-32.2-356c0-0.4 0-0.6 0-1s0-0.6 0-1c2-10 8.8-18 19.2-18.8l522-42.8c10.4-0.8 19.4 6 21 15.8 0 0.4 0.6 0.4 0.6 0.8 0 0.2 0.6 0.4 0.6 0.8l5.4 61.6-438-21c-26.4-0.8-48.2 17.6-49.4 42.6zM873.4 764.8l-169.6-199-74.8 68.6-138.4-161.6-245.4 261.4 20.8-398.2c0 0 0-0.6 0-0.8 2-10.8 12.4-18.6 23.8-18l582.4 28c11.6 0.6 20.6 9.4 20.8 20.4 0 0.4 0.6 0.6 0.6 1l-20.2 398.2z","M768 512c35.2 0 64-28.8 64-64s-28.6-64-64-64c-35.2 0-64 28.6-64 64s28.6 64 64 64z"],"grid":0,"tags":["md-images"]},{"paths":["M869.4 376c-37.6-36-87.6-56-141-56-53.2 0-103.2 19.8-140.8 55.8l-35.2 31.8 66.2 64.2 34.2-31c20.2-19.2 47-30 75.4-30s55.2 10.6 75.4 29.8c20 19.2 30.8 44.6 30.8 71.6s-11 52.2-30.8 71.2c-20.2 19.2-47 30-75.4 30s-55.2-10.6-75.4-29.8l-216.4-207.6c-37.8-36-87.8-56-140.8-56-53.4 0-103.4 19.8-141 56-37.8 36.2-58.6 84.4-58.6 136 0 51.4 20.8 99.8 58.6 136 37.6 36 87.6 56 141 56s103.4-19.8 140.8-56l75.6-72.2 75.4 72.2c37.8 36 87.8 56 140.8 56 53.4 0 103.4-19.8 140.8-55.8 38-36.2 58.8-84.4 58.8-136 0.2-51.6-20.6-100-58.4-136.2zM371 583.4c-20.2 19.2-47 30-75.4 30s-55.2-10.6-75.4-29.8c-20-19.2-30.8-44.6-30.8-71.6s11-52.2 30.8-71.2c20.2-19.2 47-30 75.4-30s55.2 10.6 75.4 29.8l74.8 71.6-74.8 71.2z"],"grid":0,"tags":["md-infinite"]},{"paths":["M512 96c-229.6 0-416 186.4-416 416s186.4 416 416 416 416-186.4 416-416c0-229.6-186.4-416-416-416zM554 720h-84v-250h84v250zM554 388h-84v-84h84v84z"],"grid":0,"tags":["md-information-circle"]},{"paths":["M464 470h96v274h-96v-274z","M464 280h96v96h-96v-96z"],"grid":0,"tags":["md-information"]},{"paths":["M512 328.6c-101.2 0-183.4 82.2-183.4 183.4s82.2 183.4 183.4 183.4 183.4-82.2 183.4-183.4c0-101.2-82.2-183.4-183.4-183.4z","M875.6 249.2c0 48.38-39.22 87.6-87.6 87.6s-87.6-39.22-87.6-87.6c0-48.38 39.22-87.6 87.6-87.6s87.6 39.22 87.6 87.6z","M890.6 339.6c-14.8 16.8-33.8 30-55.2 38 17.2 41.4 26.8 86.8 26.8 134.4 0 193.2-157.2 350.4-350.4 350.4s-350.4-157.2-350.4-350.4c0-193.2 157.2-350.4 350.4-350.4 53.8 0 104.6 12.2 150.2 33.8 9-21 23-39.2 40.6-53.2-57-29.4-121.8-46.2-190.6-46.2-229.8 0-416 186.2-416 416s186.2 416 416 416 416-186.2 416-416c0-61.4-13.4-119.8-37.4-172.4z"],"grid":0,"tags":["md-ionic"]},{"paths":["M957.4 539.6c-9.4-66.8-37.4-123.6-71.4-119.6 13.6 30.6 24.2 73.6 20.6 150.6-3-54-13.2-104.8-36-150.6-67.4-135-211.4-224.4-372.6-215.4-180.4 10-325.4 139.4-361.2 306.6l-24 3.4c-36.2 5-56.6 72.8-45.6 151.4s49.4 138.4 85.6 133.4l33.2-4.6c72.8 117.6 206.8 193 355.6 184.8 179.2-9.8 323.4-137.8 360.4-303.4l15.4-1c31.8-5.2 49.8-65.6 40-135.6zM163.2 528.8c14.2 11.2 53 37 62.8 115.2s-17.8 117.8-30 134.2c12.6-31 13-78 6-129.4-6.8-50-19-93.4-38.8-120zM549.4 771.4c-17.8 1-33.2-12.6-34.2-30.4s12.6-32.8 30.6-33.8c17.8-1 33.2 12.6 34.2 30.4s-12.8 33-30.6 33.8zM719.4 761.8c-17.8 1-33.2-12.6-34.2-30.4s12.6-32.8 30.6-33.8c17.8-1 33.2 12.6 34.2 30.4 1 17.6-12.8 32.8-30.6 33.8z","M321.2 123.4c0 0 0.2 0 0 0 0.2 0.2 0.2 0.4 0.2 0.4s0 0 0 0c0.2 0.4 0.4 0.8 0.6 1 0 0 0 0.2 0 0.2 0.8 2.2 2.4 4 4.8 5.8 4.2 3 10.4 5 18 6.2 7.2 1.2 15.8 1.4 25 1 2 0 4-0.2 6.2-0.4-0.8-1-1.8-1.8-2.6-2.8-1 0-1.8 0-2.8 0-9 0.2-17.4-0.4-24.4-1.8-7.4-1.4-13.6-3.8-17.6-7.2-1.2-1-2-2-2.8-3-0.4-1.4-0.4-3 0-4.8 1-4.8 5-10 11.4-15.6 5.8-4.8 13.4-9.8 22.8-14.6 1.8-1 3.6-1.8 5.6-2.8 0.4-0.2 0.6-0.2 1-0.4-1.6 7-2 14.4-0.6 21.8 4.8 25 26.4 42.4 51 43.2l10.4 55 22.6-4.2-10.4-55c22.6-9.6 36.4-33.6 31.6-58.6-1.4-7.4-4.2-14-8.2-19.8-11.2-1.6-32.8-1.6-61.4 4.4 2.2-0.6 4.4-1.4 6.8-2 16-4.4 31.4-7.4 45.2-8.8 1.2-0.2 2.6-0.2 3.8-0.4 2.4-0.2 5-0.4 7.4-0.6 0.4 0 0.8 0 1.2 0 8.6-0.4 16.2-0.2 22.6 0.8 5 0.6 9.4 1.6 12.8 3-1.2 2-2 4.2-2 6.6 0 5.8 3.8 10.6 9 12.2 0 0 0 0 0 0-1.2 2-2.6 4-4.4 6s-3.8 3.8-6 5.8c-2.2 1.8-4.8 3.8-7.4 5.6l-13.6 7.8c-0.2 1-0.4 2.2-0.6 3.2 0.2 0 0.4-0.2 0.6-0.2l17.6-9.8c2.6-1.6 5-3.4 7.2-5 2.4-2 4.6-3.8 6.6-5.8s3.6-4 5-5.8c0.2-0.4 0.4-0.8 0.6-1.2 6.4-0.8 11.2-6 11.2-12.6 0-7-5.8-12.8-12.8-12.8-2 0-4 0.6-5.8 1.4-4.2-2.6-10-4.4-17.2-5.8-9-1.6-20-2-32.6-1.4-1.4 0-3 0.2-4.4 0.4s-2.8 0.4-4.2 0.4c-11.2-7.2-25-10.4-39.2-7.8-16.6 3-30 13.6-37.2 27.2-2.8 1.2-5.4 2.2-8 3.4-1.4 0.6-2.8 1.2-4.2 2-12.4 6.2-22.4 12.6-29.2 19-6.6 6-10.4 12-11.2 17.4-0.4 3 0 5.8 1.6 8.2-0 0.8 0.2 1.2 0.4 1.6z"],"grid":0,"tags":["md-ionitron"]},{"paths":["M960 64c0 0-46.8-1.4-118.6 54.2-33.4 25.8-351.6 255.4-351.6 255.4l-337.6-8.4-88.2 78.8 219.6 110.4-17.2 21.6-175.8 0.2-14.4 81 126.2 97.4-53.2 119.6 120-52.8 97.4 126.2 81-14.4 0.2-175.6 21.8-17 110.6 219.4 78.6-88.2-8.4-337.4c0 0 229.8-318 255.6-351.2 55.4-72.2 54-119.2 54-119.2z"],"grid":0,"tags":["md-jet"]},{"paths":["M498.4 448c-28.4-80.4-110.2-144-200.4-144-114.4 0-202 93.6-202 208s91.6 208 206 208c90.2 0 168.2-63.6 196.4-144h205.6v128h138.2v-128h85.8v-128h-429.6zM303.2 581c-38 0-69-31-69-69s31-69 69-69 69 31 69 69-31 69-69 69z"],"grid":0,"tags":["md-key"]},{"paths":["M512 797c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.6-36.4-81.4-81-81.4zM273 64c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM273 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM273 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 227c44.6 0 81-36.6 81-81.4s-36.4-81.6-81-81.6-81 36.6-81 81.4 36.4 81.6 81 81.6zM512 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 552.8c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4c0-44.8-36.4-81.4-81-81.4zM751 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM512 308.4c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4zM512 64c-44.6 0-81 36.6-81 81.4s36.4 81.4 81 81.4 81-36.6 81-81.4-36.4-81.4-81-81.4z"],"grid":0,"tags":["md-keypad"]},{"paths":["M874.668 832c46.938 0 85.332-38.394 85.332-85.332v-533.332c0-46.938-38.394-85.336-85.332-85.336h-725.336c-46.938 0-85.332 38.398-85.332 85.336v533.332c0 46.938 38.394 85.332 85.332 85.332h-149.332c0 46.938 128 64 192 64h640c64 0 192-17.062 192-64h-149.332zM149.332 213.336h725.336v543.996h-725.336v-543.996zM512 869.332c-23.458 0-42.666-19.208-42.666-42.668 0-23.458 19.208-42.664 42.666-42.664s42.666 19.208 42.666 42.664c0 23.46-19.208 42.668-42.666 42.668z"],"grid":0,"tags":["md-laptop"]},{"paths":["M832 575.2c0-333.4-320-511.2-320-511.2s-320 177.8-320 511.2c0 237.6 162.6 281 256 286.4v98.4h128v-98.6c93.4-5.2 256-48.6 256-286.2z"],"grid":0,"tags":["md-leaf"]},{"paths":["M149.2 512c0-76.6 62.2-138.8 138.8-138.8h176v-85.2h-176c-123.6 0-224 100.4-224 224s100.4 224 224 224h176v-85.2h-176c-76.6 0-138.8-62.2-138.8-138.8zM320 556h384v-88h-384v88zM736 288h-176v85.2h176c76.6 0 138.8 62.2 138.8 138.8s-62.2 138.8-138.8 138.8h-176v85.2h176c123.6 0 224-100.4 224-224s-100.4-224-224-224z"],"grid":0,"tags":["md-link"]},{"paths":["M816 128h-608c-44.182 0-80 35.816-80 80v608c0 44.184 35.818 80 80 80h608c44.184 0 80-35.816 80-80v-608c0-44.184-35.816-80-80-80zM608 736h-320v-96h320v96zM736 560h-448v-96h448v96zM736 384h-448v-96h448v96z"],"grid":0,"tags":["md-list-box"]},{"paths":["M160 560h512v96h-512v-96z","M160 368h640v96h-640v-96z","M160 176h704v96h-704v-96z","M160 752h576v96h-576v-96z"],"grid":0,"tags":["md-list"]},{"paths":["M512 352c-88.008 0-160.002 72-160.002 160 0 88.008 71.994 160 160.002 160 88.010 0 159.998-71.992 159.998-160 0-88-71.988-160-159.998-160zM893.876 469.334c-19.21-177.062-162.148-320-339.21-339.198v-66.136h-85.332v66.134c-177.062 19.198-320 162.136-339.208 339.198h-66.126v85.334h66.124c19.208 177.062 162.144 320 339.208 339.208v66.126h85.332v-66.124c177.062-19.208 320-162.146 339.21-339.208h66.126v-85.334h-66.124zM512 810.666c-164.274 0-298.668-134.396-298.668-298.666 0-164.272 134.394-298.666 298.668-298.666 164.27 0 298.664 134.396 298.664 298.666s-134.394 298.666-298.664 298.666z"],"grid":0,"tags":["md-locate"]},{"paths":["M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200v80h-40c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80zM636.004 372h-248.008v-80c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004v80z"],"grid":0,"tags":["md-lock"]},{"paths":["M512 96c-85.8 0-168.4 26-238.4 75-68.4 48-120.4 114.4-150.2 192.2l-7.4 20.8h91.4l3.8-10c16.4-35.6 38.8-67.8 67-96 62.4-62.4 145.4-96.8 233.8-96.8s171.4 34.4 233.8 96.8c62.4 62.4 96.8 145.4 96.8 233.8 0 88.2-34.4 171.4-96.8 233.8s-145.4 96.8-233.8 96.8c-88.2 0-171.2-34.4-233.8-96.8-28-28-50.6-60.2-67-95.8l-3.8-10h-91.4l7.2 20.8c29.8 77.8 81.8 144.2 150.2 192.2 70.2 49.4 152.6 75.2 238.6 75.2 229.4 0 416-186.6 416-416s-186.6-416-416-416z","M96 554.8h379.4l-87.2 89.4 59.8 59.8 192-192-192-192-62 59.8 89.4 89.4h-379.4v85.6z"],"grid":0,"tags":["md-log-in"]},{"paths":["M384 554.8h379.4l-87.2 89.4 59.8 59.8 192-192-192-192-62 59.8 89.4 89.4h-379.4v85.6z","M511.4 842.6c-88.2 0-171-34.4-233.4-96.8s-96.6-145.4-96.6-233.8c0-88.2 34.4-171.4 96.6-233.8 62.4-62.4 145.2-96.8 233.4-96.8 88 0 170.6 34.2 233 96.4l60.6-60.6c-17-16.8-35.6-32.4-55.4-46.4-70.2-48.8-152.4-74.8-238.2-74.8-229 0-415.4 186.6-415.4 416s186.4 416 415.4 416c85.8 0 168-26 238-75 20-14 38.4-29.4 55.4-46.4l-60.4-60.4c-62.2 62.2-145 96.4-233 96.4z","M896.008 513.694l-1.697-1.697 1.697-1.697 1.697 1.697-1.697 1.697z"],"grid":0,"tags":["md-log-out"]},{"paths":["M767.2 197.6c-63-66-151.2-101.2-255.2-101.6-103.8 0.4-192 35.6-255 101.6-63.4 66.4-97 160-97 270.4 0 87 3.6 138.4 25.8 231.6 0 0 45.4 151.4 71 208.2 7 15.6 14.8 23.6 31 18.6 12.8-4 93.6-35.8 109.4-43.2 15.8-7.2 23.2-17.2 17.8-30.4-7.6-18.4-67.8-191.2-67.8-191.2-16.8-72.6-23.2-107.8-23.2-188.6 0-56.4 19.6-108.2 55.4-145.8 35-36.6 82-56.8 132.6-56.8s97.6 20.2 132.6 56.8c35.8 37.6 55.4 89.2 55.4 145.6 0 80-6.4 128-23.4 188.8s-64.4 180.2-67.8 191.2c-3.4 11.2 4.2 25 17.8 30.4s98.6 39.2 109.4 43.2c10.8 4 21.2 1.2 29-15.4 8-16.6 49.2-122.8 73-211.4 24-88.6 26-144.6 26-231.6 0-110.4-33.4-203.8-96.8-270.4zM346.2 839.4l-45.8 19.2c-13.8-32.6-34.4-86.4-51.8-154.4l44-13 53.6 148.2zM723.4 858.6l-45.8-19.2c14.4-33.2 38.2-90.2 53.2-148.2l44 13c-16.8 67.8-37.4 121.8-51.4 154.4z"],"grid":0,"tags":["md-magnet"]},{"paths":["M960 403.334c0-29.866-14.938-57.606-40.542-72.532l-407.458-202.802-407.458 202.802c-23.48 14.926-40.542 42.666-40.542 72.532v407.332c0 46.938 38.394 85.334 85.332 85.334h725.336c46.938 0 85.332-38.396 85.332-85.334v-407.332zM512 608l-342.738-224 342.738-170.666 342.738 170.666-342.738 224z"],"grid":0,"tags":["md-mail-open"]},{"paths":["M874.664 160h-725.328c-46.938 0-85.336 38.396-85.336 85.334v533.332c0 46.938 38.398 85.334 85.336 85.334h725.328c46.938 0 85.336-38.396 85.336-85.334v-533.332c0-46.938-38.398-85.334-85.336-85.334zM864 341.334l-352 234.666-352-234.666v-85.334l352 234.666 352-234.666v85.334z"],"grid":0,"tags":["md-mail"]},{"paths":["M832 96h-256v96h188.2l-213.4 213.2c-47-33.4-104.6-53.2-166.8-53.2-159 0-288 129-288 288s129 288 288 288 288-129 288-288c0-62.2-19.8-119.8-53.2-166.8l213.2-213.4v188.2h96v-352h-96zM384 832c-105.8 0-192-86.2-192-192s86.2-192 192-192 192 86.2 192 192-86.2 192-192 192z"],"grid":0,"tags":["md-male"]},{"paths":["M512 213.2c41.2 0.2 74.6-33.2 74.6-74.6 0-41.2-33.4-74.6-74.6-74.6s-74.6 33.4-74.6 74.6c0 41.2 33.4 74.6 74.6 74.6z","M586.8 230h-149.6c-56.4 0-93.2 49.6-93.2 96.8v227.2c0 44 62 44 62 0v-210h12v571.2c0 60.8 84 58.8 86 0v-329.2h16v329.4c3.4 62.4 86 56.4 86-0.2v-571.2h10v210c0 44 64 44 64 0v-227.2c0-47-37-96.8-93.2-96.8z"],"grid":0,"tags":["md-man"]},{"paths":["M874.666 128c-4.352 0-8.792 2.738-18.352 6.414s-216.314 83.19-216.314 83.19l-256-89.604-241.062 81.062c-8.544 2.146-14.938 10.666-14.938 21.332v644.272c0 12.792 8.542 21.334 21.332 21.334 3.656 0 13.010-4.66 18.174-6.638s216.494-82.968 216.494-82.968l256 89.606 241.062-81.062c8.542-2.146 14.938-10.668 14.938-21.334v-644.272c0-12.79-8.542-21.332-21.334-21.332zM640 810.666l-256-89.604v-507.73l256 89.606v507.728z"],"grid":0,"tags":["md-map"]},{"paths":["M547 304.2h-451l108.2-207.8h481.4z","M685.6 754.4c0 95.656-77.544 173.2-173.2 173.2s-173.2-77.544-173.2-173.2c0-95.656 77.544-173.2 173.2-173.2s173.2 77.544 173.2 173.2z","M697.8 598.2l230.2-294-138.6-207.8-276.6 415.6c64.6 0 125.4 25.4 171 71 5 5 9.6 10 14 15.2z","M411.6 533.2l-107-161.2h-207.8l180.2 323c10.4-42.4 32.2-81.2 64-112.8 20.8-20.6 44.6-37.2 70.6-49z"],"grid":0,"tags":["md-medal"]},{"paths":["M703.8 512l216.2-124.8-96-166.4-216 124.8v-249.6h-192v249.6l-216-124.8-96 166.4 216.2 124.8-216.2 124.8 96 166.4 216-124.8v249.6h192v-249.6l216 124.8 96-166.4z"],"grid":0,"tags":["md-medical"]},{"paths":["M704 288v-79.2c0-44.8-36-80.8-80.8-80.8h-222.4c-44.8 0-80.8 36-80.8 80.8v79.2h-224v527.2c0 44.8 36 80.8 80.8 80.8h670.4c44.8 0 80.8-36 80.8-80.8v-527.2h-224zM400 208h224v80h-224v-80zM672 656h-112v112h-96v-112h-112v-96h112v-112h96v112h112v96z"],"grid":0,"tags":["md-medkit"]},{"paths":["M764.2 286.8l-46.2 46c29.4 29.4 47.8 70.4 47.8 115.2s-18.4 85.8-47.8 115.2l46.2 46.2c41.2-41.2 66.8-98.4 66.8-161.2s-25.6-120.2-66.8-161.4z","M856.4 198l-45.4 45.4c52.2 52.2 84.6 124.8 84.6 204.6 0 79.6-32.2 152.2-84.6 204.6l45.4 45.4c63.8-64.2 103.6-152.6 103.6-250s-39.6-185.8-103.6-250z","M640 368.2v-208.2h-64l-192 160h-256l-64 32v224l64 32 160 256h96l-60-256h60l192 128h64v-208.2c36.8-3.4 64-37.8 64-79.8s-27.2-76.4-64-79.8z"],"grid":0,"tags":["md-megaphone"]},{"paths":["M128 768h768v-85.332h-768v85.332zM128 554.668h768v-85.334h-768v85.334zM128 256v85.33h768v-85.33h-768z"],"grid":0,"tags":["md-menu"]},{"paths":["M735.902 709.308l-361.902-361.226v0.692l-221.776-221.712-48.382 48.082 270.158 269.796v57.632c0 75.58 62.242 137.428 137.82 137.428 17.22 0 33.904-3.24 49.13-9.090l64.778 64.548c-34.666 17.586-73.624 27.72-113.564 27.72-125.972 0-242.73-97.18-242.73-233.18h-77.888c0 154.002 124.454 285.404 274.454 306.028v163.974h92v-163.974c44-6.704 86.132-22.444 123.254-45.244l190.556 190.156 48.066-48-67.694-67.57-116.432-115.918 116.448 115.918-116.296-116.060z","M650 502.572v-301.144c0-75.58-62.418-137.428-138-137.428s-138 61.848-138 137.428v50.488l274.218 273.936c1.34-7.582 1.782-15.358 1.782-23.28z","M832.878 490h-77.882c0 40.992-10.996 79.352-29.862 112.394l55.144 55.032c33.046-48.22 52.6-105.574 52.6-167.426z","M919.998 892.854l-67.794-67.486 67.71 67.57z"],"grid":0,"tags":["md-mic-off"]},{"paths":["M512 640c75.424 0 137.142-61.848 137.142-137.428v-301.144c0-75.58-61.718-137.428-137.142-137.428s-137.142 61.848-137.142 137.428v301.144c0 75.58 61.718 137.428 137.142 137.428zM754.278 489.096c0 137.428-116.564 233.63-242.278 233.63s-242.278-96.204-242.278-233.63h-77.722c0 155.746 123.438 286.306 274.288 306.93v163.974h91.426v-163.974c150.848-22.904 274.286-151.184 274.286-306.93h-77.722z"],"grid":0,"tags":["md-mic"]},{"paths":["M768 224v-55.2c0-58-49-104.8-109.6-104.8h-292.6c-60.8-0-109.8 46.8-109.8 104.8v55.2h304v74h-304v86h304v74h-304v86h304v74h-304v83.6c0 58 49 104.4 109.8 104.4h60.2v154h172v-154h60.4c60.6 0 109.6-46.4 109.6-104.4v-83.6h-112v-74h112v-86h-112v-74h112v-86h-112v-74h112z"],"grid":0,"tags":["md-microphone"]},{"paths":["M390 250c0-52.6 10.6-102.6 29.8-148.2-182.4 44.2-317.8 208.4-317.8 404.2 0 229.6 186.4 416 416 416 195.8 0 360-135.4 404.2-317.8-45.6 19.2-95.8 29.8-148.2 29.8-212 0-384-172-384-384z"],"grid":0,"tags":["md-moon"]},{"paths":["M592 272c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 752c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80zM592 512c0-44.004-35.996-80-80-80s-80 35.996-80 80 35.996 80 80 80 80-35.996 80-80z"],"grid":0,"tags":["md-more"]},{"paths":["M960 512l-192-192v128h-192v-192h128l-192-192-192 192h128v192h-192v-128l-192 192 192 192v-128h192v192h-128l192 192 192-192h-128v-192h192v128z"],"grid":0,"tags":["md-move"]},{"paths":["M512 128v450.2c-25.2-14.6-54.2-23.4-85.4-23.4-94.2 0-170.6 76.4-170.6 170.6s76.4 170.6 170.6 170.6 170.6-76.4 170.6-170.6v-426.8h170.8v-170.6h-256z"],"grid":0,"tags":["md-musical-note"]},{"paths":["M320 128v515.2c-16.4-5.4-34.4-8.2-53.2-8.2-76.6 0-138.8 54.2-138.8 130.8s62.2 130.2 138.8 130.2c76.6 0 139.2-56.4 139.2-138.2v-357.8h404v243.2c-16.4-5.4-34.4-8.2-53.2-8.2-76.6 0-138.8 54.2-138.8 130.8s62.2 130.2 138.8 130.2c76.6 0 139.2-56.4 139.2-138.2v-629.8h-576zM810 320h-404v-106h404v106z"],"grid":0,"tags":["md-musical-notes"]},{"paths":["M512 128l-320 738.124 29.876 29.876 290.124-128 290.124 128 29.876-29.876z"],"grid":0,"tags":["md-navigate"]},{"paths":["M720 512h32v96h-32v-96z","M224 608h259.2l-96-96h-163.2z","M729 120.2c-0.8-0.4-1.4-0.8-2-1.2-21.8-12-45-21.4-68.8-29.6-3.6-1.2-7.2-2.4-10.8-3.6-42.8-13.6-88.2-21.8-135.4-21.8-247.4 0-448 200.6-448 448 0 168.6 93.2 315.2 230.8 391.6 0.8 0.4 1.4 1 2.2 1.4 21.8 12 45 21.4 68.8 29.6 3.6 1.2 7.2 2.4 10.8 3.6 42.8 13.6 88 21.8 135.4 21.8 247.4 0 448-200.6 448-448 0-168.6-93.2-315.4-231-391.8zM512 852.8c-18.6 0-36.8-1.8-54.4-4.8-19.6-3.2-38.6-8.2-57-14.6-3.8-1.2-7.6-2.4-11.2-3.8-13-5-25.8-10.6-38-17.2-107.2-57.4-180.2-170.4-180.2-300.6 0-74.4 24.8-142.8 65.4-198.8l474.4 474.4c-56.2 40.6-124.6 65.4-199 65.4zM787.6 710.8l-474.4-474.4c56-40.4 124.2-65.2 198.8-65.2 18.6 0 36.6 1.8 54.4 4.8 19.6 3.2 38.6 8.2 57 14.6 3.6 1.2 7.4 2.4 11.2 3.8 12.4 4.8 24.4 10 36 16.2 108.4 57 182.4 170.6 182.4 301.6-0.2 74.4-25 142.6-65.4 198.6z","M704 512h-68l68 68z","M768 512h32v96h-32v-96z","M720.2 425.4c-17.6-8.2-44-11.4-91.2-11.4-2.4 0-4.8 0-7.2 0-25.4 0.2-31.8-0.2-40-12.2-5.6-8.4-2-29.6 7.4-43.8 3.2-4.8 3.6-11.2 0.8-16.4s-8.2-8.4-14-8.6c-0.2 0-18.8-0.2-36.6-7.8-21.2-9-31.2-24.2-31.2-46.2 0-51.6 43.6-55.4 45.6-55.4v-32c-24 0-77.6 22-77.6 87.4 0 35 18 62 51.4 76 8.4 3.4 16.8 5.8 24 7.2-6.6 19.6-7.2 41.8 3.4 57.4 18 26.6 40.6 26.4 66.6 26.2 2.2 0 4.6 0 7 0 52.6 0 69.2 4.6 77.8 8.6 11.4 5.2 13.6 15 13.2 31.4 0 1.4 0 0.8 0 2h32c0-0.8 0-0.8 0-2 0-14.2 0.6-45.6-31.4-60.4z","M800 488c0-51.4-6-78.4-18.2-99.2-17.2-28.8-44.8-44.8-77.8-44.8h-34.8c5.8-16.6 10.8-39.6 7-61.8-6.4-37.6-38.2-60-86.2-60v32c42 0 52.2 18.2 54.8 33.4 5 29-13.6 64.2-13.8 64.6-2.8 5-2.6 11 0.2 15.8s8.2 7.8 13.8 7.8h59c21.8 0 38.8 9.8 50.2 29.2 6.2 10.6 13.8 27 13.8 82.8h32v0.2z"],"grid":0,"tags":["md-no-smoking"]},{"paths":["M512 927.312c45.628 0 82.95-37.312 82.95-83.312h-165.9c-0 46 37.322 83.312 82.95 83.312z","M262.166 214.344l0.106 0.148-66.092-65.938-48.172 48.212 126.084 126.306c-20.316 37.97-32.092 81.32-32.092 127.068v229.11l-82 83.312v41.438h595.486l72.364 72.66 48.158-48.602-24.208-24.058h0.632l-590.266-589.656z","M782 450.14c0-127.052-90-235.354-208-262.436v-29.156c0-35.412-26.742-62.486-62-62.486-35.256 0-62 27.074-62 62.486v29.156c-30 6.876-58.096 19.002-83.5 35.326l415.5 415.68v-188.57z"],"grid":0,"tags":["md-notifications-off"]},{"paths":["M514 240.942c14.166 0 47.822 8.958 47.822 8.958 91.178 20.894 155.356 104.878 155.356 199.7v255.224l34.218 34.374h-478.792l34.218-34.374v-255.224c0-94.82 64.178-178.806 155.356-199.7 0 0 36.086-8.958 47.822-8.958zM512 96c-35.204 0-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4v0zM594.822 844.8h-165.646c0 45.762 37.266 83.2 82.824 83.2s82.822-37.438 82.822-83.2v0z"],"grid":0,"tags":["md-notifications-outline"]},{"paths":["M512 928c45.558 0 82.822-37.438 82.822-83.2h-165.646c-0 45.762 37.266 83.2 82.824 83.2zM781.178 678.4v-228.8c0-126.88-89.032-235.036-207.060-262.082v-29.118c0-35.364-26.914-62.4-62.118-62.4s-62.118 27.036-62.118 62.4v29.118c-118.030 27.046-207.060 135.202-207.060 262.082v228.8l-82.822 83.2v41.6h704v-41.6l-82.822-83.2z"],"grid":0,"tags":["md-notifications"]},{"paths":["M672 544c0-59.6-32.6-111.4-80.8-139l146.2-248.2c-66.2-38.6-143.2-60.8-225.4-60.8-82.4 0-159.8 22.4-226.2 61.2l143.2 250c-46.2 28-77 78.8-77 136.8h-288c0 166.6 93.8 306.8 228.8 384l140.2-244.8c23.4 13.2 50.2 20.8 79 20.8 28.6 0 55.4-7.6 78.6-20.6l140.6 244.6c135-77.2 228.8-217.4 228.8-384h-288z"],"grid":0,"tags":["md-nuclear"]},{"paths":["M714.4 471.2l-165-165.2h-1.6c-16.2-12-36.4-20.6-56.8-20.6-27.4 0-52.2 12.6-68.6 32.6h-1.2l-315.2 510.2v1.6c-6 12.4-10 26.6-10 41.6 0 48.8 39.4 88.6 88.6 88.6 18.8 0 36-5.8 54.8-18.2l465.8-336.2c21.8-16.6 34.8-43.2 34.8-72 0-24-9.4-46.4-25.6-62.4z","M928 290.2l-58.4-98-73.2 40.6 63-111.8-98.2-57-134.6 255.6 82.6 82.8z"],"grid":0,"tags":["md-nutrition"]},{"paths":["M810.68 810.664h-597.36v-597.328h266.68v-85.336h-266.68c-46.938 0-85.32 38.394-85.32 85.336v597.328c0 46.942 38.382 85.336 85.32 85.336h597.36c46.938 0 85.32-38.394 85.32-85.336v-266.664h-85.32v266.664zM576 128v85.336h174.948l-430.95 430.93 59.732 59.732 430.952-430.94v174.942h85.318v-320h-320z"],"grid":0,"tags":["md-open"]},{"paths":["M64 768h544v64h-544v-64z","M800 768h160v64h-160v-64z","M768 895c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z","M64 480h160v64h-160v-64z","M416 480h544v64h-544v-64z","M384 607c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z","M64 192h544v64h-544v-64z","M800 192h160v64h-160v-64z","M768 319c0 35.898-28.654 65-64 65v0c-35.346 0-64-29.102-64-65v-190c0-35.898 28.654-65 64-65v0c35.346 0 64 29.102 64 65v190z"],"grid":0,"tags":["md-options"]},{"paths":["M739 64h-454.2c-121.8 0-220.8 101.2-220.8 225.2v445.6c0 124 99 225.2 220.8 225.2h454.4c121.8 0 221-101.2 221-225.2v-445.6c-0.2-124-99.2-225.2-221.2-225.2zM350 502v1.4c0 21.8-18.2 40.8-39.8 40.8h-46.6c-21.6 0-39.8-19-39.8-40.8v-207.2c2-21.6 18.4-40.4 39.8-40.4h46.6c21.8 0 39.8 19.6 39.8 41.6v204.6zM594 796.8c0 22.8-17.8 35.2-40.2 35.2h-83.6c-22.4 0-40.2-16.2-40.2-39.2v-58.6c0-46.6 36.2-84.6 82-84.6s82 38 82 84.6v62.6zM800 502v1.4c0 21.8-18.2 40.8-39.8 40.8h-48.6c-21.6 0-39.8-19-39.8-40.8v-207.2c2-21.6 18.4-40.4 39.8-40.4h48.6c21.6 0 39.8 19.6 39.8 41.6v204.6z"],"grid":0,"tags":["md-outlet"]},{"paths":["M96 541.8l237.8 89.2 29.6 297 148.6-208 208 208 208-832-832 445.8zM685.8 793.8l-165.8-167 229.8-322.8-362.6 275.6-137.4-49.6 582-312.4-146 576.2z"],"grid":0,"tags":["md-paper-plane"]},{"paths":["M928 128h-544c-17.6 0-32 15.4-32 33v63h-204c-46.2 0-84 37.8-84 84v415c0 95.2 78 173 172 173h559.4c90.2 0 164.6-73.8 164.6-164v-572c0-17.6-14.4-32-32-32zM352 288v384h-84v-345.6c0-13.6-1.6-26.6-6.6-38.4h90.6zM318 798.8c-22 21.2-51.6 33.2-81 33.2-29 0-56.2-11.4-77-32-20.6-20.6-32-48-32-77v-396.6c0-21.2 16.8-38.4 38-38.4s38 17.2 38 38.4v377.6c0 17.6 14.4 32 32 32h115c-3 23.2-14.4 45.2-33 62.8zM896 732c0 26.6-10.8 51.6-29.8 70.6s-44.4 29.4-70.8 29.4h-420.8c25.6-29.8 41.4-67.8 41.4-109v-529h480v538z","M496 272h320v112h-320v-112z","M496 448h320v64h-320v-64z","M496 576h320v64h-320v-64z","M816 704h-320c0 0 0 64-16 64 14 0 277.2 0 297.4 0 38.6 0 38.6-42 38.6-64z"],"grid":0,"tags":["md-paper"]},{"paths":["M496.062 233.62l49.356-49.356 38.466 38.466-49.356 49.356-38.466-38.466z","M352 251.4c-90.6 0-164.6 74-164.6 164.6 0 35 11 67.4 29.8 94 30.6-26 67.8-45.2 109.4-55.2l26.4-33.2c27.2-34.2 61.4-60.4 101.6-77.8 12.2-5.2 24.8-9.6 38-13.2-29-47.4-81.2-79.2-140.6-79.2z","M324 128h56v82h-56v-82z","M64 388h82v56h-82v-56z","M163.2 553.6l-1.6-1.6-49.4 49.4 38.4 38.4 49.4-49.4z","M158.578 184.26l49.356 49.356-38.466 38.466-49.356-49.356 38.466-38.466z","M811.2 577.2c-21.8-110.4-118.8-193.2-235.2-193.2-68 0-130.2 23.8-173 77.6 58.8 4.4 113.4 26 155.6 67.8 31.2 31.2 53.2 69.2 64.2 110.6h-57.4c-26.2-74.6-96-128-181.2-128-10.2 0-24.6 1.2-35.4 3.4-91.6 18.8-156.8 94.6-156.8 188.6 0 106 86 192 192 192h416c88.4 0 160-71.6 160-160 0-84.4-65.6-153-148.8-158.8z"],"grid":0,"tags":["md-partly-sunny"]},{"paths":["M192 896h213.4v-768h-213.4v768zM618.6 128v768h213.4v-768h-213.4z"],"grid":0,"tags":["md-pause"]},{"paths":["M919 381c-9.4-25.4-25.4-43.8-46.2-53.2-9.6-4.2-19.4-6.4-29.6-6.4-43.4 0-87.4 40.4-109.8 100.6-27.6 74.6-11.6 147.6 37.2 170 9.8 4.4 20.2 6.8 31.2 6.8 44.2 0 89.2-37 111.8-92.2 17-42 19-88.8 5.4-125.6z","M290.6 422c-22.2-60.2-66.4-100.6-109.8-100.6-10.2 0-20.2 2.2-29.6 6.4-20.8 9.4-36.6 27.8-46.2 53.2-13.8 36.8-11.8 83.6 5.4 125.4 22.6 55.2 67.6 92.2 111.8 92.2 10.8 0 21.4-2.2 31.2-6.8 48.8-22.2 64.8-95.2 37.2-169.8z","M387 413.6c4 0.2 8 0 12-0.4 23.4-2.2 44.6-14.2 61.2-34.6 26.8-33 34.2-84.4 28.6-137.4-8.6-81.6-51.6-142.6-109.6-145.2 0 0-8.2 0-12.4 0.4-25.6 2.6-48.8 15.8-67 38.4-26.6 32.8-39.4 81.4-34.2 130.2 8.6 80.8 61.8 146 121.4 148.6z","M512 477.4c-138.6 0-277.4 164.8-277.4 323.2 0 47.2 23.6 85.2 47 100.8 28.8 19.2 49 26.8 91 26.8 50 0 63.6-17.6 87-33 17-11.2 31.6-20.8 52.4-20.8s35.4 9.6 52.4 20.8c23.4 15.4 37 33 87 33 42.2 0 62.4-7.6 91-26.8 23.2-15.6 47-53.6 47-100.8 0-158.4-138.8-323.2-277.4-323.2z","M625.2 413c4 0.4 8 0.6 12 0.4 59.6-2.6 113-67.8 121.6-148.6 5.2-48.8-7.6-97.6-34.2-130.2-18.4-22.6-40.6-35.2-66.2-37.6-4.2-0.4-13.4-0.6-13.4-0.6-57.8 2.6-100.8 63-109.6 144.8-5.6 53 1.8 104.6 28.6 137.4 16.8 20 38 32 61.2 34.4z"],"grid":0,"tags":["md-paw"]},{"paths":["M674.908 464c67.198 0 122.184-54.004 122.184-120 0-65.994-54.986-120-122.184-120s-122.18 54.006-122.18 120c-0 65.996 54.982 120 122.18 120zM349.092 464c67.198 0 122.18-54.004 122.18-120 0-65.994-54.982-120-122.18-120s-122.184 54.006-122.184 120c0 65.996 54.986 120 122.184 120zM349.092 552c-95.716 0-285.092 45.996-285.092 140v108h576v-108c0-94.004-195.198-140-290.908-140zM674.908 574.006c-12.21 0-20.65 0-34.908 1.994 46.852 34.004 64 56 64 116v108h256v-108c0-94.004-189.376-117.994-285.092-117.994z"],"grid":0,"tags":["md-people"]},{"paths":["M608 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM608 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z","M224 448v-128h-64v128h-128v64h128v128h64v-128h128v-64h-128z"],"grid":0,"tags":["md-person-add"]},{"paths":["M512 512c105.61 0 192-86.402 192-192s-86.39-192-192-192-192 86.402-192 192 86.39 192 192 192zM512 608c-127.196 0-384 64.804-384 192v96h768v-96c0-127.196-256.804-192-384-192z"],"grid":0,"tags":["md-person"]},{"paths":["M960 717.712v-411.426c0-45.262-36.652-82.286-81.456-82.286h-733.088c-44.804 0-81.456 37.024-81.456 82.286v411.426c0 45.264 36.652 82.288 81.456 82.288h733.090c44.802 0 81.454-37.024 81.454-82.288zM224 728v-432h576v432h-576z"],"grid":0,"tags":["md-phone-landscape"]},{"paths":["M717.712 64h-411.426c-45.262 0-82.286 36.652-82.286 81.456v733.090c0 44.802 37.024 81.454 82.286 81.454h411.426c45.264 0 82.288-36.652 82.288-81.456v-733.088c0-44.804-37.024-81.456-82.288-81.456zM728 800h-432v-576h432v576z"],"grid":0,"tags":["md-phone-portrait"]},{"paths":["M800 842.6v-533.2c0-47-38.4-85.4-85.4-85.4h-533.2c-47 0-85.4 38.4-85.4 85.4v533.4c0 47 38.4 85.4 85.4 85.4h533.4c46.8-0.2 85.2-38.6 85.2-85.6zM314.6 608l90.6 128 133.4-192 176 256h-533.2l133.2-192z","M842.6 96h-533.2c-47 0-85.4 38.4-85.4 85.4v10.6h522.6c47 0 85.4 38.4 85.4 85.4v522.6h10.6c47 0 85.4-38.4 85.4-85.4v-533.2c0-47-38.4-85.4-85.4-85.4z"],"grid":0,"tags":["md-photos"]},{"paths":["M65.2 512h446.8v-446.8c-10-0.8-21.2-1.2-32-1.2-229.8 0-416 186.2-416 416 0 10.8 0.4 22 1.2 32z","M219.6 804.4c76.2 94.8 193.2 155.6 324.4 155.6 229.8 0 416-186.2 416-416 0-131.2-60.8-248.2-155.6-324.4-63.4-51-142.4-83.8-228.4-90.4v446.8h-446.8c6.6 86 39.4 165 90.4 228.4z"],"grid":0,"tags":["md-pie"]},{"paths":["M512 64c-176.008 0-320 141.114-320 313.602 0 235.198 320 582.398 320 582.398s320-347.2 320-582.398c0-172.488-143.992-313.602-320-313.602zM512 489.602c-63.992 0-114.288-49.29-114.288-112 0-62.714 50.294-112 114.288-112s114.288 49.286 114.288 112c0 62.71-50.296 112-114.288 112z"],"grid":0,"tags":["md-pin"]},{"paths":["M128 96l85.8 758.4c5.2 41.6 41 73.6 85 73.6h426.6c44 0 79.8-32 85-73.6l85.6-758.4h-768zM782 345.6h-540l-18.8-166.4h577.2l-18.4 166.4z"],"grid":0,"tags":["md-pint"]},{"paths":["M814.4 260.8c-93-37.8-194.8-56.8-302.4-56.8-107.8 0-216.6 20.6-302.4 56-16.2 6.6-30.6 18-20.2 39s322.4 661 322.4 661l322-659.8c6.4-13.8 1.8-30.8-19.4-39.4zM372.4 408c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64zM512 694c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64zM651.6 448c-37.4 0-64-28.6-64-64s26.6-64 64-64c37.4 0 64 28.6 64 64s-26.6 64-64 64z","M873.8 132c-104.4-41.2-233.2-68-361.8-68s-255.2 24.2-361.8 66.8c-9.4 3.8-22.2 11.2-22.2 27.6l19.4 48.2c5.6 9.8 17.4 16.4 30.2 16.4 3.6 0 8.6-0.6 14.6-3 98-37.8 206.2-59.2 320-59.2s230.4 23.2 320 59.2c7.2 2.8 11.2 3 14.6 3 13.2 0 24.4-6.6 30-16.2l19.6-48.2c-0.4-14.6-10-21.6-22.6-26.6z"],"grid":0,"tags":["md-pizza"]},{"paths":["M896 672v-80l-320-208v-225.6c0-35.366-29.64-62.4-64-62.4-34.358 0-64 27.036-64 62.4v225.6l-320 208v80l320-96v227.204l-96 62.398v62.398l160-32 160 32v-62.398l-96-62.398v-227.204l320 96z"],"grid":0,"tags":["md-plane"]},{"paths":["M271.4 302c-5 6-9.8 12-14.4 18.4 64.4 72.6 152.2 153 248.4 227.4 75.6 58.4 152.6 110.4 222.8 150.2 11.8 6.6 23.4 13 34.6 18.8 5-6 9.8-12 14.4-18.4 23.4-32.2 36.2-66.4 46.6-107.2 1.6-6.4 3-12.8 4.2-19 31.6-166-71.2-329.8-237-371.8-74-18.8-148.2-10.2-212.6 19.4-42.8 19.8-76.4 45.8-107 82.2z","M836.4 653.6c-8.2 22-14.8 35-14.8 35 36.4 42.2 49.2 67.8 63.8 92.8 4.8 8.2 14.8 26.2 1.8 24.8-3.4-0.6-7-1.4-11-2.6-42.6-10.8-102.4-37.4-168.6-74.8-71.6-40.6-149.8-93.4-226.6-152.6-102.2-79-195-164.6-261.2-241-30.6-35.2-55.2-68.4-71.4-95.8-4.8-8.2-7.8-12.6-11.2-20.8-5-12.4 10-10.2 14-9.2 29.8 7.6 70 19.8 116.4 47.6 0 0 8.6-9.6 27.8-22.8-45.6-30.8-89.2-55.4-130.4-71-46.2-17.6-82.2-13.6-95 7.4-24.4 39.8 28 144.6 130.6 264-43 172 61.2 346.6 233 390 82.2 20.8 164.8 7.8 233.6-30 76.2 35.2 144.2 57.2 193.8 69.8 47.8 12.2 80.8 11 93.6-9.8 22.2-36.4-24.2-103.6-118.2-201z"],"grid":0,"tags":["md-planet"]},{"paths":["M192 104v816l640-408-640-408z"],"grid":0,"tags":["md-play"]},{"paths":["M64 448h256v384h-256v-384z","M384 256h256v576h-256v-576z","M704 576h256v256h-256v-256z"],"grid":0,"tags":["md-podium"]},{"paths":["M558.2 96h-92.4v462.2h92.4v-462.2zM781.4 196.4l-65.6 65.6c73 58.8 119.8 148.8 119.8 250 0 178.8-144.6 323.6-323.6 323.6s-323.6-144.8-323.6-323.6c0-101.2 46.6-191.4 119.2-250.6l-65.2-65.2c-89.6 76.4-146.4 189.2-146.4 315.8 0 229.8 186.2 416 416 416s416-186.2 416-416c0-126.6-56.8-239.4-146.6-315.6z"],"grid":0,"tags":["md-power"]},{"paths":["M832 128h-316.8l-362.2 375.2c-16 16-24.6 37-25 58-0.6 22.6 7.8 45.2 25 62.4l247.4 247.2c16 16 41.6 25 57.6 25s45.6-7.8 62.8-25l375.2-358.8v-320l-64-64zM770.6 333.4c-43.4 12.2-82.6-20-82.6-61.4 0-35.4 28.6-64 64-64 41.4 0 73.6 39.2 61.4 82.6-5.8 20.6-22.2 37-42.8 42.8z"],"grid":0,"tags":["md-pricetag"]},{"paths":["M884 214v282l-425.6 407.4c16 16 41.6 24.6 57.6 24.6s45.6-7.4 62.8-24.6l381.2-359.4v-256l-76-74z","M768 96h-320l-359.4 375.2c-16 16-24 35.6-24.6 56.8-0.6 22.6 7.4 46.6 24.6 63.8l247.6 247.2c16 16 41.6 25 57.6 25s45.4-7.8 62.6-25l375.6-359v-320l-64-64zM706.6 301.4c-43.4 12.2-82.6-20-82.6-61.4 0-35.4 28.6-64 64-64 41.4 0 73.6 39.2 61.4 82.6-5.8 20.6-22.2 37-42.8 42.8z"],"grid":0,"tags":["md-pricetags"]},{"paths":["M799.9 320h-575.8c-70.452 0-128.1 57.606-128.1 128v277.334h159.798v170.666h512.402v-170.666h159.8v-277.334c0-70.394-57.65-128-128.1-128zM704 832h-384v-256h384v256zM768.202 128h-512.404v160h512.402v-160z"],"grid":0,"tags":["md-print"]},{"paths":["M856 538c-43 0-81.2 26.2-96.8 66h-82.4l-62.8-161.4c-5.4-16.4-20.6-27.4-38-27.4-0.4 0-0.6 0-0.8 0-17.6 0.4-32.8 12-37.6 29l-67.2 270.8-111-583.6c-3.4-20.2-20.2-35.4-39.4-35.4-19 0-33.8 12.4-38.8 32.4l-100.6 475.6h-116.6v80h148c18.4 0 34.4-12.4 38.8-30.4l61.4-321.2 108.2 564.2c3 17.6 17.8 30.2 37.2 31.4 0.8 0 1.6 0 2.4 0 18.6 0 33.8-10.6 38.4-27l80.4-325.8 31 81.4c5.4 16.4 20.6 27.4 38 27.4h112.8c16.6 38 54.2 62 95.2 62 27.8 0 53.8-11.2 73.6-31.6 19.6-20.2 30.4-46.6 30.4-74.4 0.2-57.2-45.4-102-103.8-102z"],"grid":0,"tags":["md-pulse"]},{"paths":["M192 248.4c0-13.8 10.4-24.4 24.4-24.4h135.6v-96h-133.6c-67 0-122.4 53.4-122.4 120.4v135.6h96v-135.6z","M807.2 128h-135.2v96h134.4c13.8 0 25.6 10.4 25.6 24.4v135.6h96v-135.6c0-67-54-120.4-120.8-120.4z","M832 773.6c0 13.8-10.4 24.4-24.4 24.4h-135.6v98h135.6c67 0 120.4-55.4 120.4-122.4v-133.6h-96v133.6z","M216.4 798c-13.8 0-24.4-10.4-24.4-24.4v-133.6h-96v133.6c0 67 55.4 122.4 122.4 122.4h133.6v-98h-135.6z"],"grid":0,"tags":["md-qr-scanner"]},{"paths":["M192.8 832h154.2l101.8-193.2v-446.8h-320v446.8h154.2l-90.2 193.2zM640.8 832h154.2l100-193.2v-446.8h-318.2v446.8h164l-100 193.2z"],"grid":0,"tags":["md-quote"]},{"paths":["M512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.798c-183.036 0-332.798-149.764-332.798-332.798s149.762-332.8 332.798-332.8 332.8 149.764 332.8 332.8-149.764 332.798-332.8 332.798z"],"grid":0,"tags":["md-radio-button-off"]},{"paths":["M512 304c-114.4 0-208 93.6-208 208s93.6 208 208 208 208-93.6 208-208-93.6-208-208-208zM512 96c-228.798 0-416 187.202-416 416s187.202 416 416 416 416-187.202 416-416-187.202-416-416-416zM512 844.8c-183.036 0-332.8-149.766-332.8-332.8s149.764-332.8 332.8-332.8 332.8 149.764 332.8 332.8-149.764 332.8-332.8 332.8z"],"grid":0,"tags":["md-radio-button-on"]},{"paths":["M147.6 283.8c-30.4 12-51.6 43.6-51.6 79v512c0 47 37 85.4 83.2 85.4h665.6c46.2 0 83.2-38.4 83.2-85.4v-512c0-47.4-37-85.4-83.2-85.4h-486.8l343.6-142.6-28.2-70.8-525.8 219.8zM320 876c-70.8 0-128-57.2-128-128s57.2-128 128-128 128 57.2 128 128-57.2 128-128 128zM832 533.4h-64v-92.4h-89.6v92.4h-486.4v-170.6h640v170.6z"],"grid":0,"tags":["md-radio"]},{"paths":["M278 800c0 0-46 50.6-46 81.4 0 25.6 20.6 46.6 46 46.6s46-21 46-46.6c0-30.8-46-81.4-46-81.4z","M434 736c0 0-46 50.6-46 81.4 0 25.6 20.8 46.6 46 46.6 25.4 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z","M590 800c0 0-46 50.6-46 81.4 0 25.6 20.6 46.6 46 46.6 25.2 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z","M746 736c0 0-46 50.6-46 81.4 0 25.6 20.8 46.6 46 46.6 25.4 0 46-21 46-46.6 0-30.8-46-81.4-46-81.4z","M786.4 322.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 94.8 233 218.4 233h485.4c103 0 192.4-92 192.4-195.6-0.2-98.8-76.8-179.2-173.8-186z"],"grid":0,"tags":["md-rainy"]},{"paths":["M739.6 320c-106.8 0-192.4 85.6-192.4 192 0 47.2 15.8 89 43.8 122.2h-157.6c28-33.2 43.8-75 43.8-122.2 0-106.4-85.8-192-192.4-192s-192.8 85.6-192.8 192 85.8 192 192.4 192h455c106.8 0 192.4-85.6 192.4-192s-85.6-192-192.2-192zM284.4 634.2c-68.2 0-122.4-54.2-122.4-122.2s54.2-122.2 122.4-122.2 122.4 54.2 122.4 122.2-54 122.2-122.4 122.2zM739.6 634.2c-68.2 0-122.4-54.2-122.4-122.2s54.2-122.2 122.4-122.2 122.4 54.2 122.4 122.2-54.2 122.2-122.4 122.2z"],"grid":0,"tags":["md-recording"]},{"paths":["M64 674.4l103.6 29.6c45.8-139.4 177.4-235.6 332-235.6 85.6 0 163 31.4 223.6 82.2l-158.2 153.4h395v-384l-159.2 152.6c-80.8-70.4-185.6-113.6-301.4-113.6-203 0.2-374.6 132.4-435.4 315.4z"],"grid":0,"tags":["md-redo"]},{"paths":["M512 96c-228.8 0-416 187.2-416 416s187.2 416 416 416 416-187.2 416-416-187.2-416-416-416zM736 484h-196l89.6-89.6c-29.4-30.8-71.4-50.4-117.6-50.4-92.4 0-168 75.6-168 168s75.6 168 168 168c69.8 0 130.6-42.4 155.2-104h59.6c-27.8 92.6-112.6 160-214.8 160-124.6 0-224-100.8-224-224s100.8-224 224-224c61.6 0 117.6 25.2 158.2 65.8l65.8-65.8v196z"],"grid":0,"tags":["md-refresh-circle"]},{"paths":["M512 776c-145.194 0-264-118.81-264-264 0-145.202 118.806-264 264-264 72.6 0 138.598 30.8 184.812 79.202l-140.812 140.798h308v-308l-103.396 103.404c-63.792-63.808-151.792-103.404-248.604-103.404-193.594 0-352 158.406-352 352s156.188 352 352 352c162.090 0 296.574-108.268 338.802-256h-93.102c-37.49 99.122-134.276 168-245.7 168z"],"grid":0,"tags":["md-refresh"]},{"paths":["M512 96c-229.75 0-416 186.25-416 416s186.25 416 416 416 416-186.25 416-416-186.25-416-416-416zM726 554h-428v-84h428v84z"],"grid":0,"tags":["md-remove-circle"]},{"paths":["M192 470h640v84h-640v-84z"],"grid":0,"tags":["md-remove"]},{"paths":["M192 696h640v72h-640v-72z","M192 256h640v72h-640v-72z","M192 401.4h640v71.2h-640v-71.2z","M192 551.6h640v71.2h-640v-71.2z"],"grid":0,"tags":["md-reorder"]},{"paths":["M298.6 304h426.6v124.8l170.6-166.4-170.4-166.4v124.8h-512v249.6h85.4v-166.4zM725.4 720h-426.8v-124.8l-170.6 166.4 170.6 166.4v-124.8h512v-249.6h-85.4v166.4z"],"grid":0,"tags":["md-repeat"]},{"paths":["M595.2 96l129.8 129.8-499.2 499.2-129.8-129.8v332.8h332.8l-129.8-129.8 499.2-499.2 129.8 129.8v-332.8z"],"grid":0,"tags":["md-resize"]},{"paths":["M329.704 559.878l123.668-120.502-305.932-295.964c-67.252 65.528-67.252 173.354 0 238.88l182.264 177.586z","M624.778 483.76c67.272 29.604 160.566 8.464 227.82-59.186 82.444-80.33 99.818-196.606 34.726-257.92-62.93-63.42-182.262-46.49-264.708 33.842-69.436 67.65-91.132 158.552-60.748 221.972-95.478 95.136-423.104 414.346-423.104 414.346l60.754 59.186 299.42-291.732 299.416 291.732 60.748-59.186-299.418-291.738 65.094-61.316z"],"grid":0,"tags":["md-restaurant"]},{"paths":["M865.6 272v192h-621l168.8-172.4-66.4-67.6-283 288 283 288 66.4-67.6-168.8-172.4h715.4v-288h-94.4z"],"grid":0,"tags":["md-return-left"]},{"paths":["M64 272v288h715.4l-168.8 172.4 66.4 67.6 283-288-283-288-66.4 67.6 168.8 172.4h-621v-192h-94.4z"],"grid":0,"tags":["md-return-right"]},{"paths":["M880 192h-176l-64-64h-256l-64 64h-176c-44.2 0-80 35.8-80 80v544c0 44.2 35.8 80 80 80h736c44.2 0 80-35.8 80-80v-544c0-44.2-35.8-80-80-80zM736 534h-195.4l89.6-90.2c-29.4-30.8-71.4-51-117.6-51-92.4 0-168 75.6-168 168s75.6 168 168 168c71 0 132.4-43 156.4-107h59.2c-26.8 94-112.4 163-215.6 163-124.6 0-224-100.8-224-224s100.8-224 224-224c61.6 0 117.4 25.2 158 65.8l65.6-65.8v197.2z"],"grid":0,"tags":["md-reverse-camera"]},{"paths":["M499.2 804v-584l-435.2 292 435.2 292zM524.8 512l435.2 292v-584l-435.2 292z"],"grid":0,"tags":["md-rewind"]},{"paths":["M512 64c-141.4 0-256 114.6-256 256s114.6 256 256 256 256-114.6 256-256-114.6-256-256-256zM512 480c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z","M387.4 614.8c-38.2-16.2-72.4-39.2-101.6-68.6-2.8-2.8-5.6-5.6-8.2-8.6l-149.6 262.4h192l96 160 147-324c-16.8 2.6-33.8 4-51 4-43.2 0-85-8.4-124.6-25.2z","M746.6 537.8c-2.6 2.8-5.4 5.8-8.2 8.6-29.2 29.2-63.4 52.4-101.4 68.4l-49 107.6-43.8 96.8 63.8 140.8 96-160h192l-149.4-262.2z"],"grid":0,"tags":["md-ribbon"]},{"paths":["M521.2 429.6c47.6-81.8 96-143.2 182.8-192.8 16.6-9.6 42.4-16 45.6-17.8-168.2-51.6-237.6-155-237.6-155s-69.4 103.4-241 153c11.6 6.8 33 13 61.4 27.4 69 34.8 125 102.6 188.8 185.2z","M492.6 506.8c-119.2-184.4-229.8-253.2-396.6-253.2 108.4 157.2 104 349.2 104 430.8 0 152.2 139.6 275.6 312 275.6 115.2 0 215.8-55.2 270-137.4-71-55.2-170.2-131.4-289.4-315.8z","M928 253.6c0 0-110.4-4.6-170.4 30.8-86 51-148.8 122.6-190.8 206.4 77.6 104 146 175.8 190.8 218.8 21.4 20.4 39.6 36.4 55 49 7.4-23.6 11.6-48.6 11.6-74.4-0.2-81.6-34.8-228.2 103.8-430.6z"],"grid":0,"tags":["md-rose"]},{"paths":["M512 576c-90.886 0-167.35 52.152-204.41 128h408.82c-37.060-75.848-113.524-128-204.41-128z","M512 96c-230.874 0-416 187.2-416 416s185.126 416 416 416 416-187.2 416-416c0-228.8-187.198-416-416-416zM512 844.8c-183.036 0-332.808-149.766-332.808-332.8 0-183.036 149.774-332.8 332.808-332.8s332.808 149.764 332.808 332.8c0 183.036-149.772 332.8-332.808 332.8z","M657.6 470.4c35.366 0 62.402-27.036 62.402-62.4s-27.038-62.4-62.402-62.4c-35.364 0-62.4 27.036-62.4 62.4s27.036 62.4 62.4 62.4z","M366.4 470.4c35.364 0 62.4-27.036 62.4-62.4s-27.038-62.4-62.4-62.4c-35.366 0-62.402 27.036-62.402 62.4s27.038 62.4 62.402 62.4z"],"grid":0,"tags":["md-sad"]},{"paths":["M227 562.4v170.6l285 163 285-163v-170.6l-285 163-285-163zM512 128l-448 256 448 256 366.6-209.4v294.8h81.4v-341.4l-448-256z"],"grid":0,"tags":["md-school"]},{"paths":["M675.018 610.744h-35.002l-13.142-10.972c41.582-50.464 67.844-114.108 67.844-186.514-0.002-157.994-126.926-285.258-284.448-285.258-155.366 0-282.27 127.264-282.27 285.258s126.904 285.256 284.45 285.256c70.022 0 135.662-26.334 185.982-68.016l13.122 10.974v35.102l218.806 219.426 65.64-65.828-220.982-219.428zM412.45 610.744c-109.404 0-196.926-87.774-196.926-197.486 0-109.716 87.522-197.484 196.926-197.484 109.4 0 196.924 87.768 196.924 197.484 0 109.712-87.524 197.486-196.924 197.486z"],"grid":0,"tags":["md-search"]},{"paths":["M96 896l832-384-832-384v298.666l596 85.334-596 85.334z"],"grid":0,"tags":["md-send"]},{"paths":["M827.934 553.6c2.12-12.47 2.12-27.036 2.12-41.6s-2.12-27.036-2.12-41.6l89.334-68.636c8.52-6.236 10.638-16.634 4.26-27.036l-85.098-143.528c-4.258-8.328-17.014-12.47-25.534-8.328l-106.372 41.602c-21.276-16.636-46.788-31.202-72.32-41.602l-14.896-110.234c-2.12-8.308-10.638-16.636-21.276-16.636h-170.196c-10.636 0-19.154 8.328-21.274 16.636l-17.016 110.234c-25.534 10.4-48.928 24.964-72.342 41.602l-106.372-41.602c-10.638-4.142-21.276 0-25.534 8.328l-85.098 143.53c-4.238 8.306-2.122 20.798 4.258 27.036l91.482 68.634c0 14.564-2.12 27.036-2.12 41.6s2.12 27.036 2.12 41.6l-89.336 68.636c-8.52 6.236-10.636 16.634-4.26 27.036l85.098 143.528c4.26 8.328 17.016 12.47 25.534 8.328l106.374-41.602c21.274 16.636 46.788 31.202 72.32 41.602l17.016 110.234c2.138 10.4 10.636 16.636 21.274 16.636h170.196c10.638 0 19.156-8.328 21.276-16.636l17.036-110.234c25.514-10.4 48.928-24.964 72.32-41.602l106.374 41.602c10.636 4.142 21.274 0 25.534-8.328l85.098-143.53c4.258-8.306 2.12-20.798-4.26-27.036l-93.6-68.634zM510.936 657.6c-82.978 0-148.92-64.47-148.92-145.6s65.942-145.6 148.92-145.6 148.922 64.47 148.922 145.6-65.944 145.6-148.922 145.6z"],"grid":0,"tags":["md-settings"]},{"paths":["M896 496l-320-304v170.668c-298.668 42.666-405.334 256-448 469.332 106.666-149.332 234.666-217.604 448-217.604v174.938l320-293.334z"],"grid":0,"tags":["md-share-alt"]},{"paths":["M767.644 688.854c-32.090 0-62.048 10.652-83.442 31.958l-305.914-176.84c2.142-10.656 4.284-19.186 4.284-29.838 0-10.656-2.142-19.186-4.284-29.838l301.652-174.7c23.524 21.306 53.482 34.082 87.704 34.082 70.59 0 128.356-57.532 128.356-127.84 0-70.304-57.766-127.838-128.356-127.838-70.594 0-128.358 57.534-128.358 127.84 0 10.654 2.13 19.186 4.284 29.838l-301.642 174.7c-23.534-21.308-53.482-34.082-87.712-34.082-70.592 0-126.216 57.532-126.216 127.84 0 70.306 57.754 127.84 128.356 127.84 34.23 0 64.178-12.778 87.712-34.084l303.782 176.842c-2.152 8.51-4.282 17.042-4.282 27.694 0 68.188 55.612 123.574 124.074 123.574 68.458 0 124.072-55.386 124.072-123.574 0.002-68.188-55.61-123.574-124.070-123.574z"],"grid":0,"tags":["md-share"]},{"paths":["M640 128c-22.2 38.2-80.6 64-128 64s-105.8-25.8-128-64l-256 64v192l154-32-26 544h512l-26-544 154 32v-192l-256-64z"],"grid":0,"tags":["md-shirt"]},{"paths":["M444.4 376.2l-248.8-248.2-67.6 67.6 248.2 248.2 68.2-67.6zM632 128l98 98-602 602.4 67.6 67.6 602.4-602 98 98v-264h-264zM647.8 579.6l-67.6 67.6 150.2 150.2-98.4 98.6h264v-264l-98 98c0 0-150.2-150.4-150.2-150.4z"],"grid":0,"tags":["md-shuffle"]},{"paths":["M341.4 512l554.6 384v-768l-554.6 384z","M128 128h128v768h-128v-768z"],"grid":0,"tags":["md-skip-backward"]},{"paths":["M128 128v768l554.6-384-554.6-384z","M768 128h128v768h-128v-768z"],"grid":0,"tags":["md-skip-forward"]},{"paths":["M922.8 597l-16.6-61.8-176 47.2-120.8-69.8 120.8-69.8 176 47.2 16.6-61.8-114.2-30.6 115.4-66.6-48-83-113.2 65.4 30.6-114.2-61.8-16.6-47.2 176-124.4 71.8v-142.2l129-128.8-45.4-45.2-83.6 83.6v-133.8h-96v131.2l-83.4-83.4-45.2 45.2 128.6 128.8v142.8l-121.4-70-47.2-176-61.8 16.6 30.6 114.2-115.4-66.8-48 83.2 113.4 65.4-114.2 30.6 16.6 61.8 175.8-47.2 125.2 72.2-125.2 72.4-175.8-47.2-16.6 61.8 114.2 30.6-113.4 65.4 48 83 115.4-66.6-30.6 114 61.8 16.6 47.2-175.8 121.4-70.2v141.8l-128.6 128.8 45.2 45.2 83.4-83.6v131.2h96v-133.6l83.8 83.4 45-45.2-128.8-128.6v-141.2l124.4 72 47.2 175.8 61.8-16.6-30.6-114 113.2 65.4 48-83.2-115.4-66.6z"],"grid":0,"tags":["md-snow"]},{"paths":["M256 832h512v96h-512v-96z","M512 576c35.4 0 64-28.6 64-64s-28.6-64-64-64c-6 0-12 0.8-17.6 2.4l-133.4-97.4-8 7 97.8 133.4c-1.8 5.8-2.8 12-2.8 18.6 0 35.4 28.6 64 64 64z","M512 96c-229.8 0-416 186.2-416 416 0 96.6 33 185.4 88.2 256h117.6l52.2-52.2-45.8-45.8-44.2 44c-39.8-48.6-64.2-108-70.4-170h62.4v-64h-62.4c6.2-62 30.6-121.4 70.4-170l44.2 44 45.8-45.8-44-44.2c48.6-39.8 108-64.2 170-70.4v62.4h64v-62.4c62 6.2 121.4 30.6 170 70.4l-44 44.2 45.8 45.8 44.2-44c39.8 48.6 64.2 108 70.4 170h-62.4v64h62.4c-6.2 62-30.6 121.4-70.4 170l-44.2-44-45.8 45.8 52.2 52.2h117.6c55.2-70.6 88.2-159.4 88.2-256-0-229.8-186.2-416-416-416z"],"grid":0,"tags":["md-speedometer"]},{"paths":["M810.666 213.334v597.332h-597.332v-597.332h597.332zM810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334v0z"],"grid":0,"tags":["md-square-outline"]},{"paths":["M810.666 128h-597.332c-46.938 0-85.334 38.396-85.334 85.334v597.332c0 46.938 38.396 85.334 85.334 85.334h597.332c46.938 0 85.334-38.396 85.334-85.334v-597.332c0-46.938-38.396-85.334-85.334-85.334z"],"grid":0,"tags":["md-square"]},{"paths":["M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.574l-33.062-19.948-0.004-378.554 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"],"grid":0,"tags":["md-star-half"]},{"paths":["M916 420.818l-290.534-24.952-113.466-267.866-113.486 267.868-290.514 24.95 220.384 191.048-66.062 284.134 249.678-150.628 249.66 150.628-66.042-284.132 220.382-191.050zM545.062 690.572l-33.062-19.948-153.036 92.328 40.496-174.172-135.142-117.152 178.084-15.296 69.594-164.262 69.58 164.26 178.108 15.296-135.138 117.15 40.484 174.174-119.968-72.378z"],"grid":0,"tags":["md-star-outline"]},{"paths":["M512 745.372l249.66 150.628-66.042-284.132 220.382-191.050-290.534-24.95-113.466-267.868-113.486 267.868-290.514 24.95 220.384 191.050-66.062 284.132z"],"grid":0,"tags":["md-star"]},{"paths":["M352 128h128v768h-128v-768z","M160 672h128v224h-128v-224z","M544 544h128v352h-128v-352z","M736 352h128v544h-128v-544z"],"grid":0,"tags":["md-stats"]},{"paths":["M464 613.334h96v-261.334h-96v261.334z","M815.34 340.542l61.572-61.572-67.884-67.882-61.57 61.572c-65.024-50.546-146.72-80.66-235.458-80.66-212.078 0-384 171.922-384 384s171.922 384 384 384 384-171.922 384-384c0-88.738-30.114-170.434-80.66-235.458zM724.132 788.132c-56.664 56.664-132 87.868-212.132 87.868s-155.47-31.204-212.132-87.868c-56.664-56.662-87.868-132-87.868-212.132s31.204-155.47 87.868-212.132c56.662-56.664 132-87.868 212.132-87.868s155.468 31.204 212.132 87.868c56.664 56.662 87.868 132 87.868 212.132s-31.204 155.47-87.868 212.132z","M384 64h256v96h-256v-96z"],"grid":0,"tags":["md-stopwatch"]},{"paths":["M512 96c-187.728 0-352 21.336-352 170.668v426.664c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668zM320 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM480 480h-224v-192h224v192zM704 768c-36.272 0-64-27.73-64-64 0-36.274 27.728-64 64-64s64 27.726 64 64c0 36.27-27.728 64-64 64zM768 480h-224v-192h224v192z"],"grid":0,"tags":["md-subway"]},{"paths":["M554.6 64h-85.4v128h85.4v-128zM812.8 151.4l-76.8 76.8 59.8 59.8 76.8-76.8-59.8-59.8zM211.2 151.4l-59.8 59.8 76.8 76.8 59.8-59.8-76.8-76.8zM512 256c-140.8 0-256 115.2-256 256s115.2 256 256 256 256-115.2 256-256-115.2-256-256-256v0zM960 469.4h-128v85.4h128v-85.4zM192 469.4h-128v85.4h128v-85.4zM795.8 736l-59.8 59.8 76.8 76.8 59.8-59.8-76.8-76.8zM228.2 736l-76.8 76.8 59.8 59.8 76.8-76.8-59.8-59.8zM554.6 832h-85.4v128c12.8 0 85.4 0 85.4 0v-128z"],"grid":0,"tags":["md-sunny"]},{"paths":["M262.6 462.2l-198.6 199 198.6 198.8v-149.2h349v-99.4h-349v-149.2zM960 362.8l-198.6-198.8v149.2h-349v99.4h349v149.2l198.6-199z"],"grid":0,"tags":["md-swap"]},{"paths":["M336 432h189.8c29 29.6 69.4 48 114.2 48 88.4 0 160-71.6 160-160s-71.6-160-160-160c-44.8 0-85.2 18.4-114.2 48h-189.8c-61.6 0-112 50.4-112 112s50.4 112 112 112zM302.2 286.2c9.2-9.2 21.2-14.2 33.8-14.2h151.4c-4.8 15.2-7.4 31.2-7.4 48s2.6 32.8 7.4 48h-151.4c-12.6 0-24.8-5-33.8-14.2-9.2-9.2-14.2-21.2-14.2-33.8s5-24.8 14.2-33.8z","M688 592h-189.8c-29-29.6-69.4-48-114.2-48-88.4 0-160 71.6-160 160s71.6 160 160 160c44.8 0 85.2-18.4 114.2-48h189.8c61.6 0 112-50.4 112-112s-50.4-112-112-112zM721.8 737.8c-9.2 9.2-21.2 14.2-33.8 14.2h-151.4c4.8-15.2 7.4-31.2 7.4-48s-2.6-32.8-7.4-48h151.4c12.6 0 24.8 5 33.8 14.2 9.2 9.2 14.2 21.2 14.2 33.8s-5 24.8-14.2 33.8z"],"grid":0,"tags":["md-switch"]},{"paths":["M512 186.18v-122.18l-160 162.908 160 162.912v-122.186c131.992 0 240 109.964 240 244.366 0 40.726-10 79.428-28.008 114.032l58.008 59.062c31.992-50.914 50-109.976 50-173.094 0-179.198-144.004-325.82-320-325.82zM512 756.368c-132.002 0-240-109.976-240-244.368 0-40.726 10-79.418 27.998-114.040l-57.998-59.052c-32.002 48.872-50 109.964-50 173.092 0 179.198 144.004 325.82 320 325.82v122.18l160-162.906-160-162.914v122.188z"],"grid":0,"tags":["md-sync"]},{"paths":["M64 240c0 85.8 0 444.6 0 544 0 26.6 21.4 48 48 48 60.8 0 742 0 800 0 26.6 0 48-21.4 48-48v-544c0-26.6-21.4-48-48-48-58 0-739.4 0-800 0-26.6 0-48 21.4-48 48zM832 256v512h-672v-512h672zM924 512c0 15.4-13 28-28.2 28-15 0-28-12.4-28-28 0-15.4 12.8-28.2 28-28.2 15.2 0.2 28.2 12.8 28.2 28.2z"],"grid":0,"tags":["md-tablet-landscape"]},{"paths":["M784 64c-85.8 0-444.6 0-544 0-26.6 0-48 21.4-48 48 0 60.8 0 742 0 800 0 26.6 21.4 48 48 48h544c26.6 0 48-21.4 48-48 0-58 0-739.4 0-800 0-26.6-21.4-48-48-48zM768 832h-512v-672h512v672zM512 924c-15.4 0-28-13-28-28.2 0-15 12.4-28 28-28 15.4 0 28.2 12.8 28.2 28-0.2 15.2-12.8 28.2-28.2 28.2z"],"grid":0,"tags":["md-tablet-portrait"]},{"paths":["M767.6 184.4c-70.6-55.4-159.4-88.4-255.6-88.4-96 0-184.6 33-255.2 88 83.2 89.6 128.6 206 128 328.6-0.6 122-46.6 237.2-129.8 325.8 70.8 56 160.2 89.6 257 89.6 97 0 186.6-33.6 257.6-90-83-88.6-129-203.6-129.6-325.4-0.6-122.4 44.6-238.6 127.6-328.2z","M706.2 510.2c0 53.8 10.2 106 30.2 155.6 19.2 47.2 46.6 89.8 81.6 127.2 68.2-74.2 110-173 110-281 0-109-42.4-208.4-111.6-282.8-34.2 37-61.2 79.2-80 125.4-20 49.6-30.2 102-30.2 155.6z","M318.6 510.2c0-53.8-10.2-106-30.2-155.6-18.8-46.4-45.8-88.8-80.4-125.8-69.4 74.4-112 174-112 283.2 0 108.4 42 207.2 110.4 281.4 35.2-37.4 62.8-80.2 82-127.6 20-49.4 30.2-101.8 30.2-155.6z"],"grid":0,"tags":["md-tennisball"]},{"paths":["M816 128h-624c-44.004 0-64 35.996-64 80v688l128-128h560c44.004 0 80-35.996 80-80v-480c0-44.004-35.996-80-80-80zM396.8 484h-76.8v-80h76.8v80zM550.4 484h-76.8v-80h76.8v80zM704 484h-76.8v-80h76.8v80z"],"grid":0,"tags":["md-text"]},{"paths":["M606 600.4v-443.6c0-51.4-42-93-94-93s-94 41.6-94 93v443.8c-58 33-97.8 95.6-97.8 167.4 0 106 86 192 192 192s192-86 192-192c0-72-40.2-134.6-98.2-167.6zM480 156.8c0-16 15.4-29 32-29s32 13 32 29v99.2h-64v-99.2z"],"grid":0,"tags":["md-thermometer"]},{"paths":["M628 128h-344c-31.4 0-57.2 19.2-68.4 46.8l-114.4 270.8c-3.4 8.8-5.2 18-5.2 28v77.2c0 42.2 34 89.2 75.6 89.2h238.6l-36 163-1.2 12c0 15.8 6.4 30.2 16.6 40.6l40 40.2 252.4-254.4c13.6-13.8 22-33 22-54.2v-384c0-42.2-34.4-75.2-76-75.2z","M800 128h128v448h-128v-448z"],"grid":0,"tags":["md-thumbs-down"]},{"paths":["M396 896h344c31.4 0 57.2-19.2 68.4-46.8l114.2-270.8c3.4-8.8 5.2-18 5.2-28v-77.2c0-42.2-34-89.2-75.6-89.2h-238.4l36-163 1.2-12c0-15.8-6.4-30.2-16.6-40.6l-40.4-40.4-252 254.6c-13.6 13.8-22 33-22 54.2v384c0 42.2 34.4 75.2 76 75.2z","M96 448h128v448h-128v-448z"],"grid":0,"tags":["md-thumbs-up"]},{"paths":["M786.4 322.4c-25.4-129.2-138.6-226.4-274.4-226.4-79.4 0-152 28-201.8 90.8 68.6 5.2 132.2 30.4 181.4 79.6 36.4 36.4 62 81 74.8 129.6h-67c-30.6-87.4-112-150-211.4-150-12 0-28.6 1.4-41.2 4-106.8 22-182.8 110.8-182.8 221 0 124.2 100.4 201 224 201h136v-206h198.2l-66.4 134h66.2l-36 72h187.4c103 0 186.6-60 186.6-163.6 0-98.8-76.6-179.2-173.6-186z","M424 736h44v192l118-256h-162z"],"grid":0,"tags":["md-thunderstorm"]},{"paths":["M511.6 96c-229.6 0-415.6 186.4-415.6 416s186 416 415.6 416c230 0 416.4-186.4 416.4-416s-186.4-416-416.4-416zM512 844.8c-183.8 0-332.8-149-332.8-332.8s149-332.8 332.8-332.8 332.8 149 332.8 332.8-149 332.8-332.8 332.8z","M532.8 304h-62.4v249.6l218.4 131 31.2-51.2-187.2-111v-218.4z"],"attrs":[{"opacity":0.9},{"opacity":0.9}],"grid":0,"tags":["md-time"]},{"paths":["M465.8 743.2c0 25.4 20.8 46.2 46.2 46.2s46.2-20.8 46.2-46.2c0-25.4-20.8-46.2-46.2-46.2s-46.2 20.6-46.2 46.2zM465.8 96v184.8h92.4v-88.6c156.6 22.6 277.4 156.6 277.4 319.8 0 178.8-144.6 323.6-323.6 323.6s-323.6-144.8-323.6-323.6c0-77.6 27.2-148.8 73-204.4l250.6 250.6 65.2-65.2-314.4-314.2v1c-101.2 75.6-166.8 195.8-166.8 332.2 0 229.8 185.8 416 416 416 229.8 0 416-186.2 416-416s-186.2-416-416-416h-46.2zM789.4 512c0-25.4-20.8-46.2-46.2-46.2s-46.2 20.8-46.2 46.2 20.8 46.2 46.2 46.2c25.4 0 46.2-20.8 46.2-46.2zM234.6 512c0 25.4 20.8 46.2 46.2 46.2s46.2-20.8 46.2-46.2-20.8-46.2-46.2-46.2-46.2 20.8-46.2 46.2z"],"grid":0,"tags":["md-timer"]},{"paths":["M160 693.332c0 83.208 66.124 149.332 149.334 149.332l-53.334 53.336v32h512v-32l-53.334-53.336c83.208 0 149.334-66.124 149.334-149.332v-426.664c0-149.332-164.272-170.668-352-170.668s-352 21.336-352 170.668v426.664zM512 752c-44.004 0-80-35.994-80-79.998s35.996-80.002 80-80.002 80 35.998 80 80.002-35.996 79.998-80 79.998zM768 448h-512v-192h512v192z"],"grid":0,"tags":["md-train"]},{"paths":["M704 64v70h126.2l-162.8 161c-15-14.4-26.4-22-26.4-22-36.6-25.8-81-41-129-41-60.4 0-115.2 24-155.6 62.8l-30.4-30 62.8-62.8-57-57-63 63-75-74h126.2v-70h-256v256h70v-137.4l80.6 79.8-62.4 62.4 57 57 62.8-62.8 38.8 38.4c-14.6 29.8-23 63.4-23 99 0 109.6 79 200.8 182.2 220.4v90.6h-126v80.6h126v112h84v-112h126v-80.4h-126v-90.6c101.6-19.8 182.4-111 182.4-220.6 0-35.4-8.4-69.6-23-99.2l176.6-174.6v137.4h70v-256h-256zM512 580c-70.6 0-128-57.4-128-128s57.4-128 128-128c70.6 0 128 57.4 128 128s-57.4 128-128 128z"],"grid":0,"tags":["md-transgender"]},{"paths":["M256 810.858c0 46.834 38.396 85.142 85.334 85.142h341.334c46.936 0 85.332-38.308 85.332-85.142v-490.858h-512v490.858zM832 192h-160l-53.57-64h-212.858l-53.572 64h-160v64h640v-64z"],"grid":0,"tags":["md-trash"]},{"paths":["M960 794v-269l-102.6 102.6-282.2-282-179.2 179.4-268.8-269-63.2 63.2 332 332.6 179.2-179.4 218.6 218.8-102.6 102.8h268.8z"],"grid":0,"tags":["md-trending-down"]},{"paths":["M691.2 256l102.6 102.6-218.6 218.8-179.2-179.2-332 332.6 63.2 63.2 268.8-269 179.2 179.4 282.2-282 102.6 102.6v-269h-268.8z"],"grid":0,"tags":["md-trending-up"]},{"paths":["M784 210c1.8-54 0.4-112 0.2-114h-545.6c0 2-1.6 60 0.2 114h-142.8c0 136 19.8 204.6 42 253.4s52.8 90.6 117.4 140.6c60.2 46.6 191 107.2 208.6 115.2v56.6c-9.2 20-47 56.4-166.6 56.4h-41.4v96h512v-96h-51.4c-121.4 0-150-38.2-156.6-56.4v-56.6c18.6-9.2 161.8-80.6 208.8-115 50.4-36.8 101.8-103 117.4-140.6s41.8-129.6 41.8-253.6h-144zM219.2 423.8c-17.6-36.4-28-75.8-31.4-123.8h57.4c1.4 12 2.8 22.6 4.6 32.6 13.2 78.4 29.6 140.4 51.4 193-34.6-27-62.6-61.6-82-101.8zM804.8 423.8c-19.8 40.6-48 75.4-83.2 102.6 22-52.4 38-113.6 51.6-193.8 1.6-10 3.2-20.6 4.6-32.6h58.6c-3.6 48-13.8 87.4-31.6 123.8z"],"grid":0,"tags":["md-trophy"]},{"paths":["M820.2 488.2c24 0 53.2 21.8 67.6 51.8h40.2c-0.6-100-42.4-203-118.8-281.8-72.6-74.8-166-121-265.2-131.4-6-18-23-30.8-43.2-30.8-20 0-37 13-43 30.6-207.2 21-361.8 192.8-361.8 405.8 0 2.2 0.2 3.6 0.8 7.6h43.6c13.6-30 44.4-51.8 70.6-51.8 34 0 63 21.8 73 51.8h39.6c8.2-30 33.8-51.4 66-51.4 35.6 0 66.2 29 68.2 65.2v236.6c0 18.6 0.2 48.2-26.8 48.2-13.8 0-33.2-3.6-33.2-32v-42.6h-86v42.6c0 69.2 47.2 121.4 120 121.4 39 0 66.6-17 87-37.4 26.2-26.4 27-69.4 27-100.2v-238.2c4-51.6 47.8-63.4 83.8-63.4 34.4 0 64.6 23.2 75.6 51.2h41c10.2-30 39.6-51.8 74-51.8z"],"grid":0,"tags":["md-umbrella"]},{"paths":["M524.6 359.2c-115.8 0-220.6 43.2-301.4 113.6l-159.2-152.8v384h395l-158.2-153.6c60.8-50.6 138-82.2 223.6-82.2 154.6 0 286.2 96.4 332 235.6l103.6-29.6c-60.8-182.8-232.4-315-435.4-315z"],"grid":0,"tags":["md-undo"]},{"paths":["M752 372h-40v-80c0-110-90-200-200-200s-200 90-200 200h75.996c0-68.008 56.006-124.004 124.004-124.004 68.008 0 124.004 55.996 124.004 124.004h-0.004v80h-364c-44.004 0-80 35.996-80 80v400c0 44.004 35.996 80 80 80h480c44.004 0 80-35.996 80-80v-400c0-44.004-35.996-80-80-80zM512 736c-44.004 0-80-35.996-80-80s35.996-80 80-80 80 35.996 80 80-35.996 80-80 80z"],"grid":0,"tags":["md-unlock"]},{"paths":["M768 439v-170.4c0-26.8-22.4-48.6-49.8-48.6h-604.4c-27.4-0-49.8 21.8-49.8 48.6v486.6c0 26.8 22.4 48.8 49.8 48.8h604.4c27.4 0 49.8-22 49.8-48.6v-170.4l192 194.6v-535.2l-192 194.6z"],"grid":0,"tags":["md-videocam"]},{"paths":["M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546z"],"grid":0,"tags":["md-volume-down"]},{"paths":["M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668z"],"grid":0,"tags":["md-volume-mute"]},{"paths":["M811 512c0 45.434-9.766 88.724-27.206 127.71l63.76 63.76c31.012-56.81 48.446-122.164 48.446-191.47 0-186.512-128-344.508-298-384v89.956c124 37.308 213 155.808 213 294.044z","M512 160.916l-102.042 104.96 102.042 102.038z","M841.684 793.77l-659.452-659.456-48 48 180.998 180.826-16.56 20.86h-170.67v256h170.668l213.332 223.086v-303.086l189.83 189.372c-30.24 25.514-65.83 45.054-103.83 56.672v89.956c62-14.344 117.992-44.326 164.63-85.618l79.22 79.386 48-48.086-48.004-48.078-0.162 0.166z","M704.376 512c0-76.798-42.376-144.814-106.376-177.726v119.64l101.602 101.602c3.108-14.038 4.774-28.608 4.774-43.516z"],"grid":0,"tags":["md-volume-off"]},{"paths":["M128 384v256h170.668l213.332 223.086v-702.17l-213.332 223.084h-170.668zM704 512c0-76.798-42.666-144.814-106.666-177.726v353.272c64-30.73 106.666-98.746 106.666-175.546zM597.334 128v89.956c123.728 37.308 213.334 155.808 213.334 294.044 0 138.238-89.606 256.738-213.334 294.044v89.956c170.666-39.492 298.666-197.486 298.666-384 0-186.512-128-344.508-298.666-384z"],"grid":0,"tags":["md-volume-up"]},{"paths":["M576 224c44.446 0 79.994-35.552 79.994-80 0-44.45-35.548-80-79.994-80s-80.006 35.55-80.006 80c0 44.448 35.56 80 80.006 80z","M576 464h208v-80h-144l-89.604-138.666c-15.396-23.334-36.272-36.272-61.866-36.272-6.396 0-17.656 1.062-25.598 3.494l-222.932 75.444v224h80v-160l81.062-32-161.062 640h80l113.396-328.542 100.604 136.542v192h76v-256l-114.062-192 39.49-123.728 40.572 75.728z"],"grid":0,"tags":["md-walk"]},{"paths":["M64 928h896l-448-832-448 832zM560 800h-96v-96h96v96zM560 640h-96v-192h96v192z"],"grid":0,"tags":["md-warning"]},{"paths":["M832 512c0-102.002-48.008-192.002-121.992-250l-38.008-230h-320l-38.008 230c-73.984 57.998-121.992 147.998-121.992 250 0 101.992 48.008 191.992 121.992 250l38.008 230h320l38.008-230c73.984-58.008 121.992-148.008 121.992-250zM272 512c0-132.002 108.008-240 240-240s240 107.998 240 240c0 131.992-108.008 240-240 240s-240-108.008-240-240z"],"grid":0,"tags":["md-watch"]},{"paths":["M761 326.6l-249-262.6-249 262.6c-137.2 144.8-137.2 380 0 524.8 68.6 72.4 158.8 108.6 249 108.6s180.4-36.2 249-108.6c137.4-144.8 137.4-380 0-524.8z"],"grid":0,"tags":["md-water"]},{"paths":["M512 457.438c-45.758 0-83.194 37.058-83.194 82.36 0 45.304 37.436 82.364 83.194 82.364 45.756 0 83.194-37.058 83.194-82.364 0-45.302-37.438-82.36-83.194-82.36zM761.6 539.796c0-135.892-112.326-247.078-249.6-247.078s-249.6 111.186-249.6 247.078c0 90.606 49.922 170.894 124.792 214.144l41.614-72.064c-49.944-28.834-83.208-80.306-83.208-142.080 0-90.59 74.866-164.716 166.402-164.716 91.542 0 166.402 74.126 166.402 164.716 0 61.774-33.266 113.246-83.208 142.080l41.614 72.064c74.866-43.248 124.792-123.538 124.792-214.144zM512 128c-228.806 0-416 185.308-416 411.796 0 152.374 83.184 284.14 208 356.204l41.598-72.064c-99.838-57.648-166.414-162.648-166.414-284.138 0-181.186 149.782-329.436 332.816-329.436s332.812 148.25 332.812 329.436c0 121.49-66.568 228.542-166.41 284.138l41.598 72.064c124.812-72.064 208-203.83 208-356.204 0-226.488-187.194-411.796-416-411.796z"],"grid":0,"tags":["md-wifi"]},{"paths":["M469.334 554.666v261.334h-213.334v80h512v-80h-213.334v-261.334l341.334-341.332v-85.334h-768v85.334l341.334 341.332zM320 298.666l-85.334-85.332h554.668l-85.334 85.332h-384z"],"grid":0,"tags":["md-wine"]},{"paths":["M380.8 297.2l-58.8 208.6c-12.6 45.6 41.4 63.4 54.6 20.6l52.6-192.4h14.8l-90.4 338h84.4v254c0 46 64 46 64 0v-254h20v254c0 46 62 46 62 0v-254h86.8l-92.4-338h16.8l52.6 192.4c13 43.8 66.6 25 54.6-20.4l-58.8-208.8c-8-23.6-36.4-65.2-84-67.2h-94.6c-49.2 2-77.4 43.2-84.2 67.2z","M585.2 138.4c0-41.2-32.8-74.6-73.2-74.6s-73.2 33.4-73.2 74.6c0 41.2 32.8 74.6 73.2 74.6s73.2-33.4 73.2-74.6z"],"grid":0,"tags":["md-woman"]},{"paths":["M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21 20.8c-51.4-38.8-114-64-182-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-67.8 5.8-130.2 31-181.4 69.8l-20.8-20.8 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 24.6 20.4 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM152.4 335.6c-8.4-17.2-12.8-36.8-13-56-0.2-70.2 56.8-129.2 131-133.6 25.4-1.4 46.2 2.8 64.2 12.2l-182.2 177.4zM831.8 553c0 175.4-144 314.2-320.2 314.2-176 0-319.6-138.8-319.6-314.2s143.6-317.4 319.8-317.4c176.2-0 320 141.8 320 317.4zM689.4 158.4c17.6-9.6 38.6-13.6 64.2-12.2 74.4 4 131.2 63 131 133.6 0 19.2-4.6 38.8-13 56.2l-182.2-177.6z","M512 320v256h-192v32h224v-288z"],"grid":0,"tags":["ios-alarm-outline"]},{"paths":["M876.8 384.8c24.4-28.4 39.2-64.6 39.2-104.4 0.2-87.6-71-159.2-160.8-164.2-3.2-0.2-6.2-0.2-9.6-0.2-40.8-0.2-78.2 13.6-107.6 36.2l107.6 104.8-21.2 20.8c-51.4-38.8-114.4-64-182.4-69.8v-0.2c0-17-14-31-31-31s-31 14-31 31v0.2c-68 5.8-130 31-181.2 69.8l-20.8-20.6 107.6-104.8c-29.4-22.8-66.8-36.4-107.4-36.2-3.2 0-6.4 0.2-9.6 0.2-90 5-161.2 76.6-160.8 164.2 0 39.6 14.8 76 39.2 104.4l108-105.2 19 19c-70.2 63.8-114.2 156-114.2 258.4 0 87.8 32.4 168 86 229.4l-72.8 89.2 25 20.2 70.4-85.8c63.2 60.4 148.8 97.8 243.2 97.8h0.2c0 0 0.4 0 0.6 0 94.4 0 180.4-37.4 243.6-97.8l70.4 86 24.6-20.2-73-89.4c53.6-61.6 86-141.8 86-229.4 0-102.2-44-194.6-114.4-258.6l19-19 108.2 105.2zM544 608h-224v-32h192v-256h32v288z"],"grid":0,"tags":["ios-alarm"]},{"paths":["M928 288v576h-832v-576h832zM960 256h-896v640h896v-640z","M144 192h736v32h-736v-32z","M208 128h608v32h-608v-32z"],"grid":0,"tags":["ios-albums-outline"]},{"paths":["M960 256h-896v640h896v-640z","M144 192h736v32h-736v-32z","M208 128h608v32h-608v-32z"],"grid":0,"tags":["ios-albums"]},{"paths":["M704 256.8l-64.6-64.8-319.4 320 319.4 320 64.6-64.8-254.6-255.2z"],"grid":0,"tags":["ios-arrow-back"]},{"paths":["M96 768h160v-32h-128v-448h128v-32h-160z","M768 256v32h128v448h-128v32h160v-512z","M224 384h32v256h-32v-256z","M768 384h32v256h-32v-256z","M640 320h32v384h-32v-384z","M352 320h32v384h-32v-384z","M494 352h32v320h-32v-320z"],"grid":0,"tags":["ios-barcode-outline"]},{"paths":["M96 256v512h832v-512h-832zM256 640h-32v-256h32v256zM384 704h-32v-384h32v384zM526 672h-32v-320h32v320zM672 704h-32v-384h32v384zM800 640h-32v-256h32v256z"],"grid":0,"tags":["ios-barcode"]},{"paths":["M925.372 558.738c0.264-2.364 0.514-4.73 0.738-7.108 0.008-0.076 0.014-0.156 0.022-0.234 1.218-12.97 1.868-26.106 1.868-39.396 0-229.726-186.26-416-416-416-15.902 0-31.584 0.924-47.024 2.662-0.178 0.020-0.36 0.036-0.54 0.056 0 0.002 0 0.004 0 0.006-194.022 22.094-347.552 177.674-366.458 372.65-0.002 0-0.006 0-0.008 0-0.144 1.496-0.262 2.994-0.39 4.492-0.272 3.152-0.506 6.314-0.706 9.486-0.052 0.836-0.112 1.67-0.16 2.508-0.128 2.242-0.232 4.49-0.326 6.742-0.022 0.562-0.042 1.124-0.064 1.686-0.194 5.214-0.324 10.448-0.324 15.712 0 229.726 186.274 416 416 416 5.254 0 10.478-0.13 15.686-0.324 0.586-0.022 1.172-0.042 1.756-0.066 2.22-0.092 4.438-0.196 6.648-0.32 0.908-0.050 1.812-0.116 2.718-0.172 3.208-0.206 6.402-0.444 9.59-0.72 1.408-0.122 2.82-0.23 4.226-0.368 0-0.002 0-0.006 0-0.008 194.988-18.904 350.558-172.432 372.652-366.458 0.002 0 0.004 0 0.008 0 0.032-0.274 0.056-0.55 0.088-0.826zM893.33 512c0 5.136-0.132 10.244-0.334 15.332-20.668-0.936-41.104-3.38-61.228-7.328l12.22-38.112-30.464-9.768-12.976 40.47c-15.182-4.224-30.16-9.302-44.884-15.276-9.952-4.036-19.702-8.446-29.25-13.208l23.036-34.006-26.494-17.948-24.718 36.492c-24.482-14.7-47.406-31.954-68.61-51.624l29.46-29.46-22.626-22.626-29.46 29.46c-19.11-20.594-35.928-42.816-50.35-66.508l36.974-25.044-17.944-26.492-34.648 23.47c-5.194-10.262-9.996-20.75-14.348-31.48-5.686-14.018-10.552-28.268-14.654-42.704l41.624-13.346-9.77-30.468-39.422 12.64c-4.208-20.846-6.82-42.028-7.792-63.458 5.088-0.202 10.194-0.334 15.33-0.334 210.262-0.004 381.328 171.064 381.328 381.326zM130.674 512c0-2.634 0.046-5.258 0.1-7.878 18.128 1.118 36.078 3.374 53.782 6.818l-14.23 44.382 30.47 9.77 15-46.782c15.384 4.256 30.56 9.392 45.476 15.442 10.35 4.198 20.478 8.808 30.394 13.792l-26.81 39.58 26.492 17.946 28.438-41.984c24.076 14.558 46.64 31.586 67.53 50.966l-33.706 33.706 22.626 22.628 33.708-33.708c19.936 21.488 37.4 44.738 52.228 69.592l-41.506 28.116 17.944 26.492 38.946-26.38c4.566 9.222 8.8 18.634 12.694 28.232 6.322 15.59 11.668 31.458 16.032 47.556l-45.664 14.64 9.768 30.466 43.062-13.806c3.216 17.012 5.358 34.244 6.43 51.644-2.622 0.052-5.244 0.1-7.878 0.1-210.26-0.002-381.328-171.070-381.326-381.33zM551.786 891.258c-1.242-19.948-3.822-39.822-7.718-59.492l48.2-15.454-9.768-30.464-45.792 14.682c-7.892-28.83-18.712-57.020-32.468-84.108l40.344-27.328-17.946-26.492-37.976 25.724c-15.776-26.188-34.466-51.104-56.080-74.29l34.162-34.162-22.626-22.626-34.164 34.162c-22.576-21.042-46.786-39.32-72.216-54.828l25.392-37.486-26.492-17.944-26.892 39.7c-27.096-13.948-55.318-24.934-84.188-32.988l14.316-44.65-30.47-9.77-15.040 46.904c-20.362-4.136-40.954-6.848-61.62-8.134 18.336-176.074 156.984-316.908 332.046-338.622 1.148 23.716 4.19 47.352 9.086 70.678l-51.87 16.632 9.77 30.468 49.806-15.97c8.090 28.288 19.008 55.934 32.772 82.492l-44.644 30.242 17.946 26.492 42.472-28.77c15.376 25.056 33.47 48.91 54.232 71.18l-38.408 38.408 22.626 22.628 38.408-38.41c22.894 21.338 47.47 39.842 73.294 55.49l-29.11 42.972 26.496 17.948 30.656-45.256c26.56 13.578 54.2 24.31 82.458 32.236l-16.336 50.954 30.464 9.768 17.050-53.18c22.602 4.624 45.488 7.508 68.448 8.62-21.712 175.060-162.546 313.706-338.62 332.044z"],"grid":0,"tags":["ios-baseball-outline"]},{"paths":["M512 96c-16.088 0-31.95 0.946-47.564 2.722v0 0c-207.326 23.61-368.436 199.638-368.436 413.278 0 229.726 186.274 416 416 416 213.654 0 389.666-161.106 413.276-368.436v0 0c1.778-15.61 2.724-31.474 2.724-47.564 0-229.726-186.26-416-416-416zM519.878 893.228c-1.078-17.386-3.21-34.61-6.418-51.608l-43.022 13.792-9.77-30.468 45.624-14.628c-4.366-16.112-9.712-31.988-16.040-47.588-3.886-9.588-8.122-18.994-12.682-28.21l-38.928 26.372-17.944-26.494 41.488-28.108c-14.832-24.858-32.298-48.114-52.238-69.606l-33.704 33.706-22.626-22.626 33.704-33.704c-20.884-19.378-43.442-36.404-67.514-50.96l-28.432 41.976-26.494-17.946 26.806-39.576c-9.92-4.982-20.054-9.598-30.412-13.8-14.91-6.042-30.076-11.18-45.45-15.434l-15 46.784-30.472-9.77 14.23-44.384c-17.712-3.446-35.67-5.706-53.808-6.824 0.218-10.746 0.876-21.39 1.968-31.906 20.678 1.294 41.278 3.996 61.654 8.136l15.036-46.908 30.474 9.772-14.318 44.656c28.866 8.054 57.084 19.042 84.18 32.988l26.898-39.708 26.496 17.946-25.4 37.496c25.424 15.508 49.63 33.784 72.2 54.822l34.164-34.164 22.628 22.628-34.166 34.164c21.618 23.19 40.312 48.11 56.088 74.302l37.998-25.738 17.946 26.496-40.366 27.34c13.756 27.092 24.578 55.284 32.464 84.116l45.838-14.698 9.77 30.472-48.244 15.468c3.894 19.656 6.462 39.522 7.708 59.454-10.518 1.096-21.164 1.75-31.914 1.97zM821.922 550.586l-17.058 53.208-30.472-9.77 16.348-50.986c-28.248-7.928-55.88-18.658-82.436-32.232l-30.67 45.282-26.496-17.946 29.128-42.998c-25.824-15.652-50.398-34.154-73.288-55.492l-38.41 38.408-22.624-22.628 38.404-38.406c-20.762-22.27-38.854-46.124-54.228-71.18l-42.496 28.786-17.948-26.496 44.67-30.254c-13.762-26.556-24.678-54.198-32.768-82.482l-49.836 15.98-9.77-30.474 51.902-16.642c-4.894-23.326-7.886-46.964-9.044-70.674 10.378-1.288 20.892-2.136 31.508-2.568 1.014 21.486 3.718 42.668 7.944 63.614l39.488-12.718 9.814 30.424-41.578 13.316c4.102 14.436 8.982 28.676 14.666 42.696 4.352 10.726 9.156 21.206 14.348 31.462l34.63-23.458 17.946 26.492-36.954 25.032c14.418 23.692 31.238 45.914 50.348 66.508l29.458-29.462 22.628 22.626-29.464 29.462c21.204 19.672 44.124 36.926 68.604 51.626l24.704-36.47 26.496 17.946-23.024 33.988c9.554 4.766 19.312 9.178 29.27 13.216 14.708 5.964 29.674 11.042 44.842 15.262l12.968-40.44 30.466 9.77-12.208 38.086c20.232 3.968 40.572 6.622 61.252 7.648-0.43 10.624-1.286 21.144-2.57 31.536-22.972-1.128-45.874-3.97-68.49-8.598z"],"grid":0,"tags":["ios-baseball"]},{"paths":["M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM893.328 512c0 0.096-0.004 0.194-0.004 0.29-44.63-3.442-87.978-13.944-129.24-31.398-35.776-15.132-68.906-35.010-98.958-59.268 41.38-59.002 76.884-122.424 105.648-189.43 75.316 69.706 122.554 169.338 122.554 279.806zM745.212 210.522c-0.56 1.352-1.1 2.708-1.67 4.056-27.816 65.766-62.124 127.912-102.572 185.974-3.076-2.898-6.126-5.828-9.126-8.826-38.214-38.214-68.214-82.708-89.166-132.24-17.394-41.126-27.866-84.326-31.342-128.802 0.222 0 0.442-0.008 0.664-0.008 87.768-0.002 168.694 29.822 233.212 79.846zM479.35 132.088c8.862 116.252 62.088 220.082 142.782 294.624-18.99 25.498-39.218 50.152-60.638 73.93-95.108-100.064-209.63-181.492-337.534-238.264 63.272-72.912 153.706-121.628 255.39-130.29zM561.374 547.68c72.458 81.34 130.96 172.876 174.37 272.906-50.8 36.934-111.020 61.658-176.324 69.796-4.544-95.632-39.042-183.414-94.358-254.142 33.904-27.526 66.074-57.106 96.312-88.56zM524.078 540.078c-25.408 25.406-51.954 49.324-79.556 71.74-77.474-85.77-187.662-141.412-310.9-147.27 8.14-65.292 32.864-125.5 69.792-176.292 118.39 51.376 224.89 123.894 316.664 215.666 6.646 6.646 13.18 13.378 19.624 20.178-5.148 5.372-10.348 10.702-15.624 15.978zM131.016 496.46c50.476 2.29 98.872 13.594 142.9 32.218 49.534 20.952 94.026 50.952 132.24 89.166 4.508 4.508 8.89 9.11 13.168 13.79-62.828 47.83-130.854 88.098-203.416 120.364-53.264-65.588-85.236-149.124-85.236-239.998 0-5.208 0.136-10.382 0.344-15.54zM238.134 777.052c71.976-32.868 139.62-73.574 201.828-121.042 22.498 28.744 41.044 60.23 55.36 94.074 19.228 45.458 30.026 93.448 32.228 142.9-5.16 0.208-10.34 0.344-15.55 0.344-107.366 0-204.498-44.622-273.866-116.276zM761.62 800.042c-44.978-101.342-105.44-194.28-178.382-275.818 22.202-24.538 43.268-50.122 63.112-76.672 68.342 54.684 153.042 89.77 245.602 96.726-8.58 101.838-57.33 192.416-130.332 255.764z"],"grid":0,"tags":["ios-basketball-outline"]},{"paths":["M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.742 0 416-186.276 416-416s-186.258-416-416-416zM761.594 800.064c-8.316 7.216-16.96 14.058-25.884 20.544-43.408-100.030-101.876-191.59-174.336-272.93-30.236 31.456-62.406 61.036-96.312 88.56 55.318 70.728 89.832 158.508 94.378 254.138-10.504 1.31-21.142 2.172-31.888 2.606-2.206-49.454-13-97.442-32.228-142.9-14.316-33.844-32.862-65.33-55.36-94.074-62.208 47.466-129.846 88.186-201.82 121.052-7.766-8.022-15.184-16.382-22.23-25.058 72.56-32.268 140.582-72.542 203.41-120.372-4.278-4.68-8.66-9.282-13.168-13.79-38.214-38.214-82.708-68.214-132.24-89.166-44.030-18.624-92.424-29.928-142.9-32.216 0.434-10.758 1.296-21.406 2.606-31.918 123.24 5.858 233.426 61.506 310.9 147.276 27.604-22.416 54.15-46.334 79.556-71.74 5.276-5.276 10.476-10.606 15.624-15.976-6.446-6.8-12.978-13.534-19.624-20.18-91.774-91.772-198.274-164.29-316.664-215.664 6.486-8.922 13.33-17.564 20.544-25.878 127.902 56.774 242.424 138.202 337.534 238.264 21.422-23.778 41.648-48.432 60.638-73.93-80.694-74.542-133.912-178.376-142.776-294.624 10.546-0.898 21.208-1.384 31.98-1.404 3.476 44.476 13.948 87.676 31.342 128.802 20.952 49.534 50.952 94.026 89.166 132.24 3 3 6.050 5.93 9.124 8.826 40.452-58.062 74.758-120.208 102.574-185.974 0.57-1.348 1.11-2.706 1.67-4.056 8.838 6.852 17.362 14.084 25.558 21.67-28.766 67.004-64.264 130.43-105.644 189.432 30.052 24.26 63.182 44.136 98.958 59.27 41.262 17.454 84.61 27.956 129.24 31.396-0.008 10.774-0.486 21.434-1.376 31.982-92.556-6.958-177.262-42.036-245.602-96.718-19.844 26.55-40.91 52.134-63.112 76.672 72.95 81.54 133.382 174.494 178.362 275.838z"],"grid":0,"tags":["ios-basketball"]},{"paths":["M512 95.918c35.29 0 64 28.702 64 63.982s-28.71 63.98-64 63.98-64-28.702-64-63.98c0-35.28 28.71-63.982 64-63.982zM512 63.928c-53.020 0-96 42.966-96 95.972 0 53.004 42.98 95.97 96 95.97s96-42.966 96-95.97c0-53.006-42.98-95.972-96-95.972v0z","M848 288h-672c-26.51 0-48 21.494-48 48s21.49 48 48 48h200.902c11.098 0 26.394 8.59 34.432 29.416 9.302 24.11 4.74 66.66-1.078 102.888l-7.846 42.52c-0.038 0.208-0.41 0.2-0.41 0.406l-64.458 344.476c-4.606 26.102 12.974 50.988 39.080 55.594 2.816 0.496 5.688 0.734 8.436 0.734 22.714 0 41.834-16.38 45.94-39.672l41.002-239.878v0.332c0 0 14.5-62.816 38.904-62.816h2.192c24.904 0 34.904 62.816 34.904 62.816v-0.164l42.966 239.79c4.104 23.284 24.662 39.63 47.526 39.63 2.774 0 5.71-0.242 8.536-0.736 26.106-4.606 43.642-29.52 39.038-55.622l-64.698-344.502c-0.004-0.016 0.022-0.040 0.018-0.054-0.038-0.208-0.064-0.434-0.104-0.644l-7.542-42.822c-5.818-36.238-10.376-78.166-1.076-102.274 8.038-20.828 24.336-29.418 34.434-29.418h200.902c26.51 0 48-21.494 48-48s-21.49-48-48-48zM176 352.226c-8.822 0-16-7.292-16-16.114s7.178-16.114 16-16.114h672c8.822 0 16 7.18 16 16s-7.178 16-16 16h-203c-31.076 0-54.876 29.476-61.964 47.844-9.692 25.114-10.008 63.884-0.776 121.376l-0.018 0.208 0.012 0.22 6.734 38.276 1.124 6.482 64.504 343.256c1 5.668-1.24 9.922-2.664 11.954-1.426 2.034-4.67 5.598-10.358 6.602-0.952 0.166-1.91 0.252-2.854 0.252-7.786 0-14.414-5.278-15.766-12.944l-42.464-239.524h-0.030c-0.542-4-3.656-20.1-10.044-37.542-4.556-12.434-9.688-22.068-15.688-30.010-14.182-18.776-30.478-22.448-41.652-22.448h-2.192c-10.94 0-27.006 3.462-41.42 21.876-6.1 7.792-11.458 17.342-16.38 29.604-7.256 18.074-11.010 35.308-11.416 37.226l-0.22 0.738-41.456 239.8c-1.386 7.772-7.5 13.192-14.882 13.192-0.918 0-1.864-0.086-2.806-0.254-5.68-1-8.91-4.55-10.33-6.576-1.418-2.026-3.648-6.272-2.646-11.95l64.87-345.016 7.594-42.91 0.042-0.252c9.258-57.658 9.054-96.6-0.664-121.782-7.086-18.362-27.152-47.474-63.52-47.474z"],"grid":0,"tags":["ios-body-outline"]},{"paths":["M608 159.676c0 53.019-42.981 96-96 96s-96-42.981-96-96c0-53.019 42.981-96 96-96s96 42.981 96 96z","M848 288h-672c-26.51 0-48 21.49-48 48s21.49 48 48 48h196.902c11.158 2 26.394 7.674 34.432 28.504 9.302 24.112 4.74 67.212-1.078 103.454l-7.55 42.79c-0.038 0.208-0.078 0.414-0.116 0.622-0.004 0.016-0.004 0.024-0.008 0.040l-60.75 344.536c-4.606 26.106 12.828 51 38.934 55.606 26.11 4.602 50.666-12.832 55.268-38.942l41.966-239.914v0.334c0 0 12.5-65.030 36.904-65.030h2.192c24.904 0 36.904 65.030 36.904 65.030v-0.166l41.966 239.826c4.602 26.11 29.326 43.498 55.436 38.896 26.106-4.606 43.456-29.524 38.85-55.628l-60.792-344.552c-0.004-0.016-0.026-0.040-0.030-0.054-0.038-0.208-0.088-0.434-0.126-0.644l-7.554-42.828c-5.818-36.242-10.382-79.262-1.082-103.376 8.040-20.828 23.272-26.504 34.43-28.504h196.902c26.51 0 48-21.49 48-48s-21.49-48-48-48z"],"grid":0,"tags":["ios-body"]},{"paths":["M695.242 128c-81.882 0-158.242 28-183.156 88.99-27.086-60.99-101.27-88.99-183.154-88.99-110.402 0-200.932 51.96-200.932 158v566h44.28c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.234 128h39.428c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.106v-566c0-106.040-90.354-158-200.758-158zM496 821.852c-36-51.742-97.46-85.852-167-85.852-69.538 0-129 20.11-167 71.852l-2 1.074v-526.926c6-83.65 80.178-122 168.586-122 90.324 0 164.29 37.416 166.726 123.616-0.034 1.458 0.032 2.918 0.032 4.384l0.656 26.206v507.646zM864 296v511.852c-36-51.742-99.462-71.852-169-71.852-69.54 0-131 34.11-167 85.852v-533.852c0-88.224 75.318-128 167.174-128 88.406 0 162.826 22.35 168.826 106v30z"],"grid":0,"tags":["ios-book-outline"]},{"paths":["M328.932 128c-110.4 0-200.932 51.96-200.932 158v566h44.282c25.72-52.668 88.476-84 156.65-84 80.448 0 147.754 55.056 163.232 128h3.836v-705.308c-34.48-42.79-98.038-62.692-167.068-62.692z","M695.242 128c-68.664 0-133.426 19.702-167.242 62.022v705.978h3.594c15.478-72.944 82.99-128 163.444-128 68.17 0 122.298 23.332 156.858 84h44.104v-566c0-106.040-90.354-158-200.758-158z"],"grid":0,"tags":["ios-book"]},{"paths":["M864 128h-300.8c-20.6 0-38.6 9.2-51.2 23.4v0 0c-12.4-14.4-30.6-23.4-51.2-23.4h-300.8c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64zM496 822.2c-9.4-15.6-27-22.2-47.6-22.2h-288.4c-18.8 0-32-17-32-35.8v-572.2c0-18.8 13.2-32 32-32 0 0 261.2 0 286.6 0 25.6 0 49.4 25.6 49.4 44.4v617.8zM640 160c37.6 0 86 0 128 0v200.8l-45.8-29-18.2-12.8-18.2 12.8-45.8 29v-200.8zM896 764.2c0 18.8-13.2 35.8-32 35.8h-288.4c-20.6 0-38.2 4.6-47.6 22.2v-617.8c0-18.8 23.8-44.4 49.4-44.4 4.4 0 15.4 0 30.6 0v262l96-64 96 64v-262c37.2 0 64 0 64 0 18.8 0 32 13.4 32 32v572.2z"],"grid":0,"tags":["ios-bookmarks-outline"]},{"paths":["M685.8 330.8l18.2-12.8 18.2 12.8 45.8 29v-231.8c-41.4 0-89 0-128 0v231.8l45.8-29z","M864 128c0 0-26.6 0-64 0v293l-96-64-96 64v-293c-24.2 0-41.2 0-44.8 0-16.2 0-35.2 14.4-35.2 30s0 658 0 658l-16 11-16-11c0 0 0-644 0-658s-18.4-30-35.2-30-300.8 0-300.8 0c-37.6 0-66 26.6-66 64v572.2c0 37.6 28.4 67.8 66 67.8 0 0 259 0 286.6 0s49.4 8.4 49.4 38.8c0 18.2 0 25.2 0 25.2h32c0 0 0-6.8 0-25.2 0-30.6 21.8-38.8 49.4-38.8s286.6 0 286.6 0c37.6 0 66-30.2 66-67.8v-572.2c0-37.4-28.4-64-66-64z"],"grid":0,"tags":["ios-bookmarks"]},{"paths":["M832 256v-32h-64v32h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v-32h-64v32h-96v640h832v-640h-96zM384 255v-58.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-1zM896 864h-768v-448h768v448zM896 384h-768v-96h64v32h64v-32h512v32h64v-32h64v96z"],"grid":0,"tags":["ios-briefcase-outline"]},{"paths":["M192 224h64v32h-64v-32z","M96 416h832v480h-832v-480z","M768 224h64v32h-64v-32z","M832 256v64h-64v-64h-96v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-96v64h-64v-64h-96v128h832v-128h-96zM640 255v1h-256v-59.8c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v58.8z"],"grid":0,"tags":["ios-briefcase"]},{"paths":["M128 288v608h607.8v-608h-607.8zM703.8 864h-543.8v-544h543.8v544z","M896 128h-608v128h32v-96h544v544h-96v32h128z"],"grid":0,"tags":["ios-browsers-outline"]},{"paths":["M128 288v608h607.8v-608h-607.8z","M288 128v128h480v480h128v-608z"],"grid":0,"tags":["ios-browsers"]},{"paths":["M288 320h448v-128h-448v128zM320 224h384v64h-384v-64z","M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM768 832c0 17.6-14.4 32-32 32h-448c-17.6 0-32-14.4-32-32v-640c0-17.6 14.4-32 32-32h448c17.6 0 32 14.4 32 32v640z","M320 480v-96h-32v128h128v-32h-32z","M320 640v-96h-32v128h128v-32h-32z","M320 800v-96h-32v128h128v-32h-32z","M480 480v-96h-32v128h128v-32h-32z","M640 480v-96h-32v128h128v-32h-32z","M480 640v-96h-32v128h128v-32h-32z","M480 800v-96h-32v128h128v-32h-32z","M640 800v-256h-32v288h128v-32h-32z"],"grid":0,"tags":["ios-calculator-outline"]},{"paths":["M736 128h-448c-35.4 0-64 28.6-64 64v640c0 35.4 28.6 64 64 64h448c35.4 0 64-28.6 64-64v-640c0-35.4-28.6-64-64-64zM720 560v256h-96v-256h96zM720 400v96h-96v-96h96zM560 720v96h-96v-96h96zM560 560v96h-96v-96h96zM560 400v96h-96v-96h96zM400 720v96h-96v-96h96zM400 560v96h-96v-96h96zM400 400v96h-96v-96h96zM304 304v-96h416v96h-416z"],"grid":0,"tags":["ios-calculator"]},{"paths":["M128 384h768v512h-768v-512z","M896 192h-192v96h-32v-96h-320v96h-32v-96h-192v160h768z","M320 128h32v64h-32v-64z","M672 128h32v64h-32v-64z"],"grid":0,"tags":["ios-calendar"]},{"paths":["M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM864 733.4c0 18.6-12.4 34.6-29 34.6h-640c-17.4 0-35-17.4-35-34.6v-352c0-16.4 16.2-29.4 35-29.4h135.6l9.6-6.4c8-9 15.4-20 22.2-27.6 22.6-25.4 39-43.4 50.6-53.8 9.4-8.4 12.4-8.2 12.4-8.2h177c0 0 3.2-0.2 13.4 9 12.2 11 29.4 33 53.2 59.6 5.8 6.6 12 13.6 18.6 21l9.6 6.4h137.8c17.6 0 29 12 29 29.4v352z","M512 379c-94.2 0-171 76.8-171 171s76.8 171 171 171 171-76.8 171-171-76.8-171-171-171zM512 689c-76.8 0-139-62.2-139-139s62.2-139 139-139 139 62.2 139 139-62.2 139-139 139z","M704 384h34v34h-34v-34z","M576 550c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"],"grid":0,"tags":["ios-camera-outline"]},{"paths":["M835 320h-123.4c-64.2-72-84.4-96-109-96h-177c-24.6 0-44.4 24-109 96h-26.6v-32h-68v32h-27c-35.2 0-67 26.4-67 61.4v352c0 35 31.8 66.6 67 66.6h640c35.2 0 61-31.6 61-66.6v-352c0-35-25.8-61.4-61-61.4zM512 721c-94.2 0-171-76.8-171-171s76.8-171 171-171 171 76.8 171 171-76.8 171-171 171zM738 418h-34v-34h34v34z","M512 411c-76.8 0-139 62.2-139 139s62.2 139 139 139 139-62.2 139-139-62.2-139-139-139zM512 614c-35.4 0-64-28.6-64-64s28.6-64 64-64 64 28.6 64 64-28.6 64-64 64z"],"grid":0,"tags":["ios-camera"]},{"paths":["M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM320 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z","M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48zM769 864c-8.822 0-16-7.178-16-16s7.178-16 16-16 16 7.178 16 16-7.178 16-16 16z","M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256zM837.18 484.696l-521.202 91.98-63.464-352.6 607.738 61.216-23.072 199.404z"],"grid":0,"tags":["ios-cart-outline"]},{"paths":["M320 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z","M769 800c-26.496 0-48 21.504-48 48s21.504 48 48 48 48-21.504 48-48-21.504-48-48-48z","M896 256l-649.646-64.708c-3.256-13.944-8.738-29.32-23.676-41.334-18.628-14.98-48.714-21.958-94.678-21.958v32.002c37.228 0 62.334 5.012 74.624 14.894 8.916 7.17 11.288 16.846 14.33 31.978l-0.048 0.008 84.104 467.276c4.826 28.844 14.388 50.418 26.582 65.972 14.494 18.494 33.474 27.87 56.408 27.87h480v-32h-480c-9.454 0-38.272 0.246-51.498-67.51l-10.858-60.32 542.356-96.17 32-256z"],"grid":0,"tags":["ios-cart"]},{"paths":["M128 128h512v192h32v-224h-576v448h224v-32h-192z","M352 352v448h325.2l128 128h26.8v-128h96v-448h-576zM896 768h-96v109.2l-110-109.2h-306v-384h512v384z"],"grid":0,"tags":["ios-chatboxes-outline"]},{"paths":["M672 96h-576v448h224v-224h352z","M352 352v448h325.2l128 128h26.8v-128h96v-448h-576z"],"grid":0,"tags":["ios-chatboxes"]},{"paths":["M732.39 424.244c2.37-13.056 3.612-26.504 3.612-40.244 0-123.712-100.29-224.002-224.002-224.002s-224.002 100.29-224.002 224.002c0 13.74 1.242 27.188 3.612 40.244-94.378 26.36-163.612 112.968-163.612 215.756 0 123.712 100.29 224.002 224.002 224.002 62.684 0 119.342-25.758 160-67.254 40.658 41.496 97.316 67.254 160 67.254 123.712 0 224.002-100.29 224.002-224.002 0-102.788-69.234-189.394-163.612-215.756zM319.998 384c0-105.87 86.13-192.002 192.002-192.002s192.002 86.132 192.002 192.002c0 11.552-1.026 22.87-2.99 33.866-9.498-1.228-19.18-1.868-29.012-1.868-62.684 0-119.342 25.758-160 67.254-40.658-41.496-97.316-67.254-160-67.254-9.832 0-19.514 0.638-29.012 1.868-1.964-10.996-2.99-22.314-2.99-33.866zM544.002 640c0 39.16-11.792 75.612-32.002 106.012-20.208-30.4-32.002-66.852-32.002-106.012 0-11.552 1.026-22.87 2.99-33.866 9.498 1.228 19.18 1.868 29.012 1.868s19.514-0.638 29.012-1.868c1.964 10.996 2.99 22.314 2.99 33.866zM512 576.002c-6.968 0-13.85-0.382-20.628-1.112 5.252-14.524 12.21-28.238 20.628-40.902 8.42 12.664 15.376 26.378 20.628 40.902-6.778 0.73-13.66 1.112-20.628 1.112zM459.582 568.728c-59.512-16.91-107.332-61.874-128.21-119.62 6.78-0.728 13.66-1.112 20.628-1.112 54.706 0 104.138 23 139.144 59.834-13.45 18.378-24.176 38.872-31.562 60.898zM532.856 507.834c35.006-36.836 84.438-59.836 139.144-59.836 6.968 0 13.85 0.382 20.628 1.112-20.878 57.746-68.7 102.708-128.21 119.62-7.386-22.028-18.112-42.522-31.562-60.896zM352 832.002c-105.872 0-192.002-86.13-192.002-192.002 0-87.704 59.11-161.862 139.584-184.728 23.464 69.966 80.53 124.514 152.028 144.486-2.37 13.054-3.612 26.504-3.612 40.242 0 49.434 16.026 95.118 43.146 132.168-35.006 36.834-84.438 59.834-139.144 59.834zM672 832.002c-54.708 0-104.138-23-139.144-59.836 27.122-37.048 43.146-82.732 43.146-132.166 0-13.738-1.242-27.188-3.612-40.242 71.498-19.972 128.562-74.52 152.028-144.486 80.474 22.868 139.584 97.026 139.584 184.728 0 105.872-86.13 192.002-192.002 192.002z"],"grid":0,"tags":["ios-color-filter-outline"]},{"paths":["M732.388 424.244c2.37-13.056 3.614-26.504 3.614-40.244 0-123.712-100.292-224-224.002-224-123.714 0-224.002 100.288-224.002 224 0 13.74 1.244 27.188 3.612 40.244-94.374 26.36-163.61 112.968-163.61 215.756 0 123.71 100.288 224 224 224 62.682 0 119.34-25.758 160-67.254 40.656 41.496 97.316 67.254 159.998 67.254 123.71 0 224.002-100.29 224.002-224 0-102.788-69.238-189.394-163.612-215.756zM511.996 790.746c-0.968 0.99-1.958 1.964-2.95 2.938-6.402-6.788-12.378-13.974-17.902-21.518-27.122-37.050-43.148-82.732-43.148-132.166 0-13.738 1.244-27.188 3.614-40.242-71.498-19.972-128.562-74.52-152.028-144.486-3.188-9.504-5.744-19.294-7.644-29.318 1.884-0.58 3.764-1.178 5.67-1.708-0.092-0.504-0.17-1.014-0.258-1.518 8.372-2.098 16.926-3.734 25.64-4.86 9.496-1.23 19.178-1.868 29.010-1.868 62.682 0 119.34 25.756 160 67.252 40.656-41.496 97.316-67.252 159.998-67.252 9.832 0 19.514 0.638 29.012 1.868 8.71 1.126 17.266 2.76 25.632 4.858-0.086 0.506-0.164 1.014-0.258 1.52 1.91 0.534 3.79 1.128 5.676 1.71-1.898 10.024-4.458 19.814-7.644 29.316-23.464 69.966-80.532 124.514-152.026 144.484 2.37 13.056 3.614 26.506 3.614 40.244 0 49.434-16.028 95.116-43.148 132.166-5.524 7.544-11.504 14.734-17.906 21.52-0.992-0.974-1.982-1.948-2.954-2.94z","M541.012 606.134c-9.498 1.228-19.18 1.868-29.012 1.868s-19.516-0.638-29.012-1.868c-1.964 10.996-2.992 22.312-2.992 33.866 0 39.16 11.796 75.612 32.004 106.010 20.208-30.398 32.004-66.85 32.004-106.010 0-11.552-1.028-22.87-2.992-33.866z","M692.626 449.11c-6.78-0.728-13.66-1.112-20.628-1.112-54.708 0-104.138 23-139.142 59.834 13.45 18.376 24.176 38.868 31.562 60.896 59.51-16.91 107.33-61.872 128.208-119.618z","M532.628 574.89c-5.25-14.524-12.21-28.238-20.628-40.902-8.418 12.664-15.378 26.378-20.628 40.902 6.778 0.728 13.66 1.112 20.628 1.112s13.85-0.382 20.628-1.112z","M352 447.998c-6.968 0-13.85 0.382-20.628 1.112 20.878 57.746 68.698 102.708 128.212 119.62 7.386-22.030 18.11-42.522 31.562-60.896-35.006-36.836-84.44-59.836-139.146-59.836z"],"grid":0,"tags":["ios-color-filter"]},{"paths":["M608 192h-32v160h160v-32h-128z","M650.6 128h-330.6v96h-96v672h480v-96h96v-522l-149.4-150zM672 864h-416v-608h64v544h352v64zM768 768h-416v-608h285.4l130.6 131.2v476.8z"],"grid":0,"tags":["ios-copy-outline"]},{"paths":["M288 832v-608h-64v672h480v-64h-384z","M650.6 128h-330.6v672h480v-522l-149.4-150zM736 352h-160v-160h32v128h128v32z"],"grid":0,"tags":["ios-copy"]},{"paths":["M576 288v32h224v544h-576v-544h224v-32h-256v608h640v-608z","M386.2 504.6l-23.2 23.2 149 149 149-149-23.2-23.2-109.4 109.4v-486h-32.8v486z"],"grid":0,"tags":["ios-download-outline"]},{"paths":["M528 288v326l109.6-109.4 23.2 23.2-148.8 149-149-149 23.4-23.2 109.6 109.4v-326h-304v608h640v-608z","M496 128h32v160h-32v-160z"],"grid":0,"tags":["ios-download"]},{"paths":["M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 320c66.2 0 129.8 19 194.4 61.2 47.8 31.2 94.8 73.4 147.4 132.2-76.6 77.4-191.6 190.6-341.8 190.6-68.4 0-128.4-16.8-188.4-56.4-55-36.2-104.6-86.6-152.4-135.6 118.2-119.4 216.8-192 340.8-192z","M512 672c88.2 0 160-71.8 160-160s-71.8-160-160-160c-88.2 0-160 71.8-160 160s71.8 160 160 160zM512 384.6c70.4 0 128 57.2 128 127.4s-57.6 127.4-128 127.4c-70.4 0-127.8-57.2-127.8-127.4s57.4-127.4 127.8-127.4z","M576 512v0c0 35-28.8 64-63.6 64s-64.4-30.4-64.4-65.4 31.6-62.6 64-62.6v-32c-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43.2 96-96.2v-0.4h-32z"],"grid":0,"tags":["ios-eye-outline"]},{"paths":["M894.2 512.4c-90.6-104.4-215.8-224.4-382.2-224.4-67.2 0-128.8 19-193.8 59.6-54.8 34.4-111 82.8-188.2 162.4l-2 2 13.4 13.8c110.2 112.8 205.4 210.2 370.6 210.2 73 0 143.8-23.8 216.4-72.8 61.8-41.8 114.4-94.8 156.6-137.6l11-11-1.8-2.2zM512 672c-88.2 0-160-71.8-160-160s71.8-160 160-160c88.2 0 160 71.8 160 160s-71.8 160-160 160z","M500.8 453.6c0-13.8 4-26.8 11-37.6-53 0-95.8 43.2-95.8 96.4s43 96.2 95.8 96.2 96-43 96-96.2v0c-10.8 7-23.8 11-37.6 11-38.2-0.2-69.4-31.4-69.4-69.8z"],"grid":0,"tags":["ios-eye"]},{"paths":["M96 310l367 202-367 201.8v-403.8zM544 311.6l352 200.4-352 200.8v-400.8zM512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"],"grid":0,"tags":["ios-fastforward-outline"]},{"paths":["M512 256v246.4l-448-246.4v512l448-246.4v246.4l448-256-448-256z"],"grid":0,"tags":["ios-fastforward"]},{"paths":["M737 256h-450l-127 192v320h704v-320l-127-192zM826.8 448h-90.8v-136l90.8 136zM320 288h384v160h-96c0 53-43 96-96 96s-96-43-96-96h-96v-160zM288 312v136h-90.8l90.8-136zM832 736h-640v-256h196c14.2 55.2 64.4 96 124 96s109.8-40.8 124-96h196v256z"],"grid":0,"tags":["ios-filing-outline"]},{"paths":["M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 816h-448v-288h448v288zM736 496h-448v-288h448v288zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"],"grid":0,"tags":["ios-film-outline"]},{"paths":["M112 176v672h800v-672h-800zM256 816h-112v-96h112v96zM256 688h-112v-96h112v96zM256 560h-112v-96h112v96zM256 432h-112v-96h112v96zM256 304h-112v-96h112v96zM736 528h-448v-32h448v32zM880 816h-112v-96h112v96zM880 688h-112v-96h112v96zM880 560h-112v-96h112v96zM880 432h-112v-96h112v96zM880 304h-112v-96h112v96z"],"grid":0,"tags":["ios-film"]},{"paths":["M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5zM736 538c-22 2.8-47.8 7-77.4 7-46.2 0-90-9.4-132.4-18.4-43-9.2-87.2-26.6-134.2-26.6-51.4 0-83.8 6-103.8 12v-274.6c12-5 43.8-13.6 103.8-13.6 43.6 0 84.4 8.6 127.8 18 44 9.4 87.6 21.2 137 21.2 29.4 0 57.4-4 79.4-6.6l-0.2 281.6z"],"grid":0,"tags":["ios-flag-outline"]},{"paths":["M736 224c-22 2.8-49.8 7-79.4 7-46.2 0-88-11.4-130.4-20.4-43-9.2-87.4-18.6-134.4-18.6-93.8 0-125.6 20.2-128.8 22.4l-6.8 4.8v612.8h32v-286.6c12-5 43.6-13.8 103.8-13.8 43.6 0 84.4 16.6 127.8 26 44 9.4 89.6 19.2 139 19.2 29.4 0 55.4-4 77.4-6.6 12-1.4 22.6-2.8 32-4.4v-346.8c-9.4 1.8-20.2 3.4-32.2 5z"],"grid":0,"tags":["ios-flag"]},{"paths":["M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v672c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-608c0-26.654-19.346-46-46-46zM114 160h224c6.994 0 7.474 0.378 12.35 4.976l44.834 44.836c9.68 9.68 20.744 14.188 34.816 14.188h484c8.896 0 14 5.104 14 14v84.752c-5.008-1.776-10.39-2.752-16-2.752h-800c-5.61 0-10.992 0.976-16 2.752v-148.752c0-8.646 9.344-14 18-14zM928 846c0 8.656-5.354 18-14 18h-800c-8.916 0-18-9.084-18-18v-478c0-8.822 7.178-16 16-16h800c8.822 0 16 7.178 16 16v478z"],"grid":0,"tags":["ios-folder-outline"]},{"paths":["M944 352h-864c-8.822 0-16 7.178-16 16v478c0 26.634 23.366 50 50 50h800c25.366 0 46-22.43 46-50v-478c0-8.822-7.178-16-16-16z","M914 192h-484c-5.582 0-8.542-1.17-12.188-4.816l-45.338-45.326c-9.744-9.192-17.752-13.858-34.474-13.858h-224c-27.57 0-50 20.634-50 46v148.752c5.008-1.776 10.39-2.752 16-2.752h864c5.61 0 10.992 0.976 16 2.752v-84.752c0-26.654-19.346-46-46-46z"],"grid":0,"tags":["ios-folder"]},{"paths":["M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM178.634 327.044l36.726 105.576-84.608 73.22c1.032-64.77 18.288-125.664 47.882-178.796zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM650.050 494.412l1.842 1.53-36.754 144.058h-206.276l-36.97-144.906 0.89-0.752 137.746-116.54 139.522 116.61zM893.252 505.842l-84.908-73.476 36.85-105.63c29.7 53.208 47.024 114.21 48.058 179.106zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83zM510.514 205.34l-92.252-62.996c30-7.612 61.402-11.672 93.738-11.67 31.922 0 62.932 3.964 92.586 11.388l-94.072 63.278zM332.846 763.058l1.696 5.022 39.892 99.562c-58.478-22.702-110.022-59.408-150.464-106.012l108.876 1.428zM649.126 867.808l35.868-97.216 3.254-7.496 111.784-1.464c-40.544 46.718-92.246 83.492-150.906 106.176z"],"grid":0,"tags":["ios-football-outline"]},{"paths":["M512 96c-229.726 0-416 186.272-416 416s186.274 416 416 416c229.744 0 416-186.276 416-416s-186.26-416-416-416zM594.302 884.358c-27.028 5.314-60.654 8.374-88 8.9-26.396-0.39-52.148-3.47-77-8.986-4.288-1.098-8.766-2.276-13.61-3.554l-48.834-130.87 39.29-77.848h211.708l1.14 2.152 38.68 77.704-47.236 128.564c-5.334 1.428-10.716 2.738-16.138 3.938zM379.156 154.56l114.844 78.592v116.294l-141.994 120.134-107.14-48.818-44.664-128.038c44.018-62.408 106.276-111.064 178.954-138.164zM823.128 292.134l-44.864 128.966-107.984 48.776-142.28-120.43v-116.294l115.192-78.83c72.724 26.966 135.81 75.504 179.936 137.812zM132.288 546.828l107.512-93.036 100.196 45.708 39.436 154.574-40.866 77.058-139.72-1.83c-36.696-52.72-60.428-115.092-66.558-182.474zM685.438 731.13l-40.868-77.058 39.504-154.832 99.994-45.562 107.644 93.15c-6.13 67.382-29.864 129.754-66.554 182.472l-139.72 1.83z"],"grid":0,"tags":["ios-football"]},{"paths":["M389.644 480h-69.644v-69.524c0-5.634-5.208-10.476-10.606-10.476h-44.29c-5.396 0-9.104 4.744-9.104 10.356v69.644h-70.934c-5.23 0-9.066 4.286-9.066 9.542v42.854c0 5.396 4.062 11.606 9.722 11.606h70.278v70.934c0 5.23 4.286 9.066 9.542 9.066h42.854c5.396 0 11.606-4.062 11.606-9.722v-70.28h69.524c5.634 0 10.476-5.208 10.476-10.606v-44.29c-0.002-5.396-4.746-9.104-10.358-9.104z","M724.628 558.126c-21.472 0-38.902 17.030-38.902 38.306 0 21.11 17.43 38.168 38.902 38.168 21.566 0 38.996-17.058 38.996-38.168 0-21.276-17.428-38.306-38.996-38.306z","M639.532 474.33c-21.472 0-38.902 17.206-38.902 38.336 0 21.132 17.43 38.306 38.902 38.306 21.566 0 38.996-17.174 38.996-38.306 0-21.13-17.43-38.336-38.996-38.336z","M809.724 474.33c-21.458 0-38.884 17.206-38.884 38.336 0 21.132 17.428 38.306 38.884 38.306 21.474 0 38.904-17.174 38.904-38.306 0-21.13-17.428-38.336-38.904-38.336z","M724.628 390.602c-21.472 0-38.902 17.204-38.902 38.338 0 21.132 17.43 38.292 38.902 38.292 21.566 0 38.996-17.158 38.996-38.292 0-21.136-17.428-38.338-38.996-38.338z","M738.538 324c51.676 0 99.408 18.628 134.408 52.458 35.504 34.314 55.054 82.036 55.054 134.378 0 52.606-19.612 100.81-55.222 135.738-35.126 34.452-82.8 53.426-134.24 53.426h-453.060c-51.424 0-99.096-18.974-134.234-53.43-35.624-34.934-55.244-83.136-55.244-135.734 0-52.334 19.56-100.056 55.078-134.376 35.008-33.83 82.74-52.46 134.4-52.46h453.060zM738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836v0z"],"grid":0,"tags":["ios-game-controller-a-outline"]},{"paths":["M738.538 292h-453.060c-122.396 0-221.478 90.916-221.478 218.836 0 128.002 99.082 221.164 221.478 221.164h453.058c122.444 0 221.464-93.162 221.464-221.164 0-127.92-99.020-218.836-221.462-218.836zM400 533.394c0 5.396-4.842 10.606-10.476 10.606h-69.524v70.278c0 5.66-6.208 9.722-11.606 9.722h-42.854c-5.256 0-9.542-3.836-9.542-9.066v-70.934h-70.276c-5.66 0-9.722-6.208-9.722-11.606v-42.854c0-5.256 3.836-9.542 9.066-9.542h70.934v-69.644c0-5.612 3.708-10.356 9.106-10.356h44.29c5.396 0 10.606 4.842 10.606 10.476v69.526h69.644c5.612 0 10.356 3.708 10.356 9.106v44.288zM639.532 550.972c-21.472 0-38.902-17.174-38.902-38.306 0-21.13 17.43-38.336 38.902-38.336 21.566 0 38.996 17.206 38.996 38.336 0 21.132-17.43 38.306-38.996 38.306zM724.628 634.602c-21.472 0-38.902-17.058-38.902-38.168 0-21.278 17.43-38.306 38.902-38.306 21.566 0 38.996 17.030 38.996 38.306 0 21.108-17.428 38.168-38.996 38.168zM724.628 467.23c-21.472 0-38.902-17.158-38.902-38.292s17.43-38.338 38.902-38.338c21.566 0 38.996 17.204 38.996 38.338s-17.428 38.292-38.996 38.292zM809.724 550.972c-21.458 0-38.884-17.174-38.884-38.306 0-21.13 17.428-38.336 38.884-38.336 21.474 0 38.904 17.206 38.904 38.336 0 21.132-17.428 38.306-38.904 38.306z"],"grid":0,"tags":["ios-game-controller-a"]},{"paths":["M616.152 407.858c-22.116 0-40.152 18.028-40.152 40.208 0 22.178 18.038 40.214 40.152 40.214 22.262 0 40.296-18.038 40.296-40.214 0.002-22.182-18.034-40.208-40.296-40.208z","M703.976 495.756c-22.116 0-40.106 17.898-40.106 40.212 0 22.128 17.99 40.032 40.106 40.032 22.292 0 40.296-17.902 40.296-40.032 0.002-22.314-18.004-40.212-40.296-40.212z","M270.468 368.734c-43.28 0-78.468 35.606-78.468 79.286 0 43.73 35.188 79.246 78.468 79.246 43.31 0 78.498-35.516 78.498-79.246 0-43.68-35.186-79.286-78.498-79.286zM270.246 486.914c-21.376 0-38.686-17.442-38.686-38.894 0-21.45 17.31-38.882 38.686-38.882 21.282 0 38.594 17.434 38.594 38.882 0 21.452-17.312 38.894-38.594 38.894z","M703.976 320c-22.116 0-40.106 18.028-40.106 40.214 0 22.18 17.99 40.166 40.106 40.166 22.292 0 40.296-17.986 40.296-40.166 0.002-22.186-18.004-40.214-40.296-40.214z","M791.894 407.858c-22.21 0-40.202 18.028-40.202 40.208 0 22.178 17.99 40.214 40.202 40.214 22.118 0 40.106-18.038 40.106-40.214 0-22.182-17.988-40.208-40.106-40.208z","M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM903.354 797.432c-3.67 1.752-7.208 2.568-11.128 2.568-12.044 0-28.154-8.098-46.59-23.416-18.362-15.26-38.614-37.018-63.74-68.478-25.918-32.44-47.334-56.458-87.056-67.898-33.294-9.586-77.248-10.208-158.508-10.208h-48.686c-81.266 0-125.222 0.622-158.518 10.21-39.706 11.438-61.12 35.37-87.046 67.816-25.112 31.454-45.36 53.254-63.724 68.516-18.432 15.316-34.54 23.436-46.586 23.436-3.864 0-7.502-0.83-11.136-2.564-19.112-9.114-45.144-95.346 1.996-292.258 42.774-179.182 84.762-253.554 154.918-274.414 15.266-4.54 29.108-6.744 42.318-6.744 19.484 0 37.198 4.634 59.624 10.498 32.14 8.406 72.144 18.87 132.504 18.87 60.296 0 100.292-10.456 132.43-18.858 22.458-5.872 40.2-10.508 59.73-10.508 13.236 0 27.102 2.208 42.37 6.742 70.074 20.856 112.060 95.234 154.912 274.428 47.050 196.912 21.022 283.15 1.916 292.262z"],"grid":0,"tags":["ios-game-controller-b-outline"]},{"paths":["M270.246 409.136c-21.376 0-38.686 17.434-38.686 38.882 0 21.454 17.31 38.894 38.686 38.894 21.282 0 38.594-17.442 38.594-38.894 0-21.448-17.312-38.882-38.594-38.882z","M932.558 497.732c-42.314-176.942-87.262-270.978-176.908-297.66-19.53-5.802-36.154-8.072-51.498-8.072-55.196 0-93.876 29.366-192.16 29.366-98.348 0-137.004-29.362-192.124-29.366-15.33 0-31.926 2.27-51.442 8.072-89.738 26.682-134.684 120.718-176.922 297.66-42.362 176.946-34.668 304.726 15.358 328.578 8.142 3.89 16.462 5.69 24.908 5.69 43.388 0 90.278-47.676 135.318-104.094 51.308-64.21 64.228-65.906 220.556-65.906h48.686c156.294 0 169.256 1.692 220.564 65.906 45.052 56.414 91.94 104.008 135.33 104.008 8.452 0 16.768-1.758 24.914-5.646 50.010-23.852 57.704-151.59 15.42-328.536zM270.468 527.266c-43.28 0-78.468-35.516-78.468-79.246 0-43.68 35.188-79.286 78.468-79.286 43.31 0 78.498 35.606 78.498 79.286 0 43.73-35.186 79.246-78.498 79.246zM616.152 488.28c-22.116 0-40.152-18.038-40.152-40.214 0-22.18 18.038-40.208 40.152-40.208 22.262 0 40.296 18.028 40.296 40.208 0.002 22.176-18.034 40.214-40.296 40.214zM703.976 576c-22.116 0-40.106-17.902-40.106-40.032 0-22.314 17.99-40.212 40.106-40.212 22.292 0 40.296 17.898 40.296 40.212 0.002 22.13-18.004 40.032-40.296 40.032zM703.976 400.38c-22.116 0-40.106-17.986-40.106-40.166 0-22.188 17.99-40.214 40.106-40.214 22.292 0 40.296 18.028 40.296 40.214 0.002 22.18-18.004 40.166-40.296 40.166zM791.894 488.28c-22.21 0-40.202-18.038-40.202-40.214 0-22.18 17.99-40.208 40.202-40.208 22.118 0 40.106 18.028 40.106 40.208 0 22.176-17.988 40.214-40.106 40.214z"],"grid":0,"tags":["ios-game-controller-b"]},{"paths":["M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2zM747.6 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154zM276.4 666c-85 0-154-69.2-154-154 0-85 69.2-154 154-154 85 0 154 69.2 154 154 0 85-69 154-154 154z"],"grid":0,"tags":["ios-glasses-outline"]},{"paths":["M930.8 494c-4.4-44-24.8-86-57.8-116.8-34.2-31.8-78.6-49.4-125.4-49.4-83 0-154.6 54.8-177 134-14-14-37-23.4-58.6-23.4s-44.6 9.4-58.6 23.4c-22.4-79.2-94-134-177-134-46.6 0-91.2 17.4-125.4 49.2-33 31-53.4 73-57.8 117h-29.2v36h29.2c4.4 44 24.8 86 57.8 116.8 34.2 31.8 78.6 49.4 125.4 49.4 101.6 0 184.2-82.4 184.2-184 0-0.2 0-0.2 0-0.2v0c0-19.8 23-43.2 51.4-43.2s51.4 23.4 51.4 43.2v0c0 0 0 0 0 0.2 0 101.6 82.6 184 184.2 184 46.6 0 91.2-17.4 125.4-49.4 33-30.8 53.4-73 57.8-117h29.2v-36h-29.2z"],"grid":0,"tags":["ios-glasses"]},{"paths":["M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558zM853.66 582.282c-53.704 63.88-84.36 97.79-193.458 169.894-80.474 53.192-130.504 72.602-148.204 78.466-17.7-5.866-67.728-25.278-148.204-78.466-109.096-72.104-139.752-106.012-193.458-169.896-24.13-28.702-43.714-62.548-56.632-97.886-11.58-31.684-17.704-63.786-17.704-92.836 0-60.568 20.262-111.286 58.594-146.67 18.28-16.874 40.316-29.984 65.504-38.968 25.89-9.238 54.532-13.92 85.132-13.92 76.036 0 146.434 35.364 179.348 90.092l27.422 45.596 27.422-45.596c32.916-54.728 103.314-90.092 179.348-90.092 30.6 0 59.242 4.682 85.132 13.918 25.188 8.986 47.224 22.096 65.504 38.968 38.332 35.386 58.594 86.104 58.594 146.672 0 29.050-6.124 61.152-17.708 92.836-12.916 35.336-32.5 69.184-56.632 97.888z"],"grid":0,"tags":["ios-heart-outline"]},{"paths":["M718.77 160c-78.838 0-164.428 35.198-206.77 105.6-42.34-70.402-127.932-105.6-206.77-105.6-137.936 0-241.23 86.476-241.23 231.558 0 62.576 25.124 143.848 81.846 211.314 56.718 67.47 90.458 103.4 200.306 176 109.848 72.604 165.848 85.128 165.848 85.128s56-12.524 165.848-85.128c109.846-72.6 143.588-108.53 200.306-176 56.722-67.466 81.846-148.738 81.846-211.314 0-145.082-103.294-231.558-241.23-231.558z"],"grid":0,"tags":["ios-heart"]},{"paths":["M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256zM800 864h-160v-256h-256v256h-160v-368.62l288-230.4 288 230.4v368.62z","M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996zM288 307.198l-64 51.2v-134.398h64v83.198z"],"grid":0,"tags":["ios-home-outline"]},{"paths":["M512 224l-320 256v416h224v-256h192v256h224v-416l-320-256z","M512 128l-192 153.6v-89.6h-128v191.998l-64 50.998 23.020 22.768 360.98-288.784 360.98 288.786 23.020-22.77-384-306.996z"],"grid":0,"tags":["ios-home"]},{"paths":["M902.458 376.196c-37.094-36.262-86.558-56.196-139.288-56.196-52.726 0-102.19 19.934-139.284 56.196l-84.458 82.374 27.298 26.894 84.458-82.612c29.866-29.058 69.528-45.146 111.756-45.146 42.226 0 81.892 16.088 111.756 45.146 61.594 60.278 61.594 158.26 0 218.296-29.864 29.058-69.53 45.146-111.756 45.146-42.228 0-81.89-16.088-111.756-45.146l-251.042-244.952c-37.33-36.262-86.792-56.196-139.288-56.196-52.726 0-102.19 19.934-139.286 56.196-38.338 37.422-57.526 86.686-57.568 135.804-0.042 49.222 19.146 98.298 57.568 135.804 37.096 36.26 86.558 56.196 139.286 56.196 52.73 0 102.19-19.936 139.29-56.196l84.222-82.372-27.294-26.658-84.458 82.374c-29.864 29.058-69.528 45.146-111.758 45.146-42.226 0-81.888-16.088-111.752-45.146-61.598-60.28-61.598-158.26 0-218.296 29.864-29.058 69.526-45.146 111.752-45.146 42.23 0 81.894 16.088 111.758 45.146l251.040 244.954c37.326 36.258 86.79 56.194 139.286 56.194 52.726 0 102.19-19.936 139.286-56.196 38.496-37.344 57.744-86.604 57.774-135.804 0.030-49.202-19.16-98.34-57.542-135.804z"],"grid":0,"tags":["ios-infinite-outline"]},{"paths":["M913.642 364.754c-40.078-39.178-93.518-60.754-150.472-60.754s-110.39 21.576-150.42 60.708l-78.212 75.77 50.12 49.378 77.686-75.538c26.916-26.19 62.642-40.614 100.598-40.614 37.958 0 73.682 14.424 100.564 40.582 26.726 26.154 41.424 60.936 41.386 97.94-0.038 36.886-14.726 71.5-41.354 97.456-26.916 26.19-62.64 40.614-100.598 40.614-37.956 0-73.682-14.424-100.582-40.598l-251.066-244.98c-40.31-39.154-93.736-60.718-150.438-60.718-56.954 0-110.39 21.576-150.46 60.746-40.188 39.226-62.348 91.518-62.394 147.24-0.048 55.644 22.11 107.946 62.384 147.26 40.080 39.178 93.518 60.754 150.47 60.754 56.95 0 110.388-21.576 150.446-60.726l77.988-75.818-50.176-49.004-77.658 75.23c-26.916 26.19-62.642 40.614-100.6 40.614-37.954 0-73.678-14.424-100.56-40.582-26.728-26.154-41.428-60.938-41.388-97.942 0.038-36.886 14.726-71.498 41.356-97.454 26.916-26.19 62.64-40.614 100.594-40.614 37.958 0 73.684 14.424 100.584 40.598l251.064 244.978c40.308 39.156 93.734 60.72 150.436 60.72 56.952 0 110.388-21.576 150.426-60.71 40.358-39.146 62.602-91.454 62.634-147.28 0.034-55.676-22.116-107.974-62.358-147.256z"],"grid":0,"tags":["ios-infinite"]},{"paths":["M851 269.6c9.4-11.8 15-27 15-43.2 0-38.4-31.2-69.8-69.6-69.8-16.4 0-31.4 5.6-43.2 15-68-48.4-150-75.6-239.8-75.6-229.8-0-417.4 185-417.4 415.2s187.4 416.8 417.2 416.8c229.8 0 414.8-186.6 414.8-416.8 0-90-28.6-173.4-77-241.6zM796 182.6c24.4 0 44 19.8 44 44 0 24.4-19.8 44-44 44-24.4 0-44-19.8-44-44s19.6-44 44-44zM783.6 783.4c-35.2 35.2-76.4 63.2-122.2 82.6-47.4 20-96.4 30.4-148.4 30.4-51.8 0-103.4-10.2-150.8-30.4-45.8-19.4-86.8-47-122.2-82.6-35.2-35.2-63-76.6-82.4-122.4-20-47.4-30.2-97.8-30.2-149.8 0-51.8 10.2-102.4 30.2-149.8 19.4-45.8 47-87 82.4-122.4s76.4-63.2 122.2-82.6c47.4-20 98.8-28.2 150.8-28.2 51.8 0 101 8 148.4 28.2 25.4 10.8 49.4 24.2 71.8 40-4.2 9-6.6 19-6.6 29.8 0 38.4 31.2 69.8 69.6 69.8 10.6 0 20.6-2.4 29.8-6.6 15.8 22.4 29.2 46.4 40 72 20 47.4 30.2 97.8 30.2 149.8 0 51.8-10.2 102.4-30.2 149.8-19.4 45.8-47 87-82.4 122.4z","M513 320.2c-106 0-192 85.6-192 191.8s85.8 192.2 192 192.2c106 0 192-86 192-192.2s-86-191.8-192-191.8zM513 671.6c-88.2 0-159.4-71.6-159.4-159.6 0-88.2 71.2-159.2 159.4-159.2s159.4 71.2 159.4 159.2c0 88.2-71.4 159.6-159.4 159.6z"],"grid":0,"tags":["ios-ionic-outline"]},{"paths":["M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z","M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z","M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 864c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z","M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM789.2 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z","M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z","M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 586.8c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z","M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8zM789.2 160c41.2 0 74.8 33.6 74.8 74.8s-33.6 74.8-74.8 74.8-74.8-33.6-74.8-74.8c-0-41.2 33.4-74.8 74.8-74.8z","M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM512 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.6 74.8-74.8 74.8z","M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8zM234.8 309.6c-41.2 0-74.8-33.6-74.8-74.8s33.6-74.8 74.8-74.8 74.8 33.6 74.8 74.8c0 41.2-33.4 74.8-74.8 74.8z"],"grid":0,"tags":["ios-keypad-outline"]},{"paths":["M789.2 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M512 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M234.8 682.4c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M789.2 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M512 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M234.8 405.2c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M789.2 341.6c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8z","M512 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z","M234.8 128c-59 0-106.8 47.8-106.8 106.8s47.8 106.8 106.8 106.8c59 0 106.8-47.8 106.8-106.8s-47.8-106.8-106.8-106.8z"],"grid":0,"tags":["ios-keypad"]},{"paths":["M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574zM832.352 660.25l-31.926 55.732-256.426-147.982v296h-64v-296l-256.426 148-31.938-55.57 256.456-148.394-256.448-148.314 31.928-55.718 256.428 147.996v-296h64v296l256.426-148 31.938 55.57-256.456 148.358 256.444 148.322z"],"grid":0,"tags":["ios-medical-outline"]},{"paths":["M876 375.426l-63.854-110.852-236.146 136.574v-273.148h-128v273.148l-236.146-136.574-63.876 110.852 236.206 136.574-236.188 136.574 63.856 110.852 236.148-136.574v273.148h128v-273.148l236.144 136.574 63.878-110.852-236.206-136.574 236.184-136.574z"],"grid":0,"tags":["ios-medical"]},{"paths":["M544 416v128h128v64h-128v128h-64v-128h-128v-64h128v-128h64zM576 384h-128v128h-128v128h128v128h128v-128h128v-128h-128v-128z","M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM896 864h-768v-576h768v576z"],"grid":0,"tags":["ios-medkit-outline"]},{"paths":["M544 544v-128h-64v128h-128v64h128v128h64v-128h128v-64h-96z","M672 256v-64c-1-36.4-27.2-64-64.4-64h-198.2c-37.2 0-57.4 27.4-57.4 64v64h-256v640h832v-640h-256zM384 196.2c0-20.4 5.8-36.2 27.4-36.2h194.2c20.8 0 34.4 15.4 34.4 36.2v59.8h-256v-59.8zM704 640h-128v128h-128v-128h-128v-128h128v-128h128v128h128v128z"],"grid":0,"tags":["ios-medkit"]},{"paths":["M512 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z","M256.8 476c19.8 0 36 16.2 36 36s-16.2 36-36 36c-19.8 0-36-16.2-36-36s16.2-36 36-36zM256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z","M768 476c19.8 0 36 16.2 36 36s-16.2 36-36 36-36-16.2-36-36 16.2-36 36-36zM768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"],"grid":0,"tags":["ios-more-outline"]},{"paths":["M512 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.6-64-64-64v0z","M256.8 448c-35.4 0-64 28.6-64 64s28.6 64 64 64c35.4 0 64-28.6 64-64s-28.8-64-64-64v0z","M768 448c-35.4 0-64 28.6-64 64s28.6 64 64 64 64-28.6 64-64-28.6-64-64-64v0z"],"grid":0,"tags":["ios-more"]},{"paths":["M512 129c102.2 0 198.4 39.8 270.8 112.2s112.2 168.4 112.2 270.8-39.8 198.4-112.2 270.8-168.4 112.2-270.8 112.2-198.4-39.8-270.8-112.2c-72.2-72.4-112.2-168.6-112.2-270.8s39.8-198.4 112.2-270.8c72.4-72.2 168.6-112.2 270.8-112.2zM512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416v0z","M704 320l-447.4 192h255.4v256z"],"grid":0,"tags":["ios-navigate-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM512 768v-256h-255.4l447.4-192-192 448z"],"grid":0,"tags":["ios-navigate"]},{"paths":["M716 467.71l0.826-0.078c-0.274-0.274-0.092-0.202-0.37-0.474l-156.868-157.158c-11.666-12-28.386-20.308-46.97-20.308-23.622 0-44.23 12.308-55.27 32.308h-0.014c0 0-14.18 21.988-36.54 57.748l65.062 79.274c5.878 7.538 6.592 15.602 2.822 19.378l-0.228 0.142c-1.818 1.818-4.042 2.66-6.548 2.66-3.816 0-8.284-1.98-12.97-5.536l-71.744-58.836c-47.092 75.31-113.354 181.268-166.9 266.902l38.144 46.674c5.878 7.54 6.592 15.768 2.82 19.544l-0.228 0.228c-1.822 1.826-4.056 2.684-6.574 2.684-3.81 0-8.272-1.962-12.944-5.51l-42.134-33.066c-39.904 63.816-69.372 110.642-73.372 114.446v0.006c-6 10.124-8.17 22.264-8.17 35.328 0 35.31 29.314 63.934 64.57 63.934 15.642 0 29.14-6.79 41.598-15l229.302-168.218-57.676-70.716c-5.88-7.538-6.536-15.774-2.764-19.55l0.256-0.228c1.824-1.824 4.068-2.682 6.588-2.682 3.81 0 8.28 1.962 12.952 5.51l75.728 63.18c109.676-80.492 211.78-154.296 211.78-154.296h0.010c15.678-12 24.946-31.422 24.946-52.476 0-17.408-7.12-34.28-19.12-45.808v-0.006zM691.062 539.668c-5.328 3.868-93.384 67.864-191.528 139.798l-57.612-47.834c-10.49-7.962-21.326-11.996-32.216-11.996-10.93 0-21.184 4.194-28.916 11.818l-0.128 0.124-0.166 0.164-0.166 0.166c-15.616 15.642-15.522 41.646 0.222 61.834l0.22 0.286 0.226 0.276 36.446 44.624-201.312 147.792c-10.132 6.608-16.854 9.314-23.084 9.314-17.644 0-32-14.342-32-31.966 0-6.172 1.388-12.090 4.034-17.246 4.782-6.322 13.2-19.752 37.31-58.702 5.086-8.216 10.504-16.974 16.268-26.258l13.17 10.664 0.4 0.304c10.49 7.962 21.33 12 32.222 12 11.034 0 21.384-4.278 29.142-12.046l0.228-0.226c15.612-15.634 15.512-41.64-0.236-61.832l-0.226-0.288-0.23-0.284-23.628-28.91 135.504-216.692 44.652 36.586c10.508 7.976 21.356 12.020 32.246 12.020 9.908 0 19.262-3.45 26.678-9.78l0.922-0.674 1.742-1.748c15.58-15.606 15.48-41.556-0.236-61.708l-0.24-0.306-50.726-61.378c5.914-9.406 10.914-16.982 14.81-22.976l10.418-16.988c5.554-10.050 15.522-16.314 27.346-16.314 8.734 0 17.52 4.084 24.114 10.86l9.402 9.856h0.244l137.622 138.57v0.752l10.372 9.432c5.586 5.38 9.078 13.564 9.078 22.454 0 10.392-4.516 20.246-12.388 26.458z","M879.988 230.35l-192.832 111.51 132.504-229.876-27.638-15.984-4.976 8.626-141.55 245.57 33.34 33.392 217.112-125.552z"],"grid":0,"tags":["ios-nutrition-outline"]},{"paths":["M718 467.24l-0.212-0.078c-0.272-0.276-0.612-0.886-0.888-1.158l-157.806-158.004c-11.696-12-28.46-20.336-47.094-20.336-23.684 0-44.348 12.336-55.416 32.336h-0.014c0 0-14.218 22.702-36.636 58.498l65.234 79.7c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-71.934-58.878c-47.216 75.386-113.654 181.462-167.342 267.184l38.246 46.724c5.894 7.544 6.61 15.79 2.828 19.57l-0.228 0.228c-4.592 4.592-11.788 3.070-19.57-2.828l-40.44-33.1c-40.010 63.88-69.37 110.754-71.758 114.562v0.006c-6 10.132-10 22.288-10 35.364 0 35.348 28.488 64 63.836 64 15.684 0 28.766-6.796 41.256-15.016l229.684-168.39-57.942-70.79c-5.894-7.544-6.61-15.79-2.828-19.57l0.228-0.228c4.592-4.592 11.788-3.068 19.57 2.83l75.926 62.43c109.97-80.57 212.34-155.266 212.34-155.266h0.010c15.718-12 26.048-30.638 26.048-51.714 0-17.426-6.128-33.5-18.128-45.042v-0.004z","M896 277.562l-32.972-55.388-132.46 76.424 98.462-170.426-55.238-32.172-139.998 242.168 57.176 57.176z"],"grid":0,"tags":["ios-nutrition"]},{"paths":["M382 224v576h-94v-576h94zM414 192h-158v640h158v-640z","M736 224v576h-94v-576h94zM768 192h-158v640h158v-640z"],"grid":0,"tags":["ios-pause-outline"]},{"paths":["M256 192h158v640h-158v-640z","M610 192h158v640h-158v-640z"],"grid":0,"tags":["ios-pause"]},{"paths":["M512 224v0 0z","M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4-22.4-7.8 22.6 7.8 0 0zM294.2 727.2c11.2-11.8 25.4-22.2 40.8-28 21-8 44.8-7.6 66.6-13.2 18-4.6 40.4-11.8 54.4-24.8 12.8-12 14.2-30.4 15.4-47 1-14 0.8-27.8 0.8-41.8 0-9.8-11.4-15.4-17-23.2-9-12.2-9.4-30.4-11.2-45-0.8-6.4-1-14.6-6.4-19-6-4.8-10.4-7.4-13.4-15-4-10.4-5.4-21.6-8.6-32.4-2-7 5-13.6 7.8-19.4 5.2-10.6-3.8-27-5.6-38-5.6-32.8-5.4-68.6 18.2-94.6 47.4-52.4 156-35.8 171.6 37.8 4.8 23 1.8 49.8-4.6 72.2-2.8 9.6-6 16.6-0.4 26 8.4 13.6 4.8 22.4 0.8 37.6-3.2 12.6-7.2 18.2-16.8 26-8 6.4-6.8 22.4-8.2 31.6-1.6 11.2-2.6 23-9.4 32.4-2.6 3.6-16.8 14.8-16.8 18.6 0 22-1 44.4 2.8 66.2 5.2 31 31.2 38.4 57.2 49 26.4 10.2 57 6.4 82.6 19 26.4 13 51.8 36.8 59.4 66.2-158.6 0-317.2 0-475.8 0-2.8 0-5.6 0-8.4 0 3.8-16.6 13-29.2 24.2-41.2 18.4-19.4-11.8 12.6 0 0z","M288.2 644c14-7 29.2-8.6 44.6-10.2 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35.2 11.8-61.2 41.2-61.2 80.2 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 14-15.6 31.2-29 49.8-38.4 18-9-29.2 14.8 0 0zM205.6 672c-32.6 0-65.2 0-97.8 0 14.2-23.6 49.8-22 73.2-30.4 21.6-7.8 35.4-21 37.6-44 0.2-2.6 0.4-58.4-1.8-58.4-17.4-0.6-35.6-0.2-53-2.8 13.8-44.6 0.6-90.6 8-135.6 5.4-32.6 26.2-50.6 59.4-50.6 31.8 0 55.4 14.8 62.2 46.8 9.6 46.4-4 93.8 10.8 139.8-11 2.8-22.6 3.2-34 3.6-5.6 0.2-11.4 0.4-17 0.6-3.6 0.2-2.4 6.4-2.6 9.4-2 21.8-10 56.2 7.4 73.8-19.2 12-40 28.6-52.4 47.8z","M799.6 704c53.4 0 107 0 160.4 0 0-39-26.2-68.6-61.4-80.2-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 11.8 9.6 27.8 23.2 32.2 38.8zM798.8 649.8c-10.2-9.4-20.8-18.6-32.6-26 17.6-17.6 9.4-51.8 7.4-73.8-1.2-12.6-4-9.4-16.6-9.8-12-0.4-25.6 0.2-37-3.6 14.4-44.6 2.6-90.4 10-135.8 5.6-34.2 29-51 63-51 30.8 0 52 15.4 58.4 46 9.8 46.2-5.2 94 9 140-17 2.6-34.6 2-51.8 2.6-4.2 0.2-3.8 50.2-3.4 54.6 1.4 23.4 12.2 37.6 34.4 46.6 24.2 9.8 62 7.2 76.8 31.8-18.6 0-37 0-55.6 0-11.2 0-22.4 0-33.8 0-14.2 0.2-17.8-12.2-28.2-21.6-10-9.2 8 7.2 0 0z"],"grid":0,"tags":["ios-people-outline"]},{"paths":["M698.4 669.6c22.6 7.8-22.4-7.8 0 0v0z","M698.4 669.6c-27-9.4-56.2-10-83.2-19.4-8.2-2.8-24.4-6.2-27.8-15.6-3.2-9.2-3.2-20-3.8-29.6-0.4-7.6-0.6-15.2-0.6-22.8 0-5 12.8-15.6 15.6-20.2 10.8-18 11.8-42.2 13.8-62.6 17.4 4.8 19.6-27.4 22.6-37.2 2.2-6.8 15.6-53.6-5.2-47.2 5-8.8 7-19.6 8.4-29.4 4-25.6 5.6-53.6-2.2-78.6-16.2-52-66-81.2-118.6-82.8-53.4-1.8-107 23.8-127 75.6-9.6 25.2-8.8 52.6-5.6 79 1.4 12 3.4 25.4 9.4 36.2-19.4-5.8-9 35.4-6.8 42.6 3.2 10.2 6 46.8 24.2 41.8 1.6 16.2 3.4 32.8 7.8 48.6 3 10.6 9.2 19.6 16.4 27.8 3.6 4 5.4 4.4 5.2 9.6-0.2 15.6 0.2 32.4-3.8 47.6s-37.4 21.6-50.8 24.4c-36 7.4-69.2 10.8-99.2 33.2-35 25.8-53.2 66-53.2 109.4 166.6 0 333.2 0 499.8 0 18.8 0 37.4 0 56.2 0 0-59-35.6-111-91.6-130.4z","M286.6 645c1.2-0.6 2.4-1.2 3.2-1.6-0.6 0.2-1.2 0.6-1.6 0.8-0.6 0.2-1 0.4-1.6 0.8z","M286.6 645c-6.8 3.4-15 7.6 1.6-0.8 6-3 4.8-2.4 1.6-0.8 13.6-6.4 28.2-8 42.8-9.4 5.6-0.6 8.2-4.4 4-9.8-8-10.2-35.6-12.2-47.2-16.8-7.2-2.8-9.2-5.4-9.8-13.4-0.2-3.6-2.2-19.6 0.6-22.2 2-2 14.6-1.2 17.4-1.6 11.4-1.4 23-3.8 33.8-8 4.6-1.8 9-4 13-6.8 4.8-3.6-3.6-12.4-5.8-17.2-6.8-15-9.8-31.4-10.8-47.8-2-32.2 3-64.6-3-96.6-9-49-46.8-73.6-95-73.6-29.8 0-59.2 10.2-75.8 36.2-18.4 28.6-17.4 64.2-16.4 96.8 0.6 18.6 1.4 37.4-1.2 56-1.2 8-3 15.8-5.8 23.4-2.2 5.8-13.4 20.2-9 23.2 16.6 11.8 44.6 15.8 64.6 14.2 0.6 9.8 2.4 22.4-1.2 31.6-5.6 14.4-47.4 18.2-60 22.4-35 11.6-61 40-61 80 36.6 0 73 0 109.6 0 16.4 0 32.8 0 49.4 0 2.6 0 12.6-18.6 15.4-21.6 13.6-15 30.2-28 48.2-37.4z","M898.6 623.8c-16.2-5.2-47.4-6.8-59-20.8-5.8-7-2.6-24.8-2-33.2 8.8 0.8 18.4-0.6 27.4-1.8 8.2-1.2 16.2-2.8 24-5.6 3.6-1.4 7.2-2.8 10.6-4.8 7.8-4.6 4.2-5.4 0.2-12.2-21.8-36.6-12-83-13-123.2-0.8-33.4-9.6-70-40-88.8-27.4-17-68-17.6-97.4-5.6-84.8 34-34.8 146.4-63.8 210.8-5 10.8-12.2 14.6 0.4 21 7 3.6 14.6 6 22.2 7.8 11.6 2.8 23.6 4.4 35.6 4.8 2 0 0.6 25.2 0 27.8-2.2 9.8-23.6 12.6-31.6 14.8-8.2 2.2-21.8 2.8-25.8 11.4-6 12.8 19.8 9.6 26.2 10.8 20.6 3.8 38.8 15.2 54.8 28.2 12 9.8 28.2 23 32.6 39 53.4 0 107 0 160.4 0-0.4-40.2-26.6-68.8-61.8-80.4z"],"grid":0,"tags":["ios-people"]},{"paths":["M404.8 403.4v0 0z","M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2zM512 800h-274.6c4-6 9.4-10.2 16.4-15.2 14-10.2 32.2-19.6 54.2-27.2 13.6-4.8 33.4-8 50.8-10.6 11.4-1.8 22.2-3.4 31.8-5.6 6.8-1.6 41.6-10 57.6-29.2 9-10.8 11.6-25.4 11.2-64.6-0.2-20-1.2-38.6-1.2-39.4l-0.4-8.4-4.6-7c-3-4.6-11.6-19-16-30.6-3.6-9.4-9.2-38.4-12-56.2 0 0 0.8 2-1-7.4s-16.8-8.6-18.8-16c-1.8-7.2-3.6-13.8-8.6-36.4s5.6-22.4 7.8-32.4c1.2-6.2 0-11.4 0-11.6v0c-0.6-2-8.2-26.8-9.4-75.4-0.6-26.4 9.2-51.2 27.6-69.8 21.2-21.6 52-33 89-33 38 0 68 11.4 89.2 33 18.4 18.6 28.2 43.4 27.6 69.8-1 48.4-8.6 73.2-9.4 75.4v0c0 0.2-1.2 3.4-0.8 10.4 0.4 10.8 13.6 11 8.6 33.6s-6.8 29.2-8.6 36.4c-1.8 7.2-17 6.6-18.8 16s-1 7.4-1 7.4c-2.8 17.8-8.4 46.8-12 56.2-4.6 11.6-13.2 26-16 30.6l-4.6 7-0.4 8.4c0 0.8-1 19.4-1.2 39.4-0.4 39.2 2.2 53.8 11.2 64.6 16 19 50.8 27.6 57.6 29.2 9.6 2.2 20.4 3.8 31.8 5.6 17.4 2.6 37.2 5.8 50.8 10.6 22 7.8 40.4 17.2 54.2 27.4 7 5 12.4 9.2 16.4 15.2l-274.4-0.2z"],"grid":0,"tags":["ios-person-outline"]},{"paths":["M726.6 727.8c-25.8-9.2-62.8-12.4-86.4-17.6-13.6-3-33.4-10.6-40-18.4-6.6-8-2.6-81.8-2.6-81.8s12.2-19.2 18.8-36 13.8-62.8 13.8-62.8 13.6 0 18.4-23.8c5.2-26 13.2-36.8 12.2-56.2-1-18-10.4-19-11.4-19v0c0 0 9.8-27.2 11.2-84.8 1.6-68.2-50.6-135.4-148.6-135.4s-150 67-148.6 135.2c1.2 57.4 11.2 84.8 11.2 84.8v0c-1 0-10.4 1-11.4 19-1 19.4 7.2 29.8 12.2 55.8 4.8 23.8 18.4 24 18.4 24s7.2 46.2 13.8 63c6.6 17 18.8 36 18.8 36s4 73.8-2.6 81.8c-6.6 8-26.4 15.4-40 18.4-23.8 5.2-60.6 8.6-86.4 17.8s-105.4 40.2-105.4 104.2h640c0-64-79.6-95-105.4-104.2z"],"grid":0,"tags":["ios-person"]},{"paths":["M192 256v640h768v-640h-768zM928 864h-704v-576h704v576z","M64 128v640h96v-32h-64v-576h704v64h32v-96z"],"grid":0,"tags":["ios-photos-outline"]},{"paths":["M192 256v640h768v-640h-768z","M832 128h-768v640h96v-544h672z"],"grid":0,"tags":["ios-photos"]},{"paths":["M576 161.652c90.586 7.41 174.708 46.048 239.618 110.988 72.47 72.5 112.382 168.848 112.382 271.446 0 51.848-10.16 102.084-30.198 149.406-19.36 45.718-47.080 86.768-82.388 122.048-35.308 35.278-76.408 62.962-122.16 82.302-47.346 20.020-97.646 30.162-149.504 30.162-82.386 0-160.94-25.694-227.168-74.292-31.9-23.41-59.914-51.466-83.266-83.384-16.756-22.906-30.844-47.448-42.082-73.268l384.766-96.068v-438.992zM544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z","M480 96.362v429.886l-360.684 91.46c-18.234-47.136-22.394-113.946-22.316-138.992v-0.142c0-94.622 32.93-187.492 90.346-254.796 33.47-39.236 75.004-69.962 123.442-91.326 49.41-21.79 106.25-33.904 169.212-36.090zM512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"],"grid":0,"tags":["ios-pie-outline"]},{"paths":["M544 128v448l-395.51 98.752c54.816 165.69 211.192 285.248 395.26 285.248 229.75 0 416.25-186.25 416.25-416s-186-416-416-416v0z","M512 64h-11c-320 0-437 232.5-437 414.574 0 0 0.5 113.332 37.82 176.582l410.18-104.010v-487.146z"],"grid":0,"tags":["ios-pie"]},{"paths":["M288 249.8l419.6 262.2-419.6 262.2v-524.4zM256 192v640l512-320-512-320z"],"grid":0,"tags":["ios-play-outline"]},{"paths":["M256 192v640l512-320-512-320z"],"grid":0,"tags":["ios-play"]},{"paths":["M896 128v-64h-320l-512 576 320 320 46.942-47.808 49.058 47.808 480-544v-288h-64zM384 914.742l-275.22-274.742 480.462-544h274.758v274.754l-433.11 495.98-22.68 22.726-24.21 25.282zM928 402.754l-448 511.988-26.364-25.3 442.364-505.442v-224h32v242.754z","M704 320c35.29 0 64-28.71 64-64s-28.71-64-64-64-64 28.71-64 64 28.71 64 64 64zM704 224c17.672 0 32 14.326 32 32s-14.328 32-32 32-32-14.326-32-32 14.328-32 32-32z"],"grid":0,"tags":["ios-pricetags-outline"]},{"paths":["M928 128v274.754l-473.694 532.206 25.694 25.040 480-544v-288z","M576 64l-512 576 320 320 46.942-47.808 22.696-22.75 442.362-505.442v-320h-320zM704 320c-35.29 0-64-28.71-64-64s28.71-64 64-64 64 28.71 64 64-28.71 64-64 64z","M736 256c0 17.673-14.327 32-32 32s-32-14.327-32-32c0-17.673 14.327-32 32-32s32 14.327 32 32z"],"grid":0,"tags":["ios-pricetags"]},{"paths":["M772.4 288c-121.2 0-219.6 100.2-219.6 224 0 80.8 42 151.4 105 190.8h-291.6c63-39.4 105-110 105-190.8 0-123.8-98.4-224-219.6-224s-219.6 100.2-219.6 224c0 123.8 98.4 224 219.6 224h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM64.6 512c0-105.2 84-190.8 187-190.8 103.2 0 187 85.6 187 190.8s-84 190.8-187 190.8c-103.2 0-187-85.6-187-190.8zM772.4 702.8c-103.2 0-187-85.6-187-190.8s84-190.8 187-190.8 187 85.6 187 190.8-83.8 190.8-187 190.8z","M768 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM768 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z","M256 416c53 0 96 43 96 96s-43 96-96 96-96-43-96-96c0-53 43-96 96-96zM256 384c-70.6 0-128 57.4-128 128s57.4 128 128 128 128-57.4 128-128c0-70.6-57.4-128-128-128v0z"],"grid":0,"tags":["ios-recording-outline"]},{"paths":["M772.4 288c-121.2 0-219.6 99.8-219.6 223.6 0 80.8 42 152.4 105 190.4h-291.6c63-38 105-109.6 105-190.4 0-123.8-98.4-223.8-219.6-223.8s-219.6 100.4-219.6 224c0 123.8 98.4 224.2 219.6 224.2h520.8c121.2 0 219.6-100.2 219.6-224s-98.4-224-219.6-224zM256 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128zM768 640c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128c0 70.6-57.4 128-128 128z","M768 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z","M256 416c-53 0-96 43-96 96s43 96 96 96 96-43 96-96c0-53-43-96-96-96z"],"grid":0,"tags":["ios-recording"]},{"paths":["M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6zM544 384v-129.4l296.2 193.6-296.2 193.4v-129.6c-182 0-289.2 49.2-384.4 210.8-0 0-17.6-338.8 384.4-338.8z"],"grid":0,"tags":["ios-redo-outline"]},{"paths":["M128 800h20.6l38.4-62.4c41-65.4 89.8-125.6 151.6-153.2 48.8-21.8 93.4-37.8 173.4-40v159.6l384-256-384-256v160.6c-126 5.6-216.2 41.4-286.6 112.4-104.6 105.4-97.4 238-97.4 271.4 0.2 17.8 0 43.4 0 63.6z"],"grid":0,"tags":["ios-redo"]},{"paths":["M603.63 637.216c-26.228 22.058-57.912 34.712-91.63 34.712-72.72 0-132.572-57.93-141.78-123.93h61.22l-77.74-100-75.068 100h58.958c9.392 84 83.434 156 174.41 156 41.8 0 82.34-15.132 114.152-42.436l4.74-4.318-23.198-23.324-4.064 3.296z","M631.472 397.77c-32.376-29.55-74.804-45.678-119.472-45.678-41.8 0-82.338 15.112-114.15 42.412l-4.742 4.104 23.198 23.22 4.066-3.412c25.854-21.744 58.394-34.010 91.628-34.010 72.686 0 132.548 57.594 141.782 127.594h-61.288l77.692 102.45 75.252-102.45h-59.024c-4.482-40-23.864-85.872-54.942-114.23z","M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM864 733.402c0 18.526-12.458 34.598-29 34.598h-640c-17.476 0-35-17.328-35-34.598v-352.034c0-16.332 16.252-29.368 35-29.368h121.458c0 0 8.248 0 12.266 0s6.45-0.398 11.536-6.4 15.404-20.016 22.16-27.59c22.592-25.332 38.914-43.83 50.632-54.264 9.492-8.45 12.422-7.746 12.45-7.746h177c0.032 0 3.222-0.726 13.418 8.438 12.282 11.042 29.41 33.68 53.116 60.396 5.776 6.51 14.428 16.22 18.634 20.88s8.504 6.286 11.542 6.286 12.34 0 12.34 0h123.448c17.664 0 29 11.93 29 29.368v352.034z"],"grid":0,"tags":["ios-reverse-camera-outline"]},{"paths":["M835 320h-123.45c-64.21-72-84.438-96-109.050-96h-177c-24.628 0-44.334 24-109.042 96h-26.458v-32h-68v32h-27c-35.29 0-67 26.434-67 61.368v352.036c0 34.934 31.71 66.596 67 66.596h640c35.29 0 61-31.662 61-66.598v-352.034c0-34.934-25.71-61.368-61-61.368zM626.152 661.564c-31.812 27.304-72.352 42.436-114.152 42.436-90.974 0-165.018-72-174.41-156h-58.958l75.068-100 77.74 100h-61.22c9.208 66 69.060 123.93 141.78 123.93 33.718 0 65.402-12.654 91.63-34.712l4.064-3.294 23.198 23.324-4.74 4.316zM670.188 614.45l-77.692-102.45h61.288c-9.234-70-69.096-127.594-141.782-127.594-33.236 0-65.776 12.266-91.628 34.010l-4.066 3.412-23.198-23.22 4.742-4.104c31.81-27.3 72.35-42.412 114.15-42.412 44.666 0 87.096 16.126 119.472 45.678 31.076 28.358 50.458 74.23 54.94 114.23h59.024l-75.25 102.45z"],"grid":0,"tags":["ios-reverse-camera"]},{"paths":["M928 310v403.8l-367-201.8 367-202zM480 312v400.8l-352-200.8 352-200.4zM512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"],"grid":0,"tags":["ios-rewind-outline"]},{"paths":["M512 256l-448 256 448 256v-246.4l448 246.4v-512l-448 246.4v-246.4z"],"grid":0,"tags":["ios-rewind"]},{"paths":["M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124 6.118-6.98 12.464-13.668 19.078-20.282 0.96-0.96 1.944-1.894 2.912-2.844 37.56-36.852 81.042-65.898 129.328-86.322 51.266-21.684 105.742-32.678 161.916-32.678s110.65 10.994 161.916 32.678c48.288 20.424 91.768 49.47 129.328 86.322 0.968 0.95 1.952 1.882 2.912 2.844 6.614 6.614 12.96 13.3 19.078 20.282 7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.004-247.424-200.572-447.876-447.996-447.876zM895.322 738.354c-17.326 40.962-40.858 78.184-70.088 111.552-80.78-79.020-191.306-127.89-313.234-127.89s-232.456 48.66-313.234 127.68c-29.23-33.37-52.762-70.344-70.088-111.306-19.62-46.38-30.456-95.388-32.346-145.388h62.668v-32h-62.668c1.89-50 12.726-100.096 32.346-146.478 18.744-44.314 44.752-84.862 77.384-120.22l53.864 53.786 10.992-11.076 10.554-10.528-0.040-0.054 1.094-1.104-53.902-53.968c35.724-33.294 76.008-59.788 120.958-78.8 46.382-19.62 95.416-30.458 145.416-32.348v74.788h32v-74.792c52 1.89 100.034 12.726 146.416 32.346 44.874 18.98 85.842 45.412 121.524 78.624l-53.95 54.138 1.154 1.094-0.008 0.038 10.57 10.492 11 11.006 54.052-54.114c32.712 35.406 58.784 76.296 77.56 120.69 19.62 46.382 30.458 96.478 32.348 146.478h-64.664v32h64.668c-1.89 50-12.726 98.972-32.346 145.354z","M736.958 349.090l-170.968 147.454c-15.394-10.51-33.984-16.668-53.988-16.668-52.934 0-96 43.066-96 96 0 20.958 6.77 40.356 18.212 56.16l-23.896 23.896 22.624 22.626 24.066-24.066c15.59 10.938 34.546 17.382 54.992 17.382 52.934 0 96-43.066 96-96 0-20.774-6.654-40.010-17.912-55.736l149.698-168.22-2.828-2.828zM512 639.876c-35.346 0-64-28.652-64-64 0-35.346 28.654-64 64-64s64 28.654 64 64c0 35.346-28.654 64-64 64z"],"grid":0,"tags":["ios-speedometer-outline"]},{"paths":["M834 557.484v-1.484h59.628c-1.862-46-12.112-91.218-29.662-132.302-17.286-40.456-41.006-77.33-70.514-109.124l-49.734 49.292-22.458-21.984 49.576-49.358c-32.374-29.672-69.72-53.484-111.030-70.784-42.848-17.946-87.806-27.556-133.806-29.368v67.628h-30v-67.628c-46 1.788-89.9 11.398-132.808 29.37-40.706 17.046-77.916 40.914-110.63 70.942l49.592 49.166-1.098 1.098 0.002 0.012-0.58 0.67-20.54 20.406-49.558-48.958c-29.54 31.864-53.208 68.486-70.352 108.618-17.546 41.080-27.794 86.304-29.654 132.304h57.626v32h-57.626c1.852 44 11.83 88.864 29.658 130.594 15.378 36.002 36.796 69.328 63.662 99.852 77.57-74.754 179.916-115.856 288.308-115.856 108.226 0 210.572 41.352 288.308 116.27 26.708-30.35 48.122-63.958 63.66-100.332 17.83-41.736 27.808-86.528 29.658-130.528h-59.628v-30.516zM608 575.876c0 52.934-43.066 96-96 96-20.446 0-39.402-6.446-54.992-17.382l-24.066 24.066-22.624-22.626 23.896-23.896c-11.444-15.804-18.212-35.204-18.212-56.16 0-52.934 43.066-96 96-96 20.004 0 38.594 6.158 53.988 16.668l146.968-131.454 2.828 2.828-125.698 152.22c11.258 15.726 17.912 34.962 17.912 55.736z","M512 128c-247.424 0-448 200.452-448 447.876 0 113.95 42.566 217.94 112.632 297 7.102 8.012 14.482 15.64 22.132 23.124h44.386c63.426-78.206 160.288-128.192 268.848-128.192s205.424 49.986 268.85 128.192h44.386c7.65-7.484 15.032-15.114 22.132-23.124 70.066-79.060 112.632-183.050 112.632-297 0.002-247.424-200.574-447.876-447.998-447.876zM821.488 841.594c-6.102 6.816-12.784 13.726-20.426 21.128l-0.752 0.73-0.696-0.786c-5.258-5.94-10.986-11.97-17.518-18.44-0.55-0.542-1.11-1.078-1.668-1.614l-1.008-0.97c-34.516-33.532-74.468-59.934-118.75-78.476-47.070-19.712-97.090-29.708-148.672-29.708s-101.602 9.996-148.672 29.708c-44.28 18.542-84.234 44.946-118.75 78.476l-1.008 0.97c-0.558 0.536-1.116 1.070-1.666 1.614-6.532 6.468-12.26 12.5-17.518 18.44l-0.696 0.786-0.754-0.73c-7.642-7.402-14.324-14.312-20.424-21.128-67.028-74.882-103.942-171.258-103.942-271.37 0-109.332 43.004-212.106 121.090-289.388 78.082-77.278 181.904-119.836 292.342-119.836 110.44 0 214.26 42.558 292.34 119.836 78.086 77.284 121.090 180.058 121.090 289.388 0 100.112-36.912 196.486-103.942 271.37z","M576 575.876c0 35.346-28.654 64-64 64s-64-28.654-64-64c0-35.346 28.654-64 64-64s64 28.654 64 64z"],"grid":0,"tags":["ios-speedometer"]},{"paths":["M344.496 609.862l-109.354 318.146 276.858-197.268 276.89 197.268-109.37-318.134 280.48-195.874h-342.774l-105.226-317.99-105.196 317.99h-342.804l280.496 195.862zM512 201.5l82 246.5h262l-216 149.422 85.246 244.962-213.246-151.87v-489.014z"],"grid":0,"tags":["ios-star-half"]},{"paths":["M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8zM725.2 842.4l-213.2-152-213.2 152 85.2-245-216-149.4h262l82-246.6 82 246.6h262l-216 149.2 85.2 245.2z"],"grid":0,"tags":["ios-star-outline"]},{"paths":["M960 414h-342.8l-105.2-318.2-105.2 318.2h-342.8l280.4 195.8-109.2 318.2 276.8-197.2 276.8 197.2-109.4-318.2 280.6-195.8z"],"grid":0,"tags":["ios-star"]},{"paths":["M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM512.6 891.4c-191 0-346.2-153.4-346.2-341.8 0-188.6 155.4-341.8 346.2-341.8 191 0 346.2 153.4 346.2 341.8 0.2 188.4-155.2 341.8-346.2 341.8z","M528 514.6v-258.6h-32v258.8c-25 8.6-48 33-48 60.6 0 29.4 20 54 48 61l16 35.6 16-35.6c28-7 48-31.6 48-61 0-29-21-53.4-48-60.8z"],"grid":0,"tags":["ios-stopwatch-outline"]},{"paths":["M795.2 293.4l-3.6-3.4h36.8l17 15.6 45-45.6-81.6-80.6-46.4 44.6 17.6 18.4v37.2l-10-9.4c-62.6-56.6-140-90.4-226-97.8v-76.4h-64v76h-4c-87.4 6-170 45-232 106v-35.6l17.8-18.4-45.8-44.4-81.6 80.4 45 45.6 17-15.6h35.6c-0.6 0-1.4 1.4-2 2.2-65.6 70.2-102 161.8-102 257 0 208.8 172.2 378.8 384.2 378.8 211.6 0 383.8-169.8 383.8-378.6 0-95.2-36-186.2-100.8-256zM528 636.4l-16 35.6-16-35.6c-28-7-48-31.6-48-61 0-27.6 23-52 48-60.6v-258.8h32v258.6c27 7.4 48 31.8 48 60.8 0 29.4-20 54-48 61z"],"grid":0,"tags":["ios-stopwatch"]},{"paths":["M928 512c0-229.726-186.26-416-416-416-229.726 0-416 186.272-416 416 0 229.726 186.274 416 416 416 5.082 0 10.136-0.124 15.174-0.304 0.958-0.034 1.914-0.068 2.87-0.11 1.884-0.080 3.768-0.166 5.646-0.272 1.7-0.094 3.396-0.208 5.094-0.322 1.278-0.088 2.558-0.16 3.834-0.26 2.708-0.208 5.41-0.442 8.11-0.704 0-0.006 0-0.012 0-0.018 194.94-18.948 350.458-172.458 372.548-366.446 0.040-0.002 0.076 0 0.114-0.002 1.208-10.63 2.004-21.334 2.392-32.1-0.032 0.002-0.064 0.002-0.098 0.002 0.19-5.132 0.316-10.282 0.316-15.464zM893.33 512c0 5.136-0.132 10.242-0.334 15.328-47.278-2.152-93.354-12.212-137.232-30.010-51.582-20.916-97.876-51.662-137.594-91.382-39.72-39.72-70.466-86.014-91.384-137.594-17.806-43.912-27.87-90.028-30.012-137.34 5.054-0.2 10.126-0.33 15.228-0.33 210.258-0.002 381.328 171.066 381.328 381.328zM130.674 512c0-2.636 0.046-5.262 0.1-7.884 44.952 2.758 88.776 12.674 130.6 29.634 51.582 20.916 97.876 51.662 137.596 91.382 39.72 39.718 70.464 86.014 91.382 137.596 16.948 41.792 26.86 85.584 29.628 130.498-2.656 0.054-5.312 0.102-7.98 0.102-210.26-0-381.328-171.068-381.326-381.328zM551.886 891.246c-6.546-105.132-49.948-208.396-130.29-288.738-80.372-80.372-183.68-123.778-288.854-130.3 18.344-176.106 157.040-316.956 332.148-338.626 5.19 107.28 48.72 213.050 130.652 294.98 81.898 81.904 187.622 125.426 294.866 130.644-21.706 175.030-162.494 313.658-338.522 332.040z"],"grid":0,"tags":["ios-tennisball-outline"]},{"paths":["M96.1 503.112c-0.002 0.078-0.006 0.154-0.008 0.232 0 0 0.004 0 0.006 0 0-0.076 0-0.154 0.002-0.232z","M520.622 927.83c0.132-0.004 0.266-0.012 0.398-0.014-0.132 0.002-0.266 0.002-0.398 0.008 0-0 0 0.002 0 0.006z","M512 96.002c-5.172 0-10.58 0.128-15.704 0.316l-0.296-0.012c0 0.006 0 0.008 0 0.012-10 0.398-20 1.204-32 2.41 0-0.004 0-0.008 0-0.016 0 0.010 0.166 0.016 0.144 0.024-193.948 22.122-347.308 177.95-366.26 372.82-0.008 0.036 0.090 0.444 0.084 0.444 0.006 0 0.008 0 0.014 0-1.026 10-1.652 20-1.872 32-0.002 0-0.006 0-0.008 0l0.006-0.304c-0.056 2.86-0.108 5.554-0.108 8.43 0 229.704 185.954 415.876 415.682 415.876 13.712 0 28.318-0.766 40.318-2.062 0 0.004 0 0.012 0 0.012 0-0.008 0.426-0.016 0.48-0.028 194.872-18.972 350.494-172.172 372.624-366.072 0.008-0.028 0.176 0.148 0.184 0.148-0.004 0-0.012 0-0.016 0 1.778-16 2.726-31.718 2.726-47.808 0.002-229.702-186.258-416.19-415.998-416.19zM261.26 533.706c-41.79-16.948-85.576-26.86-130.488-29.632 0.22-10.748 0.876-21.39 1.972-31.904 105.136 6.55 208.406 49.954 288.75 130.292s123.752 183.594 130.304 288.718c-10.514 1.096-21.158 1.752-31.908 1.97-2.77-44.906-12.684-88.688-29.632-130.472-20.918-51.58-51.668-97.874-91.392-137.59-39.722-39.72-86.020-70.466-137.606-91.382zM595.444 428.53c-81.928-81.918-125.462-187.67-130.664-294.934 10.5-1.304 21.136-2.16 31.882-2.586 2.146 47.3 12.21 93.404 30.014 137.308 20.922 51.58 51.67 97.872 91.392 137.59 39.724 39.718 86.020 70.464 137.606 91.382 43.908 17.802 90.016 27.866 137.32 30.014-0.426 10.74-1.286 21.378-2.586 31.878-107.28-5.204-213.036-48.732-294.964-130.652z"],"grid":0,"tags":["ios-tennisball"]},{"paths":["M473.2 543.2c9.2 11.4 23 18.8 38.8 18.8 27.6 0 50-22.4 50-50 0-14.6-6.4-27.6-16.4-36.8-1.2-1.4-2.6-3-4.4-4.4 0 0-235.4-175-240.6-170.4s170.6 240.4 170.6 240.4c0.4 0.8 1.4 1.6 2 2.4z","M512.4 96v0h-0.4v224h32v-189.4c195.6 16.6 350.6 181 350.6 381 0 211-171.4 382.8-382.4 382.8s-382.6-171.6-382.6-382.6c0-105.6 43-201.2 112.2-270.4l-23.8-23.6c-75.4 75.4-122 179.4-122 294.2 0 229.8 186.2 416 416 416s416-186.2 416-416c0-229.8-186-416-415.6-416z"],"grid":0,"tags":["ios-timer-outline"]},{"paths":["M512 96c-229.8 0-416 186.2-416 416s186.2 416 416 416c229.8 0 416-186.2 416-416s-186.2-416-416-416zM301 301c5.2-4.6 239.8 169.8 239.8 169.8 2 1.4 3.2 3 4.4 4.4 10 9.2 16.4 22 16.4 36.6 0 27.4-22.2 49.8-49.8 49.8-15.6 0-29.4-7.4-38.6-18.8-0.8-0.8-1.6-1.4-2.2-2.2 0.2 0.2-175-234.8-170-239.6zM512.2 894.4c-211.4 0-382.8-171.4-382.8-382.8 0-105.6 42.8-201.4 112-270.6l23.6 23.6c-63.2 63.2-102.4 150.6-102.4 247 0 192.6 156.8 349.4 349.4 349.4s349-156.8 349-349.4c0-180.6-141-330.2-317-348v156.4h-32v-191.2c211.4 0 383 171.4 383 382.8s-171.6 382.8-382.8 382.8z"],"grid":0,"tags":["ios-timer"]},{"paths":["M800 226.6h-160v-40c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v40h-160v29.4h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-29.4zM413.2 186.6c0-16.2 13.2-29.4 29.2-29.4h139c16.2 0 29.2 13.2 29.2 29.4v40h-197.4v-40zM683.2 835.8v1.6c0 16.2-13.2 29.4-29.2 29.4h-282c-16.2 0-29.2-13.2-29.2-29.4v-1.6l-47.4-579.8h434.4l-46.6 579.8z","M498 320h28v482h-28v-482z","M640 320h-29.2l-21.4 482h29.2z","M413 320h-29l21.4 482h29.2z"],"grid":0,"tags":["ios-trash-outline"]},{"paths":["M640 226v-39.4c0-32.4-26.2-58.6-58.6-58.6h-139c-32.2 0-58.4 26.2-58.4 58.6v39.4h-160v30h42.2l47.2 581.4c0 32.4 26.2 58.6 58.6 58.6h282c32.4 0 58.6-26.2 58.6-58.6l46.6-581.4h40.8v-30h-160zM414 186.6c0-16.2 12.4-28.6 28.6-28.6h139c16.2 0 28.6 12.4 28.6 28.6v39.4h-196v-39.4h-0.2zM405.4 802l-21.4-482h29l21.8 482h-29.4zM526 802h-28v-482h28v482zM618.6 802h-29.2l21.6-482h29l-21.4 482z"],"grid":0,"tags":["ios-trash"]},{"paths":["M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6zM864.4 722.8c-95.2-161.6-202.4-210.8-384.4-210.8v129.6l-296.2-193.4 296.2-193.6v129.4c402 0 384.4 338.8 384.4 338.8z"],"grid":0,"tags":["ios-undo-outline"]},{"paths":["M895.8 736.4c0-33.6 7.2-166.2-97.4-271.4-70.4-70.8-160.6-106.8-286.6-112.4v-160.6l-383.8 256 384 256v-159.6c80 2.2 124.8 18.2 173.4 40 61.8 27.6 110.6 88 151.6 153.2l38.4 62.4h20.6c0-20.2-0.2-45.8-0.2-63.6z"],"grid":0,"tags":["ios-undo"]},{"paths":["M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4zM640 697.2c0 18.6-13.8 36.8-32.6 36.8h-442c-18.8 0-37.4-18.2-37.4-36.8v-375.8c0-18.6 18-31 36.8-31l442 0.2c18.8 0 33.2 12.2 33.2 30.8v375.8z","M734 426v171.2l196 106.8v-384l-196 106zM896 380v264.6l-128-67v-131.2l128.2-67.2-0.2 0.8z"],"grid":0,"tags":["ios-videocam-outline"]},{"paths":["M607.4 256h-442c-37.6 0-71.4 28.2-71.4 65.4v375.8c0 37.2 33.8 70.8 71.4 70.8h442c37.6 0 66.6-33.6 66.6-70.8v-375.8c0-37.2-29-65.4-66.6-65.4z","M734 426v171.2l196 106.8v-384l-196 106z"],"grid":0,"tags":["ios-videocam"]}];module.exports=exports["default"];
//# sourceMappingURL=icons.js.map

/***/ }),
/* 1443 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  100% {\n    transform: rotate(360deg)\n  }\n'], ['\n  100% {\n    transform: rotate(360deg)\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n'], ['\n  10%, 90% {\n    transform: translate3d(-1px, 0, 0);\n  }\n\n  20%, 80% {\n    transform: translate3d(2px, 0, 0);\n  }\n\n  30%, 50%, 70% {\n    transform: translate3d(-4px, 0, 0);\n  }\n\n  40%, 60% {\n    transform: translate3d(4px, 0, 0);\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  0% {\n    transform: scale(.75);\n  }\n\n  20% {\n    transform: scale(1);\n  }\n\n  40% {\n    transform: scale(.75);\n  }\n\n  60% {\n    transform: scale(1);\n  }\n\n  80% {\n    transform: scale(.75);\n  }\n\n  100% {\n    transform: scale(.75);\n  }\n'], ['\n  0% {\n    transform: scale(.75);\n  }\n\n  20% {\n    transform: scale(1);\n  }\n\n  40% {\n    transform: scale(.75);\n  }\n\n  60% {\n    transform: scale(1);\n  }\n\n  80% {\n    transform: scale(.75);\n  }\n\n  100% {\n    transform: scale(.75);\n  }\n']),
    _templateObject4 = _taggedTemplateLiteral(['\n\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n'], ['\n\n  animation-iteration-count: infinite;\n  animation-timing-function: linear;\n\n  ', ';\n\n  ', ';\n\n  ', ';\n']),
    _templateObject5 = _taggedTemplateLiteral(['\n    animation-name: ', ';\n    animation-duration: 0.82s;\n  '], ['\n    animation-name: ', ';\n    animation-duration: 0.82s;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    animation-name: ', ';\n    animation-duration: 2s;\n  '], ['\n    animation-name: ', ';\n    animation-duration: 2s;\n  ']);

var _styledComponents = __webpack_require__(1444);

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var rotate = (0, _styledComponents.keyframes)(_templateObject);

var shake = (0, _styledComponents.keyframes)(_templateObject2);
var beat = (0, _styledComponents.keyframes)(_templateObject3);

exports.default = _styledComponents2.default.svg(_templateObject4, function (props) {
  return props.shake && (0, _styledComponents.css)(_templateObject5, shake);
}, function (props) {
  return props.rotate && (0, _styledComponents.css)(_templateObject6, rotate);
}, function (props) {
  return props.beat && (0, _styledComponents.css)(_templateObject5, beat);
});
module.exports = exports['default'];
//# sourceMappingURL=SVG.js.map

/***/ }),
/* 1444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return wrapWithTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_is_function___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_is_function__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(1447);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);







/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') return ruleSet;
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) return [].concat(ruleSet, flatten(chunk, executionContext));

    /* Handle other components */
    // $FlowFixMe not sure how to make this pass
    if (chunk.hasOwnProperty('styledComponentId')) return [].concat(ruleSet, ['.' + chunk.styledComponentId]);

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    // $FlowFixMe have to add %checks somehow to isPlainObject
    return ruleSet.concat(__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

//      
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//mg;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

//      
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
                                     return  true ? __webpack_require__.nc : null;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.textNode.data === '') comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
    }

    var nonce = getNonce();

    if (nonce) {
      this.el.setAttribute('nonce', nonce);
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error('BrowserTag doesn\'t implement toReactElement!');
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */


  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) throw new Error("Trying to replace an element that wasn't mounted!");

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/


var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};
    this.stylesCacheable = typeof document !== 'undefined';

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  // helper for `ComponentStyle` to know when it cache static styles.
  // staticly styled-component can not safely cache styles on the server
  // without all `ComponentStyle` instances saving a reference to the
  // the styleSheet instance they last rendered with,
  // or listening to creation / reset events. otherwise you might create
  // a component with one stylesheet and render it another api response
  // with another, losing styles on from your server-side render.


  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (this.components[componentId]) throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (!comp) throw new Error('Must add a new component before you can inject css into it');
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();

    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();

    if (nonce) {
      attrs.nonce = nonce;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({
      key: key, type: 'text/css' }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) throw new Error("Can't collect styles once you've called getStyleTags!");
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

//      
/* Trying to avoid the unknown-prop errors on styled components
 by filtering by React's attribute whitelist.
 */

/* Logic copied from ReactDOMUnknownPropertyHook */
var reactProps = {
  children: true,
  dangerouslySetInnerHTML: true,
  key: true,
  ref: true,
  autoFocus: true,
  defaultValue: true,
  valueLink: true,
  defaultChecked: true,
  checkedLink: true,
  innerHTML: true,
  suppressContentEditableWarning: true,
  onFocusIn: true,
  onFocusOut: true,
  className: true,

  /* List copied from https://facebook.github.io/react/docs/events.html */
  onCopy: true,
  onCut: true,
  onPaste: true,
  onCompositionEnd: true,
  onCompositionStart: true,
  onCompositionUpdate: true,
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  onFocus: true,
  onBlur: true,
  onChange: true,
  onInput: true,
  onSubmit: true,
  onReset: true,
  onClick: true,
  onContextMenu: true,
  onDoubleClick: true,
  onDrag: true,
  onDragEnd: true,
  onDragEnter: true,
  onDragExit: true,
  onDragLeave: true,
  onDragOver: true,
  onDragStart: true,
  onDrop: true,
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOut: true,
  onMouseOver: true,
  onMouseUp: true,
  onSelect: true,
  onTouchCancel: true,
  onTouchEnd: true,
  onTouchMove: true,
  onTouchStart: true,
  onScroll: true,
  onWheel: true,
  onAbort: true,
  onCanPlay: true,
  onCanPlayThrough: true,
  onDurationChange: true,
  onEmptied: true,
  onEncrypted: true,
  onEnded: true,
  onError: true,
  onLoadedData: true,
  onLoadedMetadata: true,
  onLoadStart: true,
  onPause: true,
  onPlay: true,
  onPlaying: true,
  onProgress: true,
  onRateChange: true,
  onSeeked: true,
  onSeeking: true,
  onStalled: true,
  onSuspend: true,
  onTimeUpdate: true,
  onVolumeChange: true,
  onWaiting: true,
  onLoad: true,
  onAnimationStart: true,
  onAnimationEnd: true,
  onAnimationIteration: true,
  onTransitionEnd: true,

  onCopyCapture: true,
  onCutCapture: true,
  onPasteCapture: true,
  onCompositionEndCapture: true,
  onCompositionStartCapture: true,
  onCompositionUpdateCapture: true,
  onKeyDownCapture: true,
  onKeyPressCapture: true,
  onKeyUpCapture: true,
  onFocusCapture: true,
  onBlurCapture: true,
  onChangeCapture: true,
  onInputCapture: true,
  onSubmitCapture: true,
  onResetCapture: true,
  onClickCapture: true,
  onContextMenuCapture: true,
  onDoubleClickCapture: true,
  onDragCapture: true,
  onDragEndCapture: true,
  onDragEnterCapture: true,
  onDragExitCapture: true,
  onDragLeaveCapture: true,
  onDragOverCapture: true,
  onDragStartCapture: true,
  onDropCapture: true,
  onMouseDownCapture: true,
  onMouseEnterCapture: true,
  onMouseLeaveCapture: true,
  onMouseMoveCapture: true,
  onMouseOutCapture: true,
  onMouseOverCapture: true,
  onMouseUpCapture: true,
  onSelectCapture: true,
  onTouchCancelCapture: true,
  onTouchEndCapture: true,
  onTouchMoveCapture: true,
  onTouchStartCapture: true,
  onScrollCapture: true,
  onWheelCapture: true,
  onAbortCapture: true,
  onCanPlayCapture: true,
  onCanPlayThroughCapture: true,
  onDurationChangeCapture: true,
  onEmptiedCapture: true,
  onEncryptedCapture: true,
  onEndedCapture: true,
  onErrorCapture: true,
  onLoadedDataCapture: true,
  onLoadedMetadataCapture: true,
  onLoadStartCapture: true,
  onPauseCapture: true,
  onPlayCapture: true,
  onPlayingCapture: true,
  onProgressCapture: true,
  onRateChangeCapture: true,
  onSeekedCapture: true,
  onSeekingCapture: true,
  onStalledCapture: true,
  onSuspendCapture: true,
  onTimeUpdateCapture: true,
  onVolumeChangeCapture: true,
  onWaitingCapture: true,
  onLoadCapture: true,
  onAnimationStartCapture: true,
  onAnimationEndCapture: true,
  onAnimationIterationCapture: true,
  onTransitionEndCapture: true
};

/* From HTMLDOMPropertyConfig */
var htmlProps = {
  /**
   * Standard Properties
   */
  accept: true,
  acceptCharset: true,
  accessKey: true,
  action: true,
  allowFullScreen: true,
  allowTransparency: true,
  alt: true,
  // specifies target context for links with `preload` type
  as: true,
  async: true,
  autoComplete: true,
  // autoFocus is polyfilled/normalized by AutoFocusUtils
  // autoFocus: true,
  autoPlay: true,
  capture: true,
  cellPadding: true,
  cellSpacing: true,
  charSet: true,
  challenge: true,
  checked: true,
  cite: true,
  classID: true,
  className: true,
  cols: true,
  colSpan: true,
  content: true,
  contentEditable: true,
  contextMenu: true,
  controls: true,
  coords: true,
  crossOrigin: true,
  data: true, // For `<object />` acts as `src`.
  dateTime: true,
  default: true,
  defer: true,
  dir: true,
  disabled: true,
  download: true,
  draggable: true,
  encType: true,
  form: true,
  formAction: true,
  formEncType: true,
  formMethod: true,
  formNoValidate: true,
  formTarget: true,
  frameBorder: true,
  headers: true,
  height: true,
  hidden: true,
  high: true,
  href: true,
  hrefLang: true,
  htmlFor: true,
  httpEquiv: true,
  icon: true,
  id: true,
  inputMode: true,
  integrity: true,
  is: true,
  keyParams: true,
  keyType: true,
  kind: true,
  label: true,
  lang: true,
  list: true,
  loop: true,
  low: true,
  manifest: true,
  marginHeight: true,
  marginWidth: true,
  max: true,
  maxLength: true,
  media: true,
  mediaGroup: true,
  method: true,
  min: true,
  minLength: true,
  // Caution; `option.selected` is not updated if `select.multiple` is
  // disabled with `removeAttribute`.
  multiple: true,
  muted: true,
  name: true,
  nonce: true,
  noValidate: true,
  open: true,
  optimum: true,
  pattern: true,
  placeholder: true,
  playsInline: true,
  poster: true,
  preload: true,
  profile: true,
  radioGroup: true,
  readOnly: true,
  referrerPolicy: true,
  rel: true,
  required: true,
  reversed: true,
  role: true,
  rows: true,
  rowSpan: true,
  sandbox: true,
  scope: true,
  scoped: true,
  scrolling: true,
  seamless: true,
  selected: true,
  shape: true,
  size: true,
  sizes: true,
  span: true,
  spellCheck: true,
  src: true,
  srcDoc: true,
  srcLang: true,
  srcSet: true,
  start: true,
  step: true,
  style: true,
  summary: true,
  tabIndex: true,
  target: true,
  title: true,
  // Setting .type throws on non-<input> tags
  type: true,
  useMap: true,
  value: true,
  width: true,
  wmode: true,
  wrap: true,

  /**
   * RDFa Properties
   */
  about: true,
  datatype: true,
  inlist: true,
  prefix: true,
  // property is also supported for OpenGraph in meta tags.
  property: true,
  resource: true,
  typeof: true,
  vocab: true,

  /**
   * Non-standard Properties
   */
  // autoCapitalize and autoCorrect are supported in Mobile Safari for
  // keyboard hints.
  autoCapitalize: true,
  autoCorrect: true,
  // autoSave allows WebKit/Blink to persist values of input fields on page reloads
  autoSave: true,
  // color is for Safari mask-icon link
  color: true,
  // itemProp, itemScope, itemType are for
  // Microdata support. See http://schema.org/docs/gs.html
  itemProp: true,
  itemScope: true,
  itemType: true,
  // itemID and itemRef are for Microdata support as well but
  // only specified in the WHATWG spec document. See
  // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
  itemID: true,
  itemRef: true,
  // results show looking glass icon and recent searches on input
  // search fields in WebKit/Blink
  results: true,
  // IE-only attribute that specifies security restrictions on an iframe
  // as an alternative to the sandbox attribute on IE<10
  security: true,
  // IE-only attribute that controls focus behavior
  unselectable: 0
};

var svgProps = {
  accentHeight: true,
  accumulate: true,
  additive: true,
  alignmentBaseline: true,
  allowReorder: true,
  alphabetic: true,
  amplitude: true,
  arabicForm: true,
  ascent: true,
  attributeName: true,
  attributeType: true,
  autoReverse: true,
  azimuth: true,
  baseFrequency: true,
  baseProfile: true,
  baselineShift: true,
  bbox: true,
  begin: true,
  bias: true,
  by: true,
  calcMode: true,
  capHeight: true,
  clip: true,
  clipPath: true,
  clipRule: true,
  clipPathUnits: true,
  colorInterpolation: true,
  colorInterpolationFilters: true,
  colorProfile: true,
  colorRendering: true,
  contentScriptType: true,
  contentStyleType: true,
  cursor: true,
  cx: true,
  cy: true,
  d: true,
  decelerate: true,
  descent: true,
  diffuseConstant: true,
  direction: true,
  display: true,
  divisor: true,
  dominantBaseline: true,
  dur: true,
  dx: true,
  dy: true,
  edgeMode: true,
  elevation: true,
  enableBackground: true,
  end: true,
  exponent: true,
  externalResourcesRequired: true,
  fill: true,
  fillOpacity: true,
  fillRule: true,
  filter: true,
  filterRes: true,
  filterUnits: true,
  floodColor: true,
  floodOpacity: true,
  focusable: true,
  fontFamily: true,
  fontSize: true,
  fontSizeAdjust: true,
  fontStretch: true,
  fontStyle: true,
  fontVariant: true,
  fontWeight: true,
  format: true,
  from: true,
  fx: true,
  fy: true,
  g1: true,
  g2: true,
  glyphName: true,
  glyphOrientationHorizontal: true,
  glyphOrientationVertical: true,
  glyphRef: true,
  gradientTransform: true,
  gradientUnits: true,
  hanging: true,
  horizAdvX: true,
  horizOriginX: true,
  ideographic: true,
  imageRendering: true,
  in: true,
  in2: true,
  intercept: true,
  k: true,
  k1: true,
  k2: true,
  k3: true,
  k4: true,
  kernelMatrix: true,
  kernelUnitLength: true,
  kerning: true,
  keyPoints: true,
  keySplines: true,
  keyTimes: true,
  lengthAdjust: true,
  letterSpacing: true,
  lightingColor: true,
  limitingConeAngle: true,
  local: true,
  markerEnd: true,
  markerMid: true,
  markerStart: true,
  markerHeight: true,
  markerUnits: true,
  markerWidth: true,
  mask: true,
  maskContentUnits: true,
  maskUnits: true,
  mathematical: true,
  mode: true,
  numOctaves: true,
  offset: true,
  opacity: true,
  operator: true,
  order: true,
  orient: true,
  orientation: true,
  origin: true,
  overflow: true,
  overlinePosition: true,
  overlineThickness: true,
  paintOrder: true,
  panose1: true,
  pathLength: true,
  patternContentUnits: true,
  patternTransform: true,
  patternUnits: true,
  pointerEvents: true,
  points: true,
  pointsAtX: true,
  pointsAtY: true,
  pointsAtZ: true,
  preserveAlpha: true,
  preserveAspectRatio: true,
  primitiveUnits: true,
  r: true,
  radius: true,
  refX: true,
  refY: true,
  renderingIntent: true,
  repeatCount: true,
  repeatDur: true,
  requiredExtensions: true,
  requiredFeatures: true,
  restart: true,
  result: true,
  rotate: true,
  rx: true,
  ry: true,
  scale: true,
  seed: true,
  shapeRendering: true,
  slope: true,
  spacing: true,
  specularConstant: true,
  specularExponent: true,
  speed: true,
  spreadMethod: true,
  startOffset: true,
  stdDeviation: true,
  stemh: true,
  stemv: true,
  stitchTiles: true,
  stopColor: true,
  stopOpacity: true,
  strikethroughPosition: true,
  strikethroughThickness: true,
  string: true,
  stroke: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeLinecap: true,
  strokeLinejoin: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  surfaceScale: true,
  systemLanguage: true,
  tableValues: true,
  targetX: true,
  targetY: true,
  textAnchor: true,
  textDecoration: true,
  textRendering: true,
  textLength: true,
  to: true,
  transform: true,
  u1: true,
  u2: true,
  underlinePosition: true,
  underlineThickness: true,
  unicode: true,
  unicodeBidi: true,
  unicodeRange: true,
  unitsPerEm: true,
  vAlphabetic: true,
  vHanging: true,
  vIdeographic: true,
  vMathematical: true,
  values: true,
  vectorEffect: true,
  version: true,
  vertAdvY: true,
  vertOriginX: true,
  vertOriginY: true,
  viewBox: true,
  viewTarget: true,
  visibility: true,
  widths: true,
  wordSpacing: true,
  writingMode: true,
  x: true,
  xHeight: true,
  x1: true,
  x2: true,
  xChannelSelector: true,
  xlinkActuate: true,
  xlinkArcrole: true,
  xlinkHref: true,
  xlinkRole: true,
  xlinkShow: true,
  xlinkTitle: true,
  xlinkType: true,
  xmlBase: true,
  xmlns: true,
  xmlnsXlink: true,
  xmlLang: true,
  xmlSpace: true,
  y: true,
  y1: true,
  y2: true,
  yChannelSelector: true,
  z: true,
  zoomAndPan: true
};

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var hasOwnProperty = {}.hasOwnProperty;
var validAttr = (function (name) {
  return hasOwnProperty.call(htmlProps, name) || hasOwnProperty.call(svgProps, name) || isCustomAttribute(name.toLowerCase()) || hasOwnProperty.call(reactProps, name);
});

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      


var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

//      
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

var warnChannelDeprecated = once(function () {
  // eslint-disable-next-line no-console
  console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
});
/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      warnChannelDeprecated();

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) this.broadcast.publish(this.getTheme(nextProps.theme));
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (__WEBPACK_IMPORTED_MODULE_4_is_function___default()(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(mergedTheme)) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

//      

var escapeRegex = /[[\].#*$><+~=|^:(),"'`]/g;
var multiDashRegex = /--+/g;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  /* We depend on components having unique IDs */
  var identifiers = {};
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : _displayName.replace(escapeRegex, '-') // Replace all possible CSS selectors
    .replace(multiDashRegex, '-'); // Replace multiple -- with single -

    var nr = (identifiers[displayName] || 0) + 1;
    identifiers[displayName] = nr;

    var hash = ComponentStyle.generateName(displayName + nr);
    var componentId = displayName + '-' + hash;
    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (warnTooManyClasses !== undefined) warnTooManyClasses(className);

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a staticaly-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? options.displayName + '-' + options.componentId : componentId;

    var warnTooManyClasses = void 0;
    if (false) {
      warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : getComponentName(tag));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.warnTooManyClasses = warnTooManyClasses;
    StyledComponent.target = target;


    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled copmonent
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = isStaticRules(rules, attrs);
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          lastClassName = this.lastClassName;

      if (isStatic && lastClassName !== undefined) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName !== undefined) {
        if (styleSheet.stylesCacheable) {
          this.lastClassName = existingName;
        }
        return existingName;
      }

      var name = nameGenerator(hash);
      if (styleSheet.stylesCacheable) {
        this.lastClassName = existingName;
      }
      if (styleSheet.alreadyInjected(hash, name)) {
        return name;
      }

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      // NOTE: this can only be set when we inject the class-name.
      // For some reason, presumably due to how css is stringifyRules behaves in
      // differently between client and server, styles break.
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

//      
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

//      


var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (typeof tag !== 'string' && typeof tag !== 'function') {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs) }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var isStyledComponent$$1 = isStyledComponent(Component$$1);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: isStyledComponent$$1 ? innerRef : undefined,
        ref: isStyledComponent$$1 ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);


/***/ }),
/* 1445 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */



module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};


/***/ }),
/* 1446 */
/***/ (function(module, exports) {

module.exports = isFunction

var toString = Object.prototype.toString

function isFunction (fn) {
  var string = toString.call(fn)
  return string === '[object Function]' ||
    (typeof fn === 'function' && string !== '[object RegExp]') ||
    (typeof window !== 'undefined' &&
     // IE8 and below
     (fn === window.setTimeout ||
      fn === window.alert ||
      fn === window.confirm ||
      fn === window.prompt))
};


/***/ }),
/* 1447 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ConfirmationNumber__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ConfirmationNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ConfirmationNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FileCopy__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FileCopy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FileCopy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_BarChart__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_BarChart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_BarChart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__provider_base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Events=function(_React$PureComponent){_inherits(Events,_React$PureComponent);function Events(props){_classCallCheck(this,Events);var _this=_possibleConstructorReturn(this,(Events.__proto__||Object.getPrototypeOf(Events)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,events:[],filter:"",eventForDelete:false};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteEventSuccess=_this.getDeleteEventSuccess.bind(_this);_this.onConfirmDeleteEvent=_this.onConfirmDeleteEvent.bind(_this);_this.onAddEvent=_this.onAddEvent.bind(_this);_this.onCopyEvent=_this.onCopyEvent.bind(_this);_this.onStatisticEvent=_this.onStatisticEvent.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(Events,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.login){this.props.actionGetEvents(this.onChangePage,this.getEventsError);}}},{key:"getEventsError",value:function getEventsError(e){console.log("ERROR EVENTS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"Ocurrió un error al listar los eventos.");}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var events=this.props.eventList.filter(function(e){return e.evtName.match(filter);});var count=events.length;events=events.slice(from,end);this.setState({page:newPage,count:count,events:events});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var events=this.props.eventList.filter(function(e){return e.evtName.match(filter);});var count=events.length;events=events.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,events:events});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onStatisticEvent",value:function onStatisticEvent(event){var _this2=this;this.props.actionStatisticsByEvent(event,function(){return _this2.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["h" /* EVENTS_STATISTICS_ROUTE */]);},this.getStatisticEventError);}},{key:"getStatisticEventError",value:function getStatisticEventError(e){console.log("ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"Ocurrió un error al consultar las estadísticas del evento.");}},{key:"onCopyEvent",value:function onCopyEvent(event){this.props.actionSelectEvent(event);this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["b" /* EVENTS_COPY_ROUTE */]);}},{key:"onAddEvent",value:function onAddEvent(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["a" /* EVENTS_ADD_ROUTE */]);}},{key:"onTicketTypes",value:function onTicketTypes(event){this.props.actionSelectEvent(event);this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["A" /* TICKET_TYPES_ROUTE */]);}},{key:"onTickets",value:function onTickets(event){this.props.actionSelectEvent(event);this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["x" /* TICKETS_ROUTE */]);}},{key:"onEditEvent",value:function onEditEvent(event){this.props.actionSelectEvent(event);this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["c" /* EVENTS_EDIT_ROUTE */]);}},{key:"onConfirmDeleteEvent",value:function onConfirmDeleteEvent(){this.props.actionDeleteEvent(this.state.eventForDelete,this.getDeleteEventSuccess,this.getDeleteEventError);this.setState({eventForDelete:false});}},{key:"onDeleteEvent",value:function onDeleteEvent(event){this.setState({eventForDelete:event});}},{key:"getDeleteEventSuccess",value:function getDeleteEventSuccess(){var _this3=this;this.props.actionGetEvents(function(){_this3.onChangePage(null,_this3.state.page);},this.getEventsError);}},{key:"getDeleteEventError",value:function getDeleteEventError(e){console.log("ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar el evento.");}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Nombre","Descripción","Fecha","Status","Creado por","Modificado por"];if(__WEBPACK_IMPORTED_MODULE_16__provider_base_Settings___default.a.IS_USER_VERIFIED){headers.splice(2,0,"Venta verificada");}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this4=this;var theme=this.props.theme;var events=this.state.events;if(!events||events.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return events.map(function(item,index){// console.log(index, item)
var isActive=item.evtState.toLowerCase()=="active";var isVerified=item.evtSellVerify;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.evtDescription),__WEBPACK_IMPORTED_MODULE_16__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:isVerified?theme.table.activeCell:theme.overrides.MuiTableCell.body},isVerified?"SI":"NO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(item.evtDateTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body},isActive?"ACTIVO":"INACTIVO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.evtCreateUser),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.evtLastUpdateUser),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:Object.assign({},theme.table.actionsColumn,{minWidth:256})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Gestionar tickets"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onTickets.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["x" /* Icon */],{className:"fa fa-film"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Estad\xEDsticas del evento"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onStatisticEvent.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_BarChart___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Copiar evento"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onCopyEvent.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FileCopy___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Gestionar tipos de tickets"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onTicketTypes.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ConfirmationNumber___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Editar evento"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onEditEvent.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar evento"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this4.onDeleteEvent.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete___default.a,null)))));});}},{key:"render",value:function render(){var _this5=this;var _props=this.props,theme=_props.theme,eventList=_props.eventList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Eventos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea eventos")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de eventos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Crear nuevo evento"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddEvent,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.eventForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Evento"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el evento?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this5.setState({eventForDelete:null});}},"Cancelar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteEvent},"Eliminar")))));}}]);return Events;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,eventList:store.evt.eventList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetEvents:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["e" /* actionGetEvents */],actionDeleteEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["a" /* actionDeleteEvent */],actionStatisticsByEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["l" /* actionStatisticsByEvent */],actionSelectEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["k" /* actionSelectEvent */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Events))));

/***/ }),
/* 1449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__EventConfig__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var EventService=function(){function EventService(){_classCallCheck(this,EventService);}_createClass(EventService,null,[{key:"getEvents",/******* EVENTS **********/value:function getEvents(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointEvents;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](0);reject(_context.t0);case 14:case"end":return _context.stop();}}},_callee,_this,[[0,11]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"saveEvent",value:function saveEvent(app,event,isCopyWithTickets,userId){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointSaveEvent;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({event:event,isCopyWithTickets:isCopyWithTickets,userId:userId})});case 7:response=_context2.sent;console.log("RESPONSE SAVE EVENT",response);if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=15;break;case 12:_context2.prev=12;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 15:case"end":return _context2.stop();}}},_callee2,_this2,[[0,12]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"deleteEvent",value:function deleteEvent(app,eventId){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointDeleteEvent;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:eventId})});case 7:response=_context3.sent;console.log("RESPONSE DELETE EVENT",response,eventId);if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=15;break;case 12:_context3.prev=12;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 15:case"end":return _context3.stop();}}},_callee3,_this3,[[0,12]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}/******** FIN EVENTS *********//******** TICKET TYPES **********/},{key:"getTicketTypesByEvent",value:function getTicketTypesByEvent(app,eventId){var _this4=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context4.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointTicketTypes;_context4.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:eventId})});case 7:response=_context4.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context4.next=14;break;case 11:_context4.prev=11;_context4.t0=_context4["catch"](0);reject(_context4.t0);case 14:case"end":return _context4.stop();}}},_callee4,_this4,[[0,11]]);}));return function(_x7,_x8){return _ref4.apply(this,arguments);};}());}},{key:"saveTicketType",value:function saveTicketType(app,eventId,ticketType,userId){var _this5=this;return new Promise(function(){var _ref5=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee5(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee5$(_context5){while(1){switch(_context5.prev=_context5.next){case 0:_context5.prev=0;console.log("ticketType",ticketType);_context5.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context5.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointSaveTicketType;_context5.next=8;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId,ticketType:ticketType,userId:userId})});case 8:response=_context5.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context5.next=15;break;case 12:_context5.prev=12;_context5.t0=_context5["catch"](0);reject(_context5.t0);case 15:case"end":return _context5.stop();}}},_callee5,_this5,[[0,12]]);}));return function(_x9,_x10){return _ref5.apply(this,arguments);};}());}},{key:"deleteTicketType",value:function deleteTicketType(app,eventId,ticketTypeId){var _this6=this;return new Promise(function(){var _ref6=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee6(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee6$(_context6){while(1){switch(_context6.prev=_context6.next){case 0:_context6.prev=0;_context6.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context6.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointDeleteTicketType;_context6.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId,ticketTypeId:ticketTypeId})});case 7:response=_context6.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context6.next=14;break;case 11:_context6.prev=11;_context6.t0=_context6["catch"](0);reject(_context6.t0);case 14:case"end":return _context6.stop();}}},_callee6,_this6,[[0,11]]);}));return function(_x11,_x12){return _ref6.apply(this,arguments);};}());}},{key:"getCategories",value:function getCategories(app){var _this7=this;return new Promise(function(){var _ref7=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee7(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee7$(_context7){while(1){switch(_context7.prev=_context7.next){case 0:_context7.prev=0;_context7.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context7.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointCategories;_context7.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context7.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context7.next=14;break;case 11:_context7.prev=11;_context7.t0=_context7["catch"](0);reject(_context7.t0);case 14:case"end":return _context7.stop();}}},_callee7,_this7,[[0,11]]);}));return function(_x13,_x14){return _ref7.apply(this,arguments);};}());}/******* FIN TICKET TYPES**********//******** TICKETS **********/},{key:"getTicketsByEvent",value:function getTicketsByEvent(app,filter,order,limit){var _this8=this;return new Promise(function(){var _ref8=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee8(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee8$(_context8){while(1){switch(_context8.prev=_context8.next){case 0:_context8.prev=0;_context8.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context8.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointTickets;_context8.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({filter:filter,order:order,limit:limit})});case 7:response=_context8.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context8.next=14;break;case 11:_context8.prev=11;_context8.t0=_context8["catch"](0);reject(_context8.t0);case 14:case"end":return _context8.stop();}}},_callee8,_this8,[[0,11]]);}));return function(_x15,_x16){return _ref8.apply(this,arguments);};}());}},{key:"saveTickets",value:function saveTickets(app,eventId,tickets,producerId,origin,userId){var _this9=this;return new Promise(function(){var _ref9=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee9(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee9$(_context9){while(1){switch(_context9.prev=_context9.next){case 0:_context9.prev=0;_context9.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context9.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointSaveTickets;_context9.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnectorLarge.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId,tickets:tickets})});case 7:response=_context9.sent;console.log("RESPONSE SAVE TICKET",response);if(response.status==200){resolve(response.body);}else{reject(response);}_context9.next=15;break;case 12:_context9.prev=12;_context9.t0=_context9["catch"](0);reject(_context9.t0);case 15:case"end":return _context9.stop();}}},_callee9,_this9,[[0,12]]);}));return function(_x17,_x18){return _ref9.apply(this,arguments);};}());}},{key:"transferTicket",value:function transferTicket(app,requestObj){var _this10=this;var senderDocument=requestObj.senderDocument,receiverDocument=requestObj.receiverDocument;return new Promise(function(){var _ref10=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee10(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee10$(_context10){while(1){switch(_context10.prev=_context10.next){case 0:_context10.prev=0;_context10.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context10.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointTransfer+"?senderDocument="+senderDocument+"&receiverDocument="+receiverDocument;_context10.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(requestObj)});case 7:response=_context10.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context10.next=14;break;case 11:_context10.prev=11;_context10.t0=_context10["catch"](0);reject(_context10.t0);case 14:case"end":return _context10.stop();}}},_callee10,_this10,[[0,11]]);}));return function(_x19,_x20){return _ref10.apply(this,arguments);};}());}},{key:"deleteTicket",value:function deleteTicket(app,eventId,ticketId,du,tktState){var _this11=this;return new Promise(function(){var _ref11=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee11(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee11$(_context11){while(1){switch(_context11.prev=_context11.next){case 0:_context11.prev=0;_context11.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context11.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointDeleteTicket;_context11.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId,ticketId:ticketId,du:du,tktState:tktState})});case 7:response=_context11.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context11.next=14;break;case 11:_context11.prev=11;_context11.t0=_context11["catch"](0);reject(_context11.t0);case 14:case"end":return _context11.stop();}}},_callee11,_this11,[[0,11]]);}));return function(_x21,_x22){return _ref11.apply(this,arguments);};}());}/******* FIN TICKET **********//******* STATISTICS **********/},{key:"getStatistics",value:function getStatistics(app,eventId){var _this12=this;return new Promise(function(){var _ref12=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee12(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee12$(_context12){while(1){switch(_context12.prev=_context12.next){case 0:_context12.prev=0;_context12.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context12.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointStatistics;_context12.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId})});case 7:response=_context12.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context12.next=14;break;case 11:_context12.prev=11;_context12.t0=_context12["catch"](0);reject(_context12.t0);case 14:case"end":return _context12.stop();}}},_callee12,_this12,[[0,11]]);}));return function(_x23,_x24){return _ref12.apply(this,arguments);};}());}//Deprecada
// static getStatisticsRRPP(app, eventId) {
//   return new Promise(async (resolve, reject) => {
//     try{
//       let token = await AuthService.getToken()
//       let endpoint = EventConfig.endpointStatisticsRRPP
//       let response = await EventConfig.APIConnector.post(endpoint, {
//           headers: { Authorization: "Bearer " + token, App:app },
//           body:JSON.stringify({eventId:eventId})
//       });
//       if(response.status==200){
//         resolve(response.body)
//       }else{
//         reject(response)
//       }
//     }catch(e){
//       reject(e)
//     }
//   });
// }
},{key:"getStatisticsDirectRRPP",value:function getStatisticsDirectRRPP(app,eventId){var _this13=this;return new Promise(function(){var _ref13=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee13(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee13$(_context13){while(1){switch(_context13.prev=_context13.next){case 0:_context13.prev=0;_context13.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context13.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointStatisticsDirectRRPP;_context13.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId})});case 7:response=_context13.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context13.next=14;break;case 11:_context13.prev=11;_context13.t0=_context13["catch"](0);reject(_context13.t0);case 14:case"end":return _context13.stop();}}},_callee13,_this13,[[0,11]]);}));return function(_x25,_x26){return _ref13.apply(this,arguments);};}());}},{key:"getStatisticsReferencedRRPP",value:function getStatisticsReferencedRRPP(app,eventId){var _this14=this;return new Promise(function(){var _ref14=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee14(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee14$(_context14){while(1){switch(_context14.prev=_context14.next){case 0:_context14.prev=0;_context14.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context14.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointStatisticsReferencedRRPP;_context14.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId})});case 7:response=_context14.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context14.next=14;break;case 11:_context14.prev=11;_context14.t0=_context14["catch"](0);reject(_context14.t0);case 14:case"end":return _context14.stop();}}},_callee14,_this14,[[0,11]]);}));return function(_x27,_x28){return _ref14.apply(this,arguments);};}());}},{key:"getStatisticsProducer",value:function getStatisticsProducer(app,eventId){var _this15=this;return new Promise(function(){var _ref15=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee15(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee15$(_context15){while(1){switch(_context15.prev=_context15.next){case 0:_context15.prev=0;_context15.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context15.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].endpointStatisticsProducer;_context15.next=7;return __WEBPACK_IMPORTED_MODULE_1__EventConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({eventId:eventId})});case 7:response=_context15.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context15.next=14;break;case 11:_context15.prev=11;_context15.t0=_context15["catch"](0);reject(_context15.t0);case 14:case"end":return _context15.stop();}}},_callee15,_this15,[[0,11]]);}));return function(_x29,_x30){return _ref15.apply(this,arguments);};}());}/******* FIN STATISTICS **********/}]);return EventService;}();/* harmony default export */ __webpack_exports__["a"] = (EventService);

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var apiConnectorLarge=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:120000});var EventConfig=function(){function EventConfig(){_classCallCheck(this,EventConfig);}_createClass(EventConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpoint_v2",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN_V2;}},{key:"endpointEvents",get:function get(){return EventConfig.endpoint+"/events";}},{key:"endpointTransfer",get:function get(){return EventConfig.endpoint+"/payment/mpago/transfer-ticket-document";}},{key:"endpointSaveEvent",get:function get(){return EventConfig.endpointEvents+"/save";}},{key:"endpointDeleteEvent",get:function get(){return EventConfig.endpointEvents+"/delete";}},{key:"endpointTicketTypes",get:function get(){return EventConfig.endpointEvents+"/ticketTypes";}},{key:"endpointSaveTicketType",get:function get(){return EventConfig.endpointTicketTypes+"/save";}},{key:"endpointDeleteTicketType",get:function get(){return EventConfig.endpointTicketTypes+"/delete";}},{key:"endpointCategories",get:function get(){return EventConfig.endpointTicketTypes+"/categories";}},{key:"endpointTickets",get:function get(){return EventConfig.endpointEvents+"/tickets";}},{key:"endpointSaveTickets",get:function get(){// return `${EventConfig.endpointTickets}/save`;
return EventConfig.endpoint_v2+"/events/tickets/save";}},{key:"endpointDeleteTicket",get:function get(){return EventConfig.endpointTickets+"/delete";}},{key:"endpointStatistics",get:function get(){return EventConfig.endpointEvents+"/statistics";}//Deprecada
// static get endpointStatisticsRRPP() {
//   return `${EventConfig.endpointEvents}/rrpp`;
// }
},{key:"endpointStatisticsDirectRRPP",get:function get(){return EventConfig.endpointEvents+"/detail-direct-rrpp";}},{key:"endpointStatisticsReferencedRRPP",get:function get(){return EventConfig.endpointEvents+"/detail-referenced-rrpp";}},{key:"endpointStatisticsProducer",get:function get(){return EventConfig.endpointEvents+"/detail-producer";}},{key:"APIConnector",get:function get(){return apiConnector;}},{key:"APIConnectorLarge",get:function get(){return apiConnectorLarge;}}]);return EventConfig;}();/* harmony default export */ __webpack_exports__["a"] = (EventConfig);

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_FirebaseConnector__ = __webpack_require__(456);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var firebaseConnector=new __WEBPACK_IMPORTED_MODULE_1__lib_FirebaseConnector__["a" /* default */]({timeout:30000});var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:40000});var MediaConfig=function(){function MediaConfig(){_classCallCheck(this,MediaConfig);}_createClass(MediaConfig,null,[{key:"APIConnector",get:function get(){return apiConnector;}},{key:"base",get:function get(){return __WEBPACK_IMPORTED_MODULE_2__base_Settings___default.a.SERVER_URL;}/*INIT_INJECT_API_REST_MEDIA_CONFIG*//*END_INJECT_API_REST_MEDIA_CONFIG*/},{key:"FirebaseConnector",get:function get(){return firebaseConnector;}}]);return MediaConfig;}();/* harmony default export */ __webpack_exports__["a"] = (MediaConfig);

/***/ }),
/* 1452 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm-1 4l6 6v10c0 1.1-.9 2-2 2H7.99C6.89 23 6 22.1 6 21l.01-14c0-1.1.89-2 1.99-2h7zm-1 7h5.5L14 6.5V12z"
}), 'FileCopy');

exports.default = _default;

/***/ }),
/* 1453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_TagActions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_GoogleMapLocation__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ImageSelector_ImageSelector__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_lab_Autocomplete__ = __webpack_require__(152);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var filterTag=Object(__WEBPACK_IMPORTED_MODULE_21__material_ui_lab_Autocomplete__["a" /* createFilterOptions */])();var AddEditEvents=function(_React$PureComponent){_inherits(AddEditEvents,_React$PureComponent);function AddEditEvents(props){_classCallCheck(this,AddEditEvents);var _this=_possibleConstructorReturn(this,(AddEditEvents.__proto__||Object.getPrototypeOf(AddEditEvents)).call(this,props));_this.state={imgEdit:null,imgNameEdit:null,addPlace:false,imgError:"",tags:[],placeError:"",newPlaceName:"",newPlaceLocation:null,newPlaceAddress:"",placeSelected:"",placeItemSelected:null,copyTickets:true,errorPlaceName:undefined,tagsSelected:[],errorPlaceAddress:undefined};_this.onClean=_this.onClean.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onSaveNewPlace=_this.onSaveNewPlace.bind(_this);_this.onSelectTag=_this.onSelectTag.bind(_this);_this.onChangePlace=_this.onChangePlace.bind(_this);_this.onChangePlacesName=_this.onChangePlacesName.bind(_this);_this.onDeleteRenderTag=_this.onDeleteRenderTag.bind(_this);_this.onChangePlacesAddress=_this.onChangePlacesAddress.bind(_this);_this.getPlaces=_this.getPlaces.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(AddEditEvents,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _props$event=this.props.event,lastEventFormValues=_props$event===undefined?{}:_props$event;var _lastEventFormValues$=lastEventFormValues.evtTags,lastEvtTags=_lastEventFormValues$===undefined?[]:_lastEventFormValues$;var _nextProps$event=nextProps.event,newEvtFormValues=_nextProps$event===undefined?{}:_nextProps$event;var _newEvtFormValues$tkt=newEvtFormValues.tktTags,newEvtTags=_newEvtFormValues$tkt===undefined?[]:_newEvtFormValues$tkt;if(!this.isArrayEqual(lastEvtTags,newEvtTags)){this.setState({tagsSelected:lastEvtTags});}}},{key:"isArrayEqual",value:function isArrayEqual(x,y){return __WEBPACK_IMPORTED_MODULE_20_lodash___default()(x).differenceWith(y,__WEBPACK_IMPORTED_MODULE_20_lodash___default.a.isEqual).isEmpty();}},{key:"componentWillMount",value:function componentWillMount(){var _this2=this;if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}if(this.props.isEditing||this.props.isCopy){var event=this.props.event;if(event){event.evtDateTime=event.evtDateTime&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(event.evtDateTime).format("YYYY-MM-DDTHH:mm");event.evtInitDate=event.evtInitDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(event.evtInitDate).format("YYYY-MM-DDTHH:mm");event.evtEndDate=event.evtEndDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(event.evtEndDate).format("YYYY-MM-DDTHH:mm");if(__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default.a.IS_USER_VERIFIED){event.evtSellVerify=event.evtSellVerify||false;}this.props.initialize(event);this.getPlaces(function(){var placesFiltered=_this2.props.placeList.filter(function(p){return p.plcName==event.evtPlace;});if(placesFiltered&&placesFiltered.length){_this2.setState({placeSelected:placesFiltered[0].plcName,placeItemSelected:placesFiltered[0]});}});this.setState({imgEdit:event.evtImg,imgNameEdit:event.evtImgName});}else{this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}else{var _event={evtState:"active",evtSellRrppEnable:false};if(__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default.a.IS_USER_VERIFIED){_event.evtSellVerify=false;}this.props.initialize(_event);this.getPlaces();}this.props.actionGetTags(function(){_this2.setState({tags:_this2.props.tagList});},function(e){console.log("ERROR AL LISTAR TAGS",e);});}},{key:"getPlaces",value:function getPlaces(success){this.props.actionGetPlaces(success,function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"No pudimos listar las ubicaciones");});}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);if(error.evtImg){this.setState({imgError:error.evtImg});}if(!this.state.placeSelected){this.setState({placeError:Object(__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */])(null)});}}},{key:"onClean",value:function onClean(){var cleanEvent={evtState:"active",evtSellRrppEnable:"false"};if(this.props.isEditing){var event=this.props.event;if(__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default.a.IS_USER_VERIFIED){cleanEvent.evtSellVerify="false";}cleanEvent.evtImgPath=event.evtImgPath;cleanEvent.id=event.id;this.props.initialize();}else{if(__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default.a.IS_USER_VERIFIED){cleanEvent.evtSellVerify="false";}this.props.initialize(cleanEvent);}this.setState({imgEdit:null,imgNameEdit:null,imgError:"",placeError:""});}},{key:"onSave",value:function onSave(formValues){var _this3=this;var _state$tagsSelected=this.state.tagsSelected,tagsSelected=_state$tagsSelected===undefined?[]:_state$tagsSelected;formValues.evtTags=tagsSelected;if(!this.state.placeSelected){this.setState({placeError:Object(__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */])(null)});return;}var isCopyWithTickets=this.props.isCopy&&this.state.copyTickets;if(this.props.isCopy&&!this.state.copyTickets){//Si estoy copiando pero no seleccionó la opción para copiar tickets
delete formValues.id;//Quito el id para que haga la copia del evento
}this.props.actionSaveEvent(formValues,isCopyWithTickets,function(){__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["b" /* SUCCESS */],"El evento se guardó correctamente.");_this3.props.history.goBack();},function(e){console.log("ERROR ON SAVE EVENT",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"No se pudo guardar el evento.");});}},{key:"onSaveNewPlace",value:function onSaveNewPlace(){var _this4=this;if(this.state.newPlaceName&&this.state.newPlaceAddress){var placeLocation={_latitude:this.state.newPlaceLocation.lat(),_longitude:this.state.newPlaceLocation.lng()};var place={plcName:this.state.newPlaceName,plcAddress:this.state.newPlaceAddress,plcCoordinates:placeLocation};this.props.actionSavePlace(place,function(){return _this4.getPlaces(_this4.onChangePlace(null,place));},function(e){console.log("ERROR ON SAVE NEW PLACE",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"No pudimos agregar la ubicación");});this.setState({addPlace:false,placeSelected:place.plcName});}else{if(!this.state.newPlaceName){this.setState({errorPlaceName:"Debe ingresar un nombre para la ubicación"});}if(!this.state.newPlaceAddress){this.setState({errorPlaceAddress:"Debe ingresar una dirección para la ubicación"});}}}},{key:"onChangePlace",value:function onChangePlace(evt,place){if(place){this.props.change("evtPlaceId",place.id);this.props.change("evtPlace",place.plcName);this.props.change("evtPlaceAddress",place.plcAddress);this.props.change("evtCoordinates",place.plcCoordinates);this.setState({placeSelected:place.plcName,placeItemSelected:place,placeError:""});}else{this.props.change("evtPlaceId",null);this.props.change("evtPlace",null);this.props.change("evtPlaceAddress",null);this.props.change("evtCoordinates",null);this.setState({placeSelected:"",placeItemSelected:null});}}},{key:"onSelectTag",value:function onSelectTag(evt,tag){var tags=tag.slice();this.setState({tagsSelected:tags});}},{key:"onDeleteRenderTag",value:function onDeleteRenderTag(type,tag){var tags=null;var idx=-1;tags=this.state.tagsSelected.slice();idx=tags.findIndex(function(t){return t.id==tag.id;});if(idx>=0){tags.splice(idx,1);}this.setState({tagsSelected:tags});console.log("ON DELETE RENDER TAG",type,tag,idx);}},{key:"onChangePlacesName",value:function onChangePlacesName(evt){var txt=evt.target.value;if(txt){this.setState({newPlaceName:txt,errorPlaceName:undefined});}else{this.setState({newPlaceName:txt,errorPlaceName:"Debe ingresar un nombre para la ubicación"});}}},{key:"renderTags",value:function renderTags(type,tags){var _this5=this;var t=tags&&tags.filter(function(t){return!t.add;});return t&&t.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:tag.tagName,onDelete:_this5.onDeleteRenderTag.bind(_this5,type,tag),avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:tag.tagColor,color:"rgb(0,0,0,0.60"}},tag.tagName.substring(0,1))});});}},{key:"onChangePlacesAddress",value:function onChangePlacesAddress(evt){var txt=evt.target.value;if(txt){this.setState({newPlaceAddress:txt,errorPlaceAddress:undefined});}else{this.setState({newPlaceAddress:txt,errorPlaceAddress:"Debe ingresar una dirección para la ubicación"});}}},{key:"render",value:function render(){var _this6=this;var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,isEditing=_props.isEditing,isCopy=_props.isCopy;var title=isEditing?"Editar Evento":isCopy?"Copiar Evento":"Crear Evento";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Crear Eventos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea Eventos"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,xs:12,spacing:3,direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtTitle",label:"T\xEDtulo del evento",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtDescription",label:"Descripci\xF3n",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.imgError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ImageSelector_ImageSelector__["a" /* default */],{fieldName:"evtImg",validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]],fileDimentions:{width:750,height:370},styleButton:theme.imageSelector,imagePreviewUrl:this.state.imgEdit,fileName:this.state.imgNameEdit,fileSize:400000,noPreview:true,onChangeState:function onChangeState(){_this6.setState({imgError:""});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["t" /* FormHelperText */],null,this.state.imgError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,direction:"row",xs:12,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtDateTime",label:"Fecha del evento",type:"datetime-local",InputLabelProps:{shrink:true},fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.placeError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{className:"display-flex",style:{alignItems:"flex-end"},fullWidth:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_lab_Autocomplete__["b" /* default */],{options:this.props.placeList,getOptionLabel:function getOptionLabel(option){return option.plcName;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true,label:"Ubicaci\xF3n",error:_this6.state.placeError?true:false}));},onChange:this.onChangePlace,value:this.state.placeItemSelected,inputValue:this.state.placeSelected,freeSolo:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["q" /* Fab */],{onClick:function onClick(){return _this6.setState({addPlace:true,newPlaceName:"",newPlaceLocation:null,newPlaceAddress:""});},color:"primary",size:"small",style:{height:30,marginLeft:6}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add___default.a,{fontSize:"small"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["t" /* FormHelperText */],null,this.state.placeError)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,direction:"row",xs:12,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtInitDate",label:"Fecha/Hora Inicio disponibilidad",type:"datetime-local",InputLabelProps:{shrink:true},fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtEndDate",label:"Fecha/Hora Fin disponibilidad",type:"datetime-local",InputLabelProps:{shrink:true},fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFEvento Activo?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"evtState",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:"active"},"ACTIVO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:"inactive"},"INACTIVO")))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"evtConditions",label:"Condiciones del evento",fullWidth:true,multiline:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,xs:12,spacing:3,justify:"center"},__WEBPACK_IMPORTED_MODULE_19__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3,spacing:0,justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFVenta verificada?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"evtSellVerify",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3,spacing:0,justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFHabilitada venta RRPP?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"evtSellRrppEnable",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),this.props.isCopy&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3,spacing:0,justify:"center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFCopiar Tipo de Tickets?. Recuerde verificar la fecha de disponiblidad de los mismos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_Select__["default"],{fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]],value:this.state.copyTickets,onChange:function onChange(evt){_this6.setState({copyTickets:evt.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"40%",marginLeft:10,paddingRight:10,marginTop:24}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_lab_Autocomplete__["b" /* default */],{options:this.state.tags,value:this.state.tagsSelected,getOptionLabel:function getOptionLabel(option){return option.tagName;},filterOptions:function filterOptions(options,params){return filterTag(options,params);},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true,label:"Asocia el evento a un tag"}));},renderTags:this.renderTags.bind(this,"filter"),onChange:this.onSelectTag,loadingText:"Cargando tags ...",noOptionsText:"Sin tags",selectOnFocus:true,multiple:true,freeSolo:true,filterSelectedOptions:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Limpiar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.onClean},"Limpiar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.addPlace,draggable:true,onClose:function onClose(){return _this6.setState({addPlace:false});},disableBackdropClick:true,fullWidth:true,style:{zIndex:900},PaperProps:{style:{maxWidth:800}}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,"Agregar Ubicaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{className:"display-flex"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],{label:"Nombre",fullWidth:true,value:this.state.newPlaceName,onChange:this.onChangePlacesName,error:this.state.errorPlaceName?true:false,helperText:this.state.errorPlaceName}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],{label:"Direcci\xF3n",fullWidth:true,value:this.state.newPlaceAddress,onChange:this.onChangePlacesAddress,style:{marginLeft:10},error:this.state.errorPlaceAddress?true:false,helperText:this.state.errorPlaceAddress}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_GoogleMapLocation__["a" /* default */],{onChangeLocation:function onChangeLocation(value){return _this6.setState({newPlaceLocation:value});},onChangeAddress:function onChangeAddress(value){return _this6.setState({newPlaceAddress:value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cerrar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){return _this6.setState({addPlace:false});}},"Cerrar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onSaveNewPlace},"Guardar")))));}}]);return AddEditEvents;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE EVENT", store)
return{login:store.auth.login,tagList:store.tag.tagList,placeList:store.plc.placeList,event:store.evt.event};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionSaveEvent:__WEBPACK_IMPORTED_MODULE_17__actions_EventActions__["h" /* actionSaveEvent */],actionSavePlace:__WEBPACK_IMPORTED_MODULE_18__actions_PlaceActions__["c" /* actionSavePlace */],actionGetPlaces:__WEBPACK_IMPORTED_MODULE_18__actions_PlaceActions__["b" /* actionGetPlaces */],actionGetTags:__WEBPACK_IMPORTED_MODULE_9__actions_TagActions__["b" /* actionGetTags */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditEvent",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditEvents)))));

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__TagConfig__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserService=function(){function UserService(){_classCallCheck(this,UserService);}_createClass(UserService,null,[{key:"getTags",/******* Tags **********/value:function getTags(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].endpointTags;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;console.log("getTags",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);reject(_context.t0);case 15:case"end":return _context.stop();}}},_callee,_this,[[0,12]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"saveTag",value:function saveTag(app,tag){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;console.log("SERVICE SAVE TAG",tag);_context2.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].endpointSaveTag;console.log("ENDPOINT SAVE tag",endpoint);_context2.next=9;return __WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(tag)});case 9:response=_context2.sent;console.log("saveTag",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=17;break;case 14:_context2.prev=14;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 17:case"end":return _context2.stop();}}},_callee2,_this2,[[0,14]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"deleteTagFromUser",value:function deleteTagFromUser(app,tag,user){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;console.log("SERVICE DELETE TAG FROM USER",tag,user);_context3.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].endpointDeleteTagFromUser;console.log("ENDPOINT DELETE TAG FROM USER",endpoint);_context3.next=9;return __WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].APIConnector.delete(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({tag:tag,user:user})});case 9:response=_context3.sent;console.log("deleteTagFromUser",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=17;break;case 14:_context3.prev=14;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 17:case"end":return _context3.stop();}}},_callee3,_this3,[[0,14]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}},{key:"deleteTag",value:function deleteTag(app,tag){var _this4=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;console.log("SERVICE DELETE TAG",tag);_context4.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context4.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].endpointDeleteTag;console.log("ENDPOINT DELETE TAG",endpoint);_context4.next=9;return __WEBPACK_IMPORTED_MODULE_1__TagConfig__["a" /* default */].APIConnector.delete(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(tag)});case 9:response=_context4.sent;console.log("deleteTag",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context4.next=17;break;case 14:_context4.prev=14;_context4.t0=_context4["catch"](0);reject(_context4.t0);case 17:case"end":return _context4.stop();}}},_callee4,_this4,[[0,14]]);}));return function(_x7,_x8){return _ref4.apply(this,arguments);};}());}/******** FIN Tags *********/}]);return UserService;}();/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 1455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var RolConfig=function(){function RolConfig(){_classCallCheck(this,RolConfig);}_createClass(RolConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointTags",get:function get(){return RolConfig.endpoint+"/tags";}},{key:"endpointSaveTag",get:function get(){return RolConfig.endpointTags+"/save";}},{key:"endpointDeleteTag",get:function get(){return RolConfig.endpointTags+"/delete";}},{key:"endpointDeleteTagFromUser",get:function get(){return RolConfig.endpointTags+"/deleteFromUser";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return RolConfig;}();/* harmony default export */ __webpack_exports__["a"] = (RolConfig);

/***/ }),
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Autocomplete */
/* unused harmony export BicyclingLayer */
/* unused harmony export Circle */
/* unused harmony export Data */
/* unused harmony export DirectionsRenderer */
/* unused harmony export DirectionsService */
/* unused harmony export DistanceMatrixService */
/* unused harmony export DrawingManager */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GoogleMap; });
/* unused harmony export GroundOverlay */
/* unused harmony export HeatmapLayer */
/* unused harmony export InfoBox */
/* unused harmony export InfoWindow */
/* unused harmony export KmlLayer */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LoadScript; });
/* unused harmony export LoadScriptNext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Marker; });
/* unused harmony export MarkerClusterer */
/* unused harmony export OverlayView */
/* unused harmony export Polygon */
/* unused harmony export Polyline */
/* unused harmony export Rectangle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return StandaloneSearchBox; });
/* unused harmony export StreetViewPanorama */
/* unused harmony export StreetViewService */
/* unused harmony export TrafficLayer */
/* unused harmony export TransitLayer */
/* unused harmony export useGoogleMap */
/* unused harmony export useLoadScript */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__react_google_maps_marker_clusterer__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__react_google_maps_infobox__ = __webpack_require__(1458);






function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var MapContext =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0_react__["createContext"])(null);
function useGoogleMap() {
  !!!__WEBPACK_IMPORTED_MODULE_0_react__["useContext"] ?  false ? invariant(false, "useGoogleMap is React hook and requires React version 16.8+") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  var map = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useContext"])(MapContext);
  !!!map ?  false ? invariant(false, "useGoogleMap needs a GoogleMap available up in the tree") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
  return map;
}

var reduce = function reduce(obj, fn, acc) {
  return Object.keys(obj).reduce(function reducer(newAcc, key) {
    return fn(newAcc, obj[key], key);
  }, acc);
};

function forEach(obj, fn) {
  Object.keys(obj).forEach(function iterator(key) {
    return fn(obj[key], key);
  });
}

/* eslint-disable filenames/match-regex */
var applyUpdaterToNextProps = function applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance) {
  var map = {};

  var iter = function iter(fn, key) {
    var nextValue = nextProps[key];

    if (nextValue !== prevProps[key]) {
      map[key] = nextValue;
      fn(instance, nextValue);
    }
  };

  forEach(updaterMap, iter);
  return map;
};
function registerEvents(props, instance, eventMap) {
  var registeredList = reduce(eventMap, function reducer(acc, googleEventName, onEventName) {
    if (typeof props[onEventName] === 'function') {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }

    return acc;
  }, []);
  return registeredList;
}

function unregisterEvent(registered) {
  google.maps.event.removeListener(registered);
}

function unregisterEvents(events) {
  if (events === void 0) {
    events = [];
  }

  events.map(unregisterEvent);
}
function applyUpdatersToPropsAndRegisterEvents(_ref) {
  var updaterMap = _ref.updaterMap,
      eventMap = _ref.eventMap,
      prevProps = _ref.prevProps,
      nextProps = _ref.nextProps,
      instance = _ref.instance;
  var registeredEvents = registerEvents(nextProps, instance, eventMap);
  applyUpdaterToNextProps(updaterMap, prevProps, nextProps, instance);
  return registeredEvents;
}

var eventMap = {
  onDblClick: "dblclick",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMapTypeIdChanged: "maptypeid_changed",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseDown: "mousedown",
  onMouseUp: "mouseup",
  onRightClick: "rightclick",
  onTilesLoaded: "tilesloaded",
  onBoundsChanged: "bounds_changed",
  onCenterChanged: "center_changed",
  onClick: "click",
  onDrag: "drag",
  onHeadingChanged: "heading_changed",
  onIdle: "idle",
  onProjectionChanged: "projection_changed",
  onResize: "resize",
  onTiltChanged: "tilt_changed",
  onZoomChanged: "zoom_changed"
};
var updaterMap = {
  extraMapTypes: function extraMapTypes(map, extra) {
    extra.forEach(function forEachExtra(it, i) {
      map.mapTypes.set(String(i), it);
    });
  },
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  clickableIcons: function clickableIcons(map, clickable) {
    map.setClickableIcons(clickable);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};
var GoogleMap =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(GoogleMap, _React$PureComponent);

  function GoogleMap() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      map: null
    };
    _this.registeredEvents = [];
    _this.mapRef = null; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.getInstance = function () {
      return new google.maps.Map(_this.mapRef, _this.props.options);
    };

    _this.panTo = function (latLng) {
      var map = _this.getInstance();

      if (map) {
        map.panTo(latLng);
      }
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.setMapCallback = function () {
      if (_this.state.map !== null) {
        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.map);
        }
      }
    };
    /* eslint-disable @getify/proper-arrows/name */

    /* eslint-disable @getify/proper-arrows/this */


    _this.getRef = function (ref) {
      _this.mapRef = ref;
    };

    return _this;
  }

  var _proto = GoogleMap.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var map = this.getInstance();
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap,
      eventMap: eventMap,
      prevProps: {},
      nextProps: this.props,
      instance: map
    });

    function setMap() {
      return {
        map: map
      };
    }

    this.setState(setMap, this.setMapCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.map !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap,
        eventMap: eventMap,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.map
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.map !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.map);
      }

      unregisterEvents(this.registeredEvents);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
      id: this.props.id,
      ref: this.getRef,
      style: this.props.mapContainerStyle,
      className: this.props.mapContainerClassName
    }, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(MapContext.Provider, {
      value: this.state.map
    }, this.state.map !== null ? this.props.children : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null)));
  };

  return GoogleMap;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var isBrowser = typeof document !== 'undefined';

var injectScript = function injectScript(_ref) {
  var url = _ref.url,
      id = _ref.id;

  if (!isBrowser) {
    return Promise.reject(new Error('document is undefined'));
  }

  return new Promise(function injectScriptCallback(resolve, reject) {
    var existingScript = document.getElementById(id);
    var windowWithGoogleMap = window;

    if (existingScript) {
      // Same script id/url: keep same script
      var dataStateAttribute = existingScript.getAttribute('data-state');

      if (existingScript.src === url && dataStateAttribute !== 'error') {
        if (dataStateAttribute === 'ready') {
          return resolve(id);
        } else {
          var originalInitMap = windowWithGoogleMap.initMap;
          var originalErrorCallback = existingScript.onerror;

          windowWithGoogleMap.initMap = function initMap() {
            if (originalInitMap) {
              originalInitMap();
            }

            resolve(id);
          };

          existingScript.onerror = function (err) {
            if (originalErrorCallback) {
              originalErrorCallback(err);
            }

            reject(err);
          };

          return;
        }
      } // Same script id, but either
      // 1. requested URL is different
      // 2. script failed to load
      else {
          existingScript.remove();
        }
    }

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = url;
    script.id = id;
    script.async = true;

    script.onerror = function onerror(err) {
      script.setAttribute('data-state', 'error');
      reject(err);
    };

    windowWithGoogleMap.initMap = function onload() {
      script.setAttribute('data-state', 'ready');
      resolve(id);
    };

    document.head.appendChild(script);
  })["catch"](function (err) {
    console.error('injectScript error: ', err);
    throw err;
  });
};

var isRobotoStyle = function isRobotoStyle(element) {
  // roboto font download
  if (element.href && element.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0) {
    return true;
  } // roboto style elements


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  element.styleSheet && // @ts-ignore
  element.styleSheet.cssText && // @ts-ignore
  element.styleSheet.cssText.replace('\r\n', '').indexOf('.gm-style') === 0) {
    // @ts-ignore
    element.styleSheet.cssText = '';
    return true;
  } // roboto style elements for other browsers


  if (element.tagName.toLowerCase() === 'style' && element.innerHTML && element.innerHTML.replace('\r\n', '').indexOf('.gm-style') === 0) {
    element.innerHTML = '';
    return true;
  } // when google tries to add empty style


  if (element.tagName.toLowerCase() === 'style' && // @ts-ignore
  !element.styleSheet && !element.innerHTML) {
    return true;
  }

  return false;
}; // Preventing the Google Maps library from downloading an extra font


var preventGoogleFonts = function preventGoogleFonts() {
  // we override these methods only for one particular head element
  // default methods for other elements are not affected
  var head = document.getElementsByTagName('head')[0];
  var trueInsertBefore = head.insertBefore.bind(head); // TODO: adding return before reflect solves the TS issue
  //@ts-ignore

  head.insertBefore = function insertBefore(newElement, referenceElement) {
    if (!isRobotoStyle(newElement)) {
      Reflect.apply(trueInsertBefore, head, [newElement, referenceElement]);
    }
  };

  var trueAppend = head.appendChild.bind(head); // TODO: adding return before reflect solves the TS issue
  //@ts-ignore

  head.appendChild = function appendChild(textNode) {
    if (!isRobotoStyle(textNode)) {
      Reflect.apply(trueAppend, head, [textNode]);
    }
  };
};

function makeLoadScriptUrl(_ref) {
  var googleMapsApiKey = _ref.googleMapsApiKey,
      googleMapsClientId = _ref.googleMapsClientId,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? 'weekly' : _ref$version,
      language = _ref.language,
      region = _ref.region,
      libraries = _ref.libraries,
      channel = _ref.channel;
  var params = [];
  !(googleMapsApiKey && googleMapsClientId || !(googleMapsApiKey && googleMapsClientId)) ?  false ? invariant(false, 'You need to specify either googleMapsApiKey or googleMapsClientId for @react-google-maps/api load script to work. You cannot use both at the same time.') : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

  if (googleMapsApiKey) {
    params.push("key=" + googleMapsApiKey);
  } else if (googleMapsClientId) {
    params.push("client=" + googleMapsClientId);
  }

  if (version) {
    params.push("v=" + version);
  }

  if (language) {
    params.push("language=" + language);
  }

  if (region) {
    params.push("region=" + region);
  }

  if (libraries && libraries.length) {
    params.push("libraries=" + libraries.sort().join(','));
  }

  if (channel) {
    params.push("channel=" + channel);
  }

  params.push('callback=initMap');
  return "https://maps.googleapis.com/maps/api/js?" + params.join('&');
}

var cleaningUp = false;
function DefaultLoadingElement() {
  return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", null, "Loading...");
}
var defaultLoadScriptProps = {
  id: 'script-loader',
  version: 'weekly'
};

var LoadScript =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(LoadScript, _React$PureComponent);

  function LoadScript() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.check = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
    _this.state = {
      loaded: false
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.cleanupCallback = function () {
      //@ts-ignore
      delete window.google;

      _this.injectScript();
    }; // eslint-disable-next-line @getify/proper-arrows/name


    _this.isCleaningUp = function () {
      try {
        var promiseCallback = function promiseCallback(resolve) {
          if (!cleaningUp) {
            resolve();
          } else {
            if (isBrowser) {
              var timer = window.setInterval(function interval() {
                if (!cleaningUp) {
                  window.clearInterval(timer);
                  resolve();
                }
              }, 1);
            }
          }
        };

        return Promise.resolve(new Promise(promiseCallback));
      } catch (e) {
        return Promise.reject(e);
      }
    };

    _this.cleanup = function () {
      cleaningUp = true;
      var script = document.getElementById(_this.props.id);

      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }

      Array.prototype.slice.call(document.getElementsByTagName("script")).filter(function filter(script) {
        return script.src.includes("maps.googleapis");
      }).forEach(function forEach(script) {
        if (script.parentNode) {
          script.parentNode.removeChild(script);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName("link")).filter(function filter(link) {
        return link.href === "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700|Google+Sans";
      }).forEach(function forEach(link) {
        if (link.parentNode) {
          link.parentNode.removeChild(link);
        }
      });
      Array.prototype.slice.call(document.getElementsByTagName("style")).filter(function filter(style) {
        return style.innerText !== undefined && style.innerText.length > 0 && style.innerText.includes(".gm-");
      }).forEach(function forEach(style) {
        if (style.parentNode) {
          style.parentNode.removeChild(style);
        }
      });
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.injectScript = function () {
      if (_this.props.preventGoogleFontsLoading) {
        preventGoogleFonts();
      }

      !!!_this.props.id ?  false ? invariant(false, 'LoadScript requires "id" prop to be a string: %s', _this.props.id) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
      var injectScriptOptions = {
        id: _this.props.id,
        url: makeLoadScriptUrl(_this.props)
      };
      injectScript(injectScriptOptions) // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name
      .then(function () {
        if (_this.props.onLoad) {
          _this.props.onLoad();
        }

        _this.setState(function setLoaded() {
          return {
            loaded: true
          };
        });
      }) // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name
      ["catch"](function (err) {
        if (_this.props.onError) {
          _this.props.onError(err);
        }

        console.error("\n          There has been an Error with loading Google Maps API script, please check that you provided correct google API key (" + (_this.props.googleMapsApiKey || '-') + ") or Client ID (" + (_this.props.googleMapsClientId || '-') + ") to <LoadScript />\n          Otherwise it is a Network issue.\n        ");
      });
    };

    return _this;
  }

  var _proto = LoadScript.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (isBrowser) {
      // @ts-ignore
      if (window.google && !cleaningUp) {
        console.error("google api is already presented");
        return;
      }

      this.isCleaningUp().then(this.injectScript)["catch"](function err(err) {
        console.error("Error at injecting script after cleaning up: ", err);
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.libraries !== prevProps.libraries) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }

    if (isBrowser && prevProps.language !== this.props.language) {
      this.cleanup(); // TODO: refactor to use gDSFP maybe... wait for hooks refactoring.
      // eslint-disable-next-line react/no-did-update-set-state

      this.setState(function setLoaded() {
        return {
          loaded: false
        };
      }, this.cleanupCallback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var _this2 = this;

    if (isBrowser) {
      this.cleanup(); // eslint-disable-next-line @getify/proper-arrows/this

      var timeoutCallback = function timeoutCallback() {
        if (!_this2.check.current) {
          //@ts-ignore
          delete window.google;
          cleaningUp = false;
        }
      };

      window.setTimeout(timeoutCallback, 1);

      if (this.props.onUnmount) {
        this.props.onUnmount();
      }
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null, Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
      ref: this.check
    }), this.state.loaded ? this.props.children : this.props.loadingElement || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DefaultLoadingElement, null));
  };

  return LoadScript;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

LoadScript.defaultProps = defaultLoadScriptProps;

/* eslint-disable filenames/match-regex */
var previouslyLoadedUrl;
function useLoadScript(_ref) {
  var _ref$id = _ref.id,
      id = _ref$id === void 0 ? defaultLoadScriptProps.id : _ref$id,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? defaultLoadScriptProps.version : _ref$version,
      googleMapsApiKey = _ref.googleMapsApiKey,
      googleMapsClientId = _ref.googleMapsClientId,
      language = _ref.language,
      region = _ref.region,
      libraries = _ref.libraries,
      preventGoogleFontsLoading = _ref.preventGoogleFontsLoading,
      channel = _ref.channel;
  var isMounted = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])(false);

  var _React$useState = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(false),
      isLoaded = _React$useState[0],
      setLoaded = _React$useState[1];

  var _React$useState2 = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useState"])(undefined),
      loadError = _React$useState2[0],
      setLoadError = _React$useState2[1];

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function trackMountedState() {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function applyPreventGoogleFonts() {
    if (isBrowser && preventGoogleFontsLoading) {
      preventGoogleFonts();
    }
  }, [preventGoogleFontsLoading]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function validateLoadedState() {
    if (isLoaded) {
      ! // @ts-ignore
      !!window.google ?  false ? invariant(false, "useLoadScript was marked as loaded, but window.google is not present. Something went wrong.") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    }
  }, [isLoaded]);
  var url = makeLoadScriptUrl({
    version: version,
    googleMapsApiKey: googleMapsApiKey,
    googleMapsClientId: googleMapsClientId,
    language: language,
    region: region,
    libraries: libraries,
    channel: channel
  });
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function loadScriptAndModifyLoadedState() {
    if (!isBrowser) {
      return;
    }

    function setLoadedIfMounted() {
      if (isMounted.current) {
        setLoaded(true);
        previouslyLoadedUrl = url;
      }
    }

    if (window.google && previouslyLoadedUrl === url) {
      setLoadedIfMounted();
      return;
    }

    injectScript({
      id: id,
      url: url
    }).then(setLoadedIfMounted)["catch"](function handleInjectError(err) {
      if (isMounted.current) {
        setLoadError(err);
      }

      console.warn("\n        There has been an Error with loading Google Maps API script, please check that you provided correct google API key (" + (googleMapsApiKey || '-') + ") or Client ID (" + (googleMapsClientId || '-') + ")\n        Otherwise it is a Network issue.\n      ");
      console.error(err);
    });
  }, [id, url]);
  var prevLibraries = Object(__WEBPACK_IMPORTED_MODULE_0_react__["useRef"])();
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function checkPerformance() {
    if (prevLibraries.current && libraries !== prevLibraries.current) {
      console.warn('Performance warning! LoadScript has been reloaded unintentionally! You should not pass `libraries` prop as new array. Please keep an array of libraries as static class property for Components and PureComponents, or just a const variable outside of component, or somewhere in config files or ENV variables');
    }

    prevLibraries.current = libraries;
  }, [libraries]);
  return {
    isLoaded: isLoaded,
    loadError: loadError,
    url: url
  };
}

var defaultLoadingElement =
/*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(DefaultLoadingElement, null);

function LoadScriptNext(_ref) {
  var loadingElement = _ref.loadingElement,
      onLoad = _ref.onLoad,
      onError = _ref.onError,
      onUnmount = _ref.onUnmount,
      children = _ref.children,
      hookOptions = _objectWithoutPropertiesLoose(_ref, ["loadingElement", "onLoad", "onError", "onUnmount", "children"]);

  var _useLoadScript = useLoadScript(hookOptions),
      isLoaded = _useLoadScript.isLoaded,
      loadError = _useLoadScript.loadError;

  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function handleOnLoad() {
    if (isLoaded && typeof onLoad === "function") {
      onLoad();
    }
  }, [isLoaded, onLoad]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function handleOnError() {
    if (loadError && typeof onError === "function") {
      onError(loadError);
    }
  }, [loadError, onError]);
  Object(__WEBPACK_IMPORTED_MODULE_0_react__["useEffect"])(function handleOnUnmount() {
    return function () {
      if (onUnmount) {
        onUnmount();
      }
    };
  }, [onUnmount]);
  return isLoaded ? children : loadingElement || defaultLoadingElement;
}

var LoadScriptNext$1 = /*#__PURE__*/
Object(__WEBPACK_IMPORTED_MODULE_0_react__["memo"])(LoadScriptNext);

var eventMap$1 = {};
var updaterMap$1 = {
  options: function options(instance, _options) {
    instance.setOptions(_options);
  }
};
var TrafficLayer =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(TrafficLayer, _PureComponent);

  function TrafficLayer() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.state = {
      trafficLayer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setTrafficLayerCallback = function () {
      if (_this.state.trafficLayer !== null) {
        if (_this.props.onLoad) {
          // @ts-ignore
          _this.props.onLoad(_this.state.trafficLayer);
        }
      }
    };

    _this.registeredEvents = [];
    return _this;
  }

  var _proto = TrafficLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var trafficLayer = new google.maps.TrafficLayer(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$1,
      eventMap: eventMap$1,
      prevProps: {},
      nextProps: this.props,
      instance: trafficLayer
    });

    function setTrafficLayer() {
      return {
        trafficLayer: trafficLayer
      };
    }

    this.setState(setTrafficLayer, this.setTrafficLayerCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.trafficLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$1,
        eventMap: eventMap$1,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.trafficLayer
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.trafficLayer !== null) {
      if (this.props.onUnmount) {
        // @ts-ignore
        this.props.onUnmount(this.state.trafficLayer);
      }

      unregisterEvents(this.registeredEvents); // @ts-ignore

      this.state.trafficLayer.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return TrafficLayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
TrafficLayer.contextType = MapContext;

var BicyclingLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(BicyclingLayer, _React$PureComponent);

  function BicyclingLayer() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      bicyclingLayer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setBicyclingLayerCallback = function () {
      if (_this.state.bicyclingLayer !== null) {
        // TODO: how is this possibly null if we're doing a null check
        // @ts-ignore
        _this.state.bicyclingLayer.setMap(_this.context);

        if (_this.props.onLoad) {
          //@ts-ignore
          _this.props.onLoad(_this.state.bicyclingLayer);
        }
      }
    };

    return _this;
  }

  var _proto = BicyclingLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var bicyclingLayer = new google.maps.BicyclingLayer();

    function setBicyclingLayer() {
      return {
        bicyclingLayer: bicyclingLayer
      };
    }

    this.setState(setBicyclingLayer, this.setBicyclingLayerCallback);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.bicyclingLayer !== null) {
      if (this.props.onUnmount) {
        // @ts-ignore
        this.props.onUnmount(this.state.bicyclingLayer);
      } // @ts-ignore


      this.state.bicyclingLayer.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return BicyclingLayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
BicyclingLayer.contextType = MapContext;

var TransitLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(TransitLayer, _React$PureComponent);

  function TransitLayer() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      transitLayer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setTransitLayerCallback = function () {
      if (_this.state.transitLayer !== null) {
        // TODO: how is this possibly null if we're doing a null check
        // @ts-ignore
        _this.state.transitLayer.setMap(_this.context);

        if (_this.props.onLoad) {
          //@ts-ignore
          _this.props.onLoad(_this.state.transitLayer);
        }
      }
    };

    return _this;
  }

  var _proto = TransitLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var transitLayer = new google.maps.TransitLayer();

    function setTransitLayer() {
      return {
        transitLayer: transitLayer
      };
    }

    this.setState(setTransitLayer, this.setTransitLayerCallback);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.transitLayer !== null) {
      if (this.props.onUnmount) {
        // @ts-ignore
        this.props.onUnmount(this.state.transitLayer);
      } // @ts-ignore


      this.state.transitLayer.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return TransitLayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
TransitLayer.contextType = MapContext;

var eventMap$2 = {
  onCircleComplete: "circlecomplete",
  onMarkerComplete: "markercomplete",
  onOverlayComplete: "overlaycomplete",
  onPolygonComplete: "polygoncomplete",
  onPolylineComplete: "polylinecomplete",
  onRectangleComplete: "rectanglecomplete"
};
var updaterMap$2 = {
  drawingMode: function drawingMode(instance, _drawingMode) {
    instance.setDrawingMode(_drawingMode);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  }
};
var DrawingManager =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DrawingManager, _React$PureComponent);

  function DrawingManager(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this.registeredEvents = [];
    _this.state = {
      drawingManager: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setDrawingManagerCallback = function () {
      if (_this.state.drawingManager !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.drawingManager);
      }
    };

    !!!google.maps.drawing ?  false ? invariant(false, "Did you include prop libraries={['drawing']} in the URL? %s", google.maps.drawing) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    return _this;
  }

  var _proto = DrawingManager.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var drawingManager = new google.maps.drawing.DrawingManager(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$2,
      eventMap: eventMap$2,
      prevProps: {},
      nextProps: this.props,
      instance: drawingManager
    });

    function setDrawingManager() {
      return {
        drawingManager: drawingManager
      };
    }

    this.setState(setDrawingManager, this.setDrawingManagerCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.drawingManager !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$2,
        eventMap: eventMap$2,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.drawingManager
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.drawingManager !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.drawingManager);
      }

      unregisterEvents(this.registeredEvents);
      this.state.drawingManager.setMap(null);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return DrawingManager;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
DrawingManager.contextType = MapContext;

var eventMap$3 = {
  onAnimationChanged: "animation_changed",
  onClick: "click",
  onClickableChanged: "clickable_changed",
  onCursorChanged: "cursor_changed",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDraggableChanged: "draggable_changed",
  onDragStart: "dragstart",
  onFlatChanged: "flat_changed",
  onIconChanged: "icon_changed",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onPositionChanged: "position_changed",
  onRightClick: "rightclick",
  onShapeChanged: "shape_changed",
  onTitleChanged: "title_changed",
  onVisibleChanged: "visible_changed",
  onZindexChanged: "zindex_changed"
};
var updaterMap$3 = {
  animation: function animation(instance, _animation) {
    instance.setAnimation(_animation);
  },
  clickable: function clickable(instance, _clickable) {
    instance.setClickable(_clickable);
  },
  cursor: function cursor(instance, _cursor) {
    instance.setCursor(_cursor);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  icon: function icon(instance, _icon) {
    instance.setIcon(_icon);
  },
  label: function label(instance, _label) {
    instance.setLabel(_label);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  shape: function shape(instance, _shape) {
    instance.setShape(_shape);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var Marker =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Marker, _React$PureComponent);

  function Marker() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      marker: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setMarkerCallback = function () {
      if (_this.state.marker !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.marker);
      }
    };

    return _this;
  }

  var _proto = Marker.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var markerOptions = _extends({}, this.props.options || {}, {}, this.props.clusterer ? {} : {
      map: this.context
    }, {
      position: this.props.position
    });

    var marker = new google.maps.Marker(markerOptions);

    if (this.props.clusterer) {
      this.props.clusterer.addMarker( // @ts-ignore
      marker, !!this.props.noClustererRedraw);
    } else {
      marker.setMap(this.context);
    }

    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$3,
      eventMap: eventMap$3,
      prevProps: {},
      nextProps: this.props,
      instance: marker
    });

    function setMarker() {
      return {
        marker: marker
      };
    }

    this.setState(setMarker, this.setMarkerCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.marker !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$3,
        eventMap: eventMap$3,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.marker
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.marker !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.marker);
      }

      unregisterEvents(this.registeredEvents);

      if (this.props.clusterer) {
        this.props.clusterer.removeMarker( // @ts-ignore
        this.state.marker, !!this.props.noClustererRedraw);
      } else {
        this.state.marker && this.state.marker.setMap(null);
      }
    }
  };

  _proto.render = function render() {
    return this.props.children || null;
  };

  return Marker;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Marker.contextType = MapContext;

var eventMap$4 = {
  onClick: "click",
  onClusteringBegin: "clusteringbegin",
  onClusteringEnd: "clusteringend",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover"
};
var updaterMap$4 = {
  averageCenter: function averageCenter(instance, _averageCenter) {
    instance.setAverageCenter(_averageCenter);
  },
  batchSizeIE: function batchSizeIE(instance, _batchSizeIE) {
    instance.setBatchSizeIE(_batchSizeIE);
  },
  calculator: function calculator(instance, _calculator) {
    instance.setCalculator(_calculator);
  },
  clusterClass: function clusterClass(instance, _clusterClass) {
    instance.setClusterClass(_clusterClass);
  },
  enableRetinaIcons: function enableRetinaIcons(instance, _enableRetinaIcons) {
    instance.setEnableRetinaIcons(_enableRetinaIcons);
  },
  gridSize: function gridSize(instance, _gridSize) {
    instance.setGridSize(_gridSize);
  },
  ignoreHidden: function ignoreHidden(instance, _ignoreHidden) {
    instance.setIgnoreHidden(_ignoreHidden);
  },
  imageExtension: function imageExtension(instance, _imageExtension) {
    instance.setImageExtension(_imageExtension);
  },
  imagePath: function imagePath(instance, _imagePath) {
    instance.setImagePath(_imagePath);
  },
  imageSizes: function imageSizes(instance, _imageSizes) {
    instance.setImageSizes(_imageSizes);
  },
  maxZoom: function maxZoom(instance, _maxZoom) {
    instance.setMaxZoom(_maxZoom);
  },
  minimumClusterSize: function minimumClusterSize(instance, _minimumClusterSize) {
    instance.setMinimumClusterSize(_minimumClusterSize);
  },
  styles: function styles(instance, _styles) {
    instance.setStyles(_styles);
  },
  title: function title(instance, _title) {
    instance.setTitle(_title);
  },
  zoomOnClick: function zoomOnClick(instance, _zoomOnClick) {
    instance.setZoomOnClick(_zoomOnClick);
  }
};
var ClustererComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(ClustererComponent, _React$PureComponent);

  function ClustererComponent() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      markerClusterer: null
    };

    _this.setClustererCallback = function () {
      if (_this.state.markerClusterer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.markerClusterer);
      }
    };

    return _this;
  }

  var _proto = ClustererComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.context) {
      var markerClusterer = new __WEBPACK_IMPORTED_MODULE_2__react_google_maps_marker_clusterer__["a" /* Clusterer */](this.context, [], this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: {},
        nextProps: this.props,
        instance: markerClusterer
      });
      this.setState(function setClusterer() {
        return {
          markerClusterer: markerClusterer
        };
      }, this.setClustererCallback);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.markerClusterer) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$4,
        eventMap: eventMap$4,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.markerClusterer
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.markerClusterer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.markerClusterer);
      }

      unregisterEvents(this.registeredEvents); //@ts-ignore

      this.state.markerClusterer.setMap(null);
    }
  };

  _proto.render = function render() {
    return this.state.markerClusterer !== null ? this.props.children(this.state.markerClusterer) : null;
  };

  return ClustererComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
ClustererComponent.contextType = MapContext;

var eventMap$5 = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
};
var updaterMap$5 = {
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  position: function position(instance, _position) {
    if (_position instanceof google.maps.LatLng) {
      instance.setPosition(_position);
    } else {
      instance.setPosition(new google.maps.LatLng(_position.lat, _position.lng));
    }
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var InfoBoxComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(InfoBoxComponent, _React$PureComponent);

  function InfoBoxComponent() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoBox: null
    };

    _this.open = function (infoBox, anchor) {
      if (anchor) {
        infoBox.open(_this.context, anchor);
      } else if (infoBox.getPosition()) {
        infoBox.open(_this.context);
      } else {
          false ? invariant(false, "You must provide either an anchor or a position prop for <InfoBox>.") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) ;
      }
    };

    _this.setInfoBoxCallback = function () {
      var _this$props = _this.props,
          anchor = _this$props.anchor,
          onLoad = _this$props.onLoad;
      var infoBox = _this.state.infoBox;

      if (infoBox !== null && _this.containerElement !== null) {
        infoBox.setContent(_this.containerElement);

        _this.open(infoBox, anchor);

        if (onLoad) {
          onLoad(infoBox);
        }
      }
    };

    return _this;
  }

  var _proto = InfoBoxComponent.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var options = this.props.options;

    var _ref = options || {},
        position = _ref.position,
        infoBoxOptions = _objectWithoutPropertiesLoose(_ref, ["position"]);

    var positionLatLng;

    if (position && !(position instanceof google.maps.LatLng)) {
      positionLatLng = new google.maps.LatLng(position.lat, position.lng);
    }

    var infoBox = new __WEBPACK_IMPORTED_MODULE_4__react_google_maps_infobox__["a" /* InfoBox */](_extends({}, infoBoxOptions, {}, positionLatLng ? {
      position: positionLatLng
    } : {}));
    this.containerElement = document.createElement('div');
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$5,
      eventMap: eventMap$5,
      prevProps: {},
      nextProps: this.props,
      instance: infoBox
    });
    this.setState({
      infoBox: infoBox
    }, this.setInfoBoxCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var infoBox = this.state.infoBox;

    if (infoBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$5,
        eventMap: eventMap$5,
        prevProps: prevProps,
        nextProps: this.props,
        instance: infoBox
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var onUnmount = this.props.onUnmount;
    var infoBox = this.state.infoBox;

    if (infoBox !== null) {
      if (onUnmount) {
        onUnmount(infoBox);
      }

      unregisterEvents(this.registeredEvents);
      infoBox.close();
    }
  };

  _proto.render = function render() {
    if (!this.containerElement) {
      return null;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children), this.containerElement);
  };

  return InfoBoxComponent;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
InfoBoxComponent.contextType = MapContext;

var eventMap$6 = {
  onCloseClick: "closeclick",
  onContentChanged: "content_changed",
  onDomReady: "domready",
  onPositionChanged: "position_changed",
  onZindexChanged: "zindex_changed"
};
var updaterMap$6 = {
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var InfoWindow =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(InfoWindow, _React$PureComponent);

  function InfoWindow() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = null;
    _this.state = {
      infoWindow: null
    };

    _this.open = function (infoWindow, anchor) {
      if (anchor) {
        infoWindow.open(_this.context, anchor);
      } else if (infoWindow.getPosition()) {
        infoWindow.open(_this.context);
      } else {
          false ? invariant(false, "You must provide either an anchor (typically render it inside a <Marker>) or a position props for <InfoWindow>.") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) ;
      }
    };

    _this.setInfoWindowCallback = function () {
      if (_this.state.infoWindow !== null && _this.containerElement !== null) {
        _this.state.infoWindow.setContent(_this.containerElement);

        _this.open(_this.state.infoWindow, _this.props.anchor);

        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.infoWindow);
        }
      }
    };

    return _this;
  }

  var _proto = InfoWindow.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var infoWindow = new google.maps.InfoWindow(_extends({}, this.props.options || {}));
    this.containerElement = document.createElement("div");
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$6,
      eventMap: eventMap$6,
      prevProps: {},
      nextProps: this.props,
      instance: infoWindow
    });

    function setInfoWindow() {
      return {
        infoWindow: infoWindow
      };
    }

    this.setState(setInfoWindow, this.setInfoWindowCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$6,
        eventMap: eventMap$6,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.infoWindow
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.infoWindow !== null) {
      unregisterEvents(this.registeredEvents);
      this.state.infoWindow.close();
    }
  };

  _proto.render = function render() {
    return this.containerElement ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(__WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children), this.containerElement) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return InfoWindow;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
InfoWindow.contextType = MapContext;

var eventMap$7 = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
};
var updaterMap$7 = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  }
};
var Polyline =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Polyline, _React$PureComponent);

  function Polyline() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polyline: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setPolylineCallback = function () {
      if (_this.state.polyline !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polyline);
      }
    };

    return _this;
  }

  var _proto = Polyline.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var polyline = new google.maps.Polyline(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$7,
      eventMap: eventMap$7,
      prevProps: {},
      nextProps: this.props,
      instance: polyline
    });

    function setPolyline() {
      return {
        polyline: polyline
      };
    }

    this.setState(setPolyline, this.setPolylineCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.polyline !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$7,
        eventMap: eventMap$7,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polyline
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.polyline !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polyline);
      }

      unregisterEvents(this.registeredEvents);
      this.state.polyline.setMap(null);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return Polyline;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Polyline.contextType = MapContext;

var eventMap$8 = {
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
};
var updaterMap$8 = {
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  path: function path(instance, _path) {
    instance.setPath(_path);
  },
  paths: function paths(instance, _paths) {
    instance.setPaths(_paths);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  }
};
var Polygon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Polygon, _React$PureComponent);

  function Polygon() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      polygon: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setPolygonCallback = function () {
      if (_this.state.polygon !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.polygon);
      }
    };

    _this.render = function () {
      return null;
    };

    return _this;
  }

  var _proto = Polygon.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var polygon = new google.maps.Polygon(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$8,
      eventMap: eventMap$8,
      prevProps: {},
      nextProps: this.props,
      instance: polygon
    });

    function setPolygon() {
      return {
        polygon: polygon
      };
    }

    this.setState(setPolygon, this.setPolygonCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.polygon !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$8,
        eventMap: eventMap$8,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.polygon
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.polygon !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.polygon);
      }

      unregisterEvents(this.registeredEvents);
      this.state.polygon && this.state.polygon.setMap(null);
    }
  };

  return Polygon;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Polygon.contextType = MapContext;

var eventMap$9 = {
  onBoundsChanged: "bounds_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRightClick: "rightclick"
};
var updaterMap$9 = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  }
};
var Rectangle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Rectangle, _React$PureComponent);

  function Rectangle() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      rectangle: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setRectangleCallback = function () {
      if (_this.state.rectangle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.rectangle);
      }
    };

    return _this;
  }

  var _proto = Rectangle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var rectangle = new google.maps.Rectangle(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$9,
      eventMap: eventMap$9,
      prevProps: {},
      nextProps: this.props,
      instance: rectangle
    });

    function setRectangle() {
      return {
        rectangle: rectangle
      };
    }

    this.setState(setRectangle, this.setRectangleCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.rectangle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$9,
        eventMap: eventMap$9,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.rectangle
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.rectangle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.rectangle);
      }

      unregisterEvents(this.registeredEvents);
      this.state.rectangle.setMap(null);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return Rectangle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Rectangle.contextType = MapContext;

var eventMap$a = {
  onCenterChanged: "center_changed",
  onClick: "click",
  onDblClick: "dblclick",
  onDrag: "drag",
  onDragEnd: "dragend",
  onDragStart: "dragstart",
  onMouseDown: "mousedown",
  onMouseMove: "mousemove",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRadiusChanged: "radius_changed",
  onRightClick: "rightclick"
};
var updaterMap$a = {
  center: function center(instance, _center) {
    instance.setCenter(_center);
  },
  draggable: function draggable(instance, _draggable) {
    instance.setDraggable(_draggable);
  },
  editable: function editable(instance, _editable) {
    instance.setEditable(_editable);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  radius: function radius(instance, _radius) {
    instance.setRadius(_radius);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  }
};
var Circle =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Circle, _React$PureComponent);

  function Circle() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      circle: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setCircleCallback = function () {
      if (_this.state.circle !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.circle);
      }
    };

    return _this;
  }

  var _proto = Circle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var circle = new google.maps.Circle(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$a,
      eventMap: eventMap$a,
      prevProps: {},
      nextProps: this.props,
      instance: circle
    });

    function setCircle() {
      return {
        circle: circle
      };
    }

    this.setState(setCircle, this.setCircleCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.circle !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$a,
        eventMap: eventMap$a,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.circle
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.circle !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.circle);
      }

      unregisterEvents(this.registeredEvents);
      this.state.circle && this.state.circle.setMap(null);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return Circle;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Circle.contextType = MapContext;

var eventMap$b = {
  onAddFeature: "addfeature",
  onClick: "click",
  onDblClick: "dblclick",
  onMouseDown: "mousedown",
  onMouseOut: "mouseout",
  onMouseOver: "mouseover",
  onMouseUp: "mouseup",
  onRemoveFeature: "removefeature",
  onRemoveProperty: "removeproperty",
  onRightClick: "rightclick",
  onSetGeometry: "setgeometry",
  onSetProperty: "setproperty"
};
var updaterMap$b = {
  add: function add(instance, features) {
    instance.add(features);
  },
  addgeojson: function addgeojson(instance, geojson, options) {
    instance.addGeoJson(geojson, options);
  },
  contains: function contains(instance, feature) {
    instance.contains(feature);
  },
  foreach: function foreach(instance, callback) {
    instance.forEach(callback);
  },
  loadgeojson: function loadgeojson(instance, url, options, callback) {
    instance.loadGeoJson(url, options, callback);
  },
  overridestyle: function overridestyle(instance, feature, style) {
    instance.overrideStyle(feature, style);
  },
  remove: function remove(instance, feature) {
    instance.remove(feature);
  },
  revertstyle: function revertstyle(instance, feature) {
    instance.revertStyle(feature);
  },
  controlposition: function controlposition(instance, controlPosition // TODO: ???
  ) {
    instance.setControlPosition(controlPosition);
  },
  controls: function controls(instance, _controls) {
    instance.setControls(_controls);
  },
  drawingmode: function drawingmode(instance, mode) {
    instance.setDrawingMode(mode);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  style: function style(instance, _style) {
    instance.setStyle(_style);
  },
  togeojson: function togeojson(instance, callback) {
    instance.toGeoJson(callback);
  }
};
var Data =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Data, _React$PureComponent);

  function Data() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      data: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setDataCallback = function () {
      if (_this.state.data !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.data);
      }
    };

    return _this;
  }

  var _proto = Data.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var data = new google.maps.Data(_extends({}, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$b,
      eventMap: eventMap$b,
      prevProps: {},
      nextProps: this.props,
      instance: data
    });

    function setData() {
      return {
        data: data
      };
    }

    this.setState(setData, this.setDataCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.data !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$b,
        eventMap: eventMap$b,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.data
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.data !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.data);
      }

      unregisterEvents(this.registeredEvents);

      if (this.state.data) {
        this.state.data.setMap(null);
      }
    }
  };

  _proto.render = function render() {
    return null;
  };

  return Data;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Data.contextType = MapContext;

var eventMap$c = {
  onClick: "click",
  onDefaultViewportChanged: "defaultviewport_changed",
  onStatusChanged: "status_changed"
};
var updaterMap$c = {
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  url: function url(instance, _url) {
    instance.setUrl(_url);
  },
  zIndex: function zIndex(instance, _zIndex) {
    instance.setZIndex(_zIndex);
  }
};
var KmlLayer =
/*#__PURE__*/
function (_PureComponent) {
  _inheritsLoose(KmlLayer, _PureComponent);

  function KmlLayer() {
    var _this;

    _this = _PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      kmlLayer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setKmlLayerCallback = function () {
      if (_this.state.kmlLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.kmlLayer);
      }
    };

    return _this;
  }

  var _proto = KmlLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var kmlLayer = new google.maps.KmlLayer(_extends({}, this.props.options, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$c,
      eventMap: eventMap$c,
      prevProps: {},
      nextProps: this.props,
      instance: kmlLayer
    });

    function setLmlLayer() {
      return {
        kmlLayer: kmlLayer
      };
    }

    this.setState(setLmlLayer, this.setKmlLayerCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.kmlLayer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$c,
        eventMap: eventMap$c,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.kmlLayer
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.kmlLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.kmlLayer);
      }

      unregisterEvents(this.registeredEvents);
      this.state.kmlLayer.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return KmlLayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
KmlLayer.contextType = MapContext;

/* eslint-disable filenames/match-regex */
function getOffsetOverride(containerElement, getPixelPositionOffset) {
  return typeof getPixelPositionOffset === "function" ? getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight) : {};
}

var createLatLng = function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
};

var createLatLngBounds = function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
};

var ensureOfType = function ensureOfType(inst, type, factory) {
  return inst instanceof type ? inst : factory(inst, type);
};

var getLayoutStylesByBounds = function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());

  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px"
    };
  }

  return {
    left: "-9999px",
    top: "-9999px"
  };
};

var getLayoutStylesByPosition = function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position);

  if (point) {
    var x = point.x,
        y = point.y;
    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px"
    };
  }

  return {
    left: "-9999px",
    top: "-9999px"
  };
};

var getLayoutStyles = function getLayoutStyles(mapCanvasProjection, offset, bounds, // eslint-disable-next-line @getify/proper-arrows/params
position) {
  return bounds !== undefined ? getLayoutStylesByBounds(mapCanvasProjection, offset, ensureOfType(bounds, google.maps.LatLngBounds, createLatLngBounds)) : getLayoutStylesByPosition(mapCanvasProjection, offset, ensureOfType(position, google.maps.LatLng, createLatLng));
};

var ContentMountHandler =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(ContentMountHandler, _React$Component);

  function ContentMountHandler() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = ContentMountHandler.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onLoad) this.props.onLoad();
  };

  _proto.render = function render() {
    return this.props.children;
  };

  return ContentMountHandler;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var OverlayView =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(OverlayView, _React$PureComponent);

  function OverlayView() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      overlayView: null
    };
    _this.containerElement = null; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setOverlayViewCallback = function () {
      if (_this.state.overlayView !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.overlayView);
      }

      _this.onPositionElement();
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.onAdd = function () {
      _this.containerElement = document.createElement("div");
      _this.containerElement.style.position = "absolute";
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.onPositionElement = function () {
      if (_this.state.overlayView !== null && _this.containerElement !== null) {
        var mapCanvasProjection = _this.state.overlayView.getProjection();

        var offset = _extends({
          x: 0,
          y: 0
        }, getOffsetOverride(_this.containerElement, _this.props.getPixelPositionOffset));

        var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, _this.props.bounds, _this.props.position);
        Object.assign(_this.containerElement.style, layoutStyles);
      }
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.draw = function () {
      !!!_this.props.mapPaneName ?  false ? invariant(false, "OverlayView requires props.mapPaneName but got %s", _this.props.mapPaneName) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
      var overlayView = _this.state.overlayView;

      if (overlayView === null) {
        return;
      } // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes


      var mapPanes = overlayView.getPanes();

      if (!mapPanes) {
        return;
      }

      if (_this.containerElement) {
        mapPanes[_this.props.mapPaneName].appendChild(_this.containerElement);
      }

      _this.onPositionElement();

      _this.forceUpdate();
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name


    _this.onRemove = function () {
      if (_this.containerElement !== null && _this.containerElement.parentNode) {
        _this.containerElement.parentNode.removeChild(_this.containerElement);

        delete _this.containerElement;
      }
    };

    return _this;
  }

  var _proto2 = OverlayView.prototype;

  _proto2.componentDidMount = function componentDidMount() {
    var overlayView = new google.maps.OverlayView(); // You must implement three methods: onAdd(), draw(), and onRemove().

    overlayView.onAdd = this.onAdd;
    overlayView.draw = this.draw;
    overlayView.onRemove = this.onRemove;
    overlayView.setMap(this.context); // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.

    function setOverlayView() {
      return {
        overlayView: overlayView
      };
    }

    this.setState(setOverlayView);
  };

  _proto2.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    if (prevProps.position !== this.props.position || prevProps.bounds !== this.props.bounds) {
      setTimeout(function () {
        _this2.state.overlayView !== null && _this2.state.overlayView.draw();
      }, 0);
    }
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    if (this.state.overlayView !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.overlayView);
      }

      this.state.overlayView.setMap(null);
    }
  };

  _proto2.render = function render() {
    return this.containerElement !== null ? Object(__WEBPACK_IMPORTED_MODULE_3_react_dom__["createPortal"])(Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(ContentMountHandler, {
      onLoad: this.setOverlayViewCallback
    }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children)), this.containerElement) : Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return OverlayView;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
OverlayView.FLOAT_PANE = "floatPane";
OverlayView.MAP_PANE = "mapPane";
OverlayView.MARKER_LAYER = "markerLayer";
OverlayView.OVERLAY_LAYER = "overlayLayer";
OverlayView.OVERLAY_MOUSE_TARGET = "overlayMouseTarget";
OverlayView.contextType = MapContext;

var eventMap$d = {
  onDblClick: "dblclick",
  onClick: "click"
};
var updaterMap$d = {
  opacity: function opacity(instance, _opacity) {
    instance.setOpacity(_opacity);
  }
};
var GroundOverlay =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(GroundOverlay, _React$PureComponent);

  function GroundOverlay() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      groundOverlay: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setGroundOverlayCallback = function () {
      if (_this.state.groundOverlay !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.groundOverlay);
      }
    };

    return _this;
  }

  var _proto = GroundOverlay.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !(!!this.props.url || !!this.props.bounds) ?  false ? invariant(false, "For GroundOverlay, url and bounds are passed in to constructor and are immutable after instantiated. This is the behavior of Google Maps JavaScript API v3 ( See https://developers.google.com/maps/documentation/javascript/reference#GroundOverlay) Hence, use the corresponding two props provided by `react-google-maps-api`, url and bounds. In some cases, you'll need the GroundOverlay component to reflect the changes of url and bounds. You can leverage the React's key property to remount the component. Typically, just `key={url}` would serve your need. See https://github.com/tomchentw/react-google-maps/issues/655") : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    var groundOverlay = new google.maps.GroundOverlay(this.props.url, this.props.bounds, _extends({}, this.props.options, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$d,
      eventMap: eventMap$d,
      prevProps: {},
      nextProps: this.props,
      instance: groundOverlay
    });

    function setGroundOverlay() {
      return {
        groundOverlay: groundOverlay
      };
    }

    this.setState(setGroundOverlay, this.setGroundOverlayCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.groundOverlay !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$d,
        eventMap: eventMap$d,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.groundOverlay
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.groundOverlay) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.groundOverlay);
      }

      this.state.groundOverlay.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return GroundOverlay;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
GroundOverlay.defaultProps = {
  onLoad: function onLoad() {}
};
GroundOverlay.contextType = MapContext;

var eventMap$e = {};
var updaterMap$e = {
  data: function data(instance, _data) {
    instance.setData(_data);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  }
};
var HeatmapLayer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(HeatmapLayer, _React$PureComponent);

  function HeatmapLayer() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      heatmapLayer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setHeatmapLayerCallback = function () {
      if (_this.state.heatmapLayer !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.heatmapLayer);
      }
    };

    return _this;
  }

  var _proto = HeatmapLayer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !!!google.maps.visualization ?  false ? invariant(false, 'Did you include prop libraries={["visualization"]} to <LoadScript />? %s', google.maps.visualization) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    !!!this.props.data ?  false ? invariant(false, "data property is required in HeatmapLayer %s", this.props.data) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    var heatmapLayer = new google.maps.visualization.HeatmapLayer(_extends({
      data: this.props.data
    }, this.props.options || {}, {
      map: this.context
    }));
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$e,
      eventMap: eventMap$e,
      prevProps: {},
      nextProps: this.props,
      instance: heatmapLayer
    });

    function setHeatmapLayer() {
      return {
        heatmapLayer: heatmapLayer
      };
    }

    this.setState(setHeatmapLayer, this.setHeatmapLayerCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$e,
      eventMap: eventMap$e,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.heatmapLayer
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.heatmapLayer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.heatmapLayer);
      }

      unregisterEvents(this.registeredEvents);
      this.state.heatmapLayer.setMap(null);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return HeatmapLayer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
HeatmapLayer.contextType = MapContext;

var eventMap$f = {
  onCloseClick: "closeclick",
  onPanoChanged: "pano_changed",
  onPositionChanged: "position_changed",
  onPovChanged: "pov_changed",
  onResize: "resize",
  onStatusChanged: "status_changed",
  onVisibleChanged: "visible_changed",
  onZoomChanged: "zoom_changed"
};
var updaterMap$f = {
  register: function register(instance, provider, options) {
    instance.registerPanoProvider(provider, options);
  },
  links: function links(instance, _links) {
    instance.setLinks(_links);
  },
  motionTracking: function motionTracking(instance, _motionTracking) {
    instance.setMotionTracking(_motionTracking);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  pano: function pano(instance, _pano) {
    instance.setPano(_pano);
  },
  position: function position(instance, _position) {
    instance.setPosition(_position);
  },
  pov: function pov(instance, _pov) {
    instance.setPov(_pov);
  },
  visible: function visible(instance, _visible) {
    instance.setVisible(_visible);
  },
  zoom: function zoom(instance, _zoom) {
    instance.setZoom(_zoom);
  }
};
var StreetViewPanorama =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(StreetViewPanorama, _React$PureComponent);

  function StreetViewPanorama() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      streetViewPanorama: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setStreetViewPanoramaCallback = function () {
      if (_this.state.streetViewPanorama !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewPanorama);
      }
    };

    return _this;
  }

  var _proto = StreetViewPanorama.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var streetViewPanorama = this.context.getStreetView();
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$f,
      eventMap: eventMap$f,
      prevProps: {},
      nextProps: this.props,
      instance: streetViewPanorama
    });

    function setStreetViewPanorama() {
      return {
        streetViewPanorama: streetViewPanorama
      };
    }

    this.setState(setStreetViewPanorama, this.setStreetViewPanoramaCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.streetViewPanorama !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$f,
        eventMap: eventMap$f,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.streetViewPanorama
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.streetViewPanorama !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewPanorama);
      }

      unregisterEvents(this.registeredEvents);
      this.state.streetViewPanorama.setVisible(false);
    }
  };

  _proto.render = function render() {
    return null;
  };

  return StreetViewPanorama;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
StreetViewPanorama.contextType = MapContext;

var StreetViewService =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(StreetViewService, _React$PureComponent);

  function StreetViewService() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      streetViewService: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setStreetViewServiceCallback = function () {
      if (_this.state.streetViewService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.streetViewService);
      }
    };

    return _this;
  }

  var _proto = StreetViewService.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var streetViewService = new google.maps.StreetViewService();

    function setStreetViewService() {
      return {
        streetViewService: streetViewService
      };
    }

    this.setState(setStreetViewService);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.streetViewService !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.streetViewService);
      }
    }
  };

  _proto.render = function render() {
    return null;
  };

  return StreetViewService;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
StreetViewService.contextType = MapContext;

var DirectionsService =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DirectionsService, _React$PureComponent);

  function DirectionsService() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      directionsService: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setDirectionsServiceCallback = function () {
      if (_this.state.directionsService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.directionsService);
      }
    };

    return _this;
  }

  var _proto = DirectionsService.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !!!this.props.options ?  false ? invariant(false, "DirectionsService expected options object as parameter, but got %s", this.props.options) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    var directionsService = new google.maps.DirectionsService();

    function setDirectionsService() {
      return {
        directionsService: directionsService
      };
    }

    this.setState(setDirectionsService, this.setDirectionsServiceCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.directionsService !== null) {
      this.state.directionsService.route(this.props.options, this.props.callback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.directionsService !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsService);
      }
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return DirectionsService;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var eventMap$g = {
  onDirectionsChanged: "directions_changed"
};
var updaterMap$g = {
  directions: function directions(instance, _directions) {
    instance.setDirections(_directions);
  },
  map: function map(instance, _map) {
    instance.setMap(_map);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  panel: function panel(instance, _panel) {
    instance.setPanel(_panel);
  },
  routeIndex: function routeIndex(instance, _routeIndex) {
    instance.setRouteIndex(_routeIndex);
  }
};
var DirectionsRenderer =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DirectionsRenderer, _React$PureComponent);

  function DirectionsRenderer() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.state = {
      directionsRenderer: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setDirectionsRendererCallback = function () {
      if (_this.state.directionsRenderer !== null) {
        _this.state.directionsRenderer.setMap(_this.context);

        if (_this.props.onLoad) {
          _this.props.onLoad(_this.state.directionsRenderer);
        }
      }
    };

    return _this;
  }

  var _proto = DirectionsRenderer.prototype;

  _proto.componentDidMount = function componentDidMount() {
    var directionsRenderer = new google.maps.DirectionsRenderer(this.props.options);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$g,
      eventMap: eventMap$g,
      prevProps: {},
      nextProps: this.props,
      instance: directionsRenderer
    });
    this.setState(function setDirectionsRenderer() {
      return {
        directionsRenderer: directionsRenderer
      };
    }, this.setDirectionsRendererCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.directionsRenderer !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$g,
        eventMap: eventMap$g,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.directionsRenderer
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.directionsRenderer !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.directionsRenderer);
      }

      unregisterEvents(this.registeredEvents);

      if (this.state.directionsRenderer) {
        this.state.directionsRenderer.setMap(null);
      }
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return DirectionsRenderer;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
DirectionsRenderer.contextType = MapContext;

var DistanceMatrixService =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(DistanceMatrixService, _React$PureComponent);

  function DistanceMatrixService() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.state = {
      distanceMatrixService: null
    };

    _this.setDistanceMatrixServiceCallback = function () {
      if (_this.state.distanceMatrixService !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.distanceMatrixService);
      }
    };

    return _this;
  }

  var _proto = DistanceMatrixService.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !!!this.props.options ?  false ? invariant(false, 'DistanceMatrixService expected options object as parameter, but go %s', this.props.options) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;
    var distanceMatrixService = new google.maps.DistanceMatrixService();

    function setDistanceMatrixService() {
      return {
        distanceMatrixService: distanceMatrixService
      };
    }

    this.setState(setDistanceMatrixService, this.setDistanceMatrixServiceCallback);
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.state.distanceMatrixService !== null) {
      this.state.distanceMatrixService.getDistanceMatrix(this.props.options, this.props.callback);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.distanceMatrixService !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.distanceMatrixService);
      }
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"], null);
  };

  return DistanceMatrixService;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

var eventMap$h = {
  onPlacesChanged: "places_changed"
};
var updaterMap$h = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  }
};

var StandaloneSearchBox =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(StandaloneSearchBox, _React$PureComponent);

  function StandaloneSearchBox() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
    _this.state = {
      searchBox: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setSearchBoxCallback = function () {
      if (_this.state.searchBox !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.searchBox);
      }
    };

    return _this;
  }

  var _proto = StandaloneSearchBox.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !!!google.maps.places ?  false ? invariant(false, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0;

    if (this.containerElement !== null && this.containerElement.current !== null) {
      var input = this.containerElement.current.querySelector("input");

      if (input) {
        var searchBox = new google.maps.places.SearchBox( // @ts-ignore
        input, this.props.options);
        this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
          updaterMap: updaterMap$h,
          eventMap: eventMap$h,
          prevProps: {},
          nextProps: this.props,
          instance: searchBox
        });
        this.setState(function setSearchBox() {
          return {
            searchBox: searchBox
          };
        }, this.setSearchBoxCallback);
      }
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.state.searchBox !== null) {
      unregisterEvents(this.registeredEvents);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$h,
        eventMap: eventMap$h,
        prevProps: prevProps,
        nextProps: this.props,
        instance: this.state.searchBox
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.searchBox !== null) {
      if (this.props.onUnmount) {
        this.props.onUnmount(this.state.searchBox);
      }

      unregisterEvents(this.registeredEvents);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
      ref: this.containerElement
    }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children));
  };

  return StandaloneSearchBox;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

StandaloneSearchBox.contextType = MapContext;

var eventMap$i = {
  onPlaceChanged: "place_changed"
};
var updaterMap$i = {
  bounds: function bounds(instance, _bounds) {
    instance.setBounds(_bounds);
  },
  restrictions: function restrictions(instance, _restrictions) {
    instance.setComponentRestrictions(_restrictions);
  },
  fields: function fields(instance, _fields) {
    instance.setFields(_fields);
  },
  options: function options(instance, _options) {
    instance.setOptions(_options);
  },
  types: function types(instance, _types) {
    instance.setTypes(_types);
  }
};
var Autocomplete =
/*#__PURE__*/
function (_React$PureComponent) {
  _inheritsLoose(Autocomplete, _React$PureComponent);

  function Autocomplete() {
    var _this;

    _this = _React$PureComponent.apply(this, arguments) || this;
    _this.registeredEvents = [];
    _this.containerElement = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createRef"])();
    _this.state = {
      autocomplete: null
    }; // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name

    _this.setAutocompleteCallback = function () {
      if (_this.state.autocomplete !== null && _this.props.onLoad) {
        _this.props.onLoad(_this.state.autocomplete);
      }
    };

    return _this;
  }

  var _proto = Autocomplete.prototype;

  _proto.componentDidMount = function componentDidMount() {
    !!!google.maps.places ?  false ? invariant(false, 'You need to provide libraries={["places"]} prop to <LoadScript /> component %s', google.maps.places) : __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false) : void 0; // TODO: why is this possibly null
    // @ts-ignore

    var input = this.containerElement.current.querySelector("input");

    if (input) {
      var autocomplete = new google.maps.places.Autocomplete(input, this.props.options);
      this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
        updaterMap: updaterMap$i,
        eventMap: eventMap$i,
        prevProps: {},
        nextProps: this.props,
        instance: autocomplete
      });
      this.setState(function setAutocomplete() {
        return {
          autocomplete: autocomplete
        };
      }, this.setAutocompleteCallback);
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    unregisterEvents(this.registeredEvents);
    this.registeredEvents = applyUpdatersToPropsAndRegisterEvents({
      updaterMap: updaterMap$i,
      eventMap: eventMap$i,
      prevProps: prevProps,
      nextProps: this.props,
      instance: this.state.autocomplete
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.state.autocomplete !== null) {
      unregisterEvents(this.registeredEvents);
    }
  };

  _proto.render = function render() {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])("div", {
      ref: this.containerElement
    }, __WEBPACK_IMPORTED_MODULE_0_react__["Children"].only(this.props.children));
  };

  return Autocomplete;
}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);
Autocomplete.contextType = MapContext;


//# sourceMappingURL=reactgooglemapsapi.esm.js.map


/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Cluster */
/* unused harmony export ClusterIcon */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Clusterer; });
var ClusterIcon =
/*#__PURE__*/
function () {
  function ClusterIcon(cluster, styles) {
    cluster.getClusterer().extend(ClusterIcon, google.maps.OverlayView);
    this.cluster = cluster;
    this.className = this.cluster.getClusterer().getClusterClass();
    this.styles = styles;
    this.center = undefined;
    this.div = null;
    this.sums = null;
    this.visible = false;
    this.boundsChangedListener = null;
    this.url = '';
    this.height = 0;
    this.width = 0;
    this.anchorText = [0, 0];
    this.anchorIcon = [0, 0];
    this.textColor = 'black';
    this.textSize = 11;
    this.textDecoration = 'none';
    this.fontWeight = 'bold';
    this.fontStyle = 'normal';
    this.fontFamily = 'Arial,sans-serif';
    this.backgroundPosition = '0 0'; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore

    this.setMap(cluster.getMap()); // Note: this causes onAdd to be called
  }

  var _proto = ClusterIcon.prototype;

  _proto.onAdd = function onAdd() {
    var _this = this;

    var cMouseDownInCluster;
    var cDraggingMapByCluster;
    this.div = document.createElement('div');
    this.div.className = this.className;

    if (this.visible) {
      this.show();
    } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore


    this.getPanes().overlayMouseTarget.appendChild(this.div); // Fix for Issue 157

    this.boundsChangedListener = google.maps.event.addListener( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap(), 'boundschanged', function boundsChabged() {
      cDraggingMapByCluster = cMouseDownInCluster;
    });
    google.maps.event.addDomListener(this.div, 'mousedown', function onMouseDown() {
      cMouseDownInCluster = true;
      cDraggingMapByCluster = false;
    }); // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name

    google.maps.event.addDomListener(this.div, 'click', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    function (event) {
      cMouseDownInCluster = false;

      if (!cDraggingMapByCluster) {
        var markerClusterer = _this.cluster.getClusterer();
        /**
         * This event is fired when a cluster marker is clicked.
         * @name MarkerClusterer#click
         * @param {Cluster} c The cluster that was clicked.
         * @event
         */


        google.maps.event.trigger(markerClusterer, 'click', _this.cluster);
        google.maps.event.trigger(markerClusterer, 'clusterclick', _this.cluster); // deprecated name
        // The default click handler follows. Disable it by setting
        // the zoomOnClick property to false.

        if (markerClusterer.getZoomOnClick()) {
          // Zoom into the cluster.
          var maxZoom = markerClusterer.getMaxZoom();

          var bounds = _this.cluster.getBounds(); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore


          markerClusterer.getMap().fitBounds(bounds); // There is a fix for Issue 170 here:

          setTimeout(function timeout() {
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore
            markerClusterer.getMap().fitBounds(bounds); // Don't zoom beyond the max zoom level
            // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
            // @ts-ignore

            if (maxZoom !== null && markerClusterer.getMap().getZoom() > maxZoom) {
              // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
              // @ts-ignore
              markerClusterer.getMap().setZoom(maxZoom + 1);
            }
          }, 100);
        } // Prevent event propagation to the map:


        event.cancelBubble = true;

        if (event.stopPropagation) {
          event.stopPropagation();
        }
      }
    });
    google.maps.event.addDomListener(this.div, 'mouseover', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    function () {
      /**
       * This event is fired when the mouse moves over a cluster marker.
       * @name MarkerClusterer#mouseover
       * @param {Cluster} c The cluster that the mouse moved over.
       * @event
       */
      google.maps.event.trigger(_this.cluster.getClusterer(), 'mouseover', _this.cluster);
    }); // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name

    google.maps.event.addDomListener(this.div, 'mouseout', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    function () {
      /**
       * This event is fired when the mouse moves out of a cluster marker.
       * @name MarkerClusterer#mouseout
       * @param {Cluster} c The cluster that the mouse moved out of.
       * @event
       */
      google.maps.event.trigger(_this.cluster.getClusterer(), 'mouseout', _this.cluster);
    });
  };

  _proto.onRemove = function onRemove() {
    if (this.div && this.div.parentNode) {
      this.hide();

      if (this.boundsChangedListener !== null) {
        google.maps.event.removeListener(this.boundsChangedListener);
      }

      google.maps.event.clearInstanceListeners(this.div);
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  _proto.draw = function draw() {
    if (this.visible && this.div !== null && this.center) {
      var _this$getPosFromLatLn = this.getPosFromLatLng(this.center),
          x = _this$getPosFromLatLn.x,
          y = _this$getPosFromLatLn.y;

      this.div.style.top = y + 'px';
      this.div.style.left = x + 'px';
    }
  };

  _proto.hide = function hide() {
    if (this.div) {
      this.div.style.display = 'none';
    }

    this.visible = false;
  };

  _proto.show = function show() {
    if (this.div && this.center) {
      var img = '',
          divTitle = ''; // NOTE: values must be specified in px units

      var bp = this.backgroundPosition.split(' ');
      var spriteH = parseInt(bp[0].replace(/^\s+|\s+$/g, ''), 10);
      var spriteV = parseInt(bp[1].replace(/^\s+|\s+$/g, ''), 10);
      var pos = this.getPosFromLatLng(this.center);

      if (this.sums === null || typeof this.sums.title === 'undefined' || this.sums.title === '') {
        divTitle = this.cluster.getClusterer().getTitle();
      } else {
        divTitle = this.sums.title;
      }

      this.div.style.cssText = this.createCss(pos);
      img = "<img alt='" + divTitle + "' src='" + this.url + "' style='position: absolute; top: " + spriteV + 'px; left: ' + spriteH + 'px; '; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      //@ts-ignore

      if (!this.cluster.getClusterer().enableRetinaIcons) {
        img += 'clip: rect(' + -1 * spriteV + 'px, ' + (-1 * spriteH + this.width) + 'px, ' + (-1 * spriteV + this.height) + 'px, ' + -1 * spriteH + 'px);';
      }

      img += "'>";
      this.div.innerHTML = img + "<div style='" + 'position: absolute;' + 'top: ' + this.anchorText[0] + 'px;' + 'left: ' + this.anchorText[1] + 'px;' + 'color: ' + this.textColor + ';' + 'font-size: ' + this.textSize + 'px;' + 'font-family: ' + this.fontFamily + ';' + 'font-weight: ' + this.fontWeight + ';' + 'font-style: ' + this.fontStyle + ';' + 'text-decoration: ' + this.textDecoration + ';' + 'text-align: center;' + 'width: ' + this.width + 'px;' + 'line-height:' + this.height + 'px;' + "'>" + // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.sums.text + '</div>';
      this.div.title = divTitle;
      this.div.style.display = '';
    }

    this.visible = true;
  };

  _proto.useStyle = function useStyle(sums) {
    this.sums = sums;
    var style = this.styles[Math.min(this.styles.length - 1, Math.max(0, sums.index - 1))];
    this.url = style.url;
    this.height = style.height;
    this.width = style.width;
    this.anchorText = style.anchorText || [0, 0];
    this.anchorIcon = style.anchorIcon || [this.height / 2, this.width / 2];
    this.textColor = style.textColor || 'black';
    this.textSize = style.textSize || 11;
    this.textDecoration = style.textDecoration || 'none';
    this.fontWeight = style.fontWeight || 'bold';
    this.fontStyle = style.fontStyle || 'normal';
    this.fontFamily = style.fontFamily || 'Arial,sans-serif';
    this.backgroundPosition = style.backgroundPosition || '0 0';
  };

  _proto.setCenter = function setCenter(center) {
    this.center = center;
  };

  _proto.createCss = function createCss(pos) {
    var style = [];
    style.push('cursor: pointer;');
    style.push('position: absolute; top: ' + pos.y + 'px; left: ' + pos.x + 'px;');
    style.push('width: ' + this.width + 'px; height: ' + this.height + 'px;');
    return style.join('');
  };

  _proto.getPosFromLatLng = function getPosFromLatLng(latlng) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    var pos = this.getProjection().fromLatLngToDivPixel(latlng);
    pos.x -= this.anchorIcon[1];
    pos.y -= this.anchorIcon[0];
    pos.x = pos.x;
    pos.y = pos.y;
    return pos;
  };

  return ClusterIcon;
}();

var Cluster =
/*#__PURE__*/
function () {
  function Cluster(markerClusterer) {
    this.markerClusterer = markerClusterer; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore

    this.map = this.markerClusterer.getMap();
    this.gridSize = this.markerClusterer.getGridSize();
    this.minClusterSize = this.markerClusterer.getMinimumClusterSize();
    this.averageCenter = this.markerClusterer.getAverageCenter();
    this.markers = [];
    this.center = undefined;
    this.bounds = null;
    this.clusterIcon = new ClusterIcon(this, this.markerClusterer.getStyles());
  }

  var _proto = Cluster.prototype;

  _proto.getSize = function getSize() {
    return this.markers.length;
  };

  _proto.getMarkers = function getMarkers() {
    return this.markers;
  };

  _proto.getCenter = function getCenter() {
    return this.center;
  };

  _proto.getMap = function getMap() {
    return this.map;
  };

  _proto.getClusterer = function getClusterer() {
    return this.markerClusterer;
  };

  _proto.getBounds = function getBounds() {
    var bounds = new google.maps.LatLngBounds(this.center, this.center);
    var markers = this.getMarkers();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    }

    return bounds;
  };

  _proto.remove = function remove() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.clusterIcon.setMap(null);
    this.markers = [];
    delete this.markers;
  };

  _proto.addMarker = function addMarker(marker) {
    if (this.isMarkerAlreadyAdded(marker)) {
      return false;
    }

    if (!this.center) {
      var position = marker.getPosition();

      if (position) {
        this.center = position;
        this.calculateBounds();
      }
    } else {
      if (this.averageCenter) {
        var _position = marker.getPosition();

        if (_position) {
          var length = this.markers.length + 1;
          this.center = new google.maps.LatLng((this.center.lat() * (length - 1) + _position.lat()) / length, (this.center.lng() * (length - 1) + _position.lng()) / length);
          this.calculateBounds();
        }
      }
    }

    marker.isAdded = true;
    this.markers.push(marker);
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();

    if (maxZoom !== null && this.map.getZoom() > maxZoom) {
      // Zoomed in past max zoom, so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount < this.minClusterSize) {
      // Min cluster size not reached so show the marker.
      if (marker.getMap() !== this.map) {
        marker.setMap(this.map);
      }
    } else if (mCount === this.minClusterSize) {
      // Hide the markers that were showing.
      for (var i = 0; i < mCount; i++) {
        this.markers[i].setMap(null);
      }
    } else {
      marker.setMap(null);
    }

    this.updateIcon();
    return true;
  };

  _proto.isMarkerInClusterBounds = function isMarkerInClusterBounds(marker) {
    if (this.bounds !== null) {
      var position = marker.getPosition();

      if (position) {
        return this.bounds.contains(position);
      }
    }

    return false;
  };

  _proto.calculateBounds = function calculateBounds() {
    this.bounds = this.markerClusterer.getExtendedBounds(new google.maps.LatLngBounds(this.center, this.center));
  };

  _proto.updateIcon = function updateIcon() {
    var mCount = this.markers.length;
    var maxZoom = this.markerClusterer.getMaxZoom();

    if (maxZoom !== null && this.map.getZoom() > maxZoom) {
      this.clusterIcon.hide();
      return;
    }

    if (mCount < this.minClusterSize) {
      // Min cluster size not yet reached.
      this.clusterIcon.hide();
      return;
    }

    if (this.center) {
      this.clusterIcon.setCenter(this.center);
    }

    this.clusterIcon.useStyle(this.markerClusterer.getCalculator()(this.markers, this.markerClusterer.getStyles().length));
    this.clusterIcon.show();
  };

  _proto.isMarkerAlreadyAdded = function isMarkerAlreadyAdded(marker) {
    if (this.markers.indexOf) {
      return this.markers.includes(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          return true;
        }
      }
    }

    return false;
  };

  return Cluster;
}();

/* eslint-disable filenames/match-regex */

var CALCULATOR = function CALCULATOR(markers, numStyles) {
  var index = 0;
  var title = '';
  var count = markers.length.toString();
  var dv = count;

  while (dv !== 0) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    dv = parseInt(dv, 10) / 10;
    index++;
  }

  index = Math.min(index, numStyles);
  return {
    text: count,
    index: index,
    title: title
  };
};

var BATCH_SIZE = 2000;
var BATCH_SIZE_IE = 500;
var IMAGE_PATH = 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m';
var IMAGE_EXTENSION = 'png';
var IMAGE_SIZES = [53, 56, 66, 78, 90];
var CLUSTERER_CLASS = 'cluster';
var Clusterer =
/*#__PURE__*/
function () {
  function Clusterer(map, optMarkers, optOptions) {
    if (optMarkers === void 0) {
      optMarkers = [];
    }

    if (optOptions === void 0) {
      optOptions = {};
    }

    this.extend(Clusterer, google.maps.OverlayView);
    this.markers = [];
    this.clusters = [];
    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
    this.gridSize = optOptions.gridSize || 60;
    this.minClusterSize = optOptions.minimumClusterSize || 2;
    this.maxZoom = optOptions.maxZoom || null;
    this.styles = optOptions.styles || [];
    this.title = optOptions.title || '';
    this.zoomOnClick = true;

    if (optOptions.zoomOnClick !== undefined) {
      this.zoomOnClick = optOptions.zoomOnClick;
    }

    this.averageCenter = false;

    if (optOptions.averageCenter !== undefined) {
      this.averageCenter = optOptions.averageCenter;
    }

    this.ignoreHidden = false;

    if (optOptions.ignoreHidden !== undefined) {
      this.ignoreHidden = optOptions.ignoreHidden;
    }

    this.enableRetinaIcons = false;

    if (optOptions.enableRetinaIcons !== undefined) {
      this.enableRetinaIcons = optOptions.enableRetinaIcons;
    }

    this.imagePath = optOptions.imagePath || IMAGE_PATH;
    this.imageExtension = optOptions.imageExtension || IMAGE_EXTENSION;
    this.imageSizes = optOptions.imageSizes || IMAGE_SIZES;
    this.calculator = optOptions.calculator || CALCULATOR;
    this.batchSize = optOptions.batchSize || BATCH_SIZE;
    this.batchSizeIE = optOptions.batchSizeIE || BATCH_SIZE_IE;
    this.clusterClass = optOptions.clusterClass || CLUSTERER_CLASS;

    if (navigator.userAgent.toLowerCase().indexOf('msie') !== -1) {
      // Try to avoid IE timeout when processing a huge number of markers:
      this.batchSize = this.batchSizeIE;
    }

    this.timerRefStatic = null;
    this.setupStyles();
    this.addMarkers(optMarkers, true); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore

    this.setMap(map); // Note: this causes onAdd to be called
  }

  var _proto = Clusterer.prototype;

  _proto.onAdd = function onAdd() {
    var _this = this;

    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.activeMap = this.getMap();
    this.ready = true;
    this.repaint(); // Add the map event listeners

    this.listeners = [google.maps.event.addListener( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap(), 'zoom_changed', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    function () {
      _this.resetViewport(false); // Workaround for this Google bug: when map is at level 0 and "-" of
      // zoom slider is clicked, a "zoom_changed" event is fired even though
      // the map doesn't zoom out any further. In this situation, no "idle"
      // event is triggered so the cluster markers that have been removed
      // do not get redrawn. Same goes for a zoom in at maxZoom.


      if ( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      _this.getMap().getZoom() === (_this.get('minZoom') || 0) || // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      _this.getMap().getZoom() === _this.get('maxZoom')) {
        google.maps.event.trigger(_this, 'idle');
      }
    }), google.maps.event.addListener( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap(), 'idle', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    function () {
      _this.redraw();
    })];
  } // eslint-disable-next-line @getify/proper-arrows/this
  ;

  _proto.onRemove = function onRemove() {
    // Put all the managed markers back on the map:
    for (var i = 0; i < this.markers.length; i++) {
      if (this.markers[i].getMap() !== this.activeMap) {
        this.markers[i].setMap(this.activeMap);
      }
    } // Remove all clusters:


    for (var _i = 0; _i < this.clusters.length; _i++) {
      this.clusters[_i].remove();
    }

    this.clusters = []; // Remove map event listeners:

    for (var _i2 = 0; _i2 < this.listeners.length; _i2++) {
      google.maps.event.removeListener(this.listeners[_i2]);
    }

    this.listeners = [];
    this.activeMap = null;
    this.ready = false;
  } // eslint-disable-next-line @typescript-eslint/no-empty-function
  ;

  _proto.draw = function draw() {};

  _proto.setupStyles = function setupStyles() {
    if (this.styles.length > 0) {
      return;
    }

    for (var i = 0; i < this.imageSizes.length; i++) {
      this.styles.push({
        url: this.imagePath + (i + 1) + '.' + this.imageExtension,
        height: this.imageSizes[i],
        width: this.imageSizes[i]
      });
    }
  };

  _proto.fitMapToMarkers = function fitMapToMarkers() {
    var markers = this.getMarkers();
    var bounds = new google.maps.LatLngBounds();

    for (var i = 0; i < markers.length; i++) {
      var position = markers[i].getPosition();

      if (position) {
        bounds.extend(position);
      }
    } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore


    this.getMap().fitBounds(bounds);
  };

  _proto.getGridSize = function getGridSize() {
    return this.gridSize;
  };

  _proto.setGridSize = function setGridSize(gridSize) {
    this.gridSize = gridSize;
  };

  _proto.getMinimumClusterSize = function getMinimumClusterSize() {
    return this.minClusterSize;
  };

  _proto.setMinimumClusterSize = function setMinimumClusterSize(minimumClusterSize) {
    this.minClusterSize = minimumClusterSize;
  };

  _proto.getMaxZoom = function getMaxZoom() {
    return this.maxZoom;
  };

  _proto.setMaxZoom = function setMaxZoom(maxZoom) {
    this.maxZoom = maxZoom;
  };

  _proto.getStyles = function getStyles() {
    return this.styles;
  };

  _proto.setStyles = function setStyles(styles) {
    this.styles = styles;
  };

  _proto.getTitle = function getTitle() {
    return this.title;
  };

  _proto.setTitle = function setTitle(title) {
    this.title = title;
  };

  _proto.getZoomOnClick = function getZoomOnClick() {
    return this.zoomOnClick;
  };

  _proto.setZoomOnClick = function setZoomOnClick(zoomOnClick) {
    this.zoomOnClick = zoomOnClick;
  };

  _proto.getAverageCenter = function getAverageCenter() {
    return this.averageCenter;
  };

  _proto.setAverageCenter = function setAverageCenter(averageCenter) {
    this.averageCenter = averageCenter;
  };

  _proto.getIgnoreHidden = function getIgnoreHidden() {
    return this.ignoreHidden;
  };

  _proto.setIgnoreHidden = function setIgnoreHidden(ignoreHidden) {
    this.ignoreHidden = ignoreHidden;
  };

  _proto.getEnableRetinaIcons = function getEnableRetinaIcons() {
    return this.enableRetinaIcons;
  };

  _proto.setEnableRetinaIcons = function setEnableRetinaIcons(enableRetinaIcons) {
    this.enableRetinaIcons = enableRetinaIcons;
  };

  _proto.getImageExtension = function getImageExtension() {
    return this.imageExtension;
  };

  _proto.setImageExtension = function setImageExtension(imageExtension) {
    this.imageExtension = imageExtension;
  };

  _proto.getImagePath = function getImagePath() {
    return this.imagePath;
  };

  _proto.setImagePath = function setImagePath(imagePath) {
    this.imagePath = imagePath;
  };

  _proto.getImageSizes = function getImageSizes() {
    return this.imageSizes;
  };

  _proto.setImageSizes = function setImageSizes(imageSizes) {
    this.imageSizes = imageSizes;
  };

  _proto.getCalculator = function getCalculator() {
    return this.calculator;
  };

  _proto.setCalculator = function setCalculator(calculator) {
    this.calculator = calculator;
  };

  _proto.getBatchSizeIE = function getBatchSizeIE() {
    return this.batchSizeIE;
  };

  _proto.setBatchSizeIE = function setBatchSizeIE(batchSizeIE) {
    this.batchSizeIE = batchSizeIE;
  };

  _proto.getClusterClass = function getClusterClass() {
    return this.clusterClass;
  };

  _proto.setClusterClass = function setClusterClass(clusterClass) {
    this.clusterClass = clusterClass;
  };

  _proto.getMarkers = function getMarkers() {
    return this.markers;
  };

  _proto.getTotalMarkers = function getTotalMarkers() {
    return this.markers.length;
  };

  _proto.getClusters = function getClusters() {
    return this.clusters;
  };

  _proto.getTotalClusters = function getTotalClusters() {
    return this.clusters.length;
  };

  _proto.addMarker = function addMarker(marker, optNoDraw) {
    this.pushMarkerTo(marker);

    if (!optNoDraw) {
      this.redraw();
    }
  };

  _proto.addMarkers = function addMarkers(markers, optNoDraw) {
    for (var key in markers) {
      if (markers.hasOwnProperty(key)) {
        this.pushMarkerTo(markers[key]);
      }
    }

    if (!optNoDraw) {
      this.redraw();
    }
  };

  _proto.pushMarkerTo = function pushMarkerTo(marker) {
    var _this2 = this;

    // If the marker is draggable add a listener so we can update the clusters on the dragend:
    if (marker.getDraggable()) {
      // eslint-disable-next-line @getify/proper-arrows/name, @getify/proper-arrows/this
      google.maps.event.addListener(marker, 'dragend', function () {
        if (_this2.ready) {
          marker.isAdded = false;

          _this2.repaint();
        }
      });
    }

    marker.isAdded = false;
    this.markers.push(marker);
  };

  _proto.removeMarker_ = function removeMarker_(marker) {
    var index = -1;

    if (this.markers.indexOf) {
      index = this.markers.indexOf(marker);
    } else {
      for (var i = 0; i < this.markers.length; i++) {
        if (marker === this.markers[i]) {
          index = i;
          break;
        }
      }
    }

    if (index === -1) {
      // Marker is not in our list of markers, so do nothing:
      return false;
    }

    marker.setMap(null);
    this.markers.splice(index, 1); // Remove the marker from the list of managed markers

    return true;
  };

  _proto.removeMarker = function removeMarker(marker, optNoDraw) {
    var removed = this.removeMarker_(marker);

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  _proto.removeMarkers = function removeMarkers(markers, optNoDraw) {
    var removed = false;

    for (var i = 0; i < markers.length; i++) {
      removed = removed || this.removeMarker_(markers[i]);
    }

    if (!optNoDraw && removed) {
      this.repaint();
    }

    return removed;
  };

  _proto.clearMarkers = function clearMarkers() {
    this.resetViewport(true);
    this.markers = [];
  };

  _proto.repaint = function repaint() {
    var oldClusters = this.clusters.slice();
    this.clusters = [];
    this.resetViewport(false);
    this.redraw(); // Remove the old clusters.
    // Do it in a timeout to prevent blinking effect.

    setTimeout(function timeout() {
      for (var i = 0; i < oldClusters.length; i++) {
        oldClusters[i].remove();
      }
    }, 0);
  };

  _proto.getExtendedBounds = function getExtendedBounds(bounds) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    var projection = this.getProjection(); // Convert the points to pixels and the extend out by the grid size.

    var trPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getNorthEast().lat(), bounds.getNorthEast().lng()));
    trPix.x += this.gridSize;
    trPix.y -= this.gridSize;
    var blPix = projection.fromLatLngToDivPixel( // Turn the bounds into latlng.
    new google.maps.LatLng(bounds.getSouthWest().lat(), bounds.getSouthWest().lng()));
    blPix.x -= this.gridSize;
    blPix.y += this.gridSize; // Extend the bounds to contain the new bounds.

    bounds.extend( // Convert the pixel points back to LatLng nw
    projection.fromDivPixelToLatLng(trPix));
    bounds.extend( // Convert the pixel points back to LatLng sw
    projection.fromDivPixelToLatLng(blPix));
    return bounds;
  };

  _proto.redraw = function redraw() {
    // Redraws all the clusters.
    this.createClusters(0);
  };

  _proto.resetViewport = function resetViewport(optHide) {
    // Remove all the clusters
    for (var i = 0; i < this.clusters.length; i++) {
      this.clusters[i].remove();
    }

    this.clusters = []; // Reset the markers to not be added and to be removed from the map.

    for (var _i3 = 0; _i3 < this.markers.length; _i3++) {
      var marker = this.markers[_i3];
      marker.isAdded = false;

      if (optHide) {
        marker.setMap(null);
      }
    }
  };

  _proto.distanceBetweenPoints = function distanceBetweenPoints(p1, p2) {
    var R = 6371; // Radius of the Earth in km

    var dLat = (p2.lat() - p1.lat()) * Math.PI / 180;
    var dLon = (p2.lng() - p1.lng()) * Math.PI / 180;
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(p1.lat() * Math.PI / 180) * Math.cos(p2.lat() * Math.PI / 180) * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * (2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a)));
  };

  _proto.isMarkerInBounds = function isMarkerInBounds(marker, bounds) {
    var position = marker.getPosition();

    if (position) {
      return bounds.contains(position);
    }

    return false;
  };

  _proto.addToClosestCluster = function addToClosestCluster(marker) {
    var cluster;
    var distance = 40000; // Some large number

    var clusterToAddTo = null;

    for (var i = 0; i < this.clusters.length; i++) {
      cluster = this.clusters[i];
      var center = cluster.getCenter();
      var position = marker.getPosition();

      if (center && position) {
        var d = this.distanceBetweenPoints(center, position);

        if (d < distance) {
          distance = d;
          clusterToAddTo = cluster;
        }
      }
    }

    if (clusterToAddTo && clusterToAddTo.isMarkerInClusterBounds(marker)) {
      clusterToAddTo.addMarker(marker);
    } else {
      cluster = new Cluster(this);
      cluster.addMarker(marker);
      this.clusters.push(cluster);
    }
  };

  _proto.createClusters = function createClusters(iFirst) {
    var _this3 = this;

    if (!this.ready) {
      return;
    } // Cancel previous batch processing if we're working on the first batch:


    if (iFirst === 0) {
      /**
       * This event is fired when the <code>Clusterer</code> begins
       *  clustering markers.
       * @name Clusterer#clusteringbegin
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */
      google.maps.event.trigger(this, 'clusteringbegin', this);

      if (this.timerRefStatic !== null) {
        window.clearTimeout(this.timerRefStatic);
        delete this.timerRefStatic;
      }
    } // Get our current map view bounds.
    // Create a new bounds object so we don't affect the map.
    //
    // See Comments 9 & 11 on Issue 3651 relating to this workaround for a Google Maps bug:


    var mapBounds = // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap().getZoom() > 3 ? new google.maps.LatLngBounds( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap().getBounds().getSouthWest(), // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    this.getMap().getBounds().getNorthEast()) : new google.maps.LatLngBounds(new google.maps.LatLng(85.02070771743472, -178.48388434375), new google.maps.LatLng(-85.08136444384544, 178.00048865625));
    var bounds = this.getExtendedBounds(mapBounds);
    var iLast = Math.min(iFirst + this.batchSize, this.markers.length);

    for (var i = iFirst; i < iLast; i++) {
      var marker = this.markers[i];

      if (!marker.isAdded && this.isMarkerInBounds(marker, bounds)) {
        if (!this.ignoreHidden || this.ignoreHidden && marker.getVisible()) {
          this.addToClosestCluster(marker);
        }
      }
    }

    if (iLast < this.markers.length) {
      this.timerRefStatic = window.setTimeout( // eslint-disable-next-line @getify/proper-arrows/this, @getify/proper-arrows/name
      function () {
        _this3.createClusters(iLast);
      }, 0);
    } else {
      this.timerRefStatic = null;
      /**
       * This event is fired when the <code>Clusterer</code> stops
       *  clustering markers.
       * @name Clusterer#clusteringend
       * @param {Clusterer} mc The Clusterer whose markers are being clustered.
       * @event
       */

      google.maps.event.trigger(this, 'clusteringend', this);
    }
  };

  _proto.extend = function extend(obj1, obj2) {
    return function applyExtend(object) {
      // eslint-disable-next-line guard-for-in
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        this.prototype[property] = object.prototype[property];
      } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore


      return this;
    }.apply(obj1, [obj2]);
  };

  return Clusterer;
}();


//# sourceMappingURL=markerclusterer.esm.js.map


/***/ }),
/* 1458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return InfoBox; });
var InfoBox =
/*#__PURE__*/
function () {
  function InfoBox(options) {
    if (options === void 0) {
      options = {};
    }

    this.extend(InfoBox, google.maps.OverlayView); // Standard options (in common with google.maps.InfoWindow):

    this.content = options.content || '';
    this.disableAutoPan = options.disableAutoPan || false;
    this.maxWidth = options.maxWidth || 0;
    this.pixelOffset = options.pixelOffset || new google.maps.Size(0, 0);
    this.position = options.position || new google.maps.LatLng(0, 0);
    this.zIndex = options.zIndex || null; // Additional options (unique to InfoBox):

    this.boxClass = options.boxClass || 'infoBox';
    this.boxStyle = options.boxStyle || {};
    this.closeBoxMargin = options.closeBoxMargin || '2px';
    this.closeBoxURL = options.closeBoxURL || 'http://www.google.com/intl/en_us/mapfiles/close.gif';

    if (options.closeBoxURL === '') {
      this.closeBoxURL = '';
    }

    this.infoBoxClearance = options.infoBoxClearance || new google.maps.Size(1, 1);

    if (typeof options.visible === 'undefined') {
      if (typeof options.isHidden === 'undefined') {
        options.visible = true;
      } else {
        options.visible = !options.isHidden;
      }
    }

    this.isHidden = !options.visible;
    this.alignBottom = options.alignBottom || false;
    this.pane = options.pane || 'floatPane';
    this.enableEventPropagation = options.enableEventPropagation || false;
    this.div = null;
    this.closeListener = null;
    this.moveListener = null;
    this.mapListener = null;
    this.contextListener = null;
    this.eventListeners = null;
    this.fixedWidthSet = null;
  }

  var _proto = InfoBox.prototype;

  _proto.createInfoBoxDiv = function createInfoBoxDiv() {
    var _this = this;

    // This handler prevents an event in the InfoBox from being passed on to the map.
    function cancelHandler(event) {
      event.cancelBubble = true;

      if (event.stopPropagation) {
        event.stopPropagation();
      }
    } // This handler ignores the current event in the InfoBox and conditionally prevents
    // the event from being passed on to the map. It is used for the contextmenu event.
    // eslint-disable-next-line  @getify/proper-arrows/this


    var ignoreHandler = function ignoreHandler(event) {
      event.returnValue = false;

      if (event.preventDefault) {
        event.preventDefault();
      }

      if (!_this.enableEventPropagation) {
        cancelHandler(event);
      }
    };

    if (!this.div) {
      this.div = document.createElement('div');
      this.setBoxStyle();

      if (typeof this.content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + this.content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(this.content);
      } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore


      var panes = this.getPanes();
      panes[this.pane].appendChild(this.div); // Add the InfoBox div to the DOM

      this.addClickHandler();

      if (this.div.style.width) {
        this.fixedWidthSet = true;
      } else {
        if (this.maxWidth !== 0 && this.div.offsetWidth > this.maxWidth) {
          this.div.style.width = this.maxWidth + 'px';
          this.fixedWidthSet = true;
        } else {
          // The following code is needed to overcome problems with MSIE
          var bw = this.getBoxWidths();
          this.div.style.width = this.div.offsetWidth - bw.left - bw.right + 'px';
          this.fixedWidthSet = false;
        }
      }

      this.panBox(this.disableAutoPan);

      if (!this.enableEventPropagation) {
        this.eventListeners = []; // Cancel event propagation.
        // Note: mousemove not included (to resolve Issue 152)

        var events = ['mousedown', 'mouseover', 'mouseout', 'mouseup', 'click', 'dblclick', 'touchstart', 'touchend', 'touchmove'];

        for (var i = 0; i < events.length; i++) {
          this.eventListeners.push(google.maps.event.addDomListener(this.div, events[i], cancelHandler));
        } // Workaround for Google bug that causes the cursor to change to a pointer
        // when the mouse moves over a marker underneath InfoBox.


        this.eventListeners.push(google.maps.event.addDomListener(this.div, 'mouseover', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
        function () {
          if (_this.div) {
            _this.div.style.cursor = 'default';
          }
        }));
      }

      this.contextListener = google.maps.event.addDomListener(this.div, 'contextmenu', ignoreHandler);
      /**
       * This event is fired when the DIV containing the InfoBox's content is attached to the DOM.
       * @name InfoBox#domready
       * @event
       */

      google.maps.event.trigger(this, 'domready');
    }
  };

  _proto.getCloseBoxImg = function getCloseBoxImg() {
    var img = '';

    if (this.closeBoxURL !== '') {
      img = '<img';
      img += " src='" + this.closeBoxURL + "'";
      img += ' align=right'; // Do this because Opera chokes on style='float: right;'

      img += " style='";
      img += ' position: relative;'; // Required by MSIE

      img += ' cursor: pointer;';
      img += ' margin: ' + this.closeBoxMargin + ';';
      img += "'>";
    }

    return img;
  };

  _proto.addClickHandler = function addClickHandler() {
    if (this.div && this.div.firstChild && this.closeBoxURL !== '') {
      var closeBox = this.div.firstChild;
      this.closeListener = google.maps.event.addDomListener(closeBox, 'click', this.getCloseClickHandler());
    } else {
      this.closeListener = null;
    }
  };

  _proto.getCloseClickHandler = function getCloseClickHandler() {
    var _this2 = this;

    // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
    return function (event) {
      // 1.0.3 fix: Always prevent propagation of a close box click to the map:
      event.cancelBubble = true;

      if (event.stopPropagation) {
        event.stopPropagation();
      }
      /**
       * This event is fired when the InfoBox's close box is clicked.
       * @name InfoBox#closeclick
       * @event
       */


      google.maps.event.trigger(_this2, 'closeclick');

      _this2.close();
    };
  };

  _proto.panBox = function panBox(disablePan) {
    if (this.div && !disablePan) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      var map = this.getMap(); // Only pan if attached to map, not panorama

      if (map instanceof google.maps.Map) {
        var xOffset = 0;
        var yOffset = 0;
        var bounds = map.getBounds();

        if (bounds && !bounds.contains(this.position)) {
          // Marker not in visible area of map, so set center
          // of map to the marker position first.
          map.setCenter(this.position);
        }

        var mapDiv = map.getDiv(); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore

        var mapWidth = mapDiv.offsetWidth; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore

        var mapHeight = mapDiv.offsetHeight;
        var iwOffsetX = this.pixelOffset.width;
        var iwOffsetY = this.pixelOffset.height;
        var iwWidth = this.div.offsetWidth;
        var iwHeight = this.div.offsetHeight;
        var padX = this.infoBoxClearance.width;
        var padY = this.infoBoxClearance.height; // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore

        var projection = this.getProjection();
        var pixPosition = projection.fromLatLngToContainerPixel(this.position);

        if (pixPosition.x < -iwOffsetX + padX) {
          xOffset = pixPosition.x + iwOffsetX - padX;
        } else if (pixPosition.x + iwWidth + iwOffsetX + padX > mapWidth) {
          xOffset = pixPosition.x + iwWidth + iwOffsetX + padX - mapWidth;
        }

        if (this.alignBottom) {
          if (pixPosition.y < -iwOffsetY + padY + iwHeight) {
            yOffset = pixPosition.y + iwOffsetY - padY - iwHeight;
          } else if (pixPosition.y + iwOffsetY + padY > mapHeight) {
            yOffset = pixPosition.y + iwOffsetY + padY - mapHeight;
          }
        } else {
          if (pixPosition.y < -iwOffsetY + padY) {
            yOffset = pixPosition.y + iwOffsetY - padY;
          } else if (pixPosition.y + iwHeight + iwOffsetY + padY > mapHeight) {
            yOffset = pixPosition.y + iwHeight + iwOffsetY + padY - mapHeight;
          }
        }

        if (!(xOffset === 0 && yOffset === 0)) {
          // Move the map to the shifted center.
          map.panBy(xOffset, yOffset);
        }
      }
    }
  };

  _proto.setBoxStyle = function setBoxStyle() {
    if (this.div) {
      // Apply style values from the style sheet defined in the boxClass parameter:
      this.div.className = this.boxClass; // Clear existing inline style values:

      this.div.style.cssText = ''; // Apply style values defined in the boxStyle parameter:

      var boxStyle = this.boxStyle;

      for (var i in boxStyle) {
        if (boxStyle.hasOwnProperty(i)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.div.style[i] = boxStyle[i];
        }
      } // Fix for iOS disappearing InfoBox problem
      // See http://stackoverflow.com/questions/9229535/google-maps-markers-disappear-at-certain-zoom-level-only-on-iphone-ipad


      this.div.style.webkitTransform = 'translateZ(0)'; // Fix up opacity style for benefit of MSIE

      if (typeof this.div.style.opacity !== 'undefined' && this.div.style.opacity !== '') {
        // See http://www.quirksmode.org/css/opacity.html
        var opacity = parseFloat(this.div.style.opacity || ''); // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore

        this.div.style.msFilter = '"progid:DXImageTransform.Microsoft.Alpha(Opacity=' + opacity * 100 + ')"';
        this.div.style.filter = 'alpha(opacity=' + opacity * 100 + ')';
      } // Apply required styles


      this.div.style.position = 'absolute';
      this.div.style.visibility = 'hidden';

      if (this.zIndex !== null) {
        this.div.style.zIndex = this.zIndex + '';
      }

      if (!this.div.style.overflow) {
        this.div.style.overflow = 'auto';
      }
    }
  };

  _proto.getBoxWidths = function getBoxWidths() {
    var bw = {
      top: 0,
      bottom: 0,
      left: 0,
      right: 0
    };

    if (!this.div) {
      return bw;
    }

    if (document.defaultView && document.defaultView.getComputedStyle) {
      var ownerDocument = this.div.ownerDocument;
      var computedStyle = ownerDocument && ownerDocument.defaultView ? ownerDocument.defaultView.getComputedStyle(this.div, '') : null;

      if (computedStyle) {
        // The computed styles are always in pixel units (good!)
        bw.top = parseInt(computedStyle.borderTopWidth || '', 10) || 0;
        bw.bottom = parseInt(computedStyle.borderBottomWidth || '', 10) || 0;
        bw.left = parseInt(computedStyle.borderLeftWidth || '', 10) || 0;
        bw.right = parseInt(computedStyle.borderRightWidth || '', 10) || 0;
      }
    } else if ( // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    document.documentElement.currentStyle // MSIE
    ) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        var currentStyle = this.div.currentStyle;

        if (currentStyle) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // The current styles may not be in pixel units, but assume they are (bad!)
          bw.top = parseInt(currentStyle.borderTopWidth || '', 10) || 0;
          bw.bottom = parseInt(currentStyle.borderBottomWidth || '', 10) || 0;
          bw.left = parseInt(currentStyle.borderLeftWidth || '', 10) || 0;
          bw.right = parseInt(currentStyle.borderRightWidth || '', 10) || 0;
        }
      }

    return bw;
  };

  _proto.onRemove = function onRemove() {
    if (this.div && this.div.parentNode) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  _proto.draw = function draw() {
    this.createInfoBoxDiv();

    if (this.div) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      var projection = this.getProjection();
      var pixPosition = projection.fromLatLngToDivPixel(this.position);
      this.div.style.left = pixPosition.x + this.pixelOffset.width + 'px';

      if (this.alignBottom) {
        this.div.style.bottom = -(pixPosition.y + this.pixelOffset.height) + 'px';
      } else {
        this.div.style.top = pixPosition.y + this.pixelOffset.height + 'px';
      }

      if (this.isHidden) {
        this.div.style.visibility = 'hidden';
      } else {
        this.div.style.visibility = 'visible';
      }
    }
  };

  _proto.setOptions = function setOptions(options) {
    if (options === void 0) {
      options = {};
    }

    if (typeof options.boxClass !== 'undefined') {
      // Must be first
      this.boxClass = options.boxClass;
      this.setBoxStyle();
    }

    if (typeof options.boxStyle !== 'undefined') {
      // Must be second
      this.boxStyle = options.boxStyle;
      this.setBoxStyle();
    }

    if (typeof options.content !== 'undefined') {
      this.setContent(options.content);
    }

    if (typeof options.disableAutoPan !== 'undefined') {
      this.disableAutoPan = options.disableAutoPan;
    }

    if (typeof options.maxWidth !== 'undefined') {
      this.maxWidth = options.maxWidth;
    }

    if (typeof options.pixelOffset !== 'undefined') {
      this.pixelOffset = options.pixelOffset;
    }

    if (typeof options.alignBottom !== 'undefined') {
      this.alignBottom = options.alignBottom;
    }

    if (typeof options.position !== 'undefined') {
      this.setPosition(options.position);
    }

    if (typeof options.zIndex !== 'undefined') {
      this.setZIndex(options.zIndex);
    }

    if (typeof options.closeBoxMargin !== 'undefined') {
      this.closeBoxMargin = options.closeBoxMargin;
    }

    if (typeof options.closeBoxURL !== 'undefined') {
      this.closeBoxURL = options.closeBoxURL;
    }

    if (typeof options.infoBoxClearance !== 'undefined') {
      this.infoBoxClearance = options.infoBoxClearance;
    }

    if (typeof options.isHidden !== 'undefined') {
      this.isHidden = options.isHidden;
    }

    if (typeof options.visible !== 'undefined') {
      this.isHidden = !options.visible;
    }

    if (typeof options.enableEventPropagation !== 'undefined') {
      this.enableEventPropagation = options.enableEventPropagation;
    }

    if (this.div) {
      this.draw();
    }
  };

  _proto.setContent = function setContent(content) {
    this.content = content;

    if (this.div) {
      if (this.closeListener) {
        google.maps.event.removeListener(this.closeListener);
        this.closeListener = null;
      } // Odd code required to make things work with MSIE.


      if (!this.fixedWidthSet) {
        this.div.style.width = '';
      }

      if (typeof content === 'string') {
        this.div.innerHTML = this.getCloseBoxImg() + content;
      } else {
        this.div.innerHTML = this.getCloseBoxImg();
        this.div.appendChild(content);
      } // Perverse code required to make things work with MSIE.
      // (Ensures the close box does, in fact, float to the right.)


      if (!this.fixedWidthSet) {
        this.div.style.width = this.div.offsetWidth + 'px';

        if (typeof content === 'string') {
          this.div.innerHTML = this.getCloseBoxImg() + content;
        } else {
          this.div.innerHTML = this.getCloseBoxImg();
          this.div.appendChild(content);
        }
      }

      this.addClickHandler();
    }
    /**
     * This event is fired when the content of the InfoBox changes.
     * @name InfoBox#content_changed
     * @event
     */


    google.maps.event.trigger(this, 'content_changed');
  };

  _proto.setPosition = function setPosition(latLng) {
    this.position = latLng;

    if (this.div) {
      this.draw();
    }
    /**
     * This event is fired when the position of the InfoBox changes.
     * @name InfoBox#position_changed
     * @event
     */


    google.maps.event.trigger(this, 'position_changed');
  };

  _proto.setVisible = function setVisible(isVisible) {
    this.isHidden = !isVisible;

    if (this.div) {
      this.div.style.visibility = this.isHidden ? 'hidden' : 'visible';
    }
  };

  _proto.setZIndex = function setZIndex(index) {
    this.zIndex = index;

    if (this.div) {
      this.div.style.zIndex = index + '';
    }
    /**
     * This event is fired when the zIndex of the InfoBox changes.
     * @name InfoBox#zindex_changed
     * @event
     */


    google.maps.event.trigger(this, 'zindex_changed');
  };

  _proto.getContent = function getContent() {
    return this.content;
  };

  _proto.getPosition = function getPosition() {
    return this.position;
  };

  _proto.getZIndex = function getZIndex() {
    return this.zIndex;
  };

  _proto.getVisible = function getVisible() {
    // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore
    var map = this.getMap();
    var isVisible;

    if (typeof map === 'undefined' || map === null) {
      isVisible = false;
    } else {
      isVisible = !this.isHidden;
    }

    return isVisible;
  };

  _proto.show = function show() {
    this.isHidden = false;

    if (this.div) {
      this.div.style.visibility = 'visible';
    }
  };

  _proto.hide = function hide() {
    this.isHidden = true;

    if (this.div) {
      this.div.style.visibility = 'hidden';
    }
  };

  _proto.open = function open(map, anchor) {
    var _this3 = this;

    if (anchor) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore
      this.position = anchor.getPosition();
      this.moveListener = google.maps.event.addListener(anchor, 'position_changed', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
      function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        var position = anchor.getPosition();

        _this3.setPosition(position);
      });
      this.mapListener = google.maps.event.addListener(anchor, 'map_changed', // eslint-disable-next-line  @getify/proper-arrows/this, @getify/proper-arrows/name
      function () {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        _this3.setMap(anchor.map);
      });
    } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore


    this.setMap(map);

    if (this.div) {
      this.panBox();
    }
  };

  _proto.close = function close() {
    if (this.closeListener) {
      google.maps.event.removeListener(this.closeListener);
      this.closeListener = null;
    }

    if (this.eventListeners) {
      for (var i = 0; i < this.eventListeners.length; i++) {
        google.maps.event.removeListener(this.eventListeners[i]);
      }

      this.eventListeners = null;
    }

    if (this.moveListener) {
      google.maps.event.removeListener(this.moveListener);
      this.moveListener = null;
    }

    if (this.mapListener) {
      google.maps.event.removeListener(this.mapListener);
      this.mapListener = null;
    }

    if (this.contextListener) {
      google.maps.event.removeListener(this.contextListener);
      this.contextListener = null;
    } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
    // @ts-ignore


    this.setMap(null);
  };

  _proto.extend = function extend(obj1, obj2) {
    return function applyExtend(object) {
      // eslint-disable-next-line guard-for-in
      for (var property in object.prototype) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
        // @ts-ignore
        if (!this.prototype.hasOwnProperty(property)) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
          // @ts-ignore
          this.prototype[property] = object.prototype[property];
        }
      } // eslint-disable-next-line @typescript-eslint/ban-ts-ignore
      // @ts-ignore


      return this;
    }.apply(obj1, [obj2]);
  };

  return InfoBox;
}();


//# sourceMappingURL=infobox.esm.js.map


/***/ }),
/* 1459 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("circle", {
  cx: "12",
  cy: "12",
  r: "3"
}), _react.default.createElement("path", {
  d: "M20 4h-3.17l-1.24-1.35c-.37-.41-.91-.65-1.47-.65H9.88c-.56 0-1.1.24-1.48.65L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z"
})), 'CameraAltRounded');

exports.default = _default;

/***/ }),
/* 1460 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z"
}), 'Info');

exports.default = _default;

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FileInput=function(_Component){_inherits(FileInput,_Component);function FileInput(){_classCallCheck(this,FileInput);return _possibleConstructorReturn(this,(FileInput.__proto__||Object.getPrototypeOf(FileInput)).apply(this,arguments));}_createClass(FileInput,[{key:"render",value:function render(){var _props=this.props,_props$input=_props.input,onChange=_props$input.onChange,onBlur=_props$input.onBlur,omitMeta=_props.meta,adaptEvent=_props.adaptEvent,props=_objectWithoutProperties(_props,["input","meta","adaptEvent"]);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",Object.assign({onChange:adaptEvent(onChange),onBlur:adaptEvent(onBlur),type:"file"},props.input,props,{ref:"FileInput"}));}}]);return FileInput;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);;/* harmony default export */ __webpack_exports__["a"] = (FileInput);

/***/ }),
/* 1462 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z"
}), 'SelectAll');

exports.default = _default;

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__PlaceConfig__ = __webpack_require__(1464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var PlaceService=function(){function PlaceService(){_classCallCheck(this,PlaceService);}_createClass(PlaceService,null,[{key:"getPlaces",/******* PLACES **********/value:function getPlaces(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].endpointPlaces;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](0);reject(_context.t0);case 14:case"end":return _context.stop();}}},_callee,_this,[[0,11]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"savePlace",value:function savePlace(app,place){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].endpointSavePlace;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(place)});case 7:response=_context2.sent;// console.log("RESPONSE SAVE PLACE",response)
if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 14:case"end":return _context2.stop();}}},_callee2,_this2,[[0,11]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"deletePlace",value:function deletePlace(app,placeId){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].endpointDeletePlace;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_1__PlaceConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:placeId})});case 7:response=_context3.sent;// console.log("RESPONSE DELETE Place",response, placeId)
if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 14:case"end":return _context3.stop();}}},_callee3,_this3,[[0,11]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}/******** FIN PLACES *********/}]);return PlaceService;}();/* harmony default export */ __webpack_exports__["a"] = (PlaceService);

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var PlaceConfig=function(){function PlaceConfig(){_classCallCheck(this,PlaceConfig);}_createClass(PlaceConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointPlaces",get:function get(){return PlaceConfig.endpoint+"/places";}},{key:"endpointSavePlace",get:function get(){return PlaceConfig.endpointPlaces+"/save";}},{key:"endpointDeletePlace",get:function get(){return PlaceConfig.endpointPlaces+"/delete";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return PlaceConfig;}();/* harmony default export */ __webpack_exports__["a"] = (PlaceConfig);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Popper__ = __webpack_require__(266);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListSubheader__ = __webpack_require__(429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_IconButton__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_core_Chip__ = __webpack_require__(412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__internal_svg_icons_Close__ = __webpack_require__(1466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__internal_svg_icons_ArrowDropDown__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__useAutocomplete__ = __webpack_require__(559);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_14__useAutocomplete__["a"]; });
















var styles = function styles(theme) {
  var _option;

  return {
    /* Styles applied to the root element. */
    root: {
      '&:hover $clearIndicatorDirty, &$focused $clearIndicatorDirty': {
        visibility: 'visible'
      }
    },

    /* Pseudo-class applied to the root element if focused. */
    focused: {},

    /* Styles applied to the tag elements, e.g. the chips. */
    tag: {
      margin: 3
    },

    /* Styles applied to the Input element. */
    inputRoot: {
      flexWrap: 'wrap',
      paddingRight: 62,
      '&[class*="MuiOutlinedInput-root"]': {
        padding: 8,
        paddingRight: 62,
        '& $input': {
          padding: '10.5px 4px'
        },
        '& $input:first-child': {
          paddingLeft: 6
        },
        '& $endAdornment': {
          right: 7
        }
      },
      '&[class*="MuiFilledInput-root"]': {
        paddingTop: 19,
        paddingLeft: 8,
        '& $input': {
          paddingLeft: 4,
          paddingTop: 10
        },
        '& $endAdornment': {
          right: 7
        }
      },
      '& $input:not(:first-child)': {
        paddingLeft: 4
      },
      '& $input': {
        width: 0,
        minWidth: 30
      }
    },

    /* Styles applied to the input element. */
    input: {
      flexGrow: 1,
      textOverflow: 'ellipsis',
      opacity: 0
    },

    /* Styles applied to the input element if tag focused. */
    inputFocused: {
      opacity: 1
    },

    /* Styles applied to the endAdornment element. */
    endAdornment: {
      // We use a position absolute to support wrapping tags.
      position: 'absolute',
      right: 0,
      top: 'calc(50% - 14px)' // Center vertically

    },

    /* Styles applied to the clear indictator. */
    clearIndicator: {
      marginRight: -2,
      padding: 4,
      color: theme.palette.action.active,
      visibility: 'hidden'
    },

    /* Styles applied to the clear indictator if the input is dirty. */
    clearIndicatorDirty: {},

    /* Styles applied to the popup indictator. */
    popupIndicator: {
      padding: 2,
      marginRight: -2,
      color: theme.palette.action.active
    },

    /* Styles applied to the popup indictator if the popup is open. */
    popupIndicatorOpen: {
      transform: 'rotate(180deg)'
    },

    /* Styles applied to the popper element. */
    popper: {
      zIndex: theme.zIndex.modal
    },

    /* Styles applied to the popper element if `disablePortal={true}`. */
    popperDisablePortal: {
      position: 'absolute'
    },

    /* Styles applied to the `Paper` component. */
    paper: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.body1, {
      margin: '4px 0',
      '& > ul': {
        maxHeight: '40vh',
        overflow: 'auto'
      }
    }),

    /* Styles applied to the `listbox` component. */
    listbox: {
      listStyle: 'none',
      margin: 0,
      padding: '8px 0px',
      position: 'relative'
    },

    /* Styles applied to the loading wrapper. */
    loading: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the no option wrapper. */
    noOptions: {
      color: theme.palette.text.secondary,
      padding: '14px 16px'
    },

    /* Styles applied to the option elements. */
    option: (_option = {
      minHeight: 48,
      display: 'flex',
      justifyContent: 'flex-start',
      alignItems: 'center',
      cursor: 'pointer',
      paddingTop: 6,
      outline: '0',
      WebkitTapHighlightColor: 'transparent',
      paddingBottom: 6,
      paddingLeft: 16,
      paddingRight: 16
    }, Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_option, theme.breakpoints.up('sm'), {
      minHeight: 'auto'
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_option, '&[aria-selected="true"]', {
      backgroundColor: theme.palette.action.selected
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_option, '&[data-focus="true"]', {
      backgroundColor: theme.palette.action.hover
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_option, '&[aria-disabled="true"]', {
      opacity: 0.5,
      pointerEvents: 'none'
    }), Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_defineProperty__["a" /* default */])(_option, '&:active', {
      backgroundColor: theme.palette.action.selected
    }), _option),

    /* Styles applied to the group's label elements. */
    groupLabel: {
      backgroundColor: theme.palette.background.paper,
      top: -8
    },

    /* Styles applied to the group's ul elements. */
    groupUl: {
      padding: 0
    }
  };
};

function DisablePortal(props) {
  // eslint-disable-next-line react/prop-types
  var popperRef = props.popperRef,
      anchorEl = props.anchorEl,
      open = props.open,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["popperRef", "anchorEl", "open"]);

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", other);
}

var _ref = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__internal_svg_icons_Close__["a" /* default */], {
  fontSize: "small"
});

var _ref2 = __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__internal_svg_icons_ArrowDropDown__["a" /* default */], null);

var Autocomplete = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function Autocomplete(props, ref) {
  /* eslint-disable no-unused-vars */
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      classes = props.classes,
      className = props.className,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$clearText = props.clearText,
      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
      _props$closeIcon = props.closeIcon,
      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
      _props$closeText = props.closeText,
      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      defaultValue = props.defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$disableOpenOnF = props.disableOpenOnFocus,
      disableOpenOnFocus = _props$disableOpenOnF === void 0 ? false : _props$disableOpenOnF,
      _props$disablePortal = props.disablePortal,
      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
      filterOptions = props.filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel,
      groupBy = props.groupBy,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$ListboxCompone = props.ListboxComponent,
      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
      _props$loading = props.loading,
      loading = _props$loading === void 0 ? false : _props$loading,
      _props$loadingText = props.loadingText,
      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      _props$noOptionsText = props.noOptionsText,
      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
      onChange = props.onChange,
      onClose = props.onClose,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      open = props.open,
      _props$openText = props.openText,
      openText = _props$openText === void 0 ? 'Open' : _props$openText,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      _props$PaperComponent = props.PaperComponent,
      PaperComponent = _props$PaperComponent === void 0 ? __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Paper__["a" /* default */] : _props$PaperComponent,
      _props$PopperComponen = props.PopperComponent,
      PopperComponentProp = _props$PopperComponen === void 0 ? __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Popper__["a" /* default */] : _props$PopperComponen,
      _props$popupIcon = props.popupIcon,
      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
      renderGroupProp = props.renderGroup,
      renderInput = props.renderInput,
      renderOptionProp = props.renderOption,
      renderTags = props.renderTags,
      valueProp = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["autoComplete", "autoHighlight", "autoSelect", "classes", "className", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disableListWrap", "disableOpenOnFocus", "disablePortal", "filterOptions", "filterSelectedOptions", "freeSolo", "getOptionDisabled", "getOptionLabel", "groupBy", "id", "includeInputInList", "inputValue", "ListboxComponent", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onInputChange", "onOpen", "open", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "value"]);
  /* eslint-enable no-unused-vars */


  var popperRef = __WEBPACK_IMPORTED_MODULE_3_react___default.a.useRef(null);
  __WEBPACK_IMPORTED_MODULE_3_react___default.a.useEffect(function () {
    if (popperRef.current) {
      popperRef.current.update();
    }
  });
  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;

  var _useAutocomplete = Object(__WEBPACK_IMPORTED_MODULE_14__useAutocomplete__["b" /* default */])(props),
      getRootProps = _useAutocomplete.getRootProps,
      getInputProps = _useAutocomplete.getInputProps,
      getInputLabelProps = _useAutocomplete.getInputLabelProps,
      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
      getClearProps = _useAutocomplete.getClearProps,
      getTagProps = _useAutocomplete.getTagProps,
      getListboxProps = _useAutocomplete.getListboxProps,
      getOptionProps = _useAutocomplete.getOptionProps,
      value = _useAutocomplete.value,
      dirty = _useAutocomplete.dirty,
      id = _useAutocomplete.id,
      popupOpen = _useAutocomplete.popupOpen,
      focused = _useAutocomplete.focused,
      focusedTag = _useAutocomplete.focusedTag,
      anchorEl = _useAutocomplete.anchorEl,
      setAnchorEl = _useAutocomplete.setAnchorEl,
      inputValue = _useAutocomplete.inputValue,
      groupedOptions = _useAutocomplete.groupedOptions;

  var startAdornment;

  if (multiple && value.length > 0) {
    var getCustomizedTagProps = function getCustomizedTagProps(params) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
        className: classes.tag
      }, getTagProps(params));
    };

    if (renderTags) {
      startAdornment = renderTags(value, getCustomizedTagProps);
    } else {
      startAdornment = value.map(function (option, index) {
        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_core_Chip__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
          label: getOptionLabel(option)
        }, getCustomizedTagProps({
          index: index
        })));
      });
    }
  }

  var defaultRenderGroup = function defaultRenderGroup(params) {
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", {
      key: params.key
    }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_ListSubheader__["a" /* default */], {
      className: classes.groupLabel,
      component: "div"
    }, params.key), __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul", {
      className: classes.groupUl
    }, params.children));
  };

  var renderGroup = renderGroupProp || defaultRenderGroup;
  var renderOption = renderOptionProp || getOptionLabel;

  var renderListOption = function renderListOption(option, index) {
    var optionProps = getOptionProps({
      option: option,
      index: index
    });
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, optionProps, {
      className: classes.option
    }), renderOption(option, {
      selected: optionProps['aria-selected'],
      inputValue: inputValue
    }));
  };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className, focused && classes.focused)
  }, getRootProps(), other), renderInput({
    id: id,
    disabled: disabled,
    InputLabelProps: getInputLabelProps(),
    InputProps: {
      ref: setAnchorEl,
      className: classes.inputRoot,
      startAdornment: startAdornment,
      endAdornment: __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
        className: classes.endAdornment
      }, disableClearable || disabled ? null : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, getClearProps(), {
        "aria-label": clearText,
        title: clearText,
        className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
      }), closeIcon), freeSolo ? null : __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_IconButton__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, getPopupIndicatorProps(), {
        disabled: disabled,
        "aria-label": popupOpen ? closeText : openText,
        title: popupOpen ? closeText : openText,
        className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
      }), popupIcon))
    },
    inputProps: Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
      className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.input, focusedTag === -1 && classes.inputFocused),
      disabled: disabled
    }, getInputProps())
  })), popupOpen && anchorEl ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PopperComponent, {
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.popper, disablePortal && classes.popperDisablePortal),
    style: {
      width: anchorEl ? anchorEl.clientWidth : null
    },
    role: "presentation",
    popperRef: popperRef,
    anchorEl: anchorEl,
    open: true
  }, __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PaperComponent, {
    className: classes.paper
  }, loading && groupedOptions.length === 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.loading
  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", {
    className: classes.noOptions
  }, noOptionsText) : null, groupedOptions.length > 0 ? __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(ListboxComponent, Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: classes.listbox
  }, getListboxProps()), groupedOptions.map(function (option, index) {
    if (groupBy) {
      return renderGroup({
        key: option.key,
        children: option.options.map(function (option2, index2) {
          return renderListOption(option2, option.index + index2);
        })
      });
    }

    return renderListOption(option, index);
  })) : null)) : null);
});
 false ? Autocomplete.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: PropTypes.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: PropTypes.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: PropTypes.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: PropTypes.bool,

  /**
   * Override the default text for the *clear* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  clearText: PropTypes.string,

  /**
   * The icon to display in place of the default close icon.
   */
  closeIcon: PropTypes.node,

  /**
   * Override the default text for the *close popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  closeText: PropTypes.string,

  /**
   * If `true`, the popup will ignore the blur event if the input if filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: PropTypes.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: PropTypes.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: PropTypes.bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: PropTypes.bool,

  /**
   * If `true`, the input will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: PropTypes.bool,

  /**
   * If `true`, the popup won't open on input focus.
   */
  disableOpenOnFocus: PropTypes.bool,

  /**
   * Disable the portal behavior.
   * The children stay within it's parent DOM hierarchy.
   */
  disablePortal: PropTypes.bool,

  /**
   * A filter function that determines the options that are eligible.
   *
   * @param {any[]} options The options to render.
   * @param {object} state The state of the component.
   * @returns {any[]}
   */
  filterOptions: PropTypes.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: PropTypes.bool,

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: PropTypes.bool,

  /**
   * Used to determine the disabled state for a given option.
   */
  getOptionDisabled: PropTypes.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   */
  getOptionLabel: PropTypes.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {any} options The option to group.
   * @returns {string}
   */
  groupBy: PropTypes.func,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: PropTypes.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: PropTypes.bool,

  /**
   * The input value.
   */
  inputValue: PropTypes.string,

  /**
   * The component used to render the listbox.
   */
  ListboxComponent: PropTypes.elementType,

  /**
   * If `true`, the component is in a loading state.
   */
  loading: PropTypes.bool,

  /**
   * Text to display when in a loading state.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  loadingText: PropTypes.node,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: PropTypes.bool,

  /**
   * Text to display when there are no options.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  noOptionsText: PropTypes.node,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value
   */
  onChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: PropTypes.func,

  /**
   * Callback fired when the input value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {string} value
   */
  onInputChange: PropTypes.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: PropTypes.func,

  /**
   * Control the popup` open state.
   */
  open: PropTypes.bool,

  /**
   * Override the default text for the *open popup* icon button.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   */
  openText: PropTypes.string,

  /**
   * Array of options.
   */
  options: PropTypes.array,

  /**
   * The component used to render the body of the popup.
   */
  PaperComponent: PropTypes.elementType,

  /**
   * The component used to position the popup.
   */
  PopperComponent: PropTypes.elementType,

  /**
   * The icon to display in place of the default popup icon.
   */
  popupIcon: PropTypes.node,

  /**
   * Render the group.
   *
   * @param {any} option The group to render.
   * @returns {ReactNode}
   */
  renderGroup: PropTypes.func,

  /**
   * Render the input.
   *
   * @param {object} params
   * @returns {ReactNode}
   */
  renderInput: PropTypes.func.isRequired,

  /**
   * Render the option, use `getOptionLabel` by default.
   *
   * @param {any} option The option to render.
   * @param {object} state The state of the component.
   * @returns {ReactNode}
   */
  renderOption: PropTypes.func,

  /**
   * Render the selected value.
   *
   * @param {any} value The `value` provided to the component.
   * @param {function} getTagProps A tag props getter.
   * @returns {ReactNode}
   */
  renderTags: PropTypes.func,

  /**
   * The value of the autocomplete.
   *
   * The value must have reference equality with the option in order to be selected.
   * You can customize the equality behavior with the `getOptionSelected` prop.
   */
  value: PropTypes.any
} : void 0;
/* harmony default export */ __webpack_exports__["b"] = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiAutocomplete'
})(Autocomplete));

/***/ }),
/* 1466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(212);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close'));

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(212);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown'));

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createFilterOptions;
/* harmony export (immutable) */ __webpack_exports__["b"] = useAutocomplete;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__material_ui_core_utils__ = __webpack_require__(99);



/* eslint-disable no-constant-condition */


 // https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function defaultStringify(value) {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(value) === 'object') {
    return Object.keys(value).map(function (key) {
      return value[key];
    }).join(' ');
  }

  return JSON.stringify(value);
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      _config$stringify = config.stringify,
      stringify = _config$stringify === void 0 ? defaultStringify : _config$stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    return options.filter(function (option) {
      var candidate = stringify(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
  };
}
var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      defaultValue = props.defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$disableOpenOnF = props.disableOpenOnFocus,
      disableOpenOnFocus = _props$disableOpenOnF === void 0 ? false : _props$disableOpenOnF,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
    return x;
  } : _props$getOptionLabel,
      groupBy = props.groupBy,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onOpen = props.onOpen,
      onInputChange = props.onInputChange,
      openProp = props.open,
      _props$options = props.options,
      options = _props$options === void 0 ? [] : _props$options,
      valueProp = props.value;

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(),
      defaultId = _React$useState[0],
      setDefaultId = _React$useState[1];

  var id = idProp || defaultId;
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    // Fallback to this default id when possible.
    // Use the random value for client-side rendering only.
    // We can't use it server-side.
    setDefaultId("mui-autocomplete-".concat(Math.round(Math.random() * 1e5)));
  }, []);
  var firstFocus = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(true);
  var inputRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var listboxRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(null),
      anchorEl = _React$useState2[0],
      setAnchorEl = _React$useState2[1];

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(-1),
      focusedTag = _React$useState3[0],
      setFocusedTag = _React$useState3[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(defaultHighlighted);
  var selectedIndexRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(-1);

  function setHighlightedIndex(index) {
    var mouse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && !mouse) {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop;
      }
    }
  }

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(valueProp !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState4 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(function () {
    return !isControlled ? defaultValue || (multiple ? [] : null) : null;
  }),
      valueState = _React$useState4[0],
      setValue = _React$useState4[1];

  var value = isControlled ? valueProp : valueState;

  var _React$useRef2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(inputValueProp != null),
      isInputValueControlled = _React$useRef2.current;

  var _React$useState5 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(''),
      inputValueState = _React$useState5[0],
      setInputValue = _React$useState5[1];

  var inputValue = isInputValueControlled ? inputValueProp : inputValueState;

  var _React$useState6 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focused = _React$useState6[0],
      setFocused = _React$useState6[1];

  var resetInputValue = Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_utils__["d" /* useEventCallback */])(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);

      if (false) {
        if (typeof optionLabel !== 'string') {
          console.error(['Material-UI: the `getOptionLabel` method of useAutocomplete do not handle the options correctly.', "The component expect a string but received ".concat(_typeof(optionLabel), "."), "For the input option: ".concat(JSON.stringify(newValue), ", `getOptionLabel` returns: ").concat(newInputValue, ".")].join('\n'));
        }
      }

      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue);
    }
  });
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _React$useRef3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(openProp != null),
      isOpenControlled = _React$useRef3.current;

  var _React$useState7 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      openState = _React$useState7[0],
      setOpenState = _React$useState7[1];

  var open = isOpenControlled ? openProp : openState;
  var inputValueFilter = !multiple && value && inputValue === getOptionLabel(value) ? '' : inputValue;
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value.indexOf(option) !== -1 : value === option)) {
      return false;
    }

    return true;
  }), {
    inputValue: inputValueFilter
  }) : [];
  popupOpen = freeSolo && filteredOptions.length === 0 ? false : popupOpen;
  var focusTag = Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_utils__["d" /* useEventCallback */])(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var changeHighlightedIndex = function changeHighlightedIndex(diff, direction) {
    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex(nextIndex);
    selectedIndexRef.current = nextIndex;

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    changeHighlightedIndex('reset', 'next');
  }, [inputValue]); // eslint-disable-line react-hooks/exhaustive-deps

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    if (onOpen) {
      onOpen(event);
    }

    if (!isOpenControlled) {
      setOpenState(true);
    }
  };

  var handleClose = function handleClose(event) {
    if (!open) {
      return;
    }

    if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setOpenState(false);
    }
  };

  var handleValue = function handleValue(event, newValue) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue);
    }

    if (!isControlled) {
      setValue(newValue);
    }
  };

  var selectNewValue = function selectNewValue(event, newValue) {
    if (multiple) {
      var item = newValue;
      newValue = Array.isArray(value) ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value) : [];
      var itemIndex = value.indexOf(item);

      if (itemIndex === -1) {
        newValue.push(item);
      } else {
        newValue.splice(itemIndex, 1);
      }
    }

    handleValue(event, newValue);

    if (!disableCloseOnSelect) {
      handleClose(event);
    }

    resetInputValue(event, newValue);
    selectedIndexRef.current = -1;
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event);
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    handleValue(event, multiple ? [] : null);

    if (disableOpenOnFocus) {
      handleClose();
    }

    setInputValue('');
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
      setFocusedTag(-1);
      focusTag(-1);
    }

    switch (event.key) {
      case 'Home':
        if (popupOpen) {
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex('start', 'next');
        }

        break;

      case 'End':
        if (popupOpen) {
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex('end', 'previous');
        }

        break;

      case 'PageUp':
        // Prevent scroll of the page
        event.preventDefault();
        changeHighlightedIndex(-pageSize, 'previous');
        handleOpen(event);
        break;

      case 'PageDown':
        // Prevent scroll of the page
        event.preventDefault();
        changeHighlightedIndex(pageSize, 'next');
        handleOpen(event);
        break;

      case 'ArrowDown':
        // Prevent cursor move
        event.preventDefault();
        changeHighlightedIndex(1, 'next');
        handleOpen(event);
        break;

      case 'ArrowUp':
        // Prevent cursor move
        event.preventDefault();
        changeHighlightedIndex(-1, 'previous');
        handleOpen(event);
        break;

      case 'ArrowLeft':
        handleFocusTag(event, 'previous');
        break;

      case 'ArrowRight':
        handleFocusTag(event, 'next');
        break;

      case 'Enter':
        if (highlightedIndexRef.current !== -1 && popupOpen) {
          // We don't want to validate the form.
          event.preventDefault();
          selectNewValue(event, filteredOptions[highlightedIndexRef.current]); // Move the selection to the end.

          if (autoComplete) {
            inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
          }
        } else if (freeSolo && inputValue !== '') {
          selectNewValue(event, inputValue);
        }

        break;

      case 'Escape':
        if (popupOpen) {
          // Avoid Opera to exit fullscreen mode.
          event.preventDefault(); // Avoid the Modal to handle the event.

          event.stopPropagation();
          handleClose(event);
        } else if (clearOnEscape && inputValue !== '') {
          // Avoid Opera to exit fullscreen mode.
          event.preventDefault(); // Avoid the Modal to handle the event.

          event.stopPropagation();
          handleClear(event);
        }

        break;

      case 'Backspace':
        if (multiple && inputValue === '' && value.length > 0) {
          var index = focusedTag === -1 ? value.length - 1 : focusedTag;

          var newValue = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value);

          newValue.splice(index, 1);
          handleValue(event, newValue);
        }

        break;

      default:
    }
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (!disableOpenOnFocus) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    setFocused(false);
    firstFocus.current = true;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && selectedIndexRef.current !== -1) {
      handleValue(event, filteredOptions[selectedIndexRef.current]);
    } else if (!freeSolo) {
      resetInputValue(event, value);
    }

    handleClose(event);
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (newValue === '') {
      if (disableOpenOnFocus) {
        handleClose(event);
      }

      if (!disableClearable && !multiple) {
        handleValue(event, null);
      }
    } else {
      handleOpen(event);
    }

    if (inputValue === newValue) {
      return;
    }

    setInputValue(newValue);

    if (onInputChange) {
      onInputChange(event, newValue);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    setHighlightedIndex(index, 'mouse');
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index]);
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value);

      newValue.splice(index, 1);
      handleValue(event, newValue);
    };
  };

  var handleListboxRef = Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_utils__["d" /* useEventCallback */])(function (node) {
    Object(__WEBPACK_IMPORTED_MODULE_4__material_ui_core_utils__["c" /* setRef */])(listboxRef, node);

    if (!node) {
      return;
    } // Restore the focus to the correct option.


    setHighlightedIndex(highlightedIndexRef.current);
  });

  var handlePopupIndicator = function handlePopupIndicator(event) {
    inputRef.current.focus();

    if (open) {
      handleClose(event);
    } else {
      handleOpen(event);
    }
  };

  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.nodeName !== 'INPUT') {
      // Prevent blur
      event.preventDefault();
    }
  };

  var handleClick = function handleClick() {
    if (firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.focus();
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' && (!disableOpenOnFocus || inputRef.current === document.activeElement)) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var key = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].key === key) {
        acc[acc.length - 1].options.push(option);
      } else {
        acc.push({
          key: key,
          index: index,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      return {
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen,
        onKeyDown: handleKeyDown,
        onMouseDown: handleMouseDown,
        onClick: handleClick
      };
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref2) {
      var index = _ref2.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref3) {
      var index = _ref3.index,
          option = _ref3.option;
      var selected = multiple ? value.indexOf(option) !== -1 : value === option;
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}
useAutocomplete.propTypes = {
  /**
   * If `true`, the portion of the selected suggestion that has not been typed by the user,
   * known as the completion string, appears inline after the input cursor in the textbox.
   * The inline completion string is visually highlighted and has a selected state.
   */
  autoComplete: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the first option is automatically highlighted.
   */
  autoHighlight: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the selected option becomes the value of the input
   * when the Autocomplete loses focus unless the user chooses
   * a different option or changes the character string in the input.
   */
  autoSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object,

  /**
   * @ignore
   */
  className: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * If `true`, clear all values when the user presses escape and the popup is closed.
   */
  clearOnEscape: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the popup will ignore the blur event if the input if filled.
   * You can inspect the popup markup with your browser tools.
   * Consider this option when you need to customize the component.
   */
  debug: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * The default input value. Use when the component is not controlled.
   */
  defaultValue: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any,

  /**
   * If `true`, the input can't be cleared.
   */
  disableClearable: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the popup won't close when a value is selected.
   */
  disableCloseOnSelect: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the list box in the popup will not wrap focus.
   */
  disableListWrap: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the popup won't open on input focus.
   */
  disableOpenOnFocus: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * A filter function that determins the options that are eligible.
   *
   * @param {any} options The options to render.
   * @param {object} state The state of the component.
   * @returns {boolean}
   */
  filterOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * If `true`, hide the selected options from the list box.
   */
  filterSelectedOptions: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
   */
  freeSolo: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Used to determine the disabled state for a given option.
   */
  getOptionDisabled: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * Used to determine the string value for a given option.
   * It's used to fill the input (and the list box options if `renderOption` is not provided).
   */
  getOptionLabel: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * If provided, the options will be grouped under the returned string.
   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
   *
   * @param {any} options The option to group.
   * @returns {string}
   */
  groupBy: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * This prop is used to help implement the accessibility logic.
   * If you don't provide this prop. It falls back to a randomly generated id.
   */
  id: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,

  /**
   * If `true`, the highlight can move to the input.
   */
  includeInputInList: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * If `true`, `value` must be an array and the menu will support multiple selections.
   */
  multiple: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback
   * @param {any} value
   */
  onChange: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * Callback fired when the popup requests to be closed.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onClose: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * Callback fired when the popup requests to be opened.
   * Use in controlled mode (see open).
   *
   * @param {object} event The event source of the callback.
   */
  onOpen: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,

  /**
   * Control the popup` open state.
   */
  open: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,

  /**
   * Array of options.
   */
  options: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.array,

  /**
   * The input value.
   */
  value: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.any
};

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function deprecatedPropType(validator, reason) {
  if (true) {
    return function () {
      return null;
    };
  }

  return function (props, propName, componentName, location, propFullName) {
    var componentNameSafe = componentName || '<<anonymous>>';
    var propFullNameSafe = propFullName || propName;

    if (typeof props[propName] !== 'undefined') {
      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
    }

    return null;
  };
}

/* unused harmony default export */ var _unused_webpack_default_export = (deprecatedPropType);

/***/ }),
/* 1470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_lab_Autocomplete__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__actions_TagActions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ColorField_ColorField__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_IconPicker_IconPicker__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_lodash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_EventActions__ = __webpack_require__(69);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var filterTag=Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_lab_Autocomplete__["a" /* createFilterOptions */])();var AddEditTicketType=function(_React$PureComponent){_inherits(AddEditTicketType,_React$PureComponent);function AddEditTicketType(props){_classCallCheck(this,AddEditTicketType);var _this=_possibleConstructorReturn(this,(AddEditTicketType.__proto__||Object.getPrototypeOf(AddEditTicketType)).call(this,props));_this.onSelectIcon=_this.onSelectIcon.bind(_this);_this.onClean=_this.onClean.bind(_this);_this.onSelectTag=_this.onSelectTag.bind(_this);_this.onSave=_this.onSave.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.state={tags:[],tagsSelected:[],isCombo:false,dynamicComboList:[{}],selectedComboList:[]};return _this;}_createClass(AddEditTicketType,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){var _props$ticketFormValu=this.props.ticketFormValues,lastTicketFormValues=_props$ticketFormValu===undefined?{}:_props$ticketFormValu;var _lastTicketFormValues=lastTicketFormValues.tktTags,lastTktTags=_lastTicketFormValues===undefined?[]:_lastTicketFormValues;var _nextProps$ticketForm=nextProps.ticketFormValue,newTicketFormValues=_nextProps$ticketForm===undefined?{}:_nextProps$ticketForm;var _newTicketFormValues$=newTicketFormValues.tktTags,newTktTags=_newTicketFormValues$===undefined?[]:_newTicketFormValues$;if(!this.isArrayEqual(lastTktTags,newTktTags)){this.setState({tagsSelected:lastTktTags});}}},{key:"isArrayEqual",value:function isArrayEqual(x,y){return __WEBPACK_IMPORTED_MODULE_16_lodash___default()(x).differenceWith(y,__WEBPACK_IMPORTED_MODULE_16_lodash___default.a.isEqual).isEmpty();}},{key:"componentWillMount",value:function componentWillMount(){var _this2=this;if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.props.actionGetCategories(null,function(e){console.log("ERROR AL LISTAR CATEGORIAS",e);});this.props.actionGetTags(function(){_this2.setState({tags:_this2.props.tagList});},function(e){console.log("ERROR AL LISTAR TAGS",e);});this.props.actionGetTicketTypes(function(){},function(){});var ticket=this.props.history.location.state;if(this.props.isEditing){ticket.tktInitDate=ticket.tktInitDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(ticket.tktInitDate).format("YYYY-MM-DDTHH:mm");ticket.tktEndDate=ticket.tktEndDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(ticket.tktEndDate).format("YYYY-MM-DDTHH:mm");ticket.tktOutdateDate=ticket.tktOutdateDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(ticket.tktOutdateDate).format("YYYY-MM-DDTHH:mm");this.props.initialize(ticket);var _ticket$tktComboSubTi=ticket.tktComboSubTickets,tktComboSubTickets=_ticket$tktComboSubTi===undefined?[]:_ticket$tktComboSubTi,tktCategory=ticket.tktCategory;this.setState({isCombo:tktCategory==="Combo"?true:false,selectedComboList:tktComboSubTickets,dynamicComboList:tktComboSubTickets});}else{this.props.initialize({tktColor:"#000000",tktSellRrppEnable:false,tktVisible:true,tktSoldOut:false});}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onSelectIcon",value:function onSelectIcon(_ref){var icon=_ref.icon,family=_ref.family;console.log("ON SELECT ICON",icon,family);this.props.change("tktIcon",icon);this.props.change("tktIconFamily",family);}},{key:"onClean",value:function onClean(){if(this.props.isEditing){var ticket=this.props.history.location.state;this.props.initialize({id:ticket.id,tktColor:"#000000",tktSellRrppEnable:false,tktVisible:true,tktSoldOut:false});}else{this.props.initialize({tktColor:"#000000",tktSellRrppEnable:false,tktVisible:true,tktSoldOut:false});}}},{key:"onSave",value:function onSave(formValues){var _this3=this;var _state=this.state,_state$tagsSelected=_state.tagsSelected,tagsSelected=_state$tagsSelected===undefined?[]:_state$tagsSelected,_state$selectedComboL=_state.selectedComboList,selectedComboList=_state$selectedComboL===undefined?[]:_state$selectedComboL,isCombo=_state.isCombo;formValues.tktTags=tagsSelected;formValues.tktComboSubTickets=selectedComboList;if(isCombo&&selectedComboList.length==0){__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"Debe seleccionar tipo de tickets para el combo");return;}this.props.actionSaveTicketType(formValues,function(){__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["b" /* SUCCESS */],"El ticket se guardó correctamente.");_this3.props.history.goBack();},function(e){console.log("ERROR ON SAVE TICKET",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"No se pudo guardar el ticket.");});}},{key:"onSelectTag",value:function onSelectTag(evt,tag){var tags=tag.slice();this.setState({tagsSelected:tags});}},{key:"renderTags",value:function renderTags(type,tags){var _this4=this;var t=tags&&tags.filter(function(t){return!t.add;});return t&&t.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["g" /* Chip */],{label:tag.tagName,onDelete:_this4.onDeleteRenderTag.bind(_this4,type,tag),avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:tag.tagColor,color:"rgb(0,0,0,0.60"}},tag.tagName.substring(0,1))});});}},{key:"onDeleteRenderTag",value:function onDeleteRenderTag(type,tag){var tags=null;var idx=-1;tags=this.state.tagsSelected.slice();idx=tags.findIndex(function(t){return t.id==tag.id;});if(idx>=0){tags.splice(idx,1);}this.setState({tagsSelected:tags});console.log("ON DELETE RENDER TAG",type,tag,idx);}},{key:"render",value:function render(){var _this5=this;var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,event=_props.event,ticketFormValues=_props.ticketFormValues,categoryList=_props.categoryList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Atr\xE1s"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:"h1"},event&&event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea tipo de tickets para el evento seleccionado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:theme.paper.addEditTicketTypeTitle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Crear tipo de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Fecha del evento:"," ",event&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(event.evtDateTime)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tktName",label:"Nombre a mostrar en la compra",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tktDisplayName",label:"Nombre a mostrar en el ticket vendido",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tktProducerName",label:"Nombre a mostrar en estad\xEDsticas",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Categor\xEDa de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"tktCategory",onChange:function onChange(evt,b){_this5.setState({isCombo:b==="Combo"?true:false});},fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},categoryList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:c.id},c.id);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["A" /* InputAdornment */],{position:"start"},"$")},format:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatNumber,parse:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].toNumber,name:"tktPrice",label:"Precio (en AR$)",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_7__common_Validations__["d" /* typeIntegerOrDecimalMin10 */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],InputProps:{startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["A" /* InputAdornment */],{position:"start"},"$")},format:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatNumberWith0,parse:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].toNumber,name:"tktPriceProducer",label:"$ a rendir a productor",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_7__common_Validations__["e" /* typeIntegerOrDecimalOr0 */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Color de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_11__components_ColorField_ColorField__["a" /* default */],name:"tktColor",validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],type:"datetime-local",InputLabelProps:{shrink:true},name:"tktInitDate",label:"Fecha disponible desde",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],type:"datetime-local",InputLabelProps:{shrink:true},name:"tktEndDate",label:"Fecha disponible hasta",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"\xEDcono de tickets"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_IconPicker_IconPicker__["a" /* default */],{size:36,onSelect:this.onSelectIcon,icon:ticketFormValues&&ticketFormValues.tktIcon,iconset:ticketFormValues&&ticketFormValues.tktIconFamily})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],format:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatNumber,parse:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].toNumber,name:"tktMaxQtBuy",label:"M\xE1x. tickets por usuario",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_7__common_Validations__["c" /* typeInteger */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],format:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatNumber,parse:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].toNumber,name:"tktQtOriginal",label:"Lote total de tickets",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_7__common_Validations__["c" /* typeInteger */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],format:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].formatNumber,parse:__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].toNumber,name:"tktQt",label:"Tickets disponibles",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */],__WEBPACK_IMPORTED_MODULE_7__common_Validations__["c" /* typeInteger */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFEsta Sold Out?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],name:"tktSoldOut",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFTipo de ticket visible?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],name:"tktVisible",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],type:"datetime-local",InputLabelProps:{shrink:true},name:"tktOutdateDate",label:"Vencimiento del ticket",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFHabilitada venta RRPP?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],name:"tktSellRrppEnable",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:false},"NO"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"40%",marginLeft:10,paddingRight:10,marginTop:20}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_lab_Autocomplete__["b" /* default */],{options:this.state.tags,value:this.state.tagsSelected,getOptionLabel:function getOptionLabel(option){return option.tagName;},filterOptions:function filterOptions(options,params){return filterTag(options,params);},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true,label:"Asocia el tipo de ticket a un tag"}));},renderTags:this.renderTags.bind(this,"filter"),onChange:this.onSelectTag,loadingText:"Cargando tags ...",noOptionsText:"Sin tags",selectOnFocus:true,multiple:true,freeSolo:true,filterSelectedOptions:true}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Limpiar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.onClean},"Limpiar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar"))),this.state.isCombo?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(AddDynamicCombo,{theme:theme,selectedComboList:this.state.selectedComboList,onAddNewIndex:function onAddNewIndex(){_this5.setState({dynamicComboList:[].concat(_toConsumableArray(_this5.state.dynamicComboList),[{}])});},ticketTypeList:this.props.ticketTypeList?this.props.ticketTypeList.filter(function(e){return e.tktCategory!="Combo";}):[],onDeleteLastIndex:function onDeleteLastIndex(index){var comboListClone=[].concat(_toConsumableArray(_this5.state.dynamicComboList));comboListClone.splice(index,1);var selectedComboListClone=[].concat(_toConsumableArray(_this5.state.selectedComboList));selectedComboListClone.length>0&&selectedComboListClone.splice(index,1);_this5.setState({dynamicComboList:comboListClone,selectedComboList:selectedComboListClone});},list:this.state.dynamicComboList,onSelect:function onSelect(evt,index){var selectedComboList=[].concat(_toConsumableArray(_this5.state.selectedComboList));selectedComboList[index]=evt.target.value;_this5.setState({selectedComboList:selectedComboList});}}):null));}}]);return AddEditTicketType;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE", store)
return{login:store.auth.login,event:store.evt.event,tagList:store.tag.tagList,ticketTypeList:store.evt.ticketTypeList,ticketFormValues:store.form&&store.form.addEditTicketType&&store.form.addEditTicketType.values,categoryList:store.evt.categoryList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetCategories:__WEBPACK_IMPORTED_MODULE_17__actions_EventActions__["d" /* actionGetCategories */],actionGetTicketTypes:__WEBPACK_IMPORTED_MODULE_17__actions_EventActions__["f" /* actionGetTicketTypes */],actionSaveTicketType:__WEBPACK_IMPORTED_MODULE_17__actions_EventActions__["i" /* actionSaveTicketType */],actionGetTags:__WEBPACK_IMPORTED_MODULE_10__actions_TagActions__["b" /* actionGetTags */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditTicketType",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditTicketType)))));var AddDynamicCombo=function AddDynamicCombo(_ref2){var onSelect=_ref2.onSelect,onAddNewIndex=_ref2.onAddNewIndex,onDeleteLastIndex=_ref2.onDeleteLastIndex,list=_ref2.list,theme=_ref2.theme,_ref2$selectedComboLi=_ref2.selectedComboList,selectedComboList=_ref2$selectedComboLi===undefined?[]:_ref2$selectedComboLi,_ref2$ticketTypeList=_ref2.ticketTypeList,ticketTypeList=_ref2$ticketTypeList===undefined?[]:_ref2$ticketTypeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:theme.paper.addEditTicketTypeTitle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Seleccione Tipo de Ticket para el Combo")),list&&list.length>0&&list.map(function(val,index){var defaultVal=selectedComboList.length>0&&selectedComboList[index]?selectedComboList[index]:{};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],{style:{margin:30}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Tipo de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["L" /* Select */],{style:{margin:"30px"},onChange:function onChange(e){return onSelect(e,index);},displayEmpty:true,select:true,fullWidth:true,value:ticketTypeList&&ticketTypeList.find(function(e){return e.id==defaultVal.id;})},ticketTypeList&&ticketTypeList.map(function(c,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["I" /* MenuItem */],{value:c,key:index},c.tktDisplayName);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar Tipo de Ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.buttonMarginBottom,onClick:function onClick(){return onDeleteLastIndex(index);}},"Eliminar"))));})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["Y" /* Tooltip */],{title:"Agregar Tipo de ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:onAddNewIndex},"Agregar"))));};

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ColorField_ColorField__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_IconPicker_IconPicker__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_AttachFile__ = __webpack_require__(1472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_AttachFile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_AttachFile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_CloudDownload__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_CloudDownload___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_CloudDownload__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard__ = __webpack_require__(1474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__provider_base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { TextField, Select } from "redux-form-material-ui";
var _handleSubmitFail=void 0;var AddEditTicket=function(_React$PureComponent){_inherits(AddEditTicket,_React$PureComponent);function AddEditTicket(props){_classCallCheck(this,AddEditTicket);var _this=_possibleConstructorReturn(this,(AddEditTicket.__proto__||Object.getPrototypeOf(AddEditTicket)).call(this,props));_this.state={ticketTypeSel:"",tickets:null,searchField:"DU",search:"",tabSel:0,userSel:null,page:0,rowPerPage:5,count:0,ticketTypeError:"",duError:"",usersData:{users:[],usersToInvite:[],countGiftInvite:0,countGiftTicket:0},tableTabSel:0,ticketCount:1,ticketCountError:""};_this.getTycketTypeSuccess=_this.getTycketTypeSuccess.bind(_this);_this.onChangeSearch=_this.onChangeSearch.bind(_this);_this.onChangeTicketType=_this.onChangeTicketType.bind(_this);_this.onChangeCount=_this.onChangeCount.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onSearchUser=_this.onSearchUser.bind(_this);_this.onClean=_this.onClean.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.renderBulkForm=_this.renderBulkForm.bind(_this);_this.renderIndividualForm=_this.renderIndividualForm.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);// this.getUsersByEmailOrDUSuccess=this.getUsersByEmailOrDUSuccess.bind(this)
_this.isValidSearch=_this.isValidSearch.bind(_this);_this.isValidForm=_this.isValidForm.bind(_this);_this.onClickUploadExcel=_this.onClickUploadExcel.bind(_this);_this.onUploadExcel=_this.onUploadExcel.bind(_this);_this.uploadAttachCallback=_this.uploadAttachCallback.bind(_this);_this.onGiftAllTicket=_this.onGiftAllTicket.bind(_this);_this.getCounts=_this.getCounts.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.inputFile;return _this;}_createClass(AddEditTicket,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.props.actionGetTicketTypes(this.getTycketTypeSuccess,this.getTicketsError);}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var tickets=[];//console.log("FILTER", this.state.filter)
//let filter = new RegExp(this.state.filter,"ig")
// console.log("this.state.usersData", this.state.usersData)
if(this.state.usersData){if(this.state.tableTabSel){tickets=this.state.usersData.usersToInvite||[];}else{tickets=this.state.usersData.users||[];}}var count=tickets.length;tickets=tickets.slice(from,end);this.setState({page:newPage,count:count,tickets:tickets});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var tickets=[];// let filter = new RegExp(this.state.filter,"ig")
if(this.state.usersData){if(this.state.tableTabSel){tickets=this.state.usersData.usersToInvite||[];}else{tickets=this.state.usersData.users||[];}}var count=tickets.length;tickets=tickets.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,tickets:tickets});}},{key:"getTycketTypeSuccess",value:function getTycketTypeSuccess(){if(this.props.ticketTypeList&&this.props.ticketTypeList>0){this.setState({ticketTypeSel:this.props.this.props.ticketTypeList[0]});}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onClean",value:function onClean(){this.setState({ticketTypeSel:"",tickets:null,searchField:"DU",search:"",tabSel:0,userSel:null,page:0,rowPerPage:5,count:0,usersData:{users:[],usersToInvite:[],countGiftInvite:0,countGiftTicket:0},ticketTypeError:"",duError:"",tableTabSel:0,ticketCount:1,ticketCountError:""});}},{key:"isValidForm",value:function isValidForm(){var isValid=true;// if(this.state.tabSel){
if(!this.state.usersData||this.state.usersData.users.length==0&&this.state.usersData.usersToInvite.length==0){__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_18__common_Util__["a" /* ERROR */],"Debe agregar tickets");isValid=false;}// }else{
//   if(!this.state.ticketTypeSel){
//     this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"})
//     isValid = false
//   }
//   if(!this.state.userSel){
//     this.setState({duError:"Debe buscar un usuario"})
//     isValid = false
//   }
// }
return isValid;}},{key:"onSave",value:function onSave(){var _this2=this;if(this.isValidForm()){var tickets=this.state.usersData;// if(!this.state.tabSel){
//   tickets =[{
//     tktTypeId: this.state.ticketTypeSel.id,
//     tktPrice: this.state.ticketTypeSel.tktPrice,
//     tktDisplayName: this.state.ticketTypeSel.tktDisplayName,
//     tktCategory: this.state.ticketTypeSel.tktCategory,
//     ...this.state.userSel
//   }]
// }
var successMessage=tickets.length>1?"Los tickets se guardaron correctamente.":"El ticket se guardó correctamente.";this.props.actionSaveTickets(tickets,function(){__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_18__common_Util__["b" /* SUCCESS */],successMessage);_this2.props.history.goBack();},function(e){console.log("ERROR ON SAVE TICKET",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_18__common_Util__["a" /* ERROR */],"No se pudo guardar el/los ticket/s.");});}}},{key:"isValidSearch",value:function isValidSearch(){var isValid=true;if(!this.state.ticketTypeSel){this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"});isValid=false;}if(!this.state.ticketCount||Object(__WEBPACK_IMPORTED_MODULE_6__common_Validations__["c" /* typeInteger */])(this.state.ticketCount)||this.state.ticketCount<=0){this.setState({ticketCountError:"Debe ingresar un valor numérico positivo"});isValid=false;}var dus=this.state.search&&this.state.search.split(",");if(dus){var wrongDUs="";for(var i=0;i<dus.length;i++){var du=dus[i];if(!/^[0-9]{1,3}(\.?[0-9]{3})*$/.test(du)){var errorDU="Este campo solo admite números enteros.";wrongDUs+=wrongDUs?dus[i]:errorDU+" "+dus[i];isValid=false;}}this.setState({duError:wrongDUs});}else{this.setState({duError:"Debe ingresar al menos un número de documento."});isValid=false;}return isValid;}},{key:"onSearchUser",value:function onSearchUser(){if(this.isValidSearch()){var usersDU=this.state.search;this.props.actionGetUsersByEmailOrDU(usersDU,"",this.uploadAttachCallback,function(e){console.log("ERROR ON SEARCH USER",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_18__common_Util__["a" /* ERROR */],"No se encontró el usuario.");});}}},{key:"onChangeTicketType",value:function onChangeTicketType(evt){var usersData=Object.assign({},this.state.usersData);var type=evt.target.value;this.setState({ticketTypeSel:type,ticketTypeError:"",usersData:usersData});}},{key:"onChangeSearch",value:function onChangeSearch(evt){var txt=evt.target.value||"";this.setState({search:txt.trim(),duError:""});}},{key:"onChangeCount",value:function onChangeCount(evt){this.setState({ticketCount:evt.target.value,ticketCountError:""});}},{key:"onUploadExcel",value:function onUploadExcel(evt){evt.preventDefault();var f=evt.target.files[0];if(f){this.props.actionGetUsersFromExcel(f,this.uploadAttachCallback,function(e){console.log("ERROR",e);});}evt.target.value="";}},{key:"onClickUploadExcel",value:function onClickUploadExcel(evt){if(this.state.ticketTypeSel){this.inputFile&&this.inputFile.click();}else{this.setState({ticketTypeError:"Debe seleccionar un tipo de ticket"});}}},{key:"uploadAttachCallback",value:function uploadAttachCallback(data){var _this3=this;var type=this.state.ticketTypeSel;var idx=-1;//Usuarios
var users=this.state.usersData&&this.state.usersData.users&&this.state.usersData.users.slice(0)||[];var _loop=function _loop(i){var user=data.users[i];var ticketCount=parseInt(user.ticketCount||_this3.state.ticketCount);if(_this3.state.usersData&&_this3.state.usersData.users){idx=_this3.state.usersData.users.findIndex(function(u){if(u.tktTypeId==type.id){if(u.proEmail&&user.proEmail&&u.proEmail==user.proEmail||u.proDNI&&user.proDNI&&u.proDNI==user.proDNI){return true;}}return false;});}if(idx>=0){users[idx].ticketCount+=ticketCount;}else{users.push(Object.assign({tktTypeId:type&&type.id,tktPrice:type&&type.tktPrice,tktPriceProducer:type&&type.tktPriceProducer,tktDisplayName:type&&type.tktDisplayName,tktCategory:type&&type.tktCategory},user,{ticketCount:ticketCount}));}};for(var i=0;i<data.users.length;i++){_loop(i);}//Invitados
var usersToInvite=this.state.usersData&&this.state.usersData.usersToInvite&&this.state.usersData.usersToInvite.slice(0)||[];idx=-1;var _loop2=function _loop2(i){var user=data.usersToInvite[i];var ticketCount=parseInt(user.ticketCount||_this3.state.ticketCount);if(_this3.state.usersData&&_this3.state.usersData.usersToInvite){idx=_this3.state.usersData.usersToInvite.findIndex(function(u){if(u.tktTypeId==type.id){if(u.proEmail&&user.proEmail&&u.proEmail==user.proEmail||u.proDNI&&user.proDNI&&u.proDNI==user.proDNI){return true;}}return false;});}if(idx>=0){usersToInvite[idx].ticketCount+=ticketCount;}else{usersToInvite.push(Object.assign({tktTypeId:type&&type.id,tktPrice:type&&type.tktPrice,tktDisplayName:type&&type.tktDisplayName,tktCategory:type&&type.tktCategory},user,{ticketCount:ticketCount}));}};for(var i=0;i<data.usersToInvite.length;i++){_loop2(i);}var usersData=Object.assign({},this.state.usersData,{users:users,usersToInvite:usersToInvite});this.setState({usersData:usersData},this.onChangePage);}},{key:"onDeleteTicket",value:function onDeleteTicket(item){var ud=Object.assign({},this.state.usersData);if(this.state.tableTabSel){//Invitación
var idx=ud.usersToInvite.findIndex(function(u){return u.tktTypeId==item.tktTypeId&&(u.proEmail&&item.proEmail&&u.proEmail==item.proEmail||u.proDNI&&item.proDNI&&u.proDNI==item.proDNI);});var uToi=ud.usersToInvite[idx];if(uToi.ticketCount>1){ud.usersToInvite[idx]=Object.assign({},uToi,{ticketCount:uToi.ticketCount-1});}else{ud.usersToInvite.splice(idx,1);}ud.usersToInvite=ud.usersToInvite.slice(0);}else{var _idx=ud.users.findIndex(function(u){return u.tktTypeId==item.tktTypeId&&(u.proEmail&&item.proEmail&&u.proEmail==item.proEmail||u.proDNI&&item.proDNI&&u.proDNI==item.proDNI);});var _uToi=ud.users[_idx];if(_uToi.ticketCount>1){ud.users[_idx]=Object.assign({},_uToi,{ticketCount:_uToi.ticketCount-1});}else{ud.users.splice(_idx,1);}ud.users=ud.users.slice(0);}this.setState({usersData:ud},this.onChangePage);}},{key:"onGiftTicket",value:function onGiftTicket(item){var ud=Object.assign({},this.state.usersData);var uToi=void 0;var idx=void 0;if(this.state.tableTabSel){//Invitación
ud.usersToInvite=ud.usersToInvite.slice(0);idx=ud.usersToInvite.findIndex(function(u){return u.tktTypeId==item.tktTypeId&&(u.proEmail&&item.proEmail&&u.proEmail==item.proEmail||u.proDNI&&item.proDNI&&u.proDNI==item.proDNI);});uToi=ud.usersToInvite[idx];if(uToi.tktGiftPrice>=0){delete uToi.tktGiftPrice;ud.countGiftInvite--;}else{uToi.tktGiftPrice=0;ud.countGiftInvite++;}}else{//Tickets
ud.users=ud.users.slice(0);idx=ud.users.findIndex(function(u){return u.tktTypeId==item.tktTypeId&&(u.proEmail&&item.proEmail&&u.proEmail==item.proEmail||u.proDNI&&item.proDNI&&u.proDNI==item.proDNI);});uToi=ud.users[idx];if(uToi.tktGiftPrice>=0){delete uToi.tktGiftPrice;ud.countGiftTicket--;}else{uToi.tktGiftPrice=0;ud.countGiftTicket++;}}this.setState({usersData:ud},this.onChangePage);}},{key:"onGiftAllTicket",value:function onGiftAllTicket(){var ud=Object.assign({},this.state.usersData);if(this.state.tableTabSel){if(ud.countGiftInvite<ud.usersToInvite.length){//Si tengo sin regalar
ud.usersToInvite=ud.usersToInvite.map(function(u){return Object.assign({},u,{tktGiftPrice:0});});ud.countGiftInvite=ud.usersToInvite.length;}else{ud.usersToInvite=ud.usersToInvite.map(function(u){var i=Object.assign({},u);delete i.tktGiftPrice;return i;});ud.countGiftInvite=0;}}else{if(ud.countGiftTicket<ud.users.length){//Si tengo sin regalar
ud.users=ud.users.map(function(u){return Object.assign({},u,{tktGiftPrice:0});});ud.countGiftTicket=ud.users.length;}else{ud.users=ud.users.map(function(u){var i=Object.assign({},u);delete i.tktGiftPrice;return i;});ud.countGiftTicket=0;}}this.setState({usersData:ud},this.onChangePage);}},{key:"renderIndividualForm",value:function renderIndividualForm(){var _props=this.props,theme=_props.theme,ticketTypeList=_props.ticketTypeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.ticketTypeError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Tipo de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["L" /* Select */],{onChange:this.onChangeTicketType,fullWidth:true,value:this.state.ticketTypeSel},ticketTypeList&&ticketTypeList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["I" /* MenuItem */],{value:c},c.tktDisplayName);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["t" /* FormHelperText */],null,this.state.ticketTypeError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.duError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Usuario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["z" /* Input */],{fullWidth:true,onChange:this.onChangeSearch,value:this.state.search,startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["A" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"DU")),endAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["A" /* InputAdornment */],{position:"end"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:this.onSearchUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default.a,null)))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["t" /* FormHelperText */],null,this.state.duError)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{container:true,spacing:2},this.state.ticketTypeSel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"Valor: ",__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].formatCurrency(this.state.ticketTypeSel.tktPrice)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"Categor\xEDa: ",this.state.ticketTypeSel.tktCategory)),this.state.userSel&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"Nombre: ",this.state.userSel.proName," ",this.state.userSel.proLastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"E-mail: ",this.state.userSel.proEmail," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"DU: ",this.state.userSel.proDNI," "))));}},{key:"renderBulkForm",value:function renderBulkForm(){var _this4=this;var _props2=this.props,theme=_props2.theme,ticketTypeList=_props2.ticketTypeList;var isGiftAllInvitation=this.state.usersData.countGiftInvite==this.state.usersData.usersToInvite.length;var isGiftAllTicket=this.state.usersData.countGiftTicket==this.state.usersData.users.length;var count=this.getCounts();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.ticketTypeError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Tipo de ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["L" /* Select */],{onChange:this.onChangeTicketType,fullWidth:true,value:this.state.ticketTypeSel,defaultValue:"",displayEmpty:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["I" /* MenuItem */],{value:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Seleccionar")),ticketTypeList&&ticketTypeList.map(function(c){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["I" /* MenuItem */],{value:c},c.tktDisplayName);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["t" /* FormHelperText */],null,this.state.ticketTypeError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.ticketCountError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["z" /* Input */],{fullWidth:true,onChange:this.onChangeCount,value:this.state.ticketCount}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["t" /* FormHelperText */],null,this.state.ticketCountError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["r" /* FormControl */],{fullWidth:true,error:this.state.duError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Usuario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["z" /* Input */],{fullWidth:true,onChange:this.onChangeSearch,value:this.state.search,startAdornment:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["A" /* InputAdornment */],{position:"start"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],null,"DU"))}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["t" /* FormHelperText */],null,this.state.duError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:this.tabSel?"Agregar tickets":"Buscar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:this.onSearchUser},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add___default.a,null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("input",{type:"file",ref:function ref(r){_this4.inputFile=r;},style:{display:"none"},accept:".xlsx",onChange:this.onUploadExcel}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Cargar excel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:this.onClickUploadExcel},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["M" /* SvgIcon */],{viewBox:"0 0 384 512"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"currentColor",d:"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48zm212-240h-28.8c-4.4 0-8.4 2.4-10.5 6.3-18 33.1-22.2 42.4-28.6 57.7-13.9-29.1-6.9-17.3-28.6-57.7-2.1-3.9-6.2-6.3-10.6-6.3H124c-9.3 0-15 10-10.4 18l46.3 78-46.3 78c-4.7 8 1.1 18 10.4 18h28.9c4.4 0 8.4-2.4 10.5-6.3 21.7-40 23-45 28.6-57.7 14.9 30.2 5.9 15.9 28.6 57.7 2.1 3.9 6.2 6.3 10.6 6.3H260c9.3 0 15-10 10.4-18L224 320c.7-1.1 30.3-50.5 46.3-78 4.7-8-1.1-18-10.3-18z"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Template excel"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{href:__WEBPACK_IMPORTED_MODULE_21__provider_base_Settings___default.a.EXCEL_TEMPLATE},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_CloudDownload___default.a,null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["V" /* Tabs */],{value:this.state.tableTabSel,onChange:function onChange(evt,v){_this4.setState({tableTabSel:v},_this4.onChangePage);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["N" /* Tab */],{value:0,label:"Registrados",style:{minWidth:0}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:count.countUsers&&(count.countUsers==1?count.countUsers+" ticket":count.countUsers+" tickets")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["c" /* Badge */],{badgeContent:count.countUsers,color:"primary",style:{marginTop:10,marginRight:10}})),this.state.usersData.users.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:isGiftAllTicket?"Cobrar todos los registrados":"Invitar a todos los  registrados"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){_this4.setState({tableTabSel:0},_this4.onGiftAllTicket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard___default.a,{style:isGiftAllTicket?{color:"orange"}:undefined}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["N" /* Tab */],{value:1,label:"No Registrados",style:{minWidth:0}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:count.countInvitations&&(count.countInvitations==1?count.countInvitations+" invitaci\xF3n":count.countInvitations+" invitaciones")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["c" /* Badge */],{badgeContent:count.countInvitations,color:"primary",style:{marginTop:10,marginRight:10}})),this.state.usersData.usersToInvite.length&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:isGiftAllInvitation?"Cobrar todos los no registrados":"Invitar a todas los no registrados"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){_this4.setState({tableTabSel:1},_this4.onGiftAllTicket);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard___default.a,{style:isGiftAllInvitation?{color:"orange"}:undefined})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})));}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Tipo de Ticket","Categoría","E-mail","DNI","Nombre y Apellido","Cantidad","Valor","Total"];if(this.state.tableTabSel){headers=["Tipo de Ticket","Categoría","E-mail","DNI","Cantidad","Valor","Total"];}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this5=this;var theme=this.props.theme;var tickets=this.state.tickets;if(!tickets||tickets.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.table.empty},"Seleccione el tipo de ticket y el/los usuario/s para agregar tickets");}return tickets.map(function(item,index){var isActive=item.tktState;var isAGift=item.tktGiftPrice>=0;var price=isAGift?item.tktGiftPrice:item.tktPriceProducer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,item.tktDisplayName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,item.tktCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,item.proEmail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,item.proDNI),_this5.state.tableTabSel?null:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,item.proName," ",item.proLastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].formatNumber(item.ticketCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].formatCurrency(price)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].formatCurrency(price*item.ticketCount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Q" /* TableCell */],{style:Object.assign({},theme.table.actionsColumn,{minWith:200})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:isAGift?"Cobrar ticket":"Regalar ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:_this5.onGiftTicket.bind(_this5,item,index)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_CardGiftcard___default.a,{style:isAGift?{color:"orange"}:undefined}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:_this5.onDeleteTicket.bind(_this5,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Delete___default.a,null)))));});}},{key:"getCounts",value:function getCounts(){var _state$usersData=this.state.usersData,users=_state$usersData.users,usersToInvite=_state$usersData.usersToInvite;var count={countUsers:0,countInvitations:0};for(var i=0;i<users.length;i++){count.countUsers+=users[i].ticketCount;}for(var j=0;j<usersToInvite.length;j++){count.countInvitations+=usersToInvite[j].ticketCount;}return count;}},{key:"render",value:function render(){var _props3=this.props,theme=_props3.theme,handleSubmit=_props3.handleSubmit,event=_props3.event,ticketFormValues=_props3.ticketFormValues;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Atr\xE1s"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:"h1"},event&&event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea tickets para el evento seleccionado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.paper.addEditTicketTypeTitle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Crear ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Fecha del evento: ",event&&__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_18__common_Util__["d" /* default */].timestampToMoment(event.evtDateTime)))),this.renderBulkForm()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Limpiar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.onClean},"Limpiar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar")))));}}]);return AddEditTicket;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE", store)
return{login:store.auth.login,event:store.evt.event,ticketFormValues:store.form&&store.form.addEditTicket&&store.form.addEditTicket.values,ticketTypeList:store.evt.ticketTypeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetTicketTypes:__WEBPACK_IMPORTED_MODULE_19__actions_EventActions__["f" /* actionGetTicketTypes */],actionSaveTickets:__WEBPACK_IMPORTED_MODULE_19__actions_EventActions__["j" /* actionSaveTickets */],actionGetUsersByEmailOrDU:__WEBPACK_IMPORTED_MODULE_20__actions_UserActions__["d" /* actionGetUsersByEmailOrDU */],actionGetUsersFromExcel:__WEBPACK_IMPORTED_MODULE_20__actions_UserActions__["f" /* actionGetUsersFromExcel */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditTicket",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditTicket)))));

/***/ }),
/* 1472 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z"
}), 'AttachFile');

exports.default = _default;

/***/ }),
/* 1473 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z"
}), 'CloudDownload');

exports.default = _default;

/***/ }),
/* 1474 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z"
}), 'CardGiftcard');

exports.default = _default;

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var StatisticsEvent=function(_React$PureComponent){_inherits(StatisticsEvent,_React$PureComponent);function StatisticsEvent(props){_classCallCheck(this,StatisticsEvent);var _this=_possibleConstructorReturn(this,(StatisticsEvent.__proto__||Object.getPrototypeOf(StatisticsEvent)).call(this,props));_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(StatisticsEvent,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"renderTicketByType",value:function renderTicketByType(){var _props=this.props,theme=_props.theme,stats=_props.stats;console.log("TICKET BY TYPE",stats);return stats.statsByType&&stats.statsByType.map(function(ticket,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["w" /* GridListTile */],{style:theme.StatsCard.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:Object.assign({},theme.StatsCard.header.container,{backgroundColor:ticket.tktColor})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:Object.assign({},theme.StatsCard.header.label,{color:theme.palette.getContrastText(ticket.tktColor)})},ticket.tktProducerName&&ticket.tktProducerName.toUpperCase())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:Object.assign({},theme.StatsCard.header.value,{color:theme.palette.getContrastText(ticket.tktColor)})},"Venta total: ",__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountSell)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Entradas en venta")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktTotalQt)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Vendidas por RRPP")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktTotalQtSellByRrpp)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountSellByRrpp)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Vendidas por Productor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktTotalQtSellByProductor)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountSellByProductor)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Venta por Aplicaci\xF3n")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktTotalQtSellByApp)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountSellByApp)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:Object.assign({},theme.StatsCard.label,{color:"#03a900"})},"Vendidas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:Object.assign({},theme.StatsCard.value,{color:"#03a900"})},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktTotalQtSell)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:Object.assign({},theme.StatsCard.value,{color:"#03a900"})},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountSell)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Invitaciones")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktGiftQt)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.row},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:5},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.label},"Canjes")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(ticket.tktLoyalyQt)||0)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",style:theme.StatsCard.footer.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.footer.label},"Ganancia de productor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.StatsCard.footer.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(ticket.tktTotalAmountProducer)))));});}},{key:"render",value:function render(){var _props2=this.props,theme=_props2.theme,handleSubmit=_props2.handleSubmit,history=_props2.history,stats=_props2.stats,event=_props2.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Estad\xEDsticas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Evento ",event.evtName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["j" /* Container */],{maxWidth:1320},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{variant:"h2"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{container:true,direction:"row",spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktToSell.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktToSell.label},"Entradas en venta"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktToSell.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQt)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSellRRPP.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.label},"Vendidas por RRPP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{className:"columns-row-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQtSellByRrpp)||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){history.push(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["e" /* EVENTS_STATISTICS_DIRECT_RRPP_ROUTE */]);},size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default.a,{style:theme.stats.tktSellRRPP.value}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(stats.statsTotalAmountSellByRrpp)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSellRRPP.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.label},"Vendidas por Productor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{className:"columns-row-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQtSellByProductor)||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){history.push(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["f" /* EVENTS_STATISTICS_PRODUCER_ROUTE */]);},size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default.a,{style:theme.stats.tktSellRRPP.value}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(stats.statsTotalAmountSellByProductor)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSellNoRRPP.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellNoRRPP.label},"Venta por Aplicaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellNoRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQtSellByApp)||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSellNoRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(stats.statsTotalAmountSellByApp)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSold.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSold.label},"VENDIDAS"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSold.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQtSell)||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktSold.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(stats.statsTotalAmountSell)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSellRRPP.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktReferencedRRPP.label},"Referenciadas por RRPP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{className:"columns-row-between"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktReferencedRRPP.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsTotalQtReferencedByRrpp)||0),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){history.push(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["g" /* EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE */]);},size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default.a,{style:theme.stats.tktReferencedRRPP.value}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.producer.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.producer.label},"Ganancia de Productor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.producer.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(stats.statsTotalAmountProducer)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSold.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktGift.label},"INVITACIONES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktGift.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsGiftQt)||0))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.stats.tktSold.paper},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktLoyaly.label},"CANJES"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.tktLoyaly.value},__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatNumber(stats.statsLoyalyQt)||0)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.stats.titleDetail.box},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{style:theme.stats.titleDetail.label},"DETALLE POR TIPO DE ENTRADA ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["v" /* GridList */],{cols:2,style:{justifyContent:"space-between"}},this.renderTicketByType()))));}}]);return StatisticsEvent;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE STATISTICS", store)
return{login:store.auth.login,stats:store.evt.stats,event:store.evt.eventStats//eventPlace: store.form.addEditEvent
};}// function mapDispatchToProps(dispatch) {
//   return bindActionCreators(
//     {
//     },
//     dispatch
//   );
// }
// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps// mapDispatchToProps
)(StatisticsEvent))));

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatisticsDirectRRPP=function(_React$PureComponent){_inherits(StatisticsDirectRRPP,_React$PureComponent);function StatisticsDirectRRPP(props){_classCallCheck(this,StatisticsDirectRRPP);var _this=_possibleConstructorReturn(this,(StatisticsDirectRRPP.__proto__||Object.getPrototypeOf(StatisticsDirectRRPP)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,rrpps:[],filter:"",showPop:false,detailList:[]};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(StatisticsDirectRRPP,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}console.log("PROPS",this.props);this.props.actionStatisticsDirectRRPPByEvent(this.props.event.id,this.onChangePage,function(e){console.log("ERROR",e);__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_10__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ventas");});}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var rrpps=this.props.directRrppList.filter(function(r){return(r.lastname+", "+r.name).match(filter);});var count=rrpps.length;rrpps=rrpps.slice(from,end);this.setState({page:newPage,count:count,rrpps:rrpps});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var rrpps=this.props.directRrppList.filter(function(r){return(r.lastname+", "+r.name).match(filter);});var count=rrpps.length;rrpps=rrpps.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,rrpps:rrpps});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"renderTableHeader",value:function renderTableHeader(){// const {theme} = this.props
var headers=["RRPP","Cantidad","Importe","Ver detalle"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}));}},{key:"renderTableBody",value:function renderTableBody(){var _this2=this;var theme=this.props.theme;var rrpps=this.state.rrpps;if(!rrpps||rrpps.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return rrpps.map(function(item,index){// console.log(index, item)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.name," ",item.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatNumber(item.totalQt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatCurrency(item.totalAmount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){_this2.setState({showPop:true,rrpp:item,detailList:item.detailByType});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default.a,null))));});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,theme=_props.theme,event=_props.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Ventas Directas por RRPP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Evento ",event.evtName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"flex-end"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.showPop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,this.state.rrpp&&this.state.rrpp.name," ",this.state.rrpp&&this.state.rrpp.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"Venta directa"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{minWidth:500,boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"},align:"right"},"Importe"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.state.detailList.map(function(d,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,d.totalQt+" - "+d.tktProducerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{align:"right"},__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatCurrency(d.totalAmount)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:function onClick(){return _this3.setState({showPop:false});}},"Cerrar")))));}}]);return StatisticsDirectRRPP;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,event:store.evt.eventStats,directRrppList:store.evt.directRrppList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionStatisticsDirectRRPPByEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["m" /* actionStatisticsDirectRRPPByEvent */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(StatisticsDirectRRPP))));

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatisticsReferencedRRPP=function(_React$PureComponent){_inherits(StatisticsReferencedRRPP,_React$PureComponent);function StatisticsReferencedRRPP(props){_classCallCheck(this,StatisticsReferencedRRPP);var _this=_possibleConstructorReturn(this,(StatisticsReferencedRRPP.__proto__||Object.getPrototypeOf(StatisticsReferencedRRPP)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,rrpps:[],filter:"",showPop:false,detailList:[]};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(StatisticsReferencedRRPP,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.props.actionStatisticsReferencedRRPPByEvent(this.props.event.id,this.onChangePage,function(e){console.log("ERROR",e);__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_10__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ventas");});}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var rrpps=this.props.referencedRrppList.filter(function(r){return(r.lastname+", "+r.name).match(filter);});var count=rrpps.length;rrpps=rrpps.slice(from,end);this.setState({page:newPage,count:count,rrpps:rrpps});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var rrpps=this.props.referencedRrppList.filter(function(r){return(r.lastname+", "+r.name).match(filter);});var count=rrpps.length;rrpps=rrpps.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,rrpps:rrpps});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"renderTableHeader",value:function renderTableHeader(){// const {theme} = this.props
var headers=["RRPP","Venta referenciada"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}));}},{key:"renderTableBody",value:function renderTableBody(){var _this2=this;var theme=this.props.theme;var rrpps=this.state.rrpps;if(!rrpps||rrpps.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return rrpps.map(function(item,index){// console.log(index, item)
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.name," ",item.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatNumber(item.totalQt),item&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){_this2.setState({showPop:true,rrpp:item,detailList:item.detailByType});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default.a,null))));});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,theme=_props.theme,event=_props.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Ventas Referenciadas por RRPP"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Evento ",event.evtName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"flex-end"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.showPop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,this.state.rrpp&&this.state.rrpp.name," ",this.state.rrpp&&this.state.rrpp.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"Venta referenciada"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{minWidth:500,boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"},align:"right"},"Cantidad"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.state.detailList.map(function(d,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,d.tktProducerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{align:"right"},__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatNumber(d.totalQt)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:function onClick(){return _this3.setState({showPop:false});}},"Cerrar")))));}}]);return StatisticsReferencedRRPP;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,event:store.evt.eventStats,referencedRrppList:store.evt.referencedRrppList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionStatisticsReferencedRRPPByEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["o" /* actionStatisticsReferencedRRPPByEvent */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(StatisticsReferencedRRPP))));

/***/ }),
/* 1478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var StatisticsProducer=function(_React$PureComponent){_inherits(StatisticsProducer,_React$PureComponent);function StatisticsProducer(props){_classCallCheck(this,StatisticsProducer);var _this=_possibleConstructorReturn(this,(StatisticsProducer.__proto__||Object.getPrototypeOf(StatisticsProducer)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,producers:[],filter:"",showPop:false,detailList:[]};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(StatisticsProducer,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}console.log("PROPS",this.props);this.props.actionStatisticsProductorByEvent(this.props.event.id,this.onChangePage,function(e){console.log("ERROR",e);__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_10__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ventas");});}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var producers=this.props.producerSellList.filter(function(p){return(p.lastname+", "+p.name).match(filter);});var count=producers.length;producers=producers.slice(from,end);this.setState({page:newPage,count:count,producers:producers});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var producers=this.props.producerSellList.filter(function(p){return(p.lastname+", "+p.name).match(filter);});var count=producers.length;producers=producers.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,producers:producers});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"renderTableHeader",value:function renderTableHeader(){// const {theme} = this.props
var headers=["Productor","Cantidad","Importe","Ver detalle"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}));}},{key:"renderTableBody",value:function renderTableBody(){var _this2=this;var theme=this.props.theme;var producers=this.state.producers;if(!producers||producers.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return producers.map(function(item,index){console.log("PRODUCERS ITEMS",index,item);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.name," ",item.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatNumber(item.totalQt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatCurrency(item.totalAmount)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){_this2.setState({showPop:true,producer:item,detailList:item.detailByType});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Visibility___default.a,null))));});}},{key:"render",value:function render(){var _this3=this;var _props=this.props,theme=_props.theme,event=_props.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Ventas por Productor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Evento ",event.evtName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"flex-end"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.showPop},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,this.state.producer&&this.state.producer.name," ",this.state.producer&&this.state.producer.lastname),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"Venta productor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{minWidth:500,boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"},align:"right"},"Cantidad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"},align:"right"},"Importe"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.state.detailList.map(function(d,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,d.tktProducerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{align:"right"},__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatNumber(d.totalQt)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{align:"right"},__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].formatCurrency(d.totalAmount)));})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:function onClick(){return _this3.setState({showPop:false});}},"Cerrar")))));}}]);return StatisticsProducer;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,event:store.evt.eventStats,producerSellList:store.evt.producerSellList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionStatisticsProductorByEvent:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["n" /* actionStatisticsProductorByEvent */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(StatisticsProducer))));

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FiberManualRecord__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FiberManualRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FiberManualRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TicketTypes=function(_React$PureComponent){_inherits(TicketTypes,_React$PureComponent);function TicketTypes(props){_classCallCheck(this,TicketTypes);var _this=_possibleConstructorReturn(this,(TicketTypes.__proto__||Object.getPrototypeOf(TicketTypes)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,tickets:[],filter:"",ticketForDelete:false};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteTicketSuccess=_this.getDeleteTicketSuccess.bind(_this);_this.onAddTicket=_this.onAddTicket.bind(_this);_this.onConfirmDeleteTicket=_this.onConfirmDeleteTicket.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(TicketTypes,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.props.actionGetTicketTypes(this.onChangePage,this.getTicketsError);}},{key:"getTicketsError",value:function getTicketsError(e){console.log("ERROR AL LISTAR TICKETS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"Ocurrió un error al listar los tickets.");}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var tickets=this.props.ticketTypeList.filter(function(t){return t.tktDisplayName.match(filter);});var count=tickets.length;tickets=tickets.slice(from,end);this.setState({page:newPage,count:count,tickets:tickets});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var tickets=this.props.ticketTypeList.filter(function(t){return t.tktDisplayName.match(filter);});var count=tickets.length;tickets=tickets.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,tickets:tickets});}},{key:"onAddTicket",value:function onAddTicket(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["B" /* TICKET_TYPE_ADD_ROUTE */]);}},{key:"onEditTicket",value:function onEditTicket(ticket){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["C" /* TICKET_TYPE_EDIT_ROUTE */],ticket);}},{key:"onConfirmDeleteTicket",value:function onConfirmDeleteTicket(){this.props.actionDeleteTicketType(this.state.ticketForDelete.id,this.getDeleteTicketSuccess,this.getDeleteTicketError);this.setState({ticketForDelete:false});}},{key:"onDeleteTicket",value:function onDeleteTicket(ticket){this.setState({ticketForDelete:ticket});}},{key:"getDeleteTicketSuccess",value:function getDeleteTicketSuccess(){var _this2=this;var event=this.props.event;// console.log("EVENT", event)
this.props.actionGetTicketTypes(function(){_this2.onChangePage(null,_this2.state.page);},this.getTicketsError);}},{key:"getDeleteTicketError",value:function getDeleteTicketError(e){console.log("ERROR GET DELETE TICKET",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar el ticket.");}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Nombre","Tipo","Precio","Lote Total","Disponibles","Disponible desde","Disponible hasta","Status","Color","Creado por","Modificado por"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}/* 
tktIcon
tktIconFamily

tktMaxQtBuy
tktName

tktPriceProducer
tktProducerName
  */},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var theme=this.props.theme;var tickets=this.state.tickets;if(!tickets||tickets.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return tickets.map(function(item,index){var isActive=item.tktVisible;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktDisplayName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,"$ "+__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].formatNumber(item.tktPrice)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktQtOriginal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktQt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].timestampToMoment(item.tktInitDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].timestampToMoment(item.tktEndDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body},item.tktVisible?"ACTIVO":"INACTIVO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_FiberManualRecord___default.a,{style:{color:item.tktColor}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktCreateUser),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.tktLastUpdateUser),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:Object.assign({},theme.table.actionsColumn,{minWith:200})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Editar tipo de ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onEditTicket.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar tipo de ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onDeleteTicket.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Delete___default.a,null)))));});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,theme=_props.theme,ticketTypeList=_props.ticketTypeList,event=_props.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea tipo de tickets para el evento seleccionado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de tipos de tickets"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Crear nuevo tipo de ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddTicket,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.ticketForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Tipo de Ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el tipo de ticket?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this4.setState({ticketForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar tipo de ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteTicket},"Eliminar"))))));}}]);return TicketTypes;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,ticketTypeList:store.evt.ticketTypeList,event:store.evt.event};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetTicketTypes:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["f" /* actionGetTicketTypes */],actionDeleteTicketType:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["c" /* actionDeleteTicketType */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(TicketTypes))));

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ConfirmationNumber__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ConfirmationNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ConfirmationNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_FiberManualRecord__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_FiberManualRecord___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_FiberManualRecord__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Constants__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_Constants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_Constants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_Validations__ = __webpack_require__(67);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Tickets=function(_React$PureComponent){_inherits(Tickets,_React$PureComponent);function Tickets(props){_classCallCheck(this,Tickets);var _this=_possibleConstructorReturn(this,(Tickets.__proto__||Object.getPrototypeOf(Tickets)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,tickets:[],filter:"",ticketForDelete:false,orderBy:"tktBuyDate",orderDesc:true,ticketForTransfer:false,userDialogInformation:false,userDialogInformationUser:{},dniTransfer:"",searchField:"E-mail",search:"",emailError:""};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteTicketSuccess=_this.getDeleteTicketSuccess.bind(_this);_this.getTransferTicketError=_this.getTransferTicketError.bind(_this);_this.getTransferTicketSuccess=_this.getTransferTicketSuccess.bind(_this);_this.onAddTicket=_this.onAddTicket.bind(_this);_this.onConfirmDeleteTicket=_this.onConfirmDeleteTicket.bind(_this);_this.transferTicket=_this.transferTicket.bind(_this);_this.onTransferTicket=_this.onTransferTicket.bind(_this);_this.onSearch=_this.onSearch.bind(_this);_this.filterTickets=_this.filterTickets.bind(_this);_this.onChangeDniTransfer=_this.onChangeDniTransfer.bind(_this);_this.onSearchUser=_this.onSearchUser.bind(_this);_this.sortTickets=_this.sortTickets.bind(_this);return _this;}_createClass(Tickets,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_9__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.onChangePage(null,this.state.page);}},{key:"getTicketsError",value:function getTicketsError(e){console.log("ERROR AL LISTAR TICKETS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Ocurrió un error al listar los tickets.");}},{key:"onRefresh",value:function onRefresh(){this.onChangePage(null,this.state.page);}},{key:"onSearch",value:function onSearch(evt){this.setState({search:evt.target.value,errorEmail:""},this.onChangePage);}},{key:"filterTickets",value:function filterTickets(ticket){var filter=new RegExp(this.state.search,"ig");var result=ticket.tktDisplayName&&ticket.tktDisplayName.match(filter)||ticket.tktCategory&&ticket.tktCategory.match(filter)||ticket.tktBuyerDU&&ticket.tktBuyerDU.match(filter)||ticket.tktBuyerName&&ticket.tktBuyerName.match(filter)||ticket.tktOwnerDU&&ticket.tktOwnerDU.match(filter)||ticket.tktOwnerName&&ticket.tktOwnerName.match(filter)||ticket.tktRrpp&&ticket.tktRrpp.match(filter)||// (ticket.tktPrice && ticket.tktPrice.match(filter)) ||
// (ticket.tktBuyDate && ticket.tktBuyDate.match(filter)) ||
ticket.tktBuyOperationId&&ticket.tktBuyOperationId.match(filter)||ticket.tktState&&ticket.tktState.match(filter)||ticket.tktColor&&ticket.tktColor.match(filter)||ticket.createName&&ticket.createName.match(filter)||ticket.createLastName&&ticket.tktDisplayNamecreateLastName.match(filter);if(result&&this.state.birthdateFrom&&this.state.birthdateTo&&this.state.birthmonth!=-1){var b=this.toMoment(ticket.proBirthDate);result=b instanceof __WEBPACK_IMPORTED_MODULE_8_moment___default.a&&b.month()==this.state.birthmonth&&b.date()>=this.state.birthdateFrom&&b.date()<=this.state.birthdateTo;}// let tagFilter = this.state.tagsFilterSelected;
// if (result && tagFilter && tagFilter.length > 0) {
//   result =
//     ticket.proTags &&
//     tagFilter.some((t) => ticket.proTags.some((ut) => ut.id == t.id));
// }
return result;}},{key:"onChangePage",value:function onChangePage(dta){var _this2=this;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;console.log("this.props.event.id",this.props.event.id);this.props.actionGetTickets({evtId:this.props.event.id,search:this.state.search},{field:this.state.orderBy,desc:this.state.orderDesc},{from:newPage*this.state.rowPerPage,size:this.state.rowPerPage},function(){_this2.setState({page:newPage});},this.getTicketsError);}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){this.setState({rowPerPage:evt.target.value},this.onChangePage);}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"sortTickets",value:function sortTickets(a,b){try{if(!this.state.orderDesc){switch(this.state.orderBy){case"tktBuyerName":return(a[this.state.orderBy]+" "+a["tktBuyerName"]).localeCompare(b[this.state.orderBy]+" "+b["tktBuyerName"]);case"tktDisplayName":return(a[this.state.orderBy]+" "+a["tktDisplayName"]).localeCompare(b[this.state.orderBy]+" "+b["tktDisplayName"]);case"tktOwnerName":return(a[this.state.orderBy]+" "+a["tktOwnerName"]).localeCompare(b[this.state.orderBy]+" "+b["tktOwnerName"]);case"tktState":return(a[this.state.orderBy]+" "+a["tktColor"]).localeCompare(b[this.state.orderBy]+" "+b["tktState"]);case"tktRrpp":return a[this.state.orderBy]<b[this.state.orderBy]?1:-1;case"createEmail":return(a[this.state.orderBy]+" "+a["createEmail"]).localeCompare(b[this.state.orderBy]+" "+b["createEmail"]);case"tktBuyDate":return __WEBPACK_IMPORTED_MODULE_8_moment___default.a.unix(a.tktBuyDate).isBefore(__WEBPACK_IMPORTED_MODULE_8_moment___default.a.unix(b.tktBuyDate))?1:-1;default:break;}}else{switch(this.state.orderBy){case"tktBuyerName":return(b[this.state.orderBy]+" "+b["tktBuyerName"]).localeCompare(a[this.state.orderBy]+" "+a["tktBuyerName"]);case"tktDisplayName":return(b[this.state.orderBy]+" "+b["tktDisplayName"]).localeCompare(a[this.state.orderBy]+" "+a["tktDisplayName"]);case"tktOwnerName":return(b[this.state.orderBy]+" "+b["tktOwnerName"]).localeCompare(a[this.state.orderBy]+" "+a["tktOwnerName"]);case"createEmail":return(b[this.state.orderBy]+" "+b["createEmail"]).localeCompare(a[this.state.orderBy]+" "+a["createEmail"]);case"tktState":return(b[this.state.orderBy]+" "+b["tktState"]).localeCompare(a[this.state.orderBy]+" "+a["tktState"]);case"tktRrpp":return a[this.state.orderBy]<b[this.state.orderBy]?-1:1;case"tktBuyDate":return __WEBPACK_IMPORTED_MODULE_8_moment___default.a.unix(a.tktBuyDate).isBefore(__WEBPACK_IMPORTED_MODULE_8_moment___default.a.unix(b.tktBuyDate))?-1:1;default:break;}}}catch(e){console.log("SORT ERROR",e);return-1;}}},{key:"onChangeDniTransfer",value:function onChangeDniTransfer(evt){this.setState({dniTransfer:evt.target.value,dniError:""});}},{key:"onAddTicket",value:function onAddTicket(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_9__config_RoutesConstants__["y" /* TICKET_ADD_ROUTE */]);}},{key:"onEditTicket",value:function onEditTicket(ticket){this.props.history.push(__WEBPACK_IMPORTED_MODULE_9__config_RoutesConstants__["z" /* TICKET_EDIT_ROUTE */],ticket);}},{key:"onConfirmDeleteTicket",value:function onConfirmDeleteTicket(){var _state$ticketForDelet=this.state.ticketForDelete,id=_state$ticketForDelet.id,tktOwnerDU=_state$ticketForDelet.tktOwnerDU,tktState=_state$ticketForDelet.tktState;this.props.actionDeleteTicket(id,tktOwnerDU,tktState,this.getDeleteTicketSuccess,this.getDeleteTicketError);this.setState({ticketForDelete:false});}},{key:"transferTicket",value:function transferTicket(){var _state=this.state,receiverDocument=_state.dniTransfer,ticketForTransfer=_state.ticketForTransfer;var event=this.props.event;var eventId=event.id;var ticketId=ticketForTransfer.id,senderDocument=ticketForTransfer.tktOwnerDU;if(!receiverDocument){this.setState({dniError:"Debe completar el campo"});}else{this.props.actionTransferTicket({receiverDocument:receiverDocument,senderDocument:senderDocument,eventId:eventId,ticketId:ticketId},this.getTransferTicketSuccess,this.getTransferTicketError);this.setState({ticketForTransfer:false,dniTransfer:""});}}},{key:"onDeleteTicket",value:function onDeleteTicket(ticket){this.setState({ticketForDelete:ticket});}},{key:"onTransferTicket",value:function onTransferTicket(ticket){this.setState({ticketForTransfer:ticket});}},{key:"getDeleteTicketSuccess",value:function getDeleteTicketSuccess(){var event=this.props.event;this.onChangePage(null,this.state.page);}},{key:"getDeleteTicketError",value:function getDeleteTicketError(e){console.log("ERROR GET DELETE TICKET",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar el ticket.");}},{key:"getTransferTicketSuccess",value:function getTransferTicketSuccess(){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["b" /* SUCCESS */],"El ticket se transfirio con exito.");this.onChangePage(null,this.state.page);}},{key:"getTransferTicketError",value:function getTransferTicketError(e){var _e$body=e.body,body=_e$body===undefined?{}:_e$body;var _body$error=body.error,error=_body$error===undefined?"":_body$error;console.log("getTransferTicketError",error);if(error==="Destination user doesnt exist"){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"El dni destino no existe.");}else{__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Ocurrió un error al transferir el ticket.");}this.setState({ticketForTransfer:false,dniTransfer:""});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this3=this;var theme=this.props.theme;var headers=[{id:"tktDisplayName",label:"Nombre",hasFilter:true},{id:"tktCategory",label:"Categoría"},{id:"tktBuyerDU",label:"DNI Comprador"},{id:"tktBuyerName",label:"Comprador",hasFilter:true},{id:"tktOwnerDU",label:"DNI Poseedor"},{id:"tktOwnerName",label:"Poseedor",hasFilter:true},{id:"tktRrpp",label:"RRPP",hasFilter:true},{id:"tktPrice",label:"Precio"},{id:"tktBuyDate",label:"Fecha de compra",hasFilter:true},{id:"tktBuyOperationId",label:"Id de Operación"},{id:"tktState",label:"Status",hasFilter:true},{id:"tktColor",label:"Color"},{id:"createEmail",label:"Creado por",hasFilter:true}];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,label.hasFilter?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["U" /* TableSortLabel */],{active:_this3.state.orderBy===label.id,direction:_this3.state.orderBy===label.id&&_this3.state.orderDesc?"desc":"asc",onClick:function onClick(){return _this3.onSortByField(label.id);},hideSortIcon:false},label.label):label.label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"isValidSearch",value:function isValidSearch(){var isValid=true;if(this.state.search){switch(this.state.searchField){case"E-mail"://Emails
var errorEmail=Object(__WEBPACK_IMPORTED_MODULE_18__common_Validations__["f" /* validateEmail */])(this.state.search);if(errorEmail){this.setState({emailError:errorEmail});isValid=false;}break;case"DU"://DU
if(!/^[0-9]{1,3}(\.?[0-9]{3})*$/.test(this.state.search)){// console.log("TEST", !(/[0-9]{3}(\.?[0-9]{3})*/).test(this.state.search))
var errorDU="Este campo solo admite números enteros.";//typeInteger(this.state.search)
// if(errorDU){
this.setState({emailError:errorDU});isValid=false;// }
}break;case"IdOperacion":// IdOperacion //TODO Validar Id Operación no es numérico
var errorIdOperacion=Object(__WEBPACK_IMPORTED_MODULE_18__common_Validations__["c" /* typeInteger */])(this.state.search);if(errorIdOperacion){this.setState({emailError:errorIdOperacion});isValid=false;}break;default:break;}}return isValid;}},{key:"onSearchUser",value:function onSearchUser(){this.setState({emailError:""});if(this.isValidSearch()){this.setState({filter:this.state.search},this.onChangePage);}}},{key:"onPressUserInformation",value:function onPressUserInformation(item,buyerDialog){var _this4=this;var tktBuyerDU=item.tktBuyerDU,tktBuyerEmail=item.tktBuyerEmail,tktOwnerDU=item.tktOwnerDU,tktOwnerEmail=item.tktOwnerEmail;this.props.actionGetUsersByEmailOrDU(buyerDialog?tktBuyerDU:tktOwnerDU,buyerDialog?tktBuyerEmail:tktOwnerEmail,function(data){if(data&&data.users&&data.users.length>0){_this4.setState({userDialogInformation:true,userDialogInformationUser:data.users[0]});}else{__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["c" /* WARNING */],"No encontramos el usuario");}},function(e){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No se encontró el usuario.");});}},{key:"renderTableBody",value:function renderTableBody(){var _this5=this;var theme=this.props.theme;var tickets=this.props.ticketList.items;console.log("TICKETS",tickets);if(!tickets||tickets.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return tickets.map(function(item,index){console.log("******* ITEM",item);var isActive=item.tktState;var stateLabel=void 0;switch(item.tktState){case"pendingUse":stateLabel="Pendiente";break;case"already_used":stateLabel="Utilizado";break;case"pendingCreate":stateLabel="Sin Generar";break;default:stateLabel="";}var buyDate=item.tktBuyDate||item.tktInviteDate;var itemCountTooltip=null;if(item.ticketCount){itemCountTooltip=item.ticketCount>1?item.ticketCount+" invitaciones":item.ticketCount+" invitaci\xF3n";}var origin={};switch(item.tktOrigin){case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].standard:origin.label=item.rrppName?"R":"";origin.tooltip=item.rrppName?"Referenciada":"";origin.color=item.rrppName?"#777777":"transparent";break;case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].rrppSell:origin.label="D";origin.tooltip="Venta Directa";origin.color="black";break;case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].producer:origin.label="D";origin.tooltip="Venta Directa";origin.color="black";break;case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].producerBO:origin.label="D";origin.tooltip="Venta Directa";origin.color="black";break;case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].gift:origin.label="I";origin.tooltip="Invitación";origin.color="orange";break;case __WEBPACK_IMPORTED_MODULE_17__common_Constants__["ORIGIN"].loyaly:origin.label="C";origin.tooltip="Canje";origin.color="#B0A80D";break;default:origin.label="";origin.tooltip="";origin.color="transparent";break;}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:itemCountTooltip,placement:"left-start"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["c" /* Badge */],{color:"primary",badgeContent:item.ticketCount},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],null,item.tktDisplayName)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,item.tktCategory),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:item.tktBuyerEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.tktBuyerDU))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:item.tktBuyerEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{style:{backgroundColor:"aquamarine"},onClick:function onClick(){return _this5.onPressUserInformation(item,true);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.tktBuyerName)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:item.tktOwnerEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.tktOwnerDU||item.proDNI))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:item.tktOwnerEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{style:{backgroundColor:"aquamarine"},onClick:function onClick(){return _this5.onPressUserInformation(item,false);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.tktOwnerName||item.proEmail)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{display:"flex"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.rrppName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:origin.tooltip},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body",style:{backgroundColor:origin.color,color:"white",borderRadius:90,borderStyle:"solid",borderWidth:1,width:20,height:20,textAlign:"center",marginLeft:6,paddingTop:1}},origin.label)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].formatCurrency(item.tktPrice)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].timestampToMoment(buyDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,item.tktBuyOperationId),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body},stateLabel),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_FiberManualRecord___default.a,{style:{color:item.tktColor}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:item.createEmail},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"body"},item.createName," ",item.createLastName))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:Object.assign({},theme.table.actionsColumn,{minWith:200})},item.tktState!="already_used"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["y" /* IconButton */],{onClick:_this5.onDeleteTicket.bind(_this5,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_icons_Delete___default.a,null))),item.tktState!="pendingCreate"&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Transferir ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["y" /* IconButton */],{onClick:_this5.onTransferTicket.bind(_this5,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_icons_ConfirmationNumber___default.a,null))))));});}},{key:"renderDialogTransferTicket",value:function renderDialogTransferTicket(){var _this6=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["k" /* Dialog */],{open:this.state.ticketForTransfer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* DialogTitle */],null,"Transferir el ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["r" /* FormControl */],{error:this.state.dniError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["z" /* Input */],{placeholder:"Ingres\xE1 el DNI destino",shrink:true,onChange:this.onChangeDniTransfer,value:this.state.dniTransfer,helperText:this.state.dniError}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["t" /* FormHelperText */],null,this.state.dniError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this6.setState({ticketForTransfer:null,dniTransfer:""});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Transferir ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.transferTicket},"Transferir"))));}},{key:"openInNewTab",value:function openInNewTab(url){window.open(url,"_blank","noopener,noreferrer");}},{key:"renderPopUpUserInformation",value:function renderPopUpUserInformation(){var _this7=this;var userDialogInformationUser=this.state.userDialogInformationUser;var _userDialogInformatio=userDialogInformationUser.proTags,proTags=_userDialogInformatio===undefined?[]:_userDialogInformatio,_userDialogInformatio2=userDialogInformationUser.proInstagram,proInstagram=_userDialogInformatio2===undefined?"":_userDialogInformatio2,_userDialogInformatio3=userDialogInformationUser.proDNI,proDNI=_userDialogInformatio3===undefined?"":_userDialogInformatio3,_userDialogInformatio4=userDialogInformationUser.proName,proName=_userDialogInformatio4===undefined?"":_userDialogInformatio4,_userDialogInformatio5=userDialogInformationUser.proEmail,proEmail=_userDialogInformatio5===undefined?"":_userDialogInformatio5,_userDialogInformatio6=userDialogInformationUser.proLastName,proLastName=_userDialogInformatio6===undefined?"":_userDialogInformatio6,_userDialogInformatio7=userDialogInformationUser.proPhone,proPhone=_userDialogInformatio7===undefined?"":_userDialogInformatio7;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["k" /* Dialog */],{maxWidth:"xl",fullWidth:true,open:this.state.userDialogInformation},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* DialogTitle */],null,"Informacion del Usuario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{minWidth:500,boxShadow:"0 2px 4px 0 rgba(0, 0, 0, 0.23)"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["R" /* TableHead */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["T" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Nombre"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Apellido"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Instagram"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Telefono"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Email"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Documento"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],{style:{backgroundColor:"#f6f6f6"}},"Tags"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["P" /* TableBody */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["T" /* TableRow */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,proName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,proLastName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{style:{backgroundColor:"aquamarine"},onClick:function onClick(){return _this7.openInNewTab("https://instagram.com/"+proInstagram);}},proInstagram)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{style:{backgroundColor:"aquamarine"},onClick:function onClick(){return _this7.openInNewTab("https://api.whatsapp.com/send/?phone=549"+proPhone);}},proPhone)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,proEmail),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,proDNI),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Q" /* TableCell */],null,proTags.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["g" /* Chip */],{label:t.tagName,style:{backgroundColor:t.tagColor}});})))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Aceptar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this7.setState({userDialogInformation:null,userDialogInformationUser:{}});}},"Aceptar"))));}},{key:"render",value:function render(){var _this8=this;var _props=this.props,theme=_props.theme,event=_props.event;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"h1"},event.evtName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea tickets para el evento seleccionado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de Tickets"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["q" /* Fab */],{onClick:this.onRefresh,size:"small",style:{marginLeft:16,width:34,height:34},color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Sync___default.a,{style:{fontSize:20}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Crear nuevo ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddTicket,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["d" /* Box */],{style:{width:250,paddingLeft:10,paddingRight:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["W" /* TextField */],{placeholder:"Buscar",onChange:this.onSearch})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.props.ticketList.size,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["k" /* Dialog */],{open:this.state.ticketForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Ticket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el ticket?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this8.setState({ticketForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteTicket},"Eliminar")))),this.renderDialogTransferTicket(),this.renderPopUpUserInformation()));}}]);return Tickets;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,ticketList:store.evt.ticketList,event:store.evt.event};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetTickets:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["g" /* actionGetTickets */],actionDeleteTicket:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["b" /* actionDeleteTicket */],actionTransferTicket:__WEBPACK_IMPORTED_MODULE_4__actions_EventActions__["p" /* actionTransferTicket */],actionGetUsersByEmailOrDU:__WEBPACK_IMPORTED_MODULE_7__actions_UserActions__["d" /* actionGetUsersByEmailOrDU */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Tickets))));

/***/ }),
/* 1481 */
/***/ (function(module, exports) {

var ORIGIN={standard:"standard",// App Mobile usuario final
rrppSell:"rrppsell",// App Mobile cuando vende relaciones publicas
producer:"producer",// App Mobile cuando vende el productor
producerBO:"producer-bo",// Back Office cuando vende el productor.
gift:"gift-bo",// Regalos
loyaly:"loyaly"// Loyaly
};module.exports={ORIGIN:ORIGIN};

/***/ }),
/* 1482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_TagActions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__actions_RolActions__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_lab_Autocomplete__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ColorField_ColorField__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Backspace__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Backspace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Backspace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Block__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_CheckCircle__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_CheckCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_CheckCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Notifications__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Notifications___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Notifications__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_StarRateRounded__ = __webpack_require__(1486);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__material_ui_icons_StarRateRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_StarRateRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Brightness1__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Brightness1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Brightness1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_Bookmark__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__material_ui_icons_Bookmark___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_Bookmark__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__users_AssignRolToUser__ = __webpack_require__(1488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__users_NotifyUser__ = __webpack_require__(1510);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_icons_VerifiedUser__ = __webpack_require__(1511);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__material_ui_icons_VerifiedUser___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_VerifiedUser__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_moment__);
var _typeof=typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"?function(obj){return typeof obj;}:function(obj){return obj&&typeof Symbol==="function"&&obj.constructor===Symbol&&obj!==Symbol.prototype?"symbol":typeof obj;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import NoVerifiedIcon from '@material-ui/icons/FaceRetouchingOffIcon';
var MONTHS=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var filterTag=Object(__WEBPACK_IMPORTED_MODULE_10__material_ui_lab_Autocomplete__["a" /* createFilterOptions */])();var Users=function(_React$PureComponent){_inherits(Users,_React$PureComponent);function Users(props){var _this$state;_classCallCheck(this,Users);// let tags = []
// tags.push({tagName:"Flores", tagColor:"#34FFc6"})
// tags.push({tagName:"Manzanas", tagColor:"#FF3333"})
// tags.push({tagName:"Cielos", tagColor:"#3333EE"})
// tags.push({tagName:"Naranjas", tagColor:"#7722FF"})
var _this=_possibleConstructorReturn(this,(Users.__proto__||Object.getPrototypeOf(Users)).call(this,props));_this.state=(_this$state={page:0,rowPerPage:5,count:0,users:[],isTagVisible:true,loyalyPopUp:null,loyalyUserSelected:null,filter:"",userForDelete:false,assignRol:false,userSelected:null,orderBy:"init_date",orderDesc:true,birthmonth:-1,birthdateFrom:"",birthdateTo:"",userForVerify:false,userVerifyTitle:"",userVerifyContentText:"",userVerifyToolTipOk:"",userVerifyBtnLabel:"",qntity:"",tags:props.tagList,tagText:"",tagsSelected:[],addTagColor:"#000000"},_defineProperty(_this$state,"tagsSelected",[]),_defineProperty(_this$state,"usersSelected",[]),_defineProperty(_this$state,"tagForDelete",null),_defineProperty(_this$state,"tagsFilterSelected",[]),_defineProperty(_this$state,"rolesFilterSelected",[]),_defineProperty(_this$state,"onlyDeleted",false),_defineProperty(_this$state,"allUsersSelected",false),_this$state);_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteUserSuccess=_this.getDeleteUserSuccess.bind(_this);_this.onConfirmDeleteUser=_this.onConfirmDeleteUser.bind(_this);_this.onSearch=_this.onSearch.bind(_this);_this.onSortByField=_this.onSortByField.bind(_this);_this.sortUsers=_this.sortUsers.bind(_this);_this.onChangeDniTransfer=_this.onChangeDniTransfer.bind(_this);_this.transferPoints=_this.transferPoints.bind(_this);_this.onCloseEditUser=_this.onCloseEditUser.bind(_this);_this.onNotifyUser=_this.onNotifyUser.bind(_this);_this.sendNotificationToVerifiedUser=_this.sendNotificationToVerifiedUser.bind(_this);_this.toMoment=_this.toMoment.bind(_this);_this.onChangeFrom=_this.onChangeFrom.bind(_this);_this.onChangeTo=_this.onChangeTo.bind(_this);_this.onFilterDate=_this.onFilterDate.bind(_this);_this.onChangeMonth=_this.onChangeMonth.bind(_this);_this.onClearBirthdateFilter=_this.onClearBirthdateFilter.bind(_this);_this.onConfirmVerifyUser=_this.onConfirmVerifyUser.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.onSelectTag=_this.onSelectTag.bind(_this);_this.onSelectFilterTag=_this.onSelectFilterTag.bind(_this);_this.onSelectFilterRol=_this.onSelectFilterRol.bind(_this);_this.onSaveTag=_this.onSaveTag.bind(_this);_this.onSelectAllUser=_this.onSelectAllUser.bind(_this);_this.onAddTag=_this.onAddTag.bind(_this);_this.onConfirmDeleteTagFromUser=_this.onConfirmDeleteTagFromUser.bind(_this);_this.onChangeOnlyDeleted=_this.onChangeOnlyDeleted.bind(_this);return _this;}_createClass(Users,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;if(this.props.login){this.onChangePage();this.props.actionGetRoles(null,function(e){console.log("ERROR AL LISTAR ROLES",e);});this.props.actionGetRolesRedimidores(null,function(e){console.log("ERROR AL LISTAR ROLES REDIMIDORES",e);});this.props.actionGetTags(function(){_this2.setState({tags:_this2.props.tagList});},function(e){console.log("ERROR AL LISTAR TAGS",e);});}else{this.props.history.replace(__WEBPACK_IMPORTED_MODULE_7__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}},{key:"getUsersError",value:function getUsersError(e){console.log("ERROR GET USERS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Ocurrió un error al listar los usuarios.");}},{key:"onRefresh",value:function onRefresh(){this.onChangePage(null,this.state.page);}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onChangeMonth",value:function onChangeMonth(event){this.setState({birthmonth:event.target.value});}},{key:"onChangeFrom",value:function onChangeFrom(event){if(!event.target.value||parseInt(event.target.value)<=31&&parseInt(event.target.value)>=1){this.setState({birthdateFrom:event.target.value});}}},{key:"onChangeTo",value:function onChangeTo(event){if(!event.target.value||parseInt(event.target.value)<=31&&parseInt(event.target.value)>=1){this.setState({birthdateTo:event.target.value});}}},{key:"onFilterDate",value:function onFilterDate(){var _state=this.state,birthmonth=_state.birthmonth,birthdateFrom=_state.birthdateFrom,birthdateTo=_state.birthdateTo;var validSearch=true;if(birthmonth==-1){validSearch=false;__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Debe seleccionar el mes para filtrar por cumpleaños");}if(!birthdateFrom){validSearch=false;__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Debe seleccionar un día desde para filtrar por cumpleaños");}if(!birthdateTo){validSearch=false;__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Debe seleccionar un día hasta para filtrar por cumpleaños");}if(birthdateFrom&&birthdateTo&&parseInt(birthdateTo)<parseInt(birthdateFrom)){validSearch=false;__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Debe seleccionar un día hasta posterior o igual al día desde para filtrar por cumpleaños");}if(validSearch){this.onChangePage();}}},{key:"onClearBirthdateFilter",value:function onClearBirthdateFilter(){this.setState({birthdateFrom:"",birthdateTo:"",birthmonth:-1},this.onChangePage);}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"sortUsers",value:function sortUsers(a,b){try{if(this.state.orderBy=="proInactiveAccount"||this.state.orderBy=="proVerified"){if(b[this.state.orderBy]){return this.state.orderDesc?1:-1;}else{return this.state.orderDesc?-1:1;}}if(b[this.state.orderBy]&&!a[this.state.orderBy]){return 1;}if(!b[this.state.orderBy]&&a[this.state.orderBy]){return-1;}if(!b[this.state.orderBy]&&!a[this.state.orderBy]){return 0;}// console.log("SORT", this.state.orderBy, this.state.orderDesc,b[this.state.orderBy] - a[this.state.orderBy])
if(this.state.orderDesc){if(this.state.orderBy=="proLastName"){return(b[this.state.orderBy]+" "+b["proName"]).localeCompare(a[this.state.orderBy]+" "+a["proName"]);}if(this.state.orderBy=="init_date"){// console.log("SORT INIT DATE",
// this.state.orderDesc,
// a.proEmail, b.proEmail,
// moment.unix(a.init_date).toString(),
// moment.unix(b.init_date).toString(),
// moment.unix(a.init_date).isBefore(moment.unix(b.init_date),'min')?-1:1)
return __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(b.init_date).isBefore(__WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(a.init_date))?-1:1;}if(this.state.orderBy=="proVerificationTime"){return __WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].timestampToMoment(b.proVerificationTime).isBefore(__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].timestampToMoment(a.proVerificationTime))?-1:1;}if(this.state.orderBy=="proDNI"){return b[this.state.orderBy]<a[this.state.orderBy]?-1:1;}if(this.state.orderBy=="proRoles"){return b[this.state.orderBy].length<a[this.state.orderBy].length?-1:1;}return b[this.state.orderBy].localeCompare(a[this.state.orderBy]);}if(this.state.orderBy=="proLastName"){return(a[this.state.orderBy]+" "+a["proName"]).localeCompare(b[this.state.orderBy]+" "+b["proName"]);}if(this.state.orderBy=="init_date"){// console.log("SORT INIT DATE",
//             this.state.orderDesc,
//             a.proEmail, b.proEmail,
//             moment.unix(a.init_date).toString(),
//             moment.unix(b.init_date).toString(),
//             moment.unix(a.init_date).isBefore(moment.unix(b.init_date))?-1:1)
return __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(a.init_date).isBefore(__WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(b.init_date))?-1:1;}if(this.state.orderBy=="proVerificationTime"){return __WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].timestampToMoment(a.proVerificationTime).isBefore(__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].timestampToMoment(b.proVerificationTime))?-1:1;}if(this.state.orderBy=="proDNI"){return a[this.state.orderBy]<b[this.state.orderBy]?-1:1;}if(this.state.orderBy=="proRoles"){return a[this.state.orderBy].length<b[this.state.orderBy].length?-1:1;}return a[this.state.orderBy].localeCompare(b[this.state.orderBy]);}catch(e){console.log("SORT ERROR",e);return-1;}}},{key:"onChangeOnlyDeleted",value:function onChangeOnlyDeleted(evt){this.setState({onlyDeleted:evt.target.checked},this.onChangePage);}},{key:"onChangePage",value:function onChangePage(dta){var _this3=this;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var birthdate=null;if(this.state.birthdateFrom&&this.state.birthdateTo&&this.state.birthmonth!=-1){birthdate={from:__WEBPACK_IMPORTED_MODULE_28_moment___default()(),to:__WEBPACK_IMPORTED_MODULE_28_moment___default()()};birthdate.from.date(this.state.birthdateFrom);birthdate.from.month(this.state.birthmonth);birthdate.to.date(this.state.birthdateTo);birthdate.to.month(this.state.birthmonth);}var tags=null;if(this.state.tagsFilterSelected&&this.state.tagsFilterSelected.length>0){tags=this.state.tagsFilterSelected.map(function(t){return t.id;});}var roles=null;if(this.state.rolesFilterSelected&&this.state.rolesFilterSelected.length>0){roles=this.state.rolesFilterSelected.map(function(t){return t.id;});}this.props.actionGetUsers({search:this.state.filter,birthdate:birthdate,tags:tags,roles:roles,onlyDeleted:this.state.onlyDeleted},{field:this.state.orderBy,desc:this.state.orderDesc},{from:newPage*this.state.rowPerPage,size:this.state.rowPerPage},function(){_this3.setState({page:newPage});},this.getUsersError);}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){this.setState({rowPerPage:evt.target.value},this.onChangePage);}},{key:"onNotifyUser",value:function onNotifyUser(user){this.setState({notifyUser:true,userSelected:user});}},{key:"onBlock",value:function onBlock(user){var _this4=this;if(user.proInactiveAccount){user.proInactiveAccount=false;this.props.actionSaveUser(user,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Usuario activo");_this4.onChangePage(null,_this4.state.page);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos activar el usuario");});}else{user.proInactiveAccount=true;this.props.actionSaveUser(user,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Usuario inactivo");_this4.onChangePage(null,_this4.state.page);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos desactivar el usuario");});}}},{key:"sendNotificationToVerifiedUser",value:function sendNotificationToVerifiedUser(user){this.props.actionSendNotification(user,{title:"Verificación de cuenta",body:"Tu cuenta ya se encuentra verificada, ya podes comprar tickets y disfrutar de los beneficios. Gracias por ser parte."},function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"La notificación ha sido enviada.");},function(e){if(!(e&&e.status&&e.status==401)){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No se pudo enviar la notificación.");}console.log("ERROR AL ENVIAR NOTIFICACION DE VERIFICACIÓN A UN USUARIO",e);});}},{key:"onEditUser",value:function onEditUser(user){//this.props.history.push(USERS_EDIT_ROUTE, user)
this.setState({assignRol:true,userSelected:user});}},{key:"rechargeLoyalyPoints",value:function rechargeLoyalyPoints(user){//this.props.history.push(USERS_EDIT_ROUTE, user)
this.setState({loyalyPopUp:true,loyalyUserSelected:user});}},{key:"onCloseEditUser",value:function onCloseEditUser(save){if(save==__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */]){this.onChangePage(null,this.state.page);}this.setState({assignRol:false});}},{key:"onDeleteUser",value:function onDeleteUser(user){this.setState({userForDelete:user});}},{key:"onConfirmDeleteUser",value:function onConfirmDeleteUser(){this.props.actionDeleteUser(this.state.userForDelete,this.getDeleteUserSuccess,this.getDeleteUserError);this.setState({userForDelete:false});}},{key:"getDeleteUserSuccess",value:function getDeleteUserSuccess(){this.onChangePage(null,this.state.page);__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"El usuario se eliminó correctamente.");}},{key:"getDeleteUserError",value:function getDeleteUserError(e){console.log("ERROR getDeleteUserError",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar el usuario.");}},{key:"onVerify",value:function onVerify(user){this.setState({userForVerify:user,userVerifyTitle:user.proVerified?"Anular Verficación de Usuario":"Verificar Usuario",userVerifyContentText:"\xBFEst\xE1 seguro que desea "+(user.proVerified?"anular la verificación ":"verificar")+" a "+user.proName+" "+user.proLastName+"?",userVerifyToolTipOk:user.proVerified?"Anular Verificación":"Verificar usuario",userVerifyBtnLabel:user.proVerified?"Anular":"Verificar"});}},{key:"onConfirmVerifyUser",value:function onConfirmVerifyUser(){var _this5=this;var user=this.state.userForVerify;this.setState({userForVerify:false});if(user.proVerified){user.proVerified=false;this.props.actionSaveUser(user,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Verificación anulada");_this5.onChangePage(null,_this5.state.page);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos anular la verificación del usuario");});}else{user.proVerified=true;user.setVerificationTime=true;user.proVerificatorUser=this.props.authEmail;this.props.actionSaveUser(user,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Usuario verificado");_this5.sendNotificationToVerifiedUser(user);_this5.onChangePage(null,_this5.state.page);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos verificar el usuario");});}}},{key:"toMoment",value:function toMoment(d){console.log("TO MOMENT",d,typeof d==="undefined"?"undefined":_typeof(d));if(true){if(d){if(d._seconds){return __WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(d._seconds);}else{return __WEBPACK_IMPORTED_MODULE_28_moment___default()(d);}}}else{var m=moment(d,"DD/MM/YYYY");if(m.isValid()){return m;}else{m=moment(d,"DD [de] MMMM YYYY");if(m.isValid()){return m;}else{m=moment(d);if(m.isValid()){return m;}else{return d;}}}}}},{key:"onSelectTag",value:function onSelectTag(evt,tag){var newTagIdx=tag.findIndex(function(t){return t.inputValue;});if(newTagIdx!=-1){this.setState({openAddTag:tag[newTagIdx].inputValue});// tag.splice(newTagIdx,1)
}else{var tags=tag.slice();this.setState({tagsSelected:tags});}}},{key:"onSelectFilterTag",value:function onSelectFilterTag(evt,tags){this.setState({tagsFilterSelected:tags});}},{key:"onSelectFilterRol",value:function onSelectFilterRol(evt,roles){this.setState({rolesFilterSelected:roles});}},{key:"onSaveTag",value:function onSaveTag(){var _this6=this;this.setState({savingTag:true});var newTag={tagName:this.state.openAddTag,tagColor:this.state.addTagColor,isTagVisible:this.state.isTagVisible};this.props.actionSaveTag(newTag,function(savedTag){var tagsSelected=_this6.state.tagsSelected.slice();var tags=_this6.state.tags.slice();tags.push(savedTag);tagsSelected.push(savedTag);_this6.setState({tagsSelected:tagsSelected,tags:tags,openAddTag:null,addTagColor:"#000000"});__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"El tag "+savedTag.tagName+" se agreg\xF3 correctamente");_this6.setState({savingTag:false});},function(e){console.log("onSaveTag Error",e);__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos agregar el tag "+newTag.tagName);_this6.setState({savingTag:false});});}},{key:"onSelectUser",value:function onSelectUser(newValue,evt){var users=this.state.usersSelected.slice();if(this.state.allUsersSelected&&!evt.target.checked||!this.state.allUsersSelected&&evt.target.checked){users.push({id:newValue.id,proName:newValue.proName,proLastName:newValue.proLastName,proDNI:newValue.proDNI,proEmail:newValue.proEmail});}else{var idx=users.findIndex(function(u){return u.id==newValue.id;});if(idx>=0){users.splice(idx,1);}}this.setState({usersSelected:users});}},{key:"onSelectAllUser",value:function onSelectAllUser(evt){var users=[];this.setState({allUsersSelected:evt.target.checked});if(!evt.target.checked){this.setState({usersSelected:[]});}// if (evt.target.checked) {
//   users = this.state.lastFilteredUsers.map((u) => {
//     return {
//       id: u.id,
//       proName: u.proName,
//       proLastName: u.proLastName,
//       proDNI: u.proDNI,
//       proEmail: u.proEmail,
//     };
//   });
// }
this.setState({usersSelected:users});}},{key:"onAddTag",value:function onAddTag(){var _this7=this;var tags=this.state.tagsSelected;var users=this.state.usersSelected;var allUsersSelected=this.state.allUsersSelected;this.props.actionAddTagsToUsers(tags,allUsersSelected,users,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Agregamos los tags a los usuarios correctamente.");_this7.setState({tagsSelected:[],usersSelected:[]});_this7.onChangePage(null,_this7.state.page);},function(e){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos agregar los tags a los usuarios.");});}},{key:"onDeleteTagFromUser",value:function onDeleteTagFromUser(tag,user){this.setState({tagForDelete:{tag:tag,user:user},deleteTagFromAllUsers:false});}},{key:"onConfirmDeleteTagFromUser",value:function onConfirmDeleteTagFromUser(){var _this8=this;var _state2=this.state,tagForDelete=_state2.tagForDelete,deleteTagFromAllUsers=_state2.deleteTagFromAllUsers;this.props.actionDeleteTagFromUser(tagForDelete.tag.id,deleteTagFromAllUsers?"all":tagForDelete.user.id,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"El tag se eliminó correctamente a "+(deleteTagFromAllUsers?"los usuarios.":tagForDelete.user.proName+" "+tagForDelete.user.proLastName+"."));_this8.onChangePage(null,_this8.state.page);},function(e){console.log("ERROR onConfirmDeleteTagFromUser",e);__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"No pudimos eliminar el tag a "+(deleteTagFromAllUsers?"los usuarios.":tagForDelete.user.proName+" "+tagForDelete.user.proLastName+"."));});this.setState({tagForDelete:null});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this9=this;var theme=this.props.theme;var headers=[{id:"proEmail",label:"Usuario"},{id:"proLastName",label:"Apellido y Nombre"},{id:"proDNI",label:"DNI"},{id:"proBirthDate",label:"Fecha de nacimiento"},{id:"proPhone",label:"Télefono"},{id:"init_date",label:"Fecha de registro"},{id:"proRoles",label:"Rol"},{id:"proInactiveAccount",label:"Status"}];if(__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED){headers.splice(7,0,{id:"proVerified",label:"Cuenta"});headers.splice(1,0,{id:"proInstagram",label:"Instagram"},{id:"proVerificatorUser",label:"Verificado por"},{id:"proVerificationTime",label:"Fecha verificación"});}headers.unshift({id:"selection",label:"Seleccionar todo",secondLabel:"Deseleccionar todo"});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){if(i==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:headCell.label},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{checked:_this9.state.allUsersSelected,color:"primary",onChange:_this9.onSelectAllUser})));}if(headCell.id=="proBirthDate"||headCell.id=="proInactiveAccount"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["U" /* TableSortLabel */],{active:_this9.state.orderBy===headCell.id,direction:_this9.state.orderBy===headCell.id&&_this9.state.orderDesc?"desc":"asc",onClick:function onClick(){return _this9.onSortByField(headCell.id);},hideSortIcon:true},headCell.label));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"openInNewTab",value:function openInNewTab(url){window.open(url,"_blank","noopener,noreferrer");}},{key:"renderTableBody",value:function renderTableBody(){var _this10=this;var theme=this.props.theme;var users=this.props.userList.items;if(!users||users.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return users.map(function(item,index){var isInactive=item.proInactiveAccount;var isVerified=item.proVerified;var birthdate=_this10.toMoment(item.proBirthDate);var _item$proTags=item.proTags,proTags=_item$proTags===undefined?[]:_item$proTags,_item$proRoles=item.proRoles,proRoles=_item$proRoles===undefined?[]:_item$proRoles;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{checked:_this10.state.allUsersSelected&&!_this10.state.usersSelected.some(function(u){return u.id==item.id;})||!_this10.state.allUsersSelected&&_this10.state.usersSelected.some(function(u){return u.id==item.id;}),color:"primary",onChange:_this10.onSelectUser.bind(_this10,item)})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],null,item.proEmail),proTags&&proTags.map(function(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:t.tagName,style:{backgroundColor:t.tagColor},onDelete:_this10.onDeleteTagFromUser.bind(_this10,t,item)});}))),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{style:{backgroundColor:item.proInstagram?"aquamarine":null},onClick:function onClick(){return _this10.openInNewTab("https://instagram.com/"+item.proInstagram);}},item.proInstagram)),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,item.proVerificatorUser),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].timestampToMoment(item.proVerificationTime))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,item.proLastName+", "+item.proName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,item.proDNI),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,birthdate&&(birthdate.format&&birthdate.format("DD/MM/YYYY")||birthdate)||"No Disponible"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{style:{backgroundColor:item.proPhone?"aquamarine":null},onClick:function onClick(){return _this10.openInNewTab("https://api.whatsapp.com/send/?phone=549"+item.proPhone);}},item.proPhone)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,item.init_date?__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_28_moment___default.a.unix(item.init_date)):"No Disponible"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],null,proRoles&&proRoles.map(function(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:r.id,color:"primary"});})),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],{style:isVerified?theme.table.activeCell:theme.overrides.MuiTableCell.body},isVerified?"VERIFICADA":"NO VERIFICADA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],{style:isInactive?theme.overrides.MuiTableCell.body:theme.table.activeCell},isInactive?"INACTIVO":"ACTIVO"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Notificar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.onNotifyUser.bind(_this10,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_Notifications___default.a,null))),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.hasLoyaly==='active'&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cargar puntos"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.rechargeLoyalyPoints.bind(_this10,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__material_ui_icons_StarRateRounded___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Editar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.onEditUser.bind(_this10,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_27__provider_base_Settings___default.a.IS_USER_VERIFIED&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:isVerified?"Anular verficación":"Verificar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.onVerify.bind(_this10,item)},isVerified?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_VerifiedUser___default.a,{style:{fill:"green"}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_26__material_ui_icons_VerifiedUser___default.a,{style:{fill:"red"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:isInactive?"Activar usuario":"Desactivar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.onBlock.bind(_this10,item)},isInactive?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_CheckCircle___default.a,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Block___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:_this10.onDeleteUser.bind(_this10,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Delete___default.a,null)))));});}},{key:"onDeleteRenderTag",value:function onDeleteRenderTag(type,tag){var tags=null;var idx=-1;if(type=="add"){tags=this.state.tagsSelected.slice(0);idx=tags.findIndex(function(t){return t.id==tag.id;});if(idx>=0){tags.splice(idx,1);}this.setState({tagsSelected:tags});}if(type=="filter"){tags=this.state.tagsFilterSelected.slice();idx=tags.findIndex(function(t){return t.id==tag.id;});if(idx>=0){tags.splice(idx,1);}this.setState({tagsFilterSelected:tags});}console.log("ON DELETE RENDER TAG",type,tag,idx);}},{key:"onDeleteRenderRol",value:function onDeleteRenderRol(type,rol){var roles=null;var idx=-1;if(type=="filter"){roles=this.state.rolesFilterSelected.slice();idx=roles.findIndex(function(r){return r.id==rol.id;});if(idx>=0){roles.splice(idx,1);}this.setState({rolesFilterSelected:roles});}}},{key:"renderTags",value:function renderTags(type,tags){var _this11=this;var t=tags&&tags.filter(function(t){return!t.add;});return t&&t.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:tag.tagName,onDelete:_this11.onDeleteRenderTag.bind(_this11,type,tag),avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:tag.tagColor,color:"rgb(0,0,0,0.60"}},tag.tagName.substring(0,1))});});}},{key:"renderRoles",value:function renderRoles(type,roles){var _this12=this;var r=roles&&roles.filter(function(r){return!r.add;});return r&&r.map(function(rol){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:rol.id,onDelete:_this12.onDeleteRenderRol.bind(_this12,type,rol),avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:"black",color:"rgb(255,255,255,0.60"}},rol.id.substring(0,1))});});}},{key:"onChangeDniTransfer",value:function onChangeDniTransfer(evt){this.setState({qntity:evt.target.value,dniError:""});}},{key:"transferPoints",value:function transferPoints(){var _state3=this.state,qntity=_state3.qntity,loyalyUserSelected=_state3.loyalyUserSelected;var proDNI=loyalyUserSelected.proDNI;console.log("proDNIproDNI",proDNI);if(!qntity||isNaN(qntity)){this.setState({dniError:"Debe ser un numero valido"});}else{this.props.actionTransferPoints(qntity*1,proDNI,function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["b" /* SUCCESS */],"Se transfirieron los puntos correctamente.");},function(){__WEBPACK_IMPORTED_MODULE_23__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_23__common_Util__["a" /* ERROR */],"Ocurrió un error al transferir los puntos.");});this.setState({loyalyUserSelected:null,loyalyPopUp:false,qntity:""});}}},{key:"renderDialogLoyaly",value:function renderDialogLoyaly(){var _this13=this;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.loyalyPopUp},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,"Transferir puntos de fidelizacion"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["r" /* FormControl */],{error:this.state.dniError?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["z" /* Input */],{placeholder:"Ingres\xE1 el monto",shrink:true,onChange:this.onChangeDniTransfer,value:this.state.qntity,helperText:this.state.dniError}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["t" /* FormHelperText */],null,this.state.dniError))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this13.setState({loyalyPopUp:null,qntity:"",loyalyUserSelected:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Transferir ticket"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.transferPoints},"Transferir"))));}},{key:"render",value:function render(){var _this14=this;var _props=this.props,theme=_props.theme,userList=_props.userList,rolList=_props.rolList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Usuarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea usuarios")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["j" /* Container */],{style:Object.assign({},theme.table.container,{maxWidth:"100%"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",alignItems:"center",justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de usuarios"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["q" /* Fab */],{onClick:this.onRefresh,size:"small",style:{marginLeft:16,width:34,height:34},color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__material_ui_icons_Sync___default.a,{style:{fontSize:20}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"40%",marginLeft:10,paddingRight:10,marginBottom:16}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_lab_Autocomplete__["b" /* default */],{options:this.state.tags,value:this.state.tagsSelected,getOptionLabel:function getOptionLabel(option){return option.tagName;},filterOptions:function filterOptions(options,params){var filtered=filterTag(options,params);if(params.inputValue!==""){filtered.unshift({inputValue:params.inputValue,tagName:"Agregar \""+params.inputValue+"\""});}return filtered;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],Object.assign({},params,{fullWidth:true,label:"Agregar tags"}));},renderOption:function renderOption(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["E" /* ListItemIcon */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Brightness1___default.a,{style:{color:t.tagColor}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:t.add?"Agregar Tag "+_this14.state.tagText:t.tagName}));},renderTags:this.renderTags.bind(this,"add"),onChange:this.onSelectTag,loadingText:"Cargando tags ...",noOptionsText:"Sin tags",selectOnFocus:true,multiple:true,freeSolo:true,filterSelectedOptions:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Agregar tags a los usuarios seleccionados"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{style:{marginTop:17},onClick:this.onAddTag},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__material_ui_icons_Bookmark___default.a,null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"space-between"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{width:"35%",marginBottom:36}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],null,"Cumplea\xF1os"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["L" /* Select */],{value:this.state.birthmonth,onChange:this.onChangeMonth},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:-1},"Mes"),MONTHS.map(function(m,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:i},m);})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],{value:this.state.birthdateFrom,placeholder:"D\xEDa desde",type:"number",onChange:this.onChangeFrom,style:{width:90,marginLeft:10,marginRight:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],{value:this.state.birthdateTo,placeholder:"D\xEDa hasta",type:"number",onChange:this.onChangeTo,style:{width:90,marginLeft:10,marginRight:10}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.onFilterDate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default.a,null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.onClearBirthdateFilter},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Backspace___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"20%",marginLeft:10,paddingRight:10,marginBottom:36}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_lab_Autocomplete__["b" /* default */],{options:this.state.tags,value:this.state.tagsFilterSelected,getOptionLabel:function getOptionLabel(option){return option.tagName;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],Object.assign({},params,{fullWidth:true,label:"Filtrar por tags"}));},renderOption:function renderOption(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["E" /* ListItemIcon */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__material_ui_icons_Brightness1___default.a,{style:{color:t.tagColor}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:t.tagName}));},renderTags:this.renderTags.bind(this,"filter"),onChange:this.onSelectFilterTag,loadingText:"Cargando tags ...",noOptionsText:"Sin tags",selectOnFocus:true,multiple:true,filterSelectedOptions:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Filtrar los usuarios por tags"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{style:{marginTop:17},onClick:function onClick(){return _this14.onChangePage();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default.a,null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"20%",marginLeft:10,paddingRight:10,marginBottom:36}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_lab_Autocomplete__["b" /* default */],{options:rolList,value:this.state.rolesFilterSelected,getOptionLabel:function getOptionLabel(option){return option.id;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],Object.assign({},params,{fullWidth:true,label:"Filtrar por roles"}));},renderOption:function renderOption(r){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:r.id}));},renderTags:this.renderRoles.bind(this,"filter"),onChange:this.onSelectFilterRol,loadingText:"Cargando roles ...",noOptionsText:"Sin roles",selectOnFocus:true,multiple:true,filterSelectedOptions:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Filtrar los usuarios por roles"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{style:{marginTop:17},onClick:function onClick(){return _this14.onChangePage();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default.a,null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{width:"25%",paddingLeft:10,paddingRight:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["W" /* TextField */],{placeholder:"Buscar",onChange:this.onSearch,helperText:"Filtra por usuario, nombre, apellido, dni o tel\xE9fono"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:{width:"15%",paddingLeft:10,paddingRight:10}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["s" /* FormControlLabel */],{label:"S\xF3lo eliminados",control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:this.state.onlyDeleted,onChange:this.onChangeOnlyDeleted})}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.props.userList.size,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.userForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Usuario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el usuario?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this14.setState({userForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteUser},"Eliminar")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.userForVerify},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,this.state.userVerifyTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["n" /* DialogContentText */],null,this.state.userVerifyContentText)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this14.setState({userForVerify:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:this.state.userVerifyToolTipOk},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmVerifyUser},this.state.userVerifyBtnLabel)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.openAddTag?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,"Agregar tag "+this.state.openAddTag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["n" /* DialogContentText */],null,"Seleccione un color para el tag ",this.state.openAddTag),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ColorField_ColorField__["a" /* default */],{input:{value:this.state.addTagColor,onChange:function onChange(evt){_this14.setState({addTagColor:evt.target.value});}}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"\xBFEs visible el tag en la app?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["L" /* Select */],{value:this.state.isTagVisible,onChange:function onChange(evt){_this14.setState({isTagVisible:evt.target.value});}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:false},"NO")))),this.state.savingTag?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["h" /* CircularProgress */],{style:{margin:30,alignSelf:"center"}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this14.setState({openAddTag:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:this.state.userVerifyToolTipOk},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onSaveTag},"Agregar tag")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["k" /* Dialog */],{open:this.state.tagForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Tag"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el tag"," ",this.state.deleteTagFromAllUsers?"de todos los usuarios":this.state.tagForDelete&&"del usuario "+this.state.tagForDelete.user.proName+" "+this.state.tagForDelete.user.proLastName,"?"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["s" /* FormControlLabel */],{control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:this.state.deleteTagFromAllUsers,onChange:function onChange(evt){_this14.setState({deleteTagFromAllUsers:evt.target.checked});}}),label:"Eliminar tag de todos los usuarios"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this14.setState({tagForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar tag"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteTagFromUser},"Eliminar")))),this.renderDialogLoyaly(),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_24__users_AssignRolToUser__["a" /* default */],{open:this.state.assignRol,onClose:this.onCloseEditUser,user:this.state.userSelected}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_25__users_NotifyUser__["a" /* default */],{open:this.state.notifyUser,onClose:function onClose(){_this14.setState({notifyUser:false});},user:this.state.userSelected})));}}]);return Users;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,authEmail:store.auth.email,userList:store.usr.userList,tagList:store.tag.tagList,rolList:store.rol.rolList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetUsers:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["c" /* actionGetUsers */],actionGetRoles:__WEBPACK_IMPORTED_MODULE_6__actions_RolActions__["b" /* actionGetRoles */],actionDeleteUser:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["b" /* actionDeleteUser */],actionSaveUser:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["g" /* actionSaveUser */],actionGetRolesRedimidores:__WEBPACK_IMPORTED_MODULE_6__actions_RolActions__["c" /* actionGetRolesRedimidores */],actionTransferPoints:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["i" /* actionTransferPoints */],actionSaveTag:__WEBPACK_IMPORTED_MODULE_5__actions_TagActions__["c" /* actionSaveTag */],actionGetTags:__WEBPACK_IMPORTED_MODULE_5__actions_TagActions__["b" /* actionGetTags */],actionSendNotification:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["h" /* actionSendNotification */],actionAddTagsToUsers:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["a" /* actionAddTagsToUsers */],actionDeleteTagFromUser:__WEBPACK_IMPORTED_MODULE_5__actions_TagActions__["a" /* actionDeleteTagFromUser */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Users))));

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__RolConfig__ = __webpack_require__(1484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserService=function(){function UserService(){_classCallCheck(this,UserService);}_createClass(UserService,null,[{key:"getRoles",/******* ROLES **********/value:function getRoles(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].endpointRoles;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;console.log("getRoles",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);reject(_context.t0);case 15:case"end":return _context.stop();}}},_callee,_this,[[0,12]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"getRolesRedimidores",value:function getRolesRedimidores(app){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].endpointRolesRedimidores;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context2.sent;console.log("getRolesRedimidores",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=15;break;case 12:_context2.prev=12;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 15:case"end":return _context2.stop();}}},_callee2,_this2,[[0,12]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"saveRol",value:function saveRol(app,rol){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;console.log("SERVICE SAVE ROL",rol);_context3.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].endpointSaveRol;console.log("ENDPOINT SAVE ROL",endpoint);_context3.next=9;return __WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(rol)});case 9:response=_context3.sent;console.log("saveRol",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=17;break;case 14:_context3.prev=14;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 17:case"end":return _context3.stop();}}},_callee3,_this3,[[0,14]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}},{key:"deleteRol",value:function deleteRol(app,rol){var _this4=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;console.log("SERVICE DELETE ROL",rol);_context4.next=4;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 4:token=_context4.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].endpointDeleteRol;console.log("ENDPOINT DELETE ROL",endpoint);_context4.next=9;return __WEBPACK_IMPORTED_MODULE_1__RolConfig__["a" /* default */].APIConnector.delete(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(rol)});case 9:response=_context4.sent;console.log("deleteRol",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context4.next=17;break;case 14:_context4.prev=14;_context4.t0=_context4["catch"](0);reject(_context4.t0);case 17:case"end":return _context4.stop();}}},_callee4,_this4,[[0,14]]);}));return function(_x7,_x8){return _ref4.apply(this,arguments);};}());}/******** FIN ROLES *********/}]);return UserService;}();/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var RolConfig=function(){function RolConfig(){_classCallCheck(this,RolConfig);}_createClass(RolConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointRoles",get:function get(){return RolConfig.endpoint+"/roles";}},{key:"endpointSaveRol",get:function get(){return RolConfig.endpointRoles+"/save";}},{key:"endpointRolesRedimidores",get:function get(){return RolConfig.endpointRoles+"/redimidores";}},{key:"endpointDeleteRol",get:function get(){return RolConfig.endpointRoles+"/delete";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return RolConfig;}();/* harmony default export */ __webpack_exports__["a"] = (RolConfig);

/***/ }),
/* 1485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z"
}), 'Backspace');

exports.default = _default;

/***/ }),
/* 1486 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement(_react.default.Fragment, null, _react.default.createElement("path", {
  transform: "scale(1.33, 1.33)",
  fill: "none",
  d: "M0 0h18v18H0V0z"
}), _react.default.createElement("path", {
  transform: "scale(1.33, 1.33)",
  d: "M9 11.3l2.46 1.79c.39.29.92-.1.77-.56l-.94-2.89 2.43-1.73c.4-.28.2-.91-.29-.91h-2.98l-.97-3.02c-.15-.46-.8-.46-.95 0L7.55 7H4.57c-.49 0-.69.63-.29.91l2.43 1.73-.94 2.89c-.15.46.38.84.77.56L9 11.3z"
})), 'StarRateRounded');

exports.default = _default;

/***/ }),
/* 1487 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z"
}), 'Bookmark');

exports.default = _default;

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_lab__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ChipRedimidor_ChipRedimidor__ = __webpack_require__(1509);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var AssignRolToUser=function(_React$PureComponent){_inherits(AssignRolToUser,_React$PureComponent);function AssignRolToUser(props){_classCallCheck(this,AssignRolToUser);var _this=_possibleConstructorReturn(this,(AssignRolToUser.__proto__||Object.getPrototypeOf(AssignRolToUser)).call(this,props));_this.onSave=_this.onSave.bind(_this);_this.renderFieldByRol=_this.renderFieldByRol.bind(_this);_this.onChangeRolRedimidorAutocomplete=_this.onChangeRolRedimidorAutocomplete.bind(_this);_this.onChangeRolAutocomplete=_this.onChangeRolAutocomplete.bind(_this);_this.onDeleteRolRedimidorChip=_this.onDeleteRolRedimidorChip.bind(_this);_this.onDeleteRolChip=_this.onDeleteRolChip.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(AssignRolToUser,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.user!=nextProps.user){var proRolesRedimidor=[];//Se graba en la base cómo objeto y se usa en la pantalla cómo lista
if(nextProps.user.proRolesRedimidor){for(var k in nextProps.user.proRolesRedimidor){proRolesRedimidor.push(Object.assign({},nextProps.user.proRolesRedimidor[k],{id:k}));}}console.log("PRO ROLES REDIMIDOR",proRolesRedimidor,nextProps.user.proRolesRedimidor);this.props.initialize(Object.assign({proRoles:[]},nextProps.user,{proRolesRedimidor:proRolesRedimidor}));}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onSave",value:function onSave(formValue){var _this2=this;var user=Object.assign({},formValue);var proRolesRedimidor={};if(user.proRolesRedimidor){//Se graba en la base cómo objeto y se usa en la pantalla cómo lista
for(var i=0;i<user.proRolesRedimidor.length;i++){var pr=user.proRolesRedimidor[i];var id=pr.id;delete pr.id;console.log("ID",id);proRolesRedimidor[id]=pr;}console.log("user.proRolesRedimidor",proRolesRedimidor,user.proRolesRedimidor);user.proRolesRedimidor=proRolesRedimidor;}this.props.actionSaveUser(user,function(){__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_10__common_Util__["b" /* SUCCESS */],"Se asignaron los roles correctamente");_this2.props.onClose(__WEBPACK_IMPORTED_MODULE_10__common_Util__["b" /* SUCCESS */]);},function(e){if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_10__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_10__common_Util__["a" /* ERROR */],"No se pudieron asignar los roles");});}},{key:"onChangeRolRedimidorAutocomplete",value:function onChangeRolRedimidorAutocomplete(evt,newValue){if(newValue){var exist=this.props.proRolesRedimidor.some(function(t){return t.id==newValue.id;});if(!exist){var t=this.props.proRolesRedimidor.slice(0);t.push(newValue);this.props.change("proRolesRedimidor",t);}}}},{key:"onChangeRolAutocomplete",value:function onChangeRolAutocomplete(evt,newValue){if(newValue){var exist=this.props.roles.some(function(r){return r.id==newValue.id;});// console.log("ON CHANGE AutoCOMPLETE", newValue, this.props.roles, exist)
if(!exist){var r=this.props.roles.slice(0);r.push(newValue);this.props.change("proRoles",r);}}}},{key:"onDeleteRolRedimidorChip",value:function onDeleteRolRedimidorChip(item){var nt=this.props.proRolesRedimidor.filter(function(t){return t.id!=item.id;});this.props.change("proRolesRedimidor",nt);}},{key:"onDeleteRolChip",value:function onDeleteRolChip(item){var nr=this.props.roles.filter(function(r){return r.id!=item.id;});this.props.change("proRoles",nr);}},{key:"renderFieldByRol",value:function renderFieldByRol(){var _this3=this;// console.log("ROL", this.props.roles)
if(this.props.roles&&this.props.roles.some(function(r){return r.id=="Redimidor";})){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{container:true,item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["B" /* InputLabel */],{shrink:true},"Seleccione los roles de redimidor del usuario"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_lab__["a" /* Autocomplete */],{autoComplete:true,options:this.props.rolesRedimidoresList,getOptionLabel:function getOptionLabel(option){return option.rolName;},onChange:this.onChangeRolRedimidorAutocomplete,renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{className:"top10"},this.props.proRolesRedimidor.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_ChipRedimidor_ChipRedimidor__["a" /* default */],{key:"chip"+i,rolRedimidor:item// color="primary" 
//             label={item.rolName}
,onDelete:function onDelete(){_this3.onDeleteRolRedimidorChip(item);}});})));}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{container:true,item:true,xs:12});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,theme=_props.theme,open=_props.open,rolList=_props.rolList,handleSubmit=_props.handleSubmit,onClose=_props.onClose;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1",color:"primary"},"Asignar rol a usuario")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],{style:{minWidth:500}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{container:true,spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["TextField"],name:"proEmail",label:"e-mail",fullWidth:true,disabled:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["B" /* InputLabel */],{shrink:true},"Rol"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_lab__["a" /* Autocomplete */],{autoComplete:true,options:this.props.rolList,getOptionLabel:function getOptionLabel(option){return option.id;},onChange:this.onChangeRolAutocomplete,renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true}));}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{className:"top10"},this.props.roles&&this.props.roles.map(function(item,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["g" /* Chip */],{key:"chip"+i,color:"primary",label:item.id,onDelete:function onDelete(){_this4.onDeleteRolChip(item);}});}))),this.renderFieldByRol()))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:onClose},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:handleSubmit(this.onSave)},"Guardar"))));}}]);return AssignRolToUser;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,rolList:store.rol.rolList,rolesRedimidoresList:store.rol.rolesRedimidoresList,roles:store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRoles,proRolesRedimidor:store.form&&store.form.assignRolToUser&&store.form.assignRolToUser.values.proRolesRedimidor};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionSaveUser:__WEBPACK_IMPORTED_MODULE_9__actions_UserActions__["g" /* actionSaveUser */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["c" /* reduxForm */])({form:"assignRolToUser",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AssignRolToUser))));

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_utils__ = __webpack_require__(1490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_Star__ = __webpack_require__(1498);










function clamp(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

function getDecimalPrecision(num) {
  var decimalPart = num.toString().split('.')[1];
  return decimalPart ? decimalPart.length : 0;
}

function roundValueToPrecision(value, precision) {
  var nearest = Math.round(value / precision) * precision;
  return Number(nearest.toFixed(getDecimalPrecision(precision)));
}

var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'inline-flex',
      position: 'relative',
      fontSize: theme.typography.pxToRem(24),
      color: '#ffb400',
      cursor: 'pointer',
      WebkitTapHighlightColor: 'transparent',
      '&$disabled': {
        opacity: 0.5,
        pointerEvents: 'none'
      },
      '&$focusVisible $iconActive': {
        outline: '1px solid #999'
      }
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      fontSize: theme.typography.pxToRem(18)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      fontSize: theme.typography.pxToRem(30)
    },

    /* Styles applied to the root element if `readOnly={true}`. */
    readOnly: {
      pointerEvents: 'none'
    },

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Visually hide an element. */
    visuallyhidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      color: '#000',
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1
    },

    /* Styles applied to the pristine label. */
    pristine: {
      'input:focus ~ &': {
        top: 0,
        bottom: 0,
        position: 'absolute',
        outline: '1px solid #999',
        width: '100%'
      }
    },

    /* Styles applied to the label elements. */
    label: {
      cursor: 'inherit'
    },

    /* Styles applied to the icon wrapping elements. */
    icon: {
      display: 'flex',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shortest
      })
    },

    /* Styles applied to the icon wrapping elements when empty. */
    iconEmpty: {
      color: theme.palette.action.disabled
    },

    /* Styles applied to the icon wrapping elements when filled. */
    iconFilled: {},

    /* Styles applied to the icon wrapping elements when hover. */
    iconHover: {},

    /* Styles applied to the icon wrapping elements when focus. */
    iconFocus: {},

    /* Styles applied to the icon wrapping elements when active. */
    iconActive: {
      transform: 'scale(1.2)'
    },

    /* Styles applied to the icon wrapping elements when decimals are necessary. */
    decimal: {
      position: 'relative'
    }
  };
};

function IconContainer(props) {
  var value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["value"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", other);
}

 false ? IconContainer.propTypes = {
  value: PropTypes.number.isRequired
} : void 0;
var defaultIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__internal_svg_icons_Star__["a" /* default */], {
  fontSize: "inherit"
});

function defaultLabelText(value) {
  return "".concat(value, " Star").concat(value !== 1 ? 's' : '');
}

var Rating = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Rating(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      emptyIcon = props.emptyIcon,
      _props$getLabelText = props.getLabelText,
      getLabelText = _props$getLabelText === void 0 ? defaultLabelText : _props$getLabelText,
      _props$icon = props.icon,
      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
      _props$IconContainerC = props.IconContainerComponent,
      IconContainerComponent = _props$IconContainerC === void 0 ? IconContainer : _props$IconContainerC,
      _props$max = props.max,
      max = _props$max === void 0 ? 5 : _props$max,
      nameProp = props.name,
      onChange = props.onChange,
      onChangeActive = props.onChangeActive,
      onMouseLeave = props.onMouseLeave,
      onMouseMove = props.onMouseMove,
      _props$precision = props.precision,
      precision = _props$precision === void 0 ? 1 : _props$precision,
      _props$readOnly = props.readOnly,
      readOnly = _props$readOnly === void 0 ? false : _props$readOnly,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$value = props.value,
      valueProp2 = _props$value === void 0 ? null : _props$value,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "disabled", "emptyIcon", "getLabelText", "icon", "IconContainerComponent", "max", "name", "onChange", "onChangeActive", "onMouseLeave", "onMouseMove", "precision", "readOnly", "size", "value"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(),
      defaultName = _React$useState[0],
      setDefaultName = _React$useState[1];

  var name = nameProp || defaultName;
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    // Fallback to this default id when possible.
    // Use the random value for client-side rendering only.
    // We can't use it server-side.
    setDefaultName("mui-rating-".concat(Math.round(Math.random() * 1e5)));
  }, []);
  var valueProp = roundValueToPrecision(valueProp2, precision);
  var theme = Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["f" /* useTheme */])();

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState({
    hover: -1,
    focus: -1
  }),
      _React$useState2$ = _React$useState2[0],
      hover = _React$useState2$.hover,
      focus = _React$useState2$.focus,
      setState = _React$useState2[1];

  var value = valueProp;

  if (hover !== -1) {
    value = hover;
  }

  if (focus !== -1) {
    value = focus;
  }

  var _useIsFocusVisible = Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__["f" /* useIsFocusVisible */])(),
      isFocusVisible = _useIsFocusVisible.isFocusVisible,
      onBlurVisible = _useIsFocusVisible.onBlurVisible,
      focusVisibleRef = _useIsFocusVisible.ref;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(false),
      focusVisible = _React$useState3[0],
      setFocusVisible = _React$useState3[1];

  var rootRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  var handleFocusRef = Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__["e" /* useForkRef */])(focusVisibleRef, rootRef);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__["e" /* useForkRef */])(handleFocusRef, ref);

  var handleMouseMove = function handleMouseMove(event) {
    if (onMouseMove) {
      onMouseMove(event);
    }

    var rootNode = rootRef.current;

    var _rootNode$getBounding = rootNode.getBoundingClientRect(),
        right = _rootNode$getBounding.right,
        left = _rootNode$getBounding.left;

    var _rootNode$firstChild$ = rootNode.firstChild.getBoundingClientRect(),
        width = _rootNode$firstChild$.width;

    var percent;

    if (theme.direction === 'rtl') {
      percent = (right - event.clientX) / (width * max);
    } else {
      percent = (event.clientX - left) / (width * max);
    }

    var newHover = roundValueToPrecision(max * percent + precision / 2, precision);
    newHover = clamp(newHover, precision, max);
    setState(function (prev) {
      return prev.hover === newHover && prev.focus === newHover ? prev : {
        hover: newHover,
        focus: newHover
      };
    });
    setFocusVisible(false);

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleMouseLeave = function handleMouseLeave(event) {
    if (onMouseLeave) {
      onMouseLeave(event);
    }

    var newHover = -1;
    setState({
      hover: newHover,
      focus: newHover
    });

    if (onChangeActive && hover !== newHover) {
      onChangeActive(event, newHover);
    }
  };

  var handleChange = function handleChange(event) {
    if (onChange) {
      onChange(event, parseFloat(event.target.value));
    }
  };

  var handleFocus = function handleFocus(event) {
    if (isFocusVisible(event)) {
      setFocusVisible(true);
    }

    var newFocus = parseFloat(event.target.value);
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var handleBlur = function handleBlur(event) {
    if (hover !== -1) {
      return;
    }

    if (focusVisible !== false) {
      setFocusVisible(false);
      onBlurVisible();
    }

    var newFocus = -1;
    setState(function (prev) {
      return {
        hover: prev.hover,
        focus: newFocus
      };
    });

    if (onChangeActive && focus !== newFocus) {
      onChangeActive(event, newFocus);
    }
  };

  var item = function item(propsItem, state) {
    var id = "".concat(name, "-").concat(String(propsItem.value).replace('.', '-'));
    var container = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(IconContainerComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propsItem, {
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, state.filled ? classes.iconFilled : classes.iconEmpty, state.hover && classes.iconHover, state.focus && classes.iconFocus, state.active && classes.iconActive)
    }), emptyIcon && !state.filled ? emptyIcon : icon);

    if (readOnly || disabled) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, {
        key: propsItem.value
      }, container);
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, {
      key: propsItem.value
    }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
      className: classes.label,
      htmlFor: id
    }, container, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      className: classes.visuallyhidden
    }, getLabelText(propsItem.value))), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
      onFocus: handleFocus,
      onBlur: handleBlur,
      onChange: handleChange,
      value: propsItem.value,
      id: id,
      type: "radio",
      name: name,
      checked: state.checked,
      className: classes.visuallyhidden
    }));
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: handleRef,
    onMouseMove: handleMouseMove,
    onMouseLeave: handleMouseLeave,
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__["a" /* capitalize */])(size))], disabled && classes.disabled, focusVisible && classes.focusVisible, readOnly && classes.readOnly),
    role: readOnly ? 'img' : null,
    "aria-label": readOnly ? getLabelText(value) : null
  }, other), !readOnly && !disabled && value == null && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Fragment, null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("input", {
    value: "0",
    id: "".concat(name, "-0"),
    type: "radio",
    name: name,
    defaultChecked: true,
    className: classes.visuallyhidden
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("label", {
    htmlFor: "".concat(name, "-0"),
    className: classes.pristine
  }, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.visuallyhidden
  }, getLabelText(0)))), Array.from(new Array(max)).map(function (_, index) {
    var itemValue = index + 1;

    if (precision < 1) {
      var items = Array.from(new Array(1 / precision));
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
        key: itemValue,
        className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.decimal, itemValue === Math.ceil(value) && (hover !== -1 || focus !== -1) && classes.iconActive)
      }, items.map(function ($, indexDecimal) {
        var itemDecimalValue = roundValueToPrecision(itemValue - 1 + (indexDecimal + 1) * precision, precision);
        return item({
          value: itemDecimalValue,
          style: items.length - 1 === indexDecimal ? {} : {
            width: itemDecimalValue === value ? "".concat((indexDecimal + 1) * precision * 100, "%") : '0%',
            overflow: 'hidden',
            zIndex: 1,
            position: 'absolute'
          }
        }, {
          filled: itemDecimalValue <= value,
          hover: itemDecimalValue <= hover,
          focus: itemDecimalValue <= focus,
          checked: itemDecimalValue === valueProp
        });
      }));
    }

    return item({
      value: itemValue
    }, {
      active: itemValue === value && (hover !== -1 || focus !== -1),
      filled: itemValue <= value,
      hover: itemValue <= hover,
      focus: itemValue <= focus,
      checked: itemValue === valueProp
    });
  }));
});
 false ? Rating.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the rating will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The icon to display when empty.
   */
  emptyIcon: PropTypes.node,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the rating.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {number} value The rating label's value to format.
   * @returns {string}
   */
  getLabelText: PropTypes.func,

  /**
   * The icon to display.
   */
  icon: PropTypes.node,

  /**
   * The component containing the icon.
   */
  IconContainerComponent: PropTypes.elementType,

  /**
   * Maximum rating.
   */
  max: PropTypes.number,

  /**
   * The name attribute of the radio `input` elements.
   * If `readOnly` is false, the prop is required,
   * this input name`should be unique within the parent form.
   */
  name: chainPropTypes(PropTypes.string, function (props) {
    if (!props.readOnly && !props.name) {
      return new Error(['Material-UI: the prop `name` is required (when `readOnly` is false).', 'Additionally, the input name should be unique within the parent form.'].join('\n'));
    }

    return null;
  }),

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChange: PropTypes.func,

  /**
   * Callback function that is fired when the hover state changes.
   *
   * @param {object} event The event source of the callback.
   * @param {number} value The new value.
   */
  onChangeActive: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * @ignore
   */
  onMouseMove: PropTypes.func,

  /**
   * The minimum increment value change allowed.
   */
  precision: PropTypes.number,

  /**
   * Removes all hover effects and pointer events.
   */
  readOnly: PropTypes.bool,

  /**
   * The size of the rating.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The rating value.
   */
  value: PropTypes.number
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiRating'
})(Rating));

/***/ }),
/* 1490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__chainPropTypes__ = __webpack_require__(299);
/* unused harmony reexport chainPropTypes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__deepmerge__ = __webpack_require__(1491);
/* unused harmony reexport deepmerge */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__elementAcceptingRef__ = __webpack_require__(1492);
/* unused harmony reexport elementAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__elementTypeAcceptingRef__ = __webpack_require__(1493);
/* unused harmony reexport elementTypeAcceptingRef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__exactProp__ = __webpack_require__(1494);
/* unused harmony reexport exactProp */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__getDisplayName__ = __webpack_require__(1495);
/* unused harmony reexport getDisplayName */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ponyfillGlobal__ = __webpack_require__(1496);
/* unused harmony reexport ponyfillGlobal */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__refType__ = __webpack_require__(1497);
/* unused harmony reexport refType */
/** @license Material-UI v4.7.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */









/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isObject */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);


function isObject(item) {
  return item && Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_typeof__["a" /* default */])(item) === 'object' && !Array.isArray(item);
}
function deepmerge(target, source) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
    clone: true
  };
  var output = options.clone ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, target) : target;

  if (isObject(target) && isObject(source)) {
    Object.keys(source).forEach(function (key) {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isObject(source[key]) && key in target) {
        output[key] = deepmerge(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(299);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function acceptingRef(props, propName, componentName, location, propFullName) {
  var element = props[propName];
  var safePropName = propFullName || propName;

  if (element == null) {
    return null;
  }

  var warningHint;
  var elementType = element.type;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
    warningHint = 'Did you accidentally use a plain function component for an element instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

var elementAcceptingRef = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element, acceptingRef);
elementAcceptingRef.isRequired = Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.element.isRequired, acceptingRef);
/* unused harmony default export */ var _unused_webpack_default_export = (elementAcceptingRef);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__chainPropTypes__ = __webpack_require__(299);



function isClassComponent(elementType) {
  // elementType.prototype?.isReactComponent
  var _elementType$prototyp = elementType.prototype,
      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
  return Boolean(prototype.isReactComponent);
}

function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
  var propValue = props[propName];
  var safePropName = propFullName || propName;

  if (propValue == null) {
    return null;
  }

  var warningHint;
  /**
   * Blacklisting instead of whitelisting
   *
   * Blacklisting will miss some components, such as React.Fragment. Those will at least
   * trigger a warning in React.
   * We can't whitelist because there is no safe way to detect React.forwardRef
   * or class components. "Safe" means there's no public API.
   *
   */

  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
    warningHint = 'Did you accidentally provide a plain function component instead?';
  }

  if (warningHint !== undefined) {
    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
  }

  return null;
}

/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_1__chainPropTypes__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_prop_types__["elementType"], elementTypeAcceptingRef));

/***/ }),
/* 1494 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export specialProperty */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);


// This module is based on https://github.com/airbnb/prop-types-exact repository.
// However, in order to reduce the number of dependencies and to remove some extra safe checks
// the module was forked.
// Only exported for test purposes.
var specialProperty = "exact-prop: \u200B";
function exactProp(propTypes) {
  if (true) {
    return propTypes;
  }

  return Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, propTypes, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_defineProperty__["a" /* default */])({}, specialProperty, function (props) {
    var unsupportedProps = Object.keys(props).filter(function (prop) {
      return !propTypes.hasOwnProperty(prop);
    });

    if (unsupportedProps.length > 0) {
      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
        return "`".concat(prop, "`");
      }).join(', '), ". Please remove them."));
    }

    return null;
  }));
}

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getFunctionName */
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_is__);

 // Simplified polyfill for IE 11 support
// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  var match = "".concat(fn).match(fnNameMatchRegex);
  var name = match && match[1];
  return name || '';
}
/**
 * @param {function} Component
 * @param {string} fallback
 * @returns {string | undefined}
 */

function getFunctionComponentName(Component) {
  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  var functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE 11 support
 *
 * @param {React.ReactType} Component
 * @returns {string | undefined}
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_typeof__["a" /* default */])(Component) === 'object') {
    switch (Component.$$typeof) {
      case __WEBPACK_IMPORTED_MODULE_1_react_is__["ForwardRef"]:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      default:
        return undefined;
    }
  }

  return undefined;
}

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
/* unused harmony default export */ var _unused_webpack_default_export = (typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')());

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var refType = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object]);
/* unused harmony default export */ var _unused_webpack_default_export = (refType);

/***/ }),
/* 1498 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(212);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
}), 'Star'));

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(13);






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'block',
      backgroundColor: theme.palette.action.hover,
      height: '1.2em'
    },

    /* Styles applied to the root element if `variant="text"`. */
    text: {
      marginTop: 0,
      marginBottom: 0,
      height: 'auto',
      transformOrigin: '0 60%',
      transform: 'scale(1, 0.60)',
      borderRadius: theme.shape.borderRadius,
      '&:empty:before': {
        content: '"\\00a0"'
      }
    },

    /* Styles applied to the root element if `variant="rect"`. */
    rect: {},

    /* Styles applied to the root element if `variant="circle"`. */
    circle: {
      borderRadius: '50%'
    },

    /* Styles applied to the root element if `disabledAnimate={false}`. */
    animate: {
      animation: '$animate 1.5s ease-in-out infinite'
    },
    '@keyframes animate': {
      '0%': {
        opacity: 1
      },
      '50%': {
        opacity: 0.4
      },
      '100%': {
        opacity: 1
      }
    }
  };
};
var Skeleton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function Skeleton(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$component = props.component,
      Component = _props$component === void 0 ? 'div' : _props$component,
      _props$disableAnimate = props.disableAnimate,
      disableAnimate = _props$disableAnimate === void 0 ? false : _props$disableAnimate,
      height = props.height,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      width = props.width,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "component", "disableAnimate", "height", "variant", "width"]);

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    ref: ref,
    className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, classes[variant], className, !disableAnimate && classes.animate)
  }, other, {
    style: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      width: width,
      height: height
    }, other.style)
  }));
});
 false ? Skeleton.propTypes = {
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.elementType,

  /**
   * If `true` the animation effect is disabled.
   */
  disableAnimate: PropTypes.bool,

  /**
   * Height of the skeleton.
   * Useful when you don't want to adapt the skeleton to a text element but for instance a card.
   */
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),

  /**
   * The type of content that will be rendered.
   */
  variant: PropTypes.oneOf(['text', 'rect', 'circle']),

  /**
   * Width of the skeleton.
   * Useful when the skeleton is inside an inline element with no width of its own.
   */
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiSkeleton'
})(Skeleton));

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Zoom__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_Fab__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__ = __webpack_require__(99);











function getOrientation(direction) {
  if (direction === 'up' || direction === 'down') {
    return 'vertical';
  }

  if (direction === 'right' || direction === 'left') {
    return 'horizontal';
  }

  return undefined;
}

function clamp(value, min, max) {
  if (value < min) {
    return min;
  }

  if (value > max) {
    return max;
  }

  return value;
}

var dialRadius = 32;
var spacingActions = 16;
var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      zIndex: theme.zIndex.speedDial,
      display: 'flex',
      alignItems: 'center',
      pointerEvents: 'none'
    },

    /* Styles applied to the Fab component. */
    fab: {
      pointerEvents: 'auto'
    },

    /* Styles applied to the root if direction="up" */
    directionUp: {
      flexDirection: 'column-reverse',
      '& $actions': {
        flexDirection: 'column-reverse',
        marginBottom: -dialRadius,
        paddingBottom: spacingActions + dialRadius
      }
    },

    /* Styles applied to the root if direction="down" */
    directionDown: {
      flexDirection: 'column',
      '& $actions': {
        flexDirection: 'column',
        marginTop: -dialRadius,
        paddingTop: spacingActions + dialRadius
      }
    },

    /* Styles applied to the root if direction="left" */
    directionLeft: {
      flexDirection: 'row-reverse',
      '& $actions': {
        flexDirection: 'row-reverse',
        marginRight: -dialRadius,
        paddingRight: spacingActions + dialRadius
      }
    },

    /* Styles applied to the root if direction="right" */
    directionRight: {
      flexDirection: 'row',
      '& $actions': {
        flexDirection: 'row',
        marginLeft: -dialRadius,
        paddingLeft: spacingActions + dialRadius
      }
    },

    /* Styles applied to the actions (`children` wrapper) element. */
    actions: {
      display: 'flex',
      pointerEvents: 'auto'
    },

    /* Styles applied to the actions (`children` wrapper) element if `open={false}`. */
    actionsClosed: {
      transition: 'top 0s linear 0.2s',
      pointerEvents: 'none'
    }
  };
};
var SpeedDial = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SpeedDial(props, ref) {
  var ariaLabel = props.ariaLabel,
      _props$FabProps = props.FabProps;
  _props$FabProps = _props$FabProps === void 0 ? {} : _props$FabProps;

  var origDialButtonRef = _props$FabProps.ref,
      FabProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_props$FabProps, ["ref"]),
      childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$direction = props.direction,
      direction = _props$direction === void 0 ? 'up' : _props$direction,
      _props$hidden = props.hidden,
      hidden = _props$hidden === void 0 ? false : _props$hidden,
      icon = props.icon,
      onBlur = props.onBlur,
      onClose = props.onClose,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      onMouseEnter = props.onMouseEnter,
      onMouseLeave = props.onMouseLeave,
      onOpen = props.onOpen,
      open = props.open,
      openIcon = props.openIcon,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Zoom__["a" /* default */] : _props$TransitionComp,
      _props$transitionDura = props.transitionDuration,
      transitionDuration = _props$transitionDura === void 0 ? {
    enter: __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["c" /* duration */].enteringScreen,
    exit: __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["c" /* duration */].leavingScreen
  } : _props$transitionDura,
      TransitionProps = props.TransitionProps,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["ariaLabel", "FabProps", "children", "classes", "className", "direction", "hidden", "icon", "onBlur", "onClose", "onFocus", "onKeyDown", "onMouseEnter", "onMouseLeave", "onOpen", "open", "openIcon", "TransitionComponent", "transitionDuration", "TransitionProps"]);

  var eventTimer = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    return function () {
      clearTimeout(eventTimer.current);
    };
  }, []);
  /**
   * an index in actions.current
   */

  var focusedAction = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(0);
  /**
   * pressing this key while the focus is on a child SpeedDialAction focuses
   * the next SpeedDialAction.
   * It is equal to the first arrow key pressed while focus is on the SpeedDial
   * that is not orthogonal to the direction.
   * @type {utils.ArrowKey?}
   */

  var nextItemArrowKey = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef();
  /**
   * refs to the Button that have an action associated to them in this SpeedDial
   * [Fab, ...(SpeedDialActions > Button)]
   * @type {HTMLButtonElement[]}
   */

  var actions = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef([]);
  actions.current = [actions.current[0]];
  var handleOwnFabRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useCallback(function (fabFef) {
    actions.current[0] = fabFef;
  }, []);
  var handleFabRef = Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__["e" /* useForkRef */])(origDialButtonRef, handleOwnFabRef);
  /**
   * creates a ref callback for the Button in a SpeedDialAction
   * Is called before the original ref callback for Button that was set in buttonProps
   *
   * @param dialActionIndex {number}
   * @param origButtonRef {React.RefObject?}
   */

  var createHandleSpeedDialActionButtonRef = function createHandleSpeedDialActionButtonRef(dialActionIndex, origButtonRef) {
    return function (buttonRef) {
      actions.current[dialActionIndex + 1] = buttonRef;

      if (origButtonRef) {
        origButtonRef(buttonRef);
      }
    };
  };

  var handleKeyDown = function handleKeyDown(event) {
    if (onKeyDown) {
      onKeyDown(event);
    }

    var key = event.key.replace('Arrow', '').toLowerCase();
    var _nextItemArrowKey$cur = nextItemArrowKey.current,
        nextItemArrowKeyCurrent = _nextItemArrowKey$cur === void 0 ? key : _nextItemArrowKey$cur;

    if (event.key === 'Escape') {
      if (onClose) {
        actions.current[0].focus();
        onClose(event, 'escapeKeyDown');
      }

      return;
    }

    if (getOrientation(key) === getOrientation(nextItemArrowKeyCurrent) && getOrientation(key) !== undefined) {
      event.preventDefault();
      var actionStep = key === nextItemArrowKeyCurrent ? 1 : -1; // stay within array indices

      var nextAction = clamp(focusedAction.current + actionStep, 0, actions.current.length - 1);
      actions.current[nextAction].focus();
      focusedAction.current = nextAction;
      nextItemArrowKey.current = nextItemArrowKeyCurrent;
    }
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    // actions were closed while navigation state was not reset
    if (!open) {
      focusedAction.current = 0;
      nextItemArrowKey.current = undefined;
    }
  }, [open]);

  var handleClose = function handleClose(event) {
    if (event.type === 'mouseleave' && onMouseLeave) {
      onMouseLeave(event);
    }

    if (event.type === 'blur' && onBlur) {
      onBlur(event);
    }

    clearTimeout(eventTimer.current);

    if (onClose) {
      if (event.type === 'blur') {
        event.persist();
        eventTimer.current = setTimeout(function () {
          onClose(event, 'blur');
        });
      } else {
        onClose(event, 'mouseLeave');
      }
    }
  };

  var handleClick = function handleClick(event) {
    if (FabProps.onClick) {
      FabProps.onClick(event);
    }

    clearTimeout(eventTimer.current);

    if (open) {
      if (onClose) {
        onClose(event, 'toggle');
      }
    } else if (onOpen) {
      onOpen(event, 'toggle');
    }
  };

  var handleOpen = function handleOpen(event) {
    if (event.type === 'mouseenter' && onMouseEnter) {
      onMouseEnter(event);
    }

    if (event.type === 'focus' && onFocus) {
      onFocus(event);
    } // When moving the focus between two items,
    // a chain if blur and focus event is triggered.
    // We only handle the last event.


    clearTimeout(eventTimer.current);

    if (onOpen && !open) {
      event.persist(); // Wait for a future focus or click event

      eventTimer.current = setTimeout(function () {
        var eventMap = {
          focus: 'focus',
          mouseenter: 'mouseEnter'
        };
        onOpen(event, eventMap[event.type]);
      });
    }
  }; // Filter the label for valid id characters.


  var id = ariaLabel.replace(/^[^a-z]+|[^\w:.-]+/gi, '');
  var allItems = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.toArray(childrenProp).filter(function (child) {
    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: the SpeedDial component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(child);
  });
  var children = allItems.map(function (child, index) {
    var _child$props$FabProps = child.props.FabProps;
    _child$props$FabProps = _child$props$FabProps === void 0 ? {} : _child$props$FabProps;

    var origButtonRef = _child$props$FabProps.ref,
        ChildFabProps = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(_child$props$FabProps, ["ref"]);

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(child, {
      FabProps: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ChildFabProps, {
        ref: createHandleSpeedDialActionButtonRef(index, origButtonRef)
      }),
      delay: 30 * (open ? index : allItems.length - index),
      open: open,
      id: "".concat(id, "-action-").concat(index)
    });
  });
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, classes["direction".concat(Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__["a" /* capitalize */])(direction))], className),
    ref: ref,
    role: "presentation",
    onKeyDown: handleKeyDown,
    onBlur: handleClose,
    onFocus: handleOpen,
    onMouseEnter: handleOpen,
    onMouseLeave: handleClose
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TransitionComponent, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    in: !hidden,
    timeout: transitionDuration,
    unmountOnExit: true
  }, TransitionProps), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_Fab__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    color: "primary",
    "aria-label": ariaLabel,
    "aria-haspopup": "true",
    "aria-expanded": open,
    "aria-controls": "".concat(id, "-actions")
  }, FabProps, {
    onClick: handleClick,
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.fab, FabProps.className),
    ref: handleFabRef
  }), __WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(icon) && Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__["b" /* isMuiElement */])(icon, ['SpeedDialIcon']) ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(icon, {
    open: open
  }) : icon)), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    id: "".concat(id, "-actions"),
    role: "menu",
    "aria-orientation": getOrientation(direction),
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.actions, !open && classes.actionsClosed)
  }, children));
});
 false ? SpeedDial.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The aria-label of the button element.
   * Also used to provide the `id` for the `SpeedDial` element and its children.
   */
  ariaLabel: PropTypes.string.isRequired,

  /**
   * SpeedDialActions to display when the SpeedDial is `open`.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The direction the actions open relative to the floating action button.
   */
  direction: PropTypes.oneOf(['down', 'left', 'right', 'up']),

  /**
   * Props applied to the [`Fab`](/api/fab/) element.
   */
  FabProps: PropTypes.object,

  /**
   * If `true`, the SpeedDial will be hidden.
   */
  hidden: PropTypes.bool,

  /**
   * The icon to display in the SpeedDial Fab. The `SpeedDialIcon` component
   * provides a default Icon with animation.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  onBlur: PropTypes.func,

  /**
   * Callback fired when the component requests to be closed.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"toggle"`, `"blur"`, `"mouseLeave"`, `"escapeKeyDown"`.
   */
  onClose: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * @ignore
   */
  onMouseEnter: PropTypes.func,

  /**
   * @ignore
   */
  onMouseLeave: PropTypes.func,

  /**
   * Callback fired when the component requests to be open.
   *
   * @param {object} event The event source of the callback.
   * @param {string} reason Can be:`"toggle"`, `"focus"`, `"mouseEnter"`.
   */
  onOpen: PropTypes.func,

  /**
   * If `true`, the SpeedDial is open.
   */
  open: PropTypes.bool.isRequired,

  /**
   * The icon to display in the SpeedDial Fab when the SpeedDial is open.
   */
  openIcon: PropTypes.node,

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType,

  /**
   * The duration for the transition, in milliseconds.
   * You may specify a single timeout for all transitions, or individually with an object.
   */
  transitionDuration: PropTypes.oneOfType([PropTypes.number, PropTypes.shape({
    appear: PropTypes.number,
    enter: PropTypes.number,
    exit: PropTypes.number
  })]),

  /**
   * Props applied to the `Transition` element.
   */
  TransitionProps: PropTypes.object
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiSpeedDial'
})(SpeedDial));

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Fab__ = __webpack_require__(260);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tooltip__ = __webpack_require__(450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_utils__ = __webpack_require__(99);


// @inheritedComponent Tooltip







var styles = function styles(theme) {
  return {
    /* Styles applied to the Fab component. */
    fab: {
      margin: 8,
      color: theme.palette.text.secondary,
      backgroundColor: theme.palette.background.paper,
      '&:hover': {
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["d" /* emphasize */])(theme.palette.background.paper, 0.15)
      },
      transition: "".concat(theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter
      }), ", opacity 0.8s"),
      opacity: 1
    },

    /* Styles applied to the Fab component if `open={false}`. */
    fabClosed: {
      opacity: 0,
      transform: 'scale(0)'
    },

    /* Styles applied to the root element if `tooltipOpen={true}`. */
    staticTooltip: {
      position: 'relative',
      display: 'flex',
      '& $staticTooltipLabel': {
        transition: theme.transitions.create(['transform', 'opacity'], {
          duration: theme.transitions.duration.shorter
        }),
        opacity: 1
      }
    },

    /* Styles applied to the root element if `tooltipOpen={true}` and `open={false}`. */
    staticTooltipClosed: {
      '& $staticTooltipLabel': {
        opacity: 0,
        transform: 'scale(0.5)'
      }
    },

    /* Styles applied to the static tooltip label if `tooltipOpen={true}`. */
    staticTooltipLabel: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      position: 'absolute'
    }, theme.typography.body1, {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      boxShadow: theme.shadows[1],
      color: theme.palette.text.secondary,
      padding: '4px 16px'
    }),

    /* Styles applied to the root if `tooltipOpen={true}` and `tooltipPlacement="left"`` */
    tooltipPlacementLeft: {
      alignItems: 'center',
      '& $staticTooltipLabel': {
        transformOrigin: '100% 50%',
        right: '100%',
        marginRight: 8
      }
    },

    /* Styles applied to the root if `tooltipOpen={true}` and `tooltipPlacement="right"`` */
    tooltipPlacementRight: {
      alignItems: 'center',
      '& $staticTooltipLabel': {
        transformOrigin: '0% 50%',
        left: '100%',
        marginLeft: 8
      }
    }
  };
};
var SpeedDialAction = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SpeedDialAction(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$delay = props.delay,
      delay = _props$delay === void 0 ? 0 : _props$delay,
      _props$FabProps = props.FabProps,
      FabProps = _props$FabProps === void 0 ? {} : _props$FabProps,
      icon = props.icon,
      id = props.id,
      open = props.open,
      TooltipClasses = props.TooltipClasses,
      _props$tooltipOpen = props.tooltipOpen,
      tooltipOpenProp = _props$tooltipOpen === void 0 ? false : _props$tooltipOpen,
      _props$tooltipPlaceme = props.tooltipPlacement,
      tooltipPlacement = _props$tooltipPlaceme === void 0 ? 'left' : _props$tooltipPlaceme,
      tooltipTitle = props.tooltipTitle,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["classes", "className", "delay", "FabProps", "icon", "id", "open", "TooltipClasses", "tooltipOpen", "tooltipPlacement", "tooltipTitle"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useState(tooltipOpenProp),
      tooltipOpen = _React$useState[0],
      setTooltipOpen = _React$useState[1];

  var handleTooltipClose = function handleTooltipClose() {
    setTooltipOpen(false);
  };

  var handleTooltipOpen = function handleTooltipOpen() {
    setTooltipOpen(true);
  };

  var transitionStyle = {
    transitionDelay: "".concat(delay, "ms")
  };
  var fab = __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_Fab__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    size: "small",
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.fab, className, !open && classes.fabClosed),
    tabIndex: -1,
    role: "menuitem",
    "aria-describedby": "".concat(id, "-label")
  }, FabProps, {
    style: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, transitionStyle, {}, FabProps.style)
  }), icon);

  if (tooltipOpenProp) {
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
      id: id,
      ref: ref,
      className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.staticTooltip, classes["tooltipPlacement".concat(Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_utils__["a" /* capitalize */])(tooltipPlacement))], !open && classes.staticTooltipClosed)
    }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
      style: transitionStyle,
      id: "".concat(id, "-label"),
      className: classes.staticTooltipLabel
    }, tooltipTitle), fab);
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_Tooltip__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    id: id,
    ref: ref,
    title: tooltipTitle,
    placement: tooltipPlacement,
    onClose: handleTooltipClose,
    onOpen: handleTooltipOpen,
    open: open && tooltipOpen,
    classes: TooltipClasses
  }, other), fab);
});
 false ? SpeedDialAction.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Adds a transition delay, to allow a series of SpeedDialActions to be animated.
   */
  delay: PropTypes.number,

  /**
   * Props applied to the [`Fab`](/api/fab/) component.
   */
  FabProps: PropTypes.object,

  /**
   * The Icon to display in the SpeedDial Fab.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   */
  id: PropTypes.string,

  /**
   * @ignore
   */
  open: PropTypes.bool,

  /**
   * Classes applied to the [`Tooltip`](/api/tooltip/) element.
   */
  TooltipClasses: PropTypes.object,

  /**
   * Make the tooltip always visible when the SpeedDial is open.
   */
  tooltipOpen: PropTypes.bool,

  /**
   * Placement of the tooltip.
   */
  tooltipPlacement: PropTypes.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),

  /**
   * Label to display in the tooltip.
   */
  tooltipTitle: PropTypes.node
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiSpeedDialAction'
})(SpeedDialAction));

/***/ }),
/* 1502 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_Add__ = __webpack_require__(1503);







var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      height: 24
    },

    /* Styles applied to the icon component. */
    icon: {
      transition: theme.transitions.create(['transform', 'opacity'], {
        duration: theme.transitions.duration.short
      })
    },

    /* Styles applied to the icon component if `open={true}`. */
    iconOpen: {
      transform: 'rotate(45deg)'
    },

    /* Styles applied to the icon when and `openIcon` is provided and if `open={true}`. */
    iconWithOpenIconOpen: {
      opacity: 0
    },

    /* Styles applied to the `openIcon` if provided. */
    openIcon: {
      position: 'absolute',
      transition: theme.transitions.create(['transform', 'opacity'], {
        duration: theme.transitions.duration.short
      }),
      opacity: 0,
      transform: 'rotate(-45deg)'
    },

    /* Styles applied to the `openIcon` if provided and if `open={true}`. */
    openIconOpen: {
      transform: 'rotate(0deg)',
      opacity: 1
    }
  };
};
var SpeedDialIcon = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function SpeedDialIcon(props, ref) {
  var className = props.className,
      classes = props.classes,
      iconProp = props.icon,
      open = props.open,
      openIconProp = props.openIcon,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["className", "classes", "icon", "open", "openIcon"]);

  var iconClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.icon, open && [classes.iconOpen, openIconProp && classes.iconWithOpenIconOpen]);
  var openIconClassName = Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.openIcon, open && classes.openIconOpen);

  function formatIcon(icon, newClassName) {
    if (__WEBPACK_IMPORTED_MODULE_2_react___default.a.isValidElement(icon)) {
      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.cloneElement(icon, {
        className: newClassName
      });
    }

    return icon;
  }

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), openIconProp ? formatIcon(openIconProp, openIconClassName) : null, iconProp ? formatIcon(iconProp, iconClassName) : __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__internal_svg_icons_Add__["a" /* default */], {
    className: iconClassName
  }));
});
 false ? SpeedDialIcon.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon to display in the SpeedDial Floating Action Button.
   */
  icon: PropTypes.node,

  /**
   * @ignore
   * If `true`, the SpeedDial is open.
   */
  open: PropTypes.bool,

  /**
   * The icon to display in the SpeedDial Floating Action Button when the SpeedDial is open.
   */
  openIcon: PropTypes.node
} : void 0;
SpeedDialIcon.muiName = 'SpeedDialIcon';
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiSpeedDialIcon'
})(SpeedDialIcon));

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__createSvgIcon__ = __webpack_require__(212);


/**
 * @ignore - internal component.
 */

/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_1__createSvgIcon__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path", {
  d: "M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z"
}), 'Add'));

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_ButtonBase__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__ = __webpack_require__(99);


// @inheritedComponent ButtonBase






var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({}, theme.typography.button, {
      boxSizing: 'border-box',
      borderRadius: theme.shape.borderRadius,
      height: 48,
      padding: '0px 12px',
      border: "1px solid ".concat(Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.action.active, 0.12)),
      color: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.action.active, 0.38),
      '&$selected': {
        color: theme.palette.action.active,
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.action.active, 0.12),
        '&:hover': {
          backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.action.active, 0.15)
        },
        '& + &': {
          borderLeft: 0,
          marginLeft: 0
        }
      },
      '&$disabled': {
        color: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.action.disabled, 0.12)
      },
      '&:hover': {
        textDecoration: 'none',
        // Reset on mouse devices
        backgroundColor: Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["e" /* fade */])(theme.palette.text.primary, 0.05),
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        },
        '&$disabled': {
          backgroundColor: 'transparent'
        }
      }
    }),

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the `label` wrapper element. */
    label: {
      width: '100%',
      // Ensure the correct width for iOS Safari
      display: 'inherit',
      alignItems: 'inherit',
      justifyContent: 'inherit'
    },

    /* Styles applied to the root element if `size="small"`. */
    sizeSmall: {
      height: 40,
      padding: '0px 8px',
      fontSize: theme.typography.pxToRem(13)
    },

    /* Styles applied to the root element if `size="large"`. */
    sizeLarge: {
      height: 56,
      padding: '0px 16px',
      fontSize: theme.typography.pxToRem(15)
    }
  };
};
var ToggleButton = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function ToggleButton(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$disableFocusRi = props.disableFocusRipple,
      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
      _props$disableRipple = props.disableRipple,
      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
      onChange = props.onChange,
      onClick = props.onClick,
      selected = props.selected,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "disabled", "disableFocusRipple", "disableRipple", "onChange", "onClick", "selected", "size", "value"]);

  var handleChange = function handleChange(event) {
    if (onClick) {
      onClick(event, value);

      if (event.isDefaultPrevented()) {
        return;
      }
    }

    if (onChange) {
      onChange(event, value);
    }
  };

  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_ButtonBase__["a" /* default */], Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_4_clsx__["a" /* default */])(classes.root, className, disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_utils__["a" /* capitalize */])(size))]),
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    ref: ref,
    onClick: handleChange,
    onChange: onChange,
    value: value,
    disableRipple: disableRipple,
    "aria-pressed": selected
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("span", {
    className: classes.label
  }, children));
});
 false ? ToggleButton.propTypes = {
  /**
   * The content of the button.
   */
  children: PropTypes.node.isRequired,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, the button will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * If `true`, the  keyboard focus ripple will be disabled.
   * `disableRipple` must also be true.
   */
  disableFocusRipple: PropTypes.bool,

  /**
   * If `true`, the ripple effect will be disabled.
   */
  disableRipple: PropTypes.bool,

  /**
   * @ignore
   */
  onChange: PropTypes.func,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * If `true`, the button will be rendered in an active state.
   */
  selected: PropTypes.bool,

  /**
   * @ignore
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The value to associate with the button when selected in a
   * ToggleButtonGroup.
   */
  value: PropTypes.any.isRequired
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiToggleButton'
})(ToggleButton));

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__isValueSelected__ = __webpack_require__(1506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__ = __webpack_require__(99);










var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      backgroundColor: theme.palette.background.paper,
      borderRadius: theme.shape.borderRadius,
      display: 'inline-flex'
    },

    /* Styles applied to the children. */
    grouped: {
      padding: '0px 11px 0px 12px',
      '&:not(:first-child)': {
        marginLeft: -1,
        borderLeft: '1px solid transparent',
        borderTopLeftRadius: 0,
        borderBottomLeftRadius: 0
      },
      '&:not(:last-child)': {
        borderTopRightRadius: 0,
        borderBottomRightRadius: 0
      }
    },

    /* Styles applied to the children if `size="small"`. */
    groupedSizeSmall: {
      padding: '0px 7px 0px 8px'
    },

    /* Styles applied to the children if `size="large"`. */
    groupedSizeLarge: {
      padding: '0px 15px 0px 16px'
    }
  };
};
var ToggleButtonGroup = __WEBPACK_IMPORTED_MODULE_3_react___default.a.forwardRef(function ToggleButton(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      _props$exclusive = props.exclusive,
      exclusive = _props$exclusive === void 0 ? false : _props$exclusive,
      onChange = props.onChange,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      value = props.value,
      other = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "exclusive", "onChange", "size", "value"]);

  var handleChange = function handleChange(event, buttonValue) {
    if (!onChange) {
      return;
    }

    var index = value && value.indexOf(buttonValue);
    var newValue;

    if (value && index >= 0) {
      newValue = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value);
      newValue.splice(index, 1);
    } else {
      newValue = value ? [].concat(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(value), [buttonValue]) : [buttonValue];
    }

    onChange(event, newValue);
  };

  var handleExclusiveChange = function handleExclusiveChange(event, buttonValue) {
    if (!onChange) {
      return;
    }

    onChange(event, value === buttonValue ? null : buttonValue);
  };

  return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.root, className),
    ref: ref,
    role: "group"
  }, other), __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.map(children, function (child) {
    if (!__WEBPACK_IMPORTED_MODULE_3_react___default.a.isValidElement(child)) {
      return null;
    }

    if (false) {
      if (isFragment(child)) {
        console.error(["Material-UI: the ToggleButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    var _child$props = child.props,
        buttonSelected = _child$props.selected,
        buttonValue = _child$props.value;
    var selected = buttonSelected === undefined ? Object(__WEBPACK_IMPORTED_MODULE_7__isValueSelected__["a" /* default */])(buttonValue, value) : buttonSelected;
    return __WEBPACK_IMPORTED_MODULE_3_react___default.a.cloneElement(child, {
      className: Object(__WEBPACK_IMPORTED_MODULE_6_clsx__["a" /* default */])(classes.grouped, child.props.className, size !== 'medium' && classes["groupedSize".concat(Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_utils__["a" /* capitalize */])(size))]),
      selected: selected,
      onChange: exclusive ? handleExclusiveChange : handleChange,
      size: size
    });
  }));
});
 false ? ToggleButtonGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the button.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * If `true`, only allow one of the child ToggleButton values to be selected.
   */
  exclusive: PropTypes.bool,

  /**
   * Callback fired when the value changes.
   *
   * @param {object} event The event source of the callback.
   * @param {any} value of the selected buttons. When `exclusive` is true
   * this is a single value; when false an array of selected values. If no value
   * is selected and `exclusive` is true the value is null; when false an empty array.
   */
  onChange: PropTypes.func,

  /**
   * The size of the buttons.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The currently selected value within the group or an array of selected
   * values when `exclusive` is false.
   */
  value: PropTypes.any
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiToggleButtonGroup'
})(ToggleButtonGroup));

/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isValueSelected;
// Determine if the toggle button value matches, or is contained in, the
// candidate group value.
function isValueSelected(value, candidate) {
  if (candidate === undefined || value === undefined) {
    return false;
  }

  if (Array.isArray(candidate)) {
    return candidate.indexOf(value) >= 0;
  }

  return value === candidate;
}

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Collapse__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_utils__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__TreeView_TreeViewContext__ = __webpack_require__(573);



/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions  */








var styles = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      listStyle: 'none',
      margin: 0,
      padding: 0,
      outline: 0,
      '&:focus > $content': {
        backgroundColor: theme.palette.grey[400]
      }
    },

    /* Pseudo-class applied to the root element when expanded. */
    expanded: {},

    /* Styles applied to the `role="group"` element. */
    group: {
      margin: 0,
      padding: 0,
      marginLeft: 26
    },

    /* Styles applied to the tree node content. */
    content: {
      width: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
      '&:hover': {
        backgroundColor: theme.palette.action.hover
      }
    },

    /* Styles applied to the tree node icon and collapse/expand icon. */
    iconContainer: {
      marginRight: 2,
      width: 24,
      display: 'flex',
      justifyContent: 'center'
    },

    /* Styles applied to the label element. */
    label: {
      width: '100%'
    }
  };
};

var isPrintableCharacter = function isPrintableCharacter(str) {
  return str && str.length === 1 && str.match(/\S/);
};

var TreeItem = __WEBPACK_IMPORTED_MODULE_2_react___default.a.forwardRef(function TreeItem(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      collapseIcon = props.collapseIcon,
      endIcon = props.endIcon,
      expandIcon = props.expandIcon,
      iconProp = props.icon,
      label = props.label,
      nodeId = props.nodeId,
      onClick = props.onClick,
      onFocus = props.onFocus,
      onKeyDown = props.onKeyDown,
      _props$TransitionComp = props.TransitionComponent,
      TransitionComponent = _props$TransitionComp === void 0 ? __WEBPACK_IMPORTED_MODULE_6__material_ui_core_Collapse__["a" /* default */] : _props$TransitionComp,
      other = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "collapseIcon", "endIcon", "expandIcon", "icon", "label", "nodeId", "onClick", "onFocus", "onKeyDown", "TransitionComponent"]);

  var _React$useContext = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useContext(__WEBPACK_IMPORTED_MODULE_9__TreeView_TreeViewContext__["a" /* default */]),
      expandAllSiblings = _React$useContext.expandAllSiblings,
      focus = _React$useContext.focus,
      focusFirstNode = _React$useContext.focusFirstNode,
      focusLastNode = _React$useContext.focusLastNode,
      focusNextNode = _React$useContext.focusNextNode,
      focusPreviousNode = _React$useContext.focusPreviousNode,
      handleFirstChars = _React$useContext.handleFirstChars,
      handleLeftArrow = _React$useContext.handleLeftArrow,
      addNodeToNodeMap = _React$useContext.addNodeToNodeMap,
      removeNodeFromNodeMap = _React$useContext.removeNodeFromNodeMap,
      contextIcons = _React$useContext.icons,
      isExpanded = _React$useContext.isExpanded,
      isFocused = _React$useContext.isFocused,
      isTabable = _React$useContext.isTabable,
      setFocusByFirstCharacter = _React$useContext.setFocusByFirstCharacter,
      toggle = _React$useContext.toggle;

  var nodeRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var contentRef = __WEBPACK_IMPORTED_MODULE_2_react___default.a.useRef(null);
  var handleRef = Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_utils__["e" /* useForkRef */])(nodeRef, ref);
  var icon = iconProp;
  var expandable = Boolean(Array.isArray(children) ? children.length : children);
  var expanded = isExpanded ? isExpanded(nodeId) : false;
  var focused = isFocused ? isFocused(nodeId) : false;
  var tabable = isTabable ? isTabable(nodeId) : false;
  var icons = contextIcons || {};

  if (!icon) {
    if (expandable) {
      if (!expanded) {
        icon = expandIcon || icons.defaultExpandIcon;
      } else {
        icon = collapseIcon || icons.defaultCollapseIcon;
      }

      if (!icon) {
        icon = icons.defaultParentIcon;
      }
    } else {
      icon = endIcon || icons.defaultEndIcon;
    }
  }

  var handleClick = function handleClick(event) {
    if (!focused) {
      focus(nodeId);
    }

    if (expandable) {
      toggle(event, nodeId);
    }

    if (onClick) {
      onClick(event);
    }
  };

  var printableCharacter = function printableCharacter(event, key) {
    if (key === '*') {
      expandAllSiblings(event, nodeId);
      return true;
    }

    if (isPrintableCharacter(key)) {
      setFocusByFirstCharacter(nodeId, key);
      return true;
    }

    return false;
  };

  var handleKeyDown = function handleKeyDown(event) {
    var flag = false;
    var key = event.key;

    if (event.altKey || event.ctrlKey || event.metaKey) {
      return;
    }

    if (event.shift) {
      if (key === ' ' || key === 'Enter') {
        event.stopPropagation();
      } else if (isPrintableCharacter(key)) {
        flag = printableCharacter(event, key);
      }
    } else {
      switch (key) {
        case 'Enter':
        case ' ':
          if (nodeRef.current === event.currentTarget && expandable) {
            toggle(event);
            flag = true;
          }

          event.stopPropagation();
          break;

        case 'ArrowDown':
          focusNextNode(nodeId);
          flag = true;
          break;

        case 'ArrowUp':
          focusPreviousNode(nodeId);
          flag = true;
          break;

        case 'ArrowRight':
          if (expandable) {
            if (expanded) {
              focusNextNode(nodeId);
            } else {
              toggle(event);
            }
          }

          flag = true;
          break;

        case 'ArrowLeft':
          handleLeftArrow(nodeId, event);
          break;

        case 'Home':
          focusFirstNode();
          flag = true;
          break;

        case 'End':
          focusLastNode();
          flag = true;
          break;

        default:
          if (isPrintableCharacter(key)) {
            flag = printableCharacter(event, key);
          }

      }
    }

    if (flag) {
      event.preventDefault();
      event.stopPropagation();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  var handleFocus = function handleFocus(event) {
    if (!focused && tabable) {
      focus(nodeId);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    var childIds = __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.map(children, function (child) {
      return child.props.nodeId;
    }) || [];

    if (addNodeToNodeMap) {
      addNodeToNodeMap(nodeId, childIds);
    }
  }, [children, nodeId, addNodeToNodeMap]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (removeNodeFromNodeMap) {
      return function () {
        removeNodeFromNodeMap(nodeId);
      };
    }

    return undefined;
  }, [nodeId, removeNodeFromNodeMap]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (handleFirstChars && label) {
      handleFirstChars(nodeId, contentRef.current.textContent.substring(0, 1).toLowerCase());
    }
  }, [handleFirstChars, nodeId, label]);
  __WEBPACK_IMPORTED_MODULE_2_react___default.a.useEffect(function () {
    if (focused) {
      nodeRef.current.focus();
    }
  }, [focused]);
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    className: Object(__WEBPACK_IMPORTED_MODULE_3_clsx__["a" /* default */])(classes.root, className, expanded && classes.expanded),
    role: "treeitem",
    onKeyDown: handleKeyDown,
    onFocus: handleFocus,
    "aria-expanded": expandable ? expanded : null,
    ref: handleRef,
    tabIndex: tabable ? 0 : -1
  }, other), __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.content,
    onClick: handleClick,
    ref: contentRef
  }, icon ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div", {
    className: classes.iconContainer
  }, icon) : null, __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_Typography__["a" /* default */], {
    component: "div",
    className: classes.label
  }, label)), children && __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(TransitionComponent, {
    unmountOnExit: true,
    className: classes.group,
    in: expanded,
    component: "ul",
    role: "group"
  }, children));
});
 false ? TreeItem.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The icon used to collapse the node.
   */
  collapseIcon: PropTypes.node,

  /**
   * The icon displayed next to a end node.
   */
  endIcon: PropTypes.node,

  /**
   * The icon used to expand the node.
   */
  expandIcon: PropTypes.node,

  /**
   * The icon to display next to the tree node's label.
   */
  icon: PropTypes.node,

  /**
   * The tree node label.
   */
  label: PropTypes.node,

  /**
   * The id of the node.
   */
  nodeId: PropTypes.string.isRequired,

  /**
   * @ignore
   */
  onClick: PropTypes.func,

  /**
   * @ignore
   */
  onFocus: PropTypes.func,

  /**
   * @ignore
   */
  onKeyDown: PropTypes.func,

  /**
   * The component used for the transition.
   */
  TransitionComponent: PropTypes.elementType
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiTreeItem'
})(TreeItem));

/***/ }),
/* 1508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export styles */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__ = __webpack_require__(406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_clsx__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__TreeViewContext__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__ = __webpack_require__(13);









var styles = {
  /* Styles applied to the root element. */
  root: {
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function arrayDiff(arr1, arr2) {
  if (arr1.length !== arr2.length) return true;

  for (var i = 0; i < arr1.length; i += 1) {
    if (arr1[i] !== arr2[i]) return true;
  }

  return false;
}

var defaultExpandedDefault = [];
var TreeView = __WEBPACK_IMPORTED_MODULE_4_react___default.a.forwardRef(function TreeView(props, ref) {
  var children = props.children,
      classes = props.classes,
      className = props.className,
      defaultCollapseIcon = props.defaultCollapseIcon,
      defaultEndIcon = props.defaultEndIcon,
      _props$defaultExpande = props.defaultExpanded,
      defaultExpanded = _props$defaultExpande === void 0 ? defaultExpandedDefault : _props$defaultExpande,
      defaultExpandIcon = props.defaultExpandIcon,
      defaultParentIcon = props.defaultParentIcon,
      expandedProp = props.expanded,
      onNodeToggle = props.onNodeToggle,
      other = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutProperties__["a" /* default */])(props, ["children", "classes", "className", "defaultCollapseIcon", "defaultEndIcon", "defaultExpanded", "defaultExpandIcon", "defaultParentIcon", "expanded", "onNodeToggle"]);

  var _React$useState = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(null),
      tabable = _React$useState[0],
      setTabable = _React$useState[1];

  var _React$useState2 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(null),
      focused = _React$useState2[0],
      setFocused = _React$useState2[1];

  var firstNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef(null);
  var nodeMap = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef({});
  var firstCharMap = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef({});

  var _React$useRef = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef(expandedProp !== undefined),
      isControlled = _React$useRef.current;

  var _React$useState3 = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useState(defaultExpanded),
      expandedState = _React$useState3[0],
      setExpandedState = _React$useState3[1];

  var expanded = (isControlled ? expandedProp : expandedState) || defaultExpandedDefault;

  if (false) {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    React.useEffect(function () {
      if (isControlled !== (expandedProp != null)) {
        console.error(["Material-UI: A component is changing ".concat(isControlled ? 'a ' : 'an un', "controlled TreeView to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', 'Decide between using a controlled or uncontrolled TreeView ' + 'element for the lifetime of the component.', 'More info: https://fb.me/react-controlled-components'].join('\n'));
      }
    }, [expandedProp, isControlled]);
  }

  var prevChildIds = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useRef([]);
  __WEBPACK_IMPORTED_MODULE_4_react___default.a.useEffect(function () {
    var childIds = __WEBPACK_IMPORTED_MODULE_4_react___default.a.Children.map(children, function (child) {
      return child.props.nodeId;
    }) || [];

    if (arrayDiff(prevChildIds.current, childIds)) {
      nodeMap.current[-1] = {
        parent: null,
        children: childIds
      };
      childIds.forEach(function (id, index) {
        if (index === 0) {
          firstNode.current = id;
          setTabable(id);
        }

        nodeMap.current[id] = {
          parent: null
        };
      });
      prevChildIds.current = childIds;
    }
  }, [children]);
  var isExpanded = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useCallback(function (id) {
    return expanded.indexOf(id) !== -1;
  }, [expanded]);

  var isTabable = function isTabable(id) {
    return tabable === id;
  };

  var isFocused = function isFocused(id) {
    return focused === id;
  };

  var getLastNode = __WEBPACK_IMPORTED_MODULE_4_react___default.a.useCallback(function (id) {
    var map = nodeMap.current[id];

    if (isExpanded(id) && map.children && map.children.length > 0) {
      return getLastNode(map.children[map.children.length - 1]);
    }

    return id;
  }, [isExpanded]);

  var focus = function focus(id) {
    if (id) {
      setTabable(id);
    }

    setFocused(id);
  };

  var getNextNode = function getNextNode(id, end) {
    var map = nodeMap.current[id];
    var parent = nodeMap.current[map.parent];

    if (!end) {
      if (isExpanded(id)) {
        return map.children[0];
      }
    }

    if (parent) {
      var nodeIndex = parent.children.indexOf(id);
      var nextIndex = nodeIndex + 1;

      if (parent.children.length > nextIndex) {
        return parent.children[nextIndex];
      }

      return getNextNode(parent.id, true);
    }

    var topLevelNodes = nodeMap.current[-1].children;
    var topLevelNodeIndex = topLevelNodes.indexOf(id);

    if (topLevelNodeIndex !== -1 && topLevelNodeIndex !== topLevelNodes.length - 1) {
      return topLevelNodes[topLevelNodeIndex + 1];
    }

    return null;
  };

  var getPreviousNode = function getPreviousNode(id) {
    var map = nodeMap.current[id];
    var parent = nodeMap.current[map.parent];

    if (parent) {
      var nodeIndex = parent.children.indexOf(id);

      if (nodeIndex !== 0) {
        var nextIndex = nodeIndex - 1;
        return getLastNode(parent.children[nextIndex]);
      }

      return parent.id;
    }

    var topLevelNodes = nodeMap.current[-1].children;
    var topLevelNodeIndex = topLevelNodes.indexOf(id);

    if (topLevelNodeIndex > 0) {
      return getLastNode(topLevelNodes[topLevelNodeIndex - 1]);
    }

    return null;
  };

  var focusNextNode = function focusNextNode(id) {
    var nextNode = getNextNode(id);

    if (nextNode) {
      focus(nextNode);
    }
  };

  var focusPreviousNode = function focusPreviousNode(id) {
    var previousNode = getPreviousNode(id);

    if (previousNode) {
      focus(previousNode);
    }
  };

  var focusFirstNode = function focusFirstNode() {
    if (firstNode.current) {
      focus(firstNode.current);
    }
  };

  var focusLastNode = function focusLastNode() {
    var topLevelNodes = nodeMap.current[-1].children;
    var lastNode = getLastNode(topLevelNodes[topLevelNodes.length - 1]);
    focus(lastNode);
  };

  var toggle = function toggle(event) {
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : focused;
    var newExpanded;

    if (expanded.indexOf(value) !== -1) {
      newExpanded = expanded.filter(function (id) {
        return id !== value;
      });
      setTabable(function (oldTabable) {
        var map = nodeMap.current[oldTabable];

        if (oldTabable && (map && map.parent ? map.parent.id : null) === value) {
          return value;
        }

        return oldTabable;
      });
    } else {
      newExpanded = [value].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(expanded));
    }

    if (onNodeToggle) {
      onNodeToggle(event, newExpanded);
    }

    if (!isControlled) {
      setExpandedState(newExpanded);
    }
  };

  var expandAllSiblings = function expandAllSiblings(event, id) {
    var map = nodeMap.current[id];
    var parent = nodeMap.current[map.parent];
    var diff;

    if (parent) {
      diff = parent.children.filter(function (child) {
        return !isExpanded(child);
      });
    } else {
      var topLevelNodes = nodeMap.current[-1].children;
      diff = topLevelNodes.filter(function (node) {
        return !isExpanded(node);
      });
    }

    var newExpanded = [].concat(Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(expanded), Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_toConsumableArray__["a" /* default */])(diff));

    if (!isControlled) {
      setExpandedState(newExpanded);
    }

    if (onNodeToggle) {
      onNodeToggle(event, newExpanded);
    }
  };

  var handleLeftArrow = function handleLeftArrow(id, event) {
    var flag = false;

    if (isExpanded(id)) {
      toggle(event, id);
      flag = true;
    } else {
      var parent = nodeMap.current[id].parent;

      if (parent) {
        focus(parent);
        flag = true;
      }
    }

    if (flag && event) {
      event.preventDefault();
      event.stopPropagation();
    }
  };

  var getIndexFirstChars = function getIndexFirstChars(firstChars, startIndex, char) {
    for (var i = startIndex; i < firstChars.length; i += 1) {
      if (char === firstChars[i]) {
        return i;
      }
    }

    return -1;
  };

  var setFocusByFirstCharacter = function setFocusByFirstCharacter(id, char) {
    var start;
    var index;
    var lowercaseChar = char.toLowerCase();
    var firstCharIds = [];
    var firstChars = []; // This really only works since the ids are strings

    Object.entries(firstCharMap.current).forEach(function (_ref) {
      var _ref2 = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_slicedToArray__["a" /* default */])(_ref, 2),
          nodeId = _ref2[0],
          firstChar = _ref2[1];

      var map = nodeMap.current[nodeId];
      var visible = map.parent ? isExpanded(map.parent) : true;

      if (visible) {
        firstCharIds.push(nodeId);
        firstChars.push(firstChar);
      }
    }); // Get start index for search based on position of currentItem

    start = firstCharIds.indexOf(id) + 1;

    if (start === nodeMap.current.length) {
      start = 0;
    } // Check remaining slots in the menu


    index = getIndexFirstChars(firstChars, start, lowercaseChar); // If not found in remaining slots, check from beginning

    if (index === -1) {
      index = getIndexFirstChars(firstChars, 0, lowercaseChar);
    } // If match was found...


    if (index > -1) {
      focus(firstCharIds[index]);
    }
  };

  var addNodeToNodeMap = function addNodeToNodeMap(id, childrenIds) {
    var currentMap = nodeMap.current[id];
    nodeMap.current[id] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, currentMap, {
      children: childrenIds,
      id: id
    });
    childrenIds.forEach(function (childId) {
      var currentChildMap = nodeMap.current[childId];
      nodeMap.current[childId] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, currentChildMap, {
        parent: id,
        id: childId
      });
    });
  };

  var removeNodeFromNodeMap = function removeNodeFromNodeMap(id) {
    var map = nodeMap.current[id];

    if (map) {
      if (map.parent) {
        var parentMap = nodeMap.current[map.parent];

        if (parentMap && parentMap.children) {
          var parentChildren = parentMap.children.filter(function (c) {
            return c !== id;
          });
          nodeMap.current[map.parent] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, parentMap, {
            children: parentChildren
          });
        }
      }

      delete nodeMap.current[id];
    }
  };

  var handleFirstChars = function handleFirstChars(id, firstChar) {
    firstCharMap.current[id] = firstChar;
  };

  return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__TreeViewContext__["a" /* default */].Provider, {
    value: {
      expandAllSiblings: expandAllSiblings,
      focus: focus,
      focusFirstNode: focusFirstNode,
      focusLastNode: focusLastNode,
      focusNextNode: focusNextNode,
      focusPreviousNode: focusPreviousNode,
      handleFirstChars: handleFirstChars,
      handleLeftArrow: handleLeftArrow,
      addNodeToNodeMap: addNodeToNodeMap,
      removeNodeFromNodeMap: removeNodeFromNodeMap,
      icons: {
        defaultCollapseIcon: defaultCollapseIcon,
        defaultExpandIcon: defaultExpandIcon,
        defaultParentIcon: defaultParentIcon,
        defaultEndIcon: defaultEndIcon
      },
      isExpanded: isExpanded,
      isFocused: isFocused,
      isTabable: isTabable,
      setFocusByFirstCharacter: setFocusByFirstCharacter,
      toggle: toggle
    }
  }, __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("ul", Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
    role: "tree",
    className: Object(__WEBPACK_IMPORTED_MODULE_5_clsx__["a" /* default */])(classes.root, className),
    ref: ref
  }, other), children));
});
 false ? TreeView.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The content of the component.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The default icon used to collapse the node.
   */
  defaultCollapseIcon: PropTypes.node,

  /**
   * The default icon displayed next to a end node. This is applied to all
   * tree nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultEndIcon: PropTypes.node,

  /**
   * Expanded node ids. (Uncontrolled)
   */
  defaultExpanded: PropTypes.arrayOf(PropTypes.string),

  /**
   * The default icon used to expand the node.
   */
  defaultExpandIcon: PropTypes.node,

  /**
   * The default icon displayed next to a parent node. This is applied to all
   * parent nodes and can be overridden by the TreeItem `icon` prop.
   */
  defaultParentIcon: PropTypes.node,

  /**
   * Expanded node ids. (Controlled)
   */
  expanded: PropTypes.arrayOf(PropTypes.string),

  /**
   * Callback fired when tree items are expanded/collapsed.
   *
   * @param {object} event The event source of the callback
   * @param {array} nodeIds The ids of the expanded nodes.
   */
  onNodeToggle: PropTypes.func
} : void 0;
/* unused harmony default export */ var _unused_webpack_default_export = (Object(__WEBPACK_IMPORTED_MODULE_8__material_ui_core_styles__["g" /* withStyles */])(styles, {
  name: 'MuiTreeView'
})(TreeView));

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ChipRedimidor=function(_React$PureComponent){_inherits(ChipRedimidor,_React$PureComponent);function ChipRedimidor(props){_classCallCheck(this,ChipRedimidor);var _this=_possibleConstructorReturn(this,(ChipRedimidor.__proto__||Object.getPrototypeOf(ChipRedimidor)).call(this,props));_this.state={anchorEl:null};_this.onPopoverClose=_this.onPopoverClose.bind(_this);_this.onPopoverToggle=_this.onPopoverToggle.bind(_this);_this.renderRolDetails=_this.renderRolDetails.bind(_this);_this.renderPlacesXRol=_this.renderPlacesXRol.bind(_this);return _this;}_createClass(ChipRedimidor,[{key:"onPopoverClose",value:function onPopoverClose(){console.log("CLOSE");this.setState({anchorEl:null});}},{key:"onPopoverToggle",value:function onPopoverToggle(evt){if(this.state.anchorEl){this.setState({anchorEl:null});}else{this.setState({anchorEl:evt.currentTarget});}}},{key:"renderRolDetails",value:function renderRolDetails(){var _props=this.props,theme=_props.theme,rolRedimidor=_props.rolRedimidor;if(rolRedimidor){var permissions=rolRedimidor.rolPermissions;return permissions.map(function(p,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["D" /* ListItem */],{color:"primary",style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["G" /* ListItemText */],{primary:p.label}));});}}},{key:"renderPlacesXRol",value:function renderPlacesXRol(){var _props2=this.props,theme=_props2.theme,rolRedimidor=_props2.rolRedimidor;if(rolRedimidor){var places=rolRedimidor.rolPlaces;return places.map(function(p,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["D" /* ListItem */],{color:"primary",style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["G" /* ListItemText */],{primary:p.plcName,secondary:p.plcAddress}));});}}},{key:"render",value:function render(){var _props3=this.props,key=_props3.key,theme=_props3.theme,rolRedimidor=_props3.rolRedimidor,onDelete=_props3.onDelete;console.log("RENDER CHIP REDIMIDOR",rolRedimidor);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{key:key},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["g" /* Chip */],{color:"primary",label:rolRedimidor.rolName,onDelete:onDelete,clickeable:true,onClick:this.onPopoverToggle// onMouseEnter={this.onPopoverOpen}
// onMouseLeave={this.onPopoverClose}
}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["K" /* Popover */],{style:{padding:10,backgroundColor:"f3f3f3"},open:Boolean(this.state.anchorEl)// anchorEl={this.state.anchorEl}
,anchorPosition:{top:20,left:20},anchorOrigin:{vertical:'top',horizontal:'right'},transformOrigin:{vertical:'top',horizontal:'right'},onClose:this.onPopoverClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["d" /* Box */],{style:{backgroundColor:"#000",padding:10,justifyContent:"center",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},rolRedimidor.rolName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["C" /* List */],{disablePadding:true,dense:true,subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["H" /* ListSubheader */],{component:"div",id:"nested-list-subheader"},"Tipos de tickets d\xF3nde aplican los permisos")},this.renderRolDetails()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["C" /* List */],{disablePadding:true,dense:true,subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__material_ui_core__["H" /* ListSubheader */],{component:"div",id:"nested-list-subheader"},"Ubicaciones d\xF3nde aplican los permisos")},this.renderPlacesXRol())));}}]);return ChipRedimidor;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_2__material_ui_core_styles__["h" /* withTheme */])(ChipRedimidor));

/***/ }),
/* 1510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ImageSelector_ImageSelector__ = __webpack_require__(211);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var NotifyUser=function(_React$PureComponent){_inherits(NotifyUser,_React$PureComponent);function NotifyUser(props){_classCallCheck(this,NotifyUser);var _this=_possibleConstructorReturn(this,(NotifyUser.__proto__||Object.getPrototypeOf(NotifyUser)).call(this,props));_this.state={sendingNoty:false};_this.onSend=_this.onSend.bind(_this);_this.onClose=_this.onClose.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(NotifyUser,[{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onSend",value:function onSend(formValue){var _this2=this;this.setState({sendingNoty:true});this.props.actionSendNotification(this.props.user,formValue,function(){_this2.setState({sendingNoty:false});__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["b" /* SUCCESS */],"La notificación ha sido enviada.");_this2.onClose(__WEBPACK_IMPORTED_MODULE_9__common_Util__["b" /* SUCCESS */]);},function(e){_this2.setState({sendingNoty:false});if(!(e&&e.status&&e.status==401)){__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"No se pudo enviar la notificación.");}console.log("ERROR AL ENVIAR NOTIFICACION A UN USUARIO",e);});}},{key:"onClose",value:function onClose(SUCCESS){this.props.initialize();this.props.onClose(SUCCESS);}},{key:"render",value:function render(){var _props=this.props,theme=_props.theme,open=_props.open,user=_props.user,handleSubmit=_props.handleSubmit;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:open},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1",color:"primary"},"Enviar Notificaci\xF3n a ",user&&user.proName," ",user&&user.proLastName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],{style:{minWidth:500}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["TextField"],name:"title",label:"T\xEDtulo",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_5__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_4_redux_form_material_ui__["TextField"],name:"body",label:"Descripci\xF3n",fullWidth:true,multiline:true,rows:4,validate:[__WEBPACK_IMPORTED_MODULE_5__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["u" /* Grid */],{item:true,xs:12},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_ImageSelector_ImageSelector__["a" /* default */],{fieldName:"image",fileDimentions:{width:750,height:370},styleButton:theme.imageSelector// imagePreviewUrl={this.state.imgEdit}
// fileName={this.state.imgNameEdit}
,fileSize:300000,showDelete:true,noPreview:true})))),this.state.sendingNoty?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["h" /* CircularProgress */],{style:{margin:30,alignSelf:"center"}}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:this.onClose},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Enviar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:handleSubmit(this.onSend)},"Enviar"))));}}]);return NotifyUser;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);// function mapStateToProps(store) {
//   return {
//   };
// }
function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionSendNotification:__WEBPACK_IMPORTED_MODULE_8__actions_UserActions__["h" /* actionSendNotification */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_redux_form__["c" /* reduxForm */])({form:"notifyUser",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(null,mapDispatchToProps)(NotifyUser))));

/***/ }),
/* 1511 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z"
}), 'VerifiedUser');

exports.default = _default;

/***/ }),
/* 1512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Places=function(_React$PureComponent){_inherits(Places,_React$PureComponent);function Places(props){_classCallCheck(this,Places);var _this=_possibleConstructorReturn(this,(Places.__proto__||Object.getPrototypeOf(Places)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,places:[],filter:"",placeForDelete:false};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeletePlaceSuccess=_this.getDeletePlaceSuccess.bind(_this);_this.onConfirmDeletePlace=_this.onConfirmDeletePlace.bind(_this);_this.onAddPlace=_this.onAddPlace.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(Places,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.login){// console.log("COMPONENT WILL MOUNT")
this.props.actionGetPlaces(this.onChangePage,this.getPlacesError);}}},{key:"getPlacesError",value:function getPlacesError(e){console.log("ERROR PLACES",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_12__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ubicaciones.");}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var places=this.props.placeList.filter(function(e){return e.plcName.match(filter);});var count=places.length;places=places.slice(from,end);this.setState({page:newPage,count:count,places:places});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var places=this.props.placeList.filter(function(e){return e.plcName.match(filter);});var count=places.length;places=places.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,places:places});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onAddPlace",value:function onAddPlace(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["q" /* PLACES_ADD_ROUTE */]);}},{key:"onEditPlace",value:function onEditPlace(place){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["r" /* PLACES_EDIT_ROUTE */],place);}},{key:"onConfirmDeletePlace",value:function onConfirmDeletePlace(){this.props.actionDeletePlace(this.state.placeForDelete,this.getDeletePlaceSuccess,this.getDeletePlaceError);this.setState({placeForDelete:false});}},{key:"onDeletePlace",value:function onDeletePlace(place){this.setState({placeForDelete:place});}},{key:"getDeletePlaceSuccess",value:function getDeletePlaceSuccess(){var _this2=this;this.props.actionGetPlaces(function(){_this2.onChangePage(null,_this2.state.page);},this.getPlacesError);}},{key:"getDeletePlaceError",value:function getDeletePlaceError(e){console.log("ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_12__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar la ubicación.");}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Nombre","Dirección"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var theme=this.props.theme;var places=this.state.places;// console.log("PLACES LIST", places, this.props.placeList)
if(!places||places.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return places.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.plcName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.plcAddress),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Editar ubicaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onEditPlace.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar ubicaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onDeletePlace.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default.a,null)))));});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,theme=_props.theme,placeList=_props.placeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Ubicaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea ubicaciones")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de ubicaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Crear nueva ubicaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddPlace,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.placeForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Eliminar ubicaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar la ubicaci\xF3n?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this4.setState({placeForDelete:null});}},"Cancelar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeletePlace},"Eliminar")))));}}]);return Places;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE", store)
return{login:store.auth.login,placeList:store.plc.placeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetPlaces:__WEBPACK_IMPORTED_MODULE_4__actions_PlaceActions__["b" /* actionGetPlaces */],actionDeletePlace:__WEBPACK_IMPORTED_MODULE_4__actions_PlaceActions__["a" /* actionDeletePlace */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Places))));

/***/ }),
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_NotificationActions__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Block__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Block___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Block__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CheckCircle__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CheckCircle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_CheckCircle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Group__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Group___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Group__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Notifications=function(_React$PureComponent){_inherits(Notifications,_React$PureComponent);function Notifications(props){_classCallCheck(this,Notifications);var _this=_possibleConstructorReturn(this,(Notifications.__proto__||Object.getPrototypeOf(Notifications)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,notifications:[],filter:"",notificationForDelete:false,notificationSelected:null,openUsersNotified:null};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteNotificationSuccess=_this.getDeleteNotificationSuccess.bind(_this);_this.onConfirmDeleteNotification=_this.onConfirmDeleteNotification.bind(_this);_this.onSearch=_this.onSearch.bind(_this);_this.onAddNotification=_this.onAddNotification.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.renderUsersNotified=_this.renderUsersNotified.bind(_this);return _this;}_createClass(Notifications,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.login){this.props.actionGetNotifications(this.onChangePage,this.getNotificationsError);}}},{key:"getNotificationsError",value:function getNotificationsError(e){console.log("ERROR GET NOTIFICATIONS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las notificaciones.");}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var notifications=this.props.notificationList.filter(function(t){return t.tskParams&&t.tskParams.title&&t.tskParams.title.match(filter);});var count=notifications.length;notifications=notifications.slice(from,end);this.setState({page:newPage,count:count,notifications:notifications});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var notifications=this.props.notificationList.filter(function(t){return t.tskParams&&t.tskParams.title&&t.tskParams.title.match(filter);});var count=notifications.length;notifications=notifications.slice(from,end);this.setState({rowPerPage:evt.target.value,notifications:notifications});}},{key:"onRefresh",value:function onRefresh(){this.props.actionGetNotifications(this.onChangePage,this.getNotificationsError);}},{key:"onAddNotification",value:function onAddNotification(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["n" /* NOTIFICATIONS_ADD_ROUTE */]);}},{key:"onEditNotification",value:function onEditNotification(notification){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["o" /* NOTIFICATIONS_EDIT_ROUTE */],notification);//this.setState({ notificationSelected:notification})
}},{key:"onDeleteNotification",value:function onDeleteNotification(notification){this.setState({notificationForDelete:notification});}},{key:"onConfirmDeleteNotification",value:function onConfirmDeleteNotification(){this.props.actionDeleteNotification(this.state.notificationForDelete,this.getDeleteNotificationSuccess,this.getDeleteNotificationError);this.setState({notificationForDelete:false});}},{key:"getDeleteNotificationSuccess",value:function getDeleteNotificationSuccess(){var _this2=this;this.props.actionGetNotifications(function(){_this2.onChangePage(null,_this2.state.page);},this.getNotificationsError);}},{key:"getDeleteNotificationError",value:function getDeleteNotificationError(e){console.log("ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar la notificación.");}},{key:"onUsersNotified",value:function onUsersNotified(notification){this.setState({openUsersNotified:notification.tskUsersNotified||[]});// this.props.actionGetUsersNotified(notification.id, (users)=>{
//   console.log("USERS", users)
// }, (e)=>{Util.showNotify(ERROR,"No pudimos consultar los usuarios notificados")})
}},{key:"renderUsersNotified",value:function renderUsersNotified(users,filter){var theme=this.props.theme;if(users&&users.length>0){var reg=new RegExp(filter,"ig");return users.filter(function(u){return u.proName&&u.proName.match(reg)||u.proLastName&&u.proLastName.match(reg)||u.proDNI&&u.proDNI.toString().match(reg);}).map(function(u,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["D" /* ListItem */],{key:"u"+index,style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["G" /* ListItemText */],{primary:u.proName+" "+u.proLastName,secondary:u.proDNI}));});}}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Título","Descripción","Imágen","Status","Fecha de ejecución"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var theme=this.props.theme;var notifications=this.state.notifications;if(!notifications||notifications.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return notifications.map(function(item,index){var noti=item.tskParams;var isActive=item.tskStatus&&item.tskStatus.toLowerCase()=="complete";var isError=item.tskStatus&&item.tskStatus.toLowerCase()=="error";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,noti.title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,noti.body),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,noti.image?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:{height:"85px",objectFit:"contain"},src:noti.image,alt:""}):"Sin imagen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:isActive?theme.table.activeCell:theme.overrides.MuiTableCell.body},isActive?"ENVIADA":isError?"ERROR":"AGENDADA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].timestampToMoment(item.tskRunDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},item.tskTags&&item.tskTags.length>0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Usuarios notificados"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onUsersNotified.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Group___default.a,null))),isActive?null:[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Editar notificaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onEditNotification.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar notificaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onDeleteNotification.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Delete___default.a,null)))]));});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,theme=_props.theme,notificationList=_props.notificationList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Notificaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea notificaciones")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de notificaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{onClick:this.onRefresh,size:"small",style:{marginLeft:16,width:34,height:34},color:"secondary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Sync___default.a,{style:{fontSize:20}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Crear nueva notificaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddNotification,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{placeholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.notificationForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Notificaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar la notificaci\xF3n?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this4.setState({notificationForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar notificaci\xF3n"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteNotification},"Eliminar")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.openUsersNotified?true:false},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Usuarios Notificados"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,this.state.openUsersNotified&&this.state.openUsersNotified.length==0?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"No se envi\xF3 la notificaci\xF3n a ning\xFAn usuario"):[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["W" /* TextField */],{label:"Buscar",onChange:function onChange(evt){return _this4.setState({filterUsersNotified:evt.target.value});}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["C" /* List */],{style:{height:200,overflow:"auto"}},this.renderUsersNotified(this.state.openUsersNotified,this.state.filterUsersNotified))]),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Cerrar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:function onClick(){_this4.setState({openUsersNotified:null});}},"Cerrar"))))));}}]);return Notifications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,notificationList:store.ntf.notificationList||[]};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetNotifications:__WEBPACK_IMPORTED_MODULE_4__actions_NotificationActions__["b" /* actionGetNotifications */],actionDeleteNotification:__WEBPACK_IMPORTED_MODULE_4__actions_NotificationActions__["a" /* actionDeleteNotification */],actionSaveNotification:__WEBPACK_IMPORTED_MODULE_4__actions_NotificationActions__["d" /* actionSaveNotification */],actionGetUsersNotified:__WEBPACK_IMPORTED_MODULE_4__actions_NotificationActions__["c" /* actionGetUsersNotified */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Notifications))));

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NotificationConfig__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var NotificationService=function(){function NotificationService(){_classCallCheck(this,NotificationService);}_createClass(NotificationService,null,[{key:"getNotifications",/******* NOTIFICATIONS **********/value:function getNotifications(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].endpointNotifications;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;console.log("RESPONSE GET NOTIFICATIONS",response);if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=15;break;case 12:_context.prev=12;_context.t0=_context["catch"](0);reject(_context.t0);case 15:case"end":return _context.stop();}}},_callee,_this,[[0,12]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"saveNotification",value:function saveNotification(app,notification){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].endpointSaveNotification;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(notification)});case 7:response=_context2.sent;// console.log("RESPONSE SAVE NOTIFICATION",response)
if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 14:case"end":return _context2.stop();}}},_callee2,_this2,[[0,11]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"deleteNotification",value:function deleteNotification(app,notificationId){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].endpointDeleteNotification;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:notificationId})});case 7:response=_context3.sent;// console.log("RESPONSE DELETE Notification",response, notificationId)
if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 14:case"end":return _context3.stop();}}},_callee3,_this3,[[0,11]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}},{key:"getUsersNotified",value:function getUsersNotified(app,notificationId){var _this4=this;return new Promise(function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee4(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee4$(_context4){while(1){switch(_context4.prev=_context4.next){case 0:_context4.prev=0;_context4.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context4.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].endpointUsersNotified+"?tag="+notificationId;_context4.next=7;return __WEBPACK_IMPORTED_MODULE_1__NotificationConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context4.sent;// console.log("RESPONSE DELETE Notification",response, notificationId)
if(response.status==200){resolve(response.body);}else{reject(response);}_context4.next=14;break;case 11:_context4.prev=11;_context4.t0=_context4["catch"](0);reject(_context4.t0);case 14:case"end":return _context4.stop();}}},_callee4,_this4,[[0,11]]);}));return function(_x7,_x8){return _ref4.apply(this,arguments);};}());}/******** FIN NOTIFICATIONS *********/}]);return NotificationService;}();/* harmony default export */ __webpack_exports__["a"] = (NotificationService);

/***/ }),
/* 1515 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var NotificationConfig=function(){function NotificationConfig(){_classCallCheck(this,NotificationConfig);}_createClass(NotificationConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointNotifications",get:function get(){return NotificationConfig.endpoint+"/bo_notifications";}},{key:"endpointSaveNotification",get:function get(){return NotificationConfig.endpointNotifications+"/save";}},{key:"endpointDeleteNotification",get:function get(){return NotificationConfig.endpointNotifications+"/delete";}},{key:"endpointUsersNotified",get:function get(){return NotificationConfig.endpointNotifications+"/users";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return NotificationConfig;}();/* harmony default export */ __webpack_exports__["a"] = (NotificationConfig);

/***/ }),
/* 1516 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"
}), 'Group');

exports.default = _default;

/***/ }),
/* 1517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_lab__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Brightness1__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Brightness1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Brightness1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GoogleMapLocation__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_ImageSelector_ImageSelector__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_NotificationActions__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__actions_TagActions__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var AddEditNotifications=function(_React$PureComponent){_inherits(AddEditNotifications,_React$PureComponent);function AddEditNotifications(props){_classCallCheck(this,AddEditNotifications);var _this=_possibleConstructorReturn(this,(AddEditNotifications.__proto__||Object.getPrototypeOf(AddEditNotifications)).call(this,props));_this.state={imgEdit:null,imgNameEdit:null,tagsSelected:[]};_this.onClean=_this.onClean.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onSelectTag=_this.onSelectTag.bind(_this);_this.renderTags=_this.renderTags.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(AddEditNotifications,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}this.props.actionGetTags(null,function(e){console.log("ERROR AL LISTAR TAGS",e);});if(this.props.isEditing){var notification=this.props.history.location.state;//this.props.notification
console.log("NOTIFICATION",notification);if(notification){notification.tskRunDate=notification.tskRunDate&&__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].timestampToMoment(notification.tskRunDate).format('YYYY-MM-DDTHH:mm');this.props.initialize(notification);notification.tskParams&&this.setState({imgEdit:notification.tskParams.image,imgNameEdit:notification.tskParams.nameImg,tagsSelected:notification.tskTags});}else{this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}else{this.props.initialize({tskStatus:"scheduled",tskTask:"notify",tskImmediate:false});}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onClean",value:function onClean(){var initNoti={tskStatus:"scheduled",tskTask:"notify"};if(this.props.isEditing){var notification=this.props.notification;if(notification.tskParams&&notification.tskParams.pathImg){initNoti.tskParams={pathImg:notification.tskParams.pathImg};}this.props.initialize(initNoti);this.setState({imgEdit:null,imgNameEdit:null,tagsSelected:initNoti.tskTags});}else{this.props.initialize(initNoti);this.setState({imgEdit:null,imgNameEdit:null,tagsSelected:[]});}}},{key:"onSave",value:function onSave(formValues){var _this2=this;this.props.actionSaveNotification(Object.assign({},formValues,{tskTags:this.state.tagsSelected}),function(){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["b" /* SUCCESS */],"La notificación se guardó correctamente.");_this2.props.history.goBack();},function(e){console.log("ERROR ON SAVE NOTIFICATION",e);if(!(e&&e.status&&e.status==401)){if(e&&e.body&&e.body.notificationSendFail){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"Guardamos la notificación pero no se pudo enviar.");}else{__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No se pudo guardar la notificación.");}}});}},{key:"onSelectTag",value:function onSelectTag(evt,tag){var tags=tag.slice();this.setState({tagsSelected:tags});}},{key:"renderTags",value:function renderTags(tags){console.log("RENDER TAGS",tags);var t=tags&&tags.filter(function(t){return!t.add;});return t&&t.map(function(tag){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["g" /* Chip */],{label:tag.tagName,avatar:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["b" /* Avatar */],{style:{backgroundColor:tag.tagColor,color:"rgb(0,0,0,0.60"}},tag.tagName.substring(0,1))});});}},{key:"render",value:function render(){var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,isEditing=_props.isEditing;var title=isEditing?"Editar Notificación":"Crear Notificación";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Crear Notificaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea Notificaciones"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,xs:12,spacing:3,direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tskParams.title",label:"T\xEDtulo de la notificaci\xF3n",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tskRunDate",label:"Fecha a notificar",type:"datetime-local",InputLabelProps:{shrink:true},fullWidth:true,validate:this.props.isImmediate?undefined:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]],disabled:this.props.isImmediate}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:function component(_ref){var input=_ref.input,label=_ref.label;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["s" /* FormControlLabel */],{label:label,control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:input.value,onChange:input.onChange})});},name:"tskImmediate",label:"Env\xEDo inmediato"// type="datetime-local"
// InputLabelProps={{ shrink: true }}
// fullWidth
// validate={[required]}
})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_lab__["a" /* Autocomplete */],{options:this.props.tagList,value:this.state.tagsSelected,getOptionLabel:function getOptionLabel(option){return option.tagName;}// filterOptions={(options, params) => {
//   const filtered = filterTag(options, params);
//   if (params.inputValue !== '') {
//     filtered.unshift({
//       inputValue: params.inputValue,
//       tagName: `Agregar "${params.inputValue}"`,
//     });
//   }
//   return filtered;
// }}
,renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true,label:"Seleccionar tags",helperText:"Si no selecciona ning\xFAn tag se enviar\xE1 la notificaci\xF3n a todos los usuarios."}));},renderOption:function renderOption(t){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["E" /* ListItemIcon */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Brightness1___default.a,{style:{color:t.tagColor}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:t.tagName}));},renderTags:this.renderTags,onChange:this.onSelectTag// onInputChange={this.onInputChangeTag}
,loadingText:"Cargando tags ...",noOptionsText:"Sin tags",selectOnFocus:true,multiple:true,filterSelectedOptions:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,direction:"row",spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"tskParams.body",label:"Cuerpo de la notificaci\xF3n",fullWidth:true,multiline:true,rows:4,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Limpiar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.onClean},"Limpiar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar")))));}}]);return AddEditNotifications;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE EVENT",store);return{login:store.auth.login,notification:store.ntf.notification,tagList:store.tag.tagList,isImmediate:store.form&&store.form.addEditNotifications&&store.form.addEditNotifications.values.tskImmediate};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionSaveNotification:__WEBPACK_IMPORTED_MODULE_18__actions_NotificationActions__["d" /* actionSaveNotification */],actionGetTags:__WEBPACK_IMPORTED_MODULE_19__actions_TagActions__["b" /* actionGetTags */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditNotifications",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_14__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditNotifications)))));

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_NoveltyActions__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_Util__ = __webpack_require__(26);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var News=function(_React$PureComponent){_inherits(News,_React$PureComponent);function News(props){_classCallCheck(this,News);var _this=_possibleConstructorReturn(this,(News.__proto__||Object.getPrototypeOf(News)).call(this,props));_this.state={page:0,rowPerPage:5,count:0,news:[],filter:"",noveltyForDelete:false};_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.getDeleteNoveltySuccess=_this.getDeleteNoveltySuccess.bind(_this);_this.onConfirmDeleteNovelty=_this.onConfirmDeleteNovelty.bind(_this);_this.onAddNovelty=_this.onAddNovelty.bind(_this);_this.onSearch=_this.onSearch.bind(_this);return _this;}_createClass(News,[{key:"componentWillMount",value:function componentWillMount(){if(this.props.login){// console.log("COMPONENT WILL MOUNT")
this.props.actionGetNews(this.onChangePage,this.getNewsError);}}},{key:"getNewsError",value:function getNewsError(e){console.log("ERROR NEWS",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_12__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las novedades.");}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var filter=new RegExp(this.state.filter,"ig");var news=this.props.noveltyList.filter(function(e){return e.nvtTitle.match(filter);});var count=news.length;news=news.slice(from,end);this.setState({page:newPage,count:count,news:news});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var filter=new RegExp(this.state.filter,"ig");var news=this.props.noveltyList.filter(function(e){return e.nvtTitle.match(filter);});var count=news.length;news=news.slice(from,end);this.setState({rowPerPage:evt.target.value,count:count,news:news});}},{key:"onSearch",value:function onSearch(evt){this.setState({filter:evt.target.value},this.onChangePage);}},{key:"onAddNovelty",value:function onAddNovelty(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["k" /* NEWS_ADD_ROUTE */]);}},{key:"onEditNovelty",value:function onEditNovelty(novelty){this.props.history.push(__WEBPACK_IMPORTED_MODULE_5__config_RoutesConstants__["l" /* NEWS_EDIT_ROUTE */],novelty);}},{key:"onConfirmDeleteNovelty",value:function onConfirmDeleteNovelty(){this.props.actionDeleteNovelty(this.state.noveltyForDelete,this.getDeleteNoveltySuccess,this.getDeleteNoveltyError);this.setState({noveltyForDelete:false});}},{key:"onDeleteNovelty",value:function onDeleteNovelty(novelty){this.setState({noveltyForDelete:novelty});}},{key:"getDeleteNoveltySuccess",value:function getDeleteNoveltySuccess(){var _this2=this;this.props.actionGetNews(function(){_this2.onChangePage(null,_this2.state.page);},this.getNewsError);}},{key:"getDeleteNoveltyError",value:function getDeleteNoveltyError(e){console.log("ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_12__common_Util__["a" /* ERROR */],"Ocurrió un error al elminar la novedad.");}},{key:"renderTableHeader",value:function renderTableHeader(){var theme=this.props.theme;var headers=["Imagen","Título","Descripción","Fecha","Difusión"];return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],null,headers.map(function(label){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,label);}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var theme=this.props.theme;var news=this.state.news;// console.log("NEWS LIST", news, this.props.noveltyList)
if(!news||news.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return news.map(function(item,index){var isPublic=item.nvtDiffusion.toLowerCase()=="public";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.nvtImg?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{style:{height:"85px",objectFit:"contain"},src:item.nvtImg,alt:""}):"Sin imagen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.nvtTitle),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,item.nvtDescription),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].formatDateToShow(__WEBPACK_IMPORTED_MODULE_12__common_Util__["d" /* default */].timestampToMoment(item.nvtDate))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],null,isPublic?"Pública":"Privada"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Editar novedad"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onEditNovelty.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar novedad"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["y" /* IconButton */],{onClick:_this3.onDeleteNovelty.bind(_this3,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Delete___default.a,null)))));});}},{key:"render",value:function render(){var _this4=this;var _props=this.props,theme=_props.theme,noveltyList=_props.noveltyList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Novedades"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea novedades")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["j" /* Container */],{style:theme.table.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de novedades"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["X" /* Toolbar */],{style:theme.table.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["Y" /* Tooltip */],{title:"Crear novedad"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["q" /* Fab */],{color:"primary",onClick:this.onAddNovelty,size:"small"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_Add___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["z" /* Input */],{noveltyholder:"Buscar",onChange:this.onSearch}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["k" /* Dialog */],{open:this.state.noveltyForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["o" /* DialogTitle */],null,"Eliminar novedad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar la novedad?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this4.setState({noveltyForDelete:null});}},"Cancelar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteNovelty},"Eliminar")))));}}]);return News;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE", store)
return{login:store.auth.login,noveltyList:store.nvt.noveltyList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetNews:__WEBPACK_IMPORTED_MODULE_4__actions_NoveltyActions__["b" /* actionGetNews */],actionDeleteNovelty:__WEBPACK_IMPORTED_MODULE_4__actions_NoveltyActions__["a" /* actionDeleteNovelty */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_7__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(News))));

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var NoveltyService=function(){function NoveltyService(){_classCallCheck(this,NoveltyService);}_createClass(NoveltyService,null,[{key:"getNews",/******* PLACES **********/value:function getNews(app){var _this=this;return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].endpointNews;_context.next=7;return __WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].APIConnector.get(endpoint,{headers:{Authorization:"Bearer "+token,App:app}});case 7:response=_context.sent;if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](0);reject(_context.t0);case 14:case"end":return _context.stop();}}},_callee,_this,[[0,11]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"saveNovelty",value:function saveNovelty(app,novelty){var _this2=this;return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].endpointSaveNovelty;_context2.next=7;return __WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(novelty)});case 7:response=_context2.sent;// console.log("RESPONSE SAVE PLACE",response)
if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=14;break;case 11:_context2.prev=11;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 14:case"end":return _context2.stop();}}},_callee2,_this2,[[0,11]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"deleteNovelty",value:function deleteNovelty(app,noveltyId){var _this3=this;return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].endpointDeleteNovelty;_context3.next=7;return __WEBPACK_IMPORTED_MODULE_1__NoveltyConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify({id:noveltyId})});case 7:response=_context3.sent;// console.log("RESPONSE DELETE Novelty",response, noveltyId)
if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=14;break;case 11:_context3.prev=11;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 14:case"end":return _context3.stop();}}},_callee3,_this3,[[0,11]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}/******** FIN PLACES *********/}]);return NoveltyService;}();/* harmony default export */ __webpack_exports__["a"] = (NoveltyService);

/***/ }),
/* 1520 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var NoveltyConfig=function(){function NoveltyConfig(){_classCallCheck(this,NoveltyConfig);}_createClass(NoveltyConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointNews",get:function get(){return NoveltyConfig.endpoint+"/news";}},{key:"endpointSaveNovelty",get:function get(){return NoveltyConfig.endpointNews+"/save";}},{key:"endpointDeleteNovelty",get:function get(){return NoveltyConfig.endpointNews+"/delete";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return NoveltyConfig;}();/* harmony default export */ __webpack_exports__["a"] = (NoveltyConfig);

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_Select__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_lab__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_GoogleMapLocation__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_ImageSelector_ImageSelector__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_NoveltyActions__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var AddEditNovelty=function(_React$PureComponent){_inherits(AddEditNovelty,_React$PureComponent);function AddEditNovelty(props){_classCallCheck(this,AddEditNovelty);var _this=_possibleConstructorReturn(this,(AddEditNovelty.__proto__||Object.getPrototypeOf(AddEditNovelty)).call(this,props));_this.state={imgEdit:null,imgNameEdit:null};_this.onClean=_this.onClean.bind(_this);_this.onSave=_this.onSave.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(AddEditNovelty,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}if(this.props.isEditing){var novelty=this.props.history.location.state;//this.props.novelty
console.log("NOVELTY",novelty);if(novelty){novelty.nvtDate=novelty.nvtDate&&__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].timestampToMoment(novelty.nvtDate).format('YYYY-MM-DDTHH:mm');this.props.initialize(novelty);this.setState({imgEdit:novelty.nvtImg,imgNameEdit:novelty.nvtNameImg});}else{this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}else{this.props.initialize({nvtDiffusion:"public",nvtNotify:false});}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onClean",value:function onClean(){if(this.props.isEditing){var novelty=this.props.novelty;this.props.initialize({tskStatus:"scheduled",nvtNotificationId:novelty.notificationId,nvtPathImg:novelty.nvtPathImg});}else{this.props.initialize({nvtDiffusion:"public",nvtNotify:false});}this.setState({imgEdit:null,imgNameEdit:null});}},{key:"onSave",value:function onSave(formValues){var _this2=this;this.props.actionSaveNovelty(formValues,function(){__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["b" /* SUCCESS */],"La novedad se guardó correctamente.");_this2.props.history.goBack();},function(e){console.log("ERROR ON SAVE NOVELTY",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_15__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_15__common_Util__["a" /* ERROR */],"No se pudo guardar la novedad.");});}},{key:"render",value:function render(){var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,isEditing=_props.isEditing;var title=isEditing?"Editar Novedad":"Crear Novedad";return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Crear Novedad"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea Novedad"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,xs:12,spacing:3,direction:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:6},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"nvtTitle",label:"T\xEDtulo de la novedad",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"nvtDate",label:"Fecha de publicaci\xF3n",type:"datetime-local",InputLabelProps:{shrink:true},fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"Difusi\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"nvtDiffusion",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:"public"},"P\xDABLICA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:"private"},"PRIVADA"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:1},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true},"Notificar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["Select"],select:true,name:"nvtNotify",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:true},"SI"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["I" /* MenuItem */],{value:false},"NO")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,direction:"row",spacing:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_ImageSelector_ImageSelector__["a" /* default */],{fieldName:"nvtImg"// validate={[required]}
,fileDimentions:{width:750,height:370},styleButton:theme.imageSelector,imagePreviewUrl:this.state.imgEdit,fileName:this.state.imgNameEdit,fileSize:300000,showDelete:true,noPreview:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:8},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"nvtDescription",label:"Descripci\xF3n",fullWidth:true,multiline:true,rows:4,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Limpiar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.onClean},"Limpiar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar")))));}}]);return AddEditNovelty;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){// console.log("STORE EVENT", store)
return{login:store.auth.login,novelty:store.nvt.novelty};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionSaveNovelty:__WEBPACK_IMPORTED_MODULE_17__actions_NoveltyActions__["c" /* actionSaveNovelty */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditNews",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_13__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditNovelty)))));

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_RolActions__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_lab__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandLess__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandLess___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ExpandLess__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ExpandMore__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ExpandMore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__material_ui_icons_ExpandMore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Edit__ = __webpack_require__(98);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Edit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Edit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Delete__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Delete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Delete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var MONTHS=["Enero","Febrero","Marzo","Abril","Mayo","Junio","Julio","Agosto","Septiembre","Octubre","Noviembre","Diciembre"];var Roles=function(_React$PureComponent){_inherits(Roles,_React$PureComponent);function Roles(props){_classCallCheck(this,Roles);var _this=_possibleConstructorReturn(this,(Roles.__proto__||Object.getPrototypeOf(Roles)).call(this,props));_this.state={selectedRolIndex:0,loadingUsers:false,rolesRedimidoresListFilter:[],usersFiltred:[],rolForDelete:null,searchText:""};_this.onAddRol=_this.onAddRol.bind(_this);_this.onConfirmDeleteRol=_this.onConfirmDeleteRol.bind(_this);_this.onInputChangeUser=_this.onInputChangeUser.bind(_this);_this.onInputSearchRolChange=_this.onInputSearchRolChange.bind(_this);_this.onSearchRol=_this.onSearchRol.bind(_this);_this.onAddUser=_this.onAddUser.bind(_this);_this.renderRoles.bind(_this);return _this;}_createClass(Roles,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;console.log("LOGIN",this.props.login);if(this.props.login){this.props.actionGetRolesRedimidores(function(){_this2.setState({rolesRedimidoresListFilter:_this2.props.rolesRedimidoresList});},function(e){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos consultar los roles");});}else{this.props.history.push(__WEBPACK_IMPORTED_MODULE_6__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}}},{key:"onAddRol",value:function onAddRol(){this.props.history.push(__WEBPACK_IMPORTED_MODULE_6__config_RoutesConstants__["t" /* ROLES_ADD_ROUTE */]);}},{key:"onEditRol",value:function onEditRol(rol){this.props.history.push(__WEBPACK_IMPORTED_MODULE_6__config_RoutesConstants__["u" /* ROLES_EDIT_ROUTE */],{rol:rol});}},{key:"onDeleteRol",value:function onDeleteRol(rol){this.setState({rolForDelete:rol});}},{key:"onConfirmDeleteRol",value:function onConfirmDeleteRol(){var _this3=this;var rol=this.state.rolForDelete;this.props.actionDeleteRol(rol,function(){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["b" /* SUCCESS */],"Se elimin\xF3 el rol "+rol.rolName+" correctamente");console.log("actionDeleteRol callback",_this3.state.selectedRolIndex);_this3.props.actionGetRolesRedimidores(_this3.onSearchRol,function(e){console.log("actionGetRolesRedimidores callback",_this3.state.selectedRolIndex);__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos consultar los roles");});},function(e){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos eliminar el rol "+rol.rolName);});this.setState({rolForDelete:null});}},{key:"onInputSearchRolChange",value:function onInputSearchRolChange(event){this.setState({searchText:event.target.value});}},{key:"onSearchRol",value:function onSearchRol(){var rolesRedimidoresList=this.props.rolesRedimidoresList;console.log("onSearchRol",rolesRedimidoresList);var filter=new RegExp(this.state.searchText,"gi");var rolesRedimidoresListFilter=rolesRedimidoresList.filter(function(r){return r.rolName.match(filter);});this.setState({rolesRedimidoresListFilter:rolesRedimidoresListFilter,selectedRolIndex:0});}},{key:"onSelectRol",value:function onSelectRol(index,evt){this.setState({selectedRolIndex:index});}},{key:"onInputChangeUser",value:function onInputChangeUser(evt){var _this4=this;if(!this.state.loadingUsers&&evt&&evt.target&&evt.target.value){var userList=this.props.userList;var filter=new RegExp(evt.target.value,"gi");if(evt.target.value.length==3){//BUSCAR EN BACKEND
this.setState({loadingUsers:true});this.props.actionGetUsersByReg(evt.target.value,function(response){var usersFiltred=response.filter(function(u){return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter);});_this4.setState({usersFiltred:usersFiltred,loadingUsers:false});},function(e){_this4.setState({loadingUsers:false});console.log("ACTION GET USERS ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos listar los usuarios");});}else{if(evt.target.value.length>3){//FILTRAR EN FRONT
var usersFiltred=userList&&userList.filter(function(u){return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter);});this.setState({usersFiltred:usersFiltred});}}}}},{key:"onAddUser",value:function onAddUser(evt,user){var _this5=this;if(user){var rolesRedimidoresList=this.props.rolesRedimidoresList;var rol=Object.assign({},rolesRedimidoresList[this.state.selectedRolIndex]);var notExist=rol.rolUsers.indexOf(function(u){return u.id==user.id;})==-1;if(notExist){rol.rolUsers.push({id:user.id,proName:user.proName,proLastName:user.proLastName,proEmail:user.proEmail});console.log("USERS",user);this.props.actionSaveRol(rol,function(){rolesRedimidoresList[_this5.state.selectedRolIndex]=rol;__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["b" /* SUCCESS */],"Se asign\xF3 el rol "+rol.rolName+" a "+user.proName+" "+user.proLastName+" correctamente");},function(e){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos asignar el rol "+rol.rolName+" a "+user.proName+" "+user.proLastName);});}else{__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"El usuario "+user.proName+" "+user.proLastName+" ya tiene el rol "+rol.rolName);}evt.target.value=null;evt.target.innerHtml="";}console.log("TARGET",evt.target);// this.setState({usersSelected:users})
}},{key:"onDeleteUser",value:function onDeleteUser(user){var _this6=this;if(user){var rolesRedimidoresList=this.props.rolesRedimidoresList;var rol=Object.assign({},rolesRedimidoresList[this.state.selectedRolIndex]);var rolUsers=rol.rolUsers.filter(function(u){return u.id!=user.id;});rol.rolUsers=rolUsers;this.props.actionSaveRol(rol,function(){rolesRedimidoresList[_this6.state.selectedRolIndex]=rol;__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["b" /* SUCCESS */],"Se quit\xF3 el rol "+rol.rolName+" a "+user.proName+" "+user.proLastName+" correctamente");},function(e){__WEBPACK_IMPORTED_MODULE_16__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_16__common_Util__["a" /* ERROR */],"No pudimos quitar el rol "+rol.rolName+" a "+user.proName+" "+user.proLastName);});}}},{key:"renderRoles",value:function renderRoles(){var _this7=this;var rolesRedimidoresListFilter=this.state.rolesRedimidoresListFilter;return rolesRedimidoresListFilter.map(function(r,i){var isSelected=_this7.state.selectedRolIndex==i;console.log("RENDER ROLES",_this7.state.selectedRolIndex,i);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* ListItem */],{button:true,color:"primary",selected:isSelected,onClick:_this7.onSelectRol.bind(_this7,i)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["G" /* ListItemText */],{primary:r.rolName,secondary:r.rolDesc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["F" /* ListItemSecondaryAction */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Editar rol"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:_this7.onEditRol.bind(_this7,r)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Edit___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar rol"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Delete___default.a,{onClick:_this7.onDeleteRol.bind(_this7,r)}))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["i" /* Collapse */],{"in":isSelected,timeout:"auto",unmountOnExit:true,style:{backgroundColor:"black",color:"white",paddingLeft:12}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* List */],{disablePadding:true,dense:true,subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["H" /* ListSubheader */],{component:"div",style:{color:"rgba(255,255,255,0.7)"}},"Permisos")},_this7.renderRolDetails(i)))];});}},{key:"renderRolDetails",value:function renderRolDetails(rolIndex){var rolesRedimidoresListFilter=this.state.rolesRedimidoresListFilter;if(rolesRedimidoresListFilter&&rolesRedimidoresListFilter.length){console.log("renderRolDetails",rolIndex,rolesRedimidoresListFilter[rolIndex],rolesRedimidoresListFilter);var permissions=rolesRedimidoresListFilter[rolIndex].rolPermissions;return permissions.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* ListItem */],{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["G" /* ListItemText */],{primary:p.label}));});}}},{key:"renderUsersXRol",value:function renderUsersXRol(rolIndex){var _this8=this;var rolesRedimidoresList=this.props.rolesRedimidoresList;if(rolesRedimidoresList&&rolesRedimidoresList.length){var users=rolesRedimidoresList[rolIndex].rolUsers;return users.map(function(u){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* ListItem */],{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["G" /* ListItemText */],{primary:u.proName+" "+u.proLastName,secondary:u.proEmail}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["F" /* ListItemSecondaryAction */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar rol al usuario"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:_this8.onDeleteUser.bind(_this8,u)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Delete___default.a,null)))));});}}},{key:"renderPlacesXRol",value:function renderPlacesXRol(rolIndex){var rolesRedimidoresList=this.props.rolesRedimidoresList;if(rolesRedimidoresList&&rolesRedimidoresList.length){var places=rolesRedimidoresList[rolIndex].rolPlaces;return places.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["D" /* ListItem */],{color:"primary"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["G" /* ListItemText */],{primary:p.plcName,secondary:p.plcAddress}));});}}},{key:"render",value:function render(){var _this9=this;var _props=this.props,theme=_props.theme,userList=_props.userList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:theme.title.container},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Roles"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea roles")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["j" /* Container */],{style:Object.assign({},theme.table.container,{maxWidth:"100%"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Listado de roles")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{container:true,spacing:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:5,spacing:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["X" /* Toolbar */],{style:{justifyContent:"space-between"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["d" /* Box */],{style:{display:"flex",width:"80%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["W" /* TextField */],{label:"Buscar Rol",fullWidth:true,onChange:this.onInputSearchRolChange,value:this.state.searchText}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Buscar rol"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["y" /* IconButton */],{onClick:this.onSearchRol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__material_ui_icons_Search___default.a,null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Agregar rol"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["q" /* Fab */],{size:"smal",color:"primary",onClick:this.onAddRol},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_Add___default.a,null)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* List */],{subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["H" /* ListSubheader */],{component:"div",id:"nested-list-subheader"},"Roles")},this.renderRoles())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["X" /* Toolbar */],{style:{padding:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_lab__["a" /* Autocomplete */],{options:this.state.usersFiltred,getOptionLabel:function getOptionLabel(option){return option.proName+" "+option.proLastName;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["W" /* TextField */],Object.assign({},params,{fullWidth:true,label:"Agregar usuarios",helperText:"Escriba al menos 3 letras para buscar"}));},renderOption:function renderOption(u){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["G" /* ListItemText */],{primary:u.proName+" "+u.proLastName,secondary:u.proEmail});},onChange:this.onAddUser,onInputChange:this.onInputChangeUser,loading:this.state.loadingUsers,loadingText:"Cargando usuarios ...",noOptionsText:"Sin usuarios",blurOnSelect:true,selectOnFocus:true,clearOnBlur:true,clearOnEscape:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* List */],{subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["H" /* ListSubheader */],{component:"div",id:"nested-list-subheader"},"Usuarios con el rol seleccionado")},this.renderUsersXRol(this.state.selectedRolIndex))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["u" /* Grid */],{item:true,xs:4},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["C" /* List */],{style:{marginTop:64},subheader:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["H" /* ListSubheader */],{component:"div",id:"nested-list-subheader"},"Ubicaciones d\xF3nde aplican los permisos")},this.renderPlacesXRol(this.state.selectedRolIndex))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["k" /* Dialog */],{open:this.state.rolForDelete},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["o" /* DialogTitle */],null,"Eliminar Rol"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["m" /* DialogContent */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["n" /* DialogContentText */],null,"\xBFEst\xE1 seguro que desea eliminar el rol ",this.state.rolForDelete&&this.state.rolForDelete.rolName," ?")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["l" /* DialogActions */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",onClick:function onClick(){_this9.setState({rolForDelete:null});}},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["Y" /* Tooltip */],{title:"Eliminar rol"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",onClick:this.onConfirmDeleteRol},"Eliminar"))))));}}]);return Roles;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,authEmail:store.auth.email,rolesRedimidoresList:store.rol.rolesRedimidoresList,userList:store.usr.userList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetRolesRedimidores:__WEBPACK_IMPORTED_MODULE_5__actions_RolActions__["c" /* actionGetRolesRedimidores */],actionGetUsersByReg:__WEBPACK_IMPORTED_MODULE_4__actions_UserActions__["e" /* actionGetUsersByReg */],actionSaveRol:__WEBPACK_IMPORTED_MODULE_5__actions_RolActions__["d" /* actionSaveRol */],actionDeleteRol:__WEBPACK_IMPORTED_MODULE_5__actions_RolActions__["a" /* actionDeleteRol */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_9__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Roles))));

/***/ }),
/* 1523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z"
}), 'ExpandLess');

exports.default = _default;

/***/ }),
/* 1524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

exports.default = _default;

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_redux_form__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_Validations__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_lab__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_ColorField_ColorField__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_IconPicker_IconPicker__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__actions_EventActions__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__actions_UserActions__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__actions_RolActions__ = __webpack_require__(298);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _handleSubmitFail=void 0;var AddEditRoles=function(_React$PureComponent){_inherits(AddEditRoles,_React$PureComponent);function AddEditRoles(props){_classCallCheck(this,AddEditRoles);var _this=_possibleConstructorReturn(this,(AddEditRoles.__proto__||Object.getPrototypeOf(AddEditRoles)).call(this,props));_this.state={usersFiltred:[],usersSelected:[],permissions:[],placesSelected:[]};_this.onClean=_this.onClean.bind(_this);_this.onSave=_this.onSave.bind(_this);_this.onInputChangeUser=_this.onInputChangeUser.bind(_this);_this.onChangeUser=_this.onChangeUser.bind(_this);_this.renderPermissions=_this.renderPermissions.bind(_this);// this.renderUsers=this.renderUsers.bind(this)
_this.renderPlaces=_this.renderPlaces.bind(_this);_handleSubmitFail=_this.handleSubmitFail.bind(_this);return _this;}_createClass(AddEditRoles,[{key:"componentWillMount",value:function componentWillMount(){var _this2=this;if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}else{this.props.actionGetCategories(function(){var rol=_this2.props.history.location.state&&_this2.props.history.location.state.rol;var permissions=_this2.props.categoryList.map(function(c){var p={id:c.id,label:"Control "+c.id,selected:false};if(_this2.props.isEditing){var permissionsSelected=rol.rolPermissions.find(function(rp){return rp.id==p.id;});console.log("PERMISSIONS SELECTED",permissionsSelected);if(permissionsSelected){p=permissionsSelected;}}return p;});console.log("PERMISSIONS",permissions);_this2.setState({permissions:permissions});},function(e){console.log("ACTION GET CATEGORIES ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"No pudimos listar las categorías");});this.props.actionGetPlaces(null,function(e){console.log("ACTION GET PLACES ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"No pudimos listar las ubicaciones");});}if(this.props.isEditing){var rol=this.props.history.location.state.rol;console.log("ROL EDITING",rol,this.props.rol,this.props.history.location);this.props.initialize({rolName:rol.rolName,rolDesc:rol.rolDesc});this.setState({usersSelected:rol.rolUsers.slice(),placesSelected:rol.rolPlaces.slice()});}}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onClean",value:function onClean(){// if(this.props.isEditing){
//   let ticket=this.props.history.location.state
//   this.props.initialize({id:ticket.id, tktColor:"#000000", tktSellRrppEnable:false, tktVisible:true})
// }else{
//   this.props.initialize({tktColor:"#000000", tktSellRrppEnable:false, tktVisible:true})
// }
}},{key:"onSave",value:function onSave(formValues){var _this3=this;var rolData={rolName:formValues.rolName,rolDesc:formValues.rolDesc,rolUsers:this.state.usersSelected.map(function(u){return{id:u.id,proName:u.proName,proLastName:u.proLastName,proEmail:u.proEmail};}),rolPermissions:this.state.permissions.filter(function(p){return p.selected;}),rolPlaces:this.state.placesSelected};if(this.props.isEditing){var rol=this.props.history.location.state&&this.props.history.location.state.rol;rolData.id=rol.id;}var valid=true;var dbRolRedimidor=this.props.rolesRedimidoresList&&this.props.rolesRedimidoresList.find(function(r){return r.rolName==rolData.rolName;});if(dbRolRedimidor&&(!rolData.id||rolData.id!=dbRolRedimidor.id)){valid=false;__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"Ya existe un rol con el nombre ingresado.");}if(!rolData.rolUsers||rolData.rolUsers.length==0){valid=false;__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"Debe asignar el rol al menos a un usuario.");}if(!rolData.rolPlaces||rolData.rolPlaces.length==0){valid=false;__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"Debe asignar el rol al menos a una ubicación.");}if(valid){console.log("ROL DATA",rolData);this.props.actionSaveRol(rolData,function(){_this3.props.actionGetRolesRedimidores();__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["b" /* SUCCESS */],"El rol "+rolData.rolName+" se ha guardado correctamente");_this3.props.history.goBack();},function(e){__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"No pudimos guardar el rol "+rolData.rolName);});}// this.props.actionSaveTicketType(formValues
//   , ()=>{Util.showNoty(SUCCESS, "El ticket se guardó correctamente."); this.props.history.goBack()}
//   , (e)=>{
//     console.log("ERROR ON SAVE TICKET", e)
//     if(!(e&&e.status&&e.status==401))
//       Util.showNoty(ERROR, "No se pudo guardar el ticket.")
//   }
// )
}},{key:"onInputChangeUser",value:function onInputChangeUser(evt){var _this4=this;if(!this.state.loadingUsers){var userList=this.props.userList;var filter=new RegExp(evt.target.value,"gi");if(evt.target.value&&evt.target.value.length==3){//BUSCAR EN BACKEND
this.setState({loadingUsers:true});this.props.actionGetUsersByReg(evt.target.value,function(response){console.log("RESPONSE",response);var usersFiltred=response.filter(function(u){console.log("USER",u);return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter);});_this4.setState({usersFiltred:usersFiltred,loadingUsers:false});},function(e){_this4.setState({loadingUsers:false});console.log("ACTION GET USERS ERROR",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_14__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_14__common_Util__["a" /* ERROR */],"No pudimos listar los usuarios");});}else{if(evt.target.value&&evt.target.value.length>3){//FILTRAR EN FRONT
var usersFiltred=userList&&userList.filter(function(u){return u.proName&&u.proName.match(filter)||u.proLastName&&u.proLastName.match(filter)||u.proEmail&&u.proEmail.match(filter);});this.setState({usersFiltred:usersFiltred});}}}}},{key:"onChangeUser",value:function onChangeUser(evt,users){console.log("USERS",users);this.setState({usersSelected:users});}},{key:"onChangePermissions",value:function onChangePermissions(permission,event){var idx=this.state.permissions.indexOf(permission);var p=Object.assign({},this.state.permissions[idx],{selected:event.target.checked});var permissions=this.state.permissions.slice();permissions[idx]=p;this.setState({permissions:permissions});}},{key:"onChangePlace",value:function onChangePlace(place,event){console.log("PLACE",place);if(event.target.checked){var placesSelected=this.state.placesSelected.slice();placesSelected.push(place);this.setState({placesSelected:placesSelected});}else{var _placesSelected=this.state.placesSelected.filter(function(p){return p.id!=place.id;});this.setState({placesSelected:_placesSelected});}}},{key:"renderPermissions",value:function renderPermissions(){var _this5=this;var permissions=this.state.permissions;console.log("renderPermissions",permissions);return permissions.map(function(p,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],{key:"p"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:p.selected,onChange:_this5.onChangePermissions.bind(_this5,p)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:p.label}));});}// renderUsers(){
//   const { usersSelected } = this.state
//   console.log("USERS SELECTED", usersSelected)
//   // let userList = []
//   // let size = 20
//   // for(let i = 0;i<size;i++){
//   //   userList.push()
//   // }
//   return usersSelected.map((u,i)=>{
//     return (<ListItem key={`u${i}`}>
//               <Checkbox/>
//               <ListItemText primary={`${u.proName} ${u.proLastName}`} secondary={u.proEmail}/>
//             </ListItem>)
//   })
// }
},{key:"renderPlaces",value:function renderPlaces(){var _this6=this;var placeList=this.props.placeList;console.log("PLACES SELECTED",this.state.placesSelected);return placeList&&placeList.map(function(p,i){var isChecked=_this6.state.placesSelected.find(function(ps){return p.id==ps.id;})?true:false;console.log("PLACE",p,isChecked);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["D" /* ListItem */],{key:"pl"+i},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:isChecked,onChange:_this6.onChangePlace.bind(_this6,p)}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:p.plcName,secondary:p.plcAddress}));});}},{key:"render",value:function render(){var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,event=_props.event,ticketFormValues=_props.ticketFormValues,categoryList=_props.categoryList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Atr\xE1s"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Crear rol"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{variant:"subtitle1"},"Crea rol"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["j" /* Container */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["J" /* Paper */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Z" /* Typography */],{style:theme.paper.title,variant:"h2"},"Crear rol")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("form",{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,spacing:2},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{container:true,item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],name:"rolName",label:"Nombre del rol",fullWidth:true,validate:[__WEBPACK_IMPORTED_MODULE_7__common_Validations__["b" /* required */]]})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_redux_form__["a" /* Field */],{component:__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],multiline:true,rows:5,name:"rolDesc",label:"Descripci\xF3n del rol",fullWidth:true}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_lab__["a" /* Autocomplete */],{options:this.state.usersFiltred,value:this.state.usersSelected,getOptionLabel:function getOptionLabel(option){return option.proName+" "+option.proLastName;},renderInput:function renderInput(params){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_redux_form_material_ui__["TextField"],Object.assign({},params,{fullWidth:true,label:"Agregar usuarios",helperText:"Escriba al menos 3 letras para buscar"}));},renderOption:function renderOption(u){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["G" /* ListItemText */],{primary:u.proName+" "+u.proLastName,secondary:u.proEmail});},onChange:this.onChangeUser,onInputChange:this.onInputChangeUser,loading:this.state.loadingUsers,loadingText:"Cargando usuarios ...",noOptionsText:"Sin usuarios",multiple:true,disableCloseOnSelect:true})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Permisos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["C" /* List */],null,this.renderPermissions())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["u" /* Grid */],{item:true,xs:3},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["B" /* InputLabel */],{shrink:true,fullWidth:true},"Ubicaciones"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["C" /* List */],{style:{height:200,overflow:"auto"}},this.renderPlaces()))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["X" /* Toolbar */],{style:theme.footer.toolbar},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Cancelar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"secondary",style:theme.footer.button,onClick:this.props.history.goBack},"Cancelar")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["Y" /* Tooltip */],{title:"Guardar"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__material_ui_core__["e" /* Button */],{variant:"contained",color:"primary",style:theme.footer.button,onClick:handleSubmit(this.onSave)},"Guardar")))));}}]);return AddEditRoles;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE",store);return{login:store.auth.login,categoryList:store.evt.categoryList,placeList:store.plc.placeList,userList:store.usr.userList,rolesRedimidoresList:store.rol.rolesRedimidoresList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetCategories:__WEBPACK_IMPORTED_MODULE_15__actions_EventActions__["d" /* actionGetCategories */],actionGetPlaces:__WEBPACK_IMPORTED_MODULE_16__actions_PlaceActions__["b" /* actionGetPlaces */],actionGetUsersByReg:__WEBPACK_IMPORTED_MODULE_17__actions_UserActions__["e" /* actionGetUsersByReg */],actionSaveRol:__WEBPACK_IMPORTED_MODULE_18__actions_RolActions__["d" /* actionSaveRol */],actionGetRolesRedimidores:__WEBPACK_IMPORTED_MODULE_18__actions_RolActions__["c" /* actionGetRolesRedimidores */]},dispatch);}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_5_redux_form__["c" /* reduxForm */])({form:"addEditRoles",onSubmitFail:function onSubmitFail(errors){return _handleSubmitFail(errors);}})(Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_12__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(AddEditRoles)))));

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_StatsActions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__StatsByClientTab__ = __webpack_require__(1529);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__StatsByClientDetail__ = __webpack_require__(1530);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__StatsByEventTab__ = __webpack_require__(1531);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ClearIcon from '@material-ui/icons/Backspace';
var _handleSubmitFail=void 0;var Statistics=function(_React$PureComponent){_inherits(Statistics,_React$PureComponent);function Statistics(props){_classCallCheck(this,Statistics);var _this=_possibleConstructorReturn(this,(Statistics.__proto__||Object.getPrototypeOf(Statistics)).call(this,props));var lastMonth=__WEBPACK_IMPORTED_MODULE_13_moment___default()();lastMonth=lastMonth.add(-1,"month").format("YYYY-MM-DD");var today=__WEBPACK_IMPORTED_MODULE_13_moment___default()().format("YYYY-MM-DD");var filter={from:lastMonth,to:today,period:"daily",place:""};_this.state={count:0,rowPerPage:10,page:1,orderBy:"Qt",orderDesc:true,filter:filter,tabIndex:0,detailInitFilter:null};_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.sortStatsByClient=_this.sortStatsByClient.bind(_this);_this.onFilterDate=_this.onFilterDate.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onChangeTab=_this.onChangeTab.bind(_this);_this.onPressDetailUser=_this.onPressDetailUser.bind(_this);return _this;}_createClass(Statistics,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}else{this.onRefresh();this.props.actionGetPlaces(null,this.getPlacesError);}}},{key:"getStatsByClientError",value:function getStatsByClientError(e){console.log("ERROR GET STATS BY CLIENT",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las estadísticas por cliente.");}},{key:"getPlacesError",value:function getPlacesError(e){console.log("ERROR GET Places",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ubicaciones.");}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onRefresh",value:function onRefresh(){var _state=this.state,orderBy=_state.orderBy,orderDesc=_state.orderDesc,filter=_state.filter;var order={orderBy:orderBy,orderDesc:orderDesc};this.props.actionGetStatsByClient(filter,order,this.onChangePage,this.getStatsByClientError);}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var users=this.props.statsByClient;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByClient);users=users.slice(from,end);this.setState({page:newPage,count:count,users:users});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var users=this.props.statsByClient;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByClient);users=users.slice(from,end);this.setState({rowPerPage:evt.target.value,users:users});}},{key:"sortStatsByClient",value:function sortStatsByClient(a,b){try{if(b[this.state.orderBy]&&!a[this.state.orderBy]){return 1;}if(!b[this.state.orderBy]&&a[this.state.orderBy]){return-1;}if(!b[this.state.orderBy]&&!a[this.state.orderBy]){return 0;}}catch(e){console.log("SORT STATS BY CLIENT ERROR",e);return-1;}}},{key:"onChangeFilter",value:function onChangeFilter(field,evt){console.log("ON CHANGE FILTER DATE",evt.target.value,field);var filter=Object.assign({},this.state.filter);filter[field]=evt.target.value;this.setState({filter:filter});}},{key:"onFilterDate",value:function onFilterDate(){if(this.state.filter&&this.state.filter.from&&this.state.filter.to){this.onRefresh();}}},{key:"onChangeTab",value:function onChangeTab(evt,value){this.setState({tabIndex:value,page:0});}},{key:"onPressDetailUser",value:function onPressDetailUser(user,filter){var _this2=this;this.props.actionGetStatsByClientDetail(Object.assign({},filter,{tktBuyerDU:user.tktBuyerDU}),{},function(){_this2.setState({detailUser:user,detailInitFilter:filter});},function(e){console.log("ERROR GET Places",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"Ocurrió un error al consultar el detalle.");});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this3=this;var theme=this.props.theme;var headers=[{id:"tktBuyerLastName",label:"Apellido y Nombre"},{id:"tktBuyerDU",label:"DNI"},{id:"Qt",label:"Cantidad"},{id:"Total",label:"Total $"},{id:"TotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){if(headCell.id=="tktBuyerDU"||headCell.id=="tktBuyerLastName"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["U" /* TableSortLabel */],{active:_this3.state.orderBy===headCell.id,direction:_this3.state.orderBy===headCell.id&&_this3.state.orderDesc?'desc':'asc',onClick:function onClick(){return _this3.onSortByField(headCell.id);},hideSortIcon:true},headCell.label));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this4=this;var theme=this.props.theme;var users=this.state.users;if(!users||users.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return users.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktBuyerLastName+", "+item.tktBuyerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktBuyerDU),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.Qt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.Total),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.TotalProducer),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Y" /* Tooltip */],{title:"Ver Detalle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:_this4.onDetailUser.bind(_this4,item)},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List___default.a,null)))));});}},{key:"render",value:function render(){var _this5=this;var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,history=_props.history,placeList=_props.placeList;var _state2=this.state,detailUser=_state2.detailUser,detailInitFilter=_state2.detailInitFilter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:Object.assign({},theme.title.container,{flexDirection:"row",display:"flex"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.title.backIconContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:this.props.history.goBack,style:theme.title.backIcon},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default.a,{style:{fontSize:"2.5rem"},stroke:"white",strokeWidth:3,strokeLinecap:"round",strokeLinejoin:"round"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],{variant:"h1"},"Estad\xEDsticas"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["j" /* Container */],{maxWidth:1320},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["V" /* Tabs */],{indicatorColor:"primary",value:this.state.tabIndex,onChange:this.onChangeTab},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["N" /* Tab */],{label:"Por Cliente"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["N" /* Tab */],{label:"Por Evento"})),this.state.tabIndex==0&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__StatsByClientTab__["a" /* default */],{onPressDetail:this.onPressDetailUser}),this.state.tabIndex==1&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__StatsByEventTab__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__StatsByClientDetail__["a" /* default */],{user:detailUser,filter:detailInitFilter,onClose:function onClose(){console.log("ONCLOSE");_this5.setState({detailUser:null,detailInitFilter:null});}}));}}]);return Statistics;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE STATISTICS",store);return{login:store.auth.login,statsByClient:store.stats.statsByClient,placeList:store.plc.placeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetStatsByClient:__WEBPACK_IMPORTED_MODULE_11__actions_StatsActions__["a" /* actionGetStatsByClient */],actionGetStatsByClientDetail:__WEBPACK_IMPORTED_MODULE_11__actions_StatsActions__["b" /* actionGetStatsByClientDetail */],actionGetPlaces:__WEBPACK_IMPORTED_MODULE_12__actions_PlaceActions__["b" /* actionGetPlaces */]},dispatch);}// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Statistics))));

/***/ }),
/* 1527 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__StatsConfig__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var UserService=function(){function UserService(){_classCallCheck(this,UserService);}_createClass(UserService,null,[{key:"getStatsByClient",/******* STATS **********/value:function getStatsByClient(filter,order,app){var _this=this;console.log("PARAMS getStatsByClient",filter,order,app);return new Promise(function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(resolve,reject){var token,endpoint,body,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.prev=0;_context.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].endpointStatsByClient;body={tktDates:{from:filter.from,to:filter.to},period:filter.period,place:filter.place,state:filter.state,onlyGift:filter.onlyGift};_context.next=8;return __WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(body)});case 8:response=_context.sent;console.log("getStatsByClient",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context.next=16;break;case 13:_context.prev=13;_context.t0=_context["catch"](0);reject(_context.t0);case 16:case"end":return _context.stop();}}},_callee,_this,[[0,13]]);}));return function(_x,_x2){return _ref.apply(this,arguments);};}());}},{key:"getStatsByClientDetail",value:function getStatsByClientDetail(filter,order,app){var _this2=this;console.log("PARAMS getStatsByClientDetail",filter,order,app);return new Promise(function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2(resolve,reject){var token,endpoint,body,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_context2.prev=0;_context2.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context2.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].endpointStatsByClientDetail;body={tktDates:{from:filter.from,to:filter.to},period:filter.period,place:filter.place,state:filter.state,onlyGift:filter.onlyGift,tktBuyerDU:filter.tktBuyerDU};_context2.next=8;return __WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(body)});case 8:response=_context2.sent;console.log("getStatsByClient",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context2.next=16;break;case 13:_context2.prev=13;_context2.t0=_context2["catch"](0);reject(_context2.t0);case 16:case"end":return _context2.stop();}}},_callee2,_this2,[[0,13]]);}));return function(_x3,_x4){return _ref2.apply(this,arguments);};}());}},{key:"getStatsByEvent",value:function getStatsByEvent(filter,order,app){var _this3=this;console.log("PARAMS getStatsByEvent",filter,order,app);return new Promise(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee3(resolve,reject){var token,endpoint,body,response;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:_context3.prev=0;_context3.next=3;return __WEBPACK_IMPORTED_MODULE_2__auth_AuthService__["a" /* default */].getToken();case 3:token=_context3.sent;endpoint=__WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].endpointStatsByEvent;body={tktDates:{from:filter.from,to:filter.to},period:filter.period,place:filter.place,state:filter.state,onlyGift:filter.onlyGift};_context3.next=8;return __WEBPACK_IMPORTED_MODULE_1__StatsConfig__["a" /* default */].APIConnector.post(endpoint,{headers:{Authorization:"Bearer "+token,App:app},body:JSON.stringify(body)});case 8:response=_context3.sent;console.log("getStatsByEvent",response,app);if(response.status==200){resolve(response.body);}else{reject(response);}_context3.next=16;break;case 13:_context3.prev=13;_context3.t0=_context3["catch"](0);reject(_context3.t0);case 16:case"end":return _context3.stop();}}},_callee3,_this3,[[0,13]]);}));return function(_x5,_x6){return _ref3.apply(this,arguments);};}());}}]);return UserService;}();/* harmony default export */ __webpack_exports__["a"] = (UserService);

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__base_Settings__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}var apiConnector=new __WEBPACK_IMPORTED_MODULE_0__lib_APIConnector__["a" /* default */]({timeout:30000});var StatsConfig=function(){function StatsConfig(){_classCallCheck(this,StatsConfig);}_createClass(StatsConfig,null,[{key:"endpoint",get:function get(){return __WEBPACK_IMPORTED_MODULE_1__base_Settings___default.a.SERVICE_DOMAIN;}},{key:"endpointStats",get:function get(){return StatsConfig.endpoint+"/stats";}},{key:"endpointStatsByClient",get:function get(){return StatsConfig.endpointStats+"/byClient";}},{key:"endpointStatsByClientDetail",get:function get(){return StatsConfig.endpointStats+"/byClientDetail";}},{key:"endpointStatsByEvent",get:function get(){return StatsConfig.endpointStats+"/byEvent";}},{key:"APIConnector",get:function get(){return apiConnector;}}]);return StatsConfig;}();/* harmony default export */ __webpack_exports__["a"] = (StatsConfig);

/***/ }),
/* 1529 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__actions_StatsActions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ClearIcon from '@material-ui/icons/Backspace';
var _handleSubmitFail=void 0;var Statistics=function(_React$PureComponent){_inherits(Statistics,_React$PureComponent);function Statistics(props){_classCallCheck(this,Statistics);var _this=_possibleConstructorReturn(this,(Statistics.__proto__||Object.getPrototypeOf(Statistics)).call(this,props));var lastMonth=__WEBPACK_IMPORTED_MODULE_13_moment___default()();lastMonth=lastMonth.add(-1,"month").format("YYYY-MM-DD");var today=__WEBPACK_IMPORTED_MODULE_13_moment___default()().format("YYYY-MM-DD");var filter={from:lastMonth,to:today,period:"daily",place:"",state:"",onlyGift:false};_this.state={count:0,rowPerPage:10,page:1,orderBy:"Qt",orderDesc:true,filter:filter,tabIndex:0};_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.sortStatsByClient=_this.sortStatsByClient.bind(_this);_this.onFilterDate=_this.onFilterDate.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onChangeTab=_this.onChangeTab.bind(_this);_this.onSortByField=_this.onSortByField.bind(_this);return _this;}_createClass(Statistics,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}else{this.onRefresh();this.props.actionGetPlaces(null,this.getPlacesError);}}},{key:"getStatsByClientError",value:function getStatsByClientError(e){console.log("ERROR GET STATS BY CLIENT",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las estadísticas por cliente.");}},{key:"getPlacesError",value:function getPlacesError(e){console.log("ERROR GET Places",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_9__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ubicaciones.");}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onRefresh",value:function onRefresh(){var _state=this.state,orderBy=_state.orderBy,orderDesc=_state.orderDesc,filter=_state.filter;var order={orderBy:orderBy,orderDesc:orderDesc};this.props.actionGetStatsByClient(filter,order,this.onChangePage,this.getStatsByClientError);}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var users=this.props.statsByClient;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByClient);users=users.slice(from,end);this.setState({page:newPage,count:count,users:users});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var users=this.props.statsByClient;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByClient);users=users.slice(from,end);this.setState({rowPerPage:evt.target.value,users:users});}},{key:"sortStatsByClient",value:function sortStatsByClient(a,b){try{if(this.state.orderDesc){return b[this.state.orderBy]-a[this.state.orderBy];}return a[this.state.orderBy]-b[this.state.orderBy];}catch(e){console.log("SORT STATS BY CLIENT ERROR",e);return-1;}}},{key:"onChangeFilter",value:function onChangeFilter(field,evt){console.log("ON CHANGE FILTER DATE",evt.target.value,field);var filter=Object.assign({},this.state.filter);filter[field]=field=="onlyGift"?evt.target.checked:evt.target.value;this.setState({filter:filter});}},{key:"onFilterDate",value:function onFilterDate(){if(this.state.filter&&this.state.filter.from&&this.state.filter.to){this.onRefresh();}}},{key:"onChangeTab",value:function onChangeTab(evt,value){this.setState({tabIndex:value,page:0});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this2=this;var theme=this.props.theme;var headers=[{id:"tktBuyerLastName",label:"Apellido y Nombre"},{id:"tktBuyerDU",label:"DNI"},{id:"Qt",label:"Cantidad"},{id:"Total",label:"Total $"},{id:"TotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){if(headCell.id=="tktBuyerDU"||headCell.id=="tktBuyerLastName"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["U" /* TableSortLabel */],{active:_this2.state.orderBy===headCell.id,direction:_this2.state.orderBy===headCell.id&&_this2.state.orderDesc?'desc':'asc',onClick:function onClick(){return _this2.onSortByField(headCell.id);},hideSortIcon:true},headCell.label));}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},"Acciones"));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var _props=this.props,theme=_props.theme,onPressDetail=_props.onPressDetail;var users=this.state.users;if(!users||users.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return users.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktBuyerLastName+", "+item.tktBuyerName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktBuyerDU),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.Qt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(item.Total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_9__common_Util__["d" /* default */].formatCurrency(item.TotalProducer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],{style:theme.table.actionsColumn},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Y" /* Tooltip */],{title:"Ver Detalle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:function onClick(){return onPressDetail(item,_this3.state.filter);}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_List___default.a,null)))));});}},{key:"render",value:function render(){var _props2=this.props,theme=_props2.theme,handleSubmit=_props2.handleSubmit,history=_props2.history,placeList=_props2.placeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"space-between"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:this.state.filter.from,label:"Fecha desde",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"from")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:this.state.filter.to,label:"Fecha hasta",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"to")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["r" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["B" /* InputLabel */],{id:"stateLabel",shrink:true},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["L" /* Select */],{labelId:"stateLabel",value:this.state.filter.state,onChange:this.onChangeFilter.bind(this,"state"),displayEmpty:true// multiple
// renderValue={(selected) => (
//   <div >
//     {selected.map((item) => (
//       <Chip key={item} label={stateList[item]} color="primary"/>
//     ))}
//   </div>
// )}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Todos los estados")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:"pendingUse"},"Sin usar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:"already_used"},"Usado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["r" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["s" /* FormControlLabel */],{label:"Solo invitaciones",control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:this.state.filter.onlyGift,onChange:this.onChangeFilter.bind(this,"onlyGift")})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:this.onFilterDate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__material_ui_icons_Search___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage}));}}]);return Statistics;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE STATISTICS",store);return{login:store.auth.login,statsByClient:store.stats.statsByClient,placeList:store.plc.placeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetStatsByClient:__WEBPACK_IMPORTED_MODULE_11__actions_StatsActions__["a" /* actionGetStatsByClient */],actionGetPlaces:__WEBPACK_IMPORTED_MODULE_12__actions_PlaceActions__["b" /* actionGetPlaces */]},dispatch);}// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Statistics))));

/***/ }),
/* 1530 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_StatsActions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_List__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_List__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ClearIcon from '@material-ui/icons/Backspace';
var _handleSubmitFail=void 0;var Statistics=function(_React$PureComponent){_inherits(Statistics,_React$PureComponent);function Statistics(props){_classCallCheck(this,Statistics);var _this=_possibleConstructorReturn(this,(Statistics.__proto__||Object.getPrototypeOf(Statistics)).call(this,props));var lastMonth=__WEBPACK_IMPORTED_MODULE_14_moment___default()();lastMonth=lastMonth.add(-1,"month").format("YYYY-MM-DD");var today=__WEBPACK_IMPORTED_MODULE_14_moment___default()().format("YYYY-MM-DD");var filter=props.filter||{from:lastMonth,to:today,period:"daily",place:""};_this.state={count:0,rowPerPage:10,page:1,orderBy:"Qt",orderDesc:true,filter:filter,tabIndex:0,openDetail:{}};_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.sortstatsByClientDetail=_this.sortstatsByClientDetail.bind(_this);_this.onFilterDate=_this.onFilterDate.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onChangeTab=_this.onChangeTab.bind(_this);_this.onSortByField=_this.onSortByField.bind(_this);_this.onClose=_this.onClose.bind(_this);return _this;}_createClass(Statistics,[{key:"getstatsByClientDetailDetailError",value:function getstatsByClientDetailDetailError(e){console.log("ERROR GET STATS BY CLIENT",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_11__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las estadísticas por cliente.");}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onRefresh",value:function onRefresh(){var _state=this.state,orderBy=_state.orderBy,orderDesc=_state.orderDesc,filter=_state.filter;var user=this.props.user;console.log("USER",user);var order={orderBy:orderBy,orderDesc:orderDesc};this.props.actionGetStatsByClientDetail(Object.assign({},filter,{tktBuyerDU:user.tktBuyerDU}),order,this.onChangePage,this.getstatsByClientDetailDetailError);}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var users=this.props.statsByClientDetail;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortstatsByClientDetail);users=users.slice(from,end);this.setState({page:newPage,count:count,users:users});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var users=this.props.statsByClientDetail;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortstatsByClientDetail);users=users.slice(from,end);this.setState({rowPerPage:evt.target.value,users:users});}},{key:"sortstatsByClientDetail",value:function sortstatsByClientDetail(a,b){try{if(this.state.orderDesc){return b[this.state.orderBy]-a[this.state.orderBy];}return a[this.state.orderBy]-b[this.state.orderBy];}catch(e){console.log("SORT STATS BY CLIENT ERROR",e);return-1;}}},{key:"onChangeFilter",value:function onChangeFilter(field,evt){console.log("ON CHANGE FILTER DATE",evt.target.value,field);var filter=Object.assign({},this.state.filter);filter[field]=evt.target.value;this.setState({filter:filter});}},{key:"onFilterDate",value:function onFilterDate(){if(this.state.filter&&this.state.filter.from&&this.state.filter.to){this.onRefresh();}}},{key:"onChangeTab",value:function onChangeTab(evt,value){this.setState({tabIndex:value,page:0});}},{key:"onOpenDetail",value:function onOpenDetail(evtId){var openDetail=Object.assign({},this.state.openDetail);openDetail[evtId]=openDetail[evtId]?false:true;console.log("OPEN DETAIL",openDetail);this.setState({openDetail:openDetail});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this2=this;var theme=this.props.theme;var headers=[{id:"evtId",label:"Evento"},//  {id:"tktType",label:"Tipo de Ticket"},
{id:"Qt",label:"Cantidad"},{id:"Total",label:"Total $"},{id:"TotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){if(headCell.id=="evtId"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["U" /* TableSortLabel */],{active:_this2.state.orderBy===headCell.id,direction:_this2.state.orderBy===headCell.id&&_this2.state.orderDesc?'desc':'asc',onClick:function onClick(){return _this2.onSortByField(headCell.id);},hideSortIcon:true},headCell.label));}));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var _props=this.props,theme=_props.theme,statsByClientDetail=_props.statsByClientDetail;var openDetail=this.state.openDetail;if(!statsByClientDetail||statsByClientDetail.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return statsByClientDetail.map(function(item,index){var isOpen=openDetail[item.evtId];console.log("IS OPEN",isOpen,openDetail,item.evtId);return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Button */],{startIcon:isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp___default.a,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown___default.a,null),onClick:_this3.onOpenDetail.bind(_this3,item.evtId)},item.evtName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.evtQt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.evtTotal),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.evtTotalProducer)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["i" /* Collapse */],{"in":isOpen,timeout:"auto",unmountOnExit:true,style:{aligItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{marginLeft:20,width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["R" /* TableHead */],null,_this3.renderTableHeaderDetail()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["P" /* TableBody */],null,_this3.renderTableBodyDetail(item.tktTypeData))))];});}},{key:"renderTableHeaderDetail",value:function renderTableHeaderDetail(){var theme=this.props.theme;var headers=[{id:"id",label:"Tipo de Ticket"},//  {id:"tktType",label:"Tipo de Ticket"},
{id:"Qt",label:"Cantidad"},{id:"Total",label:"Total $"},{id:"TotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){// if(headCell.id == "evtId"){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);// }
// return (
//   <TableCell>
//     <TableSortLabel
//     active={this.state.orderBy === headCell.id}
//     direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
//     onClick={()=>this.onSortByField(headCell.id)}
//     hideSortIcon={true}>
//       {headCell.label}
//     </TableSortLabel>  
//   </TableCell>
// )
}));}},{key:"renderTableBodyDetail",value:function renderTableBodyDetail(detail){var theme=this.props.theme;if(!detail||detail.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return detail.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktCategory+" - "+item.tktName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.Qt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.Total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.TotalProducer)));});}},{key:"onClose",value:function onClose(){this.setState({openDetail:{}});this.props.onClose();}},{key:"render",value:function render(){var _props2=this.props,theme=_props2.theme,handleSubmit=_props2.handleSubmit,history=_props2.history,placeList=_props2.placeList,user=_props2.user;var filter=this.state.filter;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["k" /* Dialog */],{open:user?true:false,onClose:this.onClose},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["o" /* DialogTitle */],null,user?"Detalle de "+user.tktBuyerLastName+", "+user.tktBuyerName:""),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"space-between"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:filter.from,label:"Fecha desde",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"from")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:filter.to,label:"Fecha hasta",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"to")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:this.onFilterDate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__material_ui_icons_Search___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())));}}]);return Statistics;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE STATISTICS",store);return{login:store.auth.login,statsByClientDetail:store.stats.statsByClientDetail,placeList:store.plc.placeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetStatsByClientDetail:__WEBPACK_IMPORTED_MODULE_13__actions_StatsActions__["b" /* actionGetStatsByClientDetail */]},dispatch);}// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Statistics))));

/***/ }),
/* 1531 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__material_ui_icons_ArrowBackRounded__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__material_ui_icons_ChevronRight__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_Util__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__provider_base_Settings__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__provider_base_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__provider_base_Settings__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__actions_StatsActions__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__actions_PlaceActions__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Search__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Search___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Search__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Sync__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Sync___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__material_ui_icons_Sync__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_List__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__material_ui_icons_List___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__material_ui_icons_List__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import ClearIcon from '@material-ui/icons/Backspace';
var _handleSubmitFail=void 0;// const stateList = {all:"Todos los estados",pendingUse:"Sin usar",already_used:"Usado"}
var Statistics=function(_React$PureComponent){_inherits(Statistics,_React$PureComponent);function Statistics(props){_classCallCheck(this,Statistics);var _this=_possibleConstructorReturn(this,(Statistics.__proto__||Object.getPrototypeOf(Statistics)).call(this,props));var lastMonth=__WEBPACK_IMPORTED_MODULE_15_moment___default()();lastMonth=lastMonth.add(-1,"month").format("YYYY-MM-DD");var today=__WEBPACK_IMPORTED_MODULE_15_moment___default()().format("YYYY-MM-DD");var filter={from:lastMonth,to:today,period:"daily",place:"",state:"",onlyGift:false};_this.state={count:0,rowPerPage:10,page:1,orderBy:"evtQt",orderDesc:true,filter:filter,tabIndex:0,openDetail:{}};_handleSubmitFail=_this.handleSubmitFail.bind(_this);_this.renderTableHeader=_this.renderTableHeader.bind(_this);_this.renderTableBody=_this.renderTableBody.bind(_this);_this.onRefresh=_this.onRefresh.bind(_this);_this.sortStatsByEvent=_this.sortStatsByEvent.bind(_this);_this.onFilterDate=_this.onFilterDate.bind(_this);_this.onChangePage=_this.onChangePage.bind(_this);_this.onChangeRowsPerPage=_this.onChangeRowsPerPage.bind(_this);_this.onChangeTab=_this.onChangeTab.bind(_this);return _this;}_createClass(Statistics,[{key:"componentWillMount",value:function componentWillMount(){if(!this.props.login){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_4__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}else{this.onRefresh();this.props.actionGetPlaces(null,this.getPlacesError);}}},{key:"getStatsByEventError",value:function getStatsByEventError(e){console.log("ERROR GET STATS BY Event",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_11__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las estadísticas por Evento.");}},{key:"getPlacesError",value:function getPlacesError(e){console.log("ERROR GET Places",e);if(!(e&&e.status&&e.status==401))__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].showNoty(__WEBPACK_IMPORTED_MODULE_11__common_Util__["a" /* ERROR */],"Ocurrió un error al listar las ubicaciones.");}},{key:"handleSubmitFail",value:function handleSubmitFail(error){console.log("ERROR EN EL SUBMIT",error);}},{key:"onRefresh",value:function onRefresh(){var _state=this.state,orderBy=_state.orderBy,orderDesc=_state.orderDesc,filter=_state.filter;var order={orderBy:orderBy,orderDesc:orderDesc};this.props.actionGetStatsByEvent(filter,order,this.onChangePage,this.getStatsByEventError);}},{key:"onDetailUser",value:function onDetailUser(user){}},{key:"onSortByField",value:function onSortByField(field){if(field==this.state.orderBy){this.setState({orderDesc:!this.state.orderDesc},this.onChangePage);}else{this.setState({orderBy:field},this.onChangePage);}}},{key:"onChangePage",value:function onChangePage(){var evt=arguments.length>0&&arguments[0]!==undefined?arguments[0]:null;var newPage=arguments.length>1&&arguments[1]!==undefined?arguments[1]:0;var from=newPage*this.state.rowPerPage;var end=from+this.state.rowPerPage;var users=this.props.statsByEvent;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByEvent);users=users.slice(from,end);this.setState({page:newPage,count:count,users:users});}},{key:"onChangeRowsPerPage",value:function onChangeRowsPerPage(evt){var from=this.state.page*evt.target.value;var end=from+evt.target.value;var users=this.props.statsByEvent;//.filter(this.filterUsers)
var count=users.length;users=users.sort(this.sortStatsByEvent);users=users.slice(from,end);this.setState({rowPerPage:evt.target.value,users:users});}},{key:"sortStatsByEvent",value:function sortStatsByEvent(a,b){try{if(this.state.orderDesc){return b[this.state.orderBy]-a[this.state.orderBy];}return a[this.state.orderBy]-b[this.state.orderBy];}catch(e){console.log("SORT STATS BY CLIENT ERROR",e);return-1;}}},{key:"onChangeFilter",value:function onChangeFilter(field,evt){var filter=Object.assign({},this.state.filter);console.log("VALUE",evt.target.value);filter[field]=field=="onlyGift"?evt.target.checked:evt.target.value;// if(field=="state"){//Si estoy modificando el estado y seleccioné mas de uno 
//   if(filter[field].length==0||filter[field][filter[field].length-1]=="all"){//Si deseleccionó todo o seleccionó all
//     filter[field] = ["all"]
//   }else{
//     filter[field] = filter[field].filter((s)=>s!="all")//Quito "Todos los estados" de los seleccionados
//   }
// }
console.log("FILTER",filter);this.setState({filter:filter});}},{key:"onFilterDate",value:function onFilterDate(){if(this.state.filter&&this.state.filter.from&&this.state.filter.to){this.onRefresh();}}},{key:"onChangeTab",value:function onChangeTab(evt,value){this.setState({tabIndex:value,page:0});}},{key:"onOpenDetail",value:function onOpenDetail(evtId){var openDetail=Object.assign({},this.state.openDetail);openDetail[evtId]=openDetail[evtId]?false:true;this.setState({openDetail:openDetail});}},{key:"renderTableHeader",value:function renderTableHeader(){var _this2=this;var theme=this.props.theme;var headers=[{id:"evtName",label:"Evento"},{id:"tktPlaceName",label:"Ubicación"},{id:"evtQt",label:"Cantidad"},{id:"evtTotal",label:"Total $"},{id:"evtTotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){if(headCell.id=="tktBuyerDU"||headCell.id=="tktBuyerLastName"){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["U" /* TableSortLabel */],{active:_this2.state.orderBy===headCell.id,direction:_this2.state.orderBy===headCell.id&&_this2.state.orderDesc?'desc':'asc',onClick:function onClick(){return _this2.onSortByField(headCell.id);},hideSortIcon:true},headCell.label));}));}},{key:"renderTableBody",value:function renderTableBody(){var _this3=this;var theme=this.props.theme;var _state2=this.state,users=_state2.users,openDetail=_state2.openDetail;if(!users||users.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return users.map(function(item,index){var isOpen=openDetail[item.evtId];return[__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["e" /* Button */],{startIcon:isOpen?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__material_ui_icons_ArrowDropUp___default.a,null):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__material_ui_icons_ArrowDropDown___default.a,null),onClick:_this3.onOpenDetail.bind(_this3,item.evtId)},item.evtName)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.evtPlace),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.evtQt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.evtTotal)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.evtTotalProducer))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["i" /* Collapse */],{"in":isOpen,timeout:"auto",unmountOnExit:true,style:{aligItems:"center"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["O" /* Table */],{stickyHeader:true,style:{marginLeft:20,width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["R" /* TableHead */],null,_this3.renderTableHeaderDetail()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["P" /* TableBody */],null,_this3.renderTableBodyDetail(item.tktTypeData))))];});}},{key:"renderTableHeaderDetail",value:function renderTableHeaderDetail(){var theme=this.props.theme;var headers=[{id:"id",label:"Tipo de Ticket"},//  {id:"tktType",label:"Tipo de Ticket"},
{id:"Qt",label:"Cantidad"},{id:"Total",label:"Total $"},{id:"TotalProducer",label:"Total $ Productor"}];// if(Settings.IS_USER_VERIFIED){
//   headers.splice(1,0,{id:"proInstagram",label:"Instagram"})
// }
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],null,headers.map(function(headCell,i){// if(headCell.id == "evtId"){
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null," ",headCell.label);// }
// return (
//   <TableCell>
//     <TableSortLabel
//     active={this.state.orderBy === headCell.id}
//     direction={this.state.orderBy === headCell.id && this.state.orderDesc ? 'desc' : 'asc'}
//     onClick={()=>this.onSortByField(headCell.id)}
//     hideSortIcon={true}>
//       {headCell.label}
//     </TableSortLabel>  
//   </TableCell>
// )
}));}},{key:"renderTableBodyDetail",value:function renderTableBodyDetail(detail){var theme=this.props.theme;if(!detail||detail.length==0){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.table.empty},"No se encontraron registros");}return detail.map(function(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["T" /* TableRow */],{style:index%2==0?theme.table.row:theme.table.rowColor},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.tktCategory+" - "+item.tktName),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,item.Qt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.Total)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Q" /* TableCell */],null,__WEBPACK_IMPORTED_MODULE_11__common_Util__["d" /* default */].formatCurrency(item.TotalProducer)));});}},{key:"render",value:function render(){var _props=this.props,theme=_props.theme,handleSubmit=_props.handleSubmit,history=_props.history,placeList=_props.placeList;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["J" /* Paper */],{style:theme.paper.form},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["X" /* Toolbar */],{style:Object.assign({},theme.table.toolbar,{justifyContent:"space-between"})},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:this.state.filter.from,label:"Fecha desde",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"from")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["W" /* TextField */],{value:this.state.filter.to,label:"Fecha hasta",type:"date",InputLabelProps:{shrink:true},onChange:this.onChangeFilter.bind(this,"to")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["r" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["B" /* InputLabel */],{id:"stateLabel",shrink:true},"Estado"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["L" /* Select */],{labelId:"stateLabel",value:this.state.filter.state,onChange:this.onChangeFilter.bind(this,"state"),displayEmpty:true// multiple
// renderValue={(selected) => (
//   <div >
//     {selected.map((item) => (
//       <Chip key={item} label={stateList[item]} color="primary"/>
//     ))}
//   </div>
// )}
},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Todos los estados")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:"pendingUse"},"Sin usar"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:"already_used"},"Usado"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["r" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["s" /* FormControlLabel */],{label:"Solo invitaciones",control:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["f" /* Checkbox */],{color:"primary",checked:this.state.filter.onlyGift,onChange:this.onChangeFilter.bind(this,"onlyGift")})})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["r" /* FormControl */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["B" /* InputLabel */],{id:"placeLabel",shrink:true},"Ubicaci\xF3n"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["L" /* Select */],{labelId:"placeLabel",value:this.state.filter.place,onChange:this.onChangeFilter.bind(this,"place"),displayEmpty:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:""},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Todas las ubicaciones")),placeList&&placeList.map(function(p){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["I" /* MenuItem */],{value:p.id},p.plcName);}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["y" /* IconButton */],{onClick:this.onFilterDate},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__material_ui_icons_Search___default.a,null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["O" /* Table */],{stickyHeader:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["R" /* TableHead */],null,this.renderTableHeader()),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["P" /* TableBody */],null,this.renderTableBody())),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["S" /* TablePagination */],{rowsPerPageOptions:[5,10,25,100],component:"div",count:this.state.count,rowsPerPage:this.state.rowPerPage,page:this.state.page,onChangePage:this.onChangePage,onChangeRowsPerPage:this.onChangeRowsPerPage}));}}]);return Statistics;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){console.log("STORE STATISTICS",store);return{login:store.auth.login,statsByEvent:store.stats.statsByEvent,placeList:store.plc.placeList};}function mapDispatchToProps(dispatch){return Object(__WEBPACK_IMPORTED_MODULE_1_redux__["b" /* bindActionCreators */])({actionGetStatsByEvent:__WEBPACK_IMPORTED_MODULE_13__actions_StatsActions__["c" /* actionGetStatsByEvent */],actionGetPlaces:__WEBPACK_IMPORTED_MODULE_14__actions_PlaceActions__["b" /* actionGetPlaces */]},dispatch);}// Statistics.defaultProps = {
//   stats:{
//     statsTotalQtSell:50,
//     statsTotalQt:1000,
//     statsTotalAmmountProducer:22000,
//     statsTotalAmmount:27000,
//     statsTotalQtSellByRRPP:1100 //transient
//   }
// }
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps)(Statistics))));

/***/ }),
/* 1532 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_redux__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__config_RolesConstants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__ = __webpack_require__(13);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Home=function(_React$PureComponent){_inherits(Home,_React$PureComponent);function Home(){_classCallCheck(this,Home);return _possibleConstructorReturn(this,(Home.__proto__||Object.getPrototypeOf(Home)).apply(this,arguments));}_createClass(Home,[{key:"render",value:function render(){var _props=this.props,login=_props.login,theme=_props.theme;var roles=this.props.profile&&this.props.profile.proRoles;console.log("ROLES HOME",roles);if(login){if(roles){if(roles.some(function(r){return r.id==__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__["SUPERADMIN"]||r.id==__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__["PRODUCTOR"]||r.id==__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__["REDIMIDOR"];})){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_3__config_RoutesConstants__["d" /* EVENTS_ROUTE */]);}else{if(roles.some(function(r){console.log("HOME",r,r.id,__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__["ADMIN"]);return r.id==__WEBPACK_IMPORTED_MODULE_2__config_RolesConstants__["ADMIN"];})){this.props.history.replace(__WEBPACK_IMPORTED_MODULE_3__config_RoutesConstants__["E" /* USERS_ROUTE */]);}}}}else{this.props.history.replace(__WEBPACK_IMPORTED_MODULE_3__config_RoutesConstants__["j" /* LOGIN_ROUTE */]);}return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["d" /* Box */],{style:theme.mainContainer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__material_ui_core__["Z" /* Typography */],null,"Home"));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);function mapStateToProps(store){return{login:store.auth.login,profile:store.auth.profile};}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["f" /* withRouter */])(Object(__WEBPACK_IMPORTED_MODULE_6__material_ui_core_styles__["h" /* withTheme */])(Object(__WEBPACK_IMPORTED_MODULE_1_react_redux__["b" /* connect */])(mapStateToProps)(Home))));

/***/ }),
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _CSSTransitionGroup = __webpack_require__(1535);

var _CSSTransitionGroup2 = _interopRequireDefault(_CSSTransitionGroup);

var _TransitionGroup = __webpack_require__(581);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  TransitionGroup: _TransitionGroup2.default,
  CSSTransitionGroup: _CSSTransitionGroup2.default
};

/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TransitionGroup = __webpack_require__(581);

var _TransitionGroup2 = _interopRequireDefault(_TransitionGroup);

var _CSSTransitionGroupChild = __webpack_require__(1538);

var _CSSTransitionGroupChild2 = _interopRequireDefault(_CSSTransitionGroupChild);

var _PropTypes = __webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
  transitionName: _PropTypes.nameShape.isRequired,

  transitionAppear: _propTypes2.default.bool,
  transitionEnter: _propTypes2.default.bool,
  transitionLeave: _propTypes2.default.bool,
  transitionAppearTimeout: (0, _PropTypes.transitionTimeout)('Appear'),
  transitionEnterTimeout: (0, _PropTypes.transitionTimeout)('Enter'),
  transitionLeaveTimeout: (0, _PropTypes.transitionTimeout)('Leave')
};

var defaultProps = {
  transitionAppear: false,
  transitionEnter: true,
  transitionLeave: true
};

var CSSTransitionGroup = function (_React$Component) {
  _inherits(CSSTransitionGroup, _React$Component);

  function CSSTransitionGroup() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroup);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this._wrapChild = function (child) {
      return _react2.default.createElement(_CSSTransitionGroupChild2.default, {
        name: _this.props.transitionName,
        appear: _this.props.transitionAppear,
        enter: _this.props.transitionEnter,
        leave: _this.props.transitionLeave,
        appearTimeout: _this.props.transitionAppearTimeout,
        enterTimeout: _this.props.transitionEnterTimeout,
        leaveTimeout: _this.props.transitionLeaveTimeout
      }, child);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  // We need to provide this childFactory so that
  // ReactCSSTransitionGroupChild can receive updates to name, enter, and
  // leave while it is leaving.


  CSSTransitionGroup.prototype.render = function render() {
    return _react2.default.createElement(_TransitionGroup2.default, _extends({}, this.props, { childFactory: this._wrapChild }));
  };

  return CSSTransitionGroup;
}(_react2.default.Component);

CSSTransitionGroup.displayName = 'CSSTransitionGroup';


CSSTransitionGroup.propTypes =  false ? propTypes : {};
CSSTransitionGroup.defaultProps = defaultProps;

exports.default = CSSTransitionGroup;
module.exports = exports['default'];

/***/ }),
/* 1536 */
/***/ (function(module, exports) {


module.exports = function chain(){
  var len = arguments.length
  var args = [];

  for (var i = 0; i < len; i++)
    args[i] = arguments[i]

  args = args.filter(function(fn){ return fn != null })

  if (args.length === 0) return undefined
  if (args.length === 1) return args[0]

  return args.reduce(function(current, next){
    return function chainedFunction() {
      current.apply(this, arguments);
      next.apply(this, arguments);
    };
  })
}


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.getChildMapping = getChildMapping;
exports.mergeChildMappings = mergeChildMappings;

var _react = __webpack_require__(0);

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */
function getChildMapping(children) {
  if (!children) {
    return children;
  }
  var result = {};
  _react.Children.map(children, function (child) {
    return child;
  }).forEach(function (child) {
    result[child.key] = child;
  });
  return result;
}

/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */
function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    if (next.hasOwnProperty(key)) {
      return next[key];
    }

    return prev[key];
  }

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextKeysPending = {};

  var pendingKeys = [];
  for (var prevKey in prev) {
    if (next.hasOwnProperty(prevKey)) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i = void 0;
  var childMapping = {};
  for (var nextKey in next) {
    if (nextKeysPending.hasOwnProperty(nextKey)) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }
    childMapping[nextKey] = getValueForKey(nextKey);
  }

  // Finally, add the keys which didn't appear before any key in `next`
  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _addClass = __webpack_require__(525);

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = __webpack_require__(527);

var _removeClass2 = _interopRequireDefault(_removeClass);

var _requestAnimationFrame = __webpack_require__(1539);

var _requestAnimationFrame2 = _interopRequireDefault(_requestAnimationFrame);

var _properties = __webpack_require__(199);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(17);

var _PropTypes = __webpack_require__(582);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var events = [];
if (_properties.transitionEnd) events.push(_properties.transitionEnd);
if (_properties.animationEnd) events.push(_properties.animationEnd);

function addEndListener(node, listener) {
  if (events.length) {
    events.forEach(function (e) {
      return node.addEventListener(e, listener, false);
    });
  } else {
    setTimeout(listener, 0);
  }

  return function () {
    if (!events.length) return;
    events.forEach(function (e) {
      return node.removeEventListener(e, listener, false);
    });
  };
}

var propTypes = {
  children: _propTypes2.default.node,
  name: _PropTypes.nameShape.isRequired,

  // Once we require timeouts to be specified, we can remove the
  // boolean flags (appear etc.) and just accept a number
  // or a bool for the timeout flags (appearTimeout etc.)
  appear: _propTypes2.default.bool,
  enter: _propTypes2.default.bool,
  leave: _propTypes2.default.bool,
  appearTimeout: _propTypes2.default.number,
  enterTimeout: _propTypes2.default.number,
  leaveTimeout: _propTypes2.default.number
};

var CSSTransitionGroupChild = function (_React$Component) {
  _inherits(CSSTransitionGroupChild, _React$Component);

  function CSSTransitionGroupChild() {
    var _temp, _this, _ret;

    _classCallCheck(this, CSSTransitionGroupChild);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.componentWillAppear = function (done) {
      if (_this.props.appear) {
        _this.transition('appear', done, _this.props.appearTimeout);
      } else {
        done();
      }
    }, _this.componentWillEnter = function (done) {
      if (_this.props.enter) {
        _this.transition('enter', done, _this.props.enterTimeout);
      } else {
        done();
      }
    }, _this.componentWillLeave = function (done) {
      if (_this.props.leave) {
        _this.transition('leave', done, _this.props.leaveTimeout);
      } else {
        done();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CSSTransitionGroupChild.prototype.componentWillMount = function componentWillMount() {
    this.classNameAndNodeQueue = [];
    this.transitionTimeouts = [];
  };

  CSSTransitionGroupChild.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unmounted = true;

    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.transitionTimeouts.forEach(function (timeout) {
      clearTimeout(timeout);
    });

    this.classNameAndNodeQueue.length = 0;
  };

  CSSTransitionGroupChild.prototype.transition = function transition(animationType, finishCallback, timeout) {
    var node = (0, _reactDom.findDOMNode)(this);

    if (!node) {
      if (finishCallback) {
        finishCallback();
      }
      return;
    }

    var className = this.props.name[animationType] || this.props.name + '-' + animationType;
    var activeClassName = this.props.name[animationType + 'Active'] || className + '-active';
    var timer = null;
    var removeListeners = void 0;

    (0, _addClass2.default)(node, className);

    // Need to do this to actually trigger a transition.
    this.queueClassAndNode(activeClassName, node);

    // Clean-up the animation after the specified delay
    var finish = function finish(e) {
      if (e && e.target !== node) {
        return;
      }

      clearTimeout(timer);
      if (removeListeners) removeListeners();

      (0, _removeClass2.default)(node, className);
      (0, _removeClass2.default)(node, activeClassName);

      if (removeListeners) removeListeners();

      // Usually this optional callback is used for informing an owner of
      // a leave animation and telling it to remove the child.
      if (finishCallback) {
        finishCallback();
      }
    };

    if (timeout) {
      timer = setTimeout(finish, timeout);
      this.transitionTimeouts.push(timer);
    } else if (_properties.transitionEnd) {
      removeListeners = addEndListener(node, finish);
    }
  };

  CSSTransitionGroupChild.prototype.queueClassAndNode = function queueClassAndNode(className, node) {
    var _this2 = this;

    this.classNameAndNodeQueue.push({
      className: className,
      node: node
    });

    if (!this.rafHandle) {
      this.rafHandle = (0, _requestAnimationFrame2.default)(function () {
        return _this2.flushClassNameAndNodeQueue();
      });
    }
  };

  CSSTransitionGroupChild.prototype.flushClassNameAndNodeQueue = function flushClassNameAndNodeQueue() {
    if (!this.unmounted) {
      this.classNameAndNodeQueue.forEach(function (obj) {
        // This is for to force a repaint,
        // which is necessary in order to transition styles when adding a class name.
        /* eslint-disable no-unused-expressions */
        obj.node.scrollTop;
        /* eslint-enable no-unused-expressions */
        (0, _addClass2.default)(obj.node, obj.className);
      });
    }
    this.classNameAndNodeQueue.length = 0;
    this.rafHandle = null;
  };

  CSSTransitionGroupChild.prototype.render = function render() {
    var props = _extends({}, this.props);
    delete props.name;
    delete props.appear;
    delete props.enter;
    delete props.leave;
    delete props.appearTimeout;
    delete props.enterTimeout;
    delete props.leaveTimeout;
    delete props.children;
    return _react2.default.cloneElement(_react2.default.Children.only(this.props.children), props);
  };

  return CSSTransitionGroupChild;
}(_react2.default.Component);

CSSTransitionGroupChild.displayName = 'CSSTransitionGroupChild';


CSSTransitionGroupChild.propTypes =  false ? propTypes : {};

exports.default = CSSTransitionGroupChild;
module.exports = exports['default'];

/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(27);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(76));

var vendors = ['', 'webkit', 'moz', 'o', 'ms'];
var cancel = 'clearTimeout';
var raf = fallback;
var compatRaf;

var getKey = function getKey(vendor, k) {
  return vendor + (!vendor ? k : k[0].toUpperCase() + k.substr(1)) + 'AnimationFrame';
};

if (_inDOM.default) {
  vendors.some(function (vendor) {
    var rafKey = getKey(vendor, 'request');

    if (rafKey in window) {
      cancel = getKey(vendor, 'cancel');
      return raf = function raf(cb) {
        return window[rafKey](cb);
      };
    }
  });
}
/* https://github.com/component/raf */


var prev = new Date().getTime();

function fallback(fn) {
  var curr = new Date().getTime(),
      ms = Math.max(0, 16 - (curr - prev)),
      req = setTimeout(fn, ms);
  prev = curr;
  return req;
}

compatRaf = function compatRaf(cb) {
  return raf(cb);
};

compatRaf.cancel = function (id) {
  window[cancel] && typeof window[cancel] === 'function' && window[cancel](id);
};

var _default = compatRaf;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "css", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "keyframes", function() { return keyframes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "injectGlobal", function() { return injectGlobal; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ThemeProvider", function() { return ThemeProvider; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withTheme", function() { return wrapWithTheme; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ServerStyleSheet", function() { return ServerStyleSheet; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyleSheetManager", function() { return StyleSheetManager; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_plain_object__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(1541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);






/**
 * Copyright (c) 2013-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate$2(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

var hyphenate_1 = hyphenate$2;

var hyphenate = hyphenate_1;

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

var hyphenateStyleName_1 = hyphenateStyleName;

//      
var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(obj[key])) return objToCss(obj[key], key);
    return hyphenateStyleName_1(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }
    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      return [].concat(ruleSet, flatten(chunk, executionContext));
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      return [].concat(ruleSet, ['.' + chunk.styledComponentId]);
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      return executionContext ? ruleSet.concat.apply(ruleSet, flatten([chunk(executionContext)], executionContext)) : ruleSet.concat(chunk);
    }

    /* Handle objects */
    return ruleSet.concat(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    __WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(chunk) ? objToCss(chunk) : chunk.toString());
  }, []);
};

//      
var stylis = new __WEBPACK_IMPORTED_MODULE_1_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: true
});

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(/^\s*\/\/.*$/gm, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

//      
var chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');
var charsLength = chars.length;

/* Some high number, usually 9-digit base-10. Map it to base-😎 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = chars[x % charsLength] + name;
  }

  return chars[x % charsLength] + name;
};

//      


var interleave = (function (strings, interpolations) {
  return interpolations.reduce(function (array, interp, i) {
    return array.concat(interp, strings[i + 1]);
  }, [strings[0]]);
});

//      
var css = (function (strings) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  return flatten(interleave(strings, interpolations));
});

//      
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s+(\S+)\s+\*\//gm;

var extractCompsFromCSS = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

//      
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
                                     return  true ? __webpack_require__.nc : null;
});

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();







var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

//      
/* eslint-disable no-underscore-dangle */
/*
 * Browser Style Sheet with Rehydration
 *
 * <style data-styled-components="x y z"
 *        data-styled-components-is-local="true">
 *   /· sc-component-id: a ·/
 *   .sc-a { ... }
 *   .x { ... }
 *   /· sc-component-id: b ·/
 *   .sc-b { ... }
 *   .y { ... }
 *   .z { ... }
 * </style>
 *
 * Note: replace · with * in the above snippet.
 * */
var COMPONENTS_PER_TAG = 40;

var BrowserTag = function () {
  function BrowserTag(el, isLocal) {
    var existingSource = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    classCallCheck(this, BrowserTag);

    this.el = el;
    this.isLocal = isLocal;
    this.ready = false;

    var extractedComps = extractCompsFromCSS(existingSource);

    this.size = extractedComps.length;
    this.components = extractedComps.reduce(function (acc, obj) {
      acc[obj.componentId] = obj; // eslint-disable-line no-param-reassign
      return acc;
    }, {});
  }

  BrowserTag.prototype.isFull = function isFull() {
    return this.size >= COMPONENTS_PER_TAG;
  };

  BrowserTag.prototype.addComponent = function addComponent(componentId) {
    if (!this.ready) this.replaceElement();
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }

    var comp = { componentId: componentId, textNode: document.createTextNode('') };
    this.el.appendChild(comp.textNode);

    this.size += 1;
    this.components[componentId] = comp;
  };

  BrowserTag.prototype.inject = function inject(componentId, css, name) {
    if (!this.ready) this.replaceElement();
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.textNode.data === '') {
      comp.textNode.appendData('\n/* sc-component-id: ' + componentId + ' */\n');
    }

    comp.textNode.appendData(css);
    if (name) {
      var existingNames = this.el.getAttribute(SC_ATTR);
      this.el.setAttribute(SC_ATTR, existingNames ? existingNames + ' ' + name : name);
    }

    var nonce = getNonce();

    if (nonce) {
      this.el.setAttribute('nonce', nonce);
    }
  };

  BrowserTag.prototype.toHTML = function toHTML() {
    return this.el.outerHTML;
  };

  BrowserTag.prototype.toReactElement = function toReactElement() {
    throw new Error("BrowserTag doesn't implement toReactElement!");
  };

  BrowserTag.prototype.clone = function clone() {
    throw new Error('BrowserTag cannot be cloned!');
  };

  /* Because we care about source order, before we can inject anything we need to
   * create a text node for each component and replace the existing CSS. */


  BrowserTag.prototype.replaceElement = function replaceElement() {
    var _this = this;

    this.ready = true;
    // We have nothing to inject. Use the current el.
    if (this.size === 0) return;

    // Build up our replacement style tag
    var newEl = this.el.cloneNode();
    newEl.appendChild(document.createTextNode('\n'));

    Object.keys(this.components).forEach(function (key) {
      var comp = _this.components[key];

      // eslint-disable-next-line no-param-reassign
      comp.textNode = document.createTextNode(comp.cssFromDOM);
      newEl.appendChild(comp.textNode);
    });

    if (!this.el.parentNode) {
      throw new Error("Trying to replace an element that wasn't mounted!");
    }

    // The ol' switcheroo
    this.el.parentNode.replaceChild(newEl, this.el);
    this.el = newEl;
  };

  return BrowserTag;
}();

/* Factory function to separate DOM operations from logical ones*/


var BrowserStyleSheet = {
  create: function create() {
    var tags = [];
    var names = {};

    /* Construct existing state from DOM */
    var nodes = document.querySelectorAll('[' + SC_ATTR + ']');
    var nodesLength = nodes.length;

    for (var i = 0; i < nodesLength; i += 1) {
      var el = nodes[i];

      tags.push(new BrowserTag(el, el.getAttribute(LOCAL_ATTR) === 'true', el.innerHTML));

      var attr = el.getAttribute(SC_ATTR);
      if (attr) {
        attr.trim().split(/\s+/).forEach(function (name) {
          names[name] = true;
        });
      }
    }

    /* Factory for making more tags */
    var tagConstructor = function tagConstructor(isLocal) {
      var el = document.createElement('style');
      el.type = 'text/css';
      el.setAttribute(SC_ATTR, '');
      el.setAttribute(LOCAL_ATTR, isLocal ? 'true' : 'false');
      if (!document.head) throw new Error('Missing document <head>');
      document.head.appendChild(el);
      return new BrowserTag(el, isLocal);
    };

    return new StyleSheet(tagConstructor, tags, names);
  }
};

//      
var SC_ATTR = 'data-styled-components';
var LOCAL_ATTR = 'data-styled-components-is-local';
var CONTEXT_KEY = '__styled-components-stylesheet__';

/* eslint-disable flowtype/object-type-delimiter */

/* eslint-enable flowtype/object-type-delimiter */

var instance = null;
// eslint-disable-next-line no-use-before-define
var clones = [];

var StyleSheet = function () {
  function StyleSheet(tagConstructor) {
    var tags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var names = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    classCallCheck(this, StyleSheet);
    this.hashes = {};
    this.deferredInjections = {};
    this.stylesCacheable = typeof document !== 'undefined';

    this.tagConstructor = tagConstructor;
    this.tags = tags;
    this.names = names;
    this.constructComponentTagMap();
  }

  // helper for `ComponentStyle` to know when it cache static styles.
  // staticly styled-component can not safely cache styles on the server
  // without all `ComponentStyle` instances saving a reference to the
  // the styleSheet instance they last rendered with,
  // or listening to creation / reset events. otherwise you might create
  // a component with one stylesheet and render it another api response
  // with another, losing styles on from your server-side render.


  StyleSheet.prototype.constructComponentTagMap = function constructComponentTagMap() {
    var _this = this;

    this.componentTags = {};

    this.tags.forEach(function (tag) {
      Object.keys(tag.components).forEach(function (componentId) {
        _this.componentTags[componentId] = tag;
      });
    });
  };

  /* Best level of caching—get the name from the hash straight away. */


  StyleSheet.prototype.getName = function getName(hash) {
    return this.hashes[hash.toString()];
  };

  /* Second level of caching—if the name is already in the dom, don't
   * inject anything and record the hash for getName next time. */


  StyleSheet.prototype.alreadyInjected = function alreadyInjected(hash, name) {
    if (!this.names[name]) return false;

    this.hashes[hash.toString()] = name;
    return true;
  };

  /* Third type of caching—don't inject components' componentId twice. */


  StyleSheet.prototype.hasInjectedComponent = function hasInjectedComponent(componentId) {
    return !!this.componentTags[componentId];
  };

  StyleSheet.prototype.deferredInject = function deferredInject(componentId, isLocal, css) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.deferredInject(componentId, isLocal, css);
      });
    }

    this.getOrCreateTag(componentId, isLocal);
    this.deferredInjections[componentId] = css;
  };

  StyleSheet.prototype.inject = function inject(componentId, isLocal, css, hash, name) {
    if (this === instance) {
      clones.forEach(function (clone) {
        clone.inject(componentId, isLocal, css);
      });
    }

    var tag = this.getOrCreateTag(componentId, isLocal);

    var deferredInjection = this.deferredInjections[componentId];
    if (deferredInjection) {
      tag.inject(componentId, deferredInjection);
      delete this.deferredInjections[componentId];
    }

    tag.inject(componentId, css, name);

    if (hash && name) {
      this.hashes[hash.toString()] = name;
    }
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    return this.tags.map(function (tag, i) {
      return tag.toReactElement('sc-' + i);
    });
  };

  StyleSheet.prototype.getOrCreateTag = function getOrCreateTag(componentId, isLocal) {
    var existingTag = this.componentTags[componentId];
    if (existingTag) {
      return existingTag;
    }

    var lastTag = this.tags[this.tags.length - 1];
    var componentTag = !lastTag || lastTag.isFull() || lastTag.isLocal !== isLocal ? this.createNewTag(isLocal) : lastTag;
    this.componentTags[componentId] = componentTag;
    componentTag.addComponent(componentId);
    return componentTag;
  };

  StyleSheet.prototype.createNewTag = function createNewTag(isLocal) {
    var newTag = this.tagConstructor(isLocal);
    this.tags.push(newTag);
    return newTag;
  };

  StyleSheet.reset = function reset(isServer) {
    instance = StyleSheet.create(isServer);
  };

  /* We can make isServer totally implicit once Jest 20 drops and we
   * can change environment on a per-test basis. */


  StyleSheet.create = function create() {
    var isServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : typeof document === 'undefined';

    return (isServer ? ServerStyleSheet : BrowserStyleSheet).create();
  };

  StyleSheet.clone = function clone(oldSheet) {
    var newSheet = new StyleSheet(oldSheet.tagConstructor, oldSheet.tags.map(function (tag) {
      return tag.clone();
    }), _extends({}, oldSheet.names));

    newSheet.hashes = _extends({}, oldSheet.hashes);
    newSheet.deferredInjections = _extends({}, oldSheet.deferredInjections);
    clones.push(newSheet);

    return newSheet;
  };

  createClass(StyleSheet, null, [{
    key: 'instance',
    get: function get$$1() {
      return instance || (instance = StyleSheet.create());
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

//      
var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.props.sheet, _ref;
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);

StyleSheetManager.propTypes = {
  sheet: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired
};

//      
/* eslint-disable no-underscore-dangle */
var ServerTag = function () {
  function ServerTag(isLocal) {
    classCallCheck(this, ServerTag);

    this.isLocal = isLocal;
    this.components = {};
    this.size = 0;
    this.names = [];
  }

  ServerTag.prototype.isFull = function isFull() {
    return false;
  };

  ServerTag.prototype.addComponent = function addComponent(componentId) {
    if (false) {
      throw new Error('Trying to add Component \'' + componentId + '\' twice!');
    }
    this.components[componentId] = { componentId: componentId, css: '' };
    this.size += 1;
  };

  ServerTag.prototype.concatenateCSS = function concatenateCSS() {
    var _this = this;

    return Object.keys(this.components).reduce(function (styles, k) {
      return styles + _this.components[k].css;
    }, '');
  };

  ServerTag.prototype.inject = function inject(componentId, css, name) {
    var comp = this.components[componentId];

    if (false) {
      throw new Error('Must add a new component before you can inject css into it');
    }
    if (comp.css === '') comp.css = '/* sc-component-id: ' + componentId + ' */\n';

    comp.css += css.replace(/\n*$/, '\n');

    if (name) this.names.push(name);
  };

  ServerTag.prototype.toHTML = function toHTML() {
    var attrs = ['type="text/css"', SC_ATTR + '="' + this.names.join(' ') + '"', LOCAL_ATTR + '="' + (this.isLocal ? 'true' : 'false') + '"'];

    var nonce = getNonce();

    if (nonce) {
      attrs.push('nonce="' + nonce + '"');
    }

    return '<style ' + attrs.join(' ') + '>' + this.concatenateCSS() + '</style>';
  };

  ServerTag.prototype.toReactElement = function toReactElement(key) {
    var _attrs;

    var attrs = (_attrs = {}, _attrs[SC_ATTR] = this.names.join(' '), _attrs[LOCAL_ATTR] = this.isLocal.toString(), _attrs);

    var nonce = getNonce();

    if (nonce) {
      attrs.nonce = nonce;
    }

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('style', _extends({
      key: key,
      type: 'text/css'
    }, attrs, {
      dangerouslySetInnerHTML: { __html: this.concatenateCSS() }
    }));
  };

  ServerTag.prototype.clone = function clone() {
    var _this2 = this;

    var copy = new ServerTag(this.isLocal);
    copy.names = [].concat(this.names);
    copy.size = this.size;
    copy.components = Object.keys(this.components).reduce(function (acc, key) {
      acc[key] = _extends({}, _this2.components[key]); // eslint-disable-line no-param-reassign
      return acc;
    }, {});

    return copy;
  };

  return ServerTag;
}();

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    this.instance = StyleSheet.clone(StyleSheet.instance);
  }

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new Error("Can't collect styles once you've called getStyleTags!");
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    if (!this.closed) {
      clones.splice(clones.indexOf(this.instance), 1);
      this.closed = true;
    }

    return this.instance.toReactElements();
  };

  ServerStyleSheet.create = function create() {
    return new StyleSheet(function (isLocal) {
      return new ServerTag(isLocal);
    });
  };

  return ServerStyleSheet;
}();

//      

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

//      
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 **/
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|(?:attribute|glyph)Nam|playsInlin|(?:formE|e)ncTyp|(?:writing|input|edge)Mod|(?:xlinkTy|itemSco|keyTy|slo)p|(?:amplitu|mo)d|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ntrol|ord)s|o(?:lor(?:Interpolation)?|ntent)|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|o(?:ntextMenu|ls)|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|(?:rossOrigi|olSpa)n|apHeight|lip(?:Path)?|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|autoFocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|formActio|zoomAndPa|onFocusI|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveA(?:spectRatio|lpha)|ointsAt[X-Z]|anose1)|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:gradientT|patternT|t)ransform|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:strokeMiterlimi|(?:specularConsta|repeatCou|fontVaria)n|(?:(?:specularE|e)xpon|renderingInt|asc)en|d(?:iffuseConsta|esce)n|(?:fontSizeAdju|lengthAdju|manife)s|baselineShif|vectorEffec|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|a(?:utoCorrec|bou)|markerStar|onFocusOu|in(?:tercep|lis)|restar|forma|heigh|lis)t|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|m(?:arkerMi|etho)|preloa|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:allowFullScre|hidd)en|strokeDasharray|systemLanguage|(?:strokeLineca|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|(?:pointerEve|keyPoi)nts|unicodeRange|(?:(?:allowReord|placehold|frameBord|paintOrd|post|ord)e|repeatDu|d(?:efe|u))r|mathematical|(?:vI|i)deographic|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|vAlphabetic|mediaGroup|spellCheck|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|(?:xmlnsXl|valueL)ink|a(?:rabicForm|l(?:phabetic|t)|sync)|pathLength|(?:text|m(?:in|ax))Length|innerHTML|xlinkShow|(?:xlinkHr|glyphR)ef|r(?:e(?:quired|sult|f))?|o(?:verflow|pen)|(?:tabInde|(?:sand|b)bo|viewBo)x|(?:(?:href|xml|src)La|kerni)ng|f(?:o(?:ntSize|rm)|il(?:ter|l))|autoPlay|unicode|p(?:attern|oints)|t(?:arget[XY]|o)|i(?:temRef|n2|s)|divisor|d(?:efault|ata|ir)?|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|(?:width|size)s|(?:stri|la)ng|prefix|itemID|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|s)|t(?:arget|ype)|typeof|width|value|x(?:mlns)?|label|m(?:edia|a(?:sk|x)|in)|size|href|k(?:ey)?|end|low|x[12]|i[dn]|y[12]|g[12]|by|f[xy]|[yz])$/;

/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

//      


function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

//      


function isStyledComponent(target) /* : %checks */{
  return typeof target === 'function' && typeof target.styledComponentId === 'string';
}

//      

/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

//      


var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

//      
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

//      
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

//      
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

var _ThemeProvider$childC;
var _ThemeProvider$contex;

//      
/* globals React$Element */
// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func
});

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.error('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;
      });
    }
    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.broadcast.publish(this.getTheme(nextProps.theme));
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;
    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);
      if (false) {
        throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
      }
      return mergedTheme;
    }
    if (!__WEBPACK_IMPORTED_MODULE_0_is_plain_object___default()(theme)) {
      throw new Error('[ThemeProvider] Please make your theme prop a plain object');
    }
    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }
    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

ThemeProvider.childContextTypes = (_ThemeProvider$childC = {}, _ThemeProvider$childC[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _ThemeProvider$childC[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$childC);
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

//      

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var identifiers = {};

  /* We depend on components having unique IDs */
  var generateId = function generateId(_displayName, parentComponentId) {
    var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

    var componentId = void 0;

    /**
     * only fall back to hashing the component injection order if
     * a proper displayName isn't provided by the babel plugin
     */
    if (!_displayName) {
      var nr = (identifiers[displayName] || 0) + 1;
      identifiers[displayName] = nr;

      componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);
    } else {
      componentId = displayName + '-' + ComponentStyle.generateName(displayName);
    }

    return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
  };

  var BaseStyledComponent = function (_Component) {
    inherits(BaseStyledComponent, _Component);

    function BaseStyledComponent() {
      var _temp, _this, _ret;

      classCallCheck(this, BaseStyledComponent);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
        theme: null,
        generatedClassName: ''
      }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
      var attrs = this.constructor.attrs;

      var context = _extends({}, props, { theme: theme });
      if (attrs === undefined) {
        return context;
      }

      this.attrs = Object.keys(attrs).reduce(function (acc, key) {
        var attr = attrs[key];
        // eslint-disable-next-line no-param-reassign
        acc[key] = typeof attr === 'function' ? attr(context) : attr;
        return acc;
      }, {});

      return _extends({}, context, this.attrs);
    };

    BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
      var _constructor = this.constructor,
          attrs = _constructor.attrs,
          componentStyle = _constructor.componentStyle,
          warnTooManyClasses = _constructor.warnTooManyClasses;

      var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.instance;

      // staticaly styled-components don't need to build an execution context object,
      // and shouldn't be increasing the number of class names
      if (componentStyle.isStatic && attrs === undefined) {
        return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
      } else {
        var executionContext = this.buildExecutionContext(theme, props);
        var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

        if (false) {
          warnTooManyClasses(className);
        }

        return className;
      }
    };

    BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var componentStyle = this.constructor.componentStyle;

      var styledContext = this.context[CHANNEL_NEXT];

      // If this is a staticaly-styled component, we don't need to the theme
      // to generate or build styles.
      if (componentStyle.isStatic) {
        var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
        this.setState({ generatedClassName: generatedClassName });
        // If there is a theme in the context, subscribe to the event emitter. This
        // is necessary due to pure components blocking context updates, this circumvents
        // that by updating when an event is emitted
      } else if (styledContext !== undefined) {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          // This will be called once immediately
          var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);
          var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

          _this2.setState({ theme: theme, generatedClassName: generatedClassName });
        });
      } else {
        // eslint-disable-next-line react/prop-types
        var theme = this.props.theme || {};
        var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
        this.setState({ theme: theme, generatedClassName: _generatedClassName });
      }
    };

    BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      // If this is a staticaly-styled component, we don't need to listen to
      // props changes to update styles
      var componentStyle = this.constructor.componentStyle;

      if (componentStyle.isStatic) {
        return;
      }

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, _this3.constructor.defaultProps);
        var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

        return { theme: theme, generatedClassName: generatedClassName };
      });
    };

    BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromContext();
    };

    BaseStyledComponent.prototype.render = function render() {
      var _this4 = this;

      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var generatedClassName = this.state.generatedClassName;
      var _constructor2 = this.constructor,
          styledComponentId = _constructor2.styledComponentId,
          target = _constructor2.target;


      var isTargetTag = isTag(target);

      var className = [
      // eslint-disable-next-line react/prop-types
      this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

      var baseProps = _extends({}, this.attrs, {
        className: className
      });

      if (isStyledComponent(target)) {
        baseProps.innerRef = innerRef;
      } else {
        baseProps.ref = innerRef;
      }

      var propsForElement = Object.keys(this.props).reduce(function (acc, propName) {
        // Don't pass through non HTML tags through to HTML elements
        // always omit innerRef
        if (propName !== 'innerRef' && propName !== 'className' && (!isTargetTag || validAttr(propName))) {
          // eslint-disable-next-line no-param-reassign
          acc[propName] = _this4.props[propName];
        }

        return acc;
      }, baseProps);

      return Object(__WEBPACK_IMPORTED_MODULE_2_react__["createElement"])(target, propsForElement);
    };

    return BaseStyledComponent;
  }(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);

  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _StyledComponent$cont;

    var _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')' : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.contextTypes = (_StyledComponent$cont = {}, _StyledComponent$cont[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _StyledComponent$cont[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _StyledComponent$cont[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.instanceOf(ServerStyleSheet)]), _StyledComponent$cont);
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// murmurhash2 via https://gist.github.com/raycmorgan/588423

function doHash(str, seed) {
  var m = 0x5bd1e995;
  var r = 24;
  var h = seed ^ str.length;
  var length = str.length;
  var currentIndex = 0;

  while (length >= 4) {
    var k = UInt32(str, currentIndex);

    k = Umul32(k, m);
    k ^= k >>> r;
    k = Umul32(k, m);

    h = Umul32(h, m);
    h ^= k;

    currentIndex += 4;
    length -= 4;
  }

  switch (length) {
    case 3:
      h ^= UInt16(str, currentIndex);
      h ^= str.charCodeAt(currentIndex + 2) << 16;
      h = Umul32(h, m);
      break;

    case 2:
      h ^= UInt16(str, currentIndex);
      h = Umul32(h, m);
      break;

    case 1:
      h ^= str.charCodeAt(currentIndex);
      h = Umul32(h, m);
      break;
  }

  h ^= h >>> 13;
  h = Umul32(h, m);
  h ^= h >>> 15;

  return h >>> 0;
}

function UInt32(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8) + (str.charCodeAt(pos++) << 16) + (str.charCodeAt(pos) << 24);
}

function UInt16(str, pos) {
  return str.charCodeAt(pos++) + (str.charCodeAt(pos++) << 8);
}

function Umul32(n, m) {
  n = n | 0;
  m = m | 0;
  var nlo = n & 0xffff;
  var nhi = n >>> 16;
  var res = nlo * m + ((nhi * m & 0xffff) << 16) | 0;
  return res;
}

//      
var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0; i < rules.length; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled copmonent
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      var value = attrs[key];
      if (typeof value === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHRMEnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHRMEnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;
      if (!StyleSheet.instance.hasInjectedComponent(this.componentId)) {
        var placeholder =  false ? '.' + componentId + ' {}' : '';
        StyleSheet.instance.deferredInject(componentId, true, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          lastClassName = this.lastClassName;

      if (isStatic && lastClassName !== undefined) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var hash = doHash(this.componentId + flatCSS.join(''));

      var existingName = styleSheet.getName(hash);
      if (existingName !== undefined) {
        if (styleSheet.stylesCacheable) {
          this.lastClassName = existingName;
        }
        return existingName;
      }

      var name = nameGenerator(hash);
      if (styleSheet.stylesCacheable) {
        this.lastClassName = existingName;
      }
      if (styleSheet.alreadyInjected(hash, name)) {
        return name;
      }

      var css = '\n' + stringifyRules(flatCSS, '.' + name);
      // NOTE: this can only be set when we inject the class-name.
      // For some reason, presumably due to how css is stringifyRules behaves in
      // differently between client and server, styles break.
      styleSheet.inject(this.componentId, true, css, hash, name);
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return nameGenerator(doHash(str));
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

//      
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

//      

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

//      
var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function (strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(replaceWhitespace(JSON.stringify(rules)));

    var existingName = StyleSheet.instance.getName(hash);
    if (existingName) return existingName;

    var name = nameGenerator(hash);
    if (StyleSheet.instance.alreadyInjected(hash, name)) return name;

    var generatedCSS = stringifyRules(rules, name, '@keyframes');
    StyleSheet.instance.inject('sc-keyframes-' + name, true, generatedCSS, hash, name);
    return name;
  };
});

//      
var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal(strings) {
    for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      interpolations[_key - 1] = arguments[_key];
    }

    var rules = css.apply(undefined, [strings].concat(interpolations));
    var hash = doHash(JSON.stringify(rules));

    var componentId = 'sc-global-' + hash;
    if (StyleSheet.instance.hasInjectedComponent(componentId)) return;

    StyleSheet.instance.inject(componentId, false, stringifyRules(rules));
  };

  return injectGlobal;
});

//      


var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    if (false) {
      // $FlowInvalidInputTest
      throw new Error('Cannot create styled-component for component: ' + tag);
    }

    /* This is callable directly as a template function */
    var templateFunction = function templateFunction(strings) {
      for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        interpolations[_key - 1] = arguments[_key];
      }

      return componentConstructor(tag, options, css.apply(undefined, [strings].concat(interpolations)));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || {}, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

//      
/* globals ReactClass */

var wrapWithTheme = function wrapWithTheme(Component$$1) {
  var _WithTheme$contextTyp;

  var componentName = Component$$1.displayName || Component$$1.name || 'Component';

  var shouldSetInnerRef = isStyledComponent(Component$$1) ||
  // NOTE: We can't pass a ref to a stateless functional component
  typeof Component$$1 === 'function' && !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {}, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      // eslint-disable-next-line react/prop-types
      var innerRef = this.props.innerRef;
      var theme = this.state.theme;


      return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(Component$$1, _extends({
        theme: theme
      }, this.props, {
        innerRef: shouldSetInnerRef ? innerRef : undefined,
        ref: shouldSetInnerRef ? undefined : innerRef
      }));
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

  WithTheme.displayName = 'WithTheme(' + componentName + ')';
  WithTheme.styledComponentId = 'withTheme';
  WithTheme.contextTypes = (_WithTheme$contextTyp = {}, _WithTheme$contextTyp[CHANNEL] = __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, _WithTheme$contextTyp[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _WithTheme$contextTyp);


  return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(WithTheme, Component$$1);
};

//      

/* Import singletons */
/* Import singleton constructors */
/* Import components */
/* Import Higher Order Components */
/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["default"] = (styled);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(110)(module)))

/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */


var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    arguments: true,
    arity: true
};

var isGetOwnPropertySymbolsAvailable = typeof Object.getOwnPropertySymbols === 'function';

module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, customStatics) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
        var keys = Object.getOwnPropertyNames(sourceComponent);

        /* istanbul ignore else */
        if (isGetOwnPropertySymbolsAvailable) {
            keys = keys.concat(Object.getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            if (!REACT_STATICS[keys[i]] && !KNOWN_STATICS[keys[i]] && (!customStatics || !customStatics[keys[i]])) {
                try {
                    targetComponent[keys[i]] = sourceComponent[keys[i]];
                } catch (error) {

                }
            }
        }
    }

    return targetComponent;
};


/***/ }),
/* 1542 */
/***/ (function(module, exports) {

function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}// let _confirmDialog = null;
var AppMem=function AppMem(){_classCallCheck(this,AppMem);};module.exports=AppMem;

/***/ }),
/* 1543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_faviconCreek_png__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_assets_faviconCreek_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_assets_faviconCreek_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_faviconNuevamente_png__ = __webpack_require__(1545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_assets_faviconNuevamente_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_assets_faviconNuevamente_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_faviconHangover_png__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_assets_faviconHangover_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_assets_faviconHangover_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_faviconLeparc_png__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_assets_faviconLeparc_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_assets_faviconLeparc_png__);
//import logoLeparc from "../../common/assets/logoLeparc.png";
var favicon=null;var tenantId="hangover";if(tenantId=="creek"){favicon=__WEBPACK_IMPORTED_MODULE_0__common_assets_faviconCreek_png___default.a;}else if(tenantId=="nuevamente"){favicon=__WEBPACK_IMPORTED_MODULE_1__common_assets_faviconNuevamente_png___default.a;}else if(tenantId=="leparc"){favicon=__WEBPACK_IMPORTED_MODULE_3__common_assets_faviconLeparc_png___default.a;}else if(tenantId=="hangover"){favicon=__WEBPACK_IMPORTED_MODULE_2__common_assets_faviconHangover_png___default.a;}/* harmony default export */ __webpack_exports__["a"] = (favicon);

/***/ }),
/* 1544 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1545 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1546 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/faviconLeparc.de19d411.png";

/***/ }),
/* 1548 */
/***/ (function(module, exports) {

/*
import FirebaseConnector from "../lib/FirebaseConnector";
import Settings from "./Settings";
export { FirebaseConnector, Settings };
*/

/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z"
}), 'Home');

exports.default = _default;

/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z"
}), 'PermIdentity');

exports.default = _default;

/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
}), 'Lock');

exports.default = _default;

/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z"
}), 'Assignment');

exports.default = _default;

/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"
}), 'Place');

exports.default = _default;

/***/ }),
/* 1554 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(14);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

var _createSvgIcon = _interopRequireDefault(__webpack_require__(15));

var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
  d: "M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'ExitToApp');

exports.default = _default;

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HelmetExport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect__ = __webpack_require__(1556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_side_effect__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_fast_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_assign__);






var ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src",
    TARGET: "target"
};

var REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = "data-react-helmet";

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return Array.isArray(innermostTitle) ? innermostTitle.join("") : innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === TAG_PROPERTIES.INNER_HTML || attributeKey === TAG_PROPERTIES.CSS_TEXT || attributeKey === TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = __WEBPACK_IMPORTED_MODULE_4_object_assign___default()({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([TAG_PROPERTIES.HREF, TAG_PROPERTIES.TARGET], propsList),
        bodyAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(TAG_NAMES.LINK, [TAG_PROPERTIES.REL, TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(TAG_NAMES.META, [TAG_PROPERTIES.NAME, TAG_PROPERTIES.CHARSET, TAG_PROPERTIES.HTTPEQUIV, TAG_PROPERTIES.PROPERTY, TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(TAG_NAMES.NOSCRIPT, [TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(TAG_NAMES.SCRIPT, [TAG_PROPERTIES.SRC, TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(TAG_NAMES.STYLE, [TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame && window.requestAnimationFrame.bind(window) || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === TAG_PROPERTIES.INNER_HTML || attribute === TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === TAG_PROPERTIES.INNER_HTML || mappedAttribute === TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case ATTRIBUTE_NAMES.BODY:
        case ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            classCallCheck(this, HelmetWrapper);
            return possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !__WEBPACK_IMPORTED_MODULE_2_react_fast_compare___default()(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case TAG_NAMES.SCRIPT:
                case TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _babelHelpers$extends;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_babelHelpers$extends = {}, _babelHelpers$extends[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _babelHelpers$extends));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _babelHelpers$extends2, _babelHelpers$extends3;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_babelHelpers$extends2 = {}, _babelHelpers$extends2[child.type] = nestedChildren, _babelHelpers$extends2.titleAttributes = _extends({}, newChildProps), _babelHelpers$extends2));

                case TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_babelHelpers$extends3 = {}, _babelHelpers$extends3[child.type] = _extends({}, newChildProps), _babelHelpers$extends3));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _babelHelpers$extends4;

                newFlattenedProps = _extends({}, newFlattenedProps, (_babelHelpers$extends4 = {}, _babelHelpers$extends4[arrayChildName] = arrayTypeChildren[arrayChildName], _babelHelpers$extends4));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return warn("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return warn("Only elements types " + VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            __WEBPACK_IMPORTED_MODULE_3_react___default.a.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = convertReactPropstoHtmlAttributes(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case TAG_NAMES.LINK:
                    case TAG_NAMES.META:
                    case TAG_NAMES.NOSCRIPT:
                    case TAG_NAMES.SCRIPT:
                    case TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Component, newProps);
        };

        createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set$$1(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);
        return HelmetWrapper;
    }(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component), _class.propTypes = {
        base: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        bodyAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        children: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node), __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.node]),
        defaultTitle: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        defer: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        encodeSpecialCharacters: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.bool,
        htmlAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        link: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        meta: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        noscript: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        onChangeClientState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func,
        script: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        style: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object),
        title: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string,
        titleAttributes: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.object,
        titleTemplate: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = mapStateOnServer({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = __WEBPACK_IMPORTED_MODULE_1_react_side_effect___default()(reducePropsToState, handleClientStateChange, mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

/* unused harmony default export */ var _unused_webpack_default_export = (HelmetExport);


/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(55)))

/***/ }),
/* 1556 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_PureComponent) {
      _inheritsLoose(SideEffect, _PureComponent);

      function SideEffect() {
        return _PureComponent.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.PureComponent);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 1557 */
/***/ (function(module, exports) {

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DrawerVault_css__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DrawerVault_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DrawerVault_css__);
// import muiThemeable from "material-ui/styles/muiThemeable";
/**
 * Menu que se desplaza desde la derecha o la izquierda. Las opciones son recibidas como hijos.
 */var DrawerVault=function DrawerVault(props){var theme=Object(__WEBPACK_IMPORTED_MODULE_3__material_ui_core_styles__["f" /* useTheme */])();var isOpen=props.isOpen,username=props.username,onRequestChangeDrawer=props.onRequestChangeDrawer;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["p" /* Drawer */],{docked:false,open:isOpen,width:300,openSecondary:props.isRight,onRequestChange:onRequestChangeDrawer},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{style:{background:theme.drawer.header.background,display:"flex",alignItems:"center",padding:"25px 30px 25px 25px"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["b" /* Avatar */],{size:50,src:props.avatarSrc}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"infoUserContainer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"mainText"},username),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"secondText"},props.email),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"secondText"},props.rol))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["C" /* List */],null,props.children));};DrawerVault.propTypes={/**
	 * Si es `true` el menu estara abierto
	 */isOpen:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,username:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,/**
	 * Funcion callback que es disparada cuando se pide cambiar el estado "Abierto" del menu
	 */onRequestChangeDrawer:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,/**
	 * Si es `true` el menu se desplazara desde la derecha
	 */isRight:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,/**
	 * Ruta de la imagen avatar
	 */avatarSrc:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,email:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,rol:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string};/* harmony default export */ __webpack_exports__["a"] = (DrawerVault);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__material_ui_core__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DrawerVault_css__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__DrawerVault_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__DrawerVault_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__ = __webpack_require__(13);
//import muiThemeable from "material-ui/styles/muiThemeable";
/**
 * Componente que sera parte de un grupo de opciones en un Drawer.
 */var DrawerGroupItem=function DrawerGroupItem(props){var theme=Object(__WEBPACK_IMPORTED_MODULE_5__material_ui_core_styles__["f" /* useTheme */])();return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["b" /* Link */],{to:props.toLink,className:"noTextDeco",style:theme.menuItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:props.className},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["D" /* ListItem */],{button:true,onClick:props.onTouchTap//style={{ color: theme.palette.secondaryTextColor }}
,innerDivStyle:props.innerDivStyle},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["E" /* ListItemIcon */],null,props.icon),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__material_ui_core__["G" /* ListItemText */],{primary:props.textoItem}))));};DrawerGroupItem.propTypes={toLink:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string.isRequired,className:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,icon:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,textoItem:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,onTouchTap:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,innerDivStyle:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object])};/* harmony default export */ __webpack_exports__["a"] = (DrawerGroupItem);//muiThemeable()(DrawerGroupItem);

/***/ }),
/* 1560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nuevamente__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Nuevamente___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__Nuevamente__);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0__material_ui_core_styles__["b" /* createMuiTheme */])(__WEBPACK_IMPORTED_MODULE_1__Nuevamente___default.a));//Cambiar el Theme Acá.

/***/ }),
/* 1561 */
/***/ (function(module, exports) {

function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}var Nuevamente={palette:{type:"light",// common:{
// 	black:"#ff0000",
// 	white:"#ffff00"
// },
primary:{main:"#000000"//"#2991d6"
},secondary:{main:"#fff"},background:{paper:"#fff",default:"#f7f7f7"},textColor:"#3B3C3C",primary1Color:"#1BB6B1",secondaryTextColor:"#757575",alternateTextColor:"#ffffff",disabledColor:"#70787D"},typography:{h1:{//Título del encabezado de la sección
color:"white",fontSize:20,fontWeight:"400"},subtitle1:{//Subtítulo del encabezado de la sección
color:"white",fontSize:16},h2:{//Título del encabezado del paper
fontSize:20,color:"#2a2a2a"// fontFamily:"Roboto-Regular"
}},overrides:{MuiTableCell:{stickyHeader:{fontSize:12,color:"rgb(0,0,0,0.54)",backgroundColor:"#FFF"},body:{color:"rgb(0,0,0,0.87)",fontSize:13},root:{padding:8}},MuiTablePagination:{caption:{fontSize:12,color:"rgb(0,0,0,0.54)"},root:{fontSize:12,color:"rgb(0,0,0,0.54)"}},MuiMenuItem:{root:{fontSize:12//color:"rgb(0,0,0,0.54)"
}},MuiButton:{containedSecondary:{color:"#000000"//"#2991d6"
}},MuiIconButton:{root:{padding:5}},MuiFormLabel:{root:{color:"rgba(0, 0, 0, 0.38)",fontSize:16,width:"max-content"}},MuiAutocomplete:{root:{width:"100%"}},MuiGrid:{item:{marginTop:12,marginBottom:12}},MuiContainer:{root:_defineProperty({height:"100%",'@media (min-width: 960px)':{padding:15},'@media (min-width: 600px)':{padding:15}},"@media (min-width: 960px)",{maxWidth:"100%"})}},drawer:{header:{background:"linear-gradient(to right, #333333, #000000)"}},menuItem:{color:"rgba(103, 103, 103, 0.87)"},appBar:{root:{background:"linear-gradient(to bottom, #000, #444 85%)",//"linear-gradient(to bottom, #2275ac, #2991d6 85%)",
position:"static",alignItems:"baseline",justifyContent:"center",height:49},toolbar:{paddingLeft:0},leftIcon:{color:"#fff",//marginLeft: 5,
marginRight:0,marginTop:0}},logo:{height:24},breadcrumb:{container:{//marginBottom: 10,
paddingTop:9,paddingLeft:23,paddingBottom:7,fontSize:"0.8rem",width:"100%",position:"static",zIndex:9},separator:{color:"#444"//"#1bb6b1"
},text:{color:"#000"//"#0091d4"
}},title:{container:{height:91,width:"100%",background:"#000",//"#5d9ac2",
paddingLeft:83,paddingTop:21,marginBottom:60},backIconContainer:{marginTop:-10},backIcon:{color:"#fff"}},routesContainer:{height:"100%",width:"100%",backgroundColor:"#f7f7f7"},mainContainer:{height:"89%",width:"100%",position:"absolute",top:80,left:0,bottom:0,right:0,overflow:"scroll"},paper:{title:{paddingTop:21,paddingBottom:19,paddingLeft:26},form:{paddingTop:21,paddingLeft:36,paddingRight:66,paddingBottom:30,alignItems:"center"// backgroundColor:"rgba(0, 0, 0, 0.26)"
},addEditTicketTypeTitle:{flexDirection:"row",display:"flex",justifyContent:"space-between",paddingRight:26}},table:{toolbar:{alignItems:"center",justifyContent:"space-between",marginBottom:5},container:{alignItems:"center",justifyContent:"center",height:"100%",maxWidth:"100%"},actionsColumn:{textAlign:"center"},row:{background:"#ffffff"},rowColor:{background:"#f9f9f9"},activeCell:{color:"#04aa86"},empty:{paddingTop:20,paddingLeft:20}},footer:{toolbar:{justifyContent:"flex-end"},button:{marginLeft:20},buttonMarginBottom:{marginLeft:20,marginBottom:20}},imageSelector:{width:253,height:109,backgroundColor:"#e9e9e9",backgroundSize:"contain",backgroundRepeat:"no-repeat",backgroundPosition:"center"},stats:{tktToSell:{paper:{padding:10},label:{fontSize:14,color:"#5a5956",letterSpacing:0.2},value:{fontSize:19,color:"#5a5956",fontWeight:"bold"}},tktSellRRPP:{paper:{padding:10},label:{fontSize:14,color:"#5b95bb",letterSpacing:0.2},value:{fontSize:19,color:"#5b95bb",fontWeight:"bold"}},tktSellNoRRPP:{paper:{padding:10},label:{fontSize:14,color:"#5a5956",letterSpacing:0.2},value:{fontSize:19,color:"#5a5956",fontWeight:"bold"}},tktSold:{paper:{padding:10},label:{fontSize:14,color:"#03a900",letterSpacing:0.2},value:{fontSize:19,color:"#03a900",fontWeight:"bold"}},tktGift:{paper:{padding:10},label:{fontSize:14,color:"orange",letterSpacing:0.2},value:{fontSize:19,color:"orange",fontWeight:"bold"}},producer:{paper:{padding:10,backgroundColor:"#03a900"},label:{fontSize:14,color:"#ffffff",letterSpacing:0.2},value:{fontSize:19,color:"#ffffff",fontWeight:"bold"}},titleDetail:{box:{borderBottomStyle:"solid",borderBottomWidth:5,borderBottomColor:"#f02f66",marginTop:30,padding:12},label:{fontSize:14,color:"#f02f66",fontWeight:"400",letterSpacing:0.5}},tktLoyaly:{paper:{padding:10},label:{fontSize:14,color:"#B0A80D",letterSpacing:0.2},value:{fontSize:19,color:"#B0A80D",fontWeight:"bold"}},tktReferencedRRPP:{paper:{padding:10},label:{fontSize:14,color:"#081881",letterSpacing:0.2},value:{fontSize:19,color:"#081881",fontWeight:"bold"}}},StatsCard:{container:{height:"100%",width:"49%",marginTop:33},header:{container:{justifyContent:"space-between",alignContent:"center",paddingLeft:24,paddingRight:18,height:30,borderTopLeftRadius:4,borderTopRightRadius:4},label:{fontSize:13,fontWeight:"lighter"},value:{textAlign:"right",fontSize:13}},label:{fontSize:14,color:"#5a5956",letterSpacing:0.2,fontWeight:"lighter"},value:{textAlign:"right",fontSize:14,color:"#5a5956",letterSpacing:0.2,fontWeight:"bolder"},row:{justifyContent:"space-between",paddingLeft:24,paddingRight:24,borderBottom:"rgba(0, 0, 0, 0.23)",borderBottomStyle:"solid",borderBottomWidth:"thin",height:43},footer:{container:{backgroundColor:"green",paddingLeft:14,paddingRight:14,height:43,borderBottomLeftRadius:4,borderBottomRightRadius:4},label:{fontSize:13,color:"#ffffff",fontWeight:"lighter"},value:{textAlign:"right",fontSize:13,color:"#ffffff"}}/*
	badge: {
		secondaryColor: "#3B3C3C"
	},
	button: {
		height: 30,
		minWidth: 40
	},
	checkbox: {
		boxColor: "#70787d",
		labelColor: "#70787d",
		fontSize: 12
	},
	card: {
		titleColor: "#1BB6B1"
	},
	datePicker: {
		selectColor: "#3B3C3C",
		headerColor: "#1BB6B1"
	},
	dialog: {
		titleFontSize: 18,
		bodyFontSize: 13
	},
	flatButton: {
		fontSize: 12
	},
	floatingActionButton: {
		buttonSize: 35,
		miniSize: 25,
		color: "#1BB6B1"
	},
	menuItem: {
		dataHeight: 5,
		height: 30,
		padding: 0,
		fontSize: 10,
		selectedTextColor: "#002E74",
		rightIconDesktopFill: "#ff0000",
		spacing: 5
	},
	raisedButton: {
		fontSize: 12,
		height: 20,
		primaryColor: "#5d9ac2",//"#1BB6B1",
		secondaryColor: "#C230A4"
	},
	tableHeader: {
		whiteSpace: "normal",
		borderSize: 2
	},
	tableHeaderColumn: {
		height: 10,
		spacing: 10,
		whiteSpace: "normal",
		fontSize: 10
	},
	tableRow: {
		stripeColor: "#F5F5F5",
		border: "1px solid #ccc",
		height: 40
	},
	tableRowColumn: {
		height: 25,
		spacing: 10
	},
	tableFooter: {
		borderColor: "#EB825D"
	},
	textField: {
    hintColor: "rgba(0, 0, 0, 0.3)",
    color: "#0091d4"
	},
	timePicker: {
		headerColor: "#1BB6B1"
	}
	*/}};module.exports=Nuevamente;

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateAccess;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_RolesConstants__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants__);
var routesXRoles=void 0;function getRoutesXRoles(){if(!routesXRoles){routesXRoles={};routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.SUPERADMIN]=[__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["i" /* INDEX_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["j" /* LOGIN_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["d" /* EVENTS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["a" /* EVENTS_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["c" /* EVENTS_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["b" /* EVENTS_COPY_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["h" /* EVENTS_STATISTICS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["e" /* EVENTS_STATISTICS_DIRECT_RRPP_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["g" /* EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["f" /* EVENTS_STATISTICS_PRODUCER_ROUTE */],// STATISTICS_RRPP_ROUTE,
__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["x" /* TICKETS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["y" /* TICKET_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["z" /* TICKET_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["A" /* TICKET_TYPES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["B" /* TICKET_TYPE_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["C" /* TICKET_TYPE_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["E" /* USERS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["v" /* ROLES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["t" /* ROLES_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["u" /* ROLES_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["s" /* PLACES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["q" /* PLACES_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["r" /* PLACES_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["p" /* NOTIFICATIONS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["n" /* NOTIFICATIONS_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["o" /* NOTIFICATIONS_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["k" /* NEWS_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["l" /* NEWS_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["m" /* NEWS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["w" /* STATISTICS_ROUTE */]];routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.ADMIN]=[__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["i" /* INDEX_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["j" /* LOGIN_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["E" /* USERS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["v" /* ROLES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["t" /* ROLES_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["u" /* ROLES_EDIT_ROUTE */]];routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.PRODUCTOR]=[__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["i" /* INDEX_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["j" /* LOGIN_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["d" /* EVENTS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["a" /* EVENTS_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["c" /* EVENTS_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["b" /* EVENTS_COPY_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["h" /* EVENTS_STATISTICS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["e" /* EVENTS_STATISTICS_DIRECT_RRPP_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["g" /* EVENTS_STATISTICS_REFERENCED_RRPP_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["f" /* EVENTS_STATISTICS_PRODUCER_ROUTE */],// STATISTICS_RRPP_ROUTE,
__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["x" /* TICKETS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["y" /* TICKET_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["z" /* TICKET_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["A" /* TICKET_TYPES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["B" /* TICKET_TYPE_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["C" /* TICKET_TYPE_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["s" /* PLACES_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["q" /* PLACES_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["r" /* PLACES_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["p" /* NOTIFICATIONS_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["n" /* NOTIFICATIONS_ADD_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["o" /* NOTIFICATIONS_EDIT_ROUTE */],__WEBPACK_IMPORTED_MODULE_0__config_RoutesConstants__["w" /* STATISTICS_ROUTE */]];routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.REDIMIDOR]=[];routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.RRPP]=[];routesXRoles[__WEBPACK_IMPORTED_MODULE_1__config_RolesConstants___default.a.DEFAULT]=[];}return routesXRoles;}function validateAccess(roles,route){if(roles&&route){var rXr=getRoutesXRoles();for(var i=0;i<roles.length;i++){var rol=roles[i]&&roles[i].id;console.log("ROL",rol);if(rXr[rol].includes(route)){return true;}}}return false;}

/***/ }),
/* 1563 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 1564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = register;
/* unused harmony export unregister */
// In production, we register a service worker to serve assets from local cache.
// This lets the app load faster on subsequent visits in production, and gives
// it offline capabilities. However, it also means that developers (and users)
// will only see deployed updates on the "N+1" visit to a page, since previously
// cached resources are updated in the background.
// To learn more about the benefits of this model, read https://goo.gl/KwvDNy.
// This link also includes instructions on opting out of this behavior.
var isLocalhost=Boolean(window.location.hostname==='localhost'||// [::1] is the IPv6 localhost address.
window.location.hostname==='[::1]'||// 127.0.0.1/8 is considered localhost for IPv4.
window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/));function register(){if("production"==='production'&&'serviceWorker'in navigator){// The URL constructor is available in all browsers that support SW.
var publicUrl=new URL("",window.location);if(publicUrl.origin!==window.location.origin){// Our service worker won't work if PUBLIC_URL is on a different origin
// from what our page is served on. This might happen if a CDN is used to
// serve assets; see https://github.com/facebookincubator/create-react-app/issues/2374
return;}window.addEventListener('load',function(){var swUrl=""+'/service-worker.js';if(!isLocalhost){// Is not local host. Just register service worker
registerValidSW(swUrl);}else{// This is running on localhost. Lets check if a service worker still exists or not.
checkValidServiceWorker(swUrl);}});}}function registerValidSW(swUrl){navigator.serviceWorker.register(swUrl).then(function(registration){registration.onupdatefound=function(){var installingWorker=registration.installing;installingWorker.onstatechange=function(){if(installingWorker.state==='installed'){if(navigator.serviceWorker.controller){// At this point, the old content will have been purged and
// the fresh content will have been added to the cache.
// It's the perfect time to display a "New content is
// available; please refresh." message in your web app.
console.log('New content is available; please refresh.');}else{// At this point, everything has been precached.
// It's the perfect time to display a
// "Content is cached for offline use." message.
console.log('Content is cached for offline use.');}}};};}).catch(function(error){console.error('Error during service worker registration:',error);});}function checkValidServiceWorker(swUrl){// Check if the service worker can be found. If it can't reload the page.
fetch(swUrl).then(function(response){// Ensure service worker exists, and that we really are getting a JS file.
if(response.status===404||response.headers.get('content-type').indexOf('javascript')===-1){// No service worker found. Probably a different app. Reload the page.
navigator.serviceWorker.ready.then(function(registration){registration.unregister().then(function(){window.location.reload();});});}else{// Service worker found. Proceed as normal.
registerValidSW(swUrl);}}).catch(function(){console.log('No internet connection found. App is running in offline mode.');});}function unregister(){if('serviceWorker'in navigator){navigator.serviceWorker.ready.then(function(registration){registration.unregister();});}}

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.e26b427d.js